/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ((function(modules) {
	// Check all modules for deduplicated modules
	for(var i in modules) {
		if(Object.prototype.hasOwnProperty.call(modules, i)) {
			switch(typeof modules[i]) {
			case "function": break;
			case "object":
				// Module can be created from a template
				modules[i] = (function(_m) {
					var args = _m.slice(1), fn = modules[_m[0]];
					return function (a,b,c) {
						fn.apply(this, [a,b,c].concat(args));
					};
				}(modules[i]));
				break;
			default:
				// Module is a copy of another module
				modules[i] = modules[modules[i]];
				break;
			}
		}
	}
	return modules;
}([
/* 0 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.store = undefined;
	
	__webpack_require__(588);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(55);
	
	var _configureStore = __webpack_require__(586);
	
	var _configureStore2 = _interopRequireDefault(_configureStore);
	
	var _reactRedux = __webpack_require__(5);
	
	var _reactRouter = __webpack_require__(45);
	
	var _routes = __webpack_require__(580);
	
	var _routes2 = _interopRequireDefault(_routes);
	
	__webpack_require__(1084);
	
	__webpack_require__(1089);
	
	__webpack_require__(1087);
	
	__webpack_require__(1085);
	
	__webpack_require__(1086);
	
	__webpack_require__(1088);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	//can pass initial state to configureStore();
	//Webpack can import CSS files too!
	
	
	//import {checkAuthentication} from './actions/authenticationActions';
	
	//USE HASH HISTORY BECAUSE THIS WILL NEED WORK LOCALLY WITH OUT A SERVER ENVIROMENT
	var store = exports.store = (0, _configureStore2.default)();
	//store.dispatch(checkAuthentication());
	
	
	/*eslint-disable import/default */
	(0, _reactDom.render)(_react2.default.createElement(
	  _reactRedux.Provider,
	  { store: store },
	  _react2.default.createElement(_reactRouter.Router, { history: _reactRouter.hashHistory, routes: _routes2.default })
	), document.getElementById('app'));

/***/ },
/* 1 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	module.exports = __webpack_require__(115);


/***/ },
/* 2 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	if (false) {
	  var REACT_ELEMENT_TYPE = (typeof Symbol === 'function' &&
	    Symbol.for &&
	    Symbol.for('react.element')) ||
	    0xeac7;
	
	  var isValidElement = function(object) {
	    return typeof object === 'object' &&
	      object !== null &&
	      object.$$typeof === REACT_ELEMENT_TYPE;
	  };
	
	  // By explicitly using `prop-types` you are opting into new development behavior.
	  // http://fb.me/prop-types-in-prod
	  var throwOnDirectAccess = true;
	  module.exports = require('./factoryWithTypeCheckers')(isValidElement, throwOnDirectAccess);
	} else {
	  // By explicitly using `prop-types` you are opting into new production behavior.
	  // http://fb.me/prop-types-in-prod
	  module.exports = __webpack_require__(963)();
	}


/***/ },
/* 3 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.updateInitDataState = updateInitDataState;
	exports.setInitialisationComplete = setInitialisationComplete;
	exports.getInitStateByConstant = getInitStateByConstant;
	exports.setStudentName = setStudentName;
	exports.setContentData = setContentData;
	exports.canSeeContent = canSeeContent;
	exports.getExperienceTitle = getExperienceTitle;
	exports.getLocaleString = getLocaleString;
	exports.getLocalData = getLocalData;
	exports.getBiteByScreenId = getBiteByScreenId;
	exports.getBiteById = getBiteById;
	exports.getToolbox = getToolbox;
	exports.getDefaultToolboxPage = getDefaultToolboxPage;
	exports.getNextScreenId = getNextScreenId;
	exports.getNextScreen = getNextScreen;
	exports.getScreenById = getScreenById;
	exports.getBiteScreen = getBiteScreen;
	exports.getBite = getBite;
	exports.getScreen = getScreen;
	exports.getBackgroundAsset = getBackgroundAsset;
	exports.getLargeBackgroundAsset = getLargeBackgroundAsset;
	exports.getMobileBackgroundAsset = getMobileBackgroundAsset;
	exports.getFooterLogoAsset = getFooterLogoAsset;
	exports.getIconAsset = getIconAsset;
	exports.getVideoAsset = getVideoAsset;
	exports.getImageAsset = getImageAsset;
	exports.getLibraryImageAsset = getLibraryImageAsset;
	exports.getDocumentAsset = getDocumentAsset;
	exports.getLinkAsset = getLinkAsset;
	exports.getHotspotBackgroundAsset = getHotspotBackgroundAsset;
	exports.getAudioAsset = getAudioAsset;
	exports.getEarnedAsset = getEarnedAsset;
	exports.getUnearnedAsset = getUnearnedAsset;
	exports.getCharacterAsset = getCharacterAsset;
	exports.getCharacterPose = getCharacterPose;
	exports.getLogoAsset = getLogoAsset;
	exports.getMenuThumbnailAsset = getMenuThumbnailAsset;
	exports.getObjectOption = getObjectOption;
	exports.getObjectOptionIndex = getObjectOptionIndex;
	exports.getLastItemOfArray = getLastItemOfArray;
	exports.getArrayObjectByKey = getArrayObjectByKey;
	exports.getArrayObjectIndexByKey = getArrayObjectIndexByKey;
	exports.getTypeCount = getTypeCount;
	exports.getNotOfTypeCount = getNotOfTypeCount;
	exports.getShortHandKeyByRef = getShortHandKeyByRef;
	exports.getRefByShortHandKey = getRefByShortHandKey;
	exports.isDefined = isDefined;
	exports.getOptionParentDetails = getOptionParentDetails;
	exports.getOptionByLabelName = getOptionByLabelName;
	exports.geScreenParentDetails = geScreenParentDetails;
	exports.getAssetParentDetails = getAssetParentDetails;
	exports.getObjectCheckedOptionsByKpiHistoryOptions = getObjectCheckedOptionsByKpiHistoryOptions;
	exports.getObjectOutcomeByKpiHistoryOptions = getObjectOutcomeByKpiHistoryOptions;
	exports._getObjectOutcomeByKpiHistoryOptions = _getObjectOutcomeByKpiHistoryOptions;
	exports.getObjectOptionIds = getObjectOptionIds;
	exports.getRenderableObjects = getRenderableObjects;
	exports.closeWindow = closeWindow;
	exports.goBack = goBack;
	exports.getUserResponseKpis = getUserResponseKpis;
	exports._getImagesToPreload = _getImagesToPreload;
	exports.getPrimaryLocale = getPrimaryLocale;
	exports.getImagesToPreload = getImagesToPreload;
	exports.getAudioToPreload = getAudioToPreload;
	exports.biteHasScreensVisibleToMenu = biteHasScreensVisibleToMenu;
	exports.getPreviousObject = getPreviousObject;
	exports.allowScroll = allowScroll;
	exports.AllowAutoProgressionIfLast = AllowAutoProgressionIfLast;
	exports.setResourceLinks = setResourceLinks;
	exports.hasRequiredResources = hasRequiredResources;
	exports.getPreviousResource = getPreviousResource;
	exports.getNextResource = getNextResource;
	exports.checkLinearScreenEnabled = checkLinearScreenEnabled;
	exports.checkLinearTargetScreenEnabled = checkLinearTargetScreenEnabled;
	exports.getFirstTargetScreen = getFirstTargetScreen;
	exports.getPrevTargetScreen = getPrevTargetScreen;
	exports.getNextTargetScreen = getNextTargetScreen;
	exports.checkLinearMenuBiteEnabled = checkLinearMenuBiteEnabled;
	exports.checkOpenMenuBiteEnabled = checkOpenMenuBiteEnabled;
	exports.checkFirstLastAnyMenuBiteEnabled = checkFirstLastAnyMenuBiteEnabled;
	exports.getAllBadges = getAllBadges;
	exports.getScreenData = getScreenData;
	exports.getSubScreen = getSubScreen;
	exports.getScreenByAssetId = getScreenByAssetId;
	exports.getScreenCharacterNameByAssetId = getScreenCharacterNameByAssetId;
	exports.getScreenNotes = getScreenNotes;
	exports.allowClippedBlurEffect = allowClippedBlurEffect;
	exports.getAllPrintableAssets = getAllPrintableAssets;
	exports.getPrintableAssetsByBite = getPrintableAssetsByBite;
	exports.screenExists = screenExists;
	exports.getOptionResultString = getOptionResultString;
	
	var _dataHelper = __webpack_require__(11);
	
	var dataHelper = _interopRequireWildcard(_dataHelper);
	
	var _userDataHelper = __webpack_require__(15);
	
	var userDataHelper = _interopRequireWildcard(_userDataHelper);
	
	var _kpiHelper = __webpack_require__(35);
	
	var kpiHelper = _interopRequireWildcard(_kpiHelper);
	
	var _environmentHelper = __webpack_require__(56);
	
	var environmentHelper = _interopRequireWildcard(_environmentHelper);
	
	var _localStorage = __webpack_require__(17);
	
	var localStorage = _interopRequireWildcard(_localStorage);
	
	var _appConstants = __webpack_require__(13);
	
	var appConstants = _interopRequireWildcard(_appConstants);
	
	var _assetConstants = __webpack_require__(33);
	
	var assetConstants = _interopRequireWildcard(_assetConstants);
	
	var _objectConstants = __webpack_require__(9);
	
	var objectConstants = _interopRequireWildcard(_objectConstants);
	
	var _appModels = __webpack_require__(68);
	
	var appModels = _interopRequireWildcard(_appModels);
	
	var _componentModels = __webpack_require__(204);
	
	var componentModels = _interopRequireWildcard(_componentModels);
	
	var _shortHandModels = __webpack_require__(287);
	
	var _lodash = __webpack_require__(28);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _striptags = __webpack_require__(191);
	
	var _striptags2 = _interopRequireDefault(_striptags);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function updateInitDataState(initData, constant) {
	    var nextIndex = -1;
	    for (var i = 0; i < initData.initialisedStates.length; i++) {
	        var stateObj = initData.initialisedStates[i];
	        if (stateObj.constant === constant) {
	            stateObj = Object.assign({}, stateObj, {
	                complete: true
	            });
	            if (i < initData.initialisedStates.length - 1) {
	                nextIndex = i + 1;
	            }
	            initData.initialisedStates = dataHelper.immutableSplice(initData.initialisedStates, i, 1, stateObj);
	        }
	    }
	    initData = Object.assign({}, initData, {
	        initialised: nextIndex <= -1,
	        currentState: nextIndex > -1 ? initData.initialisedStates[nextIndex].constant : initData.currentState,
	        currentStateIndex: nextIndex > -1 ? nextIndex : initData.currentStateIndex
	    });
	    return initData;
	}
	
	function setInitialisationComplete(initData) {
	    initData = Object.assign({}, initData, {
	        checkInitialised: false
	    });
	    return initData;
	}
	
	function getInitStateByConstant(initStates, constant) {
	    var initState = initStates.filter(function (initState) {
	        return initState.constant == constant;
	    });
	    if (initState) return initState[0]; //since filter returns an array, have to grab the first.
	    return null;
	}
	
	function setStudentName(student_name) {
	    var studenNameArray = student_name.split(', ').reverse();
	    return {
	        student_name: student_name,
	        first_name: studenNameArray.length > 1 ? studenNameArray[0] : student_name,
	        last_name: studenNameArray.length > 1 ? studenNameArray[1] : ""
	    };
	}
	
	//Content Data
	function setContentData() {
	    var default_language = getArrayObjectByKey(localStorage.contentData.experience.languages, "is_selected", true).language_code; // localStorage.contentData.experience.default_langauge;
	    var user_role = localStorage.contentData.experience.publish_details.role;
	    var user_name = localStorage.contentData.experience.publish_details.published_by;
	
	    localStorage.set("default_langauge", default_language);
	    localStorage.set("user_role", user_role.toLowerCase());
	    localStorage.set("user_name", user_name);
	    localStorage.setObject("experience_locale", localStorage.contentData.experience.locale[default_language]);
	    localStorage.set("tracking_type", localStorage.contentData.experience.tracking_type);
	    localStorage.setArray("bites", localStorage.contentData.experience.bites);
	    localStorage.set("assets", localStorage.contentData.experience.assets);
	    localStorage.set("strings", localStorage.contentData.experience.strings[default_language]);
	    localStorage.setArray("resources", localStorage.contentData.experience.resources);
	    localStorage.setObject("localeOptions", localStorage.contentData.experience.locale);
	    localStorage.setArray("languages", localStorage.contentData.experience.languages);
	    document.title = localStorage.experience_locale.experience_title;
	    document.documentElement.setAttribute('lang', default_language);
	}
	
	function canSeeContent(screen) {
	    if (screen.screen_status_code === appConstants.SCREEN_STATUS_NOT_STARTED || screen.screen_status_code === appConstants.SCREEN_STATUS_IN_PROGRESS) {
	        return localStorage.user_role === appConstants.USER_ROLE_LEAD;
	    } else {
	        return true;
	    }
	}
	
	function getExperienceTitle() {
	    return localStorage.experience_locale.experience_title;
	}
	
	function getLocaleString(code) {
	    return isDefined(localStorage.strings[code]) ? localStorage.strings[code] : "";
	}
	
	//PASS ARRAY OF LOCALS FROM DATA AND RETREIVES OBJECT OF STRINGS FOR CURRENT LOCALE
	function getLocalData(obj) {
	    if (isDefined(obj.locale)) {
	        return isDefined(obj.locale[localStorage.default_langauge]) ? obj.locale[localStorage.default_langauge] : obj.locale[getPrimaryLocale(obj.locale)];
	    } else {
	        return {};
	    }
	}
	
	//GET BITE DATA
	function getBiteByScreenId(screen_id) {
	    var returnBiteId = {};
	    var biteFound = false;
	    if (!isNaN(screen_id)) {
	        for (var i = 0; i < localStorage.bites.length; i++) {
	            var bite = localStorage.bites[i];
	            for (var s = 0; s < bite.screens.length; s++) {
	                var screen = bite.screens[s];
	                if (parseInt(screen.screen_id) === parseInt(screen_id)) {
	                    biteFound = true;
	                    return bite.bite_id;
	                }
	
	                if (isDefined(screen.sub_screens) && screen.sub_screens.length > 0) {
	                    for (var b = 0; b < screen.sub_screens.length; b++) {
	                        var sub_screen = screen.sub_screens[b];
	                        if (parseInt(sub_screen.screen_id) === parseInt(screen_id)) {
	                            biteFound = true;
	                            return bite.bite_id;
	                        }
	                    }
	                }
	            }
	        }
	    } else {
	        return localStorage.bites[0].bite_id;
	    }
	}
	
	function getBiteById(bite_id) {
	    var bite = localStorage.bites.filter(function (bite) {
	        return bite.bite_id == bite_id;
	    });
	    if (bite) return bite[0]; //since filter returns an array, have to grab the first.
	    return null;
	}
	
	//GET TOOLBOX DATA
	function getToolbox() {
	    // const toolbox = localStorage.toolbox;
	    //return toolbox;
	}
	
	function getDefaultToolboxPage() {}
	// const toolbox = localStorage.toolbox;
	//if (toolbox.screens.length) return toolbox.screens[0].toolbox_id;
	//return null;
	
	
	//GET SCREEN DATA
	function getNextScreenId(screen_id) {
	    if (!isNaN(screen_id)) {
	        return getNextScreenById(screen_id);
	    } else {
	        return getFirstScreenId();
	    }
	}
	
	function getNextScreen(screen_id) {
	    if (!isNaN(screen_id)) {
	        return getScreenById(screen_id);
	    } else {
	        return getFirstScreen();
	    }
	}
	
	function getFirstScreen() {
	    return Object.assign({}, localStorage.contentData.experience.bites[0].screens[0]);
	}
	
	function getScreenById(screen_id) {
	    var returnScreen = {};
	    var screenFound = false;
	    var bites = localStorage.contentData.experience.bites;
	    for (var i = 0; i < bites.length; i++) {
	        var bite = bites[i];
	        for (var s = 0; s < bite.screens.length; s++) {
	            var screen = bite.screens[s];
	            if (screen.screen_id == screen_id) {
	                screenFound = true;
	                returnScreen = Object.assign({}, screen);
	                break;
	            }
	        }
	        if (screenFound) {
	            break;
	        }
	    }
	    return returnScreen;
	}
	
	function getFirstScreenId() {
	    return localStorage.contentData.experience.bites[0].screens[0].screen_id;
	}
	
	function getNextScreenById(screen_id) {
	    var bite_id = getBiteByScreenId(screen_id);
	    var bite = getBite(getBiteByScreenId(screen_id));
	    var returnScreenId = "";
	
	    for (var s = 0; s < bite.screens.length; s++) {
	        var screen = bite.screens[s];
	        if (parseInt(screen.screen_id) === parseInt(screen_id)) {
	            if (s < bite.screens.length - 1) {
	                returnScreenId = bite.screens[s + 1].screen_id;
	            }
	            break;
	        }
	    }
	    return returnScreenId;
	}
	
	function getBiteScreen(bite_id, screen_id) {
	    var bite = getBite(bite_id);
	    return getScreen(bite, parseInt(screen_id));
	}
	
	function getBite(bite_id) {
	    var bite = localStorage.bites.filter(function (bite) {
	        return bite.bite_id === bite_id;
	    });
	    if (bite) return bite[0]; //since filter returns an array, have to grab the first.
	    return null;
	}
	
	function getScreen(bite, screen_id) {
	    var screen = bite.screens.filter(function (screen) {
	        return screen.screen_id === screen_id;
	    });
	    if (screen) return screen[0]; //since filter returns an array, have to grab the first.
	    return null;
	}
	
	function getBackgroundAsset(background) {
	
	    var asset = localStorage.assets.filter(function (asset) {
	        return asset.type === assetConstants.ASSET_TYPE_BACKGROUND && asset.id === background.background_id;
	    });
	    if (asset) return asset[0]; //since filter returns an array, have to grab the first.
	    return null;
	}
	
	function getLargeBackgroundAsset(upload) {
	
	    var asset = localStorage.assets.filter(function (asset) {
	        return asset.type === assetConstants.ASSET_TYPE_LARGE_BACKGROUND && asset.id === upload.id;
	    });
	    if (asset) return asset[0]; //since filter returns an array, have to grab the first.
	    return null;
	}
	
	function getMobileBackgroundAsset(upload) {
	
	    var asset = localStorage.assets.filter(function (asset) {
	        return asset.type === assetConstants.ASSET_TYPE_MOBILE_BACKGROUND && asset.id === upload.id;
	    });
	    if (asset) return asset[0]; //since filter returns an array, have to grab the first.
	    return null;
	}
	
	function getFooterLogoAsset(footer_logo) {
	
	    var asset = localStorage.assets.filter(function (asset) {
	        return asset.type === assetConstants.ASSET_TYPE_FOOTER_LOGO && asset.id === footer_logo.id;
	    });
	    if (asset) return asset[0]; //since filter returns an array, have to grab the first.
	    return null;
	}
	
	function getIconAsset(icon) {
	
	    var asset = localStorage.assets.filter(function (asset) {
	        return asset.type === assetConstants.ASSET_TYPE_ICON && (asset.id === icon.id || asset.id === icon.asset_id);
	    });
	    if (asset) return asset[0]; //since filter returns an array, have to grab the first.
	    return null;
	}
	
	function getVideoAsset(video) {
	    var asset = localStorage.assets.filter(function (asset) {
	        return asset.type === assetConstants.ASSET_TYPE_VIDEO && (asset.id === video.id || asset.id === video.asset_id);
	    });
	    if (asset) return asset[0]; //since filter returns an array, have to grab the first.
	    return null;
	}
	
	function getImageAsset(image) {
	
	    var asset = localStorage.assets.filter(function (asset) {
	        return asset.type === assetConstants.ASSET_TYPE_IMAGE && (asset.id === image.id || asset.id === image.asset_id);
	    });
	    if (asset) return asset[0]; //since filter returns an array, have to grab the first.
	    return null;
	}
	
	function getLibraryImageAsset(image) {
	
	    var asset = localStorage.assets.filter(function (asset) {
	        return asset.type === assetConstants.ASSET_TYPE_LIBRARY_IMAGE && (asset.id === image.id || asset.id === image.asset_id);
	    });
	    if (asset) return asset[0]; //since filter returns an array, have to grab the first.
	    return null;
	}
	
	function getDocumentAsset(document) {
	
	    var asset = localStorage.assets.filter(function (asset) {
	        return asset.type === assetConstants.ASSET_TYPE_DOCUMENT && (asset.id === document.id || asset.id === document.asset_id);
	    });
	    if (asset) return asset[0]; //since filter returns an array, have to grab the first.
	    return null;
	}
	
	function getLinkAsset(link) {
	
	    var asset = localStorage.assets.filter(function (asset) {
	        return asset.type === assetConstants.ASSET_TYPE_LINK && (asset.id === link.id || asset.id === link.asset_id);
	    });
	    if (asset) return asset[0]; //since filter returns an array, have to grab the first.
	    return null;
	}
	
	function getHotspotBackgroundAsset(hotspotBackground) {
	    var asset = localStorage.assets.filter(function (asset) {
	        return asset.type === assetConstants.ASSET_TYPE_HOTSPOT_BACKGROUND && asset.id === hotspotBackground.id;
	    });
	    if (asset) return asset[0]; //since filter returns an array, have to grab the first.
	    return null;
	}
	
	function getAudioAsset(audio) {
	
	    var asset = localStorage.assets.filter(function (asset) {
	        return (asset.type === assetConstants.ASSET_AUDIO || asset.type === assetConstants.ASSET_CHILD_AUDIO) && (asset.id === audio.id || asset.id === audio.asset_id);
	    });
	    if (asset) return asset[0]; //since filter returns an array, have to grab the first.
	    return null;
	}
	
	function getEarnedAsset(upload) {
	
	    var asset = localStorage.assets.filter(function (asset) {
	        return asset.type === assetConstants.ASSET_TYPE_EARNED && asset.id === upload.id;
	    });
	    if (asset) return asset[0]; //since filter returns an array, have to grab the first.
	    return null;
	}
	
	function getUnearnedAsset(upload) {
	
	    var asset = localStorage.assets.filter(function (asset) {
	        return asset.type === assetConstants.ASSET_TYPE_UNEARNED && asset.id === upload.id;
	    });
	    if (asset) return asset[0]; //since filter returns an array, have to grab the first.
	    return null;
	}
	
	function getCharacterAsset(screenAsset) {
	    var character = {};
	    _lodash2.default.forEach(localStorage.assets, function (asset) {
	        if (asset.type === assetConstants.ASSET_TYPE_ID_CHARACTER && asset.id === screenAsset.id) {
	            _lodash2.default.forEach(asset.positions, function (pos) {
	                if (pos.position === screenAsset.position) {
	                    character = Object.assign({}, pos);
	                }
	            });
	        }
	    });
	    return character;
	}
	
	function getCharacterPose(character, screenAsset) {
	    var characterPose = {};
	    _lodash2.default.forEach(character.poses, function (pose) {
	        if (pose.pose === screenAsset.pose) {
	            characterPose = Object.assign({}, pose, {
	                position: screenAsset.position
	            });
	        }
	    });
	
	    return characterPose;
	}
	
	function getLogoAsset(assets) {
	    var asset = assets.filter(function (asset) {
	        return asset.type == assetConstants.ASSET_TYPE_IMAGE && asset.type_id == assetConstants.ASSET_TYPE_ID_LOGO;
	    });
	    if (asset) return asset[0]; //since filter returns an array, have to grab the first.
	    return null;
	}
	
	function getMenuThumbnailAsset(assets) {
	    var asset = assets.filter(function (asset) {
	        return asset.type == assetConstants.ASSET_TYPE_IMAGE && asset.type_id == assetConstants.ASSET_TYPE_ID_MENU_THUMBNAIL;
	    });
	    if (asset) return asset[0]; //since filter returns an array, have to grab the first.
	    return null;
	}
	
	/*
	export function getImageAsset(assets) {
	    const asset = assets.filter(asset => asset.type == assetConstants.ASSET_TYPE_IMAGE && asset.type_id == assetConstants.ASSET_TYPE_ID_IMAGE);
	    if (asset) return asset[0]; //since filter returns an array, have to grab the first.
	    return null;
	}*/
	
	function getObjectOption(options, option_id) {
	    for (var i = 0; i < options.length; i++) {
	        var option = options[i];
	
	        if (parseInt(option.option_id) === parseInt(option_id)) {
	            return option;
	        }
	    }
	    return null;
	}
	
	function getObjectOptionIndex(options, option_id) {
	    for (var i = 0; i < options.length; i++) {
	        var option = options[i];
	        if (parseInt(option.option_id) === parseInt(option_id)) {
	            return i;
	        }
	    }
	    return -1;
	}
	
	function getLastItemOfArray(array) {
	    return array[array.length - 1];
	}
	
	function getArrayObjectByKey(array, key, target) {
	    var obj = array.filter(function (obj) {
	        return obj[key] === target;
	    });
	    if (obj) return obj[0]; //since filter returns an array, have to grab the first.
	    return null;
	}
	
	function getArrayObjectIndexByKey(array, key, target) {
	    for (var i = 0; i < array.length; i++) {
	        var item = array[i];
	
	        if (item[key] === target) {
	            return i;
	        }
	    }
	    return -1;
	}
	
	function getTypeCount(array, key, target) {
	    var objectArray = [];
	    for (var i = 0; i < array.length; i++) {
	        var item = array[i];
	        if (item[key] === target) {
	            objectArray = dataHelper.immutablePush(objectArray, item);
	        }
	    }
	
	    return objectArray;
	}
	
	function getNotOfTypeCount(array, key, target) {
	    var objectArray = [];
	    for (var i = 0; i < array.length; i++) {
	        var item = array[i];
	        if (item[key] !== target) {
	            objectArray = dataHelper.immutablePush(objectArray, item);
	        }
	    }
	
	    return objectArray;
	}
	
	function getShortHandKeyByRef(ref) {
	    var obj = _shortHandModels.SHORT_HAND_KEYS.filter(function (obj) {
	        return obj.ref === ref;
	    });
	    if (obj) return obj[0]; //since filter returns an array, have to grab the first.
	    return null;
	}
	
	function getRefByShortHandKey(key) {
	    var obj = _shortHandModels.SHORT_HAND_KEYS.filter(function (obj) {
	        return obj.key === key;
	    });
	    if (obj) return obj[0]; //since filter returns an array, have to grab the first.
	    return null;
	}
	
	function isDefined(val) {
	    return typeof val !== "undefined";
	}
	
	function getOptionParentDetails(option_id) {
	    var returnObject = {};
	    //let screenFound = false;
	    var bites = localStorage.contentData.experience.bites;
	
	    _lodash2.default.forEach(bites, function (bite) {
	        _lodash2.default.forEach(bite.screens, function (screen) {
	            if (isDefined(screen.objects) && screen.objects.length > 0) {
	                _lodash2.default.forEach(screen.objects, function (object) {
	                    if (isDefined(object.options)) {
	                        _lodash2.default.forEach(object.options, function (option) {
	                            if (isDefined(object.options)) {
	                                if (option.option_id === option_id) {
	                                    returnObject = Object.assign({}, returnObject, {
	                                        bite: bite,
	                                        screen: screen,
	                                        object: object,
	                                        option: option
	                                    });
	                                }
	                            }
	                        });
	                    }
	                });
	            } else if (isDefined(screen.sub_screens) && screen.sub_screens.length > 0) {
	                _lodash2.default.forEach(screen.sub_screens, function (sub_screen) {
	                    if (isDefined(sub_screen.objects)) {
	                        _lodash2.default.forEach(sub_screen.objects, function (object) {
	                            if (isDefined(object.options)) {
	                                _lodash2.default.forEach(object.options, function (option) {
	                                    if (isDefined(object.options)) {
	                                        if (option.option_id === option_id) {
	                                            returnObject = Object.assign({}, returnObject, {
	                                                bite: bite,
	                                                screen: screen,
	                                                sub_screen: sub_screen,
	                                                object: object,
	                                                option: option
	                                            });
	                                        }
	                                    }
	                                });
	                            }
	                        });
	                    }
	                });
	            }
	        });
	    });
	    return returnObject;
	}
	
	function getOptionByLabelName(option_label, options) {
	    var returnOption = {};
	    _lodash2.default.forEach(options, function (option) {
	        if (isDefined(option.locale)) {
	            for (var i in option.locale) {
	                if (option_label === (0, _striptags2.default)(option.locale[i].option)) {
	                    returnOption = Object.assign({}, {}, {
	                        option: option
	                    });
	                }
	            }
	        }
	    });
	    return returnOption;
	}
	
	function geScreenParentDetails(screen_id) {
	    var returnObject = undefined;
	
	    var bites = localStorage.contentData.experience.bites;
	
	    for (var i = 0; i < bites.length; i++) {
	        var bite = bites[i];
	        for (var s = 0; s < bite.screens.length; s++) {
	            var screen = bite.screens[s];
	            if (isDefined(screen.sub_screens) && screen.sub_screens.length > 0) {
	                for (var c = 0; c < screen.sub_screens.length; c++) {
	                    var sub_screen = screen.sub_screens[c];
	                    if (sub_screen.screen_id === screen_id) {
	                        returnObject = Object.assign({}, screen);
	                        break;
	                    }
	                }
	            }
	        }
	    }
	    return returnObject;
	}
	
	function getAssetParentDetails(asset_id) {
	    var returnObject = {};
	    //let screenFound = false;
	    var bites = localStorage.contentData.experience.bites;
	
	    _lodash2.default.forEach(bites, function (bite) {
	        _lodash2.default.forEach(bite.screens, function (screen) {
	            if (isDefined(screen.objects) && screen.objects.length > 0) {
	                _lodash2.default.forEach(screen.objects, function (object) {
	                    if (object.asset_id === asset_id) {
	                        returnObject = Object.assign({}, returnObject, {
	                            bite: bite,
	                            screen: screen,
	                            object: object
	                        });
	                    }
	                });
	            } else if (isDefined(screen.sub_screens) && screen.sub_screens.length > 0) {
	                _lodash2.default.forEach(screen.sub_screens, function (sub_screen) {
	                    if (isDefined(sub_screen.objects)) {
	                        _lodash2.default.forEach(sub_screen.objects, function (object) {
	                            if (object.asset_id === asset_id) {
	                                returnObject = Object.assign({}, returnObject, {
	                                    bite: bite,
	                                    screen: screen,
	                                    sub_screen: sub_screen,
	                                    object: object
	                                });
	                            }
	                        });
	                    }
	                });
	            }
	        });
	    });
	    return returnObject;
	}
	function getObjectCheckedOptionsByKpiHistoryOptions(optionIdList) {
	    var checkedOptions = [];
	    for (var i = 0; i < optionIdList.length; i++) {
	        var option_id = optionIdList[i];
	        var optionDetails = getOptionParentDetails(option_id);
	        checkedOptions = dataHelper.immutablePush(checkedOptions, optionDetails.option);
	    }
	    return checkedOptions;
	}
	
	function getObjectOutcomeByKpiHistoryOptions(optionIdList) {
	    var checkedOptions = [];
	    var screenObject = {};
	    for (var i = 0; i < optionIdList.length; i++) {
	        var option_id = optionIdList[i];
	        var optionDetails = getOptionParentDetails(option_id);
	        if (i === 0) {
	            screenObject = Object.assign({}, optionDetails.object);
	        }
	        checkedOptions = dataHelper.immutablePush(checkedOptions, optionDetails.option);
	    }
	    var totalCorrectAnswerCount = getTypeCount(screenObject.options, "result", "best").length;
	    var correctAnswers = getTypeCount(checkedOptions, "result", "best");
	    var incorrectAnswers = getNotOfTypeCount(checkedOptions, "result", "best");
	    var kpis = kpiHelper.averageKpis(checkedOptions);
	    var outcome = {};
	    if (correctAnswers.length === totalCorrectAnswerCount && incorrectAnswers.length === 0) {
	        outcome = Object.assign({}, getArrayObjectByKey(screenObject.outcomes, "result", "best"), {
	            kpis: kpis
	        });
	    } else {
	        if (correctAnswers.length > 0) {
	            outcome = Object.assign({}, getArrayObjectByKey(screenObject.outcomes, "result", "ok"), {
	                kpis: kpis
	            });
	            if (!isDefined(outcome.result)) {
	                outcome = Object.assign({}, getArrayObjectByKey(screenObject.outcomes, "result", "poor"), {
	                    kpis: kpis
	                });
	            }
	        } else {
	            outcome = Object.assign({}, getArrayObjectByKey(screenObject.outcomes, "result", "poor"), {
	                kpis: kpis
	            });
	        }
	    }
	
	    return outcome;
	}
	
	function _getObjectOutcomeByKpiHistoryOptions(optionIdList) {
	    var checkedOptions = [];
	    var screenObject = {};
	    for (var i = 0; i < optionIdList.length; i++) {
	        var option_id = optionIdList[i];
	        var optionDetails = getOptionParentDetails(option_id);
	        if (i === 0) {
	            screenObject = Object.assign({}, optionDetails.object);
	        }
	        checkedOptions = dataHelper.immutablePush(checkedOptions, optionDetails.option);
	    }
	    var totalCorrectAnswerCount = getTypeCount(screenObject.options, "result", "best").length;
	    var correctAnswers = getTypeCount(optionIdList, "result", "best");
	    var incorrectAnswers = getNotOfTypeCount(optionIdList, "result", "best");
	    var kpis = kpiHelper.averageKpis(optionIdList);
	    var outcome = {};
	    if (correctAnswers.length === totalCorrectAnswerCount && incorrectAnswers.length === 0) {
	        outcome = Object.assign({}, getArrayObjectByKey(screenObject.outcomes, "result", "best"), {
	            kpis: kpis
	        });
	    } else {
	        //if (this.state.screenObject.allowPartlyCorrectResponses) {
	
	        if (correctAnswers.length > 0) {
	            outcome = Object.assign({}, getArrayObjectByKey(screenObject.outcomes, "result", "ok"), {
	                kpis: kpis
	            });
	            if (!isDefined(outcome.result)) {
	                outcome = Object.assign({}, getArrayObjectByKey(screenObject.outcomes, "result", "poor"), {
	                    kpis: kpis
	                });
	            }
	        } else {
	            outcome = Object.assign({}, getArrayObjectByKey(screenObject.outcomes, "result", "poor"), {
	                kpis: kpis
	            });
	        }
	    }
	
	    return outcome;
	}
	
	function getObjectOptionIds(object) {
	    var optionIds = [];
	    for (var i = 0; i < object.options.length; i++) {
	        var option = object.options[i];
	        optionIds = dataHelper.immutablePush(optionIds, option.option_id);
	    }
	    return optionIds;
	}
	
	function getRenderableObjects(userData, bite_id, objects) {
	    var renderableObjects = [];
	
	    for (var i = 0; i < objects.length; i++) {
	        var object = objects[i];
	
	        if (isDefined(object.options)) {
	            var optionIds = getObjectOptionIds(object);
	            var kpiUserData = userDataHelper.getUserResponseByOptionIds(userData, bite_id, optionIds);
	            if (isDefined(kpiUserData)) {
	                if (kpiUserData.option_id.length === 1) {
	                    var optionDetails = getOptionParentDetails(kpiUserData.option_id[0]);
	
	                    if (optionDetails.option.progression === objectConstants.OBJECT_PROGRESSION_CONTINUE || optionDetails.option.progression === objectConstants.OBJECT_PROGRESSION_GO_TO) {
	                        renderableObjects = dataHelper.immutablePush(renderableObjects, object);
	                    } else if (optionDetails.option.progression === objectConstants.OBJECT_PROGRESSION_TERMINAL) {
	                        renderableObjects = dataHelper.immutablePush(renderableObjects, object);
	                        break;
	                    }
	                } else if (kpiUserData.option_id.length > 1) {
	                    var outcome = getObjectOutcomeByKpiHistoryOptions(kpiUserData.option_id);
	
	                    if (outcome.progression === objectConstants.OBJECT_PROGRESSION_CONTINUE || outcome.progression === objectConstants.OBJECT_PROGRESSION_GO_TO) {
	                        renderableObjects = dataHelper.immutablePush(renderableObjects, object);
	                    } else if (outcome.progression === objectConstants.OBJECT_PROGRESSION_TERMINAL) {
	                        renderableObjects = dataHelper.immutablePush(renderableObjects, object);
	                        break;
	                    }
	                }
	            } else {
	                var status = userDataHelper.getObjectStatus(userData, object.object_id).status;
	                if (status === objectConstants.STATUS_COMPLETE && object.object_type === "compare_answer") {
	                    renderableObjects = dataHelper.immutablePush(renderableObjects, object);
	                }
	            }
	        } else {
	            renderableObjects = dataHelper.immutablePush(renderableObjects, object);
	        }
	    }
	    return renderableObjects;
	}
	
	function closeWindow() {
	    /*window.close();*/
	    /*window.parent.close();
	    top.close();*/
	    top.window.close();
	    /*parent.close();*/
	}
	
	function goBack() {
	    window.history.back();
	    window.history.go(-1);
	    history.go(-1);
	    return false;
	}
	
	//todo: move later
	function getUserResponseKpis(userBite, screen_id, asset_id, option_id) {
	    var userKpis = [];
	    for (var i = 0; i < userBite.kpis.length; i++) {
	        var kpi = userBite.kpis[i];
	        var kpiHistory = kpi.history;
	        for (var h = 0; h < kpiHistory.length; h++) {
	            var kpiResponse = kpiHistory[h];
	            if (kpiResponse.screen_id == screen_id && kpiResponse.asset_id === asset_id && kpiResponse.option_id === option_id) {
	                if (userKpis.indexOf(kpiResponse.code) === -1) {
	                    userKpis = dataHelper.immutablePush(userKpis, kpiResponse);
	                } else {
	                    var index = userKpis.indexOf(kpiResponse.code);
	                    if (kpiResponse.attempt > userKpis[index].attempt) {
	                        userKpis = dataHelper.immutableSplice(userKpis, index, 1, kpiResponse);
	                    }
	                }
	            }
	        }
	    }
	    return userKpis;
	}
	
	function _getImagesToPreload(assets) {
	    var imagesToPreload = [];
	    for (var i = 0; i < assets.length; i++) {
	        var asset = assets[i];
	        if (asset.type === assetConstants.ASSET_TYPE_ID_CHARACTER) {
	            if (isDefined(asset.positions)) {
	                for (var p = 0; p < asset.positions.length; p++) {
	                    var position = asset.positions[p];
	                    if (isDefined(position.poses)) {
	                        for (var o = 0; o < position.poses.length; o++) {
	                            var pose = position.poses[o];
	                            if (imagesToPreload.indexOf(pose.src) === -1) {
	                                imagesToPreload = dataHelper.immutablePush(imagesToPreload, pose.src);
	                            }
	                        }
	                    }
	                }
	            }
	        } else {
	            var fileExtention = dataHelper.getFileExtention(asset.src);
	            if (appModels.ALLOWED_IMAGE_FILES.indexOf(fileExtention) > -1) {
	                if (imagesToPreload.indexOf(asset.src) === -1) {
	                    imagesToPreload = dataHelper.immutablePush(imagesToPreload, asset.src);
	                }
	            }
	        }
	    }
	    return imagesToPreload;
	}
	
	function getPrimaryLocale(locale) {
	    return Object.keys(locale)[0];
	}
	
	function getImagesToPreload(default_langauge, assets) {
	
	    var imagesToPreload = [];
	    var srcArray = [];
	    for (var i = 0; i < assets.length; i++) {
	        var asset = assets[i];
	        if (asset.type === assetConstants.ASSET_TYPE_ID_CHARACTER) {
	            if (isDefined(asset.positions)) {
	                for (var p = 0; p < asset.positions.length; p++) {
	                    var position = asset.positions[p];
	                    if (isDefined(position.poses)) {
	                        for (var o = 0; o < position.poses.length; o++) {
	                            var pose = position.poses[o];
	                            var poseArray = [];
	                            if (isDefined(asset.locale)) {
	
	                                var assetLocale = isDefined(pose.locale[default_langauge]) ? pose.locale[default_langauge] : pose.locale[getPrimaryLocale(pose.locale)];
	                                poseArray = assetLocale.src.split("?");
	                            } else {
	                                poseArray = pose.src.split("?");
	                            }
	
	                            var poseSrc = poseArray[0];
	                            //console.log(poseSrc);
	
	                            var originalSrc = pose.src;
	                            if (isDefined(pose.locale)) {
	                                originalSrc = isDefined(pose.locale[default_langauge]) ? pose.locale[default_langauge].src : pose.locale[getPrimaryLocale(pose.locale)].src;
	                            }
	                            if (imagesToPreload.indexOf(originalSrc) === -1 && srcArray.indexOf(poseSrc) === -1) {
	                                imagesToPreload = dataHelper.immutablePush(imagesToPreload, originalSrc);
	                                srcArray = dataHelper.immutablePush(srcArray, poseSrc);
	                            }
	                        }
	                    }
	                }
	            }
	        } else {
	
	            var assetArray = [];
	            if (isDefined(asset.locale)) {
	                var _assetLocale = isDefined(asset.locale[default_langauge]) ? asset.locale[default_langauge] : asset.locale[getPrimaryLocale(asset.locale)];
	                assetArray = _assetLocale.src.split("?");
	            } else {
	                assetArray = asset.src.split("?");
	            }
	            var assetSrc = assetArray[0];
	            // console.log(assetSrc);
	            var fileExtention = dataHelper.getFileExtention(assetSrc);
	            if (appModels.ALLOWED_IMAGE_FILES.indexOf(fileExtention) > -1) {
	                var _originalSrc = asset.src;
	                if (isDefined(asset.locale)) {
	                    _originalSrc = isDefined(asset.locale[default_langauge]) ? asset.locale[default_langauge].src : asset.locale[getPrimaryLocale(asset.locale)].src;
	                }
	                if (imagesToPreload.indexOf(_originalSrc) === -1 && srcArray.indexOf(assetSrc) === -1) {
	                    imagesToPreload = dataHelper.immutablePush(imagesToPreload, _originalSrc);
	                    srcArray = dataHelper.immutablePush(srcArray, assetSrc);
	                }
	            }
	        }
	    }
	    return imagesToPreload;
	}
	
	function getAudioToPreload(assets) {
	    var audioToPreload = [];
	    for (var i = 0; i < assets.length; i++) {
	        var asset = assets[i];
	        var assetSrc = isDefined(asset.locale) ? getLocalData(asset).src : asset.src;
	        if (isDefined(assetSrc)) {
	            var fileExtention = dataHelper.getFileExtention(assetSrc);
	            if (appModels.ALLOWED_AUDIO_FILES.indexOf(fileExtention) > -1) {
	                var audioIndex = getArrayObjectIndexByKey(audioToPreload, "src", assetSrc);
	                if (audioIndex === -1) {
	                    audioToPreload = dataHelper.immutablePush(audioToPreload, asset);
	                }
	            }
	        }
	    }
	    return audioToPreload;
	}
	
	function biteHasScreensVisibleToMenu(screens) {
	    var visibleToMenuCount = 0;
	    _lodash2.default.forEach(screens, function (screen) {
	        if (screen.include_in_menu) {
	            visibleToMenuCount++;
	        }
	    });
	
	    return visibleToMenuCount > 0;
	}
	
	function getPreviousObject(bite_id, screen_id, asset_id) {
	    var bite = getArrayObjectByKey(localStorage.bites, "bite_id", bite_id);
	    var previousObject = {};
	    for (var s = 0; s < bite.screens.length; s++) {
	        var screen = bite.screens[s];
	        if (screen.screen_id === screen_id) {
	            if (isDefined(screen.objects) && screen.objects.length > 0) {
	                for (var o = 0; o < screen.objects.length; o++) {
	                    var object = screen.objects[o];
	                    if (object.asset_id === asset_id) {
	                        if (o > 0) {
	                            previousObject = Object.assign({}, screen.objects[o - 1]);
	                            break;
	                        }
	                    }
	                }
	            }
	        }
	        if (isDefined(screen.sub_screens) && screen.sub_screens.length > 0) {
	            for (var ss = 0; ss < screen.sub_screens.length; ss++) {
	                var sub_screen = screen.sub_screens[ss];
	                if (isDefined(sub_screen.objects) && sub_screen.objects.length > 0) {
	                    for (var sso = 0; sso < sub_screen.objects.length; sso++) {
	                        var _object = sub_screen.objects[sso];
	                        if (_object.asset_id === asset_id) {
	                            if (sso > 0) {
	                                previousObject = Object.assign({}, sub_screen.objects[sso - 1]);
	                                break;
	                            }
	                        }
	                    }
	                }
	            }
	        }
	    }
	
	    return previousObject;
	}
	
	function allowScroll(bite_id, screen_id, asset_id) {
	
	    //console.log(asset_id);
	    var allowScroll = false;
	    var previousObject = getPreviousObject(bite_id, screen_id, asset_id);
	    if (isDefined(previousObject.asset_id)) {
	
	        if (componentModels.ALWAY_SCROLL_AFTER.indexOf(previousObject.object_type) > -1 || componentModels.ALWAY_SCROLL_AFTER.indexOf(previousObject.asset_type_code) > -1) {
	            allowScroll = true;
	        } else if (componentModels.CHECK_SCROLL_AFTER.indexOf(previousObject.object_type) > -1) {
	            if (isDefined(previousObject.progression) && (previousObject.progression === objectConstants.OBJECT_PROGRESSION_CONTINUE || previousObject.progression === objectConstants.OBJECT_PROGRESSION_GO_TO)) {
	                allowScroll = true;
	            }
	        }
	    }
	    //console.log(`allowScroll: ${allowScroll}`);
	    return allowScroll;
	}
	
	function AllowAutoProgressionIfLast(asset_type_code) {
	    if (componentModels.AUTO_NAVIGATE_IF_LAST_ON_INCOMPLETE_SCREEN.indexOf(asset_type_code) > -1) {
	        return true;
	    }
	    return false;
	}
	
	function setResourceLinks(obj) {
	    var resourceLinks = [];
	
	    if (isDefined(obj.resources) && obj.resources.length > 0) {
	        _lodash2.default.forEach(obj.resources, function (resource) {
	            resourceLinks = dataHelper.immutablePush(resourceLinks, resource);
	        });
	    }
	
	    if (isDefined(obj.assets) && obj.assets.length > 0) {
	        _lodash2.default.forEach(obj.assets, function (asset) {
	            resourceLinks = dataHelper.immutablePush(resourceLinks, asset);
	        });
	    }
	
	    return resourceLinks;
	}
	
	function hasRequiredResources(resources) {
	    var hasRequired = false;
	    _lodash2.default.forEach(resources, function (resource) {
	        if (resource.required) {
	            hasRequired = true;
	        }
	    });
	    return hasRequired;
	}
	
	function getPreviousResource(resource) {
	    var returnResource = {};
	    var resourceIndex = getArrayObjectIndexByKey(localStorage.resources, "screen_id", resource.screen_id);
	    if (resourceIndex > 0) {
	        returnResource = Object.assign({}, localStorage.resources[resourceIndex - 1]);
	    }
	    return returnResource;
	}
	
	function getNextResource(resource) {
	    var returnResource = {};
	    var resourceIndex = getArrayObjectIndexByKey(localStorage.resources, "screen_id", resource.screen_id);
	    if (resourceIndex > -1 && resourceIndex < localStorage.resources.length - 1) {
	        returnResource = Object.assign({}, localStorage.resources[resourceIndex + 1]);
	    }
	    return returnResource;
	}
	
	function checkLinearScreenEnabled(userScreen, userBite) {
	
	    var isEnabled = false;
	    if (userScreen.status !== objectConstants.STATUS_NOT_STARTED) {
	        isEnabled = true;
	    } else {
	        var screenIndex = getArrayObjectIndexByKey(userBite.screens, "screen_id", userScreen.screen_id);
	        if (screenIndex > 0) {
	            var previousUserScreen = userBite.screens[screenIndex - 1];
	            if (previousUserScreen.required) {
	                isEnabled = previousUserScreen.status === objectConstants.STATUS_COMPLETE;
	            } else {
	                var prevIndex = screenIndex - 1;
	                for (var i = prevIndex; i > 0; i--) {
	                    var prevScreen = userBite.screens[i];
	                    if (prevScreen.required) {
	                        isEnabled = prevScreen.status === objectConstants.STATUS_COMPLETE;
	                        break;
	                    }
	                }
	            }
	        } else {
	            isEnabled = true;
	        }
	    }
	    return isEnabled;
	}
	
	function checkLinearTargetScreenEnabled(userScreen, userBite, screens) {
	    var isEnabled = false;
	    if (userScreen.status !== objectConstants.STATUS_NOT_STARTED) {
	        isEnabled = true;
	    } else {
	        var firstTargetScreen = getFirstTargetScreen(screens);
	        if (firstTargetScreen.screen_id === userScreen.screen_id) {
	            isEnabled = true;
	        }
	    }
	    return isEnabled;
	}
	
	function getFirstTargetScreen(screens) {
	    var result = {};
	    for (var i = 0; i < screens.length; i++) {
	        var screen = screens[i];
	        if (screen.screen_rule_type === objectConstants.SCREEN_RULE_TYPE_TARGET) {
	            result = Object.assign({}, screen);
	            break;
	        }
	    }
	    return result;
	}
	
	function getPrevTargetScreen(screenIndex, screens) {
	    var result = {};
	    for (var i = screenIndex; i > 0; i--) {
	        var screen = screens[i];
	        if (screen.screen_rule_type === objectConstants.SCREEN_RULE_TYPE_TARGET) {
	            result = Object.assign({}, screen);
	            break;
	        }
	    }
	    return result;
	}
	
	function getNextTargetScreen(screenIndex, screens) {
	    var result = {};
	    for (var i = screenIndex; i < screens.length; i++) {
	        var screen = screens[i];
	        if (screen.screen_rule_type === objectConstants.SCREEN_RULE_TYPE_TARGET) {
	            result = Object.assign({}, screen);
	            break;
	        }
	    }
	    return result;
	}
	
	function checkLinearMenuBiteEnabled(userBite, userData) {
	    var isEnabled = false;
	    if (userBite.status !== objectConstants.STATUS_NOT_STARTED) {
	        isEnabled = true;
	    } else {
	        var biteIndex = getArrayObjectIndexByKey(userData.bites, "bite_id", userBite.bite_id);
	        if (biteIndex > 0) {
	            var previousUserBite = userData.bites[biteIndex - 1];
	            if (previousUserBite.required) {
	                isEnabled = previousUserBite.status === objectConstants.STATUS_COMPLETE;
	            } else {
	                var prevIndex = biteIndex - 1;
	                for (var i = prevIndex; i > 0; i--) {
	                    var prevBite = userData.bites[i];
	                    if (prevBite.required) {
	                        isEnabled = prevBite.status === objectConstants.STATUS_COMPLETE;
	                        break;
	                    }
	                }
	            }
	        } else {
	            isEnabled = true;
	        }
	    }
	    return isEnabled;
	}
	
	function checkOpenMenuBiteEnabled(userBite, userData) {
	    var isEnabled = false;
	    if (userBite.status !== objectConstants.STATUS_NOT_STARTED) {
	        isEnabled = true;
	    } else {
	        var biteIndex = getArrayObjectIndexByKey(userData.bites, "bite_id", userBite.bite_id);
	        if (biteIndex > 0) {
	            var firstBite = userData.bites[0];
	            isEnabled = firstBite.status === objectConstants.STATUS_COMPLETE;
	        } else {
	            isEnabled = true;
	        }
	    }
	    return isEnabled;
	}
	
	function checkFirstLastAnyMenuBiteEnabled(userBite, userData) {
	    var isEnabled = false;
	    if (userBite.status !== objectConstants.STATUS_NOT_STARTED) {
	        isEnabled = true;
	    } else {
	        var biteIndex = getArrayObjectIndexByKey(userData.bites, "bite_id", userBite.bite_id);
	        if (biteIndex > 0) {
	            var firstBite = userData.bites[0];
	            if (biteIndex < userData.bites.length - 1) {
	                isEnabled = firstBite.status === objectConstants.STATUS_COMPLETE;
	            } else {
	                var lastIndex = userData.bites.length - 2; //minus 2 because we dont want to include the last bite
	                var requiredBites = 0;
	                var completeRequiredBites = 0;
	                for (var i = lastIndex; i > 0; i--) {
	                    var prevBite = userData.bites[i];
	                    if (prevBite.required) {
	                        requiredBites++;
	                        if (prevBite.status === objectConstants.STATUS_COMPLETE) {
	                            completeRequiredBites++;
	                        }
	                    }
	                }
	                isEnabled = requiredBites === completeRequiredBites;
	            }
	        } else {
	            isEnabled = true;
	        }
	    }
	
	    return isEnabled;
	}
	
	function getAllBadges() {
	    var allBadges = [];
	    _lodash2.default.forEach(localStorage.bites, function (bite) {
	        if (isDefined(bite.badges)) {
	            _lodash2.default.forEach(bite.badges, function (badge) {
	                var badgeIndex = getArrayObjectIndexByKey(allBadges, "badge_id", badge.badge_id);
	                if (badgeIndex === -1) {
	                    allBadges = dataHelper.immutablePush(allBadges, badge);
	                }
	            });
	        }
	    });
	    return allBadges;
	}
	
	function getScreenData(params) {
	    var bite = getArrayObjectByKey(localStorage.bites, "bite_id", params.bite_id);
	
	    return getArrayObjectByKey(bite.screens, "screen_id", params.screen_id);
	}
	
	function getSubScreen(params) {
	    var bite = getArrayObjectByKey(localStorage.bites, "bite_id", params.bite_id);
	    var parentScreen = getArrayObjectByKey(bite.screens, "screen_id", params.parent_screen_id);
	    return getArrayObjectByKey(parentScreen.sub_screens, "screen_id", params.screen_id);
	}
	
	function getScreenByAssetId(asset_id) {
	    var returnObject = {};
	    //let screenFound = false;
	    var bites = localStorage.contentData.experience.bites;
	
	    _lodash2.default.forEach(bites, function (bite) {
	        _lodash2.default.forEach(bite.screens, function (screen) {
	            if (isDefined(screen.objects) && screen.objects.length > 0) {
	                _lodash2.default.forEach(screen.objects, function (object) {
	                    if (object.asset_id === asset_id) {
	                        returnObject = Object.assign({}, screen);
	                    }
	                });
	            } else if (isDefined(screen.sub_screens) && screen.sub_screens.length > 0) {
	                _lodash2.default.forEach(screen.sub_screens, function (sub_screen) {
	                    if (isDefined(sub_screen.objects)) {
	                        _lodash2.default.forEach(sub_screen.objects, function (object) {
	                            if (object.asset_id === asset_id) {
	                                returnObject = Object.assign({}, sub_screen);
	                            }
	                        });
	                    }
	                });
	            }
	        });
	    });
	    return returnObject;
	}
	
	function getScreenCharacterNameByAssetId(asset_id) {
	    var characterName = "Character";
	    var screen = getScreenByAssetId(asset_id);
	    if (isDefined(screen)) {
	        var screenLocale = getLocalData(screen);
	        if (isDefined(screenLocale.character_name)) {
	            characterName = screenLocale.character_name;
	        }
	    }
	    return characterName;
	}
	
	function getScreenNotes(parentScreen, screen) {
	    var notes = [];
	    if (isDefined(parentScreen)) {
	
	        if (isDefined(parentScreen.notes) && parentScreen.notes.length > 0 && parentScreen.notes !== "<p><br></p>") {
	            var subScreenIndex = getArrayObjectIndexByKey(parentScreen.sub_screens, "screen_id", screen.screen_id);
	            if (subScreenIndex === 0) {
	                var parentNotesObject = {
	                    screen_id: parentScreen.screen_id,
	                    notes: parentScreen.notes
	                };
	                notes = dataHelper.immutablePush(notes, parentNotesObject);
	            }
	        }
	    }
	
	    if (isDefined(screen.notes) && screen.notes.length > 0 && screen.notes !== "<p><br></p>") {
	        var notesObject = {
	            screen_id: screen.screen_id,
	            notes: screen.notes
	        };
	        notes = dataHelper.immutablePush(notes, notesObject);
	    }
	
	    return notes;
	}
	
	function allowClippedBlurEffect() {
	    return (dataHelper.cssPropertyValueSupported('clip-path', 'inset(0px 0px 0px 40%)') || dataHelper.cssPropertyValueSupported('-webkit-clip-path', 'inset(0px 0px 0px 40%)')) && dataHelper.cssPropertyValueSupported('filter', 'blur(3px)');
	}
	
	function getAllPrintableAssets() {
	    var printableAssets = [];
	    _lodash2.default.forEach(localStorage.bites, function (bite) {
	        _lodash2.default.forEach(bite.screens, function (screen) {
	            if (isDefined(screen.objects) && screen.objects.length > 0) {
	                _lodash2.default.forEach(screen.objects, function (object) {
	                    if (isDefined(object.print_type) && object.print_type === objectConstants.INCLUDE_IN_PRINT) {
	                        object = Object.assign({}, object, {
	                            bite_id: bite.bite_id,
	                            screen_id: screen.screen_id
	                        });
	                        printableAssets = dataHelper.immutablePush(printableAssets, object);
	                    }
	                });
	            } else if (isDefined(screen.sub_screens) && screen.sub_screens.length > 0) {
	                _lodash2.default.forEach(screen.sub_screens, function (sub_screen) {
	                    if (isDefined(sub_screen.objects)) {
	                        _lodash2.default.forEach(sub_screen.objects, function (object) {
	                            if (isDefined(object.print_type) && object.print_type === objectConstants.INCLUDE_IN_PRINT) {
	                                object = Object.assign({}, object, {
	                                    bite_id: bite.bite_id,
	                                    screen_id: sub_screen.screen_id
	                                });
	                                printableAssets = dataHelper.immutablePush(printableAssets, object);
	                            }
	                        });
	                    }
	                });
	            }
	        });
	    });
	    return printableAssets;
	}
	
	function getPrintableAssetsByBite(bite_id) {
	    var printableAssets = [];
	    var bite = getArrayObjectByKey(localStorage.bites, "bite_id", bite_id);
	    _lodash2.default.forEach(bite.screens, function (screen) {
	        if (isDefined(screen.objects) && screen.objects.length > 0) {
	            _lodash2.default.forEach(screen.objects, function (object) {
	                if (isDefined(object.print_type) && object.print_type === objectConstants.INCLUDE_IN_PRINT) {
	                    object = Object.assign({}, object, {
	                        bite_id: bite.bite_id,
	                        screen_id: screen.screen_id
	                    });
	                    printableAssets = dataHelper.immutablePush(printableAssets, object);
	                }
	            });
	        } else if (isDefined(screen.sub_screens) && screen.sub_screens.length > 0) {
	            _lodash2.default.forEach(screen.sub_screens, function (sub_screen) {
	                if (isDefined(sub_screen.objects)) {
	                    _lodash2.default.forEach(sub_screen.objects, function (object) {
	                        if (isDefined(object.print_type) && object.print_type === objectConstants.INCLUDE_IN_PRINT) {
	                            object = Object.assign({}, object, {
	                                bite_id: bite.bite_id,
	                                screen_id: sub_screen.screen_id
	                            });
	                            printableAssets = dataHelper.immutablePush(printableAssets, object);
	                        }
	                    });
	                }
	            });
	        }
	    });
	
	    return printableAssets;
	}
	
	function screenExists(screen_id) {
	    var screen_exists = false;
	    _lodash2.default.forEach(localStorage.bites, function (bite) {
	        _lodash2.default.forEach(bite.screens, function (screen) {
	            if (screen.screen_id === screen_id) {
	                screen_exists = true;
	            }
	        });
	    });
	    return screen_exists;
	}
	
	function getOptionResultString(result, isMissed) {
	    var optionString = isMissed ? getLocaleString("this_is_a_missed") + ' ' : getLocaleString("this_is_a") + ' ';
	    switch (result) {
	
	        case objectConstants.RESULT_BEST:
	            optionString += getLocaleString("best_label") + ' ';
	            break;
	        case objectConstants.RESULT_OK:
	            optionString += getLocaleString("ok_label") + ' ';
	            break;
	        case objectConstants.RESULT_POOR:
	            optionString += getLocaleString("poor_label") + ' ';
	            break;
	        case objectConstants.RESULT_REFLECTIVE:
	            optionString += getLocaleString("reflective_label") + ' ';
	            break;
	    }
	
	    optionString += getLocaleString("option_label") + '. ';
	    return optionString;
	}

/***/ },
/* 4 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.compose = exports.applyMiddleware = exports.bindActionCreators = exports.combineReducers = exports.createStore = undefined;
	
	var _createStore = __webpack_require__(432);
	
	var _createStore2 = _interopRequireDefault(_createStore);
	
	var _combineReducers = __webpack_require__(1080);
	
	var _combineReducers2 = _interopRequireDefault(_combineReducers);
	
	var _bindActionCreators = __webpack_require__(1079);
	
	var _bindActionCreators2 = _interopRequireDefault(_bindActionCreators);
	
	var _applyMiddleware = __webpack_require__(1078);
	
	var _applyMiddleware2 = _interopRequireDefault(_applyMiddleware);
	
	var _compose = __webpack_require__(431);
	
	var _compose2 = _interopRequireDefault(_compose);
	
	var _warning = __webpack_require__(433);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	/*
	* This is a dummy function to check if the function name has been altered by minification.
	* If the function has been minified and NODE_ENV !== 'production', warn the user.
	*/
	function isCrushed() {}
	
	if (false) {
	  (0, _warning2['default'])('You are currently using minified code outside of NODE_ENV === \'production\'. ' + 'This means that you are running a slower development build of Redux. ' + 'You can use loose-envify (https://github.com/zertosh/loose-envify) for browserify ' + 'or DefinePlugin for webpack (http://stackoverflow.com/questions/30030031) ' + 'to ensure you have the correct code for your production build.');
	}
	
	exports.createStore = _createStore2['default'];
	exports.combineReducers = _combineReducers2['default'];
	exports.bindActionCreators = _bindActionCreators2['default'];
	exports.applyMiddleware = _applyMiddleware2['default'];
	exports.compose = _compose2['default'];

/***/ },
/* 5 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.connect = exports.connectAdvanced = exports.createProvider = exports.Provider = undefined;
	
	var _Provider = __webpack_require__(1037);
	
	var _Provider2 = _interopRequireDefault(_Provider);
	
	var _connectAdvanced = __webpack_require__(414);
	
	var _connectAdvanced2 = _interopRequireDefault(_connectAdvanced);
	
	var _connect = __webpack_require__(1038);
	
	var _connect2 = _interopRequireDefault(_connect);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.Provider = _Provider2.default;
	exports.createProvider = _Provider.createProvider;
	exports.connectAdvanced = _connectAdvanced2.default;
	exports.connect = _connect2.default;

/***/ },
/* 6 */
/***/ function(module, exports, __webpack_require__) {

	var global = __webpack_require__(24);
	var core = __webpack_require__(70);
	var hide = __webpack_require__(52);
	var redefine = __webpack_require__(53);
	var ctx = __webpack_require__(71);
	var PROTOTYPE = 'prototype';
	
	var $export = function (type, name, source) {
	  var IS_FORCED = type & $export.F;
	  var IS_GLOBAL = type & $export.G;
	  var IS_STATIC = type & $export.S;
	  var IS_PROTO = type & $export.P;
	  var IS_BIND = type & $export.B;
	  var target = IS_GLOBAL ? global : IS_STATIC ? global[name] || (global[name] = {}) : (global[name] || {})[PROTOTYPE];
	  var exports = IS_GLOBAL ? core : core[name] || (core[name] = {});
	  var expProto = exports[PROTOTYPE] || (exports[PROTOTYPE] = {});
	  var key, own, out, exp;
	  if (IS_GLOBAL) source = name;
	  for (key in source) {
	    // contains in native
	    own = !IS_FORCED && target && target[key] !== undefined;
	    // export native or passed
	    out = (own ? target : source)[key];
	    // bind timers to global for call from export context
	    exp = IS_BIND && own ? ctx(out, global) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
	    // extend global
	    if (target) redefine(target, key, out, type & $export.U);
	    // export
	    if (exports[key] != out) hide(exports, key, exp);
	    if (IS_PROTO && expProto[key] != out) expProto[key] = out;
	  }
	};
	global.core = core;
	// type bitmap
	$export.F = 1;   // forced
	$export.G = 2;   // global
	$export.S = 4;   // static
	$export.P = 8;   // proto
	$export.B = 16;  // bind
	$export.W = 32;  // wrap
	$export.U = 64;  // safe
	$export.R = 128; // real proto method for `library`
	module.exports = $export;


/***/ },
/* 7 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.setTrackingData = setTrackingData;
	exports.setDialogPopup = setDialogPopup;
	exports.initTracking = initTracking;
	exports.doLMSFinish = doLMSFinish;
	exports.doLMSCommit = doLMSCommit;
	exports.doQuickLMSFinish = doQuickLMSFinish;
	exports.doQuickLMSCommit = doQuickLMSCommit;
	exports.doLMSExit = doLMSExit;
	exports.setLessonLocation = setLessonLocation;
	exports.setNextLessonLocation = setNextLessonLocation;
	exports.setSuspendData = setSuspendData;
	exports.setNewLessonLocation = setNewLessonLocation;
	exports.postActvityStatement = postActvityStatement;
	exports.getActvityStatement = getActvityStatement;
	exports.setScreenAccessed = setScreenAccessed;
	exports.setScreenComplete = setScreenComplete;
	exports.setBadgeStatement = setBadgeStatement;
	exports.setActorDetails = setActorDetails;
	
	var _appConstants = __webpack_require__(13);
	
	var appConstants = _interopRequireWildcard(_appConstants);
	
	var _appHelper = __webpack_require__(3);
	
	var appHelper = _interopRequireWildcard(_appHelper);
	
	var _dataHelper = __webpack_require__(11);
	
	var dataHelper = _interopRequireWildcard(_dataHelper);
	
	var _userDataHelper = __webpack_require__(15);
	
	var userDataHelper = _interopRequireWildcard(_userDataHelper);
	
	var _suspendDataHelper = __webpack_require__(556);
	
	var suspendDataHelper = _interopRequireWildcard(_suspendDataHelper);
	
	var _badgeHelper = __webpack_require__(201);
	
	var badgeHelper = _interopRequireWildcard(_badgeHelper);
	
	var _xAPIHelper = __webpack_require__(86);
	
	var xapiHelper = _interopRequireWildcard(_xAPIHelper);
	
	var _scormService = __webpack_require__(583);
	
	var _scormService2 = _interopRequireDefault(_scormService);
	
	var _xAPIService = __webpack_require__(585);
	
	var _xAPIService2 = _interopRequireDefault(_xAPIService);
	
	var _xAPIScormService = __webpack_require__(584);
	
	var _xAPIScormService2 = _interopRequireDefault(_xAPIScormService);
	
	var _openLearningService = __webpack_require__(582);
	
	var _openLearningService2 = _interopRequireDefault(_openLearningService);
	
	var _appModels = __webpack_require__(68);
	
	var appData = _interopRequireWildcard(_appModels);
	
	var _actionTypes = __webpack_require__(22);
	
	var types = _interopRequireWildcard(_actionTypes);
	
	var _localStorage = __webpack_require__(17);
	
	var localStorage = _interopRequireWildcard(_localStorage);
	
	var _objectConstants = __webpack_require__(9);
	
	var objectConstants = _interopRequireWildcard(_objectConstants);
	
	var _scormConstants = __webpack_require__(137);
	
	var scormConstants = _interopRequireWildcard(_scormConstants);
	
	var _dialogPopupActions = __webpack_require__(19);
	
	var dialogPopupActions = _interopRequireWildcard(_dialogPopupActions);
	
	var _dialogModels = __webpack_require__(32);
	
	var _dialogHelper = __webpack_require__(202);
	
	var _lodash = __webpack_require__(28);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function setTrackingData(trackingData) {
	    return { type: types.SET_TRACKING_DATA, trackingData: trackingData };
	}
	
	function setDialogPopup(dialogPopup) {
	    return { type: types.SET_DIALOG_POPUP, dialogPopup: dialogPopup };
	}
	
	function initTracking(contentData) {
	    if (contentData.experience.tracking_type === appConstants.TRACKING_TYPE_SCORM) {
	        return function (dispatch) {
	            return _scormService2.default.initTracking().then(function (trackingData) {
	                dispatch(setTrackingData(trackingData));
	            }).catch(function (error) {
	                throw error;
	            });
	        };
	    } else if (contentData.experience.tracking_type === appConstants.TRACKING_TYPE_XAPI) {
	        return function (dispatch, getState) {
	            var state = getState();
	            var trackingData = state.trackingData;
	            return _xAPIService2.default.checkActorDefined(contentData).then(function (lrs) {
	                if (!appHelper.isDefined(trackingData.actor) && !appHelper.isDefined(lrs.lrs.actor) && contentData.experience.lrs.prompt_for_actor_if_needed) {
	                    var dialogConfig = Object.assign({}, _dialogModels.XAPI_INIT_ACTOR_CONFIG, {
	                        title: '' + localStorage.experience_locale.experience_title
	                    });
	                    return (0, _dialogHelper.setStandardDialog)(dialogConfig).then(function (dialogPopup) {
	                        dispatch(setDialogPopup(dialogPopup));
	                    }).catch(function (error) {
	                        throw error;
	                    });
	                } else if (!appHelper.isDefined(trackingData.actor) && !appHelper.isDefined(lrs.lrs.actor) && appHelper.isDefined(contentData.experience.lrs.always_anonymous) && contentData.experience.lrs.always_anonymous) {
	                    var actor = xapiHelper.setUserAsAnonymous();
	                    trackingData = Object.assign({}, state.trackingData, {
	                        actor: actor
	                    });
	                    return _xAPIService2.default.initTracking(contentData, trackingData).then(function (trackingData) {
	                        dispatch(setTrackingData(trackingData));
	                    }).catch(function (error) {
	                        throw error;
	                    });
	                } else {
	                    var _trackingData = state.trackingData;
	                    if (!_trackingData.initialised) {
	                        return _xAPIService2.default.initTracking(contentData, _trackingData).then(function (trackingData) {
	
	                            dispatch(setTrackingData(trackingData));
	                        }).catch(function (error) {
	                            throw error;
	                        });
	                    }
	                }
	            }).catch(function (error) {
	                throw error;
	            });
	        };
	    } else if (contentData.experience.tracking_type === appConstants.TRACKING_TYPE_BLENDED_XAPI_SCORM_1_2) {
	        return function (dispatch) {
	            return _xAPIScormService2.default.initTracking(contentData).then(function (trackingData) {
	                dispatch(setTrackingData(trackingData));
	            }).catch(function (error) {
	                throw error;
	            });
	        };
	    } else if (contentData.experience.tracking_type === appConstants.TRACKING_TYPE_OPEN_LEARNING) {
	        return function (dispatch) {
	            return _openLearningService2.default.initTracking(contentData).then(function (trackingData) {
	                dispatch(setTrackingData(trackingData));
	            }).catch(function (error) {
	                throw error;
	            });
	        };
	    } else {
	        return function (dispatch) {
	
	            var trackingData = Object.assign({}, appData.TRACKING_DATA, {
	                initialised: true
	            });
	
	            if (appHelper.isDefined(contentData.experience.publish_details)) {
	                var student_name = contentData.experience.publish_details.published_by;
	                var student_name_array = student_name.split(" ");
	                var first_name = student_name_array[0];
	                var last_name = student_name_array[1];
	                trackingData = Object.assign({}, trackingData, {
	                    initialised: true,
	                    student_name: student_name,
	                    first_name: first_name,
	                    last_name: last_name
	                });
	            }
	
	            dispatch(setTrackingData(trackingData));
	            ////console.log('OPEN IT IS');
	        };
	    }
	}
	
	function doLMSFinish(tracking_type) {
	    //console.log('doLMSFinish');
	    if (tracking_type === appConstants.TRACKING_TYPE_SCORM || tracking_type === appConstants.TRACKING_TYPE_BLENDED_XAPI_SCORM_1_2) {
	        return function (dispatch) {
	            return _scormService2.default.doLMSFinish().then(function (trackingData) {
	                return trackingData;
	            }).catch(function (error) {
	                throw error;
	            });
	        };
	    }
	}
	
	function doLMSCommit(tracking_type) {
	    //console.log('doLMSCommit');
	    if (tracking_type === appConstants.TRACKING_TYPE_SCORM || tracking_type === appConstants.TRACKING_TYPE_BLENDED_XAPI_SCORM_1_2) {
	        return function (dispatch) {
	            return _scormService2.default.doLMSCommit().then(function (trackingData) {
	                return trackingData;
	            }).catch(function (error) {
	                throw error;
	            });
	        };
	    }
	}
	
	function doQuickLMSFinish(tracking_type) {
	    //console.log('doLMSFinish');
	    if (tracking_type === appConstants.TRACKING_TYPE_SCORM || tracking_type === appConstants.TRACKING_TYPE_BLENDED_XAPI_SCORM_1_2) {
	        return function (dispatch) {
	            return _scormService2.default.doQuickLMSFinish().then(function (trackingData) {
	                return trackingData;
	            }).catch(function (error) {
	                throw error;
	            });
	        };
	    }
	}
	
	function doQuickLMSCommit(tracking_type) {
	    //console.log('doLMSCommit');
	    if (tracking_type === appConstants.TRACKING_TYPE_SCORM || tracking_type === appConstants.TRACKING_TYPE_BLENDED_XAPI_SCORM_1_2) {
	        return function (dispatch) {
	            return _scormService2.default.doQuickLMSCommit().then(function (trackingData) {
	                return trackingData;
	            }).catch(function (error) {
	                throw error;
	            });
	        };
	    }
	}
	
	function doLMSExit(tracking_type, exit_url) {
	    //console.log('doLMSExit');
	    if (tracking_type === appConstants.TRACKING_TYPE_SCORM || tracking_type === appConstants.TRACKING_TYPE_BLENDED_XAPI_SCORM_1_2) {
	        return function (dispatch, getState) {
	            var state = getState();
	            var userData = state.userData;
	
	            var scores = [];
	            var totalScore = 0;
	            var avgScore = 100;
	            var totalweight = 0;
	            _lodash2.default.forEach(userData.bites, function (bite) {
	                var primaryKpi = appHelper.getArrayObjectByKey(bite.kpis, "is_primary", true);
	                if (appHelper.isDefined(primaryKpi)) {
	                    var score = dataHelper.getRangePercentage(primaryKpi.min, primaryKpi.max, primaryKpi.current);
	                    if (isNaN(score)) {
	                        score = scormConstants.CMI_CORE_SCORE_MAX_DEFAULT;
	                    }
	
	                    var weightedScore = score * bite.weight;
	
	                    scores.push(weightedScore);
	                    totalScore += weightedScore;
	                    totalweight += bite.weight;
	                }
	            });
	
	            if (totalweight > 0) {
	                avgScore = Math.round(totalScore / totalweight);
	            }
	
	            //console.log(`(${totalScore} / ${scores.length}) = ${avgScore}`);
	            _scormService2.default.setScoreRaw(avgScore).then(function (rawScoreResult) {
	                _scormService2.default.setScoreMin(scormConstants.CMI_CORE_SCORE_MIN_DEFAULT).then(function (minScoreResult) {
	                    _scormService2.default.setScoreMax(scormConstants.CMI_CORE_SCORE_MAX_DEFAULT).then(function (maxScoreResult) {
	                        _scormService2.default.doLMSCommit().then(function (doLMSCommitResult) {
	                            _scormService2.default.lmsGetScore();
	                            _scormService2.default.lmsGetLessonStatus();
	                            _scormService2.default.doLMSExit().then(function (result) {
	                                //console.log(result);
	                                _scormService2.default.doLMSCommit().then(function (commitResult) {
	                                    //console.log(commitResult);
	                                    //window.location = exit_url;
	                                    _scormService2.default.doLMSFinish().then(function (finishResult) {
	                                        //console.log(finishResult);
	                                        //window.location = exit_url;
	                                    }).catch(function (error) {
	                                        throw error;
	                                    });
	                                }).catch(function (error) {
	                                    throw error;
	                                });
	                            }).catch(function (error) {
	                                throw error;
	                            });
	                        }).catch(function (error) {
	                            //console.log(`doLMSCommit error:`, error);
	                            throw error;
	                        });
	                    }).catch(function (error) {
	                        //console.log(`maxScoreResult error:`, error);
	                        throw error;
	                    }); //set cmi.core.score.raw //cmi.core.score.max
	                }).catch(function (error) {
	                    //console.log(`minScoreResult error:`, error);
	                    throw error;
	                });
	            }).catch(function (error) {
	                //console.log(`rawScoreResult error:`, error);
	                throw error;
	            }); //set cmi.core.score.raw
	            //set cmi.core.score.raw //cmi.core.score.min*/
	            /*return scormService.doLMSExit().then(result => {
	                console.log(result);
	                scormService.doLMSCommit().then(commitResult => {
	                    console.log(commitResult);
	                    //window.location = exit_url;
	                }).catch(error => {
	                    throw(error);
	                });
	            }).catch(error => {
	                throw(error);
	            });*/
	        };
	    }
	}
	
	function setLessonLocation(screen_id) {
	
	    return function (dispatch, getState) {
	        var state = getState();
	        var nextScreenId = screen_id;
	        var trackingData = Object.assign({}, state.trackingData);
	        var last_lesson_location = 0;
	        var location_history = Object.assign([], state.trackingData.location_history);
	        var location_history_last_index = location_history.length - 1;
	        //console.log(`${location_history_last_index} > -1 && ${location_history[location_history_last_index]} === ${nextScreenId}`);
	
	        if (location_history_last_index > -1 && location_history[location_history_last_index] === nextScreenId) {
	            location_history = dataHelper.immutableSplice(location_history, location_history_last_index, 1);
	        } else if (location_history[location_history_last_index] !== trackingData.lesson_location) {
	            location_history = dataHelper.immutablePush(location_history, trackingData.lesson_location);
	        }
	
	        if (location_history.length > 0) {
	            last_lesson_location = location_history[location_history.length - 1];
	        }
	
	        trackingData = Object.assign({}, state.trackingData, {
	            lesson_location: nextScreenId,
	            location_history: location_history,
	            last_lesson_location: last_lesson_location
	        });
	
	        /*let trackingData = Object.assign({}, state.trackingData,
	            {
	                lesson_location: screen_id
	            }
	        );*/
	        //console.log(trackingData);
	        if (localStorage.tracking_type === appConstants.TRACKING_TYPE_SCORM || localStorage.tracking_type === appConstants.TRACKING_TYPE_BLENDED_XAPI_SCORM_1_2) {
	            return _scormService2.default.setLessionLocation(screen_id).then(function (result) {
	                _scormService2.default.doLMSCommit().then(function (result) {
	                    dispatch(setTrackingData(trackingData));
	                    return result;
	                }).catch(function (error) {
	                    throw error;
	                });
	            }).catch(function (error) {
	                throw error;
	            });
	        } else if (localStorage.tracking_type === appConstants.TRACKING_TYPE_XAPI) {
	            return _xAPIService2.default.setLessionLocation(screen_id, state.trackingData.lrs).then(function (result) {
	                dispatch(setTrackingData(trackingData));
	                return result;
	            }).catch(function (error) {
	                throw error;
	            });
	        } else if (localStorage.tracking_type === appConstants.TRACKING_TYPE_OPEN_LEARNING) {
	            return _openLearningService2.default.setLessionLocation(screen_id).then(function (result) {
	                dispatch(setTrackingData(trackingData));
	                //return result;
	            }).catch(function (error) {
	                throw error;
	            });
	        }
	
	        dispatch(setTrackingData(trackingData));
	    };
	}
	
	function setNextLessonLocation(screen_id) {
	    return function (dispatch, getState) {
	        var state = getState();
	        var nextScreenId = appHelper.getNextScreenId(screen_id);
	        var trackingData = Object.assign({}, state.trackingData);
	        var last_lesson_location = 0;
	        var location_history = Object.assign([], state.trackingData.location_history);
	        var location_history_last_index = location_history.length - 1;
	        //console.log(`${location_history_last_index} > -1 && ${location_history[location_history_last_index]} === ${nextScreenId}`);
	
	        if (location_history_last_index > -1 && location_history[location_history_last_index] === nextScreenId) {
	            location_history = dataHelper.immutableSplice(location_history, location_history_last_index, 1);
	        } else if (location_history[location_history_last_index] !== trackingData.lesson_location) {
	            location_history = dataHelper.immutablePush(location_history, trackingData.lesson_location);
	        }
	
	        if (location_history.length > 0) {
	            last_lesson_location = location_history[location_history.length - 1];
	        }
	
	        trackingData = Object.assign({}, state.trackingData, {
	            lesson_location: nextScreenId,
	            location_history: location_history,
	            last_lesson_location: last_lesson_location
	        });
	
	        if (localStorage.tracking_type === appConstants.TRACKING_TYPE_SCORM || localStorage.tracking_type === appConstants.TRACKING_TYPE_BLENDED_XAPI_SCORM_1_2) {
	            return _scormService2.default.setLessionLocation(nextScreenId).then(function (result) {
	                _scormService2.default.doLMSCommit();
	                dispatch(setTrackingData(trackingData));
	                return result;
	            }).catch(function (error) {
	                throw error;
	            });
	        } else if (localStorage.tracking_type === appConstants.TRACKING_TYPE_XAPI) {
	            return _xAPIService2.default.setLessionLocation(nextScreenId, state.trackingData.lrs).then(function (result) {
	                dispatch(setTrackingData(trackingData));
	                return result;
	            }).catch(function (error) {
	                throw error;
	            });
	        } else if (localStorage.tracking_type === appConstants.TRACKING_TYPE_OPEN_LEARNING) {
	            return _openLearningService2.default.setLessionLocation(nextScreenId).then(function (result) {
	                dispatch(setTrackingData(trackingData));
	                //return result;
	            }).catch(function (error) {
	                throw error;
	            });
	        }
	        dispatch(setTrackingData(trackingData));
	    };
	}
	
	function setSuspendData(userData) {
	    return function (dispatch, getState) {
	        var state = getState();
	        //console.log('setSuspendData');
	        return suspendDataHelper.setSuspendData(userData).then(function (suspend_data) {
	            var trackingData = Object.assign({}, state.trackingData, {
	                suspend_data: suspend_data
	
	            });
	
	            switch (localStorage.tracking_type) {
	                case appConstants.TRACKING_TYPE_SCORM:
	                    _scormService2.default.setSuspendData(suspend_data); //set cmi.suspend_data
	
	                    if (userData.status === objectConstants.STATUS_COMPLETE) {
	                        _scormService2.default.setLessionStatus(scormConstants.LESSON_STATUS_COMPLETED).then(function (result) {
	                            var scores = [];
	                            var totalScore = 0;
	                            var avgScore = 100;
	                            var totalweight = 0;
	                            _lodash2.default.forEach(userData.bites, function (bite) {
	                                var primaryKpi = appHelper.getArrayObjectByKey(bite.kpis, "is_primary", true);
	                                if (appHelper.isDefined(primaryKpi)) {
	                                    var score = dataHelper.getRangePercentage(primaryKpi.min, primaryKpi.max, primaryKpi.current);
	                                    if (isNaN(score)) {
	                                        score = scormConstants.CMI_CORE_SCORE_MAX_DEFAULT;
	                                    }
	
	                                    var weightedScore = score * bite.weight;
	
	                                    scores.push(weightedScore);
	                                    totalScore += weightedScore;
	                                    totalweight += bite.weight;
	                                }
	                            });
	
	                            if (totalweight > 0) {
	                                avgScore = Math.round(totalScore / totalweight);
	                            }
	
	                            _scormService2.default.setScoreRaw(avgScore).then(function (rawScoreResult) {
	                                _scormService2.default.setScoreMin(scormConstants.CMI_CORE_SCORE_MIN_DEFAULT).then(function (minScoreResult) {
	                                    _scormService2.default.setScoreMax(scormConstants.CMI_CORE_SCORE_MAX_DEFAULT).then(function (maxScoreResult) {
	                                        _scormService2.default.doLMSCommit().then(function (doLMSCommitResult) {
	                                            _scormService2.default.lmsGetScore();
	                                            _scormService2.default.lmsGetLessonStatus();
	                                        }).catch(function (error) {
	                                            //console.log(`doLMSCommit error:`, error);
	                                            throw error;
	                                        });
	                                    }).catch(function (error) {
	                                        //console.log(`maxScoreResult error:`, error);
	                                        throw error;
	                                    }); //set cmi.core.score.raw //cmi.core.score.max
	                                }).catch(function (error) {
	                                    //console.log(`minScoreResult error:`, error);
	                                    throw error;
	                                });
	                            }).catch(function (error) {
	                                //console.log(`rawScoreResult error:`, error);
	                                throw error;
	                            }); //set cmi.core.score.raw
	                            //set cmi.core.score.raw //cmi.core.score.min
	                        }).catch(function (error) {
	                            //console.log(`error:`, error);
	                            throw error;
	                        }); //set cmi.core.lesson_status to completed
	
	                    } else {
	                        _scormService2.default.setLessionStatus(scormConstants.LESSON_STATUS_INCOMPLETE); //set cmi.core.lesson_status to incomplete
	                    }
	                    _scormService2.default.doLMSCommit();
	
	                    break;
	                case appConstants.TRACKING_TYPE_XAPI:
	                    _xAPIService2.default.setSuspendData(suspend_data, state.trackingData.lrs).then(function (result) {
	                        if (userData.status == objectConstants.STATUS_COMPLETE) {
	                            _xAPIService2.default.markComplete(state.trackingData.lrs, userData.bites, localStorage.contentData);
	                        }
	                        return result;
	                    }).catch(function (error) {
	                        throw error;
	                    });
	                    break;
	                case appConstants.TRACKING_TYPE_BLENDED_XAPI_SCORM_1_2:
	                    _xAPIService2.default.setSuspendData(suspend_data, state.trackingData.lrs).then(function (result) {
	                        if (userData.status == objectConstants.STATUS_COMPLETE) {
	                            _xAPIService2.default.markComplete(state.trackingData.lrs, userData.bites, localStorage.contentData);
	
	                            _scormService2.default.setLessionStatus(scormConstants.LESSON_STATUS_COMPLETED); //set cmi.core.lesson_status to completed
	
	                            var scores = [];
	                            var totalScore = 0;
	                            var avgScore = 100;
	                            var totalweight = 0;
	                            _lodash2.default.forEach(userData.bites, function (bite) {
	                                var primaryKpi = appHelper.getArrayObjectByKey(bite.kpis, "is_primary", true);
	                                if (appHelper.isDefined(primaryKpi)) {
	                                    var score = dataHelper.getRangePercentage(primaryKpi.min, primaryKpi.max, primaryKpi.current);
	                                    if (isNaN(score)) {
	                                        score = scormConstants.CMI_CORE_SCORE_MAX_DEFAULT;
	                                    }
	
	                                    var weightedScore = score * bite.weight;
	
	                                    scores.push(weightedScore);
	                                    totalScore += weightedScore;
	                                    totalweight += bite.weight;
	                                }
	                            });
	
	                            if (totalweight > 0) {
	                                avgScore = Math.round(totalScore / totalweight);
	                            }
	                            _scormService2.default.setScoreRaw(avgScore); //set cmi.core.score.raw
	                            _scormService2.default.setScoreMin(scormConstants.CMI_CORE_SCORE_MIN_DEFAULT); //cmi.core.score.min
	                            _scormService2.default.setScoreMax(scormConstants.CMI_CORE_SCORE_MAX_DEFAULT); //cmi.core.score.max
	                        } else {
	                            _scormService2.default.setLessionStatus(scormConstants.LESSON_STATUS_INCOMPLETE); //set cmi.core.lesson_status to incomplete
	                        }
	                        _scormService2.default.doLMSCommit();
	
	                        return result;
	                    }).catch(function (error) {
	                        throw error;
	                    });
	
	                    break;
	                case appConstants.TRACKING_TYPE_OPEN_LEARNING:
	                    _openLearningService2.default.setSuspendData(suspend_data).then(function (result) {
	                        if (userData.status == objectConstants.STATUS_COMPLETE) {
	                            _openLearningService2.default.markComplete(userData.bites, localStorage.contentData);
	                        }
	                        return result;
	                    }).catch(function (error) {
	                        throw error;
	                    });
	                    break;
	            }
	
	            //console.log(userData.status);
	            dispatch(setTrackingData(trackingData));
	            return trackingData;
	        }).catch(function (error) {
	            throw error;
	        });
	    };
	}
	
	function setNewLessonLocation(screen_id) {
	
	    return function (dispatch, getState) {
	        var state = getState();
	        var nextScreenId = screen_id;
	        var trackingData = Object.assign({}, state.trackingData);
	        var last_lesson_location = 0;
	        var location_history = Object.assign([], state.trackingData.location_history);
	        var location_history_last_index = location_history.length - 1;
	        //console.log(`${location_history_last_index} > -1 && ${location_history[location_history_last_index]} === ${nextScreenId}`);
	        if (location_history_last_index > -1 && location_history[location_history_last_index] === nextScreenId) {
	            location_history = dataHelper.immutableSplice(location_history, location_history_last_index, 1);
	        } else if (location_history[location_history_last_index] !== trackingData.lesson_location) {
	            location_history = dataHelper.immutablePush(location_history, trackingData.lesson_location);
	        }
	
	        if (location_history.length > 0) {
	            last_lesson_location = location_history[location_history.length - 1];
	        }
	
	        trackingData = Object.assign({}, state.trackingData, {
	            lesson_location: screen_id,
	            location_history: location_history,
	            last_lesson_location: last_lesson_location
	        });
	
	        //console.log(trackingData);
	        if (localStorage.tracking_type === appConstants.TRACKING_TYPE_SCORM || localStorage.tracking_type === appConstants.TRACKING_TYPE_BLENDED_XAPI_SCORM_1_2) {
	            return _scormService2.default.setLessionLocation(screen_id).then(function (result) {
	                _scormService2.default.doLMSCommit();
	                dispatch(setTrackingData(trackingData));
	                return result;
	            }).catch(function (error) {
	                throw error;
	            });
	        } else if (localStorage.tracking_type === appConstants.TRACKING_TYPE_XAPI) {
	            return _xAPIService2.default.setLessionLocation(screen_id, state.trackingData.lrs).then(function (result) {
	                dispatch(setTrackingData(trackingData));
	                return result;
	            }).catch(function (error) {
	                throw error;
	            });
	        } else if (localStorage.tracking_type === appConstants.TRACKING_TYPE_OPEN_LEARNING) {
	            return _openLearningService2.default.setLessionLocation(screen_id).then(function (result) {
	                dispatch(setTrackingData(trackingData));
	                //return result;
	            }).catch(function (error) {
	                throw error;
	            });
	        }
	
	        dispatch(setTrackingData(trackingData));
	    };
	}
	
	function postActvityStatement(screen, interactionData, category, voidCompleteRecords) {
	    return function (dispatch, getState) {
	        var state = getState();
	
	        if (localStorage.tracking_type === appConstants.TRACKING_TYPE_XAPI || localStorage.tracking_type === appConstants.TRACKING_TYPE_BLENDED_XAPI_SCORM_1_2) {
	            return _xAPIService2.default.postActvityStatement(screen, interactionData, category, voidCompleteRecords, state.trackingData.lrs).then(function (result) {
	                return result;
	            }).catch(function (error) {
	                throw error;
	            });
	        }
	    };
	}
	
	function getActvityStatement(interactionData) {
	    return function (dispatch, getState) {
	        var state = getState();
	
	        if (localStorage.tracking_type === appConstants.TRACKING_TYPE_XAPI || localStorage.tracking_type === appConstants.TRACKING_TYPE_BLENDED_XAPI_SCORM_1_2) {
	            return _xAPIService2.default.getActivityStatement(interactionData, state.trackingData.lrs).then(function (result) {
	                return result;
	            }).catch(function (error) {
	                throw error;
	            });
	        }
	    };
	}
	
	function setScreenAccessed(screen, parentScreen) {
	    return function (dispatch, getState) {
	        var state = getState();
	        var userData = state.userData;
	        var bite_id = appHelper.getBiteByScreenId(screen.screen_id);
	        var bite = appHelper.getBiteById(bite_id);
	        var userDataBite = appHelper.getArrayObjectByKey(userData.bites, "bite_id", bite.bite_id);
	        var biteStatus = userDataHelper.getBiteStatus(userDataBite);
	
	        /*if (localStorage.tracking_type === appConstants.TRACKING_TYPE_XAPI || localStorage.tracking_type === appConstants.TRACKING_TYPE_BLENDED_XAPI_SCORM_1_2) {
	            return xAPIService.setScreenAccessed(screen, parentScreen, bite, state.trackingData.lrs).then(result => {
	                 return xAPIService.setBiteProgressStatus(bite,biteStatus, userDataBite, parentScreen, state.trackingData.lrs).then(result => {
	                 }).catch(error => {
	                    throw(error);
	                });
	            }).catch(error => {
	                throw(error);
	            });
	        }*/
	    };
	}
	
	function setScreenComplete(screen, parentScreen) {
	    return function (dispatch, getState) {
	
	        var state = getState();
	        var userData = state.userData;
	        var bite_id = appHelper.getBiteByScreenId(screen.screen_id);
	        var bite = appHelper.getBiteById(bite_id);
	        var userDataBite = appHelper.getArrayObjectByKey(userData.bites, "bite_id", bite.bite_id);
	        var biteStatus = userDataHelper.getBiteStatus(userDataBite);
	
	        if (localStorage.tracking_type === appConstants.TRACKING_TYPE_XAPI || localStorage.tracking_type === appConstants.TRACKING_TYPE_BLENDED_XAPI_SCORM_1_2) {
	            return _xAPIService2.default.setScreenComplete(screen, parentScreen, bite, state.trackingData.lrs).then(function (result) {
	                return _xAPIService2.default.setBiteCompleteStatus(bite, biteStatus, userDataBite, parentScreen, state.trackingData.lrs).then(function (result) {}).catch(function (error) {
	                    throw error;
	                });
	            }).catch(function (error) {
	                throw error;
	            });
	        }
	    };
	}
	
	function setBadgeStatement(badge) {
	    return function (dispatch, getState) {
	        var state = getState();
	        var bite_id = badgeHelper.getBadgeParentBiteId(badge.badge_id);
	        if (localStorage.tracking_type === appConstants.TRACKING_TYPE_XAPI || localStorage.tracking_type === appConstants.TRACKING_TYPE_BLENDED_XAPI_SCORM_1_2) {
	            return _xAPIService2.default.setBadgeStatement(badge, bite_id, state.trackingData.lrs).then(function (result) {
	                return result;
	            }).catch(function (error) {
	                throw error;
	            });
	        }
	    };
	}
	
	function setActorDetails(actor) {
	    return function (dispatch, getState) {
	        var state = getState();
	        if (localStorage.tracking_type === appConstants.TRACKING_TYPE_XAPI) {
	            var trackingData = Object.assign({}, state.trackingData, {
	                actor: actor
	            });
	            dispatch(setTrackingData(trackingData));
	        }
	    };
	}

/***/ },
/* 8 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(global) {/*!
	 * VERSION: 1.20.5
	 * DATE: 2018-05-21
	 * UPDATES AND DOCS AT: http://greensock.com
	 * 
	 * Includes all of the following: TweenLite, TweenMax, TimelineLite, TimelineMax, EasePack, CSSPlugin, RoundPropsPlugin, BezierPlugin, AttrPlugin, DirectionalRotationPlugin
	 *
	 * @license Copyright (c) 2008-2018, GreenSock. All rights reserved.
	 * This work is subject to the terms at http://greensock.com/standard-license or for
	 * Club GreenSock members, the software agreement that was issued with your membership.
	 * 
	 * @author: Jack Doyle, jack@greensock.com
	 **/
	var _gsScope = (typeof(module) !== "undefined" && module.exports && typeof(global) !== "undefined") ? global : this || window; //helps ensure compatibility with AMD/RequireJS and CommonJS/Node
	(_gsScope._gsQueue || (_gsScope._gsQueue = [])).push( function() {
	
		"use strict";
	
		_gsScope._gsDefine("TweenMax", ["core.Animation","core.SimpleTimeline","TweenLite"], function(Animation, SimpleTimeline, TweenLite) {
	
			var _slice = function(a) { //don't use [].slice because that doesn't work in IE8 with a NodeList that's returned by querySelectorAll()
					var b = [],
						l = a.length,
						i;
					for (i = 0; i !== l; b.push(a[i++]));
					return b;
				},
				_applyCycle = function(vars, targets, i) {
					var alt = vars.cycle,
						p, val;
					for (p in alt) {
						val = alt[p];
						vars[p] = (typeof(val) === "function") ? val(i, targets[i]) : val[i % val.length];
					}
					delete vars.cycle;
				},
				TweenMax = function(target, duration, vars) {
					TweenLite.call(this, target, duration, vars);
					this._cycle = 0;
					this._yoyo = (this.vars.yoyo === true || !!this.vars.yoyoEase);
					this._repeat = this.vars.repeat || 0;
					this._repeatDelay = this.vars.repeatDelay || 0;
					if (this._repeat) {
						this._uncache(true); //ensures that if there is any repeat, the totalDuration will get recalculated to accurately report it.
					}
					this.render = TweenMax.prototype.render; //speed optimization (avoid prototype lookup on this "hot" method)
				},
				_tinyNum = 0.0000000001,
				TweenLiteInternals = TweenLite._internals,
				_isSelector = TweenLiteInternals.isSelector,
				_isArray = TweenLiteInternals.isArray,
				p = TweenMax.prototype = TweenLite.to({}, 0.1, {}),
				_blankArray = [];
	
			TweenMax.version = "1.20.5";
			p.constructor = TweenMax;
			p.kill()._gc = false;
			TweenMax.killTweensOf = TweenMax.killDelayedCallsTo = TweenLite.killTweensOf;
			TweenMax.getTweensOf = TweenLite.getTweensOf;
			TweenMax.lagSmoothing = TweenLite.lagSmoothing;
			TweenMax.ticker = TweenLite.ticker;
			TweenMax.render = TweenLite.render;
	
			p.invalidate = function() {
				this._yoyo = (this.vars.yoyo === true || !!this.vars.yoyoEase);
				this._repeat = this.vars.repeat || 0;
				this._repeatDelay = this.vars.repeatDelay || 0;
				this._yoyoEase = null;
				this._uncache(true);
				return TweenLite.prototype.invalidate.call(this);
			};
			
			p.updateTo = function(vars, resetDuration) {
				var curRatio = this.ratio,
					immediate = this.vars.immediateRender || vars.immediateRender,
					p;
				if (resetDuration && this._startTime < this._timeline._time) {
					this._startTime = this._timeline._time;
					this._uncache(false);
					if (this._gc) {
						this._enabled(true, false);
					} else {
						this._timeline.insert(this, this._startTime - this._delay); //ensures that any necessary re-sequencing of Animations in the timeline occurs to make sure the rendering order is correct.
					}
				}
				for (p in vars) {
					this.vars[p] = vars[p];
				}
				if (this._initted || immediate) {
					if (resetDuration) {
						this._initted = false;
						if (immediate) {
							this.render(0, true, true);
						}
					} else {
						if (this._gc) {
							this._enabled(true, false);
						}
						if (this._notifyPluginsOfEnabled && this._firstPT) {
							TweenLite._onPluginEvent("_onDisable", this); //in case a plugin like MotionBlur must perform some cleanup tasks
						}
						if (this._time / this._duration > 0.998) { //if the tween has finished (or come extremely close to finishing), we just need to rewind it to 0 and then render it again at the end which forces it to re-initialize (parsing the new vars). We allow tweens that are close to finishing (but haven't quite finished) to work this way too because otherwise, the values are so small when determining where to project the starting values that binary math issues creep in and can make the tween appear to render incorrectly when run backwards. 
							var prevTime = this._totalTime;
							this.render(0, true, false);
							this._initted = false;
							this.render(prevTime, true, false);
						} else {
							this._initted = false;
							this._init();
							if (this._time > 0 || immediate) {
								var inv = 1 / (1 - curRatio),
									pt = this._firstPT, endValue;
								while (pt) {
									endValue = pt.s + pt.c;
									pt.c *= inv;
									pt.s = endValue - pt.c;
									pt = pt._next;
								}
							}
						}
					}
				}
				return this;
			};
					
			p.render = function(time, suppressEvents, force) {
				if (!this._initted) if (this._duration === 0 && this.vars.repeat) { //zero duration tweens that render immediately have render() called from TweenLite's constructor, before TweenMax's constructor has finished setting _repeat, _repeatDelay, and _yoyo which are critical in determining totalDuration() so we need to call invalidate() which is a low-kb way to get those set properly.
					this.invalidate();
				}
				var totalDur = (!this._dirty) ? this._totalDuration : this.totalDuration(),
					prevTime = this._time,
					prevTotalTime = this._totalTime, 
					prevCycle = this._cycle,
					duration = this._duration,
					prevRawPrevTime = this._rawPrevTime,
					isComplete, callback, pt, cycleDuration, r, type, pow, rawPrevTime, yoyoEase;
				if (time >= totalDur - 0.0000001 && time >= 0) { //to work around occasional floating point math artifacts.
					this._totalTime = totalDur;
					this._cycle = this._repeat;
					if (this._yoyo && (this._cycle & 1) !== 0) {
						this._time = 0;
						this.ratio = this._ease._calcEnd ? this._ease.getRatio(0) : 0;
					} else {
						this._time = duration;
						this.ratio = this._ease._calcEnd ? this._ease.getRatio(1) : 1;
					}
					if (!this._reversed) {
						isComplete = true;
						callback = "onComplete";
						force = (force || this._timeline.autoRemoveChildren); //otherwise, if the animation is unpaused/activated after it's already finished, it doesn't get removed from the parent timeline.
					}
					if (duration === 0) if (this._initted || !this.vars.lazy || force) { //zero-duration tweens are tricky because we must discern the momentum/direction of time in order to determine whether the starting values should be rendered or the ending values. If the "playhead" of its timeline goes past the zero-duration tween in the forward direction or lands directly on it, the end values should be rendered, but if the timeline's "playhead" moves past it in the backward direction (from a postitive time to a negative time), the starting values must be rendered.
						if (this._startTime === this._timeline._duration) { //if a zero-duration tween is at the VERY end of a timeline and that timeline renders at its end, it will typically add a tiny bit of cushion to the render time to prevent rounding errors from getting in the way of tweens rendering their VERY end. If we then reverse() that timeline, the zero-duration tween will trigger its onReverseComplete even though technically the playhead didn't pass over it again. It's a very specific edge case we must accommodate.
							time = 0;
						}
						if (prevRawPrevTime < 0 || (time <= 0 && time >= -0.0000001) || (prevRawPrevTime === _tinyNum && this.data !== "isPause")) if (prevRawPrevTime !== time) { //note: when this.data is "isPause", it's a callback added by addPause() on a timeline that we should not be triggered when LEAVING its exact start time. In other words, tl.addPause(1).play(1) shouldn't pause.
							force = true;
							if (prevRawPrevTime > _tinyNum) {
								callback = "onReverseComplete";
							}
						}
						this._rawPrevTime = rawPrevTime = (!suppressEvents || time || prevRawPrevTime === time) ? time : _tinyNum; //when the playhead arrives at EXACTLY time 0 (right on top) of a zero-duration tween, we need to discern if events are suppressed so that when the playhead moves again (next time), it'll trigger the callback. If events are NOT suppressed, obviously the callback would be triggered in this render. Basically, the callback should fire either when the playhead ARRIVES or LEAVES this exact spot, not both. Imagine doing a timeline.seek(0) and there's a callback that sits at 0. Since events are suppressed on that seek() by default, nothing will fire, but when the playhead moves off of that position, the callback should fire. This behavior is what people intuitively expect. We set the _rawPrevTime to be a precise tiny number to indicate this scenario rather than using another property/variable which would increase memory usage. This technique is less readable, but more efficient.
					}
					
				} else if (time < 0.0000001) { //to work around occasional floating point math artifacts, round super small values to 0.
					this._totalTime = this._time = this._cycle = 0;
					this.ratio = this._ease._calcEnd ? this._ease.getRatio(0) : 0;
					if (prevTotalTime !== 0 || (duration === 0 && prevRawPrevTime > 0)) {
						callback = "onReverseComplete";
						isComplete = this._reversed;
					}
					if (time < 0) {
						this._active = false;
						if (duration === 0) if (this._initted || !this.vars.lazy || force) { //zero-duration tweens are tricky because we must discern the momentum/direction of time in order to determine whether the starting values should be rendered or the ending values. If the "playhead" of its timeline goes past the zero-duration tween in the forward direction or lands directly on it, the end values should be rendered, but if the timeline's "playhead" moves past it in the backward direction (from a postitive time to a negative time), the starting values must be rendered.
							if (prevRawPrevTime >= 0) {
								force = true;
							}
							this._rawPrevTime = rawPrevTime = (!suppressEvents || time || prevRawPrevTime === time) ? time : _tinyNum; //when the playhead arrives at EXACTLY time 0 (right on top) of a zero-duration tween, we need to discern if events are suppressed so that when the playhead moves again (next time), it'll trigger the callback. If events are NOT suppressed, obviously the callback would be triggered in this render. Basically, the callback should fire either when the playhead ARRIVES or LEAVES this exact spot, not both. Imagine doing a timeline.seek(0) and there's a callback that sits at 0. Since events are suppressed on that seek() by default, nothing will fire, but when the playhead moves off of that position, the callback should fire. This behavior is what people intuitively expect. We set the _rawPrevTime to be a precise tiny number to indicate this scenario rather than using another property/variable which would increase memory usage. This technique is less readable, but more efficient.
						}
					}
					if (!this._initted) { //if we render the very beginning (time == 0) of a fromTo(), we must force the render (normal tweens wouldn't need to render at a time of 0 when the prevTime was also 0). This is also mandatory to make sure overwriting kicks in immediately.
						force = true;
					}
				} else {
					this._totalTime = this._time = time;
					if (this._repeat !== 0) {
						cycleDuration = duration + this._repeatDelay;
						this._cycle = (this._totalTime / cycleDuration) >> 0; //originally _totalTime % cycleDuration but floating point errors caused problems, so I normalized it. (4 % 0.8 should be 0 but some browsers report it as 0.79999999!)
						if (this._cycle !== 0) if (this._cycle === this._totalTime / cycleDuration && prevTotalTime <= time) {
							this._cycle--; //otherwise when rendered exactly at the end time, it will act as though it is repeating (at the beginning)
						}
						this._time = this._totalTime - (this._cycle * cycleDuration);
						if (this._yoyo) if ((this._cycle & 1) !== 0) {
							this._time = duration - this._time;
							yoyoEase = this._yoyoEase || this.vars.yoyoEase; //note: we don't set this._yoyoEase in _init() like we do other properties because it's TweenMax-specific and doing it here allows us to optimize performance (most tweens don't have a yoyoEase). Note that we also must skip the this.ratio calculation further down right after we _init() in this function, because we're doing it here.
							if (yoyoEase) {
								if (!this._yoyoEase) {
									if (yoyoEase === true && !this._initted) { //if it's not initted and yoyoEase is true, this._ease won't have been populated yet so we must discern it here.
										yoyoEase = this.vars.ease;
										this._yoyoEase = yoyoEase = !yoyoEase ? TweenLite.defaultEase : (yoyoEase instanceof Ease) ? yoyoEase : (typeof(yoyoEase) === "function") ? new Ease(yoyoEase, this.vars.easeParams) : Ease.map[yoyoEase] || TweenLite.defaultEase;
									} else {
										this._yoyoEase = yoyoEase = (yoyoEase === true) ? this._ease : (yoyoEase instanceof Ease) ? yoyoEase : Ease.map[yoyoEase];
									}
								}
								this.ratio = yoyoEase ? 1 - yoyoEase.getRatio((duration - this._time) / duration) : 0;
							}
						}
						if (this._time > duration) {
							this._time = duration;
						} else if (this._time < 0) {
							this._time = 0;
						}
					}
					if (this._easeType && !yoyoEase) {
						r = this._time / duration;
						type = this._easeType;
						pow = this._easePower;
						if (type === 1 || (type === 3 && r >= 0.5)) {
							r = 1 - r;
						}
						if (type === 3) {
							r *= 2;
						}
						if (pow === 1) {
							r *= r;
						} else if (pow === 2) {
							r *= r * r;
						} else if (pow === 3) {
							r *= r * r * r;
						} else if (pow === 4) {
							r *= r * r * r * r;
						}
	
						if (type === 1) {
							this.ratio = 1 - r;
						} else if (type === 2) {
							this.ratio = r;
						} else if (this._time / duration < 0.5) {
							this.ratio = r / 2;
						} else {
							this.ratio = 1 - (r / 2);
						}
	
					} else if (!yoyoEase) {
						this.ratio = this._ease.getRatio(this._time / duration);
					}
					
				}
					
				if (prevTime === this._time && !force && prevCycle === this._cycle) {
					if (prevTotalTime !== this._totalTime) if (this._onUpdate) if (!suppressEvents) { //so that onUpdate fires even during the repeatDelay - as long as the totalTime changed, we should trigger onUpdate.
						this._callback("onUpdate");
					}
					return;
				} else if (!this._initted) {
					this._init();
					if (!this._initted || this._gc) { //immediateRender tweens typically won't initialize until the playhead advances (_time is greater than 0) in order to ensure that overwriting occurs properly. Also, if all of the tweening properties have been overwritten (which would cause _gc to be true, as set in _init()), we shouldn't continue otherwise an onStart callback could be called for example.
						return;
					} else if (!force && this._firstPT && ((this.vars.lazy !== false && this._duration) || (this.vars.lazy && !this._duration))) { //we stick it in the queue for rendering at the very end of the tick - this is a performance optimization because browsers invalidate styles and force a recalculation if you read, write, and then read style data (so it's better to read/read/read/write/write/write than read/write/read/write/read/write). The down side, of course, is that usually you WANT things to render immediately because you may have code running right after that which depends on the change. Like imagine running TweenLite.set(...) and then immediately after that, creating a nother tween that animates the same property to another value; the starting values of that 2nd tween wouldn't be accurate if lazy is true.
						this._time = prevTime;
						this._totalTime = prevTotalTime;
						this._rawPrevTime = prevRawPrevTime;
						this._cycle = prevCycle;
						TweenLiteInternals.lazyTweens.push(this);
						this._lazy = [time, suppressEvents];
						return;
					}
					//_ease is initially set to defaultEase, so now that init() has run, _ease is set properly and we need to recalculate the ratio. Overall this is faster than using conditional logic earlier in the method to avoid having to set ratio twice because we only init() once but renderTime() gets called VERY frequently.
					if (this._time && !isComplete && !yoyoEase) {
						this.ratio = this._ease.getRatio(this._time / duration);
					} else if (isComplete && this._ease._calcEnd && !yoyoEase) {
						this.ratio = this._ease.getRatio((this._time === 0) ? 0 : 1);
					}
				}
				if (this._lazy !== false) {
					this._lazy = false;
				}
	
				if (!this._active) if (!this._paused && this._time !== prevTime && time >= 0) {
					this._active = true; //so that if the user renders a tween (as opposed to the timeline rendering it), the timeline is forced to re-render and align it with the proper time/frame on the next rendering cycle. Maybe the tween already finished but the user manually re-renders it as halfway done.
				}
				if (prevTotalTime === 0) {
					if (this._initted === 2 && time > 0) {
						//this.invalidate();
						this._init(); //will just apply overwriting since _initted of (2) means it was a from() tween that had immediateRender:true
					}
					if (this._startAt) {
						if (time >= 0) {
							this._startAt.render(time, true, force);
						} else if (!callback) {
							callback = "_dummyGS"; //if no callback is defined, use a dummy value just so that the condition at the end evaluates as true because _startAt should render AFTER the normal render loop when the time is negative. We could handle this in a more intuitive way, of course, but the render loop is the MOST important thing to optimize, so this technique allows us to avoid adding extra conditional logic in a high-frequency area.
						}
					}
					if (this.vars.onStart) if (this._totalTime !== 0 || duration === 0) if (!suppressEvents) {
						this._callback("onStart");
					}
				}
				
				pt = this._firstPT;
				while (pt) {
					if (pt.f) {
						pt.t[pt.p](pt.c * this.ratio + pt.s);
					} else {
						pt.t[pt.p] = pt.c * this.ratio + pt.s;
					}
					pt = pt._next;
				}
				
				if (this._onUpdate) {
					if (time < 0) if (this._startAt && this._startTime) { //if the tween is positioned at the VERY beginning (_startTime 0) of its parent timeline, it's illegal for the playhead to go back further, so we should not render the recorded startAt values.
						this._startAt.render(time, true, force); //note: for performance reasons, we tuck this conditional logic inside less traveled areas (most tweens don't have an onUpdate). We'd just have it at the end before the onComplete, but the values should be updated before any onUpdate is called, so we ALSO put it here and then if it's not called, we do so later near the onComplete.
					}
					if (!suppressEvents) if (this._totalTime !== prevTotalTime || callback) {
						this._callback("onUpdate");
					}
				}
				if (this._cycle !== prevCycle) if (!suppressEvents) if (!this._gc) if (this.vars.onRepeat) {
					this._callback("onRepeat");
				}
				if (callback) if (!this._gc || force) { //check gc because there's a chance that kill() could be called in an onUpdate
					if (time < 0 && this._startAt && !this._onUpdate && this._startTime) { //if the tween is positioned at the VERY beginning (_startTime 0) of its parent timeline, it's illegal for the playhead to go back further, so we should not render the recorded startAt values.
						this._startAt.render(time, true, force);
					}
					if (isComplete) {
						if (this._timeline.autoRemoveChildren) {
							this._enabled(false, false);
						}
						this._active = false;
					}
					if (!suppressEvents && this.vars[callback]) {
						this._callback(callback);
					}
					if (duration === 0 && this._rawPrevTime === _tinyNum && rawPrevTime !== _tinyNum) { //the onComplete or onReverseComplete could trigger movement of the playhead and for zero-duration tweens (which must discern direction) that land directly back on their start time, we don't want to fire again on the next render. Think of several addPause()'s in a timeline that forces the playhead to a certain spot, but what if it's already paused and another tween is tweening the "time" of the timeline? Each time it moves [forward] past that spot, it would move back, and since suppressEvents is true, it'd reset _rawPrevTime to _tinyNum so that when it begins again, the callback would fire (so ultimately it could bounce back and forth during that tween). Again, this is a very uncommon scenario, but possible nonetheless.
						this._rawPrevTime = 0;
					}
				}
			};
			
	//---- STATIC FUNCTIONS -----------------------------------------------------------------------------------------------------------
			
			TweenMax.to = function(target, duration, vars) {
				return new TweenMax(target, duration, vars);
			};
			
			TweenMax.from = function(target, duration, vars) {
				vars.runBackwards = true;
				vars.immediateRender = (vars.immediateRender != false);
				return new TweenMax(target, duration, vars);
			};
			
			TweenMax.fromTo = function(target, duration, fromVars, toVars) {
				toVars.startAt = fromVars;
				toVars.immediateRender = (toVars.immediateRender != false && fromVars.immediateRender != false);
				return new TweenMax(target, duration, toVars);
			};
			
			TweenMax.staggerTo = TweenMax.allTo = function(targets, duration, vars, stagger, onCompleteAll, onCompleteAllParams, onCompleteAllScope) {
				stagger = stagger || 0;
				var delay = 0,
					a = [],
					finalComplete = function() {
						if (vars.onComplete) {
							vars.onComplete.apply(vars.onCompleteScope || this, arguments);
						}
						onCompleteAll.apply(onCompleteAllScope || vars.callbackScope || this, onCompleteAllParams || _blankArray);
					},
					cycle = vars.cycle,
					fromCycle = (vars.startAt && vars.startAt.cycle),
					l, copy, i, p;
				if (!_isArray(targets)) {
					if (typeof(targets) === "string") {
						targets = TweenLite.selector(targets) || targets;
					}
					if (_isSelector(targets)) {
						targets = _slice(targets);
					}
				}
				targets = targets || [];
				if (stagger < 0) {
					targets = _slice(targets);
					targets.reverse();
					stagger *= -1;
				}
				l = targets.length - 1;
				for (i = 0; i <= l; i++) {
					copy = {};
					for (p in vars) {
						copy[p] = vars[p];
					}
					if (cycle) {
						_applyCycle(copy, targets, i);
						if (copy.duration != null) {
							duration = copy.duration;
							delete copy.duration;
						}
					}
					if (fromCycle) {
						fromCycle = copy.startAt = {};
						for (p in vars.startAt) {
							fromCycle[p] = vars.startAt[p];
						}
						_applyCycle(copy.startAt, targets, i);
					}
					copy.delay = delay + (copy.delay || 0);
					if (i === l && onCompleteAll) {
						copy.onComplete = finalComplete;
					}
					a[i] = new TweenMax(targets[i], duration, copy);
					delay += stagger;
				}
				return a;
			};
			
			TweenMax.staggerFrom = TweenMax.allFrom = function(targets, duration, vars, stagger, onCompleteAll, onCompleteAllParams, onCompleteAllScope) {
				vars.runBackwards = true;
				vars.immediateRender = (vars.immediateRender != false);
				return TweenMax.staggerTo(targets, duration, vars, stagger, onCompleteAll, onCompleteAllParams, onCompleteAllScope);
			};
			
			TweenMax.staggerFromTo = TweenMax.allFromTo = function(targets, duration, fromVars, toVars, stagger, onCompleteAll, onCompleteAllParams, onCompleteAllScope) {
				toVars.startAt = fromVars;
				toVars.immediateRender = (toVars.immediateRender != false && fromVars.immediateRender != false);
				return TweenMax.staggerTo(targets, duration, toVars, stagger, onCompleteAll, onCompleteAllParams, onCompleteAllScope);
			};
					
			TweenMax.delayedCall = function(delay, callback, params, scope, useFrames) {
				return new TweenMax(callback, 0, {delay:delay, onComplete:callback, onCompleteParams:params, callbackScope:scope, onReverseComplete:callback, onReverseCompleteParams:params, immediateRender:false, useFrames:useFrames, overwrite:0});
			};
			
			TweenMax.set = function(target, vars) {
				return new TweenMax(target, 0, vars);
			};
			
			TweenMax.isTweening = function(target) {
				return (TweenLite.getTweensOf(target, true).length > 0);
			};
			
			var _getChildrenOf = function(timeline, includeTimelines) {
					var a = [],
						cnt = 0,
						tween = timeline._first;
					while (tween) {
						if (tween instanceof TweenLite) {
							a[cnt++] = tween;
						} else {
							if (includeTimelines) {
								a[cnt++] = tween;
							}
							a = a.concat(_getChildrenOf(tween, includeTimelines));
							cnt = a.length;
						}
						tween = tween._next;
					}
					return a;
				}, 
				getAllTweens = TweenMax.getAllTweens = function(includeTimelines) {
					return _getChildrenOf(Animation._rootTimeline, includeTimelines).concat( _getChildrenOf(Animation._rootFramesTimeline, includeTimelines) );
				};
			
			TweenMax.killAll = function(complete, tweens, delayedCalls, timelines) {
				if (tweens == null) {
					tweens = true;
				}
				if (delayedCalls == null) {
					delayedCalls = true;
				}
				var a = getAllTweens((timelines != false)),
					l = a.length,
					allTrue = (tweens && delayedCalls && timelines),
					isDC, tween, i;
				for (i = 0; i < l; i++) {
					tween = a[i];
					if (allTrue || (tween instanceof SimpleTimeline) || ((isDC = (tween.target === tween.vars.onComplete)) && delayedCalls) || (tweens && !isDC)) {
						if (complete) {
							tween.totalTime(tween._reversed ? 0 : tween.totalDuration());
						} else {
							tween._enabled(false, false);
						}
					}
				}
			};
			
			TweenMax.killChildTweensOf = function(parent, complete) {
				if (parent == null) {
					return;
				}
				var tl = TweenLiteInternals.tweenLookup,
					a, curParent, p, i, l;
				if (typeof(parent) === "string") {
					parent = TweenLite.selector(parent) || parent;
				}
				if (_isSelector(parent)) {
					parent = _slice(parent);
				}
				if (_isArray(parent)) {
					i = parent.length;
					while (--i > -1) {
						TweenMax.killChildTweensOf(parent[i], complete);
					}
					return;
				}
				a = [];
				for (p in tl) {
					curParent = tl[p].target.parentNode;
					while (curParent) {
						if (curParent === parent) {
							a = a.concat(tl[p].tweens);
						}
						curParent = curParent.parentNode;
					}
				}
				l = a.length;
				for (i = 0; i < l; i++) {
					if (complete) {
						a[i].totalTime(a[i].totalDuration());
					}
					a[i]._enabled(false, false);
				}
			};
	
			var _changePause = function(pause, tweens, delayedCalls, timelines) {
				tweens = (tweens !== false);
				delayedCalls = (delayedCalls !== false);
				timelines = (timelines !== false);
				var a = getAllTweens(timelines),
					allTrue = (tweens && delayedCalls && timelines),
					i = a.length,
					isDC, tween;
				while (--i > -1) {
					tween = a[i];
					if (allTrue || (tween instanceof SimpleTimeline) || ((isDC = (tween.target === tween.vars.onComplete)) && delayedCalls) || (tweens && !isDC)) {
						tween.paused(pause);
					}
				}
			};
			
			TweenMax.pauseAll = function(tweens, delayedCalls, timelines) {
				_changePause(true, tweens, delayedCalls, timelines);
			};
			
			TweenMax.resumeAll = function(tweens, delayedCalls, timelines) {
				_changePause(false, tweens, delayedCalls, timelines);
			};
	
			TweenMax.globalTimeScale = function(value) {
				var tl = Animation._rootTimeline,
					t = TweenLite.ticker.time;
				if (!arguments.length) {
					return tl._timeScale;
				}
				value = value || _tinyNum; //can't allow zero because it'll throw the math off
				tl._startTime = t - ((t - tl._startTime) * tl._timeScale / value);
				tl = Animation._rootFramesTimeline;
				t = TweenLite.ticker.frame;
				tl._startTime = t - ((t - tl._startTime) * tl._timeScale / value);
				tl._timeScale = Animation._rootTimeline._timeScale = value;
				return value;
			};
			
		
	//---- GETTERS / SETTERS ----------------------------------------------------------------------------------------------------------
			
			p.progress = function(value, suppressEvents) {
				return (!arguments.length) ? this._time / this.duration() : this.totalTime( this.duration() * ((this._yoyo && (this._cycle & 1) !== 0) ? 1 - value : value) + (this._cycle * (this._duration + this._repeatDelay)), suppressEvents);
			};
			
			p.totalProgress = function(value, suppressEvents) {
				return (!arguments.length) ? this._totalTime / this.totalDuration() : this.totalTime( this.totalDuration() * value, suppressEvents);
			};
			
			p.time = function(value, suppressEvents) {
				if (!arguments.length) {
					return this._time;
				}
				if (this._dirty) {
					this.totalDuration();
				}
				if (value > this._duration) {
					value = this._duration;
				}
				if (this._yoyo && (this._cycle & 1) !== 0) {
					value = (this._duration - value) + (this._cycle * (this._duration + this._repeatDelay));
				} else if (this._repeat !== 0) {
					value += this._cycle * (this._duration + this._repeatDelay);
				}
				return this.totalTime(value, suppressEvents);
			};
	
			p.duration = function(value) {
				if (!arguments.length) {
					return this._duration; //don't set _dirty = false because there could be repeats that haven't been factored into the _totalDuration yet. Otherwise, if you create a repeated TweenMax and then immediately check its duration(), it would cache the value and the totalDuration would not be correct, thus repeats wouldn't take effect.
				}
				return Animation.prototype.duration.call(this, value);
			};
	
			p.totalDuration = function(value) {
				if (!arguments.length) {
					if (this._dirty) {
						//instead of Infinity, we use 999999999999 so that we can accommodate reverses
						this._totalDuration = (this._repeat === -1) ? 999999999999 : this._duration * (this._repeat + 1) + (this._repeatDelay * this._repeat);
						this._dirty = false;
					}
					return this._totalDuration;
				}
				return (this._repeat === -1) ? this : this.duration( (value - (this._repeat * this._repeatDelay)) / (this._repeat + 1) );
			};
			
			p.repeat = function(value) {
				if (!arguments.length) {
					return this._repeat;
				}
				this._repeat = value;
				return this._uncache(true);
			};
			
			p.repeatDelay = function(value) {
				if (!arguments.length) {
					return this._repeatDelay;
				}
				this._repeatDelay = value;
				return this._uncache(true);
			};
			
			p.yoyo = function(value) {
				if (!arguments.length) {
					return this._yoyo;
				}
				this._yoyo = value;
				return this;
			};
			
			
			return TweenMax;
			
		}, true);
	
	
	
	
	
	
	
	
	/*
	 * ----------------------------------------------------------------
	 * TimelineLite
	 * ----------------------------------------------------------------
	 */
		_gsScope._gsDefine("TimelineLite", ["core.Animation","core.SimpleTimeline","TweenLite"], function(Animation, SimpleTimeline, TweenLite) {
	
			var TimelineLite = function(vars) {
					SimpleTimeline.call(this, vars);
					this._labels = {};
					this.autoRemoveChildren = (this.vars.autoRemoveChildren === true);
					this.smoothChildTiming = (this.vars.smoothChildTiming === true);
					this._sortChildren = true;
					this._onUpdate = this.vars.onUpdate;
					var v = this.vars,
						val, p;
					for (p in v) {
						val = v[p];
						if (_isArray(val)) if (val.join("").indexOf("{self}") !== -1) {
							v[p] = this._swapSelfInParams(val);
						}
					}
					if (_isArray(v.tweens)) {
						this.add(v.tweens, 0, v.align, v.stagger);
					}
				},
				_tinyNum = 0.0000000001,
				TweenLiteInternals = TweenLite._internals,
				_internals = TimelineLite._internals = {},
				_isSelector = TweenLiteInternals.isSelector,
				_isArray = TweenLiteInternals.isArray,
				_lazyTweens = TweenLiteInternals.lazyTweens,
				_lazyRender = TweenLiteInternals.lazyRender,
				_globals = _gsScope._gsDefine.globals,
				_copy = function(vars) {
					var copy = {}, p;
					for (p in vars) {
						copy[p] = vars[p];
					}
					return copy;
				},
				_applyCycle = function(vars, targets, i) {
					var alt = vars.cycle,
						p, val;
					for (p in alt) {
						val = alt[p];
						vars[p] = (typeof(val) === "function") ? val(i, targets[i]) : val[i % val.length];
					}
					delete vars.cycle;
				},
				_pauseCallback = _internals.pauseCallback = function() {},
				_slice = function(a) { //don't use [].slice because that doesn't work in IE8 with a NodeList that's returned by querySelectorAll()
					var b = [],
						l = a.length,
						i;
					for (i = 0; i !== l; b.push(a[i++]));
					return b;
				},
				p = TimelineLite.prototype = new SimpleTimeline();
	
			TimelineLite.version = "1.20.4";
			p.constructor = TimelineLite;
			p.kill()._gc = p._forcingPlayhead = p._hasPause = false;
	
			/* might use later...
			//translates a local time inside an animation to the corresponding time on the root/global timeline, factoring in all nesting and timeScales.
			function localToGlobal(time, animation) {
				while (animation) {
					time = (time / animation._timeScale) + animation._startTime;
					animation = animation.timeline;
				}
				return time;
			}
	
			//translates the supplied time on the root/global timeline into the corresponding local time inside a particular animation, factoring in all nesting and timeScales
			function globalToLocal(time, animation) {
				var scale = 1;
				time -= localToGlobal(0, animation);
				while (animation) {
					scale *= animation._timeScale;
					animation = animation.timeline;
				}
				return time * scale;
			}
			*/
	
			p.to = function(target, duration, vars, position) {
				var Engine = (vars.repeat && _globals.TweenMax) || TweenLite;
				return duration ? this.add( new Engine(target, duration, vars), position) : this.set(target, vars, position);
			};
	
			p.from = function(target, duration, vars, position) {
				return this.add( ((vars.repeat && _globals.TweenMax) || TweenLite).from(target, duration, vars), position);
			};
	
			p.fromTo = function(target, duration, fromVars, toVars, position) {
				var Engine = (toVars.repeat && _globals.TweenMax) || TweenLite;
				return duration ? this.add( Engine.fromTo(target, duration, fromVars, toVars), position) : this.set(target, toVars, position);
			};
	
			p.staggerTo = function(targets, duration, vars, stagger, position, onCompleteAll, onCompleteAllParams, onCompleteAllScope) {
				var tl = new TimelineLite({onComplete:onCompleteAll, onCompleteParams:onCompleteAllParams, callbackScope:onCompleteAllScope, smoothChildTiming:this.smoothChildTiming}),
					cycle = vars.cycle,
					copy, i;
				if (typeof(targets) === "string") {
					targets = TweenLite.selector(targets) || targets;
				}
				targets = targets || [];
				if (_isSelector(targets)) { //senses if the targets object is a selector. If it is, we should translate it into an array.
					targets = _slice(targets);
				}
				stagger = stagger || 0;
				if (stagger < 0) {
					targets = _slice(targets);
					targets.reverse();
					stagger *= -1;
				}
				for (i = 0; i < targets.length; i++) {
					copy = _copy(vars);
					if (copy.startAt) {
						copy.startAt = _copy(copy.startAt);
						if (copy.startAt.cycle) {
							_applyCycle(copy.startAt, targets, i);
						}
					}
					if (cycle) {
						_applyCycle(copy, targets, i);
						if (copy.duration != null) {
							duration = copy.duration;
							delete copy.duration;
						}
					}
					tl.to(targets[i], duration, copy, i * stagger);
				}
				return this.add(tl, position);
			};
	
			p.staggerFrom = function(targets, duration, vars, stagger, position, onCompleteAll, onCompleteAllParams, onCompleteAllScope) {
				vars.immediateRender = (vars.immediateRender != false);
				vars.runBackwards = true;
				return this.staggerTo(targets, duration, vars, stagger, position, onCompleteAll, onCompleteAllParams, onCompleteAllScope);
			};
	
			p.staggerFromTo = function(targets, duration, fromVars, toVars, stagger, position, onCompleteAll, onCompleteAllParams, onCompleteAllScope) {
				toVars.startAt = fromVars;
				toVars.immediateRender = (toVars.immediateRender != false && fromVars.immediateRender != false);
				return this.staggerTo(targets, duration, toVars, stagger, position, onCompleteAll, onCompleteAllParams, onCompleteAllScope);
			};
	
			p.call = function(callback, params, scope, position) {
				return this.add( TweenLite.delayedCall(0, callback, params, scope), position);
			};
	
			p.set = function(target, vars, position) {
				position = this._parseTimeOrLabel(position, 0, true);
				if (vars.immediateRender == null) {
					vars.immediateRender = (position === this._time && !this._paused);
				}
				return this.add( new TweenLite(target, 0, vars), position);
			};
	
			TimelineLite.exportRoot = function(vars, ignoreDelayedCalls) {
				vars = vars || {};
				if (vars.smoothChildTiming == null) {
					vars.smoothChildTiming = true;
				}
				var tl = new TimelineLite(vars),
					root = tl._timeline,
					hasNegativeStart, time,	tween, next;
				if (ignoreDelayedCalls == null) {
					ignoreDelayedCalls = true;
				}
				root._remove(tl, true);
				tl._startTime = 0;
				tl._rawPrevTime = tl._time = tl._totalTime = root._time;
				tween = root._first;
				while (tween) {
					next = tween._next;
					if (!ignoreDelayedCalls || !(tween instanceof TweenLite && tween.target === tween.vars.onComplete)) {
						time = tween._startTime - tween._delay;
						if (time < 0) {
							hasNegativeStart = 1;
						}
						tl.add(tween, time);
					}
					tween = next;
				}
				root.add(tl, 0);
				if (hasNegativeStart) { //calling totalDuration() will force the adjustment necessary to shift the children forward so none of them start before zero, and moves the timeline backwards the same amount, so the playhead is still aligned where it should be globally, but the timeline doesn't have illegal children that start before zero.
					tl.totalDuration();
				}
				return tl;
			};
	
			p.add = function(value, position, align, stagger) {
				var curTime, l, i, child, tl, beforeRawTime;
				if (typeof(position) !== "number") {
					position = this._parseTimeOrLabel(position, 0, true, value);
				}
				if (!(value instanceof Animation)) {
					if ((value instanceof Array) || (value && value.push && _isArray(value))) {
						align = align || "normal";
						stagger = stagger || 0;
						curTime = position;
						l = value.length;
						for (i = 0; i < l; i++) {
							if (_isArray(child = value[i])) {
								child = new TimelineLite({tweens:child});
							}
							this.add(child, curTime);
							if (typeof(child) !== "string" && typeof(child) !== "function") {
								if (align === "sequence") {
									curTime = child._startTime + (child.totalDuration() / child._timeScale);
								} else if (align === "start") {
									child._startTime -= child.delay();
								}
							}
							curTime += stagger;
						}
						return this._uncache(true);
					} else if (typeof(value) === "string") {
						return this.addLabel(value, position);
					} else if (typeof(value) === "function") {
						value = TweenLite.delayedCall(0, value);
					} else {
						throw("Cannot add " + value + " into the timeline; it is not a tween, timeline, function, or string.");
					}
				}
	
				SimpleTimeline.prototype.add.call(this, value, position);
	
				if (value._time) { //in case, for example, the _startTime is moved on a tween that has already rendered. Imagine it's at its end state, then the startTime is moved WAY later (after the end of this timeline), it should render at its beginning.
					value.render((this.rawTime() - value._startTime) * value._timeScale, false, false);
				}
	
				//if the timeline has already ended but the inserted tween/timeline extends the duration, we should enable this timeline again so that it renders properly. We should also align the playhead with the parent timeline's when appropriate.
				if (this._gc || this._time === this._duration) if (!this._paused) if (this._duration < this.duration()) {
					//in case any of the ancestors had completed but should now be enabled...
					tl = this;
					beforeRawTime = (tl.rawTime() > value._startTime); //if the tween is placed on the timeline so that it starts BEFORE the current rawTime, we should align the playhead (move the timeline). This is because sometimes users will create a timeline, let it finish, and much later append a tween and expect it to run instead of jumping to its end state. While technically one could argue that it should jump to its end state, that's not what users intuitively expect.
					while (tl._timeline) {
						if (beforeRawTime && tl._timeline.smoothChildTiming) {
							tl.totalTime(tl._totalTime, true); //moves the timeline (shifts its startTime) if necessary, and also enables it.
						} else if (tl._gc) {
							tl._enabled(true, false);
						}
						tl = tl._timeline;
					}
				}
	
				return this;
			};
	
			p.remove = function(value) {
				if (value instanceof Animation) {
					this._remove(value, false);
					var tl = value._timeline = value.vars.useFrames ? Animation._rootFramesTimeline : Animation._rootTimeline; //now that it's removed, default it to the root timeline so that if it gets played again, it doesn't jump back into this timeline.
					value._startTime = (value._paused ? value._pauseTime : tl._time) - ((!value._reversed ? value._totalTime : value.totalDuration() - value._totalTime) / value._timeScale); //ensure that if it gets played again, the timing is correct.
					return this;
				} else if (value instanceof Array || (value && value.push && _isArray(value))) {
					var i = value.length;
					while (--i > -1) {
						this.remove(value[i]);
					}
					return this;
				} else if (typeof(value) === "string") {
					return this.removeLabel(value);
				}
				return this.kill(null, value);
			};
	
			p._remove = function(tween, skipDisable) {
				SimpleTimeline.prototype._remove.call(this, tween, skipDisable);
				var last = this._last;
				if (!last) {
					this._time = this._totalTime = this._duration = this._totalDuration = 0;
				} else if (this._time > this.duration()) {
					this._time = this._duration;
					this._totalTime = this._totalDuration;
				}
				return this;
			};
	
			p.append = function(value, offsetOrLabel) {
				return this.add(value, this._parseTimeOrLabel(null, offsetOrLabel, true, value));
			};
	
			p.insert = p.insertMultiple = function(value, position, align, stagger) {
				return this.add(value, position || 0, align, stagger);
			};
	
			p.appendMultiple = function(tweens, offsetOrLabel, align, stagger) {
				return this.add(tweens, this._parseTimeOrLabel(null, offsetOrLabel, true, tweens), align, stagger);
			};
	
			p.addLabel = function(label, position) {
				this._labels[label] = this._parseTimeOrLabel(position);
				return this;
			};
	
			p.addPause = function(position, callback, params, scope) {
				var t = TweenLite.delayedCall(0, _pauseCallback, params, scope || this);
				t.vars.onComplete = t.vars.onReverseComplete = callback;
				t.data = "isPause";
				this._hasPause = true;
				return this.add(t, position);
			};
	
			p.removeLabel = function(label) {
				delete this._labels[label];
				return this;
			};
	
			p.getLabelTime = function(label) {
				return (this._labels[label] != null) ? this._labels[label] : -1;
			};
	
			p._parseTimeOrLabel = function(timeOrLabel, offsetOrLabel, appendIfAbsent, ignore) {
				var clippedDuration, i;
				//if we're about to add a tween/timeline (or an array of them) that's already a child of this timeline, we should remove it first so that it doesn't contaminate the duration().
				if (ignore instanceof Animation && ignore.timeline === this) {
					this.remove(ignore);
				} else if (ignore && ((ignore instanceof Array) || (ignore.push && _isArray(ignore)))) {
					i = ignore.length;
					while (--i > -1) {
						if (ignore[i] instanceof Animation && ignore[i].timeline === this) {
							this.remove(ignore[i]);
						}
					}
				}
				clippedDuration = (typeof(timeOrLabel) === "number" && !offsetOrLabel) ? 0 : (this.duration() > 99999999999) ? this.recent().endTime(false) : this._duration; //in case there's a child that infinitely repeats, users almost never intend for the insertion point of a new child to be based on a SUPER long value like that so we clip it and assume the most recently-added child's endTime should be used instead.
				if (typeof(offsetOrLabel) === "string") {
					return this._parseTimeOrLabel(offsetOrLabel, (appendIfAbsent && typeof(timeOrLabel) === "number" && this._labels[offsetOrLabel] == null) ? timeOrLabel - clippedDuration : 0, appendIfAbsent);
				}
				offsetOrLabel = offsetOrLabel || 0;
				if (typeof(timeOrLabel) === "string" && (isNaN(timeOrLabel) || this._labels[timeOrLabel] != null)) { //if the string is a number like "1", check to see if there's a label with that name, otherwise interpret it as a number (absolute value).
					i = timeOrLabel.indexOf("=");
					if (i === -1) {
						if (this._labels[timeOrLabel] == null) {
							return appendIfAbsent ? (this._labels[timeOrLabel] = clippedDuration + offsetOrLabel) : offsetOrLabel;
						}
						return this._labels[timeOrLabel] + offsetOrLabel;
					}
					offsetOrLabel = parseInt(timeOrLabel.charAt(i-1) + "1", 10) * Number(timeOrLabel.substr(i+1));
					timeOrLabel = (i > 1) ? this._parseTimeOrLabel(timeOrLabel.substr(0, i-1), 0, appendIfAbsent) : clippedDuration;
				} else if (timeOrLabel == null) {
					timeOrLabel = clippedDuration;
				}
				return Number(timeOrLabel) + offsetOrLabel;
			};
	
			p.seek = function(position, suppressEvents) {
				return this.totalTime((typeof(position) === "number") ? position : this._parseTimeOrLabel(position), (suppressEvents !== false));
			};
	
			p.stop = function() {
				return this.paused(true);
			};
	
			p.gotoAndPlay = function(position, suppressEvents) {
				return this.play(position, suppressEvents);
			};
	
			p.gotoAndStop = function(position, suppressEvents) {
				return this.pause(position, suppressEvents);
			};
	
			p.render = function(time, suppressEvents, force) {
				if (this._gc) {
					this._enabled(true, false);
				}
				var prevTime = this._time,
					totalDur = (!this._dirty) ? this._totalDuration : this.totalDuration(),
					prevStart = this._startTime,
					prevTimeScale = this._timeScale,
					prevPaused = this._paused,
					tween, isComplete, next, callback, internalForce, pauseTween, curTime;
				if (prevTime !== this._time) { //if totalDuration() finds a child with a negative startTime and smoothChildTiming is true, things get shifted around internally so we need to adjust the time accordingly. For example, if a tween starts at -30 we must shift EVERYTHING forward 30 seconds and move this timeline's startTime backward by 30 seconds so that things align with the playhead (no jump).
					time += this._time - prevTime;
				}
				if (time >= totalDur - 0.0000001 && time >= 0) { //to work around occasional floating point math artifacts.
					this._totalTime = this._time = totalDur;
					if (!this._reversed) if (!this._hasPausedChild()) {
						isComplete = true;
						callback = "onComplete";
						internalForce = !!this._timeline.autoRemoveChildren; //otherwise, if the animation is unpaused/activated after it's already finished, it doesn't get removed from the parent timeline.
						if (this._duration === 0) if ((time <= 0 && time >= -0.0000001) || this._rawPrevTime < 0 || this._rawPrevTime === _tinyNum) if (this._rawPrevTime !== time && this._first) {
							internalForce = true;
							if (this._rawPrevTime > _tinyNum) {
								callback = "onReverseComplete";
							}
						}
					}
					this._rawPrevTime = (this._duration || !suppressEvents || time || this._rawPrevTime === time) ? time : _tinyNum; //when the playhead arrives at EXACTLY time 0 (right on top) of a zero-duration timeline or tween, we need to discern if events are suppressed so that when the playhead moves again (next time), it'll trigger the callback. If events are NOT suppressed, obviously the callback would be triggered in this render. Basically, the callback should fire either when the playhead ARRIVES or LEAVES this exact spot, not both. Imagine doing a timeline.seek(0) and there's a callback that sits at 0. Since events are suppressed on that seek() by default, nothing will fire, but when the playhead moves off of that position, the callback should fire. This behavior is what people intuitively expect. We set the _rawPrevTime to be a precise tiny number to indicate this scenario rather than using another property/variable which would increase memory usage. This technique is less readable, but more efficient.
					time = totalDur + 0.0001; //to avoid occasional floating point rounding errors - sometimes child tweens/timelines were not being fully completed (their progress might be 0.999999999999998 instead of 1 because when _time - tween._startTime is performed, floating point errors would return a value that was SLIGHTLY off). Try (999999999999.7 - 999999999999) * 1 = 0.699951171875 instead of 0.7.
	
				} else if (time < 0.0000001) { //to work around occasional floating point math artifacts, round super small values to 0.
					this._totalTime = this._time = 0;
					if (prevTime !== 0 || (this._duration === 0 && this._rawPrevTime !== _tinyNum && (this._rawPrevTime > 0 || (time < 0 && this._rawPrevTime >= 0)))) {
						callback = "onReverseComplete";
						isComplete = this._reversed;
					}
					if (time < 0) {
						this._active = false;
						if (this._timeline.autoRemoveChildren && this._reversed) { //ensures proper GC if a timeline is resumed after it's finished reversing.
							internalForce = isComplete = true;
							callback = "onReverseComplete";
						} else if (this._rawPrevTime >= 0 && this._first) { //when going back beyond the start, force a render so that zero-duration tweens that sit at the very beginning render their start values properly. Otherwise, if the parent timeline's playhead lands exactly at this timeline's startTime, and then moves backwards, the zero-duration tweens at the beginning would still be at their end state.
							internalForce = true;
						}
						this._rawPrevTime = time;
					} else {
						this._rawPrevTime = (this._duration || !suppressEvents || time || this._rawPrevTime === time) ? time : _tinyNum; //when the playhead arrives at EXACTLY time 0 (right on top) of a zero-duration timeline or tween, we need to discern if events are suppressed so that when the playhead moves again (next time), it'll trigger the callback. If events are NOT suppressed, obviously the callback would be triggered in this render. Basically, the callback should fire either when the playhead ARRIVES or LEAVES this exact spot, not both. Imagine doing a timeline.seek(0) and there's a callback that sits at 0. Since events are suppressed on that seek() by default, nothing will fire, but when the playhead moves off of that position, the callback should fire. This behavior is what people intuitively expect. We set the _rawPrevTime to be a precise tiny number to indicate this scenario rather than using another property/variable which would increase memory usage. This technique is less readable, but more efficient.
						if (time === 0 && isComplete) { //if there's a zero-duration tween at the very beginning of a timeline and the playhead lands EXACTLY at time 0, that tween will correctly render its end values, but we need to keep the timeline alive for one more render so that the beginning values render properly as the parent's playhead keeps moving beyond the begining. Imagine obj.x starts at 0 and then we do tl.set(obj, {x:100}).to(obj, 1, {x:200}) and then later we tl.reverse()...the goal is to have obj.x revert to 0. If the playhead happens to land on exactly 0, without this chunk of code, it'd complete the timeline and remove it from the rendering queue (not good).
							tween = this._first;
							while (tween && tween._startTime === 0) {
								if (!tween._duration) {
									isComplete = false;
								}
								tween = tween._next;
							}
						}
						time = 0; //to avoid occasional floating point rounding errors (could cause problems especially with zero-duration tweens at the very beginning of the timeline)
						if (!this._initted) {
							internalForce = true;
						}
					}
	
				} else {
	
					if (this._hasPause && !this._forcingPlayhead && !suppressEvents) {
						if (time >= prevTime) {
							tween = this._first;
							while (tween && tween._startTime <= time && !pauseTween) {
								if (!tween._duration) if (tween.data === "isPause" && !tween.ratio && !(tween._startTime === 0 && this._rawPrevTime === 0)) {
									pauseTween = tween;
								}
								tween = tween._next;
							}
						} else {
							tween = this._last;
							while (tween && tween._startTime >= time && !pauseTween) {
								if (!tween._duration) if (tween.data === "isPause" && tween._rawPrevTime > 0) {
									pauseTween = tween;
								}
								tween = tween._prev;
							}
						}
						if (pauseTween) {
							this._time = time = pauseTween._startTime;
							this._totalTime = time + (this._cycle * (this._totalDuration + this._repeatDelay));
						}
					}
	
					this._totalTime = this._time = this._rawPrevTime = time;
				}
				if ((this._time === prevTime || !this._first) && !force && !internalForce && !pauseTween) {
					return;
				} else if (!this._initted) {
					this._initted = true;
				}
	
				if (!this._active) if (!this._paused && this._time !== prevTime && time > 0) {
					this._active = true;  //so that if the user renders the timeline (as opposed to the parent timeline rendering it), it is forced to re-render and align it with the proper time/frame on the next rendering cycle. Maybe the timeline already finished but the user manually re-renders it as halfway done, for example.
				}
	
				if (prevTime === 0) if (this.vars.onStart) if (this._time !== 0 || !this._duration) if (!suppressEvents) {
					this._callback("onStart");
				}
	
				curTime = this._time;
				if (curTime >= prevTime) {
					tween = this._first;
					while (tween) {
						next = tween._next; //record it here because the value could change after rendering...
						if (curTime !== this._time || (this._paused && !prevPaused)) { //in case a tween pauses or seeks the timeline when rendering, like inside of an onUpdate/onComplete
							break;
						} else if (tween._active || (tween._startTime <= curTime && !tween._paused && !tween._gc)) {
							if (pauseTween === tween) {
								this.pause();
							}
							if (!tween._reversed) {
								tween.render((time - tween._startTime) * tween._timeScale, suppressEvents, force);
							} else {
								tween.render(((!tween._dirty) ? tween._totalDuration : tween.totalDuration()) - ((time - tween._startTime) * tween._timeScale), suppressEvents, force);
							}
						}
						tween = next;
					}
				} else {
					tween = this._last;
					while (tween) {
						next = tween._prev; //record it here because the value could change after rendering...
						if (curTime !== this._time || (this._paused && !prevPaused)) { //in case a tween pauses or seeks the timeline when rendering, like inside of an onUpdate/onComplete
							break;
						} else if (tween._active || (tween._startTime <= prevTime && !tween._paused && !tween._gc)) {
							if (pauseTween === tween) {
								pauseTween = tween._prev; //the linked list is organized by _startTime, thus it's possible that a tween could start BEFORE the pause and end after it, in which case it would be positioned before the pause tween in the linked list, but we should render it before we pause() the timeline and cease rendering. This is only a concern when going in reverse.
								while (pauseTween && pauseTween.endTime() > this._time) {
									pauseTween.render( (pauseTween._reversed ? pauseTween.totalDuration() - ((time - pauseTween._startTime) * pauseTween._timeScale) : (time - pauseTween._startTime) * pauseTween._timeScale), suppressEvents, force);
									pauseTween = pauseTween._prev;
								}
								pauseTween = null;
								this.pause();
							}
							if (!tween._reversed) {
								tween.render((time - tween._startTime) * tween._timeScale, suppressEvents, force);
							} else {
								tween.render(((!tween._dirty) ? tween._totalDuration : tween.totalDuration()) - ((time - tween._startTime) * tween._timeScale), suppressEvents, force);
							}
						}
						tween = next;
					}
				}
	
				if (this._onUpdate) if (!suppressEvents) {
					if (_lazyTweens.length) { //in case rendering caused any tweens to lazy-init, we should render them because typically when a timeline finishes, users expect things to have rendered fully. Imagine an onUpdate on a timeline that reports/checks tweened values.
						_lazyRender();
					}
					this._callback("onUpdate");
				}
	
				if (callback) if (!this._gc) if (prevStart === this._startTime || prevTimeScale !== this._timeScale) if (this._time === 0 || totalDur >= this.totalDuration()) { //if one of the tweens that was rendered altered this timeline's startTime (like if an onComplete reversed the timeline), it probably isn't complete. If it is, don't worry, because whatever call altered the startTime would complete if it was necessary at the new time. The only exception is the timeScale property. Also check _gc because there's a chance that kill() could be called in an onUpdate
					if (isComplete) {
						if (_lazyTweens.length) { //in case rendering caused any tweens to lazy-init, we should render them because typically when a timeline finishes, users expect things to have rendered fully. Imagine an onComplete on a timeline that reports/checks tweened values.
							_lazyRender();
						}
						if (this._timeline.autoRemoveChildren) {
							this._enabled(false, false);
						}
						this._active = false;
					}
					if (!suppressEvents && this.vars[callback]) {
						this._callback(callback);
					}
				}
			};
	
			p._hasPausedChild = function() {
				var tween = this._first;
				while (tween) {
					if (tween._paused || ((tween instanceof TimelineLite) && tween._hasPausedChild())) {
						return true;
					}
					tween = tween._next;
				}
				return false;
			};
	
			p.getChildren = function(nested, tweens, timelines, ignoreBeforeTime) {
				ignoreBeforeTime = ignoreBeforeTime || -9999999999;
				var a = [],
					tween = this._first,
					cnt = 0;
				while (tween) {
					if (tween._startTime < ignoreBeforeTime) {
						//do nothing
					} else if (tween instanceof TweenLite) {
						if (tweens !== false) {
							a[cnt++] = tween;
						}
					} else {
						if (timelines !== false) {
							a[cnt++] = tween;
						}
						if (nested !== false) {
							a = a.concat(tween.getChildren(true, tweens, timelines));
							cnt = a.length;
						}
					}
					tween = tween._next;
				}
				return a;
			};
	
			p.getTweensOf = function(target, nested) {
				var disabled = this._gc,
					a = [],
					cnt = 0,
					tweens, i;
				if (disabled) {
					this._enabled(true, true); //getTweensOf() filters out disabled tweens, and we have to mark them as _gc = true when the timeline completes in order to allow clean garbage collection, so temporarily re-enable the timeline here.
				}
				tweens = TweenLite.getTweensOf(target);
				i = tweens.length;
				while (--i > -1) {
					if (tweens[i].timeline === this || (nested && this._contains(tweens[i]))) {
						a[cnt++] = tweens[i];
					}
				}
				if (disabled) {
					this._enabled(false, true);
				}
				return a;
			};
	
			p.recent = function() {
				return this._recent;
			};
	
			p._contains = function(tween) {
				var tl = tween.timeline;
				while (tl) {
					if (tl === this) {
						return true;
					}
					tl = tl.timeline;
				}
				return false;
			};
	
			p.shiftChildren = function(amount, adjustLabels, ignoreBeforeTime) {
				ignoreBeforeTime = ignoreBeforeTime || 0;
				var tween = this._first,
					labels = this._labels,
					p;
				while (tween) {
					if (tween._startTime >= ignoreBeforeTime) {
						tween._startTime += amount;
					}
					tween = tween._next;
				}
				if (adjustLabels) {
					for (p in labels) {
						if (labels[p] >= ignoreBeforeTime) {
							labels[p] += amount;
						}
					}
				}
				return this._uncache(true);
			};
	
			p._kill = function(vars, target) {
				if (!vars && !target) {
					return this._enabled(false, false);
				}
				var tweens = (!target) ? this.getChildren(true, true, false) : this.getTweensOf(target),
					i = tweens.length,
					changed = false;
				while (--i > -1) {
					if (tweens[i]._kill(vars, target)) {
						changed = true;
					}
				}
				return changed;
			};
	
			p.clear = function(labels) {
				var tweens = this.getChildren(false, true, true),
					i = tweens.length;
				this._time = this._totalTime = 0;
				while (--i > -1) {
					tweens[i]._enabled(false, false);
				}
				if (labels !== false) {
					this._labels = {};
				}
				return this._uncache(true);
			};
	
			p.invalidate = function() {
				var tween = this._first;
				while (tween) {
					tween.invalidate();
					tween = tween._next;
				}
				return Animation.prototype.invalidate.call(this);;
			};
	
			p._enabled = function(enabled, ignoreTimeline) {
				if (enabled === this._gc) {
					var tween = this._first;
					while (tween) {
						tween._enabled(enabled, true);
						tween = tween._next;
					}
				}
				return SimpleTimeline.prototype._enabled.call(this, enabled, ignoreTimeline);
			};
	
			p.totalTime = function(time, suppressEvents, uncapped) {
				this._forcingPlayhead = true;
				var val = Animation.prototype.totalTime.apply(this, arguments);
				this._forcingPlayhead = false;
				return val;
			};
	
			p.duration = function(value) {
				if (!arguments.length) {
					if (this._dirty) {
						this.totalDuration(); //just triggers recalculation
					}
					return this._duration;
				}
				if (this.duration() !== 0 && value !== 0) {
					this.timeScale(this._duration / value);
				}
				return this;
			};
	
			p.totalDuration = function(value) {
				if (!arguments.length) {
					if (this._dirty) {
						var max = 0,
							tween = this._last,
							prevStart = 999999999999,
							prev, end;
						while (tween) {
							prev = tween._prev; //record it here in case the tween changes position in the sequence...
							if (tween._dirty) {
								tween.totalDuration(); //could change the tween._startTime, so make sure the tween's cache is clean before analyzing it.
							}
							if (tween._startTime > prevStart && this._sortChildren && !tween._paused && !this._calculatingDuration) { //in case one of the tweens shifted out of order, it needs to be re-inserted into the correct position in the sequence
								this._calculatingDuration = 1; //prevent endless recursive calls - there are methods that get triggered that check duration/totalDuration when we add(), like _parseTimeOrLabel().
								this.add(tween, tween._startTime - tween._delay);
								this._calculatingDuration = 0;
							} else {
								prevStart = tween._startTime;
							}
							if (tween._startTime < 0 && !tween._paused) { //children aren't allowed to have negative startTimes unless smoothChildTiming is true, so adjust here if one is found.
								max -= tween._startTime;
								if (this._timeline.smoothChildTiming) {
									this._startTime += tween._startTime / this._timeScale;
									this._time -= tween._startTime;
									this._totalTime -= tween._startTime;
									this._rawPrevTime -= tween._startTime;
								}
								this.shiftChildren(-tween._startTime, false, -9999999999);
								prevStart = 0;
							}
							end = tween._startTime + (tween._totalDuration / tween._timeScale);
							if (end > max) {
								max = end;
							}
							tween = prev;
						}
						this._duration = this._totalDuration = max;
						this._dirty = false;
					}
					return this._totalDuration;
				}
				return (value && this.totalDuration()) ? this.timeScale(this._totalDuration / value) : this;
			};
	
			p.paused = function(value) {
				if (!value) { //if there's a pause directly at the spot from where we're unpausing, skip it.
					var tween = this._first,
						time = this._time;
					while (tween) {
						if (tween._startTime === time && tween.data === "isPause") {
							tween._rawPrevTime = 0; //remember, _rawPrevTime is how zero-duration tweens/callbacks sense directionality and determine whether or not to fire. If _rawPrevTime is the same as _startTime on the next render, it won't fire.
						}
						tween = tween._next;
					}
				}
				return Animation.prototype.paused.apply(this, arguments);
			};
	
			p.usesFrames = function() {
				var tl = this._timeline;
				while (tl._timeline) {
					tl = tl._timeline;
				}
				return (tl === Animation._rootFramesTimeline);
			};
	
			p.rawTime = function(wrapRepeats) {
				return (wrapRepeats && (this._paused || (this._repeat && this.time() > 0 && this.totalProgress() < 1))) ? this._totalTime % (this._duration + this._repeatDelay) : this._paused ? this._totalTime : (this._timeline.rawTime(wrapRepeats) - this._startTime) * this._timeScale;
			};
	
			return TimelineLite;
	
		}, true);
	
	
	
	
	
	
	
	
		
		
		
		
		
	/*
	 * ----------------------------------------------------------------
	 * TimelineMax
	 * ----------------------------------------------------------------
	 */
		_gsScope._gsDefine("TimelineMax", ["TimelineLite","TweenLite","easing.Ease"], function(TimelineLite, TweenLite, Ease) {
	
			var TimelineMax = function(vars) {
					TimelineLite.call(this, vars);
					this._repeat = this.vars.repeat || 0;
					this._repeatDelay = this.vars.repeatDelay || 0;
					this._cycle = 0;
					this._yoyo = (this.vars.yoyo === true);
					this._dirty = true;
				},
				_tinyNum = 0.0000000001,
				TweenLiteInternals = TweenLite._internals,
				_lazyTweens = TweenLiteInternals.lazyTweens,
				_lazyRender = TweenLiteInternals.lazyRender,
				_globals = _gsScope._gsDefine.globals,
				_easeNone = new Ease(null, null, 1, 0),
				p = TimelineMax.prototype = new TimelineLite();
	
			p.constructor = TimelineMax;
			p.kill()._gc = false;
			TimelineMax.version = "1.20.4";
	
			p.invalidate = function() {
				this._yoyo = (this.vars.yoyo === true);
				this._repeat = this.vars.repeat || 0;
				this._repeatDelay = this.vars.repeatDelay || 0;
				this._uncache(true);
				return TimelineLite.prototype.invalidate.call(this);
			};
	
			p.addCallback = function(callback, position, params, scope) {
				return this.add( TweenLite.delayedCall(0, callback, params, scope), position);
			};
	
			p.removeCallback = function(callback, position) {
				if (callback) {
					if (position == null) {
						this._kill(null, callback);
					} else {
						var a = this.getTweensOf(callback, false),
							i = a.length,
							time = this._parseTimeOrLabel(position);
						while (--i > -1) {
							if (a[i]._startTime === time) {
								a[i]._enabled(false, false);
							}
						}
					}
				}
				return this;
			};
	
			p.removePause = function(position) {
				return this.removeCallback(TimelineLite._internals.pauseCallback, position);
			};
	
			p.tweenTo = function(position, vars) {
				vars = vars || {};
				var copy = {ease:_easeNone, useFrames:this.usesFrames(), immediateRender:false, lazy:false},
					Engine = (vars.repeat && _globals.TweenMax) || TweenLite,
					duration, p, t;
				for (p in vars) {
					copy[p] = vars[p];
				}
				copy.time = this._parseTimeOrLabel(position);
				duration = (Math.abs(Number(copy.time) - this._time) / this._timeScale) || 0.001;
				t = new Engine(this, duration, copy);
				copy.onStart = function() {
					t.target.paused(true);
					if (t.vars.time !== t.target.time() && duration === t.duration() && !t.isFromTo) { //don't make the duration zero - if it's supposed to be zero, don't worry because it's already initting the tween and will complete immediately, effectively making the duration zero anyway. If we make duration zero, the tween won't run at all.
						t.duration( Math.abs( t.vars.time - t.target.time()) / t.target._timeScale ).render(t.time(), true, true); //render() right away to ensure that things look right, especially in the case of .tweenTo(0).
					}
					if (vars.onStart) { //in case the user had an onStart in the vars - we don't want to overwrite it.
						vars.onStart.apply(vars.onStartScope || vars.callbackScope || t, vars.onStartParams || []); //don't use t._callback("onStart") or it'll point to the copy.onStart and we'll get a recursion error.
					}
				};
				return t;
			};
	
			p.tweenFromTo = function(fromPosition, toPosition, vars) {
				vars = vars || {};
				fromPosition = this._parseTimeOrLabel(fromPosition);
				vars.startAt = {onComplete:this.seek, onCompleteParams:[fromPosition], callbackScope:this};
				vars.immediateRender = (vars.immediateRender !== false);
				var t = this.tweenTo(toPosition, vars);
				t.isFromTo = 1; //to ensure we don't mess with the duration in the onStart (we've got the start and end values here, so lock it in)
				return t.duration((Math.abs( t.vars.time - fromPosition) / this._timeScale) || 0.001);
			};
	
			p.render = function(time, suppressEvents, force) {
				if (this._gc) {
					this._enabled(true, false);
				}
				var prevTime = this._time,
					totalDur = (!this._dirty) ? this._totalDuration : this.totalDuration(),
					dur = this._duration,
					prevTotalTime = this._totalTime,
					prevStart = this._startTime,
					prevTimeScale = this._timeScale,
					prevRawPrevTime = this._rawPrevTime,
					prevPaused = this._paused,
					prevCycle = this._cycle,
					tween, isComplete, next, callback, internalForce, cycleDuration, pauseTween, curTime;
				if (prevTime !== this._time) { //if totalDuration() finds a child with a negative startTime and smoothChildTiming is true, things get shifted around internally so we need to adjust the time accordingly. For example, if a tween starts at -30 we must shift EVERYTHING forward 30 seconds and move this timeline's startTime backward by 30 seconds so that things align with the playhead (no jump).
					time += this._time - prevTime;
				}
				if (time >= totalDur - 0.0000001 && time >= 0) { //to work around occasional floating point math artifacts.
					if (!this._locked) {
						this._totalTime = totalDur;
						this._cycle = this._repeat;
					}
					if (!this._reversed) if (!this._hasPausedChild()) {
						isComplete = true;
						callback = "onComplete";
						internalForce = !!this._timeline.autoRemoveChildren; //otherwise, if the animation is unpaused/activated after it's already finished, it doesn't get removed from the parent timeline.
						if (this._duration === 0) if ((time <= 0 && time >= -0.0000001) || prevRawPrevTime < 0 || prevRawPrevTime === _tinyNum) if (prevRawPrevTime !== time && this._first) {
							internalForce = true;
							if (prevRawPrevTime > _tinyNum) {
								callback = "onReverseComplete";
							}
						}
					}
					this._rawPrevTime = (this._duration || !suppressEvents || time || this._rawPrevTime === time) ? time : _tinyNum; //when the playhead arrives at EXACTLY time 0 (right on top) of a zero-duration timeline or tween, we need to discern if events are suppressed so that when the playhead moves again (next time), it'll trigger the callback. If events are NOT suppressed, obviously the callback would be triggered in this render. Basically, the callback should fire either when the playhead ARRIVES or LEAVES this exact spot, not both. Imagine doing a timeline.seek(0) and there's a callback that sits at 0. Since events are suppressed on that seek() by default, nothing will fire, but when the playhead moves off of that position, the callback should fire. This behavior is what people intuitively expect. We set the _rawPrevTime to be a precise tiny number to indicate this scenario rather than using another property/variable which would increase memory usage. This technique is less readable, but more efficient.
					if (this._yoyo && (this._cycle & 1) !== 0) {
						this._time = time = 0;
					} else {
						this._time = dur;
						time = dur + 0.0001; //to avoid occasional floating point rounding errors - sometimes child tweens/timelines were not being fully completed (their progress might be 0.999999999999998 instead of 1 because when _time - tween._startTime is performed, floating point errors would return a value that was SLIGHTLY off). Try (999999999999.7 - 999999999999) * 1 = 0.699951171875 instead of 0.7. We cannot do less then 0.0001 because the same issue can occur when the duration is extremely large like 999999999999 in which case adding 0.00000001, for example, causes it to act like nothing was added.
					}
	
				} else if (time < 0.0000001) { //to work around occasional floating point math artifacts, round super small values to 0.
					if (!this._locked) {
						this._totalTime = this._cycle = 0;
					}
					this._time = 0;
					if (prevTime !== 0 || (dur === 0 && prevRawPrevTime !== _tinyNum && (prevRawPrevTime > 0 || (time < 0 && prevRawPrevTime >= 0)) && !this._locked)) { //edge case for checking time < 0 && prevRawPrevTime >= 0: a zero-duration fromTo() tween inside a zero-duration timeline (yeah, very rare)
						callback = "onReverseComplete";
						isComplete = this._reversed;
					}
					if (time < 0) {
						this._active = false;
						if (this._timeline.autoRemoveChildren && this._reversed) {
							internalForce = isComplete = true;
							callback = "onReverseComplete";
						} else if (prevRawPrevTime >= 0 && this._first) { //when going back beyond the start, force a render so that zero-duration tweens that sit at the very beginning render their start values properly. Otherwise, if the parent timeline's playhead lands exactly at this timeline's startTime, and then moves backwards, the zero-duration tweens at the beginning would still be at their end state.
							internalForce = true;
						}
						this._rawPrevTime = time;
					} else {
						this._rawPrevTime = (dur || !suppressEvents || time || this._rawPrevTime === time) ? time : _tinyNum; //when the playhead arrives at EXACTLY time 0 (right on top) of a zero-duration timeline or tween, we need to discern if events are suppressed so that when the playhead moves again (next time), it'll trigger the callback. If events are NOT suppressed, obviously the callback would be triggered in this render. Basically, the callback should fire either when the playhead ARRIVES or LEAVES this exact spot, not both. Imagine doing a timeline.seek(0) and there's a callback that sits at 0. Since events are suppressed on that seek() by default, nothing will fire, but when the playhead moves off of that position, the callback should fire. This behavior is what people intuitively expect. We set the _rawPrevTime to be a precise tiny number to indicate this scenario rather than using another property/variable which would increase memory usage. This technique is less readable, but more efficient.
						if (time === 0 && isComplete) { //if there's a zero-duration tween at the very beginning of a timeline and the playhead lands EXACTLY at time 0, that tween will correctly render its end values, but we need to keep the timeline alive for one more render so that the beginning values render properly as the parent's playhead keeps moving beyond the begining. Imagine obj.x starts at 0 and then we do tl.set(obj, {x:100}).to(obj, 1, {x:200}) and then later we tl.reverse()...the goal is to have obj.x revert to 0. If the playhead happens to land on exactly 0, without this chunk of code, it'd complete the timeline and remove it from the rendering queue (not good).
							tween = this._first;
							while (tween && tween._startTime === 0) {
								if (!tween._duration) {
									isComplete = false;
								}
								tween = tween._next;
							}
						}
						time = 0; //to avoid occasional floating point rounding errors (could cause problems especially with zero-duration tweens at the very beginning of the timeline)
						if (!this._initted) {
							internalForce = true;
						}
					}
	
				} else {
					if (dur === 0 && prevRawPrevTime < 0) { //without this, zero-duration repeating timelines (like with a simple callback nested at the very beginning and a repeatDelay) wouldn't render the first time through.
						internalForce = true;
					}
					this._time = this._rawPrevTime = time;
					if (!this._locked) {
						this._totalTime = time;
						if (this._repeat !== 0) {
							cycleDuration = dur + this._repeatDelay;
							this._cycle = (this._totalTime / cycleDuration) >> 0; //originally _totalTime % cycleDuration but floating point errors caused problems, so I normalized it. (4 % 0.8 should be 0 but it gets reported as 0.79999999!)
							if (this._cycle !== 0) if (this._cycle === this._totalTime / cycleDuration && prevTotalTime <= time) {
								this._cycle--; //otherwise when rendered exactly at the end time, it will act as though it is repeating (at the beginning)
							}
							this._time = this._totalTime - (this._cycle * cycleDuration);
							if (this._yoyo) if ((this._cycle & 1) !== 0) {
								this._time = dur - this._time;
							}
							if (this._time > dur) {
								this._time = dur;
								time = dur + 0.0001; //to avoid occasional floating point rounding error
							} else if (this._time < 0) {
								this._time = time = 0;
							} else {
								time = this._time;
							}
						}
					}
	
					if (this._hasPause && !this._forcingPlayhead && !suppressEvents) {
						time = this._time;
						if (time >= prevTime || (this._repeat && prevCycle !== this._cycle)) {
							tween = this._first;
							while (tween && tween._startTime <= time && !pauseTween) {
								if (!tween._duration) if (tween.data === "isPause" && !tween.ratio && !(tween._startTime === 0 && this._rawPrevTime === 0)) {
									pauseTween = tween;
								}
								tween = tween._next;
							}
						} else {
							tween = this._last;
							while (tween && tween._startTime >= time && !pauseTween) {
								if (!tween._duration) if (tween.data === "isPause" && tween._rawPrevTime > 0) {
									pauseTween = tween;
								}
								tween = tween._prev;
							}
						}
						if (pauseTween && pauseTween._startTime < dur) {
							this._time = time = pauseTween._startTime;
							this._totalTime = time + (this._cycle * (this._totalDuration + this._repeatDelay));
						}
					}
	
				}
	
				if (this._cycle !== prevCycle) if (!this._locked) {
					/*
					make sure children at the end/beginning of the timeline are rendered properly. If, for example,
					a 3-second long timeline rendered at 2.9 seconds previously, and now renders at 3.2 seconds (which
					would get transated to 2.8 seconds if the timeline yoyos or 0.2 seconds if it just repeats), there
					could be a callback or a short tween that's at 2.95 or 3 seconds in which wouldn't render. So
					we need to push the timeline to the end (and/or beginning depending on its yoyo value). Also we must
					ensure that zero-duration tweens at the very beginning or end of the TimelineMax work.
					*/
					var backwards = (this._yoyo && (prevCycle & 1) !== 0),
						wrap = (backwards === (this._yoyo && (this._cycle & 1) !== 0)),
						recTotalTime = this._totalTime,
						recCycle = this._cycle,
						recRawPrevTime = this._rawPrevTime,
						recTime = this._time;
	
					this._totalTime = prevCycle * dur;
					if (this._cycle < prevCycle) {
						backwards = !backwards;
					} else {
						this._totalTime += dur;
					}
					this._time = prevTime; //temporarily revert _time so that render() renders the children in the correct order. Without this, tweens won't rewind correctly. We could arhictect things in a "cleaner" way by splitting out the rendering queue into a separate method but for performance reasons, we kept it all inside this method.
	
					this._rawPrevTime = (dur === 0) ? prevRawPrevTime - 0.0001 : prevRawPrevTime;
					this._cycle = prevCycle;
					this._locked = true; //prevents changes to totalTime and skips repeat/yoyo behavior when we recursively call render()
					prevTime = (backwards) ? 0 : dur;
					this.render(prevTime, suppressEvents, (dur === 0));
					if (!suppressEvents) if (!this._gc) {
						if (this.vars.onRepeat) {
							this._cycle = recCycle; //in case the onRepeat alters the playhead or invalidates(), we shouldn't stay locked or use the previous cycle.
							this._locked = false;
							this._callback("onRepeat");
						}
					}
					if (prevTime !== this._time) { //in case there's a callback like onComplete in a nested tween/timeline that changes the playhead position, like via seek(), we should just abort.
						return;
					}
					if (wrap) {
						this._cycle = prevCycle; //if there's an onRepeat, we reverted this above, so make sure it's set properly again. We also unlocked in that scenario, so reset that too.
						this._locked = true;
						prevTime = (backwards) ? dur + 0.0001 : -0.0001;
						this.render(prevTime, true, false);
					}
					this._locked = false;
					if (this._paused && !prevPaused) { //if the render() triggered callback that paused this timeline, we should abort (very rare, but possible)
						return;
					}
					this._time = recTime;
					this._totalTime = recTotalTime;
					this._cycle = recCycle;
					this._rawPrevTime = recRawPrevTime;
				}
	
				if ((this._time === prevTime || !this._first) && !force && !internalForce && !pauseTween) {
					if (prevTotalTime !== this._totalTime) if (this._onUpdate) if (!suppressEvents) { //so that onUpdate fires even during the repeatDelay - as long as the totalTime changed, we should trigger onUpdate.
						this._callback("onUpdate");
					}
					return;
				} else if (!this._initted) {
					this._initted = true;
				}
	
				if (!this._active) if (!this._paused && this._totalTime !== prevTotalTime && time > 0) {
					this._active = true;  //so that if the user renders the timeline (as opposed to the parent timeline rendering it), it is forced to re-render and align it with the proper time/frame on the next rendering cycle. Maybe the timeline already finished but the user manually re-renders it as halfway done, for example.
				}
	
				if (prevTotalTime === 0) if (this.vars.onStart) if (this._totalTime !== 0 || !this._totalDuration) if (!suppressEvents) {
					this._callback("onStart");
				}
	
				curTime = this._time;
				if (curTime >= prevTime) {
					tween = this._first;
					while (tween) {
						next = tween._next; //record it here because the value could change after rendering...
						if (curTime !== this._time || (this._paused && !prevPaused)) { //in case a tween pauses or seeks the timeline when rendering, like inside of an onUpdate/onComplete
							break;
						} else if (tween._active || (tween._startTime <= this._time && !tween._paused && !tween._gc)) {
							if (pauseTween === tween) {
								this.pause();
							}
							if (!tween._reversed) {
								tween.render((time - tween._startTime) * tween._timeScale, suppressEvents, force);
							} else {
								tween.render(((!tween._dirty) ? tween._totalDuration : tween.totalDuration()) - ((time - tween._startTime) * tween._timeScale), suppressEvents, force);
							}
						}
						tween = next;
					}
				} else {
					tween = this._last;
					while (tween) {
						next = tween._prev; //record it here because the value could change after rendering...
						if (curTime !== this._time || (this._paused && !prevPaused)) { //in case a tween pauses or seeks the timeline when rendering, like inside of an onUpdate/onComplete
							break;
						} else if (tween._active || (tween._startTime <= prevTime && !tween._paused && !tween._gc)) {
							if (pauseTween === tween) {
								pauseTween = tween._prev; //the linked list is organized by _startTime, thus it's possible that a tween could start BEFORE the pause and end after it, in which case it would be positioned before the pause tween in the linked list, but we should render it before we pause() the timeline and cease rendering. This is only a concern when going in reverse.
								while (pauseTween && pauseTween.endTime() > this._time) {
									pauseTween.render( (pauseTween._reversed ? pauseTween.totalDuration() - ((time - pauseTween._startTime) * pauseTween._timeScale) : (time - pauseTween._startTime) * pauseTween._timeScale), suppressEvents, force);
									pauseTween = pauseTween._prev;
								}
								pauseTween = null;
								this.pause();
							}
							if (!tween._reversed) {
								tween.render((time - tween._startTime) * tween._timeScale, suppressEvents, force);
							} else {
								tween.render(((!tween._dirty) ? tween._totalDuration : tween.totalDuration()) - ((time - tween._startTime) * tween._timeScale), suppressEvents, force);
							}
						}
						tween = next;
					}
				}
	
				if (this._onUpdate) if (!suppressEvents) {
					if (_lazyTweens.length) { //in case rendering caused any tweens to lazy-init, we should render them because typically when a timeline finishes, users expect things to have rendered fully. Imagine an onUpdate on a timeline that reports/checks tweened values.
						_lazyRender();
					}
					this._callback("onUpdate");
				}
				if (callback) if (!this._locked) if (!this._gc) if (prevStart === this._startTime || prevTimeScale !== this._timeScale) if (this._time === 0 || totalDur >= this.totalDuration()) { //if one of the tweens that was rendered altered this timeline's startTime (like if an onComplete reversed the timeline), it probably isn't complete. If it is, don't worry, because whatever call altered the startTime would complete if it was necessary at the new time. The only exception is the timeScale property. Also check _gc because there's a chance that kill() could be called in an onUpdate
					if (isComplete) {
						if (_lazyTweens.length) { //in case rendering caused any tweens to lazy-init, we should render them because typically when a timeline finishes, users expect things to have rendered fully. Imagine an onComplete on a timeline that reports/checks tweened values.
							_lazyRender();
						}
						if (this._timeline.autoRemoveChildren) {
							this._enabled(false, false);
						}
						this._active = false;
					}
					if (!suppressEvents && this.vars[callback]) {
						this._callback(callback);
					}
				}
			};
	
			p.getActive = function(nested, tweens, timelines) {
				if (nested == null) {
					nested = true;
				}
				if (tweens == null) {
					tweens = true;
				}
				if (timelines == null) {
					timelines = false;
				}
				var a = [],
					all = this.getChildren(nested, tweens, timelines),
					cnt = 0,
					l = all.length,
					i, tween;
				for (i = 0; i < l; i++) {
					tween = all[i];
					if (tween.isActive()) {
						a[cnt++] = tween;
					}
				}
				return a;
			};
	
	
			p.getLabelAfter = function(time) {
				if (!time) if (time !== 0) { //faster than isNan()
					time = this._time;
				}
				var labels = this.getLabelsArray(),
					l = labels.length,
					i;
				for (i = 0; i < l; i++) {
					if (labels[i].time > time) {
						return labels[i].name;
					}
				}
				return null;
			};
	
			p.getLabelBefore = function(time) {
				if (time == null) {
					time = this._time;
				}
				var labels = this.getLabelsArray(),
					i = labels.length;
				while (--i > -1) {
					if (labels[i].time < time) {
						return labels[i].name;
					}
				}
				return null;
			};
	
			p.getLabelsArray = function() {
				var a = [],
					cnt = 0,
					p;
				for (p in this._labels) {
					a[cnt++] = {time:this._labels[p], name:p};
				}
				a.sort(function(a,b) {
					return a.time - b.time;
				});
				return a;
			};
	
			p.invalidate = function() {
				this._locked = false; //unlock and set cycle in case invalidate() is called from inside an onRepeat
				return TimelineLite.prototype.invalidate.call(this);
			};
	
	
	//---- GETTERS / SETTERS -------------------------------------------------------------------------------------------------------
	
			p.progress = function(value, suppressEvents) {
				return (!arguments.length) ? (this._time / this.duration()) || 0 : this.totalTime( this.duration() * ((this._yoyo && (this._cycle & 1) !== 0) ? 1 - value : value) + (this._cycle * (this._duration + this._repeatDelay)), suppressEvents);
			};
	
			p.totalProgress = function(value, suppressEvents) {
				return (!arguments.length) ? (this._totalTime / this.totalDuration()) || 0 : this.totalTime( this.totalDuration() * value, suppressEvents);
			};
	
			p.totalDuration = function(value) {
				if (!arguments.length) {
					if (this._dirty) {
						TimelineLite.prototype.totalDuration.call(this); //just forces refresh
						//Instead of Infinity, we use 999999999999 so that we can accommodate reverses.
						this._totalDuration = (this._repeat === -1) ? 999999999999 : this._duration * (this._repeat + 1) + (this._repeatDelay * this._repeat);
					}
					return this._totalDuration;
				}
				return (this._repeat === -1 || !value) ? this : this.timeScale( this.totalDuration() / value );
			};
	
			p.time = function(value, suppressEvents) {
				if (!arguments.length) {
					return this._time;
				}
				if (this._dirty) {
					this.totalDuration();
				}
				if (value > this._duration) {
					value = this._duration;
				}
				if (this._yoyo && (this._cycle & 1) !== 0) {
					value = (this._duration - value) + (this._cycle * (this._duration + this._repeatDelay));
				} else if (this._repeat !== 0) {
					value += this._cycle * (this._duration + this._repeatDelay);
				}
				return this.totalTime(value, suppressEvents);
			};
	
			p.repeat = function(value) {
				if (!arguments.length) {
					return this._repeat;
				}
				this._repeat = value;
				return this._uncache(true);
			};
	
			p.repeatDelay = function(value) {
				if (!arguments.length) {
					return this._repeatDelay;
				}
				this._repeatDelay = value;
				return this._uncache(true);
			};
	
			p.yoyo = function(value) {
				if (!arguments.length) {
					return this._yoyo;
				}
				this._yoyo = value;
				return this;
			};
	
			p.currentLabel = function(value) {
				if (!arguments.length) {
					return this.getLabelBefore(this._time + 0.00000001);
				}
				return this.seek(value, true);
			};
	
			return TimelineMax;
	
		}, true);
		
	
	
	
	
		
		
		
		
		
	
		
	/*
	 * ----------------------------------------------------------------
	 * BezierPlugin
	 * ----------------------------------------------------------------
	 */
		(function() {
	
			var _RAD2DEG = 180 / Math.PI,
				_r1 = [],
				_r2 = [],
				_r3 = [],
				_corProps = {},
				_globals = _gsScope._gsDefine.globals,
				Segment = function(a, b, c, d) {
					if (c === d) { //if c and d match, the final autoRotate value could lock at -90 degrees, so differentiate them slightly.
						c = d - (d - b) / 1000000;
					}
					if (a === b) { //if a and b match, the starting autoRotate value could lock at -90 degrees, so differentiate them slightly.
						b = a + (c - a) / 1000000;
					}
					this.a = a;
					this.b = b;
					this.c = c;
					this.d = d;
					this.da = d - a;
					this.ca = c - a;
					this.ba = b - a;
				},
				_correlate = ",x,y,z,left,top,right,bottom,marginTop,marginLeft,marginRight,marginBottom,paddingLeft,paddingTop,paddingRight,paddingBottom,backgroundPosition,backgroundPosition_y,",
				cubicToQuadratic = function(a, b, c, d) {
					var q1 = {a:a},
						q2 = {},
						q3 = {},
						q4 = {c:d},
						mab = (a + b) / 2,
						mbc = (b + c) / 2,
						mcd = (c + d) / 2,
						mabc = (mab + mbc) / 2,
						mbcd = (mbc + mcd) / 2,
						m8 = (mbcd - mabc) / 8;
					q1.b = mab + (a - mab) / 4;
					q2.b = mabc + m8;
					q1.c = q2.a = (q1.b + q2.b) / 2;
					q2.c = q3.a = (mabc + mbcd) / 2;
					q3.b = mbcd - m8;
					q4.b = mcd + (d - mcd) / 4;
					q3.c = q4.a = (q3.b + q4.b) / 2;
					return [q1, q2, q3, q4];
				},
				_calculateControlPoints = function(a, curviness, quad, basic, correlate) {
					var l = a.length - 1,
						ii = 0,
						cp1 = a[0].a,
						i, p1, p2, p3, seg, m1, m2, mm, cp2, qb, r1, r2, tl;
					for (i = 0; i < l; i++) {
						seg = a[ii];
						p1 = seg.a;
						p2 = seg.d;
						p3 = a[ii+1].d;
	
						if (correlate) {
							r1 = _r1[i];
							r2 = _r2[i];
							tl = ((r2 + r1) * curviness * 0.25) / (basic ? 0.5 : _r3[i] || 0.5);
							m1 = p2 - (p2 - p1) * (basic ? curviness * 0.5 : (r1 !== 0 ? tl / r1 : 0));
							m2 = p2 + (p3 - p2) * (basic ? curviness * 0.5 : (r2 !== 0 ? tl / r2 : 0));
							mm = p2 - (m1 + (((m2 - m1) * ((r1 * 3 / (r1 + r2)) + 0.5) / 4) || 0));
						} else {
							m1 = p2 - (p2 - p1) * curviness * 0.5;
							m2 = p2 + (p3 - p2) * curviness * 0.5;
							mm = p2 - (m1 + m2) / 2;
						}
						m1 += mm;
						m2 += mm;
	
						seg.c = cp2 = m1;
						if (i !== 0) {
							seg.b = cp1;
						} else {
							seg.b = cp1 = seg.a + (seg.c - seg.a) * 0.6; //instead of placing b on a exactly, we move it inline with c so that if the user specifies an ease like Back.easeIn or Elastic.easeIn which goes BEYOND the beginning, it will do so smoothly.
						}
	
						seg.da = p2 - p1;
						seg.ca = cp2 - p1;
						seg.ba = cp1 - p1;
	
						if (quad) {
							qb = cubicToQuadratic(p1, cp1, cp2, p2);
							a.splice(ii, 1, qb[0], qb[1], qb[2], qb[3]);
							ii += 4;
						} else {
							ii++;
						}
	
						cp1 = m2;
					}
					seg = a[ii];
					seg.b = cp1;
					seg.c = cp1 + (seg.d - cp1) * 0.4; //instead of placing c on d exactly, we move it inline with b so that if the user specifies an ease like Back.easeOut or Elastic.easeOut which goes BEYOND the end, it will do so smoothly.
					seg.da = seg.d - seg.a;
					seg.ca = seg.c - seg.a;
					seg.ba = cp1 - seg.a;
					if (quad) {
						qb = cubicToQuadratic(seg.a, cp1, seg.c, seg.d);
						a.splice(ii, 1, qb[0], qb[1], qb[2], qb[3]);
					}
				},
				_parseAnchors = function(values, p, correlate, prepend) {
					var a = [],
						l, i, p1, p2, p3, tmp;
					if (prepend) {
						values = [prepend].concat(values);
						i = values.length;
						while (--i > -1) {
							if (typeof( (tmp = values[i][p]) ) === "string") if (tmp.charAt(1) === "=") {
								values[i][p] = prepend[p] + Number(tmp.charAt(0) + tmp.substr(2)); //accommodate relative values. Do it inline instead of breaking it out into a function for speed reasons
							}
						}
					}
					l = values.length - 2;
					if (l < 0) {
						a[0] = new Segment(values[0][p], 0, 0, values[0][p]);
						return a;
					}
					for (i = 0; i < l; i++) {
						p1 = values[i][p];
						p2 = values[i+1][p];
						a[i] = new Segment(p1, 0, 0, p2);
						if (correlate) {
							p3 = values[i+2][p];
							_r1[i] = (_r1[i] || 0) + (p2 - p1) * (p2 - p1);
							_r2[i] = (_r2[i] || 0) + (p3 - p2) * (p3 - p2);
						}
					}
					a[i] = new Segment(values[i][p], 0, 0, values[i+1][p]);
					return a;
				},
				bezierThrough = function(values, curviness, quadratic, basic, correlate, prepend) {
					var obj = {},
						props = [],
						first = prepend || values[0],
						i, p, a, j, r, l, seamless, last;
					correlate = (typeof(correlate) === "string") ? ","+correlate+"," : _correlate;
					if (curviness == null) {
						curviness = 1;
					}
					for (p in values[0]) {
						props.push(p);
					}
					//check to see if the last and first values are identical (well, within 0.05). If so, make seamless by appending the second element to the very end of the values array and the 2nd-to-last element to the very beginning (we'll remove those segments later)
					if (values.length > 1) {
						last = values[values.length - 1];
						seamless = true;
						i = props.length;
						while (--i > -1) {
							p = props[i];
							if (Math.abs(first[p] - last[p]) > 0.05) { //build in a tolerance of +/-0.05 to accommodate rounding errors.
								seamless = false;
								break;
							}
						}
						if (seamless) {
							values = values.concat(); //duplicate the array to avoid contaminating the original which the user may be reusing for other tweens
							if (prepend) {
								values.unshift(prepend);
							}
							values.push(values[1]);
							prepend = values[values.length - 3];
						}
					}
					_r1.length = _r2.length = _r3.length = 0;
					i = props.length;
					while (--i > -1) {
						p = props[i];
						_corProps[p] = (correlate.indexOf(","+p+",") !== -1);
						obj[p] = _parseAnchors(values, p, _corProps[p], prepend);
					}
					i = _r1.length;
					while (--i > -1) {
						_r1[i] = Math.sqrt(_r1[i]);
						_r2[i] = Math.sqrt(_r2[i]);
					}
					if (!basic) {
						i = props.length;
						while (--i > -1) {
							if (_corProps[p]) {
								a = obj[props[i]];
								l = a.length - 1;
								for (j = 0; j < l; j++) {
									r = (a[j+1].da / _r2[j] + a[j].da / _r1[j]) || 0;
									_r3[j] = (_r3[j] || 0) + r * r;
								}
							}
						}
						i = _r3.length;
						while (--i > -1) {
							_r3[i] = Math.sqrt(_r3[i]);
						}
					}
					i = props.length;
					j = quadratic ? 4 : 1;
					while (--i > -1) {
						p = props[i];
						a = obj[p];
						_calculateControlPoints(a, curviness, quadratic, basic, _corProps[p]); //this method requires that _parseAnchors() and _setSegmentRatios() ran first so that _r1, _r2, and _r3 values are populated for all properties
						if (seamless) {
							a.splice(0, j);
							a.splice(a.length - j, j);
						}
					}
					return obj;
				},
				_parseBezierData = function(values, type, prepend) {
					type = type || "soft";
					var obj = {},
						inc = (type === "cubic") ? 3 : 2,
						soft = (type === "soft"),
						props = [],
						a, b, c, d, cur, i, j, l, p, cnt, tmp;
					if (soft && prepend) {
						values = [prepend].concat(values);
					}
					if (values == null || values.length < inc + 1) { throw "invalid Bezier data"; }
					for (p in values[0]) {
						props.push(p);
					}
					i = props.length;
					while (--i > -1) {
						p = props[i];
						obj[p] = cur = [];
						cnt = 0;
						l = values.length;
						for (j = 0; j < l; j++) {
							a = (prepend == null) ? values[j][p] : (typeof( (tmp = values[j][p]) ) === "string" && tmp.charAt(1) === "=") ? prepend[p] + Number(tmp.charAt(0) + tmp.substr(2)) : Number(tmp);
							if (soft) if (j > 1) if (j < l - 1) {
								cur[cnt++] = (a + cur[cnt-2]) / 2;
							}
							cur[cnt++] = a;
						}
						l = cnt - inc + 1;
						cnt = 0;
						for (j = 0; j < l; j += inc) {
							a = cur[j];
							b = cur[j+1];
							c = cur[j+2];
							d = (inc === 2) ? 0 : cur[j+3];
							cur[cnt++] = tmp = (inc === 3) ? new Segment(a, b, c, d) : new Segment(a, (2 * b + a) / 3, (2 * b + c) / 3, c);
						}
						cur.length = cnt;
					}
					return obj;
				},
				_addCubicLengths = function(a, steps, resolution) {
					var inc = 1 / resolution,
						j = a.length,
						d, d1, s, da, ca, ba, p, i, inv, bez, index;
					while (--j > -1) {
						bez = a[j];
						s = bez.a;
						da = bez.d - s;
						ca = bez.c - s;
						ba = bez.b - s;
						d = d1 = 0;
						for (i = 1; i <= resolution; i++) {
							p = inc * i;
							inv = 1 - p;
							d = d1 - (d1 = (p * p * da + 3 * inv * (p * ca + inv * ba)) * p);
							index = j * resolution + i - 1;
							steps[index] = (steps[index] || 0) + d * d;
						}
					}
				},
				_parseLengthData = function(obj, resolution) {
					resolution = resolution >> 0 || 6;
					var a = [],
						lengths = [],
						d = 0,
						total = 0,
						threshold = resolution - 1,
						segments = [],
						curLS = [], //current length segments array
						p, i, l, index;
					for (p in obj) {
						_addCubicLengths(obj[p], a, resolution);
					}
					l = a.length;
					for (i = 0; i < l; i++) {
						d += Math.sqrt(a[i]);
						index = i % resolution;
						curLS[index] = d;
						if (index === threshold) {
							total += d;
							index = (i / resolution) >> 0;
							segments[index] = curLS;
							lengths[index] = total;
							d = 0;
							curLS = [];
						}
					}
					return {length:total, lengths:lengths, segments:segments};
				},
	
	
	
				BezierPlugin = _gsScope._gsDefine.plugin({
						propName: "bezier",
						priority: -1,
						version: "1.3.8",
						API: 2,
						global:true,
	
						//gets called when the tween renders for the first time. This is where initial values should be recorded and any setup routines should run.
						init: function(target, vars, tween) {
							this._target = target;
							if (vars instanceof Array) {
								vars = {values:vars};
							}
							this._func = {};
							this._mod = {};
							this._props = [];
							this._timeRes = (vars.timeResolution == null) ? 6 : parseInt(vars.timeResolution, 10);
							var values = vars.values || [],
								first = {},
								second = values[0],
								autoRotate = vars.autoRotate || tween.vars.orientToBezier,
								p, isFunc, i, j, prepend;
	
							this._autoRotate = autoRotate ? (autoRotate instanceof Array) ? autoRotate : [["x","y","rotation",((autoRotate === true) ? 0 : Number(autoRotate) || 0)]] : null;
							for (p in second) {
								this._props.push(p);
							}
	
							i = this._props.length;
							while (--i > -1) {
								p = this._props[i];
	
								this._overwriteProps.push(p);
								isFunc = this._func[p] = (typeof(target[p]) === "function");
								first[p] = (!isFunc) ? parseFloat(target[p]) : target[ ((p.indexOf("set") || typeof(target["get" + p.substr(3)]) !== "function") ? p : "get" + p.substr(3)) ]();
								if (!prepend) if (first[p] !== values[0][p]) {
									prepend = first;
								}
							}
							this._beziers = (vars.type !== "cubic" && vars.type !== "quadratic" && vars.type !== "soft") ? bezierThrough(values, isNaN(vars.curviness) ? 1 : vars.curviness, false, (vars.type === "thruBasic"), vars.correlate, prepend) : _parseBezierData(values, vars.type, first);
							this._segCount = this._beziers[p].length;
	
							if (this._timeRes) {
								var ld = _parseLengthData(this._beziers, this._timeRes);
								this._length = ld.length;
								this._lengths = ld.lengths;
								this._segments = ld.segments;
								this._l1 = this._li = this._s1 = this._si = 0;
								this._l2 = this._lengths[0];
								this._curSeg = this._segments[0];
								this._s2 = this._curSeg[0];
								this._prec = 1 / this._curSeg.length;
							}
	
							if ((autoRotate = this._autoRotate)) {
								this._initialRotations = [];
								if (!(autoRotate[0] instanceof Array)) {
									this._autoRotate = autoRotate = [autoRotate];
								}
								i = autoRotate.length;
								while (--i > -1) {
									for (j = 0; j < 3; j++) {
										p = autoRotate[i][j];
										this._func[p] = (typeof(target[p]) === "function") ? target[ ((p.indexOf("set") || typeof(target["get" + p.substr(3)]) !== "function") ? p : "get" + p.substr(3)) ] : false;
									}
									p = autoRotate[i][2];
									this._initialRotations[i] = (this._func[p] ? this._func[p].call(this._target) : this._target[p]) || 0;
									this._overwriteProps.push(p);
								}
							}
							this._startRatio = tween.vars.runBackwards ? 1 : 0; //we determine the starting ratio when the tween inits which is always 0 unless the tween has runBackwards:true (indicating it's a from() tween) in which case it's 1.
							return true;
						},
	
						//called each time the values should be updated, and the ratio gets passed as the only parameter (typically it's a value between 0 and 1, but it can exceed those when using an ease like Elastic.easeOut or Back.easeOut, etc.)
						set: function(v) {
							var segments = this._segCount,
								func = this._func,
								target = this._target,
								notStart = (v !== this._startRatio),
								curIndex, inv, i, p, b, t, val, l, lengths, curSeg;
							if (!this._timeRes) {
								curIndex = (v < 0) ? 0 : (v >= 1) ? segments - 1 : (segments * v) >> 0;
								t = (v - (curIndex * (1 / segments))) * segments;
							} else {
								lengths = this._lengths;
								curSeg = this._curSeg;
								v *= this._length;
								i = this._li;
								//find the appropriate segment (if the currently cached one isn't correct)
								if (v > this._l2 && i < segments - 1) {
									l = segments - 1;
									while (i < l && (this._l2 = lengths[++i]) <= v) {	}
									this._l1 = lengths[i-1];
									this._li = i;
									this._curSeg = curSeg = this._segments[i];
									this._s2 = curSeg[(this._s1 = this._si = 0)];
								} else if (v < this._l1 && i > 0) {
									while (i > 0 && (this._l1 = lengths[--i]) >= v) { }
									if (i === 0 && v < this._l1) {
										this._l1 = 0;
									} else {
										i++;
									}
									this._l2 = lengths[i];
									this._li = i;
									this._curSeg = curSeg = this._segments[i];
									this._s1 = curSeg[(this._si = curSeg.length - 1) - 1] || 0;
									this._s2 = curSeg[this._si];
								}
								curIndex = i;
								//now find the appropriate sub-segment (we split it into the number of pieces that was defined by "precision" and measured each one)
								v -= this._l1;
								i = this._si;
								if (v > this._s2 && i < curSeg.length - 1) {
									l = curSeg.length - 1;
									while (i < l && (this._s2 = curSeg[++i]) <= v) {	}
									this._s1 = curSeg[i-1];
									this._si = i;
								} else if (v < this._s1 && i > 0) {
									while (i > 0 && (this._s1 = curSeg[--i]) >= v) {	}
									if (i === 0 && v < this._s1) {
										this._s1 = 0;
									} else {
										i++;
									}
									this._s2 = curSeg[i];
									this._si = i;
								}
								t = ((i + (v - this._s1) / (this._s2 - this._s1)) * this._prec) || 0;
							}
							inv = 1 - t;
	
							i = this._props.length;
							while (--i > -1) {
								p = this._props[i];
								b = this._beziers[p][curIndex];
								val = (t * t * b.da + 3 * inv * (t * b.ca + inv * b.ba)) * t + b.a;
								if (this._mod[p]) {
									val = this._mod[p](val, target);
								}
								if (func[p]) {
									target[p](val);
								} else {
									target[p] = val;
								}
							}
	
							if (this._autoRotate) {
								var ar = this._autoRotate,
									b2, x1, y1, x2, y2, add, conv;
								i = ar.length;
								while (--i > -1) {
									p = ar[i][2];
									add = ar[i][3] || 0;
									conv = (ar[i][4] === true) ? 1 : _RAD2DEG;
									b = this._beziers[ar[i][0]];
									b2 = this._beziers[ar[i][1]];
	
									if (b && b2) { //in case one of the properties got overwritten.
										b = b[curIndex];
										b2 = b2[curIndex];
	
										x1 = b.a + (b.b - b.a) * t;
										x2 = b.b + (b.c - b.b) * t;
										x1 += (x2 - x1) * t;
										x2 += ((b.c + (b.d - b.c) * t) - x2) * t;
	
										y1 = b2.a + (b2.b - b2.a) * t;
										y2 = b2.b + (b2.c - b2.b) * t;
										y1 += (y2 - y1) * t;
										y2 += ((b2.c + (b2.d - b2.c) * t) - y2) * t;
	
										val = notStart ? Math.atan2(y2 - y1, x2 - x1) * conv + add : this._initialRotations[i];
	
										if (this._mod[p]) {
											val = this._mod[p](val, target); //for modProps
										}
	
										if (func[p]) {
											target[p](val);
										} else {
											target[p] = val;
										}
									}
								}
							}
						}
				}),
				p = BezierPlugin.prototype;
	
	
			BezierPlugin.bezierThrough = bezierThrough;
			BezierPlugin.cubicToQuadratic = cubicToQuadratic;
			BezierPlugin._autoCSS = true; //indicates that this plugin can be inserted into the "css" object using the autoCSS feature of TweenLite
			BezierPlugin.quadraticToCubic = function(a, b, c) {
				return new Segment(a, (2 * b + a) / 3, (2 * b + c) / 3, c);
			};
	
			BezierPlugin._cssRegister = function() {
				var CSSPlugin = _globals.CSSPlugin;
				if (!CSSPlugin) {
					return;
				}
				var _internals = CSSPlugin._internals,
					_parseToProxy = _internals._parseToProxy,
					_setPluginRatio = _internals._setPluginRatio,
					CSSPropTween = _internals.CSSPropTween;
				_internals._registerComplexSpecialProp("bezier", {parser:function(t, e, prop, cssp, pt, plugin) {
					if (e instanceof Array) {
						e = {values:e};
					}
					plugin = new BezierPlugin();
					var values = e.values,
						l = values.length - 1,
						pluginValues = [],
						v = {},
						i, p, data;
					if (l < 0) {
						return pt;
					}
					for (i = 0; i <= l; i++) {
						data = _parseToProxy(t, values[i], cssp, pt, plugin, (l !== i));
						pluginValues[i] = data.end;
					}
					for (p in e) {
						v[p] = e[p]; //duplicate the vars object because we need to alter some things which would cause problems if the user plans to reuse the same vars object for another tween.
					}
					v.values = pluginValues;
					pt = new CSSPropTween(t, "bezier", 0, 0, data.pt, 2);
					pt.data = data;
					pt.plugin = plugin;
					pt.setRatio = _setPluginRatio;
					if (v.autoRotate === 0) {
						v.autoRotate = true;
					}
					if (v.autoRotate && !(v.autoRotate instanceof Array)) {
						i = (v.autoRotate === true) ? 0 : Number(v.autoRotate);
						v.autoRotate = (data.end.left != null) ? [["left","top","rotation",i,false]] : (data.end.x != null) ? [["x","y","rotation",i,false]] : false;
					}
					if (v.autoRotate) {
						if (!cssp._transform) {
							cssp._enableTransforms(false);
						}
						data.autoRotate = cssp._target._gsTransform;
						data.proxy.rotation = data.autoRotate.rotation || 0;
						cssp._overwriteProps.push("rotation");
					}
					plugin._onInitTween(data.proxy, v, cssp._tween);
					return pt;
				}});
			};
	
			p._mod = function(lookup) {
				var op = this._overwriteProps,
					i = op.length,
					val;
				while (--i > -1) {
					val = lookup[op[i]];
					if (val && typeof(val) === "function") {
						this._mod[op[i]] = val;
					}
				}
			};
	
			p._kill = function(lookup) {
				var a = this._props,
					p, i;
				for (p in this._beziers) {
					if (p in lookup) {
						delete this._beziers[p];
						delete this._func[p];
						i = a.length;
						while (--i > -1) {
							if (a[i] === p) {
								a.splice(i, 1);
							}
						}
					}
				}
				a = this._autoRotate;
				if (a) {
					i = a.length;
					while (--i > -1) {
						if (lookup[a[i][2]]) {
							a.splice(i, 1);
						}
					}
				}
				return this._super._kill.call(this, lookup);
			};
	
		}());
	
	
	
	
	
	
		
		
		
		
		
		
		
		
	/*
	 * ----------------------------------------------------------------
	 * CSSPlugin
	 * ----------------------------------------------------------------
	 */
		_gsScope._gsDefine("plugins.CSSPlugin", ["plugins.TweenPlugin","TweenLite"], function(TweenPlugin, TweenLite) {
	
			/** @constructor **/
			var CSSPlugin = function() {
					TweenPlugin.call(this, "css");
					this._overwriteProps.length = 0;
					this.setRatio = CSSPlugin.prototype.setRatio; //speed optimization (avoid prototype lookup on this "hot" method)
				},
				_globals = _gsScope._gsDefine.globals,
				_hasPriority, //turns true whenever a CSSPropTween instance is created that has a priority other than 0. This helps us discern whether or not we should spend the time organizing the linked list or not after a CSSPlugin's _onInitTween() method is called.
				_suffixMap, //we set this in _onInitTween() each time as a way to have a persistent variable we can use in other methods like _parse() without having to pass it around as a parameter and we keep _parse() decoupled from a particular CSSPlugin instance
				_cs, //computed style (we store this in a shared variable to conserve memory and make minification tighter
				_overwriteProps, //alias to the currently instantiating CSSPlugin's _overwriteProps array. We use this closure in order to avoid having to pass a reference around from method to method and aid in minification.
				_specialProps = {},
				p = CSSPlugin.prototype = new TweenPlugin("css");
	
			p.constructor = CSSPlugin;
			CSSPlugin.version = "1.20.5";
			CSSPlugin.API = 2;
			CSSPlugin.defaultTransformPerspective = 0;
			CSSPlugin.defaultSkewType = "compensated";
			CSSPlugin.defaultSmoothOrigin = true;
			p = "px"; //we'll reuse the "p" variable to keep file size down
			CSSPlugin.suffixMap = {top:p, right:p, bottom:p, left:p, width:p, height:p, fontSize:p, padding:p, margin:p, perspective:p, lineHeight:""};
	
	
			var _numExp = /(?:\-|\.|\b)(\d|\.|e\-)+/g,
				_relNumExp = /(?:\d|\-\d|\.\d|\-\.\d|\+=\d|\-=\d|\+=.\d|\-=\.\d)+/g,
				_valuesExp = /(?:\+=|\-=|\-|\b)[\d\-\.]+[a-zA-Z0-9]*(?:%|\b)/gi, //finds all the values that begin with numbers or += or -= and then a number. Includes suffixes. We use this to split complex values apart like "1px 5px 20px rgb(255,102,51)"
				_NaNExp = /(?![+-]?\d*\.?\d+|[+-]|e[+-]\d+)[^0-9]/g, //also allows scientific notation and doesn't kill the leading -/+ in -= and +=
				_suffixExp = /(?:\d|\-|\+|=|#|\.)*/g,
				_opacityExp = /opacity *= *([^)]*)/i,
				_opacityValExp = /opacity:([^;]*)/i,
				_alphaFilterExp = /alpha\(opacity *=.+?\)/i,
				_rgbhslExp = /^(rgb|hsl)/,
				_capsExp = /([A-Z])/g,
				_camelExp = /-([a-z])/gi,
				_urlExp = /(^(?:url\(\"|url\())|(?:(\"\))$|\)$)/gi, //for pulling out urls from url(...) or url("...") strings (some browsers wrap urls in quotes, some don't when reporting things like backgroundImage)
				_camelFunc = function(s, g) { return g.toUpperCase(); },
				_horizExp = /(?:Left|Right|Width)/i,
				_ieGetMatrixExp = /(M11|M12|M21|M22)=[\d\-\.e]+/gi,
				_ieSetMatrixExp = /progid\:DXImageTransform\.Microsoft\.Matrix\(.+?\)/i,
				_commasOutsideParenExp = /,(?=[^\)]*(?:\(|$))/gi, //finds any commas that are not within parenthesis
				_complexExp = /[\s,\(]/i, //for testing a string to find if it has a space, comma, or open parenthesis (clues that it's a complex value)
				_DEG2RAD = Math.PI / 180,
				_RAD2DEG = 180 / Math.PI,
				_forcePT = {},
				_dummyElement = {style:{}},
				_doc = _gsScope.document || {createElement: function() {return _dummyElement;}},
				_createElement = function(type, ns) {
					return _doc.createElementNS ? _doc.createElementNS(ns || "http://www.w3.org/1999/xhtml", type) : _doc.createElement(type);
				},
				_tempDiv = _createElement("div"),
				_tempImg = _createElement("img"),
				_internals = CSSPlugin._internals = {_specialProps:_specialProps}, //provides a hook to a few internal methods that we need to access from inside other plugins
				_agent = (_gsScope.navigator || {}).userAgent || "",
				_autoRound,
				_reqSafariFix, //we won't apply the Safari transform fix until we actually come across a tween that affects a transform property (to maintain best performance).
	
				_isSafari,
				_isFirefox, //Firefox has a bug that causes 3D transformed elements to randomly disappear unless a repaint is forced after each update on each element.
				_isSafariLT6, //Safari (and Android 4 which uses a flavor of Safari) has a bug that prevents changes to "top" and "left" properties from rendering properly if changed on the same frame as a transform UNLESS we set the element's WebkitBackfaceVisibility to hidden (weird, I know). Doing this for Android 3 and earlier seems to actually cause other problems, though (fun!)
				_ieVers,
				_supportsOpacity = (function() { //we set _isSafari, _ieVers, _isFirefox, and _supportsOpacity all in one function here to reduce file size slightly, especially in the minified version.
					var i = _agent.indexOf("Android"),
						a = _createElement("a");
					_isSafari = (_agent.indexOf("Safari") !== -1 && _agent.indexOf("Chrome") === -1 && (i === -1 || parseFloat(_agent.substr(i+8, 2)) > 3));
					_isSafariLT6 = (_isSafari && (parseFloat(_agent.substr(_agent.indexOf("Version/")+8, 2)) < 6));
					_isFirefox = (_agent.indexOf("Firefox") !== -1);
					if ((/MSIE ([0-9]{1,}[\.0-9]{0,})/).exec(_agent) || (/Trident\/.*rv:([0-9]{1,}[\.0-9]{0,})/).exec(_agent)) {
						_ieVers = parseFloat( RegExp.$1 );
					}
					if (!a) {
						return false;
					}
					a.style.cssText = "top:1px;opacity:.55;";
					return /^0.55/.test(a.style.opacity);
				}()),
				_getIEOpacity = function(v) {
					return (_opacityExp.test( ((typeof(v) === "string") ? v : (v.currentStyle ? v.currentStyle.filter : v.style.filter) || "") ) ? ( parseFloat( RegExp.$1 ) / 100 ) : 1);
				},
				_log = function(s) {//for logging messages, but in a way that won't throw errors in old versions of IE.
					if (_gsScope.console) {
						console.log(s);
					}
				},
				_target, //when initting a CSSPlugin, we set this variable so that we can access it from within many other functions without having to pass it around as params
				_index, //when initting a CSSPlugin, we set this variable so that we can access it from within many other functions without having to pass it around as params
	
				_prefixCSS = "", //the non-camelCase vendor prefix like "-o-", "-moz-", "-ms-", or "-webkit-"
				_prefix = "", //camelCase vendor prefix like "O", "ms", "Webkit", or "Moz".
	
				// @private feed in a camelCase property name like "transform" and it will check to see if it is valid as-is or if it needs a vendor prefix. It returns the corrected camelCase property name (i.e. "WebkitTransform" or "MozTransform" or "transform" or null if no such property is found, like if the browser is IE8 or before, "transform" won't be found at all)
				_checkPropPrefix = function(p, e) {
					e = e || _tempDiv;
					var s = e.style,
						a, i;
					if (s[p] !== undefined) {
						return p;
					}
					p = p.charAt(0).toUpperCase() + p.substr(1);
					a = ["O","Moz","ms","Ms","Webkit"];
					i = 5;
					while (--i > -1 && s[a[i]+p] === undefined) { }
					if (i >= 0) {
						_prefix = (i === 3) ? "ms" : a[i];
						_prefixCSS = "-" + _prefix.toLowerCase() + "-";
						return _prefix + p;
					}
					return null;
				},
	
				_getComputedStyle = (typeof(window) !== "undefined" ? window : _doc.defaultView || {getComputedStyle:function() {}}).getComputedStyle,
	
				/**
				 * @private Returns the css style for a particular property of an element. For example, to get whatever the current "left" css value for an element with an ID of "myElement", you could do:
				 * var currentLeft = CSSPlugin.getStyle( document.getElementById("myElement"), "left");
				 *
				 * @param {!Object} t Target element whose style property you want to query
				 * @param {!string} p Property name (like "left" or "top" or "marginTop", etc.)
				 * @param {Object=} cs Computed style object. This just provides a way to speed processing if you're going to get several properties on the same element in quick succession - you can reuse the result of the getComputedStyle() call.
				 * @param {boolean=} calc If true, the value will not be read directly from the element's "style" property (if it exists there), but instead the getComputedStyle() result will be used. This can be useful when you want to ensure that the browser itself is interpreting the value.
				 * @param {string=} dflt Default value that should be returned in the place of null, "none", "auto" or "auto auto".
				 * @return {?string} The current property value
				 */
				_getStyle = CSSPlugin.getStyle = function(t, p, cs, calc, dflt) {
					var rv;
					if (!_supportsOpacity) if (p === "opacity") { //several versions of IE don't use the standard "opacity" property - they use things like filter:alpha(opacity=50), so we parse that here.
						return _getIEOpacity(t);
					}
					if (!calc && t.style[p]) {
						rv = t.style[p];
					} else if ((cs = cs || _getComputedStyle(t))) {
						rv = cs[p] || cs.getPropertyValue(p) || cs.getPropertyValue(p.replace(_capsExp, "-$1").toLowerCase());
					} else if (t.currentStyle) {
						rv = t.currentStyle[p];
					}
					return (dflt != null && (!rv || rv === "none" || rv === "auto" || rv === "auto auto")) ? dflt : rv;
				},
	
				/**
				 * @private Pass the target element, the property name, the numeric value, and the suffix (like "%", "em", "px", etc.) and it will spit back the equivalent pixel number.
				 * @param {!Object} t Target element
				 * @param {!string} p Property name (like "left", "top", "marginLeft", etc.)
				 * @param {!number} v Value
				 * @param {string=} sfx Suffix (like "px" or "%" or "em")
				 * @param {boolean=} recurse If true, the call is a recursive one. In some browsers (like IE7/8), occasionally the value isn't accurately reported initially, but if we run the function again it will take effect.
				 * @return {number} value in pixels
				 */
				_convertToPixels = _internals.convertToPixels = function(t, p, v, sfx, recurse) {
					if (sfx === "px" || (!sfx && p !== "lineHeight")) { return v; }
					if (sfx === "auto" || !v) { return 0; }
					var horiz = _horizExp.test(p),
						node = t,
						style = _tempDiv.style,
						neg = (v < 0),
						precise = (v === 1),
						pix, cache, time;
					if (neg) {
						v = -v;
					}
					if (precise) {
						v *= 100;
					}
					if (p === "lineHeight" && !sfx) { //special case of when a simple lineHeight (without a unit) is used. Set it to the value, read back the computed value, and then revert.
						cache = _getComputedStyle(t).lineHeight;
						t.style.lineHeight = v;
						pix = parseFloat(_getComputedStyle(t).lineHeight);
						t.style.lineHeight = cache;
					} else if (sfx === "%" && p.indexOf("border") !== -1) {
						pix = (v / 100) * (horiz ? t.clientWidth : t.clientHeight);
					} else {
						style.cssText = "border:0 solid red;position:" + _getStyle(t, "position") + ";line-height:0;";
						if (sfx === "%" || !node.appendChild || sfx.charAt(0) === "v" || sfx === "rem") {
							node = t.parentNode || _doc.body;
							if (_getStyle(node, "display").indexOf("flex") !== -1) { //Edge and IE11 have a bug that causes offsetWidth to report as 0 if the container has display:flex and the child is position:relative. Switching to position: absolute solves it.
								style.position = "absolute";
							}
							cache = node._gsCache;
							time = TweenLite.ticker.frame;
							if (cache && horiz && cache.time === time) { //performance optimization: we record the width of elements along with the ticker frame so that we can quickly get it again on the same tick (seems relatively safe to assume it wouldn't change on the same tick)
								return cache.width * v / 100;
							}
							style[(horiz ? "width" : "height")] = v + sfx;
						} else {
							style[(horiz ? "borderLeftWidth" : "borderTopWidth")] = v + sfx;
						}
						node.appendChild(_tempDiv);
						pix = parseFloat(_tempDiv[(horiz ? "offsetWidth" : "offsetHeight")]);
						node.removeChild(_tempDiv);
						if (horiz && sfx === "%" && CSSPlugin.cacheWidths !== false) {
							cache = node._gsCache = node._gsCache || {};
							cache.time = time;
							cache.width = pix / v * 100;
						}
						if (pix === 0 && !recurse) {
							pix = _convertToPixels(t, p, v, sfx, true);
						}
					}
					if (precise) {
						pix /= 100;
					}
					return neg ? -pix : pix;
				},
				_calculateOffset = _internals.calculateOffset = function(t, p, cs) { //for figuring out "top" or "left" in px when it's "auto". We need to factor in margin with the offsetLeft/offsetTop
					if (_getStyle(t, "position", cs) !== "absolute") { return 0; }
					var dim = ((p === "left") ? "Left" : "Top"),
						v = _getStyle(t, "margin" + dim, cs);
					return t["offset" + dim] - (_convertToPixels(t, p, parseFloat(v), v.replace(_suffixExp, "")) || 0);
				},
	
				// @private returns at object containing ALL of the style properties in camelCase and their associated values.
				_getAllStyles = function(t, cs) {
					var s = {},
						i, tr, p;
					if ((cs = cs || _getComputedStyle(t, null))) {
						if ((i = cs.length)) {
							while (--i > -1) {
								p = cs[i];
								if (p.indexOf("-transform") === -1 || _transformPropCSS === p) { //Some webkit browsers duplicate transform values, one non-prefixed and one prefixed ("transform" and "WebkitTransform"), so we must weed out the extra one here.
									s[p.replace(_camelExp, _camelFunc)] = cs.getPropertyValue(p);
								}
							}
						} else { //some browsers behave differently - cs.length is always 0, so we must do a for...in loop.
							for (i in cs) {
								if (i.indexOf("Transform") === -1 || _transformProp === i) { //Some webkit browsers duplicate transform values, one non-prefixed and one prefixed ("transform" and "WebkitTransform"), so we must weed out the extra one here.
									s[i] = cs[i];
								}
							}
						}
					} else if ((cs = t.currentStyle || t.style)) {
						for (i in cs) {
							if (typeof(i) === "string" && s[i] === undefined) {
								s[i.replace(_camelExp, _camelFunc)] = cs[i];
							}
						}
					}
					if (!_supportsOpacity) {
						s.opacity = _getIEOpacity(t);
					}
					tr = _getTransform(t, cs, false);
					s.rotation = tr.rotation;
					s.skewX = tr.skewX;
					s.scaleX = tr.scaleX;
					s.scaleY = tr.scaleY;
					s.x = tr.x;
					s.y = tr.y;
					if (_supports3D) {
						s.z = tr.z;
						s.rotationX = tr.rotationX;
						s.rotationY = tr.rotationY;
						s.scaleZ = tr.scaleZ;
					}
					if (s.filters) {
						delete s.filters;
					}
					return s;
				},
	
				// @private analyzes two style objects (as returned by _getAllStyles()) and only looks for differences between them that contain tweenable values (like a number or color). It returns an object with a "difs" property which refers to an object containing only those isolated properties and values for tweening, and a "firstMPT" property which refers to the first MiniPropTween instance in a linked list that recorded all the starting values of the different properties so that we can revert to them at the end or beginning of the tween - we don't want the cascading to get messed up. The forceLookup parameter is an optional generic object with properties that should be forced into the results - this is necessary for className tweens that are overwriting others because imagine a scenario where a rollover/rollout adds/removes a class and the user swipes the mouse over the target SUPER fast, thus nothing actually changed yet and the subsequent comparison of the properties would indicate they match (especially when px rounding is taken into consideration), thus no tweening is necessary even though it SHOULD tween and remove those properties after the tween (otherwise the inline styles will contaminate things). See the className SpecialProp code for details.
				_cssDif = function(t, s1, s2, vars, forceLookup) {
					var difs = {},
						style = t.style,
						val, p, mpt;
					for (p in s2) {
						if (p !== "cssText") if (p !== "length") if (isNaN(p)) if (s1[p] !== (val = s2[p]) || (forceLookup && forceLookup[p])) if (p.indexOf("Origin") === -1) if (typeof(val) === "number" || typeof(val) === "string") {
							difs[p] = (val === "auto" && (p === "left" || p === "top")) ? _calculateOffset(t, p) : ((val === "" || val === "auto" || val === "none") && typeof(s1[p]) === "string" && s1[p].replace(_NaNExp, "") !== "") ? 0 : val; //if the ending value is defaulting ("" or "auto"), we check the starting value and if it can be parsed into a number (a string which could have a suffix too, like 700px), then we swap in 0 for "" or "auto" so that things actually tween.
							if (style[p] !== undefined) { //for className tweens, we must remember which properties already existed inline - the ones that didn't should be removed when the tween isn't in progress because they were only introduced to facilitate the transition between classes.
								mpt = new MiniPropTween(style, p, style[p], mpt);
							}
						}
					}
					if (vars) {
						for (p in vars) { //copy properties (except className)
							if (p !== "className") {
								difs[p] = vars[p];
							}
						}
					}
					return {difs:difs, firstMPT:mpt};
				},
				_dimensions = {width:["Left","Right"], height:["Top","Bottom"]},
				_margins = ["marginLeft","marginRight","marginTop","marginBottom"],
	
				/**
				 * @private Gets the width or height of an element
				 * @param {!Object} t Target element
				 * @param {!string} p Property name ("width" or "height")
				 * @param {Object=} cs Computed style object (if one exists). Just a speed optimization.
				 * @return {number} Dimension (in pixels)
				 */
				_getDimension = function(t, p, cs) {
					if ((t.nodeName + "").toLowerCase() === "svg") { //Chrome no longer supports offsetWidth/offsetHeight on SVG elements.
						return (cs || _getComputedStyle(t))[p] || 0;
					} else if (t.getCTM && _isSVG(t)) {
						return t.getBBox()[p] || 0;
					}
					var v = parseFloat((p === "width") ? t.offsetWidth : t.offsetHeight),
						a = _dimensions[p],
						i = a.length;
					cs = cs || _getComputedStyle(t, null);
					while (--i > -1) {
						v -= parseFloat( _getStyle(t, "padding" + a[i], cs, true) ) || 0;
						v -= parseFloat( _getStyle(t, "border" + a[i] + "Width", cs, true) ) || 0;
					}
					return v;
				},
	
				// @private Parses position-related complex strings like "top left" or "50px 10px" or "70% 20%", etc. which are used for things like transformOrigin or backgroundPosition. Optionally decorates a supplied object (recObj) with the following properties: "ox" (offsetX), "oy" (offsetY), "oxp" (if true, "ox" is a percentage not a pixel value), and "oxy" (if true, "oy" is a percentage not a pixel value)
				_parsePosition = function(v, recObj) {
					if (v === "contain" || v === "auto" || v === "auto auto") { //note: Firefox uses "auto auto" as default whereas Chrome uses "auto".
						return v + " ";
					}
					if (v == null || v === "") {
						v = "0 0";
					}
					var a = v.split(" "),
						x = (v.indexOf("left") !== -1) ? "0%" : (v.indexOf("right") !== -1) ? "100%" : a[0],
						y = (v.indexOf("top") !== -1) ? "0%" : (v.indexOf("bottom") !== -1) ? "100%" : a[1],
						i;
					if (a.length > 3 && !recObj) { //multiple positions
						a = v.split(", ").join(",").split(",");
						v = [];
						for (i = 0; i < a.length; i++) {
							v.push(_parsePosition(a[i]));
						}
						return v.join(",");
					}
					if (y == null) {
						y = (x === "center") ? "50%" : "0";
					} else if (y === "center") {
						y = "50%";
					}
					if (x === "center" || (isNaN(parseFloat(x)) && (x + "").indexOf("=") === -1)) { //remember, the user could flip-flop the values and say "bottom center" or "center bottom", etc. "center" is ambiguous because it could be used to describe horizontal or vertical, hence the isNaN(). If there's an "=" sign in the value, it's relative.
						x = "50%";
					}
					v = x + " " + y + ((a.length > 2) ? " " + a[2] : "");
					if (recObj) {
						recObj.oxp = (x.indexOf("%") !== -1);
						recObj.oyp = (y.indexOf("%") !== -1);
						recObj.oxr = (x.charAt(1) === "=");
						recObj.oyr = (y.charAt(1) === "=");
						recObj.ox = parseFloat(x.replace(_NaNExp, ""));
						recObj.oy = parseFloat(y.replace(_NaNExp, ""));
						recObj.v = v;
					}
					return recObj || v;
				},
	
				/**
				 * @private Takes an ending value (typically a string, but can be a number) and a starting value and returns the change between the two, looking for relative value indicators like += and -= and it also ignores suffixes (but make sure the ending value starts with a number or +=/-= and that the starting value is a NUMBER!)
				 * @param {(number|string)} e End value which is typically a string, but could be a number
				 * @param {(number|string)} b Beginning value which is typically a string but could be a number
				 * @return {number} Amount of change between the beginning and ending values (relative values that have a "+=" or "-=" are recognized)
				 */
				_parseChange = function(e, b) {
					if (typeof(e) === "function") {
						e = e(_index, _target);
					}
					return (typeof(e) === "string" && e.charAt(1) === "=") ? parseInt(e.charAt(0) + "1", 10) * parseFloat(e.substr(2)) : (parseFloat(e) - parseFloat(b)) || 0;
				},
	
				/**
				 * @private Takes a value and a default number, checks if the value is relative, null, or numeric and spits back a normalized number accordingly. Primarily used in the _parseTransform() function.
				 * @param {Object} v Value to be parsed
				 * @param {!number} d Default value (which is also used for relative calculations if "+=" or "-=" is found in the first parameter)
				 * @return {number} Parsed value
				 */
				_parseVal = function(v, d) {
					if (typeof(v) === "function") {
						v = v(_index, _target);
					}
					return (v == null) ? d : (typeof(v) === "string" && v.charAt(1) === "=") ? parseInt(v.charAt(0) + "1", 10) * parseFloat(v.substr(2)) + d : parseFloat(v) || 0;
				},
	
				/**
				 * @private Translates strings like "40deg" or "40" or 40rad" or "+=40deg" or "270_short" or "-90_cw" or "+=45_ccw" to a numeric radian angle. Of course a starting/default value must be fed in too so that relative values can be calculated properly.
				 * @param {Object} v Value to be parsed
				 * @param {!number} d Default value (which is also used for relative calculations if "+=" or "-=" is found in the first parameter)
				 * @param {string=} p property name for directionalEnd (optional - only used when the parsed value is directional ("_short", "_cw", or "_ccw" suffix). We need a way to store the uncompensated value so that at the end of the tween, we set it to exactly what was requested with no directional compensation). Property name would be "rotation", "rotationX", or "rotationY"
				 * @param {Object=} directionalEnd An object that will store the raw end values for directional angles ("_short", "_cw", or "_ccw" suffix). We need a way to store the uncompensated value so that at the end of the tween, we set it to exactly what was requested with no directional compensation.
				 * @return {number} parsed angle in radians
				 */
				_parseAngle = function(v, d, p, directionalEnd) {
					var min = 0.000001,
						cap, split, dif, result, isRelative;
					if (typeof(v) === "function") {
						v = v(_index, _target);
					}
					if (v == null) {
						result = d;
					} else if (typeof(v) === "number") {
						result = v;
					} else {
						cap = 360;
						split = v.split("_");
						isRelative = (v.charAt(1) === "=");
						dif = (isRelative ? parseInt(v.charAt(0) + "1", 10) * parseFloat(split[0].substr(2)) : parseFloat(split[0])) * ((v.indexOf("rad") === -1) ? 1 : _RAD2DEG) - (isRelative ? 0 : d);
						if (split.length) {
							if (directionalEnd) {
								directionalEnd[p] = d + dif;
							}
							if (v.indexOf("short") !== -1) {
								dif = dif % cap;
								if (dif !== dif % (cap / 2)) {
									dif = (dif < 0) ? dif + cap : dif - cap;
								}
							}
							if (v.indexOf("_cw") !== -1 && dif < 0) {
								dif = ((dif + cap * 9999999999) % cap) - ((dif / cap) | 0) * cap;
							} else if (v.indexOf("ccw") !== -1 && dif > 0) {
								dif = ((dif - cap * 9999999999) % cap) - ((dif / cap) | 0) * cap;
							}
						}
						result = d + dif;
					}
					if (result < min && result > -min) {
						result = 0;
					}
					return result;
				},
	
				_colorLookup = {aqua:[0,255,255],
					lime:[0,255,0],
					silver:[192,192,192],
					black:[0,0,0],
					maroon:[128,0,0],
					teal:[0,128,128],
					blue:[0,0,255],
					navy:[0,0,128],
					white:[255,255,255],
					fuchsia:[255,0,255],
					olive:[128,128,0],
					yellow:[255,255,0],
					orange:[255,165,0],
					gray:[128,128,128],
					purple:[128,0,128],
					green:[0,128,0],
					red:[255,0,0],
					pink:[255,192,203],
					cyan:[0,255,255],
					transparent:[255,255,255,0]},
	
				_hue = function(h, m1, m2) {
					h = (h < 0) ? h + 1 : (h > 1) ? h - 1 : h;
					return ((((h * 6 < 1) ? m1 + (m2 - m1) * h * 6 : (h < 0.5) ? m2 : (h * 3 < 2) ? m1 + (m2 - m1) * (2 / 3 - h) * 6 : m1) * 255) + 0.5) | 0;
				},
	
				/**
				 * @private Parses a color (like #9F0, #FF9900, rgb(255,51,153) or hsl(108, 50%, 10%)) into an array with 3 elements for red, green, and blue or if toHSL parameter is true, it will populate the array with hue, saturation, and lightness values. If a relative value is found in an hsl() or hsla() string, it will preserve those relative prefixes and all the values in the array will be strings instead of numbers (in all other cases it will be populated with numbers).
				 * @param {(string|number)} v The value the should be parsed which could be a string like #9F0 or rgb(255,102,51) or rgba(255,0,0,0.5) or it could be a number like 0xFF00CC or even a named color like red, blue, purple, etc.
				 * @param {(boolean)} toHSL If true, an hsl() or hsla() value will be returned instead of rgb() or rgba()
				 * @return {Array.<number>} An array containing red, green, and blue (and optionally alpha) in that order, or if the toHSL parameter was true, the array will contain hue, saturation and lightness (and optionally alpha) in that order. Always numbers unless there's a relative prefix found in an hsl() or hsla() string and toHSL is true.
				 */
				_parseColor = CSSPlugin.parseColor = function(v, toHSL) {
					var a, r, g, b, h, s, l, max, min, d, wasHSL;
					if (!v) {
						a = _colorLookup.black;
					} else if (typeof(v) === "number") {
						a = [v >> 16, (v >> 8) & 255, v & 255];
					} else {
						if (v.charAt(v.length - 1) === ",") { //sometimes a trailing comma is included and we should chop it off (typically from a comma-delimited list of values like a textShadow:"2px 2px 2px blue, 5px 5px 5px rgb(255,0,0)" - in this example "blue," has a trailing comma. We could strip it out inside parseComplex() but we'd need to do it to the beginning and ending values plus it wouldn't provide protection from other potential scenarios like if the user passes in a similar value.
							v = v.substr(0, v.length - 1);
						}
						if (_colorLookup[v]) {
							a = _colorLookup[v];
						} else if (v.charAt(0) === "#") {
							if (v.length === 4) { //for shorthand like #9F0
								r = v.charAt(1);
								g = v.charAt(2);
								b = v.charAt(3);
								v = "#" + r + r + g + g + b + b;
							}
							v = parseInt(v.substr(1), 16);
							a = [v >> 16, (v >> 8) & 255, v & 255];
						} else if (v.substr(0, 3) === "hsl") {
							a = wasHSL = v.match(_numExp);
							if (!toHSL) {
								h = (Number(a[0]) % 360) / 360;
								s = Number(a[1]) / 100;
								l = Number(a[2]) / 100;
								g = (l <= 0.5) ? l * (s + 1) : l + s - l * s;
								r = l * 2 - g;
								if (a.length > 3) {
									a[3] = Number(a[3]);
								}
								a[0] = _hue(h + 1 / 3, r, g);
								a[1] = _hue(h, r, g);
								a[2] = _hue(h - 1 / 3, r, g);
							} else if (v.indexOf("=") !== -1) { //if relative values are found, just return the raw strings with the relative prefixes in place.
								return v.match(_relNumExp);
							}
						} else {
							a = v.match(_numExp) || _colorLookup.transparent;
						}
						a[0] = Number(a[0]);
						a[1] = Number(a[1]);
						a[2] = Number(a[2]);
						if (a.length > 3) {
							a[3] = Number(a[3]);
						}
					}
					if (toHSL && !wasHSL) {
						r = a[0] / 255;
						g = a[1] / 255;
						b = a[2] / 255;
						max = Math.max(r, g, b);
						min = Math.min(r, g, b);
						l = (max + min) / 2;
						if (max === min) {
							h = s = 0;
						} else {
							d = max - min;
							s = l > 0.5 ? d / (2 - max - min) : d / (max + min);
							h = (max === r) ? (g - b) / d + (g < b ? 6 : 0) : (max === g) ? (b - r) / d + 2 : (r - g) / d + 4;
							h *= 60;
						}
						a[0] = (h + 0.5) | 0;
						a[1] = (s * 100 + 0.5) | 0;
						a[2] = (l * 100 + 0.5) | 0;
					}
					return a;
				},
				_formatColors = function(s, toHSL) {
					var colors = s.match(_colorExp) || [],
						charIndex = 0,
						parsed = "",
						i, color, temp;
					if (!colors.length) {
						return s;
					}
					for (i = 0; i < colors.length; i++) {
						color = colors[i];
						temp = s.substr(charIndex, s.indexOf(color, charIndex)-charIndex);
						charIndex += temp.length + color.length;
						color = _parseColor(color, toHSL);
						if (color.length === 3) {
							color.push(1);
						}
						parsed += temp + (toHSL ? "hsla(" + color[0] + "," + color[1] + "%," + color[2] + "%," + color[3] : "rgba(" + color.join(",")) + ")";
					}
					return parsed + s.substr(charIndex);
				},
				_colorExp = "(?:\\b(?:(?:rgb|rgba|hsl|hsla)\\(.+?\\))|\\B#(?:[0-9a-f]{3}){1,2}\\b"; //we'll dynamically build this Regular Expression to conserve file size. After building it, it will be able to find rgb(), rgba(), # (hexadecimal), and named color values like red, blue, purple, etc.
	
			for (p in _colorLookup) {
				_colorExp += "|" + p + "\\b";
			}
			_colorExp = new RegExp(_colorExp+")", "gi");
	
			CSSPlugin.colorStringFilter = function(a) {
				var combined = a[0] + " " + a[1],
					toHSL;
				if (_colorExp.test(combined)) {
					toHSL = (combined.indexOf("hsl(") !== -1 || combined.indexOf("hsla(") !== -1);
					a[0] = _formatColors(a[0], toHSL);
					a[1] = _formatColors(a[1], toHSL);
				}
				_colorExp.lastIndex = 0;
			};
	
			if (!TweenLite.defaultStringFilter) {
				TweenLite.defaultStringFilter = CSSPlugin.colorStringFilter;
			}
	
			/**
			 * @private Returns a formatter function that handles taking a string (or number in some cases) and returning a consistently formatted one in terms of delimiters, quantity of values, etc. For example, we may get boxShadow values defined as "0px red" or "0px 0px 10px rgb(255,0,0)" or "0px 0px 20px 20px #F00" and we need to ensure that what we get back is described with 4 numbers and a color. This allows us to feed it into the _parseComplex() method and split the values up appropriately. The neat thing about this _getFormatter() function is that the dflt defines a pattern as well as a default, so for example, _getFormatter("0px 0px 0px 0px #777", true) not only sets the default as 0px for all distances and #777 for the color, but also sets the pattern such that 4 numbers and a color will always get returned.
			 * @param {!string} dflt The default value and pattern to follow. So "0px 0px 0px 0px #777" will ensure that 4 numbers and a color will always get returned.
			 * @param {boolean=} clr If true, the values should be searched for color-related data. For example, boxShadow values typically contain a color whereas borderRadius don't.
			 * @param {boolean=} collapsible If true, the value is a top/left/right/bottom style one that acts like margin or padding, where if only one value is received, it's used for all 4; if 2 are received, the first is duplicated for 3rd (bottom) and the 2nd is duplicated for the 4th spot (left), etc.
			 * @return {Function} formatter function
			 */
			var _getFormatter = function(dflt, clr, collapsible, multi) {
					if (dflt == null) {
						return function(v) {return v;};
					}
					var dColor = clr ? (dflt.match(_colorExp) || [""])[0] : "",
						dVals = dflt.split(dColor).join("").match(_valuesExp) || [],
						pfx = dflt.substr(0, dflt.indexOf(dVals[0])),
						sfx = (dflt.charAt(dflt.length - 1) === ")") ? ")" : "",
						delim = (dflt.indexOf(" ") !== -1) ? " " : ",",
						numVals = dVals.length,
						dSfx = (numVals > 0) ? dVals[0].replace(_numExp, "") : "",
						formatter;
					if (!numVals) {
						return function(v) {return v;};
					}
					if (clr) {
						formatter = function(v) {
							var color, vals, i, a;
							if (typeof(v) === "number") {
								v += dSfx;
							} else if (multi && _commasOutsideParenExp.test(v)) {
								a = v.replace(_commasOutsideParenExp, "|").split("|");
								for (i = 0; i < a.length; i++) {
									a[i] = formatter(a[i]);
								}
								return a.join(",");
							}
							color = (v.match(_colorExp) || [dColor])[0];
							vals = v.split(color).join("").match(_valuesExp) || [];
							i = vals.length;
							if (numVals > i--) {
								while (++i < numVals) {
									vals[i] = collapsible ? vals[(((i - 1) / 2) | 0)] : dVals[i];
								}
							}
							return pfx + vals.join(delim) + delim + color + sfx + (v.indexOf("inset") !== -1 ? " inset" : "");
						};
						return formatter;
	
					}
					formatter = function(v) {
						var vals, a, i;
						if (typeof(v) === "number") {
							v += dSfx;
						} else if (multi && _commasOutsideParenExp.test(v)) {
							a = v.replace(_commasOutsideParenExp, "|").split("|");
							for (i = 0; i < a.length; i++) {
								a[i] = formatter(a[i]);
							}
							return a.join(",");
						}
						vals = v.match(_valuesExp) || [];
						i = vals.length;
						if (numVals > i--) {
							while (++i < numVals) {
								vals[i] = collapsible ? vals[(((i - 1) / 2) | 0)] : dVals[i];
							}
						}
						return pfx + vals.join(delim) + sfx;
					};
					return formatter;
				},
	
				/**
				 * @private returns a formatter function that's used for edge-related values like marginTop, marginLeft, paddingBottom, paddingRight, etc. Just pass a comma-delimited list of property names related to the edges.
				 * @param {!string} props a comma-delimited list of property names in order from top to left, like "marginTop,marginRight,marginBottom,marginLeft"
				 * @return {Function} a formatter function
				 */
				_getEdgeParser = function(props) {
					props = props.split(",");
					return function(t, e, p, cssp, pt, plugin, vars) {
						var a = (e + "").split(" "),
							i;
						vars = {};
						for (i = 0; i < 4; i++) {
							vars[props[i]] = a[i] = a[i] || a[(((i - 1) / 2) >> 0)];
						}
						return cssp.parse(t, vars, pt, plugin);
					};
				},
	
				// @private used when other plugins must tween values first, like BezierPlugin or ThrowPropsPlugin, etc. That plugin's setRatio() gets called first so that the values are updated, and then we loop through the MiniPropTweens which handle copying the values into their appropriate slots so that they can then be applied correctly in the main CSSPlugin setRatio() method. Remember, we typically create a proxy object that has a bunch of uniquely-named properties that we feed to the sub-plugin and it does its magic normally, and then we must interpret those values and apply them to the css because often numbers must get combined/concatenated, suffixes added, etc. to work with css, like boxShadow could have 4 values plus a color.
				_setPluginRatio = _internals._setPluginRatio = function(v) {
					this.plugin.setRatio(v);
					var d = this.data,
						proxy = d.proxy,
						mpt = d.firstMPT,
						min = 0.000001,
						val, pt, i, str, p;
					while (mpt) {
						val = proxy[mpt.v];
						if (mpt.r) {
							val = mpt.r(val);
						} else if (val < min && val > -min) {
							val = 0;
						}
						mpt.t[mpt.p] = val;
						mpt = mpt._next;
					}
					if (d.autoRotate) {
						d.autoRotate.rotation = d.mod ? d.mod.call(this._tween, proxy.rotation, this.t, this._tween) : proxy.rotation; //special case for ModifyPlugin to hook into an auto-rotating bezier
					}
					//at the end, we must set the CSSPropTween's "e" (end) value dynamically here because that's what is used in the final setRatio() method. Same for "b" at the beginning.
					if (v === 1 || v === 0) {
						mpt = d.firstMPT;
						p = (v === 1) ? "e" : "b";
						while (mpt) {
							pt = mpt.t;
							if (!pt.type) {
								pt[p] = pt.s + pt.xs0;
							} else if (pt.type === 1) {
								str = pt.xs0 + pt.s + pt.xs1;
								for (i = 1; i < pt.l; i++) {
									str += pt["xn"+i] + pt["xs"+(i+1)];
								}
								pt[p] = str;
							}
							mpt = mpt._next;
						}
					}
				},
	
				/**
				 * @private @constructor Used by a few SpecialProps to hold important values for proxies. For example, _parseToProxy() creates a MiniPropTween instance for each property that must get tweened on the proxy, and we record the original property name as well as the unique one we create for the proxy, plus whether or not the value needs to be rounded plus the original value.
				 * @param {!Object} t target object whose property we're tweening (often a CSSPropTween)
				 * @param {!string} p property name
				 * @param {(number|string|object)} v value
				 * @param {MiniPropTween=} next next MiniPropTween in the linked list
				 * @param {boolean=} r if true, the tweened value should be rounded to the nearest integer
				 */
				MiniPropTween = function(t, p, v, next, r) {
					this.t = t;
					this.p = p;
					this.v = v;
					this.r = r;
					if (next) {
						next._prev = this;
						this._next = next;
					}
				},
	
				/**
				 * @private Most other plugins (like BezierPlugin and ThrowPropsPlugin and others) can only tween numeric values, but CSSPlugin must accommodate special values that have a bunch of extra data (like a suffix or strings between numeric values, etc.). For example, boxShadow has values like "10px 10px 20px 30px rgb(255,0,0)" which would utterly confuse other plugins. This method allows us to split that data apart and grab only the numeric data and attach it to uniquely-named properties of a generic proxy object ({}) so that we can feed that to virtually any plugin to have the numbers tweened. However, we must also keep track of which properties from the proxy go with which CSSPropTween values and instances. So we create a linked list of MiniPropTweens. Each one records a target (the original CSSPropTween), property (like "s" or "xn1" or "xn2") that we're tweening and the unique property name that was used for the proxy (like "boxShadow_xn1" and "boxShadow_xn2") and whether or not they need to be rounded. That way, in the _setPluginRatio() method we can simply copy the values over from the proxy to the CSSPropTween instance(s). Then, when the main CSSPlugin setRatio() method runs and applies the CSSPropTween values accordingly, they're updated nicely. So the external plugin tweens the numbers, _setPluginRatio() copies them over, and setRatio() acts normally, applying css-specific values to the element.
				 * This method returns an object that has the following properties:
				 *  - proxy: a generic object containing the starting values for all the properties that will be tweened by the external plugin.  This is what we feed to the external _onInitTween() as the target
				 *  - end: a generic object containing the ending values for all the properties that will be tweened by the external plugin. This is what we feed to the external plugin's _onInitTween() as the destination values
				 *  - firstMPT: the first MiniPropTween in the linked list
				 *  - pt: the first CSSPropTween in the linked list that was created when parsing. If shallow is true, this linked list will NOT attach to the one passed into the _parseToProxy() as the "pt" (4th) parameter.
				 * @param {!Object} t target object to be tweened
				 * @param {!(Object|string)} vars the object containing the information about the tweening values (typically the end/destination values) that should be parsed
				 * @param {!CSSPlugin} cssp The CSSPlugin instance
				 * @param {CSSPropTween=} pt the next CSSPropTween in the linked list
				 * @param {TweenPlugin=} plugin the external TweenPlugin instance that will be handling tweening the numeric values
				 * @param {boolean=} shallow if true, the resulting linked list from the parse will NOT be attached to the CSSPropTween that was passed in as the "pt" (4th) parameter.
				 * @return An object containing the following properties: proxy, end, firstMPT, and pt (see above for descriptions)
				 */
				_parseToProxy = _internals._parseToProxy = function(t, vars, cssp, pt, plugin, shallow) {
					var bpt = pt,
						start = {},
						end = {},
						transform = cssp._transform,
						oldForce = _forcePT,
						i, p, xp, mpt, firstPT;
					cssp._transform = null;
					_forcePT = vars;
					pt = firstPT = cssp.parse(t, vars, pt, plugin);
					_forcePT = oldForce;
					//break off from the linked list so the new ones are isolated.
					if (shallow) {
						cssp._transform = transform;
						if (bpt) {
							bpt._prev = null;
							if (bpt._prev) {
								bpt._prev._next = null;
							}
						}
					}
					while (pt && pt !== bpt) {
						if (pt.type <= 1) {
							p = pt.p;
							end[p] = pt.s + pt.c;
							start[p] = pt.s;
							if (!shallow) {
								mpt = new MiniPropTween(pt, "s", p, mpt, pt.r);
								pt.c = 0;
							}
							if (pt.type === 1) {
								i = pt.l;
								while (--i > 0) {
									xp = "xn" + i;
									p = pt.p + "_" + xp;
									end[p] = pt.data[xp];
									start[p] = pt[xp];
									if (!shallow) {
										mpt = new MiniPropTween(pt, xp, p, mpt, pt.rxp[xp]);
									}
								}
							}
						}
						pt = pt._next;
					}
					return {proxy:start, end:end, firstMPT:mpt, pt:firstPT};
				},
	
	
	
				/**
				 * @constructor Each property that is tweened has at least one CSSPropTween associated with it. These instances store important information like the target, property, starting value, amount of change, etc. They can also optionally have a number of "extra" strings and numeric values named xs1, xn1, xs2, xn2, xs3, xn3, etc. where "s" indicates string and "n" indicates number. These can be pieced together in a complex-value tween (type:1) that has alternating types of data like a string, number, string, number, etc. For example, boxShadow could be "5px 5px 8px rgb(102, 102, 51)". In that value, there are 6 numbers that may need to tween and then pieced back together into a string again with spaces, suffixes, etc. xs0 is special in that it stores the suffix for standard (type:0) tweens, -OR- the first string (prefix) in a complex-value (type:1) CSSPropTween -OR- it can be the non-tweening value in a type:-1 CSSPropTween. We do this to conserve memory.
				 * CSSPropTweens have the following optional properties as well (not defined through the constructor):
				 *  - l: Length in terms of the number of extra properties that the CSSPropTween has (default: 0). For example, for a boxShadow we may need to tween 5 numbers in which case l would be 5; Keep in mind that the start/end values for the first number that's tweened are always stored in the s and c properties to conserve memory. All additional values thereafter are stored in xn1, xn2, etc.
				 *  - xfirst: The first instance of any sub-CSSPropTweens that are tweening properties of this instance. For example, we may split up a boxShadow tween so that there's a main CSSPropTween of type:1 that has various xs* and xn* values associated with the h-shadow, v-shadow, blur, color, etc. Then we spawn a CSSPropTween for each of those that has a higher priority and runs BEFORE the main CSSPropTween so that the values are all set by the time it needs to re-assemble them. The xfirst gives us an easy way to identify the first one in that chain which typically ends at the main one (because they're all prepende to the linked list)
				 *  - plugin: The TweenPlugin instance that will handle the tweening of any complex values. For example, sometimes we don't want to use normal subtweens (like xfirst refers to) to tween the values - we might want ThrowPropsPlugin or BezierPlugin some other plugin to do the actual tweening, so we create a plugin instance and store a reference here. We need this reference so that if we get a request to round values or disable a tween, we can pass along that request.
				 *  - data: Arbitrary data that needs to be stored with the CSSPropTween. Typically if we're going to have a plugin handle the tweening of a complex-value tween, we create a generic object that stores the END values that we're tweening to and the CSSPropTween's xs1, xs2, etc. have the starting values. We store that object as data. That way, we can simply pass that object to the plugin and use the CSSPropTween as the target.
				 *  - setRatio: Only used for type:2 tweens that require custom functionality. In this case, we call the CSSPropTween's setRatio() method and pass the ratio each time the tween updates. This isn't quite as efficient as doing things directly in the CSSPlugin's setRatio() method, but it's very convenient and flexible.
				 * @param {!Object} t Target object whose property will be tweened. Often a DOM element, but not always. It could be anything.
				 * @param {string} p Property to tween (name). For example, to tween element.width, p would be "width".
				 * @param {number} s Starting numeric value
				 * @param {number} c Change in numeric value over the course of the entire tween. For example, if element.width starts at 5 and should end at 100, c would be 95.
				 * @param {CSSPropTween=} next The next CSSPropTween in the linked list. If one is defined, we will define its _prev as the new instance, and the new instance's _next will be pointed at it.
				 * @param {number=} type The type of CSSPropTween where -1 = a non-tweening value, 0 = a standard simple tween, 1 = a complex value (like one that has multiple numbers in a comma- or space-delimited string like border:"1px solid red"), and 2 = one that uses a custom setRatio function that does all of the work of applying the values on each update.
				 * @param {string=} n Name of the property that should be used for overwriting purposes which is typically the same as p but not always. For example, we may need to create a subtween for the 2nd part of a "clip:rect(...)" tween in which case "p" might be xs1 but "n" is still "clip"
				 * @param {boolean=} r If true, the value(s) should be rounded
				 * @param {number=} pr Priority in the linked list order. Higher priority CSSPropTweens will be updated before lower priority ones. The default priority is 0.
				 * @param {string=} b Beginning value. We store this to ensure that it is EXACTLY what it was when the tween began without any risk of interpretation issues.
				 * @param {string=} e Ending value. We store this to ensure that it is EXACTLY what the user defined at the end of the tween without any risk of interpretation issues.
				 */
				CSSPropTween = _internals.CSSPropTween = function(t, p, s, c, next, type, n, r, pr, b, e) {
					this.t = t; //target
					this.p = p; //property
					this.s = s; //starting value
					this.c = c; //change value
					this.n = n || p; //name that this CSSPropTween should be associated to (usually the same as p, but not always - n is what overwriting looks at)
					if (!(t instanceof CSSPropTween)) {
						_overwriteProps.push(this.n);
					}
					this.r = !r ? r : (typeof(r) === "function") ? r : Math.round; //round (boolean)
					this.type = type || 0; //0 = normal tween, -1 = non-tweening (in which case xs0 will be applied to the target's property, like tp.t[tp.p] = tp.xs0), 1 = complex-value SpecialProp, 2 = custom setRatio() that does all the work
					if (pr) {
						this.pr = pr;
						_hasPriority = true;
					}
					this.b = (b === undefined) ? s : b;
					this.e = (e === undefined) ? s + c : e;
					if (next) {
						this._next = next;
						next._prev = this;
					}
				},
	
				_addNonTweeningNumericPT = function(target, prop, start, end, next, overwriteProp) { //cleans up some code redundancies and helps minification. Just a fast way to add a NUMERIC non-tweening CSSPropTween
					var pt = new CSSPropTween(target, prop, start, end - start, next, -1, overwriteProp);
					pt.b = start;
					pt.e = pt.xs0 = end;
					return pt;
				},
	
				/**
				 * Takes a target, the beginning value and ending value (as strings) and parses them into a CSSPropTween (possibly with child CSSPropTweens) that accommodates multiple numbers, colors, comma-delimited values, etc. For example:
				 * sp.parseComplex(element, "boxShadow", "5px 10px 20px rgb(255,102,51)", "0px 0px 0px red", true, "0px 0px 0px rgb(0,0,0,0)", pt);
				 * It will walk through the beginning and ending values (which should be in the same format with the same number and type of values) and figure out which parts are numbers, what strings separate the numeric/tweenable values, and then create the CSSPropTweens accordingly. If a plugin is defined, no child CSSPropTweens will be created. Instead, the ending values will be stored in the "data" property of the returned CSSPropTween like: {s:-5, xn1:-10, xn2:-20, xn3:255, xn4:0, xn5:0} so that it can be fed to any other plugin and it'll be plain numeric tweens but the recomposition of the complex value will be handled inside CSSPlugin's setRatio().
				 * If a setRatio is defined, the type of the CSSPropTween will be set to 2 and recomposition of the values will be the responsibility of that method.
				 *
				 * @param {!Object} t Target whose property will be tweened
				 * @param {!string} p Property that will be tweened (its name, like "left" or "backgroundColor" or "boxShadow")
				 * @param {string} b Beginning value
				 * @param {string} e Ending value
				 * @param {boolean} clrs If true, the value could contain a color value like "rgb(255,0,0)" or "#F00" or "red". The default is false, so no colors will be recognized (a performance optimization)
				 * @param {(string|number|Object)} dflt The default beginning value that should be used if no valid beginning value is defined or if the number of values inside the complex beginning and ending values don't match
				 * @param {?CSSPropTween} pt CSSPropTween instance that is the current head of the linked list (we'll prepend to this).
				 * @param {number=} pr Priority in the linked list order. Higher priority properties will be updated before lower priority ones. The default priority is 0.
				 * @param {TweenPlugin=} plugin If a plugin should handle the tweening of extra properties, pass the plugin instance here. If one is defined, then NO subtweens will be created for any extra properties (the properties will be created - just not additional CSSPropTween instances to tween them) because the plugin is expected to do so. However, the end values WILL be populated in the "data" property, like {s:100, xn1:50, xn2:300}
				 * @param {function(number)=} setRatio If values should be set in a custom function instead of being pieced together in a type:1 (complex-value) CSSPropTween, define that custom function here.
				 * @return {CSSPropTween} The first CSSPropTween in the linked list which includes the new one(s) added by the parseComplex() call.
				 */
				_parseComplex = CSSPlugin.parseComplex = function(t, p, b, e, clrs, dflt, pt, pr, plugin, setRatio) {
					//DEBUG: _log("parseComplex: "+p+", b: "+b+", e: "+e);
					b = b || dflt || "";
					if (typeof(e) === "function") {
						e = e(_index, _target);
					}
					pt = new CSSPropTween(t, p, 0, 0, pt, (setRatio ? 2 : 1), null, false, pr, b, e);
					e += ""; //ensures it's a string
					if (clrs && _colorExp.test(e + b)) { //if colors are found, normalize the formatting to rgba() or hsla().
						e = [b, e];
						CSSPlugin.colorStringFilter(e);
						b = e[0];
						e = e[1];
					}
					var ba = b.split(", ").join(",").split(" "), //beginning array
						ea = e.split(", ").join(",").split(" "), //ending array
						l = ba.length,
						autoRound = (_autoRound !== false),
						i, xi, ni, bv, ev, bnums, enums, bn, hasAlpha, temp, cv, str, useHSL;
					if (e.indexOf(",") !== -1 || b.indexOf(",") !== -1) {
						if ((e + b).indexOf("rgb") !== -1 || (e + b).indexOf("hsl") !== -1) { //keep rgb(), rgba(), hsl(), and hsla() values together! (remember, we're splitting on spaces)
							ba = ba.join(" ").replace(_commasOutsideParenExp, ", ").split(" ");
							ea = ea.join(" ").replace(_commasOutsideParenExp, ", ").split(" ");
						} else {
							ba = ba.join(" ").split(",").join(", ").split(" ");
							ea = ea.join(" ").split(",").join(", ").split(" ");
						}
						l = ba.length;
					}
					if (l !== ea.length) {
						//DEBUG: _log("mismatched formatting detected on " + p + " (" + b + " vs " + e + ")");
						ba = (dflt || "").split(" ");
						l = ba.length;
					}
					pt.plugin = plugin;
					pt.setRatio = setRatio;
					_colorExp.lastIndex = 0;
					for (i = 0; i < l; i++) {
						bv = ba[i];
						ev = ea[i] + "";
						bn = parseFloat(bv);
						//if the value begins with a number (most common). It's fine if it has a suffix like px
						if (bn || bn === 0) {
							pt.appendXtra("", bn, _parseChange(ev, bn), ev.replace(_relNumExp, ""), (autoRound && ev.indexOf("px") !== -1) ? Math.round : false, true);
	
						//if the value is a color
						} else if (clrs && _colorExp.test(bv)) {
							str = ev.indexOf(")") + 1;
							str = ")" + (str ? ev.substr(str) : ""); //if there's a comma or ) at the end, retain it.
							useHSL = (ev.indexOf("hsl") !== -1 && _supportsOpacity);
							temp = ev; //original string value so we can look for any prefix later.
							bv = _parseColor(bv, useHSL);
							ev = _parseColor(ev, useHSL);
							hasAlpha = (bv.length + ev.length > 6);
							if (hasAlpha && !_supportsOpacity && ev[3] === 0) { //older versions of IE don't support rgba(), so if the destination alpha is 0, just use "transparent" for the end color
								pt["xs" + pt.l] += pt.l ? " transparent" : "transparent";
								pt.e = pt.e.split(ea[i]).join("transparent");
							} else {
								if (!_supportsOpacity) { //old versions of IE don't support rgba().
									hasAlpha = false;
								}
								if (useHSL) {
									pt.appendXtra(temp.substr(0, temp.indexOf("hsl")) + (hasAlpha ? "hsla(" : "hsl("), bv[0], _parseChange(ev[0], bv[0]), ",", false, true)
										.appendXtra("", bv[1], _parseChange(ev[1], bv[1]), "%,", false)
										.appendXtra("", bv[2], _parseChange(ev[2], bv[2]), (hasAlpha ? "%," : "%" + str), false);
								} else {
									pt.appendXtra(temp.substr(0, temp.indexOf("rgb")) + (hasAlpha ? "rgba(" : "rgb("), bv[0], ev[0] - bv[0], ",", Math.round, true)
										.appendXtra("", bv[1], ev[1] - bv[1], ",", Math.round)
										.appendXtra("", bv[2], ev[2] - bv[2], (hasAlpha ? "," : str), Math.round);
								}
	
								if (hasAlpha) {
									bv = (bv.length < 4) ? 1 : bv[3];
									pt.appendXtra("", bv, ((ev.length < 4) ? 1 : ev[3]) - bv, str, false);
								}
							}
							_colorExp.lastIndex = 0; //otherwise the test() on the RegExp could move the lastIndex and taint future results.
	
						} else {
							bnums = bv.match(_numExp); //gets each group of numbers in the beginning value string and drops them into an array
	
							//if no number is found, treat it as a non-tweening value and just append the string to the current xs.
							if (!bnums) {
								pt["xs" + pt.l] += (pt.l || pt["xs" + pt.l]) ? " " + ev : ev;
	
							//loop through all the numbers that are found and construct the extra values on the pt.
							} else {
								enums = ev.match(_relNumExp); //get each group of numbers in the end value string and drop them into an array. We allow relative values too, like +=50 or -=.5
								if (!enums || enums.length !== bnums.length) {
									//DEBUG: _log("mismatched formatting detected on " + p + " (" + b + " vs " + e + ")");
									return pt;
								}
								ni = 0;
								for (xi = 0; xi < bnums.length; xi++) {
									cv = bnums[xi];
									temp = bv.indexOf(cv, ni);
									pt.appendXtra(bv.substr(ni, temp - ni), Number(cv), _parseChange(enums[xi], cv), "", (autoRound && bv.substr(temp + cv.length, 2) === "px") ? Math.round : false, (xi === 0));
									ni = temp + cv.length;
								}
								pt["xs" + pt.l] += bv.substr(ni);
							}
						}
					}
					//if there are relative values ("+=" or "-=" prefix), we need to adjust the ending value to eliminate the prefixes and combine the values properly.
					if (e.indexOf("=") !== -1) if (pt.data) {
						str = pt.xs0 + pt.data.s;
						for (i = 1; i < pt.l; i++) {
							str += pt["xs" + i] + pt.data["xn" + i];
						}
						pt.e = str + pt["xs" + i];
					}
					if (!pt.l) {
						pt.type = -1;
						pt.xs0 = pt.e;
					}
					return pt.xfirst || pt;
				},
				i = 9;
	
	
			p = CSSPropTween.prototype;
			p.l = p.pr = 0; //length (number of extra properties like xn1, xn2, xn3, etc.
			while (--i > 0) {
				p["xn" + i] = 0;
				p["xs" + i] = "";
			}
			p.xs0 = "";
			p._next = p._prev = p.xfirst = p.data = p.plugin = p.setRatio = p.rxp = null;
	
	
			/**
			 * Appends and extra tweening value to a CSSPropTween and automatically manages any prefix and suffix strings. The first extra value is stored in the s and c of the main CSSPropTween instance, but thereafter any extras are stored in the xn1, xn2, xn3, etc. The prefixes and suffixes are stored in the xs0, xs1, xs2, etc. properties. For example, if I walk through a clip value like "rect(10px, 5px, 0px, 20px)", the values would be stored like this:
			 * xs0:"rect(", s:10, xs1:"px, ", xn1:5, xs2:"px, ", xn2:0, xs3:"px, ", xn3:20, xn4:"px)"
			 * And they'd all get joined together when the CSSPlugin renders (in the setRatio() method).
			 * @param {string=} pfx Prefix (if any)
			 * @param {!number} s Starting value
			 * @param {!number} c Change in numeric value over the course of the entire tween. For example, if the start is 5 and the end is 100, the change would be 95.
			 * @param {string=} sfx Suffix (if any)
			 * @param {boolean=} r Round (if true).
			 * @param {boolean=} pad If true, this extra value should be separated by the previous one by a space. If there is no previous extra and pad is true, it will automatically drop the space.
			 * @return {CSSPropTween} returns itself so that multiple methods can be chained together.
			 */
			p.appendXtra = function(pfx, s, c, sfx, r, pad) {
				var pt = this,
					l = pt.l;
				pt["xs" + l] += (pad && (l || pt["xs" + l])) ? " " + pfx : pfx || "";
				if (!c) if (l !== 0 && !pt.plugin) { //typically we'll combine non-changing values right into the xs to optimize performance, but we don't combine them when there's a plugin that will be tweening the values because it may depend on the values being split apart, like for a bezier, if a value doesn't change between the first and second iteration but then it does on the 3rd, we'll run into trouble because there's no xn slot for that value!
					pt["xs" + l] += s + (sfx || "");
					return pt;
				}
				pt.l++;
				pt.type = pt.setRatio ? 2 : 1;
				pt["xs" + pt.l] = sfx || "";
				if (l > 0) {
					pt.data["xn" + l] = s + c;
					pt.rxp["xn" + l] = r; //round extra property (we need to tap into this in the _parseToProxy() method)
					pt["xn" + l] = s;
					if (!pt.plugin) {
						pt.xfirst = new CSSPropTween(pt, "xn" + l, s, c, pt.xfirst || pt, 0, pt.n, r, pt.pr);
						pt.xfirst.xs0 = 0; //just to ensure that the property stays numeric which helps modern browsers speed up processing. Remember, in the setRatio() method, we do pt.t[pt.p] = val + pt.xs0 so if pt.xs0 is "" (the default), it'll cast the end value as a string. When a property is a number sometimes and a string sometimes, it prevents the compiler from locking in the data type, slowing things down slightly.
					}
					return pt;
				}
				pt.data = {s:s + c};
				pt.rxp = {};
				pt.s = s;
				pt.c = c;
				pt.r = r;
				return pt;
			};
	
			/**
			 * @constructor A SpecialProp is basically a css property that needs to be treated in a non-standard way, like if it may contain a complex value like boxShadow:"5px 10px 15px rgb(255, 102, 51)" or if it is associated with another plugin like ThrowPropsPlugin or BezierPlugin. Every SpecialProp is associated with a particular property name like "boxShadow" or "throwProps" or "bezier" and it will intercept those values in the vars object that's passed to the CSSPlugin and handle them accordingly.
			 * @param {!string} p Property name (like "boxShadow" or "throwProps")
			 * @param {Object=} options An object containing any of the following configuration options:
			 *                      - defaultValue: the default value
			 *                      - parser: A function that should be called when the associated property name is found in the vars. This function should return a CSSPropTween instance and it should ensure that it is properly inserted into the linked list. It will receive 4 paramters: 1) The target, 2) The value defined in the vars, 3) The CSSPlugin instance (whose _firstPT should be used for the linked list), and 4) A computed style object if one was calculated (this is a speed optimization that allows retrieval of starting values quicker)
			 *                      - formatter: a function that formats any value received for this special property (for example, boxShadow could take "5px 5px red" and format it to "5px 5px 0px 0px red" so that both the beginning and ending values have a common order and quantity of values.)
			 *                      - prefix: if true, we'll determine whether or not this property requires a vendor prefix (like Webkit or Moz or ms or O)
			 *                      - color: set this to true if the value for this SpecialProp may contain color-related values like rgb(), rgba(), etc.
			 *                      - priority: priority in the linked list order. Higher priority SpecialProps will be updated before lower priority ones. The default priority is 0.
			 *                      - multi: if true, the formatter should accommodate a comma-delimited list of values, like boxShadow could have multiple boxShadows listed out.
			 *                      - collapsible: if true, the formatter should treat the value like it's a top/right/bottom/left value that could be collapsed, like "5px" would apply to all, "5px, 10px" would use 5px for top/bottom and 10px for right/left, etc.
			 *                      - keyword: a special keyword that can [optionally] be found inside the value (like "inset" for boxShadow). This allows us to validate beginning/ending values to make sure they match (if the keyword is found in one, it'll be added to the other for consistency by default).
			 */
			var SpecialProp = function(p, options) {
					options = options || {};
					this.p = options.prefix ? _checkPropPrefix(p) || p : p;
					_specialProps[p] = _specialProps[this.p] = this;
					this.format = options.formatter || _getFormatter(options.defaultValue, options.color, options.collapsible, options.multi);
					if (options.parser) {
						this.parse = options.parser;
					}
					this.clrs = options.color;
					this.multi = options.multi;
					this.keyword = options.keyword;
					this.dflt = options.defaultValue;
					this.pr = options.priority || 0;
				},
	
				//shortcut for creating a new SpecialProp that can accept multiple properties as a comma-delimited list (helps minification). dflt can be an array for multiple values (we don't do a comma-delimited list because the default value may contain commas, like rect(0px,0px,0px,0px)). We attach this method to the SpecialProp class/object instead of using a private _createSpecialProp() method so that we can tap into it externally if necessary, like from another plugin.
				_registerComplexSpecialProp = _internals._registerComplexSpecialProp = function(p, options, defaults) {
					if (typeof(options) !== "object") {
						options = {parser:defaults}; //to make backwards compatible with older versions of BezierPlugin and ThrowPropsPlugin
					}
					var a = p.split(","),
						d = options.defaultValue,
						i, temp;
					defaults = defaults || [d];
					for (i = 0; i < a.length; i++) {
						options.prefix = (i === 0 && options.prefix);
						options.defaultValue = defaults[i] || d;
						temp = new SpecialProp(a[i], options);
					}
				},
	
				//creates a placeholder special prop for a plugin so that the property gets caught the first time a tween of it is attempted, and at that time it makes the plugin register itself, thus taking over for all future tweens of that property. This allows us to not mandate that things load in a particular order and it also allows us to log() an error that informs the user when they attempt to tween an external plugin-related property without loading its .js file.
				_registerPluginProp = _internals._registerPluginProp = function(p) {
					if (!_specialProps[p]) {
						var pluginName = p.charAt(0).toUpperCase() + p.substr(1) + "Plugin";
						_registerComplexSpecialProp(p, {parser:function(t, e, p, cssp, pt, plugin, vars) {
							var pluginClass = _globals.com.greensock.plugins[pluginName];
							if (!pluginClass) {
								_log("Error: " + pluginName + " js file not loaded.");
								return pt;
							}
							pluginClass._cssRegister();
							return _specialProps[p].parse(t, e, p, cssp, pt, plugin, vars);
						}});
					}
				};
	
	
			p = SpecialProp.prototype;
	
			/**
			 * Alias for _parseComplex() that automatically plugs in certain values for this SpecialProp, like its property name, whether or not colors should be sensed, the default value, and priority. It also looks for any keyword that the SpecialProp defines (like "inset" for boxShadow) and ensures that the beginning and ending values have the same number of values for SpecialProps where multi is true (like boxShadow and textShadow can have a comma-delimited list)
			 * @param {!Object} t target element
			 * @param {(string|number|object)} b beginning value
			 * @param {(string|number|object)} e ending (destination) value
			 * @param {CSSPropTween=} pt next CSSPropTween in the linked list
			 * @param {TweenPlugin=} plugin If another plugin will be tweening the complex value, that TweenPlugin instance goes here.
			 * @param {function=} setRatio If a custom setRatio() method should be used to handle this complex value, that goes here.
			 * @return {CSSPropTween=} First CSSPropTween in the linked list
			 */
			p.parseComplex = function(t, b, e, pt, plugin, setRatio) {
				var kwd = this.keyword,
					i, ba, ea, l, bi, ei;
				//if this SpecialProp's value can contain a comma-delimited list of values (like boxShadow or textShadow), we must parse them in a special way, and look for a keyword (like "inset" for boxShadow) and ensure that the beginning and ending BOTH have it if the end defines it as such. We also must ensure that there are an equal number of values specified (we can't tween 1 boxShadow to 3 for example)
				if (this.multi) if (_commasOutsideParenExp.test(e) || _commasOutsideParenExp.test(b)) {
					ba = b.replace(_commasOutsideParenExp, "|").split("|");
					ea = e.replace(_commasOutsideParenExp, "|").split("|");
				} else if (kwd) {
					ba = [b];
					ea = [e];
				}
				if (ea) {
					l = (ea.length > ba.length) ? ea.length : ba.length;
					for (i = 0; i < l; i++) {
						b = ba[i] = ba[i] || this.dflt;
						e = ea[i] = ea[i] || this.dflt;
						if (kwd) {
							bi = b.indexOf(kwd);
							ei = e.indexOf(kwd);
							if (bi !== ei) {
								if (ei === -1) { //if the keyword isn't in the end value, remove it from the beginning one.
									ba[i] = ba[i].split(kwd).join("");
								} else if (bi === -1) { //if the keyword isn't in the beginning, add it.
									ba[i] += " " + kwd;
								}
							}
						}
					}
					b = ba.join(", ");
					e = ea.join(", ");
				}
				return _parseComplex(t, this.p, b, e, this.clrs, this.dflt, pt, this.pr, plugin, setRatio);
			};
	
			/**
			 * Accepts a target and end value and spits back a CSSPropTween that has been inserted into the CSSPlugin's linked list and conforms with all the conventions we use internally, like type:-1, 0, 1, or 2, setting up any extra property tweens, priority, etc. For example, if we have a boxShadow SpecialProp and call:
			 * this._firstPT = sp.parse(element, "5px 10px 20px rgb(2550,102,51)", "boxShadow", this);
			 * It should figure out the starting value of the element's boxShadow, compare it to the provided end value and create all the necessary CSSPropTweens of the appropriate types to tween the boxShadow. The CSSPropTween that gets spit back should already be inserted into the linked list (the 4th parameter is the current head, so prepend to that).
			 * @param {!Object} t Target object whose property is being tweened
			 * @param {Object} e End value as provided in the vars object (typically a string, but not always - like a throwProps would be an object).
			 * @param {!string} p Property name
			 * @param {!CSSPlugin} cssp The CSSPlugin instance that should be associated with this tween.
			 * @param {?CSSPropTween} pt The CSSPropTween that is the current head of the linked list (we'll prepend to it)
			 * @param {TweenPlugin=} plugin If a plugin will be used to tween the parsed value, this is the plugin instance.
			 * @param {Object=} vars Original vars object that contains the data for parsing.
			 * @return {CSSPropTween} The first CSSPropTween in the linked list which includes the new one(s) added by the parse() call.
			 */
			p.parse = function(t, e, p, cssp, pt, plugin, vars) {
				return this.parseComplex(t.style, this.format(_getStyle(t, this.p, _cs, false, this.dflt)), this.format(e), pt, plugin);
			};
	
			/**
			 * Registers a special property that should be intercepted from any "css" objects defined in tweens. This allows you to handle them however you want without CSSPlugin doing it for you. The 2nd parameter should be a function that accepts 3 parameters:
			 *  1) Target object whose property should be tweened (typically a DOM element)
			 *  2) The end/destination value (could be a string, number, object, or whatever you want)
			 *  3) The tween instance (you probably don't need to worry about this, but it can be useful for looking up information like the duration)
			 *
			 * Then, your function should return a function which will be called each time the tween gets rendered, passing a numeric "ratio" parameter to your function that indicates the change factor (usually between 0 and 1). For example:
			 *
			 * CSSPlugin.registerSpecialProp("myCustomProp", function(target, value, tween) {
			 *      var start = target.style.width;
			 *      return function(ratio) {
			 *              target.style.width = (start + value * ratio) + "px";
			 *              console.log("set width to " + target.style.width);
			 *          }
			 * }, 0);
			 *
			 * Then, when I do this tween, it will trigger my special property:
			 *
			 * TweenLite.to(element, 1, {css:{myCustomProp:100}});
			 *
			 * In the example, of course, we're just changing the width, but you can do anything you want.
			 *
			 * @param {!string} name Property name (or comma-delimited list of property names) that should be intercepted and handled by your function. For example, if I define "myCustomProp", then it would handle that portion of the following tween: TweenLite.to(element, 1, {css:{myCustomProp:100}})
			 * @param {!function(Object, Object, Object, string):function(number)} onInitTween The function that will be called when a tween of this special property is performed. The function will receive 4 parameters: 1) Target object that should be tweened, 2) Value that was passed to the tween, 3) The tween instance itself (rarely used), and 4) The property name that's being tweened. Your function should return a function that should be called on every update of the tween. That function will receive a single parameter that is a "change factor" value (typically between 0 and 1) indicating the amount of change as a ratio. You can use this to determine how to set the values appropriately in your function.
			 * @param {number=} priority Priority that helps the engine determine the order in which to set the properties (default: 0). Higher priority properties will be updated before lower priority ones.
			 */
			CSSPlugin.registerSpecialProp = function(name, onInitTween, priority) {
				_registerComplexSpecialProp(name, {parser:function(t, e, p, cssp, pt, plugin, vars) {
					var rv = new CSSPropTween(t, p, 0, 0, pt, 2, p, false, priority);
					rv.plugin = plugin;
					rv.setRatio = onInitTween(t, e, cssp._tween, p);
					return rv;
				}, priority:priority});
			};
	
	
	
	
	
	
			//transform-related methods and properties
			CSSPlugin.useSVGTransformAttr = true; //Safari and Firefox both have some rendering bugs when applying CSS transforms to SVG elements, so default to using the "transform" attribute instead (users can override this).
			var _transformProps = ("scaleX,scaleY,scaleZ,x,y,z,skewX,skewY,rotation,rotationX,rotationY,perspective,xPercent,yPercent").split(","),
				_transformProp = _checkPropPrefix("transform"), //the Javascript (camelCase) transform property, like msTransform, WebkitTransform, MozTransform, or OTransform.
				_transformPropCSS = _prefixCSS + "transform",
				_transformOriginProp = _checkPropPrefix("transformOrigin"),
				_supports3D = (_checkPropPrefix("perspective") !== null),
				Transform = _internals.Transform = function() {
					this.perspective = parseFloat(CSSPlugin.defaultTransformPerspective) || 0;
					this.force3D = (CSSPlugin.defaultForce3D === false || !_supports3D) ? false : CSSPlugin.defaultForce3D || "auto";
				},
				_SVGElement = _gsScope.SVGElement,
				_useSVGTransformAttr,
				//Some browsers (like Firefox and IE) don't honor transform-origin properly in SVG elements, so we need to manually adjust the matrix accordingly. We feature detect here rather than always doing the conversion for certain browsers because they may fix the problem at some point in the future.
	
				_createSVG = function(type, container, attributes) {
					var element = _doc.createElementNS("http://www.w3.org/2000/svg", type),
						reg = /([a-z])([A-Z])/g,
						p;
					for (p in attributes) {
						element.setAttributeNS(null, p.replace(reg, "$1-$2").toLowerCase(), attributes[p]);
					}
					container.appendChild(element);
					return element;
				},
				_docElement = _doc.documentElement || {},
				_forceSVGTransformAttr = (function() {
					//IE and Android stock don't support CSS transforms on SVG elements, so we must write them to the "transform" attribute. We populate this variable in the _parseTransform() method, and only if/when we come across an SVG element
					var force = _ieVers || (/Android/i.test(_agent) && !_gsScope.chrome),
						svg, rect, width;
					if (_doc.createElementNS && !force) { //IE8 and earlier doesn't support SVG anyway
						svg = _createSVG("svg", _docElement);
						rect = _createSVG("rect", svg, {width:100, height:50, x:100});
						width = rect.getBoundingClientRect().width;
						rect.style[_transformOriginProp] = "50% 50%";
						rect.style[_transformProp] = "scaleX(0.5)";
						force = (width === rect.getBoundingClientRect().width && !(_isFirefox && _supports3D)); //note: Firefox fails the test even though it does support CSS transforms in 3D. Since we can't push 3D stuff into the transform attribute, we force Firefox to pass the test here (as long as it does truly support 3D).
						_docElement.removeChild(svg);
					}
					return force;
				})(),
				_parseSVGOrigin = function(e, local, decoratee, absolute, smoothOrigin, skipRecord) {
					var tm = e._gsTransform,
						m = _getMatrix(e, true),
						v, x, y, xOrigin, yOrigin, a, b, c, d, tx, ty, determinant, xOriginOld, yOriginOld;
					if (tm) {
						xOriginOld = tm.xOrigin; //record the original values before we alter them.
						yOriginOld = tm.yOrigin;
					}
					if (!absolute || (v = absolute.split(" ")).length < 2) {
						b = e.getBBox();
						if (b.x === 0 && b.y === 0 && b.width + b.height === 0) { //some browsers (like Firefox) misreport the bounds if the element has zero width and height (it just assumes it's at x:0, y:0), thus we need to manually grab the position in that case.
							b = {x: parseFloat(e.hasAttribute("x") ? e.getAttribute("x") : e.hasAttribute("cx") ? e.getAttribute("cx") : 0) || 0, y: parseFloat(e.hasAttribute("y") ? e.getAttribute("y") : e.hasAttribute("cy") ? e.getAttribute("cy") : 0) || 0, width:0, height:0};
						}
						local = _parsePosition(local).split(" ");
						v = [(local[0].indexOf("%") !== -1 ? parseFloat(local[0]) / 100 * b.width : parseFloat(local[0])) + b.x,
							 (local[1].indexOf("%") !== -1 ? parseFloat(local[1]) / 100 * b.height : parseFloat(local[1])) + b.y];
					}
					decoratee.xOrigin = xOrigin = parseFloat(v[0]);
					decoratee.yOrigin = yOrigin = parseFloat(v[1]);
					if (absolute && m !== _identity2DMatrix) { //if svgOrigin is being set, we must invert the matrix and determine where the absolute point is, factoring in the current transforms. Otherwise, the svgOrigin would be based on the element's non-transformed position on the canvas.
						a = m[0];
						b = m[1];
						c = m[2];
						d = m[3];
						tx = m[4];
						ty = m[5];
						determinant = (a * d - b * c);
						if (determinant) { //if it's zero (like if scaleX and scaleY are zero), skip it to avoid errors with dividing by zero.
							x = xOrigin * (d / determinant) + yOrigin * (-c / determinant) + ((c * ty - d * tx) / determinant);
							y = xOrigin * (-b / determinant) + yOrigin * (a / determinant) - ((a * ty - b * tx) / determinant);
							xOrigin = decoratee.xOrigin = v[0] = x;
							yOrigin = decoratee.yOrigin = v[1] = y;
						}
					}
					if (tm) { //avoid jump when transformOrigin is changed - adjust the x/y values accordingly
						if (skipRecord) {
							decoratee.xOffset = tm.xOffset;
							decoratee.yOffset = tm.yOffset;
							tm = decoratee;
						}
						if (smoothOrigin || (smoothOrigin !== false && CSSPlugin.defaultSmoothOrigin !== false)) {
							x = xOrigin - xOriginOld;
							y = yOrigin - yOriginOld;
							//originally, we simply adjusted the x and y values, but that would cause problems if, for example, you created a rotational tween part-way through an x/y tween. Managing the offset in a separate variable gives us ultimate flexibility.
							//tm.x -= x - (x * m[0] + y * m[2]);
							//tm.y -= y - (x * m[1] + y * m[3]);
							tm.xOffset += (x * m[0] + y * m[2]) - x;
							tm.yOffset += (x * m[1] + y * m[3]) - y;
						} else {
							tm.xOffset = tm.yOffset = 0;
						}
					}
					if (!skipRecord) {
						e.setAttribute("data-svg-origin", v.join(" "));
					}
				},
				_getBBoxHack = function(swapIfPossible) { //works around issues in some browsers (like Firefox) that don't correctly report getBBox() on SVG elements inside a <defs> element and/or <mask>. We try creating an SVG, adding it to the documentElement and toss the element in there so that it's definitely part of the rendering tree, then grab the bbox and if it works, we actually swap out the original getBBox() method for our own that does these extra steps whenever getBBox is needed. This helps ensure that performance is optimal (only do all these extra steps when absolutely necessary...most elements don't need it).
					var svg = _createElement("svg", (this.ownerSVGElement && this.ownerSVGElement.getAttribute("xmlns")) || "http://www.w3.org/2000/svg"),
						oldParent = this.parentNode,
						oldSibling = this.nextSibling,
						oldCSS = this.style.cssText,
						bbox;
					_docElement.appendChild(svg);
					svg.appendChild(this);
					this.style.display = "block";
					if (swapIfPossible) {
						try {
							bbox = this.getBBox();
							this._originalGetBBox = this.getBBox;
							this.getBBox = _getBBoxHack;
						} catch (e) { }
					} else if (this._originalGetBBox) {
						bbox = this._originalGetBBox();
					}
					if (oldSibling) {
						oldParent.insertBefore(this, oldSibling);
					} else {
						oldParent.appendChild(this);
					}
					_docElement.removeChild(svg);
					this.style.cssText = oldCSS;
					return bbox;
				},
				_getBBox = function(e) {
					try {
						return e.getBBox(); //Firefox throws errors if you try calling getBBox() on an SVG element that's not rendered (like in a <symbol> or <defs>). https://bugzilla.mozilla.org/show_bug.cgi?id=612118
					} catch (error) {
						return _getBBoxHack.call(e, true);
					}
				},
				_isSVG = function(e) { //reports if the element is an SVG on which getBBox() actually works
					return !!(_SVGElement && e.getCTM && (!e.parentNode || e.ownerSVGElement) && _getBBox(e));
				},
				_identity2DMatrix = [1,0,0,1,0,0],
				_getMatrix = function(e, force2D) {
					var tm = e._gsTransform || new Transform(),
						rnd = 100000,
						style = e.style,
						isDefault, s, m, n, dec, none;
					if (_transformProp) {
						s = _getStyle(e, _transformPropCSS, null, true);
					} else if (e.currentStyle) {
						//for older versions of IE, we need to interpret the filter portion that is in the format: progid:DXImageTransform.Microsoft.Matrix(M11=6.123233995736766e-17, M12=-1, M21=1, M22=6.123233995736766e-17, sizingMethod='auto expand') Notice that we need to swap b and c compared to a normal matrix.
						s = e.currentStyle.filter.match(_ieGetMatrixExp);
						s = (s && s.length === 4) ? [s[0].substr(4), Number(s[2].substr(4)), Number(s[1].substr(4)), s[3].substr(4), (tm.x || 0), (tm.y || 0)].join(",") : "";
					}
					isDefault = (!s || s === "none" || s === "matrix(1, 0, 0, 1, 0, 0)");
					if (_transformProp && ((none = (!_getComputedStyle(e) || _getComputedStyle(e).display === "none")) || !e.parentNode)) { //note: Firefox returns null for getComputedStyle() if the element is in an iframe that has display:none. https://bugzilla.mozilla.org/show_bug.cgi?id=548397
						if (none) { //browsers don't report transforms accurately unless the element is in the DOM and has a display value that's not "none". Firefox and Microsoft browsers have a partial bug where they'll report transforms even if display:none BUT not any percentage-based values like translate(-50%, 8px) will be reported as if it's translate(0, 8px).
							n = style.display;
							style.display = "block";
						}
						if (!e.parentNode) {
							dec = 1; //flag
							_docElement.appendChild(e);
						}
						s = _getStyle(e, _transformPropCSS, null, true);
						isDefault = (!s || s === "none" || s === "matrix(1, 0, 0, 1, 0, 0)");
						if (n) {
							style.display = n;
						} else if (none) {
							_removeProp(style, "display");
						}
						if (dec) {
							_docElement.removeChild(e);
						}
					}
					if (tm.svg || (e.getCTM && _isSVG(e))) {
						if (isDefault && (style[_transformProp] + "").indexOf("matrix") !== -1) { //some browsers (like Chrome 40) don't correctly report transforms that are applied inline on an SVG element (they don't get included in the computed style), so we double-check here and accept matrix values
							s = style[_transformProp];
							isDefault = 0;
						}
						m = e.getAttribute("transform");
						if (isDefault && m) {
							m = e.transform.baseVal.consolidate().matrix; //ensures that even complex values like "translate(50,60) rotate(135,0,0)" are parsed because it mashes it into a matrix.
							s = "matrix(" + m.a + "," + m.b + "," + m.c + "," + m.d + "," + m.e + "," + m.f + ")";
							isDefault = 0;
						}
					}
					if (isDefault) {
						return _identity2DMatrix;
					}
					//split the matrix values out into an array (m for matrix)
					m = (s || "").match(_numExp) || [];
					i = m.length;
					while (--i > -1) {
						n = Number(m[i]);
						m[i] = (dec = n - (n |= 0)) ? ((dec * rnd + (dec < 0 ? -0.5 : 0.5)) | 0) / rnd + n : n; //convert strings to Numbers and round to 5 decimal places to avoid issues with tiny numbers. Roughly 20x faster than Number.toFixed(). We also must make sure to round before dividing so that values like 0.9999999999 become 1 to avoid glitches in browser rendering and interpretation of flipped/rotated 3D matrices. And don't just multiply the number by rnd, floor it, and then divide by rnd because the bitwise operations max out at a 32-bit signed integer, thus it could get clipped at a relatively low value (like 22,000.00000 for example).
					}
					return (force2D && m.length > 6) ? [m[0], m[1], m[4], m[5], m[12], m[13]] : m;
				},
	
				/**
				 * Parses the transform values for an element, returning an object with x, y, z, scaleX, scaleY, scaleZ, rotation, rotationX, rotationY, skewX, and skewY properties. Note: by default (for performance reasons), all skewing is combined into skewX and rotation but skewY still has a place in the transform object so that we can record how much of the skew is attributed to skewX vs skewY. Remember, a skewY of 10 looks the same as a rotation of 10 and skewX of -10.
				 * @param {!Object} t target element
				 * @param {Object=} cs computed style object (optional)
				 * @param {boolean=} rec if true, the transform values will be recorded to the target element's _gsTransform object, like target._gsTransform = {x:0, y:0, z:0, scaleX:1...}
				 * @param {boolean=} parse if true, we'll ignore any _gsTransform values that already exist on the element, and force a reparsing of the css (calculated style)
				 * @return {object} object containing all of the transform properties/values like {x:0, y:0, z:0, scaleX:1...}
				 */
				_getTransform = _internals.getTransform = function(t, cs, rec, parse) {
					if (t._gsTransform && rec && !parse) {
						return t._gsTransform; //if the element already has a _gsTransform, use that. Note: some browsers don't accurately return the calculated style for the transform (particularly for SVG), so it's almost always safest to just use the values we've already applied rather than re-parsing things.
					}
					var tm = rec ? t._gsTransform || new Transform() : new Transform(),
						invX = (tm.scaleX < 0), //in order to interpret things properly, we need to know if the user applied a negative scaleX previously so that we can adjust the rotation and skewX accordingly. Otherwise, if we always interpret a flipped matrix as affecting scaleY and the user only wants to tween the scaleX on multiple sequential tweens, it would keep the negative scaleY without that being the user's intent.
						min = 0.00002,
						rnd = 100000,
						zOrigin = _supports3D ? parseFloat(_getStyle(t, _transformOriginProp, cs, false, "0 0 0").split(" ")[2]) || tm.zOrigin  || 0 : 0,
						defaultTransformPerspective = parseFloat(CSSPlugin.defaultTransformPerspective) || 0,
						m, i, scaleX, scaleY, rotation, skewX;
	
					tm.svg = !!(t.getCTM && _isSVG(t));
					if (tm.svg) {
						_parseSVGOrigin(t, _getStyle(t, _transformOriginProp, cs, false, "50% 50%") + "", tm, t.getAttribute("data-svg-origin"));
						_useSVGTransformAttr = CSSPlugin.useSVGTransformAttr || _forceSVGTransformAttr;
					}
					m = _getMatrix(t);
					if (m !== _identity2DMatrix) {
	
						if (m.length === 16) {
							//we'll only look at these position-related 6 variables first because if x/y/z all match, it's relatively safe to assume we don't need to re-parse everything which risks losing important rotational information (like rotationX:180 plus rotationY:180 would look the same as rotation:180 - there's no way to know for sure which direction was taken based solely on the matrix3d() values)
							var a11 = m[0], a21 = m[1], a31 = m[2], a41 = m[3],
								a12 = m[4], a22 = m[5], a32 = m[6], a42 = m[7],
								a13 = m[8], a23 = m[9], a33 = m[10],
								a14 = m[12], a24 = m[13], a34 = m[14],
								a43 = m[11],
								angle = Math.atan2(a32, a33),
								t1, t2, t3, t4, cos, sin;
							//we manually compensate for non-zero z component of transformOrigin to work around bugs in Safari
							if (tm.zOrigin) {
								a34 = -tm.zOrigin;
								a14 = a13*a34-m[12];
								a24 = a23*a34-m[13];
								a34 = a33*a34+tm.zOrigin-m[14];
							}
							//note for possible future consolidation: rotationX: Math.atan2(a32, a33), rotationY: Math.atan2(-a31, Math.sqrt(a33 * a33 + a32 * a32)), rotation: Math.atan2(a21, a11), skew: Math.atan2(a12, a22). However, it doesn't seem to be quite as reliable as the full-on backwards rotation procedure.
							tm.rotationX = angle * _RAD2DEG;
							//rotationX
							if (angle) {
								cos = Math.cos(-angle);
								sin = Math.sin(-angle);
								t1 = a12*cos+a13*sin;
								t2 = a22*cos+a23*sin;
								t3 = a32*cos+a33*sin;
								a13 = a12*-sin+a13*cos;
								a23 = a22*-sin+a23*cos;
								a33 = a32*-sin+a33*cos;
								a43 = a42*-sin+a43*cos;
								a12 = t1;
								a22 = t2;
								a32 = t3;
							}
							//rotationY
							angle = Math.atan2(-a31, a33);
							tm.rotationY = angle * _RAD2DEG;
							if (angle) {
								cos = Math.cos(-angle);
								sin = Math.sin(-angle);
								t1 = a11*cos-a13*sin;
								t2 = a21*cos-a23*sin;
								t3 = a31*cos-a33*sin;
								a23 = a21*sin+a23*cos;
								a33 = a31*sin+a33*cos;
								a43 = a41*sin+a43*cos;
								a11 = t1;
								a21 = t2;
								a31 = t3;
							}
							//rotationZ
							angle = Math.atan2(a21, a11);
							tm.rotation = angle * _RAD2DEG;
							if (angle) {
								cos = Math.cos(angle);
								sin = Math.sin(angle);
								t1 = a11*cos+a21*sin;
								t2 = a12*cos+a22*sin;
								t3 = a13*cos+a23*sin;
								a21 = a21*cos-a11*sin;
								a22 = a22*cos-a12*sin;
								a23 = a23*cos-a13*sin;
								a11 = t1;
								a12 = t2;
								a13 = t3;
							}
	
							if (tm.rotationX && Math.abs(tm.rotationX) + Math.abs(tm.rotation) > 359.9) { //when rotationY is set, it will often be parsed as 180 degrees different than it should be, and rotationX and rotation both being 180 (it looks the same), so we adjust for that here.
								tm.rotationX = tm.rotation = 0;
								tm.rotationY = 180 - tm.rotationY;
							}
	
							//skewX
							angle = Math.atan2(a12, a22);
	
							//scales
							tm.scaleX = ((Math.sqrt(a11 * a11 + a21 * a21 + a31 * a31) * rnd + 0.5) | 0) / rnd;
							tm.scaleY = ((Math.sqrt(a22 * a22 + a32 * a32) * rnd + 0.5) | 0) / rnd;
							tm.scaleZ = ((Math.sqrt(a13 * a13 + a23 * a23 + a33 * a33) * rnd + 0.5) | 0) / rnd;
							a11 /= tm.scaleX;
							a12 /= tm.scaleY;
							a21 /= tm.scaleX;
							a22 /= tm.scaleY;
							if (Math.abs(angle) > min) {
								tm.skewX = angle * _RAD2DEG;
								a12 = 0; //unskews
								if (tm.skewType !== "simple") {
									tm.scaleY *= 1 / Math.cos(angle); //by default, we compensate the scale based on the skew so that the element maintains a similar proportion when skewed, so we have to alter the scaleY here accordingly to match the default (non-adjusted) skewing that CSS does (stretching more and more as it skews).
								}
	
							} else {
								tm.skewX = 0;
							}
	
							/* //for testing purposes
							var transform = "matrix3d(",
								comma = ",",
								zero = "0";
							a13 /= tm.scaleZ;
							a23 /= tm.scaleZ;
							a31 /= tm.scaleX;
							a32 /= tm.scaleY;
							a33 /= tm.scaleZ;
							transform += ((a11 < min && a11 > -min) ? zero : a11) + comma + ((a21 < min && a21 > -min) ? zero : a21) + comma + ((a31 < min && a31 > -min) ? zero : a31);
							transform += comma + ((a41 < min && a41 > -min) ? zero : a41) + comma + ((a12 < min && a12 > -min) ? zero : a12) + comma + ((a22 < min && a22 > -min) ? zero : a22);
							transform += comma + ((a32 < min && a32 > -min) ? zero : a32) + comma + ((a42 < min && a42 > -min) ? zero : a42) + comma + ((a13 < min && a13 > -min) ? zero : a13);
							transform += comma + ((a23 < min && a23 > -min) ? zero : a23) + comma + ((a33 < min && a33 > -min) ? zero : a33) + comma + ((a43 < min && a43 > -min) ? zero : a43) + comma;
							transform += a14 + comma + a24 + comma + a34 + comma + (tm.perspective ? (1 + (-a34 / tm.perspective)) : 1) + ")";
							console.log(transform);
							document.querySelector(".test").style[_transformProp] = transform;
							*/
	
							tm.perspective = a43 ? 1 / ((a43 < 0) ? -a43 : a43) : 0;
							tm.x = a14;
							tm.y = a24;
							tm.z = a34;
							if (tm.svg) {
								tm.x -= tm.xOrigin - (tm.xOrigin * a11 - tm.yOrigin * a12);
								tm.y -= tm.yOrigin - (tm.yOrigin * a21 - tm.xOrigin * a22);
							}
	
						} else if ((!_supports3D || parse || !m.length || tm.x !== m[4] || tm.y !== m[5] || (!tm.rotationX && !tm.rotationY))) { //sometimes a 6-element matrix is returned even when we performed 3D transforms, like if rotationX and rotationY are 180. In cases like this, we still need to honor the 3D transforms. If we just rely on the 2D info, it could affect how the data is interpreted, like scaleY might get set to -1 or rotation could get offset by 180 degrees. For example, do a TweenLite.to(element, 1, {css:{rotationX:180, rotationY:180}}) and then later, TweenLite.to(element, 1, {css:{rotationX:0}}) and without this conditional logic in place, it'd jump to a state of being unrotated when the 2nd tween starts. Then again, we need to honor the fact that the user COULD alter the transforms outside of CSSPlugin, like by manually applying new css, so we try to sense that by looking at x and y because if those changed, we know the changes were made outside CSSPlugin and we force a reinterpretation of the matrix values. Also, in Webkit browsers, if the element's "display" is "none", its calculated style value will always return empty, so if we've already recorded the values in the _gsTransform object, we'll just rely on those.
							var k = (m.length >= 6),
								a = k ? m[0] : 1,
								b = m[1] || 0,
								c = m[2] || 0,
								d = k ? m[3] : 1;
							tm.x = m[4] || 0;
							tm.y = m[5] || 0;
							scaleX = Math.sqrt(a * a + b * b);
							scaleY = Math.sqrt(d * d + c * c);
							rotation = (a || b) ? Math.atan2(b, a) * _RAD2DEG : tm.rotation || 0; //note: if scaleX is 0, we cannot accurately measure rotation. Same for skewX with a scaleY of 0. Therefore, we default to the previously recorded value (or zero if that doesn't exist).
							skewX = (c || d) ? Math.atan2(c, d) * _RAD2DEG + rotation : tm.skewX || 0;
							tm.scaleX = scaleX;
							tm.scaleY = scaleY;
							tm.rotation = rotation;
							tm.skewX = skewX;
							if (_supports3D) {
								tm.rotationX = tm.rotationY = tm.z = 0;
								tm.perspective = defaultTransformPerspective;
								tm.scaleZ = 1;
							}
							if (tm.svg) {
								tm.x -= tm.xOrigin - (tm.xOrigin * a + tm.yOrigin * c);
								tm.y -= tm.yOrigin - (tm.xOrigin * b + tm.yOrigin * d);
							}
						}
						if (Math.abs(tm.skewX) > 90 && Math.abs(tm.skewX) < 270) {
							if (invX) {
								tm.scaleX *= -1;
								tm.skewX += (tm.rotation <= 0) ? 180 : -180;
								tm.rotation += (tm.rotation <= 0) ? 180 : -180;
							} else {
								tm.scaleY *= -1;
								tm.skewX += (tm.skewX <= 0) ? 180 : -180;
							}
						}
						tm.zOrigin = zOrigin;
						//some browsers have a hard time with very small values like 2.4492935982947064e-16 (notice the "e-" towards the end) and would render the object slightly off. So we round to 0 in these cases. The conditional logic here is faster than calling Math.abs(). Also, browsers tend to render a SLIGHTLY rotated object in a fuzzy way, so we need to snap to exactly 0 when appropriate.
						for (i in tm) {
							if (tm[i] < min) if (tm[i] > -min) {
								tm[i] = 0;
							}
						}
					}
					//DEBUG: _log("parsed rotation of " + t.getAttribute("id")+": "+(tm.rotationX)+", "+(tm.rotationY)+", "+(tm.rotation)+", scale: "+tm.scaleX+", "+tm.scaleY+", "+tm.scaleZ+", position: "+tm.x+", "+tm.y+", "+tm.z+", perspective: "+tm.perspective+ ", origin: "+ tm.xOrigin+ ","+ tm.yOrigin);
					if (rec) {
						t._gsTransform = tm; //record to the object's _gsTransform which we use so that tweens can control individual properties independently (we need all the properties to accurately recompose the matrix in the setRatio() method)
						if (tm.svg) { //if we're supposed to apply transforms to the SVG element's "transform" attribute, make sure there aren't any CSS transforms applied or they'll override the attribute ones. Also clear the transform attribute if we're using CSS, just to be clean.
							if (_useSVGTransformAttr && t.style[_transformProp]) {
								TweenLite.delayedCall(0.001, function(){ //if we apply this right away (before anything has rendered), we risk there being no transforms for a brief moment and it also interferes with adjusting the transformOrigin in a tween with immediateRender:true (it'd try reading the matrix and it wouldn't have the appropriate data in place because we just removed it).
									_removeProp(t.style, _transformProp);
								});
							} else if (!_useSVGTransformAttr && t.getAttribute("transform")) {
								TweenLite.delayedCall(0.001, function(){
									t.removeAttribute("transform");
								});
							}
						}
					}
					return tm;
				},
	
				//for setting 2D transforms in IE6, IE7, and IE8 (must use a "filter" to emulate the behavior of modern day browser transforms)
				_setIETransformRatio = function(v) {
					var t = this.data, //refers to the element's _gsTransform object
						ang = -t.rotation * _DEG2RAD,
						skew = ang + t.skewX * _DEG2RAD,
						rnd = 100000,
						a = ((Math.cos(ang) * t.scaleX * rnd) | 0) / rnd,
						b = ((Math.sin(ang) * t.scaleX * rnd) | 0) / rnd,
						c = ((Math.sin(skew) * -t.scaleY * rnd) | 0) / rnd,
						d = ((Math.cos(skew) * t.scaleY * rnd) | 0) / rnd,
						style = this.t.style,
						cs = this.t.currentStyle,
						filters, val;
					if (!cs) {
						return;
					}
					val = b; //just for swapping the variables an inverting them (reused "val" to avoid creating another variable in memory). IE's filter matrix uses a non-standard matrix configuration (angle goes the opposite way, and b and c are reversed and inverted)
					b = -c;
					c = -val;
					filters = cs.filter;
					style.filter = ""; //remove filters so that we can accurately measure offsetWidth/offsetHeight
					var w = this.t.offsetWidth,
						h = this.t.offsetHeight,
						clip = (cs.position !== "absolute"),
						m = "progid:DXImageTransform.Microsoft.Matrix(M11=" + a + ", M12=" + b + ", M21=" + c + ", M22=" + d,
						ox = t.x + (w * t.xPercent / 100),
						oy = t.y + (h * t.yPercent / 100),
						dx, dy;
	
					//if transformOrigin is being used, adjust the offset x and y
					if (t.ox != null) {
						dx = ((t.oxp) ? w * t.ox * 0.01 : t.ox) - w / 2;
						dy = ((t.oyp) ? h * t.oy * 0.01 : t.oy) - h / 2;
						ox += dx - (dx * a + dy * b);
						oy += dy - (dx * c + dy * d);
					}
	
					if (!clip) {
						m += ", sizingMethod='auto expand')";
					} else {
						dx = (w / 2);
						dy = (h / 2);
						//translate to ensure that transformations occur around the correct origin (default is center).
						m += ", Dx=" + (dx - (dx * a + dy * b) + ox) + ", Dy=" + (dy - (dx * c + dy * d) + oy) + ")";
					}
					if (filters.indexOf("DXImageTransform.Microsoft.Matrix(") !== -1) {
						style.filter = filters.replace(_ieSetMatrixExp, m);
					} else {
						style.filter = m + " " + filters; //we must always put the transform/matrix FIRST (before alpha(opacity=xx)) to avoid an IE bug that slices part of the object when rotation is applied with alpha.
					}
	
					//at the end or beginning of the tween, if the matrix is normal (1, 0, 0, 1) and opacity is 100 (or doesn't exist), remove the filter to improve browser performance.
					if (v === 0 || v === 1) if (a === 1) if (b === 0) if (c === 0) if (d === 1) if (!clip || m.indexOf("Dx=0, Dy=0") !== -1) if (!_opacityExp.test(filters) || parseFloat(RegExp.$1) === 100) if (filters.indexOf("gradient(" && filters.indexOf("Alpha")) === -1) {
						style.removeAttribute("filter");
					}
	
					//we must set the margins AFTER applying the filter in order to avoid some bugs in IE8 that could (in rare scenarios) cause them to be ignored intermittently (vibration).
					if (!clip) {
						var mult = (_ieVers < 8) ? 1 : -1, //in Internet Explorer 7 and before, the box model is broken, causing the browser to treat the width/height of the actual rotated filtered image as the width/height of the box itself, but Microsoft corrected that in IE8. We must use a negative offset in IE8 on the right/bottom
							marg, prop, dif;
						dx = t.ieOffsetX || 0;
						dy = t.ieOffsetY || 0;
						t.ieOffsetX = Math.round((w - ((a < 0 ? -a : a) * w + (b < 0 ? -b : b) * h)) / 2 + ox);
						t.ieOffsetY = Math.round((h - ((d < 0 ? -d : d) * h + (c < 0 ? -c : c) * w)) / 2 + oy);
						for (i = 0; i < 4; i++) {
							prop = _margins[i];
							marg = cs[prop];
							//we need to get the current margin in case it is being tweened separately (we want to respect that tween's changes)
							val = (marg.indexOf("px") !== -1) ? parseFloat(marg) : _convertToPixels(this.t, prop, parseFloat(marg), marg.replace(_suffixExp, "")) || 0;
							if (val !== t[prop]) {
								dif = (i < 2) ? -t.ieOffsetX : -t.ieOffsetY; //if another tween is controlling a margin, we cannot only apply the difference in the ieOffsets, so we essentially zero-out the dx and dy here in that case. We record the margin(s) later so that we can keep comparing them, making this code very flexible.
							} else {
								dif = (i < 2) ? dx - t.ieOffsetX : dy - t.ieOffsetY;
							}
							style[prop] = (t[prop] = Math.round( val - dif * ((i === 0 || i === 2) ? 1 : mult) )) + "px";
						}
					}
				},
	
				/* translates a super small decimal to a string WITHOUT scientific notation
				_safeDecimal = function(n) {
					var s = (n < 0 ? -n : n) + "",
						a = s.split("e-");
					return (n < 0 ? "-0." : "0.") + new Array(parseInt(a[1], 10) || 0).join("0") + a[0].split(".").join("");
				},
				*/
	
				_setTransformRatio = _internals.set3DTransformRatio = _internals.setTransformRatio = function(v) {
					var t = this.data, //refers to the element's _gsTransform object
						style = this.t.style,
						angle = t.rotation,
						rotationX = t.rotationX,
						rotationY = t.rotationY,
						sx = t.scaleX,
						sy = t.scaleY,
						sz = t.scaleZ,
						x = t.x,
						y = t.y,
						z = t.z,
						isSVG = t.svg,
						perspective = t.perspective,
						force3D = t.force3D,
						skewY = t.skewY,
						skewX = t.skewX,
						t1,	a11, a12, a13, a21, a22, a23, a31, a32, a33, a41, a42, a43,
						zOrigin, min, cos, sin, t2, transform, comma, zero, skew, rnd;
					if (skewY) { //for performance reasons, we combine all skewing into the skewX and rotation values. Remember, a skewY of 10 degrees looks the same as a rotation of 10 degrees plus a skewX of 10 degrees.
						skewX += skewY;
						angle += skewY;
					}
	
					//check to see if we should render as 2D (and SVGs must use 2D when _useSVGTransformAttr is true)
					if (((((v === 1 || v === 0) && force3D === "auto" && (this.tween._totalTime === this.tween._totalDuration || !this.tween._totalTime)) || !force3D) && !z && !perspective && !rotationY && !rotationX && sz === 1) || (_useSVGTransformAttr && isSVG) || !_supports3D) { //on the final render (which could be 0 for a from tween), if there are no 3D aspects, render in 2D to free up memory and improve performance especially on mobile devices. Check the tween's totalTime/totalDuration too in order to make sure it doesn't happen between repeats if it's a repeating tween.
	
						//2D
						if (angle || skewX || isSVG) {
							angle *= _DEG2RAD;
							skew = skewX * _DEG2RAD;
							rnd = 100000;
							a11 = Math.cos(angle) * sx;
							a21 = Math.sin(angle) * sx;
							a12 = Math.sin(angle - skew) * -sy;
							a22 = Math.cos(angle - skew) * sy;
							if (skew && t.skewType === "simple") { //by default, we compensate skewing on the other axis to make it look more natural, but you can set the skewType to "simple" to use the uncompensated skewing that CSS does
								t1 = Math.tan(skew - skewY * _DEG2RAD);
								t1 = Math.sqrt(1 + t1 * t1);
								a12 *= t1;
								a22 *= t1;
								if (skewY) {
									t1 = Math.tan(skewY * _DEG2RAD);
									t1 = Math.sqrt(1 + t1 * t1);
									a11 *= t1;
									a21 *= t1;
								}
							}
							if (isSVG) {
								x += t.xOrigin - (t.xOrigin * a11 + t.yOrigin * a12) + t.xOffset;
								y += t.yOrigin - (t.xOrigin * a21 + t.yOrigin * a22) + t.yOffset;
								if (_useSVGTransformAttr && (t.xPercent || t.yPercent)) { //The SVG spec doesn't support percentage-based translation in the "transform" attribute, so we merge it into the matrix to simulate it.
									min = this.t.getBBox();
									x += t.xPercent * 0.01 * min.width;
									y += t.yPercent * 0.01 * min.height;
								}
								min = 0.000001;
								if (x < min) if (x > -min) {
									x = 0;
								}
								if (y < min) if (y > -min) {
									y = 0;
								}
							}
							transform = (((a11 * rnd) | 0) / rnd) + "," + (((a21 * rnd) | 0) / rnd) + "," + (((a12 * rnd) | 0) / rnd) + "," + (((a22 * rnd) | 0) / rnd) + "," + x + "," + y + ")";
							if (isSVG && _useSVGTransformAttr) {
								this.t.setAttribute("transform", "matrix(" + transform);
							} else {
								//some browsers have a hard time with very small values like 2.4492935982947064e-16 (notice the "e-" towards the end) and would render the object slightly off. So we round to 5 decimal places.
								style[_transformProp] = ((t.xPercent || t.yPercent) ? "translate(" + t.xPercent + "%," + t.yPercent + "%) matrix(" : "matrix(") + transform;
							}
						} else {
							style[_transformProp] = ((t.xPercent || t.yPercent) ? "translate(" + t.xPercent + "%," + t.yPercent + "%) matrix(" : "matrix(") + sx + ",0,0," + sy + "," + x + "," + y + ")";
						}
						return;
	
					}
					if (_isFirefox) { //Firefox has a bug (at least in v25) that causes it to render the transparent part of 32-bit PNG images as black when displayed inside an iframe and the 3D scale is very small and doesn't change sufficiently enough between renders (like if you use a Power4.easeInOut to scale from 0 to 1 where the beginning values only change a tiny amount to begin the tween before accelerating). In this case, we force the scale to be 0.00002 instead which is visually the same but works around the Firefox issue.
						min = 0.0001;
						if (sx < min && sx > -min) {
							sx = sz = 0.00002;
						}
						if (sy < min && sy > -min) {
							sy = sz = 0.00002;
						}
						if (perspective && !t.z && !t.rotationX && !t.rotationY) { //Firefox has a bug that causes elements to have an odd super-thin, broken/dotted black border on elements that have a perspective set but aren't utilizing 3D space (no rotationX, rotationY, or z).
							perspective = 0;
						}
					}
					if (angle || skewX) {
						angle *= _DEG2RAD;
						cos = a11 = Math.cos(angle);
						sin = a21 = Math.sin(angle);
						if (skewX) {
							angle -= skewX * _DEG2RAD;
							cos = Math.cos(angle);
							sin = Math.sin(angle);
							if (t.skewType === "simple") { //by default, we compensate skewing on the other axis to make it look more natural, but you can set the skewType to "simple" to use the uncompensated skewing that CSS does
								t1 = Math.tan((skewX - skewY) * _DEG2RAD);
								t1 = Math.sqrt(1 + t1 * t1);
								cos *= t1;
								sin *= t1;
								if (t.skewY) {
									t1 = Math.tan(skewY * _DEG2RAD);
									t1 = Math.sqrt(1 + t1 * t1);
									a11 *= t1;
									a21 *= t1;
								}
							}
						}
						a12 = -sin;
						a22 = cos;
	
					} else if (!rotationY && !rotationX && sz === 1 && !perspective && !isSVG) { //if we're only translating and/or 2D scaling, this is faster...
						style[_transformProp] = ((t.xPercent || t.yPercent) ? "translate(" + t.xPercent + "%," + t.yPercent + "%) translate3d(" : "translate3d(") + x + "px," + y + "px," + z +"px)" + ((sx !== 1 || sy !== 1) ? " scale(" + sx + "," + sy + ")" : "");
						return;
					} else {
						a11 = a22 = 1;
						a12 = a21 = 0;
					}
					// KEY  INDEX   AFFECTS a[row][column]
					// a11  0       rotation, rotationY, scaleX
					// a21  1       rotation, rotationY, scaleX
					// a31  2       rotationY, scaleX
					// a41  3       rotationY, scaleX
					// a12  4       rotation, skewX, rotationX, scaleY
					// a22  5       rotation, skewX, rotationX, scaleY
					// a32  6       rotationX, scaleY
					// a42  7       rotationX, scaleY
					// a13  8       rotationY, rotationX, scaleZ
					// a23  9       rotationY, rotationX, scaleZ
					// a33  10      rotationY, rotationX, scaleZ
					// a43  11      rotationY, rotationX, perspective, scaleZ
					// a14  12      x, zOrigin, svgOrigin
					// a24  13      y, zOrigin, svgOrigin
					// a34  14      z, zOrigin
					// a44  15
					// rotation: Math.atan2(a21, a11)
					// rotationY: Math.atan2(a13, a33) (or Math.atan2(a13, a11))
					// rotationX: Math.atan2(a32, a33)
					a33 = 1;
					a13 = a23 = a31 = a32 = a41 = a42 = 0;
					a43 = (perspective) ? -1 / perspective : 0;
					zOrigin = t.zOrigin;
					min = 0.000001; //threshold below which browsers use scientific notation which won't work.
					comma = ",";
					zero = "0";
					angle = rotationY * _DEG2RAD;
					if (angle) {
						cos = Math.cos(angle);
						sin = Math.sin(angle);
						a31 = -sin;
						a41 = a43*-sin;
						a13 = a11*sin;
						a23 = a21*sin;
						a33 = cos;
						a43 *= cos;
						a11 *= cos;
						a21 *= cos;
					}
					angle = rotationX * _DEG2RAD;
					if (angle) {
						cos = Math.cos(angle);
						sin = Math.sin(angle);
						t1 = a12*cos+a13*sin;
						t2 = a22*cos+a23*sin;
						a32 = a33*sin;
						a42 = a43*sin;
						a13 = a12*-sin+a13*cos;
						a23 = a22*-sin+a23*cos;
						a33 = a33*cos;
						a43 = a43*cos;
						a12 = t1;
						a22 = t2;
					}
					if (sz !== 1) {
						a13*=sz;
						a23*=sz;
						a33*=sz;
						a43*=sz;
					}
					if (sy !== 1) {
						a12*=sy;
						a22*=sy;
						a32*=sy;
						a42*=sy;
					}
					if (sx !== 1) {
						a11*=sx;
						a21*=sx;
						a31*=sx;
						a41*=sx;
					}
	
					if (zOrigin || isSVG) {
						if (zOrigin) {
							x += a13*-zOrigin;
							y += a23*-zOrigin;
							z += a33*-zOrigin+zOrigin;
						}
						if (isSVG) { //due to bugs in some browsers, we need to manage the transform-origin of SVG manually
							x += t.xOrigin - (t.xOrigin * a11 + t.yOrigin * a12) + t.xOffset;
							y += t.yOrigin - (t.xOrigin * a21 + t.yOrigin * a22) + t.yOffset;
						}
						if (x < min && x > -min) {
							x = zero;
						}
						if (y < min && y > -min) {
							y = zero;
						}
						if (z < min && z > -min) {
							z = 0; //don't use string because we calculate perspective later and need the number.
						}
					}
	
					//optimized way of concatenating all the values into a string. If we do it all in one shot, it's slower because of the way browsers have to create temp strings and the way it affects memory. If we do it piece-by-piece with +=, it's a bit slower too. We found that doing it in these sized chunks works best overall:
					transform = ((t.xPercent || t.yPercent) ? "translate(" + t.xPercent + "%," + t.yPercent + "%) matrix3d(" : "matrix3d(");
					transform += ((a11 < min && a11 > -min) ? zero : a11) + comma + ((a21 < min && a21 > -min) ? zero : a21) + comma + ((a31 < min && a31 > -min) ? zero : a31);
					transform += comma + ((a41 < min && a41 > -min) ? zero : a41) + comma + ((a12 < min && a12 > -min) ? zero : a12) + comma + ((a22 < min && a22 > -min) ? zero : a22);
					if (rotationX || rotationY || sz !== 1) { //performance optimization (often there's no rotationX or rotationY, so we can skip these calculations)
						transform += comma + ((a32 < min && a32 > -min) ? zero : a32) + comma + ((a42 < min && a42 > -min) ? zero : a42) + comma + ((a13 < min && a13 > -min) ? zero : a13);
						transform += comma + ((a23 < min && a23 > -min) ? zero : a23) + comma + ((a33 < min && a33 > -min) ? zero : a33) + comma + ((a43 < min && a43 > -min) ? zero : a43) + comma;
					} else {
						transform += ",0,0,0,0,1,0,";
					}
					transform += x + comma + y + comma + z + comma + (perspective ? (1 + (-z / perspective)) : 1) + ")";
	
					style[_transformProp] = transform;
				};
	
			p = Transform.prototype;
			p.x = p.y = p.z = p.skewX = p.skewY = p.rotation = p.rotationX = p.rotationY = p.zOrigin = p.xPercent = p.yPercent = p.xOffset = p.yOffset = 0;
			p.scaleX = p.scaleY = p.scaleZ = 1;
	
			_registerComplexSpecialProp("transform,scale,scaleX,scaleY,scaleZ,x,y,z,rotation,rotationX,rotationY,rotationZ,skewX,skewY,shortRotation,shortRotationX,shortRotationY,shortRotationZ,transformOrigin,svgOrigin,transformPerspective,directionalRotation,parseTransform,force3D,skewType,xPercent,yPercent,smoothOrigin", {parser:function(t, e, parsingProp, cssp, pt, plugin, vars) {
				if (cssp._lastParsedTransform === vars) { return pt; } //only need to parse the transform once, and only if the browser supports it.
				cssp._lastParsedTransform = vars;
				var scaleFunc = (vars.scale && typeof(vars.scale) === "function") ? vars.scale : 0, //if there's a function-based "scale" value, swap in the resulting numeric value temporarily. Otherwise, if it's called for both scaleX and scaleY independently, they may not match (like if the function uses Math.random()).
					swapFunc;
				if (typeof(vars[parsingProp]) === "function") { //whatever property triggers the initial parsing might be a function-based value in which case it already got called in parse(), thus we don't want to call it again in here. The most efficient way to avoid this is to temporarily swap the value directly into the vars object, and then after we do all our parsing in this function, we'll swap it back again.
					swapFunc = vars[parsingProp];
					vars[parsingProp] = e;
				}
				if (scaleFunc) {
					vars.scale = scaleFunc(_index, t);
				}
				var originalGSTransform = t._gsTransform,
					style = t.style,
					min = 0.000001,
					i = _transformProps.length,
					v = vars,
					endRotations = {},
					transformOriginString = "transformOrigin",
					m1 = _getTransform(t, _cs, true, v.parseTransform),
					orig = v.transform && ((typeof(v.transform) === "function") ? v.transform(_index, _target) : v.transform),
					m2, copy, has3D, hasChange, dr, x, y, matrix, p;
				m1.skewType = v.skewType || m1.skewType || CSSPlugin.defaultSkewType;
				cssp._transform = m1;
				if (orig && typeof(orig) === "string" && _transformProp) { //for values like transform:"rotate(60deg) scale(0.5, 0.8)"
					copy = _tempDiv.style; //don't use the original target because it might be SVG in which case some browsers don't report computed style correctly.
					copy[_transformProp] = orig;
					copy.display = "block"; //if display is "none", the browser often refuses to report the transform properties correctly.
					copy.position = "absolute";
					if (orig.indexOf("%") !== -1) { //%-based translations will fail unless we set the width/height to match the original target...
						copy.width = _getStyle(t, "width");
						copy.height = _getStyle(t, "height");
					}
					_doc.body.appendChild(_tempDiv);
					m2 = _getTransform(_tempDiv, null, false);
					if (m1.skewType === "simple") { //the default _getTransform() reports the skewX/scaleY as if skewType is "compensated", thus we need to adjust that here if skewType is "simple".
						m2.scaleY *= Math.cos(m2.skewX * _DEG2RAD);
					}
					if (m1.svg) { //if it's an SVG element, x/y part of the matrix will be affected by whatever we use as the origin and the offsets, so compensate here...
						x = m1.xOrigin;
						y = m1.yOrigin;
						m2.x -= m1.xOffset;
						m2.y -= m1.yOffset;
						if (v.transformOrigin || v.svgOrigin) { //if this tween is altering the origin, we must factor that in here. The actual work of recording the transformOrigin values and setting up the PropTween is done later (still inside this function) so we cannot leave the changes intact here - we only want to update the x/y accordingly.
							orig = {};
							_parseSVGOrigin(t, _parsePosition(v.transformOrigin), orig, v.svgOrigin, v.smoothOrigin, true);
							x = orig.xOrigin;
							y = orig.yOrigin;
							m2.x -= orig.xOffset - m1.xOffset;
							m2.y -= orig.yOffset - m1.yOffset;
						}
						if (x || y) {
							matrix = _getMatrix(_tempDiv, true);
							m2.x -= x - (x * matrix[0] + y * matrix[2]);
							m2.y -= y - (x * matrix[1] + y * matrix[3]);
						}
					}
					_doc.body.removeChild(_tempDiv);
					if (!m2.perspective) {
						m2.perspective = m1.perspective; //tweening to no perspective gives very unintuitive results - just keep the same perspective in that case.
					}
					if (v.xPercent != null) {
						m2.xPercent = _parseVal(v.xPercent, m1.xPercent);
					}
					if (v.yPercent != null) {
						m2.yPercent = _parseVal(v.yPercent, m1.yPercent);
					}
				} else if (typeof(v) === "object") { //for values like scaleX, scaleY, rotation, x, y, skewX, and skewY or transform:{...} (object)
					m2 = {scaleX:_parseVal((v.scaleX != null) ? v.scaleX : v.scale, m1.scaleX),
						scaleY:_parseVal((v.scaleY != null) ? v.scaleY : v.scale, m1.scaleY),
						scaleZ:_parseVal(v.scaleZ, m1.scaleZ),
						x:_parseVal(v.x, m1.x),
						y:_parseVal(v.y, m1.y),
						z:_parseVal(v.z, m1.z),
						xPercent:_parseVal(v.xPercent, m1.xPercent),
						yPercent:_parseVal(v.yPercent, m1.yPercent),
						perspective:_parseVal(v.transformPerspective, m1.perspective)};
					dr = v.directionalRotation;
					if (dr != null) {
						if (typeof(dr) === "object") {
							for (copy in dr) {
								v[copy] = dr[copy];
							}
						} else {
							v.rotation = dr;
						}
					}
					if (typeof(v.x) === "string" && v.x.indexOf("%") !== -1) {
						m2.x = 0;
						m2.xPercent = _parseVal(v.x, m1.xPercent);
					}
					if (typeof(v.y) === "string" && v.y.indexOf("%") !== -1) {
						m2.y = 0;
						m2.yPercent = _parseVal(v.y, m1.yPercent);
					}
	
					m2.rotation = _parseAngle(("rotation" in v) ? v.rotation : ("shortRotation" in v) ? v.shortRotation + "_short" : ("rotationZ" in v) ? v.rotationZ : m1.rotation, m1.rotation, "rotation", endRotations);
					if (_supports3D) {
						m2.rotationX = _parseAngle(("rotationX" in v) ? v.rotationX : ("shortRotationX" in v) ? v.shortRotationX + "_short" : m1.rotationX || 0, m1.rotationX, "rotationX", endRotations);
						m2.rotationY = _parseAngle(("rotationY" in v) ? v.rotationY : ("shortRotationY" in v) ? v.shortRotationY + "_short" : m1.rotationY || 0, m1.rotationY, "rotationY", endRotations);
					}
					m2.skewX = _parseAngle(v.skewX, m1.skewX);
					m2.skewY = _parseAngle(v.skewY, m1.skewY);
				}
				if (_supports3D && v.force3D != null) {
					m1.force3D = v.force3D;
					hasChange = true;
				}
	
				has3D = (m1.force3D || m1.z || m1.rotationX || m1.rotationY || m2.z || m2.rotationX || m2.rotationY || m2.perspective);
				if (!has3D && v.scale != null) {
					m2.scaleZ = 1; //no need to tween scaleZ.
				}
	
				while (--i > -1) {
					p = _transformProps[i];
					orig = m2[p] - m1[p];
					if (orig > min || orig < -min || v[p] != null || _forcePT[p] != null) {
						hasChange = true;
						pt = new CSSPropTween(m1, p, m1[p], orig, pt);
						if (p in endRotations) {
							pt.e = endRotations[p]; //directional rotations typically have compensated values during the tween, but we need to make sure they end at exactly what the user requested
						}
						pt.xs0 = 0; //ensures the value stays numeric in setRatio()
						pt.plugin = plugin;
						cssp._overwriteProps.push(pt.n);
					}
				}
	
				orig = v.transformOrigin;
				if (m1.svg && (orig || v.svgOrigin)) {
					x = m1.xOffset; //when we change the origin, in order to prevent things from jumping we adjust the x/y so we must record those here so that we can create PropTweens for them and flip them at the same time as the origin
					y = m1.yOffset;
					_parseSVGOrigin(t, _parsePosition(orig), m2, v.svgOrigin, v.smoothOrigin);
					pt = _addNonTweeningNumericPT(m1, "xOrigin", (originalGSTransform ? m1 : m2).xOrigin, m2.xOrigin, pt, transformOriginString); //note: if there wasn't a transformOrigin defined yet, just start with the destination one; it's wasteful otherwise, and it causes problems with fromTo() tweens. For example, TweenLite.to("#wheel", 3, {rotation:180, transformOrigin:"50% 50%", delay:1}); TweenLite.fromTo("#wheel", 3, {scale:0.5, transformOrigin:"50% 50%"}, {scale:1, delay:2}); would cause a jump when the from values revert at the beginning of the 2nd tween.
					pt = _addNonTweeningNumericPT(m1, "yOrigin", (originalGSTransform ? m1 : m2).yOrigin, m2.yOrigin, pt, transformOriginString);
					if (x !== m1.xOffset || y !== m1.yOffset) {
						pt = _addNonTweeningNumericPT(m1, "xOffset", (originalGSTransform ? x : m1.xOffset), m1.xOffset, pt, transformOriginString);
						pt = _addNonTweeningNumericPT(m1, "yOffset", (originalGSTransform ? y : m1.yOffset), m1.yOffset, pt, transformOriginString);
					}
					orig = "0px 0px"; //certain browsers (like firefox) completely botch transform-origin, so we must remove it to prevent it from contaminating transforms. We manage it ourselves with xOrigin and yOrigin
				}
				if (orig || (_supports3D && has3D && m1.zOrigin)) { //if anything 3D is happening and there's a transformOrigin with a z component that's non-zero, we must ensure that the transformOrigin's z-component is set to 0 so that we can manually do those calculations to get around Safari bugs. Even if the user didn't specifically define a "transformOrigin" in this particular tween (maybe they did it via css directly).
					if (_transformProp) {
						hasChange = true;
						p = _transformOriginProp;
						orig = (orig || _getStyle(t, p, _cs, false, "50% 50%")) + ""; //cast as string to avoid errors
						pt = new CSSPropTween(style, p, 0, 0, pt, -1, transformOriginString);
						pt.b = style[p];
						pt.plugin = plugin;
						if (_supports3D) {
							copy = m1.zOrigin;
							orig = orig.split(" ");
							m1.zOrigin = ((orig.length > 2 && !(copy !== 0 && orig[2] === "0px")) ? parseFloat(orig[2]) : copy) || 0; //Safari doesn't handle the z part of transformOrigin correctly, so we'll manually handle it in the _set3DTransformRatio() method.
							pt.xs0 = pt.e = orig[0] + " " + (orig[1] || "50%") + " 0px"; //we must define a z value of 0px specifically otherwise iOS 5 Safari will stick with the old one (if one was defined)!
							pt = new CSSPropTween(m1, "zOrigin", 0, 0, pt, -1, pt.n); //we must create a CSSPropTween for the _gsTransform.zOrigin so that it gets reset properly at the beginning if the tween runs backward (as opposed to just setting m1.zOrigin here)
							pt.b = copy;
							pt.xs0 = pt.e = m1.zOrigin;
						} else {
							pt.xs0 = pt.e = orig;
						}
	
						//for older versions of IE (6-8), we need to manually calculate things inside the setRatio() function. We record origin x and y (ox and oy) and whether or not the values are percentages (oxp and oyp).
					} else {
						_parsePosition(orig + "", m1);
					}
				}
				if (hasChange) {
					cssp._transformType = (!(m1.svg && _useSVGTransformAttr) && (has3D || this._transformType === 3)) ? 3 : 2; //quicker than calling cssp._enableTransforms();
				}
				if (swapFunc) {
					vars[parsingProp] = swapFunc;
				}
				if (scaleFunc) {
					vars.scale = scaleFunc;
				}
				return pt;
			}, prefix:true});
	
			_registerComplexSpecialProp("boxShadow", {defaultValue:"0px 0px 0px 0px #999", prefix:true, color:true, multi:true, keyword:"inset"});
	
			_registerComplexSpecialProp("borderRadius", {defaultValue:"0px", parser:function(t, e, p, cssp, pt, plugin) {
				e = this.format(e);
				var props = ["borderTopLeftRadius","borderTopRightRadius","borderBottomRightRadius","borderBottomLeftRadius"],
					style = t.style,
					ea1, i, es2, bs2, bs, es, bn, en, w, h, esfx, bsfx, rel, hn, vn, em;
				w = parseFloat(t.offsetWidth);
				h = parseFloat(t.offsetHeight);
				ea1 = e.split(" ");
				for (i = 0; i < props.length; i++) { //if we're dealing with percentages, we must convert things separately for the horizontal and vertical axis!
					if (this.p.indexOf("border")) { //older browsers used a prefix
						props[i] = _checkPropPrefix(props[i]);
					}
					bs = bs2 = _getStyle(t, props[i], _cs, false, "0px");
					if (bs.indexOf(" ") !== -1) {
						bs2 = bs.split(" ");
						bs = bs2[0];
						bs2 = bs2[1];
					}
					es = es2 = ea1[i];
					bn = parseFloat(bs);
					bsfx = bs.substr((bn + "").length);
					rel = (es.charAt(1) === "=");
					if (rel) {
						en = parseInt(es.charAt(0)+"1", 10);
						es = es.substr(2);
						en *= parseFloat(es);
						esfx = es.substr((en + "").length - (en < 0 ? 1 : 0)) || "";
					} else {
						en = parseFloat(es);
						esfx = es.substr((en + "").length);
					}
					if (esfx === "") {
						esfx = _suffixMap[p] || bsfx;
					}
					if (esfx !== bsfx) {
						hn = _convertToPixels(t, "borderLeft", bn, bsfx); //horizontal number (we use a bogus "borderLeft" property just because the _convertToPixels() method searches for the keywords "Left", "Right", "Top", and "Bottom" to determine of it's a horizontal or vertical property, and we need "border" in the name so that it knows it should measure relative to the element itself, not its parent.
						vn = _convertToPixels(t, "borderTop", bn, bsfx); //vertical number
						if (esfx === "%") {
							bs = (hn / w * 100) + "%";
							bs2 = (vn / h * 100) + "%";
						} else if (esfx === "em") {
							em = _convertToPixels(t, "borderLeft", 1, "em");
							bs = (hn / em) + "em";
							bs2 = (vn / em) + "em";
						} else {
							bs = hn + "px";
							bs2 = vn + "px";
						}
						if (rel) {
							es = (parseFloat(bs) + en) + esfx;
							es2 = (parseFloat(bs2) + en) + esfx;
						}
					}
					pt = _parseComplex(style, props[i], bs + " " + bs2, es + " " + es2, false, "0px", pt);
				}
				return pt;
			}, prefix:true, formatter:_getFormatter("0px 0px 0px 0px", false, true)});
			_registerComplexSpecialProp("borderBottomLeftRadius,borderBottomRightRadius,borderTopLeftRadius,borderTopRightRadius", {defaultValue:"0px", parser:function(t, e, p, cssp, pt, plugin) {
				return _parseComplex(t.style, p, this.format(_getStyle(t, p, _cs, false, "0px 0px")), this.format(e), false, "0px", pt);
			}, prefix:true, formatter:_getFormatter("0px 0px", false, true)});
			_registerComplexSpecialProp("backgroundPosition", {defaultValue:"0 0", parser:function(t, e, p, cssp, pt, plugin) {
				var bp = "background-position",
					cs = (_cs || _getComputedStyle(t, null)),
					bs = this.format( ((cs) ? _ieVers ? cs.getPropertyValue(bp + "-x") + " " + cs.getPropertyValue(bp + "-y") : cs.getPropertyValue(bp) : t.currentStyle.backgroundPositionX + " " + t.currentStyle.backgroundPositionY) || "0 0"), //Internet Explorer doesn't report background-position correctly - we must query background-position-x and background-position-y and combine them (even in IE10). Before IE9, we must do the same with the currentStyle object and use camelCase
					es = this.format(e),
					ba, ea, i, pct, overlap, src;
				if ((bs.indexOf("%") !== -1) !== (es.indexOf("%") !== -1) && es.split(",").length < 2) {
					src = _getStyle(t, "backgroundImage").replace(_urlExp, "");
					if (src && src !== "none") {
						ba = bs.split(" ");
						ea = es.split(" ");
						_tempImg.setAttribute("src", src); //set the temp IMG's src to the background-image so that we can measure its width/height
						i = 2;
						while (--i > -1) {
							bs = ba[i];
							pct = (bs.indexOf("%") !== -1);
							if (pct !== (ea[i].indexOf("%") !== -1)) {
								overlap = (i === 0) ? t.offsetWidth - _tempImg.width : t.offsetHeight - _tempImg.height;
								ba[i] = pct ? (parseFloat(bs) / 100 * overlap) + "px" : (parseFloat(bs) / overlap * 100) + "%";
							}
						}
						bs = ba.join(" ");
					}
				}
				return this.parseComplex(t.style, bs, es, pt, plugin);
			}, formatter:_parsePosition});
			_registerComplexSpecialProp("backgroundSize", {defaultValue:"0 0", formatter:function(v) {
				v += ""; //ensure it's a string
				return (v.substr(0,2) === "co") ? v : _parsePosition(v.indexOf(" ") === -1 ? v + " " + v : v); //if set to something like "100% 100%", Safari typically reports the computed style as just "100%" (no 2nd value), but we should ensure that there are two values, so copy the first one. Otherwise, it'd be interpreted as "100% 0" (wrong). Also remember that it could be "cover" or "contain" which we can't tween but should be able to set.
			}});
			_registerComplexSpecialProp("perspective", {defaultValue:"0px", prefix:true});
			_registerComplexSpecialProp("perspectiveOrigin", {defaultValue:"50% 50%", prefix:true});
			_registerComplexSpecialProp("transformStyle", {prefix:true});
			_registerComplexSpecialProp("backfaceVisibility", {prefix:true});
			_registerComplexSpecialProp("userSelect", {prefix:true});
			_registerComplexSpecialProp("margin", {parser:_getEdgeParser("marginTop,marginRight,marginBottom,marginLeft")});
			_registerComplexSpecialProp("padding", {parser:_getEdgeParser("paddingTop,paddingRight,paddingBottom,paddingLeft")});
			_registerComplexSpecialProp("clip", {defaultValue:"rect(0px,0px,0px,0px)", parser:function(t, e, p, cssp, pt, plugin){
				var b, cs, delim;
				if (_ieVers < 9) { //IE8 and earlier don't report a "clip" value in the currentStyle - instead, the values are split apart into clipTop, clipRight, clipBottom, and clipLeft. Also, in IE7 and earlier, the values inside rect() are space-delimited, not comma-delimited.
					cs = t.currentStyle;
					delim = _ieVers < 8 ? " " : ",";
					b = "rect(" + cs.clipTop + delim + cs.clipRight + delim + cs.clipBottom + delim + cs.clipLeft + ")";
					e = this.format(e).split(",").join(delim);
				} else {
					b = this.format(_getStyle(t, this.p, _cs, false, this.dflt));
					e = this.format(e);
				}
				return this.parseComplex(t.style, b, e, pt, plugin);
			}});
			_registerComplexSpecialProp("textShadow", {defaultValue:"0px 0px 0px #999", color:true, multi:true});
			_registerComplexSpecialProp("autoRound,strictUnits", {parser:function(t, e, p, cssp, pt) {return pt;}}); //just so that we can ignore these properties (not tween them)
			_registerComplexSpecialProp("border", {defaultValue:"0px solid #000", parser:function(t, e, p, cssp, pt, plugin) {
				var bw = _getStyle(t, "borderTopWidth", _cs, false, "0px"),
					end = this.format(e).split(" "),
					esfx = end[0].replace(_suffixExp, "");
				if (esfx !== "px") { //if we're animating to a non-px value, we need to convert the beginning width to that unit.
					bw = (parseFloat(bw) / _convertToPixels(t, "borderTopWidth", 1, esfx)) + esfx;
				}
				return this.parseComplex(t.style, this.format(bw + " " + _getStyle(t, "borderTopStyle", _cs, false, "solid") + " " + _getStyle(t, "borderTopColor", _cs, false, "#000")), end.join(" "), pt, plugin);
				}, color:true, formatter:function(v) {
					var a = v.split(" ");
					return a[0] + " " + (a[1] || "solid") + " " + (v.match(_colorExp) || ["#000"])[0];
				}});
			_registerComplexSpecialProp("borderWidth", {parser:_getEdgeParser("borderTopWidth,borderRightWidth,borderBottomWidth,borderLeftWidth")}); //Firefox doesn't pick up on borderWidth set in style sheets (only inline).
			_registerComplexSpecialProp("float,cssFloat,styleFloat", {parser:function(t, e, p, cssp, pt, plugin) {
				var s = t.style,
					prop = ("cssFloat" in s) ? "cssFloat" : "styleFloat";
				return new CSSPropTween(s, prop, 0, 0, pt, -1, p, false, 0, s[prop], e);
			}});
	
			//opacity-related
			var _setIEOpacityRatio = function(v) {
					var t = this.t, //refers to the element's style property
						filters = t.filter || _getStyle(this.data, "filter") || "",
						val = (this.s + this.c * v) | 0,
						skip;
					if (val === 100) { //for older versions of IE that need to use a filter to apply opacity, we should remove the filter if opacity hits 1 in order to improve performance, but make sure there isn't a transform (matrix) or gradient in the filters.
						if (filters.indexOf("atrix(") === -1 && filters.indexOf("radient(") === -1 && filters.indexOf("oader(") === -1) {
							t.removeAttribute("filter");
							skip = (!_getStyle(this.data, "filter")); //if a class is applied that has an alpha filter, it will take effect (we don't want that), so re-apply our alpha filter in that case. We must first remove it and then check.
						} else {
							t.filter = filters.replace(_alphaFilterExp, "");
							skip = true;
						}
					}
					if (!skip) {
						if (this.xn1) {
							t.filter = filters = filters || ("alpha(opacity=" + val + ")"); //works around bug in IE7/8 that prevents changes to "visibility" from being applied properly if the filter is changed to a different alpha on the same frame.
						}
						if (filters.indexOf("pacity") === -1) { //only used if browser doesn't support the standard opacity style property (IE 7 and 8). We omit the "O" to avoid case-sensitivity issues
							if (val !== 0 || !this.xn1) { //bugs in IE7/8 won't render the filter properly if opacity is ADDED on the same frame/render as "visibility" changes (this.xn1 is 1 if this tween is an "autoAlpha" tween)
								t.filter = filters + " alpha(opacity=" + val + ")"; //we round the value because otherwise, bugs in IE7/8 can prevent "visibility" changes from being applied properly.
							}
						} else {
							t.filter = filters.replace(_opacityExp, "opacity=" + val);
						}
					}
				};
			_registerComplexSpecialProp("opacity,alpha,autoAlpha", {defaultValue:"1", parser:function(t, e, p, cssp, pt, plugin) {
				var b = parseFloat(_getStyle(t, "opacity", _cs, false, "1")),
					style = t.style,
					isAutoAlpha = (p === "autoAlpha");
				if (typeof(e) === "string" && e.charAt(1) === "=") {
					e = ((e.charAt(0) === "-") ? -1 : 1) * parseFloat(e.substr(2)) + b;
				}
				if (isAutoAlpha && b === 1 && _getStyle(t, "visibility", _cs) === "hidden" && e !== 0) { //if visibility is initially set to "hidden", we should interpret that as intent to make opacity 0 (a convenience)
					b = 0;
				}
				if (_supportsOpacity) {
					pt = new CSSPropTween(style, "opacity", b, e - b, pt);
				} else {
					pt = new CSSPropTween(style, "opacity", b * 100, (e - b) * 100, pt);
					pt.xn1 = isAutoAlpha ? 1 : 0; //we need to record whether or not this is an autoAlpha so that in the setRatio(), we know to duplicate the setting of the alpha in order to work around a bug in IE7 and IE8 that prevents changes to "visibility" from taking effect if the filter is changed to a different alpha(opacity) at the same time. Setting it to the SAME value first, then the new value works around the IE7/8 bug.
					style.zoom = 1; //helps correct an IE issue.
					pt.type = 2;
					pt.b = "alpha(opacity=" + pt.s + ")";
					pt.e = "alpha(opacity=" + (pt.s + pt.c) + ")";
					pt.data = t;
					pt.plugin = plugin;
					pt.setRatio = _setIEOpacityRatio;
				}
				if (isAutoAlpha) { //we have to create the "visibility" PropTween after the opacity one in the linked list so that they run in the order that works properly in IE8 and earlier
					pt = new CSSPropTween(style, "visibility", 0, 0, pt, -1, null, false, 0, ((b !== 0) ? "inherit" : "hidden"), ((e === 0) ? "hidden" : "inherit"));
					pt.xs0 = "inherit";
					cssp._overwriteProps.push(pt.n);
					cssp._overwriteProps.push(p);
				}
				return pt;
			}});
	
	
			var _removeProp = function(s, p) {
					if (p) {
						if (s.removeProperty) {
							if (p.substr(0,2) === "ms" || p.substr(0,6) === "webkit") { //Microsoft and some Webkit browsers don't conform to the standard of capitalizing the first prefix character, so we adjust so that when we prefix the caps with a dash, it's correct (otherwise it'd be "ms-transform" instead of "-ms-transform" for IE9, for example)
								p = "-" + p;
							}
							s.removeProperty(p.replace(_capsExp, "-$1").toLowerCase());
						} else { //note: old versions of IE use "removeAttribute()" instead of "removeProperty()"
							s.removeAttribute(p);
						}
					}
				},
				_setClassNameRatio = function(v) {
					this.t._gsClassPT = this;
					if (v === 1 || v === 0) {
						this.t.setAttribute("class", (v === 0) ? this.b : this.e);
						var mpt = this.data, //first MiniPropTween
							s = this.t.style;
						while (mpt) {
							if (!mpt.v) {
								_removeProp(s, mpt.p);
							} else {
								s[mpt.p] = mpt.v;
							}
							mpt = mpt._next;
						}
						if (v === 1 && this.t._gsClassPT === this) {
							this.t._gsClassPT = null;
						}
					} else if (this.t.getAttribute("class") !== this.e) {
						this.t.setAttribute("class", this.e);
					}
				};
			_registerComplexSpecialProp("className", {parser:function(t, e, p, cssp, pt, plugin, vars) {
				var b = t.getAttribute("class") || "", //don't use t.className because it doesn't work consistently on SVG elements; getAttribute("class") and setAttribute("class", value") is more reliable.
					cssText = t.style.cssText,
					difData, bs, cnpt, cnptLookup, mpt;
				pt = cssp._classNamePT = new CSSPropTween(t, p, 0, 0, pt, 2);
				pt.setRatio = _setClassNameRatio;
				pt.pr = -11;
				_hasPriority = true;
				pt.b = b;
				bs = _getAllStyles(t, _cs);
				//if there's a className tween already operating on the target, force it to its end so that the necessary inline styles are removed and the class name is applied before we determine the end state (we don't want inline styles interfering that were there just for class-specific values)
				cnpt = t._gsClassPT;
				if (cnpt) {
					cnptLookup = {};
					mpt = cnpt.data; //first MiniPropTween which stores the inline styles - we need to force these so that the inline styles don't contaminate things. Otherwise, there's a small chance that a tween could start and the inline values match the destination values and they never get cleaned.
					while (mpt) {
						cnptLookup[mpt.p] = 1;
						mpt = mpt._next;
					}
					cnpt.setRatio(1);
				}
				t._gsClassPT = pt;
				pt.e = (e.charAt(1) !== "=") ? e : b.replace(new RegExp("(?:\\s|^)" + e.substr(2) + "(?![\\w-])"), "") + ((e.charAt(0) === "+") ? " " + e.substr(2) : "");
				t.setAttribute("class", pt.e);
				difData = _cssDif(t, bs, _getAllStyles(t), vars, cnptLookup);
				t.setAttribute("class", b);
				pt.data = difData.firstMPT;
				t.style.cssText = cssText; //we recorded cssText before we swapped classes and ran _getAllStyles() because in cases when a className tween is overwritten, we remove all the related tweening properties from that class change (otherwise class-specific stuff can't override properties we've directly set on the target's style object due to specificity).
				pt = pt.xfirst = cssp.parse(t, difData.difs, pt, plugin); //we record the CSSPropTween as the xfirst so that we can handle overwriting propertly (if "className" gets overwritten, we must kill all the properties associated with the className part of the tween, so we can loop through from xfirst to the pt itself)
				return pt;
			}});
	
	
			var _setClearPropsRatio = function(v) {
				if (v === 1 || v === 0) if (this.data._totalTime === this.data._totalDuration && this.data.data !== "isFromStart") { //this.data refers to the tween. Only clear at the END of the tween (remember, from() tweens make the ratio go from 1 to 0, so we can't just check that and if the tween is the zero-duration one that's created internally to render the starting values in a from() tween, ignore that because otherwise, for example, from(...{height:100, clearProps:"height", delay:1}) would wipe the height at the beginning of the tween and after 1 second, it'd kick back in).
					var s = this.t.style,
						transformParse = _specialProps.transform.parse,
						a, p, i, clearTransform, transform;
					if (this.e === "all") {
						s.cssText = "";
						clearTransform = true;
					} else {
						a = this.e.split(" ").join("").split(",");
						i = a.length;
						while (--i > -1) {
							p = a[i];
							if (_specialProps[p]) {
								if (_specialProps[p].parse === transformParse) {
									clearTransform = true;
								} else {
									p = (p === "transformOrigin") ? _transformOriginProp : _specialProps[p].p; //ensures that special properties use the proper browser-specific property name, like "scaleX" might be "-webkit-transform" or "boxShadow" might be "-moz-box-shadow"
								}
							}
							_removeProp(s, p);
						}
					}
					if (clearTransform) {
						_removeProp(s, _transformProp);
						transform = this.t._gsTransform;
						if (transform) {
							if (transform.svg) {
								this.t.removeAttribute("data-svg-origin");
								this.t.removeAttribute("transform");
							}
							delete this.t._gsTransform;
						}
					}
	
				}
			};
			_registerComplexSpecialProp("clearProps", {parser:function(t, e, p, cssp, pt) {
				pt = new CSSPropTween(t, p, 0, 0, pt, 2);
				pt.setRatio = _setClearPropsRatio;
				pt.e = e;
				pt.pr = -10;
				pt.data = cssp._tween;
				_hasPriority = true;
				return pt;
			}});
	
			p = "bezier,throwProps,physicsProps,physics2D".split(",");
			i = p.length;
			while (i--) {
				_registerPluginProp(p[i]);
			}
	
	
	
	
	
	
	
	
			p = CSSPlugin.prototype;
			p._firstPT = p._lastParsedTransform = p._transform = null;
	
			//gets called when the tween renders for the first time. This kicks everything off, recording start/end values, etc.
			p._onInitTween = function(target, vars, tween, index) {
				if (!target.nodeType) { //css is only for dom elements
					return false;
				}
				this._target = _target = target;
				this._tween = tween;
				this._vars = vars;
				_index = index;
				_autoRound = vars.autoRound;
				_hasPriority = false;
				_suffixMap = vars.suffixMap || CSSPlugin.suffixMap;
				_cs = _getComputedStyle(target, "");
				_overwriteProps = this._overwriteProps;
				var style = target.style,
					v, pt, pt2, first, last, next, zIndex, tpt, threeD;
				if (_reqSafariFix) if (style.zIndex === "") {
					v = _getStyle(target, "zIndex", _cs);
					if (v === "auto" || v === "") {
						//corrects a bug in [non-Android] Safari that prevents it from repainting elements in their new positions if they don't have a zIndex set. We also can't just apply this inside _parseTransform() because anything that's moved in any way (like using "left" or "top" instead of transforms like "x" and "y") can be affected, so it is best to ensure that anything that's tweening has a z-index. Setting "WebkitPerspective" to a non-zero value worked too except that on iOS Safari things would flicker randomly. Plus zIndex is less memory-intensive.
						this._addLazySet(style, "zIndex", 0);
					}
				}
	
				if (typeof(vars) === "string") {
					first = style.cssText;
					v = _getAllStyles(target, _cs);
					style.cssText = first + ";" + vars;
					v = _cssDif(target, v, _getAllStyles(target)).difs;
					if (!_supportsOpacity && _opacityValExp.test(vars)) {
						v.opacity = parseFloat( RegExp.$1 );
					}
					vars = v;
					style.cssText = first;
				}
	
				if (vars.className) { //className tweens will combine any differences they find in the css with the vars that are passed in, so {className:"myClass", scale:0.5, left:20} would work.
					this._firstPT = pt = _specialProps.className.parse(target, vars.className, "className", this, null, null, vars);
				} else {
					this._firstPT = pt = this.parse(target, vars, null);
				}
	
				if (this._transformType) {
					threeD = (this._transformType === 3);
					if (!_transformProp) {
						style.zoom = 1; //helps correct an IE issue.
					} else if (_isSafari) {
						_reqSafariFix = true;
						//if zIndex isn't set, iOS Safari doesn't repaint things correctly sometimes (seemingly at random).
						if (style.zIndex === "") {
							zIndex = _getStyle(target, "zIndex", _cs);
							if (zIndex === "auto" || zIndex === "") {
								this._addLazySet(style, "zIndex", 0);
							}
						}
						//Setting WebkitBackfaceVisibility corrects 3 bugs:
						// 1) [non-Android] Safari skips rendering changes to "top" and "left" that are made on the same frame/render as a transform update.
						// 2) iOS Safari sometimes neglects to repaint elements in their new positions. Setting "WebkitPerspective" to a non-zero value worked too except that on iOS Safari things would flicker randomly.
						// 3) Safari sometimes displayed odd artifacts when tweening the transform (or WebkitTransform) property, like ghosts of the edges of the element remained. Definitely a browser bug.
						//Note: we allow the user to override the auto-setting by defining WebkitBackfaceVisibility in the vars of the tween.
						if (_isSafariLT6) {
							this._addLazySet(style, "WebkitBackfaceVisibility", this._vars.WebkitBackfaceVisibility || (threeD ? "visible" : "hidden"));
						}
					}
					pt2 = pt;
					while (pt2 && pt2._next) {
						pt2 = pt2._next;
					}
					tpt = new CSSPropTween(target, "transform", 0, 0, null, 2);
					this._linkCSSP(tpt, null, pt2);
					tpt.setRatio = _transformProp ? _setTransformRatio : _setIETransformRatio;
					tpt.data = this._transform || _getTransform(target, _cs, true);
					tpt.tween = tween;
					tpt.pr = -1; //ensures that the transforms get applied after the components are updated.
					_overwriteProps.pop(); //we don't want to force the overwrite of all "transform" tweens of the target - we only care about individual transform properties like scaleX, rotation, etc. The CSSPropTween constructor automatically adds the property to _overwriteProps which is why we need to pop() here.
				}
	
				if (_hasPriority) {
					//reorders the linked list in order of pr (priority)
					while (pt) {
						next = pt._next;
						pt2 = first;
						while (pt2 && pt2.pr > pt.pr) {
							pt2 = pt2._next;
						}
						if ((pt._prev = pt2 ? pt2._prev : last)) {
							pt._prev._next = pt;
						} else {
							first = pt;
						}
						if ((pt._next = pt2)) {
							pt2._prev = pt;
						} else {
							last = pt;
						}
						pt = next;
					}
					this._firstPT = first;
				}
				return true;
			};
	
	
			p.parse = function(target, vars, pt, plugin) {
				var style = target.style,
					p, sp, bn, en, bs, es, bsfx, esfx, isStr, rel;
				for (p in vars) {
					es = vars[p]; //ending value string
					if (typeof(es) === "function") {
						es = es(_index, _target);
					}
					sp = _specialProps[p]; //SpecialProp lookup.
					if (sp) {
						pt = sp.parse(target, es, p, this, pt, plugin, vars);
					} else if (p.substr(0,2) === "--") { //for tweening CSS variables (which always start with "--"). To maximize performance and simplicity, we bypass CSSPlugin altogether and just add a normal property tween to the tween instance itself.
						this._tween._propLookup[p] = this._addTween.call(this._tween, target.style, "setProperty", _getComputedStyle(target).getPropertyValue(p) + "", es + "", p, false, p);
						continue;
					} else {
						bs = _getStyle(target, p, _cs) + "";
						isStr = (typeof(es) === "string");
						if (p === "color" || p === "fill" || p === "stroke" || p.indexOf("Color") !== -1 || (isStr && _rgbhslExp.test(es))) { //Opera uses background: to define color sometimes in addition to backgroundColor:
							if (!isStr) {
								es = _parseColor(es);
								es = ((es.length > 3) ? "rgba(" : "rgb(") + es.join(",") + ")";
							}
							pt = _parseComplex(style, p, bs, es, true, "transparent", pt, 0, plugin);
	
						} else if (isStr && _complexExp.test(es)) {
							pt = _parseComplex(style, p, bs, es, true, null, pt, 0, plugin);
	
						} else {
							bn = parseFloat(bs);
							bsfx = (bn || bn === 0) ? bs.substr((bn + "").length) : ""; //remember, bs could be non-numeric like "normal" for fontWeight, so we should default to a blank suffix in that case.
	
							if (bs === "" || bs === "auto") {
								if (p === "width" || p === "height") {
									bn = _getDimension(target, p, _cs);
									bsfx = "px";
								} else if (p === "left" || p === "top") {
									bn = _calculateOffset(target, p, _cs);
									bsfx = "px";
								} else {
									bn = (p !== "opacity") ? 0 : 1;
									bsfx = "";
								}
							}
	
							rel = (isStr && es.charAt(1) === "=");
							if (rel) {
								en = parseInt(es.charAt(0) + "1", 10);
								es = es.substr(2);
								en *= parseFloat(es);
								esfx = es.replace(_suffixExp, "");
							} else {
								en = parseFloat(es);
								esfx = isStr ? es.replace(_suffixExp, "") : "";
							}
	
							if (esfx === "") {
								esfx = (p in _suffixMap) ? _suffixMap[p] : bsfx; //populate the end suffix, prioritizing the map, then if none is found, use the beginning suffix.
							}
	
							es = (en || en === 0) ? (rel ? en + bn : en) + esfx : vars[p]; //ensures that any += or -= prefixes are taken care of. Record the end value before normalizing the suffix because we always want to end the tween on exactly what they intended even if it doesn't match the beginning value's suffix.
							//if the beginning/ending suffixes don't match, normalize them...
							if (bsfx !== esfx) if (esfx !== "" || p === "lineHeight") if (en || en === 0) if (bn) { //note: if the beginning value (bn) is 0, we don't need to convert units!
								bn = _convertToPixels(target, p, bn, bsfx);
								if (esfx === "%") {
									bn /= _convertToPixels(target, p, 100, "%") / 100;
									if (vars.strictUnits !== true) { //some browsers report only "px" values instead of allowing "%" with getComputedStyle(), so we assume that if we're tweening to a %, we should start there too unless strictUnits:true is defined. This approach is particularly useful for responsive designs that use from() tweens.
										bs = bn + "%";
									}
	
								} else if (esfx === "em" || esfx === "rem" || esfx === "vw" || esfx === "vh") {
									bn /= _convertToPixels(target, p, 1, esfx);
	
								//otherwise convert to pixels.
								} else if (esfx !== "px") {
									en = _convertToPixels(target, p, en, esfx);
									esfx = "px"; //we don't use bsfx after this, so we don't need to set it to px too.
								}
								if (rel) if (en || en === 0) {
									es = (en + bn) + esfx; //the changes we made affect relative calculations, so adjust the end value here.
								}
							}
	
							if (rel) {
								en += bn;
							}
	
							if ((bn || bn === 0) && (en || en === 0)) { //faster than isNaN(). Also, previously we required en !== bn but that doesn't really gain much performance and it prevents _parseToProxy() from working properly if beginning and ending values match but need to get tweened by an external plugin anyway. For example, a bezier tween where the target starts at left:0 and has these points: [{left:50},{left:0}] wouldn't work properly because when parsing the last point, it'd match the first (current) one and a non-tweening CSSPropTween would be recorded when we actually need a normal tween (type:0) so that things get updated during the tween properly.
								pt = new CSSPropTween(style, p, bn, en - bn, pt, 0, p, (_autoRound !== false && (esfx === "px" || p === "zIndex")), 0, bs, es);
								pt.xs0 = esfx;
								//DEBUG: _log("tween "+p+" from "+pt.b+" ("+bn+esfx+") to "+pt.e+" with suffix: "+pt.xs0);
							} else if (style[p] === undefined || !es && (es + "" === "NaN" || es == null)) {
								_log("invalid " + p + " tween value: " + vars[p]);
							} else {
								pt = new CSSPropTween(style, p, en || bn || 0, 0, pt, -1, p, false, 0, bs, es);
								pt.xs0 = (es === "none" && (p === "display" || p.indexOf("Style") !== -1)) ? bs : es; //intermediate value should typically be set immediately (end value) except for "display" or things like borderTopStyle, borderBottomStyle, etc. which should use the beginning value during the tween.
								//DEBUG: _log("non-tweening value "+p+": "+pt.xs0);
							}
						}
					}
					if (plugin) if (pt && !pt.plugin) {
						pt.plugin = plugin;
					}
				}
				return pt;
			};
	
	
			//gets called every time the tween updates, passing the new ratio (typically a value between 0 and 1, but not always (for example, if an Elastic.easeOut is used, the value can jump above 1 mid-tween). It will always start and 0 and end at 1.
			p.setRatio = function(v) {
				var pt = this._firstPT,
					min = 0.000001,
					val, str, i;
				//at the end of the tween, we set the values to exactly what we received in order to make sure non-tweening values (like "position" or "float" or whatever) are set and so that if the beginning/ending suffixes (units) didn't match and we normalized to px, the value that the user passed in is used here. We check to see if the tween is at its beginning in case it's a from() tween in which case the ratio will actually go from 1 to 0 over the course of the tween (backwards).
				if (v === 1 && (this._tween._time === this._tween._duration || this._tween._time === 0)) {
					while (pt) {
						if (pt.type !== 2) {
							if (pt.r && pt.type !== -1) {
								val = pt.r(pt.s + pt.c);
								if (!pt.type) {
									pt.t[pt.p] = val + pt.xs0;
								} else if (pt.type === 1) { //complex value (one that typically has multiple numbers inside a string, like "rect(5px,10px,20px,25px)"
									i = pt.l;
									str = pt.xs0 + val + pt.xs1;
									for (i = 1; i < pt.l; i++) {
										str += pt["xn"+i] + pt["xs"+(i+1)];
									}
									pt.t[pt.p] = str;
								}
							} else {
								pt.t[pt.p] = pt.e;
							}
						} else {
							pt.setRatio(v);
						}
						pt = pt._next;
					}
	
				} else if (v || !(this._tween._time === this._tween._duration || this._tween._time === 0) || this._tween._rawPrevTime === -0.000001) {
					while (pt) {
						val = pt.c * v + pt.s;
						if (pt.r) {
							val = pt.r(val);
						} else if (val < min) if (val > -min) {
							val = 0;
						}
						if (!pt.type) {
							pt.t[pt.p] = val + pt.xs0;
						} else if (pt.type === 1) { //complex value (one that typically has multiple numbers inside a string, like "rect(5px,10px,20px,25px)"
							i = pt.l;
							if (i === 2) {
								pt.t[pt.p] = pt.xs0 + val + pt.xs1 + pt.xn1 + pt.xs2;
							} else if (i === 3) {
								pt.t[pt.p] = pt.xs0 + val + pt.xs1 + pt.xn1 + pt.xs2 + pt.xn2 + pt.xs3;
							} else if (i === 4) {
								pt.t[pt.p] = pt.xs0 + val + pt.xs1 + pt.xn1 + pt.xs2 + pt.xn2 + pt.xs3 + pt.xn3 + pt.xs4;
							} else if (i === 5) {
								pt.t[pt.p] = pt.xs0 + val + pt.xs1 + pt.xn1 + pt.xs2 + pt.xn2 + pt.xs3 + pt.xn3 + pt.xs4 + pt.xn4 + pt.xs5;
							} else {
								str = pt.xs0 + val + pt.xs1;
								for (i = 1; i < pt.l; i++) {
									str += pt["xn"+i] + pt["xs"+(i+1)];
								}
								pt.t[pt.p] = str;
							}
	
						} else if (pt.type === -1) { //non-tweening value
							pt.t[pt.p] = pt.xs0;
	
						} else if (pt.setRatio) { //custom setRatio() for things like SpecialProps, external plugins, etc.
							pt.setRatio(v);
						}
						pt = pt._next;
					}
	
				//if the tween is reversed all the way back to the beginning, we need to restore the original values which may have different units (like % instead of px or em or whatever).
				} else {
					while (pt) {
						if (pt.type !== 2) {
							pt.t[pt.p] = pt.b;
						} else {
							pt.setRatio(v);
						}
						pt = pt._next;
					}
				}
			};
	
			/**
			 * @private
			 * Forces rendering of the target's transforms (rotation, scale, etc.) whenever the CSSPlugin's setRatio() is called.
			 * Basically, this tells the CSSPlugin to create a CSSPropTween (type 2) after instantiation that runs last in the linked
			 * list and calls the appropriate (3D or 2D) rendering function. We separate this into its own method so that we can call
			 * it from other plugins like BezierPlugin if, for example, it needs to apply an autoRotation and this CSSPlugin
			 * doesn't have any transform-related properties of its own. You can call this method as many times as you
			 * want and it won't create duplicate CSSPropTweens.
			 *
			 * @param {boolean} threeD if true, it should apply 3D tweens (otherwise, just 2D ones are fine and typically faster)
			 */
			p._enableTransforms = function(threeD) {
				this._transform = this._transform || _getTransform(this._target, _cs, true); //ensures that the element has a _gsTransform property with the appropriate values.
				this._transformType = (!(this._transform.svg && _useSVGTransformAttr) && (threeD || this._transformType === 3)) ? 3 : 2;
			};
	
			var lazySet = function(v) {
				this.t[this.p] = this.e;
				this.data._linkCSSP(this, this._next, null, true); //we purposefully keep this._next even though it'd make sense to null it, but this is a performance optimization, as this happens during the while (pt) {} loop in setRatio() at the bottom of which it sets pt = pt._next, so if we null it, the linked list will be broken in that loop.
			};
			/** @private Gives us a way to set a value on the first render (and only the first render). **/
			p._addLazySet = function(t, p, v) {
				var pt = this._firstPT = new CSSPropTween(t, p, 0, 0, this._firstPT, 2);
				pt.e = v;
				pt.setRatio = lazySet;
				pt.data = this;
			};
	
			/** @private **/
			p._linkCSSP = function(pt, next, prev, remove) {
				if (pt) {
					if (next) {
						next._prev = pt;
					}
					if (pt._next) {
						pt._next._prev = pt._prev;
					}
					if (pt._prev) {
						pt._prev._next = pt._next;
					} else if (this._firstPT === pt) {
						this._firstPT = pt._next;
						remove = true; //just to prevent resetting this._firstPT 5 lines down in case pt._next is null. (optimized for speed)
					}
					if (prev) {
						prev._next = pt;
					} else if (!remove && this._firstPT === null) {
						this._firstPT = pt;
					}
					pt._next = next;
					pt._prev = prev;
				}
				return pt;
			};
	
			p._mod = function(lookup) {
				var pt = this._firstPT;
				while (pt) {
					if (typeof(lookup[pt.p]) === "function") { //only gets called by RoundPropsPlugin (ModifyPlugin manages all the rendering internally for CSSPlugin properties that need modification). Remember, we handle rounding a bit differently in this plugin for performance reasons, leveraging "r" as an indicator that the value should be rounded internally.
						pt.r = lookup[pt.p];
					}
					pt = pt._next;
				}
			};
	
			//we need to make sure that if alpha or autoAlpha is killed, opacity is too. And autoAlpha affects the "visibility" property.
			p._kill = function(lookup) {
				var copy = lookup,
					pt, p, xfirst;
				if (lookup.autoAlpha || lookup.alpha) {
					copy = {};
					for (p in lookup) { //copy the lookup so that we're not changing the original which may be passed elsewhere.
						copy[p] = lookup[p];
					}
					copy.opacity = 1;
					if (copy.autoAlpha) {
						copy.visibility = 1;
					}
				}
				if (lookup.className && (pt = this._classNamePT)) { //for className tweens, we need to kill any associated CSSPropTweens too; a linked list starts at the className's "xfirst".
					xfirst = pt.xfirst;
					if (xfirst && xfirst._prev) {
						this._linkCSSP(xfirst._prev, pt._next, xfirst._prev._prev); //break off the prev
					} else if (xfirst === this._firstPT) {
						this._firstPT = pt._next;
					}
					if (pt._next) {
						this._linkCSSP(pt._next, pt._next._next, xfirst._prev);
					}
					this._classNamePT = null;
				}
				pt = this._firstPT;
				while (pt) {
					if (pt.plugin && pt.plugin !== p && pt.plugin._kill) { //for plugins that are registered with CSSPlugin, we should notify them of the kill.
						pt.plugin._kill(lookup);
						p = pt.plugin;
					}
					pt = pt._next;
				}
				return TweenPlugin.prototype._kill.call(this, copy);
			};
	
	
	
			//used by cascadeTo() for gathering all the style properties of each child element into an array for comparison.
			var _getChildStyles = function(e, props, targets) {
					var children, i, child, type;
					if (e.slice) {
						i = e.length;
						while (--i > -1) {
							_getChildStyles(e[i], props, targets);
						}
						return;
					}
					children = e.childNodes;
					i = children.length;
					while (--i > -1) {
						child = children[i];
						type = child.type;
						if (child.style) {
							props.push(_getAllStyles(child));
							if (targets) {
								targets.push(child);
							}
						}
						if ((type === 1 || type === 9 || type === 11) && child.childNodes.length) {
							_getChildStyles(child, props, targets);
						}
					}
				};
	
			/**
			 * Typically only useful for className tweens that may affect child elements, this method creates a TweenLite
			 * and then compares the style properties of all the target's child elements at the tween's start and end, and
			 * if any are different, it also creates tweens for those and returns an array containing ALL of the resulting
			 * tweens (so that you can easily add() them to a TimelineLite, for example). The reason this functionality is
			 * wrapped into a separate static method of CSSPlugin instead of being integrated into all regular className tweens
			 * is because it creates entirely new tweens that may have completely different targets than the original tween,
			 * so if they were all lumped into the original tween instance, it would be inconsistent with the rest of the API
			 * and it would create other problems. For example:
			 *  - If I create a tween of elementA, that tween instance may suddenly change its target to include 50 other elements (unintuitive if I specifically defined the target I wanted)
			 *  - We can't just create new independent tweens because otherwise, what happens if the original/parent tween is reversed or pause or dropped into a TimelineLite for tight control? You'd expect that tween's behavior to affect all the others.
			 *  - Analyzing every style property of every child before and after the tween is an expensive operation when there are many children, so this behavior shouldn't be imposed on all className tweens by default, especially since it's probably rare that this extra functionality is needed.
			 *
			 * @param {Object} target object to be tweened
			 * @param {number} Duration in seconds (or frames for frames-based tweens)
			 * @param {Object} Object containing the end values, like {className:"newClass", ease:Linear.easeNone}
			 * @return {Array} An array of TweenLite instances
			 */
			CSSPlugin.cascadeTo = function(target, duration, vars) {
				var tween = TweenLite.to(target, duration, vars),
					results = [tween],
					b = [],
					e = [],
					targets = [],
					_reservedProps = TweenLite._internals.reservedProps,
					i, difs, p, from;
				target = tween._targets || tween.target;
				_getChildStyles(target, b, targets);
				tween.render(duration, true, true);
				_getChildStyles(target, e);
				tween.render(0, true, true);
				tween._enabled(true);
				i = targets.length;
				while (--i > -1) {
					difs = _cssDif(targets[i], b[i], e[i]);
					if (difs.firstMPT) {
						difs = difs.difs;
						for (p in vars) {
							if (_reservedProps[p]) {
								difs[p] = vars[p];
							}
						}
						from = {};
						for (p in difs) {
							from[p] = b[i][p];
						}
						results.push(TweenLite.fromTo(targets[i], duration, from, difs));
					}
				}
				return results;
			};
	
			TweenPlugin.activate([CSSPlugin]);
			return CSSPlugin;
	
		}, true);
	
		
		
		
		
		
		
		
		
		
		
	/*
	 * ----------------------------------------------------------------
	 * RoundPropsPlugin
	 * ----------------------------------------------------------------
	 */
		(function() {
	
			var RoundPropsPlugin = _gsScope._gsDefine.plugin({
					propName: "roundProps",
					version: "1.7.0",
					priority: -1,
					API: 2,
	
					//called when the tween renders for the first time. This is where initial values should be recorded and any setup routines should run.
					init: function(target, value, tween) {
						this._tween = tween;
						return true;
					}
	
				}),
				_getRoundFunc = function(v) { //pass in 0.1 get a function that'll round to the nearest tenth, or 5 to round to the closest 5, or 0.001 to the closest 1000th, etc.
					var p = v < 1 ? Math.pow(10, (v + "").length - 2) : 1; //to avoid floating point math errors (like 24 * 0.1 == 2.4000000000000004), we chop off at a specific number of decimal places (much faster than toFixed()
					return function(n) {
						return ((Math.round(n / v) * v * p) | 0) / p;
					};
				},
				_roundLinkedList = function(node, mod) {
					while (node) {
						if (!node.f && !node.blob) {
							node.m = mod || Math.round;
						}
						node = node._next;
					}
				},
				p = RoundPropsPlugin.prototype;
	
			p._onInitAllProps = function() {
				var tween = this._tween,
					rp = tween.vars.roundProps,
					lookup = {},
					rpt = tween._propLookup.roundProps,
					pt, next, i, p;
				if (typeof(rp) === "object" && !rp.push) {
					for (p in rp) {
						lookup[p] = _getRoundFunc(rp[p]);
					}
				} else {
					if (typeof(rp) === "string") {
						rp = rp.split(",");
					}
					i = rp.length;
					while (--i > -1) {
						lookup[rp[i]] = Math.round;
					}
				}
	
				for (p in lookup) {
					pt = tween._firstPT;
					while (pt) {
						next = pt._next; //record here, because it may get removed
						if (pt.pg) {
							pt.t._mod(lookup);
						} else if (pt.n === p) {
							if (pt.f === 2 && pt.t) { //a blob (text containing multiple numeric values)
								_roundLinkedList(pt.t._firstPT, lookup[p]);
							} else {
								this._add(pt.t, p, pt.s, pt.c, lookup[p]);
								//remove from linked list
								if (next) {
									next._prev = pt._prev;
								}
								if (pt._prev) {
									pt._prev._next = next;
								} else if (tween._firstPT === pt) {
									tween._firstPT = next;
								}
								pt._next = pt._prev = null;
								tween._propLookup[p] = rpt;
							}
						}
						pt = next;
					}
				}
				return false;
			};
	
			p._add = function(target, p, s, c, mod) {
				this._addTween(target, p, s, s + c, p, mod || Math.round);
				this._overwriteProps.push(p);
			};
	
		}());
	
	
	
	
	
	
	
	
	
	
	/*
	 * ----------------------------------------------------------------
	 * AttrPlugin
	 * ----------------------------------------------------------------
	 */
	
		(function() {
	
			_gsScope._gsDefine.plugin({
				propName: "attr",
				API: 2,
				version: "0.6.1",
	
				//called when the tween renders for the first time. This is where initial values should be recorded and any setup routines should run.
				init: function(target, value, tween, index) {
					var p, end;
					if (typeof(target.setAttribute) !== "function") {
						return false;
					}
					for (p in value) {
						end = value[p];
						if (typeof(end) === "function") {
							end = end(index, target);
						}
						this._addTween(target, "setAttribute", target.getAttribute(p) + "", end + "", p, false, p);
						this._overwriteProps.push(p);
					}
					return true;
				}
	
			});
	
		}());
	
	
	
	
	
	
	
	
	
	
	/*
	 * ----------------------------------------------------------------
	 * DirectionalRotationPlugin
	 * ----------------------------------------------------------------
	 */
		_gsScope._gsDefine.plugin({
			propName: "directionalRotation",
			version: "0.3.1",
			API: 2,
	
			//called when the tween renders for the first time. This is where initial values should be recorded and any setup routines should run.
			init: function(target, value, tween, index) {
				if (typeof(value) !== "object") {
					value = {rotation:value};
				}
				this.finals = {};
				var cap = (value.useRadians === true) ? Math.PI * 2 : 360,
					min = 0.000001,
					p, v, start, end, dif, split;
				for (p in value) {
					if (p !== "useRadians") {
						end = value[p];
						if (typeof(end) === "function") {
							end = end(index, target);
						}
						split = (end + "").split("_");
						v = split[0];
						start = parseFloat( (typeof(target[p]) !== "function") ? target[p] : target[ ((p.indexOf("set") || typeof(target["get" + p.substr(3)]) !== "function") ? p : "get" + p.substr(3)) ]() );
						end = this.finals[p] = (typeof(v) === "string" && v.charAt(1) === "=") ? start + parseInt(v.charAt(0) + "1", 10) * Number(v.substr(2)) : Number(v) || 0;
						dif = end - start;
						if (split.length) {
							v = split.join("_");
							if (v.indexOf("short") !== -1) {
								dif = dif % cap;
								if (dif !== dif % (cap / 2)) {
									dif = (dif < 0) ? dif + cap : dif - cap;
								}
							}
							if (v.indexOf("_cw") !== -1 && dif < 0) {
								dif = ((dif + cap * 9999999999) % cap) - ((dif / cap) | 0) * cap;
							} else if (v.indexOf("ccw") !== -1 && dif > 0) {
								dif = ((dif - cap * 9999999999) % cap) - ((dif / cap) | 0) * cap;
							}
						}
						if (dif > min || dif < -min) {
							this._addTween(target, p, start, start + dif, p);
							this._overwriteProps.push(p);
						}
					}
				}
				return true;
			},
	
			//called each time the values should be updated, and the ratio gets passed as the only parameter (typically it's a value between 0 and 1, but it can exceed those when using an ease like Elastic.easeOut or Back.easeOut, etc.)
			set: function(ratio) {
				var pt;
				if (ratio !== 1) {
					this._super.setRatio.call(this, ratio);
				} else {
					pt = this._firstPT;
					while (pt) {
						if (pt.f) {
							pt.t[pt.p](this.finals[pt.p]);
						} else {
							pt.t[pt.p] = this.finals[pt.p];
						}
						pt = pt._next;
					}
				}
			}
	
		})._autoCSS = true;
	
	
	
	
	
	
	
		
		
		
		
	/*
	 * ----------------------------------------------------------------
	 * EasePack
	 * ----------------------------------------------------------------
	 */
		_gsScope._gsDefine("easing.Back", ["easing.Ease"], function(Ease) {
			
			var w = (_gsScope.GreenSockGlobals || _gsScope),
				gs = w.com.greensock,
				_2PI = Math.PI * 2,
				_HALF_PI = Math.PI / 2,
				_class = gs._class,
				_create = function(n, f) {
					var C = _class("easing." + n, function(){}, true),
						p = C.prototype = new Ease();
					p.constructor = C;
					p.getRatio = f;
					return C;
				},
				_easeReg = Ease.register || function(){}, //put an empty function in place just as a safety measure in case someone loads an OLD version of TweenLite.js where Ease.register doesn't exist.
				_wrap = function(name, EaseOut, EaseIn, EaseInOut, aliases) {
					var C = _class("easing."+name, {
						easeOut:new EaseOut(),
						easeIn:new EaseIn(),
						easeInOut:new EaseInOut()
					}, true);
					_easeReg(C, name);
					return C;
				},
				EasePoint = function(time, value, next) {
					this.t = time;
					this.v = value;
					if (next) {
						this.next = next;
						next.prev = this;
						this.c = next.v - value;
						this.gap = next.t - time;
					}
				},
	
				//Back
				_createBack = function(n, f) {
					var C = _class("easing." + n, function(overshoot) {
							this._p1 = (overshoot || overshoot === 0) ? overshoot : 1.70158;
							this._p2 = this._p1 * 1.525;
						}, true),
						p = C.prototype = new Ease();
					p.constructor = C;
					p.getRatio = f;
					p.config = function(overshoot) {
						return new C(overshoot);
					};
					return C;
				},
	
				Back = _wrap("Back",
					_createBack("BackOut", function(p) {
						return ((p = p - 1) * p * ((this._p1 + 1) * p + this._p1) + 1);
					}),
					_createBack("BackIn", function(p) {
						return p * p * ((this._p1 + 1) * p - this._p1);
					}),
					_createBack("BackInOut", function(p) {
						return ((p *= 2) < 1) ? 0.5 * p * p * ((this._p2 + 1) * p - this._p2) : 0.5 * ((p -= 2) * p * ((this._p2 + 1) * p + this._p2) + 2);
					})
				),
	
	
				//SlowMo
				SlowMo = _class("easing.SlowMo", function(linearRatio, power, yoyoMode) {
					power = (power || power === 0) ? power : 0.7;
					if (linearRatio == null) {
						linearRatio = 0.7;
					} else if (linearRatio > 1) {
						linearRatio = 1;
					}
					this._p = (linearRatio !== 1) ? power : 0;
					this._p1 = (1 - linearRatio) / 2;
					this._p2 = linearRatio;
					this._p3 = this._p1 + this._p2;
					this._calcEnd = (yoyoMode === true);
				}, true),
				p = SlowMo.prototype = new Ease(),
				SteppedEase, ExpoScaleEase, RoughEase, _createElastic;
	
			p.constructor = SlowMo;
			p.getRatio = function(p) {
				var r = p + (0.5 - p) * this._p;
				if (p < this._p1) {
					return this._calcEnd ? 1 - ((p = 1 - (p / this._p1)) * p) : r - ((p = 1 - (p / this._p1)) * p * p * p * r);
				} else if (p > this._p3) {
					return this._calcEnd ? (p === 1 ? 0 : 1 - (p = (p - this._p3) / this._p1) * p) : r + ((p - r) * (p = (p - this._p3) / this._p1) * p * p * p); //added p === 1 ? 0 to avoid floating point rounding errors from affecting the final value, like 1 - 0.7 = 0.30000000000000004 instead of 0.3
				}
				return this._calcEnd ? 1 : r;
			};
			SlowMo.ease = new SlowMo(0.7, 0.7);
	
			p.config = SlowMo.config = function(linearRatio, power, yoyoMode) {
				return new SlowMo(linearRatio, power, yoyoMode);
			};
	
	
			//SteppedEase
			SteppedEase = _class("easing.SteppedEase", function(steps, immediateStart) {
					steps = steps || 1;
					this._p1 = 1 / steps;
					this._p2 = steps + (immediateStart ? 0 : 1);
					this._p3 = immediateStart ? 1 : 0;
				}, true);
			p = SteppedEase.prototype = new Ease();
			p.constructor = SteppedEase;
			p.getRatio = function(p) {
				if (p < 0) {
					p = 0;
				} else if (p >= 1) {
					p = 0.999999999;
				}
				return (((this._p2 * p) | 0) + this._p3) * this._p1;
			};
			p.config = SteppedEase.config = function(steps, immediateStart) {
				return new SteppedEase(steps, immediateStart);
			};
	
			//ExpoScaleEase
			ExpoScaleEase = _class("easing.ExpoScaleEase", function(start, end, ease) {
				this._p1 = Math.log(end / start);
				this._p2 = end - start;
				this._p3 = start;
				this._ease = ease;
			}, true);
			p = ExpoScaleEase.prototype = new Ease();
			p.constructor = ExpoScaleEase;
			p.getRatio = function(p) {
				if (this._ease) {
					p = this._ease.getRatio(p);
				}
				return (this._p3 * Math.exp(this._p1 * p) - this._p3) / this._p2;
			};
			p.config = ExpoScaleEase.config = function(start, end, ease) {
				return new ExpoScaleEase(start, end, ease);
			};
	
	
			//RoughEase
			RoughEase = _class("easing.RoughEase", function(vars) {
				vars = vars || {};
				var taper = vars.taper || "none",
					a = [],
					cnt = 0,
					points = (vars.points || 20) | 0,
					i = points,
					randomize = (vars.randomize !== false),
					clamp = (vars.clamp === true),
					template = (vars.template instanceof Ease) ? vars.template : null,
					strength = (typeof(vars.strength) === "number") ? vars.strength * 0.4 : 0.4,
					x, y, bump, invX, obj, pnt;
				while (--i > -1) {
					x = randomize ? Math.random() : (1 / points) * i;
					y = template ? template.getRatio(x) : x;
					if (taper === "none") {
						bump = strength;
					} else if (taper === "out") {
						invX = 1 - x;
						bump = invX * invX * strength;
					} else if (taper === "in") {
						bump = x * x * strength;
					} else if (x < 0.5) {  //"both" (start)
						invX = x * 2;
						bump = invX * invX * 0.5 * strength;
					} else {				//"both" (end)
						invX = (1 - x) * 2;
						bump = invX * invX * 0.5 * strength;
					}
					if (randomize) {
						y += (Math.random() * bump) - (bump * 0.5);
					} else if (i % 2) {
						y += bump * 0.5;
					} else {
						y -= bump * 0.5;
					}
					if (clamp) {
						if (y > 1) {
							y = 1;
						} else if (y < 0) {
							y = 0;
						}
					}
					a[cnt++] = {x:x, y:y};
				}
				a.sort(function(a, b) {
					return a.x - b.x;
				});
	
				pnt = new EasePoint(1, 1, null);
				i = points;
				while (--i > -1) {
					obj = a[i];
					pnt = new EasePoint(obj.x, obj.y, pnt);
				}
	
				this._prev = new EasePoint(0, 0, (pnt.t !== 0) ? pnt : pnt.next);
			}, true);
			p = RoughEase.prototype = new Ease();
			p.constructor = RoughEase;
			p.getRatio = function(p) {
				var pnt = this._prev;
				if (p > pnt.t) {
					while (pnt.next && p >= pnt.t) {
						pnt = pnt.next;
					}
					pnt = pnt.prev;
				} else {
					while (pnt.prev && p <= pnt.t) {
						pnt = pnt.prev;
					}
				}
				this._prev = pnt;
				return (pnt.v + ((p - pnt.t) / pnt.gap) * pnt.c);
			};
			p.config = function(vars) {
				return new RoughEase(vars);
			};
			RoughEase.ease = new RoughEase();
	
	
			//Bounce
			_wrap("Bounce",
				_create("BounceOut", function(p) {
					if (p < 1 / 2.75) {
						return 7.5625 * p * p;
					} else if (p < 2 / 2.75) {
						return 7.5625 * (p -= 1.5 / 2.75) * p + 0.75;
					} else if (p < 2.5 / 2.75) {
						return 7.5625 * (p -= 2.25 / 2.75) * p + 0.9375;
					}
					return 7.5625 * (p -= 2.625 / 2.75) * p + 0.984375;
				}),
				_create("BounceIn", function(p) {
					if ((p = 1 - p) < 1 / 2.75) {
						return 1 - (7.5625 * p * p);
					} else if (p < 2 / 2.75) {
						return 1 - (7.5625 * (p -= 1.5 / 2.75) * p + 0.75);
					} else if (p < 2.5 / 2.75) {
						return 1 - (7.5625 * (p -= 2.25 / 2.75) * p + 0.9375);
					}
					return 1 - (7.5625 * (p -= 2.625 / 2.75) * p + 0.984375);
				}),
				_create("BounceInOut", function(p) {
					var invert = (p < 0.5);
					if (invert) {
						p = 1 - (p * 2);
					} else {
						p = (p * 2) - 1;
					}
					if (p < 1 / 2.75) {
						p = 7.5625 * p * p;
					} else if (p < 2 / 2.75) {
						p = 7.5625 * (p -= 1.5 / 2.75) * p + 0.75;
					} else if (p < 2.5 / 2.75) {
						p = 7.5625 * (p -= 2.25 / 2.75) * p + 0.9375;
					} else {
						p = 7.5625 * (p -= 2.625 / 2.75) * p + 0.984375;
					}
					return invert ? (1 - p) * 0.5 : p * 0.5 + 0.5;
				})
			);
	
	
			//CIRC
			_wrap("Circ",
				_create("CircOut", function(p) {
					return Math.sqrt(1 - (p = p - 1) * p);
				}),
				_create("CircIn", function(p) {
					return -(Math.sqrt(1 - (p * p)) - 1);
				}),
				_create("CircInOut", function(p) {
					return ((p*=2) < 1) ? -0.5 * (Math.sqrt(1 - p * p) - 1) : 0.5 * (Math.sqrt(1 - (p -= 2) * p) + 1);
				})
			);
	
	
			//Elastic
			_createElastic = function(n, f, def) {
				var C = _class("easing." + n, function(amplitude, period) {
						this._p1 = (amplitude >= 1) ? amplitude : 1; //note: if amplitude is < 1, we simply adjust the period for a more natural feel. Otherwise the math doesn't work right and the curve starts at 1.
						this._p2 = (period || def) / (amplitude < 1 ? amplitude : 1);
						this._p3 = this._p2 / _2PI * (Math.asin(1 / this._p1) || 0);
						this._p2 = _2PI / this._p2; //precalculate to optimize
					}, true),
					p = C.prototype = new Ease();
				p.constructor = C;
				p.getRatio = f;
				p.config = function(amplitude, period) {
					return new C(amplitude, period);
				};
				return C;
			};
			_wrap("Elastic",
				_createElastic("ElasticOut", function(p) {
					return this._p1 * Math.pow(2, -10 * p) * Math.sin( (p - this._p3) * this._p2 ) + 1;
				}, 0.3),
				_createElastic("ElasticIn", function(p) {
					return -(this._p1 * Math.pow(2, 10 * (p -= 1)) * Math.sin( (p - this._p3) * this._p2 ));
				}, 0.3),
				_createElastic("ElasticInOut", function(p) {
					return ((p *= 2) < 1) ? -0.5 * (this._p1 * Math.pow(2, 10 * (p -= 1)) * Math.sin( (p - this._p3) * this._p2)) : this._p1 * Math.pow(2, -10 *(p -= 1)) * Math.sin( (p - this._p3) * this._p2 ) * 0.5 + 1;
				}, 0.45)
			);
	
	
			//Expo
			_wrap("Expo",
				_create("ExpoOut", function(p) {
					return 1 - Math.pow(2, -10 * p);
				}),
				_create("ExpoIn", function(p) {
					return Math.pow(2, 10 * (p - 1)) - 0.001;
				}),
				_create("ExpoInOut", function(p) {
					return ((p *= 2) < 1) ? 0.5 * Math.pow(2, 10 * (p - 1)) : 0.5 * (2 - Math.pow(2, -10 * (p - 1)));
				})
			);
	
	
			//Sine
			_wrap("Sine",
				_create("SineOut", function(p) {
					return Math.sin(p * _HALF_PI);
				}),
				_create("SineIn", function(p) {
					return -Math.cos(p * _HALF_PI) + 1;
				}),
				_create("SineInOut", function(p) {
					return -0.5 * (Math.cos(Math.PI * p) - 1);
				})
			);
	
			_class("easing.EaseLookup", {
					find:function(s) {
						return Ease.map[s];
					}
				}, true);
	
			//register the non-standard eases
			_easeReg(w.SlowMo, "SlowMo", "ease,");
			_easeReg(RoughEase, "RoughEase", "ease,");
			_easeReg(SteppedEase, "SteppedEase", "ease,");
	
			return Back;
			
		}, true);
	
	
	});
	
	if (_gsScope._gsDefine) { _gsScope._gsQueue.pop()(); } //necessary in case TweenLite was already loaded separately.
	
	
	
	
	
	
	
	
	
	
	
	/*
	 * ----------------------------------------------------------------
	 * Base classes like TweenLite, SimpleTimeline, Ease, Ticker, etc.
	 * ----------------------------------------------------------------
	 */
	(function(window, moduleName) {
	
			"use strict";
			var _exports = {},
				_doc = window.document,
				_globals = window.GreenSockGlobals = window.GreenSockGlobals || window;
			if (_globals.TweenLite) {
				return _globals.TweenLite; //in case the core set of classes is already loaded, don't instantiate twice.
			}
			var _namespace = function(ns) {
					var a = ns.split("."),
						p = _globals, i;
					for (i = 0; i < a.length; i++) {
						p[a[i]] = p = p[a[i]] || {};
					}
					return p;
				},
				gs = _namespace("com.greensock"),
				_tinyNum = 0.0000000001,
				_slice = function(a) { //don't use Array.prototype.slice.call(target, 0) because that doesn't work in IE8 with a NodeList that's returned by querySelectorAll()
					var b = [],
						l = a.length,
						i;
					for (i = 0; i !== l; b.push(a[i++])) {}
					return b;
				},
				_emptyFunc = function() {},
				_isArray = (function() { //works around issues in iframe environments where the Array global isn't shared, thus if the object originates in a different window/iframe, "(obj instanceof Array)" will evaluate false. We added some speed optimizations to avoid Object.prototype.toString.call() unless it's absolutely necessary because it's VERY slow (like 20x slower)
					var toString = Object.prototype.toString,
						array = toString.call([]);
					return function(obj) {
						return obj != null && (obj instanceof Array || (typeof(obj) === "object" && !!obj.push && toString.call(obj) === array));
					};
				}()),
				a, i, p, _ticker, _tickerActive,
				_defLookup = {},
	
				/**
				 * @constructor
				 * Defines a GreenSock class, optionally with an array of dependencies that must be instantiated first and passed into the definition.
				 * This allows users to load GreenSock JS files in any order even if they have interdependencies (like CSSPlugin extends TweenPlugin which is
				 * inside TweenLite.js, but if CSSPlugin is loaded first, it should wait to run its code until TweenLite.js loads and instantiates TweenPlugin
				 * and then pass TweenPlugin to CSSPlugin's definition). This is all done automatically and internally.
				 *
				 * Every definition will be added to a "com.greensock" global object (typically window, but if a window.GreenSockGlobals object is found,
				 * it will go there as of v1.7). For example, TweenLite will be found at window.com.greensock.TweenLite and since it's a global class that should be available anywhere,
				 * it is ALSO referenced at window.TweenLite. However some classes aren't considered global, like the base com.greensock.core.Animation class, so
				 * those will only be at the package like window.com.greensock.core.Animation. Again, if you define a GreenSockGlobals object on the window, everything
				 * gets tucked neatly inside there instead of on the window directly. This allows you to do advanced things like load multiple versions of GreenSock
				 * files and put them into distinct objects (imagine a banner ad uses a newer version but the main site uses an older one). In that case, you could
				 * sandbox the banner one like:
				 *
				 * <script>
				 *     var gs = window.GreenSockGlobals = {}; //the newer version we're about to load could now be referenced in a "gs" object, like gs.TweenLite.to(...). Use whatever alias you want as long as it's unique, "gs" or "banner" or whatever.
				 * </script>
				 * <script src="js/greensock/v1.7/TweenMax.js"></script>
				 * <script>
				 *     window.GreenSockGlobals = window._gsQueue = window._gsDefine = null; //reset it back to null (along with the special _gsQueue variable) so that the next load of TweenMax affects the window and we can reference things directly like TweenLite.to(...)
				 * </script>
				 * <script src="js/greensock/v1.6/TweenMax.js"></script>
				 * <script>
				 *     gs.TweenLite.to(...); //would use v1.7
				 *     TweenLite.to(...); //would use v1.6
				 * </script>
				 *
				 * @param {!string} ns The namespace of the class definition, leaving off "com.greensock." as that's assumed. For example, "TweenLite" or "plugins.CSSPlugin" or "easing.Back".
				 * @param {!Array.<string>} dependencies An array of dependencies (described as their namespaces minus "com.greensock." prefix). For example ["TweenLite","plugins.TweenPlugin","core.Animation"]
				 * @param {!function():Object} func The function that should be called and passed the resolved dependencies which will return the actual class for this definition.
				 * @param {boolean=} global If true, the class will be added to the global scope (typically window unless you define a window.GreenSockGlobals object)
				 */
				Definition = function(ns, dependencies, func, global) {
					this.sc = (_defLookup[ns]) ? _defLookup[ns].sc : []; //subclasses
					_defLookup[ns] = this;
					this.gsClass = null;
					this.func = func;
					var _classes = [];
					this.check = function(init) {
						var i = dependencies.length,
							missing = i,
							cur, a, n, cl;
						while (--i > -1) {
							if ((cur = _defLookup[dependencies[i]] || new Definition(dependencies[i], [])).gsClass) {
								_classes[i] = cur.gsClass;
								missing--;
							} else if (init) {
								cur.sc.push(this);
							}
						}
						if (missing === 0 && func) {
							a = ("com.greensock." + ns).split(".");
							n = a.pop();
							cl = _namespace(a.join("."))[n] = this.gsClass = func.apply(func, _classes);
	
							//exports to multiple environments
							if (global) {
								_globals[n] = _exports[n] = cl; //provides a way to avoid global namespace pollution. By default, the main classes like TweenLite, Power1, Strong, etc. are added to window unless a GreenSockGlobals is defined. So if you want to have things added to a custom object instead, just do something like window.GreenSockGlobals = {} before loading any GreenSock files. You can even set up an alias like window.GreenSockGlobals = windows.gs = {} so that you can access everything like gs.TweenLite. Also remember that ALL classes are added to the window.com.greensock object (in their respective packages, like com.greensock.easing.Power1, com.greensock.TweenLite, etc.)
								if (typeof(module) !== "undefined" && module.exports) { //node
									if (ns === moduleName) {
										module.exports = _exports[moduleName] = cl;
										for (i in _exports) {
											cl[i] = _exports[i];
										}
									} else if (_exports[moduleName]) {
										_exports[moduleName][n] = cl;
									}
								} else if (true){ //AMD
									!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function() { return cl; }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
								}
							}
							for (i = 0; i < this.sc.length; i++) {
								this.sc[i].check();
							}
						}
					};
					this.check(true);
				},
	
				//used to create Definition instances (which basically registers a class that has dependencies).
				_gsDefine = window._gsDefine = function(ns, dependencies, func, global) {
					return new Definition(ns, dependencies, func, global);
				},
	
				//a quick way to create a class that doesn't have any dependencies. Returns the class, but first registers it in the GreenSock namespace so that other classes can grab it (other classes might be dependent on the class).
				_class = gs._class = function(ns, func, global) {
					func = func || function() {};
					_gsDefine(ns, [], function(){ return func; }, global);
					return func;
				};
	
			_gsDefine.globals = _globals;
	
	
	
	/*
	 * ----------------------------------------------------------------
	 * Ease
	 * ----------------------------------------------------------------
	 */
			var _baseParams = [0, 0, 1, 1],
				Ease = _class("easing.Ease", function(func, extraParams, type, power) {
					this._func = func;
					this._type = type || 0;
					this._power = power || 0;
					this._params = extraParams ? _baseParams.concat(extraParams) : _baseParams;
				}, true),
				_easeMap = Ease.map = {},
				_easeReg = Ease.register = function(ease, names, types, create) {
					var na = names.split(","),
						i = na.length,
						ta = (types || "easeIn,easeOut,easeInOut").split(","),
						e, name, j, type;
					while (--i > -1) {
						name = na[i];
						e = create ? _class("easing."+name, null, true) : gs.easing[name] || {};
						j = ta.length;
						while (--j > -1) {
							type = ta[j];
							_easeMap[name + "." + type] = _easeMap[type + name] = e[type] = ease.getRatio ? ease : ease[type] || new ease();
						}
					}
				};
	
			p = Ease.prototype;
			p._calcEnd = false;
			p.getRatio = function(p) {
				if (this._func) {
					this._params[0] = p;
					return this._func.apply(null, this._params);
				}
				var t = this._type,
					pw = this._power,
					r = (t === 1) ? 1 - p : (t === 2) ? p : (p < 0.5) ? p * 2 : (1 - p) * 2;
				if (pw === 1) {
					r *= r;
				} else if (pw === 2) {
					r *= r * r;
				} else if (pw === 3) {
					r *= r * r * r;
				} else if (pw === 4) {
					r *= r * r * r * r;
				}
				return (t === 1) ? 1 - r : (t === 2) ? r : (p < 0.5) ? r / 2 : 1 - (r / 2);
			};
	
			//create all the standard eases like Linear, Quad, Cubic, Quart, Quint, Strong, Power0, Power1, Power2, Power3, and Power4 (each with easeIn, easeOut, and easeInOut)
			a = ["Linear","Quad","Cubic","Quart","Quint,Strong"];
			i = a.length;
			while (--i > -1) {
				p = a[i]+",Power"+i;
				_easeReg(new Ease(null,null,1,i), p, "easeOut", true);
				_easeReg(new Ease(null,null,2,i), p, "easeIn" + ((i === 0) ? ",easeNone" : ""));
				_easeReg(new Ease(null,null,3,i), p, "easeInOut");
			}
			_easeMap.linear = gs.easing.Linear.easeIn;
			_easeMap.swing = gs.easing.Quad.easeInOut; //for jQuery folks
	
	
	/*
	 * ----------------------------------------------------------------
	 * EventDispatcher
	 * ----------------------------------------------------------------
	 */
			var EventDispatcher = _class("events.EventDispatcher", function(target) {
				this._listeners = {};
				this._eventTarget = target || this;
			});
			p = EventDispatcher.prototype;
	
			p.addEventListener = function(type, callback, scope, useParam, priority) {
				priority = priority || 0;
				var list = this._listeners[type],
					index = 0,
					listener, i;
				if (this === _ticker && !_tickerActive) {
					_ticker.wake();
				}
				if (list == null) {
					this._listeners[type] = list = [];
				}
				i = list.length;
				while (--i > -1) {
					listener = list[i];
					if (listener.c === callback && listener.s === scope) {
						list.splice(i, 1);
					} else if (index === 0 && listener.pr < priority) {
						index = i + 1;
					}
				}
				list.splice(index, 0, {c:callback, s:scope, up:useParam, pr:priority});
			};
	
			p.removeEventListener = function(type, callback) {
				var list = this._listeners[type], i;
				if (list) {
					i = list.length;
					while (--i > -1) {
						if (list[i].c === callback) {
							list.splice(i, 1);
							return;
						}
					}
				}
			};
	
			p.dispatchEvent = function(type) {
				var list = this._listeners[type],
					i, t, listener;
				if (list) {
					i = list.length;
					if (i > 1) {
						list = list.slice(0); //in case addEventListener() is called from within a listener/callback (otherwise the index could change, resulting in a skip)
					}
					t = this._eventTarget;
					while (--i > -1) {
						listener = list[i];
						if (listener) {
							if (listener.up) {
								listener.c.call(listener.s || t, {type:type, target:t});
							} else {
								listener.c.call(listener.s || t);
							}
						}
					}
				}
			};
	
	
	/*
	 * ----------------------------------------------------------------
	 * Ticker
	 * ----------------------------------------------------------------
	 */
	 		var _reqAnimFrame = window.requestAnimationFrame,
				_cancelAnimFrame = window.cancelAnimationFrame,
				_getTime = Date.now || function() {return new Date().getTime();},
				_lastUpdate = _getTime();
	
			//now try to determine the requestAnimationFrame and cancelAnimationFrame functions and if none are found, we'll use a setTimeout()/clearTimeout() polyfill.
			a = ["ms","moz","webkit","o"];
			i = a.length;
			while (--i > -1 && !_reqAnimFrame) {
				_reqAnimFrame = window[a[i] + "RequestAnimationFrame"];
				_cancelAnimFrame = window[a[i] + "CancelAnimationFrame"] || window[a[i] + "CancelRequestAnimationFrame"];
			}
	
			_class("Ticker", function(fps, useRAF) {
				var _self = this,
					_startTime = _getTime(),
					_useRAF = (useRAF !== false && _reqAnimFrame) ? "auto" : false,
					_lagThreshold = 500,
					_adjustedLag = 33,
					_tickWord = "tick", //helps reduce gc burden
					_fps, _req, _id, _gap, _nextTime,
					_tick = function(manual) {
						var elapsed = _getTime() - _lastUpdate,
							overlap, dispatch;
						if (elapsed > _lagThreshold) {
							_startTime += elapsed - _adjustedLag;
						}
						_lastUpdate += elapsed;
						_self.time = (_lastUpdate - _startTime) / 1000;
						overlap = _self.time - _nextTime;
						if (!_fps || overlap > 0 || manual === true) {
							_self.frame++;
							_nextTime += overlap + (overlap >= _gap ? 0.004 : _gap - overlap);
							dispatch = true;
						}
						if (manual !== true) { //make sure the request is made before we dispatch the "tick" event so that timing is maintained. Otherwise, if processing the "tick" requires a bunch of time (like 15ms) and we're using a setTimeout() that's based on 16.7ms, it'd technically take 31.7ms between frames otherwise.
							_id = _req(_tick);
						}
						if (dispatch) {
							_self.dispatchEvent(_tickWord);
						}
					};
	
				EventDispatcher.call(_self);
				_self.time = _self.frame = 0;
				_self.tick = function() {
					_tick(true);
				};
	
				_self.lagSmoothing = function(threshold, adjustedLag) {
					if (!arguments.length) { //if lagSmoothing() is called with no arguments, treat it like a getter that returns a boolean indicating if it's enabled or not. This is purposely undocumented and is for internal use.
						return (_lagThreshold < 1 / _tinyNum);
					}
					_lagThreshold = threshold || (1 / _tinyNum); //zero should be interpreted as basically unlimited
					_adjustedLag = Math.min(adjustedLag, _lagThreshold, 0);
				};
	
				_self.sleep = function() {
					if (_id == null) {
						return;
					}
					if (!_useRAF || !_cancelAnimFrame) {
						clearTimeout(_id);
					} else {
						_cancelAnimFrame(_id);
					}
					_req = _emptyFunc;
					_id = null;
					if (_self === _ticker) {
						_tickerActive = false;
					}
				};
	
				_self.wake = function(seamless) {
					if (_id !== null) {
						_self.sleep();
					} else if (seamless) {
						_startTime += -_lastUpdate + (_lastUpdate = _getTime());
					} else if (_self.frame > 10) { //don't trigger lagSmoothing if we're just waking up, and make sure that at least 10 frames have elapsed because of the iOS bug that we work around below with the 1.5-second setTimout().
						_lastUpdate = _getTime() - _lagThreshold + 5;
					}
					_req = (_fps === 0) ? _emptyFunc : (!_useRAF || !_reqAnimFrame) ? function(f) { return setTimeout(f, ((_nextTime - _self.time) * 1000 + 1) | 0); } : _reqAnimFrame;
					if (_self === _ticker) {
						_tickerActive = true;
					}
					_tick(2);
				};
	
				_self.fps = function(value) {
					if (!arguments.length) {
						return _fps;
					}
					_fps = value;
					_gap = 1 / (_fps || 60);
					_nextTime = this.time + _gap;
					_self.wake();
				};
	
				_self.useRAF = function(value) {
					if (!arguments.length) {
						return _useRAF;
					}
					_self.sleep();
					_useRAF = value;
					_self.fps(_fps);
				};
				_self.fps(fps);
	
				//a bug in iOS 6 Safari occasionally prevents the requestAnimationFrame from working initially, so we use a 1.5-second timeout that automatically falls back to setTimeout() if it senses this condition.
				setTimeout(function() {
					if (_useRAF === "auto" && _self.frame < 5 && (_doc || {}).visibilityState !== "hidden") {
						_self.useRAF(false);
					}
				}, 1500);
			});
	
			p = gs.Ticker.prototype = new gs.events.EventDispatcher();
			p.constructor = gs.Ticker;
	
	
	/*
	 * ----------------------------------------------------------------
	 * Animation
	 * ----------------------------------------------------------------
	 */
			var Animation = _class("core.Animation", function(duration, vars) {
					this.vars = vars = vars || {};
					this._duration = this._totalDuration = duration || 0;
					this._delay = Number(vars.delay) || 0;
					this._timeScale = 1;
					this._active = (vars.immediateRender === true);
					this.data = vars.data;
					this._reversed = (vars.reversed === true);
	
					if (!_rootTimeline) {
						return;
					}
					if (!_tickerActive) { //some browsers (like iOS 6 Safari) shut down JavaScript execution when the tab is disabled and they [occasionally] neglect to start up requestAnimationFrame again when returning - this code ensures that the engine starts up again properly.
						_ticker.wake();
					}
	
					var tl = this.vars.useFrames ? _rootFramesTimeline : _rootTimeline;
					tl.add(this, tl._time);
	
					if (this.vars.paused) {
						this.paused(true);
					}
				});
	
			_ticker = Animation.ticker = new gs.Ticker();
			p = Animation.prototype;
			p._dirty = p._gc = p._initted = p._paused = false;
			p._totalTime = p._time = 0;
			p._rawPrevTime = -1;
			p._next = p._last = p._onUpdate = p._timeline = p.timeline = null;
			p._paused = false;
	
	
			//some browsers (like iOS) occasionally drop the requestAnimationFrame event when the user switches to a different tab and then comes back again, so we use a 2-second setTimeout() to sense if/when that condition occurs and then wake() the ticker.
			var _checkTimeout = function() {
					if (_tickerActive && _getTime() - _lastUpdate > 2000 && ((_doc || {}).visibilityState !== "hidden" || !_ticker.lagSmoothing())) { //note: if the tab is hidden, we should still wake if lagSmoothing has been disabled.
						_ticker.wake();
					}
					var t = setTimeout(_checkTimeout, 2000);
					if (t.unref) {
						// allows a node process to exit even if the timeout’s callback hasn't been invoked. Without it, the node process could hang as this function is called every two seconds.
						t.unref();
					}
				};
			_checkTimeout();
	
	
			p.play = function(from, suppressEvents) {
				if (from != null) {
					this.seek(from, suppressEvents);
				}
				return this.reversed(false).paused(false);
			};
	
			p.pause = function(atTime, suppressEvents) {
				if (atTime != null) {
					this.seek(atTime, suppressEvents);
				}
				return this.paused(true);
			};
	
			p.resume = function(from, suppressEvents) {
				if (from != null) {
					this.seek(from, suppressEvents);
				}
				return this.paused(false);
			};
	
			p.seek = function(time, suppressEvents) {
				return this.totalTime(Number(time), suppressEvents !== false);
			};
	
			p.restart = function(includeDelay, suppressEvents) {
				return this.reversed(false).paused(false).totalTime(includeDelay ? -this._delay : 0, (suppressEvents !== false), true);
			};
	
			p.reverse = function(from, suppressEvents) {
				if (from != null) {
					this.seek((from || this.totalDuration()), suppressEvents);
				}
				return this.reversed(true).paused(false);
			};
	
			p.render = function(time, suppressEvents, force) {
				//stub - we override this method in subclasses.
			};
	
			p.invalidate = function() {
				this._time = this._totalTime = 0;
				this._initted = this._gc = false;
				this._rawPrevTime = -1;
				if (this._gc || !this.timeline) {
					this._enabled(true);
				}
				return this;
			};
	
			p.isActive = function() {
				var tl = this._timeline, //the 2 root timelines won't have a _timeline; they're always active.
					startTime = this._startTime,
					rawTime;
				return (!tl || (!this._gc && !this._paused && tl.isActive() && (rawTime = tl.rawTime(true)) >= startTime && rawTime < startTime + this.totalDuration() / this._timeScale - 0.0000001));
			};
	
			p._enabled = function (enabled, ignoreTimeline) {
				if (!_tickerActive) {
					_ticker.wake();
				}
				this._gc = !enabled;
				this._active = this.isActive();
				if (ignoreTimeline !== true) {
					if (enabled && !this.timeline) {
						this._timeline.add(this, this._startTime - this._delay);
					} else if (!enabled && this.timeline) {
						this._timeline._remove(this, true);
					}
				}
				return false;
			};
	
	
			p._kill = function(vars, target) {
				return this._enabled(false, false);
			};
	
			p.kill = function(vars, target) {
				this._kill(vars, target);
				return this;
			};
	
			p._uncache = function(includeSelf) {
				var tween = includeSelf ? this : this.timeline;
				while (tween) {
					tween._dirty = true;
					tween = tween.timeline;
				}
				return this;
			};
	
			p._swapSelfInParams = function(params) {
				var i = params.length,
					copy = params.concat();
				while (--i > -1) {
					if (params[i] === "{self}") {
						copy[i] = this;
					}
				}
				return copy;
			};
	
			p._callback = function(type) {
				var v = this.vars,
					callback = v[type],
					params = v[type + "Params"],
					scope = v[type + "Scope"] || v.callbackScope || this,
					l = params ? params.length : 0;
				switch (l) { //speed optimization; call() is faster than apply() so use it when there are only a few parameters (which is by far most common). Previously we simply did var v = this.vars; v[type].apply(v[type + "Scope"] || v.callbackScope || this, v[type + "Params"] || _blankArray);
					case 0: callback.call(scope); break;
					case 1: callback.call(scope, params[0]); break;
					case 2: callback.call(scope, params[0], params[1]); break;
					default: callback.apply(scope, params);
				}
			};
	
	//----Animation getters/setters --------------------------------------------------------
	
			p.eventCallback = function(type, callback, params, scope) {
				if ((type || "").substr(0,2) === "on") {
					var v = this.vars;
					if (arguments.length === 1) {
						return v[type];
					}
					if (callback == null) {
						delete v[type];
					} else {
						v[type] = callback;
						v[type + "Params"] = (_isArray(params) && params.join("").indexOf("{self}") !== -1) ? this._swapSelfInParams(params) : params;
						v[type + "Scope"] = scope;
					}
					if (type === "onUpdate") {
						this._onUpdate = callback;
					}
				}
				return this;
			};
	
			p.delay = function(value) {
				if (!arguments.length) {
					return this._delay;
				}
				if (this._timeline.smoothChildTiming) {
					this.startTime( this._startTime + value - this._delay );
				}
				this._delay = value;
				return this;
			};
	
			p.duration = function(value) {
				if (!arguments.length) {
					this._dirty = false;
					return this._duration;
				}
				this._duration = this._totalDuration = value;
				this._uncache(true); //true in case it's a TweenMax or TimelineMax that has a repeat - we'll need to refresh the totalDuration.
				if (this._timeline.smoothChildTiming) if (this._time > 0) if (this._time < this._duration) if (value !== 0) {
					this.totalTime(this._totalTime * (value / this._duration), true);
				}
				return this;
			};
	
			p.totalDuration = function(value) {
				this._dirty = false;
				return (!arguments.length) ? this._totalDuration : this.duration(value);
			};
	
			p.time = function(value, suppressEvents) {
				if (!arguments.length) {
					return this._time;
				}
				if (this._dirty) {
					this.totalDuration();
				}
				return this.totalTime((value > this._duration) ? this._duration : value, suppressEvents);
			};
	
			p.totalTime = function(time, suppressEvents, uncapped) {
				if (!_tickerActive) {
					_ticker.wake();
				}
				if (!arguments.length) {
					return this._totalTime;
				}
				if (this._timeline) {
					if (time < 0 && !uncapped) {
						time += this.totalDuration();
					}
					if (this._timeline.smoothChildTiming) {
						if (this._dirty) {
							this.totalDuration();
						}
						var totalDuration = this._totalDuration,
							tl = this._timeline;
						if (time > totalDuration && !uncapped) {
							time = totalDuration;
						}
						this._startTime = (this._paused ? this._pauseTime : tl._time) - ((!this._reversed ? time : totalDuration - time) / this._timeScale);
						if (!tl._dirty) { //for performance improvement. If the parent's cache is already dirty, it already took care of marking the ancestors as dirty too, so skip the function call here.
							this._uncache(false);
						}
						//in case any of the ancestor timelines had completed but should now be enabled, we should reset their totalTime() which will also ensure that they're lined up properly and enabled. Skip for animations that are on the root (wasteful). Example: a TimelineLite.exportRoot() is performed when there's a paused tween on the root, the export will not complete until that tween is unpaused, but imagine a child gets restarted later, after all [unpaused] tweens have completed. The startTime of that child would get pushed out, but one of the ancestors may have completed.
						if (tl._timeline) {
							while (tl._timeline) {
								if (tl._timeline._time !== (tl._startTime + tl._totalTime) / tl._timeScale) {
									tl.totalTime(tl._totalTime, true);
								}
								tl = tl._timeline;
							}
						}
					}
					if (this._gc) {
						this._enabled(true, false);
					}
					if (this._totalTime !== time || this._duration === 0) {
						if (_lazyTweens.length) {
							_lazyRender();
						}
						this.render(time, suppressEvents, false);
						if (_lazyTweens.length) { //in case rendering caused any tweens to lazy-init, we should render them because typically when someone calls seek() or time() or progress(), they expect an immediate render.
							_lazyRender();
						}
					}
				}
				return this;
			};
	
			p.progress = p.totalProgress = function(value, suppressEvents) {
				var duration = this.duration();
				return (!arguments.length) ? (duration ? this._time / duration : this.ratio) : this.totalTime(duration * value, suppressEvents);
			};
	
			p.startTime = function(value) {
				if (!arguments.length) {
					return this._startTime;
				}
				if (value !== this._startTime) {
					this._startTime = value;
					if (this.timeline) if (this.timeline._sortChildren) {
						this.timeline.add(this, value - this._delay); //ensures that any necessary re-sequencing of Animations in the timeline occurs to make sure the rendering order is correct.
					}
				}
				return this;
			};
	
			p.endTime = function(includeRepeats) {
				return this._startTime + ((includeRepeats != false) ? this.totalDuration() : this.duration()) / this._timeScale;
			};
	
			p.timeScale = function(value) {
				if (!arguments.length) {
					return this._timeScale;
				}
				var pauseTime, t;
				value = value || _tinyNum; //can't allow zero because it'll throw the math off
				if (this._timeline && this._timeline.smoothChildTiming) {
					pauseTime = this._pauseTime;
					t = (pauseTime || pauseTime === 0) ? pauseTime : this._timeline.totalTime();
					this._startTime = t - ((t - this._startTime) * this._timeScale / value);
				}
				this._timeScale = value;
				t = this.timeline;
				while (t && t.timeline) { //must update the duration/totalDuration of all ancestor timelines immediately in case in the middle of a render loop, one tween alters another tween's timeScale which shoves its startTime before 0, forcing the parent timeline to shift around and shiftChildren() which could affect that next tween's render (startTime). Doesn't matter for the root timeline though.
					t._dirty = true;
					t.totalDuration();
					t = t.timeline;
				}
				return this;
			};
	
			p.reversed = function(value) {
				if (!arguments.length) {
					return this._reversed;
				}
				if (value != this._reversed) {
					this._reversed = value;
					this.totalTime(((this._timeline && !this._timeline.smoothChildTiming) ? this.totalDuration() - this._totalTime : this._totalTime), true);
				}
				return this;
			};
	
			p.paused = function(value) {
				if (!arguments.length) {
					return this._paused;
				}
				var tl = this._timeline,
					raw, elapsed;
				if (value != this._paused) if (tl) {
					if (!_tickerActive && !value) {
						_ticker.wake();
					}
					raw = tl.rawTime();
					elapsed = raw - this._pauseTime;
					if (!value && tl.smoothChildTiming) {
						this._startTime += elapsed;
						this._uncache(false);
					}
					this._pauseTime = value ? raw : null;
					this._paused = value;
					this._active = this.isActive();
					if (!value && elapsed !== 0 && this._initted && this.duration()) {
						raw = tl.smoothChildTiming ? this._totalTime : (raw - this._startTime) / this._timeScale;
						this.render(raw, (raw === this._totalTime), true); //in case the target's properties changed via some other tween or manual update by the user, we should force a render.
					}
				}
				if (this._gc && !value) {
					this._enabled(true, false);
				}
				return this;
			};
	
	
	/*
	 * ----------------------------------------------------------------
	 * SimpleTimeline
	 * ----------------------------------------------------------------
	 */
			var SimpleTimeline = _class("core.SimpleTimeline", function(vars) {
				Animation.call(this, 0, vars);
				this.autoRemoveChildren = this.smoothChildTiming = true;
			});
	
			p = SimpleTimeline.prototype = new Animation();
			p.constructor = SimpleTimeline;
			p.kill()._gc = false;
			p._first = p._last = p._recent = null;
			p._sortChildren = false;
	
			p.add = p.insert = function(child, position, align, stagger) {
				var prevTween, st;
				child._startTime = Number(position || 0) + child._delay;
				if (child._paused) if (this !== child._timeline) { //we only adjust the _pauseTime if it wasn't in this timeline already. Remember, sometimes a tween will be inserted again into the same timeline when its startTime is changed so that the tweens in the TimelineLite/Max are re-ordered properly in the linked list (so everything renders in the proper order).
					child._pauseTime = this.rawTime() - (child._timeline.rawTime() - child._pauseTime);
				}
				if (child.timeline) {
					child.timeline._remove(child, true); //removes from existing timeline so that it can be properly added to this one.
				}
				child.timeline = child._timeline = this;
				if (child._gc) {
					child._enabled(true, true);
				}
				prevTween = this._last;
				if (this._sortChildren) {
					st = child._startTime;
					while (prevTween && prevTween._startTime > st) {
						prevTween = prevTween._prev;
					}
				}
				if (prevTween) {
					child._next = prevTween._next;
					prevTween._next = child;
				} else {
					child._next = this._first;
					this._first = child;
				}
				if (child._next) {
					child._next._prev = child;
				} else {
					this._last = child;
				}
				child._prev = prevTween;
				this._recent = child;
				if (this._timeline) {
					this._uncache(true);
				}
				return this;
			};
	
			p._remove = function(tween, skipDisable) {
				if (tween.timeline === this) {
					if (!skipDisable) {
						tween._enabled(false, true);
					}
	
					if (tween._prev) {
						tween._prev._next = tween._next;
					} else if (this._first === tween) {
						this._first = tween._next;
					}
					if (tween._next) {
						tween._next._prev = tween._prev;
					} else if (this._last === tween) {
						this._last = tween._prev;
					}
					tween._next = tween._prev = tween.timeline = null;
					if (tween === this._recent) {
						this._recent = this._last;
					}
	
					if (this._timeline) {
						this._uncache(true);
					}
				}
				return this;
			};
	
			p.render = function(time, suppressEvents, force) {
				var tween = this._first,
					next;
				this._totalTime = this._time = this._rawPrevTime = time;
				while (tween) {
					next = tween._next; //record it here because the value could change after rendering...
					if (tween._active || (time >= tween._startTime && !tween._paused && !tween._gc)) {
						if (!tween._reversed) {
							tween.render((time - tween._startTime) * tween._timeScale, suppressEvents, force);
						} else {
							tween.render(((!tween._dirty) ? tween._totalDuration : tween.totalDuration()) - ((time - tween._startTime) * tween._timeScale), suppressEvents, force);
						}
					}
					tween = next;
				}
			};
	
			p.rawTime = function() {
				if (!_tickerActive) {
					_ticker.wake();
				}
				return this._totalTime;
			};
	
	/*
	 * ----------------------------------------------------------------
	 * TweenLite
	 * ----------------------------------------------------------------
	 */
			var TweenLite = _class("TweenLite", function(target, duration, vars) {
					Animation.call(this, duration, vars);
					this.render = TweenLite.prototype.render; //speed optimization (avoid prototype lookup on this "hot" method)
	
					if (target == null) {
						throw "Cannot tween a null target.";
					}
	
					this.target = target = (typeof(target) !== "string") ? target : TweenLite.selector(target) || target;
	
					var isSelector = (target.jquery || (target.length && target !== window && target[0] && (target[0] === window || (target[0].nodeType && target[0].style && !target.nodeType)))),
						overwrite = this.vars.overwrite,
						i, targ, targets;
	
					this._overwrite = overwrite = (overwrite == null) ? _overwriteLookup[TweenLite.defaultOverwrite] : (typeof(overwrite) === "number") ? overwrite >> 0 : _overwriteLookup[overwrite];
	
					if ((isSelector || target instanceof Array || (target.push && _isArray(target))) && typeof(target[0]) !== "number") {
						this._targets = targets = _slice(target);  //don't use Array.prototype.slice.call(target, 0) because that doesn't work in IE8 with a NodeList that's returned by querySelectorAll()
						this._propLookup = [];
						this._siblings = [];
						for (i = 0; i < targets.length; i++) {
							targ = targets[i];
							if (!targ) {
								targets.splice(i--, 1);
								continue;
							} else if (typeof(targ) === "string") {
								targ = targets[i--] = TweenLite.selector(targ); //in case it's an array of strings
								if (typeof(targ) === "string") {
									targets.splice(i+1, 1); //to avoid an endless loop (can't imagine why the selector would return a string, but just in case)
								}
								continue;
							} else if (targ.length && targ !== window && targ[0] && (targ[0] === window || (targ[0].nodeType && targ[0].style && !targ.nodeType))) { //in case the user is passing in an array of selector objects (like jQuery objects), we need to check one more level and pull things out if necessary. Also note that <select> elements pass all the criteria regarding length and the first child having style, so we must also check to ensure the target isn't an HTML node itself.
								targets.splice(i--, 1);
								this._targets = targets = targets.concat(_slice(targ));
								continue;
							}
							this._siblings[i] = _register(targ, this, false);
							if (overwrite === 1) if (this._siblings[i].length > 1) {
								_applyOverwrite(targ, this, null, 1, this._siblings[i]);
							}
						}
	
					} else {
						this._propLookup = {};
						this._siblings = _register(target, this, false);
						if (overwrite === 1) if (this._siblings.length > 1) {
							_applyOverwrite(target, this, null, 1, this._siblings);
						}
					}
					if (this.vars.immediateRender || (duration === 0 && this._delay === 0 && this.vars.immediateRender !== false)) {
						this._time = -_tinyNum; //forces a render without having to set the render() "force" parameter to true because we want to allow lazying by default (using the "force" parameter always forces an immediate full render)
						this.render(Math.min(0, -this._delay)); //in case delay is negative
					}
				}, true),
				_isSelector = function(v) {
					return (v && v.length && v !== window && v[0] && (v[0] === window || (v[0].nodeType && v[0].style && !v.nodeType))); //we cannot check "nodeType" if the target is window from within an iframe, otherwise it will trigger a security error in some browsers like Firefox.
				},
				_autoCSS = function(vars, target) {
					var css = {},
						p;
					for (p in vars) {
						if (!_reservedProps[p] && (!(p in target) || p === "transform" || p === "x" || p === "y" || p === "width" || p === "height" || p === "className" || p === "border") && (!_plugins[p] || (_plugins[p] && _plugins[p]._autoCSS))) { //note: <img> elements contain read-only "x" and "y" properties. We should also prioritize editing css width/height rather than the element's properties.
							css[p] = vars[p];
							delete vars[p];
						}
					}
					vars.css = css;
				};
	
			p = TweenLite.prototype = new Animation();
			p.constructor = TweenLite;
			p.kill()._gc = false;
	
	//----TweenLite defaults, overwrite management, and root updates ----------------------------------------------------
	
			p.ratio = 0;
			p._firstPT = p._targets = p._overwrittenProps = p._startAt = null;
			p._notifyPluginsOfEnabled = p._lazy = false;
	
			TweenLite.version = "1.20.5";
			TweenLite.defaultEase = p._ease = new Ease(null, null, 1, 1);
			TweenLite.defaultOverwrite = "auto";
			TweenLite.ticker = _ticker;
			TweenLite.autoSleep = 120;
			TweenLite.lagSmoothing = function(threshold, adjustedLag) {
				_ticker.lagSmoothing(threshold, adjustedLag);
			};
	
			TweenLite.selector = window.$ || window.jQuery || function(e) {
				var selector = window.$ || window.jQuery;
				if (selector) {
					TweenLite.selector = selector;
					return selector(e);
				}
				if (!_doc) { //in some dev environments (like Angular 6), GSAP gets loaded before the document is defined! So re-query it here if/when necessary.
					_doc = window.document;
				}
				return (!_doc) ? e : (_doc.querySelectorAll ? _doc.querySelectorAll(e) : _doc.getElementById((e.charAt(0) === "#") ? e.substr(1) : e));
			};
	
			var _lazyTweens = [],
				_lazyLookup = {},
				_numbersExp = /(?:(-|-=|\+=)?\d*\.?\d*(?:e[\-+]?\d+)?)[0-9]/ig,
				_relExp = /[\+-]=-?[\.\d]/,
				//_nonNumbersExp = /(?:([\-+](?!(\d|=)))|[^\d\-+=e]|(e(?![\-+][\d])))+/ig,
				_setRatio = function(v) {
					var pt = this._firstPT,
						min = 0.000001,
						val;
					while (pt) {
						val = !pt.blob ? pt.c * v + pt.s : (v === 1 && this.end != null) ? this.end : v ? this.join("") : this.start;
						if (pt.m) {
							val = pt.m.call(this._tween, val, this._target || pt.t, this._tween);
						} else if (val < min) if (val > -min && !pt.blob) { //prevents issues with converting very small numbers to strings in the browser
							val = 0;
						}
						if (!pt.f) {
							pt.t[pt.p] = val;
						} else if (pt.fp) {
							pt.t[pt.p](pt.fp, val);
						} else {
							pt.t[pt.p](val);
						}
						pt = pt._next;
					}
				},
				//compares two strings (start/end), finds the numbers that are different and spits back an array representing the whole value but with the changing values isolated as elements. For example, "rgb(0,0,0)" and "rgb(100,50,0)" would become ["rgb(", 0, ",", 50, ",0)"]. Notice it merges the parts that are identical (performance optimization). The array also has a linked list of PropTweens attached starting with _firstPT that contain the tweening data (t, p, s, c, f, etc.). It also stores the starting value as a "start" property so that we can revert to it if/when necessary, like when a tween rewinds fully. If the quantity of numbers differs between the start and end, it will always prioritize the end value(s). The pt parameter is optional - it's for a PropTween that will be appended to the end of the linked list and is typically for actually setting the value after all of the elements have been updated (with array.join("")).
				_blobDif = function(start, end, filter, pt) {
					var a = [],
						charIndex = 0,
						s = "",
						color = 0,
						startNums, endNums, num, i, l, nonNumbers, currentNum;
					a.start = start;
					a.end = end;
					start = a[0] = start + ""; //ensure values are strings
					end = a[1] = end + "";
					if (filter) {
						filter(a); //pass an array with the starting and ending values and let the filter do whatever it needs to the values.
						start = a[0];
						end = a[1];
					}
					a.length = 0;
					startNums = start.match(_numbersExp) || [];
					endNums = end.match(_numbersExp) || [];
					if (pt) {
						pt._next = null;
						pt.blob = 1;
						a._firstPT = a._applyPT = pt; //apply last in the linked list (which means inserting it first)
					}
					l = endNums.length;
					for (i = 0; i < l; i++) {
						currentNum = endNums[i];
						nonNumbers = end.substr(charIndex, end.indexOf(currentNum, charIndex)-charIndex);
						s += (nonNumbers || !i) ? nonNumbers : ","; //note: SVG spec allows omission of comma/space when a negative sign is wedged between two numbers, like 2.5-5.3 instead of 2.5,-5.3 but when tweening, the negative value may switch to positive, so we insert the comma just in case.
						charIndex += nonNumbers.length;
						if (color) { //sense rgba() values and round them.
							color = (color + 1) % 5;
						} else if (nonNumbers.substr(-5) === "rgba(") {
							color = 1;
						}
						if (currentNum === startNums[i] || startNums.length <= i) {
							s += currentNum;
						} else {
							if (s) {
								a.push(s);
								s = "";
							}
							num = parseFloat(startNums[i]);
							a.push(num);
							a._firstPT = {_next: a._firstPT, t:a, p: a.length-1, s:num, c:((currentNum.charAt(1) === "=") ? parseInt(currentNum.charAt(0) + "1", 10) * parseFloat(currentNum.substr(2)) : (parseFloat(currentNum) - num)) || 0, f:0, m:(color && color < 4) ? Math.round : 0};
							//note: we don't set _prev because we'll never need to remove individual PropTweens from this list.
						}
						charIndex += currentNum.length;
					}
					s += end.substr(charIndex);
					if (s) {
						a.push(s);
					}
					a.setRatio = _setRatio;
					if (_relExp.test(end)) { //if the end string contains relative values, delete it so that on the final render (in _setRatio()), we don't actually set it to the string with += or -= characters (forces it to use the calculated value).
						a.end = null;
					}
					return a;
				},
				//note: "funcParam" is only necessary for function-based getters/setters that require an extra parameter like getAttribute("width") and setAttribute("width", value). In this example, funcParam would be "width". Used by AttrPlugin for example.
				_addPropTween = function(target, prop, start, end, overwriteProp, mod, funcParam, stringFilter, index) {
					if (typeof(end) === "function") {
						end = end(index || 0, target);
					}
					var type = typeof(target[prop]),
						getterName = (type !== "function") ? "" : ((prop.indexOf("set") || typeof(target["get" + prop.substr(3)]) !== "function") ? prop : "get" + prop.substr(3)),
						s = (start !== "get") ? start : !getterName ? target[prop] : funcParam ? target[getterName](funcParam) : target[getterName](),
						isRelative = (typeof(end) === "string" && end.charAt(1) === "="),
						pt = {t:target, p:prop, s:s, f:(type === "function"), pg:0, n:overwriteProp || prop, m:(!mod ? 0 : (typeof(mod) === "function") ? mod : Math.round), pr:0, c:isRelative ? parseInt(end.charAt(0) + "1", 10) * parseFloat(end.substr(2)) : (parseFloat(end) - s) || 0},
						blob;
	
					if (typeof(s) !== "number" || (typeof(end) !== "number" && !isRelative)) {
						if (funcParam || isNaN(s) || (!isRelative && isNaN(end)) || typeof(s) === "boolean" || typeof(end) === "boolean") {
							//a blob (string that has multiple numbers in it)
							pt.fp = funcParam;
							blob = _blobDif(s, (isRelative ? (parseFloat(pt.s) + pt.c) + (pt.s + "").replace(/[0-9\-\.]/g, "") : end), stringFilter || TweenLite.defaultStringFilter, pt);
							pt = {t: blob, p: "setRatio", s: 0, c: 1, f: 2, pg: 0, n: overwriteProp || prop, pr: 0, m: 0}; //"2" indicates it's a Blob property tween. Needed for RoundPropsPlugin for example.
						} else {
							pt.s = parseFloat(s);
							if (!isRelative) {
								pt.c = (parseFloat(end) - pt.s) || 0;
							}
						}
					}
					if (pt.c) { //only add it to the linked list if there's a change.
						if ((pt._next = this._firstPT)) {
							pt._next._prev = pt;
						}
						this._firstPT = pt;
						return pt;
					}
				},
				_internals = TweenLite._internals = {isArray:_isArray, isSelector:_isSelector, lazyTweens:_lazyTweens, blobDif:_blobDif}, //gives us a way to expose certain private values to other GreenSock classes without contaminating tha main TweenLite object.
				_plugins = TweenLite._plugins = {},
				_tweenLookup = _internals.tweenLookup = {},
				_tweenLookupNum = 0,
				_reservedProps = _internals.reservedProps = {ease:1, delay:1, overwrite:1, onComplete:1, onCompleteParams:1, onCompleteScope:1, useFrames:1, runBackwards:1, startAt:1, onUpdate:1, onUpdateParams:1, onUpdateScope:1, onStart:1, onStartParams:1, onStartScope:1, onReverseComplete:1, onReverseCompleteParams:1, onReverseCompleteScope:1, onRepeat:1, onRepeatParams:1, onRepeatScope:1, easeParams:1, yoyo:1, immediateRender:1, repeat:1, repeatDelay:1, data:1, paused:1, reversed:1, autoCSS:1, lazy:1, onOverwrite:1, callbackScope:1, stringFilter:1, id:1, yoyoEase:1},
				_overwriteLookup = {none:0, all:1, auto:2, concurrent:3, allOnStart:4, preexisting:5, "true":1, "false":0},
				_rootFramesTimeline = Animation._rootFramesTimeline = new SimpleTimeline(),
				_rootTimeline = Animation._rootTimeline = new SimpleTimeline(),
				_nextGCFrame = 30,
				_lazyRender = _internals.lazyRender = function() {
					var i = _lazyTweens.length,
						tween;
					_lazyLookup = {};
					while (--i > -1) {
						tween = _lazyTweens[i];
						if (tween && tween._lazy !== false) {
							tween.render(tween._lazy[0], tween._lazy[1], true);
							tween._lazy = false;
						}
					}
					_lazyTweens.length = 0;
				};
	
			_rootTimeline._startTime = _ticker.time;
			_rootFramesTimeline._startTime = _ticker.frame;
			_rootTimeline._active = _rootFramesTimeline._active = true;
			setTimeout(_lazyRender, 1); //on some mobile devices, there isn't a "tick" before code runs which means any lazy renders wouldn't run before the next official "tick".
	
			Animation._updateRoot = TweenLite.render = function() {
					var i, a, p;
					if (_lazyTweens.length) { //if code is run outside of the requestAnimationFrame loop, there may be tweens queued AFTER the engine refreshed, so we need to ensure any pending renders occur before we refresh again.
						_lazyRender();
					}
					_rootTimeline.render((_ticker.time - _rootTimeline._startTime) * _rootTimeline._timeScale, false, false);
					_rootFramesTimeline.render((_ticker.frame - _rootFramesTimeline._startTime) * _rootFramesTimeline._timeScale, false, false);
					if (_lazyTweens.length) {
						_lazyRender();
					}
					if (_ticker.frame >= _nextGCFrame) { //dump garbage every 120 frames or whatever the user sets TweenLite.autoSleep to
						_nextGCFrame = _ticker.frame + (parseInt(TweenLite.autoSleep, 10) || 120);
						for (p in _tweenLookup) {
							a = _tweenLookup[p].tweens;
							i = a.length;
							while (--i > -1) {
								if (a[i]._gc) {
									a.splice(i, 1);
								}
							}
							if (a.length === 0) {
								delete _tweenLookup[p];
							}
						}
						//if there are no more tweens in the root timelines, or if they're all paused, make the _timer sleep to reduce load on the CPU slightly
						p = _rootTimeline._first;
						if (!p || p._paused) if (TweenLite.autoSleep && !_rootFramesTimeline._first && _ticker._listeners.tick.length === 1) {
							while (p && p._paused) {
								p = p._next;
							}
							if (!p) {
								_ticker.sleep();
							}
						}
					}
				};
	
			_ticker.addEventListener("tick", Animation._updateRoot);
	
			var _register = function(target, tween, scrub) {
					var id = target._gsTweenID, a, i;
					if (!_tweenLookup[id || (target._gsTweenID = id = "t" + (_tweenLookupNum++))]) {
						_tweenLookup[id] = {target:target, tweens:[]};
					}
					if (tween) {
						a = _tweenLookup[id].tweens;
						a[(i = a.length)] = tween;
						if (scrub) {
							while (--i > -1) {
								if (a[i] === tween) {
									a.splice(i, 1);
								}
							}
						}
					}
					return _tweenLookup[id].tweens;
				},
				_onOverwrite = function(overwrittenTween, overwritingTween, target, killedProps) {
					var func = overwrittenTween.vars.onOverwrite, r1, r2;
					if (func) {
						r1 = func(overwrittenTween, overwritingTween, target, killedProps);
					}
					func = TweenLite.onOverwrite;
					if (func) {
						r2 = func(overwrittenTween, overwritingTween, target, killedProps);
					}
					return (r1 !== false && r2 !== false);
				},
				_applyOverwrite = function(target, tween, props, mode, siblings) {
					var i, changed, curTween, l;
					if (mode === 1 || mode >= 4) {
						l = siblings.length;
						for (i = 0; i < l; i++) {
							if ((curTween = siblings[i]) !== tween) {
								if (!curTween._gc) {
									if (curTween._kill(null, target, tween)) {
										changed = true;
									}
								}
							} else if (mode === 5) {
								break;
							}
						}
						return changed;
					}
					//NOTE: Add 0.0000000001 to overcome floating point errors that can cause the startTime to be VERY slightly off (when a tween's time() is set for example)
					var startTime = tween._startTime + _tinyNum,
						overlaps = [],
						oCount = 0,
						zeroDur = (tween._duration === 0),
						globalStart;
					i = siblings.length;
					while (--i > -1) {
						if ((curTween = siblings[i]) === tween || curTween._gc || curTween._paused) {
							//ignore
						} else if (curTween._timeline !== tween._timeline) {
							globalStart = globalStart || _checkOverlap(tween, 0, zeroDur);
							if (_checkOverlap(curTween, globalStart, zeroDur) === 0) {
								overlaps[oCount++] = curTween;
							}
						} else if (curTween._startTime <= startTime) if (curTween._startTime + curTween.totalDuration() / curTween._timeScale > startTime) if (!((zeroDur || !curTween._initted) && startTime - curTween._startTime <= 0.0000000002)) {
							overlaps[oCount++] = curTween;
						}
					}
	
					i = oCount;
					while (--i > -1) {
						curTween = overlaps[i];
						if (mode === 2) if (curTween._kill(props, target, tween)) {
							changed = true;
						}
						if (mode !== 2 || (!curTween._firstPT && curTween._initted)) {
							if (mode !== 2 && !_onOverwrite(curTween, tween)) {
								continue;
							}
							if (curTween._enabled(false, false)) { //if all property tweens have been overwritten, kill the tween.
								changed = true;
							}
						}
					}
					return changed;
				},
				_checkOverlap = function(tween, reference, zeroDur) {
					var tl = tween._timeline,
						ts = tl._timeScale,
						t = tween._startTime;
					while (tl._timeline) {
						t += tl._startTime;
						ts *= tl._timeScale;
						if (tl._paused) {
							return -100;
						}
						tl = tl._timeline;
					}
					t /= ts;
					return (t > reference) ? t - reference : ((zeroDur && t === reference) || (!tween._initted && t - reference < 2 * _tinyNum)) ? _tinyNum : ((t += tween.totalDuration() / tween._timeScale / ts) > reference + _tinyNum) ? 0 : t - reference - _tinyNum;
				};
	
	
	//---- TweenLite instance methods -----------------------------------------------------------------------------
	
			p._init = function() {
				var v = this.vars,
					op = this._overwrittenProps,
					dur = this._duration,
					immediate = !!v.immediateRender,
					ease = v.ease,
					i, initPlugins, pt, p, startVars, l;
				if (v.startAt) {
					if (this._startAt) {
						this._startAt.render(-1, true); //if we've run a startAt previously (when the tween instantiated), we should revert it so that the values re-instantiate correctly particularly for relative tweens. Without this, a TweenLite.fromTo(obj, 1, {x:"+=100"}, {x:"-=100"}), for example, would actually jump to +=200 because the startAt would run twice, doubling the relative change.
						this._startAt.kill();
					}
					startVars = {};
					for (p in v.startAt) { //copy the properties/values into a new object to avoid collisions, like var to = {x:0}, from = {x:500}; timeline.fromTo(e, 1, from, to).fromTo(e, 1, to, from);
						startVars[p] = v.startAt[p];
					}
					startVars.data = "isStart";
					startVars.overwrite = false;
					startVars.immediateRender = true;
					startVars.lazy = (immediate && v.lazy !== false);
					startVars.startAt = startVars.delay = null; //no nesting of startAt objects allowed (otherwise it could cause an infinite loop).
					startVars.onUpdate = v.onUpdate;
					startVars.onUpdateParams = v.onUpdateParams;
					startVars.onUpdateScope = v.onUpdateScope || v.callbackScope || this;
					this._startAt = TweenLite.to(this.target || {}, 0, startVars);
					if (immediate) {
						if (this._time > 0) {
							this._startAt = null; //tweens that render immediately (like most from() and fromTo() tweens) shouldn't revert when their parent timeline's playhead goes backward past the startTime because the initial render could have happened anytime and it shouldn't be directly correlated to this tween's startTime. Imagine setting up a complex animation where the beginning states of various objects are rendered immediately but the tween doesn't happen for quite some time - if we revert to the starting values as soon as the playhead goes backward past the tween's startTime, it will throw things off visually. Reversion should only happen in TimelineLite/Max instances where immediateRender was false (which is the default in the convenience methods like from()).
						} else if (dur !== 0) {
							return; //we skip initialization here so that overwriting doesn't occur until the tween actually begins. Otherwise, if you create several immediateRender:true tweens of the same target/properties to drop into a TimelineLite or TimelineMax, the last one created would overwrite the first ones because they didn't get placed into the timeline yet before the first render occurs and kicks in overwriting.
						}
					}
				} else if (v.runBackwards && dur !== 0) {
					//from() tweens must be handled uniquely: their beginning values must be rendered but we don't want overwriting to occur yet (when time is still 0). Wait until the tween actually begins before doing all the routines like overwriting. At that time, we should render at the END of the tween to ensure that things initialize correctly (remember, from() tweens go backwards)
					if (this._startAt) {
						this._startAt.render(-1, true);
						this._startAt.kill();
						this._startAt = null;
					} else {
						if (this._time !== 0) { //in rare cases (like if a from() tween runs and then is invalidate()-ed), immediateRender could be true but the initial forced-render gets skipped, so there's no need to force the render in this context when the _time is greater than 0
							immediate = false;
						}
						pt = {};
						for (p in v) { //copy props into a new object and skip any reserved props, otherwise onComplete or onUpdate or onStart could fire. We should, however, permit autoCSS to go through.
							if (!_reservedProps[p] || p === "autoCSS") {
								pt[p] = v[p];
							}
						}
						pt.overwrite = 0;
						pt.data = "isFromStart"; //we tag the tween with as "isFromStart" so that if [inside a plugin] we need to only do something at the very END of a tween, we have a way of identifying this tween as merely the one that's setting the beginning values for a "from()" tween. For example, clearProps in CSSPlugin should only get applied at the very END of a tween and without this tag, from(...{height:100, clearProps:"height", delay:1}) would wipe the height at the beginning of the tween and after 1 second, it'd kick back in.
						pt.lazy = (immediate && v.lazy !== false);
						pt.immediateRender = immediate; //zero-duration tweens render immediately by default, but if we're not specifically instructed to render this tween immediately, we should skip this and merely _init() to record the starting values (rendering them immediately would push them to completion which is wasteful in that case - we'd have to render(-1) immediately after)
						this._startAt = TweenLite.to(this.target, 0, pt);
						if (!immediate) {
							this._startAt._init(); //ensures that the initial values are recorded
							this._startAt._enabled(false); //no need to have the tween render on the next cycle. Disable it because we'll always manually control the renders of the _startAt tween.
							if (this.vars.immediateRender) {
								this._startAt = null;
							}
						} else if (this._time === 0) {
							return;
						}
					}
				}
				this._ease = ease = (!ease) ? TweenLite.defaultEase : (ease instanceof Ease) ? ease : (typeof(ease) === "function") ? new Ease(ease, v.easeParams) : _easeMap[ease] || TweenLite.defaultEase;
				if (v.easeParams instanceof Array && ease.config) {
					this._ease = ease.config.apply(ease, v.easeParams);
				}
				this._easeType = this._ease._type;
				this._easePower = this._ease._power;
				this._firstPT = null;
	
				if (this._targets) {
					l = this._targets.length;
					for (i = 0; i < l; i++) {
						if ( this._initProps( this._targets[i], (this._propLookup[i] = {}), this._siblings[i], (op ? op[i] : null), i) ) {
							initPlugins = true;
						}
					}
				} else {
					initPlugins = this._initProps(this.target, this._propLookup, this._siblings, op, 0);
				}
	
				if (initPlugins) {
					TweenLite._onPluginEvent("_onInitAllProps", this); //reorders the array in order of priority. Uses a static TweenPlugin method in order to minimize file size in TweenLite
				}
				if (op) if (!this._firstPT) if (typeof(this.target) !== "function") { //if all tweening properties have been overwritten, kill the tween. If the target is a function, it's probably a delayedCall so let it live.
					this._enabled(false, false);
				}
				if (v.runBackwards) {
					pt = this._firstPT;
					while (pt) {
						pt.s += pt.c;
						pt.c = -pt.c;
						pt = pt._next;
					}
				}
				this._onUpdate = v.onUpdate;
				this._initted = true;
			};
	
			p._initProps = function(target, propLookup, siblings, overwrittenProps, index) {
				var p, i, initPlugins, plugin, pt, v;
				if (target == null) {
					return false;
				}
	
				if (_lazyLookup[target._gsTweenID]) {
					_lazyRender(); //if other tweens of the same target have recently initted but haven't rendered yet, we've got to force the render so that the starting values are correct (imagine populating a timeline with a bunch of sequential tweens and then jumping to the end)
				}
	
				if (!this.vars.css) if (target.style) if (target !== window && target.nodeType) if (_plugins.css) if (this.vars.autoCSS !== false) { //it's so common to use TweenLite/Max to animate the css of DOM elements, we assume that if the target is a DOM element, that's what is intended (a convenience so that users don't have to wrap things in css:{}, although we still recommend it for a slight performance boost and better specificity). Note: we cannot check "nodeType" on the window inside an iframe.
					_autoCSS(this.vars, target);
				}
				for (p in this.vars) {
					v = this.vars[p];
					if (_reservedProps[p]) {
						if (v) if ((v instanceof Array) || (v.push && _isArray(v))) if (v.join("").indexOf("{self}") !== -1) {
							this.vars[p] = v = this._swapSelfInParams(v, this);
						}
	
					} else if (_plugins[p] && (plugin = new _plugins[p]())._onInitTween(target, this.vars[p], this, index)) {
	
						//t - target 		[object]
						//p - property 		[string]
						//s - start			[number]
						//c - change		[number]
						//f - isFunction	[boolean]
						//n - name			[string]
						//pg - isPlugin 	[boolean]
						//pr - priority		[number]
						//m - mod           [function | 0]
						this._firstPT = pt = {_next:this._firstPT, t:plugin, p:"setRatio", s:0, c:1, f:1, n:p, pg:1, pr:plugin._priority, m:0};
						i = plugin._overwriteProps.length;
						while (--i > -1) {
							propLookup[plugin._overwriteProps[i]] = this._firstPT;
						}
						if (plugin._priority || plugin._onInitAllProps) {
							initPlugins = true;
						}
						if (plugin._onDisable || plugin._onEnable) {
							this._notifyPluginsOfEnabled = true;
						}
						if (pt._next) {
							pt._next._prev = pt;
						}
	
					} else {
						propLookup[p] = _addPropTween.call(this, target, p, "get", v, p, 0, null, this.vars.stringFilter, index);
					}
				}
	
				if (overwrittenProps) if (this._kill(overwrittenProps, target)) { //another tween may have tried to overwrite properties of this tween before init() was called (like if two tweens start at the same time, the one created second will run first)
					return this._initProps(target, propLookup, siblings, overwrittenProps, index);
				}
				if (this._overwrite > 1) if (this._firstPT) if (siblings.length > 1) if (_applyOverwrite(target, this, propLookup, this._overwrite, siblings)) {
					this._kill(propLookup, target);
					return this._initProps(target, propLookup, siblings, overwrittenProps, index);
				}
				if (this._firstPT) if ((this.vars.lazy !== false && this._duration) || (this.vars.lazy && !this._duration)) { //zero duration tweens don't lazy render by default; everything else does.
					_lazyLookup[target._gsTweenID] = true;
				}
				return initPlugins;
			};
	
			p.render = function(time, suppressEvents, force) {
				var prevTime = this._time,
					duration = this._duration,
					prevRawPrevTime = this._rawPrevTime,
					isComplete, callback, pt, rawPrevTime;
				if (time >= duration - 0.0000001 && time >= 0) { //to work around occasional floating point math artifacts.
					this._totalTime = this._time = duration;
					this.ratio = this._ease._calcEnd ? this._ease.getRatio(1) : 1;
					if (!this._reversed ) {
						isComplete = true;
						callback = "onComplete";
						force = (force || this._timeline.autoRemoveChildren); //otherwise, if the animation is unpaused/activated after it's already finished, it doesn't get removed from the parent timeline.
					}
					if (duration === 0) if (this._initted || !this.vars.lazy || force) { //zero-duration tweens are tricky because we must discern the momentum/direction of time in order to determine whether the starting values should be rendered or the ending values. If the "playhead" of its timeline goes past the zero-duration tween in the forward direction or lands directly on it, the end values should be rendered, but if the timeline's "playhead" moves past it in the backward direction (from a postitive time to a negative time), the starting values must be rendered.
						if (this._startTime === this._timeline._duration) { //if a zero-duration tween is at the VERY end of a timeline and that timeline renders at its end, it will typically add a tiny bit of cushion to the render time to prevent rounding errors from getting in the way of tweens rendering their VERY end. If we then reverse() that timeline, the zero-duration tween will trigger its onReverseComplete even though technically the playhead didn't pass over it again. It's a very specific edge case we must accommodate.
							time = 0;
						}
						if (prevRawPrevTime < 0 || (time <= 0 && time >= -0.0000001) || (prevRawPrevTime === _tinyNum && this.data !== "isPause")) if (prevRawPrevTime !== time) { //note: when this.data is "isPause", it's a callback added by addPause() on a timeline that we should not be triggered when LEAVING its exact start time. In other words, tl.addPause(1).play(1) shouldn't pause.
							force = true;
							if (prevRawPrevTime > _tinyNum) {
								callback = "onReverseComplete";
							}
						}
						this._rawPrevTime = rawPrevTime = (!suppressEvents || time || prevRawPrevTime === time) ? time : _tinyNum; //when the playhead arrives at EXACTLY time 0 (right on top) of a zero-duration tween, we need to discern if events are suppressed so that when the playhead moves again (next time), it'll trigger the callback. If events are NOT suppressed, obviously the callback would be triggered in this render. Basically, the callback should fire either when the playhead ARRIVES or LEAVES this exact spot, not both. Imagine doing a timeline.seek(0) and there's a callback that sits at 0. Since events are suppressed on that seek() by default, nothing will fire, but when the playhead moves off of that position, the callback should fire. This behavior is what people intuitively expect. We set the _rawPrevTime to be a precise tiny number to indicate this scenario rather than using another property/variable which would increase memory usage. This technique is less readable, but more efficient.
					}
	
				} else if (time < 0.0000001) { //to work around occasional floating point math artifacts, round super small values to 0.
					this._totalTime = this._time = 0;
					this.ratio = this._ease._calcEnd ? this._ease.getRatio(0) : 0;
					if (prevTime !== 0 || (duration === 0 && prevRawPrevTime > 0)) {
						callback = "onReverseComplete";
						isComplete = this._reversed;
					}
					if (time < 0) {
						this._active = false;
						if (duration === 0) if (this._initted || !this.vars.lazy || force) { //zero-duration tweens are tricky because we must discern the momentum/direction of time in order to determine whether the starting values should be rendered or the ending values. If the "playhead" of its timeline goes past the zero-duration tween in the forward direction or lands directly on it, the end values should be rendered, but if the timeline's "playhead" moves past it in the backward direction (from a postitive time to a negative time), the starting values must be rendered.
							if (prevRawPrevTime >= 0 && !(prevRawPrevTime === _tinyNum && this.data === "isPause")) {
								force = true;
							}
							this._rawPrevTime = rawPrevTime = (!suppressEvents || time || prevRawPrevTime === time) ? time : _tinyNum; //when the playhead arrives at EXACTLY time 0 (right on top) of a zero-duration tween, we need to discern if events are suppressed so that when the playhead moves again (next time), it'll trigger the callback. If events are NOT suppressed, obviously the callback would be triggered in this render. Basically, the callback should fire either when the playhead ARRIVES or LEAVES this exact spot, not both. Imagine doing a timeline.seek(0) and there's a callback that sits at 0. Since events are suppressed on that seek() by default, nothing will fire, but when the playhead moves off of that position, the callback should fire. This behavior is what people intuitively expect. We set the _rawPrevTime to be a precise tiny number to indicate this scenario rather than using another property/variable which would increase memory usage. This technique is less readable, but more efficient.
						}
					}
					if (!this._initted || (this._startAt && this._startAt.progress())) { //if we render the very beginning (time == 0) of a fromTo(), we must force the render (normal tweens wouldn't need to render at a time of 0 when the prevTime was also 0). This is also mandatory to make sure overwriting kicks in immediately. Also, we check progress() because if startAt has already rendered at its end, we should force a render at its beginning. Otherwise, if you put the playhead directly on top of where a fromTo({immediateRender:false}) starts, and then move it backwards, the from() won't revert its values.
						force = true;
					}
				} else {
					this._totalTime = this._time = time;
	
					if (this._easeType) {
						var r = time / duration, type = this._easeType, pow = this._easePower;
						if (type === 1 || (type === 3 && r >= 0.5)) {
							r = 1 - r;
						}
						if (type === 3) {
							r *= 2;
						}
						if (pow === 1) {
							r *= r;
						} else if (pow === 2) {
							r *= r * r;
						} else if (pow === 3) {
							r *= r * r * r;
						} else if (pow === 4) {
							r *= r * r * r * r;
						}
	
						if (type === 1) {
							this.ratio = 1 - r;
						} else if (type === 2) {
							this.ratio = r;
						} else if (time / duration < 0.5) {
							this.ratio = r / 2;
						} else {
							this.ratio = 1 - (r / 2);
						}
	
					} else {
						this.ratio = this._ease.getRatio(time / duration);
					}
				}
	
				if (this._time === prevTime && !force) {
					return;
				} else if (!this._initted) {
					this._init();
					if (!this._initted || this._gc) { //immediateRender tweens typically won't initialize until the playhead advances (_time is greater than 0) in order to ensure that overwriting occurs properly. Also, if all of the tweening properties have been overwritten (which would cause _gc to be true, as set in _init()), we shouldn't continue otherwise an onStart callback could be called for example.
						return;
					} else if (!force && this._firstPT && ((this.vars.lazy !== false && this._duration) || (this.vars.lazy && !this._duration))) {
						this._time = this._totalTime = prevTime;
						this._rawPrevTime = prevRawPrevTime;
						_lazyTweens.push(this);
						this._lazy = [time, suppressEvents];
						return;
					}
					//_ease is initially set to defaultEase, so now that init() has run, _ease is set properly and we need to recalculate the ratio. Overall this is faster than using conditional logic earlier in the method to avoid having to set ratio twice because we only init() once but renderTime() gets called VERY frequently.
					if (this._time && !isComplete) {
						this.ratio = this._ease.getRatio(this._time / duration);
					} else if (isComplete && this._ease._calcEnd) {
						this.ratio = this._ease.getRatio((this._time === 0) ? 0 : 1);
					}
				}
				if (this._lazy !== false) { //in case a lazy render is pending, we should flush it because the new render is occurring now (imagine a lazy tween instantiating and then immediately the user calls tween.seek(tween.duration()), skipping to the end - the end render would be forced, and then if we didn't flush the lazy render, it'd fire AFTER the seek(), rendering it at the wrong time.
					this._lazy = false;
				}
				if (!this._active) if (!this._paused && this._time !== prevTime && time >= 0) {
					this._active = true;  //so that if the user renders a tween (as opposed to the timeline rendering it), the timeline is forced to re-render and align it with the proper time/frame on the next rendering cycle. Maybe the tween already finished but the user manually re-renders it as halfway done.
				}
				if (prevTime === 0) {
					if (this._startAt) {
						if (time >= 0) {
							this._startAt.render(time, true, force);
						} else if (!callback) {
							callback = "_dummyGS"; //if no callback is defined, use a dummy value just so that the condition at the end evaluates as true because _startAt should render AFTER the normal render loop when the time is negative. We could handle this in a more intuitive way, of course, but the render loop is the MOST important thing to optimize, so this technique allows us to avoid adding extra conditional logic in a high-frequency area.
						}
					}
					if (this.vars.onStart) if (this._time !== 0 || duration === 0) if (!suppressEvents) {
						this._callback("onStart");
					}
				}
				pt = this._firstPT;
				while (pt) {
					if (pt.f) {
						pt.t[pt.p](pt.c * this.ratio + pt.s);
					} else {
						pt.t[pt.p] = pt.c * this.ratio + pt.s;
					}
					pt = pt._next;
				}
	
				if (this._onUpdate) {
					if (time < 0) if (this._startAt && time !== -0.0001) { //if the tween is positioned at the VERY beginning (_startTime 0) of its parent timeline, it's illegal for the playhead to go back further, so we should not render the recorded startAt values.
						this._startAt.render(time, true, force); //note: for performance reasons, we tuck this conditional logic inside less traveled areas (most tweens don't have an onUpdate). We'd just have it at the end before the onComplete, but the values should be updated before any onUpdate is called, so we ALSO put it here and then if it's not called, we do so later near the onComplete.
					}
					if (!suppressEvents) if (this._time !== prevTime || isComplete || force) {
						this._callback("onUpdate");
					}
				}
				if (callback) if (!this._gc || force) { //check _gc because there's a chance that kill() could be called in an onUpdate
					if (time < 0 && this._startAt && !this._onUpdate && time !== -0.0001) { //-0.0001 is a special value that we use when looping back to the beginning of a repeated TimelineMax, in which case we shouldn't render the _startAt values.
						this._startAt.render(time, true, force);
					}
					if (isComplete) {
						if (this._timeline.autoRemoveChildren) {
							this._enabled(false, false);
						}
						this._active = false;
					}
					if (!suppressEvents && this.vars[callback]) {
						this._callback(callback);
					}
					if (duration === 0 && this._rawPrevTime === _tinyNum && rawPrevTime !== _tinyNum) { //the onComplete or onReverseComplete could trigger movement of the playhead and for zero-duration tweens (which must discern direction) that land directly back on their start time, we don't want to fire again on the next render. Think of several addPause()'s in a timeline that forces the playhead to a certain spot, but what if it's already paused and another tween is tweening the "time" of the timeline? Each time it moves [forward] past that spot, it would move back, and since suppressEvents is true, it'd reset _rawPrevTime to _tinyNum so that when it begins again, the callback would fire (so ultimately it could bounce back and forth during that tween). Again, this is a very uncommon scenario, but possible nonetheless.
						this._rawPrevTime = 0;
					}
				}
			};
	
			p._kill = function(vars, target, overwritingTween) {
				if (vars === "all") {
					vars = null;
				}
				if (vars == null) if (target == null || target === this.target) {
					this._lazy = false;
					return this._enabled(false, false);
				}
				target = (typeof(target) !== "string") ? (target || this._targets || this.target) : TweenLite.selector(target) || target;
				var simultaneousOverwrite = (overwritingTween && this._time && overwritingTween._startTime === this._startTime && this._timeline === overwritingTween._timeline),
					i, overwrittenProps, p, pt, propLookup, changed, killProps, record, killed;
				if ((_isArray(target) || _isSelector(target)) && typeof(target[0]) !== "number") {
					i = target.length;
					while (--i > -1) {
						if (this._kill(vars, target[i], overwritingTween)) {
							changed = true;
						}
					}
				} else {
					if (this._targets) {
						i = this._targets.length;
						while (--i > -1) {
							if (target === this._targets[i]) {
								propLookup = this._propLookup[i] || {};
								this._overwrittenProps = this._overwrittenProps || [];
								overwrittenProps = this._overwrittenProps[i] = vars ? this._overwrittenProps[i] || {} : "all";
								break;
							}
						}
					} else if (target !== this.target) {
						return false;
					} else {
						propLookup = this._propLookup;
						overwrittenProps = this._overwrittenProps = vars ? this._overwrittenProps || {} : "all";
					}
	
					if (propLookup) {
						killProps = vars || propLookup;
						record = (vars !== overwrittenProps && overwrittenProps !== "all" && vars !== propLookup && (typeof(vars) !== "object" || !vars._tempKill)); //_tempKill is a super-secret way to delete a particular tweening property but NOT have it remembered as an official overwritten property (like in BezierPlugin)
						if (overwritingTween && (TweenLite.onOverwrite || this.vars.onOverwrite)) {
							for (p in killProps) {
								if (propLookup[p]) {
									if (!killed) {
										killed = [];
									}
									killed.push(p);
								}
							}
							if ((killed || !vars) && !_onOverwrite(this, overwritingTween, target, killed)) { //if the onOverwrite returned false, that means the user wants to override the overwriting (cancel it).
								return false;
							}
						}
	
						for (p in killProps) {
							if ((pt = propLookup[p])) {
								if (simultaneousOverwrite) { //if another tween overwrites this one and they both start at exactly the same time, yet this tween has already rendered once (for example, at 0.001) because it's first in the queue, we should revert the values to where they were at 0 so that the starting values aren't contaminated on the overwriting tween.
									if (pt.f) {
										pt.t[pt.p](pt.s);
									} else {
										pt.t[pt.p] = pt.s;
									}
									changed = true;
								}
								if (pt.pg && pt.t._kill(killProps)) {
									changed = true; //some plugins need to be notified so they can perform cleanup tasks first
								}
								if (!pt.pg || pt.t._overwriteProps.length === 0) {
									if (pt._prev) {
										pt._prev._next = pt._next;
									} else if (pt === this._firstPT) {
										this._firstPT = pt._next;
									}
									if (pt._next) {
										pt._next._prev = pt._prev;
									}
									pt._next = pt._prev = null;
								}
								delete propLookup[p];
							}
							if (record) {
								overwrittenProps[p] = 1;
							}
						}
						if (!this._firstPT && this._initted) { //if all tweening properties are killed, kill the tween. Without this line, if there's a tween with multiple targets and then you killTweensOf() each target individually, the tween would technically still remain active and fire its onComplete even though there aren't any more properties tweening.
							this._enabled(false, false);
						}
					}
				}
				return changed;
			};
	
			p.invalidate = function() {
				if (this._notifyPluginsOfEnabled) {
					TweenLite._onPluginEvent("_onDisable", this);
				}
				this._firstPT = this._overwrittenProps = this._startAt = this._onUpdate = null;
				this._notifyPluginsOfEnabled = this._active = this._lazy = false;
				this._propLookup = (this._targets) ? {} : [];
				Animation.prototype.invalidate.call(this);
				if (this.vars.immediateRender) {
					this._time = -_tinyNum; //forces a render without having to set the render() "force" parameter to true because we want to allow lazying by default (using the "force" parameter always forces an immediate full render)
					this.render(Math.min(0, -this._delay)); //in case delay is negative.
				}
				return this;
			};
	
			p._enabled = function(enabled, ignoreTimeline) {
				if (!_tickerActive) {
					_ticker.wake();
				}
				if (enabled && this._gc) {
					var targets = this._targets,
						i;
					if (targets) {
						i = targets.length;
						while (--i > -1) {
							this._siblings[i] = _register(targets[i], this, true);
						}
					} else {
						this._siblings = _register(this.target, this, true);
					}
				}
				Animation.prototype._enabled.call(this, enabled, ignoreTimeline);
				if (this._notifyPluginsOfEnabled) if (this._firstPT) {
					return TweenLite._onPluginEvent((enabled ? "_onEnable" : "_onDisable"), this);
				}
				return false;
			};
	
	
	//----TweenLite static methods -----------------------------------------------------
	
			TweenLite.to = function(target, duration, vars) {
				return new TweenLite(target, duration, vars);
			};
	
			TweenLite.from = function(target, duration, vars) {
				vars.runBackwards = true;
				vars.immediateRender = (vars.immediateRender != false);
				return new TweenLite(target, duration, vars);
			};
	
			TweenLite.fromTo = function(target, duration, fromVars, toVars) {
				toVars.startAt = fromVars;
				toVars.immediateRender = (toVars.immediateRender != false && fromVars.immediateRender != false);
				return new TweenLite(target, duration, toVars);
			};
	
			TweenLite.delayedCall = function(delay, callback, params, scope, useFrames) {
				return new TweenLite(callback, 0, {delay:delay, onComplete:callback, onCompleteParams:params, callbackScope:scope, onReverseComplete:callback, onReverseCompleteParams:params, immediateRender:false, lazy:false, useFrames:useFrames, overwrite:0});
			};
	
			TweenLite.set = function(target, vars) {
				return new TweenLite(target, 0, vars);
			};
	
			TweenLite.getTweensOf = function(target, onlyActive) {
				if (target == null) { return []; }
				target = (typeof(target) !== "string") ? target : TweenLite.selector(target) || target;
				var i, a, j, t;
				if ((_isArray(target) || _isSelector(target)) && typeof(target[0]) !== "number") {
					i = target.length;
					a = [];
					while (--i > -1) {
						a = a.concat(TweenLite.getTweensOf(target[i], onlyActive));
					}
					i = a.length;
					//now get rid of any duplicates (tweens of arrays of objects could cause duplicates)
					while (--i > -1) {
						t = a[i];
						j = i;
						while (--j > -1) {
							if (t === a[j]) {
								a.splice(i, 1);
							}
						}
					}
				} else if (target._gsTweenID) {
					a = _register(target).concat();
					i = a.length;
					while (--i > -1) {
						if (a[i]._gc || (onlyActive && !a[i].isActive())) {
							a.splice(i, 1);
						}
					}
				}
				return a || [];
			};
	
			TweenLite.killTweensOf = TweenLite.killDelayedCallsTo = function(target, onlyActive, vars) {
				if (typeof(onlyActive) === "object") {
					vars = onlyActive; //for backwards compatibility (before "onlyActive" parameter was inserted)
					onlyActive = false;
				}
				var a = TweenLite.getTweensOf(target, onlyActive),
					i = a.length;
				while (--i > -1) {
					a[i]._kill(vars, target);
				}
			};
	
	
	
	/*
	 * ----------------------------------------------------------------
	 * TweenPlugin   (could easily be split out as a separate file/class, but included for ease of use (so that people don't need to include another script call before loading plugins which is easy to forget)
	 * ----------------------------------------------------------------
	 */
			var TweenPlugin = _class("plugins.TweenPlugin", function(props, priority) {
						this._overwriteProps = (props || "").split(",");
						this._propName = this._overwriteProps[0];
						this._priority = priority || 0;
						this._super = TweenPlugin.prototype;
					}, true);
	
			p = TweenPlugin.prototype;
			TweenPlugin.version = "1.19.0";
			TweenPlugin.API = 2;
			p._firstPT = null;
			p._addTween = _addPropTween;
			p.setRatio = _setRatio;
	
			p._kill = function(lookup) {
				var a = this._overwriteProps,
					pt = this._firstPT,
					i;
				if (lookup[this._propName] != null) {
					this._overwriteProps = [];
				} else {
					i = a.length;
					while (--i > -1) {
						if (lookup[a[i]] != null) {
							a.splice(i, 1);
						}
					}
				}
				while (pt) {
					if (lookup[pt.n] != null) {
						if (pt._next) {
							pt._next._prev = pt._prev;
						}
						if (pt._prev) {
							pt._prev._next = pt._next;
							pt._prev = null;
						} else if (this._firstPT === pt) {
							this._firstPT = pt._next;
						}
					}
					pt = pt._next;
				}
				return false;
			};
	
			p._mod = p._roundProps = function(lookup) {
				var pt = this._firstPT,
					val;
				while (pt) {
					val = lookup[this._propName] || (pt.n != null && lookup[ pt.n.split(this._propName + "_").join("") ]);
					if (val && typeof(val) === "function") { //some properties that are very plugin-specific add a prefix named after the _propName plus an underscore, so we need to ignore that extra stuff here.
						if (pt.f === 2) {
							pt.t._applyPT.m = val;
						} else {
							pt.m = val;
						}
					}
					pt = pt._next;
				}
			};
	
			TweenLite._onPluginEvent = function(type, tween) {
				var pt = tween._firstPT,
					changed, pt2, first, last, next;
				if (type === "_onInitAllProps") {
					//sorts the PropTween linked list in order of priority because some plugins need to render earlier/later than others, like MotionBlurPlugin applies its effects after all x/y/alpha tweens have rendered on each frame.
					while (pt) {
						next = pt._next;
						pt2 = first;
						while (pt2 && pt2.pr > pt.pr) {
							pt2 = pt2._next;
						}
						if ((pt._prev = pt2 ? pt2._prev : last)) {
							pt._prev._next = pt;
						} else {
							first = pt;
						}
						if ((pt._next = pt2)) {
							pt2._prev = pt;
						} else {
							last = pt;
						}
						pt = next;
					}
					pt = tween._firstPT = first;
				}
				while (pt) {
					if (pt.pg) if (typeof(pt.t[type]) === "function") if (pt.t[type]()) {
						changed = true;
					}
					pt = pt._next;
				}
				return changed;
			};
	
			TweenPlugin.activate = function(plugins) {
				var i = plugins.length;
				while (--i > -1) {
					if (plugins[i].API === TweenPlugin.API) {
						_plugins[(new plugins[i]())._propName] = plugins[i];
					}
				}
				return true;
			};
	
			//provides a more concise way to define plugins that have no dependencies besides TweenPlugin and TweenLite, wrapping common boilerplate stuff into one function (added in 1.9.0). You don't NEED to use this to define a plugin - the old way still works and can be useful in certain (rare) situations.
			_gsDefine.plugin = function(config) {
				if (!config || !config.propName || !config.init || !config.API) { throw "illegal plugin definition."; }
				var propName = config.propName,
					priority = config.priority || 0,
					overwriteProps = config.overwriteProps,
					map = {init:"_onInitTween", set:"setRatio", kill:"_kill", round:"_mod", mod:"_mod", initAll:"_onInitAllProps"},
					Plugin = _class("plugins." + propName.charAt(0).toUpperCase() + propName.substr(1) + "Plugin",
						function() {
							TweenPlugin.call(this, propName, priority);
							this._overwriteProps = overwriteProps || [];
						}, (config.global === true)),
					p = Plugin.prototype = new TweenPlugin(propName),
					prop;
				p.constructor = Plugin;
				Plugin.API = config.API;
				for (prop in map) {
					if (typeof(config[prop]) === "function") {
						p[map[prop]] = config[prop];
					}
				}
				Plugin.version = config.version;
				TweenPlugin.activate([Plugin]);
				return Plugin;
			};
	
	
			//now run through all the dependencies discovered and if any are missing, log that to the console as a warning. This is why it's best to have TweenLite load last - it can check all the dependencies for you.
			a = window._gsQueue;
			if (a) {
				for (i = 0; i < a.length; i++) {
					a[i]();
				}
				for (p in _defLookup) {
					if (!_defLookup[p].func) {
						window.console.log("GSAP encountered missing dependency: " + p);
					}
				}
			}
	
			_tickerActive = false; //ensures that the first official animation forces a ticker.tick() to update the time when it is instantiated
	
	})((typeof(module) !== "undefined" && module.exports && typeof(global) !== "undefined") ? global : this || window, "TweenMax");
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 9 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	var OBJECT_DISPLAY_STATE_INITIAL = exports.OBJECT_DISPLAY_STATE_INITIAL = 'OBJECT_DISPLAY_STATE_INITIAL';
	var OBJECT_DISPLAY_STATE_FEEDBACK = exports.OBJECT_DISPLAY_STATE_FEEDBACK = 'OBJECT_DISPLAY_STATE_FEEDBACK';
	var OBJECT_DISPLAY_STATE_RETRY = exports.OBJECT_DISPLAY_STATE_RETRY = 'OBJECT_DISPLAY_STATE_RETRY';
	var OBJECT_DISPLAY_STATE_ANSWERED = exports.OBJECT_DISPLAY_STATE_ANSWERED = 'OBJECT_DISPLAY_STATE_ANSWERED';
	var OBJECT_DISPLAY_STATE_REVIEW = exports.OBJECT_DISPLAY_STATE_REVIEW = 'OBJECT_DISPLAY_STATE_REVIEW';
	
	var OBJECT_PROGRESSION_CONTINUE = exports.OBJECT_PROGRESSION_CONTINUE = 'continue';
	var OBJECT_PROGRESSION_TRY_AGAIN = exports.OBJECT_PROGRESSION_TRY_AGAIN = 'try_again';
	var OBJECT_PROGRESSION_TERMINAL = exports.OBJECT_PROGRESSION_TERMINAL = 'terminal';
	var OBJECT_PROGRESSION_GO_TO = exports.OBJECT_PROGRESSION_GO_TO = 'go_to';
	var OBJECT_PROGRESSION_LINEAR = exports.OBJECT_PROGRESSION_LINEAR = 'linear';
	var OBJECT_PROGRESSION_OPEN = exports.OBJECT_PROGRESSION_OPEN = 'open';
	var OBJECT_PROGRESSION_AUTO = exports.OBJECT_PROGRESSION_AUTO = 'auto';
	var OBJECT_PROGRESSION_END = exports.OBJECT_PROGRESSION_END = 'end';
	
	var GO_TO_TYPE_OBJECT = exports.GO_TO_TYPE_OBJECT = 'object';
	var GO_TO_TYPE_SCREEN = exports.GO_TO_TYPE_SCREEN = 'screen';
	
	var TERMINAL_TYPE_SCREEN = exports.TERMINAL_TYPE_SCREEN = 'end_screen';
	var TERMINAL_TYPE_BITE = exports.TERMINAL_TYPE_BITE = 'end_bite';
	
	var SCREEN_RULE_TYPE_OPTIONAL = exports.SCREEN_RULE_TYPE_OPTIONAL = 'optional';
	var SCREEN_RULE_TYPE_REQUIRED = exports.SCREEN_RULE_TYPE_REQUIRED = 'required';
	var SCREEN_RULE_TYPE_HIDDEN = exports.SCREEN_RULE_TYPE_HIDDEN = 'hidden';
	var SCREEN_RULE_TYPE_TARGET = exports.SCREEN_RULE_TYPE_TARGET = 'target';
	
	var STATUS_NOT_STARTED = exports.STATUS_NOT_STARTED = 'NS';
	var STATUS_NOT_REQUIRED = exports.STATUS_NOT_REQUIRED = 'NR';
	var STATUS_IN_PROGRESS = exports.STATUS_IN_PROGRESS = 'IP';
	var STATUS_COMPLETE = exports.STATUS_COMPLETE = 'C';
	var STATUS_ATTEMPTED = exports.STATUS_ATTEMPTED = 'A';
	var STATUS_SAVED = exports.STATUS_SAVED = 'S';
	
	var CLASS_ACTIVE = exports.CLASS_ACTIVE = 'active';
	var CLASS_NOT_STARTED = exports.CLASS_NOT_STARTED = 'not-started';
	var CLASS_NOT_REQUIRED = exports.CLASS_NOT_REQUIRED = 'not-required';
	var CLASS_IN_PROGRESS = exports.CLASS_IN_PROGRESS = 'in-progress';
	var CLASS_COMPLETE = exports.CLASS_COMPLETE = 'complete';
	
	var RESULT_BEST = exports.RESULT_BEST = 'best';
	var RESULT_OK = exports.RESULT_OK = 'ok';
	var RESULT_POOR = exports.RESULT_POOR = 'poor';
	var RESULT_REFLECTIVE = exports.RESULT_REFLECTIVE = 'reflective';
	
	var STATUS_PASSED = exports.STATUS_PASSED = 'P';
	var STATUS_FAILED = exports.STATUS_FAILED = 'F';
	
	var OBJECT_COLUMN_LEFT = exports.OBJECT_COLUMN_LEFT = "left";
	var OBJECT_COLUMN_RIGHT = exports.OBJECT_COLUMN_RIGHT = "right";
	
	var PARENT_SCREEN_TYPE_BITE_SCREEN = exports.PARENT_SCREEN_TYPE_BITE_SCREEN = "screen";
	var PARENT_SCREEN_TYPE_TOOLBOX = exports.PARENT_SCREEN_TYPE_TOOLBOX = "toolbox";
	var PARENT_SCREEN_TYPE_OBJECT = exports.PARENT_SCREEN_TYPE_OBJECT = "object";
	
	var LINK_TYPE_TOOLBOX_SCREEN = exports.LINK_TYPE_TOOLBOX_SCREEN = "toolbox_screen";
	var LINK_TYPE_TOOLBOX_OBJECT = exports.LINK_TYPE_TOOLBOX_OBJECT = "toolbox_object";
	
	var PROGRESSION_TYPE_OPEN = exports.PROGRESSION_TYPE_OPEN = "open";
	var PROGRESSION_TYPE_LINEAR = exports.PROGRESSION_TYPE_LINEAR = "linear";
	var PROGRESSION_TYPE_EXPLORE_INTERESTS = exports.PROGRESSION_TYPE_EXPLORE_INTERESTS = "explore_options";
	
	var OBJECT_DISPLAY_STATES = exports.OBJECT_DISPLAY_STATES = [OBJECT_DISPLAY_STATE_INITIAL, OBJECT_DISPLAY_STATE_FEEDBACK, OBJECT_DISPLAY_STATE_RETRY, OBJECT_DISPLAY_STATE_REVIEW];
	
	var YOU_TUBE_PRE_URL = exports.YOU_TUBE_PRE_URL = "https://www.youtube.com/embed/";
	
	var PROMPT_TYPE_SHOW_PROMPT = exports.PROMPT_TYPE_SHOW_PROMPT = "show_prompt";
	var PROMPT_TYPE_SHOW_UNTIL_ANSWERED = exports.PROMPT_TYPE_SHOW_UNTIL_ANSWERED = "show_until_answered";
	var PROMPT_TYPE_SHOW_NO_PROMPT = exports.PROMPT_TYPE_SHOW_NO_PROMPT = "no_prompt";
	var PROMPT_TYPE_DIALOG_PROMPT = exports.PROMPT_TYPE_DIALOG_PROMPT = "dialog_prompt";
	
	var ATTEMPT_TYPE_FIRST = exports.ATTEMPT_TYPE_FIRST = "first";
	var ATTEMPT_TYPE_LAST = exports.ATTEMPT_TYPE_LAST = "last";
	
	var SCORING_TYPE_ASSESSED = exports.SCORING_TYPE_ASSESSED = "assessed";
	var SCORING_TYPE_FORMATIVE = exports.SCORING_TYPE_FORMATIVE = "formative";
	var SCORING_TYPE_REFLECTIVE = exports.SCORING_TYPE_REFLECTIVE = "reflective";
	
	var FEEDBACK_TYPE_GIVE_FEEDBACK_IMMEDIATELY = exports.FEEDBACK_TYPE_GIVE_FEEDBACK_IMMEDIATELY = "give_feedback_immediately";
	var FEEDBACK_TYPE_GIVE_FEED_LATER = exports.FEEDBACK_TYPE_GIVE_FEED_LATER = "give_feedback_later";
	var FEEDBACK_TYPE_NO_FEEDBACK = exports.FEEDBACK_TYPE_NO_FEEDBACK = "no_feedback";
	var FEEDBACK_TYPE_INCLUDE = exports.FEEDBACK_TYPE_INCLUDE = "include_feedback";
	
	var SELECTION_TYPE_SELECT_ONE = exports.SELECTION_TYPE_SELECT_ONE = "select_one";
	var SELECTION_TYPE_SELECT_MANY = exports.SELECTION_TYPE_SELECT_MANY = "select_many";
	
	var RESULT_TYPE_BEST = exports.RESULT_TYPE_BEST = "best";
	var RESULT_TYPE_OK = exports.RESULT_TYPE_OK = "ok";
	var RESULT_TYPE_POOR = exports.RESULT_TYPE_POOR = "poor";
	
	var INHERIT = exports.INHERIT = "inherit";
	
	var VIDEO_SUB_TYPE_VIMEO = exports.VIDEO_SUB_TYPE_VIMEO = 'vimeo';
	var VIDEO_SUB_TYPE_YOUTUBE = exports.VIDEO_SUB_TYPE_YOUTUBE = 'youtube';
	var VIDEO_SUB_TYPE_MP4 = exports.VIDEO_SUB_TYPE_MP4 = 'mp4';
	
	var RESULT_DISPLAY_METHOD_SCORE_ONLY = exports.RESULT_DISPLAY_METHOD_SCORE_ONLY = "score_only";
	var RESULT_DISPLAY_METHOD_OBJECTIVES_ONLY = exports.RESULT_DISPLAY_METHOD_OBJECTIVES_ONLY = "objectives_only";
	var RESULT_DISPLAY_METHOD_SCORE_AND_OBJECTIVES = exports.RESULT_DISPLAY_METHOD_SCORE_AND_OBJECTIVES = "score_and_objectives";
	
	var END_ACTION_REVIEW_OR_CLEAR = exports.END_ACTION_REVIEW_OR_CLEAR = "review_or_clear_and_start_again";
	var END_ACTION_REVIEW = exports.END_ACTION_REVIEW = "review";
	var END_ACTION_RETURN_TO_MENU = exports.END_ACTION_RETURN_TO_MENU = "return_to_menu";
	var END_ACTION_CLEAR = exports.END_ACTION_CLEAR = "clear_and_start_again";
	var END_ACTION_EXIT = exports.END_ACTION_EXIT = "exit_module";
	var END_ACTION_NONE = exports.END_ACTION_NONE = "none";
	
	var REQUIRED = exports.REQUIRED = "required";
	var OPTIONAL = exports.OPTIONAL = "optional";
	var LINEAR = exports.LINEAR = "linear";
	var CUSTOM = exports.CUSTOM = "custom";
	
	var TYPE_MENU = exports.TYPE_MENU = 'menu';
	var TYPE_SCREEN = exports.TYPE_SCREEN = 'screen';
	var TYPE_RESOURCE = exports.TYPE_RESOURCE = 'resource';
	
	var DISPLAY_ALL_BADGES = exports.DISPLAY_ALL_BADGES = "display_all_achievements";
	var DISPLAY_BITE_BADGES = exports.DISPLAY_BITE_BADGES = "display_bite_achievements";
	
	var LABEL_TYPE_LEFT = exports.LABEL_TYPE_LEFT = "left";
	var LABEL_TYPE_RIGHT = exports.LABEL_TYPE_RIGHT = "right";
	var LABEL_TYPE_NONE = exports.LABEL_TYPE_NONE = "none";
	
	var DISPLAY_TYPE_INTRODUCTION = exports.DISPLAY_TYPE_INTRODUCTION = "introduction";
	var DISPLAY_TYPE_HOTSPOT = exports.DISPLAY_TYPE_HOTSPOT = "hotspot";
	var DISPLAY_TYPE_CONCLUSION = exports.DISPLAY_TYPE_CONCLUSION = "conclusion";
	
	var RESPOND_TYPE_INLINE = exports.RESPOND_TYPE_INLINE = "respond_inline";
	var RESPOND_TYPE_ELSEWHERE = exports.RESPOND_TYPE_ELSEWHERE = "respond_elsewhere";
	var RESPOND_TYPE_ELSEWHERE_IF_SCORM = exports.RESPOND_TYPE_ELSEWHERE_IF_SCORM = "elsewhere_if_SCORM_1_2";
	
	var ASSESSED_TYPE_NONE = exports.ASSESSED_TYPE_NONE = "not_assessed";
	var ASSESSED_TYPE_FORMATIVE = exports.ASSESSED_TYPE_FORMATIVE = "self_assessed_formative";
	var ASSESSED_TYPE_SCORED = exports.ASSESSED_TYPE_SCORED = "self_assessed_scored";
	
	var ACHIEVED = exports.ACHIEVED = "achieved";
	var NOT_ACHIEVED = exports.NOT_ACHIEVED = "not_achieved";
	
	var AND = exports.AND = "and";
	var OR = exports.OR = "or";
	
	var LARGE_BACKGROUND = exports.LARGE_BACKGROUND = "large_background";
	var MOBILE_BACKGROUND = exports.MOBILE_BACKGROUND = "mobile_background";
	
	var BADGE_TYPE_SHIELD = exports.BADGE_TYPE_SHIELD = "shield";
	var BADGE_TYPE_IMAGE = exports.BADGE_TYPE_IMAGE = "image";
	
	var TAB_TYPE_HORIZONTAL = exports.TAB_TYPE_HORIZONTAL = "horizontal";
	var TAB_TYPE_VERTICAL = exports.TAB_TYPE_VERTICAL = "vertical";
	var TAB_TYPE_HORIZONTAL_FRAMELESS = exports.TAB_TYPE_HORIZONTAL_FRAMELESS = "horizontal_frameless";
	var TAB_TYPE_VERTICAL_FRAMELESS = exports.TAB_TYPE_VERTICAL_FRAMELESS = "vertical_frameless";
	var TAB_TYPE_HORIZONTAL_PROCESS = exports.TAB_TYPE_HORIZONTAL_PROCESS = "horizontal_process";
	var TAB_TYPE_VERTICAL_PROCESS = exports.TAB_TYPE_VERTICAL_PROCESS = "vertical_process";
	var TAB_TYPE_HORIZONTAL_TILE = exports.TAB_TYPE_HORIZONTAL_TILE = "horizontal_tile";
	var TAB_TYPE_VERTICAL_TILE = exports.TAB_TYPE_VERTICAL_TILE = "vertical_tile";
	
	var SLIDER_TYPE_HORIZONTAL = exports.SLIDER_TYPE_HORIZONTAL = "horizontal";
	var SLIDER_TYPE_HORIZONTAL_TIMELINE = exports.SLIDER_TYPE_HORIZONTAL_TIMELINE = "horizontal_timeline";
	
	var PANEL_LOCATION_LEFT = exports.PANEL_LOCATION_LEFT = "left";
	var PANEL_LOCATION_RIGHT = exports.PANEL_LOCATION_RIGHT = "right";
	var PANEL_LOCATION_CENTERED = exports.PANEL_LOCATION_CENTERED = "centered";
	
	var PRINT_FROM_THIS_BITE = exports.PRINT_FROM_THIS_BITE = "this_bite";
	var PRINT_FROM_ALL_BITES = exports.PRINT_FROM_ALL_BITES = "all_bites";
	var INCLUDE_IN_PRINT = exports.INCLUDE_IN_PRINT = "include_in_print";
	var EXCLUDE_FROM_PRINT = exports.EXCLUDE_FROM_PRINT = "exclude_in_print";
	var HOTSPOT_DISPLAY_TYPES = exports.HOTSPOT_DISPLAY_TYPES = [DISPLAY_TYPE_INTRODUCTION, DISPLAY_TYPE_HOTSPOT, DISPLAY_TYPE_CONCLUSION];
	
	//object animations duration
	var PROGRESS_UPDATE_DURATION = exports.PROGRESS_UPDATE_DURATION = 1;
	var DIALOG_DURATION = exports.DIALOG_DURATION = 0.5;
	var FEEDBACK_DURATION = exports.FEEDBACK_DURATION = 0.5;
	var SPEECH_BUBBLE_DURATION = exports.SPEECH_BUBBLE_DURATION = 0.7;
	var BUTTON_DURATION = exports.BUTTON_DURATION = 0;
	var ACCORDION_BUTTON_DURATION = exports.ACCORDION_BUTTON_DURATION = 0.2;
	var DROPDOWN_MENU_OPEN_DURATION = exports.DROPDOWN_MENU_OPEN_DURATION = 0.5;
	var DROPDOWN_MENU_CLOSE_DURATION = exports.DROPDOWN_MENU_CLOSE_DURATION = 0.5;
	var SHOW_PANEL_DURATION = exports.SHOW_PANEL_DURATION = 0.7;
	var MC_OPTION_DURATION = exports.MC_OPTION_DURATION = 0.7;
	
	var KPI_ROTATION_DURATION = exports.KPI_ROTATION_DURATION = 0.7;
	
	var SCROLL_TO = exports.SCROLL_TO = 500;
	var SCROLL_SPEED = exports.SCROLL_SPEED = 1;
	
	var ASSET_LEFT_PANEL_POSTFIX = exports.ASSET_LEFT_PANEL_POSTFIX = "_assetLeftPanelImage";
	var ASSET_RIGHT_PANEL_POSTFIX = exports.ASSET_RIGHT_PANEL_POSTFIX = "_assetRightPanelImage";
	var ASSET_LEFT_POSTFIX = exports.ASSET_LEFT_POSTFIX = "_assetLeftImage";
	var ASSET_RIGHT_POSTFIX = exports.ASSET_RIGHT_POSTFIX = "_assetRightImage";
	var CONTENT_AREA_POSTFIX = exports.CONTENT_AREA_POSTFIX = "_contentArea";
	
	var IMAGE_SIZE_ACTUAL = exports.IMAGE_SIZE_ACTUAL = "actual";
	var IMAGE_SIZE_RETINA = exports.IMAGE_SIZE_RETINA = "retina";
	var IMAGE_SIZE_SPECIFIC = exports.IMAGE_SIZE_SPECIFIC = "specific";
	var IMAGE_SIZE_MAX = exports.IMAGE_SIZE_MAX = "max";
	
	var IMAGE_SHAPE_NONE = exports.IMAGE_SHAPE_NONE = "none";
	var IMAGE_SHAPE_SQUARE = exports.IMAGE_SHAPE_SQUARE = "square";
	var IMAGE_SHAPE_CIRCLE = exports.IMAGE_SHAPE_CIRCLE = "circle";
	var IMAGE_SHAPE_RECTANGLE = exports.IMAGE_SHAPE_RECTANGLE = "rectangle";
	
	var IMAGE_WIDTH_5 = exports.IMAGE_WIDTH_5 = "image_width_5";
	var IMAGE_WIDTH_10 = exports.IMAGE_WIDTH_10 = "image_width_10";
	var IMAGE_WIDTH_15 = exports.IMAGE_WIDTH_15 = "image_width_15";
	var IMAGE_WIDTH_20 = exports.IMAGE_WIDTH_20 = "image_width_20";
	var IMAGE_WIDTH_25 = exports.IMAGE_WIDTH_25 = "image_width_25";
	var IMAGE_WIDTH_30 = exports.IMAGE_WIDTH_30 = "image_width_30";
	var IMAGE_WIDTH_35 = exports.IMAGE_WIDTH_35 = "image_width_35";
	var IMAGE_WIDTH_40 = exports.IMAGE_WIDTH_40 = "image_width_40";
	
	var ASSET_IMAGE_WIDTH_10 = exports.ASSET_IMAGE_WIDTH_10 = "asset_image_width_10";
	var ASSET_IMAGE_WIDTH_15 = exports.ASSET_IMAGE_WIDTH_15 = "asset_image_width_15";
	var ASSET_IMAGE_WIDTH_20 = exports.ASSET_IMAGE_WIDTH_20 = "asset_image_width_20";
	var ASSET_IMAGE_WIDTH_25 = exports.ASSET_IMAGE_WIDTH_25 = "asset_image_width_25";
	var ASSET_IMAGE_WIDTH_30 = exports.ASSET_IMAGE_WIDTH_30 = "asset_image_width_30";
	var ASSET_IMAGE_WIDTH_35 = exports.ASSET_IMAGE_WIDTH_35 = "asset_image_width_35";
	var ASSET_IMAGE_WIDTH_40 = exports.ASSET_IMAGE_WIDTH_40 = "asset_image_width_40";
	
	var TOP_ASSET_IMAGE_WIDTH_10 = exports.TOP_ASSET_IMAGE_WIDTH_10 = "asset_image_width_10";
	var TOP_ASSET_IMAGE_WIDTH_20 = exports.TOP_ASSET_IMAGE_WIDTH_20 = "asset_image_width_20";
	var TOP_ASSET_IMAGE_WIDTH_30 = exports.TOP_ASSET_IMAGE_WIDTH_30 = "asset_image_width_30";
	var TOP_ASSET_IMAGE_WIDTH_40 = exports.TOP_ASSET_IMAGE_WIDTH_40 = "asset_image_width_40";
	var TOP_ASSET_IMAGE_WIDTH_50 = exports.TOP_ASSET_IMAGE_WIDTH_50 = "asset_image_width_50";
	var TOP_ASSET_IMAGE_WIDTH_60 = exports.TOP_ASSET_IMAGE_WIDTH_60 = "asset_image_width_60";
	var TOP_ASSET_IMAGE_WIDTH_70 = exports.TOP_ASSET_IMAGE_WIDTH_70 = "asset_image_width_70";
	var TOP_ASSET_IMAGE_WIDTH_80 = exports.TOP_ASSET_IMAGE_WIDTH_80 = "asset_image_width_80";
	var TOP_ASSET_IMAGE_WIDTH_90 = exports.TOP_ASSET_IMAGE_WIDTH_90 = "asset_image_width_90";
	var TOP_ASSET_IMAGE_WIDTH_100 = exports.TOP_ASSET_IMAGE_WIDTH_100 = "asset_image_width_100";
	
	var KPI_DISPLAY_SCOPE_BOTH = exports.KPI_DISPLAY_SCOPE_BOTH = "both";
	var KPI_DISPLAY_SCOPE_PRIMARY = exports.KPI_DISPLAY_SCOPE_PRIMARY = "primary";
	var KPI_DISPLAY_SCOPE_SECONDARY = exports.KPI_DISPLAY_SCOPE_SECONDARY = "secondary";
	
	var HOT_SPOT_TYPE_NO_SCREEN = exports.HOT_SPOT_TYPE_NO_SCREEN = "no_screen";
	var HOT_SPOT_TYPE_LARGE_SCREEN = exports.HOT_SPOT_TYPE_LARGE_SCREEN = "large_screen";
	var HOT_SPOT_TYPE_MOBILE_SCREEN = exports.HOT_SPOT_TYPE_MOBILE_SCREEN = "mobile_screen";
	var HOT_SPOT_TYPE_FULL_SCREEN = exports.HOT_SPOT_TYPE_FULL_SCREEN = "full_screen";
	
	var HOT_SPOT_BUTTON_TYPE_CHECK_ROLLOVER = exports.HOT_SPOT_BUTTON_TYPE_CHECK_ROLLOVER = "check_rollover";
	var HOT_SPOT_BUTTON_TYPE_CHECK_LABEL = exports.HOT_SPOT_BUTTON_TYPE_CHECK_LABEL = "check_label";
	var HOT_SPOT_BUTTON_TYPE_SMALL_ICON = exports.HOT_SPOT_BUTTON_TYPE_SMALL_ICON = "small_icon";
	var HOT_SPOT_BUTTON_TYPE_SMALL_ICON_LABEL = exports.HOT_SPOT_BUTTON_TYPE_SMALL_ICON_LABEL = "small_icon_label";
	var HOT_SPOT_BUTTON_TYPE_LARGE_ICON = exports.HOT_SPOT_BUTTON_TYPE_LARGE_ICON = "large_icon";
	var HOT_SPOT_BUTTON_TYPE_LARGE_ICON_LABEL = exports.HOT_SPOT_BUTTON_TYPE_LARGE_ICON_LABEL = "large_icon_label";

/***/ },
/* 10 */
/***/ function(module, exports) {

	var __hasProp = {}.hasOwnProperty;
	
	if (window._gsQueue == null) {
	  window._gsQueue = [];
	}
	
	window._gsQueue.push(function() {
	  return window._gsDefine.plugin({
	    propName: 'state',
	    API: 2,
	    version: '1.0.2',
	    init: function(target, value, tween) {
	      var end, p, start, _ref, _ref1, _ref2;
	      if (typeof target.setState !== 'function') {
	        return false;
	      }
	      if (target._tweenState == null) {
	        target._tweenState = {};
	      }
	      this._tween = {};
	      for (p in value) {
	        if (!__hasProp.call(value, p)) continue;
	        end = value[p];
	        start = (_ref = (_ref1 = (_ref2 = target.state) != null ? _ref2[p] : void 0) != null ? _ref1 : target._tweenState[p]) != null ? _ref : end;
	        this._tween[p] = start;
	        this._addTween(this._tween, p, start, end, p);
	      }
	      this._target = target;
	      return true;
	    },
	    set: function(ratio) {
	      var k, v, _ref;
	      this._super.setRatio.call(this, ratio);
	      _ref = this._tween;
	      for (k in _ref) {
	        v = _ref[k];
	        this._target._tweenState[k] = v;
	      }
	      return this._target.setState(this._tween);
	    }
	  });
	});
	
	if (window._gsDefine) {
	  window._gsQueue.pop()();
	}


/***/ },
/* 11 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.immutablePush = immutablePush;
	exports.immutablePop = immutablePop;
	exports.immutableShift = immutableShift;
	exports.immutableUnshift = immutableUnshift;
	exports.immutableSort = immutableSort;
	exports.immutableReverse = immutableReverse;
	exports.immutableSplice = immutableSplice;
	exports.immutableDelete = immutableDelete;
	exports.getRandomInt = getRandomInt;
	exports.randomiseArray = randomiseArray;
	exports.isEven = isEven;
	exports.createGuid = createGuid;
	exports.getFileExtention = getFileExtention;
	exports.getRangePercentage = getRangePercentage;
	exports.cssPropertyValueSupported = cssPropertyValueSupported;
	exports.getAllTabbableElements = getAllTabbableElements;
	exports.toTitleCase = toTitleCase;
	
	var _environmentHelper = __webpack_require__(56);
	
	var environmentHelper = _interopRequireWildcard(_environmentHelper);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	//Add Value to the end of an array
	
	
	function immutablePush(arr, newEntry) {
	
	    return [].concat(_toConsumableArray(arr), [newEntry]);
	}
	
	//Remove the last element of an array,
	function immutablePop(arr) {
	    return arr.slice(0, -1);
	}
	
	//Removes the nth value of an array
	function immutableShift(arr) {
	    return arr.slice(1);
	}
	
	//Adds value to the beginning of an array
	function immutableUnshift(arr, newEntry) {
	    return [newEntry].concat(_toConsumableArray(arr));
	}
	
	//Sort the array
	function immutableSort(arr, compareFunction) {
	    return [].concat(_toConsumableArray(arr)).sort(compareFunction);
	}
	
	//Revers the order of an array
	function immutableReverse(arr) {
	    return [].concat(_toConsumableArray(arr)).reverse();
	}
	
	//Delete x amount of values from and array at the nth index, can also replace delected values with new one at nth index
	function immutableSplice(arr, start, deleteCount) {
	    for (var _len = arguments.length, items = Array(_len > 3 ? _len - 3 : 0), _key = 3; _key < _len; _key++) {
	        items[_key - 3] = arguments[_key];
	    }
	
	    return [].concat(_toConsumableArray(arr.slice(0, start)), items, _toConsumableArray(arr.slice(start + deleteCount)));
	}
	
	function immutableDelete(arr, index) {
	    return arr.slice(0, index).concat(arr.slice(index + 1));
	}
	
	function getRandomInt(min, max) {
	    return Math.floor(Math.random() * (max - min + 1)) + min;
	}
	
	function randomiseArray(arr) {
	    for (var i = arr.length; i; i--) {
	        var j = Math.floor(Math.random() * i);
	        var _ref = [arr[j], arr[i - 1]];
	        arr[i - 1] = _ref[0];
	        arr[j] = _ref[1];
	    }
	    return arr;
	}
	
	function isEven(n) {
	    return n % 2 == 0;
	}
	
	function createGuid() {
	    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
	        var r = Math.random() * 16 | 0,
	            v = c === 'x' ? r : r & 0x3 | 0x8;
	        return v.toString(16);
	    });
	}
	
	function getFileExtention(filename) {
	    return filename.split('.').pop().toLowerCase();
	}
	
	function getRangePercentage(min, max, current) {
	    return (current - min) / (max - min) * 100;
	}
	
	function cssPropertyValueSupported(prop, value) {
	    var env = environmentHelper.getEnvironment();
	    var d = document.createElement('div');
	    d.style[prop] = value;
	    return d.style[prop] === value && env.userAgent.indexOf("Edge") === -1;
	}
	
	function getAllTabbableElements(parentEl) {
	    return parentEl.querySelectorAll('button:not([tabindex="-1"]), [href]:not([tabindex="-1"]), input:not([tabindex="-1"]), select:not([tabindex="-1"]), textarea:not([tabindex="-1"]), [tabindex]:not([tabindex="-1"])');
	}
	
	function toTitleCase(str) {
	    return str.toLowerCase().replace(/^(.)|\s(.)/g, function ($1) {
	        return $1.toUpperCase();
	    });
	}

/***/ },
/* 12 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.setProjectTitleState = setProjectTitleState;
	exports.setBiteTitleState = setBiteTitleState;
	exports.setScreenTitleState = setScreenTitleState;
	exports.setAudioRef = setAudioRef;
	exports.doUpdateFontSize = doUpdateFontSize;
	exports.setProjectTitle = setProjectTitle;
	exports.setBiteTitle = setBiteTitle;
	exports.setScreenTitle = setScreenTitle;
	exports.setAudio = setAudio;
	exports.clearAudio = clearAudio;
	exports.updateFontSize = updateFontSize;
	
	var _actionTypes = __webpack_require__(22);
	
	var types = _interopRequireWildcard(_actionTypes);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function setProjectTitleState(projectTitle) {
	    return { type: types.SET_PROJECT_TITLE, projectTitle: projectTitle };
	}
	
	function setBiteTitleState(biteTitle) {
	    return { type: types.SET_BITE_TITLE, biteTitle: biteTitle };
	}
	
	function setScreenTitleState(screenTitle) {
	    return { type: types.SET_SCREEN_TITLE, screenTitle: screenTitle };
	}
	
	function setAudioRef(audio) {
	    return { type: types.SET_AUDIO_REF, audio: audio };
	}
	
	function doUpdateFontSize(fontSize) {
	    return { type: types.SET_FONT_SIZE, fontSize: fontSize };
	}
	
	function setProjectTitle(projectTitle) {
	    return function (dispatch) {
	        dispatch(setProjectTitleState(projectTitle));
	    };
	}
	
	function setBiteTitle(biteTitle) {
	    return function (dispatch) {
	        dispatch(setBiteTitleState(biteTitle));
	    };
	}
	
	function setScreenTitle(screenTitle) {
	    return function (dispatch) {
	        dispatch(setScreenTitleState(screenTitle));
	    };
	}
	
	function setAudio(audio) {
	    return function (dispatch) {
	        dispatch(setAudioRef(audio));
	    };
	}
	
	function clearAudio() {
	    return function (dispatch, getState) {
	        var state = getState();
	        var audio = Object.assign({}, state.audio, {
	            audioRef: ""
	        });
	        dispatch(setAudioRef(audio));
	    };
	}
	
	function updateFontSize(fontSize) {
	    return function (dispatch) {
	        dispatch(doUpdateFontSize(fontSize));
	    };
	}

/***/ },
/* 13 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	//DEVELOPMENT MODE
	var NODE_ENV_DEVELOPMENT = exports.NODE_ENV_DEVELOPMENT = "development";
	var NODE_ENV_PRODUCTION = exports.NODE_ENV_PRODUCTION = "production";
	var DEVELOPMENT_MODE = exports.DEVELOPMENT_MODE = ("production") === NODE_ENV_DEVELOPMENT;
	
	//INIT STATES
	var INIT_STATE_DATA_LOADED = exports.INIT_STATE_DATA_LOADED = 'INIT_STATE_DATA_LOADED';
	var INIT_STATE_IMAGES_PRE_LOADED = exports.INIT_STATE_IMAGES_PRE_LOADED = 'INIT_STATE_IMAGES_PRE_LOADED';
	var INIT_STATE_TRACKING_READY = exports.INIT_STATE_TRACKING_READY = 'INIT_STATE_TRACKING_READY';
	
	var TRACKING_TYPE_SCORM = exports.TRACKING_TYPE_SCORM = 'scorm_1_2';
	var TRACKING_TYPE_XAPI = exports.TRACKING_TYPE_XAPI = 'xapi';
	var TRACKING_TYPE_OPEN = exports.TRACKING_TYPE_OPEN = 'open';
	var TRACKING_TYPE_BLENDED_XAPI_SCORM_1_2 = exports.TRACKING_TYPE_BLENDED_XAPI_SCORM_1_2 = 'scorm_1_2_xapi';
	var TRACKING_TYPE_OPEN_LEARNING = exports.TRACKING_TYPE_OPEN_LEARNING = 'open_learning';
	
	var USER_ROLE_LEAD = exports.USER_ROLE_LEAD = "lead";
	var USER_ROLE_EDITOR = exports.USER_ROLE_EDITOR = "editor";
	var USER_ROLE_REVIEWER = exports.USER_ROLE_REVIEWER = "reviewer";
	var USER_ROLE_VIEWER = exports.USER_ROLE_VIEWER = "viewer";
	
	var SCREEN_STATUS_NOT_STARTED = exports.SCREEN_STATUS_NOT_STARTED = "not_started";
	var SCREEN_STATUS_IN_PROGRESS = exports.SCREEN_STATUS_IN_PROGRESS = "in_progress";
	var SCREEN_STATUS_IN_REVIEW = exports.SCREEN_STATUS_IN_REVIEW = "in_review";
	var SCREEN_STATUS_CHANGES = exports.SCREEN_STATUS_CHANGES = "CHANGES";
	var SCREEN_STATUS_COMPLETED = exports.SCREEN_STATUS_COMPLETED = "completed";
	
	var DATA_PATH_TRACKING_TYPE = exports.DATA_PATH_TRACKING_TYPE = 'project.trackingType.constant';
	
	var POST_COMPLETION_MODE_REVIEW = exports.POST_COMPLETION_MODE_REVIEW = "review";
	//{process.env.NODE_ENV}

/***/ },
/* 14 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var TAB_KEY = exports.TAB_KEY = 9;
	var SHIFT_KEY = exports.SHIFT_KEY = 16;
	var ENTER_KEY = exports.ENTER_KEY = 13;
	var SPACEBAR_KEY = exports.SPACEBAR_KEY = 32;
	var ESCAPE_KEY = exports.ESCAPE_KEY = 27;
	var ARROW_LEFT_KEY = exports.ARROW_LEFT_KEY = 37;
	var ARROW_UP_KEY = exports.ARROW_UP_KEY = 38;
	var ARROW_RIGHT_KEY = exports.ARROW_RIGHT_KEY = 39;
	var ARROW_DOWN_KEY = exports.ARROW_DOWN_KEY = 40;

/***/ },
/* 15 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.updateExperienceLocale = updateExperienceLocale;
	exports.terminateBite = terminateBite;
	exports.clearBiteUserData = clearBiteUserData;
	exports.setInitialUserData = setInitialUserData;
	exports.storeUserResponse = storeUserResponse;
	exports.updateScreenResults = updateScreenResults;
	exports.getLearningPlanOutcomes = getLearningPlanOutcomes;
	exports.updateLearningPlanOutcomes = updateLearningPlanOutcomes;
	exports.updateUserDataWithSuspendData = updateUserDataWithSuspendData;
	exports.updateResourceObjectResult = updateResourceObjectResult;
	exports.getResourceScreenStatus = getResourceScreenStatus;
	exports.getRequiredScreenCount = getRequiredScreenCount;
	exports.getBiteStatus = getBiteStatus;
	exports.getBiteRequired = getBiteRequired;
	exports.getBitePercentageComplete = getBitePercentageComplete;
	exports.getLessonStatus = getLessonStatus;
	exports.getLessonPercentageComplete = getLessonPercentageComplete;
	exports.getBiteUserData = getBiteUserData;
	exports.getScreenUserData = getScreenUserData;
	exports.getSubScreenUserData = getSubScreenUserData;
	exports.getObjectStatus = getObjectStatus;
	exports.getSubScreenObjectStatus = getSubScreenObjectStatus;
	exports.getResourceScreenUserData = getResourceScreenUserData;
	exports.getResourceScreenObjectUserData = getResourceScreenObjectUserData;
	exports.getAttachmentObjectUserData = getAttachmentObjectUserData;
	exports.getBiteKpi = getBiteKpi;
	exports.getUserResponseByOptionIds = getUserResponseByOptionIds;
	exports.getUserInputResponseByOptionIds = getUserInputResponseByOptionIds;
	exports.getToolboxScreenUserData = getToolboxScreenUserData;
	exports.getToolboxObjectStatus = getToolboxObjectStatus;
	exports.getScreenMultiPathResult = getScreenMultiPathResult;
	exports.getSavedObjects = getSavedObjects;
	exports.collectBadge = collectBadge;
	exports.checkBadgeEarnedOnObject = checkBadgeEarnedOnObject;
	exports.getKpiAverage = getKpiAverage;
	exports.saveNotes = saveNotes;
	exports.getAllUserBadges = getAllUserBadges;
	exports.storeUserShortResponses = storeUserShortResponses;
	
	var _appModels = __webpack_require__(68);
	
	var appModels = _interopRequireWildcard(_appModels);
	
	var _appHelper = __webpack_require__(3);
	
	var appHelper = _interopRequireWildcard(_appHelper);
	
	var _dataHelper = __webpack_require__(11);
	
	var dataHelpers = _interopRequireWildcard(_dataHelper);
	
	var _kpiHelper = __webpack_require__(35);
	
	var kpiHelper = _interopRequireWildcard(_kpiHelper);
	
	var _objectConstants = __webpack_require__(9);
	
	var objectConstants = _interopRequireWildcard(_objectConstants);
	
	var _localStorage = __webpack_require__(17);
	
	var localStorage = _interopRequireWildcard(_localStorage);
	
	var _kpiModels = __webpack_require__(57);
	
	var _lodash = __webpack_require__(28);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function updateExperienceLocale(userData, lang) {
	    return new Promise(function (resolve, reject) {
	        userData = Object.assign({}, userData, {
	            lang: lang
	
	        });
	        resolve(userData);
	    });
	}
	
	function terminateBite(userData, bite) {
	    return new Promise(function (resolve, reject) {
	
	        var biteIndex = appHelper.getArrayObjectIndexByKey(userData.bites, "bite_id", bite.bite_id);
	
	        var biteUserData = appHelper.getArrayObjectByKey(userData.bites, "bite_id", bite.bite_id);
	
	        biteUserData = Object.assign({}, biteUserData, {
	            terminated: true
	        });
	
	        biteUserData = Object.assign({}, biteUserData, {
	            status: getBiteStatus(biteUserData),
	            required: getBiteRequired(biteUserData),
	            percentageComplete: getBitePercentageComplete(biteUserData)
	        });
	
	        userData = Object.assign({}, userData, {
	            bites: dataHelpers.immutableSplice(userData.bites, biteIndex, 1, biteUserData)
	        });
	
	        userData = Object.assign({}, userData, {
	            status: getLessonStatus(userData.bites),
	            percentageComplete: getLessonPercentageComplete(userData.bites)
	        });
	        resolve(userData);
	    });
	}
	
	function clearBiteUserData(userData, experience, bite) {
	    return new Promise(function (resolve, reject) {
	        var biteMenu = {};
	        if (appHelper.isDefined(experience.experience_learning_model)) {
	            if (appHelper.isDefined(experience.learning_plan)) {
	                biteMenu = Object.assign({}, experience.learning_plan);
	            }
	        }
	        var biteIndex = appHelper.getArrayObjectIndexByKey(userData.bites, "bite_id", bite.bite_id);
	        var biteUserData = setBiteUserData(bite, biteMenu);
	        userData = Object.assign({}, userData, {
	            bites: dataHelpers.immutableSplice(userData.bites, biteIndex, 1, biteUserData)
	        });
	
	        userData = Object.assign({}, userData, {
	
	            status: getLessonStatus(userData.bites),
	            percentageComplete: getLessonPercentageComplete(userData.bites)
	        });
	        resolve(userData);
	    });
	}
	
	function setInitialUserData(experience) {
	    return new Promise(function (resolve, reject) {
	        var biteMenu = {};
	        if (appHelper.isDefined(experience.experience_learning_model)) {
	            if (appHelper.isDefined(experience.learning_plan)) {
	                biteMenu = Object.assign({}, experience.learning_plan);
	            }
	        }
	
	        var userData = Object.assign({}, appModels.USER_DATA_MODEL, {
	            lang: appHelper.getArrayObjectByKey(experience.languages, "is_selected", true).language_code,
	            resources: appHelper.isDefined(experience.resources) ? setResourcesUserData(experience.resources) : [],
	            bites: setUserDataBites(experience.bites, biteMenu),
	            attachments: setUserDataAttachments(experience.attachments),
	            short_response_questions: appHelper.isDefined(experience.short_response_questions) ? setShortResponseQuestions(experience.short_response_questions) : [],
	            //achievements: appHelper.isDefined(project.achievements) ? setUserDataAchievements(project.achievements) : [],
	            notes: []
	        });
	
	        //let the other data be set before doing this.
	        userData = Object.assign({}, userData, {
	            status: getLessonStatus(userData.bites),
	            percentageComplete: getLessonPercentageComplete(userData.bites),
	            score: 0
	        });
	
	        resolve(userData);
	    });
	}
	
	function setShortResponseQuestions(short_response_questions) {
	    var shortResponseQuestionArray = [];
	    for (var i = 0; i < short_response_questions.length; i++) {
	        var responseQuestion = Object.assign({}, short_response_questions[i], {
	            response: ""
	        });
	        shortResponseQuestionArray = dataHelpers.immutablePush(shortResponseQuestionArray, responseQuestion);
	    }
	    return shortResponseQuestionArray;
	}
	
	function setUserDataAttachments(attachments) {
	    var attachmentsArray = [];
	    for (var i = 0; i < attachments.length; i++) {
	        var attachment = Object.assign({}, attachments[i], {
	            status: objectConstants.STATUS_NOT_STARTED
	        });
	        attachmentsArray = dataHelpers.immutablePush(attachmentsArray, attachment);
	    }
	
	    return attachmentsArray;
	}
	
	function setResourcesUserData(resources) {
	    var resourcesArray = [];
	    for (var i = 0; i < resources.length; i++) {
	        var screen = resources[i];
	        resourcesArray = dataHelpers.immutablePush(resourcesArray, setResourceScreenResult(screen));
	    }
	
	    return resourcesArray;
	}
	
	function setResourceScreenResult(screen) {
	    return {
	        screen_id: screen.screen_id,
	        status: objectConstants.STATUS_NOT_STARTED,
	        objects: setScreensObjects(screen.objects)
	    };
	}
	
	/*
	function setToolboxUserData(toolbox) {
	    let userDataToolbox = Object.assign({}, appModels.USER_DATA_TOOLBOX,
	        {
	            active: toolbox.active,
	            status: objectConstants.STATUS_NOT_STARTED,
	            screens: setToolboxScreens(toolbox.screens),
	        }
	    );
	    //console.log(JSON.stringify(userDataToolbox));
	    return userDataToolbox;
	}
	
	
	//SET INIT TOOLBOX SCREEN DATA
	function setToolboxScreens(screens) {
	    let screensArray = [];
	    for (let i = 0; i < screens.length; i++) {
	        let screen = screens[i];
	        screensArray = dataHelpers.immutablePush(screensArray, setToolboxScreenResult(screen));
	    }
	
	    return screensArray;
	}
	
	function setToolboxScreenResult(screen) {
	    if (typeof screen.objects !== "undefined" || screen.objects.length > 0) {
	        return Object.assign({}, appModels.USER_DATA_TOOLBOX_SCREEN,
	            {
	                toolbox_id: screen.toolbox_id,
	                status: screen.required ? objectConstants.STATUS_NOT_STARTED : objectConstants.STATUS_COMPLETE,
	                objects: setScreensObjects(screen.objects)
	            }
	        );
	    } else {
	        return Object.assign({}, appModels.USER_DATA_SCREEN,
	            {
	                screen_id: screen.screen_id,
	                status: screen.required ? objectConstants.STATUS_NOT_STARTED : objectConstants.STATUS_COMPLETE
	            }
	        );
	    }
	}
	
	//ACHIEVEMENTS
	function setUserDataAchievements(achievements) {
	    let achievementsUserData = [];
	    for (let i = 0; i < achievements.length; i++) {
	        let achievement = achievements[i];
	        let achievementObj = Object.assign({}, appModels.USER_DATA_ACHIEVEMENT, {
	            code: achievement.code,
	
	        });
	        achievementsUserData = dataHelpers.immutablePush(achievementsUserData, achievementObj);
	    }
	    return achievementsUserData;
	}
	
	*/
	
	//BITES
	function setUserDataBites(bites, biteMenu) {
	    var bitesUserData = [];
	    for (var i = 0; i < bites.length; i++) {
	        var bite = bites[i];
	        bitesUserData = dataHelpers.immutablePush(bitesUserData, setBiteUserData(bite, biteMenu));
	    }
	    return bitesUserData;
	}
	
	function setBiteUserData(bite, biteMenu) {
	
	    var userDataBite = Object.assign({}, appModels.USER_DATA_BITE, {
	        bite_id: bite.bite_id,
	        status: objectConstants.STATUS_NOT_STARTED,
	
	        screens: setBiteScreens(bite),
	        score_kpi_id: appHelper.isDefined(bite.score_kpi) ? bite.score_kpi.id : 0,
	        kpis: setBiteKpis(bite),
	        badges: setBitesBadges(bite.badges),
	        target_screens: appHelper.isDefined(bite.target_screens) ? bite.target_screens : [],
	        number_of_target_screens: bite.number_of_target_screens,
	        complete_target_screens: [],
	        terminated: false
	    });
	
	    var required = getBiteRequired(userDataBite);
	    var biteRules = [];
	    var weight = 1;
	    if (appHelper.isDefined(biteMenu.bites)) {
	        var menuBite = appHelper.getArrayObjectByKey(biteMenu.bites, "bite_id", bite.bite_id);
	        required = menuBite.display_rule === objectConstants.REQUIRED || menuBite.display_rule === objectConstants.CUSTOM;
	        biteRules = appHelper.isDefined(menuBite.rules) ? menuBite.rules : biteRules;
	        weight = appHelper.isDefined(menuBite.weight) ? menuBite.weight : weight;
	    }
	
	    //do this after screens have been updated
	    userDataBite = Object.assign({}, userDataBite, {
	        status: getBiteStatus(userDataBite),
	        required: required,
	        visible: true,
	        percentageComplete: getBitePercentageComplete(userDataBite),
	        rules: biteRules,
	        weight: weight
	    });
	
	    return userDataBite;
	}
	
	function setBitesBadges(badges) {
	    var badgesUserData = [];
	    for (var i = 0; i < badges.length; i++) {
	        var badge = badges[i];
	        var badgeObj = Object.assign({}, appModels.USER_DATA_BADGE, {
	            badge_id: badge.badge_id
	
	        });
	        badgesUserData = dataHelpers.immutablePush(badgesUserData, badgeObj);
	    }
	    return badgesUserData;
	}
	
	//SET INIT SCREEN DATA
	function setBiteScreens(bite) {
	    var screensArray = [];
	    for (var i = 0; i < bite.screens.length; i++) {
	        var screen = bite.screens[i];
	        screensArray = dataHelpers.immutablePush(screensArray, setScreenResult(screen, bite));
	    }
	
	    return screensArray;
	}
	
	function setScreenResult(screen, bite) {
	    var required = screen.screen_rule_type !== objectConstants.SCREEN_RULE_TYPE_OPTIONAL;
	
	    return {
	        screen_id: screen.screen_id,
	        status: required ? objectConstants.STATUS_NOT_STARTED : objectConstants.STATUS_NOT_REQUIRED,
	        required: required,
	        isTargetScreen: screen.screen_rule_type == objectConstants.SCREEN_RULE_TYPE_TARGET,
	        sub_screens: appHelper.isDefined(screen.sub_screens) ? setBiteSubScreens(bite, screen) : [],
	        screen_rule_type: screen.screen_rule_type,
	        objects: appHelper.isDefined(screen.objects) ? setScreensObjects(screen.objects) : []
	    };
	}
	
	function setBiteSubScreens(bite, parentScreen) {
	    var screensArray = [];
	    for (var i = 0; i < parentScreen.sub_screens.length; i++) {
	        var screen = parentScreen.sub_screens[i];
	        screensArray = dataHelpers.immutablePush(screensArray, setSubScreenResult(screen, parentScreen, bite));
	    }
	
	    return screensArray;
	}
	
	function setSubScreenResult(screen, parentScreen, bite) {
	    var required = screen.screen_rule_type !== objectConstants.SCREEN_RULE_TYPE_OPTIONAL;
	
	    return {
	        screen_id: screen.screen_id,
	        status: required ? objectConstants.STATUS_NOT_STARTED : objectConstants.STATUS_NOT_REQUIRED,
	        required: required,
	        isTargetScreen: screen.screen_rule_type == objectConstants.SCREEN_RULE_TYPE_TARGET,
	        sub_screens: appHelper.isDefined(screen.sub_screens) ? setBiteSubScreens(bite, screen) : [],
	        screen_rule_type: screen.screen_rule_type,
	        objects: appHelper.isDefined(screen.objects) ? setScreensObjects(screen.objects) : []
	    };
	}
	
	//SET INIT OBJECT DATA
	function setScreensObjects(objects) {
	    var objectArray = [];
	    for (var i = 0; i < objects.length; i++) {
	        var object = objects[i];
	        objectArray = dataHelpers.immutablePush(objectArray, setObjectResult(object));
	    }
	    return objectArray;
	}
	
	function setObjectResult(object) {
	    var required = !appHelper.isDefined(object.required_for_completion) || appHelper.isDefined(object.required_for_completion) && object.required_for_completion;
	    return Object.assign({}, appModels.USER_DATA_SCREEN_OBJECT, {
	        asset_id: object.asset_id,
	        asset_type_code: object.asset_type_code,
	        required: required,
	        status: required ? objectConstants.STATUS_NOT_STARTED : objectConstants.STATUS_COMPLETE
	    });
	}
	
	//SET KPI DATA
	
	function setBiteKpis(bite) {
	    var kpisArray = [];
	
	    var has_score_kpi = appHelper.isDefined(bite.score_kpi);
	    var has_performance_kpis = appHelper.isDefined(bite.performance_kpis);
	
	    if (has_score_kpi) {
	        kpisArray = dataHelpers.immutablePush(kpisArray, setBiteKpiData(bite.score_kpi, bite.screens, true));
	    }
	    if (has_performance_kpis) {
	        for (var i = 0; i < bite.performance_kpis.length; i++) {
	            var kpi = bite.performance_kpis[i];
	            kpisArray = dataHelpers.immutablePush(kpisArray, setBiteKpiData(kpi, bite.screens, false));
	        }
	    }
	    return kpisArray;
	}
	
	function setBiteKpiData(kpi, screens, is_primary) {
	    var biteKpiData = Object.assign({}, appModels.USER_DATA_BITE_KPI, {
	        kpi_id: kpi.kpi_id,
	        is_primary: is_primary,
	        min: kpi.min,
	        max: kpi.max,
	        start: kpi.start,
	        current: kpi.start,
	        yellow: kpi.yellow,
	        green: kpi.green,
	        style: kpi.style,
	        unit_type: kpi.unit_type,
	        is_visible: kpi.is_visible,
	        positive_type: kpi.positive_type,
	        decimals_points: parseInt(kpi.decimals_points),
	        totalPoints: kpiHelper.getBiteKpiTotalPoints(screens, kpi.kpi_id),
	        currentScoreRange: kpiHelper.getKpiScoreRange(kpi, kpi.start),
	        last: kpi.start
	        //affects_personal_learning_plan: kpi.affects_personal_learning_plan,
	        //learning_plan_outcomes: kpi.learning_plan_outcomes
	    });
	
	    return biteKpiData;
	}
	
	function storeUserResponse(params) {
	    return new Promise(function (resolve, reject) {
	
	        var userData = Object.assign({}, params.userData);
	        var bites = Object.assign([], params.userData.bites);
	        var bite = appHelper.getArrayObjectByKey(params.userData.bites, "bite_id", params.bite_id);
	        var biteIndex = appHelper.getArrayObjectIndexByKey(params.userData.bites, "bite_id", bite.bite_id);
	
	        var bite_kpis = setBiteKpiResults(params);
	
	        //console.log(bite_kpis);
	        var bite_screens = setScreenResults(params);
	
	        bite = Object.assign({}, bite, {
	            kpis: bite_kpis,
	            screens: bite_screens
	        });
	
	        //let learning_plan_outcomes = this.getLearningPlanOutcomes(bite_kpis);
	        //console.log(learning_plan_outcomes);
	
	
	        //do this after screens have been updated
	        bite = Object.assign({}, bite, {
	            status: getBiteStatus(bite),
	            required: getBiteRequired(bite),
	            percentageComplete: getBitePercentageComplete(bite)
	        });
	
	        if (biteIndex > -1) {
	            bites = dataHelpers.immutableSplice(bites, biteIndex, 1, bite);
	        } else {
	            bites = dataHelpers.immutablePush(bites, bite);
	        }
	
	        /*if (learning_plan_outcomes.learning_plan_requires_updating) {
	            bites = updateLearningPlanOutcomes(bites, learning_plan_outcomes.personal_learning_plan);
	        }*/
	
	        if (appHelper.isDefined(localStorage.contentData.experience.experience_learning_model)) {
	            if (appHelper.isDefined(localStorage.contentData.experience.learning_plan)) {
	                var biteMenu = Object.assign({}, localStorage.contentData.experience.learning_plan);
	                bites = setBiteRequiredByRules(biteMenu, bites);
	            }
	        }
	
	        userData = Object.assign({}, userData, {
	            bites: bites
	        });
	
	        //let the other data be set before doing this.
	        userData = Object.assign({}, userData, {
	            status: getLessonStatus(userData.bites),
	            percentageComplete: getLessonPercentageComplete(userData.bites)
	        });
	        resolve(userData);
	    });
	}
	
	function setBiteRequiredByRules(biteMenu, bites) {
	    //console.log(`setBiteRequiredByRules`);
	    var updatedBites = [];
	    _lodash2.default.forEach(biteMenu.bites, function (menuBite) {
	        var bite = appHelper.getArrayObjectByKey(bites, "bite_id", menuBite.bite_id);
	        if (appHelper.isDefined(menuBite.rules) && menuBite.rules.length > 0) {
	            var ruleDefinitions = [];
	            var ruleCombination = [];
	            for (var i = 0; i < menuBite.rules.length; i++) {
	                var biteRule = menuBite.rules[i];
	                var rule = biteRule.rule;
	                var result = false;
	                var biteData = appHelper.getArrayObjectByKey(bites, "bite_id", rule.bite_id);
	                if (appHelper.isDefined(biteRule.condition)) {
	                    //Push and Clear if an or statement
	                    if (biteRule.condition === objectConstants.OR) {
	
	                        ruleDefinitions = dataHelpers.immutablePush(ruleDefinitions, ruleCombination);
	                        ruleCombination = dataHelpers.immutableSplice(ruleCombination, 0, ruleCombination.length);
	                        //console.log(`${bite.bite_id} - ${ruleDefinitions.length} - ${ruleCombination.length}`);
	                    }
	                }
	
	                if (appHelper.isDefined(biteRule.rule.kpi_id)) {
	                    var kpi = appHelper.getArrayObjectByKey(biteData.kpis, "kpi_id", rule.kpi_id);
	                    var kpiResult = appHelper.getArrayObjectByKey(_kpiModels.KPI_VALUES_TO_COLOUR_LIST, "value", kpi.currentScoreRange);
	                    result = kpiResult.colour === rule.result;
	                } else if (appHelper.isDefined(rule.badge_id)) {
	                    var badge = appHelper.getArrayObjectByKey(biteData.badges, "badge_id", rule.badge_id);
	
	                    if (rule.result === objectConstants.ACHIEVED && badge.achieved > 0) {
	                        result = true;
	                    } else if (rule.result === objectConstants.NOT_ACHIEVED && badge.achieved === 0) {
	                        result = true;
	                    }
	                }
	
	                rule = Object.assign({}, rule, {
	                    success: result
	                });
	
	                ruleCombination = dataHelpers.immutablePush(ruleCombination, rule);
	                if (i === menuBite.rules.length - 1) {
	                    ruleDefinitions = dataHelpers.immutablePush(ruleDefinitions, ruleCombination);
	                }
	            }
	            //time to check and update
	            _lodash2.default.forEach(ruleDefinitions, function (ruleCombination) {
	                var successCount = 0;
	                var display_rule = "";
	                _lodash2.default.forEach(ruleCombination, function (rule) {
	                    if (rule.success) {
	                        successCount++;
	                    }
	                    display_rule = rule.display_rule;
	                });
	                if (successCount === ruleCombination.length) {
	                    if (display_rule === objectConstants.SCREEN_RULE_TYPE_REQUIRED) {
	                        bite = Object.assign({}, bite, {
	                            required: true
	                        });
	                    } else if (display_rule === objectConstants.SCREEN_RULE_TYPE_OPTIONAL) {
	                        bite = Object.assign({}, bite, {
	                            required: false
	                        });
	                    } else if (display_rule === objectConstants.SCREEN_RULE_TYPE_HIDDEN) {
	                        bite = Object.assign({}, bite, {
	                            required: false,
	                            visible: false
	                        });
	                    }
	                } else {
	                    bite = Object.assign({}, bite, {
	                        required: true
	                    });
	                }
	                bite = Object.assign({}, bite, {
	                    status: getBiteStatus(bite),
	                    percentageComplete: getBitePercentageComplete(bite)
	                });
	
	                //console.log(`bite`,bite)
	            });
	        }
	        updatedBites = dataHelpers.immutablePush(updatedBites, bite);
	    });
	    return updatedBites;
	}
	
	function updateScreenResults(userData, params) {
	    return new Promise(function (resolve, reject) {
	        var bites = Object.assign([], userData.bites);
	        var bite = appHelper.getArrayObjectByKey(bites, "bite_id", params.bite_id);
	        var biteIndex = appHelper.getArrayObjectIndexByKey(bites, "bite_id", bite.bite_id);
	        var screen = {};
	        var screenIndex = -1;
	        var screen_status = params.screen_status;
	        var subScreen = {};
	        var subScreenIndex = -1;
	        if (appHelper.isDefined(params.parent_screen_id)) {
	
	            screen = appHelper.getArrayObjectByKey(bite.screens, "screen_id", params.parent_screen_id);
	            screenIndex = appHelper.getArrayObjectIndexByKey(bite.screens, "screen_id", params.parent_screen_id);
	            var _subScreen = getSubScreenUserData(userData, params.parent_screen_id, params.screen_id);
	            var _subScreenIndex = appHelper.getArrayObjectIndexByKey(screen.sub_screens, "screen_id", params.screen_id);
	
	            if (appHelper.isDefined(params.asset_id)) {
	                var object = appHelper.getArrayObjectByKey(_subScreen.objects, "asset_id", params.asset_id);
	                var objectIndex = appHelper.getArrayObjectIndexByKey(_subScreen.objects, "asset_id", params.asset_id);
	                if (appHelper.isDefined(params.result)) {
	                    object = Object.assign({}, object, {
	                        status: params.object_status,
	                        result: params.object_result
	                    });
	                } else {
	                    object = Object.assign({}, object, {
	                        status: params.object_status
	                    });
	                }
	
	                _subScreen = Object.assign({}, _subScreen, {
	                    status: screen_status,
	                    objects: screen_status === objectConstants.STATUS_COMPLETE ? setAllScreenObjectsToComplete(_subScreen.objects) : dataHelpers.immutableSplice(_subScreen.objects, objectIndex, 1, object)
	                });
	            } else {
	                _subScreen = Object.assign({}, _subScreen, {
	                    status: screen_status,
	                    objects: screen_status === objectConstants.STATUS_COMPLETE ? setAllScreenObjectsToComplete(_subScreen.objects) : _subScreen.objects
	                });
	            }
	            screen = Object.assign({}, screen, {
	                status: screen.status === objectConstants.STATUS_COMPLETE || screen.status === objectConstants.STATUS_NOT_REQUIRED ? screen.status : objectConstants.STATUS_IN_PROGRESS,
	                sub_screens: dataHelpers.immutableSplice(screen.sub_screens, _subScreenIndex, 1, _subScreen)
	            });
	        } else {
	            screen = appHelper.getArrayObjectByKey(bite.screens, "screen_id", params.screen_id);
	            screenIndex = appHelper.getArrayObjectIndexByKey(bite.screens, "screen_id", params.screen_id);
	
	            if (appHelper.isDefined(params.asset_id)) {
	                var _object = appHelper.getArrayObjectByKey(screen.objects, "asset_id", params.asset_id);
	                var _objectIndex = appHelper.getArrayObjectIndexByKey(screen.objects, "asset_id", params.asset_id);
	
	                if (appHelper.isDefined(params.result)) {
	                    _object = Object.assign({}, _object, {
	                        status: params.object_status,
	                        result: params.object_result
	                    });
	                } else {
	                    _object = Object.assign({}, _object, {
	                        status: params.object_status
	                    });
	                }
	
	                if (screen.status === objectConstants.STATUS_NOT_REQUIRED) {
	                    screen_status = objectConstants.STATUS_NOT_REQUIRED;
	                }
	
	                if (appHelper.isDefined(screen.sub_screens) && screen.sub_screens.length > 0) {
	                    screen = Object.assign({}, screen, {
	                        status: screen_status
	                        //objects: screen_status === objectConstants.STATUS_COMPLETE ? setAllScreenObjectsToComplete(screen.objects) : dataHelpers.immutableSplice(screen.objects, objectIndex, 1, object)
	                    });
	                } else {
	                    screen = Object.assign({}, screen, {
	                        status: screen_status,
	                        objects: screen_status === objectConstants.STATUS_COMPLETE ? setAllScreenObjectsToComplete(screen.objects) : dataHelpers.immutableSplice(screen.objects, _objectIndex, 1, _object)
	                        //sub_screens: screen_status === objectConstants.STATUS_COMPLETE ? setAllSubScreensToComplete(screen.sub_screens) : screen.sub_screens
	                    });
	                }
	            } else {
	                /*if (savedObjectExists > -1 && screen_status === objectConstants.STATUS_COMPLETE) {
	                    screen_status = objectConstants.STATUS_IN_PROGRESS;
	                }*/
	
	                if (screen.status === objectConstants.STATUS_NOT_REQUIRED) {
	                    screen_status = objectConstants.STATUS_NOT_REQUIRED;
	                }
	                if (appHelper.isDefined(screen.sub_screens) && screen.sub_screens.length > 0) {
	                    screen = Object.assign({}, screen, {
	                        status: screen_status,
	                        objects: screen_status === objectConstants.STATUS_COMPLETE ? setAllScreenObjectsToComplete(screen.objects) : screen.objects
	                    });
	                } else {
	                    screen = Object.assign({}, screen, {
	                        status: screen_status
	                        //sub_screens: screen_status === objectConstants.STATUS_COMPLETE ? setAllSubScreensToComplete(screen.sub_screens) : screen.sub_screens
	                    });
	                }
	            }
	        }
	        var bite_screens = dataHelpers.immutableSplice(bite.screens, screenIndex, 1, screen);
	        //TARGET SCREENS
	        if (screen_status === objectConstants.STATUS_COMPLETE) {
	            var isTargetScreen = appHelper.getArrayObjectIndexByKey(bite.target_screens, "screen_id", params.screen_id);
	            if (isTargetScreen > -1) {
	
	                var targetScreenAlreadyComplete = appHelper.getArrayObjectIndexByKey(bite.complete_target_screens, "screen_id", params.screen_id);
	                if (targetScreenAlreadyComplete === -1) {
	                    var targetScreenObject = {
	                        screen_id: params.screen_id
	                    };
	
	                    bite = Object.assign({}, bite, {
	                        complete_target_screens: dataHelpers.immutablePush(bite.complete_target_screens, targetScreenObject)
	                    });
	                }
	            }
	        }
	
	        bite = Object.assign({}, bite, {
	            screens: bite_screens
	        });
	
	        //do this after screens have been updated
	        bite = Object.assign({}, bite, {
	            status: getBiteStatus(bite),
	            //required: getBiteRequired(bite.screens),
	            percentageComplete: getBitePercentageComplete(bite)
	        });
	        bites = dataHelpers.immutableSplice(bites, biteIndex, 1, bite);
	        if (appHelper.isDefined(localStorage.contentData.experience.experience_learning_model)) {
	            if (appHelper.isDefined(localStorage.contentData.experience.learning_plan)) {
	                var biteMenu = Object.assign({}, localStorage.contentData.experience.learning_plan);
	                bites = setBiteRequiredByRules(biteMenu, bites);
	            }
	        }
	
	        userData = Object.assign({}, userData, {
	            bites: bites
	        });
	
	        //let the other data be set before doing this.
	        userData = Object.assign({}, userData, {
	            status: getLessonStatus(userData.bites),
	            percentageComplete: getLessonPercentageComplete(userData.bites)
	        });
	        //console.log(JSON.stringify(userData));
	        resolve(userData);
	    });
	}
	
	function setAllSubScreensToComplete(subScreens) {
	    var subScreenArray = [];
	    for (var i = 0; i < subScreens.length; i++) {
	        var subScreen = subScreens[i];
	        subScreen = Object.assign({}, subScreens, {
	            status: objectConstants.STATUS_COMPLETE,
	            objects: setAllScreenObjectsToComplete(subScreen.objects)
	        });
	        subScreenArray = dataHelpers.immutablePush(subScreenArray, subScreen);
	    }
	    return subScreenArray;
	}
	
	function setAllScreenObjectsToComplete(objects) {
	    var objectArray = [];
	    for (var i = 0; i < objects.length; i++) {
	        var object = objects[i];
	        object = Object.assign({}, object, {
	            status: objectConstants.STATUS_COMPLETE
	        });
	        objectArray = dataHelpers.immutablePush(objectArray, object);
	    }
	    return objectArray;
	}
	
	function setScreenResults(params) {
	
	    var bite = appHelper.getArrayObjectByKey(params.userData.bites, "bite_id", params.bite_id);
	    var biteScreens = [];
	    if (!appHelper.isDefined(params.parent_screen_id)) {
	        var screen = appHelper.getArrayObjectByKey(bite.screens, "screen_id", params.screen_id);
	        var screenIndex = appHelper.getArrayObjectIndexByKey(bite.screens, "screen_id", params.screen_id);
	        var screenUserData = getScreenUserData(params.userData, params.screen_id);
	        var object = appHelper.getArrayObjectByKey(screen.objects, "asset_id", params.asset_id);
	        var objectIndex = appHelper.getArrayObjectIndexByKey(screen.objects, "asset_id", params.asset_id);
	
	        var status = objectConstants.STATUS_IN_PROGRESS;
	        if (screenUserData.status === objectConstants.STATUS_COMPLETE) {
	            status = objectConstants.STATUS_COMPLETE;
	        } else if (screenUserData.status === objectConstants.STATUS_NOT_REQUIRED || !screenUserData.required) {
	            status = objectConstants.STATUS_NOT_REQUIRED;
	        }
	        screen = Object.assign({}, screen, {
	            status: status,
	            objects: dataHelpers.immutableSplice(screen.objects, objectIndex, 1, object)
	        });
	
	        biteScreens = dataHelpers.immutableSplice(bite.screens, screenIndex, 1, screen);
	    } else {
	        var parent_screen = appHelper.getArrayObjectByKey(bite.screens, "screen_id", params.parent_screen_id);
	        var parentScreenIndex = appHelper.getArrayObjectIndexByKey(bite.screens, "screen_id", params.parent_screen_id);
	        var parentScreenUserData = getScreenUserData(params.userData, params.parent_screen_id);
	
	        var sub_screen = appHelper.getArrayObjectByKey(parent_screen.sub_screens, "screen_id", params.screen_id);
	
	        var sub_screen_index = appHelper.getArrayObjectIndexByKey(parent_screen.sub_screens, "screen_id", params.screen_id);
	
	        var subScreenUserData = getSubScreenUserData(params.userData, params.parent_screen_id, params.screen_id);
	        var _object2 = appHelper.getArrayObjectByKey(sub_screen.objects, "asset_id", params.asset_id);
	
	        var _objectIndex2 = appHelper.getArrayObjectIndexByKey(sub_screen.objects, "asset_id", params.asset_id);
	
	        var _status = objectConstants.STATUS_IN_PROGRESS;
	        var parentStatus = objectConstants.STATUS_IN_PROGRESS;
	
	        if (subScreenUserData.status === objectConstants.STATUS_COMPLETE) {
	            _status = objectConstants.STATUS_COMPLETE;
	        } else if (subScreenUserData.status === objectConstants.STATUS_NOT_REQUIRED || !subScreenUserData.required) {
	            _status = objectConstants.STATUS_NOT_REQUIRED;
	        }
	
	        if (parentScreenUserData.status === objectConstants.STATUS_COMPLETE) {
	            parentStatus = objectConstants.STATUS_COMPLETE;
	        } else if (parentScreenUserData.status === objectConstants.STATUS_NOT_REQUIRED || !subScreenUserData.required) {
	            parentStatus = objectConstants.STATUS_NOT_REQUIRED;
	        }
	
	        sub_screen = Object.assign({}, sub_screen, {
	            status: _status,
	            objects: dataHelpers.immutableSplice(sub_screen.objects, _objectIndex2, 1, _object2)
	        });
	        parent_screen = Object.assign({}, parent_screen, {
	            status: parentStatus,
	            sub_screens: dataHelpers.immutableSplice(parent_screen.sub_screens, sub_screen_index, 1, sub_screen)
	        });
	
	        biteScreens = dataHelpers.immutableSplice(bite.screens, parentScreenIndex, 1, parent_screen);
	    }
	    return biteScreens;
	}
	
	function getLearningPlanOutcomes(bite_kpis) {
	    var personal_learning_plan = [];
	    for (var i = 0; i < bite_kpis.length; i++) {
	        var kpi = bite_kpis[i];
	        if (appHelper.isDefined(kpi.affects_personal_learning_plan) && kpi.affects_personal_learning_plan) {
	            for (var k = 0; k < kpi.learning_plan_outcomes.length; k++) {
	                var learning_plan = kpi.learning_plan_outcomes[k];
	                if (learning_plan.outcome === kpi.currentScoreRange) {
	                    //console.log(learning_plan.bites.length);
	                    for (var l = 0; l < learning_plan.bites.length; l++) {
	                        personal_learning_plan = dataHelpers.immutablePush(personal_learning_plan, learning_plan.bites[l]);
	                    }
	                }
	            }
	        }
	    }
	
	    return {
	        learning_plan_requires_updating: personal_learning_plan.length > 0,
	        personal_learning_plan: personal_learning_plan
	    };
	}
	
	function updateLearningPlanOutcomes(bites, personal_learning_plan) {
	    var new_bites = [];
	
	    for (var i = 0; i < bites.length; i++) {
	        var bite = bites[i];
	        var plp_index = appHelper.getArrayObjectIndexByKey(personal_learning_plan, "bite_id", bite.bite_id);
	
	        if (plp_index > -1) {
	            //let screens = Object.assign([],bite.screens);
	            var plp = appHelper.getArrayObjectByKey(personal_learning_plan, "bite_id", bite.bite_id);
	            bite = Object.assign({}, bite, {
	                required: plp.required,
	                status: !plp.required ? objectConstants.STATUS_NOT_REQUIRED : bite.status,
	                screens: setBiteScreenRequiredStatus(plp, bite.screens)
	            });
	        }
	        new_bites = dataHelpers.immutablePush(new_bites, bite);
	    }
	    return new_bites;
	}
	
	function setBiteScreenRequiredStatus(personal_learning_plan, screens) {
	    var updatedScreens = [];
	    for (var i = 0; i < screens.length; i++) {
	        var screen = screens[i];
	        if (screen.required !== personal_learning_plan.required) {
	            screen = Object.assign({}, screen, {
	                required: personal_learning_plan.required,
	                status: !personal_learning_plan.required ? objectConstants.STATUS_NOT_REQUIRED : screen.status
	            });
	        }
	        updatedScreens = dataHelpers.immutablePush(updatedScreens, screen);
	    }
	    return updatedScreens;
	}
	
	function setBiteKpiResults(params) {
	    var bite = appHelper.getArrayObjectByKey(params.userData.bites, "bite_id", params.bite_id);
	    //console.log(`bite`,bite);
	    var bite_kpis = [];
	
	    if (typeof params.kpis !== 'undefined' && params.kpis.length > 0) {
	        for (var i = 0; i < bite.kpis.length; i++) {
	
	            var kpi = bite.kpis[i];
	            if (kpi.kpi_id === null) {
	                kpi = Object.assign({}, appModels.USER_DATA_BITE_KPI);
	            }
	            //console.log(`kpi`, kpi);
	            //check to see if option exists in history
	            var previousResult = kpiHelper.getKpiPreviousResultForObject(kpi.history, params.screen_id, params.asset_id, kpi.kpi_id);
	            var previousResultIndex = kpiHelper.getKpiPreviousResultIndex(kpi.history, params.screen_id, params.asset_id, kpi.kpi_id);
	            var attemptCount = typeof previousResult.attempt === "undefined" ? 1 : previousResult.attempt + 1;
	            var optionKpi = appHelper.getArrayObjectByKey(params.kpis, "kpi_id", parseInt(kpi.kpi_id));
	            var currentKpiValue = 0;
	            var kpiValue = 0;
	            if (appHelper.isDefined(optionKpi)) {
	                kpiValue = kpiHelper.getKpiValue(optionKpi.value, kpi);
	                if (kpiValue > 0) {
	                    //console.log(`${kpi.current} + ${Math.abs(kpiValue)} = ${kpi.current + Math.abs(kpiValue)}`);
	                    currentKpiValue = parseFloat(kpi.current) + Math.abs(parseFloat(kpiValue));
	
	                    if (typeof previousResult.value == 'number') {
	                        if (previousResult.value < 0) {
	                            //console.log(`${currentKpiValue} = ${currentKpiValue} + ${Math.abs(previousResult.value)} = ${currentKpiValue + Math.abs(previousResult.value)}`)
	                            currentKpiValue = parseFloat(currentKpiValue) + Math.abs(parseFloat(previousResult.value));
	                        } else {
	                            //console.log(`${currentKpiValue} = ${currentKpiValue}  ${previousResult.value} = ${currentKpiValue - previousResult.value}`)
	
	                            currentKpiValue = parseFloat(currentKpiValue) - parseFloat(previousResult.value);
	                        }
	                    }
	
	                    if (currentKpiValue > kpi.max) {
	                        currentKpiValue = kpi.max;
	                    }
	                } else {
	                    //console.log(`${kpi.current} - ${Math.abs(kpiValue)} = ${kpi.current - Math.abs(kpiValue)}`);
	                    currentKpiValue = parseFloat(kpi.current) - Math.abs(parseFloat(kpiValue));
	
	                    if (typeof previousResult.value == 'number') {
	                        if (previousResult.value < 0) {
	                            //console.log(`${currentKpiValue} = ${currentKpiValue} + ${Math.abs(previousResult.value)} = ${currentKpiValue + Math.abs(previousResult.value)}`)
	                            currentKpiValue = parseFloat(currentKpiValue) + Math.abs(parseFloat(previousResult.value));
	                        } else {
	                            //console.log(`${currentKpiValue} = ${currentKpiValue}  ${previousResult.value} = ${currentKpiValue - previousResult.value}`)
	
	                            currentKpiValue = parseFloat(currentKpiValue) - parseFloat(previousResult.value);
	                        }
	                    }
	
	                    if (currentKpiValue < kpi.min) {
	                        currentKpiValue = kpi.min;
	                    }
	                }
	            } else {
	                //console.log(`no kpis for this question`);
	                currentKpiValue = kpi.current;
	                //console.log(`currentKpiValue`, currentKpiValue);
	            }
	
	            var decimals_points = parseInt(kpi.decimals_points) > 2 ? parseInt(kpi.decimals_points) : 2;
	            currentKpiValue = currentKpiValue.toFixed(decimals_points);
	
	            var kpiHistory = Object.assign({}, kpi, {
	                hasValue: appHelper.isDefined(optionKpi),
	                kpi_id: kpi.kpi_id,
	                parent_screen_id: params.parent_screen_id,
	                screen_id: params.screen_id,
	                asset_id: params.asset_id,
	                option_id: appHelper.isDefined(params.selectedOptions) ? params.selectedOptions : [],
	                current: parseFloat(currentKpiValue),
	                value: parseFloat(kpiValue),
	                currentScoreRange: kpiHelper.getKpiScoreRange(kpi, currentKpiValue),
	                statusIndicatorClass: appHelper.isDefined(optionKpi) ? kpiHelper.getKpiPointsIndicatorClass(optionKpi.value, kpi.kpi_id) : kpiHelper.getKpiPointsIndicatorClass("n-a", kpi.kpi_id),
	                attempt: attemptCount,
	                history: []
	            });
	
	            kpi = Object.assign({}, kpi, {
	                hasValue: appHelper.isDefined(optionKpi),
	                last: kpi.current,
	                current: parseFloat(currentKpiValue),
	                value: parseFloat(kpiValue),
	                history: previousResultIndex === -1 ? dataHelpers.immutablePush(kpi.history, kpiHistory) : dataHelpers.immutableSplice(kpi.history, previousResultIndex, 1, kpiHistory),
	                currentScoreRange: kpiHelper.getKpiScoreRange(kpi, currentKpiValue),
	                statusIndicatorClass: appHelper.isDefined(optionKpi) ? kpiHelper.getKpiPointsIndicatorClass(optionKpi.value, kpi.kpi_id) : kpiHelper.getKpiPointsIndicatorClass("n-a", kpi.kpi_id),
	                attempt: attemptCount
	            });
	
	            //console.log(kpi);
	
	            //if(appHelper.isDefined(optionKpi) || (!appHelper.isDefined(optionKpi) && kpi.is_primary)){
	            bite_kpis = dataHelpers.immutablePush(bite_kpis, kpi);
	            //}
	
	            //}
	        }
	    } else {
	        bite_kpis = Object.assign([], bite.kpis);
	    }
	
	    //console.log(`bite_kpis`,bite_kpis);
	
	    return bite_kpis;
	}
	
	//
	function updateUserDataWithSuspendData(userData, suspend_data) {
	    return new Promise(function (resolve, reject) {
	        var suspendDataBites = suspend_data[appHelper.getShortHandKeyByRef("bites").key];
	        var suspendDataResources = suspend_data[appHelper.getShortHandKeyByRef("resources").key];
	        var suspendDataAttachments = suspend_data[appHelper.getShortHandKeyByRef("attachments").key];
	        var suspendDataResponseQuestions = suspend_data[appHelper.getShortHandKeyByRef("short_response_questions").key];
	        //let suspendDataAchievements = suspend_data[appHelper.getShortHandKeyByRef("achievements").key];
	
	        var sh_bite_id = appHelper.getShortHandKeyByRef("bite_id").key;
	        var sh_screens = appHelper.getShortHandKeyByRef("screens").key;
	        var sh_kpis = appHelper.getShortHandKeyByRef("kpis").key;
	        var sh_badges = appHelper.getShortHandKeyByRef("badges").key;
	        var sh_required = appHelper.getShortHandKeyByRef("required").key;
	        var sh_complete_target_screens = appHelper.getShortHandKeyByRef("complete_target_screens").key;
	        var sh_terminated = appHelper.getShortHandKeyByRef("terminated").key;
	        //console.log(`sh_required: ${sh_required}`);
	
	        if (appHelper.isDefined(suspendDataBites)) {
	            var biteArray = [];
	            for (var i = 0; i < userData.bites.length; i++) {
	                var userDataBite = userData.bites[i];
	                var suspendDataBite = appHelper.getArrayObjectByKey(suspendDataBites, sh_bite_id, userDataBite.bite_id);
	                if (appHelper.isDefined(suspendDataBite)) {
	                    var suspendDataScreens = suspendDataBite[sh_screens];
	                    var suspendDataKPIs = suspendDataBite[sh_kpis];
	                    var suspendDataBadges = suspendDataBite[sh_badges];
	                    var suspendDataCompleteTargetScreens = suspendDataBite[sh_complete_target_screens];
	                    //console.log(`suspendDataKPIs`,suspendDataKPIs);
	                    var newBite = Object.assign({}, userDataBite, {
	                        screens: appHelper.isDefined(suspendDataScreens) ? updateBiteScreensWithSuspendData(userDataBite.screens, suspendDataScreens) : userDataBite.screens,
	                        kpis: appHelper.isDefined(suspendDataKPIs) ? updateBiteKpisWithSuspendData(userDataBite.kpis, suspendDataKPIs) : userDataBite.kpis,
	                        badges: appHelper.isDefined(suspendDataBadges) ? updateBadgesWithSuspendData(userDataBite.badges, suspendDataBadges) : userDataBite.badges,
	                        complete_target_screens: appHelper.isDefined(suspendDataCompleteTargetScreens) ? updateCompleteTargetScreensWithSuspendData(suspendDataCompleteTargetScreens) : userDataBite.complete_target_screens
	                    });
	                    newBite = Object.assign({}, newBite, {
	                        status: getBiteStatus(newBite),
	                        required: appHelper.getRefByShortHandKey(suspendDataBite[sh_required]).ref,
	                        terminated: appHelper.getRefByShortHandKey(suspendDataBite[sh_terminated]).ref,
	                        percentageComplete: getBitePercentageComplete(newBite)
	                    });
	                    biteArray = dataHelpers.immutablePush(biteArray, newBite);
	                }
	            }
	            userData = Object.assign({}, userData, {
	                bites: biteArray
	            });
	
	            //let the other data be set before doing this.
	            userData = Object.assign({}, userData, {
	                status: getLessonStatus(userData.bites),
	                percentageComplete: getLessonPercentageComplete(userData.bites),
	                lang: appHelper.isDefined(suspend_data.lang) ? suspend_data.lang : userData.lang
	            });
	        }
	
	        if (appHelper.isDefined(suspendDataResources)) {
	            userData = Object.assign({}, userData, {
	                resources: updateResourceScreensWithSuspendData(userData.resources, suspendDataResources)
	            });
	        }
	
	        if (appHelper.isDefined(suspendDataAttachments)) {
	            userData = Object.assign({}, userData, {
	                attachments: updateAttachmentsWithSuspendData(userData.attachments, suspendDataAttachments)
	            });
	        }
	
	        if (appHelper.isDefined(suspendDataResponseQuestions)) {
	            userData = Object.assign({}, userData, {
	                short_response_questions: updateShortResponseQuestionsWithSuspendData(userData.short_response_questions, suspendDataResponseQuestions)
	            });
	        }
	
	        /*if (appHelper.isDefined(suspendDataAchievements)) {
	            userData = Object.assign({}, userData, {
	                achievements: updateAchievementsWithSuspendData(userData.achievements, suspendDataAchievements)
	            });
	        }*/
	        //console.log(JSON.stringify(userData));
	        resolve(userData);
	    });
	}
	
	function updateShortResponseQuestionsWithSuspendData(short_response_questions, suspendDataResponseQuestions) {
	    var shortResponseQuestionArray = [];
	    var sh_id = appHelper.getShortHandKeyByRef("id").key;
	    var sh_response = appHelper.getShortHandKeyByRef("response").key;
	    for (var i = 0; i < short_response_questions.length; i++) {
	        var responseQuestion = short_response_questions[i];
	        var suspendDateResponseQuestion = appHelper.getArrayObjectByKey(suspendDataResponseQuestions, sh_id, responseQuestion.id);
	        if (appHelper.isDefined(suspendDateResponseQuestion)) {
	            responseQuestion = Object.assign({}, responseQuestion, {
	                response: suspendDateResponseQuestion[sh_response]
	            });
	        }
	        shortResponseQuestionArray = dataHelpers.immutablePush(shortResponseQuestionArray, responseQuestion);
	    }
	
	    return shortResponseQuestionArray;
	}
	
	function updateAttachmentsWithSuspendData(attachments, suspendDataAttachments) {
	    var attachmentsArray = [];
	    var sh_id = appHelper.getShortHandKeyByRef("id").key;
	    var sh_type = appHelper.getShortHandKeyByRef("type").key;
	    var sh_status = appHelper.getShortHandKeyByRef("status").key;
	
	    for (var i = 0; i < attachments.length; i++) {
	        var attachment = attachments[i];
	        var suspendDataAttachment = {};
	        for (var a = 0; a < suspendDataAttachments.length; a++) {
	            var _suspendDataAttachment = suspendDataAttachments[a];
	            //console.log(`${_suspendDataAttachment[sh_id]} === ${attachment.id}`);
	            if (appHelper.isDefined(_suspendDataAttachment)) {
	                if (_suspendDataAttachment[sh_id] === attachment.id && _suspendDataAttachment[sh_type] === appHelper.getShortHandKeyByRef(attachment.type).key) {
	                    suspendDataAttachment = Object.assign({}, _suspendDataAttachment);
	                }
	            }
	        }
	
	        if (appHelper.isDefined(suspendDataAttachment.id)) {
	            //console.log(`suspendDataAttachment`);
	            //console.log(suspendDataAttachment);
	            attachment = Object.assign({}, attachment, {
	                status: appHelper.getRefByShortHandKey(suspendDataAttachment[sh_status]).ref
	            });
	        }
	
	        attachmentsArray = dataHelpers.immutablePush(attachmentsArray, attachment);
	    }
	
	    return attachmentsArray;
	}
	
	function updateAchievementsWithSuspendData(achievements, suspendDataAchievements) {
	    var achievementsArray = [];
	    var sh_kpi_id = appHelper.getShortHandKeyByRef("kpi_id").key;
	    var sh_achieved = appHelper.getShortHandKeyByRef("achieved").key;
	    var sh_achievedOn = appHelper.getShortHandKeyByRef("achievedOn").key;
	    for (var i = 0; i < achievements.length; i++) {
	        var achievement = achievements[i];
	        var suspendDataAchievement = appHelper.getArrayObjectByKey(suspendDataAchievements, sh_kpi_id, achievement.kpi_id);
	        if (appHelper.isDefined(suspendDataAchievement)) {
	            achievement = Object.assign({}, achievement, {
	                achieved: suspendDataAchievement[sh_achieved],
	                achievedOn: suspendDataAchievement[sh_achievedOn]
	            });
	        }
	        achievementsArray = dataHelpers.immutablePush(achievementsArray, achievement);
	    }
	    return achievementsArray;
	}
	
	function updateBadgesWithSuspendData(badges, suspendDataBadges) {
	    var badgesArray = [];
	    var sh_badge_id = appHelper.getShortHandKeyByRef("badge_id").key;
	    var sh_achieved = appHelper.getShortHandKeyByRef("achieved").key;
	    var sh_achievedOn = appHelper.getShortHandKeyByRef("achievedOn").key;
	    for (var i = 0; i < badges.length; i++) {
	        var badge = badges[i];
	        var suspendDataBadge = appHelper.getArrayObjectByKey(suspendDataBadges, sh_badge_id, badge.badge_id);
	        if (appHelper.isDefined(suspendDataBadge)) {
	            badge = Object.assign({}, badge, {
	                achieved: suspendDataBadge[sh_achieved],
	                achievedOn: suspendDataBadge[sh_achievedOn]
	            });
	        }
	        badgesArray = dataHelpers.immutablePush(badgesArray, badge);
	    }
	    return badgesArray;
	}
	
	function updateCompleteTargetScreensWithSuspendData(suspendDataCompleteTargetScreens) {
	    var completeTargetScreens = [];
	    var sh_screen_id = appHelper.getShortHandKeyByRef("screen_id").key;
	    for (var i = 0; i < suspendDataCompleteTargetScreens.length; i++) {
	        var suspendDataTargetScreen = suspendDataCompleteTargetScreens[i];
	        if (appHelper.isDefined(suspendDataTargetScreen)) {
	            var target_screen = {
	                screen_id: suspendDataTargetScreen[sh_screen_id]
	            };
	
	            completeTargetScreens = dataHelpers.immutablePush(completeTargetScreens, target_screen);
	        }
	    }
	
	    return completeTargetScreens;
	}
	
	function updateResourceScreensWithSuspendData(resources, suspendDataResources) {
	
	    var resourcesScreenArray = [];
	    var sh_screen_id = appHelper.getShortHandKeyByRef("screen_id").key;
	    var sh_status = appHelper.getShortHandKeyByRef("status").key;
	    var sh_objects = appHelper.getShortHandKeyByRef("objects").key;
	    for (var i = 0; i < resources.length; i++) {
	        var resourceScreen = resources[i];
	        var suspendDataScreen = appHelper.getArrayObjectByKey(suspendDataResources, sh_screen_id, resourceScreen.screen_id);
	        if (appHelper.isDefined(suspendDataScreen)) {
	            var suspendDataObjects = suspendDataResources[sh_objects];
	
	            if (appHelper.isDefined(suspendDataObjects)) {
	
	                resourceScreen = Object.assign({}, resourceScreen, {
	                    screen_id: suspendDataScreen[sh_screen_id],
	                    status: appHelper.getRefByShortHandKey(suspendDataScreen[sh_status]).ref,
	                    objects: updateScreensObjectsWithSuspendData(resourceScreen.objects, suspendDataObjects)
	                });
	            } else {
	                resourceScreen = Object.assign({}, resourceScreen, {
	                    screen_id: suspendDataScreen[sh_screen_id],
	                    status: appHelper.getRefByShortHandKey(suspendDataScreen[sh_status]).ref,
	                    objects: appHelper.getRefByShortHandKey(suspendDataScreen[sh_status]).ref === objectConstants.STATUS_COMPLETE ? setAllScreenObjectsToComplete(resourceScreen.objects) : resourceScreen.objects
	                });
	            }
	            resourcesScreenArray = dataHelpers.immutablePush(resourcesScreenArray, resourceScreen);
	        }
	    }
	
	    return resourcesScreenArray;
	}
	
	function updateBiteScreensWithSuspendData(screens, suspendDataScreens) {
	    var screenArray = [];
	    var sh_screen_id = appHelper.getShortHandKeyByRef("screen_id").key;
	    var sh_status = appHelper.getShortHandKeyByRef("status").key;
	    var sh_required = appHelper.getShortHandKeyByRef("required").key;
	    var sh_objects = appHelper.getShortHandKeyByRef("objects").key;
	    var sh_sub_screens = appHelper.getShortHandKeyByRef("sub_screens").key;
	    for (var i = 0; i < screens.length; i++) {
	        var screen = screens[i];
	        var suspendDataScreen = appHelper.getArrayObjectByKey(suspendDataScreens, sh_screen_id, screen.screen_id);
	        if (appHelper.isDefined(suspendDataScreen)) {
	            var suspendDataObjects = suspendDataScreen[sh_objects];
	            var suspendDataSubScreens = suspendDataScreen[sh_sub_screens];
	            if (appHelper.isDefined(suspendDataObjects) && suspendDataObjects.length > 0) {
	                screen = Object.assign({}, screen, {
	                    screen_id: suspendDataScreen[sh_screen_id],
	                    status: appHelper.getRefByShortHandKey(suspendDataScreen[sh_status]).ref,
	                    required: appHelper.getRefByShortHandKey(suspendDataScreen[sh_required]).ref,
	                    objects: updateScreensObjectsWithSuspendData(screen.objects, suspendDataObjects)
	                });
	            } else if (appHelper.isDefined(suspendDataSubScreens) && suspendDataSubScreens.length > 0) {
	                screen = Object.assign({}, screen, {
	                    screen_id: suspendDataScreen[sh_screen_id],
	                    status: appHelper.getRefByShortHandKey(suspendDataScreen[sh_status]).ref,
	                    required: appHelper.getRefByShortHandKey(suspendDataScreen[sh_required]).ref,
	                    sub_screens: updateBiteScreensWithSuspendData(screen.sub_screens, suspendDataSubScreens)
	                });
	            } else {
	                screen = Object.assign({}, screen, {
	                    screen_id: suspendDataScreen[sh_screen_id],
	                    status: appHelper.getRefByShortHandKey(suspendDataScreen[sh_status]).ref,
	                    required: appHelper.getRefByShortHandKey(suspendDataScreen[sh_required]).ref,
	                    objects: appHelper.getRefByShortHandKey(suspendDataScreen[sh_status]).ref === objectConstants.STATUS_COMPLETE ? setAllScreenObjectsToComplete(screen.objects) : screen.objects
	                });
	            }
	            screenArray = dataHelpers.immutablePush(screenArray, screen);
	        }
	    }
	    return screenArray;
	}
	
	function updateScreensObjectsWithSuspendData(objects, suspendDataObjects) {
	    var objectArray = [];
	    var sh_asset_id = appHelper.getShortHandKeyByRef("asset_id").key;
	    for (var i = 0; i < objects.length; i++) {
	        var object = objects[i];
	        var suspendDataObject = appHelper.getArrayObjectByKey(suspendDataObjects, sh_asset_id, object.asset_id);
	        if (appHelper.isDefined(suspendDataObject)) {
	            object = Object.assign({}, object, {
	                asset_id: suspendDataObject[sh_asset_id],
	                status: objectConstants.STATUS_COMPLETE
	            });
	
	            objectArray = dataHelpers.immutablePush(objectArray, object);
	        } else {
	            objectArray = dataHelpers.immutablePush(objectArray, object);
	        }
	    }
	    return objectArray;
	}
	
	function updateBiteKpisWithSuspendData(kpis, suspendDataKPIs) {
	    var kpiArray = [];
	    var sh_current = appHelper.getShortHandKeyByRef("current").key;
	    var sh_kpi_id = appHelper.getShortHandKeyByRef("kpi_id").key;
	    var sh_history = appHelper.getShortHandKeyByRef("history").key;
	    for (var i = 0; i < kpis.length; i++) {
	        var kpi = kpis[i];
	        if (kpi.kpi_id === null) {
	            kpi = Object.assign({}, appModels.USER_DATA_BITE_KPI);
	        }
	        var suspendDataKpi = appHelper.getArrayObjectByKey(suspendDataKPIs, sh_kpi_id, kpi.kpi_id);
	
	        if (appHelper.isDefined(suspendDataKpi) && suspendDataKpi !== null) {
	            kpi = Object.assign({}, kpi, {
	                current: suspendDataKpi[sh_current],
	                currentScoreRange: kpiHelper.getKpiScoreRange(kpi, suspendDataKpi[sh_current])
	            });
	
	            kpi = Object.assign({}, kpi, {
	                history: setKpiHistoryWithSuspendData(kpi, suspendDataKpi[sh_history])
	            });
	
	            kpiArray = dataHelpers.immutablePush(kpiArray, kpi);
	        }
	    }
	    return kpiArray;
	}
	
	function setKpiHistoryWithSuspendData(kpi, kpiHistorySuspendData) {
	    var kpiHistoryArray = [];
	    var sh_value = appHelper.getShortHandKeyByRef("value").key;
	    var sh_asset_id = appHelper.getShortHandKeyByRef("asset_id").key;
	    var sh_option_id = appHelper.getShortHandKeyByRef("option_id").key;
	    var sh_current = appHelper.getShortHandKeyByRef("current").key;
	    var sh_hasValue = appHelper.getShortHandKeyByRef("hasValue").key;
	    var sh_statusIndicatorClass = appHelper.getShortHandKeyByRef("statusIndicatorClass").key;
	    for (var i = 0; i < kpiHistorySuspendData.length; i++) {
	        var kpiHistory = kpiHistorySuspendData[i];
	        var kpiHistoryOptions = kpiHistory[sh_option_id];
	        var optionDetails = {};
	        var optionKpi = {};
	        if (kpiHistoryOptions.length > 0) {
	            if (appHelper.isDefined(kpiHistoryOptions[0].option_id)) {
	                optionDetails = Object.assign({}, appHelper.getOptionParentDetails(kpiHistoryOptions[0].option_id));
	            } else {
	                optionDetails = Object.assign({}, appHelper.getOptionParentDetails(kpiHistoryOptions[0]));
	            }
	            var optionKpis = optionDetails.option.kpis !== null ? optionDetails.option.kpis : [];
	            optionKpi = appHelper.getArrayObjectByKey(optionKpis, "kpi_id", kpi.kpi_id);
	
	            if (kpiHistoryOptions.length > 1 && optionDetails.object.asset_type_code !== "compare_answer") {
	                var outcome = appHelper.getObjectOutcomeByKpiHistoryOptions(kpiHistoryOptions);
	                //let outcomeKpis
	                optionKpi = Object.assign({}, appHelper.getArrayObjectByKey(outcome.kpis, "kpi_id", kpi.kpi_id));
	            }
	        } else {
	            optionDetails = Object.assign({}, appHelper.getAssetParentDetails(kpiHistory[sh_asset_id]));
	            // optionKpi = kpiHistory;
	
	            var suspendDataOptionKpi = kpiHistory;
	            optionKpi = Object.assign({}, optionKpi, {
	
	                value: kpiHistory[sh_statusIndicatorClass][sh_value]
	
	            });
	        }
	
	        if (!appHelper.isDefined(optionKpi)) {
	            optionKpi = Object.assign({}, {});
	        }
	
	        var newKpiHistory = {
	            hasValue: kpiHistory[sh_hasValue] === 1,
	            value: kpiHistory[sh_value],
	            option_id: kpiHistoryOptions.length > 0 ? kpiHistory[sh_option_id] : [],
	            screen_id: optionDetails.screen.screen_id,
	            asset_id: optionDetails.object.asset_id,
	            current: kpiHistory[sh_current],
	            currentScoreRange: kpiHelper.getKpiScoreRange(kpi, kpi.current),
	            statusIndicatorClass: appHelper.isDefined(optionKpi.value) ? kpiHelper.getKpiPointsIndicatorClass(optionKpi.value, kpi.kpi_id) : kpiHelper.getKpiPointsIndicatorClass("n-a", kpi.kpi_id)
	        };
	
	        kpiHistoryArray = dataHelpers.immutablePush(kpiHistoryArray, newKpiHistory);
	    }
	
	    return kpiHistoryArray;
	}
	
	function updateResourceObjectResult(userData, params) {
	    return new Promise(function (resolve, reject) {
	
	        var resourceScreens = [];
	        _lodash2.default.forEach(userData.resources, function (resourceScreen) {
	            var resourceObjects = [];
	            _lodash2.default.forEach(resourceScreen.objects, function (resource) {
	
	                if (resource.asset_id === params.asset_id) {
	                    resource = Object.assign({}, resource, {
	                        status: params.status
	                    });
	                }
	                resourceObjects = dataHelpers.immutablePush(resourceObjects, resource);
	            });
	
	            resourceScreen = Object.assign({}, resourceScreen, {
	                objects: Object.assign([], resourceObjects)
	            });
	
	            resourceScreen = Object.assign({}, resourceScreen, {
	                status: getResourceScreenStatus(resourceScreen)
	            });
	
	            resourceScreens = dataHelpers.immutablePush(resourceScreens, resourceScreen);
	        });
	
	        var attachments = [];
	        _lodash2.default.forEach(userData.attachments, function (attachment) {
	
	            if (attachment.id === params.asset_id && attachment.type === params.asset_type_code) {
	                attachment = Object.assign({}, attachment, {
	                    status: params.status
	                });
	            }
	            attachments = dataHelpers.immutablePush(attachments, attachment);
	        });
	
	        userData = Object.assign({}, userData, {
	            resources: Object.assign([], resourceScreens),
	            attachments: Object.assign([], attachments)
	        });
	
	        resolve(userData);
	    });
	}
	
	function getResourceScreenStatus(screen) {
	    var completeCount = 0;
	    for (var i = 0; i < screen.objects.length; i++) {
	        var object = screen.objects[i];
	        if (object.status === objectConstants.STATUS_COMPLETE) {
	            completeCount++;
	        }
	    }
	    if (screen.status === objectConstants.STATUS_COMPLETE) {
	        return objectConstants.STATUS_COMPLETE;
	    } else if (completeCount === 0) {
	        return objectConstants.STATUS_NOT_STARTED;
	    } else if (completeCount === screen.objects.length) {
	        return objectConstants.STATUS_COMPLETE;
	    } else {
	        return objectConstants.STATUS_IN_PROGRESS;
	    }
	}
	
	function getRequiredScreenCount(bite) {
	    var requiredCount = 0;
	    for (var i = 0; i < bite.screens.length; i++) {
	        var screen = bite.screens[i];
	        //console.log(screen);
	
	        if (screen.required && !screen.isTargetScreen) {
	            //console.log(`${screen.required} && ${!screen.isTargetScreen}`);
	            requiredCount++;
	        }
	    }
	
	    return requiredCount;
	}
	
	function getBiteStatus(bite) {
	    //console.log(`getBiteStatus`);
	    var bite_id = bite.bite_id;
	    var biteStatus = objectConstants.STATUS_NOT_STARTED;
	    var completeScreenCount = 0;
	    var notRequiredScreenCount = 0;
	    var multiPathCompleteScreenCount = 0;
	    var completeWithNotRequiredCount = 0;
	
	    for (var i = 0; i < bite.screens.length; i++) {
	        var screen = bite.screens[i];
	        if (screen.required && screen.status === objectConstants.STATUS_COMPLETE && !screen.isTargetScreen) {
	            completeScreenCount++;
	            completeWithNotRequiredCount++;
	        } else if (screen.status === objectConstants.STATUS_NOT_REQUIRED) {
	            notRequiredScreenCount++;
	            completeWithNotRequiredCount++;
	        }
	    }
	
	    //console.log(`${completeScreenCount} >= ${getRequiredScreenCount(bite)}`)
	    if (completeScreenCount >= getRequiredScreenCount(bite)) {
	        //console.log(`${completeScreenCount} >= ${getRequiredScreenCount(bite)}`)
	        //console.log(`${bite.complete_target_screens.length} >= ${bite.number_of_target_screens}`);
	        if (bite.complete_target_screens.length >= bite.number_of_target_screens) {
	            biteStatus = objectConstants.STATUS_COMPLETE;
	        } else {
	            biteStatus = objectConstants.STATUS_IN_PROGRESS;
	        }
	    } else if (notRequiredScreenCount >= bite.screens.length) {
	        biteStatus = objectConstants.STATUS_NOT_REQUIRED;
	    } else if (completeScreenCount > 0 && completeScreenCount < bite.screens.length) {
	        biteStatus = objectConstants.STATUS_IN_PROGRESS;
	    }
	
	    if (completeWithNotRequiredCount >= bite.screens.length && notRequiredScreenCount > 0 && completeScreenCount > 0) {
	        biteStatus = objectConstants.STATUS_COMPLETE;
	    }
	
	    if (bite.terminated) {
	        biteStatus = objectConstants.STATUS_COMPLETE;
	    }
	
	    return biteStatus;
	}
	
	function getBiteRequired(bite) {
	    var biteRequired = true;
	    var requiredCount = getRequiredScreenCount(bite);
	    if (requiredCount === 0) {
	        biteRequired = false;
	    }
	
	    return biteRequired;
	}
	
	function getBitePercentageComplete(bite) {
	    if (bite.terminated) {
	        return 100;
	    } else {
	        return _getBitePercentageComplete(bite);
	    }
	}
	
	function _getBitePercentageComplete(bite) {
	    var screens = bite.screens;
	    var requiredScreenCount = getRequiredScreenCount(bite);
	    var requiredTargetScreens = bite.number_of_target_screens;
	    var totalScreenCount = requiredScreenCount + requiredTargetScreens;
	    var completeScreenCount = bite.complete_target_screens.length > requiredTargetScreens ? requiredTargetScreens : bite.complete_target_screens.length;
	
	    for (var i = 0; i < screens.length; i++) {
	        var screen = screens[i];
	        if (screen.required && screen.status === objectConstants.STATUS_COMPLETE && !screen.isTargetScreen) {
	            completeScreenCount++;
	        }
	    }
	
	    return Math.round(completeScreenCount / totalScreenCount * 100);
	}
	
	function getLessonStatus(bites) {
	    var biteStatus = objectConstants.STATUS_NOT_STARTED;
	    var inprogressBiteCount = 0;
	    var completeBiteCount = 0;
	
	    for (var i = 0; i < bites.length; i++) {
	        var bite = bites[i];
	        if (bite.required) {
	            if (bite.status === objectConstants.STATUS_IN_PROGRESS) {
	                inprogressBiteCount++;
	            } else if (bite.status === objectConstants.STATUS_COMPLETE) {
	                completeBiteCount++;
	            }
	        } else {
	            completeBiteCount++;
	        }
	    }
	    if (completeBiteCount >= bites.length) {
	        biteStatus = objectConstants.STATUS_COMPLETE;
	    } else if (completeBiteCount > 0 && completeBiteCount < bites.length || inprogressBiteCount > 0) {
	        biteStatus = objectConstants.STATUS_IN_PROGRESS;
	    }
	    return biteStatus;
	}
	
	function getLessonPercentageComplete(bites) {
	    var percentageComplete = 0;
	
	    for (var i = 0; i < bites.length; i++) {
	        var bite = bites[i];
	        if (bite.required) {
	            percentageComplete = percentageComplete + bite.percentageComplete;
	        } else {
	            percentageComplete = percentageComplete + 100;
	        }
	    }
	    return Math.round(percentageComplete / bites.length);
	}
	
	function getBiteUserData(userData, bite_id) {
	    for (var i = 0; i < userData.bites.length; i++) {
	        for (var _i = 0; _i < userData.bites.length; _i++) {
	            var bite = userData.bites[_i];
	            if (bite.bite_id === bite_id) {
	                return bite;
	            }
	        }
	    }
	    return undefined;
	}
	
	function getScreenUserData(userData, screen_id) {
	    for (var i = 0; i < userData.bites.length; i++) {
	        var bite = userData.bites[i];
	        for (var s = 0; s < bite.screens.length; s++) {
	            var screen = bite.screens[s];
	            if (screen.screen_id === screen_id) {
	                return screen;
	            }
	        }
	    }
	    return undefined;
	}
	
	function getSubScreenUserData(userData, parent_screen_id, screen_id) {
	    var sub_screen_obj = {};
	    _lodash2.default.forEach(userData.bites, function (bite) {
	        _lodash2.default.forEach(bite.screens, function (screen) {
	            if (screen.screen_id === parent_screen_id) {
	                _lodash2.default.forEach(screen.sub_screens, function (sub_screen) {
	                    if (sub_screen.screen_id === screen_id) {
	
	                        sub_screen_obj = Object.assign({}, sub_screen);
	                    }
	                });
	            }
	        });
	    });
	
	    return sub_screen_obj;
	}
	
	function getObjectStatus(userData, screen_id, asset_id) {
	    //console.log(userData);
	    //console.log(asset_id);
	    for (var i = 0; i < userData.bites.length; i++) {
	        var bite = userData.bites[i];
	        for (var s = 0; s < bite.screens.length; s++) {
	            var screen = bite.screens[s];
	            if (screen.screen_id === screen_id) {
	                if (appHelper.isDefined(screen.objects)) {
	                    for (var o = 0; o < screen.objects.length; o++) {
	                        var object = screen.objects[o];
	                        if (object.asset_id === asset_id) {
	                            return object;
	                        }
	                    }
	                }
	            }
	        }
	    }
	    return undefined;
	}
	
	function getSubScreenObjectStatus(userData, screen_id, sub_screen_id, asset_id) {
	    //console.log(userData);
	    //console.log(asset_id);
	    for (var i = 0; i < userData.bites.length; i++) {
	        var bite = userData.bites[i];
	        for (var s = 0; s < bite.screens.length; s++) {
	            var screen = bite.screens[s];
	            if (screen.screen_id === screen_id) {
	                if (appHelper.isDefined(screen.sub_screens)) {
	                    for (var b = 0; b < screen.sub_screens.length; b++) {
	                        var sub_screen = screen.sub_screens[b];
	                        if (sub_screen.screen_id === sub_screen_id) {
	                            if (appHelper.isDefined(sub_screen.objects)) {
	                                for (var o = 0; o < sub_screen.objects.length; o++) {
	                                    var object = sub_screen.objects[o];
	                                    if (object.asset_id === asset_id) {
	                                        return object;
	                                    }
	                                }
	                            }
	                        }
	                    }
	                }
	            }
	        }
	    }
	    return undefined;
	}
	
	function getResourceScreenUserData(userData, screen_id) {
	    var resourceScreen = {};
	    _lodash2.default.forEach(userData.resources, function (resource) {
	        if (resource.screen_id === screen_id) {
	            resourceScreen = Object.assign({}, resource);
	        }
	    });
	
	    return resourceScreen;
	}
	
	function getResourceScreenObjectUserData(userData, screen_id, asset_id) {
	    var resourceObject = {};
	    _lodash2.default.forEach(userData.resources, function (resource) {
	        if (resource.screen_id === screen_id) {
	            _lodash2.default.forEach(resource.objects, function (object) {
	                if (object.asset_id === asset_id) {
	                    resourceObject = Object.assign({}, object);
	                }
	            });
	        }
	    });
	
	    return resourceObject;
	}
	
	function getAttachmentObjectUserData(userData, asset_id) {
	    var attachmentObject = {};
	    _lodash2.default.forEach(userData.attachments, function (attachment) {
	        if (attachment.id === asset_id) {
	            attachmentObject = Object.assign({}, attachment);
	        }
	    });
	
	    return attachmentObject;
	}
	
	function getBiteKpi(usrData, bite_id, kpi_id) {
	    var bite = appHelper.getArrayObjectByKey(usrData.bites, "bite_id", bite_id);
	    return appHelper.getArrayObjectByKey(bite.kpis, "kpi_id", kpi_id);
	}
	
	function getUserResponseByOptionIds(userData, bite_id, optionIds) {
	
	    var bite = appHelper.getArrayObjectByKey(userData.bites, "bite_id", bite_id);
	    //console.log(`bite`, bite);
	    if (bite.kpis.length > 0) {
	        var primaryKpi = kpiHelper.getPrimaryKpi(bite.kpis);
	        if (!appHelper.isDefined(primaryKpi)) {
	            primaryKpi = getBiteKpi(userData, bite.bite_id, 0);
	        }
	        for (var i = 0; i < primaryKpi.history.length; i++) {
	            var history = primaryKpi.history[i];
	            for (var h = 0; h < history.option_id.length; h++) {
	                var historyOptionId = history.option_id[h];
	                if (optionIds.indexOf(historyOptionId) > -1) {
	                    return history;
	                }
	            }
	        }
	    }
	}
	
	function getUserInputResponseByOptionIds(userData, bite_id, optionIds) {
	    //console.log(`getUserResponseByOptionIds`);
	    //console.log(bite_id);
	    //console.log(optionIds);
	    var bite = appHelper.getArrayObjectByKey(userData.bites, "bite_id", bite_id);
	
	    var primaryKpi = kpiHelper.getPrimaryKpi(bite.kpis);
	    //console.log(primaryKpi);
	    for (var i = 0; i < primaryKpi.history.length; i++) {
	        var history = primaryKpi.history[i];
	        //console.log(history);
	        for (var h = 0; h < history.option_id.length; h++) {
	            var historyOptionId = history.option_id[h];
	            if (appHelper.isDefined(historyOptionId.option_id)) {
	                return history;
	            }
	        }
	        //option_id
	    }
	}
	
	function getToolboxScreenUserData(userData, toolbox_id) {
	    var toolbox = userData.toolbox;
	    var toolbox_screen = appHelper.getArrayObjectByKey(toolbox.screens, "toolbox_id", toolbox_id);
	    return toolbox_screen;
	}
	
	function getToolboxObjectStatus(userData, toolbox_id, asset_id) {
	    var toolbox = userData.toolbox;
	    var toolbox_screen = appHelper.getArrayObjectByKey(toolbox.screens, "toolbox_id", toolbox_id);
	    var object = appHelper.getArrayObjectByKey(toolbox_screen.objects, "asset_id", asset_id);
	    return object;
	}
	
	function getScreenMultiPathResult(multiPath, userData, bite_id) {
	    var bite = appHelper.getArrayObjectByKey(userData.bites, "bite_id", bite_id);
	    var kpis = bite.kpis;
	    var selectedPath = {};
	
	    for (var i = 0; i < multiPath.paths.length; i++) {
	        var path = multiPath.paths[i];
	        var matches = 0;
	        for (var k = 0; k < kpis.length; k++) {
	            var kpi = kpis[k];
	            var pathKpi = appHelper.getArrayObjectByKey(path.kpis, "kpi_id", kpi.kpi_id);
	            if (kpi.current === pathKpi.value) {
	                matches++;
	            }
	        }
	        if (matches === path.kpis.length) {
	            selectedPath = Object.assign({}, path);
	        }
	    }
	    return selectedPath;
	}
	
	function getSavedObjects(userData, bite_id) {
	    var savedObjects = [];
	    var bite = appHelper.getArrayObjectByKey(userData.bites, "bite_id", bite_id);
	    for (var s = 0; s < bite.screens.length; s++) {
	        var screen = bite.screens[s];
	        for (var o = 0; o < screen.objects.length; o++) {
	            var object = screen.objects[o];
	            if (object.status === objectConstants.STATUS_SAVED) {
	                savedObjects = dataHelpers.immutablePush(savedObjects, object);
	            }
	        }
	    }
	
	    return savedObjects;
	}
	
	//Collect Badge
	function collectBadge(userData, params) {
	    return new Promise(function (resolve, reject) {
	        var bite = appHelper.getArrayObjectByKey(userData.bites, "bite_id", params.bite_id);
	        var biteIndex = appHelper.getArrayObjectIndexByKey(userData.bites, "bite_id", params.bite_id);
	
	        var badgeIndex = appHelper.getArrayObjectIndexByKey(bite.badges, "badge_id", params.badge.badge_id);
	        var badge = appHelper.getArrayObjectByKey(bite.badges, "badge_id", params.badge.badge_id);
	        var achievedOnIndex = badge.achievedOn.indexOf(params.asset_id);
	
	        badge = Object.assign({}, badge, {
	            achieved: badge.achieved + 1,
	            achievedOn: achievedOnIndex === -1 ? dataHelpers.immutablePush(badge.achievedOn, params.asset_id) : badge.achievedOn
	        });
	
	        var badges = dataHelpers.immutableSplice(bite.badges, badgeIndex, 1, badge);
	        bite = Object.assign({}, bite, {
	            badges: Object.assign([], badges)
	        });
	
	        var bites = dataHelpers.immutableSplice(userData.bites, biteIndex, 1, bite);
	
	        if (appHelper.isDefined(localStorage.contentData.experience.experience_learning_model)) {
	            if (appHelper.isDefined(localStorage.contentData.experience.learning_plan)) {
	                var biteMenu = Object.assign({}, localStorage.contentData.experience.learning_plan);
	                bites = setBiteRequiredByRules(biteMenu, bites);
	            }
	        }
	
	        userData = Object.assign({}, userData, {
	            bites: bites
	        });
	        resolve(userData);
	    });
	}
	
	function checkBadgeEarnedOnObject(userData, params) {
	    var earnedBadges = [];
	    var bite = appHelper.getArrayObjectByKey(userData.bites, "bite_id", params.bite_id);
	    for (var i = 0; i < bite.badges.length; i++) {
	        var badge = bite.badges[i];
	        for (var j = 0; j < badge.achievedOn.length; j++) {
	            var achievedOn_asset_id = badge.achievedOn[j];
	            if (achievedOn_asset_id === params.asset_id) {
	                earnedBadges = dataHelpers.immutablePush(earnedBadges, badge);
	            }
	        }
	    }
	    return earnedBadges;
	}
	
	function getKpiAverage(userData, bite_id) {
	    var bite = appHelper.getArrayObjectByKey(userData.bites, "bite_id", bite_id);
	    var current = 0;
	    var total = 0;
	    for (var i = 0; i < bite.kpis.length; i++) {
	        var kpi = bite.kpis[i];
	        current = current + kpi.current;
	        total = total + kpi.max;
	    }
	
	    return Math.round(current / total * 100);
	}
	
	//Collect Achievement
	function saveNotes(userData, params) {
	    return new Promise(function (resolve, reject) {
	        var notesIndex = appHelper.getArrayObjectIndexByKey(userData.notes, "screen_id", params.screen_id);
	        userData = Object.assign({}, userData, {
	            notes: notesIndex === -1 ? dataHelpers.immutablePush(userData.notes, params) : dataHelpers.immutableSplice(userData.notes, notesIndex, 1, params)
	        });
	        resolve(userData);
	    });
	}
	
	function getAllUserBadges(userData) {
	    var allBadges = [];
	    _lodash2.default.forEach(userData.bites, function (bite) {
	        if (appHelper.isDefined(bite.badges)) {
	            _lodash2.default.forEach(bite.badges, function (badge) {
	                var badgeIndex = appHelper.getArrayObjectIndexByKey(allBadges, "badge_id", badge.badge_id);
	                if (badgeIndex === -1) {
	                    allBadges = dataHelpers.immutablePush(allBadges, badge);
	                }
	            });
	        }
	    });
	    return allBadges;
	}
	
	function storeUserShortResponses(params) {
	    return new Promise(function (resolve, reject) {
	        var userData = Object.assign({}, params.userData);
	        var short_response_questions = Object.assign([], userData.short_response_questions);
	
	        _lodash2.default.forEach(params.answeredQuestions, function (question) {
	            var data_question = appHelper.getArrayObjectByKey(short_response_questions, "id", question.id);
	
	            var data_questionIndex = appHelper.getArrayObjectIndexByKey(short_response_questions, "id", question.id);
	
	            data_question = Object.assign({}, data_question, {
	                response: question.response
	            });
	            short_response_questions = dataHelpers.immutableSplice(short_response_questions, data_questionIndex, 1, data_question);
	        });
	
	        userData = Object.assign({}, userData, {
	            short_response_questions: short_response_questions
	        });
	
	        //console.log(userData);
	        resolve(userData);
	    });
	}

/***/ },
/* 16 */
/***/ function(module, exports, __webpack_require__) {

	var map = {
		"./json/version": 350,
		"./json/version.json": 350
	};
	function webpackContext(req) {
		return __webpack_require__(webpackContextResolve(req));
	};
	function webpackContextResolve(req) {
		return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
	};
	webpackContext.keys = function webpackContextKeys() {
		return Object.keys(map);
	};
	webpackContext.resolve = webpackContextResolve;
	module.exports = webpackContext;
	webpackContext.id = 16;


/***/ },
/* 17 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.setObject = setObject;
	exports.setArray = setArray;
	exports.set = set;
	var contentData = exports.contentData = {};
	var default_langauge = exports.default_langauge = "";
	var experience_locale = exports.experience_locale = {};
	var tracking_type = exports.tracking_type = "";
	var post_completion_mode = exports.post_completion_mode = "";
	var resources = exports.resources = [];
	var bites = exports.bites = [];
	var assets = exports.assets = [];
	var default_progress_label = exports.default_progress_label = "Continue";
	var strings = exports.strings = {};
	var user_role = exports.user_role = "";
	var user_name = exports.user_name = "";
	var localeOptions = exports.localeOptions = {};
	var languages = exports.languages = [];
	
	//export let toolbox_locale = {};
	//export let menu = {};
	//export let achievements = [];
	//
	function setObject(string, value) {
	    return this[string] = Object.assign({}, value);
	}
	
	function setArray(string, value) {
	    this[string] = Object.assign([], value);
	}
	
	function set(string, value) {
	    this[string] = value;
	}

/***/ },
/* 18 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(5);
	
	var _redux = __webpack_require__(4);
	
	var _initActions = __webpack_require__(64);
	
	var initActions = _interopRequireWildcard(_initActions);
	
	var _trackingDataActions = __webpack_require__(7);
	
	var trackingDataActions = _interopRequireWildcard(_trackingDataActions);
	
	var _appHelper = __webpack_require__(3);
	
	var appHelper = _interopRequireWildcard(_appHelper);
	
	var _gsap = __webpack_require__(8);
	
	var _keyboardConstants = __webpack_require__(14);
	
	var keyboardConstants = _interopRequireWildcard(_keyboardConstants);
	
	var _gsapReactPlugin = __webpack_require__(10);
	
	var _gsapReactPlugin2 = _interopRequireDefault(_gsapReactPlugin);
	
	var _objectConstants = __webpack_require__(9);
	
	var objectConstants = _interopRequireWildcard(_objectConstants);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Button = function (_React$Component) {
	    _inherits(Button, _React$Component);
	
	    function Button(props, context) {
	        _classCallCheck(this, Button);
	
	        var _this = _possibleConstructorReturn(this, (Button.__proto__ || Object.getPrototypeOf(Button)).call(this, props, context));
	
	        _this.state = {};
	        _this.show = _this.show.bind(_this);
	        _this.onComplete = _this.onComplete.bind(_this);
	        _this.onKeyboardClick = _this.onKeyboardClick.bind(_this);
	        return _this;
	    }
	
	    _createClass(Button, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            // this.show();
	        }
	    }, {
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(nextProps) {}
	    }, {
	        key: 'show',
	        value: function show() {
	            var optionRef = this.refs[this.props.id];
	            _gsap.TweenLite.set(optionRef, { height: "auto" });
	            _gsap.TweenLite.from(optionRef, objectConstants.BUTTON_DURATION, {
	                height: 0,
	                ease: _gsap.Expo.easeInOut
	            }).eventCallback("onComplete", this.onComplete);
	        }
	    }, {
	        key: 'onComplete',
	        value: function onComplete() {
	            if (appHelper.isDefined(this.props.onRevealed)) {
	                this.props.onRevealed();
	            }
	        }
	    }, {
	        key: 'onKeyboardClick',
	        value: function onKeyboardClick(event) {
	            if (event.which === keyboardConstants.ENTER_KEY || event.which === keyboardConstants.SPACEBAR_KEY) {
	                event.preventDefault();
	                this.props.onClick();
	            }
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	
	            return _react2.default.createElement(
	                'div',
	                { className: ' text-center' },
	                _react2.default.createElement('input', {
	                    type: 'submit',
	                    disabled: this.props.isDisabled,
	                    tabIndex: "0",
	                    ref: this.props.id,
	                    id: this.props.id,
	                    value: this.props.label,
	                    className: 'btn btn-lg action-btn guroo-btn',
	                    onClick: this.props.onClick,
	                    onKeyDown: this.onKeyboardClick
	                })
	            );
	        }
	    }]);
	
	    return Button;
	}(_react2.default.Component);
	
	Button.propTypes = {
	    label: _propTypes2.default.string.isRequired,
	    id: _propTypes2.default.string.isRequired,
	    onClick: _propTypes2.default.func.isRequired,
	    isDisabled: _propTypes2.default.bool,
	    onRevealed: _propTypes2.default.func
	};
	
	Button.contextTypes = {
	    router: _propTypes2.default.object
	};
	
	function mapStateToProps(state, ownProps) {
	    return {};
	}
	
	function mapDispatchToProps(dispatch) {
	    return {
	        actions: (0, _redux.bindActionCreators)(Object.assign({}, initActions, trackingDataActions), dispatch)
	    };
	}
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(Button);

/***/ },
/* 19 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.setDialogPopup = setDialogPopup;
	exports.setContentToolTip = setContentToolTip;
	exports.setClickRevealDialog = setClickRevealDialog;
	exports.setAssetDialogPopup = setAssetDialogPopup;
	exports.setScreenDialogPopup = setScreenDialogPopup;
	exports.setNewDialog = setNewDialog;
	exports.updateDialog = updateDialog;
	exports.removeDialog = removeDialog;
	exports.setToolTip = setToolTip;
	exports.hideToolTop = hideToolTop;
	exports.setNewClickRevealDialog = setNewClickRevealDialog;
	exports.removeClickRevealDialog = removeClickRevealDialog;
	exports.setNewAssetDialog = setNewAssetDialog;
	exports.removeAssetDialog = removeAssetDialog;
	exports.setNewScreenDialog = setNewScreenDialog;
	exports.removeScreenDialog = removeScreenDialog;
	
	var _actionTypes = __webpack_require__(22);
	
	var types = _interopRequireWildcard(_actionTypes);
	
	var _dialogHelper = __webpack_require__(202);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function setDialogPopup(dialogPopup) {
	    return { type: types.SET_DIALOG_POPUP, dialogPopup: dialogPopup };
	}
	
	function setContentToolTip(contentToolTip) {
	    return { type: types.SET_CONTENT_TOOLTIP, contentToolTip: contentToolTip };
	}
	
	function setClickRevealDialog(clickRevealDialog) {
	    return { type: types.SET_CLICK_REVEAL_DIALOG, clickRevealDialog: clickRevealDialog };
	}
	
	function setAssetDialogPopup(assetDialog) {
	    return { type: types.SET_ASSET_DIALOG, assetDialog: assetDialog };
	}
	
	function setScreenDialogPopup(screenDialog) {
	    return { type: types.SET_SCREEN_DIALOG, screenDialog: screenDialog };
	}
	
	function setNewDialog(config) {
	    return function (dispatch) {
	        return (0, _dialogHelper.setStandardDialog)(config).then(function (dialogPopup) {
	            dispatch(setDialogPopup(dialogPopup));
	        }).catch(function (error) {
	            throw error;
	        });
	    };
	}
	
	function updateDialog(config) {
	    return function (dispatch, getState) {
	        var state = getState();
	        var dialogPopup = state.dialogPopup;
	        dialogPopup = Object.assign({}, dialogPopup, {
	            config: config
	        });
	        dispatch(setDialogPopup(dialogPopup));
	    };
	}
	
	function removeDialog() {
	    return function (dispatch) {
	        return (0, _dialogHelper.clearDialog)().then(function (dialogPopup) {
	            dispatch(setDialogPopup(dialogPopup));
	        }).catch(function (error) {
	            throw error;
	        });
	    };
	}
	
	function setToolTip(content) {
	    return function (dispatch) {
	        var contentToolTip = {
	            render: true,
	            content: content
	        };
	        dispatch(setContentToolTip(contentToolTip));
	    };
	}
	
	function hideToolTop() {
	    return function (dispatch) {
	        var contentToolTip = {
	            render: false,
	            content: ""
	        };
	        dispatch(setContentToolTip(contentToolTip));
	    };
	}
	
	function setNewClickRevealDialog(config) {
	    return function (dispatch) {
	        return (0, _dialogHelper.setClickReveal)(config).then(function (clickRevealDialog) {
	            dispatch(setClickRevealDialog(clickRevealDialog));
	        }).catch(function (error) {
	            throw error;
	        });
	    };
	}
	
	function removeClickRevealDialog() {
	    return function (dispatch) {
	        return (0, _dialogHelper.clearDialog)().then(function (clickRevealDialog) {
	            dispatch(setClickRevealDialog(clickRevealDialog));
	        }).catch(function (error) {
	            throw error;
	        });
	    };
	}
	
	function setNewAssetDialog(config) {
	    return function (dispatch) {
	        return (0, _dialogHelper.setAssetDialog)(config).then(function (dialogPopup) {
	            dispatch(setAssetDialogPopup(dialogPopup));
	        }).catch(function (error) {
	            throw error;
	        });
	    };
	}
	
	function removeAssetDialog() {
	    return function (dispatch) {
	        return (0, _dialogHelper.clearDialog)().then(function (dialogPopup) {
	            dispatch(setAssetDialogPopup(dialogPopup));
	        }).catch(function (error) {
	            throw error;
	        });
	    };
	}
	
	function setNewScreenDialog(config) {
	    return function (dispatch) {
	        return (0, _dialogHelper.setScreenDialog)(config).then(function (screenDialog) {
	            dispatch(setScreenDialogPopup(screenDialog));
	        }).catch(function (error) {
	            throw error;
	        });
	    };
	}
	
	function removeScreenDialog() {
	    return function (dispatch) {
	        return (0, _dialogHelper.clearDialog)().then(function (screenDialog) {
	            dispatch(setScreenDialogPopup(screenDialog));
	        }).catch(function (error) {
	            throw error;
	        });
	    };
	}

/***/ },
/* 20 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.setUserData = setUserData;
	exports.setInitialUserData = setInitialUserData;
	exports.clearBiteUserData = clearBiteUserData;
	exports.terminateBite = terminateBite;
	exports.updateUserDataWithSuspendData = updateUserDataWithSuspendData;
	exports.storeUserResponse = storeUserResponse;
	exports.updateScreenResults = updateScreenResults;
	exports.updateResourceObjectResult = updateResourceObjectResult;
	exports.collectBadge = collectBadge;
	exports.saveNotes = saveNotes;
	exports.storeUserShortResponses = storeUserShortResponses;
	exports.updateExperienceLocale = updateExperienceLocale;
	
	var _userDataHelper = __webpack_require__(15);
	
	var userDataHelper = _interopRequireWildcard(_userDataHelper);
	
	var _localStorage = __webpack_require__(17);
	
	var localStorage = _interopRequireWildcard(_localStorage);
	
	var _actionTypes = __webpack_require__(22);
	
	var types = _interopRequireWildcard(_actionTypes);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function setUserData(userData) {
	    return { type: types.SET_USER_DATA, userData: userData };
	}
	
	function setInitialUserData(project) {
	    return function (dispatch) {
	        return userDataHelper.setInitialUserData(project).then(function (userData) {
	            localStorage.set("default_langauge", userData.lang);
	            localStorage.set("strings", localStorage.contentData.experience.strings[userData.lang]);
	            document.documentElement.setAttribute('lang', userData.lang);
	            document.title = localStorage.contentData.experience.locale[userData.lang].experience_title;
	
	            dispatch(setUserData(userData));
	            return userData;
	        }).catch(function (error) {
	            throw error;
	        });
	    };
	}
	
	function clearBiteUserData(bite) {
	    return function (dispatch, getState) {
	        var state = getState();
	        return userDataHelper.clearBiteUserData(state.userData, state.contentData.experience, bite).then(function (userData) {
	            dispatch(setUserData(userData));
	            return userData;
	        }).catch(function (error) {
	            throw error;
	        });
	    };
	}
	
	function terminateBite(bite) {
	    return function (dispatch, getState) {
	        var state = getState();
	        return userDataHelper.terminateBite(state.userData, bite).then(function (userData) {
	            dispatch(setUserData(userData));
	            return userData;
	        }).catch(function (error) {
	            throw error;
	        });
	    };
	}
	
	function updateUserDataWithSuspendData() {
	    return function (dispatch, getState) {
	        var state = getState();
	
	        return userDataHelper.updateUserDataWithSuspendData(state.userData, state.trackingData.suspend_data).then(function (userData) {
	            localStorage.set("default_langauge", userData.lang);
	            localStorage.set("strings", localStorage.contentData.experience.strings[userData.lang]);
	            document.documentElement.setAttribute('lang', userData.lang);
	            document.title = localStorage.contentData.experience.locale[userData.lang].experience_title;
	            dispatch(setUserData(userData));
	            //console.log(userData);
	            return userData;
	        }).catch(function (error) {
	            throw error;
	        });
	    };
	}
	
	function storeUserResponse(params) {
	    return function (dispatch) {
	        return userDataHelper.storeUserResponse(params).then(function (userData) {
	            dispatch(setUserData(userData));
	            return userData;
	        }).catch(function (error) {
	            throw error;
	        });
	    };
	}
	
	function updateScreenResults(params) {
	    return function (dispatch, getState) {
	        var state = getState();
	        return userDataHelper.updateScreenResults(state.userData, params).then(function (userData) {
	            dispatch(setUserData(userData));
	            return userData;
	        }).catch(function (error) {
	            throw error;
	        });
	    };
	}
	
	function updateResourceObjectResult(params) {
	    return function (dispatch, getState) {
	        var state = getState();
	        return userDataHelper.updateResourceObjectResult(state.userData, params).then(function (userData) {
	            dispatch(setUserData(userData));
	            return userData;
	        }).catch(function (error) {
	            throw error;
	        });
	    };
	}
	
	/*
	export function collectAchievement(params) {
	    return function (dispatch, getState) {
	        const state = getState();
	        return userDataHelper.collectAchievement(state.userData, params).then(userData => {
	            dispatch(setUserData(userData));
	            return userData;
	        }).catch(error => {
	            throw(error);
	        });
	    };
	}*/
	
	function collectBadge(params) {
	    return function (dispatch, getState) {
	        var state = getState();
	        return userDataHelper.collectBadge(state.userData, params).then(function (userData) {
	            dispatch(setUserData(userData));
	            return userData;
	        }).catch(function (error) {
	            throw error;
	        });
	    };
	}
	
	function saveNotes(params) {
	    return function (dispatch, getState) {
	        var state = getState();
	        return userDataHelper.saveNotes(state.userData, params).then(function (userData) {
	            dispatch(setUserData(userData));
	            return userData;
	        }).catch(function (error) {
	            throw error;
	        });
	    };
	}
	
	function storeUserShortResponses(params) {
	    return function (dispatch) {
	        return userDataHelper.storeUserShortResponses(params).then(function (userData) {
	            dispatch(setUserData(userData));
	            return userData;
	        }).catch(function (error) {
	            throw error;
	        });
	    };
	}
	
	function updateExperienceLocale(lang) {
	    return function (dispatch, getState) {
	        var state = getState();
	        return userDataHelper.updateExperienceLocale(state.userData, lang).then(function (userData) {
	            localStorage.set("default_langauge", lang);
	            localStorage.set("strings", localStorage.contentData.experience.strings[lang]);
	            document.documentElement.setAttribute('lang', lang);
	            document.title = localStorage.contentData.experience.locale[lang].experience_title;
	
	            dispatch(setUserData(userData));
	            return userData;
	        }).catch(function (error) {
	            throw error;
	        });
	    };
	}

/***/ },
/* 21 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	/**
	 * Use invariant() to assert state which your program assumes to be true.
	 *
	 * Provide sprintf-style format (only %s is supported) and arguments
	 * to provide information about what broke and what you were
	 * expecting.
	 *
	 * The invariant message will be stripped in production, but the invariant
	 * will remain to ensure logic does not differ in production.
	 */
	
	var validateFormat = function validateFormat(format) {};
	
	if (false) {
	  validateFormat = function validateFormat(format) {
	    if (format === undefined) {
	      throw new Error('invariant requires an error message argument');
	    }
	  };
	}
	
	function invariant(condition, format, a, b, c, d, e, f) {
	  validateFormat(format);
	
	  if (!condition) {
	    var error;
	    if (format === undefined) {
	      error = new Error('Minified exception occurred; use the non-minified dev environment ' + 'for the full error message and additional helpful warnings.');
	    } else {
	      var args = [a, b, c, d, e, f];
	      var argIndex = 0;
	      error = new Error(format.replace(/%s/g, function () {
	        return args[argIndex++];
	      }));
	      error.name = 'Invariant Violation';
	    }
	
	    error.framesToPop = 1; // we don't care about invariant's own frame
	    throw error;
	  }
	}
	
	module.exports = invariant;

/***/ },
/* 22 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	//PUBLIC
	var INITIALISE = exports.INITIALISE = 'INITIALISE';
	var SET_CONTENT_DATA = exports.SET_CONTENT_DATA = 'SET_CONTENT_DATA';
	var SET_TRACKING_DATA = exports.SET_TRACKING_DATA = 'SET_TRACKING_DATA';
	var SET_USER_DATA = exports.SET_USER_DATA = 'SET_USER_DATA';
	var BEGIN_AJAX_CALL = exports.BEGIN_AJAX_CALL = 'BEGIN_AJAX_CALL';
	var AJAX_CALL_ERROR = exports.AJAX_CALL_ERROR = 'AJAX_CALL_ERROR';
	var SET_NAVIGATION = exports.SET_NAVIGATION = 'SET_NAVIGATION';
	var SET_DIALOG_POPUP = exports.SET_DIALOG_POPUP = 'SET_DIALOG_POPUP';
	var SET_CONTENT_TOOLTIP = exports.SET_CONTENT_TOOLTIP = 'SET_CONTENT_TOOLTIP';
	var SET_PROJECT_TITLE = exports.SET_PROJECT_TITLE = 'SET_PROJECT_TITLE';
	var SET_BITE_TITLE = exports.SET_BITE_TITLE = 'SET_BITE_TITLE';
	var SET_SCREEN_TITLE = exports.SET_SCREEN_TITLE = 'SET_SCREEN_TITLE';
	var SET_MAIN_MENU_DISPLAY = exports.SET_MAIN_MENU_DISPLAY = 'SET_MAIN_MENU_DISPLAY';
	var STATUS_CLOSED = exports.STATUS_CLOSED = 'CLOSED';
	var STATUS_OPEN = exports.STATUS_OPEN = 'OPEN';
	var STATUS_OPENING = exports.STATUS_OPENING = 'OPENING';
	var STATUS_CLOSING = exports.STATUS_CLOSING = 'CLOSING';
	var SET_RESOURCES_DISPLAY = exports.SET_RESOURCES_DISPLAY = 'SET_RESOURCES_DISPLAY';
	var SET_RESOURCES_PROPS = exports.SET_RESOURCES_PROPS = 'SET_RESOURCES_PROPS';
	var SET_CLICK_REVEAL_DIALOG = exports.SET_CLICK_REVEAL_DIALOG = 'SET_CLICK_REVEAL_DIALOG';
	var SET_NOTES_DISPLAY = exports.SET_NOTES_DISPLAY = 'SET_NOTES_DISPLAY';
	var SET_ASSET_DIALOG = exports.SET_ASSET_DIALOG = 'SET_ASSET_DIALOG';
	var SET_SCREEN_DIALOG = exports.SET_SCREEN_DIALOG = 'SET_SCREEN_DIALOG';
	var SET_AUDIO_REF = exports.SET_AUDIO_REF = 'SET_AUDIO_REF';
	var SET_FONT_SIZE = exports.SET_FONT_SIZE = 'SET_FONT_SIZE';

/***/ },
/* 23 */
/***/ function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(27);
	module.exports = function (it) {
	  if (!isObject(it)) throw TypeError(it + ' is not an object!');
	  return it;
	};


/***/ },
/* 24 */
/***/ function(module, exports) {

	// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
	var global = module.exports = typeof window != 'undefined' && window.Math == Math
	  ? window : typeof self != 'undefined' && self.Math == Math ? self
	  // eslint-disable-next-line no-new-func
	  : Function('return this')();
	if (typeof __g == 'number') __g = global; // eslint-disable-line no-undef


/***/ },
/* 25 */
/***/ function(module, exports, __webpack_require__) {

	;(function (root, factory) {
		if (true) {
			// CommonJS
			module.exports = exports = factory();
		}
		else if (typeof define === "function" && define.amd) {
			// AMD
			define([], factory);
		}
		else {
			// Global (browser)
			root.CryptoJS = factory();
		}
	}(this, function () {
	
		/**
		 * CryptoJS core components.
		 */
		var CryptoJS = CryptoJS || (function (Math, undefined) {
		    /*
		     * Local polyfil of Object.create
		     */
		    var create = Object.create || (function () {
		        function F() {};
	
		        return function (obj) {
		            var subtype;
	
		            F.prototype = obj;
	
		            subtype = new F();
	
		            F.prototype = null;
	
		            return subtype;
		        };
		    }())
	
		    /**
		     * CryptoJS namespace.
		     */
		    var C = {};
	
		    /**
		     * Library namespace.
		     */
		    var C_lib = C.lib = {};
	
		    /**
		     * Base object for prototypal inheritance.
		     */
		    var Base = C_lib.Base = (function () {
	
	
		        return {
		            /**
		             * Creates a new object that inherits from this object.
		             *
		             * @param {Object} overrides Properties to copy into the new object.
		             *
		             * @return {Object} The new object.
		             *
		             * @static
		             *
		             * @example
		             *
		             *     var MyType = CryptoJS.lib.Base.extend({
		             *         field: 'value',
		             *
		             *         method: function () {
		             *         }
		             *     });
		             */
		            extend: function (overrides) {
		                // Spawn
		                var subtype = create(this);
	
		                // Augment
		                if (overrides) {
		                    subtype.mixIn(overrides);
		                }
	
		                // Create default initializer
		                if (!subtype.hasOwnProperty('init') || this.init === subtype.init) {
		                    subtype.init = function () {
		                        subtype.$super.init.apply(this, arguments);
		                    };
		                }
	
		                // Initializer's prototype is the subtype object
		                subtype.init.prototype = subtype;
	
		                // Reference supertype
		                subtype.$super = this;
	
		                return subtype;
		            },
	
		            /**
		             * Extends this object and runs the init method.
		             * Arguments to create() will be passed to init().
		             *
		             * @return {Object} The new object.
		             *
		             * @static
		             *
		             * @example
		             *
		             *     var instance = MyType.create();
		             */
		            create: function () {
		                var instance = this.extend();
		                instance.init.apply(instance, arguments);
	
		                return instance;
		            },
	
		            /**
		             * Initializes a newly created object.
		             * Override this method to add some logic when your objects are created.
		             *
		             * @example
		             *
		             *     var MyType = CryptoJS.lib.Base.extend({
		             *         init: function () {
		             *             // ...
		             *         }
		             *     });
		             */
		            init: function () {
		            },
	
		            /**
		             * Copies properties into this object.
		             *
		             * @param {Object} properties The properties to mix in.
		             *
		             * @example
		             *
		             *     MyType.mixIn({
		             *         field: 'value'
		             *     });
		             */
		            mixIn: function (properties) {
		                for (var propertyName in properties) {
		                    if (properties.hasOwnProperty(propertyName)) {
		                        this[propertyName] = properties[propertyName];
		                    }
		                }
	
		                // IE won't copy toString using the loop above
		                if (properties.hasOwnProperty('toString')) {
		                    this.toString = properties.toString;
		                }
		            },
	
		            /**
		             * Creates a copy of this object.
		             *
		             * @return {Object} The clone.
		             *
		             * @example
		             *
		             *     var clone = instance.clone();
		             */
		            clone: function () {
		                return this.init.prototype.extend(this);
		            }
		        };
		    }());
	
		    /**
		     * An array of 32-bit words.
		     *
		     * @property {Array} words The array of 32-bit words.
		     * @property {number} sigBytes The number of significant bytes in this word array.
		     */
		    var WordArray = C_lib.WordArray = Base.extend({
		        /**
		         * Initializes a newly created word array.
		         *
		         * @param {Array} words (Optional) An array of 32-bit words.
		         * @param {number} sigBytes (Optional) The number of significant bytes in the words.
		         *
		         * @example
		         *
		         *     var wordArray = CryptoJS.lib.WordArray.create();
		         *     var wordArray = CryptoJS.lib.WordArray.create([0x00010203, 0x04050607]);
		         *     var wordArray = CryptoJS.lib.WordArray.create([0x00010203, 0x04050607], 6);
		         */
		        init: function (words, sigBytes) {
		            words = this.words = words || [];
	
		            if (sigBytes != undefined) {
		                this.sigBytes = sigBytes;
		            } else {
		                this.sigBytes = words.length * 4;
		            }
		        },
	
		        /**
		         * Converts this word array to a string.
		         *
		         * @param {Encoder} encoder (Optional) The encoding strategy to use. Default: CryptoJS.enc.Hex
		         *
		         * @return {string} The stringified word array.
		         *
		         * @example
		         *
		         *     var string = wordArray + '';
		         *     var string = wordArray.toString();
		         *     var string = wordArray.toString(CryptoJS.enc.Utf8);
		         */
		        toString: function (encoder) {
		            return (encoder || Hex).stringify(this);
		        },
	
		        /**
		         * Concatenates a word array to this word array.
		         *
		         * @param {WordArray} wordArray The word array to append.
		         *
		         * @return {WordArray} This word array.
		         *
		         * @example
		         *
		         *     wordArray1.concat(wordArray2);
		         */
		        concat: function (wordArray) {
		            // Shortcuts
		            var thisWords = this.words;
		            var thatWords = wordArray.words;
		            var thisSigBytes = this.sigBytes;
		            var thatSigBytes = wordArray.sigBytes;
	
		            // Clamp excess bits
		            this.clamp();
	
		            // Concat
		            if (thisSigBytes % 4) {
		                // Copy one byte at a time
		                for (var i = 0; i < thatSigBytes; i++) {
		                    var thatByte = (thatWords[i >>> 2] >>> (24 - (i % 4) * 8)) & 0xff;
		                    thisWords[(thisSigBytes + i) >>> 2] |= thatByte << (24 - ((thisSigBytes + i) % 4) * 8);
		                }
		            } else {
		                // Copy one word at a time
		                for (var i = 0; i < thatSigBytes; i += 4) {
		                    thisWords[(thisSigBytes + i) >>> 2] = thatWords[i >>> 2];
		                }
		            }
		            this.sigBytes += thatSigBytes;
	
		            // Chainable
		            return this;
		        },
	
		        /**
		         * Removes insignificant bits.
		         *
		         * @example
		         *
		         *     wordArray.clamp();
		         */
		        clamp: function () {
		            // Shortcuts
		            var words = this.words;
		            var sigBytes = this.sigBytes;
	
		            // Clamp
		            words[sigBytes >>> 2] &= 0xffffffff << (32 - (sigBytes % 4) * 8);
		            words.length = Math.ceil(sigBytes / 4);
		        },
	
		        /**
		         * Creates a copy of this word array.
		         *
		         * @return {WordArray} The clone.
		         *
		         * @example
		         *
		         *     var clone = wordArray.clone();
		         */
		        clone: function () {
		            var clone = Base.clone.call(this);
		            clone.words = this.words.slice(0);
	
		            return clone;
		        },
	
		        /**
		         * Creates a word array filled with random bytes.
		         *
		         * @param {number} nBytes The number of random bytes to generate.
		         *
		         * @return {WordArray} The random word array.
		         *
		         * @static
		         *
		         * @example
		         *
		         *     var wordArray = CryptoJS.lib.WordArray.random(16);
		         */
		        random: function (nBytes) {
		            var words = [];
	
		            var r = (function (m_w) {
		                var m_w = m_w;
		                var m_z = 0x3ade68b1;
		                var mask = 0xffffffff;
	
		                return function () {
		                    m_z = (0x9069 * (m_z & 0xFFFF) + (m_z >> 0x10)) & mask;
		                    m_w = (0x4650 * (m_w & 0xFFFF) + (m_w >> 0x10)) & mask;
		                    var result = ((m_z << 0x10) + m_w) & mask;
		                    result /= 0x100000000;
		                    result += 0.5;
		                    return result * (Math.random() > .5 ? 1 : -1);
		                }
		            });
	
		            for (var i = 0, rcache; i < nBytes; i += 4) {
		                var _r = r((rcache || Math.random()) * 0x100000000);
	
		                rcache = _r() * 0x3ade67b7;
		                words.push((_r() * 0x100000000) | 0);
		            }
	
		            return new WordArray.init(words, nBytes);
		        }
		    });
	
		    /**
		     * Encoder namespace.
		     */
		    var C_enc = C.enc = {};
	
		    /**
		     * Hex encoding strategy.
		     */
		    var Hex = C_enc.Hex = {
		        /**
		         * Converts a word array to a hex string.
		         *
		         * @param {WordArray} wordArray The word array.
		         *
		         * @return {string} The hex string.
		         *
		         * @static
		         *
		         * @example
		         *
		         *     var hexString = CryptoJS.enc.Hex.stringify(wordArray);
		         */
		        stringify: function (wordArray) {
		            // Shortcuts
		            var words = wordArray.words;
		            var sigBytes = wordArray.sigBytes;
	
		            // Convert
		            var hexChars = [];
		            for (var i = 0; i < sigBytes; i++) {
		                var bite = (words[i >>> 2] >>> (24 - (i % 4) * 8)) & 0xff;
		                hexChars.push((bite >>> 4).toString(16));
		                hexChars.push((bite & 0x0f).toString(16));
		            }
	
		            return hexChars.join('');
		        },
	
		        /**
		         * Converts a hex string to a word array.
		         *
		         * @param {string} hexStr The hex string.
		         *
		         * @return {WordArray} The word array.
		         *
		         * @static
		         *
		         * @example
		         *
		         *     var wordArray = CryptoJS.enc.Hex.parse(hexString);
		         */
		        parse: function (hexStr) {
		            // Shortcut
		            var hexStrLength = hexStr.length;
	
		            // Convert
		            var words = [];
		            for (var i = 0; i < hexStrLength; i += 2) {
		                words[i >>> 3] |= parseInt(hexStr.substr(i, 2), 16) << (24 - (i % 8) * 4);
		            }
	
		            return new WordArray.init(words, hexStrLength / 2);
		        }
		    };
	
		    /**
		     * Latin1 encoding strategy.
		     */
		    var Latin1 = C_enc.Latin1 = {
		        /**
		         * Converts a word array to a Latin1 string.
		         *
		         * @param {WordArray} wordArray The word array.
		         *
		         * @return {string} The Latin1 string.
		         *
		         * @static
		         *
		         * @example
		         *
		         *     var latin1String = CryptoJS.enc.Latin1.stringify(wordArray);
		         */
		        stringify: function (wordArray) {
		            // Shortcuts
		            var words = wordArray.words;
		            var sigBytes = wordArray.sigBytes;
	
		            // Convert
		            var latin1Chars = [];
		            for (var i = 0; i < sigBytes; i++) {
		                var bite = (words[i >>> 2] >>> (24 - (i % 4) * 8)) & 0xff;
		                latin1Chars.push(String.fromCharCode(bite));
		            }
	
		            return latin1Chars.join('');
		        },
	
		        /**
		         * Converts a Latin1 string to a word array.
		         *
		         * @param {string} latin1Str The Latin1 string.
		         *
		         * @return {WordArray} The word array.
		         *
		         * @static
		         *
		         * @example
		         *
		         *     var wordArray = CryptoJS.enc.Latin1.parse(latin1String);
		         */
		        parse: function (latin1Str) {
		            // Shortcut
		            var latin1StrLength = latin1Str.length;
	
		            // Convert
		            var words = [];
		            for (var i = 0; i < latin1StrLength; i++) {
		                words[i >>> 2] |= (latin1Str.charCodeAt(i) & 0xff) << (24 - (i % 4) * 8);
		            }
	
		            return new WordArray.init(words, latin1StrLength);
		        }
		    };
	
		    /**
		     * UTF-8 encoding strategy.
		     */
		    var Utf8 = C_enc.Utf8 = {
		        /**
		         * Converts a word array to a UTF-8 string.
		         *
		         * @param {WordArray} wordArray The word array.
		         *
		         * @return {string} The UTF-8 string.
		         *
		         * @static
		         *
		         * @example
		         *
		         *     var utf8String = CryptoJS.enc.Utf8.stringify(wordArray);
		         */
		        stringify: function (wordArray) {
		            try {
		                return decodeURIComponent(escape(Latin1.stringify(wordArray)));
		            } catch (e) {
		                throw new Error('Malformed UTF-8 data');
		            }
		        },
	
		        /**
		         * Converts a UTF-8 string to a word array.
		         *
		         * @param {string} utf8Str The UTF-8 string.
		         *
		         * @return {WordArray} The word array.
		         *
		         * @static
		         *
		         * @example
		         *
		         *     var wordArray = CryptoJS.enc.Utf8.parse(utf8String);
		         */
		        parse: function (utf8Str) {
		            return Latin1.parse(unescape(encodeURIComponent(utf8Str)));
		        }
		    };
	
		    /**
		     * Abstract buffered block algorithm template.
		     *
		     * The property blockSize must be implemented in a concrete subtype.
		     *
		     * @property {number} _minBufferSize The number of blocks that should be kept unprocessed in the buffer. Default: 0
		     */
		    var BufferedBlockAlgorithm = C_lib.BufferedBlockAlgorithm = Base.extend({
		        /**
		         * Resets this block algorithm's data buffer to its initial state.
		         *
		         * @example
		         *
		         *     bufferedBlockAlgorithm.reset();
		         */
		        reset: function () {
		            // Initial values
		            this._data = new WordArray.init();
		            this._nDataBytes = 0;
		        },
	
		        /**
		         * Adds new data to this block algorithm's buffer.
		         *
		         * @param {WordArray|string} data The data to append. Strings are converted to a WordArray using UTF-8.
		         *
		         * @example
		         *
		         *     bufferedBlockAlgorithm._append('data');
		         *     bufferedBlockAlgorithm._append(wordArray);
		         */
		        _append: function (data) {
		            // Convert string to WordArray, else assume WordArray already
		            if (typeof data == 'string') {
		                data = Utf8.parse(data);
		            }
	
		            // Append
		            this._data.concat(data);
		            this._nDataBytes += data.sigBytes;
		        },
	
		        /**
		         * Processes available data blocks.
		         *
		         * This method invokes _doProcessBlock(offset), which must be implemented by a concrete subtype.
		         *
		         * @param {boolean} doFlush Whether all blocks and partial blocks should be processed.
		         *
		         * @return {WordArray} The processed data.
		         *
		         * @example
		         *
		         *     var processedData = bufferedBlockAlgorithm._process();
		         *     var processedData = bufferedBlockAlgorithm._process(!!'flush');
		         */
		        _process: function (doFlush) {
		            // Shortcuts
		            var data = this._data;
		            var dataWords = data.words;
		            var dataSigBytes = data.sigBytes;
		            var blockSize = this.blockSize;
		            var blockSizeBytes = blockSize * 4;
	
		            // Count blocks ready
		            var nBlocksReady = dataSigBytes / blockSizeBytes;
		            if (doFlush) {
		                // Round up to include partial blocks
		                nBlocksReady = Math.ceil(nBlocksReady);
		            } else {
		                // Round down to include only full blocks,
		                // less the number of blocks that must remain in the buffer
		                nBlocksReady = Math.max((nBlocksReady | 0) - this._minBufferSize, 0);
		            }
	
		            // Count words ready
		            var nWordsReady = nBlocksReady * blockSize;
	
		            // Count bytes ready
		            var nBytesReady = Math.min(nWordsReady * 4, dataSigBytes);
	
		            // Process blocks
		            if (nWordsReady) {
		                for (var offset = 0; offset < nWordsReady; offset += blockSize) {
		                    // Perform concrete-algorithm logic
		                    this._doProcessBlock(dataWords, offset);
		                }
	
		                // Remove processed words
		                var processedWords = dataWords.splice(0, nWordsReady);
		                data.sigBytes -= nBytesReady;
		            }
	
		            // Return processed words
		            return new WordArray.init(processedWords, nBytesReady);
		        },
	
		        /**
		         * Creates a copy of this object.
		         *
		         * @return {Object} The clone.
		         *
		         * @example
		         *
		         *     var clone = bufferedBlockAlgorithm.clone();
		         */
		        clone: function () {
		            var clone = Base.clone.call(this);
		            clone._data = this._data.clone();
	
		            return clone;
		        },
	
		        _minBufferSize: 0
		    });
	
		    /**
		     * Abstract hasher template.
		     *
		     * @property {number} blockSize The number of 32-bit words this hasher operates on. Default: 16 (512 bits)
		     */
		    var Hasher = C_lib.Hasher = BufferedBlockAlgorithm.extend({
		        /**
		         * Configuration options.
		         */
		        cfg: Base.extend(),
	
		        /**
		         * Initializes a newly created hasher.
		         *
		         * @param {Object} cfg (Optional) The configuration options to use for this hash computation.
		         *
		         * @example
		         *
		         *     var hasher = CryptoJS.algo.SHA256.create();
		         */
		        init: function (cfg) {
		            // Apply config defaults
		            this.cfg = this.cfg.extend(cfg);
	
		            // Set initial values
		            this.reset();
		        },
	
		        /**
		         * Resets this hasher to its initial state.
		         *
		         * @example
		         *
		         *     hasher.reset();
		         */
		        reset: function () {
		            // Reset data buffer
		            BufferedBlockAlgorithm.reset.call(this);
	
		            // Perform concrete-hasher logic
		            this._doReset();
		        },
	
		        /**
		         * Updates this hasher with a message.
		         *
		         * @param {WordArray|string} messageUpdate The message to append.
		         *
		         * @return {Hasher} This hasher.
		         *
		         * @example
		         *
		         *     hasher.update('message');
		         *     hasher.update(wordArray);
		         */
		        update: function (messageUpdate) {
		            // Append
		            this._append(messageUpdate);
	
		            // Update the hash
		            this._process();
	
		            // Chainable
		            return this;
		        },
	
		        /**
		         * Finalizes the hash computation.
		         * Note that the finalize operation is effectively a destructive, read-once operation.
		         *
		         * @param {WordArray|string} messageUpdate (Optional) A final message update.
		         *
		         * @return {WordArray} The hash.
		         *
		         * @example
		         *
		         *     var hash = hasher.finalize();
		         *     var hash = hasher.finalize('message');
		         *     var hash = hasher.finalize(wordArray);
		         */
		        finalize: function (messageUpdate) {
		            // Final message update
		            if (messageUpdate) {
		                this._append(messageUpdate);
		            }
	
		            // Perform concrete-hasher logic
		            var hash = this._doFinalize();
	
		            return hash;
		        },
	
		        blockSize: 512/32,
	
		        /**
		         * Creates a shortcut function to a hasher's object interface.
		         *
		         * @param {Hasher} hasher The hasher to create a helper for.
		         *
		         * @return {Function} The shortcut function.
		         *
		         * @static
		         *
		         * @example
		         *
		         *     var SHA256 = CryptoJS.lib.Hasher._createHelper(CryptoJS.algo.SHA256);
		         */
		        _createHelper: function (hasher) {
		            return function (message, cfg) {
		                return new hasher.init(cfg).finalize(message);
		            };
		        },
	
		        /**
		         * Creates a shortcut function to the HMAC's object interface.
		         *
		         * @param {Hasher} hasher The hasher to use in this HMAC helper.
		         *
		         * @return {Function} The shortcut function.
		         *
		         * @static
		         *
		         * @example
		         *
		         *     var HmacSHA256 = CryptoJS.lib.Hasher._createHmacHelper(CryptoJS.algo.SHA256);
		         */
		        _createHmacHelper: function (hasher) {
		            return function (message, key) {
		                return new C_algo.HMAC.init(hasher, key).finalize(message);
		            };
		        }
		    });
	
		    /**
		     * Algorithm namespace.
		     */
		    var C_algo = C.algo = {};
	
		    return C;
		}(Math));
	
	
		return CryptoJS;
	
	}));

/***/ },
/* 26 */
/***/ function(module, exports) {

	module.exports = function (exec) {
	  try {
	    return !!exec();
	  } catch (e) {
	    return true;
	  }
	};


/***/ },
/* 27 */
/***/ function(module, exports) {

	module.exports = function (it) {
	  return typeof it === 'object' ? it !== null : typeof it === 'function';
	};


/***/ },
/* 28 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(global, module) {/**
	 * @license
	 * Lodash <https://lodash.com/>
	 * Copyright JS Foundation and other contributors <https://js.foundation/>
	 * Released under MIT license <https://lodash.com/license>
	 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
	 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
	 */
	;(function() {
	
	  /** Used as a safe reference for `undefined` in pre-ES5 environments. */
	  var undefined;
	
	  /** Used as the semantic version number. */
	  var VERSION = '4.17.11';
	
	  /** Used as the size to enable large array optimizations. */
	  var LARGE_ARRAY_SIZE = 200;
	
	  /** Error message constants. */
	  var CORE_ERROR_TEXT = 'Unsupported core-js use. Try https://npms.io/search?q=ponyfill.',
	      FUNC_ERROR_TEXT = 'Expected a function';
	
	  /** Used to stand-in for `undefined` hash values. */
	  var HASH_UNDEFINED = '__lodash_hash_undefined__';
	
	  /** Used as the maximum memoize cache size. */
	  var MAX_MEMOIZE_SIZE = 500;
	
	  /** Used as the internal argument placeholder. */
	  var PLACEHOLDER = '__lodash_placeholder__';
	
	  /** Used to compose bitmasks for cloning. */
	  var CLONE_DEEP_FLAG = 1,
	      CLONE_FLAT_FLAG = 2,
	      CLONE_SYMBOLS_FLAG = 4;
	
	  /** Used to compose bitmasks for value comparisons. */
	  var COMPARE_PARTIAL_FLAG = 1,
	      COMPARE_UNORDERED_FLAG = 2;
	
	  /** Used to compose bitmasks for function metadata. */
	  var WRAP_BIND_FLAG = 1,
	      WRAP_BIND_KEY_FLAG = 2,
	      WRAP_CURRY_BOUND_FLAG = 4,
	      WRAP_CURRY_FLAG = 8,
	      WRAP_CURRY_RIGHT_FLAG = 16,
	      WRAP_PARTIAL_FLAG = 32,
	      WRAP_PARTIAL_RIGHT_FLAG = 64,
	      WRAP_ARY_FLAG = 128,
	      WRAP_REARG_FLAG = 256,
	      WRAP_FLIP_FLAG = 512;
	
	  /** Used as default options for `_.truncate`. */
	  var DEFAULT_TRUNC_LENGTH = 30,
	      DEFAULT_TRUNC_OMISSION = '...';
	
	  /** Used to detect hot functions by number of calls within a span of milliseconds. */
	  var HOT_COUNT = 800,
	      HOT_SPAN = 16;
	
	  /** Used to indicate the type of lazy iteratees. */
	  var LAZY_FILTER_FLAG = 1,
	      LAZY_MAP_FLAG = 2,
	      LAZY_WHILE_FLAG = 3;
	
	  /** Used as references for various `Number` constants. */
	  var INFINITY = 1 / 0,
	      MAX_SAFE_INTEGER = 9007199254740991,
	      MAX_INTEGER = 1.7976931348623157e+308,
	      NAN = 0 / 0;
	
	  /** Used as references for the maximum length and index of an array. */
	  var MAX_ARRAY_LENGTH = 4294967295,
	      MAX_ARRAY_INDEX = MAX_ARRAY_LENGTH - 1,
	      HALF_MAX_ARRAY_LENGTH = MAX_ARRAY_LENGTH >>> 1;
	
	  /** Used to associate wrap methods with their bit flags. */
	  var wrapFlags = [
	    ['ary', WRAP_ARY_FLAG],
	    ['bind', WRAP_BIND_FLAG],
	    ['bindKey', WRAP_BIND_KEY_FLAG],
	    ['curry', WRAP_CURRY_FLAG],
	    ['curryRight', WRAP_CURRY_RIGHT_FLAG],
	    ['flip', WRAP_FLIP_FLAG],
	    ['partial', WRAP_PARTIAL_FLAG],
	    ['partialRight', WRAP_PARTIAL_RIGHT_FLAG],
	    ['rearg', WRAP_REARG_FLAG]
	  ];
	
	  /** `Object#toString` result references. */
	  var argsTag = '[object Arguments]',
	      arrayTag = '[object Array]',
	      asyncTag = '[object AsyncFunction]',
	      boolTag = '[object Boolean]',
	      dateTag = '[object Date]',
	      domExcTag = '[object DOMException]',
	      errorTag = '[object Error]',
	      funcTag = '[object Function]',
	      genTag = '[object GeneratorFunction]',
	      mapTag = '[object Map]',
	      numberTag = '[object Number]',
	      nullTag = '[object Null]',
	      objectTag = '[object Object]',
	      promiseTag = '[object Promise]',
	      proxyTag = '[object Proxy]',
	      regexpTag = '[object RegExp]',
	      setTag = '[object Set]',
	      stringTag = '[object String]',
	      symbolTag = '[object Symbol]',
	      undefinedTag = '[object Undefined]',
	      weakMapTag = '[object WeakMap]',
	      weakSetTag = '[object WeakSet]';
	
	  var arrayBufferTag = '[object ArrayBuffer]',
	      dataViewTag = '[object DataView]',
	      float32Tag = '[object Float32Array]',
	      float64Tag = '[object Float64Array]',
	      int8Tag = '[object Int8Array]',
	      int16Tag = '[object Int16Array]',
	      int32Tag = '[object Int32Array]',
	      uint8Tag = '[object Uint8Array]',
	      uint8ClampedTag = '[object Uint8ClampedArray]',
	      uint16Tag = '[object Uint16Array]',
	      uint32Tag = '[object Uint32Array]';
	
	  /** Used to match empty string literals in compiled template source. */
	  var reEmptyStringLeading = /\b__p \+= '';/g,
	      reEmptyStringMiddle = /\b(__p \+=) '' \+/g,
	      reEmptyStringTrailing = /(__e\(.*?\)|\b__t\)) \+\n'';/g;
	
	  /** Used to match HTML entities and HTML characters. */
	  var reEscapedHtml = /&(?:amp|lt|gt|quot|#39);/g,
	      reUnescapedHtml = /[&<>"']/g,
	      reHasEscapedHtml = RegExp(reEscapedHtml.source),
	      reHasUnescapedHtml = RegExp(reUnescapedHtml.source);
	
	  /** Used to match template delimiters. */
	  var reEscape = /<%-([\s\S]+?)%>/g,
	      reEvaluate = /<%([\s\S]+?)%>/g,
	      reInterpolate = /<%=([\s\S]+?)%>/g;
	
	  /** Used to match property names within property paths. */
	  var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
	      reIsPlainProp = /^\w*$/,
	      rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
	
	  /**
	   * Used to match `RegExp`
	   * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
	   */
	  var reRegExpChar = /[\\^$.*+?()[\]{}|]/g,
	      reHasRegExpChar = RegExp(reRegExpChar.source);
	
	  /** Used to match leading and trailing whitespace. */
	  var reTrim = /^\s+|\s+$/g,
	      reTrimStart = /^\s+/,
	      reTrimEnd = /\s+$/;
	
	  /** Used to match wrap detail comments. */
	  var reWrapComment = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/,
	      reWrapDetails = /\{\n\/\* \[wrapped with (.+)\] \*/,
	      reSplitDetails = /,? & /;
	
	  /** Used to match words composed of alphanumeric characters. */
	  var reAsciiWord = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;
	
	  /** Used to match backslashes in property paths. */
	  var reEscapeChar = /\\(\\)?/g;
	
	  /**
	   * Used to match
	   * [ES template delimiters](http://ecma-international.org/ecma-262/7.0/#sec-template-literal-lexical-components).
	   */
	  var reEsTemplate = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g;
	
	  /** Used to match `RegExp` flags from their coerced string values. */
	  var reFlags = /\w*$/;
	
	  /** Used to detect bad signed hexadecimal string values. */
	  var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
	
	  /** Used to detect binary string values. */
	  var reIsBinary = /^0b[01]+$/i;
	
	  /** Used to detect host constructors (Safari). */
	  var reIsHostCtor = /^\[object .+?Constructor\]$/;
	
	  /** Used to detect octal string values. */
	  var reIsOctal = /^0o[0-7]+$/i;
	
	  /** Used to detect unsigned integer values. */
	  var reIsUint = /^(?:0|[1-9]\d*)$/;
	
	  /** Used to match Latin Unicode letters (excluding mathematical operators). */
	  var reLatin = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g;
	
	  /** Used to ensure capturing order of template delimiters. */
	  var reNoMatch = /($^)/;
	
	  /** Used to match unescaped characters in compiled string literals. */
	  var reUnescapedString = /['\n\r\u2028\u2029\\]/g;
	
	  /** Used to compose unicode character classes. */
	  var rsAstralRange = '\\ud800-\\udfff',
	      rsComboMarksRange = '\\u0300-\\u036f',
	      reComboHalfMarksRange = '\\ufe20-\\ufe2f',
	      rsComboSymbolsRange = '\\u20d0-\\u20ff',
	      rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange,
	      rsDingbatRange = '\\u2700-\\u27bf',
	      rsLowerRange = 'a-z\\xdf-\\xf6\\xf8-\\xff',
	      rsMathOpRange = '\\xac\\xb1\\xd7\\xf7',
	      rsNonCharRange = '\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf',
	      rsPunctuationRange = '\\u2000-\\u206f',
	      rsSpaceRange = ' \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000',
	      rsUpperRange = 'A-Z\\xc0-\\xd6\\xd8-\\xde',
	      rsVarRange = '\\ufe0e\\ufe0f',
	      rsBreakRange = rsMathOpRange + rsNonCharRange + rsPunctuationRange + rsSpaceRange;
	
	  /** Used to compose unicode capture groups. */
	  var rsApos = "['\u2019]",
	      rsAstral = '[' + rsAstralRange + ']',
	      rsBreak = '[' + rsBreakRange + ']',
	      rsCombo = '[' + rsComboRange + ']',
	      rsDigits = '\\d+',
	      rsDingbat = '[' + rsDingbatRange + ']',
	      rsLower = '[' + rsLowerRange + ']',
	      rsMisc = '[^' + rsAstralRange + rsBreakRange + rsDigits + rsDingbatRange + rsLowerRange + rsUpperRange + ']',
	      rsFitz = '\\ud83c[\\udffb-\\udfff]',
	      rsModifier = '(?:' + rsCombo + '|' + rsFitz + ')',
	      rsNonAstral = '[^' + rsAstralRange + ']',
	      rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}',
	      rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]',
	      rsUpper = '[' + rsUpperRange + ']',
	      rsZWJ = '\\u200d';
	
	  /** Used to compose unicode regexes. */
	  var rsMiscLower = '(?:' + rsLower + '|' + rsMisc + ')',
	      rsMiscUpper = '(?:' + rsUpper + '|' + rsMisc + ')',
	      rsOptContrLower = '(?:' + rsApos + '(?:d|ll|m|re|s|t|ve))?',
	      rsOptContrUpper = '(?:' + rsApos + '(?:D|LL|M|RE|S|T|VE))?',
	      reOptMod = rsModifier + '?',
	      rsOptVar = '[' + rsVarRange + ']?',
	      rsOptJoin = '(?:' + rsZWJ + '(?:' + [rsNonAstral, rsRegional, rsSurrPair].join('|') + ')' + rsOptVar + reOptMod + ')*',
	      rsOrdLower = '\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])',
	      rsOrdUpper = '\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])',
	      rsSeq = rsOptVar + reOptMod + rsOptJoin,
	      rsEmoji = '(?:' + [rsDingbat, rsRegional, rsSurrPair].join('|') + ')' + rsSeq,
	      rsSymbol = '(?:' + [rsNonAstral + rsCombo + '?', rsCombo, rsRegional, rsSurrPair, rsAstral].join('|') + ')';
	
	  /** Used to match apostrophes. */
	  var reApos = RegExp(rsApos, 'g');
	
	  /**
	   * Used to match [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks) and
	   * [combining diacritical marks for symbols](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks_for_Symbols).
	   */
	  var reComboMark = RegExp(rsCombo, 'g');
	
	  /** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */
	  var reUnicode = RegExp(rsFitz + '(?=' + rsFitz + ')|' + rsSymbol + rsSeq, 'g');
	
	  /** Used to match complex or compound words. */
	  var reUnicodeWord = RegExp([
	    rsUpper + '?' + rsLower + '+' + rsOptContrLower + '(?=' + [rsBreak, rsUpper, '$'].join('|') + ')',
	    rsMiscUpper + '+' + rsOptContrUpper + '(?=' + [rsBreak, rsUpper + rsMiscLower, '$'].join('|') + ')',
	    rsUpper + '?' + rsMiscLower + '+' + rsOptContrLower,
	    rsUpper + '+' + rsOptContrUpper,
	    rsOrdUpper,
	    rsOrdLower,
	    rsDigits,
	    rsEmoji
	  ].join('|'), 'g');
	
	  /** Used to detect strings with [zero-width joiners or code points from the astral planes](http://eev.ee/blog/2015/09/12/dark-corners-of-unicode/). */
	  var reHasUnicode = RegExp('[' + rsZWJ + rsAstralRange  + rsComboRange + rsVarRange + ']');
	
	  /** Used to detect strings that need a more robust regexp to match words. */
	  var reHasUnicodeWord = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;
	
	  /** Used to assign default `context` object properties. */
	  var contextProps = [
	    'Array', 'Buffer', 'DataView', 'Date', 'Error', 'Float32Array', 'Float64Array',
	    'Function', 'Int8Array', 'Int16Array', 'Int32Array', 'Map', 'Math', 'Object',
	    'Promise', 'RegExp', 'Set', 'String', 'Symbol', 'TypeError', 'Uint8Array',
	    'Uint8ClampedArray', 'Uint16Array', 'Uint32Array', 'WeakMap',
	    '_', 'clearTimeout', 'isFinite', 'parseInt', 'setTimeout'
	  ];
	
	  /** Used to make template sourceURLs easier to identify. */
	  var templateCounter = -1;
	
	  /** Used to identify `toStringTag` values of typed arrays. */
	  var typedArrayTags = {};
	  typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
	  typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
	  typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
	  typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
	  typedArrayTags[uint32Tag] = true;
	  typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
	  typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
	  typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
	  typedArrayTags[errorTag] = typedArrayTags[funcTag] =
	  typedArrayTags[mapTag] = typedArrayTags[numberTag] =
	  typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
	  typedArrayTags[setTag] = typedArrayTags[stringTag] =
	  typedArrayTags[weakMapTag] = false;
	
	  /** Used to identify `toStringTag` values supported by `_.clone`. */
	  var cloneableTags = {};
	  cloneableTags[argsTag] = cloneableTags[arrayTag] =
	  cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] =
	  cloneableTags[boolTag] = cloneableTags[dateTag] =
	  cloneableTags[float32Tag] = cloneableTags[float64Tag] =
	  cloneableTags[int8Tag] = cloneableTags[int16Tag] =
	  cloneableTags[int32Tag] = cloneableTags[mapTag] =
	  cloneableTags[numberTag] = cloneableTags[objectTag] =
	  cloneableTags[regexpTag] = cloneableTags[setTag] =
	  cloneableTags[stringTag] = cloneableTags[symbolTag] =
	  cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] =
	  cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
	  cloneableTags[errorTag] = cloneableTags[funcTag] =
	  cloneableTags[weakMapTag] = false;
	
	  /** Used to map Latin Unicode letters to basic Latin letters. */
	  var deburredLetters = {
	    // Latin-1 Supplement block.
	    '\xc0': 'A',  '\xc1': 'A', '\xc2': 'A', '\xc3': 'A', '\xc4': 'A', '\xc5': 'A',
	    '\xe0': 'a',  '\xe1': 'a', '\xe2': 'a', '\xe3': 'a', '\xe4': 'a', '\xe5': 'a',
	    '\xc7': 'C',  '\xe7': 'c',
	    '\xd0': 'D',  '\xf0': 'd',
	    '\xc8': 'E',  '\xc9': 'E', '\xca': 'E', '\xcb': 'E',
	    '\xe8': 'e',  '\xe9': 'e', '\xea': 'e', '\xeb': 'e',
	    '\xcc': 'I',  '\xcd': 'I', '\xce': 'I', '\xcf': 'I',
	    '\xec': 'i',  '\xed': 'i', '\xee': 'i', '\xef': 'i',
	    '\xd1': 'N',  '\xf1': 'n',
	    '\xd2': 'O',  '\xd3': 'O', '\xd4': 'O', '\xd5': 'O', '\xd6': 'O', '\xd8': 'O',
	    '\xf2': 'o',  '\xf3': 'o', '\xf4': 'o', '\xf5': 'o', '\xf6': 'o', '\xf8': 'o',
	    '\xd9': 'U',  '\xda': 'U', '\xdb': 'U', '\xdc': 'U',
	    '\xf9': 'u',  '\xfa': 'u', '\xfb': 'u', '\xfc': 'u',
	    '\xdd': 'Y',  '\xfd': 'y', '\xff': 'y',
	    '\xc6': 'Ae', '\xe6': 'ae',
	    '\xde': 'Th', '\xfe': 'th',
	    '\xdf': 'ss',
	    // Latin Extended-A block.
	    '\u0100': 'A',  '\u0102': 'A', '\u0104': 'A',
	    '\u0101': 'a',  '\u0103': 'a', '\u0105': 'a',
	    '\u0106': 'C',  '\u0108': 'C', '\u010a': 'C', '\u010c': 'C',
	    '\u0107': 'c',  '\u0109': 'c', '\u010b': 'c', '\u010d': 'c',
	    '\u010e': 'D',  '\u0110': 'D', '\u010f': 'd', '\u0111': 'd',
	    '\u0112': 'E',  '\u0114': 'E', '\u0116': 'E', '\u0118': 'E', '\u011a': 'E',
	    '\u0113': 'e',  '\u0115': 'e', '\u0117': 'e', '\u0119': 'e', '\u011b': 'e',
	    '\u011c': 'G',  '\u011e': 'G', '\u0120': 'G', '\u0122': 'G',
	    '\u011d': 'g',  '\u011f': 'g', '\u0121': 'g', '\u0123': 'g',
	    '\u0124': 'H',  '\u0126': 'H', '\u0125': 'h', '\u0127': 'h',
	    '\u0128': 'I',  '\u012a': 'I', '\u012c': 'I', '\u012e': 'I', '\u0130': 'I',
	    '\u0129': 'i',  '\u012b': 'i', '\u012d': 'i', '\u012f': 'i', '\u0131': 'i',
	    '\u0134': 'J',  '\u0135': 'j',
	    '\u0136': 'K',  '\u0137': 'k', '\u0138': 'k',
	    '\u0139': 'L',  '\u013b': 'L', '\u013d': 'L', '\u013f': 'L', '\u0141': 'L',
	    '\u013a': 'l',  '\u013c': 'l', '\u013e': 'l', '\u0140': 'l', '\u0142': 'l',
	    '\u0143': 'N',  '\u0145': 'N', '\u0147': 'N', '\u014a': 'N',
	    '\u0144': 'n',  '\u0146': 'n', '\u0148': 'n', '\u014b': 'n',
	    '\u014c': 'O',  '\u014e': 'O', '\u0150': 'O',
	    '\u014d': 'o',  '\u014f': 'o', '\u0151': 'o',
	    '\u0154': 'R',  '\u0156': 'R', '\u0158': 'R',
	    '\u0155': 'r',  '\u0157': 'r', '\u0159': 'r',
	    '\u015a': 'S',  '\u015c': 'S', '\u015e': 'S', '\u0160': 'S',
	    '\u015b': 's',  '\u015d': 's', '\u015f': 's', '\u0161': 's',
	    '\u0162': 'T',  '\u0164': 'T', '\u0166': 'T',
	    '\u0163': 't',  '\u0165': 't', '\u0167': 't',
	    '\u0168': 'U',  '\u016a': 'U', '\u016c': 'U', '\u016e': 'U', '\u0170': 'U', '\u0172': 'U',
	    '\u0169': 'u',  '\u016b': 'u', '\u016d': 'u', '\u016f': 'u', '\u0171': 'u', '\u0173': 'u',
	    '\u0174': 'W',  '\u0175': 'w',
	    '\u0176': 'Y',  '\u0177': 'y', '\u0178': 'Y',
	    '\u0179': 'Z',  '\u017b': 'Z', '\u017d': 'Z',
	    '\u017a': 'z',  '\u017c': 'z', '\u017e': 'z',
	    '\u0132': 'IJ', '\u0133': 'ij',
	    '\u0152': 'Oe', '\u0153': 'oe',
	    '\u0149': "'n", '\u017f': 's'
	  };
	
	  /** Used to map characters to HTML entities. */
	  var htmlEscapes = {
	    '&': '&amp;',
	    '<': '&lt;',
	    '>': '&gt;',
	    '"': '&quot;',
	    "'": '&#39;'
	  };
	
	  /** Used to map HTML entities to characters. */
	  var htmlUnescapes = {
	    '&amp;': '&',
	    '&lt;': '<',
	    '&gt;': '>',
	    '&quot;': '"',
	    '&#39;': "'"
	  };
	
	  /** Used to escape characters for inclusion in compiled string literals. */
	  var stringEscapes = {
	    '\\': '\\',
	    "'": "'",
	    '\n': 'n',
	    '\r': 'r',
	    '\u2028': 'u2028',
	    '\u2029': 'u2029'
	  };
	
	  /** Built-in method references without a dependency on `root`. */
	  var freeParseFloat = parseFloat,
	      freeParseInt = parseInt;
	
	  /** Detect free variable `global` from Node.js. */
	  var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;
	
	  /** Detect free variable `self`. */
	  var freeSelf = typeof self == 'object' && self && self.Object === Object && self;
	
	  /** Used as a reference to the global object. */
	  var root = freeGlobal || freeSelf || Function('return this')();
	
	  /** Detect free variable `exports`. */
	  var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;
	
	  /** Detect free variable `module`. */
	  var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;
	
	  /** Detect the popular CommonJS extension `module.exports`. */
	  var moduleExports = freeModule && freeModule.exports === freeExports;
	
	  /** Detect free variable `process` from Node.js. */
	  var freeProcess = moduleExports && freeGlobal.process;
	
	  /** Used to access faster Node.js helpers. */
	  var nodeUtil = (function() {
	    try {
	      // Use `util.types` for Node.js 10+.
	      var types = freeModule && freeModule.require && freeModule.require('util').types;
	
	      if (types) {
	        return types;
	      }
	
	      // Legacy `process.binding('util')` for Node.js < 10.
	      return freeProcess && freeProcess.binding && freeProcess.binding('util');
	    } catch (e) {}
	  }());
	
	  /* Node.js helper references. */
	  var nodeIsArrayBuffer = nodeUtil && nodeUtil.isArrayBuffer,
	      nodeIsDate = nodeUtil && nodeUtil.isDate,
	      nodeIsMap = nodeUtil && nodeUtil.isMap,
	      nodeIsRegExp = nodeUtil && nodeUtil.isRegExp,
	      nodeIsSet = nodeUtil && nodeUtil.isSet,
	      nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;
	
	  /*--------------------------------------------------------------------------*/
	
	  /**
	   * A faster alternative to `Function#apply`, this function invokes `func`
	   * with the `this` binding of `thisArg` and the arguments of `args`.
	   *
	   * @private
	   * @param {Function} func The function to invoke.
	   * @param {*} thisArg The `this` binding of `func`.
	   * @param {Array} args The arguments to invoke `func` with.
	   * @returns {*} Returns the result of `func`.
	   */
	  function apply(func, thisArg, args) {
	    switch (args.length) {
	      case 0: return func.call(thisArg);
	      case 1: return func.call(thisArg, args[0]);
	      case 2: return func.call(thisArg, args[0], args[1]);
	      case 3: return func.call(thisArg, args[0], args[1], args[2]);
	    }
	    return func.apply(thisArg, args);
	  }
	
	  /**
	   * A specialized version of `baseAggregator` for arrays.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} setter The function to set `accumulator` values.
	   * @param {Function} iteratee The iteratee to transform keys.
	   * @param {Object} accumulator The initial aggregated object.
	   * @returns {Function} Returns `accumulator`.
	   */
	  function arrayAggregator(array, setter, iteratee, accumulator) {
	    var index = -1,
	        length = array == null ? 0 : array.length;
	
	    while (++index < length) {
	      var value = array[index];
	      setter(accumulator, value, iteratee(value), array);
	    }
	    return accumulator;
	  }
	
	  /**
	   * A specialized version of `_.forEach` for arrays without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @returns {Array} Returns `array`.
	   */
	  function arrayEach(array, iteratee) {
	    var index = -1,
	        length = array == null ? 0 : array.length;
	
	    while (++index < length) {
	      if (iteratee(array[index], index, array) === false) {
	        break;
	      }
	    }
	    return array;
	  }
	
	  /**
	   * A specialized version of `_.forEachRight` for arrays without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @returns {Array} Returns `array`.
	   */
	  function arrayEachRight(array, iteratee) {
	    var length = array == null ? 0 : array.length;
	
	    while (length--) {
	      if (iteratee(array[length], length, array) === false) {
	        break;
	      }
	    }
	    return array;
	  }
	
	  /**
	   * A specialized version of `_.every` for arrays without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} predicate The function invoked per iteration.
	   * @returns {boolean} Returns `true` if all elements pass the predicate check,
	   *  else `false`.
	   */
	  function arrayEvery(array, predicate) {
	    var index = -1,
	        length = array == null ? 0 : array.length;
	
	    while (++index < length) {
	      if (!predicate(array[index], index, array)) {
	        return false;
	      }
	    }
	    return true;
	  }
	
	  /**
	   * A specialized version of `_.filter` for arrays without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} predicate The function invoked per iteration.
	   * @returns {Array} Returns the new filtered array.
	   */
	  function arrayFilter(array, predicate) {
	    var index = -1,
	        length = array == null ? 0 : array.length,
	        resIndex = 0,
	        result = [];
	
	    while (++index < length) {
	      var value = array[index];
	      if (predicate(value, index, array)) {
	        result[resIndex++] = value;
	      }
	    }
	    return result;
	  }
	
	  /**
	   * A specialized version of `_.includes` for arrays without support for
	   * specifying an index to search from.
	   *
	   * @private
	   * @param {Array} [array] The array to inspect.
	   * @param {*} target The value to search for.
	   * @returns {boolean} Returns `true` if `target` is found, else `false`.
	   */
	  function arrayIncludes(array, value) {
	    var length = array == null ? 0 : array.length;
	    return !!length && baseIndexOf(array, value, 0) > -1;
	  }
	
	  /**
	   * This function is like `arrayIncludes` except that it accepts a comparator.
	   *
	   * @private
	   * @param {Array} [array] The array to inspect.
	   * @param {*} target The value to search for.
	   * @param {Function} comparator The comparator invoked per element.
	   * @returns {boolean} Returns `true` if `target` is found, else `false`.
	   */
	  function arrayIncludesWith(array, value, comparator) {
	    var index = -1,
	        length = array == null ? 0 : array.length;
	
	    while (++index < length) {
	      if (comparator(value, array[index])) {
	        return true;
	      }
	    }
	    return false;
	  }
	
	  /**
	   * A specialized version of `_.map` for arrays without support for iteratee
	   * shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @returns {Array} Returns the new mapped array.
	   */
	  function arrayMap(array, iteratee) {
	    var index = -1,
	        length = array == null ? 0 : array.length,
	        result = Array(length);
	
	    while (++index < length) {
	      result[index] = iteratee(array[index], index, array);
	    }
	    return result;
	  }
	
	  /**
	   * Appends the elements of `values` to `array`.
	   *
	   * @private
	   * @param {Array} array The array to modify.
	   * @param {Array} values The values to append.
	   * @returns {Array} Returns `array`.
	   */
	  function arrayPush(array, values) {
	    var index = -1,
	        length = values.length,
	        offset = array.length;
	
	    while (++index < length) {
	      array[offset + index] = values[index];
	    }
	    return array;
	  }
	
	  /**
	   * A specialized version of `_.reduce` for arrays without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @param {*} [accumulator] The initial value.
	   * @param {boolean} [initAccum] Specify using the first element of `array` as
	   *  the initial value.
	   * @returns {*} Returns the accumulated value.
	   */
	  function arrayReduce(array, iteratee, accumulator, initAccum) {
	    var index = -1,
	        length = array == null ? 0 : array.length;
	
	    if (initAccum && length) {
	      accumulator = array[++index];
	    }
	    while (++index < length) {
	      accumulator = iteratee(accumulator, array[index], index, array);
	    }
	    return accumulator;
	  }
	
	  /**
	   * A specialized version of `_.reduceRight` for arrays without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @param {*} [accumulator] The initial value.
	   * @param {boolean} [initAccum] Specify using the last element of `array` as
	   *  the initial value.
	   * @returns {*} Returns the accumulated value.
	   */
	  function arrayReduceRight(array, iteratee, accumulator, initAccum) {
	    var length = array == null ? 0 : array.length;
	    if (initAccum && length) {
	      accumulator = array[--length];
	    }
	    while (length--) {
	      accumulator = iteratee(accumulator, array[length], length, array);
	    }
	    return accumulator;
	  }
	
	  /**
	   * A specialized version of `_.some` for arrays without support for iteratee
	   * shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} predicate The function invoked per iteration.
	   * @returns {boolean} Returns `true` if any element passes the predicate check,
	   *  else `false`.
	   */
	  function arraySome(array, predicate) {
	    var index = -1,
	        length = array == null ? 0 : array.length;
	
	    while (++index < length) {
	      if (predicate(array[index], index, array)) {
	        return true;
	      }
	    }
	    return false;
	  }
	
	  /**
	   * Gets the size of an ASCII `string`.
	   *
	   * @private
	   * @param {string} string The string inspect.
	   * @returns {number} Returns the string size.
	   */
	  var asciiSize = baseProperty('length');
	
	  /**
	   * Converts an ASCII `string` to an array.
	   *
	   * @private
	   * @param {string} string The string to convert.
	   * @returns {Array} Returns the converted array.
	   */
	  function asciiToArray(string) {
	    return string.split('');
	  }
	
	  /**
	   * Splits an ASCII `string` into an array of its words.
	   *
	   * @private
	   * @param {string} The string to inspect.
	   * @returns {Array} Returns the words of `string`.
	   */
	  function asciiWords(string) {
	    return string.match(reAsciiWord) || [];
	  }
	
	  /**
	   * The base implementation of methods like `_.findKey` and `_.findLastKey`,
	   * without support for iteratee shorthands, which iterates over `collection`
	   * using `eachFunc`.
	   *
	   * @private
	   * @param {Array|Object} collection The collection to inspect.
	   * @param {Function} predicate The function invoked per iteration.
	   * @param {Function} eachFunc The function to iterate over `collection`.
	   * @returns {*} Returns the found element or its key, else `undefined`.
	   */
	  function baseFindKey(collection, predicate, eachFunc) {
	    var result;
	    eachFunc(collection, function(value, key, collection) {
	      if (predicate(value, key, collection)) {
	        result = key;
	        return false;
	      }
	    });
	    return result;
	  }
	
	  /**
	   * The base implementation of `_.findIndex` and `_.findLastIndex` without
	   * support for iteratee shorthands.
	   *
	   * @private
	   * @param {Array} array The array to inspect.
	   * @param {Function} predicate The function invoked per iteration.
	   * @param {number} fromIndex The index to search from.
	   * @param {boolean} [fromRight] Specify iterating from right to left.
	   * @returns {number} Returns the index of the matched value, else `-1`.
	   */
	  function baseFindIndex(array, predicate, fromIndex, fromRight) {
	    var length = array.length,
	        index = fromIndex + (fromRight ? 1 : -1);
	
	    while ((fromRight ? index-- : ++index < length)) {
	      if (predicate(array[index], index, array)) {
	        return index;
	      }
	    }
	    return -1;
	  }
	
	  /**
	   * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
	   *
	   * @private
	   * @param {Array} array The array to inspect.
	   * @param {*} value The value to search for.
	   * @param {number} fromIndex The index to search from.
	   * @returns {number} Returns the index of the matched value, else `-1`.
	   */
	  function baseIndexOf(array, value, fromIndex) {
	    return value === value
	      ? strictIndexOf(array, value, fromIndex)
	      : baseFindIndex(array, baseIsNaN, fromIndex);
	  }
	
	  /**
	   * This function is like `baseIndexOf` except that it accepts a comparator.
	   *
	   * @private
	   * @param {Array} array The array to inspect.
	   * @param {*} value The value to search for.
	   * @param {number} fromIndex The index to search from.
	   * @param {Function} comparator The comparator invoked per element.
	   * @returns {number} Returns the index of the matched value, else `-1`.
	   */
	  function baseIndexOfWith(array, value, fromIndex, comparator) {
	    var index = fromIndex - 1,
	        length = array.length;
	
	    while (++index < length) {
	      if (comparator(array[index], value)) {
	        return index;
	      }
	    }
	    return -1;
	  }
	
	  /**
	   * The base implementation of `_.isNaN` without support for number objects.
	   *
	   * @private
	   * @param {*} value The value to check.
	   * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
	   */
	  function baseIsNaN(value) {
	    return value !== value;
	  }
	
	  /**
	   * The base implementation of `_.mean` and `_.meanBy` without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} array The array to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @returns {number} Returns the mean.
	   */
	  function baseMean(array, iteratee) {
	    var length = array == null ? 0 : array.length;
	    return length ? (baseSum(array, iteratee) / length) : NAN;
	  }
	
	  /**
	   * The base implementation of `_.property` without support for deep paths.
	   *
	   * @private
	   * @param {string} key The key of the property to get.
	   * @returns {Function} Returns the new accessor function.
	   */
	  function baseProperty(key) {
	    return function(object) {
	      return object == null ? undefined : object[key];
	    };
	  }
	
	  /**
	   * The base implementation of `_.propertyOf` without support for deep paths.
	   *
	   * @private
	   * @param {Object} object The object to query.
	   * @returns {Function} Returns the new accessor function.
	   */
	  function basePropertyOf(object) {
	    return function(key) {
	      return object == null ? undefined : object[key];
	    };
	  }
	
	  /**
	   * The base implementation of `_.reduce` and `_.reduceRight`, without support
	   * for iteratee shorthands, which iterates over `collection` using `eachFunc`.
	   *
	   * @private
	   * @param {Array|Object} collection The collection to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @param {*} accumulator The initial value.
	   * @param {boolean} initAccum Specify using the first or last element of
	   *  `collection` as the initial value.
	   * @param {Function} eachFunc The function to iterate over `collection`.
	   * @returns {*} Returns the accumulated value.
	   */
	  function baseReduce(collection, iteratee, accumulator, initAccum, eachFunc) {
	    eachFunc(collection, function(value, index, collection) {
	      accumulator = initAccum
	        ? (initAccum = false, value)
	        : iteratee(accumulator, value, index, collection);
	    });
	    return accumulator;
	  }
	
	  /**
	   * The base implementation of `_.sortBy` which uses `comparer` to define the
	   * sort order of `array` and replaces criteria objects with their corresponding
	   * values.
	   *
	   * @private
	   * @param {Array} array The array to sort.
	   * @param {Function} comparer The function to define sort order.
	   * @returns {Array} Returns `array`.
	   */
	  function baseSortBy(array, comparer) {
	    var length = array.length;
	
	    array.sort(comparer);
	    while (length--) {
	      array[length] = array[length].value;
	    }
	    return array;
	  }
	
	  /**
	   * The base implementation of `_.sum` and `_.sumBy` without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} array The array to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @returns {number} Returns the sum.
	   */
	  function baseSum(array, iteratee) {
	    var result,
	        index = -1,
	        length = array.length;
	
	    while (++index < length) {
	      var current = iteratee(array[index]);
	      if (current !== undefined) {
	        result = result === undefined ? current : (result + current);
	      }
	    }
	    return result;
	  }
	
	  /**
	   * The base implementation of `_.times` without support for iteratee shorthands
	   * or max array length checks.
	   *
	   * @private
	   * @param {number} n The number of times to invoke `iteratee`.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @returns {Array} Returns the array of results.
	   */
	  function baseTimes(n, iteratee) {
	    var index = -1,
	        result = Array(n);
	
	    while (++index < n) {
	      result[index] = iteratee(index);
	    }
	    return result;
	  }
	
	  /**
	   * The base implementation of `_.toPairs` and `_.toPairsIn` which creates an array
	   * of key-value pairs for `object` corresponding to the property names of `props`.
	   *
	   * @private
	   * @param {Object} object The object to query.
	   * @param {Array} props The property names to get values for.
	   * @returns {Object} Returns the key-value pairs.
	   */
	  function baseToPairs(object, props) {
	    return arrayMap(props, function(key) {
	      return [key, object[key]];
	    });
	  }
	
	  /**
	   * The base implementation of `_.unary` without support for storing metadata.
	   *
	   * @private
	   * @param {Function} func The function to cap arguments for.
	   * @returns {Function} Returns the new capped function.
	   */
	  function baseUnary(func) {
	    return function(value) {
	      return func(value);
	    };
	  }
	
	  /**
	   * The base implementation of `_.values` and `_.valuesIn` which creates an
	   * array of `object` property values corresponding to the property names
	   * of `props`.
	   *
	   * @private
	   * @param {Object} object The object to query.
	   * @param {Array} props The property names to get values for.
	   * @returns {Object} Returns the array of property values.
	   */
	  function baseValues(object, props) {
	    return arrayMap(props, function(key) {
	      return object[key];
	    });
	  }
	
	  /**
	   * Checks if a `cache` value for `key` exists.
	   *
	   * @private
	   * @param {Object} cache The cache to query.
	   * @param {string} key The key of the entry to check.
	   * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	   */
	  function cacheHas(cache, key) {
	    return cache.has(key);
	  }
	
	  /**
	   * Used by `_.trim` and `_.trimStart` to get the index of the first string symbol
	   * that is not found in the character symbols.
	   *
	   * @private
	   * @param {Array} strSymbols The string symbols to inspect.
	   * @param {Array} chrSymbols The character symbols to find.
	   * @returns {number} Returns the index of the first unmatched string symbol.
	   */
	  function charsStartIndex(strSymbols, chrSymbols) {
	    var index = -1,
	        length = strSymbols.length;
	
	    while (++index < length && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1) {}
	    return index;
	  }
	
	  /**
	   * Used by `_.trim` and `_.trimEnd` to get the index of the last string symbol
	   * that is not found in the character symbols.
	   *
	   * @private
	   * @param {Array} strSymbols The string symbols to inspect.
	   * @param {Array} chrSymbols The character symbols to find.
	   * @returns {number} Returns the index of the last unmatched string symbol.
	   */
	  function charsEndIndex(strSymbols, chrSymbols) {
	    var index = strSymbols.length;
	
	    while (index-- && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1) {}
	    return index;
	  }
	
	  /**
	   * Gets the number of `placeholder` occurrences in `array`.
	   *
	   * @private
	   * @param {Array} array The array to inspect.
	   * @param {*} placeholder The placeholder to search for.
	   * @returns {number} Returns the placeholder count.
	   */
	  function countHolders(array, placeholder) {
	    var length = array.length,
	        result = 0;
	
	    while (length--) {
	      if (array[length] === placeholder) {
	        ++result;
	      }
	    }
	    return result;
	  }
	
	  /**
	   * Used by `_.deburr` to convert Latin-1 Supplement and Latin Extended-A
	   * letters to basic Latin letters.
	   *
	   * @private
	   * @param {string} letter The matched letter to deburr.
	   * @returns {string} Returns the deburred letter.
	   */
	  var deburrLetter = basePropertyOf(deburredLetters);
	
	  /**
	   * Used by `_.escape` to convert characters to HTML entities.
	   *
	   * @private
	   * @param {string} chr The matched character to escape.
	   * @returns {string} Returns the escaped character.
	   */
	  var escapeHtmlChar = basePropertyOf(htmlEscapes);
	
	  /**
	   * Used by `_.template` to escape characters for inclusion in compiled string literals.
	   *
	   * @private
	   * @param {string} chr The matched character to escape.
	   * @returns {string} Returns the escaped character.
	   */
	  function escapeStringChar(chr) {
	    return '\\' + stringEscapes[chr];
	  }
	
	  /**
	   * Gets the value at `key` of `object`.
	   *
	   * @private
	   * @param {Object} [object] The object to query.
	   * @param {string} key The key of the property to get.
	   * @returns {*} Returns the property value.
	   */
	  function getValue(object, key) {
	    return object == null ? undefined : object[key];
	  }
	
	  /**
	   * Checks if `string` contains Unicode symbols.
	   *
	   * @private
	   * @param {string} string The string to inspect.
	   * @returns {boolean} Returns `true` if a symbol is found, else `false`.
	   */
	  function hasUnicode(string) {
	    return reHasUnicode.test(string);
	  }
	
	  /**
	   * Checks if `string` contains a word composed of Unicode symbols.
	   *
	   * @private
	   * @param {string} string The string to inspect.
	   * @returns {boolean} Returns `true` if a word is found, else `false`.
	   */
	  function hasUnicodeWord(string) {
	    return reHasUnicodeWord.test(string);
	  }
	
	  /**
	   * Converts `iterator` to an array.
	   *
	   * @private
	   * @param {Object} iterator The iterator to convert.
	   * @returns {Array} Returns the converted array.
	   */
	  function iteratorToArray(iterator) {
	    var data,
	        result = [];
	
	    while (!(data = iterator.next()).done) {
	      result.push(data.value);
	    }
	    return result;
	  }
	
	  /**
	   * Converts `map` to its key-value pairs.
	   *
	   * @private
	   * @param {Object} map The map to convert.
	   * @returns {Array} Returns the key-value pairs.
	   */
	  function mapToArray(map) {
	    var index = -1,
	        result = Array(map.size);
	
	    map.forEach(function(value, key) {
	      result[++index] = [key, value];
	    });
	    return result;
	  }
	
	  /**
	   * Creates a unary function that invokes `func` with its argument transformed.
	   *
	   * @private
	   * @param {Function} func The function to wrap.
	   * @param {Function} transform The argument transform.
	   * @returns {Function} Returns the new function.
	   */
	  function overArg(func, transform) {
	    return function(arg) {
	      return func(transform(arg));
	    };
	  }
	
	  /**
	   * Replaces all `placeholder` elements in `array` with an internal placeholder
	   * and returns an array of their indexes.
	   *
	   * @private
	   * @param {Array} array The array to modify.
	   * @param {*} placeholder The placeholder to replace.
	   * @returns {Array} Returns the new array of placeholder indexes.
	   */
	  function replaceHolders(array, placeholder) {
	    var index = -1,
	        length = array.length,
	        resIndex = 0,
	        result = [];
	
	    while (++index < length) {
	      var value = array[index];
	      if (value === placeholder || value === PLACEHOLDER) {
	        array[index] = PLACEHOLDER;
	        result[resIndex++] = index;
	      }
	    }
	    return result;
	  }
	
	  /**
	   * Converts `set` to an array of its values.
	   *
	   * @private
	   * @param {Object} set The set to convert.
	   * @returns {Array} Returns the values.
	   */
	  function setToArray(set) {
	    var index = -1,
	        result = Array(set.size);
	
	    set.forEach(function(value) {
	      result[++index] = value;
	    });
	    return result;
	  }
	
	  /**
	   * Converts `set` to its value-value pairs.
	   *
	   * @private
	   * @param {Object} set The set to convert.
	   * @returns {Array} Returns the value-value pairs.
	   */
	  function setToPairs(set) {
	    var index = -1,
	        result = Array(set.size);
	
	    set.forEach(function(value) {
	      result[++index] = [value, value];
	    });
	    return result;
	  }
	
	  /**
	   * A specialized version of `_.indexOf` which performs strict equality
	   * comparisons of values, i.e. `===`.
	   *
	   * @private
	   * @param {Array} array The array to inspect.
	   * @param {*} value The value to search for.
	   * @param {number} fromIndex The index to search from.
	   * @returns {number} Returns the index of the matched value, else `-1`.
	   */
	  function strictIndexOf(array, value, fromIndex) {
	    var index = fromIndex - 1,
	        length = array.length;
	
	    while (++index < length) {
	      if (array[index] === value) {
	        return index;
	      }
	    }
	    return -1;
	  }
	
	  /**
	   * A specialized version of `_.lastIndexOf` which performs strict equality
	   * comparisons of values, i.e. `===`.
	   *
	   * @private
	   * @param {Array} array The array to inspect.
	   * @param {*} value The value to search for.
	   * @param {number} fromIndex The index to search from.
	   * @returns {number} Returns the index of the matched value, else `-1`.
	   */
	  function strictLastIndexOf(array, value, fromIndex) {
	    var index = fromIndex + 1;
	    while (index--) {
	      if (array[index] === value) {
	        return index;
	      }
	    }
	    return index;
	  }
	
	  /**
	   * Gets the number of symbols in `string`.
	   *
	   * @private
	   * @param {string} string The string to inspect.
	   * @returns {number} Returns the string size.
	   */
	  function stringSize(string) {
	    return hasUnicode(string)
	      ? unicodeSize(string)
	      : asciiSize(string);
	  }
	
	  /**
	   * Converts `string` to an array.
	   *
	   * @private
	   * @param {string} string The string to convert.
	   * @returns {Array} Returns the converted array.
	   */
	  function stringToArray(string) {
	    return hasUnicode(string)
	      ? unicodeToArray(string)
	      : asciiToArray(string);
	  }
	
	  /**
	   * Used by `_.unescape` to convert HTML entities to characters.
	   *
	   * @private
	   * @param {string} chr The matched character to unescape.
	   * @returns {string} Returns the unescaped character.
	   */
	  var unescapeHtmlChar = basePropertyOf(htmlUnescapes);
	
	  /**
	   * Gets the size of a Unicode `string`.
	   *
	   * @private
	   * @param {string} string The string inspect.
	   * @returns {number} Returns the string size.
	   */
	  function unicodeSize(string) {
	    var result = reUnicode.lastIndex = 0;
	    while (reUnicode.test(string)) {
	      ++result;
	    }
	    return result;
	  }
	
	  /**
	   * Converts a Unicode `string` to an array.
	   *
	   * @private
	   * @param {string} string The string to convert.
	   * @returns {Array} Returns the converted array.
	   */
	  function unicodeToArray(string) {
	    return string.match(reUnicode) || [];
	  }
	
	  /**
	   * Splits a Unicode `string` into an array of its words.
	   *
	   * @private
	   * @param {string} The string to inspect.
	   * @returns {Array} Returns the words of `string`.
	   */
	  function unicodeWords(string) {
	    return string.match(reUnicodeWord) || [];
	  }
	
	  /*--------------------------------------------------------------------------*/
	
	  /**
	   * Create a new pristine `lodash` function using the `context` object.
	   *
	   * @static
	   * @memberOf _
	   * @since 1.1.0
	   * @category Util
	   * @param {Object} [context=root] The context object.
	   * @returns {Function} Returns a new `lodash` function.
	   * @example
	   *
	   * _.mixin({ 'foo': _.constant('foo') });
	   *
	   * var lodash = _.runInContext();
	   * lodash.mixin({ 'bar': lodash.constant('bar') });
	   *
	   * _.isFunction(_.foo);
	   * // => true
	   * _.isFunction(_.bar);
	   * // => false
	   *
	   * lodash.isFunction(lodash.foo);
	   * // => false
	   * lodash.isFunction(lodash.bar);
	   * // => true
	   *
	   * // Create a suped-up `defer` in Node.js.
	   * var defer = _.runInContext({ 'setTimeout': setImmediate }).defer;
	   */
	  var runInContext = (function runInContext(context) {
	    context = context == null ? root : _.defaults(root.Object(), context, _.pick(root, contextProps));
	
	    /** Built-in constructor references. */
	    var Array = context.Array,
	        Date = context.Date,
	        Error = context.Error,
	        Function = context.Function,
	        Math = context.Math,
	        Object = context.Object,
	        RegExp = context.RegExp,
	        String = context.String,
	        TypeError = context.TypeError;
	
	    /** Used for built-in method references. */
	    var arrayProto = Array.prototype,
	        funcProto = Function.prototype,
	        objectProto = Object.prototype;
	
	    /** Used to detect overreaching core-js shims. */
	    var coreJsData = context['__core-js_shared__'];
	
	    /** Used to resolve the decompiled source of functions. */
	    var funcToString = funcProto.toString;
	
	    /** Used to check objects for own properties. */
	    var hasOwnProperty = objectProto.hasOwnProperty;
	
	    /** Used to generate unique IDs. */
	    var idCounter = 0;
	
	    /** Used to detect methods masquerading as native. */
	    var maskSrcKey = (function() {
	      var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
	      return uid ? ('Symbol(src)_1.' + uid) : '';
	    }());
	
	    /**
	     * Used to resolve the
	     * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	     * of values.
	     */
	    var nativeObjectToString = objectProto.toString;
	
	    /** Used to infer the `Object` constructor. */
	    var objectCtorString = funcToString.call(Object);
	
	    /** Used to restore the original `_` reference in `_.noConflict`. */
	    var oldDash = root._;
	
	    /** Used to detect if a method is native. */
	    var reIsNative = RegExp('^' +
	      funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
	      .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
	    );
	
	    /** Built-in value references. */
	    var Buffer = moduleExports ? context.Buffer : undefined,
	        Symbol = context.Symbol,
	        Uint8Array = context.Uint8Array,
	        allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined,
	        getPrototype = overArg(Object.getPrototypeOf, Object),
	        objectCreate = Object.create,
	        propertyIsEnumerable = objectProto.propertyIsEnumerable,
	        splice = arrayProto.splice,
	        spreadableSymbol = Symbol ? Symbol.isConcatSpreadable : undefined,
	        symIterator = Symbol ? Symbol.iterator : undefined,
	        symToStringTag = Symbol ? Symbol.toStringTag : undefined;
	
	    var defineProperty = (function() {
	      try {
	        var func = getNative(Object, 'defineProperty');
	        func({}, '', {});
	        return func;
	      } catch (e) {}
	    }());
	
	    /** Mocked built-ins. */
	    var ctxClearTimeout = context.clearTimeout !== root.clearTimeout && context.clearTimeout,
	        ctxNow = Date && Date.now !== root.Date.now && Date.now,
	        ctxSetTimeout = context.setTimeout !== root.setTimeout && context.setTimeout;
	
	    /* Built-in method references for those with the same name as other `lodash` methods. */
	    var nativeCeil = Math.ceil,
	        nativeFloor = Math.floor,
	        nativeGetSymbols = Object.getOwnPropertySymbols,
	        nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined,
	        nativeIsFinite = context.isFinite,
	        nativeJoin = arrayProto.join,
	        nativeKeys = overArg(Object.keys, Object),
	        nativeMax = Math.max,
	        nativeMin = Math.min,
	        nativeNow = Date.now,
	        nativeParseInt = context.parseInt,
	        nativeRandom = Math.random,
	        nativeReverse = arrayProto.reverse;
	
	    /* Built-in method references that are verified to be native. */
	    var DataView = getNative(context, 'DataView'),
	        Map = getNative(context, 'Map'),
	        Promise = getNative(context, 'Promise'),
	        Set = getNative(context, 'Set'),
	        WeakMap = getNative(context, 'WeakMap'),
	        nativeCreate = getNative(Object, 'create');
	
	    /** Used to store function metadata. */
	    var metaMap = WeakMap && new WeakMap;
	
	    /** Used to lookup unminified function names. */
	    var realNames = {};
	
	    /** Used to detect maps, sets, and weakmaps. */
	    var dataViewCtorString = toSource(DataView),
	        mapCtorString = toSource(Map),
	        promiseCtorString = toSource(Promise),
	        setCtorString = toSource(Set),
	        weakMapCtorString = toSource(WeakMap);
	
	    /** Used to convert symbols to primitives and strings. */
	    var symbolProto = Symbol ? Symbol.prototype : undefined,
	        symbolValueOf = symbolProto ? symbolProto.valueOf : undefined,
	        symbolToString = symbolProto ? symbolProto.toString : undefined;
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates a `lodash` object which wraps `value` to enable implicit method
	     * chain sequences. Methods that operate on and return arrays, collections,
	     * and functions can be chained together. Methods that retrieve a single value
	     * or may return a primitive value will automatically end the chain sequence
	     * and return the unwrapped value. Otherwise, the value must be unwrapped
	     * with `_#value`.
	     *
	     * Explicit chain sequences, which must be unwrapped with `_#value`, may be
	     * enabled using `_.chain`.
	     *
	     * The execution of chained methods is lazy, that is, it's deferred until
	     * `_#value` is implicitly or explicitly called.
	     *
	     * Lazy evaluation allows several methods to support shortcut fusion.
	     * Shortcut fusion is an optimization to merge iteratee calls; this avoids
	     * the creation of intermediate arrays and can greatly reduce the number of
	     * iteratee executions. Sections of a chain sequence qualify for shortcut
	     * fusion if the section is applied to an array and iteratees accept only
	     * one argument. The heuristic for whether a section qualifies for shortcut
	     * fusion is subject to change.
	     *
	     * Chaining is supported in custom builds as long as the `_#value` method is
	     * directly or indirectly included in the build.
	     *
	     * In addition to lodash methods, wrappers have `Array` and `String` methods.
	     *
	     * The wrapper `Array` methods are:
	     * `concat`, `join`, `pop`, `push`, `shift`, `sort`, `splice`, and `unshift`
	     *
	     * The wrapper `String` methods are:
	     * `replace` and `split`
	     *
	     * The wrapper methods that support shortcut fusion are:
	     * `at`, `compact`, `drop`, `dropRight`, `dropWhile`, `filter`, `find`,
	     * `findLast`, `head`, `initial`, `last`, `map`, `reject`, `reverse`, `slice`,
	     * `tail`, `take`, `takeRight`, `takeRightWhile`, `takeWhile`, and `toArray`
	     *
	     * The chainable wrapper methods are:
	     * `after`, `ary`, `assign`, `assignIn`, `assignInWith`, `assignWith`, `at`,
	     * `before`, `bind`, `bindAll`, `bindKey`, `castArray`, `chain`, `chunk`,
	     * `commit`, `compact`, `concat`, `conforms`, `constant`, `countBy`, `create`,
	     * `curry`, `debounce`, `defaults`, `defaultsDeep`, `defer`, `delay`,
	     * `difference`, `differenceBy`, `differenceWith`, `drop`, `dropRight`,
	     * `dropRightWhile`, `dropWhile`, `extend`, `extendWith`, `fill`, `filter`,
	     * `flatMap`, `flatMapDeep`, `flatMapDepth`, `flatten`, `flattenDeep`,
	     * `flattenDepth`, `flip`, `flow`, `flowRight`, `fromPairs`, `functions`,
	     * `functionsIn`, `groupBy`, `initial`, `intersection`, `intersectionBy`,
	     * `intersectionWith`, `invert`, `invertBy`, `invokeMap`, `iteratee`, `keyBy`,
	     * `keys`, `keysIn`, `map`, `mapKeys`, `mapValues`, `matches`, `matchesProperty`,
	     * `memoize`, `merge`, `mergeWith`, `method`, `methodOf`, `mixin`, `negate`,
	     * `nthArg`, `omit`, `omitBy`, `once`, `orderBy`, `over`, `overArgs`,
	     * `overEvery`, `overSome`, `partial`, `partialRight`, `partition`, `pick`,
	     * `pickBy`, `plant`, `property`, `propertyOf`, `pull`, `pullAll`, `pullAllBy`,
	     * `pullAllWith`, `pullAt`, `push`, `range`, `rangeRight`, `rearg`, `reject`,
	     * `remove`, `rest`, `reverse`, `sampleSize`, `set`, `setWith`, `shuffle`,
	     * `slice`, `sort`, `sortBy`, `splice`, `spread`, `tail`, `take`, `takeRight`,
	     * `takeRightWhile`, `takeWhile`, `tap`, `throttle`, `thru`, `toArray`,
	     * `toPairs`, `toPairsIn`, `toPath`, `toPlainObject`, `transform`, `unary`,
	     * `union`, `unionBy`, `unionWith`, `uniq`, `uniqBy`, `uniqWith`, `unset`,
	     * `unshift`, `unzip`, `unzipWith`, `update`, `updateWith`, `values`,
	     * `valuesIn`, `without`, `wrap`, `xor`, `xorBy`, `xorWith`, `zip`,
	     * `zipObject`, `zipObjectDeep`, and `zipWith`
	     *
	     * The wrapper methods that are **not** chainable by default are:
	     * `add`, `attempt`, `camelCase`, `capitalize`, `ceil`, `clamp`, `clone`,
	     * `cloneDeep`, `cloneDeepWith`, `cloneWith`, `conformsTo`, `deburr`,
	     * `defaultTo`, `divide`, `each`, `eachRight`, `endsWith`, `eq`, `escape`,
	     * `escapeRegExp`, `every`, `find`, `findIndex`, `findKey`, `findLast`,
	     * `findLastIndex`, `findLastKey`, `first`, `floor`, `forEach`, `forEachRight`,
	     * `forIn`, `forInRight`, `forOwn`, `forOwnRight`, `get`, `gt`, `gte`, `has`,
	     * `hasIn`, `head`, `identity`, `includes`, `indexOf`, `inRange`, `invoke`,
	     * `isArguments`, `isArray`, `isArrayBuffer`, `isArrayLike`, `isArrayLikeObject`,
	     * `isBoolean`, `isBuffer`, `isDate`, `isElement`, `isEmpty`, `isEqual`,
	     * `isEqualWith`, `isError`, `isFinite`, `isFunction`, `isInteger`, `isLength`,
	     * `isMap`, `isMatch`, `isMatchWith`, `isNaN`, `isNative`, `isNil`, `isNull`,
	     * `isNumber`, `isObject`, `isObjectLike`, `isPlainObject`, `isRegExp`,
	     * `isSafeInteger`, `isSet`, `isString`, `isUndefined`, `isTypedArray`,
	     * `isWeakMap`, `isWeakSet`, `join`, `kebabCase`, `last`, `lastIndexOf`,
	     * `lowerCase`, `lowerFirst`, `lt`, `lte`, `max`, `maxBy`, `mean`, `meanBy`,
	     * `min`, `minBy`, `multiply`, `noConflict`, `noop`, `now`, `nth`, `pad`,
	     * `padEnd`, `padStart`, `parseInt`, `pop`, `random`, `reduce`, `reduceRight`,
	     * `repeat`, `result`, `round`, `runInContext`, `sample`, `shift`, `size`,
	     * `snakeCase`, `some`, `sortedIndex`, `sortedIndexBy`, `sortedLastIndex`,
	     * `sortedLastIndexBy`, `startCase`, `startsWith`, `stubArray`, `stubFalse`,
	     * `stubObject`, `stubString`, `stubTrue`, `subtract`, `sum`, `sumBy`,
	     * `template`, `times`, `toFinite`, `toInteger`, `toJSON`, `toLength`,
	     * `toLower`, `toNumber`, `toSafeInteger`, `toString`, `toUpper`, `trim`,
	     * `trimEnd`, `trimStart`, `truncate`, `unescape`, `uniqueId`, `upperCase`,
	     * `upperFirst`, `value`, and `words`
	     *
	     * @name _
	     * @constructor
	     * @category Seq
	     * @param {*} value The value to wrap in a `lodash` instance.
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * function square(n) {
	     *   return n * n;
	     * }
	     *
	     * var wrapped = _([1, 2, 3]);
	     *
	     * // Returns an unwrapped value.
	     * wrapped.reduce(_.add);
	     * // => 6
	     *
	     * // Returns a wrapped value.
	     * var squares = wrapped.map(square);
	     *
	     * _.isArray(squares);
	     * // => false
	     *
	     * _.isArray(squares.value());
	     * // => true
	     */
	    function lodash(value) {
	      if (isObjectLike(value) && !isArray(value) && !(value instanceof LazyWrapper)) {
	        if (value instanceof LodashWrapper) {
	          return value;
	        }
	        if (hasOwnProperty.call(value, '__wrapped__')) {
	          return wrapperClone(value);
	        }
	      }
	      return new LodashWrapper(value);
	    }
	
	    /**
	     * The base implementation of `_.create` without support for assigning
	     * properties to the created object.
	     *
	     * @private
	     * @param {Object} proto The object to inherit from.
	     * @returns {Object} Returns the new object.
	     */
	    var baseCreate = (function() {
	      function object() {}
	      return function(proto) {
	        if (!isObject(proto)) {
	          return {};
	        }
	        if (objectCreate) {
	          return objectCreate(proto);
	        }
	        object.prototype = proto;
	        var result = new object;
	        object.prototype = undefined;
	        return result;
	      };
	    }());
	
	    /**
	     * The function whose prototype chain sequence wrappers inherit from.
	     *
	     * @private
	     */
	    function baseLodash() {
	      // No operation performed.
	    }
	
	    /**
	     * The base constructor for creating `lodash` wrapper objects.
	     *
	     * @private
	     * @param {*} value The value to wrap.
	     * @param {boolean} [chainAll] Enable explicit method chain sequences.
	     */
	    function LodashWrapper(value, chainAll) {
	      this.__wrapped__ = value;
	      this.__actions__ = [];
	      this.__chain__ = !!chainAll;
	      this.__index__ = 0;
	      this.__values__ = undefined;
	    }
	
	    /**
	     * By default, the template delimiters used by lodash are like those in
	     * embedded Ruby (ERB) as well as ES2015 template strings. Change the
	     * following template settings to use alternative delimiters.
	     *
	     * @static
	     * @memberOf _
	     * @type {Object}
	     */
	    lodash.templateSettings = {
	
	      /**
	       * Used to detect `data` property values to be HTML-escaped.
	       *
	       * @memberOf _.templateSettings
	       * @type {RegExp}
	       */
	      'escape': reEscape,
	
	      /**
	       * Used to detect code to be evaluated.
	       *
	       * @memberOf _.templateSettings
	       * @type {RegExp}
	       */
	      'evaluate': reEvaluate,
	
	      /**
	       * Used to detect `data` property values to inject.
	       *
	       * @memberOf _.templateSettings
	       * @type {RegExp}
	       */
	      'interpolate': reInterpolate,
	
	      /**
	       * Used to reference the data object in the template text.
	       *
	       * @memberOf _.templateSettings
	       * @type {string}
	       */
	      'variable': '',
	
	      /**
	       * Used to import variables into the compiled template.
	       *
	       * @memberOf _.templateSettings
	       * @type {Object}
	       */
	      'imports': {
	
	        /**
	         * A reference to the `lodash` function.
	         *
	         * @memberOf _.templateSettings.imports
	         * @type {Function}
	         */
	        '_': lodash
	      }
	    };
	
	    // Ensure wrappers are instances of `baseLodash`.
	    lodash.prototype = baseLodash.prototype;
	    lodash.prototype.constructor = lodash;
	
	    LodashWrapper.prototype = baseCreate(baseLodash.prototype);
	    LodashWrapper.prototype.constructor = LodashWrapper;
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates a lazy wrapper object which wraps `value` to enable lazy evaluation.
	     *
	     * @private
	     * @constructor
	     * @param {*} value The value to wrap.
	     */
	    function LazyWrapper(value) {
	      this.__wrapped__ = value;
	      this.__actions__ = [];
	      this.__dir__ = 1;
	      this.__filtered__ = false;
	      this.__iteratees__ = [];
	      this.__takeCount__ = MAX_ARRAY_LENGTH;
	      this.__views__ = [];
	    }
	
	    /**
	     * Creates a clone of the lazy wrapper object.
	     *
	     * @private
	     * @name clone
	     * @memberOf LazyWrapper
	     * @returns {Object} Returns the cloned `LazyWrapper` object.
	     */
	    function lazyClone() {
	      var result = new LazyWrapper(this.__wrapped__);
	      result.__actions__ = copyArray(this.__actions__);
	      result.__dir__ = this.__dir__;
	      result.__filtered__ = this.__filtered__;
	      result.__iteratees__ = copyArray(this.__iteratees__);
	      result.__takeCount__ = this.__takeCount__;
	      result.__views__ = copyArray(this.__views__);
	      return result;
	    }
	
	    /**
	     * Reverses the direction of lazy iteration.
	     *
	     * @private
	     * @name reverse
	     * @memberOf LazyWrapper
	     * @returns {Object} Returns the new reversed `LazyWrapper` object.
	     */
	    function lazyReverse() {
	      if (this.__filtered__) {
	        var result = new LazyWrapper(this);
	        result.__dir__ = -1;
	        result.__filtered__ = true;
	      } else {
	        result = this.clone();
	        result.__dir__ *= -1;
	      }
	      return result;
	    }
	
	    /**
	     * Extracts the unwrapped value from its lazy wrapper.
	     *
	     * @private
	     * @name value
	     * @memberOf LazyWrapper
	     * @returns {*} Returns the unwrapped value.
	     */
	    function lazyValue() {
	      var array = this.__wrapped__.value(),
	          dir = this.__dir__,
	          isArr = isArray(array),
	          isRight = dir < 0,
	          arrLength = isArr ? array.length : 0,
	          view = getView(0, arrLength, this.__views__),
	          start = view.start,
	          end = view.end,
	          length = end - start,
	          index = isRight ? end : (start - 1),
	          iteratees = this.__iteratees__,
	          iterLength = iteratees.length,
	          resIndex = 0,
	          takeCount = nativeMin(length, this.__takeCount__);
	
	      if (!isArr || (!isRight && arrLength == length && takeCount == length)) {
	        return baseWrapperValue(array, this.__actions__);
	      }
	      var result = [];
	
	      outer:
	      while (length-- && resIndex < takeCount) {
	        index += dir;
	
	        var iterIndex = -1,
	            value = array[index];
	
	        while (++iterIndex < iterLength) {
	          var data = iteratees[iterIndex],
	              iteratee = data.iteratee,
	              type = data.type,
	              computed = iteratee(value);
	
	          if (type == LAZY_MAP_FLAG) {
	            value = computed;
	          } else if (!computed) {
	            if (type == LAZY_FILTER_FLAG) {
	              continue outer;
	            } else {
	              break outer;
	            }
	          }
	        }
	        result[resIndex++] = value;
	      }
	      return result;
	    }
	
	    // Ensure `LazyWrapper` is an instance of `baseLodash`.
	    LazyWrapper.prototype = baseCreate(baseLodash.prototype);
	    LazyWrapper.prototype.constructor = LazyWrapper;
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates a hash object.
	     *
	     * @private
	     * @constructor
	     * @param {Array} [entries] The key-value pairs to cache.
	     */
	    function Hash(entries) {
	      var index = -1,
	          length = entries == null ? 0 : entries.length;
	
	      this.clear();
	      while (++index < length) {
	        var entry = entries[index];
	        this.set(entry[0], entry[1]);
	      }
	    }
	
	    /**
	     * Removes all key-value entries from the hash.
	     *
	     * @private
	     * @name clear
	     * @memberOf Hash
	     */
	    function hashClear() {
	      this.__data__ = nativeCreate ? nativeCreate(null) : {};
	      this.size = 0;
	    }
	
	    /**
	     * Removes `key` and its value from the hash.
	     *
	     * @private
	     * @name delete
	     * @memberOf Hash
	     * @param {Object} hash The hash to modify.
	     * @param {string} key The key of the value to remove.
	     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	     */
	    function hashDelete(key) {
	      var result = this.has(key) && delete this.__data__[key];
	      this.size -= result ? 1 : 0;
	      return result;
	    }
	
	    /**
	     * Gets the hash value for `key`.
	     *
	     * @private
	     * @name get
	     * @memberOf Hash
	     * @param {string} key The key of the value to get.
	     * @returns {*} Returns the entry value.
	     */
	    function hashGet(key) {
	      var data = this.__data__;
	      if (nativeCreate) {
	        var result = data[key];
	        return result === HASH_UNDEFINED ? undefined : result;
	      }
	      return hasOwnProperty.call(data, key) ? data[key] : undefined;
	    }
	
	    /**
	     * Checks if a hash value for `key` exists.
	     *
	     * @private
	     * @name has
	     * @memberOf Hash
	     * @param {string} key The key of the entry to check.
	     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	     */
	    function hashHas(key) {
	      var data = this.__data__;
	      return nativeCreate ? (data[key] !== undefined) : hasOwnProperty.call(data, key);
	    }
	
	    /**
	     * Sets the hash `key` to `value`.
	     *
	     * @private
	     * @name set
	     * @memberOf Hash
	     * @param {string} key The key of the value to set.
	     * @param {*} value The value to set.
	     * @returns {Object} Returns the hash instance.
	     */
	    function hashSet(key, value) {
	      var data = this.__data__;
	      this.size += this.has(key) ? 0 : 1;
	      data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
	      return this;
	    }
	
	    // Add methods to `Hash`.
	    Hash.prototype.clear = hashClear;
	    Hash.prototype['delete'] = hashDelete;
	    Hash.prototype.get = hashGet;
	    Hash.prototype.has = hashHas;
	    Hash.prototype.set = hashSet;
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates an list cache object.
	     *
	     * @private
	     * @constructor
	     * @param {Array} [entries] The key-value pairs to cache.
	     */
	    function ListCache(entries) {
	      var index = -1,
	          length = entries == null ? 0 : entries.length;
	
	      this.clear();
	      while (++index < length) {
	        var entry = entries[index];
	        this.set(entry[0], entry[1]);
	      }
	    }
	
	    /**
	     * Removes all key-value entries from the list cache.
	     *
	     * @private
	     * @name clear
	     * @memberOf ListCache
	     */
	    function listCacheClear() {
	      this.__data__ = [];
	      this.size = 0;
	    }
	
	    /**
	     * Removes `key` and its value from the list cache.
	     *
	     * @private
	     * @name delete
	     * @memberOf ListCache
	     * @param {string} key The key of the value to remove.
	     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	     */
	    function listCacheDelete(key) {
	      var data = this.__data__,
	          index = assocIndexOf(data, key);
	
	      if (index < 0) {
	        return false;
	      }
	      var lastIndex = data.length - 1;
	      if (index == lastIndex) {
	        data.pop();
	      } else {
	        splice.call(data, index, 1);
	      }
	      --this.size;
	      return true;
	    }
	
	    /**
	     * Gets the list cache value for `key`.
	     *
	     * @private
	     * @name get
	     * @memberOf ListCache
	     * @param {string} key The key of the value to get.
	     * @returns {*} Returns the entry value.
	     */
	    function listCacheGet(key) {
	      var data = this.__data__,
	          index = assocIndexOf(data, key);
	
	      return index < 0 ? undefined : data[index][1];
	    }
	
	    /**
	     * Checks if a list cache value for `key` exists.
	     *
	     * @private
	     * @name has
	     * @memberOf ListCache
	     * @param {string} key The key of the entry to check.
	     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	     */
	    function listCacheHas(key) {
	      return assocIndexOf(this.__data__, key) > -1;
	    }
	
	    /**
	     * Sets the list cache `key` to `value`.
	     *
	     * @private
	     * @name set
	     * @memberOf ListCache
	     * @param {string} key The key of the value to set.
	     * @param {*} value The value to set.
	     * @returns {Object} Returns the list cache instance.
	     */
	    function listCacheSet(key, value) {
	      var data = this.__data__,
	          index = assocIndexOf(data, key);
	
	      if (index < 0) {
	        ++this.size;
	        data.push([key, value]);
	      } else {
	        data[index][1] = value;
	      }
	      return this;
	    }
	
	    // Add methods to `ListCache`.
	    ListCache.prototype.clear = listCacheClear;
	    ListCache.prototype['delete'] = listCacheDelete;
	    ListCache.prototype.get = listCacheGet;
	    ListCache.prototype.has = listCacheHas;
	    ListCache.prototype.set = listCacheSet;
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates a map cache object to store key-value pairs.
	     *
	     * @private
	     * @constructor
	     * @param {Array} [entries] The key-value pairs to cache.
	     */
	    function MapCache(entries) {
	      var index = -1,
	          length = entries == null ? 0 : entries.length;
	
	      this.clear();
	      while (++index < length) {
	        var entry = entries[index];
	        this.set(entry[0], entry[1]);
	      }
	    }
	
	    /**
	     * Removes all key-value entries from the map.
	     *
	     * @private
	     * @name clear
	     * @memberOf MapCache
	     */
	    function mapCacheClear() {
	      this.size = 0;
	      this.__data__ = {
	        'hash': new Hash,
	        'map': new (Map || ListCache),
	        'string': new Hash
	      };
	    }
	
	    /**
	     * Removes `key` and its value from the map.
	     *
	     * @private
	     * @name delete
	     * @memberOf MapCache
	     * @param {string} key The key of the value to remove.
	     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	     */
	    function mapCacheDelete(key) {
	      var result = getMapData(this, key)['delete'](key);
	      this.size -= result ? 1 : 0;
	      return result;
	    }
	
	    /**
	     * Gets the map value for `key`.
	     *
	     * @private
	     * @name get
	     * @memberOf MapCache
	     * @param {string} key The key of the value to get.
	     * @returns {*} Returns the entry value.
	     */
	    function mapCacheGet(key) {
	      return getMapData(this, key).get(key);
	    }
	
	    /**
	     * Checks if a map value for `key` exists.
	     *
	     * @private
	     * @name has
	     * @memberOf MapCache
	     * @param {string} key The key of the entry to check.
	     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	     */
	    function mapCacheHas(key) {
	      return getMapData(this, key).has(key);
	    }
	
	    /**
	     * Sets the map `key` to `value`.
	     *
	     * @private
	     * @name set
	     * @memberOf MapCache
	     * @param {string} key The key of the value to set.
	     * @param {*} value The value to set.
	     * @returns {Object} Returns the map cache instance.
	     */
	    function mapCacheSet(key, value) {
	      var data = getMapData(this, key),
	          size = data.size;
	
	      data.set(key, value);
	      this.size += data.size == size ? 0 : 1;
	      return this;
	    }
	
	    // Add methods to `MapCache`.
	    MapCache.prototype.clear = mapCacheClear;
	    MapCache.prototype['delete'] = mapCacheDelete;
	    MapCache.prototype.get = mapCacheGet;
	    MapCache.prototype.has = mapCacheHas;
	    MapCache.prototype.set = mapCacheSet;
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     *
	     * Creates an array cache object to store unique values.
	     *
	     * @private
	     * @constructor
	     * @param {Array} [values] The values to cache.
	     */
	    function SetCache(values) {
	      var index = -1,
	          length = values == null ? 0 : values.length;
	
	      this.__data__ = new MapCache;
	      while (++index < length) {
	        this.add(values[index]);
	      }
	    }
	
	    /**
	     * Adds `value` to the array cache.
	     *
	     * @private
	     * @name add
	     * @memberOf SetCache
	     * @alias push
	     * @param {*} value The value to cache.
	     * @returns {Object} Returns the cache instance.
	     */
	    function setCacheAdd(value) {
	      this.__data__.set(value, HASH_UNDEFINED);
	      return this;
	    }
	
	    /**
	     * Checks if `value` is in the array cache.
	     *
	     * @private
	     * @name has
	     * @memberOf SetCache
	     * @param {*} value The value to search for.
	     * @returns {number} Returns `true` if `value` is found, else `false`.
	     */
	    function setCacheHas(value) {
	      return this.__data__.has(value);
	    }
	
	    // Add methods to `SetCache`.
	    SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
	    SetCache.prototype.has = setCacheHas;
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates a stack cache object to store key-value pairs.
	     *
	     * @private
	     * @constructor
	     * @param {Array} [entries] The key-value pairs to cache.
	     */
	    function Stack(entries) {
	      var data = this.__data__ = new ListCache(entries);
	      this.size = data.size;
	    }
	
	    /**
	     * Removes all key-value entries from the stack.
	     *
	     * @private
	     * @name clear
	     * @memberOf Stack
	     */
	    function stackClear() {
	      this.__data__ = new ListCache;
	      this.size = 0;
	    }
	
	    /**
	     * Removes `key` and its value from the stack.
	     *
	     * @private
	     * @name delete
	     * @memberOf Stack
	     * @param {string} key The key of the value to remove.
	     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	     */
	    function stackDelete(key) {
	      var data = this.__data__,
	          result = data['delete'](key);
	
	      this.size = data.size;
	      return result;
	    }
	
	    /**
	     * Gets the stack value for `key`.
	     *
	     * @private
	     * @name get
	     * @memberOf Stack
	     * @param {string} key The key of the value to get.
	     * @returns {*} Returns the entry value.
	     */
	    function stackGet(key) {
	      return this.__data__.get(key);
	    }
	
	    /**
	     * Checks if a stack value for `key` exists.
	     *
	     * @private
	     * @name has
	     * @memberOf Stack
	     * @param {string} key The key of the entry to check.
	     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	     */
	    function stackHas(key) {
	      return this.__data__.has(key);
	    }
	
	    /**
	     * Sets the stack `key` to `value`.
	     *
	     * @private
	     * @name set
	     * @memberOf Stack
	     * @param {string} key The key of the value to set.
	     * @param {*} value The value to set.
	     * @returns {Object} Returns the stack cache instance.
	     */
	    function stackSet(key, value) {
	      var data = this.__data__;
	      if (data instanceof ListCache) {
	        var pairs = data.__data__;
	        if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
	          pairs.push([key, value]);
	          this.size = ++data.size;
	          return this;
	        }
	        data = this.__data__ = new MapCache(pairs);
	      }
	      data.set(key, value);
	      this.size = data.size;
	      return this;
	    }
	
	    // Add methods to `Stack`.
	    Stack.prototype.clear = stackClear;
	    Stack.prototype['delete'] = stackDelete;
	    Stack.prototype.get = stackGet;
	    Stack.prototype.has = stackHas;
	    Stack.prototype.set = stackSet;
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates an array of the enumerable property names of the array-like `value`.
	     *
	     * @private
	     * @param {*} value The value to query.
	     * @param {boolean} inherited Specify returning inherited property names.
	     * @returns {Array} Returns the array of property names.
	     */
	    function arrayLikeKeys(value, inherited) {
	      var isArr = isArray(value),
	          isArg = !isArr && isArguments(value),
	          isBuff = !isArr && !isArg && isBuffer(value),
	          isType = !isArr && !isArg && !isBuff && isTypedArray(value),
	          skipIndexes = isArr || isArg || isBuff || isType,
	          result = skipIndexes ? baseTimes(value.length, String) : [],
	          length = result.length;
	
	      for (var key in value) {
	        if ((inherited || hasOwnProperty.call(value, key)) &&
	            !(skipIndexes && (
	               // Safari 9 has enumerable `arguments.length` in strict mode.
	               key == 'length' ||
	               // Node.js 0.10 has enumerable non-index properties on buffers.
	               (isBuff && (key == 'offset' || key == 'parent')) ||
	               // PhantomJS 2 has enumerable non-index properties on typed arrays.
	               (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
	               // Skip index properties.
	               isIndex(key, length)
	            ))) {
	          result.push(key);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * A specialized version of `_.sample` for arrays.
	     *
	     * @private
	     * @param {Array} array The array to sample.
	     * @returns {*} Returns the random element.
	     */
	    function arraySample(array) {
	      var length = array.length;
	      return length ? array[baseRandom(0, length - 1)] : undefined;
	    }
	
	    /**
	     * A specialized version of `_.sampleSize` for arrays.
	     *
	     * @private
	     * @param {Array} array The array to sample.
	     * @param {number} n The number of elements to sample.
	     * @returns {Array} Returns the random elements.
	     */
	    function arraySampleSize(array, n) {
	      return shuffleSelf(copyArray(array), baseClamp(n, 0, array.length));
	    }
	
	    /**
	     * A specialized version of `_.shuffle` for arrays.
	     *
	     * @private
	     * @param {Array} array The array to shuffle.
	     * @returns {Array} Returns the new shuffled array.
	     */
	    function arrayShuffle(array) {
	      return shuffleSelf(copyArray(array));
	    }
	
	    /**
	     * This function is like `assignValue` except that it doesn't assign
	     * `undefined` values.
	     *
	     * @private
	     * @param {Object} object The object to modify.
	     * @param {string} key The key of the property to assign.
	     * @param {*} value The value to assign.
	     */
	    function assignMergeValue(object, key, value) {
	      if ((value !== undefined && !eq(object[key], value)) ||
	          (value === undefined && !(key in object))) {
	        baseAssignValue(object, key, value);
	      }
	    }
	
	    /**
	     * Assigns `value` to `key` of `object` if the existing value is not equivalent
	     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * for equality comparisons.
	     *
	     * @private
	     * @param {Object} object The object to modify.
	     * @param {string} key The key of the property to assign.
	     * @param {*} value The value to assign.
	     */
	    function assignValue(object, key, value) {
	      var objValue = object[key];
	      if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) ||
	          (value === undefined && !(key in object))) {
	        baseAssignValue(object, key, value);
	      }
	    }
	
	    /**
	     * Gets the index at which the `key` is found in `array` of key-value pairs.
	     *
	     * @private
	     * @param {Array} array The array to inspect.
	     * @param {*} key The key to search for.
	     * @returns {number} Returns the index of the matched value, else `-1`.
	     */
	    function assocIndexOf(array, key) {
	      var length = array.length;
	      while (length--) {
	        if (eq(array[length][0], key)) {
	          return length;
	        }
	      }
	      return -1;
	    }
	
	    /**
	     * Aggregates elements of `collection` on `accumulator` with keys transformed
	     * by `iteratee` and values set by `setter`.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} setter The function to set `accumulator` values.
	     * @param {Function} iteratee The iteratee to transform keys.
	     * @param {Object} accumulator The initial aggregated object.
	     * @returns {Function} Returns `accumulator`.
	     */
	    function baseAggregator(collection, setter, iteratee, accumulator) {
	      baseEach(collection, function(value, key, collection) {
	        setter(accumulator, value, iteratee(value), collection);
	      });
	      return accumulator;
	    }
	
	    /**
	     * The base implementation of `_.assign` without support for multiple sources
	     * or `customizer` functions.
	     *
	     * @private
	     * @param {Object} object The destination object.
	     * @param {Object} source The source object.
	     * @returns {Object} Returns `object`.
	     */
	    function baseAssign(object, source) {
	      return object && copyObject(source, keys(source), object);
	    }
	
	    /**
	     * The base implementation of `_.assignIn` without support for multiple sources
	     * or `customizer` functions.
	     *
	     * @private
	     * @param {Object} object The destination object.
	     * @param {Object} source The source object.
	     * @returns {Object} Returns `object`.
	     */
	    function baseAssignIn(object, source) {
	      return object && copyObject(source, keysIn(source), object);
	    }
	
	    /**
	     * The base implementation of `assignValue` and `assignMergeValue` without
	     * value checks.
	     *
	     * @private
	     * @param {Object} object The object to modify.
	     * @param {string} key The key of the property to assign.
	     * @param {*} value The value to assign.
	     */
	    function baseAssignValue(object, key, value) {
	      if (key == '__proto__' && defineProperty) {
	        defineProperty(object, key, {
	          'configurable': true,
	          'enumerable': true,
	          'value': value,
	          'writable': true
	        });
	      } else {
	        object[key] = value;
	      }
	    }
	
	    /**
	     * The base implementation of `_.at` without support for individual paths.
	     *
	     * @private
	     * @param {Object} object The object to iterate over.
	     * @param {string[]} paths The property paths to pick.
	     * @returns {Array} Returns the picked elements.
	     */
	    function baseAt(object, paths) {
	      var index = -1,
	          length = paths.length,
	          result = Array(length),
	          skip = object == null;
	
	      while (++index < length) {
	        result[index] = skip ? undefined : get(object, paths[index]);
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.clamp` which doesn't coerce arguments.
	     *
	     * @private
	     * @param {number} number The number to clamp.
	     * @param {number} [lower] The lower bound.
	     * @param {number} upper The upper bound.
	     * @returns {number} Returns the clamped number.
	     */
	    function baseClamp(number, lower, upper) {
	      if (number === number) {
	        if (upper !== undefined) {
	          number = number <= upper ? number : upper;
	        }
	        if (lower !== undefined) {
	          number = number >= lower ? number : lower;
	        }
	      }
	      return number;
	    }
	
	    /**
	     * The base implementation of `_.clone` and `_.cloneDeep` which tracks
	     * traversed objects.
	     *
	     * @private
	     * @param {*} value The value to clone.
	     * @param {boolean} bitmask The bitmask flags.
	     *  1 - Deep clone
	     *  2 - Flatten inherited properties
	     *  4 - Clone symbols
	     * @param {Function} [customizer] The function to customize cloning.
	     * @param {string} [key] The key of `value`.
	     * @param {Object} [object] The parent object of `value`.
	     * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
	     * @returns {*} Returns the cloned value.
	     */
	    function baseClone(value, bitmask, customizer, key, object, stack) {
	      var result,
	          isDeep = bitmask & CLONE_DEEP_FLAG,
	          isFlat = bitmask & CLONE_FLAT_FLAG,
	          isFull = bitmask & CLONE_SYMBOLS_FLAG;
	
	      if (customizer) {
	        result = object ? customizer(value, key, object, stack) : customizer(value);
	      }
	      if (result !== undefined) {
	        return result;
	      }
	      if (!isObject(value)) {
	        return value;
	      }
	      var isArr = isArray(value);
	      if (isArr) {
	        result = initCloneArray(value);
	        if (!isDeep) {
	          return copyArray(value, result);
	        }
	      } else {
	        var tag = getTag(value),
	            isFunc = tag == funcTag || tag == genTag;
	
	        if (isBuffer(value)) {
	          return cloneBuffer(value, isDeep);
	        }
	        if (tag == objectTag || tag == argsTag || (isFunc && !object)) {
	          result = (isFlat || isFunc) ? {} : initCloneObject(value);
	          if (!isDeep) {
	            return isFlat
	              ? copySymbolsIn(value, baseAssignIn(result, value))
	              : copySymbols(value, baseAssign(result, value));
	          }
	        } else {
	          if (!cloneableTags[tag]) {
	            return object ? value : {};
	          }
	          result = initCloneByTag(value, tag, isDeep);
	        }
	      }
	      // Check for circular references and return its corresponding clone.
	      stack || (stack = new Stack);
	      var stacked = stack.get(value);
	      if (stacked) {
	        return stacked;
	      }
	      stack.set(value, result);
	
	      if (isSet(value)) {
	        value.forEach(function(subValue) {
	          result.add(baseClone(subValue, bitmask, customizer, subValue, value, stack));
	        });
	
	        return result;
	      }
	
	      if (isMap(value)) {
	        value.forEach(function(subValue, key) {
	          result.set(key, baseClone(subValue, bitmask, customizer, key, value, stack));
	        });
	
	        return result;
	      }
	
	      var keysFunc = isFull
	        ? (isFlat ? getAllKeysIn : getAllKeys)
	        : (isFlat ? keysIn : keys);
	
	      var props = isArr ? undefined : keysFunc(value);
	      arrayEach(props || value, function(subValue, key) {
	        if (props) {
	          key = subValue;
	          subValue = value[key];
	        }
	        // Recursively populate clone (susceptible to call stack limits).
	        assignValue(result, key, baseClone(subValue, bitmask, customizer, key, value, stack));
	      });
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.conforms` which doesn't clone `source`.
	     *
	     * @private
	     * @param {Object} source The object of property predicates to conform to.
	     * @returns {Function} Returns the new spec function.
	     */
	    function baseConforms(source) {
	      var props = keys(source);
	      return function(object) {
	        return baseConformsTo(object, source, props);
	      };
	    }
	
	    /**
	     * The base implementation of `_.conformsTo` which accepts `props` to check.
	     *
	     * @private
	     * @param {Object} object The object to inspect.
	     * @param {Object} source The object of property predicates to conform to.
	     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
	     */
	    function baseConformsTo(object, source, props) {
	      var length = props.length;
	      if (object == null) {
	        return !length;
	      }
	      object = Object(object);
	      while (length--) {
	        var key = props[length],
	            predicate = source[key],
	            value = object[key];
	
	        if ((value === undefined && !(key in object)) || !predicate(value)) {
	          return false;
	        }
	      }
	      return true;
	    }
	
	    /**
	     * The base implementation of `_.delay` and `_.defer` which accepts `args`
	     * to provide to `func`.
	     *
	     * @private
	     * @param {Function} func The function to delay.
	     * @param {number} wait The number of milliseconds to delay invocation.
	     * @param {Array} args The arguments to provide to `func`.
	     * @returns {number|Object} Returns the timer id or timeout object.
	     */
	    function baseDelay(func, wait, args) {
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      return setTimeout(function() { func.apply(undefined, args); }, wait);
	    }
	
	    /**
	     * The base implementation of methods like `_.difference` without support
	     * for excluding multiple arrays or iteratee shorthands.
	     *
	     * @private
	     * @param {Array} array The array to inspect.
	     * @param {Array} values The values to exclude.
	     * @param {Function} [iteratee] The iteratee invoked per element.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new array of filtered values.
	     */
	    function baseDifference(array, values, iteratee, comparator) {
	      var index = -1,
	          includes = arrayIncludes,
	          isCommon = true,
	          length = array.length,
	          result = [],
	          valuesLength = values.length;
	
	      if (!length) {
	        return result;
	      }
	      if (iteratee) {
	        values = arrayMap(values, baseUnary(iteratee));
	      }
	      if (comparator) {
	        includes = arrayIncludesWith;
	        isCommon = false;
	      }
	      else if (values.length >= LARGE_ARRAY_SIZE) {
	        includes = cacheHas;
	        isCommon = false;
	        values = new SetCache(values);
	      }
	      outer:
	      while (++index < length) {
	        var value = array[index],
	            computed = iteratee == null ? value : iteratee(value);
	
	        value = (comparator || value !== 0) ? value : 0;
	        if (isCommon && computed === computed) {
	          var valuesIndex = valuesLength;
	          while (valuesIndex--) {
	            if (values[valuesIndex] === computed) {
	              continue outer;
	            }
	          }
	          result.push(value);
	        }
	        else if (!includes(values, computed, comparator)) {
	          result.push(value);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.forEach` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {Array|Object} Returns `collection`.
	     */
	    var baseEach = createBaseEach(baseForOwn);
	
	    /**
	     * The base implementation of `_.forEachRight` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {Array|Object} Returns `collection`.
	     */
	    var baseEachRight = createBaseEach(baseForOwnRight, true);
	
	    /**
	     * The base implementation of `_.every` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} predicate The function invoked per iteration.
	     * @returns {boolean} Returns `true` if all elements pass the predicate check,
	     *  else `false`
	     */
	    function baseEvery(collection, predicate) {
	      var result = true;
	      baseEach(collection, function(value, index, collection) {
	        result = !!predicate(value, index, collection);
	        return result;
	      });
	      return result;
	    }
	
	    /**
	     * The base implementation of methods like `_.max` and `_.min` which accepts a
	     * `comparator` to determine the extremum value.
	     *
	     * @private
	     * @param {Array} array The array to iterate over.
	     * @param {Function} iteratee The iteratee invoked per iteration.
	     * @param {Function} comparator The comparator used to compare values.
	     * @returns {*} Returns the extremum value.
	     */
	    function baseExtremum(array, iteratee, comparator) {
	      var index = -1,
	          length = array.length;
	
	      while (++index < length) {
	        var value = array[index],
	            current = iteratee(value);
	
	        if (current != null && (computed === undefined
	              ? (current === current && !isSymbol(current))
	              : comparator(current, computed)
	            )) {
	          var computed = current,
	              result = value;
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.fill` without an iteratee call guard.
	     *
	     * @private
	     * @param {Array} array The array to fill.
	     * @param {*} value The value to fill `array` with.
	     * @param {number} [start=0] The start position.
	     * @param {number} [end=array.length] The end position.
	     * @returns {Array} Returns `array`.
	     */
	    function baseFill(array, value, start, end) {
	      var length = array.length;
	
	      start = toInteger(start);
	      if (start < 0) {
	        start = -start > length ? 0 : (length + start);
	      }
	      end = (end === undefined || end > length) ? length : toInteger(end);
	      if (end < 0) {
	        end += length;
	      }
	      end = start > end ? 0 : toLength(end);
	      while (start < end) {
	        array[start++] = value;
	      }
	      return array;
	    }
	
	    /**
	     * The base implementation of `_.filter` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} predicate The function invoked per iteration.
	     * @returns {Array} Returns the new filtered array.
	     */
	    function baseFilter(collection, predicate) {
	      var result = [];
	      baseEach(collection, function(value, index, collection) {
	        if (predicate(value, index, collection)) {
	          result.push(value);
	        }
	      });
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.flatten` with support for restricting flattening.
	     *
	     * @private
	     * @param {Array} array The array to flatten.
	     * @param {number} depth The maximum recursion depth.
	     * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
	     * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
	     * @param {Array} [result=[]] The initial result value.
	     * @returns {Array} Returns the new flattened array.
	     */
	    function baseFlatten(array, depth, predicate, isStrict, result) {
	      var index = -1,
	          length = array.length;
	
	      predicate || (predicate = isFlattenable);
	      result || (result = []);
	
	      while (++index < length) {
	        var value = array[index];
	        if (depth > 0 && predicate(value)) {
	          if (depth > 1) {
	            // Recursively flatten arrays (susceptible to call stack limits).
	            baseFlatten(value, depth - 1, predicate, isStrict, result);
	          } else {
	            arrayPush(result, value);
	          }
	        } else if (!isStrict) {
	          result[result.length] = value;
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `baseForOwn` which iterates over `object`
	     * properties returned by `keysFunc` and invokes `iteratee` for each property.
	     * Iteratee functions may exit iteration early by explicitly returning `false`.
	     *
	     * @private
	     * @param {Object} object The object to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @param {Function} keysFunc The function to get the keys of `object`.
	     * @returns {Object} Returns `object`.
	     */
	    var baseFor = createBaseFor();
	
	    /**
	     * This function is like `baseFor` except that it iterates over properties
	     * in the opposite order.
	     *
	     * @private
	     * @param {Object} object The object to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @param {Function} keysFunc The function to get the keys of `object`.
	     * @returns {Object} Returns `object`.
	     */
	    var baseForRight = createBaseFor(true);
	
	    /**
	     * The base implementation of `_.forOwn` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Object} object The object to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {Object} Returns `object`.
	     */
	    function baseForOwn(object, iteratee) {
	      return object && baseFor(object, iteratee, keys);
	    }
	
	    /**
	     * The base implementation of `_.forOwnRight` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Object} object The object to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {Object} Returns `object`.
	     */
	    function baseForOwnRight(object, iteratee) {
	      return object && baseForRight(object, iteratee, keys);
	    }
	
	    /**
	     * The base implementation of `_.functions` which creates an array of
	     * `object` function property names filtered from `props`.
	     *
	     * @private
	     * @param {Object} object The object to inspect.
	     * @param {Array} props The property names to filter.
	     * @returns {Array} Returns the function names.
	     */
	    function baseFunctions(object, props) {
	      return arrayFilter(props, function(key) {
	        return isFunction(object[key]);
	      });
	    }
	
	    /**
	     * The base implementation of `_.get` without support for default values.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path of the property to get.
	     * @returns {*} Returns the resolved value.
	     */
	    function baseGet(object, path) {
	      path = castPath(path, object);
	
	      var index = 0,
	          length = path.length;
	
	      while (object != null && index < length) {
	        object = object[toKey(path[index++])];
	      }
	      return (index && index == length) ? object : undefined;
	    }
	
	    /**
	     * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
	     * `keysFunc` and `symbolsFunc` to get the enumerable property names and
	     * symbols of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {Function} keysFunc The function to get the keys of `object`.
	     * @param {Function} symbolsFunc The function to get the symbols of `object`.
	     * @returns {Array} Returns the array of property names and symbols.
	     */
	    function baseGetAllKeys(object, keysFunc, symbolsFunc) {
	      var result = keysFunc(object);
	      return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
	    }
	
	    /**
	     * The base implementation of `getTag` without fallbacks for buggy environments.
	     *
	     * @private
	     * @param {*} value The value to query.
	     * @returns {string} Returns the `toStringTag`.
	     */
	    function baseGetTag(value) {
	      if (value == null) {
	        return value === undefined ? undefinedTag : nullTag;
	      }
	      return (symToStringTag && symToStringTag in Object(value))
	        ? getRawTag(value)
	        : objectToString(value);
	    }
	
	    /**
	     * The base implementation of `_.gt` which doesn't coerce arguments.
	     *
	     * @private
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if `value` is greater than `other`,
	     *  else `false`.
	     */
	    function baseGt(value, other) {
	      return value > other;
	    }
	
	    /**
	     * The base implementation of `_.has` without support for deep paths.
	     *
	     * @private
	     * @param {Object} [object] The object to query.
	     * @param {Array|string} key The key to check.
	     * @returns {boolean} Returns `true` if `key` exists, else `false`.
	     */
	    function baseHas(object, key) {
	      return object != null && hasOwnProperty.call(object, key);
	    }
	
	    /**
	     * The base implementation of `_.hasIn` without support for deep paths.
	     *
	     * @private
	     * @param {Object} [object] The object to query.
	     * @param {Array|string} key The key to check.
	     * @returns {boolean} Returns `true` if `key` exists, else `false`.
	     */
	    function baseHasIn(object, key) {
	      return object != null && key in Object(object);
	    }
	
	    /**
	     * The base implementation of `_.inRange` which doesn't coerce arguments.
	     *
	     * @private
	     * @param {number} number The number to check.
	     * @param {number} start The start of the range.
	     * @param {number} end The end of the range.
	     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
	     */
	    function baseInRange(number, start, end) {
	      return number >= nativeMin(start, end) && number < nativeMax(start, end);
	    }
	
	    /**
	     * The base implementation of methods like `_.intersection`, without support
	     * for iteratee shorthands, that accepts an array of arrays to inspect.
	     *
	     * @private
	     * @param {Array} arrays The arrays to inspect.
	     * @param {Function} [iteratee] The iteratee invoked per element.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new array of shared values.
	     */
	    function baseIntersection(arrays, iteratee, comparator) {
	      var includes = comparator ? arrayIncludesWith : arrayIncludes,
	          length = arrays[0].length,
	          othLength = arrays.length,
	          othIndex = othLength,
	          caches = Array(othLength),
	          maxLength = Infinity,
	          result = [];
	
	      while (othIndex--) {
	        var array = arrays[othIndex];
	        if (othIndex && iteratee) {
	          array = arrayMap(array, baseUnary(iteratee));
	        }
	        maxLength = nativeMin(array.length, maxLength);
	        caches[othIndex] = !comparator && (iteratee || (length >= 120 && array.length >= 120))
	          ? new SetCache(othIndex && array)
	          : undefined;
	      }
	      array = arrays[0];
	
	      var index = -1,
	          seen = caches[0];
	
	      outer:
	      while (++index < length && result.length < maxLength) {
	        var value = array[index],
	            computed = iteratee ? iteratee(value) : value;
	
	        value = (comparator || value !== 0) ? value : 0;
	        if (!(seen
	              ? cacheHas(seen, computed)
	              : includes(result, computed, comparator)
	            )) {
	          othIndex = othLength;
	          while (--othIndex) {
	            var cache = caches[othIndex];
	            if (!(cache
	                  ? cacheHas(cache, computed)
	                  : includes(arrays[othIndex], computed, comparator))
	                ) {
	              continue outer;
	            }
	          }
	          if (seen) {
	            seen.push(computed);
	          }
	          result.push(value);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.invert` and `_.invertBy` which inverts
	     * `object` with values transformed by `iteratee` and set by `setter`.
	     *
	     * @private
	     * @param {Object} object The object to iterate over.
	     * @param {Function} setter The function to set `accumulator` values.
	     * @param {Function} iteratee The iteratee to transform values.
	     * @param {Object} accumulator The initial inverted object.
	     * @returns {Function} Returns `accumulator`.
	     */
	    function baseInverter(object, setter, iteratee, accumulator) {
	      baseForOwn(object, function(value, key, object) {
	        setter(accumulator, iteratee(value), key, object);
	      });
	      return accumulator;
	    }
	
	    /**
	     * The base implementation of `_.invoke` without support for individual
	     * method arguments.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path of the method to invoke.
	     * @param {Array} args The arguments to invoke the method with.
	     * @returns {*} Returns the result of the invoked method.
	     */
	    function baseInvoke(object, path, args) {
	      path = castPath(path, object);
	      object = parent(object, path);
	      var func = object == null ? object : object[toKey(last(path))];
	      return func == null ? undefined : apply(func, object, args);
	    }
	
	    /**
	     * The base implementation of `_.isArguments`.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
	     */
	    function baseIsArguments(value) {
	      return isObjectLike(value) && baseGetTag(value) == argsTag;
	    }
	
	    /**
	     * The base implementation of `_.isArrayBuffer` without Node.js optimizations.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
	     */
	    function baseIsArrayBuffer(value) {
	      return isObjectLike(value) && baseGetTag(value) == arrayBufferTag;
	    }
	
	    /**
	     * The base implementation of `_.isDate` without Node.js optimizations.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
	     */
	    function baseIsDate(value) {
	      return isObjectLike(value) && baseGetTag(value) == dateTag;
	    }
	
	    /**
	     * The base implementation of `_.isEqual` which supports partial comparisons
	     * and tracks traversed objects.
	     *
	     * @private
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @param {boolean} bitmask The bitmask flags.
	     *  1 - Unordered comparison
	     *  2 - Partial comparison
	     * @param {Function} [customizer] The function to customize comparisons.
	     * @param {Object} [stack] Tracks traversed `value` and `other` objects.
	     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	     */
	    function baseIsEqual(value, other, bitmask, customizer, stack) {
	      if (value === other) {
	        return true;
	      }
	      if (value == null || other == null || (!isObjectLike(value) && !isObjectLike(other))) {
	        return value !== value && other !== other;
	      }
	      return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
	    }
	
	    /**
	     * A specialized version of `baseIsEqual` for arrays and objects which performs
	     * deep comparisons and tracks traversed objects enabling objects with circular
	     * references to be compared.
	     *
	     * @private
	     * @param {Object} object The object to compare.
	     * @param {Object} other The other object to compare.
	     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	     * @param {Function} customizer The function to customize comparisons.
	     * @param {Function} equalFunc The function to determine equivalents of values.
	     * @param {Object} [stack] Tracks traversed `object` and `other` objects.
	     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	     */
	    function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
	      var objIsArr = isArray(object),
	          othIsArr = isArray(other),
	          objTag = objIsArr ? arrayTag : getTag(object),
	          othTag = othIsArr ? arrayTag : getTag(other);
	
	      objTag = objTag == argsTag ? objectTag : objTag;
	      othTag = othTag == argsTag ? objectTag : othTag;
	
	      var objIsObj = objTag == objectTag,
	          othIsObj = othTag == objectTag,
	          isSameTag = objTag == othTag;
	
	      if (isSameTag && isBuffer(object)) {
	        if (!isBuffer(other)) {
	          return false;
	        }
	        objIsArr = true;
	        objIsObj = false;
	      }
	      if (isSameTag && !objIsObj) {
	        stack || (stack = new Stack);
	        return (objIsArr || isTypedArray(object))
	          ? equalArrays(object, other, bitmask, customizer, equalFunc, stack)
	          : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
	      }
	      if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
	        var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
	            othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');
	
	        if (objIsWrapped || othIsWrapped) {
	          var objUnwrapped = objIsWrapped ? object.value() : object,
	              othUnwrapped = othIsWrapped ? other.value() : other;
	
	          stack || (stack = new Stack);
	          return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
	        }
	      }
	      if (!isSameTag) {
	        return false;
	      }
	      stack || (stack = new Stack);
	      return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
	    }
	
	    /**
	     * The base implementation of `_.isMap` without Node.js optimizations.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
	     */
	    function baseIsMap(value) {
	      return isObjectLike(value) && getTag(value) == mapTag;
	    }
	
	    /**
	     * The base implementation of `_.isMatch` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Object} object The object to inspect.
	     * @param {Object} source The object of property values to match.
	     * @param {Array} matchData The property names, values, and compare flags to match.
	     * @param {Function} [customizer] The function to customize comparisons.
	     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
	     */
	    function baseIsMatch(object, source, matchData, customizer) {
	      var index = matchData.length,
	          length = index,
	          noCustomizer = !customizer;
	
	      if (object == null) {
	        return !length;
	      }
	      object = Object(object);
	      while (index--) {
	        var data = matchData[index];
	        if ((noCustomizer && data[2])
	              ? data[1] !== object[data[0]]
	              : !(data[0] in object)
	            ) {
	          return false;
	        }
	      }
	      while (++index < length) {
	        data = matchData[index];
	        var key = data[0],
	            objValue = object[key],
	            srcValue = data[1];
	
	        if (noCustomizer && data[2]) {
	          if (objValue === undefined && !(key in object)) {
	            return false;
	          }
	        } else {
	          var stack = new Stack;
	          if (customizer) {
	            var result = customizer(objValue, srcValue, key, object, source, stack);
	          }
	          if (!(result === undefined
	                ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack)
	                : result
	              )) {
	            return false;
	          }
	        }
	      }
	      return true;
	    }
	
	    /**
	     * The base implementation of `_.isNative` without bad shim checks.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a native function,
	     *  else `false`.
	     */
	    function baseIsNative(value) {
	      if (!isObject(value) || isMasked(value)) {
	        return false;
	      }
	      var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
	      return pattern.test(toSource(value));
	    }
	
	    /**
	     * The base implementation of `_.isRegExp` without Node.js optimizations.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
	     */
	    function baseIsRegExp(value) {
	      return isObjectLike(value) && baseGetTag(value) == regexpTag;
	    }
	
	    /**
	     * The base implementation of `_.isSet` without Node.js optimizations.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
	     */
	    function baseIsSet(value) {
	      return isObjectLike(value) && getTag(value) == setTag;
	    }
	
	    /**
	     * The base implementation of `_.isTypedArray` without Node.js optimizations.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
	     */
	    function baseIsTypedArray(value) {
	      return isObjectLike(value) &&
	        isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
	    }
	
	    /**
	     * The base implementation of `_.iteratee`.
	     *
	     * @private
	     * @param {*} [value=_.identity] The value to convert to an iteratee.
	     * @returns {Function} Returns the iteratee.
	     */
	    function baseIteratee(value) {
	      // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
	      // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
	      if (typeof value == 'function') {
	        return value;
	      }
	      if (value == null) {
	        return identity;
	      }
	      if (typeof value == 'object') {
	        return isArray(value)
	          ? baseMatchesProperty(value[0], value[1])
	          : baseMatches(value);
	      }
	      return property(value);
	    }
	
	    /**
	     * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names.
	     */
	    function baseKeys(object) {
	      if (!isPrototype(object)) {
	        return nativeKeys(object);
	      }
	      var result = [];
	      for (var key in Object(object)) {
	        if (hasOwnProperty.call(object, key) && key != 'constructor') {
	          result.push(key);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names.
	     */
	    function baseKeysIn(object) {
	      if (!isObject(object)) {
	        return nativeKeysIn(object);
	      }
	      var isProto = isPrototype(object),
	          result = [];
	
	      for (var key in object) {
	        if (!(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) {
	          result.push(key);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.lt` which doesn't coerce arguments.
	     *
	     * @private
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if `value` is less than `other`,
	     *  else `false`.
	     */
	    function baseLt(value, other) {
	      return value < other;
	    }
	
	    /**
	     * The base implementation of `_.map` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {Array} Returns the new mapped array.
	     */
	    function baseMap(collection, iteratee) {
	      var index = -1,
	          result = isArrayLike(collection) ? Array(collection.length) : [];
	
	      baseEach(collection, function(value, key, collection) {
	        result[++index] = iteratee(value, key, collection);
	      });
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.matches` which doesn't clone `source`.
	     *
	     * @private
	     * @param {Object} source The object of property values to match.
	     * @returns {Function} Returns the new spec function.
	     */
	    function baseMatches(source) {
	      var matchData = getMatchData(source);
	      if (matchData.length == 1 && matchData[0][2]) {
	        return matchesStrictComparable(matchData[0][0], matchData[0][1]);
	      }
	      return function(object) {
	        return object === source || baseIsMatch(object, source, matchData);
	      };
	    }
	
	    /**
	     * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
	     *
	     * @private
	     * @param {string} path The path of the property to get.
	     * @param {*} srcValue The value to match.
	     * @returns {Function} Returns the new spec function.
	     */
	    function baseMatchesProperty(path, srcValue) {
	      if (isKey(path) && isStrictComparable(srcValue)) {
	        return matchesStrictComparable(toKey(path), srcValue);
	      }
	      return function(object) {
	        var objValue = get(object, path);
	        return (objValue === undefined && objValue === srcValue)
	          ? hasIn(object, path)
	          : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
	      };
	    }
	
	    /**
	     * The base implementation of `_.merge` without support for multiple sources.
	     *
	     * @private
	     * @param {Object} object The destination object.
	     * @param {Object} source The source object.
	     * @param {number} srcIndex The index of `source`.
	     * @param {Function} [customizer] The function to customize merged values.
	     * @param {Object} [stack] Tracks traversed source values and their merged
	     *  counterparts.
	     */
	    function baseMerge(object, source, srcIndex, customizer, stack) {
	      if (object === source) {
	        return;
	      }
	      baseFor(source, function(srcValue, key) {
	        if (isObject(srcValue)) {
	          stack || (stack = new Stack);
	          baseMergeDeep(object, source, key, srcIndex, baseMerge, customizer, stack);
	        }
	        else {
	          var newValue = customizer
	            ? customizer(safeGet(object, key), srcValue, (key + ''), object, source, stack)
	            : undefined;
	
	          if (newValue === undefined) {
	            newValue = srcValue;
	          }
	          assignMergeValue(object, key, newValue);
	        }
	      }, keysIn);
	    }
	
	    /**
	     * A specialized version of `baseMerge` for arrays and objects which performs
	     * deep merges and tracks traversed objects enabling objects with circular
	     * references to be merged.
	     *
	     * @private
	     * @param {Object} object The destination object.
	     * @param {Object} source The source object.
	     * @param {string} key The key of the value to merge.
	     * @param {number} srcIndex The index of `source`.
	     * @param {Function} mergeFunc The function to merge values.
	     * @param {Function} [customizer] The function to customize assigned values.
	     * @param {Object} [stack] Tracks traversed source values and their merged
	     *  counterparts.
	     */
	    function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
	      var objValue = safeGet(object, key),
	          srcValue = safeGet(source, key),
	          stacked = stack.get(srcValue);
	
	      if (stacked) {
	        assignMergeValue(object, key, stacked);
	        return;
	      }
	      var newValue = customizer
	        ? customizer(objValue, srcValue, (key + ''), object, source, stack)
	        : undefined;
	
	      var isCommon = newValue === undefined;
	
	      if (isCommon) {
	        var isArr = isArray(srcValue),
	            isBuff = !isArr && isBuffer(srcValue),
	            isTyped = !isArr && !isBuff && isTypedArray(srcValue);
	
	        newValue = srcValue;
	        if (isArr || isBuff || isTyped) {
	          if (isArray(objValue)) {
	            newValue = objValue;
	          }
	          else if (isArrayLikeObject(objValue)) {
	            newValue = copyArray(objValue);
	          }
	          else if (isBuff) {
	            isCommon = false;
	            newValue = cloneBuffer(srcValue, true);
	          }
	          else if (isTyped) {
	            isCommon = false;
	            newValue = cloneTypedArray(srcValue, true);
	          }
	          else {
	            newValue = [];
	          }
	        }
	        else if (isPlainObject(srcValue) || isArguments(srcValue)) {
	          newValue = objValue;
	          if (isArguments(objValue)) {
	            newValue = toPlainObject(objValue);
	          }
	          else if (!isObject(objValue) || isFunction(objValue)) {
	            newValue = initCloneObject(srcValue);
	          }
	        }
	        else {
	          isCommon = false;
	        }
	      }
	      if (isCommon) {
	        // Recursively merge objects and arrays (susceptible to call stack limits).
	        stack.set(srcValue, newValue);
	        mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
	        stack['delete'](srcValue);
	      }
	      assignMergeValue(object, key, newValue);
	    }
	
	    /**
	     * The base implementation of `_.nth` which doesn't coerce arguments.
	     *
	     * @private
	     * @param {Array} array The array to query.
	     * @param {number} n The index of the element to return.
	     * @returns {*} Returns the nth element of `array`.
	     */
	    function baseNth(array, n) {
	      var length = array.length;
	      if (!length) {
	        return;
	      }
	      n += n < 0 ? length : 0;
	      return isIndex(n, length) ? array[n] : undefined;
	    }
	
	    /**
	     * The base implementation of `_.orderBy` without param guards.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function[]|Object[]|string[]} iteratees The iteratees to sort by.
	     * @param {string[]} orders The sort orders of `iteratees`.
	     * @returns {Array} Returns the new sorted array.
	     */
	    function baseOrderBy(collection, iteratees, orders) {
	      var index = -1;
	      iteratees = arrayMap(iteratees.length ? iteratees : [identity], baseUnary(getIteratee()));
	
	      var result = baseMap(collection, function(value, key, collection) {
	        var criteria = arrayMap(iteratees, function(iteratee) {
	          return iteratee(value);
	        });
	        return { 'criteria': criteria, 'index': ++index, 'value': value };
	      });
	
	      return baseSortBy(result, function(object, other) {
	        return compareMultiple(object, other, orders);
	      });
	    }
	
	    /**
	     * The base implementation of `_.pick` without support for individual
	     * property identifiers.
	     *
	     * @private
	     * @param {Object} object The source object.
	     * @param {string[]} paths The property paths to pick.
	     * @returns {Object} Returns the new object.
	     */
	    function basePick(object, paths) {
	      return basePickBy(object, paths, function(value, path) {
	        return hasIn(object, path);
	      });
	    }
	
	    /**
	     * The base implementation of  `_.pickBy` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Object} object The source object.
	     * @param {string[]} paths The property paths to pick.
	     * @param {Function} predicate The function invoked per property.
	     * @returns {Object} Returns the new object.
	     */
	    function basePickBy(object, paths, predicate) {
	      var index = -1,
	          length = paths.length,
	          result = {};
	
	      while (++index < length) {
	        var path = paths[index],
	            value = baseGet(object, path);
	
	        if (predicate(value, path)) {
	          baseSet(result, castPath(path, object), value);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * A specialized version of `baseProperty` which supports deep paths.
	     *
	     * @private
	     * @param {Array|string} path The path of the property to get.
	     * @returns {Function} Returns the new accessor function.
	     */
	    function basePropertyDeep(path) {
	      return function(object) {
	        return baseGet(object, path);
	      };
	    }
	
	    /**
	     * The base implementation of `_.pullAllBy` without support for iteratee
	     * shorthands.
	     *
	     * @private
	     * @param {Array} array The array to modify.
	     * @param {Array} values The values to remove.
	     * @param {Function} [iteratee] The iteratee invoked per element.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns `array`.
	     */
	    function basePullAll(array, values, iteratee, comparator) {
	      var indexOf = comparator ? baseIndexOfWith : baseIndexOf,
	          index = -1,
	          length = values.length,
	          seen = array;
	
	      if (array === values) {
	        values = copyArray(values);
	      }
	      if (iteratee) {
	        seen = arrayMap(array, baseUnary(iteratee));
	      }
	      while (++index < length) {
	        var fromIndex = 0,
	            value = values[index],
	            computed = iteratee ? iteratee(value) : value;
	
	        while ((fromIndex = indexOf(seen, computed, fromIndex, comparator)) > -1) {
	          if (seen !== array) {
	            splice.call(seen, fromIndex, 1);
	          }
	          splice.call(array, fromIndex, 1);
	        }
	      }
	      return array;
	    }
	
	    /**
	     * The base implementation of `_.pullAt` without support for individual
	     * indexes or capturing the removed elements.
	     *
	     * @private
	     * @param {Array} array The array to modify.
	     * @param {number[]} indexes The indexes of elements to remove.
	     * @returns {Array} Returns `array`.
	     */
	    function basePullAt(array, indexes) {
	      var length = array ? indexes.length : 0,
	          lastIndex = length - 1;
	
	      while (length--) {
	        var index = indexes[length];
	        if (length == lastIndex || index !== previous) {
	          var previous = index;
	          if (isIndex(index)) {
	            splice.call(array, index, 1);
	          } else {
	            baseUnset(array, index);
	          }
	        }
	      }
	      return array;
	    }
	
	    /**
	     * The base implementation of `_.random` without support for returning
	     * floating-point numbers.
	     *
	     * @private
	     * @param {number} lower The lower bound.
	     * @param {number} upper The upper bound.
	     * @returns {number} Returns the random number.
	     */
	    function baseRandom(lower, upper) {
	      return lower + nativeFloor(nativeRandom() * (upper - lower + 1));
	    }
	
	    /**
	     * The base implementation of `_.range` and `_.rangeRight` which doesn't
	     * coerce arguments.
	     *
	     * @private
	     * @param {number} start The start of the range.
	     * @param {number} end The end of the range.
	     * @param {number} step The value to increment or decrement by.
	     * @param {boolean} [fromRight] Specify iterating from right to left.
	     * @returns {Array} Returns the range of numbers.
	     */
	    function baseRange(start, end, step, fromRight) {
	      var index = -1,
	          length = nativeMax(nativeCeil((end - start) / (step || 1)), 0),
	          result = Array(length);
	
	      while (length--) {
	        result[fromRight ? length : ++index] = start;
	        start += step;
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.repeat` which doesn't coerce arguments.
	     *
	     * @private
	     * @param {string} string The string to repeat.
	     * @param {number} n The number of times to repeat the string.
	     * @returns {string} Returns the repeated string.
	     */
	    function baseRepeat(string, n) {
	      var result = '';
	      if (!string || n < 1 || n > MAX_SAFE_INTEGER) {
	        return result;
	      }
	      // Leverage the exponentiation by squaring algorithm for a faster repeat.
	      // See https://en.wikipedia.org/wiki/Exponentiation_by_squaring for more details.
	      do {
	        if (n % 2) {
	          result += string;
	        }
	        n = nativeFloor(n / 2);
	        if (n) {
	          string += string;
	        }
	      } while (n);
	
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.rest` which doesn't validate or coerce arguments.
	     *
	     * @private
	     * @param {Function} func The function to apply a rest parameter to.
	     * @param {number} [start=func.length-1] The start position of the rest parameter.
	     * @returns {Function} Returns the new function.
	     */
	    function baseRest(func, start) {
	      return setToString(overRest(func, start, identity), func + '');
	    }
	
	    /**
	     * The base implementation of `_.sample`.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to sample.
	     * @returns {*} Returns the random element.
	     */
	    function baseSample(collection) {
	      return arraySample(values(collection));
	    }
	
	    /**
	     * The base implementation of `_.sampleSize` without param guards.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to sample.
	     * @param {number} n The number of elements to sample.
	     * @returns {Array} Returns the random elements.
	     */
	    function baseSampleSize(collection, n) {
	      var array = values(collection);
	      return shuffleSelf(array, baseClamp(n, 0, array.length));
	    }
	
	    /**
	     * The base implementation of `_.set`.
	     *
	     * @private
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The path of the property to set.
	     * @param {*} value The value to set.
	     * @param {Function} [customizer] The function to customize path creation.
	     * @returns {Object} Returns `object`.
	     */
	    function baseSet(object, path, value, customizer) {
	      if (!isObject(object)) {
	        return object;
	      }
	      path = castPath(path, object);
	
	      var index = -1,
	          length = path.length,
	          lastIndex = length - 1,
	          nested = object;
	
	      while (nested != null && ++index < length) {
	        var key = toKey(path[index]),
	            newValue = value;
	
	        if (index != lastIndex) {
	          var objValue = nested[key];
	          newValue = customizer ? customizer(objValue, key, nested) : undefined;
	          if (newValue === undefined) {
	            newValue = isObject(objValue)
	              ? objValue
	              : (isIndex(path[index + 1]) ? [] : {});
	          }
	        }
	        assignValue(nested, key, newValue);
	        nested = nested[key];
	      }
	      return object;
	    }
	
	    /**
	     * The base implementation of `setData` without support for hot loop shorting.
	     *
	     * @private
	     * @param {Function} func The function to associate metadata with.
	     * @param {*} data The metadata.
	     * @returns {Function} Returns `func`.
	     */
	    var baseSetData = !metaMap ? identity : function(func, data) {
	      metaMap.set(func, data);
	      return func;
	    };
	
	    /**
	     * The base implementation of `setToString` without support for hot loop shorting.
	     *
	     * @private
	     * @param {Function} func The function to modify.
	     * @param {Function} string The `toString` result.
	     * @returns {Function} Returns `func`.
	     */
	    var baseSetToString = !defineProperty ? identity : function(func, string) {
	      return defineProperty(func, 'toString', {
	        'configurable': true,
	        'enumerable': false,
	        'value': constant(string),
	        'writable': true
	      });
	    };
	
	    /**
	     * The base implementation of `_.shuffle`.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to shuffle.
	     * @returns {Array} Returns the new shuffled array.
	     */
	    function baseShuffle(collection) {
	      return shuffleSelf(values(collection));
	    }
	
	    /**
	     * The base implementation of `_.slice` without an iteratee call guard.
	     *
	     * @private
	     * @param {Array} array The array to slice.
	     * @param {number} [start=0] The start position.
	     * @param {number} [end=array.length] The end position.
	     * @returns {Array} Returns the slice of `array`.
	     */
	    function baseSlice(array, start, end) {
	      var index = -1,
	          length = array.length;
	
	      if (start < 0) {
	        start = -start > length ? 0 : (length + start);
	      }
	      end = end > length ? length : end;
	      if (end < 0) {
	        end += length;
	      }
	      length = start > end ? 0 : ((end - start) >>> 0);
	      start >>>= 0;
	
	      var result = Array(length);
	      while (++index < length) {
	        result[index] = array[index + start];
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.some` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} predicate The function invoked per iteration.
	     * @returns {boolean} Returns `true` if any element passes the predicate check,
	     *  else `false`.
	     */
	    function baseSome(collection, predicate) {
	      var result;
	
	      baseEach(collection, function(value, index, collection) {
	        result = predicate(value, index, collection);
	        return !result;
	      });
	      return !!result;
	    }
	
	    /**
	     * The base implementation of `_.sortedIndex` and `_.sortedLastIndex` which
	     * performs a binary search of `array` to determine the index at which `value`
	     * should be inserted into `array` in order to maintain its sort order.
	     *
	     * @private
	     * @param {Array} array The sorted array to inspect.
	     * @param {*} value The value to evaluate.
	     * @param {boolean} [retHighest] Specify returning the highest qualified index.
	     * @returns {number} Returns the index at which `value` should be inserted
	     *  into `array`.
	     */
	    function baseSortedIndex(array, value, retHighest) {
	      var low = 0,
	          high = array == null ? low : array.length;
	
	      if (typeof value == 'number' && value === value && high <= HALF_MAX_ARRAY_LENGTH) {
	        while (low < high) {
	          var mid = (low + high) >>> 1,
	              computed = array[mid];
	
	          if (computed !== null && !isSymbol(computed) &&
	              (retHighest ? (computed <= value) : (computed < value))) {
	            low = mid + 1;
	          } else {
	            high = mid;
	          }
	        }
	        return high;
	      }
	      return baseSortedIndexBy(array, value, identity, retHighest);
	    }
	
	    /**
	     * The base implementation of `_.sortedIndexBy` and `_.sortedLastIndexBy`
	     * which invokes `iteratee` for `value` and each element of `array` to compute
	     * their sort ranking. The iteratee is invoked with one argument; (value).
	     *
	     * @private
	     * @param {Array} array The sorted array to inspect.
	     * @param {*} value The value to evaluate.
	     * @param {Function} iteratee The iteratee invoked per element.
	     * @param {boolean} [retHighest] Specify returning the highest qualified index.
	     * @returns {number} Returns the index at which `value` should be inserted
	     *  into `array`.
	     */
	    function baseSortedIndexBy(array, value, iteratee, retHighest) {
	      value = iteratee(value);
	
	      var low = 0,
	          high = array == null ? 0 : array.length,
	          valIsNaN = value !== value,
	          valIsNull = value === null,
	          valIsSymbol = isSymbol(value),
	          valIsUndefined = value === undefined;
	
	      while (low < high) {
	        var mid = nativeFloor((low + high) / 2),
	            computed = iteratee(array[mid]),
	            othIsDefined = computed !== undefined,
	            othIsNull = computed === null,
	            othIsReflexive = computed === computed,
	            othIsSymbol = isSymbol(computed);
	
	        if (valIsNaN) {
	          var setLow = retHighest || othIsReflexive;
	        } else if (valIsUndefined) {
	          setLow = othIsReflexive && (retHighest || othIsDefined);
	        } else if (valIsNull) {
	          setLow = othIsReflexive && othIsDefined && (retHighest || !othIsNull);
	        } else if (valIsSymbol) {
	          setLow = othIsReflexive && othIsDefined && !othIsNull && (retHighest || !othIsSymbol);
	        } else if (othIsNull || othIsSymbol) {
	          setLow = false;
	        } else {
	          setLow = retHighest ? (computed <= value) : (computed < value);
	        }
	        if (setLow) {
	          low = mid + 1;
	        } else {
	          high = mid;
	        }
	      }
	      return nativeMin(high, MAX_ARRAY_INDEX);
	    }
	
	    /**
	     * The base implementation of `_.sortedUniq` and `_.sortedUniqBy` without
	     * support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array} array The array to inspect.
	     * @param {Function} [iteratee] The iteratee invoked per element.
	     * @returns {Array} Returns the new duplicate free array.
	     */
	    function baseSortedUniq(array, iteratee) {
	      var index = -1,
	          length = array.length,
	          resIndex = 0,
	          result = [];
	
	      while (++index < length) {
	        var value = array[index],
	            computed = iteratee ? iteratee(value) : value;
	
	        if (!index || !eq(computed, seen)) {
	          var seen = computed;
	          result[resIndex++] = value === 0 ? 0 : value;
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.toNumber` which doesn't ensure correct
	     * conversions of binary, hexadecimal, or octal string values.
	     *
	     * @private
	     * @param {*} value The value to process.
	     * @returns {number} Returns the number.
	     */
	    function baseToNumber(value) {
	      if (typeof value == 'number') {
	        return value;
	      }
	      if (isSymbol(value)) {
	        return NAN;
	      }
	      return +value;
	    }
	
	    /**
	     * The base implementation of `_.toString` which doesn't convert nullish
	     * values to empty strings.
	     *
	     * @private
	     * @param {*} value The value to process.
	     * @returns {string} Returns the string.
	     */
	    function baseToString(value) {
	      // Exit early for strings to avoid a performance hit in some environments.
	      if (typeof value == 'string') {
	        return value;
	      }
	      if (isArray(value)) {
	        // Recursively convert values (susceptible to call stack limits).
	        return arrayMap(value, baseToString) + '';
	      }
	      if (isSymbol(value)) {
	        return symbolToString ? symbolToString.call(value) : '';
	      }
	      var result = (value + '');
	      return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
	    }
	
	    /**
	     * The base implementation of `_.uniqBy` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array} array The array to inspect.
	     * @param {Function} [iteratee] The iteratee invoked per element.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new duplicate free array.
	     */
	    function baseUniq(array, iteratee, comparator) {
	      var index = -1,
	          includes = arrayIncludes,
	          length = array.length,
	          isCommon = true,
	          result = [],
	          seen = result;
	
	      if (comparator) {
	        isCommon = false;
	        includes = arrayIncludesWith;
	      }
	      else if (length >= LARGE_ARRAY_SIZE) {
	        var set = iteratee ? null : createSet(array);
	        if (set) {
	          return setToArray(set);
	        }
	        isCommon = false;
	        includes = cacheHas;
	        seen = new SetCache;
	      }
	      else {
	        seen = iteratee ? [] : result;
	      }
	      outer:
	      while (++index < length) {
	        var value = array[index],
	            computed = iteratee ? iteratee(value) : value;
	
	        value = (comparator || value !== 0) ? value : 0;
	        if (isCommon && computed === computed) {
	          var seenIndex = seen.length;
	          while (seenIndex--) {
	            if (seen[seenIndex] === computed) {
	              continue outer;
	            }
	          }
	          if (iteratee) {
	            seen.push(computed);
	          }
	          result.push(value);
	        }
	        else if (!includes(seen, computed, comparator)) {
	          if (seen !== result) {
	            seen.push(computed);
	          }
	          result.push(value);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.unset`.
	     *
	     * @private
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The property path to unset.
	     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
	     */
	    function baseUnset(object, path) {
	      path = castPath(path, object);
	      object = parent(object, path);
	      return object == null || delete object[toKey(last(path))];
	    }
	
	    /**
	     * The base implementation of `_.update`.
	     *
	     * @private
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The path of the property to update.
	     * @param {Function} updater The function to produce the updated value.
	     * @param {Function} [customizer] The function to customize path creation.
	     * @returns {Object} Returns `object`.
	     */
	    function baseUpdate(object, path, updater, customizer) {
	      return baseSet(object, path, updater(baseGet(object, path)), customizer);
	    }
	
	    /**
	     * The base implementation of methods like `_.dropWhile` and `_.takeWhile`
	     * without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array} array The array to query.
	     * @param {Function} predicate The function invoked per iteration.
	     * @param {boolean} [isDrop] Specify dropping elements instead of taking them.
	     * @param {boolean} [fromRight] Specify iterating from right to left.
	     * @returns {Array} Returns the slice of `array`.
	     */
	    function baseWhile(array, predicate, isDrop, fromRight) {
	      var length = array.length,
	          index = fromRight ? length : -1;
	
	      while ((fromRight ? index-- : ++index < length) &&
	        predicate(array[index], index, array)) {}
	
	      return isDrop
	        ? baseSlice(array, (fromRight ? 0 : index), (fromRight ? index + 1 : length))
	        : baseSlice(array, (fromRight ? index + 1 : 0), (fromRight ? length : index));
	    }
	
	    /**
	     * The base implementation of `wrapperValue` which returns the result of
	     * performing a sequence of actions on the unwrapped `value`, where each
	     * successive action is supplied the return value of the previous.
	     *
	     * @private
	     * @param {*} value The unwrapped value.
	     * @param {Array} actions Actions to perform to resolve the unwrapped value.
	     * @returns {*} Returns the resolved value.
	     */
	    function baseWrapperValue(value, actions) {
	      var result = value;
	      if (result instanceof LazyWrapper) {
	        result = result.value();
	      }
	      return arrayReduce(actions, function(result, action) {
	        return action.func.apply(action.thisArg, arrayPush([result], action.args));
	      }, result);
	    }
	
	    /**
	     * The base implementation of methods like `_.xor`, without support for
	     * iteratee shorthands, that accepts an array of arrays to inspect.
	     *
	     * @private
	     * @param {Array} arrays The arrays to inspect.
	     * @param {Function} [iteratee] The iteratee invoked per element.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new array of values.
	     */
	    function baseXor(arrays, iteratee, comparator) {
	      var length = arrays.length;
	      if (length < 2) {
	        return length ? baseUniq(arrays[0]) : [];
	      }
	      var index = -1,
	          result = Array(length);
	
	      while (++index < length) {
	        var array = arrays[index],
	            othIndex = -1;
	
	        while (++othIndex < length) {
	          if (othIndex != index) {
	            result[index] = baseDifference(result[index] || array, arrays[othIndex], iteratee, comparator);
	          }
	        }
	      }
	      return baseUniq(baseFlatten(result, 1), iteratee, comparator);
	    }
	
	    /**
	     * This base implementation of `_.zipObject` which assigns values using `assignFunc`.
	     *
	     * @private
	     * @param {Array} props The property identifiers.
	     * @param {Array} values The property values.
	     * @param {Function} assignFunc The function to assign values.
	     * @returns {Object} Returns the new object.
	     */
	    function baseZipObject(props, values, assignFunc) {
	      var index = -1,
	          length = props.length,
	          valsLength = values.length,
	          result = {};
	
	      while (++index < length) {
	        var value = index < valsLength ? values[index] : undefined;
	        assignFunc(result, props[index], value);
	      }
	      return result;
	    }
	
	    /**
	     * Casts `value` to an empty array if it's not an array like object.
	     *
	     * @private
	     * @param {*} value The value to inspect.
	     * @returns {Array|Object} Returns the cast array-like object.
	     */
	    function castArrayLikeObject(value) {
	      return isArrayLikeObject(value) ? value : [];
	    }
	
	    /**
	     * Casts `value` to `identity` if it's not a function.
	     *
	     * @private
	     * @param {*} value The value to inspect.
	     * @returns {Function} Returns cast function.
	     */
	    function castFunction(value) {
	      return typeof value == 'function' ? value : identity;
	    }
	
	    /**
	     * Casts `value` to a path array if it's not one.
	     *
	     * @private
	     * @param {*} value The value to inspect.
	     * @param {Object} [object] The object to query keys on.
	     * @returns {Array} Returns the cast property path array.
	     */
	    function castPath(value, object) {
	      if (isArray(value)) {
	        return value;
	      }
	      return isKey(value, object) ? [value] : stringToPath(toString(value));
	    }
	
	    /**
	     * A `baseRest` alias which can be replaced with `identity` by module
	     * replacement plugins.
	     *
	     * @private
	     * @type {Function}
	     * @param {Function} func The function to apply a rest parameter to.
	     * @returns {Function} Returns the new function.
	     */
	    var castRest = baseRest;
	
	    /**
	     * Casts `array` to a slice if it's needed.
	     *
	     * @private
	     * @param {Array} array The array to inspect.
	     * @param {number} start The start position.
	     * @param {number} [end=array.length] The end position.
	     * @returns {Array} Returns the cast slice.
	     */
	    function castSlice(array, start, end) {
	      var length = array.length;
	      end = end === undefined ? length : end;
	      return (!start && end >= length) ? array : baseSlice(array, start, end);
	    }
	
	    /**
	     * A simple wrapper around the global [`clearTimeout`](https://mdn.io/clearTimeout).
	     *
	     * @private
	     * @param {number|Object} id The timer id or timeout object of the timer to clear.
	     */
	    var clearTimeout = ctxClearTimeout || function(id) {
	      return root.clearTimeout(id);
	    };
	
	    /**
	     * Creates a clone of  `buffer`.
	     *
	     * @private
	     * @param {Buffer} buffer The buffer to clone.
	     * @param {boolean} [isDeep] Specify a deep clone.
	     * @returns {Buffer} Returns the cloned buffer.
	     */
	    function cloneBuffer(buffer, isDeep) {
	      if (isDeep) {
	        return buffer.slice();
	      }
	      var length = buffer.length,
	          result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);
	
	      buffer.copy(result);
	      return result;
	    }
	
	    /**
	     * Creates a clone of `arrayBuffer`.
	     *
	     * @private
	     * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
	     * @returns {ArrayBuffer} Returns the cloned array buffer.
	     */
	    function cloneArrayBuffer(arrayBuffer) {
	      var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
	      new Uint8Array(result).set(new Uint8Array(arrayBuffer));
	      return result;
	    }
	
	    /**
	     * Creates a clone of `dataView`.
	     *
	     * @private
	     * @param {Object} dataView The data view to clone.
	     * @param {boolean} [isDeep] Specify a deep clone.
	     * @returns {Object} Returns the cloned data view.
	     */
	    function cloneDataView(dataView, isDeep) {
	      var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
	      return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
	    }
	
	    /**
	     * Creates a clone of `regexp`.
	     *
	     * @private
	     * @param {Object} regexp The regexp to clone.
	     * @returns {Object} Returns the cloned regexp.
	     */
	    function cloneRegExp(regexp) {
	      var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
	      result.lastIndex = regexp.lastIndex;
	      return result;
	    }
	
	    /**
	     * Creates a clone of the `symbol` object.
	     *
	     * @private
	     * @param {Object} symbol The symbol object to clone.
	     * @returns {Object} Returns the cloned symbol object.
	     */
	    function cloneSymbol(symbol) {
	      return symbolValueOf ? Object(symbolValueOf.call(symbol)) : {};
	    }
	
	    /**
	     * Creates a clone of `typedArray`.
	     *
	     * @private
	     * @param {Object} typedArray The typed array to clone.
	     * @param {boolean} [isDeep] Specify a deep clone.
	     * @returns {Object} Returns the cloned typed array.
	     */
	    function cloneTypedArray(typedArray, isDeep) {
	      var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
	      return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
	    }
	
	    /**
	     * Compares values to sort them in ascending order.
	     *
	     * @private
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {number} Returns the sort order indicator for `value`.
	     */
	    function compareAscending(value, other) {
	      if (value !== other) {
	        var valIsDefined = value !== undefined,
	            valIsNull = value === null,
	            valIsReflexive = value === value,
	            valIsSymbol = isSymbol(value);
	
	        var othIsDefined = other !== undefined,
	            othIsNull = other === null,
	            othIsReflexive = other === other,
	            othIsSymbol = isSymbol(other);
	
	        if ((!othIsNull && !othIsSymbol && !valIsSymbol && value > other) ||
	            (valIsSymbol && othIsDefined && othIsReflexive && !othIsNull && !othIsSymbol) ||
	            (valIsNull && othIsDefined && othIsReflexive) ||
	            (!valIsDefined && othIsReflexive) ||
	            !valIsReflexive) {
	          return 1;
	        }
	        if ((!valIsNull && !valIsSymbol && !othIsSymbol && value < other) ||
	            (othIsSymbol && valIsDefined && valIsReflexive && !valIsNull && !valIsSymbol) ||
	            (othIsNull && valIsDefined && valIsReflexive) ||
	            (!othIsDefined && valIsReflexive) ||
	            !othIsReflexive) {
	          return -1;
	        }
	      }
	      return 0;
	    }
	
	    /**
	     * Used by `_.orderBy` to compare multiple properties of a value to another
	     * and stable sort them.
	     *
	     * If `orders` is unspecified, all values are sorted in ascending order. Otherwise,
	     * specify an order of "desc" for descending or "asc" for ascending sort order
	     * of corresponding values.
	     *
	     * @private
	     * @param {Object} object The object to compare.
	     * @param {Object} other The other object to compare.
	     * @param {boolean[]|string[]} orders The order to sort by for each property.
	     * @returns {number} Returns the sort order indicator for `object`.
	     */
	    function compareMultiple(object, other, orders) {
	      var index = -1,
	          objCriteria = object.criteria,
	          othCriteria = other.criteria,
	          length = objCriteria.length,
	          ordersLength = orders.length;
	
	      while (++index < length) {
	        var result = compareAscending(objCriteria[index], othCriteria[index]);
	        if (result) {
	          if (index >= ordersLength) {
	            return result;
	          }
	          var order = orders[index];
	          return result * (order == 'desc' ? -1 : 1);
	        }
	      }
	      // Fixes an `Array#sort` bug in the JS engine embedded in Adobe applications
	      // that causes it, under certain circumstances, to provide the same value for
	      // `object` and `other`. See https://github.com/jashkenas/underscore/pull/1247
	      // for more details.
	      //
	      // This also ensures a stable sort in V8 and other engines.
	      // See https://bugs.chromium.org/p/v8/issues/detail?id=90 for more details.
	      return object.index - other.index;
	    }
	
	    /**
	     * Creates an array that is the composition of partially applied arguments,
	     * placeholders, and provided arguments into a single array of arguments.
	     *
	     * @private
	     * @param {Array} args The provided arguments.
	     * @param {Array} partials The arguments to prepend to those provided.
	     * @param {Array} holders The `partials` placeholder indexes.
	     * @params {boolean} [isCurried] Specify composing for a curried function.
	     * @returns {Array} Returns the new array of composed arguments.
	     */
	    function composeArgs(args, partials, holders, isCurried) {
	      var argsIndex = -1,
	          argsLength = args.length,
	          holdersLength = holders.length,
	          leftIndex = -1,
	          leftLength = partials.length,
	          rangeLength = nativeMax(argsLength - holdersLength, 0),
	          result = Array(leftLength + rangeLength),
	          isUncurried = !isCurried;
	
	      while (++leftIndex < leftLength) {
	        result[leftIndex] = partials[leftIndex];
	      }
	      while (++argsIndex < holdersLength) {
	        if (isUncurried || argsIndex < argsLength) {
	          result[holders[argsIndex]] = args[argsIndex];
	        }
	      }
	      while (rangeLength--) {
	        result[leftIndex++] = args[argsIndex++];
	      }
	      return result;
	    }
	
	    /**
	     * This function is like `composeArgs` except that the arguments composition
	     * is tailored for `_.partialRight`.
	     *
	     * @private
	     * @param {Array} args The provided arguments.
	     * @param {Array} partials The arguments to append to those provided.
	     * @param {Array} holders The `partials` placeholder indexes.
	     * @params {boolean} [isCurried] Specify composing for a curried function.
	     * @returns {Array} Returns the new array of composed arguments.
	     */
	    function composeArgsRight(args, partials, holders, isCurried) {
	      var argsIndex = -1,
	          argsLength = args.length,
	          holdersIndex = -1,
	          holdersLength = holders.length,
	          rightIndex = -1,
	          rightLength = partials.length,
	          rangeLength = nativeMax(argsLength - holdersLength, 0),
	          result = Array(rangeLength + rightLength),
	          isUncurried = !isCurried;
	
	      while (++argsIndex < rangeLength) {
	        result[argsIndex] = args[argsIndex];
	      }
	      var offset = argsIndex;
	      while (++rightIndex < rightLength) {
	        result[offset + rightIndex] = partials[rightIndex];
	      }
	      while (++holdersIndex < holdersLength) {
	        if (isUncurried || argsIndex < argsLength) {
	          result[offset + holders[holdersIndex]] = args[argsIndex++];
	        }
	      }
	      return result;
	    }
	
	    /**
	     * Copies the values of `source` to `array`.
	     *
	     * @private
	     * @param {Array} source The array to copy values from.
	     * @param {Array} [array=[]] The array to copy values to.
	     * @returns {Array} Returns `array`.
	     */
	    function copyArray(source, array) {
	      var index = -1,
	          length = source.length;
	
	      array || (array = Array(length));
	      while (++index < length) {
	        array[index] = source[index];
	      }
	      return array;
	    }
	
	    /**
	     * Copies properties of `source` to `object`.
	     *
	     * @private
	     * @param {Object} source The object to copy properties from.
	     * @param {Array} props The property identifiers to copy.
	     * @param {Object} [object={}] The object to copy properties to.
	     * @param {Function} [customizer] The function to customize copied values.
	     * @returns {Object} Returns `object`.
	     */
	    function copyObject(source, props, object, customizer) {
	      var isNew = !object;
	      object || (object = {});
	
	      var index = -1,
	          length = props.length;
	
	      while (++index < length) {
	        var key = props[index];
	
	        var newValue = customizer
	          ? customizer(object[key], source[key], key, object, source)
	          : undefined;
	
	        if (newValue === undefined) {
	          newValue = source[key];
	        }
	        if (isNew) {
	          baseAssignValue(object, key, newValue);
	        } else {
	          assignValue(object, key, newValue);
	        }
	      }
	      return object;
	    }
	
	    /**
	     * Copies own symbols of `source` to `object`.
	     *
	     * @private
	     * @param {Object} source The object to copy symbols from.
	     * @param {Object} [object={}] The object to copy symbols to.
	     * @returns {Object} Returns `object`.
	     */
	    function copySymbols(source, object) {
	      return copyObject(source, getSymbols(source), object);
	    }
	
	    /**
	     * Copies own and inherited symbols of `source` to `object`.
	     *
	     * @private
	     * @param {Object} source The object to copy symbols from.
	     * @param {Object} [object={}] The object to copy symbols to.
	     * @returns {Object} Returns `object`.
	     */
	    function copySymbolsIn(source, object) {
	      return copyObject(source, getSymbolsIn(source), object);
	    }
	
	    /**
	     * Creates a function like `_.groupBy`.
	     *
	     * @private
	     * @param {Function} setter The function to set accumulator values.
	     * @param {Function} [initializer] The accumulator object initializer.
	     * @returns {Function} Returns the new aggregator function.
	     */
	    function createAggregator(setter, initializer) {
	      return function(collection, iteratee) {
	        var func = isArray(collection) ? arrayAggregator : baseAggregator,
	            accumulator = initializer ? initializer() : {};
	
	        return func(collection, setter, getIteratee(iteratee, 2), accumulator);
	      };
	    }
	
	    /**
	     * Creates a function like `_.assign`.
	     *
	     * @private
	     * @param {Function} assigner The function to assign values.
	     * @returns {Function} Returns the new assigner function.
	     */
	    function createAssigner(assigner) {
	      return baseRest(function(object, sources) {
	        var index = -1,
	            length = sources.length,
	            customizer = length > 1 ? sources[length - 1] : undefined,
	            guard = length > 2 ? sources[2] : undefined;
	
	        customizer = (assigner.length > 3 && typeof customizer == 'function')
	          ? (length--, customizer)
	          : undefined;
	
	        if (guard && isIterateeCall(sources[0], sources[1], guard)) {
	          customizer = length < 3 ? undefined : customizer;
	          length = 1;
	        }
	        object = Object(object);
	        while (++index < length) {
	          var source = sources[index];
	          if (source) {
	            assigner(object, source, index, customizer);
	          }
	        }
	        return object;
	      });
	    }
	
	    /**
	     * Creates a `baseEach` or `baseEachRight` function.
	     *
	     * @private
	     * @param {Function} eachFunc The function to iterate over a collection.
	     * @param {boolean} [fromRight] Specify iterating from right to left.
	     * @returns {Function} Returns the new base function.
	     */
	    function createBaseEach(eachFunc, fromRight) {
	      return function(collection, iteratee) {
	        if (collection == null) {
	          return collection;
	        }
	        if (!isArrayLike(collection)) {
	          return eachFunc(collection, iteratee);
	        }
	        var length = collection.length,
	            index = fromRight ? length : -1,
	            iterable = Object(collection);
	
	        while ((fromRight ? index-- : ++index < length)) {
	          if (iteratee(iterable[index], index, iterable) === false) {
	            break;
	          }
	        }
	        return collection;
	      };
	    }
	
	    /**
	     * Creates a base function for methods like `_.forIn` and `_.forOwn`.
	     *
	     * @private
	     * @param {boolean} [fromRight] Specify iterating from right to left.
	     * @returns {Function} Returns the new base function.
	     */
	    function createBaseFor(fromRight) {
	      return function(object, iteratee, keysFunc) {
	        var index = -1,
	            iterable = Object(object),
	            props = keysFunc(object),
	            length = props.length;
	
	        while (length--) {
	          var key = props[fromRight ? length : ++index];
	          if (iteratee(iterable[key], key, iterable) === false) {
	            break;
	          }
	        }
	        return object;
	      };
	    }
	
	    /**
	     * Creates a function that wraps `func` to invoke it with the optional `this`
	     * binding of `thisArg`.
	     *
	     * @private
	     * @param {Function} func The function to wrap.
	     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	     * @param {*} [thisArg] The `this` binding of `func`.
	     * @returns {Function} Returns the new wrapped function.
	     */
	    function createBind(func, bitmask, thisArg) {
	      var isBind = bitmask & WRAP_BIND_FLAG,
	          Ctor = createCtor(func);
	
	      function wrapper() {
	        var fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
	        return fn.apply(isBind ? thisArg : this, arguments);
	      }
	      return wrapper;
	    }
	
	    /**
	     * Creates a function like `_.lowerFirst`.
	     *
	     * @private
	     * @param {string} methodName The name of the `String` case method to use.
	     * @returns {Function} Returns the new case function.
	     */
	    function createCaseFirst(methodName) {
	      return function(string) {
	        string = toString(string);
	
	        var strSymbols = hasUnicode(string)
	          ? stringToArray(string)
	          : undefined;
	
	        var chr = strSymbols
	          ? strSymbols[0]
	          : string.charAt(0);
	
	        var trailing = strSymbols
	          ? castSlice(strSymbols, 1).join('')
	          : string.slice(1);
	
	        return chr[methodName]() + trailing;
	      };
	    }
	
	    /**
	     * Creates a function like `_.camelCase`.
	     *
	     * @private
	     * @param {Function} callback The function to combine each word.
	     * @returns {Function} Returns the new compounder function.
	     */
	    function createCompounder(callback) {
	      return function(string) {
	        return arrayReduce(words(deburr(string).replace(reApos, '')), callback, '');
	      };
	    }
	
	    /**
	     * Creates a function that produces an instance of `Ctor` regardless of
	     * whether it was invoked as part of a `new` expression or by `call` or `apply`.
	     *
	     * @private
	     * @param {Function} Ctor The constructor to wrap.
	     * @returns {Function} Returns the new wrapped function.
	     */
	    function createCtor(Ctor) {
	      return function() {
	        // Use a `switch` statement to work with class constructors. See
	        // http://ecma-international.org/ecma-262/7.0/#sec-ecmascript-function-objects-call-thisargument-argumentslist
	        // for more details.
	        var args = arguments;
	        switch (args.length) {
	          case 0: return new Ctor;
	          case 1: return new Ctor(args[0]);
	          case 2: return new Ctor(args[0], args[1]);
	          case 3: return new Ctor(args[0], args[1], args[2]);
	          case 4: return new Ctor(args[0], args[1], args[2], args[3]);
	          case 5: return new Ctor(args[0], args[1], args[2], args[3], args[4]);
	          case 6: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5]);
	          case 7: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5], args[6]);
	        }
	        var thisBinding = baseCreate(Ctor.prototype),
	            result = Ctor.apply(thisBinding, args);
	
	        // Mimic the constructor's `return` behavior.
	        // See https://es5.github.io/#x13.2.2 for more details.
	        return isObject(result) ? result : thisBinding;
	      };
	    }
	
	    /**
	     * Creates a function that wraps `func` to enable currying.
	     *
	     * @private
	     * @param {Function} func The function to wrap.
	     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	     * @param {number} arity The arity of `func`.
	     * @returns {Function} Returns the new wrapped function.
	     */
	    function createCurry(func, bitmask, arity) {
	      var Ctor = createCtor(func);
	
	      function wrapper() {
	        var length = arguments.length,
	            args = Array(length),
	            index = length,
	            placeholder = getHolder(wrapper);
	
	        while (index--) {
	          args[index] = arguments[index];
	        }
	        var holders = (length < 3 && args[0] !== placeholder && args[length - 1] !== placeholder)
	          ? []
	          : replaceHolders(args, placeholder);
	
	        length -= holders.length;
	        if (length < arity) {
	          return createRecurry(
	            func, bitmask, createHybrid, wrapper.placeholder, undefined,
	            args, holders, undefined, undefined, arity - length);
	        }
	        var fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
	        return apply(fn, this, args);
	      }
	      return wrapper;
	    }
	
	    /**
	     * Creates a `_.find` or `_.findLast` function.
	     *
	     * @private
	     * @param {Function} findIndexFunc The function to find the collection index.
	     * @returns {Function} Returns the new find function.
	     */
	    function createFind(findIndexFunc) {
	      return function(collection, predicate, fromIndex) {
	        var iterable = Object(collection);
	        if (!isArrayLike(collection)) {
	          var iteratee = getIteratee(predicate, 3);
	          collection = keys(collection);
	          predicate = function(key) { return iteratee(iterable[key], key, iterable); };
	        }
	        var index = findIndexFunc(collection, predicate, fromIndex);
	        return index > -1 ? iterable[iteratee ? collection[index] : index] : undefined;
	      };
	    }
	
	    /**
	     * Creates a `_.flow` or `_.flowRight` function.
	     *
	     * @private
	     * @param {boolean} [fromRight] Specify iterating from right to left.
	     * @returns {Function} Returns the new flow function.
	     */
	    function createFlow(fromRight) {
	      return flatRest(function(funcs) {
	        var length = funcs.length,
	            index = length,
	            prereq = LodashWrapper.prototype.thru;
	
	        if (fromRight) {
	          funcs.reverse();
	        }
	        while (index--) {
	          var func = funcs[index];
	          if (typeof func != 'function') {
	            throw new TypeError(FUNC_ERROR_TEXT);
	          }
	          if (prereq && !wrapper && getFuncName(func) == 'wrapper') {
	            var wrapper = new LodashWrapper([], true);
	          }
	        }
	        index = wrapper ? index : length;
	        while (++index < length) {
	          func = funcs[index];
	
	          var funcName = getFuncName(func),
	              data = funcName == 'wrapper' ? getData(func) : undefined;
	
	          if (data && isLaziable(data[0]) &&
	                data[1] == (WRAP_ARY_FLAG | WRAP_CURRY_FLAG | WRAP_PARTIAL_FLAG | WRAP_REARG_FLAG) &&
	                !data[4].length && data[9] == 1
	              ) {
	            wrapper = wrapper[getFuncName(data[0])].apply(wrapper, data[3]);
	          } else {
	            wrapper = (func.length == 1 && isLaziable(func))
	              ? wrapper[funcName]()
	              : wrapper.thru(func);
	          }
	        }
	        return function() {
	          var args = arguments,
	              value = args[0];
	
	          if (wrapper && args.length == 1 && isArray(value)) {
	            return wrapper.plant(value).value();
	          }
	          var index = 0,
	              result = length ? funcs[index].apply(this, args) : value;
	
	          while (++index < length) {
	            result = funcs[index].call(this, result);
	          }
	          return result;
	        };
	      });
	    }
	
	    /**
	     * Creates a function that wraps `func` to invoke it with optional `this`
	     * binding of `thisArg`, partial application, and currying.
	     *
	     * @private
	     * @param {Function|string} func The function or method name to wrap.
	     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	     * @param {*} [thisArg] The `this` binding of `func`.
	     * @param {Array} [partials] The arguments to prepend to those provided to
	     *  the new function.
	     * @param {Array} [holders] The `partials` placeholder indexes.
	     * @param {Array} [partialsRight] The arguments to append to those provided
	     *  to the new function.
	     * @param {Array} [holdersRight] The `partialsRight` placeholder indexes.
	     * @param {Array} [argPos] The argument positions of the new function.
	     * @param {number} [ary] The arity cap of `func`.
	     * @param {number} [arity] The arity of `func`.
	     * @returns {Function} Returns the new wrapped function.
	     */
	    function createHybrid(func, bitmask, thisArg, partials, holders, partialsRight, holdersRight, argPos, ary, arity) {
	      var isAry = bitmask & WRAP_ARY_FLAG,
	          isBind = bitmask & WRAP_BIND_FLAG,
	          isBindKey = bitmask & WRAP_BIND_KEY_FLAG,
	          isCurried = bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG),
	          isFlip = bitmask & WRAP_FLIP_FLAG,
	          Ctor = isBindKey ? undefined : createCtor(func);
	
	      function wrapper() {
	        var length = arguments.length,
	            args = Array(length),
	            index = length;
	
	        while (index--) {
	          args[index] = arguments[index];
	        }
	        if (isCurried) {
	          var placeholder = getHolder(wrapper),
	              holdersCount = countHolders(args, placeholder);
	        }
	        if (partials) {
	          args = composeArgs(args, partials, holders, isCurried);
	        }
	        if (partialsRight) {
	          args = composeArgsRight(args, partialsRight, holdersRight, isCurried);
	        }
	        length -= holdersCount;
	        if (isCurried && length < arity) {
	          var newHolders = replaceHolders(args, placeholder);
	          return createRecurry(
	            func, bitmask, createHybrid, wrapper.placeholder, thisArg,
	            args, newHolders, argPos, ary, arity - length
	          );
	        }
	        var thisBinding = isBind ? thisArg : this,
	            fn = isBindKey ? thisBinding[func] : func;
	
	        length = args.length;
	        if (argPos) {
	          args = reorder(args, argPos);
	        } else if (isFlip && length > 1) {
	          args.reverse();
	        }
	        if (isAry && ary < length) {
	          args.length = ary;
	        }
	        if (this && this !== root && this instanceof wrapper) {
	          fn = Ctor || createCtor(fn);
	        }
	        return fn.apply(thisBinding, args);
	      }
	      return wrapper;
	    }
	
	    /**
	     * Creates a function like `_.invertBy`.
	     *
	     * @private
	     * @param {Function} setter The function to set accumulator values.
	     * @param {Function} toIteratee The function to resolve iteratees.
	     * @returns {Function} Returns the new inverter function.
	     */
	    function createInverter(setter, toIteratee) {
	      return function(object, iteratee) {
	        return baseInverter(object, setter, toIteratee(iteratee), {});
	      };
	    }
	
	    /**
	     * Creates a function that performs a mathematical operation on two values.
	     *
	     * @private
	     * @param {Function} operator The function to perform the operation.
	     * @param {number} [defaultValue] The value used for `undefined` arguments.
	     * @returns {Function} Returns the new mathematical operation function.
	     */
	    function createMathOperation(operator, defaultValue) {
	      return function(value, other) {
	        var result;
	        if (value === undefined && other === undefined) {
	          return defaultValue;
	        }
	        if (value !== undefined) {
	          result = value;
	        }
	        if (other !== undefined) {
	          if (result === undefined) {
	            return other;
	          }
	          if (typeof value == 'string' || typeof other == 'string') {
	            value = baseToString(value);
	            other = baseToString(other);
	          } else {
	            value = baseToNumber(value);
	            other = baseToNumber(other);
	          }
	          result = operator(value, other);
	        }
	        return result;
	      };
	    }
	
	    /**
	     * Creates a function like `_.over`.
	     *
	     * @private
	     * @param {Function} arrayFunc The function to iterate over iteratees.
	     * @returns {Function} Returns the new over function.
	     */
	    function createOver(arrayFunc) {
	      return flatRest(function(iteratees) {
	        iteratees = arrayMap(iteratees, baseUnary(getIteratee()));
	        return baseRest(function(args) {
	          var thisArg = this;
	          return arrayFunc(iteratees, function(iteratee) {
	            return apply(iteratee, thisArg, args);
	          });
	        });
	      });
	    }
	
	    /**
	     * Creates the padding for `string` based on `length`. The `chars` string
	     * is truncated if the number of characters exceeds `length`.
	     *
	     * @private
	     * @param {number} length The padding length.
	     * @param {string} [chars=' '] The string used as padding.
	     * @returns {string} Returns the padding for `string`.
	     */
	    function createPadding(length, chars) {
	      chars = chars === undefined ? ' ' : baseToString(chars);
	
	      var charsLength = chars.length;
	      if (charsLength < 2) {
	        return charsLength ? baseRepeat(chars, length) : chars;
	      }
	      var result = baseRepeat(chars, nativeCeil(length / stringSize(chars)));
	      return hasUnicode(chars)
	        ? castSlice(stringToArray(result), 0, length).join('')
	        : result.slice(0, length);
	    }
	
	    /**
	     * Creates a function that wraps `func` to invoke it with the `this` binding
	     * of `thisArg` and `partials` prepended to the arguments it receives.
	     *
	     * @private
	     * @param {Function} func The function to wrap.
	     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	     * @param {*} thisArg The `this` binding of `func`.
	     * @param {Array} partials The arguments to prepend to those provided to
	     *  the new function.
	     * @returns {Function} Returns the new wrapped function.
	     */
	    function createPartial(func, bitmask, thisArg, partials) {
	      var isBind = bitmask & WRAP_BIND_FLAG,
	          Ctor = createCtor(func);
	
	      function wrapper() {
	        var argsIndex = -1,
	            argsLength = arguments.length,
	            leftIndex = -1,
	            leftLength = partials.length,
	            args = Array(leftLength + argsLength),
	            fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
	
	        while (++leftIndex < leftLength) {
	          args[leftIndex] = partials[leftIndex];
	        }
	        while (argsLength--) {
	          args[leftIndex++] = arguments[++argsIndex];
	        }
	        return apply(fn, isBind ? thisArg : this, args);
	      }
	      return wrapper;
	    }
	
	    /**
	     * Creates a `_.range` or `_.rangeRight` function.
	     *
	     * @private
	     * @param {boolean} [fromRight] Specify iterating from right to left.
	     * @returns {Function} Returns the new range function.
	     */
	    function createRange(fromRight) {
	      return function(start, end, step) {
	        if (step && typeof step != 'number' && isIterateeCall(start, end, step)) {
	          end = step = undefined;
	        }
	        // Ensure the sign of `-0` is preserved.
	        start = toFinite(start);
	        if (end === undefined) {
	          end = start;
	          start = 0;
	        } else {
	          end = toFinite(end);
	        }
	        step = step === undefined ? (start < end ? 1 : -1) : toFinite(step);
	        return baseRange(start, end, step, fromRight);
	      };
	    }
	
	    /**
	     * Creates a function that performs a relational operation on two values.
	     *
	     * @private
	     * @param {Function} operator The function to perform the operation.
	     * @returns {Function} Returns the new relational operation function.
	     */
	    function createRelationalOperation(operator) {
	      return function(value, other) {
	        if (!(typeof value == 'string' && typeof other == 'string')) {
	          value = toNumber(value);
	          other = toNumber(other);
	        }
	        return operator(value, other);
	      };
	    }
	
	    /**
	     * Creates a function that wraps `func` to continue currying.
	     *
	     * @private
	     * @param {Function} func The function to wrap.
	     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	     * @param {Function} wrapFunc The function to create the `func` wrapper.
	     * @param {*} placeholder The placeholder value.
	     * @param {*} [thisArg] The `this` binding of `func`.
	     * @param {Array} [partials] The arguments to prepend to those provided to
	     *  the new function.
	     * @param {Array} [holders] The `partials` placeholder indexes.
	     * @param {Array} [argPos] The argument positions of the new function.
	     * @param {number} [ary] The arity cap of `func`.
	     * @param {number} [arity] The arity of `func`.
	     * @returns {Function} Returns the new wrapped function.
	     */
	    function createRecurry(func, bitmask, wrapFunc, placeholder, thisArg, partials, holders, argPos, ary, arity) {
	      var isCurry = bitmask & WRAP_CURRY_FLAG,
	          newHolders = isCurry ? holders : undefined,
	          newHoldersRight = isCurry ? undefined : holders,
	          newPartials = isCurry ? partials : undefined,
	          newPartialsRight = isCurry ? undefined : partials;
	
	      bitmask |= (isCurry ? WRAP_PARTIAL_FLAG : WRAP_PARTIAL_RIGHT_FLAG);
	      bitmask &= ~(isCurry ? WRAP_PARTIAL_RIGHT_FLAG : WRAP_PARTIAL_FLAG);
	
	      if (!(bitmask & WRAP_CURRY_BOUND_FLAG)) {
	        bitmask &= ~(WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG);
	      }
	      var newData = [
	        func, bitmask, thisArg, newPartials, newHolders, newPartialsRight,
	        newHoldersRight, argPos, ary, arity
	      ];
	
	      var result = wrapFunc.apply(undefined, newData);
	      if (isLaziable(func)) {
	        setData(result, newData);
	      }
	      result.placeholder = placeholder;
	      return setWrapToString(result, func, bitmask);
	    }
	
	    /**
	     * Creates a function like `_.round`.
	     *
	     * @private
	     * @param {string} methodName The name of the `Math` method to use when rounding.
	     * @returns {Function} Returns the new round function.
	     */
	    function createRound(methodName) {
	      var func = Math[methodName];
	      return function(number, precision) {
	        number = toNumber(number);
	        precision = precision == null ? 0 : nativeMin(toInteger(precision), 292);
	        if (precision) {
	          // Shift with exponential notation to avoid floating-point issues.
	          // See [MDN](https://mdn.io/round#Examples) for more details.
	          var pair = (toString(number) + 'e').split('e'),
	              value = func(pair[0] + 'e' + (+pair[1] + precision));
	
	          pair = (toString(value) + 'e').split('e');
	          return +(pair[0] + 'e' + (+pair[1] - precision));
	        }
	        return func(number);
	      };
	    }
	
	    /**
	     * Creates a set object of `values`.
	     *
	     * @private
	     * @param {Array} values The values to add to the set.
	     * @returns {Object} Returns the new set.
	     */
	    var createSet = !(Set && (1 / setToArray(new Set([,-0]))[1]) == INFINITY) ? noop : function(values) {
	      return new Set(values);
	    };
	
	    /**
	     * Creates a `_.toPairs` or `_.toPairsIn` function.
	     *
	     * @private
	     * @param {Function} keysFunc The function to get the keys of a given object.
	     * @returns {Function} Returns the new pairs function.
	     */
	    function createToPairs(keysFunc) {
	      return function(object) {
	        var tag = getTag(object);
	        if (tag == mapTag) {
	          return mapToArray(object);
	        }
	        if (tag == setTag) {
	          return setToPairs(object);
	        }
	        return baseToPairs(object, keysFunc(object));
	      };
	    }
	
	    /**
	     * Creates a function that either curries or invokes `func` with optional
	     * `this` binding and partially applied arguments.
	     *
	     * @private
	     * @param {Function|string} func The function or method name to wrap.
	     * @param {number} bitmask The bitmask flags.
	     *    1 - `_.bind`
	     *    2 - `_.bindKey`
	     *    4 - `_.curry` or `_.curryRight` of a bound function
	     *    8 - `_.curry`
	     *   16 - `_.curryRight`
	     *   32 - `_.partial`
	     *   64 - `_.partialRight`
	     *  128 - `_.rearg`
	     *  256 - `_.ary`
	     *  512 - `_.flip`
	     * @param {*} [thisArg] The `this` binding of `func`.
	     * @param {Array} [partials] The arguments to be partially applied.
	     * @param {Array} [holders] The `partials` placeholder indexes.
	     * @param {Array} [argPos] The argument positions of the new function.
	     * @param {number} [ary] The arity cap of `func`.
	     * @param {number} [arity] The arity of `func`.
	     * @returns {Function} Returns the new wrapped function.
	     */
	    function createWrap(func, bitmask, thisArg, partials, holders, argPos, ary, arity) {
	      var isBindKey = bitmask & WRAP_BIND_KEY_FLAG;
	      if (!isBindKey && typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      var length = partials ? partials.length : 0;
	      if (!length) {
	        bitmask &= ~(WRAP_PARTIAL_FLAG | WRAP_PARTIAL_RIGHT_FLAG);
	        partials = holders = undefined;
	      }
	      ary = ary === undefined ? ary : nativeMax(toInteger(ary), 0);
	      arity = arity === undefined ? arity : toInteger(arity);
	      length -= holders ? holders.length : 0;
	
	      if (bitmask & WRAP_PARTIAL_RIGHT_FLAG) {
	        var partialsRight = partials,
	            holdersRight = holders;
	
	        partials = holders = undefined;
	      }
	      var data = isBindKey ? undefined : getData(func);
	
	      var newData = [
	        func, bitmask, thisArg, partials, holders, partialsRight, holdersRight,
	        argPos, ary, arity
	      ];
	
	      if (data) {
	        mergeData(newData, data);
	      }
	      func = newData[0];
	      bitmask = newData[1];
	      thisArg = newData[2];
	      partials = newData[3];
	      holders = newData[4];
	      arity = newData[9] = newData[9] === undefined
	        ? (isBindKey ? 0 : func.length)
	        : nativeMax(newData[9] - length, 0);
	
	      if (!arity && bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG)) {
	        bitmask &= ~(WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG);
	      }
	      if (!bitmask || bitmask == WRAP_BIND_FLAG) {
	        var result = createBind(func, bitmask, thisArg);
	      } else if (bitmask == WRAP_CURRY_FLAG || bitmask == WRAP_CURRY_RIGHT_FLAG) {
	        result = createCurry(func, bitmask, arity);
	      } else if ((bitmask == WRAP_PARTIAL_FLAG || bitmask == (WRAP_BIND_FLAG | WRAP_PARTIAL_FLAG)) && !holders.length) {
	        result = createPartial(func, bitmask, thisArg, partials);
	      } else {
	        result = createHybrid.apply(undefined, newData);
	      }
	      var setter = data ? baseSetData : setData;
	      return setWrapToString(setter(result, newData), func, bitmask);
	    }
	
	    /**
	     * Used by `_.defaults` to customize its `_.assignIn` use to assign properties
	     * of source objects to the destination object for all destination properties
	     * that resolve to `undefined`.
	     *
	     * @private
	     * @param {*} objValue The destination value.
	     * @param {*} srcValue The source value.
	     * @param {string} key The key of the property to assign.
	     * @param {Object} object The parent object of `objValue`.
	     * @returns {*} Returns the value to assign.
	     */
	    function customDefaultsAssignIn(objValue, srcValue, key, object) {
	      if (objValue === undefined ||
	          (eq(objValue, objectProto[key]) && !hasOwnProperty.call(object, key))) {
	        return srcValue;
	      }
	      return objValue;
	    }
	
	    /**
	     * Used by `_.defaultsDeep` to customize its `_.merge` use to merge source
	     * objects into destination objects that are passed thru.
	     *
	     * @private
	     * @param {*} objValue The destination value.
	     * @param {*} srcValue The source value.
	     * @param {string} key The key of the property to merge.
	     * @param {Object} object The parent object of `objValue`.
	     * @param {Object} source The parent object of `srcValue`.
	     * @param {Object} [stack] Tracks traversed source values and their merged
	     *  counterparts.
	     * @returns {*} Returns the value to assign.
	     */
	    function customDefaultsMerge(objValue, srcValue, key, object, source, stack) {
	      if (isObject(objValue) && isObject(srcValue)) {
	        // Recursively merge objects and arrays (susceptible to call stack limits).
	        stack.set(srcValue, objValue);
	        baseMerge(objValue, srcValue, undefined, customDefaultsMerge, stack);
	        stack['delete'](srcValue);
	      }
	      return objValue;
	    }
	
	    /**
	     * Used by `_.omit` to customize its `_.cloneDeep` use to only clone plain
	     * objects.
	     *
	     * @private
	     * @param {*} value The value to inspect.
	     * @param {string} key The key of the property to inspect.
	     * @returns {*} Returns the uncloned value or `undefined` to defer cloning to `_.cloneDeep`.
	     */
	    function customOmitClone(value) {
	      return isPlainObject(value) ? undefined : value;
	    }
	
	    /**
	     * A specialized version of `baseIsEqualDeep` for arrays with support for
	     * partial deep comparisons.
	     *
	     * @private
	     * @param {Array} array The array to compare.
	     * @param {Array} other The other array to compare.
	     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	     * @param {Function} customizer The function to customize comparisons.
	     * @param {Function} equalFunc The function to determine equivalents of values.
	     * @param {Object} stack Tracks traversed `array` and `other` objects.
	     * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
	     */
	    function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
	      var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
	          arrLength = array.length,
	          othLength = other.length;
	
	      if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
	        return false;
	      }
	      // Assume cyclic values are equal.
	      var stacked = stack.get(array);
	      if (stacked && stack.get(other)) {
	        return stacked == other;
	      }
	      var index = -1,
	          result = true,
	          seen = (bitmask & COMPARE_UNORDERED_FLAG) ? new SetCache : undefined;
	
	      stack.set(array, other);
	      stack.set(other, array);
	
	      // Ignore non-index properties.
	      while (++index < arrLength) {
	        var arrValue = array[index],
	            othValue = other[index];
	
	        if (customizer) {
	          var compared = isPartial
	            ? customizer(othValue, arrValue, index, other, array, stack)
	            : customizer(arrValue, othValue, index, array, other, stack);
	        }
	        if (compared !== undefined) {
	          if (compared) {
	            continue;
	          }
	          result = false;
	          break;
	        }
	        // Recursively compare arrays (susceptible to call stack limits).
	        if (seen) {
	          if (!arraySome(other, function(othValue, othIndex) {
	                if (!cacheHas(seen, othIndex) &&
	                    (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
	                  return seen.push(othIndex);
	                }
	              })) {
	            result = false;
	            break;
	          }
	        } else if (!(
	              arrValue === othValue ||
	                equalFunc(arrValue, othValue, bitmask, customizer, stack)
	            )) {
	          result = false;
	          break;
	        }
	      }
	      stack['delete'](array);
	      stack['delete'](other);
	      return result;
	    }
	
	    /**
	     * A specialized version of `baseIsEqualDeep` for comparing objects of
	     * the same `toStringTag`.
	     *
	     * **Note:** This function only supports comparing values with tags of
	     * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
	     *
	     * @private
	     * @param {Object} object The object to compare.
	     * @param {Object} other The other object to compare.
	     * @param {string} tag The `toStringTag` of the objects to compare.
	     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	     * @param {Function} customizer The function to customize comparisons.
	     * @param {Function} equalFunc The function to determine equivalents of values.
	     * @param {Object} stack Tracks traversed `object` and `other` objects.
	     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	     */
	    function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
	      switch (tag) {
	        case dataViewTag:
	          if ((object.byteLength != other.byteLength) ||
	              (object.byteOffset != other.byteOffset)) {
	            return false;
	          }
	          object = object.buffer;
	          other = other.buffer;
	
	        case arrayBufferTag:
	          if ((object.byteLength != other.byteLength) ||
	              !equalFunc(new Uint8Array(object), new Uint8Array(other))) {
	            return false;
	          }
	          return true;
	
	        case boolTag:
	        case dateTag:
	        case numberTag:
	          // Coerce booleans to `1` or `0` and dates to milliseconds.
	          // Invalid dates are coerced to `NaN`.
	          return eq(+object, +other);
	
	        case errorTag:
	          return object.name == other.name && object.message == other.message;
	
	        case regexpTag:
	        case stringTag:
	          // Coerce regexes to strings and treat strings, primitives and objects,
	          // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
	          // for more details.
	          return object == (other + '');
	
	        case mapTag:
	          var convert = mapToArray;
	
	        case setTag:
	          var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
	          convert || (convert = setToArray);
	
	          if (object.size != other.size && !isPartial) {
	            return false;
	          }
	          // Assume cyclic values are equal.
	          var stacked = stack.get(object);
	          if (stacked) {
	            return stacked == other;
	          }
	          bitmask |= COMPARE_UNORDERED_FLAG;
	
	          // Recursively compare objects (susceptible to call stack limits).
	          stack.set(object, other);
	          var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
	          stack['delete'](object);
	          return result;
	
	        case symbolTag:
	          if (symbolValueOf) {
	            return symbolValueOf.call(object) == symbolValueOf.call(other);
	          }
	      }
	      return false;
	    }
	
	    /**
	     * A specialized version of `baseIsEqualDeep` for objects with support for
	     * partial deep comparisons.
	     *
	     * @private
	     * @param {Object} object The object to compare.
	     * @param {Object} other The other object to compare.
	     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	     * @param {Function} customizer The function to customize comparisons.
	     * @param {Function} equalFunc The function to determine equivalents of values.
	     * @param {Object} stack Tracks traversed `object` and `other` objects.
	     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	     */
	    function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
	      var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
	          objProps = getAllKeys(object),
	          objLength = objProps.length,
	          othProps = getAllKeys(other),
	          othLength = othProps.length;
	
	      if (objLength != othLength && !isPartial) {
	        return false;
	      }
	      var index = objLength;
	      while (index--) {
	        var key = objProps[index];
	        if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) {
	          return false;
	        }
	      }
	      // Assume cyclic values are equal.
	      var stacked = stack.get(object);
	      if (stacked && stack.get(other)) {
	        return stacked == other;
	      }
	      var result = true;
	      stack.set(object, other);
	      stack.set(other, object);
	
	      var skipCtor = isPartial;
	      while (++index < objLength) {
	        key = objProps[index];
	        var objValue = object[key],
	            othValue = other[key];
	
	        if (customizer) {
	          var compared = isPartial
	            ? customizer(othValue, objValue, key, other, object, stack)
	            : customizer(objValue, othValue, key, object, other, stack);
	        }
	        // Recursively compare objects (susceptible to call stack limits).
	        if (!(compared === undefined
	              ? (objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack))
	              : compared
	            )) {
	          result = false;
	          break;
	        }
	        skipCtor || (skipCtor = key == 'constructor');
	      }
	      if (result && !skipCtor) {
	        var objCtor = object.constructor,
	            othCtor = other.constructor;
	
	        // Non `Object` object instances with different constructors are not equal.
	        if (objCtor != othCtor &&
	            ('constructor' in object && 'constructor' in other) &&
	            !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
	              typeof othCtor == 'function' && othCtor instanceof othCtor)) {
	          result = false;
	        }
	      }
	      stack['delete'](object);
	      stack['delete'](other);
	      return result;
	    }
	
	    /**
	     * A specialized version of `baseRest` which flattens the rest array.
	     *
	     * @private
	     * @param {Function} func The function to apply a rest parameter to.
	     * @returns {Function} Returns the new function.
	     */
	    function flatRest(func) {
	      return setToString(overRest(func, undefined, flatten), func + '');
	    }
	
	    /**
	     * Creates an array of own enumerable property names and symbols of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names and symbols.
	     */
	    function getAllKeys(object) {
	      return baseGetAllKeys(object, keys, getSymbols);
	    }
	
	    /**
	     * Creates an array of own and inherited enumerable property names and
	     * symbols of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names and symbols.
	     */
	    function getAllKeysIn(object) {
	      return baseGetAllKeys(object, keysIn, getSymbolsIn);
	    }
	
	    /**
	     * Gets metadata for `func`.
	     *
	     * @private
	     * @param {Function} func The function to query.
	     * @returns {*} Returns the metadata for `func`.
	     */
	    var getData = !metaMap ? noop : function(func) {
	      return metaMap.get(func);
	    };
	
	    /**
	     * Gets the name of `func`.
	     *
	     * @private
	     * @param {Function} func The function to query.
	     * @returns {string} Returns the function name.
	     */
	    function getFuncName(func) {
	      var result = (func.name + ''),
	          array = realNames[result],
	          length = hasOwnProperty.call(realNames, result) ? array.length : 0;
	
	      while (length--) {
	        var data = array[length],
	            otherFunc = data.func;
	        if (otherFunc == null || otherFunc == func) {
	          return data.name;
	        }
	      }
	      return result;
	    }
	
	    /**
	     * Gets the argument placeholder value for `func`.
	     *
	     * @private
	     * @param {Function} func The function to inspect.
	     * @returns {*} Returns the placeholder value.
	     */
	    function getHolder(func) {
	      var object = hasOwnProperty.call(lodash, 'placeholder') ? lodash : func;
	      return object.placeholder;
	    }
	
	    /**
	     * Gets the appropriate "iteratee" function. If `_.iteratee` is customized,
	     * this function returns the custom method, otherwise it returns `baseIteratee`.
	     * If arguments are provided, the chosen function is invoked with them and
	     * its result is returned.
	     *
	     * @private
	     * @param {*} [value] The value to convert to an iteratee.
	     * @param {number} [arity] The arity of the created iteratee.
	     * @returns {Function} Returns the chosen function or its result.
	     */
	    function getIteratee() {
	      var result = lodash.iteratee || iteratee;
	      result = result === iteratee ? baseIteratee : result;
	      return arguments.length ? result(arguments[0], arguments[1]) : result;
	    }
	
	    /**
	     * Gets the data for `map`.
	     *
	     * @private
	     * @param {Object} map The map to query.
	     * @param {string} key The reference key.
	     * @returns {*} Returns the map data.
	     */
	    function getMapData(map, key) {
	      var data = map.__data__;
	      return isKeyable(key)
	        ? data[typeof key == 'string' ? 'string' : 'hash']
	        : data.map;
	    }
	
	    /**
	     * Gets the property names, values, and compare flags of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the match data of `object`.
	     */
	    function getMatchData(object) {
	      var result = keys(object),
	          length = result.length;
	
	      while (length--) {
	        var key = result[length],
	            value = object[key];
	
	        result[length] = [key, value, isStrictComparable(value)];
	      }
	      return result;
	    }
	
	    /**
	     * Gets the native function at `key` of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {string} key The key of the method to get.
	     * @returns {*} Returns the function if it's native, else `undefined`.
	     */
	    function getNative(object, key) {
	      var value = getValue(object, key);
	      return baseIsNative(value) ? value : undefined;
	    }
	
	    /**
	     * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
	     *
	     * @private
	     * @param {*} value The value to query.
	     * @returns {string} Returns the raw `toStringTag`.
	     */
	    function getRawTag(value) {
	      var isOwn = hasOwnProperty.call(value, symToStringTag),
	          tag = value[symToStringTag];
	
	      try {
	        value[symToStringTag] = undefined;
	        var unmasked = true;
	      } catch (e) {}
	
	      var result = nativeObjectToString.call(value);
	      if (unmasked) {
	        if (isOwn) {
	          value[symToStringTag] = tag;
	        } else {
	          delete value[symToStringTag];
	        }
	      }
	      return result;
	    }
	
	    /**
	     * Creates an array of the own enumerable symbols of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of symbols.
	     */
	    var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
	      if (object == null) {
	        return [];
	      }
	      object = Object(object);
	      return arrayFilter(nativeGetSymbols(object), function(symbol) {
	        return propertyIsEnumerable.call(object, symbol);
	      });
	    };
	
	    /**
	     * Creates an array of the own and inherited enumerable symbols of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of symbols.
	     */
	    var getSymbolsIn = !nativeGetSymbols ? stubArray : function(object) {
	      var result = [];
	      while (object) {
	        arrayPush(result, getSymbols(object));
	        object = getPrototype(object);
	      }
	      return result;
	    };
	
	    /**
	     * Gets the `toStringTag` of `value`.
	     *
	     * @private
	     * @param {*} value The value to query.
	     * @returns {string} Returns the `toStringTag`.
	     */
	    var getTag = baseGetTag;
	
	    // Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
	    if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
	        (Map && getTag(new Map) != mapTag) ||
	        (Promise && getTag(Promise.resolve()) != promiseTag) ||
	        (Set && getTag(new Set) != setTag) ||
	        (WeakMap && getTag(new WeakMap) != weakMapTag)) {
	      getTag = function(value) {
	        var result = baseGetTag(value),
	            Ctor = result == objectTag ? value.constructor : undefined,
	            ctorString = Ctor ? toSource(Ctor) : '';
	
	        if (ctorString) {
	          switch (ctorString) {
	            case dataViewCtorString: return dataViewTag;
	            case mapCtorString: return mapTag;
	            case promiseCtorString: return promiseTag;
	            case setCtorString: return setTag;
	            case weakMapCtorString: return weakMapTag;
	          }
	        }
	        return result;
	      };
	    }
	
	    /**
	     * Gets the view, applying any `transforms` to the `start` and `end` positions.
	     *
	     * @private
	     * @param {number} start The start of the view.
	     * @param {number} end The end of the view.
	     * @param {Array} transforms The transformations to apply to the view.
	     * @returns {Object} Returns an object containing the `start` and `end`
	     *  positions of the view.
	     */
	    function getView(start, end, transforms) {
	      var index = -1,
	          length = transforms.length;
	
	      while (++index < length) {
	        var data = transforms[index],
	            size = data.size;
	
	        switch (data.type) {
	          case 'drop':      start += size; break;
	          case 'dropRight': end -= size; break;
	          case 'take':      end = nativeMin(end, start + size); break;
	          case 'takeRight': start = nativeMax(start, end - size); break;
	        }
	      }
	      return { 'start': start, 'end': end };
	    }
	
	    /**
	     * Extracts wrapper details from the `source` body comment.
	     *
	     * @private
	     * @param {string} source The source to inspect.
	     * @returns {Array} Returns the wrapper details.
	     */
	    function getWrapDetails(source) {
	      var match = source.match(reWrapDetails);
	      return match ? match[1].split(reSplitDetails) : [];
	    }
	
	    /**
	     * Checks if `path` exists on `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path to check.
	     * @param {Function} hasFunc The function to check properties.
	     * @returns {boolean} Returns `true` if `path` exists, else `false`.
	     */
	    function hasPath(object, path, hasFunc) {
	      path = castPath(path, object);
	
	      var index = -1,
	          length = path.length,
	          result = false;
	
	      while (++index < length) {
	        var key = toKey(path[index]);
	        if (!(result = object != null && hasFunc(object, key))) {
	          break;
	        }
	        object = object[key];
	      }
	      if (result || ++index != length) {
	        return result;
	      }
	      length = object == null ? 0 : object.length;
	      return !!length && isLength(length) && isIndex(key, length) &&
	        (isArray(object) || isArguments(object));
	    }
	
	    /**
	     * Initializes an array clone.
	     *
	     * @private
	     * @param {Array} array The array to clone.
	     * @returns {Array} Returns the initialized clone.
	     */
	    function initCloneArray(array) {
	      var length = array.length,
	          result = new array.constructor(length);
	
	      // Add properties assigned by `RegExp#exec`.
	      if (length && typeof array[0] == 'string' && hasOwnProperty.call(array, 'index')) {
	        result.index = array.index;
	        result.input = array.input;
	      }
	      return result;
	    }
	
	    /**
	     * Initializes an object clone.
	     *
	     * @private
	     * @param {Object} object The object to clone.
	     * @returns {Object} Returns the initialized clone.
	     */
	    function initCloneObject(object) {
	      return (typeof object.constructor == 'function' && !isPrototype(object))
	        ? baseCreate(getPrototype(object))
	        : {};
	    }
	
	    /**
	     * Initializes an object clone based on its `toStringTag`.
	     *
	     * **Note:** This function only supports cloning values with tags of
	     * `Boolean`, `Date`, `Error`, `Map`, `Number`, `RegExp`, `Set`, or `String`.
	     *
	     * @private
	     * @param {Object} object The object to clone.
	     * @param {string} tag The `toStringTag` of the object to clone.
	     * @param {boolean} [isDeep] Specify a deep clone.
	     * @returns {Object} Returns the initialized clone.
	     */
	    function initCloneByTag(object, tag, isDeep) {
	      var Ctor = object.constructor;
	      switch (tag) {
	        case arrayBufferTag:
	          return cloneArrayBuffer(object);
	
	        case boolTag:
	        case dateTag:
	          return new Ctor(+object);
	
	        case dataViewTag:
	          return cloneDataView(object, isDeep);
	
	        case float32Tag: case float64Tag:
	        case int8Tag: case int16Tag: case int32Tag:
	        case uint8Tag: case uint8ClampedTag: case uint16Tag: case uint32Tag:
	          return cloneTypedArray(object, isDeep);
	
	        case mapTag:
	          return new Ctor;
	
	        case numberTag:
	        case stringTag:
	          return new Ctor(object);
	
	        case regexpTag:
	          return cloneRegExp(object);
	
	        case setTag:
	          return new Ctor;
	
	        case symbolTag:
	          return cloneSymbol(object);
	      }
	    }
	
	    /**
	     * Inserts wrapper `details` in a comment at the top of the `source` body.
	     *
	     * @private
	     * @param {string} source The source to modify.
	     * @returns {Array} details The details to insert.
	     * @returns {string} Returns the modified source.
	     */
	    function insertWrapDetails(source, details) {
	      var length = details.length;
	      if (!length) {
	        return source;
	      }
	      var lastIndex = length - 1;
	      details[lastIndex] = (length > 1 ? '& ' : '') + details[lastIndex];
	      details = details.join(length > 2 ? ', ' : ' ');
	      return source.replace(reWrapComment, '{\n/* [wrapped with ' + details + '] */\n');
	    }
	
	    /**
	     * Checks if `value` is a flattenable `arguments` object or array.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
	     */
	    function isFlattenable(value) {
	      return isArray(value) || isArguments(value) ||
	        !!(spreadableSymbol && value && value[spreadableSymbol]);
	    }
	
	    /**
	     * Checks if `value` is a valid array-like index.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
	     * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
	     */
	    function isIndex(value, length) {
	      var type = typeof value;
	      length = length == null ? MAX_SAFE_INTEGER : length;
	
	      return !!length &&
	        (type == 'number' ||
	          (type != 'symbol' && reIsUint.test(value))) &&
	            (value > -1 && value % 1 == 0 && value < length);
	    }
	
	    /**
	     * Checks if the given arguments are from an iteratee call.
	     *
	     * @private
	     * @param {*} value The potential iteratee value argument.
	     * @param {*} index The potential iteratee index or key argument.
	     * @param {*} object The potential iteratee object argument.
	     * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
	     *  else `false`.
	     */
	    function isIterateeCall(value, index, object) {
	      if (!isObject(object)) {
	        return false;
	      }
	      var type = typeof index;
	      if (type == 'number'
	            ? (isArrayLike(object) && isIndex(index, object.length))
	            : (type == 'string' && index in object)
	          ) {
	        return eq(object[index], value);
	      }
	      return false;
	    }
	
	    /**
	     * Checks if `value` is a property name and not a property path.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @param {Object} [object] The object to query keys on.
	     * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
	     */
	    function isKey(value, object) {
	      if (isArray(value)) {
	        return false;
	      }
	      var type = typeof value;
	      if (type == 'number' || type == 'symbol' || type == 'boolean' ||
	          value == null || isSymbol(value)) {
	        return true;
	      }
	      return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
	        (object != null && value in Object(object));
	    }
	
	    /**
	     * Checks if `value` is suitable for use as unique object key.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
	     */
	    function isKeyable(value) {
	      var type = typeof value;
	      return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
	        ? (value !== '__proto__')
	        : (value === null);
	    }
	
	    /**
	     * Checks if `func` has a lazy counterpart.
	     *
	     * @private
	     * @param {Function} func The function to check.
	     * @returns {boolean} Returns `true` if `func` has a lazy counterpart,
	     *  else `false`.
	     */
	    function isLaziable(func) {
	      var funcName = getFuncName(func),
	          other = lodash[funcName];
	
	      if (typeof other != 'function' || !(funcName in LazyWrapper.prototype)) {
	        return false;
	      }
	      if (func === other) {
	        return true;
	      }
	      var data = getData(other);
	      return !!data && func === data[0];
	    }
	
	    /**
	     * Checks if `func` has its source masked.
	     *
	     * @private
	     * @param {Function} func The function to check.
	     * @returns {boolean} Returns `true` if `func` is masked, else `false`.
	     */
	    function isMasked(func) {
	      return !!maskSrcKey && (maskSrcKey in func);
	    }
	
	    /**
	     * Checks if `func` is capable of being masked.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `func` is maskable, else `false`.
	     */
	    var isMaskable = coreJsData ? isFunction : stubFalse;
	
	    /**
	     * Checks if `value` is likely a prototype object.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
	     */
	    function isPrototype(value) {
	      var Ctor = value && value.constructor,
	          proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;
	
	      return value === proto;
	    }
	
	    /**
	     * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` if suitable for strict
	     *  equality comparisons, else `false`.
	     */
	    function isStrictComparable(value) {
	      return value === value && !isObject(value);
	    }
	
	    /**
	     * A specialized version of `matchesProperty` for source values suitable
	     * for strict equality comparisons, i.e. `===`.
	     *
	     * @private
	     * @param {string} key The key of the property to get.
	     * @param {*} srcValue The value to match.
	     * @returns {Function} Returns the new spec function.
	     */
	    function matchesStrictComparable(key, srcValue) {
	      return function(object) {
	        if (object == null) {
	          return false;
	        }
	        return object[key] === srcValue &&
	          (srcValue !== undefined || (key in Object(object)));
	      };
	    }
	
	    /**
	     * A specialized version of `_.memoize` which clears the memoized function's
	     * cache when it exceeds `MAX_MEMOIZE_SIZE`.
	     *
	     * @private
	     * @param {Function} func The function to have its output memoized.
	     * @returns {Function} Returns the new memoized function.
	     */
	    function memoizeCapped(func) {
	      var result = memoize(func, function(key) {
	        if (cache.size === MAX_MEMOIZE_SIZE) {
	          cache.clear();
	        }
	        return key;
	      });
	
	      var cache = result.cache;
	      return result;
	    }
	
	    /**
	     * Merges the function metadata of `source` into `data`.
	     *
	     * Merging metadata reduces the number of wrappers used to invoke a function.
	     * This is possible because methods like `_.bind`, `_.curry`, and `_.partial`
	     * may be applied regardless of execution order. Methods like `_.ary` and
	     * `_.rearg` modify function arguments, making the order in which they are
	     * executed important, preventing the merging of metadata. However, we make
	     * an exception for a safe combined case where curried functions have `_.ary`
	     * and or `_.rearg` applied.
	     *
	     * @private
	     * @param {Array} data The destination metadata.
	     * @param {Array} source The source metadata.
	     * @returns {Array} Returns `data`.
	     */
	    function mergeData(data, source) {
	      var bitmask = data[1],
	          srcBitmask = source[1],
	          newBitmask = bitmask | srcBitmask,
	          isCommon = newBitmask < (WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG | WRAP_ARY_FLAG);
	
	      var isCombo =
	        ((srcBitmask == WRAP_ARY_FLAG) && (bitmask == WRAP_CURRY_FLAG)) ||
	        ((srcBitmask == WRAP_ARY_FLAG) && (bitmask == WRAP_REARG_FLAG) && (data[7].length <= source[8])) ||
	        ((srcBitmask == (WRAP_ARY_FLAG | WRAP_REARG_FLAG)) && (source[7].length <= source[8]) && (bitmask == WRAP_CURRY_FLAG));
	
	      // Exit early if metadata can't be merged.
	      if (!(isCommon || isCombo)) {
	        return data;
	      }
	      // Use source `thisArg` if available.
	      if (srcBitmask & WRAP_BIND_FLAG) {
	        data[2] = source[2];
	        // Set when currying a bound function.
	        newBitmask |= bitmask & WRAP_BIND_FLAG ? 0 : WRAP_CURRY_BOUND_FLAG;
	      }
	      // Compose partial arguments.
	      var value = source[3];
	      if (value) {
	        var partials = data[3];
	        data[3] = partials ? composeArgs(partials, value, source[4]) : value;
	        data[4] = partials ? replaceHolders(data[3], PLACEHOLDER) : source[4];
	      }
	      // Compose partial right arguments.
	      value = source[5];
	      if (value) {
	        partials = data[5];
	        data[5] = partials ? composeArgsRight(partials, value, source[6]) : value;
	        data[6] = partials ? replaceHolders(data[5], PLACEHOLDER) : source[6];
	      }
	      // Use source `argPos` if available.
	      value = source[7];
	      if (value) {
	        data[7] = value;
	      }
	      // Use source `ary` if it's smaller.
	      if (srcBitmask & WRAP_ARY_FLAG) {
	        data[8] = data[8] == null ? source[8] : nativeMin(data[8], source[8]);
	      }
	      // Use source `arity` if one is not provided.
	      if (data[9] == null) {
	        data[9] = source[9];
	      }
	      // Use source `func` and merge bitmasks.
	      data[0] = source[0];
	      data[1] = newBitmask;
	
	      return data;
	    }
	
	    /**
	     * This function is like
	     * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
	     * except that it includes inherited enumerable properties.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names.
	     */
	    function nativeKeysIn(object) {
	      var result = [];
	      if (object != null) {
	        for (var key in Object(object)) {
	          result.push(key);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * Converts `value` to a string using `Object.prototype.toString`.
	     *
	     * @private
	     * @param {*} value The value to convert.
	     * @returns {string} Returns the converted string.
	     */
	    function objectToString(value) {
	      return nativeObjectToString.call(value);
	    }
	
	    /**
	     * A specialized version of `baseRest` which transforms the rest array.
	     *
	     * @private
	     * @param {Function} func The function to apply a rest parameter to.
	     * @param {number} [start=func.length-1] The start position of the rest parameter.
	     * @param {Function} transform The rest array transform.
	     * @returns {Function} Returns the new function.
	     */
	    function overRest(func, start, transform) {
	      start = nativeMax(start === undefined ? (func.length - 1) : start, 0);
	      return function() {
	        var args = arguments,
	            index = -1,
	            length = nativeMax(args.length - start, 0),
	            array = Array(length);
	
	        while (++index < length) {
	          array[index] = args[start + index];
	        }
	        index = -1;
	        var otherArgs = Array(start + 1);
	        while (++index < start) {
	          otherArgs[index] = args[index];
	        }
	        otherArgs[start] = transform(array);
	        return apply(func, this, otherArgs);
	      };
	    }
	
	    /**
	     * Gets the parent value at `path` of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {Array} path The path to get the parent value of.
	     * @returns {*} Returns the parent value.
	     */
	    function parent(object, path) {
	      return path.length < 2 ? object : baseGet(object, baseSlice(path, 0, -1));
	    }
	
	    /**
	     * Reorder `array` according to the specified indexes where the element at
	     * the first index is assigned as the first element, the element at
	     * the second index is assigned as the second element, and so on.
	     *
	     * @private
	     * @param {Array} array The array to reorder.
	     * @param {Array} indexes The arranged array indexes.
	     * @returns {Array} Returns `array`.
	     */
	    function reorder(array, indexes) {
	      var arrLength = array.length,
	          length = nativeMin(indexes.length, arrLength),
	          oldArray = copyArray(array);
	
	      while (length--) {
	        var index = indexes[length];
	        array[length] = isIndex(index, arrLength) ? oldArray[index] : undefined;
	      }
	      return array;
	    }
	
	    /**
	     * Gets the value at `key`, unless `key` is "__proto__".
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {string} key The key of the property to get.
	     * @returns {*} Returns the property value.
	     */
	    function safeGet(object, key) {
	      if (key == '__proto__') {
	        return;
	      }
	
	      return object[key];
	    }
	
	    /**
	     * Sets metadata for `func`.
	     *
	     * **Note:** If this function becomes hot, i.e. is invoked a lot in a short
	     * period of time, it will trip its breaker and transition to an identity
	     * function to avoid garbage collection pauses in V8. See
	     * [V8 issue 2070](https://bugs.chromium.org/p/v8/issues/detail?id=2070)
	     * for more details.
	     *
	     * @private
	     * @param {Function} func The function to associate metadata with.
	     * @param {*} data The metadata.
	     * @returns {Function} Returns `func`.
	     */
	    var setData = shortOut(baseSetData);
	
	    /**
	     * A simple wrapper around the global [`setTimeout`](https://mdn.io/setTimeout).
	     *
	     * @private
	     * @param {Function} func The function to delay.
	     * @param {number} wait The number of milliseconds to delay invocation.
	     * @returns {number|Object} Returns the timer id or timeout object.
	     */
	    var setTimeout = ctxSetTimeout || function(func, wait) {
	      return root.setTimeout(func, wait);
	    };
	
	    /**
	     * Sets the `toString` method of `func` to return `string`.
	     *
	     * @private
	     * @param {Function} func The function to modify.
	     * @param {Function} string The `toString` result.
	     * @returns {Function} Returns `func`.
	     */
	    var setToString = shortOut(baseSetToString);
	
	    /**
	     * Sets the `toString` method of `wrapper` to mimic the source of `reference`
	     * with wrapper details in a comment at the top of the source body.
	     *
	     * @private
	     * @param {Function} wrapper The function to modify.
	     * @param {Function} reference The reference function.
	     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	     * @returns {Function} Returns `wrapper`.
	     */
	    function setWrapToString(wrapper, reference, bitmask) {
	      var source = (reference + '');
	      return setToString(wrapper, insertWrapDetails(source, updateWrapDetails(getWrapDetails(source), bitmask)));
	    }
	
	    /**
	     * Creates a function that'll short out and invoke `identity` instead
	     * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
	     * milliseconds.
	     *
	     * @private
	     * @param {Function} func The function to restrict.
	     * @returns {Function} Returns the new shortable function.
	     */
	    function shortOut(func) {
	      var count = 0,
	          lastCalled = 0;
	
	      return function() {
	        var stamp = nativeNow(),
	            remaining = HOT_SPAN - (stamp - lastCalled);
	
	        lastCalled = stamp;
	        if (remaining > 0) {
	          if (++count >= HOT_COUNT) {
	            return arguments[0];
	          }
	        } else {
	          count = 0;
	        }
	        return func.apply(undefined, arguments);
	      };
	    }
	
	    /**
	     * A specialized version of `_.shuffle` which mutates and sets the size of `array`.
	     *
	     * @private
	     * @param {Array} array The array to shuffle.
	     * @param {number} [size=array.length] The size of `array`.
	     * @returns {Array} Returns `array`.
	     */
	    function shuffleSelf(array, size) {
	      var index = -1,
	          length = array.length,
	          lastIndex = length - 1;
	
	      size = size === undefined ? length : size;
	      while (++index < size) {
	        var rand = baseRandom(index, lastIndex),
	            value = array[rand];
	
	        array[rand] = array[index];
	        array[index] = value;
	      }
	      array.length = size;
	      return array;
	    }
	
	    /**
	     * Converts `string` to a property path array.
	     *
	     * @private
	     * @param {string} string The string to convert.
	     * @returns {Array} Returns the property path array.
	     */
	    var stringToPath = memoizeCapped(function(string) {
	      var result = [];
	      if (string.charCodeAt(0) === 46 /* . */) {
	        result.push('');
	      }
	      string.replace(rePropName, function(match, number, quote, subString) {
	        result.push(quote ? subString.replace(reEscapeChar, '$1') : (number || match));
	      });
	      return result;
	    });
	
	    /**
	     * Converts `value` to a string key if it's not a string or symbol.
	     *
	     * @private
	     * @param {*} value The value to inspect.
	     * @returns {string|symbol} Returns the key.
	     */
	    function toKey(value) {
	      if (typeof value == 'string' || isSymbol(value)) {
	        return value;
	      }
	      var result = (value + '');
	      return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
	    }
	
	    /**
	     * Converts `func` to its source code.
	     *
	     * @private
	     * @param {Function} func The function to convert.
	     * @returns {string} Returns the source code.
	     */
	    function toSource(func) {
	      if (func != null) {
	        try {
	          return funcToString.call(func);
	        } catch (e) {}
	        try {
	          return (func + '');
	        } catch (e) {}
	      }
	      return '';
	    }
	
	    /**
	     * Updates wrapper `details` based on `bitmask` flags.
	     *
	     * @private
	     * @returns {Array} details The details to modify.
	     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	     * @returns {Array} Returns `details`.
	     */
	    function updateWrapDetails(details, bitmask) {
	      arrayEach(wrapFlags, function(pair) {
	        var value = '_.' + pair[0];
	        if ((bitmask & pair[1]) && !arrayIncludes(details, value)) {
	          details.push(value);
	        }
	      });
	      return details.sort();
	    }
	
	    /**
	     * Creates a clone of `wrapper`.
	     *
	     * @private
	     * @param {Object} wrapper The wrapper to clone.
	     * @returns {Object} Returns the cloned wrapper.
	     */
	    function wrapperClone(wrapper) {
	      if (wrapper instanceof LazyWrapper) {
	        return wrapper.clone();
	      }
	      var result = new LodashWrapper(wrapper.__wrapped__, wrapper.__chain__);
	      result.__actions__ = copyArray(wrapper.__actions__);
	      result.__index__  = wrapper.__index__;
	      result.__values__ = wrapper.__values__;
	      return result;
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates an array of elements split into groups the length of `size`.
	     * If `array` can't be split evenly, the final chunk will be the remaining
	     * elements.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to process.
	     * @param {number} [size=1] The length of each chunk
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Array} Returns the new array of chunks.
	     * @example
	     *
	     * _.chunk(['a', 'b', 'c', 'd'], 2);
	     * // => [['a', 'b'], ['c', 'd']]
	     *
	     * _.chunk(['a', 'b', 'c', 'd'], 3);
	     * // => [['a', 'b', 'c'], ['d']]
	     */
	    function chunk(array, size, guard) {
	      if ((guard ? isIterateeCall(array, size, guard) : size === undefined)) {
	        size = 1;
	      } else {
	        size = nativeMax(toInteger(size), 0);
	      }
	      var length = array == null ? 0 : array.length;
	      if (!length || size < 1) {
	        return [];
	      }
	      var index = 0,
	          resIndex = 0,
	          result = Array(nativeCeil(length / size));
	
	      while (index < length) {
	        result[resIndex++] = baseSlice(array, index, (index += size));
	      }
	      return result;
	    }
	
	    /**
	     * Creates an array with all falsey values removed. The values `false`, `null`,
	     * `0`, `""`, `undefined`, and `NaN` are falsey.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to compact.
	     * @returns {Array} Returns the new array of filtered values.
	     * @example
	     *
	     * _.compact([0, 1, false, 2, '', 3]);
	     * // => [1, 2, 3]
	     */
	    function compact(array) {
	      var index = -1,
	          length = array == null ? 0 : array.length,
	          resIndex = 0,
	          result = [];
	
	      while (++index < length) {
	        var value = array[index];
	        if (value) {
	          result[resIndex++] = value;
	        }
	      }
	      return result;
	    }
	
	    /**
	     * Creates a new array concatenating `array` with any additional arrays
	     * and/or values.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to concatenate.
	     * @param {...*} [values] The values to concatenate.
	     * @returns {Array} Returns the new concatenated array.
	     * @example
	     *
	     * var array = [1];
	     * var other = _.concat(array, 2, [3], [[4]]);
	     *
	     * console.log(other);
	     * // => [1, 2, 3, [4]]
	     *
	     * console.log(array);
	     * // => [1]
	     */
	    function concat() {
	      var length = arguments.length;
	      if (!length) {
	        return [];
	      }
	      var args = Array(length - 1),
	          array = arguments[0],
	          index = length;
	
	      while (index--) {
	        args[index - 1] = arguments[index];
	      }
	      return arrayPush(isArray(array) ? copyArray(array) : [array], baseFlatten(args, 1));
	    }
	
	    /**
	     * Creates an array of `array` values not included in the other given arrays
	     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * for equality comparisons. The order and references of result values are
	     * determined by the first array.
	     *
	     * **Note:** Unlike `_.pullAll`, this method returns a new array.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {...Array} [values] The values to exclude.
	     * @returns {Array} Returns the new array of filtered values.
	     * @see _.without, _.xor
	     * @example
	     *
	     * _.difference([2, 1], [2, 3]);
	     * // => [1]
	     */
	    var difference = baseRest(function(array, values) {
	      return isArrayLikeObject(array)
	        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true))
	        : [];
	    });
	
	    /**
	     * This method is like `_.difference` except that it accepts `iteratee` which
	     * is invoked for each element of `array` and `values` to generate the criterion
	     * by which they're compared. The order and references of result values are
	     * determined by the first array. The iteratee is invoked with one argument:
	     * (value).
	     *
	     * **Note:** Unlike `_.pullAllBy`, this method returns a new array.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {...Array} [values] The values to exclude.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {Array} Returns the new array of filtered values.
	     * @example
	     *
	     * _.differenceBy([2.1, 1.2], [2.3, 3.4], Math.floor);
	     * // => [1.2]
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.differenceBy([{ 'x': 2 }, { 'x': 1 }], [{ 'x': 1 }], 'x');
	     * // => [{ 'x': 2 }]
	     */
	    var differenceBy = baseRest(function(array, values) {
	      var iteratee = last(values);
	      if (isArrayLikeObject(iteratee)) {
	        iteratee = undefined;
	      }
	      return isArrayLikeObject(array)
	        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), getIteratee(iteratee, 2))
	        : [];
	    });
	
	    /**
	     * This method is like `_.difference` except that it accepts `comparator`
	     * which is invoked to compare elements of `array` to `values`. The order and
	     * references of result values are determined by the first array. The comparator
	     * is invoked with two arguments: (arrVal, othVal).
	     *
	     * **Note:** Unlike `_.pullAllWith`, this method returns a new array.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {...Array} [values] The values to exclude.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new array of filtered values.
	     * @example
	     *
	     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
	     *
	     * _.differenceWith(objects, [{ 'x': 1, 'y': 2 }], _.isEqual);
	     * // => [{ 'x': 2, 'y': 1 }]
	     */
	    var differenceWith = baseRest(function(array, values) {
	      var comparator = last(values);
	      if (isArrayLikeObject(comparator)) {
	        comparator = undefined;
	      }
	      return isArrayLikeObject(array)
	        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), undefined, comparator)
	        : [];
	    });
	
	    /**
	     * Creates a slice of `array` with `n` elements dropped from the beginning.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.5.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {number} [n=1] The number of elements to drop.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.drop([1, 2, 3]);
	     * // => [2, 3]
	     *
	     * _.drop([1, 2, 3], 2);
	     * // => [3]
	     *
	     * _.drop([1, 2, 3], 5);
	     * // => []
	     *
	     * _.drop([1, 2, 3], 0);
	     * // => [1, 2, 3]
	     */
	    function drop(array, n, guard) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return [];
	      }
	      n = (guard || n === undefined) ? 1 : toInteger(n);
	      return baseSlice(array, n < 0 ? 0 : n, length);
	    }
	
	    /**
	     * Creates a slice of `array` with `n` elements dropped from the end.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {number} [n=1] The number of elements to drop.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.dropRight([1, 2, 3]);
	     * // => [1, 2]
	     *
	     * _.dropRight([1, 2, 3], 2);
	     * // => [1]
	     *
	     * _.dropRight([1, 2, 3], 5);
	     * // => []
	     *
	     * _.dropRight([1, 2, 3], 0);
	     * // => [1, 2, 3]
	     */
	    function dropRight(array, n, guard) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return [];
	      }
	      n = (guard || n === undefined) ? 1 : toInteger(n);
	      n = length - n;
	      return baseSlice(array, 0, n < 0 ? 0 : n);
	    }
	
	    /**
	     * Creates a slice of `array` excluding elements dropped from the end.
	     * Elements are dropped until `predicate` returns falsey. The predicate is
	     * invoked with three arguments: (value, index, array).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'active': true },
	     *   { 'user': 'fred',    'active': false },
	     *   { 'user': 'pebbles', 'active': false }
	     * ];
	     *
	     * _.dropRightWhile(users, function(o) { return !o.active; });
	     * // => objects for ['barney']
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.dropRightWhile(users, { 'user': 'pebbles', 'active': false });
	     * // => objects for ['barney', 'fred']
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.dropRightWhile(users, ['active', false]);
	     * // => objects for ['barney']
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.dropRightWhile(users, 'active');
	     * // => objects for ['barney', 'fred', 'pebbles']
	     */
	    function dropRightWhile(array, predicate) {
	      return (array && array.length)
	        ? baseWhile(array, getIteratee(predicate, 3), true, true)
	        : [];
	    }
	
	    /**
	     * Creates a slice of `array` excluding elements dropped from the beginning.
	     * Elements are dropped until `predicate` returns falsey. The predicate is
	     * invoked with three arguments: (value, index, array).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'active': false },
	     *   { 'user': 'fred',    'active': false },
	     *   { 'user': 'pebbles', 'active': true }
	     * ];
	     *
	     * _.dropWhile(users, function(o) { return !o.active; });
	     * // => objects for ['pebbles']
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.dropWhile(users, { 'user': 'barney', 'active': false });
	     * // => objects for ['fred', 'pebbles']
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.dropWhile(users, ['active', false]);
	     * // => objects for ['pebbles']
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.dropWhile(users, 'active');
	     * // => objects for ['barney', 'fred', 'pebbles']
	     */
	    function dropWhile(array, predicate) {
	      return (array && array.length)
	        ? baseWhile(array, getIteratee(predicate, 3), true)
	        : [];
	    }
	
	    /**
	     * Fills elements of `array` with `value` from `start` up to, but not
	     * including, `end`.
	     *
	     * **Note:** This method mutates `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.2.0
	     * @category Array
	     * @param {Array} array The array to fill.
	     * @param {*} value The value to fill `array` with.
	     * @param {number} [start=0] The start position.
	     * @param {number} [end=array.length] The end position.
	     * @returns {Array} Returns `array`.
	     * @example
	     *
	     * var array = [1, 2, 3];
	     *
	     * _.fill(array, 'a');
	     * console.log(array);
	     * // => ['a', 'a', 'a']
	     *
	     * _.fill(Array(3), 2);
	     * // => [2, 2, 2]
	     *
	     * _.fill([4, 6, 8, 10], '*', 1, 3);
	     * // => [4, '*', '*', 10]
	     */
	    function fill(array, value, start, end) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return [];
	      }
	      if (start && typeof start != 'number' && isIterateeCall(array, value, start)) {
	        start = 0;
	        end = length;
	      }
	      return baseFill(array, value, start, end);
	    }
	
	    /**
	     * This method is like `_.find` except that it returns the index of the first
	     * element `predicate` returns truthy for instead of the element itself.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.1.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @param {number} [fromIndex=0] The index to search from.
	     * @returns {number} Returns the index of the found element, else `-1`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'active': false },
	     *   { 'user': 'fred',    'active': false },
	     *   { 'user': 'pebbles', 'active': true }
	     * ];
	     *
	     * _.findIndex(users, function(o) { return o.user == 'barney'; });
	     * // => 0
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.findIndex(users, { 'user': 'fred', 'active': false });
	     * // => 1
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.findIndex(users, ['active', false]);
	     * // => 0
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.findIndex(users, 'active');
	     * // => 2
	     */
	    function findIndex(array, predicate, fromIndex) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return -1;
	      }
	      var index = fromIndex == null ? 0 : toInteger(fromIndex);
	      if (index < 0) {
	        index = nativeMax(length + index, 0);
	      }
	      return baseFindIndex(array, getIteratee(predicate, 3), index);
	    }
	
	    /**
	     * This method is like `_.findIndex` except that it iterates over elements
	     * of `collection` from right to left.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @param {number} [fromIndex=array.length-1] The index to search from.
	     * @returns {number} Returns the index of the found element, else `-1`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'active': true },
	     *   { 'user': 'fred',    'active': false },
	     *   { 'user': 'pebbles', 'active': false }
	     * ];
	     *
	     * _.findLastIndex(users, function(o) { return o.user == 'pebbles'; });
	     * // => 2
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.findLastIndex(users, { 'user': 'barney', 'active': true });
	     * // => 0
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.findLastIndex(users, ['active', false]);
	     * // => 2
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.findLastIndex(users, 'active');
	     * // => 0
	     */
	    function findLastIndex(array, predicate, fromIndex) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return -1;
	      }
	      var index = length - 1;
	      if (fromIndex !== undefined) {
	        index = toInteger(fromIndex);
	        index = fromIndex < 0
	          ? nativeMax(length + index, 0)
	          : nativeMin(index, length - 1);
	      }
	      return baseFindIndex(array, getIteratee(predicate, 3), index, true);
	    }
	
	    /**
	     * Flattens `array` a single level deep.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to flatten.
	     * @returns {Array} Returns the new flattened array.
	     * @example
	     *
	     * _.flatten([1, [2, [3, [4]], 5]]);
	     * // => [1, 2, [3, [4]], 5]
	     */
	    function flatten(array) {
	      var length = array == null ? 0 : array.length;
	      return length ? baseFlatten(array, 1) : [];
	    }
	
	    /**
	     * Recursively flattens `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to flatten.
	     * @returns {Array} Returns the new flattened array.
	     * @example
	     *
	     * _.flattenDeep([1, [2, [3, [4]], 5]]);
	     * // => [1, 2, 3, 4, 5]
	     */
	    function flattenDeep(array) {
	      var length = array == null ? 0 : array.length;
	      return length ? baseFlatten(array, INFINITY) : [];
	    }
	
	    /**
	     * Recursively flatten `array` up to `depth` times.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.4.0
	     * @category Array
	     * @param {Array} array The array to flatten.
	     * @param {number} [depth=1] The maximum recursion depth.
	     * @returns {Array} Returns the new flattened array.
	     * @example
	     *
	     * var array = [1, [2, [3, [4]], 5]];
	     *
	     * _.flattenDepth(array, 1);
	     * // => [1, 2, [3, [4]], 5]
	     *
	     * _.flattenDepth(array, 2);
	     * // => [1, 2, 3, [4], 5]
	     */
	    function flattenDepth(array, depth) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return [];
	      }
	      depth = depth === undefined ? 1 : toInteger(depth);
	      return baseFlatten(array, depth);
	    }
	
	    /**
	     * The inverse of `_.toPairs`; this method returns an object composed
	     * from key-value `pairs`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} pairs The key-value pairs.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * _.fromPairs([['a', 1], ['b', 2]]);
	     * // => { 'a': 1, 'b': 2 }
	     */
	    function fromPairs(pairs) {
	      var index = -1,
	          length = pairs == null ? 0 : pairs.length,
	          result = {};
	
	      while (++index < length) {
	        var pair = pairs[index];
	        result[pair[0]] = pair[1];
	      }
	      return result;
	    }
	
	    /**
	     * Gets the first element of `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @alias first
	     * @category Array
	     * @param {Array} array The array to query.
	     * @returns {*} Returns the first element of `array`.
	     * @example
	     *
	     * _.head([1, 2, 3]);
	     * // => 1
	     *
	     * _.head([]);
	     * // => undefined
	     */
	    function head(array) {
	      return (array && array.length) ? array[0] : undefined;
	    }
	
	    /**
	     * Gets the index at which the first occurrence of `value` is found in `array`
	     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * for equality comparisons. If `fromIndex` is negative, it's used as the
	     * offset from the end of `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {*} value The value to search for.
	     * @param {number} [fromIndex=0] The index to search from.
	     * @returns {number} Returns the index of the matched value, else `-1`.
	     * @example
	     *
	     * _.indexOf([1, 2, 1, 2], 2);
	     * // => 1
	     *
	     * // Search from the `fromIndex`.
	     * _.indexOf([1, 2, 1, 2], 2, 2);
	     * // => 3
	     */
	    function indexOf(array, value, fromIndex) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return -1;
	      }
	      var index = fromIndex == null ? 0 : toInteger(fromIndex);
	      if (index < 0) {
	        index = nativeMax(length + index, 0);
	      }
	      return baseIndexOf(array, value, index);
	    }
	
	    /**
	     * Gets all but the last element of `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.initial([1, 2, 3]);
	     * // => [1, 2]
	     */
	    function initial(array) {
	      var length = array == null ? 0 : array.length;
	      return length ? baseSlice(array, 0, -1) : [];
	    }
	
	    /**
	     * Creates an array of unique values that are included in all given arrays
	     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * for equality comparisons. The order and references of result values are
	     * determined by the first array.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @returns {Array} Returns the new array of intersecting values.
	     * @example
	     *
	     * _.intersection([2, 1], [2, 3]);
	     * // => [2]
	     */
	    var intersection = baseRest(function(arrays) {
	      var mapped = arrayMap(arrays, castArrayLikeObject);
	      return (mapped.length && mapped[0] === arrays[0])
	        ? baseIntersection(mapped)
	        : [];
	    });
	
	    /**
	     * This method is like `_.intersection` except that it accepts `iteratee`
	     * which is invoked for each element of each `arrays` to generate the criterion
	     * by which they're compared. The order and references of result values are
	     * determined by the first array. The iteratee is invoked with one argument:
	     * (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {Array} Returns the new array of intersecting values.
	     * @example
	     *
	     * _.intersectionBy([2.1, 1.2], [2.3, 3.4], Math.floor);
	     * // => [2.1]
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.intersectionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
	     * // => [{ 'x': 1 }]
	     */
	    var intersectionBy = baseRest(function(arrays) {
	      var iteratee = last(arrays),
	          mapped = arrayMap(arrays, castArrayLikeObject);
	
	      if (iteratee === last(mapped)) {
	        iteratee = undefined;
	      } else {
	        mapped.pop();
	      }
	      return (mapped.length && mapped[0] === arrays[0])
	        ? baseIntersection(mapped, getIteratee(iteratee, 2))
	        : [];
	    });
	
	    /**
	     * This method is like `_.intersection` except that it accepts `comparator`
	     * which is invoked to compare elements of `arrays`. The order and references
	     * of result values are determined by the first array. The comparator is
	     * invoked with two arguments: (arrVal, othVal).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new array of intersecting values.
	     * @example
	     *
	     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
	     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
	     *
	     * _.intersectionWith(objects, others, _.isEqual);
	     * // => [{ 'x': 1, 'y': 2 }]
	     */
	    var intersectionWith = baseRest(function(arrays) {
	      var comparator = last(arrays),
	          mapped = arrayMap(arrays, castArrayLikeObject);
	
	      comparator = typeof comparator == 'function' ? comparator : undefined;
	      if (comparator) {
	        mapped.pop();
	      }
	      return (mapped.length && mapped[0] === arrays[0])
	        ? baseIntersection(mapped, undefined, comparator)
	        : [];
	    });
	
	    /**
	     * Converts all elements in `array` into a string separated by `separator`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to convert.
	     * @param {string} [separator=','] The element separator.
	     * @returns {string} Returns the joined string.
	     * @example
	     *
	     * _.join(['a', 'b', 'c'], '~');
	     * // => 'a~b~c'
	     */
	    function join(array, separator) {
	      return array == null ? '' : nativeJoin.call(array, separator);
	    }
	
	    /**
	     * Gets the last element of `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @returns {*} Returns the last element of `array`.
	     * @example
	     *
	     * _.last([1, 2, 3]);
	     * // => 3
	     */
	    function last(array) {
	      var length = array == null ? 0 : array.length;
	      return length ? array[length - 1] : undefined;
	    }
	
	    /**
	     * This method is like `_.indexOf` except that it iterates over elements of
	     * `array` from right to left.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {*} value The value to search for.
	     * @param {number} [fromIndex=array.length-1] The index to search from.
	     * @returns {number} Returns the index of the matched value, else `-1`.
	     * @example
	     *
	     * _.lastIndexOf([1, 2, 1, 2], 2);
	     * // => 3
	     *
	     * // Search from the `fromIndex`.
	     * _.lastIndexOf([1, 2, 1, 2], 2, 2);
	     * // => 1
	     */
	    function lastIndexOf(array, value, fromIndex) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return -1;
	      }
	      var index = length;
	      if (fromIndex !== undefined) {
	        index = toInteger(fromIndex);
	        index = index < 0 ? nativeMax(length + index, 0) : nativeMin(index, length - 1);
	      }
	      return value === value
	        ? strictLastIndexOf(array, value, index)
	        : baseFindIndex(array, baseIsNaN, index, true);
	    }
	
	    /**
	     * Gets the element at index `n` of `array`. If `n` is negative, the nth
	     * element from the end is returned.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.11.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {number} [n=0] The index of the element to return.
	     * @returns {*} Returns the nth element of `array`.
	     * @example
	     *
	     * var array = ['a', 'b', 'c', 'd'];
	     *
	     * _.nth(array, 1);
	     * // => 'b'
	     *
	     * _.nth(array, -2);
	     * // => 'c';
	     */
	    function nth(array, n) {
	      return (array && array.length) ? baseNth(array, toInteger(n)) : undefined;
	    }
	
	    /**
	     * Removes all given values from `array` using
	     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * for equality comparisons.
	     *
	     * **Note:** Unlike `_.without`, this method mutates `array`. Use `_.remove`
	     * to remove elements from an array by predicate.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @param {...*} [values] The values to remove.
	     * @returns {Array} Returns `array`.
	     * @example
	     *
	     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
	     *
	     * _.pull(array, 'a', 'c');
	     * console.log(array);
	     * // => ['b', 'b']
	     */
	    var pull = baseRest(pullAll);
	
	    /**
	     * This method is like `_.pull` except that it accepts an array of values to remove.
	     *
	     * **Note:** Unlike `_.difference`, this method mutates `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @param {Array} values The values to remove.
	     * @returns {Array} Returns `array`.
	     * @example
	     *
	     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
	     *
	     * _.pullAll(array, ['a', 'c']);
	     * console.log(array);
	     * // => ['b', 'b']
	     */
	    function pullAll(array, values) {
	      return (array && array.length && values && values.length)
	        ? basePullAll(array, values)
	        : array;
	    }
	
	    /**
	     * This method is like `_.pullAll` except that it accepts `iteratee` which is
	     * invoked for each element of `array` and `values` to generate the criterion
	     * by which they're compared. The iteratee is invoked with one argument: (value).
	     *
	     * **Note:** Unlike `_.differenceBy`, this method mutates `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @param {Array} values The values to remove.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {Array} Returns `array`.
	     * @example
	     *
	     * var array = [{ 'x': 1 }, { 'x': 2 }, { 'x': 3 }, { 'x': 1 }];
	     *
	     * _.pullAllBy(array, [{ 'x': 1 }, { 'x': 3 }], 'x');
	     * console.log(array);
	     * // => [{ 'x': 2 }]
	     */
	    function pullAllBy(array, values, iteratee) {
	      return (array && array.length && values && values.length)
	        ? basePullAll(array, values, getIteratee(iteratee, 2))
	        : array;
	    }
	
	    /**
	     * This method is like `_.pullAll` except that it accepts `comparator` which
	     * is invoked to compare elements of `array` to `values`. The comparator is
	     * invoked with two arguments: (arrVal, othVal).
	     *
	     * **Note:** Unlike `_.differenceWith`, this method mutates `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.6.0
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @param {Array} values The values to remove.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns `array`.
	     * @example
	     *
	     * var array = [{ 'x': 1, 'y': 2 }, { 'x': 3, 'y': 4 }, { 'x': 5, 'y': 6 }];
	     *
	     * _.pullAllWith(array, [{ 'x': 3, 'y': 4 }], _.isEqual);
	     * console.log(array);
	     * // => [{ 'x': 1, 'y': 2 }, { 'x': 5, 'y': 6 }]
	     */
	    function pullAllWith(array, values, comparator) {
	      return (array && array.length && values && values.length)
	        ? basePullAll(array, values, undefined, comparator)
	        : array;
	    }
	
	    /**
	     * Removes elements from `array` corresponding to `indexes` and returns an
	     * array of removed elements.
	     *
	     * **Note:** Unlike `_.at`, this method mutates `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @param {...(number|number[])} [indexes] The indexes of elements to remove.
	     * @returns {Array} Returns the new array of removed elements.
	     * @example
	     *
	     * var array = ['a', 'b', 'c', 'd'];
	     * var pulled = _.pullAt(array, [1, 3]);
	     *
	     * console.log(array);
	     * // => ['a', 'c']
	     *
	     * console.log(pulled);
	     * // => ['b', 'd']
	     */
	    var pullAt = flatRest(function(array, indexes) {
	      var length = array == null ? 0 : array.length,
	          result = baseAt(array, indexes);
	
	      basePullAt(array, arrayMap(indexes, function(index) {
	        return isIndex(index, length) ? +index : index;
	      }).sort(compareAscending));
	
	      return result;
	    });
	
	    /**
	     * Removes all elements from `array` that `predicate` returns truthy for
	     * and returns an array of the removed elements. The predicate is invoked
	     * with three arguments: (value, index, array).
	     *
	     * **Note:** Unlike `_.filter`, this method mutates `array`. Use `_.pull`
	     * to pull elements from an array by value.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the new array of removed elements.
	     * @example
	     *
	     * var array = [1, 2, 3, 4];
	     * var evens = _.remove(array, function(n) {
	     *   return n % 2 == 0;
	     * });
	     *
	     * console.log(array);
	     * // => [1, 3]
	     *
	     * console.log(evens);
	     * // => [2, 4]
	     */
	    function remove(array, predicate) {
	      var result = [];
	      if (!(array && array.length)) {
	        return result;
	      }
	      var index = -1,
	          indexes = [],
	          length = array.length;
	
	      predicate = getIteratee(predicate, 3);
	      while (++index < length) {
	        var value = array[index];
	        if (predicate(value, index, array)) {
	          result.push(value);
	          indexes.push(index);
	        }
	      }
	      basePullAt(array, indexes);
	      return result;
	    }
	
	    /**
	     * Reverses `array` so that the first element becomes the last, the second
	     * element becomes the second to last, and so on.
	     *
	     * **Note:** This method mutates `array` and is based on
	     * [`Array#reverse`](https://mdn.io/Array/reverse).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @returns {Array} Returns `array`.
	     * @example
	     *
	     * var array = [1, 2, 3];
	     *
	     * _.reverse(array);
	     * // => [3, 2, 1]
	     *
	     * console.log(array);
	     * // => [3, 2, 1]
	     */
	    function reverse(array) {
	      return array == null ? array : nativeReverse.call(array);
	    }
	
	    /**
	     * Creates a slice of `array` from `start` up to, but not including, `end`.
	     *
	     * **Note:** This method is used instead of
	     * [`Array#slice`](https://mdn.io/Array/slice) to ensure dense arrays are
	     * returned.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to slice.
	     * @param {number} [start=0] The start position.
	     * @param {number} [end=array.length] The end position.
	     * @returns {Array} Returns the slice of `array`.
	     */
	    function slice(array, start, end) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return [];
	      }
	      if (end && typeof end != 'number' && isIterateeCall(array, start, end)) {
	        start = 0;
	        end = length;
	      }
	      else {
	        start = start == null ? 0 : toInteger(start);
	        end = end === undefined ? length : toInteger(end);
	      }
	      return baseSlice(array, start, end);
	    }
	
	    /**
	     * Uses a binary search to determine the lowest index at which `value`
	     * should be inserted into `array` in order to maintain its sort order.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The sorted array to inspect.
	     * @param {*} value The value to evaluate.
	     * @returns {number} Returns the index at which `value` should be inserted
	     *  into `array`.
	     * @example
	     *
	     * _.sortedIndex([30, 50], 40);
	     * // => 1
	     */
	    function sortedIndex(array, value) {
	      return baseSortedIndex(array, value);
	    }
	
	    /**
	     * This method is like `_.sortedIndex` except that it accepts `iteratee`
	     * which is invoked for `value` and each element of `array` to compute their
	     * sort ranking. The iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The sorted array to inspect.
	     * @param {*} value The value to evaluate.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {number} Returns the index at which `value` should be inserted
	     *  into `array`.
	     * @example
	     *
	     * var objects = [{ 'x': 4 }, { 'x': 5 }];
	     *
	     * _.sortedIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
	     * // => 0
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.sortedIndexBy(objects, { 'x': 4 }, 'x');
	     * // => 0
	     */
	    function sortedIndexBy(array, value, iteratee) {
	      return baseSortedIndexBy(array, value, getIteratee(iteratee, 2));
	    }
	
	    /**
	     * This method is like `_.indexOf` except that it performs a binary
	     * search on a sorted `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {*} value The value to search for.
	     * @returns {number} Returns the index of the matched value, else `-1`.
	     * @example
	     *
	     * _.sortedIndexOf([4, 5, 5, 5, 6], 5);
	     * // => 1
	     */
	    function sortedIndexOf(array, value) {
	      var length = array == null ? 0 : array.length;
	      if (length) {
	        var index = baseSortedIndex(array, value);
	        if (index < length && eq(array[index], value)) {
	          return index;
	        }
	      }
	      return -1;
	    }
	
	    /**
	     * This method is like `_.sortedIndex` except that it returns the highest
	     * index at which `value` should be inserted into `array` in order to
	     * maintain its sort order.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The sorted array to inspect.
	     * @param {*} value The value to evaluate.
	     * @returns {number} Returns the index at which `value` should be inserted
	     *  into `array`.
	     * @example
	     *
	     * _.sortedLastIndex([4, 5, 5, 5, 6], 5);
	     * // => 4
	     */
	    function sortedLastIndex(array, value) {
	      return baseSortedIndex(array, value, true);
	    }
	
	    /**
	     * This method is like `_.sortedLastIndex` except that it accepts `iteratee`
	     * which is invoked for `value` and each element of `array` to compute their
	     * sort ranking. The iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The sorted array to inspect.
	     * @param {*} value The value to evaluate.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {number} Returns the index at which `value` should be inserted
	     *  into `array`.
	     * @example
	     *
	     * var objects = [{ 'x': 4 }, { 'x': 5 }];
	     *
	     * _.sortedLastIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
	     * // => 1
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.sortedLastIndexBy(objects, { 'x': 4 }, 'x');
	     * // => 1
	     */
	    function sortedLastIndexBy(array, value, iteratee) {
	      return baseSortedIndexBy(array, value, getIteratee(iteratee, 2), true);
	    }
	
	    /**
	     * This method is like `_.lastIndexOf` except that it performs a binary
	     * search on a sorted `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {*} value The value to search for.
	     * @returns {number} Returns the index of the matched value, else `-1`.
	     * @example
	     *
	     * _.sortedLastIndexOf([4, 5, 5, 5, 6], 5);
	     * // => 3
	     */
	    function sortedLastIndexOf(array, value) {
	      var length = array == null ? 0 : array.length;
	      if (length) {
	        var index = baseSortedIndex(array, value, true) - 1;
	        if (eq(array[index], value)) {
	          return index;
	        }
	      }
	      return -1;
	    }
	
	    /**
	     * This method is like `_.uniq` except that it's designed and optimized
	     * for sorted arrays.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @returns {Array} Returns the new duplicate free array.
	     * @example
	     *
	     * _.sortedUniq([1, 1, 2]);
	     * // => [1, 2]
	     */
	    function sortedUniq(array) {
	      return (array && array.length)
	        ? baseSortedUniq(array)
	        : [];
	    }
	
	    /**
	     * This method is like `_.uniqBy` except that it's designed and optimized
	     * for sorted arrays.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {Function} [iteratee] The iteratee invoked per element.
	     * @returns {Array} Returns the new duplicate free array.
	     * @example
	     *
	     * _.sortedUniqBy([1.1, 1.2, 2.3, 2.4], Math.floor);
	     * // => [1.1, 2.3]
	     */
	    function sortedUniqBy(array, iteratee) {
	      return (array && array.length)
	        ? baseSortedUniq(array, getIteratee(iteratee, 2))
	        : [];
	    }
	
	    /**
	     * Gets all but the first element of `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.tail([1, 2, 3]);
	     * // => [2, 3]
	     */
	    function tail(array) {
	      var length = array == null ? 0 : array.length;
	      return length ? baseSlice(array, 1, length) : [];
	    }
	
	    /**
	     * Creates a slice of `array` with `n` elements taken from the beginning.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {number} [n=1] The number of elements to take.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.take([1, 2, 3]);
	     * // => [1]
	     *
	     * _.take([1, 2, 3], 2);
	     * // => [1, 2]
	     *
	     * _.take([1, 2, 3], 5);
	     * // => [1, 2, 3]
	     *
	     * _.take([1, 2, 3], 0);
	     * // => []
	     */
	    function take(array, n, guard) {
	      if (!(array && array.length)) {
	        return [];
	      }
	      n = (guard || n === undefined) ? 1 : toInteger(n);
	      return baseSlice(array, 0, n < 0 ? 0 : n);
	    }
	
	    /**
	     * Creates a slice of `array` with `n` elements taken from the end.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {number} [n=1] The number of elements to take.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.takeRight([1, 2, 3]);
	     * // => [3]
	     *
	     * _.takeRight([1, 2, 3], 2);
	     * // => [2, 3]
	     *
	     * _.takeRight([1, 2, 3], 5);
	     * // => [1, 2, 3]
	     *
	     * _.takeRight([1, 2, 3], 0);
	     * // => []
	     */
	    function takeRight(array, n, guard) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return [];
	      }
	      n = (guard || n === undefined) ? 1 : toInteger(n);
	      n = length - n;
	      return baseSlice(array, n < 0 ? 0 : n, length);
	    }
	
	    /**
	     * Creates a slice of `array` with elements taken from the end. Elements are
	     * taken until `predicate` returns falsey. The predicate is invoked with
	     * three arguments: (value, index, array).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'active': true },
	     *   { 'user': 'fred',    'active': false },
	     *   { 'user': 'pebbles', 'active': false }
	     * ];
	     *
	     * _.takeRightWhile(users, function(o) { return !o.active; });
	     * // => objects for ['fred', 'pebbles']
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.takeRightWhile(users, { 'user': 'pebbles', 'active': false });
	     * // => objects for ['pebbles']
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.takeRightWhile(users, ['active', false]);
	     * // => objects for ['fred', 'pebbles']
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.takeRightWhile(users, 'active');
	     * // => []
	     */
	    function takeRightWhile(array, predicate) {
	      return (array && array.length)
	        ? baseWhile(array, getIteratee(predicate, 3), false, true)
	        : [];
	    }
	
	    /**
	     * Creates a slice of `array` with elements taken from the beginning. Elements
	     * are taken until `predicate` returns falsey. The predicate is invoked with
	     * three arguments: (value, index, array).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'active': false },
	     *   { 'user': 'fred',    'active': false },
	     *   { 'user': 'pebbles', 'active': true }
	     * ];
	     *
	     * _.takeWhile(users, function(o) { return !o.active; });
	     * // => objects for ['barney', 'fred']
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.takeWhile(users, { 'user': 'barney', 'active': false });
	     * // => objects for ['barney']
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.takeWhile(users, ['active', false]);
	     * // => objects for ['barney', 'fred']
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.takeWhile(users, 'active');
	     * // => []
	     */
	    function takeWhile(array, predicate) {
	      return (array && array.length)
	        ? baseWhile(array, getIteratee(predicate, 3))
	        : [];
	    }
	
	    /**
	     * Creates an array of unique values, in order, from all given arrays using
	     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * for equality comparisons.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @returns {Array} Returns the new array of combined values.
	     * @example
	     *
	     * _.union([2], [1, 2]);
	     * // => [2, 1]
	     */
	    var union = baseRest(function(arrays) {
	      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true));
	    });
	
	    /**
	     * This method is like `_.union` except that it accepts `iteratee` which is
	     * invoked for each element of each `arrays` to generate the criterion by
	     * which uniqueness is computed. Result values are chosen from the first
	     * array in which the value occurs. The iteratee is invoked with one argument:
	     * (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {Array} Returns the new array of combined values.
	     * @example
	     *
	     * _.unionBy([2.1], [1.2, 2.3], Math.floor);
	     * // => [2.1, 1.2]
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.unionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
	     * // => [{ 'x': 1 }, { 'x': 2 }]
	     */
	    var unionBy = baseRest(function(arrays) {
	      var iteratee = last(arrays);
	      if (isArrayLikeObject(iteratee)) {
	        iteratee = undefined;
	      }
	      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), getIteratee(iteratee, 2));
	    });
	
	    /**
	     * This method is like `_.union` except that it accepts `comparator` which
	     * is invoked to compare elements of `arrays`. Result values are chosen from
	     * the first array in which the value occurs. The comparator is invoked
	     * with two arguments: (arrVal, othVal).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new array of combined values.
	     * @example
	     *
	     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
	     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
	     *
	     * _.unionWith(objects, others, _.isEqual);
	     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
	     */
	    var unionWith = baseRest(function(arrays) {
	      var comparator = last(arrays);
	      comparator = typeof comparator == 'function' ? comparator : undefined;
	      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), undefined, comparator);
	    });
	
	    /**
	     * Creates a duplicate-free version of an array, using
	     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * for equality comparisons, in which only the first occurrence of each element
	     * is kept. The order of result values is determined by the order they occur
	     * in the array.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @returns {Array} Returns the new duplicate free array.
	     * @example
	     *
	     * _.uniq([2, 1, 2]);
	     * // => [2, 1]
	     */
	    function uniq(array) {
	      return (array && array.length) ? baseUniq(array) : [];
	    }
	
	    /**
	     * This method is like `_.uniq` except that it accepts `iteratee` which is
	     * invoked for each element in `array` to generate the criterion by which
	     * uniqueness is computed. The order of result values is determined by the
	     * order they occur in the array. The iteratee is invoked with one argument:
	     * (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {Array} Returns the new duplicate free array.
	     * @example
	     *
	     * _.uniqBy([2.1, 1.2, 2.3], Math.floor);
	     * // => [2.1, 1.2]
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.uniqBy([{ 'x': 1 }, { 'x': 2 }, { 'x': 1 }], 'x');
	     * // => [{ 'x': 1 }, { 'x': 2 }]
	     */
	    function uniqBy(array, iteratee) {
	      return (array && array.length) ? baseUniq(array, getIteratee(iteratee, 2)) : [];
	    }
	
	    /**
	     * This method is like `_.uniq` except that it accepts `comparator` which
	     * is invoked to compare elements of `array`. The order of result values is
	     * determined by the order they occur in the array.The comparator is invoked
	     * with two arguments: (arrVal, othVal).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new duplicate free array.
	     * @example
	     *
	     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 2 }];
	     *
	     * _.uniqWith(objects, _.isEqual);
	     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }]
	     */
	    function uniqWith(array, comparator) {
	      comparator = typeof comparator == 'function' ? comparator : undefined;
	      return (array && array.length) ? baseUniq(array, undefined, comparator) : [];
	    }
	
	    /**
	     * This method is like `_.zip` except that it accepts an array of grouped
	     * elements and creates an array regrouping the elements to their pre-zip
	     * configuration.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.2.0
	     * @category Array
	     * @param {Array} array The array of grouped elements to process.
	     * @returns {Array} Returns the new array of regrouped elements.
	     * @example
	     *
	     * var zipped = _.zip(['a', 'b'], [1, 2], [true, false]);
	     * // => [['a', 1, true], ['b', 2, false]]
	     *
	     * _.unzip(zipped);
	     * // => [['a', 'b'], [1, 2], [true, false]]
	     */
	    function unzip(array) {
	      if (!(array && array.length)) {
	        return [];
	      }
	      var length = 0;
	      array = arrayFilter(array, function(group) {
	        if (isArrayLikeObject(group)) {
	          length = nativeMax(group.length, length);
	          return true;
	        }
	      });
	      return baseTimes(length, function(index) {
	        return arrayMap(array, baseProperty(index));
	      });
	    }
	
	    /**
	     * This method is like `_.unzip` except that it accepts `iteratee` to specify
	     * how regrouped values should be combined. The iteratee is invoked with the
	     * elements of each group: (...group).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.8.0
	     * @category Array
	     * @param {Array} array The array of grouped elements to process.
	     * @param {Function} [iteratee=_.identity] The function to combine
	     *  regrouped values.
	     * @returns {Array} Returns the new array of regrouped elements.
	     * @example
	     *
	     * var zipped = _.zip([1, 2], [10, 20], [100, 200]);
	     * // => [[1, 10, 100], [2, 20, 200]]
	     *
	     * _.unzipWith(zipped, _.add);
	     * // => [3, 30, 300]
	     */
	    function unzipWith(array, iteratee) {
	      if (!(array && array.length)) {
	        return [];
	      }
	      var result = unzip(array);
	      if (iteratee == null) {
	        return result;
	      }
	      return arrayMap(result, function(group) {
	        return apply(iteratee, undefined, group);
	      });
	    }
	
	    /**
	     * Creates an array excluding all given values using
	     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * for equality comparisons.
	     *
	     * **Note:** Unlike `_.pull`, this method returns a new array.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {...*} [values] The values to exclude.
	     * @returns {Array} Returns the new array of filtered values.
	     * @see _.difference, _.xor
	     * @example
	     *
	     * _.without([2, 1, 2, 3], 1, 2);
	     * // => [3]
	     */
	    var without = baseRest(function(array, values) {
	      return isArrayLikeObject(array)
	        ? baseDifference(array, values)
	        : [];
	    });
	
	    /**
	     * Creates an array of unique values that is the
	     * [symmetric difference](https://en.wikipedia.org/wiki/Symmetric_difference)
	     * of the given arrays. The order of result values is determined by the order
	     * they occur in the arrays.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.4.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @returns {Array} Returns the new array of filtered values.
	     * @see _.difference, _.without
	     * @example
	     *
	     * _.xor([2, 1], [2, 3]);
	     * // => [1, 3]
	     */
	    var xor = baseRest(function(arrays) {
	      return baseXor(arrayFilter(arrays, isArrayLikeObject));
	    });
	
	    /**
	     * This method is like `_.xor` except that it accepts `iteratee` which is
	     * invoked for each element of each `arrays` to generate the criterion by
	     * which by which they're compared. The order of result values is determined
	     * by the order they occur in the arrays. The iteratee is invoked with one
	     * argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {Array} Returns the new array of filtered values.
	     * @example
	     *
	     * _.xorBy([2.1, 1.2], [2.3, 3.4], Math.floor);
	     * // => [1.2, 3.4]
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.xorBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
	     * // => [{ 'x': 2 }]
	     */
	    var xorBy = baseRest(function(arrays) {
	      var iteratee = last(arrays);
	      if (isArrayLikeObject(iteratee)) {
	        iteratee = undefined;
	      }
	      return baseXor(arrayFilter(arrays, isArrayLikeObject), getIteratee(iteratee, 2));
	    });
	
	    /**
	     * This method is like `_.xor` except that it accepts `comparator` which is
	     * invoked to compare elements of `arrays`. The order of result values is
	     * determined by the order they occur in the arrays. The comparator is invoked
	     * with two arguments: (arrVal, othVal).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new array of filtered values.
	     * @example
	     *
	     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
	     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
	     *
	     * _.xorWith(objects, others, _.isEqual);
	     * // => [{ 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
	     */
	    var xorWith = baseRest(function(arrays) {
	      var comparator = last(arrays);
	      comparator = typeof comparator == 'function' ? comparator : undefined;
	      return baseXor(arrayFilter(arrays, isArrayLikeObject), undefined, comparator);
	    });
	
	    /**
	     * Creates an array of grouped elements, the first of which contains the
	     * first elements of the given arrays, the second of which contains the
	     * second elements of the given arrays, and so on.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to process.
	     * @returns {Array} Returns the new array of grouped elements.
	     * @example
	     *
	     * _.zip(['a', 'b'], [1, 2], [true, false]);
	     * // => [['a', 1, true], ['b', 2, false]]
	     */
	    var zip = baseRest(unzip);
	
	    /**
	     * This method is like `_.fromPairs` except that it accepts two arrays,
	     * one of property identifiers and one of corresponding values.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.4.0
	     * @category Array
	     * @param {Array} [props=[]] The property identifiers.
	     * @param {Array} [values=[]] The property values.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * _.zipObject(['a', 'b'], [1, 2]);
	     * // => { 'a': 1, 'b': 2 }
	     */
	    function zipObject(props, values) {
	      return baseZipObject(props || [], values || [], assignValue);
	    }
	
	    /**
	     * This method is like `_.zipObject` except that it supports property paths.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.1.0
	     * @category Array
	     * @param {Array} [props=[]] The property identifiers.
	     * @param {Array} [values=[]] The property values.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * _.zipObjectDeep(['a.b[0].c', 'a.b[1].d'], [1, 2]);
	     * // => { 'a': { 'b': [{ 'c': 1 }, { 'd': 2 }] } }
	     */
	    function zipObjectDeep(props, values) {
	      return baseZipObject(props || [], values || [], baseSet);
	    }
	
	    /**
	     * This method is like `_.zip` except that it accepts `iteratee` to specify
	     * how grouped values should be combined. The iteratee is invoked with the
	     * elements of each group: (...group).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.8.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to process.
	     * @param {Function} [iteratee=_.identity] The function to combine
	     *  grouped values.
	     * @returns {Array} Returns the new array of grouped elements.
	     * @example
	     *
	     * _.zipWith([1, 2], [10, 20], [100, 200], function(a, b, c) {
	     *   return a + b + c;
	     * });
	     * // => [111, 222]
	     */
	    var zipWith = baseRest(function(arrays) {
	      var length = arrays.length,
	          iteratee = length > 1 ? arrays[length - 1] : undefined;
	
	      iteratee = typeof iteratee == 'function' ? (arrays.pop(), iteratee) : undefined;
	      return unzipWith(arrays, iteratee);
	    });
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates a `lodash` wrapper instance that wraps `value` with explicit method
	     * chain sequences enabled. The result of such sequences must be unwrapped
	     * with `_#value`.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.3.0
	     * @category Seq
	     * @param {*} value The value to wrap.
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'age': 36 },
	     *   { 'user': 'fred',    'age': 40 },
	     *   { 'user': 'pebbles', 'age': 1 }
	     * ];
	     *
	     * var youngest = _
	     *   .chain(users)
	     *   .sortBy('age')
	     *   .map(function(o) {
	     *     return o.user + ' is ' + o.age;
	     *   })
	     *   .head()
	     *   .value();
	     * // => 'pebbles is 1'
	     */
	    function chain(value) {
	      var result = lodash(value);
	      result.__chain__ = true;
	      return result;
	    }
	
	    /**
	     * This method invokes `interceptor` and returns `value`. The interceptor
	     * is invoked with one argument; (value). The purpose of this method is to
	     * "tap into" a method chain sequence in order to modify intermediate results.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Seq
	     * @param {*} value The value to provide to `interceptor`.
	     * @param {Function} interceptor The function to invoke.
	     * @returns {*} Returns `value`.
	     * @example
	     *
	     * _([1, 2, 3])
	     *  .tap(function(array) {
	     *    // Mutate input array.
	     *    array.pop();
	     *  })
	     *  .reverse()
	     *  .value();
	     * // => [2, 1]
	     */
	    function tap(value, interceptor) {
	      interceptor(value);
	      return value;
	    }
	
	    /**
	     * This method is like `_.tap` except that it returns the result of `interceptor`.
	     * The purpose of this method is to "pass thru" values replacing intermediate
	     * results in a method chain sequence.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Seq
	     * @param {*} value The value to provide to `interceptor`.
	     * @param {Function} interceptor The function to invoke.
	     * @returns {*} Returns the result of `interceptor`.
	     * @example
	     *
	     * _('  abc  ')
	     *  .chain()
	     *  .trim()
	     *  .thru(function(value) {
	     *    return [value];
	     *  })
	     *  .value();
	     * // => ['abc']
	     */
	    function thru(value, interceptor) {
	      return interceptor(value);
	    }
	
	    /**
	     * This method is the wrapper version of `_.at`.
	     *
	     * @name at
	     * @memberOf _
	     * @since 1.0.0
	     * @category Seq
	     * @param {...(string|string[])} [paths] The property paths to pick.
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
	     *
	     * _(object).at(['a[0].b.c', 'a[1]']).value();
	     * // => [3, 4]
	     */
	    var wrapperAt = flatRest(function(paths) {
	      var length = paths.length,
	          start = length ? paths[0] : 0,
	          value = this.__wrapped__,
	          interceptor = function(object) { return baseAt(object, paths); };
	
	      if (length > 1 || this.__actions__.length ||
	          !(value instanceof LazyWrapper) || !isIndex(start)) {
	        return this.thru(interceptor);
	      }
	      value = value.slice(start, +start + (length ? 1 : 0));
	      value.__actions__.push({
	        'func': thru,
	        'args': [interceptor],
	        'thisArg': undefined
	      });
	      return new LodashWrapper(value, this.__chain__).thru(function(array) {
	        if (length && !array.length) {
	          array.push(undefined);
	        }
	        return array;
	      });
	    });
	
	    /**
	     * Creates a `lodash` wrapper instance with explicit method chain sequences enabled.
	     *
	     * @name chain
	     * @memberOf _
	     * @since 0.1.0
	     * @category Seq
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney', 'age': 36 },
	     *   { 'user': 'fred',   'age': 40 }
	     * ];
	     *
	     * // A sequence without explicit chaining.
	     * _(users).head();
	     * // => { 'user': 'barney', 'age': 36 }
	     *
	     * // A sequence with explicit chaining.
	     * _(users)
	     *   .chain()
	     *   .head()
	     *   .pick('user')
	     *   .value();
	     * // => { 'user': 'barney' }
	     */
	    function wrapperChain() {
	      return chain(this);
	    }
	
	    /**
	     * Executes the chain sequence and returns the wrapped result.
	     *
	     * @name commit
	     * @memberOf _
	     * @since 3.2.0
	     * @category Seq
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * var array = [1, 2];
	     * var wrapped = _(array).push(3);
	     *
	     * console.log(array);
	     * // => [1, 2]
	     *
	     * wrapped = wrapped.commit();
	     * console.log(array);
	     * // => [1, 2, 3]
	     *
	     * wrapped.last();
	     * // => 3
	     *
	     * console.log(array);
	     * // => [1, 2, 3]
	     */
	    function wrapperCommit() {
	      return new LodashWrapper(this.value(), this.__chain__);
	    }
	
	    /**
	     * Gets the next value on a wrapped object following the
	     * [iterator protocol](https://mdn.io/iteration_protocols#iterator).
	     *
	     * @name next
	     * @memberOf _
	     * @since 4.0.0
	     * @category Seq
	     * @returns {Object} Returns the next iterator value.
	     * @example
	     *
	     * var wrapped = _([1, 2]);
	     *
	     * wrapped.next();
	     * // => { 'done': false, 'value': 1 }
	     *
	     * wrapped.next();
	     * // => { 'done': false, 'value': 2 }
	     *
	     * wrapped.next();
	     * // => { 'done': true, 'value': undefined }
	     */
	    function wrapperNext() {
	      if (this.__values__ === undefined) {
	        this.__values__ = toArray(this.value());
	      }
	      var done = this.__index__ >= this.__values__.length,
	          value = done ? undefined : this.__values__[this.__index__++];
	
	      return { 'done': done, 'value': value };
	    }
	
	    /**
	     * Enables the wrapper to be iterable.
	     *
	     * @name Symbol.iterator
	     * @memberOf _
	     * @since 4.0.0
	     * @category Seq
	     * @returns {Object} Returns the wrapper object.
	     * @example
	     *
	     * var wrapped = _([1, 2]);
	     *
	     * wrapped[Symbol.iterator]() === wrapped;
	     * // => true
	     *
	     * Array.from(wrapped);
	     * // => [1, 2]
	     */
	    function wrapperToIterator() {
	      return this;
	    }
	
	    /**
	     * Creates a clone of the chain sequence planting `value` as the wrapped value.
	     *
	     * @name plant
	     * @memberOf _
	     * @since 3.2.0
	     * @category Seq
	     * @param {*} value The value to plant.
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * function square(n) {
	     *   return n * n;
	     * }
	     *
	     * var wrapped = _([1, 2]).map(square);
	     * var other = wrapped.plant([3, 4]);
	     *
	     * other.value();
	     * // => [9, 16]
	     *
	     * wrapped.value();
	     * // => [1, 4]
	     */
	    function wrapperPlant(value) {
	      var result,
	          parent = this;
	
	      while (parent instanceof baseLodash) {
	        var clone = wrapperClone(parent);
	        clone.__index__ = 0;
	        clone.__values__ = undefined;
	        if (result) {
	          previous.__wrapped__ = clone;
	        } else {
	          result = clone;
	        }
	        var previous = clone;
	        parent = parent.__wrapped__;
	      }
	      previous.__wrapped__ = value;
	      return result;
	    }
	
	    /**
	     * This method is the wrapper version of `_.reverse`.
	     *
	     * **Note:** This method mutates the wrapped array.
	     *
	     * @name reverse
	     * @memberOf _
	     * @since 0.1.0
	     * @category Seq
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * var array = [1, 2, 3];
	     *
	     * _(array).reverse().value()
	     * // => [3, 2, 1]
	     *
	     * console.log(array);
	     * // => [3, 2, 1]
	     */
	    function wrapperReverse() {
	      var value = this.__wrapped__;
	      if (value instanceof LazyWrapper) {
	        var wrapped = value;
	        if (this.__actions__.length) {
	          wrapped = new LazyWrapper(this);
	        }
	        wrapped = wrapped.reverse();
	        wrapped.__actions__.push({
	          'func': thru,
	          'args': [reverse],
	          'thisArg': undefined
	        });
	        return new LodashWrapper(wrapped, this.__chain__);
	      }
	      return this.thru(reverse);
	    }
	
	    /**
	     * Executes the chain sequence to resolve the unwrapped value.
	     *
	     * @name value
	     * @memberOf _
	     * @since 0.1.0
	     * @alias toJSON, valueOf
	     * @category Seq
	     * @returns {*} Returns the resolved unwrapped value.
	     * @example
	     *
	     * _([1, 2, 3]).value();
	     * // => [1, 2, 3]
	     */
	    function wrapperValue() {
	      return baseWrapperValue(this.__wrapped__, this.__actions__);
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates an object composed of keys generated from the results of running
	     * each element of `collection` thru `iteratee`. The corresponding value of
	     * each key is the number of times the key was returned by `iteratee`. The
	     * iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.5.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
	     * @returns {Object} Returns the composed aggregate object.
	     * @example
	     *
	     * _.countBy([6.1, 4.2, 6.3], Math.floor);
	     * // => { '4': 1, '6': 2 }
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.countBy(['one', 'two', 'three'], 'length');
	     * // => { '3': 2, '5': 1 }
	     */
	    var countBy = createAggregator(function(result, value, key) {
	      if (hasOwnProperty.call(result, key)) {
	        ++result[key];
	      } else {
	        baseAssignValue(result, key, 1);
	      }
	    });
	
	    /**
	     * Checks if `predicate` returns truthy for **all** elements of `collection`.
	     * Iteration is stopped once `predicate` returns falsey. The predicate is
	     * invoked with three arguments: (value, index|key, collection).
	     *
	     * **Note:** This method returns `true` for
	     * [empty collections](https://en.wikipedia.org/wiki/Empty_set) because
	     * [everything is true](https://en.wikipedia.org/wiki/Vacuous_truth) of
	     * elements of empty collections.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {boolean} Returns `true` if all elements pass the predicate check,
	     *  else `false`.
	     * @example
	     *
	     * _.every([true, 1, null, 'yes'], Boolean);
	     * // => false
	     *
	     * var users = [
	     *   { 'user': 'barney', 'age': 36, 'active': false },
	     *   { 'user': 'fred',   'age': 40, 'active': false }
	     * ];
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.every(users, { 'user': 'barney', 'active': false });
	     * // => false
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.every(users, ['active', false]);
	     * // => true
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.every(users, 'active');
	     * // => false
	     */
	    function every(collection, predicate, guard) {
	      var func = isArray(collection) ? arrayEvery : baseEvery;
	      if (guard && isIterateeCall(collection, predicate, guard)) {
	        predicate = undefined;
	      }
	      return func(collection, getIteratee(predicate, 3));
	    }
	
	    /**
	     * Iterates over elements of `collection`, returning an array of all elements
	     * `predicate` returns truthy for. The predicate is invoked with three
	     * arguments: (value, index|key, collection).
	     *
	     * **Note:** Unlike `_.remove`, this method returns a new array.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the new filtered array.
	     * @see _.reject
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney', 'age': 36, 'active': true },
	     *   { 'user': 'fred',   'age': 40, 'active': false }
	     * ];
	     *
	     * _.filter(users, function(o) { return !o.active; });
	     * // => objects for ['fred']
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.filter(users, { 'age': 36, 'active': true });
	     * // => objects for ['barney']
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.filter(users, ['active', false]);
	     * // => objects for ['fred']
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.filter(users, 'active');
	     * // => objects for ['barney']
	     */
	    function filter(collection, predicate) {
	      var func = isArray(collection) ? arrayFilter : baseFilter;
	      return func(collection, getIteratee(predicate, 3));
	    }
	
	    /**
	     * Iterates over elements of `collection`, returning the first element
	     * `predicate` returns truthy for. The predicate is invoked with three
	     * arguments: (value, index|key, collection).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to inspect.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @param {number} [fromIndex=0] The index to search from.
	     * @returns {*} Returns the matched element, else `undefined`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'age': 36, 'active': true },
	     *   { 'user': 'fred',    'age': 40, 'active': false },
	     *   { 'user': 'pebbles', 'age': 1,  'active': true }
	     * ];
	     *
	     * _.find(users, function(o) { return o.age < 40; });
	     * // => object for 'barney'
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.find(users, { 'age': 1, 'active': true });
	     * // => object for 'pebbles'
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.find(users, ['active', false]);
	     * // => object for 'fred'
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.find(users, 'active');
	     * // => object for 'barney'
	     */
	    var find = createFind(findIndex);
	
	    /**
	     * This method is like `_.find` except that it iterates over elements of
	     * `collection` from right to left.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to inspect.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @param {number} [fromIndex=collection.length-1] The index to search from.
	     * @returns {*} Returns the matched element, else `undefined`.
	     * @example
	     *
	     * _.findLast([1, 2, 3, 4], function(n) {
	     *   return n % 2 == 1;
	     * });
	     * // => 3
	     */
	    var findLast = createFind(findLastIndex);
	
	    /**
	     * Creates a flattened array of values by running each element in `collection`
	     * thru `iteratee` and flattening the mapped results. The iteratee is invoked
	     * with three arguments: (value, index|key, collection).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the new flattened array.
	     * @example
	     *
	     * function duplicate(n) {
	     *   return [n, n];
	     * }
	     *
	     * _.flatMap([1, 2], duplicate);
	     * // => [1, 1, 2, 2]
	     */
	    function flatMap(collection, iteratee) {
	      return baseFlatten(map(collection, iteratee), 1);
	    }
	
	    /**
	     * This method is like `_.flatMap` except that it recursively flattens the
	     * mapped results.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.7.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the new flattened array.
	     * @example
	     *
	     * function duplicate(n) {
	     *   return [[[n, n]]];
	     * }
	     *
	     * _.flatMapDeep([1, 2], duplicate);
	     * // => [1, 1, 2, 2]
	     */
	    function flatMapDeep(collection, iteratee) {
	      return baseFlatten(map(collection, iteratee), INFINITY);
	    }
	
	    /**
	     * This method is like `_.flatMap` except that it recursively flattens the
	     * mapped results up to `depth` times.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.7.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @param {number} [depth=1] The maximum recursion depth.
	     * @returns {Array} Returns the new flattened array.
	     * @example
	     *
	     * function duplicate(n) {
	     *   return [[[n, n]]];
	     * }
	     *
	     * _.flatMapDepth([1, 2], duplicate, 2);
	     * // => [[1, 1], [2, 2]]
	     */
	    function flatMapDepth(collection, iteratee, depth) {
	      depth = depth === undefined ? 1 : toInteger(depth);
	      return baseFlatten(map(collection, iteratee), depth);
	    }
	
	    /**
	     * Iterates over elements of `collection` and invokes `iteratee` for each element.
	     * The iteratee is invoked with three arguments: (value, index|key, collection).
	     * Iteratee functions may exit iteration early by explicitly returning `false`.
	     *
	     * **Note:** As with other "Collections" methods, objects with a "length"
	     * property are iterated like arrays. To avoid this behavior use `_.forIn`
	     * or `_.forOwn` for object iteration.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @alias each
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Array|Object} Returns `collection`.
	     * @see _.forEachRight
	     * @example
	     *
	     * _.forEach([1, 2], function(value) {
	     *   console.log(value);
	     * });
	     * // => Logs `1` then `2`.
	     *
	     * _.forEach({ 'a': 1, 'b': 2 }, function(value, key) {
	     *   console.log(key);
	     * });
	     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
	     */
	    function forEach(collection, iteratee) {
	      var func = isArray(collection) ? arrayEach : baseEach;
	      return func(collection, getIteratee(iteratee, 3));
	    }
	
	    /**
	     * This method is like `_.forEach` except that it iterates over elements of
	     * `collection` from right to left.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @alias eachRight
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Array|Object} Returns `collection`.
	     * @see _.forEach
	     * @example
	     *
	     * _.forEachRight([1, 2], function(value) {
	     *   console.log(value);
	     * });
	     * // => Logs `2` then `1`.
	     */
	    function forEachRight(collection, iteratee) {
	      var func = isArray(collection) ? arrayEachRight : baseEachRight;
	      return func(collection, getIteratee(iteratee, 3));
	    }
	
	    /**
	     * Creates an object composed of keys generated from the results of running
	     * each element of `collection` thru `iteratee`. The order of grouped values
	     * is determined by the order they occur in `collection`. The corresponding
	     * value of each key is an array of elements responsible for generating the
	     * key. The iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
	     * @returns {Object} Returns the composed aggregate object.
	     * @example
	     *
	     * _.groupBy([6.1, 4.2, 6.3], Math.floor);
	     * // => { '4': [4.2], '6': [6.1, 6.3] }
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.groupBy(['one', 'two', 'three'], 'length');
	     * // => { '3': ['one', 'two'], '5': ['three'] }
	     */
	    var groupBy = createAggregator(function(result, value, key) {
	      if (hasOwnProperty.call(result, key)) {
	        result[key].push(value);
	      } else {
	        baseAssignValue(result, key, [value]);
	      }
	    });
	
	    /**
	     * Checks if `value` is in `collection`. If `collection` is a string, it's
	     * checked for a substring of `value`, otherwise
	     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * is used for equality comparisons. If `fromIndex` is negative, it's used as
	     * the offset from the end of `collection`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to inspect.
	     * @param {*} value The value to search for.
	     * @param {number} [fromIndex=0] The index to search from.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
	     * @returns {boolean} Returns `true` if `value` is found, else `false`.
	     * @example
	     *
	     * _.includes([1, 2, 3], 1);
	     * // => true
	     *
	     * _.includes([1, 2, 3], 1, 2);
	     * // => false
	     *
	     * _.includes({ 'a': 1, 'b': 2 }, 1);
	     * // => true
	     *
	     * _.includes('abcd', 'bc');
	     * // => true
	     */
	    function includes(collection, value, fromIndex, guard) {
	      collection = isArrayLike(collection) ? collection : values(collection);
	      fromIndex = (fromIndex && !guard) ? toInteger(fromIndex) : 0;
	
	      var length = collection.length;
	      if (fromIndex < 0) {
	        fromIndex = nativeMax(length + fromIndex, 0);
	      }
	      return isString(collection)
	        ? (fromIndex <= length && collection.indexOf(value, fromIndex) > -1)
	        : (!!length && baseIndexOf(collection, value, fromIndex) > -1);
	    }
	
	    /**
	     * Invokes the method at `path` of each element in `collection`, returning
	     * an array of the results of each invoked method. Any additional arguments
	     * are provided to each invoked method. If `path` is a function, it's invoked
	     * for, and `this` bound to, each element in `collection`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Array|Function|string} path The path of the method to invoke or
	     *  the function invoked per iteration.
	     * @param {...*} [args] The arguments to invoke each method with.
	     * @returns {Array} Returns the array of results.
	     * @example
	     *
	     * _.invokeMap([[5, 1, 7], [3, 2, 1]], 'sort');
	     * // => [[1, 5, 7], [1, 2, 3]]
	     *
	     * _.invokeMap([123, 456], String.prototype.split, '');
	     * // => [['1', '2', '3'], ['4', '5', '6']]
	     */
	    var invokeMap = baseRest(function(collection, path, args) {
	      var index = -1,
	          isFunc = typeof path == 'function',
	          result = isArrayLike(collection) ? Array(collection.length) : [];
	
	      baseEach(collection, function(value) {
	        result[++index] = isFunc ? apply(path, value, args) : baseInvoke(value, path, args);
	      });
	      return result;
	    });
	
	    /**
	     * Creates an object composed of keys generated from the results of running
	     * each element of `collection` thru `iteratee`. The corresponding value of
	     * each key is the last element responsible for generating the key. The
	     * iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
	     * @returns {Object} Returns the composed aggregate object.
	     * @example
	     *
	     * var array = [
	     *   { 'dir': 'left', 'code': 97 },
	     *   { 'dir': 'right', 'code': 100 }
	     * ];
	     *
	     * _.keyBy(array, function(o) {
	     *   return String.fromCharCode(o.code);
	     * });
	     * // => { 'a': { 'dir': 'left', 'code': 97 }, 'd': { 'dir': 'right', 'code': 100 } }
	     *
	     * _.keyBy(array, 'dir');
	     * // => { 'left': { 'dir': 'left', 'code': 97 }, 'right': { 'dir': 'right', 'code': 100 } }
	     */
	    var keyBy = createAggregator(function(result, value, key) {
	      baseAssignValue(result, key, value);
	    });
	
	    /**
	     * Creates an array of values by running each element in `collection` thru
	     * `iteratee`. The iteratee is invoked with three arguments:
	     * (value, index|key, collection).
	     *
	     * Many lodash methods are guarded to work as iteratees for methods like
	     * `_.every`, `_.filter`, `_.map`, `_.mapValues`, `_.reject`, and `_.some`.
	     *
	     * The guarded methods are:
	     * `ary`, `chunk`, `curry`, `curryRight`, `drop`, `dropRight`, `every`,
	     * `fill`, `invert`, `parseInt`, `random`, `range`, `rangeRight`, `repeat`,
	     * `sampleSize`, `slice`, `some`, `sortBy`, `split`, `take`, `takeRight`,
	     * `template`, `trim`, `trimEnd`, `trimStart`, and `words`
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the new mapped array.
	     * @example
	     *
	     * function square(n) {
	     *   return n * n;
	     * }
	     *
	     * _.map([4, 8], square);
	     * // => [16, 64]
	     *
	     * _.map({ 'a': 4, 'b': 8 }, square);
	     * // => [16, 64] (iteration order is not guaranteed)
	     *
	     * var users = [
	     *   { 'user': 'barney' },
	     *   { 'user': 'fred' }
	     * ];
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.map(users, 'user');
	     * // => ['barney', 'fred']
	     */
	    function map(collection, iteratee) {
	      var func = isArray(collection) ? arrayMap : baseMap;
	      return func(collection, getIteratee(iteratee, 3));
	    }
	
	    /**
	     * This method is like `_.sortBy` except that it allows specifying the sort
	     * orders of the iteratees to sort by. If `orders` is unspecified, all values
	     * are sorted in ascending order. Otherwise, specify an order of "desc" for
	     * descending or "asc" for ascending sort order of corresponding values.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Array[]|Function[]|Object[]|string[]} [iteratees=[_.identity]]
	     *  The iteratees to sort by.
	     * @param {string[]} [orders] The sort orders of `iteratees`.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
	     * @returns {Array} Returns the new sorted array.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'fred',   'age': 48 },
	     *   { 'user': 'barney', 'age': 34 },
	     *   { 'user': 'fred',   'age': 40 },
	     *   { 'user': 'barney', 'age': 36 }
	     * ];
	     *
	     * // Sort by `user` in ascending order and by `age` in descending order.
	     * _.orderBy(users, ['user', 'age'], ['asc', 'desc']);
	     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 40]]
	     */
	    function orderBy(collection, iteratees, orders, guard) {
	      if (collection == null) {
	        return [];
	      }
	      if (!isArray(iteratees)) {
	        iteratees = iteratees == null ? [] : [iteratees];
	      }
	      orders = guard ? undefined : orders;
	      if (!isArray(orders)) {
	        orders = orders == null ? [] : [orders];
	      }
	      return baseOrderBy(collection, iteratees, orders);
	    }
	
	    /**
	     * Creates an array of elements split into two groups, the first of which
	     * contains elements `predicate` returns truthy for, the second of which
	     * contains elements `predicate` returns falsey for. The predicate is
	     * invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the array of grouped elements.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'age': 36, 'active': false },
	     *   { 'user': 'fred',    'age': 40, 'active': true },
	     *   { 'user': 'pebbles', 'age': 1,  'active': false }
	     * ];
	     *
	     * _.partition(users, function(o) { return o.active; });
	     * // => objects for [['fred'], ['barney', 'pebbles']]
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.partition(users, { 'age': 1, 'active': false });
	     * // => objects for [['pebbles'], ['barney', 'fred']]
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.partition(users, ['active', false]);
	     * // => objects for [['barney', 'pebbles'], ['fred']]
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.partition(users, 'active');
	     * // => objects for [['fred'], ['barney', 'pebbles']]
	     */
	    var partition = createAggregator(function(result, value, key) {
	      result[key ? 0 : 1].push(value);
	    }, function() { return [[], []]; });
	
	    /**
	     * Reduces `collection` to a value which is the accumulated result of running
	     * each element in `collection` thru `iteratee`, where each successive
	     * invocation is supplied the return value of the previous. If `accumulator`
	     * is not given, the first element of `collection` is used as the initial
	     * value. The iteratee is invoked with four arguments:
	     * (accumulator, value, index|key, collection).
	     *
	     * Many lodash methods are guarded to work as iteratees for methods like
	     * `_.reduce`, `_.reduceRight`, and `_.transform`.
	     *
	     * The guarded methods are:
	     * `assign`, `defaults`, `defaultsDeep`, `includes`, `merge`, `orderBy`,
	     * and `sortBy`
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @param {*} [accumulator] The initial value.
	     * @returns {*} Returns the accumulated value.
	     * @see _.reduceRight
	     * @example
	     *
	     * _.reduce([1, 2], function(sum, n) {
	     *   return sum + n;
	     * }, 0);
	     * // => 3
	     *
	     * _.reduce({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
	     *   (result[value] || (result[value] = [])).push(key);
	     *   return result;
	     * }, {});
	     * // => { '1': ['a', 'c'], '2': ['b'] } (iteration order is not guaranteed)
	     */
	    function reduce(collection, iteratee, accumulator) {
	      var func = isArray(collection) ? arrayReduce : baseReduce,
	          initAccum = arguments.length < 3;
	
	      return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEach);
	    }
	
	    /**
	     * This method is like `_.reduce` except that it iterates over elements of
	     * `collection` from right to left.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @param {*} [accumulator] The initial value.
	     * @returns {*} Returns the accumulated value.
	     * @see _.reduce
	     * @example
	     *
	     * var array = [[0, 1], [2, 3], [4, 5]];
	     *
	     * _.reduceRight(array, function(flattened, other) {
	     *   return flattened.concat(other);
	     * }, []);
	     * // => [4, 5, 2, 3, 0, 1]
	     */
	    function reduceRight(collection, iteratee, accumulator) {
	      var func = isArray(collection) ? arrayReduceRight : baseReduce,
	          initAccum = arguments.length < 3;
	
	      return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEachRight);
	    }
	
	    /**
	     * The opposite of `_.filter`; this method returns the elements of `collection`
	     * that `predicate` does **not** return truthy for.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the new filtered array.
	     * @see _.filter
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney', 'age': 36, 'active': false },
	     *   { 'user': 'fred',   'age': 40, 'active': true }
	     * ];
	     *
	     * _.reject(users, function(o) { return !o.active; });
	     * // => objects for ['fred']
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.reject(users, { 'age': 40, 'active': true });
	     * // => objects for ['barney']
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.reject(users, ['active', false]);
	     * // => objects for ['fred']
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.reject(users, 'active');
	     * // => objects for ['barney']
	     */
	    function reject(collection, predicate) {
	      var func = isArray(collection) ? arrayFilter : baseFilter;
	      return func(collection, negate(getIteratee(predicate, 3)));
	    }
	
	    /**
	     * Gets a random element from `collection`.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to sample.
	     * @returns {*} Returns the random element.
	     * @example
	     *
	     * _.sample([1, 2, 3, 4]);
	     * // => 2
	     */
	    function sample(collection) {
	      var func = isArray(collection) ? arraySample : baseSample;
	      return func(collection);
	    }
	
	    /**
	     * Gets `n` random elements at unique keys from `collection` up to the
	     * size of `collection`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to sample.
	     * @param {number} [n=1] The number of elements to sample.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Array} Returns the random elements.
	     * @example
	     *
	     * _.sampleSize([1, 2, 3], 2);
	     * // => [3, 1]
	     *
	     * _.sampleSize([1, 2, 3], 4);
	     * // => [2, 3, 1]
	     */
	    function sampleSize(collection, n, guard) {
	      if ((guard ? isIterateeCall(collection, n, guard) : n === undefined)) {
	        n = 1;
	      } else {
	        n = toInteger(n);
	      }
	      var func = isArray(collection) ? arraySampleSize : baseSampleSize;
	      return func(collection, n);
	    }
	
	    /**
	     * Creates an array of shuffled values, using a version of the
	     * [Fisher-Yates shuffle](https://en.wikipedia.org/wiki/Fisher-Yates_shuffle).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to shuffle.
	     * @returns {Array} Returns the new shuffled array.
	     * @example
	     *
	     * _.shuffle([1, 2, 3, 4]);
	     * // => [4, 1, 3, 2]
	     */
	    function shuffle(collection) {
	      var func = isArray(collection) ? arrayShuffle : baseShuffle;
	      return func(collection);
	    }
	
	    /**
	     * Gets the size of `collection` by returning its length for array-like
	     * values or the number of own enumerable string keyed properties for objects.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to inspect.
	     * @returns {number} Returns the collection size.
	     * @example
	     *
	     * _.size([1, 2, 3]);
	     * // => 3
	     *
	     * _.size({ 'a': 1, 'b': 2 });
	     * // => 2
	     *
	     * _.size('pebbles');
	     * // => 7
	     */
	    function size(collection) {
	      if (collection == null) {
	        return 0;
	      }
	      if (isArrayLike(collection)) {
	        return isString(collection) ? stringSize(collection) : collection.length;
	      }
	      var tag = getTag(collection);
	      if (tag == mapTag || tag == setTag) {
	        return collection.size;
	      }
	      return baseKeys(collection).length;
	    }
	
	    /**
	     * Checks if `predicate` returns truthy for **any** element of `collection`.
	     * Iteration is stopped once `predicate` returns truthy. The predicate is
	     * invoked with three arguments: (value, index|key, collection).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {boolean} Returns `true` if any element passes the predicate check,
	     *  else `false`.
	     * @example
	     *
	     * _.some([null, 0, 'yes', false], Boolean);
	     * // => true
	     *
	     * var users = [
	     *   { 'user': 'barney', 'active': true },
	     *   { 'user': 'fred',   'active': false }
	     * ];
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.some(users, { 'user': 'barney', 'active': false });
	     * // => false
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.some(users, ['active', false]);
	     * // => true
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.some(users, 'active');
	     * // => true
	     */
	    function some(collection, predicate, guard) {
	      var func = isArray(collection) ? arraySome : baseSome;
	      if (guard && isIterateeCall(collection, predicate, guard)) {
	        predicate = undefined;
	      }
	      return func(collection, getIteratee(predicate, 3));
	    }
	
	    /**
	     * Creates an array of elements, sorted in ascending order by the results of
	     * running each element in a collection thru each iteratee. This method
	     * performs a stable sort, that is, it preserves the original sort order of
	     * equal elements. The iteratees are invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {...(Function|Function[])} [iteratees=[_.identity]]
	     *  The iteratees to sort by.
	     * @returns {Array} Returns the new sorted array.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'fred',   'age': 48 },
	     *   { 'user': 'barney', 'age': 36 },
	     *   { 'user': 'fred',   'age': 40 },
	     *   { 'user': 'barney', 'age': 34 }
	     * ];
	     *
	     * _.sortBy(users, [function(o) { return o.user; }]);
	     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 40]]
	     *
	     * _.sortBy(users, ['user', 'age']);
	     * // => objects for [['barney', 34], ['barney', 36], ['fred', 40], ['fred', 48]]
	     */
	    var sortBy = baseRest(function(collection, iteratees) {
	      if (collection == null) {
	        return [];
	      }
	      var length = iteratees.length;
	      if (length > 1 && isIterateeCall(collection, iteratees[0], iteratees[1])) {
	        iteratees = [];
	      } else if (length > 2 && isIterateeCall(iteratees[0], iteratees[1], iteratees[2])) {
	        iteratees = [iteratees[0]];
	      }
	      return baseOrderBy(collection, baseFlatten(iteratees, 1), []);
	    });
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Gets the timestamp of the number of milliseconds that have elapsed since
	     * the Unix epoch (1 January 1970 00:00:00 UTC).
	     *
	     * @static
	     * @memberOf _
	     * @since 2.4.0
	     * @category Date
	     * @returns {number} Returns the timestamp.
	     * @example
	     *
	     * _.defer(function(stamp) {
	     *   console.log(_.now() - stamp);
	     * }, _.now());
	     * // => Logs the number of milliseconds it took for the deferred invocation.
	     */
	    var now = ctxNow || function() {
	      return root.Date.now();
	    };
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * The opposite of `_.before`; this method creates a function that invokes
	     * `func` once it's called `n` or more times.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {number} n The number of calls before `func` is invoked.
	     * @param {Function} func The function to restrict.
	     * @returns {Function} Returns the new restricted function.
	     * @example
	     *
	     * var saves = ['profile', 'settings'];
	     *
	     * var done = _.after(saves.length, function() {
	     *   console.log('done saving!');
	     * });
	     *
	     * _.forEach(saves, function(type) {
	     *   asyncSave({ 'type': type, 'complete': done });
	     * });
	     * // => Logs 'done saving!' after the two async saves have completed.
	     */
	    function after(n, func) {
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      n = toInteger(n);
	      return function() {
	        if (--n < 1) {
	          return func.apply(this, arguments);
	        }
	      };
	    }
	
	    /**
	     * Creates a function that invokes `func`, with up to `n` arguments,
	     * ignoring any additional arguments.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Function
	     * @param {Function} func The function to cap arguments for.
	     * @param {number} [n=func.length] The arity cap.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Function} Returns the new capped function.
	     * @example
	     *
	     * _.map(['6', '8', '10'], _.ary(parseInt, 1));
	     * // => [6, 8, 10]
	     */
	    function ary(func, n, guard) {
	      n = guard ? undefined : n;
	      n = (func && n == null) ? func.length : n;
	      return createWrap(func, WRAP_ARY_FLAG, undefined, undefined, undefined, undefined, n);
	    }
	
	    /**
	     * Creates a function that invokes `func`, with the `this` binding and arguments
	     * of the created function, while it's called less than `n` times. Subsequent
	     * calls to the created function return the result of the last `func` invocation.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Function
	     * @param {number} n The number of calls at which `func` is no longer invoked.
	     * @param {Function} func The function to restrict.
	     * @returns {Function} Returns the new restricted function.
	     * @example
	     *
	     * jQuery(element).on('click', _.before(5, addContactToList));
	     * // => Allows adding up to 4 contacts to the list.
	     */
	    function before(n, func) {
	      var result;
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      n = toInteger(n);
	      return function() {
	        if (--n > 0) {
	          result = func.apply(this, arguments);
	        }
	        if (n <= 1) {
	          func = undefined;
	        }
	        return result;
	      };
	    }
	
	    /**
	     * Creates a function that invokes `func` with the `this` binding of `thisArg`
	     * and `partials` prepended to the arguments it receives.
	     *
	     * The `_.bind.placeholder` value, which defaults to `_` in monolithic builds,
	     * may be used as a placeholder for partially applied arguments.
	     *
	     * **Note:** Unlike native `Function#bind`, this method doesn't set the "length"
	     * property of bound functions.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {Function} func The function to bind.
	     * @param {*} thisArg The `this` binding of `func`.
	     * @param {...*} [partials] The arguments to be partially applied.
	     * @returns {Function} Returns the new bound function.
	     * @example
	     *
	     * function greet(greeting, punctuation) {
	     *   return greeting + ' ' + this.user + punctuation;
	     * }
	     *
	     * var object = { 'user': 'fred' };
	     *
	     * var bound = _.bind(greet, object, 'hi');
	     * bound('!');
	     * // => 'hi fred!'
	     *
	     * // Bound with placeholders.
	     * var bound = _.bind(greet, object, _, '!');
	     * bound('hi');
	     * // => 'hi fred!'
	     */
	    var bind = baseRest(function(func, thisArg, partials) {
	      var bitmask = WRAP_BIND_FLAG;
	      if (partials.length) {
	        var holders = replaceHolders(partials, getHolder(bind));
	        bitmask |= WRAP_PARTIAL_FLAG;
	      }
	      return createWrap(func, bitmask, thisArg, partials, holders);
	    });
	
	    /**
	     * Creates a function that invokes the method at `object[key]` with `partials`
	     * prepended to the arguments it receives.
	     *
	     * This method differs from `_.bind` by allowing bound functions to reference
	     * methods that may be redefined or don't yet exist. See
	     * [Peter Michaux's article](http://peter.michaux.ca/articles/lazy-function-definition-pattern)
	     * for more details.
	     *
	     * The `_.bindKey.placeholder` value, which defaults to `_` in monolithic
	     * builds, may be used as a placeholder for partially applied arguments.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.10.0
	     * @category Function
	     * @param {Object} object The object to invoke the method on.
	     * @param {string} key The key of the method.
	     * @param {...*} [partials] The arguments to be partially applied.
	     * @returns {Function} Returns the new bound function.
	     * @example
	     *
	     * var object = {
	     *   'user': 'fred',
	     *   'greet': function(greeting, punctuation) {
	     *     return greeting + ' ' + this.user + punctuation;
	     *   }
	     * };
	     *
	     * var bound = _.bindKey(object, 'greet', 'hi');
	     * bound('!');
	     * // => 'hi fred!'
	     *
	     * object.greet = function(greeting, punctuation) {
	     *   return greeting + 'ya ' + this.user + punctuation;
	     * };
	     *
	     * bound('!');
	     * // => 'hiya fred!'
	     *
	     * // Bound with placeholders.
	     * var bound = _.bindKey(object, 'greet', _, '!');
	     * bound('hi');
	     * // => 'hiya fred!'
	     */
	    var bindKey = baseRest(function(object, key, partials) {
	      var bitmask = WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG;
	      if (partials.length) {
	        var holders = replaceHolders(partials, getHolder(bindKey));
	        bitmask |= WRAP_PARTIAL_FLAG;
	      }
	      return createWrap(key, bitmask, object, partials, holders);
	    });
	
	    /**
	     * Creates a function that accepts arguments of `func` and either invokes
	     * `func` returning its result, if at least `arity` number of arguments have
	     * been provided, or returns a function that accepts the remaining `func`
	     * arguments, and so on. The arity of `func` may be specified if `func.length`
	     * is not sufficient.
	     *
	     * The `_.curry.placeholder` value, which defaults to `_` in monolithic builds,
	     * may be used as a placeholder for provided arguments.
	     *
	     * **Note:** This method doesn't set the "length" property of curried functions.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Function
	     * @param {Function} func The function to curry.
	     * @param {number} [arity=func.length] The arity of `func`.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Function} Returns the new curried function.
	     * @example
	     *
	     * var abc = function(a, b, c) {
	     *   return [a, b, c];
	     * };
	     *
	     * var curried = _.curry(abc);
	     *
	     * curried(1)(2)(3);
	     * // => [1, 2, 3]
	     *
	     * curried(1, 2)(3);
	     * // => [1, 2, 3]
	     *
	     * curried(1, 2, 3);
	     * // => [1, 2, 3]
	     *
	     * // Curried with placeholders.
	     * curried(1)(_, 3)(2);
	     * // => [1, 2, 3]
	     */
	    function curry(func, arity, guard) {
	      arity = guard ? undefined : arity;
	      var result = createWrap(func, WRAP_CURRY_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
	      result.placeholder = curry.placeholder;
	      return result;
	    }
	
	    /**
	     * This method is like `_.curry` except that arguments are applied to `func`
	     * in the manner of `_.partialRight` instead of `_.partial`.
	     *
	     * The `_.curryRight.placeholder` value, which defaults to `_` in monolithic
	     * builds, may be used as a placeholder for provided arguments.
	     *
	     * **Note:** This method doesn't set the "length" property of curried functions.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Function
	     * @param {Function} func The function to curry.
	     * @param {number} [arity=func.length] The arity of `func`.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Function} Returns the new curried function.
	     * @example
	     *
	     * var abc = function(a, b, c) {
	     *   return [a, b, c];
	     * };
	     *
	     * var curried = _.curryRight(abc);
	     *
	     * curried(3)(2)(1);
	     * // => [1, 2, 3]
	     *
	     * curried(2, 3)(1);
	     * // => [1, 2, 3]
	     *
	     * curried(1, 2, 3);
	     * // => [1, 2, 3]
	     *
	     * // Curried with placeholders.
	     * curried(3)(1, _)(2);
	     * // => [1, 2, 3]
	     */
	    function curryRight(func, arity, guard) {
	      arity = guard ? undefined : arity;
	      var result = createWrap(func, WRAP_CURRY_RIGHT_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
	      result.placeholder = curryRight.placeholder;
	      return result;
	    }
	
	    /**
	     * Creates a debounced function that delays invoking `func` until after `wait`
	     * milliseconds have elapsed since the last time the debounced function was
	     * invoked. The debounced function comes with a `cancel` method to cancel
	     * delayed `func` invocations and a `flush` method to immediately invoke them.
	     * Provide `options` to indicate whether `func` should be invoked on the
	     * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
	     * with the last arguments provided to the debounced function. Subsequent
	     * calls to the debounced function return the result of the last `func`
	     * invocation.
	     *
	     * **Note:** If `leading` and `trailing` options are `true`, `func` is
	     * invoked on the trailing edge of the timeout only if the debounced function
	     * is invoked more than once during the `wait` timeout.
	     *
	     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
	     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
	     *
	     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
	     * for details over the differences between `_.debounce` and `_.throttle`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {Function} func The function to debounce.
	     * @param {number} [wait=0] The number of milliseconds to delay.
	     * @param {Object} [options={}] The options object.
	     * @param {boolean} [options.leading=false]
	     *  Specify invoking on the leading edge of the timeout.
	     * @param {number} [options.maxWait]
	     *  The maximum time `func` is allowed to be delayed before it's invoked.
	     * @param {boolean} [options.trailing=true]
	     *  Specify invoking on the trailing edge of the timeout.
	     * @returns {Function} Returns the new debounced function.
	     * @example
	     *
	     * // Avoid costly calculations while the window size is in flux.
	     * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
	     *
	     * // Invoke `sendMail` when clicked, debouncing subsequent calls.
	     * jQuery(element).on('click', _.debounce(sendMail, 300, {
	     *   'leading': true,
	     *   'trailing': false
	     * }));
	     *
	     * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
	     * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
	     * var source = new EventSource('/stream');
	     * jQuery(source).on('message', debounced);
	     *
	     * // Cancel the trailing debounced invocation.
	     * jQuery(window).on('popstate', debounced.cancel);
	     */
	    function debounce(func, wait, options) {
	      var lastArgs,
	          lastThis,
	          maxWait,
	          result,
	          timerId,
	          lastCallTime,
	          lastInvokeTime = 0,
	          leading = false,
	          maxing = false,
	          trailing = true;
	
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      wait = toNumber(wait) || 0;
	      if (isObject(options)) {
	        leading = !!options.leading;
	        maxing = 'maxWait' in options;
	        maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
	        trailing = 'trailing' in options ? !!options.trailing : trailing;
	      }
	
	      function invokeFunc(time) {
	        var args = lastArgs,
	            thisArg = lastThis;
	
	        lastArgs = lastThis = undefined;
	        lastInvokeTime = time;
	        result = func.apply(thisArg, args);
	        return result;
	      }
	
	      function leadingEdge(time) {
	        // Reset any `maxWait` timer.
	        lastInvokeTime = time;
	        // Start the timer for the trailing edge.
	        timerId = setTimeout(timerExpired, wait);
	        // Invoke the leading edge.
	        return leading ? invokeFunc(time) : result;
	      }
	
	      function remainingWait(time) {
	        var timeSinceLastCall = time - lastCallTime,
	            timeSinceLastInvoke = time - lastInvokeTime,
	            timeWaiting = wait - timeSinceLastCall;
	
	        return maxing
	          ? nativeMin(timeWaiting, maxWait - timeSinceLastInvoke)
	          : timeWaiting;
	      }
	
	      function shouldInvoke(time) {
	        var timeSinceLastCall = time - lastCallTime,
	            timeSinceLastInvoke = time - lastInvokeTime;
	
	        // Either this is the first call, activity has stopped and we're at the
	        // trailing edge, the system time has gone backwards and we're treating
	        // it as the trailing edge, or we've hit the `maxWait` limit.
	        return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
	          (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
	      }
	
	      function timerExpired() {
	        var time = now();
	        if (shouldInvoke(time)) {
	          return trailingEdge(time);
	        }
	        // Restart the timer.
	        timerId = setTimeout(timerExpired, remainingWait(time));
	      }
	
	      function trailingEdge(time) {
	        timerId = undefined;
	
	        // Only invoke if we have `lastArgs` which means `func` has been
	        // debounced at least once.
	        if (trailing && lastArgs) {
	          return invokeFunc(time);
	        }
	        lastArgs = lastThis = undefined;
	        return result;
	      }
	
	      function cancel() {
	        if (timerId !== undefined) {
	          clearTimeout(timerId);
	        }
	        lastInvokeTime = 0;
	        lastArgs = lastCallTime = lastThis = timerId = undefined;
	      }
	
	      function flush() {
	        return timerId === undefined ? result : trailingEdge(now());
	      }
	
	      function debounced() {
	        var time = now(),
	            isInvoking = shouldInvoke(time);
	
	        lastArgs = arguments;
	        lastThis = this;
	        lastCallTime = time;
	
	        if (isInvoking) {
	          if (timerId === undefined) {
	            return leadingEdge(lastCallTime);
	          }
	          if (maxing) {
	            // Handle invocations in a tight loop.
	            timerId = setTimeout(timerExpired, wait);
	            return invokeFunc(lastCallTime);
	          }
	        }
	        if (timerId === undefined) {
	          timerId = setTimeout(timerExpired, wait);
	        }
	        return result;
	      }
	      debounced.cancel = cancel;
	      debounced.flush = flush;
	      return debounced;
	    }
	
	    /**
	     * Defers invoking the `func` until the current call stack has cleared. Any
	     * additional arguments are provided to `func` when it's invoked.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {Function} func The function to defer.
	     * @param {...*} [args] The arguments to invoke `func` with.
	     * @returns {number} Returns the timer id.
	     * @example
	     *
	     * _.defer(function(text) {
	     *   console.log(text);
	     * }, 'deferred');
	     * // => Logs 'deferred' after one millisecond.
	     */
	    var defer = baseRest(function(func, args) {
	      return baseDelay(func, 1, args);
	    });
	
	    /**
	     * Invokes `func` after `wait` milliseconds. Any additional arguments are
	     * provided to `func` when it's invoked.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {Function} func The function to delay.
	     * @param {number} wait The number of milliseconds to delay invocation.
	     * @param {...*} [args] The arguments to invoke `func` with.
	     * @returns {number} Returns the timer id.
	     * @example
	     *
	     * _.delay(function(text) {
	     *   console.log(text);
	     * }, 1000, 'later');
	     * // => Logs 'later' after one second.
	     */
	    var delay = baseRest(function(func, wait, args) {
	      return baseDelay(func, toNumber(wait) || 0, args);
	    });
	
	    /**
	     * Creates a function that invokes `func` with arguments reversed.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Function
	     * @param {Function} func The function to flip arguments for.
	     * @returns {Function} Returns the new flipped function.
	     * @example
	     *
	     * var flipped = _.flip(function() {
	     *   return _.toArray(arguments);
	     * });
	     *
	     * flipped('a', 'b', 'c', 'd');
	     * // => ['d', 'c', 'b', 'a']
	     */
	    function flip(func) {
	      return createWrap(func, WRAP_FLIP_FLAG);
	    }
	
	    /**
	     * Creates a function that memoizes the result of `func`. If `resolver` is
	     * provided, it determines the cache key for storing the result based on the
	     * arguments provided to the memoized function. By default, the first argument
	     * provided to the memoized function is used as the map cache key. The `func`
	     * is invoked with the `this` binding of the memoized function.
	     *
	     * **Note:** The cache is exposed as the `cache` property on the memoized
	     * function. Its creation may be customized by replacing the `_.memoize.Cache`
	     * constructor with one whose instances implement the
	     * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
	     * method interface of `clear`, `delete`, `get`, `has`, and `set`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {Function} func The function to have its output memoized.
	     * @param {Function} [resolver] The function to resolve the cache key.
	     * @returns {Function} Returns the new memoized function.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': 2 };
	     * var other = { 'c': 3, 'd': 4 };
	     *
	     * var values = _.memoize(_.values);
	     * values(object);
	     * // => [1, 2]
	     *
	     * values(other);
	     * // => [3, 4]
	     *
	     * object.a = 2;
	     * values(object);
	     * // => [1, 2]
	     *
	     * // Modify the result cache.
	     * values.cache.set(object, ['a', 'b']);
	     * values(object);
	     * // => ['a', 'b']
	     *
	     * // Replace `_.memoize.Cache`.
	     * _.memoize.Cache = WeakMap;
	     */
	    function memoize(func, resolver) {
	      if (typeof func != 'function' || (resolver != null && typeof resolver != 'function')) {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      var memoized = function() {
	        var args = arguments,
	            key = resolver ? resolver.apply(this, args) : args[0],
	            cache = memoized.cache;
	
	        if (cache.has(key)) {
	          return cache.get(key);
	        }
	        var result = func.apply(this, args);
	        memoized.cache = cache.set(key, result) || cache;
	        return result;
	      };
	      memoized.cache = new (memoize.Cache || MapCache);
	      return memoized;
	    }
	
	    // Expose `MapCache`.
	    memoize.Cache = MapCache;
	
	    /**
	     * Creates a function that negates the result of the predicate `func`. The
	     * `func` predicate is invoked with the `this` binding and arguments of the
	     * created function.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Function
	     * @param {Function} predicate The predicate to negate.
	     * @returns {Function} Returns the new negated function.
	     * @example
	     *
	     * function isEven(n) {
	     *   return n % 2 == 0;
	     * }
	     *
	     * _.filter([1, 2, 3, 4, 5, 6], _.negate(isEven));
	     * // => [1, 3, 5]
	     */
	    function negate(predicate) {
	      if (typeof predicate != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      return function() {
	        var args = arguments;
	        switch (args.length) {
	          case 0: return !predicate.call(this);
	          case 1: return !predicate.call(this, args[0]);
	          case 2: return !predicate.call(this, args[0], args[1]);
	          case 3: return !predicate.call(this, args[0], args[1], args[2]);
	        }
	        return !predicate.apply(this, args);
	      };
	    }
	
	    /**
	     * Creates a function that is restricted to invoking `func` once. Repeat calls
	     * to the function return the value of the first invocation. The `func` is
	     * invoked with the `this` binding and arguments of the created function.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {Function} func The function to restrict.
	     * @returns {Function} Returns the new restricted function.
	     * @example
	     *
	     * var initialize = _.once(createApplication);
	     * initialize();
	     * initialize();
	     * // => `createApplication` is invoked once
	     */
	    function once(func) {
	      return before(2, func);
	    }
	
	    /**
	     * Creates a function that invokes `func` with its arguments transformed.
	     *
	     * @static
	     * @since 4.0.0
	     * @memberOf _
	     * @category Function
	     * @param {Function} func The function to wrap.
	     * @param {...(Function|Function[])} [transforms=[_.identity]]
	     *  The argument transforms.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * function doubled(n) {
	     *   return n * 2;
	     * }
	     *
	     * function square(n) {
	     *   return n * n;
	     * }
	     *
	     * var func = _.overArgs(function(x, y) {
	     *   return [x, y];
	     * }, [square, doubled]);
	     *
	     * func(9, 3);
	     * // => [81, 6]
	     *
	     * func(10, 5);
	     * // => [100, 10]
	     */
	    var overArgs = castRest(function(func, transforms) {
	      transforms = (transforms.length == 1 && isArray(transforms[0]))
	        ? arrayMap(transforms[0], baseUnary(getIteratee()))
	        : arrayMap(baseFlatten(transforms, 1), baseUnary(getIteratee()));
	
	      var funcsLength = transforms.length;
	      return baseRest(function(args) {
	        var index = -1,
	            length = nativeMin(args.length, funcsLength);
	
	        while (++index < length) {
	          args[index] = transforms[index].call(this, args[index]);
	        }
	        return apply(func, this, args);
	      });
	    });
	
	    /**
	     * Creates a function that invokes `func` with `partials` prepended to the
	     * arguments it receives. This method is like `_.bind` except it does **not**
	     * alter the `this` binding.
	     *
	     * The `_.partial.placeholder` value, which defaults to `_` in monolithic
	     * builds, may be used as a placeholder for partially applied arguments.
	     *
	     * **Note:** This method doesn't set the "length" property of partially
	     * applied functions.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.2.0
	     * @category Function
	     * @param {Function} func The function to partially apply arguments to.
	     * @param {...*} [partials] The arguments to be partially applied.
	     * @returns {Function} Returns the new partially applied function.
	     * @example
	     *
	     * function greet(greeting, name) {
	     *   return greeting + ' ' + name;
	     * }
	     *
	     * var sayHelloTo = _.partial(greet, 'hello');
	     * sayHelloTo('fred');
	     * // => 'hello fred'
	     *
	     * // Partially applied with placeholders.
	     * var greetFred = _.partial(greet, _, 'fred');
	     * greetFred('hi');
	     * // => 'hi fred'
	     */
	    var partial = baseRest(function(func, partials) {
	      var holders = replaceHolders(partials, getHolder(partial));
	      return createWrap(func, WRAP_PARTIAL_FLAG, undefined, partials, holders);
	    });
	
	    /**
	     * This method is like `_.partial` except that partially applied arguments
	     * are appended to the arguments it receives.
	     *
	     * The `_.partialRight.placeholder` value, which defaults to `_` in monolithic
	     * builds, may be used as a placeholder for partially applied arguments.
	     *
	     * **Note:** This method doesn't set the "length" property of partially
	     * applied functions.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.0.0
	     * @category Function
	     * @param {Function} func The function to partially apply arguments to.
	     * @param {...*} [partials] The arguments to be partially applied.
	     * @returns {Function} Returns the new partially applied function.
	     * @example
	     *
	     * function greet(greeting, name) {
	     *   return greeting + ' ' + name;
	     * }
	     *
	     * var greetFred = _.partialRight(greet, 'fred');
	     * greetFred('hi');
	     * // => 'hi fred'
	     *
	     * // Partially applied with placeholders.
	     * var sayHelloTo = _.partialRight(greet, 'hello', _);
	     * sayHelloTo('fred');
	     * // => 'hello fred'
	     */
	    var partialRight = baseRest(function(func, partials) {
	      var holders = replaceHolders(partials, getHolder(partialRight));
	      return createWrap(func, WRAP_PARTIAL_RIGHT_FLAG, undefined, partials, holders);
	    });
	
	    /**
	     * Creates a function that invokes `func` with arguments arranged according
	     * to the specified `indexes` where the argument value at the first index is
	     * provided as the first argument, the argument value at the second index is
	     * provided as the second argument, and so on.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Function
	     * @param {Function} func The function to rearrange arguments for.
	     * @param {...(number|number[])} indexes The arranged argument indexes.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var rearged = _.rearg(function(a, b, c) {
	     *   return [a, b, c];
	     * }, [2, 0, 1]);
	     *
	     * rearged('b', 'c', 'a')
	     * // => ['a', 'b', 'c']
	     */
	    var rearg = flatRest(function(func, indexes) {
	      return createWrap(func, WRAP_REARG_FLAG, undefined, undefined, undefined, indexes);
	    });
	
	    /**
	     * Creates a function that invokes `func` with the `this` binding of the
	     * created function and arguments from `start` and beyond provided as
	     * an array.
	     *
	     * **Note:** This method is based on the
	     * [rest parameter](https://mdn.io/rest_parameters).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Function
	     * @param {Function} func The function to apply a rest parameter to.
	     * @param {number} [start=func.length-1] The start position of the rest parameter.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var say = _.rest(function(what, names) {
	     *   return what + ' ' + _.initial(names).join(', ') +
	     *     (_.size(names) > 1 ? ', & ' : '') + _.last(names);
	     * });
	     *
	     * say('hello', 'fred', 'barney', 'pebbles');
	     * // => 'hello fred, barney, & pebbles'
	     */
	    function rest(func, start) {
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      start = start === undefined ? start : toInteger(start);
	      return baseRest(func, start);
	    }
	
	    /**
	     * Creates a function that invokes `func` with the `this` binding of the
	     * create function and an array of arguments much like
	     * [`Function#apply`](http://www.ecma-international.org/ecma-262/7.0/#sec-function.prototype.apply).
	     *
	     * **Note:** This method is based on the
	     * [spread operator](https://mdn.io/spread_operator).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.2.0
	     * @category Function
	     * @param {Function} func The function to spread arguments over.
	     * @param {number} [start=0] The start position of the spread.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var say = _.spread(function(who, what) {
	     *   return who + ' says ' + what;
	     * });
	     *
	     * say(['fred', 'hello']);
	     * // => 'fred says hello'
	     *
	     * var numbers = Promise.all([
	     *   Promise.resolve(40),
	     *   Promise.resolve(36)
	     * ]);
	     *
	     * numbers.then(_.spread(function(x, y) {
	     *   return x + y;
	     * }));
	     * // => a Promise of 76
	     */
	    function spread(func, start) {
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      start = start == null ? 0 : nativeMax(toInteger(start), 0);
	      return baseRest(function(args) {
	        var array = args[start],
	            otherArgs = castSlice(args, 0, start);
	
	        if (array) {
	          arrayPush(otherArgs, array);
	        }
	        return apply(func, this, otherArgs);
	      });
	    }
	
	    /**
	     * Creates a throttled function that only invokes `func` at most once per
	     * every `wait` milliseconds. The throttled function comes with a `cancel`
	     * method to cancel delayed `func` invocations and a `flush` method to
	     * immediately invoke them. Provide `options` to indicate whether `func`
	     * should be invoked on the leading and/or trailing edge of the `wait`
	     * timeout. The `func` is invoked with the last arguments provided to the
	     * throttled function. Subsequent calls to the throttled function return the
	     * result of the last `func` invocation.
	     *
	     * **Note:** If `leading` and `trailing` options are `true`, `func` is
	     * invoked on the trailing edge of the timeout only if the throttled function
	     * is invoked more than once during the `wait` timeout.
	     *
	     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
	     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
	     *
	     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
	     * for details over the differences between `_.throttle` and `_.debounce`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {Function} func The function to throttle.
	     * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
	     * @param {Object} [options={}] The options object.
	     * @param {boolean} [options.leading=true]
	     *  Specify invoking on the leading edge of the timeout.
	     * @param {boolean} [options.trailing=true]
	     *  Specify invoking on the trailing edge of the timeout.
	     * @returns {Function} Returns the new throttled function.
	     * @example
	     *
	     * // Avoid excessively updating the position while scrolling.
	     * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
	     *
	     * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
	     * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
	     * jQuery(element).on('click', throttled);
	     *
	     * // Cancel the trailing throttled invocation.
	     * jQuery(window).on('popstate', throttled.cancel);
	     */
	    function throttle(func, wait, options) {
	      var leading = true,
	          trailing = true;
	
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      if (isObject(options)) {
	        leading = 'leading' in options ? !!options.leading : leading;
	        trailing = 'trailing' in options ? !!options.trailing : trailing;
	      }
	      return debounce(func, wait, {
	        'leading': leading,
	        'maxWait': wait,
	        'trailing': trailing
	      });
	    }
	
	    /**
	     * Creates a function that accepts up to one argument, ignoring any
	     * additional arguments.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Function
	     * @param {Function} func The function to cap arguments for.
	     * @returns {Function} Returns the new capped function.
	     * @example
	     *
	     * _.map(['6', '8', '10'], _.unary(parseInt));
	     * // => [6, 8, 10]
	     */
	    function unary(func) {
	      return ary(func, 1);
	    }
	
	    /**
	     * Creates a function that provides `value` to `wrapper` as its first
	     * argument. Any additional arguments provided to the function are appended
	     * to those provided to the `wrapper`. The wrapper is invoked with the `this`
	     * binding of the created function.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {*} value The value to wrap.
	     * @param {Function} [wrapper=identity] The wrapper function.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var p = _.wrap(_.escape, function(func, text) {
	     *   return '<p>' + func(text) + '</p>';
	     * });
	     *
	     * p('fred, barney, & pebbles');
	     * // => '<p>fred, barney, &amp; pebbles</p>'
	     */
	    function wrap(value, wrapper) {
	      return partial(castFunction(wrapper), value);
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Casts `value` as an array if it's not one.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.4.0
	     * @category Lang
	     * @param {*} value The value to inspect.
	     * @returns {Array} Returns the cast array.
	     * @example
	     *
	     * _.castArray(1);
	     * // => [1]
	     *
	     * _.castArray({ 'a': 1 });
	     * // => [{ 'a': 1 }]
	     *
	     * _.castArray('abc');
	     * // => ['abc']
	     *
	     * _.castArray(null);
	     * // => [null]
	     *
	     * _.castArray(undefined);
	     * // => [undefined]
	     *
	     * _.castArray();
	     * // => []
	     *
	     * var array = [1, 2, 3];
	     * console.log(_.castArray(array) === array);
	     * // => true
	     */
	    function castArray() {
	      if (!arguments.length) {
	        return [];
	      }
	      var value = arguments[0];
	      return isArray(value) ? value : [value];
	    }
	
	    /**
	     * Creates a shallow clone of `value`.
	     *
	     * **Note:** This method is loosely based on the
	     * [structured clone algorithm](https://mdn.io/Structured_clone_algorithm)
	     * and supports cloning arrays, array buffers, booleans, date objects, maps,
	     * numbers, `Object` objects, regexes, sets, strings, symbols, and typed
	     * arrays. The own enumerable properties of `arguments` objects are cloned
	     * as plain objects. An empty object is returned for uncloneable values such
	     * as error objects, functions, DOM nodes, and WeakMaps.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to clone.
	     * @returns {*} Returns the cloned value.
	     * @see _.cloneDeep
	     * @example
	     *
	     * var objects = [{ 'a': 1 }, { 'b': 2 }];
	     *
	     * var shallow = _.clone(objects);
	     * console.log(shallow[0] === objects[0]);
	     * // => true
	     */
	    function clone(value) {
	      return baseClone(value, CLONE_SYMBOLS_FLAG);
	    }
	
	    /**
	     * This method is like `_.clone` except that it accepts `customizer` which
	     * is invoked to produce the cloned value. If `customizer` returns `undefined`,
	     * cloning is handled by the method instead. The `customizer` is invoked with
	     * up to four arguments; (value [, index|key, object, stack]).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to clone.
	     * @param {Function} [customizer] The function to customize cloning.
	     * @returns {*} Returns the cloned value.
	     * @see _.cloneDeepWith
	     * @example
	     *
	     * function customizer(value) {
	     *   if (_.isElement(value)) {
	     *     return value.cloneNode(false);
	     *   }
	     * }
	     *
	     * var el = _.cloneWith(document.body, customizer);
	     *
	     * console.log(el === document.body);
	     * // => false
	     * console.log(el.nodeName);
	     * // => 'BODY'
	     * console.log(el.childNodes.length);
	     * // => 0
	     */
	    function cloneWith(value, customizer) {
	      customizer = typeof customizer == 'function' ? customizer : undefined;
	      return baseClone(value, CLONE_SYMBOLS_FLAG, customizer);
	    }
	
	    /**
	     * This method is like `_.clone` except that it recursively clones `value`.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.0.0
	     * @category Lang
	     * @param {*} value The value to recursively clone.
	     * @returns {*} Returns the deep cloned value.
	     * @see _.clone
	     * @example
	     *
	     * var objects = [{ 'a': 1 }, { 'b': 2 }];
	     *
	     * var deep = _.cloneDeep(objects);
	     * console.log(deep[0] === objects[0]);
	     * // => false
	     */
	    function cloneDeep(value) {
	      return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG);
	    }
	
	    /**
	     * This method is like `_.cloneWith` except that it recursively clones `value`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to recursively clone.
	     * @param {Function} [customizer] The function to customize cloning.
	     * @returns {*} Returns the deep cloned value.
	     * @see _.cloneWith
	     * @example
	     *
	     * function customizer(value) {
	     *   if (_.isElement(value)) {
	     *     return value.cloneNode(true);
	     *   }
	     * }
	     *
	     * var el = _.cloneDeepWith(document.body, customizer);
	     *
	     * console.log(el === document.body);
	     * // => false
	     * console.log(el.nodeName);
	     * // => 'BODY'
	     * console.log(el.childNodes.length);
	     * // => 20
	     */
	    function cloneDeepWith(value, customizer) {
	      customizer = typeof customizer == 'function' ? customizer : undefined;
	      return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG, customizer);
	    }
	
	    /**
	     * Checks if `object` conforms to `source` by invoking the predicate
	     * properties of `source` with the corresponding property values of `object`.
	     *
	     * **Note:** This method is equivalent to `_.conforms` when `source` is
	     * partially applied.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.14.0
	     * @category Lang
	     * @param {Object} object The object to inspect.
	     * @param {Object} source The object of property predicates to conform to.
	     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': 2 };
	     *
	     * _.conformsTo(object, { 'b': function(n) { return n > 1; } });
	     * // => true
	     *
	     * _.conformsTo(object, { 'b': function(n) { return n > 2; } });
	     * // => false
	     */
	    function conformsTo(object, source) {
	      return source == null || baseConformsTo(object, source, keys(source));
	    }
	
	    /**
	     * Performs a
	     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * comparison between two values to determine if they are equivalent.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	     * @example
	     *
	     * var object = { 'a': 1 };
	     * var other = { 'a': 1 };
	     *
	     * _.eq(object, object);
	     * // => true
	     *
	     * _.eq(object, other);
	     * // => false
	     *
	     * _.eq('a', 'a');
	     * // => true
	     *
	     * _.eq('a', Object('a'));
	     * // => false
	     *
	     * _.eq(NaN, NaN);
	     * // => true
	     */
	    function eq(value, other) {
	      return value === other || (value !== value && other !== other);
	    }
	
	    /**
	     * Checks if `value` is greater than `other`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.9.0
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if `value` is greater than `other`,
	     *  else `false`.
	     * @see _.lt
	     * @example
	     *
	     * _.gt(3, 1);
	     * // => true
	     *
	     * _.gt(3, 3);
	     * // => false
	     *
	     * _.gt(1, 3);
	     * // => false
	     */
	    var gt = createRelationalOperation(baseGt);
	
	    /**
	     * Checks if `value` is greater than or equal to `other`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.9.0
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if `value` is greater than or equal to
	     *  `other`, else `false`.
	     * @see _.lte
	     * @example
	     *
	     * _.gte(3, 1);
	     * // => true
	     *
	     * _.gte(3, 3);
	     * // => true
	     *
	     * _.gte(1, 3);
	     * // => false
	     */
	    var gte = createRelationalOperation(function(value, other) {
	      return value >= other;
	    });
	
	    /**
	     * Checks if `value` is likely an `arguments` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
	     *  else `false`.
	     * @example
	     *
	     * _.isArguments(function() { return arguments; }());
	     * // => true
	     *
	     * _.isArguments([1, 2, 3]);
	     * // => false
	     */
	    var isArguments = baseIsArguments(function() { return arguments; }()) ? baseIsArguments : function(value) {
	      return isObjectLike(value) && hasOwnProperty.call(value, 'callee') &&
	        !propertyIsEnumerable.call(value, 'callee');
	    };
	
	    /**
	     * Checks if `value` is classified as an `Array` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an array, else `false`.
	     * @example
	     *
	     * _.isArray([1, 2, 3]);
	     * // => true
	     *
	     * _.isArray(document.body.children);
	     * // => false
	     *
	     * _.isArray('abc');
	     * // => false
	     *
	     * _.isArray(_.noop);
	     * // => false
	     */
	    var isArray = Array.isArray;
	
	    /**
	     * Checks if `value` is classified as an `ArrayBuffer` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.3.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
	     * @example
	     *
	     * _.isArrayBuffer(new ArrayBuffer(2));
	     * // => true
	     *
	     * _.isArrayBuffer(new Array(2));
	     * // => false
	     */
	    var isArrayBuffer = nodeIsArrayBuffer ? baseUnary(nodeIsArrayBuffer) : baseIsArrayBuffer;
	
	    /**
	     * Checks if `value` is array-like. A value is considered array-like if it's
	     * not a function and has a `value.length` that's an integer greater than or
	     * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
	     * @example
	     *
	     * _.isArrayLike([1, 2, 3]);
	     * // => true
	     *
	     * _.isArrayLike(document.body.children);
	     * // => true
	     *
	     * _.isArrayLike('abc');
	     * // => true
	     *
	     * _.isArrayLike(_.noop);
	     * // => false
	     */
	    function isArrayLike(value) {
	      return value != null && isLength(value.length) && !isFunction(value);
	    }
	
	    /**
	     * This method is like `_.isArrayLike` except that it also checks if `value`
	     * is an object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an array-like object,
	     *  else `false`.
	     * @example
	     *
	     * _.isArrayLikeObject([1, 2, 3]);
	     * // => true
	     *
	     * _.isArrayLikeObject(document.body.children);
	     * // => true
	     *
	     * _.isArrayLikeObject('abc');
	     * // => false
	     *
	     * _.isArrayLikeObject(_.noop);
	     * // => false
	     */
	    function isArrayLikeObject(value) {
	      return isObjectLike(value) && isArrayLike(value);
	    }
	
	    /**
	     * Checks if `value` is classified as a boolean primitive or object.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a boolean, else `false`.
	     * @example
	     *
	     * _.isBoolean(false);
	     * // => true
	     *
	     * _.isBoolean(null);
	     * // => false
	     */
	    function isBoolean(value) {
	      return value === true || value === false ||
	        (isObjectLike(value) && baseGetTag(value) == boolTag);
	    }
	
	    /**
	     * Checks if `value` is a buffer.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.3.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
	     * @example
	     *
	     * _.isBuffer(new Buffer(2));
	     * // => true
	     *
	     * _.isBuffer(new Uint8Array(2));
	     * // => false
	     */
	    var isBuffer = nativeIsBuffer || stubFalse;
	
	    /**
	     * Checks if `value` is classified as a `Date` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
	     * @example
	     *
	     * _.isDate(new Date);
	     * // => true
	     *
	     * _.isDate('Mon April 23 2012');
	     * // => false
	     */
	    var isDate = nodeIsDate ? baseUnary(nodeIsDate) : baseIsDate;
	
	    /**
	     * Checks if `value` is likely a DOM element.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a DOM element, else `false`.
	     * @example
	     *
	     * _.isElement(document.body);
	     * // => true
	     *
	     * _.isElement('<body>');
	     * // => false
	     */
	    function isElement(value) {
	      return isObjectLike(value) && value.nodeType === 1 && !isPlainObject(value);
	    }
	
	    /**
	     * Checks if `value` is an empty object, collection, map, or set.
	     *
	     * Objects are considered empty if they have no own enumerable string keyed
	     * properties.
	     *
	     * Array-like values such as `arguments` objects, arrays, buffers, strings, or
	     * jQuery-like collections are considered empty if they have a `length` of `0`.
	     * Similarly, maps and sets are considered empty if they have a `size` of `0`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is empty, else `false`.
	     * @example
	     *
	     * _.isEmpty(null);
	     * // => true
	     *
	     * _.isEmpty(true);
	     * // => true
	     *
	     * _.isEmpty(1);
	     * // => true
	     *
	     * _.isEmpty([1, 2, 3]);
	     * // => false
	     *
	     * _.isEmpty({ 'a': 1 });
	     * // => false
	     */
	    function isEmpty(value) {
	      if (value == null) {
	        return true;
	      }
	      if (isArrayLike(value) &&
	          (isArray(value) || typeof value == 'string' || typeof value.splice == 'function' ||
	            isBuffer(value) || isTypedArray(value) || isArguments(value))) {
	        return !value.length;
	      }
	      var tag = getTag(value);
	      if (tag == mapTag || tag == setTag) {
	        return !value.size;
	      }
	      if (isPrototype(value)) {
	        return !baseKeys(value).length;
	      }
	      for (var key in value) {
	        if (hasOwnProperty.call(value, key)) {
	          return false;
	        }
	      }
	      return true;
	    }
	
	    /**
	     * Performs a deep comparison between two values to determine if they are
	     * equivalent.
	     *
	     * **Note:** This method supports comparing arrays, array buffers, booleans,
	     * date objects, error objects, maps, numbers, `Object` objects, regexes,
	     * sets, strings, symbols, and typed arrays. `Object` objects are compared
	     * by their own, not inherited, enumerable properties. Functions and DOM
	     * nodes are compared by strict equality, i.e. `===`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	     * @example
	     *
	     * var object = { 'a': 1 };
	     * var other = { 'a': 1 };
	     *
	     * _.isEqual(object, other);
	     * // => true
	     *
	     * object === other;
	     * // => false
	     */
	    function isEqual(value, other) {
	      return baseIsEqual(value, other);
	    }
	
	    /**
	     * This method is like `_.isEqual` except that it accepts `customizer` which
	     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
	     * are handled by the method instead. The `customizer` is invoked with up to
	     * six arguments: (objValue, othValue [, index|key, object, other, stack]).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @param {Function} [customizer] The function to customize comparisons.
	     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	     * @example
	     *
	     * function isGreeting(value) {
	     *   return /^h(?:i|ello)$/.test(value);
	     * }
	     *
	     * function customizer(objValue, othValue) {
	     *   if (isGreeting(objValue) && isGreeting(othValue)) {
	     *     return true;
	     *   }
	     * }
	     *
	     * var array = ['hello', 'goodbye'];
	     * var other = ['hi', 'goodbye'];
	     *
	     * _.isEqualWith(array, other, customizer);
	     * // => true
	     */
	    function isEqualWith(value, other, customizer) {
	      customizer = typeof customizer == 'function' ? customizer : undefined;
	      var result = customizer ? customizer(value, other) : undefined;
	      return result === undefined ? baseIsEqual(value, other, undefined, customizer) : !!result;
	    }
	
	    /**
	     * Checks if `value` is an `Error`, `EvalError`, `RangeError`, `ReferenceError`,
	     * `SyntaxError`, `TypeError`, or `URIError` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an error object, else `false`.
	     * @example
	     *
	     * _.isError(new Error);
	     * // => true
	     *
	     * _.isError(Error);
	     * // => false
	     */
	    function isError(value) {
	      if (!isObjectLike(value)) {
	        return false;
	      }
	      var tag = baseGetTag(value);
	      return tag == errorTag || tag == domExcTag ||
	        (typeof value.message == 'string' && typeof value.name == 'string' && !isPlainObject(value));
	    }
	
	    /**
	     * Checks if `value` is a finite primitive number.
	     *
	     * **Note:** This method is based on
	     * [`Number.isFinite`](https://mdn.io/Number/isFinite).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a finite number, else `false`.
	     * @example
	     *
	     * _.isFinite(3);
	     * // => true
	     *
	     * _.isFinite(Number.MIN_VALUE);
	     * // => true
	     *
	     * _.isFinite(Infinity);
	     * // => false
	     *
	     * _.isFinite('3');
	     * // => false
	     */
	    function isFinite(value) {
	      return typeof value == 'number' && nativeIsFinite(value);
	    }
	
	    /**
	     * Checks if `value` is classified as a `Function` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a function, else `false`.
	     * @example
	     *
	     * _.isFunction(_);
	     * // => true
	     *
	     * _.isFunction(/abc/);
	     * // => false
	     */
	    function isFunction(value) {
	      if (!isObject(value)) {
	        return false;
	      }
	      // The use of `Object#toString` avoids issues with the `typeof` operator
	      // in Safari 9 which returns 'object' for typed arrays and other constructors.
	      var tag = baseGetTag(value);
	      return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
	    }
	
	    /**
	     * Checks if `value` is an integer.
	     *
	     * **Note:** This method is based on
	     * [`Number.isInteger`](https://mdn.io/Number/isInteger).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an integer, else `false`.
	     * @example
	     *
	     * _.isInteger(3);
	     * // => true
	     *
	     * _.isInteger(Number.MIN_VALUE);
	     * // => false
	     *
	     * _.isInteger(Infinity);
	     * // => false
	     *
	     * _.isInteger('3');
	     * // => false
	     */
	    function isInteger(value) {
	      return typeof value == 'number' && value == toInteger(value);
	    }
	
	    /**
	     * Checks if `value` is a valid array-like length.
	     *
	     * **Note:** This method is loosely based on
	     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
	     * @example
	     *
	     * _.isLength(3);
	     * // => true
	     *
	     * _.isLength(Number.MIN_VALUE);
	     * // => false
	     *
	     * _.isLength(Infinity);
	     * // => false
	     *
	     * _.isLength('3');
	     * // => false
	     */
	    function isLength(value) {
	      return typeof value == 'number' &&
	        value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
	    }
	
	    /**
	     * Checks if `value` is the
	     * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
	     * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an object, else `false`.
	     * @example
	     *
	     * _.isObject({});
	     * // => true
	     *
	     * _.isObject([1, 2, 3]);
	     * // => true
	     *
	     * _.isObject(_.noop);
	     * // => true
	     *
	     * _.isObject(null);
	     * // => false
	     */
	    function isObject(value) {
	      var type = typeof value;
	      return value != null && (type == 'object' || type == 'function');
	    }
	
	    /**
	     * Checks if `value` is object-like. A value is object-like if it's not `null`
	     * and has a `typeof` result of "object".
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
	     * @example
	     *
	     * _.isObjectLike({});
	     * // => true
	     *
	     * _.isObjectLike([1, 2, 3]);
	     * // => true
	     *
	     * _.isObjectLike(_.noop);
	     * // => false
	     *
	     * _.isObjectLike(null);
	     * // => false
	     */
	    function isObjectLike(value) {
	      return value != null && typeof value == 'object';
	    }
	
	    /**
	     * Checks if `value` is classified as a `Map` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.3.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
	     * @example
	     *
	     * _.isMap(new Map);
	     * // => true
	     *
	     * _.isMap(new WeakMap);
	     * // => false
	     */
	    var isMap = nodeIsMap ? baseUnary(nodeIsMap) : baseIsMap;
	
	    /**
	     * Performs a partial deep comparison between `object` and `source` to
	     * determine if `object` contains equivalent property values.
	     *
	     * **Note:** This method is equivalent to `_.matches` when `source` is
	     * partially applied.
	     *
	     * Partial comparisons will match empty array and empty object `source`
	     * values against any array or object value, respectively. See `_.isEqual`
	     * for a list of supported value comparisons.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Lang
	     * @param {Object} object The object to inspect.
	     * @param {Object} source The object of property values to match.
	     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': 2 };
	     *
	     * _.isMatch(object, { 'b': 2 });
	     * // => true
	     *
	     * _.isMatch(object, { 'b': 1 });
	     * // => false
	     */
	    function isMatch(object, source) {
	      return object === source || baseIsMatch(object, source, getMatchData(source));
	    }
	
	    /**
	     * This method is like `_.isMatch` except that it accepts `customizer` which
	     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
	     * are handled by the method instead. The `customizer` is invoked with five
	     * arguments: (objValue, srcValue, index|key, object, source).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {Object} object The object to inspect.
	     * @param {Object} source The object of property values to match.
	     * @param {Function} [customizer] The function to customize comparisons.
	     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
	     * @example
	     *
	     * function isGreeting(value) {
	     *   return /^h(?:i|ello)$/.test(value);
	     * }
	     *
	     * function customizer(objValue, srcValue) {
	     *   if (isGreeting(objValue) && isGreeting(srcValue)) {
	     *     return true;
	     *   }
	     * }
	     *
	     * var object = { 'greeting': 'hello' };
	     * var source = { 'greeting': 'hi' };
	     *
	     * _.isMatchWith(object, source, customizer);
	     * // => true
	     */
	    function isMatchWith(object, source, customizer) {
	      customizer = typeof customizer == 'function' ? customizer : undefined;
	      return baseIsMatch(object, source, getMatchData(source), customizer);
	    }
	
	    /**
	     * Checks if `value` is `NaN`.
	     *
	     * **Note:** This method is based on
	     * [`Number.isNaN`](https://mdn.io/Number/isNaN) and is not the same as
	     * global [`isNaN`](https://mdn.io/isNaN) which returns `true` for
	     * `undefined` and other non-number values.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
	     * @example
	     *
	     * _.isNaN(NaN);
	     * // => true
	     *
	     * _.isNaN(new Number(NaN));
	     * // => true
	     *
	     * isNaN(undefined);
	     * // => true
	     *
	     * _.isNaN(undefined);
	     * // => false
	     */
	    function isNaN(value) {
	      // An `NaN` primitive is the only value that is not equal to itself.
	      // Perform the `toStringTag` check first to avoid errors with some
	      // ActiveX objects in IE.
	      return isNumber(value) && value != +value;
	    }
	
	    /**
	     * Checks if `value` is a pristine native function.
	     *
	     * **Note:** This method can't reliably detect native functions in the presence
	     * of the core-js package because core-js circumvents this kind of detection.
	     * Despite multiple requests, the core-js maintainer has made it clear: any
	     * attempt to fix the detection will be obstructed. As a result, we're left
	     * with little choice but to throw an error. Unfortunately, this also affects
	     * packages, like [babel-polyfill](https://www.npmjs.com/package/babel-polyfill),
	     * which rely on core-js.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a native function,
	     *  else `false`.
	     * @example
	     *
	     * _.isNative(Array.prototype.push);
	     * // => true
	     *
	     * _.isNative(_);
	     * // => false
	     */
	    function isNative(value) {
	      if (isMaskable(value)) {
	        throw new Error(CORE_ERROR_TEXT);
	      }
	      return baseIsNative(value);
	    }
	
	    /**
	     * Checks if `value` is `null`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is `null`, else `false`.
	     * @example
	     *
	     * _.isNull(null);
	     * // => true
	     *
	     * _.isNull(void 0);
	     * // => false
	     */
	    function isNull(value) {
	      return value === null;
	    }
	
	    /**
	     * Checks if `value` is `null` or `undefined`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is nullish, else `false`.
	     * @example
	     *
	     * _.isNil(null);
	     * // => true
	     *
	     * _.isNil(void 0);
	     * // => true
	     *
	     * _.isNil(NaN);
	     * // => false
	     */
	    function isNil(value) {
	      return value == null;
	    }
	
	    /**
	     * Checks if `value` is classified as a `Number` primitive or object.
	     *
	     * **Note:** To exclude `Infinity`, `-Infinity`, and `NaN`, which are
	     * classified as numbers, use the `_.isFinite` method.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a number, else `false`.
	     * @example
	     *
	     * _.isNumber(3);
	     * // => true
	     *
	     * _.isNumber(Number.MIN_VALUE);
	     * // => true
	     *
	     * _.isNumber(Infinity);
	     * // => true
	     *
	     * _.isNumber('3');
	     * // => false
	     */
	    function isNumber(value) {
	      return typeof value == 'number' ||
	        (isObjectLike(value) && baseGetTag(value) == numberTag);
	    }
	
	    /**
	     * Checks if `value` is a plain object, that is, an object created by the
	     * `Object` constructor or one with a `[[Prototype]]` of `null`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.8.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     * }
	     *
	     * _.isPlainObject(new Foo);
	     * // => false
	     *
	     * _.isPlainObject([1, 2, 3]);
	     * // => false
	     *
	     * _.isPlainObject({ 'x': 0, 'y': 0 });
	     * // => true
	     *
	     * _.isPlainObject(Object.create(null));
	     * // => true
	     */
	    function isPlainObject(value) {
	      if (!isObjectLike(value) || baseGetTag(value) != objectTag) {
	        return false;
	      }
	      var proto = getPrototype(value);
	      if (proto === null) {
	        return true;
	      }
	      var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
	      return typeof Ctor == 'function' && Ctor instanceof Ctor &&
	        funcToString.call(Ctor) == objectCtorString;
	    }
	
	    /**
	     * Checks if `value` is classified as a `RegExp` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
	     * @example
	     *
	     * _.isRegExp(/abc/);
	     * // => true
	     *
	     * _.isRegExp('/abc/');
	     * // => false
	     */
	    var isRegExp = nodeIsRegExp ? baseUnary(nodeIsRegExp) : baseIsRegExp;
	
	    /**
	     * Checks if `value` is a safe integer. An integer is safe if it's an IEEE-754
	     * double precision number which isn't the result of a rounded unsafe integer.
	     *
	     * **Note:** This method is based on
	     * [`Number.isSafeInteger`](https://mdn.io/Number/isSafeInteger).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a safe integer, else `false`.
	     * @example
	     *
	     * _.isSafeInteger(3);
	     * // => true
	     *
	     * _.isSafeInteger(Number.MIN_VALUE);
	     * // => false
	     *
	     * _.isSafeInteger(Infinity);
	     * // => false
	     *
	     * _.isSafeInteger('3');
	     * // => false
	     */
	    function isSafeInteger(value) {
	      return isInteger(value) && value >= -MAX_SAFE_INTEGER && value <= MAX_SAFE_INTEGER;
	    }
	
	    /**
	     * Checks if `value` is classified as a `Set` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.3.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
	     * @example
	     *
	     * _.isSet(new Set);
	     * // => true
	     *
	     * _.isSet(new WeakSet);
	     * // => false
	     */
	    var isSet = nodeIsSet ? baseUnary(nodeIsSet) : baseIsSet;
	
	    /**
	     * Checks if `value` is classified as a `String` primitive or object.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a string, else `false`.
	     * @example
	     *
	     * _.isString('abc');
	     * // => true
	     *
	     * _.isString(1);
	     * // => false
	     */
	    function isString(value) {
	      return typeof value == 'string' ||
	        (!isArray(value) && isObjectLike(value) && baseGetTag(value) == stringTag);
	    }
	
	    /**
	     * Checks if `value` is classified as a `Symbol` primitive or object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
	     * @example
	     *
	     * _.isSymbol(Symbol.iterator);
	     * // => true
	     *
	     * _.isSymbol('abc');
	     * // => false
	     */
	    function isSymbol(value) {
	      return typeof value == 'symbol' ||
	        (isObjectLike(value) && baseGetTag(value) == symbolTag);
	    }
	
	    /**
	     * Checks if `value` is classified as a typed array.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
	     * @example
	     *
	     * _.isTypedArray(new Uint8Array);
	     * // => true
	     *
	     * _.isTypedArray([]);
	     * // => false
	     */
	    var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;
	
	    /**
	     * Checks if `value` is `undefined`.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is `undefined`, else `false`.
	     * @example
	     *
	     * _.isUndefined(void 0);
	     * // => true
	     *
	     * _.isUndefined(null);
	     * // => false
	     */
	    function isUndefined(value) {
	      return value === undefined;
	    }
	
	    /**
	     * Checks if `value` is classified as a `WeakMap` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.3.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a weak map, else `false`.
	     * @example
	     *
	     * _.isWeakMap(new WeakMap);
	     * // => true
	     *
	     * _.isWeakMap(new Map);
	     * // => false
	     */
	    function isWeakMap(value) {
	      return isObjectLike(value) && getTag(value) == weakMapTag;
	    }
	
	    /**
	     * Checks if `value` is classified as a `WeakSet` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.3.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a weak set, else `false`.
	     * @example
	     *
	     * _.isWeakSet(new WeakSet);
	     * // => true
	     *
	     * _.isWeakSet(new Set);
	     * // => false
	     */
	    function isWeakSet(value) {
	      return isObjectLike(value) && baseGetTag(value) == weakSetTag;
	    }
	
	    /**
	     * Checks if `value` is less than `other`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.9.0
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if `value` is less than `other`,
	     *  else `false`.
	     * @see _.gt
	     * @example
	     *
	     * _.lt(1, 3);
	     * // => true
	     *
	     * _.lt(3, 3);
	     * // => false
	     *
	     * _.lt(3, 1);
	     * // => false
	     */
	    var lt = createRelationalOperation(baseLt);
	
	    /**
	     * Checks if `value` is less than or equal to `other`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.9.0
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if `value` is less than or equal to
	     *  `other`, else `false`.
	     * @see _.gte
	     * @example
	     *
	     * _.lte(1, 3);
	     * // => true
	     *
	     * _.lte(3, 3);
	     * // => true
	     *
	     * _.lte(3, 1);
	     * // => false
	     */
	    var lte = createRelationalOperation(function(value, other) {
	      return value <= other;
	    });
	
	    /**
	     * Converts `value` to an array.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to convert.
	     * @returns {Array} Returns the converted array.
	     * @example
	     *
	     * _.toArray({ 'a': 1, 'b': 2 });
	     * // => [1, 2]
	     *
	     * _.toArray('abc');
	     * // => ['a', 'b', 'c']
	     *
	     * _.toArray(1);
	     * // => []
	     *
	     * _.toArray(null);
	     * // => []
	     */
	    function toArray(value) {
	      if (!value) {
	        return [];
	      }
	      if (isArrayLike(value)) {
	        return isString(value) ? stringToArray(value) : copyArray(value);
	      }
	      if (symIterator && value[symIterator]) {
	        return iteratorToArray(value[symIterator]());
	      }
	      var tag = getTag(value),
	          func = tag == mapTag ? mapToArray : (tag == setTag ? setToArray : values);
	
	      return func(value);
	    }
	
	    /**
	     * Converts `value` to a finite number.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.12.0
	     * @category Lang
	     * @param {*} value The value to convert.
	     * @returns {number} Returns the converted number.
	     * @example
	     *
	     * _.toFinite(3.2);
	     * // => 3.2
	     *
	     * _.toFinite(Number.MIN_VALUE);
	     * // => 5e-324
	     *
	     * _.toFinite(Infinity);
	     * // => 1.7976931348623157e+308
	     *
	     * _.toFinite('3.2');
	     * // => 3.2
	     */
	    function toFinite(value) {
	      if (!value) {
	        return value === 0 ? value : 0;
	      }
	      value = toNumber(value);
	      if (value === INFINITY || value === -INFINITY) {
	        var sign = (value < 0 ? -1 : 1);
	        return sign * MAX_INTEGER;
	      }
	      return value === value ? value : 0;
	    }
	
	    /**
	     * Converts `value` to an integer.
	     *
	     * **Note:** This method is loosely based on
	     * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to convert.
	     * @returns {number} Returns the converted integer.
	     * @example
	     *
	     * _.toInteger(3.2);
	     * // => 3
	     *
	     * _.toInteger(Number.MIN_VALUE);
	     * // => 0
	     *
	     * _.toInteger(Infinity);
	     * // => 1.7976931348623157e+308
	     *
	     * _.toInteger('3.2');
	     * // => 3
	     */
	    function toInteger(value) {
	      var result = toFinite(value),
	          remainder = result % 1;
	
	      return result === result ? (remainder ? result - remainder : result) : 0;
	    }
	
	    /**
	     * Converts `value` to an integer suitable for use as the length of an
	     * array-like object.
	     *
	     * **Note:** This method is based on
	     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to convert.
	     * @returns {number} Returns the converted integer.
	     * @example
	     *
	     * _.toLength(3.2);
	     * // => 3
	     *
	     * _.toLength(Number.MIN_VALUE);
	     * // => 0
	     *
	     * _.toLength(Infinity);
	     * // => 4294967295
	     *
	     * _.toLength('3.2');
	     * // => 3
	     */
	    function toLength(value) {
	      return value ? baseClamp(toInteger(value), 0, MAX_ARRAY_LENGTH) : 0;
	    }
	
	    /**
	     * Converts `value` to a number.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to process.
	     * @returns {number} Returns the number.
	     * @example
	     *
	     * _.toNumber(3.2);
	     * // => 3.2
	     *
	     * _.toNumber(Number.MIN_VALUE);
	     * // => 5e-324
	     *
	     * _.toNumber(Infinity);
	     * // => Infinity
	     *
	     * _.toNumber('3.2');
	     * // => 3.2
	     */
	    function toNumber(value) {
	      if (typeof value == 'number') {
	        return value;
	      }
	      if (isSymbol(value)) {
	        return NAN;
	      }
	      if (isObject(value)) {
	        var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
	        value = isObject(other) ? (other + '') : other;
	      }
	      if (typeof value != 'string') {
	        return value === 0 ? value : +value;
	      }
	      value = value.replace(reTrim, '');
	      var isBinary = reIsBinary.test(value);
	      return (isBinary || reIsOctal.test(value))
	        ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
	        : (reIsBadHex.test(value) ? NAN : +value);
	    }
	
	    /**
	     * Converts `value` to a plain object flattening inherited enumerable string
	     * keyed properties of `value` to own properties of the plain object.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Lang
	     * @param {*} value The value to convert.
	     * @returns {Object} Returns the converted plain object.
	     * @example
	     *
	     * function Foo() {
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.assign({ 'a': 1 }, new Foo);
	     * // => { 'a': 1, 'b': 2 }
	     *
	     * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
	     * // => { 'a': 1, 'b': 2, 'c': 3 }
	     */
	    function toPlainObject(value) {
	      return copyObject(value, keysIn(value));
	    }
	
	    /**
	     * Converts `value` to a safe integer. A safe integer can be compared and
	     * represented correctly.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to convert.
	     * @returns {number} Returns the converted integer.
	     * @example
	     *
	     * _.toSafeInteger(3.2);
	     * // => 3
	     *
	     * _.toSafeInteger(Number.MIN_VALUE);
	     * // => 0
	     *
	     * _.toSafeInteger(Infinity);
	     * // => 9007199254740991
	     *
	     * _.toSafeInteger('3.2');
	     * // => 3
	     */
	    function toSafeInteger(value) {
	      return value
	        ? baseClamp(toInteger(value), -MAX_SAFE_INTEGER, MAX_SAFE_INTEGER)
	        : (value === 0 ? value : 0);
	    }
	
	    /**
	     * Converts `value` to a string. An empty string is returned for `null`
	     * and `undefined` values. The sign of `-0` is preserved.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to convert.
	     * @returns {string} Returns the converted string.
	     * @example
	     *
	     * _.toString(null);
	     * // => ''
	     *
	     * _.toString(-0);
	     * // => '-0'
	     *
	     * _.toString([1, 2, 3]);
	     * // => '1,2,3'
	     */
	    function toString(value) {
	      return value == null ? '' : baseToString(value);
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Assigns own enumerable string keyed properties of source objects to the
	     * destination object. Source objects are applied from left to right.
	     * Subsequent sources overwrite property assignments of previous sources.
	     *
	     * **Note:** This method mutates `object` and is loosely based on
	     * [`Object.assign`](https://mdn.io/Object/assign).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.10.0
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} [sources] The source objects.
	     * @returns {Object} Returns `object`.
	     * @see _.assignIn
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     * }
	     *
	     * function Bar() {
	     *   this.c = 3;
	     * }
	     *
	     * Foo.prototype.b = 2;
	     * Bar.prototype.d = 4;
	     *
	     * _.assign({ 'a': 0 }, new Foo, new Bar);
	     * // => { 'a': 1, 'c': 3 }
	     */
	    var assign = createAssigner(function(object, source) {
	      if (isPrototype(source) || isArrayLike(source)) {
	        copyObject(source, keys(source), object);
	        return;
	      }
	      for (var key in source) {
	        if (hasOwnProperty.call(source, key)) {
	          assignValue(object, key, source[key]);
	        }
	      }
	    });
	
	    /**
	     * This method is like `_.assign` except that it iterates over own and
	     * inherited source properties.
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @alias extend
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} [sources] The source objects.
	     * @returns {Object} Returns `object`.
	     * @see _.assign
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     * }
	     *
	     * function Bar() {
	     *   this.c = 3;
	     * }
	     *
	     * Foo.prototype.b = 2;
	     * Bar.prototype.d = 4;
	     *
	     * _.assignIn({ 'a': 0 }, new Foo, new Bar);
	     * // => { 'a': 1, 'b': 2, 'c': 3, 'd': 4 }
	     */
	    var assignIn = createAssigner(function(object, source) {
	      copyObject(source, keysIn(source), object);
	    });
	
	    /**
	     * This method is like `_.assignIn` except that it accepts `customizer`
	     * which is invoked to produce the assigned values. If `customizer` returns
	     * `undefined`, assignment is handled by the method instead. The `customizer`
	     * is invoked with five arguments: (objValue, srcValue, key, object, source).
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @alias extendWith
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} sources The source objects.
	     * @param {Function} [customizer] The function to customize assigned values.
	     * @returns {Object} Returns `object`.
	     * @see _.assignWith
	     * @example
	     *
	     * function customizer(objValue, srcValue) {
	     *   return _.isUndefined(objValue) ? srcValue : objValue;
	     * }
	     *
	     * var defaults = _.partialRight(_.assignInWith, customizer);
	     *
	     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
	     * // => { 'a': 1, 'b': 2 }
	     */
	    var assignInWith = createAssigner(function(object, source, srcIndex, customizer) {
	      copyObject(source, keysIn(source), object, customizer);
	    });
	
	    /**
	     * This method is like `_.assign` except that it accepts `customizer`
	     * which is invoked to produce the assigned values. If `customizer` returns
	     * `undefined`, assignment is handled by the method instead. The `customizer`
	     * is invoked with five arguments: (objValue, srcValue, key, object, source).
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} sources The source objects.
	     * @param {Function} [customizer] The function to customize assigned values.
	     * @returns {Object} Returns `object`.
	     * @see _.assignInWith
	     * @example
	     *
	     * function customizer(objValue, srcValue) {
	     *   return _.isUndefined(objValue) ? srcValue : objValue;
	     * }
	     *
	     * var defaults = _.partialRight(_.assignWith, customizer);
	     *
	     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
	     * // => { 'a': 1, 'b': 2 }
	     */
	    var assignWith = createAssigner(function(object, source, srcIndex, customizer) {
	      copyObject(source, keys(source), object, customizer);
	    });
	
	    /**
	     * Creates an array of values corresponding to `paths` of `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.0.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {...(string|string[])} [paths] The property paths to pick.
	     * @returns {Array} Returns the picked values.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
	     *
	     * _.at(object, ['a[0].b.c', 'a[1]']);
	     * // => [3, 4]
	     */
	    var at = flatRest(baseAt);
	
	    /**
	     * Creates an object that inherits from the `prototype` object. If a
	     * `properties` object is given, its own enumerable string keyed properties
	     * are assigned to the created object.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.3.0
	     * @category Object
	     * @param {Object} prototype The object to inherit from.
	     * @param {Object} [properties] The properties to assign to the object.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * function Shape() {
	     *   this.x = 0;
	     *   this.y = 0;
	     * }
	     *
	     * function Circle() {
	     *   Shape.call(this);
	     * }
	     *
	     * Circle.prototype = _.create(Shape.prototype, {
	     *   'constructor': Circle
	     * });
	     *
	     * var circle = new Circle;
	     * circle instanceof Circle;
	     * // => true
	     *
	     * circle instanceof Shape;
	     * // => true
	     */
	    function create(prototype, properties) {
	      var result = baseCreate(prototype);
	      return properties == null ? result : baseAssign(result, properties);
	    }
	
	    /**
	     * Assigns own and inherited enumerable string keyed properties of source
	     * objects to the destination object for all destination properties that
	     * resolve to `undefined`. Source objects are applied from left to right.
	     * Once a property is set, additional values of the same property are ignored.
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} [sources] The source objects.
	     * @returns {Object} Returns `object`.
	     * @see _.defaultsDeep
	     * @example
	     *
	     * _.defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
	     * // => { 'a': 1, 'b': 2 }
	     */
	    var defaults = baseRest(function(object, sources) {
	      object = Object(object);
	
	      var index = -1;
	      var length = sources.length;
	      var guard = length > 2 ? sources[2] : undefined;
	
	      if (guard && isIterateeCall(sources[0], sources[1], guard)) {
	        length = 1;
	      }
	
	      while (++index < length) {
	        var source = sources[index];
	        var props = keysIn(source);
	        var propsIndex = -1;
	        var propsLength = props.length;
	
	        while (++propsIndex < propsLength) {
	          var key = props[propsIndex];
	          var value = object[key];
	
	          if (value === undefined ||
	              (eq(value, objectProto[key]) && !hasOwnProperty.call(object, key))) {
	            object[key] = source[key];
	          }
	        }
	      }
	
	      return object;
	    });
	
	    /**
	     * This method is like `_.defaults` except that it recursively assigns
	     * default properties.
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.10.0
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} [sources] The source objects.
	     * @returns {Object} Returns `object`.
	     * @see _.defaults
	     * @example
	     *
	     * _.defaultsDeep({ 'a': { 'b': 2 } }, { 'a': { 'b': 1, 'c': 3 } });
	     * // => { 'a': { 'b': 2, 'c': 3 } }
	     */
	    var defaultsDeep = baseRest(function(args) {
	      args.push(undefined, customDefaultsMerge);
	      return apply(mergeWith, undefined, args);
	    });
	
	    /**
	     * This method is like `_.find` except that it returns the key of the first
	     * element `predicate` returns truthy for instead of the element itself.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.1.0
	     * @category Object
	     * @param {Object} object The object to inspect.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {string|undefined} Returns the key of the matched element,
	     *  else `undefined`.
	     * @example
	     *
	     * var users = {
	     *   'barney':  { 'age': 36, 'active': true },
	     *   'fred':    { 'age': 40, 'active': false },
	     *   'pebbles': { 'age': 1,  'active': true }
	     * };
	     *
	     * _.findKey(users, function(o) { return o.age < 40; });
	     * // => 'barney' (iteration order is not guaranteed)
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.findKey(users, { 'age': 1, 'active': true });
	     * // => 'pebbles'
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.findKey(users, ['active', false]);
	     * // => 'fred'
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.findKey(users, 'active');
	     * // => 'barney'
	     */
	    function findKey(object, predicate) {
	      return baseFindKey(object, getIteratee(predicate, 3), baseForOwn);
	    }
	
	    /**
	     * This method is like `_.findKey` except that it iterates over elements of
	     * a collection in the opposite order.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Object
	     * @param {Object} object The object to inspect.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {string|undefined} Returns the key of the matched element,
	     *  else `undefined`.
	     * @example
	     *
	     * var users = {
	     *   'barney':  { 'age': 36, 'active': true },
	     *   'fred':    { 'age': 40, 'active': false },
	     *   'pebbles': { 'age': 1,  'active': true }
	     * };
	     *
	     * _.findLastKey(users, function(o) { return o.age < 40; });
	     * // => returns 'pebbles' assuming `_.findKey` returns 'barney'
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.findLastKey(users, { 'age': 36, 'active': true });
	     * // => 'barney'
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.findLastKey(users, ['active', false]);
	     * // => 'fred'
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.findLastKey(users, 'active');
	     * // => 'pebbles'
	     */
	    function findLastKey(object, predicate) {
	      return baseFindKey(object, getIteratee(predicate, 3), baseForOwnRight);
	    }
	
	    /**
	     * Iterates over own and inherited enumerable string keyed properties of an
	     * object and invokes `iteratee` for each property. The iteratee is invoked
	     * with three arguments: (value, key, object). Iteratee functions may exit
	     * iteration early by explicitly returning `false`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.3.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Object} Returns `object`.
	     * @see _.forInRight
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.forIn(new Foo, function(value, key) {
	     *   console.log(key);
	     * });
	     * // => Logs 'a', 'b', then 'c' (iteration order is not guaranteed).
	     */
	    function forIn(object, iteratee) {
	      return object == null
	        ? object
	        : baseFor(object, getIteratee(iteratee, 3), keysIn);
	    }
	
	    /**
	     * This method is like `_.forIn` except that it iterates over properties of
	     * `object` in the opposite order.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Object} Returns `object`.
	     * @see _.forIn
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.forInRight(new Foo, function(value, key) {
	     *   console.log(key);
	     * });
	     * // => Logs 'c', 'b', then 'a' assuming `_.forIn` logs 'a', 'b', then 'c'.
	     */
	    function forInRight(object, iteratee) {
	      return object == null
	        ? object
	        : baseForRight(object, getIteratee(iteratee, 3), keysIn);
	    }
	
	    /**
	     * Iterates over own enumerable string keyed properties of an object and
	     * invokes `iteratee` for each property. The iteratee is invoked with three
	     * arguments: (value, key, object). Iteratee functions may exit iteration
	     * early by explicitly returning `false`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.3.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Object} Returns `object`.
	     * @see _.forOwnRight
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.forOwn(new Foo, function(value, key) {
	     *   console.log(key);
	     * });
	     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
	     */
	    function forOwn(object, iteratee) {
	      return object && baseForOwn(object, getIteratee(iteratee, 3));
	    }
	
	    /**
	     * This method is like `_.forOwn` except that it iterates over properties of
	     * `object` in the opposite order.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Object} Returns `object`.
	     * @see _.forOwn
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.forOwnRight(new Foo, function(value, key) {
	     *   console.log(key);
	     * });
	     * // => Logs 'b' then 'a' assuming `_.forOwn` logs 'a' then 'b'.
	     */
	    function forOwnRight(object, iteratee) {
	      return object && baseForOwnRight(object, getIteratee(iteratee, 3));
	    }
	
	    /**
	     * Creates an array of function property names from own enumerable properties
	     * of `object`.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to inspect.
	     * @returns {Array} Returns the function names.
	     * @see _.functionsIn
	     * @example
	     *
	     * function Foo() {
	     *   this.a = _.constant('a');
	     *   this.b = _.constant('b');
	     * }
	     *
	     * Foo.prototype.c = _.constant('c');
	     *
	     * _.functions(new Foo);
	     * // => ['a', 'b']
	     */
	    function functions(object) {
	      return object == null ? [] : baseFunctions(object, keys(object));
	    }
	
	    /**
	     * Creates an array of function property names from own and inherited
	     * enumerable properties of `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The object to inspect.
	     * @returns {Array} Returns the function names.
	     * @see _.functions
	     * @example
	     *
	     * function Foo() {
	     *   this.a = _.constant('a');
	     *   this.b = _.constant('b');
	     * }
	     *
	     * Foo.prototype.c = _.constant('c');
	     *
	     * _.functionsIn(new Foo);
	     * // => ['a', 'b', 'c']
	     */
	    function functionsIn(object) {
	      return object == null ? [] : baseFunctions(object, keysIn(object));
	    }
	
	    /**
	     * Gets the value at `path` of `object`. If the resolved value is
	     * `undefined`, the `defaultValue` is returned in its place.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.7.0
	     * @category Object
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path of the property to get.
	     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
	     * @returns {*} Returns the resolved value.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
	     *
	     * _.get(object, 'a[0].b.c');
	     * // => 3
	     *
	     * _.get(object, ['a', '0', 'b', 'c']);
	     * // => 3
	     *
	     * _.get(object, 'a.b.c', 'default');
	     * // => 'default'
	     */
	    function get(object, path, defaultValue) {
	      var result = object == null ? undefined : baseGet(object, path);
	      return result === undefined ? defaultValue : result;
	    }
	
	    /**
	     * Checks if `path` is a direct property of `object`.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path to check.
	     * @returns {boolean} Returns `true` if `path` exists, else `false`.
	     * @example
	     *
	     * var object = { 'a': { 'b': 2 } };
	     * var other = _.create({ 'a': _.create({ 'b': 2 }) });
	     *
	     * _.has(object, 'a');
	     * // => true
	     *
	     * _.has(object, 'a.b');
	     * // => true
	     *
	     * _.has(object, ['a', 'b']);
	     * // => true
	     *
	     * _.has(other, 'a');
	     * // => false
	     */
	    function has(object, path) {
	      return object != null && hasPath(object, path, baseHas);
	    }
	
	    /**
	     * Checks if `path` is a direct or inherited property of `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path to check.
	     * @returns {boolean} Returns `true` if `path` exists, else `false`.
	     * @example
	     *
	     * var object = _.create({ 'a': _.create({ 'b': 2 }) });
	     *
	     * _.hasIn(object, 'a');
	     * // => true
	     *
	     * _.hasIn(object, 'a.b');
	     * // => true
	     *
	     * _.hasIn(object, ['a', 'b']);
	     * // => true
	     *
	     * _.hasIn(object, 'b');
	     * // => false
	     */
	    function hasIn(object, path) {
	      return object != null && hasPath(object, path, baseHasIn);
	    }
	
	    /**
	     * Creates an object composed of the inverted keys and values of `object`.
	     * If `object` contains duplicate values, subsequent values overwrite
	     * property assignments of previous values.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.7.0
	     * @category Object
	     * @param {Object} object The object to invert.
	     * @returns {Object} Returns the new inverted object.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': 2, 'c': 1 };
	     *
	     * _.invert(object);
	     * // => { '1': 'c', '2': 'b' }
	     */
	    var invert = createInverter(function(result, value, key) {
	      if (value != null &&
	          typeof value.toString != 'function') {
	        value = nativeObjectToString.call(value);
	      }
	
	      result[value] = key;
	    }, constant(identity));
	
	    /**
	     * This method is like `_.invert` except that the inverted object is generated
	     * from the results of running each element of `object` thru `iteratee`. The
	     * corresponding inverted value of each inverted key is an array of keys
	     * responsible for generating the inverted value. The iteratee is invoked
	     * with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.1.0
	     * @category Object
	     * @param {Object} object The object to invert.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {Object} Returns the new inverted object.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': 2, 'c': 1 };
	     *
	     * _.invertBy(object);
	     * // => { '1': ['a', 'c'], '2': ['b'] }
	     *
	     * _.invertBy(object, function(value) {
	     *   return 'group' + value;
	     * });
	     * // => { 'group1': ['a', 'c'], 'group2': ['b'] }
	     */
	    var invertBy = createInverter(function(result, value, key) {
	      if (value != null &&
	          typeof value.toString != 'function') {
	        value = nativeObjectToString.call(value);
	      }
	
	      if (hasOwnProperty.call(result, value)) {
	        result[value].push(key);
	      } else {
	        result[value] = [key];
	      }
	    }, getIteratee);
	
	    /**
	     * Invokes the method at `path` of `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path of the method to invoke.
	     * @param {...*} [args] The arguments to invoke the method with.
	     * @returns {*} Returns the result of the invoked method.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c': [1, 2, 3, 4] } }] };
	     *
	     * _.invoke(object, 'a[0].b.c.slice', 1, 3);
	     * // => [2, 3]
	     */
	    var invoke = baseRest(baseInvoke);
	
	    /**
	     * Creates an array of the own enumerable property names of `object`.
	     *
	     * **Note:** Non-object values are coerced to objects. See the
	     * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
	     * for more details.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.keys(new Foo);
	     * // => ['a', 'b'] (iteration order is not guaranteed)
	     *
	     * _.keys('hi');
	     * // => ['0', '1']
	     */
	    function keys(object) {
	      return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
	    }
	
	    /**
	     * Creates an array of the own and inherited enumerable property names of `object`.
	     *
	     * **Note:** Non-object values are coerced to objects.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Object
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.keysIn(new Foo);
	     * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
	     */
	    function keysIn(object) {
	      return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
	    }
	
	    /**
	     * The opposite of `_.mapValues`; this method creates an object with the
	     * same values as `object` and keys generated by running each own enumerable
	     * string keyed property of `object` thru `iteratee`. The iteratee is invoked
	     * with three arguments: (value, key, object).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.8.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Object} Returns the new mapped object.
	     * @see _.mapValues
	     * @example
	     *
	     * _.mapKeys({ 'a': 1, 'b': 2 }, function(value, key) {
	     *   return key + value;
	     * });
	     * // => { 'a1': 1, 'b2': 2 }
	     */
	    function mapKeys(object, iteratee) {
	      var result = {};
	      iteratee = getIteratee(iteratee, 3);
	
	      baseForOwn(object, function(value, key, object) {
	        baseAssignValue(result, iteratee(value, key, object), value);
	      });
	      return result;
	    }
	
	    /**
	     * Creates an object with the same keys as `object` and values generated
	     * by running each own enumerable string keyed property of `object` thru
	     * `iteratee`. The iteratee is invoked with three arguments:
	     * (value, key, object).
	     *
	     * @static
	     * @memberOf _
	     * @since 2.4.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Object} Returns the new mapped object.
	     * @see _.mapKeys
	     * @example
	     *
	     * var users = {
	     *   'fred':    { 'user': 'fred',    'age': 40 },
	     *   'pebbles': { 'user': 'pebbles', 'age': 1 }
	     * };
	     *
	     * _.mapValues(users, function(o) { return o.age; });
	     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.mapValues(users, 'age');
	     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
	     */
	    function mapValues(object, iteratee) {
	      var result = {};
	      iteratee = getIteratee(iteratee, 3);
	
	      baseForOwn(object, function(value, key, object) {
	        baseAssignValue(result, key, iteratee(value, key, object));
	      });
	      return result;
	    }
	
	    /**
	     * This method is like `_.assign` except that it recursively merges own and
	     * inherited enumerable string keyed properties of source objects into the
	     * destination object. Source properties that resolve to `undefined` are
	     * skipped if a destination value exists. Array and plain object properties
	     * are merged recursively. Other objects and value types are overridden by
	     * assignment. Source objects are applied from left to right. Subsequent
	     * sources overwrite property assignments of previous sources.
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.5.0
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} [sources] The source objects.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * var object = {
	     *   'a': [{ 'b': 2 }, { 'd': 4 }]
	     * };
	     *
	     * var other = {
	     *   'a': [{ 'c': 3 }, { 'e': 5 }]
	     * };
	     *
	     * _.merge(object, other);
	     * // => { 'a': [{ 'b': 2, 'c': 3 }, { 'd': 4, 'e': 5 }] }
	     */
	    var merge = createAssigner(function(object, source, srcIndex) {
	      baseMerge(object, source, srcIndex);
	    });
	
	    /**
	     * This method is like `_.merge` except that it accepts `customizer` which
	     * is invoked to produce the merged values of the destination and source
	     * properties. If `customizer` returns `undefined`, merging is handled by the
	     * method instead. The `customizer` is invoked with six arguments:
	     * (objValue, srcValue, key, object, source, stack).
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} sources The source objects.
	     * @param {Function} customizer The function to customize assigned values.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * function customizer(objValue, srcValue) {
	     *   if (_.isArray(objValue)) {
	     *     return objValue.concat(srcValue);
	     *   }
	     * }
	     *
	     * var object = { 'a': [1], 'b': [2] };
	     * var other = { 'a': [3], 'b': [4] };
	     *
	     * _.mergeWith(object, other, customizer);
	     * // => { 'a': [1, 3], 'b': [2, 4] }
	     */
	    var mergeWith = createAssigner(function(object, source, srcIndex, customizer) {
	      baseMerge(object, source, srcIndex, customizer);
	    });
	
	    /**
	     * The opposite of `_.pick`; this method creates an object composed of the
	     * own and inherited enumerable property paths of `object` that are not omitted.
	     *
	     * **Note:** This method is considerably slower than `_.pick`.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The source object.
	     * @param {...(string|string[])} [paths] The property paths to omit.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': '2', 'c': 3 };
	     *
	     * _.omit(object, ['a', 'c']);
	     * // => { 'b': '2' }
	     */
	    var omit = flatRest(function(object, paths) {
	      var result = {};
	      if (object == null) {
	        return result;
	      }
	      var isDeep = false;
	      paths = arrayMap(paths, function(path) {
	        path = castPath(path, object);
	        isDeep || (isDeep = path.length > 1);
	        return path;
	      });
	      copyObject(object, getAllKeysIn(object), result);
	      if (isDeep) {
	        result = baseClone(result, CLONE_DEEP_FLAG | CLONE_FLAT_FLAG | CLONE_SYMBOLS_FLAG, customOmitClone);
	      }
	      var length = paths.length;
	      while (length--) {
	        baseUnset(result, paths[length]);
	      }
	      return result;
	    });
	
	    /**
	     * The opposite of `_.pickBy`; this method creates an object composed of
	     * the own and inherited enumerable string keyed properties of `object` that
	     * `predicate` doesn't return truthy for. The predicate is invoked with two
	     * arguments: (value, key).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The source object.
	     * @param {Function} [predicate=_.identity] The function invoked per property.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': '2', 'c': 3 };
	     *
	     * _.omitBy(object, _.isNumber);
	     * // => { 'b': '2' }
	     */
	    function omitBy(object, predicate) {
	      return pickBy(object, negate(getIteratee(predicate)));
	    }
	
	    /**
	     * Creates an object composed of the picked `object` properties.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The source object.
	     * @param {...(string|string[])} [paths] The property paths to pick.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': '2', 'c': 3 };
	     *
	     * _.pick(object, ['a', 'c']);
	     * // => { 'a': 1, 'c': 3 }
	     */
	    var pick = flatRest(function(object, paths) {
	      return object == null ? {} : basePick(object, paths);
	    });
	
	    /**
	     * Creates an object composed of the `object` properties `predicate` returns
	     * truthy for. The predicate is invoked with two arguments: (value, key).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The source object.
	     * @param {Function} [predicate=_.identity] The function invoked per property.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': '2', 'c': 3 };
	     *
	     * _.pickBy(object, _.isNumber);
	     * // => { 'a': 1, 'c': 3 }
	     */
	    function pickBy(object, predicate) {
	      if (object == null) {
	        return {};
	      }
	      var props = arrayMap(getAllKeysIn(object), function(prop) {
	        return [prop];
	      });
	      predicate = getIteratee(predicate);
	      return basePickBy(object, props, function(value, path) {
	        return predicate(value, path[0]);
	      });
	    }
	
	    /**
	     * This method is like `_.get` except that if the resolved value is a
	     * function it's invoked with the `this` binding of its parent object and
	     * its result is returned.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path of the property to resolve.
	     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
	     * @returns {*} Returns the resolved value.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c1': 3, 'c2': _.constant(4) } }] };
	     *
	     * _.result(object, 'a[0].b.c1');
	     * // => 3
	     *
	     * _.result(object, 'a[0].b.c2');
	     * // => 4
	     *
	     * _.result(object, 'a[0].b.c3', 'default');
	     * // => 'default'
	     *
	     * _.result(object, 'a[0].b.c3', _.constant('default'));
	     * // => 'default'
	     */
	    function result(object, path, defaultValue) {
	      path = castPath(path, object);
	
	      var index = -1,
	          length = path.length;
	
	      // Ensure the loop is entered when path is empty.
	      if (!length) {
	        length = 1;
	        object = undefined;
	      }
	      while (++index < length) {
	        var value = object == null ? undefined : object[toKey(path[index])];
	        if (value === undefined) {
	          index = length;
	          value = defaultValue;
	        }
	        object = isFunction(value) ? value.call(object) : value;
	      }
	      return object;
	    }
	
	    /**
	     * Sets the value at `path` of `object`. If a portion of `path` doesn't exist,
	     * it's created. Arrays are created for missing index properties while objects
	     * are created for all other missing properties. Use `_.setWith` to customize
	     * `path` creation.
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.7.0
	     * @category Object
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The path of the property to set.
	     * @param {*} value The value to set.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
	     *
	     * _.set(object, 'a[0].b.c', 4);
	     * console.log(object.a[0].b.c);
	     * // => 4
	     *
	     * _.set(object, ['x', '0', 'y', 'z'], 5);
	     * console.log(object.x[0].y.z);
	     * // => 5
	     */
	    function set(object, path, value) {
	      return object == null ? object : baseSet(object, path, value);
	    }
	
	    /**
	     * This method is like `_.set` except that it accepts `customizer` which is
	     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
	     * path creation is handled by the method instead. The `customizer` is invoked
	     * with three arguments: (nsValue, key, nsObject).
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The path of the property to set.
	     * @param {*} value The value to set.
	     * @param {Function} [customizer] The function to customize assigned values.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * var object = {};
	     *
	     * _.setWith(object, '[0][1]', 'a', Object);
	     * // => { '0': { '1': 'a' } }
	     */
	    function setWith(object, path, value, customizer) {
	      customizer = typeof customizer == 'function' ? customizer : undefined;
	      return object == null ? object : baseSet(object, path, value, customizer);
	    }
	
	    /**
	     * Creates an array of own enumerable string keyed-value pairs for `object`
	     * which can be consumed by `_.fromPairs`. If `object` is a map or set, its
	     * entries are returned.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @alias entries
	     * @category Object
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the key-value pairs.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.toPairs(new Foo);
	     * // => [['a', 1], ['b', 2]] (iteration order is not guaranteed)
	     */
	    var toPairs = createToPairs(keys);
	
	    /**
	     * Creates an array of own and inherited enumerable string keyed-value pairs
	     * for `object` which can be consumed by `_.fromPairs`. If `object` is a map
	     * or set, its entries are returned.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @alias entriesIn
	     * @category Object
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the key-value pairs.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.toPairsIn(new Foo);
	     * // => [['a', 1], ['b', 2], ['c', 3]] (iteration order is not guaranteed)
	     */
	    var toPairsIn = createToPairs(keysIn);
	
	    /**
	     * An alternative to `_.reduce`; this method transforms `object` to a new
	     * `accumulator` object which is the result of running each of its own
	     * enumerable string keyed properties thru `iteratee`, with each invocation
	     * potentially mutating the `accumulator` object. If `accumulator` is not
	     * provided, a new object with the same `[[Prototype]]` will be used. The
	     * iteratee is invoked with four arguments: (accumulator, value, key, object).
	     * Iteratee functions may exit iteration early by explicitly returning `false`.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.3.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @param {*} [accumulator] The custom accumulator value.
	     * @returns {*} Returns the accumulated value.
	     * @example
	     *
	     * _.transform([2, 3, 4], function(result, n) {
	     *   result.push(n *= n);
	     *   return n % 2 == 0;
	     * }, []);
	     * // => [4, 9]
	     *
	     * _.transform({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
	     *   (result[value] || (result[value] = [])).push(key);
	     * }, {});
	     * // => { '1': ['a', 'c'], '2': ['b'] }
	     */
	    function transform(object, iteratee, accumulator) {
	      var isArr = isArray(object),
	          isArrLike = isArr || isBuffer(object) || isTypedArray(object);
	
	      iteratee = getIteratee(iteratee, 4);
	      if (accumulator == null) {
	        var Ctor = object && object.constructor;
	        if (isArrLike) {
	          accumulator = isArr ? new Ctor : [];
	        }
	        else if (isObject(object)) {
	          accumulator = isFunction(Ctor) ? baseCreate(getPrototype(object)) : {};
	        }
	        else {
	          accumulator = {};
	        }
	      }
	      (isArrLike ? arrayEach : baseForOwn)(object, function(value, index, object) {
	        return iteratee(accumulator, value, index, object);
	      });
	      return accumulator;
	    }
	
	    /**
	     * Removes the property at `path` of `object`.
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The path of the property to unset.
	     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c': 7 } }] };
	     * _.unset(object, 'a[0].b.c');
	     * // => true
	     *
	     * console.log(object);
	     * // => { 'a': [{ 'b': {} }] };
	     *
	     * _.unset(object, ['a', '0', 'b', 'c']);
	     * // => true
	     *
	     * console.log(object);
	     * // => { 'a': [{ 'b': {} }] };
	     */
	    function unset(object, path) {
	      return object == null ? true : baseUnset(object, path);
	    }
	
	    /**
	     * This method is like `_.set` except that accepts `updater` to produce the
	     * value to set. Use `_.updateWith` to customize `path` creation. The `updater`
	     * is invoked with one argument: (value).
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.6.0
	     * @category Object
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The path of the property to set.
	     * @param {Function} updater The function to produce the updated value.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
	     *
	     * _.update(object, 'a[0].b.c', function(n) { return n * n; });
	     * console.log(object.a[0].b.c);
	     * // => 9
	     *
	     * _.update(object, 'x[0].y.z', function(n) { return n ? n + 1 : 0; });
	     * console.log(object.x[0].y.z);
	     * // => 0
	     */
	    function update(object, path, updater) {
	      return object == null ? object : baseUpdate(object, path, castFunction(updater));
	    }
	
	    /**
	     * This method is like `_.update` except that it accepts `customizer` which is
	     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
	     * path creation is handled by the method instead. The `customizer` is invoked
	     * with three arguments: (nsValue, key, nsObject).
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.6.0
	     * @category Object
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The path of the property to set.
	     * @param {Function} updater The function to produce the updated value.
	     * @param {Function} [customizer] The function to customize assigned values.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * var object = {};
	     *
	     * _.updateWith(object, '[0][1]', _.constant('a'), Object);
	     * // => { '0': { '1': 'a' } }
	     */
	    function updateWith(object, path, updater, customizer) {
	      customizer = typeof customizer == 'function' ? customizer : undefined;
	      return object == null ? object : baseUpdate(object, path, castFunction(updater), customizer);
	    }
	
	    /**
	     * Creates an array of the own enumerable string keyed property values of `object`.
	     *
	     * **Note:** Non-object values are coerced to objects.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property values.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.values(new Foo);
	     * // => [1, 2] (iteration order is not guaranteed)
	     *
	     * _.values('hi');
	     * // => ['h', 'i']
	     */
	    function values(object) {
	      return object == null ? [] : baseValues(object, keys(object));
	    }
	
	    /**
	     * Creates an array of the own and inherited enumerable string keyed property
	     * values of `object`.
	     *
	     * **Note:** Non-object values are coerced to objects.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Object
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property values.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.valuesIn(new Foo);
	     * // => [1, 2, 3] (iteration order is not guaranteed)
	     */
	    function valuesIn(object) {
	      return object == null ? [] : baseValues(object, keysIn(object));
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Clamps `number` within the inclusive `lower` and `upper` bounds.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Number
	     * @param {number} number The number to clamp.
	     * @param {number} [lower] The lower bound.
	     * @param {number} upper The upper bound.
	     * @returns {number} Returns the clamped number.
	     * @example
	     *
	     * _.clamp(-10, -5, 5);
	     * // => -5
	     *
	     * _.clamp(10, -5, 5);
	     * // => 5
	     */
	    function clamp(number, lower, upper) {
	      if (upper === undefined) {
	        upper = lower;
	        lower = undefined;
	      }
	      if (upper !== undefined) {
	        upper = toNumber(upper);
	        upper = upper === upper ? upper : 0;
	      }
	      if (lower !== undefined) {
	        lower = toNumber(lower);
	        lower = lower === lower ? lower : 0;
	      }
	      return baseClamp(toNumber(number), lower, upper);
	    }
	
	    /**
	     * Checks if `n` is between `start` and up to, but not including, `end`. If
	     * `end` is not specified, it's set to `start` with `start` then set to `0`.
	     * If `start` is greater than `end` the params are swapped to support
	     * negative ranges.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.3.0
	     * @category Number
	     * @param {number} number The number to check.
	     * @param {number} [start=0] The start of the range.
	     * @param {number} end The end of the range.
	     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
	     * @see _.range, _.rangeRight
	     * @example
	     *
	     * _.inRange(3, 2, 4);
	     * // => true
	     *
	     * _.inRange(4, 8);
	     * // => true
	     *
	     * _.inRange(4, 2);
	     * // => false
	     *
	     * _.inRange(2, 2);
	     * // => false
	     *
	     * _.inRange(1.2, 2);
	     * // => true
	     *
	     * _.inRange(5.2, 4);
	     * // => false
	     *
	     * _.inRange(-3, -2, -6);
	     * // => true
	     */
	    function inRange(number, start, end) {
	      start = toFinite(start);
	      if (end === undefined) {
	        end = start;
	        start = 0;
	      } else {
	        end = toFinite(end);
	      }
	      number = toNumber(number);
	      return baseInRange(number, start, end);
	    }
	
	    /**
	     * Produces a random number between the inclusive `lower` and `upper` bounds.
	     * If only one argument is provided a number between `0` and the given number
	     * is returned. If `floating` is `true`, or either `lower` or `upper` are
	     * floats, a floating-point number is returned instead of an integer.
	     *
	     * **Note:** JavaScript follows the IEEE-754 standard for resolving
	     * floating-point values which can produce unexpected results.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.7.0
	     * @category Number
	     * @param {number} [lower=0] The lower bound.
	     * @param {number} [upper=1] The upper bound.
	     * @param {boolean} [floating] Specify returning a floating-point number.
	     * @returns {number} Returns the random number.
	     * @example
	     *
	     * _.random(0, 5);
	     * // => an integer between 0 and 5
	     *
	     * _.random(5);
	     * // => also an integer between 0 and 5
	     *
	     * _.random(5, true);
	     * // => a floating-point number between 0 and 5
	     *
	     * _.random(1.2, 5.2);
	     * // => a floating-point number between 1.2 and 5.2
	     */
	    function random(lower, upper, floating) {
	      if (floating && typeof floating != 'boolean' && isIterateeCall(lower, upper, floating)) {
	        upper = floating = undefined;
	      }
	      if (floating === undefined) {
	        if (typeof upper == 'boolean') {
	          floating = upper;
	          upper = undefined;
	        }
	        else if (typeof lower == 'boolean') {
	          floating = lower;
	          lower = undefined;
	        }
	      }
	      if (lower === undefined && upper === undefined) {
	        lower = 0;
	        upper = 1;
	      }
	      else {
	        lower = toFinite(lower);
	        if (upper === undefined) {
	          upper = lower;
	          lower = 0;
	        } else {
	          upper = toFinite(upper);
	        }
	      }
	      if (lower > upper) {
	        var temp = lower;
	        lower = upper;
	        upper = temp;
	      }
	      if (floating || lower % 1 || upper % 1) {
	        var rand = nativeRandom();
	        return nativeMin(lower + (rand * (upper - lower + freeParseFloat('1e-' + ((rand + '').length - 1)))), upper);
	      }
	      return baseRandom(lower, upper);
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Converts `string` to [camel case](https://en.wikipedia.org/wiki/CamelCase).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the camel cased string.
	     * @example
	     *
	     * _.camelCase('Foo Bar');
	     * // => 'fooBar'
	     *
	     * _.camelCase('--foo-bar--');
	     * // => 'fooBar'
	     *
	     * _.camelCase('__FOO_BAR__');
	     * // => 'fooBar'
	     */
	    var camelCase = createCompounder(function(result, word, index) {
	      word = word.toLowerCase();
	      return result + (index ? capitalize(word) : word);
	    });
	
	    /**
	     * Converts the first character of `string` to upper case and the remaining
	     * to lower case.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to capitalize.
	     * @returns {string} Returns the capitalized string.
	     * @example
	     *
	     * _.capitalize('FRED');
	     * // => 'Fred'
	     */
	    function capitalize(string) {
	      return upperFirst(toString(string).toLowerCase());
	    }
	
	    /**
	     * Deburrs `string` by converting
	     * [Latin-1 Supplement](https://en.wikipedia.org/wiki/Latin-1_Supplement_(Unicode_block)#Character_table)
	     * and [Latin Extended-A](https://en.wikipedia.org/wiki/Latin_Extended-A)
	     * letters to basic Latin letters and removing
	     * [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to deburr.
	     * @returns {string} Returns the deburred string.
	     * @example
	     *
	     * _.deburr('déjà vu');
	     * // => 'deja vu'
	     */
	    function deburr(string) {
	      string = toString(string);
	      return string && string.replace(reLatin, deburrLetter).replace(reComboMark, '');
	    }
	
	    /**
	     * Checks if `string` ends with the given target string.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to inspect.
	     * @param {string} [target] The string to search for.
	     * @param {number} [position=string.length] The position to search up to.
	     * @returns {boolean} Returns `true` if `string` ends with `target`,
	     *  else `false`.
	     * @example
	     *
	     * _.endsWith('abc', 'c');
	     * // => true
	     *
	     * _.endsWith('abc', 'b');
	     * // => false
	     *
	     * _.endsWith('abc', 'b', 2);
	     * // => true
	     */
	    function endsWith(string, target, position) {
	      string = toString(string);
	      target = baseToString(target);
	
	      var length = string.length;
	      position = position === undefined
	        ? length
	        : baseClamp(toInteger(position), 0, length);
	
	      var end = position;
	      position -= target.length;
	      return position >= 0 && string.slice(position, end) == target;
	    }
	
	    /**
	     * Converts the characters "&", "<", ">", '"', and "'" in `string` to their
	     * corresponding HTML entities.
	     *
	     * **Note:** No other characters are escaped. To escape additional
	     * characters use a third-party library like [_he_](https://mths.be/he).
	     *
	     * Though the ">" character is escaped for symmetry, characters like
	     * ">" and "/" don't need escaping in HTML and have no special meaning
	     * unless they're part of a tag or unquoted attribute value. See
	     * [Mathias Bynens's article](https://mathiasbynens.be/notes/ambiguous-ampersands)
	     * (under "semi-related fun fact") for more details.
	     *
	     * When working with HTML you should always
	     * [quote attribute values](http://wonko.com/post/html-escaping) to reduce
	     * XSS vectors.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category String
	     * @param {string} [string=''] The string to escape.
	     * @returns {string} Returns the escaped string.
	     * @example
	     *
	     * _.escape('fred, barney, & pebbles');
	     * // => 'fred, barney, &amp; pebbles'
	     */
	    function escape(string) {
	      string = toString(string);
	      return (string && reHasUnescapedHtml.test(string))
	        ? string.replace(reUnescapedHtml, escapeHtmlChar)
	        : string;
	    }
	
	    /**
	     * Escapes the `RegExp` special characters "^", "$", "\", ".", "*", "+",
	     * "?", "(", ")", "[", "]", "{", "}", and "|" in `string`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to escape.
	     * @returns {string} Returns the escaped string.
	     * @example
	     *
	     * _.escapeRegExp('[lodash](https://lodash.com/)');
	     * // => '\[lodash\]\(https://lodash\.com/\)'
	     */
	    function escapeRegExp(string) {
	      string = toString(string);
	      return (string && reHasRegExpChar.test(string))
	        ? string.replace(reRegExpChar, '\\$&')
	        : string;
	    }
	
	    /**
	     * Converts `string` to
	     * [kebab case](https://en.wikipedia.org/wiki/Letter_case#Special_case_styles).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the kebab cased string.
	     * @example
	     *
	     * _.kebabCase('Foo Bar');
	     * // => 'foo-bar'
	     *
	     * _.kebabCase('fooBar');
	     * // => 'foo-bar'
	     *
	     * _.kebabCase('__FOO_BAR__');
	     * // => 'foo-bar'
	     */
	    var kebabCase = createCompounder(function(result, word, index) {
	      return result + (index ? '-' : '') + word.toLowerCase();
	    });
	
	    /**
	     * Converts `string`, as space separated words, to lower case.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the lower cased string.
	     * @example
	     *
	     * _.lowerCase('--Foo-Bar--');
	     * // => 'foo bar'
	     *
	     * _.lowerCase('fooBar');
	     * // => 'foo bar'
	     *
	     * _.lowerCase('__FOO_BAR__');
	     * // => 'foo bar'
	     */
	    var lowerCase = createCompounder(function(result, word, index) {
	      return result + (index ? ' ' : '') + word.toLowerCase();
	    });
	
	    /**
	     * Converts the first character of `string` to lower case.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the converted string.
	     * @example
	     *
	     * _.lowerFirst('Fred');
	     * // => 'fred'
	     *
	     * _.lowerFirst('FRED');
	     * // => 'fRED'
	     */
	    var lowerFirst = createCaseFirst('toLowerCase');
	
	    /**
	     * Pads `string` on the left and right sides if it's shorter than `length`.
	     * Padding characters are truncated if they can't be evenly divided by `length`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to pad.
	     * @param {number} [length=0] The padding length.
	     * @param {string} [chars=' '] The string used as padding.
	     * @returns {string} Returns the padded string.
	     * @example
	     *
	     * _.pad('abc', 8);
	     * // => '  abc   '
	     *
	     * _.pad('abc', 8, '_-');
	     * // => '_-abc_-_'
	     *
	     * _.pad('abc', 3);
	     * // => 'abc'
	     */
	    function pad(string, length, chars) {
	      string = toString(string);
	      length = toInteger(length);
	
	      var strLength = length ? stringSize(string) : 0;
	      if (!length || strLength >= length) {
	        return string;
	      }
	      var mid = (length - strLength) / 2;
	      return (
	        createPadding(nativeFloor(mid), chars) +
	        string +
	        createPadding(nativeCeil(mid), chars)
	      );
	    }
	
	    /**
	     * Pads `string` on the right side if it's shorter than `length`. Padding
	     * characters are truncated if they exceed `length`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to pad.
	     * @param {number} [length=0] The padding length.
	     * @param {string} [chars=' '] The string used as padding.
	     * @returns {string} Returns the padded string.
	     * @example
	     *
	     * _.padEnd('abc', 6);
	     * // => 'abc   '
	     *
	     * _.padEnd('abc', 6, '_-');
	     * // => 'abc_-_'
	     *
	     * _.padEnd('abc', 3);
	     * // => 'abc'
	     */
	    function padEnd(string, length, chars) {
	      string = toString(string);
	      length = toInteger(length);
	
	      var strLength = length ? stringSize(string) : 0;
	      return (length && strLength < length)
	        ? (string + createPadding(length - strLength, chars))
	        : string;
	    }
	
	    /**
	     * Pads `string` on the left side if it's shorter than `length`. Padding
	     * characters are truncated if they exceed `length`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to pad.
	     * @param {number} [length=0] The padding length.
	     * @param {string} [chars=' '] The string used as padding.
	     * @returns {string} Returns the padded string.
	     * @example
	     *
	     * _.padStart('abc', 6);
	     * // => '   abc'
	     *
	     * _.padStart('abc', 6, '_-');
	     * // => '_-_abc'
	     *
	     * _.padStart('abc', 3);
	     * // => 'abc'
	     */
	    function padStart(string, length, chars) {
	      string = toString(string);
	      length = toInteger(length);
	
	      var strLength = length ? stringSize(string) : 0;
	      return (length && strLength < length)
	        ? (createPadding(length - strLength, chars) + string)
	        : string;
	    }
	
	    /**
	     * Converts `string` to an integer of the specified radix. If `radix` is
	     * `undefined` or `0`, a `radix` of `10` is used unless `value` is a
	     * hexadecimal, in which case a `radix` of `16` is used.
	     *
	     * **Note:** This method aligns with the
	     * [ES5 implementation](https://es5.github.io/#x15.1.2.2) of `parseInt`.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.1.0
	     * @category String
	     * @param {string} string The string to convert.
	     * @param {number} [radix=10] The radix to interpret `value` by.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {number} Returns the converted integer.
	     * @example
	     *
	     * _.parseInt('08');
	     * // => 8
	     *
	     * _.map(['6', '08', '10'], _.parseInt);
	     * // => [6, 8, 10]
	     */
	    function parseInt(string, radix, guard) {
	      if (guard || radix == null) {
	        radix = 0;
	      } else if (radix) {
	        radix = +radix;
	      }
	      return nativeParseInt(toString(string).replace(reTrimStart, ''), radix || 0);
	    }
	
	    /**
	     * Repeats the given string `n` times.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to repeat.
	     * @param {number} [n=1] The number of times to repeat the string.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {string} Returns the repeated string.
	     * @example
	     *
	     * _.repeat('*', 3);
	     * // => '***'
	     *
	     * _.repeat('abc', 2);
	     * // => 'abcabc'
	     *
	     * _.repeat('abc', 0);
	     * // => ''
	     */
	    function repeat(string, n, guard) {
	      if ((guard ? isIterateeCall(string, n, guard) : n === undefined)) {
	        n = 1;
	      } else {
	        n = toInteger(n);
	      }
	      return baseRepeat(toString(string), n);
	    }
	
	    /**
	     * Replaces matches for `pattern` in `string` with `replacement`.
	     *
	     * **Note:** This method is based on
	     * [`String#replace`](https://mdn.io/String/replace).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to modify.
	     * @param {RegExp|string} pattern The pattern to replace.
	     * @param {Function|string} replacement The match replacement.
	     * @returns {string} Returns the modified string.
	     * @example
	     *
	     * _.replace('Hi Fred', 'Fred', 'Barney');
	     * // => 'Hi Barney'
	     */
	    function replace() {
	      var args = arguments,
	          string = toString(args[0]);
	
	      return args.length < 3 ? string : string.replace(args[1], args[2]);
	    }
	
	    /**
	     * Converts `string` to
	     * [snake case](https://en.wikipedia.org/wiki/Snake_case).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the snake cased string.
	     * @example
	     *
	     * _.snakeCase('Foo Bar');
	     * // => 'foo_bar'
	     *
	     * _.snakeCase('fooBar');
	     * // => 'foo_bar'
	     *
	     * _.snakeCase('--FOO-BAR--');
	     * // => 'foo_bar'
	     */
	    var snakeCase = createCompounder(function(result, word, index) {
	      return result + (index ? '_' : '') + word.toLowerCase();
	    });
	
	    /**
	     * Splits `string` by `separator`.
	     *
	     * **Note:** This method is based on
	     * [`String#split`](https://mdn.io/String/split).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to split.
	     * @param {RegExp|string} separator The separator pattern to split by.
	     * @param {number} [limit] The length to truncate results to.
	     * @returns {Array} Returns the string segments.
	     * @example
	     *
	     * _.split('a-b-c', '-', 2);
	     * // => ['a', 'b']
	     */
	    function split(string, separator, limit) {
	      if (limit && typeof limit != 'number' && isIterateeCall(string, separator, limit)) {
	        separator = limit = undefined;
	      }
	      limit = limit === undefined ? MAX_ARRAY_LENGTH : limit >>> 0;
	      if (!limit) {
	        return [];
	      }
	      string = toString(string);
	      if (string && (
	            typeof separator == 'string' ||
	            (separator != null && !isRegExp(separator))
	          )) {
	        separator = baseToString(separator);
	        if (!separator && hasUnicode(string)) {
	          return castSlice(stringToArray(string), 0, limit);
	        }
	      }
	      return string.split(separator, limit);
	    }
	
	    /**
	     * Converts `string` to
	     * [start case](https://en.wikipedia.org/wiki/Letter_case#Stylistic_or_specialised_usage).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.1.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the start cased string.
	     * @example
	     *
	     * _.startCase('--foo-bar--');
	     * // => 'Foo Bar'
	     *
	     * _.startCase('fooBar');
	     * // => 'Foo Bar'
	     *
	     * _.startCase('__FOO_BAR__');
	     * // => 'FOO BAR'
	     */
	    var startCase = createCompounder(function(result, word, index) {
	      return result + (index ? ' ' : '') + upperFirst(word);
	    });
	
	    /**
	     * Checks if `string` starts with the given target string.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to inspect.
	     * @param {string} [target] The string to search for.
	     * @param {number} [position=0] The position to search from.
	     * @returns {boolean} Returns `true` if `string` starts with `target`,
	     *  else `false`.
	     * @example
	     *
	     * _.startsWith('abc', 'a');
	     * // => true
	     *
	     * _.startsWith('abc', 'b');
	     * // => false
	     *
	     * _.startsWith('abc', 'b', 1);
	     * // => true
	     */
	    function startsWith(string, target, position) {
	      string = toString(string);
	      position = position == null
	        ? 0
	        : baseClamp(toInteger(position), 0, string.length);
	
	      target = baseToString(target);
	      return string.slice(position, position + target.length) == target;
	    }
	
	    /**
	     * Creates a compiled template function that can interpolate data properties
	     * in "interpolate" delimiters, HTML-escape interpolated data properties in
	     * "escape" delimiters, and execute JavaScript in "evaluate" delimiters. Data
	     * properties may be accessed as free variables in the template. If a setting
	     * object is given, it takes precedence over `_.templateSettings` values.
	     *
	     * **Note:** In the development build `_.template` utilizes
	     * [sourceURLs](http://www.html5rocks.com/en/tutorials/developertools/sourcemaps/#toc-sourceurl)
	     * for easier debugging.
	     *
	     * For more information on precompiling templates see
	     * [lodash's custom builds documentation](https://lodash.com/custom-builds).
	     *
	     * For more information on Chrome extension sandboxes see
	     * [Chrome's extensions documentation](https://developer.chrome.com/extensions/sandboxingEval).
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category String
	     * @param {string} [string=''] The template string.
	     * @param {Object} [options={}] The options object.
	     * @param {RegExp} [options.escape=_.templateSettings.escape]
	     *  The HTML "escape" delimiter.
	     * @param {RegExp} [options.evaluate=_.templateSettings.evaluate]
	     *  The "evaluate" delimiter.
	     * @param {Object} [options.imports=_.templateSettings.imports]
	     *  An object to import into the template as free variables.
	     * @param {RegExp} [options.interpolate=_.templateSettings.interpolate]
	     *  The "interpolate" delimiter.
	     * @param {string} [options.sourceURL='lodash.templateSources[n]']
	     *  The sourceURL of the compiled template.
	     * @param {string} [options.variable='obj']
	     *  The data object variable name.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Function} Returns the compiled template function.
	     * @example
	     *
	     * // Use the "interpolate" delimiter to create a compiled template.
	     * var compiled = _.template('hello <%= user %>!');
	     * compiled({ 'user': 'fred' });
	     * // => 'hello fred!'
	     *
	     * // Use the HTML "escape" delimiter to escape data property values.
	     * var compiled = _.template('<b><%- value %></b>');
	     * compiled({ 'value': '<script>' });
	     * // => '<b>&lt;script&gt;</b>'
	     *
	     * // Use the "evaluate" delimiter to execute JavaScript and generate HTML.
	     * var compiled = _.template('<% _.forEach(users, function(user) { %><li><%- user %></li><% }); %>');
	     * compiled({ 'users': ['fred', 'barney'] });
	     * // => '<li>fred</li><li>barney</li>'
	     *
	     * // Use the internal `print` function in "evaluate" delimiters.
	     * var compiled = _.template('<% print("hello " + user); %>!');
	     * compiled({ 'user': 'barney' });
	     * // => 'hello barney!'
	     *
	     * // Use the ES template literal delimiter as an "interpolate" delimiter.
	     * // Disable support by replacing the "interpolate" delimiter.
	     * var compiled = _.template('hello ${ user }!');
	     * compiled({ 'user': 'pebbles' });
	     * // => 'hello pebbles!'
	     *
	     * // Use backslashes to treat delimiters as plain text.
	     * var compiled = _.template('<%= "\\<%- value %\\>" %>');
	     * compiled({ 'value': 'ignored' });
	     * // => '<%- value %>'
	     *
	     * // Use the `imports` option to import `jQuery` as `jq`.
	     * var text = '<% jq.each(users, function(user) { %><li><%- user %></li><% }); %>';
	     * var compiled = _.template(text, { 'imports': { 'jq': jQuery } });
	     * compiled({ 'users': ['fred', 'barney'] });
	     * // => '<li>fred</li><li>barney</li>'
	     *
	     * // Use the `sourceURL` option to specify a custom sourceURL for the template.
	     * var compiled = _.template('hello <%= user %>!', { 'sourceURL': '/basic/greeting.jst' });
	     * compiled(data);
	     * // => Find the source of "greeting.jst" under the Sources tab or Resources panel of the web inspector.
	     *
	     * // Use the `variable` option to ensure a with-statement isn't used in the compiled template.
	     * var compiled = _.template('hi <%= data.user %>!', { 'variable': 'data' });
	     * compiled.source;
	     * // => function(data) {
	     * //   var __t, __p = '';
	     * //   __p += 'hi ' + ((__t = ( data.user )) == null ? '' : __t) + '!';
	     * //   return __p;
	     * // }
	     *
	     * // Use custom template delimiters.
	     * _.templateSettings.interpolate = /{{([\s\S]+?)}}/g;
	     * var compiled = _.template('hello {{ user }}!');
	     * compiled({ 'user': 'mustache' });
	     * // => 'hello mustache!'
	     *
	     * // Use the `source` property to inline compiled templates for meaningful
	     * // line numbers in error messages and stack traces.
	     * fs.writeFileSync(path.join(process.cwd(), 'jst.js'), '\
	     *   var JST = {\
	     *     "main": ' + _.template(mainText).source + '\
	     *   };\
	     * ');
	     */
	    function template(string, options, guard) {
	      // Based on John Resig's `tmpl` implementation
	      // (http://ejohn.org/blog/javascript-micro-templating/)
	      // and Laura Doktorova's doT.js (https://github.com/olado/doT).
	      var settings = lodash.templateSettings;
	
	      if (guard && isIterateeCall(string, options, guard)) {
	        options = undefined;
	      }
	      string = toString(string);
	      options = assignInWith({}, options, settings, customDefaultsAssignIn);
	
	      var imports = assignInWith({}, options.imports, settings.imports, customDefaultsAssignIn),
	          importsKeys = keys(imports),
	          importsValues = baseValues(imports, importsKeys);
	
	      var isEscaping,
	          isEvaluating,
	          index = 0,
	          interpolate = options.interpolate || reNoMatch,
	          source = "__p += '";
	
	      // Compile the regexp to match each delimiter.
	      var reDelimiters = RegExp(
	        (options.escape || reNoMatch).source + '|' +
	        interpolate.source + '|' +
	        (interpolate === reInterpolate ? reEsTemplate : reNoMatch).source + '|' +
	        (options.evaluate || reNoMatch).source + '|$'
	      , 'g');
	
	      // Use a sourceURL for easier debugging.
	      var sourceURL = '//# sourceURL=' +
	        ('sourceURL' in options
	          ? options.sourceURL
	          : ('lodash.templateSources[' + (++templateCounter) + ']')
	        ) + '\n';
	
	      string.replace(reDelimiters, function(match, escapeValue, interpolateValue, esTemplateValue, evaluateValue, offset) {
	        interpolateValue || (interpolateValue = esTemplateValue);
	
	        // Escape characters that can't be included in string literals.
	        source += string.slice(index, offset).replace(reUnescapedString, escapeStringChar);
	
	        // Replace delimiters with snippets.
	        if (escapeValue) {
	          isEscaping = true;
	          source += "' +\n__e(" + escapeValue + ") +\n'";
	        }
	        if (evaluateValue) {
	          isEvaluating = true;
	          source += "';\n" + evaluateValue + ";\n__p += '";
	        }
	        if (interpolateValue) {
	          source += "' +\n((__t = (" + interpolateValue + ")) == null ? '' : __t) +\n'";
	        }
	        index = offset + match.length;
	
	        // The JS engine embedded in Adobe products needs `match` returned in
	        // order to produce the correct `offset` value.
	        return match;
	      });
	
	      source += "';\n";
	
	      // If `variable` is not specified wrap a with-statement around the generated
	      // code to add the data object to the top of the scope chain.
	      var variable = options.variable;
	      if (!variable) {
	        source = 'with (obj) {\n' + source + '\n}\n';
	      }
	      // Cleanup code by stripping empty strings.
	      source = (isEvaluating ? source.replace(reEmptyStringLeading, '') : source)
	        .replace(reEmptyStringMiddle, '$1')
	        .replace(reEmptyStringTrailing, '$1;');
	
	      // Frame code as the function body.
	      source = 'function(' + (variable || 'obj') + ') {\n' +
	        (variable
	          ? ''
	          : 'obj || (obj = {});\n'
	        ) +
	        "var __t, __p = ''" +
	        (isEscaping
	           ? ', __e = _.escape'
	           : ''
	        ) +
	        (isEvaluating
	          ? ', __j = Array.prototype.join;\n' +
	            "function print() { __p += __j.call(arguments, '') }\n"
	          : ';\n'
	        ) +
	        source +
	        'return __p\n}';
	
	      var result = attempt(function() {
	        return Function(importsKeys, sourceURL + 'return ' + source)
	          .apply(undefined, importsValues);
	      });
	
	      // Provide the compiled function's source by its `toString` method or
	      // the `source` property as a convenience for inlining compiled templates.
	      result.source = source;
	      if (isError(result)) {
	        throw result;
	      }
	      return result;
	    }
	
	    /**
	     * Converts `string`, as a whole, to lower case just like
	     * [String#toLowerCase](https://mdn.io/toLowerCase).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the lower cased string.
	     * @example
	     *
	     * _.toLower('--Foo-Bar--');
	     * // => '--foo-bar--'
	     *
	     * _.toLower('fooBar');
	     * // => 'foobar'
	     *
	     * _.toLower('__FOO_BAR__');
	     * // => '__foo_bar__'
	     */
	    function toLower(value) {
	      return toString(value).toLowerCase();
	    }
	
	    /**
	     * Converts `string`, as a whole, to upper case just like
	     * [String#toUpperCase](https://mdn.io/toUpperCase).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the upper cased string.
	     * @example
	     *
	     * _.toUpper('--foo-bar--');
	     * // => '--FOO-BAR--'
	     *
	     * _.toUpper('fooBar');
	     * // => 'FOOBAR'
	     *
	     * _.toUpper('__foo_bar__');
	     * // => '__FOO_BAR__'
	     */
	    function toUpper(value) {
	      return toString(value).toUpperCase();
	    }
	
	    /**
	     * Removes leading and trailing whitespace or specified characters from `string`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to trim.
	     * @param {string} [chars=whitespace] The characters to trim.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {string} Returns the trimmed string.
	     * @example
	     *
	     * _.trim('  abc  ');
	     * // => 'abc'
	     *
	     * _.trim('-_-abc-_-', '_-');
	     * // => 'abc'
	     *
	     * _.map(['  foo  ', '  bar  '], _.trim);
	     * // => ['foo', 'bar']
	     */
	    function trim(string, chars, guard) {
	      string = toString(string);
	      if (string && (guard || chars === undefined)) {
	        return string.replace(reTrim, '');
	      }
	      if (!string || !(chars = baseToString(chars))) {
	        return string;
	      }
	      var strSymbols = stringToArray(string),
	          chrSymbols = stringToArray(chars),
	          start = charsStartIndex(strSymbols, chrSymbols),
	          end = charsEndIndex(strSymbols, chrSymbols) + 1;
	
	      return castSlice(strSymbols, start, end).join('');
	    }
	
	    /**
	     * Removes trailing whitespace or specified characters from `string`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to trim.
	     * @param {string} [chars=whitespace] The characters to trim.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {string} Returns the trimmed string.
	     * @example
	     *
	     * _.trimEnd('  abc  ');
	     * // => '  abc'
	     *
	     * _.trimEnd('-_-abc-_-', '_-');
	     * // => '-_-abc'
	     */
	    function trimEnd(string, chars, guard) {
	      string = toString(string);
	      if (string && (guard || chars === undefined)) {
	        return string.replace(reTrimEnd, '');
	      }
	      if (!string || !(chars = baseToString(chars))) {
	        return string;
	      }
	      var strSymbols = stringToArray(string),
	          end = charsEndIndex(strSymbols, stringToArray(chars)) + 1;
	
	      return castSlice(strSymbols, 0, end).join('');
	    }
	
	    /**
	     * Removes leading whitespace or specified characters from `string`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to trim.
	     * @param {string} [chars=whitespace] The characters to trim.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {string} Returns the trimmed string.
	     * @example
	     *
	     * _.trimStart('  abc  ');
	     * // => 'abc  '
	     *
	     * _.trimStart('-_-abc-_-', '_-');
	     * // => 'abc-_-'
	     */
	    function trimStart(string, chars, guard) {
	      string = toString(string);
	      if (string && (guard || chars === undefined)) {
	        return string.replace(reTrimStart, '');
	      }
	      if (!string || !(chars = baseToString(chars))) {
	        return string;
	      }
	      var strSymbols = stringToArray(string),
	          start = charsStartIndex(strSymbols, stringToArray(chars));
	
	      return castSlice(strSymbols, start).join('');
	    }
	
	    /**
	     * Truncates `string` if it's longer than the given maximum string length.
	     * The last characters of the truncated string are replaced with the omission
	     * string which defaults to "...".
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to truncate.
	     * @param {Object} [options={}] The options object.
	     * @param {number} [options.length=30] The maximum string length.
	     * @param {string} [options.omission='...'] The string to indicate text is omitted.
	     * @param {RegExp|string} [options.separator] The separator pattern to truncate to.
	     * @returns {string} Returns the truncated string.
	     * @example
	     *
	     * _.truncate('hi-diddly-ho there, neighborino');
	     * // => 'hi-diddly-ho there, neighbo...'
	     *
	     * _.truncate('hi-diddly-ho there, neighborino', {
	     *   'length': 24,
	     *   'separator': ' '
	     * });
	     * // => 'hi-diddly-ho there,...'
	     *
	     * _.truncate('hi-diddly-ho there, neighborino', {
	     *   'length': 24,
	     *   'separator': /,? +/
	     * });
	     * // => 'hi-diddly-ho there...'
	     *
	     * _.truncate('hi-diddly-ho there, neighborino', {
	     *   'omission': ' [...]'
	     * });
	     * // => 'hi-diddly-ho there, neig [...]'
	     */
	    function truncate(string, options) {
	      var length = DEFAULT_TRUNC_LENGTH,
	          omission = DEFAULT_TRUNC_OMISSION;
	
	      if (isObject(options)) {
	        var separator = 'separator' in options ? options.separator : separator;
	        length = 'length' in options ? toInteger(options.length) : length;
	        omission = 'omission' in options ? baseToString(options.omission) : omission;
	      }
	      string = toString(string);
	
	      var strLength = string.length;
	      if (hasUnicode(string)) {
	        var strSymbols = stringToArray(string);
	        strLength = strSymbols.length;
	      }
	      if (length >= strLength) {
	        return string;
	      }
	      var end = length - stringSize(omission);
	      if (end < 1) {
	        return omission;
	      }
	      var result = strSymbols
	        ? castSlice(strSymbols, 0, end).join('')
	        : string.slice(0, end);
	
	      if (separator === undefined) {
	        return result + omission;
	      }
	      if (strSymbols) {
	        end += (result.length - end);
	      }
	      if (isRegExp(separator)) {
	        if (string.slice(end).search(separator)) {
	          var match,
	              substring = result;
	
	          if (!separator.global) {
	            separator = RegExp(separator.source, toString(reFlags.exec(separator)) + 'g');
	          }
	          separator.lastIndex = 0;
	          while ((match = separator.exec(substring))) {
	            var newEnd = match.index;
	          }
	          result = result.slice(0, newEnd === undefined ? end : newEnd);
	        }
	      } else if (string.indexOf(baseToString(separator), end) != end) {
	        var index = result.lastIndexOf(separator);
	        if (index > -1) {
	          result = result.slice(0, index);
	        }
	      }
	      return result + omission;
	    }
	
	    /**
	     * The inverse of `_.escape`; this method converts the HTML entities
	     * `&amp;`, `&lt;`, `&gt;`, `&quot;`, and `&#39;` in `string` to
	     * their corresponding characters.
	     *
	     * **Note:** No other HTML entities are unescaped. To unescape additional
	     * HTML entities use a third-party library like [_he_](https://mths.be/he).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.6.0
	     * @category String
	     * @param {string} [string=''] The string to unescape.
	     * @returns {string} Returns the unescaped string.
	     * @example
	     *
	     * _.unescape('fred, barney, &amp; pebbles');
	     * // => 'fred, barney, & pebbles'
	     */
	    function unescape(string) {
	      string = toString(string);
	      return (string && reHasEscapedHtml.test(string))
	        ? string.replace(reEscapedHtml, unescapeHtmlChar)
	        : string;
	    }
	
	    /**
	     * Converts `string`, as space separated words, to upper case.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the upper cased string.
	     * @example
	     *
	     * _.upperCase('--foo-bar');
	     * // => 'FOO BAR'
	     *
	     * _.upperCase('fooBar');
	     * // => 'FOO BAR'
	     *
	     * _.upperCase('__foo_bar__');
	     * // => 'FOO BAR'
	     */
	    var upperCase = createCompounder(function(result, word, index) {
	      return result + (index ? ' ' : '') + word.toUpperCase();
	    });
	
	    /**
	     * Converts the first character of `string` to upper case.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the converted string.
	     * @example
	     *
	     * _.upperFirst('fred');
	     * // => 'Fred'
	     *
	     * _.upperFirst('FRED');
	     * // => 'FRED'
	     */
	    var upperFirst = createCaseFirst('toUpperCase');
	
	    /**
	     * Splits `string` into an array of its words.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to inspect.
	     * @param {RegExp|string} [pattern] The pattern to match words.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Array} Returns the words of `string`.
	     * @example
	     *
	     * _.words('fred, barney, & pebbles');
	     * // => ['fred', 'barney', 'pebbles']
	     *
	     * _.words('fred, barney, & pebbles', /[^, ]+/g);
	     * // => ['fred', 'barney', '&', 'pebbles']
	     */
	    function words(string, pattern, guard) {
	      string = toString(string);
	      pattern = guard ? undefined : pattern;
	
	      if (pattern === undefined) {
	        return hasUnicodeWord(string) ? unicodeWords(string) : asciiWords(string);
	      }
	      return string.match(pattern) || [];
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Attempts to invoke `func`, returning either the result or the caught error
	     * object. Any additional arguments are provided to `func` when it's invoked.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Util
	     * @param {Function} func The function to attempt.
	     * @param {...*} [args] The arguments to invoke `func` with.
	     * @returns {*} Returns the `func` result or error object.
	     * @example
	     *
	     * // Avoid throwing errors for invalid selectors.
	     * var elements = _.attempt(function(selector) {
	     *   return document.querySelectorAll(selector);
	     * }, '>_>');
	     *
	     * if (_.isError(elements)) {
	     *   elements = [];
	     * }
	     */
	    var attempt = baseRest(function(func, args) {
	      try {
	        return apply(func, undefined, args);
	      } catch (e) {
	        return isError(e) ? e : new Error(e);
	      }
	    });
	
	    /**
	     * Binds methods of an object to the object itself, overwriting the existing
	     * method.
	     *
	     * **Note:** This method doesn't set the "length" property of bound functions.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Util
	     * @param {Object} object The object to bind and assign the bound methods to.
	     * @param {...(string|string[])} methodNames The object method names to bind.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * var view = {
	     *   'label': 'docs',
	     *   'click': function() {
	     *     console.log('clicked ' + this.label);
	     *   }
	     * };
	     *
	     * _.bindAll(view, ['click']);
	     * jQuery(element).on('click', view.click);
	     * // => Logs 'clicked docs' when clicked.
	     */
	    var bindAll = flatRest(function(object, methodNames) {
	      arrayEach(methodNames, function(key) {
	        key = toKey(key);
	        baseAssignValue(object, key, bind(object[key], object));
	      });
	      return object;
	    });
	
	    /**
	     * Creates a function that iterates over `pairs` and invokes the corresponding
	     * function of the first predicate to return truthy. The predicate-function
	     * pairs are invoked with the `this` binding and arguments of the created
	     * function.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {Array} pairs The predicate-function pairs.
	     * @returns {Function} Returns the new composite function.
	     * @example
	     *
	     * var func = _.cond([
	     *   [_.matches({ 'a': 1 }),           _.constant('matches A')],
	     *   [_.conforms({ 'b': _.isNumber }), _.constant('matches B')],
	     *   [_.stubTrue,                      _.constant('no match')]
	     * ]);
	     *
	     * func({ 'a': 1, 'b': 2 });
	     * // => 'matches A'
	     *
	     * func({ 'a': 0, 'b': 1 });
	     * // => 'matches B'
	     *
	     * func({ 'a': '1', 'b': '2' });
	     * // => 'no match'
	     */
	    function cond(pairs) {
	      var length = pairs == null ? 0 : pairs.length,
	          toIteratee = getIteratee();
	
	      pairs = !length ? [] : arrayMap(pairs, function(pair) {
	        if (typeof pair[1] != 'function') {
	          throw new TypeError(FUNC_ERROR_TEXT);
	        }
	        return [toIteratee(pair[0]), pair[1]];
	      });
	
	      return baseRest(function(args) {
	        var index = -1;
	        while (++index < length) {
	          var pair = pairs[index];
	          if (apply(pair[0], this, args)) {
	            return apply(pair[1], this, args);
	          }
	        }
	      });
	    }
	
	    /**
	     * Creates a function that invokes the predicate properties of `source` with
	     * the corresponding property values of a given object, returning `true` if
	     * all predicates return truthy, else `false`.
	     *
	     * **Note:** The created function is equivalent to `_.conformsTo` with
	     * `source` partially applied.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {Object} source The object of property predicates to conform to.
	     * @returns {Function} Returns the new spec function.
	     * @example
	     *
	     * var objects = [
	     *   { 'a': 2, 'b': 1 },
	     *   { 'a': 1, 'b': 2 }
	     * ];
	     *
	     * _.filter(objects, _.conforms({ 'b': function(n) { return n > 1; } }));
	     * // => [{ 'a': 1, 'b': 2 }]
	     */
	    function conforms(source) {
	      return baseConforms(baseClone(source, CLONE_DEEP_FLAG));
	    }
	
	    /**
	     * Creates a function that returns `value`.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.4.0
	     * @category Util
	     * @param {*} value The value to return from the new function.
	     * @returns {Function} Returns the new constant function.
	     * @example
	     *
	     * var objects = _.times(2, _.constant({ 'a': 1 }));
	     *
	     * console.log(objects);
	     * // => [{ 'a': 1 }, { 'a': 1 }]
	     *
	     * console.log(objects[0] === objects[1]);
	     * // => true
	     */
	    function constant(value) {
	      return function() {
	        return value;
	      };
	    }
	
	    /**
	     * Checks `value` to determine whether a default value should be returned in
	     * its place. The `defaultValue` is returned if `value` is `NaN`, `null`,
	     * or `undefined`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.14.0
	     * @category Util
	     * @param {*} value The value to check.
	     * @param {*} defaultValue The default value.
	     * @returns {*} Returns the resolved value.
	     * @example
	     *
	     * _.defaultTo(1, 10);
	     * // => 1
	     *
	     * _.defaultTo(undefined, 10);
	     * // => 10
	     */
	    function defaultTo(value, defaultValue) {
	      return (value == null || value !== value) ? defaultValue : value;
	    }
	
	    /**
	     * Creates a function that returns the result of invoking the given functions
	     * with the `this` binding of the created function, where each successive
	     * invocation is supplied the return value of the previous.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Util
	     * @param {...(Function|Function[])} [funcs] The functions to invoke.
	     * @returns {Function} Returns the new composite function.
	     * @see _.flowRight
	     * @example
	     *
	     * function square(n) {
	     *   return n * n;
	     * }
	     *
	     * var addSquare = _.flow([_.add, square]);
	     * addSquare(1, 2);
	     * // => 9
	     */
	    var flow = createFlow();
	
	    /**
	     * This method is like `_.flow` except that it creates a function that
	     * invokes the given functions from right to left.
	     *
	     * @static
	     * @since 3.0.0
	     * @memberOf _
	     * @category Util
	     * @param {...(Function|Function[])} [funcs] The functions to invoke.
	     * @returns {Function} Returns the new composite function.
	     * @see _.flow
	     * @example
	     *
	     * function square(n) {
	     *   return n * n;
	     * }
	     *
	     * var addSquare = _.flowRight([square, _.add]);
	     * addSquare(1, 2);
	     * // => 9
	     */
	    var flowRight = createFlow(true);
	
	    /**
	     * This method returns the first argument it receives.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Util
	     * @param {*} value Any value.
	     * @returns {*} Returns `value`.
	     * @example
	     *
	     * var object = { 'a': 1 };
	     *
	     * console.log(_.identity(object) === object);
	     * // => true
	     */
	    function identity(value) {
	      return value;
	    }
	
	    /**
	     * Creates a function that invokes `func` with the arguments of the created
	     * function. If `func` is a property name, the created function returns the
	     * property value for a given element. If `func` is an array or object, the
	     * created function returns `true` for elements that contain the equivalent
	     * source properties, otherwise it returns `false`.
	     *
	     * @static
	     * @since 4.0.0
	     * @memberOf _
	     * @category Util
	     * @param {*} [func=_.identity] The value to convert to a callback.
	     * @returns {Function} Returns the callback.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney', 'age': 36, 'active': true },
	     *   { 'user': 'fred',   'age': 40, 'active': false }
	     * ];
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.filter(users, _.iteratee({ 'user': 'barney', 'active': true }));
	     * // => [{ 'user': 'barney', 'age': 36, 'active': true }]
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.filter(users, _.iteratee(['user', 'fred']));
	     * // => [{ 'user': 'fred', 'age': 40 }]
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.map(users, _.iteratee('user'));
	     * // => ['barney', 'fred']
	     *
	     * // Create custom iteratee shorthands.
	     * _.iteratee = _.wrap(_.iteratee, function(iteratee, func) {
	     *   return !_.isRegExp(func) ? iteratee(func) : function(string) {
	     *     return func.test(string);
	     *   };
	     * });
	     *
	     * _.filter(['abc', 'def'], /ef/);
	     * // => ['def']
	     */
	    function iteratee(func) {
	      return baseIteratee(typeof func == 'function' ? func : baseClone(func, CLONE_DEEP_FLAG));
	    }
	
	    /**
	     * Creates a function that performs a partial deep comparison between a given
	     * object and `source`, returning `true` if the given object has equivalent
	     * property values, else `false`.
	     *
	     * **Note:** The created function is equivalent to `_.isMatch` with `source`
	     * partially applied.
	     *
	     * Partial comparisons will match empty array and empty object `source`
	     * values against any array or object value, respectively. See `_.isEqual`
	     * for a list of supported value comparisons.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Util
	     * @param {Object} source The object of property values to match.
	     * @returns {Function} Returns the new spec function.
	     * @example
	     *
	     * var objects = [
	     *   { 'a': 1, 'b': 2, 'c': 3 },
	     *   { 'a': 4, 'b': 5, 'c': 6 }
	     * ];
	     *
	     * _.filter(objects, _.matches({ 'a': 4, 'c': 6 }));
	     * // => [{ 'a': 4, 'b': 5, 'c': 6 }]
	     */
	    function matches(source) {
	      return baseMatches(baseClone(source, CLONE_DEEP_FLAG));
	    }
	
	    /**
	     * Creates a function that performs a partial deep comparison between the
	     * value at `path` of a given object to `srcValue`, returning `true` if the
	     * object value is equivalent, else `false`.
	     *
	     * **Note:** Partial comparisons will match empty array and empty object
	     * `srcValue` values against any array or object value, respectively. See
	     * `_.isEqual` for a list of supported value comparisons.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.2.0
	     * @category Util
	     * @param {Array|string} path The path of the property to get.
	     * @param {*} srcValue The value to match.
	     * @returns {Function} Returns the new spec function.
	     * @example
	     *
	     * var objects = [
	     *   { 'a': 1, 'b': 2, 'c': 3 },
	     *   { 'a': 4, 'b': 5, 'c': 6 }
	     * ];
	     *
	     * _.find(objects, _.matchesProperty('a', 4));
	     * // => { 'a': 4, 'b': 5, 'c': 6 }
	     */
	    function matchesProperty(path, srcValue) {
	      return baseMatchesProperty(path, baseClone(srcValue, CLONE_DEEP_FLAG));
	    }
	
	    /**
	     * Creates a function that invokes the method at `path` of a given object.
	     * Any additional arguments are provided to the invoked method.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.7.0
	     * @category Util
	     * @param {Array|string} path The path of the method to invoke.
	     * @param {...*} [args] The arguments to invoke the method with.
	     * @returns {Function} Returns the new invoker function.
	     * @example
	     *
	     * var objects = [
	     *   { 'a': { 'b': _.constant(2) } },
	     *   { 'a': { 'b': _.constant(1) } }
	     * ];
	     *
	     * _.map(objects, _.method('a.b'));
	     * // => [2, 1]
	     *
	     * _.map(objects, _.method(['a', 'b']));
	     * // => [2, 1]
	     */
	    var method = baseRest(function(path, args) {
	      return function(object) {
	        return baseInvoke(object, path, args);
	      };
	    });
	
	    /**
	     * The opposite of `_.method`; this method creates a function that invokes
	     * the method at a given path of `object`. Any additional arguments are
	     * provided to the invoked method.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.7.0
	     * @category Util
	     * @param {Object} object The object to query.
	     * @param {...*} [args] The arguments to invoke the method with.
	     * @returns {Function} Returns the new invoker function.
	     * @example
	     *
	     * var array = _.times(3, _.constant),
	     *     object = { 'a': array, 'b': array, 'c': array };
	     *
	     * _.map(['a[2]', 'c[0]'], _.methodOf(object));
	     * // => [2, 0]
	     *
	     * _.map([['a', '2'], ['c', '0']], _.methodOf(object));
	     * // => [2, 0]
	     */
	    var methodOf = baseRest(function(object, args) {
	      return function(path) {
	        return baseInvoke(object, path, args);
	      };
	    });
	
	    /**
	     * Adds all own enumerable string keyed function properties of a source
	     * object to the destination object. If `object` is a function, then methods
	     * are added to its prototype as well.
	     *
	     * **Note:** Use `_.runInContext` to create a pristine `lodash` function to
	     * avoid conflicts caused by modifying the original.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Util
	     * @param {Function|Object} [object=lodash] The destination object.
	     * @param {Object} source The object of functions to add.
	     * @param {Object} [options={}] The options object.
	     * @param {boolean} [options.chain=true] Specify whether mixins are chainable.
	     * @returns {Function|Object} Returns `object`.
	     * @example
	     *
	     * function vowels(string) {
	     *   return _.filter(string, function(v) {
	     *     return /[aeiou]/i.test(v);
	     *   });
	     * }
	     *
	     * _.mixin({ 'vowels': vowels });
	     * _.vowels('fred');
	     * // => ['e']
	     *
	     * _('fred').vowels().value();
	     * // => ['e']
	     *
	     * _.mixin({ 'vowels': vowels }, { 'chain': false });
	     * _('fred').vowels();
	     * // => ['e']
	     */
	    function mixin(object, source, options) {
	      var props = keys(source),
	          methodNames = baseFunctions(source, props);
	
	      if (options == null &&
	          !(isObject(source) && (methodNames.length || !props.length))) {
	        options = source;
	        source = object;
	        object = this;
	        methodNames = baseFunctions(source, keys(source));
	      }
	      var chain = !(isObject(options) && 'chain' in options) || !!options.chain,
	          isFunc = isFunction(object);
	
	      arrayEach(methodNames, function(methodName) {
	        var func = source[methodName];
	        object[methodName] = func;
	        if (isFunc) {
	          object.prototype[methodName] = function() {
	            var chainAll = this.__chain__;
	            if (chain || chainAll) {
	              var result = object(this.__wrapped__),
	                  actions = result.__actions__ = copyArray(this.__actions__);
	
	              actions.push({ 'func': func, 'args': arguments, 'thisArg': object });
	              result.__chain__ = chainAll;
	              return result;
	            }
	            return func.apply(object, arrayPush([this.value()], arguments));
	          };
	        }
	      });
	
	      return object;
	    }
	
	    /**
	     * Reverts the `_` variable to its previous value and returns a reference to
	     * the `lodash` function.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Util
	     * @returns {Function} Returns the `lodash` function.
	     * @example
	     *
	     * var lodash = _.noConflict();
	     */
	    function noConflict() {
	      if (root._ === this) {
	        root._ = oldDash;
	      }
	      return this;
	    }
	
	    /**
	     * This method returns `undefined`.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.3.0
	     * @category Util
	     * @example
	     *
	     * _.times(2, _.noop);
	     * // => [undefined, undefined]
	     */
	    function noop() {
	      // No operation performed.
	    }
	
	    /**
	     * Creates a function that gets the argument at index `n`. If `n` is negative,
	     * the nth argument from the end is returned.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {number} [n=0] The index of the argument to return.
	     * @returns {Function} Returns the new pass-thru function.
	     * @example
	     *
	     * var func = _.nthArg(1);
	     * func('a', 'b', 'c', 'd');
	     * // => 'b'
	     *
	     * var func = _.nthArg(-2);
	     * func('a', 'b', 'c', 'd');
	     * // => 'c'
	     */
	    function nthArg(n) {
	      n = toInteger(n);
	      return baseRest(function(args) {
	        return baseNth(args, n);
	      });
	    }
	
	    /**
	     * Creates a function that invokes `iteratees` with the arguments it receives
	     * and returns their results.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {...(Function|Function[])} [iteratees=[_.identity]]
	     *  The iteratees to invoke.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var func = _.over([Math.max, Math.min]);
	     *
	     * func(1, 2, 3, 4);
	     * // => [4, 1]
	     */
	    var over = createOver(arrayMap);
	
	    /**
	     * Creates a function that checks if **all** of the `predicates` return
	     * truthy when invoked with the arguments it receives.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {...(Function|Function[])} [predicates=[_.identity]]
	     *  The predicates to check.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var func = _.overEvery([Boolean, isFinite]);
	     *
	     * func('1');
	     * // => true
	     *
	     * func(null);
	     * // => false
	     *
	     * func(NaN);
	     * // => false
	     */
	    var overEvery = createOver(arrayEvery);
	
	    /**
	     * Creates a function that checks if **any** of the `predicates` return
	     * truthy when invoked with the arguments it receives.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {...(Function|Function[])} [predicates=[_.identity]]
	     *  The predicates to check.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var func = _.overSome([Boolean, isFinite]);
	     *
	     * func('1');
	     * // => true
	     *
	     * func(null);
	     * // => true
	     *
	     * func(NaN);
	     * // => false
	     */
	    var overSome = createOver(arraySome);
	
	    /**
	     * Creates a function that returns the value at `path` of a given object.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.4.0
	     * @category Util
	     * @param {Array|string} path The path of the property to get.
	     * @returns {Function} Returns the new accessor function.
	     * @example
	     *
	     * var objects = [
	     *   { 'a': { 'b': 2 } },
	     *   { 'a': { 'b': 1 } }
	     * ];
	     *
	     * _.map(objects, _.property('a.b'));
	     * // => [2, 1]
	     *
	     * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
	     * // => [1, 2]
	     */
	    function property(path) {
	      return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
	    }
	
	    /**
	     * The opposite of `_.property`; this method creates a function that returns
	     * the value at a given path of `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Util
	     * @param {Object} object The object to query.
	     * @returns {Function} Returns the new accessor function.
	     * @example
	     *
	     * var array = [0, 1, 2],
	     *     object = { 'a': array, 'b': array, 'c': array };
	     *
	     * _.map(['a[2]', 'c[0]'], _.propertyOf(object));
	     * // => [2, 0]
	     *
	     * _.map([['a', '2'], ['c', '0']], _.propertyOf(object));
	     * // => [2, 0]
	     */
	    function propertyOf(object) {
	      return function(path) {
	        return object == null ? undefined : baseGet(object, path);
	      };
	    }
	
	    /**
	     * Creates an array of numbers (positive and/or negative) progressing from
	     * `start` up to, but not including, `end`. A step of `-1` is used if a negative
	     * `start` is specified without an `end` or `step`. If `end` is not specified,
	     * it's set to `start` with `start` then set to `0`.
	     *
	     * **Note:** JavaScript follows the IEEE-754 standard for resolving
	     * floating-point values which can produce unexpected results.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Util
	     * @param {number} [start=0] The start of the range.
	     * @param {number} end The end of the range.
	     * @param {number} [step=1] The value to increment or decrement by.
	     * @returns {Array} Returns the range of numbers.
	     * @see _.inRange, _.rangeRight
	     * @example
	     *
	     * _.range(4);
	     * // => [0, 1, 2, 3]
	     *
	     * _.range(-4);
	     * // => [0, -1, -2, -3]
	     *
	     * _.range(1, 5);
	     * // => [1, 2, 3, 4]
	     *
	     * _.range(0, 20, 5);
	     * // => [0, 5, 10, 15]
	     *
	     * _.range(0, -4, -1);
	     * // => [0, -1, -2, -3]
	     *
	     * _.range(1, 4, 0);
	     * // => [1, 1, 1]
	     *
	     * _.range(0);
	     * // => []
	     */
	    var range = createRange();
	
	    /**
	     * This method is like `_.range` except that it populates values in
	     * descending order.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {number} [start=0] The start of the range.
	     * @param {number} end The end of the range.
	     * @param {number} [step=1] The value to increment or decrement by.
	     * @returns {Array} Returns the range of numbers.
	     * @see _.inRange, _.range
	     * @example
	     *
	     * _.rangeRight(4);
	     * // => [3, 2, 1, 0]
	     *
	     * _.rangeRight(-4);
	     * // => [-3, -2, -1, 0]
	     *
	     * _.rangeRight(1, 5);
	     * // => [4, 3, 2, 1]
	     *
	     * _.rangeRight(0, 20, 5);
	     * // => [15, 10, 5, 0]
	     *
	     * _.rangeRight(0, -4, -1);
	     * // => [-3, -2, -1, 0]
	     *
	     * _.rangeRight(1, 4, 0);
	     * // => [1, 1, 1]
	     *
	     * _.rangeRight(0);
	     * // => []
	     */
	    var rangeRight = createRange(true);
	
	    /**
	     * This method returns a new empty array.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.13.0
	     * @category Util
	     * @returns {Array} Returns the new empty array.
	     * @example
	     *
	     * var arrays = _.times(2, _.stubArray);
	     *
	     * console.log(arrays);
	     * // => [[], []]
	     *
	     * console.log(arrays[0] === arrays[1]);
	     * // => false
	     */
	    function stubArray() {
	      return [];
	    }
	
	    /**
	     * This method returns `false`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.13.0
	     * @category Util
	     * @returns {boolean} Returns `false`.
	     * @example
	     *
	     * _.times(2, _.stubFalse);
	     * // => [false, false]
	     */
	    function stubFalse() {
	      return false;
	    }
	
	    /**
	     * This method returns a new empty object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.13.0
	     * @category Util
	     * @returns {Object} Returns the new empty object.
	     * @example
	     *
	     * var objects = _.times(2, _.stubObject);
	     *
	     * console.log(objects);
	     * // => [{}, {}]
	     *
	     * console.log(objects[0] === objects[1]);
	     * // => false
	     */
	    function stubObject() {
	      return {};
	    }
	
	    /**
	     * This method returns an empty string.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.13.0
	     * @category Util
	     * @returns {string} Returns the empty string.
	     * @example
	     *
	     * _.times(2, _.stubString);
	     * // => ['', '']
	     */
	    function stubString() {
	      return '';
	    }
	
	    /**
	     * This method returns `true`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.13.0
	     * @category Util
	     * @returns {boolean} Returns `true`.
	     * @example
	     *
	     * _.times(2, _.stubTrue);
	     * // => [true, true]
	     */
	    function stubTrue() {
	      return true;
	    }
	
	    /**
	     * Invokes the iteratee `n` times, returning an array of the results of
	     * each invocation. The iteratee is invoked with one argument; (index).
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Util
	     * @param {number} n The number of times to invoke `iteratee`.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the array of results.
	     * @example
	     *
	     * _.times(3, String);
	     * // => ['0', '1', '2']
	     *
	     *  _.times(4, _.constant(0));
	     * // => [0, 0, 0, 0]
	     */
	    function times(n, iteratee) {
	      n = toInteger(n);
	      if (n < 1 || n > MAX_SAFE_INTEGER) {
	        return [];
	      }
	      var index = MAX_ARRAY_LENGTH,
	          length = nativeMin(n, MAX_ARRAY_LENGTH);
	
	      iteratee = getIteratee(iteratee);
	      n -= MAX_ARRAY_LENGTH;
	
	      var result = baseTimes(length, iteratee);
	      while (++index < n) {
	        iteratee(index);
	      }
	      return result;
	    }
	
	    /**
	     * Converts `value` to a property path array.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {*} value The value to convert.
	     * @returns {Array} Returns the new property path array.
	     * @example
	     *
	     * _.toPath('a.b.c');
	     * // => ['a', 'b', 'c']
	     *
	     * _.toPath('a[0].b.c');
	     * // => ['a', '0', 'b', 'c']
	     */
	    function toPath(value) {
	      if (isArray(value)) {
	        return arrayMap(value, toKey);
	      }
	      return isSymbol(value) ? [value] : copyArray(stringToPath(toString(value)));
	    }
	
	    /**
	     * Generates a unique ID. If `prefix` is given, the ID is appended to it.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Util
	     * @param {string} [prefix=''] The value to prefix the ID with.
	     * @returns {string} Returns the unique ID.
	     * @example
	     *
	     * _.uniqueId('contact_');
	     * // => 'contact_104'
	     *
	     * _.uniqueId();
	     * // => '105'
	     */
	    function uniqueId(prefix) {
	      var id = ++idCounter;
	      return toString(prefix) + id;
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Adds two numbers.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.4.0
	     * @category Math
	     * @param {number} augend The first number in an addition.
	     * @param {number} addend The second number in an addition.
	     * @returns {number} Returns the total.
	     * @example
	     *
	     * _.add(6, 4);
	     * // => 10
	     */
	    var add = createMathOperation(function(augend, addend) {
	      return augend + addend;
	    }, 0);
	
	    /**
	     * Computes `number` rounded up to `precision`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.10.0
	     * @category Math
	     * @param {number} number The number to round up.
	     * @param {number} [precision=0] The precision to round up to.
	     * @returns {number} Returns the rounded up number.
	     * @example
	     *
	     * _.ceil(4.006);
	     * // => 5
	     *
	     * _.ceil(6.004, 2);
	     * // => 6.01
	     *
	     * _.ceil(6040, -2);
	     * // => 6100
	     */
	    var ceil = createRound('ceil');
	
	    /**
	     * Divide two numbers.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.7.0
	     * @category Math
	     * @param {number} dividend The first number in a division.
	     * @param {number} divisor The second number in a division.
	     * @returns {number} Returns the quotient.
	     * @example
	     *
	     * _.divide(6, 4);
	     * // => 1.5
	     */
	    var divide = createMathOperation(function(dividend, divisor) {
	      return dividend / divisor;
	    }, 1);
	
	    /**
	     * Computes `number` rounded down to `precision`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.10.0
	     * @category Math
	     * @param {number} number The number to round down.
	     * @param {number} [precision=0] The precision to round down to.
	     * @returns {number} Returns the rounded down number.
	     * @example
	     *
	     * _.floor(4.006);
	     * // => 4
	     *
	     * _.floor(0.046, 2);
	     * // => 0.04
	     *
	     * _.floor(4060, -2);
	     * // => 4000
	     */
	    var floor = createRound('floor');
	
	    /**
	     * Computes the maximum value of `array`. If `array` is empty or falsey,
	     * `undefined` is returned.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @returns {*} Returns the maximum value.
	     * @example
	     *
	     * _.max([4, 2, 8, 6]);
	     * // => 8
	     *
	     * _.max([]);
	     * // => undefined
	     */
	    function max(array) {
	      return (array && array.length)
	        ? baseExtremum(array, identity, baseGt)
	        : undefined;
	    }
	
	    /**
	     * This method is like `_.max` except that it accepts `iteratee` which is
	     * invoked for each element in `array` to generate the criterion by which
	     * the value is ranked. The iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {*} Returns the maximum value.
	     * @example
	     *
	     * var objects = [{ 'n': 1 }, { 'n': 2 }];
	     *
	     * _.maxBy(objects, function(o) { return o.n; });
	     * // => { 'n': 2 }
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.maxBy(objects, 'n');
	     * // => { 'n': 2 }
	     */
	    function maxBy(array, iteratee) {
	      return (array && array.length)
	        ? baseExtremum(array, getIteratee(iteratee, 2), baseGt)
	        : undefined;
	    }
	
	    /**
	     * Computes the mean of the values in `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @returns {number} Returns the mean.
	     * @example
	     *
	     * _.mean([4, 2, 8, 6]);
	     * // => 5
	     */
	    function mean(array) {
	      return baseMean(array, identity);
	    }
	
	    /**
	     * This method is like `_.mean` except that it accepts `iteratee` which is
	     * invoked for each element in `array` to generate the value to be averaged.
	     * The iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.7.0
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {number} Returns the mean.
	     * @example
	     *
	     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
	     *
	     * _.meanBy(objects, function(o) { return o.n; });
	     * // => 5
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.meanBy(objects, 'n');
	     * // => 5
	     */
	    function meanBy(array, iteratee) {
	      return baseMean(array, getIteratee(iteratee, 2));
	    }
	
	    /**
	     * Computes the minimum value of `array`. If `array` is empty or falsey,
	     * `undefined` is returned.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @returns {*} Returns the minimum value.
	     * @example
	     *
	     * _.min([4, 2, 8, 6]);
	     * // => 2
	     *
	     * _.min([]);
	     * // => undefined
	     */
	    function min(array) {
	      return (array && array.length)
	        ? baseExtremum(array, identity, baseLt)
	        : undefined;
	    }
	
	    /**
	     * This method is like `_.min` except that it accepts `iteratee` which is
	     * invoked for each element in `array` to generate the criterion by which
	     * the value is ranked. The iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {*} Returns the minimum value.
	     * @example
	     *
	     * var objects = [{ 'n': 1 }, { 'n': 2 }];
	     *
	     * _.minBy(objects, function(o) { return o.n; });
	     * // => { 'n': 1 }
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.minBy(objects, 'n');
	     * // => { 'n': 1 }
	     */
	    function minBy(array, iteratee) {
	      return (array && array.length)
	        ? baseExtremum(array, getIteratee(iteratee, 2), baseLt)
	        : undefined;
	    }
	
	    /**
	     * Multiply two numbers.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.7.0
	     * @category Math
	     * @param {number} multiplier The first number in a multiplication.
	     * @param {number} multiplicand The second number in a multiplication.
	     * @returns {number} Returns the product.
	     * @example
	     *
	     * _.multiply(6, 4);
	     * // => 24
	     */
	    var multiply = createMathOperation(function(multiplier, multiplicand) {
	      return multiplier * multiplicand;
	    }, 1);
	
	    /**
	     * Computes `number` rounded to `precision`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.10.0
	     * @category Math
	     * @param {number} number The number to round.
	     * @param {number} [precision=0] The precision to round to.
	     * @returns {number} Returns the rounded number.
	     * @example
	     *
	     * _.round(4.006);
	     * // => 4
	     *
	     * _.round(4.006, 2);
	     * // => 4.01
	     *
	     * _.round(4060, -2);
	     * // => 4100
	     */
	    var round = createRound('round');
	
	    /**
	     * Subtract two numbers.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Math
	     * @param {number} minuend The first number in a subtraction.
	     * @param {number} subtrahend The second number in a subtraction.
	     * @returns {number} Returns the difference.
	     * @example
	     *
	     * _.subtract(6, 4);
	     * // => 2
	     */
	    var subtract = createMathOperation(function(minuend, subtrahend) {
	      return minuend - subtrahend;
	    }, 0);
	
	    /**
	     * Computes the sum of the values in `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.4.0
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @returns {number} Returns the sum.
	     * @example
	     *
	     * _.sum([4, 2, 8, 6]);
	     * // => 20
	     */
	    function sum(array) {
	      return (array && array.length)
	        ? baseSum(array, identity)
	        : 0;
	    }
	
	    /**
	     * This method is like `_.sum` except that it accepts `iteratee` which is
	     * invoked for each element in `array` to generate the value to be summed.
	     * The iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {number} Returns the sum.
	     * @example
	     *
	     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
	     *
	     * _.sumBy(objects, function(o) { return o.n; });
	     * // => 20
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.sumBy(objects, 'n');
	     * // => 20
	     */
	    function sumBy(array, iteratee) {
	      return (array && array.length)
	        ? baseSum(array, getIteratee(iteratee, 2))
	        : 0;
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    // Add methods that return wrapped values in chain sequences.
	    lodash.after = after;
	    lodash.ary = ary;
	    lodash.assign = assign;
	    lodash.assignIn = assignIn;
	    lodash.assignInWith = assignInWith;
	    lodash.assignWith = assignWith;
	    lodash.at = at;
	    lodash.before = before;
	    lodash.bind = bind;
	    lodash.bindAll = bindAll;
	    lodash.bindKey = bindKey;
	    lodash.castArray = castArray;
	    lodash.chain = chain;
	    lodash.chunk = chunk;
	    lodash.compact = compact;
	    lodash.concat = concat;
	    lodash.cond = cond;
	    lodash.conforms = conforms;
	    lodash.constant = constant;
	    lodash.countBy = countBy;
	    lodash.create = create;
	    lodash.curry = curry;
	    lodash.curryRight = curryRight;
	    lodash.debounce = debounce;
	    lodash.defaults = defaults;
	    lodash.defaultsDeep = defaultsDeep;
	    lodash.defer = defer;
	    lodash.delay = delay;
	    lodash.difference = difference;
	    lodash.differenceBy = differenceBy;
	    lodash.differenceWith = differenceWith;
	    lodash.drop = drop;
	    lodash.dropRight = dropRight;
	    lodash.dropRightWhile = dropRightWhile;
	    lodash.dropWhile = dropWhile;
	    lodash.fill = fill;
	    lodash.filter = filter;
	    lodash.flatMap = flatMap;
	    lodash.flatMapDeep = flatMapDeep;
	    lodash.flatMapDepth = flatMapDepth;
	    lodash.flatten = flatten;
	    lodash.flattenDeep = flattenDeep;
	    lodash.flattenDepth = flattenDepth;
	    lodash.flip = flip;
	    lodash.flow = flow;
	    lodash.flowRight = flowRight;
	    lodash.fromPairs = fromPairs;
	    lodash.functions = functions;
	    lodash.functionsIn = functionsIn;
	    lodash.groupBy = groupBy;
	    lodash.initial = initial;
	    lodash.intersection = intersection;
	    lodash.intersectionBy = intersectionBy;
	    lodash.intersectionWith = intersectionWith;
	    lodash.invert = invert;
	    lodash.invertBy = invertBy;
	    lodash.invokeMap = invokeMap;
	    lodash.iteratee = iteratee;
	    lodash.keyBy = keyBy;
	    lodash.keys = keys;
	    lodash.keysIn = keysIn;
	    lodash.map = map;
	    lodash.mapKeys = mapKeys;
	    lodash.mapValues = mapValues;
	    lodash.matches = matches;
	    lodash.matchesProperty = matchesProperty;
	    lodash.memoize = memoize;
	    lodash.merge = merge;
	    lodash.mergeWith = mergeWith;
	    lodash.method = method;
	    lodash.methodOf = methodOf;
	    lodash.mixin = mixin;
	    lodash.negate = negate;
	    lodash.nthArg = nthArg;
	    lodash.omit = omit;
	    lodash.omitBy = omitBy;
	    lodash.once = once;
	    lodash.orderBy = orderBy;
	    lodash.over = over;
	    lodash.overArgs = overArgs;
	    lodash.overEvery = overEvery;
	    lodash.overSome = overSome;
	    lodash.partial = partial;
	    lodash.partialRight = partialRight;
	    lodash.partition = partition;
	    lodash.pick = pick;
	    lodash.pickBy = pickBy;
	    lodash.property = property;
	    lodash.propertyOf = propertyOf;
	    lodash.pull = pull;
	    lodash.pullAll = pullAll;
	    lodash.pullAllBy = pullAllBy;
	    lodash.pullAllWith = pullAllWith;
	    lodash.pullAt = pullAt;
	    lodash.range = range;
	    lodash.rangeRight = rangeRight;
	    lodash.rearg = rearg;
	    lodash.reject = reject;
	    lodash.remove = remove;
	    lodash.rest = rest;
	    lodash.reverse = reverse;
	    lodash.sampleSize = sampleSize;
	    lodash.set = set;
	    lodash.setWith = setWith;
	    lodash.shuffle = shuffle;
	    lodash.slice = slice;
	    lodash.sortBy = sortBy;
	    lodash.sortedUniq = sortedUniq;
	    lodash.sortedUniqBy = sortedUniqBy;
	    lodash.split = split;
	    lodash.spread = spread;
	    lodash.tail = tail;
	    lodash.take = take;
	    lodash.takeRight = takeRight;
	    lodash.takeRightWhile = takeRightWhile;
	    lodash.takeWhile = takeWhile;
	    lodash.tap = tap;
	    lodash.throttle = throttle;
	    lodash.thru = thru;
	    lodash.toArray = toArray;
	    lodash.toPairs = toPairs;
	    lodash.toPairsIn = toPairsIn;
	    lodash.toPath = toPath;
	    lodash.toPlainObject = toPlainObject;
	    lodash.transform = transform;
	    lodash.unary = unary;
	    lodash.union = union;
	    lodash.unionBy = unionBy;
	    lodash.unionWith = unionWith;
	    lodash.uniq = uniq;
	    lodash.uniqBy = uniqBy;
	    lodash.uniqWith = uniqWith;
	    lodash.unset = unset;
	    lodash.unzip = unzip;
	    lodash.unzipWith = unzipWith;
	    lodash.update = update;
	    lodash.updateWith = updateWith;
	    lodash.values = values;
	    lodash.valuesIn = valuesIn;
	    lodash.without = without;
	    lodash.words = words;
	    lodash.wrap = wrap;
	    lodash.xor = xor;
	    lodash.xorBy = xorBy;
	    lodash.xorWith = xorWith;
	    lodash.zip = zip;
	    lodash.zipObject = zipObject;
	    lodash.zipObjectDeep = zipObjectDeep;
	    lodash.zipWith = zipWith;
	
	    // Add aliases.
	    lodash.entries = toPairs;
	    lodash.entriesIn = toPairsIn;
	    lodash.extend = assignIn;
	    lodash.extendWith = assignInWith;
	
	    // Add methods to `lodash.prototype`.
	    mixin(lodash, lodash);
	
	    /*------------------------------------------------------------------------*/
	
	    // Add methods that return unwrapped values in chain sequences.
	    lodash.add = add;
	    lodash.attempt = attempt;
	    lodash.camelCase = camelCase;
	    lodash.capitalize = capitalize;
	    lodash.ceil = ceil;
	    lodash.clamp = clamp;
	    lodash.clone = clone;
	    lodash.cloneDeep = cloneDeep;
	    lodash.cloneDeepWith = cloneDeepWith;
	    lodash.cloneWith = cloneWith;
	    lodash.conformsTo = conformsTo;
	    lodash.deburr = deburr;
	    lodash.defaultTo = defaultTo;
	    lodash.divide = divide;
	    lodash.endsWith = endsWith;
	    lodash.eq = eq;
	    lodash.escape = escape;
	    lodash.escapeRegExp = escapeRegExp;
	    lodash.every = every;
	    lodash.find = find;
	    lodash.findIndex = findIndex;
	    lodash.findKey = findKey;
	    lodash.findLast = findLast;
	    lodash.findLastIndex = findLastIndex;
	    lodash.findLastKey = findLastKey;
	    lodash.floor = floor;
	    lodash.forEach = forEach;
	    lodash.forEachRight = forEachRight;
	    lodash.forIn = forIn;
	    lodash.forInRight = forInRight;
	    lodash.forOwn = forOwn;
	    lodash.forOwnRight = forOwnRight;
	    lodash.get = get;
	    lodash.gt = gt;
	    lodash.gte = gte;
	    lodash.has = has;
	    lodash.hasIn = hasIn;
	    lodash.head = head;
	    lodash.identity = identity;
	    lodash.includes = includes;
	    lodash.indexOf = indexOf;
	    lodash.inRange = inRange;
	    lodash.invoke = invoke;
	    lodash.isArguments = isArguments;
	    lodash.isArray = isArray;
	    lodash.isArrayBuffer = isArrayBuffer;
	    lodash.isArrayLike = isArrayLike;
	    lodash.isArrayLikeObject = isArrayLikeObject;
	    lodash.isBoolean = isBoolean;
	    lodash.isBuffer = isBuffer;
	    lodash.isDate = isDate;
	    lodash.isElement = isElement;
	    lodash.isEmpty = isEmpty;
	    lodash.isEqual = isEqual;
	    lodash.isEqualWith = isEqualWith;
	    lodash.isError = isError;
	    lodash.isFinite = isFinite;
	    lodash.isFunction = isFunction;
	    lodash.isInteger = isInteger;
	    lodash.isLength = isLength;
	    lodash.isMap = isMap;
	    lodash.isMatch = isMatch;
	    lodash.isMatchWith = isMatchWith;
	    lodash.isNaN = isNaN;
	    lodash.isNative = isNative;
	    lodash.isNil = isNil;
	    lodash.isNull = isNull;
	    lodash.isNumber = isNumber;
	    lodash.isObject = isObject;
	    lodash.isObjectLike = isObjectLike;
	    lodash.isPlainObject = isPlainObject;
	    lodash.isRegExp = isRegExp;
	    lodash.isSafeInteger = isSafeInteger;
	    lodash.isSet = isSet;
	    lodash.isString = isString;
	    lodash.isSymbol = isSymbol;
	    lodash.isTypedArray = isTypedArray;
	    lodash.isUndefined = isUndefined;
	    lodash.isWeakMap = isWeakMap;
	    lodash.isWeakSet = isWeakSet;
	    lodash.join = join;
	    lodash.kebabCase = kebabCase;
	    lodash.last = last;
	    lodash.lastIndexOf = lastIndexOf;
	    lodash.lowerCase = lowerCase;
	    lodash.lowerFirst = lowerFirst;
	    lodash.lt = lt;
	    lodash.lte = lte;
	    lodash.max = max;
	    lodash.maxBy = maxBy;
	    lodash.mean = mean;
	    lodash.meanBy = meanBy;
	    lodash.min = min;
	    lodash.minBy = minBy;
	    lodash.stubArray = stubArray;
	    lodash.stubFalse = stubFalse;
	    lodash.stubObject = stubObject;
	    lodash.stubString = stubString;
	    lodash.stubTrue = stubTrue;
	    lodash.multiply = multiply;
	    lodash.nth = nth;
	    lodash.noConflict = noConflict;
	    lodash.noop = noop;
	    lodash.now = now;
	    lodash.pad = pad;
	    lodash.padEnd = padEnd;
	    lodash.padStart = padStart;
	    lodash.parseInt = parseInt;
	    lodash.random = random;
	    lodash.reduce = reduce;
	    lodash.reduceRight = reduceRight;
	    lodash.repeat = repeat;
	    lodash.replace = replace;
	    lodash.result = result;
	    lodash.round = round;
	    lodash.runInContext = runInContext;
	    lodash.sample = sample;
	    lodash.size = size;
	    lodash.snakeCase = snakeCase;
	    lodash.some = some;
	    lodash.sortedIndex = sortedIndex;
	    lodash.sortedIndexBy = sortedIndexBy;
	    lodash.sortedIndexOf = sortedIndexOf;
	    lodash.sortedLastIndex = sortedLastIndex;
	    lodash.sortedLastIndexBy = sortedLastIndexBy;
	    lodash.sortedLastIndexOf = sortedLastIndexOf;
	    lodash.startCase = startCase;
	    lodash.startsWith = startsWith;
	    lodash.subtract = subtract;
	    lodash.sum = sum;
	    lodash.sumBy = sumBy;
	    lodash.template = template;
	    lodash.times = times;
	    lodash.toFinite = toFinite;
	    lodash.toInteger = toInteger;
	    lodash.toLength = toLength;
	    lodash.toLower = toLower;
	    lodash.toNumber = toNumber;
	    lodash.toSafeInteger = toSafeInteger;
	    lodash.toString = toString;
	    lodash.toUpper = toUpper;
	    lodash.trim = trim;
	    lodash.trimEnd = trimEnd;
	    lodash.trimStart = trimStart;
	    lodash.truncate = truncate;
	    lodash.unescape = unescape;
	    lodash.uniqueId = uniqueId;
	    lodash.upperCase = upperCase;
	    lodash.upperFirst = upperFirst;
	
	    // Add aliases.
	    lodash.each = forEach;
	    lodash.eachRight = forEachRight;
	    lodash.first = head;
	
	    mixin(lodash, (function() {
	      var source = {};
	      baseForOwn(lodash, function(func, methodName) {
	        if (!hasOwnProperty.call(lodash.prototype, methodName)) {
	          source[methodName] = func;
	        }
	      });
	      return source;
	    }()), { 'chain': false });
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * The semantic version number.
	     *
	     * @static
	     * @memberOf _
	     * @type {string}
	     */
	    lodash.VERSION = VERSION;
	
	    // Assign default placeholders.
	    arrayEach(['bind', 'bindKey', 'curry', 'curryRight', 'partial', 'partialRight'], function(methodName) {
	      lodash[methodName].placeholder = lodash;
	    });
	
	    // Add `LazyWrapper` methods for `_.drop` and `_.take` variants.
	    arrayEach(['drop', 'take'], function(methodName, index) {
	      LazyWrapper.prototype[methodName] = function(n) {
	        n = n === undefined ? 1 : nativeMax(toInteger(n), 0);
	
	        var result = (this.__filtered__ && !index)
	          ? new LazyWrapper(this)
	          : this.clone();
	
	        if (result.__filtered__) {
	          result.__takeCount__ = nativeMin(n, result.__takeCount__);
	        } else {
	          result.__views__.push({
	            'size': nativeMin(n, MAX_ARRAY_LENGTH),
	            'type': methodName + (result.__dir__ < 0 ? 'Right' : '')
	          });
	        }
	        return result;
	      };
	
	      LazyWrapper.prototype[methodName + 'Right'] = function(n) {
	        return this.reverse()[methodName](n).reverse();
	      };
	    });
	
	    // Add `LazyWrapper` methods that accept an `iteratee` value.
	    arrayEach(['filter', 'map', 'takeWhile'], function(methodName, index) {
	      var type = index + 1,
	          isFilter = type == LAZY_FILTER_FLAG || type == LAZY_WHILE_FLAG;
	
	      LazyWrapper.prototype[methodName] = function(iteratee) {
	        var result = this.clone();
	        result.__iteratees__.push({
	          'iteratee': getIteratee(iteratee, 3),
	          'type': type
	        });
	        result.__filtered__ = result.__filtered__ || isFilter;
	        return result;
	      };
	    });
	
	    // Add `LazyWrapper` methods for `_.head` and `_.last`.
	    arrayEach(['head', 'last'], function(methodName, index) {
	      var takeName = 'take' + (index ? 'Right' : '');
	
	      LazyWrapper.prototype[methodName] = function() {
	        return this[takeName](1).value()[0];
	      };
	    });
	
	    // Add `LazyWrapper` methods for `_.initial` and `_.tail`.
	    arrayEach(['initial', 'tail'], function(methodName, index) {
	      var dropName = 'drop' + (index ? '' : 'Right');
	
	      LazyWrapper.prototype[methodName] = function() {
	        return this.__filtered__ ? new LazyWrapper(this) : this[dropName](1);
	      };
	    });
	
	    LazyWrapper.prototype.compact = function() {
	      return this.filter(identity);
	    };
	
	    LazyWrapper.prototype.find = function(predicate) {
	      return this.filter(predicate).head();
	    };
	
	    LazyWrapper.prototype.findLast = function(predicate) {
	      return this.reverse().find(predicate);
	    };
	
	    LazyWrapper.prototype.invokeMap = baseRest(function(path, args) {
	      if (typeof path == 'function') {
	        return new LazyWrapper(this);
	      }
	      return this.map(function(value) {
	        return baseInvoke(value, path, args);
	      });
	    });
	
	    LazyWrapper.prototype.reject = function(predicate) {
	      return this.filter(negate(getIteratee(predicate)));
	    };
	
	    LazyWrapper.prototype.slice = function(start, end) {
	      start = toInteger(start);
	
	      var result = this;
	      if (result.__filtered__ && (start > 0 || end < 0)) {
	        return new LazyWrapper(result);
	      }
	      if (start < 0) {
	        result = result.takeRight(-start);
	      } else if (start) {
	        result = result.drop(start);
	      }
	      if (end !== undefined) {
	        end = toInteger(end);
	        result = end < 0 ? result.dropRight(-end) : result.take(end - start);
	      }
	      return result;
	    };
	
	    LazyWrapper.prototype.takeRightWhile = function(predicate) {
	      return this.reverse().takeWhile(predicate).reverse();
	    };
	
	    LazyWrapper.prototype.toArray = function() {
	      return this.take(MAX_ARRAY_LENGTH);
	    };
	
	    // Add `LazyWrapper` methods to `lodash.prototype`.
	    baseForOwn(LazyWrapper.prototype, function(func, methodName) {
	      var checkIteratee = /^(?:filter|find|map|reject)|While$/.test(methodName),
	          isTaker = /^(?:head|last)$/.test(methodName),
	          lodashFunc = lodash[isTaker ? ('take' + (methodName == 'last' ? 'Right' : '')) : methodName],
	          retUnwrapped = isTaker || /^find/.test(methodName);
	
	      if (!lodashFunc) {
	        return;
	      }
	      lodash.prototype[methodName] = function() {
	        var value = this.__wrapped__,
	            args = isTaker ? [1] : arguments,
	            isLazy = value instanceof LazyWrapper,
	            iteratee = args[0],
	            useLazy = isLazy || isArray(value);
	
	        var interceptor = function(value) {
	          var result = lodashFunc.apply(lodash, arrayPush([value], args));
	          return (isTaker && chainAll) ? result[0] : result;
	        };
	
	        if (useLazy && checkIteratee && typeof iteratee == 'function' && iteratee.length != 1) {
	          // Avoid lazy use if the iteratee has a "length" value other than `1`.
	          isLazy = useLazy = false;
	        }
	        var chainAll = this.__chain__,
	            isHybrid = !!this.__actions__.length,
	            isUnwrapped = retUnwrapped && !chainAll,
	            onlyLazy = isLazy && !isHybrid;
	
	        if (!retUnwrapped && useLazy) {
	          value = onlyLazy ? value : new LazyWrapper(this);
	          var result = func.apply(value, args);
	          result.__actions__.push({ 'func': thru, 'args': [interceptor], 'thisArg': undefined });
	          return new LodashWrapper(result, chainAll);
	        }
	        if (isUnwrapped && onlyLazy) {
	          return func.apply(this, args);
	        }
	        result = this.thru(interceptor);
	        return isUnwrapped ? (isTaker ? result.value()[0] : result.value()) : result;
	      };
	    });
	
	    // Add `Array` methods to `lodash.prototype`.
	    arrayEach(['pop', 'push', 'shift', 'sort', 'splice', 'unshift'], function(methodName) {
	      var func = arrayProto[methodName],
	          chainName = /^(?:push|sort|unshift)$/.test(methodName) ? 'tap' : 'thru',
	          retUnwrapped = /^(?:pop|shift)$/.test(methodName);
	
	      lodash.prototype[methodName] = function() {
	        var args = arguments;
	        if (retUnwrapped && !this.__chain__) {
	          var value = this.value();
	          return func.apply(isArray(value) ? value : [], args);
	        }
	        return this[chainName](function(value) {
	          return func.apply(isArray(value) ? value : [], args);
	        });
	      };
	    });
	
	    // Map minified method names to their real names.
	    baseForOwn(LazyWrapper.prototype, function(func, methodName) {
	      var lodashFunc = lodash[methodName];
	      if (lodashFunc) {
	        var key = (lodashFunc.name + ''),
	            names = realNames[key] || (realNames[key] = []);
	
	        names.push({ 'name': methodName, 'func': lodashFunc });
	      }
	    });
	
	    realNames[createHybrid(undefined, WRAP_BIND_KEY_FLAG).name] = [{
	      'name': 'wrapper',
	      'func': undefined
	    }];
	
	    // Add methods to `LazyWrapper`.
	    LazyWrapper.prototype.clone = lazyClone;
	    LazyWrapper.prototype.reverse = lazyReverse;
	    LazyWrapper.prototype.value = lazyValue;
	
	    // Add chain sequence methods to the `lodash` wrapper.
	    lodash.prototype.at = wrapperAt;
	    lodash.prototype.chain = wrapperChain;
	    lodash.prototype.commit = wrapperCommit;
	    lodash.prototype.next = wrapperNext;
	    lodash.prototype.plant = wrapperPlant;
	    lodash.prototype.reverse = wrapperReverse;
	    lodash.prototype.toJSON = lodash.prototype.valueOf = lodash.prototype.value = wrapperValue;
	
	    // Add lazy aliases.
	    lodash.prototype.first = lodash.prototype.head;
	
	    if (symIterator) {
	      lodash.prototype[symIterator] = wrapperToIterator;
	    }
	    return lodash;
	  });
	
	  /*--------------------------------------------------------------------------*/
	
	  // Export lodash.
	  var _ = runInContext();
	
	  // Some AMD build optimizers, like r.js, check for condition patterns like:
	  if (true) {
	    // Expose Lodash on the global object to prevent errors when Lodash is
	    // loaded by a script tag in the presence of an AMD loader.
	    // See http://requirejs.org/docs/errors.html#mismatch for more details.
	    // Use `_.noConflict` to remove Lodash from the global object.
	    root._ = _;
	
	    // Define as an anonymous module so, through path mapping, it can be
	    // referenced as the "underscore" module.
	    !(__WEBPACK_AMD_DEFINE_RESULT__ = function() {
	      return _;
	    }.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  }
	  // Check for `exports` after `define` in case a build optimizer adds it.
	  else if (freeModule) {
	    // Export for Node.js.
	    (freeModule.exports = _)._ = _;
	    // Export for CommonJS support.
	    freeExports._ = _;
	  }
	  else {
	    // Export to the global object.
	    root._ = _;
	  }
	}.call(this));
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }()), __webpack_require__(192)(module)))

/***/ },
/* 29 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	'use strict';
	
	/**
	 * WARNING: DO NOT manually require this module.
	 * This is a replacement for `invariant(...)` used by the error code system
	 * and will _only_ be required by the corresponding babel pass.
	 * It always throws.
	 */
	
	function reactProdInvariant(code) {
	  var argCount = arguments.length - 1;
	
	  var message = 'Minified React error #' + code + '; visit ' + 'http://facebook.github.io/react/docs/error-decoder.html?invariant=' + code;
	
	  for (var argIdx = 0; argIdx < argCount; argIdx++) {
	    message += '&args[]=' + encodeURIComponent(arguments[argIdx + 1]);
	  }
	
	  message += ' for the full message or use the non-minified dev environment' + ' for full errors and additional helpful warnings.';
	
	  var error = new Error(message);
	  error.name = 'Invariant Violation';
	  error.framesToPop = 1; // we don't care about reactProdInvariant's own frame
	
	  throw error;
	}
	
	module.exports = reactProdInvariant;

/***/ },
/* 30 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2014-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var emptyFunction = __webpack_require__(80);
	
	/**
	 * Similar to invariant but only logs a warning if the condition is not met.
	 * This can be used to log issues in development environments in critical
	 * paths. Removing the logging code for production environments will keep the
	 * same logic and follow the same code paths.
	 */
	
	var warning = emptyFunction;
	
	if (false) {
	  var printWarning = function printWarning(format) {
	    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	      args[_key - 1] = arguments[_key];
	    }
	
	    var argIndex = 0;
	    var message = 'Warning: ' + format.replace(/%s/g, function () {
	      return args[argIndex++];
	    });
	    if (typeof console !== 'undefined') {
	      console.error(message);
	    }
	    try {
	      // --- Welcome to debugging React ---
	      // This error was thrown as a convenience so that you can use this stack
	      // to find the callsite that caused this warning to fire.
	      throw new Error(message);
	    } catch (x) {}
	  };
	
	  warning = function warning(condition, format) {
	    if (format === undefined) {
	      throw new Error('`warning(condition, format, ...args)` requires a warning ' + 'message argument');
	    }
	
	    if (format.indexOf('Failed Composite propType: ') === 0) {
	      return; // Ignore CompositeComponent proptype check.
	    }
	
	    if (!condition) {
	      for (var _len2 = arguments.length, args = Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
	        args[_key2 - 2] = arguments[_key2];
	      }
	
	      printWarning.apply(undefined, [format].concat(args));
	    }
	  };
	}
	
	module.exports = warning;

/***/ },
/* 31 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.getMenuComponentByType = getMenuComponentByType;
	exports.getBiteComponentByType = getBiteComponentByType;
	exports.getScreenComponentByType = getScreenComponentByType;
	exports.getSubTitleScreenComponentByType = getSubTitleScreenComponentByType;
	exports.getDefaultSubTitleScreenComponent = getDefaultSubTitleScreenComponent;
	exports.getAssetComponentByType = getAssetComponentByType;
	exports.getChildObjectComponentByType = getChildObjectComponentByType;
	exports.getResourceLinkComponentByType = getResourceLinkComponentByType;
	
	var _componentModels = __webpack_require__(204);
	
	var componentModels = _interopRequireWildcard(_componentModels);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function getMenuComponentByType(menu_type) {
	    var menu = componentModels.MENU_TYPES.filter(function (menu) {
	        return menu.constant == menu_type;
	    });
	    if (menu) return menu[0]; //since filter returns an array, have to grab the first.
	    return null;
	}
	
	function getBiteComponentByType(bite_type) {
	    var bite = componentModels.BITE_TYPES.filter(function (bite) {
	        return bite.constant == bite_type;
	    });
	    if (bite) return bite[0]; //since filter returns an array, have to grab the first.
	    return null;
	}
	
	function getScreenComponentByType(screen_type) {
	    var screen = componentModels.SCREEN_TYPES.filter(function (screen) {
	        return screen.constant == screen_type;
	    });
	    if (screen) return screen[0]; //since filter returns an array, have to grab the first.
	    return null;
	}
	
	function getSubTitleScreenComponentByType(screen_type) {
	    var sub_screen = componentModels.TITLE_SCREEN_SUB_TYPES.filter(function (sub_screen) {
	        return sub_screen.constant == screen_type;
	    });
	    if (sub_screen) return sub_screen[0]; //since filter returns an array, have to grab the first.
	    return null;
	}
	
	function getDefaultSubTitleScreenComponent() {
	    var sub_screen = componentModels.TITLE_SCREEN_SUB_TYPES.filter(function (sub_screen) {
	        return sub_screen.isDefault;
	    });
	    if (sub_screen) return sub_screen[0]; //since filter returns an array, have to grab the first.
	    return null;
	}
	
	function getAssetComponentByType(asset_type) {
	    var asset = componentModels.ASSET_TYPES.filter(function (asset) {
	        return asset.constant == asset_type;
	    });
	    if (asset) return asset[0]; //since filter returns an array, have to grab the first.
	    return null;
	}
	
	function getChildObjectComponentByType(asset_type_code) {
	    var object = componentModels.CHILD_OBJECTS_TYPES.filter(function (object) {
	        return object.constant == asset_type_code;
	    });
	    if (object) return object[0]; //since filter returns an array, have to grab the first.
	    return null;
	}
	
	function getResourceLinkComponentByType(object_type) {
	    var object = componentModels.RESOURCE_LINK_TYPES.filter(function (object) {
	        return object.constant == object_type;
	    });
	    if (object) return object[0]; //since filter returns an array, have to grab the first.
	    return null;
	}
	/*
	export function getToolboxComponentByType(asset_type_code){
	    const object = componentModels.TOOLBOX_TYPES.filter(object => object.constant == asset_type_code);
	    if (object) return object[0]; //since filter returns an array, have to grab the first.
	    return null;
	}

	export function getToolboxScreenComponentByType(asset_type_code){
	    const object = componentModels.TOOLBOX_SCREEN_TYPES.filter(object => object.constant == asset_type_code);
	    if (object) return object[0]; //since filter returns an array, have to grab the first.
	    return null;
	}*/

/***/ },
/* 32 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.DIALOG_TYPES = exports.SCREEN_DIALOG = exports.ASSET_DIALOG = exports.SIDE_DIALOG = exports.DIALOG = exports.LOCALE_CONFIG = exports.RESUME_CONFIG = exports.EXIT_CONFIG = exports.XAPI_INIT_ACTOR_CONFIG = exports.PERFORMANCE_CONFIG = exports.SCREEN_CONFIG = exports.ASSET_CONFIG = exports.SHORT_ANSWER_REVIEW_CONFIG = exports.MULTIPLE_ANSWER_REVIEW_CONFIG = exports.MULTIPLE_CHOICE_REVIEW_CONFIG = exports.LEANER_ACTION_REVIEW_CONFIG = exports.DIALOG_CONFIG = undefined;
	
	var _dialogConstants = __webpack_require__(555);
	
	var dialogConstants = _interopRequireWildcard(_dialogConstants);
	
	var _SingleAnswerReview = __webpack_require__(509);
	
	var _SingleAnswerReview2 = _interopRequireDefault(_SingleAnswerReview);
	
	var _MultipleAnswerReview = __webpack_require__(504);
	
	var _MultipleAnswerReview2 = _interopRequireDefault(_MultipleAnswerReview);
	
	var _ConversationSingleAnswerReview = __webpack_require__(496);
	
	var _ConversationSingleAnswerReview2 = _interopRequireDefault(_ConversationSingleAnswerReview);
	
	var _ShortResponseReview = __webpack_require__(519);
	
	var _ShortResponseReview2 = _interopRequireDefault(_ShortResponseReview);
	
	var _KpiDashboard = __webpack_require__(93);
	
	var _KpiDashboard2 = _interopRequireDefault(_KpiDashboard);
	
	var _BadgeDashboard = __webpack_require__(280);
	
	var _BadgeDashboard2 = _interopRequireDefault(_BadgeDashboard);
	
	var _ActorPrompt = __webpack_require__(463);
	
	var _ActorPrompt2 = _interopRequireDefault(_ActorPrompt);
	
	var _ExitPrompt = __webpack_require__(464);
	
	var _ExitPrompt2 = _interopRequireDefault(_ExitPrompt);
	
	var _ResumePrompt = __webpack_require__(468);
	
	var _ResumePrompt2 = _interopRequireDefault(_ResumePrompt);
	
	var _LocalePrompt = __webpack_require__(466);
	
	var _LocalePrompt2 = _interopRequireDefault(_LocalePrompt);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	//eslint-disable-line import/no-named-as-default
	//import Hello from '../components/Hello'; //eslint-disable-line import/no-named-as-default
	//eslint-disable-line import/no-named-as-default
	//eslint-disable-line import/no-named-as-default
	//eslint-disable-line import/no-named-as-default
	
	//eslint-disable-line import/no-named-as-default
	
	//import LearnerActionReview from '../components/objects/learnerAction/LearnerActionReview'; //eslint-disable-line import/no-named-as-default
	var DIALOG_STATE_CLASSES = {
	    isOpen: dialogConstants.DIALOG_CLASS_STATE_OPEN,
	    isClosed: dialogConstants.DIALOG_CLASS_STATE_CLOSED
	}; //eslint-disable-line import/no-named-as-default
	//eslint-disable-line import/no-named-as-default
	//eslint-disable-line import/no-named-as-default
	//eslint-disable-line import/no-named-as-default
	//eslint-disable-line import/no-named-as-default
	
	
	var OPEN_STATE = {
	    opacity: 1
	
	};
	
	var CLOSED_STATE = {
	    opacity: 0
	};
	
	//DEFAULT
	
	var DIALOG_CHILD_COMPONENTS = {
	    childComponent: null,
	    id: 'pageNotFound',
	    componentProps: null
	};
	
	var DIALOG_CONFIG = exports.DIALOG_CONFIG = {
	    dialogComponent: dialogConstants.CONTENT_DIALOG,
	    title: "",
	    icon: "",
	    theme: "",
	    showCloseBtn: true,
	    onClose: undefined,
	    childComponents: [DIALOG_CHILD_COMPONENTS]
	};
	
	//LEANER_ACTION_REVIEW
	var LEANER_ACTION_REVIEW_CHILD_COMPONENTS = {
	    childComponent: _ConversationSingleAnswerReview2.default,
	    id: 'learnerActionReview',
	    componentProps: {}
	};
	
	var LEANER_ACTION_REVIEW_CONFIG = exports.LEANER_ACTION_REVIEW_CONFIG = {
	    dialogComponent: dialogConstants.CONTENT_DIALOG,
	    title: "Review",
	    icon: "icons8-right",
	    theme: "",
	    showCloseBtn: true,
	    onClose: undefined,
	    childComponents: [LEANER_ACTION_REVIEW_CHILD_COMPONENTS]
	};
	
	//LEANER_ACTION_REVIEW
	
	var MULTIPLE_CHOICE_REVIEW_CHILD_COMPONENTS = {
	    childComponent: _SingleAnswerReview2.default,
	    id: 'multipleChoicenReview',
	    componentProps: {}
	};
	
	var MULTIPLE_CHOICE_REVIEW_CONFIG = exports.MULTIPLE_CHOICE_REVIEW_CONFIG = {
	    dialogComponent: dialogConstants.CONTENT_DIALOG,
	    title: "Review",
	    icon: "icons8-right",
	    theme: "",
	    showCloseBtn: true,
	    onClose: undefined,
	    childComponents: [MULTIPLE_CHOICE_REVIEW_CHILD_COMPONENTS]
	};
	
	//MULTIPLE_ANSWER_REVIEW
	var MULTIPLE_ANSWER_REVIEW_CHILD_COMPONENTS = {
	    childComponent: _MultipleAnswerReview2.default,
	    id: 'multipleAnswerReview',
	    componentProps: {}
	};
	
	var MULTIPLE_ANSWER_REVIEW_CONFIG = exports.MULTIPLE_ANSWER_REVIEW_CONFIG = {
	    dialogComponent: dialogConstants.CONTENT_DIALOG,
	    title: "Review",
	    icon: "icons8-right",
	    theme: "",
	    showCloseBtn: true,
	    onClose: undefined,
	    childComponents: [MULTIPLE_ANSWER_REVIEW_CHILD_COMPONENTS]
	};
	
	var SHORT_ANSWER_REVIEW_CHILD_COMPONENTS = {
	    childComponent: _ShortResponseReview2.default,
	    id: 'shortAnswerReview',
	    componentProps: {}
	};
	
	var SHORT_ANSWER_REVIEW_CONFIG = exports.SHORT_ANSWER_REVIEW_CONFIG = {
	    dialogComponent: dialogConstants.CONTENT_DIALOG,
	    title: "Review",
	    icon: "icons8-right",
	    theme: "",
	    showCloseBtn: true,
	    onClose: undefined,
	    childComponents: [SHORT_ANSWER_REVIEW_CHILD_COMPONENTS]
	};
	
	var ASSET_CHILD_COMPONENTS = {
	    childComponent: undefined,
	    id: 'assetDialog',
	    componentProps: {}
	};
	
	var ASSET_CONFIG = exports.ASSET_CONFIG = {
	    dialogComponent: undefined,
	    title: "",
	    icon: "",
	    theme: "",
	    showCloseBtn: true,
	    onClose: undefined,
	    childComponents: [ASSET_CHILD_COMPONENTS]
	};
	
	var SCREEN_CONFIG = exports.SCREEN_CONFIG = {
	    component: undefined,
	    biteCallbacks: {},
	    parentScreen: undefined,
	    screen: undefined,
	    showCloseBtn: true,
	    onClose: undefined,
	    sourceId: undefined
	};
	
	var PERFORMANCE_KPI_CHILD_COMPONENTS = {
	    childComponent: _KpiDashboard2.default,
	    id: 'KpiDashboard',
	    componentProps: {}
	};
	
	var PERFORMANCE_BADGE_CHILD_COMPONENTS = {
	    childComponent: _BadgeDashboard2.default,
	    id: 'BadgeDashboard',
	    componentProps: {}
	};
	
	var PERFORMANCE_CONFIG = exports.PERFORMANCE_CONFIG = {
	    dialogComponent: dialogConstants.CONTENT_DIALOG,
	    title: "Performance & Badges",
	    icon: "icons8-right",
	    theme: "performance",
	    showCloseBtn: true,
	    onClose: undefined,
	    sourceId: undefined,
	    childComponents: [PERFORMANCE_KPI_CHILD_COMPONENTS, PERFORMANCE_BADGE_CHILD_COMPONENTS]
	};
	
	var XAPI_INIT_ACTOR_CHILD_COMPONENTS = {
	    childComponent: _ActorPrompt2.default,
	    id: 'InitActor',
	    componentProps: {}
	};
	
	var XAPI_INIT_ACTOR_CONFIG = exports.XAPI_INIT_ACTOR_CONFIG = {
	    dialogComponent: dialogConstants.INIT_DIALOG,
	    title: "",
	    icon: "",
	    theme: "init-prompt",
	    showCloseBtn: true,
	    onClose: undefined,
	    childComponents: [XAPI_INIT_ACTOR_CHILD_COMPONENTS]
	};
	
	var EXIT_CHILD_COMPONENTS = {
	    childComponent: _ExitPrompt2.default,
	    id: 'ExitPrompt',
	    componentProps: {}
	};
	
	var EXIT_CONFIG = exports.EXIT_CONFIG = {
	    dialogComponent: dialogConstants.INIT_DIALOG,
	    title: "Goodbye",
	    icon: "",
	    theme: "init-prompt",
	    showCloseBtn: true,
	    onClose: undefined,
	    sourceId: "exitBtn",
	    childComponents: [EXIT_CHILD_COMPONENTS]
	};
	
	var RESUME_CHILD_COMPONENTS = {
	    childComponent: _ResumePrompt2.default,
	    id: 'ResumePrompt',
	    componentProps: {}
	};
	
	var RESUME_CONFIG = exports.RESUME_CONFIG = {
	    dialogComponent: dialogConstants.INIT_DIALOG,
	    title: "Welcome Back",
	    icon: "",
	    theme: "init-prompt",
	    showCloseBtn: true,
	    onClose: undefined,
	    childComponents: [RESUME_CHILD_COMPONENTS]
	};
	
	var LOCALE_CHILD_COMPONENTS = {
	    childComponent: _LocalePrompt2.default,
	    id: 'InitLocale',
	    componentProps: {}
	};
	
	var LOCALE_CONFIG = exports.LOCALE_CONFIG = {
	    dialogComponent: dialogConstants.INIT_DIALOG,
	    title: "",
	    icon: "",
	    theme: "init-prompt",
	    showCloseBtn: true,
	    onClose: undefined,
	    childComponents: [LOCALE_CHILD_COMPONENTS]
	};
	/*
	//LEANER_ACTION_REVIEW
	export let CLICK_REVEAL_CHILD_COMPONENT = {
	    childComponent: undefined,
	    id:'',
	    componentProps:{}
	};
	
	export let CLICK_REVEAL_CONFIG = {
	    dialogComponent: dialogConstants.CLICK_REVEAL_DIALOG,
	    title: "",
	    icon: "",
	    theme: "",
	    showCloseBtn: true,
	    callbacks: {},
	    childComponents: []
	};
	
	
	*/
	//DEFAULT PARENT MODELS
	var DIALOG = exports.DIALOG = {
	    component: dialogConstants.DIALOG_POPUP,
	    dialogTypeConstant: dialogConstants.DIALOG,
	    className: dialogConstants.DIALOG_CLASSNAME,
	    isOpen: false,
	    currentClassState: DIALOG_STATE_CLASSES.isClosed,
	    classStates: DIALOG_STATE_CLASSES,
	    currentState: CLOSED_STATE,
	    openState: OPEN_STATE,
	    closedState: CLOSED_STATE,
	    config: DIALOG_CONFIG,
	    render: true
	};
	
	//DEFAULT PARENT MODELS
	var SIDE_DIALOG = exports.SIDE_DIALOG = {
	    component: dialogConstants.DIALOG_POPUP,
	    dialogTypeConstant: dialogConstants.DIALOG,
	    className: dialogConstants.SIDE_DIALOG_CLASSNAME,
	    isOpen: false,
	    currentClassState: DIALOG_STATE_CLASSES.isClosed,
	    classStates: DIALOG_STATE_CLASSES,
	    currentState: CLOSED_STATE,
	    openState: OPEN_STATE,
	    closedState: CLOSED_STATE,
	    config: DIALOG_CONFIG,
	    render: true
	};
	
	var ASSET_DIALOG = exports.ASSET_DIALOG = {
	    component: dialogConstants.ASSET_DIALOG,
	    dialogTypeConstant: dialogConstants.DIALOG,
	    className: dialogConstants.ASSET_DIALOG_CLASSNAME,
	    isOpen: false,
	    currentClassState: DIALOG_STATE_CLASSES.isClosed,
	    classStates: DIALOG_STATE_CLASSES,
	    currentState: CLOSED_STATE,
	    openState: OPEN_STATE,
	    closedState: CLOSED_STATE,
	    config: DIALOG_CONFIG,
	    render: true
	};
	
	var SCREEN_DIALOG = exports.SCREEN_DIALOG = {
	    component: dialogConstants.SCREEN_DIALOG,
	    dialogTypeConstant: dialogConstants.DIALOG,
	    className: dialogConstants.SCREEN_DIALOG_CLASSNAME,
	    isOpen: false,
	    currentClassState: DIALOG_STATE_CLASSES.isClosed,
	    classStates: DIALOG_STATE_CLASSES,
	    currentState: CLOSED_STATE,
	    openState: OPEN_STATE,
	    closedState: CLOSED_STATE,
	    config: SCREEN_CONFIG,
	    render: true
	};
	
	//DEFAULT PARENT MODELS
	/*
	export let CLICK_REVEAL_DIALOG = {
	    component:dialogConstants.CLICK_REVEAL_DIALOG_POPUP,
	    dialogTypeConstant: dialogConstants.CLICK_REVEAL_DIALOG,
	    className: dialogConstants.CLICK_REVEAL_DIALOG_CLASSNAME,
	    isOpen: false,
	    currentClassState: DIALOG_STATE_CLASSES.isClosed,
	    classStates: DIALOG_STATE_CLASSES,
	    currentState: CLOSED_STATE,
	    openState: OPEN_STATE,
	    closedState: CLOSED_STATE,
	    config: CLICK_REVEAL_CONFIG,
	    render: true
	};
	*/
	
	var DIALOG_TYPES = exports.DIALOG_TYPES = [DIALOG, SIDE_DIALOG, ASSET_DIALOG];

/***/ },
/* 33 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var ASSET_TYPE_IMAGE = exports.ASSET_TYPE_IMAGE = 'image';
	var ASSET_TYPE_LIBRARY_IMAGE = exports.ASSET_TYPE_LIBRARY_IMAGE = 'library_image';
	var ASSET_TYPE_BACKGROUND = exports.ASSET_TYPE_BACKGROUND = 'background';
	var ASSET_TYPE_LARGE_BACKGROUND = exports.ASSET_TYPE_LARGE_BACKGROUND = 'large_background';
	var ASSET_TYPE_MOBILE_BACKGROUND = exports.ASSET_TYPE_MOBILE_BACKGROUND = 'mobile_background';
	
	var ASSET_TYPE_FOOTER_LOGO = exports.ASSET_TYPE_FOOTER_LOGO = 'footer_logo';
	var ASSET_TYPE_VIDEO = exports.ASSET_TYPE_VIDEO = 'video';
	var ASSET_TYPE_LINK = exports.ASSET_TYPE_LINK = 'link';
	var ASSET_TYPE_DOCUMENT = exports.ASSET_TYPE_DOCUMENT = 'document';
	var ASSET_TYPE_AUDIO = exports.ASSET_TYPE_AUDIO = 'audio';
	var ASSET_TYPE_HOTSPOT_BACKGROUND = exports.ASSET_TYPE_HOTSPOT_BACKGROUND = 'hotspot_background';
	var ASSET_SUB_TYPE_MP4 = exports.ASSET_SUB_TYPE_MP4 = 'mp4';
	var ASSET_SUB_TYPE_YOUTUBE = exports.ASSET_SUB_TYPE_YOUTUBE = 'youtube';
	var ASSET_SUB_TYPE_VIMEO = exports.ASSET_SUB_TYPE_VIMEO = 'vimeo';
	var ASSET_TYPE_ID_CHARACTER_FULL_BODY = exports.ASSET_TYPE_ID_CHARACTER_FULL_BODY = 'character_full_body';
	var ASSET_TYPE_ID_CHARACTER_FULL_BODY_LARGER = exports.ASSET_TYPE_ID_CHARACTER_FULL_BODY_LARGER = 'character_full_body_larger';
	var ASSET_TYPE_ID_CHARACTER_HALF_BODY = exports.ASSET_TYPE_ID_CHARACTER_HALF_BODY = 'character_half_body';
	var ASSET_TYPE_ID_CHARACTER_PROFILE = exports.ASSET_TYPE_ID_CHARACTER_PROFILE = 'character_profile';
	var ASSET_TYPE_ID_LOGO = exports.ASSET_TYPE_ID_LOGO = 'logo';
	var ASSET_TYPE_ID_MENU_THUMBNAIL = exports.ASSET_TYPE_ID_MENU_THUMBNAIL = 'menu_thumbnail';
	var ASSET_TYPE_ICON = exports.ASSET_TYPE_ICON = 'icon';
	var ASSET_TYPE_ID_CHARACTER = exports.ASSET_TYPE_ID_CHARACTER = 'character';
	
	var ASSET_TYPE_SELECTED = exports.ASSET_TYPE_SELECTED = 'selected';
	var ASSET_TYPE_INHERIT_FROM_THEME = exports.ASSET_TYPE_INHERIT_FROM_THEME = 'from_theme';
	
	var ASSET_AUDIO = exports.ASSET_AUDIO = 'asset_audio';
	var ASSET_CHILD_AUDIO = exports.ASSET_CHILD_AUDIO = 'asset_child_audio';
	
	var ASSET_TYPE_EARNED = exports.ASSET_TYPE_EARNED = 'earned';
	var ASSET_TYPE_UNEARNED = exports.ASSET_TYPE_UNEARNED = 'unearned';

/***/ },
/* 34 */
/***/ function(module, exports, __webpack_require__) {

	var store = __webpack_require__(165)('wks');
	var uid = __webpack_require__(111);
	var Symbol = __webpack_require__(24).Symbol;
	var USE_SYMBOL = typeof Symbol == 'function';
	
	var $exports = module.exports = function (name) {
	  return store[name] || (store[name] =
	    USE_SYMBOL && Symbol[name] || (USE_SYMBOL ? Symbol : uid)('Symbol.' + name));
	};
	
	$exports.store = store;


/***/ },
/* 35 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.getPrimaryKpi = getPrimaryKpi;
	exports.setKpiRenderOrder = setKpiRenderOrder;
	exports.getPrimaryKpiIndex = getPrimaryKpiIndex;
	exports.getBiteKpiTotalPoints = getBiteKpiTotalPoints;
	exports.getObjectBestPoints = getObjectBestPoints;
	exports.scaleKpiValue = scaleKpiValue;
	exports.getKpiValue = getKpiValue;
	exports.getKpiScoreRange = getKpiScoreRange;
	exports.getResultKpiKey = getResultKpiKey;
	exports.getKpiPreviousResultForObject = getKpiPreviousResultForObject;
	exports.getKpiPreviousResultIndex = getKpiPreviousResultIndex;
	exports.getKpiUserResponse = getKpiUserResponse;
	exports.getKpiPointsIndicatorClass = getKpiPointsIndicatorClass;
	exports.getRotationAngle_old = getRotationAngle_old;
	exports.getRotationAngle = getRotationAngle;
	exports.describeArc = describeArc;
	exports.biteHasVisibleKpis = biteHasVisibleKpis;
	exports.kpisAreVisible = kpisAreVisible;
	exports.getKpis = getKpis;
	exports.getAllKpis = getAllKpis;
	exports.getScoreKpi = getScoreKpi;
	exports.averageKpis = averageKpis;
	exports.removeObjectivesFromKpisToDisplay = removeObjectivesFromKpisToDisplay;
	exports.removeScoreFromKpisToDisplay = removeScoreFromKpisToDisplay;
	exports.removeKpisFromKpisToDisplay = removeKpisFromKpisToDisplay;
	exports.setKpiMenuData = setKpiMenuData;
	
	var _dataHelper = __webpack_require__(11);
	
	var dataHelper = _interopRequireWildcard(_dataHelper);
	
	var _appHelper = __webpack_require__(3);
	
	var appHelper = _interopRequireWildcard(_appHelper);
	
	var _kpiModels = __webpack_require__(57);
	
	var kpiModels = _interopRequireWildcard(_kpiModels);
	
	var _objectConstants = __webpack_require__(9);
	
	var objectConstants = _interopRequireWildcard(_objectConstants);
	
	var _localStorage = __webpack_require__(17);
	
	var localStorage = _interopRequireWildcard(_localStorage);
	
	var _lodash = __webpack_require__(28);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	//KPIs
	
	function getPrimaryKpi(kpis) {
	    var kpi = kpis.filter(function (kpi) {
	        return kpi.is_primary;
	    });
	    if (kpi) return kpi[0]; //since filter returns an array, have to grab the first.
	    return null;
	}
	
	function setKpiRenderOrder(kpis) {
	    var isEven = dataHelper.isEven(kpis);
	    var primaryIndex = getPrimaryKpiIndex(kpis);
	    var primaryKpi = appHelper.getArrayObjectByKey(kpis, "is_primary", true);
	    if (isEven) {
	        if (primaryIndex === 0) {
	            return kpis;
	        } else {
	            kpis = dataHelper.immutableSplice(kpis, primaryIndex, 1);
	            kpis = dataHelper.immutableUnshift(kpis, primaryKpi);
	            return kpis;
	        }
	    } else {
	        var centerIndex = Math.round(kpis.length / 2) - 1;
	
	        if (primaryIndex === centerIndex) {
	            return kpis;
	        } else {
	            kpis = dataHelper.immutableSplice(kpis, primaryIndex, 1);
	            kpis = dataHelper.immutableSplice(kpis, centerIndex, 0, primaryKpi);
	            return kpis;
	        }
	    }
	}
	
	function getPrimaryKpiIndex(kpis) {
	
	    for (var i = 0; i < kpis.length; i++) {
	        var kpi = kpis[i];
	        if (kpi.is_primary) {
	            return i;
	        }
	    }
	}
	
	function getBiteKpiTotalPoints(screens, kpi_id) {
	    //console.log(`getBiteKpiTotalPoints : ${kpi_id}`);
	    var totalPoints = 0;
	    for (var i = 0; i < screens.length; i++) {
	        //console.log(screens);
	        if (appHelper.isDefined(screens[i].sub_screens)) {
	            for (var s = 0; s < screens[i].sub_screens.length; s++) {
	                var subScreen = screens[i].sub_screens[s];
	                var subScreenObjects = subScreen.objects;
	                var subScreenObjectPoints = getScreenObjectKpiTotalPoints(subScreenObjects, kpi_id);
	                totalPoints = totalPoints + subScreenObjectPoints;
	            }
	        } else {
	            var screenObjects = screens[i].objects;
	            var screenObjectPoints = getScreenObjectKpiTotalPoints(screenObjects, kpi_id);
	            totalPoints = totalPoints + screenObjectPoints;
	        }
	    }
	    //console.log(`${kpi_id} totalPoints: ${totalPoints}`)
	    return totalPoints;
	}
	
	function getScreenObjectKpiTotalPoints(screenObjects, kpi_id) {
	
	    var screenObjectPoints = 0;
	    for (var i = 0; i < screenObjects.length; i++) {
	        if (appHelper.isDefined(screenObjects[i].options) && screenObjects[i].options.length) {
	            var options = screenObjects[i].options;
	            var optionPoints = 0;
	            if (screenObjects[i].selection_type === objectConstants.SELECTION_TYPE_SELECT_ONE) {
	                optionPoints = getObjectPoints(options, kpi_id);
	                // console.log(kpi_id, `  ` ,optionPoints);
	                screenObjectPoints = screenObjectPoints + optionPoints;
	            } else {
	                optionPoints = getObjectBestPoints(options, kpi_id);
	                //console.log(kpi_id, `  ` ,optionPoints);
	                screenObjectPoints = screenObjectPoints + optionPoints;
	            }
	            //console.log(`${kpi_id} screenObjectPoints: ${screenObjectPoints}`)
	        } else if (appHelper.isDefined(screenObjects[i].assess_type) && screenObjects[i].assess_type === objectConstants.ASSESSED_TYPE_SCORED) {
	            //console.log('else');
	            screenObjectPoints = screenObjectPoints + 2;
	        }
	    }
	
	    return screenObjectPoints;
	}
	
	function getObjectPoints(options, kpi_id) {
	    var optionPoints = 0;
	    for (var i = 0; i < options.length; i++) {
	
	        var option = options[i];
	        if (option.kpis !== null && appHelper.isDefined(option.kpis) && option.kpis.length > 0) {
	            var kpi = appHelper.getArrayObjectByKey(option.kpis, 'kpi_id', parseInt(kpi_id));
	
	            if (appHelper.isDefined(kpi)) {
	                if (kpi.value > optionPoints) {
	                    optionPoints = kpi.value;
	                }
	            }
	        }
	    }
	    //console.log(`optionPoints: ${optionPoints}`);
	    return optionPoints;
	}
	
	function getObjectBestPoints(options, kpi_id) {
	    var optionPoints = 0;
	    for (var i = 0; i < options.length; i++) {
	
	        var option = options[i];
	        //console.log(option);
	        if (option.kpis !== null && appHelper.isDefined(option.kpis) && option.kpis.length > 0) {
	            var kpi = appHelper.getArrayObjectByKey(option.kpis, 'kpi_id', parseInt(kpi_id));
	            //console.log(`getObjectBestPoints`,option, kpi);
	            if (appHelper.isDefined(kpi)) {
	                if (option.result === objectConstants.RESULT_TYPE_BEST) {
	                    optionPoints = parseInt(optionPoints) + parseInt(kpi.value);
	                }
	            }
	        }
	    }
	    //console.log(`optionPoints: ${optionPoints}`);
	    return optionPoints;
	}
	
	function scaleKpiValue(kpiValue, options, kpi_id) {
	    var max = getObjectBestPoints(options, kpi_id);
	    var min = 0 - max;
	    var percentageValue = dataHelper.getRangePercentage(min, max, kpiValue);
	    if (percentageValue < 24) {
	        return -2;
	    } else if (percentageValue > 24 && percentageValue < 50) {
	        return -1;
	    } else if (percentageValue >= 50 && percentageValue < 75) {
	        return 0;
	    } else if (percentageValue >= 75 && percentageValue < 100) {
	        return 1;
	    } else {
	        return 2;
	    }
	}
	
	function getKpiValue(kpiPointsVal, kpi) {
	    //console.log(`(${kpiPointsVal} / ${kpi.totalPoints} * (${kpi.max} - ${kpi.start}))`);
	    var decimals_points = parseInt(kpi.decimals_points) > 2 ? parseInt(kpi.decimals_points) : 2;
	    //console.log(`(${kpiPointsVal} / ${kpi.totalPoints} * (${kpi.max} - ${kpi.start})).toFixed(${decimals_points}) = ${(kpiPointsVal / kpi.totalPoints * (kpi.max - kpi.start)).toFixed(decimals_points)}`);
	    return (kpiPointsVal / kpi.totalPoints * (kpi.max - kpi.start)).toFixed(decimals_points);
	}
	
	function getKpiScoreRange(kpi, value) {
	
	    if (value < kpi.yellow) {
	        return "poor";
	    } else if (value >= kpi.yellow && value < kpi.green) {
	        return "ok";
	    } else {
	        return "best";
	    }
	}
	
	function getResultKpiKey(kpi) {
	
	    if (kpi.current < kpi.yellow) {
	        return "red_feedback";
	    } else if (kpi.current >= kpi.yellow && kpi.current < kpi.green) {
	        return "yellow_feedback";
	    } else {
	        return "green_feedback";
	    }
	}
	
	function getKpiPreviousResultForObject(biteKpiHistory, screen_id, asset_id, kpi_id) {
	    var currentAttempt = -1;
	    var result = {};
	    for (var i = 0; i < biteKpiHistory.length; i++) {
	        var history = biteKpiHistory[i];
	        if (history.screen_id === screen_id && history.asset_id === asset_id) {
	            result = Object.assign({}, history);
	        }
	    }
	    return result;
	}
	
	function getKpiPreviousResultIndex(biteKpiHistory, screen_id, asset_id, kpi_id) {
	    var currentAttempt = -1;
	    var result = -1;
	    for (var i = 0; i < biteKpiHistory.length; i++) {
	        var history = biteKpiHistory[i];
	        if (history.screen_id === screen_id && history.asset_id === asset_id) {
	            result = i;
	            currentAttempt = history.attempt;
	        }
	    }
	    return result;
	}
	
	function getKpiUserResponse(userKpiResult, screen_id, asset_id, option_id) {
	    var kpi = userKpiResult.history.filter(function (kpi) {
	        return kpi.screen_id == screen_id && kpi.asset_id == asset_id && kpi.option_id == option_id;
	    });
	    if (kpi) return kpi[0]; //since filter returns an array, have to grab the first.
	    return null;
	}
	
	function getKpiPointsIndicatorClass(value, kpi_id) {
	    var kpi = getKpi(kpi_id);
	
	    if (!appHelper.isDefined(kpi.scoring_pattern)) {
	        kpi = Object.assign({}, kpi, {
	            scoring_pattern: kpiModels.KPI_SCORING_PATTERNS[0]
	        });
	    }
	
	    var indicatorClasses = appHelper.getArrayObjectByKey(kpiModels.KPI_SCORING_PATTERNS, "constant", kpi.scoring_pattern).indicatorClasses;
	    var highestValue = appHelper.getArrayObjectByKey(indicatorClasses, "class", "positive-double").value;
	    var lowestValue = appHelper.getArrayObjectByKey(indicatorClasses, "class", "negative-double").value;
	    //console.log(`indicatorClass`,indicatorClasses,highestValue,lowestValue);
	
	    var result = appHelper.getArrayObjectByKey(indicatorClasses, "value", value);
	    if (!appHelper.isDefined(result)) {
	        if (value > highestValue) {
	            result = Object.assign({}, {
	                value: value,
	                class: "positive-double"
	            });
	        } else if (value < lowestValue) {
	            result = Object.assign({}, {
	                value: value,
	                class: "negative-double"
	            });
	        }
	    }
	
	    return result;
	}
	
	function getKpi(kpi_id) {
	    for (var i = 0; i < localStorage.bites.length; i++) {
	        var bite = localStorage.bites[i];
	        var kpis = getAllKpis(bite);
	        if (kpis.length > 0) {
	            var kpiIndex = appHelper.getArrayObjectIndexByKey(kpis, "kpi_id", kpi_id);
	            if (kpiIndex > -1) {
	                var kpi = appHelper.getArrayObjectByKey(kpis, "kpi_id", kpi_id);
	                return kpi;
	            }
	        }
	    }
	}
	
	function getRotationAngle_old(maxRotation, currentPoints, totalPoints) {
	    return maxRotation * 2 / totalPoints * currentPoints - maxRotation;
	}
	
	function getRotationAngle(maxRotation, minValue, currentPoints, totalPoints) {
	    var percentage = (currentPoints - minValue) / (totalPoints - minValue) * 100;
	    var value = totalPoints / 100 * percentage;
	    return maxRotation * 2 / totalPoints * value - maxRotation;
	}
	
	function describeArc(x, y, radius, startAngle, endAngle) {
	
	    var start = polarToCartesian(x, y, radius, endAngle);
	    var end = polarToCartesian(x, y, radius, startAngle);
	
	    var largeArcFlag = endAngle - startAngle <= 180 ? "0" : "1";
	
	    var d = ["M", start.x, start.y, "A", radius, radius, 0, largeArcFlag, 0, end.x, end.y].join(" ");
	
	    return d;
	}
	
	function polarToCartesian(centerX, centerY, radius, angleInDegrees) {
	    var angleInRadians = (angleInDegrees - 90) * Math.PI / 180.0;
	
	    return {
	        x: centerX + radius * Math.cos(angleInRadians),
	        y: centerY + radius * Math.sin(angleInRadians)
	    };
	}
	
	function biteHasVisibleKpis(bite) {
	    var visibleKpis = 0;
	    if (appHelper.isDefined(bite.score_kpi) && bite.score_kpi.kpi_id !== null && bite.score_kpi.is_visible) {
	        visibleKpis++;
	    }
	
	    if (appHelper.isDefined(bite.performance_kpis)) {
	        _lodash2.default.forEach(bite.performance_kpis, function (kpi) {
	            if (kpi.is_visible) {
	                visibleKpis++;
	            }
	        });
	    }
	
	    return visibleKpis > 0;
	}
	
	function kpisAreVisible(kpis, bite_id) {
	    var visibleKpis = 0;
	    var bite = appHelper.getBiteById(bite_id);
	
	    if (appHelper.isDefined(bite.score_kpi) && bite.score_kpi.kpi_id !== null && bite.score_kpi.is_visible) {
	        if (appHelper.getArrayObjectIndexByKey(kpis, "kpi_id", bite.score_kpi.kpi_id) > -1) {
	            visibleKpis++;
	        }
	    }
	
	    if (appHelper.isDefined(bite.performance_kpis)) {
	        _lodash2.default.forEach(bite.performance_kpis, function (kpi) {
	            if (kpi.is_visible && appHelper.getArrayObjectIndexByKey(kpis, "kpi_id", kpi.kpi_id) > -1) {
	                visibleKpis++;
	            }
	        });
	    }
	    return visibleKpis > 0;
	}
	
	function getKpis(bite) {
	    var kpis = [];
	    if (appHelper.isDefined(bite.score_kpi) && bite.score_kpi.is_visible) {
	        var primaryKpi = Object.assign({}, bite.score_kpi, {
	            is_primary: true
	        });
	        kpis = dataHelper.immutablePush(kpis, primaryKpi);
	    }
	
	    if (appHelper.isDefined(bite.performance_kpis)) {
	        _lodash2.default.forEach(bite.performance_kpis, function (kpi) {
	            if (kpi.is_visible) {
	                kpi = Object.assign({}, kpi, {
	                    is_primary: false
	                });
	                kpis = dataHelper.immutablePush(kpis, kpi);
	            }
	        });
	    }
	    return kpis;
	}
	
	function getAllKpis(bite) {
	    var kpis = [];
	    if (appHelper.isDefined(bite.score_kpi)) {
	        var primaryKpi = Object.assign({}, bite.score_kpi, {
	            is_primary: true
	        });
	        kpis = dataHelper.immutablePush(kpis, primaryKpi);
	    }
	
	    if (appHelper.isDefined(bite.performance_kpis)) {
	        _lodash2.default.forEach(bite.performance_kpis, function (kpi) {
	
	            kpi = Object.assign({}, kpi, {
	                is_primary: false
	            });
	            kpis = dataHelper.immutablePush(kpis, kpi);
	        });
	    }
	    return kpis;
	}
	
	function getScoreKpi(bite) {
	    var score_kpi = {};
	    if (appHelper.isDefined(bite.score_kpi) && bite.score_kpi.is_visible) {
	        score_kpi = Object.assign({}, bite.score_kpi, {
	            is_primary: true
	        });
	    }
	    return score_kpi;
	}
	
	function averageKpis(responses) {
	    var kpis = [];
	    _lodash2.default.forEach(responses, function (response) {
	        //console.log(response.kpis);
	        _lodash2.default.forEach(response.kpis, function (kpi) {
	            //console.log(kpis);
	            var kpiIndex = appHelper.getArrayObjectIndexByKey(kpis, "kpi_id", kpi.kpi_id);
	            var kpiResult = {};
	            if (kpiIndex === -1) {
	                kpiResult = Object.assign({}, kpiResult, {
	                    kpi_id: kpi.kpi_id,
	                    value: kpi.value
	                });
	                kpis = dataHelper.immutablePush(kpis, kpiResult);
	            } else {
	                kpiResult = Object.assign({}, kpis[kpiIndex], {
	                    value: parseInt(kpi.value) + parseInt(kpis[kpiIndex].value)
	                });
	                kpis = dataHelper.immutableSplice(kpis, kpiIndex, 1, kpiResult);
	            }
	        });
	    });
	    /*
	        _.forEach(kpis, function (kpi) {
	            let kpiIndex = appHelper.getArrayObjectIndexByKey(kpis, "kpi_id", kpi.kpi_id);
	            kpi = Object.assign({}, kpi, {
	                value: Math.round(kpi.value / responses.length)
	            });
	            kpis = dataHelper.immutableSplice(kpis, kpiIndex, 1, kpi);
	        });
	    */
	    return kpis;
	}
	
	function removeObjectivesFromKpisToDisplay(kpiList) {
	    var returnKpis = Object.assign([], kpiList);
	    var trashCan = [];
	
	    _lodash2.default.forEach(kpiList, function (kpi) {
	        if (!kpi.data.is_primary) {
	            trashCan = dataHelper.immutablePush(trashCan, kpi);
	        }
	    });
	
	    _lodash2.default.forEach(trashCan, function (kpi) {
	        var kpiIndex = appHelper.getArrayObjectIndexByKey(returnKpis, "kpi_id", kpi.kpi_id);
	        returnKpis = dataHelper.immutableSplice(returnKpis, kpiIndex, 1);
	    });
	
	    return returnKpis;
	}
	
	function removeScoreFromKpisToDisplay(kpiList) {
	    var returnKpis = Object.assign([], kpiList);
	    var trashCan = [];
	
	    _lodash2.default.forEach(kpiList, function (kpi) {
	        if (kpi.data.is_primary) {
	            trashCan = dataHelper.immutablePush(trashCan, kpi);
	        }
	    });
	
	    _lodash2.default.forEach(trashCan, function (kpi) {
	        var kpiIndex = appHelper.getArrayObjectIndexByKey(returnKpis, "kpi_id", kpi.kpi_id);
	        returnKpis = dataHelper.immutableSplice(returnKpis, kpiIndex, 1);
	    });
	
	    return returnKpis;
	}
	
	function removeKpisFromKpisToDisplay(kpiList, kpisToRemove) {
	    var returnKpis = Object.assign([], kpiList);
	    var trashCan = [];
	
	    _lodash2.default.forEach(kpiList, function (kpi) {
	        _lodash2.default.forEach(kpisToRemove, function (kpiToRemove) {
	            if (kpi.kpi_id === parseInt(kpiToRemove.kpi_id)) {
	                trashCan = dataHelper.immutablePush(trashCan, kpi);
	            }
	        });
	    });
	
	    _lodash2.default.forEach(trashCan, function (kpi) {
	        var kpiIndex = appHelper.getArrayObjectIndexByKey(returnKpis, "kpi_id", kpi.kpi_id);
	        returnKpis = dataHelper.immutableSplice(returnKpis, kpiIndex, 1);
	    });
	
	    return returnKpis;
	}
	
	function setKpiMenuData(kpiList) {
	
	    var menuData = [];
	    _lodash2.default.forEach(kpiList, function (kpi) {
	
	        var menuItem = {
	            constant: kpi.kpi_id,
	            kpi_id: kpi.kpi_id,
	            label: appHelper.getLocalData(kpi.data).long_title
	        };
	        menuData = dataHelper.immutablePush(menuData, menuItem);
	    });
	    return menuData;
	}

/***/ },
/* 36 */
/***/ function(module, exports) {

	/*
	object-assign
	(c) Sindre Sorhus
	@license MIT
	*/
	
	'use strict';
	/* eslint-disable no-unused-vars */
	var getOwnPropertySymbols = Object.getOwnPropertySymbols;
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	var propIsEnumerable = Object.prototype.propertyIsEnumerable;
	
	function toObject(val) {
		if (val === null || val === undefined) {
			throw new TypeError('Object.assign cannot be called with null or undefined');
		}
	
		return Object(val);
	}
	
	function shouldUseNative() {
		try {
			if (!Object.assign) {
				return false;
			}
	
			// Detect buggy property enumeration order in older V8 versions.
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=4118
			var test1 = new String('abc');  // eslint-disable-line no-new-wrappers
			test1[5] = 'de';
			if (Object.getOwnPropertyNames(test1)[0] === '5') {
				return false;
			}
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=3056
			var test2 = {};
			for (var i = 0; i < 10; i++) {
				test2['_' + String.fromCharCode(i)] = i;
			}
			var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
				return test2[n];
			});
			if (order2.join('') !== '0123456789') {
				return false;
			}
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=3056
			var test3 = {};
			'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
				test3[letter] = letter;
			});
			if (Object.keys(Object.assign({}, test3)).join('') !==
					'abcdefghijklmnopqrst') {
				return false;
			}
	
			return true;
		} catch (err) {
			// We don't expect any of the above to throw, but better to be safe.
			return false;
		}
	}
	
	module.exports = shouldUseNative() ? Object.assign : function (target, source) {
		var from;
		var to = toObject(target);
		var symbols;
	
		for (var s = 1; s < arguments.length; s++) {
			from = Object(arguments[s]);
	
			for (var key in from) {
				if (hasOwnProperty.call(from, key)) {
					to[key] = from[key];
				}
			}
	
			if (getOwnPropertySymbols) {
				symbols = getOwnPropertySymbols(from);
				for (var i = 0; i < symbols.length; i++) {
					if (propIsEnumerable.call(from, symbols[i])) {
						to[symbols[i]] = from[symbols[i]];
					}
				}
			}
		}
	
		return to;
	};


/***/ },
/* 37 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	var KPI_RED_ZONE_COLOUR = exports.KPI_RED_ZONE_COLOUR = '#C5000F';
	var KPI_YELLOW_ZONE_COLOUR = exports.KPI_YELLOW_ZONE_COLOUR = '#F6AD17';
	var KPI_GREEN_ZONE_COLOUR = exports.KPI_GREEN_ZONE_COLOUR = '#39AA27';
	
	var KPI_METER_TYPE_ROTATION = exports.KPI_METER_TYPE_ROTATION = 'rotation';
	
	var KPI_MIN_ROTATION = exports.KPI_MIN_ROTATION = -120;
	var KPI_MAX_ROTATION = exports.KPI_MAX_ROTATION = 120;
	//
	//SET SVG PARAMS FOR ROTATION METER IN MODULE HEADER
	//
	var HEADER_KPI_ROTATION_SVG_PARAM_X_POS = exports.HEADER_KPI_ROTATION_SVG_PARAM_X_POS = 18;
	var HEADER_KPI_ROTATION_SVG_PARAM_Y_POS = exports.HEADER_KPI_ROTATION_SVG_PARAM_Y_POS = 18;
	var HEADER_KPI_ROTATION_SVG_PARAM_RADIUS = exports.HEADER_KPI_ROTATION_SVG_PARAM_RADIUS = 16;
	var HEADER_KPI_ROTATION_SVG_PARAM_STROKE = exports.HEADER_KPI_ROTATION_SVG_PARAM_STROKE = 3;
	
	//
	//SET SVG PARAMS FOR DEFAULT ROTATION METER USED IN TOOLTIP AND FEEDBACK
	//
	var DEFAULT_KPI_ROTATION_SVG_PARAM_X_POS = exports.DEFAULT_KPI_ROTATION_SVG_PARAM_X_POS = 32;
	var DEFAULT_KPI_ROTATION_SVG_PARAM_Y_POS = exports.DEFAULT_KPI_ROTATION_SVG_PARAM_Y_POS = 32;
	var DEFAULT_KPI_ROTATION_SVG_PARAM_RADIUS = exports.DEFAULT_KPI_ROTATION_SVG_PARAM_RADIUS = 28;
	var DEFAULT_KPI_ROTATION_SVG_PARAM_STROKE = exports.DEFAULT_KPI_ROTATION_SVG_PARAM_STROKE = 5;
	
	//
	//SET SVG PARAMS FOR PRIMARY ROTATION METER USED IN TOOLTIP AND FEEDBACK
	//
	var PRIMARY_KPI_ROTATION_SVG_PARAM_X_POS = exports.PRIMARY_KPI_ROTATION_SVG_PARAM_X_POS = 40;
	var PRIMARY_KPI_ROTATION_SVG_PARAM_Y_POS = exports.PRIMARY_KPI_ROTATION_SVG_PARAM_Y_POS = 40;
	var PRIMARY_KPI_ROTATION_SVG_PARAM_RADIUS = exports.PRIMARY_KPI_ROTATION_SVG_PARAM_RADIUS = 36;
	var PRIMARY_KPI_ROTATION_SVG_PARAM_STROKE = exports.PRIMARY_KPI_ROTATION_SVG_PARAM_STROKE = 6;
	/*kpiMeter:{
	 x: 18,
	 y: 18,
	 radius: 16,
	 stroke: 3,
	 }*/
	
	//METER WITH START / DEFAULT VALUE AND THE KPI LABEL
	var KPI_DISPLAY_STATE_START = exports.KPI_DISPLAY_STATE_START = 'KPI_DISPLAY_STATE_START';
	
	//METER WITH CURRENT VALUE AND THE KPI LABEL
	var KPI_DISPLAY_STATE_CURRENT = exports.KPI_DISPLAY_STATE_CURRENT = 'KPI_DISPLAY_STATE_CURRENT';
	
	//METER WITH CURRENT VALUE AND THE KPI LABEL
	var KPI_DISPLAY_STATE_CURRENT_VALUE_WITH_LABEL = exports.KPI_DISPLAY_STATE_CURRENT_VALUE_WITH_LABEL = 'KPI_DISPLAY_STATE_CURRENT_VALUE_WITH_LABEL';
	
	//METER WITH CURRENT VALUE WITHOUT THE KPI LABEL
	var KPI_DISPLAY_STATE_CURRENT_VALUE_NO_LABEL = exports.KPI_DISPLAY_STATE_CURRENT_VALUE_NO_LABEL = 'KPI_DISPLAY_STATE_CURRENT_VALUE_NO_LABEL';
	
	//METER WITH UPDATED SCORE WITH KPI LABEL AND INDICATORS OF HOW YOU SCORED
	var KPI_DISPLAY_STATE_CURRENT_POINTS_AWARDED = exports.KPI_DISPLAY_STATE_CURRENT_POINTS_AWARDED = 'KPI_DISPLAY_STATE_CURRENT_POINTS_AWARDED';
	
	// KPI LABEL AND INDICATORS OF HOW YOU SCORED WITH NO METER
	var KPI_DISPLAY_STATE_REVIEW_POINTS_AWARDED = exports.KPI_DISPLAY_STATE_REVIEW_POINTS_AWARDED = 'KPI_DISPLAY_STATE_REVIEW_POINTS_AWARDED';
	
	var RED_ASSET = exports.RED_ASSET = "red_asset";
	var YELLOW_ASSET = exports.YELLOW_ASSET = "yellow_asset";
	var GREEN_ASSET = exports.GREEN_ASSET = "green_asset";
	
	var WATERMARK_STYLES = exports.WATERMARK_STYLES = {
	    opacity: 0.08,
	    position: "absolute",
	    height: "80px",
	    width: "80px",
	    right: "10px",
	    top: "5px"
	};

/***/ },
/* 38 */
/***/ function(module, exports, __webpack_require__) {

	// Thank's IE8 for his funny defineProperty
	module.exports = !__webpack_require__(26)(function () {
	  return Object.defineProperty({}, 'a', { get: function () { return 7; } }).a != 7;
	});


/***/ },
/* 39 */
/***/ function(module, exports, __webpack_require__) {

	var anObject = __webpack_require__(23);
	var IE8_DOM_DEFINE = __webpack_require__(300);
	var toPrimitive = __webpack_require__(79);
	var dP = Object.defineProperty;
	
	exports.f = __webpack_require__(38) ? Object.defineProperty : function defineProperty(O, P, Attributes) {
	  anObject(O);
	  P = toPrimitive(P, true);
	  anObject(Attributes);
	  if (IE8_DOM_DEFINE) try {
	    return dP(O, P, Attributes);
	  } catch (e) { /* empty */ }
	  if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported!');
	  if ('value' in Attributes) O[P] = Attributes.value;
	  return O;
	};


/***/ },
/* 40 */
/***/ function(module, exports, __webpack_require__) {

	// 7.1.15 ToLength
	var toInteger = __webpack_require__(78);
	var min = Math.min;
	module.exports = function (it) {
	  return it > 0 ? min(toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
	};


/***/ },
/* 41 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(29);
	
	var DOMProperty = __webpack_require__(128);
	var ReactDOMComponentFlags = __webpack_require__(385);
	
	var invariant = __webpack_require__(21);
	
	var ATTR_NAME = DOMProperty.ID_ATTRIBUTE_NAME;
	var Flags = ReactDOMComponentFlags;
	
	var internalInstanceKey = '__reactInternalInstance$' + Math.random().toString(36).slice(2);
	
	/**
	 * Check if a given node should be cached.
	 */
	function shouldPrecacheNode(node, nodeID) {
	  return node.nodeType === 1 && node.getAttribute(ATTR_NAME) === String(nodeID) || node.nodeType === 8 && node.nodeValue === ' react-text: ' + nodeID + ' ' || node.nodeType === 8 && node.nodeValue === ' react-empty: ' + nodeID + ' ';
	}
	
	/**
	 * Drill down (through composites and empty components) until we get a host or
	 * host text component.
	 *
	 * This is pretty polymorphic but unavoidable with the current structure we have
	 * for `_renderedChildren`.
	 */
	function getRenderedHostOrTextFromComponent(component) {
	  var rendered;
	  while (rendered = component._renderedComponent) {
	    component = rendered;
	  }
	  return component;
	}
	
	/**
	 * Populate `_hostNode` on the rendered host/text component with the given
	 * DOM node. The passed `inst` can be a composite.
	 */
	function precacheNode(inst, node) {
	  var hostInst = getRenderedHostOrTextFromComponent(inst);
	  hostInst._hostNode = node;
	  node[internalInstanceKey] = hostInst;
	}
	
	function uncacheNode(inst) {
	  var node = inst._hostNode;
	  if (node) {
	    delete node[internalInstanceKey];
	    inst._hostNode = null;
	  }
	}
	
	/**
	 * Populate `_hostNode` on each child of `inst`, assuming that the children
	 * match up with the DOM (element) children of `node`.
	 *
	 * We cache entire levels at once to avoid an n^2 problem where we access the
	 * children of a node sequentially and have to walk from the start to our target
	 * node every time.
	 *
	 * Since we update `_renderedChildren` and the actual DOM at (slightly)
	 * different times, we could race here and see a newer `_renderedChildren` than
	 * the DOM nodes we see. To avoid this, ReactMultiChild calls
	 * `prepareToManageChildren` before we change `_renderedChildren`, at which
	 * time the container's child nodes are always cached (until it unmounts).
	 */
	function precacheChildNodes(inst, node) {
	  if (inst._flags & Flags.hasCachedChildNodes) {
	    return;
	  }
	  var children = inst._renderedChildren;
	  var childNode = node.firstChild;
	  outer: for (var name in children) {
	    if (!children.hasOwnProperty(name)) {
	      continue;
	    }
	    var childInst = children[name];
	    var childID = getRenderedHostOrTextFromComponent(childInst)._domID;
	    if (childID === 0) {
	      // We're currently unmounting this child in ReactMultiChild; skip it.
	      continue;
	    }
	    // We assume the child nodes are in the same order as the child instances.
	    for (; childNode !== null; childNode = childNode.nextSibling) {
	      if (shouldPrecacheNode(childNode, childID)) {
	        precacheNode(childInst, childNode);
	        continue outer;
	      }
	    }
	    // We reached the end of the DOM children without finding an ID match.
	     true ?  false ? invariant(false, 'Unable to find element with ID %s.', childID) : _prodInvariant('32', childID) : void 0;
	  }
	  inst._flags |= Flags.hasCachedChildNodes;
	}
	
	/**
	 * Given a DOM node, return the closest ReactDOMComponent or
	 * ReactDOMTextComponent instance ancestor.
	 */
	function getClosestInstanceFromNode(node) {
	  if (node[internalInstanceKey]) {
	    return node[internalInstanceKey];
	  }
	
	  // Walk up the tree until we find an ancestor whose instance we have cached.
	  var parents = [];
	  while (!node[internalInstanceKey]) {
	    parents.push(node);
	    if (node.parentNode) {
	      node = node.parentNode;
	    } else {
	      // Top of the tree. This node must not be part of a React tree (or is
	      // unmounted, potentially).
	      return null;
	    }
	  }
	
	  var closest;
	  var inst;
	  for (; node && (inst = node[internalInstanceKey]); node = parents.pop()) {
	    closest = inst;
	    if (parents.length) {
	      precacheChildNodes(inst, node);
	    }
	  }
	
	  return closest;
	}
	
	/**
	 * Given a DOM node, return the ReactDOMComponent or ReactDOMTextComponent
	 * instance, or null if the node was not rendered by this React.
	 */
	function getInstanceFromNode(node) {
	  var inst = getClosestInstanceFromNode(node);
	  if (inst != null && inst._hostNode === node) {
	    return inst;
	  } else {
	    return null;
	  }
	}
	
	/**
	 * Given a ReactDOMComponent or ReactDOMTextComponent, return the corresponding
	 * DOM node.
	 */
	function getNodeFromInstance(inst) {
	  // Without this first invariant, passing a non-DOM-component triggers the next
	  // invariant for a missing parent, which is super confusing.
	  !(inst._hostNode !== undefined) ?  false ? invariant(false, 'getNodeFromInstance: Invalid argument.') : _prodInvariant('33') : void 0;
	
	  if (inst._hostNode) {
	    return inst._hostNode;
	  }
	
	  // Walk up the tree until we find an ancestor whose DOM node we have cached.
	  var parents = [];
	  while (!inst._hostNode) {
	    parents.push(inst);
	    !inst._hostParent ?  false ? invariant(false, 'React DOM tree root should always have a node reference.') : _prodInvariant('34') : void 0;
	    inst = inst._hostParent;
	  }
	
	  // Now parents contains each ancestor that does *not* have a cached native
	  // node, and `inst` is the deepest ancestor that does.
	  for (; parents.length; inst = parents.pop()) {
	    precacheChildNodes(inst, inst._hostNode);
	  }
	
	  return inst._hostNode;
	}
	
	var ReactDOMComponentTree = {
	  getClosestInstanceFromNode: getClosestInstanceFromNode,
	  getInstanceFromNode: getInstanceFromNode,
	  getNodeFromInstance: getNodeFromInstance,
	  precacheChildNodes: precacheChildNodes,
	  precacheNode: precacheNode,
	  uncacheNode: uncacheNode
	};
	
	module.exports = ReactDOMComponentTree;

/***/ },
/* 42 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _appModels = __webpack_require__(68);
	
	var appData = _interopRequireWildcard(_appModels);
	
	var _actionTypes = __webpack_require__(22);
	
	var actionTypes = _interopRequireWildcard(_actionTypes);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	exports.default = {
	    initData: appData.INIT_DATA,
	    trackingData: appData.TRACKING_DATA,
	    contentData: {
	        contentLoaded: false
	    },
	    userData: {},
	    navigation: {},
	    dialogPopup: {
	        render: false
	    },
	    contentToolTip: {
	        render: false,
	        content: ""
	    },
	    clickRevealDialog: {
	        render: false
	    },
	    assetDialog: {
	        render: false
	    },
	    screenDialog: {
	        render: false
	    },
	    titles: appData.TITLES,
	    ajaxCallsInProgress: 0,
	    displayMainMenu: actionTypes.STATUS_CLOSED,
	    displayResources: actionTypes.STATUS_CLOSED,
	    displayNotes: actionTypes.STATUS_CLOSED,
	    resourceProps: appData.RESOURCE_PROPS,
	    audio: {
	        audioRef: "",
	        audioAllowed: true
	    },
	    fontSize: appData.FONT_SIZE
	};

/***/ },
/* 43 */
/***/ function(module, exports, __webpack_require__) {

	// 7.1.13 ToObject(argument)
	var defined = __webpack_require__(76);
	module.exports = function (it) {
	  return Object(defined(it));
	};


/***/ },
/* 44 */
/***/ function(module, exports, __webpack_require__) {

	;(function (root, factory, undef) {
		if (true) {
			// CommonJS
			module.exports = exports = factory(__webpack_require__(25), __webpack_require__(112));
		}
		else if (typeof define === "function" && define.amd) {
			// AMD
			define(["./core", "./evpkdf"], factory);
		}
		else {
			// Global (browser)
			factory(root.CryptoJS);
		}
	}(this, function (CryptoJS) {
	
		/**
		 * Cipher core components.
		 */
		CryptoJS.lib.Cipher || (function (undefined) {
		    // Shortcuts
		    var C = CryptoJS;
		    var C_lib = C.lib;
		    var Base = C_lib.Base;
		    var WordArray = C_lib.WordArray;
		    var BufferedBlockAlgorithm = C_lib.BufferedBlockAlgorithm;
		    var C_enc = C.enc;
		    var Utf8 = C_enc.Utf8;
		    var Base64 = C_enc.Base64;
		    var C_algo = C.algo;
		    var EvpKDF = C_algo.EvpKDF;
	
		    /**
		     * Abstract base cipher template.
		     *
		     * @property {number} keySize This cipher's key size. Default: 4 (128 bits)
		     * @property {number} ivSize This cipher's IV size. Default: 4 (128 bits)
		     * @property {number} _ENC_XFORM_MODE A constant representing encryption mode.
		     * @property {number} _DEC_XFORM_MODE A constant representing decryption mode.
		     */
		    var Cipher = C_lib.Cipher = BufferedBlockAlgorithm.extend({
		        /**
		         * Configuration options.
		         *
		         * @property {WordArray} iv The IV to use for this operation.
		         */
		        cfg: Base.extend(),
	
		        /**
		         * Creates this cipher in encryption mode.
		         *
		         * @param {WordArray} key The key.
		         * @param {Object} cfg (Optional) The configuration options to use for this operation.
		         *
		         * @return {Cipher} A cipher instance.
		         *
		         * @static
		         *
		         * @example
		         *
		         *     var cipher = CryptoJS.algo.AES.createEncryptor(keyWordArray, { iv: ivWordArray });
		         */
		        createEncryptor: function (key, cfg) {
		            return this.create(this._ENC_XFORM_MODE, key, cfg);
		        },
	
		        /**
		         * Creates this cipher in decryption mode.
		         *
		         * @param {WordArray} key The key.
		         * @param {Object} cfg (Optional) The configuration options to use for this operation.
		         *
		         * @return {Cipher} A cipher instance.
		         *
		         * @static
		         *
		         * @example
		         *
		         *     var cipher = CryptoJS.algo.AES.createDecryptor(keyWordArray, { iv: ivWordArray });
		         */
		        createDecryptor: function (key, cfg) {
		            return this.create(this._DEC_XFORM_MODE, key, cfg);
		        },
	
		        /**
		         * Initializes a newly created cipher.
		         *
		         * @param {number} xformMode Either the encryption or decryption transormation mode constant.
		         * @param {WordArray} key The key.
		         * @param {Object} cfg (Optional) The configuration options to use for this operation.
		         *
		         * @example
		         *
		         *     var cipher = CryptoJS.algo.AES.create(CryptoJS.algo.AES._ENC_XFORM_MODE, keyWordArray, { iv: ivWordArray });
		         */
		        init: function (xformMode, key, cfg) {
		            // Apply config defaults
		            this.cfg = this.cfg.extend(cfg);
	
		            // Store transform mode and key
		            this._xformMode = xformMode;
		            this._key = key;
	
		            // Set initial values
		            this.reset();
		        },
	
		        /**
		         * Resets this cipher to its initial state.
		         *
		         * @example
		         *
		         *     cipher.reset();
		         */
		        reset: function () {
		            // Reset data buffer
		            BufferedBlockAlgorithm.reset.call(this);
	
		            // Perform concrete-cipher logic
		            this._doReset();
		        },
	
		        /**
		         * Adds data to be encrypted or decrypted.
		         *
		         * @param {WordArray|string} dataUpdate The data to encrypt or decrypt.
		         *
		         * @return {WordArray} The data after processing.
		         *
		         * @example
		         *
		         *     var encrypted = cipher.process('data');
		         *     var encrypted = cipher.process(wordArray);
		         */
		        process: function (dataUpdate) {
		            // Append
		            this._append(dataUpdate);
	
		            // Process available blocks
		            return this._process();
		        },
	
		        /**
		         * Finalizes the encryption or decryption process.
		         * Note that the finalize operation is effectively a destructive, read-once operation.
		         *
		         * @param {WordArray|string} dataUpdate The final data to encrypt or decrypt.
		         *
		         * @return {WordArray} The data after final processing.
		         *
		         * @example
		         *
		         *     var encrypted = cipher.finalize();
		         *     var encrypted = cipher.finalize('data');
		         *     var encrypted = cipher.finalize(wordArray);
		         */
		        finalize: function (dataUpdate) {
		            // Final data update
		            if (dataUpdate) {
		                this._append(dataUpdate);
		            }
	
		            // Perform concrete-cipher logic
		            var finalProcessedData = this._doFinalize();
	
		            return finalProcessedData;
		        },
	
		        keySize: 128/32,
	
		        ivSize: 128/32,
	
		        _ENC_XFORM_MODE: 1,
	
		        _DEC_XFORM_MODE: 2,
	
		        /**
		         * Creates shortcut functions to a cipher's object interface.
		         *
		         * @param {Cipher} cipher The cipher to create a helper for.
		         *
		         * @return {Object} An object with encrypt and decrypt shortcut functions.
		         *
		         * @static
		         *
		         * @example
		         *
		         *     var AES = CryptoJS.lib.Cipher._createHelper(CryptoJS.algo.AES);
		         */
		        _createHelper: (function () {
		            function selectCipherStrategy(key) {
		                if (typeof key == 'string') {
		                    return PasswordBasedCipher;
		                } else {
		                    return SerializableCipher;
		                }
		            }
	
		            return function (cipher) {
		                return {
		                    encrypt: function (message, key, cfg) {
		                        return selectCipherStrategy(key).encrypt(cipher, message, key, cfg);
		                    },
	
		                    decrypt: function (ciphertext, key, cfg) {
		                        return selectCipherStrategy(key).decrypt(cipher, ciphertext, key, cfg);
		                    }
		                };
		            };
		        }())
		    });
	
		    /**
		     * Abstract base stream cipher template.
		     *
		     * @property {number} blockSize The number of 32-bit words this cipher operates on. Default: 1 (32 bits)
		     */
		    var StreamCipher = C_lib.StreamCipher = Cipher.extend({
		        _doFinalize: function () {
		            // Process partial blocks
		            var finalProcessedBlocks = this._process(!!'flush');
	
		            return finalProcessedBlocks;
		        },
	
		        blockSize: 1
		    });
	
		    /**
		     * Mode namespace.
		     */
		    var C_mode = C.mode = {};
	
		    /**
		     * Abstract base block cipher mode template.
		     */
		    var BlockCipherMode = C_lib.BlockCipherMode = Base.extend({
		        /**
		         * Creates this mode for encryption.
		         *
		         * @param {Cipher} cipher A block cipher instance.
		         * @param {Array} iv The IV words.
		         *
		         * @static
		         *
		         * @example
		         *
		         *     var mode = CryptoJS.mode.CBC.createEncryptor(cipher, iv.words);
		         */
		        createEncryptor: function (cipher, iv) {
		            return this.Encryptor.create(cipher, iv);
		        },
	
		        /**
		         * Creates this mode for decryption.
		         *
		         * @param {Cipher} cipher A block cipher instance.
		         * @param {Array} iv The IV words.
		         *
		         * @static
		         *
		         * @example
		         *
		         *     var mode = CryptoJS.mode.CBC.createDecryptor(cipher, iv.words);
		         */
		        createDecryptor: function (cipher, iv) {
		            return this.Decryptor.create(cipher, iv);
		        },
	
		        /**
		         * Initializes a newly created mode.
		         *
		         * @param {Cipher} cipher A block cipher instance.
		         * @param {Array} iv The IV words.
		         *
		         * @example
		         *
		         *     var mode = CryptoJS.mode.CBC.Encryptor.create(cipher, iv.words);
		         */
		        init: function (cipher, iv) {
		            this._cipher = cipher;
		            this._iv = iv;
		        }
		    });
	
		    /**
		     * Cipher Block Chaining mode.
		     */
		    var CBC = C_mode.CBC = (function () {
		        /**
		         * Abstract base CBC mode.
		         */
		        var CBC = BlockCipherMode.extend();
	
		        /**
		         * CBC encryptor.
		         */
		        CBC.Encryptor = CBC.extend({
		            /**
		             * Processes the data block at offset.
		             *
		             * @param {Array} words The data words to operate on.
		             * @param {number} offset The offset where the block starts.
		             *
		             * @example
		             *
		             *     mode.processBlock(data.words, offset);
		             */
		            processBlock: function (words, offset) {
		                // Shortcuts
		                var cipher = this._cipher;
		                var blockSize = cipher.blockSize;
	
		                // XOR and encrypt
		                xorBlock.call(this, words, offset, blockSize);
		                cipher.encryptBlock(words, offset);
	
		                // Remember this block to use with next block
		                this._prevBlock = words.slice(offset, offset + blockSize);
		            }
		        });
	
		        /**
		         * CBC decryptor.
		         */
		        CBC.Decryptor = CBC.extend({
		            /**
		             * Processes the data block at offset.
		             *
		             * @param {Array} words The data words to operate on.
		             * @param {number} offset The offset where the block starts.
		             *
		             * @example
		             *
		             *     mode.processBlock(data.words, offset);
		             */
		            processBlock: function (words, offset) {
		                // Shortcuts
		                var cipher = this._cipher;
		                var blockSize = cipher.blockSize;
	
		                // Remember this block to use with next block
		                var thisBlock = words.slice(offset, offset + blockSize);
	
		                // Decrypt and XOR
		                cipher.decryptBlock(words, offset);
		                xorBlock.call(this, words, offset, blockSize);
	
		                // This block becomes the previous block
		                this._prevBlock = thisBlock;
		            }
		        });
	
		        function xorBlock(words, offset, blockSize) {
		            // Shortcut
		            var iv = this._iv;
	
		            // Choose mixing block
		            if (iv) {
		                var block = iv;
	
		                // Remove IV for subsequent blocks
		                this._iv = undefined;
		            } else {
		                var block = this._prevBlock;
		            }
	
		            // XOR blocks
		            for (var i = 0; i < blockSize; i++) {
		                words[offset + i] ^= block[i];
		            }
		        }
	
		        return CBC;
		    }());
	
		    /**
		     * Padding namespace.
		     */
		    var C_pad = C.pad = {};
	
		    /**
		     * PKCS #5/7 padding strategy.
		     */
		    var Pkcs7 = C_pad.Pkcs7 = {
		        /**
		         * Pads data using the algorithm defined in PKCS #5/7.
		         *
		         * @param {WordArray} data The data to pad.
		         * @param {number} blockSize The multiple that the data should be padded to.
		         *
		         * @static
		         *
		         * @example
		         *
		         *     CryptoJS.pad.Pkcs7.pad(wordArray, 4);
		         */
		        pad: function (data, blockSize) {
		            // Shortcut
		            var blockSizeBytes = blockSize * 4;
	
		            // Count padding bytes
		            var nPaddingBytes = blockSizeBytes - data.sigBytes % blockSizeBytes;
	
		            // Create padding word
		            var paddingWord = (nPaddingBytes << 24) | (nPaddingBytes << 16) | (nPaddingBytes << 8) | nPaddingBytes;
	
		            // Create padding
		            var paddingWords = [];
		            for (var i = 0; i < nPaddingBytes; i += 4) {
		                paddingWords.push(paddingWord);
		            }
		            var padding = WordArray.create(paddingWords, nPaddingBytes);
	
		            // Add padding
		            data.concat(padding);
		        },
	
		        /**
		         * Unpads data that had been padded using the algorithm defined in PKCS #5/7.
		         *
		         * @param {WordArray} data The data to unpad.
		         *
		         * @static
		         *
		         * @example
		         *
		         *     CryptoJS.pad.Pkcs7.unpad(wordArray);
		         */
		        unpad: function (data) {
		            // Get number of padding bytes from last byte
		            var nPaddingBytes = data.words[(data.sigBytes - 1) >>> 2] & 0xff;
	
		            // Remove padding
		            data.sigBytes -= nPaddingBytes;
		        }
		    };
	
		    /**
		     * Abstract base block cipher template.
		     *
		     * @property {number} blockSize The number of 32-bit words this cipher operates on. Default: 4 (128 bits)
		     */
		    var BlockCipher = C_lib.BlockCipher = Cipher.extend({
		        /**
		         * Configuration options.
		         *
		         * @property {Mode} mode The block mode to use. Default: CBC
		         * @property {Padding} padding The padding strategy to use. Default: Pkcs7
		         */
		        cfg: Cipher.cfg.extend({
		            mode: CBC,
		            padding: Pkcs7
		        }),
	
		        reset: function () {
		            // Reset cipher
		            Cipher.reset.call(this);
	
		            // Shortcuts
		            var cfg = this.cfg;
		            var iv = cfg.iv;
		            var mode = cfg.mode;
	
		            // Reset block mode
		            if (this._xformMode == this._ENC_XFORM_MODE) {
		                var modeCreator = mode.createEncryptor;
		            } else /* if (this._xformMode == this._DEC_XFORM_MODE) */ {
		                var modeCreator = mode.createDecryptor;
		                // Keep at least one block in the buffer for unpadding
		                this._minBufferSize = 1;
		            }
	
		            if (this._mode && this._mode.__creator == modeCreator) {
		                this._mode.init(this, iv && iv.words);
		            } else {
		                this._mode = modeCreator.call(mode, this, iv && iv.words);
		                this._mode.__creator = modeCreator;
		            }
		        },
	
		        _doProcessBlock: function (words, offset) {
		            this._mode.processBlock(words, offset);
		        },
	
		        _doFinalize: function () {
		            // Shortcut
		            var padding = this.cfg.padding;
	
		            // Finalize
		            if (this._xformMode == this._ENC_XFORM_MODE) {
		                // Pad data
		                padding.pad(this._data, this.blockSize);
	
		                // Process final blocks
		                var finalProcessedBlocks = this._process(!!'flush');
		            } else /* if (this._xformMode == this._DEC_XFORM_MODE) */ {
		                // Process final blocks
		                var finalProcessedBlocks = this._process(!!'flush');
	
		                // Unpad data
		                padding.unpad(finalProcessedBlocks);
		            }
	
		            return finalProcessedBlocks;
		        },
	
		        blockSize: 128/32
		    });
	
		    /**
		     * A collection of cipher parameters.
		     *
		     * @property {WordArray} ciphertext The raw ciphertext.
		     * @property {WordArray} key The key to this ciphertext.
		     * @property {WordArray} iv The IV used in the ciphering operation.
		     * @property {WordArray} salt The salt used with a key derivation function.
		     * @property {Cipher} algorithm The cipher algorithm.
		     * @property {Mode} mode The block mode used in the ciphering operation.
		     * @property {Padding} padding The padding scheme used in the ciphering operation.
		     * @property {number} blockSize The block size of the cipher.
		     * @property {Format} formatter The default formatting strategy to convert this cipher params object to a string.
		     */
		    var CipherParams = C_lib.CipherParams = Base.extend({
		        /**
		         * Initializes a newly created cipher params object.
		         *
		         * @param {Object} cipherParams An object with any of the possible cipher parameters.
		         *
		         * @example
		         *
		         *     var cipherParams = CryptoJS.lib.CipherParams.create({
		         *         ciphertext: ciphertextWordArray,
		         *         key: keyWordArray,
		         *         iv: ivWordArray,
		         *         salt: saltWordArray,
		         *         algorithm: CryptoJS.algo.AES,
		         *         mode: CryptoJS.mode.CBC,
		         *         padding: CryptoJS.pad.PKCS7,
		         *         blockSize: 4,
		         *         formatter: CryptoJS.format.OpenSSL
		         *     });
		         */
		        init: function (cipherParams) {
		            this.mixIn(cipherParams);
		        },
	
		        /**
		         * Converts this cipher params object to a string.
		         *
		         * @param {Format} formatter (Optional) The formatting strategy to use.
		         *
		         * @return {string} The stringified cipher params.
		         *
		         * @throws Error If neither the formatter nor the default formatter is set.
		         *
		         * @example
		         *
		         *     var string = cipherParams + '';
		         *     var string = cipherParams.toString();
		         *     var string = cipherParams.toString(CryptoJS.format.OpenSSL);
		         */
		        toString: function (formatter) {
		            return (formatter || this.formatter).stringify(this);
		        }
		    });
	
		    /**
		     * Format namespace.
		     */
		    var C_format = C.format = {};
	
		    /**
		     * OpenSSL formatting strategy.
		     */
		    var OpenSSLFormatter = C_format.OpenSSL = {
		        /**
		         * Converts a cipher params object to an OpenSSL-compatible string.
		         *
		         * @param {CipherParams} cipherParams The cipher params object.
		         *
		         * @return {string} The OpenSSL-compatible string.
		         *
		         * @static
		         *
		         * @example
		         *
		         *     var openSSLString = CryptoJS.format.OpenSSL.stringify(cipherParams);
		         */
		        stringify: function (cipherParams) {
		            // Shortcuts
		            var ciphertext = cipherParams.ciphertext;
		            var salt = cipherParams.salt;
	
		            // Format
		            if (salt) {
		                var wordArray = WordArray.create([0x53616c74, 0x65645f5f]).concat(salt).concat(ciphertext);
		            } else {
		                var wordArray = ciphertext;
		            }
	
		            return wordArray.toString(Base64);
		        },
	
		        /**
		         * Converts an OpenSSL-compatible string to a cipher params object.
		         *
		         * @param {string} openSSLStr The OpenSSL-compatible string.
		         *
		         * @return {CipherParams} The cipher params object.
		         *
		         * @static
		         *
		         * @example
		         *
		         *     var cipherParams = CryptoJS.format.OpenSSL.parse(openSSLString);
		         */
		        parse: function (openSSLStr) {
		            // Parse base64
		            var ciphertext = Base64.parse(openSSLStr);
	
		            // Shortcut
		            var ciphertextWords = ciphertext.words;
	
		            // Test for salt
		            if (ciphertextWords[0] == 0x53616c74 && ciphertextWords[1] == 0x65645f5f) {
		                // Extract salt
		                var salt = WordArray.create(ciphertextWords.slice(2, 4));
	
		                // Remove salt from ciphertext
		                ciphertextWords.splice(0, 4);
		                ciphertext.sigBytes -= 16;
		            }
	
		            return CipherParams.create({ ciphertext: ciphertext, salt: salt });
		        }
		    };
	
		    /**
		     * A cipher wrapper that returns ciphertext as a serializable cipher params object.
		     */
		    var SerializableCipher = C_lib.SerializableCipher = Base.extend({
		        /**
		         * Configuration options.
		         *
		         * @property {Formatter} format The formatting strategy to convert cipher param objects to and from a string. Default: OpenSSL
		         */
		        cfg: Base.extend({
		            format: OpenSSLFormatter
		        }),
	
		        /**
		         * Encrypts a message.
		         *
		         * @param {Cipher} cipher The cipher algorithm to use.
		         * @param {WordArray|string} message The message to encrypt.
		         * @param {WordArray} key The key.
		         * @param {Object} cfg (Optional) The configuration options to use for this operation.
		         *
		         * @return {CipherParams} A cipher params object.
		         *
		         * @static
		         *
		         * @example
		         *
		         *     var ciphertextParams = CryptoJS.lib.SerializableCipher.encrypt(CryptoJS.algo.AES, message, key);
		         *     var ciphertextParams = CryptoJS.lib.SerializableCipher.encrypt(CryptoJS.algo.AES, message, key, { iv: iv });
		         *     var ciphertextParams = CryptoJS.lib.SerializableCipher.encrypt(CryptoJS.algo.AES, message, key, { iv: iv, format: CryptoJS.format.OpenSSL });
		         */
		        encrypt: function (cipher, message, key, cfg) {
		            // Apply config defaults
		            cfg = this.cfg.extend(cfg);
	
		            // Encrypt
		            var encryptor = cipher.createEncryptor(key, cfg);
		            var ciphertext = encryptor.finalize(message);
	
		            // Shortcut
		            var cipherCfg = encryptor.cfg;
	
		            // Create and return serializable cipher params
		            return CipherParams.create({
		                ciphertext: ciphertext,
		                key: key,
		                iv: cipherCfg.iv,
		                algorithm: cipher,
		                mode: cipherCfg.mode,
		                padding: cipherCfg.padding,
		                blockSize: cipher.blockSize,
		                formatter: cfg.format
		            });
		        },
	
		        /**
		         * Decrypts serialized ciphertext.
		         *
		         * @param {Cipher} cipher The cipher algorithm to use.
		         * @param {CipherParams|string} ciphertext The ciphertext to decrypt.
		         * @param {WordArray} key The key.
		         * @param {Object} cfg (Optional) The configuration options to use for this operation.
		         *
		         * @return {WordArray} The plaintext.
		         *
		         * @static
		         *
		         * @example
		         *
		         *     var plaintext = CryptoJS.lib.SerializableCipher.decrypt(CryptoJS.algo.AES, formattedCiphertext, key, { iv: iv, format: CryptoJS.format.OpenSSL });
		         *     var plaintext = CryptoJS.lib.SerializableCipher.decrypt(CryptoJS.algo.AES, ciphertextParams, key, { iv: iv, format: CryptoJS.format.OpenSSL });
		         */
		        decrypt: function (cipher, ciphertext, key, cfg) {
		            // Apply config defaults
		            cfg = this.cfg.extend(cfg);
	
		            // Convert string to CipherParams
		            ciphertext = this._parse(ciphertext, cfg.format);
	
		            // Decrypt
		            var plaintext = cipher.createDecryptor(key, cfg).finalize(ciphertext.ciphertext);
	
		            return plaintext;
		        },
	
		        /**
		         * Converts serialized ciphertext to CipherParams,
		         * else assumed CipherParams already and returns ciphertext unchanged.
		         *
		         * @param {CipherParams|string} ciphertext The ciphertext.
		         * @param {Formatter} format The formatting strategy to use to parse serialized ciphertext.
		         *
		         * @return {CipherParams} The unserialized ciphertext.
		         *
		         * @static
		         *
		         * @example
		         *
		         *     var ciphertextParams = CryptoJS.lib.SerializableCipher._parse(ciphertextStringOrParams, format);
		         */
		        _parse: function (ciphertext, format) {
		            if (typeof ciphertext == 'string') {
		                return format.parse(ciphertext, this);
		            } else {
		                return ciphertext;
		            }
		        }
		    });
	
		    /**
		     * Key derivation function namespace.
		     */
		    var C_kdf = C.kdf = {};
	
		    /**
		     * OpenSSL key derivation function.
		     */
		    var OpenSSLKdf = C_kdf.OpenSSL = {
		        /**
		         * Derives a key and IV from a password.
		         *
		         * @param {string} password The password to derive from.
		         * @param {number} keySize The size in words of the key to generate.
		         * @param {number} ivSize The size in words of the IV to generate.
		         * @param {WordArray|string} salt (Optional) A 64-bit salt to use. If omitted, a salt will be generated randomly.
		         *
		         * @return {CipherParams} A cipher params object with the key, IV, and salt.
		         *
		         * @static
		         *
		         * @example
		         *
		         *     var derivedParams = CryptoJS.kdf.OpenSSL.execute('Password', 256/32, 128/32);
		         *     var derivedParams = CryptoJS.kdf.OpenSSL.execute('Password', 256/32, 128/32, 'saltsalt');
		         */
		        execute: function (password, keySize, ivSize, salt) {
		            // Generate random salt
		            if (!salt) {
		                salt = WordArray.random(64/8);
		            }
	
		            // Derive key and IV
		            var key = EvpKDF.create({ keySize: keySize + ivSize }).compute(password, salt);
	
		            // Separate key and IV
		            var iv = WordArray.create(key.words.slice(keySize), ivSize * 4);
		            key.sigBytes = keySize * 4;
	
		            // Return params
		            return CipherParams.create({ key: key, iv: iv, salt: salt });
		        }
		    };
	
		    /**
		     * A serializable cipher wrapper that derives the key from a password,
		     * and returns ciphertext as a serializable cipher params object.
		     */
		    var PasswordBasedCipher = C_lib.PasswordBasedCipher = SerializableCipher.extend({
		        /**
		         * Configuration options.
		         *
		         * @property {KDF} kdf The key derivation function to use to generate a key and IV from a password. Default: OpenSSL
		         */
		        cfg: SerializableCipher.cfg.extend({
		            kdf: OpenSSLKdf
		        }),
	
		        /**
		         * Encrypts a message using a password.
		         *
		         * @param {Cipher} cipher The cipher algorithm to use.
		         * @param {WordArray|string} message The message to encrypt.
		         * @param {string} password The password.
		         * @param {Object} cfg (Optional) The configuration options to use for this operation.
		         *
		         * @return {CipherParams} A cipher params object.
		         *
		         * @static
		         *
		         * @example
		         *
		         *     var ciphertextParams = CryptoJS.lib.PasswordBasedCipher.encrypt(CryptoJS.algo.AES, message, 'password');
		         *     var ciphertextParams = CryptoJS.lib.PasswordBasedCipher.encrypt(CryptoJS.algo.AES, message, 'password', { format: CryptoJS.format.OpenSSL });
		         */
		        encrypt: function (cipher, message, password, cfg) {
		            // Apply config defaults
		            cfg = this.cfg.extend(cfg);
	
		            // Derive key and other params
		            var derivedParams = cfg.kdf.execute(password, cipher.keySize, cipher.ivSize);
	
		            // Add IV to config
		            cfg.iv = derivedParams.iv;
	
		            // Encrypt
		            var ciphertext = SerializableCipher.encrypt.call(this, cipher, message, derivedParams.key, cfg);
	
		            // Mix in derived params
		            ciphertext.mixIn(derivedParams);
	
		            return ciphertext;
		        },
	
		        /**
		         * Decrypts serialized ciphertext using a password.
		         *
		         * @param {Cipher} cipher The cipher algorithm to use.
		         * @param {CipherParams|string} ciphertext The ciphertext to decrypt.
		         * @param {string} password The password.
		         * @param {Object} cfg (Optional) The configuration options to use for this operation.
		         *
		         * @return {WordArray} The plaintext.
		         *
		         * @static
		         *
		         * @example
		         *
		         *     var plaintext = CryptoJS.lib.PasswordBasedCipher.decrypt(CryptoJS.algo.AES, formattedCiphertext, 'password', { format: CryptoJS.format.OpenSSL });
		         *     var plaintext = CryptoJS.lib.PasswordBasedCipher.decrypt(CryptoJS.algo.AES, ciphertextParams, 'password', { format: CryptoJS.format.OpenSSL });
		         */
		        decrypt: function (cipher, ciphertext, password, cfg) {
		            // Apply config defaults
		            cfg = this.cfg.extend(cfg);
	
		            // Convert string to CipherParams
		            ciphertext = this._parse(ciphertext, cfg.format);
	
		            // Derive key and other params
		            var derivedParams = cfg.kdf.execute(password, cipher.keySize, cipher.ivSize, ciphertext.salt);
	
		            // Add IV to config
		            cfg.iv = derivedParams.iv;
	
		            // Decrypt
		            var plaintext = SerializableCipher.decrypt.call(this, cipher, ciphertext, derivedParams.key, cfg);
	
		            return plaintext;
		        }
		    });
		}());
	
	
	}));

/***/ },
/* 45 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.createMemoryHistory = exports.hashHistory = exports.browserHistory = exports.applyRouterMiddleware = exports.formatPattern = exports.useRouterHistory = exports.match = exports.routerShape = exports.locationShape = exports.RouterContext = exports.createRoutes = exports.Route = exports.Redirect = exports.IndexRoute = exports.IndexRedirect = exports.withRouter = exports.IndexLink = exports.Link = exports.Router = undefined;
	
	var _RouteUtils = __webpack_require__(100);
	
	Object.defineProperty(exports, 'createRoutes', {
	  enumerable: true,
	  get: function get() {
	    return _RouteUtils.createRoutes;
	  }
	});
	
	var _PropTypes = __webpack_require__(269);
	
	Object.defineProperty(exports, 'locationShape', {
	  enumerable: true,
	  get: function get() {
	    return _PropTypes.locationShape;
	  }
	});
	Object.defineProperty(exports, 'routerShape', {
	  enumerable: true,
	  get: function get() {
	    return _PropTypes.routerShape;
	  }
	});
	
	var _PatternUtils = __webpack_require__(129);
	
	Object.defineProperty(exports, 'formatPattern', {
	  enumerable: true,
	  get: function get() {
	    return _PatternUtils.formatPattern;
	  }
	});
	
	var _Router2 = __webpack_require__(1050);
	
	var _Router3 = _interopRequireDefault(_Router2);
	
	var _Link2 = __webpack_require__(418);
	
	var _Link3 = _interopRequireDefault(_Link2);
	
	var _IndexLink2 = __webpack_require__(1046);
	
	var _IndexLink3 = _interopRequireDefault(_IndexLink2);
	
	var _withRouter2 = __webpack_require__(1061);
	
	var _withRouter3 = _interopRequireDefault(_withRouter2);
	
	var _IndexRedirect2 = __webpack_require__(1047);
	
	var _IndexRedirect3 = _interopRequireDefault(_IndexRedirect2);
	
	var _IndexRoute2 = __webpack_require__(1048);
	
	var _IndexRoute3 = _interopRequireDefault(_IndexRoute2);
	
	var _Redirect2 = __webpack_require__(420);
	
	var _Redirect3 = _interopRequireDefault(_Redirect2);
	
	var _Route2 = __webpack_require__(1049);
	
	var _Route3 = _interopRequireDefault(_Route2);
	
	var _RouterContext2 = __webpack_require__(270);
	
	var _RouterContext3 = _interopRequireDefault(_RouterContext2);
	
	var _match2 = __webpack_require__(1059);
	
	var _match3 = _interopRequireDefault(_match2);
	
	var _useRouterHistory2 = __webpack_require__(425);
	
	var _useRouterHistory3 = _interopRequireDefault(_useRouterHistory2);
	
	var _applyRouterMiddleware2 = __webpack_require__(1052);
	
	var _applyRouterMiddleware3 = _interopRequireDefault(_applyRouterMiddleware2);
	
	var _browserHistory2 = __webpack_require__(1053);
	
	var _browserHistory3 = _interopRequireDefault(_browserHistory2);
	
	var _hashHistory2 = __webpack_require__(1057);
	
	var _hashHistory3 = _interopRequireDefault(_hashHistory2);
	
	var _createMemoryHistory2 = __webpack_require__(422);
	
	var _createMemoryHistory3 = _interopRequireDefault(_createMemoryHistory2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.Router = _Router3.default; /* components */
	
	exports.Link = _Link3.default;
	exports.IndexLink = _IndexLink3.default;
	exports.withRouter = _withRouter3.default;
	
	/* components (configuration) */
	
	exports.IndexRedirect = _IndexRedirect3.default;
	exports.IndexRoute = _IndexRoute3.default;
	exports.Redirect = _Redirect3.default;
	exports.Route = _Route3.default;
	
	/* utils */
	
	exports.RouterContext = _RouterContext3.default;
	exports.match = _match3.default;
	exports.useRouterHistory = _useRouterHistory3.default;
	exports.applyRouterMiddleware = _applyRouterMiddleware3.default;
	
	/* histories */
	
	exports.browserHistory = _browserHistory3.default;
	exports.hashHistory = _hashHistory3.default;
	exports.createMemoryHistory = _createMemoryHistory3.default;

/***/ },
/* 46 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';
	
	/**
	 * Use invariant() to assert state which your program assumes to be true.
	 *
	 * Provide sprintf-style format (only %s is supported) and arguments
	 * to provide information about what broke and what you were
	 * expecting.
	 *
	 * The invariant message will be stripped in production, but the invariant
	 * will remain to ensure logic does not differ in production.
	 */
	
	var invariant = function(condition, format, a, b, c, d, e, f) {
	  if (false) {
	    if (format === undefined) {
	      throw new Error('invariant requires an error message argument');
	    }
	  }
	
	  if (!condition) {
	    var error;
	    if (format === undefined) {
	      error = new Error(
	        'Minified exception occurred; use the non-minified dev environment ' +
	        'for the full error message and additional helpful warnings.'
	      );
	    } else {
	      var args = [a, b, c, d, e, f];
	      var argIndex = 0;
	      error = new Error(
	        format.replace(/%s/g, function() { return args[argIndex++]; })
	      );
	      error.name = 'Invariant Violation';
	    }
	
	    error.framesToPop = 1; // we don't care about invariant's own frame
	    throw error;
	  }
	};
	
	module.exports = invariant;


/***/ },
/* 47 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(5);
	
	var _redux = __webpack_require__(4);
	
	var _Badge = __webpack_require__(135);
	
	var _Badge2 = _interopRequireDefault(_Badge);
	
	var _appDataActions = __webpack_require__(12);
	
	var appDataActions = _interopRequireWildcard(_appDataActions);
	
	var _userDataActions = __webpack_require__(20);
	
	var userDataActions = _interopRequireWildcard(_userDataActions);
	
	var _trackingDataActions = __webpack_require__(7);
	
	var trackingDataActions = _interopRequireWildcard(_trackingDataActions);
	
	var _localStorage = __webpack_require__(17);
	
	var localStorage = _interopRequireWildcard(_localStorage);
	
	var _appConstants = __webpack_require__(13);
	
	var appConstants = _interopRequireWildcard(_appConstants);
	
	var _objectConstants = __webpack_require__(9);
	
	var objectConstants = _interopRequireWildcard(_objectConstants);
	
	var _appHelper = __webpack_require__(3);
	
	var appHelper = _interopRequireWildcard(_appHelper);
	
	var _userDataHelper = __webpack_require__(15);
	
	var userDataHelper = _interopRequireWildcard(_userDataHelper);
	
	var _Button = __webpack_require__(18);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _gsap = __webpack_require__(8);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } //eslint-disable-line import/no-named-as-default
	
	
	var BadgeCollect = function (_React$Component) {
	    _inherits(BadgeCollect, _React$Component);
	
	    function BadgeCollect(props, context) {
	        _classCallCheck(this, BadgeCollect);
	
	        var _this = _possibleConstructorReturn(this, (BadgeCollect.__proto__ || Object.getPrototypeOf(BadgeCollect)).call(this, props, context));
	
	        _this.state = {
	            lang: _this.props.lang,
	            userData: _this.props.userData,
	            badge_id: _this.props.badge_id,
	            badge: _this.props.badge,
	            userBadge: _this.props.userBadge,
	            showAchievedCount: false,
	            showAchievedState: true,
	            collected: appHelper.isDefined(_this.props.collected) ? _this.props.collected : false,
	            locale: {},
	            checkBagdeCollected: false,
	            collect_label: appHelper.getLocaleString("collect_label")
	        };
	        _this.show = _this.show.bind(_this);
	        _this.getLocale = _this.getLocale.bind(_this);
	        _this.collect = _this.collect.bind(_this);
	        _this.checkCollected = _this.checkCollected.bind(_this);
	        _this.handleProgression = _this.handleProgression.bind(_this);
	        return _this;
	    }
	
	    _createClass(BadgeCollect, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            this.checkCollected();
	            this.getLocale();
	            if (appHelper.isDefined(this.props.animate) && this.props.animate) {
	                this.show();
	            }
	        }
	    }, {
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(nextProps) {
	
	            if (this.state.userData !== nextProps.userData) {
	                this.setState({ userData: Object.assign({}, nextProps.userData), checkBagdeCollected: true });
	            }
	
	            if (this.state.userBadge !== nextProps.userBadge) {
	                this.setState({ userBadge: Object.assign({}, nextProps.userBadge) });
	            }
	            if (appHelper.isDefined(nextProps.collected) && this.state.collected !== nextProps.collected) {
	                this.setState({ collected: nextProps.collected });
	            }
	            if (this.state.lang !== nextProps.lang) {
	                this.setState({
	                    lang: nextProps.lang,
	                    locale: appHelper.getLocalData(this.state.badge),
	                    collect_label: appHelper.getLocaleString("collect_label")
	                });
	            }
	        }
	    }, {
	        key: 'componentDidUpdate',
	        value: function componentDidUpdate() {
	            if (this.state.checkBagdeCollected && !this.state.collected) {
	                this.checkCollected();
	            }
	        }
	    }, {
	        key: 'getLocale',
	        value: function getLocale() {
	            var locale = appHelper.getLocalData(this.state.badge);
	            this.setState({ locale: Object.assign({}, locale) });
	        }
	    }, {
	        key: 'checkCollected',
	        value: function checkCollected() {
	            this.setState({ checkBagdeCollected: false });
	            var params = {
	                bite_id: this.props.bite_id,
	                asset_id: this.props.asset_id
	            };
	            var badgesCollected = userDataHelper.checkBadgeEarnedOnObject(this.state.userData, params);
	            var collectedIndex = appHelper.getArrayObjectIndexByKey(badgesCollected, "badge_id", this.state.badge.badge_id);
	            if (collectedIndex > -1) {
	                this.setState({ collected: true });
	                if (appHelper.isDefined(this.props.onCollected)) {
	                    this.props.onCollected();
	                }
	            }
	        }
	    }, {
	        key: 'collect',
	        value: function collect(event) {
	            var _this2 = this;
	
	            event.stopPropagation();
	            this.setState({ collected: true });
	
	            var params = {
	                badge: this.state.badge,
	                bite_id: this.props.bite_id,
	                asset_id: this.props.asset_id
	            };
	            this.props.actions.collectBadge(params).then(function (userData) {
	                _this2.props.actions.setSuspendData(userData).then(function (trackingData) {
	                    if (localStorage.tracking_type === appConstants.TRACKING_TYPE_XAPI || localStorage.tracking_type === appConstants.TRACKING_TYPE_BLENDED_XAPI_SCORM_1_2) {
	                        _this2.props.actions.setBadgeStatement(_this2.state.badge).then(function (statement) {
	                            _this2.props.onCollected();
	                        }).catch(function (error) {
	                            _this2.props.onCollected();
	                        });
	                    } else {
	                        _this2.props.onCollected();
	                    }
	                }).catch(function (error) {});
	            }).catch(function (error) {});
	        }
	    }, {
	        key: 'handleProgression',
	        value: function handleProgression() {}
	    }, {
	        key: 'show',
	        value: function show() {
	            var collectRef = this.refs['badgeCollect_' + this.state.badge_id];
	            if (appHelper.isDefined(collectRef)) {
	                _gsap.TweenLite.set(collectRef, { height: "auto" });
	                _gsap.TweenLite.from(collectRef, objectConstants.SHOW_PANEL_DURATION, {
	                    height: 0,
	                    ease: _gsap.Expo.easeInOut
	                });
	            }
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            return _react2.default.createElement(
	                'div',
	                { className: 'kpi-overview-panel badge-badge-collection', ref: 'badgeCollect_' + this.state.badge_id },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'kpi-overview-row', ref: 'badge_' + this.state.badge_id },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'kpi-meter-col' },
	                        _react2.default.createElement(_Badge2.default, { badge: this.state.badge,
	                            userBadge: this.state.userBadge,
	                            showAchievedCount: this.state.showAchievedCount,
	                            showAchievedState: this.state.showAchievedState })
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'kpi-content-col' },
	                        _react2.default.createElement(
	                            'h4',
	                            null,
	                            _react2.default.createElement(
	                                'strong',
	                                null,
	                                this.state.locale.long_title
	                            )
	                        ),
	                        _react2.default.createElement('div', { dangerouslySetInnerHTML: { __html: this.state.locale.collection_statement } }),
	                        !this.state.collected ? _react2.default.createElement(
	                            'div',
	                            { className: 'text-center' },
	                            _react2.default.createElement(_Button2.default, { label: this.state.collect_label,
	                                id: this.state.badge_id + '_button',
	                                onClick: this.collect })
	                        ) : null
	                    )
	                )
	            );
	        }
	    }]);
	
	    return BadgeCollect;
	}(_react2.default.Component);
	
	/*OLD
	* <div className="badge-collection-panel" ref={`badge_${this.state.badge_id}`}>
	                <div className="collect-left-col">
	                    <Badge badge={this.state.badge}
	                           userBadge={this.state.userBadge}
	                           showAchievedCount={this.state.showAchievedCount}
	                           showAchievedState={this.state.showAchievedState}/>
	                </div>
	                <div className="collect-right-col">
	                    <div><strong>{this.state.locale.long_title}</strong></div>
	                    <div dangerouslySetInnerHTML={{__html: this.state.locale.collection_statement}}/>
	                </div>
	                {!this.state.collected
	                    ?
	                    <div className="collect-full-col">
	                        <div className="text-center">
	                            <Button label="Collect"
	                                    id={`${this.state.badge_id}_button`}
	                                    onClick={this.collect} />
	                        </div>
	                    </div>
	                    :null
	                }
	            </div>
	* */
	
	BadgeCollect.propTypes = {
	    badge_id: _propTypes2.default.number.isRequired,
	    onCollected: _propTypes2.default.func,
	    bite_id: _propTypes2.default.number,
	    asset_id: _propTypes2.default.number,
	    userBadge: _propTypes2.default.object,
	    collected: _propTypes2.default.bool,
	    badge: _propTypes2.default.object,
	    animate: _propTypes2.default.bool,
	    lang: _propTypes2.default.string.isRequired,
	    userData: _propTypes2.default.object.isRequired,
	    actions: _propTypes2.default.object.isRequired
	};
	
	BadgeCollect.contextTypes = {
	    router: _propTypes2.default.object
	};
	
	function mapStateToProps(state, ownProps) {
	    var badges = appHelper.getArrayObjectByKey(localStorage.bites, "bite_id", ownProps.bite_id).badges;
	    var badgeUserData = appHelper.getArrayObjectByKey(state.userData.bites, "bite_id", ownProps.bite_id).badges;
	    var lang = state.userData.lang;
	    return {
	        lang: lang,
	        userData: state.userData,
	        badge: appHelper.getArrayObjectByKey(badges, "badge_id", ownProps.badge_id),
	        userBadge: appHelper.getArrayObjectByKey(badgeUserData, "badge_id", ownProps.badge_id)
	
	    };
	}
	
	function mapDispatchToProps(dispatch) {
	    return {
	        actions: (0, _redux.bindActionCreators)(Object.assign({}, userDataActions, trackingDataActions, appDataActions), dispatch)
	    };
	}
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(BadgeCollect);

/***/ },
/* 48 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(5);
	
	var _redux = __webpack_require__(4);
	
	var _Button = __webpack_require__(18);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _appDataActions = __webpack_require__(12);
	
	var appDataActions = _interopRequireWildcard(_appDataActions);
	
	var _trackingDataActions = __webpack_require__(7);
	
	var trackingDataActions = _interopRequireWildcard(_trackingDataActions);
	
	var _appHelper = __webpack_require__(3);
	
	var appHelper = _interopRequireWildcard(_appHelper);
	
	var _dataHelper = __webpack_require__(11);
	
	var dataHelper = _interopRequireWildcard(_dataHelper);
	
	var _userDataHelper = __webpack_require__(15);
	
	var userDataHelper = _interopRequireWildcard(_userDataHelper);
	
	var _objectConstants = __webpack_require__(9);
	
	var objectConstants = _interopRequireWildcard(_objectConstants);
	
	var _componentHelper = __webpack_require__(31);
	
	var _gsap = __webpack_require__(8);
	
	var _gsapReactPlugin = __webpack_require__(10);
	
	var _gsapReactPlugin2 = _interopRequireDefault(_gsapReactPlugin);
	
	var _lodash = __webpack_require__(28);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } //eslint-disable-line import/no-named-as-default
	
	
	var Text = function (_React$Component) {
	    _inherits(Text, _React$Component);
	
	    function Text(props, context) {
	        _classCallCheck(this, Text);
	
	        var _this = _possibleConstructorReturn(this, (Text.__proto__ || Object.getPrototypeOf(Text)).call(this, props, context));
	
	        _this.state = {
	            lang: _this.props.lang,
	            resources: _this.props.resources,
	            resourceLinks: [],
	            userData: _this.props.userData,
	            initialised: false,
	            checkResourcesComplete: false
	        };
	
	        _this.setResourceLinks = _this.setResourceLinks.bind(_this);
	        _this.onCheckResourcesComplete = _this.onCheckResourcesComplete.bind(_this);
	        _this.onResourceLinkComplete = _this.onResourceLinkComplete.bind(_this);
	        return _this;
	    }
	
	    _createClass(Text, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            this.setResourceLinks();
	        }
	    }, {
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(nextProps) {
	            if (this.state.userData !== nextProps.userData) {
	                this.setState({
	                    userData: Object.assign({}, nextProps.userData),
	                    checkResourcesComplete: true
	                });
	            }
	        }
	    }, {
	        key: 'componentDidUpdate',
	        value: function componentDidUpdate() {
	            if (this.state.checkResourcesComplete) {
	                this.onCheckResourcesComplete();
	            }
	        }
	    }, {
	        key: 'setResourceLinks',
	        value: function setResourceLinks() {
	
	            var resourceLinks = [];
	            _lodash2.default.forEach(this.state.resources, function (resource) {
	                var resourceLink = Object.assign({}, (0, _componentHelper.getResourceLinkComponentByType)(resource.object_type), {
	                    data: resource,
	                    isComplete: !resource.required
	                });
	                resourceLinks = dataHelper.immutablePush(resourceLinks, resourceLink);
	            });
	
	            this.setState({
	                resourceLinks: Object.assign([], resourceLinks),
	                checkResourcesComplete: true,
	                initialised: true
	            });
	        }
	    }, {
	        key: 'onCheckResourcesComplete',
	        value: function onCheckResourcesComplete() {
	            var completeResourceCount = 0;
	            var userData = this.state.userData;
	            this.setState({ checkResourcesComplete: false });
	            _lodash2.default.forEach(this.state.resourceLinks, function (resource) {
	                if (appHelper.isDefined(resource.data.asset_id)) {
	                    var objectUserData = userDataHelper.getAttachmentObjectUserData(userData, resource.data.asset_id);
	                    if (objectUserData.status === objectConstants.STATUS_COMPLETE || !resource.data.required) {
	                        completeResourceCount++;
	                    }
	                } else {
	                    var screenUserData = userDataHelper.getResourceScreenUserData(userData, resource.data.screen_id);
	                    if (screenUserData.status === objectConstants.STATUS_COMPLETE || !resource.data.required) {
	                        completeResourceCount++;
	                    }
	                }
	            });
	
	            if (completeResourceCount >= this.state.resourceLinks.length) {
	                //console.log(`onCheckResourcesComplete: ${completeResourceCount} complete`);
	                this.props.onResourcesComplete();
	            }
	        }
	    }, {
	        key: 'onResourceLinkComplete',
	        value: function onResourceLinkComplete(resourceLink) {
	            var updatedResource = {};
	            var updatedResourceIndex = {};
	
	            for (var i = 0; i < this.state.resourceLinks.length; i++) {
	                var resource = this.state.resourceLinks[i];
	                if (appHelper.isDefined(resourceLink.asset_id)) {
	                    if (resource.data.asset_id === resourceLink.asset_id) {
	                        updatedResource = Object.assign({}, resource, {
	                            isComplete: true
	                        });
	                        updatedResourceIndex = i;
	                        break;
	                    }
	                } else {
	                    if (resource.data.screen_id === resourceLink.screen_id && !appHelper.isDefined(resource.data.asset_id)) {
	                        updatedResource = Object.assign({}, resource, {
	                            isComplete: true
	                        });
	                        updatedResourceIndex = i;
	                        break;
	                    }
	                }
	            }
	
	            this.setState({
	                resourceLinks: dataHelper.immutableSplice(this.state.resourceLinks, updatedResourceIndex, 1, updatedResource),
	                checkResourcesComplete: true
	            });
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            return _react2.default.createElement(
	                'div',
	                null,
	                this.state.initialised ? _react2.default.createElement(
	                    'ul',
	                    { className: 'resource-links' },
	                    this.state.resourceLinks.map(function (resourceLink) {
	                        return _react2.default.createElement(resourceLink.component, { key: appHelper.isDefined(resourceLink.data.asset_id) ? resourceLink.data.asset_id : resourceLink.data.screen_id, resource: resourceLink.data });
	                    })
	                ) : null
	            );
	        }
	    }]);
	
	    return Text;
	}(_react2.default.Component);
	
	Text.propTypes = {
	    resources: _propTypes2.default.array.isRequired,
	    onResourcesComplete: _propTypes2.default.func,
	    trackingData: _propTypes2.default.object.isRequired,
	    userData: _propTypes2.default.object.isRequired,
	    lang: _propTypes2.default.string.isRequired,
	    actions: _propTypes2.default.object.isRequired
	};
	
	Text.contextTypes = {
	    router: _propTypes2.default.object
	};
	
	function mapStateToProps(state, ownProps) {
	    var lang = state.userData.lang;
	    return {
	        lang: lang,
	        contentData: state.contentData,
	        trackingData: state.trackingData,
	        userData: state.userData
	    };
	}
	
	function mapDispatchToProps(dispatch) {
	    return {
	        actions: (0, _redux.bindActionCreators)(Object.assign({}, appDataActions, trackingDataActions), dispatch)
	    };
	}
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(Text);

/***/ },
/* 49 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.SHORT_RESPONSE_LABEL = exports.SWIPE_HORIZONTAL_LABEL = exports.GRID_CHOICE_LABEL = exports.CONVERSATION_SINGLE_ANSWER_LABEL = exports.MULTIPLE_CHOICE_MULTIPLE_ANSWER_LABEL = exports.MULTIPLE_CHOICE_SINGLE_ANSWER_LABEL = exports.COMPONENT_RESOURCE_VIDEO_LINK = exports.RESOURCE_VIDEO_LINK = exports.COMPONENT_RESOURCE_URL_LINK = exports.RESOURCE_URL_LINK = exports.COMPONENT_RESOURCE_SCREEN_LINK = exports.RESOURCE_SCREEN_LINK = exports.COMPONENT_RESOURCE_IMAGE_LINK = exports.RESOURCE_IMAGE_LINK = exports.COMPONENT_RESOURCE_DOCUMENT_LINK = exports.RESOURCE_DOCUMENT_LINK = undefined;
	exports.COMPONENT_PRINT_RESPONSES = exports.PRINT_RESPONSES = exports.COMPONENT_SHORT_RESPONSE = exports.SHORT_RESPONSE = exports.COMPONENT_AWARD_BADGE = exports.AWARD_BADGE = exports.COMPONENT_BADGE_OVERVIEW = exports.BADGE_OVERVIEW = exports.COMPONENT_THE_END = exports.THE_END = exports.COMPONENT_KPI_RESULTS_LIST = exports.KPI_RESULTS_LIST = exports.COMPONENT_KPI_GRAPH_RESULTS = exports.KPI_GRAPH_RESULTS = exports.COMPONENT_LIBRARY_IMAGE = exports.LIBRARY_IMAGE = exports.COMPONENT_IMAGE = exports.IMAGE = exports.COMPONENT_DOCUMENT = exports.DOCUMENT = exports.COMPONENT_LINK = exports.LINK = exports.COMPONENT_SUB_MP4 = exports.MP4_SUB_VIDEO = exports.COMPONENT_SUB_YOUTUBE = exports.YOUTUBE_SUB_VIDEO = exports.COMPONENT_SUB_VIMEO_VIDEO = exports.VIMEO_SUB_VIDEO = exports.COMPONENT_MP4 = exports.MP4_VIDEO = exports.COMPONENT_YOUTUBE = exports.YOUTUBE_VIDEO = exports.COMPONENT_VIMEO_VIDEO = exports.VIMEO_VIDEO = exports.COMPONENT_VIDEO = exports.VIDEO = exports.COMPONENT_SWIPE_HORIZONTAL = exports.SWIPE_HORIZONTAL = exports.COMPONENT_GRID_SINGLE_ANSWER = exports.GRID_SINGLE_ANSWER = exports.COMPONENT_GRID_CHOICE = exports.GRID_CHOICE = exports.COMPONENT_CONVERSATION_MULTIPLE_ANSWER = exports.CONVERSATION_MULTIPLE_ANSWER = exports.COMPONENT_CONVERSATION_SINGLE_ANSWER = exports.CONVERSATION_SINGLE_ANSWER = exports.COMPONENT_CONVERSATION_CHOICE = exports.CONVERSATION_CHOICE = exports.COMPONENT_MULTIPLE_ANSWER = exports.MULTIPLE_ANSWER = exports.COMPONENT_SINGLE_ANSWER = exports.SINGLE_ANSWER = exports.COMPONENT_MULTIPLE_CHOICE = exports.MULTIPLE_CHOICE = exports.COMPONENT_KPI_OVERVIEW = exports.KPI_OVERVIEW = exports.COMPONENT_SCORE_INTRODUCTION = exports.SCORE_INTRODUCTION = exports.COMPONENT_TEXT = exports.TEXT = exports.COMPONENT_NARRATOR_SPEAK = exports.NARRATOR_SPEAK = exports.COMPONENT_LEARNER_SPEAK = exports.LEARNER_SPEAK = exports.COMPONENT_CHARACTER_SPEAK = exports.CHARACTER_SPEAK = exports.COMPONENT_CONVERSATION_DIALOG = exports.CONVERSATION_DIALOG = exports.COMPONENT_BADGE_DASHBOARD_OBJECT = exports.COMPONENT_KPI_DASHBOARD_OBJECT = exports.COMPONENT_TOOLTIP_OBJECT = exports.COMPONENT_VIDEO_MOBILE_SCREEN = exports.COMPONENT_ACCORDION_SCREEN = exports.SCREEN_TYPE_ACCORDION = exports.COMPONENT_RESOUCES_SCROLL_SCREEN = exports.COMPONENT_VIDEO_SCREEN = exports.SCREEN_TYPE_VIDEO = exports.COMPONENT_HOTSPOT_SCREEN = exports.SCREEN_TYPE_HOTSPOT = exports.COMPONENT_SLIDER_SCREEN = exports.SCREEN_TYPE_SLIDER = exports.COMPONENT_SCROLL_SCREEN = exports.SCREEN_TYPE_SCROLL = exports.COMPONENT_TABBED_SCREEN = exports.SCREEN_TYPE_TABBED = exports.COMPONENT_SCREEN_SUB_TYPE_TITLE_IMAGE_BASED = exports.SCREEN_SUB_TYPE_TITLE_IMAGE_BASED = exports.COMPONENT_SCREEN_SUB_TYPE_TITLE_STANDARD = exports.SCREEN_SUB_TYPE_TITLE_STANDARD = exports.COMPONENT_TITLE_SCREEN = exports.SCREEN_TYPE_TITLE = exports.COMPONENT_SCENARIO_SCREEN = exports.SCREEN_TYPE_SCENARIO = exports.COMPONENT_LEARNING_PLAN = exports.MENU_TYPE_PERSONAL_LEARNING_PLAN = exports.MENU_TYPE_FIRST_ANY_LAST_LEARNING_PLAN = exports.MENU_TYPE_OPEN_LEARNING_PLAN = exports.MENU_TYPE_LINEAR_LEARNING_PLAN = exports.COMPONENT_SCENARIO_BITE = exports.BITE_TYPE_SCENARIO = undefined;
	
	var _LearningPlanMenu = __webpack_require__(470);
	
	var _LearningPlanMenu2 = _interopRequireDefault(_LearningPlanMenu);
	
	var _ScenarioBite = __webpack_require__(444);
	
	var _ScenarioBite2 = _interopRequireDefault(_ScenarioBite);
	
	var _ScenarioScreen = __webpack_require__(541);
	
	var _ScenarioScreen2 = _interopRequireDefault(_ScenarioScreen);
	
	var _ScrollScreen = __webpack_require__(542);
	
	var _ScrollScreen2 = _interopRequireDefault(_ScrollScreen);
	
	var _TabbedScreen = __webpack_require__(548);
	
	var _TabbedScreen2 = _interopRequireDefault(_TabbedScreen);
	
	var _TitleScreen = __webpack_require__(549);
	
	var _TitleScreen2 = _interopRequireDefault(_TitleScreen);
	
	var _TitleScreenManager = __webpack_require__(551);
	
	var _TitleScreenManager2 = _interopRequireDefault(_TitleScreenManager);
	
	var _TitleScreenImageBased = __webpack_require__(550);
	
	var _TitleScreenImageBased2 = _interopRequireDefault(_TitleScreenImageBased);
	
	var _AccordionScreen = __webpack_require__(537);
	
	var _AccordionScreen2 = _interopRequireDefault(_AccordionScreen);
	
	var _SliderScreen = __webpack_require__(543);
	
	var _SliderScreen2 = _interopRequireDefault(_SliderScreen);
	
	var _HotspotScreen = __webpack_require__(539);
	
	var _HotspotScreen2 = _interopRequireDefault(_HotspotScreen);
	
	var _VideoScreen = __webpack_require__(554);
	
	var _VideoScreen2 = _interopRequireDefault(_VideoScreen);
	
	var _VideoMobileScreen = __webpack_require__(553);
	
	var _VideoMobileScreen2 = _interopRequireDefault(_VideoMobileScreen);
	
	var _ResourcesScrollScreen = __webpack_require__(540);
	
	var _ResourcesScrollScreen2 = _interopRequireDefault(_ResourcesScrollScreen);
	
	var _ToolTip = __webpack_require__(526);
	
	var _ToolTip2 = _interopRequireDefault(_ToolTip);
	
	var _KpiDashboard = __webpack_require__(93);
	
	var _KpiDashboard2 = _interopRequireDefault(_KpiDashboard);
	
	var _BadgeDashboard = __webpack_require__(280);
	
	var _BadgeDashboard2 = _interopRequireDefault(_BadgeDashboard);
	
	var _ScoreIntroduction = __webpack_require__(489);
	
	var _ScoreIntroduction2 = _interopRequireDefault(_ScoreIntroduction);
	
	var _KpiOverview = __webpack_require__(484);
	
	var _KpiOverview2 = _interopRequireDefault(_KpiOverview);
	
	var _KpiGraphResults = __webpack_require__(483);
	
	var _KpiGraphResults2 = _interopRequireDefault(_KpiGraphResults);
	
	var _KpiResultsList = __webpack_require__(486);
	
	var _KpiResultsList2 = _interopRequireDefault(_KpiResultsList);
	
	var _ConversationDialog = __webpack_require__(475);
	
	var _ConversationDialog2 = _interopRequireDefault(_ConversationDialog);
	
	var _CharacterSpeak = __webpack_require__(196);
	
	var _CharacterSpeak2 = _interopRequireDefault(_CharacterSpeak);
	
	var _LearnerSpeak = __webpack_require__(197);
	
	var _LearnerSpeak2 = _interopRequireDefault(_LearnerSpeak);
	
	var _NarratorSpeak = __webpack_require__(476);
	
	var _NarratorSpeak2 = _interopRequireDefault(_NarratorSpeak);
	
	var _Text = __webpack_require__(524);
	
	var _Text2 = _interopRequireDefault(_Text);
	
	var _MultipleChoice = __webpack_require__(491);
	
	var _MultipleChoice2 = _interopRequireDefault(_MultipleChoice);
	
	var _SingleAnswer = __webpack_require__(505);
	
	var _SingleAnswer2 = _interopRequireDefault(_SingleAnswer);
	
	var _MultipleAnswer = __webpack_require__(499);
	
	var _MultipleAnswer2 = _interopRequireDefault(_MultipleAnswer);
	
	var _ConversationSingleAnswer = __webpack_require__(492);
	
	var _ConversationSingleAnswer2 = _interopRequireDefault(_ConversationSingleAnswer);
	
	var _GridChoice = __webpack_require__(497);
	
	var _GridChoice2 = _interopRequireDefault(_GridChoice);
	
	var _SwipeHorizontal = __webpack_require__(520);
	
	var _SwipeHorizontal2 = _interopRequireDefault(_SwipeHorizontal);
	
	var _Video = __webpack_require__(528);
	
	var _Video2 = _interopRequireDefault(_Video);
	
	var _VimeoVIdeo = __webpack_require__(533);
	
	var _VimeoVIdeo2 = _interopRequireDefault(_VimeoVIdeo);
	
	var _ReactVideoPlayer = __webpack_require__(527);
	
	var _ReactVideoPlayer2 = _interopRequireDefault(_ReactVideoPlayer);
	
	var _Link = __webpack_require__(490);
	
	var _Link2 = _interopRequireDefault(_Link);
	
	var _Document = __webpack_require__(477);
	
	var _Document2 = _interopRequireDefault(_Document);
	
	var _Image = __webpack_require__(478);
	
	var _Image2 = _interopRequireDefault(_Image);
	
	var _LibraryImage = __webpack_require__(479);
	
	var _LibraryImage2 = _interopRequireDefault(_LibraryImage);
	
	var _TheEnd = __webpack_require__(525);
	
	var _TheEnd2 = _interopRequireDefault(_TheEnd);
	
	var _BadgeOverview = __webpack_require__(473);
	
	var _BadgeOverview2 = _interopRequireDefault(_BadgeOverview);
	
	var _AwardBadge = __webpack_require__(471);
	
	var _AwardBadge2 = _interopRequireDefault(_AwardBadge);
	
	var _VimeoPlayer = __webpack_require__(532);
	
	var _VimeoPlayer2 = _interopRequireDefault(_VimeoPlayer);
	
	var _VideoPlayer = __webpack_require__(531);
	
	var _VideoPlayer2 = _interopRequireDefault(_VideoPlayer);
	
	var _VideoJsInlinePlayer = __webpack_require__(529);
	
	var _VideoJsInlinePlayer2 = _interopRequireDefault(_VideoJsInlinePlayer);
	
	var _VideoJsPlayer = __webpack_require__(530);
	
	var _VideoJsPlayer2 = _interopRequireDefault(_VideoJsPlayer);
	
	var _ShortResponse = __webpack_require__(516);
	
	var _ShortResponse2 = _interopRequireDefault(_ShortResponse);
	
	var _PrintResponses = __webpack_require__(515);
	
	var _PrintResponses2 = _interopRequireDefault(_PrintResponses);
	
	var _ResourceDocumentLink = __webpack_require__(510);
	
	var _ResourceDocumentLink2 = _interopRequireDefault(_ResourceDocumentLink);
	
	var _ResourceImageLink = __webpack_require__(511);
	
	var _ResourceImageLink2 = _interopRequireDefault(_ResourceImageLink);
	
	var _ResourceScreenLink = __webpack_require__(512);
	
	var _ResourceScreenLink2 = _interopRequireDefault(_ResourceScreenLink);
	
	var _ResourceUrlLink = __webpack_require__(513);
	
	var _ResourceUrlLink2 = _interopRequireDefault(_ResourceUrlLink);
	
	var _ResourceVideoLink = __webpack_require__(514);
	
	var _ResourceVideoLink2 = _interopRequireDefault(_ResourceVideoLink);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	//eslint-disable-line import/no-named-as-default
	
	//BITES
	//BITE MENU
	var BITE_TYPE_SCENARIO = exports.BITE_TYPE_SCENARIO = "Scenario"; //eslint-disable-line import/no-named-as-default
	
	//BITES
	var COMPONENT_SCENARIO_BITE = exports.COMPONENT_SCENARIO_BITE = _ScenarioBite2.default;
	
	//SCREENS
	
	//eslint-disable-line import/no-named-as-default
	//eslint-disable-line import/no-named-as-default
	//eslint-disable-line import/no-named-as-default
	//eslint-disable-line import/no-named-as-default
	//eslint-disable-line import/no-named-as-default
	//eslint-disable-line import/no-named-as-default
	
	//eslint-disable-line import/no-named-as-default
	//eslint-disable-line import/no-named-as-default
	//eslint-disable-line import/no-named-as-default
	//eslint-disable-line import/no-named-as-default
	//eslint-disable-line import/no-named-as-default
	//eslint-disable-line import/no-named-as-default
	
	//eslint-disable-line import/no-named-as-default
	//eslint-disable-line import/no-named-as-default
	//eslint-disable-line import/no-named-as-default
	
	//eslint-disable-line import/no-named-as-default
	//eslint-disable-line import/no-named-as-default
	//eslint-disable-line import/no-named-as-default
	//eslint-disable-line import/no-named-as-default
	
	//eslint-disable-line import/no-named-as-default
	//eslint-disable-line import/no-named-as-default
	//eslint-disable-line import/no-named-as-default
	//eslint-disable-line import/no-named-as-default
	//eslint-disable-line import/no-named-as-default
	//eslint-disable-line import/no-named-as-default
	//eslint-disable-line import/no-named-as-default
	//eslint-disable-line import/no-named-as-default
	//eslint-disable-line import/no-named-as-default
	//eslint-disable-line import/no-named-as-default
	//eslint-disable-line import/no-named-as-default
	//eslint-disable-line import/no-named-as-default
	//eslint-disable-line import/no-named-as-default
	//eslint-disable-line import/no-named-as-default
	//eslint-disable-line import/no-named-as-default
	//eslint-disable-line import/no-named-as-default
	//eslint-disable-line import/no-named-as-default
	//eslint-disable-line import/no-named-as-default
	
	//eslint-disable-line import/no-named-as-default
	//eslint-disable-line import/no-named-as-default
	//RESOURCES
	
	
	//MENUS
	var MENU_TYPE_LINEAR_LEARNING_PLAN = exports.MENU_TYPE_LINEAR_LEARNING_PLAN = "linear_learning_plan";
	var MENU_TYPE_OPEN_LEARNING_PLAN = exports.MENU_TYPE_OPEN_LEARNING_PLAN = "open_learning_plan";
	var MENU_TYPE_FIRST_ANY_LAST_LEARNING_PLAN = exports.MENU_TYPE_FIRST_ANY_LAST_LEARNING_PLAN = "first_any_last_learning_plan";
	var MENU_TYPE_PERSONAL_LEARNING_PLAN = exports.MENU_TYPE_PERSONAL_LEARNING_PLAN = "personalised_learning_plan";
	var COMPONENT_LEARNING_PLAN = exports.COMPONENT_LEARNING_PLAN = _LearningPlanMenu2.default;
	
	//SCREENS
	
	var SCREEN_TYPE_SCENARIO = exports.SCREEN_TYPE_SCENARIO = "scenario";
	var COMPONENT_SCENARIO_SCREEN = exports.COMPONENT_SCENARIO_SCREEN = _ScenarioScreen2.default;
	
	var SCREEN_TYPE_TITLE = exports.SCREEN_TYPE_TITLE = "title_screen";
	var COMPONENT_TITLE_SCREEN = exports.COMPONENT_TITLE_SCREEN = _TitleScreenManager2.default;
	
	var SCREEN_SUB_TYPE_TITLE_STANDARD = exports.SCREEN_SUB_TYPE_TITLE_STANDARD = "standard";
	var COMPONENT_SCREEN_SUB_TYPE_TITLE_STANDARD = exports.COMPONENT_SCREEN_SUB_TYPE_TITLE_STANDARD = _TitleScreen2.default;
	var SCREEN_SUB_TYPE_TITLE_IMAGE_BASED = exports.SCREEN_SUB_TYPE_TITLE_IMAGE_BASED = "image_based";
	var COMPONENT_SCREEN_SUB_TYPE_TITLE_IMAGE_BASED = exports.COMPONENT_SCREEN_SUB_TYPE_TITLE_IMAGE_BASED = _TitleScreenImageBased2.default;
	
	var SCREEN_TYPE_TABBED = exports.SCREEN_TYPE_TABBED = "tabbed_content";
	var COMPONENT_TABBED_SCREEN = exports.COMPONENT_TABBED_SCREEN = _TabbedScreen2.default;
	
	var SCREEN_TYPE_SCROLL = exports.SCREEN_TYPE_SCROLL = "content";
	var COMPONENT_SCROLL_SCREEN = exports.COMPONENT_SCROLL_SCREEN = _ScrollScreen2.default;
	
	var SCREEN_TYPE_SLIDER = exports.SCREEN_TYPE_SLIDER = "slider";
	var COMPONENT_SLIDER_SCREEN = exports.COMPONENT_SLIDER_SCREEN = _SliderScreen2.default;
	
	var SCREEN_TYPE_HOTSPOT = exports.SCREEN_TYPE_HOTSPOT = "hotspots";
	var COMPONENT_HOTSPOT_SCREEN = exports.COMPONENT_HOTSPOT_SCREEN = _HotspotScreen2.default;
	
	var SCREEN_TYPE_VIDEO = exports.SCREEN_TYPE_VIDEO = "video";
	var COMPONENT_VIDEO_SCREEN = exports.COMPONENT_VIDEO_SCREEN = _VideoScreen2.default;
	
	var COMPONENT_RESOUCES_SCROLL_SCREEN = exports.COMPONENT_RESOUCES_SCROLL_SCREEN = _ResourcesScrollScreen2.default;
	
	//MOBILE SCREENS
	var SCREEN_TYPE_ACCORDION = exports.SCREEN_TYPE_ACCORDION = "accordion";
	var COMPONENT_ACCORDION_SCREEN = exports.COMPONENT_ACCORDION_SCREEN = _AccordionScreen2.default;
	var COMPONENT_VIDEO_MOBILE_SCREEN = exports.COMPONENT_VIDEO_MOBILE_SCREEN = _VideoMobileScreen2.default;
	
	//objects
	
	var COMPONENT_TOOLTIP_OBJECT = exports.COMPONENT_TOOLTIP_OBJECT = _ToolTip2.default;
	
	var COMPONENT_KPI_DASHBOARD_OBJECT = exports.COMPONENT_KPI_DASHBOARD_OBJECT = _KpiDashboard2.default;
	var COMPONENT_BADGE_DASHBOARD_OBJECT = exports.COMPONENT_BADGE_DASHBOARD_OBJECT = _BadgeDashboard2.default;
	
	var CONVERSATION_DIALOG = exports.CONVERSATION_DIALOG = "dialog";
	var COMPONENT_CONVERSATION_DIALOG = exports.COMPONENT_CONVERSATION_DIALOG = _ConversationDialog2.default;
	
	var CHARACTER_SPEAK = exports.CHARACTER_SPEAK = "character";
	var COMPONENT_CHARACTER_SPEAK = exports.COMPONENT_CHARACTER_SPEAK = _CharacterSpeak2.default;
	
	var LEARNER_SPEAK = exports.LEARNER_SPEAK = "learner";
	var COMPONENT_LEARNER_SPEAK = exports.COMPONENT_LEARNER_SPEAK = _LearnerSpeak2.default;
	
	var NARRATOR_SPEAK = exports.NARRATOR_SPEAK = "narrator";
	var COMPONENT_NARRATOR_SPEAK = exports.COMPONENT_NARRATOR_SPEAK = _NarratorSpeak2.default;
	
	var TEXT = exports.TEXT = "text";
	var COMPONENT_TEXT = exports.COMPONENT_TEXT = _Text2.default;
	
	var SCORE_INTRODUCTION = exports.SCORE_INTRODUCTION = "score_introduction";
	var COMPONENT_SCORE_INTRODUCTION = exports.COMPONENT_SCORE_INTRODUCTION = _ScoreIntroduction2.default;
	
	var KPI_OVERVIEW = exports.KPI_OVERVIEW = "objectives_overview";
	var COMPONENT_KPI_OVERVIEW = exports.COMPONENT_KPI_OVERVIEW = _KpiOverview2.default;
	
	var MULTIPLE_CHOICE = exports.MULTIPLE_CHOICE = "multiple_choice";
	
	var COMPONENT_MULTIPLE_CHOICE = exports.COMPONENT_MULTIPLE_CHOICE = _MultipleChoice2.default;
	
	var SINGLE_ANSWER = exports.SINGLE_ANSWER = "multiple_choice_select_one";
	var COMPONENT_SINGLE_ANSWER = exports.COMPONENT_SINGLE_ANSWER = _SingleAnswer2.default;
	
	var MULTIPLE_ANSWER = exports.MULTIPLE_ANSWER = "multiple_choice_select_many";
	var COMPONENT_MULTIPLE_ANSWER = exports.COMPONENT_MULTIPLE_ANSWER = _MultipleAnswer2.default;
	
	var CONVERSATION_CHOICE = exports.CONVERSATION_CHOICE = "conversation_choice";
	var COMPONENT_CONVERSATION_CHOICE = exports.COMPONENT_CONVERSATION_CHOICE = _MultipleChoice2.default;
	
	var CONVERSATION_SINGLE_ANSWER = exports.CONVERSATION_SINGLE_ANSWER = "conversation_choice_select_one";
	
	var COMPONENT_CONVERSATION_SINGLE_ANSWER = exports.COMPONENT_CONVERSATION_SINGLE_ANSWER = _ConversationSingleAnswer2.default;
	
	var CONVERSATION_MULTIPLE_ANSWER = exports.CONVERSATION_MULTIPLE_ANSWER = "conversation_choice_select_many";
	var COMPONENT_CONVERSATION_MULTIPLE_ANSWER = exports.COMPONENT_CONVERSATION_MULTIPLE_ANSWER = _MultipleAnswer2.default;
	
	var GRID_CHOICE = exports.GRID_CHOICE = "grid_choice";
	
	var COMPONENT_GRID_CHOICE = exports.COMPONENT_GRID_CHOICE = _MultipleChoice2.default;
	
	var GRID_SINGLE_ANSWER = exports.GRID_SINGLE_ANSWER = "grid_choice_select_one";
	var COMPONENT_GRID_SINGLE_ANSWER = exports.COMPONENT_GRID_SINGLE_ANSWER = _GridChoice2.default;
	
	var SWIPE_HORIZONTAL = exports.SWIPE_HORIZONTAL = "swipe_left_or_right";
	
	var COMPONENT_SWIPE_HORIZONTAL = exports.COMPONENT_SWIPE_HORIZONTAL = _SwipeHorizontal2.default;
	
	var VIDEO = exports.VIDEO = "video";
	var COMPONENT_VIDEO = exports.COMPONENT_VIDEO = _Video2.default;
	
	var VIMEO_VIDEO = exports.VIMEO_VIDEO = "vimeo";
	var COMPONENT_VIMEO_VIDEO = exports.COMPONENT_VIMEO_VIDEO = _VimeoPlayer2.default;
	
	var YOUTUBE_VIDEO = exports.YOUTUBE_VIDEO = "youtube";
	var COMPONENT_YOUTUBE = exports.COMPONENT_YOUTUBE = _VideoPlayer2.default;
	
	var MP4_VIDEO = exports.MP4_VIDEO = "mp4";
	var COMPONENT_MP4 = exports.COMPONENT_MP4 = _VideoJsInlinePlayer2.default;
	
	var VIMEO_SUB_VIDEO = exports.VIMEO_SUB_VIDEO = "vimeo";
	var COMPONENT_SUB_VIMEO_VIDEO = exports.COMPONENT_SUB_VIMEO_VIDEO = _VimeoVIdeo2.default;
	
	var YOUTUBE_SUB_VIDEO = exports.YOUTUBE_SUB_VIDEO = "youtube";
	var COMPONENT_SUB_YOUTUBE = exports.COMPONENT_SUB_YOUTUBE = _ReactVideoPlayer2.default;
	
	var MP4_SUB_VIDEO = exports.MP4_SUB_VIDEO = "mp4";
	var COMPONENT_SUB_MP4 = exports.COMPONENT_SUB_MP4 = _VideoJsPlayer2.default;
	
	var LINK = exports.LINK = 'link';
	var COMPONENT_LINK = exports.COMPONENT_LINK = _Link2.default;
	
	var DOCUMENT = exports.DOCUMENT = 'document';
	var COMPONENT_DOCUMENT = exports.COMPONENT_DOCUMENT = _Document2.default;
	
	var IMAGE = exports.IMAGE = 'image';
	var COMPONENT_IMAGE = exports.COMPONENT_IMAGE = _Image2.default;
	
	var LIBRARY_IMAGE = exports.LIBRARY_IMAGE = 'library_image';
	var COMPONENT_LIBRARY_IMAGE = exports.COMPONENT_LIBRARY_IMAGE = _LibraryImage2.default;
	
	var KPI_GRAPH_RESULTS = exports.KPI_GRAPH_RESULTS = 'graph_results';
	var COMPONENT_KPI_GRAPH_RESULTS = exports.COMPONENT_KPI_GRAPH_RESULTS = _KpiGraphResults2.default;
	
	var KPI_RESULTS_LIST = exports.KPI_RESULTS_LIST = 'results_list';
	var COMPONENT_KPI_RESULTS_LIST = exports.COMPONENT_KPI_RESULTS_LIST = _KpiResultsList2.default;
	
	var THE_END = exports.THE_END = 'the_end';
	var COMPONENT_THE_END = exports.COMPONENT_THE_END = _TheEnd2.default;
	
	var BADGE_OVERVIEW = exports.BADGE_OVERVIEW = 'badge_overview';
	var COMPONENT_BADGE_OVERVIEW = exports.COMPONENT_BADGE_OVERVIEW = _BadgeOverview2.default;
	
	var AWARD_BADGE = exports.AWARD_BADGE = 'award_badge';
	var COMPONENT_AWARD_BADGE = exports.COMPONENT_AWARD_BADGE = _AwardBadge2.default;
	
	var SHORT_RESPONSE = exports.SHORT_RESPONSE = 'short_response';
	var COMPONENT_SHORT_RESPONSE = exports.COMPONENT_SHORT_RESPONSE = _ShortResponse2.default;
	
	var PRINT_RESPONSES = exports.PRINT_RESPONSES = 'print_responses';
	var COMPONENT_PRINT_RESPONSES = exports.COMPONENT_PRINT_RESPONSES = _PrintResponses2.default;
	
	//Resources
	var RESOURCE_DOCUMENT_LINK = exports.RESOURCE_DOCUMENT_LINK = 'document';
	var COMPONENT_RESOURCE_DOCUMENT_LINK = exports.COMPONENT_RESOURCE_DOCUMENT_LINK = _ResourceDocumentLink2.default;
	
	var RESOURCE_IMAGE_LINK = exports.RESOURCE_IMAGE_LINK = 'image';
	var COMPONENT_RESOURCE_IMAGE_LINK = exports.COMPONENT_RESOURCE_IMAGE_LINK = _ResourceImageLink2.default;
	
	var RESOURCE_SCREEN_LINK = exports.RESOURCE_SCREEN_LINK = 'screen';
	var COMPONENT_RESOURCE_SCREEN_LINK = exports.COMPONENT_RESOURCE_SCREEN_LINK = _ResourceScreenLink2.default;
	
	var RESOURCE_URL_LINK = exports.RESOURCE_URL_LINK = 'link';
	var COMPONENT_RESOURCE_URL_LINK = exports.COMPONENT_RESOURCE_URL_LINK = _ResourceUrlLink2.default;
	
	var RESOURCE_VIDEO_LINK = exports.RESOURCE_VIDEO_LINK = 'video';
	var COMPONENT_RESOURCE_VIDEO_LINK = exports.COMPONENT_RESOURCE_VIDEO_LINK = _ResourceVideoLink2.default;
	
	var MULTIPLE_CHOICE_SINGLE_ANSWER_LABEL = exports.MULTIPLE_CHOICE_SINGLE_ANSWER_LABEL = "Multiple Choice - Select One";
	var MULTIPLE_CHOICE_MULTIPLE_ANSWER_LABEL = exports.MULTIPLE_CHOICE_MULTIPLE_ANSWER_LABEL = "Multiple Choice - Select Many";
	var CONVERSATION_SINGLE_ANSWER_LABEL = exports.CONVERSATION_SINGLE_ANSWER_LABEL = 'Conversation Choice';
	var GRID_CHOICE_LABEL = exports.GRID_CHOICE_LABEL = "Grid Choice";
	var SWIPE_HORIZONTAL_LABEL = exports.SWIPE_HORIZONTAL_LABEL = "Swipe Left or Right";
	var SHORT_RESPONSE_LABEL = exports.SHORT_RESPONSE_LABEL = "Short Response";

/***/ },
/* 50 */
/***/ function(module, exports) {

	module.exports = function (it) {
	  if (typeof it != 'function') throw TypeError(it + ' is not a function!');
	  return it;
	};


/***/ },
/* 51 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
	
	/**
	 * Simple, lightweight module assisting with the detection and context of
	 * Worker. Helps avoid circular dependencies and allows code to reason about
	 * whether or not they are in a Worker, even if they never include the main
	 * `ReactWorker` dependency.
	 */
	var ExecutionEnvironment = {
	
	  canUseDOM: canUseDOM,
	
	  canUseWorkers: typeof Worker !== 'undefined',
	
	  canUseEventListeners: canUseDOM && !!(window.addEventListener || window.attachEvent),
	
	  canUseViewport: canUseDOM && !!window.screen,
	
	  isInWorker: !canUseDOM // For now, this is true - might change in the future.
	
	};
	
	module.exports = ExecutionEnvironment;

/***/ },
/* 52 */
/***/ function(module, exports, __webpack_require__) {

	var dP = __webpack_require__(39);
	var createDesc = __webpack_require__(107);
	module.exports = __webpack_require__(38) ? function (object, key, value) {
	  return dP.f(object, key, createDesc(1, value));
	} : function (object, key, value) {
	  object[key] = value;
	  return object;
	};


/***/ },
/* 53 */
/***/ function(module, exports, __webpack_require__) {

	var global = __webpack_require__(24);
	var hide = __webpack_require__(52);
	var has = __webpack_require__(58);
	var SRC = __webpack_require__(111)('src');
	var TO_STRING = 'toString';
	var $toString = Function[TO_STRING];
	var TPL = ('' + $toString).split(TO_STRING);
	
	__webpack_require__(70).inspectSource = function (it) {
	  return $toString.call(it);
	};
	
	(module.exports = function (O, key, val, safe) {
	  var isFunction = typeof val == 'function';
	  if (isFunction) has(val, 'name') || hide(val, 'name', key);
	  if (O[key] === val) return;
	  if (isFunction) has(val, SRC) || hide(val, SRC, O[key] ? '' + O[key] : TPL.join(String(key)));
	  if (O === global) {
	    O[key] = val;
	  } else if (!safe) {
	    delete O[key];
	    hide(O, key, val);
	  } else if (O[key]) {
	    O[key] = val;
	  } else {
	    hide(O, key, val);
	  }
	// add fake Function#toString for correct work wrapped methods / constructors with methods like LoDash isNative
	})(Function.prototype, TO_STRING, function toString() {
	  return typeof this == 'function' && this[SRC] || $toString.call(this);
	});


/***/ },
/* 54 */
/***/ function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(6);
	var fails = __webpack_require__(26);
	var defined = __webpack_require__(76);
	var quot = /"/g;
	// B.2.3.2.1 CreateHTML(string, tag, attribute, value)
	var createHTML = function (string, tag, attribute, value) {
	  var S = String(defined(string));
	  var p1 = '<' + tag;
	  if (attribute !== '') p1 += ' ' + attribute + '="' + String(value).replace(quot, '&quot;') + '"';
	  return p1 + '>' + S + '</' + tag + '>';
	};
	module.exports = function (NAME, exec) {
	  var O = {};
	  O[NAME] = exec(createHTML);
	  $export($export.P + $export.F * fails(function () {
	    var test = ''[NAME]('"');
	    return test !== test.toLowerCase() || test.split('"').length > 3;
	  }), 'String', O);
	};


/***/ },
/* 55 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	module.exports = __webpack_require__(979);


/***/ },
/* 56 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.getEnvironment = getEnvironment;
	
	var _environmentModels = __webpack_require__(557);
	
	var evironmentModels = _interopRequireWildcard(_environmentModels);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function getEnvironment() {
	    return Object.assign({}, evironmentModels.environment, {
	        os: getOsDetails(),
	        browser: getBrowserDetails(),
	        isDevice: isDevice(),
	        window: getWindowDetails()
	
	    });
	}
	
	function getOsDetails() {
	    var agent = evironmentModels.header.join(' ');
	    var osDetails = {};
	    var os = evironmentModels.os;
	    if (window.device && window.device.model.toLowerCase().indexOf("ipad") >= 0) {
	        for (var i = 0; i < os.length; i++) {
	            if (os[i].name == 'iPad') {
	                osDetails = Object.assign({}, os[i]);
	                break;
	            }
	        }
	    } else {
	        osDetails = Object.assign({}, matchItem(agent, os));
	    }
	    return osDetails;
	}
	
	function getBrowserDetails() {
	    var agent = evironmentModels.header.join(' ');
	    return matchItem(agent, evironmentModels.browser);
	}
	
	function isDevice() {
	    var deviceAgent = navigator.userAgent.toLowerCase();
	    var iDevice = deviceAgent.match(/(iphone|ipod|ipad|android)/) ? true : false;
	    return iDevice;
	}
	
	function getWindowDetails() {
	    var isiPhone = navigator.userAgent.match(/(iPhone)/g) ? true : false;
	    var windowSize = "lg";
	    if (isiPhone) {
	        windowSize = 'xs';
	    } else {
	        var w = window.innerWidth;
	        if (w <= 767) {
	            windowSize = "xs";
	        }
	        if (w > 767 && w < 992) {
	            windowSize = "sm";
	        }
	        if (w >= 992 && w < 1200) {
	            windowSize = "md";
	        }
	    }
	
	    return {
	        size: windowSize,
	        width: window.innerWidth,
	        height: window.innerHeight,
	        orientation: window.innerWidth > window.innerHeight ? "landscape" : "portrait"
	    };
	}
	
	function matchItem(string, data) {
	    var i = 0,
	        j = 0,
	        regex = void 0,
	        regexv = void 0,
	        match = void 0,
	        matches = void 0,
	        version = void 0;
	
	    for (i = 0; i < data.length; i += 1) {
	        regex = new RegExp(data[i].value, 'i');
	        match = regex.test(string);
	        if (match) {
	            regexv = new RegExp(data[i].version + '[- /:;]([\\d._]+)', 'i');
	            matches = string.match(regexv);
	            version = '';
	            if (matches) {
	                if (matches[1]) {
	                    matches = matches[1];
	                }
	            }
	            if (matches) {
	                matches = matches.split(/[._]+/);
	                for (j = 0; j < matches.length; j += 1) {
	                    if (j === 0) {
	                        version += matches[j] + '.';
	                    } else {
	                        version += matches[j];
	                    }
	                }
	            } else {
	                version = '0';
	            }
	            return {
	                name: data[i].name,
	                version: parseFloat(version)
	            };
	        }
	    }
	    return { name: 'unknown', version: 0 };
	}

/***/ },
/* 57 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.KPI_SCORING_PATTERNS = exports.KPI_VALUES_TO_COLOUR_LIST = exports.KPI_SELF_RATING_LIST = exports.KPI_POINTS_INDICATOR_CLASSES_TYPE_2 = exports.KPI_POINTS_INDICATOR_CLASSES = exports.BEST_TO_GREEN = exports.OK_TO_YELLOW = exports.POOR_TO_RED = exports.POINTS_INDICATOR_NOT_APPLICABLE = exports.POINTS_INDICATOR_NEUTRAL_TYPE_2 = exports.POINTS_INDICATOR_NEGATIVE_LARGE_TYPE_2 = exports.POINTS_INDICATOR_NEGATIVE_SMALL_TYPE_2 = exports.POINTS_INDICATOR_POSITIVE_LARGE_TYPE_2 = exports.POINTS_INDICATOR_POSITIVE_SMALL_TYPE_2 = exports.POINTS_INDICATOR_NEUTRAL = exports.POINTS_INDICATOR_NEGATIVE_LARGE = exports.POINTS_INDICATOR_NEGATIVE_SMALL = exports.POINTS_INDICATOR_POSITIVE_LARGE = exports.POINTS_INDICATOR_POSITIVE_SMALL = exports.PRIMARY_KPI_ROTATION_METER_PARAMS = exports.DEFAULT_KPI_ROTATION_METER_PARAMS = exports.TAB_KPI_ROTATION_METER_PARAMS = exports.HEADER_KPI_ROTATION_METER_PARAMS = undefined;
	
	var _kpiConstants = __webpack_require__(37);
	
	var kpiConstants = _interopRequireWildcard(_kpiConstants);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	var HEADER_KPI_ROTATION_METER_PARAMS = exports.HEADER_KPI_ROTATION_METER_PARAMS = {
	    className: "kpi-rotation-btn",
	    showLabel: false,
	    minRotation: kpiConstants.KPI_MIN_ROTATION,
	    maxRotation: kpiConstants.KPI_MAX_ROTATION,
	    svgX: kpiConstants.HEADER_KPI_ROTATION_SVG_PARAM_X_POS,
	    svgY: kpiConstants.HEADER_KPI_ROTATION_SVG_PARAM_Y_POS,
	    svgRadius: kpiConstants.HEADER_KPI_ROTATION_SVG_PARAM_RADIUS,
	    svgStroke: kpiConstants.HEADER_KPI_ROTATION_SVG_PARAM_STROKE
	};
	
	var TAB_KPI_ROTATION_METER_PARAMS = exports.TAB_KPI_ROTATION_METER_PARAMS = {
	    className: "kpi-rotation-tab",
	    showLabel: false,
	    minRotation: kpiConstants.KPI_MIN_ROTATION,
	    maxRotation: kpiConstants.KPI_MAX_ROTATION,
	    svgX: kpiConstants.HEADER_KPI_ROTATION_SVG_PARAM_X_POS,
	    svgY: kpiConstants.HEADER_KPI_ROTATION_SVG_PARAM_Y_POS,
	    svgRadius: kpiConstants.HEADER_KPI_ROTATION_SVG_PARAM_RADIUS,
	    svgStroke: kpiConstants.HEADER_KPI_ROTATION_SVG_PARAM_STROKE
	};
	
	var DEFAULT_KPI_ROTATION_METER_PARAMS = exports.DEFAULT_KPI_ROTATION_METER_PARAMS = {
	    className: "kpi-rotation default",
	    showLabel: true,
	    minRotation: kpiConstants.KPI_MIN_ROTATION,
	    maxRotation: kpiConstants.KPI_MAX_ROTATION,
	    svgX: kpiConstants.DEFAULT_KPI_ROTATION_SVG_PARAM_X_POS,
	    svgY: kpiConstants.DEFAULT_KPI_ROTATION_SVG_PARAM_Y_POS,
	    svgRadius: kpiConstants.DEFAULT_KPI_ROTATION_SVG_PARAM_RADIUS,
	    svgStroke: kpiConstants.DEFAULT_KPI_ROTATION_SVG_PARAM_STROKE
	};
	
	var PRIMARY_KPI_ROTATION_METER_PARAMS = exports.PRIMARY_KPI_ROTATION_METER_PARAMS = {
	    className: "kpi-rotation primary",
	    showLabel: true,
	    minRotation: kpiConstants.KPI_MIN_ROTATION,
	    maxRotation: kpiConstants.KPI_MAX_ROTATION,
	    svgX: kpiConstants.PRIMARY_KPI_ROTATION_SVG_PARAM_X_POS,
	    svgY: kpiConstants.PRIMARY_KPI_ROTATION_SVG_PARAM_Y_POS,
	    svgRadius: kpiConstants.PRIMARY_KPI_ROTATION_SVG_PARAM_RADIUS,
	    svgStroke: kpiConstants.PRIMARY_KPI_ROTATION_SVG_PARAM_STROKE
	};
	
	var POINTS_INDICATOR_POSITIVE_SMALL = exports.POINTS_INDICATOR_POSITIVE_SMALL = {
	    value: 1,
	    class: "positive-single"
	};
	
	var POINTS_INDICATOR_POSITIVE_LARGE = exports.POINTS_INDICATOR_POSITIVE_LARGE = {
	    value: 2,
	    class: "positive-double"
	};
	
	var POINTS_INDICATOR_NEGATIVE_SMALL = exports.POINTS_INDICATOR_NEGATIVE_SMALL = {
	    value: -1,
	    class: "negative-single"
	};
	
	var POINTS_INDICATOR_NEGATIVE_LARGE = exports.POINTS_INDICATOR_NEGATIVE_LARGE = {
	    value: -2,
	    class: "negative-double"
	};
	
	var POINTS_INDICATOR_NEUTRAL = exports.POINTS_INDICATOR_NEUTRAL = {
	    value: 0,
	    class: "no-value"
	};
	
	var POINTS_INDICATOR_POSITIVE_SMALL_TYPE_2 = exports.POINTS_INDICATOR_POSITIVE_SMALL_TYPE_2 = {
	    value: 2,
	    class: "positive-single"
	};
	
	var POINTS_INDICATOR_POSITIVE_LARGE_TYPE_2 = exports.POINTS_INDICATOR_POSITIVE_LARGE_TYPE_2 = {
	    value: 3,
	    class: "positive-double"
	};
	
	var POINTS_INDICATOR_NEGATIVE_SMALL_TYPE_2 = exports.POINTS_INDICATOR_NEGATIVE_SMALL_TYPE_2 = {
	    value: 0,
	    class: "negative-single"
	};
	
	var POINTS_INDICATOR_NEGATIVE_LARGE_TYPE_2 = exports.POINTS_INDICATOR_NEGATIVE_LARGE_TYPE_2 = {
	    value: -1,
	    class: "negative-double"
	};
	
	var POINTS_INDICATOR_NEUTRAL_TYPE_2 = exports.POINTS_INDICATOR_NEUTRAL_TYPE_2 = {
	    value: 1,
	    class: "no-value"
	};
	
	var POINTS_INDICATOR_NOT_APPLICABLE = exports.POINTS_INDICATOR_NOT_APPLICABLE = {
	    value: "n-a",
	    class: "n-a"
	};
	
	var POOR_TO_RED = exports.POOR_TO_RED = {
	    value: "poor",
	    colour: "red"
	};
	
	var OK_TO_YELLOW = exports.OK_TO_YELLOW = {
	    value: "ok",
	    colour: "yellow"
	};
	
	var BEST_TO_GREEN = exports.BEST_TO_GREEN = {
	    value: "best",
	    colour: "green"
	};
	
	var KPI_POINTS_INDICATOR_CLASSES = exports.KPI_POINTS_INDICATOR_CLASSES = [POINTS_INDICATOR_POSITIVE_SMALL, POINTS_INDICATOR_POSITIVE_LARGE, POINTS_INDICATOR_NEGATIVE_SMALL, POINTS_INDICATOR_NEGATIVE_LARGE, POINTS_INDICATOR_NEUTRAL, POINTS_INDICATOR_NOT_APPLICABLE];
	
	var KPI_POINTS_INDICATOR_CLASSES_TYPE_2 = exports.KPI_POINTS_INDICATOR_CLASSES_TYPE_2 = [POINTS_INDICATOR_POSITIVE_SMALL_TYPE_2, POINTS_INDICATOR_POSITIVE_LARGE_TYPE_2, POINTS_INDICATOR_NEGATIVE_SMALL_TYPE_2, POINTS_INDICATOR_NEGATIVE_LARGE_TYPE_2, POINTS_INDICATOR_NEUTRAL_TYPE_2, POINTS_INDICATOR_NOT_APPLICABLE];
	
	var KPI_SELF_RATING_LIST = exports.KPI_SELF_RATING_LIST = [POINTS_INDICATOR_POSITIVE_LARGE, POINTS_INDICATOR_POSITIVE_SMALL, POINTS_INDICATOR_NEUTRAL, POINTS_INDICATOR_NEGATIVE_SMALL, POINTS_INDICATOR_NEGATIVE_LARGE];
	
	var KPI_VALUES_TO_COLOUR_LIST = exports.KPI_VALUES_TO_COLOUR_LIST = [POOR_TO_RED, OK_TO_YELLOW, BEST_TO_GREEN];
	
	var KPI_SCORING_PATTERNS = exports.KPI_SCORING_PATTERNS = [{
	    constant: "scoring_pattern_-2,-1,0,1,2",
	    indicatorClasses: KPI_POINTS_INDICATOR_CLASSES
	}, {
	    constant: "scoring_pattern_-1,0,1,2,3",
	    indicatorClasses: KPI_POINTS_INDICATOR_CLASSES_TYPE_2
	}];

/***/ },
/* 58 */
/***/ function(module, exports) {

	var hasOwnProperty = {}.hasOwnProperty;
	module.exports = function (it, key) {
	  return hasOwnProperty.call(it, key);
	};


/***/ },
/* 59 */
/***/ function(module, exports, __webpack_require__) {

	var pIE = __webpack_require__(140);
	var createDesc = __webpack_require__(107);
	var toIObject = __webpack_require__(61);
	var toPrimitive = __webpack_require__(79);
	var has = __webpack_require__(58);
	var IE8_DOM_DEFINE = __webpack_require__(300);
	var gOPD = Object.getOwnPropertyDescriptor;
	
	exports.f = __webpack_require__(38) ? gOPD : function getOwnPropertyDescriptor(O, P) {
	  O = toIObject(O);
	  P = toPrimitive(P, true);
	  if (IE8_DOM_DEFINE) try {
	    return gOPD(O, P);
	  } catch (e) { /* empty */ }
	  if (has(O, P)) return createDesc(!pIE.f.call(O, P), O[P]);
	};


/***/ },
/* 60 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.2.9 / 15.2.3.2 Object.getPrototypeOf(O)
	var has = __webpack_require__(58);
	var toObject = __webpack_require__(43);
	var IE_PROTO = __webpack_require__(221)('IE_PROTO');
	var ObjectProto = Object.prototype;
	
	module.exports = Object.getPrototypeOf || function (O) {
	  O = toObject(O);
	  if (has(O, IE_PROTO)) return O[IE_PROTO];
	  if (typeof O.constructor == 'function' && O instanceof O.constructor) {
	    return O.constructor.prototype;
	  } return O instanceof Object ? ObjectProto : null;
	};


/***/ },
/* 61 */
/***/ function(module, exports, __webpack_require__) {

	// to indexed object, toObject with fallback for non-array-like ES3 strings
	var IObject = __webpack_require__(139);
	var defined = __webpack_require__(76);
	module.exports = function (it) {
	  return IObject(defined(it));
	};


/***/ },
/* 62 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2016-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	// Trust the developer to only use ReactInstrumentation with a __DEV__ check
	
	var debugTool = null;
	
	if (false) {
	  var ReactDebugTool = require('./ReactDebugTool');
	  debugTool = ReactDebugTool;
	}
	
	module.exports = { debugTool: debugTool };

/***/ },
/* 63 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	exports.parseStartTime = parseStartTime;
	exports.parseEndTime = parseEndTime;
	exports.randomString = randomString;
	exports.queryString = queryString;
	exports.getSDK = getSDK;
	exports.getConfig = getConfig;
	exports.omit = omit;
	exports.callPlayer = callPlayer;
	exports.isObject = isObject;
	exports.isEqual = isEqual;
	exports.isMediaStream = isMediaStream;
	
	var _loadScript = __webpack_require__(848);
	
	var _loadScript2 = _interopRequireDefault(_loadScript);
	
	var _deepmerge = __webpack_require__(820);
	
	var _deepmerge2 = _interopRequireDefault(_deepmerge);
	
	var _props = __webpack_require__(190);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var MATCH_START_QUERY = /[?&#](?:start|t)=([0-9hms]+)/;
	var MATCH_END_QUERY = /[?&#]end=([0-9hms]+)/;
	var MATCH_START_STAMP = /(\d+)(h|m|s)/g;
	var MATCH_NUMERIC = /^\d+$/;
	
	// Parse YouTube URL for a start time param, ie ?t=1h14m30s
	// and return the start time in seconds
	function parseTimeParam(url, pattern) {
	  var match = url.match(pattern);
	  if (match) {
	    var stamp = match[1];
	    if (stamp.match(MATCH_START_STAMP)) {
	      return parseTimeString(stamp);
	    }
	    if (MATCH_NUMERIC.test(stamp)) {
	      return parseInt(stamp);
	    }
	  }
	  return undefined;
	}
	
	function parseTimeString(stamp) {
	  var seconds = 0;
	  var array = MATCH_START_STAMP.exec(stamp);
	  while (array !== null) {
	    var _array = array,
	        _array2 = _slicedToArray(_array, 3),
	        count = _array2[1],
	        period = _array2[2];
	
	    if (period === 'h') seconds += parseInt(count, 10) * 60 * 60;
	    if (period === 'm') seconds += parseInt(count, 10) * 60;
	    if (period === 's') seconds += parseInt(count, 10);
	    array = MATCH_START_STAMP.exec(stamp);
	  }
	  return seconds;
	}
	
	function parseStartTime(url) {
	  return parseTimeParam(url, MATCH_START_QUERY);
	}
	
	function parseEndTime(url) {
	  return parseTimeParam(url, MATCH_END_QUERY);
	}
	
	// http://stackoverflow.com/a/38622545
	function randomString() {
	  return Math.random().toString(36).substr(2, 5);
	}
	
	function queryString(object) {
	  return Object.keys(object).map(function (key) {
	    return key + '=' + object[key];
	  }).join('&');
	}
	
	// Util function to load an external SDK
	// or return the SDK if it is already loaded
	var resolves = {};
	function getSDK(url, sdkGlobal) {
	  var sdkReady = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
	  var isLoaded = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : function () {
	    return true;
	  };
	  var fetchScript = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : _loadScript2['default'];
	
	  if (window[sdkGlobal] && isLoaded(window[sdkGlobal])) {
	    return Promise.resolve(window[sdkGlobal]);
	  }
	  return new Promise(function (resolve, reject) {
	    // If we are already loading the SDK, add the resolve
	    // function to the existing array of resolve functions
	    if (resolves[url]) {
	      resolves[url].push(resolve);
	      return;
	    }
	    resolves[url] = [resolve];
	    var onLoaded = function onLoaded(sdk) {
	      // When loaded, resolve all pending promises
	      resolves[url].forEach(function (resolve) {
	        return resolve(sdk);
	      });
	    };
	    if (sdkReady) {
	      var previousOnReady = window[sdkReady];
	      window[sdkReady] = function () {
	        if (previousOnReady) previousOnReady();
	        onLoaded(window[sdkGlobal]);
	      };
	    }
	    fetchScript(url, function (err) {
	      if (err) reject(err);
	      if (!sdkReady) {
	        onLoaded(window[sdkGlobal]);
	      }
	    });
	  });
	}
	
	function getConfig(props, defaultProps, showWarning) {
	  var config = (0, _deepmerge2['default'])(defaultProps.config, props.config);
	  var _iteratorNormalCompletion = true;
	  var _didIteratorError = false;
	  var _iteratorError = undefined;
	
	  try {
	    for (var _iterator = _props.DEPRECATED_CONFIG_PROPS[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	      var p = _step.value;
	
	      if (props[p]) {
	        var key = p.replace(/Config$/, '');
	        config = (0, _deepmerge2['default'])(config, _defineProperty({}, key, props[p]));
	        if (showWarning) {
	          var link = 'https://github.com/CookPete/react-player#config-prop';
	          var message = 'ReactPlayer: %c' + p + ' %cis deprecated, please use the config prop instead \u2013 ' + link;
	          console.warn(message, 'font-weight: bold', '');
	        }
	      }
	    }
	  } catch (err) {
	    _didIteratorError = true;
	    _iteratorError = err;
	  } finally {
	    try {
	      if (!_iteratorNormalCompletion && _iterator['return']) {
	        _iterator['return']();
	      }
	    } finally {
	      if (_didIteratorError) {
	        throw _iteratorError;
	      }
	    }
	  }
	
	  return config;
	}
	
	function omit(object) {
	  var _ref;
	
	  for (var _len = arguments.length, arrays = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	    arrays[_key - 1] = arguments[_key];
	  }
	
	  var omitKeys = (_ref = []).concat.apply(_ref, arrays);
	  var output = {};
	  var keys = Object.keys(object);
	  var _iteratorNormalCompletion2 = true;
	  var _didIteratorError2 = false;
	  var _iteratorError2 = undefined;
	
	  try {
	    for (var _iterator2 = keys[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
	      var key = _step2.value;
	
	      if (omitKeys.indexOf(key) === -1) {
	        output[key] = object[key];
	      }
	    }
	  } catch (err) {
	    _didIteratorError2 = true;
	    _iteratorError2 = err;
	  } finally {
	    try {
	      if (!_iteratorNormalCompletion2 && _iterator2['return']) {
	        _iterator2['return']();
	      }
	    } finally {
	      if (_didIteratorError2) {
	        throw _iteratorError2;
	      }
	    }
	  }
	
	  return output;
	}
	
	function callPlayer(method) {
	  var _player;
	
	  // Util method for calling a method on this.player
	  // but guard against errors and console.warn instead
	  if (!this.player || !this.player[method]) {
	    var message = 'ReactPlayer: ' + this.constructor.displayName + ' player could not call %c' + method + '%c \u2013 ';
	    if (!this.player) {
	      message += 'The player was not available';
	    } else if (!this.player[method]) {
	      message += 'The method was not available';
	    }
	    console.warn(message, 'font-weight: bold', '');
	    return null;
	  }
	
	  for (var _len2 = arguments.length, args = Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
	    args[_key2 - 1] = arguments[_key2];
	  }
	
	  return (_player = this.player)[method].apply(_player, args);
	}
	
	function isObject(val) {
	  return val !== null && (typeof val === 'undefined' ? 'undefined' : _typeof(val)) === 'object';
	}
	
	// Deep comparison of two objects but ignoring
	// functions, for use in shouldComponentUpdate
	function isEqual(a, b) {
	  if (typeof a === 'function' && typeof b === 'function') {
	    return true;
	  }
	  if (a instanceof Array && b instanceof Array) {
	    if (a.length !== b.length) {
	      return false;
	    }
	    for (var i = 0; i !== a.length; i++) {
	      if (!isEqual(a[i], b[i])) {
	        return false;
	      }
	    }
	    return true;
	  }
	  if (isObject(a) && isObject(b)) {
	    if (Object.keys(a).length !== Object.keys(b).length) {
	      return false;
	    }
	    var _iteratorNormalCompletion3 = true;
	    var _didIteratorError3 = false;
	    var _iteratorError3 = undefined;
	
	    try {
	      for (var _iterator3 = Object.keys(a)[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
	        var key = _step3.value;
	
	        if (!isEqual(a[key], b[key])) {
	          return false;
	        }
	      }
	    } catch (err) {
	      _didIteratorError3 = true;
	      _iteratorError3 = err;
	    } finally {
	      try {
	        if (!_iteratorNormalCompletion3 && _iterator3['return']) {
	          _iterator3['return']();
	        }
	      } finally {
	        if (_didIteratorError3) {
	          throw _iteratorError3;
	        }
	      }
	    }
	
	    return true;
	  }
	  return a === b;
	}
	
	function isMediaStream(url) {
	  return typeof window !== 'undefined' && typeof window.MediaStream !== 'undefined' && url instanceof window.MediaStream;
	}

/***/ },
/* 64 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.setContentData = setContentData;
	exports.initApp = initApp;
	exports.loadContentData = loadContentData;
	exports.updateInitData = updateInitData;
	exports.updateContentData = updateContentData;
	exports.checkPreloadedImageState = checkPreloadedImageState;
	
	var _actionTypes = __webpack_require__(22);
	
	var types = _interopRequireWildcard(_actionTypes);
	
	var _appConstants = __webpack_require__(13);
	
	var AppConstants = _interopRequireWildcard(_appConstants);
	
	var _localStorage = __webpack_require__(17);
	
	var localStorage = _interopRequireWildcard(_localStorage);
	
	var _dataService = __webpack_require__(581);
	
	var _dataService2 = _interopRequireDefault(_dataService);
	
	var _dataHelper = __webpack_require__(11);
	
	var dataHelper = _interopRequireWildcard(_dataHelper);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function setContentData(contentData) {
	    return { type: types.SET_CONTENT_DATA, contentData: contentData };
	}
	
	function initApp(initData) {
	    return { type: types.INITIALISE, initData: initData };
	}
	
	function loadContentData(initData) {
	    return function (dispatch) {
	        var dataPath = __webpack_require__(833);
	        return _dataService2.default.loadData(dataPath).then(function (contentDataObj) {
	            var contentData = Object.assign({}, contentDataObj, {
	                contentLoaded: true
	            });
	            //console.log(contentData);
	            dispatch(setContentData(contentData));
	            localStorage.setObject("contentData", contentData);
	        }).catch(function (error) {
	            throw error;
	        });
	    };
	}
	
	function updateInitData(initData) {
	    return function (dispatch) {
	        dispatch(initApp(initData));
	    };
	}
	
	function updateContentData(contentData) {
	    return function (dispatch) {
	        dispatch(setContentData(contentData));
	    };
	}
	
	function checkPreloadedImageState(initData) {}

/***/ },
/* 65 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(5);
	
	var _redux = __webpack_require__(4);
	
	var _CharacterSpeak = __webpack_require__(196);
	
	var _CharacterSpeak2 = _interopRequireDefault(_CharacterSpeak);
	
	var _LearnerSpeak = __webpack_require__(197);
	
	var _LearnerSpeak2 = _interopRequireDefault(_LearnerSpeak);
	
	var _Button = __webpack_require__(18);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _trackingDataActions = __webpack_require__(7);
	
	var trackingDataActions = _interopRequireWildcard(_trackingDataActions);
	
	var _appHelper = __webpack_require__(3);
	
	var appHelper = _interopRequireWildcard(_appHelper);
	
	var _objectConstants = __webpack_require__(9);
	
	var objectConstants = _interopRequireWildcard(_objectConstants);
	
	var _dataHelper = __webpack_require__(11);
	
	var dataHelper = _interopRequireWildcard(_dataHelper);
	
	var _gsap = __webpack_require__(8);
	
	var _gsapReactPlugin = __webpack_require__(10);
	
	var _gsapReactPlugin2 = _interopRequireDefault(_gsapReactPlugin);
	
	var _componentHelper = __webpack_require__(31);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } //eslint-disable-line import/no-named-as-default
	//eslint-disable-line import/no-named-as-default
	//eslint-disable-line import/no-named-as-default
	
	var ChildConversationDialog = function (_React$Component) {
	    _inherits(ChildConversationDialog, _React$Component);
	
	    function ChildConversationDialog(props, context) {
	        _classCallCheck(this, ChildConversationDialog);
	
	        var _this = _possibleConstructorReturn(this, (ChildConversationDialog.__proto__ || Object.getPrototypeOf(ChildConversationDialog)).call(this, props, context));
	
	        _this.state = {
	            initialised: false,
	            dialogs: _this.props.dialogs,
	            renderedDialogs: [],
	            callbacks: {},
	            delay: 0
	
	        };
	
	        _this.onComplete = _this.onComplete.bind(_this);
	        _this.setDialog = _this.setDialog.bind(_this);
	        _this.setCallbacks = _this.setCallbacks.bind(_this);
	        _this.onObjectComplete = _this.onObjectComplete.bind(_this);
	        return _this;
	    }
	
	    _createClass(ChildConversationDialog, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            this.setCallbacks();
	            this.setDialog(0);
	        }
	    }, {
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(nextProps) {}
	    }, {
	        key: 'componentDidUpdate',
	        value: function componentDidUpdate() {
	            if (this.state.setVariable) {
	                this.getVariable();
	            }
	        }
	    }, {
	        key: 'setCallbacks',
	        value: function setCallbacks() {
	            this.setState({
	                callbacks: Object.assign({}, this.props.callbacks, {
	                    onObjectComplete: this.onObjectComplete,
	                    getCharacterName: appHelper.isDefined(this.props.callbacks.getCharacterName) ? this.props.callbacks.getCharacterName : appHelper.getScreenCharacterNameByAssetId(this.props.asset_id)
	                })
	            });
	        }
	    }, {
	        key: 'onObjectComplete',
	        value: function onObjectComplete(index) {
	            var nextIndex = index + 1;
	            if (nextIndex < this.state.dialogs.length) {
	                this.setDialog(nextIndex);
	            } else {
	                this.onComplete();
	            }
	        }
	    }, {
	        key: 'setDialog',
	        value: function setDialog(index) {
	            var dialog = Object.assign({}, this.state.dialogs[index]);
	            var dialogType = Object.assign({}, (0, _componentHelper.getChildObjectComponentByType)(dialog.object_type), {
	                data: dialog,
	                index: index
	            });
	            this.setState({ renderedDialogs: dataHelper.immutablePush(this.state.renderedDialogs, dialogType) });
	        }
	    }, {
	        key: 'onComplete',
	        value: function onComplete() {
	            if (appHelper.isDefined(this.props.onComplete)) {
	                this.props.onComplete();
	            }
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this2 = this;
	
	            return _react2.default.createElement(
	                'div',
	                { className: 'content-dialogs', ref: this.props.option_id },
	                this.state.renderedDialogs.map(function (dialog) {
	                    return _react2.default.createElement(
	                        'div',
	                        { key: 'diaglog_' + dialog.index },
	                        _react2.default.createElement(dialog.component, { asset_id: _this2.props.asset_id, option_id: _this2.props.option_id, index: dialog.index, dialog: dialog.data, callbacks: _this2.state.callbacks, delay: _this2.state.delay })
	                    );
	                })
	            );
	        }
	    }]);
	
	    return ChildConversationDialog;
	}(_react2.default.Component);
	
	ChildConversationDialog.propTypes = {
	    asset_id: _propTypes2.default.number.isRequired,
	    option_id: _propTypes2.default.number.isRequired,
	    dialogs: _propTypes2.default.array.isRequired,
	    callbacks: _propTypes2.default.object.isRequired,
	    onComplete: _propTypes2.default.func,
	    actions: _propTypes2.default.object
	};
	
	ChildConversationDialog.contextTypes = {
	    router: _propTypes2.default.object
	};
	
	function mapStateToProps(state, ownProps) {
	    return {};
	}
	
	function mapDispatchToProps(dispatch) {
	    return {
	        actions: (0, _redux.bindActionCreators)(Object.assign({}, trackingDataActions), dispatch)
	    };
	}
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(ChildConversationDialog);

/***/ },
/* 66 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(5);
	
	var _redux = __webpack_require__(4);
	
	var _Button = __webpack_require__(18);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _AssetImage = __webpack_require__(136);
	
	var _AssetImage2 = _interopRequireDefault(_AssetImage);
	
	var _userDataActions = __webpack_require__(20);
	
	var userDataActions = _interopRequireWildcard(_userDataActions);
	
	var _trackingDataActions = __webpack_require__(7);
	
	var trackingDataActions = _interopRequireWildcard(_trackingDataActions);
	
	var _dialogPopupActions = __webpack_require__(19);
	
	var dialogPopupActions = _interopRequireWildcard(_dialogPopupActions);
	
	var _appHelper = __webpack_require__(3);
	
	var appHelper = _interopRequireWildcard(_appHelper);
	
	var _userDataHelper = __webpack_require__(15);
	
	var userDataHelper = _interopRequireWildcard(_userDataHelper);
	
	var _dataHelper = __webpack_require__(11);
	
	var dataHelper = _interopRequireWildcard(_dataHelper);
	
	var _appConstants = __webpack_require__(13);
	
	var appConstants = _interopRequireWildcard(_appConstants);
	
	var _objectConstants = __webpack_require__(9);
	
	var objectConstants = _interopRequireWildcard(_objectConstants);
	
	var _keyboardConstants = __webpack_require__(14);
	
	var keyboardConstants = _interopRequireWildcard(_keyboardConstants);
	
	var _dialogModels = __webpack_require__(32);
	
	var _gsap = __webpack_require__(8);
	
	var _gsapReactPlugin = __webpack_require__(10);
	
	var _gsapReactPlugin2 = _interopRequireDefault(_gsapReactPlugin);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } //eslint-disable-line import/no-named-as-default
	
	
	var SecondaryImage = function (_React$Component) {
	    _inherits(SecondaryImage, _React$Component);
	
	    function SecondaryImage(props, context) {
	        _classCallCheck(this, SecondaryImage);
	
	        var _this = _possibleConstructorReturn(this, (SecondaryImage.__proto__ || Object.getPrototypeOf(SecondaryImage)).call(this, props, context));
	
	        _this.state = {
	            lang: _this.props.lang,
	            screenObject: _this.props.screenObject,
	            userData: _this.props.userData,
	            status: objectConstants.STATUS_NOT_STARTED,
	            locale: appHelper.getLocalData(_this.props.screenObject),
	            showProgressionButton: false,
	            image: {},
	            screenStatus: "",
	            checkComplete: false,
	            continue_label: appHelper.getLocaleString("continue_label")
	
	        };
	        _this.getAssets = _this.getAssets.bind(_this);
	        _this.show = _this.show.bind(_this);
	        _this.setClass = _this.setClass.bind(_this);
	        _this.scrollToTop = _this.scrollToTop.bind(_this);
	        _this.getImagePath = _this.getImagePath.bind(_this);
	        _this.onCloseAssetDialog = _this.onCloseAssetDialog.bind(_this);
	        _this.launchAsset = _this.launchAsset.bind(_this);
	        _this.setKeyboardAccessibility = _this.setKeyboardAccessibility.bind(_this);
	
	        return _this;
	    }
	
	    _createClass(SecondaryImage, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            this.getAssets();
	        }
	    }, {
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(nextProps) {
	            if (this.state.lang !== nextProps.lang) {
	                var image = appHelper.getImageAsset(this.state.screenObject);
	                this.setState({
	                    lang: nextProps.lang,
	                    locale: appHelper.getLocalData(this.state.screenObject),
	                    image: appHelper.isDefined(image.locale) ? appHelper.getLocalData(image) : image,
	                    continue_label: appHelper.getLocaleString("continue_label")
	                });
	            }
	        }
	    }, {
	        key: 'componentDidUpdate',
	        value: function componentDidUpdate() {}
	    }, {
	        key: 'getAssets',
	        value: function getAssets() {
	            var image = appHelper.getImageAsset(this.state.screenObject);
	            this.setState({ image: appHelper.isDefined(image.locale) ? appHelper.getLocalData(image) : image });
	        }
	    }, {
	        key: 'show',
	        value: function show() {
	            var fileRef = this.refs['image_' + this.state.screenObject.asset_id];
	            if (appHelper.isDefined(fileRef)) {
	                _gsap.TweenLite.set(fileRef, { opacity: 1, height: "auto" });
	                _gsap.TweenLite.from(fileRef, 1, {
	                    height: 0,
	                    opacity: 0,
	                    ease: _gsap.Expo.easeInOut
	                });
	            }
	        }
	    }, {
	        key: 'scrollToTop',
	        value: function scrollToTop() {}
	    }, {
	        key: 'getImagePath',
	        value: function getImagePath(image) {
	            if (appConstants.DEVELOPMENT_MODE) {
	                if (appHelper.isDefined(image) && image.length > 0) {
	                    return __webpack_require__(16)("./" + image);
	                }
	            } else {
	                return image;
	            }
	        }
	    }, {
	        key: 'setClass',
	        value: function setClass() {
	            if (this.state.status === objectConstants.STATUS_COMPLETE) {
	                return "complete";
	            } else {
	                return "not-started";
	            }
	        }
	    }, {
	        key: 'onCloseAssetDialog',
	        value: function onCloseAssetDialog(viewed) {
	            /*let objectUserData = userDataHelper.getAttachmentObjectUserData(this.state.userData, this.state.resource.asset_id);
	            if(objectUserData.status !== objectConstants.STATUS_COMPLETE && viewed) {
	                this.updateResourceObjectResult();
	            }*/
	        }
	    }, {
	        key: 'launchAsset',
	        value: function launchAsset() {
	            var childComponenents = [];
	            var config = Object.assign({}, _dialogModels.ASSET_CONFIG, {
	                title: this.state.locale.label,
	                onClose: this.onCloseAssetDialog,
	                showCloseBtn: false,
	                theme: "dialog-asset-image",
	                sourceId: 'image_btn_' + this.state.screenObject.asset_id
	            });
	
	            for (var i = 0; i < config.childComponents.length; i++) {
	                var child = config.childComponents[i];
	                child = Object.assign({}, child, {
	                    childComponent: _AssetImage2.default,
	                    componentProps: Object.assign({}, {
	                        screenObject: this.state.screenObject,
	                        callbacks: {}
	
	                    })
	                });
	
	                childComponenents = dataHelper.immutablePush(childComponenents, child);
	            }
	            config = Object.assign({}, config, {
	                childComponents: childComponenents
	            });
	
	            this.props.actions.setNewAssetDialog(config);
	        }
	    }, {
	        key: 'setKeyboardAccessibility',
	        value: function setKeyboardAccessibility(event) {
	
	            if (event.which === keyboardConstants.ENTER_KEY || event.which === keyboardConstants.SPACEBAR_KEY) {
	                event.preventDefault();
	                event.stopPropagation();
	                this.launchAsset();
	            }
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            return _react2.default.createElement(
	                'div',
	                { className: 'object-container', ref: 'image_' + this.state.screenObject.asset_id },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'asset-image', onClick: this.launchAsset, id: 'image_btn_' + this.state.screenObject.asset_id, onKeyDown: this.setKeyboardAccessibility, role: 'link', tabIndex: 0 },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'img-container' },
	                        _react2.default.createElement('img', { src: this.getImagePath(this.state.image.src), alt: this.state.locale.label, id: appHelper.isDefined(this.props.id) ? this.props.id : 'image_' + this.state.screenObject.asset_id })
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'asset-desc' },
	                        appHelper.isDefined(this.state.locale.label) && this.state.locale.label.length > 0 ? _react2.default.createElement('div', { className: 'title', dangerouslySetInnerHTML: { __html: this.state.locale.label } }) : null,
	                        appHelper.isDefined(this.state.locale.description) && this.state.locale.description !== null && this.state.locale.description.length > 0 ? _react2.default.createElement('div', { className: 'desc-text', dangerouslySetInnerHTML: { __html: this.state.locale.description } }) : null
	                    )
	                ),
	                this.state.showProgressionButton ? _react2.default.createElement(_Button2.default, { label: this.state.continue_label,
	                    id: this.state.screenObject + '_button',
	                    onClick: this.onProgressionBtnClicked }) : null
	            );
	        }
	    }]);
	
	    return SecondaryImage;
	}(_react2.default.Component);
	
	SecondaryImage.propTypes = {
	    screenObject: _propTypes2.default.object.isRequired,
	    id: _propTypes2.default.string,
	    index: _propTypes2.default.number,
	    userData: _propTypes2.default.object.isRequired,
	    lang: _propTypes2.default.string.isRequired,
	    actions: _propTypes2.default.object.isRequired
	};
	
	SecondaryImage.contextTypes = {
	    router: _propTypes2.default.object
	};
	
	/*
	* <ParagraphText screenObject={this.state.screenObject}
	                                   ref={`${this.state.screenObject.asset_id}_paragraph`}
	                                   id={`${this.state.screenObject}_description`}
	                                   class_name="document-description"
	                                   objectKey={`description`}/>*/
	
	function mapStateToProps(state, ownProps) {
	    var lang = state.userData.lang;
	    return {
	        lang: lang,
	        userData: state.userData
	    };
	}
	
	function mapDispatchToProps(dispatch) {
	    return {
	        actions: (0, _redux.bindActionCreators)(Object.assign({}, userDataActions, trackingDataActions, dialogPopupActions), dispatch)
	    };
	}
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(SecondaryImage);

/***/ },
/* 67 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(5);
	
	var _redux = __webpack_require__(4);
	
	var _Button = __webpack_require__(18);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _AssetImage = __webpack_require__(136);
	
	var _AssetImage2 = _interopRequireDefault(_AssetImage);
	
	var _userDataActions = __webpack_require__(20);
	
	var userDataActions = _interopRequireWildcard(_userDataActions);
	
	var _trackingDataActions = __webpack_require__(7);
	
	var trackingDataActions = _interopRequireWildcard(_trackingDataActions);
	
	var _dialogPopupActions = __webpack_require__(19);
	
	var dialogPopupActions = _interopRequireWildcard(_dialogPopupActions);
	
	var _appHelper = __webpack_require__(3);
	
	var appHelper = _interopRequireWildcard(_appHelper);
	
	var _userDataHelper = __webpack_require__(15);
	
	var userDataHelper = _interopRequireWildcard(_userDataHelper);
	
	var _dataHelper = __webpack_require__(11);
	
	var dataHelper = _interopRequireWildcard(_dataHelper);
	
	var _appConstants = __webpack_require__(13);
	
	var appConstants = _interopRequireWildcard(_appConstants);
	
	var _objectConstants = __webpack_require__(9);
	
	var objectConstants = _interopRequireWildcard(_objectConstants);
	
	var _dialogModels = __webpack_require__(32);
	
	var _gsap = __webpack_require__(8);
	
	var _gsapReactPlugin = __webpack_require__(10);
	
	var _gsapReactPlugin2 = _interopRequireDefault(_gsapReactPlugin);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } //eslint-disable-line import/no-named-as-default
	
	
	var SecondaryLibraryImage = function (_React$Component) {
	    _inherits(SecondaryLibraryImage, _React$Component);
	
	    function SecondaryLibraryImage(props, context) {
	        _classCallCheck(this, SecondaryLibraryImage);
	
	        var _this = _possibleConstructorReturn(this, (SecondaryLibraryImage.__proto__ || Object.getPrototypeOf(SecondaryLibraryImage)).call(this, props, context));
	
	        _this.state = {
	            lang: _this.props.lang,
	            screenObject: _this.props.screenObject,
	
	            image: {},
	            screenStatus: "",
	            continue_label: appHelper.getLocaleString("continue_label"),
	            credit_label: appHelper.getLocaleString("credit_label")
	
	        };
	        _this.getAssets = _this.getAssets.bind(_this);
	        _this.show = _this.show.bind(_this);
	        _this.getImagePath = _this.getImagePath.bind(_this);
	        return _this;
	    }
	
	    _createClass(SecondaryLibraryImage, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            this.getAssets();
	        }
	    }, {
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(nextProps) {
	            if (this.state.lang !== nextProps.lang) {
	                this.setState({
	                    lang: nextProps.lang,
	                    continue_label: appHelper.getLocaleString("continue_label"),
	                    credit_label: appHelper.getLocaleString("credit_label")
	                });
	            }
	        }
	    }, {
	        key: 'componentDidUpdate',
	        value: function componentDidUpdate() {}
	    }, {
	        key: 'getAssets',
	        value: function getAssets() {
	            var image = appHelper.getLibraryImageAsset(this.state.screenObject);
	            this.setState({ image: image });
	        }
	    }, {
	        key: 'show',
	        value: function show() {
	            var fileRef = this.refs['image_' + this.state.screenObject.id];
	            if (appHelper.isDefined(fileRef)) {
	                _gsap.TweenLite.set(fileRef, { opacity: 1, height: "auto" });
	                _gsap.TweenLite.from(fileRef, 0, {
	                    height: 0,
	                    opacity: 0,
	                    ease: _gsap.Expo.easeInOut
	                });
	            }
	        }
	    }, {
	        key: 'getImagePath',
	        value: function getImagePath(image) {
	            if (appConstants.DEVELOPMENT_MODE) {
	                if (appHelper.isDefined(image) && image.length > 0) {
	                    return __webpack_require__(16)("./" + image);
	                }
	            } else {
	                return image;
	            }
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            return _react2.default.createElement(
	                'div',
	                { className: 'object-container', ref: 'image_' + this.state.screenObject.id },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'library-image' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'img-container' },
	                        _react2.default.createElement('img', { src: this.getImagePath(this.state.image.src), alt: '', id: appHelper.isDefined(this.props.id) ? this.props.id : 'image_file_' + this.state.screenObject.id })
	                    ),
	                    appHelper.isDefined(this.state.image.credit) && this.state.image.credit.length > 0 && _react2.default.createElement(
	                        'div',
	                        { className: 'image-credit center', style: this.state.imageStyles },
	                        this.state.cedit_label,
	                        ': ',
	                        this.state.image.credit
	                    )
	                ),
	                this.state.showProgressionButton ? _react2.default.createElement(_Button2.default, { label: this.state.continue_label,
	                    id: this.state.screenObject + '_button',
	                    onClick: this.onProgressionBtnClicked }) : null
	            );
	        }
	    }]);
	
	    return SecondaryLibraryImage;
	}(_react2.default.Component);
	
	SecondaryLibraryImage.propTypes = {
	    screenObject: _propTypes2.default.object.isRequired,
	    id: _propTypes2.default.string,
	    index: _propTypes2.default.number,
	    userData: _propTypes2.default.object.isRequired,
	    lang: _propTypes2.default.string.isRequired,
	    actions: _propTypes2.default.object.isRequired
	};
	
	SecondaryLibraryImage.contextTypes = {
	    router: _propTypes2.default.object
	};
	
	function mapStateToProps(state, ownProps) {
	    var lang = state.userData.lang;
	    return {
	        lang: lang,
	        userData: state.userData
	    };
	}
	
	function mapDispatchToProps(dispatch) {
	    return {
	        actions: (0, _redux.bindActionCreators)(Object.assign({}, userDataActions, trackingDataActions, dialogPopupActions), dispatch)
	    };
	}
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(SecondaryLibraryImage);

/***/ },
/* 68 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.RESOURCE_PROPS = exports.FONT_SIZE = exports.ALLOWED_AUDIO_FILES = exports.ALLOWED_IMAGE_FILES = exports.USER_DATA_SCREEN_OBJECT = exports.USER_DATA_SCREEN = exports.USER_DATA_BITE_KPI = exports.USER_DATA_BADGE = exports.USER_DATA_BITE = exports.USER_DATA_MODEL = exports.TITLES = exports.TRACKING_DATA = exports.INIT_DATA = exports.TRACKING_READY = exports.IMAGES_PRE_LOADED = exports.DATA_LOADED = exports.SETTINGS = undefined;
	
	var _appConstants = __webpack_require__(13);
	
	var AppConstants = _interopRequireWildcard(_appConstants);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	var SETTINGS = exports.SETTINGS = {
	    DEVELOPMENT_MODE: AppConstants.DEVELOPMENT_MODE
	};
	
	var DATA_LOADED = exports.DATA_LOADED = {
	    constant: AppConstants.INIT_STATE_DATA_LOADED,
	    complete: false,
	    localeStringConstant: "retrieving_label",
	    message: ""
	};
	
	var IMAGES_PRE_LOADED = exports.IMAGES_PRE_LOADED = {
	    constant: AppConstants.INIT_STATE_IMAGES_PRE_LOADED,
	    complete: false,
	    localeStringConstant: "preloading_label",
	    message: ""
	};
	
	var TRACKING_READY = exports.TRACKING_READY = {
	    constant: AppConstants.INIT_STATE_TRACKING_READY,
	    complete: false,
	    localeStringConstant: "initialising_tracking_label",
	    message: ""
	};
	
	var INIT_DATA = exports.INIT_DATA = {
	    initialised: false,
	    checkInitialised: true,
	    currentStateIndex: 0,
	    currentState: AppConstants.INIT_STATE_DATA_LOADED,
	    localeStringConstant: "creating_your_experience_label",
	    mainMessage: "",
	    resumed: false,
	    lang_suspend_data_set: false,
	    lang_preference_invoked: false,
	    lang_preference_set: false,
	    initialisedStates: [DATA_LOADED, IMAGES_PRE_LOADED, TRACKING_READY]
	};
	
	var TRACKING_DATA = exports.TRACKING_DATA = {
	    initialised: false,
	    suspend_data: {},
	    student_id: "",
	    student_name: "",
	    first_name: "",
	    last_name: "",
	    lesson_location: 0,
	    lesson_status: "",
	    score_raw: 0,
	    score_min: 0,
	    score_max: 100,
	    location_history: [],
	    last_lesson_location: 0,
	    lrs: {}
	};
	
	var TITLES = exports.TITLES = {
	    projectTitle: "",
	    biteTitle: "",
	    screenTitle: ""
	};
	
	//USER DATA MODELS
	
	var USER_DATA_MODEL = exports.USER_DATA_MODEL = {
	    status: "",
	    percentageComplete: 0,
	    bites: []
	};
	
	var USER_DATA_BITE = exports.USER_DATA_BITE = {
	    bite_id: "",
	    screens: [],
	    kpis: [],
	    status: "",
	    percentageComplete: 0
	};
	
	var USER_DATA_BADGE = exports.USER_DATA_BADGE = {
	    badge_id: 0,
	    achieved: 0,
	    achievedOn: []
	};
	
	var USER_DATA_BITE_KPI = exports.USER_DATA_BITE_KPI = {
	    kpi_id: 0,
	    is_primary: false,
	    min: 0,
	    max: 0,
	    start: 0,
	    current: 0,
	    yellow: 0,
	    green: 0,
	    style: "",
	    unit_type: "",
	    is_visible: false,
	    positive_type: "",
	    decimals_points: 0,
	    totalPoints: 0,
	    currentScoreRange: "",
	    last: 0,
	    value: 0,
	    history: []
	};
	
	var USER_DATA_SCREEN = exports.USER_DATA_SCREEN = {
	    screen_id: "",
	    objects: [],
	    status: ""
	};
	
	var USER_DATA_SCREEN_OBJECT = exports.USER_DATA_SCREEN_OBJECT = {
	    object_id: "",
	    asset_type_code: "",
	    status: ""
	};
	
	var ALLOWED_IMAGE_FILES = exports.ALLOWED_IMAGE_FILES = ["gif", "jpg", "jpeg", "svg", "png"];
	
	var ALLOWED_AUDIO_FILES = exports.ALLOWED_AUDIO_FILES = ["mp3"];
	
	var FONT_SIZE = exports.FONT_SIZE = {
	    currentFontSize: 100,
	    maxFontSize: 200,
	    minFontSize: 75,
	    resetFontSize: 100
	};
	
	var RESOURCE_PROPS = exports.RESOURCE_PROPS = {
	    sourceId: "",
	    activeResourcesId: 0
	};

/***/ },
/* 69 */
/***/ function(module, exports) {

	var toString = {}.toString;
	
	module.exports = function (it) {
	  return toString.call(it).slice(8, -1);
	};


/***/ },
/* 70 */
/***/ function(module, exports) {

	var core = module.exports = { version: '2.5.7' };
	if (typeof __e == 'number') __e = core; // eslint-disable-line no-undef


/***/ },
/* 71 */
/***/ function(module, exports, __webpack_require__) {

	// optional / simple context binding
	var aFunction = __webpack_require__(50);
	module.exports = function (fn, that, length) {
	  aFunction(fn);
	  if (that === undefined) return fn;
	  switch (length) {
	    case 1: return function (a) {
	      return fn.call(that, a);
	    };
	    case 2: return function (a, b) {
	      return fn.call(that, a, b);
	    };
	    case 3: return function (a, b, c) {
	      return fn.call(that, a, b, c);
	    };
	  }
	  return function (/* ...args */) {
	    return fn.apply(that, arguments);
	  };
	};


/***/ },
/* 72 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var fails = __webpack_require__(26);
	
	module.exports = function (method, arg) {
	  return !!method && fails(function () {
	    // eslint-disable-next-line no-useless-call
	    arg ? method.call(null, function () { /* empty */ }, 1) : method.call(null);
	  });
	};


/***/ },
/* 73 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var React = __webpack_require__(1);
	var factory = __webpack_require__(325);
	
	if (typeof React === 'undefined') {
	  throw Error(
	    'create-react-class could not find the React object. If you are using script tags, ' +
	      'make sure that React is being loaded before create-react-class.'
	  );
	}
	
	// Hack to grab NoopUpdateQueue from isomorphic React
	var ReactNoopUpdateQueue = new React.Component().updater;
	
	module.exports = factory(
	  React.Component,
	  React.isValidElement,
	  ReactNoopUpdateQueue
	);


/***/ },
/* 74 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(29),
	    _assign = __webpack_require__(36);
	
	var CallbackQueue = __webpack_require__(383);
	var PooledClass = __webpack_require__(113);
	var ReactFeatureFlags = __webpack_require__(391);
	var ReactReconciler = __webpack_require__(114);
	var Transaction = __webpack_require__(186);
	
	var invariant = __webpack_require__(21);
	
	var dirtyComponents = [];
	var updateBatchNumber = 0;
	var asapCallbackQueue = CallbackQueue.getPooled();
	var asapEnqueued = false;
	
	var batchingStrategy = null;
	
	function ensureInjected() {
	  !(ReactUpdates.ReactReconcileTransaction && batchingStrategy) ?  false ? invariant(false, 'ReactUpdates: must inject a reconcile transaction class and batching strategy') : _prodInvariant('123') : void 0;
	}
	
	var NESTED_UPDATES = {
	  initialize: function () {
	    this.dirtyComponentsLength = dirtyComponents.length;
	  },
	  close: function () {
	    if (this.dirtyComponentsLength !== dirtyComponents.length) {
	      // Additional updates were enqueued by componentDidUpdate handlers or
	      // similar; before our own UPDATE_QUEUEING wrapper closes, we want to run
	      // these new updates so that if A's componentDidUpdate calls setState on
	      // B, B will update before the callback A's updater provided when calling
	      // setState.
	      dirtyComponents.splice(0, this.dirtyComponentsLength);
	      flushBatchedUpdates();
	    } else {
	      dirtyComponents.length = 0;
	    }
	  }
	};
	
	var UPDATE_QUEUEING = {
	  initialize: function () {
	    this.callbackQueue.reset();
	  },
	  close: function () {
	    this.callbackQueue.notifyAll();
	  }
	};
	
	var TRANSACTION_WRAPPERS = [NESTED_UPDATES, UPDATE_QUEUEING];
	
	function ReactUpdatesFlushTransaction() {
	  this.reinitializeTransaction();
	  this.dirtyComponentsLength = null;
	  this.callbackQueue = CallbackQueue.getPooled();
	  this.reconcileTransaction = ReactUpdates.ReactReconcileTransaction.getPooled(
	  /* useCreateElement */true);
	}
	
	_assign(ReactUpdatesFlushTransaction.prototype, Transaction, {
	  getTransactionWrappers: function () {
	    return TRANSACTION_WRAPPERS;
	  },
	
	  destructor: function () {
	    this.dirtyComponentsLength = null;
	    CallbackQueue.release(this.callbackQueue);
	    this.callbackQueue = null;
	    ReactUpdates.ReactReconcileTransaction.release(this.reconcileTransaction);
	    this.reconcileTransaction = null;
	  },
	
	  perform: function (method, scope, a) {
	    // Essentially calls `this.reconcileTransaction.perform(method, scope, a)`
	    // with this transaction's wrappers around it.
	    return Transaction.perform.call(this, this.reconcileTransaction.perform, this.reconcileTransaction, method, scope, a);
	  }
	});
	
	PooledClass.addPoolingTo(ReactUpdatesFlushTransaction);
	
	function batchedUpdates(callback, a, b, c, d, e) {
	  ensureInjected();
	  return batchingStrategy.batchedUpdates(callback, a, b, c, d, e);
	}
	
	/**
	 * Array comparator for ReactComponents by mount ordering.
	 *
	 * @param {ReactComponent} c1 first component you're comparing
	 * @param {ReactComponent} c2 second component you're comparing
	 * @return {number} Return value usable by Array.prototype.sort().
	 */
	function mountOrderComparator(c1, c2) {
	  return c1._mountOrder - c2._mountOrder;
	}
	
	function runBatchedUpdates(transaction) {
	  var len = transaction.dirtyComponentsLength;
	  !(len === dirtyComponents.length) ?  false ? invariant(false, 'Expected flush transaction\'s stored dirty-components length (%s) to match dirty-components array length (%s).', len, dirtyComponents.length) : _prodInvariant('124', len, dirtyComponents.length) : void 0;
	
	  // Since reconciling a component higher in the owner hierarchy usually (not
	  // always -- see shouldComponentUpdate()) will reconcile children, reconcile
	  // them before their children by sorting the array.
	  dirtyComponents.sort(mountOrderComparator);
	
	  // Any updates enqueued while reconciling must be performed after this entire
	  // batch. Otherwise, if dirtyComponents is [A, B] where A has children B and
	  // C, B could update twice in a single batch if C's render enqueues an update
	  // to B (since B would have already updated, we should skip it, and the only
	  // way we can know to do so is by checking the batch counter).
	  updateBatchNumber++;
	
	  for (var i = 0; i < len; i++) {
	    // If a component is unmounted before pending changes apply, it will still
	    // be here, but we assume that it has cleared its _pendingCallbacks and
	    // that performUpdateIfNecessary is a noop.
	    var component = dirtyComponents[i];
	
	    // If performUpdateIfNecessary happens to enqueue any new updates, we
	    // shouldn't execute the callbacks until the next render happens, so
	    // stash the callbacks first
	    var callbacks = component._pendingCallbacks;
	    component._pendingCallbacks = null;
	
	    var markerName;
	    if (ReactFeatureFlags.logTopLevelRenders) {
	      var namedComponent = component;
	      // Duck type TopLevelWrapper. This is probably always true.
	      if (component._currentElement.type.isReactTopLevelWrapper) {
	        namedComponent = component._renderedComponent;
	      }
	      markerName = 'React update: ' + namedComponent.getName();
	      console.time(markerName);
	    }
	
	    ReactReconciler.performUpdateIfNecessary(component, transaction.reconcileTransaction, updateBatchNumber);
	
	    if (markerName) {
	      console.timeEnd(markerName);
	    }
	
	    if (callbacks) {
	      for (var j = 0; j < callbacks.length; j++) {
	        transaction.callbackQueue.enqueue(callbacks[j], component.getPublicInstance());
	      }
	    }
	  }
	}
	
	var flushBatchedUpdates = function () {
	  // ReactUpdatesFlushTransaction's wrappers will clear the dirtyComponents
	  // array and perform any updates enqueued by mount-ready handlers (i.e.,
	  // componentDidUpdate) but we need to check here too in order to catch
	  // updates enqueued by setState callbacks and asap calls.
	  while (dirtyComponents.length || asapEnqueued) {
	    if (dirtyComponents.length) {
	      var transaction = ReactUpdatesFlushTransaction.getPooled();
	      transaction.perform(runBatchedUpdates, null, transaction);
	      ReactUpdatesFlushTransaction.release(transaction);
	    }
	
	    if (asapEnqueued) {
	      asapEnqueued = false;
	      var queue = asapCallbackQueue;
	      asapCallbackQueue = CallbackQueue.getPooled();
	      queue.notifyAll();
	      CallbackQueue.release(queue);
	    }
	  }
	};
	
	/**
	 * Mark a component as needing a rerender, adding an optional callback to a
	 * list of functions which will be executed once the rerender occurs.
	 */
	function enqueueUpdate(component) {
	  ensureInjected();
	
	  // Various parts of our code (such as ReactCompositeComponent's
	  // _renderValidatedComponent) assume that calls to render aren't nested;
	  // verify that that's the case. (This is called by each top-level update
	  // function, like setState, forceUpdate, etc.; creation and
	  // destruction of top-level components is guarded in ReactMount.)
	
	  if (!batchingStrategy.isBatchingUpdates) {
	    batchingStrategy.batchedUpdates(enqueueUpdate, component);
	    return;
	  }
	
	  dirtyComponents.push(component);
	  if (component._updateBatchNumber == null) {
	    component._updateBatchNumber = updateBatchNumber + 1;
	  }
	}
	
	/**
	 * Enqueue a callback to be run at the end of the current batching cycle. Throws
	 * if no updates are currently being performed.
	 */
	function asap(callback, context) {
	  invariant(batchingStrategy.isBatchingUpdates, "ReactUpdates.asap: Can't enqueue an asap callback in a context where" + 'updates are not being batched.');
	  asapCallbackQueue.enqueue(callback, context);
	  asapEnqueued = true;
	}
	
	var ReactUpdatesInjection = {
	  injectReconcileTransaction: function (ReconcileTransaction) {
	    !ReconcileTransaction ?  false ? invariant(false, 'ReactUpdates: must provide a reconcile transaction class') : _prodInvariant('126') : void 0;
	    ReactUpdates.ReactReconcileTransaction = ReconcileTransaction;
	  },
	
	  injectBatchingStrategy: function (_batchingStrategy) {
	    !_batchingStrategy ?  false ? invariant(false, 'ReactUpdates: must provide a batching strategy') : _prodInvariant('127') : void 0;
	    !(typeof _batchingStrategy.batchedUpdates === 'function') ?  false ? invariant(false, 'ReactUpdates: must provide a batchedUpdates() function') : _prodInvariant('128') : void 0;
	    !(typeof _batchingStrategy.isBatchingUpdates === 'boolean') ?  false ? invariant(false, 'ReactUpdates: must provide an isBatchingUpdates boolean attribute') : _prodInvariant('129') : void 0;
	    batchingStrategy = _batchingStrategy;
	  }
	};
	
	var ReactUpdates = {
	  /**
	   * React references `ReactReconcileTransaction` using this property in order
	   * to allow dependency injection.
	   *
	   * @internal
	   */
	  ReactReconcileTransaction: null,
	
	  batchedUpdates: batchedUpdates,
	  enqueueUpdate: enqueueUpdate,
	  flushBatchedUpdates: flushBatchedUpdates,
	  injection: ReactUpdatesInjection,
	  asap: asap
	};
	
	module.exports = ReactUpdates;

/***/ },
/* 75 */
/***/ function(module, exports, __webpack_require__) {

	// 0 -> Array#forEach
	// 1 -> Array#map
	// 2 -> Array#filter
	// 3 -> Array#some
	// 4 -> Array#every
	// 5 -> Array#find
	// 6 -> Array#findIndex
	var ctx = __webpack_require__(71);
	var IObject = __webpack_require__(139);
	var toObject = __webpack_require__(43);
	var toLength = __webpack_require__(40);
	var asc = __webpack_require__(206);
	module.exports = function (TYPE, $create) {
	  var IS_MAP = TYPE == 1;
	  var IS_FILTER = TYPE == 2;
	  var IS_SOME = TYPE == 3;
	  var IS_EVERY = TYPE == 4;
	  var IS_FIND_INDEX = TYPE == 6;
	  var NO_HOLES = TYPE == 5 || IS_FIND_INDEX;
	  var create = $create || asc;
	  return function ($this, callbackfn, that) {
	    var O = toObject($this);
	    var self = IObject(O);
	    var f = ctx(callbackfn, that, 3);
	    var length = toLength(self.length);
	    var index = 0;
	    var result = IS_MAP ? create($this, length) : IS_FILTER ? create($this, 0) : undefined;
	    var val, res;
	    for (;length > index; index++) if (NO_HOLES || index in self) {
	      val = self[index];
	      res = f(val, index, O);
	      if (TYPE) {
	        if (IS_MAP) result[index] = res;   // map
	        else if (res) switch (TYPE) {
	          case 3: return true;             // some
	          case 5: return val;              // find
	          case 6: return index;            // findIndex
	          case 2: result.push(val);        // filter
	        } else if (IS_EVERY) return false; // every
	      }
	    }
	    return IS_FIND_INDEX ? -1 : IS_SOME || IS_EVERY ? IS_EVERY : result;
	  };
	};


/***/ },
/* 76 */
/***/ function(module, exports) {

	// 7.2.1 RequireObjectCoercible(argument)
	module.exports = function (it) {
	  if (it == undefined) throw TypeError("Can't call method on  " + it);
	  return it;
	};


/***/ },
/* 77 */
/***/ function(module, exports, __webpack_require__) {

	// most Object methods by ES6 should accept primitives
	var $export = __webpack_require__(6);
	var core = __webpack_require__(70);
	var fails = __webpack_require__(26);
	module.exports = function (KEY, exec) {
	  var fn = (core.Object || {})[KEY] || Object[KEY];
	  var exp = {};
	  exp[KEY] = exec(fn);
	  $export($export.S + $export.F * fails(function () { fn(1); }), 'Object', exp);
	};


/***/ },
/* 78 */
/***/ function(module, exports) {

	// 7.1.4 ToInteger
	var ceil = Math.ceil;
	var floor = Math.floor;
	module.exports = function (it) {
	  return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
	};


/***/ },
/* 79 */
/***/ function(module, exports, __webpack_require__) {

	// 7.1.1 ToPrimitive(input [, PreferredType])
	var isObject = __webpack_require__(27);
	// instead of the ES6 spec version, we didn't implement @@toPrimitive case
	// and the second argument - flag - preferred type is a string
	module.exports = function (it, S) {
	  if (!isObject(it)) return it;
	  var fn, val;
	  if (S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
	  if (typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it))) return val;
	  if (!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
	  throw TypeError("Can't convert object to primitive value");
	};


/***/ },
/* 80 */
/***/ function(module, exports) {

	"use strict";
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	function makeEmptyFunction(arg) {
	  return function () {
	    return arg;
	  };
	}
	
	/**
	 * This function accepts and discards inputs; it has no side effects. This is
	 * primarily useful idiomatically for overridable function endpoints which
	 * always need to be callable, since JS lacks a null-call idiom ala Cocoa.
	 */
	var emptyFunction = function emptyFunction() {};
	
	emptyFunction.thatReturns = makeEmptyFunction;
	emptyFunction.thatReturnsFalse = makeEmptyFunction(false);
	emptyFunction.thatReturnsTrue = makeEmptyFunction(true);
	emptyFunction.thatReturnsNull = makeEmptyFunction(null);
	emptyFunction.thatReturnsThis = function () {
	  return this;
	};
	emptyFunction.thatReturnsArgument = function (arg) {
	  return arg;
	};
	
	module.exports = emptyFunction;

/***/ },
/* 81 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	exports['default'] = createSinglePlayer;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _props2 = __webpack_require__(190);
	
	var _utils = __webpack_require__(63);
	
	var _Player = __webpack_require__(265);
	
	var _Player2 = _interopRequireDefault(_Player);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var SUPPORTED_PROPS = Object.keys(_props2.propTypes);
	
	function createSinglePlayer(activePlayer) {
	  var _class, _temp2;
	
	  return _temp2 = _class = function (_Component) {
	    _inherits(SinglePlayer, _Component);
	
	    function SinglePlayer() {
	      var _ref;
	
	      var _temp, _this, _ret;
	
	      _classCallCheck(this, SinglePlayer);
	
	      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	        args[_key] = arguments[_key];
	      }
	
	      return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = SinglePlayer.__proto__ || Object.getPrototypeOf(SinglePlayer)).call.apply(_ref, [this].concat(args))), _this), _this.config = (0, _utils.getConfig)(_this.props, _props2.defaultProps, true), _this.getDuration = function () {
	        if (!_this.player) return null;
	        return _this.player.getDuration();
	      }, _this.getCurrentTime = function () {
	        if (!_this.player) return null;
	        return _this.player.getCurrentTime();
	      }, _this.getSecondsLoaded = function () {
	        if (!_this.player) return null;
	        return _this.player.getSecondsLoaded();
	      }, _this.getInternalPlayer = function () {
	        var key = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'player';
	
	        if (!_this.player) return null;
	        return _this.player.getInternalPlayer(key);
	      }, _this.seekTo = function (fraction) {
	        if (!_this.player) return null;
	        _this.player.seekTo(fraction);
	      }, _this.ref = function (player) {
	        _this.player = player;
	      }, _temp), _possibleConstructorReturn(_this, _ret);
	    }
	
	    _createClass(SinglePlayer, [{
	      key: 'shouldComponentUpdate',
	      value: function shouldComponentUpdate(nextProps) {
	        return !(0, _utils.isEqual)(this.props, nextProps);
	      }
	    }, {
	      key: 'componentWillUpdate',
	      value: function componentWillUpdate(nextProps) {
	        this.config = (0, _utils.getConfig)(nextProps, _props2.defaultProps);
	      }
	    }, {
	      key: 'render',
	      value: function render() {
	        if (!activePlayer.canPlay(this.props.url)) {
	          return null;
	        }
	        var _props = this.props,
	            style = _props.style,
	            width = _props.width,
	            height = _props.height,
	            Wrapper = _props.wrapper;
	
	        var otherProps = (0, _utils.omit)(this.props, SUPPORTED_PROPS, _props2.DEPRECATED_CONFIG_PROPS);
	        return _react2['default'].createElement(
	          Wrapper,
	          _extends({ style: _extends({}, style, { width: width, height: height }) }, otherProps),
	          _react2['default'].createElement(_Player2['default'], _extends({}, this.props, {
	            ref: this.ref,
	            activePlayer: activePlayer,
	            config: this.config
	          }))
	        );
	      }
	    }]);
	
	    return SinglePlayer;
	  }(_react.Component), _class.displayName = activePlayer.displayName + 'Player', _class.propTypes = _props2.propTypes, _class.defaultProps = _props2.defaultProps, _class.canPlay = activePlayer.canPlay, _temp2;
	}

/***/ },
/* 82 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(5);
	
	var _redux = __webpack_require__(4);
	
	var _appHelper = __webpack_require__(3);
	
	var appHelper = _interopRequireWildcard(_appHelper);
	
	var _kpiHelper = __webpack_require__(35);
	
	var kpiHelper = _interopRequireWildcard(_kpiHelper);
	
	var _dataHelper = __webpack_require__(11);
	
	var dataHelper = _interopRequireWildcard(_dataHelper);
	
	var _kpiConstants = __webpack_require__(37);
	
	var kpiConstants = _interopRequireWildcard(_kpiConstants);
	
	var _objectConstants = __webpack_require__(9);
	
	var objectConstants = _interopRequireWildcard(_objectConstants);
	
	var _appDataActions = __webpack_require__(12);
	
	var appDataActions = _interopRequireWildcard(_appDataActions);
	
	var _trackingDataActions = __webpack_require__(7);
	
	var trackingDataActions = _interopRequireWildcard(_trackingDataActions);
	
	var _gsap = __webpack_require__(8);
	
	var _gsapReactPlugin = __webpack_require__(10);
	
	var _gsapReactPlugin2 = _interopRequireDefault(_gsapReactPlugin);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var RotationKpiMeter = function (_React$Component) {
	    _inherits(RotationKpiMeter, _React$Component);
	
	    function RotationKpiMeter(props, context) {
	        _classCallCheck(this, RotationKpiMeter);
	
	        var _this = _possibleConstructorReturn(this, (RotationKpiMeter.__proto__ || Object.getPrototypeOf(RotationKpiMeter)).call(this, props, context));
	
	        _this.state = {
	            lang: _this.props.lang,
	            kpiDefaults: _this.props.kpiDefaults,
	            userKpiResult: _this.props.userKpiResult,
	            meterParams: _this.props.meterParams,
	            feedback_styles: _this.props.feedback_styles,
	            showPointsIndicator: false,
	            statusIndicatorClass: _this.props.responseReview ? _this.props.userKpiResult.statusIndicatorClass.class : "",
	            svgExtensionClass: "",
	            locale: {},
	            guid: dataHelper.createGuid(),
	            redrawMeter: false,
	            kpiUpdate: {
	                current: 0,
	                new: 0,
	                difference: 0,
	                type: ""
	            },
	            getUpdateDifference: false,
	            current_score_for_label: appHelper.getLocaleString("current_score_for_label"),
	            start_label: appHelper.getLocaleString("start_label")
	        };
	
	        _this.getLocale = _this.getLocale.bind(_this);
	        _this.renderSvg = _this.renderSvg.bind(_this);
	        _this.setSvgClass = _this.setSvgClass.bind(_this);
	        _this.setMeterRotation = _this.setMeterRotation.bind(_this);
	        _this.setDefaultMeterRotation = _this.setDefaultMeterRotation.bind(_this);
	        _this.updateMeterValues = _this.updateMeterValues.bind(_this);
	        _this.updateKpiClassValues = _this.updateKpiClassValues.bind(_this);
	        _this.updateMeterRotation = _this.updateMeterRotation.bind(_this);
	        _this.onRotationComplete = _this.onRotationComplete.bind(_this);
	        _this.getValue = _this.getValue.bind(_this);
	        _this.setUpdateDifference = _this.setUpdateDifference.bind(_this);
	        _this.getCurrentValue = _this.getCurrentValue.bind(_this);
	        return _this;
	    }
	
	    _createClass(RotationKpiMeter, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	
	            this.getLocale();
	            this.renderSvg();
	            if (this.props.displayState === kpiConstants.KPI_DISPLAY_STATE_START) {
	                this.setDefaultMeterRotation();
	            } else {
	                this.setMeterRotation();
	            }
	        }
	    }, {
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(nextProps) {
	            if (this.state.userKpiResult !== nextProps.userKpiResult || this.state.kpiDefaults !== nextProps.kpiDefaults) {
	                var kpiUpdate = {
	                    current: this.state.userKpiResult.current,
	                    new: nextProps.userKpiResult.current
	                };
	                this.setState({
	                    statusIndicatorClass: "",
	                    kpiUpdate: Object.assign({}, kpiUpdate),
	                    getUpdateDifference: true,
	                    userKpiResult: Object.assign({}, nextProps.userKpiResult),
	                    kpiDefaults: Object.assign({}, nextProps.kpiDefaults),
	                    redrawMeter: appHelper.isDefined(this.props.allowKpiRedraw) && this.props.allowKpiRedraw
	                });
	                this.updateMeterValues(nextProps.userKpiResult);
	            }
	            if (this.state.lang !== nextProps.lang) {
	                this.setState({
	                    lang: nextProps.lang,
	                    locale: appHelper.getLocalData(this.state.kpiDefaults),
	                    current_score_for_label: appHelper.getLocaleString("current_score_for_label"),
	                    start_label: appHelper.getLocaleString("start_label")
	                });
	            }
	        }
	    }, {
	        key: 'componentDidUpdate',
	        value: function componentDidUpdate() {
	            if (this.state.redrawMeter) {
	                this.getLocale();
	                this.renderSvg();
	                if (this.props.displayState === kpiConstants.KPI_DISPLAY_STATE_START) {
	                    this.setDefaultMeterRotation();
	                } else {
	                    this.setMeterRotation();
	                }
	            }
	
	            if (!this.state.redrawMeter && this.state.getUpdateDifference) {
	                this.setUpdateDifference();
	            }
	        }
	    }, {
	        key: 'getLocale',
	        value: function getLocale() {
	            this.setState({ locale: appHelper.getLocalData(this.state.kpiDefaults) });
	        }
	    }, {
	        key: 'renderSvg',
	        value: function renderSvg() {
	            this.setState({ redrawMeter: false });
	            var redZone = this.refs['kpiRedZone_' + this.state.kpiDefaults.kpi_id + '_' + this.state.guid];
	            var yellowZone = this.refs['kpiYellowZone_' + this.state.kpiDefaults.kpi_id + '_' + this.state.guid];
	            var greenZone = this.refs['kpiGreenZone_' + this.state.kpiDefaults.kpi_id + '_' + this.state.guid];
	
	            redZone.setAttribute("d", kpiHelper.describeArc(this.state.meterParams.svgX, this.state.meterParams.svgY, this.state.meterParams.svgRadius, kpiHelper.getRotationAngle(this.state.meterParams.maxRotation, this.state.kpiDefaults.min, this.state.kpiDefaults.min, this.state.kpiDefaults.max), kpiHelper.getRotationAngle(this.state.meterParams.maxRotation, this.state.kpiDefaults.min, this.state.kpiDefaults.yellow, this.state.kpiDefaults.max)));
	            yellowZone.setAttribute("d", kpiHelper.describeArc(this.state.meterParams.svgX, this.state.meterParams.svgY, this.state.meterParams.svgRadius, kpiHelper.getRotationAngle(this.state.meterParams.maxRotation, this.state.kpiDefaults.min, this.state.kpiDefaults.yellow, this.state.kpiDefaults.max), kpiHelper.getRotationAngle(this.state.meterParams.maxRotation, this.state.kpiDefaults.min, this.state.kpiDefaults.green, this.state.kpiDefaults.max)));
	            greenZone.setAttribute("d", kpiHelper.describeArc(this.state.meterParams.svgX, this.state.meterParams.svgY, this.state.meterParams.svgRadius, kpiHelper.getRotationAngle(this.state.meterParams.maxRotation, this.state.kpiDefaults.min, this.state.kpiDefaults.green, this.state.kpiDefaults.max), kpiHelper.getRotationAngle(this.state.meterParams.maxRotation, this.state.kpiDefaults.min, this.state.kpiDefaults.max, this.state.kpiDefaults.max)));
	        }
	    }, {
	        key: 'updateMeterValues',
	        value: function updateMeterValues(updatedResult) {
	            var updateKpiClassValues = this.updateKpiClassValues;
	            var index = 1000;
	            if (appHelper.isDefined(this.props.index)) {
	                index = (this.props.index + 1) * 1000;
	            }
	            setTimeout(function () {
	                updateKpiClassValues(updatedResult);
	            }, index);
	        }
	    }, {
	        key: 'updateKpiClassValues',
	        value: function updateKpiClassValues(updatedResult) {
	            //if(appHelper.isDefined(updatedResult.statusIndicatorClass)){
	            //this.setState({statusIndicatorClass: updatedResult.statusIndicatorClass.class});
	            //this.setSvgClass(updatedResult.statusIndicatorClass.class);
	            this.updateMeterRotation(updatedResult);
	            //}
	        }
	    }, {
	        key: 'setMeterRotation',
	        value: function setMeterRotation() {
	            var duration = 0;
	            var rotator = this.refs['rotator_' + this.state.userKpiResult.kpi_id + '_' + this.state.guid];
	            var rotationAngle = kpiHelper.getRotationAngle(this.state.meterParams.maxRotation, this.state.kpiDefaults.min, this.state.userKpiResult.current, this.state.kpiDefaults.max);
	            _gsap.TweenLite.to(rotator, duration, {
	                rotation: rotationAngle + 'deg',
	                ease: _gsap.Expo.easeOut
	            });
	        }
	    }, {
	        key: 'setDefaultMeterRotation',
	        value: function setDefaultMeterRotation() {
	            var duration = 0;
	            var rotator = this.refs['rotator_' + this.state.userKpiResult.kpi_id + '_' + this.state.guid];
	            var rotationAngle = kpiHelper.getRotationAngle(this.state.meterParams.maxRotation, this.state.kpiDefaults.min, this.state.kpiDefaults.start, this.state.kpiDefaults.max);
	            _gsap.TweenLite.to(rotator, duration, {
	                rotation: rotationAngle + 'deg',
	                ease: _gsap.Expo.easeOut
	            });
	        }
	    }, {
	        key: 'updateMeterRotation',
	        value: function updateMeterRotation(updatedResult) {
	            var duration = objectConstants.KPI_ROTATION_DURATION;
	            var rotator = this.refs['rotator_' + this.state.userKpiResult.kpi_id + '_' + this.state.guid];
	            var rotationAngle = kpiHelper.getRotationAngle(this.state.meterParams.maxRotation, this.state.kpiDefaults.min, updatedResult.current, this.state.kpiDefaults.max);
	            _gsap.TweenLite.to(rotator, duration, {
	                rotation: rotationAngle + 'deg',
	                ease: _gsap.Expo.easeOut,
	                delay: 0.5,
	                onComplete: this.onRotationComplete,
	                onCompleteParams: [updatedResult]
	            });
	        }
	    }, {
	        key: 'onRotationComplete',
	        value: function onRotationComplete(params) {
	            if (appHelper.isDefined(this.props.onRotationComplete)) {
	                this.props.onRotationComplete(this.state.userKpiResult.kpi_id);
	            }
	        }
	    }, {
	        key: 'setSvgClass',
	        value: function setSvgClass(pointIndicatorClass) {
	            if (this.props.showImmediateImpact && pointIndicatorClass === "no-value") {
	                this.setState({ svgExtensionClass: "no-value" });
	            }
	        }
	    }, {
	        key: 'getValue',
	        value: function getValue() {
	            if (appHelper.isDefined(this.state.kpiDefaults.decimals)) {
	                //if(this.state.userKpiResult.current)
	                return Number(this.state.userKpiResult.current).toFixed(this.state.kpiDefaults.decimals);
	            } else {
	                Number(this.state.userKpiResult.current).toFixed(0);
	            }
	        }
	    }, {
	        key: 'setUpdateDifference',
	        value: function setUpdateDifference() {
	            this.setState({ getUpdateDifference: false });
	            var decimal_points = parseFloat(this.state.kpiDefaults.decimals_points);
	
	            if (this.state.kpiUpdate.new > this.state.kpiUpdate.current) {
	                this.setState({
	                    kpiUpdate: Object.assign({}, this.state.kpiUpdate, {
	                        difference: decimal_points === 0 ? this.state.userKpiResult.value.toFixed(2) : this.state.userKpiResult.value.toFixed(decimal_points),
	                        type: 'positive'
	                    })
	                });
	            } else if (this.state.kpiUpdate.current > this.state.kpiUpdate.new) {
	                var difference = Math.abs(this.state.userKpiResult.value);
	                this.setState({
	                    kpiUpdate: Object.assign({}, this.state.kpiUpdate, {
	                        difference: decimal_points === 0 ? Math.abs(this.state.userKpiResult.value).toFixed(2) : Math.abs(this.state.userKpiResult.value).toFixed(decimal_points),
	                        type: 'negative'
	                    })
	                });
	            } else {
	                this.setState({
	                    kpiUpdate: Object.assign({}, this.state.kpiUpdate, {
	                        difference: 0,
	                        type: 'neutral'
	                    })
	                });
	            }
	        }
	    }, {
	        key: 'getCurrentValue',
	        value: function getCurrentValue() {
	            var decimal_points = parseFloat(this.state.kpiDefaults.decimals_points);
	            /*if(decimal_points === 0){
	                console.log(this.state.userKpiResult.current);
	                return  Math.floor(this.state.userKpiResult.current);
	            }else{
	                return this.state.userKpiResult.current.toFixed(this.state.kpiDefaults.decimals_points);
	            }*/
	            return this.state.userKpiResult.current.toFixed(decimal_points);
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            return _react2.default.createElement(
	                'div',
	                { className: ' ' + this.state.meterParams.className, role: 'presentation' },
	                this.state.kpiUpdate.difference !== 0 && !this.props.allowKpiRedraw ? _react2.default.createElement(
	                    'div',
	                    { className: 'kpi-score-difference ' + this.state.kpiUpdate.type, role: 'presentation' },
	                    _react2.default.createElement(
	                        'span',
	                        { className: 'diff-label' },
	                        _react2.default.createElement(
	                            'span',
	                            { className: '' + this.state.kpiUpdate.type },
	                            _react2.default.createElement(
	                                'span',
	                                { className: '' + this.state.kpiDefaults.unit_type },
	                                this.state.kpiUpdate.difference
	                            )
	                        )
	                    )
	                ) : null,
	                _react2.default.createElement(
	                    'div',
	                    { className: 'kpi-rotation-meter' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'meter-wrapper' },
	                        this.props.displayState === kpiConstants.KPI_DISPLAY_STATE_START ? _react2.default.createElement(
	                            'div',
	                            { className: 'min-label ' + kpiHelper.getKpiScoreRange(this.state.kpiDefaults, this.state.kpiDefaults.min), role: 'presentation' },
	                            _react2.default.createElement(
	                                'span',
	                                { className: '' + this.state.kpiDefaults.unit_type },
	                                this.state.kpiDefaults.min.toFixed(this.state.kpiDefaults.decimals_points)
	                            )
	                        ) : null,
	                        _react2.default.createElement(
	                            'svg',
	                            { className: 'kpi-svg ' + this.state.svgExtensionClass, role: 'presentation' },
	                            _react2.default.createElement('path', { ref: 'kpiRedZone_' + this.state.kpiDefaults.kpi_id + '_' + this.state.guid, fill: 'none',
	                                strokeWidth: this.state.meterParams.svgStroke,
	                                stroke: this.state.feedback_styles.red_feedback.colors.color, role: 'presentation' }),
	                            _react2.default.createElement('path', { ref: 'kpiYellowZone_' + this.state.kpiDefaults.kpi_id + '_' + this.state.guid, fill: 'none',
	                                strokeWidth: this.state.meterParams.svgStroke,
	                                stroke: this.state.feedback_styles.yellow_feedback.colors.color, role: 'presentation' }),
	                            _react2.default.createElement('path', { ref: 'kpiGreenZone_' + this.state.kpiDefaults.kpi_id + '_' + this.state.guid, fill: 'none',
	                                strokeWidth: this.state.meterParams.svgStroke,
	                                stroke: this.state.feedback_styles.green_feedback.colors.color, role: 'presentation' })
	                        ),
	                        _react2.default.createElement('div', { className: 'rotator', ref: 'rotator_' + this.state.kpiDefaults.kpi_id + '_' + this.state.guid, role: 'presentation' }),
	                        this.props.displayState === kpiConstants.KPI_DISPLAY_STATE_START ? _react2.default.createElement(
	                            'div',
	                            { className: 'max-label ' + kpiHelper.getKpiScoreRange(this.state.kpiDefaults, this.state.kpiDefaults.max), role: 'presentation' },
	                            _react2.default.createElement(
	                                'span',
	                                { className: '' + this.state.kpiDefaults.unit_type },
	                                this.state.kpiDefaults.max.toFixed(this.state.kpiDefaults.decimals_points)
	                            )
	                        ) : null
	                    )
	                ),
	                this.props.displayState === kpiConstants.KPI_DISPLAY_STATE_CURRENT_POINTS_AWARDED || this.props.displayState === kpiConstants.KPI_DISPLAY_STATE_REVIEW_POINTS_AWARDED || this.props.displayState === kpiConstants.KPI_DISPLAY_STATE_START ? _react2.default.createElement(
	                    'div',
	                    { className: 'kpi-points-awarded ' + this.state.statusIndicatorClass + ' guroo-kpi-label' },
	                    this.state.locale.short_title
	                ) : null,
	                this.props.displayState === kpiConstants.KPI_DISPLAY_STATE_CURRENT_VALUE_WITH_LABEL || this.props.displayState === kpiConstants.KPI_DISPLAY_STATE_CURRENT_VALUE_NO_LABEL ? _react2.default.createElement(
	                    'div',
	                    { className: 'kpi-current-score' },
	                    _react2.default.createElement(
	                        'span',
	                        { className: 'current-score-label ' + this.state.userKpiResult.currentScoreRange + ' ' + this.state.kpiDefaults.unit_type },
	                        _react2.default.createElement(
	                            'span',
	                            { className: 'hidden-el' },
	                            this.state.current_score_for_label,
	                            ' ',
	                            this.state.locale.short_title,
	                            ':'
	                        ),
	                        this.getCurrentValue(),
	                        _react2.default.createElement(
	                            'span',
	                            { className: 'hidden-el' },
	                            ' ',
	                            appHelper.getLocaleString("out_of_label"),
	                            ' ',
	                            this.state.kpiDefaults.max
	                        )
	                    )
	                ) : null,
	                this.props.displayState === kpiConstants.KPI_DISPLAY_STATE_CURRENT_VALUE_WITH_LABEL ? _react2.default.createElement(
	                    'div',
	                    { className: 'kpi-label' },
	                    this.state.locale.short_title
	                ) : null,
	                this.props.displayState === kpiConstants.KPI_DISPLAY_STATE_START ? _react2.default.createElement(
	                    'div',
	                    { className: 'start-label ' + kpiHelper.getKpiScoreRange(this.state.kpiDefaults, this.state.kpiDefaults.start), role: 'presentation' },
	                    this.state.start_label,
	                    ': ',
	                    _react2.default.createElement(
	                        'span',
	                        { className: '' + this.state.kpiDefaults.unit_type },
	                        this.state.kpiDefaults.start.toFixed(this.state.kpiDefaults.decimals_points)
	                    )
	                ) : null
	            );
	        }
	    }]);
	
	    return RotationKpiMeter;
	}(_react2.default.Component);
	
	RotationKpiMeter.propTypes = {
	    userKpiResult: _propTypes2.default.object.isRequired,
	    kpiDefaults: _propTypes2.default.object.isRequired,
	    meterParams: _propTypes2.default.object.isRequired,
	    feedback_styles: _propTypes2.default.object.isRequired,
	    displayState: _propTypes2.default.string,
	    responseReview: _propTypes2.default.bool,
	    bite_id: _propTypes2.default.number,
	    screen_id: _propTypes2.default.number,
	    asset_id: _propTypes2.default.number,
	    option_id: _propTypes2.default.number,
	    showImmediateImpact: _propTypes2.default.bool,
	    onMeterClicked: _propTypes2.default.func,
	    index: _propTypes2.default.number,
	    onRotationComplete: _propTypes2.default.func,
	    lang: _propTypes2.default.string.isRequired,
	    allowKpiRedraw: _propTypes2.default.bool
	};
	
	RotationKpiMeter.contextTypes = {
	    router: _propTypes2.default.object
	};
	
	function mapStateToProps(state, ownProps) {
	
	    var userBite = appHelper.getArrayObjectByKey(state.userData.bites, "bite_id", ownProps.bite_id);
	    var userKpiResult = appHelper.getArrayObjectByKey(userBite.kpis, "kpi_id", ownProps.kpiDefaults.kpi_id);
	    if (ownProps.responseReview) {
	        userKpiResult = Object.assign({}, kpiHelper.getKpiUserResponse(userKpiResult, ownProps.screen_id, ownProps.asset_id, ownProps.option_id));
	    }
	    var lang = state.userData.lang;
	    return {
	        lang: lang,
	        userKpiResult: userKpiResult,
	        feedback_styles: state.contentData.experience.feedback_styles
	    };
	}
	
	function mapDispatchToProps(dispatch) {
	    return {
	        actions: (0, _redux.bindActionCreators)(Object.assign({}, trackingDataActions, appDataActions), dispatch)
	    };
	}
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(RotationKpiMeter);

/***/ },
/* 83 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(5);
	
	var _redux = __webpack_require__(4);
	
	var _appDataActions = __webpack_require__(12);
	
	var appDataActions = _interopRequireWildcard(_appDataActions);
	
	var _trackingDataActions = __webpack_require__(7);
	
	var trackingDataActions = _interopRequireWildcard(_trackingDataActions);
	
	var _dialogPopupActions = __webpack_require__(19);
	
	var dialogPopupActions = _interopRequireWildcard(_dialogPopupActions);
	
	var _appHelper = __webpack_require__(3);
	
	var appHelper = _interopRequireWildcard(_appHelper);
	
	var _dataHelper = __webpack_require__(11);
	
	var dataHelper = _interopRequireWildcard(_dataHelper);
	
	var _userDataHelper = __webpack_require__(15);
	
	var userDataHelper = _interopRequireWildcard(_userDataHelper);
	
	var _objectConstants = __webpack_require__(9);
	
	var objectConstants = _interopRequireWildcard(_objectConstants);
	
	var _gsap = __webpack_require__(8);
	
	var _gsapReactPlugin = __webpack_require__(10);
	
	var _gsapReactPlugin2 = _interopRequireDefault(_gsapReactPlugin);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Prompt = function (_React$Component) {
	    _inherits(Prompt, _React$Component);
	
	    function Prompt(props, context) {
	        _classCallCheck(this, Prompt);
	
	        var _this = _possibleConstructorReturn(this, (Prompt.__proto__ || Object.getPrototypeOf(Prompt)).call(this, props, context));
	
	        _this.state = {
	            locale: _this.props.locale,
	            isVisible: false
	        };
	
	        _this.show = _this.show.bind(_this);
	        _this.onShowComplete = _this.onShowComplete.bind(_this);
	        _this.hide = _this.hide.bind(_this);
	        _this.onHideComplete = _this.onHideComplete.bind(_this);
	        return _this;
	    }
	
	    _createClass(Prompt, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            this.show();
	        }
	    }, {
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(nextProps) {
	            if (this.state.locale !== nextProps.locale) {
	                this.setState({ locale: Object.assign({}, nextProps.locale) });
	            }
	        }
	    }, {
	        key: 'componentDidUpdate',
	        value: function componentDidUpdate() {}
	    }, {
	        key: 'show',
	        value: function show() {
	            var optionRef = this.refs['prompt_' + this.props.id];
	            _gsap.TweenLite.set(optionRef, { height: "auto" });
	            _gsap.TweenLite.from(optionRef, objectConstants.SHOW_PANEL_DURATION, {
	                height: 0,
	                ease: _gsap.Expo.easeInOut
	            }).eventCallback("onComplete", this.onShowComplete);
	        }
	    }, {
	        key: 'onShowComplete',
	        value: function onShowComplete() {
	            this.setState({ isVisible: true });
	            if (appHelper.isDefined(this.props.onComplete)) {
	                this.props.onComplete();
	            }
	        }
	    }, {
	        key: 'hide',
	        value: function hide() {
	            var optionRef = this.refs['prompt_' + this.props.id];
	
	            _gsap.TweenLite.to(optionRef, 1, {
	                height: 0,
	                ease: _gsap.Expo.easeInOut
	            }).eventCallback("onComplete", this.onHideComplete);
	        }
	    }, {
	        key: 'onHideComplete',
	        value: function onHideComplete() {
	            this.setState({ isVisible: false });
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            return this.state.locale.description.length > 0 ? _react2.default.createElement(
	                'div',
	                { className: 'object-container', ref: 'prompt_' + this.props.id },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'question-prompt' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'content-column' },
	                        this.props.show_title && appHelper.isDefined(this.state.locale.label) && this.state.locale.label !== null && this.state.locale.label.length > 0 ? _react2.default.createElement('h4', { className: 'bold', dangerouslySetInnerHTML: { __html: this.state.locale.label } }) : null,
	                        appHelper.isDefined(this.state.locale.description) && this.state.locale.description !== null && this.state.locale.description.length > 0 ? _react2.default.createElement('div', { dangerouslySetInnerHTML: { __html: this.state.locale.description } }) : null
	                    )
	                )
	            ) : _react2.default.createElement('div', { ref: 'prompt_' + this.props.id });
	        }
	    }]);
	
	    return Prompt;
	}(_react2.default.Component);
	
	Prompt.propTypes = {
	    id: _propTypes2.default.number.isRequired,
	    locale: _propTypes2.default.object.isRequired,
	    show_title: _propTypes2.default.bool.isRequired,
	    onComplete: _propTypes2.default.func,
	    actions: _propTypes2.default.object.isRequired
	};
	
	Prompt.contextTypes = {
	    router: _propTypes2.default.object
	};
	
	function mapStateToProps(state) {
	    return {};
	}
	
	function mapDispatchToProps(dispatch) {
	    return {
	        actions: (0, _redux.bindActionCreators)(Object.assign({}, appDataActions, trackingDataActions, dialogPopupActions), dispatch)
	    };
	}
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(Prompt);

/***/ },
/* 84 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(5);
	
	var _redux = __webpack_require__(4);
	
	var _Button = __webpack_require__(18);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _ResourceLinks = __webpack_require__(48);
	
	var _ResourceLinks2 = _interopRequireDefault(_ResourceLinks);
	
	var _SecondaryImage = __webpack_require__(66);
	
	var _SecondaryImage2 = _interopRequireDefault(_SecondaryImage);
	
	var _SecondaryLibraryImage = __webpack_require__(67);
	
	var _SecondaryLibraryImage2 = _interopRequireDefault(_SecondaryLibraryImage);
	
	var _appDataActions = __webpack_require__(12);
	
	var appDataActions = _interopRequireWildcard(_appDataActions);
	
	var _trackingDataActions = __webpack_require__(7);
	
	var trackingDataActions = _interopRequireWildcard(_trackingDataActions);
	
	var _appConstants = __webpack_require__(13);
	
	var appConstants = _interopRequireWildcard(_appConstants);
	
	var _appHelper = __webpack_require__(3);
	
	var appHelper = _interopRequireWildcard(_appHelper);
	
	var _userDataHelper = __webpack_require__(15);
	
	var userDataHelper = _interopRequireWildcard(_userDataHelper);
	
	var _objectConstants = __webpack_require__(9);
	
	var objectConstants = _interopRequireWildcard(_objectConstants);
	
	var _assetConstants = __webpack_require__(33);
	
	var assetConstants = _interopRequireWildcard(_assetConstants);
	
	var _gsap = __webpack_require__(8);
	
	var _gsapReactPlugin = __webpack_require__(10);
	
	var _gsapReactPlugin2 = _interopRequireDefault(_gsapReactPlugin);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } //eslint-disable-line import/no-named-as-default
	
	
	var NotReadyYet = function (_React$Component) {
	    _inherits(NotReadyYet, _React$Component);
	
	    function NotReadyYet(props, context) {
	        _classCallCheck(this, NotReadyYet);
	
	        var _this = _possibleConstructorReturn(this, (NotReadyYet.__proto__ || Object.getPrototypeOf(NotReadyYet)).call(this, props, context));
	
	        _this.state = {
	            lang: _this.props.lang,
	            screen_not_ready_label: appHelper.getLocaleString("screen_not_ready_label")
	        };
	        _this.getImagePath = _this.getImagePath.bind(_this);
	        _this.show = _this.show.bind(_this);
	        return _this;
	    }
	
	    _createClass(NotReadyYet, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            this.show();
	        }
	    }, {
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(nextProps) {
	            if (this.state.lang !== nextProps.lang) {
	                this.setState({
	                    lang: nextProps.lang,
	                    screen_not_ready_label: appHelper.getLocaleString("screen_not_ready_label")
	                });
	            }
	        }
	    }, {
	        key: 'componentDidUpdate',
	        value: function componentDidUpdate() {}
	    }, {
	        key: 'getImagePath',
	        value: function getImagePath(image) {
	            if (appConstants.DEVELOPMENT_MODE) {
	                if (appHelper.isDefined(image) && image.length > 0) {
	                    return __webpack_require__(16)("./" + image);
	                }
	            } else {
	                return image;
	            }
	        }
	    }, {
	        key: 'show',
	        value: function show() {
	            var optionRef = this.refs[this.props.screen_id + '_text'];
	            _gsap.TweenLite.set(optionRef, { height: "auto" });
	            _gsap.TweenLite.from(optionRef, objectConstants.SHOW_PANEL_DURATION, {
	                height: 0,
	                ease: _gsap.Expo.easeInOut
	            });
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            return _react2.default.createElement(
	                'div',
	                { className: 'object-container', ref: this.props.screen_id + '_text' },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'screen-not-ready' },
	                    this.state.screen_not_ready_label
	                )
	            );
	        }
	    }]);
	
	    return NotReadyYet;
	}(_react2.default.Component);
	
	NotReadyYet.propTypes = {
	    screen_id: _propTypes2.default.number.isRequired,
	    lang: _propTypes2.default.string.isRequired,
	    actions: _propTypes2.default.object.isRequired
	};
	
	NotReadyYet.contextTypes = {
	    router: _propTypes2.default.object
	};
	
	function mapStateToProps(state, ownProps) {
	    var lang = state.userData.lang;
	    return {
	        lang: lang
	    };
	}
	
	function mapDispatchToProps(dispatch) {
	    return {
	        actions: (0, _redux.bindActionCreators)(Object.assign({}, appDataActions, trackingDataActions), dispatch)
	    };
	}
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(NotReadyYet);

/***/ },
/* 85 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(5);
	
	var _redux = __webpack_require__(4);
	
	var _Button = __webpack_require__(18);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _ResourceLinks = __webpack_require__(48);
	
	var _ResourceLinks2 = _interopRequireDefault(_ResourceLinks);
	
	var _SecondaryImage = __webpack_require__(66);
	
	var _SecondaryImage2 = _interopRequireDefault(_SecondaryImage);
	
	var _SecondaryLibraryImage = __webpack_require__(67);
	
	var _SecondaryLibraryImage2 = _interopRequireDefault(_SecondaryLibraryImage);
	
	var _appDataActions = __webpack_require__(12);
	
	var appDataActions = _interopRequireWildcard(_appDataActions);
	
	var _trackingDataActions = __webpack_require__(7);
	
	var trackingDataActions = _interopRequireWildcard(_trackingDataActions);
	
	var _appConstants = __webpack_require__(13);
	
	var appConstants = _interopRequireWildcard(_appConstants);
	
	var _appHelper = __webpack_require__(3);
	
	var appHelper = _interopRequireWildcard(_appHelper);
	
	var _userDataHelper = __webpack_require__(15);
	
	var userDataHelper = _interopRequireWildcard(_userDataHelper);
	
	var _objectConstants = __webpack_require__(9);
	
	var objectConstants = _interopRequireWildcard(_objectConstants);
	
	var _assetConstants = __webpack_require__(33);
	
	var assetConstants = _interopRequireWildcard(_assetConstants);
	
	var _gsap = __webpack_require__(8);
	
	var _gsapReactPlugin = __webpack_require__(10);
	
	var _gsapReactPlugin2 = _interopRequireDefault(_gsapReactPlugin);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } //eslint-disable-line import/no-named-as-default
	
	
	var ProducerNotes = function (_React$Component) {
	    _inherits(ProducerNotes, _React$Component);
	
	    function ProducerNotes(props, context) {
	        _classCallCheck(this, ProducerNotes);
	
	        var _this = _possibleConstructorReturn(this, (ProducerNotes.__proto__ || Object.getPrototypeOf(ProducerNotes)).call(this, props, context));
	
	        _this.state = {
	            lang: _this.props.lang,
	            producer_notes_label: appHelper.getLocaleString("producer_notes_label")
	        };
	        _this.getImagePath = _this.getImagePath.bind(_this);
	        _this.show = _this.show.bind(_this);
	        return _this;
	    }
	
	    _createClass(ProducerNotes, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            this.show();
	        }
	    }, {
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(nextProps) {
	            if (this.state.lang !== nextProps.lang) {
	                this.setState({
	                    lang: nextProps.lang,
	                    screen_not_ready_label: appHelper.getLocaleString("producer_notes_label")
	                });
	            }
	        }
	    }, {
	        key: 'componentDidUpdate',
	        value: function componentDidUpdate() {}
	    }, {
	        key: 'getImagePath',
	        value: function getImagePath(image) {
	            if (appConstants.DEVELOPMENT_MODE) {
	                if (appHelper.isDefined(image) && image.length > 0) {
	                    return __webpack_require__(16)("./" + image);
	                }
	            } else {
	                return image;
	            }
	        }
	    }, {
	        key: 'show',
	        value: function show() {
	            var optionRef = this.refs[this.props.screen_id + '_text'];
	            _gsap.TweenLite.set(optionRef, { height: "auto" });
	            _gsap.TweenLite.from(optionRef, objectConstants.SHOW_PANEL_DURATION, {
	                height: 0,
	                ease: _gsap.Expo.easeInOut
	            });
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            return _react2.default.createElement(
	                'div',
	                { className: 'object-container', ref: this.props.screen_id + '_text' },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'producer-notes' },
	                    _react2.default.createElement('img', { className: 'guroo-producer-logo', src: __webpack_require__(1100), alt: '' }),
	                    _react2.default.createElement(
	                        'h4',
	                        { className: 'producer-notes-title' },
	                        this.state.producer_notes_label
	                    ),
	                    this.props.notes.map(function (note) {
	                        return _react2.default.createElement('div', { className: 'producer-notes-description', key: note.screen_id, dangerouslySetInnerHTML: { __html: note.notes } });
	                    })
	                )
	            );
	        }
	    }]);
	
	    return ProducerNotes;
	}(_react2.default.Component);
	
	ProducerNotes.propTypes = {
	    notes: _propTypes2.default.array.isRequired,
	    screen_id: _propTypes2.default.number.isRequired,
	    lang: _propTypes2.default.string.isRequired,
	    actions: _propTypes2.default.object.isRequired
	};
	
	ProducerNotes.contextTypes = {
	    router: _propTypes2.default.object
	};
	
	function mapStateToProps(state, ownProps) {
	    var lang = state.userData.lang;
	    return {
	        lang: lang
	    };
	}
	
	function mapDispatchToProps(dispatch) {
	    return {
	        actions: (0, _redux.bindActionCreators)(Object.assign({}, appDataActions, trackingDataActions), dispatch)
	    };
	}
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(ProducerNotes);

/***/ },
/* 86 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.setMultiAnswerChoiceInteractionData = setMultiAnswerChoiceInteractionData;
	exports.setSingleAnwserChoiceInteractionData = setSingleAnwserChoiceInteractionData;
	exports.getMultipleChoiceIds = getMultipleChoiceIds;
	exports.setShortResponseInteractions = setShortResponseInteractions;
	exports.getShortResponseIds = getShortResponseIds;
	exports.getChoiceByDescription = getChoiceByDescription;
	exports.setUserAsAnonymous = setUserAsAnonymous;
	
	var _xAPIModels = __webpack_require__(560);
	
	var xAPIModels = _interopRequireWildcard(_xAPIModels);
	
	var _appHelper = __webpack_require__(3);
	
	var appHelper = _interopRequireWildcard(_appHelper);
	
	var _dataHelper = __webpack_require__(11);
	
	var dataHelper = _interopRequireWildcard(_dataHelper);
	
	var _kpiHelper = __webpack_require__(35);
	
	var kpiHelper = _interopRequireWildcard(_kpiHelper);
	
	var _localStorage = __webpack_require__(17);
	
	var localStorage = _interopRequireWildcard(_localStorage);
	
	var _objectConstants = __webpack_require__(9);
	
	var objectConstants = _interopRequireWildcard(_objectConstants);
	
	var _lodash = __webpack_require__(28);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _striptags = __webpack_require__(191);
	
	var _striptags2 = _interopRequireDefault(_striptags);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function setMultiAnswerChoiceInteractionData(obj, responseObj) {
	    var objLocale = appHelper.getLocalData(obj);
	    //SET RESULT
	    var resultParam = Object.assign({}, xAPIModels.RESULT, {
	        completion: responseObj.outcome.progression !== objectConstants.OBJECT_PROGRESSION_TRY_AGAIN,
	        success: obj.scoring_type === objectConstants.SCORING_TYPE_REFLECTIVE || responseObj.outcome.result === objectConstants.RESULT_BEST,
	        response: setQuestionResponses(responseObj.checkedOptions),
	        //score: obj.scoring_type === objectConstants.SCORING_TYPE_ASSESSED && responseObj.outcome.kpis !== null  ? setScore(obj, responseObj) : getScoreObj(obj.scoring_type, responseObj.outcome.result)
	        score: getScoreObj(obj.scoring_type, responseObj.outcome.result)
	    });
	
	    if (obj.scoring_type === objectConstants.SCORING_TYPE_REFLECTIVE) {
	        resultParam = Object.assign({}, _lodash2.default.omit(resultParam, 'success'));
	    }
	
	    //SET OBJECT
	    var correctAnswers = appHelper.getTypeCount(obj.options, "result", "best");
	
	    var definition = {
	        name: {
	            "en-US": (0, _striptags2.default)(objLocale.description)
	        },
	        description: {
	            "en-US": (0, _striptags2.default)(objLocale.description)
	        },
	        type: 'http://adlnet.gov/expapi/activities/cmi.interaction',
	        interactionType: "choice",
	        //correctResponsesPattern: [setQuestionResponses(correctAnswers)],
	        //correctResponsesPattern: obj.scoring_type === objectConstants.SCORING_TYPE_REFLECTIVE ? []: [setQuestionResponses(correctAnswers)],
	        choices: setChoices(obj.options)
	    };
	
	    if (obj.scoring_type !== objectConstants.SCORING_TYPE_REFLECTIVE) {
	        definition['correctResponsesPattern'] = [setQuestionResponses(correctAnswers)];
	    }
	
	    var objectParam = Object.assign({}, xAPIModels.CHOICE_OBJECT, {
	        id: setId(obj, responseObj),
	        definition: definition
	    });
	
	    return Object.assign({}, xAPIModels.CHOICE, {
	        result: resultParam,
	        object: objectParam
	    });
	}
	
	function setSingleAnwserChoiceInteractionData(obj, responseObj) {
	    var objLocale = appHelper.getLocalData(obj);
	    //SET RESULT
	    var optionLocale = appHelper.getLocalData(responseObj.latestResponse);
	    //striptags(optionLocale.option)
	
	    var resultParam = Object.assign({}, xAPIModels.RESULT, {
	        completion: responseObj.latestResponse.progression !== objectConstants.OBJECT_PROGRESSION_TRY_AGAIN,
	        success: obj.scoring_type === objectConstants.SCORING_TYPE_REFLECTIVE || responseObj.latestResponse.result === objectConstants.RESULT_BEST,
	        //response: responseObj.latestResponse.option_id.toString(),
	        response: (0, _striptags2.default)(optionLocale.option),
	        //score: obj.scoring_type === objectConstants.SCORING_TYPE_ASSESSED && responseObj.latestResponse.kpis !== null ? setScore(obj, responseObj) : getScoreObj(obj.scoring_type, responseObj.outcome.result)
	        score: getScoreObj(obj.scoring_type, responseObj.latestResponse.result)
	    });
	
	    if (obj.scoring_type === objectConstants.SCORING_TYPE_REFLECTIVE) {
	        resultParam = Object.assign({}, _lodash2.default.omit(resultParam, 'success'));
	    }
	
	    //SET OBJECT
	    var correctAnswers = appHelper.getTypeCount(obj.options, "result", "best");
	
	    var definition = {
	        name: {
	            "en-US": (0, _striptags2.default)(objLocale.description)
	        },
	        description: {
	            "en-US": (0, _striptags2.default)(objLocale.description)
	        },
	        type: 'http://adlnet.gov/expapi/activities/cmi.interaction',
	        interactionType: "choice",
	        choices: setChoices(obj.options)
	    };
	
	    if (obj.scoring_type !== objectConstants.SCORING_TYPE_REFLECTIVE) {
	        definition['correctResponsesPattern'] = [setQuestionResponses(correctAnswers)];
	    }
	
	    var objectParam = Object.assign({}, xAPIModels.CHOICE_OBJECT, {
	
	        id: setId(obj, responseObj),
	        definition: definition
	
	    });
	
	    return Object.assign({}, xAPIModels.CHOICE, {
	        result: resultParam,
	        object: objectParam
	    });
	}
	
	function getMultipleChoiceIds(params) {
	
	    var activityId = "";
	
	    if (appHelper.isDefined(params.parent_screen_id)) {
	        activityId = 'bite_id:' + params.bite_id + '/screen_id:' + params.parent_screen_id + '/sub_screen_id:' + params.screen_id + '/asset_id:' + params.asset_id;
	    } else {
	        activityId = 'bite_id:' + params.bite_id + '/screen_id:' + params.screen_id + '/asset_id:' + params.asset_id;
	    }
	
	    return {
	        id: params.asset_id,
	        activityId: activityId
	    };
	}
	
	function setShortResponseInteractions(obj, params) {
	    var shortResponses = [];
	    _lodash2.default.forEach(params.renderedQuestions, function (data) {
	        var response = setShortResponseInteractionData(obj, params, data);
	        shortResponses = dataHelper.immutablePush(shortResponses, response);
	    });
	
	    return shortResponses;
	}
	
	function setShortResponseInteractionData(obj, params, responseData) {
	    var objLocale = appHelper.getLocalData(obj);
	    var responseLocale = appHelper.getLocalData(responseData);
	    //console.log(`response`,responseData.response);
	    var resultParam = Object.assign({}, xAPIModels.RESULT, {
	        completion: true,
	        //success: true, //obj.scoring_type === objectConstants.SCORING_TYPE_REFLECTIVE || params.latestResponse.result === objectConstants.RESULT_BEST,
	        response: responseData.response,
	        score: obj.assess_type === objectConstants.ASSESSED_TYPE_SCORED && params.kpi_user_rating.value !== null ? setSelfRatingScore(obj, params) : xAPIModels.BEST_SCORE
	    });
	
	    //console.log(`setShortResponseInteractionData resultParam`,resultParam);
	
	    var objectParam = Object.assign({}, xAPIModels.FILL_IN_OBJECT, {
	
	        id: setShortResponseId(obj, responseData),
	        definition: {
	            name: {
	                //"en-US": striptags(objLocale.description)
	                "en-US": (0, _striptags2.default)(responseLocale.prompt)
	            },
	            description: {
	                "en-US": (0, _striptags2.default)(responseLocale.prompt)
	            },
	            type: 'http://adlnet.gov/expapi/activities/cmi.interaction',
	            interactionType: "fill-in"
	            //correctResponsesPattern: [striptags(responseData.response)],
	
	        }
	
	    });
	
	    return Object.assign({}, xAPIModels.FILL_IN, {
	        result: resultParam,
	        object: objectParam
	    });
	}
	
	function getShortResponseIds(obj, params) {
	    var shortResponseIds = [];
	    _lodash2.default.forEach(params.renderedQuestions, function (data) {
	        var activityId = "";
	
	        if (appHelper.isDefined(params.parent_screen_id)) {
	            activityId = 'bite_id:' + params.bite_id + '/screen_id:' + params.parent_screen_id + '/sub_screen_id:' + params.screen_id + '/asset_id:' + params.asset_id + '/id:' + data.id;
	        } else {
	            activityId = 'bite_id:' + params.bite_id + '/screen_id:' + params.screen_id + '/asset_id:' + params.asset_id + '/id:' + data.id;
	        }
	
	        var response = {
	            id: data.id,
	            activityId: activityId
	        };
	        shortResponseIds = dataHelper.immutablePush(shortResponseIds, response, params);
	    });
	
	    return shortResponseIds;
	}
	//Private functions
	
	function setId(obj, responseObj) {
	    return 'asset_id:' + obj.asset_id;
	}
	
	function setShortResponseId(obj, responseData) {
	    return 'asset_id:' + obj.asset_id + '/id:' + responseData.id;
	}
	
	function setSelfRatingScore(obj, responseObj) {
	    var max = 2;
	    var min = -2;
	    var raw = responseObj.kpi_user_rating.value !== null ? responseObj.kpi_user_rating.value : 0;
	
	    return {
	        scaled: dataHelper.getRangePercentage(min, max, raw) / 100,
	        min: min,
	        max: max,
	        raw: raw
	    };
	}
	
	function setScore(obj, responseObj) {
	    var score_kpi_id = appHelper.getArrayObjectByKey(localStorage.bites, "bite_id", responseObj.bite_id).score_kpi.kpi_id;
	    var score_kpi = appHelper.isDefined(responseObj.outcome) ? appHelper.getArrayObjectByKey(responseObj.outcome.kpis, "kpi_id", score_kpi_id) : appHelper.getArrayObjectByKey(responseObj.latestResponse.kpis, "kpi_id", score_kpi_id);
	    var max = 2;
	    var min = -2;
	    var raw = appHelper.isDefined(score_kpi) ? score_kpi.value : 0;
	    var bestScore = kpiHelper.getObjectBestPoints(obj.options, score_kpi_id);
	
	    if (bestScore < -2 || bestScore > 2) {
	        raw = kpiHelper.scaleKpiValue(raw, obj.options, score_kpi_id);
	    }
	
	    return {
	        scaled: dataHelper.getRangePercentage(min, max, raw) / 100,
	        min: min,
	        max: max,
	        raw: raw
	    };
	}
	
	function setQuestionResponses(checkedOptions) {
	    var responses = [];
	    _lodash2.default.forEach(checkedOptions, function (option) {
	        var optionLocale = appHelper.getLocalData(option);
	        //responses = dataHelper.immutablePush(responses,option.option_id.toString());
	        responses = dataHelper.immutablePush(responses, (0, _striptags2.default)(optionLocale.option));
	    });
	    return responses.join("[,]");
	}
	
	function setChoices(options) {
	    var choices = [];
	    _lodash2.default.forEach(options, function (option) {
	        var optionLocale = appHelper.getLocalData(option);
	        var choice = {
	            id: option.option_id.toString(),
	            description: {
	                "en-US": (0, _striptags2.default)(optionLocale.option)
	            }
	        };
	        /*let choice = {
	            id: option.option_id.toString(),
	            description: {
	                "en-US": optionLocale.option
	            }
	        };*/
	
	        choices = dataHelper.immutablePush(choices, choice);
	    });
	
	    return choices;
	}
	
	function getScoreObj(scoring_type, result) {
	    var score = xAPIModels.BEST_SCORE;
	    if (scoring_type === objectConstants.SCORING_TYPE_REFLECTIVE) {
	        return score;
	    } else {
	        switch (result) {
	            case objectConstants.RESULT_BEST:
	                score = xAPIModels.BEST_SCORE;
	                break;
	            case objectConstants.RESULT_OK:
	                score = xAPIModels.OK_SCORE;
	                break;
	            case objectConstants.RESULT_POOR:
	                score = xAPIModels.POOR_SCORE;
	                break;
	            default:
	                score = xAPIModels.BEST_SCORE;
	        }
	        return score;
	    }
	}
	
	function getChoiceByDescription(choices, description) {
	    var returnObject = {};
	    _lodash2.default.forEach(choices, function (choice) {
	
	        if (choice.description["en-US"] === description) {
	            returnObject = Object.assign({}, choice);
	        }
	    });
	
	    return returnObject;
	}
	
	function setUserAsAnonymous() {
	    var cookieName = "actor";
	    var actor = {};
	    var actorCookie = getUserCookie(cookieName);
	
	    if (actorCookie === "") {
	        var d = new Date();
	        var n = d.getTime();
	        var email_address = String(n) + '@guest.com';
	        var name = 'Guest ' + String(n);
	
	        actor = {
	            objectType: "Agent",
	            name: name,
	            mbox: 'mailto:' + email_address
	        };
	
	        setUserCookie(cookieName, JSON.stringify(actor), 2);
	
	        return actor;
	    } else {
	        actor = JSON.parse(actorCookie);
	        return actor;
	    }
	}
	
	function setUserCookie(cname, cvalue, exdays) {
	    var d = new Date();
	    d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);
	    var expires = "expires=" + d.toUTCString();
	    document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
	}
	
	function getUserCookie(cname) {
	    var name = cname + "=";
	    var decodedCookie = decodeURIComponent(document.cookie);
	    var ca = decodedCookie.split(';');
	    for (var i = 0; i < ca.length; i++) {
	        var c = ca[i];
	        while (c.charAt(0) == ' ') {
	            c = c.substring(1);
	        }
	        if (c.indexOf(name) == 0) {
	            return c.substring(name.length, c.length);
	        }
	    }
	    return "";
	}

/***/ },
/* 87 */
/***/ function(module, exports, __webpack_require__) {

	var Map = __webpack_require__(321);
	var $export = __webpack_require__(6);
	var shared = __webpack_require__(165)('metadata');
	var store = shared.store || (shared.store = new (__webpack_require__(324))());
	
	var getOrCreateMetadataMap = function (target, targetKey, create) {
	  var targetMetadata = store.get(target);
	  if (!targetMetadata) {
	    if (!create) return undefined;
	    store.set(target, targetMetadata = new Map());
	  }
	  var keyMetadata = targetMetadata.get(targetKey);
	  if (!keyMetadata) {
	    if (!create) return undefined;
	    targetMetadata.set(targetKey, keyMetadata = new Map());
	  } return keyMetadata;
	};
	var ordinaryHasOwnMetadata = function (MetadataKey, O, P) {
	  var metadataMap = getOrCreateMetadataMap(O, P, false);
	  return metadataMap === undefined ? false : metadataMap.has(MetadataKey);
	};
	var ordinaryGetOwnMetadata = function (MetadataKey, O, P) {
	  var metadataMap = getOrCreateMetadataMap(O, P, false);
	  return metadataMap === undefined ? undefined : metadataMap.get(MetadataKey);
	};
	var ordinaryDefineOwnMetadata = function (MetadataKey, MetadataValue, O, P) {
	  getOrCreateMetadataMap(O, P, true).set(MetadataKey, MetadataValue);
	};
	var ordinaryOwnMetadataKeys = function (target, targetKey) {
	  var metadataMap = getOrCreateMetadataMap(target, targetKey, false);
	  var keys = [];
	  if (metadataMap) metadataMap.forEach(function (_, key) { keys.push(key); });
	  return keys;
	};
	var toMetaKey = function (it) {
	  return it === undefined || typeof it == 'symbol' ? it : String(it);
	};
	var exp = function (O) {
	  $export($export.S, 'Reflect', O);
	};
	
	module.exports = {
	  store: store,
	  map: getOrCreateMetadataMap,
	  has: ordinaryHasOwnMetadata,
	  get: ordinaryGetOwnMetadata,
	  set: ordinaryDefineOwnMetadata,
	  keys: ordinaryOwnMetadataKeys,
	  key: toMetaKey,
	  exp: exp
	};


/***/ },
/* 88 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	if (__webpack_require__(38)) {
	  var LIBRARY = __webpack_require__(96);
	  var global = __webpack_require__(24);
	  var fails = __webpack_require__(26);
	  var $export = __webpack_require__(6);
	  var $typed = __webpack_require__(167);
	  var $buffer = __webpack_require__(227);
	  var ctx = __webpack_require__(71);
	  var anInstance = __webpack_require__(102);
	  var propertyDesc = __webpack_require__(107);
	  var hide = __webpack_require__(52);
	  var redefineAll = __webpack_require__(108);
	  var toInteger = __webpack_require__(78);
	  var toLength = __webpack_require__(40);
	  var toIndex = __webpack_require__(319);
	  var toAbsoluteIndex = __webpack_require__(110);
	  var toPrimitive = __webpack_require__(79);
	  var has = __webpack_require__(58);
	  var classof = __webpack_require__(138);
	  var isObject = __webpack_require__(27);
	  var toObject = __webpack_require__(43);
	  var isArrayIter = __webpack_require__(213);
	  var create = __webpack_require__(104);
	  var getPrototypeOf = __webpack_require__(60);
	  var gOPN = __webpack_require__(105).f;
	  var getIterFn = __webpack_require__(229);
	  var uid = __webpack_require__(111);
	  var wks = __webpack_require__(34);
	  var createArrayMethod = __webpack_require__(75);
	  var createArrayIncludes = __webpack_require__(154);
	  var speciesConstructor = __webpack_require__(166);
	  var ArrayIterators = __webpack_require__(230);
	  var Iterators = __webpack_require__(116);
	  var $iterDetect = __webpack_require__(160);
	  var setSpecies = __webpack_require__(109);
	  var arrayFill = __webpack_require__(205);
	  var arrayCopyWithin = __webpack_require__(292);
	  var $DP = __webpack_require__(39);
	  var $GOPD = __webpack_require__(59);
	  var dP = $DP.f;
	  var gOPD = $GOPD.f;
	  var RangeError = global.RangeError;
	  var TypeError = global.TypeError;
	  var Uint8Array = global.Uint8Array;
	  var ARRAY_BUFFER = 'ArrayBuffer';
	  var SHARED_BUFFER = 'Shared' + ARRAY_BUFFER;
	  var BYTES_PER_ELEMENT = 'BYTES_PER_ELEMENT';
	  var PROTOTYPE = 'prototype';
	  var ArrayProto = Array[PROTOTYPE];
	  var $ArrayBuffer = $buffer.ArrayBuffer;
	  var $DataView = $buffer.DataView;
	  var arrayForEach = createArrayMethod(0);
	  var arrayFilter = createArrayMethod(2);
	  var arraySome = createArrayMethod(3);
	  var arrayEvery = createArrayMethod(4);
	  var arrayFind = createArrayMethod(5);
	  var arrayFindIndex = createArrayMethod(6);
	  var arrayIncludes = createArrayIncludes(true);
	  var arrayIndexOf = createArrayIncludes(false);
	  var arrayValues = ArrayIterators.values;
	  var arrayKeys = ArrayIterators.keys;
	  var arrayEntries = ArrayIterators.entries;
	  var arrayLastIndexOf = ArrayProto.lastIndexOf;
	  var arrayReduce = ArrayProto.reduce;
	  var arrayReduceRight = ArrayProto.reduceRight;
	  var arrayJoin = ArrayProto.join;
	  var arraySort = ArrayProto.sort;
	  var arraySlice = ArrayProto.slice;
	  var arrayToString = ArrayProto.toString;
	  var arrayToLocaleString = ArrayProto.toLocaleString;
	  var ITERATOR = wks('iterator');
	  var TAG = wks('toStringTag');
	  var TYPED_CONSTRUCTOR = uid('typed_constructor');
	  var DEF_CONSTRUCTOR = uid('def_constructor');
	  var ALL_CONSTRUCTORS = $typed.CONSTR;
	  var TYPED_ARRAY = $typed.TYPED;
	  var VIEW = $typed.VIEW;
	  var WRONG_LENGTH = 'Wrong length!';
	
	  var $map = createArrayMethod(1, function (O, length) {
	    return allocate(speciesConstructor(O, O[DEF_CONSTRUCTOR]), length);
	  });
	
	  var LITTLE_ENDIAN = fails(function () {
	    // eslint-disable-next-line no-undef
	    return new Uint8Array(new Uint16Array([1]).buffer)[0] === 1;
	  });
	
	  var FORCED_SET = !!Uint8Array && !!Uint8Array[PROTOTYPE].set && fails(function () {
	    new Uint8Array(1).set({});
	  });
	
	  var toOffset = function (it, BYTES) {
	    var offset = toInteger(it);
	    if (offset < 0 || offset % BYTES) throw RangeError('Wrong offset!');
	    return offset;
	  };
	
	  var validate = function (it) {
	    if (isObject(it) && TYPED_ARRAY in it) return it;
	    throw TypeError(it + ' is not a typed array!');
	  };
	
	  var allocate = function (C, length) {
	    if (!(isObject(C) && TYPED_CONSTRUCTOR in C)) {
	      throw TypeError('It is not a typed array constructor!');
	    } return new C(length);
	  };
	
	  var speciesFromList = function (O, list) {
	    return fromList(speciesConstructor(O, O[DEF_CONSTRUCTOR]), list);
	  };
	
	  var fromList = function (C, list) {
	    var index = 0;
	    var length = list.length;
	    var result = allocate(C, length);
	    while (length > index) result[index] = list[index++];
	    return result;
	  };
	
	  var addGetter = function (it, key, internal) {
	    dP(it, key, { get: function () { return this._d[internal]; } });
	  };
	
	  var $from = function from(source /* , mapfn, thisArg */) {
	    var O = toObject(source);
	    var aLen = arguments.length;
	    var mapfn = aLen > 1 ? arguments[1] : undefined;
	    var mapping = mapfn !== undefined;
	    var iterFn = getIterFn(O);
	    var i, length, values, result, step, iterator;
	    if (iterFn != undefined && !isArrayIter(iterFn)) {
	      for (iterator = iterFn.call(O), values = [], i = 0; !(step = iterator.next()).done; i++) {
	        values.push(step.value);
	      } O = values;
	    }
	    if (mapping && aLen > 2) mapfn = ctx(mapfn, arguments[2], 2);
	    for (i = 0, length = toLength(O.length), result = allocate(this, length); length > i; i++) {
	      result[i] = mapping ? mapfn(O[i], i) : O[i];
	    }
	    return result;
	  };
	
	  var $of = function of(/* ...items */) {
	    var index = 0;
	    var length = arguments.length;
	    var result = allocate(this, length);
	    while (length > index) result[index] = arguments[index++];
	    return result;
	  };
	
	  // iOS Safari 6.x fails here
	  var TO_LOCALE_BUG = !!Uint8Array && fails(function () { arrayToLocaleString.call(new Uint8Array(1)); });
	
	  var $toLocaleString = function toLocaleString() {
	    return arrayToLocaleString.apply(TO_LOCALE_BUG ? arraySlice.call(validate(this)) : validate(this), arguments);
	  };
	
	  var proto = {
	    copyWithin: function copyWithin(target, start /* , end */) {
	      return arrayCopyWithin.call(validate(this), target, start, arguments.length > 2 ? arguments[2] : undefined);
	    },
	    every: function every(callbackfn /* , thisArg */) {
	      return arrayEvery(validate(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined);
	    },
	    fill: function fill(value /* , start, end */) { // eslint-disable-line no-unused-vars
	      return arrayFill.apply(validate(this), arguments);
	    },
	    filter: function filter(callbackfn /* , thisArg */) {
	      return speciesFromList(this, arrayFilter(validate(this), callbackfn,
	        arguments.length > 1 ? arguments[1] : undefined));
	    },
	    find: function find(predicate /* , thisArg */) {
	      return arrayFind(validate(this), predicate, arguments.length > 1 ? arguments[1] : undefined);
	    },
	    findIndex: function findIndex(predicate /* , thisArg */) {
	      return arrayFindIndex(validate(this), predicate, arguments.length > 1 ? arguments[1] : undefined);
	    },
	    forEach: function forEach(callbackfn /* , thisArg */) {
	      arrayForEach(validate(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined);
	    },
	    indexOf: function indexOf(searchElement /* , fromIndex */) {
	      return arrayIndexOf(validate(this), searchElement, arguments.length > 1 ? arguments[1] : undefined);
	    },
	    includes: function includes(searchElement /* , fromIndex */) {
	      return arrayIncludes(validate(this), searchElement, arguments.length > 1 ? arguments[1] : undefined);
	    },
	    join: function join(separator) { // eslint-disable-line no-unused-vars
	      return arrayJoin.apply(validate(this), arguments);
	    },
	    lastIndexOf: function lastIndexOf(searchElement /* , fromIndex */) { // eslint-disable-line no-unused-vars
	      return arrayLastIndexOf.apply(validate(this), arguments);
	    },
	    map: function map(mapfn /* , thisArg */) {
	      return $map(validate(this), mapfn, arguments.length > 1 ? arguments[1] : undefined);
	    },
	    reduce: function reduce(callbackfn /* , initialValue */) { // eslint-disable-line no-unused-vars
	      return arrayReduce.apply(validate(this), arguments);
	    },
	    reduceRight: function reduceRight(callbackfn /* , initialValue */) { // eslint-disable-line no-unused-vars
	      return arrayReduceRight.apply(validate(this), arguments);
	    },
	    reverse: function reverse() {
	      var that = this;
	      var length = validate(that).length;
	      var middle = Math.floor(length / 2);
	      var index = 0;
	      var value;
	      while (index < middle) {
	        value = that[index];
	        that[index++] = that[--length];
	        that[length] = value;
	      } return that;
	    },
	    some: function some(callbackfn /* , thisArg */) {
	      return arraySome(validate(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined);
	    },
	    sort: function sort(comparefn) {
	      return arraySort.call(validate(this), comparefn);
	    },
	    subarray: function subarray(begin, end) {
	      var O = validate(this);
	      var length = O.length;
	      var $begin = toAbsoluteIndex(begin, length);
	      return new (speciesConstructor(O, O[DEF_CONSTRUCTOR]))(
	        O.buffer,
	        O.byteOffset + $begin * O.BYTES_PER_ELEMENT,
	        toLength((end === undefined ? length : toAbsoluteIndex(end, length)) - $begin)
	      );
	    }
	  };
	
	  var $slice = function slice(start, end) {
	    return speciesFromList(this, arraySlice.call(validate(this), start, end));
	  };
	
	  var $set = function set(arrayLike /* , offset */) {
	    validate(this);
	    var offset = toOffset(arguments[1], 1);
	    var length = this.length;
	    var src = toObject(arrayLike);
	    var len = toLength(src.length);
	    var index = 0;
	    if (len + offset > length) throw RangeError(WRONG_LENGTH);
	    while (index < len) this[offset + index] = src[index++];
	  };
	
	  var $iterators = {
	    entries: function entries() {
	      return arrayEntries.call(validate(this));
	    },
	    keys: function keys() {
	      return arrayKeys.call(validate(this));
	    },
	    values: function values() {
	      return arrayValues.call(validate(this));
	    }
	  };
	
	  var isTAIndex = function (target, key) {
	    return isObject(target)
	      && target[TYPED_ARRAY]
	      && typeof key != 'symbol'
	      && key in target
	      && String(+key) == String(key);
	  };
	  var $getDesc = function getOwnPropertyDescriptor(target, key) {
	    return isTAIndex(target, key = toPrimitive(key, true))
	      ? propertyDesc(2, target[key])
	      : gOPD(target, key);
	  };
	  var $setDesc = function defineProperty(target, key, desc) {
	    if (isTAIndex(target, key = toPrimitive(key, true))
	      && isObject(desc)
	      && has(desc, 'value')
	      && !has(desc, 'get')
	      && !has(desc, 'set')
	      // TODO: add validation descriptor w/o calling accessors
	      && !desc.configurable
	      && (!has(desc, 'writable') || desc.writable)
	      && (!has(desc, 'enumerable') || desc.enumerable)
	    ) {
	      target[key] = desc.value;
	      return target;
	    } return dP(target, key, desc);
	  };
	
	  if (!ALL_CONSTRUCTORS) {
	    $GOPD.f = $getDesc;
	    $DP.f = $setDesc;
	  }
	
	  $export($export.S + $export.F * !ALL_CONSTRUCTORS, 'Object', {
	    getOwnPropertyDescriptor: $getDesc,
	    defineProperty: $setDesc
	  });
	
	  if (fails(function () { arrayToString.call({}); })) {
	    arrayToString = arrayToLocaleString = function toString() {
	      return arrayJoin.call(this);
	    };
	  }
	
	  var $TypedArrayPrototype$ = redefineAll({}, proto);
	  redefineAll($TypedArrayPrototype$, $iterators);
	  hide($TypedArrayPrototype$, ITERATOR, $iterators.values);
	  redefineAll($TypedArrayPrototype$, {
	    slice: $slice,
	    set: $set,
	    constructor: function () { /* noop */ },
	    toString: arrayToString,
	    toLocaleString: $toLocaleString
	  });
	  addGetter($TypedArrayPrototype$, 'buffer', 'b');
	  addGetter($TypedArrayPrototype$, 'byteOffset', 'o');
	  addGetter($TypedArrayPrototype$, 'byteLength', 'l');
	  addGetter($TypedArrayPrototype$, 'length', 'e');
	  dP($TypedArrayPrototype$, TAG, {
	    get: function () { return this[TYPED_ARRAY]; }
	  });
	
	  // eslint-disable-next-line max-statements
	  module.exports = function (KEY, BYTES, wrapper, CLAMPED) {
	    CLAMPED = !!CLAMPED;
	    var NAME = KEY + (CLAMPED ? 'Clamped' : '') + 'Array';
	    var GETTER = 'get' + KEY;
	    var SETTER = 'set' + KEY;
	    var TypedArray = global[NAME];
	    var Base = TypedArray || {};
	    var TAC = TypedArray && getPrototypeOf(TypedArray);
	    var FORCED = !TypedArray || !$typed.ABV;
	    var O = {};
	    var TypedArrayPrototype = TypedArray && TypedArray[PROTOTYPE];
	    var getter = function (that, index) {
	      var data = that._d;
	      return data.v[GETTER](index * BYTES + data.o, LITTLE_ENDIAN);
	    };
	    var setter = function (that, index, value) {
	      var data = that._d;
	      if (CLAMPED) value = (value = Math.round(value)) < 0 ? 0 : value > 0xff ? 0xff : value & 0xff;
	      data.v[SETTER](index * BYTES + data.o, value, LITTLE_ENDIAN);
	    };
	    var addElement = function (that, index) {
	      dP(that, index, {
	        get: function () {
	          return getter(this, index);
	        },
	        set: function (value) {
	          return setter(this, index, value);
	        },
	        enumerable: true
	      });
	    };
	    if (FORCED) {
	      TypedArray = wrapper(function (that, data, $offset, $length) {
	        anInstance(that, TypedArray, NAME, '_d');
	        var index = 0;
	        var offset = 0;
	        var buffer, byteLength, length, klass;
	        if (!isObject(data)) {
	          length = toIndex(data);
	          byteLength = length * BYTES;
	          buffer = new $ArrayBuffer(byteLength);
	        } else if (data instanceof $ArrayBuffer || (klass = classof(data)) == ARRAY_BUFFER || klass == SHARED_BUFFER) {
	          buffer = data;
	          offset = toOffset($offset, BYTES);
	          var $len = data.byteLength;
	          if ($length === undefined) {
	            if ($len % BYTES) throw RangeError(WRONG_LENGTH);
	            byteLength = $len - offset;
	            if (byteLength < 0) throw RangeError(WRONG_LENGTH);
	          } else {
	            byteLength = toLength($length) * BYTES;
	            if (byteLength + offset > $len) throw RangeError(WRONG_LENGTH);
	          }
	          length = byteLength / BYTES;
	        } else if (TYPED_ARRAY in data) {
	          return fromList(TypedArray, data);
	        } else {
	          return $from.call(TypedArray, data);
	        }
	        hide(that, '_d', {
	          b: buffer,
	          o: offset,
	          l: byteLength,
	          e: length,
	          v: new $DataView(buffer)
	        });
	        while (index < length) addElement(that, index++);
	      });
	      TypedArrayPrototype = TypedArray[PROTOTYPE] = create($TypedArrayPrototype$);
	      hide(TypedArrayPrototype, 'constructor', TypedArray);
	    } else if (!fails(function () {
	      TypedArray(1);
	    }) || !fails(function () {
	      new TypedArray(-1); // eslint-disable-line no-new
	    }) || !$iterDetect(function (iter) {
	      new TypedArray(); // eslint-disable-line no-new
	      new TypedArray(null); // eslint-disable-line no-new
	      new TypedArray(1.5); // eslint-disable-line no-new
	      new TypedArray(iter); // eslint-disable-line no-new
	    }, true)) {
	      TypedArray = wrapper(function (that, data, $offset, $length) {
	        anInstance(that, TypedArray, NAME);
	        var klass;
	        // `ws` module bug, temporarily remove validation length for Uint8Array
	        // https://github.com/websockets/ws/pull/645
	        if (!isObject(data)) return new Base(toIndex(data));
	        if (data instanceof $ArrayBuffer || (klass = classof(data)) == ARRAY_BUFFER || klass == SHARED_BUFFER) {
	          return $length !== undefined
	            ? new Base(data, toOffset($offset, BYTES), $length)
	            : $offset !== undefined
	              ? new Base(data, toOffset($offset, BYTES))
	              : new Base(data);
	        }
	        if (TYPED_ARRAY in data) return fromList(TypedArray, data);
	        return $from.call(TypedArray, data);
	      });
	      arrayForEach(TAC !== Function.prototype ? gOPN(Base).concat(gOPN(TAC)) : gOPN(Base), function (key) {
	        if (!(key in TypedArray)) hide(TypedArray, key, Base[key]);
	      });
	      TypedArray[PROTOTYPE] = TypedArrayPrototype;
	      if (!LIBRARY) TypedArrayPrototype.constructor = TypedArray;
	    }
	    var $nativeIterator = TypedArrayPrototype[ITERATOR];
	    var CORRECT_ITER_NAME = !!$nativeIterator
	      && ($nativeIterator.name == 'values' || $nativeIterator.name == undefined);
	    var $iterator = $iterators.values;
	    hide(TypedArray, TYPED_CONSTRUCTOR, true);
	    hide(TypedArrayPrototype, TYPED_ARRAY, NAME);
	    hide(TypedArrayPrototype, VIEW, true);
	    hide(TypedArrayPrototype, DEF_CONSTRUCTOR, TypedArray);
	
	    if (CLAMPED ? new TypedArray(1)[TAG] != NAME : !(TAG in TypedArrayPrototype)) {
	      dP(TypedArrayPrototype, TAG, {
	        get: function () { return NAME; }
	      });
	    }
	
	    O[NAME] = TypedArray;
	
	    $export($export.G + $export.W + $export.F * (TypedArray != Base), O);
	
	    $export($export.S, NAME, {
	      BYTES_PER_ELEMENT: BYTES
	    });
	
	    $export($export.S + $export.F * fails(function () { Base.of.call(TypedArray, 1); }), NAME, {
	      from: $from,
	      of: $of
	    });
	
	    if (!(BYTES_PER_ELEMENT in TypedArrayPrototype)) hide(TypedArrayPrototype, BYTES_PER_ELEMENT, BYTES);
	
	    $export($export.P, NAME, proto);
	
	    setSpecies(NAME);
	
	    $export($export.P + $export.F * FORCED_SET, NAME, { set: $set });
	
	    $export($export.P + $export.F * !CORRECT_ITER_NAME, NAME, $iterators);
	
	    if (!LIBRARY && TypedArrayPrototype.toString != arrayToString) TypedArrayPrototype.toString = arrayToString;
	
	    $export($export.P + $export.F * fails(function () {
	      new TypedArray(1).slice();
	    }), NAME, { slice: $slice });
	
	    $export($export.P + $export.F * (fails(function () {
	      return [1, 2].toLocaleString() != new TypedArray([1, 2]).toLocaleString();
	    }) || !fails(function () {
	      TypedArrayPrototype.toLocaleString.call([1, 2]);
	    })), NAME, { toLocaleString: $toLocaleString });
	
	    Iterators[NAME] = CORRECT_ITER_NAME ? $nativeIterator : $iterator;
	    if (!LIBRARY && !CORRECT_ITER_NAME) hide(TypedArrayPrototype, ITERATOR, $iterator);
	  };
	} else module.exports = function () { /* empty */ };


/***/ },
/* 89 */
/***/ function(module, exports, __webpack_require__) {

	var freeGlobal = __webpack_require__(362);
	
	/** Detect free variable `self`. */
	var freeSelf = typeof self == 'object' && self && self.Object === Object && self;
	
	/** Used as a reference to the global object. */
	var root = freeGlobal || freeSelf || Function('return this')();
	
	module.exports = root;


/***/ },
/* 90 */
/***/ function(module, exports) {

	/**
	 * Checks if `value` is classified as an `Array` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
	 * @example
	 *
	 * _.isArray([1, 2, 3]);
	 * // => true
	 *
	 * _.isArray(document.body.children);
	 * // => false
	 *
	 * _.isArray('abc');
	 * // => false
	 *
	 * _.isArray(_.noop);
	 * // => false
	 */
	var isArray = Array.isArray;
	
	module.exports = isArray;


/***/ },
/* 91 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(36);
	
	var PooledClass = __webpack_require__(113);
	
	var emptyFunction = __webpack_require__(80);
	var warning = __webpack_require__(30);
	
	var didWarnForAddedNewProperty = false;
	var isProxySupported = typeof Proxy === 'function';
	
	var shouldBeReleasedProperties = ['dispatchConfig', '_targetInst', 'nativeEvent', 'isDefaultPrevented', 'isPropagationStopped', '_dispatchListeners', '_dispatchInstances'];
	
	/**
	 * @interface Event
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var EventInterface = {
	  type: null,
	  target: null,
	  // currentTarget is set when dispatching; no use in copying it here
	  currentTarget: emptyFunction.thatReturnsNull,
	  eventPhase: null,
	  bubbles: null,
	  cancelable: null,
	  timeStamp: function (event) {
	    return event.timeStamp || Date.now();
	  },
	  defaultPrevented: null,
	  isTrusted: null
	};
	
	/**
	 * Synthetic events are dispatched by event plugins, typically in response to a
	 * top-level event delegation handler.
	 *
	 * These systems should generally use pooling to reduce the frequency of garbage
	 * collection. The system should check `isPersistent` to determine whether the
	 * event should be released into the pool after being dispatched. Users that
	 * need a persisted event should invoke `persist`.
	 *
	 * Synthetic events (and subclasses) implement the DOM Level 3 Events API by
	 * normalizing browser quirks. Subclasses do not necessarily have to implement a
	 * DOM interface; custom application-specific events can also subclass this.
	 *
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {*} targetInst Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @param {DOMEventTarget} nativeEventTarget Target node.
	 */
	function SyntheticEvent(dispatchConfig, targetInst, nativeEvent, nativeEventTarget) {
	  if (false) {
	    // these have a getter/setter for warnings
	    delete this.nativeEvent;
	    delete this.preventDefault;
	    delete this.stopPropagation;
	  }
	
	  this.dispatchConfig = dispatchConfig;
	  this._targetInst = targetInst;
	  this.nativeEvent = nativeEvent;
	
	  var Interface = this.constructor.Interface;
	  for (var propName in Interface) {
	    if (!Interface.hasOwnProperty(propName)) {
	      continue;
	    }
	    if (false) {
	      delete this[propName]; // this has a getter/setter for warnings
	    }
	    var normalize = Interface[propName];
	    if (normalize) {
	      this[propName] = normalize(nativeEvent);
	    } else {
	      if (propName === 'target') {
	        this.target = nativeEventTarget;
	      } else {
	        this[propName] = nativeEvent[propName];
	      }
	    }
	  }
	
	  var defaultPrevented = nativeEvent.defaultPrevented != null ? nativeEvent.defaultPrevented : nativeEvent.returnValue === false;
	  if (defaultPrevented) {
	    this.isDefaultPrevented = emptyFunction.thatReturnsTrue;
	  } else {
	    this.isDefaultPrevented = emptyFunction.thatReturnsFalse;
	  }
	  this.isPropagationStopped = emptyFunction.thatReturnsFalse;
	  return this;
	}
	
	_assign(SyntheticEvent.prototype, {
	  preventDefault: function () {
	    this.defaultPrevented = true;
	    var event = this.nativeEvent;
	    if (!event) {
	      return;
	    }
	
	    if (event.preventDefault) {
	      event.preventDefault();
	      // eslint-disable-next-line valid-typeof
	    } else if (typeof event.returnValue !== 'unknown') {
	      event.returnValue = false;
	    }
	    this.isDefaultPrevented = emptyFunction.thatReturnsTrue;
	  },
	
	  stopPropagation: function () {
	    var event = this.nativeEvent;
	    if (!event) {
	      return;
	    }
	
	    if (event.stopPropagation) {
	      event.stopPropagation();
	      // eslint-disable-next-line valid-typeof
	    } else if (typeof event.cancelBubble !== 'unknown') {
	      // The ChangeEventPlugin registers a "propertychange" event for
	      // IE. This event does not support bubbling or cancelling, and
	      // any references to cancelBubble throw "Member not found".  A
	      // typeof check of "unknown" circumvents this issue (and is also
	      // IE specific).
	      event.cancelBubble = true;
	    }
	
	    this.isPropagationStopped = emptyFunction.thatReturnsTrue;
	  },
	
	  /**
	   * We release all dispatched `SyntheticEvent`s after each event loop, adding
	   * them back into the pool. This allows a way to hold onto a reference that
	   * won't be added back into the pool.
	   */
	  persist: function () {
	    this.isPersistent = emptyFunction.thatReturnsTrue;
	  },
	
	  /**
	   * Checks if this event should be released back into the pool.
	   *
	   * @return {boolean} True if this should not be released, false otherwise.
	   */
	  isPersistent: emptyFunction.thatReturnsFalse,
	
	  /**
	   * `PooledClass` looks for `destructor` on each instance it releases.
	   */
	  destructor: function () {
	    var Interface = this.constructor.Interface;
	    for (var propName in Interface) {
	      if (false) {
	        Object.defineProperty(this, propName, getPooledWarningPropertyDefinition(propName, Interface[propName]));
	      } else {
	        this[propName] = null;
	      }
	    }
	    for (var i = 0; i < shouldBeReleasedProperties.length; i++) {
	      this[shouldBeReleasedProperties[i]] = null;
	    }
	    if (false) {
	      Object.defineProperty(this, 'nativeEvent', getPooledWarningPropertyDefinition('nativeEvent', null));
	      Object.defineProperty(this, 'preventDefault', getPooledWarningPropertyDefinition('preventDefault', emptyFunction));
	      Object.defineProperty(this, 'stopPropagation', getPooledWarningPropertyDefinition('stopPropagation', emptyFunction));
	    }
	  }
	});
	
	SyntheticEvent.Interface = EventInterface;
	
	/**
	 * Helper to reduce boilerplate when creating subclasses.
	 *
	 * @param {function} Class
	 * @param {?object} Interface
	 */
	SyntheticEvent.augmentClass = function (Class, Interface) {
	  var Super = this;
	
	  var E = function () {};
	  E.prototype = Super.prototype;
	  var prototype = new E();
	
	  _assign(prototype, Class.prototype);
	  Class.prototype = prototype;
	  Class.prototype.constructor = Class;
	
	  Class.Interface = _assign({}, Super.Interface, Interface);
	  Class.augmentClass = Super.augmentClass;
	
	  PooledClass.addPoolingTo(Class, PooledClass.fourArgumentPooler);
	};
	
	/** Proxying after everything set on SyntheticEvent
	  * to resolve Proxy issue on some WebKit browsers
	  * in which some Event properties are set to undefined (GH#10010)
	  */
	if (false) {
	  if (isProxySupported) {
	    /*eslint-disable no-func-assign */
	    SyntheticEvent = new Proxy(SyntheticEvent, {
	      construct: function (target, args) {
	        return this.apply(target, Object.create(target.prototype), args);
	      },
	      apply: function (constructor, that, args) {
	        return new Proxy(constructor.apply(that, args), {
	          set: function (target, prop, value) {
	            if (prop !== 'isPersistent' && !target.constructor.Interface.hasOwnProperty(prop) && shouldBeReleasedProperties.indexOf(prop) === -1) {
	              process.env.NODE_ENV !== 'production' ? warning(didWarnForAddedNewProperty || target.isPersistent(), "This synthetic event is reused for performance reasons. If you're " + "seeing this, you're adding a new property in the synthetic event object. " + 'The property is never released. See ' + 'https://fb.me/react-event-pooling for more information.') : void 0;
	              didWarnForAddedNewProperty = true;
	            }
	            target[prop] = value;
	            return true;
	          }
	        });
	      }
	    });
	    /*eslint-enable no-func-assign */
	  }
	}
	
	PooledClass.addPoolingTo(SyntheticEvent, PooledClass.fourArgumentPooler);
	
	module.exports = SyntheticEvent;
	
	/**
	  * Helper to nullify syntheticEvent instance properties when destructing
	  *
	  * @param {object} SyntheticEvent
	  * @param {String} propName
	  * @return {object} defineProperty object
	  */
	function getPooledWarningPropertyDefinition(propName, getVal) {
	  var isFunction = typeof getVal === 'function';
	  return {
	    configurable: true,
	    set: set,
	    get: get
	  };
	
	  function set(val) {
	    var action = isFunction ? 'setting the method' : 'setting the property';
	    warn(action, 'This is effectively a no-op');
	    return val;
	  }
	
	  function get() {
	    var action = isFunction ? 'accessing the method' : 'accessing the property';
	    var result = isFunction ? 'This is a no-op function' : 'This is set to null';
	    warn(action, result);
	    return getVal;
	  }
	
	  function warn(action, result) {
	    var warningCondition = false;
	     false ? warning(warningCondition, "This synthetic event is reused for performance reasons. If you're seeing this, " + "you're %s `%s` on a released/nullified synthetic event. %s. " + 'If you must keep the original synthetic event around, use event.persist(). ' + 'See https://fb.me/react-event-pooling for more information.', action, propName, result) : void 0;
	  }
	}

/***/ },
/* 92 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	/**
	 * Keeps track of the current owner.
	 *
	 * The current owner is the component who should own any components that are
	 * currently being constructed.
	 */
	var ReactCurrentOwner = {
	  /**
	   * @internal
	   * @type {ReactComponent}
	   */
	  current: null
	};
	
	module.exports = ReactCurrentOwner;

/***/ },
/* 93 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(5);
	
	var _redux = __webpack_require__(4);
	
	var _RotationKpiMeter = __webpack_require__(82);
	
	var _RotationKpiMeter2 = _interopRequireDefault(_RotationKpiMeter);
	
	var _KpiResultReview = __webpack_require__(151);
	
	var _KpiResultReview2 = _interopRequireDefault(_KpiResultReview);
	
	var _appDataActions = __webpack_require__(12);
	
	var appDataActions = _interopRequireWildcard(_appDataActions);
	
	var _trackingDataActions = __webpack_require__(7);
	
	var trackingDataActions = _interopRequireWildcard(_trackingDataActions);
	
	var _dataHelper = __webpack_require__(11);
	
	var dataHelper = _interopRequireWildcard(_dataHelper);
	
	var _appHelper = __webpack_require__(3);
	
	var appHelper = _interopRequireWildcard(_appHelper);
	
	var _kpiHelper = __webpack_require__(35);
	
	var kpiHelper = _interopRequireWildcard(_kpiHelper);
	
	var _kpiConstants = __webpack_require__(37);
	
	var kpiConstants = _interopRequireWildcard(_kpiConstants);
	
	var _objectConstants = __webpack_require__(9);
	
	var objectConstants = _interopRequireWildcard(_objectConstants);
	
	var _kpiModels = __webpack_require__(57);
	
	var kpiModels = _interopRequireWildcard(_kpiModels);
	
	var _gsap = __webpack_require__(8);
	
	var _gsapReactPlugin = __webpack_require__(10);
	
	var _gsapReactPlugin2 = _interopRequireDefault(_gsapReactPlugin);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var KpiDashboard = function (_React$Component) {
	    _inherits(KpiDashboard, _React$Component);
	
	    function KpiDashboard(props, context) {
	        _classCallCheck(this, KpiDashboard);
	
	        var _this = _possibleConstructorReturn(this, (KpiDashboard.__proto__ || Object.getPrototypeOf(KpiDashboard)).call(this, props, context));
	
	        _this.state = {
	            lang: _this.props.lang,
	            userKpisResults: kpiHelper.setKpiRenderOrder(_this.props.userKpisResults),
	            bite: _this.props.bite,
	            kpis: kpiHelper.getKpis(_this.props.bite),
	            showTitle: _this.props.showTitle,
	            locale: {},
	            guid: dataHelper.createGuid(),
	            allowUpdates: true,
	            updatedKpis: [],
	            checkAllUpdated: false,
	            performance_label: appHelper.getLocaleString("performance_label")
	        };
	
	        _this.getKpiLocaleById = _this.getKpiLocaleById.bind(_this);
	        _this.getKpiMeterParams = _this.getKpiMeterParams.bind(_this);
	        _this.getLocale = _this.getLocale.bind(_this);
	        _this.showDashboard = _this.showDashboard.bind(_this);
	        _this.onComplete = _this.onComplete.bind(_this);
	        _this.getKpiItemClass = _this.getKpiItemClass.bind(_this);
	        _this.setReviewStateKpiData = _this.setReviewStateKpiData.bind(_this);
	        _this.onUpdateComplete = _this.onUpdateComplete.bind(_this);
	        return _this;
	    }
	
	    _createClass(KpiDashboard, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            if (this.props.displayState === kpiConstants.KPI_DISPLAY_STATE_REVIEW_POINTS_AWARDED) {
	                this.setReviewStateKpiData();
	            }
	            this.getLocale();
	            this.showDashboard();
	        }
	    }, {
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(nextProps) {
	            if (this.state.userKpisResults !== nextProps.userKpisResults) {
	                //console.log('update dashboard');
	                //this.setState({userKpisResults: kpiHelper.setKpiRenderOrder(nextProps.userKpisResults)});
	            }
	            if (this.state.showTitle !== nextProps.showTitle) {
	                this.setState({ showTitle: nextProps.showTitle });
	            }
	            if (this.state.lang !== nextProps.lang) {
	                this.setState({
	                    lang: nextProps.lang,
	                    locale: appHelper.getLocalData(this.state.bite),
	                    performance_label: appHelper.getLocaleString("performance_label")
	                });
	            }
	        }
	    }, {
	        key: 'shouldComponentUpdate',
	        value: function shouldComponentUpdate() {
	            return this.state.allowUpdates;
	        }
	    }, {
	        key: 'componentDidUpdate',
	        value: function componentDidUpdate() {}
	    }, {
	        key: 'getLocale',
	        value: function getLocale() {
	            var locale = appHelper.getLocalData(this.state.bite);
	            this.setState({ locale: Object.assign({}, locale) });
	        }
	    }, {
	        key: 'getKpiLocaleById',
	        value: function getKpiLocaleById(kpi_id) {
	            var kpi = appHelper.getArrayObjectByKey(this.state.bite.kpis, "kpi_id", kpi_id);
	            return appHelper.getLocalData(kpi);
	        }
	    }, {
	        key: 'getKpiMeterParams',
	        value: function getKpiMeterParams(is_primary) {
	            if (is_primary) {
	                return kpiModels.PRIMARY_KPI_ROTATION_METER_PARAMS;
	            } else {
	                if (this.state.kpis.length < 3) {
	                    return kpiModels.PRIMARY_KPI_ROTATION_METER_PARAMS;
	                } else {
	                    return kpiModels.DEFAULT_KPI_ROTATION_METER_PARAMS;
	                }
	            }
	        }
	    }, {
	        key: 'setReviewStateKpiData',
	        value: function setReviewStateKpiData() {
	            var primaryKpiIndex = kpiHelper.getPrimaryKpiIndex(this.state.userKpisResults);
	            var primaryKpi = kpiHelper.getPrimaryKpi(this.state.userKpisResults);
	            var reorderedKpis = dataHelper.immutableSplice(this.state.userKpisResults, primaryKpiIndex, 1);
	            reorderedKpis = dataHelper.immutableUnshift(reorderedKpis, primaryKpi);
	
	            this.setState({
	                userKpisResults: Object.assign([], reorderedKpis)
	            });
	        }
	    }, {
	        key: 'getKpiItemClass',
	        value: function getKpiItemClass(kpi) {
	            if (this.props.displayState === kpiConstants.KPI_DISPLAY_STATE_CURRENT_VALUE_WITH_LABEL) {
	                return 'kpi-item inline';
	            } else {
	                return 'kpi-item-review inline';
	            }
	        }
	    }, {
	        key: 'showDashboard',
	        value: function showDashboard() {
	
	            var optionRef = this.refs['kpi_dashboard_' + this.state.guid];
	            _gsap.TweenLite.set(optionRef, { height: "auto" });
	            _gsap.TweenLite.from(optionRef, objectConstants.SHOW_PANEL_DURATION, {
	                height: 0,
	                ease: _gsap.Expo.linear
	            }).eventCallback("onComplete", this.onComplete);
	        }
	    }, {
	        key: 'onComplete',
	        value: function onComplete() {
	            if (!this.props.responseReview) {
	                this.setState({ allowUpdates: false });
	            }
	
	            if (typeof this.props.onComplete !== 'undefined') {
	                this.props.onComplete();
	            }
	        }
	    }, {
	        key: 'onUpdateComplete',
	        value: function onUpdateComplete(kpi_id) {
	            var kpi_idIndex = appHelper.getArrayObjectIndexByKey(this.state.updatedKpis, "kpi_id", kpi_id);
	            if (kpi_idIndex === -1) {
	                this.setState({ updatedKpis: dataHelper.immutablePush(this.state.updatedKpis, kpi_id) });
	            }
	            if (this.state.updatedKpis.length >= this.state.userKpisResults.length && appHelper.isDefined(this.props.onUpdateComplete)) {
	                this.props.onUpdateComplete();
	            }
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this2 = this;
	
	            return _react2.default.createElement(
	                'div',
	                { className: 'kpi-dashboard', ref: 'kpi_dashboard_' + this.state.guid },
	                this.state.showTitle ? _react2.default.createElement(
	                    'h4',
	                    { className: 'text-center' },
	                    this.state.performance_label
	                ) : null,
	                _react2.default.createElement(
	                    'div',
	                    { className: 'object-container' },
	                    _react2.default.createElement(
	                        'ul',
	                        { className: 'inline-list ' + (!this.props.responseReview ? 'text-center' : '') },
	                        this.state.userKpisResults.map(function (kpi) {
	                            return (appHelper.isDefined(_this2.props.hideScoreKpi) && _this2.props.hideScoreKpi && !kpi.is_primary || !appHelper.isDefined(_this2.props.hideScoreKpi) || appHelper.isDefined(_this2.props.hideScoreKpi) && !_this2.props.hideScoreKpi) && _this2.props.responseReview && appHelper.isDefined(appHelper.getArrayObjectByKey(_this2.state.kpis, "kpi_id", kpi.kpi_id)) && appHelper.getArrayObjectByKey(_this2.state.kpis, "kpi_id", kpi.kpi_id).is_visible ? _react2.default.createElement(
	                                'li',
	                                { className: 'inline-item ' + _this2.getKpiItemClass(kpi),
	                                    key: kpi.kpi_id + '_' + dataHelper.createGuid() },
	                                _react2.default.createElement(_KpiResultReview2.default, {
	                                    kpiDefaults: appHelper.getArrayObjectByKey(_this2.state.kpis, "kpi_id", kpi.kpi_id),
	                                    meterParams: _this2.getKpiMeterParams(false),
	                                    kpi: appHelper.getArrayObjectByKey(_this2.props.option.kpis, "kpi_id", kpi.kpi_id) })
	                            ) : null;
	                        }),
	                        this.state.userKpisResults.map(function (kpi) {
	                            return !_this2.props.responseReview && appHelper.isDefined(appHelper.getArrayObjectByKey(_this2.state.kpis, "kpi_id", kpi.kpi_id)) && appHelper.isDefined(appHelper.getArrayObjectByKey(_this2.state.kpis, "kpi_id", kpi.kpi_id)) && appHelper.getArrayObjectByKey(_this2.state.kpis, "kpi_id", kpi.kpi_id).is_visible ? _react2.default.createElement(
	                                'li',
	                                { className: 'inline-item ' + _this2.getKpiItemClass(kpi),
	                                    key: kpi.kpi_id + '_' + dataHelper.createGuid() },
	                                _react2.default.createElement(_RotationKpiMeter2.default, { bite_id: _this2.state.bite.bite_id,
	                                    kpiDefaults: appHelper.getArrayObjectByKey(_this2.state.kpis, "kpi_id", kpi.kpi_id),
	                                    index: appHelper.getArrayObjectIndexByKey(_this2.state.kpis, "kpi_id", kpi.kpi_id),
	                                    showImmediateImpact: _this2.props.showImmediateImpact,
	                                    meterParams: _this2.getKpiMeterParams(kpi.is_primary),
	                                    displayState: _this2.props.displayState,
	                                    responseReview: _this2.props.responseReview,
	                                    screen_id: _this2.props.screen_id,
	                                    asset_id: _this2.props.asset_id,
	                                    option_id: typeof _this2.props.option !== "undefined" ? _this2.props.option.option_id : 0,
	                                    onRotationComplete: _this2.onUpdateComplete })
	                            ) : null;
	                        })
	                    )
	                )
	            );
	        }
	    }]);
	
	    return KpiDashboard;
	}(_react2.default.Component);
	
	KpiDashboard.propTypes = {
	    displayState: _propTypes2.default.string.isRequired,
	    bite_id: _propTypes2.default.number.isRequired,
	    showTitle: _propTypes2.default.bool.isRequired,
	    lang: _propTypes2.default.string.isRequired,
	    bite: _propTypes2.default.object,
	    responseReview: _propTypes2.default.bool,
	    screen_id: _propTypes2.default.number,
	    asset_id: _propTypes2.default.number,
	    option: _propTypes2.default.object,
	    showImmediateImpact: _propTypes2.default.bool,
	    userKpisResults: _propTypes2.default.array,
	    onComplete: _propTypes2.default.func,
	    onUpdateComplete: _propTypes2.default.func,
	    hideScoreKpi: _propTypes2.default.bool
	
	};
	
	KpiDashboard.contextTypes = {
	    router: _propTypes2.default.object
	};
	
	function mapStateToProps(state, ownProps) {
	    var userBite = appHelper.getArrayObjectByKey(state.userData.bites, "bite_id", ownProps.bite_id);
	    var bite = appHelper.getBite(ownProps.bite_id);
	    var userKpisResults = userBite.kpis;
	
	    var lang = state.userData.lang;
	    return {
	        lang: lang,
	        userKpisResults: userKpisResults,
	        bite: bite
	    };
	}
	
	function mapDispatchToProps(dispatch) {
	    return {
	        actions: (0, _redux.bindActionCreators)(Object.assign({}, trackingDataActions, appDataActions), dispatch)
	    };
	}
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(KpiDashboard);

/***/ },
/* 94 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(5);
	
	var _redux = __webpack_require__(4);
	
	var _appDataActions = __webpack_require__(12);
	
	var appDataActions = _interopRequireWildcard(_appDataActions);
	
	var _trackingDataActions = __webpack_require__(7);
	
	var trackingDataActions = _interopRequireWildcard(_trackingDataActions);
	
	var _dialogPopupActions = __webpack_require__(19);
	
	var dialogPopupActions = _interopRequireWildcard(_dialogPopupActions);
	
	var _appHelper = __webpack_require__(3);
	
	var appHelper = _interopRequireWildcard(_appHelper);
	
	var _dataHelper = __webpack_require__(11);
	
	var dataHelper = _interopRequireWildcard(_dataHelper);
	
	var _userDataHelper = __webpack_require__(15);
	
	var userDataHelper = _interopRequireWildcard(_userDataHelper);
	
	var _appConstants = __webpack_require__(13);
	
	var appConstants = _interopRequireWildcard(_appConstants);
	
	var _objectConstants = __webpack_require__(9);
	
	var objectConstants = _interopRequireWildcard(_objectConstants);
	
	var _gsap = __webpack_require__(8);
	
	var _gsapReactPlugin = __webpack_require__(10);
	
	var _gsapReactPlugin2 = _interopRequireDefault(_gsapReactPlugin);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var DialogPrompt = function (_React$Component) {
	    _inherits(DialogPrompt, _React$Component);
	
	    function DialogPrompt(props, context) {
	        _classCallCheck(this, DialogPrompt);
	
	        var _this = _possibleConstructorReturn(this, (DialogPrompt.__proto__ || Object.getPrototypeOf(DialogPrompt)).call(this, props, context));
	
	        _this.state = {
	            locale: _this.props.locale,
	            isVisible: false,
	            screen: appHelper.getScreenByAssetId(_this.props.id),
	            character: {
	                src: "",
	                pose: "",
	                position: ""
	            }
	        };
	
	        _this.show = _this.show.bind(_this);
	        _this.onShowComplete = _this.onShowComplete.bind(_this);
	        _this.hide = _this.hide.bind(_this);
	        _this.onHideComplete = _this.onHideComplete.bind(_this);
	        _this.getAssets = _this.getAssets.bind(_this);
	        _this.getImagePath = _this.getImagePath.bind(_this);
	        _this.getClass = _this.getClass.bind(_this);
	        return _this;
	    }
	
	    _createClass(DialogPrompt, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            this.getAssets();
	            this.show();
	        }
	    }, {
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(nextProps) {
	            if (this.state.locale !== nextProps.locale) {
	                this.setState({ locale: Object.assign({}, nextProps.locale) });
	            }
	        }
	    }, {
	        key: 'componentDidUpdate',
	        value: function componentDidUpdate() {}
	    }, {
	        key: 'getAssets',
	        value: function getAssets() {
	            var screenCharacter = {};
	            var characterAsset = Object.assign(this.state.character);
	
	            if (appHelper.isDefined(this.state.screen.assets.character)) {
	                screenCharacter = appHelper.getCharacterAsset(this.state.screen.assets.character);
	                characterAsset = appHelper.getCharacterPose(screenCharacter, this.state.screen.assets.character);
	            }
	
	            if (appHelper.isDefined(this.props.id)) {
	                var asset = appHelper.getArrayObjectByKey(this.state.screen.objects, "asset_id", this.props.id);
	                if (appHelper.isDefined(asset.character_pose) && asset.character_pose.pose !== objectConstants.INHERIT) {
	                    characterAsset = appHelper.getCharacterPose(screenCharacter, asset.character_pose);
	                }
	            }
	
	            if (appHelper.isDefined(characterAsset.src)) {
	                this.setState({ character: Object.assign({}, characterAsset) });
	            }
	        }
	    }, {
	        key: 'getImagePath',
	        value: function getImagePath(image) {
	            if (appConstants.DEVELOPMENT_MODE) {
	                if (appHelper.isDefined(image) && image.length > 0) {
	                    return __webpack_require__(16)("./" + image);
	                }
	            } else {
	                return image;
	            }
	        }
	    }, {
	        key: 'show',
	        value: function show() {
	            var optionRef = this.refs['prompt_' + this.props.id];
	            _gsap.TweenLite.set(optionRef, { height: "auto" });
	            _gsap.TweenLite.from(optionRef, objectConstants.SPEECH_BUBBLE_DURATION, {
	                height: 0,
	                ease: _gsap.Expo.easeInOut
	            }).eventCallback("onComplete", this.onShowComplete);
	        }
	    }, {
	        key: 'onShowComplete',
	        value: function onShowComplete() {
	            this.setState({ isVisible: true });
	            if (appHelper.isDefined(this.props.onComplete)) {
	                this.props.onComplete();
	            }
	        }
	    }, {
	        key: 'hide',
	        value: function hide() {
	            var optionRef = this.refs['prompt_' + this.props.id];
	
	            _gsap.TweenLite.to(optionRef, 1, {
	                height: 0,
	                ease: _gsap.Expo.easeInOut
	            }).eventCallback("onComplete", this.onHideComplete);
	        }
	    }, {
	        key: 'onHideComplete',
	        value: function onHideComplete() {
	            this.setState({ isVisible: false });
	        }
	    }, {
	        key: 'getClass',
	        value: function getClass() {
	            return appHelper.isDefined(this.state.character.src) && this.state.character.src.length > 0 ? 'customer-has-expression' : '';
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            return _react2.default.createElement(
	                'div',
	                { className: '  object-container-conversation ' + this.getClass(), ref: 'prompt_' + this.props.id },
	                this.props.show_title ? _react2.default.createElement('h4', { dangerouslySetInnerHTML: { __html: this.state.locale.label } }) : null,
	                _react2.default.createElement(
	                    'div',
	                    { className: 'customer_name_label' },
	                    appHelper.isDefined(this.props.character_name) && this.props.character_name !== null && this.props.character_name.length > 0 ? _react2.default.createElement(
	                        'span',
	                        null,
	                        this.props.character_name
	                    ) : _react2.default.createElement(
	                        'span',
	                        null,
	                        'Character'
	                    )
	                ),
	                appHelper.isDefined(this.state.character.src) && this.state.character.src.length > 0 ? _react2.default.createElement(
	                    'div',
	                    { className: 'character-expression' },
	                    _react2.default.createElement('img', { src: this.getImagePath(this.state.character.src), alt: '' })
	                ) : null,
	                appHelper.isDefined(this.state.locale.description) && this.state.locale.description !== null && this.state.locale.description !== null && this.state.locale.description.length > 0 ? _react2.default.createElement('div', { className: 'character speak', dangerouslySetInnerHTML: { __html: this.state.locale.description } }) : null
	            );
	        }
	    }]);
	
	    return DialogPrompt;
	}(_react2.default.Component);
	
	DialogPrompt.propTypes = {
	    id: _propTypes2.default.number.isRequired,
	    locale: _propTypes2.default.object.isRequired,
	    character_name: _propTypes2.default.string,
	    show_title: _propTypes2.default.bool.isRequired,
	    onComplete: _propTypes2.default.func,
	    actions: _propTypes2.default.object.isRequired
	};
	
	DialogPrompt.contextTypes = {
	    router: _propTypes2.default.object
	};
	
	function mapStateToProps(state) {
	    return {};
	}
	
	function mapDispatchToProps(dispatch) {
	    return {
	        actions: (0, _redux.bindActionCreators)(Object.assign({}, appDataActions, trackingDataActions, dialogPopupActions), dispatch)
	    };
	}
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(DialogPrompt);

/***/ },
/* 95 */
/***/ function(module, exports, __webpack_require__) {

	// 22.1.3.31 Array.prototype[@@unscopables]
	var UNSCOPABLES = __webpack_require__(34)('unscopables');
	var ArrayProto = Array.prototype;
	if (ArrayProto[UNSCOPABLES] == undefined) __webpack_require__(52)(ArrayProto, UNSCOPABLES, {});
	module.exports = function (key) {
	  ArrayProto[UNSCOPABLES][key] = true;
	};


/***/ },
/* 96 */
/***/ function(module, exports) {

	module.exports = false;


/***/ },
/* 97 */
/***/ function(module, exports, __webpack_require__) {

	var META = __webpack_require__(111)('meta');
	var isObject = __webpack_require__(27);
	var has = __webpack_require__(58);
	var setDesc = __webpack_require__(39).f;
	var id = 0;
	var isExtensible = Object.isExtensible || function () {
	  return true;
	};
	var FREEZE = !__webpack_require__(26)(function () {
	  return isExtensible(Object.preventExtensions({}));
	});
	var setMeta = function (it) {
	  setDesc(it, META, { value: {
	    i: 'O' + ++id, // object ID
	    w: {}          // weak collections IDs
	  } });
	};
	var fastKey = function (it, create) {
	  // return primitive with prefix
	  if (!isObject(it)) return typeof it == 'symbol' ? it : (typeof it == 'string' ? 'S' : 'P') + it;
	  if (!has(it, META)) {
	    // can't set metadata to uncaught frozen object
	    if (!isExtensible(it)) return 'F';
	    // not necessary to add metadata
	    if (!create) return 'E';
	    // add missing metadata
	    setMeta(it);
	  // return object ID
	  } return it[META].i;
	};
	var getWeak = function (it, create) {
	  if (!has(it, META)) {
	    // can't set metadata to uncaught frozen object
	    if (!isExtensible(it)) return true;
	    // not necessary to add metadata
	    if (!create) return false;
	    // add missing metadata
	    setMeta(it);
	  // return hash weak collections IDs
	  } return it[META].w;
	};
	// add metadata on freeze-family methods calling
	var onFreeze = function (it) {
	  if (FREEZE && meta.NEED && isExtensible(it) && !has(it, META)) setMeta(it);
	  return it;
	};
	var meta = module.exports = {
	  KEY: META,
	  NEED: false,
	  fastKey: fastKey,
	  getWeak: getWeak,
	  onFreeze: onFreeze
	};


/***/ },
/* 98 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.createPath = exports.parsePath = exports.getQueryStringValueFromPath = exports.stripQueryStringValueFromPath = exports.addQueryStringValueToPath = undefined;
	
	var _warning = __webpack_require__(101);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var addQueryStringValueToPath = exports.addQueryStringValueToPath = function addQueryStringValueToPath(path, key, value) {
	  var _parsePath = parsePath(path),
	      pathname = _parsePath.pathname,
	      search = _parsePath.search,
	      hash = _parsePath.hash;
	
	  return createPath({
	    pathname: pathname,
	    search: search + (search.indexOf('?') === -1 ? '?' : '&') + key + '=' + value,
	    hash: hash
	  });
	};
	
	var stripQueryStringValueFromPath = exports.stripQueryStringValueFromPath = function stripQueryStringValueFromPath(path, key) {
	  var _parsePath2 = parsePath(path),
	      pathname = _parsePath2.pathname,
	      search = _parsePath2.search,
	      hash = _parsePath2.hash;
	
	  return createPath({
	    pathname: pathname,
	    search: search.replace(new RegExp('([?&])' + key + '=[a-zA-Z0-9]+(&?)'), function (match, prefix, suffix) {
	      return prefix === '?' ? prefix : suffix;
	    }),
	    hash: hash
	  });
	};
	
	var getQueryStringValueFromPath = exports.getQueryStringValueFromPath = function getQueryStringValueFromPath(path, key) {
	  var _parsePath3 = parsePath(path),
	      search = _parsePath3.search;
	
	  var match = search.match(new RegExp('[?&]' + key + '=([a-zA-Z0-9]+)'));
	  return match && match[1];
	};
	
	var extractPath = function extractPath(string) {
	  var match = string.match(/^(https?:)?\/\/[^\/]*/);
	  return match == null ? string : string.substring(match[0].length);
	};
	
	var parsePath = exports.parsePath = function parsePath(path) {
	  var pathname = extractPath(path);
	  var search = '';
	  var hash = '';
	
	   false ? (0, _warning2.default)(path === pathname, 'A path must be pathname + search + hash only, not a full URL like "%s"', path) : void 0;
	
	  var hashIndex = pathname.indexOf('#');
	  if (hashIndex !== -1) {
	    hash = pathname.substring(hashIndex);
	    pathname = pathname.substring(0, hashIndex);
	  }
	
	  var searchIndex = pathname.indexOf('?');
	  if (searchIndex !== -1) {
	    search = pathname.substring(searchIndex);
	    pathname = pathname.substring(0, searchIndex);
	  }
	
	  if (pathname === '') pathname = '/';
	
	  return {
	    pathname: pathname,
	    search: search,
	    hash: hash
	  };
	};
	
	var createPath = exports.createPath = function createPath(location) {
	  if (location == null || typeof location === 'string') return location;
	
	  var basename = location.basename,
	      pathname = location.pathname,
	      search = location.search,
	      hash = location.hash;
	
	  var path = (basename || '') + pathname;
	
	  if (search && search !== '?') path += search;
	
	  if (hash) path += hash;
	
	  return path;
	};

/***/ },
/* 99 */
/***/ function(module, exports) {

	/**
	 * mux.js
	 *
	 * Copyright (c) 2014 Brightcove
	 * All rights reserved.
	 *
	 * A lightweight readable stream implemention that handles event dispatching.
	 * Objects that inherit from streams should call init in their constructors.
	 */
	'use strict';
	
	var Stream = function() {
	  this.init = function() {
	    var listeners = {};
	    /**
	     * Add a listener for a specified event type.
	     * @param type {string} the event name
	     * @param listener {function} the callback to be invoked when an event of
	     * the specified type occurs
	     */
	    this.on = function(type, listener) {
	      if (!listeners[type]) {
	        listeners[type] = [];
	      }
	      listeners[type] = listeners[type].concat(listener);
	    };
	    /**
	     * Remove a listener for a specified event type.
	     * @param type {string} the event name
	     * @param listener {function} a function previously registered for this
	     * type of event through `on`
	     */
	    this.off = function(type, listener) {
	      var index;
	      if (!listeners[type]) {
	        return false;
	      }
	      index = listeners[type].indexOf(listener);
	      listeners[type] = listeners[type].slice();
	      listeners[type].splice(index, 1);
	      return index > -1;
	    };
	    /**
	     * Trigger an event of the specified type on this stream. Any additional
	     * arguments to this function are passed as parameters to event listeners.
	     * @param type {string} the event name
	     */
	    this.trigger = function(type) {
	      var callbacks, i, length, args;
	      callbacks = listeners[type];
	      if (!callbacks) {
	        return;
	      }
	      // Slicing the arguments on every invocation of this method
	      // can add a significant amount of overhead. Avoid the
	      // intermediate object creation for the common case of a
	      // single callback argument
	      if (arguments.length === 2) {
	        length = callbacks.length;
	        for (i = 0; i < length; ++i) {
	          callbacks[i].call(this, arguments[1]);
	        }
	      } else {
	        args = [];
	        i = arguments.length;
	        for (i = 1; i < arguments.length; ++i) {
	          args.push(arguments[i]);
	        }
	        length = callbacks.length;
	        for (i = 0; i < length; ++i) {
	          callbacks[i].apply(this, args);
	        }
	      }
	    };
	    /**
	     * Destroys the stream and cleans up.
	     */
	    this.dispose = function() {
	      listeners = {};
	    };
	  };
	};
	
	/**
	 * Forwards all `data` events on this stream to the destination stream. The
	 * destination stream should provide a method `push` to receive the data
	 * events as they arrive.
	 * @param destination {stream} the stream that will receive all `data` events
	 * @param autoFlush {boolean} if false, we will not call `flush` on the destination
	 *                            when the current stream emits a 'done' event
	 * @see http://nodejs.org/api/stream.html#stream_readable_pipe_destination_options
	 */
	Stream.prototype.pipe = function(destination) {
	  this.on('data', function(data) {
	    destination.push(data);
	  });
	
	  this.on('done', function(flushSource) {
	    destination.flush(flushSource);
	  });
	
	  return destination;
	};
	
	// Default stream functions that are expected to be overridden to perform
	// actual work. These are provided by the prototype as a sort of no-op
	// implementation so that we don't have to check for their existence in the
	// `pipe` function above.
	Stream.prototype.push = function(data) {
	  this.trigger('data', data);
	};
	
	Stream.prototype.flush = function(flushSource) {
	  this.trigger('done', flushSource);
	};
	
	module.exports = Stream;


/***/ },
/* 100 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.isReactChildren = isReactChildren;
	exports.createRouteFromReactElement = createRouteFromReactElement;
	exports.createRoutesFromReactChildren = createRoutesFromReactChildren;
	exports.createRoutes = createRoutes;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function isValidChild(object) {
	  return object == null || _react2.default.isValidElement(object);
	}
	
	function isReactChildren(object) {
	  return isValidChild(object) || Array.isArray(object) && object.every(isValidChild);
	}
	
	function createRoute(defaultProps, props) {
	  return _extends({}, defaultProps, props);
	}
	
	function createRouteFromReactElement(element) {
	  var type = element.type;
	  var route = createRoute(type.defaultProps, element.props);
	
	  if (route.children) {
	    var childRoutes = createRoutesFromReactChildren(route.children, route);
	
	    if (childRoutes.length) route.childRoutes = childRoutes;
	
	    delete route.children;
	  }
	
	  return route;
	}
	
	/**
	 * Creates and returns a routes object from the given ReactChildren. JSX
	 * provides a convenient way to visualize how routes in the hierarchy are
	 * nested.
	 *
	 *   import { Route, createRoutesFromReactChildren } from 'react-router'
	 *
	 *   const routes = createRoutesFromReactChildren(
	 *     <Route component={App}>
	 *       <Route path="home" component={Dashboard}/>
	 *       <Route path="news" component={NewsFeed}/>
	 *     </Route>
	 *   )
	 *
	 * Note: This method is automatically used when you provide <Route> children
	 * to a <Router> component.
	 */
	function createRoutesFromReactChildren(children, parentRoute) {
	  var routes = [];
	
	  _react2.default.Children.forEach(children, function (element) {
	    if (_react2.default.isValidElement(element)) {
	      // Component classes may have a static create* method.
	      if (element.type.createRouteFromReactElement) {
	        var route = element.type.createRouteFromReactElement(element, parentRoute);
	
	        if (route) routes.push(route);
	      } else {
	        routes.push(createRouteFromReactElement(element));
	      }
	    }
	  });
	
	  return routes;
	}
	
	/**
	 * Creates and returns an array of routes from the given object which
	 * may be a JSX route, a plain object route, or an array of either.
	 */
	function createRoutes(routes) {
	  if (isReactChildren(routes)) {
	    routes = createRoutesFromReactChildren(routes);
	  } else if (routes && !Array.isArray(routes)) {
	    routes = [routes];
	  }
	
	  return routes;
	}

/***/ },
/* 101 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2014-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 */
	
	'use strict';
	
	/**
	 * Similar to invariant but only logs a warning if the condition is not met.
	 * This can be used to log issues in development environments in critical
	 * paths. Removing the logging code for production environments will keep the
	 * same logic and follow the same code paths.
	 */
	
	var warning = function() {};
	
	if (false) {
	  warning = function(condition, format, args) {
	    var len = arguments.length;
	    args = new Array(len > 2 ? len - 2 : 0);
	    for (var key = 2; key < len; key++) {
	      args[key - 2] = arguments[key];
	    }
	    if (format === undefined) {
	      throw new Error(
	        '`warning(condition, format, ...args)` requires a warning ' +
	        'message argument'
	      );
	    }
	
	    if (format.length < 10 || (/^[s\W]*$/).test(format)) {
	      throw new Error(
	        'The warning format should be able to uniquely identify this ' +
	        'warning. Please, use a more descriptive format than: ' + format
	      );
	    }
	
	    if (!condition) {
	      var argIndex = 0;
	      var message = 'Warning: ' +
	        format.replace(/%s/g, function() {
	          return args[argIndex++];
	        });
	      if (typeof console !== 'undefined') {
	        console.error(message);
	      }
	      try {
	        // This error was thrown as a convenience so that you can use this stack
	        // to find the callsite that caused this warning to fire.
	        throw new Error(message);
	      } catch(x) {}
	    }
	  };
	}
	
	module.exports = warning;


/***/ },
/* 102 */
/***/ function(module, exports) {

	module.exports = function (it, Constructor, name, forbiddenField) {
	  if (!(it instanceof Constructor) || (forbiddenField !== undefined && forbiddenField in it)) {
	    throw TypeError(name + ': incorrect invocation!');
	  } return it;
	};


/***/ },
/* 103 */
/***/ function(module, exports, __webpack_require__) {

	var ctx = __webpack_require__(71);
	var call = __webpack_require__(303);
	var isArrayIter = __webpack_require__(213);
	var anObject = __webpack_require__(23);
	var toLength = __webpack_require__(40);
	var getIterFn = __webpack_require__(229);
	var BREAK = {};
	var RETURN = {};
	var exports = module.exports = function (iterable, entries, fn, that, ITERATOR) {
	  var iterFn = ITERATOR ? function () { return iterable; } : getIterFn(iterable);
	  var f = ctx(fn, that, entries ? 2 : 1);
	  var index = 0;
	  var length, step, iterator, result;
	  if (typeof iterFn != 'function') throw TypeError(iterable + ' is not iterable!');
	  // fast case for arrays with default iterator
	  if (isArrayIter(iterFn)) for (length = toLength(iterable.length); length > index; index++) {
	    result = entries ? f(anObject(step = iterable[index])[0], step[1]) : f(iterable[index]);
	    if (result === BREAK || result === RETURN) return result;
	  } else for (iterator = iterFn.call(iterable); !(step = iterator.next()).done;) {
	    result = call(iterator, f, step.value, entries);
	    if (result === BREAK || result === RETURN) return result;
	  }
	};
	exports.BREAK = BREAK;
	exports.RETURN = RETURN;


/***/ },
/* 104 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
	var anObject = __webpack_require__(23);
	var dPs = __webpack_require__(309);
	var enumBugKeys = __webpack_require__(209);
	var IE_PROTO = __webpack_require__(221)('IE_PROTO');
	var Empty = function () { /* empty */ };
	var PROTOTYPE = 'prototype';
	
	// Create object with fake `null` prototype: use iframe Object with cleared prototype
	var createDict = function () {
	  // Thrash, waste and sodomy: IE GC bug
	  var iframe = __webpack_require__(208)('iframe');
	  var i = enumBugKeys.length;
	  var lt = '<';
	  var gt = '>';
	  var iframeDocument;
	  iframe.style.display = 'none';
	  __webpack_require__(211).appendChild(iframe);
	  iframe.src = 'javascript:'; // eslint-disable-line no-script-url
	  // createDict = iframe.contentWindow.Object;
	  // html.removeChild(iframe);
	  iframeDocument = iframe.contentWindow.document;
	  iframeDocument.open();
	  iframeDocument.write(lt + 'script' + gt + 'document.F=Object' + lt + '/script' + gt);
	  iframeDocument.close();
	  createDict = iframeDocument.F;
	  while (i--) delete createDict[PROTOTYPE][enumBugKeys[i]];
	  return createDict();
	};
	
	module.exports = Object.create || function create(O, Properties) {
	  var result;
	  if (O !== null) {
	    Empty[PROTOTYPE] = anObject(O);
	    result = new Empty();
	    Empty[PROTOTYPE] = null;
	    // add "__proto__" for Object.getPrototypeOf polyfill
	    result[IE_PROTO] = O;
	  } else result = createDict();
	  return Properties === undefined ? result : dPs(result, Properties);
	};


/***/ },
/* 105 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.2.7 / 15.2.3.4 Object.getOwnPropertyNames(O)
	var $keys = __webpack_require__(311);
	var hiddenKeys = __webpack_require__(209).concat('length', 'prototype');
	
	exports.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
	  return $keys(O, hiddenKeys);
	};


/***/ },
/* 106 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.2.14 / 15.2.3.14 Object.keys(O)
	var $keys = __webpack_require__(311);
	var enumBugKeys = __webpack_require__(209);
	
	module.exports = Object.keys || function keys(O) {
	  return $keys(O, enumBugKeys);
	};


/***/ },
/* 107 */
/***/ function(module, exports) {

	module.exports = function (bitmap, value) {
	  return {
	    enumerable: !(bitmap & 1),
	    configurable: !(bitmap & 2),
	    writable: !(bitmap & 4),
	    value: value
	  };
	};


/***/ },
/* 108 */
/***/ function(module, exports, __webpack_require__) {

	var redefine = __webpack_require__(53);
	module.exports = function (target, src, safe) {
	  for (var key in src) redefine(target, key, src[key], safe);
	  return target;
	};


/***/ },
/* 109 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var global = __webpack_require__(24);
	var dP = __webpack_require__(39);
	var DESCRIPTORS = __webpack_require__(38);
	var SPECIES = __webpack_require__(34)('species');
	
	module.exports = function (KEY) {
	  var C = global[KEY];
	  if (DESCRIPTORS && C && !C[SPECIES]) dP.f(C, SPECIES, {
	    configurable: true,
	    get: function () { return this; }
	  });
	};


/***/ },
/* 110 */
/***/ function(module, exports, __webpack_require__) {

	var toInteger = __webpack_require__(78);
	var max = Math.max;
	var min = Math.min;
	module.exports = function (index, length) {
	  index = toInteger(index);
	  return index < 0 ? max(index + length, 0) : min(index, length);
	};


/***/ },
/* 111 */
/***/ function(module, exports) {

	var id = 0;
	var px = Math.random();
	module.exports = function (key) {
	  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
	};


/***/ },
/* 112 */
/***/ function(module, exports, __webpack_require__) {

	;(function (root, factory, undef) {
		if (true) {
			// CommonJS
			module.exports = exports = factory(__webpack_require__(25), __webpack_require__(232), __webpack_require__(231));
		}
		else if (typeof define === "function" && define.amd) {
			// AMD
			define(["./core", "./sha1", "./hmac"], factory);
		}
		else {
			// Global (browser)
			factory(root.CryptoJS);
		}
	}(this, function (CryptoJS) {
	
		(function () {
		    // Shortcuts
		    var C = CryptoJS;
		    var C_lib = C.lib;
		    var Base = C_lib.Base;
		    var WordArray = C_lib.WordArray;
		    var C_algo = C.algo;
		    var MD5 = C_algo.MD5;
	
		    /**
		     * This key derivation function is meant to conform with EVP_BytesToKey.
		     * www.openssl.org/docs/crypto/EVP_BytesToKey.html
		     */
		    var EvpKDF = C_algo.EvpKDF = Base.extend({
		        /**
		         * Configuration options.
		         *
		         * @property {number} keySize The key size in words to generate. Default: 4 (128 bits)
		         * @property {Hasher} hasher The hash algorithm to use. Default: MD5
		         * @property {number} iterations The number of iterations to perform. Default: 1
		         */
		        cfg: Base.extend({
		            keySize: 128/32,
		            hasher: MD5,
		            iterations: 1
		        }),
	
		        /**
		         * Initializes a newly created key derivation function.
		         *
		         * @param {Object} cfg (Optional) The configuration options to use for the derivation.
		         *
		         * @example
		         *
		         *     var kdf = CryptoJS.algo.EvpKDF.create();
		         *     var kdf = CryptoJS.algo.EvpKDF.create({ keySize: 8 });
		         *     var kdf = CryptoJS.algo.EvpKDF.create({ keySize: 8, iterations: 1000 });
		         */
		        init: function (cfg) {
		            this.cfg = this.cfg.extend(cfg);
		        },
	
		        /**
		         * Derives a key from a password.
		         *
		         * @param {WordArray|string} password The password.
		         * @param {WordArray|string} salt A salt.
		         *
		         * @return {WordArray} The derived key.
		         *
		         * @example
		         *
		         *     var key = kdf.compute(password, salt);
		         */
		        compute: function (password, salt) {
		            // Shortcut
		            var cfg = this.cfg;
	
		            // Init hasher
		            var hasher = cfg.hasher.create();
	
		            // Initial values
		            var derivedKey = WordArray.create();
	
		            // Shortcuts
		            var derivedKeyWords = derivedKey.words;
		            var keySize = cfg.keySize;
		            var iterations = cfg.iterations;
	
		            // Generate key
		            while (derivedKeyWords.length < keySize) {
		                if (block) {
		                    hasher.update(block);
		                }
		                var block = hasher.update(password).finalize(salt);
		                hasher.reset();
	
		                // Iterations
		                for (var i = 1; i < iterations; i++) {
		                    block = hasher.finalize(block);
		                    hasher.reset();
		                }
	
		                derivedKey.concat(block);
		            }
		            derivedKey.sigBytes = keySize * 4;
	
		            return derivedKey;
		        }
		    });
	
		    /**
		     * Derives a key from a password.
		     *
		     * @param {WordArray|string} password The password.
		     * @param {WordArray|string} salt A salt.
		     * @param {Object} cfg (Optional) The configuration options to use for this computation.
		     *
		     * @return {WordArray} The derived key.
		     *
		     * @static
		     *
		     * @example
		     *
		     *     var key = CryptoJS.EvpKDF(password, salt);
		     *     var key = CryptoJS.EvpKDF(password, salt, { keySize: 8 });
		     *     var key = CryptoJS.EvpKDF(password, salt, { keySize: 8, iterations: 1000 });
		     */
		    C.EvpKDF = function (password, salt, cfg) {
		        return EvpKDF.create(cfg).compute(password, salt);
		    };
		}());
	
	
		return CryptoJS.EvpKDF;
	
	}));

/***/ },
/* 113 */
[1138, 29],
/* 114 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ReactRef = __webpack_require__(999);
	var ReactInstrumentation = __webpack_require__(62);
	
	var warning = __webpack_require__(30);
	
	/**
	 * Helper to call ReactRef.attachRefs with this composite component, split out
	 * to avoid allocations in the transaction mount-ready queue.
	 */
	function attachRefs() {
	  ReactRef.attachRefs(this, this._currentElement);
	}
	
	var ReactReconciler = {
	  /**
	   * Initializes the component, renders markup, and registers event listeners.
	   *
	   * @param {ReactComponent} internalInstance
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @param {?object} the containing host component instance
	   * @param {?object} info about the host container
	   * @return {?string} Rendered markup to be inserted into the DOM.
	   * @final
	   * @internal
	   */
	  mountComponent: function (internalInstance, transaction, hostParent, hostContainerInfo, context, parentDebugID) // 0 in production and for roots
	  {
	    if (false) {
	      if (internalInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onBeforeMountComponent(internalInstance._debugID, internalInstance._currentElement, parentDebugID);
	      }
	    }
	    var markup = internalInstance.mountComponent(transaction, hostParent, hostContainerInfo, context, parentDebugID);
	    if (internalInstance._currentElement && internalInstance._currentElement.ref != null) {
	      transaction.getReactMountReady().enqueue(attachRefs, internalInstance);
	    }
	    if (false) {
	      if (internalInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onMountComponent(internalInstance._debugID);
	      }
	    }
	    return markup;
	  },
	
	  /**
	   * Returns a value that can be passed to
	   * ReactComponentEnvironment.replaceNodeWithMarkup.
	   */
	  getHostNode: function (internalInstance) {
	    return internalInstance.getHostNode();
	  },
	
	  /**
	   * Releases any resources allocated by `mountComponent`.
	   *
	   * @final
	   * @internal
	   */
	  unmountComponent: function (internalInstance, safely) {
	    if (false) {
	      if (internalInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onBeforeUnmountComponent(internalInstance._debugID);
	      }
	    }
	    ReactRef.detachRefs(internalInstance, internalInstance._currentElement);
	    internalInstance.unmountComponent(safely);
	    if (false) {
	      if (internalInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onUnmountComponent(internalInstance._debugID);
	      }
	    }
	  },
	
	  /**
	   * Update a component using a new element.
	   *
	   * @param {ReactComponent} internalInstance
	   * @param {ReactElement} nextElement
	   * @param {ReactReconcileTransaction} transaction
	   * @param {object} context
	   * @internal
	   */
	  receiveComponent: function (internalInstance, nextElement, transaction, context) {
	    var prevElement = internalInstance._currentElement;
	
	    if (nextElement === prevElement && context === internalInstance._context) {
	      // Since elements are immutable after the owner is rendered,
	      // we can do a cheap identity compare here to determine if this is a
	      // superfluous reconcile. It's possible for state to be mutable but such
	      // change should trigger an update of the owner which would recreate
	      // the element. We explicitly check for the existence of an owner since
	      // it's possible for an element created outside a composite to be
	      // deeply mutated and reused.
	
	      // TODO: Bailing out early is just a perf optimization right?
	      // TODO: Removing the return statement should affect correctness?
	      return;
	    }
	
	    if (false) {
	      if (internalInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onBeforeUpdateComponent(internalInstance._debugID, nextElement);
	      }
	    }
	
	    var refsChanged = ReactRef.shouldUpdateRefs(prevElement, nextElement);
	
	    if (refsChanged) {
	      ReactRef.detachRefs(internalInstance, prevElement);
	    }
	
	    internalInstance.receiveComponent(nextElement, transaction, context);
	
	    if (refsChanged && internalInstance._currentElement && internalInstance._currentElement.ref != null) {
	      transaction.getReactMountReady().enqueue(attachRefs, internalInstance);
	    }
	
	    if (false) {
	      if (internalInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onUpdateComponent(internalInstance._debugID);
	      }
	    }
	  },
	
	  /**
	   * Flush any dirty changes in a component.
	   *
	   * @param {ReactComponent} internalInstance
	   * @param {ReactReconcileTransaction} transaction
	   * @internal
	   */
	  performUpdateIfNecessary: function (internalInstance, transaction, updateBatchNumber) {
	    if (internalInstance._updateBatchNumber !== updateBatchNumber) {
	      // The component's enqueued batch number should always be the current
	      // batch or the following one.
	       false ? warning(internalInstance._updateBatchNumber == null || internalInstance._updateBatchNumber === updateBatchNumber + 1, 'performUpdateIfNecessary: Unexpected batch number (current %s, ' + 'pending %s)', updateBatchNumber, internalInstance._updateBatchNumber) : void 0;
	      return;
	    }
	    if (false) {
	      if (internalInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onBeforeUpdateComponent(internalInstance._debugID, internalInstance._currentElement);
	      }
	    }
	    internalInstance.performUpdateIfNecessary(transaction);
	    if (false) {
	      if (internalInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onUpdateComponent(internalInstance._debugID);
	      }
	    }
	  }
	};
	
	module.exports = ReactReconciler;

/***/ },
/* 115 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(36);
	
	var ReactBaseClasses = __webpack_require__(426);
	var ReactChildren = __webpack_require__(1064);
	var ReactDOMFactories = __webpack_require__(1065);
	var ReactElement = __webpack_require__(131);
	var ReactPropTypes = __webpack_require__(1066);
	var ReactVersion = __webpack_require__(1067);
	
	var createReactClass = __webpack_require__(1068);
	var onlyChild = __webpack_require__(1072);
	
	var createElement = ReactElement.createElement;
	var createFactory = ReactElement.createFactory;
	var cloneElement = ReactElement.cloneElement;
	
	if (false) {
	  var lowPriorityWarning = require('./lowPriorityWarning');
	  var canDefineProperty = require('./canDefineProperty');
	  var ReactElementValidator = require('./ReactElementValidator');
	  var didWarnPropTypesDeprecated = false;
	  createElement = ReactElementValidator.createElement;
	  createFactory = ReactElementValidator.createFactory;
	  cloneElement = ReactElementValidator.cloneElement;
	}
	
	var __spread = _assign;
	var createMixin = function (mixin) {
	  return mixin;
	};
	
	if (false) {
	  var warnedForSpread = false;
	  var warnedForCreateMixin = false;
	  __spread = function () {
	    lowPriorityWarning(warnedForSpread, 'React.__spread is deprecated and should not be used. Use ' + 'Object.assign directly or another helper function with similar ' + 'semantics. You may be seeing this warning due to your compiler. ' + 'See https://fb.me/react-spread-deprecation for more details.');
	    warnedForSpread = true;
	    return _assign.apply(null, arguments);
	  };
	
	  createMixin = function (mixin) {
	    lowPriorityWarning(warnedForCreateMixin, 'React.createMixin is deprecated and should not be used. ' + 'In React v16.0, it will be removed. ' + 'You can use this mixin directly instead. ' + 'See https://fb.me/createmixin-was-never-implemented for more info.');
	    warnedForCreateMixin = true;
	    return mixin;
	  };
	}
	
	var React = {
	  // Modern
	
	  Children: {
	    map: ReactChildren.map,
	    forEach: ReactChildren.forEach,
	    count: ReactChildren.count,
	    toArray: ReactChildren.toArray,
	    only: onlyChild
	  },
	
	  Component: ReactBaseClasses.Component,
	  PureComponent: ReactBaseClasses.PureComponent,
	
	  createElement: createElement,
	  cloneElement: cloneElement,
	  isValidElement: ReactElement.isValidElement,
	
	  // Classic
	
	  PropTypes: ReactPropTypes,
	  createClass: createReactClass,
	  createFactory: createFactory,
	  createMixin: createMixin,
	
	  // This looks DOM specific but these are actually isomorphic helpers
	  // since they are just generating DOM strings.
	  DOM: ReactDOMFactories,
	
	  version: ReactVersion,
	
	  // Deprecated hook for JSX spread, don't use this for anything.
	  __spread: __spread
	};
	
	if (false) {
	  var warnedForCreateClass = false;
	  if (canDefineProperty) {
	    Object.defineProperty(React, 'PropTypes', {
	      get: function () {
	        lowPriorityWarning(didWarnPropTypesDeprecated, 'Accessing PropTypes via the main React package is deprecated,' + ' and will be removed in  React v16.0.' + ' Use the latest available v15.* prop-types package from npm instead.' + ' For info on usage, compatibility, migration and more, see ' + 'https://fb.me/prop-types-docs');
	        didWarnPropTypesDeprecated = true;
	        return ReactPropTypes;
	      }
	    });
	
	    Object.defineProperty(React, 'createClass', {
	      get: function () {
	        lowPriorityWarning(warnedForCreateClass, 'Accessing createClass via the main React package is deprecated,' + ' and will be removed in React v16.0.' + " Use a plain JavaScript class instead. If you're not yet " + 'ready to migrate, create-react-class v15.* is available ' + 'on npm as a temporary, drop-in replacement. ' + 'For more info see https://fb.me/react-create-class');
	        warnedForCreateClass = true;
	        return createReactClass;
	      }
	    });
	  }
	
	  // React.DOM factories are deprecated. Wrap these methods so that
	  // invocations of the React.DOM namespace and alert users to switch
	  // to the `react-dom-factories` package.
	  React.DOM = {};
	  var warnedForFactories = false;
	  Object.keys(ReactDOMFactories).forEach(function (factory) {
	    React.DOM[factory] = function () {
	      if (!warnedForFactories) {
	        lowPriorityWarning(false, 'Accessing factories like React.DOM.%s has been deprecated ' + 'and will be removed in v16.0+. Use the ' + 'react-dom-factories package instead. ' + ' Version 1.0 provides a drop-in replacement.' + ' For more info, see https://fb.me/react-dom-factories', factory);
	        warnedForFactories = true;
	      }
	      return ReactDOMFactories[factory].apply(ReactDOMFactories, arguments);
	    };
	  });
	}
	
	module.exports = React;

/***/ },
/* 116 */
/***/ function(module, exports) {

	module.exports = {};


/***/ },
/* 117 */
/***/ function(module, exports, __webpack_require__) {

	var def = __webpack_require__(39).f;
	var has = __webpack_require__(58);
	var TAG = __webpack_require__(34)('toStringTag');
	
	module.exports = function (it, tag, stat) {
	  if (it && !has(it = stat ? it : it.prototype, TAG)) def(it, TAG, { configurable: true, value: tag });
	};


/***/ },
/* 118 */
/***/ function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(6);
	var defined = __webpack_require__(76);
	var fails = __webpack_require__(26);
	var spaces = __webpack_require__(225);
	var space = '[' + spaces + ']';
	var non = '\u200b\u0085';
	var ltrim = RegExp('^' + space + space + '*');
	var rtrim = RegExp(space + space + '*$');
	
	var exporter = function (KEY, exec, ALIAS) {
	  var exp = {};
	  var FORCE = fails(function () {
	    return !!spaces[KEY]() || non[KEY]() != non;
	  });
	  var fn = exp[KEY] = FORCE ? exec(trim) : spaces[KEY];
	  if (ALIAS) exp[ALIAS] = fn;
	  $export($export.P + $export.F * FORCE, 'String', exp);
	};
	
	// 1 -> String#trimLeft
	// 2 -> String#trimRight
	// 3 -> String#trim
	var trim = exporter.trim = function (string, TYPE) {
	  string = String(defined(string));
	  if (TYPE & 1) string = string.replace(ltrim, '');
	  if (TYPE & 2) string = string.replace(rtrim, '');
	  return string;
	};
	
	module.exports = exporter;


/***/ },
/* 119 */
/***/ function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(27);
	module.exports = function (it, TYPE) {
	  if (!isObject(it) || it._t !== TYPE) throw TypeError('Incompatible receiver, ' + TYPE + ' required!');
	  return it;
	};


/***/ },
/* 120 */
/***/ function(module, exports, __webpack_require__) {

	;(function (root, factory) {
		if (true) {
			// CommonJS
			module.exports = exports = factory(__webpack_require__(25));
		}
		else if (typeof define === "function" && define.amd) {
			// AMD
			define(["./core"], factory);
		}
		else {
			// Global (browser)
			factory(root.CryptoJS);
		}
	}(this, function (CryptoJS) {
	
		(function () {
		    // Shortcuts
		    var C = CryptoJS;
		    var C_lib = C.lib;
		    var WordArray = C_lib.WordArray;
		    var C_enc = C.enc;
	
		    /**
		     * Base64 encoding strategy.
		     */
		    var Base64 = C_enc.Base64 = {
		        /**
		         * Converts a word array to a Base64 string.
		         *
		         * @param {WordArray} wordArray The word array.
		         *
		         * @return {string} The Base64 string.
		         *
		         * @static
		         *
		         * @example
		         *
		         *     var base64String = CryptoJS.enc.Base64.stringify(wordArray);
		         */
		        stringify: function (wordArray) {
		            // Shortcuts
		            var words = wordArray.words;
		            var sigBytes = wordArray.sigBytes;
		            var map = this._map;
	
		            // Clamp excess bits
		            wordArray.clamp();
	
		            // Convert
		            var base64Chars = [];
		            for (var i = 0; i < sigBytes; i += 3) {
		                var byte1 = (words[i >>> 2]       >>> (24 - (i % 4) * 8))       & 0xff;
		                var byte2 = (words[(i + 1) >>> 2] >>> (24 - ((i + 1) % 4) * 8)) & 0xff;
		                var byte3 = (words[(i + 2) >>> 2] >>> (24 - ((i + 2) % 4) * 8)) & 0xff;
	
		                var triplet = (byte1 << 16) | (byte2 << 8) | byte3;
	
		                for (var j = 0; (j < 4) && (i + j * 0.75 < sigBytes); j++) {
		                    base64Chars.push(map.charAt((triplet >>> (6 * (3 - j))) & 0x3f));
		                }
		            }
	
		            // Add padding
		            var paddingChar = map.charAt(64);
		            if (paddingChar) {
		                while (base64Chars.length % 4) {
		                    base64Chars.push(paddingChar);
		                }
		            }
	
		            return base64Chars.join('');
		        },
	
		        /**
		         * Converts a Base64 string to a word array.
		         *
		         * @param {string} base64Str The Base64 string.
		         *
		         * @return {WordArray} The word array.
		         *
		         * @static
		         *
		         * @example
		         *
		         *     var wordArray = CryptoJS.enc.Base64.parse(base64String);
		         */
		        parse: function (base64Str) {
		            // Shortcuts
		            var base64StrLength = base64Str.length;
		            var map = this._map;
		            var reverseMap = this._reverseMap;
	
		            if (!reverseMap) {
		                    reverseMap = this._reverseMap = [];
		                    for (var j = 0; j < map.length; j++) {
		                        reverseMap[map.charCodeAt(j)] = j;
		                    }
		            }
	
		            // Ignore padding
		            var paddingChar = map.charAt(64);
		            if (paddingChar) {
		                var paddingIndex = base64Str.indexOf(paddingChar);
		                if (paddingIndex !== -1) {
		                    base64StrLength = paddingIndex;
		                }
		            }
	
		            // Convert
		            return parseLoop(base64Str, base64StrLength, reverseMap);
	
		        },
	
		        _map: 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/='
		    };
	
		    function parseLoop(base64Str, base64StrLength, reverseMap) {
		      var words = [];
		      var nBytes = 0;
		      for (var i = 0; i < base64StrLength; i++) {
		          if (i % 4) {
		              var bits1 = reverseMap[base64Str.charCodeAt(i - 1)] << ((i % 4) * 2);
		              var bits2 = reverseMap[base64Str.charCodeAt(i)] >>> (6 - (i % 4) * 2);
		              words[nBytes >>> 2] |= (bits1 | bits2) << (24 - (nBytes % 4) * 8);
		              nBytes++;
		          }
		      }
		      return WordArray.create(words, nBytes);
		    }
		}());
	
	
		return CryptoJS.enc.Base64;
	
	}));

/***/ },
/* 121 */
/***/ function(module, exports, __webpack_require__) {

	;(function (root, factory) {
		if (true) {
			// CommonJS
			module.exports = exports = factory(__webpack_require__(25));
		}
		else if (typeof define === "function" && define.amd) {
			// AMD
			define(["./core"], factory);
		}
		else {
			// Global (browser)
			factory(root.CryptoJS);
		}
	}(this, function (CryptoJS) {
	
		(function (Math) {
		    // Shortcuts
		    var C = CryptoJS;
		    var C_lib = C.lib;
		    var WordArray = C_lib.WordArray;
		    var Hasher = C_lib.Hasher;
		    var C_algo = C.algo;
	
		    // Constants table
		    var T = [];
	
		    // Compute constants
		    (function () {
		        for (var i = 0; i < 64; i++) {
		            T[i] = (Math.abs(Math.sin(i + 1)) * 0x100000000) | 0;
		        }
		    }());
	
		    /**
		     * MD5 hash algorithm.
		     */
		    var MD5 = C_algo.MD5 = Hasher.extend({
		        _doReset: function () {
		            this._hash = new WordArray.init([
		                0x67452301, 0xefcdab89,
		                0x98badcfe, 0x10325476
		            ]);
		        },
	
		        _doProcessBlock: function (M, offset) {
		            // Swap endian
		            for (var i = 0; i < 16; i++) {
		                // Shortcuts
		                var offset_i = offset + i;
		                var M_offset_i = M[offset_i];
	
		                M[offset_i] = (
		                    (((M_offset_i << 8)  | (M_offset_i >>> 24)) & 0x00ff00ff) |
		                    (((M_offset_i << 24) | (M_offset_i >>> 8))  & 0xff00ff00)
		                );
		            }
	
		            // Shortcuts
		            var H = this._hash.words;
	
		            var M_offset_0  = M[offset + 0];
		            var M_offset_1  = M[offset + 1];
		            var M_offset_2  = M[offset + 2];
		            var M_offset_3  = M[offset + 3];
		            var M_offset_4  = M[offset + 4];
		            var M_offset_5  = M[offset + 5];
		            var M_offset_6  = M[offset + 6];
		            var M_offset_7  = M[offset + 7];
		            var M_offset_8  = M[offset + 8];
		            var M_offset_9  = M[offset + 9];
		            var M_offset_10 = M[offset + 10];
		            var M_offset_11 = M[offset + 11];
		            var M_offset_12 = M[offset + 12];
		            var M_offset_13 = M[offset + 13];
		            var M_offset_14 = M[offset + 14];
		            var M_offset_15 = M[offset + 15];
	
		            // Working varialbes
		            var a = H[0];
		            var b = H[1];
		            var c = H[2];
		            var d = H[3];
	
		            // Computation
		            a = FF(a, b, c, d, M_offset_0,  7,  T[0]);
		            d = FF(d, a, b, c, M_offset_1,  12, T[1]);
		            c = FF(c, d, a, b, M_offset_2,  17, T[2]);
		            b = FF(b, c, d, a, M_offset_3,  22, T[3]);
		            a = FF(a, b, c, d, M_offset_4,  7,  T[4]);
		            d = FF(d, a, b, c, M_offset_5,  12, T[5]);
		            c = FF(c, d, a, b, M_offset_6,  17, T[6]);
		            b = FF(b, c, d, a, M_offset_7,  22, T[7]);
		            a = FF(a, b, c, d, M_offset_8,  7,  T[8]);
		            d = FF(d, a, b, c, M_offset_9,  12, T[9]);
		            c = FF(c, d, a, b, M_offset_10, 17, T[10]);
		            b = FF(b, c, d, a, M_offset_11, 22, T[11]);
		            a = FF(a, b, c, d, M_offset_12, 7,  T[12]);
		            d = FF(d, a, b, c, M_offset_13, 12, T[13]);
		            c = FF(c, d, a, b, M_offset_14, 17, T[14]);
		            b = FF(b, c, d, a, M_offset_15, 22, T[15]);
	
		            a = GG(a, b, c, d, M_offset_1,  5,  T[16]);
		            d = GG(d, a, b, c, M_offset_6,  9,  T[17]);
		            c = GG(c, d, a, b, M_offset_11, 14, T[18]);
		            b = GG(b, c, d, a, M_offset_0,  20, T[19]);
		            a = GG(a, b, c, d, M_offset_5,  5,  T[20]);
		            d = GG(d, a, b, c, M_offset_10, 9,  T[21]);
		            c = GG(c, d, a, b, M_offset_15, 14, T[22]);
		            b = GG(b, c, d, a, M_offset_4,  20, T[23]);
		            a = GG(a, b, c, d, M_offset_9,  5,  T[24]);
		            d = GG(d, a, b, c, M_offset_14, 9,  T[25]);
		            c = GG(c, d, a, b, M_offset_3,  14, T[26]);
		            b = GG(b, c, d, a, M_offset_8,  20, T[27]);
		            a = GG(a, b, c, d, M_offset_13, 5,  T[28]);
		            d = GG(d, a, b, c, M_offset_2,  9,  T[29]);
		            c = GG(c, d, a, b, M_offset_7,  14, T[30]);
		            b = GG(b, c, d, a, M_offset_12, 20, T[31]);
	
		            a = HH(a, b, c, d, M_offset_5,  4,  T[32]);
		            d = HH(d, a, b, c, M_offset_8,  11, T[33]);
		            c = HH(c, d, a, b, M_offset_11, 16, T[34]);
		            b = HH(b, c, d, a, M_offset_14, 23, T[35]);
		            a = HH(a, b, c, d, M_offset_1,  4,  T[36]);
		            d = HH(d, a, b, c, M_offset_4,  11, T[37]);
		            c = HH(c, d, a, b, M_offset_7,  16, T[38]);
		            b = HH(b, c, d, a, M_offset_10, 23, T[39]);
		            a = HH(a, b, c, d, M_offset_13, 4,  T[40]);
		            d = HH(d, a, b, c, M_offset_0,  11, T[41]);
		            c = HH(c, d, a, b, M_offset_3,  16, T[42]);
		            b = HH(b, c, d, a, M_offset_6,  23, T[43]);
		            a = HH(a, b, c, d, M_offset_9,  4,  T[44]);
		            d = HH(d, a, b, c, M_offset_12, 11, T[45]);
		            c = HH(c, d, a, b, M_offset_15, 16, T[46]);
		            b = HH(b, c, d, a, M_offset_2,  23, T[47]);
	
		            a = II(a, b, c, d, M_offset_0,  6,  T[48]);
		            d = II(d, a, b, c, M_offset_7,  10, T[49]);
		            c = II(c, d, a, b, M_offset_14, 15, T[50]);
		            b = II(b, c, d, a, M_offset_5,  21, T[51]);
		            a = II(a, b, c, d, M_offset_12, 6,  T[52]);
		            d = II(d, a, b, c, M_offset_3,  10, T[53]);
		            c = II(c, d, a, b, M_offset_10, 15, T[54]);
		            b = II(b, c, d, a, M_offset_1,  21, T[55]);
		            a = II(a, b, c, d, M_offset_8,  6,  T[56]);
		            d = II(d, a, b, c, M_offset_15, 10, T[57]);
		            c = II(c, d, a, b, M_offset_6,  15, T[58]);
		            b = II(b, c, d, a, M_offset_13, 21, T[59]);
		            a = II(a, b, c, d, M_offset_4,  6,  T[60]);
		            d = II(d, a, b, c, M_offset_11, 10, T[61]);
		            c = II(c, d, a, b, M_offset_2,  15, T[62]);
		            b = II(b, c, d, a, M_offset_9,  21, T[63]);
	
		            // Intermediate hash value
		            H[0] = (H[0] + a) | 0;
		            H[1] = (H[1] + b) | 0;
		            H[2] = (H[2] + c) | 0;
		            H[3] = (H[3] + d) | 0;
		        },
	
		        _doFinalize: function () {
		            // Shortcuts
		            var data = this._data;
		            var dataWords = data.words;
	
		            var nBitsTotal = this._nDataBytes * 8;
		            var nBitsLeft = data.sigBytes * 8;
	
		            // Add padding
		            dataWords[nBitsLeft >>> 5] |= 0x80 << (24 - nBitsLeft % 32);
	
		            var nBitsTotalH = Math.floor(nBitsTotal / 0x100000000);
		            var nBitsTotalL = nBitsTotal;
		            dataWords[(((nBitsLeft + 64) >>> 9) << 4) + 15] = (
		                (((nBitsTotalH << 8)  | (nBitsTotalH >>> 24)) & 0x00ff00ff) |
		                (((nBitsTotalH << 24) | (nBitsTotalH >>> 8))  & 0xff00ff00)
		            );
		            dataWords[(((nBitsLeft + 64) >>> 9) << 4) + 14] = (
		                (((nBitsTotalL << 8)  | (nBitsTotalL >>> 24)) & 0x00ff00ff) |
		                (((nBitsTotalL << 24) | (nBitsTotalL >>> 8))  & 0xff00ff00)
		            );
	
		            data.sigBytes = (dataWords.length + 1) * 4;
	
		            // Hash final blocks
		            this._process();
	
		            // Shortcuts
		            var hash = this._hash;
		            var H = hash.words;
	
		            // Swap endian
		            for (var i = 0; i < 4; i++) {
		                // Shortcut
		                var H_i = H[i];
	
		                H[i] = (((H_i << 8)  | (H_i >>> 24)) & 0x00ff00ff) |
		                       (((H_i << 24) | (H_i >>> 8))  & 0xff00ff00);
		            }
	
		            // Return final computed hash
		            return hash;
		        },
	
		        clone: function () {
		            var clone = Hasher.clone.call(this);
		            clone._hash = this._hash.clone();
	
		            return clone;
		        }
		    });
	
		    function FF(a, b, c, d, x, s, t) {
		        var n = a + ((b & c) | (~b & d)) + x + t;
		        return ((n << s) | (n >>> (32 - s))) + b;
		    }
	
		    function GG(a, b, c, d, x, s, t) {
		        var n = a + ((b & d) | (c & ~d)) + x + t;
		        return ((n << s) | (n >>> (32 - s))) + b;
		    }
	
		    function HH(a, b, c, d, x, s, t) {
		        var n = a + (b ^ c ^ d) + x + t;
		        return ((n << s) | (n >>> (32 - s))) + b;
		    }
	
		    function II(a, b, c, d, x, s, t) {
		        var n = a + (c ^ (b | ~d)) + x + t;
		        return ((n << s) | (n >>> (32 - s))) + b;
		    }
	
		    /**
		     * Shortcut function to the hasher's object interface.
		     *
		     * @param {WordArray|string} message The message to hash.
		     *
		     * @return {WordArray} The hash.
		     *
		     * @static
		     *
		     * @example
		     *
		     *     var hash = CryptoJS.MD5('message');
		     *     var hash = CryptoJS.MD5(wordArray);
		     */
		    C.MD5 = Hasher._createHelper(MD5);
	
		    /**
		     * Shortcut function to the HMAC's object interface.
		     *
		     * @param {WordArray|string} message The message to hash.
		     * @param {WordArray|string} key The secret key.
		     *
		     * @return {WordArray} The HMAC.
		     *
		     * @static
		     *
		     * @example
		     *
		     *     var hmac = CryptoJS.HmacMD5(message, key);
		     */
		    C.HmacMD5 = Hasher._createHmacHelper(MD5);
		}(Math));
	
	
		return CryptoJS.MD5;
	
	}));

/***/ },
/* 122 */
/***/ function(module, exports) {

	/*
		MIT License http://www.opensource.org/licenses/mit-license.php
		Author Tobias Koppers @sokra
	*/
	// css base code, injected by the css-loader
	module.exports = function(useSourceMap) {
		var list = [];
	
		// return the list of modules as css string
		list.toString = function toString() {
			return this.map(function (item) {
				var content = cssWithMappingToString(item, useSourceMap);
				if(item[2]) {
					return "@media " + item[2] + "{" + content + "}";
				} else {
					return content;
				}
			}).join("");
		};
	
		// import a list of modules into the list
		list.i = function(modules, mediaQuery) {
			if(typeof modules === "string")
				modules = [[null, modules, ""]];
			var alreadyImportedModules = {};
			for(var i = 0; i < this.length; i++) {
				var id = this[i][0];
				if(typeof id === "number")
					alreadyImportedModules[id] = true;
			}
			for(i = 0; i < modules.length; i++) {
				var item = modules[i];
				// skip already imported module
				// this implementation is not 100% perfect for weird media query combinations
				//  when a module is imported multiple times with different media queries.
				//  I hope this will never occur (Hey this way we have smaller bundles)
				if(typeof item[0] !== "number" || !alreadyImportedModules[item[0]]) {
					if(mediaQuery && !item[2]) {
						item[2] = mediaQuery;
					} else if(mediaQuery) {
						item[2] = "(" + item[2] + ") and (" + mediaQuery + ")";
					}
					list.push(item);
				}
			}
		};
		return list;
	};
	
	function cssWithMappingToString(item, useSourceMap) {
		var content = item[1] || '';
		var cssMapping = item[3];
		if (!cssMapping) {
			return content;
		}
	
		if (useSourceMap && typeof btoa === 'function') {
			var sourceMapping = toComment(cssMapping);
			var sourceURLs = cssMapping.sources.map(function (source) {
				return '/*# sourceURL=' + cssMapping.sourceRoot + source + ' */'
			});
	
			return [content].concat(sourceURLs).concat([sourceMapping]).join('\n');
		}
	
		return [content].join('\n');
	}
	
	// Adapted from convert-source-map (MIT)
	function toComment(sourceMap) {
		// eslint-disable-next-line no-undef
		var base64 = btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap))));
		var data = 'sourceMappingURL=data:application/json;charset=utf-8;base64,' + base64;
	
		return '/*# ' + data + ' */';
	}


/***/ },
/* 123 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.locationsAreEqual = exports.statesAreEqual = exports.createLocation = exports.createQuery = undefined;
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _invariant = __webpack_require__(46);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _warning = __webpack_require__(101);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _PathUtils = __webpack_require__(98);
	
	var _Actions = __webpack_require__(172);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var createQuery = exports.createQuery = function createQuery(props) {
	  return _extends(Object.create(null), props);
	};
	
	var createLocation = exports.createLocation = function createLocation() {
	  var input = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '/';
	  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _Actions.POP;
	  var key = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
	
	  var object = typeof input === 'string' ? (0, _PathUtils.parsePath)(input) : input;
	
	   false ? (0, _warning2.default)(!object.path, 'Location descriptor objects should have a `pathname`, not a `path`.') : void 0;
	
	  var pathname = object.pathname || '/';
	  var search = object.search || '';
	  var hash = object.hash || '';
	  var state = object.state;
	
	  return {
	    pathname: pathname,
	    search: search,
	    hash: hash,
	    state: state,
	    action: action,
	    key: key
	  };
	};
	
	var isDate = function isDate(object) {
	  return Object.prototype.toString.call(object) === '[object Date]';
	};
	
	var statesAreEqual = exports.statesAreEqual = function statesAreEqual(a, b) {
	  if (a === b) return true;
	
	  var typeofA = typeof a === 'undefined' ? 'undefined' : _typeof(a);
	  var typeofB = typeof b === 'undefined' ? 'undefined' : _typeof(b);
	
	  if (typeofA !== typeofB) return false;
	
	  !(typeofA !== 'function') ?  false ? (0, _invariant2.default)(false, 'You must not store functions in location state') : (0, _invariant2.default)(false) : void 0;
	
	  // Not the same object, but same type.
	  if (typeofA === 'object') {
	    !!(isDate(a) && isDate(b)) ?  false ? (0, _invariant2.default)(false, 'You must not store Date objects in location state') : (0, _invariant2.default)(false) : void 0;
	
	    if (!Array.isArray(a)) {
	      var keysofA = Object.keys(a);
	      var keysofB = Object.keys(b);
	      return keysofA.length === keysofB.length && keysofA.every(function (key) {
	        return statesAreEqual(a[key], b[key]);
	      });
	    }
	
	    return Array.isArray(b) && a.length === b.length && a.every(function (item, index) {
	      return statesAreEqual(item, b[index]);
	    });
	  }
	
	  // All other serializable types (string, number, boolean)
	  // should be strict equal.
	  return false;
	};
	
	var locationsAreEqual = exports.locationsAreEqual = function locationsAreEqual(a, b) {
	  return a.key === b.key &&
	  // a.action === b.action && // Different action !== location change.
	  a.pathname === b.pathname && a.search === b.search && a.hash === b.hash && statesAreEqual(a.state, b.state);
	};

/***/ },
/* 124 */
/***/ function(module, exports, __webpack_require__) {

	var Symbol = __webpack_require__(175),
	    getRawTag = __webpack_require__(890),
	    objectToString = __webpack_require__(918);
	
	/** `Object#toString` result references. */
	var nullTag = '[object Null]',
	    undefinedTag = '[object Undefined]';
	
	/** Built-in value references. */
	var symToStringTag = Symbol ? Symbol.toStringTag : undefined;
	
	/**
	 * The base implementation of `getTag` without fallbacks for buggy environments.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @returns {string} Returns the `toStringTag`.
	 */
	function baseGetTag(value) {
	  if (value == null) {
	    return value === undefined ? undefinedTag : nullTag;
	  }
	  return (symToStringTag && symToStringTag in Object(value))
	    ? getRawTag(value)
	    : objectToString(value);
	}
	
	module.exports = baseGetTag;


/***/ },
/* 125 */
/***/ function(module, exports, __webpack_require__) {

	var baseIsNative = __webpack_require__(869),
	    getValue = __webpack_require__(893);
	
	/**
	 * Gets the native function at `key` of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {string} key The key of the method to get.
	 * @returns {*} Returns the function if it's native, else `undefined`.
	 */
	function getNative(object, key) {
	  var value = getValue(object, key);
	  return baseIsNative(value) ? value : undefined;
	}
	
	module.exports = getNative;


/***/ },
/* 126 */
/***/ function(module, exports) {

	/**
	 * Checks if `value` is object-like. A value is object-like if it's not `null`
	 * and has a `typeof` result of "object".
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
	 * @example
	 *
	 * _.isObjectLike({});
	 * // => true
	 *
	 * _.isObjectLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isObjectLike(_.noop);
	 * // => false
	 *
	 * _.isObjectLike(null);
	 * // => false
	 */
	function isObjectLike(value) {
	  return value != null && typeof value == 'object';
	}
	
	module.exports = isObjectLike;


/***/ },
/* 127 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2015-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var DOMNamespaces = __webpack_require__(249);
	var setInnerHTML = __webpack_require__(188);
	
	var createMicrosoftUnsafeLocalFunction = __webpack_require__(257);
	var setTextContent = __webpack_require__(406);
	
	var ELEMENT_NODE_TYPE = 1;
	var DOCUMENT_FRAGMENT_NODE_TYPE = 11;
	
	/**
	 * In IE (8-11) and Edge, appending nodes with no children is dramatically
	 * faster than appending a full subtree, so we essentially queue up the
	 * .appendChild calls here and apply them so each node is added to its parent
	 * before any children are added.
	 *
	 * In other browsers, doing so is slower or neutral compared to the other order
	 * (in Firefox, twice as slow) so we only do this inversion in IE.
	 *
	 * See https://github.com/spicyj/innerhtml-vs-createelement-vs-clonenode.
	 */
	var enableLazy = typeof document !== 'undefined' && typeof document.documentMode === 'number' || typeof navigator !== 'undefined' && typeof navigator.userAgent === 'string' && /\bEdge\/\d/.test(navigator.userAgent);
	
	function insertTreeChildren(tree) {
	  if (!enableLazy) {
	    return;
	  }
	  var node = tree.node;
	  var children = tree.children;
	  if (children.length) {
	    for (var i = 0; i < children.length; i++) {
	      insertTreeBefore(node, children[i], null);
	    }
	  } else if (tree.html != null) {
	    setInnerHTML(node, tree.html);
	  } else if (tree.text != null) {
	    setTextContent(node, tree.text);
	  }
	}
	
	var insertTreeBefore = createMicrosoftUnsafeLocalFunction(function (parentNode, tree, referenceNode) {
	  // DocumentFragments aren't actually part of the DOM after insertion so
	  // appending children won't update the DOM. We need to ensure the fragment
	  // is properly populated first, breaking out of our lazy approach for just
	  // this level. Also, some <object> plugins (like Flash Player) will read
	  // <param> nodes immediately upon insertion into the DOM, so <object>
	  // must also be populated prior to insertion into the DOM.
	  if (tree.node.nodeType === DOCUMENT_FRAGMENT_NODE_TYPE || tree.node.nodeType === ELEMENT_NODE_TYPE && tree.node.nodeName.toLowerCase() === 'object' && (tree.node.namespaceURI == null || tree.node.namespaceURI === DOMNamespaces.html)) {
	    insertTreeChildren(tree);
	    parentNode.insertBefore(tree.node, referenceNode);
	  } else {
	    parentNode.insertBefore(tree.node, referenceNode);
	    insertTreeChildren(tree);
	  }
	});
	
	function replaceChildWithTree(oldNode, newTree) {
	  oldNode.parentNode.replaceChild(newTree.node, oldNode);
	  insertTreeChildren(newTree);
	}
	
	function queueChild(parentTree, childTree) {
	  if (enableLazy) {
	    parentTree.children.push(childTree);
	  } else {
	    parentTree.node.appendChild(childTree.node);
	  }
	}
	
	function queueHTML(tree, html) {
	  if (enableLazy) {
	    tree.html = html;
	  } else {
	    setInnerHTML(tree.node, html);
	  }
	}
	
	function queueText(tree, text) {
	  if (enableLazy) {
	    tree.text = text;
	  } else {
	    setTextContent(tree.node, text);
	  }
	}
	
	function toString() {
	  return this.node.nodeName;
	}
	
	function DOMLazyTree(node) {
	  return {
	    node: node,
	    children: [],
	    html: null,
	    text: null,
	    toString: toString
	  };
	}
	
	DOMLazyTree.insertTreeBefore = insertTreeBefore;
	DOMLazyTree.replaceChildWithTree = replaceChildWithTree;
	DOMLazyTree.queueChild = queueChild;
	DOMLazyTree.queueHTML = queueHTML;
	DOMLazyTree.queueText = queueText;
	
	module.exports = DOMLazyTree;

/***/ },
/* 128 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(29);
	
	var invariant = __webpack_require__(21);
	
	function checkMask(value, bitmask) {
	  return (value & bitmask) === bitmask;
	}
	
	var DOMPropertyInjection = {
	  /**
	   * Mapping from normalized, camelcased property names to a configuration that
	   * specifies how the associated DOM property should be accessed or rendered.
	   */
	  MUST_USE_PROPERTY: 0x1,
	  HAS_BOOLEAN_VALUE: 0x4,
	  HAS_NUMERIC_VALUE: 0x8,
	  HAS_POSITIVE_NUMERIC_VALUE: 0x10 | 0x8,
	  HAS_OVERLOADED_BOOLEAN_VALUE: 0x20,
	
	  /**
	   * Inject some specialized knowledge about the DOM. This takes a config object
	   * with the following properties:
	   *
	   * isCustomAttribute: function that given an attribute name will return true
	   * if it can be inserted into the DOM verbatim. Useful for data-* or aria-*
	   * attributes where it's impossible to enumerate all of the possible
	   * attribute names,
	   *
	   * Properties: object mapping DOM property name to one of the
	   * DOMPropertyInjection constants or null. If your attribute isn't in here,
	   * it won't get written to the DOM.
	   *
	   * DOMAttributeNames: object mapping React attribute name to the DOM
	   * attribute name. Attribute names not specified use the **lowercase**
	   * normalized name.
	   *
	   * DOMAttributeNamespaces: object mapping React attribute name to the DOM
	   * attribute namespace URL. (Attribute names not specified use no namespace.)
	   *
	   * DOMPropertyNames: similar to DOMAttributeNames but for DOM properties.
	   * Property names not specified use the normalized name.
	   *
	   * DOMMutationMethods: Properties that require special mutation methods. If
	   * `value` is undefined, the mutation method should unset the property.
	   *
	   * @param {object} domPropertyConfig the config as described above.
	   */
	  injectDOMPropertyConfig: function (domPropertyConfig) {
	    var Injection = DOMPropertyInjection;
	    var Properties = domPropertyConfig.Properties || {};
	    var DOMAttributeNamespaces = domPropertyConfig.DOMAttributeNamespaces || {};
	    var DOMAttributeNames = domPropertyConfig.DOMAttributeNames || {};
	    var DOMPropertyNames = domPropertyConfig.DOMPropertyNames || {};
	    var DOMMutationMethods = domPropertyConfig.DOMMutationMethods || {};
	
	    if (domPropertyConfig.isCustomAttribute) {
	      DOMProperty._isCustomAttributeFunctions.push(domPropertyConfig.isCustomAttribute);
	    }
	
	    for (var propName in Properties) {
	      !!DOMProperty.properties.hasOwnProperty(propName) ?  false ? invariant(false, 'injectDOMPropertyConfig(...): You\'re trying to inject DOM property \'%s\' which has already been injected. You may be accidentally injecting the same DOM property config twice, or you may be injecting two configs that have conflicting property names.', propName) : _prodInvariant('48', propName) : void 0;
	
	      var lowerCased = propName.toLowerCase();
	      var propConfig = Properties[propName];
	
	      var propertyInfo = {
	        attributeName: lowerCased,
	        attributeNamespace: null,
	        propertyName: propName,
	        mutationMethod: null,
	
	        mustUseProperty: checkMask(propConfig, Injection.MUST_USE_PROPERTY),
	        hasBooleanValue: checkMask(propConfig, Injection.HAS_BOOLEAN_VALUE),
	        hasNumericValue: checkMask(propConfig, Injection.HAS_NUMERIC_VALUE),
	        hasPositiveNumericValue: checkMask(propConfig, Injection.HAS_POSITIVE_NUMERIC_VALUE),
	        hasOverloadedBooleanValue: checkMask(propConfig, Injection.HAS_OVERLOADED_BOOLEAN_VALUE)
	      };
	      !(propertyInfo.hasBooleanValue + propertyInfo.hasNumericValue + propertyInfo.hasOverloadedBooleanValue <= 1) ?  false ? invariant(false, 'DOMProperty: Value can be one of boolean, overloaded boolean, or numeric value, but not a combination: %s', propName) : _prodInvariant('50', propName) : void 0;
	
	      if (false) {
	        DOMProperty.getPossibleStandardName[lowerCased] = propName;
	      }
	
	      if (DOMAttributeNames.hasOwnProperty(propName)) {
	        var attributeName = DOMAttributeNames[propName];
	        propertyInfo.attributeName = attributeName;
	        if (false) {
	          DOMProperty.getPossibleStandardName[attributeName] = propName;
	        }
	      }
	
	      if (DOMAttributeNamespaces.hasOwnProperty(propName)) {
	        propertyInfo.attributeNamespace = DOMAttributeNamespaces[propName];
	      }
	
	      if (DOMPropertyNames.hasOwnProperty(propName)) {
	        propertyInfo.propertyName = DOMPropertyNames[propName];
	      }
	
	      if (DOMMutationMethods.hasOwnProperty(propName)) {
	        propertyInfo.mutationMethod = DOMMutationMethods[propName];
	      }
	
	      DOMProperty.properties[propName] = propertyInfo;
	    }
	  }
	};
	
	/* eslint-disable max-len */
	var ATTRIBUTE_NAME_START_CHAR = ':A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD';
	/* eslint-enable max-len */
	
	/**
	 * DOMProperty exports lookup objects that can be used like functions:
	 *
	 *   > DOMProperty.isValid['id']
	 *   true
	 *   > DOMProperty.isValid['foobar']
	 *   undefined
	 *
	 * Although this may be confusing, it performs better in general.
	 *
	 * @see http://jsperf.com/key-exists
	 * @see http://jsperf.com/key-missing
	 */
	var DOMProperty = {
	  ID_ATTRIBUTE_NAME: 'data-reactid',
	  ROOT_ATTRIBUTE_NAME: 'data-reactroot',
	
	  ATTRIBUTE_NAME_START_CHAR: ATTRIBUTE_NAME_START_CHAR,
	  ATTRIBUTE_NAME_CHAR: ATTRIBUTE_NAME_START_CHAR + '\\-.0-9\\u00B7\\u0300-\\u036F\\u203F-\\u2040',
	
	  /**
	   * Map from property "standard name" to an object with info about how to set
	   * the property in the DOM. Each object contains:
	   *
	   * attributeName:
	   *   Used when rendering markup or with `*Attribute()`.
	   * attributeNamespace
	   * propertyName:
	   *   Used on DOM node instances. (This includes properties that mutate due to
	   *   external factors.)
	   * mutationMethod:
	   *   If non-null, used instead of the property or `setAttribute()` after
	   *   initial render.
	   * mustUseProperty:
	   *   Whether the property must be accessed and mutated as an object property.
	   * hasBooleanValue:
	   *   Whether the property should be removed when set to a falsey value.
	   * hasNumericValue:
	   *   Whether the property must be numeric or parse as a numeric and should be
	   *   removed when set to a falsey value.
	   * hasPositiveNumericValue:
	   *   Whether the property must be positive numeric or parse as a positive
	   *   numeric and should be removed when set to a falsey value.
	   * hasOverloadedBooleanValue:
	   *   Whether the property can be used as a flag as well as with a value.
	   *   Removed when strictly equal to false; present without a value when
	   *   strictly equal to true; present with a value otherwise.
	   */
	  properties: {},
	
	  /**
	   * Mapping from lowercase property names to the properly cased version, used
	   * to warn in the case of missing properties. Available only in __DEV__.
	   *
	   * autofocus is predefined, because adding it to the property whitelist
	   * causes unintended side effects.
	   *
	   * @type {Object}
	   */
	  getPossibleStandardName:  false ? { autofocus: 'autoFocus' } : null,
	
	  /**
	   * All of the isCustomAttribute() functions that have been injected.
	   */
	  _isCustomAttributeFunctions: [],
	
	  /**
	   * Checks whether a property name is a custom attribute.
	   * @method
	   */
	  isCustomAttribute: function (attributeName) {
	    for (var i = 0; i < DOMProperty._isCustomAttributeFunctions.length; i++) {
	      var isCustomAttributeFn = DOMProperty._isCustomAttributeFunctions[i];
	      if (isCustomAttributeFn(attributeName)) {
	        return true;
	      }
	    }
	    return false;
	  },
	
	  injection: DOMPropertyInjection
	};
	
	module.exports = DOMProperty;

/***/ },
/* 129 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.compilePattern = compilePattern;
	exports.matchPattern = matchPattern;
	exports.getParamNames = getParamNames;
	exports.getParams = getParams;
	exports.formatPattern = formatPattern;
	
	var _invariant = __webpack_require__(46);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function escapeRegExp(string) {
	  return string.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
	}
	
	function _compilePattern(pattern) {
	  var regexpSource = '';
	  var paramNames = [];
	  var tokens = [];
	
	  var match = void 0,
	      lastIndex = 0,
	      matcher = /:([a-zA-Z_$][a-zA-Z0-9_$]*)|\*\*|\*|\(|\)|\\\(|\\\)/g;
	  while (match = matcher.exec(pattern)) {
	    if (match.index !== lastIndex) {
	      tokens.push(pattern.slice(lastIndex, match.index));
	      regexpSource += escapeRegExp(pattern.slice(lastIndex, match.index));
	    }
	
	    if (match[1]) {
	      regexpSource += '([^/]+)';
	      paramNames.push(match[1]);
	    } else if (match[0] === '**') {
	      regexpSource += '(.*)';
	      paramNames.push('splat');
	    } else if (match[0] === '*') {
	      regexpSource += '(.*?)';
	      paramNames.push('splat');
	    } else if (match[0] === '(') {
	      regexpSource += '(?:';
	    } else if (match[0] === ')') {
	      regexpSource += ')?';
	    } else if (match[0] === '\\(') {
	      regexpSource += '\\(';
	    } else if (match[0] === '\\)') {
	      regexpSource += '\\)';
	    }
	
	    tokens.push(match[0]);
	
	    lastIndex = matcher.lastIndex;
	  }
	
	  if (lastIndex !== pattern.length) {
	    tokens.push(pattern.slice(lastIndex, pattern.length));
	    regexpSource += escapeRegExp(pattern.slice(lastIndex, pattern.length));
	  }
	
	  return {
	    pattern: pattern,
	    regexpSource: regexpSource,
	    paramNames: paramNames,
	    tokens: tokens
	  };
	}
	
	var CompiledPatternsCache = Object.create(null);
	
	function compilePattern(pattern) {
	  if (!CompiledPatternsCache[pattern]) CompiledPatternsCache[pattern] = _compilePattern(pattern);
	
	  return CompiledPatternsCache[pattern];
	}
	
	/**
	 * Attempts to match a pattern on the given pathname. Patterns may use
	 * the following special characters:
	 *
	 * - :paramName     Matches a URL segment up to the next /, ?, or #. The
	 *                  captured string is considered a "param"
	 * - ()             Wraps a segment of the URL that is optional
	 * - *              Consumes (non-greedy) all characters up to the next
	 *                  character in the pattern, or to the end of the URL if
	 *                  there is none
	 * - **             Consumes (greedy) all characters up to the next character
	 *                  in the pattern, or to the end of the URL if there is none
	 *
	 *  The function calls callback(error, matched) when finished.
	 * The return value is an object with the following properties:
	 *
	 * - remainingPathname
	 * - paramNames
	 * - paramValues
	 */
	function matchPattern(pattern, pathname) {
	  // Ensure pattern starts with leading slash for consistency with pathname.
	  if (pattern.charAt(0) !== '/') {
	    pattern = '/' + pattern;
	  }
	
	  var _compilePattern2 = compilePattern(pattern),
	      regexpSource = _compilePattern2.regexpSource,
	      paramNames = _compilePattern2.paramNames,
	      tokens = _compilePattern2.tokens;
	
	  if (pattern.charAt(pattern.length - 1) !== '/') {
	    regexpSource += '/?'; // Allow optional path separator at end.
	  }
	
	  // Special-case patterns like '*' for catch-all routes.
	  if (tokens[tokens.length - 1] === '*') {
	    regexpSource += '$';
	  }
	
	  var match = pathname.match(new RegExp('^' + regexpSource, 'i'));
	  if (match == null) {
	    return null;
	  }
	
	  var matchedPath = match[0];
	  var remainingPathname = pathname.substr(matchedPath.length);
	
	  if (remainingPathname) {
	    // Require that the match ends at a path separator, if we didn't match
	    // the full path, so any remaining pathname is a new path segment.
	    if (matchedPath.charAt(matchedPath.length - 1) !== '/') {
	      return null;
	    }
	
	    // If there is a remaining pathname, treat the path separator as part of
	    // the remaining pathname for properly continuing the match.
	    remainingPathname = '/' + remainingPathname;
	  }
	
	  return {
	    remainingPathname: remainingPathname,
	    paramNames: paramNames,
	    paramValues: match.slice(1).map(function (v) {
	      return v && decodeURIComponent(v);
	    })
	  };
	}
	
	function getParamNames(pattern) {
	  return compilePattern(pattern).paramNames;
	}
	
	function getParams(pattern, pathname) {
	  var match = matchPattern(pattern, pathname);
	  if (!match) {
	    return null;
	  }
	
	  var paramNames = match.paramNames,
	      paramValues = match.paramValues;
	
	  var params = {};
	
	  paramNames.forEach(function (paramName, index) {
	    params[paramName] = paramValues[index];
	  });
	
	  return params;
	}
	
	/**
	 * Returns a version of the given pattern with params interpolated. Throws
	 * if there is a dynamic segment of the pattern for which there is no param.
	 */
	function formatPattern(pattern, params) {
	  params = params || {};
	
	  var _compilePattern3 = compilePattern(pattern),
	      tokens = _compilePattern3.tokens;
	
	  var parenCount = 0,
	      pathname = '',
	      splatIndex = 0,
	      parenHistory = [];
	
	  var token = void 0,
	      paramName = void 0,
	      paramValue = void 0;
	  for (var i = 0, len = tokens.length; i < len; ++i) {
	    token = tokens[i];
	
	    if (token === '*' || token === '**') {
	      paramValue = Array.isArray(params.splat) ? params.splat[splatIndex++] : params.splat;
	
	      !(paramValue != null || parenCount > 0) ?  false ? (0, _invariant2.default)(false, 'Missing splat #%s for path "%s"', splatIndex, pattern) : (0, _invariant2.default)(false) : void 0;
	
	      if (paramValue != null) pathname += encodeURI(paramValue);
	    } else if (token === '(') {
	      parenHistory[parenCount] = '';
	      parenCount += 1;
	    } else if (token === ')') {
	      var parenText = parenHistory.pop();
	      parenCount -= 1;
	
	      if (parenCount) parenHistory[parenCount - 1] += parenText;else pathname += parenText;
	    } else if (token === '\\(') {
	      pathname += '(';
	    } else if (token === '\\)') {
	      pathname += ')';
	    } else if (token.charAt(0) === ':') {
	      paramName = token.substring(1);
	      paramValue = params[paramName];
	
	      !(paramValue != null || parenCount > 0) ?  false ? (0, _invariant2.default)(false, 'Missing "%s" parameter for path "%s"', paramName, pattern) : (0, _invariant2.default)(false) : void 0;
	
	      if (paramValue == null) {
	        if (parenCount) {
	          parenHistory[parenCount - 1] = '';
	
	          var curTokenIdx = tokens.indexOf(token);
	          var tokensSubset = tokens.slice(curTokenIdx, tokens.length);
	          var nextParenIdx = -1;
	
	          for (var _i = 0; _i < tokensSubset.length; _i++) {
	            if (tokensSubset[_i] == ')') {
	              nextParenIdx = _i;
	              break;
	            }
	          }
	
	          !(nextParenIdx > 0) ?  false ? (0, _invariant2.default)(false, 'Path "%s" is missing end paren at segment "%s"', pattern, tokensSubset.join('')) : (0, _invariant2.default)(false) : void 0;
	
	          // jump to ending paren
	          i = curTokenIdx + nextParenIdx - 1;
	        }
	      } else if (parenCount) parenHistory[parenCount - 1] += encodeURIComponent(paramValue);else pathname += encodeURIComponent(paramValue);
	    } else {
	      if (parenCount) parenHistory[parenCount - 1] += token;else pathname += token;
	    }
	  }
	
	  !(parenCount <= 0) ?  false ? (0, _invariant2.default)(false, 'Path "%s" is missing end paren', pattern) : (0, _invariant2.default)(false) : void 0;
	
	  return pathname.replace(/\/+/g, '/');
	}

/***/ },
/* 130 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = routerWarning;
	exports._resetWarned = _resetWarned;
	
	var _warning = __webpack_require__(101);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var warned = {};
	
	function routerWarning(falseToWarn, message) {
	  // Only issue deprecation warnings once.
	  if (message.indexOf('deprecated') !== -1) {
	    if (warned[message]) {
	      return;
	    }
	
	    warned[message] = true;
	  }
	
	  message = '[react-router] ' + message;
	
	  for (var _len = arguments.length, args = Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
	    args[_key - 2] = arguments[_key];
	  }
	
	  _warning2.default.apply(undefined, [falseToWarn, message].concat(args));
	}
	
	function _resetWarned() {
	  warned = {};
	}

/***/ },
/* 131 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2014-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(36);
	
	var ReactCurrentOwner = __webpack_require__(92);
	
	var warning = __webpack_require__(30);
	var canDefineProperty = __webpack_require__(430);
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	
	var REACT_ELEMENT_TYPE = __webpack_require__(428);
	
	var RESERVED_PROPS = {
	  key: true,
	  ref: true,
	  __self: true,
	  __source: true
	};
	
	var specialPropKeyWarningShown, specialPropRefWarningShown;
	
	function hasValidRef(config) {
	  if (false) {
	    if (hasOwnProperty.call(config, 'ref')) {
	      var getter = Object.getOwnPropertyDescriptor(config, 'ref').get;
	      if (getter && getter.isReactWarning) {
	        return false;
	      }
	    }
	  }
	  return config.ref !== undefined;
	}
	
	function hasValidKey(config) {
	  if (false) {
	    if (hasOwnProperty.call(config, 'key')) {
	      var getter = Object.getOwnPropertyDescriptor(config, 'key').get;
	      if (getter && getter.isReactWarning) {
	        return false;
	      }
	    }
	  }
	  return config.key !== undefined;
	}
	
	function defineKeyPropWarningGetter(props, displayName) {
	  var warnAboutAccessingKey = function () {
	    if (!specialPropKeyWarningShown) {
	      specialPropKeyWarningShown = true;
	       false ? warning(false, '%s: `key` is not a prop. Trying to access it will result ' + 'in `undefined` being returned. If you need to access the same ' + 'value within the child component, you should pass it as a different ' + 'prop. (https://fb.me/react-special-props)', displayName) : void 0;
	    }
	  };
	  warnAboutAccessingKey.isReactWarning = true;
	  Object.defineProperty(props, 'key', {
	    get: warnAboutAccessingKey,
	    configurable: true
	  });
	}
	
	function defineRefPropWarningGetter(props, displayName) {
	  var warnAboutAccessingRef = function () {
	    if (!specialPropRefWarningShown) {
	      specialPropRefWarningShown = true;
	       false ? warning(false, '%s: `ref` is not a prop. Trying to access it will result ' + 'in `undefined` being returned. If you need to access the same ' + 'value within the child component, you should pass it as a different ' + 'prop. (https://fb.me/react-special-props)', displayName) : void 0;
	    }
	  };
	  warnAboutAccessingRef.isReactWarning = true;
	  Object.defineProperty(props, 'ref', {
	    get: warnAboutAccessingRef,
	    configurable: true
	  });
	}
	
	/**
	 * Factory method to create a new React element. This no longer adheres to
	 * the class pattern, so do not use new to call it. Also, no instanceof check
	 * will work. Instead test $$typeof field against Symbol.for('react.element') to check
	 * if something is a React Element.
	 *
	 * @param {*} type
	 * @param {*} key
	 * @param {string|object} ref
	 * @param {*} self A *temporary* helper to detect places where `this` is
	 * different from the `owner` when React.createElement is called, so that we
	 * can warn. We want to get rid of owner and replace string `ref`s with arrow
	 * functions, and as long as `this` and owner are the same, there will be no
	 * change in behavior.
	 * @param {*} source An annotation object (added by a transpiler or otherwise)
	 * indicating filename, line number, and/or other information.
	 * @param {*} owner
	 * @param {*} props
	 * @internal
	 */
	var ReactElement = function (type, key, ref, self, source, owner, props) {
	  var element = {
	    // This tag allow us to uniquely identify this as a React Element
	    $$typeof: REACT_ELEMENT_TYPE,
	
	    // Built-in properties that belong on the element
	    type: type,
	    key: key,
	    ref: ref,
	    props: props,
	
	    // Record the component responsible for creating this element.
	    _owner: owner
	  };
	
	  if (false) {
	    // The validation flag is currently mutative. We put it on
	    // an external backing store so that we can freeze the whole object.
	    // This can be replaced with a WeakMap once they are implemented in
	    // commonly used development environments.
	    element._store = {};
	
	    // To make comparing ReactElements easier for testing purposes, we make
	    // the validation flag non-enumerable (where possible, which should
	    // include every environment we run tests in), so the test framework
	    // ignores it.
	    if (canDefineProperty) {
	      Object.defineProperty(element._store, 'validated', {
	        configurable: false,
	        enumerable: false,
	        writable: true,
	        value: false
	      });
	      // self and source are DEV only properties.
	      Object.defineProperty(element, '_self', {
	        configurable: false,
	        enumerable: false,
	        writable: false,
	        value: self
	      });
	      // Two elements created in two different places should be considered
	      // equal for testing purposes and therefore we hide it from enumeration.
	      Object.defineProperty(element, '_source', {
	        configurable: false,
	        enumerable: false,
	        writable: false,
	        value: source
	      });
	    } else {
	      element._store.validated = false;
	      element._self = self;
	      element._source = source;
	    }
	    if (Object.freeze) {
	      Object.freeze(element.props);
	      Object.freeze(element);
	    }
	  }
	
	  return element;
	};
	
	/**
	 * Create and return a new ReactElement of the given type.
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.createelement
	 */
	ReactElement.createElement = function (type, config, children) {
	  var propName;
	
	  // Reserved names are extracted
	  var props = {};
	
	  var key = null;
	  var ref = null;
	  var self = null;
	  var source = null;
	
	  if (config != null) {
	    if (hasValidRef(config)) {
	      ref = config.ref;
	    }
	    if (hasValidKey(config)) {
	      key = '' + config.key;
	    }
	
	    self = config.__self === undefined ? null : config.__self;
	    source = config.__source === undefined ? null : config.__source;
	    // Remaining properties are added to a new props object
	    for (propName in config) {
	      if (hasOwnProperty.call(config, propName) && !RESERVED_PROPS.hasOwnProperty(propName)) {
	        props[propName] = config[propName];
	      }
	    }
	  }
	
	  // Children can be more than one argument, and those are transferred onto
	  // the newly allocated props object.
	  var childrenLength = arguments.length - 2;
	  if (childrenLength === 1) {
	    props.children = children;
	  } else if (childrenLength > 1) {
	    var childArray = Array(childrenLength);
	    for (var i = 0; i < childrenLength; i++) {
	      childArray[i] = arguments[i + 2];
	    }
	    if (false) {
	      if (Object.freeze) {
	        Object.freeze(childArray);
	      }
	    }
	    props.children = childArray;
	  }
	
	  // Resolve default props
	  if (type && type.defaultProps) {
	    var defaultProps = type.defaultProps;
	    for (propName in defaultProps) {
	      if (props[propName] === undefined) {
	        props[propName] = defaultProps[propName];
	      }
	    }
	  }
	  if (false) {
	    if (key || ref) {
	      if (typeof props.$$typeof === 'undefined' || props.$$typeof !== REACT_ELEMENT_TYPE) {
	        var displayName = typeof type === 'function' ? type.displayName || type.name || 'Unknown' : type;
	        if (key) {
	          defineKeyPropWarningGetter(props, displayName);
	        }
	        if (ref) {
	          defineRefPropWarningGetter(props, displayName);
	        }
	      }
	    }
	  }
	  return ReactElement(type, key, ref, self, source, ReactCurrentOwner.current, props);
	};
	
	/**
	 * Return a function that produces ReactElements of a given type.
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.createfactory
	 */
	ReactElement.createFactory = function (type) {
	  var factory = ReactElement.createElement.bind(null, type);
	  // Expose the type on the factory and the prototype so that it can be
	  // easily accessed on elements. E.g. `<Foo />.type === Foo`.
	  // This should not be named `constructor` since this may not be the function
	  // that created the element, and it may not even be a constructor.
	  // Legacy hook TODO: Warn if this is accessed
	  factory.type = type;
	  return factory;
	};
	
	ReactElement.cloneAndReplaceKey = function (oldElement, newKey) {
	  var newElement = ReactElement(oldElement.type, newKey, oldElement.ref, oldElement._self, oldElement._source, oldElement._owner, oldElement.props);
	
	  return newElement;
	};
	
	/**
	 * Clone and return a new ReactElement using element as the starting point.
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.cloneelement
	 */
	ReactElement.cloneElement = function (element, config, children) {
	  var propName;
	
	  // Original props are copied
	  var props = _assign({}, element.props);
	
	  // Reserved names are extracted
	  var key = element.key;
	  var ref = element.ref;
	  // Self is preserved since the owner is preserved.
	  var self = element._self;
	  // Source is preserved since cloneElement is unlikely to be targeted by a
	  // transpiler, and the original source is probably a better indicator of the
	  // true owner.
	  var source = element._source;
	
	  // Owner will be preserved, unless ref is overridden
	  var owner = element._owner;
	
	  if (config != null) {
	    if (hasValidRef(config)) {
	      // Silently steal the ref from the parent.
	      ref = config.ref;
	      owner = ReactCurrentOwner.current;
	    }
	    if (hasValidKey(config)) {
	      key = '' + config.key;
	    }
	
	    // Remaining properties override existing props
	    var defaultProps;
	    if (element.type && element.type.defaultProps) {
	      defaultProps = element.type.defaultProps;
	    }
	    for (propName in config) {
	      if (hasOwnProperty.call(config, propName) && !RESERVED_PROPS.hasOwnProperty(propName)) {
	        if (config[propName] === undefined && defaultProps !== undefined) {
	          // Resolve default props
	          props[propName] = defaultProps[propName];
	        } else {
	          props[propName] = config[propName];
	        }
	      }
	    }
	  }
	
	  // Children can be more than one argument, and those are transferred onto
	  // the newly allocated props object.
	  var childrenLength = arguments.length - 2;
	  if (childrenLength === 1) {
	    props.children = children;
	  } else if (childrenLength > 1) {
	    var childArray = Array(childrenLength);
	    for (var i = 0; i < childrenLength; i++) {
	      childArray[i] = arguments[i + 2];
	    }
	    props.children = childArray;
	  }
	
	  return ReactElement(element.type, key, ref, self, source, owner, props);
	};
	
	/**
	 * Verifies the object is a ReactElement.
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.isvalidelement
	 * @param {?object} object
	 * @return {boolean} True if `object` is a valid component.
	 * @final
	 */
	ReactElement.isValidElement = function (object) {
	  return typeof object === 'object' && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
	};
	
	module.exports = ReactElement;

/***/ },
/* 132 */
/***/ function(module, exports, __webpack_require__) {

	/*
		MIT License http://www.opensource.org/licenses/mit-license.php
		Author Tobias Koppers @sokra
	*/
	
	var stylesInDom = {};
	
	var	memoize = function (fn) {
		var memo;
	
		return function () {
			if (typeof memo === "undefined") memo = fn.apply(this, arguments);
			return memo;
		};
	};
	
	var isOldIE = memoize(function () {
		// Test for IE <= 9 as proposed by Browserhacks
		// @see http://browserhacks.com/#hack-e71d8692f65334173fee715c222cb805
		// Tests for existence of standard globals is to allow style-loader
		// to operate correctly into non-standard environments
		// @see https://github.com/webpack-contrib/style-loader/issues/177
		return window && document && document.all && !window.atob;
	});
	
	var getElement = (function (fn) {
		var memo = {};
	
		return function(selector) {
			if (typeof memo[selector] === "undefined") {
				memo[selector] = fn.call(this, selector);
			}
	
			return memo[selector]
		};
	})(function (target) {
		return document.querySelector(target)
	});
	
	var singleton = null;
	var	singletonCounter = 0;
	var	stylesInsertedAtTop = [];
	
	var	fixUrls = __webpack_require__(1090);
	
	module.exports = function(list, options) {
		if (true) {
			if (typeof document !== "object") throw new Error("The style-loader cannot be used in a non-browser environment");
		}
	
		options = options || {};
	
		options.attrs = typeof options.attrs === "object" ? options.attrs : {};
	
		// Force single-tag solution on IE6-9, which has a hard limit on the # of <style>
		// tags it will allow on a page
		if (!options.singleton) options.singleton = isOldIE();
	
		// By default, add <style> tags to the <head> element
		if (!options.insertInto) options.insertInto = "head";
	
		// By default, add <style> tags to the bottom of the target
		if (!options.insertAt) options.insertAt = "bottom";
	
		var styles = listToStyles(list, options);
	
		addStylesToDom(styles, options);
	
		return function update (newList) {
			var mayRemove = [];
	
			for (var i = 0; i < styles.length; i++) {
				var item = styles[i];
				var domStyle = stylesInDom[item.id];
	
				domStyle.refs--;
				mayRemove.push(domStyle);
			}
	
			if(newList) {
				var newStyles = listToStyles(newList, options);
				addStylesToDom(newStyles, options);
			}
	
			for (var i = 0; i < mayRemove.length; i++) {
				var domStyle = mayRemove[i];
	
				if(domStyle.refs === 0) {
					for (var j = 0; j < domStyle.parts.length; j++) domStyle.parts[j]();
	
					delete stylesInDom[domStyle.id];
				}
			}
		};
	};
	
	function addStylesToDom (styles, options) {
		for (var i = 0; i < styles.length; i++) {
			var item = styles[i];
			var domStyle = stylesInDom[item.id];
	
			if(domStyle) {
				domStyle.refs++;
	
				for(var j = 0; j < domStyle.parts.length; j++) {
					domStyle.parts[j](item.parts[j]);
				}
	
				for(; j < item.parts.length; j++) {
					domStyle.parts.push(addStyle(item.parts[j], options));
				}
			} else {
				var parts = [];
	
				for(var j = 0; j < item.parts.length; j++) {
					parts.push(addStyle(item.parts[j], options));
				}
	
				stylesInDom[item.id] = {id: item.id, refs: 1, parts: parts};
			}
		}
	}
	
	function listToStyles (list, options) {
		var styles = [];
		var newStyles = {};
	
		for (var i = 0; i < list.length; i++) {
			var item = list[i];
			var id = options.base ? item[0] + options.base : item[0];
			var css = item[1];
			var media = item[2];
			var sourceMap = item[3];
			var part = {css: css, media: media, sourceMap: sourceMap};
	
			if(!newStyles[id]) styles.push(newStyles[id] = {id: id, parts: [part]});
			else newStyles[id].parts.push(part);
		}
	
		return styles;
	}
	
	function insertStyleElement (options, style) {
		var target = getElement(options.insertInto)
	
		if (!target) {
			throw new Error("Couldn't find a style target. This probably means that the value for the 'insertInto' parameter is invalid.");
		}
	
		var lastStyleElementInsertedAtTop = stylesInsertedAtTop[stylesInsertedAtTop.length - 1];
	
		if (options.insertAt === "top") {
			if (!lastStyleElementInsertedAtTop) {
				target.insertBefore(style, target.firstChild);
			} else if (lastStyleElementInsertedAtTop.nextSibling) {
				target.insertBefore(style, lastStyleElementInsertedAtTop.nextSibling);
			} else {
				target.appendChild(style);
			}
			stylesInsertedAtTop.push(style);
		} else if (options.insertAt === "bottom") {
			target.appendChild(style);
		} else {
			throw new Error("Invalid value for parameter 'insertAt'. Must be 'top' or 'bottom'.");
		}
	}
	
	function removeStyleElement (style) {
		if (style.parentNode === null) return false;
		style.parentNode.removeChild(style);
	
		var idx = stylesInsertedAtTop.indexOf(style);
		if(idx >= 0) {
			stylesInsertedAtTop.splice(idx, 1);
		}
	}
	
	function createStyleElement (options) {
		var style = document.createElement("style");
	
		options.attrs.type = "text/css";
	
		addAttrs(style, options.attrs);
		insertStyleElement(options, style);
	
		return style;
	}
	
	function createLinkElement (options) {
		var link = document.createElement("link");
	
		options.attrs.type = "text/css";
		options.attrs.rel = "stylesheet";
	
		addAttrs(link, options.attrs);
		insertStyleElement(options, link);
	
		return link;
	}
	
	function addAttrs (el, attrs) {
		Object.keys(attrs).forEach(function (key) {
			el.setAttribute(key, attrs[key]);
		});
	}
	
	function addStyle (obj, options) {
		var style, update, remove, result;
	
		// If a transform function was defined, run it on the css
		if (options.transform && obj.css) {
		    result = options.transform(obj.css);
	
		    if (result) {
		    	// If transform returns a value, use that instead of the original css.
		    	// This allows running runtime transformations on the css.
		    	obj.css = result;
		    } else {
		    	// If the transform function returns a falsy value, don't add this css.
		    	// This allows conditional loading of css
		    	return function() {
		    		// noop
		    	};
		    }
		}
	
		if (options.singleton) {
			var styleIndex = singletonCounter++;
	
			style = singleton || (singleton = createStyleElement(options));
	
			update = applyToSingletonTag.bind(null, style, styleIndex, false);
			remove = applyToSingletonTag.bind(null, style, styleIndex, true);
	
		} else if (
			obj.sourceMap &&
			typeof URL === "function" &&
			typeof URL.createObjectURL === "function" &&
			typeof URL.revokeObjectURL === "function" &&
			typeof Blob === "function" &&
			typeof btoa === "function"
		) {
			style = createLinkElement(options);
			update = updateLink.bind(null, style, options);
			remove = function () {
				removeStyleElement(style);
	
				if(style.href) URL.revokeObjectURL(style.href);
			};
		} else {
			style = createStyleElement(options);
			update = applyToTag.bind(null, style);
			remove = function () {
				removeStyleElement(style);
			};
		}
	
		update(obj);
	
		return function updateStyle (newObj) {
			if (newObj) {
				if (
					newObj.css === obj.css &&
					newObj.media === obj.media &&
					newObj.sourceMap === obj.sourceMap
				) {
					return;
				}
	
				update(obj = newObj);
			} else {
				remove();
			}
		};
	}
	
	var replaceText = (function () {
		var textStore = [];
	
		return function (index, replacement) {
			textStore[index] = replacement;
	
			return textStore.filter(Boolean).join('\n');
		};
	})();
	
	function applyToSingletonTag (style, index, remove, obj) {
		var css = remove ? "" : obj.css;
	
		if (style.styleSheet) {
			style.styleSheet.cssText = replaceText(index, css);
		} else {
			var cssNode = document.createTextNode(css);
			var childNodes = style.childNodes;
	
			if (childNodes[index]) style.removeChild(childNodes[index]);
	
			if (childNodes.length) {
				style.insertBefore(cssNode, childNodes[index]);
			} else {
				style.appendChild(cssNode);
			}
		}
	}
	
	function applyToTag (style, obj) {
		var css = obj.css;
		var media = obj.media;
	
		if(media) {
			style.setAttribute("media", media)
		}
	
		if(style.styleSheet) {
			style.styleSheet.cssText = css;
		} else {
			while(style.firstChild) {
				style.removeChild(style.firstChild);
			}
	
			style.appendChild(document.createTextNode(css));
		}
	}
	
	function updateLink (link, options, obj) {
		var css = obj.css;
		var sourceMap = obj.sourceMap;
	
		/*
			If convertToAbsoluteUrls isn't defined, but sourcemaps are enabled
			and there is no publicPath defined then lets turn convertToAbsoluteUrls
			on by default.  Otherwise default to the convertToAbsoluteUrls option
			directly
		*/
		var autoFixUrls = options.convertToAbsoluteUrls === undefined && sourceMap;
	
		if (options.convertToAbsoluteUrls || autoFixUrls) {
			css = fixUrls(css);
		}
	
		if (sourceMap) {
			// http://stackoverflow.com/a/26603875
			css += "\n/*# sourceMappingURL=data:application/json;base64," + btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap)))) + " */";
		}
	
		var blob = new Blob([css], { type: "text/css" });
	
		var oldSrc = link.href;
	
		link.href = URL.createObjectURL(blob);
	
		if(oldSrc) URL.revokeObjectURL(oldSrc);
	}


/***/ },
/* 133 */
/***/ function(module, exports, __webpack_require__) {

	var map = {
		"./best.svg": 1102,
		"./ok.svg": 1103,
		"./poor.svg": 1104,
		"./reflective.svg": 1105
	};
	function webpackContext(req) {
		return __webpack_require__(webpackContextResolve(req));
	};
	function webpackContextResolve(req) {
		return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
	};
	webpackContext.keys = function webpackContextKeys() {
		return Object.keys(map);
	};
	webpackContext.resolve = webpackContextResolve;
	module.exports = webpackContext;
	webpackContext.id = 133;


/***/ },
/* 134 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.setMainMenuDisplay = setMainMenuDisplay;
	
	var _actionTypes = __webpack_require__(22);
	
	var types = _interopRequireWildcard(_actionTypes);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function setMainMenuDisplay(displayMainMenu) {
	    return { type: types.SET_MAIN_MENU_DISPLAY, displayMainMenu: displayMainMenu };
	}

/***/ },
/* 135 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRouter = __webpack_require__(45);
	
	var _reactRedux = __webpack_require__(5);
	
	var _redux = __webpack_require__(4);
	
	var _svgInlineReact = __webpack_require__(434);
	
	var _svgInlineReact2 = _interopRequireDefault(_svgInlineReact);
	
	var _appDataActions = __webpack_require__(12);
	
	var appDataActions = _interopRequireWildcard(_appDataActions);
	
	var _trackingDataActions = __webpack_require__(7);
	
	var trackingDataActions = _interopRequireWildcard(_trackingDataActions);
	
	var _localStorage = __webpack_require__(17);
	
	var localStorage = _interopRequireWildcard(_localStorage);
	
	var _appHelper = __webpack_require__(3);
	
	var appHelper = _interopRequireWildcard(_appHelper);
	
	var _appConstants = __webpack_require__(13);
	
	var appConstants = _interopRequireWildcard(_appConstants);
	
	var _assetConstants = __webpack_require__(33);
	
	var assetConstants = _interopRequireWildcard(_assetConstants);
	
	var _objectConstants = __webpack_require__(9);
	
	var objectConstants = _interopRequireWildcard(_objectConstants);
	
	var _componentHelper = __webpack_require__(31);
	
	var _componentConstants = __webpack_require__(49);
	
	var _gsap = __webpack_require__(8);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Badge = function (_React$Component) {
	    _inherits(Badge, _React$Component);
	
	    function Badge(props, context) {
	        _classCallCheck(this, Badge);
	
	        var _this = _possibleConstructorReturn(this, (Badge.__proto__ || Object.getPrototypeOf(Badge)).call(this, props, context));
	
	        _this.state = {
	            lang: _this.props.lang,
	            badge: _this.props.badge,
	            userBadge: _this.props.userBadge,
	            showAchievedCount: _this.props.userBadge,
	            showAchievedState: _this.props.showAchievedState,
	            currentBadgeId: appHelper.isDefined(_this.props.currentBadgeId) ? _this.props.currentBadgeId : "",
	            locale: appHelper.getLocalData(_this.props.badge),
	            icon: {
	                src: ""
	            },
	            earnedBadge: {},
	            unearnedBadge: {}
	
	        };
	
	        _this.getBadgeClass = _this.getBadgeClass.bind(_this);
	        _this.getAssets = _this.getAssets.bind(_this);
	        _this.getImagePath = _this.getImagePath.bind(_this);
	        _this.onBadgeClicked = _this.onBadgeClicked.bind(_this);
	        _this.getActiveClass = _this.getActiveClass.bind(_this);
	        _this.setKeyboardAccessibility = _this.setKeyboardAccessibility.bind(_this);
	
	        return _this;
	    }
	
	    _createClass(Badge, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	
	            this.getAssets();
	        }
	    }, {
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(nextProps) {
	            if (this.state.userBadge !== nextProps.userBadge) {
	                this.setState({ userBadge: Object.assign({}, nextProps.userBadge) });
	            }
	            if (this.state.showAchievedCount !== nextProps.showAchievedCount) {
	                this.setState({ showAchievedCount: nextProps.showAchievedCount });
	            }
	            if (this.state.showAchievedState !== nextProps.showAchievedState) {
	                this.setState({ showAchievedState: nextProps.showAchievedState });
	            }
	
	            if (appHelper.isDefined(nextProps.currentBadgeId) && this.state.currentBadgeId !== nextProps.currentBadgeId) {
	                this.setState({ currentBadgeId: nextProps.currentBadgeId });
	            }
	            if (this.state.lang !== nextProps.lang) {
	                this.setState({
	                    lang: nextProps.lang,
	                    locale: appHelper.getLocalData(this.props.badge)
	                });
	            }
	        }
	    }, {
	        key: 'getAssets',
	        value: function getAssets() {
	            var icon = {};
	            var earnedBadge = {};
	            var unearnedBadge = {};
	
	            if (this.state.badge.icon.constant === assetConstants.ASSET_TYPE_ICON) {
	                icon = appHelper.getIconAsset(this.state.badge.icon);
	            } else if (this.state.badge.icon.constant === assetConstants.ASSET_TYPE_LIBRARY_IMAGE) {
	                icon = appHelper.getLibraryImageAsset(this.state.badge.icon);
	            }
	
	            if (appHelper.isDefined(this.state.badge.badge_type) && this.state.badge.badge_type === objectConstants.BADGE_TYPE_IMAGE) {
	                if (appHelper.isDefined(this.state.locale.image) && appHelper.isDefined(this.state.locale.image.earned.file_name)) {
	                    earnedBadge = appHelper.getEarnedAsset(this.state.locale.image.earned);
	                }
	
	                if (appHelper.isDefined(this.state.locale.image) && appHelper.isDefined(this.state.locale.image.unearned.file_name)) {
	                    unearnedBadge = appHelper.getUnearnedAsset(this.state.locale.image.unearned);
	                }
	            }
	
	            this.setState({
	                icon: Object.assign({}, appHelper.isDefined(icon.src) ? icon : this.state.icon),
	                earnedBadge: Object.assign({}, appHelper.isDefined(earnedBadge.src) ? earnedBadge : this.state.earnedBadge),
	                unearnedBadge: Object.assign({}, appHelper.isDefined(unearnedBadge.src) ? unearnedBadge : this.state.unearnedBadge)
	            });
	        }
	    }, {
	        key: 'getBadgeClass',
	        value: function getBadgeClass() {
	            return this.state.userBadge.achieved === 0 && this.props.showAchievedState ? 'not-achieved' : 'achieved';
	        }
	    }, {
	        key: 'getImagePath',
	        value: function getImagePath(image) {
	            if (appConstants.DEVELOPMENT_MODE) {
	                if (appHelper.isDefined(image) && image.length > 0) {
	                    return __webpack_require__(16)("./" + image);
	                }
	            } else {
	                return image;
	            }
	        }
	    }, {
	        key: 'onBadgeClicked',
	        value: function onBadgeClicked(event) {
	            event.stopPropagation();
	            event.preventDefault();
	            if (appHelper.isDefined(this.props.onClicked)) {
	                if (this.state.badge.badge_id !== this.state.currentBadgeId) {
	                    this.props.onClicked(this.state.badge.badge_id, this.state.locale);
	                } else {
	                    this.props.onClicked("", {});
	                }
	            }
	        }
	    }, {
	        key: 'getActiveClass',
	        value: function getActiveClass() {
	            return this.state.badge.badge_id === this.state.currentBadgeId ? 'active' : '';
	        }
	    }, {
	        key: 'setKeyboardAccessibility',
	        value: function setKeyboardAccessibility(event) {}
	
	        //<InlineSVG className="guroo-icon" src={this.getImagePath(this.state.icon.src)}/>
	
	    }, {
	        key: 'render',
	        value: function render() {
	            return this.state.badge.badge_type === objectConstants.BADGE_TYPE_SHIELD ? _react2.default.createElement(
	                'div',
	                { className: 'badge ' + this.getActiveClass(), onClick: this.onBadgeClicked,
	                    onKeyDown: this.setKeyboardAccessibility, onFocus: this.onBadgeClicked,
	                    onMouseOver: this.onBadgeClicked, onMouseOut: this.onBadgeClicked, onBlur: this.onBadgeClicked,
	                    id: 'badge_' + this.state.badge.badge_id,
	                    tabIndex: appHelper.isDefined(this.props.onClicked) ? 0 : -1, role: 'link' },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'badge-container ' + this.getBadgeClass() },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'badge-icon' },
	                        _react2.default.createElement('img', { src: this.getImagePath(this.state.icon.src), alt: '' })
	                    )
	                ),
	                _react2.default.createElement('div', { className: 'badge-label', dangerouslySetInnerHTML: { __html: this.state.locale.short_title } }),
	                this.state.userBadge.achieved > 1 && this.props.showAchievedCount ? _react2.default.createElement(
	                    'div',
	                    { className: 'achieved-count' },
	                    'x',
	                    this.state.userBadge.achieved
	                ) : null,
	                _react2.default.createElement(
	                    'div',
	                    { className: 'hidden' },
	                    appHelper.isDefined(this.state.locale.long_title) && this.state.locale.long_title !== null && this.state.locale.long_title.length > 0 ? _react2.default.createElement('h4', { dangerouslySetInnerHTML: { __html: this.state.locale.long_title } }) : null,
	                    appHelper.isDefined(this.state.locale.description) && this.state.locale.description !== null && this.state.locale.description.length > 0 ? _react2.default.createElement('div', { dangerouslySetInnerHTML: { __html: this.state.locale.description } }) : null
	                )
	            ) : _react2.default.createElement(
	                'div',
	                { className: 'image-badge', onClick: this.onBadgeClicked, onKeyDown: this.setKeyboardAccessibility,
	                    onFocus: this.onBadgeClicked, onMouseOver: this.onBadgeClicked, onMouseOut: this.onBadgeClicked,
	                    onBlur: this.onBadgeClicked, id: 'badge_' + this.state.badge.badge_id,
	                    tabIndex: appHelper.isDefined(this.props.onClicked) ? 0 : -1, role: 'link' },
	                this.state.userBadge.achieved === 0 && this.props.showAchievedState ? _react2.default.createElement('img', { src: this.getImagePath(this.state.unearnedBadge.src), alt: '' }) : _react2.default.createElement('img', { src: this.getImagePath(this.state.earnedBadge.src), alt: '' }),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'hidden' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'hidden' },
	                        appHelper.isDefined(this.state.locale.long_title) && this.state.locale.long_title.length > 0 ? _react2.default.createElement('h5', { dangerouslySetInnerHTML: { __html: this.state.locale.long_title } }) : null,
	                        appHelper.isDefined(this.state.locale.description) && this.state.locale.description !== null && this.state.locale.description.length > 0 ? _react2.default.createElement('div', { dangerouslySetInnerHTML: { __html: this.state.locale.description } }) : null
	                    )
	                )
	            );
	        }
	    }]);
	
	    return Badge;
	}(_react2.default.Component);
	
	Badge.propTypes = {
	    badge: _propTypes2.default.object.isRequired,
	    userBadge: _propTypes2.default.object.isRequired,
	    showAchievedCount: _propTypes2.default.bool.isRequired,
	    showAchievedState: _propTypes2.default.bool.isRequired,
	    onClicked: _propTypes2.default.func,
	    currentBadgeId: _propTypes2.default.number,
	    lang: _propTypes2.default.string.isRequired,
	    actions: _propTypes2.default.object.isRequired
	};
	
	Badge.contextTypes = {
	    router: _propTypes2.default.object
	};
	
	function mapStateToProps(state, ownProps) {
	    var lang = state.userData.lang;
	    return {
	        lang: lang
	    };
	}
	
	function mapDispatchToProps(dispatch) {
	    return {
	        actions: (0, _redux.bindActionCreators)(Object.assign({}, trackingDataActions, appDataActions), dispatch)
	    };
	}
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(Badge);

/***/ },
/* 136 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(5);
	
	var _redux = __webpack_require__(4);
	
	var _Button = __webpack_require__(18);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _userDataActions = __webpack_require__(20);
	
	var userDataActions = _interopRequireWildcard(_userDataActions);
	
	var _trackingDataActions = __webpack_require__(7);
	
	var trackingDataActions = _interopRequireWildcard(_trackingDataActions);
	
	var _appHelper = __webpack_require__(3);
	
	var appHelper = _interopRequireWildcard(_appHelper);
	
	var _userDataHelper = __webpack_require__(15);
	
	var userDataHelper = _interopRequireWildcard(_userDataHelper);
	
	var _appConstants = __webpack_require__(13);
	
	var appConstants = _interopRequireWildcard(_appConstants);
	
	var _objectConstants = __webpack_require__(9);
	
	var objectConstants = _interopRequireWildcard(_objectConstants);
	
	var _gsap = __webpack_require__(8);
	
	var _gsapReactPlugin = __webpack_require__(10);
	
	var _gsapReactPlugin2 = _interopRequireDefault(_gsapReactPlugin);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } //eslint-disable-line import/no-named-as-default
	
	
	var AssetImage = function (_React$Component) {
	    _inherits(AssetImage, _React$Component);
	
	    function AssetImage(props, context) {
	        _classCallCheck(this, AssetImage);
	
	        var _this = _possibleConstructorReturn(this, (AssetImage.__proto__ || Object.getPrototypeOf(AssetImage)).call(this, props, context));
	
	        _this.state = {
	            lang: _this.props.lang,
	            screenObject: _this.props.screenObject,
	            userData: _this.props.userData,
	            status: objectConstants.STATUS_NOT_STARTED,
	            locale: appHelper.getLocalData(_this.props.screenObject),
	            showProgressionButton: false,
	            image: {},
	            screenStatus: "",
	            filter: "landscape",
	            checkComplete: false,
	            isResourceObject: appHelper.isDefined(_this.props.callbacks.checkIsResourceScreen) && _this.props.callbacks.checkIsResourceScreen(),
	            imageRevealed: false,
	            done_label: appHelper.getLocaleString("done_label")
	
	        };
	        _this.getAssets = _this.getAssets.bind(_this);
	        _this.show = _this.show.bind(_this);
	        _this.setClass = _this.setClass.bind(_this);
	        _this.getImagePath = _this.getImagePath.bind(_this);
	        _this.getImageClass = _this.getImageClass.bind(_this);
	        _this.onImageRevealed = _this.onImageRevealed.bind(_this);
	        _this.getFilterBtnClass = _this.getFilterBtnClass.bind(_this);
	        _this.setFilterWidth = _this.setFilterWidth.bind(_this);
	        _this.setFilterHeight = _this.setFilterHeight.bind(_this);
	        return _this;
	    }
	
	    _createClass(AssetImage, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            this.getAssets();
	            this.show();
	            if (appHelper.isDefined(this.props.callbacks.updateCharacterExpression) && appHelper.isDefined(this.state.screenObject.character_pose)) {
	                this.props.callbacks.updateCharacterExpression(this.state.screenObject.character_pose);
	            }
	        }
	    }, {
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(nextProps) {
	            if (this.state.lang !== nextProps.lang) {
	                var image = appHelper.getImageAsset(this.state.screenObject);
	                this.setState({
	                    lang: nextProps.lang,
	                    locale: appHelper.getLocalData(this.state.screenObject),
	                    image: appHelper.isDefined(image.locale) ? appHelper.getLocalData(image) : image,
	                    done_label: appHelper.getLocaleString("done_label")
	                });
	            }
	        }
	    }, {
	        key: 'componentDidUpdate',
	        value: function componentDidUpdate() {
	            if (this.state.checkComplete) {
	                this.onComplete();
	            }
	        }
	    }, {
	        key: 'getAssets',
	        value: function getAssets() {
	            var image = appHelper.getImageAsset(this.state.screenObject);
	            this.setState({ image: appHelper.isDefined(image.locale) ? appHelper.getLocalData(image) : image });
	        }
	    }, {
	        key: 'show',
	        value: function show() {
	            var fileRef = this.refs['image_' + this.state.screenObject.asset_id];
	            if (appHelper.isDefined(fileRef)) {
	                _gsap.TweenLite.set(fileRef, { opacity: 1 });
	                _gsap.TweenLite.from(fileRef, objectConstants.SHOW_PANEL_DURATION, {
	                    opacity: 0,
	                    ease: _gsap.Expo.easeInOut
	                }).eventCallback("onComplete", this.onImageRevealed);
	            }
	        }
	    }, {
	        key: 'onImageRevealed',
	        value: function onImageRevealed() {
	            this.setState({ imageRevealed: true });
	            this.props.onAssetViewed();
	        }
	    }, {
	        key: 'getImagePath',
	        value: function getImagePath(image) {
	            if (appConstants.DEVELOPMENT_MODE) {
	                if (appHelper.isDefined(image) && image.length > 0) {
	                    return __webpack_require__(16)("./" + image);
	                }
	            } else {
	                return image;
	            }
	        }
	    }, {
	        key: 'setClass',
	        value: function setClass() {
	            return this.state.imageRevealed ? "viewable" : "hidden";
	        }
	    }, {
	        key: 'getImageClass',
	        value: function getImageClass() {
	            /*let image = this.refs[`asset_image_${this.state.screenObject.asset_id}`];
	            if(appHelper.isDefined(image)){
	                let imageWidth = image.offsetWidth;
	                let imageHeight = image.offsetHeight;
	                return imageWidth >= imageHeight ? 'landscape' : 'portrait';
	            }else {
	                return "";
	            }*/
	            return this.state.filter;
	        }
	    }, {
	        key: 'getFilterBtnClass',
	        value: function getFilterBtnClass(value) {
	            return value === this.state.filter ? 'active' : '';
	        }
	    }, {
	        key: 'setFilterWidth',
	        value: function setFilterWidth() {
	            this.setState({ filter: "landscape" });
	        }
	    }, {
	        key: 'setFilterHeight',
	        value: function setFilterHeight() {
	            this.setState({ filter: "portrait" });
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            return _react2.default.createElement(
	                'div',
	                { className: 'object-container', ref: 'image_' + this.state.screenObject.asset_id },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'asset-dialog-image ', ref: 'asset_image_' + this.state.screenObject.asset_id },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'asset-image-header' },
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'title-col truncate-text-container' },
	                            _react2.default.createElement('div', { className: 'title', dangerouslySetInnerHTML: { __html: this.state.locale.label } })
	                        ),
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'nav-col' },
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'btn-group text-right icon-btn-group' },
	                                _react2.default.createElement(
	                                    'button',
	                                    { type: 'button', className: 'btn guroo-btn ' + this.getFilterBtnClass("landscape"), id: 'landscape_image', onClick: this.setFilterWidth },
	                                    _react2.default.createElement('span', { className: 'icon icons8-width-filled' }),
	                                    ' '
	                                ),
	                                _react2.default.createElement(
	                                    'button',
	                                    { type: 'button', className: 'btn guroo-btn ' + this.getFilterBtnClass("portrait"), id: 'portrait_image', onClick: this.setFilterHeight },
	                                    _react2.default.createElement('span', { className: 'icon icons8-height-filled' })
	                                )
	                            ),
	                            '\xA0',
	                            _react2.default.createElement(
	                                'button',
	                                { className: 'btn guroo-btn', onClick: this.props.closeDialog, id: 'image_close_btn' },
	                                this.state.done_label
	                            )
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'asset-img-container ' + this.getImageClass() },
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'img-container' },
	                            _react2.default.createElement('img', { src: this.getImagePath(this.state.image.src), className: '', alt: this.state.locale.label })
	                        ),
	                        appHelper.isDefined(this.state.locale.description) && this.state.locale.description !== null && this.state.locale.description.length > 0 ? _react2.default.createElement(
	                            'div',
	                            { className: 'asset-desc' },
	                            _react2.default.createElement('div', { dangerouslySetInnerHTML: { __html: this.state.locale.description } })
	                        ) : null
	                    )
	                )
	            );
	        }
	    }]);
	
	    return AssetImage;
	}(_react2.default.Component);
	
	AssetImage.propTypes = {
	    screenObject: _propTypes2.default.object.isRequired,
	    callbacks: _propTypes2.default.object.isRequired,
	    onAssetViewed: _propTypes2.default.func.isRequired,
	    closeDialog: _propTypes2.default.func.isRequired,
	    index: _propTypes2.default.number,
	    userData: _propTypes2.default.object.isRequired,
	    lang: _propTypes2.default.string.isRequired,
	    actions: _propTypes2.default.object.isRequired
	};
	
	AssetImage.contextTypes = {
	    router: _propTypes2.default.object
	};
	
	function mapStateToProps(state, ownProps) {
	    var lang = state.userData.lang;
	    return {
	        lang: lang,
	        userData: state.userData
	    };
	}
	
	function mapDispatchToProps(dispatch) {
	    return {
	        actions: (0, _redux.bindActionCreators)(Object.assign({}, userDataActions, trackingDataActions), dispatch)
	    };
	}
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(AssetImage);

/***/ },
/* 137 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var CMI_CORE_CHILDREN = exports.CMI_CORE_CHILDREN = "cmi.core._children"; // READ ONLY
	var CMI_CORE_STUDENT_ID = exports.CMI_CORE_STUDENT_ID = "cmi.core.student_id"; // READ ONLY
	var CMI_CORE_STUDENT_NAME = exports.CMI_CORE_STUDENT_NAME = "cmi.core.student_name"; // READ ONLY
	var CMI_CORE_LESSON_LOCATION = exports.CMI_CORE_LESSON_LOCATION = "cmi.core.lesson_location"; // READ & WRITE
	var CMI_CORE_CREDIT_READONLY = exports.CMI_CORE_CREDIT_READONLY = "cmi.core.credit"; // READ ONLY
	var CMI_CORE_LESSON_STATUS = exports.CMI_CORE_LESSON_STATUS = "cmi.core.lesson_status"; // READ & WRITE
	var CMI_CORE_ENTRY = exports.CMI_CORE_ENTRY = "cmi.core.entry"; // READ ONLY
	var CMI_CORE_SCORE_CHILDREN = exports.CMI_CORE_SCORE_CHILDREN = "cmi.core.score._children"; // READ ONLY
	var CMI_CORE_SCORE_RAW = exports.CMI_CORE_SCORE_RAW = "cmi.core.score.raw"; // READ & WRITE
	var CMI_CORE_SCORE_MAX = exports.CMI_CORE_SCORE_MAX = "cmi.core.score.max"; // READ & WRITE
	var CMI_CORE_SCORE_MIN = exports.CMI_CORE_SCORE_MIN = "cmi.core.score.min"; // READ & WRITE
	var CMI_CORE_TOTAL_TIME = exports.CMI_CORE_TOTAL_TIME = "cmi.core.total_time"; // READ ONLY
	var CMI_CORE_LESSON_MODE = exports.CMI_CORE_LESSON_MODE = "cmi.core.lesson_mode"; // READ ONLY
	var CMI_CORE_EXIT = exports.CMI_CORE_EXIT = "cmi.core.exit"; // WRITE ONLY
	var CMI_CORE_SESSION_TIME = exports.CMI_CORE_SESSION_TIME = "cmi.core.session_time"; // WRITE ONLY
	var CMI_SUSPEND_DATA = exports.CMI_SUSPEND_DATA = "cmi.suspend_data"; // READ & WRITE
	var CMI_LAUNCH_DATA = exports.CMI_LAUNCH_DATA = "cmi.launch_data"; //READ ONLY
	var CMI_COMMENTS = exports.CMI_COMMENTS = "cmi.comments"; // READ & WRITE
	var CMI_COMMENTS_FROM_LMS = exports.CMI_COMMENTS_FROM_LMS = "cmi.comments_from_lms"; //READ ONLY
	
	var CMI_CREDIT = exports.CMI_CREDIT = "credit";
	var CMI_NO_CREDIT = exports.CMI_NO_CREDIT = "no-credit";
	var LESSON_STATUS_PASSED = exports.LESSON_STATUS_PASSED = "passed";
	var LESSON_STATUS_COMPLETED = exports.LESSON_STATUS_COMPLETED = "completed";
	var LESSON_STATUS_FAILED = exports.LESSON_STATUS_FAILED = "failed";
	var LESSON_STATUS_INCOMPLETE = exports.LESSON_STATUS_INCOMPLETE = "incomplete";
	var LESSON_STATUS_BROWSED = exports.LESSON_STATUS_BROWSED = "browsed";
	var LESSON_STATUS_NOT_ATTEMPTED = exports.LESSON_STATUS_NOT_ATTEMPTED = "not attempted";
	var LESSON_MODE_BROWSE = exports.LESSON_MODE_BROWSE = "browse";
	var LESSON_MODE_NORMAL = exports.LESSON_MODE_NORMAL = "normal";
	var LESSON_MODE_REVIEW = exports.LESSON_MODE_REVIEW = "learnerActionReview";
	var EXIT_TIME_OUT = exports.EXIT_TIME_OUT = "time-out";
	var EXIT_SUSPEND = exports.EXIT_SUSPEND = "suspend";
	var EXIT_LOGOUT = exports.EXIT_LOGOUT = "logout";
	
	var SUSPEND_DATA_LIMIT = exports.SUSPEND_DATA_LIMIT = 4096;
	
	//NOT MANDATORY
	var CMI_OBJECTIVES_CHILDREN = exports.CMI_OBJECTIVES_CHILDREN = "cmi.objectives._children"; //READ ONLY
	var CMI_OBJECTIVES_COUNT = exports.CMI_OBJECTIVES_COUNT = "cmi.objectives._count"; //READ ONLY
	var CMI_OBJECTIVES_N_ID = exports.CMI_OBJECTIVES_N_ID = "cmi.objectives.n.id"; //READ & WRITE
	var CMI_OBJECTIVES_N_SCORE_CHILDREN = exports.CMI_OBJECTIVES_N_SCORE_CHILDREN = "cmi.objectives.n.score._children"; //READ ONLY
	var CMI_OBJECTIVES_N_SCORE_RAW = exports.CMI_OBJECTIVES_N_SCORE_RAW = "cmi.objectives.n.score.raw"; //READ & WRITE
	var CMI_OBJECTIVES_N_SCORE_MAX = exports.CMI_OBJECTIVES_N_SCORE_MAX = "cmi.objectives.n.score.max"; //READ ONLY
	var CMI_OBJECTIVES_N_SCORE_MIN = exports.CMI_OBJECTIVES_N_SCORE_MIN = "cmi.objectives.n.score.min"; //READ ONLY
	var CMI_OBJECTIVES_N_STATUS = exports.CMI_OBJECTIVES_N_STATUS = "cmi.objectives.n.status"; //READ ONLY
	var CMI_STUDENT_DATA_CHILDREN = exports.CMI_STUDENT_DATA_CHILDREN = "cmi.student_data._children"; //READ ONLY
	var CMI_STUDENT_DATA_MASTERY_SCORE = exports.CMI_STUDENT_DATA_MASTERY_SCORE = "cmi.student_data.mastery_score"; //READ ONLY
	var CMI_STUDENT_DATA_MAX_TIME_ALLOWED = exports.CMI_STUDENT_DATA_MAX_TIME_ALLOWED = "cmi.student_data.max_time_allowed"; //READ ONLY
	var CMI_STUDENT_DATA_TIME_LIMIT_ACTION = exports.CMI_STUDENT_DATA_TIME_LIMIT_ACTION = "cmi.student_data.time_limit_action"; //READ ONLY
	var CMI_STUDENT_PREFERENCE_CHILDREN = exports.CMI_STUDENT_PREFERENCE_CHILDREN = "cmi.student_preference._children"; //READ ONLY
	var CMI_STUDENT_PREFERENCE_AUDIO = exports.CMI_STUDENT_PREFERENCE_AUDIO = "cmi.student_preference.audio"; //READ & WRITE
	var CMI_STUDENT_PREFERENCE_LANGUAGE = exports.CMI_STUDENT_PREFERENCE_LANGUAGE = "cmi.student_preference.language"; //READ & WRITE
	var CMI_STUDENT_PREFERENCE_SPEED = exports.CMI_STUDENT_PREFERENCE_SPEED = "cmi.student_preference.speed"; //READ & WRITE
	var CMI_STUDENT_PREFERENCE_TEXT = exports.CMI_STUDENT_PREFERENCE_TEXT = "cmi.student_preference.text"; //READ & WRITE
	var CMI_INTERACTIONS_CHILDREN = exports.CMI_INTERACTIONS_CHILDREN = "cmi.interactions._children"; //READ ONLY
	var CMI_INTERACTIONS_COUNT = exports.CMI_INTERACTIONS_COUNT = "cmi.interactions._count"; //READ ONLY
	var CMI_INTERACTIONS_N_ID = exports.CMI_INTERACTIONS_N_ID = "cmi.interactions.n.id"; //READ ONLY
	var CMI_INTERACTIONS_N_OBJECTIVES_COUNT = exports.CMI_INTERACTIONS_N_OBJECTIVES_COUNT = "cmi.interactions.n.objectives._count"; //READ ONLY
	var CMI_INTERACTIONS_N_OBJECTIVES_ID = exports.CMI_INTERACTIONS_N_OBJECTIVES_ID = "cmi.interactions.n.objectives.id"; //WRITE ONLY
	var CMI_INTERACTIONS_N_TIME = exports.CMI_INTERACTIONS_N_TIME = "cmi.interactions.n.time."; //WRITE ONLY
	var CMI_INTERACTIONS_N_TYPE = exports.CMI_INTERACTIONS_N_TYPE = "cmi.interaction.n.type"; //WRITE ONLY
	var CMI_INTERACTIONS_N_CORRECT_RESPONSES_COUNT = exports.CMI_INTERACTIONS_N_CORRECT_RESPONSES_COUNT = "cmi.interaction.n.correct_responses._count"; //READ ONLY
	var CMI_INTERACTIONS_N_CORRECT_RESPONSES_N_PATTERN = exports.CMI_INTERACTIONS_N_CORRECT_RESPONSES_N_PATTERN = "cmi.interaction.correct_responses.n.pattern"; //WRITE ONLY
	var CMI_INTERACTIONS_N_WEIGHTING = exports.CMI_INTERACTIONS_N_WEIGHTING = "cmi.interaction.n.weighting"; //WRITE ONLY
	var CMI_INTERACTIONS_N_STUDENT_RESPONSE = exports.CMI_INTERACTIONS_N_STUDENT_RESPONSE = "cmi.interaction.student_response"; //WRITE ONLY
	var CMI_INTERACTIONS_N_RESULT = exports.CMI_INTERACTIONS_N_RESULT = "cmi.interaction.n.result"; //WRITE ONLY
	var CMI_INTERACTIONS_N_LATENCY = exports.CMI_INTERACTIONS_N_LATENCY = "cmi.interaction.n.latency";
	
	var INTERACTION_TYPE_TRUE_FALSE = exports.INTERACTION_TYPE_TRUE_FALSE = "true-false";
	var INTERACTION_TYPE_CHOICE = exports.INTERACTION_TYPE_CHOICE = "choice";
	var INTERACTION_TYPE_FILL_IN = exports.INTERACTION_TYPE_FILL_IN = "fill-in";
	var INTERACTION_TYPE_MATCHING = exports.INTERACTION_TYPE_MATCHING = "matching";
	var INTERACTION_TYPE_PERFORMACE = exports.INTERACTION_TYPE_PERFORMACE = "performance";
	var INTERACTION_TYPE_SEQUENCING = exports.INTERACTION_TYPE_SEQUENCING = "sequencing";
	var INTERACTION_TYPE_LIKERT = exports.INTERACTION_TYPE_LIKERT = "likert";
	var INTERACTION_TYPE_NUMERIC = exports.INTERACTION_TYPE_NUMERIC = "numeric";
	
	var CMI_CORE_SCORE_MAX_DEFAULT = exports.CMI_CORE_SCORE_MAX_DEFAULT = 100;
	var CMI_CORE_SCORE_MIN_DEFAULT = exports.CMI_CORE_SCORE_MIN_DEFAULT = 0;

/***/ },
/* 138 */
/***/ function(module, exports, __webpack_require__) {

	// getting tag from 19.1.3.6 Object.prototype.toString()
	var cof = __webpack_require__(69);
	var TAG = __webpack_require__(34)('toStringTag');
	// ES3 wrong here
	var ARG = cof(function () { return arguments; }()) == 'Arguments';
	
	// fallback for IE11 Script Access Denied error
	var tryGet = function (it, key) {
	  try {
	    return it[key];
	  } catch (e) { /* empty */ }
	};
	
	module.exports = function (it) {
	  var O, T, B;
	  return it === undefined ? 'Undefined' : it === null ? 'Null'
	    // @@toStringTag case
	    : typeof (T = tryGet(O = Object(it), TAG)) == 'string' ? T
	    // builtinTag case
	    : ARG ? cof(O)
	    // ES3 arguments fallback
	    : (B = cof(O)) == 'Object' && typeof O.callee == 'function' ? 'Arguments' : B;
	};


/***/ },
/* 139 */
/***/ function(module, exports, __webpack_require__) {

	// fallback for non-array-like ES3 and non-enumerable old V8 strings
	var cof = __webpack_require__(69);
	// eslint-disable-next-line no-prototype-builtins
	module.exports = Object('z').propertyIsEnumerable(0) ? Object : function (it) {
	  return cof(it) == 'String' ? it.split('') : Object(it);
	};


/***/ },
/* 140 */
/***/ function(module, exports) {

	exports.f = {}.propertyIsEnumerable;


/***/ },
/* 141 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var emptyObject = {};
	
	if (false) {
	  Object.freeze(emptyObject);
	}
	
	module.exports = emptyObject;

/***/ },
/* 142 */
/***/ function(module, exports) {

	/**
	 * Checks if `value` is the
	 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
	 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
	 * @example
	 *
	 * _.isObject({});
	 * // => true
	 *
	 * _.isObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isObject(_.noop);
	 * // => true
	 *
	 * _.isObject(null);
	 * // => false
	 */
	function isObject(value) {
	  var type = typeof value;
	  return value != null && (type == 'object' || type == 'function');
	}
	
	module.exports = isObject;


/***/ },
/* 143 */
/***/ function(module, exports) {

	'use strict';
	
	module.exports = {
	  H264_STREAM_TYPE: 0x1B,
	  ADTS_STREAM_TYPE: 0x0F,
	  METADATA_STREAM_TYPE: 0x15
	};


/***/ },
/* 144 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(29);
	
	var EventPluginRegistry = __webpack_require__(250);
	var EventPluginUtils = __webpack_require__(251);
	var ReactErrorUtils = __webpack_require__(255);
	
	var accumulateInto = __webpack_require__(400);
	var forEachAccumulated = __webpack_require__(401);
	var invariant = __webpack_require__(21);
	
	/**
	 * Internal store for event listeners
	 */
	var listenerBank = {};
	
	/**
	 * Internal queue of events that have accumulated their dispatches and are
	 * waiting to have their dispatches executed.
	 */
	var eventQueue = null;
	
	/**
	 * Dispatches an event and releases it back into the pool, unless persistent.
	 *
	 * @param {?object} event Synthetic event to be dispatched.
	 * @param {boolean} simulated If the event is simulated (changes exn behavior)
	 * @private
	 */
	var executeDispatchesAndRelease = function (event, simulated) {
	  if (event) {
	    EventPluginUtils.executeDispatchesInOrder(event, simulated);
	
	    if (!event.isPersistent()) {
	      event.constructor.release(event);
	    }
	  }
	};
	var executeDispatchesAndReleaseSimulated = function (e) {
	  return executeDispatchesAndRelease(e, true);
	};
	var executeDispatchesAndReleaseTopLevel = function (e) {
	  return executeDispatchesAndRelease(e, false);
	};
	
	var getDictionaryKey = function (inst) {
	  // Prevents V8 performance issue:
	  // https://github.com/facebook/react/pull/7232
	  return '.' + inst._rootNodeID;
	};
	
	function isInteractive(tag) {
	  return tag === 'button' || tag === 'input' || tag === 'select' || tag === 'textarea';
	}
	
	function shouldPreventMouseEvent(name, type, props) {
	  switch (name) {
	    case 'onClick':
	    case 'onClickCapture':
	    case 'onDoubleClick':
	    case 'onDoubleClickCapture':
	    case 'onMouseDown':
	    case 'onMouseDownCapture':
	    case 'onMouseMove':
	    case 'onMouseMoveCapture':
	    case 'onMouseUp':
	    case 'onMouseUpCapture':
	      return !!(props.disabled && isInteractive(type));
	    default:
	      return false;
	  }
	}
	
	/**
	 * This is a unified interface for event plugins to be installed and configured.
	 *
	 * Event plugins can implement the following properties:
	 *
	 *   `extractEvents` {function(string, DOMEventTarget, string, object): *}
	 *     Required. When a top-level event is fired, this method is expected to
	 *     extract synthetic events that will in turn be queued and dispatched.
	 *
	 *   `eventTypes` {object}
	 *     Optional, plugins that fire events must publish a mapping of registration
	 *     names that are used to register listeners. Values of this mapping must
	 *     be objects that contain `registrationName` or `phasedRegistrationNames`.
	 *
	 *   `executeDispatch` {function(object, function, string)}
	 *     Optional, allows plugins to override how an event gets dispatched. By
	 *     default, the listener is simply invoked.
	 *
	 * Each plugin that is injected into `EventsPluginHub` is immediately operable.
	 *
	 * @public
	 */
	var EventPluginHub = {
	  /**
	   * Methods for injecting dependencies.
	   */
	  injection: {
	    /**
	     * @param {array} InjectedEventPluginOrder
	     * @public
	     */
	    injectEventPluginOrder: EventPluginRegistry.injectEventPluginOrder,
	
	    /**
	     * @param {object} injectedNamesToPlugins Map from names to plugin modules.
	     */
	    injectEventPluginsByName: EventPluginRegistry.injectEventPluginsByName
	  },
	
	  /**
	   * Stores `listener` at `listenerBank[registrationName][key]`. Is idempotent.
	   *
	   * @param {object} inst The instance, which is the source of events.
	   * @param {string} registrationName Name of listener (e.g. `onClick`).
	   * @param {function} listener The callback to store.
	   */
	  putListener: function (inst, registrationName, listener) {
	    !(typeof listener === 'function') ?  false ? invariant(false, 'Expected %s listener to be a function, instead got type %s', registrationName, typeof listener) : _prodInvariant('94', registrationName, typeof listener) : void 0;
	
	    var key = getDictionaryKey(inst);
	    var bankForRegistrationName = listenerBank[registrationName] || (listenerBank[registrationName] = {});
	    bankForRegistrationName[key] = listener;
	
	    var PluginModule = EventPluginRegistry.registrationNameModules[registrationName];
	    if (PluginModule && PluginModule.didPutListener) {
	      PluginModule.didPutListener(inst, registrationName, listener);
	    }
	  },
	
	  /**
	   * @param {object} inst The instance, which is the source of events.
	   * @param {string} registrationName Name of listener (e.g. `onClick`).
	   * @return {?function} The stored callback.
	   */
	  getListener: function (inst, registrationName) {
	    // TODO: shouldPreventMouseEvent is DOM-specific and definitely should not
	    // live here; needs to be moved to a better place soon
	    var bankForRegistrationName = listenerBank[registrationName];
	    if (shouldPreventMouseEvent(registrationName, inst._currentElement.type, inst._currentElement.props)) {
	      return null;
	    }
	    var key = getDictionaryKey(inst);
	    return bankForRegistrationName && bankForRegistrationName[key];
	  },
	
	  /**
	   * Deletes a listener from the registration bank.
	   *
	   * @param {object} inst The instance, which is the source of events.
	   * @param {string} registrationName Name of listener (e.g. `onClick`).
	   */
	  deleteListener: function (inst, registrationName) {
	    var PluginModule = EventPluginRegistry.registrationNameModules[registrationName];
	    if (PluginModule && PluginModule.willDeleteListener) {
	      PluginModule.willDeleteListener(inst, registrationName);
	    }
	
	    var bankForRegistrationName = listenerBank[registrationName];
	    // TODO: This should never be null -- when is it?
	    if (bankForRegistrationName) {
	      var key = getDictionaryKey(inst);
	      delete bankForRegistrationName[key];
	    }
	  },
	
	  /**
	   * Deletes all listeners for the DOM element with the supplied ID.
	   *
	   * @param {object} inst The instance, which is the source of events.
	   */
	  deleteAllListeners: function (inst) {
	    var key = getDictionaryKey(inst);
	    for (var registrationName in listenerBank) {
	      if (!listenerBank.hasOwnProperty(registrationName)) {
	        continue;
	      }
	
	      if (!listenerBank[registrationName][key]) {
	        continue;
	      }
	
	      var PluginModule = EventPluginRegistry.registrationNameModules[registrationName];
	      if (PluginModule && PluginModule.willDeleteListener) {
	        PluginModule.willDeleteListener(inst, registrationName);
	      }
	
	      delete listenerBank[registrationName][key];
	    }
	  },
	
	  /**
	   * Allows registered plugins an opportunity to extract events from top-level
	   * native browser events.
	   *
	   * @return {*} An accumulation of synthetic events.
	   * @internal
	   */
	  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	    var events;
	    var plugins = EventPluginRegistry.plugins;
	    for (var i = 0; i < plugins.length; i++) {
	      // Not every plugin in the ordering may be loaded at runtime.
	      var possiblePlugin = plugins[i];
	      if (possiblePlugin) {
	        var extractedEvents = possiblePlugin.extractEvents(topLevelType, targetInst, nativeEvent, nativeEventTarget);
	        if (extractedEvents) {
	          events = accumulateInto(events, extractedEvents);
	        }
	      }
	    }
	    return events;
	  },
	
	  /**
	   * Enqueues a synthetic event that should be dispatched when
	   * `processEventQueue` is invoked.
	   *
	   * @param {*} events An accumulation of synthetic events.
	   * @internal
	   */
	  enqueueEvents: function (events) {
	    if (events) {
	      eventQueue = accumulateInto(eventQueue, events);
	    }
	  },
	
	  /**
	   * Dispatches all synthetic events on the event queue.
	   *
	   * @internal
	   */
	  processEventQueue: function (simulated) {
	    // Set `eventQueue` to null before processing it so that we can tell if more
	    // events get enqueued while processing.
	    var processingEventQueue = eventQueue;
	    eventQueue = null;
	    if (simulated) {
	      forEachAccumulated(processingEventQueue, executeDispatchesAndReleaseSimulated);
	    } else {
	      forEachAccumulated(processingEventQueue, executeDispatchesAndReleaseTopLevel);
	    }
	    !!eventQueue ?  false ? invariant(false, 'processEventQueue(): Additional events were enqueued while processing an event queue. Support for this has not yet been implemented.') : _prodInvariant('95') : void 0;
	    // This would be a good time to rethrow if any of the event handlers threw.
	    ReactErrorUtils.rethrowCaughtError();
	  },
	
	  /**
	   * These are needed for tests only. Do not use!
	   */
	  __purge: function () {
	    listenerBank = {};
	  },
	
	  __getListenerBank: function () {
	    return listenerBank;
	  }
	};
	
	module.exports = EventPluginHub;

/***/ },
/* 145 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var EventPluginHub = __webpack_require__(144);
	var EventPluginUtils = __webpack_require__(251);
	
	var accumulateInto = __webpack_require__(400);
	var forEachAccumulated = __webpack_require__(401);
	var warning = __webpack_require__(30);
	
	var getListener = EventPluginHub.getListener;
	
	/**
	 * Some event types have a notion of different registration names for different
	 * "phases" of propagation. This finds listeners by a given phase.
	 */
	function listenerAtPhase(inst, event, propagationPhase) {
	  var registrationName = event.dispatchConfig.phasedRegistrationNames[propagationPhase];
	  return getListener(inst, registrationName);
	}
	
	/**
	 * Tags a `SyntheticEvent` with dispatched listeners. Creating this function
	 * here, allows us to not have to bind or create functions for each event.
	 * Mutating the event's members allows us to not have to create a wrapping
	 * "dispatch" object that pairs the event with the listener.
	 */
	function accumulateDirectionalDispatches(inst, phase, event) {
	  if (false) {
	    process.env.NODE_ENV !== 'production' ? warning(inst, 'Dispatching inst must not be null') : void 0;
	  }
	  var listener = listenerAtPhase(inst, event, phase);
	  if (listener) {
	    event._dispatchListeners = accumulateInto(event._dispatchListeners, listener);
	    event._dispatchInstances = accumulateInto(event._dispatchInstances, inst);
	  }
	}
	
	/**
	 * Collect dispatches (must be entirely collected before dispatching - see unit
	 * tests). Lazily allocate the array to conserve memory.  We must loop through
	 * each event and perform the traversal for each one. We cannot perform a
	 * single traversal for the entire collection of events because each event may
	 * have a different target.
	 */
	function accumulateTwoPhaseDispatchesSingle(event) {
	  if (event && event.dispatchConfig.phasedRegistrationNames) {
	    EventPluginUtils.traverseTwoPhase(event._targetInst, accumulateDirectionalDispatches, event);
	  }
	}
	
	/**
	 * Same as `accumulateTwoPhaseDispatchesSingle`, but skips over the targetID.
	 */
	function accumulateTwoPhaseDispatchesSingleSkipTarget(event) {
	  if (event && event.dispatchConfig.phasedRegistrationNames) {
	    var targetInst = event._targetInst;
	    var parentInst = targetInst ? EventPluginUtils.getParentInstance(targetInst) : null;
	    EventPluginUtils.traverseTwoPhase(parentInst, accumulateDirectionalDispatches, event);
	  }
	}
	
	/**
	 * Accumulates without regard to direction, does not look for phased
	 * registration names. Same as `accumulateDirectDispatchesSingle` but without
	 * requiring that the `dispatchMarker` be the same as the dispatched ID.
	 */
	function accumulateDispatches(inst, ignoredDirection, event) {
	  if (event && event.dispatchConfig.registrationName) {
	    var registrationName = event.dispatchConfig.registrationName;
	    var listener = getListener(inst, registrationName);
	    if (listener) {
	      event._dispatchListeners = accumulateInto(event._dispatchListeners, listener);
	      event._dispatchInstances = accumulateInto(event._dispatchInstances, inst);
	    }
	  }
	}
	
	/**
	 * Accumulates dispatches on an `SyntheticEvent`, but only for the
	 * `dispatchMarker`.
	 * @param {SyntheticEvent} event
	 */
	function accumulateDirectDispatchesSingle(event) {
	  if (event && event.dispatchConfig.registrationName) {
	    accumulateDispatches(event._targetInst, null, event);
	  }
	}
	
	function accumulateTwoPhaseDispatches(events) {
	  forEachAccumulated(events, accumulateTwoPhaseDispatchesSingle);
	}
	
	function accumulateTwoPhaseDispatchesSkipTarget(events) {
	  forEachAccumulated(events, accumulateTwoPhaseDispatchesSingleSkipTarget);
	}
	
	function accumulateEnterLeaveDispatches(leave, enter, from, to) {
	  EventPluginUtils.traverseEnterLeave(from, to, accumulateDispatches, leave, enter);
	}
	
	function accumulateDirectDispatches(events) {
	  forEachAccumulated(events, accumulateDirectDispatchesSingle);
	}
	
	/**
	 * A small set of propagation patterns, each of which will accept a small amount
	 * of information, and generate a set of "dispatch ready event objects" - which
	 * are sets of events that have already been annotated with a set of dispatched
	 * listener functions/ids. The API is designed this way to discourage these
	 * propagation strategies from actually executing the dispatches, since we
	 * always want to collect the entire set of dispatches before executing event a
	 * single one.
	 *
	 * @constructor EventPropagators
	 */
	var EventPropagators = {
	  accumulateTwoPhaseDispatches: accumulateTwoPhaseDispatches,
	  accumulateTwoPhaseDispatchesSkipTarget: accumulateTwoPhaseDispatchesSkipTarget,
	  accumulateDirectDispatches: accumulateDirectDispatches,
	  accumulateEnterLeaveDispatches: accumulateEnterLeaveDispatches
	};
	
	module.exports = EventPropagators;

/***/ },
/* 146 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	/**
	 * `ReactInstanceMap` maintains a mapping from a public facing stateful
	 * instance (key) and the internal representation (value). This allows public
	 * methods to accept the user facing instance as an argument and map them back
	 * to internal methods.
	 */
	
	// TODO: Replace this with ES6: var ReactInstanceMap = new Map();
	
	var ReactInstanceMap = {
	  /**
	   * This API should be called `delete` but we'd have to make sure to always
	   * transform these to strings for IE support. When this transform is fully
	   * supported we can rename it.
	   */
	  remove: function (key) {
	    key._reactInternalInstance = undefined;
	  },
	
	  get: function (key) {
	    return key._reactInternalInstance;
	  },
	
	  has: function (key) {
	    return key._reactInternalInstance !== undefined;
	  },
	
	  set: function (key, value) {
	    key._reactInternalInstance = value;
	  }
	};
	
	module.exports = ReactInstanceMap;

/***/ },
/* 147 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var SyntheticEvent = __webpack_require__(91);
	
	var getEventTarget = __webpack_require__(260);
	
	/**
	 * @interface UIEvent
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var UIEventInterface = {
	  view: function (event) {
	    if (event.view) {
	      return event.view;
	    }
	
	    var target = getEventTarget(event);
	    if (target.window === target) {
	      // target is a window object
	      return target;
	    }
	
	    var doc = target.ownerDocument;
	    // TODO: Figure out why `ownerDocument` is sometimes undefined in IE8.
	    if (doc) {
	      return doc.defaultView || doc.parentWindow;
	    } else {
	      return window;
	    }
	  },
	  detail: function (event) {
	    return event.detail || 0;
	  }
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticEvent}
	 */
	function SyntheticUIEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticEvent.augmentClass(SyntheticUIEvent, UIEventInterface);
	
	module.exports = SyntheticUIEvent;

/***/ },
/* 148 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.routes = exports.route = exports.components = exports.component = exports.history = undefined;
	exports.falsy = falsy;
	
	var _propTypes = __webpack_require__(2);
	
	function falsy(props, propName, componentName) {
	  if (props[propName]) return new Error('<' + componentName + '> should not have a "' + propName + '" prop');
	}
	
	var history = exports.history = (0, _propTypes.shape)({
	  listen: _propTypes.func.isRequired,
	  push: _propTypes.func.isRequired,
	  replace: _propTypes.func.isRequired,
	  go: _propTypes.func.isRequired,
	  goBack: _propTypes.func.isRequired,
	  goForward: _propTypes.func.isRequired
	});
	
	var component = exports.component = (0, _propTypes.oneOfType)([_propTypes.func, _propTypes.string]);
	var components = exports.components = (0, _propTypes.oneOfType)([component, _propTypes.object]);
	var route = exports.route = (0, _propTypes.oneOfType)([_propTypes.object, _propTypes.element]);
	var routes = exports.routes = (0, _propTypes.oneOfType)([route, (0, _propTypes.arrayOf)(route)]);

/***/ },
/* 149 */
29,
/* 150 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.setResourcesDisplay = setResourcesDisplay;
	exports.setResourcesProps = setResourcesProps;
	
	var _actionTypes = __webpack_require__(22);
	
	var types = _interopRequireWildcard(_actionTypes);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function setResourcesDisplay(displayResources) {
	    return { type: types.SET_RESOURCES_DISPLAY, displayResources: displayResources };
	}
	
	function setResourcesProps(resourceProps) {
	    return { type: types.SET_RESOURCES_PROPS, resourceProps: resourceProps };
	}

/***/ },
/* 151 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(5);
	
	var _redux = __webpack_require__(4);
	
	var _appHelper = __webpack_require__(3);
	
	var appHelper = _interopRequireWildcard(_appHelper);
	
	var _kpiHelper = __webpack_require__(35);
	
	var kpiHelper = _interopRequireWildcard(_kpiHelper);
	
	var _dataHelper = __webpack_require__(11);
	
	var dataHelper = _interopRequireWildcard(_dataHelper);
	
	var _appDataActions = __webpack_require__(12);
	
	var appDataActions = _interopRequireWildcard(_appDataActions);
	
	var _trackingDataActions = __webpack_require__(7);
	
	var trackingDataActions = _interopRequireWildcard(_trackingDataActions);
	
	var _gsap = __webpack_require__(8);
	
	var _gsapReactPlugin = __webpack_require__(10);
	
	var _gsapReactPlugin2 = _interopRequireDefault(_gsapReactPlugin);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var KpiResultReview = function (_React$Component) {
	    _inherits(KpiResultReview, _React$Component);
	
	    function KpiResultReview(props, context) {
	        _classCallCheck(this, KpiResultReview);
	
	        var _this = _possibleConstructorReturn(this, (KpiResultReview.__proto__ || Object.getPrototypeOf(KpiResultReview)).call(this, props, context));
	
	        _this.state = {
	            lang: props.lang,
	            kpiDefaults: _this.props.kpiDefaults,
	            kpi: props.kpi,
	            currentScoreRange: {
	                class: ""
	            },
	            showPointsIndicator: false,
	            locale: {},
	            guid: dataHelper.createGuid(),
	            updateScoreRange: false
	        };
	
	        _this.getLocale = _this.getLocale.bind(_this);
	        _this.setCurrentScoreRange = _this.setCurrentScoreRange.bind(_this);
	
	        return _this;
	    }
	
	    _createClass(KpiResultReview, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	
	            this.getLocale();
	            this.setCurrentScoreRange();
	        }
	    }, {
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(nextProps) {
	            if (this.state.lang !== nextProps.lang) {
	                this.setState({
	                    lang: nextProps.lang,
	                    locale: appHelper.getLocalData(this.state.kpiDefaults)
	                });
	            }
	
	            if (this.state.kpi !== nextProps.kpi) {
	                this.setState({
	                    kpi: Object.assign({}, nextProps.kpi),
	                    updateScoreRange: true
	                });
	            }
	        }
	    }, {
	        key: 'componentDidUpdate',
	        value: function componentDidUpdate() {
	            if (this.state.updateScoreRange) {
	                this.setCurrentScoreRange();
	            }
	        }
	    }, {
	        key: 'getLocale',
	        value: function getLocale() {
	            this.setState({ locale: appHelper.getLocalData(this.state.kpiDefaults) });
	        }
	    }, {
	        key: 'setCurrentScoreRange',
	        value: function setCurrentScoreRange() {
	            this.setState({
	                updateScoreRange: false
	            });
	            if (appHelper.isDefined(appHelper.isDefined(this.state.kpi))) {
	                var currentScoreRange = {};
	                if (appHelper.isDefined(this.state.kpi.kpi_id)) {
	                    currentScoreRange = kpiHelper.getKpiPointsIndicatorClass(this.state.kpi.value, this.state.kpi.kpi_id);
	                } else {
	                    currentScoreRange = kpiHelper.getKpiPointsIndicatorClass(this.state.kpi.value, this.state.kpiDefaults.kpi_id);
	                }
	                this.setState({
	                    currentScoreRange: Object.assign({}, currentScoreRange)
	                });
	            }
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            return appHelper.isDefined(this.props.kpi) ? _react2.default.createElement(
	                'div',
	                { className: 'kpi-points-review-awarded guroo-kpi-label ' + this.state.currentScoreRange.class },
	                _react2.default.createElement('div', { className: 'kpi-result' }),
	                this.state.locale.long_title
	            ) : null;
	        }
	    }]);
	
	    return KpiResultReview;
	}(_react2.default.Component);
	
	KpiResultReview.propTypes = {
	    kpiDefaults: _propTypes2.default.object.isRequired,
	    meterParams: _propTypes2.default.object,
	    kpi: _propTypes2.default.object,
	    lang: _propTypes2.default.string.isRequired
	
	};
	
	KpiResultReview.contextTypes = {
	    router: _propTypes2.default.object
	};
	
	function mapStateToProps(state, ownProps) {
	    var lang = state.userData.lang;
	    return {
	        lang: lang
	
	    };
	}
	
	function mapDispatchToProps(dispatch) {
	    return {
	        actions: (0, _redux.bindActionCreators)(Object.assign({}, trackingDataActions, appDataActions), dispatch)
	    };
	}
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(KpiResultReview);

/***/ },
/* 152 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.validateEmail = validateEmail;
	exports.validatePassword = validatePassword;
	exports.validateLowercaseNoSpaces = validateLowercaseNoSpaces;
	exports.checkPasswordsMatch = checkPasswordsMatch;
	exports.validateLength = validateLength;
	exports.validatePasswordCritea = validatePasswordCritea;
	function validateEmail(email) {
	    if (!checkEmail(email)) {
	        return {
	            result: false,
	            message: "Please enter a valid email address!"
	        };
	    }
	    return {
	        result: true,
	        message: "valid"
	    };
	}
	
	function validatePassword(pwd1) {
	
	    if (!checkPassword(pwd1)) {
	        return {
	            result: false,
	            message: " must contain at least 8 characters, including UPPER/lowercase and numbers."
	        };
	    }
	
	    return {
	        result: true,
	        message: "valid"
	    };
	}
	
	function validateLowercaseNoSpaces(val) {
	
	    if (!checkLowercaseNoSpaces(val)) {
	        return {
	            result: false,
	            message: " must not contain uppercase characters or spaces."
	        };
	    }
	
	    return {
	        result: true,
	        message: "valid"
	    };
	}
	
	function checkPasswordsMatch(pwd1, pwd2) {
	    if (pwd1.length === 0 || pwd2.length === 0 || pwd1 !== pwd2) {
	        return {
	            result: false,
	            message: "Please check that you've entered and confirmed your password!"
	        };
	    }
	    return {
	        result: true,
	        message: "valid"
	    };
	}
	
	function validateLength(string) {
	    if (string.length === 0) {
	        return {
	            result: false,
	            message: "must not be empty."
	        };
	    }
	    return {
	        result: true,
	        message: "valid"
	    };
	}
	
	function validatePasswordCritea(pwd) {
	    var exceedMinLength = pwd.length >= 8;
	    var containsLowercase = checkContainsLower(pwd);
	    var containsUppercase = checkContainsUpper(pwd);
	    var containsNumeric = checkContainsNumeric(pwd);
	    var isValid = false;
	
	    if (exceedMinLength && containsLowercase && containsUppercase && containsNumeric) {
	        isValid = true;
	    }
	    return {
	        isValid: isValid,
	        exceedMinLength: exceedMinLength,
	        containsLowercase: containsLowercase,
	        containsUppercase: containsUppercase,
	        containsNumeric: containsNumeric
	    };
	}
	
	//private
	function checkEmail(srt) {
	    var re = /^(([^<>()\\[\]\\.,;:\s@"]+(\.[^<>()\\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
	    var res = /^(([^<>()\\[\]\\.,;:\s@"]+(\.[^<>()\\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
	    var bitch = /^(.+):\/\/([^:\\/]*):?(\d+)?(\/.*)?$/;
	
	    return re.test(srt);
	}
	
	function checkPassword(str) {
	    var re = /(?=.*\d)(?=.*[a-z])(?=.*[A-Z]).{8,}/;
	    return re.test(str);
	}
	
	function checkContainsLower(str) {
	    var re = /(?=.*[a-z])/;
	    return re.test(str);
	}
	
	function checkContainsUpper(str) {
	    var re = /(?=.*[A-Z])/;
	    return re.test(str);
	}
	
	function checkContainsNumeric(str) {
	    var re = /(?=.*\d)/;
	    return re.test(str);
	}
	
	function checkLowercaseNoSpaces(str) {
	    var re = /^[a-z0-9]+(\s+[a-z0-9]+)?$/;
	    return re.test(str);
	}

/***/ },
/* 153 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.getNavigation = getNavigation;
	exports.getPageNavigation = getPageNavigation;
	
	var _navigationModels = __webpack_require__(558);
	
	var navigationModels = _interopRequireWildcard(_navigationModels);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function getNavigation(constant) {
	    var navigation = navigationModels.NAVIGATION_TYPES.filter(function (navigation) {
	        return navigation.constant == constant;
	    });
	    if (navigation) return navigation[0]; //since filter returns an array, have to grab the first.
	    return null;
	}
	
	function getPageNavigation(constant, newPageTitle, paramId) {
	    return new Promise(function (resolve, reject) {
	
	        var navigation = getNavigation(constant);
	        var navObject = {};
	        if (typeof newPageTitle !== 'undefined') {
	            navObject = Object.assign({}, navigation, {
	                pageTitle: newPageTitle
	            });
	        } else {
	            navObject = Object.assign({}, navigation);
	        }
	
	        if (typeof paramId !== 'undefined') {
	
	            navObject = Object.assign({}, navObject, {
	                paramId: paramId.toString()
	            });
	
	            for (var i = 0; i < navObject.secondaryNav.length; i++) {
	                var nav = Object.assign({}, navObject.secondaryNav[i], {
	                    path: navObject.secondaryNav[i].path + '/' + paramId
	                });
	            }
	        }
	
	        resolve(navObject);
	    });
	}

/***/ },
/* 154 */
/***/ function(module, exports, __webpack_require__) {

	// false -> Array#indexOf
	// true  -> Array#includes
	var toIObject = __webpack_require__(61);
	var toLength = __webpack_require__(40);
	var toAbsoluteIndex = __webpack_require__(110);
	module.exports = function (IS_INCLUDES) {
	  return function ($this, el, fromIndex) {
	    var O = toIObject($this);
	    var length = toLength(O.length);
	    var index = toAbsoluteIndex(fromIndex, length);
	    var value;
	    // Array#includes uses SameValueZero equality algorithm
	    // eslint-disable-next-line no-self-compare
	    if (IS_INCLUDES && el != el) while (length > index) {
	      value = O[index++];
	      // eslint-disable-next-line no-self-compare
	      if (value != value) return true;
	    // Array#indexOf ignores holes, Array#includes - not
	    } else for (;length > index; index++) if (IS_INCLUDES || index in O) {
	      if (O[index] === el) return IS_INCLUDES || index || 0;
	    } return !IS_INCLUDES && -1;
	  };
	};


/***/ },
/* 155 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var global = __webpack_require__(24);
	var $export = __webpack_require__(6);
	var redefine = __webpack_require__(53);
	var redefineAll = __webpack_require__(108);
	var meta = __webpack_require__(97);
	var forOf = __webpack_require__(103);
	var anInstance = __webpack_require__(102);
	var isObject = __webpack_require__(27);
	var fails = __webpack_require__(26);
	var $iterDetect = __webpack_require__(160);
	var setToStringTag = __webpack_require__(117);
	var inheritIfRequired = __webpack_require__(212);
	
	module.exports = function (NAME, wrapper, methods, common, IS_MAP, IS_WEAK) {
	  var Base = global[NAME];
	  var C = Base;
	  var ADDER = IS_MAP ? 'set' : 'add';
	  var proto = C && C.prototype;
	  var O = {};
	  var fixMethod = function (KEY) {
	    var fn = proto[KEY];
	    redefine(proto, KEY,
	      KEY == 'delete' ? function (a) {
	        return IS_WEAK && !isObject(a) ? false : fn.call(this, a === 0 ? 0 : a);
	      } : KEY == 'has' ? function has(a) {
	        return IS_WEAK && !isObject(a) ? false : fn.call(this, a === 0 ? 0 : a);
	      } : KEY == 'get' ? function get(a) {
	        return IS_WEAK && !isObject(a) ? undefined : fn.call(this, a === 0 ? 0 : a);
	      } : KEY == 'add' ? function add(a) { fn.call(this, a === 0 ? 0 : a); return this; }
	        : function set(a, b) { fn.call(this, a === 0 ? 0 : a, b); return this; }
	    );
	  };
	  if (typeof C != 'function' || !(IS_WEAK || proto.forEach && !fails(function () {
	    new C().entries().next();
	  }))) {
	    // create collection constructor
	    C = common.getConstructor(wrapper, NAME, IS_MAP, ADDER);
	    redefineAll(C.prototype, methods);
	    meta.NEED = true;
	  } else {
	    var instance = new C();
	    // early implementations not supports chaining
	    var HASNT_CHAINING = instance[ADDER](IS_WEAK ? {} : -0, 1) != instance;
	    // V8 ~  Chromium 40- weak-collections throws on primitives, but should return false
	    var THROWS_ON_PRIMITIVES = fails(function () { instance.has(1); });
	    // most early implementations doesn't supports iterables, most modern - not close it correctly
	    var ACCEPT_ITERABLES = $iterDetect(function (iter) { new C(iter); }); // eslint-disable-line no-new
	    // for early implementations -0 and +0 not the same
	    var BUGGY_ZERO = !IS_WEAK && fails(function () {
	      // V8 ~ Chromium 42- fails only with 5+ elements
	      var $instance = new C();
	      var index = 5;
	      while (index--) $instance[ADDER](index, index);
	      return !$instance.has(-0);
	    });
	    if (!ACCEPT_ITERABLES) {
	      C = wrapper(function (target, iterable) {
	        anInstance(target, C, NAME);
	        var that = inheritIfRequired(new Base(), target, C);
	        if (iterable != undefined) forOf(iterable, IS_MAP, that[ADDER], that);
	        return that;
	      });
	      C.prototype = proto;
	      proto.constructor = C;
	    }
	    if (THROWS_ON_PRIMITIVES || BUGGY_ZERO) {
	      fixMethod('delete');
	      fixMethod('has');
	      IS_MAP && fixMethod('get');
	    }
	    if (BUGGY_ZERO || HASNT_CHAINING) fixMethod(ADDER);
	    // weak collections should not contains .clear method
	    if (IS_WEAK && proto.clear) delete proto.clear;
	  }
	
	  setToStringTag(C, NAME);
	
	  O[NAME] = C;
	  $export($export.G + $export.W + $export.F * (C != Base), O);
	
	  if (!IS_WEAK) common.setStrong(C, NAME, IS_MAP);
	
	  return C;
	};


/***/ },
/* 156 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var hide = __webpack_require__(52);
	var redefine = __webpack_require__(53);
	var fails = __webpack_require__(26);
	var defined = __webpack_require__(76);
	var wks = __webpack_require__(34);
	
	module.exports = function (KEY, length, exec) {
	  var SYMBOL = wks(KEY);
	  var fns = exec(defined, SYMBOL, ''[KEY]);
	  var strfn = fns[0];
	  var rxfn = fns[1];
	  if (fails(function () {
	    var O = {};
	    O[SYMBOL] = function () { return 7; };
	    return ''[KEY](O) != 7;
	  })) {
	    redefine(String.prototype, KEY, strfn);
	    hide(RegExp.prototype, SYMBOL, length == 2
	      // 21.2.5.8 RegExp.prototype[@@replace](string, replaceValue)
	      // 21.2.5.11 RegExp.prototype[@@split](string, limit)
	      ? function (string, arg) { return rxfn.call(string, this, arg); }
	      // 21.2.5.6 RegExp.prototype[@@match](string)
	      // 21.2.5.9 RegExp.prototype[@@search](string)
	      : function (string) { return rxfn.call(string, this); }
	    );
	  }
	};


/***/ },
/* 157 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// 21.2.5.3 get RegExp.prototype.flags
	var anObject = __webpack_require__(23);
	module.exports = function () {
	  var that = anObject(this);
	  var result = '';
	  if (that.global) result += 'g';
	  if (that.ignoreCase) result += 'i';
	  if (that.multiline) result += 'm';
	  if (that.unicode) result += 'u';
	  if (that.sticky) result += 'y';
	  return result;
	};


/***/ },
/* 158 */
/***/ function(module, exports, __webpack_require__) {

	// 7.2.2 IsArray(argument)
	var cof = __webpack_require__(69);
	module.exports = Array.isArray || function isArray(arg) {
	  return cof(arg) == 'Array';
	};


/***/ },
/* 159 */
/***/ function(module, exports, __webpack_require__) {

	// 7.2.8 IsRegExp(argument)
	var isObject = __webpack_require__(27);
	var cof = __webpack_require__(69);
	var MATCH = __webpack_require__(34)('match');
	module.exports = function (it) {
	  var isRegExp;
	  return isObject(it) && ((isRegExp = it[MATCH]) !== undefined ? !!isRegExp : cof(it) == 'RegExp');
	};


/***/ },
/* 160 */
/***/ function(module, exports, __webpack_require__) {

	var ITERATOR = __webpack_require__(34)('iterator');
	var SAFE_CLOSING = false;
	
	try {
	  var riter = [7][ITERATOR]();
	  riter['return'] = function () { SAFE_CLOSING = true; };
	  // eslint-disable-next-line no-throw-literal
	  Array.from(riter, function () { throw 2; });
	} catch (e) { /* empty */ }
	
	module.exports = function (exec, skipClosing) {
	  if (!skipClosing && !SAFE_CLOSING) return false;
	  var safe = false;
	  try {
	    var arr = [7];
	    var iter = arr[ITERATOR]();
	    iter.next = function () { return { done: safe = true }; };
	    arr[ITERATOR] = function () { return iter; };
	    exec(arr);
	  } catch (e) { /* empty */ }
	  return safe;
	};


/***/ },
/* 161 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// Forced replacement prototype accessors methods
	module.exports = __webpack_require__(96) || !__webpack_require__(26)(function () {
	  var K = Math.random();
	  // In FF throws only define methods
	  // eslint-disable-next-line no-undef, no-useless-call
	  __defineSetter__.call(null, K, function () { /* empty */ });
	  delete __webpack_require__(24)[K];
	});


/***/ },
/* 162 */
/***/ function(module, exports) {

	exports.f = Object.getOwnPropertySymbols;


/***/ },
/* 163 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// https://tc39.github.io/proposal-setmap-offrom/
	var $export = __webpack_require__(6);
	var aFunction = __webpack_require__(50);
	var ctx = __webpack_require__(71);
	var forOf = __webpack_require__(103);
	
	module.exports = function (COLLECTION) {
	  $export($export.S, COLLECTION, { from: function from(source /* , mapFn, thisArg */) {
	    var mapFn = arguments[1];
	    var mapping, A, n, cb;
	    aFunction(this);
	    mapping = mapFn !== undefined;
	    if (mapping) aFunction(mapFn);
	    if (source == undefined) return new this();
	    A = [];
	    if (mapping) {
	      n = 0;
	      cb = ctx(mapFn, arguments[2], 2);
	      forOf(source, false, function (nextItem) {
	        A.push(cb(nextItem, n++));
	      });
	    } else {
	      forOf(source, false, A.push, A);
	    }
	    return new this(A);
	  } });
	};


/***/ },
/* 164 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// https://tc39.github.io/proposal-setmap-offrom/
	var $export = __webpack_require__(6);
	
	module.exports = function (COLLECTION) {
	  $export($export.S, COLLECTION, { of: function of() {
	    var length = arguments.length;
	    var A = new Array(length);
	    while (length--) A[length] = arguments[length];
	    return new this(A);
	  } });
	};


/***/ },
/* 165 */
/***/ function(module, exports, __webpack_require__) {

	var core = __webpack_require__(70);
	var global = __webpack_require__(24);
	var SHARED = '__core-js_shared__';
	var store = global[SHARED] || (global[SHARED] = {});
	
	(module.exports = function (key, value) {
	  return store[key] || (store[key] = value !== undefined ? value : {});
	})('versions', []).push({
	  version: core.version,
	  mode: __webpack_require__(96) ? 'pure' : 'global',
	  copyright: '© 2018 Denis Pushkarev (zloirock.ru)'
	});


/***/ },
/* 166 */
/***/ function(module, exports, __webpack_require__) {

	// 7.3.20 SpeciesConstructor(O, defaultConstructor)
	var anObject = __webpack_require__(23);
	var aFunction = __webpack_require__(50);
	var SPECIES = __webpack_require__(34)('species');
	module.exports = function (O, D) {
	  var C = anObject(O).constructor;
	  var S;
	  return C === undefined || (S = anObject(C)[SPECIES]) == undefined ? D : aFunction(S);
	};


/***/ },
/* 167 */
/***/ function(module, exports, __webpack_require__) {

	var global = __webpack_require__(24);
	var hide = __webpack_require__(52);
	var uid = __webpack_require__(111);
	var TYPED = uid('typed_array');
	var VIEW = uid('view');
	var ABV = !!(global.ArrayBuffer && global.DataView);
	var CONSTR = ABV;
	var i = 0;
	var l = 9;
	var Typed;
	
	var TypedArrayConstructors = (
	  'Int8Array,Uint8Array,Uint8ClampedArray,Int16Array,Uint16Array,Int32Array,Uint32Array,Float32Array,Float64Array'
	).split(',');
	
	while (i < l) {
	  if (Typed = global[TypedArrayConstructors[i++]]) {
	    hide(Typed.prototype, TYPED, true);
	    hide(Typed.prototype, VIEW, true);
	  } else CONSTR = false;
	}
	
	module.exports = {
	  ABV: ABV,
	  CONSTR: CONSTR,
	  TYPED: TYPED,
	  VIEW: VIEW
	};


/***/ },
/* 168 */
/***/ function(module, exports, __webpack_require__) {

	var global = __webpack_require__(24);
	var navigator = global.navigator;
	
	module.exports = navigator && navigator.userAgent || '';


/***/ },
/* 169 */
/***/ function(module, exports, __webpack_require__) {

	;(function (root, factory) {
		if (true) {
			// CommonJS
			module.exports = exports = factory(__webpack_require__(25));
		}
		else if (typeof define === "function" && define.amd) {
			// AMD
			define(["./core"], factory);
		}
		else {
			// Global (browser)
			factory(root.CryptoJS);
		}
	}(this, function (CryptoJS) {
	
		(function (undefined) {
		    // Shortcuts
		    var C = CryptoJS;
		    var C_lib = C.lib;
		    var Base = C_lib.Base;
		    var X32WordArray = C_lib.WordArray;
	
		    /**
		     * x64 namespace.
		     */
		    var C_x64 = C.x64 = {};
	
		    /**
		     * A 64-bit word.
		     */
		    var X64Word = C_x64.Word = Base.extend({
		        /**
		         * Initializes a newly created 64-bit word.
		         *
		         * @param {number} high The high 32 bits.
		         * @param {number} low The low 32 bits.
		         *
		         * @example
		         *
		         *     var x64Word = CryptoJS.x64.Word.create(0x00010203, 0x04050607);
		         */
		        init: function (high, low) {
		            this.high = high;
		            this.low = low;
		        }
	
		        /**
		         * Bitwise NOTs this word.
		         *
		         * @return {X64Word} A new x64-Word object after negating.
		         *
		         * @example
		         *
		         *     var negated = x64Word.not();
		         */
		        // not: function () {
		            // var high = ~this.high;
		            // var low = ~this.low;
	
		            // return X64Word.create(high, low);
		        // },
	
		        /**
		         * Bitwise ANDs this word with the passed word.
		         *
		         * @param {X64Word} word The x64-Word to AND with this word.
		         *
		         * @return {X64Word} A new x64-Word object after ANDing.
		         *
		         * @example
		         *
		         *     var anded = x64Word.and(anotherX64Word);
		         */
		        // and: function (word) {
		            // var high = this.high & word.high;
		            // var low = this.low & word.low;
	
		            // return X64Word.create(high, low);
		        // },
	
		        /**
		         * Bitwise ORs this word with the passed word.
		         *
		         * @param {X64Word} word The x64-Word to OR with this word.
		         *
		         * @return {X64Word} A new x64-Word object after ORing.
		         *
		         * @example
		         *
		         *     var ored = x64Word.or(anotherX64Word);
		         */
		        // or: function (word) {
		            // var high = this.high | word.high;
		            // var low = this.low | word.low;
	
		            // return X64Word.create(high, low);
		        // },
	
		        /**
		         * Bitwise XORs this word with the passed word.
		         *
		         * @param {X64Word} word The x64-Word to XOR with this word.
		         *
		         * @return {X64Word} A new x64-Word object after XORing.
		         *
		         * @example
		         *
		         *     var xored = x64Word.xor(anotherX64Word);
		         */
		        // xor: function (word) {
		            // var high = this.high ^ word.high;
		            // var low = this.low ^ word.low;
	
		            // return X64Word.create(high, low);
		        // },
	
		        /**
		         * Shifts this word n bits to the left.
		         *
		         * @param {number} n The number of bits to shift.
		         *
		         * @return {X64Word} A new x64-Word object after shifting.
		         *
		         * @example
		         *
		         *     var shifted = x64Word.shiftL(25);
		         */
		        // shiftL: function (n) {
		            // if (n < 32) {
		                // var high = (this.high << n) | (this.low >>> (32 - n));
		                // var low = this.low << n;
		            // } else {
		                // var high = this.low << (n - 32);
		                // var low = 0;
		            // }
	
		            // return X64Word.create(high, low);
		        // },
	
		        /**
		         * Shifts this word n bits to the right.
		         *
		         * @param {number} n The number of bits to shift.
		         *
		         * @return {X64Word} A new x64-Word object after shifting.
		         *
		         * @example
		         *
		         *     var shifted = x64Word.shiftR(7);
		         */
		        // shiftR: function (n) {
		            // if (n < 32) {
		                // var low = (this.low >>> n) | (this.high << (32 - n));
		                // var high = this.high >>> n;
		            // } else {
		                // var low = this.high >>> (n - 32);
		                // var high = 0;
		            // }
	
		            // return X64Word.create(high, low);
		        // },
	
		        /**
		         * Rotates this word n bits to the left.
		         *
		         * @param {number} n The number of bits to rotate.
		         *
		         * @return {X64Word} A new x64-Word object after rotating.
		         *
		         * @example
		         *
		         *     var rotated = x64Word.rotL(25);
		         */
		        // rotL: function (n) {
		            // return this.shiftL(n).or(this.shiftR(64 - n));
		        // },
	
		        /**
		         * Rotates this word n bits to the right.
		         *
		         * @param {number} n The number of bits to rotate.
		         *
		         * @return {X64Word} A new x64-Word object after rotating.
		         *
		         * @example
		         *
		         *     var rotated = x64Word.rotR(7);
		         */
		        // rotR: function (n) {
		            // return this.shiftR(n).or(this.shiftL(64 - n));
		        // },
	
		        /**
		         * Adds this word with the passed word.
		         *
		         * @param {X64Word} word The x64-Word to add with this word.
		         *
		         * @return {X64Word} A new x64-Word object after adding.
		         *
		         * @example
		         *
		         *     var added = x64Word.add(anotherX64Word);
		         */
		        // add: function (word) {
		            // var low = (this.low + word.low) | 0;
		            // var carry = (low >>> 0) < (this.low >>> 0) ? 1 : 0;
		            // var high = (this.high + word.high + carry) | 0;
	
		            // return X64Word.create(high, low);
		        // }
		    });
	
		    /**
		     * An array of 64-bit words.
		     *
		     * @property {Array} words The array of CryptoJS.x64.Word objects.
		     * @property {number} sigBytes The number of significant bytes in this word array.
		     */
		    var X64WordArray = C_x64.WordArray = Base.extend({
		        /**
		         * Initializes a newly created word array.
		         *
		         * @param {Array} words (Optional) An array of CryptoJS.x64.Word objects.
		         * @param {number} sigBytes (Optional) The number of significant bytes in the words.
		         *
		         * @example
		         *
		         *     var wordArray = CryptoJS.x64.WordArray.create();
		         *
		         *     var wordArray = CryptoJS.x64.WordArray.create([
		         *         CryptoJS.x64.Word.create(0x00010203, 0x04050607),
		         *         CryptoJS.x64.Word.create(0x18191a1b, 0x1c1d1e1f)
		         *     ]);
		         *
		         *     var wordArray = CryptoJS.x64.WordArray.create([
		         *         CryptoJS.x64.Word.create(0x00010203, 0x04050607),
		         *         CryptoJS.x64.Word.create(0x18191a1b, 0x1c1d1e1f)
		         *     ], 10);
		         */
		        init: function (words, sigBytes) {
		            words = this.words = words || [];
	
		            if (sigBytes != undefined) {
		                this.sigBytes = sigBytes;
		            } else {
		                this.sigBytes = words.length * 8;
		            }
		        },
	
		        /**
		         * Converts this 64-bit word array to a 32-bit word array.
		         *
		         * @return {CryptoJS.lib.WordArray} This word array's data as a 32-bit word array.
		         *
		         * @example
		         *
		         *     var x32WordArray = x64WordArray.toX32();
		         */
		        toX32: function () {
		            // Shortcuts
		            var x64Words = this.words;
		            var x64WordsLength = x64Words.length;
	
		            // Convert
		            var x32Words = [];
		            for (var i = 0; i < x64WordsLength; i++) {
		                var x64Word = x64Words[i];
		                x32Words.push(x64Word.high);
		                x32Words.push(x64Word.low);
		            }
	
		            return X32WordArray.create(x32Words, this.sigBytes);
		        },
	
		        /**
		         * Creates a copy of this word array.
		         *
		         * @return {X64WordArray} The clone.
		         *
		         * @example
		         *
		         *     var clone = x64WordArray.clone();
		         */
		        clone: function () {
		            var clone = Base.clone.call(this);
	
		            // Clone "words" array
		            var words = clone.words = this.words.slice(0);
	
		            // Clone each X64Word object
		            var wordsLength = words.length;
		            for (var i = 0; i < wordsLength; i++) {
		                words[i] = words[i].clone();
		            }
	
		            return clone;
		        }
		    });
		}());
	
	
		return CryptoJS;
	
	}));

/***/ },
/* 170 */
/***/ function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {var win;
	
	if (typeof window !== "undefined") {
	    win = window;
	} else if (typeof global !== "undefined") {
	    win = global;
	} else if (typeof self !== "undefined"){
	    win = self;
	} else {
	    win = {};
	}
	
	module.exports = win;
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 171 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(global) {/*!
	 * VERSION: 1.20.5
	 * DATE: 2018-05-21
	 * UPDATES AND DOCS AT: http://greensock.com
	 *
	 * @license Copyright (c) 2008-2018, GreenSock. All rights reserved.
	 * This work is subject to the terms at http://greensock.com/standard-license or for
	 * Club GreenSock members, the software agreement that was issued with your membership.
	 * 
	 * @author: Jack Doyle, jack@greensock.com
	 */
	(function(window, moduleName) {
	
			"use strict";
			var _exports = {},
				_doc = window.document,
				_globals = window.GreenSockGlobals = window.GreenSockGlobals || window;
			if (_globals.TweenLite) {
				return _globals.TweenLite; //in case the core set of classes is already loaded, don't instantiate twice.
			}
			var _namespace = function(ns) {
					var a = ns.split("."),
						p = _globals, i;
					for (i = 0; i < a.length; i++) {
						p[a[i]] = p = p[a[i]] || {};
					}
					return p;
				},
				gs = _namespace("com.greensock"),
				_tinyNum = 0.0000000001,
				_slice = function(a) { //don't use Array.prototype.slice.call(target, 0) because that doesn't work in IE8 with a NodeList that's returned by querySelectorAll()
					var b = [],
						l = a.length,
						i;
					for (i = 0; i !== l; b.push(a[i++])) {}
					return b;
				},
				_emptyFunc = function() {},
				_isArray = (function() { //works around issues in iframe environments where the Array global isn't shared, thus if the object originates in a different window/iframe, "(obj instanceof Array)" will evaluate false. We added some speed optimizations to avoid Object.prototype.toString.call() unless it's absolutely necessary because it's VERY slow (like 20x slower)
					var toString = Object.prototype.toString,
						array = toString.call([]);
					return function(obj) {
						return obj != null && (obj instanceof Array || (typeof(obj) === "object" && !!obj.push && toString.call(obj) === array));
					};
				}()),
				a, i, p, _ticker, _tickerActive,
				_defLookup = {},
	
				/**
				 * @constructor
				 * Defines a GreenSock class, optionally with an array of dependencies that must be instantiated first and passed into the definition.
				 * This allows users to load GreenSock JS files in any order even if they have interdependencies (like CSSPlugin extends TweenPlugin which is
				 * inside TweenLite.js, but if CSSPlugin is loaded first, it should wait to run its code until TweenLite.js loads and instantiates TweenPlugin
				 * and then pass TweenPlugin to CSSPlugin's definition). This is all done automatically and internally.
				 *
				 * Every definition will be added to a "com.greensock" global object (typically window, but if a window.GreenSockGlobals object is found,
				 * it will go there as of v1.7). For example, TweenLite will be found at window.com.greensock.TweenLite and since it's a global class that should be available anywhere,
				 * it is ALSO referenced at window.TweenLite. However some classes aren't considered global, like the base com.greensock.core.Animation class, so
				 * those will only be at the package like window.com.greensock.core.Animation. Again, if you define a GreenSockGlobals object on the window, everything
				 * gets tucked neatly inside there instead of on the window directly. This allows you to do advanced things like load multiple versions of GreenSock
				 * files and put them into distinct objects (imagine a banner ad uses a newer version but the main site uses an older one). In that case, you could
				 * sandbox the banner one like:
				 *
				 * <script>
				 *     var gs = window.GreenSockGlobals = {}; //the newer version we're about to load could now be referenced in a "gs" object, like gs.TweenLite.to(...). Use whatever alias you want as long as it's unique, "gs" or "banner" or whatever.
				 * </script>
				 * <script src="js/greensock/v1.7/TweenMax.js"></script>
				 * <script>
				 *     window.GreenSockGlobals = window._gsQueue = window._gsDefine = null; //reset it back to null (along with the special _gsQueue variable) so that the next load of TweenMax affects the window and we can reference things directly like TweenLite.to(...)
				 * </script>
				 * <script src="js/greensock/v1.6/TweenMax.js"></script>
				 * <script>
				 *     gs.TweenLite.to(...); //would use v1.7
				 *     TweenLite.to(...); //would use v1.6
				 * </script>
				 *
				 * @param {!string} ns The namespace of the class definition, leaving off "com.greensock." as that's assumed. For example, "TweenLite" or "plugins.CSSPlugin" or "easing.Back".
				 * @param {!Array.<string>} dependencies An array of dependencies (described as their namespaces minus "com.greensock." prefix). For example ["TweenLite","plugins.TweenPlugin","core.Animation"]
				 * @param {!function():Object} func The function that should be called and passed the resolved dependencies which will return the actual class for this definition.
				 * @param {boolean=} global If true, the class will be added to the global scope (typically window unless you define a window.GreenSockGlobals object)
				 */
				Definition = function(ns, dependencies, func, global) {
					this.sc = (_defLookup[ns]) ? _defLookup[ns].sc : []; //subclasses
					_defLookup[ns] = this;
					this.gsClass = null;
					this.func = func;
					var _classes = [];
					this.check = function(init) {
						var i = dependencies.length,
							missing = i,
							cur, a, n, cl;
						while (--i > -1) {
							if ((cur = _defLookup[dependencies[i]] || new Definition(dependencies[i], [])).gsClass) {
								_classes[i] = cur.gsClass;
								missing--;
							} else if (init) {
								cur.sc.push(this);
							}
						}
						if (missing === 0 && func) {
							a = ("com.greensock." + ns).split(".");
							n = a.pop();
							cl = _namespace(a.join("."))[n] = this.gsClass = func.apply(func, _classes);
	
							//exports to multiple environments
							if (global) {
								_globals[n] = _exports[n] = cl; //provides a way to avoid global namespace pollution. By default, the main classes like TweenLite, Power1, Strong, etc. are added to window unless a GreenSockGlobals is defined. So if you want to have things added to a custom object instead, just do something like window.GreenSockGlobals = {} before loading any GreenSock files. You can even set up an alias like window.GreenSockGlobals = windows.gs = {} so that you can access everything like gs.TweenLite. Also remember that ALL classes are added to the window.com.greensock object (in their respective packages, like com.greensock.easing.Power1, com.greensock.TweenLite, etc.)
								if (typeof(module) !== "undefined" && module.exports) { //node
									if (ns === moduleName) {
										module.exports = _exports[moduleName] = cl;
										for (i in _exports) {
											cl[i] = _exports[i];
										}
									} else if (_exports[moduleName]) {
										_exports[moduleName][n] = cl;
									}
								} else if (true){ //AMD
									!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function() { return cl; }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
								}
							}
							for (i = 0; i < this.sc.length; i++) {
								this.sc[i].check();
							}
						}
					};
					this.check(true);
				},
	
				//used to create Definition instances (which basically registers a class that has dependencies).
				_gsDefine = window._gsDefine = function(ns, dependencies, func, global) {
					return new Definition(ns, dependencies, func, global);
				},
	
				//a quick way to create a class that doesn't have any dependencies. Returns the class, but first registers it in the GreenSock namespace so that other classes can grab it (other classes might be dependent on the class).
				_class = gs._class = function(ns, func, global) {
					func = func || function() {};
					_gsDefine(ns, [], function(){ return func; }, global);
					return func;
				};
	
			_gsDefine.globals = _globals;
	
	
	
	/*
	 * ----------------------------------------------------------------
	 * Ease
	 * ----------------------------------------------------------------
	 */
			var _baseParams = [0, 0, 1, 1],
				Ease = _class("easing.Ease", function(func, extraParams, type, power) {
					this._func = func;
					this._type = type || 0;
					this._power = power || 0;
					this._params = extraParams ? _baseParams.concat(extraParams) : _baseParams;
				}, true),
				_easeMap = Ease.map = {},
				_easeReg = Ease.register = function(ease, names, types, create) {
					var na = names.split(","),
						i = na.length,
						ta = (types || "easeIn,easeOut,easeInOut").split(","),
						e, name, j, type;
					while (--i > -1) {
						name = na[i];
						e = create ? _class("easing."+name, null, true) : gs.easing[name] || {};
						j = ta.length;
						while (--j > -1) {
							type = ta[j];
							_easeMap[name + "." + type] = _easeMap[type + name] = e[type] = ease.getRatio ? ease : ease[type] || new ease();
						}
					}
				};
	
			p = Ease.prototype;
			p._calcEnd = false;
			p.getRatio = function(p) {
				if (this._func) {
					this._params[0] = p;
					return this._func.apply(null, this._params);
				}
				var t = this._type,
					pw = this._power,
					r = (t === 1) ? 1 - p : (t === 2) ? p : (p < 0.5) ? p * 2 : (1 - p) * 2;
				if (pw === 1) {
					r *= r;
				} else if (pw === 2) {
					r *= r * r;
				} else if (pw === 3) {
					r *= r * r * r;
				} else if (pw === 4) {
					r *= r * r * r * r;
				}
				return (t === 1) ? 1 - r : (t === 2) ? r : (p < 0.5) ? r / 2 : 1 - (r / 2);
			};
	
			//create all the standard eases like Linear, Quad, Cubic, Quart, Quint, Strong, Power0, Power1, Power2, Power3, and Power4 (each with easeIn, easeOut, and easeInOut)
			a = ["Linear","Quad","Cubic","Quart","Quint,Strong"];
			i = a.length;
			while (--i > -1) {
				p = a[i]+",Power"+i;
				_easeReg(new Ease(null,null,1,i), p, "easeOut", true);
				_easeReg(new Ease(null,null,2,i), p, "easeIn" + ((i === 0) ? ",easeNone" : ""));
				_easeReg(new Ease(null,null,3,i), p, "easeInOut");
			}
			_easeMap.linear = gs.easing.Linear.easeIn;
			_easeMap.swing = gs.easing.Quad.easeInOut; //for jQuery folks
	
	
	/*
	 * ----------------------------------------------------------------
	 * EventDispatcher
	 * ----------------------------------------------------------------
	 */
			var EventDispatcher = _class("events.EventDispatcher", function(target) {
				this._listeners = {};
				this._eventTarget = target || this;
			});
			p = EventDispatcher.prototype;
	
			p.addEventListener = function(type, callback, scope, useParam, priority) {
				priority = priority || 0;
				var list = this._listeners[type],
					index = 0,
					listener, i;
				if (this === _ticker && !_tickerActive) {
					_ticker.wake();
				}
				if (list == null) {
					this._listeners[type] = list = [];
				}
				i = list.length;
				while (--i > -1) {
					listener = list[i];
					if (listener.c === callback && listener.s === scope) {
						list.splice(i, 1);
					} else if (index === 0 && listener.pr < priority) {
						index = i + 1;
					}
				}
				list.splice(index, 0, {c:callback, s:scope, up:useParam, pr:priority});
			};
	
			p.removeEventListener = function(type, callback) {
				var list = this._listeners[type], i;
				if (list) {
					i = list.length;
					while (--i > -1) {
						if (list[i].c === callback) {
							list.splice(i, 1);
							return;
						}
					}
				}
			};
	
			p.dispatchEvent = function(type) {
				var list = this._listeners[type],
					i, t, listener;
				if (list) {
					i = list.length;
					if (i > 1) { 
						list = list.slice(0); //in case addEventListener() is called from within a listener/callback (otherwise the index could change, resulting in a skip)
					}
					t = this._eventTarget;
					while (--i > -1) {
						listener = list[i];
						if (listener) {
							if (listener.up) {
								listener.c.call(listener.s || t, {type:type, target:t});
							} else {
								listener.c.call(listener.s || t);
							}
						}
					}
				}
			};
	
	
	/*
	 * ----------------------------------------------------------------
	 * Ticker
	 * ----------------------------------------------------------------
	 */
	 		var _reqAnimFrame = window.requestAnimationFrame,
				_cancelAnimFrame = window.cancelAnimationFrame,
				_getTime = Date.now || function() {return new Date().getTime();},
				_lastUpdate = _getTime();
	
			//now try to determine the requestAnimationFrame and cancelAnimationFrame functions and if none are found, we'll use a setTimeout()/clearTimeout() polyfill.
			a = ["ms","moz","webkit","o"];
			i = a.length;
			while (--i > -1 && !_reqAnimFrame) {
				_reqAnimFrame = window[a[i] + "RequestAnimationFrame"];
				_cancelAnimFrame = window[a[i] + "CancelAnimationFrame"] || window[a[i] + "CancelRequestAnimationFrame"];
			}
	
			_class("Ticker", function(fps, useRAF) {
				var _self = this,
					_startTime = _getTime(),
					_useRAF = (useRAF !== false && _reqAnimFrame) ? "auto" : false,
					_lagThreshold = 500,
					_adjustedLag = 33,
					_tickWord = "tick", //helps reduce gc burden
					_fps, _req, _id, _gap, _nextTime,
					_tick = function(manual) {
						var elapsed = _getTime() - _lastUpdate,
							overlap, dispatch;
						if (elapsed > _lagThreshold) {
							_startTime += elapsed - _adjustedLag;
						}
						_lastUpdate += elapsed;
						_self.time = (_lastUpdate - _startTime) / 1000;
						overlap = _self.time - _nextTime;
						if (!_fps || overlap > 0 || manual === true) {
							_self.frame++;
							_nextTime += overlap + (overlap >= _gap ? 0.004 : _gap - overlap);
							dispatch = true;
						}
						if (manual !== true) { //make sure the request is made before we dispatch the "tick" event so that timing is maintained. Otherwise, if processing the "tick" requires a bunch of time (like 15ms) and we're using a setTimeout() that's based on 16.7ms, it'd technically take 31.7ms between frames otherwise.
							_id = _req(_tick);
						}
						if (dispatch) {
							_self.dispatchEvent(_tickWord);
						}
					};
	
				EventDispatcher.call(_self);
				_self.time = _self.frame = 0;
				_self.tick = function() {
					_tick(true);
				};
	
				_self.lagSmoothing = function(threshold, adjustedLag) {
					if (!arguments.length) { //if lagSmoothing() is called with no arguments, treat it like a getter that returns a boolean indicating if it's enabled or not. This is purposely undocumented and is for internal use.
						return (_lagThreshold < 1 / _tinyNum);
					}
					_lagThreshold = threshold || (1 / _tinyNum); //zero should be interpreted as basically unlimited
					_adjustedLag = Math.min(adjustedLag, _lagThreshold, 0);
				};
	
				_self.sleep = function() {
					if (_id == null) {
						return;
					}
					if (!_useRAF || !_cancelAnimFrame) {
						clearTimeout(_id);
					} else {
						_cancelAnimFrame(_id);
					}
					_req = _emptyFunc;
					_id = null;
					if (_self === _ticker) {
						_tickerActive = false;
					}
				};
	
				_self.wake = function(seamless) {
					if (_id !== null) {
						_self.sleep();
					} else if (seamless) {
						_startTime += -_lastUpdate + (_lastUpdate = _getTime());
					} else if (_self.frame > 10) { //don't trigger lagSmoothing if we're just waking up, and make sure that at least 10 frames have elapsed because of the iOS bug that we work around below with the 1.5-second setTimout().
						_lastUpdate = _getTime() - _lagThreshold + 5;
					}
					_req = (_fps === 0) ? _emptyFunc : (!_useRAF || !_reqAnimFrame) ? function(f) { return setTimeout(f, ((_nextTime - _self.time) * 1000 + 1) | 0); } : _reqAnimFrame;
					if (_self === _ticker) {
						_tickerActive = true;
					}
					_tick(2);
				};
	
				_self.fps = function(value) {
					if (!arguments.length) {
						return _fps;
					}
					_fps = value;
					_gap = 1 / (_fps || 60);
					_nextTime = this.time + _gap;
					_self.wake();
				};
	
				_self.useRAF = function(value) {
					if (!arguments.length) {
						return _useRAF;
					}
					_self.sleep();
					_useRAF = value;
					_self.fps(_fps);
				};
				_self.fps(fps);
	
				//a bug in iOS 6 Safari occasionally prevents the requestAnimationFrame from working initially, so we use a 1.5-second timeout that automatically falls back to setTimeout() if it senses this condition.
				setTimeout(function() {
					if (_useRAF === "auto" && _self.frame < 5 && (_doc || {}).visibilityState !== "hidden") {
						_self.useRAF(false);
					}
				}, 1500);
			});
	
			p = gs.Ticker.prototype = new gs.events.EventDispatcher();
			p.constructor = gs.Ticker;
	
	
	/*
	 * ----------------------------------------------------------------
	 * Animation
	 * ----------------------------------------------------------------
	 */
			var Animation = _class("core.Animation", function(duration, vars) {
					this.vars = vars = vars || {};
					this._duration = this._totalDuration = duration || 0;
					this._delay = Number(vars.delay) || 0;
					this._timeScale = 1;
					this._active = (vars.immediateRender === true);
					this.data = vars.data;
					this._reversed = (vars.reversed === true);
	
					if (!_rootTimeline) {
						return;
					}
					if (!_tickerActive) { //some browsers (like iOS 6 Safari) shut down JavaScript execution when the tab is disabled and they [occasionally] neglect to start up requestAnimationFrame again when returning - this code ensures that the engine starts up again properly.
						_ticker.wake();
					}
	
					var tl = this.vars.useFrames ? _rootFramesTimeline : _rootTimeline;
					tl.add(this, tl._time);
	
					if (this.vars.paused) {
						this.paused(true);
					}
				});
	
			_ticker = Animation.ticker = new gs.Ticker();
			p = Animation.prototype;
			p._dirty = p._gc = p._initted = p._paused = false;
			p._totalTime = p._time = 0;
			p._rawPrevTime = -1;
			p._next = p._last = p._onUpdate = p._timeline = p.timeline = null;
			p._paused = false;
	
	
			//some browsers (like iOS) occasionally drop the requestAnimationFrame event when the user switches to a different tab and then comes back again, so we use a 2-second setTimeout() to sense if/when that condition occurs and then wake() the ticker.
			var _checkTimeout = function() {
					if (_tickerActive && _getTime() - _lastUpdate > 2000 && ((_doc || {}).visibilityState !== "hidden" || !_ticker.lagSmoothing())) { //note: if the tab is hidden, we should still wake if lagSmoothing has been disabled.
						_ticker.wake();
					}
					var t = setTimeout(_checkTimeout, 2000);
					if (t.unref) {
						// allows a node process to exit even if the timeout’s callback hasn't been invoked. Without it, the node process could hang as this function is called every two seconds.
						t.unref();
					}
				};
			_checkTimeout();
	
	
			p.play = function(from, suppressEvents) {
				if (from != null) {
					this.seek(from, suppressEvents);
				}
				return this.reversed(false).paused(false);
			};
	
			p.pause = function(atTime, suppressEvents) {
				if (atTime != null) {
					this.seek(atTime, suppressEvents);
				}
				return this.paused(true);
			};
	
			p.resume = function(from, suppressEvents) {
				if (from != null) {
					this.seek(from, suppressEvents);
				}
				return this.paused(false);
			};
	
			p.seek = function(time, suppressEvents) {
				return this.totalTime(Number(time), suppressEvents !== false);
			};
	
			p.restart = function(includeDelay, suppressEvents) {
				return this.reversed(false).paused(false).totalTime(includeDelay ? -this._delay : 0, (suppressEvents !== false), true);
			};
	
			p.reverse = function(from, suppressEvents) {
				if (from != null) {
					this.seek((from || this.totalDuration()), suppressEvents);
				}
				return this.reversed(true).paused(false);
			};
	
			p.render = function(time, suppressEvents, force) {
				//stub - we override this method in subclasses.
			};
	
			p.invalidate = function() {
				this._time = this._totalTime = 0;
				this._initted = this._gc = false;
				this._rawPrevTime = -1;
				if (this._gc || !this.timeline) {
					this._enabled(true);
				}
				return this;
			};
	
			p.isActive = function() {
				var tl = this._timeline, //the 2 root timelines won't have a _timeline; they're always active.
					startTime = this._startTime,
					rawTime;
				return (!tl || (!this._gc && !this._paused && tl.isActive() && (rawTime = tl.rawTime(true)) >= startTime && rawTime < startTime + this.totalDuration() / this._timeScale - 0.0000001));
			};
	
			p._enabled = function (enabled, ignoreTimeline) {
				if (!_tickerActive) {
					_ticker.wake();
				}
				this._gc = !enabled;
				this._active = this.isActive();
				if (ignoreTimeline !== true) {
					if (enabled && !this.timeline) {
						this._timeline.add(this, this._startTime - this._delay);
					} else if (!enabled && this.timeline) {
						this._timeline._remove(this, true);
					}
				}
				return false;
			};
	
	
			p._kill = function(vars, target) {
				return this._enabled(false, false);
			};
	
			p.kill = function(vars, target) {
				this._kill(vars, target);
				return this;
			};
	
			p._uncache = function(includeSelf) {
				var tween = includeSelf ? this : this.timeline;
				while (tween) {
					tween._dirty = true;
					tween = tween.timeline;
				}
				return this;
			};
	
			p._swapSelfInParams = function(params) {
				var i = params.length,
					copy = params.concat();
				while (--i > -1) {
					if (params[i] === "{self}") {
						copy[i] = this;
					}
				}
				return copy;
			};
	
			p._callback = function(type) {
				var v = this.vars,
					callback = v[type],
					params = v[type + "Params"],
					scope = v[type + "Scope"] || v.callbackScope || this,
					l = params ? params.length : 0;
				switch (l) { //speed optimization; call() is faster than apply() so use it when there are only a few parameters (which is by far most common). Previously we simply did var v = this.vars; v[type].apply(v[type + "Scope"] || v.callbackScope || this, v[type + "Params"] || _blankArray);
					case 0: callback.call(scope); break;
					case 1: callback.call(scope, params[0]); break;
					case 2: callback.call(scope, params[0], params[1]); break;
					default: callback.apply(scope, params);
				}
			};
	
	//----Animation getters/setters --------------------------------------------------------
	
			p.eventCallback = function(type, callback, params, scope) {
				if ((type || "").substr(0,2) === "on") {
					var v = this.vars;
					if (arguments.length === 1) {
						return v[type];
					}
					if (callback == null) {
						delete v[type];
					} else {
						v[type] = callback;
						v[type + "Params"] = (_isArray(params) && params.join("").indexOf("{self}") !== -1) ? this._swapSelfInParams(params) : params;
						v[type + "Scope"] = scope;
					}
					if (type === "onUpdate") {
						this._onUpdate = callback;
					}
				}
				return this;
			};
	
			p.delay = function(value) {
				if (!arguments.length) {
					return this._delay;
				}
				if (this._timeline.smoothChildTiming) {
					this.startTime( this._startTime + value - this._delay );
				}
				this._delay = value;
				return this;
			};
	
			p.duration = function(value) {
				if (!arguments.length) {
					this._dirty = false;
					return this._duration;
				}
				this._duration = this._totalDuration = value;
				this._uncache(true); //true in case it's a TweenMax or TimelineMax that has a repeat - we'll need to refresh the totalDuration.
				if (this._timeline.smoothChildTiming) if (this._time > 0) if (this._time < this._duration) if (value !== 0) {
					this.totalTime(this._totalTime * (value / this._duration), true);
				}
				return this;
			};
	
			p.totalDuration = function(value) {
				this._dirty = false;
				return (!arguments.length) ? this._totalDuration : this.duration(value);
			};
	
			p.time = function(value, suppressEvents) {
				if (!arguments.length) {
					return this._time;
				}
				if (this._dirty) {
					this.totalDuration();
				}
				return this.totalTime((value > this._duration) ? this._duration : value, suppressEvents);
			};
	
			p.totalTime = function(time, suppressEvents, uncapped) {
				if (!_tickerActive) {
					_ticker.wake();
				}
				if (!arguments.length) {
					return this._totalTime;
				}
				if (this._timeline) {
					if (time < 0 && !uncapped) {
						time += this.totalDuration();
					}
					if (this._timeline.smoothChildTiming) {
						if (this._dirty) {
							this.totalDuration();
						}
						var totalDuration = this._totalDuration,
							tl = this._timeline;
						if (time > totalDuration && !uncapped) {
							time = totalDuration;
						}
						this._startTime = (this._paused ? this._pauseTime : tl._time) - ((!this._reversed ? time : totalDuration - time) / this._timeScale);
						if (!tl._dirty) { //for performance improvement. If the parent's cache is already dirty, it already took care of marking the ancestors as dirty too, so skip the function call here.
							this._uncache(false);
						}
						//in case any of the ancestor timelines had completed but should now be enabled, we should reset their totalTime() which will also ensure that they're lined up properly and enabled. Skip for animations that are on the root (wasteful). Example: a TimelineLite.exportRoot() is performed when there's a paused tween on the root, the export will not complete until that tween is unpaused, but imagine a child gets restarted later, after all [unpaused] tweens have completed. The startTime of that child would get pushed out, but one of the ancestors may have completed.
						if (tl._timeline) {
							while (tl._timeline) {
								if (tl._timeline._time !== (tl._startTime + tl._totalTime) / tl._timeScale) {
									tl.totalTime(tl._totalTime, true);
								}
								tl = tl._timeline;
							}
						}
					}
					if (this._gc) {
						this._enabled(true, false);
					}
					if (this._totalTime !== time || this._duration === 0) {
						if (_lazyTweens.length) {
							_lazyRender();
						}
						this.render(time, suppressEvents, false);
						if (_lazyTweens.length) { //in case rendering caused any tweens to lazy-init, we should render them because typically when someone calls seek() or time() or progress(), they expect an immediate render.
							_lazyRender();
						}
					}
				}
				return this;
			};
	
			p.progress = p.totalProgress = function(value, suppressEvents) {
				var duration = this.duration();
				return (!arguments.length) ? (duration ? this._time / duration : this.ratio) : this.totalTime(duration * value, suppressEvents);
			};
	
			p.startTime = function(value) {
				if (!arguments.length) {
					return this._startTime;
				}
				if (value !== this._startTime) {
					this._startTime = value;
					if (this.timeline) if (this.timeline._sortChildren) {
						this.timeline.add(this, value - this._delay); //ensures that any necessary re-sequencing of Animations in the timeline occurs to make sure the rendering order is correct.
					}
				}
				return this;
			};
	
			p.endTime = function(includeRepeats) {
				return this._startTime + ((includeRepeats != false) ? this.totalDuration() : this.duration()) / this._timeScale;
			};
	
			p.timeScale = function(value) {
				if (!arguments.length) {
					return this._timeScale;
				}
				var pauseTime, t;
				value = value || _tinyNum; //can't allow zero because it'll throw the math off
				if (this._timeline && this._timeline.smoothChildTiming) {
					pauseTime = this._pauseTime;
					t = (pauseTime || pauseTime === 0) ? pauseTime : this._timeline.totalTime();
					this._startTime = t - ((t - this._startTime) * this._timeScale / value);
				}
				this._timeScale = value;
				t = this.timeline;
				while (t && t.timeline) { //must update the duration/totalDuration of all ancestor timelines immediately in case in the middle of a render loop, one tween alters another tween's timeScale which shoves its startTime before 0, forcing the parent timeline to shift around and shiftChildren() which could affect that next tween's render (startTime). Doesn't matter for the root timeline though.
					t._dirty = true;
					t.totalDuration();
					t = t.timeline;
				}
				return this;
			};
	
			p.reversed = function(value) {
				if (!arguments.length) {
					return this._reversed;
				}
				if (value != this._reversed) {
					this._reversed = value;
					this.totalTime(((this._timeline && !this._timeline.smoothChildTiming) ? this.totalDuration() - this._totalTime : this._totalTime), true);
				}
				return this;
			};
	
			p.paused = function(value) {
				if (!arguments.length) {
					return this._paused;
				}
				var tl = this._timeline,
					raw, elapsed;
				if (value != this._paused) if (tl) {
					if (!_tickerActive && !value) {
						_ticker.wake();
					}
					raw = tl.rawTime();
					elapsed = raw - this._pauseTime;
					if (!value && tl.smoothChildTiming) {
						this._startTime += elapsed;
						this._uncache(false);
					}
					this._pauseTime = value ? raw : null;
					this._paused = value;
					this._active = this.isActive();
					if (!value && elapsed !== 0 && this._initted && this.duration()) {
						raw = tl.smoothChildTiming ? this._totalTime : (raw - this._startTime) / this._timeScale;
						this.render(raw, (raw === this._totalTime), true); //in case the target's properties changed via some other tween or manual update by the user, we should force a render.
					}
				}
				if (this._gc && !value) {
					this._enabled(true, false);
				}
				return this;
			};
	
	
	/*
	 * ----------------------------------------------------------------
	 * SimpleTimeline
	 * ----------------------------------------------------------------
	 */
			var SimpleTimeline = _class("core.SimpleTimeline", function(vars) {
				Animation.call(this, 0, vars);
				this.autoRemoveChildren = this.smoothChildTiming = true;
			});
	
			p = SimpleTimeline.prototype = new Animation();
			p.constructor = SimpleTimeline;
			p.kill()._gc = false;
			p._first = p._last = p._recent = null;
			p._sortChildren = false;
	
			p.add = p.insert = function(child, position, align, stagger) {
				var prevTween, st;
				child._startTime = Number(position || 0) + child._delay;
				if (child._paused) if (this !== child._timeline) { //we only adjust the _pauseTime if it wasn't in this timeline already. Remember, sometimes a tween will be inserted again into the same timeline when its startTime is changed so that the tweens in the TimelineLite/Max are re-ordered properly in the linked list (so everything renders in the proper order).
					child._pauseTime = this.rawTime() - (child._timeline.rawTime() - child._pauseTime);
				}
				if (child.timeline) {
					child.timeline._remove(child, true); //removes from existing timeline so that it can be properly added to this one.
				}
				child.timeline = child._timeline = this;
				if (child._gc) {
					child._enabled(true, true);
				}
				prevTween = this._last;
				if (this._sortChildren) {
					st = child._startTime;
					while (prevTween && prevTween._startTime > st) {
						prevTween = prevTween._prev;
					}
				}
				if (prevTween) {
					child._next = prevTween._next;
					prevTween._next = child;
				} else {
					child._next = this._first;
					this._first = child;
				}
				if (child._next) {
					child._next._prev = child;
				} else {
					this._last = child;
				}
				child._prev = prevTween;
				this._recent = child;
				if (this._timeline) {
					this._uncache(true);
				}
				return this;
			};
	
			p._remove = function(tween, skipDisable) {
				if (tween.timeline === this) {
					if (!skipDisable) {
						tween._enabled(false, true);
					}
	
					if (tween._prev) {
						tween._prev._next = tween._next;
					} else if (this._first === tween) {
						this._first = tween._next;
					}
					if (tween._next) {
						tween._next._prev = tween._prev;
					} else if (this._last === tween) {
						this._last = tween._prev;
					}
					tween._next = tween._prev = tween.timeline = null;
					if (tween === this._recent) {
						this._recent = this._last;
					}
	
					if (this._timeline) {
						this._uncache(true);
					}
				}
				return this;
			};
	
			p.render = function(time, suppressEvents, force) {
				var tween = this._first,
					next;
				this._totalTime = this._time = this._rawPrevTime = time;
				while (tween) {
					next = tween._next; //record it here because the value could change after rendering...
					if (tween._active || (time >= tween._startTime && !tween._paused && !tween._gc)) {
						if (!tween._reversed) {
							tween.render((time - tween._startTime) * tween._timeScale, suppressEvents, force);
						} else {
							tween.render(((!tween._dirty) ? tween._totalDuration : tween.totalDuration()) - ((time - tween._startTime) * tween._timeScale), suppressEvents, force);
						}
					}
					tween = next;
				}
			};
	
			p.rawTime = function() {
				if (!_tickerActive) {
					_ticker.wake();
				}
				return this._totalTime;
			};
	
	/*
	 * ----------------------------------------------------------------
	 * TweenLite
	 * ----------------------------------------------------------------
	 */
			var TweenLite = _class("TweenLite", function(target, duration, vars) {
					Animation.call(this, duration, vars);
					this.render = TweenLite.prototype.render; //speed optimization (avoid prototype lookup on this "hot" method)
	
					if (target == null) {
						throw "Cannot tween a null target.";
					}
	
					this.target = target = (typeof(target) !== "string") ? target : TweenLite.selector(target) || target;
	
					var isSelector = (target.jquery || (target.length && target !== window && target[0] && (target[0] === window || (target[0].nodeType && target[0].style && !target.nodeType)))),
						overwrite = this.vars.overwrite,
						i, targ, targets;
	
					this._overwrite = overwrite = (overwrite == null) ? _overwriteLookup[TweenLite.defaultOverwrite] : (typeof(overwrite) === "number") ? overwrite >> 0 : _overwriteLookup[overwrite];
	
					if ((isSelector || target instanceof Array || (target.push && _isArray(target))) && typeof(target[0]) !== "number") {
						this._targets = targets = _slice(target);  //don't use Array.prototype.slice.call(target, 0) because that doesn't work in IE8 with a NodeList that's returned by querySelectorAll()
						this._propLookup = [];
						this._siblings = [];
						for (i = 0; i < targets.length; i++) {
							targ = targets[i];
							if (!targ) {
								targets.splice(i--, 1);
								continue;
							} else if (typeof(targ) === "string") {
								targ = targets[i--] = TweenLite.selector(targ); //in case it's an array of strings
								if (typeof(targ) === "string") {
									targets.splice(i+1, 1); //to avoid an endless loop (can't imagine why the selector would return a string, but just in case)
								}
								continue;
							} else if (targ.length && targ !== window && targ[0] && (targ[0] === window || (targ[0].nodeType && targ[0].style && !targ.nodeType))) { //in case the user is passing in an array of selector objects (like jQuery objects), we need to check one more level and pull things out if necessary. Also note that <select> elements pass all the criteria regarding length and the first child having style, so we must also check to ensure the target isn't an HTML node itself.
								targets.splice(i--, 1);
								this._targets = targets = targets.concat(_slice(targ));
								continue;
							}
							this._siblings[i] = _register(targ, this, false);
							if (overwrite === 1) if (this._siblings[i].length > 1) {
								_applyOverwrite(targ, this, null, 1, this._siblings[i]);
							}
						}
	
					} else {
						this._propLookup = {};
						this._siblings = _register(target, this, false);
						if (overwrite === 1) if (this._siblings.length > 1) {
							_applyOverwrite(target, this, null, 1, this._siblings);
						}
					}
					if (this.vars.immediateRender || (duration === 0 && this._delay === 0 && this.vars.immediateRender !== false)) {
						this._time = -_tinyNum; //forces a render without having to set the render() "force" parameter to true because we want to allow lazying by default (using the "force" parameter always forces an immediate full render)
						this.render(Math.min(0, -this._delay)); //in case delay is negative
					}
				}, true),
				_isSelector = function(v) {
					return (v && v.length && v !== window && v[0] && (v[0] === window || (v[0].nodeType && v[0].style && !v.nodeType))); //we cannot check "nodeType" if the target is window from within an iframe, otherwise it will trigger a security error in some browsers like Firefox.
				},
				_autoCSS = function(vars, target) {
					var css = {},
						p;
					for (p in vars) {
						if (!_reservedProps[p] && (!(p in target) || p === "transform" || p === "x" || p === "y" || p === "width" || p === "height" || p === "className" || p === "border") && (!_plugins[p] || (_plugins[p] && _plugins[p]._autoCSS))) { //note: <img> elements contain read-only "x" and "y" properties. We should also prioritize editing css width/height rather than the element's properties.
							css[p] = vars[p];
							delete vars[p];
						}
					}
					vars.css = css;
				};
	
			p = TweenLite.prototype = new Animation();
			p.constructor = TweenLite;
			p.kill()._gc = false;
	
	//----TweenLite defaults, overwrite management, and root updates ----------------------------------------------------
	
			p.ratio = 0;
			p._firstPT = p._targets = p._overwrittenProps = p._startAt = null;
			p._notifyPluginsOfEnabled = p._lazy = false;
	
			TweenLite.version = "1.20.5";
			TweenLite.defaultEase = p._ease = new Ease(null, null, 1, 1);
			TweenLite.defaultOverwrite = "auto";
			TweenLite.ticker = _ticker;
			TweenLite.autoSleep = 120;
			TweenLite.lagSmoothing = function(threshold, adjustedLag) {
				_ticker.lagSmoothing(threshold, adjustedLag);
			};
	
			TweenLite.selector = window.$ || window.jQuery || function(e) {
				var selector = window.$ || window.jQuery;
				if (selector) {
					TweenLite.selector = selector;
					return selector(e);
				}
				if (!_doc) { //in some dev environments (like Angular 6), GSAP gets loaded before the document is defined! So re-query it here if/when necessary.
					_doc = window.document;
				}
				return (!_doc) ? e : (_doc.querySelectorAll ? _doc.querySelectorAll(e) : _doc.getElementById((e.charAt(0) === "#") ? e.substr(1) : e));
			};
	
			var _lazyTweens = [],
				_lazyLookup = {},
				_numbersExp = /(?:(-|-=|\+=)?\d*\.?\d*(?:e[\-+]?\d+)?)[0-9]/ig,
				_relExp = /[\+-]=-?[\.\d]/,
				//_nonNumbersExp = /(?:([\-+](?!(\d|=)))|[^\d\-+=e]|(e(?![\-+][\d])))+/ig,
				_setRatio = function(v) {
					var pt = this._firstPT,
						min = 0.000001,
						val;
					while (pt) {
						val = !pt.blob ? pt.c * v + pt.s : (v === 1 && this.end != null) ? this.end : v ? this.join("") : this.start;
						if (pt.m) {
							val = pt.m.call(this._tween, val, this._target || pt.t, this._tween);
						} else if (val < min) if (val > -min && !pt.blob) { //prevents issues with converting very small numbers to strings in the browser
							val = 0;
						}
						if (!pt.f) {
							pt.t[pt.p] = val;
						} else if (pt.fp) {
							pt.t[pt.p](pt.fp, val);
						} else {
							pt.t[pt.p](val);
						}
						pt = pt._next;
					}
				},
				//compares two strings (start/end), finds the numbers that are different and spits back an array representing the whole value but with the changing values isolated as elements. For example, "rgb(0,0,0)" and "rgb(100,50,0)" would become ["rgb(", 0, ",", 50, ",0)"]. Notice it merges the parts that are identical (performance optimization). The array also has a linked list of PropTweens attached starting with _firstPT that contain the tweening data (t, p, s, c, f, etc.). It also stores the starting value as a "start" property so that we can revert to it if/when necessary, like when a tween rewinds fully. If the quantity of numbers differs between the start and end, it will always prioritize the end value(s). The pt parameter is optional - it's for a PropTween that will be appended to the end of the linked list and is typically for actually setting the value after all of the elements have been updated (with array.join("")).
				_blobDif = function(start, end, filter, pt) {
					var a = [],
						charIndex = 0,
						s = "",
						color = 0,
						startNums, endNums, num, i, l, nonNumbers, currentNum;
					a.start = start;
					a.end = end;
					start = a[0] = start + ""; //ensure values are strings
					end = a[1] = end + "";
					if (filter) {
						filter(a); //pass an array with the starting and ending values and let the filter do whatever it needs to the values.
						start = a[0];
						end = a[1];
					}
					a.length = 0;
					startNums = start.match(_numbersExp) || [];
					endNums = end.match(_numbersExp) || [];
					if (pt) {
						pt._next = null;
						pt.blob = 1;
						a._firstPT = a._applyPT = pt; //apply last in the linked list (which means inserting it first)
					}
					l = endNums.length;
					for (i = 0; i < l; i++) {
						currentNum = endNums[i];
						nonNumbers = end.substr(charIndex, end.indexOf(currentNum, charIndex)-charIndex);
						s += (nonNumbers || !i) ? nonNumbers : ","; //note: SVG spec allows omission of comma/space when a negative sign is wedged between two numbers, like 2.5-5.3 instead of 2.5,-5.3 but when tweening, the negative value may switch to positive, so we insert the comma just in case.
						charIndex += nonNumbers.length;
						if (color) { //sense rgba() values and round them.
							color = (color + 1) % 5;
						} else if (nonNumbers.substr(-5) === "rgba(") {
							color = 1;
						}
						if (currentNum === startNums[i] || startNums.length <= i) {
							s += currentNum;
						} else {
							if (s) {
								a.push(s);
								s = "";
							}
							num = parseFloat(startNums[i]);
							a.push(num);
							a._firstPT = {_next: a._firstPT, t:a, p: a.length-1, s:num, c:((currentNum.charAt(1) === "=") ? parseInt(currentNum.charAt(0) + "1", 10) * parseFloat(currentNum.substr(2)) : (parseFloat(currentNum) - num)) || 0, f:0, m:(color && color < 4) ? Math.round : 0};
							//note: we don't set _prev because we'll never need to remove individual PropTweens from this list.
						}
						charIndex += currentNum.length;
					}
					s += end.substr(charIndex);
					if (s) {
						a.push(s);
					}
					a.setRatio = _setRatio;
					if (_relExp.test(end)) { //if the end string contains relative values, delete it so that on the final render (in _setRatio()), we don't actually set it to the string with += or -= characters (forces it to use the calculated value).
						a.end = null;
					}
					return a;
				},
				//note: "funcParam" is only necessary for function-based getters/setters that require an extra parameter like getAttribute("width") and setAttribute("width", value). In this example, funcParam would be "width". Used by AttrPlugin for example.
				_addPropTween = function(target, prop, start, end, overwriteProp, mod, funcParam, stringFilter, index) {
					if (typeof(end) === "function") {
						end = end(index || 0, target);
					}
					var type = typeof(target[prop]),
						getterName = (type !== "function") ? "" : ((prop.indexOf("set") || typeof(target["get" + prop.substr(3)]) !== "function") ? prop : "get" + prop.substr(3)),
						s = (start !== "get") ? start : !getterName ? target[prop] : funcParam ? target[getterName](funcParam) : target[getterName](),
						isRelative = (typeof(end) === "string" && end.charAt(1) === "="),
						pt = {t:target, p:prop, s:s, f:(type === "function"), pg:0, n:overwriteProp || prop, m:(!mod ? 0 : (typeof(mod) === "function") ? mod : Math.round), pr:0, c:isRelative ? parseInt(end.charAt(0) + "1", 10) * parseFloat(end.substr(2)) : (parseFloat(end) - s) || 0},
						blob;
	
					if (typeof(s) !== "number" || (typeof(end) !== "number" && !isRelative)) {
						if (funcParam || isNaN(s) || (!isRelative && isNaN(end)) || typeof(s) === "boolean" || typeof(end) === "boolean") {
							//a blob (string that has multiple numbers in it)
							pt.fp = funcParam;
							blob = _blobDif(s, (isRelative ? (parseFloat(pt.s) + pt.c) + (pt.s + "").replace(/[0-9\-\.]/g, "") : end), stringFilter || TweenLite.defaultStringFilter, pt);
							pt = {t: blob, p: "setRatio", s: 0, c: 1, f: 2, pg: 0, n: overwriteProp || prop, pr: 0, m: 0}; //"2" indicates it's a Blob property tween. Needed for RoundPropsPlugin for example.
						} else {
							pt.s = parseFloat(s);
							if (!isRelative) {
								pt.c = (parseFloat(end) - pt.s) || 0;
							}
						}
					}
					if (pt.c) { //only add it to the linked list if there's a change.
						if ((pt._next = this._firstPT)) {
							pt._next._prev = pt;
						}
						this._firstPT = pt;
						return pt;
					}
				},
				_internals = TweenLite._internals = {isArray:_isArray, isSelector:_isSelector, lazyTweens:_lazyTweens, blobDif:_blobDif}, //gives us a way to expose certain private values to other GreenSock classes without contaminating tha main TweenLite object.
				_plugins = TweenLite._plugins = {},
				_tweenLookup = _internals.tweenLookup = {},
				_tweenLookupNum = 0,
				_reservedProps = _internals.reservedProps = {ease:1, delay:1, overwrite:1, onComplete:1, onCompleteParams:1, onCompleteScope:1, useFrames:1, runBackwards:1, startAt:1, onUpdate:1, onUpdateParams:1, onUpdateScope:1, onStart:1, onStartParams:1, onStartScope:1, onReverseComplete:1, onReverseCompleteParams:1, onReverseCompleteScope:1, onRepeat:1, onRepeatParams:1, onRepeatScope:1, easeParams:1, yoyo:1, immediateRender:1, repeat:1, repeatDelay:1, data:1, paused:1, reversed:1, autoCSS:1, lazy:1, onOverwrite:1, callbackScope:1, stringFilter:1, id:1, yoyoEase:1},
				_overwriteLookup = {none:0, all:1, auto:2, concurrent:3, allOnStart:4, preexisting:5, "true":1, "false":0},
				_rootFramesTimeline = Animation._rootFramesTimeline = new SimpleTimeline(),
				_rootTimeline = Animation._rootTimeline = new SimpleTimeline(),
				_nextGCFrame = 30,
				_lazyRender = _internals.lazyRender = function() {
					var i = _lazyTweens.length,
						tween;
					_lazyLookup = {};
					while (--i > -1) {
						tween = _lazyTweens[i];
						if (tween && tween._lazy !== false) {
							tween.render(tween._lazy[0], tween._lazy[1], true);
							tween._lazy = false;
						}
					}
					_lazyTweens.length = 0;
				};
	
			_rootTimeline._startTime = _ticker.time;
			_rootFramesTimeline._startTime = _ticker.frame;
			_rootTimeline._active = _rootFramesTimeline._active = true;
			setTimeout(_lazyRender, 1); //on some mobile devices, there isn't a "tick" before code runs which means any lazy renders wouldn't run before the next official "tick".
	
			Animation._updateRoot = TweenLite.render = function() {
					var i, a, p;
					if (_lazyTweens.length) { //if code is run outside of the requestAnimationFrame loop, there may be tweens queued AFTER the engine refreshed, so we need to ensure any pending renders occur before we refresh again.
						_lazyRender();
					}
					_rootTimeline.render((_ticker.time - _rootTimeline._startTime) * _rootTimeline._timeScale, false, false);
					_rootFramesTimeline.render((_ticker.frame - _rootFramesTimeline._startTime) * _rootFramesTimeline._timeScale, false, false);
					if (_lazyTweens.length) {
						_lazyRender();
					}
					if (_ticker.frame >= _nextGCFrame) { //dump garbage every 120 frames or whatever the user sets TweenLite.autoSleep to
						_nextGCFrame = _ticker.frame + (parseInt(TweenLite.autoSleep, 10) || 120);
						for (p in _tweenLookup) {
							a = _tweenLookup[p].tweens;
							i = a.length;
							while (--i > -1) {
								if (a[i]._gc) {
									a.splice(i, 1);
								}
							}
							if (a.length === 0) {
								delete _tweenLookup[p];
							}
						}
						//if there are no more tweens in the root timelines, or if they're all paused, make the _timer sleep to reduce load on the CPU slightly
						p = _rootTimeline._first;
						if (!p || p._paused) if (TweenLite.autoSleep && !_rootFramesTimeline._first && _ticker._listeners.tick.length === 1) {
							while (p && p._paused) {
								p = p._next;
							}
							if (!p) {
								_ticker.sleep();
							}
						}
					}
				};
	
			_ticker.addEventListener("tick", Animation._updateRoot);
	
			var _register = function(target, tween, scrub) {
					var id = target._gsTweenID, a, i;
					if (!_tweenLookup[id || (target._gsTweenID = id = "t" + (_tweenLookupNum++))]) {
						_tweenLookup[id] = {target:target, tweens:[]};
					}
					if (tween) {
						a = _tweenLookup[id].tweens;
						a[(i = a.length)] = tween;
						if (scrub) {
							while (--i > -1) {
								if (a[i] === tween) {
									a.splice(i, 1);
								}
							}
						}
					}
					return _tweenLookup[id].tweens;
				},
				_onOverwrite = function(overwrittenTween, overwritingTween, target, killedProps) {
					var func = overwrittenTween.vars.onOverwrite, r1, r2;
					if (func) {
						r1 = func(overwrittenTween, overwritingTween, target, killedProps);
					}
					func = TweenLite.onOverwrite;
					if (func) {
						r2 = func(overwrittenTween, overwritingTween, target, killedProps);
					}
					return (r1 !== false && r2 !== false);
				},
				_applyOverwrite = function(target, tween, props, mode, siblings) {
					var i, changed, curTween, l;
					if (mode === 1 || mode >= 4) {
						l = siblings.length;
						for (i = 0; i < l; i++) {
							if ((curTween = siblings[i]) !== tween) {
								if (!curTween._gc) {
									if (curTween._kill(null, target, tween)) {
										changed = true;
									}
								}
							} else if (mode === 5) {
								break;
							}
						}
						return changed;
					}
					//NOTE: Add 0.0000000001 to overcome floating point errors that can cause the startTime to be VERY slightly off (when a tween's time() is set for example)
					var startTime = tween._startTime + _tinyNum,
						overlaps = [],
						oCount = 0,
						zeroDur = (tween._duration === 0),
						globalStart;
					i = siblings.length;
					while (--i > -1) {
						if ((curTween = siblings[i]) === tween || curTween._gc || curTween._paused) {
							//ignore
						} else if (curTween._timeline !== tween._timeline) {
							globalStart = globalStart || _checkOverlap(tween, 0, zeroDur);
							if (_checkOverlap(curTween, globalStart, zeroDur) === 0) {
								overlaps[oCount++] = curTween;
							}
						} else if (curTween._startTime <= startTime) if (curTween._startTime + curTween.totalDuration() / curTween._timeScale > startTime) if (!((zeroDur || !curTween._initted) && startTime - curTween._startTime <= 0.0000000002)) {
							overlaps[oCount++] = curTween;
						}
					}
	
					i = oCount;
					while (--i > -1) {
						curTween = overlaps[i];
						if (mode === 2) if (curTween._kill(props, target, tween)) {
							changed = true;
						}
						if (mode !== 2 || (!curTween._firstPT && curTween._initted)) {
							if (mode !== 2 && !_onOverwrite(curTween, tween)) {
								continue;
							}
							if (curTween._enabled(false, false)) { //if all property tweens have been overwritten, kill the tween.
								changed = true;
							}
						}
					}
					return changed;
				},
				_checkOverlap = function(tween, reference, zeroDur) {
					var tl = tween._timeline,
						ts = tl._timeScale,
						t = tween._startTime;
					while (tl._timeline) {
						t += tl._startTime;
						ts *= tl._timeScale;
						if (tl._paused) {
							return -100;
						}
						tl = tl._timeline;
					}
					t /= ts;
					return (t > reference) ? t - reference : ((zeroDur && t === reference) || (!tween._initted && t - reference < 2 * _tinyNum)) ? _tinyNum : ((t += tween.totalDuration() / tween._timeScale / ts) > reference + _tinyNum) ? 0 : t - reference - _tinyNum;
				};
	
	
	//---- TweenLite instance methods -----------------------------------------------------------------------------
	
			p._init = function() {
				var v = this.vars,
					op = this._overwrittenProps,
					dur = this._duration,
					immediate = !!v.immediateRender,
					ease = v.ease,
					i, initPlugins, pt, p, startVars, l;
				if (v.startAt) {
					if (this._startAt) {
						this._startAt.render(-1, true); //if we've run a startAt previously (when the tween instantiated), we should revert it so that the values re-instantiate correctly particularly for relative tweens. Without this, a TweenLite.fromTo(obj, 1, {x:"+=100"}, {x:"-=100"}), for example, would actually jump to +=200 because the startAt would run twice, doubling the relative change.
						this._startAt.kill();
					}
					startVars = {};
					for (p in v.startAt) { //copy the properties/values into a new object to avoid collisions, like var to = {x:0}, from = {x:500}; timeline.fromTo(e, 1, from, to).fromTo(e, 1, to, from);
						startVars[p] = v.startAt[p];
					}
					startVars.data = "isStart";
					startVars.overwrite = false;
					startVars.immediateRender = true;
					startVars.lazy = (immediate && v.lazy !== false);
					startVars.startAt = startVars.delay = null; //no nesting of startAt objects allowed (otherwise it could cause an infinite loop).
					startVars.onUpdate = v.onUpdate;
					startVars.onUpdateParams = v.onUpdateParams;
					startVars.onUpdateScope = v.onUpdateScope || v.callbackScope || this;
					this._startAt = TweenLite.to(this.target || {}, 0, startVars);
					if (immediate) {
						if (this._time > 0) {
							this._startAt = null; //tweens that render immediately (like most from() and fromTo() tweens) shouldn't revert when their parent timeline's playhead goes backward past the startTime because the initial render could have happened anytime and it shouldn't be directly correlated to this tween's startTime. Imagine setting up a complex animation where the beginning states of various objects are rendered immediately but the tween doesn't happen for quite some time - if we revert to the starting values as soon as the playhead goes backward past the tween's startTime, it will throw things off visually. Reversion should only happen in TimelineLite/Max instances where immediateRender was false (which is the default in the convenience methods like from()).
						} else if (dur !== 0) {
							return; //we skip initialization here so that overwriting doesn't occur until the tween actually begins. Otherwise, if you create several immediateRender:true tweens of the same target/properties to drop into a TimelineLite or TimelineMax, the last one created would overwrite the first ones because they didn't get placed into the timeline yet before the first render occurs and kicks in overwriting.
						}
					}
				} else if (v.runBackwards && dur !== 0) {
					//from() tweens must be handled uniquely: their beginning values must be rendered but we don't want overwriting to occur yet (when time is still 0). Wait until the tween actually begins before doing all the routines like overwriting. At that time, we should render at the END of the tween to ensure that things initialize correctly (remember, from() tweens go backwards)
					if (this._startAt) {
						this._startAt.render(-1, true);
						this._startAt.kill();
						this._startAt = null;
					} else {
						if (this._time !== 0) { //in rare cases (like if a from() tween runs and then is invalidate()-ed), immediateRender could be true but the initial forced-render gets skipped, so there's no need to force the render in this context when the _time is greater than 0
							immediate = false;
						}
						pt = {};
						for (p in v) { //copy props into a new object and skip any reserved props, otherwise onComplete or onUpdate or onStart could fire. We should, however, permit autoCSS to go through.
							if (!_reservedProps[p] || p === "autoCSS") {
								pt[p] = v[p];
							}
						}
						pt.overwrite = 0;
						pt.data = "isFromStart"; //we tag the tween with as "isFromStart" so that if [inside a plugin] we need to only do something at the very END of a tween, we have a way of identifying this tween as merely the one that's setting the beginning values for a "from()" tween. For example, clearProps in CSSPlugin should only get applied at the very END of a tween and without this tag, from(...{height:100, clearProps:"height", delay:1}) would wipe the height at the beginning of the tween and after 1 second, it'd kick back in.
						pt.lazy = (immediate && v.lazy !== false);
						pt.immediateRender = immediate; //zero-duration tweens render immediately by default, but if we're not specifically instructed to render this tween immediately, we should skip this and merely _init() to record the starting values (rendering them immediately would push them to completion which is wasteful in that case - we'd have to render(-1) immediately after)
						this._startAt = TweenLite.to(this.target, 0, pt);
						if (!immediate) {
							this._startAt._init(); //ensures that the initial values are recorded
							this._startAt._enabled(false); //no need to have the tween render on the next cycle. Disable it because we'll always manually control the renders of the _startAt tween.
							if (this.vars.immediateRender) {
								this._startAt = null;
							}
						} else if (this._time === 0) {
							return;
						}
					}
				}
				this._ease = ease = (!ease) ? TweenLite.defaultEase : (ease instanceof Ease) ? ease : (typeof(ease) === "function") ? new Ease(ease, v.easeParams) : _easeMap[ease] || TweenLite.defaultEase;
				if (v.easeParams instanceof Array && ease.config) {
					this._ease = ease.config.apply(ease, v.easeParams);
				}
				this._easeType = this._ease._type;
				this._easePower = this._ease._power;
				this._firstPT = null;
	
				if (this._targets) {
					l = this._targets.length;
					for (i = 0; i < l; i++) {
						if ( this._initProps( this._targets[i], (this._propLookup[i] = {}), this._siblings[i], (op ? op[i] : null), i) ) {
							initPlugins = true;
						}
					}
				} else {
					initPlugins = this._initProps(this.target, this._propLookup, this._siblings, op, 0);
				}
	
				if (initPlugins) {
					TweenLite._onPluginEvent("_onInitAllProps", this); //reorders the array in order of priority. Uses a static TweenPlugin method in order to minimize file size in TweenLite
				}
				if (op) if (!this._firstPT) if (typeof(this.target) !== "function") { //if all tweening properties have been overwritten, kill the tween. If the target is a function, it's probably a delayedCall so let it live.
					this._enabled(false, false);
				}
				if (v.runBackwards) {
					pt = this._firstPT;
					while (pt) {
						pt.s += pt.c;
						pt.c = -pt.c;
						pt = pt._next;
					}
				}
				this._onUpdate = v.onUpdate;
				this._initted = true;
			};
	
			p._initProps = function(target, propLookup, siblings, overwrittenProps, index) {
				var p, i, initPlugins, plugin, pt, v;
				if (target == null) {
					return false;
				}
	
				if (_lazyLookup[target._gsTweenID]) {
					_lazyRender(); //if other tweens of the same target have recently initted but haven't rendered yet, we've got to force the render so that the starting values are correct (imagine populating a timeline with a bunch of sequential tweens and then jumping to the end)
				}
	
				if (!this.vars.css) if (target.style) if (target !== window && target.nodeType) if (_plugins.css) if (this.vars.autoCSS !== false) { //it's so common to use TweenLite/Max to animate the css of DOM elements, we assume that if the target is a DOM element, that's what is intended (a convenience so that users don't have to wrap things in css:{}, although we still recommend it for a slight performance boost and better specificity). Note: we cannot check "nodeType" on the window inside an iframe.
					_autoCSS(this.vars, target);
				}
				for (p in this.vars) {
					v = this.vars[p];
					if (_reservedProps[p]) {
						if (v) if ((v instanceof Array) || (v.push && _isArray(v))) if (v.join("").indexOf("{self}") !== -1) {
							this.vars[p] = v = this._swapSelfInParams(v, this);
						}
	
					} else if (_plugins[p] && (plugin = new _plugins[p]())._onInitTween(target, this.vars[p], this, index)) {
	
						//t - target 		[object]
						//p - property 		[string]
						//s - start			[number]
						//c - change		[number]
						//f - isFunction	[boolean]
						//n - name			[string]
						//pg - isPlugin 	[boolean]
						//pr - priority		[number]
						//m - mod           [function | 0]
						this._firstPT = pt = {_next:this._firstPT, t:plugin, p:"setRatio", s:0, c:1, f:1, n:p, pg:1, pr:plugin._priority, m:0};
						i = plugin._overwriteProps.length;
						while (--i > -1) {
							propLookup[plugin._overwriteProps[i]] = this._firstPT;
						}
						if (plugin._priority || plugin._onInitAllProps) {
							initPlugins = true;
						}
						if (plugin._onDisable || plugin._onEnable) {
							this._notifyPluginsOfEnabled = true;
						}
						if (pt._next) {
							pt._next._prev = pt;
						}
	
					} else {
						propLookup[p] = _addPropTween.call(this, target, p, "get", v, p, 0, null, this.vars.stringFilter, index);
					}
				}
	
				if (overwrittenProps) if (this._kill(overwrittenProps, target)) { //another tween may have tried to overwrite properties of this tween before init() was called (like if two tweens start at the same time, the one created second will run first)
					return this._initProps(target, propLookup, siblings, overwrittenProps, index);
				}
				if (this._overwrite > 1) if (this._firstPT) if (siblings.length > 1) if (_applyOverwrite(target, this, propLookup, this._overwrite, siblings)) {
					this._kill(propLookup, target);
					return this._initProps(target, propLookup, siblings, overwrittenProps, index);
				}
				if (this._firstPT) if ((this.vars.lazy !== false && this._duration) || (this.vars.lazy && !this._duration)) { //zero duration tweens don't lazy render by default; everything else does.
					_lazyLookup[target._gsTweenID] = true;
				}
				return initPlugins;
			};
	
			p.render = function(time, suppressEvents, force) {
				var prevTime = this._time,
					duration = this._duration,
					prevRawPrevTime = this._rawPrevTime,
					isComplete, callback, pt, rawPrevTime;
				if (time >= duration - 0.0000001 && time >= 0) { //to work around occasional floating point math artifacts.
					this._totalTime = this._time = duration;
					this.ratio = this._ease._calcEnd ? this._ease.getRatio(1) : 1;
					if (!this._reversed ) {
						isComplete = true;
						callback = "onComplete";
						force = (force || this._timeline.autoRemoveChildren); //otherwise, if the animation is unpaused/activated after it's already finished, it doesn't get removed from the parent timeline.
					}
					if (duration === 0) if (this._initted || !this.vars.lazy || force) { //zero-duration tweens are tricky because we must discern the momentum/direction of time in order to determine whether the starting values should be rendered or the ending values. If the "playhead" of its timeline goes past the zero-duration tween in the forward direction or lands directly on it, the end values should be rendered, but if the timeline's "playhead" moves past it in the backward direction (from a postitive time to a negative time), the starting values must be rendered.
						if (this._startTime === this._timeline._duration) { //if a zero-duration tween is at the VERY end of a timeline and that timeline renders at its end, it will typically add a tiny bit of cushion to the render time to prevent rounding errors from getting in the way of tweens rendering their VERY end. If we then reverse() that timeline, the zero-duration tween will trigger its onReverseComplete even though technically the playhead didn't pass over it again. It's a very specific edge case we must accommodate.
							time = 0;
						}
						if (prevRawPrevTime < 0 || (time <= 0 && time >= -0.0000001) || (prevRawPrevTime === _tinyNum && this.data !== "isPause")) if (prevRawPrevTime !== time) { //note: when this.data is "isPause", it's a callback added by addPause() on a timeline that we should not be triggered when LEAVING its exact start time. In other words, tl.addPause(1).play(1) shouldn't pause.
							force = true;
							if (prevRawPrevTime > _tinyNum) {
								callback = "onReverseComplete";
							}
						}
						this._rawPrevTime = rawPrevTime = (!suppressEvents || time || prevRawPrevTime === time) ? time : _tinyNum; //when the playhead arrives at EXACTLY time 0 (right on top) of a zero-duration tween, we need to discern if events are suppressed so that when the playhead moves again (next time), it'll trigger the callback. If events are NOT suppressed, obviously the callback would be triggered in this render. Basically, the callback should fire either when the playhead ARRIVES or LEAVES this exact spot, not both. Imagine doing a timeline.seek(0) and there's a callback that sits at 0. Since events are suppressed on that seek() by default, nothing will fire, but when the playhead moves off of that position, the callback should fire. This behavior is what people intuitively expect. We set the _rawPrevTime to be a precise tiny number to indicate this scenario rather than using another property/variable which would increase memory usage. This technique is less readable, but more efficient.
					}
	
				} else if (time < 0.0000001) { //to work around occasional floating point math artifacts, round super small values to 0.
					this._totalTime = this._time = 0;
					this.ratio = this._ease._calcEnd ? this._ease.getRatio(0) : 0;
					if (prevTime !== 0 || (duration === 0 && prevRawPrevTime > 0)) {
						callback = "onReverseComplete";
						isComplete = this._reversed;
					}
					if (time < 0) {
						this._active = false;
						if (duration === 0) if (this._initted || !this.vars.lazy || force) { //zero-duration tweens are tricky because we must discern the momentum/direction of time in order to determine whether the starting values should be rendered or the ending values. If the "playhead" of its timeline goes past the zero-duration tween in the forward direction or lands directly on it, the end values should be rendered, but if the timeline's "playhead" moves past it in the backward direction (from a postitive time to a negative time), the starting values must be rendered.
							if (prevRawPrevTime >= 0 && !(prevRawPrevTime === _tinyNum && this.data === "isPause")) {
								force = true;
							}
							this._rawPrevTime = rawPrevTime = (!suppressEvents || time || prevRawPrevTime === time) ? time : _tinyNum; //when the playhead arrives at EXACTLY time 0 (right on top) of a zero-duration tween, we need to discern if events are suppressed so that when the playhead moves again (next time), it'll trigger the callback. If events are NOT suppressed, obviously the callback would be triggered in this render. Basically, the callback should fire either when the playhead ARRIVES or LEAVES this exact spot, not both. Imagine doing a timeline.seek(0) and there's a callback that sits at 0. Since events are suppressed on that seek() by default, nothing will fire, but when the playhead moves off of that position, the callback should fire. This behavior is what people intuitively expect. We set the _rawPrevTime to be a precise tiny number to indicate this scenario rather than using another property/variable which would increase memory usage. This technique is less readable, but more efficient.
						}
					}
					if (!this._initted || (this._startAt && this._startAt.progress())) { //if we render the very beginning (time == 0) of a fromTo(), we must force the render (normal tweens wouldn't need to render at a time of 0 when the prevTime was also 0). This is also mandatory to make sure overwriting kicks in immediately. Also, we check progress() because if startAt has already rendered at its end, we should force a render at its beginning. Otherwise, if you put the playhead directly on top of where a fromTo({immediateRender:false}) starts, and then move it backwards, the from() won't revert its values.
						force = true;
					}
				} else {
					this._totalTime = this._time = time;
	
					if (this._easeType) {
						var r = time / duration, type = this._easeType, pow = this._easePower;
						if (type === 1 || (type === 3 && r >= 0.5)) {
							r = 1 - r;
						}
						if (type === 3) {
							r *= 2;
						}
						if (pow === 1) {
							r *= r;
						} else if (pow === 2) {
							r *= r * r;
						} else if (pow === 3) {
							r *= r * r * r;
						} else if (pow === 4) {
							r *= r * r * r * r;
						}
	
						if (type === 1) {
							this.ratio = 1 - r;
						} else if (type === 2) {
							this.ratio = r;
						} else if (time / duration < 0.5) {
							this.ratio = r / 2;
						} else {
							this.ratio = 1 - (r / 2);
						}
	
					} else {
						this.ratio = this._ease.getRatio(time / duration);
					}
				}
	
				if (this._time === prevTime && !force) {
					return;
				} else if (!this._initted) {
					this._init();
					if (!this._initted || this._gc) { //immediateRender tweens typically won't initialize until the playhead advances (_time is greater than 0) in order to ensure that overwriting occurs properly. Also, if all of the tweening properties have been overwritten (which would cause _gc to be true, as set in _init()), we shouldn't continue otherwise an onStart callback could be called for example.
						return;
					} else if (!force && this._firstPT && ((this.vars.lazy !== false && this._duration) || (this.vars.lazy && !this._duration))) {
						this._time = this._totalTime = prevTime;
						this._rawPrevTime = prevRawPrevTime;
						_lazyTweens.push(this);
						this._lazy = [time, suppressEvents];
						return;
					}
					//_ease is initially set to defaultEase, so now that init() has run, _ease is set properly and we need to recalculate the ratio. Overall this is faster than using conditional logic earlier in the method to avoid having to set ratio twice because we only init() once but renderTime() gets called VERY frequently.
					if (this._time && !isComplete) {
						this.ratio = this._ease.getRatio(this._time / duration);
					} else if (isComplete && this._ease._calcEnd) {
						this.ratio = this._ease.getRatio((this._time === 0) ? 0 : 1);
					}
				}
				if (this._lazy !== false) { //in case a lazy render is pending, we should flush it because the new render is occurring now (imagine a lazy tween instantiating and then immediately the user calls tween.seek(tween.duration()), skipping to the end - the end render would be forced, and then if we didn't flush the lazy render, it'd fire AFTER the seek(), rendering it at the wrong time.
					this._lazy = false;
				}
				if (!this._active) if (!this._paused && this._time !== prevTime && time >= 0) {
					this._active = true;  //so that if the user renders a tween (as opposed to the timeline rendering it), the timeline is forced to re-render and align it with the proper time/frame on the next rendering cycle. Maybe the tween already finished but the user manually re-renders it as halfway done.
				}
				if (prevTime === 0) {
					if (this._startAt) {
						if (time >= 0) {
							this._startAt.render(time, true, force);
						} else if (!callback) {
							callback = "_dummyGS"; //if no callback is defined, use a dummy value just so that the condition at the end evaluates as true because _startAt should render AFTER the normal render loop when the time is negative. We could handle this in a more intuitive way, of course, but the render loop is the MOST important thing to optimize, so this technique allows us to avoid adding extra conditional logic in a high-frequency area.
						}
					}
					if (this.vars.onStart) if (this._time !== 0 || duration === 0) if (!suppressEvents) {
						this._callback("onStart");
					}
				}
				pt = this._firstPT;
				while (pt) {
					if (pt.f) {
						pt.t[pt.p](pt.c * this.ratio + pt.s);
					} else {
						pt.t[pt.p] = pt.c * this.ratio + pt.s;
					}
					pt = pt._next;
				}
	
				if (this._onUpdate) {
					if (time < 0) if (this._startAt && time !== -0.0001) { //if the tween is positioned at the VERY beginning (_startTime 0) of its parent timeline, it's illegal for the playhead to go back further, so we should not render the recorded startAt values.
						this._startAt.render(time, true, force); //note: for performance reasons, we tuck this conditional logic inside less traveled areas (most tweens don't have an onUpdate). We'd just have it at the end before the onComplete, but the values should be updated before any onUpdate is called, so we ALSO put it here and then if it's not called, we do so later near the onComplete.
					}
					if (!suppressEvents) if (this._time !== prevTime || isComplete || force) {
						this._callback("onUpdate");
					}
				}
				if (callback) if (!this._gc || force) { //check _gc because there's a chance that kill() could be called in an onUpdate
					if (time < 0 && this._startAt && !this._onUpdate && time !== -0.0001) { //-0.0001 is a special value that we use when looping back to the beginning of a repeated TimelineMax, in which case we shouldn't render the _startAt values.
						this._startAt.render(time, true, force);
					}
					if (isComplete) {
						if (this._timeline.autoRemoveChildren) {
							this._enabled(false, false);
						}
						this._active = false;
					}
					if (!suppressEvents && this.vars[callback]) {
						this._callback(callback);
					}
					if (duration === 0 && this._rawPrevTime === _tinyNum && rawPrevTime !== _tinyNum) { //the onComplete or onReverseComplete could trigger movement of the playhead and for zero-duration tweens (which must discern direction) that land directly back on their start time, we don't want to fire again on the next render. Think of several addPause()'s in a timeline that forces the playhead to a certain spot, but what if it's already paused and another tween is tweening the "time" of the timeline? Each time it moves [forward] past that spot, it would move back, and since suppressEvents is true, it'd reset _rawPrevTime to _tinyNum so that when it begins again, the callback would fire (so ultimately it could bounce back and forth during that tween). Again, this is a very uncommon scenario, but possible nonetheless.
						this._rawPrevTime = 0;
					}
				}
			};
	
			p._kill = function(vars, target, overwritingTween) {
				if (vars === "all") {
					vars = null;
				}
				if (vars == null) if (target == null || target === this.target) {
					this._lazy = false;
					return this._enabled(false, false);
				}
				target = (typeof(target) !== "string") ? (target || this._targets || this.target) : TweenLite.selector(target) || target;
				var simultaneousOverwrite = (overwritingTween && this._time && overwritingTween._startTime === this._startTime && this._timeline === overwritingTween._timeline),
					i, overwrittenProps, p, pt, propLookup, changed, killProps, record, killed;
				if ((_isArray(target) || _isSelector(target)) && typeof(target[0]) !== "number") {
					i = target.length;
					while (--i > -1) {
						if (this._kill(vars, target[i], overwritingTween)) {
							changed = true;
						}
					}
				} else {
					if (this._targets) {
						i = this._targets.length;
						while (--i > -1) {
							if (target === this._targets[i]) {
								propLookup = this._propLookup[i] || {};
								this._overwrittenProps = this._overwrittenProps || [];
								overwrittenProps = this._overwrittenProps[i] = vars ? this._overwrittenProps[i] || {} : "all";
								break;
							}
						}
					} else if (target !== this.target) {
						return false;
					} else {
						propLookup = this._propLookup;
						overwrittenProps = this._overwrittenProps = vars ? this._overwrittenProps || {} : "all";
					}
	
					if (propLookup) {
						killProps = vars || propLookup;
						record = (vars !== overwrittenProps && overwrittenProps !== "all" && vars !== propLookup && (typeof(vars) !== "object" || !vars._tempKill)); //_tempKill is a super-secret way to delete a particular tweening property but NOT have it remembered as an official overwritten property (like in BezierPlugin)
						if (overwritingTween && (TweenLite.onOverwrite || this.vars.onOverwrite)) {
							for (p in killProps) {
								if (propLookup[p]) {
									if (!killed) {
										killed = [];
									}
									killed.push(p);
								}
							}
							if ((killed || !vars) && !_onOverwrite(this, overwritingTween, target, killed)) { //if the onOverwrite returned false, that means the user wants to override the overwriting (cancel it).
								return false;
							}
						}
	
						for (p in killProps) {
							if ((pt = propLookup[p])) {
								if (simultaneousOverwrite) { //if another tween overwrites this one and they both start at exactly the same time, yet this tween has already rendered once (for example, at 0.001) because it's first in the queue, we should revert the values to where they were at 0 so that the starting values aren't contaminated on the overwriting tween.
									if (pt.f) {
										pt.t[pt.p](pt.s);
									} else {
										pt.t[pt.p] = pt.s;
									}
									changed = true;
								}
								if (pt.pg && pt.t._kill(killProps)) {
									changed = true; //some plugins need to be notified so they can perform cleanup tasks first
								}
								if (!pt.pg || pt.t._overwriteProps.length === 0) {
									if (pt._prev) {
										pt._prev._next = pt._next;
									} else if (pt === this._firstPT) {
										this._firstPT = pt._next;
									}
									if (pt._next) {
										pt._next._prev = pt._prev;
									}
									pt._next = pt._prev = null;
								}
								delete propLookup[p];
							}
							if (record) {
								overwrittenProps[p] = 1;
							}
						}
						if (!this._firstPT && this._initted) { //if all tweening properties are killed, kill the tween. Without this line, if there's a tween with multiple targets and then you killTweensOf() each target individually, the tween would technically still remain active and fire its onComplete even though there aren't any more properties tweening.
							this._enabled(false, false);
						}
					}
				}
				return changed;
			};
	
			p.invalidate = function() {
				if (this._notifyPluginsOfEnabled) {
					TweenLite._onPluginEvent("_onDisable", this);
				}
				this._firstPT = this._overwrittenProps = this._startAt = this._onUpdate = null;
				this._notifyPluginsOfEnabled = this._active = this._lazy = false;
				this._propLookup = (this._targets) ? {} : [];
				Animation.prototype.invalidate.call(this);
				if (this.vars.immediateRender) {
					this._time = -_tinyNum; //forces a render without having to set the render() "force" parameter to true because we want to allow lazying by default (using the "force" parameter always forces an immediate full render)
					this.render(Math.min(0, -this._delay)); //in case delay is negative.
				}
				return this;
			};
	
			p._enabled = function(enabled, ignoreTimeline) {
				if (!_tickerActive) {
					_ticker.wake();
				}
				if (enabled && this._gc) {
					var targets = this._targets,
						i;
					if (targets) {
						i = targets.length;
						while (--i > -1) {
							this._siblings[i] = _register(targets[i], this, true);
						}
					} else {
						this._siblings = _register(this.target, this, true);
					}
				}
				Animation.prototype._enabled.call(this, enabled, ignoreTimeline);
				if (this._notifyPluginsOfEnabled) if (this._firstPT) {
					return TweenLite._onPluginEvent((enabled ? "_onEnable" : "_onDisable"), this);
				}
				return false;
			};
	
	
	//----TweenLite static methods -----------------------------------------------------
	
			TweenLite.to = function(target, duration, vars) {
				return new TweenLite(target, duration, vars);
			};
	
			TweenLite.from = function(target, duration, vars) {
				vars.runBackwards = true;
				vars.immediateRender = (vars.immediateRender != false);
				return new TweenLite(target, duration, vars);
			};
	
			TweenLite.fromTo = function(target, duration, fromVars, toVars) {
				toVars.startAt = fromVars;
				toVars.immediateRender = (toVars.immediateRender != false && fromVars.immediateRender != false);
				return new TweenLite(target, duration, toVars);
			};
	
			TweenLite.delayedCall = function(delay, callback, params, scope, useFrames) {
				return new TweenLite(callback, 0, {delay:delay, onComplete:callback, onCompleteParams:params, callbackScope:scope, onReverseComplete:callback, onReverseCompleteParams:params, immediateRender:false, lazy:false, useFrames:useFrames, overwrite:0});
			};
	
			TweenLite.set = function(target, vars) {
				return new TweenLite(target, 0, vars);
			};
	
			TweenLite.getTweensOf = function(target, onlyActive) {
				if (target == null) { return []; }
				target = (typeof(target) !== "string") ? target : TweenLite.selector(target) || target;
				var i, a, j, t;
				if ((_isArray(target) || _isSelector(target)) && typeof(target[0]) !== "number") {
					i = target.length;
					a = [];
					while (--i > -1) {
						a = a.concat(TweenLite.getTweensOf(target[i], onlyActive));
					}
					i = a.length;
					//now get rid of any duplicates (tweens of arrays of objects could cause duplicates)
					while (--i > -1) {
						t = a[i];
						j = i;
						while (--j > -1) {
							if (t === a[j]) {
								a.splice(i, 1);
							}
						}
					}
				} else if (target._gsTweenID) {
					a = _register(target).concat();
					i = a.length;
					while (--i > -1) {
						if (a[i]._gc || (onlyActive && !a[i].isActive())) {
							a.splice(i, 1);
						}
					}
				}
				return a || [];
			};
	
			TweenLite.killTweensOf = TweenLite.killDelayedCallsTo = function(target, onlyActive, vars) {
				if (typeof(onlyActive) === "object") {
					vars = onlyActive; //for backwards compatibility (before "onlyActive" parameter was inserted)
					onlyActive = false;
				}
				var a = TweenLite.getTweensOf(target, onlyActive),
					i = a.length;
				while (--i > -1) {
					a[i]._kill(vars, target);
				}
			};
	
	
	
	/*
	 * ----------------------------------------------------------------
	 * TweenPlugin   (could easily be split out as a separate file/class, but included for ease of use (so that people don't need to include another script call before loading plugins which is easy to forget)
	 * ----------------------------------------------------------------
	 */
			var TweenPlugin = _class("plugins.TweenPlugin", function(props, priority) {
						this._overwriteProps = (props || "").split(",");
						this._propName = this._overwriteProps[0];
						this._priority = priority || 0;
						this._super = TweenPlugin.prototype;
					}, true);
	
			p = TweenPlugin.prototype;
			TweenPlugin.version = "1.19.0";
			TweenPlugin.API = 2;
			p._firstPT = null;
			p._addTween = _addPropTween;
			p.setRatio = _setRatio;
	
			p._kill = function(lookup) {
				var a = this._overwriteProps,
					pt = this._firstPT,
					i;
				if (lookup[this._propName] != null) {
					this._overwriteProps = [];
				} else {
					i = a.length;
					while (--i > -1) {
						if (lookup[a[i]] != null) {
							a.splice(i, 1);
						}
					}
				}
				while (pt) {
					if (lookup[pt.n] != null) {
						if (pt._next) {
							pt._next._prev = pt._prev;
						}
						if (pt._prev) {
							pt._prev._next = pt._next;
							pt._prev = null;
						} else if (this._firstPT === pt) {
							this._firstPT = pt._next;
						}
					}
					pt = pt._next;
				}
				return false;
			};
	
			p._mod = p._roundProps = function(lookup) {
				var pt = this._firstPT,
					val;
				while (pt) {
					val = lookup[this._propName] || (pt.n != null && lookup[ pt.n.split(this._propName + "_").join("") ]);
					if (val && typeof(val) === "function") { //some properties that are very plugin-specific add a prefix named after the _propName plus an underscore, so we need to ignore that extra stuff here.
						if (pt.f === 2) {
							pt.t._applyPT.m = val;
						} else {
							pt.m = val;
						}
					}
					pt = pt._next;
				}
			};
	
			TweenLite._onPluginEvent = function(type, tween) {
				var pt = tween._firstPT,
					changed, pt2, first, last, next;
				if (type === "_onInitAllProps") {
					//sorts the PropTween linked list in order of priority because some plugins need to render earlier/later than others, like MotionBlurPlugin applies its effects after all x/y/alpha tweens have rendered on each frame.
					while (pt) {
						next = pt._next;
						pt2 = first;
						while (pt2 && pt2.pr > pt.pr) {
							pt2 = pt2._next;
						}
						if ((pt._prev = pt2 ? pt2._prev : last)) {
							pt._prev._next = pt;
						} else {
							first = pt;
						}
						if ((pt._next = pt2)) {
							pt2._prev = pt;
						} else {
							last = pt;
						}
						pt = next;
					}
					pt = tween._firstPT = first;
				}
				while (pt) {
					if (pt.pg) if (typeof(pt.t[type]) === "function") if (pt.t[type]()) {
						changed = true;
					}
					pt = pt._next;
				}
				return changed;
			};
	
			TweenPlugin.activate = function(plugins) {
				var i = plugins.length;
				while (--i > -1) {
					if (plugins[i].API === TweenPlugin.API) {
						_plugins[(new plugins[i]())._propName] = plugins[i];
					}
				}
				return true;
			};
	
			//provides a more concise way to define plugins that have no dependencies besides TweenPlugin and TweenLite, wrapping common boilerplate stuff into one function (added in 1.9.0). You don't NEED to use this to define a plugin - the old way still works and can be useful in certain (rare) situations.
			_gsDefine.plugin = function(config) {
				if (!config || !config.propName || !config.init || !config.API) { throw "illegal plugin definition."; }
				var propName = config.propName,
					priority = config.priority || 0,
					overwriteProps = config.overwriteProps,
					map = {init:"_onInitTween", set:"setRatio", kill:"_kill", round:"_mod", mod:"_mod", initAll:"_onInitAllProps"},
					Plugin = _class("plugins." + propName.charAt(0).toUpperCase() + propName.substr(1) + "Plugin",
						function() {
							TweenPlugin.call(this, propName, priority);
							this._overwriteProps = overwriteProps || [];
						}, (config.global === true)),
					p = Plugin.prototype = new TweenPlugin(propName),
					prop;
				p.constructor = Plugin;
				Plugin.API = config.API;
				for (prop in map) {
					if (typeof(config[prop]) === "function") {
						p[map[prop]] = config[prop];
					}
				}
				Plugin.version = config.version;
				TweenPlugin.activate([Plugin]);
				return Plugin;
			};
	
	
			//now run through all the dependencies discovered and if any are missing, log that to the console as a warning. This is why it's best to have TweenLite load last - it can check all the dependencies for you.
			a = window._gsQueue;
			if (a) {
				for (i = 0; i < a.length; i++) {
					a[i]();
				}
				for (p in _defLookup) {
					if (!_defLookup[p].func) {
						window.console.log("GSAP encountered missing dependency: " + p);
					}
				}
			}
	
			_tickerActive = false; //ensures that the first official animation forces a ticker.tick() to update the time when it is instantiated
	
	})((typeof(module) !== "undefined" && module.exports && typeof(global) !== "undefined") ? global : this || window, "TweenLite");
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 172 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	/**
	 * Indicates that navigation was caused by a call to history.push.
	 */
	var PUSH = exports.PUSH = 'PUSH';
	
	/**
	 * Indicates that navigation was caused by a call to history.replace.
	 */
	var REPLACE = exports.REPLACE = 'REPLACE';
	
	/**
	 * Indicates that navigation was caused by some other action such
	 * as using a browser's back/forward buttons and/or manually manipulating
	 * the URL in a browser's location bar. This is the default.
	 *
	 * See https://developer.mozilla.org/en-US/docs/Web/API/WindowEventHandlers/onpopstate
	 * for more information.
	 */
	var POP = exports.POP = 'POP';

/***/ },
/* 173 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	var addEventListener = exports.addEventListener = function addEventListener(node, event, listener) {
	  return node.addEventListener ? node.addEventListener(event, listener, false) : node.attachEvent('on' + event, listener);
	};
	
	var removeEventListener = exports.removeEventListener = function removeEventListener(node, event, listener) {
	  return node.removeEventListener ? node.removeEventListener(event, listener, false) : node.detachEvent('on' + event, listener);
	};
	
	/**
	 * Returns true if the HTML5 history API is supported. Taken from Modernizr.
	 *
	 * https://github.com/Modernizr/Modernizr/blob/master/LICENSE
	 * https://github.com/Modernizr/Modernizr/blob/master/feature-detects/history.js
	 * changed to avoid false negatives for Windows Phones: https://github.com/reactjs/react-router/issues/586
	 */
	var supportsHistory = exports.supportsHistory = function supportsHistory() {
	  var ua = window.navigator.userAgent;
	
	  if ((ua.indexOf('Android 2.') !== -1 || ua.indexOf('Android 4.0') !== -1) && ua.indexOf('Mobile Safari') !== -1 && ua.indexOf('Chrome') === -1 && ua.indexOf('Windows Phone') === -1) return false;
	
	  return window.history && 'pushState' in window.history;
	};
	
	/**
	 * Returns false if using go(n) with hash history causes a full page reload.
	 */
	var supportsGoWithoutReloadUsingHash = exports.supportsGoWithoutReloadUsingHash = function supportsGoWithoutReloadUsingHash() {
	  return window.navigator.userAgent.indexOf('Firefox') === -1;
	};
	
	/**
	 * Returns true if browser fires popstate on hash change.
	 * IE10 and IE11 do not.
	 */
	var supportsPopstateOnHashchange = exports.supportsPopstateOnHashchange = function supportsPopstateOnHashchange() {
	  return window.navigator.userAgent.indexOf('Trident') === -1;
	};
	
	/**
	 * Returns true if a given popstate event is an extraneous WebKit event.
	 * Accounts for the fact that Chrome on iOS fires real popstate events
	 * containing undefined state when pressing the back button.
	 */
	var isExtraneousPopstateEvent = exports.isExtraneousPopstateEvent = function isExtraneousPopstateEvent(event) {
	  return event.state === undefined && navigator.userAgent.indexOf('CriOS') === -1;
	};

/***/ },
/* 174 */
/***/ function(module, exports, __webpack_require__) {

	var listCacheClear = __webpack_require__(904),
	    listCacheDelete = __webpack_require__(905),
	    listCacheGet = __webpack_require__(906),
	    listCacheHas = __webpack_require__(907),
	    listCacheSet = __webpack_require__(908);
	
	/**
	 * Creates an list cache object.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function ListCache(entries) {
	  var index = -1,
	      length = entries == null ? 0 : entries.length;
	
	  this.clear();
	  while (++index < length) {
	    var entry = entries[index];
	    this.set(entry[0], entry[1]);
	  }
	}
	
	// Add methods to `ListCache`.
	ListCache.prototype.clear = listCacheClear;
	ListCache.prototype['delete'] = listCacheDelete;
	ListCache.prototype.get = listCacheGet;
	ListCache.prototype.has = listCacheHas;
	ListCache.prototype.set = listCacheSet;
	
	module.exports = ListCache;


/***/ },
/* 175 */
/***/ function(module, exports, __webpack_require__) {

	var root = __webpack_require__(89);
	
	/** Built-in value references. */
	var Symbol = root.Symbol;
	
	module.exports = Symbol;


/***/ },
/* 176 */
/***/ function(module, exports, __webpack_require__) {

	var eq = __webpack_require__(244);
	
	/**
	 * Gets the index at which the `key` is found in `array` of key-value pairs.
	 *
	 * @private
	 * @param {Array} array The array to inspect.
	 * @param {*} key The key to search for.
	 * @returns {number} Returns the index of the matched value, else `-1`.
	 */
	function assocIndexOf(array, key) {
	  var length = array.length;
	  while (length--) {
	    if (eq(array[length][0], key)) {
	      return length;
	    }
	  }
	  return -1;
	}
	
	module.exports = assocIndexOf;


/***/ },
/* 177 */
/***/ function(module, exports, __webpack_require__) {

	var isKeyable = __webpack_require__(901);
	
	/**
	 * Gets the data for `map`.
	 *
	 * @private
	 * @param {Object} map The map to query.
	 * @param {string} key The reference key.
	 * @returns {*} Returns the map data.
	 */
	function getMapData(map, key) {
	  var data = map.__data__;
	  return isKeyable(key)
	    ? data[typeof key == 'string' ? 'string' : 'hash']
	    : data.map;
	}
	
	module.exports = getMapData;


/***/ },
/* 178 */
/***/ function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__(125);
	
	/* Built-in method references that are verified to be native. */
	var nativeCreate = getNative(Object, 'create');
	
	module.exports = nativeCreate;


/***/ },
/* 179 */
/***/ function(module, exports, __webpack_require__) {

	var isSymbol = __webpack_require__(181);
	
	/** Used as references for various `Number` constants. */
	var INFINITY = 1 / 0;
	
	/**
	 * Converts `value` to a string key if it's not a string or symbol.
	 *
	 * @private
	 * @param {*} value The value to inspect.
	 * @returns {string|symbol} Returns the key.
	 */
	function toKey(value) {
	  if (typeof value == 'string' || isSymbol(value)) {
	    return value;
	  }
	  var result = (value + '');
	  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
	}
	
	module.exports = toKey;


/***/ },
/* 180 */
/***/ function(module, exports, __webpack_require__) {

	var isFunction = __webpack_require__(371),
	    isLength = __webpack_require__(245);
	
	/**
	 * Checks if `value` is array-like. A value is considered array-like if it's
	 * not a function and has a `value.length` that's an integer greater than or
	 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
	 * @example
	 *
	 * _.isArrayLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isArrayLike(document.body.children);
	 * // => true
	 *
	 * _.isArrayLike('abc');
	 * // => true
	 *
	 * _.isArrayLike(_.noop);
	 * // => false
	 */
	function isArrayLike(value) {
	  return value != null && isLength(value.length) && !isFunction(value);
	}
	
	module.exports = isArrayLike;


/***/ },
/* 181 */
/***/ function(module, exports, __webpack_require__) {

	var baseGetTag = __webpack_require__(124),
	    isObjectLike = __webpack_require__(126);
	
	/** `Object#toString` result references. */
	var symbolTag = '[object Symbol]';
	
	/**
	 * Checks if `value` is classified as a `Symbol` primitive or object.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
	 * @example
	 *
	 * _.isSymbol(Symbol.iterator);
	 * // => true
	 *
	 * _.isSymbol('abc');
	 * // => false
	 */
	function isSymbol(value) {
	  return typeof value == 'symbol' ||
	    (isObjectLike(value) && baseGetTag(value) == symbolTag);
	}
	
	module.exports = isSymbol;


/***/ },
/* 182 */
/***/ function(module, exports, __webpack_require__) {

	var arrayLikeKeys = __webpack_require__(857),
	    baseKeys = __webpack_require__(871),
	    isArrayLike = __webpack_require__(180);
	
	/**
	 * Creates an array of the own enumerable property names of `object`.
	 *
	 * **Note:** Non-object values are coerced to objects. See the
	 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
	 * for more details.
	 *
	 * @static
	 * @since 0.1.0
	 * @memberOf _
	 * @category Object
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 *   this.b = 2;
	 * }
	 *
	 * Foo.prototype.c = 3;
	 *
	 * _.keys(new Foo);
	 * // => ['a', 'b'] (iteration order is not guaranteed)
	 *
	 * _.keys('hi');
	 * // => ['0', '1']
	 */
	function keys(object) {
	  return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
	}
	
	module.exports = keys;


/***/ },
/* 183 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * mux.js
	 *
	 * Copyright (c) 2015 Brightcove
	 * All rights reserved.
	 *
	 * Utilities to detect basic properties and metadata about MP4s.
	 */
	'use strict';
	
	var toUnsigned = __webpack_require__(957).toUnsigned;
	var findBox, parseType, timescale, startTime, getVideoTrackIds;
	
	// Find the data for a box specified by its path
	findBox = function(data, path) {
	  var results = [],
	      i, size, type, end, subresults;
	
	  if (!path.length) {
	    // short-circuit the search for empty paths
	    return null;
	  }
	
	  for (i = 0; i < data.byteLength;) {
	    size  = toUnsigned(data[i]     << 24 |
	                       data[i + 1] << 16 |
	                       data[i + 2] <<  8 |
	                       data[i + 3]);
	
	    type = parseType(data.subarray(i + 4, i + 8));
	
	    end = size > 1 ? i + size : data.byteLength;
	
	    if (type === path[0]) {
	      if (path.length === 1) {
	        // this is the end of the path and we've found the box we were
	        // looking for
	        results.push(data.subarray(i + 8, end));
	      } else {
	        // recursively search for the next box along the path
	        subresults = findBox(data.subarray(i + 8, end), path.slice(1));
	        if (subresults.length) {
	          results = results.concat(subresults);
	        }
	      }
	    }
	    i = end;
	  }
	
	  // we've finished searching all of data
	  return results;
	};
	
	/**
	 * Returns the string representation of an ASCII encoded four byte buffer.
	 * @param buffer {Uint8Array} a four-byte buffer to translate
	 * @return {string} the corresponding string
	 */
	parseType = function(buffer) {
	  var result = '';
	  result += String.fromCharCode(buffer[0]);
	  result += String.fromCharCode(buffer[1]);
	  result += String.fromCharCode(buffer[2]);
	  result += String.fromCharCode(buffer[3]);
	  return result;
	};
	
	/**
	 * Parses an MP4 initialization segment and extracts the timescale
	 * values for any declared tracks. Timescale values indicate the
	 * number of clock ticks per second to assume for time-based values
	 * elsewhere in the MP4.
	 *
	 * To determine the start time of an MP4, you need two pieces of
	 * information: the timescale unit and the earliest base media decode
	 * time. Multiple timescales can be specified within an MP4 but the
	 * base media decode time is always expressed in the timescale from
	 * the media header box for the track:
	 * ```
	 * moov > trak > mdia > mdhd.timescale
	 * ```
	 * @param init {Uint8Array} the bytes of the init segment
	 * @return {object} a hash of track ids to timescale values or null if
	 * the init segment is malformed.
	 */
	timescale = function(init) {
	  var
	    result = {},
	    traks = findBox(init, ['moov', 'trak']);
	
	  // mdhd timescale
	  return traks.reduce(function(result, trak) {
	    var tkhd, version, index, id, mdhd;
	
	    tkhd = findBox(trak, ['tkhd'])[0];
	    if (!tkhd) {
	      return null;
	    }
	    version = tkhd[0];
	    index = version === 0 ? 12 : 20;
	    id = toUnsigned(tkhd[index]     << 24 |
	                    tkhd[index + 1] << 16 |
	                    tkhd[index + 2] <<  8 |
	                    tkhd[index + 3]);
	
	    mdhd = findBox(trak, ['mdia', 'mdhd'])[0];
	    if (!mdhd) {
	      return null;
	    }
	    version = mdhd[0];
	    index = version === 0 ? 12 : 20;
	    result[id] = toUnsigned(mdhd[index]     << 24 |
	                            mdhd[index + 1] << 16 |
	                            mdhd[index + 2] <<  8 |
	                            mdhd[index + 3]);
	    return result;
	  }, result);
	};
	
	/**
	 * Determine the base media decode start time, in seconds, for an MP4
	 * fragment. If multiple fragments are specified, the earliest time is
	 * returned.
	 *
	 * The base media decode time can be parsed from track fragment
	 * metadata:
	 * ```
	 * moof > traf > tfdt.baseMediaDecodeTime
	 * ```
	 * It requires the timescale value from the mdhd to interpret.
	 *
	 * @param timescale {object} a hash of track ids to timescale values.
	 * @return {number} the earliest base media decode start time for the
	 * fragment, in seconds
	 */
	startTime = function(timescale, fragment) {
	  var trafs, baseTimes, result;
	
	  // we need info from two childrend of each track fragment box
	  trafs = findBox(fragment, ['moof', 'traf']);
	
	  // determine the start times for each track
	  baseTimes = [].concat.apply([], trafs.map(function(traf) {
	    return findBox(traf, ['tfhd']).map(function(tfhd) {
	      var id, scale, baseTime;
	
	      // get the track id from the tfhd
	      id = toUnsigned(tfhd[4] << 24 |
	                      tfhd[5] << 16 |
	                      tfhd[6] <<  8 |
	                      tfhd[7]);
	      // assume a 90kHz clock if no timescale was specified
	      scale = timescale[id] || 90e3;
	
	      // get the base media decode time from the tfdt
	      baseTime = findBox(traf, ['tfdt']).map(function(tfdt) {
	        var version, result;
	
	        version = tfdt[0];
	        result = toUnsigned(tfdt[4] << 24 |
	                            tfdt[5] << 16 |
	                            tfdt[6] <<  8 |
	                            tfdt[7]);
	        if (version ===  1) {
	          result *= Math.pow(2, 32);
	          result += toUnsigned(tfdt[8]  << 24 |
	                               tfdt[9]  << 16 |
	                               tfdt[10] <<  8 |
	                               tfdt[11]);
	        }
	        return result;
	      })[0];
	      baseTime = baseTime || Infinity;
	
	      // convert base time to seconds
	      return baseTime / scale;
	    });
	  }));
	
	  // return the minimum
	  result = Math.min.apply(null, baseTimes);
	  return isFinite(result) ? result : 0;
	};
	
	/**
	  * Find the trackIds of the video tracks in this source.
	  * Found by parsing the Handler Reference and Track Header Boxes:
	  *   moov > trak > mdia > hdlr
	  *   moov > trak > tkhd
	  *
	  * @param {Uint8Array} init - The bytes of the init segment for this source
	  * @return {Number[]} A list of trackIds
	  *
	  * @see ISO-BMFF-12/2015, Section 8.4.3
	 **/
	getVideoTrackIds = function(init) {
	  var traks = findBox(init, ['moov', 'trak']);
	  var videoTrackIds = [];
	
	  traks.forEach(function(trak) {
	    var hdlrs = findBox(trak, ['mdia', 'hdlr']);
	    var tkhds = findBox(trak, ['tkhd']);
	
	    hdlrs.forEach(function(hdlr, index) {
	      var handlerType = parseType(hdlr.subarray(8, 12));
	      var tkhd = tkhds[index];
	      var view;
	      var version;
	      var trackId;
	
	      if (handlerType === 'vide') {
	        view = new DataView(tkhd.buffer, tkhd.byteOffset, tkhd.byteLength);
	        version = view.getUint8(0);
	        trackId = (version === 0) ? view.getUint32(12) : view.getUint32(20);
	
	        videoTrackIds.push(trackId);
	      }
	    });
	  });
	
	  return videoTrackIds;
	};
	
	module.exports = {
	  findBox: findBox,
	  parseType: parseType,
	  timescale: timescale,
	  startTime: startTime,
	  videoTrackIds: getVideoTrackIds
	};


/***/ },
/* 184 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(36);
	
	var EventPluginRegistry = __webpack_require__(250);
	var ReactEventEmitterMixin = __webpack_require__(992);
	var ViewportMetrics = __webpack_require__(399);
	
	var getVendorPrefixedEventName = __webpack_require__(1023);
	var isEventSupported = __webpack_require__(262);
	
	/**
	 * Summary of `ReactBrowserEventEmitter` event handling:
	 *
	 *  - Top-level delegation is used to trap most native browser events. This
	 *    may only occur in the main thread and is the responsibility of
	 *    ReactEventListener, which is injected and can therefore support pluggable
	 *    event sources. This is the only work that occurs in the main thread.
	 *
	 *  - We normalize and de-duplicate events to account for browser quirks. This
	 *    may be done in the worker thread.
	 *
	 *  - Forward these native events (with the associated top-level type used to
	 *    trap it) to `EventPluginHub`, which in turn will ask plugins if they want
	 *    to extract any synthetic events.
	 *
	 *  - The `EventPluginHub` will then process each event by annotating them with
	 *    "dispatches", a sequence of listeners and IDs that care about that event.
	 *
	 *  - The `EventPluginHub` then dispatches the events.
	 *
	 * Overview of React and the event system:
	 *
	 * +------------+    .
	 * |    DOM     |    .
	 * +------------+    .
	 *       |           .
	 *       v           .
	 * +------------+    .
	 * | ReactEvent |    .
	 * |  Listener  |    .
	 * +------------+    .                         +-----------+
	 *       |           .               +--------+|SimpleEvent|
	 *       |           .               |         |Plugin     |
	 * +-----|------+    .               v         +-----------+
	 * |     |      |    .    +--------------+                    +------------+
	 * |     +-----------.--->|EventPluginHub|                    |    Event   |
	 * |            |    .    |              |     +-----------+  | Propagators|
	 * | ReactEvent |    .    |              |     |TapEvent   |  |------------|
	 * |  Emitter   |    .    |              |<---+|Plugin     |  |other plugin|
	 * |            |    .    |              |     +-----------+  |  utilities |
	 * |     +-----------.--->|              |                    +------------+
	 * |     |      |    .    +--------------+
	 * +-----|------+    .                ^        +-----------+
	 *       |           .                |        |Enter/Leave|
	 *       +           .                +-------+|Plugin     |
	 * +-------------+   .                         +-----------+
	 * | application |   .
	 * |-------------|   .
	 * |             |   .
	 * |             |   .
	 * +-------------+   .
	 *                   .
	 *    React Core     .  General Purpose Event Plugin System
	 */
	
	var hasEventPageXY;
	var alreadyListeningTo = {};
	var isMonitoringScrollValue = false;
	var reactTopListenersCounter = 0;
	
	// For events like 'submit' which don't consistently bubble (which we trap at a
	// lower node than `document`), binding at `document` would cause duplicate
	// events so we don't include them here
	var topEventMapping = {
	  topAbort: 'abort',
	  topAnimationEnd: getVendorPrefixedEventName('animationend') || 'animationend',
	  topAnimationIteration: getVendorPrefixedEventName('animationiteration') || 'animationiteration',
	  topAnimationStart: getVendorPrefixedEventName('animationstart') || 'animationstart',
	  topBlur: 'blur',
	  topCanPlay: 'canplay',
	  topCanPlayThrough: 'canplaythrough',
	  topChange: 'change',
	  topClick: 'click',
	  topCompositionEnd: 'compositionend',
	  topCompositionStart: 'compositionstart',
	  topCompositionUpdate: 'compositionupdate',
	  topContextMenu: 'contextmenu',
	  topCopy: 'copy',
	  topCut: 'cut',
	  topDoubleClick: 'dblclick',
	  topDrag: 'drag',
	  topDragEnd: 'dragend',
	  topDragEnter: 'dragenter',
	  topDragExit: 'dragexit',
	  topDragLeave: 'dragleave',
	  topDragOver: 'dragover',
	  topDragStart: 'dragstart',
	  topDrop: 'drop',
	  topDurationChange: 'durationchange',
	  topEmptied: 'emptied',
	  topEncrypted: 'encrypted',
	  topEnded: 'ended',
	  topError: 'error',
	  topFocus: 'focus',
	  topInput: 'input',
	  topKeyDown: 'keydown',
	  topKeyPress: 'keypress',
	  topKeyUp: 'keyup',
	  topLoadedData: 'loadeddata',
	  topLoadedMetadata: 'loadedmetadata',
	  topLoadStart: 'loadstart',
	  topMouseDown: 'mousedown',
	  topMouseMove: 'mousemove',
	  topMouseOut: 'mouseout',
	  topMouseOver: 'mouseover',
	  topMouseUp: 'mouseup',
	  topPaste: 'paste',
	  topPause: 'pause',
	  topPlay: 'play',
	  topPlaying: 'playing',
	  topProgress: 'progress',
	  topRateChange: 'ratechange',
	  topScroll: 'scroll',
	  topSeeked: 'seeked',
	  topSeeking: 'seeking',
	  topSelectionChange: 'selectionchange',
	  topStalled: 'stalled',
	  topSuspend: 'suspend',
	  topTextInput: 'textInput',
	  topTimeUpdate: 'timeupdate',
	  topTouchCancel: 'touchcancel',
	  topTouchEnd: 'touchend',
	  topTouchMove: 'touchmove',
	  topTouchStart: 'touchstart',
	  topTransitionEnd: getVendorPrefixedEventName('transitionend') || 'transitionend',
	  topVolumeChange: 'volumechange',
	  topWaiting: 'waiting',
	  topWheel: 'wheel'
	};
	
	/**
	 * To ensure no conflicts with other potential React instances on the page
	 */
	var topListenersIDKey = '_reactListenersID' + String(Math.random()).slice(2);
	
	function getListeningForDocument(mountAt) {
	  // In IE8, `mountAt` is a host object and doesn't have `hasOwnProperty`
	  // directly.
	  if (!Object.prototype.hasOwnProperty.call(mountAt, topListenersIDKey)) {
	    mountAt[topListenersIDKey] = reactTopListenersCounter++;
	    alreadyListeningTo[mountAt[topListenersIDKey]] = {};
	  }
	  return alreadyListeningTo[mountAt[topListenersIDKey]];
	}
	
	/**
	 * `ReactBrowserEventEmitter` is used to attach top-level event listeners. For
	 * example:
	 *
	 *   EventPluginHub.putListener('myID', 'onClick', myFunction);
	 *
	 * This would allocate a "registration" of `('onClick', myFunction)` on 'myID'.
	 *
	 * @internal
	 */
	var ReactBrowserEventEmitter = _assign({}, ReactEventEmitterMixin, {
	  /**
	   * Injectable event backend
	   */
	  ReactEventListener: null,
	
	  injection: {
	    /**
	     * @param {object} ReactEventListener
	     */
	    injectReactEventListener: function (ReactEventListener) {
	      ReactEventListener.setHandleTopLevel(ReactBrowserEventEmitter.handleTopLevel);
	      ReactBrowserEventEmitter.ReactEventListener = ReactEventListener;
	    }
	  },
	
	  /**
	   * Sets whether or not any created callbacks should be enabled.
	   *
	   * @param {boolean} enabled True if callbacks should be enabled.
	   */
	  setEnabled: function (enabled) {
	    if (ReactBrowserEventEmitter.ReactEventListener) {
	      ReactBrowserEventEmitter.ReactEventListener.setEnabled(enabled);
	    }
	  },
	
	  /**
	   * @return {boolean} True if callbacks are enabled.
	   */
	  isEnabled: function () {
	    return !!(ReactBrowserEventEmitter.ReactEventListener && ReactBrowserEventEmitter.ReactEventListener.isEnabled());
	  },
	
	  /**
	   * We listen for bubbled touch events on the document object.
	   *
	   * Firefox v8.01 (and possibly others) exhibited strange behavior when
	   * mounting `onmousemove` events at some node that was not the document
	   * element. The symptoms were that if your mouse is not moving over something
	   * contained within that mount point (for example on the background) the
	   * top-level listeners for `onmousemove` won't be called. However, if you
	   * register the `mousemove` on the document object, then it will of course
	   * catch all `mousemove`s. This along with iOS quirks, justifies restricting
	   * top-level listeners to the document object only, at least for these
	   * movement types of events and possibly all events.
	   *
	   * @see http://www.quirksmode.org/blog/archives/2010/09/click_event_del.html
	   *
	   * Also, `keyup`/`keypress`/`keydown` do not bubble to the window on IE, but
	   * they bubble to document.
	   *
	   * @param {string} registrationName Name of listener (e.g. `onClick`).
	   * @param {object} contentDocumentHandle Document which owns the container
	   */
	  listenTo: function (registrationName, contentDocumentHandle) {
	    var mountAt = contentDocumentHandle;
	    var isListening = getListeningForDocument(mountAt);
	    var dependencies = EventPluginRegistry.registrationNameDependencies[registrationName];
	
	    for (var i = 0; i < dependencies.length; i++) {
	      var dependency = dependencies[i];
	      if (!(isListening.hasOwnProperty(dependency) && isListening[dependency])) {
	        if (dependency === 'topWheel') {
	          if (isEventSupported('wheel')) {
	            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topWheel', 'wheel', mountAt);
	          } else if (isEventSupported('mousewheel')) {
	            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topWheel', 'mousewheel', mountAt);
	          } else {
	            // Firefox needs to capture a different mouse scroll event.
	            // @see http://www.quirksmode.org/dom/events/tests/scroll.html
	            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topWheel', 'DOMMouseScroll', mountAt);
	          }
	        } else if (dependency === 'topScroll') {
	          if (isEventSupported('scroll', true)) {
	            ReactBrowserEventEmitter.ReactEventListener.trapCapturedEvent('topScroll', 'scroll', mountAt);
	          } else {
	            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topScroll', 'scroll', ReactBrowserEventEmitter.ReactEventListener.WINDOW_HANDLE);
	          }
	        } else if (dependency === 'topFocus' || dependency === 'topBlur') {
	          if (isEventSupported('focus', true)) {
	            ReactBrowserEventEmitter.ReactEventListener.trapCapturedEvent('topFocus', 'focus', mountAt);
	            ReactBrowserEventEmitter.ReactEventListener.trapCapturedEvent('topBlur', 'blur', mountAt);
	          } else if (isEventSupported('focusin')) {
	            // IE has `focusin` and `focusout` events which bubble.
	            // @see http://www.quirksmode.org/blog/archives/2008/04/delegating_the.html
	            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topFocus', 'focusin', mountAt);
	            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topBlur', 'focusout', mountAt);
	          }
	
	          // to make sure blur and focus event listeners are only attached once
	          isListening.topBlur = true;
	          isListening.topFocus = true;
	        } else if (topEventMapping.hasOwnProperty(dependency)) {
	          ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent(dependency, topEventMapping[dependency], mountAt);
	        }
	
	        isListening[dependency] = true;
	      }
	    }
	  },
	
	  trapBubbledEvent: function (topLevelType, handlerBaseName, handle) {
	    return ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent(topLevelType, handlerBaseName, handle);
	  },
	
	  trapCapturedEvent: function (topLevelType, handlerBaseName, handle) {
	    return ReactBrowserEventEmitter.ReactEventListener.trapCapturedEvent(topLevelType, handlerBaseName, handle);
	  },
	
	  /**
	   * Protect against document.createEvent() returning null
	   * Some popup blocker extensions appear to do this:
	   * https://github.com/facebook/react/issues/6887
	   */
	  supportsEventPageXY: function () {
	    if (!document.createEvent) {
	      return false;
	    }
	    var ev = document.createEvent('MouseEvent');
	    return ev != null && 'pageX' in ev;
	  },
	
	  /**
	   * Listens to window scroll and resize events. We cache scroll values so that
	   * application code can access them without triggering reflows.
	   *
	   * ViewportMetrics is only used by SyntheticMouse/TouchEvent and only when
	   * pageX/pageY isn't supported (legacy browsers).
	   *
	   * NOTE: Scroll events do not bubble.
	   *
	   * @see http://www.quirksmode.org/dom/events/scroll.html
	   */
	  ensureScrollValueMonitoring: function () {
	    if (hasEventPageXY === undefined) {
	      hasEventPageXY = ReactBrowserEventEmitter.supportsEventPageXY();
	    }
	    if (!hasEventPageXY && !isMonitoringScrollValue) {
	      var refresh = ViewportMetrics.refreshScrollValues;
	      ReactBrowserEventEmitter.ReactEventListener.monitorScrollValue(refresh);
	      isMonitoringScrollValue = true;
	    }
	  }
	});
	
	module.exports = ReactBrowserEventEmitter;

/***/ },
/* 185 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var SyntheticUIEvent = __webpack_require__(147);
	var ViewportMetrics = __webpack_require__(399);
	
	var getEventModifierState = __webpack_require__(259);
	
	/**
	 * @interface MouseEvent
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var MouseEventInterface = {
	  screenX: null,
	  screenY: null,
	  clientX: null,
	  clientY: null,
	  ctrlKey: null,
	  shiftKey: null,
	  altKey: null,
	  metaKey: null,
	  getModifierState: getEventModifierState,
	  button: function (event) {
	    // Webkit, Firefox, IE9+
	    // which:  1 2 3
	    // button: 0 1 2 (standard)
	    var button = event.button;
	    if ('which' in event) {
	      return button;
	    }
	    // IE<9
	    // which:  undefined
	    // button: 0 0 0
	    // button: 1 4 2 (onmouseup)
	    return button === 2 ? 2 : button === 4 ? 1 : 0;
	  },
	  buttons: null,
	  relatedTarget: function (event) {
	    return event.relatedTarget || (event.fromElement === event.srcElement ? event.toElement : event.fromElement);
	  },
	  // "Proprietary" Interface.
	  pageX: function (event) {
	    return 'pageX' in event ? event.pageX : event.clientX + ViewportMetrics.currentScrollLeft;
	  },
	  pageY: function (event) {
	    return 'pageY' in event ? event.pageY : event.clientY + ViewportMetrics.currentScrollTop;
	  }
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticMouseEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticUIEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticUIEvent.augmentClass(SyntheticMouseEvent, MouseEventInterface);
	
	module.exports = SyntheticMouseEvent;

/***/ },
/* 186 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(29);
	
	var invariant = __webpack_require__(21);
	
	var OBSERVED_ERROR = {};
	
	/**
	 * `Transaction` creates a black box that is able to wrap any method such that
	 * certain invariants are maintained before and after the method is invoked
	 * (Even if an exception is thrown while invoking the wrapped method). Whoever
	 * instantiates a transaction can provide enforcers of the invariants at
	 * creation time. The `Transaction` class itself will supply one additional
	 * automatic invariant for you - the invariant that any transaction instance
	 * should not be run while it is already being run. You would typically create a
	 * single instance of a `Transaction` for reuse multiple times, that potentially
	 * is used to wrap several different methods. Wrappers are extremely simple -
	 * they only require implementing two methods.
	 *
	 * <pre>
	 *                       wrappers (injected at creation time)
	 *                                      +        +
	 *                                      |        |
	 *                    +-----------------|--------|--------------+
	 *                    |                 v        |              |
	 *                    |      +---------------+   |              |
	 *                    |   +--|    wrapper1   |---|----+         |
	 *                    |   |  +---------------+   v    |         |
	 *                    |   |          +-------------+  |         |
	 *                    |   |     +----|   wrapper2  |--------+   |
	 *                    |   |     |    +-------------+  |     |   |
	 *                    |   |     |                     |     |   |
	 *                    |   v     v                     v     v   | wrapper
	 *                    | +---+ +---+   +---------+   +---+ +---+ | invariants
	 * perform(anyMethod) | |   | |   |   |         |   |   | |   | | maintained
	 * +----------------->|-|---|-|---|-->|anyMethod|---|---|-|---|-|-------->
	 *                    | |   | |   |   |         |   |   | |   | |
	 *                    | |   | |   |   |         |   |   | |   | |
	 *                    | |   | |   |   |         |   |   | |   | |
	 *                    | +---+ +---+   +---------+   +---+ +---+ |
	 *                    |  initialize                    close    |
	 *                    +-----------------------------------------+
	 * </pre>
	 *
	 * Use cases:
	 * - Preserving the input selection ranges before/after reconciliation.
	 *   Restoring selection even in the event of an unexpected error.
	 * - Deactivating events while rearranging the DOM, preventing blurs/focuses,
	 *   while guaranteeing that afterwards, the event system is reactivated.
	 * - Flushing a queue of collected DOM mutations to the main UI thread after a
	 *   reconciliation takes place in a worker thread.
	 * - Invoking any collected `componentDidUpdate` callbacks after rendering new
	 *   content.
	 * - (Future use case): Wrapping particular flushes of the `ReactWorker` queue
	 *   to preserve the `scrollTop` (an automatic scroll aware DOM).
	 * - (Future use case): Layout calculations before and after DOM updates.
	 *
	 * Transactional plugin API:
	 * - A module that has an `initialize` method that returns any precomputation.
	 * - and a `close` method that accepts the precomputation. `close` is invoked
	 *   when the wrapped process is completed, or has failed.
	 *
	 * @param {Array<TransactionalWrapper>} transactionWrapper Wrapper modules
	 * that implement `initialize` and `close`.
	 * @return {Transaction} Single transaction for reuse in thread.
	 *
	 * @class Transaction
	 */
	var TransactionImpl = {
	  /**
	   * Sets up this instance so that it is prepared for collecting metrics. Does
	   * so such that this setup method may be used on an instance that is already
	   * initialized, in a way that does not consume additional memory upon reuse.
	   * That can be useful if you decide to make your subclass of this mixin a
	   * "PooledClass".
	   */
	  reinitializeTransaction: function () {
	    this.transactionWrappers = this.getTransactionWrappers();
	    if (this.wrapperInitData) {
	      this.wrapperInitData.length = 0;
	    } else {
	      this.wrapperInitData = [];
	    }
	    this._isInTransaction = false;
	  },
	
	  _isInTransaction: false,
	
	  /**
	   * @abstract
	   * @return {Array<TransactionWrapper>} Array of transaction wrappers.
	   */
	  getTransactionWrappers: null,
	
	  isInTransaction: function () {
	    return !!this._isInTransaction;
	  },
	
	  /* eslint-disable space-before-function-paren */
	
	  /**
	   * Executes the function within a safety window. Use this for the top level
	   * methods that result in large amounts of computation/mutations that would
	   * need to be safety checked. The optional arguments helps prevent the need
	   * to bind in many cases.
	   *
	   * @param {function} method Member of scope to call.
	   * @param {Object} scope Scope to invoke from.
	   * @param {Object?=} a Argument to pass to the method.
	   * @param {Object?=} b Argument to pass to the method.
	   * @param {Object?=} c Argument to pass to the method.
	   * @param {Object?=} d Argument to pass to the method.
	   * @param {Object?=} e Argument to pass to the method.
	   * @param {Object?=} f Argument to pass to the method.
	   *
	   * @return {*} Return value from `method`.
	   */
	  perform: function (method, scope, a, b, c, d, e, f) {
	    /* eslint-enable space-before-function-paren */
	    !!this.isInTransaction() ?  false ? invariant(false, 'Transaction.perform(...): Cannot initialize a transaction when there is already an outstanding transaction.') : _prodInvariant('27') : void 0;
	    var errorThrown;
	    var ret;
	    try {
	      this._isInTransaction = true;
	      // Catching errors makes debugging more difficult, so we start with
	      // errorThrown set to true before setting it to false after calling
	      // close -- if it's still set to true in the finally block, it means
	      // one of these calls threw.
	      errorThrown = true;
	      this.initializeAll(0);
	      ret = method.call(scope, a, b, c, d, e, f);
	      errorThrown = false;
	    } finally {
	      try {
	        if (errorThrown) {
	          // If `method` throws, prefer to show that stack trace over any thrown
	          // by invoking `closeAll`.
	          try {
	            this.closeAll(0);
	          } catch (err) {}
	        } else {
	          // Since `method` didn't throw, we don't want to silence the exception
	          // here.
	          this.closeAll(0);
	        }
	      } finally {
	        this._isInTransaction = false;
	      }
	    }
	    return ret;
	  },
	
	  initializeAll: function (startIndex) {
	    var transactionWrappers = this.transactionWrappers;
	    for (var i = startIndex; i < transactionWrappers.length; i++) {
	      var wrapper = transactionWrappers[i];
	      try {
	        // Catching errors makes debugging more difficult, so we start with the
	        // OBSERVED_ERROR state before overwriting it with the real return value
	        // of initialize -- if it's still set to OBSERVED_ERROR in the finally
	        // block, it means wrapper.initialize threw.
	        this.wrapperInitData[i] = OBSERVED_ERROR;
	        this.wrapperInitData[i] = wrapper.initialize ? wrapper.initialize.call(this) : null;
	      } finally {
	        if (this.wrapperInitData[i] === OBSERVED_ERROR) {
	          // The initializer for wrapper i threw an error; initialize the
	          // remaining wrappers but silence any exceptions from them to ensure
	          // that the first error is the one to bubble up.
	          try {
	            this.initializeAll(i + 1);
	          } catch (err) {}
	        }
	      }
	    }
	  },
	
	  /**
	   * Invokes each of `this.transactionWrappers.close[i]` functions, passing into
	   * them the respective return values of `this.transactionWrappers.init[i]`
	   * (`close`rs that correspond to initializers that failed will not be
	   * invoked).
	   */
	  closeAll: function (startIndex) {
	    !this.isInTransaction() ?  false ? invariant(false, 'Transaction.closeAll(): Cannot close transaction when none are open.') : _prodInvariant('28') : void 0;
	    var transactionWrappers = this.transactionWrappers;
	    for (var i = startIndex; i < transactionWrappers.length; i++) {
	      var wrapper = transactionWrappers[i];
	      var initData = this.wrapperInitData[i];
	      var errorThrown;
	      try {
	        // Catching errors makes debugging more difficult, so we start with
	        // errorThrown set to true before setting it to false after calling
	        // close -- if it's still set to true in the finally block, it means
	        // wrapper.close threw.
	        errorThrown = true;
	        if (initData !== OBSERVED_ERROR && wrapper.close) {
	          wrapper.close.call(this, initData);
	        }
	        errorThrown = false;
	      } finally {
	        if (errorThrown) {
	          // The closer for wrapper i threw an error; close the remaining
	          // wrappers but silence any exceptions from them to ensure that the
	          // first error is the one to bubble up.
	          try {
	            this.closeAll(i + 1);
	          } catch (e) {}
	        }
	      }
	    }
	    this.wrapperInitData.length = 0;
	  }
	};
	
	module.exports = TransactionImpl;

/***/ },
/* 187 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2016-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * Based on the escape-html library, which is used under the MIT License below:
	 *
	 * Copyright (c) 2012-2013 TJ Holowaychuk
	 * Copyright (c) 2015 Andreas Lubbe
	 * Copyright (c) 2015 Tiancheng "Timothy" Gu
	 *
	 * Permission is hereby granted, free of charge, to any person obtaining
	 * a copy of this software and associated documentation files (the
	 * 'Software'), to deal in the Software without restriction, including
	 * without limitation the rights to use, copy, modify, merge, publish,
	 * distribute, sublicense, and/or sell copies of the Software, and to
	 * permit persons to whom the Software is furnished to do so, subject to
	 * the following conditions:
	 *
	 * The above copyright notice and this permission notice shall be
	 * included in all copies or substantial portions of the Software.
	 *
	 * THE SOFTWARE IS PROVIDED 'AS IS', WITHOUT WARRANTY OF ANY KIND,
	 * EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	 * MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT.
	 * IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY
	 * CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT,
	 * TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE
	 * SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
	 *
	 */
	
	'use strict';
	
	// code copied and modified from escape-html
	/**
	 * Module variables.
	 * @private
	 */
	
	var matchHtmlRegExp = /["'&<>]/;
	
	/**
	 * Escape special characters in the given string of html.
	 *
	 * @param  {string} string The string to escape for inserting into HTML
	 * @return {string}
	 * @public
	 */
	
	function escapeHtml(string) {
	  var str = '' + string;
	  var match = matchHtmlRegExp.exec(str);
	
	  if (!match) {
	    return str;
	  }
	
	  var escape;
	  var html = '';
	  var index = 0;
	  var lastIndex = 0;
	
	  for (index = match.index; index < str.length; index++) {
	    switch (str.charCodeAt(index)) {
	      case 34:
	        // "
	        escape = '&quot;';
	        break;
	      case 38:
	        // &
	        escape = '&amp;';
	        break;
	      case 39:
	        // '
	        escape = '&#x27;'; // modified from escape-html; used to be '&#39'
	        break;
	      case 60:
	        // <
	        escape = '&lt;';
	        break;
	      case 62:
	        // >
	        escape = '&gt;';
	        break;
	      default:
	        continue;
	    }
	
	    if (lastIndex !== index) {
	      html += str.substring(lastIndex, index);
	    }
	
	    lastIndex = index + 1;
	    html += escape;
	  }
	
	  return lastIndex !== index ? html + str.substring(lastIndex, index) : html;
	}
	// end code copied and modified from escape-html
	
	/**
	 * Escapes text to prevent scripting attacks.
	 *
	 * @param {*} text Text value to escape.
	 * @return {string} An escaped string.
	 */
	function escapeTextContentForBrowser(text) {
	  if (typeof text === 'boolean' || typeof text === 'number') {
	    // this shortcircuit helps perf for types that we know will never have
	    // special characters, especially given that this function is used often
	    // for numeric dom ids.
	    return '' + text;
	  }
	  return escapeHtml(text);
	}
	
	module.exports = escapeTextContentForBrowser;

/***/ },
/* 188 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ExecutionEnvironment = __webpack_require__(51);
	var DOMNamespaces = __webpack_require__(249);
	
	var WHITESPACE_TEST = /^[ \r\n\t\f]/;
	var NONVISIBLE_TEST = /<(!--|link|noscript|meta|script|style)[ \r\n\t\f\/>]/;
	
	var createMicrosoftUnsafeLocalFunction = __webpack_require__(257);
	
	// SVG temp container for IE lacking innerHTML
	var reusableSVGContainer;
	
	/**
	 * Set the innerHTML property of a node, ensuring that whitespace is preserved
	 * even in IE8.
	 *
	 * @param {DOMElement} node
	 * @param {string} html
	 * @internal
	 */
	var setInnerHTML = createMicrosoftUnsafeLocalFunction(function (node, html) {
	  // IE does not have innerHTML for SVG nodes, so instead we inject the
	  // new markup in a temp node and then move the child nodes across into
	  // the target node
	  if (node.namespaceURI === DOMNamespaces.svg && !('innerHTML' in node)) {
	    reusableSVGContainer = reusableSVGContainer || document.createElement('div');
	    reusableSVGContainer.innerHTML = '<svg>' + html + '</svg>';
	    var svgNode = reusableSVGContainer.firstChild;
	    while (svgNode.firstChild) {
	      node.appendChild(svgNode.firstChild);
	    }
	  } else {
	    node.innerHTML = html;
	  }
	});
	
	if (ExecutionEnvironment.canUseDOM) {
	  // IE8: When updating a just created node with innerHTML only leading
	  // whitespace is removed. When updating an existing node with innerHTML
	  // whitespace in root TextNodes is also collapsed.
	  // @see quirksmode.org/bugreports/archives/2004/11/innerhtml_and_t.html
	
	  // Feature detection; only IE8 is known to behave improperly like this.
	  var testElement = document.createElement('div');
	  testElement.innerHTML = ' ';
	  if (testElement.innerHTML === '') {
	    setInnerHTML = function (node, html) {
	      // Magic theory: IE8 supposedly differentiates between added and updated
	      // nodes when processing innerHTML, innerHTML on updated nodes suffers
	      // from worse whitespace behavior. Re-adding a node like this triggers
	      // the initial and more favorable whitespace behavior.
	      // TODO: What to do on a detached node?
	      if (node.parentNode) {
	        node.parentNode.replaceChild(node, node);
	      }
	
	      // We also implement a workaround for non-visible tags disappearing into
	      // thin air on IE8, this only happens if there is no visible text
	      // in-front of the non-visible tags. Piggyback on the whitespace fix
	      // and simply check if any non-visible tags appear in the source.
	      if (WHITESPACE_TEST.test(html) || html[0] === '<' && NONVISIBLE_TEST.test(html)) {
	        // Recover leading whitespace by temporarily prepending any character.
	        // \uFEFF has the potential advantage of being zero-width/invisible.
	        // UglifyJS drops U+FEFF chars when parsing, so use String.fromCharCode
	        // in hopes that this is preserved even if "\uFEFF" is transformed to
	        // the actual Unicode character (by Babel, for example).
	        // https://github.com/mishoo/UglifyJS2/blob/v2.4.20/lib/parse.js#L216
	        node.innerHTML = String.fromCharCode(0xfeff) + html;
	
	        // deleteData leaves an empty `TextNode` which offsets the index of all
	        // children. Definitely want to avoid this.
	        var textNode = node.firstChild;
	        if (textNode.data.length === 1) {
	          node.removeChild(textNode);
	        } else {
	          textNode.deleteData(0, 1);
	        }
	      } else {
	        node.innerHTML = html;
	      }
	    };
	  }
	  testElement = null;
	}
	
	module.exports = setInnerHTML;

/***/ },
/* 189 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _props2 = __webpack_require__(190);
	
	var _utils = __webpack_require__(63);
	
	var _players = __webpack_require__(1032);
	
	var _players2 = _interopRequireDefault(_players);
	
	var _Player3 = __webpack_require__(265);
	
	var _Player4 = _interopRequireDefault(_Player3);
	
	var _FilePlayer = __webpack_require__(409);
	
	var _preload = __webpack_require__(1033);
	
	var _preload2 = _interopRequireDefault(_preload);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var SUPPORTED_PROPS = Object.keys(_props2.propTypes);
	
	var customPlayers = [];
	
	var ReactPlayer = function (_Component) {
	  _inherits(ReactPlayer, _Component);
	
	  function ReactPlayer() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, ReactPlayer);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = ReactPlayer.__proto__ || Object.getPrototypeOf(ReactPlayer)).call.apply(_ref, [this].concat(args))), _this), _this.config = (0, _utils.getConfig)(_this.props, _props2.defaultProps, true), _this.getDuration = function () {
	      if (!_this.player) return null;
	      return _this.player.getDuration();
	    }, _this.getCurrentTime = function () {
	      if (!_this.player) return null;
	      return _this.player.getCurrentTime();
	    }, _this.getSecondsLoaded = function () {
	      if (!_this.player) return null;
	      return _this.player.getSecondsLoaded();
	    }, _this.getInternalPlayer = function () {
	      var key = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'player';
	
	      if (!_this.player) return null;
	      return _this.player.getInternalPlayer(key);
	    }, _this.seekTo = function (fraction) {
	      if (!_this.player) return null;
	      _this.player.seekTo(fraction);
	    }, _this.onReady = function () {
	      _this.props.onReady(_this);
	    }, _this.wrapperRef = function (wrapper) {
	      _this.wrapper = wrapper;
	    }, _this.activePlayerRef = function (player) {
	      _this.player = player;
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(ReactPlayer, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      if (this.props.progressFrequency) {
	        var message = 'ReactPlayer: %cprogressFrequency%c is deprecated, please use %cprogressInterval%c instead';
	        console.warn(message, 'font-weight: bold', '', 'font-weight: bold', '');
	      }
	    }
	  }, {
	    key: 'shouldComponentUpdate',
	    value: function shouldComponentUpdate(nextProps) {
	      return !(0, _utils.isEqual)(this.props, nextProps);
	    }
	  }, {
	    key: 'componentWillUpdate',
	    value: function componentWillUpdate(nextProps) {
	      this.config = (0, _utils.getConfig)(nextProps, _props2.defaultProps);
	    }
	  }, {
	    key: 'getActivePlayer',
	    value: function getActivePlayer(url) {
	      var _arr = [].concat(_toConsumableArray(customPlayers), _toConsumableArray(_players2['default']));
	
	      for (var _i = 0; _i < _arr.length; _i++) {
	        var _Player = _arr[_i];
	        if (_Player.canPlay(url)) {
	          return _Player;
	        }
	      }
	      // Fall back to FilePlayer if nothing else can play the URL
	      return _FilePlayer.FilePlayer;
	    }
	  }, {
	    key: 'renderActivePlayer',
	    value: function renderActivePlayer(url) {
	      if (!url) return null;
	      var activePlayer = this.getActivePlayer(url);
	      return _react2['default'].createElement(_Player4['default'], _extends({}, this.props, {
	        key: activePlayer.displayName,
	        ref: this.activePlayerRef,
	        config: this.config,
	        activePlayer: activePlayer,
	        onReady: this.onReady
	      }));
	    }
	  }, {
	    key: 'sortPlayers',
	    value: function sortPlayers(a, b) {
	      // Retain player order to prevent weird iframe behaviour when switching players
	      if (a && b) {
	        return a.key < b.key ? -1 : 1;
	      }
	      return 0;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          url = _props.url,
	          style = _props.style,
	          width = _props.width,
	          height = _props.height,
	          Wrapper = _props.wrapper;
	
	      var otherProps = (0, _utils.omit)(this.props, SUPPORTED_PROPS, _props2.DEPRECATED_CONFIG_PROPS);
	      var activePlayer = this.renderActivePlayer(url);
	      var preloadPlayers = (0, _preload2['default'])(url, this.config);
	      var players = [activePlayer].concat(_toConsumableArray(preloadPlayers)).sort(this.sortPlayers);
	      return _react2['default'].createElement(
	        Wrapper,
	        _extends({ ref: this.wrapperRef, style: _extends({}, style, { width: width, height: height }) }, otherProps),
	        players
	      );
	    }
	  }]);
	
	  return ReactPlayer;
	}(_react.Component);
	
	ReactPlayer.addCustomPlayer = function (player) {
	  customPlayers.push(player);
	};
	
	ReactPlayer.removeCustomPlayers = function () {
	  customPlayers = [];
	};
	
	ReactPlayer.displayName = 'ReactPlayer';
	ReactPlayer.propTypes = _props2.propTypes;
	ReactPlayer.defaultProps = _props2.defaultProps;
	
	ReactPlayer.canPlay = function (url) {
	  var _arr2 = [].concat(_toConsumableArray(customPlayers), _toConsumableArray(_players2['default']));
	
	  for (var _i2 = 0; _i2 < _arr2.length; _i2++) {
	    var _Player2 = _arr2[_i2];
	    if (_Player2.canPlay(url)) {
	      return true;
	    }
	  }
	  return false;
	};
	
	exports['default'] = ReactPlayer;

/***/ },
/* 190 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.DEPRECATED_CONFIG_PROPS = exports.defaultProps = exports.propTypes = undefined;
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var string = _propTypes2['default'].string,
	    bool = _propTypes2['default'].bool,
	    number = _propTypes2['default'].number,
	    array = _propTypes2['default'].array,
	    oneOfType = _propTypes2['default'].oneOfType,
	    shape = _propTypes2['default'].shape,
	    object = _propTypes2['default'].object,
	    func = _propTypes2['default'].func;
	var propTypes = exports.propTypes = {
	  url: oneOfType([string, array, object]),
	  playing: bool,
	  loop: bool,
	  controls: bool,
	  volume: number,
	  muted: bool,
	  playbackRate: number,
	  width: oneOfType([string, number]),
	  height: oneOfType([string, number]),
	  style: object,
	  progressInterval: number,
	  playsinline: bool,
	  wrapper: oneOfType([string, func]),
	  config: shape({
	    soundcloud: shape({
	      options: object
	    }),
	    youtube: shape({
	      playerVars: object,
	      preload: bool
	    }),
	    facebook: shape({
	      appId: string
	    }),
	    dailymotion: shape({
	      params: object,
	      preload: bool
	    }),
	    vimeo: shape({
	      playerOptions: object,
	      preload: bool
	    }),
	    file: shape({
	      attributes: object,
	      tracks: array,
	      forceVideo: bool,
	      forceAudio: bool,
	      forceHLS: bool,
	      forceDASH: bool,
	      hlsOptions: object
	    }),
	    wistia: shape({
	      options: object
	    }),
	    mixcloud: shape({
	      options: object
	    }),
	    twitch: shape({
	      options: object
	    })
	  }),
	  onReady: func,
	  onStart: func,
	  onPlay: func,
	  onPause: func,
	  onBuffer: func,
	  onEnded: func,
	  onError: func,
	  onDuration: func,
	  onSeek: func,
	  onProgress: func
	};
	
	var defaultProps = exports.defaultProps = {
	  playing: false,
	  loop: false,
	  controls: false,
	  volume: null,
	  muted: false,
	  playbackRate: 1,
	  width: '640px',
	  height: '360px',
	  style: {},
	  progressInterval: 1000,
	  playsinline: false,
	  wrapper: 'div',
	  config: {
	    soundcloud: {
	      options: {
	        visual: true, // Undocumented, but makes player fill container and look better
	        buying: false,
	        liking: false,
	        download: false,
	        sharing: false,
	        show_comments: false,
	        show_playcount: false
	      }
	    },
	    youtube: {
	      playerVars: {
	        playsinline: 1,
	        showinfo: 0,
	        rel: 0,
	        iv_load_policy: 3,
	        modestbranding: 1
	      },
	      preload: false
	    },
	    facebook: {
	      appId: '1309697205772819'
	    },
	    dailymotion: {
	      params: {
	        api: 1,
	        'endscreen-enable': false
	      },
	      preload: false
	    },
	    vimeo: {
	      playerOptions: {
	        autopause: false,
	        byline: false,
	        portrait: false,
	        title: false
	      },
	      preload: false
	    },
	    file: {
	      attributes: {},
	      tracks: [],
	      forceVideo: false,
	      forceAudio: false,
	      forceHLS: false,
	      forceDASH: false,
	      hlsOptions: {}
	    },
	    wistia: {
	      options: {}
	    },
	    mixcloud: {
	      options: {
	        hide_cover: 1
	      }
	    },
	    twitch: {
	      options: {}
	    }
	  },
	  onReady: function onReady() {},
	  onStart: function onStart() {},
	  onPlay: function onPlay() {},
	  onPause: function onPause() {},
	  onBuffer: function onBuffer() {},
	  onEnded: function onEnded() {},
	  onError: function onError() {},
	  onDuration: function onDuration() {},
	  onSeek: function onSeek() {},
	  onProgress: function onProgress() {}
	};
	
	var DEPRECATED_CONFIG_PROPS = exports.DEPRECATED_CONFIG_PROPS = ['soundcloudConfig', 'youtubeConfig', 'facebookConfig', 'dailymotionConfig', 'vimeoConfig', 'fileConfig', 'wistiaConfig'];

/***/ },
/* 191 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	(function (root, factory) {
	    if (true) {
	        // AMD. Register as an anonymous module.
	        !(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	    } else if (typeof module === 'object' && module.exports) {
	        // Node. Does not work with strict CommonJS, but
	        // only CommonJS-like environments that support module.exports,
	        // like Node.
	        module.exports = factory();
	    } else {
	        // Browser globals (root is window)
	        root.striptags = factory();
	  }
	}(this, function () {
	
	    var STATE_OUTPUT       = 0,
	        STATE_HTML         = 1,
	        STATE_PRE_COMMENT  = 2,
	        STATE_COMMENT      = 3,
	        WHITESPACE         = /\s/,
	        ALLOWED_TAGS_REGEX = /<(\w*)>/g;
	
	    function striptags(html, allowableTags, tagReplacement) {
	        var html = html || '',
	            state = STATE_OUTPUT,
	            depth = 0,
	            output = '',
	            tagBuffer = '',
	            inQuote = false,
	            i, length, c;
	
	        if (typeof allowableTags === 'string') {
	            // Parse the string into an array of tags
	            allowableTags = parseAllowableTags(allowableTags);
	        } else if (!Array.isArray(allowableTags)) {
	            // If it is not an array, explicitly set to null
	            allowableTags = null;
	        }
	
	        for (i = 0, length = html.length; i < length; i++) {
	            c = html[i];
	
	            switch (c) {
	                case '<': {
	                    // ignore '<' if inside a quote
	                    if (inQuote) {
	                        break;
	                    }
	
	                    // '<' followed by a space is not a valid tag, continue
	                    if (html[i + 1] == ' ') {
	                        consumeCharacter(c);
	                        break;
	                    }
	
	                    // change to STATE_HTML
	                    if (state == STATE_OUTPUT) {
	                        state = STATE_HTML;
	
	                        consumeCharacter(c);
	                        break;
	                    }
	
	                    // ignore additional '<' characters when inside a tag
	                    if (state == STATE_HTML) {
	                        depth++;
	                        break;
	                    }
	
	                    consumeCharacter(c);
	                    break;
	                }
	
	                case '>': {
	                    // something like this is happening: '<<>>'
	                    if (depth) {
	                        depth--;
	                        break;
	                    }
	
	                    // ignore '>' if inside a quote
	                    if (inQuote) {
	                        break;
	                    }
	
	                    // an HTML tag was closed
	                    if (state == STATE_HTML) {
	                        inQuote = state = 0;
	
	                        if (allowableTags) {
	                            tagBuffer += '>';
	                            flushTagBuffer();
	                        }
	
	                        break;
	                    }
	
	                    // '<!' met its ending '>'
	                    if (state == STATE_PRE_COMMENT) {
	                        inQuote = state = 0;
	                        tagBuffer = '';
	                        break;
	                    }
	
	                    // if last two characters were '--', then end comment
	                    if (state == STATE_COMMENT &&
	                        html[i - 1] == '-' &&
	                        html[i - 2] == '-') {
	
	                        inQuote = state = 0;
	                        tagBuffer = '';
	                        break;
	                    }
	
	                    consumeCharacter(c);
	                    break;
	                }
	
	                // catch both single and double quotes
	                case '"':
	                case '\'': {
	                    if (state == STATE_HTML) {
	                        if (inQuote == c) {
	                            // end quote found
	                            inQuote = false;
	                        } else if (!inQuote) {
	                            // start quote only if not already in one
	                            inQuote = c;
	                        }
	                    }
	
	                    consumeCharacter(c);
	                    break;
	                }
	
	                case '!': {
	                    if (state == STATE_HTML &&
	                        html[i - 1] == '<') {
	
	                        // looks like we might be starting a comment
	                        state = STATE_PRE_COMMENT;
	                        break;
	                    }
	
	                    consumeCharacter(c);
	                    break;
	                }
	
	                case '-': {
	                    // if the previous two characters were '!-', this is a comment
	                    if (state == STATE_PRE_COMMENT &&
	                        html[i - 1] == '-' &&
	                        html[i - 2] == '!') {
	
	                        state = STATE_COMMENT;
	                        break;
	                    }
	
	                    consumeCharacter(c);
	                    break;
	                }
	
	                case 'E':
	                case 'e': {
	                    // check for DOCTYPE, because it looks like a comment and isn't
	                    if (state == STATE_PRE_COMMENT &&
	                        html.substr(i - 6, 7).toLowerCase() == 'doctype') {
	
	                        state = STATE_HTML;
	                        break;
	                    }
	
	                    consumeCharacter(c);
	                    break;
	                }
	
	                default: {
	                    consumeCharacter(c);
	                }
	            }
	        }
	
	        function consumeCharacter(c) {
	            if (state == STATE_OUTPUT) {
	                output += c;
	            } else if (allowableTags && state == STATE_HTML) {
	                tagBuffer += c;
	            }
	        }
	
	        function flushTagBuffer() {
	            var normalized = '',
	                nonWhitespaceSeen = false,
	                i, length, c;
	
	            normalizeTagBuffer:
	            for (i = 0, length = tagBuffer.length; i < length; i++) {
	                c = tagBuffer[i].toLowerCase();
	
	                switch (c) {
	                    case '<': {
	                        break;
	                    }
	
	                    case '>': {
	                        break normalizeTagBuffer;
	                    }
	
	                    case '/': {
	                        nonWhitespaceSeen = true;
	                        break;
	                    }
	
	                    default: {
	                        if (!c.match(WHITESPACE)) {
	                            nonWhitespaceSeen = true;
	                            normalized += c;
	                        } else if (nonWhitespaceSeen) {
	                            break normalizeTagBuffer;
	                        }
	                    }
	                }
	            }
	
	            if (allowableTags.indexOf(normalized) !== -1) {
	                output += tagBuffer;
	            } else if (tagReplacement) {
	                output += tagReplacement;
	            }
	
	            tagBuffer = '';
	        }
	
	        return output;
	    }
	
	    /**
	     * Return an array containing tags that are allowed to pass through the
	     * algorithm.
	     *
	     * @param string allowableTags A string of tags to allow (e.g. "<b><strong>").
	     * @return array|null An array of allowed tags or null if none.
	     */
	    function parseAllowableTags(allowableTags) {
	        var tagsArray = [],
	            match;
	
	        while ((match = ALLOWED_TAGS_REGEX.exec(allowableTags)) !== null) {
	            tagsArray.push(match[1]);
	        }
	
	        return tagsArray.length !== 0 ? tagsArray : null;
	    }
	
	    return striptags;
	}));


/***/ },
/* 192 */
/***/ function(module, exports) {

	module.exports = function(module) {
		if(!module.webpackPolyfill) {
			module.deprecate = function() {};
			module.paths = [];
			// module.parent = undefined by default
			module.children = [];
			module.webpackPolyfill = 1;
		}
		return module;
	}


/***/ },
/* 193 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var EmailInput = function EmailInput(_ref) {
	    var name = _ref.name,
	        label = _ref.label,
	        subLabel = _ref.subLabel,
	        onChange = _ref.onChange,
	        className = _ref.className,
	        placeholder = _ref.placeholder,
	        value = _ref.value,
	        error = _ref.error,
	        hideErrorMessage = _ref.hideErrorMessage;
	
	    var wrapperClass = 'form-group';
	    if (error && error.length > 0) {
	        wrapperClass += " " + 'has-error';
	    }
	
	    return _react2.default.createElement(
	        'div',
	        { className: wrapperClass },
	        _react2.default.createElement(
	            'label',
	            { htmlFor: name },
	            _react2.default.createElement(
	                'span',
	                null,
	                label
	            )
	        ),
	        _react2.default.createElement(
	            'div',
	            { className: 'field' },
	            _react2.default.createElement('input', {
	                type: 'email',
	                name: name,
	                className: className + ' form-control',
	                placeholder: placeholder,
	                value: value,
	                onChange: onChange
	            }),
	            error && typeof hideErrorMessage === 'undefined' && _react2.default.createElement(
	                'div',
	                { className: 'alert alert-danger' },
	                error
	            )
	        )
	    );
	};
	
	EmailInput.propTypes = {
	    name: _propTypes2.default.string.isRequired,
	    label: _propTypes2.default.string.isRequired,
	    subLabel: _propTypes2.default.string,
	    onChange: _propTypes2.default.func.isRequired,
	    className: _propTypes2.default.string,
	    placeholder: _propTypes2.default.string,
	    value: _propTypes2.default.string,
	    error: _propTypes2.default.string,
	    hideErrorMessage: _propTypes2.default.string
	};
	
	exports.default = EmailInput;

/***/ },
/* 194 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(5);
	
	var _redux = __webpack_require__(4);
	
	var _SelectionMenu = __webpack_require__(279);
	
	var _SelectionMenu2 = _interopRequireDefault(_SelectionMenu);
	
	var _userDataActions = __webpack_require__(20);
	
	var userDataActions = _interopRequireWildcard(_userDataActions);
	
	var _trackingDataActions = __webpack_require__(7);
	
	var trackingDataActions = _interopRequireWildcard(_trackingDataActions);
	
	var _appHelper = __webpack_require__(3);
	
	var appHelper = _interopRequireWildcard(_appHelper);
	
	var _dataHelper = __webpack_require__(11);
	
	var dataHelper = _interopRequireWildcard(_dataHelper);
	
	var _localStorage = __webpack_require__(17);
	
	var localStorage = _interopRequireWildcard(_localStorage);
	
	var _gsap = __webpack_require__(8);
	
	var _gsapReactPlugin = __webpack_require__(10);
	
	var _gsapReactPlugin2 = _interopRequireDefault(_gsapReactPlugin);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var LocalePicker = function (_React$Component) {
	    _inherits(LocalePicker, _React$Component);
	
	    function LocalePicker(props, context) {
	        _classCallCheck(this, LocalePicker);
	
	        var _this = _possibleConstructorReturn(this, (LocalePicker.__proto__ || Object.getPrototypeOf(LocalePicker)).call(this, props, context));
	
	        _this.state = {
	            showTitle: appHelper.isDefined(_this.props.showTitle) ? _this.props.showTitle : true,
	            userData: _this.props.userData,
	            contentData: _this.props.contentData,
	            currentSelection: {},
	            menuData: [],
	            onMenuSelect: _propTypes2.default.func,
	            idKey: "id",
	            labelKey: "label"
	        };
	        _this.setLocaleMenuData = _this.setLocaleMenuData.bind(_this);
	        _this.onMenuSelect = _this.onMenuSelect.bind(_this);
	        return _this;
	    }
	
	    _createClass(LocalePicker, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            this.setLocaleMenuData();
	        }
	    }, {
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(nextProps) {
	            if (this.state.userData !== nextProps.userData) {
	                var currentLang = appHelper.getArrayObjectByKey(localStorage.languages, "language_code", nextProps.userData.lang);
	                var currentSelection = {
	                    constant: currentLang.language_code,
	                    id: currentLang.language_id,
	                    label: this.state.showTitle ? currentLang.language_name + ' - <span class="title-case">' + currentLang.language_code + '</span>' : '<span class="title-case">' + currentLang.language_code + '<span/>'
	                };
	                this.setState({
	                    userData: nextProps.userData,
	                    currentSelection: Object.assign({}, currentSelection)
	                });
	            }
	        }
	    }, {
	        key: 'componentDidUpdate',
	        value: function componentDidUpdate() {}
	    }, {
	        key: 'setLocaleMenuData',
	        value: function setLocaleMenuData() {
	            var menuData = [];
	            var languages = localStorage.languages;
	
	            for (var i = 0; i < languages.length; i++) {
	                var lang = languages[i];
	                var menuItem = {
	                    constant: lang.language_code,
	                    id: lang.language_id,
	                    label: lang.language_name + ' - <span class="title-case">' + lang.language_code + '</span>'
	                };
	                menuData = dataHelper.immutablePush(menuData, menuItem);
	            }
	
	            var currentLang = appHelper.getArrayObjectByKey(localStorage.languages, "language_code", this.state.userData.lang);
	            var currentSelection = {
	                constant: currentLang.language_code,
	                id: currentLang.language_id,
	                label: this.state.showTitle ? currentLang.language_name + ' - <span class="title-case">' + currentLang.language_code + '</span>' : '<span class="title-case">' + currentLang.language_code + '<span/>'
	            };
	
	            this.setState({
	                menuData: Object.assign([], menuData),
	                currentSelection: Object.assign({}, currentSelection)
	
	            });
	        }
	    }, {
	        key: 'onMenuSelect',
	        value: function onMenuSelect(data) {
	            var _this2 = this;
	
	            this.props.actions.updateExperienceLocale(data.constant).then(function (userData) {
	                _this2.props.actions.setSuspendData(userData);
	            }).catch(function (error) {});
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            return this.state.menuData.length > 0 ? _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(_SelectionMenu2.default, { currentSelection: this.state.currentSelection, menuData: this.state.menuData, classExtention: 'locale-picker',
	                    idKey: this.state.idKey, labelKey: this.state.labelKey, onMenuSelect: this.onMenuSelect })
	            ) : _react2.default.createElement(
	                'p',
	                null,
	                'No Locale'
	            );
	        }
	    }]);
	
	    return LocalePicker;
	}(_react2.default.Component);
	
	LocalePicker.propTypes = {
	    showTitle: _propTypes2.default.bool,
	    userData: _propTypes2.default.object.isRequired,
	    contentData: _propTypes2.default.object.isRequired,
	    actions: _propTypes2.default.object.isRequired
	};
	
	LocalePicker.contextTypes = {
	    router: _propTypes2.default.object
	};
	
	function mapStateToProps(state, ownProps) {
	    var lang = state.userData.lang;
	    return {
	        contentData: state.contentData,
	        userData: state.userData
	
	    };
	}
	
	function mapDispatchToProps(dispatch) {
	    return {
	        actions: (0, _redux.bindActionCreators)(Object.assign({}, userDataActions, trackingDataActions), dispatch)
	    };
	}
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(LocalePicker);

/***/ },
/* 195 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.TextInput = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _MessagePanel = __webpack_require__(278);
	
	var _MessagePanel2 = _interopRequireDefault(_MessagePanel);
	
	var _appHelper = __webpack_require__(3);
	
	var appHelper = _interopRequireWildcard(_appHelper);
	
	var _keyboardConstants = __webpack_require__(14);
	
	var keyboardConstants = _interopRequireWildcard(_keyboardConstants);
	
	var _gsap = __webpack_require__(8);
	
	var _gsapReactPlugin = __webpack_require__(10);
	
	var _gsapReactPlugin2 = _interopRequireDefault(_gsapReactPlugin);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } //eslint-disable-line import/no-named-as-default
	
	
	var TextInput = exports.TextInput = function (_React$Component) {
	    _inherits(TextInput, _React$Component);
	
	    function TextInput(props, context) {
	        _classCallCheck(this, TextInput);
	
	        var _this = _possibleConstructorReturn(this, (TextInput.__proto__ || Object.getPrototypeOf(TextInput)).call(this, props, context));
	
	        _this.state = {
	            inFocus: false
	
	        };
	        _this.getWrapperClass = _this.getWrapperClass.bind(_this);
	        _this.onEnter = _this.onEnter.bind(_this);
	        _this.onFocusIn = _this.onFocusIn.bind(_this);
	        _this.onFocusOut = _this.onFocusOut.bind(_this);
	        _this.addFocusOutEffect = _this.addFocusOutEffect.bind(_this);
	        _this.onFocusOutComplete = _this.onFocusOutComplete.bind(_this);
	        _this.onRemove = _this.onRemove.bind(_this);
	        _this.onClickIcon = _this.onClickIcon.bind(_this);
	        _this.setOnClickIconKeyboardAccessibility = _this.setOnClickIconKeyboardAccessibility.bind(_this);
	        _this.setOnRemoveKeyboardAccessibility = _this.setOnRemoveKeyboardAccessibility.bind(_this);
	        return _this;
	    }
	
	    _createClass(TextInput, [{
	        key: 'getWrapperClass',
	        value: function getWrapperClass() {
	            var wrapperClass = 'form-group';
	
	            if (appHelper.isDefined(this.props.wrapperClassName)) {
	                wrapperClass += ' ' + this.props.wrapperClassName;
	            }
	
	            if (this.state.inFocus) {
	                wrapperClass += ' active';
	            }
	
	            if (this.props.error && this.props.error.length > 0) {
	                wrapperClass += ' has-error';
	            }
	
	            return wrapperClass;
	        }
	    }, {
	        key: 'onEnter',
	        value: function onEnter(event) {
	            if (event.key === 'Enter') {
	                //this.addFocusOutEffect();
	                var inputRef = this.refs['input_' + this.props.name];
	                if (appHelper.isDefined(inputRef)) {
	
	                    inputRef.blur();
	                }
	            }
	        }
	    }, {
	        key: 'onFocusIn',
	        value: function onFocusIn() {
	            this.setState({
	                inFocus: true
	            });
	        }
	    }, {
	        key: 'onFocusOut',
	        value: function onFocusOut() {
	            this.setState({
	                inFocus: false
	            });
	            this.addFocusOutEffect();
	        }
	    }, {
	        key: 'addFocusOutEffect',
	        value: function addFocusOutEffect() {
	            var inputRef = this.refs['input_' + this.props.name];
	            if (appHelper.isDefined(inputRef)) {
	                inputRef.classList.remove("focus-out");
	
	                _gsap.TweenLite.to(inputRef, 0.5, {
	                    css: { className: '+=focus-out' }
	                }).eventCallback("onComplete", this.onFocusOutComplete);
	            }
	        }
	    }, {
	        key: 'onFocusOutComplete',
	        value: function onFocusOutComplete() {
	            var inputRef = this.refs['input_' + this.props.name];
	            if (appHelper.isDefined(inputRef)) {
	                inputRef.classList.remove("focus-out");
	            }
	        }
	    }, {
	        key: 'onRemove',
	        value: function onRemove() {
	            this.props.onRemove();
	        }
	    }, {
	        key: 'onClickIcon',
	        value: function onClickIcon(event) {
	            event.stopPropagation();
	            this.props.onClickIcon();
	        }
	    }, {
	        key: 'setOnClickIconKeyboardAccessibility',
	        value: function setOnClickIconKeyboardAccessibility(event) {
	
	            if (event.which === keyboardConstants.ENTER_KEY || event.which === keyboardConstants.SPACEBAR_KEY) {
	                event.preventDefault();
	                event.stopPropagation();
	                this.onClickIcon();
	            }
	        }
	    }, {
	        key: 'setOnRemoveKeyboardAccessibility',
	        value: function setOnRemoveKeyboardAccessibility(event) {
	
	            if (event.which === keyboardConstants.ENTER_KEY || event.which === keyboardConstants.SPACEBAR_KEY) {
	                event.preventDefault();
	                event.stopPropagation();
	                this.onRemove();
	            }
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	
	            return _react2.default.createElement(
	                'div',
	                { className: '' + this.getWrapperClass() },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'relative-input-wrapper' },
	                    _react2.default.createElement(
	                        'label',
	                        { htmlFor: this.props.name },
	                        _react2.default.createElement(
	                            'span',
	                            null,
	                            this.props.label
	                        ),
	                        typeof this.props.onRemove !== 'undefined' ? _react2.default.createElement(
	                            'span',
	                            null,
	                            ' | ',
	                            _react2.default.createElement(
	                                'div',
	                                { onClick: this.onRemove, onKeyDown: this.setOnRemoveKeyboardAccessibility, tabIndex: '0', role: 'link' },
	                                'Remove'
	                            )
	                        ) : null,
	                        typeof this.props.subLabel !== 'undefined' ? _react2.default.createElement(
	                            'span',
	                            { className: 'sub-label' },
	                            ' - ',
	                            this.props.subLabel
	                        ) : null
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'field' },
	                        _react2.default.createElement('input', {
	                            type: this.props.type || 'text',
	                            name: this.props.name,
	                            ref: 'input_' + this.props.name,
	                            className: this.props.className + ' form-control',
	                            placeholder: this.props.placeholder,
	                            value: this.props.value,
	                            onChange: this.props.onChange,
	                            onKeyPress: this.onEnter,
	                            onFocus: this.onFocusIn,
	                            onBlur: this.onFocusOut,
	                            disabled: this.props.isDisabled ? "disabled" : "",
	                            maxLength: typeof this.props.maxLength !== 'undefined' ? this.props.maxLength : ''
	
	                        }),
	                        typeof this.props.iconContainerClass !== 'undefined' && typeof this.props.iconClass !== 'undefined' && typeof this.props.onClickIcon !== 'undefined' ? _react2.default.createElement(
	                            'span',
	                            { className: '' + this.props.iconContainerClass, onClick: this.onClickIcon, onKeyDown: this.setOnClickIconKeyboardAccessibility, tabIndex: '0', role: 'link' },
	                            _react2.default.createElement('span', { className: this.props.iconClass })
	                        ) : null,
	                        typeof this.props.messagePanelParams != 'undefined' && this.props.messagePanelParams.show ? _react2.default.createElement(_MessagePanel2.default, { name: this.props.name, message: this.props.messagePanelParams.message, alignment: this.props.messagePanelParams.alignment, show: this.props.messagePanelParams.show }) : null,
	                        this.props.error && typeof this.props.hideErrorMessage === 'undefined' && _react2.default.createElement(
	                            'div',
	                            { className: 'alert alert-danger' },
	                            this.props.error
	                        )
	                    )
	                )
	            );
	        }
	    }]);
	
	    return TextInput;
	}(_react2.default.Component);
	
	TextInput.propTypes = {
	    name: _propTypes2.default.string.isRequired,
	    label: _propTypes2.default.string.isRequired,
	    onChange: _propTypes2.default.func.isRequired,
	    subLabel: _propTypes2.default.string,
	    wrapperClassName: _propTypes2.default.string,
	    className: _propTypes2.default.string,
	    placeholder: _propTypes2.default.string,
	    value: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	    error: _propTypes2.default.string,
	    messagePanelParams: _propTypes2.default.object,
	    onRemove: _propTypes2.default.func,
	    hideErrorMessage: _propTypes2.default.string,
	    maxLength: _propTypes2.default.string,
	    type: _propTypes2.default.string,
	    iconContainerClass: _propTypes2.default.string,
	    iconClass: _propTypes2.default.string,
	    onClickIcon: _propTypes2.default.func,
	    isDisabled: _propTypes2.default.bool
	
	};
	
	//Pull in the React Router context so router is available on this.context.router.
	TextInput.contextTypes = {
	    router: _propTypes2.default.object
	};
	
	//Init
	
	
	exports.default = TextInput;

/***/ },
/* 196 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(5);
	
	var _redux = __webpack_require__(4);
	
	var _Button = __webpack_require__(18);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _trackingDataActions = __webpack_require__(7);
	
	var trackingDataActions = _interopRequireWildcard(_trackingDataActions);
	
	var _appHelper = __webpack_require__(3);
	
	var appHelper = _interopRequireWildcard(_appHelper);
	
	var _objectConstants = __webpack_require__(9);
	
	var objectConstants = _interopRequireWildcard(_objectConstants);
	
	var _appConstants = __webpack_require__(13);
	
	var appConstants = _interopRequireWildcard(_appConstants);
	
	var _userDataHelper = __webpack_require__(15);
	
	var userDataHelper = _interopRequireWildcard(_userDataHelper);
	
	var _gsap = __webpack_require__(8);
	
	var _gsapReactPlugin = __webpack_require__(10);
	
	var _gsapReactPlugin2 = _interopRequireDefault(_gsapReactPlugin);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } //eslint-disable-line import/no-named-as-default
	
	
	var CharacterSpeak = function (_React$Component) {
	    _inherits(CharacterSpeak, _React$Component);
	
	    function CharacterSpeak(props, context) {
	        _classCallCheck(this, CharacterSpeak);
	
	        var _this = _possibleConstructorReturn(this, (CharacterSpeak.__proto__ || Object.getPrototypeOf(CharacterSpeak)).call(this, props, context));
	
	        _this.state = {
	            lang: _this.props.lang,
	            character_name: appHelper.getScreenCharacterNameByAssetId(_this.props.asset_id),
	            screen: appHelper.getScreenByAssetId(_this.props.asset_id),
	            locale: appHelper.getLocalData(_this.props.dialog),
	            asset: {
	                src: ""
	            },
	
	            character: {
	                src: "",
	                pose: "",
	                position: ""
	            },
	            audio: {
	                src: ""
	            },
	            option: {},
	            hasAudio: false,
	            readyAudio: false,
	            audioComplete: false,
	            renderComplete: false,
	            character_speech_bubble_label: appHelper.getLocaleString("character_speech_bubble_label"),
	            character_label: appHelper.getLocaleString("character_label"),
	            speaking_label: appHelper.getLocaleString("speaking_label")
	        };
	
	        _this.showResponse = _this.showResponse.bind(_this);
	        _this.handleProgression = _this.handleProgression.bind(_this);
	        _this.onComplete = _this.onComplete.bind(_this);
	        _this.getAssets = _this.getAssets.bind(_this);
	        _this.getImagePath = _this.getImagePath.bind(_this);
	        _this.getClass = _this.getClass.bind(_this);
	        _this.getExpressionClass = _this.getExpressionClass.bind(_this);
	        _this.onPlayAudio = _this.onPlayAudio.bind(_this);
	        _this.onEndAudio = _this.onEndAudio.bind(_this);
	        return _this;
	    }
	
	    _createClass(CharacterSpeak, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            this.getAssets();
	            this.showResponse();
	        }
	    }, {
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(nextProps) {
	            if (this.state.lang !== nextProps.lang) {
	                this.setState({
	                    lang: nextProps.lang,
	                    locale: appHelper.getLocalData(this.props.dialog),
	                    character_speech_bubble_label: appHelper.getLocaleString("character_speech_bubble_label"),
	                    character_label: appHelper.getLocaleString("character_label"),
	                    speaking_label: appHelper.getLocaleString("speaking_label")
	                });
	            }
	        }
	    }, {
	        key: 'componentDidUpdate',
	        value: function componentDidUpdate() {
	            if (this.state.readyAudio) {
	                this.onPlayAudio();
	            }
	
	            if (this.state.hasAudio && this.state.audioComplete && this.state.renderComplete) {
	                this.handleProgression();
	            }
	        }
	    }, {
	        key: 'getAssets',
	        value: function getAssets() {
	            var screenCharacter = {};
	            var characterAsset = Object.assign(this.state.character);
	            var option = {};
	
	            if (appHelper.isDefined(this.state.screen.assets.character)) {
	                screenCharacter = appHelper.getCharacterAsset(this.state.screen.assets.character);
	                characterAsset = appHelper.getCharacterPose(screenCharacter, this.state.screen.assets.character);
	            }
	
	            if (appHelper.isDefined(this.props.asset_id)) {
	                var asset = appHelper.getArrayObjectByKey(this.state.screen.objects, "asset_id", this.props.asset_id);
	                if (appHelper.isDefined(asset.character_pose) && asset.character_pose.pose !== objectConstants.INHERIT) {
	                    characterAsset = appHelper.getCharacterPose(screenCharacter, asset.character_pose);
	                    if (!appHelper.isDefined(characterAsset.position)) {
	                        characterAsset = Object.assign({}, characterAsset, { position: screenCharacter.position });
	                    }
	                }
	
	                if (appHelper.isDefined(this.props.option_id)) {
	                    option = Object.assign({}, appHelper.getArrayObjectByKey(asset.options, "option_id", this.props.option_id));
	                    if (appHelper.isDefined(option.character_pose) && option.character_pose.pose !== objectConstants.INHERIT) {
	                        characterAsset = appHelper.getCharacterPose(screenCharacter, option.character_pose);
	                        if (!appHelper.isDefined(characterAsset.position)) {
	                            characterAsset = Object.assign({}, characterAsset, { position: screenCharacter.position });
	                        }
	                    }
	                }
	            }
	
	            if (appHelper.isDefined(characterAsset.src)) {
	                this.setState({
	                    character: Object.assign({}, characterAsset),
	                    option: Object.assign({}, option)
	                });
	            }
	
	            if (appHelper.isDefined(this.props.dialog.image)) {
	                this.setState({
	                    asset: Object.assign({}, appHelper.getLibraryImageAsset(this.props.dialog.image))
	                });
	            }
	
	            if (appHelper.isDefined(this.props.dialog.audio)) {
	                this.setState({
	                    audio: Object.assign({}, appHelper.getAudioAsset(this.props.dialog.audio)),
	                    readyAudio: true,
	                    hasAudio: true
	                });
	            }
	        }
	    }, {
	        key: 'getImagePath',
	        value: function getImagePath(image) {
	            if (appConstants.DEVELOPMENT_MODE) {
	                if (appHelper.isDefined(image) && image.length > 0) {
	                    return __webpack_require__(16)("./" + image);
	                }
	            } else {
	                return image;
	            }
	        }
	    }, {
	        key: 'showResponse',
	        value: function showResponse() {
	            var objectRef = this.refs['characterSpeak_' + this.props.index];
	            _gsap.TweenLite.set(objectRef, { height: "auto" });
	            _gsap.TweenLite.from(objectRef, objectConstants.SPEECH_BUBBLE_DURATION, {
	                height: 0,
	                ease: _gsap.Expo.easeInOut,
	                delay: this.props.delay
	            }).eventCallback("onComplete", this.onComplete);
	        }
	    }, {
	        key: 'onComplete',
	        value: function onComplete() {
	            this.setState({ renderComplete: true });
	            if (!this.state.hasAudio) {
	                this.handleProgression();
	            }
	        }
	    }, {
	        key: 'onPlayAudio',
	        value: function onPlayAudio() {
	            this.setState({
	                readyAudio: false
	            });
	
	            var videoRef = this.refs['learnerSpeak_' + this.props.asset_id + '_' + this.props.index + '_audio'];
	            if (appHelper.isDefined(videoRef)) {
	                videoRef.play();
	                var onEndAudio = this.onEndAudio;
	                videoRef.onended = function () {
	                    onEndAudio();
	                };
	            }
	        }
	    }, {
	        key: 'onEndAudio',
	        value: function onEndAudio() {
	            this.setState({
	                audioComplete: true
	            });
	        }
	    }, {
	        key: 'handleProgression',
	        value: function handleProgression() {
	            this.setState({ renderComplete: false, audioComplete: false });
	            this.props.callbacks.onObjectComplete(this.props.index);
	        }
	    }, {
	        key: 'getClass',
	        value: function getClass() {
	            return appHelper.isDefined(this.state.character.src) && this.state.character.src.length > 0 ? 'customer-has-expression' : '';
	        }
	    }, {
	        key: 'getExpressionClass',
	        value: function getExpressionClass() {
	            return appHelper.isDefined(this.state.option.result) ? this.state.option.result : '';
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            return _react2.default.createElement(
	                'span',
	                null,
	                _react2.default.createElement(
	                    'div',
	                    { className: 'object-container ' + this.getClass(), ref: 'characterSpeak_' + this.props.index },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'customer_name_label' },
	                        _react2.default.createElement(
	                            'span',
	                            { className: 'hidden-el' },
	                            this.state.character_speech_bubble_label,
	                            ', '
	                        ),
	                        appHelper.isDefined(this.state.character_name) && this.state.character_name !== null && this.state.character_name.length > 0 ? _react2.default.createElement(
	                            'span',
	                            null,
	                            this.state.character_name
	                        ) : _react2.default.createElement(
	                            'span',
	                            null,
	                            this.state.character_label
	                        ),
	                        _react2.default.createElement(
	                            'span',
	                            { className: 'hidden-el' },
	                            this.state.speaking_label,
	                            ','
	                        )
	                    ),
	                    appHelper.isDefined(this.state.character.src) && this.state.character.src.length > 0 ? _react2.default.createElement(
	                        'div',
	                        { className: 'character-expression ' + this.getExpressionClass() + ' ' + this.state.character.position },
	                        _react2.default.createElement('img', { src: this.getImagePath(this.state.character.src), alt: '' })
	                    ) : null,
	                    appHelper.isDefined(this.state.locale.label) ? _react2.default.createElement('div', { className: 'character speak', dangerouslySetInnerHTML: { __html: this.state.locale.label } }) : _react2.default.createElement(
	                        'div',
	                        { className: 'character-conversation-image' },
	                        _react2.default.createElement('img', { src: this.getImagePath(this.state.asset.src), alt: '' })
	                    )
	                ),
	                appHelper.isDefined(this.state.audio.src) && this.state.audio.src.length > 0 ? _react2.default.createElement('audio', { ref: 'learnerSpeak_' + this.props.asset_id + '_' + this.props.index + '_audio', src: this.getImagePath(this.state.audio.src) }) : null
	            );
	        }
	    }]);
	
	    return CharacterSpeak;
	}(_react2.default.Component);
	
	CharacterSpeak.propTypes = {
	    asset_id: _propTypes2.default.number.isRequired,
	    option_id: _propTypes2.default.number,
	    index: _propTypes2.default.number.isRequired,
	    dialog: _propTypes2.default.object.isRequired,
	    delay: _propTypes2.default.number.isRequired,
	    callbacks: _propTypes2.default.object.isRequired,
	    lang: _propTypes2.default.string.isRequired,
	    actions: _propTypes2.default.object
	};
	
	CharacterSpeak.contextTypes = {
	    router: _propTypes2.default.object
	};
	
	function mapStateToProps(state, ownProps) {
	    var lang = state.userData.lang;
	    return {
	        lang: lang
	    };
	}
	
	function mapDispatchToProps(dispatch) {
	    return {
	        actions: (0, _redux.bindActionCreators)(Object.assign({}, trackingDataActions), dispatch)
	    };
	}
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(CharacterSpeak);

/***/ },
/* 197 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(5);
	
	var _redux = __webpack_require__(4);
	
	var _trackingDataActions = __webpack_require__(7);
	
	var trackingDataActions = _interopRequireWildcard(_trackingDataActions);
	
	var _appHelper = __webpack_require__(3);
	
	var appHelper = _interopRequireWildcard(_appHelper);
	
	var _appConstants = __webpack_require__(13);
	
	var appConstants = _interopRequireWildcard(_appConstants);
	
	var _objectConstants = __webpack_require__(9);
	
	var objectConstants = _interopRequireWildcard(_objectConstants);
	
	var _gsap = __webpack_require__(8);
	
	var _gsapReactPlugin = __webpack_require__(10);
	
	var _gsapReactPlugin2 = _interopRequireDefault(_gsapReactPlugin);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var LearnerSpeak = function (_React$Component) {
	    _inherits(LearnerSpeak, _React$Component);
	
	    function LearnerSpeak(props, context) {
	        _classCallCheck(this, LearnerSpeak);
	
	        var _this = _possibleConstructorReturn(this, (LearnerSpeak.__proto__ || Object.getPrototypeOf(LearnerSpeak)).call(this, props, context));
	
	        _this.state = {
	            lang: _this.props.lang,
	            locale: appHelper.getLocalData(_this.props.dialog),
	            asset: {
	                src: ""
	            },
	            audio: {
	                src: ""
	            },
	            hasAudio: false,
	            readyAudio: false,
	            audioComplete: false,
	            renderComplete: false,
	            learning_speech_bubble_label: appHelper.getLocaleString("learning_speech_bubble_label"),
	            you_label: appHelper.getLocaleString("you_label"),
	            speaking_label: appHelper.getLocaleString("speaking_label")
	        };
	
	        _this.showResponse = _this.showResponse.bind(_this);
	        _this.handleProgression = _this.handleProgression.bind(_this);
	        _this.setAssets = _this.setAssets.bind(_this);
	        _this.getImagePath = _this.getImagePath.bind(_this);
	        _this.onComplete = _this.onComplete.bind(_this);
	        _this.onPlayAudio = _this.onPlayAudio.bind(_this);
	        _this.onEndAudio = _this.onEndAudio.bind(_this);
	        return _this;
	    }
	
	    _createClass(LearnerSpeak, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            this.setAssets();
	            this.showResponse();
	        }
	    }, {
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(nextProps) {
	            if (appHelper.isDefined(this.props.dialog.audio)) {
	                this.setState({
	                    audio: Object.assign({}, appHelper.getAudioAsset(this.props.dialog.audio)),
	                    readyAudio: true,
	                    hasAudio: true
	                });
	            }
	
	            if (this.state.lang !== nextProps.lang) {
	                this.setState({
	                    lang: nextProps.lang,
	                    locale: appHelper.getLocalData(this.props.dialog)
	                });
	            }
	        }
	    }, {
	        key: 'componentDidUpdate',
	        value: function componentDidUpdate() {
	            if (this.state.readyAudio) {
	                this.onPlayAudio();
	            }
	
	            if (this.state.hasAudio && this.state.audioComplete && this.state.renderComplete) {
	                this.handleProgression();
	            }
	        }
	    }, {
	        key: 'setAssets',
	        value: function setAssets() {
	
	            if (appHelper.isDefined(this.props.dialog.image)) {
	                this.setState({ asset: Object.assign({}, appHelper.getLibraryImageAsset(this.props.dialog.image)) });
	            }
	            if (appHelper.isDefined(this.props.dialog.audio)) {
	                this.setState({
	                    audio: Object.assign({}, appHelper.getAudioAsset(this.props.dialog.audio)),
	                    readyAudio: true,
	                    hasAudio: true
	                });
	            }
	        }
	    }, {
	        key: 'getImagePath',
	        value: function getImagePath(image) {
	            if (appConstants.DEVELOPMENT_MODE) {
	                if (appHelper.isDefined(image) && image.length > 0) {
	                    return __webpack_require__(16)("./" + image);
	                }
	            } else {
	                return image;
	            }
	        }
	    }, {
	        key: 'showResponse',
	        value: function showResponse() {
	            var objectRef = this.refs['learnerSpeak_' + this.props.index];
	            _gsap.TweenLite.set(objectRef, { height: "auto" });
	            _gsap.TweenLite.from(objectRef, objectConstants.SPEECH_BUBBLE_DURATION, {
	                height: 0,
	                ease: _gsap.Expo.easeInOut,
	                delay: this.props.delay
	            }).eventCallback("onComplete", this.onComplete);
	        }
	    }, {
	        key: 'onComplete',
	        value: function onComplete() {
	            this.setState({ renderComplete: true });
	            if (!this.state.hasAudio) {
	                this.handleProgression();
	            }
	        }
	    }, {
	        key: 'onPlayAudio',
	        value: function onPlayAudio() {
	            this.setState({
	                readyAudio: false
	            });
	
	            var videoRef = this.refs['learnerSpeak_' + this.props.asset_id + '_' + this.props.index + '_audio'];
	            alert(videoRef);
	            if (appHelper.isDefined(videoRef)) {
	                videoRef.play();
	                var onEndAudio = this.onEndAudio;
	                videoRef.onended = function () {
	                    onEndAudio();
	                };
	            }
	        }
	    }, {
	        key: 'onEndAudio',
	        value: function onEndAudio() {
	            this.setState({
	                audioComplete: true
	            });
	        }
	    }, {
	        key: 'handleProgression',
	        value: function handleProgression() {
	            this.setState({ renderComplete: false, audioComplete: false });
	            this.props.callbacks.onObjectComplete(this.props.index);
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            return _react2.default.createElement(
	                'div',
	                { className: 'object-container', ref: 'learnerSpeak_' + this.props.index },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'user_name_label' },
	                    _react2.default.createElement(
	                        'span',
	                        { className: 'hidden-el' },
	                        this.state.learning_speech_bubble_label,
	                        ', '
	                    ),
	                    this.props.trackingData.first_name.length > 0 && !this.props.trackingData.first_name.includes('Guest') ? _react2.default.createElement(
	                        'span',
	                        null,
	                        this.props.trackingData.first_name
	                    ) : _react2.default.createElement(
	                        'span',
	                        null,
	                        this.state.you_label
	                    ),
	                    _react2.default.createElement(
	                        'span',
	                        { className: 'hidden-el' },
	                        ' ',
	                        this.state.speaking_label,
	                        ','
	                    )
	                ),
	                appHelper.isDefined(this.state.locale.label) ? _react2.default.createElement('div', { className: 'learner speak', dangerouslySetInnerHTML: { __html: this.state.locale.label } }) : _react2.default.createElement(
	                    'div',
	                    { className: 'learner-conversation-image' },
	                    _react2.default.createElement('img', { src: this.getImagePath(this.state.asset.src), alt: '' })
	                ),
	                appHelper.isDefined(this.state.audio.src) && this.state.audio.src.length > 0 ? _react2.default.createElement('audio', { ref: 'learnerSpeak_' + this.props.asset_id + '_' + this.props.index + '_audio', src: this.getImagePath(this.state.audio.src) }) : null
	            );
	        }
	    }]);
	
	    return LearnerSpeak;
	}(_react2.default.Component);
	
	LearnerSpeak.propTypes = {
	    asset_id: _propTypes2.default.number.isRequired,
	    option_id: _propTypes2.default.number,
	    index: _propTypes2.default.number.isRequired,
	    dialog: _propTypes2.default.object.isRequired,
	    delay: _propTypes2.default.number.isRequired,
	    callbacks: _propTypes2.default.object.isRequired,
	    trackingData: _propTypes2.default.object.isRequired,
	    lang: _propTypes2.default.string.isRequired,
	    actions: _propTypes2.default.object
	};
	
	LearnerSpeak.contextTypes = {
	    router: _propTypes2.default.object
	};
	
	function mapStateToProps(state, ownProps) {
	    var lang = state.userData.lang;
	    return {
	        lang: lang,
	        trackingData: state.trackingData
	    };
	}
	
	function mapDispatchToProps(dispatch) {
	    return {
	        actions: (0, _redux.bindActionCreators)(Object.assign({}, trackingDataActions), dispatch)
	    };
	}
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(LearnerSpeak);

/***/ },
/* 198 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(5);
	
	var _redux = __webpack_require__(4);
	
	var _RotationKpiMeter = __webpack_require__(82);
	
	var _RotationKpiMeter2 = _interopRequireDefault(_RotationKpiMeter);
	
	var _KpiResultReview = __webpack_require__(151);
	
	var _KpiResultReview2 = _interopRequireDefault(_KpiResultReview);
	
	var _appDataActions = __webpack_require__(12);
	
	var appDataActions = _interopRequireWildcard(_appDataActions);
	
	var _trackingDataActions = __webpack_require__(7);
	
	var trackingDataActions = _interopRequireWildcard(_trackingDataActions);
	
	var _dataHelper = __webpack_require__(11);
	
	var dataHelper = _interopRequireWildcard(_dataHelper);
	
	var _appHelper = __webpack_require__(3);
	
	var appHelper = _interopRequireWildcard(_appHelper);
	
	var _kpiHelper = __webpack_require__(35);
	
	var kpiHelper = _interopRequireWildcard(_kpiHelper);
	
	var _kpiConstants = __webpack_require__(37);
	
	var kpiConstants = _interopRequireWildcard(_kpiConstants);
	
	var _kpiModels = __webpack_require__(57);
	
	var kpiModels = _interopRequireWildcard(_kpiModels);
	
	var _gsap = __webpack_require__(8);
	
	var _gsapReactPlugin = __webpack_require__(10);
	
	var _gsapReactPlugin2 = _interopRequireDefault(_gsapReactPlugin);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ScoreKpi = function (_React$Component) {
	    _inherits(ScoreKpi, _React$Component);
	
	    function ScoreKpi(props, context) {
	        _classCallCheck(this, ScoreKpi);
	
	        var _this = _possibleConstructorReturn(this, (ScoreKpi.__proto__ || Object.getPrototypeOf(ScoreKpi)).call(this, props, context));
	
	        _this.state = {
	            lang: _this.props.lang,
	            userKpisResults: kpiHelper.setKpiRenderOrder(_this.props.userKpisResults),
	            bite: _this.props.bite,
	            score_kpi: kpiHelper.getScoreKpi(_this.props.bite),
	            locale: {},
	            guid: dataHelper.createGuid(),
	            allowUpdates: true,
	            updatedKpis: [],
	            checkAllUpdated: false
	
	        };
	
	        _this.getKpiMeterParams = _this.getKpiMeterParams.bind(_this);
	        _this.getLocale = _this.getLocale.bind(_this);
	        _this.showDashboard = _this.showDashboard.bind(_this);
	        _this.onComplete = _this.onComplete.bind(_this);
	        _this.onUpdateComplete = _this.onUpdateComplete.bind(_this);
	        return _this;
	    }
	
	    _createClass(ScoreKpi, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            if (appHelper.isDefined(this.state.score_kpi.kpi_id)) {
	                this.getLocale();
	                this.showDashboard();
	            } else {
	                this.onUpdateComplete();
	            }
	        }
	    }, {
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(nextProps) {
	
	            if (this.state.lang !== nextProps.lang) {
	                this.setState({
	                    lang: nextProps.lang,
	                    locale: appHelper.getLocalData(this.state.bite)
	                });
	            }
	        }
	    }, {
	        key: 'shouldComponentUpdate',
	        value: function shouldComponentUpdate() {
	            return this.state.allowUpdates;
	        }
	    }, {
	        key: 'componentDidUpdate',
	        value: function componentDidUpdate() {}
	    }, {
	        key: 'getLocale',
	        value: function getLocale() {
	            var locale = appHelper.getLocalData(this.state.bite);
	            this.setState({ locale: Object.assign({}, locale) });
	        }
	    }, {
	        key: 'getKpiMeterParams',
	        value: function getKpiMeterParams(is_primary) {
	            if (is_primary) {
	                return kpiModels.PRIMARY_KPI_ROTATION_METER_PARAMS;
	            } else {
	                if (this.state.kpis.length < 3) {
	                    return kpiModels.PRIMARY_KPI_ROTATION_METER_PARAMS;
	                } else {
	                    return kpiModels.DEFAULT_KPI_ROTATION_METER_PARAMS;
	                }
	            }
	        }
	    }, {
	        key: 'showDashboard',
	        value: function showDashboard() {
	
	            var optionRef = this.refs['kpi_dashboard_' + this.state.guid];
	            _gsap.TweenLite.set(optionRef, { height: "auto" });
	            _gsap.TweenLite.from(optionRef, 0.3, {
	                height: 0,
	                ease: _gsap.Expo.linear
	            }).eventCallback("onComplete", this.onComplete);
	        }
	    }, {
	        key: 'onComplete',
	        value: function onComplete() {
	            if (!this.props.responseReview) {
	                this.setState({ allowUpdates: false });
	            }
	
	            if (typeof this.props.onComplete !== 'undefined') {
	                this.props.onComplete();
	            }
	        }
	    }, {
	        key: 'onUpdateComplete',
	        value: function onUpdateComplete(kpi_id) {
	            this.props.onUpdateComplete();
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            return appHelper.isDefined(this.state.score_kpi.kpi_id) ? _react2.default.createElement(
	                'div',
	                { className: 'kpi-dashboard', ref: 'kpi_dashboard_' + this.state.guid },
	                _react2.default.createElement(
	                    'ul',
	                    { className: 'inline-list text-center' },
	                    _react2.default.createElement(
	                        'li',
	                        { className: 'inline-item kpi-item' },
	                        _react2.default.createElement(_RotationKpiMeter2.default, { bite_id: this.state.bite.bite_id,
	                            kpiDefaults: this.state.score_kpi,
	                            index: 0,
	                            showImmediateImpact: this.props.showImmediateImpact,
	                            meterParams: kpiModels.PRIMARY_KPI_ROTATION_METER_PARAMS,
	                            displayState: this.props.displayState,
	                            responseReview: this.props.responseReview,
	                            screen_id: this.props.screen_id,
	                            asset_id: this.props.asset_id,
	                            option_id: typeof this.props.option !== "undefined" ? this.props.option.option_id : 0,
	                            onRotationComplete: this.onUpdateComplete })
	                    )
	                )
	            ) : null;
	        }
	    }]);
	
	    return ScoreKpi;
	}(_react2.default.Component);
	
	ScoreKpi.propTypes = {
	    displayState: _propTypes2.default.string.isRequired,
	    bite_id: _propTypes2.default.number.isRequired,
	    bite: _propTypes2.default.object,
	    responseReview: _propTypes2.default.bool,
	    screen_id: _propTypes2.default.number,
	    asset_id: _propTypes2.default.number,
	    option: _propTypes2.default.object,
	    showImmediateImpact: _propTypes2.default.bool,
	    userKpisResults: _propTypes2.default.array,
	    onComplete: _propTypes2.default.func,
	    onUpdateComplete: _propTypes2.default.func,
	    lang: _propTypes2.default.string.isRequired
	};
	
	ScoreKpi.contextTypes = {
	    router: _propTypes2.default.object
	};
	
	function mapStateToProps(state, ownProps) {
	    var userBite = appHelper.getArrayObjectByKey(state.userData.bites, "bite_id", ownProps.bite_id);
	    var bite = appHelper.getBite(ownProps.bite_id);
	    var userKpisResults = userBite.kpis;
	    var lang = state.userData.lang;
	    return {
	        lang: lang,
	        userKpisResults: userKpisResults,
	        bite: bite
	    };
	}
	
	function mapDispatchToProps(dispatch) {
	    return {
	        actions: (0, _redux.bindActionCreators)(Object.assign({}, trackingDataActions, appDataActions), dispatch)
	    };
	}
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(ScoreKpi);

/***/ },
/* 199 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(5);
	
	var _redux = __webpack_require__(4);
	
	var _KpiDashboard = __webpack_require__(93);
	
	var _KpiDashboard2 = _interopRequireDefault(_KpiDashboard);
	
	var _appHelper = __webpack_require__(3);
	
	var appHelper = _interopRequireWildcard(_appHelper);
	
	var _kpiHelper = __webpack_require__(35);
	
	var kpiHelper = _interopRequireWildcard(_kpiHelper);
	
	var _kpiConstants = __webpack_require__(37);
	
	var kpiConstants = _interopRequireWildcard(_kpiConstants);
	
	var _dataHelper = __webpack_require__(11);
	
	var dataHelper = _interopRequireWildcard(_dataHelper);
	
	var _objectConstants = __webpack_require__(9);
	
	var objectConstants = _interopRequireWildcard(_objectConstants);
	
	var _gsap = __webpack_require__(8);
	
	var _gsapReactPlugin = __webpack_require__(10);
	
	var _gsapReactPlugin2 = _interopRequireDefault(_gsapReactPlugin);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } //eslint-disable-line import/no-named-as-default
	
	
	var OptionFeedback = function (_React$Component) {
	    _inherits(OptionFeedback, _React$Component);
	
	    function OptionFeedback(props, context) {
	        _classCallCheck(this, OptionFeedback);
	
	        var _this = _possibleConstructorReturn(this, (OptionFeedback.__proto__ || Object.getPrototypeOf(OptionFeedback)).call(this, props, context));
	
	        _this.state = {
	            feedback_options: props.feedback_options,
	            scoreKpi: kpiHelper.getScoreKpi(_this.props.bite),
	            kpiDashboardParams: {
	                responseReview: true,
	                showTitle: false,
	                showImmediateImpact: true,
	                allowUpdates: false
	
	            },
	            hideScoreKpi: true
	        };
	        _this.show = _this.show.bind(_this);
	        _this.onOptionFeedbackRevealed = _this.onOptionFeedbackRevealed.bind(_this);
	        _this.setOptionClass = _this.setOptionClass.bind(_this);
	        return _this;
	    }
	
	    _createClass(OptionFeedback, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {}
	    }, {
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(nextProps) {
	
	            if (this.state.feedback_options !== nextProps.feedback_options) {
	                this.setState({ feedback_options: Object.assign([], nextProps.feedback_options) });
	            }
	        }
	    }, {
	        key: 'show',
	        value: function show() {
	
	            var feedbackPanel = this.refs[this.props.asset_id + '_key-_feedback_options_panel-panel'];
	            _gsap.TweenLite.set(feedbackPanel, { height: "auto", opacity: 1 });
	            _gsap.TweenLite.from(feedbackPanel, 0.2, {
	                height: 0,
	                opacity: 0,
	                ease: _gsap.Expo.easeInOut
	            }).eventCallback("onComplete", this.onOptionFeedbackRevealed);
	        }
	    }, {
	        key: 'onOptionFeedbackRevealed',
	        value: function onOptionFeedbackRevealed() {
	            if (appHelper.isDefined(this.props.onComplete)) {
	                this.props.onComplete();
	            }
	        }
	    }, {
	        key: 'setOptionClass',
	        value: function setOptionClass(option) {
	            if (this.props.responseData.scoring_type === objectConstants.SCORING_TYPE_ASSESSED && appHelper.isDefined(this.state.scoreKpi.kpi_id)) {
	                var scoreKpiResults = appHelper.getArrayObjectByKey(option.kpis, "kpi_id", this.state.scoreKpi.kpi_id);
	                if (appHelper.isDefined(scoreKpiResults)) {
	                    return kpiHelper.getKpiPointsIndicatorClass(scoreKpiResults.value, scoreKpiResults.kpi_id).class;
	                } else {
	                    return option.result;
	                }
	            } else {
	                return option.result;
	            }
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this2 = this;
	
	            return _react2.default.createElement(
	                'div',
	                { className: 'feedback-options-container', ref: this.props.asset_id + '_feedback_options_panel' },
	                this.state.feedback_options.map(function (feedback_option) {
	                    return feedback_option.options.length > 0 && feedback_option.feedback.length > 0 ? _react2.default.createElement(
	                        'div',
	                        { className: 'feedback-options-panel', key: feedback_option.option_id + '_panel' },
	                        _react2.default.createElement(
	                            'ul',
	                            { className: 'feedback-options' },
	                            feedback_option.options.map(function (option) {
	                                return _react2.default.createElement(
	                                    'li',
	                                    { className: 'feedback-option ' + option.className + ' ' + _this2.setOptionClass(option),
	                                        key: option.option_id },
	                                    _react2.default.createElement('div', { dangerouslySetInnerHTML: { __html: option.option_text } })
	                                );
	                            })
	                        ),
	                        feedback_option.feedback.length > 0 && feedback_option.feedback !== "<p><br></p>" ? _react2.default.createElement('div', { className: 'feedback-option-feedback',
	                            dangerouslySetInnerHTML: { __html: feedback_option.feedback } }) : null
	                    ) : null;
	                })
	            );
	        }
	    }]);
	
	    return OptionFeedback;
	}(_react2.default.Component);
	
	OptionFeedback.propTypes = {
	    feedback_options: _propTypes2.default.array,
	    asset_id: _propTypes2.default.number.isRequired,
	    bite: _propTypes2.default.object,
	    responseData: _propTypes2.default.object,
	    missedOptions: _propTypes2.default.object,
	    onComplete: _propTypes2.default.func,
	    actions: _propTypes2.default.object
	};
	
	OptionFeedback.contextTypes = {
	    router: _propTypes2.default.object
	};
	
	function mapStateToProps(state, ownProps) {
	    return {
	        bite: appHelper.getBiteById(ownProps.responseData.bite_id)
	    };
	}
	
	function mapDispatchToProps(dispatch) {
	    return {
	        actions: (0, _redux.bindActionCreators)(Object.assign({}, {}), dispatch)
	    };
	}
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(OptionFeedback);

/***/ },
/* 200 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(5);
	
	var _redux = __webpack_require__(4);
	
	var _appDataActions = __webpack_require__(12);
	
	var appDataActions = _interopRequireWildcard(_appDataActions);
	
	var _Button = __webpack_require__(18);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _ResourceLinks = __webpack_require__(48);
	
	var _ResourceLinks2 = _interopRequireDefault(_ResourceLinks);
	
	var _SecondaryImage = __webpack_require__(66);
	
	var _SecondaryImage2 = _interopRequireDefault(_SecondaryImage);
	
	var _SecondaryLibraryImage = __webpack_require__(67);
	
	var _SecondaryLibraryImage2 = _interopRequireDefault(_SecondaryLibraryImage);
	
	var _KpiDashboard = __webpack_require__(93);
	
	var _KpiDashboard2 = _interopRequireDefault(_KpiDashboard);
	
	var _OptionFeedback = __webpack_require__(199);
	
	var _OptionFeedback2 = _interopRequireDefault(_OptionFeedback);
	
	var _ScoreKpi = __webpack_require__(198);
	
	var _ScoreKpi2 = _interopRequireDefault(_ScoreKpi);
	
	var _ChildConversationDialog = __webpack_require__(65);
	
	var _ChildConversationDialog2 = _interopRequireDefault(_ChildConversationDialog);
	
	var _BadgeCollect = __webpack_require__(47);
	
	var _BadgeCollect2 = _interopRequireDefault(_BadgeCollect);
	
	var _trackingDataActions = __webpack_require__(7);
	
	var trackingDataActions = _interopRequireWildcard(_trackingDataActions);
	
	var _userDataActions = __webpack_require__(20);
	
	var userDataActions = _interopRequireWildcard(_userDataActions);
	
	var _appHelper = __webpack_require__(3);
	
	var appHelper = _interopRequireWildcard(_appHelper);
	
	var _dataHelper = __webpack_require__(11);
	
	var dataHelper = _interopRequireWildcard(_dataHelper);
	
	var _appConstants = __webpack_require__(13);
	
	var appConstants = _interopRequireWildcard(_appConstants);
	
	var _objectConstants = __webpack_require__(9);
	
	var objectConstants = _interopRequireWildcard(_objectConstants);
	
	var _kpiConstants = __webpack_require__(37);
	
	var kpiConstants = _interopRequireWildcard(_kpiConstants);
	
	var _assetConstants = __webpack_require__(33);
	
	var assetConstants = _interopRequireWildcard(_assetConstants);
	
	var _keyboardConstants = __webpack_require__(14);
	
	var keyboardConstants = _interopRequireWildcard(_keyboardConstants);
	
	var _localStorage = __webpack_require__(17);
	
	var localStorage = _interopRequireWildcard(_localStorage);
	
	var _gsap = __webpack_require__(8);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } //eslint-disable-line import/no-named-as-default
	
	
	//eslint-disable-line import/no-named-as-default
	//eslint-disable-line import/no-named-as-default
	//eslint-disable-line import/no-named-as-default
	
	
	var SingleAnswerFeedback = function (_React$Component) {
	    _inherits(SingleAnswerFeedback, _React$Component);
	
	    function SingleAnswerFeedback(props, context) {
	        _classCallCheck(this, SingleAnswerFeedback);
	
	        var _this = _possibleConstructorReturn(this, (SingleAnswerFeedback.__proto__ || Object.getPrototypeOf(SingleAnswerFeedback)).call(this, props, context));
	
	        _this.state = {
	            lang: _this.props.lang,
	            option: _this.props.option,
	            options: _this.props.options,
	            locale: appHelper.getLocalData(_this.props.option),
	            hideFeedback: _this.props.hideFeedback,
	            showKpis: _this.props.screenObject.scoring_type === objectConstants.SCORING_TYPE_ASSESSED && appHelper.isDefined(_this.props.option.kpis) && _this.props.option.kpis !== null,
	            showProgression: false,
	            enableProgression: _this.props.screenObject.scoring_type !== objectConstants.SCORING_TYPE_ASSESSED || _this.props.option.kpis === null,
	            optionFeedback: [],
	            kpiDashboardParams: {
	                showTitle: false,
	                showImmediateImpact: true,
	                allowUpdates: false
	            },
	            hasDialogs: appHelper.isDefined(_this.props.option.dialogs) && _this.props.option.dialogs.length > 0,
	            dialogComplete: !appHelper.isDefined(_this.props.option.dialogs) || _this.props.option.dialogs.length === 0,
	            hasBadges: appHelper.isDefined(_this.props.option.badges) && _this.props.option.badges.length > 0,
	            badgesCollected: false,
	            resourceLinks: [],
	            hasResources: false,
	            resourcesAreComplete: true,
	            optionAsset: {
	                src: ""
	            },
	            assetData: {},
	            completionCalled: false,
	            feedbackInterval: {},
	            review_other_options_label: appHelper.getLocaleString("review_other_options_label")
	        };
	        _this.show = _this.show.bind(_this);
	        _this.onFeedbackRevealed = _this.onFeedbackRevealed.bind(_this);
	        _this.onFeedbackHidden = _this.onFeedbackHidden.bind(_this);
	        _this.onProgressionClicked = _this.onProgressionClicked.bind(_this);
	        _this.scrollToTop = _this.scrollToTop.bind(_this);
	        _this.handleOptionFeedback = _this.handleOptionFeedback.bind(_this);
	        _this.storeUserResponse = _this.storeUserResponse.bind(_this);
	        _this.enableProgression = _this.enableProgression.bind(_this);
	        _this.getLinkClass = _this.getLinkClass.bind(_this);
	        _this.getDisabledState = _this.getDisabledState.bind(_this);
	        _this.dialogsOnComplete = _this.dialogsOnComplete.bind(_this);
	        _this.onBadgeCollected = _this.onBadgeCollected.bind(_this);
	        _this.onResourcesComplete = _this.onResourcesComplete.bind(_this);
	        _this.setResources = _this.setResources.bind(_this);
	        _this.getAssets = _this.getAssets.bind(_this);
	        _this.getAssetType = _this.getAssetType.bind(_this);
	        _this.getInheritedFeedback = _this.getInheritedFeedback.bind(_this);
	        _this.checkIsReadyToComplete = _this.checkIsReadyToComplete.bind(_this);
	        _this.setComplete = _this.setComplete.bind(_this);
	        _this.showProgressButton = _this.showProgressButton.bind(_this);
	        _this.setKeyboardAccessibility = _this.setKeyboardAccessibility.bind(_this);
	        _this.onReview = _this.onReview.bind(_this);
	        _this.setFeedbackInterval = _this.setFeedbackInterval.bind(_this);
	        _this.checkShowProgressButton = _this.checkShowProgressButton.bind(_this);
	        return _this;
	    }
	
	    _createClass(SingleAnswerFeedback, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	
	            this.getAssets();
	            //this.handleOptionFeedback();
	            this.setResources();
	            this.show();
	            this.setFeedbackInterval();
	            if (appHelper.isDefined(this.props.callbacks.updateCharacterExpression) && appHelper.isDefined(this.state.option.character_pose)) {
	                this.props.callbacks.updateCharacterExpression(this.state.option.character_pose);
	            }
	        }
	    }, {
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(nextProps) {
	            if (this.state.hideFeedback !== nextProps.hideFeedback) {
	                this.setState({ hideFeedback: nextProps.hideFeedback });
	            }
	
	            if (this.state.lang !== nextProps.lang) {
	                this.setState({
	                    lang: nextProps.lang,
	                    locale: appHelper.getLocalData(this.state.option),
	                    review_other_options_label: appHelper.getLocaleString("review_other_options_label")
	                });
	            }
	        }
	    }, {
	        key: 'componentDidUpdate',
	        value: function componentDidUpdate() {
	            if (this.checkIsReadyToComplete()) {
	                this.setComplete();
	            }
	            if (this.state.hideFeedback) {
	                this.hide();
	            }
	        }
	    }, {
	        key: 'componentWillUnmount',
	        value: function componentWillUnmount() {
	            clearInterval(this.state.feedbackInterval);
	        }
	    }, {
	        key: 'setFeedbackInterval',
	        value: function setFeedbackInterval() {
	            var interval = setInterval(this.checkShowProgressButton, 500);
	            this.setState({ feedbackInterval: interval });
	        }
	    }, {
	        key: 'checkShowProgressButton',
	        value: function checkShowProgressButton() {
	            if (this.showProgressButton()) {
	                this.props.onEnableProgression(this.state.locale.progression_label);
	                clearInterval(this.state.feedbackInterval);
	            }
	        }
	    }, {
	        key: 'getAssets',
	        value: function getAssets() {
	            var screenAsset = {};
	            var assetData = {};
	
	            if (appHelper.isDefined(this.state.option.image)) {
	                screenAsset = this.getAssetType(this.state.option.image);
	                assetData = Object.assign({}, this.state.option.image);
	            }
	
	            this.setState({
	                screenAsset: Object.assign({}, screenAsset),
	                assetData: Object.assign({}, assetData)
	            });
	
	            if (appHelper.isDefined(this.state.option.audio)) {
	                var audio = appHelper.getAudioAsset(this.state.option.audio);
	                var audioObj = {
	                    audioRef: 'audio_' + audio.id + '_' + audio.type
	                };
	
	                this.props.actions.setAudio(audioObj);
	            }
	        }
	    }, {
	        key: 'getAssetType',
	        value: function getAssetType(asset) {
	            /*
	             screenCharacter = appHelper.getCharacterAsset(this.state.screen.assets.left);
	                //console.log(screenCharacter);
	                characterAsset = appHelper.getCharacterPose(screenCharacter, this.state.screen.assets.left);
	            * */
	            var returnAsset = {};
	            if (asset.constant === assetConstants.ASSET_TYPE_ICON) {
	                returnAsset = appHelper.getIconAsset(asset);
	            } else if (asset.constant === assetConstants.ASSET_TYPE_IMAGE) {
	                returnAsset = appHelper.getImageAsset(asset);
	            } else if (asset.constant === assetConstants.ASSET_TYPE_LIBRARY_IMAGE) {
	                returnAsset = appHelper.getLibraryImageAsset(asset);
	            } else if (asset.constant === assetConstants.ASSET_TYPE_ID_CHARACTER) {
	                var characterAsset = appHelper.getCharacterAsset(asset);
	                returnAsset = appHelper.getCharacterPose(characterAsset, asset);
	            }
	            returnAsset = appHelper.isDefined(returnAsset.locale) ? appHelper.getLocalData(returnAsset) : returnAsset;
	
	            if (appHelper.isDefined(asset.constant) && !appHelper.isDefined(returnAsset.type)) {
	                returnAsset = Object.assign({}, returnAsset, {
	                    type: asset.constant
	                });
	            }
	
	            return returnAsset;
	        }
	    }, {
	        key: 'getImagePath',
	        value: function getImagePath(image) {
	            if (appConstants.DEVELOPMENT_MODE) {
	                if (appHelper.isDefined(image) && image.length > 0) {
	                    return __webpack_require__(16)("./" + image);
	                }
	            } else {
	                return image;
	            }
	        }
	    }, {
	        key: 'storeUserResponse',
	        value: function storeUserResponse() {
	            var selectedOptions = [this.state.option.option_id];
	            var responseObj = {
	                asset_id: this.props.asset_id,
	                selectedOptions: selectedOptions,
	                kpis: this.state.option.kpis !== null ? this.state.option.kpis : []
	            };
	            this.props.callbacks.storeUserResponse(responseObj);
	        }
	    }, {
	        key: 'scrollToTop',
	        value: function scrollToTop() {
	            var feedback = document.getElementById('feedback_wrapper_' + this.props.asset_id);
	            this.props.callbacks.scrollToFeedback(feedback.offsetTop);
	        }
	    }, {
	        key: 'enableProgression',
	        value: function enableProgression() {
	            this.setState({ enableProgression: true });
	        }
	    }, {
	        key: 'getLinkClass',
	        value: function getLinkClass() {
	            return this.state.enableProgression ? "" : "disabled-link";
	        }
	    }, {
	        key: 'getDisabledState',
	        value: function getDisabledState() {
	            return !this.state.enableProgression;
	        }
	    }, {
	        key: 'handleOptionFeedback',
	        value: function handleOptionFeedback() {
	            var feedbackOptions = [];
	            var noMsgObj = {
	                id: "none",
	                feedback: "",
	                options: [],
	                checked: false
	            };
	
	            var optionsForFeedback = [];
	            for (var i = 0; i < this.props.options.length; i++) {
	                var option = this.props.options[i];
	                var locale = appHelper.getLocalData(option);
	
	                var isChecked = this.state.option.option_id === option.option_id;
	                var optionObject = {
	                    result: option.result,
	                    className: isChecked ? 'checked' : 'unchecked',
	                    option_text: locale.option,
	                    option_id: option.option_id,
	                    kpis: appHelper.isDefined(option.kpis) && option.kpis !== null ? option.kpis : []
	                };
	
	                if (isChecked) {
	                    optionsForFeedback = dataHelper.immutablePush(optionsForFeedback, optionObject);
	                }
	            }
	
	            if (optionsForFeedback.length > 1) {
	
	                optionsForFeedback.sort(function (a, b) {
	                    if (a.className < b.className) return -1;
	                    if (a.className > b.className) return 1;
	                    return 0;
	                });
	            }
	
	            if (optionsForFeedback.length > 0) {
	                noMsgObj = Object.assign({}, noMsgObj, {
	                    options: Object.assign([], optionsForFeedback)
	                });
	            }
	
	            if (noMsgObj.options.length > 0) {
	                feedbackOptions = dataHelper.immutablePush(feedbackOptions, noMsgObj);
	            }
	
	            this.setState({ optionFeedback: Object.assign([], feedbackOptions) });
	        }
	    }, {
	        key: 'onFeedbackRevealed',
	        value: function onFeedbackRevealed() {
	            this.storeUserResponse();
	            this.scrollToTop();
	        }
	    }, {
	        key: 'onFeedbackHidden',
	        value: function onFeedbackHidden() {
	            //  this.props.callbacks.resizeWatcher();
	            if (typeof this.props.onComplete !== 'undefined') {
	                this.props.onComplete();
	            }
	        }
	    }, {
	        key: 'showFeedbackContent',
	        value: function showFeedbackContent() {
	            this.setState({ showFeedbackContent: true });
	        }
	    }, {
	        key: 'onProgressionClicked',
	        value: function onProgressionClicked() {
	            this.hide();
	        }
	    }, {
	        key: 'show',
	        value: function show() {
	            var feedbackPanel = this.refs[this.state.option.option_id + '_feedbackPanel'];
	            _gsap.TweenLite.set(feedbackPanel, { height: "auto", opacity: 1 });
	            _gsap.TweenLite.from(feedbackPanel, objectConstants.FEEDBACK_DURATION, {
	                height: 0,
	                opacity: 0,
	                ease: _gsap.Expo.easeInOut
	            }).eventCallback("onComplete", this.onFeedbackRevealed);
	            /**/
	        }
	    }, {
	        key: 'hide',
	        value: function hide() {
	            this.setState({ hideFeedback: false });
	            var feedbackPanel = this.refs[this.state.option.option_id + '_feedbackPanel'];
	            _gsap.TweenLite.to(feedbackPanel, objectConstants.FEEDBACK_DURATION, {
	                height: 0,
	                opacity: 0,
	                ease: _gsap.Expo.easeInOut
	            }).eventCallback("onComplete", this.onFeedbackHidden);
	        }
	    }, {
	        key: 'onToolboxComplete',
	        value: function onToolboxComplete(progression, asset_id, latestResponse) {
	            this.setState({ toolboxIsComplete: true });
	        }
	    }, {
	        key: 'setToolboxCallbacks',
	        value: function setToolboxCallbacks() {
	            this.setState({
	                toolboxCallbacks: Object.assign({}, this.state.toolboxCallbacks, {
	                    onObjectComplete: this.onToolboxComplete,
	                    isReviewMode: function isReviewMode() {
	                        return false;
	                    }
	                })
	            });
	        }
	    }, {
	        key: 'onBadgeCollected',
	        value: function onBadgeCollected() {
	            this.setState({ badgesCollected: true });
	            //this.hide();
	        }
	    }, {
	        key: 'dialogsOnComplete',
	        value: function dialogsOnComplete() {
	            this.setState({ dialogComplete: true });
	        }
	    }, {
	        key: 'setResources',
	        value: function setResources() {
	            var resourceLinks = appHelper.setResourceLinks(this.state.option);
	
	            this.setState({
	                resourceLinks: Object.assign([], resourceLinks),
	                hasResources: resourceLinks.length > 0,
	                resourcesAreComplete: resourceLinks.length === 0
	            });
	        }
	    }, {
	        key: 'onResourcesComplete',
	        value: function onResourcesComplete() {
	            if (!this.state.resourcesAreComplete) {
	                this.setState({ resourcesAreComplete: true, checkComplete: true });
	            }
	        }
	    }, {
	        key: 'getInheritedFeedback',
	        value: function getInheritedFeedback(feedback_id) {
	            var option = appHelper.getArrayObjectByKey(this.state.options, "option_id", feedback_id);
	            var optionLocale = appHelper.getLocalData(option);
	            return optionLocale.feedback;
	        }
	    }, {
	        key: 'checkIsReadyToComplete',
	        value: function checkIsReadyToComplete() {
	            return !this.props.callbacks.hasNextObject(this.props.index) && this.state.option.progression !== objectConstants.OBJECT_PROGRESSION_TRY_AGAIN && this.state.enableProgression && !this.state.completionCalled
	            //&& ((this.state.hasBadges && this.state.badgesCollected) || !this.state.hasBadges )
	            && this.state.resourcesAreComplete;
	        }
	    }, {
	        key: 'setComplete',
	        value: function setComplete() {
	            this.setState({ completionCalled: true });
	            this.props.onComplete();
	        }
	    }, {
	        key: 'showProgressButton',
	        value: function showProgressButton() {
	            /*return (
	                (!this.props.callbacks.hasNextObject(this.props.screenObject) && this.state.option.progression === objectConstants.OBJECT_PROGRESSION_TRY_AGAIN) || this.props.callbacks.hasNextObject(this.props.screenObject))
	                && appHelper.isDefined(this.state.locale.progression_label)
	                && ((this.state.hasBadges && this.state.badgesCollected) || !this.state.hasBadges )
	                && this.state.resourcesAreComplete;*/
	            return this.state.enableProgression && appHelper.isDefined(this.state.locale.progression_label)
	            //&& ((this.state.hasBadges && this.state.badgesCollected) || !this.state.hasBadges )
	            && this.state.resourcesAreComplete;
	        }
	    }, {
	        key: 'setKeyboardAccessibility',
	        value: function setKeyboardAccessibility(event) {
	
	            if (event.which === keyboardConstants.ENTER_KEY || event.which === keyboardConstants.SPACEBAR_KEY) {
	                event.preventDefault();
	                if (this.state.enableProgression) {
	                    this.onReview();
	                }
	            }
	        }
	    }, {
	        key: 'onReview',
	        value: function onReview() {
	            if (this.state.enableProgression) {
	                this.props.onShowReview('review_link_' + this.state.option.option_id);
	            }
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            return _react2.default.createElement(
	                'div',
	                { className: 'feedback-panel ' + this.state.option.result,
	                    ref: this.state.option.option_id + '_feedbackPanel',
	                    id: this.state.option.option_id + '_feedbackPanel' },
	                _react2.default.createElement('img', { src: __webpack_require__(133)("./" + this.state.option.result + '.svg'), style: kpiConstants.WATERMARK_STYLES, alt: '' }),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'feedback-content-col' },
	                    this.state.showKpis ? _react2.default.createElement(_ScoreKpi2.default, { bite_id: this.props.responseData.bite_id,
	                        displayState: kpiConstants.KPI_DISPLAY_STATE_CURRENT_VALUE_NO_LABEL,
	                        showImmediateImpact: this.state.kpiDashboardParams.showImmediateImpact,
	                        showTitle: this.state.kpiDashboardParams.showTitle,
	                        onUpdateComplete: this.enableProgression }) : null,
	                    this.state.optionFeedback.length > 0 && this.props.option.enable_feedback ? _react2.default.createElement(_OptionFeedback2.default, { feedback_options: this.state.optionFeedback,
	                        asset_id: this.props.asset_id,
	                        responseData: this.props.responseData
	                    }) : null,
	                    appHelper.isDefined(this.state.assetData.constant) && (!appHelper.isDefined(this.props.showImages) || appHelper.isDefined(this.props.showImages) && this.props.showImages) ? _react2.default.createElement(
	                        'div',
	                        { className: 'feedback-image' },
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'image-container' },
	                            this.state.assetData.constant === assetConstants.ASSET_TYPE_IMAGE || this.state.assetData.constant === assetConstants.ASSET_TYPE_LIBRARY_IMAGE ? this.state.assetData.constant === assetConstants.ASSET_TYPE_IMAGE ? _react2.default.createElement(_SecondaryImage2.default, { screenObject: this.state.assetData }) : _react2.default.createElement(_SecondaryLibraryImage2.default, { screenObject: this.state.assetData }) : _react2.default.createElement('img', { src: this.getImagePath(this.state.screenAsset.src), alt: '' })
	                        )
	                    ) : null,
	                    appHelper.isDefined(this.state.locale.feedback) && this.state.locale.feedback.length > 0 && this.state.locale.feedback !== "<p><br></p>" && this.props.option.enable_feedback ? _react2.default.createElement('div', { dangerouslySetInnerHTML: { __html: this.state.locale.feedback } }) : appHelper.isDefined(this.state.option.feedback_id) ? _react2.default.createElement('div', {
	                        dangerouslySetInnerHTML: { __html: this.getInheritedFeedback(this.state.option.feedback_id) } }) : null,
	                    this.state.hasResources ? _react2.default.createElement(_ResourceLinks2.default, { resources: this.state.resourceLinks,
	                        onResourcesComplete: this.onResourcesComplete }) : null,
	                    this.props.option.progression === objectConstants.OBJECT_PROGRESSION_CONTINUE && this.state.resourcesAreComplete && this.props.contentData.experience.include_explore_feedback ? _react2.default.createElement(
	                        'div',
	                        { className: 'guroo-active-link text-center ' + this.getLinkClass(), role: 'link',
	                            tabIndex: '0',
	                            id: 'review_link_' + this.state.option.option_id,
	                            onKeyDown: this.setKeyboardAccessibility,
	                            onClick: this.onReview },
	                        this.state.review_other_options_label
	                    ) : null
	                )
	            );
	        }
	    }]);
	
	    return SingleAnswerFeedback;
	}(_react2.default.Component);
	
	SingleAnswerFeedback.propTypes = {
	    screenObject: _propTypes2.default.object,
	    option: _propTypes2.default.object.isRequired,
	    options: _propTypes2.default.array.isRequired,
	    responseData: _propTypes2.default.object.isRequired,
	    callbacks: _propTypes2.default.object.isRequired,
	    asset_id: _propTypes2.default.number.isRequired,
	    index: _propTypes2.default.number,
	    onComplete: _propTypes2.default.func,
	    onShowReview: _propTypes2.default.func,
	    scrollToFeedback: _propTypes2.default.func,
	    actions: _propTypes2.default.object,
	    contentData: _propTypes2.default.object.isRequired,
	    showImages: _propTypes2.default.bool,
	    onEnableProgression: _propTypes2.default.func,
	    lang: _propTypes2.default.string.isRequired,
	    hideFeedback: _propTypes2.default.bool
	};
	
	SingleAnswerFeedback.contextTypes = {
	    router: _propTypes2.default.object
	};
	
	function mapStateToProps(state, ownProps) {
	    var lang = state.userData.lang;
	    return {
	        lang: lang,
	        contentData: state.contentData
	    };
	}
	
	function mapDispatchToProps(dispatch) {
	    return {
	        actions: (0, _redux.bindActionCreators)(Object.assign({}, appDataActions, trackingDataActions, userDataActions), dispatch)
	    };
	}
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(SingleAnswerFeedback);

/***/ },
/* 201 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.getTotalAchievedCount = getTotalAchievedCount;
	exports.biteHasvisibleBadges = biteHasvisibleBadges;
	exports.getBadgeParentBiteId = getBadgeParentBiteId;
	
	var _appHelper = __webpack_require__(3);
	
	var appHelper = _interopRequireWildcard(_appHelper);
	
	var _localStorage = __webpack_require__(17);
	
	var localStorage = _interopRequireWildcard(_localStorage);
	
	var _lodash = __webpack_require__(28);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function getTotalAchievedCount(badges) {
	    var achieved = 0;
	    for (var i = 0; i < badges.length; i++) {
	        var badge = badges[i];
	        achieved = achieved + badge.achieved;
	    }
	    return achieved;
	}
	
	function biteHasvisibleBadges(bite) {
	    var visibleBadges = 0;
	
	    if (appHelper.isDefined(bite.badges)) {
	        _lodash2.default.forEach(bite.badges, function (badge) {
	            if (!appHelper.isDefined(badge.is_visible) || appHelper.isDefined(badge.is_visible) && badge.is_visible) {
	                visibleBadges++;
	            }
	        });
	    }
	
	    return visibleBadges > 0;
	}
	
	function getBadgeParentBiteId(badge_id) {
	    var bite_id = -1;
	    for (var i = 0; i < localStorage.bites.length; i++) {
	        var bite = localStorage.bites[i];
	        if (appHelper.isDefined(bite.badges)) {
	            var badgeIndex = appHelper.getArrayObjectIndexByKey(bite.badges, "badge_id", badge_id);
	            if (badgeIndex > -1) {
	                bite_id = bite.bite_id;
	                break;
	            }
	        }
	    }
	    return bite_id;
	}

/***/ },
/* 202 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.newDialog = newDialog;
	exports.newAssetDialog = newAssetDialog;
	exports.newScreenDialog = newScreenDialog;
	exports.setConfig = setConfig;
	exports.setScreenConfig = setScreenConfig;
	exports.setClass = setClass;
	exports.setComponent = setComponent;
	exports.clearDialog = clearDialog;
	exports.setStandardDialog = setStandardDialog;
	exports.setAssetDialog = setAssetDialog;
	exports.setScreenDialog = setScreenDialog;
	exports.setClickReveal = setClickReveal;
	
	var _dialogModels = __webpack_require__(32);
	
	var dialogModels = _interopRequireWildcard(_dialogModels);
	
	var _appHelper = __webpack_require__(3);
	
	var appHelper = _interopRequireWildcard(_appHelper);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function newDialog(confgObj) {
	    return Object.assign({}, dialogModels.DIALOG);
	}
	
	/*export function newClickRevealDialog(){
	    return Object.assign({}, dialogModels.CLICK_REVEAL_DIALOG);
	}*/
	
	function newAssetDialog() {
	    return Object.assign({}, dialogModels.ASSET_DIALOG);
	}
	
	function newScreenDialog() {
	    return Object.assign({}, dialogModels.SCREEN_DIALOG);
	}
	
	function setConfig(config) {
	    //console.log('setConfig', config);
	    return Object.assign({}, dialogModels.DIALOG_CONFIG, {
	        dialogComponent: typeof config.dialogComponent !== 'undefined' ? config.dialogComponent : dialogModels.DIALOG_CONFIG.dialogComponent,
	        title: typeof config.title !== 'undefined' ? config.title : dialogModels.DIALOG_CONFIG.title,
	        icon: typeof config.icon !== 'undefined' ? config.icon : dialogModels.DIALOG_CONFIG.icon,
	        theme: typeof config.theme !== 'undefined' ? config.theme : dialogModels.DIALOG_CONFIG.theme,
	        showCloseBtn: typeof config.showCloseBtn !== 'undefined' ? config.showCloseBtn : dialogModels.DIALOG_CONFIG.showCloseBtn,
	        onClose: typeof config.onClose !== 'undefined' ? config.onClose : dialogModels.DIALOG_CONFIG.showCloseBtn,
	        childComponents: typeof config.childComponents !== 'undefined' ? config.childComponents : dialogModels.DIALOG_CONFIG.childComponents,
	        sourceId: typeof config.sourceId !== 'undefined' ? config.sourceId : dialogModels.DIALOG_CONFIG.sourceId
	    });
	}
	
	function setScreenConfig(config) {
	    return Object.assign({}, dialogModels.SCREEN_CONFIG, {
	        component: appHelper.isDefined(config.component) ? config.component : dialogModels.SCREEN_CONFIG.component,
	        biteCallbacks: appHelper.isDefined(config.biteCallbacks) ? config.biteCallbacks : dialogModels.SCREEN_CONFIG.biteCallbacks,
	        parentScreen: appHelper.isDefined(config.parentScreen) ? config.parentScreen : dialogModels.SCREEN_CONFIG.parentScreen,
	        screen: appHelper.isDefined(config.screen) ? config.screen : dialogModels.SCREEN_CONFIG.screen,
	        showCloseBtn: appHelper.isDefined(config.showCloseBtn) ? config.showCloseBtn : dialogModels.SCREEN_CONFIG.showCloseBtn,
	        onClose: appHelper.isDefined(config.onClose) ? config.onClose : dialogModels.SCREEN_CONFIG.onClose,
	        sourceId: typeof config.sourceId !== 'undefined' ? config.sourceId : dialogModels.DIALOG_CONFIG.sourceId
	    });
	}
	
	function setClass(dialog, className) {
	    return Object.assign({}, dialog, { className: className });
	}
	
	function setComponent(dialog, className) {
	    return Object.assign({}, dialog, { className: className });
	}
	
	function clearDialog() {
	    return new Promise(function (resolve, reject) {
	        var dialog = {};
	        resolve(dialog);
	    });
	}
	
	function setStandardDialog(config) {
	    return new Promise(function (resolve, reject) {
	
	        var dialog = newDialog();
	        dialog.config = Object.assign({}, setConfig(config));
	
	        resolve(dialog);
	    });
	}
	
	function setAssetDialog(config) {
	    return new Promise(function (resolve, reject) {
	
	        var dialog = newAssetDialog();
	        dialog.config = Object.assign({}, setConfig(config));
	
	        resolve(dialog);
	    });
	}
	
	function setScreenDialog(config) {
	    return new Promise(function (resolve, reject) {
	
	        var dialog = newScreenDialog();
	        dialog.config = Object.assign({}, setScreenConfig(config));
	
	        resolve(dialog);
	    });
	}
	
	function setClickReveal(config) {
	    return new Promise(function (resolve, reject) {
	        /*
	                let dialog = newClickRevealDialog();
	                dialog.config = Object.assign({}, setConfig(config));
	        
	                resolve(dialog);*/
	
	    });
	}

/***/ },
/* 203 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.getScreenAssetPanelWidth = getScreenAssetPanelWidth;
	exports.showAssetLeftPanel = showAssetLeftPanel;
	exports.showAssetLeft = showAssetLeft;
	exports.showAssetRightPanel = showAssetRightPanel;
	exports.showAssetRight = showAssetRight;
	exports.checkImageWidth = checkImageWidth;
	exports.getAssetType = getAssetType;
	exports.checkAssetPanelImageWidth = checkAssetPanelImageWidth;
	exports.checkContentImageWidth = checkContentImageWidth;
	exports.getAssetLeftPanelId = getAssetLeftPanelId;
	exports.getAssetRightPanelId = getAssetRightPanelId;
	exports.getAssetLeftId = getAssetLeftId;
	exports.getAssetRightId = getAssetRightId;
	exports.getContentAreaId = getContentAreaId;
	exports.getImageClass = getImageClass;
	exports.getImageShape = getImageShape;
	exports.getImageEffect = getImageEffect;
	exports.getImageOrientation = getImageOrientation;
	exports.getAssetImageOrientation = getAssetImageOrientation;
	exports.getAssetImageShape = getAssetImageShape;
	exports.getAssetImageClass = getAssetImageClass;
	exports.checkAssetImageWidth = checkAssetImageWidth;
	
	var _appHelper = __webpack_require__(3);
	
	var appHelper = _interopRequireWildcard(_appHelper);
	
	var _objectConstants = __webpack_require__(9);
	
	var objectConstants = _interopRequireWildcard(_objectConstants);
	
	var _objectModels = __webpack_require__(559);
	
	var objectModels = _interopRequireWildcard(_objectModels);
	
	var _assetConstants = __webpack_require__(33);
	
	var assetConstants = _interopRequireWildcard(_assetConstants);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	var NONE = "none";
	
	function getScreenAssetPanelWidth(screen) {
	    var style = "";
	    if (showAssetLeftPanel(screen) || showAssetRightPanel(screen)) {
	        style = "flexi";
	    }
	
	    return style;
	}
	
	function showAssetLeftPanel(screen) {
	    return appHelper.isDefined(screen.panel_location) && screen.panel_location === "right" && appHelper.isDefined(screen.assets.left);
	}
	function showAssetLeft(screen) {
	    return appHelper.isDefined(screen.assets.left);
	}
	
	function showAssetRightPanel(screen) {
	    return appHelper.isDefined(screen.panel_location) && screen.panel_location === "left" && appHelper.isDefined(screen.assets.right);
	}
	
	function showAssetRight(screen) {
	    return appHelper.isDefined(screen.assets.right);
	}
	
	function checkImageWidth(screen) {
	    var width = {
	        styles: {}
	    };
	    if (showAssetLeftPanel(screen) || showAssetRightPanel(screen)) {
	
	        width = checkAssetPanelImageWidth(screen.screen_id, screen);
	    } else if (showAssetLeft(screen) || showAssetRight(screen)) {
	
	        width = checkContentImageWidth(screen.screen_id, screen);
	    }
	    return width;
	}
	function getAssetType(asset) {
	    var returnAsset = {};
	    if (asset.constant === assetConstants.ASSET_TYPE_ID_CHARACTER) {
	        var screenCharacter = appHelper.getCharacterAsset(asset);
	        returnAsset = appHelper.getCharacterPose(screenCharacter, asset);
	    } else if (asset.constant === assetConstants.ASSET_TYPE_ICON) {
	        returnAsset = appHelper.getIconAsset(asset);
	    } else if (asset.constant === assetConstants.ASSET_TYPE_IMAGE) {
	        returnAsset = appHelper.getImageAsset(asset);
	    } else if (asset.constant === assetConstants.ASSET_TYPE_LIBRARY_IMAGE) {
	        returnAsset = appHelper.getLibraryImageAsset(asset);
	    }
	
	    returnAsset = appHelper.isDefined(returnAsset.locale) ? appHelper.getLocalData(returnAsset) : returnAsset;
	
	    return returnAsset;
	}
	function checkAssetPanelImageWidth(screen_id, screen) {
	    var contentArea = document.getElementById('screenWrapper');
	    var max = Math.round(contentArea.offsetWidth / 100 * 40) - 20;
	    var width = 0;
	    //console.log('width set at line 60', width);
	    if (showAssetLeftPanel(screen) || showAssetRightPanel(screen)) {
	        var screenAsset = {};
	        if (showAssetLeftPanel(screen)) {
	            screenAsset = getAssetType(screen.assets.left);
	        } else if (showAssetRightPanel(screen)) {
	            screenAsset = getAssetType(screen.assets.right);
	        }
	
	        if (appHelper.isDefined(screenAsset.width)) {
	            var obj = appHelper.getArrayObjectByKey(objectModels.SPECIIFIC_IMAGE_SIZES, "constant", screen.screen_image_width);
	            switch (screen.image_size) {
	                case objectConstants.IMAGE_SIZE_ACTUAL:
	                    width = screenAsset.width < max ? screenAsset.width : max;
	                    //console.log('width set at line 74', width);
	                    break;
	                case objectConstants.IMAGE_SIZE_RETINA:
	                    width = screenAsset.width / 2 < max ? screenAsset.width / 2 : max;
	                    //console.log('width set at line 78', width);
	                    break;
	                case objectConstants.IMAGE_SIZE_SPECIFIC:
	                    width = Math.round(contentArea.offsetWidth / 100 * obj.value);
	                    //console.log('width set at line 83', width);
	                    break;
	                case objectConstants.IMAGE_SIZE_MAX:
	                    width = max;
	                    //console.log('width set at line 86', width);
	                    break;
	            }
	
	            if (getImageShape(screen_id, screen).length > 0 && screenAsset.width > 0) {
	                if (screen.image_shape === objectConstants.IMAGE_SHAPE_RECTANGLE) {
	                    var imageOrientation = getImageOrientation(screen_id, screen);
	                    if (imageOrientation === "landscape") {
	                        var maxWidth = screenAsset.width / 100 * 58.5;
	                        if (width > maxWidth) {
	                            width = maxWidth;
	                            //console.log('width set at line 98', width);
	                        }
	                    } else {
	                        if (screenAsset.width < width) {
	                            width = screenAsset.width;
	                            //console.log('width set at line 104', width);
	                        }
	                    }
	                } else {
	                    if (screenAsset.height < width) {
	                        width = screenAsset.height;
	                        //console.log('width set at line 111', width);
	
	                        if (screenAsset.width < width) {
	                            width = screenAsset.width;
	                            //console.log('width set at line 115', width);
	                        }
	                    } else if (screenAsset.width < width) {
	                        width = screenAsset.width;
	                        //console.log('width set at line 119', width);
	                        if (screenAsset.height < width) {
	                            width = screenAsset.height;
	                            //console.log('width set at line 122', width);
	                        }
	                    }
	                }
	            } else {
	                if (screenAsset.width < width && screenAsset.width > 0) {
	                    width = screenAsset.width;
	                    //console.log('width set at line 129', width);
	                }
	            }
	        }
	    }
	
	    //console.log(`width: `,width);
	    return {
	        styles: {
	            width: width,
	            display: width === 0 ? 'none' : 'block'
	        }
	    };
	}
	
	function checkContentImageWidth(screen_id, screen) {
	    var contentArea = document.getElementById(screen.screen_id + '_feed_id');
	
	    var width = 0;
	    if (showAssetLeft(screen) || showAssetRight(screen)) {
	        var screenAsset = {};
	        if (showAssetLeft(screen)) {
	            screenAsset = getAssetType(screen.assets.left);
	        } else if (showAssetRight(screen)) {
	            screenAsset = getAssetType(screen.assets.right);
	        }
	
	        if (appHelper.isDefined(screenAsset.width) && contentArea !== null) {
	            var max = Math.round(contentArea.offsetWidth / 100 * 40);
	            var obj = appHelper.getArrayObjectByKey(objectModels.SPECIIFIC_IMAGE_SIZES, "constant", screen.screen_image_width);
	            switch (screen.image_size) {
	                case objectConstants.IMAGE_SIZE_ACTUAL:
	                    width = screenAsset.width < max ? screenAsset.width : max;
	                    break;
	                case objectConstants.IMAGE_SIZE_RETINA:
	                    width = screenAsset.width / 2 < max ? screenAsset.width / 2 : max;
	                    break;
	                case objectConstants.IMAGE_SIZE_SPECIFIC:
	                    width = Math.round(contentArea.offsetWidth / 100 * obj.value);
	                    break;
	                case objectConstants.IMAGE_SIZE_MAX:
	                    width = max;
	                    break;
	            }
	
	            if (getImageShape(screen_id, screen).length > 0 && screenAsset.width > 0) {
	                if (screen.image_shape === objectConstants.IMAGE_SHAPE_RECTANGLE) {
	                    var imageOrientation = getImageOrientation(screen_id, screen);
	                    if (imageOrientation === "landscape") {
	                        var maxWidth = screenAsset.width / 100 * 58.5;
	                        if (width > maxWidth) {
	                            width = maxWidth;
	                        }
	                    } else {
	                        if (screenAsset.width < width) {
	                            width = screenAsset.width;
	                        }
	                    }
	                } else {
	                    if (screenAsset.height < width) {
	                        width = screenAsset.height;
	                        if (screenAsset.width < width) {
	                            width = screenAsset.width;
	                        }
	                    } else if (screenAsset.width < width) {
	                        width = screenAsset.width;
	                        if (screenAsset.height < width) {
	                            width = screenAsset.height;
	                        }
	                    }
	                }
	            } else {
	                if (screenAsset.width < width && screenAsset.width > 0) {
	                    width = screenAsset.width;
	                }
	            }
	        }
	    }
	
	    return {
	        styles: {
	            width: width,
	            display: width === 0 ? 'none' : 'block'
	        }
	    };
	}
	
	function getAssetLeftPanelId(screen_id) {
	    return '' + screen_id + objectConstants.ASSET_LEFT_PANEL_POSTFIX;
	}
	
	function getAssetRightPanelId(screen_id) {
	    return '' + screen_id + objectConstants.ASSET_RIGHT_PANEL_POSTFIX;
	}
	
	function getAssetLeftId(screen_id) {
	    return '' + screen_id + objectConstants.ASSET_LEFT_POSTFIX;
	}
	
	function getAssetRightId(screen_id) {
	    return '' + screen_id + objectConstants.ASSET_RIGHT_POSTFIX;
	}
	
	function getContentAreaId(screen_id) {
	    return '' + screen_id + objectConstants.CONTENT_AREA_POSTFIX;
	}
	
	function getImageClass(screen) {
	    var imageShape = getImageShape(screen.screen_id, screen);
	    var imageEffect = getImageEffect(screen);
	    var imageOrientation = getImageOrientation(screen.screen_id, screen);
	    return imageShape + ' ' + imageEffect + ' ' + imageOrientation;
	}
	
	function getImageShape(screen_id, screen) {
	    //image_shape
	    var imageOrientation = getImageOrientation(screen_id, screen);
	
	    if (screen.image_shape !== NONE) {
	        if (imageOrientation === "landscape") {
	            return screen.image_shape + ' ' + screen.image_mask_position_landscape;
	        } else {
	            return screen.image_shape + ' ' + screen.image_mask_position_portrait;
	        }
	    } else {
	        return "none";
	    }
	}
	
	function getImageEffect(screen) {
	    //image_effect
	    return screen.image_effect !== NONE ? screen.image_effect : "none";
	}
	
	function getImageOrientation(screen_id, screen) {
	    var screenAsset = {};
	    if (showAssetLeftPanel(screen)) {
	        screenAsset = getAssetType(screen.assets.left);
	    } else if (showAssetRightPanel(screen)) {
	        screenAsset = getAssetType(screen.assets.right);
	    } else if (showAssetLeft(screen)) {
	        screenAsset = getAssetType(screen.assets.left);
	    } else if (showAssetRight(screen)) {
	        screenAsset = getAssetType(screen.assets.right);
	    }
	
	    if (appHelper.isDefined(screenAsset)) {
	        return screenAsset.width < screenAsset.height ? "portrait" : "landscape";
	    }
	
	    return "";
	}
	
	// Objects
	function getAssetImageOrientation(asset) {
	    var image = {};
	    if (appHelper.isDefined(asset.left)) {
	        image = Object.assign({}, asset.left);
	    } else if (appHelper.isDefined(asset.right)) {
	        image = Object.assign({}, asset.right);
	    } else if (appHelper.isDefined(asset.top)) {
	        image = Object.assign({}, asset.top);
	    } else if (appHelper.isDefined(asset.bottom)) {
	        image = Object.assign({}, asset.bottom);
	    } else if (appHelper.isDefined(asset.image)) {
	        image = Object.assign({}, asset.image);
	    }
	
	    if (appHelper.isDefined(image.width) && appHelper.isDefined(image.height)) {
	        return image.width < image.height ? "portrait" : "landscape";
	    }
	    return "landscape";
	}
	
	function getAssetImageShape(asset) {
	
	    //image_shape
	    var imageOrientation = getAssetImageOrientation(asset);
	
	    if (asset.image_shape !== NONE) {
	        if (imageOrientation === "landscape") {
	            return asset.image_shape + ' ' + asset.image_mask_position_landscape;
	        } else {
	            return asset.image_shape + ' ' + asset.image_mask_position_portrait;
	        }
	    } else {
	        return "none";
	    }
	}
	
	function getAssetImageClass(asset) {
	    var imageShape = getAssetImageShape(asset);
	    var imageEffect = getImageEffect(asset);
	    var imageOrientation = getAssetImageOrientation(asset);
	    return imageShape + ' ' + imageEffect + ' ' + imageOrientation;
	}
	
	function checkAssetImageWidth(asset, image, maxWidth) {
	    if (appHelper.isDefined(asset.top) || appHelper.isDefined(asset.right) || appHelper.isDefined(asset.bottom) || appHelper.isDefined(asset.left) || appHelper.isDefined(asset.image)) {
	        //console.log(`maxWidth`, maxWidth ,`image`, image);
	        var max = maxWidth;
	        if (appHelper.isDefined(asset.left) || appHelper.isDefined(asset.right)) {
	            max = Math.round(maxWidth / 100 * 40) - 20;
	        }
	
	        var width = max;
	        var validationMsg = "Your image has reached it's maximum width";
	        var showValidation = false;
	
	        /*let image = {};
	        if(appHelper.isDefined(asset.left)){
	            image = Object.assign({},asset.left);
	        }else if(appHelper.isDefined(asset.right)){
	            image = Object.assign({},asset.right);
	        }else if(appHelper.isDefined(asset.top)){
	            image = Object.assign({},asset.top);
	        }else if(appHelper.isDefined(asset.bottom)){
	            image = Object.assign({},asset.bottom);
	        }else if(appHelper.isDefined(asset.image)){
	            image = Object.assign({},asset.image);
	            //console.log(`image`,image);
	        }*/
	
	        if (image.constant === "icon" && (!appHelper.isDefined(image.width) || image.width === null || image.width === "")) {
	            image = Object.assign({}, image, {
	                width: 500,
	                height: 500
	            });
	        }
	
	        if (appHelper.isDefined(image.width)) {
	            var imageWidth = parseInt(image.width);
	            var imageHeight = parseInt(image.height);
	            var obj = {};
	            if (appHelper.isDefined(asset.left) || appHelper.isDefined(asset.right)) {
	                obj = appHelper.getArrayObjectByKey(objectModels.ASSET_IMAGE_SIZES, "constant", asset.asset_image_width);
	            } else if (appHelper.isDefined(asset.top) || appHelper.isDefined(asset.bottom)) {
	                obj = appHelper.getArrayObjectByKey(objectModels.TOP_ASSET_IMAGE_SIZES, "constant", asset.top_asset_image_width);
	            } else if (appHelper.isDefined(asset.image)) {
	                obj = appHelper.getArrayObjectByKey(objectModels.TOP_ASSET_IMAGE_SIZES, "constant", asset.asset_image_width);
	            }
	            switch (asset.image_size) {
	                case objectConstants.IMAGE_SIZE_ACTUAL:
	                    width = imageWidth < width && imageWidth > 0 ? imageWidth : width;
	                    break;
	                case objectConstants.IMAGE_SIZE_RETINA:
	                    width = imageWidth / 2 < width && imageWidth > 0 ? imageWidth / 2 : width;
	                    break;
	                case objectConstants.IMAGE_SIZE_SPECIFIC:
	
	                    width = Math.round(maxWidth / 100 * obj.value);
	                    break;
	                case objectConstants.IMAGE_SIZE_MAX:
	                    width = imageWidth < width && imageWidth > 0 ? imageWidth : width;
	                    break;
	            }
	
	            if (getAssetImageShape(asset).length > 0 && imageWidth > 0) {
	                if (asset.image_shape === objectConstants.IMAGE_SHAPE_RECTANGLE) {
	                    var imageOrientation = getAssetImageOrientation(asset);
	                    if (imageOrientation === "landscape") {
	                        var _maxWidth = imageWidth / 100 * 58.5;
	
	                        if (width > _maxWidth) {
	                            width = _maxWidth;
	                        }
	
	                        var maxHeight = width / 3 * 4;
	                        if (maxHeight > imageHeight) {
	                            var _maxWidth2 = imageHeight / 3 * 2.2;
	                            width = _maxWidth2;
	                        }
	                    } else {
	                        if (imageWidth < width) {
	                            width = imageWidth;
	                        }
	                    }
	                } else if (asset.image_shape !== NONE) {
	                    // console.log(`asset.image_shape`,asset.image_shape)
	                    if (imageHeight < width) {
	                        width = imageHeight;
	
	                        if (imageWidth < width) {
	                            width = imageWidth;
	                        }
	                    } else if (imageWidth < width) {
	                        width = imageWidth;
	
	                        if (imageHeight < width) {
	                            // console.log('hello2')
	                            width = imageHeight;
	                        }
	                    }
	                }
	            } else {
	                if (imageWidth < width && imageWidth > 0) {
	                    width = imageWidth;
	                }
	            }
	        }
	
	        return {
	            styles: {
	                width: width
	            },
	            validation: {
	                message: showValidation ? validationMsg : ""
	            }
	        };
	    }
	    return {
	        styles: {},
	        validation: {}
	    };
	}

/***/ },
/* 204 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.AUTO_NAVIGATE_IF_LAST_ON_INCOMPLETE_SCREEN = exports.CHECK_SCROLL_AFTER = exports.ALWAY_SCROLL_AFTER = exports.RESOURCE_LINK_TYPES = exports.CHILD_OBJECTS_TYPES = exports.ASSET_TYPES = exports.TITLE_SCREEN_SUB_TYPES = exports.SCREEN_TYPES = exports.BITE_TYPES = exports.MENU_TYPES = exports.MENU_TYPE_PERSONAL_LEARNING_PLAN = exports.MENU_TYPE_FIRST_ANY_LAST_LEARNING_PLAN = exports.MENU_TYPE_OPEN_LEARNING_PLAN = exports.MENU_TYPE_LINEAR_LEARNING_PLAN = undefined;
	
	var _componentConstants = __webpack_require__(49);
	
	var componentConstants = _interopRequireWildcard(_componentConstants);
	
	var _objectConstants = __webpack_require__(9);
	
	var objectConstants = _interopRequireWildcard(_objectConstants);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	//MENUS
	
	
	var MENU_TYPE_LINEAR_LEARNING_PLAN = exports.MENU_TYPE_LINEAR_LEARNING_PLAN = {
	    constant: componentConstants.MENU_TYPE_LINEAR_LEARNING_PLAN,
	    component: componentConstants.COMPONENT_LEARNING_PLAN
	};
	
	var MENU_TYPE_OPEN_LEARNING_PLAN = exports.MENU_TYPE_OPEN_LEARNING_PLAN = {
	    constant: componentConstants.MENU_TYPE_OPEN_LEARNING_PLAN,
	    component: componentConstants.COMPONENT_LEARNING_PLAN
	};
	
	var MENU_TYPE_FIRST_ANY_LAST_LEARNING_PLAN = exports.MENU_TYPE_FIRST_ANY_LAST_LEARNING_PLAN = {
	    constant: componentConstants.MENU_TYPE_FIRST_ANY_LAST_LEARNING_PLAN,
	    component: componentConstants.COMPONENT_LEARNING_PLAN
	};
	
	var MENU_TYPE_PERSONAL_LEARNING_PLAN = exports.MENU_TYPE_PERSONAL_LEARNING_PLAN = {
	    constant: componentConstants.MENU_TYPE_PERSONAL_LEARNING_PLAN,
	    component: componentConstants.COMPONENT_LEARNING_PLAN
	};
	
	// EXPORT ARRAY OF ALL BITES
	var MENU_TYPES = exports.MENU_TYPES = [MENU_TYPE_LINEAR_LEARNING_PLAN, MENU_TYPE_OPEN_LEARNING_PLAN, MENU_TYPE_FIRST_ANY_LAST_LEARNING_PLAN, MENU_TYPE_PERSONAL_LEARNING_PLAN];
	
	//BITES
	
	var SCENARIO_BITE = {
	    constant: componentConstants.BITE_TYPE_SCENARIO,
	    component: componentConstants.COMPONENT_SCENARIO_BITE
	};
	
	// EXPORT ARRAY OF ALL BITES
	var BITE_TYPES = exports.BITE_TYPES = [SCENARIO_BITE];
	
	var SCENARIO_SCREEN = {
	    constant: componentConstants.SCREEN_TYPE_SCENARIO,
	    component: componentConstants.COMPONENT_SCENARIO_SCREEN,
	    isAdaptive: false,
	    adaptiveComponentSizes: {
	        lg: {},
	        md: {},
	        sm: {},
	        xs: {}
	    }
	};
	
	var SCROLL_SCREEN = {
	    constant: componentConstants.SCREEN_TYPE_SCROLL,
	    component: componentConstants.COMPONENT_SCROLL_SCREEN,
	    resourcesComponent: componentConstants.COMPONENT_RESOUCES_SCROLL_SCREEN,
	    isAdaptive: false,
	    adaptiveComponentSizes: {
	        lg: {},
	        md: {},
	        sm: {},
	        xs: {}
	    }
	};
	
	var TABBED_SCREEN = {
	    constant: componentConstants.SCREEN_TYPE_TABBED,
	    component: componentConstants.COMPONENT_TABBED_SCREEN,
	    isAdaptive: true,
	    adaptiveComponentSizes: {
	        lg: {},
	        md: {},
	        sm: {
	            portrait: componentConstants.COMPONENT_ACCORDION_SCREEN
	        },
	        xs: {
	            landscape: componentConstants.COMPONENT_ACCORDION_SCREEN,
	            portrait: componentConstants.COMPONENT_ACCORDION_SCREEN
	        }
	    }
	};
	
	var ACCORDION_SCREEN = {
	    constant: componentConstants.SCREEN_TYPE_ACCORDION,
	    component: componentConstants.COMPONENT_ACCORDION_SCREEN,
	    isAdaptive: true,
	    adaptiveComponentSizes: {
	        lg: {},
	        md: {},
	        sm: {},
	        xs: {}
	    }
	};
	
	var TITLE_SCREEN = {
	    constant: componentConstants.SCREEN_TYPE_TITLE,
	    component: componentConstants.COMPONENT_TITLE_SCREEN,
	    isAdaptive: false,
	    adaptiveComponentSizes: {
	        lg: {},
	        md: {},
	        sm: {},
	        xs: {}
	    }
	};
	
	var SLIDER_SCREEN = {
	    constant: componentConstants.SCREEN_TYPE_SLIDER,
	    component: componentConstants.COMPONENT_SLIDER_SCREEN,
	    isAdaptive: false,
	    adaptiveComponentSizes: {
	        lg: {},
	        md: {},
	        sm: {},
	        xs: {}
	    }
	};
	
	var HOTSPOT_SCREEN = {
	    constant: componentConstants.SCREEN_TYPE_HOTSPOT,
	    component: componentConstants.COMPONENT_HOTSPOT_SCREEN,
	    isAdaptive: true,
	    adaptiveComponentSizes: {
	        lg: {},
	        md: {},
	        sm: {
	            portrait: componentConstants.COMPONENT_ACCORDION_SCREEN
	        },
	        xs: {
	            landscape: componentConstants.COMPONENT_ACCORDION_SCREEN,
	            portrait: componentConstants.COMPONENT_ACCORDION_SCREEN
	        }
	    }
	};
	
	var VIDEO_SCREEN = {
	    constant: componentConstants.SCREEN_TYPE_VIDEO,
	    component: componentConstants.COMPONENT_VIDEO_SCREEN,
	    isAdaptive: true,
	    adaptiveComponentSizes: {
	        lg: {},
	        md: {},
	        sm: {},
	        xs: {
	            landscape: componentConstants.COMPONENT_VIDEO_MOBILE_SCREEN,
	            portrait: componentConstants.COMPONENT_VIDEO_MOBILE_SCREEN
	        }
	    }
	};
	
	var SCREEN_TYPES = exports.SCREEN_TYPES = [TITLE_SCREEN, TABBED_SCREEN, SCENARIO_SCREEN, SCROLL_SCREEN, SLIDER_SCREEN, HOTSPOT_SCREEN, VIDEO_SCREEN, ACCORDION_SCREEN];
	
	var TITLE_SCREEN_STANDARD = {
	    constant: componentConstants.SCREEN_SUB_TYPE_TITLE_STANDARD,
	    component: componentConstants.COMPONENT_SCREEN_SUB_TYPE_TITLE_STANDARD,
	    isAdaptive: false,
	    isDefault: true,
	    adaptiveComponentSizes: {
	        lg: {},
	        md: {},
	        sm: {},
	        xs: {}
	    }
	};
	
	var TITLE_SCREEN_STANDARD_IMAGE_BASED = {
	    constant: componentConstants.SCREEN_SUB_TYPE_TITLE_IMAGE_BASED,
	    component: componentConstants.COMPONENT_SCREEN_SUB_TYPE_TITLE_IMAGE_BASED,
	    isAdaptive: false,
	    isDefault: false,
	    adaptiveComponentSizes: {
	        lg: {},
	        md: {},
	        sm: {},
	        xs: {}
	    }
	};
	var TITLE_SCREEN_SUB_TYPES = exports.TITLE_SCREEN_SUB_TYPES = [TITLE_SCREEN_STANDARD, TITLE_SCREEN_STANDARD_IMAGE_BASED];
	
	var CONVERSATION_DIALOG = {
	    constant: componentConstants.CONVERSATION_DIALOG,
	    component: componentConstants.COMPONENT_CONVERSATION_DIALOG
	};
	
	var TEXT = {
	    constant: componentConstants.TEXT,
	    component: componentConstants.COMPONENT_TEXT
	};
	
	var SCORE_INTRODUCTION = {
	    constant: componentConstants.SCORE_INTRODUCTION,
	    component: componentConstants.COMPONENT_SCORE_INTRODUCTION
	};
	
	var KPI_OVERVIEW = {
	    constant: componentConstants.KPI_OVERVIEW,
	    component: componentConstants.COMPONENT_KPI_OVERVIEW
	};
	
	var MULTIPLE_CHOICE = {
	    constant: componentConstants.MULTIPLE_CHOICE,
	    component: componentConstants.COMPONENT_MULTIPLE_CHOICE
	};
	
	var CONVERSATION_CHOICE = {
	    constant: componentConstants.CONVERSATION_CHOICE,
	    component: componentConstants.COMPONENT_CONVERSATION_CHOICE
	};
	
	var GRID_CHOICE = {
	    constant: componentConstants.GRID_CHOICE,
	    component: componentConstants.COMPONENT_GRID_CHOICE
	};
	
	var SWIPE_HORIZONTAL = {
	    constant: componentConstants.SWIPE_HORIZONTAL,
	    component: componentConstants.COMPONENT_SWIPE_HORIZONTAL
	};
	
	var VIDEO = {
	    constant: componentConstants.VIDEO,
	    component: componentConstants.COMPONENT_VIDEO
	};
	
	var LINK = {
	    constant: componentConstants.LINK,
	    component: componentConstants.COMPONENT_LINK
	};
	
	var DOCUMENT = {
	    constant: componentConstants.DOCUMENT,
	    component: componentConstants.COMPONENT_DOCUMENT
	};
	
	var IMAGE = {
	    constant: componentConstants.IMAGE,
	    component: componentConstants.COMPONENT_IMAGE
	};
	
	var LIBRARY_IMAGE = {
	    constant: componentConstants.LIBRARY_IMAGE,
	    component: componentConstants.COMPONENT_LIBRARY_IMAGE
	};
	
	var KPI_GRAPH_RESULTS = {
	    constant: componentConstants.KPI_GRAPH_RESULTS,
	    component: componentConstants.COMPONENT_KPI_GRAPH_RESULTS
	};
	
	var KPI_RESULTS_LIST = {
	    constant: componentConstants.KPI_RESULTS_LIST,
	    component: componentConstants.COMPONENT_KPI_RESULTS_LIST
	};
	
	var THE_END = {
	    constant: componentConstants.THE_END,
	    component: componentConstants.COMPONENT_THE_END
	};
	
	var BADGE_OVERVIEW = {
	    constant: componentConstants.BADGE_OVERVIEW,
	    component: componentConstants.COMPONENT_BADGE_OVERVIEW
	};
	
	var AWARD_BADGE = {
	    constant: componentConstants.AWARD_BADGE,
	    component: componentConstants.COMPONENT_AWARD_BADGE
	};
	
	var VIMEO_VIDEO = {
	    constant: componentConstants.VIMEO_VIDEO,
	    component: componentConstants.COMPONENT_VIMEO_VIDEO
	};
	
	var YOUTUBE_VIDEO = {
	    constant: componentConstants.YOUTUBE_VIDEO,
	    component: componentConstants.COMPONENT_YOUTUBE
	};
	
	var MP4_VIDEO = {
	    constant: componentConstants.MP4_VIDEO,
	    component: componentConstants.COMPONENT_MP4
	};
	
	var SHORT_RESPONSE = {
	    constant: componentConstants.SHORT_RESPONSE,
	    component: componentConstants.COMPONENT_SHORT_RESPONSE
	
	};
	
	var PRINT_RESPONSES = {
	    constant: componentConstants.PRINT_RESPONSES,
	    component: componentConstants.COMPONENT_PRINT_RESPONSES
	
	};
	
	var ASSET_TYPES = exports.ASSET_TYPES = [CONVERSATION_DIALOG, TEXT, SCORE_INTRODUCTION, KPI_OVERVIEW, MULTIPLE_CHOICE, CONVERSATION_CHOICE, GRID_CHOICE, SWIPE_HORIZONTAL, VIDEO, LINK, DOCUMENT, IMAGE, LIBRARY_IMAGE, KPI_GRAPH_RESULTS, KPI_RESULTS_LIST, THE_END, BADGE_OVERVIEW, AWARD_BADGE, VIMEO_VIDEO, YOUTUBE_VIDEO, MP4_VIDEO, SHORT_RESPONSE, PRINT_RESPONSES];
	
	/*CHILD OBJECTS*/
	
	var CHARACTER_SPEAK = {
	    constant: componentConstants.CHARACTER_SPEAK,
	    component: componentConstants.COMPONENT_CHARACTER_SPEAK
	};
	
	var LEARNER_SPEAK = {
	    constant: componentConstants.LEARNER_SPEAK,
	    component: componentConstants.COMPONENT_LEARNER_SPEAK
	};
	
	var NARRATOR_SPEAK = {
	    constant: componentConstants.NARRATOR_SPEAK,
	    component: componentConstants.COMPONENT_NARRATOR_SPEAK
	};
	
	var SINGLE_ANSWER = {
	    constant: componentConstants.SINGLE_ANSWER,
	    component: componentConstants.COMPONENT_SINGLE_ANSWER
	};
	
	var MULTIPLE_ANSWER = {
	    constant: componentConstants.MULTIPLE_ANSWER,
	    component: componentConstants.COMPONENT_MULTIPLE_ANSWER
	};
	
	var CONVERSATION_SINGLE_ANSWER = {
	    constant: componentConstants.CONVERSATION_SINGLE_ANSWER,
	    component: componentConstants.COMPONENT_CONVERSATION_SINGLE_ANSWER
	};
	
	var CONVERSATION_MULTIPLE_ANSWER = {
	    constant: componentConstants.CONVERSATION_MULTIPLE_ANSWER,
	    component: componentConstants.COMPONENT_CONVERSATION_MULTIPLE_ANSWER
	};
	
	var GRID_SINGLE_ANSWER = {
	    constant: componentConstants.GRID_SINGLE_ANSWER,
	    component: componentConstants.COMPONENT_GRID_SINGLE_ANSWER
	};
	
	var VIMEO_SUB_VIDEO = {
	    constant: componentConstants.VIMEO_SUB_VIDEO,
	    component: componentConstants.COMPONENT_SUB_VIMEO_VIDEO
	};
	
	var YOUTUBE_SUB_VIDEO = {
	    constant: componentConstants.YOUTUBE_SUB_VIDEO,
	    component: componentConstants.COMPONENT_SUB_YOUTUBE
	};
	
	var MP4_SUB_VIDEO = {
	    constant: componentConstants.MP4_SUB_VIDEO,
	    component: componentConstants.COMPONENT_SUB_MP4
	};
	
	var CHILD_OBJECTS_TYPES = exports.CHILD_OBJECTS_TYPES = [CHARACTER_SPEAK, LEARNER_SPEAK, NARRATOR_SPEAK, SINGLE_ANSWER, MULTIPLE_ANSWER, CONVERSATION_SINGLE_ANSWER, CONVERSATION_MULTIPLE_ANSWER, GRID_SINGLE_ANSWER, VIMEO_SUB_VIDEO, YOUTUBE_SUB_VIDEO, MP4_SUB_VIDEO];
	
	var RESOURCE_DOCUMENT_LINK = {
	    constant: componentConstants.RESOURCE_DOCUMENT_LINK,
	    component: componentConstants.COMPONENT_RESOURCE_DOCUMENT_LINK
	};
	
	var RESOURCE_IMAGE_LINK = {
	    constant: componentConstants.RESOURCE_IMAGE_LINK,
	    component: componentConstants.COMPONENT_RESOURCE_IMAGE_LINK
	};
	
	var RESOURCE_SCREEN_LINK = {
	    constant: componentConstants.RESOURCE_SCREEN_LINK,
	    component: componentConstants.COMPONENT_RESOURCE_SCREEN_LINK
	};
	
	var RESOURCE_URL_LINK = {
	    constant: componentConstants.RESOURCE_URL_LINK,
	    component: componentConstants.COMPONENT_RESOURCE_URL_LINK
	};
	
	var RESOURCE_VIDEO_LINK = {
	    constant: componentConstants.RESOURCE_VIDEO_LINK,
	    component: componentConstants.COMPONENT_RESOURCE_VIDEO_LINK
	};
	
	var RESOURCE_LINK_TYPES = exports.RESOURCE_LINK_TYPES = [RESOURCE_DOCUMENT_LINK, RESOURCE_IMAGE_LINK, RESOURCE_SCREEN_LINK, RESOURCE_URL_LINK, RESOURCE_VIDEO_LINK];
	
	var ALWAY_SCROLL_AFTER = exports.ALWAY_SCROLL_AFTER = [componentConstants.MULTIPLE_CHOICE, componentConstants.CONVERSATION_CHOICE, componentConstants.GRID_CHOICE, componentConstants.SWIPE_HORIZONTAL, componentConstants.VIDEO, componentConstants.SHORT_RESPONSE];
	
	var CHECK_SCROLL_AFTER = exports.CHECK_SCROLL_AFTER = [componentConstants.CONVERSATION_DIALOG, componentConstants.TEXT, componentConstants.SCORE_INTRODUCTION, componentConstants.KPI_OVERVIEW, componentConstants.LINK, componentConstants.DOCUMENT, componentConstants.IMAGE, componentConstants.LIBRARY_IMAGE, componentConstants.KPI_GRAPH_RESULTS, componentConstants.KPI_RESULTS_LIST, componentConstants.THE_END, componentConstants.BADGE_OVERVIEW, componentConstants.AWARD_BADGE, componentConstants.PRINT_RESPONSES];
	
	var AUTO_NAVIGATE_IF_LAST_ON_INCOMPLETE_SCREEN = exports.AUTO_NAVIGATE_IF_LAST_ON_INCOMPLETE_SCREEN = [componentConstants.MULTIPLE_CHOICE, componentConstants.CONVERSATION_CHOICE, componentConstants.GRID_CHOICE, componentConstants.SWIPE_HORIZONTAL];
	
	/*
	*  CONVERSATION_DIALOG,
	    TEXT,
	    SCORE_INTRODUCTION,
	    KPI_OVERVIEW,
	    MULTIPLE_CHOICE,
	    CONVERSATION_CHOICE,
	    GRID_CHOICE,
	    SWIPE_HORIZONTAL,
	    VIDEO,
	    LINK,
	    DOCUMENT,
	    IMAGE,
	    LIBRARY_IMAGE,
	    KPI_GRAPH_RESULTS,
	    KPI_RESULTS_LIST,
	    THE_END,
	    BADGE_OVERVIEW,
	    AWARD_BADGE
	* */

/***/ },
/* 205 */
/***/ function(module, exports, __webpack_require__) {

	// 22.1.3.6 Array.prototype.fill(value, start = 0, end = this.length)
	'use strict';
	var toObject = __webpack_require__(43);
	var toAbsoluteIndex = __webpack_require__(110);
	var toLength = __webpack_require__(40);
	module.exports = function fill(value /* , start = 0, end = @length */) {
	  var O = toObject(this);
	  var length = toLength(O.length);
	  var aLen = arguments.length;
	  var index = toAbsoluteIndex(aLen > 1 ? arguments[1] : undefined, length);
	  var end = aLen > 2 ? arguments[2] : undefined;
	  var endPos = end === undefined ? length : toAbsoluteIndex(end, length);
	  while (endPos > index) O[index++] = value;
	  return O;
	};


/***/ },
/* 206 */
/***/ function(module, exports, __webpack_require__) {

	// 9.4.2.3 ArraySpeciesCreate(originalArray, length)
	var speciesConstructor = __webpack_require__(591);
	
	module.exports = function (original, length) {
	  return new (speciesConstructor(original))(length);
	};


/***/ },
/* 207 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $defineProperty = __webpack_require__(39);
	var createDesc = __webpack_require__(107);
	
	module.exports = function (object, index, value) {
	  if (index in object) $defineProperty.f(object, index, createDesc(0, value));
	  else object[index] = value;
	};


/***/ },
/* 208 */
/***/ function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(27);
	var document = __webpack_require__(24).document;
	// typeof document.createElement is 'object' in old IE
	var is = isObject(document) && isObject(document.createElement);
	module.exports = function (it) {
	  return is ? document.createElement(it) : {};
	};


/***/ },
/* 209 */
/***/ function(module, exports) {

	// IE 8- don't enum bug keys
	module.exports = (
	  'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'
	).split(',');


/***/ },
/* 210 */
/***/ function(module, exports, __webpack_require__) {

	var MATCH = __webpack_require__(34)('match');
	module.exports = function (KEY) {
	  var re = /./;
	  try {
	    '/./'[KEY](re);
	  } catch (e) {
	    try {
	      re[MATCH] = false;
	      return !'/./'[KEY](re);
	    } catch (f) { /* empty */ }
	  } return true;
	};


/***/ },
/* 211 */
/***/ function(module, exports, __webpack_require__) {

	var document = __webpack_require__(24).document;
	module.exports = document && document.documentElement;


/***/ },
/* 212 */
/***/ function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(27);
	var setPrototypeOf = __webpack_require__(220).set;
	module.exports = function (that, target, C) {
	  var S = target.constructor;
	  var P;
	  if (S !== C && typeof S == 'function' && (P = S.prototype) !== C.prototype && isObject(P) && setPrototypeOf) {
	    setPrototypeOf(that, P);
	  } return that;
	};


/***/ },
/* 213 */
/***/ function(module, exports, __webpack_require__) {

	// check on default Array iterator
	var Iterators = __webpack_require__(116);
	var ITERATOR = __webpack_require__(34)('iterator');
	var ArrayProto = Array.prototype;
	
	module.exports = function (it) {
	  return it !== undefined && (Iterators.Array === it || ArrayProto[ITERATOR] === it);
	};


/***/ },
/* 214 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var create = __webpack_require__(104);
	var descriptor = __webpack_require__(107);
	var setToStringTag = __webpack_require__(117);
	var IteratorPrototype = {};
	
	// 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
	__webpack_require__(52)(IteratorPrototype, __webpack_require__(34)('iterator'), function () { return this; });
	
	module.exports = function (Constructor, NAME, next) {
	  Constructor.prototype = create(IteratorPrototype, { next: descriptor(1, next) });
	  setToStringTag(Constructor, NAME + ' Iterator');
	};


/***/ },
/* 215 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var LIBRARY = __webpack_require__(96);
	var $export = __webpack_require__(6);
	var redefine = __webpack_require__(53);
	var hide = __webpack_require__(52);
	var Iterators = __webpack_require__(116);
	var $iterCreate = __webpack_require__(214);
	var setToStringTag = __webpack_require__(117);
	var getPrototypeOf = __webpack_require__(60);
	var ITERATOR = __webpack_require__(34)('iterator');
	var BUGGY = !([].keys && 'next' in [].keys()); // Safari has buggy iterators w/o `next`
	var FF_ITERATOR = '@@iterator';
	var KEYS = 'keys';
	var VALUES = 'values';
	
	var returnThis = function () { return this; };
	
	module.exports = function (Base, NAME, Constructor, next, DEFAULT, IS_SET, FORCED) {
	  $iterCreate(Constructor, NAME, next);
	  var getMethod = function (kind) {
	    if (!BUGGY && kind in proto) return proto[kind];
	    switch (kind) {
	      case KEYS: return function keys() { return new Constructor(this, kind); };
	      case VALUES: return function values() { return new Constructor(this, kind); };
	    } return function entries() { return new Constructor(this, kind); };
	  };
	  var TAG = NAME + ' Iterator';
	  var DEF_VALUES = DEFAULT == VALUES;
	  var VALUES_BUG = false;
	  var proto = Base.prototype;
	  var $native = proto[ITERATOR] || proto[FF_ITERATOR] || DEFAULT && proto[DEFAULT];
	  var $default = $native || getMethod(DEFAULT);
	  var $entries = DEFAULT ? !DEF_VALUES ? $default : getMethod('entries') : undefined;
	  var $anyNative = NAME == 'Array' ? proto.entries || $native : $native;
	  var methods, key, IteratorPrototype;
	  // Fix native
	  if ($anyNative) {
	    IteratorPrototype = getPrototypeOf($anyNative.call(new Base()));
	    if (IteratorPrototype !== Object.prototype && IteratorPrototype.next) {
	      // Set @@toStringTag to native iterators
	      setToStringTag(IteratorPrototype, TAG, true);
	      // fix for some old engines
	      if (!LIBRARY && typeof IteratorPrototype[ITERATOR] != 'function') hide(IteratorPrototype, ITERATOR, returnThis);
	    }
	  }
	  // fix Array#{values, @@iterator}.name in V8 / FF
	  if (DEF_VALUES && $native && $native.name !== VALUES) {
	    VALUES_BUG = true;
	    $default = function values() { return $native.call(this); };
	  }
	  // Define iterator
	  if ((!LIBRARY || FORCED) && (BUGGY || VALUES_BUG || !proto[ITERATOR])) {
	    hide(proto, ITERATOR, $default);
	  }
	  // Plug for library
	  Iterators[NAME] = $default;
	  Iterators[TAG] = returnThis;
	  if (DEFAULT) {
	    methods = {
	      values: DEF_VALUES ? $default : getMethod(VALUES),
	      keys: IS_SET ? $default : getMethod(KEYS),
	      entries: $entries
	    };
	    if (FORCED) for (key in methods) {
	      if (!(key in proto)) redefine(proto, key, methods[key]);
	    } else $export($export.P + $export.F * (BUGGY || VALUES_BUG), NAME, methods);
	  }
	  return methods;
	};


/***/ },
/* 216 */
/***/ function(module, exports) {

	// 20.2.2.14 Math.expm1(x)
	var $expm1 = Math.expm1;
	module.exports = (!$expm1
	  // Old FF bug
	  || $expm1(10) > 22025.465794806719 || $expm1(10) < 22025.4657948067165168
	  // Tor Browser bug
	  || $expm1(-2e-17) != -2e-17
	) ? function expm1(x) {
	  return (x = +x) == 0 ? x : x > -1e-6 && x < 1e-6 ? x + x * x / 2 : Math.exp(x) - 1;
	} : $expm1;


/***/ },
/* 217 */
/***/ function(module, exports) {

	// 20.2.2.28 Math.sign(x)
	module.exports = Math.sign || function sign(x) {
	  // eslint-disable-next-line no-self-compare
	  return (x = +x) == 0 || x != x ? x : x < 0 ? -1 : 1;
	};


/***/ },
/* 218 */
/***/ function(module, exports, __webpack_require__) {

	var global = __webpack_require__(24);
	var macrotask = __webpack_require__(226).set;
	var Observer = global.MutationObserver || global.WebKitMutationObserver;
	var process = global.process;
	var Promise = global.Promise;
	var isNode = __webpack_require__(69)(process) == 'process';
	
	module.exports = function () {
	  var head, last, notify;
	
	  var flush = function () {
	    var parent, fn;
	    if (isNode && (parent = process.domain)) parent.exit();
	    while (head) {
	      fn = head.fn;
	      head = head.next;
	      try {
	        fn();
	      } catch (e) {
	        if (head) notify();
	        else last = undefined;
	        throw e;
	      }
	    } last = undefined;
	    if (parent) parent.enter();
	  };
	
	  // Node.js
	  if (isNode) {
	    notify = function () {
	      process.nextTick(flush);
	    };
	  // browsers with MutationObserver, except iOS Safari - https://github.com/zloirock/core-js/issues/339
	  } else if (Observer && !(global.navigator && global.navigator.standalone)) {
	    var toggle = true;
	    var node = document.createTextNode('');
	    new Observer(flush).observe(node, { characterData: true }); // eslint-disable-line no-new
	    notify = function () {
	      node.data = toggle = !toggle;
	    };
	  // environments with maybe non-completely correct, but existent Promise
	  } else if (Promise && Promise.resolve) {
	    // Promise.resolve without an argument throws an error in LG WebOS 2
	    var promise = Promise.resolve(undefined);
	    notify = function () {
	      promise.then(flush);
	    };
	  // for other environments - macrotask based on:
	  // - setImmediate
	  // - MessageChannel
	  // - window.postMessag
	  // - onreadystatechange
	  // - setTimeout
	  } else {
	    notify = function () {
	      // strange IE + webpack dev server bug - use .call(global)
	      macrotask.call(global, flush);
	    };
	  }
	
	  return function (fn) {
	    var task = { fn: fn, next: undefined };
	    if (last) last.next = task;
	    if (!head) {
	      head = task;
	      notify();
	    } last = task;
	  };
	};


/***/ },
/* 219 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// 25.4.1.5 NewPromiseCapability(C)
	var aFunction = __webpack_require__(50);
	
	function PromiseCapability(C) {
	  var resolve, reject;
	  this.promise = new C(function ($$resolve, $$reject) {
	    if (resolve !== undefined || reject !== undefined) throw TypeError('Bad Promise constructor');
	    resolve = $$resolve;
	    reject = $$reject;
	  });
	  this.resolve = aFunction(resolve);
	  this.reject = aFunction(reject);
	}
	
	module.exports.f = function (C) {
	  return new PromiseCapability(C);
	};


/***/ },
/* 220 */
/***/ function(module, exports, __webpack_require__) {

	// Works with __proto__ only. Old v8 can't work with null proto objects.
	/* eslint-disable no-proto */
	var isObject = __webpack_require__(27);
	var anObject = __webpack_require__(23);
	var check = function (O, proto) {
	  anObject(O);
	  if (!isObject(proto) && proto !== null) throw TypeError(proto + ": can't set as prototype!");
	};
	module.exports = {
	  set: Object.setPrototypeOf || ('__proto__' in {} ? // eslint-disable-line
	    function (test, buggy, set) {
	      try {
	        set = __webpack_require__(71)(Function.call, __webpack_require__(59).f(Object.prototype, '__proto__').set, 2);
	        set(test, []);
	        buggy = !(test instanceof Array);
	      } catch (e) { buggy = true; }
	      return function setPrototypeOf(O, proto) {
	        check(O, proto);
	        if (buggy) O.__proto__ = proto;
	        else set(O, proto);
	        return O;
	      };
	    }({}, false) : undefined),
	  check: check
	};


/***/ },
/* 221 */
/***/ function(module, exports, __webpack_require__) {

	var shared = __webpack_require__(165)('keys');
	var uid = __webpack_require__(111);
	module.exports = function (key) {
	  return shared[key] || (shared[key] = uid(key));
	};


/***/ },
/* 222 */
/***/ function(module, exports, __webpack_require__) {

	var toInteger = __webpack_require__(78);
	var defined = __webpack_require__(76);
	// true  -> String#at
	// false -> String#codePointAt
	module.exports = function (TO_STRING) {
	  return function (that, pos) {
	    var s = String(defined(that));
	    var i = toInteger(pos);
	    var l = s.length;
	    var a, b;
	    if (i < 0 || i >= l) return TO_STRING ? '' : undefined;
	    a = s.charCodeAt(i);
	    return a < 0xd800 || a > 0xdbff || i + 1 === l || (b = s.charCodeAt(i + 1)) < 0xdc00 || b > 0xdfff
	      ? TO_STRING ? s.charAt(i) : a
	      : TO_STRING ? s.slice(i, i + 2) : (a - 0xd800 << 10) + (b - 0xdc00) + 0x10000;
	  };
	};


/***/ },
/* 223 */
/***/ function(module, exports, __webpack_require__) {

	// helper for String#{startsWith, endsWith, includes}
	var isRegExp = __webpack_require__(159);
	var defined = __webpack_require__(76);
	
	module.exports = function (that, searchString, NAME) {
	  if (isRegExp(searchString)) throw TypeError('String#' + NAME + " doesn't accept regex!");
	  return String(defined(that));
	};


/***/ },
/* 224 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var toInteger = __webpack_require__(78);
	var defined = __webpack_require__(76);
	
	module.exports = function repeat(count) {
	  var str = String(defined(this));
	  var res = '';
	  var n = toInteger(count);
	  if (n < 0 || n == Infinity) throw RangeError("Count can't be negative");
	  for (;n > 0; (n >>>= 1) && (str += str)) if (n & 1) res += str;
	  return res;
	};


/***/ },
/* 225 */
/***/ function(module, exports) {

	module.exports = '\x09\x0A\x0B\x0C\x0D\x20\xA0\u1680\u180E\u2000\u2001\u2002\u2003' +
	  '\u2004\u2005\u2006\u2007\u2008\u2009\u200A\u202F\u205F\u3000\u2028\u2029\uFEFF';


/***/ },
/* 226 */
/***/ function(module, exports, __webpack_require__) {

	var ctx = __webpack_require__(71);
	var invoke = __webpack_require__(301);
	var html = __webpack_require__(211);
	var cel = __webpack_require__(208);
	var global = __webpack_require__(24);
	var process = global.process;
	var setTask = global.setImmediate;
	var clearTask = global.clearImmediate;
	var MessageChannel = global.MessageChannel;
	var Dispatch = global.Dispatch;
	var counter = 0;
	var queue = {};
	var ONREADYSTATECHANGE = 'onreadystatechange';
	var defer, channel, port;
	var run = function () {
	  var id = +this;
	  // eslint-disable-next-line no-prototype-builtins
	  if (queue.hasOwnProperty(id)) {
	    var fn = queue[id];
	    delete queue[id];
	    fn();
	  }
	};
	var listener = function (event) {
	  run.call(event.data);
	};
	// Node.js 0.9+ & IE10+ has setImmediate, otherwise:
	if (!setTask || !clearTask) {
	  setTask = function setImmediate(fn) {
	    var args = [];
	    var i = 1;
	    while (arguments.length > i) args.push(arguments[i++]);
	    queue[++counter] = function () {
	      // eslint-disable-next-line no-new-func
	      invoke(typeof fn == 'function' ? fn : Function(fn), args);
	    };
	    defer(counter);
	    return counter;
	  };
	  clearTask = function clearImmediate(id) {
	    delete queue[id];
	  };
	  // Node.js 0.8-
	  if (__webpack_require__(69)(process) == 'process') {
	    defer = function (id) {
	      process.nextTick(ctx(run, id, 1));
	    };
	  // Sphere (JS game engine) Dispatch API
	  } else if (Dispatch && Dispatch.now) {
	    defer = function (id) {
	      Dispatch.now(ctx(run, id, 1));
	    };
	  // Browsers with MessageChannel, includes WebWorkers
	  } else if (MessageChannel) {
	    channel = new MessageChannel();
	    port = channel.port2;
	    channel.port1.onmessage = listener;
	    defer = ctx(port.postMessage, port, 1);
	  // Browsers with postMessage, skip WebWorkers
	  // IE8 has postMessage, but it's sync & typeof its postMessage is 'object'
	  } else if (global.addEventListener && typeof postMessage == 'function' && !global.importScripts) {
	    defer = function (id) {
	      global.postMessage(id + '', '*');
	    };
	    global.addEventListener('message', listener, false);
	  // IE8-
	  } else if (ONREADYSTATECHANGE in cel('script')) {
	    defer = function (id) {
	      html.appendChild(cel('script'))[ONREADYSTATECHANGE] = function () {
	        html.removeChild(this);
	        run.call(id);
	      };
	    };
	  // Rest old browsers
	  } else {
	    defer = function (id) {
	      setTimeout(ctx(run, id, 1), 0);
	    };
	  }
	}
	module.exports = {
	  set: setTask,
	  clear: clearTask
	};


/***/ },
/* 227 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var global = __webpack_require__(24);
	var DESCRIPTORS = __webpack_require__(38);
	var LIBRARY = __webpack_require__(96);
	var $typed = __webpack_require__(167);
	var hide = __webpack_require__(52);
	var redefineAll = __webpack_require__(108);
	var fails = __webpack_require__(26);
	var anInstance = __webpack_require__(102);
	var toInteger = __webpack_require__(78);
	var toLength = __webpack_require__(40);
	var toIndex = __webpack_require__(319);
	var gOPN = __webpack_require__(105).f;
	var dP = __webpack_require__(39).f;
	var arrayFill = __webpack_require__(205);
	var setToStringTag = __webpack_require__(117);
	var ARRAY_BUFFER = 'ArrayBuffer';
	var DATA_VIEW = 'DataView';
	var PROTOTYPE = 'prototype';
	var WRONG_LENGTH = 'Wrong length!';
	var WRONG_INDEX = 'Wrong index!';
	var $ArrayBuffer = global[ARRAY_BUFFER];
	var $DataView = global[DATA_VIEW];
	var Math = global.Math;
	var RangeError = global.RangeError;
	// eslint-disable-next-line no-shadow-restricted-names
	var Infinity = global.Infinity;
	var BaseBuffer = $ArrayBuffer;
	var abs = Math.abs;
	var pow = Math.pow;
	var floor = Math.floor;
	var log = Math.log;
	var LN2 = Math.LN2;
	var BUFFER = 'buffer';
	var BYTE_LENGTH = 'byteLength';
	var BYTE_OFFSET = 'byteOffset';
	var $BUFFER = DESCRIPTORS ? '_b' : BUFFER;
	var $LENGTH = DESCRIPTORS ? '_l' : BYTE_LENGTH;
	var $OFFSET = DESCRIPTORS ? '_o' : BYTE_OFFSET;
	
	// IEEE754 conversions based on https://github.com/feross/ieee754
	function packIEEE754(value, mLen, nBytes) {
	  var buffer = new Array(nBytes);
	  var eLen = nBytes * 8 - mLen - 1;
	  var eMax = (1 << eLen) - 1;
	  var eBias = eMax >> 1;
	  var rt = mLen === 23 ? pow(2, -24) - pow(2, -77) : 0;
	  var i = 0;
	  var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
	  var e, m, c;
	  value = abs(value);
	  // eslint-disable-next-line no-self-compare
	  if (value != value || value === Infinity) {
	    // eslint-disable-next-line no-self-compare
	    m = value != value ? 1 : 0;
	    e = eMax;
	  } else {
	    e = floor(log(value) / LN2);
	    if (value * (c = pow(2, -e)) < 1) {
	      e--;
	      c *= 2;
	    }
	    if (e + eBias >= 1) {
	      value += rt / c;
	    } else {
	      value += rt * pow(2, 1 - eBias);
	    }
	    if (value * c >= 2) {
	      e++;
	      c /= 2;
	    }
	    if (e + eBias >= eMax) {
	      m = 0;
	      e = eMax;
	    } else if (e + eBias >= 1) {
	      m = (value * c - 1) * pow(2, mLen);
	      e = e + eBias;
	    } else {
	      m = value * pow(2, eBias - 1) * pow(2, mLen);
	      e = 0;
	    }
	  }
	  for (; mLen >= 8; buffer[i++] = m & 255, m /= 256, mLen -= 8);
	  e = e << mLen | m;
	  eLen += mLen;
	  for (; eLen > 0; buffer[i++] = e & 255, e /= 256, eLen -= 8);
	  buffer[--i] |= s * 128;
	  return buffer;
	}
	function unpackIEEE754(buffer, mLen, nBytes) {
	  var eLen = nBytes * 8 - mLen - 1;
	  var eMax = (1 << eLen) - 1;
	  var eBias = eMax >> 1;
	  var nBits = eLen - 7;
	  var i = nBytes - 1;
	  var s = buffer[i--];
	  var e = s & 127;
	  var m;
	  s >>= 7;
	  for (; nBits > 0; e = e * 256 + buffer[i], i--, nBits -= 8);
	  m = e & (1 << -nBits) - 1;
	  e >>= -nBits;
	  nBits += mLen;
	  for (; nBits > 0; m = m * 256 + buffer[i], i--, nBits -= 8);
	  if (e === 0) {
	    e = 1 - eBias;
	  } else if (e === eMax) {
	    return m ? NaN : s ? -Infinity : Infinity;
	  } else {
	    m = m + pow(2, mLen);
	    e = e - eBias;
	  } return (s ? -1 : 1) * m * pow(2, e - mLen);
	}
	
	function unpackI32(bytes) {
	  return bytes[3] << 24 | bytes[2] << 16 | bytes[1] << 8 | bytes[0];
	}
	function packI8(it) {
	  return [it & 0xff];
	}
	function packI16(it) {
	  return [it & 0xff, it >> 8 & 0xff];
	}
	function packI32(it) {
	  return [it & 0xff, it >> 8 & 0xff, it >> 16 & 0xff, it >> 24 & 0xff];
	}
	function packF64(it) {
	  return packIEEE754(it, 52, 8);
	}
	function packF32(it) {
	  return packIEEE754(it, 23, 4);
	}
	
	function addGetter(C, key, internal) {
	  dP(C[PROTOTYPE], key, { get: function () { return this[internal]; } });
	}
	
	function get(view, bytes, index, isLittleEndian) {
	  var numIndex = +index;
	  var intIndex = toIndex(numIndex);
	  if (intIndex + bytes > view[$LENGTH]) throw RangeError(WRONG_INDEX);
	  var store = view[$BUFFER]._b;
	  var start = intIndex + view[$OFFSET];
	  var pack = store.slice(start, start + bytes);
	  return isLittleEndian ? pack : pack.reverse();
	}
	function set(view, bytes, index, conversion, value, isLittleEndian) {
	  var numIndex = +index;
	  var intIndex = toIndex(numIndex);
	  if (intIndex + bytes > view[$LENGTH]) throw RangeError(WRONG_INDEX);
	  var store = view[$BUFFER]._b;
	  var start = intIndex + view[$OFFSET];
	  var pack = conversion(+value);
	  for (var i = 0; i < bytes; i++) store[start + i] = pack[isLittleEndian ? i : bytes - i - 1];
	}
	
	if (!$typed.ABV) {
	  $ArrayBuffer = function ArrayBuffer(length) {
	    anInstance(this, $ArrayBuffer, ARRAY_BUFFER);
	    var byteLength = toIndex(length);
	    this._b = arrayFill.call(new Array(byteLength), 0);
	    this[$LENGTH] = byteLength;
	  };
	
	  $DataView = function DataView(buffer, byteOffset, byteLength) {
	    anInstance(this, $DataView, DATA_VIEW);
	    anInstance(buffer, $ArrayBuffer, DATA_VIEW);
	    var bufferLength = buffer[$LENGTH];
	    var offset = toInteger(byteOffset);
	    if (offset < 0 || offset > bufferLength) throw RangeError('Wrong offset!');
	    byteLength = byteLength === undefined ? bufferLength - offset : toLength(byteLength);
	    if (offset + byteLength > bufferLength) throw RangeError(WRONG_LENGTH);
	    this[$BUFFER] = buffer;
	    this[$OFFSET] = offset;
	    this[$LENGTH] = byteLength;
	  };
	
	  if (DESCRIPTORS) {
	    addGetter($ArrayBuffer, BYTE_LENGTH, '_l');
	    addGetter($DataView, BUFFER, '_b');
	    addGetter($DataView, BYTE_LENGTH, '_l');
	    addGetter($DataView, BYTE_OFFSET, '_o');
	  }
	
	  redefineAll($DataView[PROTOTYPE], {
	    getInt8: function getInt8(byteOffset) {
	      return get(this, 1, byteOffset)[0] << 24 >> 24;
	    },
	    getUint8: function getUint8(byteOffset) {
	      return get(this, 1, byteOffset)[0];
	    },
	    getInt16: function getInt16(byteOffset /* , littleEndian */) {
	      var bytes = get(this, 2, byteOffset, arguments[1]);
	      return (bytes[1] << 8 | bytes[0]) << 16 >> 16;
	    },
	    getUint16: function getUint16(byteOffset /* , littleEndian */) {
	      var bytes = get(this, 2, byteOffset, arguments[1]);
	      return bytes[1] << 8 | bytes[0];
	    },
	    getInt32: function getInt32(byteOffset /* , littleEndian */) {
	      return unpackI32(get(this, 4, byteOffset, arguments[1]));
	    },
	    getUint32: function getUint32(byteOffset /* , littleEndian */) {
	      return unpackI32(get(this, 4, byteOffset, arguments[1])) >>> 0;
	    },
	    getFloat32: function getFloat32(byteOffset /* , littleEndian */) {
	      return unpackIEEE754(get(this, 4, byteOffset, arguments[1]), 23, 4);
	    },
	    getFloat64: function getFloat64(byteOffset /* , littleEndian */) {
	      return unpackIEEE754(get(this, 8, byteOffset, arguments[1]), 52, 8);
	    },
	    setInt8: function setInt8(byteOffset, value) {
	      set(this, 1, byteOffset, packI8, value);
	    },
	    setUint8: function setUint8(byteOffset, value) {
	      set(this, 1, byteOffset, packI8, value);
	    },
	    setInt16: function setInt16(byteOffset, value /* , littleEndian */) {
	      set(this, 2, byteOffset, packI16, value, arguments[2]);
	    },
	    setUint16: function setUint16(byteOffset, value /* , littleEndian */) {
	      set(this, 2, byteOffset, packI16, value, arguments[2]);
	    },
	    setInt32: function setInt32(byteOffset, value /* , littleEndian */) {
	      set(this, 4, byteOffset, packI32, value, arguments[2]);
	    },
	    setUint32: function setUint32(byteOffset, value /* , littleEndian */) {
	      set(this, 4, byteOffset, packI32, value, arguments[2]);
	    },
	    setFloat32: function setFloat32(byteOffset, value /* , littleEndian */) {
	      set(this, 4, byteOffset, packF32, value, arguments[2]);
	    },
	    setFloat64: function setFloat64(byteOffset, value /* , littleEndian */) {
	      set(this, 8, byteOffset, packF64, value, arguments[2]);
	    }
	  });
	} else {
	  if (!fails(function () {
	    $ArrayBuffer(1);
	  }) || !fails(function () {
	    new $ArrayBuffer(-1); // eslint-disable-line no-new
	  }) || fails(function () {
	    new $ArrayBuffer(); // eslint-disable-line no-new
	    new $ArrayBuffer(1.5); // eslint-disable-line no-new
	    new $ArrayBuffer(NaN); // eslint-disable-line no-new
	    return $ArrayBuffer.name != ARRAY_BUFFER;
	  })) {
	    $ArrayBuffer = function ArrayBuffer(length) {
	      anInstance(this, $ArrayBuffer);
	      return new BaseBuffer(toIndex(length));
	    };
	    var ArrayBufferProto = $ArrayBuffer[PROTOTYPE] = BaseBuffer[PROTOTYPE];
	    for (var keys = gOPN(BaseBuffer), j = 0, key; keys.length > j;) {
	      if (!((key = keys[j++]) in $ArrayBuffer)) hide($ArrayBuffer, key, BaseBuffer[key]);
	    }
	    if (!LIBRARY) ArrayBufferProto.constructor = $ArrayBuffer;
	  }
	  // iOS Safari 7.x bug
	  var view = new $DataView(new $ArrayBuffer(2));
	  var $setInt8 = $DataView[PROTOTYPE].setInt8;
	  view.setInt8(0, 2147483648);
	  view.setInt8(1, 2147483649);
	  if (view.getInt8(0) || !view.getInt8(1)) redefineAll($DataView[PROTOTYPE], {
	    setInt8: function setInt8(byteOffset, value) {
	      $setInt8.call(this, byteOffset, value << 24 >> 24);
	    },
	    setUint8: function setUint8(byteOffset, value) {
	      $setInt8.call(this, byteOffset, value << 24 >> 24);
	    }
	  }, true);
	}
	setToStringTag($ArrayBuffer, ARRAY_BUFFER);
	setToStringTag($DataView, DATA_VIEW);
	hide($DataView[PROTOTYPE], $typed.VIEW, true);
	exports[ARRAY_BUFFER] = $ArrayBuffer;
	exports[DATA_VIEW] = $DataView;


/***/ },
/* 228 */
/***/ function(module, exports, __webpack_require__) {

	var global = __webpack_require__(24);
	var core = __webpack_require__(70);
	var LIBRARY = __webpack_require__(96);
	var wksExt = __webpack_require__(320);
	var defineProperty = __webpack_require__(39).f;
	module.exports = function (name) {
	  var $Symbol = core.Symbol || (core.Symbol = LIBRARY ? {} : global.Symbol || {});
	  if (name.charAt(0) != '_' && !(name in $Symbol)) defineProperty($Symbol, name, { value: wksExt.f(name) });
	};


/***/ },
/* 229 */
/***/ function(module, exports, __webpack_require__) {

	var classof = __webpack_require__(138);
	var ITERATOR = __webpack_require__(34)('iterator');
	var Iterators = __webpack_require__(116);
	module.exports = __webpack_require__(70).getIteratorMethod = function (it) {
	  if (it != undefined) return it[ITERATOR]
	    || it['@@iterator']
	    || Iterators[classof(it)];
	};


/***/ },
/* 230 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var addToUnscopables = __webpack_require__(95);
	var step = __webpack_require__(304);
	var Iterators = __webpack_require__(116);
	var toIObject = __webpack_require__(61);
	
	// 22.1.3.4 Array.prototype.entries()
	// 22.1.3.13 Array.prototype.keys()
	// 22.1.3.29 Array.prototype.values()
	// 22.1.3.30 Array.prototype[@@iterator]()
	module.exports = __webpack_require__(215)(Array, 'Array', function (iterated, kind) {
	  this._t = toIObject(iterated); // target
	  this._i = 0;                   // next index
	  this._k = kind;                // kind
	// 22.1.5.2.1 %ArrayIteratorPrototype%.next()
	}, function () {
	  var O = this._t;
	  var kind = this._k;
	  var index = this._i++;
	  if (!O || index >= O.length) {
	    this._t = undefined;
	    return step(1);
	  }
	  if (kind == 'keys') return step(0, index);
	  if (kind == 'values') return step(0, O[index]);
	  return step(0, [index, O[index]]);
	}, 'values');
	
	// argumentsList[@@iterator] is %ArrayProto_values% (9.4.4.6, 9.4.4.7)
	Iterators.Arguments = Iterators.Array;
	
	addToUnscopables('keys');
	addToUnscopables('values');
	addToUnscopables('entries');


/***/ },
/* 231 */
/***/ function(module, exports, __webpack_require__) {

	;(function (root, factory) {
		if (true) {
			// CommonJS
			module.exports = exports = factory(__webpack_require__(25));
		}
		else if (typeof define === "function" && define.amd) {
			// AMD
			define(["./core"], factory);
		}
		else {
			// Global (browser)
			factory(root.CryptoJS);
		}
	}(this, function (CryptoJS) {
	
		(function () {
		    // Shortcuts
		    var C = CryptoJS;
		    var C_lib = C.lib;
		    var Base = C_lib.Base;
		    var C_enc = C.enc;
		    var Utf8 = C_enc.Utf8;
		    var C_algo = C.algo;
	
		    /**
		     * HMAC algorithm.
		     */
		    var HMAC = C_algo.HMAC = Base.extend({
		        /**
		         * Initializes a newly created HMAC.
		         *
		         * @param {Hasher} hasher The hash algorithm to use.
		         * @param {WordArray|string} key The secret key.
		         *
		         * @example
		         *
		         *     var hmacHasher = CryptoJS.algo.HMAC.create(CryptoJS.algo.SHA256, key);
		         */
		        init: function (hasher, key) {
		            // Init hasher
		            hasher = this._hasher = new hasher.init();
	
		            // Convert string to WordArray, else assume WordArray already
		            if (typeof key == 'string') {
		                key = Utf8.parse(key);
		            }
	
		            // Shortcuts
		            var hasherBlockSize = hasher.blockSize;
		            var hasherBlockSizeBytes = hasherBlockSize * 4;
	
		            // Allow arbitrary length keys
		            if (key.sigBytes > hasherBlockSizeBytes) {
		                key = hasher.finalize(key);
		            }
	
		            // Clamp excess bits
		            key.clamp();
	
		            // Clone key for inner and outer pads
		            var oKey = this._oKey = key.clone();
		            var iKey = this._iKey = key.clone();
	
		            // Shortcuts
		            var oKeyWords = oKey.words;
		            var iKeyWords = iKey.words;
	
		            // XOR keys with pad constants
		            for (var i = 0; i < hasherBlockSize; i++) {
		                oKeyWords[i] ^= 0x5c5c5c5c;
		                iKeyWords[i] ^= 0x36363636;
		            }
		            oKey.sigBytes = iKey.sigBytes = hasherBlockSizeBytes;
	
		            // Set initial values
		            this.reset();
		        },
	
		        /**
		         * Resets this HMAC to its initial state.
		         *
		         * @example
		         *
		         *     hmacHasher.reset();
		         */
		        reset: function () {
		            // Shortcut
		            var hasher = this._hasher;
	
		            // Reset
		            hasher.reset();
		            hasher.update(this._iKey);
		        },
	
		        /**
		         * Updates this HMAC with a message.
		         *
		         * @param {WordArray|string} messageUpdate The message to append.
		         *
		         * @return {HMAC} This HMAC instance.
		         *
		         * @example
		         *
		         *     hmacHasher.update('message');
		         *     hmacHasher.update(wordArray);
		         */
		        update: function (messageUpdate) {
		            this._hasher.update(messageUpdate);
	
		            // Chainable
		            return this;
		        },
	
		        /**
		         * Finalizes the HMAC computation.
		         * Note that the finalize operation is effectively a destructive, read-once operation.
		         *
		         * @param {WordArray|string} messageUpdate (Optional) A final message update.
		         *
		         * @return {WordArray} The HMAC.
		         *
		         * @example
		         *
		         *     var hmac = hmacHasher.finalize();
		         *     var hmac = hmacHasher.finalize('message');
		         *     var hmac = hmacHasher.finalize(wordArray);
		         */
		        finalize: function (messageUpdate) {
		            // Shortcut
		            var hasher = this._hasher;
	
		            // Compute HMAC
		            var innerHash = hasher.finalize(messageUpdate);
		            hasher.reset();
		            var hmac = hasher.finalize(this._oKey.clone().concat(innerHash));
	
		            return hmac;
		        }
		    });
		}());
	
	
	}));

/***/ },
/* 232 */
/***/ function(module, exports, __webpack_require__) {

	;(function (root, factory) {
		if (true) {
			// CommonJS
			module.exports = exports = factory(__webpack_require__(25));
		}
		else if (typeof define === "function" && define.amd) {
			// AMD
			define(["./core"], factory);
		}
		else {
			// Global (browser)
			factory(root.CryptoJS);
		}
	}(this, function (CryptoJS) {
	
		(function () {
		    // Shortcuts
		    var C = CryptoJS;
		    var C_lib = C.lib;
		    var WordArray = C_lib.WordArray;
		    var Hasher = C_lib.Hasher;
		    var C_algo = C.algo;
	
		    // Reusable object
		    var W = [];
	
		    /**
		     * SHA-1 hash algorithm.
		     */
		    var SHA1 = C_algo.SHA1 = Hasher.extend({
		        _doReset: function () {
		            this._hash = new WordArray.init([
		                0x67452301, 0xefcdab89,
		                0x98badcfe, 0x10325476,
		                0xc3d2e1f0
		            ]);
		        },
	
		        _doProcessBlock: function (M, offset) {
		            // Shortcut
		            var H = this._hash.words;
	
		            // Working variables
		            var a = H[0];
		            var b = H[1];
		            var c = H[2];
		            var d = H[3];
		            var e = H[4];
	
		            // Computation
		            for (var i = 0; i < 80; i++) {
		                if (i < 16) {
		                    W[i] = M[offset + i] | 0;
		                } else {
		                    var n = W[i - 3] ^ W[i - 8] ^ W[i - 14] ^ W[i - 16];
		                    W[i] = (n << 1) | (n >>> 31);
		                }
	
		                var t = ((a << 5) | (a >>> 27)) + e + W[i];
		                if (i < 20) {
		                    t += ((b & c) | (~b & d)) + 0x5a827999;
		                } else if (i < 40) {
		                    t += (b ^ c ^ d) + 0x6ed9eba1;
		                } else if (i < 60) {
		                    t += ((b & c) | (b & d) | (c & d)) - 0x70e44324;
		                } else /* if (i < 80) */ {
		                    t += (b ^ c ^ d) - 0x359d3e2a;
		                }
	
		                e = d;
		                d = c;
		                c = (b << 30) | (b >>> 2);
		                b = a;
		                a = t;
		            }
	
		            // Intermediate hash value
		            H[0] = (H[0] + a) | 0;
		            H[1] = (H[1] + b) | 0;
		            H[2] = (H[2] + c) | 0;
		            H[3] = (H[3] + d) | 0;
		            H[4] = (H[4] + e) | 0;
		        },
	
		        _doFinalize: function () {
		            // Shortcuts
		            var data = this._data;
		            var dataWords = data.words;
	
		            var nBitsTotal = this._nDataBytes * 8;
		            var nBitsLeft = data.sigBytes * 8;
	
		            // Add padding
		            dataWords[nBitsLeft >>> 5] |= 0x80 << (24 - nBitsLeft % 32);
		            dataWords[(((nBitsLeft + 64) >>> 9) << 4) + 14] = Math.floor(nBitsTotal / 0x100000000);
		            dataWords[(((nBitsLeft + 64) >>> 9) << 4) + 15] = nBitsTotal;
		            data.sigBytes = dataWords.length * 4;
	
		            // Hash final blocks
		            this._process();
	
		            // Return final computed hash
		            return this._hash;
		        },
	
		        clone: function () {
		            var clone = Hasher.clone.call(this);
		            clone._hash = this._hash.clone();
	
		            return clone;
		        }
		    });
	
		    /**
		     * Shortcut function to the hasher's object interface.
		     *
		     * @param {WordArray|string} message The message to hash.
		     *
		     * @return {WordArray} The hash.
		     *
		     * @static
		     *
		     * @example
		     *
		     *     var hash = CryptoJS.SHA1('message');
		     *     var hash = CryptoJS.SHA1(wordArray);
		     */
		    C.SHA1 = Hasher._createHelper(SHA1);
	
		    /**
		     * Shortcut function to the HMAC's object interface.
		     *
		     * @param {WordArray|string} message The message to hash.
		     * @param {WordArray|string} key The secret key.
		     *
		     * @return {WordArray} The HMAC.
		     *
		     * @static
		     *
		     * @example
		     *
		     *     var hmac = CryptoJS.HmacSHA1(message, key);
		     */
		    C.HmacSHA1 = Hasher._createHmacHelper(SHA1);
		}());
	
	
		return CryptoJS.SHA1;
	
	}));

/***/ },
/* 233 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 * 
	 */
	
	/*eslint-disable no-self-compare */
	
	'use strict';
	
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	
	/**
	 * inlined Object.is polyfill to avoid requiring consumers ship their own
	 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
	 */
	function is(x, y) {
	  // SameValue algorithm
	  if (x === y) {
	    // Steps 1-5, 7-10
	    // Steps 6.b-6.e: +0 != -0
	    // Added the nonzero y check to make Flow happy, but it is redundant
	    return x !== 0 || y !== 0 || 1 / x === 1 / y;
	  } else {
	    // Step 6.a: NaN == NaN
	    return x !== x && y !== y;
	  }
	}
	
	/**
	 * Performs equality by iterating through keys on an object and returning false
	 * when any key has values which are not strictly equal between the arguments.
	 * Returns true when the values of all keys are strictly equal.
	 */
	function shallowEqual(objA, objB) {
	  if (is(objA, objB)) {
	    return true;
	  }
	
	  if (typeof objA !== 'object' || objA === null || typeof objB !== 'object' || objB === null) {
	    return false;
	  }
	
	  var keysA = Object.keys(objA);
	  var keysB = Object.keys(objB);
	
	  if (keysA.length !== keysB.length) {
	    return false;
	  }
	
	  // Test for A's keys different from B.
	  for (var i = 0; i < keysA.length; i++) {
	    if (!hasOwnProperty.call(objB, keysA[i]) || !is(objA[keysA[i]], objB[keysA[i]])) {
	      return false;
	    }
	  }
	
	  return true;
	}
	
	module.exports = shallowEqual;

/***/ },
/* 234 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.go = exports.replaceLocation = exports.pushLocation = exports.startListener = exports.getUserConfirmation = exports.getCurrentLocation = undefined;
	
	var _LocationUtils = __webpack_require__(123);
	
	var _DOMUtils = __webpack_require__(173);
	
	var _DOMStateStorage = __webpack_require__(352);
	
	var _PathUtils = __webpack_require__(98);
	
	var _ExecutionEnvironment = __webpack_require__(235);
	
	var PopStateEvent = 'popstate';
	var HashChangeEvent = 'hashchange';
	
	var needsHashchangeListener = _ExecutionEnvironment.canUseDOM && !(0, _DOMUtils.supportsPopstateOnHashchange)();
	
	var _createLocation = function _createLocation(historyState) {
	  var key = historyState && historyState.key;
	
	  return (0, _LocationUtils.createLocation)({
	    pathname: window.location.pathname,
	    search: window.location.search,
	    hash: window.location.hash,
	    state: key ? (0, _DOMStateStorage.readState)(key) : undefined
	  }, undefined, key);
	};
	
	var getCurrentLocation = exports.getCurrentLocation = function getCurrentLocation() {
	  var historyState = void 0;
	  try {
	    historyState = window.history.state || {};
	  } catch (error) {
	    // IE 11 sometimes throws when accessing window.history.state
	    // See https://github.com/ReactTraining/history/pull/289
	    historyState = {};
	  }
	
	  return _createLocation(historyState);
	};
	
	var getUserConfirmation = exports.getUserConfirmation = function getUserConfirmation(message, callback) {
	  return callback(window.confirm(message));
	}; // eslint-disable-line no-alert
	
	var startListener = exports.startListener = function startListener(listener) {
	  var handlePopState = function handlePopState(event) {
	    if ((0, _DOMUtils.isExtraneousPopstateEvent)(event)) // Ignore extraneous popstate events in WebKit
	      return;
	    listener(_createLocation(event.state));
	  };
	
	  (0, _DOMUtils.addEventListener)(window, PopStateEvent, handlePopState);
	
	  var handleUnpoppedHashChange = function handleUnpoppedHashChange() {
	    return listener(getCurrentLocation());
	  };
	
	  if (needsHashchangeListener) {
	    (0, _DOMUtils.addEventListener)(window, HashChangeEvent, handleUnpoppedHashChange);
	  }
	
	  return function () {
	    (0, _DOMUtils.removeEventListener)(window, PopStateEvent, handlePopState);
	
	    if (needsHashchangeListener) {
	      (0, _DOMUtils.removeEventListener)(window, HashChangeEvent, handleUnpoppedHashChange);
	    }
	  };
	};
	
	var updateLocation = function updateLocation(location, updateState) {
	  var state = location.state,
	      key = location.key;
	
	
	  if (state !== undefined) (0, _DOMStateStorage.saveState)(key, state);
	
	  updateState({ key: key }, (0, _PathUtils.createPath)(location));
	};
	
	var pushLocation = exports.pushLocation = function pushLocation(location) {
	  return updateLocation(location, function (state, path) {
	    return window.history.pushState(state, null, path);
	  });
	};
	
	var replaceLocation = exports.replaceLocation = function replaceLocation(location) {
	  return updateLocation(location, function (state, path) {
	    return window.history.replaceState(state, null, path);
	  });
	};
	
	var go = exports.go = function go(n) {
	  if (n) window.history.go(n);
	};

/***/ },
/* 235 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	var canUseDOM = exports.canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);

/***/ },
/* 236 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _AsyncUtils = __webpack_require__(837);
	
	var _PathUtils = __webpack_require__(98);
	
	var _runTransitionHook = __webpack_require__(237);
	
	var _runTransitionHook2 = _interopRequireDefault(_runTransitionHook);
	
	var _Actions = __webpack_require__(172);
	
	var _LocationUtils = __webpack_require__(123);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var createHistory = function createHistory() {
	  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	  var getCurrentLocation = options.getCurrentLocation,
	      getUserConfirmation = options.getUserConfirmation,
	      pushLocation = options.pushLocation,
	      replaceLocation = options.replaceLocation,
	      go = options.go,
	      keyLength = options.keyLength;
	
	
	  var currentLocation = void 0;
	  var pendingLocation = void 0;
	  var beforeListeners = [];
	  var listeners = [];
	  var allKeys = [];
	
	  var getCurrentIndex = function getCurrentIndex() {
	    if (pendingLocation && pendingLocation.action === _Actions.POP) return allKeys.indexOf(pendingLocation.key);
	
	    if (currentLocation) return allKeys.indexOf(currentLocation.key);
	
	    return -1;
	  };
	
	  var updateLocation = function updateLocation(nextLocation) {
	    var currentIndex = getCurrentIndex();
	
	    currentLocation = nextLocation;
	
	    if (currentLocation.action === _Actions.PUSH) {
	      allKeys = [].concat(allKeys.slice(0, currentIndex + 1), [currentLocation.key]);
	    } else if (currentLocation.action === _Actions.REPLACE) {
	      allKeys[currentIndex] = currentLocation.key;
	    }
	
	    listeners.forEach(function (listener) {
	      return listener(currentLocation);
	    });
	  };
	
	  var listenBefore = function listenBefore(listener) {
	    beforeListeners.push(listener);
	
	    return function () {
	      return beforeListeners = beforeListeners.filter(function (item) {
	        return item !== listener;
	      });
	    };
	  };
	
	  var listen = function listen(listener) {
	    listeners.push(listener);
	
	    return function () {
	      return listeners = listeners.filter(function (item) {
	        return item !== listener;
	      });
	    };
	  };
	
	  var confirmTransitionTo = function confirmTransitionTo(location, callback) {
	    (0, _AsyncUtils.loopAsync)(beforeListeners.length, function (index, next, done) {
	      (0, _runTransitionHook2.default)(beforeListeners[index], location, function (result) {
	        return result != null ? done(result) : next();
	      });
	    }, function (message) {
	      if (getUserConfirmation && typeof message === 'string') {
	        getUserConfirmation(message, function (ok) {
	          return callback(ok !== false);
	        });
	      } else {
	        callback(message !== false);
	      }
	    });
	  };
	
	  var transitionTo = function transitionTo(nextLocation) {
	    if (currentLocation && (0, _LocationUtils.locationsAreEqual)(currentLocation, nextLocation) || pendingLocation && (0, _LocationUtils.locationsAreEqual)(pendingLocation, nextLocation)) return; // Nothing to do
	
	    pendingLocation = nextLocation;
	
	    confirmTransitionTo(nextLocation, function (ok) {
	      if (pendingLocation !== nextLocation) return; // Transition was interrupted during confirmation
	
	      pendingLocation = null;
	
	      if (ok) {
	        // Treat PUSH to same path like REPLACE to be consistent with browsers
	        if (nextLocation.action === _Actions.PUSH) {
	          var prevPath = (0, _PathUtils.createPath)(currentLocation);
	          var nextPath = (0, _PathUtils.createPath)(nextLocation);
	
	          if (nextPath === prevPath && (0, _LocationUtils.statesAreEqual)(currentLocation.state, nextLocation.state)) nextLocation.action = _Actions.REPLACE;
	        }
	
	        if (nextLocation.action === _Actions.POP) {
	          updateLocation(nextLocation);
	        } else if (nextLocation.action === _Actions.PUSH) {
	          if (pushLocation(nextLocation) !== false) updateLocation(nextLocation);
	        } else if (nextLocation.action === _Actions.REPLACE) {
	          if (replaceLocation(nextLocation) !== false) updateLocation(nextLocation);
	        }
	      } else if (currentLocation && nextLocation.action === _Actions.POP) {
	        var prevIndex = allKeys.indexOf(currentLocation.key);
	        var nextIndex = allKeys.indexOf(nextLocation.key);
	
	        if (prevIndex !== -1 && nextIndex !== -1) go(prevIndex - nextIndex); // Restore the URL
	      }
	    });
	  };
	
	  var push = function push(input) {
	    return transitionTo(createLocation(input, _Actions.PUSH));
	  };
	
	  var replace = function replace(input) {
	    return transitionTo(createLocation(input, _Actions.REPLACE));
	  };
	
	  var goBack = function goBack() {
	    return go(-1);
	  };
	
	  var goForward = function goForward() {
	    return go(1);
	  };
	
	  var createKey = function createKey() {
	    return Math.random().toString(36).substr(2, keyLength || 6);
	  };
	
	  var createHref = function createHref(location) {
	    return (0, _PathUtils.createPath)(location);
	  };
	
	  var createLocation = function createLocation(location, action) {
	    var key = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : createKey();
	    return (0, _LocationUtils.createLocation)(location, action, key);
	  };
	
	  return {
	    getCurrentLocation: getCurrentLocation,
	    listenBefore: listenBefore,
	    listen: listen,
	    transitionTo: transitionTo,
	    push: push,
	    replace: replace,
	    go: go,
	    goBack: goBack,
	    goForward: goForward,
	    createKey: createKey,
	    createPath: _PathUtils.createPath,
	    createHref: createHref,
	    createLocation: createLocation
	  };
	};
	
	exports.default = createHistory;

/***/ },
/* 237 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _warning = __webpack_require__(101);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var runTransitionHook = function runTransitionHook(hook, location, callback) {
	  var result = hook(location, callback);
	
	  if (hook.length < 2) {
	    // Assume the hook runs synchronously and automatically
	    // call the callback with the return value.
	    callback(result);
	  } else {
	     false ? (0, _warning2.default)(result === undefined, 'You should not "return" in a transition hook with a callback argument; ' + 'call the callback instead') : void 0;
	  }
	};
	
	exports.default = runTransitionHook;

/***/ },
/* 238 */
/***/ function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__(125),
	    root = __webpack_require__(89);
	
	/* Built-in method references that are verified to be native. */
	var Map = getNative(root, 'Map');
	
	module.exports = Map;


/***/ },
/* 239 */
/***/ function(module, exports, __webpack_require__) {

	var mapCacheClear = __webpack_require__(909),
	    mapCacheDelete = __webpack_require__(910),
	    mapCacheGet = __webpack_require__(911),
	    mapCacheHas = __webpack_require__(912),
	    mapCacheSet = __webpack_require__(913);
	
	/**
	 * Creates a map cache object to store key-value pairs.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function MapCache(entries) {
	  var index = -1,
	      length = entries == null ? 0 : entries.length;
	
	  this.clear();
	  while (++index < length) {
	    var entry = entries[index];
	    this.set(entry[0], entry[1]);
	  }
	}
	
	// Add methods to `MapCache`.
	MapCache.prototype.clear = mapCacheClear;
	MapCache.prototype['delete'] = mapCacheDelete;
	MapCache.prototype.get = mapCacheGet;
	MapCache.prototype.has = mapCacheHas;
	MapCache.prototype.set = mapCacheSet;
	
	module.exports = MapCache;


/***/ },
/* 240 */
/***/ function(module, exports, __webpack_require__) {

	var baseIsEqualDeep = __webpack_require__(867),
	    isObjectLike = __webpack_require__(126);
	
	/**
	 * The base implementation of `_.isEqual` which supports partial comparisons
	 * and tracks traversed objects.
	 *
	 * @private
	 * @param {*} value The value to compare.
	 * @param {*} other The other value to compare.
	 * @param {boolean} bitmask The bitmask flags.
	 *  1 - Unordered comparison
	 *  2 - Partial comparison
	 * @param {Function} [customizer] The function to customize comparisons.
	 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
	 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	 */
	function baseIsEqual(value, other, bitmask, customizer, stack) {
	  if (value === other) {
	    return true;
	  }
	  if (value == null || other == null || (!isObjectLike(value) && !isObjectLike(other))) {
	    return value !== value && other !== other;
	  }
	  return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
	}
	
	module.exports = baseIsEqual;


/***/ },
/* 241 */
/***/ function(module, exports, __webpack_require__) {

	var baseMatches = __webpack_require__(872),
	    baseMatchesProperty = __webpack_require__(873),
	    identity = __webpack_require__(931),
	    isArray = __webpack_require__(90),
	    property = __webpack_require__(933);
	
	/**
	 * The base implementation of `_.iteratee`.
	 *
	 * @private
	 * @param {*} [value=_.identity] The value to convert to an iteratee.
	 * @returns {Function} Returns the iteratee.
	 */
	function baseIteratee(value) {
	  // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
	  // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
	  if (typeof value == 'function') {
	    return value;
	  }
	  if (value == null) {
	    return identity;
	  }
	  if (typeof value == 'object') {
	    return isArray(value)
	      ? baseMatchesProperty(value[0], value[1])
	      : baseMatches(value);
	  }
	  return property(value);
	}
	
	module.exports = baseIteratee;


/***/ },
/* 242 */
/***/ function(module, exports) {

	/** Used as references for various `Number` constants. */
	var MAX_SAFE_INTEGER = 9007199254740991;
	
	/** Used to detect unsigned integer values. */
	var reIsUint = /^(?:0|[1-9]\d*)$/;
	
	/**
	 * Checks if `value` is a valid array-like index.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
	 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
	 */
	function isIndex(value, length) {
	  var type = typeof value;
	  length = length == null ? MAX_SAFE_INTEGER : length;
	
	  return !!length &&
	    (type == 'number' ||
	      (type != 'symbol' && reIsUint.test(value))) &&
	        (value > -1 && value % 1 == 0 && value < length);
	}
	
	module.exports = isIndex;


/***/ },
/* 243 */
/***/ function(module, exports, __webpack_require__) {

	var isArray = __webpack_require__(90),
	    isSymbol = __webpack_require__(181);
	
	/** Used to match property names within property paths. */
	var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
	    reIsPlainProp = /^\w*$/;
	
	/**
	 * Checks if `value` is a property name and not a property path.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @param {Object} [object] The object to query keys on.
	 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
	 */
	function isKey(value, object) {
	  if (isArray(value)) {
	    return false;
	  }
	  var type = typeof value;
	  if (type == 'number' || type == 'symbol' || type == 'boolean' ||
	      value == null || isSymbol(value)) {
	    return true;
	  }
	  return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
	    (object != null && value in Object(object));
	}
	
	module.exports = isKey;


/***/ },
/* 244 */
/***/ function(module, exports) {

	/**
	 * Performs a
	 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	 * comparison between two values to determine if they are equivalent.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to compare.
	 * @param {*} other The other value to compare.
	 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	 * @example
	 *
	 * var object = { 'a': 1 };
	 * var other = { 'a': 1 };
	 *
	 * _.eq(object, object);
	 * // => true
	 *
	 * _.eq(object, other);
	 * // => false
	 *
	 * _.eq('a', 'a');
	 * // => true
	 *
	 * _.eq('a', Object('a'));
	 * // => false
	 *
	 * _.eq(NaN, NaN);
	 * // => true
	 */
	function eq(value, other) {
	  return value === other || (value !== value && other !== other);
	}
	
	module.exports = eq;


/***/ },
/* 245 */
/***/ function(module, exports) {

	/** Used as references for various `Number` constants. */
	var MAX_SAFE_INTEGER = 9007199254740991;
	
	/**
	 * Checks if `value` is a valid array-like length.
	 *
	 * **Note:** This method is loosely based on
	 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
	 * @example
	 *
	 * _.isLength(3);
	 * // => true
	 *
	 * _.isLength(Number.MIN_VALUE);
	 * // => false
	 *
	 * _.isLength(Infinity);
	 * // => false
	 *
	 * _.isLength('3');
	 * // => false
	 */
	function isLength(value) {
	  return typeof value == 'number' &&
	    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
	}
	
	module.exports = isLength;


/***/ },
/* 246 */
/***/ function(module, exports, __webpack_require__) {

	var baseGetTag = __webpack_require__(124),
	    getPrototype = __webpack_require__(889),
	    isObjectLike = __webpack_require__(126);
	
	/** `Object#toString` result references. */
	var objectTag = '[object Object]';
	
	/** Used for built-in method references. */
	var funcProto = Function.prototype,
	    objectProto = Object.prototype;
	
	/** Used to resolve the decompiled source of functions. */
	var funcToString = funcProto.toString;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/** Used to infer the `Object` constructor. */
	var objectCtorString = funcToString.call(Object);
	
	/**
	 * Checks if `value` is a plain object, that is, an object created by the
	 * `Object` constructor or one with a `[[Prototype]]` of `null`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.8.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 * }
	 *
	 * _.isPlainObject(new Foo);
	 * // => false
	 *
	 * _.isPlainObject([1, 2, 3]);
	 * // => false
	 *
	 * _.isPlainObject({ 'x': 0, 'y': 0 });
	 * // => true
	 *
	 * _.isPlainObject(Object.create(null));
	 * // => true
	 */
	function isPlainObject(value) {
	  if (!isObjectLike(value) || baseGetTag(value) != objectTag) {
	    return false;
	  }
	  var proto = getPrototype(value);
	  if (proto === null) {
	    return true;
	  }
	  var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
	  return typeof Ctor == 'function' && Ctor instanceof Ctor &&
	    funcToString.call(Ctor) == objectCtorString;
	}
	
	module.exports = isPlainObject;


/***/ },
/* 247 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * mux.js
	 *
	 * Copyright (c) 2015 Brightcove
	 * All rights reserved.
	 *
	 * A stream-based mp2t to mp4 converter. This utility can be used to
	 * deliver mp4s to a SourceBuffer on platforms that support native
	 * Media Source Extensions.
	 */
	'use strict';
	
	var Stream = __webpack_require__(99);
	var mp4 = __webpack_require__(375);
	var frameUtils = __webpack_require__(952);
	var trackDecodeInfo = __webpack_require__(954);
	var m2ts = __webpack_require__(948);
	var AdtsStream = __webpack_require__(945);
	var H264Stream = __webpack_require__(946).H264Stream;
	var AacStream = __webpack_require__(943);
	var coneOfSilence = __webpack_require__(947);
	var clock = __webpack_require__(958);
	
	// constants
	var AUDIO_PROPERTIES = [
	  'audioobjecttype',
	  'channelcount',
	  'samplerate',
	  'samplingfrequencyindex',
	  'samplesize'
	];
	
	var VIDEO_PROPERTIES = [
	  'width',
	  'height',
	  'profileIdc',
	  'levelIdc',
	  'profileCompatibility'
	];
	
	var ONE_SECOND_IN_TS = 90000; // 90kHz clock
	
	// object types
	var VideoSegmentStream, AudioSegmentStream, Transmuxer, CoalesceStream;
	
	// Helper functions
	var
	  isLikelyAacData,
	  arrayEquals,
	  sumFrameByteLengths;
	
	isLikelyAacData = function(data) {
	  if ((data[0] === 'I'.charCodeAt(0)) &&
	      (data[1] === 'D'.charCodeAt(0)) &&
	      (data[2] === '3'.charCodeAt(0))) {
	    return true;
	  }
	  return false;
	};
	
	/**
	 * Compare two arrays (even typed) for same-ness
	 */
	arrayEquals = function(a, b) {
	  var
	    i;
	
	  if (a.length !== b.length) {
	    return false;
	  }
	
	  // compare the value of each element in the array
	  for (i = 0; i < a.length; i++) {
	    if (a[i] !== b[i]) {
	      return false;
	    }
	  }
	
	  return true;
	};
	
	/**
	 * Sum the `byteLength` properties of the data in each AAC frame
	 */
	sumFrameByteLengths = function(array) {
	  var
	    i,
	    currentObj,
	    sum = 0;
	
	  // sum the byteLength's all each nal unit in the frame
	  for (i = 0; i < array.length; i++) {
	    currentObj = array[i];
	    sum += currentObj.data.byteLength;
	  }
	
	  return sum;
	};
	
	/**
	 * Constructs a single-track, ISO BMFF media segment from AAC data
	 * events. The output of this stream can be fed to a SourceBuffer
	 * configured with a suitable initialization segment.
	 * @param track {object} track metadata configuration
	 * @param options {object} transmuxer options object
	 * @param options.keepOriginalTimestamps {boolean} If true, keep the timestamps
	 *        in the source; false to adjust the first segment to start at 0.
	 */
	AudioSegmentStream = function(track, options) {
	  var
	    adtsFrames = [],
	    sequenceNumber = 0,
	    earliestAllowedDts = 0,
	    audioAppendStartTs = 0,
	    videoBaseMediaDecodeTime = Infinity;
	
	  options = options || {};
	
	  AudioSegmentStream.prototype.init.call(this);
	
	  this.push = function(data) {
	    trackDecodeInfo.collectDtsInfo(track, data);
	
	    if (track) {
	      AUDIO_PROPERTIES.forEach(function(prop) {
	        track[prop] = data[prop];
	      });
	    }
	
	    // buffer audio data until end() is called
	    adtsFrames.push(data);
	  };
	
	  this.setEarliestDts = function(earliestDts) {
	    earliestAllowedDts = earliestDts - track.timelineStartInfo.baseMediaDecodeTime;
	  };
	
	  this.setVideoBaseMediaDecodeTime = function(baseMediaDecodeTime) {
	    videoBaseMediaDecodeTime = baseMediaDecodeTime;
	  };
	
	  this.setAudioAppendStart = function(timestamp) {
	    audioAppendStartTs = timestamp;
	  };
	
	  this.flush = function() {
	    var
	      frames,
	      moof,
	      mdat,
	      boxes;
	
	    // return early if no audio data has been observed
	    if (adtsFrames.length === 0) {
	      this.trigger('done', 'AudioSegmentStream');
	      return;
	    }
	
	    frames = this.trimAdtsFramesByEarliestDts_(adtsFrames);
	    track.baseMediaDecodeTime = trackDecodeInfo.calculateTrackBaseMediaDecodeTime(
	      track, options.keepOriginalTimestamps);
	
	    this.prefixWithSilence_(track, frames);
	
	    // we have to build the index from byte locations to
	    // samples (that is, adts frames) in the audio data
	    track.samples = this.generateSampleTable_(frames);
	
	    // concatenate the audio data to constuct the mdat
	    mdat = mp4.mdat(this.concatenateFrameData_(frames));
	
	    adtsFrames = [];
	
	    moof = mp4.moof(sequenceNumber, [track]);
	    boxes = new Uint8Array(moof.byteLength + mdat.byteLength);
	
	    // bump the sequence number for next time
	    sequenceNumber++;
	
	    boxes.set(moof);
	    boxes.set(mdat, moof.byteLength);
	
	    trackDecodeInfo.clearDtsInfo(track);
	
	    this.trigger('data', {track: track, boxes: boxes});
	    this.trigger('done', 'AudioSegmentStream');
	  };
	
	  // Possibly pad (prefix) the audio track with silence if appending this track
	  // would lead to the introduction of a gap in the audio buffer
	  this.prefixWithSilence_ = function(track, frames) {
	    var
	      baseMediaDecodeTimeTs,
	      frameDuration = 0,
	      audioGapDuration = 0,
	      audioFillFrameCount = 0,
	      audioFillDuration = 0,
	      silentFrame,
	      i;
	
	    if (!frames.length) {
	      return;
	    }
	
	    baseMediaDecodeTimeTs = clock.audioTsToVideoTs(track.baseMediaDecodeTime, track.samplerate);
	    // determine frame clock duration based on sample rate, round up to avoid overfills
	    frameDuration = Math.ceil(ONE_SECOND_IN_TS / (track.samplerate / 1024));
	
	    if (audioAppendStartTs && videoBaseMediaDecodeTime) {
	      // insert the shortest possible amount (audio gap or audio to video gap)
	      audioGapDuration =
	        baseMediaDecodeTimeTs - Math.max(audioAppendStartTs, videoBaseMediaDecodeTime);
	      // number of full frames in the audio gap
	      audioFillFrameCount = Math.floor(audioGapDuration / frameDuration);
	      audioFillDuration = audioFillFrameCount * frameDuration;
	    }
	
	    // don't attempt to fill gaps smaller than a single frame or larger
	    // than a half second
	    if (audioFillFrameCount < 1 || audioFillDuration > ONE_SECOND_IN_TS / 2) {
	      return;
	    }
	
	    silentFrame = coneOfSilence[track.samplerate];
	
	    if (!silentFrame) {
	      // we don't have a silent frame pregenerated for the sample rate, so use a frame
	      // from the content instead
	      silentFrame = frames[0].data;
	    }
	
	    for (i = 0; i < audioFillFrameCount; i++) {
	      frames.splice(i, 0, {
	        data: silentFrame
	      });
	    }
	
	    track.baseMediaDecodeTime -=
	      Math.floor(clock.videoTsToAudioTs(audioFillDuration, track.samplerate));
	  };
	
	  // If the audio segment extends before the earliest allowed dts
	  // value, remove AAC frames until starts at or after the earliest
	  // allowed DTS so that we don't end up with a negative baseMedia-
	  // DecodeTime for the audio track
	  this.trimAdtsFramesByEarliestDts_ = function(adtsFrames) {
	    if (track.minSegmentDts >= earliestAllowedDts) {
	      return adtsFrames;
	    }
	
	    // We will need to recalculate the earliest segment Dts
	    track.minSegmentDts = Infinity;
	
	    return adtsFrames.filter(function(currentFrame) {
	      // If this is an allowed frame, keep it and record it's Dts
	      if (currentFrame.dts >= earliestAllowedDts) {
	        track.minSegmentDts = Math.min(track.minSegmentDts, currentFrame.dts);
	        track.minSegmentPts = track.minSegmentDts;
	        return true;
	      }
	      // Otherwise, discard it
	      return false;
	    });
	  };
	
	  // generate the track's raw mdat data from an array of frames
	  this.generateSampleTable_ = function(frames) {
	    var
	      i,
	      currentFrame,
	      samples = [];
	
	    for (i = 0; i < frames.length; i++) {
	      currentFrame = frames[i];
	      samples.push({
	        size: currentFrame.data.byteLength,
	        duration: 1024 // For AAC audio, all samples contain 1024 samples
	      });
	    }
	    return samples;
	  };
	
	  // generate the track's sample table from an array of frames
	  this.concatenateFrameData_ = function(frames) {
	    var
	      i,
	      currentFrame,
	      dataOffset = 0,
	      data = new Uint8Array(sumFrameByteLengths(frames));
	
	    for (i = 0; i < frames.length; i++) {
	      currentFrame = frames[i];
	
	      data.set(currentFrame.data, dataOffset);
	      dataOffset += currentFrame.data.byteLength;
	    }
	    return data;
	  };
	};
	
	AudioSegmentStream.prototype = new Stream();
	
	/**
	 * Constructs a single-track, ISO BMFF media segment from H264 data
	 * events. The output of this stream can be fed to a SourceBuffer
	 * configured with a suitable initialization segment.
	 * @param track {object} track metadata configuration
	 * @param options {object} transmuxer options object
	 * @param options.alignGopsAtEnd {boolean} If true, start from the end of the
	 *        gopsToAlignWith list when attempting to align gop pts
	 * @param options.keepOriginalTimestamps {boolean} If true, keep the timestamps
	 *        in the source; false to adjust the first segment to start at 0.
	 */
	VideoSegmentStream = function(track, options) {
	  var
	    sequenceNumber = 0,
	    nalUnits = [],
	    gopsToAlignWith = [],
	    config,
	    pps;
	
	  options = options || {};
	
	  VideoSegmentStream.prototype.init.call(this);
	
	  delete track.minPTS;
	
	  this.gopCache_ = [];
	
	  /**
	    * Constructs a ISO BMFF segment given H264 nalUnits
	    * @param {Object} nalUnit A data event representing a nalUnit
	    * @param {String} nalUnit.nalUnitType
	    * @param {Object} nalUnit.config Properties for a mp4 track
	    * @param {Uint8Array} nalUnit.data The nalUnit bytes
	    * @see lib/codecs/h264.js
	   **/
	  this.push = function(nalUnit) {
	    trackDecodeInfo.collectDtsInfo(track, nalUnit);
	
	    // record the track config
	    if (nalUnit.nalUnitType === 'seq_parameter_set_rbsp' && !config) {
	      config = nalUnit.config;
	      track.sps = [nalUnit.data];
	
	      VIDEO_PROPERTIES.forEach(function(prop) {
	        track[prop] = config[prop];
	      }, this);
	    }
	
	    if (nalUnit.nalUnitType === 'pic_parameter_set_rbsp' &&
	        !pps) {
	      pps = nalUnit.data;
	      track.pps = [nalUnit.data];
	    }
	
	    // buffer video until flush() is called
	    nalUnits.push(nalUnit);
	  };
	
	  /**
	    * Pass constructed ISO BMFF track and boxes on to the
	    * next stream in the pipeline
	   **/
	  this.flush = function() {
	    var
	      frames,
	      gopForFusion,
	      gops,
	      moof,
	      mdat,
	      boxes;
	
	    // Throw away nalUnits at the start of the byte stream until
	    // we find the first AUD
	    while (nalUnits.length) {
	      if (nalUnits[0].nalUnitType === 'access_unit_delimiter_rbsp') {
	        break;
	      }
	      nalUnits.shift();
	    }
	
	    // Return early if no video data has been observed
	    if (nalUnits.length === 0) {
	      this.resetStream_();
	      this.trigger('done', 'VideoSegmentStream');
	      return;
	    }
	
	    // Organize the raw nal-units into arrays that represent
	    // higher-level constructs such as frames and gops
	    // (group-of-pictures)
	    frames = frameUtils.groupNalsIntoFrames(nalUnits);
	    gops = frameUtils.groupFramesIntoGops(frames);
	
	    // If the first frame of this fragment is not a keyframe we have
	    // a problem since MSE (on Chrome) requires a leading keyframe.
	    //
	    // We have two approaches to repairing this situation:
	    // 1) GOP-FUSION:
	    //    This is where we keep track of the GOPS (group-of-pictures)
	    //    from previous fragments and attempt to find one that we can
	    //    prepend to the current fragment in order to create a valid
	    //    fragment.
	    // 2) KEYFRAME-PULLING:
	    //    Here we search for the first keyframe in the fragment and
	    //    throw away all the frames between the start of the fragment
	    //    and that keyframe. We then extend the duration and pull the
	    //    PTS of the keyframe forward so that it covers the time range
	    //    of the frames that were disposed of.
	    //
	    // #1 is far prefereable over #2 which can cause "stuttering" but
	    // requires more things to be just right.
	    if (!gops[0][0].keyFrame) {
	      // Search for a gop for fusion from our gopCache
	      gopForFusion = this.getGopForFusion_(nalUnits[0], track);
	
	      if (gopForFusion) {
	        gops.unshift(gopForFusion);
	        // Adjust Gops' metadata to account for the inclusion of the
	        // new gop at the beginning
	        gops.byteLength += gopForFusion.byteLength;
	        gops.nalCount += gopForFusion.nalCount;
	        gops.pts = gopForFusion.pts;
	        gops.dts = gopForFusion.dts;
	        gops.duration += gopForFusion.duration;
	      } else {
	        // If we didn't find a candidate gop fall back to keyframe-pulling
	        gops = frameUtils.extendFirstKeyFrame(gops);
	      }
	    }
	
	    // Trim gops to align with gopsToAlignWith
	    if (gopsToAlignWith.length) {
	      var alignedGops;
	
	      if (options.alignGopsAtEnd) {
	        alignedGops = this.alignGopsAtEnd_(gops);
	      } else {
	        alignedGops = this.alignGopsAtStart_(gops);
	      }
	
	      if (!alignedGops) {
	        // save all the nals in the last GOP into the gop cache
	        this.gopCache_.unshift({
	          gop: gops.pop(),
	          pps: track.pps,
	          sps: track.sps
	        });
	
	        // Keep a maximum of 6 GOPs in the cache
	        this.gopCache_.length = Math.min(6, this.gopCache_.length);
	
	        // Clear nalUnits
	        nalUnits = [];
	
	        // return early no gops can be aligned with desired gopsToAlignWith
	        this.resetStream_();
	        this.trigger('done', 'VideoSegmentStream');
	        return;
	      }
	
	      // Some gops were trimmed. clear dts info so minSegmentDts and pts are correct
	      // when recalculated before sending off to CoalesceStream
	      trackDecodeInfo.clearDtsInfo(track);
	
	      gops = alignedGops;
	    }
	
	    trackDecodeInfo.collectDtsInfo(track, gops);
	
	    // First, we have to build the index from byte locations to
	    // samples (that is, frames) in the video data
	    track.samples = frameUtils.generateSampleTable(gops);
	
	    // Concatenate the video data and construct the mdat
	    mdat = mp4.mdat(frameUtils.concatenateNalData(gops));
	
	    track.baseMediaDecodeTime = trackDecodeInfo.calculateTrackBaseMediaDecodeTime(
	      track, options.keepOriginalTimestamps);
	
	    this.trigger('processedGopsInfo', gops.map(function(gop) {
	      return {
	        pts: gop.pts,
	        dts: gop.dts,
	        byteLength: gop.byteLength
	      };
	    }));
	
	    // save all the nals in the last GOP into the gop cache
	    this.gopCache_.unshift({
	      gop: gops.pop(),
	      pps: track.pps,
	      sps: track.sps
	    });
	
	    // Keep a maximum of 6 GOPs in the cache
	    this.gopCache_.length = Math.min(6, this.gopCache_.length);
	
	    // Clear nalUnits
	    nalUnits = [];
	
	    this.trigger('baseMediaDecodeTime', track.baseMediaDecodeTime);
	    this.trigger('timelineStartInfo', track.timelineStartInfo);
	
	    moof = mp4.moof(sequenceNumber, [track]);
	
	    // it would be great to allocate this array up front instead of
	    // throwing away hundreds of media segment fragments
	    boxes = new Uint8Array(moof.byteLength + mdat.byteLength);
	
	    // Bump the sequence number for next time
	    sequenceNumber++;
	
	    boxes.set(moof);
	    boxes.set(mdat, moof.byteLength);
	
	    this.trigger('data', {track: track, boxes: boxes});
	
	    this.resetStream_();
	
	    // Continue with the flush process now
	    this.trigger('done', 'VideoSegmentStream');
	  };
	
	  this.resetStream_ = function() {
	    trackDecodeInfo.clearDtsInfo(track);
	
	    // reset config and pps because they may differ across segments
	    // for instance, when we are rendition switching
	    config = undefined;
	    pps = undefined;
	  };
	
	  // Search for a candidate Gop for gop-fusion from the gop cache and
	  // return it or return null if no good candidate was found
	  this.getGopForFusion_ = function(nalUnit) {
	    var
	      halfSecond = 45000, // Half-a-second in a 90khz clock
	      allowableOverlap = 10000, // About 3 frames @ 30fps
	      nearestDistance = Infinity,
	      dtsDistance,
	      nearestGopObj,
	      currentGop,
	      currentGopObj,
	      i;
	
	    // Search for the GOP nearest to the beginning of this nal unit
	    for (i = 0; i < this.gopCache_.length; i++) {
	      currentGopObj = this.gopCache_[i];
	      currentGop = currentGopObj.gop;
	
	      // Reject Gops with different SPS or PPS
	      if (!(track.pps && arrayEquals(track.pps[0], currentGopObj.pps[0])) ||
	          !(track.sps && arrayEquals(track.sps[0], currentGopObj.sps[0]))) {
	        continue;
	      }
	
	      // Reject Gops that would require a negative baseMediaDecodeTime
	      if (currentGop.dts < track.timelineStartInfo.dts) {
	        continue;
	      }
	
	      // The distance between the end of the gop and the start of the nalUnit
	      dtsDistance = (nalUnit.dts - currentGop.dts) - currentGop.duration;
	
	      // Only consider GOPS that start before the nal unit and end within
	      // a half-second of the nal unit
	      if (dtsDistance >= -allowableOverlap &&
	          dtsDistance <= halfSecond) {
	
	        // Always use the closest GOP we found if there is more than
	        // one candidate
	        if (!nearestGopObj ||
	            nearestDistance > dtsDistance) {
	          nearestGopObj = currentGopObj;
	          nearestDistance = dtsDistance;
	        }
	      }
	    }
	
	    if (nearestGopObj) {
	      return nearestGopObj.gop;
	    }
	    return null;
	  };
	
	  // trim gop list to the first gop found that has a matching pts with a gop in the list
	  // of gopsToAlignWith starting from the START of the list
	  this.alignGopsAtStart_ = function(gops) {
	    var alignIndex, gopIndex, align, gop, byteLength, nalCount, duration, alignedGops;
	
	    byteLength = gops.byteLength;
	    nalCount = gops.nalCount;
	    duration = gops.duration;
	    alignIndex = gopIndex = 0;
	
	    while (alignIndex < gopsToAlignWith.length && gopIndex < gops.length) {
	      align = gopsToAlignWith[alignIndex];
	      gop = gops[gopIndex];
	
	      if (align.pts === gop.pts) {
	        break;
	      }
	
	      if (gop.pts > align.pts) {
	        // this current gop starts after the current gop we want to align on, so increment
	        // align index
	        alignIndex++;
	        continue;
	      }
	
	      // current gop starts before the current gop we want to align on. so increment gop
	      // index
	      gopIndex++;
	      byteLength -= gop.byteLength;
	      nalCount -= gop.nalCount;
	      duration -= gop.duration;
	    }
	
	    if (gopIndex === 0) {
	      // no gops to trim
	      return gops;
	    }
	
	    if (gopIndex === gops.length) {
	      // all gops trimmed, skip appending all gops
	      return null;
	    }
	
	    alignedGops = gops.slice(gopIndex);
	    alignedGops.byteLength = byteLength;
	    alignedGops.duration = duration;
	    alignedGops.nalCount = nalCount;
	    alignedGops.pts = alignedGops[0].pts;
	    alignedGops.dts = alignedGops[0].dts;
	
	    return alignedGops;
	  };
	
	  // trim gop list to the first gop found that has a matching pts with a gop in the list
	  // of gopsToAlignWith starting from the END of the list
	  this.alignGopsAtEnd_ = function(gops) {
	    var alignIndex, gopIndex, align, gop, alignEndIndex, matchFound;
	
	    alignIndex = gopsToAlignWith.length - 1;
	    gopIndex = gops.length - 1;
	    alignEndIndex = null;
	    matchFound = false;
	
	    while (alignIndex >= 0 && gopIndex >= 0) {
	      align = gopsToAlignWith[alignIndex];
	      gop = gops[gopIndex];
	
	      if (align.pts === gop.pts) {
	        matchFound = true;
	        break;
	      }
	
	      if (align.pts > gop.pts) {
	        alignIndex--;
	        continue;
	      }
	
	      if (alignIndex === gopsToAlignWith.length - 1) {
	        // gop.pts is greater than the last alignment candidate. If no match is found
	        // by the end of this loop, we still want to append gops that come after this
	        // point
	        alignEndIndex = gopIndex;
	      }
	
	      gopIndex--;
	    }
	
	    if (!matchFound && alignEndIndex === null) {
	      return null;
	    }
	
	    var trimIndex;
	
	    if (matchFound) {
	      trimIndex = gopIndex;
	    } else {
	      trimIndex = alignEndIndex;
	    }
	
	    if (trimIndex === 0) {
	      return gops;
	    }
	
	    var alignedGops = gops.slice(trimIndex);
	    var metadata = alignedGops.reduce(function(total, gop) {
	      total.byteLength += gop.byteLength;
	      total.duration += gop.duration;
	      total.nalCount += gop.nalCount;
	      return total;
	    }, { byteLength: 0, duration: 0, nalCount: 0 });
	
	    alignedGops.byteLength = metadata.byteLength;
	    alignedGops.duration = metadata.duration;
	    alignedGops.nalCount = metadata.nalCount;
	    alignedGops.pts = alignedGops[0].pts;
	    alignedGops.dts = alignedGops[0].dts;
	
	    return alignedGops;
	  };
	
	  this.alignGopsWith = function(newGopsToAlignWith) {
	    gopsToAlignWith = newGopsToAlignWith;
	  };
	};
	
	VideoSegmentStream.prototype = new Stream();
	
	/**
	 * A Stream that can combine multiple streams (ie. audio & video)
	 * into a single output segment for MSE. Also supports audio-only
	 * and video-only streams.
	 */
	CoalesceStream = function(options, metadataStream) {
	  // Number of Tracks per output segment
	  // If greater than 1, we combine multiple
	  // tracks into a single segment
	  this.numberOfTracks = 0;
	  this.metadataStream = metadataStream;
	
	  if (typeof options.remux !== 'undefined') {
	    this.remuxTracks = !!options.remux;
	  } else {
	    this.remuxTracks = true;
	  }
	
	  this.pendingTracks = [];
	  this.videoTrack = null;
	  this.pendingBoxes = [];
	  this.pendingCaptions = [];
	  this.pendingMetadata = [];
	  this.pendingBytes = 0;
	  this.emittedTracks = 0;
	
	  CoalesceStream.prototype.init.call(this);
	
	  // Take output from multiple
	  this.push = function(output) {
	    // buffer incoming captions until the associated video segment
	    // finishes
	    if (output.text) {
	      return this.pendingCaptions.push(output);
	    }
	    // buffer incoming id3 tags until the final flush
	    if (output.frames) {
	      return this.pendingMetadata.push(output);
	    }
	
	    // Add this track to the list of pending tracks and store
	    // important information required for the construction of
	    // the final segment
	    this.pendingTracks.push(output.track);
	    this.pendingBoxes.push(output.boxes);
	    this.pendingBytes += output.boxes.byteLength;
	
	    if (output.track.type === 'video') {
	      this.videoTrack = output.track;
	    }
	    if (output.track.type === 'audio') {
	      this.audioTrack = output.track;
	    }
	  };
	};
	
	CoalesceStream.prototype = new Stream();
	CoalesceStream.prototype.flush = function(flushSource) {
	  var
	    offset = 0,
	    event = {
	      captions: [],
	      captionStreams: {},
	      metadata: [],
	      info: {}
	    },
	    caption,
	    id3,
	    initSegment,
	    timelineStartPts = 0,
	    i;
	
	  if (this.pendingTracks.length < this.numberOfTracks) {
	    if (flushSource !== 'VideoSegmentStream' &&
	        flushSource !== 'AudioSegmentStream') {
	      // Return because we haven't received a flush from a data-generating
	      // portion of the segment (meaning that we have only recieved meta-data
	      // or captions.)
	      return;
	    } else if (this.remuxTracks) {
	      // Return until we have enough tracks from the pipeline to remux (if we
	      // are remuxing audio and video into a single MP4)
	      return;
	    } else if (this.pendingTracks.length === 0) {
	      // In the case where we receive a flush without any data having been
	      // received we consider it an emitted track for the purposes of coalescing
	      // `done` events.
	      // We do this for the case where there is an audio and video track in the
	      // segment but no audio data. (seen in several playlists with alternate
	      // audio tracks and no audio present in the main TS segments.)
	      this.emittedTracks++;
	
	      if (this.emittedTracks >= this.numberOfTracks) {
	        this.trigger('done');
	        this.emittedTracks = 0;
	      }
	      return;
	    }
	  }
	
	  if (this.videoTrack) {
	    timelineStartPts = this.videoTrack.timelineStartInfo.pts;
	    VIDEO_PROPERTIES.forEach(function(prop) {
	      event.info[prop] = this.videoTrack[prop];
	    }, this);
	  } else if (this.audioTrack) {
	    timelineStartPts = this.audioTrack.timelineStartInfo.pts;
	    AUDIO_PROPERTIES.forEach(function(prop) {
	      event.info[prop] = this.audioTrack[prop];
	    }, this);
	  }
	
	  if (this.pendingTracks.length === 1) {
	    event.type = this.pendingTracks[0].type;
	  } else {
	    event.type = 'combined';
	  }
	
	  this.emittedTracks += this.pendingTracks.length;
	
	  initSegment = mp4.initSegment(this.pendingTracks);
	
	  // Create a new typed array to hold the init segment
	  event.initSegment = new Uint8Array(initSegment.byteLength);
	
	  // Create an init segment containing a moov
	  // and track definitions
	  event.initSegment.set(initSegment);
	
	  // Create a new typed array to hold the moof+mdats
	  event.data = new Uint8Array(this.pendingBytes);
	
	  // Append each moof+mdat (one per track) together
	  for (i = 0; i < this.pendingBoxes.length; i++) {
	    event.data.set(this.pendingBoxes[i], offset);
	    offset += this.pendingBoxes[i].byteLength;
	  }
	
	  // Translate caption PTS times into second offsets into the
	  // video timeline for the segment, and add track info
	  for (i = 0; i < this.pendingCaptions.length; i++) {
	    caption = this.pendingCaptions[i];
	    caption.startTime = (caption.startPts - timelineStartPts);
	    caption.startTime /= 90e3;
	    caption.endTime = (caption.endPts - timelineStartPts);
	    caption.endTime /= 90e3;
	    event.captionStreams[caption.stream] = true;
	    event.captions.push(caption);
	  }
	
	  // Translate ID3 frame PTS times into second offsets into the
	  // video timeline for the segment
	  for (i = 0; i < this.pendingMetadata.length; i++) {
	    id3 = this.pendingMetadata[i];
	    id3.cueTime = (id3.pts - timelineStartPts);
	    id3.cueTime /= 90e3;
	    event.metadata.push(id3);
	  }
	  // We add this to every single emitted segment even though we only need
	  // it for the first
	  event.metadata.dispatchType = this.metadataStream.dispatchType;
	
	  // Reset stream state
	  this.pendingTracks.length = 0;
	  this.videoTrack = null;
	  this.pendingBoxes.length = 0;
	  this.pendingCaptions.length = 0;
	  this.pendingBytes = 0;
	  this.pendingMetadata.length = 0;
	
	  // Emit the built segment
	  this.trigger('data', event);
	
	  // Only emit `done` if all tracks have been flushed and emitted
	  if (this.emittedTracks >= this.numberOfTracks) {
	    this.trigger('done');
	    this.emittedTracks = 0;
	  }
	};
	/**
	 * A Stream that expects MP2T binary data as input and produces
	 * corresponding media segments, suitable for use with Media Source
	 * Extension (MSE) implementations that support the ISO BMFF byte
	 * stream format, like Chrome.
	 */
	Transmuxer = function(options) {
	  var
	    self = this,
	    hasFlushed = true,
	    videoTrack,
	    audioTrack;
	
	  Transmuxer.prototype.init.call(this);
	
	  options = options || {};
	  this.baseMediaDecodeTime = options.baseMediaDecodeTime || 0;
	  this.transmuxPipeline_ = {};
	
	  this.setupAacPipeline = function() {
	    var pipeline = {};
	    this.transmuxPipeline_ = pipeline;
	
	    pipeline.type = 'aac';
	    pipeline.metadataStream = new m2ts.MetadataStream();
	
	    // set up the parsing pipeline
	    pipeline.aacStream = new AacStream();
	    pipeline.audioTimestampRolloverStream = new m2ts.TimestampRolloverStream('audio');
	    pipeline.timedMetadataTimestampRolloverStream = new m2ts.TimestampRolloverStream('timed-metadata');
	    pipeline.adtsStream = new AdtsStream();
	    pipeline.coalesceStream = new CoalesceStream(options, pipeline.metadataStream);
	    pipeline.headOfPipeline = pipeline.aacStream;
	
	    pipeline.aacStream
	      .pipe(pipeline.audioTimestampRolloverStream)
	      .pipe(pipeline.adtsStream);
	    pipeline.aacStream
	      .pipe(pipeline.timedMetadataTimestampRolloverStream)
	      .pipe(pipeline.metadataStream)
	      .pipe(pipeline.coalesceStream);
	
	    pipeline.metadataStream.on('timestamp', function(frame) {
	      pipeline.aacStream.setTimestamp(frame.timeStamp);
	    });
	
	    pipeline.aacStream.on('data', function(data) {
	      if (data.type === 'timed-metadata' && !pipeline.audioSegmentStream) {
	        audioTrack = audioTrack || {
	          timelineStartInfo: {
	            baseMediaDecodeTime: self.baseMediaDecodeTime
	          },
	          codec: 'adts',
	          type: 'audio'
	        };
	        // hook up the audio segment stream to the first track with aac data
	        pipeline.coalesceStream.numberOfTracks++;
	        pipeline.audioSegmentStream = new AudioSegmentStream(audioTrack, options);
	        // Set up the final part of the audio pipeline
	        pipeline.adtsStream
	          .pipe(pipeline.audioSegmentStream)
	          .pipe(pipeline.coalesceStream);
	      }
	    });
	
	    // Re-emit any data coming from the coalesce stream to the outside world
	    pipeline.coalesceStream.on('data', this.trigger.bind(this, 'data'));
	    // Let the consumer know we have finished flushing the entire pipeline
	    pipeline.coalesceStream.on('done', this.trigger.bind(this, 'done'));
	  };
	
	  this.setupTsPipeline = function() {
	    var pipeline = {};
	    this.transmuxPipeline_ = pipeline;
	
	    pipeline.type = 'ts';
	    pipeline.metadataStream = new m2ts.MetadataStream();
	
	    // set up the parsing pipeline
	    pipeline.packetStream = new m2ts.TransportPacketStream();
	    pipeline.parseStream = new m2ts.TransportParseStream();
	    pipeline.elementaryStream = new m2ts.ElementaryStream();
	    pipeline.videoTimestampRolloverStream = new m2ts.TimestampRolloverStream('video');
	    pipeline.audioTimestampRolloverStream = new m2ts.TimestampRolloverStream('audio');
	    pipeline.timedMetadataTimestampRolloverStream = new m2ts.TimestampRolloverStream('timed-metadata');
	    pipeline.adtsStream = new AdtsStream();
	    pipeline.h264Stream = new H264Stream();
	    pipeline.captionStream = new m2ts.CaptionStream();
	    pipeline.coalesceStream = new CoalesceStream(options, pipeline.metadataStream);
	    pipeline.headOfPipeline = pipeline.packetStream;
	
	    // disassemble MPEG2-TS packets into elementary streams
	    pipeline.packetStream
	      .pipe(pipeline.parseStream)
	      .pipe(pipeline.elementaryStream);
	
	    // !!THIS ORDER IS IMPORTANT!!
	    // demux the streams
	    pipeline.elementaryStream
	      .pipe(pipeline.videoTimestampRolloverStream)
	      .pipe(pipeline.h264Stream);
	    pipeline.elementaryStream
	      .pipe(pipeline.audioTimestampRolloverStream)
	      .pipe(pipeline.adtsStream);
	
	    pipeline.elementaryStream
	      .pipe(pipeline.timedMetadataTimestampRolloverStream)
	      .pipe(pipeline.metadataStream)
	      .pipe(pipeline.coalesceStream);
	
	    // Hook up CEA-608/708 caption stream
	    pipeline.h264Stream.pipe(pipeline.captionStream)
	      .pipe(pipeline.coalesceStream);
	
	    pipeline.elementaryStream.on('data', function(data) {
	      var i;
	
	      if (data.type === 'metadata') {
	        i = data.tracks.length;
	
	        // scan the tracks listed in the metadata
	        while (i--) {
	          if (!videoTrack && data.tracks[i].type === 'video') {
	            videoTrack = data.tracks[i];
	            videoTrack.timelineStartInfo.baseMediaDecodeTime = self.baseMediaDecodeTime;
	          } else if (!audioTrack && data.tracks[i].type === 'audio') {
	            audioTrack = data.tracks[i];
	            audioTrack.timelineStartInfo.baseMediaDecodeTime = self.baseMediaDecodeTime;
	          }
	        }
	
	        // hook up the video segment stream to the first track with h264 data
	        if (videoTrack && !pipeline.videoSegmentStream) {
	          pipeline.coalesceStream.numberOfTracks++;
	          pipeline.videoSegmentStream = new VideoSegmentStream(videoTrack, options);
	
	          pipeline.videoSegmentStream.on('timelineStartInfo', function(timelineStartInfo) {
	          // When video emits timelineStartInfo data after a flush, we forward that
	          // info to the AudioSegmentStream, if it exists, because video timeline
	          // data takes precedence.
	            if (audioTrack) {
	              audioTrack.timelineStartInfo = timelineStartInfo;
	              // On the first segment we trim AAC frames that exist before the
	              // very earliest DTS we have seen in video because Chrome will
	              // interpret any video track with a baseMediaDecodeTime that is
	              // non-zero as a gap.
	              pipeline.audioSegmentStream.setEarliestDts(timelineStartInfo.dts);
	            }
	          });
	
	          pipeline.videoSegmentStream.on('processedGopsInfo',
	            self.trigger.bind(self, 'gopInfo'));
	
	          pipeline.videoSegmentStream.on('baseMediaDecodeTime', function(baseMediaDecodeTime) {
	            if (audioTrack) {
	              pipeline.audioSegmentStream.setVideoBaseMediaDecodeTime(baseMediaDecodeTime);
	            }
	          });
	
	          // Set up the final part of the video pipeline
	          pipeline.h264Stream
	            .pipe(pipeline.videoSegmentStream)
	            .pipe(pipeline.coalesceStream);
	        }
	
	        if (audioTrack && !pipeline.audioSegmentStream) {
	          // hook up the audio segment stream to the first track with aac data
	          pipeline.coalesceStream.numberOfTracks++;
	          pipeline.audioSegmentStream = new AudioSegmentStream(audioTrack, options);
	
	          // Set up the final part of the audio pipeline
	          pipeline.adtsStream
	            .pipe(pipeline.audioSegmentStream)
	            .pipe(pipeline.coalesceStream);
	        }
	      }
	    });
	
	    // Re-emit any data coming from the coalesce stream to the outside world
	    pipeline.coalesceStream.on('data', this.trigger.bind(this, 'data'));
	    // Let the consumer know we have finished flushing the entire pipeline
	    pipeline.coalesceStream.on('done', this.trigger.bind(this, 'done'));
	  };
	
	  // hook up the segment streams once track metadata is delivered
	  this.setBaseMediaDecodeTime = function(baseMediaDecodeTime) {
	    var pipeline = this.transmuxPipeline_;
	
	    this.baseMediaDecodeTime = baseMediaDecodeTime;
	    if (audioTrack) {
	      audioTrack.timelineStartInfo.dts = undefined;
	      audioTrack.timelineStartInfo.pts = undefined;
	      trackDecodeInfo.clearDtsInfo(audioTrack);
	      audioTrack.timelineStartInfo.baseMediaDecodeTime = baseMediaDecodeTime;
	      if (pipeline.audioTimestampRolloverStream) {
	        pipeline.audioTimestampRolloverStream.discontinuity();
	      }
	    }
	    if (videoTrack) {
	      if (pipeline.videoSegmentStream) {
	        pipeline.videoSegmentStream.gopCache_ = [];
	        pipeline.videoTimestampRolloverStream.discontinuity();
	      }
	      videoTrack.timelineStartInfo.dts = undefined;
	      videoTrack.timelineStartInfo.pts = undefined;
	      trackDecodeInfo.clearDtsInfo(videoTrack);
	      pipeline.captionStream.reset();
	      videoTrack.timelineStartInfo.baseMediaDecodeTime = baseMediaDecodeTime;
	    }
	
	    if (pipeline.timedMetadataTimestampRolloverStream) {
	      pipeline.timedMetadataTimestampRolloverStream.discontinuity();
	    }
	  };
	
	  this.setAudioAppendStart = function(timestamp) {
	    if (audioTrack) {
	      this.transmuxPipeline_.audioSegmentStream.setAudioAppendStart(timestamp);
	    }
	  };
	
	  this.alignGopsWith = function(gopsToAlignWith) {
	    if (videoTrack && this.transmuxPipeline_.videoSegmentStream) {
	      this.transmuxPipeline_.videoSegmentStream.alignGopsWith(gopsToAlignWith);
	    }
	  };
	
	  // feed incoming data to the front of the parsing pipeline
	  this.push = function(data) {
	    if (hasFlushed) {
	      var isAac = isLikelyAacData(data);
	
	      if (isAac && this.transmuxPipeline_.type !== 'aac') {
	        this.setupAacPipeline();
	      } else if (!isAac && this.transmuxPipeline_.type !== 'ts') {
	        this.setupTsPipeline();
	      }
	      hasFlushed = false;
	    }
	    this.transmuxPipeline_.headOfPipeline.push(data);
	  };
	
	  // flush any buffered data
	  this.flush = function() {
	      hasFlushed = true;
	    // Start at the top of the pipeline and flush all pending work
	    this.transmuxPipeline_.headOfPipeline.flush();
	  };
	
	  // Caption data has to be reset when seeking outside buffered range
	  this.resetCaptions = function() {
	    if (this.transmuxPipeline_.captionStream) {
	      this.transmuxPipeline_.captionStream.reset();
	    }
	  };
	
	};
	Transmuxer.prototype = new Stream();
	
	module.exports = {
	  Transmuxer: Transmuxer,
	  VideoSegmentStream: VideoSegmentStream,
	  AudioSegmentStream: AudioSegmentStream,
	  AUDIO_PROPERTIES: AUDIO_PROPERTIES,
	  VIDEO_PROPERTIES: VIDEO_PROPERTIES
	};


/***/ },
/* 248 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var DOMLazyTree = __webpack_require__(127);
	var Danger = __webpack_require__(971);
	var ReactDOMComponentTree = __webpack_require__(41);
	var ReactInstrumentation = __webpack_require__(62);
	
	var createMicrosoftUnsafeLocalFunction = __webpack_require__(257);
	var setInnerHTML = __webpack_require__(188);
	var setTextContent = __webpack_require__(406);
	
	function getNodeAfter(parentNode, node) {
	  // Special case for text components, which return [open, close] comments
	  // from getHostNode.
	  if (Array.isArray(node)) {
	    node = node[1];
	  }
	  return node ? node.nextSibling : parentNode.firstChild;
	}
	
	/**
	 * Inserts `childNode` as a child of `parentNode` at the `index`.
	 *
	 * @param {DOMElement} parentNode Parent node in which to insert.
	 * @param {DOMElement} childNode Child node to insert.
	 * @param {number} index Index at which to insert the child.
	 * @internal
	 */
	var insertChildAt = createMicrosoftUnsafeLocalFunction(function (parentNode, childNode, referenceNode) {
	  // We rely exclusively on `insertBefore(node, null)` instead of also using
	  // `appendChild(node)`. (Using `undefined` is not allowed by all browsers so
	  // we are careful to use `null`.)
	  parentNode.insertBefore(childNode, referenceNode);
	});
	
	function insertLazyTreeChildAt(parentNode, childTree, referenceNode) {
	  DOMLazyTree.insertTreeBefore(parentNode, childTree, referenceNode);
	}
	
	function moveChild(parentNode, childNode, referenceNode) {
	  if (Array.isArray(childNode)) {
	    moveDelimitedText(parentNode, childNode[0], childNode[1], referenceNode);
	  } else {
	    insertChildAt(parentNode, childNode, referenceNode);
	  }
	}
	
	function removeChild(parentNode, childNode) {
	  if (Array.isArray(childNode)) {
	    var closingComment = childNode[1];
	    childNode = childNode[0];
	    removeDelimitedText(parentNode, childNode, closingComment);
	    parentNode.removeChild(closingComment);
	  }
	  parentNode.removeChild(childNode);
	}
	
	function moveDelimitedText(parentNode, openingComment, closingComment, referenceNode) {
	  var node = openingComment;
	  while (true) {
	    var nextNode = node.nextSibling;
	    insertChildAt(parentNode, node, referenceNode);
	    if (node === closingComment) {
	      break;
	    }
	    node = nextNode;
	  }
	}
	
	function removeDelimitedText(parentNode, startNode, closingComment) {
	  while (true) {
	    var node = startNode.nextSibling;
	    if (node === closingComment) {
	      // The closing comment is removed by ReactMultiChild.
	      break;
	    } else {
	      parentNode.removeChild(node);
	    }
	  }
	}
	
	function replaceDelimitedText(openingComment, closingComment, stringText) {
	  var parentNode = openingComment.parentNode;
	  var nodeAfterComment = openingComment.nextSibling;
	  if (nodeAfterComment === closingComment) {
	    // There are no text nodes between the opening and closing comments; insert
	    // a new one if stringText isn't empty.
	    if (stringText) {
	      insertChildAt(parentNode, document.createTextNode(stringText), nodeAfterComment);
	    }
	  } else {
	    if (stringText) {
	      // Set the text content of the first node after the opening comment, and
	      // remove all following nodes up until the closing comment.
	      setTextContent(nodeAfterComment, stringText);
	      removeDelimitedText(parentNode, nodeAfterComment, closingComment);
	    } else {
	      removeDelimitedText(parentNode, openingComment, closingComment);
	    }
	  }
	
	  if (false) {
	    ReactInstrumentation.debugTool.onHostOperation({
	      instanceID: ReactDOMComponentTree.getInstanceFromNode(openingComment)._debugID,
	      type: 'replace text',
	      payload: stringText
	    });
	  }
	}
	
	var dangerouslyReplaceNodeWithMarkup = Danger.dangerouslyReplaceNodeWithMarkup;
	if (false) {
	  dangerouslyReplaceNodeWithMarkup = function (oldChild, markup, prevInstance) {
	    Danger.dangerouslyReplaceNodeWithMarkup(oldChild, markup);
	    if (prevInstance._debugID !== 0) {
	      ReactInstrumentation.debugTool.onHostOperation({
	        instanceID: prevInstance._debugID,
	        type: 'replace with',
	        payload: markup.toString()
	      });
	    } else {
	      var nextInstance = ReactDOMComponentTree.getInstanceFromNode(markup.node);
	      if (nextInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onHostOperation({
	          instanceID: nextInstance._debugID,
	          type: 'mount',
	          payload: markup.toString()
	        });
	      }
	    }
	  };
	}
	
	/**
	 * Operations for updating with DOM children.
	 */
	var DOMChildrenOperations = {
	  dangerouslyReplaceNodeWithMarkup: dangerouslyReplaceNodeWithMarkup,
	
	  replaceDelimitedText: replaceDelimitedText,
	
	  /**
	   * Updates a component's children by processing a series of updates. The
	   * update configurations are each expected to have a `parentNode` property.
	   *
	   * @param {array<object>} updates List of update configurations.
	   * @internal
	   */
	  processUpdates: function (parentNode, updates) {
	    if (false) {
	      var parentNodeDebugID = ReactDOMComponentTree.getInstanceFromNode(parentNode)._debugID;
	    }
	
	    for (var k = 0; k < updates.length; k++) {
	      var update = updates[k];
	      switch (update.type) {
	        case 'INSERT_MARKUP':
	          insertLazyTreeChildAt(parentNode, update.content, getNodeAfter(parentNode, update.afterNode));
	          if (false) {
	            ReactInstrumentation.debugTool.onHostOperation({
	              instanceID: parentNodeDebugID,
	              type: 'insert child',
	              payload: {
	                toIndex: update.toIndex,
	                content: update.content.toString()
	              }
	            });
	          }
	          break;
	        case 'MOVE_EXISTING':
	          moveChild(parentNode, update.fromNode, getNodeAfter(parentNode, update.afterNode));
	          if (false) {
	            ReactInstrumentation.debugTool.onHostOperation({
	              instanceID: parentNodeDebugID,
	              type: 'move child',
	              payload: { fromIndex: update.fromIndex, toIndex: update.toIndex }
	            });
	          }
	          break;
	        case 'SET_MARKUP':
	          setInnerHTML(parentNode, update.content);
	          if (false) {
	            ReactInstrumentation.debugTool.onHostOperation({
	              instanceID: parentNodeDebugID,
	              type: 'replace children',
	              payload: update.content.toString()
	            });
	          }
	          break;
	        case 'TEXT_CONTENT':
	          setTextContent(parentNode, update.content);
	          if (false) {
	            ReactInstrumentation.debugTool.onHostOperation({
	              instanceID: parentNodeDebugID,
	              type: 'replace text',
	              payload: update.content.toString()
	            });
	          }
	          break;
	        case 'REMOVE_NODE':
	          removeChild(parentNode, update.fromNode);
	          if (false) {
	            ReactInstrumentation.debugTool.onHostOperation({
	              instanceID: parentNodeDebugID,
	              type: 'remove child',
	              payload: { fromIndex: update.fromIndex }
	            });
	          }
	          break;
	      }
	    }
	  }
	};
	
	module.exports = DOMChildrenOperations;

/***/ },
/* 249 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var DOMNamespaces = {
	  html: 'http://www.w3.org/1999/xhtml',
	  mathml: 'http://www.w3.org/1998/Math/MathML',
	  svg: 'http://www.w3.org/2000/svg'
	};
	
	module.exports = DOMNamespaces;

/***/ },
/* 250 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(29);
	
	var invariant = __webpack_require__(21);
	
	/**
	 * Injectable ordering of event plugins.
	 */
	var eventPluginOrder = null;
	
	/**
	 * Injectable mapping from names to event plugin modules.
	 */
	var namesToPlugins = {};
	
	/**
	 * Recomputes the plugin list using the injected plugins and plugin ordering.
	 *
	 * @private
	 */
	function recomputePluginOrdering() {
	  if (!eventPluginOrder) {
	    // Wait until an `eventPluginOrder` is injected.
	    return;
	  }
	  for (var pluginName in namesToPlugins) {
	    var pluginModule = namesToPlugins[pluginName];
	    var pluginIndex = eventPluginOrder.indexOf(pluginName);
	    !(pluginIndex > -1) ?  false ? invariant(false, 'EventPluginRegistry: Cannot inject event plugins that do not exist in the plugin ordering, `%s`.', pluginName) : _prodInvariant('96', pluginName) : void 0;
	    if (EventPluginRegistry.plugins[pluginIndex]) {
	      continue;
	    }
	    !pluginModule.extractEvents ?  false ? invariant(false, 'EventPluginRegistry: Event plugins must implement an `extractEvents` method, but `%s` does not.', pluginName) : _prodInvariant('97', pluginName) : void 0;
	    EventPluginRegistry.plugins[pluginIndex] = pluginModule;
	    var publishedEvents = pluginModule.eventTypes;
	    for (var eventName in publishedEvents) {
	      !publishEventForPlugin(publishedEvents[eventName], pluginModule, eventName) ?  false ? invariant(false, 'EventPluginRegistry: Failed to publish event `%s` for plugin `%s`.', eventName, pluginName) : _prodInvariant('98', eventName, pluginName) : void 0;
	    }
	  }
	}
	
	/**
	 * Publishes an event so that it can be dispatched by the supplied plugin.
	 *
	 * @param {object} dispatchConfig Dispatch configuration for the event.
	 * @param {object} PluginModule Plugin publishing the event.
	 * @return {boolean} True if the event was successfully published.
	 * @private
	 */
	function publishEventForPlugin(dispatchConfig, pluginModule, eventName) {
	  !!EventPluginRegistry.eventNameDispatchConfigs.hasOwnProperty(eventName) ?  false ? invariant(false, 'EventPluginHub: More than one plugin attempted to publish the same event name, `%s`.', eventName) : _prodInvariant('99', eventName) : void 0;
	  EventPluginRegistry.eventNameDispatchConfigs[eventName] = dispatchConfig;
	
	  var phasedRegistrationNames = dispatchConfig.phasedRegistrationNames;
	  if (phasedRegistrationNames) {
	    for (var phaseName in phasedRegistrationNames) {
	      if (phasedRegistrationNames.hasOwnProperty(phaseName)) {
	        var phasedRegistrationName = phasedRegistrationNames[phaseName];
	        publishRegistrationName(phasedRegistrationName, pluginModule, eventName);
	      }
	    }
	    return true;
	  } else if (dispatchConfig.registrationName) {
	    publishRegistrationName(dispatchConfig.registrationName, pluginModule, eventName);
	    return true;
	  }
	  return false;
	}
	
	/**
	 * Publishes a registration name that is used to identify dispatched events and
	 * can be used with `EventPluginHub.putListener` to register listeners.
	 *
	 * @param {string} registrationName Registration name to add.
	 * @param {object} PluginModule Plugin publishing the event.
	 * @private
	 */
	function publishRegistrationName(registrationName, pluginModule, eventName) {
	  !!EventPluginRegistry.registrationNameModules[registrationName] ?  false ? invariant(false, 'EventPluginHub: More than one plugin attempted to publish the same registration name, `%s`.', registrationName) : _prodInvariant('100', registrationName) : void 0;
	  EventPluginRegistry.registrationNameModules[registrationName] = pluginModule;
	  EventPluginRegistry.registrationNameDependencies[registrationName] = pluginModule.eventTypes[eventName].dependencies;
	
	  if (false) {
	    var lowerCasedName = registrationName.toLowerCase();
	    EventPluginRegistry.possibleRegistrationNames[lowerCasedName] = registrationName;
	
	    if (registrationName === 'onDoubleClick') {
	      EventPluginRegistry.possibleRegistrationNames.ondblclick = registrationName;
	    }
	  }
	}
	
	/**
	 * Registers plugins so that they can extract and dispatch events.
	 *
	 * @see {EventPluginHub}
	 */
	var EventPluginRegistry = {
	  /**
	   * Ordered list of injected plugins.
	   */
	  plugins: [],
	
	  /**
	   * Mapping from event name to dispatch config
	   */
	  eventNameDispatchConfigs: {},
	
	  /**
	   * Mapping from registration name to plugin module
	   */
	  registrationNameModules: {},
	
	  /**
	   * Mapping from registration name to event name
	   */
	  registrationNameDependencies: {},
	
	  /**
	   * Mapping from lowercase registration names to the properly cased version,
	   * used to warn in the case of missing event handlers. Available
	   * only in __DEV__.
	   * @type {Object}
	   */
	  possibleRegistrationNames:  false ? {} : null,
	  // Trust the developer to only use possibleRegistrationNames in __DEV__
	
	  /**
	   * Injects an ordering of plugins (by plugin name). This allows the ordering
	   * to be decoupled from injection of the actual plugins so that ordering is
	   * always deterministic regardless of packaging, on-the-fly injection, etc.
	   *
	   * @param {array} InjectedEventPluginOrder
	   * @internal
	   * @see {EventPluginHub.injection.injectEventPluginOrder}
	   */
	  injectEventPluginOrder: function (injectedEventPluginOrder) {
	    !!eventPluginOrder ?  false ? invariant(false, 'EventPluginRegistry: Cannot inject event plugin ordering more than once. You are likely trying to load more than one copy of React.') : _prodInvariant('101') : void 0;
	    // Clone the ordering so it cannot be dynamically mutated.
	    eventPluginOrder = Array.prototype.slice.call(injectedEventPluginOrder);
	    recomputePluginOrdering();
	  },
	
	  /**
	   * Injects plugins to be used by `EventPluginHub`. The plugin names must be
	   * in the ordering injected by `injectEventPluginOrder`.
	   *
	   * Plugins can be injected as part of page initialization or on-the-fly.
	   *
	   * @param {object} injectedNamesToPlugins Map from names to plugin modules.
	   * @internal
	   * @see {EventPluginHub.injection.injectEventPluginsByName}
	   */
	  injectEventPluginsByName: function (injectedNamesToPlugins) {
	    var isOrderingDirty = false;
	    for (var pluginName in injectedNamesToPlugins) {
	      if (!injectedNamesToPlugins.hasOwnProperty(pluginName)) {
	        continue;
	      }
	      var pluginModule = injectedNamesToPlugins[pluginName];
	      if (!namesToPlugins.hasOwnProperty(pluginName) || namesToPlugins[pluginName] !== pluginModule) {
	        !!namesToPlugins[pluginName] ?  false ? invariant(false, 'EventPluginRegistry: Cannot inject two different event plugins using the same name, `%s`.', pluginName) : _prodInvariant('102', pluginName) : void 0;
	        namesToPlugins[pluginName] = pluginModule;
	        isOrderingDirty = true;
	      }
	    }
	    if (isOrderingDirty) {
	      recomputePluginOrdering();
	    }
	  },
	
	  /**
	   * Looks up the plugin for the supplied event.
	   *
	   * @param {object} event A synthetic event.
	   * @return {?object} The plugin that created the supplied event.
	   * @internal
	   */
	  getPluginModuleForEvent: function (event) {
	    var dispatchConfig = event.dispatchConfig;
	    if (dispatchConfig.registrationName) {
	      return EventPluginRegistry.registrationNameModules[dispatchConfig.registrationName] || null;
	    }
	    if (dispatchConfig.phasedRegistrationNames !== undefined) {
	      // pulling phasedRegistrationNames out of dispatchConfig helps Flow see
	      // that it is not undefined.
	      var phasedRegistrationNames = dispatchConfig.phasedRegistrationNames;
	
	      for (var phase in phasedRegistrationNames) {
	        if (!phasedRegistrationNames.hasOwnProperty(phase)) {
	          continue;
	        }
	        var pluginModule = EventPluginRegistry.registrationNameModules[phasedRegistrationNames[phase]];
	        if (pluginModule) {
	          return pluginModule;
	        }
	      }
	    }
	    return null;
	  },
	
	  /**
	   * Exposed for unit testing.
	   * @private
	   */
	  _resetEventPlugins: function () {
	    eventPluginOrder = null;
	    for (var pluginName in namesToPlugins) {
	      if (namesToPlugins.hasOwnProperty(pluginName)) {
	        delete namesToPlugins[pluginName];
	      }
	    }
	    EventPluginRegistry.plugins.length = 0;
	
	    var eventNameDispatchConfigs = EventPluginRegistry.eventNameDispatchConfigs;
	    for (var eventName in eventNameDispatchConfigs) {
	      if (eventNameDispatchConfigs.hasOwnProperty(eventName)) {
	        delete eventNameDispatchConfigs[eventName];
	      }
	    }
	
	    var registrationNameModules = EventPluginRegistry.registrationNameModules;
	    for (var registrationName in registrationNameModules) {
	      if (registrationNameModules.hasOwnProperty(registrationName)) {
	        delete registrationNameModules[registrationName];
	      }
	    }
	
	    if (false) {
	      var possibleRegistrationNames = EventPluginRegistry.possibleRegistrationNames;
	      for (var lowerCasedName in possibleRegistrationNames) {
	        if (possibleRegistrationNames.hasOwnProperty(lowerCasedName)) {
	          delete possibleRegistrationNames[lowerCasedName];
	        }
	      }
	    }
	  }
	};
	
	module.exports = EventPluginRegistry;

/***/ },
/* 251 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(29);
	
	var ReactErrorUtils = __webpack_require__(255);
	
	var invariant = __webpack_require__(21);
	var warning = __webpack_require__(30);
	
	/**
	 * Injected dependencies:
	 */
	
	/**
	 * - `ComponentTree`: [required] Module that can convert between React instances
	 *   and actual node references.
	 */
	var ComponentTree;
	var TreeTraversal;
	var injection = {
	  injectComponentTree: function (Injected) {
	    ComponentTree = Injected;
	    if (false) {
	      process.env.NODE_ENV !== 'production' ? warning(Injected && Injected.getNodeFromInstance && Injected.getInstanceFromNode, 'EventPluginUtils.injection.injectComponentTree(...): Injected ' + 'module is missing getNodeFromInstance or getInstanceFromNode.') : void 0;
	    }
	  },
	  injectTreeTraversal: function (Injected) {
	    TreeTraversal = Injected;
	    if (false) {
	      process.env.NODE_ENV !== 'production' ? warning(Injected && Injected.isAncestor && Injected.getLowestCommonAncestor, 'EventPluginUtils.injection.injectTreeTraversal(...): Injected ' + 'module is missing isAncestor or getLowestCommonAncestor.') : void 0;
	    }
	  }
	};
	
	function isEndish(topLevelType) {
	  return topLevelType === 'topMouseUp' || topLevelType === 'topTouchEnd' || topLevelType === 'topTouchCancel';
	}
	
	function isMoveish(topLevelType) {
	  return topLevelType === 'topMouseMove' || topLevelType === 'topTouchMove';
	}
	function isStartish(topLevelType) {
	  return topLevelType === 'topMouseDown' || topLevelType === 'topTouchStart';
	}
	
	var validateEventDispatches;
	if (false) {
	  validateEventDispatches = function (event) {
	    var dispatchListeners = event._dispatchListeners;
	    var dispatchInstances = event._dispatchInstances;
	
	    var listenersIsArr = Array.isArray(dispatchListeners);
	    var listenersLen = listenersIsArr ? dispatchListeners.length : dispatchListeners ? 1 : 0;
	
	    var instancesIsArr = Array.isArray(dispatchInstances);
	    var instancesLen = instancesIsArr ? dispatchInstances.length : dispatchInstances ? 1 : 0;
	
	    process.env.NODE_ENV !== 'production' ? warning(instancesIsArr === listenersIsArr && instancesLen === listenersLen, 'EventPluginUtils: Invalid `event`.') : void 0;
	  };
	}
	
	/**
	 * Dispatch the event to the listener.
	 * @param {SyntheticEvent} event SyntheticEvent to handle
	 * @param {boolean} simulated If the event is simulated (changes exn behavior)
	 * @param {function} listener Application-level callback
	 * @param {*} inst Internal component instance
	 */
	function executeDispatch(event, simulated, listener, inst) {
	  var type = event.type || 'unknown-event';
	  event.currentTarget = EventPluginUtils.getNodeFromInstance(inst);
	  if (simulated) {
	    ReactErrorUtils.invokeGuardedCallbackWithCatch(type, listener, event);
	  } else {
	    ReactErrorUtils.invokeGuardedCallback(type, listener, event);
	  }
	  event.currentTarget = null;
	}
	
	/**
	 * Standard/simple iteration through an event's collected dispatches.
	 */
	function executeDispatchesInOrder(event, simulated) {
	  var dispatchListeners = event._dispatchListeners;
	  var dispatchInstances = event._dispatchInstances;
	  if (false) {
	    validateEventDispatches(event);
	  }
	  if (Array.isArray(dispatchListeners)) {
	    for (var i = 0; i < dispatchListeners.length; i++) {
	      if (event.isPropagationStopped()) {
	        break;
	      }
	      // Listeners and Instances are two parallel arrays that are always in sync.
	      executeDispatch(event, simulated, dispatchListeners[i], dispatchInstances[i]);
	    }
	  } else if (dispatchListeners) {
	    executeDispatch(event, simulated, dispatchListeners, dispatchInstances);
	  }
	  event._dispatchListeners = null;
	  event._dispatchInstances = null;
	}
	
	/**
	 * Standard/simple iteration through an event's collected dispatches, but stops
	 * at the first dispatch execution returning true, and returns that id.
	 *
	 * @return {?string} id of the first dispatch execution who's listener returns
	 * true, or null if no listener returned true.
	 */
	function executeDispatchesInOrderStopAtTrueImpl(event) {
	  var dispatchListeners = event._dispatchListeners;
	  var dispatchInstances = event._dispatchInstances;
	  if (false) {
	    validateEventDispatches(event);
	  }
	  if (Array.isArray(dispatchListeners)) {
	    for (var i = 0; i < dispatchListeners.length; i++) {
	      if (event.isPropagationStopped()) {
	        break;
	      }
	      // Listeners and Instances are two parallel arrays that are always in sync.
	      if (dispatchListeners[i](event, dispatchInstances[i])) {
	        return dispatchInstances[i];
	      }
	    }
	  } else if (dispatchListeners) {
	    if (dispatchListeners(event, dispatchInstances)) {
	      return dispatchInstances;
	    }
	  }
	  return null;
	}
	
	/**
	 * @see executeDispatchesInOrderStopAtTrueImpl
	 */
	function executeDispatchesInOrderStopAtTrue(event) {
	  var ret = executeDispatchesInOrderStopAtTrueImpl(event);
	  event._dispatchInstances = null;
	  event._dispatchListeners = null;
	  return ret;
	}
	
	/**
	 * Execution of a "direct" dispatch - there must be at most one dispatch
	 * accumulated on the event or it is considered an error. It doesn't really make
	 * sense for an event with multiple dispatches (bubbled) to keep track of the
	 * return values at each dispatch execution, but it does tend to make sense when
	 * dealing with "direct" dispatches.
	 *
	 * @return {*} The return value of executing the single dispatch.
	 */
	function executeDirectDispatch(event) {
	  if (false) {
	    validateEventDispatches(event);
	  }
	  var dispatchListener = event._dispatchListeners;
	  var dispatchInstance = event._dispatchInstances;
	  !!Array.isArray(dispatchListener) ?  false ? invariant(false, 'executeDirectDispatch(...): Invalid `event`.') : _prodInvariant('103') : void 0;
	  event.currentTarget = dispatchListener ? EventPluginUtils.getNodeFromInstance(dispatchInstance) : null;
	  var res = dispatchListener ? dispatchListener(event) : null;
	  event.currentTarget = null;
	  event._dispatchListeners = null;
	  event._dispatchInstances = null;
	  return res;
	}
	
	/**
	 * @param {SyntheticEvent} event
	 * @return {boolean} True iff number of dispatches accumulated is greater than 0.
	 */
	function hasDispatches(event) {
	  return !!event._dispatchListeners;
	}
	
	/**
	 * General utilities that are useful in creating custom Event Plugins.
	 */
	var EventPluginUtils = {
	  isEndish: isEndish,
	  isMoveish: isMoveish,
	  isStartish: isStartish,
	
	  executeDirectDispatch: executeDirectDispatch,
	  executeDispatchesInOrder: executeDispatchesInOrder,
	  executeDispatchesInOrderStopAtTrue: executeDispatchesInOrderStopAtTrue,
	  hasDispatches: hasDispatches,
	
	  getInstanceFromNode: function (node) {
	    return ComponentTree.getInstanceFromNode(node);
	  },
	  getNodeFromInstance: function (node) {
	    return ComponentTree.getNodeFromInstance(node);
	  },
	  isAncestor: function (a, b) {
	    return TreeTraversal.isAncestor(a, b);
	  },
	  getLowestCommonAncestor: function (a, b) {
	    return TreeTraversal.getLowestCommonAncestor(a, b);
	  },
	  getParentInstance: function (inst) {
	    return TreeTraversal.getParentInstance(inst);
	  },
	  traverseTwoPhase: function (target, fn, arg) {
	    return TreeTraversal.traverseTwoPhase(target, fn, arg);
	  },
	  traverseEnterLeave: function (from, to, fn, argFrom, argTo) {
	    return TreeTraversal.traverseEnterLeave(from, to, fn, argFrom, argTo);
	  },
	
	  injection: injection
	};
	
	module.exports = EventPluginUtils;

/***/ },
/* 252 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	/**
	 * Escape and wrap key so it is safe to use as a reactid
	 *
	 * @param {string} key to be escaped.
	 * @return {string} the escaped key.
	 */
	
	function escape(key) {
	  var escapeRegex = /[=:]/g;
	  var escaperLookup = {
	    '=': '=0',
	    ':': '=2'
	  };
	  var escapedString = ('' + key).replace(escapeRegex, function (match) {
	    return escaperLookup[match];
	  });
	
	  return '$' + escapedString;
	}
	
	/**
	 * Unescape and unwrap key for human-readable display
	 *
	 * @param {string} key to unescape.
	 * @return {string} the unescaped key.
	 */
	function unescape(key) {
	  var unescapeRegex = /(=0|=2)/g;
	  var unescaperLookup = {
	    '=0': '=',
	    '=2': ':'
	  };
	  var keySubstring = key[0] === '.' && key[1] === '$' ? key.substring(2) : key.substring(1);
	
	  return ('' + keySubstring).replace(unescapeRegex, function (match) {
	    return unescaperLookup[match];
	  });
	}
	
	var KeyEscapeUtils = {
	  escape: escape,
	  unescape: unescape
	};
	
	module.exports = KeyEscapeUtils;

/***/ },
/* 253 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(29);
	
	var ReactPropTypesSecret = __webpack_require__(997);
	var propTypesFactory = __webpack_require__(378);
	
	var React = __webpack_require__(115);
	var PropTypes = propTypesFactory(React.isValidElement);
	
	var invariant = __webpack_require__(21);
	var warning = __webpack_require__(30);
	
	var hasReadOnlyValue = {
	  button: true,
	  checkbox: true,
	  image: true,
	  hidden: true,
	  radio: true,
	  reset: true,
	  submit: true
	};
	
	function _assertSingleLink(inputProps) {
	  !(inputProps.checkedLink == null || inputProps.valueLink == null) ?  false ? invariant(false, 'Cannot provide a checkedLink and a valueLink. If you want to use checkedLink, you probably don\'t want to use valueLink and vice versa.') : _prodInvariant('87') : void 0;
	}
	function _assertValueLink(inputProps) {
	  _assertSingleLink(inputProps);
	  !(inputProps.value == null && inputProps.onChange == null) ?  false ? invariant(false, 'Cannot provide a valueLink and a value or onChange event. If you want to use value or onChange, you probably don\'t want to use valueLink.') : _prodInvariant('88') : void 0;
	}
	
	function _assertCheckedLink(inputProps) {
	  _assertSingleLink(inputProps);
	  !(inputProps.checked == null && inputProps.onChange == null) ?  false ? invariant(false, 'Cannot provide a checkedLink and a checked property or onChange event. If you want to use checked or onChange, you probably don\'t want to use checkedLink') : _prodInvariant('89') : void 0;
	}
	
	var propTypes = {
	  value: function (props, propName, componentName) {
	    if (!props[propName] || hasReadOnlyValue[props.type] || props.onChange || props.readOnly || props.disabled) {
	      return null;
	    }
	    return new Error('You provided a `value` prop to a form field without an ' + '`onChange` handler. This will render a read-only field. If ' + 'the field should be mutable use `defaultValue`. Otherwise, ' + 'set either `onChange` or `readOnly`.');
	  },
	  checked: function (props, propName, componentName) {
	    if (!props[propName] || props.onChange || props.readOnly || props.disabled) {
	      return null;
	    }
	    return new Error('You provided a `checked` prop to a form field without an ' + '`onChange` handler. This will render a read-only field. If ' + 'the field should be mutable use `defaultChecked`. Otherwise, ' + 'set either `onChange` or `readOnly`.');
	  },
	  onChange: PropTypes.func
	};
	
	var loggedTypeFailures = {};
	function getDeclarationErrorAddendum(owner) {
	  if (owner) {
	    var name = owner.getName();
	    if (name) {
	      return ' Check the render method of `' + name + '`.';
	    }
	  }
	  return '';
	}
	
	/**
	 * Provide a linked `value` attribute for controlled forms. You should not use
	 * this outside of the ReactDOM controlled form components.
	 */
	var LinkedValueUtils = {
	  checkPropTypes: function (tagName, props, owner) {
	    for (var propName in propTypes) {
	      if (propTypes.hasOwnProperty(propName)) {
	        var error = propTypes[propName](props, propName, tagName, 'prop', null, ReactPropTypesSecret);
	      }
	      if (error instanceof Error && !(error.message in loggedTypeFailures)) {
	        // Only monitor this failure once because there tends to be a lot of the
	        // same error.
	        loggedTypeFailures[error.message] = true;
	
	        var addendum = getDeclarationErrorAddendum(owner);
	         false ? warning(false, 'Failed form propType: %s%s', error.message, addendum) : void 0;
	      }
	    }
	  },
	
	  /**
	   * @param {object} inputProps Props for form component
	   * @return {*} current value of the input either from value prop or link.
	   */
	  getValue: function (inputProps) {
	    if (inputProps.valueLink) {
	      _assertValueLink(inputProps);
	      return inputProps.valueLink.value;
	    }
	    return inputProps.value;
	  },
	
	  /**
	   * @param {object} inputProps Props for form component
	   * @return {*} current checked status of the input either from checked prop
	   *             or link.
	   */
	  getChecked: function (inputProps) {
	    if (inputProps.checkedLink) {
	      _assertCheckedLink(inputProps);
	      return inputProps.checkedLink.value;
	    }
	    return inputProps.checked;
	  },
	
	  /**
	   * @param {object} inputProps Props for form component
	   * @param {SyntheticEvent} event change event to handle
	   */
	  executeOnChange: function (inputProps, event) {
	    if (inputProps.valueLink) {
	      _assertValueLink(inputProps);
	      return inputProps.valueLink.requestChange(event.target.value);
	    } else if (inputProps.checkedLink) {
	      _assertCheckedLink(inputProps);
	      return inputProps.checkedLink.requestChange(event.target.checked);
	    } else if (inputProps.onChange) {
	      return inputProps.onChange.call(undefined, event);
	    }
	  }
	};
	
	module.exports = LinkedValueUtils;

/***/ },
/* 254 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2014-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(29);
	
	var invariant = __webpack_require__(21);
	
	var injected = false;
	
	var ReactComponentEnvironment = {
	  /**
	   * Optionally injectable hook for swapping out mount images in the middle of
	   * the tree.
	   */
	  replaceNodeWithMarkup: null,
	
	  /**
	   * Optionally injectable hook for processing a queue of child updates. Will
	   * later move into MultiChildComponents.
	   */
	  processChildrenUpdates: null,
	
	  injection: {
	    injectEnvironment: function (environment) {
	      !!injected ?  false ? invariant(false, 'ReactCompositeComponent: injectEnvironment() can only be called once.') : _prodInvariant('104') : void 0;
	      ReactComponentEnvironment.replaceNodeWithMarkup = environment.replaceNodeWithMarkup;
	      ReactComponentEnvironment.processChildrenUpdates = environment.processChildrenUpdates;
	      injected = true;
	    }
	  }
	};
	
	module.exports = ReactComponentEnvironment;

/***/ },
/* 255 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var caughtError = null;
	
	/**
	 * Call a function while guarding against errors that happens within it.
	 *
	 * @param {String} name of the guard to use for logging or debugging
	 * @param {Function} func The function to invoke
	 * @param {*} a First argument
	 * @param {*} b Second argument
	 */
	function invokeGuardedCallback(name, func, a) {
	  try {
	    func(a);
	  } catch (x) {
	    if (caughtError === null) {
	      caughtError = x;
	    }
	  }
	}
	
	var ReactErrorUtils = {
	  invokeGuardedCallback: invokeGuardedCallback,
	
	  /**
	   * Invoked by ReactTestUtils.Simulate so that any errors thrown by the event
	   * handler are sure to be rethrown by rethrowCaughtError.
	   */
	  invokeGuardedCallbackWithCatch: invokeGuardedCallback,
	
	  /**
	   * During execution of guarded functions we will capture the first error which
	   * we will rethrow to be handled by the top level error handler.
	   */
	  rethrowCaughtError: function () {
	    if (caughtError) {
	      var error = caughtError;
	      caughtError = null;
	      throw error;
	    }
	  }
	};
	
	if (false) {
	  /**
	   * To help development we can get better devtools integration by simulating a
	   * real browser event.
	   */
	  if (typeof window !== 'undefined' && typeof window.dispatchEvent === 'function' && typeof document !== 'undefined' && typeof document.createEvent === 'function') {
	    var fakeNode = document.createElement('react');
	    ReactErrorUtils.invokeGuardedCallback = function (name, func, a) {
	      var boundFunc = function () {
	        func(a);
	      };
	      var evtType = 'react-' + name;
	      fakeNode.addEventListener(evtType, boundFunc, false);
	      var evt = document.createEvent('Event');
	      evt.initEvent(evtType, false, false);
	      fakeNode.dispatchEvent(evt);
	      fakeNode.removeEventListener(evtType, boundFunc, false);
	    };
	  }
	}
	
	module.exports = ReactErrorUtils;

/***/ },
/* 256 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2015-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(29);
	
	var ReactCurrentOwner = __webpack_require__(92);
	var ReactInstanceMap = __webpack_require__(146);
	var ReactInstrumentation = __webpack_require__(62);
	var ReactUpdates = __webpack_require__(74);
	
	var invariant = __webpack_require__(21);
	var warning = __webpack_require__(30);
	
	function enqueueUpdate(internalInstance) {
	  ReactUpdates.enqueueUpdate(internalInstance);
	}
	
	function formatUnexpectedArgument(arg) {
	  var type = typeof arg;
	  if (type !== 'object') {
	    return type;
	  }
	  var displayName = arg.constructor && arg.constructor.name || type;
	  var keys = Object.keys(arg);
	  if (keys.length > 0 && keys.length < 20) {
	    return displayName + ' (keys: ' + keys.join(', ') + ')';
	  }
	  return displayName;
	}
	
	function getInternalInstanceReadyForUpdate(publicInstance, callerName) {
	  var internalInstance = ReactInstanceMap.get(publicInstance);
	  if (!internalInstance) {
	    if (false) {
	      var ctor = publicInstance.constructor;
	      // Only warn when we have a callerName. Otherwise we should be silent.
	      // We're probably calling from enqueueCallback. We don't want to warn
	      // there because we already warned for the corresponding lifecycle method.
	      process.env.NODE_ENV !== 'production' ? warning(!callerName, '%s(...): Can only update a mounted or mounting component. ' + 'This usually means you called %s() on an unmounted component. ' + 'This is a no-op. Please check the code for the %s component.', callerName, callerName, ctor && (ctor.displayName || ctor.name) || 'ReactClass') : void 0;
	    }
	    return null;
	  }
	
	  if (false) {
	    process.env.NODE_ENV !== 'production' ? warning(ReactCurrentOwner.current == null, '%s(...): Cannot update during an existing state transition (such as ' + "within `render` or another component's constructor). Render methods " + 'should be a pure function of props and state; constructor ' + 'side-effects are an anti-pattern, but can be moved to ' + '`componentWillMount`.', callerName) : void 0;
	  }
	
	  return internalInstance;
	}
	
	/**
	 * ReactUpdateQueue allows for state updates to be scheduled into a later
	 * reconciliation step.
	 */
	var ReactUpdateQueue = {
	  /**
	   * Checks whether or not this composite component is mounted.
	   * @param {ReactClass} publicInstance The instance we want to test.
	   * @return {boolean} True if mounted, false otherwise.
	   * @protected
	   * @final
	   */
	  isMounted: function (publicInstance) {
	    if (false) {
	      var owner = ReactCurrentOwner.current;
	      if (owner !== null) {
	        process.env.NODE_ENV !== 'production' ? warning(owner._warnedAboutRefsInRender, '%s is accessing isMounted inside its render() function. ' + 'render() should be a pure function of props and state. It should ' + 'never access something that requires stale data from the previous ' + 'render, such as refs. Move this logic to componentDidMount and ' + 'componentDidUpdate instead.', owner.getName() || 'A component') : void 0;
	        owner._warnedAboutRefsInRender = true;
	      }
	    }
	    var internalInstance = ReactInstanceMap.get(publicInstance);
	    if (internalInstance) {
	      // During componentWillMount and render this will still be null but after
	      // that will always render to something. At least for now. So we can use
	      // this hack.
	      return !!internalInstance._renderedComponent;
	    } else {
	      return false;
	    }
	  },
	
	  /**
	   * Enqueue a callback that will be executed after all the pending updates
	   * have processed.
	   *
	   * @param {ReactClass} publicInstance The instance to use as `this` context.
	   * @param {?function} callback Called after state is updated.
	   * @param {string} callerName Name of the calling function in the public API.
	   * @internal
	   */
	  enqueueCallback: function (publicInstance, callback, callerName) {
	    ReactUpdateQueue.validateCallback(callback, callerName);
	    var internalInstance = getInternalInstanceReadyForUpdate(publicInstance);
	
	    // Previously we would throw an error if we didn't have an internal
	    // instance. Since we want to make it a no-op instead, we mirror the same
	    // behavior we have in other enqueue* methods.
	    // We also need to ignore callbacks in componentWillMount. See
	    // enqueueUpdates.
	    if (!internalInstance) {
	      return null;
	    }
	
	    if (internalInstance._pendingCallbacks) {
	      internalInstance._pendingCallbacks.push(callback);
	    } else {
	      internalInstance._pendingCallbacks = [callback];
	    }
	    // TODO: The callback here is ignored when setState is called from
	    // componentWillMount. Either fix it or disallow doing so completely in
	    // favor of getInitialState. Alternatively, we can disallow
	    // componentWillMount during server-side rendering.
	    enqueueUpdate(internalInstance);
	  },
	
	  enqueueCallbackInternal: function (internalInstance, callback) {
	    if (internalInstance._pendingCallbacks) {
	      internalInstance._pendingCallbacks.push(callback);
	    } else {
	      internalInstance._pendingCallbacks = [callback];
	    }
	    enqueueUpdate(internalInstance);
	  },
	
	  /**
	   * Forces an update. This should only be invoked when it is known with
	   * certainty that we are **not** in a DOM transaction.
	   *
	   * You may want to call this when you know that some deeper aspect of the
	   * component's state has changed but `setState` was not called.
	   *
	   * This will not invoke `shouldComponentUpdate`, but it will invoke
	   * `componentWillUpdate` and `componentDidUpdate`.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @internal
	   */
	  enqueueForceUpdate: function (publicInstance) {
	    var internalInstance = getInternalInstanceReadyForUpdate(publicInstance, 'forceUpdate');
	
	    if (!internalInstance) {
	      return;
	    }
	
	    internalInstance._pendingForceUpdate = true;
	
	    enqueueUpdate(internalInstance);
	  },
	
	  /**
	   * Replaces all of the state. Always use this or `setState` to mutate state.
	   * You should treat `this.state` as immutable.
	   *
	   * There is no guarantee that `this.state` will be immediately updated, so
	   * accessing `this.state` after calling this method may return the old value.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @param {object} completeState Next state.
	   * @internal
	   */
	  enqueueReplaceState: function (publicInstance, completeState, callback) {
	    var internalInstance = getInternalInstanceReadyForUpdate(publicInstance, 'replaceState');
	
	    if (!internalInstance) {
	      return;
	    }
	
	    internalInstance._pendingStateQueue = [completeState];
	    internalInstance._pendingReplaceState = true;
	
	    // Future-proof 15.5
	    if (callback !== undefined && callback !== null) {
	      ReactUpdateQueue.validateCallback(callback, 'replaceState');
	      if (internalInstance._pendingCallbacks) {
	        internalInstance._pendingCallbacks.push(callback);
	      } else {
	        internalInstance._pendingCallbacks = [callback];
	      }
	    }
	
	    enqueueUpdate(internalInstance);
	  },
	
	  /**
	   * Sets a subset of the state. This only exists because _pendingState is
	   * internal. This provides a merging strategy that is not available to deep
	   * properties which is confusing. TODO: Expose pendingState or don't use it
	   * during the merge.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @param {object} partialState Next partial state to be merged with state.
	   * @internal
	   */
	  enqueueSetState: function (publicInstance, partialState) {
	    if (false) {
	      ReactInstrumentation.debugTool.onSetState();
	      process.env.NODE_ENV !== 'production' ? warning(partialState != null, 'setState(...): You passed an undefined or null state object; ' + 'instead, use forceUpdate().') : void 0;
	    }
	
	    var internalInstance = getInternalInstanceReadyForUpdate(publicInstance, 'setState');
	
	    if (!internalInstance) {
	      return;
	    }
	
	    var queue = internalInstance._pendingStateQueue || (internalInstance._pendingStateQueue = []);
	    queue.push(partialState);
	
	    enqueueUpdate(internalInstance);
	  },
	
	  enqueueElementInternal: function (internalInstance, nextElement, nextContext) {
	    internalInstance._pendingElement = nextElement;
	    // TODO: introduce _pendingContext instead of setting it directly.
	    internalInstance._context = nextContext;
	    enqueueUpdate(internalInstance);
	  },
	
	  validateCallback: function (callback, callerName) {
	    !(!callback || typeof callback === 'function') ?  false ? invariant(false, '%s(...): Expected the last optional `callback` argument to be a function. Instead received: %s.', callerName, formatUnexpectedArgument(callback)) : _prodInvariant('122', callerName, formatUnexpectedArgument(callback)) : void 0;
	  }
	};
	
	module.exports = ReactUpdateQueue;

/***/ },
/* 257 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	/* globals MSApp */
	
	'use strict';
	
	/**
	 * Create a function which has 'unsafe' privileges (required by windows8 apps)
	 */
	
	var createMicrosoftUnsafeLocalFunction = function (func) {
	  if (typeof MSApp !== 'undefined' && MSApp.execUnsafeLocalFunction) {
	    return function (arg0, arg1, arg2, arg3) {
	      MSApp.execUnsafeLocalFunction(function () {
	        return func(arg0, arg1, arg2, arg3);
	      });
	    };
	  } else {
	    return func;
	  }
	};
	
	module.exports = createMicrosoftUnsafeLocalFunction;

/***/ },
/* 258 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	/**
	 * `charCode` represents the actual "character code" and is safe to use with
	 * `String.fromCharCode`. As such, only keys that correspond to printable
	 * characters produce a valid `charCode`, the only exception to this is Enter.
	 * The Tab-key is considered non-printable and does not have a `charCode`,
	 * presumably because it does not produce a tab-character in browsers.
	 *
	 * @param {object} nativeEvent Native browser event.
	 * @return {number} Normalized `charCode` property.
	 */
	
	function getEventCharCode(nativeEvent) {
	  var charCode;
	  var keyCode = nativeEvent.keyCode;
	
	  if ('charCode' in nativeEvent) {
	    charCode = nativeEvent.charCode;
	
	    // FF does not set `charCode` for the Enter-key, check against `keyCode`.
	    if (charCode === 0 && keyCode === 13) {
	      charCode = 13;
	    }
	  } else {
	    // IE8 does not implement `charCode`, but `keyCode` has the correct value.
	    charCode = keyCode;
	  }
	
	  // Some non-printable keys are reported in `charCode`/`keyCode`, discard them.
	  // Must not discard the (non-)printable Enter-key.
	  if (charCode >= 32 || charCode === 13) {
	    return charCode;
	  }
	
	  return 0;
	}
	
	module.exports = getEventCharCode;

/***/ },
/* 259 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	/**
	 * Translation from modifier key to the associated property in the event.
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/#keys-Modifiers
	 */
	
	var modifierKeyToProp = {
	  Alt: 'altKey',
	  Control: 'ctrlKey',
	  Meta: 'metaKey',
	  Shift: 'shiftKey'
	};
	
	// IE8 does not implement getModifierState so we simply map it to the only
	// modifier keys exposed by the event itself, does not support Lock-keys.
	// Currently, all major browsers except Chrome seems to support Lock-keys.
	function modifierStateGetter(keyArg) {
	  var syntheticEvent = this;
	  var nativeEvent = syntheticEvent.nativeEvent;
	  if (nativeEvent.getModifierState) {
	    return nativeEvent.getModifierState(keyArg);
	  }
	  var keyProp = modifierKeyToProp[keyArg];
	  return keyProp ? !!nativeEvent[keyProp] : false;
	}
	
	function getEventModifierState(nativeEvent) {
	  return modifierStateGetter;
	}
	
	module.exports = getEventModifierState;

/***/ },
/* 260 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	/**
	 * Gets the target node from a native browser event by accounting for
	 * inconsistencies in browser DOM APIs.
	 *
	 * @param {object} nativeEvent Native browser event.
	 * @return {DOMEventTarget} Target node.
	 */
	
	function getEventTarget(nativeEvent) {
	  var target = nativeEvent.target || nativeEvent.srcElement || window;
	
	  // Normalize SVG <use> element events #4963
	  if (target.correspondingUseElement) {
	    target = target.correspondingUseElement;
	  }
	
	  // Safari may fire events on text nodes (Node.TEXT_NODE is 3).
	  // @see http://www.quirksmode.org/js/events_properties.html
	  return target.nodeType === 3 ? target.parentNode : target;
	}
	
	module.exports = getEventTarget;

/***/ },
/* 261 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(29),
	    _assign = __webpack_require__(36);
	
	var ReactCompositeComponent = __webpack_require__(978);
	var ReactEmptyComponent = __webpack_require__(390);
	var ReactHostComponent = __webpack_require__(392);
	
	var getNextDebugID = __webpack_require__(1070);
	var invariant = __webpack_require__(21);
	var warning = __webpack_require__(30);
	
	// To avoid a cyclic dependency, we create the final class in this module
	var ReactCompositeComponentWrapper = function (element) {
	  this.construct(element);
	};
	
	function getDeclarationErrorAddendum(owner) {
	  if (owner) {
	    var name = owner.getName();
	    if (name) {
	      return ' Check the render method of `' + name + '`.';
	    }
	  }
	  return '';
	}
	
	/**
	 * Check if the type reference is a known internal type. I.e. not a user
	 * provided composite type.
	 *
	 * @param {function} type
	 * @return {boolean} Returns true if this is a valid internal type.
	 */
	function isInternalComponentType(type) {
	  return typeof type === 'function' && typeof type.prototype !== 'undefined' && typeof type.prototype.mountComponent === 'function' && typeof type.prototype.receiveComponent === 'function';
	}
	
	/**
	 * Given a ReactNode, create an instance that will actually be mounted.
	 *
	 * @param {ReactNode} node
	 * @param {boolean} shouldHaveDebugID
	 * @return {object} A new instance of the element's constructor.
	 * @protected
	 */
	function instantiateReactComponent(node, shouldHaveDebugID) {
	  var instance;
	
	  if (node === null || node === false) {
	    instance = ReactEmptyComponent.create(instantiateReactComponent);
	  } else if (typeof node === 'object') {
	    var element = node;
	    var type = element.type;
	    if (typeof type !== 'function' && typeof type !== 'string') {
	      var info = '';
	      if (false) {
	        if (type === undefined || typeof type === 'object' && type !== null && Object.keys(type).length === 0) {
	          info += ' You likely forgot to export your component from the file ' + "it's defined in.";
	        }
	      }
	      info += getDeclarationErrorAddendum(element._owner);
	       true ?  false ? invariant(false, 'Element type is invalid: expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s', type == null ? type : typeof type, info) : _prodInvariant('130', type == null ? type : typeof type, info) : void 0;
	    }
	
	    // Special case string values
	    if (typeof element.type === 'string') {
	      instance = ReactHostComponent.createInternalComponent(element);
	    } else if (isInternalComponentType(element.type)) {
	      // This is temporarily available for custom components that are not string
	      // representations. I.e. ART. Once those are updated to use the string
	      // representation, we can drop this code path.
	      instance = new element.type(element);
	
	      // We renamed this. Allow the old name for compat. :(
	      if (!instance.getHostNode) {
	        instance.getHostNode = instance.getNativeNode;
	      }
	    } else {
	      instance = new ReactCompositeComponentWrapper(element);
	    }
	  } else if (typeof node === 'string' || typeof node === 'number') {
	    instance = ReactHostComponent.createInstanceForText(node);
	  } else {
	     true ?  false ? invariant(false, 'Encountered invalid React node of type %s', typeof node) : _prodInvariant('131', typeof node) : void 0;
	  }
	
	  if (false) {
	    process.env.NODE_ENV !== 'production' ? warning(typeof instance.mountComponent === 'function' && typeof instance.receiveComponent === 'function' && typeof instance.getHostNode === 'function' && typeof instance.unmountComponent === 'function', 'Only React Components can be mounted.') : void 0;
	  }
	
	  // These two fields are used by the DOM and ART diffing algorithms
	  // respectively. Instead of using expandos on components, we should be
	  // storing the state needed by the diffing algorithms elsewhere.
	  instance._mountIndex = 0;
	  instance._mountImage = null;
	
	  if (false) {
	    instance._debugID = shouldHaveDebugID ? getNextDebugID() : 0;
	  }
	
	  // Internal instances should fully constructed at this point, so they should
	  // not get any new fields added to them at this point.
	  if (false) {
	    if (Object.preventExtensions) {
	      Object.preventExtensions(instance);
	    }
	  }
	
	  return instance;
	}
	
	_assign(ReactCompositeComponentWrapper.prototype, ReactCompositeComponent, {
	  _instantiateReactComponent: instantiateReactComponent
	});
	
	module.exports = instantiateReactComponent;

/***/ },
/* 262 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ExecutionEnvironment = __webpack_require__(51);
	
	var useHasFeature;
	if (ExecutionEnvironment.canUseDOM) {
	  useHasFeature = document.implementation && document.implementation.hasFeature &&
	  // always returns true in newer browsers as per the standard.
	  // @see http://dom.spec.whatwg.org/#dom-domimplementation-hasfeature
	  document.implementation.hasFeature('', '') !== true;
	}
	
	/**
	 * Checks if an event is supported in the current execution environment.
	 *
	 * NOTE: This will not work correctly for non-generic events such as `change`,
	 * `reset`, `load`, `error`, and `select`.
	 *
	 * Borrows from Modernizr.
	 *
	 * @param {string} eventNameSuffix Event name, e.g. "click".
	 * @param {?boolean} capture Check if the capture phase is supported.
	 * @return {boolean} True if the event is supported.
	 * @internal
	 * @license Modernizr 3.0.0pre (Custom Build) | MIT
	 */
	function isEventSupported(eventNameSuffix, capture) {
	  if (!ExecutionEnvironment.canUseDOM || capture && !('addEventListener' in document)) {
	    return false;
	  }
	
	  var eventName = 'on' + eventNameSuffix;
	  var isSupported = eventName in document;
	
	  if (!isSupported) {
	    var element = document.createElement('div');
	    element.setAttribute(eventName, 'return;');
	    isSupported = typeof element[eventName] === 'function';
	  }
	
	  if (!isSupported && useHasFeature && eventNameSuffix === 'wheel') {
	    // This is the only way to test support for the `wheel` event in IE9+.
	    isSupported = document.implementation.hasFeature('Events.wheel', '3.0');
	  }
	
	  return isSupported;
	}
	
	module.exports = isEventSupported;

/***/ },
/* 263 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	/**
	 * Given a `prevElement` and `nextElement`, determines if the existing
	 * instance should be updated as opposed to being destroyed or replaced by a new
	 * instance. Both arguments are elements. This ensures that this logic can
	 * operate on stateless trees without any backing instance.
	 *
	 * @param {?object} prevElement
	 * @param {?object} nextElement
	 * @return {boolean} True if the existing instance should be updated.
	 * @protected
	 */
	
	function shouldUpdateReactComponent(prevElement, nextElement) {
	  var prevEmpty = prevElement === null || prevElement === false;
	  var nextEmpty = nextElement === null || nextElement === false;
	  if (prevEmpty || nextEmpty) {
	    return prevEmpty === nextEmpty;
	  }
	
	  var prevType = typeof prevElement;
	  var nextType = typeof nextElement;
	  if (prevType === 'string' || prevType === 'number') {
	    return nextType === 'string' || nextType === 'number';
	  } else {
	    return nextType === 'object' && prevElement.type === nextElement.type && prevElement.key === nextElement.key;
	  }
	}
	
	module.exports = shouldUpdateReactComponent;

/***/ },
/* 264 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2015-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(36);
	
	var emptyFunction = __webpack_require__(80);
	var warning = __webpack_require__(30);
	
	var validateDOMNesting = emptyFunction;
	
	if (false) {
	  // This validation code was written based on the HTML5 parsing spec:
	  // https://html.spec.whatwg.org/multipage/syntax.html#has-an-element-in-scope
	  //
	  // Note: this does not catch all invalid nesting, nor does it try to (as it's
	  // not clear what practical benefit doing so provides); instead, we warn only
	  // for cases where the parser will give a parse tree differing from what React
	  // intended. For example, <b><div></div></b> is invalid but we don't warn
	  // because it still parses correctly; we do warn for other cases like nested
	  // <p> tags where the beginning of the second element implicitly closes the
	  // first, causing a confusing mess.
	
	  // https://html.spec.whatwg.org/multipage/syntax.html#special
	  var specialTags = ['address', 'applet', 'area', 'article', 'aside', 'base', 'basefont', 'bgsound', 'blockquote', 'body', 'br', 'button', 'caption', 'center', 'col', 'colgroup', 'dd', 'details', 'dir', 'div', 'dl', 'dt', 'embed', 'fieldset', 'figcaption', 'figure', 'footer', 'form', 'frame', 'frameset', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'head', 'header', 'hgroup', 'hr', 'html', 'iframe', 'img', 'input', 'isindex', 'li', 'link', 'listing', 'main', 'marquee', 'menu', 'menuitem', 'meta', 'nav', 'noembed', 'noframes', 'noscript', 'object', 'ol', 'p', 'param', 'plaintext', 'pre', 'script', 'section', 'select', 'source', 'style', 'summary', 'table', 'tbody', 'td', 'template', 'textarea', 'tfoot', 'th', 'thead', 'title', 'tr', 'track', 'ul', 'wbr', 'xmp'];
	
	  // https://html.spec.whatwg.org/multipage/syntax.html#has-an-element-in-scope
	  var inScopeTags = ['applet', 'caption', 'html', 'table', 'td', 'th', 'marquee', 'object', 'template',
	
	  // https://html.spec.whatwg.org/multipage/syntax.html#html-integration-point
	  // TODO: Distinguish by namespace here -- for <title>, including it here
	  // errs on the side of fewer warnings
	  'foreignObject', 'desc', 'title'];
	
	  // https://html.spec.whatwg.org/multipage/syntax.html#has-an-element-in-button-scope
	  var buttonScopeTags = inScopeTags.concat(['button']);
	
	  // https://html.spec.whatwg.org/multipage/syntax.html#generate-implied-end-tags
	  var impliedEndTags = ['dd', 'dt', 'li', 'option', 'optgroup', 'p', 'rp', 'rt'];
	
	  var emptyAncestorInfo = {
	    current: null,
	
	    formTag: null,
	    aTagInScope: null,
	    buttonTagInScope: null,
	    nobrTagInScope: null,
	    pTagInButtonScope: null,
	
	    listItemTagAutoclosing: null,
	    dlItemTagAutoclosing: null
	  };
	
	  var updatedAncestorInfo = function (oldInfo, tag, instance) {
	    var ancestorInfo = _assign({}, oldInfo || emptyAncestorInfo);
	    var info = { tag: tag, instance: instance };
	
	    if (inScopeTags.indexOf(tag) !== -1) {
	      ancestorInfo.aTagInScope = null;
	      ancestorInfo.buttonTagInScope = null;
	      ancestorInfo.nobrTagInScope = null;
	    }
	    if (buttonScopeTags.indexOf(tag) !== -1) {
	      ancestorInfo.pTagInButtonScope = null;
	    }
	
	    // See rules for 'li', 'dd', 'dt' start tags in
	    // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inbody
	    if (specialTags.indexOf(tag) !== -1 && tag !== 'address' && tag !== 'div' && tag !== 'p') {
	      ancestorInfo.listItemTagAutoclosing = null;
	      ancestorInfo.dlItemTagAutoclosing = null;
	    }
	
	    ancestorInfo.current = info;
	
	    if (tag === 'form') {
	      ancestorInfo.formTag = info;
	    }
	    if (tag === 'a') {
	      ancestorInfo.aTagInScope = info;
	    }
	    if (tag === 'button') {
	      ancestorInfo.buttonTagInScope = info;
	    }
	    if (tag === 'nobr') {
	      ancestorInfo.nobrTagInScope = info;
	    }
	    if (tag === 'p') {
	      ancestorInfo.pTagInButtonScope = info;
	    }
	    if (tag === 'li') {
	      ancestorInfo.listItemTagAutoclosing = info;
	    }
	    if (tag === 'dd' || tag === 'dt') {
	      ancestorInfo.dlItemTagAutoclosing = info;
	    }
	
	    return ancestorInfo;
	  };
	
	  /**
	   * Returns whether
	   */
	  var isTagValidWithParent = function (tag, parentTag) {
	    // First, let's check if we're in an unusual parsing mode...
	    switch (parentTag) {
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inselect
	      case 'select':
	        return tag === 'option' || tag === 'optgroup' || tag === '#text';
	      case 'optgroup':
	        return tag === 'option' || tag === '#text';
	      // Strictly speaking, seeing an <option> doesn't mean we're in a <select>
	      // but
	      case 'option':
	        return tag === '#text';
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intd
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-incaption
	      // No special behavior since these rules fall back to "in body" mode for
	      // all except special table nodes which cause bad parsing behavior anyway.
	
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intr
	      case 'tr':
	        return tag === 'th' || tag === 'td' || tag === 'style' || tag === 'script' || tag === 'template';
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intbody
	      case 'tbody':
	      case 'thead':
	      case 'tfoot':
	        return tag === 'tr' || tag === 'style' || tag === 'script' || tag === 'template';
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-incolgroup
	      case 'colgroup':
	        return tag === 'col' || tag === 'template';
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intable
	      case 'table':
	        return tag === 'caption' || tag === 'colgroup' || tag === 'tbody' || tag === 'tfoot' || tag === 'thead' || tag === 'style' || tag === 'script' || tag === 'template';
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inhead
	      case 'head':
	        return tag === 'base' || tag === 'basefont' || tag === 'bgsound' || tag === 'link' || tag === 'meta' || tag === 'title' || tag === 'noscript' || tag === 'noframes' || tag === 'style' || tag === 'script' || tag === 'template';
	      // https://html.spec.whatwg.org/multipage/semantics.html#the-html-element
	      case 'html':
	        return tag === 'head' || tag === 'body';
	      case '#document':
	        return tag === 'html';
	    }
	
	    // Probably in the "in body" parsing mode, so we outlaw only tag combos
	    // where the parsing rules cause implicit opens or closes to be added.
	    // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inbody
	    switch (tag) {
	      case 'h1':
	      case 'h2':
	      case 'h3':
	      case 'h4':
	      case 'h5':
	      case 'h6':
	        return parentTag !== 'h1' && parentTag !== 'h2' && parentTag !== 'h3' && parentTag !== 'h4' && parentTag !== 'h5' && parentTag !== 'h6';
	
	      case 'rp':
	      case 'rt':
	        return impliedEndTags.indexOf(parentTag) === -1;
	
	      case 'body':
	      case 'caption':
	      case 'col':
	      case 'colgroup':
	      case 'frame':
	      case 'head':
	      case 'html':
	      case 'tbody':
	      case 'td':
	      case 'tfoot':
	      case 'th':
	      case 'thead':
	      case 'tr':
	        // These tags are only valid with a few parents that have special child
	        // parsing rules -- if we're down here, then none of those matched and
	        // so we allow it only if we don't know what the parent is, as all other
	        // cases are invalid.
	        return parentTag == null;
	    }
	
	    return true;
	  };
	
	  /**
	   * Returns whether
	   */
	  var findInvalidAncestorForTag = function (tag, ancestorInfo) {
	    switch (tag) {
	      case 'address':
	      case 'article':
	      case 'aside':
	      case 'blockquote':
	      case 'center':
	      case 'details':
	      case 'dialog':
	      case 'dir':
	      case 'div':
	      case 'dl':
	      case 'fieldset':
	      case 'figcaption':
	      case 'figure':
	      case 'footer':
	      case 'header':
	      case 'hgroup':
	      case 'main':
	      case 'menu':
	      case 'nav':
	      case 'ol':
	      case 'p':
	      case 'section':
	      case 'summary':
	      case 'ul':
	      case 'pre':
	      case 'listing':
	      case 'table':
	      case 'hr':
	      case 'xmp':
	      case 'h1':
	      case 'h2':
	      case 'h3':
	      case 'h4':
	      case 'h5':
	      case 'h6':
	        return ancestorInfo.pTagInButtonScope;
	
	      case 'form':
	        return ancestorInfo.formTag || ancestorInfo.pTagInButtonScope;
	
	      case 'li':
	        return ancestorInfo.listItemTagAutoclosing;
	
	      case 'dd':
	      case 'dt':
	        return ancestorInfo.dlItemTagAutoclosing;
	
	      case 'button':
	        return ancestorInfo.buttonTagInScope;
	
	      case 'a':
	        // Spec says something about storing a list of markers, but it sounds
	        // equivalent to this check.
	        return ancestorInfo.aTagInScope;
	
	      case 'nobr':
	        return ancestorInfo.nobrTagInScope;
	    }
	
	    return null;
	  };
	
	  /**
	   * Given a ReactCompositeComponent instance, return a list of its recursive
	   * owners, starting at the root and ending with the instance itself.
	   */
	  var findOwnerStack = function (instance) {
	    if (!instance) {
	      return [];
	    }
	
	    var stack = [];
	    do {
	      stack.push(instance);
	    } while (instance = instance._currentElement._owner);
	    stack.reverse();
	    return stack;
	  };
	
	  var didWarn = {};
	
	  validateDOMNesting = function (childTag, childText, childInstance, ancestorInfo) {
	    ancestorInfo = ancestorInfo || emptyAncestorInfo;
	    var parentInfo = ancestorInfo.current;
	    var parentTag = parentInfo && parentInfo.tag;
	
	    if (childText != null) {
	      process.env.NODE_ENV !== 'production' ? warning(childTag == null, 'validateDOMNesting: when childText is passed, childTag should be null') : void 0;
	      childTag = '#text';
	    }
	
	    var invalidParent = isTagValidWithParent(childTag, parentTag) ? null : parentInfo;
	    var invalidAncestor = invalidParent ? null : findInvalidAncestorForTag(childTag, ancestorInfo);
	    var problematic = invalidParent || invalidAncestor;
	
	    if (problematic) {
	      var ancestorTag = problematic.tag;
	      var ancestorInstance = problematic.instance;
	
	      var childOwner = childInstance && childInstance._currentElement._owner;
	      var ancestorOwner = ancestorInstance && ancestorInstance._currentElement._owner;
	
	      var childOwners = findOwnerStack(childOwner);
	      var ancestorOwners = findOwnerStack(ancestorOwner);
	
	      var minStackLen = Math.min(childOwners.length, ancestorOwners.length);
	      var i;
	
	      var deepestCommon = -1;
	      for (i = 0; i < minStackLen; i++) {
	        if (childOwners[i] === ancestorOwners[i]) {
	          deepestCommon = i;
	        } else {
	          break;
	        }
	      }
	
	      var UNKNOWN = '(unknown)';
	      var childOwnerNames = childOwners.slice(deepestCommon + 1).map(function (inst) {
	        return inst.getName() || UNKNOWN;
	      });
	      var ancestorOwnerNames = ancestorOwners.slice(deepestCommon + 1).map(function (inst) {
	        return inst.getName() || UNKNOWN;
	      });
	      var ownerInfo = [].concat(
	      // If the parent and child instances have a common owner ancestor, start
	      // with that -- otherwise we just start with the parent's owners.
	      deepestCommon !== -1 ? childOwners[deepestCommon].getName() || UNKNOWN : [], ancestorOwnerNames, ancestorTag,
	      // If we're warning about an invalid (non-parent) ancestry, add '...'
	      invalidAncestor ? ['...'] : [], childOwnerNames, childTag).join(' > ');
	
	      var warnKey = !!invalidParent + '|' + childTag + '|' + ancestorTag + '|' + ownerInfo;
	      if (didWarn[warnKey]) {
	        return;
	      }
	      didWarn[warnKey] = true;
	
	      var tagDisplayName = childTag;
	      var whitespaceInfo = '';
	      if (childTag === '#text') {
	        if (/\S/.test(childText)) {
	          tagDisplayName = 'Text nodes';
	        } else {
	          tagDisplayName = 'Whitespace text nodes';
	          whitespaceInfo = " Make sure you don't have any extra whitespace between tags on " + 'each line of your source code.';
	        }
	      } else {
	        tagDisplayName = '<' + childTag + '>';
	      }
	
	      if (invalidParent) {
	        var info = '';
	        if (ancestorTag === 'table' && childTag === 'tr') {
	          info += ' Add a <tbody> to your code to match the DOM tree generated by ' + 'the browser.';
	        }
	        process.env.NODE_ENV !== 'production' ? warning(false, 'validateDOMNesting(...): %s cannot appear as a child of <%s>.%s ' + 'See %s.%s', tagDisplayName, ancestorTag, whitespaceInfo, ownerInfo, info) : void 0;
	      } else {
	        process.env.NODE_ENV !== 'production' ? warning(false, 'validateDOMNesting(...): %s cannot appear as a descendant of ' + '<%s>. See %s.', tagDisplayName, ancestorTag, ownerInfo) : void 0;
	      }
	    }
	  };
	
	  validateDOMNesting.updatedAncestorInfo = updatedAncestorInfo;
	
	  // For testing
	  validateDOMNesting.isTagValidInContext = function (tag, ancestorInfo) {
	    ancestorInfo = ancestorInfo || emptyAncestorInfo;
	    var parentInfo = ancestorInfo.current;
	    var parentTag = parentInfo && parentInfo.tag;
	    return isTagValidWithParent(tag, parentTag) && !findInvalidAncestorForTag(tag, ancestorInfo);
	  };
	}
	
	module.exports = validateDOMNesting;

/***/ },
/* 265 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _props2 = __webpack_require__(190);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var SEEK_ON_PLAY_EXPIRY = 5000;
	
	var Player = function (_Component) {
	  _inherits(Player, _Component);
	
	  function Player() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, Player);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Player.__proto__ || Object.getPrototypeOf(Player)).call.apply(_ref, [this].concat(args))), _this), _this.mounted = false, _this.isReady = false, _this.isPlaying = false, _this.isLoading = true, _this.loadOnReady = null, _this.startOnPlay = true, _this.seekOnPlay = null, _this.onDurationCalled = false, _this.getInternalPlayer = function (key) {
	      if (!_this.player) return null;
	      return _this.player[key];
	    }, _this.progress = function () {
	      if (_this.props.url && _this.player && _this.isReady) {
	        var playedSeconds = _this.getCurrentTime() || 0;
	        var loadedSeconds = _this.getSecondsLoaded();
	        var duration = _this.getDuration();
	        if (duration) {
	          var progress = {
	            playedSeconds: playedSeconds,
	            played: playedSeconds / duration
	          };
	          if (loadedSeconds !== null) {
	            progress.loadedSeconds = loadedSeconds;
	            progress.loaded = loadedSeconds / duration;
	          }
	          // Only call onProgress if values have changed
	          if (progress.played !== _this.prevPlayed || progress.loaded !== _this.prevLoaded) {
	            _this.props.onProgress(progress);
	          }
	          _this.prevPlayed = progress.played;
	          _this.prevLoaded = progress.loaded;
	        }
	      }
	      _this.progressTimeout = setTimeout(_this.progress, _this.props.progressFrequency || _this.props.progressInterval);
	    }, _this.onReady = function () {
	      if (!_this.mounted) return;
	      _this.isReady = true;
	      _this.isLoading = false;
	      var _this$props = _this.props,
	          onReady = _this$props.onReady,
	          playing = _this$props.playing,
	          volume = _this$props.volume,
	          muted = _this$props.muted;
	
	      onReady();
	      if (!muted && volume !== null) {
	        _this.player.setVolume(volume);
	      }
	      if (_this.loadOnReady) {
	        _this.player.load(_this.loadOnReady, true);
	        _this.loadOnReady = null;
	      } else if (playing) {
	        _this.player.play();
	      }
	      _this.onDurationCheck();
	    }, _this.onPlay = function () {
	      _this.isPlaying = true;
	      _this.isLoading = false;
	      var _this$props2 = _this.props,
	          onStart = _this$props2.onStart,
	          onPlay = _this$props2.onPlay,
	          playbackRate = _this$props2.playbackRate;
	
	      if (_this.startOnPlay) {
	        if (_this.player.setPlaybackRate) {
	          _this.player.setPlaybackRate(playbackRate);
	        }
	        onStart();
	        _this.startOnPlay = false;
	      }
	      onPlay();
	      if (_this.seekOnPlay) {
	        _this.seekTo(_this.seekOnPlay);
	        _this.seekOnPlay = null;
	      }
	      _this.onDurationCheck();
	    }, _this.onPause = function (e) {
	      _this.isPlaying = false;
	      if (!_this.isLoading) {
	        _this.props.onPause(e);
	      }
	    }, _this.onEnded = function () {
	      var _this$props3 = _this.props,
	          activePlayer = _this$props3.activePlayer,
	          loop = _this$props3.loop,
	          onEnded = _this$props3.onEnded;
	
	      if (activePlayer.loopOnEnded && loop) {
	        _this.seekTo(0);
	      }
	      if (!loop) {
	        _this.isPlaying = false;
	      }
	      onEnded();
	    }, _this.onDurationCheck = function () {
	      clearTimeout(_this.durationCheckTimeout);
	      var duration = _this.getDuration();
	      if (duration) {
	        if (!_this.onDurationCalled) {
	          _this.props.onDuration(duration);
	          _this.onDurationCalled = true;
	        }
	      } else {
	        _this.durationCheckTimeout = setTimeout(_this.onDurationCheck, 100);
	      }
	    }, _this.ref = function (player) {
	      if (player) {
	        _this.player = player;
	      }
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  } // Track playing state internally to prevent bugs
	  // Use isLoading to prevent onPause when switching URL
	
	
	  _createClass(Player, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.mounted = true;
	      this.player.load(this.props.url);
	      this.progress();
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      clearTimeout(this.progressTimeout);
	      clearTimeout(this.durationCheckTimeout);
	      if (this.isReady) {
	        this.player.stop();
	      }
	      this.mounted = false;
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      var _this2 = this;
	
	      // Invoke player methods based on incoming props
	      var _props = this.props,
	          url = _props.url,
	          playing = _props.playing,
	          volume = _props.volume,
	          muted = _props.muted,
	          playbackRate = _props.playbackRate;
	
	      if (url !== nextProps.url) {
	        if (this.isLoading) {
	          console.warn('ReactPlayer: the attempt to load ' + nextProps.url + ' is being deferred until the player has loaded');
	          this.loadOnReady = nextProps.url;
	          return;
	        }
	        this.isLoading = true;
	        this.startOnPlay = true;
	        this.onDurationCalled = false;
	        this.player.load(nextProps.url, this.isReady);
	      }
	      if (!playing && nextProps.playing && !this.isPlaying) {
	        this.player.play();
	      }
	      if (playing && !nextProps.playing && this.isPlaying) {
	        this.player.pause();
	      }
	      if (volume !== nextProps.volume && nextProps.volume !== null) {
	        this.player.setVolume(nextProps.volume);
	      }
	      if (muted !== nextProps.muted) {
	        if (nextProps.muted) {
	          this.player.mute();
	        } else {
	          this.player.unmute();
	          if (nextProps.volume !== null) {
	            // Set volume next tick to fix a bug with DailyMotion
	            setTimeout(function () {
	              return _this2.player.setVolume(nextProps.volume);
	            });
	          }
	        }
	      }
	      if (playbackRate !== nextProps.playbackRate && this.player.setPlaybackRate) {
	        this.player.setPlaybackRate(nextProps.playbackRate);
	      }
	    }
	  }, {
	    key: 'getDuration',
	    value: function getDuration() {
	      if (!this.isReady) return null;
	      return this.player.getDuration();
	    }
	  }, {
	    key: 'getCurrentTime',
	    value: function getCurrentTime() {
	      if (!this.isReady) return null;
	      return this.player.getCurrentTime();
	    }
	  }, {
	    key: 'getSecondsLoaded',
	    value: function getSecondsLoaded() {
	      if (!this.isReady) return null;
	      return this.player.getSecondsLoaded();
	    }
	  }, {
	    key: 'seekTo',
	    value: function seekTo(amount) {
	      var _this3 = this;
	
	      // When seeking before player is ready, store value and seek later
	      if (!this.isReady && amount !== 0) {
	        this.seekOnPlay = amount;
	        setTimeout(function () {
	          _this3.seekOnPlay = null;
	        }, SEEK_ON_PLAY_EXPIRY);
	        return;
	      }
	      if (amount > 0 && amount < 1) {
	        // Convert fraction to seconds based on duration
	        var duration = this.player.getDuration();
	        if (!duration) {
	          console.warn('ReactPlayer: could not seek using fraction – duration not yet available');
	          return;
	        }
	        this.player.seekTo(duration * amount);
	        return;
	      }
	      this.player.seekTo(amount);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var Player = this.props.activePlayer;
	      if (!Player) {
	        return null;
	      }
	      return _react2['default'].createElement(Player, _extends({}, this.props, {
	        ref: this.ref,
	        onReady: this.onReady,
	        onPlay: this.onPlay,
	        onPause: this.onPause,
	        onEnded: this.onEnded
	      }));
	    }
	  }]);
	
	  return Player;
	}(_react.Component);
	
	Player.displayName = 'Player';
	Player.propTypes = _props2.propTypes;
	Player.defaultProps = _props2.defaultProps;
	exports['default'] = Player;

/***/ },
/* 266 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = warning;
	/**
	 * Prints a warning in the console if it exists.
	 *
	 * @param {String} message The warning message.
	 * @returns {void}
	 */
	function warning(message) {
	  /* eslint-disable no-console */
	  if (typeof console !== 'undefined' && typeof console.error === 'function') {
	    console.error(message);
	  }
	  /* eslint-enable no-console */
	  try {
	    // This error was thrown as a convenience so that if you enable
	    // "break on all exceptions" in your console,
	    // it would pause the execution at this line.
	    throw new Error(message);
	    /* eslint-disable no-empty */
	  } catch (e) {}
	  /* eslint-enable no-empty */
	}

/***/ },
/* 267 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports.loopAsync = loopAsync;
	exports.mapAsync = mapAsync;
	function loopAsync(turns, work, callback) {
	  var currentTurn = 0,
	      isDone = false;
	  var sync = false,
	      hasNext = false,
	      doneArgs = void 0;
	
	  function done() {
	    isDone = true;
	    if (sync) {
	      // Iterate instead of recursing if possible.
	      doneArgs = [].concat(Array.prototype.slice.call(arguments));
	      return;
	    }
	
	    callback.apply(this, arguments);
	  }
	
	  function next() {
	    if (isDone) {
	      return;
	    }
	
	    hasNext = true;
	    if (sync) {
	      // Iterate instead of recursing if possible.
	      return;
	    }
	
	    sync = true;
	
	    while (!isDone && currentTurn < turns && hasNext) {
	      hasNext = false;
	      work.call(this, currentTurn++, next, done);
	    }
	
	    sync = false;
	
	    if (isDone) {
	      // This means the loop finished synchronously.
	      callback.apply(this, doneArgs);
	      return;
	    }
	
	    if (currentTurn >= turns && hasNext) {
	      isDone = true;
	      callback();
	    }
	  }
	
	  next();
	}
	
	function mapAsync(array, work, callback) {
	  var length = array.length;
	  var values = [];
	
	  if (length === 0) return callback(null, values);
	
	  var isDone = false,
	      doneCount = 0;
	
	  function done(index, error, value) {
	    if (isDone) return;
	
	    if (error) {
	      isDone = true;
	      callback(error);
	    } else {
	      values[index] = value;
	
	      isDone = ++doneCount === length;
	
	      if (isDone) callback(null, values);
	    }
	  }
	
	  array.forEach(function (item, index) {
	    work(item, index, function (error, value) {
	      done(index, error, value);
	    });
	  });
	}

/***/ },
/* 268 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.ContextProvider = ContextProvider;
	exports.ContextSubscriber = ContextSubscriber;
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// Works around issues with context updates failing to propagate.
	// Caveat: the context value is expected to never change its identity.
	// https://github.com/facebook/react/issues/2517
	// https://github.com/reactjs/react-router/issues/470
	
	var contextProviderShape = _propTypes2.default.shape({
	  subscribe: _propTypes2.default.func.isRequired,
	  eventIndex: _propTypes2.default.number.isRequired
	});
	
	function makeContextName(name) {
	  return '@@contextSubscriber/' + name;
	}
	
	function ContextProvider(name) {
	  var _childContextTypes, _ref2;
	
	  var contextName = makeContextName(name);
	  var listenersKey = contextName + '/listeners';
	  var eventIndexKey = contextName + '/eventIndex';
	  var subscribeKey = contextName + '/subscribe';
	
	  return _ref2 = {
	    childContextTypes: (_childContextTypes = {}, _childContextTypes[contextName] = contextProviderShape.isRequired, _childContextTypes),
	
	    getChildContext: function getChildContext() {
	      var _ref;
	
	      return _ref = {}, _ref[contextName] = {
	        eventIndex: this[eventIndexKey],
	        subscribe: this[subscribeKey]
	      }, _ref;
	    },
	    componentWillMount: function componentWillMount() {
	      this[listenersKey] = [];
	      this[eventIndexKey] = 0;
	    },
	    componentWillReceiveProps: function componentWillReceiveProps() {
	      this[eventIndexKey]++;
	    },
	    componentDidUpdate: function componentDidUpdate() {
	      var _this = this;
	
	      this[listenersKey].forEach(function (listener) {
	        return listener(_this[eventIndexKey]);
	      });
	    }
	  }, _ref2[subscribeKey] = function (listener) {
	    var _this2 = this;
	
	    // No need to immediately call listener here.
	    this[listenersKey].push(listener);
	
	    return function () {
	      _this2[listenersKey] = _this2[listenersKey].filter(function (item) {
	        return item !== listener;
	      });
	    };
	  }, _ref2;
	}
	
	function ContextSubscriber(name) {
	  var _contextTypes, _ref4;
	
	  var contextName = makeContextName(name);
	  var lastRenderedEventIndexKey = contextName + '/lastRenderedEventIndex';
	  var handleContextUpdateKey = contextName + '/handleContextUpdate';
	  var unsubscribeKey = contextName + '/unsubscribe';
	
	  return _ref4 = {
	    contextTypes: (_contextTypes = {}, _contextTypes[contextName] = contextProviderShape, _contextTypes),
	
	    getInitialState: function getInitialState() {
	      var _ref3;
	
	      if (!this.context[contextName]) {
	        return {};
	      }
	
	      return _ref3 = {}, _ref3[lastRenderedEventIndexKey] = this.context[contextName].eventIndex, _ref3;
	    },
	    componentDidMount: function componentDidMount() {
	      if (!this.context[contextName]) {
	        return;
	      }
	
	      this[unsubscribeKey] = this.context[contextName].subscribe(this[handleContextUpdateKey]);
	    },
	    componentWillReceiveProps: function componentWillReceiveProps() {
	      var _setState;
	
	      if (!this.context[contextName]) {
	        return;
	      }
	
	      this.setState((_setState = {}, _setState[lastRenderedEventIndexKey] = this.context[contextName].eventIndex, _setState));
	    },
	    componentWillUnmount: function componentWillUnmount() {
	      if (!this[unsubscribeKey]) {
	        return;
	      }
	
	      this[unsubscribeKey]();
	      this[unsubscribeKey] = null;
	    }
	  }, _ref4[handleContextUpdateKey] = function (eventIndex) {
	    if (eventIndex !== this.state[lastRenderedEventIndexKey]) {
	      var _setState2;
	
	      this.setState((_setState2 = {}, _setState2[lastRenderedEventIndexKey] = eventIndex, _setState2));
	    }
	  }, _ref4;
	}

/***/ },
/* 269 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.locationShape = exports.routerShape = undefined;
	
	var _propTypes = __webpack_require__(2);
	
	var routerShape = exports.routerShape = (0, _propTypes.shape)({
	  push: _propTypes.func.isRequired,
	  replace: _propTypes.func.isRequired,
	  go: _propTypes.func.isRequired,
	  goBack: _propTypes.func.isRequired,
	  goForward: _propTypes.func.isRequired,
	  setRouteLeaveHook: _propTypes.func.isRequired,
	  isActive: _propTypes.func.isRequired
	});
	
	var locationShape = exports.locationShape = (0, _propTypes.shape)({
	  pathname: _propTypes.string.isRequired,
	  search: _propTypes.string.isRequired,
	  state: _propTypes.object,
	  action: _propTypes.string.isRequired,
	  key: _propTypes.string
	});

/***/ },
/* 270 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _invariant = __webpack_require__(46);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _createReactClass = __webpack_require__(73);
	
	var _createReactClass2 = _interopRequireDefault(_createReactClass);
	
	var _propTypes = __webpack_require__(2);
	
	var _getRouteParams = __webpack_require__(1056);
	
	var _getRouteParams2 = _interopRequireDefault(_getRouteParams);
	
	var _ContextUtils = __webpack_require__(268);
	
	var _RouteUtils = __webpack_require__(100);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * A <RouterContext> renders the component tree for a given router state
	 * and sets the history object and the current location in context.
	 */
	var RouterContext = (0, _createReactClass2.default)({
	  displayName: 'RouterContext',
	
	  mixins: [(0, _ContextUtils.ContextProvider)('router')],
	
	  propTypes: {
	    router: _propTypes.object.isRequired,
	    location: _propTypes.object.isRequired,
	    routes: _propTypes.array.isRequired,
	    params: _propTypes.object.isRequired,
	    components: _propTypes.array.isRequired,
	    createElement: _propTypes.func.isRequired
	  },
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      createElement: _react2.default.createElement
	    };
	  },
	
	
	  childContextTypes: {
	    router: _propTypes.object.isRequired
	  },
	
	  getChildContext: function getChildContext() {
	    return {
	      router: this.props.router
	    };
	  },
	  createElement: function createElement(component, props) {
	    return component == null ? null : this.props.createElement(component, props);
	  },
	  render: function render() {
	    var _this = this;
	
	    var _props = this.props,
	        location = _props.location,
	        routes = _props.routes,
	        params = _props.params,
	        components = _props.components,
	        router = _props.router;
	
	    var element = null;
	
	    if (components) {
	      element = components.reduceRight(function (element, components, index) {
	        if (components == null) return element; // Don't create new children; use the grandchildren.
	
	        var route = routes[index];
	        var routeParams = (0, _getRouteParams2.default)(route, params);
	        var props = {
	          location: location,
	          params: params,
	          route: route,
	          router: router,
	          routeParams: routeParams,
	          routes: routes
	        };
	
	        if ((0, _RouteUtils.isReactChildren)(element)) {
	          props.children = element;
	        } else if (element) {
	          for (var prop in element) {
	            if (Object.prototype.hasOwnProperty.call(element, prop)) props[prop] = element[prop];
	          }
	        }
	
	        if ((typeof components === 'undefined' ? 'undefined' : _typeof(components)) === 'object') {
	          var elements = {};
	
	          for (var key in components) {
	            if (Object.prototype.hasOwnProperty.call(components, key)) {
	              // Pass through the key as a prop to createElement to allow
	              // custom createElement functions to know which named component
	              // they're rendering, for e.g. matching up to fetched data.
	              elements[key] = _this.createElement(components[key], _extends({
	                key: key }, props));
	            }
	          }
	
	          return elements;
	        }
	
	        return _this.createElement(components, props);
	      }, element);
	    }
	
	    !(element === null || element === false || _react2.default.isValidElement(element)) ?  false ? (0, _invariant2.default)(false, 'The root route must render a single element') : (0, _invariant2.default)(false) : void 0;
	
	    return element;
	  }
	});
	
	exports.default = RouterContext;
	module.exports = exports['default'];

/***/ },
/* 271 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(setImmediate, clearImmediate) {var nextTick = __webpack_require__(1094).nextTick;
	var apply = Function.prototype.apply;
	var slice = Array.prototype.slice;
	var immediateIds = {};
	var nextImmediateId = 0;
	
	// DOM APIs, for completeness
	
	exports.setTimeout = function() {
	  return new Timeout(apply.call(setTimeout, window, arguments), clearTimeout);
	};
	exports.setInterval = function() {
	  return new Timeout(apply.call(setInterval, window, arguments), clearInterval);
	};
	exports.clearTimeout =
	exports.clearInterval = function(timeout) { timeout.close(); };
	
	function Timeout(id, clearFn) {
	  this._id = id;
	  this._clearFn = clearFn;
	}
	Timeout.prototype.unref = Timeout.prototype.ref = function() {};
	Timeout.prototype.close = function() {
	  this._clearFn.call(window, this._id);
	};
	
	// Does not start the time, just sets up the members needed.
	exports.enroll = function(item, msecs) {
	  clearTimeout(item._idleTimeoutId);
	  item._idleTimeout = msecs;
	};
	
	exports.unenroll = function(item) {
	  clearTimeout(item._idleTimeoutId);
	  item._idleTimeout = -1;
	};
	
	exports._unrefActive = exports.active = function(item) {
	  clearTimeout(item._idleTimeoutId);
	
	  var msecs = item._idleTimeout;
	  if (msecs >= 0) {
	    item._idleTimeoutId = setTimeout(function onTimeout() {
	      if (item._onTimeout)
	        item._onTimeout();
	    }, msecs);
	  }
	};
	
	// That's not how node.js implements it but the exposed api is the same.
	exports.setImmediate = typeof setImmediate === "function" ? setImmediate : function(fn) {
	  var id = nextImmediateId++;
	  var args = arguments.length < 2 ? false : slice.call(arguments, 1);
	
	  immediateIds[id] = true;
	
	  nextTick(function onNextTick() {
	    if (immediateIds[id]) {
	      // fn.call() is faster so we optimize for the common use-case
	      // @see http://jsperf.com/call-apply-segu
	      if (args) {
	        fn.apply(null, args);
	      } else {
	        fn.call(null);
	      }
	      // Prevent ids from leaking
	      exports.clearImmediate(id);
	    }
	  });
	
	  return id;
	};
	
	exports.clearImmediate = typeof clearImmediate === "function" ? clearImmediate : function(id) {
	  delete immediateIds[id];
	};
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(271).setImmediate, __webpack_require__(271).clearImmediate))

/***/ },
/* 272 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global, setImmediate) {/*! @vimeo/player v2.6.3 | (c) 2018 Vimeo | MIT License | https://github.com/vimeo/player.js */
	(function (global, factory) {
	   true ? module.exports = factory() :
	  typeof define === 'function' && define.amd ? define(factory) :
	  (global.Vimeo = global.Vimeo || {}, global.Vimeo.Player = factory());
	}(this, (function () { 'use strict';
	
	  function _classCallCheck(instance, Constructor) {
	    if (!(instance instanceof Constructor)) {
	      throw new TypeError("Cannot call a class as a function");
	    }
	  }
	
	  function _defineProperties(target, props) {
	    for (var i = 0; i < props.length; i++) {
	      var descriptor = props[i];
	      descriptor.enumerable = descriptor.enumerable || false;
	      descriptor.configurable = true;
	      if ("value" in descriptor) descriptor.writable = true;
	      Object.defineProperty(target, descriptor.key, descriptor);
	    }
	  }
	
	  function _createClass(Constructor, protoProps, staticProps) {
	    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
	    if (staticProps) _defineProperties(Constructor, staticProps);
	    return Constructor;
	  }
	
	  /**
	   * @module lib/functions
	   */
	
	  /**
	   * Check to see this is a node environment.
	   * @type {Boolean}
	   */
	
	  /* global global */
	  var isNode = typeof global !== 'undefined' && {}.toString.call(global) === '[object global]';
	  /**
	   * Get the name of the method for a given getter or setter.
	   *
	   * @param {string} prop The name of the property.
	   * @param {string} type Either “get” or “set”.
	   * @return {string}
	   */
	
	  function getMethodName(prop, type) {
	    if (prop.indexOf(type.toLowerCase()) === 0) {
	      return prop;
	    }
	
	    return "".concat(type.toLowerCase()).concat(prop.substr(0, 1).toUpperCase()).concat(prop.substr(1));
	  }
	  /**
	   * Check to see if the object is a DOM Element.
	   *
	   * @param {*} element The object to check.
	   * @return {boolean}
	   */
	
	  function isDomElement(element) {
	    return element instanceof window.HTMLElement;
	  }
	  /**
	   * Check to see whether the value is a number.
	   *
	   * @see http://dl.dropboxusercontent.com/u/35146/js/tests/isNumber.html
	   * @param {*} value The value to check.
	   * @param {boolean} integer Check if the value is an integer.
	   * @return {boolean}
	   */
	
	  function isInteger(value) {
	    // eslint-disable-next-line eqeqeq
	    return !isNaN(parseFloat(value)) && isFinite(value) && Math.floor(value) == value;
	  }
	  /**
	   * Check to see if the URL is a Vimeo url.
	   *
	   * @param {string} url The url string.
	   * @return {boolean}
	   */
	
	  function isVimeoUrl(url) {
	    return /^(https?:)?\/\/((player|www).)?vimeo.com(?=$|\/)/.test(url);
	  }
	  /**
	   * Get the Vimeo URL from an element.
	   * The element must have either a data-vimeo-id or data-vimeo-url attribute.
	   *
	   * @param {object} oEmbedParameters The oEmbed parameters.
	   * @return {string}
	   */
	
	  function getVimeoUrl() {
	    var oEmbedParameters = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	    var id = oEmbedParameters.id;
	    var url = oEmbedParameters.url;
	    var idOrUrl = id || url;
	
	    if (!idOrUrl) {
	      throw new Error('An id or url must be passed, either in an options object or as a data-vimeo-id or data-vimeo-url attribute.');
	    }
	
	    if (isInteger(idOrUrl)) {
	      return "https://vimeo.com/".concat(idOrUrl);
	    }
	
	    if (isVimeoUrl(idOrUrl)) {
	      return idOrUrl.replace('http:', 'https:');
	    }
	
	    if (id) {
	      throw new TypeError("\u201C".concat(id, "\u201D is not a valid video id."));
	    }
	
	    throw new TypeError("\u201C".concat(idOrUrl, "\u201D is not a vimeo.com url."));
	  }
	
	  var arrayIndexOfSupport = typeof Array.prototype.indexOf !== 'undefined';
	  var postMessageSupport = typeof window !== 'undefined' && typeof window.postMessage !== 'undefined';
	
	  if (!isNode && (!arrayIndexOfSupport || !postMessageSupport)) {
	    throw new Error('Sorry, the Vimeo Player API is not available in this browser.');
	  }
	
	  var commonjsGlobal = typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};
	
	  function createCommonjsModule(fn, module) {
	  	return module = { exports: {} }, fn(module, module.exports), module.exports;
	  }
	
	  /*!
	   * weakmap-polyfill v2.0.0 - ECMAScript6 WeakMap polyfill
	   * https://github.com/polygonplanet/weakmap-polyfill
	   * Copyright (c) 2015-2016 polygon planet <polygon.planet.aqua@gmail.com>
	   * @license MIT
	   */
	  (function (self) {
	
	    if (self.WeakMap) {
	      return;
	    }
	
	    var hasOwnProperty = Object.prototype.hasOwnProperty;
	
	    var defineProperty = function (object, name, value) {
	      if (Object.defineProperty) {
	        Object.defineProperty(object, name, {
	          configurable: true,
	          writable: true,
	          value: value
	        });
	      } else {
	        object[name] = value;
	      }
	    };
	
	    self.WeakMap = function () {
	      // ECMA-262 23.3 WeakMap Objects
	      function WeakMap() {
	        if (this === void 0) {
	          throw new TypeError("Constructor WeakMap requires 'new'");
	        }
	
	        defineProperty(this, '_id', genId('_WeakMap')); // ECMA-262 23.3.1.1 WeakMap([iterable])
	
	        if (arguments.length > 0) {
	          // Currently, WeakMap `iterable` argument is not supported
	          throw new TypeError('WeakMap iterable is not supported');
	        }
	      } // ECMA-262 23.3.3.2 WeakMap.prototype.delete(key)
	
	
	      defineProperty(WeakMap.prototype, 'delete', function (key) {
	        checkInstance(this, 'delete');
	
	        if (!isObject(key)) {
	          return false;
	        }
	
	        var entry = key[this._id];
	
	        if (entry && entry[0] === key) {
	          delete key[this._id];
	          return true;
	        }
	
	        return false;
	      }); // ECMA-262 23.3.3.3 WeakMap.prototype.get(key)
	
	      defineProperty(WeakMap.prototype, 'get', function (key) {
	        checkInstance(this, 'get');
	
	        if (!isObject(key)) {
	          return void 0;
	        }
	
	        var entry = key[this._id];
	
	        if (entry && entry[0] === key) {
	          return entry[1];
	        }
	
	        return void 0;
	      }); // ECMA-262 23.3.3.4 WeakMap.prototype.has(key)
	
	      defineProperty(WeakMap.prototype, 'has', function (key) {
	        checkInstance(this, 'has');
	
	        if (!isObject(key)) {
	          return false;
	        }
	
	        var entry = key[this._id];
	
	        if (entry && entry[0] === key) {
	          return true;
	        }
	
	        return false;
	      }); // ECMA-262 23.3.3.5 WeakMap.prototype.set(key, value)
	
	      defineProperty(WeakMap.prototype, 'set', function (key, value) {
	        checkInstance(this, 'set');
	
	        if (!isObject(key)) {
	          throw new TypeError('Invalid value used as weak map key');
	        }
	
	        var entry = key[this._id];
	
	        if (entry && entry[0] === key) {
	          entry[1] = value;
	          return this;
	        }
	
	        defineProperty(key, this._id, [key, value]);
	        return this;
	      });
	
	      function checkInstance(x, methodName) {
	        if (!isObject(x) || !hasOwnProperty.call(x, '_id')) {
	          throw new TypeError(methodName + ' method called on incompatible receiver ' + typeof x);
	        }
	      }
	
	      function genId(prefix) {
	        return prefix + '_' + rand() + '.' + rand();
	      }
	
	      function rand() {
	        return Math.random().toString().substring(2);
	      }
	
	      defineProperty(WeakMap, '_polyfill', true);
	      return WeakMap;
	    }();
	
	    function isObject(x) {
	      return Object(x) === x;
	    }
	  })(typeof self !== 'undefined' ? self : typeof window !== 'undefined' ? window : typeof commonjsGlobal !== 'undefined' ? commonjsGlobal : commonjsGlobal);
	
	  var npo_src = createCommonjsModule(function (module) {
	  /*! Native Promise Only
	      v0.8.1 (c) Kyle Simpson
	      MIT License: http://getify.mit-license.org
	  */
	  (function UMD(name, context, definition) {
	    // special form of UMD for polyfilling across evironments
	    context[name] = context[name] || definition();
	
	    if (module.exports) {
	      module.exports = context[name];
	    } else if (false) {
	      undefined(function $AMD$() {
	        return context[name];
	      });
	    }
	  })("Promise", typeof commonjsGlobal != "undefined" ? commonjsGlobal : commonjsGlobal, function DEF() {
	
	    var builtInProp,
	        cycle,
	        scheduling_queue,
	        ToString = Object.prototype.toString,
	        timer = typeof setImmediate != "undefined" ? function timer(fn) {
	      return setImmediate(fn);
	    } : setTimeout; // dammit, IE8.
	
	    try {
	      Object.defineProperty({}, "x", {});
	
	      builtInProp = function builtInProp(obj, name, val, config) {
	        return Object.defineProperty(obj, name, {
	          value: val,
	          writable: true,
	          configurable: config !== false
	        });
	      };
	    } catch (err) {
	      builtInProp = function builtInProp(obj, name, val) {
	        obj[name] = val;
	        return obj;
	      };
	    } // Note: using a queue instead of array for efficiency
	
	
	    scheduling_queue = function Queue() {
	      var first, last, item;
	
	      function Item(fn, self) {
	        this.fn = fn;
	        this.self = self;
	        this.next = void 0;
	      }
	
	      return {
	        add: function add(fn, self) {
	          item = new Item(fn, self);
	
	          if (last) {
	            last.next = item;
	          } else {
	            first = item;
	          }
	
	          last = item;
	          item = void 0;
	        },
	        drain: function drain() {
	          var f = first;
	          first = last = cycle = void 0;
	
	          while (f) {
	            f.fn.call(f.self);
	            f = f.next;
	          }
	        }
	      };
	    }();
	
	    function schedule(fn, self) {
	      scheduling_queue.add(fn, self);
	
	      if (!cycle) {
	        cycle = timer(scheduling_queue.drain);
	      }
	    } // promise duck typing
	
	
	    function isThenable(o) {
	      var _then,
	          o_type = typeof o;
	
	      if (o != null && (o_type == "object" || o_type == "function")) {
	        _then = o.then;
	      }
	
	      return typeof _then == "function" ? _then : false;
	    }
	
	    function notify() {
	      for (var i = 0; i < this.chain.length; i++) {
	        notifyIsolated(this, this.state === 1 ? this.chain[i].success : this.chain[i].failure, this.chain[i]);
	      }
	
	      this.chain.length = 0;
	    } // NOTE: This is a separate function to isolate
	    // the `try..catch` so that other code can be
	    // optimized better
	
	
	    function notifyIsolated(self, cb, chain) {
	      var ret, _then;
	
	      try {
	        if (cb === false) {
	          chain.reject(self.msg);
	        } else {
	          if (cb === true) {
	            ret = self.msg;
	          } else {
	            ret = cb.call(void 0, self.msg);
	          }
	
	          if (ret === chain.promise) {
	            chain.reject(TypeError("Promise-chain cycle"));
	          } else if (_then = isThenable(ret)) {
	            _then.call(ret, chain.resolve, chain.reject);
	          } else {
	            chain.resolve(ret);
	          }
	        }
	      } catch (err) {
	        chain.reject(err);
	      }
	    }
	
	    function resolve(msg) {
	      var _then,
	          self = this; // already triggered?
	
	
	      if (self.triggered) {
	        return;
	      }
	
	      self.triggered = true; // unwrap
	
	      if (self.def) {
	        self = self.def;
	      }
	
	      try {
	        if (_then = isThenable(msg)) {
	          schedule(function () {
	            var def_wrapper = new MakeDefWrapper(self);
	
	            try {
	              _then.call(msg, function $resolve$() {
	                resolve.apply(def_wrapper, arguments);
	              }, function $reject$() {
	                reject.apply(def_wrapper, arguments);
	              });
	            } catch (err) {
	              reject.call(def_wrapper, err);
	            }
	          });
	        } else {
	          self.msg = msg;
	          self.state = 1;
	
	          if (self.chain.length > 0) {
	            schedule(notify, self);
	          }
	        }
	      } catch (err) {
	        reject.call(new MakeDefWrapper(self), err);
	      }
	    }
	
	    function reject(msg) {
	      var self = this; // already triggered?
	
	      if (self.triggered) {
	        return;
	      }
	
	      self.triggered = true; // unwrap
	
	      if (self.def) {
	        self = self.def;
	      }
	
	      self.msg = msg;
	      self.state = 2;
	
	      if (self.chain.length > 0) {
	        schedule(notify, self);
	      }
	    }
	
	    function iteratePromises(Constructor, arr, resolver, rejecter) {
	      for (var idx = 0; idx < arr.length; idx++) {
	        (function IIFE(idx) {
	          Constructor.resolve(arr[idx]).then(function $resolver$(msg) {
	            resolver(idx, msg);
	          }, rejecter);
	        })(idx);
	      }
	    }
	
	    function MakeDefWrapper(self) {
	      this.def = self;
	      this.triggered = false;
	    }
	
	    function MakeDef(self) {
	      this.promise = self;
	      this.state = 0;
	      this.triggered = false;
	      this.chain = [];
	      this.msg = void 0;
	    }
	
	    function Promise(executor) {
	      if (typeof executor != "function") {
	        throw TypeError("Not a function");
	      }
	
	      if (this.__NPO__ !== 0) {
	        throw TypeError("Not a promise");
	      } // instance shadowing the inherited "brand"
	      // to signal an already "initialized" promise
	
	
	      this.__NPO__ = 1;
	      var def = new MakeDef(this);
	
	      this["then"] = function then(success, failure) {
	        var o = {
	          success: typeof success == "function" ? success : true,
	          failure: typeof failure == "function" ? failure : false
	        }; // Note: `then(..)` itself can be borrowed to be used against
	        // a different promise constructor for making the chained promise,
	        // by substituting a different `this` binding.
	
	        o.promise = new this.constructor(function extractChain(resolve, reject) {
	          if (typeof resolve != "function" || typeof reject != "function") {
	            throw TypeError("Not a function");
	          }
	
	          o.resolve = resolve;
	          o.reject = reject;
	        });
	        def.chain.push(o);
	
	        if (def.state !== 0) {
	          schedule(notify, def);
	        }
	
	        return o.promise;
	      };
	
	      this["catch"] = function $catch$(failure) {
	        return this.then(void 0, failure);
	      };
	
	      try {
	        executor.call(void 0, function publicResolve(msg) {
	          resolve.call(def, msg);
	        }, function publicReject(msg) {
	          reject.call(def, msg);
	        });
	      } catch (err) {
	        reject.call(def, err);
	      }
	    }
	
	    var PromisePrototype = builtInProp({}, "constructor", Promise,
	    /*configurable=*/
	    false); // Note: Android 4 cannot use `Object.defineProperty(..)` here
	
	    Promise.prototype = PromisePrototype; // built-in "brand" to signal an "uninitialized" promise
	
	    builtInProp(PromisePrototype, "__NPO__", 0,
	    /*configurable=*/
	    false);
	    builtInProp(Promise, "resolve", function Promise$resolve(msg) {
	      var Constructor = this; // spec mandated checks
	      // note: best "isPromise" check that's practical for now
	
	      if (msg && typeof msg == "object" && msg.__NPO__ === 1) {
	        return msg;
	      }
	
	      return new Constructor(function executor(resolve, reject) {
	        if (typeof resolve != "function" || typeof reject != "function") {
	          throw TypeError("Not a function");
	        }
	
	        resolve(msg);
	      });
	    });
	    builtInProp(Promise, "reject", function Promise$reject(msg) {
	      return new this(function executor(resolve, reject) {
	        if (typeof resolve != "function" || typeof reject != "function") {
	          throw TypeError("Not a function");
	        }
	
	        reject(msg);
	      });
	    });
	    builtInProp(Promise, "all", function Promise$all(arr) {
	      var Constructor = this; // spec mandated checks
	
	      if (ToString.call(arr) != "[object Array]") {
	        return Constructor.reject(TypeError("Not an array"));
	      }
	
	      if (arr.length === 0) {
	        return Constructor.resolve([]);
	      }
	
	      return new Constructor(function executor(resolve, reject) {
	        if (typeof resolve != "function" || typeof reject != "function") {
	          throw TypeError("Not a function");
	        }
	
	        var len = arr.length,
	            msgs = Array(len),
	            count = 0;
	        iteratePromises(Constructor, arr, function resolver(idx, msg) {
	          msgs[idx] = msg;
	
	          if (++count === len) {
	            resolve(msgs);
	          }
	        }, reject);
	      });
	    });
	    builtInProp(Promise, "race", function Promise$race(arr) {
	      var Constructor = this; // spec mandated checks
	
	      if (ToString.call(arr) != "[object Array]") {
	        return Constructor.reject(TypeError("Not an array"));
	      }
	
	      return new Constructor(function executor(resolve, reject) {
	        if (typeof resolve != "function" || typeof reject != "function") {
	          throw TypeError("Not a function");
	        }
	
	        iteratePromises(Constructor, arr, function resolver(idx, msg) {
	          resolve(msg);
	        }, reject);
	      });
	    });
	    return Promise;
	  });
	  });
	
	  /**
	   * @module lib/callbacks
	   */
	  var callbackMap = new WeakMap();
	  /**
	   * Store a callback for a method or event for a player.
	   *
	   * @param {Player} player The player object.
	   * @param {string} name The method or event name.
	   * @param {(function(this:Player, *): void|{resolve: function, reject: function})} callback
	   *        The callback to call or an object with resolve and reject functions for a promise.
	   * @return {void}
	   */
	
	  function storeCallback(player, name, callback) {
	    var playerCallbacks = callbackMap.get(player.element) || {};
	
	    if (!(name in playerCallbacks)) {
	      playerCallbacks[name] = [];
	    }
	
	    playerCallbacks[name].push(callback);
	    callbackMap.set(player.element, playerCallbacks);
	  }
	  /**
	   * Get the callbacks for a player and event or method.
	   *
	   * @param {Player} player The player object.
	   * @param {string} name The method or event name
	   * @return {function[]}
	   */
	
	  function getCallbacks(player, name) {
	    var playerCallbacks = callbackMap.get(player.element) || {};
	    return playerCallbacks[name] || [];
	  }
	  /**
	   * Remove a stored callback for a method or event for a player.
	   *
	   * @param {Player} player The player object.
	   * @param {string} name The method or event name
	   * @param {function} [callback] The specific callback to remove.
	   * @return {boolean} Was this the last callback?
	   */
	
	  function removeCallback(player, name, callback) {
	    var playerCallbacks = callbackMap.get(player.element) || {};
	
	    if (!playerCallbacks[name]) {
	      return true;
	    } // If no callback is passed, remove all callbacks for the event
	
	
	    if (!callback) {
	      playerCallbacks[name] = [];
	      callbackMap.set(player.element, playerCallbacks);
	      return true;
	    }
	
	    var index = playerCallbacks[name].indexOf(callback);
	
	    if (index !== -1) {
	      playerCallbacks[name].splice(index, 1);
	    }
	
	    callbackMap.set(player.element, playerCallbacks);
	    return playerCallbacks[name] && playerCallbacks[name].length === 0;
	  }
	  /**
	   * Return the first stored callback for a player and event or method.
	   *
	   * @param {Player} player The player object.
	   * @param {string} name The method or event name.
	   * @return {function} The callback, or false if there were none
	   */
	
	  function shiftCallbacks(player, name) {
	    var playerCallbacks = getCallbacks(player, name);
	
	    if (playerCallbacks.length < 1) {
	      return false;
	    }
	
	    var callback = playerCallbacks.shift();
	    removeCallback(player, name, callback);
	    return callback;
	  }
	  /**
	   * Move callbacks associated with an element to another element.
	   *
	   * @param {HTMLElement} oldElement The old element.
	   * @param {HTMLElement} newElement The new element.
	   * @return {void}
	   */
	
	  function swapCallbacks(oldElement, newElement) {
	    var playerCallbacks = callbackMap.get(oldElement);
	    callbackMap.set(newElement, playerCallbacks);
	    callbackMap.delete(oldElement);
	  }
	
	  /**
	   * @module lib/embed
	   */
	  var oEmbedParameters = ['autopause', 'autoplay', 'background', 'byline', 'color', 'height', 'id', 'loop', 'maxheight', 'maxwidth', 'muted', 'playsinline', 'portrait', 'responsive', 'speed', 'title', 'transparent', 'url', 'width'];
	  /**
	   * Get the 'data-vimeo'-prefixed attributes from an element as an object.
	   *
	   * @param {HTMLElement} element The element.
	   * @param {Object} [defaults={}] The default values to use.
	   * @return {Object<string, string>}
	   */
	
	  function getOEmbedParameters(element) {
	    var defaults = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	    return oEmbedParameters.reduce(function (params, param) {
	      var value = element.getAttribute("data-vimeo-".concat(param));
	
	      if (value || value === '') {
	        params[param] = value === '' ? 1 : value;
	      }
	
	      return params;
	    }, defaults);
	  }
	  /**
	   * Create an embed from oEmbed data inside an element.
	   *
	   * @param {object} data The oEmbed data.
	   * @param {HTMLElement} element The element to put the iframe in.
	   * @return {HTMLIFrameElement} The iframe embed.
	   */
	
	  function createEmbed(_ref, element) {
	    var html = _ref.html;
	
	    if (!element) {
	      throw new TypeError('An element must be provided');
	    }
	
	    if (element.getAttribute('data-vimeo-initialized') !== null) {
	      return element.querySelector('iframe');
	    }
	
	    var div = document.createElement('div');
	    div.innerHTML = html;
	    element.appendChild(div.firstChild);
	    element.setAttribute('data-vimeo-initialized', 'true');
	    return element.querySelector('iframe');
	  }
	  /**
	   * Make an oEmbed call for the specified URL.
	   *
	   * @param {string} videoUrl The vimeo.com url for the video.
	   * @param {Object} [params] Parameters to pass to oEmbed.
	   * @param {HTMLElement} element The element.
	   * @return {Promise}
	   */
	
	  function getOEmbedData(videoUrl) {
	    var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	    var element = arguments.length > 2 ? arguments[2] : undefined;
	    return new Promise(function (resolve, reject) {
	      if (!isVimeoUrl(videoUrl)) {
	        throw new TypeError("\u201C".concat(videoUrl, "\u201D is not a vimeo.com url."));
	      }
	
	      var url = "https://vimeo.com/api/oembed.json?url=".concat(encodeURIComponent(videoUrl), "&domain=").concat(window.location.hostname);
	
	      for (var param in params) {
	        if (params.hasOwnProperty(param)) {
	          url += "&".concat(param, "=").concat(encodeURIComponent(params[param]));
	        }
	      }
	
	      var xhr = 'XDomainRequest' in window ? new XDomainRequest() : new XMLHttpRequest();
	      xhr.open('GET', url, true);
	
	      xhr.onload = function () {
	        if (xhr.status === 404) {
	          reject(new Error("\u201C".concat(videoUrl, "\u201D was not found.")));
	          return;
	        }
	
	        if (xhr.status === 403) {
	          reject(new Error("\u201C".concat(videoUrl, "\u201D is not embeddable.")));
	          return;
	        }
	
	        try {
	          var json = JSON.parse(xhr.responseText); // Check api response for 403 on oembed
	
	          if (json.domain_status_code === 403) {
	            // We still want to create the embed to give users visual feedback
	            createEmbed(json, element);
	            reject(new Error("\u201C".concat(videoUrl, "\u201D is not embeddable.")));
	            return;
	          }
	
	          resolve(json);
	        } catch (error) {
	          reject(error);
	        }
	      };
	
	      xhr.onerror = function () {
	        var status = xhr.status ? " (".concat(xhr.status, ")") : '';
	        reject(new Error("There was an error fetching the embed code from Vimeo".concat(status, ".")));
	      };
	
	      xhr.send();
	    });
	  }
	  /**
	   * Initialize all embeds within a specific element
	   *
	   * @param {HTMLElement} [parent=document] The parent element.
	   * @return {void}
	   */
	
	  function initializeEmbeds() {
	    var parent = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : document;
	    var elements = [].slice.call(parent.querySelectorAll('[data-vimeo-id], [data-vimeo-url]'));
	
	    var handleError = function handleError(error) {
	      if ('console' in window && console.error) {
	        console.error("There was an error creating an embed: ".concat(error));
	      }
	    };
	
	    elements.forEach(function (element) {
	      try {
	        // Skip any that have data-vimeo-defer
	        if (element.getAttribute('data-vimeo-defer') !== null) {
	          return;
	        }
	
	        var params = getOEmbedParameters(element);
	        var url = getVimeoUrl(params);
	        getOEmbedData(url, params, element).then(function (data) {
	          return createEmbed(data, element);
	        }).catch(handleError);
	      } catch (error) {
	        handleError(error);
	      }
	    });
	  }
	  /**
	   * Resize embeds when messaged by the player.
	   *
	   * @param {HTMLElement} [parent=document] The parent element.
	   * @return {void}
	   */
	
	  function resizeEmbeds() {
	    var parent = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : document;
	
	    var onMessage = function onMessage(event) {
	      if (!isVimeoUrl(event.origin)) {
	        return;
	      } // 'spacechange' is fired only on embeds with cards
	
	
	      if (!event.data || event.data.event !== 'spacechange') {
	        return;
	      }
	
	      var iframes = parent.querySelectorAll('iframe');
	
	      for (var i = 0; i < iframes.length; i++) {
	        if (iframes[i].contentWindow !== event.source) {
	          continue;
	        } // Change padding-bottom of the enclosing div to accommodate
	        // card carousel without distorting aspect ratio
	
	
	        var space = iframes[i].parentElement;
	        space.style.paddingBottom = "".concat(event.data.data[0].bottom, "px");
	        break;
	      }
	    };
	
	    if (window.addEventListener) {
	      window.addEventListener('message', onMessage, false);
	    } else if (window.attachEvent) {
	      window.attachEvent('onmessage', onMessage);
	    }
	  }
	
	  /**
	   * @module lib/postmessage
	   */
	  /**
	   * Parse a message received from postMessage.
	   *
	   * @param {*} data The data received from postMessage.
	   * @return {object}
	   */
	
	  function parseMessageData(data) {
	    if (typeof data === 'string') {
	      data = JSON.parse(data);
	    }
	
	    return data;
	  }
	  /**
	   * Post a message to the specified target.
	   *
	   * @param {Player} player The player object to use.
	   * @param {string} method The API method to call.
	   * @param {object} params The parameters to send to the player.
	   * @return {void}
	   */
	
	  function postMessage(player, method, params) {
	    if (!player.element.contentWindow || !player.element.contentWindow.postMessage) {
	      return;
	    }
	
	    var message = {
	      method: method
	    };
	
	    if (params !== undefined) {
	      message.value = params;
	    } // IE 8 and 9 do not support passing messages, so stringify them
	
	
	    var ieVersion = parseFloat(navigator.userAgent.toLowerCase().replace(/^.*msie (\d+).*$/, '$1'));
	
	    if (ieVersion >= 8 && ieVersion < 10) {
	      message = JSON.stringify(message);
	    }
	
	    player.element.contentWindow.postMessage(message, player.origin);
	  }
	  /**
	   * Parse the data received from a message event.
	   *
	   * @param {Player} player The player that received the message.
	   * @param {(Object|string)} data The message data. Strings will be parsed into JSON.
	   * @return {void}
	   */
	
	  function processData(player, data) {
	    data = parseMessageData(data);
	    var callbacks = [];
	    var param;
	
	    if (data.event) {
	      if (data.event === 'error') {
	        var promises = getCallbacks(player, data.data.method);
	        promises.forEach(function (promise) {
	          var error = new Error(data.data.message);
	          error.name = data.data.name;
	          promise.reject(error);
	          removeCallback(player, data.data.method, promise);
	        });
	      }
	
	      callbacks = getCallbacks(player, "event:".concat(data.event));
	      param = data.data;
	    } else if (data.method) {
	      var callback = shiftCallbacks(player, data.method);
	
	      if (callback) {
	        callbacks.push(callback);
	        param = data.value;
	      }
	    }
	
	    callbacks.forEach(function (callback) {
	      try {
	        if (typeof callback === 'function') {
	          callback.call(player, param);
	          return;
	        }
	
	        callback.resolve(param);
	      } catch (e) {// empty
	      }
	    });
	  }
	
	  var playerMap = new WeakMap();
	  var readyMap = new WeakMap();
	
	  var Player =
	  /*#__PURE__*/
	  function () {
	    /**
	     * Create a Player.
	     *
	     * @param {(HTMLIFrameElement|HTMLElement|string|jQuery)} element A reference to the Vimeo
	     *        player iframe, and id, or a jQuery object.
	     * @param {object} [options] oEmbed parameters to use when creating an embed in the element.
	     * @return {Player}
	     */
	    function Player(element) {
	      var _this = this;
	
	      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	      _classCallCheck(this, Player);
	
	      /* global jQuery */
	      if (window.jQuery && element instanceof jQuery) {
	        if (element.length > 1 && window.console && console.warn) {
	          console.warn('A jQuery object with multiple elements was passed, using the first element.');
	        }
	
	        element = element[0];
	      } // Find an element by ID
	
	
	      if (typeof document !== 'undefined' && typeof element === 'string') {
	        element = document.getElementById(element);
	      } // Not an element!
	
	
	      if (!isDomElement(element)) {
	        throw new TypeError('You must pass either a valid element or a valid id.');
	      } // Already initialized an embed in this div, so grab the iframe
	
	
	      if (element.nodeName !== 'IFRAME') {
	        var iframe = element.querySelector('iframe');
	
	        if (iframe) {
	          element = iframe;
	        }
	      } // iframe url is not a Vimeo url
	
	
	      if (element.nodeName === 'IFRAME' && !isVimeoUrl(element.getAttribute('src') || '')) {
	        throw new Error('The player element passed isn’t a Vimeo embed.');
	      } // If there is already a player object in the map, return that
	
	
	      if (playerMap.has(element)) {
	        return playerMap.get(element);
	      }
	
	      this.element = element;
	      this.origin = '*';
	      var readyPromise = new npo_src(function (resolve, reject) {
	        var onMessage = function onMessage(event) {
	          if (!isVimeoUrl(event.origin) || _this.element.contentWindow !== event.source) {
	            return;
	          }
	
	          if (_this.origin === '*') {
	            _this.origin = event.origin;
	          }
	
	          var data = parseMessageData(event.data);
	          var isReadyEvent = 'event' in data && data.event === 'ready';
	          var isPingResponse = 'method' in data && data.method === 'ping';
	
	          if (isReadyEvent || isPingResponse) {
	            _this.element.setAttribute('data-ready', 'true');
	
	            resolve();
	            return;
	          }
	
	          processData(_this, data);
	        };
	
	        if (window.addEventListener) {
	          window.addEventListener('message', onMessage, false);
	        } else if (window.attachEvent) {
	          window.attachEvent('onmessage', onMessage);
	        }
	
	        if (_this.element.nodeName !== 'IFRAME') {
	          var params = getOEmbedParameters(element, options);
	          var url = getVimeoUrl(params);
	          getOEmbedData(url, params, element).then(function (data) {
	            var iframe = createEmbed(data, element); // Overwrite element with the new iframe,
	            // but store reference to the original element
	
	            _this.element = iframe;
	            _this._originalElement = element;
	            swapCallbacks(element, iframe);
	            playerMap.set(_this.element, _this);
	            return data;
	          }).catch(function (error) {
	            return reject(error);
	          });
	        }
	      }); // Store a copy of this Player in the map
	
	      readyMap.set(this, readyPromise);
	      playerMap.set(this.element, this); // Send a ping to the iframe so the ready promise will be resolved if
	      // the player is already ready.
	
	      if (this.element.nodeName === 'IFRAME') {
	        postMessage(this, 'ping');
	      }
	
	      return this;
	    }
	    /**
	     * Get a promise for a method.
	     *
	     * @param {string} name The API method to call.
	     * @param {Object} [args={}] Arguments to send via postMessage.
	     * @return {Promise}
	     */
	
	
	    _createClass(Player, [{
	      key: "callMethod",
	      value: function callMethod(name) {
	        var _this2 = this;
	
	        var args = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	        return new npo_src(function (resolve, reject) {
	          // We are storing the resolve/reject handlers to call later, so we
	          // can’t return here.
	          // eslint-disable-next-line promise/always-return
	          return _this2.ready().then(function () {
	            storeCallback(_this2, name, {
	              resolve: resolve,
	              reject: reject
	            });
	            postMessage(_this2, name, args);
	          }).catch(function (error) {
	            reject(error);
	          });
	        });
	      }
	      /**
	       * Get a promise for the value of a player property.
	       *
	       * @param {string} name The property name
	       * @return {Promise}
	       */
	
	    }, {
	      key: "get",
	      value: function get(name) {
	        var _this3 = this;
	
	        return new npo_src(function (resolve, reject) {
	          name = getMethodName(name, 'get'); // We are storing the resolve/reject handlers to call later, so we
	          // can’t return here.
	          // eslint-disable-next-line promise/always-return
	
	          return _this3.ready().then(function () {
	            storeCallback(_this3, name, {
	              resolve: resolve,
	              reject: reject
	            });
	            postMessage(_this3, name);
	          });
	        });
	      }
	      /**
	       * Get a promise for setting the value of a player property.
	       *
	       * @param {string} name The API method to call.
	       * @param {mixed} value The value to set.
	       * @return {Promise}
	       */
	
	    }, {
	      key: "set",
	      value: function set(name, value) {
	        var _this4 = this;
	
	        return npo_src.resolve(value).then(function (val) {
	          name = getMethodName(name, 'set');
	
	          if (val === undefined || val === null) {
	            throw new TypeError('There must be a value to set.');
	          }
	
	          return _this4.ready().then(function () {
	            return new npo_src(function (resolve, reject) {
	              storeCallback(_this4, name, {
	                resolve: resolve,
	                reject: reject
	              });
	              postMessage(_this4, name, val);
	            });
	          });
	        });
	      }
	      /**
	       * Add an event listener for the specified event. Will call the
	       * callback with a single parameter, `data`, that contains the data for
	       * that event.
	       *
	       * @param {string} eventName The name of the event.
	       * @param {function(*)} callback The function to call when the event fires.
	       * @return {void}
	       */
	
	    }, {
	      key: "on",
	      value: function on(eventName, callback) {
	        if (!eventName) {
	          throw new TypeError('You must pass an event name.');
	        }
	
	        if (!callback) {
	          throw new TypeError('You must pass a callback function.');
	        }
	
	        if (typeof callback !== 'function') {
	          throw new TypeError('The callback must be a function.');
	        }
	
	        var callbacks = getCallbacks(this, "event:".concat(eventName));
	
	        if (callbacks.length === 0) {
	          this.callMethod('addEventListener', eventName).catch(function () {// Ignore the error. There will be an error event fired that
	            // will trigger the error callback if they are listening.
	          });
	        }
	
	        storeCallback(this, "event:".concat(eventName), callback);
	      }
	      /**
	       * Remove an event listener for the specified event. Will remove all
	       * listeners for that event if a `callback` isn’t passed, or only that
	       * specific callback if it is passed.
	       *
	       * @param {string} eventName The name of the event.
	       * @param {function} [callback] The specific callback to remove.
	       * @return {void}
	       */
	
	    }, {
	      key: "off",
	      value: function off(eventName, callback) {
	        if (!eventName) {
	          throw new TypeError('You must pass an event name.');
	        }
	
	        if (callback && typeof callback !== 'function') {
	          throw new TypeError('The callback must be a function.');
	        }
	
	        var lastCallback = removeCallback(this, "event:".concat(eventName), callback); // If there are no callbacks left, remove the listener
	
	        if (lastCallback) {
	          this.callMethod('removeEventListener', eventName).catch(function (e) {// Ignore the error. There will be an error event fired that
	            // will trigger the error callback if they are listening.
	          });
	        }
	      }
	      /**
	       * A promise to load a new video.
	       *
	       * @promise LoadVideoPromise
	       * @fulfill {number} The video with this id successfully loaded.
	       * @reject {TypeError} The id was not a number.
	       */
	
	      /**
	       * Load a new video into this embed. The promise will be resolved if
	       * the video is successfully loaded, or it will be rejected if it could
	       * not be loaded.
	       *
	       * @param {number} id The id of the video.
	       * @return {LoadVideoPromise}
	       */
	
	    }, {
	      key: "loadVideo",
	      value: function loadVideo(id) {
	        return this.callMethod('loadVideo', id);
	      }
	      /**
	       * A promise to perform an action when the Player is ready.
	       *
	       * @todo document errors
	       * @promise LoadVideoPromise
	       * @fulfill {void}
	       */
	
	      /**
	       * Trigger a function when the player iframe has initialized. You do not
	       * need to wait for `ready` to trigger to begin adding event listeners
	       * or calling other methods.
	       *
	       * @return {ReadyPromise}
	       */
	
	    }, {
	      key: "ready",
	      value: function ready() {
	        var readyPromise = readyMap.get(this) || new npo_src(function (resolve, reject) {
	          reject(new Error('Unknown player. Probably unloaded.'));
	        });
	        return npo_src.resolve(readyPromise);
	      }
	      /**
	       * A promise to add a cue point to the player.
	       *
	       * @promise AddCuePointPromise
	       * @fulfill {string} The id of the cue point to use for removeCuePoint.
	       * @reject {RangeError} the time was less than 0 or greater than the
	       *         video’s duration.
	       * @reject {UnsupportedError} Cue points are not supported with the current
	       *         player or browser.
	       */
	
	      /**
	       * Add a cue point to the player.
	       *
	       * @param {number} time The time for the cue point.
	       * @param {object} [data] Arbitrary data to be returned with the cue point.
	       * @return {AddCuePointPromise}
	       */
	
	    }, {
	      key: "addCuePoint",
	      value: function addCuePoint(time) {
	        var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	        return this.callMethod('addCuePoint', {
	          time: time,
	          data: data
	        });
	      }
	      /**
	       * A promise to remove a cue point from the player.
	       *
	       * @promise AddCuePointPromise
	       * @fulfill {string} The id of the cue point that was removed.
	       * @reject {InvalidCuePoint} The cue point with the specified id was not
	       *         found.
	       * @reject {UnsupportedError} Cue points are not supported with the current
	       *         player or browser.
	       */
	
	      /**
	       * Remove a cue point from the video.
	       *
	       * @param {string} id The id of the cue point to remove.
	       * @return {RemoveCuePointPromise}
	       */
	
	    }, {
	      key: "removeCuePoint",
	      value: function removeCuePoint(id) {
	        return this.callMethod('removeCuePoint', id);
	      }
	      /**
	       * A representation of a text track on a video.
	       *
	       * @typedef {Object} VimeoTextTrack
	       * @property {string} language The ISO language code.
	       * @property {string} kind The kind of track it is (captions or subtitles).
	       * @property {string} label The human‐readable label for the track.
	       */
	
	      /**
	       * A promise to enable a text track.
	       *
	       * @promise EnableTextTrackPromise
	       * @fulfill {VimeoTextTrack} The text track that was enabled.
	       * @reject {InvalidTrackLanguageError} No track was available with the
	       *         specified language.
	       * @reject {InvalidTrackError} No track was available with the specified
	       *         language and kind.
	       */
	
	      /**
	       * Enable the text track with the specified language, and optionally the
	       * specified kind (captions or subtitles).
	       *
	       * When set via the API, the track language will not change the viewer’s
	       * stored preference.
	       *
	       * @param {string} language The two‐letter language code.
	       * @param {string} [kind] The kind of track to enable (captions or subtitles).
	       * @return {EnableTextTrackPromise}
	       */
	
	    }, {
	      key: "enableTextTrack",
	      value: function enableTextTrack(language, kind) {
	        if (!language) {
	          throw new TypeError('You must pass a language.');
	        }
	
	        return this.callMethod('enableTextTrack', {
	          language: language,
	          kind: kind
	        });
	      }
	      /**
	       * A promise to disable the active text track.
	       *
	       * @promise DisableTextTrackPromise
	       * @fulfill {void} The track was disabled.
	       */
	
	      /**
	       * Disable the currently-active text track.
	       *
	       * @return {DisableTextTrackPromise}
	       */
	
	    }, {
	      key: "disableTextTrack",
	      value: function disableTextTrack() {
	        return this.callMethod('disableTextTrack');
	      }
	      /**
	       * A promise to pause the video.
	       *
	       * @promise PausePromise
	       * @fulfill {void} The video was paused.
	       */
	
	      /**
	       * Pause the video if it’s playing.
	       *
	       * @return {PausePromise}
	       */
	
	    }, {
	      key: "pause",
	      value: function pause() {
	        return this.callMethod('pause');
	      }
	      /**
	       * A promise to play the video.
	       *
	       * @promise PlayPromise
	       * @fulfill {void} The video was played.
	       */
	
	      /**
	       * Play the video if it’s paused. **Note:** on iOS and some other
	       * mobile devices, you cannot programmatically trigger play. Once the
	       * viewer has tapped on the play button in the player, however, you
	       * will be able to use this function.
	       *
	       * @return {PlayPromise}
	       */
	
	    }, {
	      key: "play",
	      value: function play() {
	        return this.callMethod('play');
	      }
	      /**
	       * A promise to unload the video.
	       *
	       * @promise UnloadPromise
	       * @fulfill {void} The video was unloaded.
	       */
	
	      /**
	       * Return the player to its initial state.
	       *
	       * @return {UnloadPromise}
	       */
	
	    }, {
	      key: "unload",
	      value: function unload() {
	        return this.callMethod('unload');
	      }
	      /**
	       * Cleanup the player and remove it from the DOM
	       *
	       * It won't be usable and a new one should be constructed
	       *  in order to do any operations.
	       *
	       * @return {Promise}
	       */
	
	    }, {
	      key: "destroy",
	      value: function destroy() {
	        var _this5 = this;
	
	        return new npo_src(function (resolve) {
	          readyMap.delete(_this5);
	          playerMap.delete(_this5.element);
	
	          if (_this5._originalElement) {
	            playerMap.delete(_this5._originalElement);
	
	            _this5._originalElement.removeAttribute('data-vimeo-initialized');
	          }
	
	          if (_this5.element && _this5.element.nodeName === 'IFRAME') {
	            _this5.element.remove();
	          }
	
	          resolve();
	        });
	      }
	      /**
	       * A promise to get the autopause behavior of the video.
	       *
	       * @promise GetAutopausePromise
	       * @fulfill {boolean} Whether autopause is turned on or off.
	       * @reject {UnsupportedError} Autopause is not supported with the current
	       *         player or browser.
	       */
	
	      /**
	       * Get the autopause behavior for this player.
	       *
	       * @return {GetAutopausePromise}
	       */
	
	    }, {
	      key: "getAutopause",
	      value: function getAutopause() {
	        return this.get('autopause');
	      }
	      /**
	       * A promise to set the autopause behavior of the video.
	       *
	       * @promise SetAutopausePromise
	       * @fulfill {boolean} Whether autopause is turned on or off.
	       * @reject {UnsupportedError} Autopause is not supported with the current
	       *         player or browser.
	       */
	
	      /**
	       * Enable or disable the autopause behavior of this player.
	       *
	       * By default, when another video is played in the same browser, this
	       * player will automatically pause. Unless you have a specific reason
	       * for doing so, we recommend that you leave autopause set to the
	       * default (`true`).
	       *
	       * @param {boolean} autopause
	       * @return {SetAutopausePromise}
	       */
	
	    }, {
	      key: "setAutopause",
	      value: function setAutopause(autopause) {
	        return this.set('autopause', autopause);
	      }
	      /**
	       * A promise to get the color of the player.
	       *
	       * @promise GetColorPromise
	       * @fulfill {string} The hex color of the player.
	       */
	
	      /**
	       * Get the color for this player.
	       *
	       * @return {GetColorPromise}
	       */
	
	    }, {
	      key: "getColor",
	      value: function getColor() {
	        return this.get('color');
	      }
	      /**
	       * A promise to set the color of the player.
	       *
	       * @promise SetColorPromise
	       * @fulfill {string} The color was successfully set.
	       * @reject {TypeError} The string was not a valid hex or rgb color.
	       * @reject {ContrastError} The color was set, but the contrast is
	       *         outside of the acceptable range.
	       * @reject {EmbedSettingsError} The owner of the player has chosen to
	       *         use a specific color.
	       */
	
	      /**
	       * Set the color of this player to a hex or rgb string. Setting the
	       * color may fail if the owner of the video has set their embed
	       * preferences to force a specific color.
	       *
	       * @param {string} color The hex or rgb color string to set.
	       * @return {SetColorPromise}
	       */
	
	    }, {
	      key: "setColor",
	      value: function setColor(color) {
	        return this.set('color', color);
	      }
	      /**
	       * A representation of a cue point.
	       *
	       * @typedef {Object} VimeoCuePoint
	       * @property {number} time The time of the cue point.
	       * @property {object} data The data passed when adding the cue point.
	       * @property {string} id The unique id for use with removeCuePoint.
	       */
	
	      /**
	       * A promise to get the cue points of a video.
	       *
	       * @promise GetCuePointsPromise
	       * @fulfill {VimeoCuePoint[]} The cue points added to the video.
	       * @reject {UnsupportedError} Cue points are not supported with the current
	       *         player or browser.
	       */
	
	      /**
	       * Get an array of the cue points added to the video.
	       *
	       * @return {GetCuePointsPromise}
	       */
	
	    }, {
	      key: "getCuePoints",
	      value: function getCuePoints() {
	        return this.get('cuePoints');
	      }
	      /**
	       * A promise to get the current time of the video.
	       *
	       * @promise GetCurrentTimePromise
	       * @fulfill {number} The current time in seconds.
	       */
	
	      /**
	       * Get the current playback position in seconds.
	       *
	       * @return {GetCurrentTimePromise}
	       */
	
	    }, {
	      key: "getCurrentTime",
	      value: function getCurrentTime() {
	        return this.get('currentTime');
	      }
	      /**
	       * A promise to set the current time of the video.
	       *
	       * @promise SetCurrentTimePromise
	       * @fulfill {number} The actual current time that was set.
	       * @reject {RangeError} the time was less than 0 or greater than the
	       *         video’s duration.
	       */
	
	      /**
	       * Set the current playback position in seconds. If the player was
	       * paused, it will remain paused. Likewise, if the player was playing,
	       * it will resume playing once the video has buffered.
	       *
	       * You can provide an accurate time and the player will attempt to seek
	       * to as close to that time as possible. The exact time will be the
	       * fulfilled value of the promise.
	       *
	       * @param {number} currentTime
	       * @return {SetCurrentTimePromise}
	       */
	
	    }, {
	      key: "setCurrentTime",
	      value: function setCurrentTime(currentTime) {
	        return this.set('currentTime', currentTime);
	      }
	      /**
	       * A promise to get the duration of the video.
	       *
	       * @promise GetDurationPromise
	       * @fulfill {number} The duration in seconds.
	       */
	
	      /**
	       * Get the duration of the video in seconds. It will be rounded to the
	       * nearest second before playback begins, and to the nearest thousandth
	       * of a second after playback begins.
	       *
	       * @return {GetDurationPromise}
	       */
	
	    }, {
	      key: "getDuration",
	      value: function getDuration() {
	        return this.get('duration');
	      }
	      /**
	       * A promise to get the ended state of the video.
	       *
	       * @promise GetEndedPromise
	       * @fulfill {boolean} Whether or not the video has ended.
	       */
	
	      /**
	       * Get the ended state of the video. The video has ended if
	       * `currentTime === duration`.
	       *
	       * @return {GetEndedPromise}
	       */
	
	    }, {
	      key: "getEnded",
	      value: function getEnded() {
	        return this.get('ended');
	      }
	      /**
	       * A promise to get the loop state of the player.
	       *
	       * @promise GetLoopPromise
	       * @fulfill {boolean} Whether or not the player is set to loop.
	       */
	
	      /**
	       * Get the loop state of the player.
	       *
	       * @return {GetLoopPromise}
	       */
	
	    }, {
	      key: "getLoop",
	      value: function getLoop() {
	        return this.get('loop');
	      }
	      /**
	       * A promise to set the loop state of the player.
	       *
	       * @promise SetLoopPromise
	       * @fulfill {boolean} The loop state that was set.
	       */
	
	      /**
	       * Set the loop state of the player. When set to `true`, the player
	       * will start over immediately once playback ends.
	       *
	       * @param {boolean} loop
	       * @return {SetLoopPromise}
	       */
	
	    }, {
	      key: "setLoop",
	      value: function setLoop(loop) {
	        return this.set('loop', loop);
	      }
	      /**
	       * A promise to get the paused state of the player.
	       *
	       * @promise GetLoopPromise
	       * @fulfill {boolean} Whether or not the video is paused.
	       */
	
	      /**
	       * Get the paused state of the player.
	       *
	       * @return {GetLoopPromise}
	       */
	
	    }, {
	      key: "getPaused",
	      value: function getPaused() {
	        return this.get('paused');
	      }
	      /**
	       * A promise to get the playback rate of the player.
	       *
	       * @promise GetPlaybackRatePromise
	       * @fulfill {number} The playback rate of the player on a scale from 0.5 to 2.
	       */
	
	      /**
	       * Get the playback rate of the player on a scale from `0.5` to `2`.
	       *
	       * @return {GetPlaybackRatePromise}
	       */
	
	    }, {
	      key: "getPlaybackRate",
	      value: function getPlaybackRate() {
	        return this.get('playbackRate');
	      }
	      /**
	       * A promise to set the playbackrate of the player.
	       *
	       * @promise SetPlaybackRatePromise
	       * @fulfill {number} The playback rate was set.
	       * @reject {RangeError} The playback rate was less than 0.5 or greater than 2.
	       */
	
	      /**
	       * Set the playback rate of the player on a scale from `0.5` to `2`. When set
	       * via the API, the playback rate will not be synchronized to other
	       * players or stored as the viewer's preference.
	       *
	       * @param {number} playbackRate
	       * @return {SetPlaybackRatePromise}
	       */
	
	    }, {
	      key: "setPlaybackRate",
	      value: function setPlaybackRate(playbackRate) {
	        return this.set('playbackRate', playbackRate);
	      }
	      /**
	       * A promise to get the text tracks of a video.
	       *
	       * @promise GetTextTracksPromise
	       * @fulfill {VimeoTextTrack[]} The text tracks associated with the video.
	       */
	
	      /**
	       * Get an array of the text tracks that exist for the video.
	       *
	       * @return {GetTextTracksPromise}
	       */
	
	    }, {
	      key: "getTextTracks",
	      value: function getTextTracks() {
	        return this.get('textTracks');
	      }
	      /**
	       * A promise to get the embed code for the video.
	       *
	       * @promise GetVideoEmbedCodePromise
	       * @fulfill {string} The `<iframe>` embed code for the video.
	       */
	
	      /**
	       * Get the `<iframe>` embed code for the video.
	       *
	       * @return {GetVideoEmbedCodePromise}
	       */
	
	    }, {
	      key: "getVideoEmbedCode",
	      value: function getVideoEmbedCode() {
	        return this.get('videoEmbedCode');
	      }
	      /**
	       * A promise to get the id of the video.
	       *
	       * @promise GetVideoIdPromise
	       * @fulfill {number} The id of the video.
	       */
	
	      /**
	       * Get the id of the video.
	       *
	       * @return {GetVideoIdPromise}
	       */
	
	    }, {
	      key: "getVideoId",
	      value: function getVideoId() {
	        return this.get('videoId');
	      }
	      /**
	       * A promise to get the title of the video.
	       *
	       * @promise GetVideoTitlePromise
	       * @fulfill {number} The title of the video.
	       */
	
	      /**
	       * Get the title of the video.
	       *
	       * @return {GetVideoTitlePromise}
	       */
	
	    }, {
	      key: "getVideoTitle",
	      value: function getVideoTitle() {
	        return this.get('videoTitle');
	      }
	      /**
	       * A promise to get the native width of the video.
	       *
	       * @promise GetVideoWidthPromise
	       * @fulfill {number} The native width of the video.
	       */
	
	      /**
	       * Get the native width of the currently‐playing video. The width of
	       * the highest‐resolution available will be used before playback begins.
	       *
	       * @return {GetVideoWidthPromise}
	       */
	
	    }, {
	      key: "getVideoWidth",
	      value: function getVideoWidth() {
	        return this.get('videoWidth');
	      }
	      /**
	       * A promise to get the native height of the video.
	       *
	       * @promise GetVideoHeightPromise
	       * @fulfill {number} The native height of the video.
	       */
	
	      /**
	       * Get the native height of the currently‐playing video. The height of
	       * the highest‐resolution available will be used before playback begins.
	       *
	       * @return {GetVideoHeightPromise}
	       */
	
	    }, {
	      key: "getVideoHeight",
	      value: function getVideoHeight() {
	        return this.get('videoHeight');
	      }
	      /**
	       * A promise to get the vimeo.com url for the video.
	       *
	       * @promise GetVideoUrlPromise
	       * @fulfill {number} The vimeo.com url for the video.
	       * @reject {PrivacyError} The url isn’t available because of the video’s privacy setting.
	       */
	
	      /**
	       * Get the vimeo.com url for the video.
	       *
	       * @return {GetVideoUrlPromise}
	       */
	
	    }, {
	      key: "getVideoUrl",
	      value: function getVideoUrl() {
	        return this.get('videoUrl');
	      }
	      /**
	       * A promise to get the volume level of the player.
	       *
	       * @promise GetVolumePromise
	       * @fulfill {number} The volume level of the player on a scale from 0 to 1.
	       */
	
	      /**
	       * Get the current volume level of the player on a scale from `0` to `1`.
	       *
	       * Most mobile devices do not support an independent volume from the
	       * system volume. In those cases, this method will always return `1`.
	       *
	       * @return {GetVolumePromise}
	       */
	
	    }, {
	      key: "getVolume",
	      value: function getVolume() {
	        return this.get('volume');
	      }
	      /**
	       * A promise to set the volume level of the player.
	       *
	       * @promise SetVolumePromise
	       * @fulfill {number} The volume was set.
	       * @reject {RangeError} The volume was less than 0 or greater than 1.
	       */
	
	      /**
	       * Set the volume of the player on a scale from `0` to `1`. When set
	       * via the API, the volume level will not be synchronized to other
	       * players or stored as the viewer’s preference.
	       *
	       * Most mobile devices do not support setting the volume. An error will
	       * *not* be triggered in that situation.
	       *
	       * @param {number} volume
	       * @return {SetVolumePromise}
	       */
	
	    }, {
	      key: "setVolume",
	      value: function setVolume(volume) {
	        return this.set('volume', volume);
	      }
	    }]);
	
	    return Player;
	  }(); // Setup embed only if this is not a node environment
	  // and if there is no existing Vimeo Player object
	
	
	  if (!isNode && window.Vimeo && !window.Vimeo.Player) {
	    initializeEmbeds();
	    resizeEmbeds();
	  }
	
	  return Player;
	
	})));
	
	//# sourceMappingURL=player.js.map
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }()), __webpack_require__(271).setImmediate))

/***/ },
/* 273 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _redux = __webpack_require__(4);
	
	var _reactRedux = __webpack_require__(5);
	
	var _appDataActions = __webpack_require__(12);
	
	var appDataActions = _interopRequireWildcard(_appDataActions);
	
	var _keyboardConstants = __webpack_require__(14);
	
	var keyboardConstants = _interopRequireWildcard(_keyboardConstants);
	
	var _appHelper = __webpack_require__(3);
	
	var appHelper = _interopRequireWildcard(_appHelper);
	
	var _lodash = __webpack_require__(28);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var TextResize = function (_React$Component) {
	    _inherits(TextResize, _React$Component);
	
	    function TextResize(props, context) {
	        _classCallCheck(this, TextResize);
	
	        var _this = _possibleConstructorReturn(this, (TextResize.__proto__ || Object.getPrototypeOf(TextResize)).call(this, props, context));
	
	        _this.state = {
	            fontSize: _this.props.fontSize,
	            doUpdateFontSize: false,
	            lang: _this.props.lang,
	            increase_font_size_label: appHelper.getLocaleString("increase_font_size_label"),
	            decrease_font_size_label: appHelper.getLocaleString("decrease_font_size_label"),
	            reset_font_size_label: appHelper.getLocaleString("reset_font_size_label")
	        };
	        _this.onIncreaseFont = _this.onIncreaseFont.bind(_this);
	        _this.onDecreaseFont = _this.onDecreaseFont.bind(_this);
	        _this.onResetFont = _this.onResetFont.bind(_this);
	        _this.canIncrease = _this.canIncrease.bind(_this);
	        _this.canDecrease = _this.canDecrease.bind(_this);
	        _this.changeFontSize = _this.changeFontSize.bind(_this);
	        _this.updateFontSize = _this.updateFontSize.bind(_this);
	        _this.onIncreaseFontKeyDown = _this.onIncreaseFontKeyDown.bind(_this);
	        _this.onDecreaseFontKeyDown = _this.onDecreaseFontKeyDown.bind(_this);
	        _this.onResetFontKeyDown = _this.onResetFontKeyDown.bind(_this);
	        return _this;
	    }
	
	    _createClass(TextResize, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {}
	    }, {
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(nextProps) {
	            if (this.state.fontSize !== nextProps.fontSize) {
	                this.setState({ fontSize: nextProps.fontSize });
	            }
	
	            if (this.state.lang !== nextProps.lang) {
	                this.setState({
	                    lang: nextProps.lang,
	                    increase_font_size_label: appHelper.getLocaleString("increase_font_size_label"),
	                    decrease_font_size_label: appHelper.getLocaleString("decrease_font_size_label"),
	                    reset_font_size_label: appHelper.getLocaleString("reset_font_size_label")
	                });
	            }
	        }
	    }, {
	        key: 'componentDidUpdate',
	        value: function componentDidUpdate() {
	            if (this.state.doUpdateFontSize) {
	                this.updateFontSize();
	            }
	        }
	    }, {
	        key: 'updateFontSize',
	        value: function updateFontSize() {
	            this.setState({ doUpdateFontSize: false });
	            this.props.actions.updateFontSize(this.state.fontSize);
	        }
	    }, {
	        key: 'onIncreaseFont',
	        value: function onIncreaseFont(event) {
	            event.stopPropagation();
	            this.changeFontSize(1);
	        }
	    }, {
	        key: 'onDecreaseFont',
	        value: function onDecreaseFont(event) {
	            event.stopPropagation();
	            this.changeFontSize(-1);
	        }
	    }, {
	        key: 'onResetFont',
	        value: function onResetFont(event) {
	            event.stopPropagation();
	            this.setState({
	                fontSize: Object.assign({}, this.state.fontSize, {
	                    currentFontSize: this.state.fontSize.resetFontSize
	                }),
	                doUpdateFontSize: true
	            });
	        }
	    }, {
	        key: 'onIncreaseFontKeyDown',
	        value: function onIncreaseFontKeyDown(event) {
	
	            if (event.which === keyboardConstants.ENTER_KEY || event.which === keyboardConstants.SPACEBAR_KEY) {
	                event.preventDefault();
	                event.stopPropagation();
	                this.changeFontSize(1);
	            }
	        }
	    }, {
	        key: 'onDecreaseFontKeyDown',
	        value: function onDecreaseFontKeyDown(event) {
	
	            if (event.which === keyboardConstants.ENTER_KEY || event.which === keyboardConstants.SPACEBAR_KEY) {
	                event.preventDefault();
	                event.stopPropagation();
	                this.changeFontSize(-1);
	            }
	        }
	    }, {
	        key: 'onResetFontKeyDown',
	        value: function onResetFontKeyDown(event) {
	
	            if (event.which === keyboardConstants.ENTER_KEY || event.which === keyboardConstants.SPACEBAR_KEY) {
	                event.preventDefault();
	                event.stopPropagation();
	                this.setState({
	                    fontSize: Object.assign({}, this.state.fontSize, {
	                        currentFontSize: this.state.fontSize.resetFontSize
	                    }),
	                    doUpdateFontSize: true
	                });
	            }
	        }
	    }, {
	        key: 'changeFontSize',
	        value: function changeFontSize(sizeDifference) {
	            var currentFontSize = parseInt(this.state.fontSize.currentFontSize) + parseInt(sizeDifference * 5);
	            if (currentFontSize > this.state.fontSize.maxFontSize) {
	                currentFontSize = this.state.fontSize.maxFontSize;
	            } else if (currentFontSize < this.state.fontSize.minFontSize) {
	                currentFontSize = this.state.fontSize.minFontSize;
	            }
	            this.setState({
	                fontSize: Object.assign({}, this.state.fontSize, {
	                    currentFontSize: currentFontSize
	                }),
	                doUpdateFontSize: true
	            });
	        }
	    }, {
	        key: 'canIncrease',
	        value: function canIncrease() {
	            return this.state.fontSize.currentFontSize === this.state.fontSize.maxFontSize;
	        }
	    }, {
	        key: 'canDecrease',
	        value: function canDecrease() {
	            return this.state.fontSize.currentFontSize === this.state.fontSize.minFontSize;
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            return _react2.default.createElement(
	                'ul',
	                { className: 'text-resize-list' },
	                _react2.default.createElement(
	                    'li',
	                    { className: 'text-resize-item' },
	                    _react2.default.createElement(
	                        'button',
	                        { className: 'resize-btn increase-font-btn', onClick: this.onIncreaseFont, onKeyDown: this.onIncreaseFontKeyDown,
	                            disabled: this.canIncrease() },
	                        _react2.default.createElement(
	                            'span',
	                            { className: 'hidden-el' },
	                            this.state.increase_font_size_label
	                        )
	                    )
	                ),
	                _react2.default.createElement(
	                    'li',
	                    { className: 'text-resize-item' },
	                    _react2.default.createElement(
	                        'button',
	                        { className: 'resize-btn decrease-font-btn', onClick: this.onDecreaseFont, onKeyDown: this.onDecreaseFontKeyDown,
	                            disabled: this.canDecrease() },
	                        _react2.default.createElement(
	                            'span',
	                            { className: 'hidden-el' },
	                            this.state.decrease_font_size_label
	                        )
	                    )
	                ),
	                _react2.default.createElement(
	                    'li',
	                    { className: 'text-resize-item' },
	                    _react2.default.createElement(
	                        'button',
	                        { className: 'resize-btn reset-font-btn', onClick: this.onResetFont, onKeyDown: this.onResetFontKeyDown },
	                        _react2.default.createElement(
	                            'span',
	                            { className: 'hidden-el' },
	                            this.state.reset_font_size_label
	                        )
	                    )
	                )
	            );
	        }
	    }]);
	
	    return TextResize;
	}(_react2.default.Component);
	
	TextResize.propTypes = {
	    lang: _propTypes2.default.string.isRequired,
	    fontSize: _propTypes2.default.object.isRequired,
	    actions: _propTypes2.default.object.isRequired
	};
	
	function mapStateToProps(state, ownProps) {
	
	    var lang = state.userData.lang;
	    return {
	        lang: lang,
	        fontSize: state.fontSize
	    };
	}
	
	function mapDispatchToProps(dispatch) {
	    return {
	        actions: (0, _redux.bindActionCreators)(Object.assign({}, appDataActions), dispatch)
	    };
	}
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(TextResize);

/***/ },
/* 274 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(5);
	
	var _redux = __webpack_require__(4);
	
	var _dialogPopupActions = __webpack_require__(19);
	
	var dialogPopupActions = _interopRequireWildcard(_dialogPopupActions);
	
	var _appHelper = __webpack_require__(3);
	
	var appHelper = _interopRequireWildcard(_appHelper);
	
	var _dialogModels = __webpack_require__(32);
	
	var _keyboardConstants = __webpack_require__(14);
	
	var keyboardConstants = _interopRequireWildcard(_keyboardConstants);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ExitButton = function (_React$Component) {
	    _inherits(ExitButton, _React$Component);
	
	    function ExitButton(props, context) {
	        _classCallCheck(this, ExitButton);
	
	        var _this = _possibleConstructorReturn(this, (ExitButton.__proto__ || Object.getPrototypeOf(ExitButton)).call(this, props, context));
	
	        _this.state = {
	            lang: _this.props.lang,
	            label: appHelper.getLocaleString("exit_label")
	        };
	        _this.exit = _this.exit.bind(_this);
	        _this.setBtnClass = _this.setBtnClass.bind(_this);
	        _this.setIconClass = _this.setIconClass.bind(_this);
	        _this.setKeyboardAccessibility = _this.setKeyboardAccessibility.bind(_this);
	        return _this;
	    }
	
	    _createClass(ExitButton, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {}
	    }, {
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(nextProps) {
	            if (this.state.lang !== nextProps.lang) {
	                this.setState({
	                    lang: nextProps.lang,
	                    label: appHelper.getLocaleString("exit_label")
	                });
	            }
	        }
	    }, {
	        key: 'exit',
	        value: function exit() {
	            var config = Object.assign({}, _dialogModels.EXIT_CONFIG, {
	                sourceId: "exitBtn"
	            });
	            this.props.actions.setNewDialog(config);
	        }
	    }, {
	        key: 'setBtnClass',
	        value: function setBtnClass() {
	            var disabled = false;
	            if (appHelper.isDefined(this.props.disabled)) {
	                disabled = this.props.disabled;
	            }
	
	            return disabled ? "disabled" : "";
	        }
	    }, {
	        key: 'setIconClass',
	        value: function setIconClass() {
	            return "icons8-cirlced-close";
	        }
	    }, {
	        key: 'setKeyboardAccessibility',
	        value: function setKeyboardAccessibility(event) {
	            if (event.which === keyboardConstants.ENTER_KEY || event.which === keyboardConstants.SPACEBAR_KEY) {
	                event.preventDefault();
	                this.exit();
	            }
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            return _react2.default.createElement(
	                'div',
	                { className: 'header-btn ' + this.setBtnClass(), onClick: this.exit, onKeyDown: this.setKeyboardAccessibility, role: 'link', tabIndex: '0', 'aria-controls': 'exit', title: 'Exit', id: 'exitBtn', ref: this.state.label, 'aria-disabled': this.props.disabled },
	                _react2.default.createElement('div', { className: 'icon ' + this.setIconClass() + ' ' }),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'btn-label' },
	                    this.state.label
	                )
	            );
	        }
	    }]);
	
	    return ExitButton;
	}(_react2.default.Component);
	
	ExitButton.propTypes = {
	    disabled: _propTypes2.default.bool,
	    lang: _propTypes2.default.string.isRequired,
	    actions: _propTypes2.default.object.isRequired
	
	};
	
	ExitButton.contextTypes = {
	
	    router: _propTypes2.default.object
	};
	
	function mapStateToProps(state, ownProps) {
	    var lang = state.userData.lang;
	    return {
	        lang: lang
	    };
	}
	
	function mapDispatchToProps(dispatch) {
	    return {
	        actions: (0, _redux.bindActionCreators)(Object.assign({}, dialogPopupActions), dispatch)
	    };
	}
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(ExitButton);

/***/ },
/* 275 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(5);
	
	var _redux = __webpack_require__(4);
	
	var _initActions = __webpack_require__(64);
	
	var initActions = _interopRequireWildcard(_initActions);
	
	var _trackingDataActions = __webpack_require__(7);
	
	var trackingDataActions = _interopRequireWildcard(_trackingDataActions);
	
	var _appHelper = __webpack_require__(3);
	
	var appHelper = _interopRequireWildcard(_appHelper);
	
	var _objectConstants = __webpack_require__(9);
	
	var objectConstants = _interopRequireWildcard(_objectConstants);
	
	var _gsap = __webpack_require__(8);
	
	var _gsapReactPlugin = __webpack_require__(10);
	
	var _gsapReactPlugin2 = _interopRequireDefault(_gsapReactPlugin);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var IconButton = function (_React$Component) {
	    _inherits(IconButton, _React$Component);
	
	    function IconButton(props, context) {
	        _classCallCheck(this, IconButton);
	
	        var _this = _possibleConstructorReturn(this, (IconButton.__proto__ || Object.getPrototypeOf(IconButton)).call(this, props, context));
	
	        _this.state = {};
	        _this.show = _this.show.bind(_this);
	        _this.setAlignment = _this.setAlignment.bind(_this);
	        _this.onComplete = _this.onComplete.bind(_this);
	        return _this;
	    }
	
	    _createClass(IconButton, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            this.show();
	        }
	    }, {
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(nextProps) {}
	    }, {
	        key: 'show',
	        value: function show() {
	            var optionRef = this.refs[this.props.id];
	            _gsap.TweenLite.set(optionRef, { height: "auto" });
	            _gsap.TweenLite.from(optionRef, objectConstants.BUTTON_DURATION, {
	                height: 0,
	                ease: _gsap.Expo.easeInOut
	            }).eventCallback("onComplete", this.onComplete);
	        }
	    }, {
	        key: 'onComplete',
	        value: function onComplete() {}
	    }, {
	        key: 'setAlignment',
	        value: function setAlignment() {
	            if (typeof this.props.alignment !== "undefined") {
	                return this.props.alignment;
	            } else {
	                return "text-center";
	            }
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	
	            return _react2.default.createElement(
	                'div',
	                { className: 'object-container ' + this.setAlignment(), ref: this.props.id },
	                _react2.default.createElement(
	                    'button',
	                    { className: 'btn btn-lg guroo-btn ' + this.props.class, disabled: this.props.isDisabled, onClick: this.props.onClick },
	                    this.props.label
	                )
	            );
	        }
	    }]);
	
	    return IconButton;
	}(_react2.default.Component);
	
	IconButton.propTypes = {
	    label: _propTypes2.default.string,
	    class: _propTypes2.default.string.isRequired,
	    onClick: _propTypes2.default.func.isRequired,
	    id: _propTypes2.default.string.isRequired,
	    alignment: _propTypes2.default.string,
	    isDisabled: _propTypes2.default.bool
	};
	
	IconButton.contextTypes = {
	    router: _propTypes2.default.object
	};
	
	function mapStateToProps(state, ownProps) {
	    return {};
	}
	
	function mapDispatchToProps(dispatch) {
	    return {
	        actions: (0, _redux.bindActionCreators)(Object.assign({}, initActions, trackingDataActions), dispatch)
	    };
	}
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(IconButton);

/***/ },
/* 276 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _redux = __webpack_require__(4);
	
	var _reactRedux = __webpack_require__(5);
	
	var _trackingDataActions = __webpack_require__(7);
	
	var trackingDataActions = _interopRequireWildcard(_trackingDataActions);
	
	var _mainMenuActions = __webpack_require__(134);
	
	var mainMenuActions = _interopRequireWildcard(_mainMenuActions);
	
	var _actionTypes = __webpack_require__(22);
	
	var actionTypes = _interopRequireWildcard(_actionTypes);
	
	var _appHelper = __webpack_require__(3);
	
	var appHelper = _interopRequireWildcard(_appHelper);
	
	var _objectConstants = __webpack_require__(9);
	
	var objectConstants = _interopRequireWildcard(_objectConstants);
	
	var _keyboardConstants = __webpack_require__(14);
	
	var keyboardConstants = _interopRequireWildcard(_keyboardConstants);
	
	var _lodash = __webpack_require__(28);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var MainMenuItem = function (_React$Component) {
	    _inherits(MainMenuItem, _React$Component);
	
	    function MainMenuItem(props, context) {
	        _classCallCheck(this, MainMenuItem);
	
	        var _this = _possibleConstructorReturn(this, (MainMenuItem.__proto__ || Object.getPrototypeOf(MainMenuItem)).call(this, props, context));
	
	        _this.state = {
	            lang: _this.props.lang,
	            locale: appHelper.getLocalData(_this.props.screen),
	            bite: appHelper.getBiteById(_this.props.bite_id),
	            userBite: _this.props.userBite,
	            userScreen: _this.props.userScreen,
	            screen_status: _this.props.userScreen.status,
	            current_screen_id: _this.props.trackingData.lesson_location,
	            isEnabled: false,
	            checkEnabledState: false,
	            setLocale: false
	        };
	
	        _this.loadScreen = _this.loadScreen.bind(_this);
	        _this.setClass = _this.setClass.bind(_this);
	        _this.setEnabledState = _this.setEnabledState.bind(_this);
	        _this.setKeyboardAccessibility = _this.setKeyboardAccessibility.bind(_this);
	        _this.getLocale = _this.getLocale.bind(_this);
	        return _this;
	    }
	
	    _createClass(MainMenuItem, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            this.setEnabledState();
	        }
	    }, {
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(nextProps) {
	            if (this.state.userBite !== nextProps.userBite) {
	                this.setState({
	                    userBite: Object.assign({}, nextProps.userBite),
	                    userScreen: Object.assign({}, nextProps.userScreen),
	                    screen_status: nextProps.userScreen.status,
	                    checkEnabledState: true
	                });
	            }
	            if (this.state.lang !== nextProps.lang) {
	                this.setState({
	                    lang: nextProps.lang,
	                    locale: appHelper.getLocalData(this.props.screen)
	                });
	            }
	        }
	    }, {
	        key: 'componentDidUpdate',
	        value: function componentDidUpdate() {
	            if (this.state.checkEnabledState) {
	                this.setEnabledState();
	            }
	
	            if (this.state.setLocale) {
	                this.getLocale();
	            }
	        }
	    }, {
	        key: 'getLocale',
	        value: function getLocale() {
	            var locale = appHelper.getLocalData(this.state.screen);
	            this.setState({ locale: Object.assign({}, locale), setLocale: false });
	        }
	    }, {
	        key: 'setEnabledState',
	        value: function setEnabledState() {
	
	            var isEnabled = false;
	            if (!this.state.bite.show_target_screens_in_menu && this.state.bite.navigation_type === objectConstants.LINEAR) {
	                isEnabled = appHelper.checkLinearScreenEnabled(this.state.userScreen, this.state.userBite);
	            } else if (this.state.bite.show_target_screens_in_menu && this.state.bite.navigation_type === objectConstants.LINEAR) {
	                //isEnabled = appHelper.checkLinearTargetScreenEnabled(this.state.userScreen, this.state.userBite, this.state.bite.screens);
	                isEnabled = appHelper.checkLinearScreenEnabled(this.state.userScreen, this.state.userBite);
	            } else {
	                isEnabled = true;
	            }
	
	            this.setState({
	                checkEnabledState: false,
	                isEnabled: isEnabled
	            });
	        }
	    }, {
	        key: 'loadScreen',
	        value: function loadScreen() {
	            if (this.state.isEnabled) {
	                this.props.actions.setNewLessonLocation(this.props.screen.screen_id);
	                this.props.actions.setMainMenuDisplay(actionTypes.STATUS_CLOSING);
	            }
	        }
	    }, {
	        key: 'setClass',
	        value: function setClass() {
	            var className = '';
	
	            if (!this.state.isEnabled) {
	                className += 'disabled ';
	            }
	            if (this.props.screen.screen_id === this.state.current_screen_id) {
	                className += objectConstants.CLASS_ACTIVE + ' ';
	            } else if (this.state.bite.show_target_screens_in_menu) {
	                var currentScreen = appHelper.getArrayObjectByKey(this.state.bite.screens, "screen_id", this.state.current_screen_id);
	                if (currentScreen.screen_rule_type !== objectConstants.SCREEN_RULE_TYPE_TARGET) {
	                    var currentScreenIndex = appHelper.getArrayObjectIndexByKey(this.state.bite.screens, "screen_id", this.state.current_screen_id);
	                    var prevTargetScreen = appHelper.getPrevTargetScreen(currentScreenIndex, this.state.bite.screens, "screen_id");
	                    if (prevTargetScreen.screen_id === this.props.screen.screen_id) {
	                        className += objectConstants.CLASS_ACTIVE + ' ';
	                    }
	                }
	            }
	
	            if (this.state.screen_status === objectConstants.STATUS_NOT_REQUIRED) {
	                className += objectConstants.CLASS_NOT_REQUIRED + ' ';
	            } else if (this.state.screen_status === objectConstants.STATUS_IN_PROGRESS) {
	                className += objectConstants.CLASS_IN_PROGRESS + ' ';
	            } else if (this.state.screen_status === objectConstants.STATUS_COMPLETE) {
	                className += objectConstants.CLASS_COMPLETE + ' ';
	            } else {
	                className += objectConstants.CLASS_NOT_STARTED + ' ';
	            }
	
	            return className;
	        }
	    }, {
	        key: 'setKeyboardAccessibility',
	        value: function setKeyboardAccessibility(event) {
	            if (event.which === keyboardConstants.ENTER_KEY || event.which === keyboardConstants.SPACEBAR_KEY) {
	                event.preventDefault();
	                this.loadScreen();
	            }
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            return _react2.default.createElement('div', { className: 'menu-nav-item ' + this.setClass(), onClick: this.loadScreen, onKeyDown: this.setKeyboardAccessibility, role: 'menuitem', tabIndex: !appHelper.isDefined(this.props.isAccessible) || appHelper.isDefined(this.props.isAccessible) && this.props.isAccessible ? "0" : "-1", id: 'menuNavItem_' + this.props.screen.screen_id, dangerouslySetInnerHTML: { __html: this.state.locale.title } });
	        }
	    }]);
	
	    return MainMenuItem;
	}(_react2.default.Component);
	
	MainMenuItem.propTypes = {
	    screen: _propTypes2.default.object.isRequired,
	    userData: _propTypes2.default.object.isRequired,
	    bite_id: _propTypes2.default.number.isRequired,
	    screen_id: _propTypes2.default.number.isRequired,
	    userBite: _propTypes2.default.object.isRequired,
	    userScreen: _propTypes2.default.object.isRequired,
	    isAccessible: _propTypes2.default.bool,
	    //current_screen_id: PropTypes.string.isRequired,
	    trackingData: _propTypes2.default.object.isRequired,
	    lang: _propTypes2.default.string.isRequired,
	    actions: _propTypes2.default.object.isRequired
	};
	
	function mapStateToProps(state, ownProps) {
	    var bite_id = appHelper.getBiteByScreenId(state.trackingData.lesson_location);
	    var screen_id = ownProps.screen.screen_id;
	
	    var userBite = _lodash2.default.find(state.userData.bites, function (bites) {
	        return bites.bite_id === bite_id;
	    });
	
	    var userScreen = _lodash2.default.find(userBite.screens, function (screen) {
	        return screen.screen_id === screen_id;
	    });
	
	    var lang = state.userData.lang;
	    return {
	        screen: ownProps.screen,
	        userData: state.userData,
	        bite_id: bite_id,
	        screen_id: screen_id,
	        userBite: userBite,
	        userScreen: userScreen,
	        trackingData: state.trackingData,
	        lang: lang
	    };
	}
	
	function mapDispatchToProps(dispatch) {
	    return {
	        actions: (0, _redux.bindActionCreators)(Object.assign({}, trackingDataActions, mainMenuActions), dispatch)
	    };
	}
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(MainMenuItem);

/***/ },
/* 277 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.BasicEditor = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _MessagePanel = __webpack_require__(278);
	
	var _MessagePanel2 = _interopRequireDefault(_MessagePanel);
	
	var _appHelper = __webpack_require__(3);
	
	var appHelper = _interopRequireWildcard(_appHelper);
	
	var _gsap = __webpack_require__(8);
	
	var _gsapReactPlugin = __webpack_require__(10);
	
	var _gsapReactPlugin2 = _interopRequireDefault(_gsapReactPlugin);
	
	var _reactQuill = __webpack_require__(1035);
	
	var _reactQuill2 = _interopRequireDefault(_reactQuill);
	
	var _reactDom = __webpack_require__(55);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _keyboardConstants = __webpack_require__(14);
	
	var keyboardConstants = _interopRequireWildcard(_keyboardConstants);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } //eslint-disable-line import/no-named-as-default
	//https://github.com/zenoamaro/react-quill#quick-start
	
	
	var BasicEditor = exports.BasicEditor = function (_React$Component) {
	    _inherits(BasicEditor, _React$Component);
	
	    function BasicEditor(props, context) {
	        _classCallCheck(this, BasicEditor);
	
	        var _this = _possibleConstructorReturn(this, (BasicEditor.__proto__ || Object.getPrototypeOf(BasicEditor)).call(this, props, context));
	
	        _this.state = {
	            inFocus: false,
	            modules: {
	                toolbar: [['bold', 'italic', 'underline', 'align', { 'align': 'center' }, { 'align': 'right' }, { 'list': 'ordered' }, { 'list': 'bullet' }]]
	            },
	            formats: ['align', 'bold', 'italic', 'underline', 'list', 'bullet', 'clean']
	            /*modules: {
	                toolbar: [
	                    ['bold', 'italic'],
	                    [{'list': 'ordered'}, {'list': 'bullet'}],
	                    ['clean']
	                ],
	            },
	            formats: [
	                'bold', 'italic',
	                'list', 'bullet'
	            ]*/
	
	        };
	        _this.getWrapperClass = _this.getWrapperClass.bind(_this);
	        _this.getFieldClass = _this.getFieldClass.bind(_this);
	        _this.onFocusIn = _this.onFocusIn.bind(_this);
	        _this.onFocusOut = _this.onFocusOut.bind(_this);
	        _this.addFocusOutEffect = _this.addFocusOutEffect.bind(_this);
	        _this.onFocusOutComplete = _this.onFocusOutComplete.bind(_this);
	        _this.handleClickOutside = _this.handleClickOutside.bind(_this);
	        _this.setKeyboardAccessibility = _this.setKeyboardAccessibility.bind(_this);
	        return _this;
	    }
	
	    _createClass(BasicEditor, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {}
	    }, {
	        key: 'componentWillUnmount',
	        value: function componentWillUnmount() {}
	    }, {
	        key: 'handleClickOutside',
	        value: function handleClickOutside(event) {
	            if (appHelper.isDefined(_reactDom2.default.findDOMNode(this))) {
	                var domNode = _reactDom2.default.findDOMNode(this);
	
	                if (!domNode || !domNode.contains(event.target)) {
	                    this.onFocusOut();
	                }
	            }
	        }
	    }, {
	        key: 'getWrapperClass',
	        value: function getWrapperClass() {
	            var wrapperClass = 'form-group';
	
	            if (appHelper.isDefined(this.props.wrapperClassName)) {
	                wrapperClass += ' ' + this.props.wrapperClassName;
	            }
	
	            if (this.state.inFocus) {
	                wrapperClass += ' active';
	            }
	
	            if (this.props.error && this.props.error.length > 0) {
	                wrapperClass += ' has-error';
	            }
	
	            return wrapperClass;
	        }
	    }, {
	        key: 'getFieldClass',
	        value: function getFieldClass() {
	            var wrapperClass = 'form-control ' + this.props.className;
	
	            if (this.state.inFocus) {
	                wrapperClass += ' active';
	            }
	
	            return wrapperClass;
	        }
	    }, {
	        key: 'onFocusIn',
	        value: function onFocusIn() {
	            this.setState({
	                inFocus: true
	            });
	        }
	    }, {
	        key: 'onFocusOut',
	        value: function onFocusOut() {
	            this.setState({
	                inFocus: false
	            });
	            this.addFocusOutEffect();
	        }
	    }, {
	        key: 'addFocusOutEffect',
	        value: function addFocusOutEffect() {
	            var inputRef = this.refs['input_' + this.props.name];
	            if (appHelper.isDefined(inputRef)) {
	                inputRef.classList.remove("focus-out");
	                _gsap.TweenLite.to(inputRef, 0.5, {
	                    css: { className: '+=focus-out' }
	                }).eventCallback("onComplete", this.onFocusOutComplete);
	            }
	        }
	    }, {
	        key: 'onFocusOutComplete',
	        value: function onFocusOutComplete() {
	            var inputRef = this.refs['input_' + this.props.name];
	            if (appHelper.isDefined(inputRef)) {
	                inputRef.classList.remove("focus-out");
	            }
	        }
	    }, {
	        key: 'setKeyboardAccessibility',
	        value: function setKeyboardAccessibility() {}
	    }, {
	        key: 'render',
	        value: function render() {
	            return _react2.default.createElement(
	                'div',
	                { className: '' + this.getWrapperClass() },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'relative-input-wrapper' },
	                    _react2.default.createElement(
	                        'label',
	                        { className: 'editor-label', htmlFor: this.props.name },
	                        _react2.default.createElement('span', { dangerouslySetInnerHTML: { __html: this.props.label } }),
	                        typeof subLabel !== 'undefined' ? _react2.default.createElement(
	                            'span',
	                            { className: 'sub-label' },
	                            ' - ',
	                            this.props.subLabel
	                        ) : null
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { ref: 'input_' + this.props.name },
	                        _react2.default.createElement(_reactQuill2.default, {
	                            name: this.props.name,
	                            id: this.props.name,
	                            value: this.props.value,
	                            onChange: this.props.onChange,
	                            placeholder: appHelper.isDefined(this.props.placeholder) ? this.props.placeholder : '' + appHelper.getLocaleString("text_editor_placeholder"),
	
	                            onKeyPress: this.onFocusIn,
	                            theme: 'snow',
	                            modules: this.state.modules,
	                            formats: this.state.formats
	                        }),
	                        typeof this.props.messagePanelParams != 'undefined' && this.props.messagePanelParams.show ? _react2.default.createElement(_MessagePanel2.default, { name: this.props.name, message: this.props.messagePanelParams.message, alignment: this.props.messagePanelParams.alignment, show: this.props.messagePanelParams.show }) : null,
	                        this.props.error && _react2.default.createElement(
	                            'div',
	                            { className: 'alert alert-danger' },
	                            this.props.error
	                        )
	                    )
	                )
	            );
	        }
	    }]);
	
	    return BasicEditor;
	}(_react2.default.Component);
	
	BasicEditor.propTypes = {
	    name: _propTypes2.default.string.isRequired,
	    label: _propTypes2.default.string,
	    onChange: _propTypes2.default.func.isRequired,
	    subLabel: _propTypes2.default.string,
	    wrapperClassName: _propTypes2.default.string,
	    className: _propTypes2.default.string,
	    placeholder: _propTypes2.default.string,
	    value: _propTypes2.default.string,
	    error: _propTypes2.default.string,
	    messagePanelParams: _propTypes2.default.object,
	    onDoneFocusId: _propTypes2.default.string,
	    index: _propTypes2.default.number
	};
	
	//Pull in the React Router context so router is available on this.context.router.
	BasicEditor.contextTypes = {
	    router: _propTypes2.default.object
	};
	
	//Init
	
	
	exports.default = BasicEditor;

/***/ },
/* 278 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.MessagePanel = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _formValidationHelper = __webpack_require__(152);
	
	var formValidationHelper = _interopRequireWildcard(_formValidationHelper);
	
	var _gsap = __webpack_require__(8);
	
	var _gsapReactPlugin = __webpack_require__(10);
	
	var _gsapReactPlugin2 = _interopRequireDefault(_gsapReactPlugin);
	
	var _reactDom = __webpack_require__(55);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var MessagePanel = exports.MessagePanel = function (_React$Component) {
	    _inherits(MessagePanel, _React$Component);
	
	    function MessagePanel(props, context) {
	        _classCallCheck(this, MessagePanel);
	
	        var _this = _possibleConstructorReturn(this, (MessagePanel.__proto__ || Object.getPrototypeOf(MessagePanel)).call(this, props, context));
	
	        _this.state = {
	            isVisible: false
	        };
	        _this.onShowValidator = _this.onShowValidator.bind(_this);
	        _this.onShowComplete = _this.onShowComplete.bind(_this);
	        _this.onHideValidator = _this.onHideValidator.bind(_this);
	        _this.onHideComplete = _this.onHideComplete.bind(_this);
	        return _this;
	    }
	
	    _createClass(MessagePanel, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            this.onShowValidator();
	        }
	    }, {
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(nextProps) {
	            //let newPasswordState = formValidationHelper.validatePasswordCritea(nextProps.password);
	            ///this.setState({passwordState: Object.assign({}, newPasswordState)});
	            if (!this.state.isVisible && nextProps.show) {
	                //this.onShowValidator();
	            }
	        }
	    }, {
	        key: 'componentWillUnmount',
	        value: function componentWillUnmount() {
	            if (this.state.isVisible) {
	                this.onHideValidator();
	            }
	        }
	    }, {
	        key: 'onShowValidator',
	        value: function onShowValidator() {
	
	            var validator = this.refs.message;
	            _gsap.TweenLite.set(validator, { zIndex: 100 });
	            _gsap.TweenLite.to(validator, 0.5, { opacity: 1, ease: _gsap.Expo.easeIn }).eventCallback("onComplete", this.onShowComplete);
	        }
	    }, {
	        key: 'onShowComplete',
	        value: function onShowComplete() {
	            this.setState({ isVisible: true });
	        }
	    }, {
	        key: 'onHideValidator',
	        value: function onHideValidator() {
	            var validator = this.refs.message;
	            _gsap.TweenLite.to(validator, 0.5, { opacity: 0, ease: _gsap.Expo.easeOut }).eventCallback("onComplete", this.onHideComplete);
	        }
	    }, {
	        key: 'onHideComplete',
	        value: function onHideComplete() {
	            var validator = this.refs.validator;
	            _gsap.TweenLite.set(validator, { zIndex: 0 });
	            this.setState({ isVisible: false });
	            //this.props.onHide();
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            return _react2.default.createElement(
	                'div',
	                { className: "validation-panel " + this.props.alignment, ref: 'message' },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'padding' },
	                    this.props.message
	                )
	            );
	        }
	    }]);
	
	    return MessagePanel;
	}(_react2.default.Component);
	
	MessagePanel.propTypes = {
	    name: _propTypes2.default.string.isRequired,
	    message: _propTypes2.default.string,
	    alignment: _propTypes2.default.string,
	    show: _propTypes2.default.bool
	};
	
	exports.default = MessagePanel;

/***/ },
/* 279 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.SelectionMenu = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(5);
	
	var _redux = __webpack_require__(4);
	
	var _initActions = __webpack_require__(64);
	
	var initActions = _interopRequireWildcard(_initActions);
	
	var _SelectMenuOption = __webpack_require__(462);
	
	var _SelectMenuOption2 = _interopRequireDefault(_SelectMenuOption);
	
	var _objectConstants = __webpack_require__(9);
	
	var objectConstants = _interopRequireWildcard(_objectConstants);
	
	var _keyboardConstants = __webpack_require__(14);
	
	var keyboardConstants = _interopRequireWildcard(_keyboardConstants);
	
	var _appHelper = __webpack_require__(3);
	
	var appHelper = _interopRequireWildcard(_appHelper);
	
	var _gsap = __webpack_require__(8);
	
	var _gsapReactPlugin = __webpack_require__(10);
	
	var _gsapReactPlugin2 = _interopRequireDefault(_gsapReactPlugin);
	
	var _reactDom = __webpack_require__(55);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var SelectionMenu = exports.SelectionMenu = function (_React$Component) {
	    _inherits(SelectionMenu, _React$Component);
	
	    function SelectionMenu(props, context) {
	        _classCallCheck(this, SelectionMenu);
	
	        var _this = _possibleConstructorReturn(this, (SelectionMenu.__proto__ || Object.getPrototypeOf(SelectionMenu)).call(this, props, context));
	
	        _this.state = {
	            menuData: _this.props.menuData,
	            currentSelection: _this.props.currentSelection,
	            canClickMenu: true,
	            isOpen: false,
	            allowStateUpdates: true,
	            currentFocus: _this.props.currentSelection,
	            requestedUpdate: false
	        };
	
	        _this.onSelect = _this.onSelect.bind(_this);
	        _this.checkIsActive = _this.checkIsActive.bind(_this);
	        _this.handleMenu = _this.handleMenu.bind(_this);
	        _this.showMenu = _this.showMenu.bind(_this);
	        _this.hideMenu = _this.hideMenu.bind(_this);
	        _this.onMenuOpenComplete = _this.onMenuOpenComplete.bind(_this);
	        _this.onMenuClosedComplete = _this.onMenuClosedComplete.bind(_this);
	        _this.getClass = _this.getClass.bind(_this);
	        _this.getPreviousOption = _this.getPreviousOption.bind(_this);
	        _this.getNextOption = _this.getNextOption.bind(_this);
	        _this.setKeyboardAccessibility = _this.setKeyboardAccessibility.bind(_this);
	        _this.setKeyboardNavigationControls = _this.setKeyboardNavigationControls.bind(_this);
	        return _this;
	    }
	
	    _createClass(SelectionMenu, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {}
	    }, {
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(nextProps) {
	            if (this.state.currentSelection !== nextProps.currentSelection) {
	                this.setState({ currentSelection: Object.assign({}, nextProps.currentSelection), requestedUpdate: false });
	            }
	
	            if (this.state.menuData !== nextProps.menuData) {
	                this.setState({ menuData: Object.assign([], nextProps.menuData) });
	            }
	        }
	    }, {
	        key: 'checkIsActive',
	        value: function checkIsActive(constant) {
	            if (constant === this.state.currentFocus.constant) {
	                return 'active';
	            } else {
	                return "";
	            }
	        }
	    }, {
	        key: 'onSelect',
	        value: function onSelect(data) {
	
	            this.props.onMenuSelect(data);
	        }
	    }, {
	        key: 'handleMenu',
	        value: function handleMenu(event) {
	            if (appHelper.isDefined(event)) {
	                event.stopPropagation();
	            }
	            if (this.state.canClickMenu) {
	                if (this.state.isOpen) {
	                    this.hideMenu();
	                } else {
	                    this.showMenu();
	                }
	            }
	        }
	    }, {
	        key: 'hideMenu',
	        value: function hideMenu() {
	            if (this.state.isOpen) {
	                var rotator = this.refs.rotator;
	                _gsap.TweenLite.to(rotator, objectConstants.DROPDOWN_MENU_CLOSE_DURATION, {
	                    rotation: '+=' + 180 + 'deg',
	                    ease: _gsap.Expo.easeInOut
	                }).eventCallback("onComplete", this.onMenuHandledComplete);
	            }
	            this.setState({ canClickMenu: false });
	            var mainMenu = this.refs.menu;
	            _gsap.TweenLite.to(mainMenu, objectConstants.DROPDOWN_MENU_CLOSE_DURATION, { height: 0, ease: _gsap.Expo.easeInOut }).eventCallback("onComplete", this.onMenuClosedComplete);
	        }
	    }, {
	        key: 'showMenu',
	        value: function showMenu() {
	            this.setState({ isOpen: true, canClickMenu: false });
	            var mainMenu = this.refs.menu;
	            var rotator = this.refs.rotator;
	
	            _gsap.TweenLite.to(rotator, objectConstants.DROPDOWN_MENU_OPEN_DURATION, { rotation: '+=' + 180 + 'deg', ease: _gsap.Expo.easeInOut }).eventCallback("onComplete", this.onMenuHandledComplete);
	            _gsap.TweenLite.set(mainMenu, { height: "auto" });
	            _gsap.TweenLite.from(mainMenu, objectConstants.DROPDOWN_MENU_OPEN_DURATION, { height: 0, ease: _gsap.Expo.easeInOut }).eventCallback("onComplete", this.onMenuOpenComplete);
	        }
	    }, {
	        key: 'onMenuOpenComplete',
	        value: function onMenuOpenComplete() {
	            var menuList = this.refs['menu'];
	            menuList.focus();
	            if (this.state.allowStateUpdates) {
	                this.setState({ canClickMenu: true });
	            }
	        }
	    }, {
	        key: 'onMenuClosedComplete',
	        value: function onMenuClosedComplete() {
	            if (this.state.allowStateUpdates) {
	                this.setState({ canClickMenu: true, isOpen: false });
	            }
	        }
	    }, {
	        key: 'getClass',
	        value: function getClass() {
	            return this.state.isOpen ? "open" : "closed";
	        }
	    }, {
	        key: 'setKeyboardAccessibility',
	        value: function setKeyboardAccessibility(event) {
	
	            if (event.which === keyboardConstants.ENTER_KEY || event.which === keyboardConstants.SPACEBAR_KEY) {
	                event.preventDefault();
	                event.stopPropagation();
	                if (this.state.canClickMenu) {
	                    if (this.state.menuIsOpen) {
	                        this.hideMenu();
	                    } else {
	                        this.showMenu();
	                    }
	                }
	            }
	        }
	    }, {
	        key: 'getPreviousOption',
	        value: function getPreviousOption() {
	            var currentFocusIndex = appHelper.getArrayObjectIndexByKey(this.state.menuData, "constant", this.state.currentFocus.constant);
	            var prevIndex = currentFocusIndex - 1;
	
	            if (prevIndex < 0) {
	                prevIndex = this.state.menuData.length - 1;
	            }
	
	            var nextFocus = this.state.menuData[prevIndex];
	
	            this.setState({ currentFocus: Object.assign({}, nextFocus) });
	        }
	    }, {
	        key: 'getNextOption',
	        value: function getNextOption() {
	            var currentFocusIndex = appHelper.getArrayObjectIndexByKey(this.state.menuData, "constant", this.state.currentFocus.constant);
	
	            var nextIndex = currentFocusIndex + 1;
	
	            if (nextIndex === this.state.menuData.length) {
	                nextIndex = 0;
	            }
	
	            var nextFocus = this.state.menuData[nextIndex];
	
	            this.setState({ currentFocus: Object.assign({}, nextFocus) });
	        }
	    }, {
	        key: 'setKeyboardNavigationControls',
	        value: function setKeyboardNavigationControls(event) {
	            event.stopPropagation();
	            if (event.which === keyboardConstants.ARROW_DOWN_KEY) {
	                event.preventDefault();
	                event.stopPropagation();
	                this.getNextOption();
	            }
	            if (event.which === keyboardConstants.ARROW_UP_KEY) {
	                event.preventDefault();
	                event.stopPropagation();
	                this.getPreviousOption();
	            }
	
	            if (event.which === keyboardConstants.ENTER_KEY || event.which === keyboardConstants.SPACEBAR_KEY) {
	                event.preventDefault();
	                event.stopPropagation();
	                this.onSelect(this.state.currentFocus);
	                this.hideMenu();
	                var referenceMenuBtn = this.refs['resourceMenuBtn'];
	                referenceMenuBtn.focus();
	            }
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this2 = this;
	
	            return _react2.default.createElement(
	                'div',
	                { className: 'selection-menu ' + this.getClass() + ' ' + (appHelper.isDefined(this.props.classExtention) ? this.props.classExtention : ""), onClick: this.handleMenu, onKeyDown: this.setKeyboardAccessibility, role: 'button', id: 'menuBtn_' + this.props.idKey, ref: 'resourceMenuBtn', tabIndex: '0', 'aria-haspopup': 'true' },
	                _react2.default.createElement('div', { className: 'selected-title', id: 'currentSelection', dangerouslySetInnerHTML: { __html: this.state.currentSelection[this.props.labelKey] } }),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'menu-icon' },
	                    _react2.default.createElement('div', { ref: 'rotator', className: 'rotating-icon icons8-circled-arrow-down-filled' })
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { ref: 'menu', className: 'menu-option-container',
	                        role: 'listbox',
	                        id: 'menu',
	                        onKeyDown: this.setKeyboardNavigationControls,
	                        'aria-labelledby': 'currentSelection',
	                        tabIndex: this.state.isOpen ? 0 : -1 },
	                    _react2.default.createElement(
	                        'ul',
	                        { className: 'menu-option-list' },
	                        this.state.menuData.map(function (nav) {
	                            return _react2.default.createElement(
	                                'li',
	                                { className: 'option-item', key: nav[_this2.props.idKey] },
	                                _react2.default.createElement(_SelectMenuOption2.default, {
	                                    onSelectFunc: _this2.onSelect,
	                                    params: nav,
	                                    label: nav[_this2.props.labelKey],
	                                    activeClass: _this2.checkIsActive(nav.constant),
	                                    isOpen: _this2.state.isOpen,
	                                    currentFocus: _this2.state.currentFocus })
	                            );
	                        })
	                    )
	                )
	            );
	        }
	    }]);
	
	    return SelectionMenu;
	}(_react2.default.Component);
	
	SelectionMenu.propTypes = {
	    menuData: _propTypes2.default.array,
	    currentSelection: _propTypes2.default.object,
	    onMenuSelect: _propTypes2.default.func,
	    idKey: _propTypes2.default.string,
	    labelKey: _propTypes2.default.string,
	    actions: _propTypes2.default.object,
	    classExtention: _propTypes2.default.string
	};
	
	//Pull in the React Router context so router is available on this.context.router.
	SelectionMenu.contextTypes = {
	    router: _propTypes2.default.object
	};
	
	//Init
	function mapStateToProps(state, ownProps) {
	    return {};
	}
	
	function mapDispatchToProps(dispatch) {
	    return {
	        actions: (0, _redux.bindActionCreators)(Object.assign({}, initActions), dispatch)
	    };
	}
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(SelectionMenu);

/***/ },
/* 280 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(5);
	
	var _redux = __webpack_require__(4);
	
	var _Badge = __webpack_require__(135);
	
	var _Badge2 = _interopRequireDefault(_Badge);
	
	var _appDataActions = __webpack_require__(12);
	
	var appDataActions = _interopRequireWildcard(_appDataActions);
	
	var _trackingDataActions = __webpack_require__(7);
	
	var trackingDataActions = _interopRequireWildcard(_trackingDataActions);
	
	var _localStorage = __webpack_require__(17);
	
	var localStorage = _interopRequireWildcard(_localStorage);
	
	var _appHelper = __webpack_require__(3);
	
	var appHelper = _interopRequireWildcard(_appHelper);
	
	var _objectConstants = __webpack_require__(9);
	
	var objectConstants = _interopRequireWildcard(_objectConstants);
	
	var _gsap = __webpack_require__(8);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var BadgeDashboard = function (_React$Component) {
	    _inherits(BadgeDashboard, _React$Component);
	
	    function BadgeDashboard(props, context) {
	        _classCallCheck(this, BadgeDashboard);
	
	        var _this = _possibleConstructorReturn(this, (BadgeDashboard.__proto__ || Object.getPrototypeOf(BadgeDashboard)).call(this, props, context));
	
	        _this.state = {
	            badgeUserData: _this.props.badgeUserData,
	            badges: appHelper.getArrayObjectByKey(localStorage.bites, "bite_id", _this.props.bite_id).badges,
	            showAchievedCount: true,
	            showAchievedState: true,
	            currentBadgeLocale: {},
	            currentBadgeId: 0,
	            lang: _this.props.lang,
	            your_badges_label: appHelper.getLocaleString("your_badges_label")
	        };
	
	        _this.getUserBadge = _this.getUserBadge.bind(_this);
	        _this.showDetails = _this.showDetails.bind(_this);
	        _this.show = _this.show.bind(_this);
	        _this.setKeyboardAccessibility = _this.setKeyboardAccessibility.bind(_this);
	        return _this;
	    }
	
	    _createClass(BadgeDashboard, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            this.show();
	        }
	    }, {
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(nextProps) {
	            if (this.state.badgeUserData !== nextProps.badgeUserData) {
	                this.setState({ badgeUserData: Object.assign([], nextProps.badgeUserData) });
	            }
	
	            if (this.state.lang !== nextProps.lang) {
	                this.setState({
	                    lang: nextProps.lang,
	                    your_badges_label: appHelper.getLocaleString("your_badges_label")
	                });
	            }
	        }
	    }, {
	        key: 'getUserBadge',
	        value: function getUserBadge(badge) {
	            return appHelper.getArrayObjectByKey(this.state.badgeUserData, "badge_id", badge.badge_id);
	        }
	    }, {
	        key: 'show',
	        value: function show() {
	            var ref = this.refs.badge_dashboard;
	            if (appHelper.isDefined(ref)) {
	                _gsap.TweenLite.set(ref, { opacity: 1, height: "auto" });
	                _gsap.TweenLite.from(ref, objectConstants.SHOW_PANEL_DURATION, {
	                    height: 0,
	                    opacity: 0,
	                    ease: _gsap.Expo.easeInOut
	                });
	            }
	        }
	    }, {
	        key: 'showDetails',
	        value: function showDetails(badge_id, locale) {
	            this.setState({
	                currentBadgeLocale: Object.assign({}, locale),
	                currentBadgeId: parseFloat(badge_id)
	            });
	        }
	    }, {
	        key: 'setKeyboardAccessibility',
	        value: function setKeyboardAccessibility() {}
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this2 = this;
	
	            return _react2.default.createElement(
	                'div',
	                { className: 'object-container', ref: 'badge_dashboard', style: { marginBottom: 0 } },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'badge-dashboard' },
	                    _react2.default.createElement(
	                        'h4',
	                        { className: 'text-center' },
	                        this.state.your_badges_label
	                    ),
	                    _react2.default.createElement(
	                        'ul',
	                        { className: 'badge-grid', role: 'presentation' },
	                        this.state.badges.map(function (badge) {
	                            return _react2.default.createElement(
	                                'li',
	                                { key: badge.badge_id, className: 'badge-grid-item' },
	                                _react2.default.createElement(_Badge2.default, { badge: badge,
	                                    userBadge: _this2.getUserBadge(badge),
	                                    showAchievedCount: _this2.state.showAchievedCount,
	                                    showAchievedState: _this2.state.showAchievedState,
	                                    onClicked: _this2.showDetails,
	                                    currentBadgeId: parseFloat(_this2.state.currentBadgeId)
	                                })
	                            );
	                        })
	                    ),
	                    typeof this.state.currentBadgeId === "number" && this.state.currentBadgeId !== 0 && !isNaN(this.state.currentBadgeId) ? _react2.default.createElement(
	                        'div',
	                        { className: 'badge-details', role: 'presentation' },
	                        _react2.default.createElement(
	                            'p',
	                            null,
	                            _react2.default.createElement(
	                                'strong',
	                                null,
	                                this.state.currentBadgeLocale.long_title
	                            )
	                        ),
	                        _react2.default.createElement('div', { className: 'content', dangerouslySetInnerHTML: { __html: this.state.currentBadgeLocale.description } })
	                    ) : null
	                )
	            );
	        }
	    }]);
	
	    return BadgeDashboard;
	}(_react2.default.Component);
	
	BadgeDashboard.propTypes = {
	    badgeUserData: _propTypes2.default.array,
	    actions: _propTypes2.default.object.isRequired,
	    lang: _propTypes2.default.string.isRequired,
	    bite_id: _propTypes2.default.number
	};
	
	BadgeDashboard.contextTypes = {
	    router: _propTypes2.default.object
	};
	
	function mapStateToProps(state, ownProps) {
	    var lang = state.userData.lang;
	    return {
	        lang: lang,
	        badgeUserData: appHelper.getArrayObjectByKey(state.userData.bites, "bite_id", ownProps.bite_id).badges
	    };
	}
	
	function mapDispatchToProps(dispatch) {
	    return {
	        actions: (0, _redux.bindActionCreators)(Object.assign({}, trackingDataActions, appDataActions), dispatch)
	    };
	}
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(BadgeDashboard);

/***/ },
/* 281 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(5);
	
	var _redux = __webpack_require__(4);
	
	var _RotationKpiMeter = __webpack_require__(82);
	
	var _RotationKpiMeter2 = _interopRequireDefault(_RotationKpiMeter);
	
	var _appDataActions = __webpack_require__(12);
	
	var appDataActions = _interopRequireWildcard(_appDataActions);
	
	var _trackingDataActions = __webpack_require__(7);
	
	var trackingDataActions = _interopRequireWildcard(_trackingDataActions);
	
	var _appHelper = __webpack_require__(3);
	
	var appHelper = _interopRequireWildcard(_appHelper);
	
	var _kpiModels = __webpack_require__(57);
	
	var kpiModels = _interopRequireWildcard(_kpiModels);
	
	var _kpiConstants = __webpack_require__(37);
	
	var kpiConstants = _interopRequireWildcard(_kpiConstants);
	
	var _dataHelper = __webpack_require__(11);
	
	var dataHelper = _interopRequireWildcard(_dataHelper);
	
	var _objectConstants = __webpack_require__(9);
	
	var objectConstants = _interopRequireWildcard(_objectConstants);
	
	var _gsap = __webpack_require__(8);
	
	var _gsapReactPlugin = __webpack_require__(10);
	
	var _gsapReactPlugin2 = _interopRequireDefault(_gsapReactPlugin);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var KpiDescription = function (_React$Component) {
	    _inherits(KpiDescription, _React$Component);
	
	    function KpiDescription(props, context) {
	        _classCallCheck(this, KpiDescription);
	
	        var _this = _possibleConstructorReturn(this, (KpiDescription.__proto__ || Object.getPrototypeOf(KpiDescription)).call(this, props, context));
	
	        _this.state = {
	            lang: _this.props.lang,
	            kpi: _this.props.kpi,
	            locale: appHelper.getLocalData(_this.props.kpi)
	
	        };
	
	        _this.show = _this.show.bind(_this);
	        _this.handleProgression = _this.handleProgression.bind(_this);
	        return _this;
	    }
	
	    _createClass(KpiDescription, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	
	            this.show();
	        }
	    }, {
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(nextProps) {
	            if (this.state.lang !== nextProps.lang) {
	                this.setState({
	                    lang: nextProps.lang,
	                    locale: appHelper.getLocalData(this.state.kpi)
	                });
	            }
	        }
	    }, {
	        key: 'show',
	        value: function show() {
	            var optionRef = this.refs[this.state.kpi.kpi_id + '_description'];
	            _gsap.TweenLite.set(optionRef, { height: "auto", opacity: 1 });
	            _gsap.TweenLite.from(optionRef, objectConstants.SHOW_PANEL_DURATION, {
	                height: 0,
	                ease: _gsap.Expo.easeInOut
	            }).eventCallback("onComplete", this.handleProgression);
	        }
	    }, {
	        key: 'handleProgression',
	        value: function handleProgression() {
	            if (appHelper.isDefined(this.props.callbacks)) {
	                this.props.callbacks.onObjectComplete(this.state.kpi);
	            }
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            return _react2.default.createElement(
	                'div',
	                { className: 'kpi-overview-row', ref: this.state.kpi.kpi_id + '_description' },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'kpi-meter-col', role: 'presentation' },
	                    _react2.default.createElement(_RotationKpiMeter2.default, { bite_id: this.props.bite_id,
	                        kpiDefaults: this.state.kpi,
	                        meterParams: kpiModels.PRIMARY_KPI_ROTATION_METER_PARAMS,
	                        displayState: kpiConstants.KPI_DISPLAY_STATE_START })
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'kpi-content-col' },
	                    appHelper.isDefined(this.state.locale.long_title) && this.state.locale.long_title !== null && this.state.locale.long_title.length > 0 ? _react2.default.createElement(
	                        'h4',
	                        null,
	                        _react2.default.createElement(
	                            'strong',
	                            null,
	                            this.state.locale.long_title
	                        )
	                    ) : null,
	                    appHelper.isDefined(this.state.locale.description) && this.state.locale.description !== null && this.state.locale.description.length > 0 ? _react2.default.createElement('div', { dangerouslySetInnerHTML: { __html: this.state.locale.description } }) : null
	                )
	            );
	        }
	    }]);
	
	    return KpiDescription;
	}(_react2.default.Component);
	
	KpiDescription.propTypes = {
	    kpi: _propTypes2.default.object.isRequired,
	    bite_id: _propTypes2.default.number.isRequired,
	    callbacks: _propTypes2.default.object,
	    lang: _propTypes2.default.string.isRequired,
	    actions: _propTypes2.default.object
	};
	
	KpiDescription.contextTypes = {
	    router: _propTypes2.default.object
	};
	
	function mapStateToProps(state, ownProps) {
	    var lang = state.userData.lang;
	    return {
	        lang: lang
	    };
	}
	
	function mapDispatchToProps(dispatch) {
	    return {
	        actions: (0, _redux.bindActionCreators)(Object.assign({}, appDataActions, trackingDataActions), dispatch)
	    };
	}
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(KpiDescription);

/***/ },
/* 282 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRouter = __webpack_require__(45);
	
	var _reactRedux = __webpack_require__(5);
	
	var _redux = __webpack_require__(4);
	
	var _RotationKpiMeter = __webpack_require__(82);
	
	var _RotationKpiMeter2 = _interopRequireDefault(_RotationKpiMeter);
	
	var _SelectionMenu = __webpack_require__(279);
	
	var _SelectionMenu2 = _interopRequireDefault(_SelectionMenu);
	
	var _BadgeCollect = __webpack_require__(47);
	
	var _BadgeCollect2 = _interopRequireDefault(_BadgeCollect);
	
	var _ResourceLinks = __webpack_require__(48);
	
	var _ResourceLinks2 = _interopRequireDefault(_ResourceLinks);
	
	var _appDataActions = __webpack_require__(12);
	
	var appDataActions = _interopRequireWildcard(_appDataActions);
	
	var _trackingDataActions = __webpack_require__(7);
	
	var trackingDataActions = _interopRequireWildcard(_trackingDataActions);
	
	var _dataHelper = __webpack_require__(11);
	
	var dataHelper = _interopRequireWildcard(_dataHelper);
	
	var _appHelper = __webpack_require__(3);
	
	var appHelper = _interopRequireWildcard(_appHelper);
	
	var _kpiHelper = __webpack_require__(35);
	
	var kpiHelper = _interopRequireWildcard(_kpiHelper);
	
	var _userDataHelper = __webpack_require__(15);
	
	var userDataHelper = _interopRequireWildcard(_userDataHelper);
	
	var _kpiConstants = __webpack_require__(37);
	
	var kpiConstants = _interopRequireWildcard(_kpiConstants);
	
	var _assetConstants = __webpack_require__(33);
	
	var assetConstants = _interopRequireWildcard(_assetConstants);
	
	var _appConstants = __webpack_require__(13);
	
	var appConstants = _interopRequireWildcard(_appConstants);
	
	var _objectConstants = __webpack_require__(9);
	
	var objectConstants = _interopRequireWildcard(_objectConstants);
	
	var _kpiModels = __webpack_require__(57);
	
	var kpiModels = _interopRequireWildcard(_kpiModels);
	
	var _localStorage = __webpack_require__(17);
	
	var localStorage = _interopRequireWildcard(_localStorage);
	
	var _keyboardConstants = __webpack_require__(14);
	
	var keyboardConstants = _interopRequireWildcard(_keyboardConstants);
	
	var _gsap = __webpack_require__(8);
	
	var _gsapReactPlugin = __webpack_require__(10);
	
	var _gsapReactPlugin2 = _interopRequireDefault(_gsapReactPlugin);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var KpiResultsPanel = function (_React$Component) {
	    _inherits(KpiResultsPanel, _React$Component);
	
	    function KpiResultsPanel(props, context) {
	        _classCallCheck(this, KpiResultsPanel);
	
	        var _this = _possibleConstructorReturn(this, (KpiResultsPanel.__proto__ || Object.getPrototypeOf(KpiResultsPanel)).call(this, props, context));
	
	        _this.state = {
	            lang: _this.props.lang,
	            kpiMenuData: _this.props.kpiMenuData,
	            userDataKpi: _this.props.userDataKpi,
	            kpiData: _this.props.kpiData,
	            completeKpis: _this.props.completeKpis,
	            allowKpiRedraw: true,
	            locale: appHelper.getLocalData(_this.props.kpiData),
	            assets: {
	                screenAsset: {
	                    src: "",
	                    pose: "",
	                    position: ""
	                }
	            },
	            updateAssets: false,
	            hasBadges: appHelper.isDefined(_this.props.kpiData.badge_id) && _this.props.kpiData.badge_id > 0 && _this.props.kpiData.badge_id !== 0 && _this.props.userDataKpi.currentScoreRange === objectConstants.RESULT_BEST,
	            badgesCollected: false,
	            badge: {},
	            hasResources: false,
	            resourcesAreComplete: false,
	            checkComplete: false,
	            isComplete: false,
	            checkBadge: false
	        };
	
	        _this.getAssetTarget = _this.getAssetTarget.bind(_this);
	        _this.getAssets = _this.getAssets.bind(_this);
	        _this.getAssetType = _this.getAssetType.bind(_this);
	        _this.getImagePath = _this.getImagePath.bind(_this);
	        _this.onBadgeCollected = _this.onBadgeCollected.bind(_this);
	        _this.getBadge = _this.getBadge.bind(_this);
	        _this.onResourcesComplete = _this.onResourcesComplete.bind(_this);
	        _this.onComplete = _this.onComplete.bind(_this);
	        _this.getKpiIsComplete = _this.getKpiIsComplete.bind(_this);
	        _this.getPreviousKpi = _this.getPreviousKpi.bind(_this);
	        _this.getNextKpi = _this.getNextKpi.bind(_this);
	        _this.setKpi = _this.setKpi.bind(_this);
	        _this.getAccessiblePreviousKpi = _this.getAccessiblePreviousKpi.bind(_this);
	        _this.getAccessibleNextKpi = _this.getAccessibleNextKpi.bind(_this);
	        _this.getAccessibleKpi = _this.getAccessibleKpi.bind(_this);
	        return _this;
	    }
	
	    _createClass(KpiResultsPanel, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            if (this.state.hasBadges) {
	                this.getBadge(this.state.kpiData.badge_id);
	            }
	
	            var getAssets = this.getAssets;
	
	            setTimeout(function () {
	                getAssets();
	            }, 500);
	
	            // this.getAssets();
	        }
	    }, {
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(nextProps) {
	            if (this.state.userDataKpi !== nextProps.userDataKpi) {
	                this.setState({
	                    userDataKpi: Object.assign({}, nextProps.userDataKpi),
	                    updateAssets: true,
	                    hasBadges: appHelper.isDefined(nextProps.kpiData.badge_id) && nextProps.kpiData.badge_id > 0 && nextProps.kpiData.badge_id !== 0 && nextProps.userDataKpi.currentScoreRange === objectConstants.RESULT_BEST,
	                    checkBadge: true
	                });
	            }
	
	            if (this.state.kpiData !== nextProps.kpiData) {
	                this.setState({
	                    kpiData: Object.assign({}, nextProps.kpiData),
	                    locale: Object.assign({}, appHelper.getLocalData(nextProps.kpiData)),
	                    updateAssets: true,
	                    hasBadges: appHelper.isDefined(nextProps.kpiData.badge_id) && nextProps.kpiData.badge_id > 0 && nextProps.kpiData.badge_id !== 0 && nextProps.userDataKpi.currentScoreRange === objectConstants.RESULT_BEST,
	                    checkBadge: true
	                });
	            }
	
	            if (this.state.kpiMenuData !== nextProps.kpiMenuData) {
	                this.setState({ kpiMenuData: Object.assign({}, nextProps.kpiMenuData) });
	            }
	
	            if (this.state.completeKpis !== nextProps.completeKpis) {
	                this.setState({ completeKpis: Object.assign([], nextProps.completeKpis) });
	            }
	
	            if (this.state.lang !== nextProps.lang) {
	                this.setState({
	                    lang: nextProps.lang,
	                    locale: appHelper.getLocalData(this.state.kpiData)
	                });
	            }
	        }
	    }, {
	        key: 'componentDidUpdate',
	        value: function componentDidUpdate() {
	
	            if (this.state.updateAssets) {
	                this.getAssets();
	                this.getBadge(this.state.kpiData.badge_id);
	            }
	
	            if (this.state.checkComplete) {
	                this.onComplete();
	            }
	
	            if (this.state.checkBadge) {
	                this.getBadge(this.state.kpiData.badge_id);
	            }
	        }
	    }, {
	        key: 'onComplete',
	        value: function onComplete() {
	
	            if (this.state.resourcesAreComplete && appHelper.isDefined(this.props.onComplete)) {
	                this.props.onComplete(this.state.kpiData);
	                this.setState({ checkComplete: false, isComplete: this.state.resourcesAreComplete });
	            }
	        }
	    }, {
	        key: 'getBadge',
	        value: function getBadge(badge_id) {
	            this.setState({ checkBadge: false });
	            var badges = appHelper.getArrayObjectByKey(localStorage.bites, "bite_id", this.props.bite_id).badges;
	            this.setState({ badge: Object.assign({}, appHelper.getArrayObjectByKey(badges, "badge_id", badge_id)) });
	        }
	    }, {
	        key: 'getAssetTarget',
	        value: function getAssetTarget() {
	
	            //console.log(`getAssetTarget`,this.state.userDataKpi);
	            if (this.state.userDataKpi.currentScoreRange === objectConstants.RESULT_TYPE_BEST) {
	                return kpiConstants.GREEN_ASSET;
	            } else if (this.state.userDataKpi.currentScoreRange === objectConstants.RESULT_TYPE_OK) {
	                return kpiConstants.YELLOW_ASSET;
	            } else if (this.state.userDataKpi.currentScoreRange === objectConstants.RESULT_TYPE_POOR) {
	                return kpiConstants.RED_ASSET;
	            }
	        }
	    }, {
	        key: 'getAssets',
	        value: function getAssets() {
	            var assetTarget = this.getAssetTarget();
	            //console.log(`assetTarget`,assetTarget);
	            var screenAsset = this.getAssetType(this.state.kpiData.assets[0][assetTarget]);
	
	            var resourceLinks = appHelper.setResourceLinks(this.state.kpiData.assets[0][assetTarget]);
	            var hasRequiredResources = appHelper.hasRequiredResources(resourceLinks);
	
	            this.setState({
	                updateAssets: false,
	                assets: Object.assign({}, this.state.assets, {
	                    screenAsset: screenAsset
	                }),
	                resourceLinks: Object.assign([], resourceLinks),
	                hasResources: resourceLinks.length > 0,
	                resourcesAreComplete: resourceLinks.length === 0 || !hasRequiredResources,
	                checkComplete: true
	            });
	        }
	    }, {
	        key: 'getAssetType',
	        value: function getAssetType(asset) {
	            var returnAsset = {};
	            if (asset.constant === assetConstants.ASSET_TYPE_ID_CHARACTER) {
	                var screenCharacter = appHelper.getCharacterAsset(asset);
	                returnAsset = appHelper.getCharacterPose(screenCharacter, asset);
	            } else if (asset.constant === assetConstants.ASSET_TYPE_ICON) {
	                returnAsset = appHelper.getIconAsset(asset);
	            } else if (asset.constant === assetConstants.ASSET_TYPE_IMAGE) {
	                returnAsset = appHelper.getImageAsset(asset);
	            }
	            returnAsset = appHelper.isDefined(returnAsset.locale) ? appHelper.getLocalData(returnAsset) : returnAsset;
	
	            if (appHelper.isDefined(asset.constant) && !appHelper.isDefined(returnAsset.type)) {
	                returnAsset = Object.assign({}, returnAsset, {
	                    type: asset.constant
	                });
	            }
	            return returnAsset;
	        }
	    }, {
	        key: 'getImagePath',
	        value: function getImagePath(image) {
	            if (appConstants.DEVELOPMENT_MODE) {
	                if (appHelper.isDefined(image) && image.length > 0) {
	                    return __webpack_require__(16)("./" + image);
	                }
	            } else {
	                return image;
	            }
	        }
	    }, {
	        key: 'onBadgeCollected',
	        value: function onBadgeCollected() {
	            this.setState({ badgesCollected: true });
	            //this.hide();
	        }
	    }, {
	        key: 'onResourcesComplete',
	        value: function onResourcesComplete() {
	            if (!this.state.resourcesAreComplete) {
	                this.setState({ resourcesAreComplete: true, checkComplete: true });
	            }
	        }
	    }, {
	        key: 'getKpiIsComplete',
	        value: function getKpiIsComplete(kpi_id) {
	            var index = appHelper.getArrayObjectIndexByKey(this.state.completeKpis, "kpi_id", kpi_id);
	            return index > -1 ? "complete" : "";
	        }
	    }, {
	        key: 'setKpi',
	        value: function setKpi(kpi) {
	            this.state.kpiMenuData.onMenuSelect(kpi);
	        }
	    }, {
	        key: 'getPreviousKpi',
	        value: function getPreviousKpi() {
	            var index = appHelper.getArrayObjectIndexByKey(this.state.kpiMenuData.menu, "constant", this.state.kpiData.kpi_id);
	            var prevIndex = this.state.kpiMenuData.menu.length - 1;
	            if (index > 0) {
	                prevIndex = index - 1;
	            }
	            this.state.kpiMenuData.onMenuSelect(this.state.kpiMenuData.menu[prevIndex]);
	        }
	    }, {
	        key: 'getNextKpi',
	        value: function getNextKpi() {
	            var index = appHelper.getArrayObjectIndexByKey(this.state.kpiMenuData.menu, "constant", this.state.kpiData.kpi_id);
	            var nextIndex = 0;
	            if (index < this.state.kpiMenuData.menu.length - 1) {
	                nextIndex = index + 1;
	            }
	
	            this.state.kpiMenuData.onMenuSelect(this.state.kpiMenuData.menu[nextIndex]);
	
	            // this.state.kpiMenuData.onMenuSelect(this.state.kpiMenuData.menu[index + 1]);
	        }
	    }, {
	        key: 'getAccessiblePreviousKpi',
	        value: function getAccessiblePreviousKpi() {
	            if (event.which === keyboardConstants.ENTER_KEY || event.which === keyboardConstants.SPACEBAR_KEY) {
	                event.preventDefault();
	                this.getPreviousKpi();
	            }
	        }
	    }, {
	        key: 'getAccessibleNextKpi',
	        value: function getAccessibleNextKpi() {
	            if (event.which === keyboardConstants.ENTER_KEY || event.which === keyboardConstants.SPACEBAR_KEY) {
	                event.preventDefault();
	                this.getNextKpi();
	            }
	        }
	    }, {
	        key: 'getAccessibleKpi',
	        value: function getAccessibleKpi(kpi) {
	            if (event.which === keyboardConstants.ENTER_KEY || event.which === keyboardConstants.SPACEBAR_KEY) {
	                event.preventDefault();
	                this.setKpi(kpi);
	            }
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this2 = this;
	
	            return _react2.default.createElement(
	                'div',
	                { className: 'kpi-results-panel ' + this.state.userDataKpi.currentScoreRange, ref: 'kpi-results-panel' },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'results-row' },
	                    appHelper.isDefined(this.state.assets.screenAsset.src) && this.state.assets.screenAsset.src.length > 0 ? _react2.default.createElement(
	                        'div',
	                        { className: 'kpi-results-column' },
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'kpi-result-asset' },
	                            _react2.default.createElement('img', { src: this.getImagePath(this.state.assets.screenAsset.src), alt: '' })
	                        )
	                    ) : null,
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'kpi-results-column flex-1' },
	                        appHelper.isDefined(this.state.kpiMenuData) && this.state.kpiMenuData.menu.length > 1 ? _react2.default.createElement(_SelectionMenu2.default, { menuData: this.state.kpiMenuData.menu,
	                            currentSelection: this.state.kpiMenuData.currentKpi,
	                            onMenuSelect: this.state.kpiMenuData.onMenuSelect,
	                            idKey: this.state.kpiMenuData.idKey,
	                            labelKey: this.state.kpiMenuData.labelKey }) : _react2.default.createElement(
	                            'div',
	                            null,
	                            _react2.default.createElement(
	                                'strong',
	                                null,
	                                this.state.locale.long_title
	                            )
	                        ),
	                        _react2.default.createElement('div', {
	                            dangerouslySetInnerHTML: { __html: this.state.locale[kpiHelper.getResultKpiKey(this.state.userDataKpi)] } }),
	                        this.state.hasResources ? _react2.default.createElement(_ResourceLinks2.default, { resources: this.state.resourceLinks,
	                            onResourcesComplete: this.onResourcesComplete }) : null
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'kpi-results-column' },
	                        appHelper.isDefined(this.state.kpiMenuData) && this.state.kpiMenuData.menu.length > 1 ? _react2.default.createElement(
	                            'div',
	                            null,
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'kpi-nav-list' },
	                                _react2.default.createElement('div', { role: 'button', tabIndex: '0', className: 'back-nav', onClick: this.getPreviousKpi, onKeyDown: this.getAccessiblePreviousKpi }),
	                                this.state.kpiMenuData.menu.map(function (kpi) {
	                                    return _react2.default.createElement('div', { key: kpi.constant, onClick: function onClick() {
	                                            return _this2.setKpi(kpi);
	                                        }, onKeyDown: function onKeyDown() {
	                                            return _this2.getAccessibleKpi(kpi);
	                                        }, className: 'kpi-indicator ' + _this2.getKpiIsComplete(kpi.constant), role: 'button', tabIndex: '0' });
	                                }),
	                                _react2.default.createElement('div', { className: 'next-nav', role: 'button', tabIndex: '0', onClick: this.getNextKpi, onKeyDown: this.getAccessibleNextKpi })
	                            )
	                        ) : null,
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'kpi-result-meter' },
	                            _react2.default.createElement(_RotationKpiMeter2.default, { bite_id: this.props.bite_id,
	                                kpiDefaults: this.state.kpiData,
	                                meterParams: kpiModels.PRIMARY_KPI_ROTATION_METER_PARAMS,
	                                displayState: kpiConstants.KPI_DISPLAY_STATE_CURRENT_VALUE_NO_LABEL,
	                                allowKpiRedraw: this.state.allowKpiRedraw
	                            })
	                        )
	                    )
	                ),
	                this.state.hasBadges && appHelper.isDefined(this.state.badge.badge_id) ? _react2.default.createElement(
	                    'div',
	                    { className: 'results-row' },
	                    _react2.default.createElement('div', { className: 'kpi-result-asset' }),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'kpi-results-column flex-1' },
	                        _react2.default.createElement(_BadgeCollect2.default, { key: this.state.badge.badge_id,
	                            badge_id: this.state.badge.badge_id, bite_id: this.props.bite_id,
	                            asset_id: this.props.asset_id,
	                            onCollected: this.onBadgeCollected })
	                    )
	                ) : null
	            );
	        }
	    }]);
	
	    return KpiResultsPanel;
	}(_react2.default.Component);
	
	KpiResultsPanel.propTypes = {
	    userDataKpi: _propTypes2.default.object.isRequired,
	    kpiData: _propTypes2.default.object.isRequired,
	    asset_id: _propTypes2.default.number,
	    bite_id: _propTypes2.default.number,
	    kpiMenuData: _propTypes2.default.object,
	    completeKpis: _propTypes2.default.array,
	    lang: _propTypes2.default.string.isRequired,
	    onComplete: _propTypes2.default.func
	};
	
	KpiResultsPanel.contextTypes = {
	    router: _propTypes2.default.object
	};
	
	function mapStateToProps(state, ownProps) {
	    var lang = state.userData.lang;
	    return {
	        lang: lang
	
	    };
	}
	
	function mapDispatchToProps(dispatch) {
	    return {
	        actions: (0, _redux.bindActionCreators)(Object.assign({}, trackingDataActions, appDataActions), dispatch)
	    };
	}
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(KpiResultsPanel);

/***/ },
/* 283 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(5);
	
	var _redux = __webpack_require__(4);
	
	var _BasicEditor = __webpack_require__(277);
	
	var _BasicEditor2 = _interopRequireDefault(_BasicEditor);
	
	var _appDataActions = __webpack_require__(12);
	
	var appDataActions = _interopRequireWildcard(_appDataActions);
	
	var _trackingDataActions = __webpack_require__(7);
	
	var trackingDataActions = _interopRequireWildcard(_trackingDataActions);
	
	var _appHelper = __webpack_require__(3);
	
	var appHelper = _interopRequireWildcard(_appHelper);
	
	var _objectConstants = __webpack_require__(9);
	
	var objectConstants = _interopRequireWildcard(_objectConstants);
	
	var _gsap = __webpack_require__(8);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } //eslint-disable-line import/no-named-as-default
	
	
	//eslint-disable-line import/no-named-as-default
	//eslint-disable-line import/no-named-as-default
	//eslint-disable-line import/no-named-as-default
	
	var ShortResponseQuestion = function (_React$Component) {
	    _inherits(ShortResponseQuestion, _React$Component);
	
	    function ShortResponseQuestion(props, context) {
	        _classCallCheck(this, ShortResponseQuestion);
	
	        var _this = _possibleConstructorReturn(this, (ShortResponseQuestion.__proto__ || Object.getPrototypeOf(ShortResponseQuestion)).call(this, props, context));
	
	        _this.state = {
	            lang: _this.props.lang,
	            screenObject: _this.props.screenObject,
	            status: objectConstants.STATUS_NOT_STARTED,
	            locale: appHelper.getLocalData(_this.props.screenObject)
	        };
	        return _this;
	    }
	
	    _createClass(ShortResponseQuestion, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {}
	    }, {
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(nextProps) {
	            if (this.state.lang !== nextProps.lang) {
	                this.setState({
	                    lang: nextProps.lang,
	                    locale: appHelper.getLocalData(this.state.screenObject)
	                });
	            }
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            return _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement('div', { className: 'editor-label', dangerouslySetInnerHTML: { __html: this.state.locale.prompt } }),
	                _react2.default.createElement('br', null)
	            );
	        }
	    }]);
	
	    return ShortResponseQuestion;
	}(_react2.default.Component);
	
	ShortResponseQuestion.propTypes = {
	    parentObject: _propTypes2.default.object.isRequired,
	    screenObject: _propTypes2.default.object.isRequired,
	    callbacks: _propTypes2.default.object.isRequired,
	    contentData: _propTypes2.default.object.isRequired,
	    trackingData: _propTypes2.default.object.isRequired,
	    userData: _propTypes2.default.object.isRequired,
	    lang: _propTypes2.default.string.isRequired,
	    actions: _propTypes2.default.object.isRequired
	};
	
	ShortResponseQuestion.contextTypes = {
	    router: _propTypes2.default.object
	};
	
	function mapStateToProps(state, ownProps) {
	    var lang = state.userData.lang;
	    return {
	        lang: lang,
	        contentData: state.contentData,
	        trackingData: state.trackingData,
	        userData: state.userData
	    };
	}
	
	function mapDispatchToProps(dispatch) {
	    return {
	        actions: (0, _redux.bindActionCreators)(Object.assign({}, appDataActions, trackingDataActions), dispatch)
	    };
	}
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(ShortResponseQuestion);

/***/ },
/* 284 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(5);
	
	var _redux = __webpack_require__(4);
	
	var _BasicEditor = __webpack_require__(277);
	
	var _BasicEditor2 = _interopRequireDefault(_BasicEditor);
	
	var _appDataActions = __webpack_require__(12);
	
	var appDataActions = _interopRequireWildcard(_appDataActions);
	
	var _trackingDataActions = __webpack_require__(7);
	
	var trackingDataActions = _interopRequireWildcard(_trackingDataActions);
	
	var _appHelper = __webpack_require__(3);
	
	var appHelper = _interopRequireWildcard(_appHelper);
	
	var _objectConstants = __webpack_require__(9);
	
	var objectConstants = _interopRequireWildcard(_objectConstants);
	
	var _gsap = __webpack_require__(8);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } //eslint-disable-line import/no-named-as-default
	
	
	//eslint-disable-line import/no-named-as-default
	//eslint-disable-line import/no-named-as-default
	//eslint-disable-line import/no-named-as-default
	
	var TextArea = function (_React$Component) {
	    _inherits(TextArea, _React$Component);
	
	    function TextArea(props, context) {
	        _classCallCheck(this, TextArea);
	
	        var _this = _possibleConstructorReturn(this, (TextArea.__proto__ || Object.getPrototypeOf(TextArea)).call(this, props, context));
	
	        _this.state = {
	            lang: _this.props.lang,
	            screenObject: _this.props.screenObject,
	            status: objectConstants.STATUS_NOT_STARTED,
	            locale: appHelper.getLocalData(_this.props.screenObject),
	            response: _this.props.screenObject.response
	        };
	        _this.onChange = _this.onChange.bind(_this);
	        _this.getNextFocusId = _this.getNextFocusId.bind(_this);
	        _this.getEditorIndex = _this.getEditorIndex.bind(_this);
	        return _this;
	    }
	
	    _createClass(TextArea, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            this.getNextFocusId();
	        }
	    }, {
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(nextProps) {
	            if (this.state.screenObject !== nextProps.screenObject) {
	                this.setState({ screenObject: Object.assign({}, nextProps.screenObject) });
	            }
	            if (this.state.lang !== nextProps.lang) {
	                this.setState({
	                    lang: nextProps.lang,
	                    locale: appHelper.getLocalData(this.state.screenObject)
	                });
	            }
	        }
	    }, {
	        key: 'onChange',
	        value: function onChange(value) {
	            this.setState({ response: value });
	
	            this.props.callbacks.updateField({
	                id: this.state.screenObject.id,
	                response: value
	            });
	        }
	    }, {
	        key: 'getNextFocusId',
	        value: function getNextFocusId() {
	            var questionIndex = appHelper.getArrayObjectIndexByKey(this.props.parentObject.questions, "id", this.state.screenObject.id);
	            if (questionIndex < this.props.parentObject.questions.length - 1) {
	                var nextQuestion = this.props.parentObject.questions[questionIndex + 1];
	                var nextFocusId = 'short_response_' + nextQuestion.id;
	                return nextFocusId;
	            } else {
	                return this.props.parentObject.asset_id + '_button';
	            }
	        }
	    }, {
	        key: 'getEditorIndex',
	        value: function getEditorIndex() {
	            return appHelper.getArrayObjectIndexByKey(this.props.parentObject.questions, "id", this.state.screenObject.id);
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            return _react2.default.createElement(
	                'div',
	                null,
	                !this.props.submitted ? _react2.default.createElement(_BasicEditor2.default, { key: this.state.screenObject.id,
	                    name: 'field_' + this.state.screenObject.id,
	                    label: this.state.locale.prompt,
	                    value: this.state.response,
	                    onChange: this.onChange,
	                    wrapperClassName: '',
	                    onDoneFocusId: this.getNextFocusId(),
	                    className: 'standard-no-margin',
	                    index: this.getEditorIndex()
	                }) : _react2.default.createElement(
	                    'div',
	                    null,
	                    _react2.default.createElement('div', { dangerouslySetInnerHTML: { __html: this.state.locale.prompt } }),
	                    _react2.default.createElement('div', { className: 'embedded-response', dangerouslySetInnerHTML: { __html: this.state.response } })
	                ),
	                _react2.default.createElement('br', null)
	            );
	        }
	    }]);
	
	    return TextArea;
	}(_react2.default.Component);
	
	TextArea.propTypes = {
	    parentObject: _propTypes2.default.object.isRequired,
	    screenObject: _propTypes2.default.object.isRequired,
	    callbacks: _propTypes2.default.object.isRequired,
	    submitted: _propTypes2.default.bool,
	    contentData: _propTypes2.default.object.isRequired,
	    trackingData: _propTypes2.default.object.isRequired,
	    userData: _propTypes2.default.object.isRequired,
	    lang: _propTypes2.default.string.isRequired,
	    actions: _propTypes2.default.object.isRequired
	};
	
	TextArea.contextTypes = {
	    router: _propTypes2.default.object
	};
	
	function mapStateToProps(state, ownProps) {
	    var lang = state.userData.lang;
	    return {
	        lang: lang,
	        contentData: state.contentData,
	        trackingData: state.trackingData,
	        userData: state.userData
	    };
	}
	
	function mapDispatchToProps(dispatch) {
	    return {
	        actions: (0, _redux.bindActionCreators)(Object.assign({}, appDataActions, trackingDataActions), dispatch)
	    };
	}
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(TextArea);

/***/ },
/* 285 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(5);
	
	var _redux = __webpack_require__(4);
	
	var _trackingDataActions = __webpack_require__(7);
	
	var trackingDataActions = _interopRequireWildcard(_trackingDataActions);
	
	var _appHelper = __webpack_require__(3);
	
	var appHelper = _interopRequireWildcard(_appHelper);
	
	var _userDataHelper = __webpack_require__(15);
	
	var userDataHelper = _interopRequireWildcard(_userDataHelper);
	
	var _appConstants = __webpack_require__(13);
	
	var appConstants = _interopRequireWildcard(_appConstants);
	
	var _objectConstants = __webpack_require__(9);
	
	var objectConstants = _interopRequireWildcard(_objectConstants);
	
	var _componentHelper = __webpack_require__(31);
	
	var _keyboardConstants = __webpack_require__(14);
	
	var keyboardConstants = _interopRequireWildcard(_keyboardConstants);
	
	var _gsap = __webpack_require__(8);
	
	var _gsapReactPlugin = __webpack_require__(10);
	
	var _gsapReactPlugin2 = _interopRequireDefault(_gsapReactPlugin);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var VideoBtnMobile = function (_React$Component) {
	    _inherits(VideoBtnMobile, _React$Component);
	
	    function VideoBtnMobile(props, context) {
	        _classCallCheck(this, VideoBtnMobile);
	
	        var _this = _possibleConstructorReturn(this, (VideoBtnMobile.__proto__ || Object.getPrototypeOf(VideoBtnMobile)).call(this, props, context));
	
	        _this.state = {
	            lang: _this.props.lang,
	            userData: _this.props.userData,
	            object: _this.props.object,
	            activeObject: _this.props.activeObject,
	            enabledObjects: _this.props.enabledObjects,
	            completeObjects: _this.props.completeObjects,
	            focusedObject: _this.props.focusedObject,
	            className: "",
	            locale: appHelper.getLocalData(_this.props.object),
	            update: false,
	            renderedObject: {},
	            video: {
	                src: "",
	                thumbnail: ""
	            },
	            autoPlay: false,
	            nextObject: {}
	        };
	        _this.setClass = _this.setClass.bind(_this);
	        _this.getAssets = _this.getAssets.bind(_this);
	        _this.onClicked = _this.onClicked.bind(_this);
	        _this.objectIsEnabled = _this.objectIsEnabled.bind(_this);
	        _this.objectIsComplete = _this.objectIsComplete.bind(_this);
	        _this.getImagePath = _this.getImagePath.bind(_this);
	        _this.getObjectStatus = _this.getObjectStatus.bind(_this);
	        _this.getObject = _this.getObject.bind(_this);
	        _this.setNextObject = _this.setNextObject.bind(_this);
	        _this.setKeyboardAccessibility = _this.setKeyboardAccessibility.bind(_this);
	
	        return _this;
	    }
	
	    _createClass(VideoBtnMobile, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	
	            this.setClass();
	            this.getAssets();
	            if (appHelper.isDefined(this.state.object)) {
	                this.getObject(this.state.object);
	            }
	        }
	    }, {
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(nextProps) {
	
	            if (this.state.object !== nextProps.object) {
	                this.setState({ nextObject: Object.assign({}, nextProps.object) });
	            }
	
	            if (this.state.userData !== nextProps.userData) {
	                this.setState({ userData: Object.assign({}, nextProps.userData) });
	            }
	
	            if (this.state.activeObject !== nextProps.activeObject) {
	                this.setState({ activeObject: Object.assign({}, nextProps.activeObject) });
	            }
	            if (this.state.enabledObjects !== nextProps.enabledObjects) {
	                this.setState({ enabledObjects: Object.assign([], nextProps.enabledObjects) });
	            }
	            if (this.state.completeObjects !== nextProps.completeObjects) {
	                this.setState({ completeObjects: Object.assign([], nextProps.completeObjects) });
	            }
	
	            if (this.state.focusedObject !== nextProps.focusedObject) {
	                this.setState({ focusedObject: Object.assign([], nextProps.focusedObject) });
	            }
	
	            if (this.state.lang !== nextProps.lang) {
	                var video = appHelper.getVideoAsset(this.state.object);
	                this.setState({
	                    lang: nextProps.lang,
	                    locale: appHelper.getLocalData(this.state.screen),
	                    video: appHelper.isDefined(video) && video.src.length > 0 ? video : this.state.video
	                });
	            }
	        }
	    }, {
	        key: 'componentDidUpdate',
	        value: function componentDidUpdate() {
	            if (this.state.update) {
	                this.setClass();
	            }
	
	            if (appHelper.isDefined(this.state.nextObject.asset_id)) {
	                this.setNextObject();
	            }
	        }
	    }, {
	        key: 'getObject',
	        value: function getObject(object) {
	            this.setState({
	                renderedObject: Object.assign({}, {}),
	                nextObject: object
	                //autoPlay: appHelper.getArrayObjectIndexByKey(this.state.screen.objects,"asset_id",object.asset_id) > 0
	            });
	        }
	    }, {
	        key: 'setNextObject',
	        value: function setNextObject() {
	            this.setState({ nextObject: Object.assign({}, {}) });
	            var objectLocale = appHelper.getLocalData(this.state.nextObject);
	            var objectType = Object.assign({}, (0, _componentHelper.getAssetComponentByType)(objectLocale.asset_sub_type_code), {
	                data: this.state.nextObject
	            });
	
	            this.setState({ renderedObject: Object.assign({}, objectType) });
	        }
	    }, {
	        key: 'getAssets',
	        value: function getAssets() {
	            var video = appHelper.getVideoAsset(this.props.object);
	            video = appHelper.getLocalData(video);
	            if (appHelper.isDefined(video) && video.src.length > 0) {
	                this.setState({ video: video });
	            }
	        }
	    }, {
	        key: 'getImagePath',
	        value: function getImagePath(image) {
	            if (appConstants.DEVELOPMENT_MODE) {
	                if (appHelper.isDefined(image) && image.length > 0) {
	                    return __webpack_require__(16)("./" + image);
	                }
	            } else {
	                return image;
	            }
	        }
	    }, {
	        key: 'getObjectStatus',
	        value: function getObjectStatus() {
	            var objectUserData = {};
	            var subScreenParent = this.props.callbacks.getSubScreenParent();
	            var screen_id = this.props.callbacks.getScreenId();
	            if (appHelper.isDefined(subScreenParent)) {
	                objectUserData = userDataHelper.getSubScreenObjectStatus(this.state.userData, subScreenParent.screen_id, screen_id, this.state.object.asset_id);
	            } else if (this.state.isResourceObject) {
	                objectUserData = userDataHelper.getResourceScreenObjectUserData(this.state.userData, screen_id, this.state.object.asset_id);
	            } else {
	                objectUserData = userDataHelper.getObjectStatus(this.state.userData, screen_id, this.state.object.asset_id);
	            }
	
	            return objectUserData.status;
	        }
	    }, {
	        key: 'objectIsEnabled',
	        value: function objectIsEnabled() {
	            return appHelper.getArrayObjectIndexByKey(this.state.enabledObjects, "asset_id", this.state.object.asset_id);
	        }
	    }, {
	        key: 'objectIsComplete',
	        value: function objectIsComplete() {
	            return appHelper.getArrayObjectIndexByKey(this.state.completeObjects, "asset_id", this.state.object.asset_id);
	        }
	    }, {
	        key: 'setClass',
	        value: function setClass() {
	            var className = "";
	
	            if (appHelper.isDefined(this.state.activeObject.data) && this.state.activeObject.data.asset_id === this.state.object.asset_id) {
	                className += "active ";
	            }
	
	            if (this.objectIsEnabled() === -1) {
	                className += "disabled ";
	            }
	
	            if (this.objectIsComplete() > -1 || this.getObjectStatus() === objectConstants.STATUS_COMPLETE) {
	                className += "complete ";
	            } else {
	                className += "incomplete ";
	            }
	
	            return className;
	        }
	    }, {
	        key: 'onClicked',
	        value: function onClicked() {
	            if (this.objectIsEnabled() > -1 || this.getObjectStatus() === objectConstants.STATUS_COMPLETE) {
	                this.props.onClickFunc(this.state.object);
	            }
	        }
	    }, {
	        key: 'setKeyboardAccessibility',
	        value: function setKeyboardAccessibility(event) {
	            if (event.which === keyboardConstants.ENTER_KEY || event.which === keyboardConstants.SPACEBAR_KEY) {
	                event.preventDefault();
	                this.onClicked();
	            }
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            return _react2.default.createElement(
	                'div',
	                { className: 'video-btn ' + this.setClass(), onClick: this.onClicked, onKeyDown: this.setKeyboardAccessibility, role: 'presentation', 'aria-current': appHelper.isDefined(this.state.activeObject.data) && this.state.activeObject.data.asset_id === this.state.object.asset_id, 'aria-disabled': this.objectIsEnabled() === -1 },
	                appHelper.isDefined(this.state.renderedObject.data) ? _react2.default.createElement(this.state.renderedObject.component, {
	                    screenObject: this.state.renderedObject.data,
	                    video: appHelper.getLocalData(appHelper.getVideoAsset(this.state.renderedObject.data)),
	                    autoPlay: this.state.autoPlay,
	                    callbacks: this.props.callbacks }) : null
	            );
	        }
	    }]);
	
	    return VideoBtnMobile;
	}(_react2.default.Component);
	
	VideoBtnMobile.propTypes = {
	    object: _propTypes2.default.object.isRequired,
	    activeObject: _propTypes2.default.object.isRequired,
	    enabledObjects: _propTypes2.default.array.isRequired,
	    completeObjects: _propTypes2.default.array.isRequired,
	    callbacks: _propTypes2.default.object.isRequired,
	    userData: _propTypes2.default.object.isRequired,
	    onClickFunc: _propTypes2.default.func,
	    focusedObject: _propTypes2.default.object,
	    lang: _propTypes2.default.string.isRequired,
	    actions: _propTypes2.default.object
	};
	
	VideoBtnMobile.contextTypes = {
	    router: _propTypes2.default.object
	};
	
	function mapStateToProps(state, ownProps) {
	    var lang = state.userData.lang;
	    return {
	        lang: lang,
	        userData: state.userData
	    };
	}
	
	function mapDispatchToProps(dispatch) {
	    return {
	        actions: (0, _redux.bindActionCreators)(Object.assign({}, trackingDataActions), dispatch)
	    };
	}
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(VideoBtnMobile);

/***/ },
/* 286 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	var LRS_END_POINT = exports.LRS_END_POINT = "https://saas.learninglocker.net:443/data/xAPI/";
	var LRS_KEY = exports.LRS_KEY = "7473bd5b16d9285e2eaec3bdb55d0914535453ed";
	var LRS_SECRET = exports.LRS_SECRET = "f6b15929418591de550b33a7133be3b3a12bfb46";
	var LRS_ALLOW_FAIL = exports.LRS_ALLOW_FAIL = false;
	
	var OBJECT_TYPE_AGENT = exports.OBJECT_TYPE_AGENT = "Agent";
	var OBJECT_TYPE_GROUP = exports.OBJECT_TYPE_GROUP = "Group";
	
	var ACTOR = exports.ACTOR = {
	    objectType: OBJECT_TYPE_AGENT,
	    name: "Adam Steff",
	    account: {
	        name: "145",
	        homePage: "http://www.gurooproducer.com"
	    }
	};
	
	var TARGET = exports.TARGET = "http://www.gurooproducer.com/72/video";
	
	var ACTIVITY_URL_ID = exports.ACTIVITY_URL_ID = "http://www.gurooproducer.com/activitiy";
	
	var KPI_CODE = exports.KPI_CODE = "kpi";
	var KPI_LABEL = exports.KPI_LABEL = "KPI";
	
	var BADGE_CODE = exports.BADGE_CODE = "badge";
	var BADGE_LABEL = exports.BADGE_LABEL = "Badge";
	
	var EXPERIENCE_CODE = exports.EXPERIENCE_CODE = "learning_experience";
	var EXPERIENC_LABEL = exports.EXPERIENC_LABEL = "Learning Experience";
	
	var BITE_CODE = exports.BITE_CODE = "learning_bite";
	var BITE_LABEL = exports.BITE_LABEL = "Learning Bite";
	
	var SCREEN_CODE = exports.SCREEN_CODE = "screen";
	var SCREEN_LABEL = exports.SCREEN_LABEL = "Screen";
	
	var SUB_SCREEN_CODE = exports.SUB_SCREEN_CODE = "sub_screen";
	var SUB_SCREEN_LABEL = exports.SUB_SCREEN_LABEL = "Sub Screen";
	
	var PROJECT_ACTIVITY_TYPE = exports.PROJECT_ACTIVITY_TYPE = "http://id.tincanapi.com/activitytype/project-site";
	var MODULE_ACTIVITY_TYPE = exports.MODULE_ACTIVITY_TYPE = "http://adlnet.gov/expapi/activities/module";
	var SECTION_ACTIVITY_TYPE = exports.SECTION_ACTIVITY_TYPE = "http://id.tincanapi.com/activitytype/section";
	var OBJECTIVE_ACTIVITY_TYPE = exports.OBJECTIVE_ACTIVITY_TYPE = "http://adlnet.gov/expapi/activities/objective";
	var BADGE_ACTIVITY_TYPE = exports.BADGE_ACTIVITY_TYPE = "http://activitystrea.ms/schema/1.0/badge";
	var QUESTION_ACTIVITY_TYPE = exports.QUESTION_ACTIVITY_TYPE = "http://adlnet.gov/expapi/activities/question";
	var PAGE_ACTIVITY_TYPE = exports.PAGE_ACTIVITY_TYPE = "http://activitystrea.ms/schema/1.0/page";

/***/ },
/* 287 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.SHORT_HAND_KEYS = exports.STATUS_INDICATOR_CLASS = exports.RESPONSE = exports.SHORT_RESPONSE_QUESTIONS = exports.TERMINATED = exports.COMPLETE_TARGET_SCREENS = exports.REF_FALSE = exports.REF_TRUE = exports.REQUIRED = exports.ACTIVE = exports.PERCENTAGE_COMPLETE = exports.RESOURCES = exports.REF_RESULT_POOR = exports.REF_RESULT_OK = exports.REF_RESULT_BEST = exports.REF_STATUS_FAILED = exports.REF_STATUS_PASSED = exports.REF_STATUS_SAVED = exports.REF_STATUS_ATTEMPTED = exports.REF_STATUS_COMPLETE = exports.REF_STATUS_IN_PROGRESS = exports.REF_STATUS_NOT_STARTED = exports.REF_STATUS_NOT_REQUIRED = exports.ASSET_SUB_TYPE_VIMEO = exports.ASSET_SUB_TYPE_YOUTUBE = exports.ASSET_SUB_TYPE_MP4 = exports.ASSET_TYPE_DOCUMENT = exports.ASSET_TYPE_LINK = exports.ASSET_TYPE_VIDEO = exports.ASSET_TYPE_IMAGE = exports.SUB_TYPE = exports.TYPE = exports.ID = exports.ATTACHMENTS = exports.ACHIEVED_ON = exports.ACHIEVED = exports.BADGE_ID = exports.BADGES = exports.ACHIEVEMENTS = exports.UNDEFINED = exports.EMPTY_STRING = exports.NULL = exports.RESULT = exports.HAS_VALUE = exports.STATUS = exports.KPI_HISTORY = exports.KPI_CURRENT_SCORE_RANGE = exports.KPI_CURRENT_VALUE = exports.KPI_VALUE = exports.KPI_ID = exports.KPIS = exports.OPTION_ID = exports.OPTIONS = exports.ASSET_ID = exports.OBJECTS = exports.SCREEN_ID = exports.SUB_SCREENS = exports.SCREENS = exports.BITE_ID = exports.BITES = undefined;
	
	var _objectConstants = __webpack_require__(9);
	
	var objectConstants = _interopRequireWildcard(_objectConstants);
	
	var _assetConstants = __webpack_require__(33);
	
	var assetConstants = _interopRequireWildcard(_assetConstants);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	//DATA SHORT HAND REFERENCES
	
	var BITES = exports.BITES = {
	    ref: "bites",
	    key: "bi"
	};
	
	var BITE_ID = exports.BITE_ID = {
	    ref: "bite_id",
	    key: "b"
	};
	
	var SCREENS = exports.SCREENS = {
	    ref: "screens",
	    key: "sr"
	};
	
	var SUB_SCREENS = exports.SUB_SCREENS = {
	    ref: "sub_screens",
	    key: "sbr"
	};
	
	var SCREEN_ID = exports.SCREEN_ID = {
	    ref: "screen_id",
	    key: "x"
	};
	
	var OBJECTS = exports.OBJECTS = {
	    ref: "objects",
	    key: "ob"
	};
	
	var ASSET_ID = exports.ASSET_ID = {
	    ref: "asset_id",
	    key: "a"
	};
	
	var OPTIONS = exports.OPTIONS = {
	    ref: "options",
	    key: "op"
	};
	
	var OPTION_ID = exports.OPTION_ID = {
	    ref: "option_id",
	    key: "o"
	};
	
	var KPIS = exports.KPIS = {
	    ref: "kpis",
	    key: "k"
	};
	
	var KPI_ID = exports.KPI_ID = {
	    ref: "kpi_id",
	    key: "ki"
	};
	
	var KPI_VALUE = exports.KPI_VALUE = {
	    ref: "value",
	    key: "v"
	};
	
	var KPI_CURRENT_VALUE = exports.KPI_CURRENT_VALUE = {
	    ref: "current",
	    key: "c"
	};
	var KPI_CURRENT_SCORE_RANGE = exports.KPI_CURRENT_SCORE_RANGE = {
	    ref: "currentScoreRange",
	    key: "csr"
	};
	
	var KPI_HISTORY = exports.KPI_HISTORY = {
	    ref: "history",
	    key: "h"
	};
	
	var STATUS = exports.STATUS = {
	    ref: "status",
	    key: "s"
	};
	
	var HAS_VALUE = exports.HAS_VALUE = {
	    ref: "hasValue",
	    key: "y"
	};
	
	var RESULT = exports.RESULT = {
	    ref: "result",
	    key: "re"
	};
	
	var NULL = exports.NULL = {
	    ref: null,
	    key: "N"
	};
	
	var EMPTY_STRING = exports.EMPTY_STRING = {
	    ref: "",
	    key: ""
	};
	
	var UNDEFINED = exports.UNDEFINED = {
	    ref: undefined,
	    key: "U"
	};
	
	var ACHIEVEMENTS = exports.ACHIEVEMENTS = {
	    ref: "achievements",
	    key: "achs"
	};
	
	var BADGES = exports.BADGES = {
	    ref: "badges",
	    key: "bdg"
	};
	
	var BADGE_ID = exports.BADGE_ID = {
	    ref: "badge_id",
	    key: "bgi"
	};
	
	var ACHIEVED = exports.ACHIEVED = {
	    ref: "achieved",
	    key: "ach"
	};
	
	var ACHIEVED_ON = exports.ACHIEVED_ON = {
	    ref: "achievedOn",
	    key: "ao"
	};
	
	var ATTACHMENTS = exports.ATTACHMENTS = {
	    ref: "attachments",
	    key: "at"
	};
	
	var ID = exports.ID = {
	    ref: "id",
	    key: "id"
	};
	
	var TYPE = exports.TYPE = {
	    ref: "type",
	    key: "t"
	};
	
	var SUB_TYPE = exports.SUB_TYPE = {
	    ref: "sub_type",
	    key: "st"
	};
	
	var ASSET_TYPE_IMAGE = exports.ASSET_TYPE_IMAGE = {
	    ref: assetConstants.ASSET_TYPE_IMAGE,
	    key: "IM"
	};
	
	var ASSET_TYPE_VIDEO = exports.ASSET_TYPE_VIDEO = {
	    ref: assetConstants.ASSET_TYPE_VIDEO,
	    key: "V"
	};
	
	var ASSET_TYPE_LINK = exports.ASSET_TYPE_LINK = {
	    ref: assetConstants.ASSET_TYPE_LINK,
	    key: "L"
	};
	
	var ASSET_TYPE_DOCUMENT = exports.ASSET_TYPE_DOCUMENT = {
	    ref: assetConstants.ASSET_TYPE_DOCUMENT,
	    key: "D"
	};
	
	var ASSET_SUB_TYPE_MP4 = exports.ASSET_SUB_TYPE_MP4 = {
	    ref: assetConstants.ASSET_SUB_TYPE_MP4,
	    key: assetConstants.ASSET_SUB_TYPE_MP4
	};
	
	var ASSET_SUB_TYPE_YOUTUBE = exports.ASSET_SUB_TYPE_YOUTUBE = {
	    ref: assetConstants.ASSET_SUB_TYPE_YOUTUBE,
	    key: "YT"
	};
	
	var ASSET_SUB_TYPE_VIMEO = exports.ASSET_SUB_TYPE_VIMEO = {
	    ref: assetConstants.ASSET_SUB_TYPE_VIMEO,
	    key: "VIM"
	};
	
	var REF_STATUS_NOT_REQUIRED = exports.REF_STATUS_NOT_REQUIRED = {
	    ref: objectConstants.STATUS_NOT_REQUIRED,
	    key: objectConstants.STATUS_NOT_REQUIRED
	};
	
	var REF_STATUS_NOT_STARTED = exports.REF_STATUS_NOT_STARTED = {
	    ref: objectConstants.STATUS_NOT_STARTED,
	    key: objectConstants.STATUS_NOT_STARTED
	};
	
	var REF_STATUS_IN_PROGRESS = exports.REF_STATUS_IN_PROGRESS = {
	    ref: objectConstants.STATUS_IN_PROGRESS,
	    key: objectConstants.STATUS_IN_PROGRESS
	};
	
	var REF_STATUS_COMPLETE = exports.REF_STATUS_COMPLETE = {
	    ref: objectConstants.STATUS_COMPLETE,
	    key: objectConstants.STATUS_COMPLETE
	};
	
	var REF_STATUS_ATTEMPTED = exports.REF_STATUS_ATTEMPTED = {
	    ref: objectConstants.STATUS_ATTEMPTED,
	    key: objectConstants.STATUS_ATTEMPTED
	};
	
	var REF_STATUS_SAVED = exports.REF_STATUS_SAVED = {
	    ref: objectConstants.STATUS_SAVED,
	    key: objectConstants.STATUS_SAVED
	};
	
	var REF_STATUS_PASSED = exports.REF_STATUS_PASSED = {
	    ref: objectConstants.STATUS_PASSED,
	    key: objectConstants.STATUS_PASSED
	};
	
	var REF_STATUS_FAILED = exports.REF_STATUS_FAILED = {
	    ref: objectConstants.STATUS_FAILED,
	    key: objectConstants.STATUS_FAILED
	};
	
	var REF_RESULT_BEST = exports.REF_RESULT_BEST = {
	    ref: objectConstants.RESULT_BEST,
	    key: objectConstants.RESULT_BEST
	};
	
	var REF_RESULT_OK = exports.REF_RESULT_OK = {
	    ref: objectConstants.RESULT_OK,
	    key: objectConstants.RESULT_OK
	};
	
	var REF_RESULT_POOR = exports.REF_RESULT_POOR = {
	    ref: objectConstants.RESULT_POOR,
	    key: objectConstants.RESULT_POOR
	};
	
	var RESOURCES = exports.RESOURCES = {
	    ref: "resources",
	    key: "rc"
	};
	
	var PERCENTAGE_COMPLETE = exports.PERCENTAGE_COMPLETE = {
	    ref: "percentageComplete",
	    key: "pc"
	};
	
	var ACTIVE = exports.ACTIVE = {
	    ref: "active",
	    key: "ac"
	};
	
	var REQUIRED = exports.REQUIRED = {
	    ref: "required",
	    key: "r"
	};
	
	var REF_TRUE = exports.REF_TRUE = {
	    ref: true,
	    key: 1
	};
	
	var REF_FALSE = exports.REF_FALSE = {
	    ref: false,
	    key: 0
	};
	
	var COMPLETE_TARGET_SCREENS = exports.COMPLETE_TARGET_SCREENS = {
	    ref: "complete_target_screens",
	    key: "cts"
	};
	
	var TERMINATED = exports.TERMINATED = {
	    ref: "terminated",
	    key: "tm"
	};
	
	var SHORT_RESPONSE_QUESTIONS = exports.SHORT_RESPONSE_QUESTIONS = {
	    ref: "short_response_questions",
	    key: "srq"
	};
	
	var RESPONSE = exports.RESPONSE = {
	    ref: "response",
	    key: "rp"
	};
	
	var STATUS_INDICATOR_CLASS = exports.STATUS_INDICATOR_CLASS = {
	    ref: "statusIndicatorClass",
	    key: "z"
	};
	
	var SHORT_HAND_KEYS = exports.SHORT_HAND_KEYS = [BITES, BITE_ID, SCREENS, SUB_SCREENS, SCREEN_ID, OBJECTS, ASSET_ID, OPTIONS, OPTION_ID, KPIS, KPI_ID, KPI_VALUE, KPI_CURRENT_VALUE, KPI_CURRENT_SCORE_RANGE, KPI_HISTORY, STATUS, HAS_VALUE, RESULT, NULL, EMPTY_STRING, UNDEFINED, REF_STATUS_NOT_REQUIRED, REF_STATUS_NOT_STARTED, REF_STATUS_IN_PROGRESS, REF_STATUS_COMPLETE, REF_STATUS_ATTEMPTED, REF_STATUS_SAVED, REF_STATUS_PASSED, REF_STATUS_FAILED, REF_RESULT_BEST, REF_RESULT_OK, REF_RESULT_POOR, RESOURCES, PERCENTAGE_COMPLETE, ACTIVE, REQUIRED, ACHIEVEMENTS, BADGES, BADGE_ID, ACHIEVED, ACHIEVED_ON, ATTACHMENTS, ID, TYPE, SUB_TYPE, ASSET_TYPE_IMAGE, ASSET_TYPE_DOCUMENT, ASSET_TYPE_LINK, ASSET_TYPE_VIDEO, ASSET_SUB_TYPE_MP4, ASSET_SUB_TYPE_VIMEO, ASSET_SUB_TYPE_YOUTUBE, REF_TRUE, REF_FALSE, COMPLETE_TARGET_SCREENS, TERMINATED, SHORT_RESPONSE_QUESTIONS, RESPONSE, STATUS_INDICATOR_CLASS];

/***/ },
/* 288 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.doLMSInitialize = doLMSInitialize;
	exports.doLMSFinish = doLMSFinish;
	exports.doLMSGetValue = doLMSGetValue;
	exports.doLMSSetValue = doLMSSetValue;
	exports.doLMSCommit = doLMSCommit;
	exports.doLMSGetLastError = doLMSGetLastError;
	exports.doLMSGetErrorString = doLMSGetErrorString;
	exports.LMSIsInitialized = LMSIsInitialized;
	exports.ErrorHandler = ErrorHandler;
	exports.getAPIHandle = getAPIHandle;
	exports.findAPI = findAPI;
	exports.getAPI = getAPI;
	//ES6 SCROM API WRAPPER
	
	// set this to false to turn debugging off
	// and get rid of those annoying alert boxes.
	var _Debug = false; // set this to false to turn debugging off
	
	// Define exception/error codes
	
	var _NoError = 0;
	var _GeneralException = 101;
	var _ServerBusy = 102;
	var _InvalidArgumentError = 201;
	var _ElementCannotHaveChildren = 202;
	var _ElementIsNotAnArray = 203;
	var _NotInitialized = 301;
	var _NotImplementedError = 401;
	var _InvalidSetValue = 402;
	var _ElementIsReadOnly = 403;
	var _ElementIsWriteOnly = 404;
	var _IncorrectDataType = 405;
	
	// local variable definitions
	var apiHandle = null;
	var API = null;
	var findAPITries = 0;
	
	var resolveObj = {
	    success: true,
	    message: "",
	    data: ""
	};
	
	var rejectObj = {
	    success: false,
	    message: "",
	    data: ""
	};
	/*******************************************************************************
	 ** Inputs:  None
	 ** Return:  CMIBoolean true if the initialization was successful, or
	 **          CMIBoolean false if the initialization failed.
	 **
	 ** Description:
	 ** Initialize communication with LMS by calling the LMSInitialize
	 ** function which will be implemented by the LMS.
	 **
	 *******************************************************************************/
	
	function doLMSInitialize() {
	    return new Promise(function (resolve, reject) {
	        // conso le.log("doLMSInitialize");
	        var api = getAPIHandle();
	        // console.log('api',api);
	        if (api == null) {
	            //alert("Unable to locate the LMS's API Implementation.\nLMSInitialize was not successful.");
	            //reject(ErrorHandler());
	            reject(Object.assign({}, rejectObj, {
	                message: "Error: doLMSInitialize(): " + ErrorHandler(),
	                result: ErrorHandler()
	            }));
	        }
	
	        var result = api.LMSInitialize("");
	
	        if (result.toString() != "true") {
	            reject(Object.assign({}, rejectObj, {
	                message: "Error: doLMSInitialize(): " + ErrorHandler(),
	                data: ErrorHandler()
	            }));
	        }
	        //alert('doLMSInitialize() - ' + result);
	        resolve(Object.assign({}, resolveObj, {
	            message: "Success: doLMSInitialize(): " + result.toString(),
	            data: result.toString()
	        }));
	    });
	}
	
	/*******************************************************************************
	 **
	 ** Function doLMSFinish()
	 ** Inputs:  None
	 ** Return:  CMIBoolean true if successful
	 **          CMIBoolean false if failed.
	 **
	 ** Description:
	 ** Close communication with LMS by calling the LMSFinish
	 ** function which will be implemented by the LMS
	 **
	 *******************************************************************************/
	
	function doLMSFinish() {
	    return new Promise(function (resolve, reject) {
	        //console.log("doLMSFinish");
	        var api = getAPIHandle();
	        var result = "";
	
	        if (api == null) {
	            //alert("Unable to locate the LMS's API Implementation.\nLMSFinish was not successful.");
	            reject(Object.assign({}, rejectObj, {
	                message: "Error: doLMSFinish(): " + ErrorHandler(),
	                data: ErrorHandler()
	            }));
	        } else {
	            // call the LMSFinish function that should be implemented by the API
	
	            var _result = api.LMSFinish("");
	            if (_result.toString() != "true") {
	                var err = ErrorHandler();
	                reject(Object.assign({}, rejectObj, {
	                    message: "Error: doLMSFinish(): " + ErrorHandler(),
	                    data: ErrorHandler()
	                }));
	            }
	        }
	        //alert('doLMSFinish() - ' + result);
	        resolve(Object.assign({}, resolveObj, {
	            message: "Success: doLMSFinish(): " + result.toString(),
	            data: result.toString()
	        }));
	    });
	}
	
	/*******************************************************************************
	 **
	 ** Function doLMSGetValue(name)
	 ** Inputs:  name - string representing the cmi data model defined category or
	 **             element (e.g. cmi.core.student_id)
	 ** Return:  The value presently assigned by the LMS to the cmi data model
	 **       element defined by the element or category identified by the name
	 **       input value.
	 **
	 ** Description:
	 ** Wraps the call to the LMS LMSGetValue method
	 **
	 *******************************************************************************/
	
	function doLMSGetValue(name) {
	    return new Promise(function (resolve, reject) {
	        var api = getAPIHandle();
	        if (api == null) {
	            //alert("Unable to locate the LMS's API Implementation.\nLMSGetValue was not successful.");
	            reject(Object.assign({}, rejectObj, {
	                message: "Error: doLMSGetValue(" + name + "): " + ErrorHandler(),
	                data: ErrorHandler()
	            }));
	        } else {
	            var value = api.LMSGetValue(name);
	            var errCode = api.LMSGetLastError().toString();
	            if (errCode != _NoError) {
	                // an error was encountered so display the error description
	                var errDescription = api.LMSGetErrorString(errCode);
	                //alert("LMSGetValue("+name+") failed. \n"+ errDescription);
	                reject(Object.assign({}, rejectObj, {
	                    message: "Error: doLMSGetValue(" + name + "): \n " + errDescription,
	                    data: errDescription
	                }));
	            } else {
	                //alert('doLMSGetValue() - ' + value);
	
	                resolve(Object.assign({}, resolveObj, {
	                    message: "Success: doLMSGetValue(" + name + "): " + value.toString(),
	                    data: value.toString()
	                }));
	            }
	        }
	    });
	}
	
	/*******************************************************************************
	 **
	 ** Function doLMSSetValue(name, value)
	 ** Inputs:  name -string representing the data model defined category or element
	 **          value -the value that the named element or category will be assigned
	 ** Return:  CMIBoolean true if successful
	 **          CMIBoolean false if failed.
	 **
	 ** Description:
	 ** Wraps the call to the LMS LMSSetValue function
	 **
	 *******************************************************************************/
	
	function doLMSSetValue(name, value) {
	    return new Promise(function (resolve, reject) {
	        var api = getAPIHandle();
	        var result = "";
	        if (api == null) {
	            //alert("Unable to locate the LMS's API Implementation.\nLMSSetValue was not successful.");
	            reject(Object.assign({}, rejectObj, {
	                message: "Error: doLMSSetValue(" + name + "," + value + "): " + ErrorHandler(),
	                data: ErrorHandler()
	            }));
	        } else {
	            var _result2 = api.LMSSetValue(name, value);
	            if (_result2.toString() != "true") {
	                var err = ErrorHandler();
	                reject(Object.assign({}, rejectObj, {
	                    message: "Error: doLMSSetValue(" + name + "," + value + "): " + ErrorHandler(),
	                    data: ErrorHandler()
	                }));
	            }
	        }
	        //alert('doLMSSetValue(name) - ' + name + ' , doLMSSetValue(value) - ' + value);
	        //resolve(`success: doLMSSetValue(name) - ${name} , doLMSSetValue(value) - ${value}`);
	        resolve(Object.assign({}, resolveObj, {
	            message: "Success: doLMSSetValue(" + name + "," + value + "): " + result.toString(),
	            data: result.toString()
	        }));
	    });
	}
	
	/*******************************************************************************
	 **
	 ** Function doLMSCommit()
	 ** Inputs:  None
	 ** Return:  None
	 **
	 ** Description:
	 ** Call the LMSCommit function
	 **
	 *******************************************************************************/
	
	function doLMSCommit() {
	    return new Promise(function (resolve, reject) {
	        //console.log(`doLMSCommit`);
	        var api = getAPIHandle();
	        var result = "";
	        if (api == null) {
	            //alert("Unable to locate the LMS's API Implementation.\nLMSCommit was not successful.");
	            reject(Object.assign({}, rejectObj, {
	                message: "Error: doLMSCommit(): " + ErrorHandler(),
	                data: ErrorHandler()
	            }));
	        } else {
	            result = api.LMSCommit("");
	            if (result != "true") {
	                var err = ErrorHandler();
	                reject(Object.assign({}, rejectObj, {
	                    message: "Error: doLMSCommit(): " + ErrorHandler(),
	                    data: ErrorHandler()
	                }));
	            }
	        }
	        //alert('doLMSCommit() - ' + result);
	        //resolve(result.toString());
	        //console.log(result.toString());
	        resolve(Object.assign({}, resolveObj, {
	            message: "Success: doLMSCommit(): " + result.toString(),
	            data: result.toString()
	        }));
	    });
	}
	
	/*******************************************************************************
	 **
	 ** Function doLMSGetLastError()
	 ** Inputs:  None
	 ** Return:  The error code that was set by the last LMS function call
	 **
	 ** Description:
	 ** Call the LMSGetLastError function
	 **
	 *******************************************************************************/
	
	function doLMSGetLastError() {
	    return new Promise(function (resolve, reject) {
	        var api = getAPIHandle();
	        if (api == null) {
	            //alert("Unable to locate the LMS's API Implementation.\nLMSGetLastError was not successful.");
	            //since we can't get the error code from the LMS, return a general error
	            reject(Object.assign({}, rejectObj, {
	                message: "Error: doLMSGetLastError(): " + ErrorHandler(),
	                data: ErrorHandler()
	            }));
	        }
	
	        //resolve(api.LMSGetLastError().toString());
	        resolve(Object.assign({}, resolveObj, {
	            message: "Success: doLMSGetLastError(): " + api.LMSGetLastError().toString(),
	            data: api.LMSGetLastError().toString()
	        }));
	    });
	}
	
	/*******************************************************************************
	 **
	 ** Function doLMSGetErrorString(errorCode)
	 ** Inputs:  errorCode - Error Code
	 ** Return:  The textual description that corresponds to the input error code
	 **
	 ** Description:
	 ** Call the LMSGetErrorString function
	 **
	 ********************************************************************************/
	
	function doLMSGetErrorString(errorCode) {
	    return new Promise(function (resolve, reject) {
	        var api = getAPIHandle();
	        if (api == null) {
	            //alert("Unable to locate the LMS's API Implementation.\nLMSGetErrorString was not successful.");
	            reject(Object.assign({}, rejectObj, {
	                message: "Error: doLMSGetErrorString(" + errorCode + "): " + ErrorHandler(),
	                data: ErrorHandler()
	            }));
	        }
	
	        //resolve(api.LMSGetErrorString(errorCode).toString());
	        resolve(Object.assign({}, resolveObj, {
	            message: "Success: doLMSGetErrorString(" + errorCode + "): " + api.LMSGetErrorString(errorCode).toString(),
	            data: api.LMSGetErrorString(errorCode).toString()
	        }));
	    });
	}
	
	/*******************************************************************************
	 **
	 ** Function doLMSGetDiagnostic(errorCode)
	 ** Inputs:  errorCode - Error Code(integer format), or null
	 ** Return:  The vendor specific textual description that corresponds to the
	 **          input error code
	 **
	 ** Description:
	 ** Call the LMSGetDiagnostic function
	 **
	 *******************************************************************************/
	
	function doLMSGetDiagnostic(errorCode) {
	    return new Promise(function (resolve, reject) {
	        var api = getAPIHandle();
	        if (api == null) {
	            //alert("Unable to locate the LMS's API Implementation.\nLMSGetDiagnostic was not successful.");
	            reject(Object.assign({}, rejectObj, {
	                message: "Error: doLMSGetDiagnostic(" + errorCode + "): " + ErrorHandler(),
	                data: ErrorHandler()
	            }));
	        }
	
	        //resolve(api.LMSGetDiagnostic(errorCode).toString());
	        resolve(Object.assign({}, resolveObj, {
	
	            message: "Success: doLMSGetDiagnostic(" + errorCode + "): " + api.LMSGetDiagnostic(errorCode).toString(),
	            data: api.LMSGetErrorString(errorCode).toString()
	        }));
	    });
	}
	
	/*******************************************************************************
	 **
	 ** Function LMSIsInitialized()
	 ** Inputs:  none
	 ** Return:  true if the LMS API is currently initialized, otherwise false
	 **
	 ** Description:
	 ** Determines if the LMS API is currently initialized or not.
	 **
	 *******************************************************************************/
	
	function LMSIsInitialized() {
	    // there is no direct method for determining if the LMS API is initialized
	    // for example an LMSIsInitialized function defined on the API so we'll try
	    // a simple LMSGetValue and trap for the LMS Not Initialized Error
	    return new Promise(function (resolve, reject) {
	        var api = getAPIHandle();
	        if (api == null) {
	            //alert("Unable to locate the LMS's API Implementation.\nLMSIsInitialized() failed.");
	            reject(Object.assign({}, rejectObj, {
	                message: "Error: LMSIsInitialized(): " + ErrorHandler(),
	                data: ErrorHandler()
	            }));
	        } else {
	            var value = api.LMSGetValue("cmi.core.student_name");
	            var errCode = api.LMSGetLastError().toString();
	            if (errCode == _NotInitialized) {
	                resolve(Object.assign({}, resolveObj, {
	                    message: "Success: LMSIsInitialized(): false",
	                    data: "false"
	                }));
	            } else {
	                resolve(Object.assign({}, resolveObj, {
	                    message: "Success: LMSIsInitialized(): true",
	                    data: "true"
	                }));
	            }
	        }
	    });
	}
	
	/*******************************************************************************
	 **
	 ** Function ErrorHandler()
	 ** Inputs:  None
	 ** Return:  The current value of the LMS Error Code
	 **
	 ** Description:
	 ** Determines if an error was encountered by the previous API call
	 ** and if so, displays a message to the user.  If the error code
	 ** has associated text it is also displayed.
	 **
	 *******************************************************************************/
	
	function ErrorHandler() {
	
	    var api = getAPIHandle();
	    if (api == null) {
	        return "Unable to locate the LMS's API Implementation.\nCannot determine LMS error code.";
	    }
	
	    // check for errors caused by or from the LMS
	    var errCode = api.LMSGetLastError().toString();
	    if (errCode != _NoError) {
	        // an error was encountered so display the error description
	        var errDescription = api.LMSGetErrorString(errCode);
	
	        if (_Debug == true) {
	            errDescription += "\n";
	            errDescription += api.LMSGetDiagnostic(null);
	            // by passing null to LMSGetDiagnostic, we get any available diagnostics
	            // on the previous error.
	        }
	
	        //alert(errDescription);
	    }
	    return errCode;
	}
	
	/******************************************************************************
	 **
	 ** Function getAPIHandle()
	 ** Inputs:  None
	 ** Return:  value contained by APIHandle
	 **
	 ** Description:
	 ** Returns the handle to API object if it was previously set,
	 ** otherwise it returns null
	 **
	 *******************************************************************************/
	
	function getAPIHandle() {
	    if (apiHandle == null) {
	        apiHandle = getAPI();
	    }
	
	    return apiHandle;
	}
	
	/*******************************************************************************
	 **
	 ** Function findAPI(win)
	 ** Inputs:  win - a Window Object
	 ** Return:  If an API object is found, it's returned, otherwise null is returned
	 **
	 ** Description:
	 ** This function looks for an object named API in parent and opener windows
	 **
	 *******************************************************************************/
	
	function findAPI(win) {
	    while (win.API == null && win.parent != null && win.parent != win) {
	        findAPITries++;
	        // Note: 7 is an arbitrary number, but should be more than sufficient
	        if (findAPITries > 7) {
	            //alert("Error finding API -- too deeply nested.");
	            return null;
	        }
	
	        win = win.parent;
	    }
	    return win.API;
	}
	
	/*******************************************************************************
	 **
	 ** Function getAPI()
	 ** Inputs:  none
	 ** Return:  If an API object is found, it's returned, otherwise null is returned
	 **
	 ** Description:
	 ** This function looks for an object named API, first in the current window's
	 ** frame hierarchy and then, if necessary, in the current window's opener window
	 ** hierarchy (if there is an opener window).
	 **
	 *******************************************************************************/
	
	function getAPI() {
	    var theAPI = findAPI(window);
	    if (theAPI == null && window.opener != null && typeof window.opener != "undefined") {
	        theAPI = findAPI(window.opener);
	    }
	    if (theAPI == null) {
	        // alert("Unable to find an API adapter");
	    }
	    return theAPI;
	}

/***/ },
/* 289 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }(); //https://www.npmjs.com/package/crypto-js
	
	
	var _cryptoJs = __webpack_require__(793);
	
	var _cryptoJs2 = _interopRequireDefault(_cryptoJs);
	
	var _jquery = __webpack_require__(356);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	/*****************/
	//Reconstructed from https://github.com/adlnet/xAPIWrapper
	/*****************/
	
	var debug = true;
	var xapiVersion = "1.0.1";
	
	if (!Date.prototype.toISOString) {
	    (function () {
	
	        function pad(number) {
	            var r = String(number);
	            if (r.length === 1) {
	                r = '0' + r;
	            }
	            return r;
	        }
	
	        Date.prototype.toISOString = function () {
	            return this.getUTCFullYear() + '-' + pad(this.getUTCMonth() + 1) + '-' + pad(this.getUTCDate()) + 'T' + pad(this.getUTCHours()) + ':' + pad(this.getUTCMinutes()) + ':' + pad(this.getUTCSeconds()) + '.' + String((this.getUTCMilliseconds() / 1000).toFixed(3)).slice(2, 5) + 'Z';
	        };
	    })();
	}
	
	// shim for old-style Base64 lib
	function toBase64(text) {
	    if (_cryptoJs2.default && _cryptoJs2.default.enc.Base64) return _cryptoJs2.default.enc.Base64.stringify(_cryptoJs2.default.enc.Latin1.parse(text));else return _cryptoJs2.default.enc.Base64.encode(text);
	}
	
	// shim for old-style crypto lib
	function toSHA1(text) {
	    if (_cryptoJs2.default && _cryptoJs2.default.SHA1) return _cryptoJs2.default.SHA1(text).toString();else return Crypto.util.bytesToHex(Crypto.SHA1(text, { asBytes: true }));
	}
	function toSHA256(text) {
	    if (_cryptoJs2.default && _cryptoJs2.default.SHA256) return _cryptoJs2.default.SHA256(text).toString();
	}
	
	// check if string or object is date, if it is, return date object
	// feburary 31st == march 3rd in this solution
	function isDate(date) {
	    // check if object is being passed
	    var d = void 0;
	    if (Object.prototype.toString.call(date) === "[object Date]") d = date;else d = new Date(date);
	    // deep check on date object
	    if (Object.prototype.toString.call(d) === "[object Date]") {
	        // it is a date
	        if (isNaN(d.valueOf())) {
	            this.log("Invalid date String passed");
	            return null;
	        } else {
	            return d;
	        }
	    } else {
	        // not a date
	        this.log("Invalid date object");
	        return null;
	    }
	}
	
	var xAPI = function () {
	    function xAPI() {
	        _classCallCheck(this, xAPI);
	    }
	
	    _createClass(xAPI, null, [{
	        key: '_getobj',
	        value: function _getobj(obj, path) {
	            var parts = path.split('.');
	
	            var part = parts[0];
	            path = parts.slice(1).join('.');
	
	            if (!obj[part]) {
	                if (/\[\]$/.test(part)) {
	                    part = part.slice(0, -2);
	                    obj[part] = [];
	                } else obj[part] = {};
	            }
	
	            if (!path) return obj[part];else return this._getobj(obj[part], path);
	        }
	    }, {
	        key: 'getByteLen',
	        value: function getByteLen(normal_val) {
	            // Force string type
	            normal_val = String(normal_val);
	
	            var byteLen = 0;
	            for (var i = 0; i < normal_val.length; i++) {
	                var c = normal_val.charCodeAt(i);
	                byteLen += c < 1 << 7 ? 1 : c < 1 << 11 ? 2 : c < 1 << 16 ? 3 : c < 1 << 21 ? 4 : c < 1 << 26 ? 5 : c < 1 << 31 ? 6 : Number.NaN;
	            }
	            return byteLen;
	        }
	    }, {
	        key: 'Config',
	        value: function Config() {
	            var conf = {};
	            conf['endpoint'] = "http://localhost:8000/xapi/";
	            try {
	                conf['auth'] = "Basic " + toBase64('tom:1234');
	            } catch (e) {
	                //log("Exception in Config trying to encode auth: " + e);
	            }
	
	            return conf;
	        }
	    }, {
	        key: 'Statement',
	        value: function Statement(actor, verb, object) {
	
	            // initialize
	            this.generateId = generateId.bind(this);
	
	            // if first arg is an xapi statement, parse
	            if (actor && actor.actor && actor.verb && actor.object) {
	
	                var stmt = actor;
	                for (var i in stmt) {
	                    if (i != 'actor' && i != 'verb' && i != 'object') this[i] = stmt[i];
	                }
	                actor = stmt.actor;
	                verb = stmt.verb;
	                object = stmt.object;
	            }
	
	            if (actor) {
	                if (actor instanceof xAPI.Agent) this.actor = actor;else if (actor.objectType === 'Agent' || !actor.objectType) {
	                    this.actor = xAPI.Agent(actor);
	                } else if (actor.objectType === 'Group') this.actor = xAPI.Group(actor);
	            } else this.actor = null;
	
	            if (verb) {
	                if (typeof verb.id !== 'undefined') this.verb = verb;else this.verb = xAPI.Verb(verb);
	            } else this.verb = null;
	
	            // decide what kind of object was passed
	            if (object) {
	                if (object.objectType === 'Activity' || !object.objectType) {
	                    if (typeof object.id !== 'undefined') this.object = object;else this.object = xAPI.Activity(object);
	                } else if (object.objectType === 'Agent') {
	                    if (object instanceof xAPI.Agent) this.object = object;else this.object = new xAPI.Agent(object);
	                } else if (object.objectType === 'Group') {
	                    if (object instanceof xAPI.Group) this.object = object;else this.object = xAPI.Group(object);
	                } else if (object.objectType === 'StatementRef') {
	                    if (typeof object.id !== 'undefined') this.object = object;else this.object = xAPI.StatementRef(object);
	                } else if (object.objectType === 'SubStatement') {
	                    if (object instanceof xAPI.SubStatement) this.object = object;else this.object = xAPI.SubStatement(object);
	                } else this.object = null;
	            } else this.object = null;
	
	            function generateId() {
	                this.id = xAPI.ruuid();
	            }
	        }
	    }, {
	        key: 'Agent',
	        value: function Agent(identifier, name) {
	            var agent = {};
	
	            agent.objectType = 'Agent';
	            agent.name = name;
	
	            // figure out what type of identifier was given
	            if (identifier && (identifier.mbox || identifier.mbox_sha1sum || identifier.openid || identifier.account)) {
	                for (var i in identifier) {
	                    agent[i] = identifier[i];
	                }
	            } else if (/^mailto:/.test(identifier)) {
	                agent.mbox = identifier;
	            } else if (/^[0-9a-f]{40}$/i.test(identifier)) {
	                agent.mbox_sha1sum = identifier;
	            } else if (/^http[s]?:/.test(identifier)) {
	                agent.openid = identifier;
	            } else if (identifier && identifier.homePage && identifier.name) {
	                agent.account = identifier;
	            }
	            return agent;
	        }
	    }, {
	        key: 'Group',
	        value: function Group(identifier, members, name) {
	            var group = {};
	            xAPI.Agent.call(this, identifier, name);
	            group.member = members;
	            group.objectType = 'Group';
	            return group;
	        }
	    }, {
	        key: 'Verb',
	        value: function Verb(id, description) {
	            var verb = {};
	            // if passed a verb object then copy and return
	            if (id && id.id) {
	                for (var i in id) {
	                    verb[i] = id[i];
	                }
	                return;
	            }
	
	            // save id and build language map
	            verb.id = id;
	            if (description) {
	                if (typeof description === 'string' || description instanceof String) {
	                    verb.display = { 'en-US': description };
	                } else {
	                    verb.display = description;
	                }
	            }
	
	            return verb;
	        }
	    }, {
	        key: 'Activity',
	        value: function Activity(id, name, description, type) {
	            var activity = {};
	            // if first arg is activity, copy everything over
	            if (id && id.id) {
	                var act = id;
	                for (var i in act) {
	                    activity[i] = act[i];
	                }
	                return;
	            }
	
	            activity.objectType = 'Activity';
	            activity.id = id;
	            if (name || description || type) {
	                activity.definition = {};
	
	                if (typeof name === 'string' || name instanceof String) activity.definition.name = { 'en-US': name };else if (name) activity.definition.name = name;
	
	                if (typeof description === 'string' || description instanceof String) activity.definition.description = { 'en-US': description };else if (description) activity.definition.description = description;
	
	                if (typeof type !== 'undefined') {
	                    activity.definition.type = type;
	                }
	            }
	            return activity;
	        }
	    }, {
	        key: 'StatementRef',
	        value: function StatementRef(id) {
	            var statementRef = {};
	
	            if (id && id.id) {
	                for (var i in id) {
	                    statementRef[i] = id[i];
	                }
	            } else {
	                statementRef.objectType = 'StatementRef';
	                statementRef.id = id;
	            }
	            return statementRef;
	        }
	    }, {
	        key: 'SubStatement',
	        value: function SubStatement(actor, verb, object) {
	            var subStatement = {};
	            subStatement = xAPI.XAPIStatement.call(this, actor, verb, object);
	            subStatement.objectType = 'SubStatement';
	
	            delete subStatement.id;
	            delete subStatement.stored;
	            delete subStatement.version;
	            delete subStatement.authority;
	
	            return subStatement;
	        }
	    }, {
	        key: 'Verbs',
	        value: function Verbs() {
	            var verbs = {
	                "abandoned": {
	                    "id": "https://w3id.org/xapi/adl/verbs/abandoned",
	                    "display": { "en-US": "abandoned" }
	                },
	                "answered": {
	                    "id": "http://adlnet.gov/expapi/verbs/answered",
	                    "display": { "de-DE": "beantwortete",
	                        "en-US": "answered",
	                        "fr-FR": "a répondu",
	                        "es-ES": "contestó" }
	                },
	                "asked": {
	                    "id": "http://adlnet.gov/expapi/verbs/asked",
	                    "display": { "de-DE": "fragte",
	                        "en-US": "asked",
	                        "fr-FR": "a demandé",
	                        "es-ES": "preguntó" }
	                },
	                "attempted": {
	                    "id": "http://adlnet.gov/expapi/verbs/attempted",
	                    "display": { "de-DE": "versuchte",
	                        "en-US": "attempted",
	                        "fr-FR": "a essayé",
	                        "es-ES": "intentó" }
	                },
	                "attended": {
	                    "id": "http://adlnet.gov/expapi/verbs/attended",
	                    "display": { "de-DE": "nahm teil an",
	                        "en-US": "attended",
	                        "fr-FR": "a suivi",
	                        "es-ES": "asistió" }
	                },
	                "commented": {
	                    "id": "http://adlnet.gov/expapi/verbs/commented",
	                    "display": { "de-DE": "kommentierte",
	                        "en-US": "commented",
	                        "fr-FR": "a commenté",
	                        "es-ES": "comentó" }
	                },
	                "completed": {
	                    "id": "http://adlnet.gov/expapi/verbs/completed",
	                    "display": { "de-DE": "beendete",
	                        "en-US": "completed",
	                        "fr-FR": "a terminé",
	                        "es-ES": "completó" }
	                },
	                "exited": {
	                    "id": "http://adlnet.gov/expapi/verbs/exited",
	                    "display": { "de-DE": "verließ",
	                        "en-US": "exited",
	                        "fr-FR": "a quitté",
	                        "es-ES": "salió" }
	                },
	                "experienced": {
	                    "id": "http://adlnet.gov/expapi/verbs/experienced",
	                    "display": { "de-DE": "erlebte",
	                        "en-US": "experienced",
	                        "fr-FR": "a éprouvé",
	                        "es-ES": "experimentó" }
	                },
	                "failed": {
	                    "id": "http://adlnet.gov/expapi/verbs/failed",
	                    "display": { "de-DE": "verfehlte",
	                        "en-US": "failed",
	                        "fr-FR": "a échoué",
	                        "es-ES": "fracasó" }
	                },
	                "imported": {
	                    "id": "http://adlnet.gov/expapi/verbs/imported",
	                    "display": { "de-DE": "importierte",
	                        "en-US": "imported",
	                        "fr-FR": "a importé",
	                        "es-ES": "importó" }
	                },
	                "initialized": {
	                    "id": "http://adlnet.gov/expapi/verbs/initialized",
	                    "display": { "de-DE": "initialisierte",
	                        "en-US": "initialized",
	                        "fr-FR": "a initialisé",
	                        "es-ES": "inicializó" }
	                },
	                "interacted": {
	                    "id": "http://adlnet.gov/expapi/verbs/interacted",
	                    "display": { "de-DE": "interagierte",
	                        "en-US": "interacted",
	                        "fr-FR": "a interagi",
	                        "es-ES": "interactuó" }
	                },
	                "launched": {
	                    "id": "http://adlnet.gov/expapi/verbs/launched",
	                    "display": { "de-DE": "startete",
	                        "en-US": "launched",
	                        "fr-FR": "a lancé",
	                        "es-ES": "lanzó" }
	                },
	                "mastered": {
	                    "id": "http://adlnet.gov/expapi/verbs/mastered",
	                    "display": { "de-DE": "meisterte",
	                        "en-US": "mastered",
	                        "fr-FR": "a maîtrisé",
	                        "es-ES": "dominó" }
	                },
	                "passed": {
	                    "id": "http://adlnet.gov/expapi/verbs/passed",
	                    "display": { "de-DE": "bestand",
	                        "en-US": "passed",
	                        "fr-FR": "a réussi",
	                        "es-ES": "aprobó" }
	                },
	                "preferred": {
	                    "id": "http://adlnet.gov/expapi/verbs/preferred",
	                    "display": { "de-DE": "bevorzugte",
	                        "en-US": "preferred",
	                        "fr-FR": "a préféré",
	                        "es-ES": "prefirió" }
	                },
	                "progressed": {
	                    "id": "http://adlnet.gov/expapi/verbs/progressed",
	                    "display": { "de-DE": "machte Fortschritt mit",
	                        "en-US": "progressed",
	                        "fr-FR": "a progressé",
	                        "es-ES": "progresó" }
	                },
	                "registered": {
	                    "id": "http://adlnet.gov/expapi/verbs/registered",
	                    "display": { "de-DE": "registrierte",
	                        "en-US": "registered",
	                        "fr-FR": "a enregistré",
	                        "es-ES": "registró" }
	                },
	                "responded": {
	                    "id": "http://adlnet.gov/expapi/verbs/responded",
	                    "display": { "de-DE": "reagierte",
	                        "en-US": "responded",
	                        "fr-FR": "a répondu",
	                        "es-ES": "respondió" }
	                },
	                "resumed": {
	                    "id": "http://adlnet.gov/expapi/verbs/resumed",
	                    "display": { "de-DE": "setzte fort",
	                        "en-US": "resumed",
	                        "fr-FR": "a repris",
	                        "es-ES": "continuó" }
	                },
	                "satisfied": {
	                    "id": "https://w3id.org/xapi/adl/verbs/satisfied",
	                    "display": { "en-US": "satisfied" }
	                },
	                "scored": {
	                    "id": "http://adlnet.gov/expapi/verbs/scored",
	                    "display": { "de-DE": "erreichte",
	                        "en-US": "scored",
	                        "fr-FR": "a marqué",
	                        "es-ES": "anotó" }
	                },
	                "shared": {
	                    "id": "http://adlnet.gov/expapi/verbs/shared",
	                    "display": { "de-DE": "teilte",
	                        "en-US": "shared",
	                        "fr-FR": "a partagé",
	                        "es-ES": "compartió" }
	                },
	                "suspended": {
	                    "id": "http://adlnet.gov/expapi/verbs/suspended",
	                    "display": { "de-DE": "pausierte",
	                        "en-US": "suspended",
	                        "fr-FR": "a suspendu",
	                        "es-ES": "aplazó" }
	                },
	                "terminated": {
	                    "id": "http://adlnet.gov/expapi/verbs/terminated",
	                    "display": { "de-DE": "beendete",
	                        "en-US": "terminated",
	                        "fr-FR": "a terminé",
	                        "es-ES": "terminó" }
	                },
	                "voided": {
	                    "id": "http://adlnet.gov/expapi/verbs/voided",
	                    "display": { "de-DE": "entwertete",
	                        "en-US": "voided",
	                        "fr-FR": "a annulé",
	                        "es-ES": "anuló" }
	                },
	                "waived": {
	                    "id": "https://w3id.org/xapi/adl/verbs/waived",
	                    "display": { "en-US": "waived" }
	                },
	                "earned": {
	                    "id": "http://id.tincanapi.com/verb/earned",
	                    "display": { "en-US": "earned" }
	                }
	            };
	
	            return verbs;
	        }
	    }, {
	        key: 'Lrs',
	        value: function Lrs(config, verifyxapiversion) {
	
	            //public
	            this.Statement = xAPI.Statement.bind(this);
	            this.Agent = xAPI.Agent.bind(this);
	            this.Group = xAPI.Group.bind(this);
	            this.Verb = xAPI.Verb.bind(this);
	            this.Activity = xAPI.Activity.bind(this);
	            this.StatementRef = xAPI.StatementRef.bind(this);
	            this.SubStatement = xAPI.SubStatement.bind(this);
	            this.Verbs = xAPI.Verbs();
	
	            this.updateSettings = xAPI.updateSettings.bind(this);
	            this.getCurrentUrl = xAPI.getCurrentUrl.bind(this);
	            this.updateAuth = xAPI.updateAuth.bind(this);
	            this.searchParams = xAPI.searchParams.bind(this);
	            this.hash = xAPI.hash.bind(this);
	            this.changeConfig = xAPI.changeConfig.bind(this);
	
	            this.generateRegistration = xAPI.generateRegistration.bind(this);
	            this.addParentActivity = xAPI.addParentActivity.bind(this);
	            this.addGroupingActivity = xAPI.addGroupingActivity.bind(this);
	            this.addCategoryActivity = xAPI.addCategoryActivity.bind(this);
	            this.addOtherContextActivity = xAPI.addOtherContextActivity.bind(this);
	
	            this.prepareStatement = xAPI.prepareStatement.bind(this);
	            this.sendStatement = xAPI.sendStatement.bind(this);
	            this.buildMultipartPost = xAPI.buildMultipartPost.bind(this);
	            this.sendStatements = xAPI.sendStatements.bind(this);
	            this.getStatements = xAPI.getStatements.bind(this);
	            this.getActivities = xAPI.getActivities.bind(this);
	            this.sendState = xAPI.sendState.bind(this);
	            this.getState = xAPI.getState.bind(this);
	            this.deleteState = xAPI.deleteState.bind(this);
	            this.sendActivityProfile = xAPI.sendActivityProfile.bind(this);
	            this.getActivityProfile = xAPI.getActivityProfile.bind(this);
	            this.deleteActivityProfile = xAPI.deleteActivityProfile.bind(this);
	            this.testConfig = xAPI.testConfig.bind(this);
	            this.log = xAPI.log.bind(this);
	
	            this.lrs = xAPI.getLRSObject(config || {});
	            if (typeof this.lrs === 'undefined') {
	                this.lrs = {};
	            }
	            this.settings = {};
	
	            if (this.lrs.user && this.lrs.password) this.updateAuth(this.lrs, this.lrs.user, this.lrs.password);
	            if (typeof this.lrs.endpoint !== "undefined") {
	                this.base = xAPI.getbase(this.lrs.endpoint);
	            }
	            this.withCredentials = false;
	            this.withCredentials = config && config.withCredentials;
	
	            if (verifyxapiversion && this.testConfig.call(this)) {
	                window.xAPI.XHR_request(this.lrs, this.lrs.endpoint + "about", "GET", null, null, function (r) {
	                    if (r.status == 200) {
	                        try {
	                            var lrsabout = JSON.parse(r.response);
	                            var versionOK = false;
	                            for (var idx in lrsabout.version) {
	                                if (lrsabout.version[idx] == xapiVersion) {
	                                    versionOK = true;
	                                    break;
	                                }
	                            }
	                            if (!versionOK) {
	                                this.log("The lrs version [" + lrsabout.version + "]" + " does not match this wrapper's XAPI version [" + xapiVersion + "]");
	                            }
	                        } catch (e) {
	                            this.log("The response was not an about object");
	                        }
	                    } else {
	                        this.log("The request to get information about the LRS failed: " + r);
	                    }
	                }, null, false, null, this.withCredentials, false);
	            }
	        }
	    }, {
	        key: 'updateSettings',
	        value: function updateSettings(settings) {
	            this.settings = Object.assign({}, settings);
	        }
	    }, {
	        key: 'getCurrentUrl',
	        value: function getCurrentUrl() {
	            var pathArray = window.location.href.split('/');
	            var protocol = pathArray[0];
	            var host = pathArray[2];
	            var url = protocol + '//' + host;
	            return url;
	        }
	    }, {
	        key: 'getbase',
	        value: function getbase(url) {
	            var l = document.createElement("a");
	            l.href = url;
	            if (l.protocol && l.host) return l.protocol + "//" + l.host;else this.log("Couldn't create base url from endpoint: " + this.lrs.endpoint);
	        }
	    }, {
	        key: 'updateAuth',
	        value: function updateAuth(obj, username, password) {
	            obj.auth = "Basic " + toBase64(username + ":" + password);
	        }
	    }, {
	        key: 'searchParams',
	        value: function searchParams() {
	            var sp = { "format": "exact" };
	            return sp;
	        }
	    }, {
	        key: 'hash',
	        value: function hash(tohash) {
	            if (!tohash) return null;
	            try {
	                return toSHA1(tohash);
	            } catch (e) {
	                this.log("Error trying to hash -- " + e);
	                return null;
	            }
	        }
	    }, {
	        key: 'changeConfig',
	        value: function changeConfig(config) {
	            try {
	                this.log("updating lrs object with new configuration");
	                this.lrs = xAPI.mergeRecursive(this.lrs, config);
	                if (config.user && config.password) this.updateAuth(this.lrs, config.user, config.password);
	                this.base = xAPI.getbase(this.lrs.endpoint);
	                this.withCredentials = config.withCredentials;
	            } catch (e) {
	                this.log("error while changing configuration -- " + e);
	            }
	        }
	    }, {
	        key: 'generateRegistration',
	        value: function generateRegistration(stmt) {
	            xAPI._getobj(stmt, 'context').registration = xAPI.ruuid();
	            return stmt;
	        }
	    }, {
	        key: 'addParentActivity',
	        value: function addParentActivity(stmt, activity) {
	            xAPI._getobj(stmt, 'context.contextActivities.parent[]').push(activity);
	            return stmt;
	        }
	    }, {
	        key: 'addGroupingActivity',
	        value: function addGroupingActivity(stmt, activity) {
	            xAPI._getobj(stmt, 'context.contextActivities.grouping[]').push(activity);
	            return stmt;
	        }
	    }, {
	        key: 'addCategoryActivity',
	        value: function addCategoryActivity(stmt, activity) {
	            xAPI._getobj(stmt, 'context.contextActivities.category[]').push(activity);
	            return stmt;
	        }
	    }, {
	        key: 'addOtherContextActivity',
	        value: function addOtherContextActivity(stmt, activity) {
	            xAPI._getobj(stmt, 'context.contextActivities.other[]').push(activity);
	            return stmt;
	        }
	    }, {
	        key: 'prepareStatement',
	        value: function prepareStatement(stmt) {
	            if (stmt.actor === undefined) {
	                stmt.actor = JSON.parse(this.lrs.actor);
	            } else if (typeof stmt.actor === "string") {
	                stmt.actor = JSON.parse(stmt.actor);
	            }
	            if (this.lrs.grouping || this.lrs.registration || this.lrs.activity_platform) {
	                if (!stmt.context) {
	                    stmt.context = {};
	                }
	            }
	
	            if (this.lrs.grouping) {
	                if (!stmt.context.contextActivities) {
	                    stmt.context.contextActivities = {};
	                }
	                stmt.context.contextActivities.grouping = [{ id: this.lrs.grouping }];
	            }
	            if (this.lrs.registration) {
	                stmt.context.registration = this.lrs.registration;
	            }
	            if (this.lrs.activity_platform) {
	                stmt.context.platform = this.lrs.activity_platform;
	            }
	        }
	    }, {
	        key: 'sendStatement',
	        value: function sendStatement(stmt, callback, attachments) {
	            if (this.testConfig()) {
	                this.prepareStatement(stmt);
	                var id = void 0;
	                if (stmt['id']) {
	                    id = stmt['id'];
	                } else {
	                    id = xAPI.ruuid();
	                    stmt['id'] = id;
	                }
	
	                var payload = JSON.stringify(stmt);
	                var extraHeaders = null;
	                if (attachments && attachments.length > 0) {
	                    extraHeaders = {};
	                    payload = this.buildMultipartPost(stmt, attachments, extraHeaders);
	                }
	
	                var params = {
	                    url: this.lrs.endpoint + "statements",
	                    method: "POST",
	                    data: payload,
	                    auth: this.lrs.auth,
	                    extraHeaders: extraHeaders,
	                    withCredentials: this.withCredentials
	                };
	
	                return xAPI.request(params).then(function (response) {
	                    return response;
	                }).catch(function (error) {
	                    throw error;
	                });
	            }
	        }
	    }, {
	        key: 'buildMultipartPost',
	        value: function buildMultipartPost(statement, attachments, extraHeaders) {
	            statement.attachments = [];
	            for (var i = 0; i < attachments.length; i++) {
	                //replace the term 'signature' with the hard coded definition for a signature attachment
	                if (attachments[i].type == "signature") {
	                    attachments[i].type = {
	                        "usageType": "http://xAPInet.gov/expapi/attachments/signature",
	                        "display": {
	                            "en-US": "A JWT signature"
	                        },
	                        "description": {
	                            "en-US": "A signature proving the statement was not modified"
	                        },
	                        "contentType": "application/octet-stream"
	                    };
	                }
	
	                //compute the length and the sha2 of the attachment
	                attachments[i].type.length = attachments[i].value.length;
	                attachments[i].type.sha2 = toSHA256(attachments[i].value);
	
	                //attach the attachment metadata to the statement
	                statement.attachments.push(attachments[i].type);
	            }
	
	            var body = "";
	            var CRLF = "\r\n";
	            var boundary = (Math.random() + ' ').substring(2, 10) + (Math.random() + ' ').substring(2, 10);
	
	            extraHeaders["Content-Type"] = "multipart/mixed; boundary=" + boundary;
	
	            body += CRLF + '--' + boundary + CRLF + 'Content-Type:application/json' + CRLF + "Content-Disposition: form-data; name=\"statement\"" + CRLF + CRLF;
	            body += JSON.stringify(statement);
	
	            for (var _i in attachments) {
	
	                body += CRLF + '--' + boundary + CRLF + 'X-Experience-API-Hash:' + attachments[_i].type.sha2 + CRLF + "Content-Type:application/octet-stream" + CRLF + "Content-Transfer-Encoding: binary" + CRLF + CRLF;
	                body += attachments[_i].value;
	            }
	            body += CRLF + "--" + boundary + "--" + CRLF;
	
	            return body;
	        }
	    }, {
	        key: 'sendStatements',
	        value: function sendStatements(stmtArray, callback) {
	            if (this.testConfig()) {
	                for (var i in stmtArray) {
	                    this.prepareStatement(stmtArray[i]);
	                }
	
	                var params = {
	                    url: this.lrs.endpoint + "statements",
	                    method: "POST",
	                    data: JSON.stringify(stmtArray),
	                    auth: this.lrs.auth,
	                    extraHeaders: null,
	                    withCredentials: this.withCredentials
	                };
	
	                return xAPI.request(params).then(function (response) {
	                    return response;
	                }).catch(function (error) {
	                    throw error;
	                });
	            }
	        }
	    }, {
	        key: 'getStatements',
	        value: function getStatements(searchparams, more, callback) {
	            if (this.testConfig()) {
	                var url = this.lrs.endpoint + "statements";
	                if (more) {
	                    url = this.base + more;
	                } else {
	                    var urlparams = new Array();
	
	                    for (var s in searchparams) {
	                        if (s == "until" || s == "since") {
	                            var d = new Date(searchparams[s]);
	                            urlparams.push(s + "=" + encodeURIComponent(d.toISOString()));
	                        } else if (s == "agent") {
	                            urlparams.push(s + "=" + encodeURIComponent(JSON.stringify(searchparams[s])));
	                        } else {
	                            urlparams.push(s + "=" + encodeURIComponent(searchparams[s]));
	                        }
	                    }
	                    if (urlparams.length > 0) url = url + "?" + urlparams.join("&");
	                }
	
	                var params = {
	                    url: url,
	                    method: "GET",
	                    data: null,
	                    auth: this.lrs.auth,
	                    extraHeaders: null,
	                    withCredentials: this.withCredentials
	                };
	
	                return xAPI.request(params).then(function (response) {
	                    return response;
	                }).catch(function (error) {
	                    throw error;
	                });
	            }
	        }
	    }, {
	        key: 'getActivities',
	        value: function getActivities(activityid, callback) {
	            if (this.testConfig()) {
	                var url = this.lrs.endpoint + "activities?activityId=<activityid>";
	                url = url.replace('<activityid>', encodeURIComponent(activityid));
	
	                var params = {
	                    url: url,
	                    method: "GET",
	                    data: null,
	                    auth: this.lrs.auth,
	                    extraHeaders: null,
	                    withCredentials: this.withCredentials
	                };
	
	                return xAPI.request(params).then(function (response) {
	                    return response;
	                }).catch(function (error) {
	                    throw error;
	                });
	            }
	        }
	    }, {
	        key: 'sendState',
	        value: function sendState(activityid, agent, stateid, registration, stateval, matchHash, noneMatchHash) {
	            if (this.testConfig()) {
	                var url = this.lrs.endpoint + "activities/state?activityId=<activity ID>&agent=<agent>&stateId=<stateid>";
	
	                url = url.replace('<activity ID>', encodeURIComponent(activityid));
	                url = url.replace('<agent>', encodeURIComponent(JSON.stringify(agent)));
	                url = url.replace('<stateid>', encodeURIComponent(stateid));
	
	                if (registration) {
	                    url += "&registration=" + encodeURIComponent(registration);
	                }
	
	                var headers = null;
	                if (matchHash && noneMatchHash) {
	                    this.log("Can't have both If-Match and If-None-Match");
	                } else if (matchHash) {
	                    headers = { "If-Match": xAPI.formatHash(matchHash) };
	                } else if (noneMatchHash) {
	                    headers = { "If-None-Match": xAPI.formatHash(noneMatchHash) };
	                }
	
	                var method = "PUT";
	                if (stateval) {
	                    if (stateval instanceof Array) {
	                        stateval = JSON.stringify(stateval);
	                        headers = headers || {};
	                        headers["Content-Type"] = "application/json";
	                    } else if (stateval instanceof Object) {
	                        stateval = JSON.stringify(stateval);
	                        headers = headers || {};
	                        headers["Content-Type"] = "application/json";
	                        method = "POST";
	                    } else {
	                        headers = headers || {};
	                        headers["Content-Type"] = "application/octet-stream";
	                    }
	                } else {
	                    this.log("No activity state was included.");
	                    return false;
	                }
	
	                var params = {
	                    url: url,
	                    method: method,
	                    data: stateval,
	                    auth: this.lrs.auth,
	                    extraHeaders: headers,
	                    withCredentials: this.withCredentials
	                };
	
	                return xAPI.request(params).then(function (response) {
	                    return response;
	                }).catch(function (error) {
	                    throw error;
	                });
	            }
	        }
	    }, {
	        key: 'getState',
	        value: function getState(activityid, agent, stateid, registration, since, callback) {
	            if (this.testConfig()) {
	                var url = this.lrs.endpoint + "activities/state?activityId=<activity ID>&agent=<agent>";
	
	                url = url.replace('<activity ID>', encodeURIComponent(activityid));
	                url = url.replace('<agent>', encodeURIComponent(JSON.stringify(agent)));
	
	                if (stateid) {
	                    url += "&stateId=" + encodeURIComponent(stateid);
	                }
	
	                if (registration) {
	                    url += "&registration=" + encodeURIComponent(registration);
	                }
	
	                if (since) {
	                    since = isDate(since);
	                    if (since != null) {
	                        url += '&since=' + encodeURIComponent(since.toISOString());
	                    }
	                }
	
	                var params = {
	                    url: url,
	                    method: "GET",
	                    data: null,
	                    auth: this.lrs.auth,
	                    extraHeaders: null,
	                    withCredentials: this.withCredentials
	                };
	
	                return xAPI.request(params).then(function (response) {
	                    return response;
	                }).catch(function (error) {
	                    throw error;
	                });
	            }
	        }
	    }, {
	        key: 'deleteState',
	        value: function deleteState(activityid, agent, stateid, registration, matchHash, noneMatchHash, callback) {
	            if (this.testConfig()) {
	                var url = this.lrs.endpoint + "activities/state?activityId=<activity ID>&agent=<agent>&stateId=<stateid>";
	
	                url = url.replace('<activity ID>', encodeURIComponent(activityid));
	                url = url.replace('<agent>', encodeURIComponent(JSON.stringify(agent)));
	                url = url.replace('<stateid>', encodeURIComponent(stateid));
	
	                if (registration) {
	                    url += "&registration=" + encodeURIComponent(registration);
	                }
	
	                var headers = null;
	                if (matchHash && noneMatchHash) {
	                    this.log("Can't have both If-Match and If-None-Match");
	                } else if (matchHash) {
	                    headers = { "If-Match": xAPI.formatHash(matchHash) };
	                } else if (noneMatchHash) {
	                    headers = { "If-None-Match": xAPI.formatHash(noneMatchHash) };
	                }
	
	                var params = {
	                    url: url,
	                    method: "DELETE",
	                    data: null,
	                    auth: this.lrs.auth,
	                    extraHeaders: headers,
	                    withCredentials: this.withCredentials
	                };
	
	                return xAPI.request(params).then(function (response) {
	                    return response;
	                }).catch(function (error) {
	                    throw error;
	                });
	            }
	        }
	    }, {
	        key: 'sendActivityProfile',
	        value: function sendActivityProfile(activityid, profileid, profileval, matchHash, noneMatchHash, callback) {
	            if (this.testConfig()) {
	                var url = this.lrs.endpoint + "activities/profile?activityId=<activity ID>&profileId=<profileid>";
	
	                url = url.replace('<activity ID>', encodeURIComponent(activityid));
	                url = url.replace('<profileid>', encodeURIComponent(profileid));
	
	                var headers = null;
	                if (matchHash && noneMatchHash) {
	                    this.log("Can't have both If-Match and If-None-Match");
	                } else if (matchHash) {
	                    headers = { "If-Match": xAPI.formatHash(matchHash) };
	                } else if (noneMatchHash) {
	                    headers = { "If-None-Match": xAPI.formatHash(noneMatchHash) };
	                }
	
	                var method = "PUT";
	                if (profileval) {
	                    if (profileval instanceof Array) {
	                        profileval = JSON.stringify(profileval);
	                        headers = headers || {};
	                        headers["Content-Type"] = "application/json";
	                    } else if (profileval instanceof Object) {
	                        profileval = JSON.stringify(profileval);
	                        headers = headers || {};
	                        headers["Content-Type"] = "application/json";
	                        method = "POST";
	                    } else {
	                        headers = headers || {};
	                        headers["Content-Type"] = "application/octet-stream";
	                    }
	                } else {
	                    this.log("No activity profile was included.");
	                    return false;
	                }
	
	                var params = {
	                    url: url,
	                    method: method,
	                    data: profileval,
	                    auth: this.lrs.auth,
	                    extraHeaders: headers,
	                    withCredentials: this.withCredentials
	                };
	
	                return xAPI.request(params).then(function (response) {
	                    return response;
	                }).catch(function (error) {
	                    throw error;
	                });
	            }
	        }
	    }, {
	        key: 'getActivityProfile',
	        value: function getActivityProfile(activityid, profileid, since, callback) {
	            if (this.testConfig()) {
	                var url = this.lrs.endpoint + "activities/profile?activityId=<activity ID>";
	
	                url = url.replace('<activity ID>', encodeURIComponent(activityid));
	
	                if (profileid) {
	                    url += "&profileId=" + encodeURIComponent(profileid);
	                }
	
	                if (since) {
	                    since = isDate(since);
	                    if (since != null) {
	                        url += '&since=' + encodeURIComponent(since.toISOString());
	                    }
	                }
	
	                var params = {
	                    url: url,
	                    method: "GET",
	                    data: null,
	                    auth: this.lrs.auth,
	                    extraHeaders: null,
	                    withCredentials: this.withCredentials
	                };
	
	                return xAPI.request(params).then(function (response) {
	                    return response;
	                }).catch(function (error) {
	                    throw error;
	                });
	            }
	        }
	    }, {
	        key: 'deleteActivityProfile',
	        value: function deleteActivityProfile(activityid, profileid, matchHash, noneMatchHash, callback) {
	            if (this.testConfig()) {
	                var url = this.lrs.endpoint + "activities/profile?activityId=<activity ID>&profileId=<profileid>";
	
	                url = url.replace('<activity ID>', encodeURIComponent(activityid));
	                url = url.replace('<profileid>', encodeURIComponent(profileid));
	
	                var headers = null;
	                if (matchHash && noneMatchHash) {
	                    this.log("Can't have both If-Match and If-None-Match");
	                } else if (matchHash) {
	                    headers = { "If-Match": xAPI.formatHash(matchHash) };
	                } else if (noneMatchHash) {
	                    headers = { "If-None-Match": xAPI.formatHash(noneMatchHash) };
	                }
	
	                var params = {
	                    url: url,
	                    method: "DELETE",
	                    data: null,
	                    auth: this.lrs.auth,
	                    extraHeaders: headers,
	                    withCredentials: this.withCredentials
	                };
	
	                return xAPI.request(params).then(function (response) {
	                    return response;
	                }).catch(function (error) {
	                    throw error;
	                });
	            }
	        }
	    }, {
	        key: 'getAgents',
	        value: function getAgents(agent, callback) {
	            if (this.testConfig()) {
	                var url = this.lrs.endpoint + "agents?agent=<agent>";
	                url = url.replace('<agent>', encodeURIComponent(JSON.stringify(agent)));
	
	                var params = {
	                    url: url,
	                    method: "GET",
	                    data: null,
	                    auth: this.lrs.auth,
	                    extraHeaders: null,
	                    withCredentials: this.withCredentials
	                };
	
	                return xAPI.request(params).then(function (response) {
	                    return response;
	                }).catch(function (error) {
	                    throw error;
	                });
	            }
	        }
	    }, {
	        key: 'sendAgentProfile',
	        value: function sendAgentProfile(agent, profileid, profileval, matchHash, noneMatchHash, callback) {
	            if (this.testConfig()) {
	                var url = this.lrs.endpoint + "agents/profile?agent=<agent>&profileId=<profileid>";
	
	                url = url.replace('<agent>', encodeURIComponent(JSON.stringify(agent)));
	                url = url.replace('<profileid>', encodeURIComponent(profileid));
	
	                var headers = null;
	                if (matchHash && noneMatchHash) {
	                    this.log("Can't have both If-Match and If-None-Match");
	                } else if (matchHash) {
	                    headers = { "If-Match": xAPI.formatHash(matchHash) };
	                } else if (noneMatchHash) {
	                    headers = { "If-None-Match": xAPI.formatHash(noneMatchHash) };
	                }
	
	                var method = "PUT";
	                if (profileval) {
	                    if (profileval instanceof Array) {
	                        profileval = JSON.stringify(profileval);
	                        headers = headers || {};
	                        headers["Content-Type"] = "application/json";
	                    } else if (profileval instanceof Object) {
	                        profileval = JSON.stringify(profileval);
	                        headers = headers || {};
	                        headers["Content-Type"] = "application/json";
	                        method = "POST";
	                    } else {
	                        headers = headers || {};
	                        headers["Content-Type"] = "application/octet-stream";
	                    }
	                } else {
	                    this.log("No agent profile was included.");
	                    return false;
	                }
	
	                var params = {
	                    url: url,
	                    method: method,
	                    data: profileval,
	                    auth: this.lrs.auth,
	                    extraHeaders: headers,
	                    withCredentials: this.withCredentials
	                };
	
	                return xAPI.request(params).then(function (response) {
	                    return response;
	                }).catch(function (error) {
	                    throw error;
	                });
	            }
	        }
	    }, {
	        key: 'getAgentProfile',
	        value: function getAgentProfile(agent, profileid, since, callback) {
	            if (this.testConfig()) {
	                var url = this.lrs.endpoint + "agents/profile?agent=<agent>";
	
	                url = url.replace('<agent>', encodeURIComponent(JSON.stringify(agent)));
	                url = url.replace('<profileid>', encodeURIComponent(profileid));
	
	                if (profileid) {
	                    url += "&profileId=" + encodeURIComponent(profileid);
	                }
	
	                if (since) {
	                    since = isDate(since);
	                    if (since != null) {
	                        url += '&since=' + encodeURIComponent(since.toISOString());
	                    }
	                }
	
	                var params = {
	                    url: url,
	                    method: "GET",
	                    data: null,
	                    auth: this.lrs.auth,
	                    extraHeaders: null,
	                    withCredentials: this.withCredentials
	                };
	
	                return xAPI.request(params).then(function (response) {
	                    return response;
	                }).catch(function (error) {
	                    throw error;
	                });
	            }
	        }
	    }, {
	        key: 'deleteAgentProfile',
	        value: function deleteAgentProfile(agent, profileid, matchHash, noneMatchHash) {
	            if (this.testConfig()) {
	                var url = this.lrs.endpoint + "agents/profile?agent=<agent>&profileId=<profileid>";
	
	                url = url.replace('<agent>', encodeURIComponent(JSON.stringify(agent)));
	                url = url.replace('<profileid>', encodeURIComponent(profileid));
	
	                var headers = null;
	                if (matchHash && noneMatchHash) {
	                    this.log("Can't have both If-Match and If-None-Match");
	                } else if (matchHash) {
	                    headers = { "If-Match": xAPI.formatHash(matchHash) };
	                } else if (noneMatchHash) {
	                    headers = { "If-None-Match": xAPI.formatHash(noneMatchHash) };
	                }
	
	                var params = {
	                    url: url,
	                    method: "DELETE",
	                    data: null,
	                    auth: this.lrs.auth,
	                    extraHeaders: headers,
	                    withCredentials: this.withCredentials
	                };
	            }
	        }
	    }, {
	        key: 'testConfig',
	        value: function testConfig() {
	            try {
	                return this.lrs.endpoint != undefined && this.lrs.endpoint != "";
	            } catch (e) {
	                return false;
	            }
	        }
	    }, {
	        key: 'log',
	        value: function log(message) {
	            if (!debug) return false;
	            try {
	                console.log(message);
	                return true;
	            } catch (e) {
	                return false;
	            }
	        }
	    }, {
	        key: 'mergeRecursive',
	        value: function mergeRecursive(obj1, obj2) {
	            for (var p in obj2) {
	                var prop = obj2[p];
	                this.log(p + " :: " + prop);
	                try {
	                    // Property in destination object set; update its value.
	                    if (obj2[p].constructor == Object) {
	                        obj1[p] = this.mergeRecursive(obj1[p], obj2[p]);
	                    } else {
	                        if (obj1 == undefined) {
	                            obj1 = new Object();
	                        }
	                        obj1[p] = obj2[p];
	                    }
	                } catch (e) {
	                    if (obj1 == undefined) {
	                        obj1 = new Object();
	                    }
	                    // Property in destination object not set; create it and set its value.
	                    obj1[p] = obj2[p];
	                }
	            }
	
	            return obj1;
	        }
	    }, {
	        key: 'getLRSObject',
	        value: function getLRSObject(config) {
	            var lrsProps = ["endpoint", "auth", "actor", "registration", "activity_id", "grouping", "activity_platform"];
	            var lrs = new Object();
	            var qsVars = void 0,
	                prop = void 0;
	
	            qsVars = this.parseQueryString();
	            if (qsVars !== undefined && Object.keys(qsVars).length !== 0) {
	                for (var i = 0; i < lrsProps.length; i++) {
	                    prop = lrsProps[i];
	                    if (qsVars[prop]) {
	                        lrs[prop] = qsVars[prop];
	                        delete qsVars[prop];
	                    }
	                }
	                if (Object.keys(qsVars).length !== 0) {
	                    lrs.extended = qsVars;
	                }
	
	                lrs = this.mergeRecursive(config, lrs);
	            } else {
	                lrs = config;
	            }
	
	            return lrs;
	        }
	    }, {
	        key: 'parseQueryString',
	        value: function parseQueryString() {
	            var qs = void 0,
	                pairs = void 0,
	                pair = void 0,
	                ii = void 0,
	                parsed = void 0;
	
	            qs = window.location.search.substr(1);
	
	            pairs = qs.split('&');
	            parsed = {};
	            for (ii = 0; ii < pairs.length; ii++) {
	                pair = pairs[ii].split('=');
	                if (pair.length === 2 && pair[0]) {
	                    parsed[pair[0]] = decodeURIComponent(pair[1]);
	                }
	            }
	
	            return parsed;
	        }
	    }, {
	        key: 'ruuid',
	        value: function ruuid() {
	            return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
	                var r = Math.random() * 16 | 0,
	                    v = c == 'x' ? r : r & 0x3 | 0x8;
	                return v.toString(16);
	            });
	        }
	    }, {
	        key: 'dateFromISOString',
	        value: function dateFromISOString(isostr) {
	            var regexp = "([0-9]{4})(-([0-9]{2})(-([0-9]{2})" + "([T| ]([0-9]{2}):([0-9]{2})(:([0-9]{2})(\\.([0-9]+))?)?" + "(Z|(([-+])([0-9]{2}):([0-9]{2})))?)?)?)?";
	            var d = isostr.match(new RegExp(regexp));
	
	            var offset = 0;
	            var date = new Date(d[1], 0, 1);
	
	            if (d[3]) {
	                date.setMonth(d[3] - 1);
	            }
	            if (d[5]) {
	                date.setDate(d[5]);
	            }
	            if (d[7]) {
	                date.setHours(d[7]);
	            }
	            if (d[8]) {
	                date.setMinutes(d[8]);
	            }
	            if (d[10]) {
	                date.setSeconds(d[10]);
	            }
	            if (d[12]) {
	                date.setMilliseconds(Number("0." + d[12]) * 1000);
	            }
	            if (d[14]) {
	                offset = Number(d[16]) * 60 + Number(d[17]);
	                offset *= d[15] == '-' ? 1 : -1;
	            }
	
	            offset -= date.getTimezoneOffset();
	            var time = Number(date) + offset * 60 * 1000;
	
	            var dateToReturn = new Date();
	            dateToReturn.setTime(Number(time));
	            return dateToReturn;
	        }
	    }, {
	        key: 'request',
	        value: function request(params) {
	            return new Promise(function (resolve, reject) {
	
	                //headers
	                var headers = {
	                    "Content-Type": "application/json",
	                    "Authorization": params.auth,
	                    "X-Experience-API-Version": xapiVersion
	                };
	                if (params.extraHeaders !== null) {
	                    for (var headerName in params.extraHeaders) {
	                        headers[headerName] = params.extraHeaders[headerName];
	                    }
	                }
	
	                _jquery2.default.ajax({
	                    type: params.method,
	                    url: params.url,
	                    headers: headers,
	                    data: params.data,
	                    contentType: 'application/json',
	                    dataType: 'json',
	                    urlParts: params.url.toLowerCase().match(/^(.+):\/\/([^:\\/]*):?(\d+)?(\/.*)?$/),
	                    location: window.location,
	                    withCredentials: params.withCredentials
	
	                }).done(resolve).fail(reject);
	            });
	        }
	    }, {
	        key: 'formatHash',
	        value: function formatHash(hash) {
	            return hash === "*" ? hash : '"' + hash + '"';
	        }
	    }]);
	
	    return xAPI;
	}();
	
	exports.default = xAPI;

/***/ },
/* 290 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer, global) {/*!
	 * The buffer module from node.js, for the browser.
	 *
	 * @author   Feross Aboukhadijeh <feross@feross.org> <http://feross.org>
	 * @license  MIT
	 */
	/* eslint-disable no-proto */
	
	'use strict'
	
	var base64 = __webpack_require__(589)
	var ieee754 = __webpack_require__(843)
	var isArray = __webpack_require__(846)
	
	exports.Buffer = Buffer
	exports.SlowBuffer = SlowBuffer
	exports.INSPECT_MAX_BYTES = 50
	
	/**
	 * If `Buffer.TYPED_ARRAY_SUPPORT`:
	 *   === true    Use Uint8Array implementation (fastest)
	 *   === false   Use Object implementation (most compatible, even IE6)
	 *
	 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
	 * Opera 11.6+, iOS 4.2+.
	 *
	 * Due to various browser bugs, sometimes the Object implementation will be used even
	 * when the browser supports typed arrays.
	 *
	 * Note:
	 *
	 *   - Firefox 4-29 lacks support for adding new properties to `Uint8Array` instances,
	 *     See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438.
	 *
	 *   - Chrome 9-10 is missing the `TypedArray.prototype.subarray` function.
	 *
	 *   - IE10 has a broken `TypedArray.prototype.subarray` function which returns arrays of
	 *     incorrect length in some situations.
	
	 * We detect these buggy browsers and set `Buffer.TYPED_ARRAY_SUPPORT` to `false` so they
	 * get the Object implementation, which is slower but behaves correctly.
	 */
	Buffer.TYPED_ARRAY_SUPPORT = global.TYPED_ARRAY_SUPPORT !== undefined
	  ? global.TYPED_ARRAY_SUPPORT
	  : typedArraySupport()
	
	/*
	 * Export kMaxLength after typed array support is determined.
	 */
	exports.kMaxLength = kMaxLength()
	
	function typedArraySupport () {
	  try {
	    var arr = new Uint8Array(1)
	    arr.__proto__ = {__proto__: Uint8Array.prototype, foo: function () { return 42 }}
	    return arr.foo() === 42 && // typed array instances can be augmented
	        typeof arr.subarray === 'function' && // chrome 9-10 lack `subarray`
	        arr.subarray(1, 1).byteLength === 0 // ie10 has broken `subarray`
	  } catch (e) {
	    return false
	  }
	}
	
	function kMaxLength () {
	  return Buffer.TYPED_ARRAY_SUPPORT
	    ? 0x7fffffff
	    : 0x3fffffff
	}
	
	function createBuffer (that, length) {
	  if (kMaxLength() < length) {
	    throw new RangeError('Invalid typed array length')
	  }
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    // Return an augmented `Uint8Array` instance, for best performance
	    that = new Uint8Array(length)
	    that.__proto__ = Buffer.prototype
	  } else {
	    // Fallback: Return an object instance of the Buffer class
	    if (that === null) {
	      that = new Buffer(length)
	    }
	    that.length = length
	  }
	
	  return that
	}
	
	/**
	 * The Buffer constructor returns instances of `Uint8Array` that have their
	 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
	 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
	 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
	 * returns a single octet.
	 *
	 * The `Uint8Array` prototype remains unmodified.
	 */
	
	function Buffer (arg, encodingOrOffset, length) {
	  if (!Buffer.TYPED_ARRAY_SUPPORT && !(this instanceof Buffer)) {
	    return new Buffer(arg, encodingOrOffset, length)
	  }
	
	  // Common case.
	  if (typeof arg === 'number') {
	    if (typeof encodingOrOffset === 'string') {
	      throw new Error(
	        'If encoding is specified then the first argument must be a string'
	      )
	    }
	    return allocUnsafe(this, arg)
	  }
	  return from(this, arg, encodingOrOffset, length)
	}
	
	Buffer.poolSize = 8192 // not used by this implementation
	
	// TODO: Legacy, not needed anymore. Remove in next major version.
	Buffer._augment = function (arr) {
	  arr.__proto__ = Buffer.prototype
	  return arr
	}
	
	function from (that, value, encodingOrOffset, length) {
	  if (typeof value === 'number') {
	    throw new TypeError('"value" argument must not be a number')
	  }
	
	  if (typeof ArrayBuffer !== 'undefined' && value instanceof ArrayBuffer) {
	    return fromArrayBuffer(that, value, encodingOrOffset, length)
	  }
	
	  if (typeof value === 'string') {
	    return fromString(that, value, encodingOrOffset)
	  }
	
	  return fromObject(that, value)
	}
	
	/**
	 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
	 * if value is a number.
	 * Buffer.from(str[, encoding])
	 * Buffer.from(array)
	 * Buffer.from(buffer)
	 * Buffer.from(arrayBuffer[, byteOffset[, length]])
	 **/
	Buffer.from = function (value, encodingOrOffset, length) {
	  return from(null, value, encodingOrOffset, length)
	}
	
	if (Buffer.TYPED_ARRAY_SUPPORT) {
	  Buffer.prototype.__proto__ = Uint8Array.prototype
	  Buffer.__proto__ = Uint8Array
	  if (typeof Symbol !== 'undefined' && Symbol.species &&
	      Buffer[Symbol.species] === Buffer) {
	    // Fix subarray() in ES2016. See: https://github.com/feross/buffer/pull/97
	    Object.defineProperty(Buffer, Symbol.species, {
	      value: null,
	      configurable: true
	    })
	  }
	}
	
	function assertSize (size) {
	  if (typeof size !== 'number') {
	    throw new TypeError('"size" argument must be a number')
	  } else if (size < 0) {
	    throw new RangeError('"size" argument must not be negative')
	  }
	}
	
	function alloc (that, size, fill, encoding) {
	  assertSize(size)
	  if (size <= 0) {
	    return createBuffer(that, size)
	  }
	  if (fill !== undefined) {
	    // Only pay attention to encoding if it's a string. This
	    // prevents accidentally sending in a number that would
	    // be interpretted as a start offset.
	    return typeof encoding === 'string'
	      ? createBuffer(that, size).fill(fill, encoding)
	      : createBuffer(that, size).fill(fill)
	  }
	  return createBuffer(that, size)
	}
	
	/**
	 * Creates a new filled Buffer instance.
	 * alloc(size[, fill[, encoding]])
	 **/
	Buffer.alloc = function (size, fill, encoding) {
	  return alloc(null, size, fill, encoding)
	}
	
	function allocUnsafe (that, size) {
	  assertSize(size)
	  that = createBuffer(that, size < 0 ? 0 : checked(size) | 0)
	  if (!Buffer.TYPED_ARRAY_SUPPORT) {
	    for (var i = 0; i < size; ++i) {
	      that[i] = 0
	    }
	  }
	  return that
	}
	
	/**
	 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
	 * */
	Buffer.allocUnsafe = function (size) {
	  return allocUnsafe(null, size)
	}
	/**
	 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
	 */
	Buffer.allocUnsafeSlow = function (size) {
	  return allocUnsafe(null, size)
	}
	
	function fromString (that, string, encoding) {
	  if (typeof encoding !== 'string' || encoding === '') {
	    encoding = 'utf8'
	  }
	
	  if (!Buffer.isEncoding(encoding)) {
	    throw new TypeError('"encoding" must be a valid string encoding')
	  }
	
	  var length = byteLength(string, encoding) | 0
	  that = createBuffer(that, length)
	
	  var actual = that.write(string, encoding)
	
	  if (actual !== length) {
	    // Writing a hex string, for example, that contains invalid characters will
	    // cause everything after the first invalid character to be ignored. (e.g.
	    // 'abxxcd' will be treated as 'ab')
	    that = that.slice(0, actual)
	  }
	
	  return that
	}
	
	function fromArrayLike (that, array) {
	  var length = array.length < 0 ? 0 : checked(array.length) | 0
	  that = createBuffer(that, length)
	  for (var i = 0; i < length; i += 1) {
	    that[i] = array[i] & 255
	  }
	  return that
	}
	
	function fromArrayBuffer (that, array, byteOffset, length) {
	  array.byteLength // this throws if `array` is not a valid ArrayBuffer
	
	  if (byteOffset < 0 || array.byteLength < byteOffset) {
	    throw new RangeError('\'offset\' is out of bounds')
	  }
	
	  if (array.byteLength < byteOffset + (length || 0)) {
	    throw new RangeError('\'length\' is out of bounds')
	  }
	
	  if (byteOffset === undefined && length === undefined) {
	    array = new Uint8Array(array)
	  } else if (length === undefined) {
	    array = new Uint8Array(array, byteOffset)
	  } else {
	    array = new Uint8Array(array, byteOffset, length)
	  }
	
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    // Return an augmented `Uint8Array` instance, for best performance
	    that = array
	    that.__proto__ = Buffer.prototype
	  } else {
	    // Fallback: Return an object instance of the Buffer class
	    that = fromArrayLike(that, array)
	  }
	  return that
	}
	
	function fromObject (that, obj) {
	  if (Buffer.isBuffer(obj)) {
	    var len = checked(obj.length) | 0
	    that = createBuffer(that, len)
	
	    if (that.length === 0) {
	      return that
	    }
	
	    obj.copy(that, 0, 0, len)
	    return that
	  }
	
	  if (obj) {
	    if ((typeof ArrayBuffer !== 'undefined' &&
	        obj.buffer instanceof ArrayBuffer) || 'length' in obj) {
	      if (typeof obj.length !== 'number' || isnan(obj.length)) {
	        return createBuffer(that, 0)
	      }
	      return fromArrayLike(that, obj)
	    }
	
	    if (obj.type === 'Buffer' && isArray(obj.data)) {
	      return fromArrayLike(that, obj.data)
	    }
	  }
	
	  throw new TypeError('First argument must be a string, Buffer, ArrayBuffer, Array, or array-like object.')
	}
	
	function checked (length) {
	  // Note: cannot use `length < kMaxLength()` here because that fails when
	  // length is NaN (which is otherwise coerced to zero.)
	  if (length >= kMaxLength()) {
	    throw new RangeError('Attempt to allocate Buffer larger than maximum ' +
	                         'size: 0x' + kMaxLength().toString(16) + ' bytes')
	  }
	  return length | 0
	}
	
	function SlowBuffer (length) {
	  if (+length != length) { // eslint-disable-line eqeqeq
	    length = 0
	  }
	  return Buffer.alloc(+length)
	}
	
	Buffer.isBuffer = function isBuffer (b) {
	  return !!(b != null && b._isBuffer)
	}
	
	Buffer.compare = function compare (a, b) {
	  if (!Buffer.isBuffer(a) || !Buffer.isBuffer(b)) {
	    throw new TypeError('Arguments must be Buffers')
	  }
	
	  if (a === b) return 0
	
	  var x = a.length
	  var y = b.length
	
	  for (var i = 0, len = Math.min(x, y); i < len; ++i) {
	    if (a[i] !== b[i]) {
	      x = a[i]
	      y = b[i]
	      break
	    }
	  }
	
	  if (x < y) return -1
	  if (y < x) return 1
	  return 0
	}
	
	Buffer.isEncoding = function isEncoding (encoding) {
	  switch (String(encoding).toLowerCase()) {
	    case 'hex':
	    case 'utf8':
	    case 'utf-8':
	    case 'ascii':
	    case 'latin1':
	    case 'binary':
	    case 'base64':
	    case 'ucs2':
	    case 'ucs-2':
	    case 'utf16le':
	    case 'utf-16le':
	      return true
	    default:
	      return false
	  }
	}
	
	Buffer.concat = function concat (list, length) {
	  if (!isArray(list)) {
	    throw new TypeError('"list" argument must be an Array of Buffers')
	  }
	
	  if (list.length === 0) {
	    return Buffer.alloc(0)
	  }
	
	  var i
	  if (length === undefined) {
	    length = 0
	    for (i = 0; i < list.length; ++i) {
	      length += list[i].length
	    }
	  }
	
	  var buffer = Buffer.allocUnsafe(length)
	  var pos = 0
	  for (i = 0; i < list.length; ++i) {
	    var buf = list[i]
	    if (!Buffer.isBuffer(buf)) {
	      throw new TypeError('"list" argument must be an Array of Buffers')
	    }
	    buf.copy(buffer, pos)
	    pos += buf.length
	  }
	  return buffer
	}
	
	function byteLength (string, encoding) {
	  if (Buffer.isBuffer(string)) {
	    return string.length
	  }
	  if (typeof ArrayBuffer !== 'undefined' && typeof ArrayBuffer.isView === 'function' &&
	      (ArrayBuffer.isView(string) || string instanceof ArrayBuffer)) {
	    return string.byteLength
	  }
	  if (typeof string !== 'string') {
	    string = '' + string
	  }
	
	  var len = string.length
	  if (len === 0) return 0
	
	  // Use a for loop to avoid recursion
	  var loweredCase = false
	  for (;;) {
	    switch (encoding) {
	      case 'ascii':
	      case 'latin1':
	      case 'binary':
	        return len
	      case 'utf8':
	      case 'utf-8':
	      case undefined:
	        return utf8ToBytes(string).length
	      case 'ucs2':
	      case 'ucs-2':
	      case 'utf16le':
	      case 'utf-16le':
	        return len * 2
	      case 'hex':
	        return len >>> 1
	      case 'base64':
	        return base64ToBytes(string).length
	      default:
	        if (loweredCase) return utf8ToBytes(string).length // assume utf8
	        encoding = ('' + encoding).toLowerCase()
	        loweredCase = true
	    }
	  }
	}
	Buffer.byteLength = byteLength
	
	function slowToString (encoding, start, end) {
	  var loweredCase = false
	
	  // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
	  // property of a typed array.
	
	  // This behaves neither like String nor Uint8Array in that we set start/end
	  // to their upper/lower bounds if the value passed is out of range.
	  // undefined is handled specially as per ECMA-262 6th Edition,
	  // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
	  if (start === undefined || start < 0) {
	    start = 0
	  }
	  // Return early if start > this.length. Done here to prevent potential uint32
	  // coercion fail below.
	  if (start > this.length) {
	    return ''
	  }
	
	  if (end === undefined || end > this.length) {
	    end = this.length
	  }
	
	  if (end <= 0) {
	    return ''
	  }
	
	  // Force coersion to uint32. This will also coerce falsey/NaN values to 0.
	  end >>>= 0
	  start >>>= 0
	
	  if (end <= start) {
	    return ''
	  }
	
	  if (!encoding) encoding = 'utf8'
	
	  while (true) {
	    switch (encoding) {
	      case 'hex':
	        return hexSlice(this, start, end)
	
	      case 'utf8':
	      case 'utf-8':
	        return utf8Slice(this, start, end)
	
	      case 'ascii':
	        return asciiSlice(this, start, end)
	
	      case 'latin1':
	      case 'binary':
	        return latin1Slice(this, start, end)
	
	      case 'base64':
	        return base64Slice(this, start, end)
	
	      case 'ucs2':
	      case 'ucs-2':
	      case 'utf16le':
	      case 'utf-16le':
	        return utf16leSlice(this, start, end)
	
	      default:
	        if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding)
	        encoding = (encoding + '').toLowerCase()
	        loweredCase = true
	    }
	  }
	}
	
	// The property is used by `Buffer.isBuffer` and `is-buffer` (in Safari 5-7) to detect
	// Buffer instances.
	Buffer.prototype._isBuffer = true
	
	function swap (b, n, m) {
	  var i = b[n]
	  b[n] = b[m]
	  b[m] = i
	}
	
	Buffer.prototype.swap16 = function swap16 () {
	  var len = this.length
	  if (len % 2 !== 0) {
	    throw new RangeError('Buffer size must be a multiple of 16-bits')
	  }
	  for (var i = 0; i < len; i += 2) {
	    swap(this, i, i + 1)
	  }
	  return this
	}
	
	Buffer.prototype.swap32 = function swap32 () {
	  var len = this.length
	  if (len % 4 !== 0) {
	    throw new RangeError('Buffer size must be a multiple of 32-bits')
	  }
	  for (var i = 0; i < len; i += 4) {
	    swap(this, i, i + 3)
	    swap(this, i + 1, i + 2)
	  }
	  return this
	}
	
	Buffer.prototype.swap64 = function swap64 () {
	  var len = this.length
	  if (len % 8 !== 0) {
	    throw new RangeError('Buffer size must be a multiple of 64-bits')
	  }
	  for (var i = 0; i < len; i += 8) {
	    swap(this, i, i + 7)
	    swap(this, i + 1, i + 6)
	    swap(this, i + 2, i + 5)
	    swap(this, i + 3, i + 4)
	  }
	  return this
	}
	
	Buffer.prototype.toString = function toString () {
	  var length = this.length | 0
	  if (length === 0) return ''
	  if (arguments.length === 0) return utf8Slice(this, 0, length)
	  return slowToString.apply(this, arguments)
	}
	
	Buffer.prototype.equals = function equals (b) {
	  if (!Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer')
	  if (this === b) return true
	  return Buffer.compare(this, b) === 0
	}
	
	Buffer.prototype.inspect = function inspect () {
	  var str = ''
	  var max = exports.INSPECT_MAX_BYTES
	  if (this.length > 0) {
	    str = this.toString('hex', 0, max).match(/.{2}/g).join(' ')
	    if (this.length > max) str += ' ... '
	  }
	  return '<Buffer ' + str + '>'
	}
	
	Buffer.prototype.compare = function compare (target, start, end, thisStart, thisEnd) {
	  if (!Buffer.isBuffer(target)) {
	    throw new TypeError('Argument must be a Buffer')
	  }
	
	  if (start === undefined) {
	    start = 0
	  }
	  if (end === undefined) {
	    end = target ? target.length : 0
	  }
	  if (thisStart === undefined) {
	    thisStart = 0
	  }
	  if (thisEnd === undefined) {
	    thisEnd = this.length
	  }
	
	  if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) {
	    throw new RangeError('out of range index')
	  }
	
	  if (thisStart >= thisEnd && start >= end) {
	    return 0
	  }
	  if (thisStart >= thisEnd) {
	    return -1
	  }
	  if (start >= end) {
	    return 1
	  }
	
	  start >>>= 0
	  end >>>= 0
	  thisStart >>>= 0
	  thisEnd >>>= 0
	
	  if (this === target) return 0
	
	  var x = thisEnd - thisStart
	  var y = end - start
	  var len = Math.min(x, y)
	
	  var thisCopy = this.slice(thisStart, thisEnd)
	  var targetCopy = target.slice(start, end)
	
	  for (var i = 0; i < len; ++i) {
	    if (thisCopy[i] !== targetCopy[i]) {
	      x = thisCopy[i]
	      y = targetCopy[i]
	      break
	    }
	  }
	
	  if (x < y) return -1
	  if (y < x) return 1
	  return 0
	}
	
	// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
	// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
	//
	// Arguments:
	// - buffer - a Buffer to search
	// - val - a string, Buffer, or number
	// - byteOffset - an index into `buffer`; will be clamped to an int32
	// - encoding - an optional encoding, relevant is val is a string
	// - dir - true for indexOf, false for lastIndexOf
	function bidirectionalIndexOf (buffer, val, byteOffset, encoding, dir) {
	  // Empty buffer means no match
	  if (buffer.length === 0) return -1
	
	  // Normalize byteOffset
	  if (typeof byteOffset === 'string') {
	    encoding = byteOffset
	    byteOffset = 0
	  } else if (byteOffset > 0x7fffffff) {
	    byteOffset = 0x7fffffff
	  } else if (byteOffset < -0x80000000) {
	    byteOffset = -0x80000000
	  }
	  byteOffset = +byteOffset  // Coerce to Number.
	  if (isNaN(byteOffset)) {
	    // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
	    byteOffset = dir ? 0 : (buffer.length - 1)
	  }
	
	  // Normalize byteOffset: negative offsets start from the end of the buffer
	  if (byteOffset < 0) byteOffset = buffer.length + byteOffset
	  if (byteOffset >= buffer.length) {
	    if (dir) return -1
	    else byteOffset = buffer.length - 1
	  } else if (byteOffset < 0) {
	    if (dir) byteOffset = 0
	    else return -1
	  }
	
	  // Normalize val
	  if (typeof val === 'string') {
	    val = Buffer.from(val, encoding)
	  }
	
	  // Finally, search either indexOf (if dir is true) or lastIndexOf
	  if (Buffer.isBuffer(val)) {
	    // Special case: looking for empty string/buffer always fails
	    if (val.length === 0) {
	      return -1
	    }
	    return arrayIndexOf(buffer, val, byteOffset, encoding, dir)
	  } else if (typeof val === 'number') {
	    val = val & 0xFF // Search for a byte value [0-255]
	    if (Buffer.TYPED_ARRAY_SUPPORT &&
	        typeof Uint8Array.prototype.indexOf === 'function') {
	      if (dir) {
	        return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset)
	      } else {
	        return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset)
	      }
	    }
	    return arrayIndexOf(buffer, [ val ], byteOffset, encoding, dir)
	  }
	
	  throw new TypeError('val must be string, number or Buffer')
	}
	
	function arrayIndexOf (arr, val, byteOffset, encoding, dir) {
	  var indexSize = 1
	  var arrLength = arr.length
	  var valLength = val.length
	
	  if (encoding !== undefined) {
	    encoding = String(encoding).toLowerCase()
	    if (encoding === 'ucs2' || encoding === 'ucs-2' ||
	        encoding === 'utf16le' || encoding === 'utf-16le') {
	      if (arr.length < 2 || val.length < 2) {
	        return -1
	      }
	      indexSize = 2
	      arrLength /= 2
	      valLength /= 2
	      byteOffset /= 2
	    }
	  }
	
	  function read (buf, i) {
	    if (indexSize === 1) {
	      return buf[i]
	    } else {
	      return buf.readUInt16BE(i * indexSize)
	    }
	  }
	
	  var i
	  if (dir) {
	    var foundIndex = -1
	    for (i = byteOffset; i < arrLength; i++) {
	      if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
	        if (foundIndex === -1) foundIndex = i
	        if (i - foundIndex + 1 === valLength) return foundIndex * indexSize
	      } else {
	        if (foundIndex !== -1) i -= i - foundIndex
	        foundIndex = -1
	      }
	    }
	  } else {
	    if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength
	    for (i = byteOffset; i >= 0; i--) {
	      var found = true
	      for (var j = 0; j < valLength; j++) {
	        if (read(arr, i + j) !== read(val, j)) {
	          found = false
	          break
	        }
	      }
	      if (found) return i
	    }
	  }
	
	  return -1
	}
	
	Buffer.prototype.includes = function includes (val, byteOffset, encoding) {
	  return this.indexOf(val, byteOffset, encoding) !== -1
	}
	
	Buffer.prototype.indexOf = function indexOf (val, byteOffset, encoding) {
	  return bidirectionalIndexOf(this, val, byteOffset, encoding, true)
	}
	
	Buffer.prototype.lastIndexOf = function lastIndexOf (val, byteOffset, encoding) {
	  return bidirectionalIndexOf(this, val, byteOffset, encoding, false)
	}
	
	function hexWrite (buf, string, offset, length) {
	  offset = Number(offset) || 0
	  var remaining = buf.length - offset
	  if (!length) {
	    length = remaining
	  } else {
	    length = Number(length)
	    if (length > remaining) {
	      length = remaining
	    }
	  }
	
	  // must be an even number of digits
	  var strLen = string.length
	  if (strLen % 2 !== 0) throw new TypeError('Invalid hex string')
	
	  if (length > strLen / 2) {
	    length = strLen / 2
	  }
	  for (var i = 0; i < length; ++i) {
	    var parsed = parseInt(string.substr(i * 2, 2), 16)
	    if (isNaN(parsed)) return i
	    buf[offset + i] = parsed
	  }
	  return i
	}
	
	function utf8Write (buf, string, offset, length) {
	  return blitBuffer(utf8ToBytes(string, buf.length - offset), buf, offset, length)
	}
	
	function asciiWrite (buf, string, offset, length) {
	  return blitBuffer(asciiToBytes(string), buf, offset, length)
	}
	
	function latin1Write (buf, string, offset, length) {
	  return asciiWrite(buf, string, offset, length)
	}
	
	function base64Write (buf, string, offset, length) {
	  return blitBuffer(base64ToBytes(string), buf, offset, length)
	}
	
	function ucs2Write (buf, string, offset, length) {
	  return blitBuffer(utf16leToBytes(string, buf.length - offset), buf, offset, length)
	}
	
	Buffer.prototype.write = function write (string, offset, length, encoding) {
	  // Buffer#write(string)
	  if (offset === undefined) {
	    encoding = 'utf8'
	    length = this.length
	    offset = 0
	  // Buffer#write(string, encoding)
	  } else if (length === undefined && typeof offset === 'string') {
	    encoding = offset
	    length = this.length
	    offset = 0
	  // Buffer#write(string, offset[, length][, encoding])
	  } else if (isFinite(offset)) {
	    offset = offset | 0
	    if (isFinite(length)) {
	      length = length | 0
	      if (encoding === undefined) encoding = 'utf8'
	    } else {
	      encoding = length
	      length = undefined
	    }
	  // legacy write(string, encoding, offset, length) - remove in v0.13
	  } else {
	    throw new Error(
	      'Buffer.write(string, encoding, offset[, length]) is no longer supported'
	    )
	  }
	
	  var remaining = this.length - offset
	  if (length === undefined || length > remaining) length = remaining
	
	  if ((string.length > 0 && (length < 0 || offset < 0)) || offset > this.length) {
	    throw new RangeError('Attempt to write outside buffer bounds')
	  }
	
	  if (!encoding) encoding = 'utf8'
	
	  var loweredCase = false
	  for (;;) {
	    switch (encoding) {
	      case 'hex':
	        return hexWrite(this, string, offset, length)
	
	      case 'utf8':
	      case 'utf-8':
	        return utf8Write(this, string, offset, length)
	
	      case 'ascii':
	        return asciiWrite(this, string, offset, length)
	
	      case 'latin1':
	      case 'binary':
	        return latin1Write(this, string, offset, length)
	
	      case 'base64':
	        // Warning: maxLength not taken into account in base64Write
	        return base64Write(this, string, offset, length)
	
	      case 'ucs2':
	      case 'ucs-2':
	      case 'utf16le':
	      case 'utf-16le':
	        return ucs2Write(this, string, offset, length)
	
	      default:
	        if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding)
	        encoding = ('' + encoding).toLowerCase()
	        loweredCase = true
	    }
	  }
	}
	
	Buffer.prototype.toJSON = function toJSON () {
	  return {
	    type: 'Buffer',
	    data: Array.prototype.slice.call(this._arr || this, 0)
	  }
	}
	
	function base64Slice (buf, start, end) {
	  if (start === 0 && end === buf.length) {
	    return base64.fromByteArray(buf)
	  } else {
	    return base64.fromByteArray(buf.slice(start, end))
	  }
	}
	
	function utf8Slice (buf, start, end) {
	  end = Math.min(buf.length, end)
	  var res = []
	
	  var i = start
	  while (i < end) {
	    var firstByte = buf[i]
	    var codePoint = null
	    var bytesPerSequence = (firstByte > 0xEF) ? 4
	      : (firstByte > 0xDF) ? 3
	      : (firstByte > 0xBF) ? 2
	      : 1
	
	    if (i + bytesPerSequence <= end) {
	      var secondByte, thirdByte, fourthByte, tempCodePoint
	
	      switch (bytesPerSequence) {
	        case 1:
	          if (firstByte < 0x80) {
	            codePoint = firstByte
	          }
	          break
	        case 2:
	          secondByte = buf[i + 1]
	          if ((secondByte & 0xC0) === 0x80) {
	            tempCodePoint = (firstByte & 0x1F) << 0x6 | (secondByte & 0x3F)
	            if (tempCodePoint > 0x7F) {
	              codePoint = tempCodePoint
	            }
	          }
	          break
	        case 3:
	          secondByte = buf[i + 1]
	          thirdByte = buf[i + 2]
	          if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
	            tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | (thirdByte & 0x3F)
	            if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) {
	              codePoint = tempCodePoint
	            }
	          }
	          break
	        case 4:
	          secondByte = buf[i + 1]
	          thirdByte = buf[i + 2]
	          fourthByte = buf[i + 3]
	          if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
	            tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | (fourthByte & 0x3F)
	            if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) {
	              codePoint = tempCodePoint
	            }
	          }
	      }
	    }
	
	    if (codePoint === null) {
	      // we did not generate a valid codePoint so insert a
	      // replacement char (U+FFFD) and advance only 1 byte
	      codePoint = 0xFFFD
	      bytesPerSequence = 1
	    } else if (codePoint > 0xFFFF) {
	      // encode to utf16 (surrogate pair dance)
	      codePoint -= 0x10000
	      res.push(codePoint >>> 10 & 0x3FF | 0xD800)
	      codePoint = 0xDC00 | codePoint & 0x3FF
	    }
	
	    res.push(codePoint)
	    i += bytesPerSequence
	  }
	
	  return decodeCodePointsArray(res)
	}
	
	// Based on http://stackoverflow.com/a/22747272/680742, the browser with
	// the lowest limit is Chrome, with 0x10000 args.
	// We go 1 magnitude less, for safety
	var MAX_ARGUMENTS_LENGTH = 0x1000
	
	function decodeCodePointsArray (codePoints) {
	  var len = codePoints.length
	  if (len <= MAX_ARGUMENTS_LENGTH) {
	    return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
	  }
	
	  // Decode in chunks to avoid "call stack size exceeded".
	  var res = ''
	  var i = 0
	  while (i < len) {
	    res += String.fromCharCode.apply(
	      String,
	      codePoints.slice(i, i += MAX_ARGUMENTS_LENGTH)
	    )
	  }
	  return res
	}
	
	function asciiSlice (buf, start, end) {
	  var ret = ''
	  end = Math.min(buf.length, end)
	
	  for (var i = start; i < end; ++i) {
	    ret += String.fromCharCode(buf[i] & 0x7F)
	  }
	  return ret
	}
	
	function latin1Slice (buf, start, end) {
	  var ret = ''
	  end = Math.min(buf.length, end)
	
	  for (var i = start; i < end; ++i) {
	    ret += String.fromCharCode(buf[i])
	  }
	  return ret
	}
	
	function hexSlice (buf, start, end) {
	  var len = buf.length
	
	  if (!start || start < 0) start = 0
	  if (!end || end < 0 || end > len) end = len
	
	  var out = ''
	  for (var i = start; i < end; ++i) {
	    out += toHex(buf[i])
	  }
	  return out
	}
	
	function utf16leSlice (buf, start, end) {
	  var bytes = buf.slice(start, end)
	  var res = ''
	  for (var i = 0; i < bytes.length; i += 2) {
	    res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256)
	  }
	  return res
	}
	
	Buffer.prototype.slice = function slice (start, end) {
	  var len = this.length
	  start = ~~start
	  end = end === undefined ? len : ~~end
	
	  if (start < 0) {
	    start += len
	    if (start < 0) start = 0
	  } else if (start > len) {
	    start = len
	  }
	
	  if (end < 0) {
	    end += len
	    if (end < 0) end = 0
	  } else if (end > len) {
	    end = len
	  }
	
	  if (end < start) end = start
	
	  var newBuf
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    newBuf = this.subarray(start, end)
	    newBuf.__proto__ = Buffer.prototype
	  } else {
	    var sliceLen = end - start
	    newBuf = new Buffer(sliceLen, undefined)
	    for (var i = 0; i < sliceLen; ++i) {
	      newBuf[i] = this[i + start]
	    }
	  }
	
	  return newBuf
	}
	
	/*
	 * Need to make sure that buffer isn't trying to write out of bounds.
	 */
	function checkOffset (offset, ext, length) {
	  if ((offset % 1) !== 0 || offset < 0) throw new RangeError('offset is not uint')
	  if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length')
	}
	
	Buffer.prototype.readUIntLE = function readUIntLE (offset, byteLength, noAssert) {
	  offset = offset | 0
	  byteLength = byteLength | 0
	  if (!noAssert) checkOffset(offset, byteLength, this.length)
	
	  var val = this[offset]
	  var mul = 1
	  var i = 0
	  while (++i < byteLength && (mul *= 0x100)) {
	    val += this[offset + i] * mul
	  }
	
	  return val
	}
	
	Buffer.prototype.readUIntBE = function readUIntBE (offset, byteLength, noAssert) {
	  offset = offset | 0
	  byteLength = byteLength | 0
	  if (!noAssert) {
	    checkOffset(offset, byteLength, this.length)
	  }
	
	  var val = this[offset + --byteLength]
	  var mul = 1
	  while (byteLength > 0 && (mul *= 0x100)) {
	    val += this[offset + --byteLength] * mul
	  }
	
	  return val
	}
	
	Buffer.prototype.readUInt8 = function readUInt8 (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 1, this.length)
	  return this[offset]
	}
	
	Buffer.prototype.readUInt16LE = function readUInt16LE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 2, this.length)
	  return this[offset] | (this[offset + 1] << 8)
	}
	
	Buffer.prototype.readUInt16BE = function readUInt16BE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 2, this.length)
	  return (this[offset] << 8) | this[offset + 1]
	}
	
	Buffer.prototype.readUInt32LE = function readUInt32LE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 4, this.length)
	
	  return ((this[offset]) |
	      (this[offset + 1] << 8) |
	      (this[offset + 2] << 16)) +
	      (this[offset + 3] * 0x1000000)
	}
	
	Buffer.prototype.readUInt32BE = function readUInt32BE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 4, this.length)
	
	  return (this[offset] * 0x1000000) +
	    ((this[offset + 1] << 16) |
	    (this[offset + 2] << 8) |
	    this[offset + 3])
	}
	
	Buffer.prototype.readIntLE = function readIntLE (offset, byteLength, noAssert) {
	  offset = offset | 0
	  byteLength = byteLength | 0
	  if (!noAssert) checkOffset(offset, byteLength, this.length)
	
	  var val = this[offset]
	  var mul = 1
	  var i = 0
	  while (++i < byteLength && (mul *= 0x100)) {
	    val += this[offset + i] * mul
	  }
	  mul *= 0x80
	
	  if (val >= mul) val -= Math.pow(2, 8 * byteLength)
	
	  return val
	}
	
	Buffer.prototype.readIntBE = function readIntBE (offset, byteLength, noAssert) {
	  offset = offset | 0
	  byteLength = byteLength | 0
	  if (!noAssert) checkOffset(offset, byteLength, this.length)
	
	  var i = byteLength
	  var mul = 1
	  var val = this[offset + --i]
	  while (i > 0 && (mul *= 0x100)) {
	    val += this[offset + --i] * mul
	  }
	  mul *= 0x80
	
	  if (val >= mul) val -= Math.pow(2, 8 * byteLength)
	
	  return val
	}
	
	Buffer.prototype.readInt8 = function readInt8 (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 1, this.length)
	  if (!(this[offset] & 0x80)) return (this[offset])
	  return ((0xff - this[offset] + 1) * -1)
	}
	
	Buffer.prototype.readInt16LE = function readInt16LE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 2, this.length)
	  var val = this[offset] | (this[offset + 1] << 8)
	  return (val & 0x8000) ? val | 0xFFFF0000 : val
	}
	
	Buffer.prototype.readInt16BE = function readInt16BE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 2, this.length)
	  var val = this[offset + 1] | (this[offset] << 8)
	  return (val & 0x8000) ? val | 0xFFFF0000 : val
	}
	
	Buffer.prototype.readInt32LE = function readInt32LE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 4, this.length)
	
	  return (this[offset]) |
	    (this[offset + 1] << 8) |
	    (this[offset + 2] << 16) |
	    (this[offset + 3] << 24)
	}
	
	Buffer.prototype.readInt32BE = function readInt32BE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 4, this.length)
	
	  return (this[offset] << 24) |
	    (this[offset + 1] << 16) |
	    (this[offset + 2] << 8) |
	    (this[offset + 3])
	}
	
	Buffer.prototype.readFloatLE = function readFloatLE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 4, this.length)
	  return ieee754.read(this, offset, true, 23, 4)
	}
	
	Buffer.prototype.readFloatBE = function readFloatBE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 4, this.length)
	  return ieee754.read(this, offset, false, 23, 4)
	}
	
	Buffer.prototype.readDoubleLE = function readDoubleLE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 8, this.length)
	  return ieee754.read(this, offset, true, 52, 8)
	}
	
	Buffer.prototype.readDoubleBE = function readDoubleBE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 8, this.length)
	  return ieee754.read(this, offset, false, 52, 8)
	}
	
	function checkInt (buf, value, offset, ext, max, min) {
	  if (!Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance')
	  if (value > max || value < min) throw new RangeError('"value" argument is out of bounds')
	  if (offset + ext > buf.length) throw new RangeError('Index out of range')
	}
	
	Buffer.prototype.writeUIntLE = function writeUIntLE (value, offset, byteLength, noAssert) {
	  value = +value
	  offset = offset | 0
	  byteLength = byteLength | 0
	  if (!noAssert) {
	    var maxBytes = Math.pow(2, 8 * byteLength) - 1
	    checkInt(this, value, offset, byteLength, maxBytes, 0)
	  }
	
	  var mul = 1
	  var i = 0
	  this[offset] = value & 0xFF
	  while (++i < byteLength && (mul *= 0x100)) {
	    this[offset + i] = (value / mul) & 0xFF
	  }
	
	  return offset + byteLength
	}
	
	Buffer.prototype.writeUIntBE = function writeUIntBE (value, offset, byteLength, noAssert) {
	  value = +value
	  offset = offset | 0
	  byteLength = byteLength | 0
	  if (!noAssert) {
	    var maxBytes = Math.pow(2, 8 * byteLength) - 1
	    checkInt(this, value, offset, byteLength, maxBytes, 0)
	  }
	
	  var i = byteLength - 1
	  var mul = 1
	  this[offset + i] = value & 0xFF
	  while (--i >= 0 && (mul *= 0x100)) {
	    this[offset + i] = (value / mul) & 0xFF
	  }
	
	  return offset + byteLength
	}
	
	Buffer.prototype.writeUInt8 = function writeUInt8 (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 1, 0xff, 0)
	  if (!Buffer.TYPED_ARRAY_SUPPORT) value = Math.floor(value)
	  this[offset] = (value & 0xff)
	  return offset + 1
	}
	
	function objectWriteUInt16 (buf, value, offset, littleEndian) {
	  if (value < 0) value = 0xffff + value + 1
	  for (var i = 0, j = Math.min(buf.length - offset, 2); i < j; ++i) {
	    buf[offset + i] = (value & (0xff << (8 * (littleEndian ? i : 1 - i)))) >>>
	      (littleEndian ? i : 1 - i) * 8
	  }
	}
	
	Buffer.prototype.writeUInt16LE = function writeUInt16LE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value & 0xff)
	    this[offset + 1] = (value >>> 8)
	  } else {
	    objectWriteUInt16(this, value, offset, true)
	  }
	  return offset + 2
	}
	
	Buffer.prototype.writeUInt16BE = function writeUInt16BE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value >>> 8)
	    this[offset + 1] = (value & 0xff)
	  } else {
	    objectWriteUInt16(this, value, offset, false)
	  }
	  return offset + 2
	}
	
	function objectWriteUInt32 (buf, value, offset, littleEndian) {
	  if (value < 0) value = 0xffffffff + value + 1
	  for (var i = 0, j = Math.min(buf.length - offset, 4); i < j; ++i) {
	    buf[offset + i] = (value >>> (littleEndian ? i : 3 - i) * 8) & 0xff
	  }
	}
	
	Buffer.prototype.writeUInt32LE = function writeUInt32LE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset + 3] = (value >>> 24)
	    this[offset + 2] = (value >>> 16)
	    this[offset + 1] = (value >>> 8)
	    this[offset] = (value & 0xff)
	  } else {
	    objectWriteUInt32(this, value, offset, true)
	  }
	  return offset + 4
	}
	
	Buffer.prototype.writeUInt32BE = function writeUInt32BE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value >>> 24)
	    this[offset + 1] = (value >>> 16)
	    this[offset + 2] = (value >>> 8)
	    this[offset + 3] = (value & 0xff)
	  } else {
	    objectWriteUInt32(this, value, offset, false)
	  }
	  return offset + 4
	}
	
	Buffer.prototype.writeIntLE = function writeIntLE (value, offset, byteLength, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) {
	    var limit = Math.pow(2, 8 * byteLength - 1)
	
	    checkInt(this, value, offset, byteLength, limit - 1, -limit)
	  }
	
	  var i = 0
	  var mul = 1
	  var sub = 0
	  this[offset] = value & 0xFF
	  while (++i < byteLength && (mul *= 0x100)) {
	    if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) {
	      sub = 1
	    }
	    this[offset + i] = ((value / mul) >> 0) - sub & 0xFF
	  }
	
	  return offset + byteLength
	}
	
	Buffer.prototype.writeIntBE = function writeIntBE (value, offset, byteLength, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) {
	    var limit = Math.pow(2, 8 * byteLength - 1)
	
	    checkInt(this, value, offset, byteLength, limit - 1, -limit)
	  }
	
	  var i = byteLength - 1
	  var mul = 1
	  var sub = 0
	  this[offset + i] = value & 0xFF
	  while (--i >= 0 && (mul *= 0x100)) {
	    if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) {
	      sub = 1
	    }
	    this[offset + i] = ((value / mul) >> 0) - sub & 0xFF
	  }
	
	  return offset + byteLength
	}
	
	Buffer.prototype.writeInt8 = function writeInt8 (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 1, 0x7f, -0x80)
	  if (!Buffer.TYPED_ARRAY_SUPPORT) value = Math.floor(value)
	  if (value < 0) value = 0xff + value + 1
	  this[offset] = (value & 0xff)
	  return offset + 1
	}
	
	Buffer.prototype.writeInt16LE = function writeInt16LE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value & 0xff)
	    this[offset + 1] = (value >>> 8)
	  } else {
	    objectWriteUInt16(this, value, offset, true)
	  }
	  return offset + 2
	}
	
	Buffer.prototype.writeInt16BE = function writeInt16BE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value >>> 8)
	    this[offset + 1] = (value & 0xff)
	  } else {
	    objectWriteUInt16(this, value, offset, false)
	  }
	  return offset + 2
	}
	
	Buffer.prototype.writeInt32LE = function writeInt32LE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value & 0xff)
	    this[offset + 1] = (value >>> 8)
	    this[offset + 2] = (value >>> 16)
	    this[offset + 3] = (value >>> 24)
	  } else {
	    objectWriteUInt32(this, value, offset, true)
	  }
	  return offset + 4
	}
	
	Buffer.prototype.writeInt32BE = function writeInt32BE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000)
	  if (value < 0) value = 0xffffffff + value + 1
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value >>> 24)
	    this[offset + 1] = (value >>> 16)
	    this[offset + 2] = (value >>> 8)
	    this[offset + 3] = (value & 0xff)
	  } else {
	    objectWriteUInt32(this, value, offset, false)
	  }
	  return offset + 4
	}
	
	function checkIEEE754 (buf, value, offset, ext, max, min) {
	  if (offset + ext > buf.length) throw new RangeError('Index out of range')
	  if (offset < 0) throw new RangeError('Index out of range')
	}
	
	function writeFloat (buf, value, offset, littleEndian, noAssert) {
	  if (!noAssert) {
	    checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -3.4028234663852886e+38)
	  }
	  ieee754.write(buf, value, offset, littleEndian, 23, 4)
	  return offset + 4
	}
	
	Buffer.prototype.writeFloatLE = function writeFloatLE (value, offset, noAssert) {
	  return writeFloat(this, value, offset, true, noAssert)
	}
	
	Buffer.prototype.writeFloatBE = function writeFloatBE (value, offset, noAssert) {
	  return writeFloat(this, value, offset, false, noAssert)
	}
	
	function writeDouble (buf, value, offset, littleEndian, noAssert) {
	  if (!noAssert) {
	    checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -1.7976931348623157E+308)
	  }
	  ieee754.write(buf, value, offset, littleEndian, 52, 8)
	  return offset + 8
	}
	
	Buffer.prototype.writeDoubleLE = function writeDoubleLE (value, offset, noAssert) {
	  return writeDouble(this, value, offset, true, noAssert)
	}
	
	Buffer.prototype.writeDoubleBE = function writeDoubleBE (value, offset, noAssert) {
	  return writeDouble(this, value, offset, false, noAssert)
	}
	
	// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
	Buffer.prototype.copy = function copy (target, targetStart, start, end) {
	  if (!start) start = 0
	  if (!end && end !== 0) end = this.length
	  if (targetStart >= target.length) targetStart = target.length
	  if (!targetStart) targetStart = 0
	  if (end > 0 && end < start) end = start
	
	  // Copy 0 bytes; we're done
	  if (end === start) return 0
	  if (target.length === 0 || this.length === 0) return 0
	
	  // Fatal error conditions
	  if (targetStart < 0) {
	    throw new RangeError('targetStart out of bounds')
	  }
	  if (start < 0 || start >= this.length) throw new RangeError('sourceStart out of bounds')
	  if (end < 0) throw new RangeError('sourceEnd out of bounds')
	
	  // Are we oob?
	  if (end > this.length) end = this.length
	  if (target.length - targetStart < end - start) {
	    end = target.length - targetStart + start
	  }
	
	  var len = end - start
	  var i
	
	  if (this === target && start < targetStart && targetStart < end) {
	    // descending copy from end
	    for (i = len - 1; i >= 0; --i) {
	      target[i + targetStart] = this[i + start]
	    }
	  } else if (len < 1000 || !Buffer.TYPED_ARRAY_SUPPORT) {
	    // ascending copy from start
	    for (i = 0; i < len; ++i) {
	      target[i + targetStart] = this[i + start]
	    }
	  } else {
	    Uint8Array.prototype.set.call(
	      target,
	      this.subarray(start, start + len),
	      targetStart
	    )
	  }
	
	  return len
	}
	
	// Usage:
	//    buffer.fill(number[, offset[, end]])
	//    buffer.fill(buffer[, offset[, end]])
	//    buffer.fill(string[, offset[, end]][, encoding])
	Buffer.prototype.fill = function fill (val, start, end, encoding) {
	  // Handle string cases:
	  if (typeof val === 'string') {
	    if (typeof start === 'string') {
	      encoding = start
	      start = 0
	      end = this.length
	    } else if (typeof end === 'string') {
	      encoding = end
	      end = this.length
	    }
	    if (val.length === 1) {
	      var code = val.charCodeAt(0)
	      if (code < 256) {
	        val = code
	      }
	    }
	    if (encoding !== undefined && typeof encoding !== 'string') {
	      throw new TypeError('encoding must be a string')
	    }
	    if (typeof encoding === 'string' && !Buffer.isEncoding(encoding)) {
	      throw new TypeError('Unknown encoding: ' + encoding)
	    }
	  } else if (typeof val === 'number') {
	    val = val & 255
	  }
	
	  // Invalid ranges are not set to a default, so can range check early.
	  if (start < 0 || this.length < start || this.length < end) {
	    throw new RangeError('Out of range index')
	  }
	
	  if (end <= start) {
	    return this
	  }
	
	  start = start >>> 0
	  end = end === undefined ? this.length : end >>> 0
	
	  if (!val) val = 0
	
	  var i
	  if (typeof val === 'number') {
	    for (i = start; i < end; ++i) {
	      this[i] = val
	    }
	  } else {
	    var bytes = Buffer.isBuffer(val)
	      ? val
	      : utf8ToBytes(new Buffer(val, encoding).toString())
	    var len = bytes.length
	    for (i = 0; i < end - start; ++i) {
	      this[i + start] = bytes[i % len]
	    }
	  }
	
	  return this
	}
	
	// HELPER FUNCTIONS
	// ================
	
	var INVALID_BASE64_RE = /[^+\/0-9A-Za-z-_]/g
	
	function base64clean (str) {
	  // Node strips out invalid characters like \n and \t from the string, base64-js does not
	  str = stringtrim(str).replace(INVALID_BASE64_RE, '')
	  // Node converts strings with length < 2 to ''
	  if (str.length < 2) return ''
	  // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
	  while (str.length % 4 !== 0) {
	    str = str + '='
	  }
	  return str
	}
	
	function stringtrim (str) {
	  if (str.trim) return str.trim()
	  return str.replace(/^\s+|\s+$/g, '')
	}
	
	function toHex (n) {
	  if (n < 16) return '0' + n.toString(16)
	  return n.toString(16)
	}
	
	function utf8ToBytes (string, units) {
	  units = units || Infinity
	  var codePoint
	  var length = string.length
	  var leadSurrogate = null
	  var bytes = []
	
	  for (var i = 0; i < length; ++i) {
	    codePoint = string.charCodeAt(i)
	
	    // is surrogate component
	    if (codePoint > 0xD7FF && codePoint < 0xE000) {
	      // last char was a lead
	      if (!leadSurrogate) {
	        // no lead yet
	        if (codePoint > 0xDBFF) {
	          // unexpected trail
	          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
	          continue
	        } else if (i + 1 === length) {
	          // unpaired lead
	          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
	          continue
	        }
	
	        // valid lead
	        leadSurrogate = codePoint
	
	        continue
	      }
	
	      // 2 leads in a row
	      if (codePoint < 0xDC00) {
	        if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
	        leadSurrogate = codePoint
	        continue
	      }
	
	      // valid surrogate pair
	      codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000
	    } else if (leadSurrogate) {
	      // valid bmp char, but last char was a lead
	      if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
	    }
	
	    leadSurrogate = null
	
	    // encode utf8
	    if (codePoint < 0x80) {
	      if ((units -= 1) < 0) break
	      bytes.push(codePoint)
	    } else if (codePoint < 0x800) {
	      if ((units -= 2) < 0) break
	      bytes.push(
	        codePoint >> 0x6 | 0xC0,
	        codePoint & 0x3F | 0x80
	      )
	    } else if (codePoint < 0x10000) {
	      if ((units -= 3) < 0) break
	      bytes.push(
	        codePoint >> 0xC | 0xE0,
	        codePoint >> 0x6 & 0x3F | 0x80,
	        codePoint & 0x3F | 0x80
	      )
	    } else if (codePoint < 0x110000) {
	      if ((units -= 4) < 0) break
	      bytes.push(
	        codePoint >> 0x12 | 0xF0,
	        codePoint >> 0xC & 0x3F | 0x80,
	        codePoint >> 0x6 & 0x3F | 0x80,
	        codePoint & 0x3F | 0x80
	      )
	    } else {
	      throw new Error('Invalid code point')
	    }
	  }
	
	  return bytes
	}
	
	function asciiToBytes (str) {
	  var byteArray = []
	  for (var i = 0; i < str.length; ++i) {
	    // Node's code seems to be doing this and not & 0x7F..
	    byteArray.push(str.charCodeAt(i) & 0xFF)
	  }
	  return byteArray
	}
	
	function utf16leToBytes (str, units) {
	  var c, hi, lo
	  var byteArray = []
	  for (var i = 0; i < str.length; ++i) {
	    if ((units -= 2) < 0) break
	
	    c = str.charCodeAt(i)
	    hi = c >> 8
	    lo = c % 256
	    byteArray.push(lo)
	    byteArray.push(hi)
	  }
	
	  return byteArray
	}
	
	function base64ToBytes (str) {
	  return base64.toByteArray(base64clean(str))
	}
	
	function blitBuffer (src, dst, offset, length) {
	  for (var i = 0; i < length; ++i) {
	    if ((i + offset >= dst.length) || (i >= src.length)) break
	    dst[i + offset] = src[i]
	  }
	  return i
	}
	
	function isnan (val) {
	  return val !== val // eslint-disable-line no-self-compare
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(290).Buffer, (function() { return this; }())))

/***/ },
/* 291 */
/***/ function(module, exports, __webpack_require__) {

	var cof = __webpack_require__(69);
	module.exports = function (it, msg) {
	  if (typeof it != 'number' && cof(it) != 'Number') throw TypeError(msg);
	  return +it;
	};


/***/ },
/* 292 */
/***/ function(module, exports, __webpack_require__) {

	// 22.1.3.3 Array.prototype.copyWithin(target, start, end = this.length)
	'use strict';
	var toObject = __webpack_require__(43);
	var toAbsoluteIndex = __webpack_require__(110);
	var toLength = __webpack_require__(40);
	
	module.exports = [].copyWithin || function copyWithin(target /* = 0 */, start /* = 0, end = @length */) {
	  var O = toObject(this);
	  var len = toLength(O.length);
	  var to = toAbsoluteIndex(target, len);
	  var from = toAbsoluteIndex(start, len);
	  var end = arguments.length > 2 ? arguments[2] : undefined;
	  var count = Math.min((end === undefined ? len : toAbsoluteIndex(end, len)) - from, len - to);
	  var inc = 1;
	  if (from < to && to < from + count) {
	    inc = -1;
	    from += count - 1;
	    to += count - 1;
	  }
	  while (count-- > 0) {
	    if (from in O) O[to] = O[from];
	    else delete O[to];
	    to += inc;
	    from += inc;
	  } return O;
	};


/***/ },
/* 293 */
/***/ function(module, exports, __webpack_require__) {

	var forOf = __webpack_require__(103);
	
	module.exports = function (iter, ITERATOR) {
	  var result = [];
	  forOf(iter, false, result.push, result, ITERATOR);
	  return result;
	};


/***/ },
/* 294 */
/***/ function(module, exports, __webpack_require__) {

	var aFunction = __webpack_require__(50);
	var toObject = __webpack_require__(43);
	var IObject = __webpack_require__(139);
	var toLength = __webpack_require__(40);
	
	module.exports = function (that, callbackfn, aLen, memo, isRight) {
	  aFunction(callbackfn);
	  var O = toObject(that);
	  var self = IObject(O);
	  var length = toLength(O.length);
	  var index = isRight ? length - 1 : 0;
	  var i = isRight ? -1 : 1;
	  if (aLen < 2) for (;;) {
	    if (index in self) {
	      memo = self[index];
	      index += i;
	      break;
	    }
	    index += i;
	    if (isRight ? index < 0 : length <= index) {
	      throw TypeError('Reduce of empty array with no initial value');
	    }
	  }
	  for (;isRight ? index >= 0 : length > index; index += i) if (index in self) {
	    memo = callbackfn(memo, self[index], index, O);
	  }
	  return memo;
	};


/***/ },
/* 295 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var aFunction = __webpack_require__(50);
	var isObject = __webpack_require__(27);
	var invoke = __webpack_require__(301);
	var arraySlice = [].slice;
	var factories = {};
	
	var construct = function (F, len, args) {
	  if (!(len in factories)) {
	    for (var n = [], i = 0; i < len; i++) n[i] = 'a[' + i + ']';
	    // eslint-disable-next-line no-new-func
	    factories[len] = Function('F,a', 'return new F(' + n.join(',') + ')');
	  } return factories[len](F, args);
	};
	
	module.exports = Function.bind || function bind(that /* , ...args */) {
	  var fn = aFunction(this);
	  var partArgs = arraySlice.call(arguments, 1);
	  var bound = function (/* args... */) {
	    var args = partArgs.concat(arraySlice.call(arguments));
	    return this instanceof bound ? construct(fn, args.length, args) : invoke(fn, args, that);
	  };
	  if (isObject(fn.prototype)) bound.prototype = fn.prototype;
	  return bound;
	};


/***/ },
/* 296 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var dP = __webpack_require__(39).f;
	var create = __webpack_require__(104);
	var redefineAll = __webpack_require__(108);
	var ctx = __webpack_require__(71);
	var anInstance = __webpack_require__(102);
	var forOf = __webpack_require__(103);
	var $iterDefine = __webpack_require__(215);
	var step = __webpack_require__(304);
	var setSpecies = __webpack_require__(109);
	var DESCRIPTORS = __webpack_require__(38);
	var fastKey = __webpack_require__(97).fastKey;
	var validate = __webpack_require__(119);
	var SIZE = DESCRIPTORS ? '_s' : 'size';
	
	var getEntry = function (that, key) {
	  // fast case
	  var index = fastKey(key);
	  var entry;
	  if (index !== 'F') return that._i[index];
	  // frozen object case
	  for (entry = that._f; entry; entry = entry.n) {
	    if (entry.k == key) return entry;
	  }
	};
	
	module.exports = {
	  getConstructor: function (wrapper, NAME, IS_MAP, ADDER) {
	    var C = wrapper(function (that, iterable) {
	      anInstance(that, C, NAME, '_i');
	      that._t = NAME;         // collection type
	      that._i = create(null); // index
	      that._f = undefined;    // first entry
	      that._l = undefined;    // last entry
	      that[SIZE] = 0;         // size
	      if (iterable != undefined) forOf(iterable, IS_MAP, that[ADDER], that);
	    });
	    redefineAll(C.prototype, {
	      // 23.1.3.1 Map.prototype.clear()
	      // 23.2.3.2 Set.prototype.clear()
	      clear: function clear() {
	        for (var that = validate(this, NAME), data = that._i, entry = that._f; entry; entry = entry.n) {
	          entry.r = true;
	          if (entry.p) entry.p = entry.p.n = undefined;
	          delete data[entry.i];
	        }
	        that._f = that._l = undefined;
	        that[SIZE] = 0;
	      },
	      // 23.1.3.3 Map.prototype.delete(key)
	      // 23.2.3.4 Set.prototype.delete(value)
	      'delete': function (key) {
	        var that = validate(this, NAME);
	        var entry = getEntry(that, key);
	        if (entry) {
	          var next = entry.n;
	          var prev = entry.p;
	          delete that._i[entry.i];
	          entry.r = true;
	          if (prev) prev.n = next;
	          if (next) next.p = prev;
	          if (that._f == entry) that._f = next;
	          if (that._l == entry) that._l = prev;
	          that[SIZE]--;
	        } return !!entry;
	      },
	      // 23.2.3.6 Set.prototype.forEach(callbackfn, thisArg = undefined)
	      // 23.1.3.5 Map.prototype.forEach(callbackfn, thisArg = undefined)
	      forEach: function forEach(callbackfn /* , that = undefined */) {
	        validate(this, NAME);
	        var f = ctx(callbackfn, arguments.length > 1 ? arguments[1] : undefined, 3);
	        var entry;
	        while (entry = entry ? entry.n : this._f) {
	          f(entry.v, entry.k, this);
	          // revert to the last existing entry
	          while (entry && entry.r) entry = entry.p;
	        }
	      },
	      // 23.1.3.7 Map.prototype.has(key)
	      // 23.2.3.7 Set.prototype.has(value)
	      has: function has(key) {
	        return !!getEntry(validate(this, NAME), key);
	      }
	    });
	    if (DESCRIPTORS) dP(C.prototype, 'size', {
	      get: function () {
	        return validate(this, NAME)[SIZE];
	      }
	    });
	    return C;
	  },
	  def: function (that, key, value) {
	    var entry = getEntry(that, key);
	    var prev, index;
	    // change existing entry
	    if (entry) {
	      entry.v = value;
	    // create new entry
	    } else {
	      that._l = entry = {
	        i: index = fastKey(key, true), // <- index
	        k: key,                        // <- key
	        v: value,                      // <- value
	        p: prev = that._l,             // <- previous entry
	        n: undefined,                  // <- next entry
	        r: false                       // <- removed
	      };
	      if (!that._f) that._f = entry;
	      if (prev) prev.n = entry;
	      that[SIZE]++;
	      // add to index
	      if (index !== 'F') that._i[index] = entry;
	    } return that;
	  },
	  getEntry: getEntry,
	  setStrong: function (C, NAME, IS_MAP) {
	    // add .keys, .values, .entries, [@@iterator]
	    // 23.1.3.4, 23.1.3.8, 23.1.3.11, 23.1.3.12, 23.2.3.5, 23.2.3.8, 23.2.3.10, 23.2.3.11
	    $iterDefine(C, NAME, function (iterated, kind) {
	      this._t = validate(iterated, NAME); // target
	      this._k = kind;                     // kind
	      this._l = undefined;                // previous
	    }, function () {
	      var that = this;
	      var kind = that._k;
	      var entry = that._l;
	      // revert to the last existing entry
	      while (entry && entry.r) entry = entry.p;
	      // get next entry
	      if (!that._t || !(that._l = entry = entry ? entry.n : that._t._f)) {
	        // or finish the iteration
	        that._t = undefined;
	        return step(1);
	      }
	      // return step by kind
	      if (kind == 'keys') return step(0, entry.k);
	      if (kind == 'values') return step(0, entry.v);
	      return step(0, [entry.k, entry.v]);
	    }, IS_MAP ? 'entries' : 'values', !IS_MAP, true);
	
	    // add [@@species], 23.1.2.2, 23.2.2.2
	    setSpecies(NAME);
	  }
	};


/***/ },
/* 297 */
/***/ function(module, exports, __webpack_require__) {

	// https://github.com/DavidBruant/Map-Set.prototype.toJSON
	var classof = __webpack_require__(138);
	var from = __webpack_require__(293);
	module.exports = function (NAME) {
	  return function toJSON() {
	    if (classof(this) != NAME) throw TypeError(NAME + "#toJSON isn't generic");
	    return from(this);
	  };
	};


/***/ },
/* 298 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var redefineAll = __webpack_require__(108);
	var getWeak = __webpack_require__(97).getWeak;
	var anObject = __webpack_require__(23);
	var isObject = __webpack_require__(27);
	var anInstance = __webpack_require__(102);
	var forOf = __webpack_require__(103);
	var createArrayMethod = __webpack_require__(75);
	var $has = __webpack_require__(58);
	var validate = __webpack_require__(119);
	var arrayFind = createArrayMethod(5);
	var arrayFindIndex = createArrayMethod(6);
	var id = 0;
	
	// fallback for uncaught frozen keys
	var uncaughtFrozenStore = function (that) {
	  return that._l || (that._l = new UncaughtFrozenStore());
	};
	var UncaughtFrozenStore = function () {
	  this.a = [];
	};
	var findUncaughtFrozen = function (store, key) {
	  return arrayFind(store.a, function (it) {
	    return it[0] === key;
	  });
	};
	UncaughtFrozenStore.prototype = {
	  get: function (key) {
	    var entry = findUncaughtFrozen(this, key);
	    if (entry) return entry[1];
	  },
	  has: function (key) {
	    return !!findUncaughtFrozen(this, key);
	  },
	  set: function (key, value) {
	    var entry = findUncaughtFrozen(this, key);
	    if (entry) entry[1] = value;
	    else this.a.push([key, value]);
	  },
	  'delete': function (key) {
	    var index = arrayFindIndex(this.a, function (it) {
	      return it[0] === key;
	    });
	    if (~index) this.a.splice(index, 1);
	    return !!~index;
	  }
	};
	
	module.exports = {
	  getConstructor: function (wrapper, NAME, IS_MAP, ADDER) {
	    var C = wrapper(function (that, iterable) {
	      anInstance(that, C, NAME, '_i');
	      that._t = NAME;      // collection type
	      that._i = id++;      // collection id
	      that._l = undefined; // leak store for uncaught frozen objects
	      if (iterable != undefined) forOf(iterable, IS_MAP, that[ADDER], that);
	    });
	    redefineAll(C.prototype, {
	      // 23.3.3.2 WeakMap.prototype.delete(key)
	      // 23.4.3.3 WeakSet.prototype.delete(value)
	      'delete': function (key) {
	        if (!isObject(key)) return false;
	        var data = getWeak(key);
	        if (data === true) return uncaughtFrozenStore(validate(this, NAME))['delete'](key);
	        return data && $has(data, this._i) && delete data[this._i];
	      },
	      // 23.3.3.4 WeakMap.prototype.has(key)
	      // 23.4.3.4 WeakSet.prototype.has(value)
	      has: function has(key) {
	        if (!isObject(key)) return false;
	        var data = getWeak(key);
	        if (data === true) return uncaughtFrozenStore(validate(this, NAME)).has(key);
	        return data && $has(data, this._i);
	      }
	    });
	    return C;
	  },
	  def: function (that, key, value) {
	    var data = getWeak(anObject(key), true);
	    if (data === true) uncaughtFrozenStore(that).set(key, value);
	    else data[that._i] = value;
	    return that;
	  },
	  ufstore: uncaughtFrozenStore
	};


/***/ },
/* 299 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// https://tc39.github.io/proposal-flatMap/#sec-FlattenIntoArray
	var isArray = __webpack_require__(158);
	var isObject = __webpack_require__(27);
	var toLength = __webpack_require__(40);
	var ctx = __webpack_require__(71);
	var IS_CONCAT_SPREADABLE = __webpack_require__(34)('isConcatSpreadable');
	
	function flattenIntoArray(target, original, source, sourceLen, start, depth, mapper, thisArg) {
	  var targetIndex = start;
	  var sourceIndex = 0;
	  var mapFn = mapper ? ctx(mapper, thisArg, 3) : false;
	  var element, spreadable;
	
	  while (sourceIndex < sourceLen) {
	    if (sourceIndex in source) {
	      element = mapFn ? mapFn(source[sourceIndex], sourceIndex, original) : source[sourceIndex];
	
	      spreadable = false;
	      if (isObject(element)) {
	        spreadable = element[IS_CONCAT_SPREADABLE];
	        spreadable = spreadable !== undefined ? !!spreadable : isArray(element);
	      }
	
	      if (spreadable && depth > 0) {
	        targetIndex = flattenIntoArray(target, original, element, toLength(element.length), targetIndex, depth - 1) - 1;
	      } else {
	        if (targetIndex >= 0x1fffffffffffff) throw TypeError();
	        target[targetIndex] = element;
	      }
	
	      targetIndex++;
	    }
	    sourceIndex++;
	  }
	  return targetIndex;
	}
	
	module.exports = flattenIntoArray;


/***/ },
/* 300 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = !__webpack_require__(38) && !__webpack_require__(26)(function () {
	  return Object.defineProperty(__webpack_require__(208)('div'), 'a', { get: function () { return 7; } }).a != 7;
	});


/***/ },
/* 301 */
/***/ function(module, exports) {

	// fast apply, http://jsperf.lnkit.com/fast-apply/5
	module.exports = function (fn, args, that) {
	  var un = that === undefined;
	  switch (args.length) {
	    case 0: return un ? fn()
	                      : fn.call(that);
	    case 1: return un ? fn(args[0])
	                      : fn.call(that, args[0]);
	    case 2: return un ? fn(args[0], args[1])
	                      : fn.call(that, args[0], args[1]);
	    case 3: return un ? fn(args[0], args[1], args[2])
	                      : fn.call(that, args[0], args[1], args[2]);
	    case 4: return un ? fn(args[0], args[1], args[2], args[3])
	                      : fn.call(that, args[0], args[1], args[2], args[3]);
	  } return fn.apply(that, args);
	};


/***/ },
/* 302 */
/***/ function(module, exports, __webpack_require__) {

	// 20.1.2.3 Number.isInteger(number)
	var isObject = __webpack_require__(27);
	var floor = Math.floor;
	module.exports = function isInteger(it) {
	  return !isObject(it) && isFinite(it) && floor(it) === it;
	};


/***/ },
/* 303 */
/***/ function(module, exports, __webpack_require__) {

	// call something on iterator step with safe closing on error
	var anObject = __webpack_require__(23);
	module.exports = function (iterator, fn, value, entries) {
	  try {
	    return entries ? fn(anObject(value)[0], value[1]) : fn(value);
	  // 7.4.6 IteratorClose(iterator, completion)
	  } catch (e) {
	    var ret = iterator['return'];
	    if (ret !== undefined) anObject(ret.call(iterator));
	    throw e;
	  }
	};


/***/ },
/* 304 */
/***/ function(module, exports) {

	module.exports = function (done, value) {
	  return { value: value, done: !!done };
	};


/***/ },
/* 305 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.16 Math.fround(x)
	var sign = __webpack_require__(217);
	var pow = Math.pow;
	var EPSILON = pow(2, -52);
	var EPSILON32 = pow(2, -23);
	var MAX32 = pow(2, 127) * (2 - EPSILON32);
	var MIN32 = pow(2, -126);
	
	var roundTiesToEven = function (n) {
	  return n + 1 / EPSILON - 1 / EPSILON;
	};
	
	module.exports = Math.fround || function fround(x) {
	  var $abs = Math.abs(x);
	  var $sign = sign(x);
	  var a, result;
	  if ($abs < MIN32) return $sign * roundTiesToEven($abs / MIN32 / EPSILON32) * MIN32 * EPSILON32;
	  a = (1 + EPSILON32 / EPSILON) * $abs;
	  result = a - (a - $abs);
	  // eslint-disable-next-line no-self-compare
	  if (result > MAX32 || result != result) return $sign * Infinity;
	  return $sign * result;
	};


/***/ },
/* 306 */
/***/ function(module, exports) {

	// 20.2.2.20 Math.log1p(x)
	module.exports = Math.log1p || function log1p(x) {
	  return (x = +x) > -1e-8 && x < 1e-8 ? x - x * x / 2 : Math.log(1 + x);
	};


/***/ },
/* 307 */
/***/ function(module, exports) {

	// https://rwaldron.github.io/proposal-math-extensions/
	module.exports = Math.scale || function scale(x, inLow, inHigh, outLow, outHigh) {
	  if (
	    arguments.length === 0
	      // eslint-disable-next-line no-self-compare
	      || x != x
	      // eslint-disable-next-line no-self-compare
	      || inLow != inLow
	      // eslint-disable-next-line no-self-compare
	      || inHigh != inHigh
	      // eslint-disable-next-line no-self-compare
	      || outLow != outLow
	      // eslint-disable-next-line no-self-compare
	      || outHigh != outHigh
	  ) return NaN;
	  if (x === Infinity || x === -Infinity) return x;
	  return (x - inLow) * (outHigh - outLow) / (inHigh - inLow) + outLow;
	};


/***/ },
/* 308 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// 19.1.2.1 Object.assign(target, source, ...)
	var getKeys = __webpack_require__(106);
	var gOPS = __webpack_require__(162);
	var pIE = __webpack_require__(140);
	var toObject = __webpack_require__(43);
	var IObject = __webpack_require__(139);
	var $assign = Object.assign;
	
	// should work with symbols and should have deterministic property order (V8 bug)
	module.exports = !$assign || __webpack_require__(26)(function () {
	  var A = {};
	  var B = {};
	  // eslint-disable-next-line no-undef
	  var S = Symbol();
	  var K = 'abcdefghijklmnopqrst';
	  A[S] = 7;
	  K.split('').forEach(function (k) { B[k] = k; });
	  return $assign({}, A)[S] != 7 || Object.keys($assign({}, B)).join('') != K;
	}) ? function assign(target, source) { // eslint-disable-line no-unused-vars
	  var T = toObject(target);
	  var aLen = arguments.length;
	  var index = 1;
	  var getSymbols = gOPS.f;
	  var isEnum = pIE.f;
	  while (aLen > index) {
	    var S = IObject(arguments[index++]);
	    var keys = getSymbols ? getKeys(S).concat(getSymbols(S)) : getKeys(S);
	    var length = keys.length;
	    var j = 0;
	    var key;
	    while (length > j) if (isEnum.call(S, key = keys[j++])) T[key] = S[key];
	  } return T;
	} : $assign;


/***/ },
/* 309 */
/***/ function(module, exports, __webpack_require__) {

	var dP = __webpack_require__(39);
	var anObject = __webpack_require__(23);
	var getKeys = __webpack_require__(106);
	
	module.exports = __webpack_require__(38) ? Object.defineProperties : function defineProperties(O, Properties) {
	  anObject(O);
	  var keys = getKeys(Properties);
	  var length = keys.length;
	  var i = 0;
	  var P;
	  while (length > i) dP.f(O, P = keys[i++], Properties[P]);
	  return O;
	};


/***/ },
/* 310 */
/***/ function(module, exports, __webpack_require__) {

	// fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window
	var toIObject = __webpack_require__(61);
	var gOPN = __webpack_require__(105).f;
	var toString = {}.toString;
	
	var windowNames = typeof window == 'object' && window && Object.getOwnPropertyNames
	  ? Object.getOwnPropertyNames(window) : [];
	
	var getWindowNames = function (it) {
	  try {
	    return gOPN(it);
	  } catch (e) {
	    return windowNames.slice();
	  }
	};
	
	module.exports.f = function getOwnPropertyNames(it) {
	  return windowNames && toString.call(it) == '[object Window]' ? getWindowNames(it) : gOPN(toIObject(it));
	};


/***/ },
/* 311 */
/***/ function(module, exports, __webpack_require__) {

	var has = __webpack_require__(58);
	var toIObject = __webpack_require__(61);
	var arrayIndexOf = __webpack_require__(154)(false);
	var IE_PROTO = __webpack_require__(221)('IE_PROTO');
	
	module.exports = function (object, names) {
	  var O = toIObject(object);
	  var i = 0;
	  var result = [];
	  var key;
	  for (key in O) if (key != IE_PROTO) has(O, key) && result.push(key);
	  // Don't enum bug & hidden keys
	  while (names.length > i) if (has(O, key = names[i++])) {
	    ~arrayIndexOf(result, key) || result.push(key);
	  }
	  return result;
	};


/***/ },
/* 312 */
/***/ function(module, exports, __webpack_require__) {

	var getKeys = __webpack_require__(106);
	var toIObject = __webpack_require__(61);
	var isEnum = __webpack_require__(140).f;
	module.exports = function (isEntries) {
	  return function (it) {
	    var O = toIObject(it);
	    var keys = getKeys(O);
	    var length = keys.length;
	    var i = 0;
	    var result = [];
	    var key;
	    while (length > i) if (isEnum.call(O, key = keys[i++])) {
	      result.push(isEntries ? [key, O[key]] : O[key]);
	    } return result;
	  };
	};


/***/ },
/* 313 */
/***/ function(module, exports, __webpack_require__) {

	// all object keys, includes non-enumerable and symbols
	var gOPN = __webpack_require__(105);
	var gOPS = __webpack_require__(162);
	var anObject = __webpack_require__(23);
	var Reflect = __webpack_require__(24).Reflect;
	module.exports = Reflect && Reflect.ownKeys || function ownKeys(it) {
	  var keys = gOPN.f(anObject(it));
	  var getSymbols = gOPS.f;
	  return getSymbols ? keys.concat(getSymbols(it)) : keys;
	};


/***/ },
/* 314 */
/***/ function(module, exports, __webpack_require__) {

	var $parseFloat = __webpack_require__(24).parseFloat;
	var $trim = __webpack_require__(118).trim;
	
	module.exports = 1 / $parseFloat(__webpack_require__(225) + '-0') !== -Infinity ? function parseFloat(str) {
	  var string = $trim(String(str), 3);
	  var result = $parseFloat(string);
	  return result === 0 && string.charAt(0) == '-' ? -0 : result;
	} : $parseFloat;


/***/ },
/* 315 */
/***/ function(module, exports, __webpack_require__) {

	var $parseInt = __webpack_require__(24).parseInt;
	var $trim = __webpack_require__(118).trim;
	var ws = __webpack_require__(225);
	var hex = /^[-+]?0[xX]/;
	
	module.exports = $parseInt(ws + '08') !== 8 || $parseInt(ws + '0x16') !== 22 ? function parseInt(str, radix) {
	  var string = $trim(String(str), 3);
	  return $parseInt(string, (radix >>> 0) || (hex.test(string) ? 16 : 10));
	} : $parseInt;


/***/ },
/* 316 */
/***/ function(module, exports) {

	module.exports = function (exec) {
	  try {
	    return { e: false, v: exec() };
	  } catch (e) {
	    return { e: true, v: e };
	  }
	};


/***/ },
/* 317 */
/***/ function(module, exports, __webpack_require__) {

	var anObject = __webpack_require__(23);
	var isObject = __webpack_require__(27);
	var newPromiseCapability = __webpack_require__(219);
	
	module.exports = function (C, x) {
	  anObject(C);
	  if (isObject(x) && x.constructor === C) return x;
	  var promiseCapability = newPromiseCapability.f(C);
	  var resolve = promiseCapability.resolve;
	  resolve(x);
	  return promiseCapability.promise;
	};


/***/ },
/* 318 */
/***/ function(module, exports, __webpack_require__) {

	// https://github.com/tc39/proposal-string-pad-start-end
	var toLength = __webpack_require__(40);
	var repeat = __webpack_require__(224);
	var defined = __webpack_require__(76);
	
	module.exports = function (that, maxLength, fillString, left) {
	  var S = String(defined(that));
	  var stringLength = S.length;
	  var fillStr = fillString === undefined ? ' ' : String(fillString);
	  var intMaxLength = toLength(maxLength);
	  if (intMaxLength <= stringLength || fillStr == '') return S;
	  var fillLen = intMaxLength - stringLength;
	  var stringFiller = repeat.call(fillStr, Math.ceil(fillLen / fillStr.length));
	  if (stringFiller.length > fillLen) stringFiller = stringFiller.slice(0, fillLen);
	  return left ? stringFiller + S : S + stringFiller;
	};


/***/ },
/* 319 */
/***/ function(module, exports, __webpack_require__) {

	// https://tc39.github.io/ecma262/#sec-toindex
	var toInteger = __webpack_require__(78);
	var toLength = __webpack_require__(40);
	module.exports = function (it) {
	  if (it === undefined) return 0;
	  var number = toInteger(it);
	  var length = toLength(number);
	  if (number !== length) throw RangeError('Wrong length!');
	  return length;
	};


/***/ },
/* 320 */
/***/ function(module, exports, __webpack_require__) {

	exports.f = __webpack_require__(34);


/***/ },
/* 321 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var strong = __webpack_require__(296);
	var validate = __webpack_require__(119);
	var MAP = 'Map';
	
	// 23.1 Map Objects
	module.exports = __webpack_require__(155)(MAP, function (get) {
	  return function Map() { return get(this, arguments.length > 0 ? arguments[0] : undefined); };
	}, {
	  // 23.1.3.6 Map.prototype.get(key)
	  get: function get(key) {
	    var entry = strong.getEntry(validate(this, MAP), key);
	    return entry && entry.v;
	  },
	  // 23.1.3.9 Map.prototype.set(key, value)
	  set: function set(key, value) {
	    return strong.def(validate(this, MAP), key === 0 ? 0 : key, value);
	  }
	}, strong, true);


/***/ },
/* 322 */
/***/ function(module, exports, __webpack_require__) {

	// 21.2.5.3 get RegExp.prototype.flags()
	if (__webpack_require__(38) && /./g.flags != 'g') __webpack_require__(39).f(RegExp.prototype, 'flags', {
	  configurable: true,
	  get: __webpack_require__(157)
	});


/***/ },
/* 323 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var strong = __webpack_require__(296);
	var validate = __webpack_require__(119);
	var SET = 'Set';
	
	// 23.2 Set Objects
	module.exports = __webpack_require__(155)(SET, function (get) {
	  return function Set() { return get(this, arguments.length > 0 ? arguments[0] : undefined); };
	}, {
	  // 23.2.3.1 Set.prototype.add(value)
	  add: function add(value) {
	    return strong.def(validate(this, SET), value = value === 0 ? 0 : value, value);
	  }
	}, strong);


/***/ },
/* 324 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var each = __webpack_require__(75)(0);
	var redefine = __webpack_require__(53);
	var meta = __webpack_require__(97);
	var assign = __webpack_require__(308);
	var weak = __webpack_require__(298);
	var isObject = __webpack_require__(27);
	var fails = __webpack_require__(26);
	var validate = __webpack_require__(119);
	var WEAK_MAP = 'WeakMap';
	var getWeak = meta.getWeak;
	var isExtensible = Object.isExtensible;
	var uncaughtFrozenStore = weak.ufstore;
	var tmp = {};
	var InternalMap;
	
	var wrapper = function (get) {
	  return function WeakMap() {
	    return get(this, arguments.length > 0 ? arguments[0] : undefined);
	  };
	};
	
	var methods = {
	  // 23.3.3.3 WeakMap.prototype.get(key)
	  get: function get(key) {
	    if (isObject(key)) {
	      var data = getWeak(key);
	      if (data === true) return uncaughtFrozenStore(validate(this, WEAK_MAP)).get(key);
	      return data ? data[this._i] : undefined;
	    }
	  },
	  // 23.3.3.5 WeakMap.prototype.set(key, value)
	  set: function set(key, value) {
	    return weak.def(validate(this, WEAK_MAP), key, value);
	  }
	};
	
	// 23.3 WeakMap Objects
	var $WeakMap = module.exports = __webpack_require__(155)(WEAK_MAP, wrapper, methods, weak, true, true);
	
	// IE11 WeakMap frozen keys fix
	if (fails(function () { return new $WeakMap().set((Object.freeze || Object)(tmp), 7).get(tmp) != 7; })) {
	  InternalMap = weak.getConstructor(wrapper, WEAK_MAP);
	  assign(InternalMap.prototype, methods);
	  meta.NEED = true;
	  each(['delete', 'has', 'get', 'set'], function (key) {
	    var proto = $WeakMap.prototype;
	    var method = proto[key];
	    redefine(proto, key, function (a, b) {
	      // store frozen objects on internal weakmap shim
	      if (isObject(a) && !isExtensible(a)) {
	        if (!this._f) this._f = new InternalMap();
	        var result = this._f[key](a, b);
	        return key == 'set' ? this : result;
	      // store all the rest on native weakmap
	      } return method.call(this, a, b);
	    });
	  });
	}


/***/ },
/* 325 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(36);
	
	var emptyObject = __webpack_require__(141);
	var _invariant = __webpack_require__(21);
	
	if (false) {
	  var warning = require('fbjs/lib/warning');
	}
	
	var MIXINS_KEY = 'mixins';
	
	// Helper function to allow the creation of anonymous functions which do not
	// have .name set to the name of the variable being assigned to.
	function identity(fn) {
	  return fn;
	}
	
	var ReactPropTypeLocationNames;
	if (false) {
	  ReactPropTypeLocationNames = {
	    prop: 'prop',
	    context: 'context',
	    childContext: 'child context'
	  };
	} else {
	  ReactPropTypeLocationNames = {};
	}
	
	function factory(ReactComponent, isValidElement, ReactNoopUpdateQueue) {
	  /**
	   * Policies that describe methods in `ReactClassInterface`.
	   */
	
	  var injectedMixins = [];
	
	  /**
	   * Composite components are higher-level components that compose other composite
	   * or host components.
	   *
	   * To create a new type of `ReactClass`, pass a specification of
	   * your new class to `React.createClass`. The only requirement of your class
	   * specification is that you implement a `render` method.
	   *
	   *   var MyComponent = React.createClass({
	   *     render: function() {
	   *       return <div>Hello World</div>;
	   *     }
	   *   });
	   *
	   * The class specification supports a specific protocol of methods that have
	   * special meaning (e.g. `render`). See `ReactClassInterface` for
	   * more the comprehensive protocol. Any other properties and methods in the
	   * class specification will be available on the prototype.
	   *
	   * @interface ReactClassInterface
	   * @internal
	   */
	  var ReactClassInterface = {
	    /**
	     * An array of Mixin objects to include when defining your component.
	     *
	     * @type {array}
	     * @optional
	     */
	    mixins: 'DEFINE_MANY',
	
	    /**
	     * An object containing properties and methods that should be defined on
	     * the component's constructor instead of its prototype (static methods).
	     *
	     * @type {object}
	     * @optional
	     */
	    statics: 'DEFINE_MANY',
	
	    /**
	     * Definition of prop types for this component.
	     *
	     * @type {object}
	     * @optional
	     */
	    propTypes: 'DEFINE_MANY',
	
	    /**
	     * Definition of context types for this component.
	     *
	     * @type {object}
	     * @optional
	     */
	    contextTypes: 'DEFINE_MANY',
	
	    /**
	     * Definition of context types this component sets for its children.
	     *
	     * @type {object}
	     * @optional
	     */
	    childContextTypes: 'DEFINE_MANY',
	
	    // ==== Definition methods ====
	
	    /**
	     * Invoked when the component is mounted. Values in the mapping will be set on
	     * `this.props` if that prop is not specified (i.e. using an `in` check).
	     *
	     * This method is invoked before `getInitialState` and therefore cannot rely
	     * on `this.state` or use `this.setState`.
	     *
	     * @return {object}
	     * @optional
	     */
	    getDefaultProps: 'DEFINE_MANY_MERGED',
	
	    /**
	     * Invoked once before the component is mounted. The return value will be used
	     * as the initial value of `this.state`.
	     *
	     *   getInitialState: function() {
	     *     return {
	     *       isOn: false,
	     *       fooBaz: new BazFoo()
	     *     }
	     *   }
	     *
	     * @return {object}
	     * @optional
	     */
	    getInitialState: 'DEFINE_MANY_MERGED',
	
	    /**
	     * @return {object}
	     * @optional
	     */
	    getChildContext: 'DEFINE_MANY_MERGED',
	
	    /**
	     * Uses props from `this.props` and state from `this.state` to render the
	     * structure of the component.
	     *
	     * No guarantees are made about when or how often this method is invoked, so
	     * it must not have side effects.
	     *
	     *   render: function() {
	     *     var name = this.props.name;
	     *     return <div>Hello, {name}!</div>;
	     *   }
	     *
	     * @return {ReactComponent}
	     * @required
	     */
	    render: 'DEFINE_ONCE',
	
	    // ==== Delegate methods ====
	
	    /**
	     * Invoked when the component is initially created and about to be mounted.
	     * This may have side effects, but any external subscriptions or data created
	     * by this method must be cleaned up in `componentWillUnmount`.
	     *
	     * @optional
	     */
	    componentWillMount: 'DEFINE_MANY',
	
	    /**
	     * Invoked when the component has been mounted and has a DOM representation.
	     * However, there is no guarantee that the DOM node is in the document.
	     *
	     * Use this as an opportunity to operate on the DOM when the component has
	     * been mounted (initialized and rendered) for the first time.
	     *
	     * @param {DOMElement} rootNode DOM element representing the component.
	     * @optional
	     */
	    componentDidMount: 'DEFINE_MANY',
	
	    /**
	     * Invoked before the component receives new props.
	     *
	     * Use this as an opportunity to react to a prop transition by updating the
	     * state using `this.setState`. Current props are accessed via `this.props`.
	     *
	     *   componentWillReceiveProps: function(nextProps, nextContext) {
	     *     this.setState({
	     *       likesIncreasing: nextProps.likeCount > this.props.likeCount
	     *     });
	     *   }
	     *
	     * NOTE: There is no equivalent `componentWillReceiveState`. An incoming prop
	     * transition may cause a state change, but the opposite is not true. If you
	     * need it, you are probably looking for `componentWillUpdate`.
	     *
	     * @param {object} nextProps
	     * @optional
	     */
	    componentWillReceiveProps: 'DEFINE_MANY',
	
	    /**
	     * Invoked while deciding if the component should be updated as a result of
	     * receiving new props, state and/or context.
	     *
	     * Use this as an opportunity to `return false` when you're certain that the
	     * transition to the new props/state/context will not require a component
	     * update.
	     *
	     *   shouldComponentUpdate: function(nextProps, nextState, nextContext) {
	     *     return !equal(nextProps, this.props) ||
	     *       !equal(nextState, this.state) ||
	     *       !equal(nextContext, this.context);
	     *   }
	     *
	     * @param {object} nextProps
	     * @param {?object} nextState
	     * @param {?object} nextContext
	     * @return {boolean} True if the component should update.
	     * @optional
	     */
	    shouldComponentUpdate: 'DEFINE_ONCE',
	
	    /**
	     * Invoked when the component is about to update due to a transition from
	     * `this.props`, `this.state` and `this.context` to `nextProps`, `nextState`
	     * and `nextContext`.
	     *
	     * Use this as an opportunity to perform preparation before an update occurs.
	     *
	     * NOTE: You **cannot** use `this.setState()` in this method.
	     *
	     * @param {object} nextProps
	     * @param {?object} nextState
	     * @param {?object} nextContext
	     * @param {ReactReconcileTransaction} transaction
	     * @optional
	     */
	    componentWillUpdate: 'DEFINE_MANY',
	
	    /**
	     * Invoked when the component's DOM representation has been updated.
	     *
	     * Use this as an opportunity to operate on the DOM when the component has
	     * been updated.
	     *
	     * @param {object} prevProps
	     * @param {?object} prevState
	     * @param {?object} prevContext
	     * @param {DOMElement} rootNode DOM element representing the component.
	     * @optional
	     */
	    componentDidUpdate: 'DEFINE_MANY',
	
	    /**
	     * Invoked when the component is about to be removed from its parent and have
	     * its DOM representation destroyed.
	     *
	     * Use this as an opportunity to deallocate any external resources.
	     *
	     * NOTE: There is no `componentDidUnmount` since your component will have been
	     * destroyed by that point.
	     *
	     * @optional
	     */
	    componentWillUnmount: 'DEFINE_MANY',
	
	    /**
	     * Replacement for (deprecated) `componentWillMount`.
	     *
	     * @optional
	     */
	    UNSAFE_componentWillMount: 'DEFINE_MANY',
	
	    /**
	     * Replacement for (deprecated) `componentWillReceiveProps`.
	     *
	     * @optional
	     */
	    UNSAFE_componentWillReceiveProps: 'DEFINE_MANY',
	
	    /**
	     * Replacement for (deprecated) `componentWillUpdate`.
	     *
	     * @optional
	     */
	    UNSAFE_componentWillUpdate: 'DEFINE_MANY',
	
	    // ==== Advanced methods ====
	
	    /**
	     * Updates the component's currently mounted DOM representation.
	     *
	     * By default, this implements React's rendering and reconciliation algorithm.
	     * Sophisticated clients may wish to override this.
	     *
	     * @param {ReactReconcileTransaction} transaction
	     * @internal
	     * @overridable
	     */
	    updateComponent: 'OVERRIDE_BASE'
	  };
	
	  /**
	   * Similar to ReactClassInterface but for static methods.
	   */
	  var ReactClassStaticInterface = {
	    /**
	     * This method is invoked after a component is instantiated and when it
	     * receives new props. Return an object to update state in response to
	     * prop changes. Return null to indicate no change to state.
	     *
	     * If an object is returned, its keys will be merged into the existing state.
	     *
	     * @return {object || null}
	     * @optional
	     */
	    getDerivedStateFromProps: 'DEFINE_MANY_MERGED'
	  };
	
	  /**
	   * Mapping from class specification keys to special processing functions.
	   *
	   * Although these are declared like instance properties in the specification
	   * when defining classes using `React.createClass`, they are actually static
	   * and are accessible on the constructor instead of the prototype. Despite
	   * being static, they must be defined outside of the "statics" key under
	   * which all other static methods are defined.
	   */
	  var RESERVED_SPEC_KEYS = {
	    displayName: function(Constructor, displayName) {
	      Constructor.displayName = displayName;
	    },
	    mixins: function(Constructor, mixins) {
	      if (mixins) {
	        for (var i = 0; i < mixins.length; i++) {
	          mixSpecIntoComponent(Constructor, mixins[i]);
	        }
	      }
	    },
	    childContextTypes: function(Constructor, childContextTypes) {
	      if (false) {
	        validateTypeDef(Constructor, childContextTypes, 'childContext');
	      }
	      Constructor.childContextTypes = _assign(
	        {},
	        Constructor.childContextTypes,
	        childContextTypes
	      );
	    },
	    contextTypes: function(Constructor, contextTypes) {
	      if (false) {
	        validateTypeDef(Constructor, contextTypes, 'context');
	      }
	      Constructor.contextTypes = _assign(
	        {},
	        Constructor.contextTypes,
	        contextTypes
	      );
	    },
	    /**
	     * Special case getDefaultProps which should move into statics but requires
	     * automatic merging.
	     */
	    getDefaultProps: function(Constructor, getDefaultProps) {
	      if (Constructor.getDefaultProps) {
	        Constructor.getDefaultProps = createMergedResultFunction(
	          Constructor.getDefaultProps,
	          getDefaultProps
	        );
	      } else {
	        Constructor.getDefaultProps = getDefaultProps;
	      }
	    },
	    propTypes: function(Constructor, propTypes) {
	      if (false) {
	        validateTypeDef(Constructor, propTypes, 'prop');
	      }
	      Constructor.propTypes = _assign({}, Constructor.propTypes, propTypes);
	    },
	    statics: function(Constructor, statics) {
	      mixStaticSpecIntoComponent(Constructor, statics);
	    },
	    autobind: function() {}
	  };
	
	  function validateTypeDef(Constructor, typeDef, location) {
	    for (var propName in typeDef) {
	      if (typeDef.hasOwnProperty(propName)) {
	        // use a warning instead of an _invariant so components
	        // don't show up in prod but only in __DEV__
	        if (false) {
	          warning(
	            typeof typeDef[propName] === 'function',
	            '%s: %s type `%s` is invalid; it must be a function, usually from ' +
	              'React.PropTypes.',
	            Constructor.displayName || 'ReactClass',
	            ReactPropTypeLocationNames[location],
	            propName
	          );
	        }
	      }
	    }
	  }
	
	  function validateMethodOverride(isAlreadyDefined, name) {
	    var specPolicy = ReactClassInterface.hasOwnProperty(name)
	      ? ReactClassInterface[name]
	      : null;
	
	    // Disallow overriding of base class methods unless explicitly allowed.
	    if (ReactClassMixin.hasOwnProperty(name)) {
	      _invariant(
	        specPolicy === 'OVERRIDE_BASE',
	        'ReactClassInterface: You are attempting to override ' +
	          '`%s` from your class specification. Ensure that your method names ' +
	          'do not overlap with React methods.',
	        name
	      );
	    }
	
	    // Disallow defining methods more than once unless explicitly allowed.
	    if (isAlreadyDefined) {
	      _invariant(
	        specPolicy === 'DEFINE_MANY' || specPolicy === 'DEFINE_MANY_MERGED',
	        'ReactClassInterface: You are attempting to define ' +
	          '`%s` on your component more than once. This conflict may be due ' +
	          'to a mixin.',
	        name
	      );
	    }
	  }
	
	  /**
	   * Mixin helper which handles policy validation and reserved
	   * specification keys when building React classes.
	   */
	  function mixSpecIntoComponent(Constructor, spec) {
	    if (!spec) {
	      if (false) {
	        var typeofSpec = typeof spec;
	        var isMixinValid = typeofSpec === 'object' && spec !== null;
	
	        if (process.env.NODE_ENV !== 'production') {
	          warning(
	            isMixinValid,
	            "%s: You're attempting to include a mixin that is either null " +
	              'or not an object. Check the mixins included by the component, ' +
	              'as well as any mixins they include themselves. ' +
	              'Expected object but got %s.',
	            Constructor.displayName || 'ReactClass',
	            spec === null ? null : typeofSpec
	          );
	        }
	      }
	
	      return;
	    }
	
	    _invariant(
	      typeof spec !== 'function',
	      "ReactClass: You're attempting to " +
	        'use a component class or function as a mixin. Instead, just use a ' +
	        'regular object.'
	    );
	    _invariant(
	      !isValidElement(spec),
	      "ReactClass: You're attempting to " +
	        'use a component as a mixin. Instead, just use a regular object.'
	    );
	
	    var proto = Constructor.prototype;
	    var autoBindPairs = proto.__reactAutoBindPairs;
	
	    // By handling mixins before any other properties, we ensure the same
	    // chaining order is applied to methods with DEFINE_MANY policy, whether
	    // mixins are listed before or after these methods in the spec.
	    if (spec.hasOwnProperty(MIXINS_KEY)) {
	      RESERVED_SPEC_KEYS.mixins(Constructor, spec.mixins);
	    }
	
	    for (var name in spec) {
	      if (!spec.hasOwnProperty(name)) {
	        continue;
	      }
	
	      if (name === MIXINS_KEY) {
	        // We have already handled mixins in a special case above.
	        continue;
	      }
	
	      var property = spec[name];
	      var isAlreadyDefined = proto.hasOwnProperty(name);
	      validateMethodOverride(isAlreadyDefined, name);
	
	      if (RESERVED_SPEC_KEYS.hasOwnProperty(name)) {
	        RESERVED_SPEC_KEYS[name](Constructor, property);
	      } else {
	        // Setup methods on prototype:
	        // The following member methods should not be automatically bound:
	        // 1. Expected ReactClass methods (in the "interface").
	        // 2. Overridden methods (that were mixed in).
	        var isReactClassMethod = ReactClassInterface.hasOwnProperty(name);
	        var isFunction = typeof property === 'function';
	        var shouldAutoBind =
	          isFunction &&
	          !isReactClassMethod &&
	          !isAlreadyDefined &&
	          spec.autobind !== false;
	
	        if (shouldAutoBind) {
	          autoBindPairs.push(name, property);
	          proto[name] = property;
	        } else {
	          if (isAlreadyDefined) {
	            var specPolicy = ReactClassInterface[name];
	
	            // These cases should already be caught by validateMethodOverride.
	            _invariant(
	              isReactClassMethod &&
	                (specPolicy === 'DEFINE_MANY_MERGED' ||
	                  specPolicy === 'DEFINE_MANY'),
	              'ReactClass: Unexpected spec policy %s for key %s ' +
	                'when mixing in component specs.',
	              specPolicy,
	              name
	            );
	
	            // For methods which are defined more than once, call the existing
	            // methods before calling the new property, merging if appropriate.
	            if (specPolicy === 'DEFINE_MANY_MERGED') {
	              proto[name] = createMergedResultFunction(proto[name], property);
	            } else if (specPolicy === 'DEFINE_MANY') {
	              proto[name] = createChainedFunction(proto[name], property);
	            }
	          } else {
	            proto[name] = property;
	            if (false) {
	              // Add verbose displayName to the function, which helps when looking
	              // at profiling tools.
	              if (typeof property === 'function' && spec.displayName) {
	                proto[name].displayName = spec.displayName + '_' + name;
	              }
	            }
	          }
	        }
	      }
	    }
	  }
	
	  function mixStaticSpecIntoComponent(Constructor, statics) {
	    if (!statics) {
	      return;
	    }
	
	    for (var name in statics) {
	      var property = statics[name];
	      if (!statics.hasOwnProperty(name)) {
	        continue;
	      }
	
	      var isReserved = name in RESERVED_SPEC_KEYS;
	      _invariant(
	        !isReserved,
	        'ReactClass: You are attempting to define a reserved ' +
	          'property, `%s`, that shouldn\'t be on the "statics" key. Define it ' +
	          'as an instance property instead; it will still be accessible on the ' +
	          'constructor.',
	        name
	      );
	
	      var isAlreadyDefined = name in Constructor;
	      if (isAlreadyDefined) {
	        var specPolicy = ReactClassStaticInterface.hasOwnProperty(name)
	          ? ReactClassStaticInterface[name]
	          : null;
	
	        _invariant(
	          specPolicy === 'DEFINE_MANY_MERGED',
	          'ReactClass: You are attempting to define ' +
	            '`%s` on your component more than once. This conflict may be ' +
	            'due to a mixin.',
	          name
	        );
	
	        Constructor[name] = createMergedResultFunction(Constructor[name], property);
	
	        return;
	      }
	
	      Constructor[name] = property;
	    }
	  }
	
	  /**
	   * Merge two objects, but throw if both contain the same key.
	   *
	   * @param {object} one The first object, which is mutated.
	   * @param {object} two The second object
	   * @return {object} one after it has been mutated to contain everything in two.
	   */
	  function mergeIntoWithNoDuplicateKeys(one, two) {
	    _invariant(
	      one && two && typeof one === 'object' && typeof two === 'object',
	      'mergeIntoWithNoDuplicateKeys(): Cannot merge non-objects.'
	    );
	
	    for (var key in two) {
	      if (two.hasOwnProperty(key)) {
	        _invariant(
	          one[key] === undefined,
	          'mergeIntoWithNoDuplicateKeys(): ' +
	            'Tried to merge two objects with the same key: `%s`. This conflict ' +
	            'may be due to a mixin; in particular, this may be caused by two ' +
	            'getInitialState() or getDefaultProps() methods returning objects ' +
	            'with clashing keys.',
	          key
	        );
	        one[key] = two[key];
	      }
	    }
	    return one;
	  }
	
	  /**
	   * Creates a function that invokes two functions and merges their return values.
	   *
	   * @param {function} one Function to invoke first.
	   * @param {function} two Function to invoke second.
	   * @return {function} Function that invokes the two argument functions.
	   * @private
	   */
	  function createMergedResultFunction(one, two) {
	    return function mergedResult() {
	      var a = one.apply(this, arguments);
	      var b = two.apply(this, arguments);
	      if (a == null) {
	        return b;
	      } else if (b == null) {
	        return a;
	      }
	      var c = {};
	      mergeIntoWithNoDuplicateKeys(c, a);
	      mergeIntoWithNoDuplicateKeys(c, b);
	      return c;
	    };
	  }
	
	  /**
	   * Creates a function that invokes two functions and ignores their return vales.
	   *
	   * @param {function} one Function to invoke first.
	   * @param {function} two Function to invoke second.
	   * @return {function} Function that invokes the two argument functions.
	   * @private
	   */
	  function createChainedFunction(one, two) {
	    return function chainedFunction() {
	      one.apply(this, arguments);
	      two.apply(this, arguments);
	    };
	  }
	
	  /**
	   * Binds a method to the component.
	   *
	   * @param {object} component Component whose method is going to be bound.
	   * @param {function} method Method to be bound.
	   * @return {function} The bound method.
	   */
	  function bindAutoBindMethod(component, method) {
	    var boundMethod = method.bind(component);
	    if (false) {
	      boundMethod.__reactBoundContext = component;
	      boundMethod.__reactBoundMethod = method;
	      boundMethod.__reactBoundArguments = null;
	      var componentName = component.constructor.displayName;
	      var _bind = boundMethod.bind;
	      boundMethod.bind = function(newThis) {
	        for (
	          var _len = arguments.length,
	            args = Array(_len > 1 ? _len - 1 : 0),
	            _key = 1;
	          _key < _len;
	          _key++
	        ) {
	          args[_key - 1] = arguments[_key];
	        }
	
	        // User is trying to bind() an autobound method; we effectively will
	        // ignore the value of "this" that the user is trying to use, so
	        // let's warn.
	        if (newThis !== component && newThis !== null) {
	          if (process.env.NODE_ENV !== 'production') {
	            warning(
	              false,
	              'bind(): React component methods may only be bound to the ' +
	                'component instance. See %s',
	              componentName
	            );
	          }
	        } else if (!args.length) {
	          if (process.env.NODE_ENV !== 'production') {
	            warning(
	              false,
	              'bind(): You are binding a component method to the component. ' +
	                'React does this for you automatically in a high-performance ' +
	                'way, so you can safely remove this call. See %s',
	              componentName
	            );
	          }
	          return boundMethod;
	        }
	        var reboundMethod = _bind.apply(boundMethod, arguments);
	        reboundMethod.__reactBoundContext = component;
	        reboundMethod.__reactBoundMethod = method;
	        reboundMethod.__reactBoundArguments = args;
	        return reboundMethod;
	      };
	    }
	    return boundMethod;
	  }
	
	  /**
	   * Binds all auto-bound methods in a component.
	   *
	   * @param {object} component Component whose method is going to be bound.
	   */
	  function bindAutoBindMethods(component) {
	    var pairs = component.__reactAutoBindPairs;
	    for (var i = 0; i < pairs.length; i += 2) {
	      var autoBindKey = pairs[i];
	      var method = pairs[i + 1];
	      component[autoBindKey] = bindAutoBindMethod(component, method);
	    }
	  }
	
	  var IsMountedPreMixin = {
	    componentDidMount: function() {
	      this.__isMounted = true;
	    }
	  };
	
	  var IsMountedPostMixin = {
	    componentWillUnmount: function() {
	      this.__isMounted = false;
	    }
	  };
	
	  /**
	   * Add more to the ReactClass base class. These are all legacy features and
	   * therefore not already part of the modern ReactComponent.
	   */
	  var ReactClassMixin = {
	    /**
	     * TODO: This will be deprecated because state should always keep a consistent
	     * type signature and the only use case for this, is to avoid that.
	     */
	    replaceState: function(newState, callback) {
	      this.updater.enqueueReplaceState(this, newState, callback);
	    },
	
	    /**
	     * Checks whether or not this composite component is mounted.
	     * @return {boolean} True if mounted, false otherwise.
	     * @protected
	     * @final
	     */
	    isMounted: function() {
	      if (false) {
	        warning(
	          this.__didWarnIsMounted,
	          '%s: isMounted is deprecated. Instead, make sure to clean up ' +
	            'subscriptions and pending requests in componentWillUnmount to ' +
	            'prevent memory leaks.',
	          (this.constructor && this.constructor.displayName) ||
	            this.name ||
	            'Component'
	        );
	        this.__didWarnIsMounted = true;
	      }
	      return !!this.__isMounted;
	    }
	  };
	
	  var ReactClassComponent = function() {};
	  _assign(
	    ReactClassComponent.prototype,
	    ReactComponent.prototype,
	    ReactClassMixin
	  );
	
	  /**
	   * Creates a composite component class given a class specification.
	   * See https://facebook.github.io/react/docs/top-level-api.html#react.createclass
	   *
	   * @param {object} spec Class specification (which must define `render`).
	   * @return {function} Component constructor function.
	   * @public
	   */
	  function createClass(spec) {
	    // To keep our warnings more understandable, we'll use a little hack here to
	    // ensure that Constructor.name !== 'Constructor'. This makes sure we don't
	    // unnecessarily identify a class without displayName as 'Constructor'.
	    var Constructor = identity(function(props, context, updater) {
	      // This constructor gets overridden by mocks. The argument is used
	      // by mocks to assert on what gets mounted.
	
	      if (false) {
	        warning(
	          this instanceof Constructor,
	          'Something is calling a React component directly. Use a factory or ' +
	            'JSX instead. See: https://fb.me/react-legacyfactory'
	        );
	      }
	
	      // Wire up auto-binding
	      if (this.__reactAutoBindPairs.length) {
	        bindAutoBindMethods(this);
	      }
	
	      this.props = props;
	      this.context = context;
	      this.refs = emptyObject;
	      this.updater = updater || ReactNoopUpdateQueue;
	
	      this.state = null;
	
	      // ReactClasses doesn't have constructors. Instead, they use the
	      // getInitialState and componentWillMount methods for initialization.
	
	      var initialState = this.getInitialState ? this.getInitialState() : null;
	      if (false) {
	        // We allow auto-mocks to proceed as if they're returning null.
	        if (
	          initialState === undefined &&
	          this.getInitialState._isMockFunction
	        ) {
	          // This is probably bad practice. Consider warning here and
	          // deprecating this convenience.
	          initialState = null;
	        }
	      }
	      _invariant(
	        typeof initialState === 'object' && !Array.isArray(initialState),
	        '%s.getInitialState(): must return an object or null',
	        Constructor.displayName || 'ReactCompositeComponent'
	      );
	
	      this.state = initialState;
	    });
	    Constructor.prototype = new ReactClassComponent();
	    Constructor.prototype.constructor = Constructor;
	    Constructor.prototype.__reactAutoBindPairs = [];
	
	    injectedMixins.forEach(mixSpecIntoComponent.bind(null, Constructor));
	
	    mixSpecIntoComponent(Constructor, IsMountedPreMixin);
	    mixSpecIntoComponent(Constructor, spec);
	    mixSpecIntoComponent(Constructor, IsMountedPostMixin);
	
	    // Initialize the defaultProps property after all mixins have been merged.
	    if (Constructor.getDefaultProps) {
	      Constructor.defaultProps = Constructor.getDefaultProps();
	    }
	
	    if (false) {
	      // This is a tag to indicate that the use of these method names is ok,
	      // since it's used with createClass. If it's not, then it's likely a
	      // mistake so we'll warn you to use the static property, property
	      // initializer or constructor respectively.
	      if (Constructor.getDefaultProps) {
	        Constructor.getDefaultProps.isReactClassApproved = {};
	      }
	      if (Constructor.prototype.getInitialState) {
	        Constructor.prototype.getInitialState.isReactClassApproved = {};
	      }
	    }
	
	    _invariant(
	      Constructor.prototype.render,
	      'createClass(...): Class specification must implement a `render` method.'
	    );
	
	    if (false) {
	      warning(
	        !Constructor.prototype.componentShouldUpdate,
	        '%s has a method called ' +
	          'componentShouldUpdate(). Did you mean shouldComponentUpdate()? ' +
	          'The name is phrased as a question because the function is ' +
	          'expected to return a value.',
	        spec.displayName || 'A component'
	      );
	      warning(
	        !Constructor.prototype.componentWillRecieveProps,
	        '%s has a method called ' +
	          'componentWillRecieveProps(). Did you mean componentWillReceiveProps()?',
	        spec.displayName || 'A component'
	      );
	      warning(
	        !Constructor.prototype.UNSAFE_componentWillRecieveProps,
	        '%s has a method called UNSAFE_componentWillRecieveProps(). ' +
	          'Did you mean UNSAFE_componentWillReceiveProps()?',
	        spec.displayName || 'A component'
	      );
	    }
	
	    // Reduce time spent doing lookups by setting these on the prototype.
	    for (var methodName in ReactClassInterface) {
	      if (!Constructor.prototype[methodName]) {
	        Constructor.prototype[methodName] = null;
	      }
	    }
	
	    return Constructor;
	  }
	
	  return createClass;
	}
	
	module.exports = factory;


/***/ },
/* 326 */
/***/ function(module, exports, __webpack_require__) {

	;(function (root, factory) {
		if (true) {
			// CommonJS
			module.exports = exports = factory(__webpack_require__(25));
		}
		else if (typeof define === "function" && define.amd) {
			// AMD
			define(["./core"], factory);
		}
		else {
			// Global (browser)
			factory(root.CryptoJS);
		}
	}(this, function (CryptoJS) {
	
		(function (Math) {
		    // Shortcuts
		    var C = CryptoJS;
		    var C_lib = C.lib;
		    var WordArray = C_lib.WordArray;
		    var Hasher = C_lib.Hasher;
		    var C_algo = C.algo;
	
		    // Initialization and round constants tables
		    var H = [];
		    var K = [];
	
		    // Compute constants
		    (function () {
		        function isPrime(n) {
		            var sqrtN = Math.sqrt(n);
		            for (var factor = 2; factor <= sqrtN; factor++) {
		                if (!(n % factor)) {
		                    return false;
		                }
		            }
	
		            return true;
		        }
	
		        function getFractionalBits(n) {
		            return ((n - (n | 0)) * 0x100000000) | 0;
		        }
	
		        var n = 2;
		        var nPrime = 0;
		        while (nPrime < 64) {
		            if (isPrime(n)) {
		                if (nPrime < 8) {
		                    H[nPrime] = getFractionalBits(Math.pow(n, 1 / 2));
		                }
		                K[nPrime] = getFractionalBits(Math.pow(n, 1 / 3));
	
		                nPrime++;
		            }
	
		            n++;
		        }
		    }());
	
		    // Reusable object
		    var W = [];
	
		    /**
		     * SHA-256 hash algorithm.
		     */
		    var SHA256 = C_algo.SHA256 = Hasher.extend({
		        _doReset: function () {
		            this._hash = new WordArray.init(H.slice(0));
		        },
	
		        _doProcessBlock: function (M, offset) {
		            // Shortcut
		            var H = this._hash.words;
	
		            // Working variables
		            var a = H[0];
		            var b = H[1];
		            var c = H[2];
		            var d = H[3];
		            var e = H[4];
		            var f = H[5];
		            var g = H[6];
		            var h = H[7];
	
		            // Computation
		            for (var i = 0; i < 64; i++) {
		                if (i < 16) {
		                    W[i] = M[offset + i] | 0;
		                } else {
		                    var gamma0x = W[i - 15];
		                    var gamma0  = ((gamma0x << 25) | (gamma0x >>> 7))  ^
		                                  ((gamma0x << 14) | (gamma0x >>> 18)) ^
		                                   (gamma0x >>> 3);
	
		                    var gamma1x = W[i - 2];
		                    var gamma1  = ((gamma1x << 15) | (gamma1x >>> 17)) ^
		                                  ((gamma1x << 13) | (gamma1x >>> 19)) ^
		                                   (gamma1x >>> 10);
	
		                    W[i] = gamma0 + W[i - 7] + gamma1 + W[i - 16];
		                }
	
		                var ch  = (e & f) ^ (~e & g);
		                var maj = (a & b) ^ (a & c) ^ (b & c);
	
		                var sigma0 = ((a << 30) | (a >>> 2)) ^ ((a << 19) | (a >>> 13)) ^ ((a << 10) | (a >>> 22));
		                var sigma1 = ((e << 26) | (e >>> 6)) ^ ((e << 21) | (e >>> 11)) ^ ((e << 7)  | (e >>> 25));
	
		                var t1 = h + sigma1 + ch + K[i] + W[i];
		                var t2 = sigma0 + maj;
	
		                h = g;
		                g = f;
		                f = e;
		                e = (d + t1) | 0;
		                d = c;
		                c = b;
		                b = a;
		                a = (t1 + t2) | 0;
		            }
	
		            // Intermediate hash value
		            H[0] = (H[0] + a) | 0;
		            H[1] = (H[1] + b) | 0;
		            H[2] = (H[2] + c) | 0;
		            H[3] = (H[3] + d) | 0;
		            H[4] = (H[4] + e) | 0;
		            H[5] = (H[5] + f) | 0;
		            H[6] = (H[6] + g) | 0;
		            H[7] = (H[7] + h) | 0;
		        },
	
		        _doFinalize: function () {
		            // Shortcuts
		            var data = this._data;
		            var dataWords = data.words;
	
		            var nBitsTotal = this._nDataBytes * 8;
		            var nBitsLeft = data.sigBytes * 8;
	
		            // Add padding
		            dataWords[nBitsLeft >>> 5] |= 0x80 << (24 - nBitsLeft % 32);
		            dataWords[(((nBitsLeft + 64) >>> 9) << 4) + 14] = Math.floor(nBitsTotal / 0x100000000);
		            dataWords[(((nBitsLeft + 64) >>> 9) << 4) + 15] = nBitsTotal;
		            data.sigBytes = dataWords.length * 4;
	
		            // Hash final blocks
		            this._process();
	
		            // Return final computed hash
		            return this._hash;
		        },
	
		        clone: function () {
		            var clone = Hasher.clone.call(this);
		            clone._hash = this._hash.clone();
	
		            return clone;
		        }
		    });
	
		    /**
		     * Shortcut function to the hasher's object interface.
		     *
		     * @param {WordArray|string} message The message to hash.
		     *
		     * @return {WordArray} The hash.
		     *
		     * @static
		     *
		     * @example
		     *
		     *     var hash = CryptoJS.SHA256('message');
		     *     var hash = CryptoJS.SHA256(wordArray);
		     */
		    C.SHA256 = Hasher._createHelper(SHA256);
	
		    /**
		     * Shortcut function to the HMAC's object interface.
		     *
		     * @param {WordArray|string} message The message to hash.
		     * @param {WordArray|string} key The secret key.
		     *
		     * @return {WordArray} The HMAC.
		     *
		     * @static
		     *
		     * @example
		     *
		     *     var hmac = CryptoJS.HmacSHA256(message, key);
		     */
		    C.HmacSHA256 = Hasher._createHmacHelper(SHA256);
		}(Math));
	
	
		return CryptoJS.SHA256;
	
	}));

/***/ },
/* 327 */
/***/ function(module, exports, __webpack_require__) {

	;(function (root, factory, undef) {
		if (true) {
			// CommonJS
			module.exports = exports = factory(__webpack_require__(25), __webpack_require__(169));
		}
		else if (typeof define === "function" && define.amd) {
			// AMD
			define(["./core", "./x64-core"], factory);
		}
		else {
			// Global (browser)
			factory(root.CryptoJS);
		}
	}(this, function (CryptoJS) {
	
		(function () {
		    // Shortcuts
		    var C = CryptoJS;
		    var C_lib = C.lib;
		    var Hasher = C_lib.Hasher;
		    var C_x64 = C.x64;
		    var X64Word = C_x64.Word;
		    var X64WordArray = C_x64.WordArray;
		    var C_algo = C.algo;
	
		    function X64Word_create() {
		        return X64Word.create.apply(X64Word, arguments);
		    }
	
		    // Constants
		    var K = [
		        X64Word_create(0x428a2f98, 0xd728ae22), X64Word_create(0x71374491, 0x23ef65cd),
		        X64Word_create(0xb5c0fbcf, 0xec4d3b2f), X64Word_create(0xe9b5dba5, 0x8189dbbc),
		        X64Word_create(0x3956c25b, 0xf348b538), X64Word_create(0x59f111f1, 0xb605d019),
		        X64Word_create(0x923f82a4, 0xaf194f9b), X64Word_create(0xab1c5ed5, 0xda6d8118),
		        X64Word_create(0xd807aa98, 0xa3030242), X64Word_create(0x12835b01, 0x45706fbe),
		        X64Word_create(0x243185be, 0x4ee4b28c), X64Word_create(0x550c7dc3, 0xd5ffb4e2),
		        X64Word_create(0x72be5d74, 0xf27b896f), X64Word_create(0x80deb1fe, 0x3b1696b1),
		        X64Word_create(0x9bdc06a7, 0x25c71235), X64Word_create(0xc19bf174, 0xcf692694),
		        X64Word_create(0xe49b69c1, 0x9ef14ad2), X64Word_create(0xefbe4786, 0x384f25e3),
		        X64Word_create(0x0fc19dc6, 0x8b8cd5b5), X64Word_create(0x240ca1cc, 0x77ac9c65),
		        X64Word_create(0x2de92c6f, 0x592b0275), X64Word_create(0x4a7484aa, 0x6ea6e483),
		        X64Word_create(0x5cb0a9dc, 0xbd41fbd4), X64Word_create(0x76f988da, 0x831153b5),
		        X64Word_create(0x983e5152, 0xee66dfab), X64Word_create(0xa831c66d, 0x2db43210),
		        X64Word_create(0xb00327c8, 0x98fb213f), X64Word_create(0xbf597fc7, 0xbeef0ee4),
		        X64Word_create(0xc6e00bf3, 0x3da88fc2), X64Word_create(0xd5a79147, 0x930aa725),
		        X64Word_create(0x06ca6351, 0xe003826f), X64Word_create(0x14292967, 0x0a0e6e70),
		        X64Word_create(0x27b70a85, 0x46d22ffc), X64Word_create(0x2e1b2138, 0x5c26c926),
		        X64Word_create(0x4d2c6dfc, 0x5ac42aed), X64Word_create(0x53380d13, 0x9d95b3df),
		        X64Word_create(0x650a7354, 0x8baf63de), X64Word_create(0x766a0abb, 0x3c77b2a8),
		        X64Word_create(0x81c2c92e, 0x47edaee6), X64Word_create(0x92722c85, 0x1482353b),
		        X64Word_create(0xa2bfe8a1, 0x4cf10364), X64Word_create(0xa81a664b, 0xbc423001),
		        X64Word_create(0xc24b8b70, 0xd0f89791), X64Word_create(0xc76c51a3, 0x0654be30),
		        X64Word_create(0xd192e819, 0xd6ef5218), X64Word_create(0xd6990624, 0x5565a910),
		        X64Word_create(0xf40e3585, 0x5771202a), X64Word_create(0x106aa070, 0x32bbd1b8),
		        X64Word_create(0x19a4c116, 0xb8d2d0c8), X64Word_create(0x1e376c08, 0x5141ab53),
		        X64Word_create(0x2748774c, 0xdf8eeb99), X64Word_create(0x34b0bcb5, 0xe19b48a8),
		        X64Word_create(0x391c0cb3, 0xc5c95a63), X64Word_create(0x4ed8aa4a, 0xe3418acb),
		        X64Word_create(0x5b9cca4f, 0x7763e373), X64Word_create(0x682e6ff3, 0xd6b2b8a3),
		        X64Word_create(0x748f82ee, 0x5defb2fc), X64Word_create(0x78a5636f, 0x43172f60),
		        X64Word_create(0x84c87814, 0xa1f0ab72), X64Word_create(0x8cc70208, 0x1a6439ec),
		        X64Word_create(0x90befffa, 0x23631e28), X64Word_create(0xa4506ceb, 0xde82bde9),
		        X64Word_create(0xbef9a3f7, 0xb2c67915), X64Word_create(0xc67178f2, 0xe372532b),
		        X64Word_create(0xca273ece, 0xea26619c), X64Word_create(0xd186b8c7, 0x21c0c207),
		        X64Word_create(0xeada7dd6, 0xcde0eb1e), X64Word_create(0xf57d4f7f, 0xee6ed178),
		        X64Word_create(0x06f067aa, 0x72176fba), X64Word_create(0x0a637dc5, 0xa2c898a6),
		        X64Word_create(0x113f9804, 0xbef90dae), X64Word_create(0x1b710b35, 0x131c471b),
		        X64Word_create(0x28db77f5, 0x23047d84), X64Word_create(0x32caab7b, 0x40c72493),
		        X64Word_create(0x3c9ebe0a, 0x15c9bebc), X64Word_create(0x431d67c4, 0x9c100d4c),
		        X64Word_create(0x4cc5d4be, 0xcb3e42b6), X64Word_create(0x597f299c, 0xfc657e2a),
		        X64Word_create(0x5fcb6fab, 0x3ad6faec), X64Word_create(0x6c44198c, 0x4a475817)
		    ];
	
		    // Reusable objects
		    var W = [];
		    (function () {
		        for (var i = 0; i < 80; i++) {
		            W[i] = X64Word_create();
		        }
		    }());
	
		    /**
		     * SHA-512 hash algorithm.
		     */
		    var SHA512 = C_algo.SHA512 = Hasher.extend({
		        _doReset: function () {
		            this._hash = new X64WordArray.init([
		                new X64Word.init(0x6a09e667, 0xf3bcc908), new X64Word.init(0xbb67ae85, 0x84caa73b),
		                new X64Word.init(0x3c6ef372, 0xfe94f82b), new X64Word.init(0xa54ff53a, 0x5f1d36f1),
		                new X64Word.init(0x510e527f, 0xade682d1), new X64Word.init(0x9b05688c, 0x2b3e6c1f),
		                new X64Word.init(0x1f83d9ab, 0xfb41bd6b), new X64Word.init(0x5be0cd19, 0x137e2179)
		            ]);
		        },
	
		        _doProcessBlock: function (M, offset) {
		            // Shortcuts
		            var H = this._hash.words;
	
		            var H0 = H[0];
		            var H1 = H[1];
		            var H2 = H[2];
		            var H3 = H[3];
		            var H4 = H[4];
		            var H5 = H[5];
		            var H6 = H[6];
		            var H7 = H[7];
	
		            var H0h = H0.high;
		            var H0l = H0.low;
		            var H1h = H1.high;
		            var H1l = H1.low;
		            var H2h = H2.high;
		            var H2l = H2.low;
		            var H3h = H3.high;
		            var H3l = H3.low;
		            var H4h = H4.high;
		            var H4l = H4.low;
		            var H5h = H5.high;
		            var H5l = H5.low;
		            var H6h = H6.high;
		            var H6l = H6.low;
		            var H7h = H7.high;
		            var H7l = H7.low;
	
		            // Working variables
		            var ah = H0h;
		            var al = H0l;
		            var bh = H1h;
		            var bl = H1l;
		            var ch = H2h;
		            var cl = H2l;
		            var dh = H3h;
		            var dl = H3l;
		            var eh = H4h;
		            var el = H4l;
		            var fh = H5h;
		            var fl = H5l;
		            var gh = H6h;
		            var gl = H6l;
		            var hh = H7h;
		            var hl = H7l;
	
		            // Rounds
		            for (var i = 0; i < 80; i++) {
		                // Shortcut
		                var Wi = W[i];
	
		                // Extend message
		                if (i < 16) {
		                    var Wih = Wi.high = M[offset + i * 2]     | 0;
		                    var Wil = Wi.low  = M[offset + i * 2 + 1] | 0;
		                } else {
		                    // Gamma0
		                    var gamma0x  = W[i - 15];
		                    var gamma0xh = gamma0x.high;
		                    var gamma0xl = gamma0x.low;
		                    var gamma0h  = ((gamma0xh >>> 1) | (gamma0xl << 31)) ^ ((gamma0xh >>> 8) | (gamma0xl << 24)) ^ (gamma0xh >>> 7);
		                    var gamma0l  = ((gamma0xl >>> 1) | (gamma0xh << 31)) ^ ((gamma0xl >>> 8) | (gamma0xh << 24)) ^ ((gamma0xl >>> 7) | (gamma0xh << 25));
	
		                    // Gamma1
		                    var gamma1x  = W[i - 2];
		                    var gamma1xh = gamma1x.high;
		                    var gamma1xl = gamma1x.low;
		                    var gamma1h  = ((gamma1xh >>> 19) | (gamma1xl << 13)) ^ ((gamma1xh << 3) | (gamma1xl >>> 29)) ^ (gamma1xh >>> 6);
		                    var gamma1l  = ((gamma1xl >>> 19) | (gamma1xh << 13)) ^ ((gamma1xl << 3) | (gamma1xh >>> 29)) ^ ((gamma1xl >>> 6) | (gamma1xh << 26));
	
		                    // W[i] = gamma0 + W[i - 7] + gamma1 + W[i - 16]
		                    var Wi7  = W[i - 7];
		                    var Wi7h = Wi7.high;
		                    var Wi7l = Wi7.low;
	
		                    var Wi16  = W[i - 16];
		                    var Wi16h = Wi16.high;
		                    var Wi16l = Wi16.low;
	
		                    var Wil = gamma0l + Wi7l;
		                    var Wih = gamma0h + Wi7h + ((Wil >>> 0) < (gamma0l >>> 0) ? 1 : 0);
		                    var Wil = Wil + gamma1l;
		                    var Wih = Wih + gamma1h + ((Wil >>> 0) < (gamma1l >>> 0) ? 1 : 0);
		                    var Wil = Wil + Wi16l;
		                    var Wih = Wih + Wi16h + ((Wil >>> 0) < (Wi16l >>> 0) ? 1 : 0);
	
		                    Wi.high = Wih;
		                    Wi.low  = Wil;
		                }
	
		                var chh  = (eh & fh) ^ (~eh & gh);
		                var chl  = (el & fl) ^ (~el & gl);
		                var majh = (ah & bh) ^ (ah & ch) ^ (bh & ch);
		                var majl = (al & bl) ^ (al & cl) ^ (bl & cl);
	
		                var sigma0h = ((ah >>> 28) | (al << 4))  ^ ((ah << 30)  | (al >>> 2)) ^ ((ah << 25) | (al >>> 7));
		                var sigma0l = ((al >>> 28) | (ah << 4))  ^ ((al << 30)  | (ah >>> 2)) ^ ((al << 25) | (ah >>> 7));
		                var sigma1h = ((eh >>> 14) | (el << 18)) ^ ((eh >>> 18) | (el << 14)) ^ ((eh << 23) | (el >>> 9));
		                var sigma1l = ((el >>> 14) | (eh << 18)) ^ ((el >>> 18) | (eh << 14)) ^ ((el << 23) | (eh >>> 9));
	
		                // t1 = h + sigma1 + ch + K[i] + W[i]
		                var Ki  = K[i];
		                var Kih = Ki.high;
		                var Kil = Ki.low;
	
		                var t1l = hl + sigma1l;
		                var t1h = hh + sigma1h + ((t1l >>> 0) < (hl >>> 0) ? 1 : 0);
		                var t1l = t1l + chl;
		                var t1h = t1h + chh + ((t1l >>> 0) < (chl >>> 0) ? 1 : 0);
		                var t1l = t1l + Kil;
		                var t1h = t1h + Kih + ((t1l >>> 0) < (Kil >>> 0) ? 1 : 0);
		                var t1l = t1l + Wil;
		                var t1h = t1h + Wih + ((t1l >>> 0) < (Wil >>> 0) ? 1 : 0);
	
		                // t2 = sigma0 + maj
		                var t2l = sigma0l + majl;
		                var t2h = sigma0h + majh + ((t2l >>> 0) < (sigma0l >>> 0) ? 1 : 0);
	
		                // Update working variables
		                hh = gh;
		                hl = gl;
		                gh = fh;
		                gl = fl;
		                fh = eh;
		                fl = el;
		                el = (dl + t1l) | 0;
		                eh = (dh + t1h + ((el >>> 0) < (dl >>> 0) ? 1 : 0)) | 0;
		                dh = ch;
		                dl = cl;
		                ch = bh;
		                cl = bl;
		                bh = ah;
		                bl = al;
		                al = (t1l + t2l) | 0;
		                ah = (t1h + t2h + ((al >>> 0) < (t1l >>> 0) ? 1 : 0)) | 0;
		            }
	
		            // Intermediate hash value
		            H0l = H0.low  = (H0l + al);
		            H0.high = (H0h + ah + ((H0l >>> 0) < (al >>> 0) ? 1 : 0));
		            H1l = H1.low  = (H1l + bl);
		            H1.high = (H1h + bh + ((H1l >>> 0) < (bl >>> 0) ? 1 : 0));
		            H2l = H2.low  = (H2l + cl);
		            H2.high = (H2h + ch + ((H2l >>> 0) < (cl >>> 0) ? 1 : 0));
		            H3l = H3.low  = (H3l + dl);
		            H3.high = (H3h + dh + ((H3l >>> 0) < (dl >>> 0) ? 1 : 0));
		            H4l = H4.low  = (H4l + el);
		            H4.high = (H4h + eh + ((H4l >>> 0) < (el >>> 0) ? 1 : 0));
		            H5l = H5.low  = (H5l + fl);
		            H5.high = (H5h + fh + ((H5l >>> 0) < (fl >>> 0) ? 1 : 0));
		            H6l = H6.low  = (H6l + gl);
		            H6.high = (H6h + gh + ((H6l >>> 0) < (gl >>> 0) ? 1 : 0));
		            H7l = H7.low  = (H7l + hl);
		            H7.high = (H7h + hh + ((H7l >>> 0) < (hl >>> 0) ? 1 : 0));
		        },
	
		        _doFinalize: function () {
		            // Shortcuts
		            var data = this._data;
		            var dataWords = data.words;
	
		            var nBitsTotal = this._nDataBytes * 8;
		            var nBitsLeft = data.sigBytes * 8;
	
		            // Add padding
		            dataWords[nBitsLeft >>> 5] |= 0x80 << (24 - nBitsLeft % 32);
		            dataWords[(((nBitsLeft + 128) >>> 10) << 5) + 30] = Math.floor(nBitsTotal / 0x100000000);
		            dataWords[(((nBitsLeft + 128) >>> 10) << 5) + 31] = nBitsTotal;
		            data.sigBytes = dataWords.length * 4;
	
		            // Hash final blocks
		            this._process();
	
		            // Convert hash to 32-bit word array before returning
		            var hash = this._hash.toX32();
	
		            // Return final computed hash
		            return hash;
		        },
	
		        clone: function () {
		            var clone = Hasher.clone.call(this);
		            clone._hash = this._hash.clone();
	
		            return clone;
		        },
	
		        blockSize: 1024/32
		    });
	
		    /**
		     * Shortcut function to the hasher's object interface.
		     *
		     * @param {WordArray|string} message The message to hash.
		     *
		     * @return {WordArray} The hash.
		     *
		     * @static
		     *
		     * @example
		     *
		     *     var hash = CryptoJS.SHA512('message');
		     *     var hash = CryptoJS.SHA512(wordArray);
		     */
		    C.SHA512 = Hasher._createHelper(SHA512);
	
		    /**
		     * Shortcut function to the HMAC's object interface.
		     *
		     * @param {WordArray|string} message The message to hash.
		     * @param {WordArray|string} key The secret key.
		     *
		     * @return {WordArray} The HMAC.
		     *
		     * @static
		     *
		     * @example
		     *
		     *     var hmac = CryptoJS.HmacSHA512(message, key);
		     */
		    C.HmacSHA512 = Hasher._createHmacHelper(SHA512);
		}());
	
	
		return CryptoJS.SHA512;
	
	}));

/***/ },
/* 328 */
/***/ function(module, exports) {

	module.exports = function escape(url) {
	    if (typeof url !== 'string') {
	        return url
	    }
	    // If url is already wrapped in quotes, remove them
	    if (/^['"].*['"]$/.test(url)) {
	        url = url.slice(1, -1);
	    }
	    // Should url be wrapped?
	    // See https://drafts.csswg.org/css-values-3/#urls
	    if (/["'() \t\n]/.test(url)) {
	        return '"' + url.replace(/"/g, '\\"').replace(/\n/g, '\\n') + '"'
	    }
	
	    return url
	}


/***/ },
/* 329 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 */
	
	var emptyFunction = __webpack_require__(80);
	
	/**
	 * Upstream version of event listener. Does not take into account specific
	 * nature of platform.
	 */
	var EventListener = {
	  /**
	   * Listen to DOM events during the bubble phase.
	   *
	   * @param {DOMEventTarget} target DOM element to register listener on.
	   * @param {string} eventType Event type, e.g. 'click' or 'mouseover'.
	   * @param {function} callback Callback function.
	   * @return {object} Object with a `remove` method.
	   */
	  listen: function listen(target, eventType, callback) {
	    if (target.addEventListener) {
	      target.addEventListener(eventType, callback, false);
	      return {
	        remove: function remove() {
	          target.removeEventListener(eventType, callback, false);
	        }
	      };
	    } else if (target.attachEvent) {
	      target.attachEvent('on' + eventType, callback);
	      return {
	        remove: function remove() {
	          target.detachEvent('on' + eventType, callback);
	        }
	      };
	    }
	  },
	
	  /**
	   * Listen to DOM events during the capture phase.
	   *
	   * @param {DOMEventTarget} target DOM element to register listener on.
	   * @param {string} eventType Event type, e.g. 'click' or 'mouseover'.
	   * @param {function} callback Callback function.
	   * @return {object} Object with a `remove` method.
	   */
	  capture: function capture(target, eventType, callback) {
	    if (target.addEventListener) {
	      target.addEventListener(eventType, callback, true);
	      return {
	        remove: function remove() {
	          target.removeEventListener(eventType, callback, true);
	        }
	      };
	    } else {
	      if (false) {
	        console.error('Attempted to listen to events during the capture phase on a ' + 'browser that does not support the capture phase. Your application ' + 'will not receive some events.');
	      }
	      return {
	        remove: emptyFunction
	      };
	    }
	  },
	
	  registerDefault: function registerDefault() {}
	};
	
	module.exports = EventListener;

/***/ },
/* 330 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	/**
	 * @param {DOMElement} node input/textarea to focus
	 */
	
	function focusNode(node) {
	  // IE8 can throw "Can't move focus to the control because it is invisible,
	  // not enabled, or of a type that does not accept the focus." for all kinds of
	  // reasons that are too expensive and fragile to test.
	  try {
	    node.focus();
	  } catch (e) {}
	}
	
	module.exports = focusNode;

/***/ },
/* 331 */
/***/ function(module, exports) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 */
	
	/* eslint-disable fb-www/typeof-undefined */
	
	/**
	 * Same as document.activeElement but wraps in a try-catch block. In IE it is
	 * not safe to call document.activeElement if there is nothing focused.
	 *
	 * The activeElement will be null only if the document or document body is not
	 * yet defined.
	 *
	 * @param {?DOMDocument} doc Defaults to current document.
	 * @return {?DOMElement}
	 */
	function getActiveElement(doc) /*?DOMElement*/{
	  doc = doc || (typeof document !== 'undefined' ? document : undefined);
	  if (typeof doc === 'undefined') {
	    return null;
	  }
	  try {
	    return doc.activeElement || doc.body;
	  } catch (e) {
	    return doc.body;
	  }
	}
	
	module.exports = getActiveElement;

/***/ },
/* 332 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "assets/fonts/glyphicons-halflings-regular.eot";

/***/ },
/* 333 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "assets/fonts/FWDCircularVietWeb-Black.eot";

/***/ },
/* 334 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "assets/fonts/FWDCircularVietWeb-BlackItalic.eot";

/***/ },
/* 335 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "assets/fonts/FWDCircularVietWeb-Bold.eot";

/***/ },
/* 336 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "assets/fonts/FWDCircularVietWeb-BoldItalic.eot";

/***/ },
/* 337 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "assets/fonts/FWDCircularVietWeb-Book.eot";

/***/ },
/* 338 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "assets/fonts/FWDCircularVietWeb-BookItalic.eot";

/***/ },
/* 339 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "assets/fonts/FWDCircularVietWeb-Medium.eot";

/***/ },
/* 340 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "assets/fonts/FWDCircularVietWeb-MediumItalic.eot";

/***/ },
/* 341 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "assets/fonts/FWDCircularWeb-Black.eot";

/***/ },
/* 342 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "assets/fonts/FWDCircularWeb-BlackItalic.eot";

/***/ },
/* 343 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "assets/fonts/FWDCircularWeb-Bold.eot";

/***/ },
/* 344 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "assets/fonts/FWDCircularWeb-BoldItalic.eot";

/***/ },
/* 345 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "assets/fonts/FWDCircularWeb-Book.eot";

/***/ },
/* 346 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "assets/fonts/FWDCircularWeb-BookItalic.eot";

/***/ },
/* 347 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "assets/fonts/FWDCircularWeb-Medium.eot";

/***/ },
/* 348 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "assets/fonts/FWDCircularWeb-MediumItalic.eot";

/***/ },
/* 349 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "assets/fonts/Guroo-Producer.eot";

/***/ },
/* 350 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "json/version.json";

/***/ },
/* 351 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(global) {/*!
	 * VERSION: 1.20.5
	 * DATE: 2018-05-21
	 * UPDATES AND DOCS AT: http://greensock.com
	 *
	 * @license Copyright (c) 2008-2018, GreenSock. All rights reserved.
	 * This work is subject to the terms at http://greensock.com/standard-license or for
	 * Club GreenSock members, the software agreement that was issued with your membership.
	 * 
	 * @author: Jack Doyle, jack@greensock.com
	 */
	var _gsScope = (typeof(module) !== "undefined" && module.exports && typeof(global) !== "undefined") ? global : this || window; //helps ensure compatibility with AMD/RequireJS and CommonJS/Node
	(_gsScope._gsQueue || (_gsScope._gsQueue = [])).push( function() {
	
		"use strict";
	
		_gsScope._gsDefine("plugins.CSSPlugin", ["plugins.TweenPlugin","TweenLite"], function(TweenPlugin, TweenLite) {
	
			/** @constructor **/
			var CSSPlugin = function() {
					TweenPlugin.call(this, "css");
					this._overwriteProps.length = 0;
					this.setRatio = CSSPlugin.prototype.setRatio; //speed optimization (avoid prototype lookup on this "hot" method)
				},
				_globals = _gsScope._gsDefine.globals,
				_hasPriority, //turns true whenever a CSSPropTween instance is created that has a priority other than 0. This helps us discern whether or not we should spend the time organizing the linked list or not after a CSSPlugin's _onInitTween() method is called.
				_suffixMap, //we set this in _onInitTween() each time as a way to have a persistent variable we can use in other methods like _parse() without having to pass it around as a parameter and we keep _parse() decoupled from a particular CSSPlugin instance
				_cs, //computed style (we store this in a shared variable to conserve memory and make minification tighter
				_overwriteProps, //alias to the currently instantiating CSSPlugin's _overwriteProps array. We use this closure in order to avoid having to pass a reference around from method to method and aid in minification.
				_specialProps = {},
				p = CSSPlugin.prototype = new TweenPlugin("css");
	
			p.constructor = CSSPlugin;
			CSSPlugin.version = "1.20.5";
			CSSPlugin.API = 2;
			CSSPlugin.defaultTransformPerspective = 0;
			CSSPlugin.defaultSkewType = "compensated";
			CSSPlugin.defaultSmoothOrigin = true;
			p = "px"; //we'll reuse the "p" variable to keep file size down
			CSSPlugin.suffixMap = {top:p, right:p, bottom:p, left:p, width:p, height:p, fontSize:p, padding:p, margin:p, perspective:p, lineHeight:""};
	
	
			var _numExp = /(?:\-|\.|\b)(\d|\.|e\-)+/g,
				_relNumExp = /(?:\d|\-\d|\.\d|\-\.\d|\+=\d|\-=\d|\+=.\d|\-=\.\d)+/g,
				_valuesExp = /(?:\+=|\-=|\-|\b)[\d\-\.]+[a-zA-Z0-9]*(?:%|\b)/gi, //finds all the values that begin with numbers or += or -= and then a number. Includes suffixes. We use this to split complex values apart like "1px 5px 20px rgb(255,102,51)"
				_NaNExp = /(?![+-]?\d*\.?\d+|[+-]|e[+-]\d+)[^0-9]/g, //also allows scientific notation and doesn't kill the leading -/+ in -= and +=
				_suffixExp = /(?:\d|\-|\+|=|#|\.)*/g,
				_opacityExp = /opacity *= *([^)]*)/i,
				_opacityValExp = /opacity:([^;]*)/i,
				_alphaFilterExp = /alpha\(opacity *=.+?\)/i,
				_rgbhslExp = /^(rgb|hsl)/,
				_capsExp = /([A-Z])/g,
				_camelExp = /-([a-z])/gi,
				_urlExp = /(^(?:url\(\"|url\())|(?:(\"\))$|\)$)/gi, //for pulling out urls from url(...) or url("...") strings (some browsers wrap urls in quotes, some don't when reporting things like backgroundImage)
				_camelFunc = function(s, g) { return g.toUpperCase(); },
				_horizExp = /(?:Left|Right|Width)/i,
				_ieGetMatrixExp = /(M11|M12|M21|M22)=[\d\-\.e]+/gi,
				_ieSetMatrixExp = /progid\:DXImageTransform\.Microsoft\.Matrix\(.+?\)/i,
				_commasOutsideParenExp = /,(?=[^\)]*(?:\(|$))/gi, //finds any commas that are not within parenthesis
				_complexExp = /[\s,\(]/i, //for testing a string to find if it has a space, comma, or open parenthesis (clues that it's a complex value)
				_DEG2RAD = Math.PI / 180,
				_RAD2DEG = 180 / Math.PI,
				_forcePT = {},
				_dummyElement = {style:{}},
				_doc = _gsScope.document || {createElement: function() {return _dummyElement;}},
				_createElement = function(type, ns) {
					return _doc.createElementNS ? _doc.createElementNS(ns || "http://www.w3.org/1999/xhtml", type) : _doc.createElement(type);
				},
				_tempDiv = _createElement("div"),
				_tempImg = _createElement("img"),
				_internals = CSSPlugin._internals = {_specialProps:_specialProps}, //provides a hook to a few internal methods that we need to access from inside other plugins
				_agent = (_gsScope.navigator || {}).userAgent || "",
				_autoRound,
				_reqSafariFix, //we won't apply the Safari transform fix until we actually come across a tween that affects a transform property (to maintain best performance).
	
				_isSafari,
				_isFirefox, //Firefox has a bug that causes 3D transformed elements to randomly disappear unless a repaint is forced after each update on each element.
				_isSafariLT6, //Safari (and Android 4 which uses a flavor of Safari) has a bug that prevents changes to "top" and "left" properties from rendering properly if changed on the same frame as a transform UNLESS we set the element's WebkitBackfaceVisibility to hidden (weird, I know). Doing this for Android 3 and earlier seems to actually cause other problems, though (fun!)
				_ieVers,
				_supportsOpacity = (function() { //we set _isSafari, _ieVers, _isFirefox, and _supportsOpacity all in one function here to reduce file size slightly, especially in the minified version.
					var i = _agent.indexOf("Android"),
						a = _createElement("a");
					_isSafari = (_agent.indexOf("Safari") !== -1 && _agent.indexOf("Chrome") === -1 && (i === -1 || parseFloat(_agent.substr(i+8, 2)) > 3));
					_isSafariLT6 = (_isSafari && (parseFloat(_agent.substr(_agent.indexOf("Version/")+8, 2)) < 6));
					_isFirefox = (_agent.indexOf("Firefox") !== -1);
					if ((/MSIE ([0-9]{1,}[\.0-9]{0,})/).exec(_agent) || (/Trident\/.*rv:([0-9]{1,}[\.0-9]{0,})/).exec(_agent)) {
						_ieVers = parseFloat( RegExp.$1 );
					}
					if (!a) {
						return false;
					}
					a.style.cssText = "top:1px;opacity:.55;";
					return /^0.55/.test(a.style.opacity);
				}()),
				_getIEOpacity = function(v) {
					return (_opacityExp.test( ((typeof(v) === "string") ? v : (v.currentStyle ? v.currentStyle.filter : v.style.filter) || "") ) ? ( parseFloat( RegExp.$1 ) / 100 ) : 1);
				},
				_log = function(s) {//for logging messages, but in a way that won't throw errors in old versions of IE.
					if (_gsScope.console) {
						console.log(s);
					}
				},
				_target, //when initting a CSSPlugin, we set this variable so that we can access it from within many other functions without having to pass it around as params
				_index, //when initting a CSSPlugin, we set this variable so that we can access it from within many other functions without having to pass it around as params
	
				_prefixCSS = "", //the non-camelCase vendor prefix like "-o-", "-moz-", "-ms-", or "-webkit-"
				_prefix = "", //camelCase vendor prefix like "O", "ms", "Webkit", or "Moz".
	
				// @private feed in a camelCase property name like "transform" and it will check to see if it is valid as-is or if it needs a vendor prefix. It returns the corrected camelCase property name (i.e. "WebkitTransform" or "MozTransform" or "transform" or null if no such property is found, like if the browser is IE8 or before, "transform" won't be found at all)
				_checkPropPrefix = function(p, e) {
					e = e || _tempDiv;
					var s = e.style,
						a, i;
					if (s[p] !== undefined) {
						return p;
					}
					p = p.charAt(0).toUpperCase() + p.substr(1);
					a = ["O","Moz","ms","Ms","Webkit"];
					i = 5;
					while (--i > -1 && s[a[i]+p] === undefined) { }
					if (i >= 0) {
						_prefix = (i === 3) ? "ms" : a[i];
						_prefixCSS = "-" + _prefix.toLowerCase() + "-";
						return _prefix + p;
					}
					return null;
				},
	
				_getComputedStyle = (typeof(window) !== "undefined" ? window : _doc.defaultView || {getComputedStyle:function() {}}).getComputedStyle,
	
				/**
				 * @private Returns the css style for a particular property of an element. For example, to get whatever the current "left" css value for an element with an ID of "myElement", you could do:
				 * var currentLeft = CSSPlugin.getStyle( document.getElementById("myElement"), "left");
				 *
				 * @param {!Object} t Target element whose style property you want to query
				 * @param {!string} p Property name (like "left" or "top" or "marginTop", etc.)
				 * @param {Object=} cs Computed style object. This just provides a way to speed processing if you're going to get several properties on the same element in quick succession - you can reuse the result of the getComputedStyle() call.
				 * @param {boolean=} calc If true, the value will not be read directly from the element's "style" property (if it exists there), but instead the getComputedStyle() result will be used. This can be useful when you want to ensure that the browser itself is interpreting the value.
				 * @param {string=} dflt Default value that should be returned in the place of null, "none", "auto" or "auto auto".
				 * @return {?string} The current property value
				 */
				_getStyle = CSSPlugin.getStyle = function(t, p, cs, calc, dflt) {
					var rv;
					if (!_supportsOpacity) if (p === "opacity") { //several versions of IE don't use the standard "opacity" property - they use things like filter:alpha(opacity=50), so we parse that here.
						return _getIEOpacity(t);
					}
					if (!calc && t.style[p]) {
						rv = t.style[p];
					} else if ((cs = cs || _getComputedStyle(t))) {
						rv = cs[p] || cs.getPropertyValue(p) || cs.getPropertyValue(p.replace(_capsExp, "-$1").toLowerCase());
					} else if (t.currentStyle) {
						rv = t.currentStyle[p];
					}
					return (dflt != null && (!rv || rv === "none" || rv === "auto" || rv === "auto auto")) ? dflt : rv;
				},
	
				/**
				 * @private Pass the target element, the property name, the numeric value, and the suffix (like "%", "em", "px", etc.) and it will spit back the equivalent pixel number.
				 * @param {!Object} t Target element
				 * @param {!string} p Property name (like "left", "top", "marginLeft", etc.)
				 * @param {!number} v Value
				 * @param {string=} sfx Suffix (like "px" or "%" or "em")
				 * @param {boolean=} recurse If true, the call is a recursive one. In some browsers (like IE7/8), occasionally the value isn't accurately reported initially, but if we run the function again it will take effect.
				 * @return {number} value in pixels
				 */
				_convertToPixels = _internals.convertToPixels = function(t, p, v, sfx, recurse) {
					if (sfx === "px" || (!sfx && p !== "lineHeight")) { return v; }
					if (sfx === "auto" || !v) { return 0; }
					var horiz = _horizExp.test(p),
						node = t,
						style = _tempDiv.style,
						neg = (v < 0),
						precise = (v === 1),
						pix, cache, time;
					if (neg) {
						v = -v;
					}
					if (precise) {
						v *= 100;
					}
					if (p === "lineHeight" && !sfx) { //special case of when a simple lineHeight (without a unit) is used. Set it to the value, read back the computed value, and then revert.
						cache = _getComputedStyle(t).lineHeight;
						t.style.lineHeight = v;
						pix = parseFloat(_getComputedStyle(t).lineHeight);
						t.style.lineHeight = cache;
					} else if (sfx === "%" && p.indexOf("border") !== -1) {
						pix = (v / 100) * (horiz ? t.clientWidth : t.clientHeight);
					} else {
						style.cssText = "border:0 solid red;position:" + _getStyle(t, "position") + ";line-height:0;";
						if (sfx === "%" || !node.appendChild || sfx.charAt(0) === "v" || sfx === "rem") {
							node = t.parentNode || _doc.body;
							if (_getStyle(node, "display").indexOf("flex") !== -1) { //Edge and IE11 have a bug that causes offsetWidth to report as 0 if the container has display:flex and the child is position:relative. Switching to position: absolute solves it.
								style.position = "absolute";
							}
							cache = node._gsCache;
							time = TweenLite.ticker.frame;
							if (cache && horiz && cache.time === time) { //performance optimization: we record the width of elements along with the ticker frame so that we can quickly get it again on the same tick (seems relatively safe to assume it wouldn't change on the same tick)
								return cache.width * v / 100;
							}
							style[(horiz ? "width" : "height")] = v + sfx;
						} else {
							style[(horiz ? "borderLeftWidth" : "borderTopWidth")] = v + sfx;
						}
						node.appendChild(_tempDiv);
						pix = parseFloat(_tempDiv[(horiz ? "offsetWidth" : "offsetHeight")]);
						node.removeChild(_tempDiv);
						if (horiz && sfx === "%" && CSSPlugin.cacheWidths !== false) {
							cache = node._gsCache = node._gsCache || {};
							cache.time = time;
							cache.width = pix / v * 100;
						}
						if (pix === 0 && !recurse) {
							pix = _convertToPixels(t, p, v, sfx, true);
						}
					}
					if (precise) {
						pix /= 100;
					}
					return neg ? -pix : pix;
				},
				_calculateOffset = _internals.calculateOffset = function(t, p, cs) { //for figuring out "top" or "left" in px when it's "auto". We need to factor in margin with the offsetLeft/offsetTop
					if (_getStyle(t, "position", cs) !== "absolute") { return 0; }
					var dim = ((p === "left") ? "Left" : "Top"),
						v = _getStyle(t, "margin" + dim, cs);
					return t["offset" + dim] - (_convertToPixels(t, p, parseFloat(v), v.replace(_suffixExp, "")) || 0);
				},
	
				// @private returns at object containing ALL of the style properties in camelCase and their associated values.
				_getAllStyles = function(t, cs) {
					var s = {},
						i, tr, p;
					if ((cs = cs || _getComputedStyle(t, null))) {
						if ((i = cs.length)) {
							while (--i > -1) {
								p = cs[i];
								if (p.indexOf("-transform") === -1 || _transformPropCSS === p) { //Some webkit browsers duplicate transform values, one non-prefixed and one prefixed ("transform" and "WebkitTransform"), so we must weed out the extra one here.
									s[p.replace(_camelExp, _camelFunc)] = cs.getPropertyValue(p);
								}
							}
						} else { //some browsers behave differently - cs.length is always 0, so we must do a for...in loop.
							for (i in cs) {
								if (i.indexOf("Transform") === -1 || _transformProp === i) { //Some webkit browsers duplicate transform values, one non-prefixed and one prefixed ("transform" and "WebkitTransform"), so we must weed out the extra one here.
									s[i] = cs[i];
								}
							}
						}
					} else if ((cs = t.currentStyle || t.style)) {
						for (i in cs) {
							if (typeof(i) === "string" && s[i] === undefined) {
								s[i.replace(_camelExp, _camelFunc)] = cs[i];
							}
						}
					}
					if (!_supportsOpacity) {
						s.opacity = _getIEOpacity(t);
					}
					tr = _getTransform(t, cs, false);
					s.rotation = tr.rotation;
					s.skewX = tr.skewX;
					s.scaleX = tr.scaleX;
					s.scaleY = tr.scaleY;
					s.x = tr.x;
					s.y = tr.y;
					if (_supports3D) {
						s.z = tr.z;
						s.rotationX = tr.rotationX;
						s.rotationY = tr.rotationY;
						s.scaleZ = tr.scaleZ;
					}
					if (s.filters) {
						delete s.filters;
					}
					return s;
				},
	
				// @private analyzes two style objects (as returned by _getAllStyles()) and only looks for differences between them that contain tweenable values (like a number or color). It returns an object with a "difs" property which refers to an object containing only those isolated properties and values for tweening, and a "firstMPT" property which refers to the first MiniPropTween instance in a linked list that recorded all the starting values of the different properties so that we can revert to them at the end or beginning of the tween - we don't want the cascading to get messed up. The forceLookup parameter is an optional generic object with properties that should be forced into the results - this is necessary for className tweens that are overwriting others because imagine a scenario where a rollover/rollout adds/removes a class and the user swipes the mouse over the target SUPER fast, thus nothing actually changed yet and the subsequent comparison of the properties would indicate they match (especially when px rounding is taken into consideration), thus no tweening is necessary even though it SHOULD tween and remove those properties after the tween (otherwise the inline styles will contaminate things). See the className SpecialProp code for details.
				_cssDif = function(t, s1, s2, vars, forceLookup) {
					var difs = {},
						style = t.style,
						val, p, mpt;
					for (p in s2) {
						if (p !== "cssText") if (p !== "length") if (isNaN(p)) if (s1[p] !== (val = s2[p]) || (forceLookup && forceLookup[p])) if (p.indexOf("Origin") === -1) if (typeof(val) === "number" || typeof(val) === "string") {
							difs[p] = (val === "auto" && (p === "left" || p === "top")) ? _calculateOffset(t, p) : ((val === "" || val === "auto" || val === "none") && typeof(s1[p]) === "string" && s1[p].replace(_NaNExp, "") !== "") ? 0 : val; //if the ending value is defaulting ("" or "auto"), we check the starting value and if it can be parsed into a number (a string which could have a suffix too, like 700px), then we swap in 0 for "" or "auto" so that things actually tween.
							if (style[p] !== undefined) { //for className tweens, we must remember which properties already existed inline - the ones that didn't should be removed when the tween isn't in progress because they were only introduced to facilitate the transition between classes.
								mpt = new MiniPropTween(style, p, style[p], mpt);
							}
						}
					}
					if (vars) {
						for (p in vars) { //copy properties (except className)
							if (p !== "className") {
								difs[p] = vars[p];
							}
						}
					}
					return {difs:difs, firstMPT:mpt};
				},
				_dimensions = {width:["Left","Right"], height:["Top","Bottom"]},
				_margins = ["marginLeft","marginRight","marginTop","marginBottom"],
	
				/**
				 * @private Gets the width or height of an element
				 * @param {!Object} t Target element
				 * @param {!string} p Property name ("width" or "height")
				 * @param {Object=} cs Computed style object (if one exists). Just a speed optimization.
				 * @return {number} Dimension (in pixels)
				 */
				_getDimension = function(t, p, cs) {
					if ((t.nodeName + "").toLowerCase() === "svg") { //Chrome no longer supports offsetWidth/offsetHeight on SVG elements.
						return (cs || _getComputedStyle(t))[p] || 0;
					} else if (t.getCTM && _isSVG(t)) {
						return t.getBBox()[p] || 0;
					}
					var v = parseFloat((p === "width") ? t.offsetWidth : t.offsetHeight),
						a = _dimensions[p],
						i = a.length;
					cs = cs || _getComputedStyle(t, null);
					while (--i > -1) {
						v -= parseFloat( _getStyle(t, "padding" + a[i], cs, true) ) || 0;
						v -= parseFloat( _getStyle(t, "border" + a[i] + "Width", cs, true) ) || 0;
					}
					return v;
				},
	
				// @private Parses position-related complex strings like "top left" or "50px 10px" or "70% 20%", etc. which are used for things like transformOrigin or backgroundPosition. Optionally decorates a supplied object (recObj) with the following properties: "ox" (offsetX), "oy" (offsetY), "oxp" (if true, "ox" is a percentage not a pixel value), and "oxy" (if true, "oy" is a percentage not a pixel value)
				_parsePosition = function(v, recObj) {
					if (v === "contain" || v === "auto" || v === "auto auto") { //note: Firefox uses "auto auto" as default whereas Chrome uses "auto".
						return v + " ";
					}
					if (v == null || v === "") {
						v = "0 0";
					}
					var a = v.split(" "),
						x = (v.indexOf("left") !== -1) ? "0%" : (v.indexOf("right") !== -1) ? "100%" : a[0],
						y = (v.indexOf("top") !== -1) ? "0%" : (v.indexOf("bottom") !== -1) ? "100%" : a[1],
						i;
					if (a.length > 3 && !recObj) { //multiple positions
						a = v.split(", ").join(",").split(",");
						v = [];
						for (i = 0; i < a.length; i++) {
							v.push(_parsePosition(a[i]));
						}
						return v.join(",");
					}
					if (y == null) {
						y = (x === "center") ? "50%" : "0";
					} else if (y === "center") {
						y = "50%";
					}
					if (x === "center" || (isNaN(parseFloat(x)) && (x + "").indexOf("=") === -1)) { //remember, the user could flip-flop the values and say "bottom center" or "center bottom", etc. "center" is ambiguous because it could be used to describe horizontal or vertical, hence the isNaN(). If there's an "=" sign in the value, it's relative.
						x = "50%";
					}
					v = x + " " + y + ((a.length > 2) ? " " + a[2] : "");
					if (recObj) {
						recObj.oxp = (x.indexOf("%") !== -1);
						recObj.oyp = (y.indexOf("%") !== -1);
						recObj.oxr = (x.charAt(1) === "=");
						recObj.oyr = (y.charAt(1) === "=");
						recObj.ox = parseFloat(x.replace(_NaNExp, ""));
						recObj.oy = parseFloat(y.replace(_NaNExp, ""));
						recObj.v = v;
					}
					return recObj || v;
				},
	
				/**
				 * @private Takes an ending value (typically a string, but can be a number) and a starting value and returns the change between the two, looking for relative value indicators like += and -= and it also ignores suffixes (but make sure the ending value starts with a number or +=/-= and that the starting value is a NUMBER!)
				 * @param {(number|string)} e End value which is typically a string, but could be a number
				 * @param {(number|string)} b Beginning value which is typically a string but could be a number
				 * @return {number} Amount of change between the beginning and ending values (relative values that have a "+=" or "-=" are recognized)
				 */
				_parseChange = function(e, b) {
					if (typeof(e) === "function") {
						e = e(_index, _target);
					}
					return (typeof(e) === "string" && e.charAt(1) === "=") ? parseInt(e.charAt(0) + "1", 10) * parseFloat(e.substr(2)) : (parseFloat(e) - parseFloat(b)) || 0;
				},
	
				/**
				 * @private Takes a value and a default number, checks if the value is relative, null, or numeric and spits back a normalized number accordingly. Primarily used in the _parseTransform() function.
				 * @param {Object} v Value to be parsed
				 * @param {!number} d Default value (which is also used for relative calculations if "+=" or "-=" is found in the first parameter)
				 * @return {number} Parsed value
				 */
				_parseVal = function(v, d) {
					if (typeof(v) === "function") {
						v = v(_index, _target);
					}
					return (v == null) ? d : (typeof(v) === "string" && v.charAt(1) === "=") ? parseInt(v.charAt(0) + "1", 10) * parseFloat(v.substr(2)) + d : parseFloat(v) || 0;
				},
	
				/**
				 * @private Translates strings like "40deg" or "40" or 40rad" or "+=40deg" or "270_short" or "-90_cw" or "+=45_ccw" to a numeric radian angle. Of course a starting/default value must be fed in too so that relative values can be calculated properly.
				 * @param {Object} v Value to be parsed
				 * @param {!number} d Default value (which is also used for relative calculations if "+=" or "-=" is found in the first parameter)
				 * @param {string=} p property name for directionalEnd (optional - only used when the parsed value is directional ("_short", "_cw", or "_ccw" suffix). We need a way to store the uncompensated value so that at the end of the tween, we set it to exactly what was requested with no directional compensation). Property name would be "rotation", "rotationX", or "rotationY"
				 * @param {Object=} directionalEnd An object that will store the raw end values for directional angles ("_short", "_cw", or "_ccw" suffix). We need a way to store the uncompensated value so that at the end of the tween, we set it to exactly what was requested with no directional compensation.
				 * @return {number} parsed angle in radians
				 */
				_parseAngle = function(v, d, p, directionalEnd) {
					var min = 0.000001,
						cap, split, dif, result, isRelative;
					if (typeof(v) === "function") {
						v = v(_index, _target);
					}
					if (v == null) {
						result = d;
					} else if (typeof(v) === "number") {
						result = v;
					} else {
						cap = 360;
						split = v.split("_");
						isRelative = (v.charAt(1) === "=");
						dif = (isRelative ? parseInt(v.charAt(0) + "1", 10) * parseFloat(split[0].substr(2)) : parseFloat(split[0])) * ((v.indexOf("rad") === -1) ? 1 : _RAD2DEG) - (isRelative ? 0 : d);
						if (split.length) {
							if (directionalEnd) {
								directionalEnd[p] = d + dif;
							}
							if (v.indexOf("short") !== -1) {
								dif = dif % cap;
								if (dif !== dif % (cap / 2)) {
									dif = (dif < 0) ? dif + cap : dif - cap;
								}
							}
							if (v.indexOf("_cw") !== -1 && dif < 0) {
								dif = ((dif + cap * 9999999999) % cap) - ((dif / cap) | 0) * cap;
							} else if (v.indexOf("ccw") !== -1 && dif > 0) {
								dif = ((dif - cap * 9999999999) % cap) - ((dif / cap) | 0) * cap;
							}
						}
						result = d + dif;
					}
					if (result < min && result > -min) {
						result = 0;
					}
					return result;
				},
	
				_colorLookup = {aqua:[0,255,255],
					lime:[0,255,0],
					silver:[192,192,192],
					black:[0,0,0],
					maroon:[128,0,0],
					teal:[0,128,128],
					blue:[0,0,255],
					navy:[0,0,128],
					white:[255,255,255],
					fuchsia:[255,0,255],
					olive:[128,128,0],
					yellow:[255,255,0],
					orange:[255,165,0],
					gray:[128,128,128],
					purple:[128,0,128],
					green:[0,128,0],
					red:[255,0,0],
					pink:[255,192,203],
					cyan:[0,255,255],
					transparent:[255,255,255,0]},
	
				_hue = function(h, m1, m2) {
					h = (h < 0) ? h + 1 : (h > 1) ? h - 1 : h;
					return ((((h * 6 < 1) ? m1 + (m2 - m1) * h * 6 : (h < 0.5) ? m2 : (h * 3 < 2) ? m1 + (m2 - m1) * (2 / 3 - h) * 6 : m1) * 255) + 0.5) | 0;
				},
	
				/**
				 * @private Parses a color (like #9F0, #FF9900, rgb(255,51,153) or hsl(108, 50%, 10%)) into an array with 3 elements for red, green, and blue or if toHSL parameter is true, it will populate the array with hue, saturation, and lightness values. If a relative value is found in an hsl() or hsla() string, it will preserve those relative prefixes and all the values in the array will be strings instead of numbers (in all other cases it will be populated with numbers).
				 * @param {(string|number)} v The value the should be parsed which could be a string like #9F0 or rgb(255,102,51) or rgba(255,0,0,0.5) or it could be a number like 0xFF00CC or even a named color like red, blue, purple, etc.
				 * @param {(boolean)} toHSL If true, an hsl() or hsla() value will be returned instead of rgb() or rgba()
				 * @return {Array.<number>} An array containing red, green, and blue (and optionally alpha) in that order, or if the toHSL parameter was true, the array will contain hue, saturation and lightness (and optionally alpha) in that order. Always numbers unless there's a relative prefix found in an hsl() or hsla() string and toHSL is true.
				 */
				_parseColor = CSSPlugin.parseColor = function(v, toHSL) {
					var a, r, g, b, h, s, l, max, min, d, wasHSL;
					if (!v) {
						a = _colorLookup.black;
					} else if (typeof(v) === "number") {
						a = [v >> 16, (v >> 8) & 255, v & 255];
					} else {
						if (v.charAt(v.length - 1) === ",") { //sometimes a trailing comma is included and we should chop it off (typically from a comma-delimited list of values like a textShadow:"2px 2px 2px blue, 5px 5px 5px rgb(255,0,0)" - in this example "blue," has a trailing comma. We could strip it out inside parseComplex() but we'd need to do it to the beginning and ending values plus it wouldn't provide protection from other potential scenarios like if the user passes in a similar value.
							v = v.substr(0, v.length - 1);
						}
						if (_colorLookup[v]) {
							a = _colorLookup[v];
						} else if (v.charAt(0) === "#") {
							if (v.length === 4) { //for shorthand like #9F0
								r = v.charAt(1);
								g = v.charAt(2);
								b = v.charAt(3);
								v = "#" + r + r + g + g + b + b;
							}
							v = parseInt(v.substr(1), 16);
							a = [v >> 16, (v >> 8) & 255, v & 255];
						} else if (v.substr(0, 3) === "hsl") {
							a = wasHSL = v.match(_numExp);
							if (!toHSL) {
								h = (Number(a[0]) % 360) / 360;
								s = Number(a[1]) / 100;
								l = Number(a[2]) / 100;
								g = (l <= 0.5) ? l * (s + 1) : l + s - l * s;
								r = l * 2 - g;
								if (a.length > 3) {
									a[3] = Number(a[3]);
								}
								a[0] = _hue(h + 1 / 3, r, g);
								a[1] = _hue(h, r, g);
								a[2] = _hue(h - 1 / 3, r, g);
							} else if (v.indexOf("=") !== -1) { //if relative values are found, just return the raw strings with the relative prefixes in place.
								return v.match(_relNumExp);
							}
						} else {
							a = v.match(_numExp) || _colorLookup.transparent;
						}
						a[0] = Number(a[0]);
						a[1] = Number(a[1]);
						a[2] = Number(a[2]);
						if (a.length > 3) {
							a[3] = Number(a[3]);
						}
					}
					if (toHSL && !wasHSL) {
						r = a[0] / 255;
						g = a[1] / 255;
						b = a[2] / 255;
						max = Math.max(r, g, b);
						min = Math.min(r, g, b);
						l = (max + min) / 2;
						if (max === min) {
							h = s = 0;
						} else {
							d = max - min;
							s = l > 0.5 ? d / (2 - max - min) : d / (max + min);
							h = (max === r) ? (g - b) / d + (g < b ? 6 : 0) : (max === g) ? (b - r) / d + 2 : (r - g) / d + 4;
							h *= 60;
						}
						a[0] = (h + 0.5) | 0;
						a[1] = (s * 100 + 0.5) | 0;
						a[2] = (l * 100 + 0.5) | 0;
					}
					return a;
				},
				_formatColors = function(s, toHSL) {
					var colors = s.match(_colorExp) || [],
						charIndex = 0,
						parsed = "",
						i, color, temp;
					if (!colors.length) {
						return s;
					}
					for (i = 0; i < colors.length; i++) {
						color = colors[i];
						temp = s.substr(charIndex, s.indexOf(color, charIndex)-charIndex);
						charIndex += temp.length + color.length;
						color = _parseColor(color, toHSL);
						if (color.length === 3) {
							color.push(1);
						}
						parsed += temp + (toHSL ? "hsla(" + color[0] + "," + color[1] + "%," + color[2] + "%," + color[3] : "rgba(" + color.join(",")) + ")";
					}
					return parsed + s.substr(charIndex);
				},
				_colorExp = "(?:\\b(?:(?:rgb|rgba|hsl|hsla)\\(.+?\\))|\\B#(?:[0-9a-f]{3}){1,2}\\b"; //we'll dynamically build this Regular Expression to conserve file size. After building it, it will be able to find rgb(), rgba(), # (hexadecimal), and named color values like red, blue, purple, etc.
	
			for (p in _colorLookup) {
				_colorExp += "|" + p + "\\b";
			}
			_colorExp = new RegExp(_colorExp+")", "gi");
	
			CSSPlugin.colorStringFilter = function(a) {
				var combined = a[0] + " " + a[1],
					toHSL;
				if (_colorExp.test(combined)) {
					toHSL = (combined.indexOf("hsl(") !== -1 || combined.indexOf("hsla(") !== -1);
					a[0] = _formatColors(a[0], toHSL);
					a[1] = _formatColors(a[1], toHSL);
				}
				_colorExp.lastIndex = 0;
			};
	
			if (!TweenLite.defaultStringFilter) {
				TweenLite.defaultStringFilter = CSSPlugin.colorStringFilter;
			}
	
			/**
			 * @private Returns a formatter function that handles taking a string (or number in some cases) and returning a consistently formatted one in terms of delimiters, quantity of values, etc. For example, we may get boxShadow values defined as "0px red" or "0px 0px 10px rgb(255,0,0)" or "0px 0px 20px 20px #F00" and we need to ensure that what we get back is described with 4 numbers and a color. This allows us to feed it into the _parseComplex() method and split the values up appropriately. The neat thing about this _getFormatter() function is that the dflt defines a pattern as well as a default, so for example, _getFormatter("0px 0px 0px 0px #777", true) not only sets the default as 0px for all distances and #777 for the color, but also sets the pattern such that 4 numbers and a color will always get returned.
			 * @param {!string} dflt The default value and pattern to follow. So "0px 0px 0px 0px #777" will ensure that 4 numbers and a color will always get returned.
			 * @param {boolean=} clr If true, the values should be searched for color-related data. For example, boxShadow values typically contain a color whereas borderRadius don't.
			 * @param {boolean=} collapsible If true, the value is a top/left/right/bottom style one that acts like margin or padding, where if only one value is received, it's used for all 4; if 2 are received, the first is duplicated for 3rd (bottom) and the 2nd is duplicated for the 4th spot (left), etc.
			 * @return {Function} formatter function
			 */
			var _getFormatter = function(dflt, clr, collapsible, multi) {
					if (dflt == null) {
						return function(v) {return v;};
					}
					var dColor = clr ? (dflt.match(_colorExp) || [""])[0] : "",
						dVals = dflt.split(dColor).join("").match(_valuesExp) || [],
						pfx = dflt.substr(0, dflt.indexOf(dVals[0])),
						sfx = (dflt.charAt(dflt.length - 1) === ")") ? ")" : "",
						delim = (dflt.indexOf(" ") !== -1) ? " " : ",",
						numVals = dVals.length,
						dSfx = (numVals > 0) ? dVals[0].replace(_numExp, "") : "",
						formatter;
					if (!numVals) {
						return function(v) {return v;};
					}
					if (clr) {
						formatter = function(v) {
							var color, vals, i, a;
							if (typeof(v) === "number") {
								v += dSfx;
							} else if (multi && _commasOutsideParenExp.test(v)) {
								a = v.replace(_commasOutsideParenExp, "|").split("|");
								for (i = 0; i < a.length; i++) {
									a[i] = formatter(a[i]);
								}
								return a.join(",");
							}
							color = (v.match(_colorExp) || [dColor])[0];
							vals = v.split(color).join("").match(_valuesExp) || [];
							i = vals.length;
							if (numVals > i--) {
								while (++i < numVals) {
									vals[i] = collapsible ? vals[(((i - 1) / 2) | 0)] : dVals[i];
								}
							}
							return pfx + vals.join(delim) + delim + color + sfx + (v.indexOf("inset") !== -1 ? " inset" : "");
						};
						return formatter;
	
					}
					formatter = function(v) {
						var vals, a, i;
						if (typeof(v) === "number") {
							v += dSfx;
						} else if (multi && _commasOutsideParenExp.test(v)) {
							a = v.replace(_commasOutsideParenExp, "|").split("|");
							for (i = 0; i < a.length; i++) {
								a[i] = formatter(a[i]);
							}
							return a.join(",");
						}
						vals = v.match(_valuesExp) || [];
						i = vals.length;
						if (numVals > i--) {
							while (++i < numVals) {
								vals[i] = collapsible ? vals[(((i - 1) / 2) | 0)] : dVals[i];
							}
						}
						return pfx + vals.join(delim) + sfx;
					};
					return formatter;
				},
	
				/**
				 * @private returns a formatter function that's used for edge-related values like marginTop, marginLeft, paddingBottom, paddingRight, etc. Just pass a comma-delimited list of property names related to the edges.
				 * @param {!string} props a comma-delimited list of property names in order from top to left, like "marginTop,marginRight,marginBottom,marginLeft"
				 * @return {Function} a formatter function
				 */
				_getEdgeParser = function(props) {
					props = props.split(",");
					return function(t, e, p, cssp, pt, plugin, vars) {
						var a = (e + "").split(" "),
							i;
						vars = {};
						for (i = 0; i < 4; i++) {
							vars[props[i]] = a[i] = a[i] || a[(((i - 1) / 2) >> 0)];
						}
						return cssp.parse(t, vars, pt, plugin);
					};
				},
	
				// @private used when other plugins must tween values first, like BezierPlugin or ThrowPropsPlugin, etc. That plugin's setRatio() gets called first so that the values are updated, and then we loop through the MiniPropTweens which handle copying the values into their appropriate slots so that they can then be applied correctly in the main CSSPlugin setRatio() method. Remember, we typically create a proxy object that has a bunch of uniquely-named properties that we feed to the sub-plugin and it does its magic normally, and then we must interpret those values and apply them to the css because often numbers must get combined/concatenated, suffixes added, etc. to work with css, like boxShadow could have 4 values plus a color.
				_setPluginRatio = _internals._setPluginRatio = function(v) {
					this.plugin.setRatio(v);
					var d = this.data,
						proxy = d.proxy,
						mpt = d.firstMPT,
						min = 0.000001,
						val, pt, i, str, p;
					while (mpt) {
						val = proxy[mpt.v];
						if (mpt.r) {
							val = mpt.r(val);
						} else if (val < min && val > -min) {
							val = 0;
						}
						mpt.t[mpt.p] = val;
						mpt = mpt._next;
					}
					if (d.autoRotate) {
						d.autoRotate.rotation = d.mod ? d.mod.call(this._tween, proxy.rotation, this.t, this._tween) : proxy.rotation; //special case for ModifyPlugin to hook into an auto-rotating bezier
					}
					//at the end, we must set the CSSPropTween's "e" (end) value dynamically here because that's what is used in the final setRatio() method. Same for "b" at the beginning.
					if (v === 1 || v === 0) {
						mpt = d.firstMPT;
						p = (v === 1) ? "e" : "b";
						while (mpt) {
							pt = mpt.t;
							if (!pt.type) {
								pt[p] = pt.s + pt.xs0;
							} else if (pt.type === 1) {
								str = pt.xs0 + pt.s + pt.xs1;
								for (i = 1; i < pt.l; i++) {
									str += pt["xn"+i] + pt["xs"+(i+1)];
								}
								pt[p] = str;
							}
							mpt = mpt._next;
						}
					}
				},
	
				/**
				 * @private @constructor Used by a few SpecialProps to hold important values for proxies. For example, _parseToProxy() creates a MiniPropTween instance for each property that must get tweened on the proxy, and we record the original property name as well as the unique one we create for the proxy, plus whether or not the value needs to be rounded plus the original value.
				 * @param {!Object} t target object whose property we're tweening (often a CSSPropTween)
				 * @param {!string} p property name
				 * @param {(number|string|object)} v value
				 * @param {MiniPropTween=} next next MiniPropTween in the linked list
				 * @param {boolean=} r if true, the tweened value should be rounded to the nearest integer
				 */
				MiniPropTween = function(t, p, v, next, r) {
					this.t = t;
					this.p = p;
					this.v = v;
					this.r = r;
					if (next) {
						next._prev = this;
						this._next = next;
					}
				},
	
				/**
				 * @private Most other plugins (like BezierPlugin and ThrowPropsPlugin and others) can only tween numeric values, but CSSPlugin must accommodate special values that have a bunch of extra data (like a suffix or strings between numeric values, etc.). For example, boxShadow has values like "10px 10px 20px 30px rgb(255,0,0)" which would utterly confuse other plugins. This method allows us to split that data apart and grab only the numeric data and attach it to uniquely-named properties of a generic proxy object ({}) so that we can feed that to virtually any plugin to have the numbers tweened. However, we must also keep track of which properties from the proxy go with which CSSPropTween values and instances. So we create a linked list of MiniPropTweens. Each one records a target (the original CSSPropTween), property (like "s" or "xn1" or "xn2") that we're tweening and the unique property name that was used for the proxy (like "boxShadow_xn1" and "boxShadow_xn2") and whether or not they need to be rounded. That way, in the _setPluginRatio() method we can simply copy the values over from the proxy to the CSSPropTween instance(s). Then, when the main CSSPlugin setRatio() method runs and applies the CSSPropTween values accordingly, they're updated nicely. So the external plugin tweens the numbers, _setPluginRatio() copies them over, and setRatio() acts normally, applying css-specific values to the element.
				 * This method returns an object that has the following properties:
				 *  - proxy: a generic object containing the starting values for all the properties that will be tweened by the external plugin.  This is what we feed to the external _onInitTween() as the target
				 *  - end: a generic object containing the ending values for all the properties that will be tweened by the external plugin. This is what we feed to the external plugin's _onInitTween() as the destination values
				 *  - firstMPT: the first MiniPropTween in the linked list
				 *  - pt: the first CSSPropTween in the linked list that was created when parsing. If shallow is true, this linked list will NOT attach to the one passed into the _parseToProxy() as the "pt" (4th) parameter.
				 * @param {!Object} t target object to be tweened
				 * @param {!(Object|string)} vars the object containing the information about the tweening values (typically the end/destination values) that should be parsed
				 * @param {!CSSPlugin} cssp The CSSPlugin instance
				 * @param {CSSPropTween=} pt the next CSSPropTween in the linked list
				 * @param {TweenPlugin=} plugin the external TweenPlugin instance that will be handling tweening the numeric values
				 * @param {boolean=} shallow if true, the resulting linked list from the parse will NOT be attached to the CSSPropTween that was passed in as the "pt" (4th) parameter.
				 * @return An object containing the following properties: proxy, end, firstMPT, and pt (see above for descriptions)
				 */
				_parseToProxy = _internals._parseToProxy = function(t, vars, cssp, pt, plugin, shallow) {
					var bpt = pt,
						start = {},
						end = {},
						transform = cssp._transform,
						oldForce = _forcePT,
						i, p, xp, mpt, firstPT;
					cssp._transform = null;
					_forcePT = vars;
					pt = firstPT = cssp.parse(t, vars, pt, plugin);
					_forcePT = oldForce;
					//break off from the linked list so the new ones are isolated.
					if (shallow) {
						cssp._transform = transform;
						if (bpt) {
							bpt._prev = null;
							if (bpt._prev) {
								bpt._prev._next = null;
							}
						}
					}
					while (pt && pt !== bpt) {
						if (pt.type <= 1) {
							p = pt.p;
							end[p] = pt.s + pt.c;
							start[p] = pt.s;
							if (!shallow) {
								mpt = new MiniPropTween(pt, "s", p, mpt, pt.r);
								pt.c = 0;
							}
							if (pt.type === 1) {
								i = pt.l;
								while (--i > 0) {
									xp = "xn" + i;
									p = pt.p + "_" + xp;
									end[p] = pt.data[xp];
									start[p] = pt[xp];
									if (!shallow) {
										mpt = new MiniPropTween(pt, xp, p, mpt, pt.rxp[xp]);
									}
								}
							}
						}
						pt = pt._next;
					}
					return {proxy:start, end:end, firstMPT:mpt, pt:firstPT};
				},
	
	
	
				/**
				 * @constructor Each property that is tweened has at least one CSSPropTween associated with it. These instances store important information like the target, property, starting value, amount of change, etc. They can also optionally have a number of "extra" strings and numeric values named xs1, xn1, xs2, xn2, xs3, xn3, etc. where "s" indicates string and "n" indicates number. These can be pieced together in a complex-value tween (type:1) that has alternating types of data like a string, number, string, number, etc. For example, boxShadow could be "5px 5px 8px rgb(102, 102, 51)". In that value, there are 6 numbers that may need to tween and then pieced back together into a string again with spaces, suffixes, etc. xs0 is special in that it stores the suffix for standard (type:0) tweens, -OR- the first string (prefix) in a complex-value (type:1) CSSPropTween -OR- it can be the non-tweening value in a type:-1 CSSPropTween. We do this to conserve memory.
				 * CSSPropTweens have the following optional properties as well (not defined through the constructor):
				 *  - l: Length in terms of the number of extra properties that the CSSPropTween has (default: 0). For example, for a boxShadow we may need to tween 5 numbers in which case l would be 5; Keep in mind that the start/end values for the first number that's tweened are always stored in the s and c properties to conserve memory. All additional values thereafter are stored in xn1, xn2, etc.
				 *  - xfirst: The first instance of any sub-CSSPropTweens that are tweening properties of this instance. For example, we may split up a boxShadow tween so that there's a main CSSPropTween of type:1 that has various xs* and xn* values associated with the h-shadow, v-shadow, blur, color, etc. Then we spawn a CSSPropTween for each of those that has a higher priority and runs BEFORE the main CSSPropTween so that the values are all set by the time it needs to re-assemble them. The xfirst gives us an easy way to identify the first one in that chain which typically ends at the main one (because they're all prepende to the linked list)
				 *  - plugin: The TweenPlugin instance that will handle the tweening of any complex values. For example, sometimes we don't want to use normal subtweens (like xfirst refers to) to tween the values - we might want ThrowPropsPlugin or BezierPlugin some other plugin to do the actual tweening, so we create a plugin instance and store a reference here. We need this reference so that if we get a request to round values or disable a tween, we can pass along that request.
				 *  - data: Arbitrary data that needs to be stored with the CSSPropTween. Typically if we're going to have a plugin handle the tweening of a complex-value tween, we create a generic object that stores the END values that we're tweening to and the CSSPropTween's xs1, xs2, etc. have the starting values. We store that object as data. That way, we can simply pass that object to the plugin and use the CSSPropTween as the target.
				 *  - setRatio: Only used for type:2 tweens that require custom functionality. In this case, we call the CSSPropTween's setRatio() method and pass the ratio each time the tween updates. This isn't quite as efficient as doing things directly in the CSSPlugin's setRatio() method, but it's very convenient and flexible.
				 * @param {!Object} t Target object whose property will be tweened. Often a DOM element, but not always. It could be anything.
				 * @param {string} p Property to tween (name). For example, to tween element.width, p would be "width".
				 * @param {number} s Starting numeric value
				 * @param {number} c Change in numeric value over the course of the entire tween. For example, if element.width starts at 5 and should end at 100, c would be 95.
				 * @param {CSSPropTween=} next The next CSSPropTween in the linked list. If one is defined, we will define its _prev as the new instance, and the new instance's _next will be pointed at it.
				 * @param {number=} type The type of CSSPropTween where -1 = a non-tweening value, 0 = a standard simple tween, 1 = a complex value (like one that has multiple numbers in a comma- or space-delimited string like border:"1px solid red"), and 2 = one that uses a custom setRatio function that does all of the work of applying the values on each update.
				 * @param {string=} n Name of the property that should be used for overwriting purposes which is typically the same as p but not always. For example, we may need to create a subtween for the 2nd part of a "clip:rect(...)" tween in which case "p" might be xs1 but "n" is still "clip"
				 * @param {boolean=} r If true, the value(s) should be rounded
				 * @param {number=} pr Priority in the linked list order. Higher priority CSSPropTweens will be updated before lower priority ones. The default priority is 0.
				 * @param {string=} b Beginning value. We store this to ensure that it is EXACTLY what it was when the tween began without any risk of interpretation issues.
				 * @param {string=} e Ending value. We store this to ensure that it is EXACTLY what the user defined at the end of the tween without any risk of interpretation issues.
				 */
				CSSPropTween = _internals.CSSPropTween = function(t, p, s, c, next, type, n, r, pr, b, e) {
					this.t = t; //target
					this.p = p; //property
					this.s = s; //starting value
					this.c = c; //change value
					this.n = n || p; //name that this CSSPropTween should be associated to (usually the same as p, but not always - n is what overwriting looks at)
					if (!(t instanceof CSSPropTween)) {
						_overwriteProps.push(this.n);
					}
					this.r = !r ? r : (typeof(r) === "function") ? r : Math.round; //round (boolean)
					this.type = type || 0; //0 = normal tween, -1 = non-tweening (in which case xs0 will be applied to the target's property, like tp.t[tp.p] = tp.xs0), 1 = complex-value SpecialProp, 2 = custom setRatio() that does all the work
					if (pr) {
						this.pr = pr;
						_hasPriority = true;
					}
					this.b = (b === undefined) ? s : b;
					this.e = (e === undefined) ? s + c : e;
					if (next) {
						this._next = next;
						next._prev = this;
					}
				},
	
				_addNonTweeningNumericPT = function(target, prop, start, end, next, overwriteProp) { //cleans up some code redundancies and helps minification. Just a fast way to add a NUMERIC non-tweening CSSPropTween
					var pt = new CSSPropTween(target, prop, start, end - start, next, -1, overwriteProp);
					pt.b = start;
					pt.e = pt.xs0 = end;
					return pt;
				},
	
				/**
				 * Takes a target, the beginning value and ending value (as strings) and parses them into a CSSPropTween (possibly with child CSSPropTweens) that accommodates multiple numbers, colors, comma-delimited values, etc. For example:
				 * sp.parseComplex(element, "boxShadow", "5px 10px 20px rgb(255,102,51)", "0px 0px 0px red", true, "0px 0px 0px rgb(0,0,0,0)", pt);
				 * It will walk through the beginning and ending values (which should be in the same format with the same number and type of values) and figure out which parts are numbers, what strings separate the numeric/tweenable values, and then create the CSSPropTweens accordingly. If a plugin is defined, no child CSSPropTweens will be created. Instead, the ending values will be stored in the "data" property of the returned CSSPropTween like: {s:-5, xn1:-10, xn2:-20, xn3:255, xn4:0, xn5:0} so that it can be fed to any other plugin and it'll be plain numeric tweens but the recomposition of the complex value will be handled inside CSSPlugin's setRatio().
				 * If a setRatio is defined, the type of the CSSPropTween will be set to 2 and recomposition of the values will be the responsibility of that method.
				 *
				 * @param {!Object} t Target whose property will be tweened
				 * @param {!string} p Property that will be tweened (its name, like "left" or "backgroundColor" or "boxShadow")
				 * @param {string} b Beginning value
				 * @param {string} e Ending value
				 * @param {boolean} clrs If true, the value could contain a color value like "rgb(255,0,0)" or "#F00" or "red". The default is false, so no colors will be recognized (a performance optimization)
				 * @param {(string|number|Object)} dflt The default beginning value that should be used if no valid beginning value is defined or if the number of values inside the complex beginning and ending values don't match
				 * @param {?CSSPropTween} pt CSSPropTween instance that is the current head of the linked list (we'll prepend to this).
				 * @param {number=} pr Priority in the linked list order. Higher priority properties will be updated before lower priority ones. The default priority is 0.
				 * @param {TweenPlugin=} plugin If a plugin should handle the tweening of extra properties, pass the plugin instance here. If one is defined, then NO subtweens will be created for any extra properties (the properties will be created - just not additional CSSPropTween instances to tween them) because the plugin is expected to do so. However, the end values WILL be populated in the "data" property, like {s:100, xn1:50, xn2:300}
				 * @param {function(number)=} setRatio If values should be set in a custom function instead of being pieced together in a type:1 (complex-value) CSSPropTween, define that custom function here.
				 * @return {CSSPropTween} The first CSSPropTween in the linked list which includes the new one(s) added by the parseComplex() call.
				 */
				_parseComplex = CSSPlugin.parseComplex = function(t, p, b, e, clrs, dflt, pt, pr, plugin, setRatio) {
					//DEBUG: _log("parseComplex: "+p+", b: "+b+", e: "+e);
					b = b || dflt || "";
					if (typeof(e) === "function") {
						e = e(_index, _target);
					}
					pt = new CSSPropTween(t, p, 0, 0, pt, (setRatio ? 2 : 1), null, false, pr, b, e);
					e += ""; //ensures it's a string
					if (clrs && _colorExp.test(e + b)) { //if colors are found, normalize the formatting to rgba() or hsla().
						e = [b, e];
						CSSPlugin.colorStringFilter(e);
						b = e[0];
						e = e[1];
					}
					var ba = b.split(", ").join(",").split(" "), //beginning array
						ea = e.split(", ").join(",").split(" "), //ending array
						l = ba.length,
						autoRound = (_autoRound !== false),
						i, xi, ni, bv, ev, bnums, enums, bn, hasAlpha, temp, cv, str, useHSL;
					if (e.indexOf(",") !== -1 || b.indexOf(",") !== -1) {
						if ((e + b).indexOf("rgb") !== -1 || (e + b).indexOf("hsl") !== -1) { //keep rgb(), rgba(), hsl(), and hsla() values together! (remember, we're splitting on spaces)
							ba = ba.join(" ").replace(_commasOutsideParenExp, ", ").split(" ");
							ea = ea.join(" ").replace(_commasOutsideParenExp, ", ").split(" ");
						} else {
							ba = ba.join(" ").split(",").join(", ").split(" ");
							ea = ea.join(" ").split(",").join(", ").split(" ");
						}
						l = ba.length;
					}
					if (l !== ea.length) {
						//DEBUG: _log("mismatched formatting detected on " + p + " (" + b + " vs " + e + ")");
						ba = (dflt || "").split(" ");
						l = ba.length;
					}
					pt.plugin = plugin;
					pt.setRatio = setRatio;
					_colorExp.lastIndex = 0;
					for (i = 0; i < l; i++) {
						bv = ba[i];
						ev = ea[i] + "";
						bn = parseFloat(bv);
						//if the value begins with a number (most common). It's fine if it has a suffix like px
						if (bn || bn === 0) {
							pt.appendXtra("", bn, _parseChange(ev, bn), ev.replace(_relNumExp, ""), (autoRound && ev.indexOf("px") !== -1) ? Math.round : false, true);
	
						//if the value is a color
						} else if (clrs && _colorExp.test(bv)) {
							str = ev.indexOf(")") + 1;
							str = ")" + (str ? ev.substr(str) : ""); //if there's a comma or ) at the end, retain it.
							useHSL = (ev.indexOf("hsl") !== -1 && _supportsOpacity);
							temp = ev; //original string value so we can look for any prefix later.
							bv = _parseColor(bv, useHSL);
							ev = _parseColor(ev, useHSL);
							hasAlpha = (bv.length + ev.length > 6);
							if (hasAlpha && !_supportsOpacity && ev[3] === 0) { //older versions of IE don't support rgba(), so if the destination alpha is 0, just use "transparent" for the end color
								pt["xs" + pt.l] += pt.l ? " transparent" : "transparent";
								pt.e = pt.e.split(ea[i]).join("transparent");
							} else {
								if (!_supportsOpacity) { //old versions of IE don't support rgba().
									hasAlpha = false;
								}
								if (useHSL) {
									pt.appendXtra(temp.substr(0, temp.indexOf("hsl")) + (hasAlpha ? "hsla(" : "hsl("), bv[0], _parseChange(ev[0], bv[0]), ",", false, true)
										.appendXtra("", bv[1], _parseChange(ev[1], bv[1]), "%,", false)
										.appendXtra("", bv[2], _parseChange(ev[2], bv[2]), (hasAlpha ? "%," : "%" + str), false);
								} else {
									pt.appendXtra(temp.substr(0, temp.indexOf("rgb")) + (hasAlpha ? "rgba(" : "rgb("), bv[0], ev[0] - bv[0], ",", Math.round, true)
										.appendXtra("", bv[1], ev[1] - bv[1], ",", Math.round)
										.appendXtra("", bv[2], ev[2] - bv[2], (hasAlpha ? "," : str), Math.round);
								}
	
								if (hasAlpha) {
									bv = (bv.length < 4) ? 1 : bv[3];
									pt.appendXtra("", bv, ((ev.length < 4) ? 1 : ev[3]) - bv, str, false);
								}
							}
							_colorExp.lastIndex = 0; //otherwise the test() on the RegExp could move the lastIndex and taint future results.
	
						} else {
							bnums = bv.match(_numExp); //gets each group of numbers in the beginning value string and drops them into an array
	
							//if no number is found, treat it as a non-tweening value and just append the string to the current xs.
							if (!bnums) {
								pt["xs" + pt.l] += (pt.l || pt["xs" + pt.l]) ? " " + ev : ev;
	
							//loop through all the numbers that are found and construct the extra values on the pt.
							} else {
								enums = ev.match(_relNumExp); //get each group of numbers in the end value string and drop them into an array. We allow relative values too, like +=50 or -=.5
								if (!enums || enums.length !== bnums.length) {
									//DEBUG: _log("mismatched formatting detected on " + p + " (" + b + " vs " + e + ")");
									return pt;
								}
								ni = 0;
								for (xi = 0; xi < bnums.length; xi++) {
									cv = bnums[xi];
									temp = bv.indexOf(cv, ni);
									pt.appendXtra(bv.substr(ni, temp - ni), Number(cv), _parseChange(enums[xi], cv), "", (autoRound && bv.substr(temp + cv.length, 2) === "px") ? Math.round : false, (xi === 0));
									ni = temp + cv.length;
								}
								pt["xs" + pt.l] += bv.substr(ni);
							}
						}
					}
					//if there are relative values ("+=" or "-=" prefix), we need to adjust the ending value to eliminate the prefixes and combine the values properly.
					if (e.indexOf("=") !== -1) if (pt.data) {
						str = pt.xs0 + pt.data.s;
						for (i = 1; i < pt.l; i++) {
							str += pt["xs" + i] + pt.data["xn" + i];
						}
						pt.e = str + pt["xs" + i];
					}
					if (!pt.l) {
						pt.type = -1;
						pt.xs0 = pt.e;
					}
					return pt.xfirst || pt;
				},
				i = 9;
	
	
			p = CSSPropTween.prototype;
			p.l = p.pr = 0; //length (number of extra properties like xn1, xn2, xn3, etc.
			while (--i > 0) {
				p["xn" + i] = 0;
				p["xs" + i] = "";
			}
			p.xs0 = "";
			p._next = p._prev = p.xfirst = p.data = p.plugin = p.setRatio = p.rxp = null;
	
	
			/**
			 * Appends and extra tweening value to a CSSPropTween and automatically manages any prefix and suffix strings. The first extra value is stored in the s and c of the main CSSPropTween instance, but thereafter any extras are stored in the xn1, xn2, xn3, etc. The prefixes and suffixes are stored in the xs0, xs1, xs2, etc. properties. For example, if I walk through a clip value like "rect(10px, 5px, 0px, 20px)", the values would be stored like this:
			 * xs0:"rect(", s:10, xs1:"px, ", xn1:5, xs2:"px, ", xn2:0, xs3:"px, ", xn3:20, xn4:"px)"
			 * And they'd all get joined together when the CSSPlugin renders (in the setRatio() method).
			 * @param {string=} pfx Prefix (if any)
			 * @param {!number} s Starting value
			 * @param {!number} c Change in numeric value over the course of the entire tween. For example, if the start is 5 and the end is 100, the change would be 95.
			 * @param {string=} sfx Suffix (if any)
			 * @param {boolean=} r Round (if true).
			 * @param {boolean=} pad If true, this extra value should be separated by the previous one by a space. If there is no previous extra and pad is true, it will automatically drop the space.
			 * @return {CSSPropTween} returns itself so that multiple methods can be chained together.
			 */
			p.appendXtra = function(pfx, s, c, sfx, r, pad) {
				var pt = this,
					l = pt.l;
				pt["xs" + l] += (pad && (l || pt["xs" + l])) ? " " + pfx : pfx || "";
				if (!c) if (l !== 0 && !pt.plugin) { //typically we'll combine non-changing values right into the xs to optimize performance, but we don't combine them when there's a plugin that will be tweening the values because it may depend on the values being split apart, like for a bezier, if a value doesn't change between the first and second iteration but then it does on the 3rd, we'll run into trouble because there's no xn slot for that value!
					pt["xs" + l] += s + (sfx || "");
					return pt;
				}
				pt.l++;
				pt.type = pt.setRatio ? 2 : 1;
				pt["xs" + pt.l] = sfx || "";
				if (l > 0) {
					pt.data["xn" + l] = s + c;
					pt.rxp["xn" + l] = r; //round extra property (we need to tap into this in the _parseToProxy() method)
					pt["xn" + l] = s;
					if (!pt.plugin) {
						pt.xfirst = new CSSPropTween(pt, "xn" + l, s, c, pt.xfirst || pt, 0, pt.n, r, pt.pr);
						pt.xfirst.xs0 = 0; //just to ensure that the property stays numeric which helps modern browsers speed up processing. Remember, in the setRatio() method, we do pt.t[pt.p] = val + pt.xs0 so if pt.xs0 is "" (the default), it'll cast the end value as a string. When a property is a number sometimes and a string sometimes, it prevents the compiler from locking in the data type, slowing things down slightly.
					}
					return pt;
				}
				pt.data = {s:s + c};
				pt.rxp = {};
				pt.s = s;
				pt.c = c;
				pt.r = r;
				return pt;
			};
	
			/**
			 * @constructor A SpecialProp is basically a css property that needs to be treated in a non-standard way, like if it may contain a complex value like boxShadow:"5px 10px 15px rgb(255, 102, 51)" or if it is associated with another plugin like ThrowPropsPlugin or BezierPlugin. Every SpecialProp is associated with a particular property name like "boxShadow" or "throwProps" or "bezier" and it will intercept those values in the vars object that's passed to the CSSPlugin and handle them accordingly.
			 * @param {!string} p Property name (like "boxShadow" or "throwProps")
			 * @param {Object=} options An object containing any of the following configuration options:
			 *                      - defaultValue: the default value
			 *                      - parser: A function that should be called when the associated property name is found in the vars. This function should return a CSSPropTween instance and it should ensure that it is properly inserted into the linked list. It will receive 4 paramters: 1) The target, 2) The value defined in the vars, 3) The CSSPlugin instance (whose _firstPT should be used for the linked list), and 4) A computed style object if one was calculated (this is a speed optimization that allows retrieval of starting values quicker)
			 *                      - formatter: a function that formats any value received for this special property (for example, boxShadow could take "5px 5px red" and format it to "5px 5px 0px 0px red" so that both the beginning and ending values have a common order and quantity of values.)
			 *                      - prefix: if true, we'll determine whether or not this property requires a vendor prefix (like Webkit or Moz or ms or O)
			 *                      - color: set this to true if the value for this SpecialProp may contain color-related values like rgb(), rgba(), etc.
			 *                      - priority: priority in the linked list order. Higher priority SpecialProps will be updated before lower priority ones. The default priority is 0.
			 *                      - multi: if true, the formatter should accommodate a comma-delimited list of values, like boxShadow could have multiple boxShadows listed out.
			 *                      - collapsible: if true, the formatter should treat the value like it's a top/right/bottom/left value that could be collapsed, like "5px" would apply to all, "5px, 10px" would use 5px for top/bottom and 10px for right/left, etc.
			 *                      - keyword: a special keyword that can [optionally] be found inside the value (like "inset" for boxShadow). This allows us to validate beginning/ending values to make sure they match (if the keyword is found in one, it'll be added to the other for consistency by default).
			 */
			var SpecialProp = function(p, options) {
					options = options || {};
					this.p = options.prefix ? _checkPropPrefix(p) || p : p;
					_specialProps[p] = _specialProps[this.p] = this;
					this.format = options.formatter || _getFormatter(options.defaultValue, options.color, options.collapsible, options.multi);
					if (options.parser) {
						this.parse = options.parser;
					}
					this.clrs = options.color;
					this.multi = options.multi;
					this.keyword = options.keyword;
					this.dflt = options.defaultValue;
					this.pr = options.priority || 0;
				},
	
				//shortcut for creating a new SpecialProp that can accept multiple properties as a comma-delimited list (helps minification). dflt can be an array for multiple values (we don't do a comma-delimited list because the default value may contain commas, like rect(0px,0px,0px,0px)). We attach this method to the SpecialProp class/object instead of using a private _createSpecialProp() method so that we can tap into it externally if necessary, like from another plugin.
				_registerComplexSpecialProp = _internals._registerComplexSpecialProp = function(p, options, defaults) {
					if (typeof(options) !== "object") {
						options = {parser:defaults}; //to make backwards compatible with older versions of BezierPlugin and ThrowPropsPlugin
					}
					var a = p.split(","),
						d = options.defaultValue,
						i, temp;
					defaults = defaults || [d];
					for (i = 0; i < a.length; i++) {
						options.prefix = (i === 0 && options.prefix);
						options.defaultValue = defaults[i] || d;
						temp = new SpecialProp(a[i], options);
					}
				},
	
				//creates a placeholder special prop for a plugin so that the property gets caught the first time a tween of it is attempted, and at that time it makes the plugin register itself, thus taking over for all future tweens of that property. This allows us to not mandate that things load in a particular order and it also allows us to log() an error that informs the user when they attempt to tween an external plugin-related property without loading its .js file.
				_registerPluginProp = _internals._registerPluginProp = function(p) {
					if (!_specialProps[p]) {
						var pluginName = p.charAt(0).toUpperCase() + p.substr(1) + "Plugin";
						_registerComplexSpecialProp(p, {parser:function(t, e, p, cssp, pt, plugin, vars) {
							var pluginClass = _globals.com.greensock.plugins[pluginName];
							if (!pluginClass) {
								_log("Error: " + pluginName + " js file not loaded.");
								return pt;
							}
							pluginClass._cssRegister();
							return _specialProps[p].parse(t, e, p, cssp, pt, plugin, vars);
						}});
					}
				};
	
	
			p = SpecialProp.prototype;
	
			/**
			 * Alias for _parseComplex() that automatically plugs in certain values for this SpecialProp, like its property name, whether or not colors should be sensed, the default value, and priority. It also looks for any keyword that the SpecialProp defines (like "inset" for boxShadow) and ensures that the beginning and ending values have the same number of values for SpecialProps where multi is true (like boxShadow and textShadow can have a comma-delimited list)
			 * @param {!Object} t target element
			 * @param {(string|number|object)} b beginning value
			 * @param {(string|number|object)} e ending (destination) value
			 * @param {CSSPropTween=} pt next CSSPropTween in the linked list
			 * @param {TweenPlugin=} plugin If another plugin will be tweening the complex value, that TweenPlugin instance goes here.
			 * @param {function=} setRatio If a custom setRatio() method should be used to handle this complex value, that goes here.
			 * @return {CSSPropTween=} First CSSPropTween in the linked list
			 */
			p.parseComplex = function(t, b, e, pt, plugin, setRatio) {
				var kwd = this.keyword,
					i, ba, ea, l, bi, ei;
				//if this SpecialProp's value can contain a comma-delimited list of values (like boxShadow or textShadow), we must parse them in a special way, and look for a keyword (like "inset" for boxShadow) and ensure that the beginning and ending BOTH have it if the end defines it as such. We also must ensure that there are an equal number of values specified (we can't tween 1 boxShadow to 3 for example)
				if (this.multi) if (_commasOutsideParenExp.test(e) || _commasOutsideParenExp.test(b)) {
					ba = b.replace(_commasOutsideParenExp, "|").split("|");
					ea = e.replace(_commasOutsideParenExp, "|").split("|");
				} else if (kwd) {
					ba = [b];
					ea = [e];
				}
				if (ea) {
					l = (ea.length > ba.length) ? ea.length : ba.length;
					for (i = 0; i < l; i++) {
						b = ba[i] = ba[i] || this.dflt;
						e = ea[i] = ea[i] || this.dflt;
						if (kwd) {
							bi = b.indexOf(kwd);
							ei = e.indexOf(kwd);
							if (bi !== ei) {
								if (ei === -1) { //if the keyword isn't in the end value, remove it from the beginning one.
									ba[i] = ba[i].split(kwd).join("");
								} else if (bi === -1) { //if the keyword isn't in the beginning, add it.
									ba[i] += " " + kwd;
								}
							}
						}
					}
					b = ba.join(", ");
					e = ea.join(", ");
				}
				return _parseComplex(t, this.p, b, e, this.clrs, this.dflt, pt, this.pr, plugin, setRatio);
			};
	
			/**
			 * Accepts a target and end value and spits back a CSSPropTween that has been inserted into the CSSPlugin's linked list and conforms with all the conventions we use internally, like type:-1, 0, 1, or 2, setting up any extra property tweens, priority, etc. For example, if we have a boxShadow SpecialProp and call:
			 * this._firstPT = sp.parse(element, "5px 10px 20px rgb(2550,102,51)", "boxShadow", this);
			 * It should figure out the starting value of the element's boxShadow, compare it to the provided end value and create all the necessary CSSPropTweens of the appropriate types to tween the boxShadow. The CSSPropTween that gets spit back should already be inserted into the linked list (the 4th parameter is the current head, so prepend to that).
			 * @param {!Object} t Target object whose property is being tweened
			 * @param {Object} e End value as provided in the vars object (typically a string, but not always - like a throwProps would be an object).
			 * @param {!string} p Property name
			 * @param {!CSSPlugin} cssp The CSSPlugin instance that should be associated with this tween.
			 * @param {?CSSPropTween} pt The CSSPropTween that is the current head of the linked list (we'll prepend to it)
			 * @param {TweenPlugin=} plugin If a plugin will be used to tween the parsed value, this is the plugin instance.
			 * @param {Object=} vars Original vars object that contains the data for parsing.
			 * @return {CSSPropTween} The first CSSPropTween in the linked list which includes the new one(s) added by the parse() call.
			 */
			p.parse = function(t, e, p, cssp, pt, plugin, vars) {
				return this.parseComplex(t.style, this.format(_getStyle(t, this.p, _cs, false, this.dflt)), this.format(e), pt, plugin);
			};
	
			/**
			 * Registers a special property that should be intercepted from any "css" objects defined in tweens. This allows you to handle them however you want without CSSPlugin doing it for you. The 2nd parameter should be a function that accepts 3 parameters:
			 *  1) Target object whose property should be tweened (typically a DOM element)
			 *  2) The end/destination value (could be a string, number, object, or whatever you want)
			 *  3) The tween instance (you probably don't need to worry about this, but it can be useful for looking up information like the duration)
			 *
			 * Then, your function should return a function which will be called each time the tween gets rendered, passing a numeric "ratio" parameter to your function that indicates the change factor (usually between 0 and 1). For example:
			 *
			 * CSSPlugin.registerSpecialProp("myCustomProp", function(target, value, tween) {
			 *      var start = target.style.width;
			 *      return function(ratio) {
			 *              target.style.width = (start + value * ratio) + "px";
			 *              console.log("set width to " + target.style.width);
			 *          }
			 * }, 0);
			 *
			 * Then, when I do this tween, it will trigger my special property:
			 *
			 * TweenLite.to(element, 1, {css:{myCustomProp:100}});
			 *
			 * In the example, of course, we're just changing the width, but you can do anything you want.
			 *
			 * @param {!string} name Property name (or comma-delimited list of property names) that should be intercepted and handled by your function. For example, if I define "myCustomProp", then it would handle that portion of the following tween: TweenLite.to(element, 1, {css:{myCustomProp:100}})
			 * @param {!function(Object, Object, Object, string):function(number)} onInitTween The function that will be called when a tween of this special property is performed. The function will receive 4 parameters: 1) Target object that should be tweened, 2) Value that was passed to the tween, 3) The tween instance itself (rarely used), and 4) The property name that's being tweened. Your function should return a function that should be called on every update of the tween. That function will receive a single parameter that is a "change factor" value (typically between 0 and 1) indicating the amount of change as a ratio. You can use this to determine how to set the values appropriately in your function.
			 * @param {number=} priority Priority that helps the engine determine the order in which to set the properties (default: 0). Higher priority properties will be updated before lower priority ones.
			 */
			CSSPlugin.registerSpecialProp = function(name, onInitTween, priority) {
				_registerComplexSpecialProp(name, {parser:function(t, e, p, cssp, pt, plugin, vars) {
					var rv = new CSSPropTween(t, p, 0, 0, pt, 2, p, false, priority);
					rv.plugin = plugin;
					rv.setRatio = onInitTween(t, e, cssp._tween, p);
					return rv;
				}, priority:priority});
			};
	
	
	
	
	
	
			//transform-related methods and properties
			CSSPlugin.useSVGTransformAttr = true; //Safari and Firefox both have some rendering bugs when applying CSS transforms to SVG elements, so default to using the "transform" attribute instead (users can override this).
			var _transformProps = ("scaleX,scaleY,scaleZ,x,y,z,skewX,skewY,rotation,rotationX,rotationY,perspective,xPercent,yPercent").split(","),
				_transformProp = _checkPropPrefix("transform"), //the Javascript (camelCase) transform property, like msTransform, WebkitTransform, MozTransform, or OTransform.
				_transformPropCSS = _prefixCSS + "transform",
				_transformOriginProp = _checkPropPrefix("transformOrigin"),
				_supports3D = (_checkPropPrefix("perspective") !== null),
				Transform = _internals.Transform = function() {
					this.perspective = parseFloat(CSSPlugin.defaultTransformPerspective) || 0;
					this.force3D = (CSSPlugin.defaultForce3D === false || !_supports3D) ? false : CSSPlugin.defaultForce3D || "auto";
				},
				_SVGElement = _gsScope.SVGElement,
				_useSVGTransformAttr,
				//Some browsers (like Firefox and IE) don't honor transform-origin properly in SVG elements, so we need to manually adjust the matrix accordingly. We feature detect here rather than always doing the conversion for certain browsers because they may fix the problem at some point in the future.
	
				_createSVG = function(type, container, attributes) {
					var element = _doc.createElementNS("http://www.w3.org/2000/svg", type),
						reg = /([a-z])([A-Z])/g,
						p;
					for (p in attributes) {
						element.setAttributeNS(null, p.replace(reg, "$1-$2").toLowerCase(), attributes[p]);
					}
					container.appendChild(element);
					return element;
				},
				_docElement = _doc.documentElement || {},
				_forceSVGTransformAttr = (function() {
					//IE and Android stock don't support CSS transforms on SVG elements, so we must write them to the "transform" attribute. We populate this variable in the _parseTransform() method, and only if/when we come across an SVG element
					var force = _ieVers || (/Android/i.test(_agent) && !_gsScope.chrome),
						svg, rect, width;
					if (_doc.createElementNS && !force) { //IE8 and earlier doesn't support SVG anyway
						svg = _createSVG("svg", _docElement);
						rect = _createSVG("rect", svg, {width:100, height:50, x:100});
						width = rect.getBoundingClientRect().width;
						rect.style[_transformOriginProp] = "50% 50%";
						rect.style[_transformProp] = "scaleX(0.5)";
						force = (width === rect.getBoundingClientRect().width && !(_isFirefox && _supports3D)); //note: Firefox fails the test even though it does support CSS transforms in 3D. Since we can't push 3D stuff into the transform attribute, we force Firefox to pass the test here (as long as it does truly support 3D).
						_docElement.removeChild(svg);
					}
					return force;
				})(),
				_parseSVGOrigin = function(e, local, decoratee, absolute, smoothOrigin, skipRecord) {
					var tm = e._gsTransform,
						m = _getMatrix(e, true),
						v, x, y, xOrigin, yOrigin, a, b, c, d, tx, ty, determinant, xOriginOld, yOriginOld;
					if (tm) {
						xOriginOld = tm.xOrigin; //record the original values before we alter them.
						yOriginOld = tm.yOrigin;
					}
					if (!absolute || (v = absolute.split(" ")).length < 2) {
						b = e.getBBox();
						if (b.x === 0 && b.y === 0 && b.width + b.height === 0) { //some browsers (like Firefox) misreport the bounds if the element has zero width and height (it just assumes it's at x:0, y:0), thus we need to manually grab the position in that case.
							b = {x: parseFloat(e.hasAttribute("x") ? e.getAttribute("x") : e.hasAttribute("cx") ? e.getAttribute("cx") : 0) || 0, y: parseFloat(e.hasAttribute("y") ? e.getAttribute("y") : e.hasAttribute("cy") ? e.getAttribute("cy") : 0) || 0, width:0, height:0};
						}
						local = _parsePosition(local).split(" ");
						v = [(local[0].indexOf("%") !== -1 ? parseFloat(local[0]) / 100 * b.width : parseFloat(local[0])) + b.x,
							 (local[1].indexOf("%") !== -1 ? parseFloat(local[1]) / 100 * b.height : parseFloat(local[1])) + b.y];
					}
					decoratee.xOrigin = xOrigin = parseFloat(v[0]);
					decoratee.yOrigin = yOrigin = parseFloat(v[1]);
					if (absolute && m !== _identity2DMatrix) { //if svgOrigin is being set, we must invert the matrix and determine where the absolute point is, factoring in the current transforms. Otherwise, the svgOrigin would be based on the element's non-transformed position on the canvas.
						a = m[0];
						b = m[1];
						c = m[2];
						d = m[3];
						tx = m[4];
						ty = m[5];
						determinant = (a * d - b * c);
						if (determinant) { //if it's zero (like if scaleX and scaleY are zero), skip it to avoid errors with dividing by zero.
							x = xOrigin * (d / determinant) + yOrigin * (-c / determinant) + ((c * ty - d * tx) / determinant);
							y = xOrigin * (-b / determinant) + yOrigin * (a / determinant) - ((a * ty - b * tx) / determinant);
							xOrigin = decoratee.xOrigin = v[0] = x;
							yOrigin = decoratee.yOrigin = v[1] = y;
						}
					}
					if (tm) { //avoid jump when transformOrigin is changed - adjust the x/y values accordingly
						if (skipRecord) {
							decoratee.xOffset = tm.xOffset;
							decoratee.yOffset = tm.yOffset;
							tm = decoratee;
						}
						if (smoothOrigin || (smoothOrigin !== false && CSSPlugin.defaultSmoothOrigin !== false)) {
							x = xOrigin - xOriginOld;
							y = yOrigin - yOriginOld;
							//originally, we simply adjusted the x and y values, but that would cause problems if, for example, you created a rotational tween part-way through an x/y tween. Managing the offset in a separate variable gives us ultimate flexibility.
							//tm.x -= x - (x * m[0] + y * m[2]);
							//tm.y -= y - (x * m[1] + y * m[3]);
							tm.xOffset += (x * m[0] + y * m[2]) - x;
							tm.yOffset += (x * m[1] + y * m[3]) - y;
						} else {
							tm.xOffset = tm.yOffset = 0;
						}
					}
					if (!skipRecord) {
						e.setAttribute("data-svg-origin", v.join(" "));
					}
				},
				_getBBoxHack = function(swapIfPossible) { //works around issues in some browsers (like Firefox) that don't correctly report getBBox() on SVG elements inside a <defs> element and/or <mask>. We try creating an SVG, adding it to the documentElement and toss the element in there so that it's definitely part of the rendering tree, then grab the bbox and if it works, we actually swap out the original getBBox() method for our own that does these extra steps whenever getBBox is needed. This helps ensure that performance is optimal (only do all these extra steps when absolutely necessary...most elements don't need it).
					var svg = _createElement("svg", (this.ownerSVGElement && this.ownerSVGElement.getAttribute("xmlns")) || "http://www.w3.org/2000/svg"),
						oldParent = this.parentNode,
						oldSibling = this.nextSibling,
						oldCSS = this.style.cssText,
						bbox;
					_docElement.appendChild(svg);
					svg.appendChild(this);
					this.style.display = "block";
					if (swapIfPossible) {
						try {
							bbox = this.getBBox();
							this._originalGetBBox = this.getBBox;
							this.getBBox = _getBBoxHack;
						} catch (e) { }
					} else if (this._originalGetBBox) {
						bbox = this._originalGetBBox();
					}
					if (oldSibling) {
						oldParent.insertBefore(this, oldSibling);
					} else {
						oldParent.appendChild(this);
					}
					_docElement.removeChild(svg);
					this.style.cssText = oldCSS;
					return bbox;
				},
				_getBBox = function(e) {
					try {
						return e.getBBox(); //Firefox throws errors if you try calling getBBox() on an SVG element that's not rendered (like in a <symbol> or <defs>). https://bugzilla.mozilla.org/show_bug.cgi?id=612118
					} catch (error) {
						return _getBBoxHack.call(e, true);
					}
				},
				_isSVG = function(e) { //reports if the element is an SVG on which getBBox() actually works
					return !!(_SVGElement && e.getCTM && (!e.parentNode || e.ownerSVGElement) && _getBBox(e));
				},
				_identity2DMatrix = [1,0,0,1,0,0],
				_getMatrix = function(e, force2D) {
					var tm = e._gsTransform || new Transform(),
						rnd = 100000,
						style = e.style,
						isDefault, s, m, n, dec, none;
					if (_transformProp) {
						s = _getStyle(e, _transformPropCSS, null, true);
					} else if (e.currentStyle) {
						//for older versions of IE, we need to interpret the filter portion that is in the format: progid:DXImageTransform.Microsoft.Matrix(M11=6.123233995736766e-17, M12=-1, M21=1, M22=6.123233995736766e-17, sizingMethod='auto expand') Notice that we need to swap b and c compared to a normal matrix.
						s = e.currentStyle.filter.match(_ieGetMatrixExp);
						s = (s && s.length === 4) ? [s[0].substr(4), Number(s[2].substr(4)), Number(s[1].substr(4)), s[3].substr(4), (tm.x || 0), (tm.y || 0)].join(",") : "";
					}
					isDefault = (!s || s === "none" || s === "matrix(1, 0, 0, 1, 0, 0)");
					if (_transformProp && ((none = (!_getComputedStyle(e) || _getComputedStyle(e).display === "none")) || !e.parentNode)) { //note: Firefox returns null for getComputedStyle() if the element is in an iframe that has display:none. https://bugzilla.mozilla.org/show_bug.cgi?id=548397
						if (none) { //browsers don't report transforms accurately unless the element is in the DOM and has a display value that's not "none". Firefox and Microsoft browsers have a partial bug where they'll report transforms even if display:none BUT not any percentage-based values like translate(-50%, 8px) will be reported as if it's translate(0, 8px).
							n = style.display;
							style.display = "block";
						}
						if (!e.parentNode) {
							dec = 1; //flag
							_docElement.appendChild(e);
						}
						s = _getStyle(e, _transformPropCSS, null, true);
						isDefault = (!s || s === "none" || s === "matrix(1, 0, 0, 1, 0, 0)");
						if (n) {
							style.display = n;
						} else if (none) {
							_removeProp(style, "display");
						}
						if (dec) {
							_docElement.removeChild(e);
						}
					}
					if (tm.svg || (e.getCTM && _isSVG(e))) {
						if (isDefault && (style[_transformProp] + "").indexOf("matrix") !== -1) { //some browsers (like Chrome 40) don't correctly report transforms that are applied inline on an SVG element (they don't get included in the computed style), so we double-check here and accept matrix values
							s = style[_transformProp];
							isDefault = 0;
						}
						m = e.getAttribute("transform");
						if (isDefault && m) {
							m = e.transform.baseVal.consolidate().matrix; //ensures that even complex values like "translate(50,60) rotate(135,0,0)" are parsed because it mashes it into a matrix.
							s = "matrix(" + m.a + "," + m.b + "," + m.c + "," + m.d + "," + m.e + "," + m.f + ")";
							isDefault = 0;
						}
					}
					if (isDefault) {
						return _identity2DMatrix;
					}
					//split the matrix values out into an array (m for matrix)
					m = (s || "").match(_numExp) || [];
					i = m.length;
					while (--i > -1) {
						n = Number(m[i]);
						m[i] = (dec = n - (n |= 0)) ? ((dec * rnd + (dec < 0 ? -0.5 : 0.5)) | 0) / rnd + n : n; //convert strings to Numbers and round to 5 decimal places to avoid issues with tiny numbers. Roughly 20x faster than Number.toFixed(). We also must make sure to round before dividing so that values like 0.9999999999 become 1 to avoid glitches in browser rendering and interpretation of flipped/rotated 3D matrices. And don't just multiply the number by rnd, floor it, and then divide by rnd because the bitwise operations max out at a 32-bit signed integer, thus it could get clipped at a relatively low value (like 22,000.00000 for example).
					}
					return (force2D && m.length > 6) ? [m[0], m[1], m[4], m[5], m[12], m[13]] : m;
				},
	
				/**
				 * Parses the transform values for an element, returning an object with x, y, z, scaleX, scaleY, scaleZ, rotation, rotationX, rotationY, skewX, and skewY properties. Note: by default (for performance reasons), all skewing is combined into skewX and rotation but skewY still has a place in the transform object so that we can record how much of the skew is attributed to skewX vs skewY. Remember, a skewY of 10 looks the same as a rotation of 10 and skewX of -10.
				 * @param {!Object} t target element
				 * @param {Object=} cs computed style object (optional)
				 * @param {boolean=} rec if true, the transform values will be recorded to the target element's _gsTransform object, like target._gsTransform = {x:0, y:0, z:0, scaleX:1...}
				 * @param {boolean=} parse if true, we'll ignore any _gsTransform values that already exist on the element, and force a reparsing of the css (calculated style)
				 * @return {object} object containing all of the transform properties/values like {x:0, y:0, z:0, scaleX:1...}
				 */
				_getTransform = _internals.getTransform = function(t, cs, rec, parse) {
					if (t._gsTransform && rec && !parse) {
						return t._gsTransform; //if the element already has a _gsTransform, use that. Note: some browsers don't accurately return the calculated style for the transform (particularly for SVG), so it's almost always safest to just use the values we've already applied rather than re-parsing things.
					}
					var tm = rec ? t._gsTransform || new Transform() : new Transform(),
						invX = (tm.scaleX < 0), //in order to interpret things properly, we need to know if the user applied a negative scaleX previously so that we can adjust the rotation and skewX accordingly. Otherwise, if we always interpret a flipped matrix as affecting scaleY and the user only wants to tween the scaleX on multiple sequential tweens, it would keep the negative scaleY without that being the user's intent.
						min = 0.00002,
						rnd = 100000,
						zOrigin = _supports3D ? parseFloat(_getStyle(t, _transformOriginProp, cs, false, "0 0 0").split(" ")[2]) || tm.zOrigin  || 0 : 0,
						defaultTransformPerspective = parseFloat(CSSPlugin.defaultTransformPerspective) || 0,
						m, i, scaleX, scaleY, rotation, skewX;
	
					tm.svg = !!(t.getCTM && _isSVG(t));
					if (tm.svg) {
						_parseSVGOrigin(t, _getStyle(t, _transformOriginProp, cs, false, "50% 50%") + "", tm, t.getAttribute("data-svg-origin"));
						_useSVGTransformAttr = CSSPlugin.useSVGTransformAttr || _forceSVGTransformAttr;
					}
					m = _getMatrix(t);
					if (m !== _identity2DMatrix) {
	
						if (m.length === 16) {
							//we'll only look at these position-related 6 variables first because if x/y/z all match, it's relatively safe to assume we don't need to re-parse everything which risks losing important rotational information (like rotationX:180 plus rotationY:180 would look the same as rotation:180 - there's no way to know for sure which direction was taken based solely on the matrix3d() values)
							var a11 = m[0], a21 = m[1], a31 = m[2], a41 = m[3],
								a12 = m[4], a22 = m[5], a32 = m[6], a42 = m[7],
								a13 = m[8], a23 = m[9], a33 = m[10],
								a14 = m[12], a24 = m[13], a34 = m[14],
								a43 = m[11],
								angle = Math.atan2(a32, a33),
								t1, t2, t3, t4, cos, sin;
							//we manually compensate for non-zero z component of transformOrigin to work around bugs in Safari
							if (tm.zOrigin) {
								a34 = -tm.zOrigin;
								a14 = a13*a34-m[12];
								a24 = a23*a34-m[13];
								a34 = a33*a34+tm.zOrigin-m[14];
							}
							//note for possible future consolidation: rotationX: Math.atan2(a32, a33), rotationY: Math.atan2(-a31, Math.sqrt(a33 * a33 + a32 * a32)), rotation: Math.atan2(a21, a11), skew: Math.atan2(a12, a22). However, it doesn't seem to be quite as reliable as the full-on backwards rotation procedure.
							tm.rotationX = angle * _RAD2DEG;
							//rotationX
							if (angle) {
								cos = Math.cos(-angle);
								sin = Math.sin(-angle);
								t1 = a12*cos+a13*sin;
								t2 = a22*cos+a23*sin;
								t3 = a32*cos+a33*sin;
								a13 = a12*-sin+a13*cos;
								a23 = a22*-sin+a23*cos;
								a33 = a32*-sin+a33*cos;
								a43 = a42*-sin+a43*cos;
								a12 = t1;
								a22 = t2;
								a32 = t3;
							}
							//rotationY
							angle = Math.atan2(-a31, a33);
							tm.rotationY = angle * _RAD2DEG;
							if (angle) {
								cos = Math.cos(-angle);
								sin = Math.sin(-angle);
								t1 = a11*cos-a13*sin;
								t2 = a21*cos-a23*sin;
								t3 = a31*cos-a33*sin;
								a23 = a21*sin+a23*cos;
								a33 = a31*sin+a33*cos;
								a43 = a41*sin+a43*cos;
								a11 = t1;
								a21 = t2;
								a31 = t3;
							}
							//rotationZ
							angle = Math.atan2(a21, a11);
							tm.rotation = angle * _RAD2DEG;
							if (angle) {
								cos = Math.cos(angle);
								sin = Math.sin(angle);
								t1 = a11*cos+a21*sin;
								t2 = a12*cos+a22*sin;
								t3 = a13*cos+a23*sin;
								a21 = a21*cos-a11*sin;
								a22 = a22*cos-a12*sin;
								a23 = a23*cos-a13*sin;
								a11 = t1;
								a12 = t2;
								a13 = t3;
							}
	
							if (tm.rotationX && Math.abs(tm.rotationX) + Math.abs(tm.rotation) > 359.9) { //when rotationY is set, it will often be parsed as 180 degrees different than it should be, and rotationX and rotation both being 180 (it looks the same), so we adjust for that here.
								tm.rotationX = tm.rotation = 0;
								tm.rotationY = 180 - tm.rotationY;
							}
	
							//skewX
							angle = Math.atan2(a12, a22);
	
							//scales
							tm.scaleX = ((Math.sqrt(a11 * a11 + a21 * a21 + a31 * a31) * rnd + 0.5) | 0) / rnd;
							tm.scaleY = ((Math.sqrt(a22 * a22 + a32 * a32) * rnd + 0.5) | 0) / rnd;
							tm.scaleZ = ((Math.sqrt(a13 * a13 + a23 * a23 + a33 * a33) * rnd + 0.5) | 0) / rnd;
							a11 /= tm.scaleX;
							a12 /= tm.scaleY;
							a21 /= tm.scaleX;
							a22 /= tm.scaleY;
							if (Math.abs(angle) > min) {
								tm.skewX = angle * _RAD2DEG;
								a12 = 0; //unskews
								if (tm.skewType !== "simple") {
									tm.scaleY *= 1 / Math.cos(angle); //by default, we compensate the scale based on the skew so that the element maintains a similar proportion when skewed, so we have to alter the scaleY here accordingly to match the default (non-adjusted) skewing that CSS does (stretching more and more as it skews).
								}
	
							} else {
								tm.skewX = 0;
							}
	
							/* //for testing purposes
							var transform = "matrix3d(",
								comma = ",",
								zero = "0";
							a13 /= tm.scaleZ;
							a23 /= tm.scaleZ;
							a31 /= tm.scaleX;
							a32 /= tm.scaleY;
							a33 /= tm.scaleZ;
							transform += ((a11 < min && a11 > -min) ? zero : a11) + comma + ((a21 < min && a21 > -min) ? zero : a21) + comma + ((a31 < min && a31 > -min) ? zero : a31);
							transform += comma + ((a41 < min && a41 > -min) ? zero : a41) + comma + ((a12 < min && a12 > -min) ? zero : a12) + comma + ((a22 < min && a22 > -min) ? zero : a22);
							transform += comma + ((a32 < min && a32 > -min) ? zero : a32) + comma + ((a42 < min && a42 > -min) ? zero : a42) + comma + ((a13 < min && a13 > -min) ? zero : a13);
							transform += comma + ((a23 < min && a23 > -min) ? zero : a23) + comma + ((a33 < min && a33 > -min) ? zero : a33) + comma + ((a43 < min && a43 > -min) ? zero : a43) + comma;
							transform += a14 + comma + a24 + comma + a34 + comma + (tm.perspective ? (1 + (-a34 / tm.perspective)) : 1) + ")";
							console.log(transform);
							document.querySelector(".test").style[_transformProp] = transform;
							*/
	
							tm.perspective = a43 ? 1 / ((a43 < 0) ? -a43 : a43) : 0;
							tm.x = a14;
							tm.y = a24;
							tm.z = a34;
							if (tm.svg) {
								tm.x -= tm.xOrigin - (tm.xOrigin * a11 - tm.yOrigin * a12);
								tm.y -= tm.yOrigin - (tm.yOrigin * a21 - tm.xOrigin * a22);
							}
	
						} else if ((!_supports3D || parse || !m.length || tm.x !== m[4] || tm.y !== m[5] || (!tm.rotationX && !tm.rotationY))) { //sometimes a 6-element matrix is returned even when we performed 3D transforms, like if rotationX and rotationY are 180. In cases like this, we still need to honor the 3D transforms. If we just rely on the 2D info, it could affect how the data is interpreted, like scaleY might get set to -1 or rotation could get offset by 180 degrees. For example, do a TweenLite.to(element, 1, {css:{rotationX:180, rotationY:180}}) and then later, TweenLite.to(element, 1, {css:{rotationX:0}}) and without this conditional logic in place, it'd jump to a state of being unrotated when the 2nd tween starts. Then again, we need to honor the fact that the user COULD alter the transforms outside of CSSPlugin, like by manually applying new css, so we try to sense that by looking at x and y because if those changed, we know the changes were made outside CSSPlugin and we force a reinterpretation of the matrix values. Also, in Webkit browsers, if the element's "display" is "none", its calculated style value will always return empty, so if we've already recorded the values in the _gsTransform object, we'll just rely on those.
							var k = (m.length >= 6),
								a = k ? m[0] : 1,
								b = m[1] || 0,
								c = m[2] || 0,
								d = k ? m[3] : 1;
							tm.x = m[4] || 0;
							tm.y = m[5] || 0;
							scaleX = Math.sqrt(a * a + b * b);
							scaleY = Math.sqrt(d * d + c * c);
							rotation = (a || b) ? Math.atan2(b, a) * _RAD2DEG : tm.rotation || 0; //note: if scaleX is 0, we cannot accurately measure rotation. Same for skewX with a scaleY of 0. Therefore, we default to the previously recorded value (or zero if that doesn't exist).
							skewX = (c || d) ? Math.atan2(c, d) * _RAD2DEG + rotation : tm.skewX || 0;
							tm.scaleX = scaleX;
							tm.scaleY = scaleY;
							tm.rotation = rotation;
							tm.skewX = skewX;
							if (_supports3D) {
								tm.rotationX = tm.rotationY = tm.z = 0;
								tm.perspective = defaultTransformPerspective;
								tm.scaleZ = 1;
							}
							if (tm.svg) {
								tm.x -= tm.xOrigin - (tm.xOrigin * a + tm.yOrigin * c);
								tm.y -= tm.yOrigin - (tm.xOrigin * b + tm.yOrigin * d);
							}
						}
						if (Math.abs(tm.skewX) > 90 && Math.abs(tm.skewX) < 270) {
							if (invX) {
								tm.scaleX *= -1;
								tm.skewX += (tm.rotation <= 0) ? 180 : -180;
								tm.rotation += (tm.rotation <= 0) ? 180 : -180;
							} else {
								tm.scaleY *= -1;
								tm.skewX += (tm.skewX <= 0) ? 180 : -180;
							}
						}
						tm.zOrigin = zOrigin;
						//some browsers have a hard time with very small values like 2.4492935982947064e-16 (notice the "e-" towards the end) and would render the object slightly off. So we round to 0 in these cases. The conditional logic here is faster than calling Math.abs(). Also, browsers tend to render a SLIGHTLY rotated object in a fuzzy way, so we need to snap to exactly 0 when appropriate.
						for (i in tm) {
							if (tm[i] < min) if (tm[i] > -min) {
								tm[i] = 0;
							}
						}
					}
					//DEBUG: _log("parsed rotation of " + t.getAttribute("id")+": "+(tm.rotationX)+", "+(tm.rotationY)+", "+(tm.rotation)+", scale: "+tm.scaleX+", "+tm.scaleY+", "+tm.scaleZ+", position: "+tm.x+", "+tm.y+", "+tm.z+", perspective: "+tm.perspective+ ", origin: "+ tm.xOrigin+ ","+ tm.yOrigin);
					if (rec) {
						t._gsTransform = tm; //record to the object's _gsTransform which we use so that tweens can control individual properties independently (we need all the properties to accurately recompose the matrix in the setRatio() method)
						if (tm.svg) { //if we're supposed to apply transforms to the SVG element's "transform" attribute, make sure there aren't any CSS transforms applied or they'll override the attribute ones. Also clear the transform attribute if we're using CSS, just to be clean.
							if (_useSVGTransformAttr && t.style[_transformProp]) {
								TweenLite.delayedCall(0.001, function(){ //if we apply this right away (before anything has rendered), we risk there being no transforms for a brief moment and it also interferes with adjusting the transformOrigin in a tween with immediateRender:true (it'd try reading the matrix and it wouldn't have the appropriate data in place because we just removed it).
									_removeProp(t.style, _transformProp);
								});
							} else if (!_useSVGTransformAttr && t.getAttribute("transform")) {
								TweenLite.delayedCall(0.001, function(){
									t.removeAttribute("transform");
								});
							}
						}
					}
					return tm;
				},
	
				//for setting 2D transforms in IE6, IE7, and IE8 (must use a "filter" to emulate the behavior of modern day browser transforms)
				_setIETransformRatio = function(v) {
					var t = this.data, //refers to the element's _gsTransform object
						ang = -t.rotation * _DEG2RAD,
						skew = ang + t.skewX * _DEG2RAD,
						rnd = 100000,
						a = ((Math.cos(ang) * t.scaleX * rnd) | 0) / rnd,
						b = ((Math.sin(ang) * t.scaleX * rnd) | 0) / rnd,
						c = ((Math.sin(skew) * -t.scaleY * rnd) | 0) / rnd,
						d = ((Math.cos(skew) * t.scaleY * rnd) | 0) / rnd,
						style = this.t.style,
						cs = this.t.currentStyle,
						filters, val;
					if (!cs) {
						return;
					}
					val = b; //just for swapping the variables an inverting them (reused "val" to avoid creating another variable in memory). IE's filter matrix uses a non-standard matrix configuration (angle goes the opposite way, and b and c are reversed and inverted)
					b = -c;
					c = -val;
					filters = cs.filter;
					style.filter = ""; //remove filters so that we can accurately measure offsetWidth/offsetHeight
					var w = this.t.offsetWidth,
						h = this.t.offsetHeight,
						clip = (cs.position !== "absolute"),
						m = "progid:DXImageTransform.Microsoft.Matrix(M11=" + a + ", M12=" + b + ", M21=" + c + ", M22=" + d,
						ox = t.x + (w * t.xPercent / 100),
						oy = t.y + (h * t.yPercent / 100),
						dx, dy;
	
					//if transformOrigin is being used, adjust the offset x and y
					if (t.ox != null) {
						dx = ((t.oxp) ? w * t.ox * 0.01 : t.ox) - w / 2;
						dy = ((t.oyp) ? h * t.oy * 0.01 : t.oy) - h / 2;
						ox += dx - (dx * a + dy * b);
						oy += dy - (dx * c + dy * d);
					}
	
					if (!clip) {
						m += ", sizingMethod='auto expand')";
					} else {
						dx = (w / 2);
						dy = (h / 2);
						//translate to ensure that transformations occur around the correct origin (default is center).
						m += ", Dx=" + (dx - (dx * a + dy * b) + ox) + ", Dy=" + (dy - (dx * c + dy * d) + oy) + ")";
					}
					if (filters.indexOf("DXImageTransform.Microsoft.Matrix(") !== -1) {
						style.filter = filters.replace(_ieSetMatrixExp, m);
					} else {
						style.filter = m + " " + filters; //we must always put the transform/matrix FIRST (before alpha(opacity=xx)) to avoid an IE bug that slices part of the object when rotation is applied with alpha.
					}
	
					//at the end or beginning of the tween, if the matrix is normal (1, 0, 0, 1) and opacity is 100 (or doesn't exist), remove the filter to improve browser performance.
					if (v === 0 || v === 1) if (a === 1) if (b === 0) if (c === 0) if (d === 1) if (!clip || m.indexOf("Dx=0, Dy=0") !== -1) if (!_opacityExp.test(filters) || parseFloat(RegExp.$1) === 100) if (filters.indexOf("gradient(" && filters.indexOf("Alpha")) === -1) {
						style.removeAttribute("filter");
					}
	
					//we must set the margins AFTER applying the filter in order to avoid some bugs in IE8 that could (in rare scenarios) cause them to be ignored intermittently (vibration).
					if (!clip) {
						var mult = (_ieVers < 8) ? 1 : -1, //in Internet Explorer 7 and before, the box model is broken, causing the browser to treat the width/height of the actual rotated filtered image as the width/height of the box itself, but Microsoft corrected that in IE8. We must use a negative offset in IE8 on the right/bottom
							marg, prop, dif;
						dx = t.ieOffsetX || 0;
						dy = t.ieOffsetY || 0;
						t.ieOffsetX = Math.round((w - ((a < 0 ? -a : a) * w + (b < 0 ? -b : b) * h)) / 2 + ox);
						t.ieOffsetY = Math.round((h - ((d < 0 ? -d : d) * h + (c < 0 ? -c : c) * w)) / 2 + oy);
						for (i = 0; i < 4; i++) {
							prop = _margins[i];
							marg = cs[prop];
							//we need to get the current margin in case it is being tweened separately (we want to respect that tween's changes)
							val = (marg.indexOf("px") !== -1) ? parseFloat(marg) : _convertToPixels(this.t, prop, parseFloat(marg), marg.replace(_suffixExp, "")) || 0;
							if (val !== t[prop]) {
								dif = (i < 2) ? -t.ieOffsetX : -t.ieOffsetY; //if another tween is controlling a margin, we cannot only apply the difference in the ieOffsets, so we essentially zero-out the dx and dy here in that case. We record the margin(s) later so that we can keep comparing them, making this code very flexible.
							} else {
								dif = (i < 2) ? dx - t.ieOffsetX : dy - t.ieOffsetY;
							}
							style[prop] = (t[prop] = Math.round( val - dif * ((i === 0 || i === 2) ? 1 : mult) )) + "px";
						}
					}
				},
	
				/* translates a super small decimal to a string WITHOUT scientific notation
				_safeDecimal = function(n) {
					var s = (n < 0 ? -n : n) + "",
						a = s.split("e-");
					return (n < 0 ? "-0." : "0.") + new Array(parseInt(a[1], 10) || 0).join("0") + a[0].split(".").join("");
				},
				*/
	
				_setTransformRatio = _internals.set3DTransformRatio = _internals.setTransformRatio = function(v) {
					var t = this.data, //refers to the element's _gsTransform object
						style = this.t.style,
						angle = t.rotation,
						rotationX = t.rotationX,
						rotationY = t.rotationY,
						sx = t.scaleX,
						sy = t.scaleY,
						sz = t.scaleZ,
						x = t.x,
						y = t.y,
						z = t.z,
						isSVG = t.svg,
						perspective = t.perspective,
						force3D = t.force3D,
						skewY = t.skewY,
						skewX = t.skewX,
						t1,	a11, a12, a13, a21, a22, a23, a31, a32, a33, a41, a42, a43,
						zOrigin, min, cos, sin, t2, transform, comma, zero, skew, rnd;
					if (skewY) { //for performance reasons, we combine all skewing into the skewX and rotation values. Remember, a skewY of 10 degrees looks the same as a rotation of 10 degrees plus a skewX of 10 degrees.
						skewX += skewY;
						angle += skewY;
					}
	
					//check to see if we should render as 2D (and SVGs must use 2D when _useSVGTransformAttr is true)
					if (((((v === 1 || v === 0) && force3D === "auto" && (this.tween._totalTime === this.tween._totalDuration || !this.tween._totalTime)) || !force3D) && !z && !perspective && !rotationY && !rotationX && sz === 1) || (_useSVGTransformAttr && isSVG) || !_supports3D) { //on the final render (which could be 0 for a from tween), if there are no 3D aspects, render in 2D to free up memory and improve performance especially on mobile devices. Check the tween's totalTime/totalDuration too in order to make sure it doesn't happen between repeats if it's a repeating tween.
	
						//2D
						if (angle || skewX || isSVG) {
							angle *= _DEG2RAD;
							skew = skewX * _DEG2RAD;
							rnd = 100000;
							a11 = Math.cos(angle) * sx;
							a21 = Math.sin(angle) * sx;
							a12 = Math.sin(angle - skew) * -sy;
							a22 = Math.cos(angle - skew) * sy;
							if (skew && t.skewType === "simple") { //by default, we compensate skewing on the other axis to make it look more natural, but you can set the skewType to "simple" to use the uncompensated skewing that CSS does
								t1 = Math.tan(skew - skewY * _DEG2RAD);
								t1 = Math.sqrt(1 + t1 * t1);
								a12 *= t1;
								a22 *= t1;
								if (skewY) {
									t1 = Math.tan(skewY * _DEG2RAD);
									t1 = Math.sqrt(1 + t1 * t1);
									a11 *= t1;
									a21 *= t1;
								}
							}
							if (isSVG) {
								x += t.xOrigin - (t.xOrigin * a11 + t.yOrigin * a12) + t.xOffset;
								y += t.yOrigin - (t.xOrigin * a21 + t.yOrigin * a22) + t.yOffset;
								if (_useSVGTransformAttr && (t.xPercent || t.yPercent)) { //The SVG spec doesn't support percentage-based translation in the "transform" attribute, so we merge it into the matrix to simulate it.
									min = this.t.getBBox();
									x += t.xPercent * 0.01 * min.width;
									y += t.yPercent * 0.01 * min.height;
								}
								min = 0.000001;
								if (x < min) if (x > -min) {
									x = 0;
								}
								if (y < min) if (y > -min) {
									y = 0;
								}
							}
							transform = (((a11 * rnd) | 0) / rnd) + "," + (((a21 * rnd) | 0) / rnd) + "," + (((a12 * rnd) | 0) / rnd) + "," + (((a22 * rnd) | 0) / rnd) + "," + x + "," + y + ")";
							if (isSVG && _useSVGTransformAttr) {
								this.t.setAttribute("transform", "matrix(" + transform);
							} else {
								//some browsers have a hard time with very small values like 2.4492935982947064e-16 (notice the "e-" towards the end) and would render the object slightly off. So we round to 5 decimal places.
								style[_transformProp] = ((t.xPercent || t.yPercent) ? "translate(" + t.xPercent + "%," + t.yPercent + "%) matrix(" : "matrix(") + transform;
							}
						} else {
							style[_transformProp] = ((t.xPercent || t.yPercent) ? "translate(" + t.xPercent + "%," + t.yPercent + "%) matrix(" : "matrix(") + sx + ",0,0," + sy + "," + x + "," + y + ")";
						}
						return;
	
					}
					if (_isFirefox) { //Firefox has a bug (at least in v25) that causes it to render the transparent part of 32-bit PNG images as black when displayed inside an iframe and the 3D scale is very small and doesn't change sufficiently enough between renders (like if you use a Power4.easeInOut to scale from 0 to 1 where the beginning values only change a tiny amount to begin the tween before accelerating). In this case, we force the scale to be 0.00002 instead which is visually the same but works around the Firefox issue.
						min = 0.0001;
						if (sx < min && sx > -min) {
							sx = sz = 0.00002;
						}
						if (sy < min && sy > -min) {
							sy = sz = 0.00002;
						}
						if (perspective && !t.z && !t.rotationX && !t.rotationY) { //Firefox has a bug that causes elements to have an odd super-thin, broken/dotted black border on elements that have a perspective set but aren't utilizing 3D space (no rotationX, rotationY, or z).
							perspective = 0;
						}
					}
					if (angle || skewX) {
						angle *= _DEG2RAD;
						cos = a11 = Math.cos(angle);
						sin = a21 = Math.sin(angle);
						if (skewX) {
							angle -= skewX * _DEG2RAD;
							cos = Math.cos(angle);
							sin = Math.sin(angle);
							if (t.skewType === "simple") { //by default, we compensate skewing on the other axis to make it look more natural, but you can set the skewType to "simple" to use the uncompensated skewing that CSS does
								t1 = Math.tan((skewX - skewY) * _DEG2RAD);
								t1 = Math.sqrt(1 + t1 * t1);
								cos *= t1;
								sin *= t1;
								if (t.skewY) {
									t1 = Math.tan(skewY * _DEG2RAD);
									t1 = Math.sqrt(1 + t1 * t1);
									a11 *= t1;
									a21 *= t1;
								}
							}
						}
						a12 = -sin;
						a22 = cos;
	
					} else if (!rotationY && !rotationX && sz === 1 && !perspective && !isSVG) { //if we're only translating and/or 2D scaling, this is faster...
						style[_transformProp] = ((t.xPercent || t.yPercent) ? "translate(" + t.xPercent + "%," + t.yPercent + "%) translate3d(" : "translate3d(") + x + "px," + y + "px," + z +"px)" + ((sx !== 1 || sy !== 1) ? " scale(" + sx + "," + sy + ")" : "");
						return;
					} else {
						a11 = a22 = 1;
						a12 = a21 = 0;
					}
					// KEY  INDEX   AFFECTS a[row][column]
					// a11  0       rotation, rotationY, scaleX
					// a21  1       rotation, rotationY, scaleX
					// a31  2       rotationY, scaleX
					// a41  3       rotationY, scaleX
					// a12  4       rotation, skewX, rotationX, scaleY
					// a22  5       rotation, skewX, rotationX, scaleY
					// a32  6       rotationX, scaleY
					// a42  7       rotationX, scaleY
					// a13  8       rotationY, rotationX, scaleZ
					// a23  9       rotationY, rotationX, scaleZ
					// a33  10      rotationY, rotationX, scaleZ
					// a43  11      rotationY, rotationX, perspective, scaleZ
					// a14  12      x, zOrigin, svgOrigin
					// a24  13      y, zOrigin, svgOrigin
					// a34  14      z, zOrigin
					// a44  15
					// rotation: Math.atan2(a21, a11)
					// rotationY: Math.atan2(a13, a33) (or Math.atan2(a13, a11))
					// rotationX: Math.atan2(a32, a33)
					a33 = 1;
					a13 = a23 = a31 = a32 = a41 = a42 = 0;
					a43 = (perspective) ? -1 / perspective : 0;
					zOrigin = t.zOrigin;
					min = 0.000001; //threshold below which browsers use scientific notation which won't work.
					comma = ",";
					zero = "0";
					angle = rotationY * _DEG2RAD;
					if (angle) {
						cos = Math.cos(angle);
						sin = Math.sin(angle);
						a31 = -sin;
						a41 = a43*-sin;
						a13 = a11*sin;
						a23 = a21*sin;
						a33 = cos;
						a43 *= cos;
						a11 *= cos;
						a21 *= cos;
					}
					angle = rotationX * _DEG2RAD;
					if (angle) {
						cos = Math.cos(angle);
						sin = Math.sin(angle);
						t1 = a12*cos+a13*sin;
						t2 = a22*cos+a23*sin;
						a32 = a33*sin;
						a42 = a43*sin;
						a13 = a12*-sin+a13*cos;
						a23 = a22*-sin+a23*cos;
						a33 = a33*cos;
						a43 = a43*cos;
						a12 = t1;
						a22 = t2;
					}
					if (sz !== 1) {
						a13*=sz;
						a23*=sz;
						a33*=sz;
						a43*=sz;
					}
					if (sy !== 1) {
						a12*=sy;
						a22*=sy;
						a32*=sy;
						a42*=sy;
					}
					if (sx !== 1) {
						a11*=sx;
						a21*=sx;
						a31*=sx;
						a41*=sx;
					}
	
					if (zOrigin || isSVG) {
						if (zOrigin) {
							x += a13*-zOrigin;
							y += a23*-zOrigin;
							z += a33*-zOrigin+zOrigin;
						}
						if (isSVG) { //due to bugs in some browsers, we need to manage the transform-origin of SVG manually
							x += t.xOrigin - (t.xOrigin * a11 + t.yOrigin * a12) + t.xOffset;
							y += t.yOrigin - (t.xOrigin * a21 + t.yOrigin * a22) + t.yOffset;
						}
						if (x < min && x > -min) {
							x = zero;
						}
						if (y < min && y > -min) {
							y = zero;
						}
						if (z < min && z > -min) {
							z = 0; //don't use string because we calculate perspective later and need the number.
						}
					}
	
					//optimized way of concatenating all the values into a string. If we do it all in one shot, it's slower because of the way browsers have to create temp strings and the way it affects memory. If we do it piece-by-piece with +=, it's a bit slower too. We found that doing it in these sized chunks works best overall:
					transform = ((t.xPercent || t.yPercent) ? "translate(" + t.xPercent + "%," + t.yPercent + "%) matrix3d(" : "matrix3d(");
					transform += ((a11 < min && a11 > -min) ? zero : a11) + comma + ((a21 < min && a21 > -min) ? zero : a21) + comma + ((a31 < min && a31 > -min) ? zero : a31);
					transform += comma + ((a41 < min && a41 > -min) ? zero : a41) + comma + ((a12 < min && a12 > -min) ? zero : a12) + comma + ((a22 < min && a22 > -min) ? zero : a22);
					if (rotationX || rotationY || sz !== 1) { //performance optimization (often there's no rotationX or rotationY, so we can skip these calculations)
						transform += comma + ((a32 < min && a32 > -min) ? zero : a32) + comma + ((a42 < min && a42 > -min) ? zero : a42) + comma + ((a13 < min && a13 > -min) ? zero : a13);
						transform += comma + ((a23 < min && a23 > -min) ? zero : a23) + comma + ((a33 < min && a33 > -min) ? zero : a33) + comma + ((a43 < min && a43 > -min) ? zero : a43) + comma;
					} else {
						transform += ",0,0,0,0,1,0,";
					}
					transform += x + comma + y + comma + z + comma + (perspective ? (1 + (-z / perspective)) : 1) + ")";
	
					style[_transformProp] = transform;
				};
	
			p = Transform.prototype;
			p.x = p.y = p.z = p.skewX = p.skewY = p.rotation = p.rotationX = p.rotationY = p.zOrigin = p.xPercent = p.yPercent = p.xOffset = p.yOffset = 0;
			p.scaleX = p.scaleY = p.scaleZ = 1;
	
			_registerComplexSpecialProp("transform,scale,scaleX,scaleY,scaleZ,x,y,z,rotation,rotationX,rotationY,rotationZ,skewX,skewY,shortRotation,shortRotationX,shortRotationY,shortRotationZ,transformOrigin,svgOrigin,transformPerspective,directionalRotation,parseTransform,force3D,skewType,xPercent,yPercent,smoothOrigin", {parser:function(t, e, parsingProp, cssp, pt, plugin, vars) {
				if (cssp._lastParsedTransform === vars) { return pt; } //only need to parse the transform once, and only if the browser supports it.
				cssp._lastParsedTransform = vars;
				var scaleFunc = (vars.scale && typeof(vars.scale) === "function") ? vars.scale : 0, //if there's a function-based "scale" value, swap in the resulting numeric value temporarily. Otherwise, if it's called for both scaleX and scaleY independently, they may not match (like if the function uses Math.random()).
					swapFunc;
				if (typeof(vars[parsingProp]) === "function") { //whatever property triggers the initial parsing might be a function-based value in which case it already got called in parse(), thus we don't want to call it again in here. The most efficient way to avoid this is to temporarily swap the value directly into the vars object, and then after we do all our parsing in this function, we'll swap it back again.
					swapFunc = vars[parsingProp];
					vars[parsingProp] = e;
				}
				if (scaleFunc) {
					vars.scale = scaleFunc(_index, t);
				}
				var originalGSTransform = t._gsTransform,
					style = t.style,
					min = 0.000001,
					i = _transformProps.length,
					v = vars,
					endRotations = {},
					transformOriginString = "transformOrigin",
					m1 = _getTransform(t, _cs, true, v.parseTransform),
					orig = v.transform && ((typeof(v.transform) === "function") ? v.transform(_index, _target) : v.transform),
					m2, copy, has3D, hasChange, dr, x, y, matrix, p;
				m1.skewType = v.skewType || m1.skewType || CSSPlugin.defaultSkewType;
				cssp._transform = m1;
				if (orig && typeof(orig) === "string" && _transformProp) { //for values like transform:"rotate(60deg) scale(0.5, 0.8)"
					copy = _tempDiv.style; //don't use the original target because it might be SVG in which case some browsers don't report computed style correctly.
					copy[_transformProp] = orig;
					copy.display = "block"; //if display is "none", the browser often refuses to report the transform properties correctly.
					copy.position = "absolute";
					if (orig.indexOf("%") !== -1) { //%-based translations will fail unless we set the width/height to match the original target...
						copy.width = _getStyle(t, "width");
						copy.height = _getStyle(t, "height");
					}
					_doc.body.appendChild(_tempDiv);
					m2 = _getTransform(_tempDiv, null, false);
					if (m1.skewType === "simple") { //the default _getTransform() reports the skewX/scaleY as if skewType is "compensated", thus we need to adjust that here if skewType is "simple".
						m2.scaleY *= Math.cos(m2.skewX * _DEG2RAD);
					}
					if (m1.svg) { //if it's an SVG element, x/y part of the matrix will be affected by whatever we use as the origin and the offsets, so compensate here...
						x = m1.xOrigin;
						y = m1.yOrigin;
						m2.x -= m1.xOffset;
						m2.y -= m1.yOffset;
						if (v.transformOrigin || v.svgOrigin) { //if this tween is altering the origin, we must factor that in here. The actual work of recording the transformOrigin values and setting up the PropTween is done later (still inside this function) so we cannot leave the changes intact here - we only want to update the x/y accordingly.
							orig = {};
							_parseSVGOrigin(t, _parsePosition(v.transformOrigin), orig, v.svgOrigin, v.smoothOrigin, true);
							x = orig.xOrigin;
							y = orig.yOrigin;
							m2.x -= orig.xOffset - m1.xOffset;
							m2.y -= orig.yOffset - m1.yOffset;
						}
						if (x || y) {
							matrix = _getMatrix(_tempDiv, true);
							m2.x -= x - (x * matrix[0] + y * matrix[2]);
							m2.y -= y - (x * matrix[1] + y * matrix[3]);
						}
					}
					_doc.body.removeChild(_tempDiv);
					if (!m2.perspective) {
						m2.perspective = m1.perspective; //tweening to no perspective gives very unintuitive results - just keep the same perspective in that case.
					}
					if (v.xPercent != null) {
						m2.xPercent = _parseVal(v.xPercent, m1.xPercent);
					}
					if (v.yPercent != null) {
						m2.yPercent = _parseVal(v.yPercent, m1.yPercent);
					}
				} else if (typeof(v) === "object") { //for values like scaleX, scaleY, rotation, x, y, skewX, and skewY or transform:{...} (object)
					m2 = {scaleX:_parseVal((v.scaleX != null) ? v.scaleX : v.scale, m1.scaleX),
						scaleY:_parseVal((v.scaleY != null) ? v.scaleY : v.scale, m1.scaleY),
						scaleZ:_parseVal(v.scaleZ, m1.scaleZ),
						x:_parseVal(v.x, m1.x),
						y:_parseVal(v.y, m1.y),
						z:_parseVal(v.z, m1.z),
						xPercent:_parseVal(v.xPercent, m1.xPercent),
						yPercent:_parseVal(v.yPercent, m1.yPercent),
						perspective:_parseVal(v.transformPerspective, m1.perspective)};
					dr = v.directionalRotation;
					if (dr != null) {
						if (typeof(dr) === "object") {
							for (copy in dr) {
								v[copy] = dr[copy];
							}
						} else {
							v.rotation = dr;
						}
					}
					if (typeof(v.x) === "string" && v.x.indexOf("%") !== -1) {
						m2.x = 0;
						m2.xPercent = _parseVal(v.x, m1.xPercent);
					}
					if (typeof(v.y) === "string" && v.y.indexOf("%") !== -1) {
						m2.y = 0;
						m2.yPercent = _parseVal(v.y, m1.yPercent);
					}
	
					m2.rotation = _parseAngle(("rotation" in v) ? v.rotation : ("shortRotation" in v) ? v.shortRotation + "_short" : ("rotationZ" in v) ? v.rotationZ : m1.rotation, m1.rotation, "rotation", endRotations);
					if (_supports3D) {
						m2.rotationX = _parseAngle(("rotationX" in v) ? v.rotationX : ("shortRotationX" in v) ? v.shortRotationX + "_short" : m1.rotationX || 0, m1.rotationX, "rotationX", endRotations);
						m2.rotationY = _parseAngle(("rotationY" in v) ? v.rotationY : ("shortRotationY" in v) ? v.shortRotationY + "_short" : m1.rotationY || 0, m1.rotationY, "rotationY", endRotations);
					}
					m2.skewX = _parseAngle(v.skewX, m1.skewX);
					m2.skewY = _parseAngle(v.skewY, m1.skewY);
				}
				if (_supports3D && v.force3D != null) {
					m1.force3D = v.force3D;
					hasChange = true;
				}
	
				has3D = (m1.force3D || m1.z || m1.rotationX || m1.rotationY || m2.z || m2.rotationX || m2.rotationY || m2.perspective);
				if (!has3D && v.scale != null) {
					m2.scaleZ = 1; //no need to tween scaleZ.
				}
	
				while (--i > -1) {
					p = _transformProps[i];
					orig = m2[p] - m1[p];
					if (orig > min || orig < -min || v[p] != null || _forcePT[p] != null) {
						hasChange = true;
						pt = new CSSPropTween(m1, p, m1[p], orig, pt);
						if (p in endRotations) {
							pt.e = endRotations[p]; //directional rotations typically have compensated values during the tween, but we need to make sure they end at exactly what the user requested
						}
						pt.xs0 = 0; //ensures the value stays numeric in setRatio()
						pt.plugin = plugin;
						cssp._overwriteProps.push(pt.n);
					}
				}
	
				orig = v.transformOrigin;
				if (m1.svg && (orig || v.svgOrigin)) {
					x = m1.xOffset; //when we change the origin, in order to prevent things from jumping we adjust the x/y so we must record those here so that we can create PropTweens for them and flip them at the same time as the origin
					y = m1.yOffset;
					_parseSVGOrigin(t, _parsePosition(orig), m2, v.svgOrigin, v.smoothOrigin);
					pt = _addNonTweeningNumericPT(m1, "xOrigin", (originalGSTransform ? m1 : m2).xOrigin, m2.xOrigin, pt, transformOriginString); //note: if there wasn't a transformOrigin defined yet, just start with the destination one; it's wasteful otherwise, and it causes problems with fromTo() tweens. For example, TweenLite.to("#wheel", 3, {rotation:180, transformOrigin:"50% 50%", delay:1}); TweenLite.fromTo("#wheel", 3, {scale:0.5, transformOrigin:"50% 50%"}, {scale:1, delay:2}); would cause a jump when the from values revert at the beginning of the 2nd tween.
					pt = _addNonTweeningNumericPT(m1, "yOrigin", (originalGSTransform ? m1 : m2).yOrigin, m2.yOrigin, pt, transformOriginString);
					if (x !== m1.xOffset || y !== m1.yOffset) {
						pt = _addNonTweeningNumericPT(m1, "xOffset", (originalGSTransform ? x : m1.xOffset), m1.xOffset, pt, transformOriginString);
						pt = _addNonTweeningNumericPT(m1, "yOffset", (originalGSTransform ? y : m1.yOffset), m1.yOffset, pt, transformOriginString);
					}
					orig = "0px 0px"; //certain browsers (like firefox) completely botch transform-origin, so we must remove it to prevent it from contaminating transforms. We manage it ourselves with xOrigin and yOrigin
				}
				if (orig || (_supports3D && has3D && m1.zOrigin)) { //if anything 3D is happening and there's a transformOrigin with a z component that's non-zero, we must ensure that the transformOrigin's z-component is set to 0 so that we can manually do those calculations to get around Safari bugs. Even if the user didn't specifically define a "transformOrigin" in this particular tween (maybe they did it via css directly).
					if (_transformProp) {
						hasChange = true;
						p = _transformOriginProp;
						orig = (orig || _getStyle(t, p, _cs, false, "50% 50%")) + ""; //cast as string to avoid errors
						pt = new CSSPropTween(style, p, 0, 0, pt, -1, transformOriginString);
						pt.b = style[p];
						pt.plugin = plugin;
						if (_supports3D) {
							copy = m1.zOrigin;
							orig = orig.split(" ");
							m1.zOrigin = ((orig.length > 2 && !(copy !== 0 && orig[2] === "0px")) ? parseFloat(orig[2]) : copy) || 0; //Safari doesn't handle the z part of transformOrigin correctly, so we'll manually handle it in the _set3DTransformRatio() method.
							pt.xs0 = pt.e = orig[0] + " " + (orig[1] || "50%") + " 0px"; //we must define a z value of 0px specifically otherwise iOS 5 Safari will stick with the old one (if one was defined)!
							pt = new CSSPropTween(m1, "zOrigin", 0, 0, pt, -1, pt.n); //we must create a CSSPropTween for the _gsTransform.zOrigin so that it gets reset properly at the beginning if the tween runs backward (as opposed to just setting m1.zOrigin here)
							pt.b = copy;
							pt.xs0 = pt.e = m1.zOrigin;
						} else {
							pt.xs0 = pt.e = orig;
						}
	
						//for older versions of IE (6-8), we need to manually calculate things inside the setRatio() function. We record origin x and y (ox and oy) and whether or not the values are percentages (oxp and oyp).
					} else {
						_parsePosition(orig + "", m1);
					}
				}
				if (hasChange) {
					cssp._transformType = (!(m1.svg && _useSVGTransformAttr) && (has3D || this._transformType === 3)) ? 3 : 2; //quicker than calling cssp._enableTransforms();
				}
				if (swapFunc) {
					vars[parsingProp] = swapFunc;
				}
				if (scaleFunc) {
					vars.scale = scaleFunc;
				}
				return pt;
			}, prefix:true});
	
			_registerComplexSpecialProp("boxShadow", {defaultValue:"0px 0px 0px 0px #999", prefix:true, color:true, multi:true, keyword:"inset"});
	
			_registerComplexSpecialProp("borderRadius", {defaultValue:"0px", parser:function(t, e, p, cssp, pt, plugin) {
				e = this.format(e);
				var props = ["borderTopLeftRadius","borderTopRightRadius","borderBottomRightRadius","borderBottomLeftRadius"],
					style = t.style,
					ea1, i, es2, bs2, bs, es, bn, en, w, h, esfx, bsfx, rel, hn, vn, em;
				w = parseFloat(t.offsetWidth);
				h = parseFloat(t.offsetHeight);
				ea1 = e.split(" ");
				for (i = 0; i < props.length; i++) { //if we're dealing with percentages, we must convert things separately for the horizontal and vertical axis!
					if (this.p.indexOf("border")) { //older browsers used a prefix
						props[i] = _checkPropPrefix(props[i]);
					}
					bs = bs2 = _getStyle(t, props[i], _cs, false, "0px");
					if (bs.indexOf(" ") !== -1) {
						bs2 = bs.split(" ");
						bs = bs2[0];
						bs2 = bs2[1];
					}
					es = es2 = ea1[i];
					bn = parseFloat(bs);
					bsfx = bs.substr((bn + "").length);
					rel = (es.charAt(1) === "=");
					if (rel) {
						en = parseInt(es.charAt(0)+"1", 10);
						es = es.substr(2);
						en *= parseFloat(es);
						esfx = es.substr((en + "").length - (en < 0 ? 1 : 0)) || "";
					} else {
						en = parseFloat(es);
						esfx = es.substr((en + "").length);
					}
					if (esfx === "") {
						esfx = _suffixMap[p] || bsfx;
					}
					if (esfx !== bsfx) {
						hn = _convertToPixels(t, "borderLeft", bn, bsfx); //horizontal number (we use a bogus "borderLeft" property just because the _convertToPixels() method searches for the keywords "Left", "Right", "Top", and "Bottom" to determine of it's a horizontal or vertical property, and we need "border" in the name so that it knows it should measure relative to the element itself, not its parent.
						vn = _convertToPixels(t, "borderTop", bn, bsfx); //vertical number
						if (esfx === "%") {
							bs = (hn / w * 100) + "%";
							bs2 = (vn / h * 100) + "%";
						} else if (esfx === "em") {
							em = _convertToPixels(t, "borderLeft", 1, "em");
							bs = (hn / em) + "em";
							bs2 = (vn / em) + "em";
						} else {
							bs = hn + "px";
							bs2 = vn + "px";
						}
						if (rel) {
							es = (parseFloat(bs) + en) + esfx;
							es2 = (parseFloat(bs2) + en) + esfx;
						}
					}
					pt = _parseComplex(style, props[i], bs + " " + bs2, es + " " + es2, false, "0px", pt);
				}
				return pt;
			}, prefix:true, formatter:_getFormatter("0px 0px 0px 0px", false, true)});
			_registerComplexSpecialProp("borderBottomLeftRadius,borderBottomRightRadius,borderTopLeftRadius,borderTopRightRadius", {defaultValue:"0px", parser:function(t, e, p, cssp, pt, plugin) {
				return _parseComplex(t.style, p, this.format(_getStyle(t, p, _cs, false, "0px 0px")), this.format(e), false, "0px", pt);
			}, prefix:true, formatter:_getFormatter("0px 0px", false, true)});
			_registerComplexSpecialProp("backgroundPosition", {defaultValue:"0 0", parser:function(t, e, p, cssp, pt, plugin) {
				var bp = "background-position",
					cs = (_cs || _getComputedStyle(t, null)),
					bs = this.format( ((cs) ? _ieVers ? cs.getPropertyValue(bp + "-x") + " " + cs.getPropertyValue(bp + "-y") : cs.getPropertyValue(bp) : t.currentStyle.backgroundPositionX + " " + t.currentStyle.backgroundPositionY) || "0 0"), //Internet Explorer doesn't report background-position correctly - we must query background-position-x and background-position-y and combine them (even in IE10). Before IE9, we must do the same with the currentStyle object and use camelCase
					es = this.format(e),
					ba, ea, i, pct, overlap, src;
				if ((bs.indexOf("%") !== -1) !== (es.indexOf("%") !== -1) && es.split(",").length < 2) {
					src = _getStyle(t, "backgroundImage").replace(_urlExp, "");
					if (src && src !== "none") {
						ba = bs.split(" ");
						ea = es.split(" ");
						_tempImg.setAttribute("src", src); //set the temp IMG's src to the background-image so that we can measure its width/height
						i = 2;
						while (--i > -1) {
							bs = ba[i];
							pct = (bs.indexOf("%") !== -1);
							if (pct !== (ea[i].indexOf("%") !== -1)) {
								overlap = (i === 0) ? t.offsetWidth - _tempImg.width : t.offsetHeight - _tempImg.height;
								ba[i] = pct ? (parseFloat(bs) / 100 * overlap) + "px" : (parseFloat(bs) / overlap * 100) + "%";
							}
						}
						bs = ba.join(" ");
					}
				}
				return this.parseComplex(t.style, bs, es, pt, plugin);
			}, formatter:_parsePosition});
			_registerComplexSpecialProp("backgroundSize", {defaultValue:"0 0", formatter:function(v) {
				v += ""; //ensure it's a string
				return (v.substr(0,2) === "co") ? v : _parsePosition(v.indexOf(" ") === -1 ? v + " " + v : v); //if set to something like "100% 100%", Safari typically reports the computed style as just "100%" (no 2nd value), but we should ensure that there are two values, so copy the first one. Otherwise, it'd be interpreted as "100% 0" (wrong). Also remember that it could be "cover" or "contain" which we can't tween but should be able to set.
			}});
			_registerComplexSpecialProp("perspective", {defaultValue:"0px", prefix:true});
			_registerComplexSpecialProp("perspectiveOrigin", {defaultValue:"50% 50%", prefix:true});
			_registerComplexSpecialProp("transformStyle", {prefix:true});
			_registerComplexSpecialProp("backfaceVisibility", {prefix:true});
			_registerComplexSpecialProp("userSelect", {prefix:true});
			_registerComplexSpecialProp("margin", {parser:_getEdgeParser("marginTop,marginRight,marginBottom,marginLeft")});
			_registerComplexSpecialProp("padding", {parser:_getEdgeParser("paddingTop,paddingRight,paddingBottom,paddingLeft")});
			_registerComplexSpecialProp("clip", {defaultValue:"rect(0px,0px,0px,0px)", parser:function(t, e, p, cssp, pt, plugin){
				var b, cs, delim;
				if (_ieVers < 9) { //IE8 and earlier don't report a "clip" value in the currentStyle - instead, the values are split apart into clipTop, clipRight, clipBottom, and clipLeft. Also, in IE7 and earlier, the values inside rect() are space-delimited, not comma-delimited.
					cs = t.currentStyle;
					delim = _ieVers < 8 ? " " : ",";
					b = "rect(" + cs.clipTop + delim + cs.clipRight + delim + cs.clipBottom + delim + cs.clipLeft + ")";
					e = this.format(e).split(",").join(delim);
				} else {
					b = this.format(_getStyle(t, this.p, _cs, false, this.dflt));
					e = this.format(e);
				}
				return this.parseComplex(t.style, b, e, pt, plugin);
			}});
			_registerComplexSpecialProp("textShadow", {defaultValue:"0px 0px 0px #999", color:true, multi:true});
			_registerComplexSpecialProp("autoRound,strictUnits", {parser:function(t, e, p, cssp, pt) {return pt;}}); //just so that we can ignore these properties (not tween them)
			_registerComplexSpecialProp("border", {defaultValue:"0px solid #000", parser:function(t, e, p, cssp, pt, plugin) {
				var bw = _getStyle(t, "borderTopWidth", _cs, false, "0px"),
					end = this.format(e).split(" "),
					esfx = end[0].replace(_suffixExp, "");
				if (esfx !== "px") { //if we're animating to a non-px value, we need to convert the beginning width to that unit.
					bw = (parseFloat(bw) / _convertToPixels(t, "borderTopWidth", 1, esfx)) + esfx;
				}
				return this.parseComplex(t.style, this.format(bw + " " + _getStyle(t, "borderTopStyle", _cs, false, "solid") + " " + _getStyle(t, "borderTopColor", _cs, false, "#000")), end.join(" "), pt, plugin);
				}, color:true, formatter:function(v) {
					var a = v.split(" ");
					return a[0] + " " + (a[1] || "solid") + " " + (v.match(_colorExp) || ["#000"])[0];
				}});
			_registerComplexSpecialProp("borderWidth", {parser:_getEdgeParser("borderTopWidth,borderRightWidth,borderBottomWidth,borderLeftWidth")}); //Firefox doesn't pick up on borderWidth set in style sheets (only inline).
			_registerComplexSpecialProp("float,cssFloat,styleFloat", {parser:function(t, e, p, cssp, pt, plugin) {
				var s = t.style,
					prop = ("cssFloat" in s) ? "cssFloat" : "styleFloat";
				return new CSSPropTween(s, prop, 0, 0, pt, -1, p, false, 0, s[prop], e);
			}});
	
			//opacity-related
			var _setIEOpacityRatio = function(v) {
					var t = this.t, //refers to the element's style property
						filters = t.filter || _getStyle(this.data, "filter") || "",
						val = (this.s + this.c * v) | 0,
						skip;
					if (val === 100) { //for older versions of IE that need to use a filter to apply opacity, we should remove the filter if opacity hits 1 in order to improve performance, but make sure there isn't a transform (matrix) or gradient in the filters.
						if (filters.indexOf("atrix(") === -1 && filters.indexOf("radient(") === -1 && filters.indexOf("oader(") === -1) {
							t.removeAttribute("filter");
							skip = (!_getStyle(this.data, "filter")); //if a class is applied that has an alpha filter, it will take effect (we don't want that), so re-apply our alpha filter in that case. We must first remove it and then check.
						} else {
							t.filter = filters.replace(_alphaFilterExp, "");
							skip = true;
						}
					}
					if (!skip) {
						if (this.xn1) {
							t.filter = filters = filters || ("alpha(opacity=" + val + ")"); //works around bug in IE7/8 that prevents changes to "visibility" from being applied properly if the filter is changed to a different alpha on the same frame.
						}
						if (filters.indexOf("pacity") === -1) { //only used if browser doesn't support the standard opacity style property (IE 7 and 8). We omit the "O" to avoid case-sensitivity issues
							if (val !== 0 || !this.xn1) { //bugs in IE7/8 won't render the filter properly if opacity is ADDED on the same frame/render as "visibility" changes (this.xn1 is 1 if this tween is an "autoAlpha" tween)
								t.filter = filters + " alpha(opacity=" + val + ")"; //we round the value because otherwise, bugs in IE7/8 can prevent "visibility" changes from being applied properly.
							}
						} else {
							t.filter = filters.replace(_opacityExp, "opacity=" + val);
						}
					}
				};
			_registerComplexSpecialProp("opacity,alpha,autoAlpha", {defaultValue:"1", parser:function(t, e, p, cssp, pt, plugin) {
				var b = parseFloat(_getStyle(t, "opacity", _cs, false, "1")),
					style = t.style,
					isAutoAlpha = (p === "autoAlpha");
				if (typeof(e) === "string" && e.charAt(1) === "=") {
					e = ((e.charAt(0) === "-") ? -1 : 1) * parseFloat(e.substr(2)) + b;
				}
				if (isAutoAlpha && b === 1 && _getStyle(t, "visibility", _cs) === "hidden" && e !== 0) { //if visibility is initially set to "hidden", we should interpret that as intent to make opacity 0 (a convenience)
					b = 0;
				}
				if (_supportsOpacity) {
					pt = new CSSPropTween(style, "opacity", b, e - b, pt);
				} else {
					pt = new CSSPropTween(style, "opacity", b * 100, (e - b) * 100, pt);
					pt.xn1 = isAutoAlpha ? 1 : 0; //we need to record whether or not this is an autoAlpha so that in the setRatio(), we know to duplicate the setting of the alpha in order to work around a bug in IE7 and IE8 that prevents changes to "visibility" from taking effect if the filter is changed to a different alpha(opacity) at the same time. Setting it to the SAME value first, then the new value works around the IE7/8 bug.
					style.zoom = 1; //helps correct an IE issue.
					pt.type = 2;
					pt.b = "alpha(opacity=" + pt.s + ")";
					pt.e = "alpha(opacity=" + (pt.s + pt.c) + ")";
					pt.data = t;
					pt.plugin = plugin;
					pt.setRatio = _setIEOpacityRatio;
				}
				if (isAutoAlpha) { //we have to create the "visibility" PropTween after the opacity one in the linked list so that they run in the order that works properly in IE8 and earlier
					pt = new CSSPropTween(style, "visibility", 0, 0, pt, -1, null, false, 0, ((b !== 0) ? "inherit" : "hidden"), ((e === 0) ? "hidden" : "inherit"));
					pt.xs0 = "inherit";
					cssp._overwriteProps.push(pt.n);
					cssp._overwriteProps.push(p);
				}
				return pt;
			}});
	
	
			var _removeProp = function(s, p) {
					if (p) {
						if (s.removeProperty) {
							if (p.substr(0,2) === "ms" || p.substr(0,6) === "webkit") { //Microsoft and some Webkit browsers don't conform to the standard of capitalizing the first prefix character, so we adjust so that when we prefix the caps with a dash, it's correct (otherwise it'd be "ms-transform" instead of "-ms-transform" for IE9, for example)
								p = "-" + p;
							}
							s.removeProperty(p.replace(_capsExp, "-$1").toLowerCase());
						} else { //note: old versions of IE use "removeAttribute()" instead of "removeProperty()"
							s.removeAttribute(p);
						}
					}
				},
				_setClassNameRatio = function(v) {
					this.t._gsClassPT = this;
					if (v === 1 || v === 0) {
						this.t.setAttribute("class", (v === 0) ? this.b : this.e);
						var mpt = this.data, //first MiniPropTween
							s = this.t.style;
						while (mpt) {
							if (!mpt.v) {
								_removeProp(s, mpt.p);
							} else {
								s[mpt.p] = mpt.v;
							}
							mpt = mpt._next;
						}
						if (v === 1 && this.t._gsClassPT === this) {
							this.t._gsClassPT = null;
						}
					} else if (this.t.getAttribute("class") !== this.e) {
						this.t.setAttribute("class", this.e);
					}
				};
			_registerComplexSpecialProp("className", {parser:function(t, e, p, cssp, pt, plugin, vars) {
				var b = t.getAttribute("class") || "", //don't use t.className because it doesn't work consistently on SVG elements; getAttribute("class") and setAttribute("class", value") is more reliable.
					cssText = t.style.cssText,
					difData, bs, cnpt, cnptLookup, mpt;
				pt = cssp._classNamePT = new CSSPropTween(t, p, 0, 0, pt, 2);
				pt.setRatio = _setClassNameRatio;
				pt.pr = -11;
				_hasPriority = true;
				pt.b = b;
				bs = _getAllStyles(t, _cs);
				//if there's a className tween already operating on the target, force it to its end so that the necessary inline styles are removed and the class name is applied before we determine the end state (we don't want inline styles interfering that were there just for class-specific values)
				cnpt = t._gsClassPT;
				if (cnpt) {
					cnptLookup = {};
					mpt = cnpt.data; //first MiniPropTween which stores the inline styles - we need to force these so that the inline styles don't contaminate things. Otherwise, there's a small chance that a tween could start and the inline values match the destination values and they never get cleaned.
					while (mpt) {
						cnptLookup[mpt.p] = 1;
						mpt = mpt._next;
					}
					cnpt.setRatio(1);
				}
				t._gsClassPT = pt;
				pt.e = (e.charAt(1) !== "=") ? e : b.replace(new RegExp("(?:\\s|^)" + e.substr(2) + "(?![\\w-])"), "") + ((e.charAt(0) === "+") ? " " + e.substr(2) : "");
				t.setAttribute("class", pt.e);
				difData = _cssDif(t, bs, _getAllStyles(t), vars, cnptLookup);
				t.setAttribute("class", b);
				pt.data = difData.firstMPT;
				t.style.cssText = cssText; //we recorded cssText before we swapped classes and ran _getAllStyles() because in cases when a className tween is overwritten, we remove all the related tweening properties from that class change (otherwise class-specific stuff can't override properties we've directly set on the target's style object due to specificity).
				pt = pt.xfirst = cssp.parse(t, difData.difs, pt, plugin); //we record the CSSPropTween as the xfirst so that we can handle overwriting propertly (if "className" gets overwritten, we must kill all the properties associated with the className part of the tween, so we can loop through from xfirst to the pt itself)
				return pt;
			}});
	
	
			var _setClearPropsRatio = function(v) {
				if (v === 1 || v === 0) if (this.data._totalTime === this.data._totalDuration && this.data.data !== "isFromStart") { //this.data refers to the tween. Only clear at the END of the tween (remember, from() tweens make the ratio go from 1 to 0, so we can't just check that and if the tween is the zero-duration one that's created internally to render the starting values in a from() tween, ignore that because otherwise, for example, from(...{height:100, clearProps:"height", delay:1}) would wipe the height at the beginning of the tween and after 1 second, it'd kick back in).
					var s = this.t.style,
						transformParse = _specialProps.transform.parse,
						a, p, i, clearTransform, transform;
					if (this.e === "all") {
						s.cssText = "";
						clearTransform = true;
					} else {
						a = this.e.split(" ").join("").split(",");
						i = a.length;
						while (--i > -1) {
							p = a[i];
							if (_specialProps[p]) {
								if (_specialProps[p].parse === transformParse) {
									clearTransform = true;
								} else {
									p = (p === "transformOrigin") ? _transformOriginProp : _specialProps[p].p; //ensures that special properties use the proper browser-specific property name, like "scaleX" might be "-webkit-transform" or "boxShadow" might be "-moz-box-shadow"
								}
							}
							_removeProp(s, p);
						}
					}
					if (clearTransform) {
						_removeProp(s, _transformProp);
						transform = this.t._gsTransform;
						if (transform) {
							if (transform.svg) {
								this.t.removeAttribute("data-svg-origin");
								this.t.removeAttribute("transform");
							}
							delete this.t._gsTransform;
						}
					}
	
				}
			};
			_registerComplexSpecialProp("clearProps", {parser:function(t, e, p, cssp, pt) {
				pt = new CSSPropTween(t, p, 0, 0, pt, 2);
				pt.setRatio = _setClearPropsRatio;
				pt.e = e;
				pt.pr = -10;
				pt.data = cssp._tween;
				_hasPriority = true;
				return pt;
			}});
	
			p = "bezier,throwProps,physicsProps,physics2D".split(",");
			i = p.length;
			while (i--) {
				_registerPluginProp(p[i]);
			}
	
	
	
	
	
	
	
	
			p = CSSPlugin.prototype;
			p._firstPT = p._lastParsedTransform = p._transform = null;
	
			//gets called when the tween renders for the first time. This kicks everything off, recording start/end values, etc.
			p._onInitTween = function(target, vars, tween, index) {
				if (!target.nodeType) { //css is only for dom elements
					return false;
				}
				this._target = _target = target;
				this._tween = tween;
				this._vars = vars;
				_index = index;
				_autoRound = vars.autoRound;
				_hasPriority = false;
				_suffixMap = vars.suffixMap || CSSPlugin.suffixMap;
				_cs = _getComputedStyle(target, "");
				_overwriteProps = this._overwriteProps;
				var style = target.style,
					v, pt, pt2, first, last, next, zIndex, tpt, threeD;
				if (_reqSafariFix) if (style.zIndex === "") {
					v = _getStyle(target, "zIndex", _cs);
					if (v === "auto" || v === "") {
						//corrects a bug in [non-Android] Safari that prevents it from repainting elements in their new positions if they don't have a zIndex set. We also can't just apply this inside _parseTransform() because anything that's moved in any way (like using "left" or "top" instead of transforms like "x" and "y") can be affected, so it is best to ensure that anything that's tweening has a z-index. Setting "WebkitPerspective" to a non-zero value worked too except that on iOS Safari things would flicker randomly. Plus zIndex is less memory-intensive.
						this._addLazySet(style, "zIndex", 0);
					}
				}
	
				if (typeof(vars) === "string") {
					first = style.cssText;
					v = _getAllStyles(target, _cs);
					style.cssText = first + ";" + vars;
					v = _cssDif(target, v, _getAllStyles(target)).difs;
					if (!_supportsOpacity && _opacityValExp.test(vars)) {
						v.opacity = parseFloat( RegExp.$1 );
					}
					vars = v;
					style.cssText = first;
				}
	
				if (vars.className) { //className tweens will combine any differences they find in the css with the vars that are passed in, so {className:"myClass", scale:0.5, left:20} would work.
					this._firstPT = pt = _specialProps.className.parse(target, vars.className, "className", this, null, null, vars);
				} else {
					this._firstPT = pt = this.parse(target, vars, null);
				}
	
				if (this._transformType) {
					threeD = (this._transformType === 3);
					if (!_transformProp) {
						style.zoom = 1; //helps correct an IE issue.
					} else if (_isSafari) {
						_reqSafariFix = true;
						//if zIndex isn't set, iOS Safari doesn't repaint things correctly sometimes (seemingly at random).
						if (style.zIndex === "") {
							zIndex = _getStyle(target, "zIndex", _cs);
							if (zIndex === "auto" || zIndex === "") {
								this._addLazySet(style, "zIndex", 0);
							}
						}
						//Setting WebkitBackfaceVisibility corrects 3 bugs:
						// 1) [non-Android] Safari skips rendering changes to "top" and "left" that are made on the same frame/render as a transform update.
						// 2) iOS Safari sometimes neglects to repaint elements in their new positions. Setting "WebkitPerspective" to a non-zero value worked too except that on iOS Safari things would flicker randomly.
						// 3) Safari sometimes displayed odd artifacts when tweening the transform (or WebkitTransform) property, like ghosts of the edges of the element remained. Definitely a browser bug.
						//Note: we allow the user to override the auto-setting by defining WebkitBackfaceVisibility in the vars of the tween.
						if (_isSafariLT6) {
							this._addLazySet(style, "WebkitBackfaceVisibility", this._vars.WebkitBackfaceVisibility || (threeD ? "visible" : "hidden"));
						}
					}
					pt2 = pt;
					while (pt2 && pt2._next) {
						pt2 = pt2._next;
					}
					tpt = new CSSPropTween(target, "transform", 0, 0, null, 2);
					this._linkCSSP(tpt, null, pt2);
					tpt.setRatio = _transformProp ? _setTransformRatio : _setIETransformRatio;
					tpt.data = this._transform || _getTransform(target, _cs, true);
					tpt.tween = tween;
					tpt.pr = -1; //ensures that the transforms get applied after the components are updated.
					_overwriteProps.pop(); //we don't want to force the overwrite of all "transform" tweens of the target - we only care about individual transform properties like scaleX, rotation, etc. The CSSPropTween constructor automatically adds the property to _overwriteProps which is why we need to pop() here.
				}
	
				if (_hasPriority) {
					//reorders the linked list in order of pr (priority)
					while (pt) {
						next = pt._next;
						pt2 = first;
						while (pt2 && pt2.pr > pt.pr) {
							pt2 = pt2._next;
						}
						if ((pt._prev = pt2 ? pt2._prev : last)) {
							pt._prev._next = pt;
						} else {
							first = pt;
						}
						if ((pt._next = pt2)) {
							pt2._prev = pt;
						} else {
							last = pt;
						}
						pt = next;
					}
					this._firstPT = first;
				}
				return true;
			};
	
	
			p.parse = function(target, vars, pt, plugin) {
				var style = target.style,
					p, sp, bn, en, bs, es, bsfx, esfx, isStr, rel;
				for (p in vars) {
					es = vars[p]; //ending value string
					if (typeof(es) === "function") {
						es = es(_index, _target);
					}
					sp = _specialProps[p]; //SpecialProp lookup.
					if (sp) {
						pt = sp.parse(target, es, p, this, pt, plugin, vars);
					} else if (p.substr(0,2) === "--") { //for tweening CSS variables (which always start with "--"). To maximize performance and simplicity, we bypass CSSPlugin altogether and just add a normal property tween to the tween instance itself.
						this._tween._propLookup[p] = this._addTween.call(this._tween, target.style, "setProperty", _getComputedStyle(target).getPropertyValue(p) + "", es + "", p, false, p);
						continue;
					} else {
						bs = _getStyle(target, p, _cs) + "";
						isStr = (typeof(es) === "string");
						if (p === "color" || p === "fill" || p === "stroke" || p.indexOf("Color") !== -1 || (isStr && _rgbhslExp.test(es))) { //Opera uses background: to define color sometimes in addition to backgroundColor:
							if (!isStr) {
								es = _parseColor(es);
								es = ((es.length > 3) ? "rgba(" : "rgb(") + es.join(",") + ")";
							}
							pt = _parseComplex(style, p, bs, es, true, "transparent", pt, 0, plugin);
	
						} else if (isStr && _complexExp.test(es)) {
							pt = _parseComplex(style, p, bs, es, true, null, pt, 0, plugin);
	
						} else {
							bn = parseFloat(bs);
							bsfx = (bn || bn === 0) ? bs.substr((bn + "").length) : ""; //remember, bs could be non-numeric like "normal" for fontWeight, so we should default to a blank suffix in that case.
	
							if (bs === "" || bs === "auto") {
								if (p === "width" || p === "height") {
									bn = _getDimension(target, p, _cs);
									bsfx = "px";
								} else if (p === "left" || p === "top") {
									bn = _calculateOffset(target, p, _cs);
									bsfx = "px";
								} else {
									bn = (p !== "opacity") ? 0 : 1;
									bsfx = "";
								}
							}
	
							rel = (isStr && es.charAt(1) === "=");
							if (rel) {
								en = parseInt(es.charAt(0) + "1", 10);
								es = es.substr(2);
								en *= parseFloat(es);
								esfx = es.replace(_suffixExp, "");
							} else {
								en = parseFloat(es);
								esfx = isStr ? es.replace(_suffixExp, "") : "";
							}
	
							if (esfx === "") {
								esfx = (p in _suffixMap) ? _suffixMap[p] : bsfx; //populate the end suffix, prioritizing the map, then if none is found, use the beginning suffix.
							}
	
							es = (en || en === 0) ? (rel ? en + bn : en) + esfx : vars[p]; //ensures that any += or -= prefixes are taken care of. Record the end value before normalizing the suffix because we always want to end the tween on exactly what they intended even if it doesn't match the beginning value's suffix.
							//if the beginning/ending suffixes don't match, normalize them...
							if (bsfx !== esfx) if (esfx !== "" || p === "lineHeight") if (en || en === 0) if (bn) { //note: if the beginning value (bn) is 0, we don't need to convert units!
								bn = _convertToPixels(target, p, bn, bsfx);
								if (esfx === "%") {
									bn /= _convertToPixels(target, p, 100, "%") / 100;
									if (vars.strictUnits !== true) { //some browsers report only "px" values instead of allowing "%" with getComputedStyle(), so we assume that if we're tweening to a %, we should start there too unless strictUnits:true is defined. This approach is particularly useful for responsive designs that use from() tweens.
										bs = bn + "%";
									}
	
								} else if (esfx === "em" || esfx === "rem" || esfx === "vw" || esfx === "vh") {
									bn /= _convertToPixels(target, p, 1, esfx);
	
								//otherwise convert to pixels.
								} else if (esfx !== "px") {
									en = _convertToPixels(target, p, en, esfx);
									esfx = "px"; //we don't use bsfx after this, so we don't need to set it to px too.
								}
								if (rel) if (en || en === 0) {
									es = (en + bn) + esfx; //the changes we made affect relative calculations, so adjust the end value here.
								}
							}
	
							if (rel) {
								en += bn;
							}
	
							if ((bn || bn === 0) && (en || en === 0)) { //faster than isNaN(). Also, previously we required en !== bn but that doesn't really gain much performance and it prevents _parseToProxy() from working properly if beginning and ending values match but need to get tweened by an external plugin anyway. For example, a bezier tween where the target starts at left:0 and has these points: [{left:50},{left:0}] wouldn't work properly because when parsing the last point, it'd match the first (current) one and a non-tweening CSSPropTween would be recorded when we actually need a normal tween (type:0) so that things get updated during the tween properly.
								pt = new CSSPropTween(style, p, bn, en - bn, pt, 0, p, (_autoRound !== false && (esfx === "px" || p === "zIndex")), 0, bs, es);
								pt.xs0 = esfx;
								//DEBUG: _log("tween "+p+" from "+pt.b+" ("+bn+esfx+") to "+pt.e+" with suffix: "+pt.xs0);
							} else if (style[p] === undefined || !es && (es + "" === "NaN" || es == null)) {
								_log("invalid " + p + " tween value: " + vars[p]);
							} else {
								pt = new CSSPropTween(style, p, en || bn || 0, 0, pt, -1, p, false, 0, bs, es);
								pt.xs0 = (es === "none" && (p === "display" || p.indexOf("Style") !== -1)) ? bs : es; //intermediate value should typically be set immediately (end value) except for "display" or things like borderTopStyle, borderBottomStyle, etc. which should use the beginning value during the tween.
								//DEBUG: _log("non-tweening value "+p+": "+pt.xs0);
							}
						}
					}
					if (plugin) if (pt && !pt.plugin) {
						pt.plugin = plugin;
					}
				}
				return pt;
			};
	
	
			//gets called every time the tween updates, passing the new ratio (typically a value between 0 and 1, but not always (for example, if an Elastic.easeOut is used, the value can jump above 1 mid-tween). It will always start and 0 and end at 1.
			p.setRatio = function(v) {
				var pt = this._firstPT,
					min = 0.000001,
					val, str, i;
				//at the end of the tween, we set the values to exactly what we received in order to make sure non-tweening values (like "position" or "float" or whatever) are set and so that if the beginning/ending suffixes (units) didn't match and we normalized to px, the value that the user passed in is used here. We check to see if the tween is at its beginning in case it's a from() tween in which case the ratio will actually go from 1 to 0 over the course of the tween (backwards).
				if (v === 1 && (this._tween._time === this._tween._duration || this._tween._time === 0)) {
					while (pt) {
						if (pt.type !== 2) {
							if (pt.r && pt.type !== -1) {
								val = pt.r(pt.s + pt.c);
								if (!pt.type) {
									pt.t[pt.p] = val + pt.xs0;
								} else if (pt.type === 1) { //complex value (one that typically has multiple numbers inside a string, like "rect(5px,10px,20px,25px)"
									i = pt.l;
									str = pt.xs0 + val + pt.xs1;
									for (i = 1; i < pt.l; i++) {
										str += pt["xn"+i] + pt["xs"+(i+1)];
									}
									pt.t[pt.p] = str;
								}
							} else {
								pt.t[pt.p] = pt.e;
							}
						} else {
							pt.setRatio(v);
						}
						pt = pt._next;
					}
	
				} else if (v || !(this._tween._time === this._tween._duration || this._tween._time === 0) || this._tween._rawPrevTime === -0.000001) {
					while (pt) {
						val = pt.c * v + pt.s;
						if (pt.r) {
							val = pt.r(val);
						} else if (val < min) if (val > -min) {
							val = 0;
						}
						if (!pt.type) {
							pt.t[pt.p] = val + pt.xs0;
						} else if (pt.type === 1) { //complex value (one that typically has multiple numbers inside a string, like "rect(5px,10px,20px,25px)"
							i = pt.l;
							if (i === 2) {
								pt.t[pt.p] = pt.xs0 + val + pt.xs1 + pt.xn1 + pt.xs2;
							} else if (i === 3) {
								pt.t[pt.p] = pt.xs0 + val + pt.xs1 + pt.xn1 + pt.xs2 + pt.xn2 + pt.xs3;
							} else if (i === 4) {
								pt.t[pt.p] = pt.xs0 + val + pt.xs1 + pt.xn1 + pt.xs2 + pt.xn2 + pt.xs3 + pt.xn3 + pt.xs4;
							} else if (i === 5) {
								pt.t[pt.p] = pt.xs0 + val + pt.xs1 + pt.xn1 + pt.xs2 + pt.xn2 + pt.xs3 + pt.xn3 + pt.xs4 + pt.xn4 + pt.xs5;
							} else {
								str = pt.xs0 + val + pt.xs1;
								for (i = 1; i < pt.l; i++) {
									str += pt["xn"+i] + pt["xs"+(i+1)];
								}
								pt.t[pt.p] = str;
							}
	
						} else if (pt.type === -1) { //non-tweening value
							pt.t[pt.p] = pt.xs0;
	
						} else if (pt.setRatio) { //custom setRatio() for things like SpecialProps, external plugins, etc.
							pt.setRatio(v);
						}
						pt = pt._next;
					}
	
				//if the tween is reversed all the way back to the beginning, we need to restore the original values which may have different units (like % instead of px or em or whatever).
				} else {
					while (pt) {
						if (pt.type !== 2) {
							pt.t[pt.p] = pt.b;
						} else {
							pt.setRatio(v);
						}
						pt = pt._next;
					}
				}
			};
	
			/**
			 * @private
			 * Forces rendering of the target's transforms (rotation, scale, etc.) whenever the CSSPlugin's setRatio() is called.
			 * Basically, this tells the CSSPlugin to create a CSSPropTween (type 2) after instantiation that runs last in the linked
			 * list and calls the appropriate (3D or 2D) rendering function. We separate this into its own method so that we can call
			 * it from other plugins like BezierPlugin if, for example, it needs to apply an autoRotation and this CSSPlugin
			 * doesn't have any transform-related properties of its own. You can call this method as many times as you
			 * want and it won't create duplicate CSSPropTweens.
			 *
			 * @param {boolean} threeD if true, it should apply 3D tweens (otherwise, just 2D ones are fine and typically faster)
			 */
			p._enableTransforms = function(threeD) {
				this._transform = this._transform || _getTransform(this._target, _cs, true); //ensures that the element has a _gsTransform property with the appropriate values.
				this._transformType = (!(this._transform.svg && _useSVGTransformAttr) && (threeD || this._transformType === 3)) ? 3 : 2;
			};
	
			var lazySet = function(v) {
				this.t[this.p] = this.e;
				this.data._linkCSSP(this, this._next, null, true); //we purposefully keep this._next even though it'd make sense to null it, but this is a performance optimization, as this happens during the while (pt) {} loop in setRatio() at the bottom of which it sets pt = pt._next, so if we null it, the linked list will be broken in that loop.
			};
			/** @private Gives us a way to set a value on the first render (and only the first render). **/
			p._addLazySet = function(t, p, v) {
				var pt = this._firstPT = new CSSPropTween(t, p, 0, 0, this._firstPT, 2);
				pt.e = v;
				pt.setRatio = lazySet;
				pt.data = this;
			};
	
			/** @private **/
			p._linkCSSP = function(pt, next, prev, remove) {
				if (pt) {
					if (next) {
						next._prev = pt;
					}
					if (pt._next) {
						pt._next._prev = pt._prev;
					}
					if (pt._prev) {
						pt._prev._next = pt._next;
					} else if (this._firstPT === pt) {
						this._firstPT = pt._next;
						remove = true; //just to prevent resetting this._firstPT 5 lines down in case pt._next is null. (optimized for speed)
					}
					if (prev) {
						prev._next = pt;
					} else if (!remove && this._firstPT === null) {
						this._firstPT = pt;
					}
					pt._next = next;
					pt._prev = prev;
				}
				return pt;
			};
	
			p._mod = function(lookup) {
				var pt = this._firstPT;
				while (pt) {
					if (typeof(lookup[pt.p]) === "function") { //only gets called by RoundPropsPlugin (ModifyPlugin manages all the rendering internally for CSSPlugin properties that need modification). Remember, we handle rounding a bit differently in this plugin for performance reasons, leveraging "r" as an indicator that the value should be rounded internally.
						pt.r = lookup[pt.p];
					}
					pt = pt._next;
				}
			};
	
			//we need to make sure that if alpha or autoAlpha is killed, opacity is too. And autoAlpha affects the "visibility" property.
			p._kill = function(lookup) {
				var copy = lookup,
					pt, p, xfirst;
				if (lookup.autoAlpha || lookup.alpha) {
					copy = {};
					for (p in lookup) { //copy the lookup so that we're not changing the original which may be passed elsewhere.
						copy[p] = lookup[p];
					}
					copy.opacity = 1;
					if (copy.autoAlpha) {
						copy.visibility = 1;
					}
				}
				if (lookup.className && (pt = this._classNamePT)) { //for className tweens, we need to kill any associated CSSPropTweens too; a linked list starts at the className's "xfirst".
					xfirst = pt.xfirst;
					if (xfirst && xfirst._prev) {
						this._linkCSSP(xfirst._prev, pt._next, xfirst._prev._prev); //break off the prev
					} else if (xfirst === this._firstPT) {
						this._firstPT = pt._next;
					}
					if (pt._next) {
						this._linkCSSP(pt._next, pt._next._next, xfirst._prev);
					}
					this._classNamePT = null;
				}
				pt = this._firstPT;
				while (pt) {
					if (pt.plugin && pt.plugin !== p && pt.plugin._kill) { //for plugins that are registered with CSSPlugin, we should notify them of the kill.
						pt.plugin._kill(lookup);
						p = pt.plugin;
					}
					pt = pt._next;
				}
				return TweenPlugin.prototype._kill.call(this, copy);
			};
	
	
	
			//used by cascadeTo() for gathering all the style properties of each child element into an array for comparison.
			var _getChildStyles = function(e, props, targets) {
					var children, i, child, type;
					if (e.slice) {
						i = e.length;
						while (--i > -1) {
							_getChildStyles(e[i], props, targets);
						}
						return;
					}
					children = e.childNodes;
					i = children.length;
					while (--i > -1) {
						child = children[i];
						type = child.type;
						if (child.style) {
							props.push(_getAllStyles(child));
							if (targets) {
								targets.push(child);
							}
						}
						if ((type === 1 || type === 9 || type === 11) && child.childNodes.length) {
							_getChildStyles(child, props, targets);
						}
					}
				};
	
			/**
			 * Typically only useful for className tweens that may affect child elements, this method creates a TweenLite
			 * and then compares the style properties of all the target's child elements at the tween's start and end, and
			 * if any are different, it also creates tweens for those and returns an array containing ALL of the resulting
			 * tweens (so that you can easily add() them to a TimelineLite, for example). The reason this functionality is
			 * wrapped into a separate static method of CSSPlugin instead of being integrated into all regular className tweens
			 * is because it creates entirely new tweens that may have completely different targets than the original tween,
			 * so if they were all lumped into the original tween instance, it would be inconsistent with the rest of the API
			 * and it would create other problems. For example:
			 *  - If I create a tween of elementA, that tween instance may suddenly change its target to include 50 other elements (unintuitive if I specifically defined the target I wanted)
			 *  - We can't just create new independent tweens because otherwise, what happens if the original/parent tween is reversed or pause or dropped into a TimelineLite for tight control? You'd expect that tween's behavior to affect all the others.
			 *  - Analyzing every style property of every child before and after the tween is an expensive operation when there are many children, so this behavior shouldn't be imposed on all className tweens by default, especially since it's probably rare that this extra functionality is needed.
			 *
			 * @param {Object} target object to be tweened
			 * @param {number} Duration in seconds (or frames for frames-based tweens)
			 * @param {Object} Object containing the end values, like {className:"newClass", ease:Linear.easeNone}
			 * @return {Array} An array of TweenLite instances
			 */
			CSSPlugin.cascadeTo = function(target, duration, vars) {
				var tween = TweenLite.to(target, duration, vars),
					results = [tween],
					b = [],
					e = [],
					targets = [],
					_reservedProps = TweenLite._internals.reservedProps,
					i, difs, p, from;
				target = tween._targets || tween.target;
				_getChildStyles(target, b, targets);
				tween.render(duration, true, true);
				_getChildStyles(target, e);
				tween.render(0, true, true);
				tween._enabled(true);
				i = targets.length;
				while (--i > -1) {
					difs = _cssDif(targets[i], b[i], e[i]);
					if (difs.firstMPT) {
						difs = difs.difs;
						for (p in vars) {
							if (_reservedProps[p]) {
								difs[p] = vars[p];
							}
						}
						from = {};
						for (p in difs) {
							from[p] = b[i][p];
						}
						results.push(TweenLite.fromTo(targets[i], duration, from, difs));
					}
				}
				return results;
			};
	
			TweenPlugin.activate([CSSPlugin]);
			return CSSPlugin;
	
		}, true);
		
	}); if (_gsScope._gsDefine) { _gsScope._gsQueue.pop()(); }
	
	//export to AMD/RequireJS and CommonJS/Node (precursor to full modular build system coming at a later date)
	(function(name) {
		"use strict";
		var getGlobal = function() {
			return (_gsScope.GreenSockGlobals || _gsScope)[name];
		};
		if (typeof(module) !== "undefined" && module.exports) { //node
			__webpack_require__(171);
			module.exports = getGlobal();
		} else if (true) { //AMD
			!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(171)], __WEBPACK_AMD_DEFINE_FACTORY__ = (getGlobal), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		}
	}("CSSPlugin"));
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 352 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.readState = exports.saveState = undefined;
	
	var _warning = __webpack_require__(101);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var QuotaExceededErrors = {
	  QuotaExceededError: true,
	  QUOTA_EXCEEDED_ERR: true
	};
	
	var SecurityErrors = {
	  SecurityError: true
	};
	
	var KeyPrefix = '@@History/';
	
	var createKey = function createKey(key) {
	  return KeyPrefix + key;
	};
	
	var saveState = exports.saveState = function saveState(key, state) {
	  if (!window.sessionStorage) {
	    // Session storage is not available or hidden.
	    // sessionStorage is undefined in Internet Explorer when served via file protocol.
	     false ? (0, _warning2.default)(false, '[history] Unable to save state; sessionStorage is not available') : void 0;
	
	    return;
	  }
	
	  try {
	    if (state == null) {
	      window.sessionStorage.removeItem(createKey(key));
	    } else {
	      window.sessionStorage.setItem(createKey(key), JSON.stringify(state));
	    }
	  } catch (error) {
	    if (SecurityErrors[error.name]) {
	      // Blocking cookies in Chrome/Firefox/Safari throws SecurityError on any
	      // attempt to access window.sessionStorage.
	       false ? (0, _warning2.default)(false, '[history] Unable to save state; sessionStorage is not available due to security settings') : void 0;
	
	      return;
	    }
	
	    if (QuotaExceededErrors[error.name] && window.sessionStorage.length === 0) {
	      // Safari "private mode" throws QuotaExceededError.
	       false ? (0, _warning2.default)(false, '[history] Unable to save state; sessionStorage is not available in Safari private mode') : void 0;
	
	      return;
	    }
	
	    throw error;
	  }
	};
	
	var readState = exports.readState = function readState(key) {
	  var json = void 0;
	  try {
	    json = window.sessionStorage.getItem(createKey(key));
	  } catch (error) {
	    if (SecurityErrors[error.name]) {
	      // Blocking cookies in Chrome/Firefox/Safari throws SecurityError on any
	      // attempt to access window.sessionStorage.
	       false ? (0, _warning2.default)(false, '[history] Unable to read state; sessionStorage is not available due to security settings') : void 0;
	
	      return undefined;
	    }
	  }
	
	  if (json) {
	    try {
	      return JSON.parse(json);
	    } catch (error) {
	      // Ignore invalid JSON.
	    }
	  }
	
	  return undefined;
	};

/***/ },
/* 353 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _runTransitionHook = __webpack_require__(237);
	
	var _runTransitionHook2 = _interopRequireDefault(_runTransitionHook);
	
	var _PathUtils = __webpack_require__(98);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var useBasename = function useBasename(createHistory) {
	  return function () {
	    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	    var history = createHistory(options);
	    var basename = options.basename;
	
	
	    var addBasename = function addBasename(location) {
	      if (!location) return location;
	
	      if (basename && location.basename == null) {
	        if (location.pathname.toLowerCase().indexOf(basename.toLowerCase()) === 0) {
	          location.pathname = location.pathname.substring(basename.length);
	          location.basename = basename;
	
	          if (location.pathname === '') location.pathname = '/';
	        } else {
	          location.basename = '';
	        }
	      }
	
	      return location;
	    };
	
	    var prependBasename = function prependBasename(location) {
	      if (!basename) return location;
	
	      var object = typeof location === 'string' ? (0, _PathUtils.parsePath)(location) : location;
	      var pname = object.pathname;
	      var normalizedBasename = basename.slice(-1) === '/' ? basename : basename + '/';
	      var normalizedPathname = pname.charAt(0) === '/' ? pname.slice(1) : pname;
	      var pathname = normalizedBasename + normalizedPathname;
	
	      return _extends({}, object, {
	        pathname: pathname
	      });
	    };
	
	    // Override all read methods with basename-aware versions.
	    var getCurrentLocation = function getCurrentLocation() {
	      return addBasename(history.getCurrentLocation());
	    };
	
	    var listenBefore = function listenBefore(hook) {
	      return history.listenBefore(function (location, callback) {
	        return (0, _runTransitionHook2.default)(hook, addBasename(location), callback);
	      });
	    };
	
	    var listen = function listen(listener) {
	      return history.listen(function (location) {
	        return listener(addBasename(location));
	      });
	    };
	
	    // Override all write methods with basename-aware versions.
	    var push = function push(location) {
	      return history.push(prependBasename(location));
	    };
	
	    var replace = function replace(location) {
	      return history.replace(prependBasename(location));
	    };
	
	    var createPath = function createPath(location) {
	      return history.createPath(prependBasename(location));
	    };
	
	    var createHref = function createHref(location) {
	      return history.createHref(prependBasename(location));
	    };
	
	    var createLocation = function createLocation(location) {
	      for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	        args[_key - 1] = arguments[_key];
	      }
	
	      return addBasename(history.createLocation.apply(history, [prependBasename(location)].concat(args)));
	    };
	
	    return _extends({}, history, {
	      getCurrentLocation: getCurrentLocation,
	      listenBefore: listenBefore,
	      listen: listen,
	      push: push,
	      replace: replace,
	      createPath: createPath,
	      createHref: createHref,
	      createLocation: createLocation
	    });
	  };
	};
	
	exports.default = useBasename;

/***/ },
/* 354 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _queryString = __webpack_require__(965);
	
	var _runTransitionHook = __webpack_require__(237);
	
	var _runTransitionHook2 = _interopRequireDefault(_runTransitionHook);
	
	var _LocationUtils = __webpack_require__(123);
	
	var _PathUtils = __webpack_require__(98);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var defaultStringifyQuery = function defaultStringifyQuery(query) {
	  return (0, _queryString.stringify)(query).replace(/%20/g, '+');
	};
	
	var defaultParseQueryString = _queryString.parse;
	
	/**
	 * Returns a new createHistory function that may be used to create
	 * history objects that know how to handle URL queries.
	 */
	var useQueries = function useQueries(createHistory) {
	  return function () {
	    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	    var history = createHistory(options);
	    var stringifyQuery = options.stringifyQuery,
	        parseQueryString = options.parseQueryString;
	
	
	    if (typeof stringifyQuery !== 'function') stringifyQuery = defaultStringifyQuery;
	
	    if (typeof parseQueryString !== 'function') parseQueryString = defaultParseQueryString;
	
	    var decodeQuery = function decodeQuery(location) {
	      if (!location) return location;
	
	      if (location.query == null) location.query = parseQueryString(location.search.substring(1));
	
	      return location;
	    };
	
	    var encodeQuery = function encodeQuery(location, query) {
	      if (query == null) return location;
	
	      var object = typeof location === 'string' ? (0, _PathUtils.parsePath)(location) : location;
	      var queryString = stringifyQuery(query);
	      var search = queryString ? '?' + queryString : '';
	
	      return _extends({}, object, {
	        search: search
	      });
	    };
	
	    // Override all read methods with query-aware versions.
	    var getCurrentLocation = function getCurrentLocation() {
	      return decodeQuery(history.getCurrentLocation());
	    };
	
	    var listenBefore = function listenBefore(hook) {
	      return history.listenBefore(function (location, callback) {
	        return (0, _runTransitionHook2.default)(hook, decodeQuery(location), callback);
	      });
	    };
	
	    var listen = function listen(listener) {
	      return history.listen(function (location) {
	        return listener(decodeQuery(location));
	      });
	    };
	
	    // Override all write methods with query-aware versions.
	    var push = function push(location) {
	      return history.push(encodeQuery(location, location.query));
	    };
	
	    var replace = function replace(location) {
	      return history.replace(encodeQuery(location, location.query));
	    };
	
	    var createPath = function createPath(location) {
	      return history.createPath(encodeQuery(location, location.query));
	    };
	
	    var createHref = function createHref(location) {
	      return history.createHref(encodeQuery(location, location.query));
	    };
	
	    var createLocation = function createLocation(location) {
	      for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	        args[_key - 1] = arguments[_key];
	      }
	
	      var newLocation = history.createLocation.apply(history, [encodeQuery(location, location.query)].concat(args));
	
	      if (location.query) newLocation.query = (0, _LocationUtils.createQuery)(location.query);
	
	      return decodeQuery(newLocation);
	    };
	
	    return _extends({}, history, {
	      getCurrentLocation: getCurrentLocation,
	      listenBefore: listenBefore,
	      listen: listen,
	      push: push,
	      replace: replace,
	      createPath: createPath,
	      createHref: createHref,
	      createLocation: createLocation
	    });
	  };
	};
	
	exports.default = useQueries;

/***/ },
/* 355 */
/***/ function(module, exports) {

	'use strict';
	
	/**
	 * Copyright 2015, Yahoo! Inc.
	 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
	 */
	var REACT_STATICS = {
	    childContextTypes: true,
	    contextTypes: true,
	    defaultProps: true,
	    displayName: true,
	    getDefaultProps: true,
	    getDerivedStateFromProps: true,
	    mixins: true,
	    propTypes: true,
	    type: true
	};
	
	var KNOWN_STATICS = {
	    name: true,
	    length: true,
	    prototype: true,
	    caller: true,
	    callee: true,
	    arguments: true,
	    arity: true
	};
	
	var defineProperty = Object.defineProperty;
	var getOwnPropertyNames = Object.getOwnPropertyNames;
	var getOwnPropertySymbols = Object.getOwnPropertySymbols;
	var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
	var getPrototypeOf = Object.getPrototypeOf;
	var objectPrototype = getPrototypeOf && getPrototypeOf(Object);
	
	function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
	    if (typeof sourceComponent !== 'string') { // don't hoist over string (html) components
	
	        if (objectPrototype) {
	            var inheritedComponent = getPrototypeOf(sourceComponent);
	            if (inheritedComponent && inheritedComponent !== objectPrototype) {
	                hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
	            }
	        }
	
	        var keys = getOwnPropertyNames(sourceComponent);
	
	        if (getOwnPropertySymbols) {
	            keys = keys.concat(getOwnPropertySymbols(sourceComponent));
	        }
	
	        for (var i = 0; i < keys.length; ++i) {
	            var key = keys[i];
	            if (!REACT_STATICS[key] && !KNOWN_STATICS[key] && (!blacklist || !blacklist[key])) {
	                var descriptor = getOwnPropertyDescriptor(sourceComponent, key);
	                try { // Avoid failures from read-only properties
	                    defineProperty(targetComponent, key, descriptor);
	                } catch (e) {}
	            }
	        }
	
	        return targetComponent;
	    }
	
	    return targetComponent;
	}
	
	module.exports = hoistNonReactStatics;


/***/ },
/* 356 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
	 * jQuery JavaScript Library v3.3.1
	 * https://jquery.com/
	 *
	 * Includes Sizzle.js
	 * https://sizzlejs.com/
	 *
	 * Copyright JS Foundation and other contributors
	 * Released under the MIT license
	 * https://jquery.org/license
	 *
	 * Date: 2018-01-20T17:24Z
	 */
	( function( global, factory ) {
	
		"use strict";
	
		if ( typeof module === "object" && typeof module.exports === "object" ) {
	
			// For CommonJS and CommonJS-like environments where a proper `window`
			// is present, execute the factory and get jQuery.
			// For environments that do not have a `window` with a `document`
			// (such as Node.js), expose a factory as module.exports.
			// This accentuates the need for the creation of a real `window`.
			// e.g. var jQuery = require("jquery")(window);
			// See ticket #14549 for more info.
			module.exports = global.document ?
				factory( global, true ) :
				function( w ) {
					if ( !w.document ) {
						throw new Error( "jQuery requires a window with a document" );
					}
					return factory( w );
				};
		} else {
			factory( global );
		}
	
	// Pass this if window is not defined yet
	} )( typeof window !== "undefined" ? window : this, function( window, noGlobal ) {
	
	// Edge <= 12 - 13+, Firefox <=18 - 45+, IE 10 - 11, Safari 5.1 - 9+, iOS 6 - 9.1
	// throw exceptions when non-strict code (e.g., ASP.NET 4.5) accesses strict mode
	// arguments.callee.caller (trac-13335). But as of jQuery 3.0 (2016), strict mode should be common
	// enough that all such attempts are guarded in a try block.
	"use strict";
	
	var arr = [];
	
	var document = window.document;
	
	var getProto = Object.getPrototypeOf;
	
	var slice = arr.slice;
	
	var concat = arr.concat;
	
	var push = arr.push;
	
	var indexOf = arr.indexOf;
	
	var class2type = {};
	
	var toString = class2type.toString;
	
	var hasOwn = class2type.hasOwnProperty;
	
	var fnToString = hasOwn.toString;
	
	var ObjectFunctionString = fnToString.call( Object );
	
	var support = {};
	
	var isFunction = function isFunction( obj ) {
	
	      // Support: Chrome <=57, Firefox <=52
	      // In some browsers, typeof returns "function" for HTML <object> elements
	      // (i.e., `typeof document.createElement( "object" ) === "function"`).
	      // We don't want to classify *any* DOM node as a function.
	      return typeof obj === "function" && typeof obj.nodeType !== "number";
	  };
	
	
	var isWindow = function isWindow( obj ) {
			return obj != null && obj === obj.window;
		};
	
	
	
	
		var preservedScriptAttributes = {
			type: true,
			src: true,
			noModule: true
		};
	
		function DOMEval( code, doc, node ) {
			doc = doc || document;
	
			var i,
				script = doc.createElement( "script" );
	
			script.text = code;
			if ( node ) {
				for ( i in preservedScriptAttributes ) {
					if ( node[ i ] ) {
						script[ i ] = node[ i ];
					}
				}
			}
			doc.head.appendChild( script ).parentNode.removeChild( script );
		}
	
	
	function toType( obj ) {
		if ( obj == null ) {
			return obj + "";
		}
	
		// Support: Android <=2.3 only (functionish RegExp)
		return typeof obj === "object" || typeof obj === "function" ?
			class2type[ toString.call( obj ) ] || "object" :
			typeof obj;
	}
	/* global Symbol */
	// Defining this global in .eslintrc.json would create a danger of using the global
	// unguarded in another place, it seems safer to define global only for this module
	
	
	
	var
		version = "3.3.1",
	
		// Define a local copy of jQuery
		jQuery = function( selector, context ) {
	
			// The jQuery object is actually just the init constructor 'enhanced'
			// Need init if jQuery is called (just allow error to be thrown if not included)
			return new jQuery.fn.init( selector, context );
		},
	
		// Support: Android <=4.0 only
		// Make sure we trim BOM and NBSP
		rtrim = /^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g;
	
	jQuery.fn = jQuery.prototype = {
	
		// The current version of jQuery being used
		jquery: version,
	
		constructor: jQuery,
	
		// The default length of a jQuery object is 0
		length: 0,
	
		toArray: function() {
			return slice.call( this );
		},
	
		// Get the Nth element in the matched element set OR
		// Get the whole matched element set as a clean array
		get: function( num ) {
	
			// Return all the elements in a clean array
			if ( num == null ) {
				return slice.call( this );
			}
	
			// Return just the one element from the set
			return num < 0 ? this[ num + this.length ] : this[ num ];
		},
	
		// Take an array of elements and push it onto the stack
		// (returning the new matched element set)
		pushStack: function( elems ) {
	
			// Build a new jQuery matched element set
			var ret = jQuery.merge( this.constructor(), elems );
	
			// Add the old object onto the stack (as a reference)
			ret.prevObject = this;
	
			// Return the newly-formed element set
			return ret;
		},
	
		// Execute a callback for every element in the matched set.
		each: function( callback ) {
			return jQuery.each( this, callback );
		},
	
		map: function( callback ) {
			return this.pushStack( jQuery.map( this, function( elem, i ) {
				return callback.call( elem, i, elem );
			} ) );
		},
	
		slice: function() {
			return this.pushStack( slice.apply( this, arguments ) );
		},
	
		first: function() {
			return this.eq( 0 );
		},
	
		last: function() {
			return this.eq( -1 );
		},
	
		eq: function( i ) {
			var len = this.length,
				j = +i + ( i < 0 ? len : 0 );
			return this.pushStack( j >= 0 && j < len ? [ this[ j ] ] : [] );
		},
	
		end: function() {
			return this.prevObject || this.constructor();
		},
	
		// For internal use only.
		// Behaves like an Array's method, not like a jQuery method.
		push: push,
		sort: arr.sort,
		splice: arr.splice
	};
	
	jQuery.extend = jQuery.fn.extend = function() {
		var options, name, src, copy, copyIsArray, clone,
			target = arguments[ 0 ] || {},
			i = 1,
			length = arguments.length,
			deep = false;
	
		// Handle a deep copy situation
		if ( typeof target === "boolean" ) {
			deep = target;
	
			// Skip the boolean and the target
			target = arguments[ i ] || {};
			i++;
		}
	
		// Handle case when target is a string or something (possible in deep copy)
		if ( typeof target !== "object" && !isFunction( target ) ) {
			target = {};
		}
	
		// Extend jQuery itself if only one argument is passed
		if ( i === length ) {
			target = this;
			i--;
		}
	
		for ( ; i < length; i++ ) {
	
			// Only deal with non-null/undefined values
			if ( ( options = arguments[ i ] ) != null ) {
	
				// Extend the base object
				for ( name in options ) {
					src = target[ name ];
					copy = options[ name ];
	
					// Prevent never-ending loop
					if ( target === copy ) {
						continue;
					}
	
					// Recurse if we're merging plain objects or arrays
					if ( deep && copy && ( jQuery.isPlainObject( copy ) ||
						( copyIsArray = Array.isArray( copy ) ) ) ) {
	
						if ( copyIsArray ) {
							copyIsArray = false;
							clone = src && Array.isArray( src ) ? src : [];
	
						} else {
							clone = src && jQuery.isPlainObject( src ) ? src : {};
						}
	
						// Never move original objects, clone them
						target[ name ] = jQuery.extend( deep, clone, copy );
	
					// Don't bring in undefined values
					} else if ( copy !== undefined ) {
						target[ name ] = copy;
					}
				}
			}
		}
	
		// Return the modified object
		return target;
	};
	
	jQuery.extend( {
	
		// Unique for each copy of jQuery on the page
		expando: "jQuery" + ( version + Math.random() ).replace( /\D/g, "" ),
	
		// Assume jQuery is ready without the ready module
		isReady: true,
	
		error: function( msg ) {
			throw new Error( msg );
		},
	
		noop: function() {},
	
		isPlainObject: function( obj ) {
			var proto, Ctor;
	
			// Detect obvious negatives
			// Use toString instead of jQuery.type to catch host objects
			if ( !obj || toString.call( obj ) !== "[object Object]" ) {
				return false;
			}
	
			proto = getProto( obj );
	
			// Objects with no prototype (e.g., `Object.create( null )`) are plain
			if ( !proto ) {
				return true;
			}
	
			// Objects with prototype are plain iff they were constructed by a global Object function
			Ctor = hasOwn.call( proto, "constructor" ) && proto.constructor;
			return typeof Ctor === "function" && fnToString.call( Ctor ) === ObjectFunctionString;
		},
	
		isEmptyObject: function( obj ) {
	
			/* eslint-disable no-unused-vars */
			// See https://github.com/eslint/eslint/issues/6125
			var name;
	
			for ( name in obj ) {
				return false;
			}
			return true;
		},
	
		// Evaluates a script in a global context
		globalEval: function( code ) {
			DOMEval( code );
		},
	
		each: function( obj, callback ) {
			var length, i = 0;
	
			if ( isArrayLike( obj ) ) {
				length = obj.length;
				for ( ; i < length; i++ ) {
					if ( callback.call( obj[ i ], i, obj[ i ] ) === false ) {
						break;
					}
				}
			} else {
				for ( i in obj ) {
					if ( callback.call( obj[ i ], i, obj[ i ] ) === false ) {
						break;
					}
				}
			}
	
			return obj;
		},
	
		// Support: Android <=4.0 only
		trim: function( text ) {
			return text == null ?
				"" :
				( text + "" ).replace( rtrim, "" );
		},
	
		// results is for internal usage only
		makeArray: function( arr, results ) {
			var ret = results || [];
	
			if ( arr != null ) {
				if ( isArrayLike( Object( arr ) ) ) {
					jQuery.merge( ret,
						typeof arr === "string" ?
						[ arr ] : arr
					);
				} else {
					push.call( ret, arr );
				}
			}
	
			return ret;
		},
	
		inArray: function( elem, arr, i ) {
			return arr == null ? -1 : indexOf.call( arr, elem, i );
		},
	
		// Support: Android <=4.0 only, PhantomJS 1 only
		// push.apply(_, arraylike) throws on ancient WebKit
		merge: function( first, second ) {
			var len = +second.length,
				j = 0,
				i = first.length;
	
			for ( ; j < len; j++ ) {
				first[ i++ ] = second[ j ];
			}
	
			first.length = i;
	
			return first;
		},
	
		grep: function( elems, callback, invert ) {
			var callbackInverse,
				matches = [],
				i = 0,
				length = elems.length,
				callbackExpect = !invert;
	
			// Go through the array, only saving the items
			// that pass the validator function
			for ( ; i < length; i++ ) {
				callbackInverse = !callback( elems[ i ], i );
				if ( callbackInverse !== callbackExpect ) {
					matches.push( elems[ i ] );
				}
			}
	
			return matches;
		},
	
		// arg is for internal usage only
		map: function( elems, callback, arg ) {
			var length, value,
				i = 0,
				ret = [];
	
			// Go through the array, translating each of the items to their new values
			if ( isArrayLike( elems ) ) {
				length = elems.length;
				for ( ; i < length; i++ ) {
					value = callback( elems[ i ], i, arg );
	
					if ( value != null ) {
						ret.push( value );
					}
				}
	
			// Go through every key on the object,
			} else {
				for ( i in elems ) {
					value = callback( elems[ i ], i, arg );
	
					if ( value != null ) {
						ret.push( value );
					}
				}
			}
	
			// Flatten any nested arrays
			return concat.apply( [], ret );
		},
	
		// A global GUID counter for objects
		guid: 1,
	
		// jQuery.support is not used in Core but other projects attach their
		// properties to it so it needs to exist.
		support: support
	} );
	
	if ( typeof Symbol === "function" ) {
		jQuery.fn[ Symbol.iterator ] = arr[ Symbol.iterator ];
	}
	
	// Populate the class2type map
	jQuery.each( "Boolean Number String Function Array Date RegExp Object Error Symbol".split( " " ),
	function( i, name ) {
		class2type[ "[object " + name + "]" ] = name.toLowerCase();
	} );
	
	function isArrayLike( obj ) {
	
		// Support: real iOS 8.2 only (not reproducible in simulator)
		// `in` check used to prevent JIT error (gh-2145)
		// hasOwn isn't used here due to false negatives
		// regarding Nodelist length in IE
		var length = !!obj && "length" in obj && obj.length,
			type = toType( obj );
	
		if ( isFunction( obj ) || isWindow( obj ) ) {
			return false;
		}
	
		return type === "array" || length === 0 ||
			typeof length === "number" && length > 0 && ( length - 1 ) in obj;
	}
	var Sizzle =
	/*!
	 * Sizzle CSS Selector Engine v2.3.3
	 * https://sizzlejs.com/
	 *
	 * Copyright jQuery Foundation and other contributors
	 * Released under the MIT license
	 * http://jquery.org/license
	 *
	 * Date: 2016-08-08
	 */
	(function( window ) {
	
	var i,
		support,
		Expr,
		getText,
		isXML,
		tokenize,
		compile,
		select,
		outermostContext,
		sortInput,
		hasDuplicate,
	
		// Local document vars
		setDocument,
		document,
		docElem,
		documentIsHTML,
		rbuggyQSA,
		rbuggyMatches,
		matches,
		contains,
	
		// Instance-specific data
		expando = "sizzle" + 1 * new Date(),
		preferredDoc = window.document,
		dirruns = 0,
		done = 0,
		classCache = createCache(),
		tokenCache = createCache(),
		compilerCache = createCache(),
		sortOrder = function( a, b ) {
			if ( a === b ) {
				hasDuplicate = true;
			}
			return 0;
		},
	
		// Instance methods
		hasOwn = ({}).hasOwnProperty,
		arr = [],
		pop = arr.pop,
		push_native = arr.push,
		push = arr.push,
		slice = arr.slice,
		// Use a stripped-down indexOf as it's faster than native
		// https://jsperf.com/thor-indexof-vs-for/5
		indexOf = function( list, elem ) {
			var i = 0,
				len = list.length;
			for ( ; i < len; i++ ) {
				if ( list[i] === elem ) {
					return i;
				}
			}
			return -1;
		},
	
		booleans = "checked|selected|async|autofocus|autoplay|controls|defer|disabled|hidden|ismap|loop|multiple|open|readonly|required|scoped",
	
		// Regular expressions
	
		// http://www.w3.org/TR/css3-selectors/#whitespace
		whitespace = "[\\x20\\t\\r\\n\\f]",
	
		// http://www.w3.org/TR/CSS21/syndata.html#value-def-identifier
		identifier = "(?:\\\\.|[\\w-]|[^\0-\\xa0])+",
	
		// Attribute selectors: http://www.w3.org/TR/selectors/#attribute-selectors
		attributes = "\\[" + whitespace + "*(" + identifier + ")(?:" + whitespace +
			// Operator (capture 2)
			"*([*^$|!~]?=)" + whitespace +
			// "Attribute values must be CSS identifiers [capture 5] or strings [capture 3 or capture 4]"
			"*(?:'((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\"|(" + identifier + "))|)" + whitespace +
			"*\\]",
	
		pseudos = ":(" + identifier + ")(?:\\((" +
			// To reduce the number of selectors needing tokenize in the preFilter, prefer arguments:
			// 1. quoted (capture 3; capture 4 or capture 5)
			"('((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\")|" +
			// 2. simple (capture 6)
			"((?:\\\\.|[^\\\\()[\\]]|" + attributes + ")*)|" +
			// 3. anything else (capture 2)
			".*" +
			")\\)|)",
	
		// Leading and non-escaped trailing whitespace, capturing some non-whitespace characters preceding the latter
		rwhitespace = new RegExp( whitespace + "+", "g" ),
		rtrim = new RegExp( "^" + whitespace + "+|((?:^|[^\\\\])(?:\\\\.)*)" + whitespace + "+$", "g" ),
	
		rcomma = new RegExp( "^" + whitespace + "*," + whitespace + "*" ),
		rcombinators = new RegExp( "^" + whitespace + "*([>+~]|" + whitespace + ")" + whitespace + "*" ),
	
		rattributeQuotes = new RegExp( "=" + whitespace + "*([^\\]'\"]*?)" + whitespace + "*\\]", "g" ),
	
		rpseudo = new RegExp( pseudos ),
		ridentifier = new RegExp( "^" + identifier + "$" ),
	
		matchExpr = {
			"ID": new RegExp( "^#(" + identifier + ")" ),
			"CLASS": new RegExp( "^\\.(" + identifier + ")" ),
			"TAG": new RegExp( "^(" + identifier + "|[*])" ),
			"ATTR": new RegExp( "^" + attributes ),
			"PSEUDO": new RegExp( "^" + pseudos ),
			"CHILD": new RegExp( "^:(only|first|last|nth|nth-last)-(child|of-type)(?:\\(" + whitespace +
				"*(even|odd|(([+-]|)(\\d*)n|)" + whitespace + "*(?:([+-]|)" + whitespace +
				"*(\\d+)|))" + whitespace + "*\\)|)", "i" ),
			"bool": new RegExp( "^(?:" + booleans + ")$", "i" ),
			// For use in libraries implementing .is()
			// We use this for POS matching in `select`
			"needsContext": new RegExp( "^" + whitespace + "*[>+~]|:(even|odd|eq|gt|lt|nth|first|last)(?:\\(" +
				whitespace + "*((?:-\\d)?\\d*)" + whitespace + "*\\)|)(?=[^-]|$)", "i" )
		},
	
		rinputs = /^(?:input|select|textarea|button)$/i,
		rheader = /^h\d$/i,
	
		rnative = /^[^{]+\{\s*\[native \w/,
	
		// Easily-parseable/retrievable ID or TAG or CLASS selectors
		rquickExpr = /^(?:#([\w-]+)|(\w+)|\.([\w-]+))$/,
	
		rsibling = /[+~]/,
	
		// CSS escapes
		// http://www.w3.org/TR/CSS21/syndata.html#escaped-characters
		runescape = new RegExp( "\\\\([\\da-f]{1,6}" + whitespace + "?|(" + whitespace + ")|.)", "ig" ),
		funescape = function( _, escaped, escapedWhitespace ) {
			var high = "0x" + escaped - 0x10000;
			// NaN means non-codepoint
			// Support: Firefox<24
			// Workaround erroneous numeric interpretation of +"0x"
			return high !== high || escapedWhitespace ?
				escaped :
				high < 0 ?
					// BMP codepoint
					String.fromCharCode( high + 0x10000 ) :
					// Supplemental Plane codepoint (surrogate pair)
					String.fromCharCode( high >> 10 | 0xD800, high & 0x3FF | 0xDC00 );
		},
	
		// CSS string/identifier serialization
		// https://drafts.csswg.org/cssom/#common-serializing-idioms
		rcssescape = /([\0-\x1f\x7f]|^-?\d)|^-$|[^\0-\x1f\x7f-\uFFFF\w-]/g,
		fcssescape = function( ch, asCodePoint ) {
			if ( asCodePoint ) {
	
				// U+0000 NULL becomes U+FFFD REPLACEMENT CHARACTER
				if ( ch === "\0" ) {
					return "\uFFFD";
				}
	
				// Control characters and (dependent upon position) numbers get escaped as code points
				return ch.slice( 0, -1 ) + "\\" + ch.charCodeAt( ch.length - 1 ).toString( 16 ) + " ";
			}
	
			// Other potentially-special ASCII characters get backslash-escaped
			return "\\" + ch;
		},
	
		// Used for iframes
		// See setDocument()
		// Removing the function wrapper causes a "Permission Denied"
		// error in IE
		unloadHandler = function() {
			setDocument();
		},
	
		disabledAncestor = addCombinator(
			function( elem ) {
				return elem.disabled === true && ("form" in elem || "label" in elem);
			},
			{ dir: "parentNode", next: "legend" }
		);
	
	// Optimize for push.apply( _, NodeList )
	try {
		push.apply(
			(arr = slice.call( preferredDoc.childNodes )),
			preferredDoc.childNodes
		);
		// Support: Android<4.0
		// Detect silently failing push.apply
		arr[ preferredDoc.childNodes.length ].nodeType;
	} catch ( e ) {
		push = { apply: arr.length ?
	
			// Leverage slice if possible
			function( target, els ) {
				push_native.apply( target, slice.call(els) );
			} :
	
			// Support: IE<9
			// Otherwise append directly
			function( target, els ) {
				var j = target.length,
					i = 0;
				// Can't trust NodeList.length
				while ( (target[j++] = els[i++]) ) {}
				target.length = j - 1;
			}
		};
	}
	
	function Sizzle( selector, context, results, seed ) {
		var m, i, elem, nid, match, groups, newSelector,
			newContext = context && context.ownerDocument,
	
			// nodeType defaults to 9, since context defaults to document
			nodeType = context ? context.nodeType : 9;
	
		results = results || [];
	
		// Return early from calls with invalid selector or context
		if ( typeof selector !== "string" || !selector ||
			nodeType !== 1 && nodeType !== 9 && nodeType !== 11 ) {
	
			return results;
		}
	
		// Try to shortcut find operations (as opposed to filters) in HTML documents
		if ( !seed ) {
	
			if ( ( context ? context.ownerDocument || context : preferredDoc ) !== document ) {
				setDocument( context );
			}
			context = context || document;
	
			if ( documentIsHTML ) {
	
				// If the selector is sufficiently simple, try using a "get*By*" DOM method
				// (excepting DocumentFragment context, where the methods don't exist)
				if ( nodeType !== 11 && (match = rquickExpr.exec( selector )) ) {
	
					// ID selector
					if ( (m = match[1]) ) {
	
						// Document context
						if ( nodeType === 9 ) {
							if ( (elem = context.getElementById( m )) ) {
	
								// Support: IE, Opera, Webkit
								// TODO: identify versions
								// getElementById can match elements by name instead of ID
								if ( elem.id === m ) {
									results.push( elem );
									return results;
								}
							} else {
								return results;
							}
	
						// Element context
						} else {
	
							// Support: IE, Opera, Webkit
							// TODO: identify versions
							// getElementById can match elements by name instead of ID
							if ( newContext && (elem = newContext.getElementById( m )) &&
								contains( context, elem ) &&
								elem.id === m ) {
	
								results.push( elem );
								return results;
							}
						}
	
					// Type selector
					} else if ( match[2] ) {
						push.apply( results, context.getElementsByTagName( selector ) );
						return results;
	
					// Class selector
					} else if ( (m = match[3]) && support.getElementsByClassName &&
						context.getElementsByClassName ) {
	
						push.apply( results, context.getElementsByClassName( m ) );
						return results;
					}
				}
	
				// Take advantage of querySelectorAll
				if ( support.qsa &&
					!compilerCache[ selector + " " ] &&
					(!rbuggyQSA || !rbuggyQSA.test( selector )) ) {
	
					if ( nodeType !== 1 ) {
						newContext = context;
						newSelector = selector;
	
					// qSA looks outside Element context, which is not what we want
					// Thanks to Andrew Dupont for this workaround technique
					// Support: IE <=8
					// Exclude object elements
					} else if ( context.nodeName.toLowerCase() !== "object" ) {
	
						// Capture the context ID, setting it first if necessary
						if ( (nid = context.getAttribute( "id" )) ) {
							nid = nid.replace( rcssescape, fcssescape );
						} else {
							context.setAttribute( "id", (nid = expando) );
						}
	
						// Prefix every selector in the list
						groups = tokenize( selector );
						i = groups.length;
						while ( i-- ) {
							groups[i] = "#" + nid + " " + toSelector( groups[i] );
						}
						newSelector = groups.join( "," );
	
						// Expand context for sibling selectors
						newContext = rsibling.test( selector ) && testContext( context.parentNode ) ||
							context;
					}
	
					if ( newSelector ) {
						try {
							push.apply( results,
								newContext.querySelectorAll( newSelector )
							);
							return results;
						} catch ( qsaError ) {
						} finally {
							if ( nid === expando ) {
								context.removeAttribute( "id" );
							}
						}
					}
				}
			}
		}
	
		// All others
		return select( selector.replace( rtrim, "$1" ), context, results, seed );
	}
	
	/**
	 * Create key-value caches of limited size
	 * @returns {function(string, object)} Returns the Object data after storing it on itself with
	 *	property name the (space-suffixed) string and (if the cache is larger than Expr.cacheLength)
	 *	deleting the oldest entry
	 */
	function createCache() {
		var keys = [];
	
		function cache( key, value ) {
			// Use (key + " ") to avoid collision with native prototype properties (see Issue #157)
			if ( keys.push( key + " " ) > Expr.cacheLength ) {
				// Only keep the most recent entries
				delete cache[ keys.shift() ];
			}
			return (cache[ key + " " ] = value);
		}
		return cache;
	}
	
	/**
	 * Mark a function for special use by Sizzle
	 * @param {Function} fn The function to mark
	 */
	function markFunction( fn ) {
		fn[ expando ] = true;
		return fn;
	}
	
	/**
	 * Support testing using an element
	 * @param {Function} fn Passed the created element and returns a boolean result
	 */
	function assert( fn ) {
		var el = document.createElement("fieldset");
	
		try {
			return !!fn( el );
		} catch (e) {
			return false;
		} finally {
			// Remove from its parent by default
			if ( el.parentNode ) {
				el.parentNode.removeChild( el );
			}
			// release memory in IE
			el = null;
		}
	}
	
	/**
	 * Adds the same handler for all of the specified attrs
	 * @param {String} attrs Pipe-separated list of attributes
	 * @param {Function} handler The method that will be applied
	 */
	function addHandle( attrs, handler ) {
		var arr = attrs.split("|"),
			i = arr.length;
	
		while ( i-- ) {
			Expr.attrHandle[ arr[i] ] = handler;
		}
	}
	
	/**
	 * Checks document order of two siblings
	 * @param {Element} a
	 * @param {Element} b
	 * @returns {Number} Returns less than 0 if a precedes b, greater than 0 if a follows b
	 */
	function siblingCheck( a, b ) {
		var cur = b && a,
			diff = cur && a.nodeType === 1 && b.nodeType === 1 &&
				a.sourceIndex - b.sourceIndex;
	
		// Use IE sourceIndex if available on both nodes
		if ( diff ) {
			return diff;
		}
	
		// Check if b follows a
		if ( cur ) {
			while ( (cur = cur.nextSibling) ) {
				if ( cur === b ) {
					return -1;
				}
			}
		}
	
		return a ? 1 : -1;
	}
	
	/**
	 * Returns a function to use in pseudos for input types
	 * @param {String} type
	 */
	function createInputPseudo( type ) {
		return function( elem ) {
			var name = elem.nodeName.toLowerCase();
			return name === "input" && elem.type === type;
		};
	}
	
	/**
	 * Returns a function to use in pseudos for buttons
	 * @param {String} type
	 */
	function createButtonPseudo( type ) {
		return function( elem ) {
			var name = elem.nodeName.toLowerCase();
			return (name === "input" || name === "button") && elem.type === type;
		};
	}
	
	/**
	 * Returns a function to use in pseudos for :enabled/:disabled
	 * @param {Boolean} disabled true for :disabled; false for :enabled
	 */
	function createDisabledPseudo( disabled ) {
	
		// Known :disabled false positives: fieldset[disabled] > legend:nth-of-type(n+2) :can-disable
		return function( elem ) {
	
			// Only certain elements can match :enabled or :disabled
			// https://html.spec.whatwg.org/multipage/scripting.html#selector-enabled
			// https://html.spec.whatwg.org/multipage/scripting.html#selector-disabled
			if ( "form" in elem ) {
	
				// Check for inherited disabledness on relevant non-disabled elements:
				// * listed form-associated elements in a disabled fieldset
				//   https://html.spec.whatwg.org/multipage/forms.html#category-listed
				//   https://html.spec.whatwg.org/multipage/forms.html#concept-fe-disabled
				// * option elements in a disabled optgroup
				//   https://html.spec.whatwg.org/multipage/forms.html#concept-option-disabled
				// All such elements have a "form" property.
				if ( elem.parentNode && elem.disabled === false ) {
	
					// Option elements defer to a parent optgroup if present
					if ( "label" in elem ) {
						if ( "label" in elem.parentNode ) {
							return elem.parentNode.disabled === disabled;
						} else {
							return elem.disabled === disabled;
						}
					}
	
					// Support: IE 6 - 11
					// Use the isDisabled shortcut property to check for disabled fieldset ancestors
					return elem.isDisabled === disabled ||
	
						// Where there is no isDisabled, check manually
						/* jshint -W018 */
						elem.isDisabled !== !disabled &&
							disabledAncestor( elem ) === disabled;
				}
	
				return elem.disabled === disabled;
	
			// Try to winnow out elements that can't be disabled before trusting the disabled property.
			// Some victims get caught in our net (label, legend, menu, track), but it shouldn't
			// even exist on them, let alone have a boolean value.
			} else if ( "label" in elem ) {
				return elem.disabled === disabled;
			}
	
			// Remaining elements are neither :enabled nor :disabled
			return false;
		};
	}
	
	/**
	 * Returns a function to use in pseudos for positionals
	 * @param {Function} fn
	 */
	function createPositionalPseudo( fn ) {
		return markFunction(function( argument ) {
			argument = +argument;
			return markFunction(function( seed, matches ) {
				var j,
					matchIndexes = fn( [], seed.length, argument ),
					i = matchIndexes.length;
	
				// Match elements found at the specified indexes
				while ( i-- ) {
					if ( seed[ (j = matchIndexes[i]) ] ) {
						seed[j] = !(matches[j] = seed[j]);
					}
				}
			});
		});
	}
	
	/**
	 * Checks a node for validity as a Sizzle context
	 * @param {Element|Object=} context
	 * @returns {Element|Object|Boolean} The input node if acceptable, otherwise a falsy value
	 */
	function testContext( context ) {
		return context && typeof context.getElementsByTagName !== "undefined" && context;
	}
	
	// Expose support vars for convenience
	support = Sizzle.support = {};
	
	/**
	 * Detects XML nodes
	 * @param {Element|Object} elem An element or a document
	 * @returns {Boolean} True iff elem is a non-HTML XML node
	 */
	isXML = Sizzle.isXML = function( elem ) {
		// documentElement is verified for cases where it doesn't yet exist
		// (such as loading iframes in IE - #4833)
		var documentElement = elem && (elem.ownerDocument || elem).documentElement;
		return documentElement ? documentElement.nodeName !== "HTML" : false;
	};
	
	/**
	 * Sets document-related variables once based on the current document
	 * @param {Element|Object} [doc] An element or document object to use to set the document
	 * @returns {Object} Returns the current document
	 */
	setDocument = Sizzle.setDocument = function( node ) {
		var hasCompare, subWindow,
			doc = node ? node.ownerDocument || node : preferredDoc;
	
		// Return early if doc is invalid or already selected
		if ( doc === document || doc.nodeType !== 9 || !doc.documentElement ) {
			return document;
		}
	
		// Update global variables
		document = doc;
		docElem = document.documentElement;
		documentIsHTML = !isXML( document );
	
		// Support: IE 9-11, Edge
		// Accessing iframe documents after unload throws "permission denied" errors (jQuery #13936)
		if ( preferredDoc !== document &&
			(subWindow = document.defaultView) && subWindow.top !== subWindow ) {
	
			// Support: IE 11, Edge
			if ( subWindow.addEventListener ) {
				subWindow.addEventListener( "unload", unloadHandler, false );
	
			// Support: IE 9 - 10 only
			} else if ( subWindow.attachEvent ) {
				subWindow.attachEvent( "onunload", unloadHandler );
			}
		}
	
		/* Attributes
		---------------------------------------------------------------------- */
	
		// Support: IE<8
		// Verify that getAttribute really returns attributes and not properties
		// (excepting IE8 booleans)
		support.attributes = assert(function( el ) {
			el.className = "i";
			return !el.getAttribute("className");
		});
	
		/* getElement(s)By*
		---------------------------------------------------------------------- */
	
		// Check if getElementsByTagName("*") returns only elements
		support.getElementsByTagName = assert(function( el ) {
			el.appendChild( document.createComment("") );
			return !el.getElementsByTagName("*").length;
		});
	
		// Support: IE<9
		support.getElementsByClassName = rnative.test( document.getElementsByClassName );
	
		// Support: IE<10
		// Check if getElementById returns elements by name
		// The broken getElementById methods don't pick up programmatically-set names,
		// so use a roundabout getElementsByName test
		support.getById = assert(function( el ) {
			docElem.appendChild( el ).id = expando;
			return !document.getElementsByName || !document.getElementsByName( expando ).length;
		});
	
		// ID filter and find
		if ( support.getById ) {
			Expr.filter["ID"] = function( id ) {
				var attrId = id.replace( runescape, funescape );
				return function( elem ) {
					return elem.getAttribute("id") === attrId;
				};
			};
			Expr.find["ID"] = function( id, context ) {
				if ( typeof context.getElementById !== "undefined" && documentIsHTML ) {
					var elem = context.getElementById( id );
					return elem ? [ elem ] : [];
				}
			};
		} else {
			Expr.filter["ID"] =  function( id ) {
				var attrId = id.replace( runescape, funescape );
				return function( elem ) {
					var node = typeof elem.getAttributeNode !== "undefined" &&
						elem.getAttributeNode("id");
					return node && node.value === attrId;
				};
			};
	
			// Support: IE 6 - 7 only
			// getElementById is not reliable as a find shortcut
			Expr.find["ID"] = function( id, context ) {
				if ( typeof context.getElementById !== "undefined" && documentIsHTML ) {
					var node, i, elems,
						elem = context.getElementById( id );
	
					if ( elem ) {
	
						// Verify the id attribute
						node = elem.getAttributeNode("id");
						if ( node && node.value === id ) {
							return [ elem ];
						}
	
						// Fall back on getElementsByName
						elems = context.getElementsByName( id );
						i = 0;
						while ( (elem = elems[i++]) ) {
							node = elem.getAttributeNode("id");
							if ( node && node.value === id ) {
								return [ elem ];
							}
						}
					}
	
					return [];
				}
			};
		}
	
		// Tag
		Expr.find["TAG"] = support.getElementsByTagName ?
			function( tag, context ) {
				if ( typeof context.getElementsByTagName !== "undefined" ) {
					return context.getElementsByTagName( tag );
	
				// DocumentFragment nodes don't have gEBTN
				} else if ( support.qsa ) {
					return context.querySelectorAll( tag );
				}
			} :
	
			function( tag, context ) {
				var elem,
					tmp = [],
					i = 0,
					// By happy coincidence, a (broken) gEBTN appears on DocumentFragment nodes too
					results = context.getElementsByTagName( tag );
	
				// Filter out possible comments
				if ( tag === "*" ) {
					while ( (elem = results[i++]) ) {
						if ( elem.nodeType === 1 ) {
							tmp.push( elem );
						}
					}
	
					return tmp;
				}
				return results;
			};
	
		// Class
		Expr.find["CLASS"] = support.getElementsByClassName && function( className, context ) {
			if ( typeof context.getElementsByClassName !== "undefined" && documentIsHTML ) {
				return context.getElementsByClassName( className );
			}
		};
	
		/* QSA/matchesSelector
		---------------------------------------------------------------------- */
	
		// QSA and matchesSelector support
	
		// matchesSelector(:active) reports false when true (IE9/Opera 11.5)
		rbuggyMatches = [];
	
		// qSa(:focus) reports false when true (Chrome 21)
		// We allow this because of a bug in IE8/9 that throws an error
		// whenever `document.activeElement` is accessed on an iframe
		// So, we allow :focus to pass through QSA all the time to avoid the IE error
		// See https://bugs.jquery.com/ticket/13378
		rbuggyQSA = [];
	
		if ( (support.qsa = rnative.test( document.querySelectorAll )) ) {
			// Build QSA regex
			// Regex strategy adopted from Diego Perini
			assert(function( el ) {
				// Select is set to empty string on purpose
				// This is to test IE's treatment of not explicitly
				// setting a boolean content attribute,
				// since its presence should be enough
				// https://bugs.jquery.com/ticket/12359
				docElem.appendChild( el ).innerHTML = "<a id='" + expando + "'></a>" +
					"<select id='" + expando + "-\r\\' msallowcapture=''>" +
					"<option selected=''></option></select>";
	
				// Support: IE8, Opera 11-12.16
				// Nothing should be selected when empty strings follow ^= or $= or *=
				// The test attribute must be unknown in Opera but "safe" for WinRT
				// https://msdn.microsoft.com/en-us/library/ie/hh465388.aspx#attribute_section
				if ( el.querySelectorAll("[msallowcapture^='']").length ) {
					rbuggyQSA.push( "[*^$]=" + whitespace + "*(?:''|\"\")" );
				}
	
				// Support: IE8
				// Boolean attributes and "value" are not treated correctly
				if ( !el.querySelectorAll("[selected]").length ) {
					rbuggyQSA.push( "\\[" + whitespace + "*(?:value|" + booleans + ")" );
				}
	
				// Support: Chrome<29, Android<4.4, Safari<7.0+, iOS<7.0+, PhantomJS<1.9.8+
				if ( !el.querySelectorAll( "[id~=" + expando + "-]" ).length ) {
					rbuggyQSA.push("~=");
				}
	
				// Webkit/Opera - :checked should return selected option elements
				// http://www.w3.org/TR/2011/REC-css3-selectors-20110929/#checked
				// IE8 throws error here and will not see later tests
				if ( !el.querySelectorAll(":checked").length ) {
					rbuggyQSA.push(":checked");
				}
	
				// Support: Safari 8+, iOS 8+
				// https://bugs.webkit.org/show_bug.cgi?id=136851
				// In-page `selector#id sibling-combinator selector` fails
				if ( !el.querySelectorAll( "a#" + expando + "+*" ).length ) {
					rbuggyQSA.push(".#.+[+~]");
				}
			});
	
			assert(function( el ) {
				el.innerHTML = "<a href='' disabled='disabled'></a>" +
					"<select disabled='disabled'><option/></select>";
	
				// Support: Windows 8 Native Apps
				// The type and name attributes are restricted during .innerHTML assignment
				var input = document.createElement("input");
				input.setAttribute( "type", "hidden" );
				el.appendChild( input ).setAttribute( "name", "D" );
	
				// Support: IE8
				// Enforce case-sensitivity of name attribute
				if ( el.querySelectorAll("[name=d]").length ) {
					rbuggyQSA.push( "name" + whitespace + "*[*^$|!~]?=" );
				}
	
				// FF 3.5 - :enabled/:disabled and hidden elements (hidden elements are still enabled)
				// IE8 throws error here and will not see later tests
				if ( el.querySelectorAll(":enabled").length !== 2 ) {
					rbuggyQSA.push( ":enabled", ":disabled" );
				}
	
				// Support: IE9-11+
				// IE's :disabled selector does not pick up the children of disabled fieldsets
				docElem.appendChild( el ).disabled = true;
				if ( el.querySelectorAll(":disabled").length !== 2 ) {
					rbuggyQSA.push( ":enabled", ":disabled" );
				}
	
				// Opera 10-11 does not throw on post-comma invalid pseudos
				el.querySelectorAll("*,:x");
				rbuggyQSA.push(",.*:");
			});
		}
	
		if ( (support.matchesSelector = rnative.test( (matches = docElem.matches ||
			docElem.webkitMatchesSelector ||
			docElem.mozMatchesSelector ||
			docElem.oMatchesSelector ||
			docElem.msMatchesSelector) )) ) {
	
			assert(function( el ) {
				// Check to see if it's possible to do matchesSelector
				// on a disconnected node (IE 9)
				support.disconnectedMatch = matches.call( el, "*" );
	
				// This should fail with an exception
				// Gecko does not error, returns false instead
				matches.call( el, "[s!='']:x" );
				rbuggyMatches.push( "!=", pseudos );
			});
		}
	
		rbuggyQSA = rbuggyQSA.length && new RegExp( rbuggyQSA.join("|") );
		rbuggyMatches = rbuggyMatches.length && new RegExp( rbuggyMatches.join("|") );
	
		/* Contains
		---------------------------------------------------------------------- */
		hasCompare = rnative.test( docElem.compareDocumentPosition );
	
		// Element contains another
		// Purposefully self-exclusive
		// As in, an element does not contain itself
		contains = hasCompare || rnative.test( docElem.contains ) ?
			function( a, b ) {
				var adown = a.nodeType === 9 ? a.documentElement : a,
					bup = b && b.parentNode;
				return a === bup || !!( bup && bup.nodeType === 1 && (
					adown.contains ?
						adown.contains( bup ) :
						a.compareDocumentPosition && a.compareDocumentPosition( bup ) & 16
				));
			} :
			function( a, b ) {
				if ( b ) {
					while ( (b = b.parentNode) ) {
						if ( b === a ) {
							return true;
						}
					}
				}
				return false;
			};
	
		/* Sorting
		---------------------------------------------------------------------- */
	
		// Document order sorting
		sortOrder = hasCompare ?
		function( a, b ) {
	
			// Flag for duplicate removal
			if ( a === b ) {
				hasDuplicate = true;
				return 0;
			}
	
			// Sort on method existence if only one input has compareDocumentPosition
			var compare = !a.compareDocumentPosition - !b.compareDocumentPosition;
			if ( compare ) {
				return compare;
			}
	
			// Calculate position if both inputs belong to the same document
			compare = ( a.ownerDocument || a ) === ( b.ownerDocument || b ) ?
				a.compareDocumentPosition( b ) :
	
				// Otherwise we know they are disconnected
				1;
	
			// Disconnected nodes
			if ( compare & 1 ||
				(!support.sortDetached && b.compareDocumentPosition( a ) === compare) ) {
	
				// Choose the first element that is related to our preferred document
				if ( a === document || a.ownerDocument === preferredDoc && contains(preferredDoc, a) ) {
					return -1;
				}
				if ( b === document || b.ownerDocument === preferredDoc && contains(preferredDoc, b) ) {
					return 1;
				}
	
				// Maintain original order
				return sortInput ?
					( indexOf( sortInput, a ) - indexOf( sortInput, b ) ) :
					0;
			}
	
			return compare & 4 ? -1 : 1;
		} :
		function( a, b ) {
			// Exit early if the nodes are identical
			if ( a === b ) {
				hasDuplicate = true;
				return 0;
			}
	
			var cur,
				i = 0,
				aup = a.parentNode,
				bup = b.parentNode,
				ap = [ a ],
				bp = [ b ];
	
			// Parentless nodes are either documents or disconnected
			if ( !aup || !bup ) {
				return a === document ? -1 :
					b === document ? 1 :
					aup ? -1 :
					bup ? 1 :
					sortInput ?
					( indexOf( sortInput, a ) - indexOf( sortInput, b ) ) :
					0;
	
			// If the nodes are siblings, we can do a quick check
			} else if ( aup === bup ) {
				return siblingCheck( a, b );
			}
	
			// Otherwise we need full lists of their ancestors for comparison
			cur = a;
			while ( (cur = cur.parentNode) ) {
				ap.unshift( cur );
			}
			cur = b;
			while ( (cur = cur.parentNode) ) {
				bp.unshift( cur );
			}
	
			// Walk down the tree looking for a discrepancy
			while ( ap[i] === bp[i] ) {
				i++;
			}
	
			return i ?
				// Do a sibling check if the nodes have a common ancestor
				siblingCheck( ap[i], bp[i] ) :
	
				// Otherwise nodes in our document sort first
				ap[i] === preferredDoc ? -1 :
				bp[i] === preferredDoc ? 1 :
				0;
		};
	
		return document;
	};
	
	Sizzle.matches = function( expr, elements ) {
		return Sizzle( expr, null, null, elements );
	};
	
	Sizzle.matchesSelector = function( elem, expr ) {
		// Set document vars if needed
		if ( ( elem.ownerDocument || elem ) !== document ) {
			setDocument( elem );
		}
	
		// Make sure that attribute selectors are quoted
		expr = expr.replace( rattributeQuotes, "='$1']" );
	
		if ( support.matchesSelector && documentIsHTML &&
			!compilerCache[ expr + " " ] &&
			( !rbuggyMatches || !rbuggyMatches.test( expr ) ) &&
			( !rbuggyQSA     || !rbuggyQSA.test( expr ) ) ) {
	
			try {
				var ret = matches.call( elem, expr );
	
				// IE 9's matchesSelector returns false on disconnected nodes
				if ( ret || support.disconnectedMatch ||
						// As well, disconnected nodes are said to be in a document
						// fragment in IE 9
						elem.document && elem.document.nodeType !== 11 ) {
					return ret;
				}
			} catch (e) {}
		}
	
		return Sizzle( expr, document, null, [ elem ] ).length > 0;
	};
	
	Sizzle.contains = function( context, elem ) {
		// Set document vars if needed
		if ( ( context.ownerDocument || context ) !== document ) {
			setDocument( context );
		}
		return contains( context, elem );
	};
	
	Sizzle.attr = function( elem, name ) {
		// Set document vars if needed
		if ( ( elem.ownerDocument || elem ) !== document ) {
			setDocument( elem );
		}
	
		var fn = Expr.attrHandle[ name.toLowerCase() ],
			// Don't get fooled by Object.prototype properties (jQuery #13807)
			val = fn && hasOwn.call( Expr.attrHandle, name.toLowerCase() ) ?
				fn( elem, name, !documentIsHTML ) :
				undefined;
	
		return val !== undefined ?
			val :
			support.attributes || !documentIsHTML ?
				elem.getAttribute( name ) :
				(val = elem.getAttributeNode(name)) && val.specified ?
					val.value :
					null;
	};
	
	Sizzle.escape = function( sel ) {
		return (sel + "").replace( rcssescape, fcssescape );
	};
	
	Sizzle.error = function( msg ) {
		throw new Error( "Syntax error, unrecognized expression: " + msg );
	};
	
	/**
	 * Document sorting and removing duplicates
	 * @param {ArrayLike} results
	 */
	Sizzle.uniqueSort = function( results ) {
		var elem,
			duplicates = [],
			j = 0,
			i = 0;
	
		// Unless we *know* we can detect duplicates, assume their presence
		hasDuplicate = !support.detectDuplicates;
		sortInput = !support.sortStable && results.slice( 0 );
		results.sort( sortOrder );
	
		if ( hasDuplicate ) {
			while ( (elem = results[i++]) ) {
				if ( elem === results[ i ] ) {
					j = duplicates.push( i );
				}
			}
			while ( j-- ) {
				results.splice( duplicates[ j ], 1 );
			}
		}
	
		// Clear input after sorting to release objects
		// See https://github.com/jquery/sizzle/pull/225
		sortInput = null;
	
		return results;
	};
	
	/**
	 * Utility function for retrieving the text value of an array of DOM nodes
	 * @param {Array|Element} elem
	 */
	getText = Sizzle.getText = function( elem ) {
		var node,
			ret = "",
			i = 0,
			nodeType = elem.nodeType;
	
		if ( !nodeType ) {
			// If no nodeType, this is expected to be an array
			while ( (node = elem[i++]) ) {
				// Do not traverse comment nodes
				ret += getText( node );
			}
		} else if ( nodeType === 1 || nodeType === 9 || nodeType === 11 ) {
			// Use textContent for elements
			// innerText usage removed for consistency of new lines (jQuery #11153)
			if ( typeof elem.textContent === "string" ) {
				return elem.textContent;
			} else {
				// Traverse its children
				for ( elem = elem.firstChild; elem; elem = elem.nextSibling ) {
					ret += getText( elem );
				}
			}
		} else if ( nodeType === 3 || nodeType === 4 ) {
			return elem.nodeValue;
		}
		// Do not include comment or processing instruction nodes
	
		return ret;
	};
	
	Expr = Sizzle.selectors = {
	
		// Can be adjusted by the user
		cacheLength: 50,
	
		createPseudo: markFunction,
	
		match: matchExpr,
	
		attrHandle: {},
	
		find: {},
	
		relative: {
			">": { dir: "parentNode", first: true },
			" ": { dir: "parentNode" },
			"+": { dir: "previousSibling", first: true },
			"~": { dir: "previousSibling" }
		},
	
		preFilter: {
			"ATTR": function( match ) {
				match[1] = match[1].replace( runescape, funescape );
	
				// Move the given value to match[3] whether quoted or unquoted
				match[3] = ( match[3] || match[4] || match[5] || "" ).replace( runescape, funescape );
	
				if ( match[2] === "~=" ) {
					match[3] = " " + match[3] + " ";
				}
	
				return match.slice( 0, 4 );
			},
	
			"CHILD": function( match ) {
				/* matches from matchExpr["CHILD"]
					1 type (only|nth|...)
					2 what (child|of-type)
					3 argument (even|odd|\d*|\d*n([+-]\d+)?|...)
					4 xn-component of xn+y argument ([+-]?\d*n|)
					5 sign of xn-component
					6 x of xn-component
					7 sign of y-component
					8 y of y-component
				*/
				match[1] = match[1].toLowerCase();
	
				if ( match[1].slice( 0, 3 ) === "nth" ) {
					// nth-* requires argument
					if ( !match[3] ) {
						Sizzle.error( match[0] );
					}
	
					// numeric x and y parameters for Expr.filter.CHILD
					// remember that false/true cast respectively to 0/1
					match[4] = +( match[4] ? match[5] + (match[6] || 1) : 2 * ( match[3] === "even" || match[3] === "odd" ) );
					match[5] = +( ( match[7] + match[8] ) || match[3] === "odd" );
	
				// other types prohibit arguments
				} else if ( match[3] ) {
					Sizzle.error( match[0] );
				}
	
				return match;
			},
	
			"PSEUDO": function( match ) {
				var excess,
					unquoted = !match[6] && match[2];
	
				if ( matchExpr["CHILD"].test( match[0] ) ) {
					return null;
				}
	
				// Accept quoted arguments as-is
				if ( match[3] ) {
					match[2] = match[4] || match[5] || "";
	
				// Strip excess characters from unquoted arguments
				} else if ( unquoted && rpseudo.test( unquoted ) &&
					// Get excess from tokenize (recursively)
					(excess = tokenize( unquoted, true )) &&
					// advance to the next closing parenthesis
					(excess = unquoted.indexOf( ")", unquoted.length - excess ) - unquoted.length) ) {
	
					// excess is a negative index
					match[0] = match[0].slice( 0, excess );
					match[2] = unquoted.slice( 0, excess );
				}
	
				// Return only captures needed by the pseudo filter method (type and argument)
				return match.slice( 0, 3 );
			}
		},
	
		filter: {
	
			"TAG": function( nodeNameSelector ) {
				var nodeName = nodeNameSelector.replace( runescape, funescape ).toLowerCase();
				return nodeNameSelector === "*" ?
					function() { return true; } :
					function( elem ) {
						return elem.nodeName && elem.nodeName.toLowerCase() === nodeName;
					};
			},
	
			"CLASS": function( className ) {
				var pattern = classCache[ className + " " ];
	
				return pattern ||
					(pattern = new RegExp( "(^|" + whitespace + ")" + className + "(" + whitespace + "|$)" )) &&
					classCache( className, function( elem ) {
						return pattern.test( typeof elem.className === "string" && elem.className || typeof elem.getAttribute !== "undefined" && elem.getAttribute("class") || "" );
					});
			},
	
			"ATTR": function( name, operator, check ) {
				return function( elem ) {
					var result = Sizzle.attr( elem, name );
	
					if ( result == null ) {
						return operator === "!=";
					}
					if ( !operator ) {
						return true;
					}
	
					result += "";
	
					return operator === "=" ? result === check :
						operator === "!=" ? result !== check :
						operator === "^=" ? check && result.indexOf( check ) === 0 :
						operator === "*=" ? check && result.indexOf( check ) > -1 :
						operator === "$=" ? check && result.slice( -check.length ) === check :
						operator === "~=" ? ( " " + result.replace( rwhitespace, " " ) + " " ).indexOf( check ) > -1 :
						operator === "|=" ? result === check || result.slice( 0, check.length + 1 ) === check + "-" :
						false;
				};
			},
	
			"CHILD": function( type, what, argument, first, last ) {
				var simple = type.slice( 0, 3 ) !== "nth",
					forward = type.slice( -4 ) !== "last",
					ofType = what === "of-type";
	
				return first === 1 && last === 0 ?
	
					// Shortcut for :nth-*(n)
					function( elem ) {
						return !!elem.parentNode;
					} :
	
					function( elem, context, xml ) {
						var cache, uniqueCache, outerCache, node, nodeIndex, start,
							dir = simple !== forward ? "nextSibling" : "previousSibling",
							parent = elem.parentNode,
							name = ofType && elem.nodeName.toLowerCase(),
							useCache = !xml && !ofType,
							diff = false;
	
						if ( parent ) {
	
							// :(first|last|only)-(child|of-type)
							if ( simple ) {
								while ( dir ) {
									node = elem;
									while ( (node = node[ dir ]) ) {
										if ( ofType ?
											node.nodeName.toLowerCase() === name :
											node.nodeType === 1 ) {
	
											return false;
										}
									}
									// Reverse direction for :only-* (if we haven't yet done so)
									start = dir = type === "only" && !start && "nextSibling";
								}
								return true;
							}
	
							start = [ forward ? parent.firstChild : parent.lastChild ];
	
							// non-xml :nth-child(...) stores cache data on `parent`
							if ( forward && useCache ) {
	
								// Seek `elem` from a previously-cached index
	
								// ...in a gzip-friendly way
								node = parent;
								outerCache = node[ expando ] || (node[ expando ] = {});
	
								// Support: IE <9 only
								// Defend against cloned attroperties (jQuery gh-1709)
								uniqueCache = outerCache[ node.uniqueID ] ||
									(outerCache[ node.uniqueID ] = {});
	
								cache = uniqueCache[ type ] || [];
								nodeIndex = cache[ 0 ] === dirruns && cache[ 1 ];
								diff = nodeIndex && cache[ 2 ];
								node = nodeIndex && parent.childNodes[ nodeIndex ];
	
								while ( (node = ++nodeIndex && node && node[ dir ] ||
	
									// Fallback to seeking `elem` from the start
									(diff = nodeIndex = 0) || start.pop()) ) {
	
									// When found, cache indexes on `parent` and break
									if ( node.nodeType === 1 && ++diff && node === elem ) {
										uniqueCache[ type ] = [ dirruns, nodeIndex, diff ];
										break;
									}
								}
	
							} else {
								// Use previously-cached element index if available
								if ( useCache ) {
									// ...in a gzip-friendly way
									node = elem;
									outerCache = node[ expando ] || (node[ expando ] = {});
	
									// Support: IE <9 only
									// Defend against cloned attroperties (jQuery gh-1709)
									uniqueCache = outerCache[ node.uniqueID ] ||
										(outerCache[ node.uniqueID ] = {});
	
									cache = uniqueCache[ type ] || [];
									nodeIndex = cache[ 0 ] === dirruns && cache[ 1 ];
									diff = nodeIndex;
								}
	
								// xml :nth-child(...)
								// or :nth-last-child(...) or :nth(-last)?-of-type(...)
								if ( diff === false ) {
									// Use the same loop as above to seek `elem` from the start
									while ( (node = ++nodeIndex && node && node[ dir ] ||
										(diff = nodeIndex = 0) || start.pop()) ) {
	
										if ( ( ofType ?
											node.nodeName.toLowerCase() === name :
											node.nodeType === 1 ) &&
											++diff ) {
	
											// Cache the index of each encountered element
											if ( useCache ) {
												outerCache = node[ expando ] || (node[ expando ] = {});
	
												// Support: IE <9 only
												// Defend against cloned attroperties (jQuery gh-1709)
												uniqueCache = outerCache[ node.uniqueID ] ||
													(outerCache[ node.uniqueID ] = {});
	
												uniqueCache[ type ] = [ dirruns, diff ];
											}
	
											if ( node === elem ) {
												break;
											}
										}
									}
								}
							}
	
							// Incorporate the offset, then check against cycle size
							diff -= last;
							return diff === first || ( diff % first === 0 && diff / first >= 0 );
						}
					};
			},
	
			"PSEUDO": function( pseudo, argument ) {
				// pseudo-class names are case-insensitive
				// http://www.w3.org/TR/selectors/#pseudo-classes
				// Prioritize by case sensitivity in case custom pseudos are added with uppercase letters
				// Remember that setFilters inherits from pseudos
				var args,
					fn = Expr.pseudos[ pseudo ] || Expr.setFilters[ pseudo.toLowerCase() ] ||
						Sizzle.error( "unsupported pseudo: " + pseudo );
	
				// The user may use createPseudo to indicate that
				// arguments are needed to create the filter function
				// just as Sizzle does
				if ( fn[ expando ] ) {
					return fn( argument );
				}
	
				// But maintain support for old signatures
				if ( fn.length > 1 ) {
					args = [ pseudo, pseudo, "", argument ];
					return Expr.setFilters.hasOwnProperty( pseudo.toLowerCase() ) ?
						markFunction(function( seed, matches ) {
							var idx,
								matched = fn( seed, argument ),
								i = matched.length;
							while ( i-- ) {
								idx = indexOf( seed, matched[i] );
								seed[ idx ] = !( matches[ idx ] = matched[i] );
							}
						}) :
						function( elem ) {
							return fn( elem, 0, args );
						};
				}
	
				return fn;
			}
		},
	
		pseudos: {
			// Potentially complex pseudos
			"not": markFunction(function( selector ) {
				// Trim the selector passed to compile
				// to avoid treating leading and trailing
				// spaces as combinators
				var input = [],
					results = [],
					matcher = compile( selector.replace( rtrim, "$1" ) );
	
				return matcher[ expando ] ?
					markFunction(function( seed, matches, context, xml ) {
						var elem,
							unmatched = matcher( seed, null, xml, [] ),
							i = seed.length;
	
						// Match elements unmatched by `matcher`
						while ( i-- ) {
							if ( (elem = unmatched[i]) ) {
								seed[i] = !(matches[i] = elem);
							}
						}
					}) :
					function( elem, context, xml ) {
						input[0] = elem;
						matcher( input, null, xml, results );
						// Don't keep the element (issue #299)
						input[0] = null;
						return !results.pop();
					};
			}),
	
			"has": markFunction(function( selector ) {
				return function( elem ) {
					return Sizzle( selector, elem ).length > 0;
				};
			}),
	
			"contains": markFunction(function( text ) {
				text = text.replace( runescape, funescape );
				return function( elem ) {
					return ( elem.textContent || elem.innerText || getText( elem ) ).indexOf( text ) > -1;
				};
			}),
	
			// "Whether an element is represented by a :lang() selector
			// is based solely on the element's language value
			// being equal to the identifier C,
			// or beginning with the identifier C immediately followed by "-".
			// The matching of C against the element's language value is performed case-insensitively.
			// The identifier C does not have to be a valid language name."
			// http://www.w3.org/TR/selectors/#lang-pseudo
			"lang": markFunction( function( lang ) {
				// lang value must be a valid identifier
				if ( !ridentifier.test(lang || "") ) {
					Sizzle.error( "unsupported lang: " + lang );
				}
				lang = lang.replace( runescape, funescape ).toLowerCase();
				return function( elem ) {
					var elemLang;
					do {
						if ( (elemLang = documentIsHTML ?
							elem.lang :
							elem.getAttribute("xml:lang") || elem.getAttribute("lang")) ) {
	
							elemLang = elemLang.toLowerCase();
							return elemLang === lang || elemLang.indexOf( lang + "-" ) === 0;
						}
					} while ( (elem = elem.parentNode) && elem.nodeType === 1 );
					return false;
				};
			}),
	
			// Miscellaneous
			"target": function( elem ) {
				var hash = window.location && window.location.hash;
				return hash && hash.slice( 1 ) === elem.id;
			},
	
			"root": function( elem ) {
				return elem === docElem;
			},
	
			"focus": function( elem ) {
				return elem === document.activeElement && (!document.hasFocus || document.hasFocus()) && !!(elem.type || elem.href || ~elem.tabIndex);
			},
	
			// Boolean properties
			"enabled": createDisabledPseudo( false ),
			"disabled": createDisabledPseudo( true ),
	
			"checked": function( elem ) {
				// In CSS3, :checked should return both checked and selected elements
				// http://www.w3.org/TR/2011/REC-css3-selectors-20110929/#checked
				var nodeName = elem.nodeName.toLowerCase();
				return (nodeName === "input" && !!elem.checked) || (nodeName === "option" && !!elem.selected);
			},
	
			"selected": function( elem ) {
				// Accessing this property makes selected-by-default
				// options in Safari work properly
				if ( elem.parentNode ) {
					elem.parentNode.selectedIndex;
				}
	
				return elem.selected === true;
			},
	
			// Contents
			"empty": function( elem ) {
				// http://www.w3.org/TR/selectors/#empty-pseudo
				// :empty is negated by element (1) or content nodes (text: 3; cdata: 4; entity ref: 5),
				//   but not by others (comment: 8; processing instruction: 7; etc.)
				// nodeType < 6 works because attributes (2) do not appear as children
				for ( elem = elem.firstChild; elem; elem = elem.nextSibling ) {
					if ( elem.nodeType < 6 ) {
						return false;
					}
				}
				return true;
			},
	
			"parent": function( elem ) {
				return !Expr.pseudos["empty"]( elem );
			},
	
			// Element/input types
			"header": function( elem ) {
				return rheader.test( elem.nodeName );
			},
	
			"input": function( elem ) {
				return rinputs.test( elem.nodeName );
			},
	
			"button": function( elem ) {
				var name = elem.nodeName.toLowerCase();
				return name === "input" && elem.type === "button" || name === "button";
			},
	
			"text": function( elem ) {
				var attr;
				return elem.nodeName.toLowerCase() === "input" &&
					elem.type === "text" &&
	
					// Support: IE<8
					// New HTML5 attribute values (e.g., "search") appear with elem.type === "text"
					( (attr = elem.getAttribute("type")) == null || attr.toLowerCase() === "text" );
			},
	
			// Position-in-collection
			"first": createPositionalPseudo(function() {
				return [ 0 ];
			}),
	
			"last": createPositionalPseudo(function( matchIndexes, length ) {
				return [ length - 1 ];
			}),
	
			"eq": createPositionalPseudo(function( matchIndexes, length, argument ) {
				return [ argument < 0 ? argument + length : argument ];
			}),
	
			"even": createPositionalPseudo(function( matchIndexes, length ) {
				var i = 0;
				for ( ; i < length; i += 2 ) {
					matchIndexes.push( i );
				}
				return matchIndexes;
			}),
	
			"odd": createPositionalPseudo(function( matchIndexes, length ) {
				var i = 1;
				for ( ; i < length; i += 2 ) {
					matchIndexes.push( i );
				}
				return matchIndexes;
			}),
	
			"lt": createPositionalPseudo(function( matchIndexes, length, argument ) {
				var i = argument < 0 ? argument + length : argument;
				for ( ; --i >= 0; ) {
					matchIndexes.push( i );
				}
				return matchIndexes;
			}),
	
			"gt": createPositionalPseudo(function( matchIndexes, length, argument ) {
				var i = argument < 0 ? argument + length : argument;
				for ( ; ++i < length; ) {
					matchIndexes.push( i );
				}
				return matchIndexes;
			})
		}
	};
	
	Expr.pseudos["nth"] = Expr.pseudos["eq"];
	
	// Add button/input type pseudos
	for ( i in { radio: true, checkbox: true, file: true, password: true, image: true } ) {
		Expr.pseudos[ i ] = createInputPseudo( i );
	}
	for ( i in { submit: true, reset: true } ) {
		Expr.pseudos[ i ] = createButtonPseudo( i );
	}
	
	// Easy API for creating new setFilters
	function setFilters() {}
	setFilters.prototype = Expr.filters = Expr.pseudos;
	Expr.setFilters = new setFilters();
	
	tokenize = Sizzle.tokenize = function( selector, parseOnly ) {
		var matched, match, tokens, type,
			soFar, groups, preFilters,
			cached = tokenCache[ selector + " " ];
	
		if ( cached ) {
			return parseOnly ? 0 : cached.slice( 0 );
		}
	
		soFar = selector;
		groups = [];
		preFilters = Expr.preFilter;
	
		while ( soFar ) {
	
			// Comma and first run
			if ( !matched || (match = rcomma.exec( soFar )) ) {
				if ( match ) {
					// Don't consume trailing commas as valid
					soFar = soFar.slice( match[0].length ) || soFar;
				}
				groups.push( (tokens = []) );
			}
	
			matched = false;
	
			// Combinators
			if ( (match = rcombinators.exec( soFar )) ) {
				matched = match.shift();
				tokens.push({
					value: matched,
					// Cast descendant combinators to space
					type: match[0].replace( rtrim, " " )
				});
				soFar = soFar.slice( matched.length );
			}
	
			// Filters
			for ( type in Expr.filter ) {
				if ( (match = matchExpr[ type ].exec( soFar )) && (!preFilters[ type ] ||
					(match = preFilters[ type ]( match ))) ) {
					matched = match.shift();
					tokens.push({
						value: matched,
						type: type,
						matches: match
					});
					soFar = soFar.slice( matched.length );
				}
			}
	
			if ( !matched ) {
				break;
			}
		}
	
		// Return the length of the invalid excess
		// if we're just parsing
		// Otherwise, throw an error or return tokens
		return parseOnly ?
			soFar.length :
			soFar ?
				Sizzle.error( selector ) :
				// Cache the tokens
				tokenCache( selector, groups ).slice( 0 );
	};
	
	function toSelector( tokens ) {
		var i = 0,
			len = tokens.length,
			selector = "";
		for ( ; i < len; i++ ) {
			selector += tokens[i].value;
		}
		return selector;
	}
	
	function addCombinator( matcher, combinator, base ) {
		var dir = combinator.dir,
			skip = combinator.next,
			key = skip || dir,
			checkNonElements = base && key === "parentNode",
			doneName = done++;
	
		return combinator.first ?
			// Check against closest ancestor/preceding element
			function( elem, context, xml ) {
				while ( (elem = elem[ dir ]) ) {
					if ( elem.nodeType === 1 || checkNonElements ) {
						return matcher( elem, context, xml );
					}
				}
				return false;
			} :
	
			// Check against all ancestor/preceding elements
			function( elem, context, xml ) {
				var oldCache, uniqueCache, outerCache,
					newCache = [ dirruns, doneName ];
	
				// We can't set arbitrary data on XML nodes, so they don't benefit from combinator caching
				if ( xml ) {
					while ( (elem = elem[ dir ]) ) {
						if ( elem.nodeType === 1 || checkNonElements ) {
							if ( matcher( elem, context, xml ) ) {
								return true;
							}
						}
					}
				} else {
					while ( (elem = elem[ dir ]) ) {
						if ( elem.nodeType === 1 || checkNonElements ) {
							outerCache = elem[ expando ] || (elem[ expando ] = {});
	
							// Support: IE <9 only
							// Defend against cloned attroperties (jQuery gh-1709)
							uniqueCache = outerCache[ elem.uniqueID ] || (outerCache[ elem.uniqueID ] = {});
	
							if ( skip && skip === elem.nodeName.toLowerCase() ) {
								elem = elem[ dir ] || elem;
							} else if ( (oldCache = uniqueCache[ key ]) &&
								oldCache[ 0 ] === dirruns && oldCache[ 1 ] === doneName ) {
	
								// Assign to newCache so results back-propagate to previous elements
								return (newCache[ 2 ] = oldCache[ 2 ]);
							} else {
								// Reuse newcache so results back-propagate to previous elements
								uniqueCache[ key ] = newCache;
	
								// A match means we're done; a fail means we have to keep checking
								if ( (newCache[ 2 ] = matcher( elem, context, xml )) ) {
									return true;
								}
							}
						}
					}
				}
				return false;
			};
	}
	
	function elementMatcher( matchers ) {
		return matchers.length > 1 ?
			function( elem, context, xml ) {
				var i = matchers.length;
				while ( i-- ) {
					if ( !matchers[i]( elem, context, xml ) ) {
						return false;
					}
				}
				return true;
			} :
			matchers[0];
	}
	
	function multipleContexts( selector, contexts, results ) {
		var i = 0,
			len = contexts.length;
		for ( ; i < len; i++ ) {
			Sizzle( selector, contexts[i], results );
		}
		return results;
	}
	
	function condense( unmatched, map, filter, context, xml ) {
		var elem,
			newUnmatched = [],
			i = 0,
			len = unmatched.length,
			mapped = map != null;
	
		for ( ; i < len; i++ ) {
			if ( (elem = unmatched[i]) ) {
				if ( !filter || filter( elem, context, xml ) ) {
					newUnmatched.push( elem );
					if ( mapped ) {
						map.push( i );
					}
				}
			}
		}
	
		return newUnmatched;
	}
	
	function setMatcher( preFilter, selector, matcher, postFilter, postFinder, postSelector ) {
		if ( postFilter && !postFilter[ expando ] ) {
			postFilter = setMatcher( postFilter );
		}
		if ( postFinder && !postFinder[ expando ] ) {
			postFinder = setMatcher( postFinder, postSelector );
		}
		return markFunction(function( seed, results, context, xml ) {
			var temp, i, elem,
				preMap = [],
				postMap = [],
				preexisting = results.length,
	
				// Get initial elements from seed or context
				elems = seed || multipleContexts( selector || "*", context.nodeType ? [ context ] : context, [] ),
	
				// Prefilter to get matcher input, preserving a map for seed-results synchronization
				matcherIn = preFilter && ( seed || !selector ) ?
					condense( elems, preMap, preFilter, context, xml ) :
					elems,
	
				matcherOut = matcher ?
					// If we have a postFinder, or filtered seed, or non-seed postFilter or preexisting results,
					postFinder || ( seed ? preFilter : preexisting || postFilter ) ?
	
						// ...intermediate processing is necessary
						[] :
	
						// ...otherwise use results directly
						results :
					matcherIn;
	
			// Find primary matches
			if ( matcher ) {
				matcher( matcherIn, matcherOut, context, xml );
			}
	
			// Apply postFilter
			if ( postFilter ) {
				temp = condense( matcherOut, postMap );
				postFilter( temp, [], context, xml );
	
				// Un-match failing elements by moving them back to matcherIn
				i = temp.length;
				while ( i-- ) {
					if ( (elem = temp[i]) ) {
						matcherOut[ postMap[i] ] = !(matcherIn[ postMap[i] ] = elem);
					}
				}
			}
	
			if ( seed ) {
				if ( postFinder || preFilter ) {
					if ( postFinder ) {
						// Get the final matcherOut by condensing this intermediate into postFinder contexts
						temp = [];
						i = matcherOut.length;
						while ( i-- ) {
							if ( (elem = matcherOut[i]) ) {
								// Restore matcherIn since elem is not yet a final match
								temp.push( (matcherIn[i] = elem) );
							}
						}
						postFinder( null, (matcherOut = []), temp, xml );
					}
	
					// Move matched elements from seed to results to keep them synchronized
					i = matcherOut.length;
					while ( i-- ) {
						if ( (elem = matcherOut[i]) &&
							(temp = postFinder ? indexOf( seed, elem ) : preMap[i]) > -1 ) {
	
							seed[temp] = !(results[temp] = elem);
						}
					}
				}
	
			// Add elements to results, through postFinder if defined
			} else {
				matcherOut = condense(
					matcherOut === results ?
						matcherOut.splice( preexisting, matcherOut.length ) :
						matcherOut
				);
				if ( postFinder ) {
					postFinder( null, results, matcherOut, xml );
				} else {
					push.apply( results, matcherOut );
				}
			}
		});
	}
	
	function matcherFromTokens( tokens ) {
		var checkContext, matcher, j,
			len = tokens.length,
			leadingRelative = Expr.relative[ tokens[0].type ],
			implicitRelative = leadingRelative || Expr.relative[" "],
			i = leadingRelative ? 1 : 0,
	
			// The foundational matcher ensures that elements are reachable from top-level context(s)
			matchContext = addCombinator( function( elem ) {
				return elem === checkContext;
			}, implicitRelative, true ),
			matchAnyContext = addCombinator( function( elem ) {
				return indexOf( checkContext, elem ) > -1;
			}, implicitRelative, true ),
			matchers = [ function( elem, context, xml ) {
				var ret = ( !leadingRelative && ( xml || context !== outermostContext ) ) || (
					(checkContext = context).nodeType ?
						matchContext( elem, context, xml ) :
						matchAnyContext( elem, context, xml ) );
				// Avoid hanging onto element (issue #299)
				checkContext = null;
				return ret;
			} ];
	
		for ( ; i < len; i++ ) {
			if ( (matcher = Expr.relative[ tokens[i].type ]) ) {
				matchers = [ addCombinator(elementMatcher( matchers ), matcher) ];
			} else {
				matcher = Expr.filter[ tokens[i].type ].apply( null, tokens[i].matches );
	
				// Return special upon seeing a positional matcher
				if ( matcher[ expando ] ) {
					// Find the next relative operator (if any) for proper handling
					j = ++i;
					for ( ; j < len; j++ ) {
						if ( Expr.relative[ tokens[j].type ] ) {
							break;
						}
					}
					return setMatcher(
						i > 1 && elementMatcher( matchers ),
						i > 1 && toSelector(
							// If the preceding token was a descendant combinator, insert an implicit any-element `*`
							tokens.slice( 0, i - 1 ).concat({ value: tokens[ i - 2 ].type === " " ? "*" : "" })
						).replace( rtrim, "$1" ),
						matcher,
						i < j && matcherFromTokens( tokens.slice( i, j ) ),
						j < len && matcherFromTokens( (tokens = tokens.slice( j )) ),
						j < len && toSelector( tokens )
					);
				}
				matchers.push( matcher );
			}
		}
	
		return elementMatcher( matchers );
	}
	
	function matcherFromGroupMatchers( elementMatchers, setMatchers ) {
		var bySet = setMatchers.length > 0,
			byElement = elementMatchers.length > 0,
			superMatcher = function( seed, context, xml, results, outermost ) {
				var elem, j, matcher,
					matchedCount = 0,
					i = "0",
					unmatched = seed && [],
					setMatched = [],
					contextBackup = outermostContext,
					// We must always have either seed elements or outermost context
					elems = seed || byElement && Expr.find["TAG"]( "*", outermost ),
					// Use integer dirruns iff this is the outermost matcher
					dirrunsUnique = (dirruns += contextBackup == null ? 1 : Math.random() || 0.1),
					len = elems.length;
	
				if ( outermost ) {
					outermostContext = context === document || context || outermost;
				}
	
				// Add elements passing elementMatchers directly to results
				// Support: IE<9, Safari
				// Tolerate NodeList properties (IE: "length"; Safari: <number>) matching elements by id
				for ( ; i !== len && (elem = elems[i]) != null; i++ ) {
					if ( byElement && elem ) {
						j = 0;
						if ( !context && elem.ownerDocument !== document ) {
							setDocument( elem );
							xml = !documentIsHTML;
						}
						while ( (matcher = elementMatchers[j++]) ) {
							if ( matcher( elem, context || document, xml) ) {
								results.push( elem );
								break;
							}
						}
						if ( outermost ) {
							dirruns = dirrunsUnique;
						}
					}
	
					// Track unmatched elements for set filters
					if ( bySet ) {
						// They will have gone through all possible matchers
						if ( (elem = !matcher && elem) ) {
							matchedCount--;
						}
	
						// Lengthen the array for every element, matched or not
						if ( seed ) {
							unmatched.push( elem );
						}
					}
				}
	
				// `i` is now the count of elements visited above, and adding it to `matchedCount`
				// makes the latter nonnegative.
				matchedCount += i;
	
				// Apply set filters to unmatched elements
				// NOTE: This can be skipped if there are no unmatched elements (i.e., `matchedCount`
				// equals `i`), unless we didn't visit _any_ elements in the above loop because we have
				// no element matchers and no seed.
				// Incrementing an initially-string "0" `i` allows `i` to remain a string only in that
				// case, which will result in a "00" `matchedCount` that differs from `i` but is also
				// numerically zero.
				if ( bySet && i !== matchedCount ) {
					j = 0;
					while ( (matcher = setMatchers[j++]) ) {
						matcher( unmatched, setMatched, context, xml );
					}
	
					if ( seed ) {
						// Reintegrate element matches to eliminate the need for sorting
						if ( matchedCount > 0 ) {
							while ( i-- ) {
								if ( !(unmatched[i] || setMatched[i]) ) {
									setMatched[i] = pop.call( results );
								}
							}
						}
	
						// Discard index placeholder values to get only actual matches
						setMatched = condense( setMatched );
					}
	
					// Add matches to results
					push.apply( results, setMatched );
	
					// Seedless set matches succeeding multiple successful matchers stipulate sorting
					if ( outermost && !seed && setMatched.length > 0 &&
						( matchedCount + setMatchers.length ) > 1 ) {
	
						Sizzle.uniqueSort( results );
					}
				}
	
				// Override manipulation of globals by nested matchers
				if ( outermost ) {
					dirruns = dirrunsUnique;
					outermostContext = contextBackup;
				}
	
				return unmatched;
			};
	
		return bySet ?
			markFunction( superMatcher ) :
			superMatcher;
	}
	
	compile = Sizzle.compile = function( selector, match /* Internal Use Only */ ) {
		var i,
			setMatchers = [],
			elementMatchers = [],
			cached = compilerCache[ selector + " " ];
	
		if ( !cached ) {
			// Generate a function of recursive functions that can be used to check each element
			if ( !match ) {
				match = tokenize( selector );
			}
			i = match.length;
			while ( i-- ) {
				cached = matcherFromTokens( match[i] );
				if ( cached[ expando ] ) {
					setMatchers.push( cached );
				} else {
					elementMatchers.push( cached );
				}
			}
	
			// Cache the compiled function
			cached = compilerCache( selector, matcherFromGroupMatchers( elementMatchers, setMatchers ) );
	
			// Save selector and tokenization
			cached.selector = selector;
		}
		return cached;
	};
	
	/**
	 * A low-level selection function that works with Sizzle's compiled
	 *  selector functions
	 * @param {String|Function} selector A selector or a pre-compiled
	 *  selector function built with Sizzle.compile
	 * @param {Element} context
	 * @param {Array} [results]
	 * @param {Array} [seed] A set of elements to match against
	 */
	select = Sizzle.select = function( selector, context, results, seed ) {
		var i, tokens, token, type, find,
			compiled = typeof selector === "function" && selector,
			match = !seed && tokenize( (selector = compiled.selector || selector) );
	
		results = results || [];
	
		// Try to minimize operations if there is only one selector in the list and no seed
		// (the latter of which guarantees us context)
		if ( match.length === 1 ) {
	
			// Reduce context if the leading compound selector is an ID
			tokens = match[0] = match[0].slice( 0 );
			if ( tokens.length > 2 && (token = tokens[0]).type === "ID" &&
					context.nodeType === 9 && documentIsHTML && Expr.relative[ tokens[1].type ] ) {
	
				context = ( Expr.find["ID"]( token.matches[0].replace(runescape, funescape), context ) || [] )[0];
				if ( !context ) {
					return results;
	
				// Precompiled matchers will still verify ancestry, so step up a level
				} else if ( compiled ) {
					context = context.parentNode;
				}
	
				selector = selector.slice( tokens.shift().value.length );
			}
	
			// Fetch a seed set for right-to-left matching
			i = matchExpr["needsContext"].test( selector ) ? 0 : tokens.length;
			while ( i-- ) {
				token = tokens[i];
	
				// Abort if we hit a combinator
				if ( Expr.relative[ (type = token.type) ] ) {
					break;
				}
				if ( (find = Expr.find[ type ]) ) {
					// Search, expanding context for leading sibling combinators
					if ( (seed = find(
						token.matches[0].replace( runescape, funescape ),
						rsibling.test( tokens[0].type ) && testContext( context.parentNode ) || context
					)) ) {
	
						// If seed is empty or no tokens remain, we can return early
						tokens.splice( i, 1 );
						selector = seed.length && toSelector( tokens );
						if ( !selector ) {
							push.apply( results, seed );
							return results;
						}
	
						break;
					}
				}
			}
		}
	
		// Compile and execute a filtering function if one is not provided
		// Provide `match` to avoid retokenization if we modified the selector above
		( compiled || compile( selector, match ) )(
			seed,
			context,
			!documentIsHTML,
			results,
			!context || rsibling.test( selector ) && testContext( context.parentNode ) || context
		);
		return results;
	};
	
	// One-time assignments
	
	// Sort stability
	support.sortStable = expando.split("").sort( sortOrder ).join("") === expando;
	
	// Support: Chrome 14-35+
	// Always assume duplicates if they aren't passed to the comparison function
	support.detectDuplicates = !!hasDuplicate;
	
	// Initialize against the default document
	setDocument();
	
	// Support: Webkit<537.32 - Safari 6.0.3/Chrome 25 (fixed in Chrome 27)
	// Detached nodes confoundingly follow *each other*
	support.sortDetached = assert(function( el ) {
		// Should return 1, but returns 4 (following)
		return el.compareDocumentPosition( document.createElement("fieldset") ) & 1;
	});
	
	// Support: IE<8
	// Prevent attribute/property "interpolation"
	// https://msdn.microsoft.com/en-us/library/ms536429%28VS.85%29.aspx
	if ( !assert(function( el ) {
		el.innerHTML = "<a href='#'></a>";
		return el.firstChild.getAttribute("href") === "#" ;
	}) ) {
		addHandle( "type|href|height|width", function( elem, name, isXML ) {
			if ( !isXML ) {
				return elem.getAttribute( name, name.toLowerCase() === "type" ? 1 : 2 );
			}
		});
	}
	
	// Support: IE<9
	// Use defaultValue in place of getAttribute("value")
	if ( !support.attributes || !assert(function( el ) {
		el.innerHTML = "<input/>";
		el.firstChild.setAttribute( "value", "" );
		return el.firstChild.getAttribute( "value" ) === "";
	}) ) {
		addHandle( "value", function( elem, name, isXML ) {
			if ( !isXML && elem.nodeName.toLowerCase() === "input" ) {
				return elem.defaultValue;
			}
		});
	}
	
	// Support: IE<9
	// Use getAttributeNode to fetch booleans when getAttribute lies
	if ( !assert(function( el ) {
		return el.getAttribute("disabled") == null;
	}) ) {
		addHandle( booleans, function( elem, name, isXML ) {
			var val;
			if ( !isXML ) {
				return elem[ name ] === true ? name.toLowerCase() :
						(val = elem.getAttributeNode( name )) && val.specified ?
						val.value :
					null;
			}
		});
	}
	
	return Sizzle;
	
	})( window );
	
	
	
	jQuery.find = Sizzle;
	jQuery.expr = Sizzle.selectors;
	
	// Deprecated
	jQuery.expr[ ":" ] = jQuery.expr.pseudos;
	jQuery.uniqueSort = jQuery.unique = Sizzle.uniqueSort;
	jQuery.text = Sizzle.getText;
	jQuery.isXMLDoc = Sizzle.isXML;
	jQuery.contains = Sizzle.contains;
	jQuery.escapeSelector = Sizzle.escape;
	
	
	
	
	var dir = function( elem, dir, until ) {
		var matched = [],
			truncate = until !== undefined;
	
		while ( ( elem = elem[ dir ] ) && elem.nodeType !== 9 ) {
			if ( elem.nodeType === 1 ) {
				if ( truncate && jQuery( elem ).is( until ) ) {
					break;
				}
				matched.push( elem );
			}
		}
		return matched;
	};
	
	
	var siblings = function( n, elem ) {
		var matched = [];
	
		for ( ; n; n = n.nextSibling ) {
			if ( n.nodeType === 1 && n !== elem ) {
				matched.push( n );
			}
		}
	
		return matched;
	};
	
	
	var rneedsContext = jQuery.expr.match.needsContext;
	
	
	
	function nodeName( elem, name ) {
	
	  return elem.nodeName && elem.nodeName.toLowerCase() === name.toLowerCase();
	
	};
	var rsingleTag = ( /^<([a-z][^\/\0>:\x20\t\r\n\f]*)[\x20\t\r\n\f]*\/?>(?:<\/\1>|)$/i );
	
	
	
	// Implement the identical functionality for filter and not
	function winnow( elements, qualifier, not ) {
		if ( isFunction( qualifier ) ) {
			return jQuery.grep( elements, function( elem, i ) {
				return !!qualifier.call( elem, i, elem ) !== not;
			} );
		}
	
		// Single element
		if ( qualifier.nodeType ) {
			return jQuery.grep( elements, function( elem ) {
				return ( elem === qualifier ) !== not;
			} );
		}
	
		// Arraylike of elements (jQuery, arguments, Array)
		if ( typeof qualifier !== "string" ) {
			return jQuery.grep( elements, function( elem ) {
				return ( indexOf.call( qualifier, elem ) > -1 ) !== not;
			} );
		}
	
		// Filtered directly for both simple and complex selectors
		return jQuery.filter( qualifier, elements, not );
	}
	
	jQuery.filter = function( expr, elems, not ) {
		var elem = elems[ 0 ];
	
		if ( not ) {
			expr = ":not(" + expr + ")";
		}
	
		if ( elems.length === 1 && elem.nodeType === 1 ) {
			return jQuery.find.matchesSelector( elem, expr ) ? [ elem ] : [];
		}
	
		return jQuery.find.matches( expr, jQuery.grep( elems, function( elem ) {
			return elem.nodeType === 1;
		} ) );
	};
	
	jQuery.fn.extend( {
		find: function( selector ) {
			var i, ret,
				len = this.length,
				self = this;
	
			if ( typeof selector !== "string" ) {
				return this.pushStack( jQuery( selector ).filter( function() {
					for ( i = 0; i < len; i++ ) {
						if ( jQuery.contains( self[ i ], this ) ) {
							return true;
						}
					}
				} ) );
			}
	
			ret = this.pushStack( [] );
	
			for ( i = 0; i < len; i++ ) {
				jQuery.find( selector, self[ i ], ret );
			}
	
			return len > 1 ? jQuery.uniqueSort( ret ) : ret;
		},
		filter: function( selector ) {
			return this.pushStack( winnow( this, selector || [], false ) );
		},
		not: function( selector ) {
			return this.pushStack( winnow( this, selector || [], true ) );
		},
		is: function( selector ) {
			return !!winnow(
				this,
	
				// If this is a positional/relative selector, check membership in the returned set
				// so $("p:first").is("p:last") won't return true for a doc with two "p".
				typeof selector === "string" && rneedsContext.test( selector ) ?
					jQuery( selector ) :
					selector || [],
				false
			).length;
		}
	} );
	
	
	// Initialize a jQuery object
	
	
	// A central reference to the root jQuery(document)
	var rootjQuery,
	
		// A simple way to check for HTML strings
		// Prioritize #id over <tag> to avoid XSS via location.hash (#9521)
		// Strict HTML recognition (#11290: must start with <)
		// Shortcut simple #id case for speed
		rquickExpr = /^(?:\s*(<[\w\W]+>)[^>]*|#([\w-]+))$/,
	
		init = jQuery.fn.init = function( selector, context, root ) {
			var match, elem;
	
			// HANDLE: $(""), $(null), $(undefined), $(false)
			if ( !selector ) {
				return this;
			}
	
			// Method init() accepts an alternate rootjQuery
			// so migrate can support jQuery.sub (gh-2101)
			root = root || rootjQuery;
	
			// Handle HTML strings
			if ( typeof selector === "string" ) {
				if ( selector[ 0 ] === "<" &&
					selector[ selector.length - 1 ] === ">" &&
					selector.length >= 3 ) {
	
					// Assume that strings that start and end with <> are HTML and skip the regex check
					match = [ null, selector, null ];
	
				} else {
					match = rquickExpr.exec( selector );
				}
	
				// Match html or make sure no context is specified for #id
				if ( match && ( match[ 1 ] || !context ) ) {
	
					// HANDLE: $(html) -> $(array)
					if ( match[ 1 ] ) {
						context = context instanceof jQuery ? context[ 0 ] : context;
	
						// Option to run scripts is true for back-compat
						// Intentionally let the error be thrown if parseHTML is not present
						jQuery.merge( this, jQuery.parseHTML(
							match[ 1 ],
							context && context.nodeType ? context.ownerDocument || context : document,
							true
						) );
	
						// HANDLE: $(html, props)
						if ( rsingleTag.test( match[ 1 ] ) && jQuery.isPlainObject( context ) ) {
							for ( match in context ) {
	
								// Properties of context are called as methods if possible
								if ( isFunction( this[ match ] ) ) {
									this[ match ]( context[ match ] );
	
								// ...and otherwise set as attributes
								} else {
									this.attr( match, context[ match ] );
								}
							}
						}
	
						return this;
	
					// HANDLE: $(#id)
					} else {
						elem = document.getElementById( match[ 2 ] );
	
						if ( elem ) {
	
							// Inject the element directly into the jQuery object
							this[ 0 ] = elem;
							this.length = 1;
						}
						return this;
					}
	
				// HANDLE: $(expr, $(...))
				} else if ( !context || context.jquery ) {
					return ( context || root ).find( selector );
	
				// HANDLE: $(expr, context)
				// (which is just equivalent to: $(context).find(expr)
				} else {
					return this.constructor( context ).find( selector );
				}
	
			// HANDLE: $(DOMElement)
			} else if ( selector.nodeType ) {
				this[ 0 ] = selector;
				this.length = 1;
				return this;
	
			// HANDLE: $(function)
			// Shortcut for document ready
			} else if ( isFunction( selector ) ) {
				return root.ready !== undefined ?
					root.ready( selector ) :
	
					// Execute immediately if ready is not present
					selector( jQuery );
			}
	
			return jQuery.makeArray( selector, this );
		};
	
	// Give the init function the jQuery prototype for later instantiation
	init.prototype = jQuery.fn;
	
	// Initialize central reference
	rootjQuery = jQuery( document );
	
	
	var rparentsprev = /^(?:parents|prev(?:Until|All))/,
	
		// Methods guaranteed to produce a unique set when starting from a unique set
		guaranteedUnique = {
			children: true,
			contents: true,
			next: true,
			prev: true
		};
	
	jQuery.fn.extend( {
		has: function( target ) {
			var targets = jQuery( target, this ),
				l = targets.length;
	
			return this.filter( function() {
				var i = 0;
				for ( ; i < l; i++ ) {
					if ( jQuery.contains( this, targets[ i ] ) ) {
						return true;
					}
				}
			} );
		},
	
		closest: function( selectors, context ) {
			var cur,
				i = 0,
				l = this.length,
				matched = [],
				targets = typeof selectors !== "string" && jQuery( selectors );
	
			// Positional selectors never match, since there's no _selection_ context
			if ( !rneedsContext.test( selectors ) ) {
				for ( ; i < l; i++ ) {
					for ( cur = this[ i ]; cur && cur !== context; cur = cur.parentNode ) {
	
						// Always skip document fragments
						if ( cur.nodeType < 11 && ( targets ?
							targets.index( cur ) > -1 :
	
							// Don't pass non-elements to Sizzle
							cur.nodeType === 1 &&
								jQuery.find.matchesSelector( cur, selectors ) ) ) {
	
							matched.push( cur );
							break;
						}
					}
				}
			}
	
			return this.pushStack( matched.length > 1 ? jQuery.uniqueSort( matched ) : matched );
		},
	
		// Determine the position of an element within the set
		index: function( elem ) {
	
			// No argument, return index in parent
			if ( !elem ) {
				return ( this[ 0 ] && this[ 0 ].parentNode ) ? this.first().prevAll().length : -1;
			}
	
			// Index in selector
			if ( typeof elem === "string" ) {
				return indexOf.call( jQuery( elem ), this[ 0 ] );
			}
	
			// Locate the position of the desired element
			return indexOf.call( this,
	
				// If it receives a jQuery object, the first element is used
				elem.jquery ? elem[ 0 ] : elem
			);
		},
	
		add: function( selector, context ) {
			return this.pushStack(
				jQuery.uniqueSort(
					jQuery.merge( this.get(), jQuery( selector, context ) )
				)
			);
		},
	
		addBack: function( selector ) {
			return this.add( selector == null ?
				this.prevObject : this.prevObject.filter( selector )
			);
		}
	} );
	
	function sibling( cur, dir ) {
		while ( ( cur = cur[ dir ] ) && cur.nodeType !== 1 ) {}
		return cur;
	}
	
	jQuery.each( {
		parent: function( elem ) {
			var parent = elem.parentNode;
			return parent && parent.nodeType !== 11 ? parent : null;
		},
		parents: function( elem ) {
			return dir( elem, "parentNode" );
		},
		parentsUntil: function( elem, i, until ) {
			return dir( elem, "parentNode", until );
		},
		next: function( elem ) {
			return sibling( elem, "nextSibling" );
		},
		prev: function( elem ) {
			return sibling( elem, "previousSibling" );
		},
		nextAll: function( elem ) {
			return dir( elem, "nextSibling" );
		},
		prevAll: function( elem ) {
			return dir( elem, "previousSibling" );
		},
		nextUntil: function( elem, i, until ) {
			return dir( elem, "nextSibling", until );
		},
		prevUntil: function( elem, i, until ) {
			return dir( elem, "previousSibling", until );
		},
		siblings: function( elem ) {
			return siblings( ( elem.parentNode || {} ).firstChild, elem );
		},
		children: function( elem ) {
			return siblings( elem.firstChild );
		},
		contents: function( elem ) {
	        if ( nodeName( elem, "iframe" ) ) {
	            return elem.contentDocument;
	        }
	
	        // Support: IE 9 - 11 only, iOS 7 only, Android Browser <=4.3 only
	        // Treat the template element as a regular one in browsers that
	        // don't support it.
	        if ( nodeName( elem, "template" ) ) {
	            elem = elem.content || elem;
	        }
	
	        return jQuery.merge( [], elem.childNodes );
		}
	}, function( name, fn ) {
		jQuery.fn[ name ] = function( until, selector ) {
			var matched = jQuery.map( this, fn, until );
	
			if ( name.slice( -5 ) !== "Until" ) {
				selector = until;
			}
	
			if ( selector && typeof selector === "string" ) {
				matched = jQuery.filter( selector, matched );
			}
	
			if ( this.length > 1 ) {
	
				// Remove duplicates
				if ( !guaranteedUnique[ name ] ) {
					jQuery.uniqueSort( matched );
				}
	
				// Reverse order for parents* and prev-derivatives
				if ( rparentsprev.test( name ) ) {
					matched.reverse();
				}
			}
	
			return this.pushStack( matched );
		};
	} );
	var rnothtmlwhite = ( /[^\x20\t\r\n\f]+/g );
	
	
	
	// Convert String-formatted options into Object-formatted ones
	function createOptions( options ) {
		var object = {};
		jQuery.each( options.match( rnothtmlwhite ) || [], function( _, flag ) {
			object[ flag ] = true;
		} );
		return object;
	}
	
	/*
	 * Create a callback list using the following parameters:
	 *
	 *	options: an optional list of space-separated options that will change how
	 *			the callback list behaves or a more traditional option object
	 *
	 * By default a callback list will act like an event callback list and can be
	 * "fired" multiple times.
	 *
	 * Possible options:
	 *
	 *	once:			will ensure the callback list can only be fired once (like a Deferred)
	 *
	 *	memory:			will keep track of previous values and will call any callback added
	 *					after the list has been fired right away with the latest "memorized"
	 *					values (like a Deferred)
	 *
	 *	unique:			will ensure a callback can only be added once (no duplicate in the list)
	 *
	 *	stopOnFalse:	interrupt callings when a callback returns false
	 *
	 */
	jQuery.Callbacks = function( options ) {
	
		// Convert options from String-formatted to Object-formatted if needed
		// (we check in cache first)
		options = typeof options === "string" ?
			createOptions( options ) :
			jQuery.extend( {}, options );
	
		var // Flag to know if list is currently firing
			firing,
	
			// Last fire value for non-forgettable lists
			memory,
	
			// Flag to know if list was already fired
			fired,
	
			// Flag to prevent firing
			locked,
	
			// Actual callback list
			list = [],
	
			// Queue of execution data for repeatable lists
			queue = [],
	
			// Index of currently firing callback (modified by add/remove as needed)
			firingIndex = -1,
	
			// Fire callbacks
			fire = function() {
	
				// Enforce single-firing
				locked = locked || options.once;
	
				// Execute callbacks for all pending executions,
				// respecting firingIndex overrides and runtime changes
				fired = firing = true;
				for ( ; queue.length; firingIndex = -1 ) {
					memory = queue.shift();
					while ( ++firingIndex < list.length ) {
	
						// Run callback and check for early termination
						if ( list[ firingIndex ].apply( memory[ 0 ], memory[ 1 ] ) === false &&
							options.stopOnFalse ) {
	
							// Jump to end and forget the data so .add doesn't re-fire
							firingIndex = list.length;
							memory = false;
						}
					}
				}
	
				// Forget the data if we're done with it
				if ( !options.memory ) {
					memory = false;
				}
	
				firing = false;
	
				// Clean up if we're done firing for good
				if ( locked ) {
	
					// Keep an empty list if we have data for future add calls
					if ( memory ) {
						list = [];
	
					// Otherwise, this object is spent
					} else {
						list = "";
					}
				}
			},
	
			// Actual Callbacks object
			self = {
	
				// Add a callback or a collection of callbacks to the list
				add: function() {
					if ( list ) {
	
						// If we have memory from a past run, we should fire after adding
						if ( memory && !firing ) {
							firingIndex = list.length - 1;
							queue.push( memory );
						}
	
						( function add( args ) {
							jQuery.each( args, function( _, arg ) {
								if ( isFunction( arg ) ) {
									if ( !options.unique || !self.has( arg ) ) {
										list.push( arg );
									}
								} else if ( arg && arg.length && toType( arg ) !== "string" ) {
	
									// Inspect recursively
									add( arg );
								}
							} );
						} )( arguments );
	
						if ( memory && !firing ) {
							fire();
						}
					}
					return this;
				},
	
				// Remove a callback from the list
				remove: function() {
					jQuery.each( arguments, function( _, arg ) {
						var index;
						while ( ( index = jQuery.inArray( arg, list, index ) ) > -1 ) {
							list.splice( index, 1 );
	
							// Handle firing indexes
							if ( index <= firingIndex ) {
								firingIndex--;
							}
						}
					} );
					return this;
				},
	
				// Check if a given callback is in the list.
				// If no argument is given, return whether or not list has callbacks attached.
				has: function( fn ) {
					return fn ?
						jQuery.inArray( fn, list ) > -1 :
						list.length > 0;
				},
	
				// Remove all callbacks from the list
				empty: function() {
					if ( list ) {
						list = [];
					}
					return this;
				},
	
				// Disable .fire and .add
				// Abort any current/pending executions
				// Clear all callbacks and values
				disable: function() {
					locked = queue = [];
					list = memory = "";
					return this;
				},
				disabled: function() {
					return !list;
				},
	
				// Disable .fire
				// Also disable .add unless we have memory (since it would have no effect)
				// Abort any pending executions
				lock: function() {
					locked = queue = [];
					if ( !memory && !firing ) {
						list = memory = "";
					}
					return this;
				},
				locked: function() {
					return !!locked;
				},
	
				// Call all callbacks with the given context and arguments
				fireWith: function( context, args ) {
					if ( !locked ) {
						args = args || [];
						args = [ context, args.slice ? args.slice() : args ];
						queue.push( args );
						if ( !firing ) {
							fire();
						}
					}
					return this;
				},
	
				// Call all the callbacks with the given arguments
				fire: function() {
					self.fireWith( this, arguments );
					return this;
				},
	
				// To know if the callbacks have already been called at least once
				fired: function() {
					return !!fired;
				}
			};
	
		return self;
	};
	
	
	function Identity( v ) {
		return v;
	}
	function Thrower( ex ) {
		throw ex;
	}
	
	function adoptValue( value, resolve, reject, noValue ) {
		var method;
	
		try {
	
			// Check for promise aspect first to privilege synchronous behavior
			if ( value && isFunction( ( method = value.promise ) ) ) {
				method.call( value ).done( resolve ).fail( reject );
	
			// Other thenables
			} else if ( value && isFunction( ( method = value.then ) ) ) {
				method.call( value, resolve, reject );
	
			// Other non-thenables
			} else {
	
				// Control `resolve` arguments by letting Array#slice cast boolean `noValue` to integer:
				// * false: [ value ].slice( 0 ) => resolve( value )
				// * true: [ value ].slice( 1 ) => resolve()
				resolve.apply( undefined, [ value ].slice( noValue ) );
			}
	
		// For Promises/A+, convert exceptions into rejections
		// Since jQuery.when doesn't unwrap thenables, we can skip the extra checks appearing in
		// Deferred#then to conditionally suppress rejection.
		} catch ( value ) {
	
			// Support: Android 4.0 only
			// Strict mode functions invoked without .call/.apply get global-object context
			reject.apply( undefined, [ value ] );
		}
	}
	
	jQuery.extend( {
	
		Deferred: function( func ) {
			var tuples = [
	
					// action, add listener, callbacks,
					// ... .then handlers, argument index, [final state]
					[ "notify", "progress", jQuery.Callbacks( "memory" ),
						jQuery.Callbacks( "memory" ), 2 ],
					[ "resolve", "done", jQuery.Callbacks( "once memory" ),
						jQuery.Callbacks( "once memory" ), 0, "resolved" ],
					[ "reject", "fail", jQuery.Callbacks( "once memory" ),
						jQuery.Callbacks( "once memory" ), 1, "rejected" ]
				],
				state = "pending",
				promise = {
					state: function() {
						return state;
					},
					always: function() {
						deferred.done( arguments ).fail( arguments );
						return this;
					},
					"catch": function( fn ) {
						return promise.then( null, fn );
					},
	
					// Keep pipe for back-compat
					pipe: function( /* fnDone, fnFail, fnProgress */ ) {
						var fns = arguments;
	
						return jQuery.Deferred( function( newDefer ) {
							jQuery.each( tuples, function( i, tuple ) {
	
								// Map tuples (progress, done, fail) to arguments (done, fail, progress)
								var fn = isFunction( fns[ tuple[ 4 ] ] ) && fns[ tuple[ 4 ] ];
	
								// deferred.progress(function() { bind to newDefer or newDefer.notify })
								// deferred.done(function() { bind to newDefer or newDefer.resolve })
								// deferred.fail(function() { bind to newDefer or newDefer.reject })
								deferred[ tuple[ 1 ] ]( function() {
									var returned = fn && fn.apply( this, arguments );
									if ( returned && isFunction( returned.promise ) ) {
										returned.promise()
											.progress( newDefer.notify )
											.done( newDefer.resolve )
											.fail( newDefer.reject );
									} else {
										newDefer[ tuple[ 0 ] + "With" ](
											this,
											fn ? [ returned ] : arguments
										);
									}
								} );
							} );
							fns = null;
						} ).promise();
					},
					then: function( onFulfilled, onRejected, onProgress ) {
						var maxDepth = 0;
						function resolve( depth, deferred, handler, special ) {
							return function() {
								var that = this,
									args = arguments,
									mightThrow = function() {
										var returned, then;
	
										// Support: Promises/A+ section 2.3.3.3.3
										// https://promisesaplus.com/#point-59
										// Ignore double-resolution attempts
										if ( depth < maxDepth ) {
											return;
										}
	
										returned = handler.apply( that, args );
	
										// Support: Promises/A+ section 2.3.1
										// https://promisesaplus.com/#point-48
										if ( returned === deferred.promise() ) {
											throw new TypeError( "Thenable self-resolution" );
										}
	
										// Support: Promises/A+ sections 2.3.3.1, 3.5
										// https://promisesaplus.com/#point-54
										// https://promisesaplus.com/#point-75
										// Retrieve `then` only once
										then = returned &&
	
											// Support: Promises/A+ section 2.3.4
											// https://promisesaplus.com/#point-64
											// Only check objects and functions for thenability
											( typeof returned === "object" ||
												typeof returned === "function" ) &&
											returned.then;
	
										// Handle a returned thenable
										if ( isFunction( then ) ) {
	
											// Special processors (notify) just wait for resolution
											if ( special ) {
												then.call(
													returned,
													resolve( maxDepth, deferred, Identity, special ),
													resolve( maxDepth, deferred, Thrower, special )
												);
	
											// Normal processors (resolve) also hook into progress
											} else {
	
												// ...and disregard older resolution values
												maxDepth++;
	
												then.call(
													returned,
													resolve( maxDepth, deferred, Identity, special ),
													resolve( maxDepth, deferred, Thrower, special ),
													resolve( maxDepth, deferred, Identity,
														deferred.notifyWith )
												);
											}
	
										// Handle all other returned values
										} else {
	
											// Only substitute handlers pass on context
											// and multiple values (non-spec behavior)
											if ( handler !== Identity ) {
												that = undefined;
												args = [ returned ];
											}
	
											// Process the value(s)
											// Default process is resolve
											( special || deferred.resolveWith )( that, args );
										}
									},
	
									// Only normal processors (resolve) catch and reject exceptions
									process = special ?
										mightThrow :
										function() {
											try {
												mightThrow();
											} catch ( e ) {
	
												if ( jQuery.Deferred.exceptionHook ) {
													jQuery.Deferred.exceptionHook( e,
														process.stackTrace );
												}
	
												// Support: Promises/A+ section 2.3.3.3.4.1
												// https://promisesaplus.com/#point-61
												// Ignore post-resolution exceptions
												if ( depth + 1 >= maxDepth ) {
	
													// Only substitute handlers pass on context
													// and multiple values (non-spec behavior)
													if ( handler !== Thrower ) {
														that = undefined;
														args = [ e ];
													}
	
													deferred.rejectWith( that, args );
												}
											}
										};
	
								// Support: Promises/A+ section 2.3.3.3.1
								// https://promisesaplus.com/#point-57
								// Re-resolve promises immediately to dodge false rejection from
								// subsequent errors
								if ( depth ) {
									process();
								} else {
	
									// Call an optional hook to record the stack, in case of exception
									// since it's otherwise lost when execution goes async
									if ( jQuery.Deferred.getStackHook ) {
										process.stackTrace = jQuery.Deferred.getStackHook();
									}
									window.setTimeout( process );
								}
							};
						}
	
						return jQuery.Deferred( function( newDefer ) {
	
							// progress_handlers.add( ... )
							tuples[ 0 ][ 3 ].add(
								resolve(
									0,
									newDefer,
									isFunction( onProgress ) ?
										onProgress :
										Identity,
									newDefer.notifyWith
								)
							);
	
							// fulfilled_handlers.add( ... )
							tuples[ 1 ][ 3 ].add(
								resolve(
									0,
									newDefer,
									isFunction( onFulfilled ) ?
										onFulfilled :
										Identity
								)
							);
	
							// rejected_handlers.add( ... )
							tuples[ 2 ][ 3 ].add(
								resolve(
									0,
									newDefer,
									isFunction( onRejected ) ?
										onRejected :
										Thrower
								)
							);
						} ).promise();
					},
	
					// Get a promise for this deferred
					// If obj is provided, the promise aspect is added to the object
					promise: function( obj ) {
						return obj != null ? jQuery.extend( obj, promise ) : promise;
					}
				},
				deferred = {};
	
			// Add list-specific methods
			jQuery.each( tuples, function( i, tuple ) {
				var list = tuple[ 2 ],
					stateString = tuple[ 5 ];
	
				// promise.progress = list.add
				// promise.done = list.add
				// promise.fail = list.add
				promise[ tuple[ 1 ] ] = list.add;
	
				// Handle state
				if ( stateString ) {
					list.add(
						function() {
	
							// state = "resolved" (i.e., fulfilled)
							// state = "rejected"
							state = stateString;
						},
	
						// rejected_callbacks.disable
						// fulfilled_callbacks.disable
						tuples[ 3 - i ][ 2 ].disable,
	
						// rejected_handlers.disable
						// fulfilled_handlers.disable
						tuples[ 3 - i ][ 3 ].disable,
	
						// progress_callbacks.lock
						tuples[ 0 ][ 2 ].lock,
	
						// progress_handlers.lock
						tuples[ 0 ][ 3 ].lock
					);
				}
	
				// progress_handlers.fire
				// fulfilled_handlers.fire
				// rejected_handlers.fire
				list.add( tuple[ 3 ].fire );
	
				// deferred.notify = function() { deferred.notifyWith(...) }
				// deferred.resolve = function() { deferred.resolveWith(...) }
				// deferred.reject = function() { deferred.rejectWith(...) }
				deferred[ tuple[ 0 ] ] = function() {
					deferred[ tuple[ 0 ] + "With" ]( this === deferred ? undefined : this, arguments );
					return this;
				};
	
				// deferred.notifyWith = list.fireWith
				// deferred.resolveWith = list.fireWith
				// deferred.rejectWith = list.fireWith
				deferred[ tuple[ 0 ] + "With" ] = list.fireWith;
			} );
	
			// Make the deferred a promise
			promise.promise( deferred );
	
			// Call given func if any
			if ( func ) {
				func.call( deferred, deferred );
			}
	
			// All done!
			return deferred;
		},
	
		// Deferred helper
		when: function( singleValue ) {
			var
	
				// count of uncompleted subordinates
				remaining = arguments.length,
	
				// count of unprocessed arguments
				i = remaining,
	
				// subordinate fulfillment data
				resolveContexts = Array( i ),
				resolveValues = slice.call( arguments ),
	
				// the master Deferred
				master = jQuery.Deferred(),
	
				// subordinate callback factory
				updateFunc = function( i ) {
					return function( value ) {
						resolveContexts[ i ] = this;
						resolveValues[ i ] = arguments.length > 1 ? slice.call( arguments ) : value;
						if ( !( --remaining ) ) {
							master.resolveWith( resolveContexts, resolveValues );
						}
					};
				};
	
			// Single- and empty arguments are adopted like Promise.resolve
			if ( remaining <= 1 ) {
				adoptValue( singleValue, master.done( updateFunc( i ) ).resolve, master.reject,
					!remaining );
	
				// Use .then() to unwrap secondary thenables (cf. gh-3000)
				if ( master.state() === "pending" ||
					isFunction( resolveValues[ i ] && resolveValues[ i ].then ) ) {
	
					return master.then();
				}
			}
	
			// Multiple arguments are aggregated like Promise.all array elements
			while ( i-- ) {
				adoptValue( resolveValues[ i ], updateFunc( i ), master.reject );
			}
	
			return master.promise();
		}
	} );
	
	
	// These usually indicate a programmer mistake during development,
	// warn about them ASAP rather than swallowing them by default.
	var rerrorNames = /^(Eval|Internal|Range|Reference|Syntax|Type|URI)Error$/;
	
	jQuery.Deferred.exceptionHook = function( error, stack ) {
	
		// Support: IE 8 - 9 only
		// Console exists when dev tools are open, which can happen at any time
		if ( window.console && window.console.warn && error && rerrorNames.test( error.name ) ) {
			window.console.warn( "jQuery.Deferred exception: " + error.message, error.stack, stack );
		}
	};
	
	
	
	
	jQuery.readyException = function( error ) {
		window.setTimeout( function() {
			throw error;
		} );
	};
	
	
	
	
	// The deferred used on DOM ready
	var readyList = jQuery.Deferred();
	
	jQuery.fn.ready = function( fn ) {
	
		readyList
			.then( fn )
	
			// Wrap jQuery.readyException in a function so that the lookup
			// happens at the time of error handling instead of callback
			// registration.
			.catch( function( error ) {
				jQuery.readyException( error );
			} );
	
		return this;
	};
	
	jQuery.extend( {
	
		// Is the DOM ready to be used? Set to true once it occurs.
		isReady: false,
	
		// A counter to track how many items to wait for before
		// the ready event fires. See #6781
		readyWait: 1,
	
		// Handle when the DOM is ready
		ready: function( wait ) {
	
			// Abort if there are pending holds or we're already ready
			if ( wait === true ? --jQuery.readyWait : jQuery.isReady ) {
				return;
			}
	
			// Remember that the DOM is ready
			jQuery.isReady = true;
	
			// If a normal DOM Ready event fired, decrement, and wait if need be
			if ( wait !== true && --jQuery.readyWait > 0 ) {
				return;
			}
	
			// If there are functions bound, to execute
			readyList.resolveWith( document, [ jQuery ] );
		}
	} );
	
	jQuery.ready.then = readyList.then;
	
	// The ready event handler and self cleanup method
	function completed() {
		document.removeEventListener( "DOMContentLoaded", completed );
		window.removeEventListener( "load", completed );
		jQuery.ready();
	}
	
	// Catch cases where $(document).ready() is called
	// after the browser event has already occurred.
	// Support: IE <=9 - 10 only
	// Older IE sometimes signals "interactive" too soon
	if ( document.readyState === "complete" ||
		( document.readyState !== "loading" && !document.documentElement.doScroll ) ) {
	
		// Handle it asynchronously to allow scripts the opportunity to delay ready
		window.setTimeout( jQuery.ready );
	
	} else {
	
		// Use the handy event callback
		document.addEventListener( "DOMContentLoaded", completed );
	
		// A fallback to window.onload, that will always work
		window.addEventListener( "load", completed );
	}
	
	
	
	
	// Multifunctional method to get and set values of a collection
	// The value/s can optionally be executed if it's a function
	var access = function( elems, fn, key, value, chainable, emptyGet, raw ) {
		var i = 0,
			len = elems.length,
			bulk = key == null;
	
		// Sets many values
		if ( toType( key ) === "object" ) {
			chainable = true;
			for ( i in key ) {
				access( elems, fn, i, key[ i ], true, emptyGet, raw );
			}
	
		// Sets one value
		} else if ( value !== undefined ) {
			chainable = true;
	
			if ( !isFunction( value ) ) {
				raw = true;
			}
	
			if ( bulk ) {
	
				// Bulk operations run against the entire set
				if ( raw ) {
					fn.call( elems, value );
					fn = null;
	
				// ...except when executing function values
				} else {
					bulk = fn;
					fn = function( elem, key, value ) {
						return bulk.call( jQuery( elem ), value );
					};
				}
			}
	
			if ( fn ) {
				for ( ; i < len; i++ ) {
					fn(
						elems[ i ], key, raw ?
						value :
						value.call( elems[ i ], i, fn( elems[ i ], key ) )
					);
				}
			}
		}
	
		if ( chainable ) {
			return elems;
		}
	
		// Gets
		if ( bulk ) {
			return fn.call( elems );
		}
	
		return len ? fn( elems[ 0 ], key ) : emptyGet;
	};
	
	
	// Matches dashed string for camelizing
	var rmsPrefix = /^-ms-/,
		rdashAlpha = /-([a-z])/g;
	
	// Used by camelCase as callback to replace()
	function fcamelCase( all, letter ) {
		return letter.toUpperCase();
	}
	
	// Convert dashed to camelCase; used by the css and data modules
	// Support: IE <=9 - 11, Edge 12 - 15
	// Microsoft forgot to hump their vendor prefix (#9572)
	function camelCase( string ) {
		return string.replace( rmsPrefix, "ms-" ).replace( rdashAlpha, fcamelCase );
	}
	var acceptData = function( owner ) {
	
		// Accepts only:
		//  - Node
		//    - Node.ELEMENT_NODE
		//    - Node.DOCUMENT_NODE
		//  - Object
		//    - Any
		return owner.nodeType === 1 || owner.nodeType === 9 || !( +owner.nodeType );
	};
	
	
	
	
	function Data() {
		this.expando = jQuery.expando + Data.uid++;
	}
	
	Data.uid = 1;
	
	Data.prototype = {
	
		cache: function( owner ) {
	
			// Check if the owner object already has a cache
			var value = owner[ this.expando ];
	
			// If not, create one
			if ( !value ) {
				value = {};
	
				// We can accept data for non-element nodes in modern browsers,
				// but we should not, see #8335.
				// Always return an empty object.
				if ( acceptData( owner ) ) {
	
					// If it is a node unlikely to be stringify-ed or looped over
					// use plain assignment
					if ( owner.nodeType ) {
						owner[ this.expando ] = value;
	
					// Otherwise secure it in a non-enumerable property
					// configurable must be true to allow the property to be
					// deleted when data is removed
					} else {
						Object.defineProperty( owner, this.expando, {
							value: value,
							configurable: true
						} );
					}
				}
			}
	
			return value;
		},
		set: function( owner, data, value ) {
			var prop,
				cache = this.cache( owner );
	
			// Handle: [ owner, key, value ] args
			// Always use camelCase key (gh-2257)
			if ( typeof data === "string" ) {
				cache[ camelCase( data ) ] = value;
	
			// Handle: [ owner, { properties } ] args
			} else {
	
				// Copy the properties one-by-one to the cache object
				for ( prop in data ) {
					cache[ camelCase( prop ) ] = data[ prop ];
				}
			}
			return cache;
		},
		get: function( owner, key ) {
			return key === undefined ?
				this.cache( owner ) :
	
				// Always use camelCase key (gh-2257)
				owner[ this.expando ] && owner[ this.expando ][ camelCase( key ) ];
		},
		access: function( owner, key, value ) {
	
			// In cases where either:
			//
			//   1. No key was specified
			//   2. A string key was specified, but no value provided
			//
			// Take the "read" path and allow the get method to determine
			// which value to return, respectively either:
			//
			//   1. The entire cache object
			//   2. The data stored at the key
			//
			if ( key === undefined ||
					( ( key && typeof key === "string" ) && value === undefined ) ) {
	
				return this.get( owner, key );
			}
	
			// When the key is not a string, or both a key and value
			// are specified, set or extend (existing objects) with either:
			//
			//   1. An object of properties
			//   2. A key and value
			//
			this.set( owner, key, value );
	
			// Since the "set" path can have two possible entry points
			// return the expected data based on which path was taken[*]
			return value !== undefined ? value : key;
		},
		remove: function( owner, key ) {
			var i,
				cache = owner[ this.expando ];
	
			if ( cache === undefined ) {
				return;
			}
	
			if ( key !== undefined ) {
	
				// Support array or space separated string of keys
				if ( Array.isArray( key ) ) {
	
					// If key is an array of keys...
					// We always set camelCase keys, so remove that.
					key = key.map( camelCase );
				} else {
					key = camelCase( key );
	
					// If a key with the spaces exists, use it.
					// Otherwise, create an array by matching non-whitespace
					key = key in cache ?
						[ key ] :
						( key.match( rnothtmlwhite ) || [] );
				}
	
				i = key.length;
	
				while ( i-- ) {
					delete cache[ key[ i ] ];
				}
			}
	
			// Remove the expando if there's no more data
			if ( key === undefined || jQuery.isEmptyObject( cache ) ) {
	
				// Support: Chrome <=35 - 45
				// Webkit & Blink performance suffers when deleting properties
				// from DOM nodes, so set to undefined instead
				// https://bugs.chromium.org/p/chromium/issues/detail?id=378607 (bug restricted)
				if ( owner.nodeType ) {
					owner[ this.expando ] = undefined;
				} else {
					delete owner[ this.expando ];
				}
			}
		},
		hasData: function( owner ) {
			var cache = owner[ this.expando ];
			return cache !== undefined && !jQuery.isEmptyObject( cache );
		}
	};
	var dataPriv = new Data();
	
	var dataUser = new Data();
	
	
	
	//	Implementation Summary
	//
	//	1. Enforce API surface and semantic compatibility with 1.9.x branch
	//	2. Improve the module's maintainability by reducing the storage
	//		paths to a single mechanism.
	//	3. Use the same single mechanism to support "private" and "user" data.
	//	4. _Never_ expose "private" data to user code (TODO: Drop _data, _removeData)
	//	5. Avoid exposing implementation details on user objects (eg. expando properties)
	//	6. Provide a clear path for implementation upgrade to WeakMap in 2014
	
	var rbrace = /^(?:\{[\w\W]*\}|\[[\w\W]*\])$/,
		rmultiDash = /[A-Z]/g;
	
	function getData( data ) {
		if ( data === "true" ) {
			return true;
		}
	
		if ( data === "false" ) {
			return false;
		}
	
		if ( data === "null" ) {
			return null;
		}
	
		// Only convert to a number if it doesn't change the string
		if ( data === +data + "" ) {
			return +data;
		}
	
		if ( rbrace.test( data ) ) {
			return JSON.parse( data );
		}
	
		return data;
	}
	
	function dataAttr( elem, key, data ) {
		var name;
	
		// If nothing was found internally, try to fetch any
		// data from the HTML5 data-* attribute
		if ( data === undefined && elem.nodeType === 1 ) {
			name = "data-" + key.replace( rmultiDash, "-$&" ).toLowerCase();
			data = elem.getAttribute( name );
	
			if ( typeof data === "string" ) {
				try {
					data = getData( data );
				} catch ( e ) {}
	
				// Make sure we set the data so it isn't changed later
				dataUser.set( elem, key, data );
			} else {
				data = undefined;
			}
		}
		return data;
	}
	
	jQuery.extend( {
		hasData: function( elem ) {
			return dataUser.hasData( elem ) || dataPriv.hasData( elem );
		},
	
		data: function( elem, name, data ) {
			return dataUser.access( elem, name, data );
		},
	
		removeData: function( elem, name ) {
			dataUser.remove( elem, name );
		},
	
		// TODO: Now that all calls to _data and _removeData have been replaced
		// with direct calls to dataPriv methods, these can be deprecated.
		_data: function( elem, name, data ) {
			return dataPriv.access( elem, name, data );
		},
	
		_removeData: function( elem, name ) {
			dataPriv.remove( elem, name );
		}
	} );
	
	jQuery.fn.extend( {
		data: function( key, value ) {
			var i, name, data,
				elem = this[ 0 ],
				attrs = elem && elem.attributes;
	
			// Gets all values
			if ( key === undefined ) {
				if ( this.length ) {
					data = dataUser.get( elem );
	
					if ( elem.nodeType === 1 && !dataPriv.get( elem, "hasDataAttrs" ) ) {
						i = attrs.length;
						while ( i-- ) {
	
							// Support: IE 11 only
							// The attrs elements can be null (#14894)
							if ( attrs[ i ] ) {
								name = attrs[ i ].name;
								if ( name.indexOf( "data-" ) === 0 ) {
									name = camelCase( name.slice( 5 ) );
									dataAttr( elem, name, data[ name ] );
								}
							}
						}
						dataPriv.set( elem, "hasDataAttrs", true );
					}
				}
	
				return data;
			}
	
			// Sets multiple values
			if ( typeof key === "object" ) {
				return this.each( function() {
					dataUser.set( this, key );
				} );
			}
	
			return access( this, function( value ) {
				var data;
	
				// The calling jQuery object (element matches) is not empty
				// (and therefore has an element appears at this[ 0 ]) and the
				// `value` parameter was not undefined. An empty jQuery object
				// will result in `undefined` for elem = this[ 0 ] which will
				// throw an exception if an attempt to read a data cache is made.
				if ( elem && value === undefined ) {
	
					// Attempt to get data from the cache
					// The key will always be camelCased in Data
					data = dataUser.get( elem, key );
					if ( data !== undefined ) {
						return data;
					}
	
					// Attempt to "discover" the data in
					// HTML5 custom data-* attrs
					data = dataAttr( elem, key );
					if ( data !== undefined ) {
						return data;
					}
	
					// We tried really hard, but the data doesn't exist.
					return;
				}
	
				// Set the data...
				this.each( function() {
	
					// We always store the camelCased key
					dataUser.set( this, key, value );
				} );
			}, null, value, arguments.length > 1, null, true );
		},
	
		removeData: function( key ) {
			return this.each( function() {
				dataUser.remove( this, key );
			} );
		}
	} );
	
	
	jQuery.extend( {
		queue: function( elem, type, data ) {
			var queue;
	
			if ( elem ) {
				type = ( type || "fx" ) + "queue";
				queue = dataPriv.get( elem, type );
	
				// Speed up dequeue by getting out quickly if this is just a lookup
				if ( data ) {
					if ( !queue || Array.isArray( data ) ) {
						queue = dataPriv.access( elem, type, jQuery.makeArray( data ) );
					} else {
						queue.push( data );
					}
				}
				return queue || [];
			}
		},
	
		dequeue: function( elem, type ) {
			type = type || "fx";
	
			var queue = jQuery.queue( elem, type ),
				startLength = queue.length,
				fn = queue.shift(),
				hooks = jQuery._queueHooks( elem, type ),
				next = function() {
					jQuery.dequeue( elem, type );
				};
	
			// If the fx queue is dequeued, always remove the progress sentinel
			if ( fn === "inprogress" ) {
				fn = queue.shift();
				startLength--;
			}
	
			if ( fn ) {
	
				// Add a progress sentinel to prevent the fx queue from being
				// automatically dequeued
				if ( type === "fx" ) {
					queue.unshift( "inprogress" );
				}
	
				// Clear up the last queue stop function
				delete hooks.stop;
				fn.call( elem, next, hooks );
			}
	
			if ( !startLength && hooks ) {
				hooks.empty.fire();
			}
		},
	
		// Not public - generate a queueHooks object, or return the current one
		_queueHooks: function( elem, type ) {
			var key = type + "queueHooks";
			return dataPriv.get( elem, key ) || dataPriv.access( elem, key, {
				empty: jQuery.Callbacks( "once memory" ).add( function() {
					dataPriv.remove( elem, [ type + "queue", key ] );
				} )
			} );
		}
	} );
	
	jQuery.fn.extend( {
		queue: function( type, data ) {
			var setter = 2;
	
			if ( typeof type !== "string" ) {
				data = type;
				type = "fx";
				setter--;
			}
	
			if ( arguments.length < setter ) {
				return jQuery.queue( this[ 0 ], type );
			}
	
			return data === undefined ?
				this :
				this.each( function() {
					var queue = jQuery.queue( this, type, data );
	
					// Ensure a hooks for this queue
					jQuery._queueHooks( this, type );
	
					if ( type === "fx" && queue[ 0 ] !== "inprogress" ) {
						jQuery.dequeue( this, type );
					}
				} );
		},
		dequeue: function( type ) {
			return this.each( function() {
				jQuery.dequeue( this, type );
			} );
		},
		clearQueue: function( type ) {
			return this.queue( type || "fx", [] );
		},
	
		// Get a promise resolved when queues of a certain type
		// are emptied (fx is the type by default)
		promise: function( type, obj ) {
			var tmp,
				count = 1,
				defer = jQuery.Deferred(),
				elements = this,
				i = this.length,
				resolve = function() {
					if ( !( --count ) ) {
						defer.resolveWith( elements, [ elements ] );
					}
				};
	
			if ( typeof type !== "string" ) {
				obj = type;
				type = undefined;
			}
			type = type || "fx";
	
			while ( i-- ) {
				tmp = dataPriv.get( elements[ i ], type + "queueHooks" );
				if ( tmp && tmp.empty ) {
					count++;
					tmp.empty.add( resolve );
				}
			}
			resolve();
			return defer.promise( obj );
		}
	} );
	var pnum = ( /[+-]?(?:\d*\.|)\d+(?:[eE][+-]?\d+|)/ ).source;
	
	var rcssNum = new RegExp( "^(?:([+-])=|)(" + pnum + ")([a-z%]*)$", "i" );
	
	
	var cssExpand = [ "Top", "Right", "Bottom", "Left" ];
	
	var isHiddenWithinTree = function( elem, el ) {
	
			// isHiddenWithinTree might be called from jQuery#filter function;
			// in that case, element will be second argument
			elem = el || elem;
	
			// Inline style trumps all
			return elem.style.display === "none" ||
				elem.style.display === "" &&
	
				// Otherwise, check computed style
				// Support: Firefox <=43 - 45
				// Disconnected elements can have computed display: none, so first confirm that elem is
				// in the document.
				jQuery.contains( elem.ownerDocument, elem ) &&
	
				jQuery.css( elem, "display" ) === "none";
		};
	
	var swap = function( elem, options, callback, args ) {
		var ret, name,
			old = {};
	
		// Remember the old values, and insert the new ones
		for ( name in options ) {
			old[ name ] = elem.style[ name ];
			elem.style[ name ] = options[ name ];
		}
	
		ret = callback.apply( elem, args || [] );
	
		// Revert the old values
		for ( name in options ) {
			elem.style[ name ] = old[ name ];
		}
	
		return ret;
	};
	
	
	
	
	function adjustCSS( elem, prop, valueParts, tween ) {
		var adjusted, scale,
			maxIterations = 20,
			currentValue = tween ?
				function() {
					return tween.cur();
				} :
				function() {
					return jQuery.css( elem, prop, "" );
				},
			initial = currentValue(),
			unit = valueParts && valueParts[ 3 ] || ( jQuery.cssNumber[ prop ] ? "" : "px" ),
	
			// Starting value computation is required for potential unit mismatches
			initialInUnit = ( jQuery.cssNumber[ prop ] || unit !== "px" && +initial ) &&
				rcssNum.exec( jQuery.css( elem, prop ) );
	
		if ( initialInUnit && initialInUnit[ 3 ] !== unit ) {
	
			// Support: Firefox <=54
			// Halve the iteration target value to prevent interference from CSS upper bounds (gh-2144)
			initial = initial / 2;
	
			// Trust units reported by jQuery.css
			unit = unit || initialInUnit[ 3 ];
	
			// Iteratively approximate from a nonzero starting point
			initialInUnit = +initial || 1;
	
			while ( maxIterations-- ) {
	
				// Evaluate and update our best guess (doubling guesses that zero out).
				// Finish if the scale equals or crosses 1 (making the old*new product non-positive).
				jQuery.style( elem, prop, initialInUnit + unit );
				if ( ( 1 - scale ) * ( 1 - ( scale = currentValue() / initial || 0.5 ) ) <= 0 ) {
					maxIterations = 0;
				}
				initialInUnit = initialInUnit / scale;
	
			}
	
			initialInUnit = initialInUnit * 2;
			jQuery.style( elem, prop, initialInUnit + unit );
	
			// Make sure we update the tween properties later on
			valueParts = valueParts || [];
		}
	
		if ( valueParts ) {
			initialInUnit = +initialInUnit || +initial || 0;
	
			// Apply relative offset (+=/-=) if specified
			adjusted = valueParts[ 1 ] ?
				initialInUnit + ( valueParts[ 1 ] + 1 ) * valueParts[ 2 ] :
				+valueParts[ 2 ];
			if ( tween ) {
				tween.unit = unit;
				tween.start = initialInUnit;
				tween.end = adjusted;
			}
		}
		return adjusted;
	}
	
	
	var defaultDisplayMap = {};
	
	function getDefaultDisplay( elem ) {
		var temp,
			doc = elem.ownerDocument,
			nodeName = elem.nodeName,
			display = defaultDisplayMap[ nodeName ];
	
		if ( display ) {
			return display;
		}
	
		temp = doc.body.appendChild( doc.createElement( nodeName ) );
		display = jQuery.css( temp, "display" );
	
		temp.parentNode.removeChild( temp );
	
		if ( display === "none" ) {
			display = "block";
		}
		defaultDisplayMap[ nodeName ] = display;
	
		return display;
	}
	
	function showHide( elements, show ) {
		var display, elem,
			values = [],
			index = 0,
			length = elements.length;
	
		// Determine new display value for elements that need to change
		for ( ; index < length; index++ ) {
			elem = elements[ index ];
			if ( !elem.style ) {
				continue;
			}
	
			display = elem.style.display;
			if ( show ) {
	
				// Since we force visibility upon cascade-hidden elements, an immediate (and slow)
				// check is required in this first loop unless we have a nonempty display value (either
				// inline or about-to-be-restored)
				if ( display === "none" ) {
					values[ index ] = dataPriv.get( elem, "display" ) || null;
					if ( !values[ index ] ) {
						elem.style.display = "";
					}
				}
				if ( elem.style.display === "" && isHiddenWithinTree( elem ) ) {
					values[ index ] = getDefaultDisplay( elem );
				}
			} else {
				if ( display !== "none" ) {
					values[ index ] = "none";
	
					// Remember what we're overwriting
					dataPriv.set( elem, "display", display );
				}
			}
		}
	
		// Set the display of the elements in a second loop to avoid constant reflow
		for ( index = 0; index < length; index++ ) {
			if ( values[ index ] != null ) {
				elements[ index ].style.display = values[ index ];
			}
		}
	
		return elements;
	}
	
	jQuery.fn.extend( {
		show: function() {
			return showHide( this, true );
		},
		hide: function() {
			return showHide( this );
		},
		toggle: function( state ) {
			if ( typeof state === "boolean" ) {
				return state ? this.show() : this.hide();
			}
	
			return this.each( function() {
				if ( isHiddenWithinTree( this ) ) {
					jQuery( this ).show();
				} else {
					jQuery( this ).hide();
				}
			} );
		}
	} );
	var rcheckableType = ( /^(?:checkbox|radio)$/i );
	
	var rtagName = ( /<([a-z][^\/\0>\x20\t\r\n\f]+)/i );
	
	var rscriptType = ( /^$|^module$|\/(?:java|ecma)script/i );
	
	
	
	// We have to close these tags to support XHTML (#13200)
	var wrapMap = {
	
		// Support: IE <=9 only
		option: [ 1, "<select multiple='multiple'>", "</select>" ],
	
		// XHTML parsers do not magically insert elements in the
		// same way that tag soup parsers do. So we cannot shorten
		// this by omitting <tbody> or other required elements.
		thead: [ 1, "<table>", "</table>" ],
		col: [ 2, "<table><colgroup>", "</colgroup></table>" ],
		tr: [ 2, "<table><tbody>", "</tbody></table>" ],
		td: [ 3, "<table><tbody><tr>", "</tr></tbody></table>" ],
	
		_default: [ 0, "", "" ]
	};
	
	// Support: IE <=9 only
	wrapMap.optgroup = wrapMap.option;
	
	wrapMap.tbody = wrapMap.tfoot = wrapMap.colgroup = wrapMap.caption = wrapMap.thead;
	wrapMap.th = wrapMap.td;
	
	
	function getAll( context, tag ) {
	
		// Support: IE <=9 - 11 only
		// Use typeof to avoid zero-argument method invocation on host objects (#15151)
		var ret;
	
		if ( typeof context.getElementsByTagName !== "undefined" ) {
			ret = context.getElementsByTagName( tag || "*" );
	
		} else if ( typeof context.querySelectorAll !== "undefined" ) {
			ret = context.querySelectorAll( tag || "*" );
	
		} else {
			ret = [];
		}
	
		if ( tag === undefined || tag && nodeName( context, tag ) ) {
			return jQuery.merge( [ context ], ret );
		}
	
		return ret;
	}
	
	
	// Mark scripts as having already been evaluated
	function setGlobalEval( elems, refElements ) {
		var i = 0,
			l = elems.length;
	
		for ( ; i < l; i++ ) {
			dataPriv.set(
				elems[ i ],
				"globalEval",
				!refElements || dataPriv.get( refElements[ i ], "globalEval" )
			);
		}
	}
	
	
	var rhtml = /<|&#?\w+;/;
	
	function buildFragment( elems, context, scripts, selection, ignored ) {
		var elem, tmp, tag, wrap, contains, j,
			fragment = context.createDocumentFragment(),
			nodes = [],
			i = 0,
			l = elems.length;
	
		for ( ; i < l; i++ ) {
			elem = elems[ i ];
	
			if ( elem || elem === 0 ) {
	
				// Add nodes directly
				if ( toType( elem ) === "object" ) {
	
					// Support: Android <=4.0 only, PhantomJS 1 only
					// push.apply(_, arraylike) throws on ancient WebKit
					jQuery.merge( nodes, elem.nodeType ? [ elem ] : elem );
	
				// Convert non-html into a text node
				} else if ( !rhtml.test( elem ) ) {
					nodes.push( context.createTextNode( elem ) );
	
				// Convert html into DOM nodes
				} else {
					tmp = tmp || fragment.appendChild( context.createElement( "div" ) );
	
					// Deserialize a standard representation
					tag = ( rtagName.exec( elem ) || [ "", "" ] )[ 1 ].toLowerCase();
					wrap = wrapMap[ tag ] || wrapMap._default;
					tmp.innerHTML = wrap[ 1 ] + jQuery.htmlPrefilter( elem ) + wrap[ 2 ];
	
					// Descend through wrappers to the right content
					j = wrap[ 0 ];
					while ( j-- ) {
						tmp = tmp.lastChild;
					}
	
					// Support: Android <=4.0 only, PhantomJS 1 only
					// push.apply(_, arraylike) throws on ancient WebKit
					jQuery.merge( nodes, tmp.childNodes );
	
					// Remember the top-level container
					tmp = fragment.firstChild;
	
					// Ensure the created nodes are orphaned (#12392)
					tmp.textContent = "";
				}
			}
		}
	
		// Remove wrapper from fragment
		fragment.textContent = "";
	
		i = 0;
		while ( ( elem = nodes[ i++ ] ) ) {
	
			// Skip elements already in the context collection (trac-4087)
			if ( selection && jQuery.inArray( elem, selection ) > -1 ) {
				if ( ignored ) {
					ignored.push( elem );
				}
				continue;
			}
	
			contains = jQuery.contains( elem.ownerDocument, elem );
	
			// Append to fragment
			tmp = getAll( fragment.appendChild( elem ), "script" );
	
			// Preserve script evaluation history
			if ( contains ) {
				setGlobalEval( tmp );
			}
	
			// Capture executables
			if ( scripts ) {
				j = 0;
				while ( ( elem = tmp[ j++ ] ) ) {
					if ( rscriptType.test( elem.type || "" ) ) {
						scripts.push( elem );
					}
				}
			}
		}
	
		return fragment;
	}
	
	
	( function() {
		var fragment = document.createDocumentFragment(),
			div = fragment.appendChild( document.createElement( "div" ) ),
			input = document.createElement( "input" );
	
		// Support: Android 4.0 - 4.3 only
		// Check state lost if the name is set (#11217)
		// Support: Windows Web Apps (WWA)
		// `name` and `type` must use .setAttribute for WWA (#14901)
		input.setAttribute( "type", "radio" );
		input.setAttribute( "checked", "checked" );
		input.setAttribute( "name", "t" );
	
		div.appendChild( input );
	
		// Support: Android <=4.1 only
		// Older WebKit doesn't clone checked state correctly in fragments
		support.checkClone = div.cloneNode( true ).cloneNode( true ).lastChild.checked;
	
		// Support: IE <=11 only
		// Make sure textarea (and checkbox) defaultValue is properly cloned
		div.innerHTML = "<textarea>x</textarea>";
		support.noCloneChecked = !!div.cloneNode( true ).lastChild.defaultValue;
	} )();
	var documentElement = document.documentElement;
	
	
	
	var
		rkeyEvent = /^key/,
		rmouseEvent = /^(?:mouse|pointer|contextmenu|drag|drop)|click/,
		rtypenamespace = /^([^.]*)(?:\.(.+)|)/;
	
	function returnTrue() {
		return true;
	}
	
	function returnFalse() {
		return false;
	}
	
	// Support: IE <=9 only
	// See #13393 for more info
	function safeActiveElement() {
		try {
			return document.activeElement;
		} catch ( err ) { }
	}
	
	function on( elem, types, selector, data, fn, one ) {
		var origFn, type;
	
		// Types can be a map of types/handlers
		if ( typeof types === "object" ) {
	
			// ( types-Object, selector, data )
			if ( typeof selector !== "string" ) {
	
				// ( types-Object, data )
				data = data || selector;
				selector = undefined;
			}
			for ( type in types ) {
				on( elem, type, selector, data, types[ type ], one );
			}
			return elem;
		}
	
		if ( data == null && fn == null ) {
	
			// ( types, fn )
			fn = selector;
			data = selector = undefined;
		} else if ( fn == null ) {
			if ( typeof selector === "string" ) {
	
				// ( types, selector, fn )
				fn = data;
				data = undefined;
			} else {
	
				// ( types, data, fn )
				fn = data;
				data = selector;
				selector = undefined;
			}
		}
		if ( fn === false ) {
			fn = returnFalse;
		} else if ( !fn ) {
			return elem;
		}
	
		if ( one === 1 ) {
			origFn = fn;
			fn = function( event ) {
	
				// Can use an empty set, since event contains the info
				jQuery().off( event );
				return origFn.apply( this, arguments );
			};
	
			// Use same guid so caller can remove using origFn
			fn.guid = origFn.guid || ( origFn.guid = jQuery.guid++ );
		}
		return elem.each( function() {
			jQuery.event.add( this, types, fn, data, selector );
		} );
	}
	
	/*
	 * Helper functions for managing events -- not part of the public interface.
	 * Props to Dean Edwards' addEvent library for many of the ideas.
	 */
	jQuery.event = {
	
		global: {},
	
		add: function( elem, types, handler, data, selector ) {
	
			var handleObjIn, eventHandle, tmp,
				events, t, handleObj,
				special, handlers, type, namespaces, origType,
				elemData = dataPriv.get( elem );
	
			// Don't attach events to noData or text/comment nodes (but allow plain objects)
			if ( !elemData ) {
				return;
			}
	
			// Caller can pass in an object of custom data in lieu of the handler
			if ( handler.handler ) {
				handleObjIn = handler;
				handler = handleObjIn.handler;
				selector = handleObjIn.selector;
			}
	
			// Ensure that invalid selectors throw exceptions at attach time
			// Evaluate against documentElement in case elem is a non-element node (e.g., document)
			if ( selector ) {
				jQuery.find.matchesSelector( documentElement, selector );
			}
	
			// Make sure that the handler has a unique ID, used to find/remove it later
			if ( !handler.guid ) {
				handler.guid = jQuery.guid++;
			}
	
			// Init the element's event structure and main handler, if this is the first
			if ( !( events = elemData.events ) ) {
				events = elemData.events = {};
			}
			if ( !( eventHandle = elemData.handle ) ) {
				eventHandle = elemData.handle = function( e ) {
	
					// Discard the second event of a jQuery.event.trigger() and
					// when an event is called after a page has unloaded
					return typeof jQuery !== "undefined" && jQuery.event.triggered !== e.type ?
						jQuery.event.dispatch.apply( elem, arguments ) : undefined;
				};
			}
	
			// Handle multiple events separated by a space
			types = ( types || "" ).match( rnothtmlwhite ) || [ "" ];
			t = types.length;
			while ( t-- ) {
				tmp = rtypenamespace.exec( types[ t ] ) || [];
				type = origType = tmp[ 1 ];
				namespaces = ( tmp[ 2 ] || "" ).split( "." ).sort();
	
				// There *must* be a type, no attaching namespace-only handlers
				if ( !type ) {
					continue;
				}
	
				// If event changes its type, use the special event handlers for the changed type
				special = jQuery.event.special[ type ] || {};
	
				// If selector defined, determine special event api type, otherwise given type
				type = ( selector ? special.delegateType : special.bindType ) || type;
	
				// Update special based on newly reset type
				special = jQuery.event.special[ type ] || {};
	
				// handleObj is passed to all event handlers
				handleObj = jQuery.extend( {
					type: type,
					origType: origType,
					data: data,
					handler: handler,
					guid: handler.guid,
					selector: selector,
					needsContext: selector && jQuery.expr.match.needsContext.test( selector ),
					namespace: namespaces.join( "." )
				}, handleObjIn );
	
				// Init the event handler queue if we're the first
				if ( !( handlers = events[ type ] ) ) {
					handlers = events[ type ] = [];
					handlers.delegateCount = 0;
	
					// Only use addEventListener if the special events handler returns false
					if ( !special.setup ||
						special.setup.call( elem, data, namespaces, eventHandle ) === false ) {
	
						if ( elem.addEventListener ) {
							elem.addEventListener( type, eventHandle );
						}
					}
				}
	
				if ( special.add ) {
					special.add.call( elem, handleObj );
	
					if ( !handleObj.handler.guid ) {
						handleObj.handler.guid = handler.guid;
					}
				}
	
				// Add to the element's handler list, delegates in front
				if ( selector ) {
					handlers.splice( handlers.delegateCount++, 0, handleObj );
				} else {
					handlers.push( handleObj );
				}
	
				// Keep track of which events have ever been used, for event optimization
				jQuery.event.global[ type ] = true;
			}
	
		},
	
		// Detach an event or set of events from an element
		remove: function( elem, types, handler, selector, mappedTypes ) {
	
			var j, origCount, tmp,
				events, t, handleObj,
				special, handlers, type, namespaces, origType,
				elemData = dataPriv.hasData( elem ) && dataPriv.get( elem );
	
			if ( !elemData || !( events = elemData.events ) ) {
				return;
			}
	
			// Once for each type.namespace in types; type may be omitted
			types = ( types || "" ).match( rnothtmlwhite ) || [ "" ];
			t = types.length;
			while ( t-- ) {
				tmp = rtypenamespace.exec( types[ t ] ) || [];
				type = origType = tmp[ 1 ];
				namespaces = ( tmp[ 2 ] || "" ).split( "." ).sort();
	
				// Unbind all events (on this namespace, if provided) for the element
				if ( !type ) {
					for ( type in events ) {
						jQuery.event.remove( elem, type + types[ t ], handler, selector, true );
					}
					continue;
				}
	
				special = jQuery.event.special[ type ] || {};
				type = ( selector ? special.delegateType : special.bindType ) || type;
				handlers = events[ type ] || [];
				tmp = tmp[ 2 ] &&
					new RegExp( "(^|\\.)" + namespaces.join( "\\.(?:.*\\.|)" ) + "(\\.|$)" );
	
				// Remove matching events
				origCount = j = handlers.length;
				while ( j-- ) {
					handleObj = handlers[ j ];
	
					if ( ( mappedTypes || origType === handleObj.origType ) &&
						( !handler || handler.guid === handleObj.guid ) &&
						( !tmp || tmp.test( handleObj.namespace ) ) &&
						( !selector || selector === handleObj.selector ||
							selector === "**" && handleObj.selector ) ) {
						handlers.splice( j, 1 );
	
						if ( handleObj.selector ) {
							handlers.delegateCount--;
						}
						if ( special.remove ) {
							special.remove.call( elem, handleObj );
						}
					}
				}
	
				// Remove generic event handler if we removed something and no more handlers exist
				// (avoids potential for endless recursion during removal of special event handlers)
				if ( origCount && !handlers.length ) {
					if ( !special.teardown ||
						special.teardown.call( elem, namespaces, elemData.handle ) === false ) {
	
						jQuery.removeEvent( elem, type, elemData.handle );
					}
	
					delete events[ type ];
				}
			}
	
			// Remove data and the expando if it's no longer used
			if ( jQuery.isEmptyObject( events ) ) {
				dataPriv.remove( elem, "handle events" );
			}
		},
	
		dispatch: function( nativeEvent ) {
	
			// Make a writable jQuery.Event from the native event object
			var event = jQuery.event.fix( nativeEvent );
	
			var i, j, ret, matched, handleObj, handlerQueue,
				args = new Array( arguments.length ),
				handlers = ( dataPriv.get( this, "events" ) || {} )[ event.type ] || [],
				special = jQuery.event.special[ event.type ] || {};
	
			// Use the fix-ed jQuery.Event rather than the (read-only) native event
			args[ 0 ] = event;
	
			for ( i = 1; i < arguments.length; i++ ) {
				args[ i ] = arguments[ i ];
			}
	
			event.delegateTarget = this;
	
			// Call the preDispatch hook for the mapped type, and let it bail if desired
			if ( special.preDispatch && special.preDispatch.call( this, event ) === false ) {
				return;
			}
	
			// Determine handlers
			handlerQueue = jQuery.event.handlers.call( this, event, handlers );
	
			// Run delegates first; they may want to stop propagation beneath us
			i = 0;
			while ( ( matched = handlerQueue[ i++ ] ) && !event.isPropagationStopped() ) {
				event.currentTarget = matched.elem;
	
				j = 0;
				while ( ( handleObj = matched.handlers[ j++ ] ) &&
					!event.isImmediatePropagationStopped() ) {
	
					// Triggered event must either 1) have no namespace, or 2) have namespace(s)
					// a subset or equal to those in the bound event (both can have no namespace).
					if ( !event.rnamespace || event.rnamespace.test( handleObj.namespace ) ) {
	
						event.handleObj = handleObj;
						event.data = handleObj.data;
	
						ret = ( ( jQuery.event.special[ handleObj.origType ] || {} ).handle ||
							handleObj.handler ).apply( matched.elem, args );
	
						if ( ret !== undefined ) {
							if ( ( event.result = ret ) === false ) {
								event.preventDefault();
								event.stopPropagation();
							}
						}
					}
				}
			}
	
			// Call the postDispatch hook for the mapped type
			if ( special.postDispatch ) {
				special.postDispatch.call( this, event );
			}
	
			return event.result;
		},
	
		handlers: function( event, handlers ) {
			var i, handleObj, sel, matchedHandlers, matchedSelectors,
				handlerQueue = [],
				delegateCount = handlers.delegateCount,
				cur = event.target;
	
			// Find delegate handlers
			if ( delegateCount &&
	
				// Support: IE <=9
				// Black-hole SVG <use> instance trees (trac-13180)
				cur.nodeType &&
	
				// Support: Firefox <=42
				// Suppress spec-violating clicks indicating a non-primary pointer button (trac-3861)
				// https://www.w3.org/TR/DOM-Level-3-Events/#event-type-click
				// Support: IE 11 only
				// ...but not arrow key "clicks" of radio inputs, which can have `button` -1 (gh-2343)
				!( event.type === "click" && event.button >= 1 ) ) {
	
				for ( ; cur !== this; cur = cur.parentNode || this ) {
	
					// Don't check non-elements (#13208)
					// Don't process clicks on disabled elements (#6911, #8165, #11382, #11764)
					if ( cur.nodeType === 1 && !( event.type === "click" && cur.disabled === true ) ) {
						matchedHandlers = [];
						matchedSelectors = {};
						for ( i = 0; i < delegateCount; i++ ) {
							handleObj = handlers[ i ];
	
							// Don't conflict with Object.prototype properties (#13203)
							sel = handleObj.selector + " ";
	
							if ( matchedSelectors[ sel ] === undefined ) {
								matchedSelectors[ sel ] = handleObj.needsContext ?
									jQuery( sel, this ).index( cur ) > -1 :
									jQuery.find( sel, this, null, [ cur ] ).length;
							}
							if ( matchedSelectors[ sel ] ) {
								matchedHandlers.push( handleObj );
							}
						}
						if ( matchedHandlers.length ) {
							handlerQueue.push( { elem: cur, handlers: matchedHandlers } );
						}
					}
				}
			}
	
			// Add the remaining (directly-bound) handlers
			cur = this;
			if ( delegateCount < handlers.length ) {
				handlerQueue.push( { elem: cur, handlers: handlers.slice( delegateCount ) } );
			}
	
			return handlerQueue;
		},
	
		addProp: function( name, hook ) {
			Object.defineProperty( jQuery.Event.prototype, name, {
				enumerable: true,
				configurable: true,
	
				get: isFunction( hook ) ?
					function() {
						if ( this.originalEvent ) {
								return hook( this.originalEvent );
						}
					} :
					function() {
						if ( this.originalEvent ) {
								return this.originalEvent[ name ];
						}
					},
	
				set: function( value ) {
					Object.defineProperty( this, name, {
						enumerable: true,
						configurable: true,
						writable: true,
						value: value
					} );
				}
			} );
		},
	
		fix: function( originalEvent ) {
			return originalEvent[ jQuery.expando ] ?
				originalEvent :
				new jQuery.Event( originalEvent );
		},
	
		special: {
			load: {
	
				// Prevent triggered image.load events from bubbling to window.load
				noBubble: true
			},
			focus: {
	
				// Fire native event if possible so blur/focus sequence is correct
				trigger: function() {
					if ( this !== safeActiveElement() && this.focus ) {
						this.focus();
						return false;
					}
				},
				delegateType: "focusin"
			},
			blur: {
				trigger: function() {
					if ( this === safeActiveElement() && this.blur ) {
						this.blur();
						return false;
					}
				},
				delegateType: "focusout"
			},
			click: {
	
				// For checkbox, fire native event so checked state will be right
				trigger: function() {
					if ( this.type === "checkbox" && this.click && nodeName( this, "input" ) ) {
						this.click();
						return false;
					}
				},
	
				// For cross-browser consistency, don't fire native .click() on links
				_default: function( event ) {
					return nodeName( event.target, "a" );
				}
			},
	
			beforeunload: {
				postDispatch: function( event ) {
	
					// Support: Firefox 20+
					// Firefox doesn't alert if the returnValue field is not set.
					if ( event.result !== undefined && event.originalEvent ) {
						event.originalEvent.returnValue = event.result;
					}
				}
			}
		}
	};
	
	jQuery.removeEvent = function( elem, type, handle ) {
	
		// This "if" is needed for plain objects
		if ( elem.removeEventListener ) {
			elem.removeEventListener( type, handle );
		}
	};
	
	jQuery.Event = function( src, props ) {
	
		// Allow instantiation without the 'new' keyword
		if ( !( this instanceof jQuery.Event ) ) {
			return new jQuery.Event( src, props );
		}
	
		// Event object
		if ( src && src.type ) {
			this.originalEvent = src;
			this.type = src.type;
	
			// Events bubbling up the document may have been marked as prevented
			// by a handler lower down the tree; reflect the correct value.
			this.isDefaultPrevented = src.defaultPrevented ||
					src.defaultPrevented === undefined &&
	
					// Support: Android <=2.3 only
					src.returnValue === false ?
				returnTrue :
				returnFalse;
	
			// Create target properties
			// Support: Safari <=6 - 7 only
			// Target should not be a text node (#504, #13143)
			this.target = ( src.target && src.target.nodeType === 3 ) ?
				src.target.parentNode :
				src.target;
	
			this.currentTarget = src.currentTarget;
			this.relatedTarget = src.relatedTarget;
	
		// Event type
		} else {
			this.type = src;
		}
	
		// Put explicitly provided properties onto the event object
		if ( props ) {
			jQuery.extend( this, props );
		}
	
		// Create a timestamp if incoming event doesn't have one
		this.timeStamp = src && src.timeStamp || Date.now();
	
		// Mark it as fixed
		this[ jQuery.expando ] = true;
	};
	
	// jQuery.Event is based on DOM3 Events as specified by the ECMAScript Language Binding
	// https://www.w3.org/TR/2003/WD-DOM-Level-3-Events-20030331/ecma-script-binding.html
	jQuery.Event.prototype = {
		constructor: jQuery.Event,
		isDefaultPrevented: returnFalse,
		isPropagationStopped: returnFalse,
		isImmediatePropagationStopped: returnFalse,
		isSimulated: false,
	
		preventDefault: function() {
			var e = this.originalEvent;
	
			this.isDefaultPrevented = returnTrue;
	
			if ( e && !this.isSimulated ) {
				e.preventDefault();
			}
		},
		stopPropagation: function() {
			var e = this.originalEvent;
	
			this.isPropagationStopped = returnTrue;
	
			if ( e && !this.isSimulated ) {
				e.stopPropagation();
			}
		},
		stopImmediatePropagation: function() {
			var e = this.originalEvent;
	
			this.isImmediatePropagationStopped = returnTrue;
	
			if ( e && !this.isSimulated ) {
				e.stopImmediatePropagation();
			}
	
			this.stopPropagation();
		}
	};
	
	// Includes all common event props including KeyEvent and MouseEvent specific props
	jQuery.each( {
		altKey: true,
		bubbles: true,
		cancelable: true,
		changedTouches: true,
		ctrlKey: true,
		detail: true,
		eventPhase: true,
		metaKey: true,
		pageX: true,
		pageY: true,
		shiftKey: true,
		view: true,
		"char": true,
		charCode: true,
		key: true,
		keyCode: true,
		button: true,
		buttons: true,
		clientX: true,
		clientY: true,
		offsetX: true,
		offsetY: true,
		pointerId: true,
		pointerType: true,
		screenX: true,
		screenY: true,
		targetTouches: true,
		toElement: true,
		touches: true,
	
		which: function( event ) {
			var button = event.button;
	
			// Add which for key events
			if ( event.which == null && rkeyEvent.test( event.type ) ) {
				return event.charCode != null ? event.charCode : event.keyCode;
			}
	
			// Add which for click: 1 === left; 2 === middle; 3 === right
			if ( !event.which && button !== undefined && rmouseEvent.test( event.type ) ) {
				if ( button & 1 ) {
					return 1;
				}
	
				if ( button & 2 ) {
					return 3;
				}
	
				if ( button & 4 ) {
					return 2;
				}
	
				return 0;
			}
	
			return event.which;
		}
	}, jQuery.event.addProp );
	
	// Create mouseenter/leave events using mouseover/out and event-time checks
	// so that event delegation works in jQuery.
	// Do the same for pointerenter/pointerleave and pointerover/pointerout
	//
	// Support: Safari 7 only
	// Safari sends mouseenter too often; see:
	// https://bugs.chromium.org/p/chromium/issues/detail?id=470258
	// for the description of the bug (it existed in older Chrome versions as well).
	jQuery.each( {
		mouseenter: "mouseover",
		mouseleave: "mouseout",
		pointerenter: "pointerover",
		pointerleave: "pointerout"
	}, function( orig, fix ) {
		jQuery.event.special[ orig ] = {
			delegateType: fix,
			bindType: fix,
	
			handle: function( event ) {
				var ret,
					target = this,
					related = event.relatedTarget,
					handleObj = event.handleObj;
	
				// For mouseenter/leave call the handler if related is outside the target.
				// NB: No relatedTarget if the mouse left/entered the browser window
				if ( !related || ( related !== target && !jQuery.contains( target, related ) ) ) {
					event.type = handleObj.origType;
					ret = handleObj.handler.apply( this, arguments );
					event.type = fix;
				}
				return ret;
			}
		};
	} );
	
	jQuery.fn.extend( {
	
		on: function( types, selector, data, fn ) {
			return on( this, types, selector, data, fn );
		},
		one: function( types, selector, data, fn ) {
			return on( this, types, selector, data, fn, 1 );
		},
		off: function( types, selector, fn ) {
			var handleObj, type;
			if ( types && types.preventDefault && types.handleObj ) {
	
				// ( event )  dispatched jQuery.Event
				handleObj = types.handleObj;
				jQuery( types.delegateTarget ).off(
					handleObj.namespace ?
						handleObj.origType + "." + handleObj.namespace :
						handleObj.origType,
					handleObj.selector,
					handleObj.handler
				);
				return this;
			}
			if ( typeof types === "object" ) {
	
				// ( types-object [, selector] )
				for ( type in types ) {
					this.off( type, selector, types[ type ] );
				}
				return this;
			}
			if ( selector === false || typeof selector === "function" ) {
	
				// ( types [, fn] )
				fn = selector;
				selector = undefined;
			}
			if ( fn === false ) {
				fn = returnFalse;
			}
			return this.each( function() {
				jQuery.event.remove( this, types, fn, selector );
			} );
		}
	} );
	
	
	var
	
		/* eslint-disable max-len */
	
		// See https://github.com/eslint/eslint/issues/3229
		rxhtmlTag = /<(?!area|br|col|embed|hr|img|input|link|meta|param)(([a-z][^\/\0>\x20\t\r\n\f]*)[^>]*)\/>/gi,
	
		/* eslint-enable */
	
		// Support: IE <=10 - 11, Edge 12 - 13 only
		// In IE/Edge using regex groups here causes severe slowdowns.
		// See https://connect.microsoft.com/IE/feedback/details/1736512/
		rnoInnerhtml = /<script|<style|<link/i,
	
		// checked="checked" or checked
		rchecked = /checked\s*(?:[^=]|=\s*.checked.)/i,
		rcleanScript = /^\s*<!(?:\[CDATA\[|--)|(?:\]\]|--)>\s*$/g;
	
	// Prefer a tbody over its parent table for containing new rows
	function manipulationTarget( elem, content ) {
		if ( nodeName( elem, "table" ) &&
			nodeName( content.nodeType !== 11 ? content : content.firstChild, "tr" ) ) {
	
			return jQuery( elem ).children( "tbody" )[ 0 ] || elem;
		}
	
		return elem;
	}
	
	// Replace/restore the type attribute of script elements for safe DOM manipulation
	function disableScript( elem ) {
		elem.type = ( elem.getAttribute( "type" ) !== null ) + "/" + elem.type;
		return elem;
	}
	function restoreScript( elem ) {
		if ( ( elem.type || "" ).slice( 0, 5 ) === "true/" ) {
			elem.type = elem.type.slice( 5 );
		} else {
			elem.removeAttribute( "type" );
		}
	
		return elem;
	}
	
	function cloneCopyEvent( src, dest ) {
		var i, l, type, pdataOld, pdataCur, udataOld, udataCur, events;
	
		if ( dest.nodeType !== 1 ) {
			return;
		}
	
		// 1. Copy private data: events, handlers, etc.
		if ( dataPriv.hasData( src ) ) {
			pdataOld = dataPriv.access( src );
			pdataCur = dataPriv.set( dest, pdataOld );
			events = pdataOld.events;
	
			if ( events ) {
				delete pdataCur.handle;
				pdataCur.events = {};
	
				for ( type in events ) {
					for ( i = 0, l = events[ type ].length; i < l; i++ ) {
						jQuery.event.add( dest, type, events[ type ][ i ] );
					}
				}
			}
		}
	
		// 2. Copy user data
		if ( dataUser.hasData( src ) ) {
			udataOld = dataUser.access( src );
			udataCur = jQuery.extend( {}, udataOld );
	
			dataUser.set( dest, udataCur );
		}
	}
	
	// Fix IE bugs, see support tests
	function fixInput( src, dest ) {
		var nodeName = dest.nodeName.toLowerCase();
	
		// Fails to persist the checked state of a cloned checkbox or radio button.
		if ( nodeName === "input" && rcheckableType.test( src.type ) ) {
			dest.checked = src.checked;
	
		// Fails to return the selected option to the default selected state when cloning options
		} else if ( nodeName === "input" || nodeName === "textarea" ) {
			dest.defaultValue = src.defaultValue;
		}
	}
	
	function domManip( collection, args, callback, ignored ) {
	
		// Flatten any nested arrays
		args = concat.apply( [], args );
	
		var fragment, first, scripts, hasScripts, node, doc,
			i = 0,
			l = collection.length,
			iNoClone = l - 1,
			value = args[ 0 ],
			valueIsFunction = isFunction( value );
	
		// We can't cloneNode fragments that contain checked, in WebKit
		if ( valueIsFunction ||
				( l > 1 && typeof value === "string" &&
					!support.checkClone && rchecked.test( value ) ) ) {
			return collection.each( function( index ) {
				var self = collection.eq( index );
				if ( valueIsFunction ) {
					args[ 0 ] = value.call( this, index, self.html() );
				}
				domManip( self, args, callback, ignored );
			} );
		}
	
		if ( l ) {
			fragment = buildFragment( args, collection[ 0 ].ownerDocument, false, collection, ignored );
			first = fragment.firstChild;
	
			if ( fragment.childNodes.length === 1 ) {
				fragment = first;
			}
	
			// Require either new content or an interest in ignored elements to invoke the callback
			if ( first || ignored ) {
				scripts = jQuery.map( getAll( fragment, "script" ), disableScript );
				hasScripts = scripts.length;
	
				// Use the original fragment for the last item
				// instead of the first because it can end up
				// being emptied incorrectly in certain situations (#8070).
				for ( ; i < l; i++ ) {
					node = fragment;
	
					if ( i !== iNoClone ) {
						node = jQuery.clone( node, true, true );
	
						// Keep references to cloned scripts for later restoration
						if ( hasScripts ) {
	
							// Support: Android <=4.0 only, PhantomJS 1 only
							// push.apply(_, arraylike) throws on ancient WebKit
							jQuery.merge( scripts, getAll( node, "script" ) );
						}
					}
	
					callback.call( collection[ i ], node, i );
				}
	
				if ( hasScripts ) {
					doc = scripts[ scripts.length - 1 ].ownerDocument;
	
					// Reenable scripts
					jQuery.map( scripts, restoreScript );
	
					// Evaluate executable scripts on first document insertion
					for ( i = 0; i < hasScripts; i++ ) {
						node = scripts[ i ];
						if ( rscriptType.test( node.type || "" ) &&
							!dataPriv.access( node, "globalEval" ) &&
							jQuery.contains( doc, node ) ) {
	
							if ( node.src && ( node.type || "" ).toLowerCase()  !== "module" ) {
	
								// Optional AJAX dependency, but won't run scripts if not present
								if ( jQuery._evalUrl ) {
									jQuery._evalUrl( node.src );
								}
							} else {
								DOMEval( node.textContent.replace( rcleanScript, "" ), doc, node );
							}
						}
					}
				}
			}
		}
	
		return collection;
	}
	
	function remove( elem, selector, keepData ) {
		var node,
			nodes = selector ? jQuery.filter( selector, elem ) : elem,
			i = 0;
	
		for ( ; ( node = nodes[ i ] ) != null; i++ ) {
			if ( !keepData && node.nodeType === 1 ) {
				jQuery.cleanData( getAll( node ) );
			}
	
			if ( node.parentNode ) {
				if ( keepData && jQuery.contains( node.ownerDocument, node ) ) {
					setGlobalEval( getAll( node, "script" ) );
				}
				node.parentNode.removeChild( node );
			}
		}
	
		return elem;
	}
	
	jQuery.extend( {
		htmlPrefilter: function( html ) {
			return html.replace( rxhtmlTag, "<$1></$2>" );
		},
	
		clone: function( elem, dataAndEvents, deepDataAndEvents ) {
			var i, l, srcElements, destElements,
				clone = elem.cloneNode( true ),
				inPage = jQuery.contains( elem.ownerDocument, elem );
	
			// Fix IE cloning issues
			if ( !support.noCloneChecked && ( elem.nodeType === 1 || elem.nodeType === 11 ) &&
					!jQuery.isXMLDoc( elem ) ) {
	
				// We eschew Sizzle here for performance reasons: https://jsperf.com/getall-vs-sizzle/2
				destElements = getAll( clone );
				srcElements = getAll( elem );
	
				for ( i = 0, l = srcElements.length; i < l; i++ ) {
					fixInput( srcElements[ i ], destElements[ i ] );
				}
			}
	
			// Copy the events from the original to the clone
			if ( dataAndEvents ) {
				if ( deepDataAndEvents ) {
					srcElements = srcElements || getAll( elem );
					destElements = destElements || getAll( clone );
	
					for ( i = 0, l = srcElements.length; i < l; i++ ) {
						cloneCopyEvent( srcElements[ i ], destElements[ i ] );
					}
				} else {
					cloneCopyEvent( elem, clone );
				}
			}
	
			// Preserve script evaluation history
			destElements = getAll( clone, "script" );
			if ( destElements.length > 0 ) {
				setGlobalEval( destElements, !inPage && getAll( elem, "script" ) );
			}
	
			// Return the cloned set
			return clone;
		},
	
		cleanData: function( elems ) {
			var data, elem, type,
				special = jQuery.event.special,
				i = 0;
	
			for ( ; ( elem = elems[ i ] ) !== undefined; i++ ) {
				if ( acceptData( elem ) ) {
					if ( ( data = elem[ dataPriv.expando ] ) ) {
						if ( data.events ) {
							for ( type in data.events ) {
								if ( special[ type ] ) {
									jQuery.event.remove( elem, type );
	
								// This is a shortcut to avoid jQuery.event.remove's overhead
								} else {
									jQuery.removeEvent( elem, type, data.handle );
								}
							}
						}
	
						// Support: Chrome <=35 - 45+
						// Assign undefined instead of using delete, see Data#remove
						elem[ dataPriv.expando ] = undefined;
					}
					if ( elem[ dataUser.expando ] ) {
	
						// Support: Chrome <=35 - 45+
						// Assign undefined instead of using delete, see Data#remove
						elem[ dataUser.expando ] = undefined;
					}
				}
			}
		}
	} );
	
	jQuery.fn.extend( {
		detach: function( selector ) {
			return remove( this, selector, true );
		},
	
		remove: function( selector ) {
			return remove( this, selector );
		},
	
		text: function( value ) {
			return access( this, function( value ) {
				return value === undefined ?
					jQuery.text( this ) :
					this.empty().each( function() {
						if ( this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9 ) {
							this.textContent = value;
						}
					} );
			}, null, value, arguments.length );
		},
	
		append: function() {
			return domManip( this, arguments, function( elem ) {
				if ( this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9 ) {
					var target = manipulationTarget( this, elem );
					target.appendChild( elem );
				}
			} );
		},
	
		prepend: function() {
			return domManip( this, arguments, function( elem ) {
				if ( this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9 ) {
					var target = manipulationTarget( this, elem );
					target.insertBefore( elem, target.firstChild );
				}
			} );
		},
	
		before: function() {
			return domManip( this, arguments, function( elem ) {
				if ( this.parentNode ) {
					this.parentNode.insertBefore( elem, this );
				}
			} );
		},
	
		after: function() {
			return domManip( this, arguments, function( elem ) {
				if ( this.parentNode ) {
					this.parentNode.insertBefore( elem, this.nextSibling );
				}
			} );
		},
	
		empty: function() {
			var elem,
				i = 0;
	
			for ( ; ( elem = this[ i ] ) != null; i++ ) {
				if ( elem.nodeType === 1 ) {
	
					// Prevent memory leaks
					jQuery.cleanData( getAll( elem, false ) );
	
					// Remove any remaining nodes
					elem.textContent = "";
				}
			}
	
			return this;
		},
	
		clone: function( dataAndEvents, deepDataAndEvents ) {
			dataAndEvents = dataAndEvents == null ? false : dataAndEvents;
			deepDataAndEvents = deepDataAndEvents == null ? dataAndEvents : deepDataAndEvents;
	
			return this.map( function() {
				return jQuery.clone( this, dataAndEvents, deepDataAndEvents );
			} );
		},
	
		html: function( value ) {
			return access( this, function( value ) {
				var elem = this[ 0 ] || {},
					i = 0,
					l = this.length;
	
				if ( value === undefined && elem.nodeType === 1 ) {
					return elem.innerHTML;
				}
	
				// See if we can take a shortcut and just use innerHTML
				if ( typeof value === "string" && !rnoInnerhtml.test( value ) &&
					!wrapMap[ ( rtagName.exec( value ) || [ "", "" ] )[ 1 ].toLowerCase() ] ) {
	
					value = jQuery.htmlPrefilter( value );
	
					try {
						for ( ; i < l; i++ ) {
							elem = this[ i ] || {};
	
							// Remove element nodes and prevent memory leaks
							if ( elem.nodeType === 1 ) {
								jQuery.cleanData( getAll( elem, false ) );
								elem.innerHTML = value;
							}
						}
	
						elem = 0;
	
					// If using innerHTML throws an exception, use the fallback method
					} catch ( e ) {}
				}
	
				if ( elem ) {
					this.empty().append( value );
				}
			}, null, value, arguments.length );
		},
	
		replaceWith: function() {
			var ignored = [];
	
			// Make the changes, replacing each non-ignored context element with the new content
			return domManip( this, arguments, function( elem ) {
				var parent = this.parentNode;
	
				if ( jQuery.inArray( this, ignored ) < 0 ) {
					jQuery.cleanData( getAll( this ) );
					if ( parent ) {
						parent.replaceChild( elem, this );
					}
				}
	
			// Force callback invocation
			}, ignored );
		}
	} );
	
	jQuery.each( {
		appendTo: "append",
		prependTo: "prepend",
		insertBefore: "before",
		insertAfter: "after",
		replaceAll: "replaceWith"
	}, function( name, original ) {
		jQuery.fn[ name ] = function( selector ) {
			var elems,
				ret = [],
				insert = jQuery( selector ),
				last = insert.length - 1,
				i = 0;
	
			for ( ; i <= last; i++ ) {
				elems = i === last ? this : this.clone( true );
				jQuery( insert[ i ] )[ original ]( elems );
	
				// Support: Android <=4.0 only, PhantomJS 1 only
				// .get() because push.apply(_, arraylike) throws on ancient WebKit
				push.apply( ret, elems.get() );
			}
	
			return this.pushStack( ret );
		};
	} );
	var rnumnonpx = new RegExp( "^(" + pnum + ")(?!px)[a-z%]+$", "i" );
	
	var getStyles = function( elem ) {
	
			// Support: IE <=11 only, Firefox <=30 (#15098, #14150)
			// IE throws on elements created in popups
			// FF meanwhile throws on frame elements through "defaultView.getComputedStyle"
			var view = elem.ownerDocument.defaultView;
	
			if ( !view || !view.opener ) {
				view = window;
			}
	
			return view.getComputedStyle( elem );
		};
	
	var rboxStyle = new RegExp( cssExpand.join( "|" ), "i" );
	
	
	
	( function() {
	
		// Executing both pixelPosition & boxSizingReliable tests require only one layout
		// so they're executed at the same time to save the second computation.
		function computeStyleTests() {
	
			// This is a singleton, we need to execute it only once
			if ( !div ) {
				return;
			}
	
			container.style.cssText = "position:absolute;left:-11111px;width:60px;" +
				"margin-top:1px;padding:0;border:0";
			div.style.cssText =
				"position:relative;display:block;box-sizing:border-box;overflow:scroll;" +
				"margin:auto;border:1px;padding:1px;" +
				"width:60%;top:1%";
			documentElement.appendChild( container ).appendChild( div );
	
			var divStyle = window.getComputedStyle( div );
			pixelPositionVal = divStyle.top !== "1%";
	
			// Support: Android 4.0 - 4.3 only, Firefox <=3 - 44
			reliableMarginLeftVal = roundPixelMeasures( divStyle.marginLeft ) === 12;
	
			// Support: Android 4.0 - 4.3 only, Safari <=9.1 - 10.1, iOS <=7.0 - 9.3
			// Some styles come back with percentage values, even though they shouldn't
			div.style.right = "60%";
			pixelBoxStylesVal = roundPixelMeasures( divStyle.right ) === 36;
	
			// Support: IE 9 - 11 only
			// Detect misreporting of content dimensions for box-sizing:border-box elements
			boxSizingReliableVal = roundPixelMeasures( divStyle.width ) === 36;
	
			// Support: IE 9 only
			// Detect overflow:scroll screwiness (gh-3699)
			div.style.position = "absolute";
			scrollboxSizeVal = div.offsetWidth === 36 || "absolute";
	
			documentElement.removeChild( container );
	
			// Nullify the div so it wouldn't be stored in the memory and
			// it will also be a sign that checks already performed
			div = null;
		}
	
		function roundPixelMeasures( measure ) {
			return Math.round( parseFloat( measure ) );
		}
	
		var pixelPositionVal, boxSizingReliableVal, scrollboxSizeVal, pixelBoxStylesVal,
			reliableMarginLeftVal,
			container = document.createElement( "div" ),
			div = document.createElement( "div" );
	
		// Finish early in limited (non-browser) environments
		if ( !div.style ) {
			return;
		}
	
		// Support: IE <=9 - 11 only
		// Style of cloned element affects source element cloned (#8908)
		div.style.backgroundClip = "content-box";
		div.cloneNode( true ).style.backgroundClip = "";
		support.clearCloneStyle = div.style.backgroundClip === "content-box";
	
		jQuery.extend( support, {
			boxSizingReliable: function() {
				computeStyleTests();
				return boxSizingReliableVal;
			},
			pixelBoxStyles: function() {
				computeStyleTests();
				return pixelBoxStylesVal;
			},
			pixelPosition: function() {
				computeStyleTests();
				return pixelPositionVal;
			},
			reliableMarginLeft: function() {
				computeStyleTests();
				return reliableMarginLeftVal;
			},
			scrollboxSize: function() {
				computeStyleTests();
				return scrollboxSizeVal;
			}
		} );
	} )();
	
	
	function curCSS( elem, name, computed ) {
		var width, minWidth, maxWidth, ret,
	
			// Support: Firefox 51+
			// Retrieving style before computed somehow
			// fixes an issue with getting wrong values
			// on detached elements
			style = elem.style;
	
		computed = computed || getStyles( elem );
	
		// getPropertyValue is needed for:
		//   .css('filter') (IE 9 only, #12537)
		//   .css('--customProperty) (#3144)
		if ( computed ) {
			ret = computed.getPropertyValue( name ) || computed[ name ];
	
			if ( ret === "" && !jQuery.contains( elem.ownerDocument, elem ) ) {
				ret = jQuery.style( elem, name );
			}
	
			// A tribute to the "awesome hack by Dean Edwards"
			// Android Browser returns percentage for some values,
			// but width seems to be reliably pixels.
			// This is against the CSSOM draft spec:
			// https://drafts.csswg.org/cssom/#resolved-values
			if ( !support.pixelBoxStyles() && rnumnonpx.test( ret ) && rboxStyle.test( name ) ) {
	
				// Remember the original values
				width = style.width;
				minWidth = style.minWidth;
				maxWidth = style.maxWidth;
	
				// Put in the new values to get a computed value out
				style.minWidth = style.maxWidth = style.width = ret;
				ret = computed.width;
	
				// Revert the changed values
				style.width = width;
				style.minWidth = minWidth;
				style.maxWidth = maxWidth;
			}
		}
	
		return ret !== undefined ?
	
			// Support: IE <=9 - 11 only
			// IE returns zIndex value as an integer.
			ret + "" :
			ret;
	}
	
	
	function addGetHookIf( conditionFn, hookFn ) {
	
		// Define the hook, we'll check on the first run if it's really needed.
		return {
			get: function() {
				if ( conditionFn() ) {
	
					// Hook not needed (or it's not possible to use it due
					// to missing dependency), remove it.
					delete this.get;
					return;
				}
	
				// Hook needed; redefine it so that the support test is not executed again.
				return ( this.get = hookFn ).apply( this, arguments );
			}
		};
	}
	
	
	var
	
		// Swappable if display is none or starts with table
		// except "table", "table-cell", or "table-caption"
		// See here for display values: https://developer.mozilla.org/en-US/docs/CSS/display
		rdisplayswap = /^(none|table(?!-c[ea]).+)/,
		rcustomProp = /^--/,
		cssShow = { position: "absolute", visibility: "hidden", display: "block" },
		cssNormalTransform = {
			letterSpacing: "0",
			fontWeight: "400"
		},
	
		cssPrefixes = [ "Webkit", "Moz", "ms" ],
		emptyStyle = document.createElement( "div" ).style;
	
	// Return a css property mapped to a potentially vendor prefixed property
	function vendorPropName( name ) {
	
		// Shortcut for names that are not vendor prefixed
		if ( name in emptyStyle ) {
			return name;
		}
	
		// Check for vendor prefixed names
		var capName = name[ 0 ].toUpperCase() + name.slice( 1 ),
			i = cssPrefixes.length;
	
		while ( i-- ) {
			name = cssPrefixes[ i ] + capName;
			if ( name in emptyStyle ) {
				return name;
			}
		}
	}
	
	// Return a property mapped along what jQuery.cssProps suggests or to
	// a vendor prefixed property.
	function finalPropName( name ) {
		var ret = jQuery.cssProps[ name ];
		if ( !ret ) {
			ret = jQuery.cssProps[ name ] = vendorPropName( name ) || name;
		}
		return ret;
	}
	
	function setPositiveNumber( elem, value, subtract ) {
	
		// Any relative (+/-) values have already been
		// normalized at this point
		var matches = rcssNum.exec( value );
		return matches ?
	
			// Guard against undefined "subtract", e.g., when used as in cssHooks
			Math.max( 0, matches[ 2 ] - ( subtract || 0 ) ) + ( matches[ 3 ] || "px" ) :
			value;
	}
	
	function boxModelAdjustment( elem, dimension, box, isBorderBox, styles, computedVal ) {
		var i = dimension === "width" ? 1 : 0,
			extra = 0,
			delta = 0;
	
		// Adjustment may not be necessary
		if ( box === ( isBorderBox ? "border" : "content" ) ) {
			return 0;
		}
	
		for ( ; i < 4; i += 2 ) {
	
			// Both box models exclude margin
			if ( box === "margin" ) {
				delta += jQuery.css( elem, box + cssExpand[ i ], true, styles );
			}
	
			// If we get here with a content-box, we're seeking "padding" or "border" or "margin"
			if ( !isBorderBox ) {
	
				// Add padding
				delta += jQuery.css( elem, "padding" + cssExpand[ i ], true, styles );
	
				// For "border" or "margin", add border
				if ( box !== "padding" ) {
					delta += jQuery.css( elem, "border" + cssExpand[ i ] + "Width", true, styles );
	
				// But still keep track of it otherwise
				} else {
					extra += jQuery.css( elem, "border" + cssExpand[ i ] + "Width", true, styles );
				}
	
			// If we get here with a border-box (content + padding + border), we're seeking "content" or
			// "padding" or "margin"
			} else {
	
				// For "content", subtract padding
				if ( box === "content" ) {
					delta -= jQuery.css( elem, "padding" + cssExpand[ i ], true, styles );
				}
	
				// For "content" or "padding", subtract border
				if ( box !== "margin" ) {
					delta -= jQuery.css( elem, "border" + cssExpand[ i ] + "Width", true, styles );
				}
			}
		}
	
		// Account for positive content-box scroll gutter when requested by providing computedVal
		if ( !isBorderBox && computedVal >= 0 ) {
	
			// offsetWidth/offsetHeight is a rounded sum of content, padding, scroll gutter, and border
			// Assuming integer scroll gutter, subtract the rest and round down
			delta += Math.max( 0, Math.ceil(
				elem[ "offset" + dimension[ 0 ].toUpperCase() + dimension.slice( 1 ) ] -
				computedVal -
				delta -
				extra -
				0.5
			) );
		}
	
		return delta;
	}
	
	function getWidthOrHeight( elem, dimension, extra ) {
	
		// Start with computed style
		var styles = getStyles( elem ),
			val = curCSS( elem, dimension, styles ),
			isBorderBox = jQuery.css( elem, "boxSizing", false, styles ) === "border-box",
			valueIsBorderBox = isBorderBox;
	
		// Support: Firefox <=54
		// Return a confounding non-pixel value or feign ignorance, as appropriate.
		if ( rnumnonpx.test( val ) ) {
			if ( !extra ) {
				return val;
			}
			val = "auto";
		}
	
		// Check for style in case a browser which returns unreliable values
		// for getComputedStyle silently falls back to the reliable elem.style
		valueIsBorderBox = valueIsBorderBox &&
			( support.boxSizingReliable() || val === elem.style[ dimension ] );
	
		// Fall back to offsetWidth/offsetHeight when value is "auto"
		// This happens for inline elements with no explicit setting (gh-3571)
		// Support: Android <=4.1 - 4.3 only
		// Also use offsetWidth/offsetHeight for misreported inline dimensions (gh-3602)
		if ( val === "auto" ||
			!parseFloat( val ) && jQuery.css( elem, "display", false, styles ) === "inline" ) {
	
			val = elem[ "offset" + dimension[ 0 ].toUpperCase() + dimension.slice( 1 ) ];
	
			// offsetWidth/offsetHeight provide border-box values
			valueIsBorderBox = true;
		}
	
		// Normalize "" and auto
		val = parseFloat( val ) || 0;
	
		// Adjust for the element's box model
		return ( val +
			boxModelAdjustment(
				elem,
				dimension,
				extra || ( isBorderBox ? "border" : "content" ),
				valueIsBorderBox,
				styles,
	
				// Provide the current computed size to request scroll gutter calculation (gh-3589)
				val
			)
		) + "px";
	}
	
	jQuery.extend( {
	
		// Add in style property hooks for overriding the default
		// behavior of getting and setting a style property
		cssHooks: {
			opacity: {
				get: function( elem, computed ) {
					if ( computed ) {
	
						// We should always get a number back from opacity
						var ret = curCSS( elem, "opacity" );
						return ret === "" ? "1" : ret;
					}
				}
			}
		},
	
		// Don't automatically add "px" to these possibly-unitless properties
		cssNumber: {
			"animationIterationCount": true,
			"columnCount": true,
			"fillOpacity": true,
			"flexGrow": true,
			"flexShrink": true,
			"fontWeight": true,
			"lineHeight": true,
			"opacity": true,
			"order": true,
			"orphans": true,
			"widows": true,
			"zIndex": true,
			"zoom": true
		},
	
		// Add in properties whose names you wish to fix before
		// setting or getting the value
		cssProps: {},
	
		// Get and set the style property on a DOM Node
		style: function( elem, name, value, extra ) {
	
			// Don't set styles on text and comment nodes
			if ( !elem || elem.nodeType === 3 || elem.nodeType === 8 || !elem.style ) {
				return;
			}
	
			// Make sure that we're working with the right name
			var ret, type, hooks,
				origName = camelCase( name ),
				isCustomProp = rcustomProp.test( name ),
				style = elem.style;
	
			// Make sure that we're working with the right name. We don't
			// want to query the value if it is a CSS custom property
			// since they are user-defined.
			if ( !isCustomProp ) {
				name = finalPropName( origName );
			}
	
			// Gets hook for the prefixed version, then unprefixed version
			hooks = jQuery.cssHooks[ name ] || jQuery.cssHooks[ origName ];
	
			// Check if we're setting a value
			if ( value !== undefined ) {
				type = typeof value;
	
				// Convert "+=" or "-=" to relative numbers (#7345)
				if ( type === "string" && ( ret = rcssNum.exec( value ) ) && ret[ 1 ] ) {
					value = adjustCSS( elem, name, ret );
	
					// Fixes bug #9237
					type = "number";
				}
	
				// Make sure that null and NaN values aren't set (#7116)
				if ( value == null || value !== value ) {
					return;
				}
	
				// If a number was passed in, add the unit (except for certain CSS properties)
				if ( type === "number" ) {
					value += ret && ret[ 3 ] || ( jQuery.cssNumber[ origName ] ? "" : "px" );
				}
	
				// background-* props affect original clone's values
				if ( !support.clearCloneStyle && value === "" && name.indexOf( "background" ) === 0 ) {
					style[ name ] = "inherit";
				}
	
				// If a hook was provided, use that value, otherwise just set the specified value
				if ( !hooks || !( "set" in hooks ) ||
					( value = hooks.set( elem, value, extra ) ) !== undefined ) {
	
					if ( isCustomProp ) {
						style.setProperty( name, value );
					} else {
						style[ name ] = value;
					}
				}
	
			} else {
	
				// If a hook was provided get the non-computed value from there
				if ( hooks && "get" in hooks &&
					( ret = hooks.get( elem, false, extra ) ) !== undefined ) {
	
					return ret;
				}
	
				// Otherwise just get the value from the style object
				return style[ name ];
			}
		},
	
		css: function( elem, name, extra, styles ) {
			var val, num, hooks,
				origName = camelCase( name ),
				isCustomProp = rcustomProp.test( name );
	
			// Make sure that we're working with the right name. We don't
			// want to modify the value if it is a CSS custom property
			// since they are user-defined.
			if ( !isCustomProp ) {
				name = finalPropName( origName );
			}
	
			// Try prefixed name followed by the unprefixed name
			hooks = jQuery.cssHooks[ name ] || jQuery.cssHooks[ origName ];
	
			// If a hook was provided get the computed value from there
			if ( hooks && "get" in hooks ) {
				val = hooks.get( elem, true, extra );
			}
	
			// Otherwise, if a way to get the computed value exists, use that
			if ( val === undefined ) {
				val = curCSS( elem, name, styles );
			}
	
			// Convert "normal" to computed value
			if ( val === "normal" && name in cssNormalTransform ) {
				val = cssNormalTransform[ name ];
			}
	
			// Make numeric if forced or a qualifier was provided and val looks numeric
			if ( extra === "" || extra ) {
				num = parseFloat( val );
				return extra === true || isFinite( num ) ? num || 0 : val;
			}
	
			return val;
		}
	} );
	
	jQuery.each( [ "height", "width" ], function( i, dimension ) {
		jQuery.cssHooks[ dimension ] = {
			get: function( elem, computed, extra ) {
				if ( computed ) {
	
					// Certain elements can have dimension info if we invisibly show them
					// but it must have a current display style that would benefit
					return rdisplayswap.test( jQuery.css( elem, "display" ) ) &&
	
						// Support: Safari 8+
						// Table columns in Safari have non-zero offsetWidth & zero
						// getBoundingClientRect().width unless display is changed.
						// Support: IE <=11 only
						// Running getBoundingClientRect on a disconnected node
						// in IE throws an error.
						( !elem.getClientRects().length || !elem.getBoundingClientRect().width ) ?
							swap( elem, cssShow, function() {
								return getWidthOrHeight( elem, dimension, extra );
							} ) :
							getWidthOrHeight( elem, dimension, extra );
				}
			},
	
			set: function( elem, value, extra ) {
				var matches,
					styles = getStyles( elem ),
					isBorderBox = jQuery.css( elem, "boxSizing", false, styles ) === "border-box",
					subtract = extra && boxModelAdjustment(
						elem,
						dimension,
						extra,
						isBorderBox,
						styles
					);
	
				// Account for unreliable border-box dimensions by comparing offset* to computed and
				// faking a content-box to get border and padding (gh-3699)
				if ( isBorderBox && support.scrollboxSize() === styles.position ) {
					subtract -= Math.ceil(
						elem[ "offset" + dimension[ 0 ].toUpperCase() + dimension.slice( 1 ) ] -
						parseFloat( styles[ dimension ] ) -
						boxModelAdjustment( elem, dimension, "border", false, styles ) -
						0.5
					);
				}
	
				// Convert to pixels if value adjustment is needed
				if ( subtract && ( matches = rcssNum.exec( value ) ) &&
					( matches[ 3 ] || "px" ) !== "px" ) {
	
					elem.style[ dimension ] = value;
					value = jQuery.css( elem, dimension );
				}
	
				return setPositiveNumber( elem, value, subtract );
			}
		};
	} );
	
	jQuery.cssHooks.marginLeft = addGetHookIf( support.reliableMarginLeft,
		function( elem, computed ) {
			if ( computed ) {
				return ( parseFloat( curCSS( elem, "marginLeft" ) ) ||
					elem.getBoundingClientRect().left -
						swap( elem, { marginLeft: 0 }, function() {
							return elem.getBoundingClientRect().left;
						} )
					) + "px";
			}
		}
	);
	
	// These hooks are used by animate to expand properties
	jQuery.each( {
		margin: "",
		padding: "",
		border: "Width"
	}, function( prefix, suffix ) {
		jQuery.cssHooks[ prefix + suffix ] = {
			expand: function( value ) {
				var i = 0,
					expanded = {},
	
					// Assumes a single number if not a string
					parts = typeof value === "string" ? value.split( " " ) : [ value ];
	
				for ( ; i < 4; i++ ) {
					expanded[ prefix + cssExpand[ i ] + suffix ] =
						parts[ i ] || parts[ i - 2 ] || parts[ 0 ];
				}
	
				return expanded;
			}
		};
	
		if ( prefix !== "margin" ) {
			jQuery.cssHooks[ prefix + suffix ].set = setPositiveNumber;
		}
	} );
	
	jQuery.fn.extend( {
		css: function( name, value ) {
			return access( this, function( elem, name, value ) {
				var styles, len,
					map = {},
					i = 0;
	
				if ( Array.isArray( name ) ) {
					styles = getStyles( elem );
					len = name.length;
	
					for ( ; i < len; i++ ) {
						map[ name[ i ] ] = jQuery.css( elem, name[ i ], false, styles );
					}
	
					return map;
				}
	
				return value !== undefined ?
					jQuery.style( elem, name, value ) :
					jQuery.css( elem, name );
			}, name, value, arguments.length > 1 );
		}
	} );
	
	
	function Tween( elem, options, prop, end, easing ) {
		return new Tween.prototype.init( elem, options, prop, end, easing );
	}
	jQuery.Tween = Tween;
	
	Tween.prototype = {
		constructor: Tween,
		init: function( elem, options, prop, end, easing, unit ) {
			this.elem = elem;
			this.prop = prop;
			this.easing = easing || jQuery.easing._default;
			this.options = options;
			this.start = this.now = this.cur();
			this.end = end;
			this.unit = unit || ( jQuery.cssNumber[ prop ] ? "" : "px" );
		},
		cur: function() {
			var hooks = Tween.propHooks[ this.prop ];
	
			return hooks && hooks.get ?
				hooks.get( this ) :
				Tween.propHooks._default.get( this );
		},
		run: function( percent ) {
			var eased,
				hooks = Tween.propHooks[ this.prop ];
	
			if ( this.options.duration ) {
				this.pos = eased = jQuery.easing[ this.easing ](
					percent, this.options.duration * percent, 0, 1, this.options.duration
				);
			} else {
				this.pos = eased = percent;
			}
			this.now = ( this.end - this.start ) * eased + this.start;
	
			if ( this.options.step ) {
				this.options.step.call( this.elem, this.now, this );
			}
	
			if ( hooks && hooks.set ) {
				hooks.set( this );
			} else {
				Tween.propHooks._default.set( this );
			}
			return this;
		}
	};
	
	Tween.prototype.init.prototype = Tween.prototype;
	
	Tween.propHooks = {
		_default: {
			get: function( tween ) {
				var result;
	
				// Use a property on the element directly when it is not a DOM element,
				// or when there is no matching style property that exists.
				if ( tween.elem.nodeType !== 1 ||
					tween.elem[ tween.prop ] != null && tween.elem.style[ tween.prop ] == null ) {
					return tween.elem[ tween.prop ];
				}
	
				// Passing an empty string as a 3rd parameter to .css will automatically
				// attempt a parseFloat and fallback to a string if the parse fails.
				// Simple values such as "10px" are parsed to Float;
				// complex values such as "rotate(1rad)" are returned as-is.
				result = jQuery.css( tween.elem, tween.prop, "" );
	
				// Empty strings, null, undefined and "auto" are converted to 0.
				return !result || result === "auto" ? 0 : result;
			},
			set: function( tween ) {
	
				// Use step hook for back compat.
				// Use cssHook if its there.
				// Use .style if available and use plain properties where available.
				if ( jQuery.fx.step[ tween.prop ] ) {
					jQuery.fx.step[ tween.prop ]( tween );
				} else if ( tween.elem.nodeType === 1 &&
					( tween.elem.style[ jQuery.cssProps[ tween.prop ] ] != null ||
						jQuery.cssHooks[ tween.prop ] ) ) {
					jQuery.style( tween.elem, tween.prop, tween.now + tween.unit );
				} else {
					tween.elem[ tween.prop ] = tween.now;
				}
			}
		}
	};
	
	// Support: IE <=9 only
	// Panic based approach to setting things on disconnected nodes
	Tween.propHooks.scrollTop = Tween.propHooks.scrollLeft = {
		set: function( tween ) {
			if ( tween.elem.nodeType && tween.elem.parentNode ) {
				tween.elem[ tween.prop ] = tween.now;
			}
		}
	};
	
	jQuery.easing = {
		linear: function( p ) {
			return p;
		},
		swing: function( p ) {
			return 0.5 - Math.cos( p * Math.PI ) / 2;
		},
		_default: "swing"
	};
	
	jQuery.fx = Tween.prototype.init;
	
	// Back compat <1.8 extension point
	jQuery.fx.step = {};
	
	
	
	
	var
		fxNow, inProgress,
		rfxtypes = /^(?:toggle|show|hide)$/,
		rrun = /queueHooks$/;
	
	function schedule() {
		if ( inProgress ) {
			if ( document.hidden === false && window.requestAnimationFrame ) {
				window.requestAnimationFrame( schedule );
			} else {
				window.setTimeout( schedule, jQuery.fx.interval );
			}
	
			jQuery.fx.tick();
		}
	}
	
	// Animations created synchronously will run synchronously
	function createFxNow() {
		window.setTimeout( function() {
			fxNow = undefined;
		} );
		return ( fxNow = Date.now() );
	}
	
	// Generate parameters to create a standard animation
	function genFx( type, includeWidth ) {
		var which,
			i = 0,
			attrs = { height: type };
	
		// If we include width, step value is 1 to do all cssExpand values,
		// otherwise step value is 2 to skip over Left and Right
		includeWidth = includeWidth ? 1 : 0;
		for ( ; i < 4; i += 2 - includeWidth ) {
			which = cssExpand[ i ];
			attrs[ "margin" + which ] = attrs[ "padding" + which ] = type;
		}
	
		if ( includeWidth ) {
			attrs.opacity = attrs.width = type;
		}
	
		return attrs;
	}
	
	function createTween( value, prop, animation ) {
		var tween,
			collection = ( Animation.tweeners[ prop ] || [] ).concat( Animation.tweeners[ "*" ] ),
			index = 0,
			length = collection.length;
		for ( ; index < length; index++ ) {
			if ( ( tween = collection[ index ].call( animation, prop, value ) ) ) {
	
				// We're done with this property
				return tween;
			}
		}
	}
	
	function defaultPrefilter( elem, props, opts ) {
		var prop, value, toggle, hooks, oldfire, propTween, restoreDisplay, display,
			isBox = "width" in props || "height" in props,
			anim = this,
			orig = {},
			style = elem.style,
			hidden = elem.nodeType && isHiddenWithinTree( elem ),
			dataShow = dataPriv.get( elem, "fxshow" );
	
		// Queue-skipping animations hijack the fx hooks
		if ( !opts.queue ) {
			hooks = jQuery._queueHooks( elem, "fx" );
			if ( hooks.unqueued == null ) {
				hooks.unqueued = 0;
				oldfire = hooks.empty.fire;
				hooks.empty.fire = function() {
					if ( !hooks.unqueued ) {
						oldfire();
					}
				};
			}
			hooks.unqueued++;
	
			anim.always( function() {
	
				// Ensure the complete handler is called before this completes
				anim.always( function() {
					hooks.unqueued--;
					if ( !jQuery.queue( elem, "fx" ).length ) {
						hooks.empty.fire();
					}
				} );
			} );
		}
	
		// Detect show/hide animations
		for ( prop in props ) {
			value = props[ prop ];
			if ( rfxtypes.test( value ) ) {
				delete props[ prop ];
				toggle = toggle || value === "toggle";
				if ( value === ( hidden ? "hide" : "show" ) ) {
	
					// Pretend to be hidden if this is a "show" and
					// there is still data from a stopped show/hide
					if ( value === "show" && dataShow && dataShow[ prop ] !== undefined ) {
						hidden = true;
	
					// Ignore all other no-op show/hide data
					} else {
						continue;
					}
				}
				orig[ prop ] = dataShow && dataShow[ prop ] || jQuery.style( elem, prop );
			}
		}
	
		// Bail out if this is a no-op like .hide().hide()
		propTween = !jQuery.isEmptyObject( props );
		if ( !propTween && jQuery.isEmptyObject( orig ) ) {
			return;
		}
	
		// Restrict "overflow" and "display" styles during box animations
		if ( isBox && elem.nodeType === 1 ) {
	
			// Support: IE <=9 - 11, Edge 12 - 15
			// Record all 3 overflow attributes because IE does not infer the shorthand
			// from identically-valued overflowX and overflowY and Edge just mirrors
			// the overflowX value there.
			opts.overflow = [ style.overflow, style.overflowX, style.overflowY ];
	
			// Identify a display type, preferring old show/hide data over the CSS cascade
			restoreDisplay = dataShow && dataShow.display;
			if ( restoreDisplay == null ) {
				restoreDisplay = dataPriv.get( elem, "display" );
			}
			display = jQuery.css( elem, "display" );
			if ( display === "none" ) {
				if ( restoreDisplay ) {
					display = restoreDisplay;
				} else {
	
					// Get nonempty value(s) by temporarily forcing visibility
					showHide( [ elem ], true );
					restoreDisplay = elem.style.display || restoreDisplay;
					display = jQuery.css( elem, "display" );
					showHide( [ elem ] );
				}
			}
	
			// Animate inline elements as inline-block
			if ( display === "inline" || display === "inline-block" && restoreDisplay != null ) {
				if ( jQuery.css( elem, "float" ) === "none" ) {
	
					// Restore the original display value at the end of pure show/hide animations
					if ( !propTween ) {
						anim.done( function() {
							style.display = restoreDisplay;
						} );
						if ( restoreDisplay == null ) {
							display = style.display;
							restoreDisplay = display === "none" ? "" : display;
						}
					}
					style.display = "inline-block";
				}
			}
		}
	
		if ( opts.overflow ) {
			style.overflow = "hidden";
			anim.always( function() {
				style.overflow = opts.overflow[ 0 ];
				style.overflowX = opts.overflow[ 1 ];
				style.overflowY = opts.overflow[ 2 ];
			} );
		}
	
		// Implement show/hide animations
		propTween = false;
		for ( prop in orig ) {
	
			// General show/hide setup for this element animation
			if ( !propTween ) {
				if ( dataShow ) {
					if ( "hidden" in dataShow ) {
						hidden = dataShow.hidden;
					}
				} else {
					dataShow = dataPriv.access( elem, "fxshow", { display: restoreDisplay } );
				}
	
				// Store hidden/visible for toggle so `.stop().toggle()` "reverses"
				if ( toggle ) {
					dataShow.hidden = !hidden;
				}
	
				// Show elements before animating them
				if ( hidden ) {
					showHide( [ elem ], true );
				}
	
				/* eslint-disable no-loop-func */
	
				anim.done( function() {
	
				/* eslint-enable no-loop-func */
	
					// The final step of a "hide" animation is actually hiding the element
					if ( !hidden ) {
						showHide( [ elem ] );
					}
					dataPriv.remove( elem, "fxshow" );
					for ( prop in orig ) {
						jQuery.style( elem, prop, orig[ prop ] );
					}
				} );
			}
	
			// Per-property setup
			propTween = createTween( hidden ? dataShow[ prop ] : 0, prop, anim );
			if ( !( prop in dataShow ) ) {
				dataShow[ prop ] = propTween.start;
				if ( hidden ) {
					propTween.end = propTween.start;
					propTween.start = 0;
				}
			}
		}
	}
	
	function propFilter( props, specialEasing ) {
		var index, name, easing, value, hooks;
	
		// camelCase, specialEasing and expand cssHook pass
		for ( index in props ) {
			name = camelCase( index );
			easing = specialEasing[ name ];
			value = props[ index ];
			if ( Array.isArray( value ) ) {
				easing = value[ 1 ];
				value = props[ index ] = value[ 0 ];
			}
	
			if ( index !== name ) {
				props[ name ] = value;
				delete props[ index ];
			}
	
			hooks = jQuery.cssHooks[ name ];
			if ( hooks && "expand" in hooks ) {
				value = hooks.expand( value );
				delete props[ name ];
	
				// Not quite $.extend, this won't overwrite existing keys.
				// Reusing 'index' because we have the correct "name"
				for ( index in value ) {
					if ( !( index in props ) ) {
						props[ index ] = value[ index ];
						specialEasing[ index ] = easing;
					}
				}
			} else {
				specialEasing[ name ] = easing;
			}
		}
	}
	
	function Animation( elem, properties, options ) {
		var result,
			stopped,
			index = 0,
			length = Animation.prefilters.length,
			deferred = jQuery.Deferred().always( function() {
	
				// Don't match elem in the :animated selector
				delete tick.elem;
			} ),
			tick = function() {
				if ( stopped ) {
					return false;
				}
				var currentTime = fxNow || createFxNow(),
					remaining = Math.max( 0, animation.startTime + animation.duration - currentTime ),
	
					// Support: Android 2.3 only
					// Archaic crash bug won't allow us to use `1 - ( 0.5 || 0 )` (#12497)
					temp = remaining / animation.duration || 0,
					percent = 1 - temp,
					index = 0,
					length = animation.tweens.length;
	
				for ( ; index < length; index++ ) {
					animation.tweens[ index ].run( percent );
				}
	
				deferred.notifyWith( elem, [ animation, percent, remaining ] );
	
				// If there's more to do, yield
				if ( percent < 1 && length ) {
					return remaining;
				}
	
				// If this was an empty animation, synthesize a final progress notification
				if ( !length ) {
					deferred.notifyWith( elem, [ animation, 1, 0 ] );
				}
	
				// Resolve the animation and report its conclusion
				deferred.resolveWith( elem, [ animation ] );
				return false;
			},
			animation = deferred.promise( {
				elem: elem,
				props: jQuery.extend( {}, properties ),
				opts: jQuery.extend( true, {
					specialEasing: {},
					easing: jQuery.easing._default
				}, options ),
				originalProperties: properties,
				originalOptions: options,
				startTime: fxNow || createFxNow(),
				duration: options.duration,
				tweens: [],
				createTween: function( prop, end ) {
					var tween = jQuery.Tween( elem, animation.opts, prop, end,
							animation.opts.specialEasing[ prop ] || animation.opts.easing );
					animation.tweens.push( tween );
					return tween;
				},
				stop: function( gotoEnd ) {
					var index = 0,
	
						// If we are going to the end, we want to run all the tweens
						// otherwise we skip this part
						length = gotoEnd ? animation.tweens.length : 0;
					if ( stopped ) {
						return this;
					}
					stopped = true;
					for ( ; index < length; index++ ) {
						animation.tweens[ index ].run( 1 );
					}
	
					// Resolve when we played the last frame; otherwise, reject
					if ( gotoEnd ) {
						deferred.notifyWith( elem, [ animation, 1, 0 ] );
						deferred.resolveWith( elem, [ animation, gotoEnd ] );
					} else {
						deferred.rejectWith( elem, [ animation, gotoEnd ] );
					}
					return this;
				}
			} ),
			props = animation.props;
	
		propFilter( props, animation.opts.specialEasing );
	
		for ( ; index < length; index++ ) {
			result = Animation.prefilters[ index ].call( animation, elem, props, animation.opts );
			if ( result ) {
				if ( isFunction( result.stop ) ) {
					jQuery._queueHooks( animation.elem, animation.opts.queue ).stop =
						result.stop.bind( result );
				}
				return result;
			}
		}
	
		jQuery.map( props, createTween, animation );
	
		if ( isFunction( animation.opts.start ) ) {
			animation.opts.start.call( elem, animation );
		}
	
		// Attach callbacks from options
		animation
			.progress( animation.opts.progress )
			.done( animation.opts.done, animation.opts.complete )
			.fail( animation.opts.fail )
			.always( animation.opts.always );
	
		jQuery.fx.timer(
			jQuery.extend( tick, {
				elem: elem,
				anim: animation,
				queue: animation.opts.queue
			} )
		);
	
		return animation;
	}
	
	jQuery.Animation = jQuery.extend( Animation, {
	
		tweeners: {
			"*": [ function( prop, value ) {
				var tween = this.createTween( prop, value );
				adjustCSS( tween.elem, prop, rcssNum.exec( value ), tween );
				return tween;
			} ]
		},
	
		tweener: function( props, callback ) {
			if ( isFunction( props ) ) {
				callback = props;
				props = [ "*" ];
			} else {
				props = props.match( rnothtmlwhite );
			}
	
			var prop,
				index = 0,
				length = props.length;
	
			for ( ; index < length; index++ ) {
				prop = props[ index ];
				Animation.tweeners[ prop ] = Animation.tweeners[ prop ] || [];
				Animation.tweeners[ prop ].unshift( callback );
			}
		},
	
		prefilters: [ defaultPrefilter ],
	
		prefilter: function( callback, prepend ) {
			if ( prepend ) {
				Animation.prefilters.unshift( callback );
			} else {
				Animation.prefilters.push( callback );
			}
		}
	} );
	
	jQuery.speed = function( speed, easing, fn ) {
		var opt = speed && typeof speed === "object" ? jQuery.extend( {}, speed ) : {
			complete: fn || !fn && easing ||
				isFunction( speed ) && speed,
			duration: speed,
			easing: fn && easing || easing && !isFunction( easing ) && easing
		};
	
		// Go to the end state if fx are off
		if ( jQuery.fx.off ) {
			opt.duration = 0;
	
		} else {
			if ( typeof opt.duration !== "number" ) {
				if ( opt.duration in jQuery.fx.speeds ) {
					opt.duration = jQuery.fx.speeds[ opt.duration ];
	
				} else {
					opt.duration = jQuery.fx.speeds._default;
				}
			}
		}
	
		// Normalize opt.queue - true/undefined/null -> "fx"
		if ( opt.queue == null || opt.queue === true ) {
			opt.queue = "fx";
		}
	
		// Queueing
		opt.old = opt.complete;
	
		opt.complete = function() {
			if ( isFunction( opt.old ) ) {
				opt.old.call( this );
			}
	
			if ( opt.queue ) {
				jQuery.dequeue( this, opt.queue );
			}
		};
	
		return opt;
	};
	
	jQuery.fn.extend( {
		fadeTo: function( speed, to, easing, callback ) {
	
			// Show any hidden elements after setting opacity to 0
			return this.filter( isHiddenWithinTree ).css( "opacity", 0 ).show()
	
				// Animate to the value specified
				.end().animate( { opacity: to }, speed, easing, callback );
		},
		animate: function( prop, speed, easing, callback ) {
			var empty = jQuery.isEmptyObject( prop ),
				optall = jQuery.speed( speed, easing, callback ),
				doAnimation = function() {
	
					// Operate on a copy of prop so per-property easing won't be lost
					var anim = Animation( this, jQuery.extend( {}, prop ), optall );
	
					// Empty animations, or finishing resolves immediately
					if ( empty || dataPriv.get( this, "finish" ) ) {
						anim.stop( true );
					}
				};
				doAnimation.finish = doAnimation;
	
			return empty || optall.queue === false ?
				this.each( doAnimation ) :
				this.queue( optall.queue, doAnimation );
		},
		stop: function( type, clearQueue, gotoEnd ) {
			var stopQueue = function( hooks ) {
				var stop = hooks.stop;
				delete hooks.stop;
				stop( gotoEnd );
			};
	
			if ( typeof type !== "string" ) {
				gotoEnd = clearQueue;
				clearQueue = type;
				type = undefined;
			}
			if ( clearQueue && type !== false ) {
				this.queue( type || "fx", [] );
			}
	
			return this.each( function() {
				var dequeue = true,
					index = type != null && type + "queueHooks",
					timers = jQuery.timers,
					data = dataPriv.get( this );
	
				if ( index ) {
					if ( data[ index ] && data[ index ].stop ) {
						stopQueue( data[ index ] );
					}
				} else {
					for ( index in data ) {
						if ( data[ index ] && data[ index ].stop && rrun.test( index ) ) {
							stopQueue( data[ index ] );
						}
					}
				}
	
				for ( index = timers.length; index--; ) {
					if ( timers[ index ].elem === this &&
						( type == null || timers[ index ].queue === type ) ) {
	
						timers[ index ].anim.stop( gotoEnd );
						dequeue = false;
						timers.splice( index, 1 );
					}
				}
	
				// Start the next in the queue if the last step wasn't forced.
				// Timers currently will call their complete callbacks, which
				// will dequeue but only if they were gotoEnd.
				if ( dequeue || !gotoEnd ) {
					jQuery.dequeue( this, type );
				}
			} );
		},
		finish: function( type ) {
			if ( type !== false ) {
				type = type || "fx";
			}
			return this.each( function() {
				var index,
					data = dataPriv.get( this ),
					queue = data[ type + "queue" ],
					hooks = data[ type + "queueHooks" ],
					timers = jQuery.timers,
					length = queue ? queue.length : 0;
	
				// Enable finishing flag on private data
				data.finish = true;
	
				// Empty the queue first
				jQuery.queue( this, type, [] );
	
				if ( hooks && hooks.stop ) {
					hooks.stop.call( this, true );
				}
	
				// Look for any active animations, and finish them
				for ( index = timers.length; index--; ) {
					if ( timers[ index ].elem === this && timers[ index ].queue === type ) {
						timers[ index ].anim.stop( true );
						timers.splice( index, 1 );
					}
				}
	
				// Look for any animations in the old queue and finish them
				for ( index = 0; index < length; index++ ) {
					if ( queue[ index ] && queue[ index ].finish ) {
						queue[ index ].finish.call( this );
					}
				}
	
				// Turn off finishing flag
				delete data.finish;
			} );
		}
	} );
	
	jQuery.each( [ "toggle", "show", "hide" ], function( i, name ) {
		var cssFn = jQuery.fn[ name ];
		jQuery.fn[ name ] = function( speed, easing, callback ) {
			return speed == null || typeof speed === "boolean" ?
				cssFn.apply( this, arguments ) :
				this.animate( genFx( name, true ), speed, easing, callback );
		};
	} );
	
	// Generate shortcuts for custom animations
	jQuery.each( {
		slideDown: genFx( "show" ),
		slideUp: genFx( "hide" ),
		slideToggle: genFx( "toggle" ),
		fadeIn: { opacity: "show" },
		fadeOut: { opacity: "hide" },
		fadeToggle: { opacity: "toggle" }
	}, function( name, props ) {
		jQuery.fn[ name ] = function( speed, easing, callback ) {
			return this.animate( props, speed, easing, callback );
		};
	} );
	
	jQuery.timers = [];
	jQuery.fx.tick = function() {
		var timer,
			i = 0,
			timers = jQuery.timers;
	
		fxNow = Date.now();
	
		for ( ; i < timers.length; i++ ) {
			timer = timers[ i ];
	
			// Run the timer and safely remove it when done (allowing for external removal)
			if ( !timer() && timers[ i ] === timer ) {
				timers.splice( i--, 1 );
			}
		}
	
		if ( !timers.length ) {
			jQuery.fx.stop();
		}
		fxNow = undefined;
	};
	
	jQuery.fx.timer = function( timer ) {
		jQuery.timers.push( timer );
		jQuery.fx.start();
	};
	
	jQuery.fx.interval = 13;
	jQuery.fx.start = function() {
		if ( inProgress ) {
			return;
		}
	
		inProgress = true;
		schedule();
	};
	
	jQuery.fx.stop = function() {
		inProgress = null;
	};
	
	jQuery.fx.speeds = {
		slow: 600,
		fast: 200,
	
		// Default speed
		_default: 400
	};
	
	
	// Based off of the plugin by Clint Helfers, with permission.
	// https://web.archive.org/web/20100324014747/http://blindsignals.com/index.php/2009/07/jquery-delay/
	jQuery.fn.delay = function( time, type ) {
		time = jQuery.fx ? jQuery.fx.speeds[ time ] || time : time;
		type = type || "fx";
	
		return this.queue( type, function( next, hooks ) {
			var timeout = window.setTimeout( next, time );
			hooks.stop = function() {
				window.clearTimeout( timeout );
			};
		} );
	};
	
	
	( function() {
		var input = document.createElement( "input" ),
			select = document.createElement( "select" ),
			opt = select.appendChild( document.createElement( "option" ) );
	
		input.type = "checkbox";
	
		// Support: Android <=4.3 only
		// Default value for a checkbox should be "on"
		support.checkOn = input.value !== "";
	
		// Support: IE <=11 only
		// Must access selectedIndex to make default options select
		support.optSelected = opt.selected;
	
		// Support: IE <=11 only
		// An input loses its value after becoming a radio
		input = document.createElement( "input" );
		input.value = "t";
		input.type = "radio";
		support.radioValue = input.value === "t";
	} )();
	
	
	var boolHook,
		attrHandle = jQuery.expr.attrHandle;
	
	jQuery.fn.extend( {
		attr: function( name, value ) {
			return access( this, jQuery.attr, name, value, arguments.length > 1 );
		},
	
		removeAttr: function( name ) {
			return this.each( function() {
				jQuery.removeAttr( this, name );
			} );
		}
	} );
	
	jQuery.extend( {
		attr: function( elem, name, value ) {
			var ret, hooks,
				nType = elem.nodeType;
	
			// Don't get/set attributes on text, comment and attribute nodes
			if ( nType === 3 || nType === 8 || nType === 2 ) {
				return;
			}
	
			// Fallback to prop when attributes are not supported
			if ( typeof elem.getAttribute === "undefined" ) {
				return jQuery.prop( elem, name, value );
			}
	
			// Attribute hooks are determined by the lowercase version
			// Grab necessary hook if one is defined
			if ( nType !== 1 || !jQuery.isXMLDoc( elem ) ) {
				hooks = jQuery.attrHooks[ name.toLowerCase() ] ||
					( jQuery.expr.match.bool.test( name ) ? boolHook : undefined );
			}
	
			if ( value !== undefined ) {
				if ( value === null ) {
					jQuery.removeAttr( elem, name );
					return;
				}
	
				if ( hooks && "set" in hooks &&
					( ret = hooks.set( elem, value, name ) ) !== undefined ) {
					return ret;
				}
	
				elem.setAttribute( name, value + "" );
				return value;
			}
	
			if ( hooks && "get" in hooks && ( ret = hooks.get( elem, name ) ) !== null ) {
				return ret;
			}
	
			ret = jQuery.find.attr( elem, name );
	
			// Non-existent attributes return null, we normalize to undefined
			return ret == null ? undefined : ret;
		},
	
		attrHooks: {
			type: {
				set: function( elem, value ) {
					if ( !support.radioValue && value === "radio" &&
						nodeName( elem, "input" ) ) {
						var val = elem.value;
						elem.setAttribute( "type", value );
						if ( val ) {
							elem.value = val;
						}
						return value;
					}
				}
			}
		},
	
		removeAttr: function( elem, value ) {
			var name,
				i = 0,
	
				// Attribute names can contain non-HTML whitespace characters
				// https://html.spec.whatwg.org/multipage/syntax.html#attributes-2
				attrNames = value && value.match( rnothtmlwhite );
	
			if ( attrNames && elem.nodeType === 1 ) {
				while ( ( name = attrNames[ i++ ] ) ) {
					elem.removeAttribute( name );
				}
			}
		}
	} );
	
	// Hooks for boolean attributes
	boolHook = {
		set: function( elem, value, name ) {
			if ( value === false ) {
	
				// Remove boolean attributes when set to false
				jQuery.removeAttr( elem, name );
			} else {
				elem.setAttribute( name, name );
			}
			return name;
		}
	};
	
	jQuery.each( jQuery.expr.match.bool.source.match( /\w+/g ), function( i, name ) {
		var getter = attrHandle[ name ] || jQuery.find.attr;
	
		attrHandle[ name ] = function( elem, name, isXML ) {
			var ret, handle,
				lowercaseName = name.toLowerCase();
	
			if ( !isXML ) {
	
				// Avoid an infinite loop by temporarily removing this function from the getter
				handle = attrHandle[ lowercaseName ];
				attrHandle[ lowercaseName ] = ret;
				ret = getter( elem, name, isXML ) != null ?
					lowercaseName :
					null;
				attrHandle[ lowercaseName ] = handle;
			}
			return ret;
		};
	} );
	
	
	
	
	var rfocusable = /^(?:input|select|textarea|button)$/i,
		rclickable = /^(?:a|area)$/i;
	
	jQuery.fn.extend( {
		prop: function( name, value ) {
			return access( this, jQuery.prop, name, value, arguments.length > 1 );
		},
	
		removeProp: function( name ) {
			return this.each( function() {
				delete this[ jQuery.propFix[ name ] || name ];
			} );
		}
	} );
	
	jQuery.extend( {
		prop: function( elem, name, value ) {
			var ret, hooks,
				nType = elem.nodeType;
	
			// Don't get/set properties on text, comment and attribute nodes
			if ( nType === 3 || nType === 8 || nType === 2 ) {
				return;
			}
	
			if ( nType !== 1 || !jQuery.isXMLDoc( elem ) ) {
	
				// Fix name and attach hooks
				name = jQuery.propFix[ name ] || name;
				hooks = jQuery.propHooks[ name ];
			}
	
			if ( value !== undefined ) {
				if ( hooks && "set" in hooks &&
					( ret = hooks.set( elem, value, name ) ) !== undefined ) {
					return ret;
				}
	
				return ( elem[ name ] = value );
			}
	
			if ( hooks && "get" in hooks && ( ret = hooks.get( elem, name ) ) !== null ) {
				return ret;
			}
	
			return elem[ name ];
		},
	
		propHooks: {
			tabIndex: {
				get: function( elem ) {
	
					// Support: IE <=9 - 11 only
					// elem.tabIndex doesn't always return the
					// correct value when it hasn't been explicitly set
					// https://web.archive.org/web/20141116233347/http://fluidproject.org/blog/2008/01/09/getting-setting-and-removing-tabindex-values-with-javascript/
					// Use proper attribute retrieval(#12072)
					var tabindex = jQuery.find.attr( elem, "tabindex" );
	
					if ( tabindex ) {
						return parseInt( tabindex, 10 );
					}
	
					if (
						rfocusable.test( elem.nodeName ) ||
						rclickable.test( elem.nodeName ) &&
						elem.href
					) {
						return 0;
					}
	
					return -1;
				}
			}
		},
	
		propFix: {
			"for": "htmlFor",
			"class": "className"
		}
	} );
	
	// Support: IE <=11 only
	// Accessing the selectedIndex property
	// forces the browser to respect setting selected
	// on the option
	// The getter ensures a default option is selected
	// when in an optgroup
	// eslint rule "no-unused-expressions" is disabled for this code
	// since it considers such accessions noop
	if ( !support.optSelected ) {
		jQuery.propHooks.selected = {
			get: function( elem ) {
	
				/* eslint no-unused-expressions: "off" */
	
				var parent = elem.parentNode;
				if ( parent && parent.parentNode ) {
					parent.parentNode.selectedIndex;
				}
				return null;
			},
			set: function( elem ) {
	
				/* eslint no-unused-expressions: "off" */
	
				var parent = elem.parentNode;
				if ( parent ) {
					parent.selectedIndex;
	
					if ( parent.parentNode ) {
						parent.parentNode.selectedIndex;
					}
				}
			}
		};
	}
	
	jQuery.each( [
		"tabIndex",
		"readOnly",
		"maxLength",
		"cellSpacing",
		"cellPadding",
		"rowSpan",
		"colSpan",
		"useMap",
		"frameBorder",
		"contentEditable"
	], function() {
		jQuery.propFix[ this.toLowerCase() ] = this;
	} );
	
	
	
	
		// Strip and collapse whitespace according to HTML spec
		// https://infra.spec.whatwg.org/#strip-and-collapse-ascii-whitespace
		function stripAndCollapse( value ) {
			var tokens = value.match( rnothtmlwhite ) || [];
			return tokens.join( " " );
		}
	
	
	function getClass( elem ) {
		return elem.getAttribute && elem.getAttribute( "class" ) || "";
	}
	
	function classesToArray( value ) {
		if ( Array.isArray( value ) ) {
			return value;
		}
		if ( typeof value === "string" ) {
			return value.match( rnothtmlwhite ) || [];
		}
		return [];
	}
	
	jQuery.fn.extend( {
		addClass: function( value ) {
			var classes, elem, cur, curValue, clazz, j, finalValue,
				i = 0;
	
			if ( isFunction( value ) ) {
				return this.each( function( j ) {
					jQuery( this ).addClass( value.call( this, j, getClass( this ) ) );
				} );
			}
	
			classes = classesToArray( value );
	
			if ( classes.length ) {
				while ( ( elem = this[ i++ ] ) ) {
					curValue = getClass( elem );
					cur = elem.nodeType === 1 && ( " " + stripAndCollapse( curValue ) + " " );
	
					if ( cur ) {
						j = 0;
						while ( ( clazz = classes[ j++ ] ) ) {
							if ( cur.indexOf( " " + clazz + " " ) < 0 ) {
								cur += clazz + " ";
							}
						}
	
						// Only assign if different to avoid unneeded rendering.
						finalValue = stripAndCollapse( cur );
						if ( curValue !== finalValue ) {
							elem.setAttribute( "class", finalValue );
						}
					}
				}
			}
	
			return this;
		},
	
		removeClass: function( value ) {
			var classes, elem, cur, curValue, clazz, j, finalValue,
				i = 0;
	
			if ( isFunction( value ) ) {
				return this.each( function( j ) {
					jQuery( this ).removeClass( value.call( this, j, getClass( this ) ) );
				} );
			}
	
			if ( !arguments.length ) {
				return this.attr( "class", "" );
			}
	
			classes = classesToArray( value );
	
			if ( classes.length ) {
				while ( ( elem = this[ i++ ] ) ) {
					curValue = getClass( elem );
	
					// This expression is here for better compressibility (see addClass)
					cur = elem.nodeType === 1 && ( " " + stripAndCollapse( curValue ) + " " );
	
					if ( cur ) {
						j = 0;
						while ( ( clazz = classes[ j++ ] ) ) {
	
							// Remove *all* instances
							while ( cur.indexOf( " " + clazz + " " ) > -1 ) {
								cur = cur.replace( " " + clazz + " ", " " );
							}
						}
	
						// Only assign if different to avoid unneeded rendering.
						finalValue = stripAndCollapse( cur );
						if ( curValue !== finalValue ) {
							elem.setAttribute( "class", finalValue );
						}
					}
				}
			}
	
			return this;
		},
	
		toggleClass: function( value, stateVal ) {
			var type = typeof value,
				isValidValue = type === "string" || Array.isArray( value );
	
			if ( typeof stateVal === "boolean" && isValidValue ) {
				return stateVal ? this.addClass( value ) : this.removeClass( value );
			}
	
			if ( isFunction( value ) ) {
				return this.each( function( i ) {
					jQuery( this ).toggleClass(
						value.call( this, i, getClass( this ), stateVal ),
						stateVal
					);
				} );
			}
	
			return this.each( function() {
				var className, i, self, classNames;
	
				if ( isValidValue ) {
	
					// Toggle individual class names
					i = 0;
					self = jQuery( this );
					classNames = classesToArray( value );
	
					while ( ( className = classNames[ i++ ] ) ) {
	
						// Check each className given, space separated list
						if ( self.hasClass( className ) ) {
							self.removeClass( className );
						} else {
							self.addClass( className );
						}
					}
	
				// Toggle whole class name
				} else if ( value === undefined || type === "boolean" ) {
					className = getClass( this );
					if ( className ) {
	
						// Store className if set
						dataPriv.set( this, "__className__", className );
					}
	
					// If the element has a class name or if we're passed `false`,
					// then remove the whole classname (if there was one, the above saved it).
					// Otherwise bring back whatever was previously saved (if anything),
					// falling back to the empty string if nothing was stored.
					if ( this.setAttribute ) {
						this.setAttribute( "class",
							className || value === false ?
							"" :
							dataPriv.get( this, "__className__" ) || ""
						);
					}
				}
			} );
		},
	
		hasClass: function( selector ) {
			var className, elem,
				i = 0;
	
			className = " " + selector + " ";
			while ( ( elem = this[ i++ ] ) ) {
				if ( elem.nodeType === 1 &&
					( " " + stripAndCollapse( getClass( elem ) ) + " " ).indexOf( className ) > -1 ) {
						return true;
				}
			}
	
			return false;
		}
	} );
	
	
	
	
	var rreturn = /\r/g;
	
	jQuery.fn.extend( {
		val: function( value ) {
			var hooks, ret, valueIsFunction,
				elem = this[ 0 ];
	
			if ( !arguments.length ) {
				if ( elem ) {
					hooks = jQuery.valHooks[ elem.type ] ||
						jQuery.valHooks[ elem.nodeName.toLowerCase() ];
	
					if ( hooks &&
						"get" in hooks &&
						( ret = hooks.get( elem, "value" ) ) !== undefined
					) {
						return ret;
					}
	
					ret = elem.value;
	
					// Handle most common string cases
					if ( typeof ret === "string" ) {
						return ret.replace( rreturn, "" );
					}
	
					// Handle cases where value is null/undef or number
					return ret == null ? "" : ret;
				}
	
				return;
			}
	
			valueIsFunction = isFunction( value );
	
			return this.each( function( i ) {
				var val;
	
				if ( this.nodeType !== 1 ) {
					return;
				}
	
				if ( valueIsFunction ) {
					val = value.call( this, i, jQuery( this ).val() );
				} else {
					val = value;
				}
	
				// Treat null/undefined as ""; convert numbers to string
				if ( val == null ) {
					val = "";
	
				} else if ( typeof val === "number" ) {
					val += "";
	
				} else if ( Array.isArray( val ) ) {
					val = jQuery.map( val, function( value ) {
						return value == null ? "" : value + "";
					} );
				}
	
				hooks = jQuery.valHooks[ this.type ] || jQuery.valHooks[ this.nodeName.toLowerCase() ];
	
				// If set returns undefined, fall back to normal setting
				if ( !hooks || !( "set" in hooks ) || hooks.set( this, val, "value" ) === undefined ) {
					this.value = val;
				}
			} );
		}
	} );
	
	jQuery.extend( {
		valHooks: {
			option: {
				get: function( elem ) {
	
					var val = jQuery.find.attr( elem, "value" );
					return val != null ?
						val :
	
						// Support: IE <=10 - 11 only
						// option.text throws exceptions (#14686, #14858)
						// Strip and collapse whitespace
						// https://html.spec.whatwg.org/#strip-and-collapse-whitespace
						stripAndCollapse( jQuery.text( elem ) );
				}
			},
			select: {
				get: function( elem ) {
					var value, option, i,
						options = elem.options,
						index = elem.selectedIndex,
						one = elem.type === "select-one",
						values = one ? null : [],
						max = one ? index + 1 : options.length;
	
					if ( index < 0 ) {
						i = max;
	
					} else {
						i = one ? index : 0;
					}
	
					// Loop through all the selected options
					for ( ; i < max; i++ ) {
						option = options[ i ];
	
						// Support: IE <=9 only
						// IE8-9 doesn't update selected after form reset (#2551)
						if ( ( option.selected || i === index ) &&
	
								// Don't return options that are disabled or in a disabled optgroup
								!option.disabled &&
								( !option.parentNode.disabled ||
									!nodeName( option.parentNode, "optgroup" ) ) ) {
	
							// Get the specific value for the option
							value = jQuery( option ).val();
	
							// We don't need an array for one selects
							if ( one ) {
								return value;
							}
	
							// Multi-Selects return an array
							values.push( value );
						}
					}
	
					return values;
				},
	
				set: function( elem, value ) {
					var optionSet, option,
						options = elem.options,
						values = jQuery.makeArray( value ),
						i = options.length;
	
					while ( i-- ) {
						option = options[ i ];
	
						/* eslint-disable no-cond-assign */
	
						if ( option.selected =
							jQuery.inArray( jQuery.valHooks.option.get( option ), values ) > -1
						) {
							optionSet = true;
						}
	
						/* eslint-enable no-cond-assign */
					}
	
					// Force browsers to behave consistently when non-matching value is set
					if ( !optionSet ) {
						elem.selectedIndex = -1;
					}
					return values;
				}
			}
		}
	} );
	
	// Radios and checkboxes getter/setter
	jQuery.each( [ "radio", "checkbox" ], function() {
		jQuery.valHooks[ this ] = {
			set: function( elem, value ) {
				if ( Array.isArray( value ) ) {
					return ( elem.checked = jQuery.inArray( jQuery( elem ).val(), value ) > -1 );
				}
			}
		};
		if ( !support.checkOn ) {
			jQuery.valHooks[ this ].get = function( elem ) {
				return elem.getAttribute( "value" ) === null ? "on" : elem.value;
			};
		}
	} );
	
	
	
	
	// Return jQuery for attributes-only inclusion
	
	
	support.focusin = "onfocusin" in window;
	
	
	var rfocusMorph = /^(?:focusinfocus|focusoutblur)$/,
		stopPropagationCallback = function( e ) {
			e.stopPropagation();
		};
	
	jQuery.extend( jQuery.event, {
	
		trigger: function( event, data, elem, onlyHandlers ) {
	
			var i, cur, tmp, bubbleType, ontype, handle, special, lastElement,
				eventPath = [ elem || document ],
				type = hasOwn.call( event, "type" ) ? event.type : event,
				namespaces = hasOwn.call( event, "namespace" ) ? event.namespace.split( "." ) : [];
	
			cur = lastElement = tmp = elem = elem || document;
	
			// Don't do events on text and comment nodes
			if ( elem.nodeType === 3 || elem.nodeType === 8 ) {
				return;
			}
	
			// focus/blur morphs to focusin/out; ensure we're not firing them right now
			if ( rfocusMorph.test( type + jQuery.event.triggered ) ) {
				return;
			}
	
			if ( type.indexOf( "." ) > -1 ) {
	
				// Namespaced trigger; create a regexp to match event type in handle()
				namespaces = type.split( "." );
				type = namespaces.shift();
				namespaces.sort();
			}
			ontype = type.indexOf( ":" ) < 0 && "on" + type;
	
			// Caller can pass in a jQuery.Event object, Object, or just an event type string
			event = event[ jQuery.expando ] ?
				event :
				new jQuery.Event( type, typeof event === "object" && event );
	
			// Trigger bitmask: & 1 for native handlers; & 2 for jQuery (always true)
			event.isTrigger = onlyHandlers ? 2 : 3;
			event.namespace = namespaces.join( "." );
			event.rnamespace = event.namespace ?
				new RegExp( "(^|\\.)" + namespaces.join( "\\.(?:.*\\.|)" ) + "(\\.|$)" ) :
				null;
	
			// Clean up the event in case it is being reused
			event.result = undefined;
			if ( !event.target ) {
				event.target = elem;
			}
	
			// Clone any incoming data and prepend the event, creating the handler arg list
			data = data == null ?
				[ event ] :
				jQuery.makeArray( data, [ event ] );
	
			// Allow special events to draw outside the lines
			special = jQuery.event.special[ type ] || {};
			if ( !onlyHandlers && special.trigger && special.trigger.apply( elem, data ) === false ) {
				return;
			}
	
			// Determine event propagation path in advance, per W3C events spec (#9951)
			// Bubble up to document, then to window; watch for a global ownerDocument var (#9724)
			if ( !onlyHandlers && !special.noBubble && !isWindow( elem ) ) {
	
				bubbleType = special.delegateType || type;
				if ( !rfocusMorph.test( bubbleType + type ) ) {
					cur = cur.parentNode;
				}
				for ( ; cur; cur = cur.parentNode ) {
					eventPath.push( cur );
					tmp = cur;
				}
	
				// Only add window if we got to document (e.g., not plain obj or detached DOM)
				if ( tmp === ( elem.ownerDocument || document ) ) {
					eventPath.push( tmp.defaultView || tmp.parentWindow || window );
				}
			}
	
			// Fire handlers on the event path
			i = 0;
			while ( ( cur = eventPath[ i++ ] ) && !event.isPropagationStopped() ) {
				lastElement = cur;
				event.type = i > 1 ?
					bubbleType :
					special.bindType || type;
	
				// jQuery handler
				handle = ( dataPriv.get( cur, "events" ) || {} )[ event.type ] &&
					dataPriv.get( cur, "handle" );
				if ( handle ) {
					handle.apply( cur, data );
				}
	
				// Native handler
				handle = ontype && cur[ ontype ];
				if ( handle && handle.apply && acceptData( cur ) ) {
					event.result = handle.apply( cur, data );
					if ( event.result === false ) {
						event.preventDefault();
					}
				}
			}
			event.type = type;
	
			// If nobody prevented the default action, do it now
			if ( !onlyHandlers && !event.isDefaultPrevented() ) {
	
				if ( ( !special._default ||
					special._default.apply( eventPath.pop(), data ) === false ) &&
					acceptData( elem ) ) {
	
					// Call a native DOM method on the target with the same name as the event.
					// Don't do default actions on window, that's where global variables be (#6170)
					if ( ontype && isFunction( elem[ type ] ) && !isWindow( elem ) ) {
	
						// Don't re-trigger an onFOO event when we call its FOO() method
						tmp = elem[ ontype ];
	
						if ( tmp ) {
							elem[ ontype ] = null;
						}
	
						// Prevent re-triggering of the same event, since we already bubbled it above
						jQuery.event.triggered = type;
	
						if ( event.isPropagationStopped() ) {
							lastElement.addEventListener( type, stopPropagationCallback );
						}
	
						elem[ type ]();
	
						if ( event.isPropagationStopped() ) {
							lastElement.removeEventListener( type, stopPropagationCallback );
						}
	
						jQuery.event.triggered = undefined;
	
						if ( tmp ) {
							elem[ ontype ] = tmp;
						}
					}
				}
			}
	
			return event.result;
		},
	
		// Piggyback on a donor event to simulate a different one
		// Used only for `focus(in | out)` events
		simulate: function( type, elem, event ) {
			var e = jQuery.extend(
				new jQuery.Event(),
				event,
				{
					type: type,
					isSimulated: true
				}
			);
	
			jQuery.event.trigger( e, null, elem );
		}
	
	} );
	
	jQuery.fn.extend( {
	
		trigger: function( type, data ) {
			return this.each( function() {
				jQuery.event.trigger( type, data, this );
			} );
		},
		triggerHandler: function( type, data ) {
			var elem = this[ 0 ];
			if ( elem ) {
				return jQuery.event.trigger( type, data, elem, true );
			}
		}
	} );
	
	
	// Support: Firefox <=44
	// Firefox doesn't have focus(in | out) events
	// Related ticket - https://bugzilla.mozilla.org/show_bug.cgi?id=687787
	//
	// Support: Chrome <=48 - 49, Safari <=9.0 - 9.1
	// focus(in | out) events fire after focus & blur events,
	// which is spec violation - http://www.w3.org/TR/DOM-Level-3-Events/#events-focusevent-event-order
	// Related ticket - https://bugs.chromium.org/p/chromium/issues/detail?id=449857
	if ( !support.focusin ) {
		jQuery.each( { focus: "focusin", blur: "focusout" }, function( orig, fix ) {
	
			// Attach a single capturing handler on the document while someone wants focusin/focusout
			var handler = function( event ) {
				jQuery.event.simulate( fix, event.target, jQuery.event.fix( event ) );
			};
	
			jQuery.event.special[ fix ] = {
				setup: function() {
					var doc = this.ownerDocument || this,
						attaches = dataPriv.access( doc, fix );
	
					if ( !attaches ) {
						doc.addEventListener( orig, handler, true );
					}
					dataPriv.access( doc, fix, ( attaches || 0 ) + 1 );
				},
				teardown: function() {
					var doc = this.ownerDocument || this,
						attaches = dataPriv.access( doc, fix ) - 1;
	
					if ( !attaches ) {
						doc.removeEventListener( orig, handler, true );
						dataPriv.remove( doc, fix );
	
					} else {
						dataPriv.access( doc, fix, attaches );
					}
				}
			};
		} );
	}
	var location = window.location;
	
	var nonce = Date.now();
	
	var rquery = ( /\?/ );
	
	
	
	// Cross-browser xml parsing
	jQuery.parseXML = function( data ) {
		var xml;
		if ( !data || typeof data !== "string" ) {
			return null;
		}
	
		// Support: IE 9 - 11 only
		// IE throws on parseFromString with invalid input.
		try {
			xml = ( new window.DOMParser() ).parseFromString( data, "text/xml" );
		} catch ( e ) {
			xml = undefined;
		}
	
		if ( !xml || xml.getElementsByTagName( "parsererror" ).length ) {
			jQuery.error( "Invalid XML: " + data );
		}
		return xml;
	};
	
	
	var
		rbracket = /\[\]$/,
		rCRLF = /\r?\n/g,
		rsubmitterTypes = /^(?:submit|button|image|reset|file)$/i,
		rsubmittable = /^(?:input|select|textarea|keygen)/i;
	
	function buildParams( prefix, obj, traditional, add ) {
		var name;
	
		if ( Array.isArray( obj ) ) {
	
			// Serialize array item.
			jQuery.each( obj, function( i, v ) {
				if ( traditional || rbracket.test( prefix ) ) {
	
					// Treat each array item as a scalar.
					add( prefix, v );
	
				} else {
	
					// Item is non-scalar (array or object), encode its numeric index.
					buildParams(
						prefix + "[" + ( typeof v === "object" && v != null ? i : "" ) + "]",
						v,
						traditional,
						add
					);
				}
			} );
	
		} else if ( !traditional && toType( obj ) === "object" ) {
	
			// Serialize object item.
			for ( name in obj ) {
				buildParams( prefix + "[" + name + "]", obj[ name ], traditional, add );
			}
	
		} else {
	
			// Serialize scalar item.
			add( prefix, obj );
		}
	}
	
	// Serialize an array of form elements or a set of
	// key/values into a query string
	jQuery.param = function( a, traditional ) {
		var prefix,
			s = [],
			add = function( key, valueOrFunction ) {
	
				// If value is a function, invoke it and use its return value
				var value = isFunction( valueOrFunction ) ?
					valueOrFunction() :
					valueOrFunction;
	
				s[ s.length ] = encodeURIComponent( key ) + "=" +
					encodeURIComponent( value == null ? "" : value );
			};
	
		// If an array was passed in, assume that it is an array of form elements.
		if ( Array.isArray( a ) || ( a.jquery && !jQuery.isPlainObject( a ) ) ) {
	
			// Serialize the form elements
			jQuery.each( a, function() {
				add( this.name, this.value );
			} );
	
		} else {
	
			// If traditional, encode the "old" way (the way 1.3.2 or older
			// did it), otherwise encode params recursively.
			for ( prefix in a ) {
				buildParams( prefix, a[ prefix ], traditional, add );
			}
		}
	
		// Return the resulting serialization
		return s.join( "&" );
	};
	
	jQuery.fn.extend( {
		serialize: function() {
			return jQuery.param( this.serializeArray() );
		},
		serializeArray: function() {
			return this.map( function() {
	
				// Can add propHook for "elements" to filter or add form elements
				var elements = jQuery.prop( this, "elements" );
				return elements ? jQuery.makeArray( elements ) : this;
			} )
			.filter( function() {
				var type = this.type;
	
				// Use .is( ":disabled" ) so that fieldset[disabled] works
				return this.name && !jQuery( this ).is( ":disabled" ) &&
					rsubmittable.test( this.nodeName ) && !rsubmitterTypes.test( type ) &&
					( this.checked || !rcheckableType.test( type ) );
			} )
			.map( function( i, elem ) {
				var val = jQuery( this ).val();
	
				if ( val == null ) {
					return null;
				}
	
				if ( Array.isArray( val ) ) {
					return jQuery.map( val, function( val ) {
						return { name: elem.name, value: val.replace( rCRLF, "\r\n" ) };
					} );
				}
	
				return { name: elem.name, value: val.replace( rCRLF, "\r\n" ) };
			} ).get();
		}
	} );
	
	
	var
		r20 = /%20/g,
		rhash = /#.*$/,
		rantiCache = /([?&])_=[^&]*/,
		rheaders = /^(.*?):[ \t]*([^\r\n]*)$/mg,
	
		// #7653, #8125, #8152: local protocol detection
		rlocalProtocol = /^(?:about|app|app-storage|.+-extension|file|res|widget):$/,
		rnoContent = /^(?:GET|HEAD)$/,
		rprotocol = /^\/\//,
	
		/* Prefilters
		 * 1) They are useful to introduce custom dataTypes (see ajax/jsonp.js for an example)
		 * 2) These are called:
		 *    - BEFORE asking for a transport
		 *    - AFTER param serialization (s.data is a string if s.processData is true)
		 * 3) key is the dataType
		 * 4) the catchall symbol "*" can be used
		 * 5) execution will start with transport dataType and THEN continue down to "*" if needed
		 */
		prefilters = {},
	
		/* Transports bindings
		 * 1) key is the dataType
		 * 2) the catchall symbol "*" can be used
		 * 3) selection will start with transport dataType and THEN go to "*" if needed
		 */
		transports = {},
	
		// Avoid comment-prolog char sequence (#10098); must appease lint and evade compression
		allTypes = "*/".concat( "*" ),
	
		// Anchor tag for parsing the document origin
		originAnchor = document.createElement( "a" );
		originAnchor.href = location.href;
	
	// Base "constructor" for jQuery.ajaxPrefilter and jQuery.ajaxTransport
	function addToPrefiltersOrTransports( structure ) {
	
		// dataTypeExpression is optional and defaults to "*"
		return function( dataTypeExpression, func ) {
	
			if ( typeof dataTypeExpression !== "string" ) {
				func = dataTypeExpression;
				dataTypeExpression = "*";
			}
	
			var dataType,
				i = 0,
				dataTypes = dataTypeExpression.toLowerCase().match( rnothtmlwhite ) || [];
	
			if ( isFunction( func ) ) {
	
				// For each dataType in the dataTypeExpression
				while ( ( dataType = dataTypes[ i++ ] ) ) {
	
					// Prepend if requested
					if ( dataType[ 0 ] === "+" ) {
						dataType = dataType.slice( 1 ) || "*";
						( structure[ dataType ] = structure[ dataType ] || [] ).unshift( func );
	
					// Otherwise append
					} else {
						( structure[ dataType ] = structure[ dataType ] || [] ).push( func );
					}
				}
			}
		};
	}
	
	// Base inspection function for prefilters and transports
	function inspectPrefiltersOrTransports( structure, options, originalOptions, jqXHR ) {
	
		var inspected = {},
			seekingTransport = ( structure === transports );
	
		function inspect( dataType ) {
			var selected;
			inspected[ dataType ] = true;
			jQuery.each( structure[ dataType ] || [], function( _, prefilterOrFactory ) {
				var dataTypeOrTransport = prefilterOrFactory( options, originalOptions, jqXHR );
				if ( typeof dataTypeOrTransport === "string" &&
					!seekingTransport && !inspected[ dataTypeOrTransport ] ) {
	
					options.dataTypes.unshift( dataTypeOrTransport );
					inspect( dataTypeOrTransport );
					return false;
				} else if ( seekingTransport ) {
					return !( selected = dataTypeOrTransport );
				}
			} );
			return selected;
		}
	
		return inspect( options.dataTypes[ 0 ] ) || !inspected[ "*" ] && inspect( "*" );
	}
	
	// A special extend for ajax options
	// that takes "flat" options (not to be deep extended)
	// Fixes #9887
	function ajaxExtend( target, src ) {
		var key, deep,
			flatOptions = jQuery.ajaxSettings.flatOptions || {};
	
		for ( key in src ) {
			if ( src[ key ] !== undefined ) {
				( flatOptions[ key ] ? target : ( deep || ( deep = {} ) ) )[ key ] = src[ key ];
			}
		}
		if ( deep ) {
			jQuery.extend( true, target, deep );
		}
	
		return target;
	}
	
	/* Handles responses to an ajax request:
	 * - finds the right dataType (mediates between content-type and expected dataType)
	 * - returns the corresponding response
	 */
	function ajaxHandleResponses( s, jqXHR, responses ) {
	
		var ct, type, finalDataType, firstDataType,
			contents = s.contents,
			dataTypes = s.dataTypes;
	
		// Remove auto dataType and get content-type in the process
		while ( dataTypes[ 0 ] === "*" ) {
			dataTypes.shift();
			if ( ct === undefined ) {
				ct = s.mimeType || jqXHR.getResponseHeader( "Content-Type" );
			}
		}
	
		// Check if we're dealing with a known content-type
		if ( ct ) {
			for ( type in contents ) {
				if ( contents[ type ] && contents[ type ].test( ct ) ) {
					dataTypes.unshift( type );
					break;
				}
			}
		}
	
		// Check to see if we have a response for the expected dataType
		if ( dataTypes[ 0 ] in responses ) {
			finalDataType = dataTypes[ 0 ];
		} else {
	
			// Try convertible dataTypes
			for ( type in responses ) {
				if ( !dataTypes[ 0 ] || s.converters[ type + " " + dataTypes[ 0 ] ] ) {
					finalDataType = type;
					break;
				}
				if ( !firstDataType ) {
					firstDataType = type;
				}
			}
	
			// Or just use first one
			finalDataType = finalDataType || firstDataType;
		}
	
		// If we found a dataType
		// We add the dataType to the list if needed
		// and return the corresponding response
		if ( finalDataType ) {
			if ( finalDataType !== dataTypes[ 0 ] ) {
				dataTypes.unshift( finalDataType );
			}
			return responses[ finalDataType ];
		}
	}
	
	/* Chain conversions given the request and the original response
	 * Also sets the responseXXX fields on the jqXHR instance
	 */
	function ajaxConvert( s, response, jqXHR, isSuccess ) {
		var conv2, current, conv, tmp, prev,
			converters = {},
	
			// Work with a copy of dataTypes in case we need to modify it for conversion
			dataTypes = s.dataTypes.slice();
	
		// Create converters map with lowercased keys
		if ( dataTypes[ 1 ] ) {
			for ( conv in s.converters ) {
				converters[ conv.toLowerCase() ] = s.converters[ conv ];
			}
		}
	
		current = dataTypes.shift();
	
		// Convert to each sequential dataType
		while ( current ) {
	
			if ( s.responseFields[ current ] ) {
				jqXHR[ s.responseFields[ current ] ] = response;
			}
	
			// Apply the dataFilter if provided
			if ( !prev && isSuccess && s.dataFilter ) {
				response = s.dataFilter( response, s.dataType );
			}
	
			prev = current;
			current = dataTypes.shift();
	
			if ( current ) {
	
				// There's only work to do if current dataType is non-auto
				if ( current === "*" ) {
	
					current = prev;
	
				// Convert response if prev dataType is non-auto and differs from current
				} else if ( prev !== "*" && prev !== current ) {
	
					// Seek a direct converter
					conv = converters[ prev + " " + current ] || converters[ "* " + current ];
	
					// If none found, seek a pair
					if ( !conv ) {
						for ( conv2 in converters ) {
	
							// If conv2 outputs current
							tmp = conv2.split( " " );
							if ( tmp[ 1 ] === current ) {
	
								// If prev can be converted to accepted input
								conv = converters[ prev + " " + tmp[ 0 ] ] ||
									converters[ "* " + tmp[ 0 ] ];
								if ( conv ) {
	
									// Condense equivalence converters
									if ( conv === true ) {
										conv = converters[ conv2 ];
	
									// Otherwise, insert the intermediate dataType
									} else if ( converters[ conv2 ] !== true ) {
										current = tmp[ 0 ];
										dataTypes.unshift( tmp[ 1 ] );
									}
									break;
								}
							}
						}
					}
	
					// Apply converter (if not an equivalence)
					if ( conv !== true ) {
	
						// Unless errors are allowed to bubble, catch and return them
						if ( conv && s.throws ) {
							response = conv( response );
						} else {
							try {
								response = conv( response );
							} catch ( e ) {
								return {
									state: "parsererror",
									error: conv ? e : "No conversion from " + prev + " to " + current
								};
							}
						}
					}
				}
			}
		}
	
		return { state: "success", data: response };
	}
	
	jQuery.extend( {
	
		// Counter for holding the number of active queries
		active: 0,
	
		// Last-Modified header cache for next request
		lastModified: {},
		etag: {},
	
		ajaxSettings: {
			url: location.href,
			type: "GET",
			isLocal: rlocalProtocol.test( location.protocol ),
			global: true,
			processData: true,
			async: true,
			contentType: "application/x-www-form-urlencoded; charset=UTF-8",
	
			/*
			timeout: 0,
			data: null,
			dataType: null,
			username: null,
			password: null,
			cache: null,
			throws: false,
			traditional: false,
			headers: {},
			*/
	
			accepts: {
				"*": allTypes,
				text: "text/plain",
				html: "text/html",
				xml: "application/xml, text/xml",
				json: "application/json, text/javascript"
			},
	
			contents: {
				xml: /\bxml\b/,
				html: /\bhtml/,
				json: /\bjson\b/
			},
	
			responseFields: {
				xml: "responseXML",
				text: "responseText",
				json: "responseJSON"
			},
	
			// Data converters
			// Keys separate source (or catchall "*") and destination types with a single space
			converters: {
	
				// Convert anything to text
				"* text": String,
	
				// Text to html (true = no transformation)
				"text html": true,
	
				// Evaluate text as a json expression
				"text json": JSON.parse,
	
				// Parse text as xml
				"text xml": jQuery.parseXML
			},
	
			// For options that shouldn't be deep extended:
			// you can add your own custom options here if
			// and when you create one that shouldn't be
			// deep extended (see ajaxExtend)
			flatOptions: {
				url: true,
				context: true
			}
		},
	
		// Creates a full fledged settings object into target
		// with both ajaxSettings and settings fields.
		// If target is omitted, writes into ajaxSettings.
		ajaxSetup: function( target, settings ) {
			return settings ?
	
				// Building a settings object
				ajaxExtend( ajaxExtend( target, jQuery.ajaxSettings ), settings ) :
	
				// Extending ajaxSettings
				ajaxExtend( jQuery.ajaxSettings, target );
		},
	
		ajaxPrefilter: addToPrefiltersOrTransports( prefilters ),
		ajaxTransport: addToPrefiltersOrTransports( transports ),
	
		// Main method
		ajax: function( url, options ) {
	
			// If url is an object, simulate pre-1.5 signature
			if ( typeof url === "object" ) {
				options = url;
				url = undefined;
			}
	
			// Force options to be an object
			options = options || {};
	
			var transport,
	
				// URL without anti-cache param
				cacheURL,
	
				// Response headers
				responseHeadersString,
				responseHeaders,
	
				// timeout handle
				timeoutTimer,
	
				// Url cleanup var
				urlAnchor,
	
				// Request state (becomes false upon send and true upon completion)
				completed,
	
				// To know if global events are to be dispatched
				fireGlobals,
	
				// Loop variable
				i,
	
				// uncached part of the url
				uncached,
	
				// Create the final options object
				s = jQuery.ajaxSetup( {}, options ),
	
				// Callbacks context
				callbackContext = s.context || s,
	
				// Context for global events is callbackContext if it is a DOM node or jQuery collection
				globalEventContext = s.context &&
					( callbackContext.nodeType || callbackContext.jquery ) ?
						jQuery( callbackContext ) :
						jQuery.event,
	
				// Deferreds
				deferred = jQuery.Deferred(),
				completeDeferred = jQuery.Callbacks( "once memory" ),
	
				// Status-dependent callbacks
				statusCode = s.statusCode || {},
	
				// Headers (they are sent all at once)
				requestHeaders = {},
				requestHeadersNames = {},
	
				// Default abort message
				strAbort = "canceled",
	
				// Fake xhr
				jqXHR = {
					readyState: 0,
	
					// Builds headers hashtable if needed
					getResponseHeader: function( key ) {
						var match;
						if ( completed ) {
							if ( !responseHeaders ) {
								responseHeaders = {};
								while ( ( match = rheaders.exec( responseHeadersString ) ) ) {
									responseHeaders[ match[ 1 ].toLowerCase() ] = match[ 2 ];
								}
							}
							match = responseHeaders[ key.toLowerCase() ];
						}
						return match == null ? null : match;
					},
	
					// Raw string
					getAllResponseHeaders: function() {
						return completed ? responseHeadersString : null;
					},
	
					// Caches the header
					setRequestHeader: function( name, value ) {
						if ( completed == null ) {
							name = requestHeadersNames[ name.toLowerCase() ] =
								requestHeadersNames[ name.toLowerCase() ] || name;
							requestHeaders[ name ] = value;
						}
						return this;
					},
	
					// Overrides response content-type header
					overrideMimeType: function( type ) {
						if ( completed == null ) {
							s.mimeType = type;
						}
						return this;
					},
	
					// Status-dependent callbacks
					statusCode: function( map ) {
						var code;
						if ( map ) {
							if ( completed ) {
	
								// Execute the appropriate callbacks
								jqXHR.always( map[ jqXHR.status ] );
							} else {
	
								// Lazy-add the new callbacks in a way that preserves old ones
								for ( code in map ) {
									statusCode[ code ] = [ statusCode[ code ], map[ code ] ];
								}
							}
						}
						return this;
					},
	
					// Cancel the request
					abort: function( statusText ) {
						var finalText = statusText || strAbort;
						if ( transport ) {
							transport.abort( finalText );
						}
						done( 0, finalText );
						return this;
					}
				};
	
			// Attach deferreds
			deferred.promise( jqXHR );
	
			// Add protocol if not provided (prefilters might expect it)
			// Handle falsy url in the settings object (#10093: consistency with old signature)
			// We also use the url parameter if available
			s.url = ( ( url || s.url || location.href ) + "" )
				.replace( rprotocol, location.protocol + "//" );
	
			// Alias method option to type as per ticket #12004
			s.type = options.method || options.type || s.method || s.type;
	
			// Extract dataTypes list
			s.dataTypes = ( s.dataType || "*" ).toLowerCase().match( rnothtmlwhite ) || [ "" ];
	
			// A cross-domain request is in order when the origin doesn't match the current origin.
			if ( s.crossDomain == null ) {
				urlAnchor = document.createElement( "a" );
	
				// Support: IE <=8 - 11, Edge 12 - 15
				// IE throws exception on accessing the href property if url is malformed,
				// e.g. http://example.com:80x/
				try {
					urlAnchor.href = s.url;
	
					// Support: IE <=8 - 11 only
					// Anchor's host property isn't correctly set when s.url is relative
					urlAnchor.href = urlAnchor.href;
					s.crossDomain = originAnchor.protocol + "//" + originAnchor.host !==
						urlAnchor.protocol + "//" + urlAnchor.host;
				} catch ( e ) {
	
					// If there is an error parsing the URL, assume it is crossDomain,
					// it can be rejected by the transport if it is invalid
					s.crossDomain = true;
				}
			}
	
			// Convert data if not already a string
			if ( s.data && s.processData && typeof s.data !== "string" ) {
				s.data = jQuery.param( s.data, s.traditional );
			}
	
			// Apply prefilters
			inspectPrefiltersOrTransports( prefilters, s, options, jqXHR );
	
			// If request was aborted inside a prefilter, stop there
			if ( completed ) {
				return jqXHR;
			}
	
			// We can fire global events as of now if asked to
			// Don't fire events if jQuery.event is undefined in an AMD-usage scenario (#15118)
			fireGlobals = jQuery.event && s.global;
	
			// Watch for a new set of requests
			if ( fireGlobals && jQuery.active++ === 0 ) {
				jQuery.event.trigger( "ajaxStart" );
			}
	
			// Uppercase the type
			s.type = s.type.toUpperCase();
	
			// Determine if request has content
			s.hasContent = !rnoContent.test( s.type );
	
			// Save the URL in case we're toying with the If-Modified-Since
			// and/or If-None-Match header later on
			// Remove hash to simplify url manipulation
			cacheURL = s.url.replace( rhash, "" );
	
			// More options handling for requests with no content
			if ( !s.hasContent ) {
	
				// Remember the hash so we can put it back
				uncached = s.url.slice( cacheURL.length );
	
				// If data is available and should be processed, append data to url
				if ( s.data && ( s.processData || typeof s.data === "string" ) ) {
					cacheURL += ( rquery.test( cacheURL ) ? "&" : "?" ) + s.data;
	
					// #9682: remove data so that it's not used in an eventual retry
					delete s.data;
				}
	
				// Add or update anti-cache param if needed
				if ( s.cache === false ) {
					cacheURL = cacheURL.replace( rantiCache, "$1" );
					uncached = ( rquery.test( cacheURL ) ? "&" : "?" ) + "_=" + ( nonce++ ) + uncached;
				}
	
				// Put hash and anti-cache on the URL that will be requested (gh-1732)
				s.url = cacheURL + uncached;
	
			// Change '%20' to '+' if this is encoded form body content (gh-2658)
			} else if ( s.data && s.processData &&
				( s.contentType || "" ).indexOf( "application/x-www-form-urlencoded" ) === 0 ) {
				s.data = s.data.replace( r20, "+" );
			}
	
			// Set the If-Modified-Since and/or If-None-Match header, if in ifModified mode.
			if ( s.ifModified ) {
				if ( jQuery.lastModified[ cacheURL ] ) {
					jqXHR.setRequestHeader( "If-Modified-Since", jQuery.lastModified[ cacheURL ] );
				}
				if ( jQuery.etag[ cacheURL ] ) {
					jqXHR.setRequestHeader( "If-None-Match", jQuery.etag[ cacheURL ] );
				}
			}
	
			// Set the correct header, if data is being sent
			if ( s.data && s.hasContent && s.contentType !== false || options.contentType ) {
				jqXHR.setRequestHeader( "Content-Type", s.contentType );
			}
	
			// Set the Accepts header for the server, depending on the dataType
			jqXHR.setRequestHeader(
				"Accept",
				s.dataTypes[ 0 ] && s.accepts[ s.dataTypes[ 0 ] ] ?
					s.accepts[ s.dataTypes[ 0 ] ] +
						( s.dataTypes[ 0 ] !== "*" ? ", " + allTypes + "; q=0.01" : "" ) :
					s.accepts[ "*" ]
			);
	
			// Check for headers option
			for ( i in s.headers ) {
				jqXHR.setRequestHeader( i, s.headers[ i ] );
			}
	
			// Allow custom headers/mimetypes and early abort
			if ( s.beforeSend &&
				( s.beforeSend.call( callbackContext, jqXHR, s ) === false || completed ) ) {
	
				// Abort if not done already and return
				return jqXHR.abort();
			}
	
			// Aborting is no longer a cancellation
			strAbort = "abort";
	
			// Install callbacks on deferreds
			completeDeferred.add( s.complete );
			jqXHR.done( s.success );
			jqXHR.fail( s.error );
	
			// Get transport
			transport = inspectPrefiltersOrTransports( transports, s, options, jqXHR );
	
			// If no transport, we auto-abort
			if ( !transport ) {
				done( -1, "No Transport" );
			} else {
				jqXHR.readyState = 1;
	
				// Send global event
				if ( fireGlobals ) {
					globalEventContext.trigger( "ajaxSend", [ jqXHR, s ] );
				}
	
				// If request was aborted inside ajaxSend, stop there
				if ( completed ) {
					return jqXHR;
				}
	
				// Timeout
				if ( s.async && s.timeout > 0 ) {
					timeoutTimer = window.setTimeout( function() {
						jqXHR.abort( "timeout" );
					}, s.timeout );
				}
	
				try {
					completed = false;
					transport.send( requestHeaders, done );
				} catch ( e ) {
	
					// Rethrow post-completion exceptions
					if ( completed ) {
						throw e;
					}
	
					// Propagate others as results
					done( -1, e );
				}
			}
	
			// Callback for when everything is done
			function done( status, nativeStatusText, responses, headers ) {
				var isSuccess, success, error, response, modified,
					statusText = nativeStatusText;
	
				// Ignore repeat invocations
				if ( completed ) {
					return;
				}
	
				completed = true;
	
				// Clear timeout if it exists
				if ( timeoutTimer ) {
					window.clearTimeout( timeoutTimer );
				}
	
				// Dereference transport for early garbage collection
				// (no matter how long the jqXHR object will be used)
				transport = undefined;
	
				// Cache response headers
				responseHeadersString = headers || "";
	
				// Set readyState
				jqXHR.readyState = status > 0 ? 4 : 0;
	
				// Determine if successful
				isSuccess = status >= 200 && status < 300 || status === 304;
	
				// Get response data
				if ( responses ) {
					response = ajaxHandleResponses( s, jqXHR, responses );
				}
	
				// Convert no matter what (that way responseXXX fields are always set)
				response = ajaxConvert( s, response, jqXHR, isSuccess );
	
				// If successful, handle type chaining
				if ( isSuccess ) {
	
					// Set the If-Modified-Since and/or If-None-Match header, if in ifModified mode.
					if ( s.ifModified ) {
						modified = jqXHR.getResponseHeader( "Last-Modified" );
						if ( modified ) {
							jQuery.lastModified[ cacheURL ] = modified;
						}
						modified = jqXHR.getResponseHeader( "etag" );
						if ( modified ) {
							jQuery.etag[ cacheURL ] = modified;
						}
					}
	
					// if no content
					if ( status === 204 || s.type === "HEAD" ) {
						statusText = "nocontent";
	
					// if not modified
					} else if ( status === 304 ) {
						statusText = "notmodified";
	
					// If we have data, let's convert it
					} else {
						statusText = response.state;
						success = response.data;
						error = response.error;
						isSuccess = !error;
					}
				} else {
	
					// Extract error from statusText and normalize for non-aborts
					error = statusText;
					if ( status || !statusText ) {
						statusText = "error";
						if ( status < 0 ) {
							status = 0;
						}
					}
				}
	
				// Set data for the fake xhr object
				jqXHR.status = status;
				jqXHR.statusText = ( nativeStatusText || statusText ) + "";
	
				// Success/Error
				if ( isSuccess ) {
					deferred.resolveWith( callbackContext, [ success, statusText, jqXHR ] );
				} else {
					deferred.rejectWith( callbackContext, [ jqXHR, statusText, error ] );
				}
	
				// Status-dependent callbacks
				jqXHR.statusCode( statusCode );
				statusCode = undefined;
	
				if ( fireGlobals ) {
					globalEventContext.trigger( isSuccess ? "ajaxSuccess" : "ajaxError",
						[ jqXHR, s, isSuccess ? success : error ] );
				}
	
				// Complete
				completeDeferred.fireWith( callbackContext, [ jqXHR, statusText ] );
	
				if ( fireGlobals ) {
					globalEventContext.trigger( "ajaxComplete", [ jqXHR, s ] );
	
					// Handle the global AJAX counter
					if ( !( --jQuery.active ) ) {
						jQuery.event.trigger( "ajaxStop" );
					}
				}
			}
	
			return jqXHR;
		},
	
		getJSON: function( url, data, callback ) {
			return jQuery.get( url, data, callback, "json" );
		},
	
		getScript: function( url, callback ) {
			return jQuery.get( url, undefined, callback, "script" );
		}
	} );
	
	jQuery.each( [ "get", "post" ], function( i, method ) {
		jQuery[ method ] = function( url, data, callback, type ) {
	
			// Shift arguments if data argument was omitted
			if ( isFunction( data ) ) {
				type = type || callback;
				callback = data;
				data = undefined;
			}
	
			// The url can be an options object (which then must have .url)
			return jQuery.ajax( jQuery.extend( {
				url: url,
				type: method,
				dataType: type,
				data: data,
				success: callback
			}, jQuery.isPlainObject( url ) && url ) );
		};
	} );
	
	
	jQuery._evalUrl = function( url ) {
		return jQuery.ajax( {
			url: url,
	
			// Make this explicit, since user can override this through ajaxSetup (#11264)
			type: "GET",
			dataType: "script",
			cache: true,
			async: false,
			global: false,
			"throws": true
		} );
	};
	
	
	jQuery.fn.extend( {
		wrapAll: function( html ) {
			var wrap;
	
			if ( this[ 0 ] ) {
				if ( isFunction( html ) ) {
					html = html.call( this[ 0 ] );
				}
	
				// The elements to wrap the target around
				wrap = jQuery( html, this[ 0 ].ownerDocument ).eq( 0 ).clone( true );
	
				if ( this[ 0 ].parentNode ) {
					wrap.insertBefore( this[ 0 ] );
				}
	
				wrap.map( function() {
					var elem = this;
	
					while ( elem.firstElementChild ) {
						elem = elem.firstElementChild;
					}
	
					return elem;
				} ).append( this );
			}
	
			return this;
		},
	
		wrapInner: function( html ) {
			if ( isFunction( html ) ) {
				return this.each( function( i ) {
					jQuery( this ).wrapInner( html.call( this, i ) );
				} );
			}
	
			return this.each( function() {
				var self = jQuery( this ),
					contents = self.contents();
	
				if ( contents.length ) {
					contents.wrapAll( html );
	
				} else {
					self.append( html );
				}
			} );
		},
	
		wrap: function( html ) {
			var htmlIsFunction = isFunction( html );
	
			return this.each( function( i ) {
				jQuery( this ).wrapAll( htmlIsFunction ? html.call( this, i ) : html );
			} );
		},
	
		unwrap: function( selector ) {
			this.parent( selector ).not( "body" ).each( function() {
				jQuery( this ).replaceWith( this.childNodes );
			} );
			return this;
		}
	} );
	
	
	jQuery.expr.pseudos.hidden = function( elem ) {
		return !jQuery.expr.pseudos.visible( elem );
	};
	jQuery.expr.pseudos.visible = function( elem ) {
		return !!( elem.offsetWidth || elem.offsetHeight || elem.getClientRects().length );
	};
	
	
	
	
	jQuery.ajaxSettings.xhr = function() {
		try {
			return new window.XMLHttpRequest();
		} catch ( e ) {}
	};
	
	var xhrSuccessStatus = {
	
			// File protocol always yields status code 0, assume 200
			0: 200,
	
			// Support: IE <=9 only
			// #1450: sometimes IE returns 1223 when it should be 204
			1223: 204
		},
		xhrSupported = jQuery.ajaxSettings.xhr();
	
	support.cors = !!xhrSupported && ( "withCredentials" in xhrSupported );
	support.ajax = xhrSupported = !!xhrSupported;
	
	jQuery.ajaxTransport( function( options ) {
		var callback, errorCallback;
	
		// Cross domain only allowed if supported through XMLHttpRequest
		if ( support.cors || xhrSupported && !options.crossDomain ) {
			return {
				send: function( headers, complete ) {
					var i,
						xhr = options.xhr();
	
					xhr.open(
						options.type,
						options.url,
						options.async,
						options.username,
						options.password
					);
	
					// Apply custom fields if provided
					if ( options.xhrFields ) {
						for ( i in options.xhrFields ) {
							xhr[ i ] = options.xhrFields[ i ];
						}
					}
	
					// Override mime type if needed
					if ( options.mimeType && xhr.overrideMimeType ) {
						xhr.overrideMimeType( options.mimeType );
					}
	
					// X-Requested-With header
					// For cross-domain requests, seeing as conditions for a preflight are
					// akin to a jigsaw puzzle, we simply never set it to be sure.
					// (it can always be set on a per-request basis or even using ajaxSetup)
					// For same-domain requests, won't change header if already provided.
					if ( !options.crossDomain && !headers[ "X-Requested-With" ] ) {
						headers[ "X-Requested-With" ] = "XMLHttpRequest";
					}
	
					// Set headers
					for ( i in headers ) {
						xhr.setRequestHeader( i, headers[ i ] );
					}
	
					// Callback
					callback = function( type ) {
						return function() {
							if ( callback ) {
								callback = errorCallback = xhr.onload =
									xhr.onerror = xhr.onabort = xhr.ontimeout =
										xhr.onreadystatechange = null;
	
								if ( type === "abort" ) {
									xhr.abort();
								} else if ( type === "error" ) {
	
									// Support: IE <=9 only
									// On a manual native abort, IE9 throws
									// errors on any property access that is not readyState
									if ( typeof xhr.status !== "number" ) {
										complete( 0, "error" );
									} else {
										complete(
	
											// File: protocol always yields status 0; see #8605, #14207
											xhr.status,
											xhr.statusText
										);
									}
								} else {
									complete(
										xhrSuccessStatus[ xhr.status ] || xhr.status,
										xhr.statusText,
	
										// Support: IE <=9 only
										// IE9 has no XHR2 but throws on binary (trac-11426)
										// For XHR2 non-text, let the caller handle it (gh-2498)
										( xhr.responseType || "text" ) !== "text"  ||
										typeof xhr.responseText !== "string" ?
											{ binary: xhr.response } :
											{ text: xhr.responseText },
										xhr.getAllResponseHeaders()
									);
								}
							}
						};
					};
	
					// Listen to events
					xhr.onload = callback();
					errorCallback = xhr.onerror = xhr.ontimeout = callback( "error" );
	
					// Support: IE 9 only
					// Use onreadystatechange to replace onabort
					// to handle uncaught aborts
					if ( xhr.onabort !== undefined ) {
						xhr.onabort = errorCallback;
					} else {
						xhr.onreadystatechange = function() {
	
							// Check readyState before timeout as it changes
							if ( xhr.readyState === 4 ) {
	
								// Allow onerror to be called first,
								// but that will not handle a native abort
								// Also, save errorCallback to a variable
								// as xhr.onerror cannot be accessed
								window.setTimeout( function() {
									if ( callback ) {
										errorCallback();
									}
								} );
							}
						};
					}
	
					// Create the abort callback
					callback = callback( "abort" );
	
					try {
	
						// Do send the request (this may raise an exception)
						xhr.send( options.hasContent && options.data || null );
					} catch ( e ) {
	
						// #14683: Only rethrow if this hasn't been notified as an error yet
						if ( callback ) {
							throw e;
						}
					}
				},
	
				abort: function() {
					if ( callback ) {
						callback();
					}
				}
			};
		}
	} );
	
	
	
	
	// Prevent auto-execution of scripts when no explicit dataType was provided (See gh-2432)
	jQuery.ajaxPrefilter( function( s ) {
		if ( s.crossDomain ) {
			s.contents.script = false;
		}
	} );
	
	// Install script dataType
	jQuery.ajaxSetup( {
		accepts: {
			script: "text/javascript, application/javascript, " +
				"application/ecmascript, application/x-ecmascript"
		},
		contents: {
			script: /\b(?:java|ecma)script\b/
		},
		converters: {
			"text script": function( text ) {
				jQuery.globalEval( text );
				return text;
			}
		}
	} );
	
	// Handle cache's special case and crossDomain
	jQuery.ajaxPrefilter( "script", function( s ) {
		if ( s.cache === undefined ) {
			s.cache = false;
		}
		if ( s.crossDomain ) {
			s.type = "GET";
		}
	} );
	
	// Bind script tag hack transport
	jQuery.ajaxTransport( "script", function( s ) {
	
		// This transport only deals with cross domain requests
		if ( s.crossDomain ) {
			var script, callback;
			return {
				send: function( _, complete ) {
					script = jQuery( "<script>" ).prop( {
						charset: s.scriptCharset,
						src: s.url
					} ).on(
						"load error",
						callback = function( evt ) {
							script.remove();
							callback = null;
							if ( evt ) {
								complete( evt.type === "error" ? 404 : 200, evt.type );
							}
						}
					);
	
					// Use native DOM manipulation to avoid our domManip AJAX trickery
					document.head.appendChild( script[ 0 ] );
				},
				abort: function() {
					if ( callback ) {
						callback();
					}
				}
			};
		}
	} );
	
	
	
	
	var oldCallbacks = [],
		rjsonp = /(=)\?(?=&|$)|\?\?/;
	
	// Default jsonp settings
	jQuery.ajaxSetup( {
		jsonp: "callback",
		jsonpCallback: function() {
			var callback = oldCallbacks.pop() || ( jQuery.expando + "_" + ( nonce++ ) );
			this[ callback ] = true;
			return callback;
		}
	} );
	
	// Detect, normalize options and install callbacks for jsonp requests
	jQuery.ajaxPrefilter( "json jsonp", function( s, originalSettings, jqXHR ) {
	
		var callbackName, overwritten, responseContainer,
			jsonProp = s.jsonp !== false && ( rjsonp.test( s.url ) ?
				"url" :
				typeof s.data === "string" &&
					( s.contentType || "" )
						.indexOf( "application/x-www-form-urlencoded" ) === 0 &&
					rjsonp.test( s.data ) && "data"
			);
	
		// Handle iff the expected data type is "jsonp" or we have a parameter to set
		if ( jsonProp || s.dataTypes[ 0 ] === "jsonp" ) {
	
			// Get callback name, remembering preexisting value associated with it
			callbackName = s.jsonpCallback = isFunction( s.jsonpCallback ) ?
				s.jsonpCallback() :
				s.jsonpCallback;
	
			// Insert callback into url or form data
			if ( jsonProp ) {
				s[ jsonProp ] = s[ jsonProp ].replace( rjsonp, "$1" + callbackName );
			} else if ( s.jsonp !== false ) {
				s.url += ( rquery.test( s.url ) ? "&" : "?" ) + s.jsonp + "=" + callbackName;
			}
	
			// Use data converter to retrieve json after script execution
			s.converters[ "script json" ] = function() {
				if ( !responseContainer ) {
					jQuery.error( callbackName + " was not called" );
				}
				return responseContainer[ 0 ];
			};
	
			// Force json dataType
			s.dataTypes[ 0 ] = "json";
	
			// Install callback
			overwritten = window[ callbackName ];
			window[ callbackName ] = function() {
				responseContainer = arguments;
			};
	
			// Clean-up function (fires after converters)
			jqXHR.always( function() {
	
				// If previous value didn't exist - remove it
				if ( overwritten === undefined ) {
					jQuery( window ).removeProp( callbackName );
	
				// Otherwise restore preexisting value
				} else {
					window[ callbackName ] = overwritten;
				}
	
				// Save back as free
				if ( s[ callbackName ] ) {
	
					// Make sure that re-using the options doesn't screw things around
					s.jsonpCallback = originalSettings.jsonpCallback;
	
					// Save the callback name for future use
					oldCallbacks.push( callbackName );
				}
	
				// Call if it was a function and we have a response
				if ( responseContainer && isFunction( overwritten ) ) {
					overwritten( responseContainer[ 0 ] );
				}
	
				responseContainer = overwritten = undefined;
			} );
	
			// Delegate to script
			return "script";
		}
	} );
	
	
	
	
	// Support: Safari 8 only
	// In Safari 8 documents created via document.implementation.createHTMLDocument
	// collapse sibling forms: the second one becomes a child of the first one.
	// Because of that, this security measure has to be disabled in Safari 8.
	// https://bugs.webkit.org/show_bug.cgi?id=137337
	support.createHTMLDocument = ( function() {
		var body = document.implementation.createHTMLDocument( "" ).body;
		body.innerHTML = "<form></form><form></form>";
		return body.childNodes.length === 2;
	} )();
	
	
	// Argument "data" should be string of html
	// context (optional): If specified, the fragment will be created in this context,
	// defaults to document
	// keepScripts (optional): If true, will include scripts passed in the html string
	jQuery.parseHTML = function( data, context, keepScripts ) {
		if ( typeof data !== "string" ) {
			return [];
		}
		if ( typeof context === "boolean" ) {
			keepScripts = context;
			context = false;
		}
	
		var base, parsed, scripts;
	
		if ( !context ) {
	
			// Stop scripts or inline event handlers from being executed immediately
			// by using document.implementation
			if ( support.createHTMLDocument ) {
				context = document.implementation.createHTMLDocument( "" );
	
				// Set the base href for the created document
				// so any parsed elements with URLs
				// are based on the document's URL (gh-2965)
				base = context.createElement( "base" );
				base.href = document.location.href;
				context.head.appendChild( base );
			} else {
				context = document;
			}
		}
	
		parsed = rsingleTag.exec( data );
		scripts = !keepScripts && [];
	
		// Single tag
		if ( parsed ) {
			return [ context.createElement( parsed[ 1 ] ) ];
		}
	
		parsed = buildFragment( [ data ], context, scripts );
	
		if ( scripts && scripts.length ) {
			jQuery( scripts ).remove();
		}
	
		return jQuery.merge( [], parsed.childNodes );
	};
	
	
	/**
	 * Load a url into a page
	 */
	jQuery.fn.load = function( url, params, callback ) {
		var selector, type, response,
			self = this,
			off = url.indexOf( " " );
	
		if ( off > -1 ) {
			selector = stripAndCollapse( url.slice( off ) );
			url = url.slice( 0, off );
		}
	
		// If it's a function
		if ( isFunction( params ) ) {
	
			// We assume that it's the callback
			callback = params;
			params = undefined;
	
		// Otherwise, build a param string
		} else if ( params && typeof params === "object" ) {
			type = "POST";
		}
	
		// If we have elements to modify, make the request
		if ( self.length > 0 ) {
			jQuery.ajax( {
				url: url,
	
				// If "type" variable is undefined, then "GET" method will be used.
				// Make value of this field explicit since
				// user can override it through ajaxSetup method
				type: type || "GET",
				dataType: "html",
				data: params
			} ).done( function( responseText ) {
	
				// Save response for use in complete callback
				response = arguments;
	
				self.html( selector ?
	
					// If a selector was specified, locate the right elements in a dummy div
					// Exclude scripts to avoid IE 'Permission Denied' errors
					jQuery( "<div>" ).append( jQuery.parseHTML( responseText ) ).find( selector ) :
	
					// Otherwise use the full result
					responseText );
	
			// If the request succeeds, this function gets "data", "status", "jqXHR"
			// but they are ignored because response was set above.
			// If it fails, this function gets "jqXHR", "status", "error"
			} ).always( callback && function( jqXHR, status ) {
				self.each( function() {
					callback.apply( this, response || [ jqXHR.responseText, status, jqXHR ] );
				} );
			} );
		}
	
		return this;
	};
	
	
	
	
	// Attach a bunch of functions for handling common AJAX events
	jQuery.each( [
		"ajaxStart",
		"ajaxStop",
		"ajaxComplete",
		"ajaxError",
		"ajaxSuccess",
		"ajaxSend"
	], function( i, type ) {
		jQuery.fn[ type ] = function( fn ) {
			return this.on( type, fn );
		};
	} );
	
	
	
	
	jQuery.expr.pseudos.animated = function( elem ) {
		return jQuery.grep( jQuery.timers, function( fn ) {
			return elem === fn.elem;
		} ).length;
	};
	
	
	
	
	jQuery.offset = {
		setOffset: function( elem, options, i ) {
			var curPosition, curLeft, curCSSTop, curTop, curOffset, curCSSLeft, calculatePosition,
				position = jQuery.css( elem, "position" ),
				curElem = jQuery( elem ),
				props = {};
	
			// Set position first, in-case top/left are set even on static elem
			if ( position === "static" ) {
				elem.style.position = "relative";
			}
	
			curOffset = curElem.offset();
			curCSSTop = jQuery.css( elem, "top" );
			curCSSLeft = jQuery.css( elem, "left" );
			calculatePosition = ( position === "absolute" || position === "fixed" ) &&
				( curCSSTop + curCSSLeft ).indexOf( "auto" ) > -1;
	
			// Need to be able to calculate position if either
			// top or left is auto and position is either absolute or fixed
			if ( calculatePosition ) {
				curPosition = curElem.position();
				curTop = curPosition.top;
				curLeft = curPosition.left;
	
			} else {
				curTop = parseFloat( curCSSTop ) || 0;
				curLeft = parseFloat( curCSSLeft ) || 0;
			}
	
			if ( isFunction( options ) ) {
	
				// Use jQuery.extend here to allow modification of coordinates argument (gh-1848)
				options = options.call( elem, i, jQuery.extend( {}, curOffset ) );
			}
	
			if ( options.top != null ) {
				props.top = ( options.top - curOffset.top ) + curTop;
			}
			if ( options.left != null ) {
				props.left = ( options.left - curOffset.left ) + curLeft;
			}
	
			if ( "using" in options ) {
				options.using.call( elem, props );
	
			} else {
				curElem.css( props );
			}
		}
	};
	
	jQuery.fn.extend( {
	
		// offset() relates an element's border box to the document origin
		offset: function( options ) {
	
			// Preserve chaining for setter
			if ( arguments.length ) {
				return options === undefined ?
					this :
					this.each( function( i ) {
						jQuery.offset.setOffset( this, options, i );
					} );
			}
	
			var rect, win,
				elem = this[ 0 ];
	
			if ( !elem ) {
				return;
			}
	
			// Return zeros for disconnected and hidden (display: none) elements (gh-2310)
			// Support: IE <=11 only
			// Running getBoundingClientRect on a
			// disconnected node in IE throws an error
			if ( !elem.getClientRects().length ) {
				return { top: 0, left: 0 };
			}
	
			// Get document-relative position by adding viewport scroll to viewport-relative gBCR
			rect = elem.getBoundingClientRect();
			win = elem.ownerDocument.defaultView;
			return {
				top: rect.top + win.pageYOffset,
				left: rect.left + win.pageXOffset
			};
		},
	
		// position() relates an element's margin box to its offset parent's padding box
		// This corresponds to the behavior of CSS absolute positioning
		position: function() {
			if ( !this[ 0 ] ) {
				return;
			}
	
			var offsetParent, offset, doc,
				elem = this[ 0 ],
				parentOffset = { top: 0, left: 0 };
	
			// position:fixed elements are offset from the viewport, which itself always has zero offset
			if ( jQuery.css( elem, "position" ) === "fixed" ) {
	
				// Assume position:fixed implies availability of getBoundingClientRect
				offset = elem.getBoundingClientRect();
	
			} else {
				offset = this.offset();
	
				// Account for the *real* offset parent, which can be the document or its root element
				// when a statically positioned element is identified
				doc = elem.ownerDocument;
				offsetParent = elem.offsetParent || doc.documentElement;
				while ( offsetParent &&
					( offsetParent === doc.body || offsetParent === doc.documentElement ) &&
					jQuery.css( offsetParent, "position" ) === "static" ) {
	
					offsetParent = offsetParent.parentNode;
				}
				if ( offsetParent && offsetParent !== elem && offsetParent.nodeType === 1 ) {
	
					// Incorporate borders into its offset, since they are outside its content origin
					parentOffset = jQuery( offsetParent ).offset();
					parentOffset.top += jQuery.css( offsetParent, "borderTopWidth", true );
					parentOffset.left += jQuery.css( offsetParent, "borderLeftWidth", true );
				}
			}
	
			// Subtract parent offsets and element margins
			return {
				top: offset.top - parentOffset.top - jQuery.css( elem, "marginTop", true ),
				left: offset.left - parentOffset.left - jQuery.css( elem, "marginLeft", true )
			};
		},
	
		// This method will return documentElement in the following cases:
		// 1) For the element inside the iframe without offsetParent, this method will return
		//    documentElement of the parent window
		// 2) For the hidden or detached element
		// 3) For body or html element, i.e. in case of the html node - it will return itself
		//
		// but those exceptions were never presented as a real life use-cases
		// and might be considered as more preferable results.
		//
		// This logic, however, is not guaranteed and can change at any point in the future
		offsetParent: function() {
			return this.map( function() {
				var offsetParent = this.offsetParent;
	
				while ( offsetParent && jQuery.css( offsetParent, "position" ) === "static" ) {
					offsetParent = offsetParent.offsetParent;
				}
	
				return offsetParent || documentElement;
			} );
		}
	} );
	
	// Create scrollLeft and scrollTop methods
	jQuery.each( { scrollLeft: "pageXOffset", scrollTop: "pageYOffset" }, function( method, prop ) {
		var top = "pageYOffset" === prop;
	
		jQuery.fn[ method ] = function( val ) {
			return access( this, function( elem, method, val ) {
	
				// Coalesce documents and windows
				var win;
				if ( isWindow( elem ) ) {
					win = elem;
				} else if ( elem.nodeType === 9 ) {
					win = elem.defaultView;
				}
	
				if ( val === undefined ) {
					return win ? win[ prop ] : elem[ method ];
				}
	
				if ( win ) {
					win.scrollTo(
						!top ? val : win.pageXOffset,
						top ? val : win.pageYOffset
					);
	
				} else {
					elem[ method ] = val;
				}
			}, method, val, arguments.length );
		};
	} );
	
	// Support: Safari <=7 - 9.1, Chrome <=37 - 49
	// Add the top/left cssHooks using jQuery.fn.position
	// Webkit bug: https://bugs.webkit.org/show_bug.cgi?id=29084
	// Blink bug: https://bugs.chromium.org/p/chromium/issues/detail?id=589347
	// getComputedStyle returns percent when specified for top/left/bottom/right;
	// rather than make the css module depend on the offset module, just check for it here
	jQuery.each( [ "top", "left" ], function( i, prop ) {
		jQuery.cssHooks[ prop ] = addGetHookIf( support.pixelPosition,
			function( elem, computed ) {
				if ( computed ) {
					computed = curCSS( elem, prop );
	
					// If curCSS returns percentage, fallback to offset
					return rnumnonpx.test( computed ) ?
						jQuery( elem ).position()[ prop ] + "px" :
						computed;
				}
			}
		);
	} );
	
	
	// Create innerHeight, innerWidth, height, width, outerHeight and outerWidth methods
	jQuery.each( { Height: "height", Width: "width" }, function( name, type ) {
		jQuery.each( { padding: "inner" + name, content: type, "": "outer" + name },
			function( defaultExtra, funcName ) {
	
			// Margin is only for outerHeight, outerWidth
			jQuery.fn[ funcName ] = function( margin, value ) {
				var chainable = arguments.length && ( defaultExtra || typeof margin !== "boolean" ),
					extra = defaultExtra || ( margin === true || value === true ? "margin" : "border" );
	
				return access( this, function( elem, type, value ) {
					var doc;
	
					if ( isWindow( elem ) ) {
	
						// $( window ).outerWidth/Height return w/h including scrollbars (gh-1729)
						return funcName.indexOf( "outer" ) === 0 ?
							elem[ "inner" + name ] :
							elem.document.documentElement[ "client" + name ];
					}
	
					// Get document width or height
					if ( elem.nodeType === 9 ) {
						doc = elem.documentElement;
	
						// Either scroll[Width/Height] or offset[Width/Height] or client[Width/Height],
						// whichever is greatest
						return Math.max(
							elem.body[ "scroll" + name ], doc[ "scroll" + name ],
							elem.body[ "offset" + name ], doc[ "offset" + name ],
							doc[ "client" + name ]
						);
					}
	
					return value === undefined ?
	
						// Get width or height on the element, requesting but not forcing parseFloat
						jQuery.css( elem, type, extra ) :
	
						// Set width or height on the element
						jQuery.style( elem, type, value, extra );
				}, type, chainable ? margin : undefined, chainable );
			};
		} );
	} );
	
	
	jQuery.each( ( "blur focus focusin focusout resize scroll click dblclick " +
		"mousedown mouseup mousemove mouseover mouseout mouseenter mouseleave " +
		"change select submit keydown keypress keyup contextmenu" ).split( " " ),
		function( i, name ) {
	
		// Handle event binding
		jQuery.fn[ name ] = function( data, fn ) {
			return arguments.length > 0 ?
				this.on( name, null, data, fn ) :
				this.trigger( name );
		};
	} );
	
	jQuery.fn.extend( {
		hover: function( fnOver, fnOut ) {
			return this.mouseenter( fnOver ).mouseleave( fnOut || fnOver );
		}
	} );
	
	
	
	
	jQuery.fn.extend( {
	
		bind: function( types, data, fn ) {
			return this.on( types, null, data, fn );
		},
		unbind: function( types, fn ) {
			return this.off( types, null, fn );
		},
	
		delegate: function( selector, types, data, fn ) {
			return this.on( types, selector, data, fn );
		},
		undelegate: function( selector, types, fn ) {
	
			// ( namespace ) or ( selector, types [, fn] )
			return arguments.length === 1 ?
				this.off( selector, "**" ) :
				this.off( types, selector || "**", fn );
		}
	} );
	
	// Bind a function to a context, optionally partially applying any
	// arguments.
	// jQuery.proxy is deprecated to promote standards (specifically Function#bind)
	// However, it is not slated for removal any time soon
	jQuery.proxy = function( fn, context ) {
		var tmp, args, proxy;
	
		if ( typeof context === "string" ) {
			tmp = fn[ context ];
			context = fn;
			fn = tmp;
		}
	
		// Quick check to determine if target is callable, in the spec
		// this throws a TypeError, but we will just return undefined.
		if ( !isFunction( fn ) ) {
			return undefined;
		}
	
		// Simulated bind
		args = slice.call( arguments, 2 );
		proxy = function() {
			return fn.apply( context || this, args.concat( slice.call( arguments ) ) );
		};
	
		// Set the guid of unique handler to the same of original handler, so it can be removed
		proxy.guid = fn.guid = fn.guid || jQuery.guid++;
	
		return proxy;
	};
	
	jQuery.holdReady = function( hold ) {
		if ( hold ) {
			jQuery.readyWait++;
		} else {
			jQuery.ready( true );
		}
	};
	jQuery.isArray = Array.isArray;
	jQuery.parseJSON = JSON.parse;
	jQuery.nodeName = nodeName;
	jQuery.isFunction = isFunction;
	jQuery.isWindow = isWindow;
	jQuery.camelCase = camelCase;
	jQuery.type = toType;
	
	jQuery.now = Date.now;
	
	jQuery.isNumeric = function( obj ) {
	
		// As of jQuery 3.0, isNumeric is limited to
		// strings and numbers (primitives or objects)
		// that can be coerced to finite numbers (gh-2662)
		var type = jQuery.type( obj );
		return ( type === "number" || type === "string" ) &&
	
			// parseFloat NaNs numeric-cast false positives ("")
			// ...but misinterprets leading-number strings, particularly hex literals ("0x...")
			// subtraction forces infinities to NaN
			!isNaN( obj - parseFloat( obj ) );
	};
	
	
	
	
	// Register as a named AMD module, since jQuery can be concatenated with other
	// files that may use define, but not via a proper concatenation script that
	// understands anonymous AMD modules. A named AMD is safest and most robust
	// way to register. Lowercase jquery is used because AMD module names are
	// derived from file names, and jQuery is normally delivered in a lowercase
	// file name. Do this after creating the global so that if an AMD module wants
	// to call noConflict to hide this version of jQuery, it will work.
	
	// Note that for maximum portability, libraries that are not jQuery should
	// declare themselves as anonymous modules, and avoid setting a global if an
	// AMD loader is present. jQuery is a special case. For more information, see
	// https://github.com/jrburke/requirejs/wiki/Updating-existing-libraries#wiki-anon
	
	if ( true ) {
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function() {
			return jQuery;
		}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	}
	
	
	
	
	var
	
		// Map over jQuery in case of overwrite
		_jQuery = window.jQuery,
	
		// Map over the $ in case of overwrite
		_$ = window.$;
	
	jQuery.noConflict = function( deep ) {
		if ( window.$ === jQuery ) {
			window.$ = _$;
		}
	
		if ( deep && window.jQuery === jQuery ) {
			window.jQuery = _jQuery;
		}
	
		return jQuery;
	};
	
	// Expose jQuery and $ identifiers, even in AMD
	// (#7102#comment:10, https://github.com/jquery/jquery/pull/557)
	// and CommonJS for browser emulators (#13566)
	if ( !noGlobal ) {
		window.jQuery = window.$ = jQuery;
	}
	
	
	
	
	return jQuery;
	} );


/***/ },
/* 357 */
/***/ function(module, exports, __webpack_require__) {

	var ListCache = __webpack_require__(174),
	    stackClear = __webpack_require__(922),
	    stackDelete = __webpack_require__(923),
	    stackGet = __webpack_require__(924),
	    stackHas = __webpack_require__(925),
	    stackSet = __webpack_require__(926);
	
	/**
	 * Creates a stack cache object to store key-value pairs.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function Stack(entries) {
	  var data = this.__data__ = new ListCache(entries);
	  this.size = data.size;
	}
	
	// Add methods to `Stack`.
	Stack.prototype.clear = stackClear;
	Stack.prototype['delete'] = stackDelete;
	Stack.prototype.get = stackGet;
	Stack.prototype.has = stackHas;
	Stack.prototype.set = stackSet;
	
	module.exports = Stack;


/***/ },
/* 358 */
/***/ function(module, exports) {

	/**
	 * A specialized version of `_.some` for arrays without support for iteratee
	 * shorthands.
	 *
	 * @private
	 * @param {Array} [array] The array to iterate over.
	 * @param {Function} predicate The function invoked per iteration.
	 * @returns {boolean} Returns `true` if any element passes the predicate check,
	 *  else `false`.
	 */
	function arraySome(array, predicate) {
	  var index = -1,
	      length = array == null ? 0 : array.length;
	
	  while (++index < length) {
	    if (predicate(array[index], index, array)) {
	      return true;
	    }
	  }
	  return false;
	}
	
	module.exports = arraySome;


/***/ },
/* 359 */
/***/ function(module, exports, __webpack_require__) {

	var castPath = __webpack_require__(360),
	    toKey = __webpack_require__(179);
	
	/**
	 * The base implementation of `_.get` without support for default values.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {Array|string} path The path of the property to get.
	 * @returns {*} Returns the resolved value.
	 */
	function baseGet(object, path) {
	  path = castPath(path, object);
	
	  var index = 0,
	      length = path.length;
	
	  while (object != null && index < length) {
	    object = object[toKey(path[index++])];
	  }
	  return (index && index == length) ? object : undefined;
	}
	
	module.exports = baseGet;


/***/ },
/* 360 */
/***/ function(module, exports, __webpack_require__) {

	var isArray = __webpack_require__(90),
	    isKey = __webpack_require__(243),
	    stringToPath = __webpack_require__(927),
	    toString = __webpack_require__(940);
	
	/**
	 * Casts `value` to a path array if it's not one.
	 *
	 * @private
	 * @param {*} value The value to inspect.
	 * @param {Object} [object] The object to query keys on.
	 * @returns {Array} Returns the cast property path array.
	 */
	function castPath(value, object) {
	  if (isArray(value)) {
	    return value;
	  }
	  return isKey(value, object) ? [value] : stringToPath(toString(value));
	}
	
	module.exports = castPath;


/***/ },
/* 361 */
/***/ function(module, exports, __webpack_require__) {

	var SetCache = __webpack_require__(853),
	    arraySome = __webpack_require__(358),
	    cacheHas = __webpack_require__(880);
	
	/** Used to compose bitmasks for value comparisons. */
	var COMPARE_PARTIAL_FLAG = 1,
	    COMPARE_UNORDERED_FLAG = 2;
	
	/**
	 * A specialized version of `baseIsEqualDeep` for arrays with support for
	 * partial deep comparisons.
	 *
	 * @private
	 * @param {Array} array The array to compare.
	 * @param {Array} other The other array to compare.
	 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	 * @param {Function} customizer The function to customize comparisons.
	 * @param {Function} equalFunc The function to determine equivalents of values.
	 * @param {Object} stack Tracks traversed `array` and `other` objects.
	 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
	 */
	function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
	  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
	      arrLength = array.length,
	      othLength = other.length;
	
	  if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
	    return false;
	  }
	  // Assume cyclic values are equal.
	  var stacked = stack.get(array);
	  if (stacked && stack.get(other)) {
	    return stacked == other;
	  }
	  var index = -1,
	      result = true,
	      seen = (bitmask & COMPARE_UNORDERED_FLAG) ? new SetCache : undefined;
	
	  stack.set(array, other);
	  stack.set(other, array);
	
	  // Ignore non-index properties.
	  while (++index < arrLength) {
	    var arrValue = array[index],
	        othValue = other[index];
	
	    if (customizer) {
	      var compared = isPartial
	        ? customizer(othValue, arrValue, index, other, array, stack)
	        : customizer(arrValue, othValue, index, array, other, stack);
	    }
	    if (compared !== undefined) {
	      if (compared) {
	        continue;
	      }
	      result = false;
	      break;
	    }
	    // Recursively compare arrays (susceptible to call stack limits).
	    if (seen) {
	      if (!arraySome(other, function(othValue, othIndex) {
	            if (!cacheHas(seen, othIndex) &&
	                (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
	              return seen.push(othIndex);
	            }
	          })) {
	        result = false;
	        break;
	      }
	    } else if (!(
	          arrValue === othValue ||
	            equalFunc(arrValue, othValue, bitmask, customizer, stack)
	        )) {
	      result = false;
	      break;
	    }
	  }
	  stack['delete'](array);
	  stack['delete'](other);
	  return result;
	}
	
	module.exports = equalArrays;


/***/ },
/* 362 */
/***/ function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {/** Detect free variable `global` from Node.js. */
	var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;
	
	module.exports = freeGlobal;
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 363 */
/***/ function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(142);
	
	/**
	 * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` if suitable for strict
	 *  equality comparisons, else `false`.
	 */
	function isStrictComparable(value) {
	  return value === value && !isObject(value);
	}
	
	module.exports = isStrictComparable;


/***/ },
/* 364 */
/***/ function(module, exports) {

	/**
	 * A specialized version of `matchesProperty` for source values suitable
	 * for strict equality comparisons, i.e. `===`.
	 *
	 * @private
	 * @param {string} key The key of the property to get.
	 * @param {*} srcValue The value to match.
	 * @returns {Function} Returns the new spec function.
	 */
	function matchesStrictComparable(key, srcValue) {
	  return function(object) {
	    if (object == null) {
	      return false;
	    }
	    return object[key] === srcValue &&
	      (srcValue !== undefined || (key in Object(object)));
	  };
	}
	
	module.exports = matchesStrictComparable;


/***/ },
/* 365 */
/***/ function(module, exports) {

	/**
	 * Creates a unary function that invokes `func` with its argument transformed.
	 *
	 * @private
	 * @param {Function} func The function to wrap.
	 * @param {Function} transform The argument transform.
	 * @returns {Function} Returns the new function.
	 */
	function overArg(func, transform) {
	  return function(arg) {
	    return func(transform(arg));
	  };
	}
	
	module.exports = overArg;


/***/ },
/* 366 */
/***/ function(module, exports) {

	/** Used for built-in method references. */
	var funcProto = Function.prototype;
	
	/** Used to resolve the decompiled source of functions. */
	var funcToString = funcProto.toString;
	
	/**
	 * Converts `func` to its source code.
	 *
	 * @private
	 * @param {Function} func The function to convert.
	 * @returns {string} Returns the source code.
	 */
	function toSource(func) {
	  if (func != null) {
	    try {
	      return funcToString.call(func);
	    } catch (e) {}
	    try {
	      return (func + '');
	    } catch (e) {}
	  }
	  return '';
	}
	
	module.exports = toSource;


/***/ },
/* 367 */
/***/ function(module, exports, __webpack_require__) {

	var createFind = __webpack_require__(884),
	    findIndex = __webpack_require__(928);
	
	/**
	 * Iterates over elements of `collection`, returning the first element
	 * `predicate` returns truthy for. The predicate is invoked with three
	 * arguments: (value, index|key, collection).
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Collection
	 * @param {Array|Object} collection The collection to inspect.
	 * @param {Function} [predicate=_.identity] The function invoked per iteration.
	 * @param {number} [fromIndex=0] The index to search from.
	 * @returns {*} Returns the matched element, else `undefined`.
	 * @example
	 *
	 * var users = [
	 *   { 'user': 'barney',  'age': 36, 'active': true },
	 *   { 'user': 'fred',    'age': 40, 'active': false },
	 *   { 'user': 'pebbles', 'age': 1,  'active': true }
	 * ];
	 *
	 * _.find(users, function(o) { return o.age < 40; });
	 * // => object for 'barney'
	 *
	 * // The `_.matches` iteratee shorthand.
	 * _.find(users, { 'age': 1, 'active': true });
	 * // => object for 'pebbles'
	 *
	 * // The `_.matchesProperty` iteratee shorthand.
	 * _.find(users, ['active', false]);
	 * // => object for 'fred'
	 *
	 * // The `_.property` iteratee shorthand.
	 * _.find(users, 'active');
	 * // => object for 'barney'
	 */
	var find = createFind(findIndex);
	
	module.exports = find;


/***/ },
/* 368 */
/***/ function(module, exports, __webpack_require__) {

	var baseIsArguments = __webpack_require__(866),
	    isObjectLike = __webpack_require__(126);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/** Built-in value references. */
	var propertyIsEnumerable = objectProto.propertyIsEnumerable;
	
	/**
	 * Checks if `value` is likely an `arguments` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
	 *  else `false`.
	 * @example
	 *
	 * _.isArguments(function() { return arguments; }());
	 * // => true
	 *
	 * _.isArguments([1, 2, 3]);
	 * // => false
	 */
	var isArguments = baseIsArguments(function() { return arguments; }()) ? baseIsArguments : function(value) {
	  return isObjectLike(value) && hasOwnProperty.call(value, 'callee') &&
	    !propertyIsEnumerable.call(value, 'callee');
	};
	
	module.exports = isArguments;


/***/ },
/* 369 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var root = __webpack_require__(89),
	    stubFalse = __webpack_require__(936);
	
	/** Detect free variable `exports`. */
	var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;
	
	/** Detect free variable `module`. */
	var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;
	
	/** Detect the popular CommonJS extension `module.exports`. */
	var moduleExports = freeModule && freeModule.exports === freeExports;
	
	/** Built-in value references. */
	var Buffer = moduleExports ? root.Buffer : undefined;
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;
	
	/**
	 * Checks if `value` is a buffer.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.3.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
	 * @example
	 *
	 * _.isBuffer(new Buffer(2));
	 * // => true
	 *
	 * _.isBuffer(new Uint8Array(2));
	 * // => false
	 */
	var isBuffer = nativeIsBuffer || stubFalse;
	
	module.exports = isBuffer;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(192)(module)))

/***/ },
/* 370 */
/***/ function(module, exports, __webpack_require__) {

	var baseIsEqual = __webpack_require__(240);
	
	/**
	 * Performs a deep comparison between two values to determine if they are
	 * equivalent.
	 *
	 * **Note:** This method supports comparing arrays, array buffers, booleans,
	 * date objects, error objects, maps, numbers, `Object` objects, regexes,
	 * sets, strings, symbols, and typed arrays. `Object` objects are compared
	 * by their own, not inherited, enumerable properties. Functions and DOM
	 * nodes are compared by strict equality, i.e. `===`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to compare.
	 * @param {*} other The other value to compare.
	 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	 * @example
	 *
	 * var object = { 'a': 1 };
	 * var other = { 'a': 1 };
	 *
	 * _.isEqual(object, other);
	 * // => true
	 *
	 * object === other;
	 * // => false
	 */
	function isEqual(value, other) {
	  return baseIsEqual(value, other);
	}
	
	module.exports = isEqual;


/***/ },
/* 371 */
/***/ function(module, exports, __webpack_require__) {

	var baseGetTag = __webpack_require__(124),
	    isObject = __webpack_require__(142);
	
	/** `Object#toString` result references. */
	var asyncTag = '[object AsyncFunction]',
	    funcTag = '[object Function]',
	    genTag = '[object GeneratorFunction]',
	    proxyTag = '[object Proxy]';
	
	/**
	 * Checks if `value` is classified as a `Function` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
	 * @example
	 *
	 * _.isFunction(_);
	 * // => true
	 *
	 * _.isFunction(/abc/);
	 * // => false
	 */
	function isFunction(value) {
	  if (!isObject(value)) {
	    return false;
	  }
	  // The use of `Object#toString` avoids issues with the `typeof` operator
	  // in Safari 9 which returns 'object' for typed arrays and other constructors.
	  var tag = baseGetTag(value);
	  return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
	}
	
	module.exports = isFunction;


/***/ },
/* 372 */
/***/ function(module, exports, __webpack_require__) {

	var baseIsTypedArray = __webpack_require__(870),
	    baseUnary = __webpack_require__(879),
	    nodeUtil = __webpack_require__(917);
	
	/* Node.js helper references. */
	var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;
	
	/**
	 * Checks if `value` is classified as a typed array.
	 *
	 * @static
	 * @memberOf _
	 * @since 3.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
	 * @example
	 *
	 * _.isTypedArray(new Uint8Array);
	 * // => true
	 *
	 * _.isTypedArray([]);
	 * // => false
	 */
	var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;
	
	module.exports = isTypedArray;


/***/ },
/* 373 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * mux.js
	 *
	 * Copyright (c) 2015 Brightcove
	 * All rights reserved.
	 *
	 * Reads in-band caption information from a video elementary
	 * stream. Captions must follow the CEA-708 standard for injection
	 * into an MPEG-2 transport streams.
	 * @see https://en.wikipedia.org/wiki/CEA-708
	 * @see https://www.gpo.gov/fdsys/pkg/CFR-2007-title47-vol1/pdf/CFR-2007-title47-vol1-sec15-119.pdf
	 */
	
	'use strict';
	
	// -----------------
	// Link To Transport
	// -----------------
	
	var Stream = __webpack_require__(99);
	var cea708Parser = __webpack_require__(376);
	
	var CaptionStream = function() {
	
	  CaptionStream.prototype.init.call(this);
	
	  this.captionPackets_ = [];
	
	  this.ccStreams_ = [
	    new Cea608Stream(0, 0), // eslint-disable-line no-use-before-define
	    new Cea608Stream(0, 1), // eslint-disable-line no-use-before-define
	    new Cea608Stream(1, 0), // eslint-disable-line no-use-before-define
	    new Cea608Stream(1, 1) // eslint-disable-line no-use-before-define
	  ];
	
	  this.reset();
	
	  // forward data and done events from CCs to this CaptionStream
	  this.ccStreams_.forEach(function(cc) {
	    cc.on('data', this.trigger.bind(this, 'data'));
	    cc.on('done', this.trigger.bind(this, 'done'));
	  }, this);
	
	};
	
	CaptionStream.prototype = new Stream();
	CaptionStream.prototype.push = function(event) {
	  var sei, userData, newCaptionPackets;
	
	  // only examine SEI NALs
	  if (event.nalUnitType !== 'sei_rbsp') {
	    return;
	  }
	
	  // parse the sei
	  sei = cea708Parser.parseSei(event.escapedRBSP);
	
	  // ignore everything but user_data_registered_itu_t_t35
	  if (sei.payloadType !== cea708Parser.USER_DATA_REGISTERED_ITU_T_T35) {
	    return;
	  }
	
	  // parse out the user data payload
	  userData = cea708Parser.parseUserData(sei);
	
	  // ignore unrecognized userData
	  if (!userData) {
	    return;
	  }
	
	  // Sometimes, the same segment # will be downloaded twice. To stop the
	  // caption data from being processed twice, we track the latest dts we've
	  // received and ignore everything with a dts before that. However, since
	  // data for a specific dts can be split across packets on either side of
	  // a segment boundary, we need to make sure we *don't* ignore the packets
	  // from the *next* segment that have dts === this.latestDts_. By constantly
	  // tracking the number of packets received with dts === this.latestDts_, we
	  // know how many should be ignored once we start receiving duplicates.
	  if (event.dts < this.latestDts_) {
	    // We've started getting older data, so set the flag.
	    this.ignoreNextEqualDts_ = true;
	    return;
	  } else if ((event.dts === this.latestDts_) && (this.ignoreNextEqualDts_)) {
	    this.numSameDts_--;
	    if (!this.numSameDts_) {
	      // We've received the last duplicate packet, time to start processing again
	      this.ignoreNextEqualDts_ = false;
	    }
	    return;
	  }
	
	  // parse out CC data packets and save them for later
	  newCaptionPackets = cea708Parser.parseCaptionPackets(event.pts, userData);
	  this.captionPackets_ = this.captionPackets_.concat(newCaptionPackets);
	  if (this.latestDts_ !== event.dts) {
	    this.numSameDts_ = 0;
	  }
	  this.numSameDts_++;
	  this.latestDts_ = event.dts;
	};
	
	CaptionStream.prototype.flush = function() {
	  // make sure we actually parsed captions before proceeding
	  if (!this.captionPackets_.length) {
	    this.ccStreams_.forEach(function(cc) {
	      cc.flush();
	    }, this);
	    return;
	  }
	
	  // In Chrome, the Array#sort function is not stable so add a
	  // presortIndex that we can use to ensure we get a stable-sort
	  this.captionPackets_.forEach(function(elem, idx) {
	    elem.presortIndex = idx;
	  });
	
	  // sort caption byte-pairs based on their PTS values
	  this.captionPackets_.sort(function(a, b) {
	    if (a.pts === b.pts) {
	      return a.presortIndex - b.presortIndex;
	    }
	    return a.pts - b.pts;
	  });
	
	  this.captionPackets_.forEach(function(packet) {
	    if (packet.type < 2) {
	      // Dispatch packet to the right Cea608Stream
	      this.dispatchCea608Packet(packet);
	    }
	    // this is where an 'else' would go for a dispatching packets
	    // to a theoretical Cea708Stream that handles SERVICEn data
	  }, this);
	
	  this.captionPackets_.length = 0;
	  this.ccStreams_.forEach(function(cc) {
	    cc.flush();
	  }, this);
	  return;
	};
	
	CaptionStream.prototype.reset = function() {
	  this.latestDts_ = null;
	  this.ignoreNextEqualDts_ = false;
	  this.numSameDts_ = 0;
	  this.activeCea608Channel_ = [null, null];
	  this.ccStreams_.forEach(function(ccStream) {
	    ccStream.reset();
	  });
	};
	
	CaptionStream.prototype.dispatchCea608Packet = function(packet) {
	  // NOTE: packet.type is the CEA608 field
	  if (this.setsChannel1Active(packet)) {
	    this.activeCea608Channel_[packet.type] = 0;
	  } else if (this.setsChannel2Active(packet)) {
	    this.activeCea608Channel_[packet.type] = 1;
	  }
	  if (this.activeCea608Channel_[packet.type] === null) {
	    // If we haven't received anything to set the active channel, discard the
	    // data; we don't want jumbled captions
	    return;
	  }
	  this.ccStreams_[(packet.type << 1) + this.activeCea608Channel_[packet.type]].push(packet);
	};
	
	CaptionStream.prototype.setsChannel1Active = function(packet) {
	  return ((packet.ccData & 0x7800) === 0x1000);
	};
	CaptionStream.prototype.setsChannel2Active = function(packet) {
	  return ((packet.ccData & 0x7800) === 0x1800);
	};
	
	// ----------------------
	// Session to Application
	// ----------------------
	
	// This hash maps non-ASCII, special, and extended character codes to their
	// proper Unicode equivalent. The first keys that are only a single byte
	// are the non-standard ASCII characters, which simply map the CEA608 byte
	// to the standard ASCII/Unicode. The two-byte keys that follow are the CEA608
	// character codes, but have their MSB bitmasked with 0x03 so that a lookup
	// can be performed regardless of the field and data channel on which the
	// character code was received.
	var CHARACTER_TRANSLATION = {
	  0x2a: 0xe1,     // á
	  0x5c: 0xe9,     // é
	  0x5e: 0xed,     // í
	  0x5f: 0xf3,     // ó
	  0x60: 0xfa,     // ú
	  0x7b: 0xe7,     // ç
	  0x7c: 0xf7,     // ÷
	  0x7d: 0xd1,     // Ñ
	  0x7e: 0xf1,     // ñ
	  0x7f: 0x2588,   // █
	  0x0130: 0xae,   // ®
	  0x0131: 0xb0,   // °
	  0x0132: 0xbd,   // ½
	  0x0133: 0xbf,   // ¿
	  0x0134: 0x2122, // ™
	  0x0135: 0xa2,   // ¢
	  0x0136: 0xa3,   // £
	  0x0137: 0x266a, // ♪
	  0x0138: 0xe0,   // à
	  0x0139: 0xa0,   //
	  0x013a: 0xe8,   // è
	  0x013b: 0xe2,   // â
	  0x013c: 0xea,   // ê
	  0x013d: 0xee,   // î
	  0x013e: 0xf4,   // ô
	  0x013f: 0xfb,   // û
	  0x0220: 0xc1,   // Á
	  0x0221: 0xc9,   // É
	  0x0222: 0xd3,   // Ó
	  0x0223: 0xda,   // Ú
	  0x0224: 0xdc,   // Ü
	  0x0225: 0xfc,   // ü
	  0x0226: 0x2018, // ‘
	  0x0227: 0xa1,   // ¡
	  0x0228: 0x2a,   // *
	  0x0229: 0x27,   // '
	  0x022a: 0x2014, // —
	  0x022b: 0xa9,   // ©
	  0x022c: 0x2120, // ℠
	  0x022d: 0x2022, // •
	  0x022e: 0x201c, // “
	  0x022f: 0x201d, // ”
	  0x0230: 0xc0,   // À
	  0x0231: 0xc2,   // Â
	  0x0232: 0xc7,   // Ç
	  0x0233: 0xc8,   // È
	  0x0234: 0xca,   // Ê
	  0x0235: 0xcb,   // Ë
	  0x0236: 0xeb,   // ë
	  0x0237: 0xce,   // Î
	  0x0238: 0xcf,   // Ï
	  0x0239: 0xef,   // ï
	  0x023a: 0xd4,   // Ô
	  0x023b: 0xd9,   // Ù
	  0x023c: 0xf9,   // ù
	  0x023d: 0xdb,   // Û
	  0x023e: 0xab,   // «
	  0x023f: 0xbb,   // »
	  0x0320: 0xc3,   // Ã
	  0x0321: 0xe3,   // ã
	  0x0322: 0xcd,   // Í
	  0x0323: 0xcc,   // Ì
	  0x0324: 0xec,   // ì
	  0x0325: 0xd2,   // Ò
	  0x0326: 0xf2,   // ò
	  0x0327: 0xd5,   // Õ
	  0x0328: 0xf5,   // õ
	  0x0329: 0x7b,   // {
	  0x032a: 0x7d,   // }
	  0x032b: 0x5c,   // \
	  0x032c: 0x5e,   // ^
	  0x032d: 0x5f,   // _
	  0x032e: 0x7c,   // |
	  0x032f: 0x7e,   // ~
	  0x0330: 0xc4,   // Ä
	  0x0331: 0xe4,   // ä
	  0x0332: 0xd6,   // Ö
	  0x0333: 0xf6,   // ö
	  0x0334: 0xdf,   // ß
	  0x0335: 0xa5,   // ¥
	  0x0336: 0xa4,   // ¤
	  0x0337: 0x2502, // │
	  0x0338: 0xc5,   // Å
	  0x0339: 0xe5,   // å
	  0x033a: 0xd8,   // Ø
	  0x033b: 0xf8,   // ø
	  0x033c: 0x250c, // ┌
	  0x033d: 0x2510, // ┐
	  0x033e: 0x2514, // └
	  0x033f: 0x2518  // ┘
	};
	
	var getCharFromCode = function(code) {
	  if (code === null) {
	    return '';
	  }
	  code = CHARACTER_TRANSLATION[code] || code;
	  return String.fromCharCode(code);
	};
	
	// the index of the last row in a CEA-608 display buffer
	var BOTTOM_ROW = 14;
	
	// This array is used for mapping PACs -> row #, since there's no way of
	// getting it through bit logic.
	var ROWS = [0x1100, 0x1120, 0x1200, 0x1220, 0x1500, 0x1520, 0x1600, 0x1620,
	            0x1700, 0x1720, 0x1000, 0x1300, 0x1320, 0x1400, 0x1420];
	
	// CEA-608 captions are rendered onto a 34x15 matrix of character
	// cells. The "bottom" row is the last element in the outer array.
	var createDisplayBuffer = function() {
	  var result = [], i = BOTTOM_ROW + 1;
	  while (i--) {
	    result.push('');
	  }
	  return result;
	};
	
	var Cea608Stream = function(field, dataChannel) {
	  Cea608Stream.prototype.init.call(this);
	
	  this.field_ = field || 0;
	  this.dataChannel_ = dataChannel || 0;
	
	  this.name_ = 'CC' + (((this.field_ << 1) | this.dataChannel_) + 1);
	
	  this.setConstants();
	  this.reset();
	
	  this.push = function(packet) {
	    var data, swap, char0, char1, text;
	    // remove the parity bits
	    data = packet.ccData & 0x7f7f;
	
	    // ignore duplicate control codes; the spec demands they're sent twice
	    if (data === this.lastControlCode_) {
	      this.lastControlCode_ = null;
	      return;
	    }
	
	    // Store control codes
	    if ((data & 0xf000) === 0x1000) {
	      this.lastControlCode_ = data;
	    } else if (data !== this.PADDING_) {
	      this.lastControlCode_ = null;
	    }
	
	    char0 = data >>> 8;
	    char1 = data & 0xff;
	
	    if (data === this.PADDING_) {
	      return;
	
	    } else if (data === this.RESUME_CAPTION_LOADING_) {
	      this.mode_ = 'popOn';
	
	    } else if (data === this.END_OF_CAPTION_) {
	      // If an EOC is received while in paint-on mode, the displayed caption
	      // text should be swapped to non-displayed memory as if it was a pop-on
	      // caption. Because of that, we should explicitly switch back to pop-on
	      // mode
	      this.mode_ = 'popOn';
	      this.clearFormatting(packet.pts);
	      // if a caption was being displayed, it's gone now
	      this.flushDisplayed(packet.pts);
	
	      // flip memory
	      swap = this.displayed_;
	      this.displayed_ = this.nonDisplayed_;
	      this.nonDisplayed_ = swap;
	
	      // start measuring the time to display the caption
	      this.startPts_ = packet.pts;
	
	    } else if (data === this.ROLL_UP_2_ROWS_) {
	      this.rollUpRows_ = 2;
	      this.setRollUp(packet.pts);
	    } else if (data === this.ROLL_UP_3_ROWS_) {
	      this.rollUpRows_ = 3;
	      this.setRollUp(packet.pts);
	    } else if (data === this.ROLL_UP_4_ROWS_) {
	      this.rollUpRows_ = 4;
	      this.setRollUp(packet.pts);
	    } else if (data === this.CARRIAGE_RETURN_) {
	      this.clearFormatting(packet.pts);
	      this.flushDisplayed(packet.pts);
	      this.shiftRowsUp_();
	      this.startPts_ = packet.pts;
	
	    } else if (data === this.BACKSPACE_) {
	      if (this.mode_ === 'popOn') {
	        this.nonDisplayed_[this.row_] = this.nonDisplayed_[this.row_].slice(0, -1);
	      } else {
	        this.displayed_[this.row_] = this.displayed_[this.row_].slice(0, -1);
	      }
	    } else if (data === this.ERASE_DISPLAYED_MEMORY_) {
	      this.flushDisplayed(packet.pts);
	      this.displayed_ = createDisplayBuffer();
	    } else if (data === this.ERASE_NON_DISPLAYED_MEMORY_) {
	      this.nonDisplayed_ = createDisplayBuffer();
	
	    } else if (data === this.RESUME_DIRECT_CAPTIONING_) {
	      if (this.mode_ !== 'paintOn') {
	        // NOTE: This should be removed when proper caption positioning is
	        // implemented
	        this.flushDisplayed(packet.pts);
	        this.displayed_ = createDisplayBuffer();
	      }
	      this.mode_ = 'paintOn';
	      this.startPts_ = packet.pts;
	
	    // Append special characters to caption text
	    } else if (this.isSpecialCharacter(char0, char1)) {
	      // Bitmask char0 so that we can apply character transformations
	      // regardless of field and data channel.
	      // Then byte-shift to the left and OR with char1 so we can pass the
	      // entire character code to `getCharFromCode`.
	      char0 = (char0 & 0x03) << 8;
	      text = getCharFromCode(char0 | char1);
	      this[this.mode_](packet.pts, text);
	      this.column_++;
	
	    // Append extended characters to caption text
	    } else if (this.isExtCharacter(char0, char1)) {
	      // Extended characters always follow their "non-extended" equivalents.
	      // IE if a "è" is desired, you'll always receive "eè"; non-compliant
	      // decoders are supposed to drop the "è", while compliant decoders
	      // backspace the "e" and insert "è".
	
	      // Delete the previous character
	      if (this.mode_ === 'popOn') {
	        this.nonDisplayed_[this.row_] = this.nonDisplayed_[this.row_].slice(0, -1);
	      } else {
	        this.displayed_[this.row_] = this.displayed_[this.row_].slice(0, -1);
	      }
	
	      // Bitmask char0 so that we can apply character transformations
	      // regardless of field and data channel.
	      // Then byte-shift to the left and OR with char1 so we can pass the
	      // entire character code to `getCharFromCode`.
	      char0 = (char0 & 0x03) << 8;
	      text = getCharFromCode(char0 | char1);
	      this[this.mode_](packet.pts, text);
	      this.column_++;
	
	    // Process mid-row codes
	    } else if (this.isMidRowCode(char0, char1)) {
	      // Attributes are not additive, so clear all formatting
	      this.clearFormatting(packet.pts);
	
	      // According to the standard, mid-row codes
	      // should be replaced with spaces, so add one now
	      this[this.mode_](packet.pts, ' ');
	      this.column_++;
	
	      if ((char1 & 0xe) === 0xe) {
	        this.addFormatting(packet.pts, ['i']);
	      }
	
	      if ((char1 & 0x1) === 0x1) {
	        this.addFormatting(packet.pts, ['u']);
	      }
	
	    // Detect offset control codes and adjust cursor
	    } else if (this.isOffsetControlCode(char0, char1)) {
	      // Cursor position is set by indent PAC (see below) in 4-column
	      // increments, with an additional offset code of 1-3 to reach any
	      // of the 32 columns specified by CEA-608. So all we need to do
	      // here is increment the column cursor by the given offset.
	      this.column_ += (char1 & 0x03);
	
	    // Detect PACs (Preamble Address Codes)
	    } else if (this.isPAC(char0, char1)) {
	
	      // There's no logic for PAC -> row mapping, so we have to just
	      // find the row code in an array and use its index :(
	      var row = ROWS.indexOf(data & 0x1f20);
	
	      // Configure the caption window if we're in roll-up mode
	      if (this.mode_ === 'rollUp') {
	        this.setRollUp(packet.pts, row);
	      }
	
	      if (row !== this.row_) {
	        // formatting is only persistent for current row
	        this.clearFormatting(packet.pts);
	        this.row_ = row;
	      }
	      // All PACs can apply underline, so detect and apply
	      // (All odd-numbered second bytes set underline)
	      if ((char1 & 0x1) && (this.formatting_.indexOf('u') === -1)) {
	          this.addFormatting(packet.pts, ['u']);
	      }
	
	      if ((data & 0x10) === 0x10) {
	        // We've got an indent level code. Each successive even number
	        // increments the column cursor by 4, so we can get the desired
	        // column position by bit-shifting to the right (to get n/2)
	        // and multiplying by 4.
	        this.column_ = ((data & 0xe) >> 1) * 4;
	      }
	
	      if (this.isColorPAC(char1)) {
	        // it's a color code, though we only support white, which
	        // can be either normal or italicized. white italics can be
	        // either 0x4e or 0x6e depending on the row, so we just
	        // bitwise-and with 0xe to see if italics should be turned on
	        if ((char1 & 0xe) === 0xe) {
	          this.addFormatting(packet.pts, ['i']);
	        }
	      }
	
	    // We have a normal character in char0, and possibly one in char1
	    } else if (this.isNormalChar(char0)) {
	      if (char1 === 0x00) {
	        char1 = null;
	      }
	      text = getCharFromCode(char0);
	      text += getCharFromCode(char1);
	      this[this.mode_](packet.pts, text);
	      this.column_ += text.length;
	
	    } // finish data processing
	
	  };
	};
	Cea608Stream.prototype = new Stream();
	// Trigger a cue point that captures the current state of the
	// display buffer
	Cea608Stream.prototype.flushDisplayed = function(pts) {
	  var content = this.displayed_
	    // remove spaces from the start and end of the string
	    .map(function(row) {
	      return row.trim();
	    })
	    // combine all text rows to display in one cue
	    .join('\n')
	    // and remove blank rows from the start and end, but not the middle
	    .replace(/^\n+|\n+$/g, '');
	
	  if (content.length) {
	    this.trigger('data', {
	      startPts: this.startPts_,
	      endPts: pts,
	      text: content,
	      stream: this.name_
	    });
	  }
	};
	
	/**
	 * Zero out the data, used for startup and on seek
	 */
	Cea608Stream.prototype.reset = function() {
	  this.mode_ = 'popOn';
	  // When in roll-up mode, the index of the last row that will
	  // actually display captions. If a caption is shifted to a row
	  // with a lower index than this, it is cleared from the display
	  // buffer
	  this.topRow_ = 0;
	  this.startPts_ = 0;
	  this.displayed_ = createDisplayBuffer();
	  this.nonDisplayed_ = createDisplayBuffer();
	  this.lastControlCode_ = null;
	
	  // Track row and column for proper line-breaking and spacing
	  this.column_ = 0;
	  this.row_ = BOTTOM_ROW;
	  this.rollUpRows_ = 2;
	
	  // This variable holds currently-applied formatting
	  this.formatting_ = [];
	};
	
	/**
	 * Sets up control code and related constants for this instance
	 */
	Cea608Stream.prototype.setConstants = function() {
	  // The following attributes have these uses:
	  // ext_ :    char0 for mid-row codes, and the base for extended
	  //           chars (ext_+0, ext_+1, and ext_+2 are char0s for
	  //           extended codes)
	  // control_: char0 for control codes, except byte-shifted to the
	  //           left so that we can do this.control_ | CONTROL_CODE
	  // offset_:  char0 for tab offset codes
	  //
	  // It's also worth noting that control codes, and _only_ control codes,
	  // differ between field 1 and field2. Field 2 control codes are always
	  // their field 1 value plus 1. That's why there's the "| field" on the
	  // control value.
	  if (this.dataChannel_ === 0) {
	    this.BASE_     = 0x10;
	    this.EXT_      = 0x11;
	    this.CONTROL_  = (0x14 | this.field_) << 8;
	    this.OFFSET_   = 0x17;
	  } else if (this.dataChannel_ === 1) {
	    this.BASE_     = 0x18;
	    this.EXT_      = 0x19;
	    this.CONTROL_  = (0x1c | this.field_) << 8;
	    this.OFFSET_   = 0x1f;
	  }
	
	  // Constants for the LSByte command codes recognized by Cea608Stream. This
	  // list is not exhaustive. For a more comprehensive listing and semantics see
	  // http://www.gpo.gov/fdsys/pkg/CFR-2010-title47-vol1/pdf/CFR-2010-title47-vol1-sec15-119.pdf
	  // Padding
	  this.PADDING_                    = 0x0000;
	  // Pop-on Mode
	  this.RESUME_CAPTION_LOADING_     = this.CONTROL_ | 0x20;
	  this.END_OF_CAPTION_             = this.CONTROL_ | 0x2f;
	  // Roll-up Mode
	  this.ROLL_UP_2_ROWS_             = this.CONTROL_ | 0x25;
	  this.ROLL_UP_3_ROWS_             = this.CONTROL_ | 0x26;
	  this.ROLL_UP_4_ROWS_             = this.CONTROL_ | 0x27;
	  this.CARRIAGE_RETURN_            = this.CONTROL_ | 0x2d;
	  // paint-on mode
	  this.RESUME_DIRECT_CAPTIONING_   = this.CONTROL_ | 0x29;
	  // Erasure
	  this.BACKSPACE_                  = this.CONTROL_ | 0x21;
	  this.ERASE_DISPLAYED_MEMORY_     = this.CONTROL_ | 0x2c;
	  this.ERASE_NON_DISPLAYED_MEMORY_ = this.CONTROL_ | 0x2e;
	};
	
	/**
	 * Detects if the 2-byte packet data is a special character
	 *
	 * Special characters have a second byte in the range 0x30 to 0x3f,
	 * with the first byte being 0x11 (for data channel 1) or 0x19 (for
	 * data channel 2).
	 *
	 * @param  {Integer} char0 The first byte
	 * @param  {Integer} char1 The second byte
	 * @return {Boolean}       Whether the 2 bytes are an special character
	 */
	Cea608Stream.prototype.isSpecialCharacter = function(char0, char1) {
	  return (char0 === this.EXT_ && char1 >= 0x30 && char1 <= 0x3f);
	};
	
	/**
	 * Detects if the 2-byte packet data is an extended character
	 *
	 * Extended characters have a second byte in the range 0x20 to 0x3f,
	 * with the first byte being 0x12 or 0x13 (for data channel 1) or
	 * 0x1a or 0x1b (for data channel 2).
	 *
	 * @param  {Integer} char0 The first byte
	 * @param  {Integer} char1 The second byte
	 * @return {Boolean}       Whether the 2 bytes are an extended character
	 */
	Cea608Stream.prototype.isExtCharacter = function(char0, char1) {
	  return ((char0 === (this.EXT_ + 1) || char0 === (this.EXT_ + 2)) &&
	    (char1 >= 0x20 && char1 <= 0x3f));
	};
	
	/**
	 * Detects if the 2-byte packet is a mid-row code
	 *
	 * Mid-row codes have a second byte in the range 0x20 to 0x2f, with
	 * the first byte being 0x11 (for data channel 1) or 0x19 (for data
	 * channel 2).
	 *
	 * @param  {Integer} char0 The first byte
	 * @param  {Integer} char1 The second byte
	 * @return {Boolean}       Whether the 2 bytes are a mid-row code
	 */
	Cea608Stream.prototype.isMidRowCode = function(char0, char1) {
	  return (char0 === this.EXT_ && (char1 >= 0x20 && char1 <= 0x2f));
	};
	
	/**
	 * Detects if the 2-byte packet is an offset control code
	 *
	 * Offset control codes have a second byte in the range 0x21 to 0x23,
	 * with the first byte being 0x17 (for data channel 1) or 0x1f (for
	 * data channel 2).
	 *
	 * @param  {Integer} char0 The first byte
	 * @param  {Integer} char1 The second byte
	 * @return {Boolean}       Whether the 2 bytes are an offset control code
	 */
	Cea608Stream.prototype.isOffsetControlCode = function(char0, char1) {
	  return (char0 === this.OFFSET_ && (char1 >= 0x21 && char1 <= 0x23));
	};
	
	/**
	 * Detects if the 2-byte packet is a Preamble Address Code
	 *
	 * PACs have a first byte in the range 0x10 to 0x17 (for data channel 1)
	 * or 0x18 to 0x1f (for data channel 2), with the second byte in the
	 * range 0x40 to 0x7f.
	 *
	 * @param  {Integer} char0 The first byte
	 * @param  {Integer} char1 The second byte
	 * @return {Boolean}       Whether the 2 bytes are a PAC
	 */
	Cea608Stream.prototype.isPAC = function(char0, char1) {
	  return (char0 >= this.BASE_ && char0 < (this.BASE_ + 8) &&
	    (char1 >= 0x40 && char1 <= 0x7f));
	};
	
	/**
	 * Detects if a packet's second byte is in the range of a PAC color code
	 *
	 * PAC color codes have the second byte be in the range 0x40 to 0x4f, or
	 * 0x60 to 0x6f.
	 *
	 * @param  {Integer} char1 The second byte
	 * @return {Boolean}       Whether the byte is a color PAC
	 */
	Cea608Stream.prototype.isColorPAC = function(char1) {
	  return ((char1 >= 0x40 && char1 <= 0x4f) || (char1 >= 0x60 && char1 <= 0x7f));
	};
	
	/**
	 * Detects if a single byte is in the range of a normal character
	 *
	 * Normal text bytes are in the range 0x20 to 0x7f.
	 *
	 * @param  {Integer} char  The byte
	 * @return {Boolean}       Whether the byte is a normal character
	 */
	Cea608Stream.prototype.isNormalChar = function(char) {
	  return (char >= 0x20 && char <= 0x7f);
	};
	
	/**
	 * Configures roll-up
	 *
	 * @param  {Integer} pts         Current PTS
	 * @param  {Integer} newBaseRow  Used by PACs to slide the current window to
	 *                               a new position
	 */
	Cea608Stream.prototype.setRollUp = function(pts, newBaseRow) {
	  // Reset the base row to the bottom row when switching modes
	  if (this.mode_ !== 'rollUp') {
	    this.row_ = BOTTOM_ROW;
	    this.mode_ = 'rollUp';
	    // Spec says to wipe memories when switching to roll-up
	    this.flushDisplayed(pts);
	    this.nonDisplayed_ = createDisplayBuffer();
	    this.displayed_ = createDisplayBuffer();
	  }
	
	  if (newBaseRow !== undefined && newBaseRow !== this.row_) {
	    // move currently displayed captions (up or down) to the new base row
	    for (var i = 0; i < this.rollUpRows_; i++) {
	      this.displayed_[newBaseRow - i] = this.displayed_[this.row_ - i];
	      this.displayed_[this.row_ - i] = '';
	    }
	  }
	
	  if (newBaseRow === undefined) {
	    newBaseRow = this.row_;
	  }
	  this.topRow_ = newBaseRow - this.rollUpRows_ + 1;
	};
	
	// Adds the opening HTML tag for the passed character to the caption text,
	// and keeps track of it for later closing
	Cea608Stream.prototype.addFormatting = function(pts, format) {
	  this.formatting_ = this.formatting_.concat(format);
	  var text = format.reduce(function(text, format) {
	    return text + '<' + format + '>';
	  }, '');
	  this[this.mode_](pts, text);
	};
	
	// Adds HTML closing tags for current formatting to caption text and
	// clears remembered formatting
	Cea608Stream.prototype.clearFormatting = function(pts) {
	  if (!this.formatting_.length) {
	    return;
	  }
	  var text = this.formatting_.reverse().reduce(function(text, format) {
	    return text + '</' + format + '>';
	  }, '');
	  this.formatting_ = [];
	  this[this.mode_](pts, text);
	};
	
	// Mode Implementations
	Cea608Stream.prototype.popOn = function(pts, text) {
	  var baseRow = this.nonDisplayed_[this.row_];
	
	  // buffer characters
	  baseRow += text;
	  this.nonDisplayed_[this.row_] = baseRow;
	};
	
	Cea608Stream.prototype.rollUp = function(pts, text) {
	  var baseRow = this.displayed_[this.row_];
	
	  baseRow += text;
	  this.displayed_[this.row_] = baseRow;
	
	};
	
	Cea608Stream.prototype.shiftRowsUp_ = function() {
	  var i;
	  // clear out inactive rows
	  for (i = 0; i < this.topRow_; i++) {
	    this.displayed_[i] = '';
	  }
	  for (i = this.row_ + 1; i < BOTTOM_ROW + 1; i++) {
	    this.displayed_[i] = '';
	  }
	  // shift displayed rows up
	  for (i = this.topRow_; i < this.row_; i++) {
	    this.displayed_[i] = this.displayed_[i + 1];
	  }
	  // clear out the bottom row
	  this.displayed_[this.row_] = '';
	};
	
	Cea608Stream.prototype.paintOn = function(pts, text) {
	  var baseRow = this.displayed_[this.row_];
	
	  baseRow += text;
	  this.displayed_[this.row_] = baseRow;
	};
	
	// exports
	module.exports = {
	  CaptionStream: CaptionStream,
	  Cea608Stream: Cea608Stream
	};


/***/ },
/* 374 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * mux.js
	 *
	 * Copyright (c) 2016 Brightcove
	 * All rights reserved.
	 *
	 * Accepts program elementary stream (PES) data events and corrects
	 * decode and presentation time stamps to account for a rollover
	 * of the 33 bit value.
	 */
	
	'use strict';
	
	var Stream = __webpack_require__(99);
	
	var MAX_TS = 8589934592;
	
	var RO_THRESH = 4294967296;
	
	var handleRollover = function(value, reference) {
	  var direction = 1;
	
	  if (value > reference) {
	    // If the current timestamp value is greater than our reference timestamp and we detect a
	    // timestamp rollover, this means the roll over is happening in the opposite direction.
	    // Example scenario: Enter a long stream/video just after a rollover occurred. The reference
	    // point will be set to a small number, e.g. 1. The user then seeks backwards over the
	    // rollover point. In loading this segment, the timestamp values will be very large,
	    // e.g. 2^33 - 1. Since this comes before the data we loaded previously, we want to adjust
	    // the time stamp to be `value - 2^33`.
	    direction = -1;
	  }
	
	  // Note: A seek forwards or back that is greater than the RO_THRESH (2^32, ~13 hours) will
	  // cause an incorrect adjustment.
	  while (Math.abs(reference - value) > RO_THRESH) {
	    value += (direction * MAX_TS);
	  }
	
	  return value;
	};
	
	var TimestampRolloverStream = function(type) {
	  var lastDTS, referenceDTS;
	
	  TimestampRolloverStream.prototype.init.call(this);
	
	  this.type_ = type;
	
	  this.push = function(data) {
	    if (data.type !== this.type_) {
	      return;
	    }
	
	    if (referenceDTS === undefined) {
	      referenceDTS = data.dts;
	    }
	
	    data.dts = handleRollover(data.dts, referenceDTS);
	    data.pts = handleRollover(data.pts, referenceDTS);
	
	    lastDTS = data.dts;
	
	    this.trigger('data', data);
	  };
	
	  this.flush = function() {
	    referenceDTS = lastDTS;
	    this.trigger('done');
	  };
	
	  this.discontinuity = function() {
	    referenceDTS = void 0;
	    lastDTS = void 0;
	  };
	
	};
	
	TimestampRolloverStream.prototype = new Stream();
	
	module.exports = {
	  TimestampRolloverStream: TimestampRolloverStream,
	  handleRollover: handleRollover
	};


/***/ },
/* 375 */
/***/ function(module, exports) {

	/**
	 * mux.js
	 *
	 * Copyright (c) 2015 Brightcove
	 * All rights reserved.
	 *
	 * Functions that generate fragmented MP4s suitable for use with Media
	 * Source Extensions.
	 */
	'use strict';
	
	var UINT32_MAX = Math.pow(2, 32) - 1;
	
	var box, dinf, esds, ftyp, mdat, mfhd, minf, moof, moov, mvex, mvhd,
	    trak, tkhd, mdia, mdhd, hdlr, sdtp, stbl, stsd, traf, trex,
	    trun, types, MAJOR_BRAND, MINOR_VERSION, AVC1_BRAND, VIDEO_HDLR,
	    AUDIO_HDLR, HDLR_TYPES, VMHD, SMHD, DREF, STCO, STSC, STSZ, STTS;
	
	// pre-calculate constants
	(function() {
	  var i;
	  types = {
	    avc1: [], // codingname
	    avcC: [],
	    btrt: [],
	    dinf: [],
	    dref: [],
	    esds: [],
	    ftyp: [],
	    hdlr: [],
	    mdat: [],
	    mdhd: [],
	    mdia: [],
	    mfhd: [],
	    minf: [],
	    moof: [],
	    moov: [],
	    mp4a: [], // codingname
	    mvex: [],
	    mvhd: [],
	    sdtp: [],
	    smhd: [],
	    stbl: [],
	    stco: [],
	    stsc: [],
	    stsd: [],
	    stsz: [],
	    stts: [],
	    styp: [],
	    tfdt: [],
	    tfhd: [],
	    traf: [],
	    trak: [],
	    trun: [],
	    trex: [],
	    tkhd: [],
	    vmhd: []
	  };
	
	  // In environments where Uint8Array is undefined (e.g., IE8), skip set up so that we
	  // don't throw an error
	  if (typeof Uint8Array === 'undefined') {
	    return;
	  }
	
	  for (i in types) {
	    if (types.hasOwnProperty(i)) {
	      types[i] = [
	        i.charCodeAt(0),
	        i.charCodeAt(1),
	        i.charCodeAt(2),
	        i.charCodeAt(3)
	      ];
	    }
	  }
	
	  MAJOR_BRAND = new Uint8Array([
	    'i'.charCodeAt(0),
	    's'.charCodeAt(0),
	    'o'.charCodeAt(0),
	    'm'.charCodeAt(0)
	  ]);
	  AVC1_BRAND = new Uint8Array([
	    'a'.charCodeAt(0),
	    'v'.charCodeAt(0),
	    'c'.charCodeAt(0),
	    '1'.charCodeAt(0)
	  ]);
	  MINOR_VERSION = new Uint8Array([0, 0, 0, 1]);
	  VIDEO_HDLR = new Uint8Array([
	    0x00, // version 0
	    0x00, 0x00, 0x00, // flags
	    0x00, 0x00, 0x00, 0x00, // pre_defined
	    0x76, 0x69, 0x64, 0x65, // handler_type: 'vide'
	    0x00, 0x00, 0x00, 0x00, // reserved
	    0x00, 0x00, 0x00, 0x00, // reserved
	    0x00, 0x00, 0x00, 0x00, // reserved
	    0x56, 0x69, 0x64, 0x65,
	    0x6f, 0x48, 0x61, 0x6e,
	    0x64, 0x6c, 0x65, 0x72, 0x00 // name: 'VideoHandler'
	  ]);
	  AUDIO_HDLR = new Uint8Array([
	    0x00, // version 0
	    0x00, 0x00, 0x00, // flags
	    0x00, 0x00, 0x00, 0x00, // pre_defined
	    0x73, 0x6f, 0x75, 0x6e, // handler_type: 'soun'
	    0x00, 0x00, 0x00, 0x00, // reserved
	    0x00, 0x00, 0x00, 0x00, // reserved
	    0x00, 0x00, 0x00, 0x00, // reserved
	    0x53, 0x6f, 0x75, 0x6e,
	    0x64, 0x48, 0x61, 0x6e,
	    0x64, 0x6c, 0x65, 0x72, 0x00 // name: 'SoundHandler'
	  ]);
	  HDLR_TYPES = {
	    video: VIDEO_HDLR,
	    audio: AUDIO_HDLR
	  };
	  DREF = new Uint8Array([
	    0x00, // version 0
	    0x00, 0x00, 0x00, // flags
	    0x00, 0x00, 0x00, 0x01, // entry_count
	    0x00, 0x00, 0x00, 0x0c, // entry_size
	    0x75, 0x72, 0x6c, 0x20, // 'url' type
	    0x00, // version 0
	    0x00, 0x00, 0x01 // entry_flags
	  ]);
	  SMHD = new Uint8Array([
	    0x00,             // version
	    0x00, 0x00, 0x00, // flags
	    0x00, 0x00,       // balance, 0 means centered
	    0x00, 0x00        // reserved
	  ]);
	  STCO = new Uint8Array([
	    0x00, // version
	    0x00, 0x00, 0x00, // flags
	    0x00, 0x00, 0x00, 0x00 // entry_count
	  ]);
	  STSC = STCO;
	  STSZ = new Uint8Array([
	    0x00, // version
	    0x00, 0x00, 0x00, // flags
	    0x00, 0x00, 0x00, 0x00, // sample_size
	    0x00, 0x00, 0x00, 0x00 // sample_count
	  ]);
	  STTS = STCO;
	  VMHD = new Uint8Array([
	    0x00, // version
	    0x00, 0x00, 0x01, // flags
	    0x00, 0x00, // graphicsmode
	    0x00, 0x00,
	    0x00, 0x00,
	    0x00, 0x00 // opcolor
	  ]);
	}());
	
	box = function(type) {
	  var
	    payload = [],
	    size = 0,
	    i,
	    result,
	    view;
	
	  for (i = 1; i < arguments.length; i++) {
	    payload.push(arguments[i]);
	  }
	
	  i = payload.length;
	
	  // calculate the total size we need to allocate
	  while (i--) {
	    size += payload[i].byteLength;
	  }
	  result = new Uint8Array(size + 8);
	  view = new DataView(result.buffer, result.byteOffset, result.byteLength);
	  view.setUint32(0, result.byteLength);
	  result.set(type, 4);
	
	  // copy the payload into the result
	  for (i = 0, size = 8; i < payload.length; i++) {
	    result.set(payload[i], size);
	    size += payload[i].byteLength;
	  }
	  return result;
	};
	
	dinf = function() {
	  return box(types.dinf, box(types.dref, DREF));
	};
	
	esds = function(track) {
	  return box(types.esds, new Uint8Array([
	    0x00, // version
	    0x00, 0x00, 0x00, // flags
	
	    // ES_Descriptor
	    0x03, // tag, ES_DescrTag
	    0x19, // length
	    0x00, 0x00, // ES_ID
	    0x00, // streamDependenceFlag, URL_flag, reserved, streamPriority
	
	    // DecoderConfigDescriptor
	    0x04, // tag, DecoderConfigDescrTag
	    0x11, // length
	    0x40, // object type
	    0x15,  // streamType
	    0x00, 0x06, 0x00, // bufferSizeDB
	    0x00, 0x00, 0xda, 0xc0, // maxBitrate
	    0x00, 0x00, 0xda, 0xc0, // avgBitrate
	
	    // DecoderSpecificInfo
	    0x05, // tag, DecoderSpecificInfoTag
	    0x02, // length
	    // ISO/IEC 14496-3, AudioSpecificConfig
	    // for samplingFrequencyIndex see ISO/IEC 13818-7:2006, 8.1.3.2.2, Table 35
	    (track.audioobjecttype << 3) | (track.samplingfrequencyindex >>> 1),
	    (track.samplingfrequencyindex << 7) | (track.channelcount << 3),
	    0x06, 0x01, 0x02 // GASpecificConfig
	  ]));
	};
	
	ftyp = function() {
	  return box(types.ftyp, MAJOR_BRAND, MINOR_VERSION, MAJOR_BRAND, AVC1_BRAND);
	};
	
	hdlr = function(type) {
	  return box(types.hdlr, HDLR_TYPES[type]);
	};
	mdat = function(data) {
	  return box(types.mdat, data);
	};
	mdhd = function(track) {
	  var result = new Uint8Array([
	    0x00,                   // version 0
	    0x00, 0x00, 0x00,       // flags
	    0x00, 0x00, 0x00, 0x02, // creation_time
	    0x00, 0x00, 0x00, 0x03, // modification_time
	    0x00, 0x01, 0x5f, 0x90, // timescale, 90,000 "ticks" per second
	
	    (track.duration >>> 24) & 0xFF,
	    (track.duration >>> 16) & 0xFF,
	    (track.duration >>>  8) & 0xFF,
	    track.duration & 0xFF,  // duration
	    0x55, 0xc4,             // 'und' language (undetermined)
	    0x00, 0x00
	  ]);
	
	  // Use the sample rate from the track metadata, when it is
	  // defined. The sample rate can be parsed out of an ADTS header, for
	  // instance.
	  if (track.samplerate) {
	    result[12] = (track.samplerate >>> 24) & 0xFF;
	    result[13] = (track.samplerate >>> 16) & 0xFF;
	    result[14] = (track.samplerate >>>  8) & 0xFF;
	    result[15] = (track.samplerate)        & 0xFF;
	  }
	
	  return box(types.mdhd, result);
	};
	mdia = function(track) {
	  return box(types.mdia, mdhd(track), hdlr(track.type), minf(track));
	};
	mfhd = function(sequenceNumber) {
	  return box(types.mfhd, new Uint8Array([
	    0x00,
	    0x00, 0x00, 0x00, // flags
	    (sequenceNumber & 0xFF000000) >> 24,
	    (sequenceNumber & 0xFF0000) >> 16,
	    (sequenceNumber & 0xFF00) >> 8,
	    sequenceNumber & 0xFF // sequence_number
	  ]));
	};
	minf = function(track) {
	  return box(types.minf,
	             track.type === 'video' ? box(types.vmhd, VMHD) : box(types.smhd, SMHD),
	             dinf(),
	             stbl(track));
	};
	moof = function(sequenceNumber, tracks) {
	  var
	    trackFragments = [],
	    i = tracks.length;
	  // build traf boxes for each track fragment
	  while (i--) {
	    trackFragments[i] = traf(tracks[i]);
	  }
	  return box.apply(null, [
	    types.moof,
	    mfhd(sequenceNumber)
	  ].concat(trackFragments));
	};
	/**
	 * Returns a movie box.
	 * @param tracks {array} the tracks associated with this movie
	 * @see ISO/IEC 14496-12:2012(E), section 8.2.1
	 */
	moov = function(tracks) {
	  var
	    i = tracks.length,
	    boxes = [];
	
	  while (i--) {
	    boxes[i] = trak(tracks[i]);
	  }
	
	  return box.apply(null, [types.moov, mvhd(0xffffffff)].concat(boxes).concat(mvex(tracks)));
	};
	mvex = function(tracks) {
	  var
	    i = tracks.length,
	    boxes = [];
	
	  while (i--) {
	    boxes[i] = trex(tracks[i]);
	  }
	  return box.apply(null, [types.mvex].concat(boxes));
	};
	mvhd = function(duration) {
	  var
	    bytes = new Uint8Array([
	      0x00, // version 0
	      0x00, 0x00, 0x00, // flags
	      0x00, 0x00, 0x00, 0x01, // creation_time
	      0x00, 0x00, 0x00, 0x02, // modification_time
	      0x00, 0x01, 0x5f, 0x90, // timescale, 90,000 "ticks" per second
	      (duration & 0xFF000000) >> 24,
	      (duration & 0xFF0000) >> 16,
	      (duration & 0xFF00) >> 8,
	      duration & 0xFF, // duration
	      0x00, 0x01, 0x00, 0x00, // 1.0 rate
	      0x01, 0x00, // 1.0 volume
	      0x00, 0x00, // reserved
	      0x00, 0x00, 0x00, 0x00, // reserved
	      0x00, 0x00, 0x00, 0x00, // reserved
	      0x00, 0x01, 0x00, 0x00,
	      0x00, 0x00, 0x00, 0x00,
	      0x00, 0x00, 0x00, 0x00,
	      0x00, 0x00, 0x00, 0x00,
	      0x00, 0x01, 0x00, 0x00,
	      0x00, 0x00, 0x00, 0x00,
	      0x00, 0x00, 0x00, 0x00,
	      0x00, 0x00, 0x00, 0x00,
	      0x40, 0x00, 0x00, 0x00, // transformation: unity matrix
	      0x00, 0x00, 0x00, 0x00,
	      0x00, 0x00, 0x00, 0x00,
	      0x00, 0x00, 0x00, 0x00,
	      0x00, 0x00, 0x00, 0x00,
	      0x00, 0x00, 0x00, 0x00,
	      0x00, 0x00, 0x00, 0x00, // pre_defined
	      0xff, 0xff, 0xff, 0xff // next_track_ID
	    ]);
	  return box(types.mvhd, bytes);
	};
	
	sdtp = function(track) {
	  var
	    samples = track.samples || [],
	    bytes = new Uint8Array(4 + samples.length),
	    flags,
	    i;
	
	  // leave the full box header (4 bytes) all zero
	
	  // write the sample table
	  for (i = 0; i < samples.length; i++) {
	    flags = samples[i].flags;
	
	    bytes[i + 4] = (flags.dependsOn << 4) |
	      (flags.isDependedOn << 2) |
	      (flags.hasRedundancy);
	  }
	
	  return box(types.sdtp,
	             bytes);
	};
	
	stbl = function(track) {
	  return box(types.stbl,
	             stsd(track),
	             box(types.stts, STTS),
	             box(types.stsc, STSC),
	             box(types.stsz, STSZ),
	             box(types.stco, STCO));
	};
	
	(function() {
	  var videoSample, audioSample;
	
	  stsd = function(track) {
	
	    return box(types.stsd, new Uint8Array([
	      0x00, // version 0
	      0x00, 0x00, 0x00, // flags
	      0x00, 0x00, 0x00, 0x01
	    ]), track.type === 'video' ? videoSample(track) : audioSample(track));
	  };
	
	  videoSample = function(track) {
	    var
	      sps = track.sps || [],
	      pps = track.pps || [],
	      sequenceParameterSets = [],
	      pictureParameterSets = [],
	      i;
	
	    // assemble the SPSs
	    for (i = 0; i < sps.length; i++) {
	      sequenceParameterSets.push((sps[i].byteLength & 0xFF00) >>> 8);
	      sequenceParameterSets.push((sps[i].byteLength & 0xFF)); // sequenceParameterSetLength
	      sequenceParameterSets = sequenceParameterSets.concat(Array.prototype.slice.call(sps[i])); // SPS
	    }
	
	    // assemble the PPSs
	    for (i = 0; i < pps.length; i++) {
	      pictureParameterSets.push((pps[i].byteLength & 0xFF00) >>> 8);
	      pictureParameterSets.push((pps[i].byteLength & 0xFF));
	      pictureParameterSets = pictureParameterSets.concat(Array.prototype.slice.call(pps[i]));
	    }
	
	    return box(types.avc1, new Uint8Array([
	      0x00, 0x00, 0x00,
	      0x00, 0x00, 0x00, // reserved
	      0x00, 0x01, // data_reference_index
	      0x00, 0x00, // pre_defined
	      0x00, 0x00, // reserved
	      0x00, 0x00, 0x00, 0x00,
	      0x00, 0x00, 0x00, 0x00,
	      0x00, 0x00, 0x00, 0x00, // pre_defined
	      (track.width & 0xff00) >> 8,
	      track.width & 0xff, // width
	      (track.height & 0xff00) >> 8,
	      track.height & 0xff, // height
	      0x00, 0x48, 0x00, 0x00, // horizresolution
	      0x00, 0x48, 0x00, 0x00, // vertresolution
	      0x00, 0x00, 0x00, 0x00, // reserved
	      0x00, 0x01, // frame_count
	      0x13,
	      0x76, 0x69, 0x64, 0x65,
	      0x6f, 0x6a, 0x73, 0x2d,
	      0x63, 0x6f, 0x6e, 0x74,
	      0x72, 0x69, 0x62, 0x2d,
	      0x68, 0x6c, 0x73, 0x00,
	      0x00, 0x00, 0x00, 0x00,
	      0x00, 0x00, 0x00, 0x00,
	      0x00, 0x00, 0x00, // compressorname
	      0x00, 0x18, // depth = 24
	      0x11, 0x11 // pre_defined = -1
	    ]), box(types.avcC, new Uint8Array([
	      0x01, // configurationVersion
	      track.profileIdc, // AVCProfileIndication
	      track.profileCompatibility, // profile_compatibility
	      track.levelIdc, // AVCLevelIndication
	      0xff // lengthSizeMinusOne, hard-coded to 4 bytes
	    ].concat([
	      sps.length // numOfSequenceParameterSets
	    ]).concat(sequenceParameterSets).concat([
	      pps.length // numOfPictureParameterSets
	    ]).concat(pictureParameterSets))), // "PPS"
	            box(types.btrt, new Uint8Array([
	              0x00, 0x1c, 0x9c, 0x80, // bufferSizeDB
	              0x00, 0x2d, 0xc6, 0xc0, // maxBitrate
	              0x00, 0x2d, 0xc6, 0xc0
	            ])) // avgBitrate
	              );
	  };
	
	  audioSample = function(track) {
	    return box(types.mp4a, new Uint8Array([
	
	      // SampleEntry, ISO/IEC 14496-12
	      0x00, 0x00, 0x00,
	      0x00, 0x00, 0x00, // reserved
	      0x00, 0x01, // data_reference_index
	
	      // AudioSampleEntry, ISO/IEC 14496-12
	      0x00, 0x00, 0x00, 0x00, // reserved
	      0x00, 0x00, 0x00, 0x00, // reserved
	      (track.channelcount & 0xff00) >> 8,
	      (track.channelcount & 0xff), // channelcount
	
	      (track.samplesize & 0xff00) >> 8,
	      (track.samplesize & 0xff), // samplesize
	      0x00, 0x00, // pre_defined
	      0x00, 0x00, // reserved
	
	      (track.samplerate & 0xff00) >> 8,
	      (track.samplerate & 0xff),
	      0x00, 0x00 // samplerate, 16.16
	
	      // MP4AudioSampleEntry, ISO/IEC 14496-14
	    ]), esds(track));
	  };
	}());
	
	tkhd = function(track) {
	  var result = new Uint8Array([
	    0x00, // version 0
	    0x00, 0x00, 0x07, // flags
	    0x00, 0x00, 0x00, 0x00, // creation_time
	    0x00, 0x00, 0x00, 0x00, // modification_time
	    (track.id & 0xFF000000) >> 24,
	    (track.id & 0xFF0000) >> 16,
	    (track.id & 0xFF00) >> 8,
	    track.id & 0xFF, // track_ID
	    0x00, 0x00, 0x00, 0x00, // reserved
	    (track.duration & 0xFF000000) >> 24,
	    (track.duration & 0xFF0000) >> 16,
	    (track.duration & 0xFF00) >> 8,
	    track.duration & 0xFF, // duration
	    0x00, 0x00, 0x00, 0x00,
	    0x00, 0x00, 0x00, 0x00, // reserved
	    0x00, 0x00, // layer
	    0x00, 0x00, // alternate_group
	    0x01, 0x00, // non-audio track volume
	    0x00, 0x00, // reserved
	    0x00, 0x01, 0x00, 0x00,
	    0x00, 0x00, 0x00, 0x00,
	    0x00, 0x00, 0x00, 0x00,
	    0x00, 0x00, 0x00, 0x00,
	    0x00, 0x01, 0x00, 0x00,
	    0x00, 0x00, 0x00, 0x00,
	    0x00, 0x00, 0x00, 0x00,
	    0x00, 0x00, 0x00, 0x00,
	    0x40, 0x00, 0x00, 0x00, // transformation: unity matrix
	    (track.width & 0xFF00) >> 8,
	    track.width & 0xFF,
	    0x00, 0x00, // width
	    (track.height & 0xFF00) >> 8,
	    track.height & 0xFF,
	    0x00, 0x00 // height
	  ]);
	
	  return box(types.tkhd, result);
	};
	
	/**
	 * Generate a track fragment (traf) box. A traf box collects metadata
	 * about tracks in a movie fragment (moof) box.
	 */
	traf = function(track) {
	  var trackFragmentHeader, trackFragmentDecodeTime, trackFragmentRun,
	      sampleDependencyTable, dataOffset,
	      upperWordBaseMediaDecodeTime, lowerWordBaseMediaDecodeTime;
	
	  trackFragmentHeader = box(types.tfhd, new Uint8Array([
	    0x00, // version 0
	    0x00, 0x00, 0x3a, // flags
	    (track.id & 0xFF000000) >> 24,
	    (track.id & 0xFF0000) >> 16,
	    (track.id & 0xFF00) >> 8,
	    (track.id & 0xFF), // track_ID
	    0x00, 0x00, 0x00, 0x01, // sample_description_index
	    0x00, 0x00, 0x00, 0x00, // default_sample_duration
	    0x00, 0x00, 0x00, 0x00, // default_sample_size
	    0x00, 0x00, 0x00, 0x00  // default_sample_flags
	  ]));
	
	  upperWordBaseMediaDecodeTime = Math.floor(track.baseMediaDecodeTime / (UINT32_MAX + 1));
	  lowerWordBaseMediaDecodeTime = Math.floor(track.baseMediaDecodeTime % (UINT32_MAX + 1));
	
	  trackFragmentDecodeTime = box(types.tfdt, new Uint8Array([
	    0x01, // version 1
	    0x00, 0x00, 0x00, // flags
	    // baseMediaDecodeTime
	    (upperWordBaseMediaDecodeTime >>> 24) & 0xFF,
	    (upperWordBaseMediaDecodeTime >>> 16) & 0xFF,
	    (upperWordBaseMediaDecodeTime >>>  8) & 0xFF,
	    upperWordBaseMediaDecodeTime & 0xFF,
	    (lowerWordBaseMediaDecodeTime >>> 24) & 0xFF,
	    (lowerWordBaseMediaDecodeTime >>> 16) & 0xFF,
	    (lowerWordBaseMediaDecodeTime >>>  8) & 0xFF,
	    lowerWordBaseMediaDecodeTime & 0xFF
	  ]));
	
	  // the data offset specifies the number of bytes from the start of
	  // the containing moof to the first payload byte of the associated
	  // mdat
	  dataOffset = (32 + // tfhd
	                20 + // tfdt
	                8 +  // traf header
	                16 + // mfhd
	                8 +  // moof header
	                8);  // mdat header
	
	  // audio tracks require less metadata
	  if (track.type === 'audio') {
	    trackFragmentRun = trun(track, dataOffset);
	    return box(types.traf,
	               trackFragmentHeader,
	               trackFragmentDecodeTime,
	               trackFragmentRun);
	  }
	
	  // video tracks should contain an independent and disposable samples
	  // box (sdtp)
	  // generate one and adjust offsets to match
	  sampleDependencyTable = sdtp(track);
	  trackFragmentRun = trun(track,
	                          sampleDependencyTable.length + dataOffset);
	  return box(types.traf,
	             trackFragmentHeader,
	             trackFragmentDecodeTime,
	             trackFragmentRun,
	             sampleDependencyTable);
	};
	
	/**
	 * Generate a track box.
	 * @param track {object} a track definition
	 * @return {Uint8Array} the track box
	 */
	trak = function(track) {
	  track.duration = track.duration || 0xffffffff;
	  return box(types.trak,
	             tkhd(track),
	             mdia(track));
	};
	
	trex = function(track) {
	  var result = new Uint8Array([
	    0x00, // version 0
	    0x00, 0x00, 0x00, // flags
	    (track.id & 0xFF000000) >> 24,
	    (track.id & 0xFF0000) >> 16,
	    (track.id & 0xFF00) >> 8,
	    (track.id & 0xFF), // track_ID
	    0x00, 0x00, 0x00, 0x01, // default_sample_description_index
	    0x00, 0x00, 0x00, 0x00, // default_sample_duration
	    0x00, 0x00, 0x00, 0x00, // default_sample_size
	    0x00, 0x01, 0x00, 0x01 // default_sample_flags
	  ]);
	  // the last two bytes of default_sample_flags is the sample
	  // degradation priority, a hint about the importance of this sample
	  // relative to others. Lower the degradation priority for all sample
	  // types other than video.
	  if (track.type !== 'video') {
	    result[result.length - 1] = 0x00;
	  }
	
	  return box(types.trex, result);
	};
	
	(function() {
	  var audioTrun, videoTrun, trunHeader;
	
	  // This method assumes all samples are uniform. That is, if a
	  // duration is present for the first sample, it will be present for
	  // all subsequent samples.
	  // see ISO/IEC 14496-12:2012, Section 8.8.8.1
	  trunHeader = function(samples, offset) {
	    var durationPresent = 0, sizePresent = 0,
	        flagsPresent = 0, compositionTimeOffset = 0;
	
	    // trun flag constants
	    if (samples.length) {
	      if (samples[0].duration !== undefined) {
	        durationPresent = 0x1;
	      }
	      if (samples[0].size !== undefined) {
	        sizePresent = 0x2;
	      }
	      if (samples[0].flags !== undefined) {
	        flagsPresent = 0x4;
	      }
	      if (samples[0].compositionTimeOffset !== undefined) {
	        compositionTimeOffset = 0x8;
	      }
	    }
	
	    return [
	      0x00, // version 0
	      0x00,
	      durationPresent | sizePresent | flagsPresent | compositionTimeOffset,
	      0x01, // flags
	      (samples.length & 0xFF000000) >>> 24,
	      (samples.length & 0xFF0000) >>> 16,
	      (samples.length & 0xFF00) >>> 8,
	      samples.length & 0xFF, // sample_count
	      (offset & 0xFF000000) >>> 24,
	      (offset & 0xFF0000) >>> 16,
	      (offset & 0xFF00) >>> 8,
	      offset & 0xFF // data_offset
	    ];
	  };
	
	  videoTrun = function(track, offset) {
	    var bytes, samples, sample, i;
	
	    samples = track.samples || [];
	    offset += 8 + 12 + (16 * samples.length);
	
	    bytes = trunHeader(samples, offset);
	
	    for (i = 0; i < samples.length; i++) {
	      sample = samples[i];
	      bytes = bytes.concat([
	        (sample.duration & 0xFF000000) >>> 24,
	        (sample.duration & 0xFF0000) >>> 16,
	        (sample.duration & 0xFF00) >>> 8,
	        sample.duration & 0xFF, // sample_duration
	        (sample.size & 0xFF000000) >>> 24,
	        (sample.size & 0xFF0000) >>> 16,
	        (sample.size & 0xFF00) >>> 8,
	        sample.size & 0xFF, // sample_size
	        (sample.flags.isLeading << 2) | sample.flags.dependsOn,
	        (sample.flags.isDependedOn << 6) |
	          (sample.flags.hasRedundancy << 4) |
	          (sample.flags.paddingValue << 1) |
	          sample.flags.isNonSyncSample,
	        sample.flags.degradationPriority & 0xF0 << 8,
	        sample.flags.degradationPriority & 0x0F, // sample_flags
	        (sample.compositionTimeOffset & 0xFF000000) >>> 24,
	        (sample.compositionTimeOffset & 0xFF0000) >>> 16,
	        (sample.compositionTimeOffset & 0xFF00) >>> 8,
	        sample.compositionTimeOffset & 0xFF // sample_composition_time_offset
	      ]);
	    }
	    return box(types.trun, new Uint8Array(bytes));
	  };
	
	  audioTrun = function(track, offset) {
	    var bytes, samples, sample, i;
	
	    samples = track.samples || [];
	    offset += 8 + 12 + (8 * samples.length);
	
	    bytes = trunHeader(samples, offset);
	
	    for (i = 0; i < samples.length; i++) {
	      sample = samples[i];
	      bytes = bytes.concat([
	        (sample.duration & 0xFF000000) >>> 24,
	        (sample.duration & 0xFF0000) >>> 16,
	        (sample.duration & 0xFF00) >>> 8,
	        sample.duration & 0xFF, // sample_duration
	        (sample.size & 0xFF000000) >>> 24,
	        (sample.size & 0xFF0000) >>> 16,
	        (sample.size & 0xFF00) >>> 8,
	        sample.size & 0xFF]); // sample_size
	    }
	
	    return box(types.trun, new Uint8Array(bytes));
	  };
	
	  trun = function(track, offset) {
	    if (track.type === 'audio') {
	      return audioTrun(track, offset);
	    }
	
	    return videoTrun(track, offset);
	  };
	}());
	
	module.exports = {
	  ftyp: ftyp,
	  mdat: mdat,
	  moof: moof,
	  moov: moov,
	  initSegment: function(tracks) {
	    var
	      fileType = ftyp(),
	      movie = moov(tracks),
	      result;
	
	    result = new Uint8Array(fileType.byteLength + movie.byteLength);
	    result.set(fileType);
	    result.set(movie, fileType.byteLength);
	    return result;
	  }
	};


/***/ },
/* 376 */
/***/ function(module, exports) {

	/**
	 * mux.js
	 *
	 * Copyright (c) 2015 Brightcove
	 * All rights reserved.
	 *
	 * Reads in-band caption information from a video elementary
	 * stream. Captions must follow the CEA-708 standard for injection
	 * into an MPEG-2 transport streams.
	 * @see https://en.wikipedia.org/wiki/CEA-708
	 * @see https://www.gpo.gov/fdsys/pkg/CFR-2007-title47-vol1/pdf/CFR-2007-title47-vol1-sec15-119.pdf
	 */
	
	'use strict';
	
	// Supplemental enhancement information (SEI) NAL units have a
	// payload type field to indicate how they are to be
	// interpreted. CEAS-708 caption content is always transmitted with
	// payload type 0x04.
	var USER_DATA_REGISTERED_ITU_T_T35 = 4,
	    RBSP_TRAILING_BITS = 128;
	
	/**
	  * Parse a supplemental enhancement information (SEI) NAL unit.
	  * Stops parsing once a message of type ITU T T35 has been found.
	  *
	  * @param bytes {Uint8Array} the bytes of a SEI NAL unit
	  * @return {object} the parsed SEI payload
	  * @see Rec. ITU-T H.264, 7.3.2.3.1
	  */
	var parseSei = function(bytes) {
	  var
	    i = 0,
	    result = {
	      payloadType: -1,
	      payloadSize: 0
	    },
	    payloadType = 0,
	    payloadSize = 0;
	
	  // go through the sei_rbsp parsing each each individual sei_message
	  while (i < bytes.byteLength) {
	    // stop once we have hit the end of the sei_rbsp
	    if (bytes[i] === RBSP_TRAILING_BITS) {
	      break;
	    }
	
	    // Parse payload type
	    while (bytes[i] === 0xFF) {
	      payloadType += 255;
	      i++;
	    }
	    payloadType += bytes[i++];
	
	    // Parse payload size
	    while (bytes[i] === 0xFF) {
	      payloadSize += 255;
	      i++;
	    }
	    payloadSize += bytes[i++];
	
	    // this sei_message is a 608/708 caption so save it and break
	    // there can only ever be one caption message in a frame's sei
	    if (!result.payload && payloadType === USER_DATA_REGISTERED_ITU_T_T35) {
	      result.payloadType = payloadType;
	      result.payloadSize = payloadSize;
	      result.payload = bytes.subarray(i, i + payloadSize);
	      break;
	    }
	
	    // skip the payload and parse the next message
	    i += payloadSize;
	    payloadType = 0;
	    payloadSize = 0;
	  }
	
	  return result;
	};
	
	// see ANSI/SCTE 128-1 (2013), section 8.1
	var parseUserData = function(sei) {
	  // itu_t_t35_contry_code must be 181 (United States) for
	  // captions
	  if (sei.payload[0] !== 181) {
	    return null;
	  }
	
	  // itu_t_t35_provider_code should be 49 (ATSC) for captions
	  if (((sei.payload[1] << 8) | sei.payload[2]) !== 49) {
	    return null;
	  }
	
	  // the user_identifier should be "GA94" to indicate ATSC1 data
	  if (String.fromCharCode(sei.payload[3],
	                          sei.payload[4],
	                          sei.payload[5],
	                          sei.payload[6]) !== 'GA94') {
	    return null;
	  }
	
	  // finally, user_data_type_code should be 0x03 for caption data
	  if (sei.payload[7] !== 0x03) {
	    return null;
	  }
	
	  // return the user_data_type_structure and strip the trailing
	  // marker bits
	  return sei.payload.subarray(8, sei.payload.length - 1);
	};
	
	// see CEA-708-D, section 4.4
	var parseCaptionPackets = function(pts, userData) {
	  var results = [], i, count, offset, data;
	
	  // if this is just filler, return immediately
	  if (!(userData[0] & 0x40)) {
	    return results;
	  }
	
	  // parse out the cc_data_1 and cc_data_2 fields
	  count = userData[0] & 0x1f;
	  for (i = 0; i < count; i++) {
	    offset = i * 3;
	    data = {
	      type: userData[offset + 2] & 0x03,
	      pts: pts
	    };
	
	    // capture cc data when cc_valid is 1
	    if (userData[offset + 2] & 0x04) {
	      data.ccData = (userData[offset + 3] << 8) | userData[offset + 4];
	      results.push(data);
	    }
	  }
	  return results;
	};
	
	var discardEmulationPreventionBytes = function(data) {
	    var
	      length = data.byteLength,
	      emulationPreventionBytesPositions = [],
	      i = 1,
	      newLength, newData;
	
	    // Find all `Emulation Prevention Bytes`
	    while (i < length - 2) {
	      if (data[i] === 0 && data[i + 1] === 0 && data[i + 2] === 0x03) {
	        emulationPreventionBytesPositions.push(i + 2);
	        i += 2;
	      } else {
	        i++;
	      }
	    }
	
	    // If no Emulation Prevention Bytes were found just return the original
	    // array
	    if (emulationPreventionBytesPositions.length === 0) {
	      return data;
	    }
	
	    // Create a new array to hold the NAL unit data
	    newLength = length - emulationPreventionBytesPositions.length;
	    newData = new Uint8Array(newLength);
	    var sourceIndex = 0;
	
	    for (i = 0; i < newLength; sourceIndex++, i++) {
	      if (sourceIndex === emulationPreventionBytesPositions[0]) {
	        // Skip this byte
	        sourceIndex++;
	        // Remove this position index
	        emulationPreventionBytesPositions.shift();
	      }
	      newData[i] = data[sourceIndex];
	    }
	
	    return newData;
	};
	
	// exports
	module.exports = {
	  parseSei: parseSei,
	  parseUserData: parseUserData,
	  parseCaptionPackets: parseCaptionPackets,
	  discardEmulationPreventionBytes: discardEmulationPreventionBytes,
	  USER_DATA_REGISTERED_ITU_T_T35: USER_DATA_REGISTERED_ITU_T_T35
	};


/***/ },
/* 377 */
/***/ function(module, exports) {

	// shim for using process in browser
	var process = module.exports = {};
	
	// cached from whatever global is present so that test runners that stub it
	// don't break things.  But we need to wrap it in a try catch in case it is
	// wrapped in strict mode code which doesn't define any globals.  It's inside a
	// function because try/catches deoptimize in certain engines.
	
	var cachedSetTimeout;
	var cachedClearTimeout;
	
	function defaultSetTimout() {
	    throw new Error('setTimeout has not been defined');
	}
	function defaultClearTimeout () {
	    throw new Error('clearTimeout has not been defined');
	}
	(function () {
	    try {
	        if (typeof setTimeout === 'function') {
	            cachedSetTimeout = setTimeout;
	        } else {
	            cachedSetTimeout = defaultSetTimout;
	        }
	    } catch (e) {
	        cachedSetTimeout = defaultSetTimout;
	    }
	    try {
	        if (typeof clearTimeout === 'function') {
	            cachedClearTimeout = clearTimeout;
	        } else {
	            cachedClearTimeout = defaultClearTimeout;
	        }
	    } catch (e) {
	        cachedClearTimeout = defaultClearTimeout;
	    }
	} ())
	function runTimeout(fun) {
	    if (cachedSetTimeout === setTimeout) {
	        //normal enviroments in sane situations
	        return setTimeout(fun, 0);
	    }
	    // if setTimeout wasn't available but was latter defined
	    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
	        cachedSetTimeout = setTimeout;
	        return setTimeout(fun, 0);
	    }
	    try {
	        // when when somebody has screwed with setTimeout but no I.E. maddness
	        return cachedSetTimeout(fun, 0);
	    } catch(e){
	        try {
	            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
	            return cachedSetTimeout.call(null, fun, 0);
	        } catch(e){
	            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
	            return cachedSetTimeout.call(this, fun, 0);
	        }
	    }
	
	
	}
	function runClearTimeout(marker) {
	    if (cachedClearTimeout === clearTimeout) {
	        //normal enviroments in sane situations
	        return clearTimeout(marker);
	    }
	    // if clearTimeout wasn't available but was latter defined
	    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
	        cachedClearTimeout = clearTimeout;
	        return clearTimeout(marker);
	    }
	    try {
	        // when when somebody has screwed with setTimeout but no I.E. maddness
	        return cachedClearTimeout(marker);
	    } catch (e){
	        try {
	            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
	            return cachedClearTimeout.call(null, marker);
	        } catch (e){
	            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
	            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
	            return cachedClearTimeout.call(this, marker);
	        }
	    }
	
	
	
	}
	var queue = [];
	var draining = false;
	var currentQueue;
	var queueIndex = -1;
	
	function cleanUpNextTick() {
	    if (!draining || !currentQueue) {
	        return;
	    }
	    draining = false;
	    if (currentQueue.length) {
	        queue = currentQueue.concat(queue);
	    } else {
	        queueIndex = -1;
	    }
	    if (queue.length) {
	        drainQueue();
	    }
	}
	
	function drainQueue() {
	    if (draining) {
	        return;
	    }
	    var timeout = runTimeout(cleanUpNextTick);
	    draining = true;
	
	    var len = queue.length;
	    while(len) {
	        currentQueue = queue;
	        queue = [];
	        while (++queueIndex < len) {
	            if (currentQueue) {
	                currentQueue[queueIndex].run();
	            }
	        }
	        queueIndex = -1;
	        len = queue.length;
	    }
	    currentQueue = null;
	    draining = false;
	    runClearTimeout(timeout);
	}
	
	process.nextTick = function (fun) {
	    var args = new Array(arguments.length - 1);
	    if (arguments.length > 1) {
	        for (var i = 1; i < arguments.length; i++) {
	            args[i - 1] = arguments[i];
	        }
	    }
	    queue.push(new Item(fun, args));
	    if (queue.length === 1 && !draining) {
	        runTimeout(drainQueue);
	    }
	};
	
	// v8 likes predictible objects
	function Item(fun, array) {
	    this.fun = fun;
	    this.array = array;
	}
	Item.prototype.run = function () {
	    this.fun.apply(null, this.array);
	};
	process.title = 'browser';
	process.browser = true;
	process.env = {};
	process.argv = [];
	process.version = ''; // empty string to avoid regexp issues
	process.versions = {};
	
	function noop() {}
	
	process.on = noop;
	process.addListener = noop;
	process.once = noop;
	process.off = noop;
	process.removeListener = noop;
	process.removeAllListeners = noop;
	process.emit = noop;
	process.prependListener = noop;
	process.prependOnceListener = noop;
	
	process.listeners = function (name) { return [] }
	
	process.binding = function (name) {
	    throw new Error('process.binding is not supported');
	};
	
	process.cwd = function () { return '/' };
	process.chdir = function (dir) {
	    throw new Error('process.chdir is not supported');
	};
	process.umask = function() { return 0; };


/***/ },
/* 378 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';
	
	// React 15.5 references this module, and assumes PropTypes are still callable in production.
	// Therefore we re-export development-only version with all the PropTypes checks here.
	// However if one is migrating to the `prop-types` npm library, they will go through the
	// `index.js` entry point, and it will branch depending on the environment.
	var factory = __webpack_require__(964);
	module.exports = function(isValidElement) {
	  // It is still allowed in 15.5.
	  var throwOnDirectAccess = false;
	  return factory(isValidElement, throwOnDirectAccess);
	};


/***/ },
/* 379 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';
	
	var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';
	
	module.exports = ReactPropTypesSecret;


/***/ },
/* 380 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer) {/*!
	 * Quill Editor v1.3.6
	 * https://quilljs.com/
	 * Copyright (c) 2014, Jason Chen
	 * Copyright (c) 2013, salesforce.com
	 */
	(function webpackUniversalModuleDefinition(root, factory) {
		if(true)
			module.exports = factory();
		else if(typeof define === 'function' && define.amd)
			define([], factory);
		else if(typeof exports === 'object')
			exports["Quill"] = factory();
		else
			root["Quill"] = factory();
	})(typeof self !== 'undefined' ? self : this, function() {
	return /******/ (function(modules) { // webpackBootstrap
	/******/ 	// The module cache
	/******/ 	var installedModules = {};
	/******/
	/******/ 	// The require function
	/******/ 	function __webpack_require__(moduleId) {
	/******/
	/******/ 		// Check if module is in cache
	/******/ 		if(installedModules[moduleId]) {
	/******/ 			return installedModules[moduleId].exports;
	/******/ 		}
	/******/ 		// Create a new module (and put it into the cache)
	/******/ 		var module = installedModules[moduleId] = {
	/******/ 			i: moduleId,
	/******/ 			l: false,
	/******/ 			exports: {}
	/******/ 		};
	/******/
	/******/ 		// Execute the module function
	/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
	/******/
	/******/ 		// Flag the module as loaded
	/******/ 		module.l = true;
	/******/
	/******/ 		// Return the exports of the module
	/******/ 		return module.exports;
	/******/ 	}
	/******/
	/******/
	/******/ 	// expose the modules object (__webpack_modules__)
	/******/ 	__webpack_require__.m = modules;
	/******/
	/******/ 	// expose the module cache
	/******/ 	__webpack_require__.c = installedModules;
	/******/
	/******/ 	// define getter function for harmony exports
	/******/ 	__webpack_require__.d = function(exports, name, getter) {
	/******/ 		if(!__webpack_require__.o(exports, name)) {
	/******/ 			Object.defineProperty(exports, name, {
	/******/ 				configurable: false,
	/******/ 				enumerable: true,
	/******/ 				get: getter
	/******/ 			});
	/******/ 		}
	/******/ 	};
	/******/
	/******/ 	// getDefaultExport function for compatibility with non-harmony modules
	/******/ 	__webpack_require__.n = function(module) {
	/******/ 		var getter = module && module.__esModule ?
	/******/ 			function getDefault() { return module['default']; } :
	/******/ 			function getModuleExports() { return module; };
	/******/ 		__webpack_require__.d(getter, 'a', getter);
	/******/ 		return getter;
	/******/ 	};
	/******/
	/******/ 	// Object.prototype.hasOwnProperty.call
	/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
	/******/
	/******/ 	// __webpack_public_path__
	/******/ 	__webpack_require__.p = "";
	/******/
	/******/ 	// Load entry module and return exports
	/******/ 	return __webpack_require__(__webpack_require__.s = 109);
	/******/ })
	/************************************************************************/
	/******/ ([
	/* 0 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	Object.defineProperty(exports, "__esModule", { value: true });
	var container_1 = __webpack_require__(17);
	var format_1 = __webpack_require__(18);
	var leaf_1 = __webpack_require__(19);
	var scroll_1 = __webpack_require__(45);
	var inline_1 = __webpack_require__(46);
	var block_1 = __webpack_require__(47);
	var embed_1 = __webpack_require__(48);
	var text_1 = __webpack_require__(49);
	var attributor_1 = __webpack_require__(12);
	var class_1 = __webpack_require__(32);
	var style_1 = __webpack_require__(33);
	var store_1 = __webpack_require__(31);
	var Registry = __webpack_require__(1);
	var Parchment = {
	    Scope: Registry.Scope,
	    create: Registry.create,
	    find: Registry.find,
	    query: Registry.query,
	    register: Registry.register,
	    Container: container_1.default,
	    Format: format_1.default,
	    Leaf: leaf_1.default,
	    Embed: embed_1.default,
	    Scroll: scroll_1.default,
	    Block: block_1.default,
	    Inline: inline_1.default,
	    Text: text_1.default,
	    Attributor: {
	        Attribute: attributor_1.default,
	        Class: class_1.default,
	        Style: style_1.default,
	        Store: store_1.default,
	    },
	};
	exports.default = Parchment;
	
	
	/***/ }),
	/* 1 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var ParchmentError = /** @class */ (function (_super) {
	    __extends(ParchmentError, _super);
	    function ParchmentError(message) {
	        var _this = this;
	        message = '[Parchment] ' + message;
	        _this = _super.call(this, message) || this;
	        _this.message = message;
	        _this.name = _this.constructor.name;
	        return _this;
	    }
	    return ParchmentError;
	}(Error));
	exports.ParchmentError = ParchmentError;
	var attributes = {};
	var classes = {};
	var tags = {};
	var types = {};
	exports.DATA_KEY = '__blot';
	var Scope;
	(function (Scope) {
	    Scope[Scope["TYPE"] = 3] = "TYPE";
	    Scope[Scope["LEVEL"] = 12] = "LEVEL";
	    Scope[Scope["ATTRIBUTE"] = 13] = "ATTRIBUTE";
	    Scope[Scope["BLOT"] = 14] = "BLOT";
	    Scope[Scope["INLINE"] = 7] = "INLINE";
	    Scope[Scope["BLOCK"] = 11] = "BLOCK";
	    Scope[Scope["BLOCK_BLOT"] = 10] = "BLOCK_BLOT";
	    Scope[Scope["INLINE_BLOT"] = 6] = "INLINE_BLOT";
	    Scope[Scope["BLOCK_ATTRIBUTE"] = 9] = "BLOCK_ATTRIBUTE";
	    Scope[Scope["INLINE_ATTRIBUTE"] = 5] = "INLINE_ATTRIBUTE";
	    Scope[Scope["ANY"] = 15] = "ANY";
	})(Scope = exports.Scope || (exports.Scope = {}));
	function create(input, value) {
	    var match = query(input);
	    if (match == null) {
	        throw new ParchmentError("Unable to create " + input + " blot");
	    }
	    var BlotClass = match;
	    var node = 
	    // @ts-ignore
	    input instanceof Node || input['nodeType'] === Node.TEXT_NODE ? input : BlotClass.create(value);
	    return new BlotClass(node, value);
	}
	exports.create = create;
	function find(node, bubble) {
	    if (bubble === void 0) { bubble = false; }
	    if (node == null)
	        return null;
	    // @ts-ignore
	    if (node[exports.DATA_KEY] != null)
	        return node[exports.DATA_KEY].blot;
	    if (bubble)
	        return find(node.parentNode, bubble);
	    return null;
	}
	exports.find = find;
	function query(query, scope) {
	    if (scope === void 0) { scope = Scope.ANY; }
	    var match;
	    if (typeof query === 'string') {
	        match = types[query] || attributes[query];
	        // @ts-ignore
	    }
	    else if (query instanceof Text || query['nodeType'] === Node.TEXT_NODE) {
	        match = types['text'];
	    }
	    else if (typeof query === 'number') {
	        if (query & Scope.LEVEL & Scope.BLOCK) {
	            match = types['block'];
	        }
	        else if (query & Scope.LEVEL & Scope.INLINE) {
	            match = types['inline'];
	        }
	    }
	    else if (query instanceof HTMLElement) {
	        var names = (query.getAttribute('class') || '').split(/\s+/);
	        for (var i in names) {
	            match = classes[names[i]];
	            if (match)
	                break;
	        }
	        match = match || tags[query.tagName];
	    }
	    if (match == null)
	        return null;
	    // @ts-ignore
	    if (scope & Scope.LEVEL & match.scope && scope & Scope.TYPE & match.scope)
	        return match;
	    return null;
	}
	exports.query = query;
	function register() {
	    var Definitions = [];
	    for (var _i = 0; _i < arguments.length; _i++) {
	        Definitions[_i] = arguments[_i];
	    }
	    if (Definitions.length > 1) {
	        return Definitions.map(function (d) {
	            return register(d);
	        });
	    }
	    var Definition = Definitions[0];
	    if (typeof Definition.blotName !== 'string' && typeof Definition.attrName !== 'string') {
	        throw new ParchmentError('Invalid definition');
	    }
	    else if (Definition.blotName === 'abstract') {
	        throw new ParchmentError('Cannot register abstract class');
	    }
	    types[Definition.blotName || Definition.attrName] = Definition;
	    if (typeof Definition.keyName === 'string') {
	        attributes[Definition.keyName] = Definition;
	    }
	    else {
	        if (Definition.className != null) {
	            classes[Definition.className] = Definition;
	        }
	        if (Definition.tagName != null) {
	            if (Array.isArray(Definition.tagName)) {
	                Definition.tagName = Definition.tagName.map(function (tagName) {
	                    return tagName.toUpperCase();
	                });
	            }
	            else {
	                Definition.tagName = Definition.tagName.toUpperCase();
	            }
	            var tagNames = Array.isArray(Definition.tagName) ? Definition.tagName : [Definition.tagName];
	            tagNames.forEach(function (tag) {
	                if (tags[tag] == null || Definition.className == null) {
	                    tags[tag] = Definition;
	                }
	            });
	        }
	    }
	    return Definition;
	}
	exports.register = register;
	
	
	/***/ }),
	/* 2 */
	/***/ (function(module, exports, __webpack_require__) {
	
	var diff = __webpack_require__(51);
	var equal = __webpack_require__(11);
	var extend = __webpack_require__(3);
	var op = __webpack_require__(20);
	
	
	var NULL_CHARACTER = String.fromCharCode(0);  // Placeholder char for embed in diff()
	
	
	var Delta = function (ops) {
	  // Assume we are given a well formed ops
	  if (Array.isArray(ops)) {
	    this.ops = ops;
	  } else if (ops != null && Array.isArray(ops.ops)) {
	    this.ops = ops.ops;
	  } else {
	    this.ops = [];
	  }
	};
	
	
	Delta.prototype.insert = function (text, attributes) {
	  var newOp = {};
	  if (text.length === 0) return this;
	  newOp.insert = text;
	  if (attributes != null && typeof attributes === 'object' && Object.keys(attributes).length > 0) {
	    newOp.attributes = attributes;
	  }
	  return this.push(newOp);
	};
	
	Delta.prototype['delete'] = function (length) {
	  if (length <= 0) return this;
	  return this.push({ 'delete': length });
	};
	
	Delta.prototype.retain = function (length, attributes) {
	  if (length <= 0) return this;
	  var newOp = { retain: length };
	  if (attributes != null && typeof attributes === 'object' && Object.keys(attributes).length > 0) {
	    newOp.attributes = attributes;
	  }
	  return this.push(newOp);
	};
	
	Delta.prototype.push = function (newOp) {
	  var index = this.ops.length;
	  var lastOp = this.ops[index - 1];
	  newOp = extend(true, {}, newOp);
	  if (typeof lastOp === 'object') {
	    if (typeof newOp['delete'] === 'number' && typeof lastOp['delete'] === 'number') {
	      this.ops[index - 1] = { 'delete': lastOp['delete'] + newOp['delete'] };
	      return this;
	    }
	    // Since it does not matter if we insert before or after deleting at the same index,
	    // always prefer to insert first
	    if (typeof lastOp['delete'] === 'number' && newOp.insert != null) {
	      index -= 1;
	      lastOp = this.ops[index - 1];
	      if (typeof lastOp !== 'object') {
	        this.ops.unshift(newOp);
	        return this;
	      }
	    }
	    if (equal(newOp.attributes, lastOp.attributes)) {
	      if (typeof newOp.insert === 'string' && typeof lastOp.insert === 'string') {
	        this.ops[index - 1] = { insert: lastOp.insert + newOp.insert };
	        if (typeof newOp.attributes === 'object') this.ops[index - 1].attributes = newOp.attributes
	        return this;
	      } else if (typeof newOp.retain === 'number' && typeof lastOp.retain === 'number') {
	        this.ops[index - 1] = { retain: lastOp.retain + newOp.retain };
	        if (typeof newOp.attributes === 'object') this.ops[index - 1].attributes = newOp.attributes
	        return this;
	      }
	    }
	  }
	  if (index === this.ops.length) {
	    this.ops.push(newOp);
	  } else {
	    this.ops.splice(index, 0, newOp);
	  }
	  return this;
	};
	
	Delta.prototype.chop = function () {
	  var lastOp = this.ops[this.ops.length - 1];
	  if (lastOp && lastOp.retain && !lastOp.attributes) {
	    this.ops.pop();
	  }
	  return this;
	};
	
	Delta.prototype.filter = function (predicate) {
	  return this.ops.filter(predicate);
	};
	
	Delta.prototype.forEach = function (predicate) {
	  this.ops.forEach(predicate);
	};
	
	Delta.prototype.map = function (predicate) {
	  return this.ops.map(predicate);
	};
	
	Delta.prototype.partition = function (predicate) {
	  var passed = [], failed = [];
	  this.forEach(function(op) {
	    var target = predicate(op) ? passed : failed;
	    target.push(op);
	  });
	  return [passed, failed];
	};
	
	Delta.prototype.reduce = function (predicate, initial) {
	  return this.ops.reduce(predicate, initial);
	};
	
	Delta.prototype.changeLength = function () {
	  return this.reduce(function (length, elem) {
	    if (elem.insert) {
	      return length + op.length(elem);
	    } else if (elem.delete) {
	      return length - elem.delete;
	    }
	    return length;
	  }, 0);
	};
	
	Delta.prototype.length = function () {
	  return this.reduce(function (length, elem) {
	    return length + op.length(elem);
	  }, 0);
	};
	
	Delta.prototype.slice = function (start, end) {
	  start = start || 0;
	  if (typeof end !== 'number') end = Infinity;
	  var ops = [];
	  var iter = op.iterator(this.ops);
	  var index = 0;
	  while (index < end && iter.hasNext()) {
	    var nextOp;
	    if (index < start) {
	      nextOp = iter.next(start - index);
	    } else {
	      nextOp = iter.next(end - index);
	      ops.push(nextOp);
	    }
	    index += op.length(nextOp);
	  }
	  return new Delta(ops);
	};
	
	
	Delta.prototype.compose = function (other) {
	  var thisIter = op.iterator(this.ops);
	  var otherIter = op.iterator(other.ops);
	  var delta = new Delta();
	  while (thisIter.hasNext() || otherIter.hasNext()) {
	    if (otherIter.peekType() === 'insert') {
	      delta.push(otherIter.next());
	    } else if (thisIter.peekType() === 'delete') {
	      delta.push(thisIter.next());
	    } else {
	      var length = Math.min(thisIter.peekLength(), otherIter.peekLength());
	      var thisOp = thisIter.next(length);
	      var otherOp = otherIter.next(length);
	      if (typeof otherOp.retain === 'number') {
	        var newOp = {};
	        if (typeof thisOp.retain === 'number') {
	          newOp.retain = length;
	        } else {
	          newOp.insert = thisOp.insert;
	        }
	        // Preserve null when composing with a retain, otherwise remove it for inserts
	        var attributes = op.attributes.compose(thisOp.attributes, otherOp.attributes, typeof thisOp.retain === 'number');
	        if (attributes) newOp.attributes = attributes;
	        delta.push(newOp);
	      // Other op should be delete, we could be an insert or retain
	      // Insert + delete cancels out
	      } else if (typeof otherOp['delete'] === 'number' && typeof thisOp.retain === 'number') {
	        delta.push(otherOp);
	      }
	    }
	  }
	  return delta.chop();
	};
	
	Delta.prototype.concat = function (other) {
	  var delta = new Delta(this.ops.slice());
	  if (other.ops.length > 0) {
	    delta.push(other.ops[0]);
	    delta.ops = delta.ops.concat(other.ops.slice(1));
	  }
	  return delta;
	};
	
	Delta.prototype.diff = function (other, index) {
	  if (this.ops === other.ops) {
	    return new Delta();
	  }
	  var strings = [this, other].map(function (delta) {
	    return delta.map(function (op) {
	      if (op.insert != null) {
	        return typeof op.insert === 'string' ? op.insert : NULL_CHARACTER;
	      }
	      var prep = (delta === other) ? 'on' : 'with';
	      throw new Error('diff() called ' + prep + ' non-document');
	    }).join('');
	  });
	  var delta = new Delta();
	  var diffResult = diff(strings[0], strings[1], index);
	  var thisIter = op.iterator(this.ops);
	  var otherIter = op.iterator(other.ops);
	  diffResult.forEach(function (component) {
	    var length = component[1].length;
	    while (length > 0) {
	      var opLength = 0;
	      switch (component[0]) {
	        case diff.INSERT:
	          opLength = Math.min(otherIter.peekLength(), length);
	          delta.push(otherIter.next(opLength));
	          break;
	        case diff.DELETE:
	          opLength = Math.min(length, thisIter.peekLength());
	          thisIter.next(opLength);
	          delta['delete'](opLength);
	          break;
	        case diff.EQUAL:
	          opLength = Math.min(thisIter.peekLength(), otherIter.peekLength(), length);
	          var thisOp = thisIter.next(opLength);
	          var otherOp = otherIter.next(opLength);
	          if (equal(thisOp.insert, otherOp.insert)) {
	            delta.retain(opLength, op.attributes.diff(thisOp.attributes, otherOp.attributes));
	          } else {
	            delta.push(otherOp)['delete'](opLength);
	          }
	          break;
	      }
	      length -= opLength;
	    }
	  });
	  return delta.chop();
	};
	
	Delta.prototype.eachLine = function (predicate, newline) {
	  newline = newline || '\n';
	  var iter = op.iterator(this.ops);
	  var line = new Delta();
	  var i = 0;
	  while (iter.hasNext()) {
	    if (iter.peekType() !== 'insert') return;
	    var thisOp = iter.peek();
	    var start = op.length(thisOp) - iter.peekLength();
	    var index = typeof thisOp.insert === 'string' ?
	      thisOp.insert.indexOf(newline, start) - start : -1;
	    if (index < 0) {
	      line.push(iter.next());
	    } else if (index > 0) {
	      line.push(iter.next(index));
	    } else {
	      if (predicate(line, iter.next(1).attributes || {}, i) === false) {
	        return;
	      }
	      i += 1;
	      line = new Delta();
	    }
	  }
	  if (line.length() > 0) {
	    predicate(line, {}, i);
	  }
	};
	
	Delta.prototype.transform = function (other, priority) {
	  priority = !!priority;
	  if (typeof other === 'number') {
	    return this.transformPosition(other, priority);
	  }
	  var thisIter = op.iterator(this.ops);
	  var otherIter = op.iterator(other.ops);
	  var delta = new Delta();
	  while (thisIter.hasNext() || otherIter.hasNext()) {
	    if (thisIter.peekType() === 'insert' && (priority || otherIter.peekType() !== 'insert')) {
	      delta.retain(op.length(thisIter.next()));
	    } else if (otherIter.peekType() === 'insert') {
	      delta.push(otherIter.next());
	    } else {
	      var length = Math.min(thisIter.peekLength(), otherIter.peekLength());
	      var thisOp = thisIter.next(length);
	      var otherOp = otherIter.next(length);
	      if (thisOp['delete']) {
	        // Our delete either makes their delete redundant or removes their retain
	        continue;
	      } else if (otherOp['delete']) {
	        delta.push(otherOp);
	      } else {
	        // We retain either their retain or insert
	        delta.retain(length, op.attributes.transform(thisOp.attributes, otherOp.attributes, priority));
	      }
	    }
	  }
	  return delta.chop();
	};
	
	Delta.prototype.transformPosition = function (index, priority) {
	  priority = !!priority;
	  var thisIter = op.iterator(this.ops);
	  var offset = 0;
	  while (thisIter.hasNext() && offset <= index) {
	    var length = thisIter.peekLength();
	    var nextType = thisIter.peekType();
	    thisIter.next();
	    if (nextType === 'delete') {
	      index -= Math.min(length, index - offset);
	      continue;
	    } else if (nextType === 'insert' && (offset < index || !priority)) {
	      index += length;
	    }
	    offset += length;
	  }
	  return index;
	};
	
	
	module.exports = Delta;
	
	
	/***/ }),
	/* 3 */
	/***/ (function(module, exports) {
	
	'use strict';
	
	var hasOwn = Object.prototype.hasOwnProperty;
	var toStr = Object.prototype.toString;
	
	var isArray = function isArray(arr) {
		if (typeof Array.isArray === 'function') {
			return Array.isArray(arr);
		}
	
		return toStr.call(arr) === '[object Array]';
	};
	
	var isPlainObject = function isPlainObject(obj) {
		if (!obj || toStr.call(obj) !== '[object Object]') {
			return false;
		}
	
		var hasOwnConstructor = hasOwn.call(obj, 'constructor');
		var hasIsPrototypeOf = obj.constructor && obj.constructor.prototype && hasOwn.call(obj.constructor.prototype, 'isPrototypeOf');
		// Not own constructor property must be Object
		if (obj.constructor && !hasOwnConstructor && !hasIsPrototypeOf) {
			return false;
		}
	
		// Own properties are enumerated firstly, so to speed up,
		// if last one is own, then all properties are own.
		var key;
		for (key in obj) { /**/ }
	
		return typeof key === 'undefined' || hasOwn.call(obj, key);
	};
	
	module.exports = function extend() {
		var options, name, src, copy, copyIsArray, clone;
		var target = arguments[0];
		var i = 1;
		var length = arguments.length;
		var deep = false;
	
		// Handle a deep copy situation
		if (typeof target === 'boolean') {
			deep = target;
			target = arguments[1] || {};
			// skip the boolean and the target
			i = 2;
		}
		if (target == null || (typeof target !== 'object' && typeof target !== 'function')) {
			target = {};
		}
	
		for (; i < length; ++i) {
			options = arguments[i];
			// Only deal with non-null/undefined values
			if (options != null) {
				// Extend the base object
				for (name in options) {
					src = target[name];
					copy = options[name];
	
					// Prevent never-ending loop
					if (target !== copy) {
						// Recurse if we're merging plain objects or arrays
						if (deep && copy && (isPlainObject(copy) || (copyIsArray = isArray(copy)))) {
							if (copyIsArray) {
								copyIsArray = false;
								clone = src && isArray(src) ? src : [];
							} else {
								clone = src && isPlainObject(src) ? src : {};
							}
	
							// Never move original objects, clone them
							target[name] = extend(deep, clone, copy);
	
						// Don't bring in undefined values
						} else if (typeof copy !== 'undefined') {
							target[name] = copy;
						}
					}
				}
			}
		}
	
		// Return the modified object
		return target;
	};
	
	
	/***/ }),
	/* 4 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.BlockEmbed = exports.bubbleFormats = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };
	
	var _extend = __webpack_require__(3);
	
	var _extend2 = _interopRequireDefault(_extend);
	
	var _quillDelta = __webpack_require__(2);
	
	var _quillDelta2 = _interopRequireDefault(_quillDelta);
	
	var _parchment = __webpack_require__(0);
	
	var _parchment2 = _interopRequireDefault(_parchment);
	
	var _break = __webpack_require__(16);
	
	var _break2 = _interopRequireDefault(_break);
	
	var _inline = __webpack_require__(6);
	
	var _inline2 = _interopRequireDefault(_inline);
	
	var _text = __webpack_require__(7);
	
	var _text2 = _interopRequireDefault(_text);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var NEWLINE_LENGTH = 1;
	
	var BlockEmbed = function (_Parchment$Embed) {
	  _inherits(BlockEmbed, _Parchment$Embed);
	
	  function BlockEmbed() {
	    _classCallCheck(this, BlockEmbed);
	
	    return _possibleConstructorReturn(this, (BlockEmbed.__proto__ || Object.getPrototypeOf(BlockEmbed)).apply(this, arguments));
	  }
	
	  _createClass(BlockEmbed, [{
	    key: 'attach',
	    value: function attach() {
	      _get(BlockEmbed.prototype.__proto__ || Object.getPrototypeOf(BlockEmbed.prototype), 'attach', this).call(this);
	      this.attributes = new _parchment2.default.Attributor.Store(this.domNode);
	    }
	  }, {
	    key: 'delta',
	    value: function delta() {
	      return new _quillDelta2.default().insert(this.value(), (0, _extend2.default)(this.formats(), this.attributes.values()));
	    }
	  }, {
	    key: 'format',
	    value: function format(name, value) {
	      var attribute = _parchment2.default.query(name, _parchment2.default.Scope.BLOCK_ATTRIBUTE);
	      if (attribute != null) {
	        this.attributes.attribute(attribute, value);
	      }
	    }
	  }, {
	    key: 'formatAt',
	    value: function formatAt(index, length, name, value) {
	      this.format(name, value);
	    }
	  }, {
	    key: 'insertAt',
	    value: function insertAt(index, value, def) {
	      if (typeof value === 'string' && value.endsWith('\n')) {
	        var block = _parchment2.default.create(Block.blotName);
	        this.parent.insertBefore(block, index === 0 ? this : this.next);
	        block.insertAt(0, value.slice(0, -1));
	      } else {
	        _get(BlockEmbed.prototype.__proto__ || Object.getPrototypeOf(BlockEmbed.prototype), 'insertAt', this).call(this, index, value, def);
	      }
	    }
	  }]);
	
	  return BlockEmbed;
	}(_parchment2.default.Embed);
	
	BlockEmbed.scope = _parchment2.default.Scope.BLOCK_BLOT;
	// It is important for cursor behavior BlockEmbeds use tags that are block level elements
	
	
	var Block = function (_Parchment$Block) {
	  _inherits(Block, _Parchment$Block);
	
	  function Block(domNode) {
	    _classCallCheck(this, Block);
	
	    var _this2 = _possibleConstructorReturn(this, (Block.__proto__ || Object.getPrototypeOf(Block)).call(this, domNode));
	
	    _this2.cache = {};
	    return _this2;
	  }
	
	  _createClass(Block, [{
	    key: 'delta',
	    value: function delta() {
	      if (this.cache.delta == null) {
	        this.cache.delta = this.descendants(_parchment2.default.Leaf).reduce(function (delta, leaf) {
	          if (leaf.length() === 0) {
	            return delta;
	          } else {
	            return delta.insert(leaf.value(), bubbleFormats(leaf));
	          }
	        }, new _quillDelta2.default()).insert('\n', bubbleFormats(this));
	      }
	      return this.cache.delta;
	    }
	  }, {
	    key: 'deleteAt',
	    value: function deleteAt(index, length) {
	      _get(Block.prototype.__proto__ || Object.getPrototypeOf(Block.prototype), 'deleteAt', this).call(this, index, length);
	      this.cache = {};
	    }
	  }, {
	    key: 'formatAt',
	    value: function formatAt(index, length, name, value) {
	      if (length <= 0) return;
	      if (_parchment2.default.query(name, _parchment2.default.Scope.BLOCK)) {
	        if (index + length === this.length()) {
	          this.format(name, value);
	        }
	      } else {
	        _get(Block.prototype.__proto__ || Object.getPrototypeOf(Block.prototype), 'formatAt', this).call(this, index, Math.min(length, this.length() - index - 1), name, value);
	      }
	      this.cache = {};
	    }
	  }, {
	    key: 'insertAt',
	    value: function insertAt(index, value, def) {
	      if (def != null) return _get(Block.prototype.__proto__ || Object.getPrototypeOf(Block.prototype), 'insertAt', this).call(this, index, value, def);
	      if (value.length === 0) return;
	      var lines = value.split('\n');
	      var text = lines.shift();
	      if (text.length > 0) {
	        if (index < this.length() - 1 || this.children.tail == null) {
	          _get(Block.prototype.__proto__ || Object.getPrototypeOf(Block.prototype), 'insertAt', this).call(this, Math.min(index, this.length() - 1), text);
	        } else {
	          this.children.tail.insertAt(this.children.tail.length(), text);
	        }
	        this.cache = {};
	      }
	      var block = this;
	      lines.reduce(function (index, line) {
	        block = block.split(index, true);
	        block.insertAt(0, line);
	        return line.length;
	      }, index + text.length);
	    }
	  }, {
	    key: 'insertBefore',
	    value: function insertBefore(blot, ref) {
	      var head = this.children.head;
	      _get(Block.prototype.__proto__ || Object.getPrototypeOf(Block.prototype), 'insertBefore', this).call(this, blot, ref);
	      if (head instanceof _break2.default) {
	        head.remove();
	      }
	      this.cache = {};
	    }
	  }, {
	    key: 'length',
	    value: function length() {
	      if (this.cache.length == null) {
	        this.cache.length = _get(Block.prototype.__proto__ || Object.getPrototypeOf(Block.prototype), 'length', this).call(this) + NEWLINE_LENGTH;
	      }
	      return this.cache.length;
	    }
	  }, {
	    key: 'moveChildren',
	    value: function moveChildren(target, ref) {
	      _get(Block.prototype.__proto__ || Object.getPrototypeOf(Block.prototype), 'moveChildren', this).call(this, target, ref);
	      this.cache = {};
	    }
	  }, {
	    key: 'optimize',
	    value: function optimize(context) {
	      _get(Block.prototype.__proto__ || Object.getPrototypeOf(Block.prototype), 'optimize', this).call(this, context);
	      this.cache = {};
	    }
	  }, {
	    key: 'path',
	    value: function path(index) {
	      return _get(Block.prototype.__proto__ || Object.getPrototypeOf(Block.prototype), 'path', this).call(this, index, true);
	    }
	  }, {
	    key: 'removeChild',
	    value: function removeChild(child) {
	      _get(Block.prototype.__proto__ || Object.getPrototypeOf(Block.prototype), 'removeChild', this).call(this, child);
	      this.cache = {};
	    }
	  }, {
	    key: 'split',
	    value: function split(index) {
	      var force = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	
	      if (force && (index === 0 || index >= this.length() - NEWLINE_LENGTH)) {
	        var clone = this.clone();
	        if (index === 0) {
	          this.parent.insertBefore(clone, this);
	          return this;
	        } else {
	          this.parent.insertBefore(clone, this.next);
	          return clone;
	        }
	      } else {
	        var next = _get(Block.prototype.__proto__ || Object.getPrototypeOf(Block.prototype), 'split', this).call(this, index, force);
	        this.cache = {};
	        return next;
	      }
	    }
	  }]);
	
	  return Block;
	}(_parchment2.default.Block);
	
	Block.blotName = 'block';
	Block.tagName = 'P';
	Block.defaultChild = 'break';
	Block.allowedChildren = [_inline2.default, _parchment2.default.Embed, _text2.default];
	
	function bubbleFormats(blot) {
	  var formats = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	  if (blot == null) return formats;
	  if (typeof blot.formats === 'function') {
	    formats = (0, _extend2.default)(formats, blot.formats());
	  }
	  if (blot.parent == null || blot.parent.blotName == 'scroll' || blot.parent.statics.scope !== blot.statics.scope) {
	    return formats;
	  }
	  return bubbleFormats(blot.parent, formats);
	}
	
	exports.bubbleFormats = bubbleFormats;
	exports.BlockEmbed = BlockEmbed;
	exports.default = Block;
	
	/***/ }),
	/* 5 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.overload = exports.expandConfig = undefined;
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	__webpack_require__(50);
	
	var _quillDelta = __webpack_require__(2);
	
	var _quillDelta2 = _interopRequireDefault(_quillDelta);
	
	var _editor = __webpack_require__(14);
	
	var _editor2 = _interopRequireDefault(_editor);
	
	var _emitter3 = __webpack_require__(8);
	
	var _emitter4 = _interopRequireDefault(_emitter3);
	
	var _module = __webpack_require__(9);
	
	var _module2 = _interopRequireDefault(_module);
	
	var _parchment = __webpack_require__(0);
	
	var _parchment2 = _interopRequireDefault(_parchment);
	
	var _selection = __webpack_require__(15);
	
	var _selection2 = _interopRequireDefault(_selection);
	
	var _extend = __webpack_require__(3);
	
	var _extend2 = _interopRequireDefault(_extend);
	
	var _logger = __webpack_require__(10);
	
	var _logger2 = _interopRequireDefault(_logger);
	
	var _theme = __webpack_require__(34);
	
	var _theme2 = _interopRequireDefault(_theme);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var debug = (0, _logger2.default)('quill');
	
	var Quill = function () {
	  _createClass(Quill, null, [{
	    key: 'debug',
	    value: function debug(limit) {
	      if (limit === true) {
	        limit = 'log';
	      }
	      _logger2.default.level(limit);
	    }
	  }, {
	    key: 'find',
	    value: function find(node) {
	      return node.__quill || _parchment2.default.find(node);
	    }
	  }, {
	    key: 'import',
	    value: function _import(name) {
	      if (this.imports[name] == null) {
	        debug.error('Cannot import ' + name + '. Are you sure it was registered?');
	      }
	      return this.imports[name];
	    }
	  }, {
	    key: 'register',
	    value: function register(path, target) {
	      var _this = this;
	
	      var overwrite = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
	
	      if (typeof path !== 'string') {
	        var name = path.attrName || path.blotName;
	        if (typeof name === 'string') {
	          // register(Blot | Attributor, overwrite)
	          this.register('formats/' + name, path, target);
	        } else {
	          Object.keys(path).forEach(function (key) {
	            _this.register(key, path[key], target);
	          });
	        }
	      } else {
	        if (this.imports[path] != null && !overwrite) {
	          debug.warn('Overwriting ' + path + ' with', target);
	        }
	        this.imports[path] = target;
	        if ((path.startsWith('blots/') || path.startsWith('formats/')) && target.blotName !== 'abstract') {
	          _parchment2.default.register(target);
	        } else if (path.startsWith('modules') && typeof target.register === 'function') {
	          target.register();
	        }
	      }
	    }
	  }]);
	
	  function Quill(container) {
	    var _this2 = this;
	
	    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	    _classCallCheck(this, Quill);
	
	    this.options = expandConfig(container, options);
	    this.container = this.options.container;
	    if (this.container == null) {
	      return debug.error('Invalid Quill container', container);
	    }
	    if (this.options.debug) {
	      Quill.debug(this.options.debug);
	    }
	    var html = this.container.innerHTML.trim();
	    this.container.classList.add('ql-container');
	    this.container.innerHTML = '';
	    this.container.__quill = this;
	    this.root = this.addContainer('ql-editor');
	    this.root.classList.add('ql-blank');
	    this.root.setAttribute('data-gramm', false);
	    this.scrollingContainer = this.options.scrollingContainer || this.root;
	    this.emitter = new _emitter4.default();
	    this.scroll = _parchment2.default.create(this.root, {
	      emitter: this.emitter,
	      whitelist: this.options.formats
	    });
	    this.editor = new _editor2.default(this.scroll);
	    this.selection = new _selection2.default(this.scroll, this.emitter);
	    this.theme = new this.options.theme(this, this.options);
	    this.keyboard = this.theme.addModule('keyboard');
	    this.clipboard = this.theme.addModule('clipboard');
	    this.history = this.theme.addModule('history');
	    this.theme.init();
	    this.emitter.on(_emitter4.default.events.EDITOR_CHANGE, function (type) {
	      if (type === _emitter4.default.events.TEXT_CHANGE) {
	        _this2.root.classList.toggle('ql-blank', _this2.editor.isBlank());
	      }
	    });
	    this.emitter.on(_emitter4.default.events.SCROLL_UPDATE, function (source, mutations) {
	      var range = _this2.selection.lastRange;
	      var index = range && range.length === 0 ? range.index : undefined;
	      modify.call(_this2, function () {
	        return _this2.editor.update(null, mutations, index);
	      }, source);
	    });
	    var contents = this.clipboard.convert('<div class=\'ql-editor\' style="white-space: normal;">' + html + '<p><br></p></div>');
	    this.setContents(contents);
	    this.history.clear();
	    if (this.options.placeholder) {
	      this.root.setAttribute('data-placeholder', this.options.placeholder);
	    }
	    if (this.options.readOnly) {
	      this.disable();
	    }
	  }
	
	  _createClass(Quill, [{
	    key: 'addContainer',
	    value: function addContainer(container) {
	      var refNode = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
	
	      if (typeof container === 'string') {
	        var className = container;
	        container = document.createElement('div');
	        container.classList.add(className);
	      }
	      this.container.insertBefore(container, refNode);
	      return container;
	    }
	  }, {
	    key: 'blur',
	    value: function blur() {
	      this.selection.setRange(null);
	    }
	  }, {
	    key: 'deleteText',
	    value: function deleteText(index, length, source) {
	      var _this3 = this;
	
	      var _overload = overload(index, length, source);
	
	      var _overload2 = _slicedToArray(_overload, 4);
	
	      index = _overload2[0];
	      length = _overload2[1];
	      source = _overload2[3];
	
	      return modify.call(this, function () {
	        return _this3.editor.deleteText(index, length);
	      }, source, index, -1 * length);
	    }
	  }, {
	    key: 'disable',
	    value: function disable() {
	      this.enable(false);
	    }
	  }, {
	    key: 'enable',
	    value: function enable() {
	      var enabled = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
	
	      this.scroll.enable(enabled);
	      this.container.classList.toggle('ql-disabled', !enabled);
	    }
	  }, {
	    key: 'focus',
	    value: function focus() {
	      var scrollTop = this.scrollingContainer.scrollTop;
	      this.selection.focus();
	      this.scrollingContainer.scrollTop = scrollTop;
	      this.scrollIntoView();
	    }
	  }, {
	    key: 'format',
	    value: function format(name, value) {
	      var _this4 = this;
	
	      var source = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : _emitter4.default.sources.API;
	
	      return modify.call(this, function () {
	        var range = _this4.getSelection(true);
	        var change = new _quillDelta2.default();
	        if (range == null) {
	          return change;
	        } else if (_parchment2.default.query(name, _parchment2.default.Scope.BLOCK)) {
	          change = _this4.editor.formatLine(range.index, range.length, _defineProperty({}, name, value));
	        } else if (range.length === 0) {
	          _this4.selection.format(name, value);
	          return change;
	        } else {
	          change = _this4.editor.formatText(range.index, range.length, _defineProperty({}, name, value));
	        }
	        _this4.setSelection(range, _emitter4.default.sources.SILENT);
	        return change;
	      }, source);
	    }
	  }, {
	    key: 'formatLine',
	    value: function formatLine(index, length, name, value, source) {
	      var _this5 = this;
	
	      var formats = void 0;
	
	      var _overload3 = overload(index, length, name, value, source);
	
	      var _overload4 = _slicedToArray(_overload3, 4);
	
	      index = _overload4[0];
	      length = _overload4[1];
	      formats = _overload4[2];
	      source = _overload4[3];
	
	      return modify.call(this, function () {
	        return _this5.editor.formatLine(index, length, formats);
	      }, source, index, 0);
	    }
	  }, {
	    key: 'formatText',
	    value: function formatText(index, length, name, value, source) {
	      var _this6 = this;
	
	      var formats = void 0;
	
	      var _overload5 = overload(index, length, name, value, source);
	
	      var _overload6 = _slicedToArray(_overload5, 4);
	
	      index = _overload6[0];
	      length = _overload6[1];
	      formats = _overload6[2];
	      source = _overload6[3];
	
	      return modify.call(this, function () {
	        return _this6.editor.formatText(index, length, formats);
	      }, source, index, 0);
	    }
	  }, {
	    key: 'getBounds',
	    value: function getBounds(index) {
	      var length = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
	
	      var bounds = void 0;
	      if (typeof index === 'number') {
	        bounds = this.selection.getBounds(index, length);
	      } else {
	        bounds = this.selection.getBounds(index.index, index.length);
	      }
	      var containerBounds = this.container.getBoundingClientRect();
	      return {
	        bottom: bounds.bottom - containerBounds.top,
	        height: bounds.height,
	        left: bounds.left - containerBounds.left,
	        right: bounds.right - containerBounds.left,
	        top: bounds.top - containerBounds.top,
	        width: bounds.width
	      };
	    }
	  }, {
	    key: 'getContents',
	    value: function getContents() {
	      var index = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
	      var length = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.getLength() - index;
	
	      var _overload7 = overload(index, length);
	
	      var _overload8 = _slicedToArray(_overload7, 2);
	
	      index = _overload8[0];
	      length = _overload8[1];
	
	      return this.editor.getContents(index, length);
	    }
	  }, {
	    key: 'getFormat',
	    value: function getFormat() {
	      var index = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.getSelection(true);
	      var length = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
	
	      if (typeof index === 'number') {
	        return this.editor.getFormat(index, length);
	      } else {
	        return this.editor.getFormat(index.index, index.length);
	      }
	    }
	  }, {
	    key: 'getIndex',
	    value: function getIndex(blot) {
	      return blot.offset(this.scroll);
	    }
	  }, {
	    key: 'getLength',
	    value: function getLength() {
	      return this.scroll.length();
	    }
	  }, {
	    key: 'getLeaf',
	    value: function getLeaf(index) {
	      return this.scroll.leaf(index);
	    }
	  }, {
	    key: 'getLine',
	    value: function getLine(index) {
	      return this.scroll.line(index);
	    }
	  }, {
	    key: 'getLines',
	    value: function getLines() {
	      var index = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
	      var length = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : Number.MAX_VALUE;
	
	      if (typeof index !== 'number') {
	        return this.scroll.lines(index.index, index.length);
	      } else {
	        return this.scroll.lines(index, length);
	      }
	    }
	  }, {
	    key: 'getModule',
	    value: function getModule(name) {
	      return this.theme.modules[name];
	    }
	  }, {
	    key: 'getSelection',
	    value: function getSelection() {
	      var focus = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
	
	      if (focus) this.focus();
	      this.update(); // Make sure we access getRange with editor in consistent state
	      return this.selection.getRange()[0];
	    }
	  }, {
	    key: 'getText',
	    value: function getText() {
	      var index = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
	      var length = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.getLength() - index;
	
	      var _overload9 = overload(index, length);
	
	      var _overload10 = _slicedToArray(_overload9, 2);
	
	      index = _overload10[0];
	      length = _overload10[1];
	
	      return this.editor.getText(index, length);
	    }
	  }, {
	    key: 'hasFocus',
	    value: function hasFocus() {
	      return this.selection.hasFocus();
	    }
	  }, {
	    key: 'insertEmbed',
	    value: function insertEmbed(index, embed, value) {
	      var _this7 = this;
	
	      var source = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : Quill.sources.API;
	
	      return modify.call(this, function () {
	        return _this7.editor.insertEmbed(index, embed, value);
	      }, source, index);
	    }
	  }, {
	    key: 'insertText',
	    value: function insertText(index, text, name, value, source) {
	      var _this8 = this;
	
	      var formats = void 0;
	
	      var _overload11 = overload(index, 0, name, value, source);
	
	      var _overload12 = _slicedToArray(_overload11, 4);
	
	      index = _overload12[0];
	      formats = _overload12[2];
	      source = _overload12[3];
	
	      return modify.call(this, function () {
	        return _this8.editor.insertText(index, text, formats);
	      }, source, index, text.length);
	    }
	  }, {
	    key: 'isEnabled',
	    value: function isEnabled() {
	      return !this.container.classList.contains('ql-disabled');
	    }
	  }, {
	    key: 'off',
	    value: function off() {
	      return this.emitter.off.apply(this.emitter, arguments);
	    }
	  }, {
	    key: 'on',
	    value: function on() {
	      return this.emitter.on.apply(this.emitter, arguments);
	    }
	  }, {
	    key: 'once',
	    value: function once() {
	      return this.emitter.once.apply(this.emitter, arguments);
	    }
	  }, {
	    key: 'pasteHTML',
	    value: function pasteHTML(index, html, source) {
	      this.clipboard.dangerouslyPasteHTML(index, html, source);
	    }
	  }, {
	    key: 'removeFormat',
	    value: function removeFormat(index, length, source) {
	      var _this9 = this;
	
	      var _overload13 = overload(index, length, source);
	
	      var _overload14 = _slicedToArray(_overload13, 4);
	
	      index = _overload14[0];
	      length = _overload14[1];
	      source = _overload14[3];
	
	      return modify.call(this, function () {
	        return _this9.editor.removeFormat(index, length);
	      }, source, index);
	    }
	  }, {
	    key: 'scrollIntoView',
	    value: function scrollIntoView() {
	      this.selection.scrollIntoView(this.scrollingContainer);
	    }
	  }, {
	    key: 'setContents',
	    value: function setContents(delta) {
	      var _this10 = this;
	
	      var source = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _emitter4.default.sources.API;
	
	      return modify.call(this, function () {
	        delta = new _quillDelta2.default(delta);
	        var length = _this10.getLength();
	        var deleted = _this10.editor.deleteText(0, length);
	        var applied = _this10.editor.applyDelta(delta);
	        var lastOp = applied.ops[applied.ops.length - 1];
	        if (lastOp != null && typeof lastOp.insert === 'string' && lastOp.insert[lastOp.insert.length - 1] === '\n') {
	          _this10.editor.deleteText(_this10.getLength() - 1, 1);
	          applied.delete(1);
	        }
	        var ret = deleted.compose(applied);
	        return ret;
	      }, source);
	    }
	  }, {
	    key: 'setSelection',
	    value: function setSelection(index, length, source) {
	      if (index == null) {
	        this.selection.setRange(null, length || Quill.sources.API);
	      } else {
	        var _overload15 = overload(index, length, source);
	
	        var _overload16 = _slicedToArray(_overload15, 4);
	
	        index = _overload16[0];
	        length = _overload16[1];
	        source = _overload16[3];
	
	        this.selection.setRange(new _selection.Range(index, length), source);
	        if (source !== _emitter4.default.sources.SILENT) {
	          this.selection.scrollIntoView(this.scrollingContainer);
	        }
	      }
	    }
	  }, {
	    key: 'setText',
	    value: function setText(text) {
	      var source = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _emitter4.default.sources.API;
	
	      var delta = new _quillDelta2.default().insert(text);
	      return this.setContents(delta, source);
	    }
	  }, {
	    key: 'update',
	    value: function update() {
	      var source = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _emitter4.default.sources.USER;
	
	      var change = this.scroll.update(source); // Will update selection before selection.update() does if text changes
	      this.selection.update(source);
	      return change;
	    }
	  }, {
	    key: 'updateContents',
	    value: function updateContents(delta) {
	      var _this11 = this;
	
	      var source = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _emitter4.default.sources.API;
	
	      return modify.call(this, function () {
	        delta = new _quillDelta2.default(delta);
	        return _this11.editor.applyDelta(delta, source);
	      }, source, true);
	    }
	  }]);
	
	  return Quill;
	}();
	
	Quill.DEFAULTS = {
	  bounds: null,
	  formats: null,
	  modules: {},
	  placeholder: '',
	  readOnly: false,
	  scrollingContainer: null,
	  strict: true,
	  theme: 'default'
	};
	Quill.events = _emitter4.default.events;
	Quill.sources = _emitter4.default.sources;
	// eslint-disable-next-line no-undef
	Quill.version =  false ? 'dev' : "1.3.6";
	
	Quill.imports = {
	  'delta': _quillDelta2.default,
	  'parchment': _parchment2.default,
	  'core/module': _module2.default,
	  'core/theme': _theme2.default
	};
	
	function expandConfig(container, userConfig) {
	  userConfig = (0, _extend2.default)(true, {
	    container: container,
	    modules: {
	      clipboard: true,
	      keyboard: true,
	      history: true
	    }
	  }, userConfig);
	  if (!userConfig.theme || userConfig.theme === Quill.DEFAULTS.theme) {
	    userConfig.theme = _theme2.default;
	  } else {
	    userConfig.theme = Quill.import('themes/' + userConfig.theme);
	    if (userConfig.theme == null) {
	      throw new Error('Invalid theme ' + userConfig.theme + '. Did you register it?');
	    }
	  }
	  var themeConfig = (0, _extend2.default)(true, {}, userConfig.theme.DEFAULTS);
	  [themeConfig, userConfig].forEach(function (config) {
	    config.modules = config.modules || {};
	    Object.keys(config.modules).forEach(function (module) {
	      if (config.modules[module] === true) {
	        config.modules[module] = {};
	      }
	    });
	  });
	  var moduleNames = Object.keys(themeConfig.modules).concat(Object.keys(userConfig.modules));
	  var moduleConfig = moduleNames.reduce(function (config, name) {
	    var moduleClass = Quill.import('modules/' + name);
	    if (moduleClass == null) {
	      debug.error('Cannot load ' + name + ' module. Are you sure you registered it?');
	    } else {
	      config[name] = moduleClass.DEFAULTS || {};
	    }
	    return config;
	  }, {});
	  // Special case toolbar shorthand
	  if (userConfig.modules != null && userConfig.modules.toolbar && userConfig.modules.toolbar.constructor !== Object) {
	    userConfig.modules.toolbar = {
	      container: userConfig.modules.toolbar
	    };
	  }
	  userConfig = (0, _extend2.default)(true, {}, Quill.DEFAULTS, { modules: moduleConfig }, themeConfig, userConfig);
	  ['bounds', 'container', 'scrollingContainer'].forEach(function (key) {
	    if (typeof userConfig[key] === 'string') {
	      userConfig[key] = document.querySelector(userConfig[key]);
	    }
	  });
	  userConfig.modules = Object.keys(userConfig.modules).reduce(function (config, name) {
	    if (userConfig.modules[name]) {
	      config[name] = userConfig.modules[name];
	    }
	    return config;
	  }, {});
	  return userConfig;
	}
	
	// Handle selection preservation and TEXT_CHANGE emission
	// common to modification APIs
	function modify(modifier, source, index, shift) {
	  if (this.options.strict && !this.isEnabled() && source === _emitter4.default.sources.USER) {
	    return new _quillDelta2.default();
	  }
	  var range = index == null ? null : this.getSelection();
	  var oldDelta = this.editor.delta;
	  var change = modifier();
	  if (range != null) {
	    if (index === true) index = range.index;
	    if (shift == null) {
	      range = shiftRange(range, change, source);
	    } else if (shift !== 0) {
	      range = shiftRange(range, index, shift, source);
	    }
	    this.setSelection(range, _emitter4.default.sources.SILENT);
	  }
	  if (change.length() > 0) {
	    var _emitter;
	
	    var args = [_emitter4.default.events.TEXT_CHANGE, change, oldDelta, source];
	    (_emitter = this.emitter).emit.apply(_emitter, [_emitter4.default.events.EDITOR_CHANGE].concat(args));
	    if (source !== _emitter4.default.sources.SILENT) {
	      var _emitter2;
	
	      (_emitter2 = this.emitter).emit.apply(_emitter2, args);
	    }
	  }
	  return change;
	}
	
	function overload(index, length, name, value, source) {
	  var formats = {};
	  if (typeof index.index === 'number' && typeof index.length === 'number') {
	    // Allow for throwaway end (used by insertText/insertEmbed)
	    if (typeof length !== 'number') {
	      source = value, value = name, name = length, length = index.length, index = index.index;
	    } else {
	      length = index.length, index = index.index;
	    }
	  } else if (typeof length !== 'number') {
	    source = value, value = name, name = length, length = 0;
	  }
	  // Handle format being object, two format name/value strings or excluded
	  if ((typeof name === 'undefined' ? 'undefined' : _typeof(name)) === 'object') {
	    formats = name;
	    source = value;
	  } else if (typeof name === 'string') {
	    if (value != null) {
	      formats[name] = value;
	    } else {
	      source = name;
	    }
	  }
	  // Handle optional source
	  source = source || _emitter4.default.sources.API;
	  return [index, length, formats, source];
	}
	
	function shiftRange(range, index, length, source) {
	  if (range == null) return null;
	  var start = void 0,
	      end = void 0;
	  if (index instanceof _quillDelta2.default) {
	    var _map = [range.index, range.index + range.length].map(function (pos) {
	      return index.transformPosition(pos, source !== _emitter4.default.sources.USER);
	    });
	
	    var _map2 = _slicedToArray(_map, 2);
	
	    start = _map2[0];
	    end = _map2[1];
	  } else {
	    var _map3 = [range.index, range.index + range.length].map(function (pos) {
	      if (pos < index || pos === index && source === _emitter4.default.sources.USER) return pos;
	      if (length >= 0) {
	        return pos + length;
	      } else {
	        return Math.max(index, pos + length);
	      }
	    });
	
	    var _map4 = _slicedToArray(_map3, 2);
	
	    start = _map4[0];
	    end = _map4[1];
	  }
	  return new _selection.Range(start, end - start);
	}
	
	exports.expandConfig = expandConfig;
	exports.overload = overload;
	exports.default = Quill;
	
	/***/ }),
	/* 6 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };
	
	var _text = __webpack_require__(7);
	
	var _text2 = _interopRequireDefault(_text);
	
	var _parchment = __webpack_require__(0);
	
	var _parchment2 = _interopRequireDefault(_parchment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Inline = function (_Parchment$Inline) {
	  _inherits(Inline, _Parchment$Inline);
	
	  function Inline() {
	    _classCallCheck(this, Inline);
	
	    return _possibleConstructorReturn(this, (Inline.__proto__ || Object.getPrototypeOf(Inline)).apply(this, arguments));
	  }
	
	  _createClass(Inline, [{
	    key: 'formatAt',
	    value: function formatAt(index, length, name, value) {
	      if (Inline.compare(this.statics.blotName, name) < 0 && _parchment2.default.query(name, _parchment2.default.Scope.BLOT)) {
	        var blot = this.isolate(index, length);
	        if (value) {
	          blot.wrap(name, value);
	        }
	      } else {
	        _get(Inline.prototype.__proto__ || Object.getPrototypeOf(Inline.prototype), 'formatAt', this).call(this, index, length, name, value);
	      }
	    }
	  }, {
	    key: 'optimize',
	    value: function optimize(context) {
	      _get(Inline.prototype.__proto__ || Object.getPrototypeOf(Inline.prototype), 'optimize', this).call(this, context);
	      if (this.parent instanceof Inline && Inline.compare(this.statics.blotName, this.parent.statics.blotName) > 0) {
	        var parent = this.parent.isolate(this.offset(), this.length());
	        this.moveChildren(parent);
	        parent.wrap(this);
	      }
	    }
	  }], [{
	    key: 'compare',
	    value: function compare(self, other) {
	      var selfIndex = Inline.order.indexOf(self);
	      var otherIndex = Inline.order.indexOf(other);
	      if (selfIndex >= 0 || otherIndex >= 0) {
	        return selfIndex - otherIndex;
	      } else if (self === other) {
	        return 0;
	      } else if (self < other) {
	        return -1;
	      } else {
	        return 1;
	      }
	    }
	  }]);
	
	  return Inline;
	}(_parchment2.default.Inline);
	
	Inline.allowedChildren = [Inline, _parchment2.default.Embed, _text2.default];
	// Lower index means deeper in the DOM tree, since not found (-1) is for embeds
	Inline.order = ['cursor', 'inline', // Must be lower
	'underline', 'strike', 'italic', 'bold', 'script', 'link', 'code' // Must be higher
	];
	
	exports.default = Inline;
	
	/***/ }),
	/* 7 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _parchment = __webpack_require__(0);
	
	var _parchment2 = _interopRequireDefault(_parchment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var TextBlot = function (_Parchment$Text) {
	  _inherits(TextBlot, _Parchment$Text);
	
	  function TextBlot() {
	    _classCallCheck(this, TextBlot);
	
	    return _possibleConstructorReturn(this, (TextBlot.__proto__ || Object.getPrototypeOf(TextBlot)).apply(this, arguments));
	  }
	
	  return TextBlot;
	}(_parchment2.default.Text);
	
	exports.default = TextBlot;
	
	/***/ }),
	/* 8 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };
	
	var _eventemitter = __webpack_require__(54);
	
	var _eventemitter2 = _interopRequireDefault(_eventemitter);
	
	var _logger = __webpack_require__(10);
	
	var _logger2 = _interopRequireDefault(_logger);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var debug = (0, _logger2.default)('quill:events');
	
	var EVENTS = ['selectionchange', 'mousedown', 'mouseup', 'click'];
	
	EVENTS.forEach(function (eventName) {
	  document.addEventListener(eventName, function () {
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    [].slice.call(document.querySelectorAll('.ql-container')).forEach(function (node) {
	      // TODO use WeakMap
	      if (node.__quill && node.__quill.emitter) {
	        var _node$__quill$emitter;
	
	        (_node$__quill$emitter = node.__quill.emitter).handleDOM.apply(_node$__quill$emitter, args);
	      }
	    });
	  });
	});
	
	var Emitter = function (_EventEmitter) {
	  _inherits(Emitter, _EventEmitter);
	
	  function Emitter() {
	    _classCallCheck(this, Emitter);
	
	    var _this = _possibleConstructorReturn(this, (Emitter.__proto__ || Object.getPrototypeOf(Emitter)).call(this));
	
	    _this.listeners = {};
	    _this.on('error', debug.error);
	    return _this;
	  }
	
	  _createClass(Emitter, [{
	    key: 'emit',
	    value: function emit() {
	      debug.log.apply(debug, arguments);
	      _get(Emitter.prototype.__proto__ || Object.getPrototypeOf(Emitter.prototype), 'emit', this).apply(this, arguments);
	    }
	  }, {
	    key: 'handleDOM',
	    value: function handleDOM(event) {
	      for (var _len2 = arguments.length, args = Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
	        args[_key2 - 1] = arguments[_key2];
	      }
	
	      (this.listeners[event.type] || []).forEach(function (_ref) {
	        var node = _ref.node,
	            handler = _ref.handler;
	
	        if (event.target === node || node.contains(event.target)) {
	          handler.apply(undefined, [event].concat(args));
	        }
	      });
	    }
	  }, {
	    key: 'listenDOM',
	    value: function listenDOM(eventName, node, handler) {
	      if (!this.listeners[eventName]) {
	        this.listeners[eventName] = [];
	      }
	      this.listeners[eventName].push({ node: node, handler: handler });
	    }
	  }]);
	
	  return Emitter;
	}(_eventemitter2.default);
	
	Emitter.events = {
	  EDITOR_CHANGE: 'editor-change',
	  SCROLL_BEFORE_UPDATE: 'scroll-before-update',
	  SCROLL_OPTIMIZE: 'scroll-optimize',
	  SCROLL_UPDATE: 'scroll-update',
	  SELECTION_CHANGE: 'selection-change',
	  TEXT_CHANGE: 'text-change'
	};
	Emitter.sources = {
	  API: 'api',
	  SILENT: 'silent',
	  USER: 'user'
	};
	
	exports.default = Emitter;
	
	/***/ }),
	/* 9 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var Module = function Module(quill) {
	  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	  _classCallCheck(this, Module);
	
	  this.quill = quill;
	  this.options = options;
	};
	
	Module.DEFAULTS = {};
	
	exports.default = Module;
	
	/***/ }),
	/* 10 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var levels = ['error', 'warn', 'log', 'info'];
	var level = 'warn';
	
	function debug(method) {
	  if (levels.indexOf(method) <= levels.indexOf(level)) {
	    var _console;
	
	    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	      args[_key - 1] = arguments[_key];
	    }
	
	    (_console = console)[method].apply(_console, args); // eslint-disable-line no-console
	  }
	}
	
	function namespace(ns) {
	  return levels.reduce(function (logger, method) {
	    logger[method] = debug.bind(console, method, ns);
	    return logger;
	  }, {});
	}
	
	debug.level = namespace.level = function (newLevel) {
	  level = newLevel;
	};
	
	exports.default = namespace;
	
	/***/ }),
	/* 11 */
	/***/ (function(module, exports, __webpack_require__) {
	
	var pSlice = Array.prototype.slice;
	var objectKeys = __webpack_require__(52);
	var isArguments = __webpack_require__(53);
	
	var deepEqual = module.exports = function (actual, expected, opts) {
	  if (!opts) opts = {};
	  // 7.1. All identical values are equivalent, as determined by ===.
	  if (actual === expected) {
	    return true;
	
	  } else if (actual instanceof Date && expected instanceof Date) {
	    return actual.getTime() === expected.getTime();
	
	  // 7.3. Other pairs that do not both pass typeof value == 'object',
	  // equivalence is determined by ==.
	  } else if (!actual || !expected || typeof actual != 'object' && typeof expected != 'object') {
	    return opts.strict ? actual === expected : actual == expected;
	
	  // 7.4. For all other Object pairs, including Array objects, equivalence is
	  // determined by having the same number of owned properties (as verified
	  // with Object.prototype.hasOwnProperty.call), the same set of keys
	  // (although not necessarily the same order), equivalent values for every
	  // corresponding key, and an identical 'prototype' property. Note: this
	  // accounts for both named and indexed properties on Arrays.
	  } else {
	    return objEquiv(actual, expected, opts);
	  }
	}
	
	function isUndefinedOrNull(value) {
	  return value === null || value === undefined;
	}
	
	function isBuffer (x) {
	  if (!x || typeof x !== 'object' || typeof x.length !== 'number') return false;
	  if (typeof x.copy !== 'function' || typeof x.slice !== 'function') {
	    return false;
	  }
	  if (x.length > 0 && typeof x[0] !== 'number') return false;
	  return true;
	}
	
	function objEquiv(a, b, opts) {
	  var i, key;
	  if (isUndefinedOrNull(a) || isUndefinedOrNull(b))
	    return false;
	  // an identical 'prototype' property.
	  if (a.prototype !== b.prototype) return false;
	  //~~~I've managed to break Object.keys through screwy arguments passing.
	  //   Converting to array solves the problem.
	  if (isArguments(a)) {
	    if (!isArguments(b)) {
	      return false;
	    }
	    a = pSlice.call(a);
	    b = pSlice.call(b);
	    return deepEqual(a, b, opts);
	  }
	  if (isBuffer(a)) {
	    if (!isBuffer(b)) {
	      return false;
	    }
	    if (a.length !== b.length) return false;
	    for (i = 0; i < a.length; i++) {
	      if (a[i] !== b[i]) return false;
	    }
	    return true;
	  }
	  try {
	    var ka = objectKeys(a),
	        kb = objectKeys(b);
	  } catch (e) {//happens when one is a string literal and the other isn't
	    return false;
	  }
	  // having the same number of owned properties (keys incorporates
	  // hasOwnProperty)
	  if (ka.length != kb.length)
	    return false;
	  //the same set of keys (although not necessarily the same order),
	  ka.sort();
	  kb.sort();
	  //~~~cheap key test
	  for (i = ka.length - 1; i >= 0; i--) {
	    if (ka[i] != kb[i])
	      return false;
	  }
	  //equivalent values for every corresponding key, and
	  //~~~possibly expensive deep test
	  for (i = ka.length - 1; i >= 0; i--) {
	    key = ka[i];
	    if (!deepEqual(a[key], b[key], opts)) return false;
	  }
	  return typeof a === typeof b;
	}
	
	
	/***/ }),
	/* 12 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	Object.defineProperty(exports, "__esModule", { value: true });
	var Registry = __webpack_require__(1);
	var Attributor = /** @class */ (function () {
	    function Attributor(attrName, keyName, options) {
	        if (options === void 0) { options = {}; }
	        this.attrName = attrName;
	        this.keyName = keyName;
	        var attributeBit = Registry.Scope.TYPE & Registry.Scope.ATTRIBUTE;
	        if (options.scope != null) {
	            // Ignore type bits, force attribute bit
	            this.scope = (options.scope & Registry.Scope.LEVEL) | attributeBit;
	        }
	        else {
	            this.scope = Registry.Scope.ATTRIBUTE;
	        }
	        if (options.whitelist != null)
	            this.whitelist = options.whitelist;
	    }
	    Attributor.keys = function (node) {
	        return [].map.call(node.attributes, function (item) {
	            return item.name;
	        });
	    };
	    Attributor.prototype.add = function (node, value) {
	        if (!this.canAdd(node, value))
	            return false;
	        node.setAttribute(this.keyName, value);
	        return true;
	    };
	    Attributor.prototype.canAdd = function (node, value) {
	        var match = Registry.query(node, Registry.Scope.BLOT & (this.scope | Registry.Scope.TYPE));
	        if (match == null)
	            return false;
	        if (this.whitelist == null)
	            return true;
	        if (typeof value === 'string') {
	            return this.whitelist.indexOf(value.replace(/["']/g, '')) > -1;
	        }
	        else {
	            return this.whitelist.indexOf(value) > -1;
	        }
	    };
	    Attributor.prototype.remove = function (node) {
	        node.removeAttribute(this.keyName);
	    };
	    Attributor.prototype.value = function (node) {
	        var value = node.getAttribute(this.keyName);
	        if (this.canAdd(node, value) && value) {
	            return value;
	        }
	        return '';
	    };
	    return Attributor;
	}());
	exports.default = Attributor;
	
	
	/***/ }),
	/* 13 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.Code = undefined;
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };
	
	var _quillDelta = __webpack_require__(2);
	
	var _quillDelta2 = _interopRequireDefault(_quillDelta);
	
	var _parchment = __webpack_require__(0);
	
	var _parchment2 = _interopRequireDefault(_parchment);
	
	var _block = __webpack_require__(4);
	
	var _block2 = _interopRequireDefault(_block);
	
	var _inline = __webpack_require__(6);
	
	var _inline2 = _interopRequireDefault(_inline);
	
	var _text = __webpack_require__(7);
	
	var _text2 = _interopRequireDefault(_text);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Code = function (_Inline) {
	  _inherits(Code, _Inline);
	
	  function Code() {
	    _classCallCheck(this, Code);
	
	    return _possibleConstructorReturn(this, (Code.__proto__ || Object.getPrototypeOf(Code)).apply(this, arguments));
	  }
	
	  return Code;
	}(_inline2.default);
	
	Code.blotName = 'code';
	Code.tagName = 'CODE';
	
	var CodeBlock = function (_Block) {
	  _inherits(CodeBlock, _Block);
	
	  function CodeBlock() {
	    _classCallCheck(this, CodeBlock);
	
	    return _possibleConstructorReturn(this, (CodeBlock.__proto__ || Object.getPrototypeOf(CodeBlock)).apply(this, arguments));
	  }
	
	  _createClass(CodeBlock, [{
	    key: 'delta',
	    value: function delta() {
	      var _this3 = this;
	
	      var text = this.domNode.textContent;
	      if (text.endsWith('\n')) {
	        // Should always be true
	        text = text.slice(0, -1);
	      }
	      return text.split('\n').reduce(function (delta, frag) {
	        return delta.insert(frag).insert('\n', _this3.formats());
	      }, new _quillDelta2.default());
	    }
	  }, {
	    key: 'format',
	    value: function format(name, value) {
	      if (name === this.statics.blotName && value) return;
	
	      var _descendant = this.descendant(_text2.default, this.length() - 1),
	          _descendant2 = _slicedToArray(_descendant, 1),
	          text = _descendant2[0];
	
	      if (text != null) {
	        text.deleteAt(text.length() - 1, 1);
	      }
	      _get(CodeBlock.prototype.__proto__ || Object.getPrototypeOf(CodeBlock.prototype), 'format', this).call(this, name, value);
	    }
	  }, {
	    key: 'formatAt',
	    value: function formatAt(index, length, name, value) {
	      if (length === 0) return;
	      if (_parchment2.default.query(name, _parchment2.default.Scope.BLOCK) == null || name === this.statics.blotName && value === this.statics.formats(this.domNode)) {
	        return;
	      }
	      var nextNewline = this.newlineIndex(index);
	      if (nextNewline < 0 || nextNewline >= index + length) return;
	      var prevNewline = this.newlineIndex(index, true) + 1;
	      var isolateLength = nextNewline - prevNewline + 1;
	      var blot = this.isolate(prevNewline, isolateLength);
	      var next = blot.next;
	      blot.format(name, value);
	      if (next instanceof CodeBlock) {
	        next.formatAt(0, index - prevNewline + length - isolateLength, name, value);
	      }
	    }
	  }, {
	    key: 'insertAt',
	    value: function insertAt(index, value, def) {
	      if (def != null) return;
	
	      var _descendant3 = this.descendant(_text2.default, index),
	          _descendant4 = _slicedToArray(_descendant3, 2),
	          text = _descendant4[0],
	          offset = _descendant4[1];
	
	      text.insertAt(offset, value);
	    }
	  }, {
	    key: 'length',
	    value: function length() {
	      var length = this.domNode.textContent.length;
	      if (!this.domNode.textContent.endsWith('\n')) {
	        return length + 1;
	      }
	      return length;
	    }
	  }, {
	    key: 'newlineIndex',
	    value: function newlineIndex(searchIndex) {
	      var reverse = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	
	      if (!reverse) {
	        var offset = this.domNode.textContent.slice(searchIndex).indexOf('\n');
	        return offset > -1 ? searchIndex + offset : -1;
	      } else {
	        return this.domNode.textContent.slice(0, searchIndex).lastIndexOf('\n');
	      }
	    }
	  }, {
	    key: 'optimize',
	    value: function optimize(context) {
	      if (!this.domNode.textContent.endsWith('\n')) {
	        this.appendChild(_parchment2.default.create('text', '\n'));
	      }
	      _get(CodeBlock.prototype.__proto__ || Object.getPrototypeOf(CodeBlock.prototype), 'optimize', this).call(this, context);
	      var next = this.next;
	      if (next != null && next.prev === this && next.statics.blotName === this.statics.blotName && this.statics.formats(this.domNode) === next.statics.formats(next.domNode)) {
	        next.optimize(context);
	        next.moveChildren(this);
	        next.remove();
	      }
	    }
	  }, {
	    key: 'replace',
	    value: function replace(target) {
	      _get(CodeBlock.prototype.__proto__ || Object.getPrototypeOf(CodeBlock.prototype), 'replace', this).call(this, target);
	      [].slice.call(this.domNode.querySelectorAll('*')).forEach(function (node) {
	        var blot = _parchment2.default.find(node);
	        if (blot == null) {
	          node.parentNode.removeChild(node);
	        } else if (blot instanceof _parchment2.default.Embed) {
	          blot.remove();
	        } else {
	          blot.unwrap();
	        }
	      });
	    }
	  }], [{
	    key: 'create',
	    value: function create(value) {
	      var domNode = _get(CodeBlock.__proto__ || Object.getPrototypeOf(CodeBlock), 'create', this).call(this, value);
	      domNode.setAttribute('spellcheck', false);
	      return domNode;
	    }
	  }, {
	    key: 'formats',
	    value: function formats() {
	      return true;
	    }
	  }]);
	
	  return CodeBlock;
	}(_block2.default);
	
	CodeBlock.blotName = 'code-block';
	CodeBlock.tagName = 'PRE';
	CodeBlock.TAB = '  ';
	
	exports.Code = Code;
	exports.default = CodeBlock;
	
	/***/ }),
	/* 14 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _quillDelta = __webpack_require__(2);
	
	var _quillDelta2 = _interopRequireDefault(_quillDelta);
	
	var _op = __webpack_require__(20);
	
	var _op2 = _interopRequireDefault(_op);
	
	var _parchment = __webpack_require__(0);
	
	var _parchment2 = _interopRequireDefault(_parchment);
	
	var _code = __webpack_require__(13);
	
	var _code2 = _interopRequireDefault(_code);
	
	var _cursor = __webpack_require__(24);
	
	var _cursor2 = _interopRequireDefault(_cursor);
	
	var _block = __webpack_require__(4);
	
	var _block2 = _interopRequireDefault(_block);
	
	var _break = __webpack_require__(16);
	
	var _break2 = _interopRequireDefault(_break);
	
	var _clone = __webpack_require__(21);
	
	var _clone2 = _interopRequireDefault(_clone);
	
	var _deepEqual = __webpack_require__(11);
	
	var _deepEqual2 = _interopRequireDefault(_deepEqual);
	
	var _extend = __webpack_require__(3);
	
	var _extend2 = _interopRequireDefault(_extend);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var ASCII = /^[ -~]*$/;
	
	var Editor = function () {
	  function Editor(scroll) {
	    _classCallCheck(this, Editor);
	
	    this.scroll = scroll;
	    this.delta = this.getDelta();
	  }
	
	  _createClass(Editor, [{
	    key: 'applyDelta',
	    value: function applyDelta(delta) {
	      var _this = this;
	
	      var consumeNextNewline = false;
	      this.scroll.update();
	      var scrollLength = this.scroll.length();
	      this.scroll.batchStart();
	      delta = normalizeDelta(delta);
	      delta.reduce(function (index, op) {
	        var length = op.retain || op.delete || op.insert.length || 1;
	        var attributes = op.attributes || {};
	        if (op.insert != null) {
	          if (typeof op.insert === 'string') {
	            var text = op.insert;
	            if (text.endsWith('\n') && consumeNextNewline) {
	              consumeNextNewline = false;
	              text = text.slice(0, -1);
	            }
	            if (index >= scrollLength && !text.endsWith('\n')) {
	              consumeNextNewline = true;
	            }
	            _this.scroll.insertAt(index, text);
	
	            var _scroll$line = _this.scroll.line(index),
	                _scroll$line2 = _slicedToArray(_scroll$line, 2),
	                line = _scroll$line2[0],
	                offset = _scroll$line2[1];
	
	            var formats = (0, _extend2.default)({}, (0, _block.bubbleFormats)(line));
	            if (line instanceof _block2.default) {
	              var _line$descendant = line.descendant(_parchment2.default.Leaf, offset),
	                  _line$descendant2 = _slicedToArray(_line$descendant, 1),
	                  leaf = _line$descendant2[0];
	
	              formats = (0, _extend2.default)(formats, (0, _block.bubbleFormats)(leaf));
	            }
	            attributes = _op2.default.attributes.diff(formats, attributes) || {};
	          } else if (_typeof(op.insert) === 'object') {
	            var key = Object.keys(op.insert)[0]; // There should only be one key
	            if (key == null) return index;
	            _this.scroll.insertAt(index, key, op.insert[key]);
	          }
	          scrollLength += length;
	        }
	        Object.keys(attributes).forEach(function (name) {
	          _this.scroll.formatAt(index, length, name, attributes[name]);
	        });
	        return index + length;
	      }, 0);
	      delta.reduce(function (index, op) {
	        if (typeof op.delete === 'number') {
	          _this.scroll.deleteAt(index, op.delete);
	          return index;
	        }
	        return index + (op.retain || op.insert.length || 1);
	      }, 0);
	      this.scroll.batchEnd();
	      return this.update(delta);
	    }
	  }, {
	    key: 'deleteText',
	    value: function deleteText(index, length) {
	      this.scroll.deleteAt(index, length);
	      return this.update(new _quillDelta2.default().retain(index).delete(length));
	    }
	  }, {
	    key: 'formatLine',
	    value: function formatLine(index, length) {
	      var _this2 = this;
	
	      var formats = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	
	      this.scroll.update();
	      Object.keys(formats).forEach(function (format) {
	        if (_this2.scroll.whitelist != null && !_this2.scroll.whitelist[format]) return;
	        var lines = _this2.scroll.lines(index, Math.max(length, 1));
	        var lengthRemaining = length;
	        lines.forEach(function (line) {
	          var lineLength = line.length();
	          if (!(line instanceof _code2.default)) {
	            line.format(format, formats[format]);
	          } else {
	            var codeIndex = index - line.offset(_this2.scroll);
	            var codeLength = line.newlineIndex(codeIndex + lengthRemaining) - codeIndex + 1;
	            line.formatAt(codeIndex, codeLength, format, formats[format]);
	          }
	          lengthRemaining -= lineLength;
	        });
	      });
	      this.scroll.optimize();
	      return this.update(new _quillDelta2.default().retain(index).retain(length, (0, _clone2.default)(formats)));
	    }
	  }, {
	    key: 'formatText',
	    value: function formatText(index, length) {
	      var _this3 = this;
	
	      var formats = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	
	      Object.keys(formats).forEach(function (format) {
	        _this3.scroll.formatAt(index, length, format, formats[format]);
	      });
	      return this.update(new _quillDelta2.default().retain(index).retain(length, (0, _clone2.default)(formats)));
	    }
	  }, {
	    key: 'getContents',
	    value: function getContents(index, length) {
	      return this.delta.slice(index, index + length);
	    }
	  }, {
	    key: 'getDelta',
	    value: function getDelta() {
	      return this.scroll.lines().reduce(function (delta, line) {
	        return delta.concat(line.delta());
	      }, new _quillDelta2.default());
	    }
	  }, {
	    key: 'getFormat',
	    value: function getFormat(index) {
	      var length = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
	
	      var lines = [],
	          leaves = [];
	      if (length === 0) {
	        this.scroll.path(index).forEach(function (path) {
	          var _path = _slicedToArray(path, 1),
	              blot = _path[0];
	
	          if (blot instanceof _block2.default) {
	            lines.push(blot);
	          } else if (blot instanceof _parchment2.default.Leaf) {
	            leaves.push(blot);
	          }
	        });
	      } else {
	        lines = this.scroll.lines(index, length);
	        leaves = this.scroll.descendants(_parchment2.default.Leaf, index, length);
	      }
	      var formatsArr = [lines, leaves].map(function (blots) {
	        if (blots.length === 0) return {};
	        var formats = (0, _block.bubbleFormats)(blots.shift());
	        while (Object.keys(formats).length > 0) {
	          var blot = blots.shift();
	          if (blot == null) return formats;
	          formats = combineFormats((0, _block.bubbleFormats)(blot), formats);
	        }
	        return formats;
	      });
	      return _extend2.default.apply(_extend2.default, formatsArr);
	    }
	  }, {
	    key: 'getText',
	    value: function getText(index, length) {
	      return this.getContents(index, length).filter(function (op) {
	        return typeof op.insert === 'string';
	      }).map(function (op) {
	        return op.insert;
	      }).join('');
	    }
	  }, {
	    key: 'insertEmbed',
	    value: function insertEmbed(index, embed, value) {
	      this.scroll.insertAt(index, embed, value);
	      return this.update(new _quillDelta2.default().retain(index).insert(_defineProperty({}, embed, value)));
	    }
	  }, {
	    key: 'insertText',
	    value: function insertText(index, text) {
	      var _this4 = this;
	
	      var formats = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	
	      text = text.replace(/\r\n/g, '\n').replace(/\r/g, '\n');
	      this.scroll.insertAt(index, text);
	      Object.keys(formats).forEach(function (format) {
	        _this4.scroll.formatAt(index, text.length, format, formats[format]);
	      });
	      return this.update(new _quillDelta2.default().retain(index).insert(text, (0, _clone2.default)(formats)));
	    }
	  }, {
	    key: 'isBlank',
	    value: function isBlank() {
	      if (this.scroll.children.length == 0) return true;
	      if (this.scroll.children.length > 1) return false;
	      var block = this.scroll.children.head;
	      if (block.statics.blotName !== _block2.default.blotName) return false;
	      if (block.children.length > 1) return false;
	      return block.children.head instanceof _break2.default;
	    }
	  }, {
	    key: 'removeFormat',
	    value: function removeFormat(index, length) {
	      var text = this.getText(index, length);
	
	      var _scroll$line3 = this.scroll.line(index + length),
	          _scroll$line4 = _slicedToArray(_scroll$line3, 2),
	          line = _scroll$line4[0],
	          offset = _scroll$line4[1];
	
	      var suffixLength = 0,
	          suffix = new _quillDelta2.default();
	      if (line != null) {
	        if (!(line instanceof _code2.default)) {
	          suffixLength = line.length() - offset;
	        } else {
	          suffixLength = line.newlineIndex(offset) - offset + 1;
	        }
	        suffix = line.delta().slice(offset, offset + suffixLength - 1).insert('\n');
	      }
	      var contents = this.getContents(index, length + suffixLength);
	      var diff = contents.diff(new _quillDelta2.default().insert(text).concat(suffix));
	      var delta = new _quillDelta2.default().retain(index).concat(diff);
	      return this.applyDelta(delta);
	    }
	  }, {
	    key: 'update',
	    value: function update(change) {
	      var mutations = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
	      var cursorIndex = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : undefined;
	
	      var oldDelta = this.delta;
	      if (mutations.length === 1 && mutations[0].type === 'characterData' && mutations[0].target.data.match(ASCII) && _parchment2.default.find(mutations[0].target)) {
	        // Optimization for character changes
	        var textBlot = _parchment2.default.find(mutations[0].target);
	        var formats = (0, _block.bubbleFormats)(textBlot);
	        var index = textBlot.offset(this.scroll);
	        var oldValue = mutations[0].oldValue.replace(_cursor2.default.CONTENTS, '');
	        var oldText = new _quillDelta2.default().insert(oldValue);
	        var newText = new _quillDelta2.default().insert(textBlot.value());
	        var diffDelta = new _quillDelta2.default().retain(index).concat(oldText.diff(newText, cursorIndex));
	        change = diffDelta.reduce(function (delta, op) {
	          if (op.insert) {
	            return delta.insert(op.insert, formats);
	          } else {
	            return delta.push(op);
	          }
	        }, new _quillDelta2.default());
	        this.delta = oldDelta.compose(change);
	      } else {
	        this.delta = this.getDelta();
	        if (!change || !(0, _deepEqual2.default)(oldDelta.compose(change), this.delta)) {
	          change = oldDelta.diff(this.delta, cursorIndex);
	        }
	      }
	      return change;
	    }
	  }]);
	
	  return Editor;
	}();
	
	function combineFormats(formats, combined) {
	  return Object.keys(combined).reduce(function (merged, name) {
	    if (formats[name] == null) return merged;
	    if (combined[name] === formats[name]) {
	      merged[name] = combined[name];
	    } else if (Array.isArray(combined[name])) {
	      if (combined[name].indexOf(formats[name]) < 0) {
	        merged[name] = combined[name].concat([formats[name]]);
	      }
	    } else {
	      merged[name] = [combined[name], formats[name]];
	    }
	    return merged;
	  }, {});
	}
	
	function normalizeDelta(delta) {
	  return delta.reduce(function (delta, op) {
	    if (op.insert === 1) {
	      var attributes = (0, _clone2.default)(op.attributes);
	      delete attributes['image'];
	      return delta.insert({ image: op.attributes.image }, attributes);
	    }
	    if (op.attributes != null && (op.attributes.list === true || op.attributes.bullet === true)) {
	      op = (0, _clone2.default)(op);
	      if (op.attributes.list) {
	        op.attributes.list = 'ordered';
	      } else {
	        op.attributes.list = 'bullet';
	        delete op.attributes.bullet;
	      }
	    }
	    if (typeof op.insert === 'string') {
	      var text = op.insert.replace(/\r\n/g, '\n').replace(/\r/g, '\n');
	      return delta.insert(text, op.attributes);
	    }
	    return delta.push(op);
	  }, new _quillDelta2.default());
	}
	
	exports.default = Editor;
	
	/***/ }),
	/* 15 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.Range = undefined;
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _parchment = __webpack_require__(0);
	
	var _parchment2 = _interopRequireDefault(_parchment);
	
	var _clone = __webpack_require__(21);
	
	var _clone2 = _interopRequireDefault(_clone);
	
	var _deepEqual = __webpack_require__(11);
	
	var _deepEqual2 = _interopRequireDefault(_deepEqual);
	
	var _emitter3 = __webpack_require__(8);
	
	var _emitter4 = _interopRequireDefault(_emitter3);
	
	var _logger = __webpack_require__(10);
	
	var _logger2 = _interopRequireDefault(_logger);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var debug = (0, _logger2.default)('quill:selection');
	
	var Range = function Range(index) {
	  var length = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
	
	  _classCallCheck(this, Range);
	
	  this.index = index;
	  this.length = length;
	};
	
	var Selection = function () {
	  function Selection(scroll, emitter) {
	    var _this = this;
	
	    _classCallCheck(this, Selection);
	
	    this.emitter = emitter;
	    this.scroll = scroll;
	    this.composing = false;
	    this.mouseDown = false;
	    this.root = this.scroll.domNode;
	    this.cursor = _parchment2.default.create('cursor', this);
	    // savedRange is last non-null range
	    this.lastRange = this.savedRange = new Range(0, 0);
	    this.handleComposition();
	    this.handleDragging();
	    this.emitter.listenDOM('selectionchange', document, function () {
	      if (!_this.mouseDown) {
	        setTimeout(_this.update.bind(_this, _emitter4.default.sources.USER), 1);
	      }
	    });
	    this.emitter.on(_emitter4.default.events.EDITOR_CHANGE, function (type, delta) {
	      if (type === _emitter4.default.events.TEXT_CHANGE && delta.length() > 0) {
	        _this.update(_emitter4.default.sources.SILENT);
	      }
	    });
	    this.emitter.on(_emitter4.default.events.SCROLL_BEFORE_UPDATE, function () {
	      if (!_this.hasFocus()) return;
	      var native = _this.getNativeRange();
	      if (native == null) return;
	      if (native.start.node === _this.cursor.textNode) return; // cursor.restore() will handle
	      // TODO unclear if this has negative side effects
	      _this.emitter.once(_emitter4.default.events.SCROLL_UPDATE, function () {
	        try {
	          _this.setNativeRange(native.start.node, native.start.offset, native.end.node, native.end.offset);
	        } catch (ignored) {}
	      });
	    });
	    this.emitter.on(_emitter4.default.events.SCROLL_OPTIMIZE, function (mutations, context) {
	      if (context.range) {
	        var _context$range = context.range,
	            startNode = _context$range.startNode,
	            startOffset = _context$range.startOffset,
	            endNode = _context$range.endNode,
	            endOffset = _context$range.endOffset;
	
	        _this.setNativeRange(startNode, startOffset, endNode, endOffset);
	      }
	    });
	    this.update(_emitter4.default.sources.SILENT);
	  }
	
	  _createClass(Selection, [{
	    key: 'handleComposition',
	    value: function handleComposition() {
	      var _this2 = this;
	
	      this.root.addEventListener('compositionstart', function () {
	        _this2.composing = true;
	      });
	      this.root.addEventListener('compositionend', function () {
	        _this2.composing = false;
	        if (_this2.cursor.parent) {
	          var range = _this2.cursor.restore();
	          if (!range) return;
	          setTimeout(function () {
	            _this2.setNativeRange(range.startNode, range.startOffset, range.endNode, range.endOffset);
	          }, 1);
	        }
	      });
	    }
	  }, {
	    key: 'handleDragging',
	    value: function handleDragging() {
	      var _this3 = this;
	
	      this.emitter.listenDOM('mousedown', document.body, function () {
	        _this3.mouseDown = true;
	      });
	      this.emitter.listenDOM('mouseup', document.body, function () {
	        _this3.mouseDown = false;
	        _this3.update(_emitter4.default.sources.USER);
	      });
	    }
	  }, {
	    key: 'focus',
	    value: function focus() {
	      if (this.hasFocus()) return;
	      this.root.focus();
	      this.setRange(this.savedRange);
	    }
	  }, {
	    key: 'format',
	    value: function format(_format, value) {
	      if (this.scroll.whitelist != null && !this.scroll.whitelist[_format]) return;
	      this.scroll.update();
	      var nativeRange = this.getNativeRange();
	      if (nativeRange == null || !nativeRange.native.collapsed || _parchment2.default.query(_format, _parchment2.default.Scope.BLOCK)) return;
	      if (nativeRange.start.node !== this.cursor.textNode) {
	        var blot = _parchment2.default.find(nativeRange.start.node, false);
	        if (blot == null) return;
	        // TODO Give blot ability to not split
	        if (blot instanceof _parchment2.default.Leaf) {
	          var after = blot.split(nativeRange.start.offset);
	          blot.parent.insertBefore(this.cursor, after);
	        } else {
	          blot.insertBefore(this.cursor, nativeRange.start.node); // Should never happen
	        }
	        this.cursor.attach();
	      }
	      this.cursor.format(_format, value);
	      this.scroll.optimize();
	      this.setNativeRange(this.cursor.textNode, this.cursor.textNode.data.length);
	      this.update();
	    }
	  }, {
	    key: 'getBounds',
	    value: function getBounds(index) {
	      var length = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
	
	      var scrollLength = this.scroll.length();
	      index = Math.min(index, scrollLength - 1);
	      length = Math.min(index + length, scrollLength - 1) - index;
	      var node = void 0,
	          _scroll$leaf = this.scroll.leaf(index),
	          _scroll$leaf2 = _slicedToArray(_scroll$leaf, 2),
	          leaf = _scroll$leaf2[0],
	          offset = _scroll$leaf2[1];
	      if (leaf == null) return null;
	
	      var _leaf$position = leaf.position(offset, true);
	
	      var _leaf$position2 = _slicedToArray(_leaf$position, 2);
	
	      node = _leaf$position2[0];
	      offset = _leaf$position2[1];
	
	      var range = document.createRange();
	      if (length > 0) {
	        range.setStart(node, offset);
	
	        var _scroll$leaf3 = this.scroll.leaf(index + length);
	
	        var _scroll$leaf4 = _slicedToArray(_scroll$leaf3, 2);
	
	        leaf = _scroll$leaf4[0];
	        offset = _scroll$leaf4[1];
	
	        if (leaf == null) return null;
	
	        var _leaf$position3 = leaf.position(offset, true);
	
	        var _leaf$position4 = _slicedToArray(_leaf$position3, 2);
	
	        node = _leaf$position4[0];
	        offset = _leaf$position4[1];
	
	        range.setEnd(node, offset);
	        return range.getBoundingClientRect();
	      } else {
	        var side = 'left';
	        var rect = void 0;
	        if (node instanceof Text) {
	          if (offset < node.data.length) {
	            range.setStart(node, offset);
	            range.setEnd(node, offset + 1);
	          } else {
	            range.setStart(node, offset - 1);
	            range.setEnd(node, offset);
	            side = 'right';
	          }
	          rect = range.getBoundingClientRect();
	        } else {
	          rect = leaf.domNode.getBoundingClientRect();
	          if (offset > 0) side = 'right';
	        }
	        return {
	          bottom: rect.top + rect.height,
	          height: rect.height,
	          left: rect[side],
	          right: rect[side],
	          top: rect.top,
	          width: 0
	        };
	      }
	    }
	  }, {
	    key: 'getNativeRange',
	    value: function getNativeRange() {
	      var selection = document.getSelection();
	      if (selection == null || selection.rangeCount <= 0) return null;
	      var nativeRange = selection.getRangeAt(0);
	      if (nativeRange == null) return null;
	      var range = this.normalizeNative(nativeRange);
	      debug.info('getNativeRange', range);
	      return range;
	    }
	  }, {
	    key: 'getRange',
	    value: function getRange() {
	      var normalized = this.getNativeRange();
	      if (normalized == null) return [null, null];
	      var range = this.normalizedToRange(normalized);
	      return [range, normalized];
	    }
	  }, {
	    key: 'hasFocus',
	    value: function hasFocus() {
	      return document.activeElement === this.root;
	    }
	  }, {
	    key: 'normalizedToRange',
	    value: function normalizedToRange(range) {
	      var _this4 = this;
	
	      var positions = [[range.start.node, range.start.offset]];
	      if (!range.native.collapsed) {
	        positions.push([range.end.node, range.end.offset]);
	      }
	      var indexes = positions.map(function (position) {
	        var _position = _slicedToArray(position, 2),
	            node = _position[0],
	            offset = _position[1];
	
	        var blot = _parchment2.default.find(node, true);
	        var index = blot.offset(_this4.scroll);
	        if (offset === 0) {
	          return index;
	        } else if (blot instanceof _parchment2.default.Container) {
	          return index + blot.length();
	        } else {
	          return index + blot.index(node, offset);
	        }
	      });
	      var end = Math.min(Math.max.apply(Math, _toConsumableArray(indexes)), this.scroll.length() - 1);
	      var start = Math.min.apply(Math, [end].concat(_toConsumableArray(indexes)));
	      return new Range(start, end - start);
	    }
	  }, {
	    key: 'normalizeNative',
	    value: function normalizeNative(nativeRange) {
	      if (!contains(this.root, nativeRange.startContainer) || !nativeRange.collapsed && !contains(this.root, nativeRange.endContainer)) {
	        return null;
	      }
	      var range = {
	        start: { node: nativeRange.startContainer, offset: nativeRange.startOffset },
	        end: { node: nativeRange.endContainer, offset: nativeRange.endOffset },
	        native: nativeRange
	      };
	      [range.start, range.end].forEach(function (position) {
	        var node = position.node,
	            offset = position.offset;
	        while (!(node instanceof Text) && node.childNodes.length > 0) {
	          if (node.childNodes.length > offset) {
	            node = node.childNodes[offset];
	            offset = 0;
	          } else if (node.childNodes.length === offset) {
	            node = node.lastChild;
	            offset = node instanceof Text ? node.data.length : node.childNodes.length + 1;
	          } else {
	            break;
	          }
	        }
	        position.node = node, position.offset = offset;
	      });
	      return range;
	    }
	  }, {
	    key: 'rangeToNative',
	    value: function rangeToNative(range) {
	      var _this5 = this;
	
	      var indexes = range.collapsed ? [range.index] : [range.index, range.index + range.length];
	      var args = [];
	      var scrollLength = this.scroll.length();
	      indexes.forEach(function (index, i) {
	        index = Math.min(scrollLength - 1, index);
	        var node = void 0,
	            _scroll$leaf5 = _this5.scroll.leaf(index),
	            _scroll$leaf6 = _slicedToArray(_scroll$leaf5, 2),
	            leaf = _scroll$leaf6[0],
	            offset = _scroll$leaf6[1];
	        var _leaf$position5 = leaf.position(offset, i !== 0);
	
	        var _leaf$position6 = _slicedToArray(_leaf$position5, 2);
	
	        node = _leaf$position6[0];
	        offset = _leaf$position6[1];
	
	        args.push(node, offset);
	      });
	      if (args.length < 2) {
	        args = args.concat(args);
	      }
	      return args;
	    }
	  }, {
	    key: 'scrollIntoView',
	    value: function scrollIntoView(scrollingContainer) {
	      var range = this.lastRange;
	      if (range == null) return;
	      var bounds = this.getBounds(range.index, range.length);
	      if (bounds == null) return;
	      var limit = this.scroll.length() - 1;
	
	      var _scroll$line = this.scroll.line(Math.min(range.index, limit)),
	          _scroll$line2 = _slicedToArray(_scroll$line, 1),
	          first = _scroll$line2[0];
	
	      var last = first;
	      if (range.length > 0) {
	        var _scroll$line3 = this.scroll.line(Math.min(range.index + range.length, limit));
	
	        var _scroll$line4 = _slicedToArray(_scroll$line3, 1);
	
	        last = _scroll$line4[0];
	      }
	      if (first == null || last == null) return;
	      var scrollBounds = scrollingContainer.getBoundingClientRect();
	      if (bounds.top < scrollBounds.top) {
	        scrollingContainer.scrollTop -= scrollBounds.top - bounds.top;
	      } else if (bounds.bottom > scrollBounds.bottom) {
	        scrollingContainer.scrollTop += bounds.bottom - scrollBounds.bottom;
	      }
	    }
	  }, {
	    key: 'setNativeRange',
	    value: function setNativeRange(startNode, startOffset) {
	      var endNode = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : startNode;
	      var endOffset = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : startOffset;
	      var force = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;
	
	      debug.info('setNativeRange', startNode, startOffset, endNode, endOffset);
	      if (startNode != null && (this.root.parentNode == null || startNode.parentNode == null || endNode.parentNode == null)) {
	        return;
	      }
	      var selection = document.getSelection();
	      if (selection == null) return;
	      if (startNode != null) {
	        if (!this.hasFocus()) this.root.focus();
	        var native = (this.getNativeRange() || {}).native;
	        if (native == null || force || startNode !== native.startContainer || startOffset !== native.startOffset || endNode !== native.endContainer || endOffset !== native.endOffset) {
	
	          if (startNode.tagName == "BR") {
	            startOffset = [].indexOf.call(startNode.parentNode.childNodes, startNode);
	            startNode = startNode.parentNode;
	          }
	          if (endNode.tagName == "BR") {
	            endOffset = [].indexOf.call(endNode.parentNode.childNodes, endNode);
	            endNode = endNode.parentNode;
	          }
	          var range = document.createRange();
	          range.setStart(startNode, startOffset);
	          range.setEnd(endNode, endOffset);
	          selection.removeAllRanges();
	          selection.addRange(range);
	        }
	      } else {
	        selection.removeAllRanges();
	        this.root.blur();
	        document.body.focus(); // root.blur() not enough on IE11+Travis+SauceLabs (but not local VMs)
	      }
	    }
	  }, {
	    key: 'setRange',
	    value: function setRange(range) {
	      var force = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	      var source = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : _emitter4.default.sources.API;
	
	      if (typeof force === 'string') {
	        source = force;
	        force = false;
	      }
	      debug.info('setRange', range);
	      if (range != null) {
	        var args = this.rangeToNative(range);
	        this.setNativeRange.apply(this, _toConsumableArray(args).concat([force]));
	      } else {
	        this.setNativeRange(null);
	      }
	      this.update(source);
	    }
	  }, {
	    key: 'update',
	    value: function update() {
	      var source = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _emitter4.default.sources.USER;
	
	      var oldRange = this.lastRange;
	
	      var _getRange = this.getRange(),
	          _getRange2 = _slicedToArray(_getRange, 2),
	          lastRange = _getRange2[0],
	          nativeRange = _getRange2[1];
	
	      this.lastRange = lastRange;
	      if (this.lastRange != null) {
	        this.savedRange = this.lastRange;
	      }
	      if (!(0, _deepEqual2.default)(oldRange, this.lastRange)) {
	        var _emitter;
	
	        if (!this.composing && nativeRange != null && nativeRange.native.collapsed && nativeRange.start.node !== this.cursor.textNode) {
	          this.cursor.restore();
	        }
	        var args = [_emitter4.default.events.SELECTION_CHANGE, (0, _clone2.default)(this.lastRange), (0, _clone2.default)(oldRange), source];
	        (_emitter = this.emitter).emit.apply(_emitter, [_emitter4.default.events.EDITOR_CHANGE].concat(args));
	        if (source !== _emitter4.default.sources.SILENT) {
	          var _emitter2;
	
	          (_emitter2 = this.emitter).emit.apply(_emitter2, args);
	        }
	      }
	    }
	  }]);
	
	  return Selection;
	}();
	
	function contains(parent, descendant) {
	  try {
	    // Firefox inserts inaccessible nodes around video elements
	    descendant.parentNode;
	  } catch (e) {
	    return false;
	  }
	  // IE11 has bug with Text nodes
	  // https://connect.microsoft.com/IE/feedback/details/780874/node-contains-is-incorrect
	  if (descendant instanceof Text) {
	    descendant = descendant.parentNode;
	  }
	  return parent.contains(descendant);
	}
	
	exports.Range = Range;
	exports.default = Selection;
	
	/***/ }),
	/* 16 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };
	
	var _parchment = __webpack_require__(0);
	
	var _parchment2 = _interopRequireDefault(_parchment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Break = function (_Parchment$Embed) {
	  _inherits(Break, _Parchment$Embed);
	
	  function Break() {
	    _classCallCheck(this, Break);
	
	    return _possibleConstructorReturn(this, (Break.__proto__ || Object.getPrototypeOf(Break)).apply(this, arguments));
	  }
	
	  _createClass(Break, [{
	    key: 'insertInto',
	    value: function insertInto(parent, ref) {
	      if (parent.children.length === 0) {
	        _get(Break.prototype.__proto__ || Object.getPrototypeOf(Break.prototype), 'insertInto', this).call(this, parent, ref);
	      } else {
	        this.remove();
	      }
	    }
	  }, {
	    key: 'length',
	    value: function length() {
	      return 0;
	    }
	  }, {
	    key: 'value',
	    value: function value() {
	      return '';
	    }
	  }], [{
	    key: 'value',
	    value: function value() {
	      return undefined;
	    }
	  }]);
	
	  return Break;
	}(_parchment2.default.Embed);
	
	Break.blotName = 'break';
	Break.tagName = 'BR';
	
	exports.default = Break;
	
	/***/ }),
	/* 17 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var linked_list_1 = __webpack_require__(44);
	var shadow_1 = __webpack_require__(30);
	var Registry = __webpack_require__(1);
	var ContainerBlot = /** @class */ (function (_super) {
	    __extends(ContainerBlot, _super);
	    function ContainerBlot(domNode) {
	        var _this = _super.call(this, domNode) || this;
	        _this.build();
	        return _this;
	    }
	    ContainerBlot.prototype.appendChild = function (other) {
	        this.insertBefore(other);
	    };
	    ContainerBlot.prototype.attach = function () {
	        _super.prototype.attach.call(this);
	        this.children.forEach(function (child) {
	            child.attach();
	        });
	    };
	    ContainerBlot.prototype.build = function () {
	        var _this = this;
	        this.children = new linked_list_1.default();
	        // Need to be reversed for if DOM nodes already in order
	        [].slice
	            .call(this.domNode.childNodes)
	            .reverse()
	            .forEach(function (node) {
	            try {
	                var child = makeBlot(node);
	                _this.insertBefore(child, _this.children.head || undefined);
	            }
	            catch (err) {
	                if (err instanceof Registry.ParchmentError)
	                    return;
	                else
	                    throw err;
	            }
	        });
	    };
	    ContainerBlot.prototype.deleteAt = function (index, length) {
	        if (index === 0 && length === this.length()) {
	            return this.remove();
	        }
	        this.children.forEachAt(index, length, function (child, offset, length) {
	            child.deleteAt(offset, length);
	        });
	    };
	    ContainerBlot.prototype.descendant = function (criteria, index) {
	        var _a = this.children.find(index), child = _a[0], offset = _a[1];
	        if ((criteria.blotName == null && criteria(child)) ||
	            (criteria.blotName != null && child instanceof criteria)) {
	            return [child, offset];
	        }
	        else if (child instanceof ContainerBlot) {
	            return child.descendant(criteria, offset);
	        }
	        else {
	            return [null, -1];
	        }
	    };
	    ContainerBlot.prototype.descendants = function (criteria, index, length) {
	        if (index === void 0) { index = 0; }
	        if (length === void 0) { length = Number.MAX_VALUE; }
	        var descendants = [];
	        var lengthLeft = length;
	        this.children.forEachAt(index, length, function (child, index, length) {
	            if ((criteria.blotName == null && criteria(child)) ||
	                (criteria.blotName != null && child instanceof criteria)) {
	                descendants.push(child);
	            }
	            if (child instanceof ContainerBlot) {
	                descendants = descendants.concat(child.descendants(criteria, index, lengthLeft));
	            }
	            lengthLeft -= length;
	        });
	        return descendants;
	    };
	    ContainerBlot.prototype.detach = function () {
	        this.children.forEach(function (child) {
	            child.detach();
	        });
	        _super.prototype.detach.call(this);
	    };
	    ContainerBlot.prototype.formatAt = function (index, length, name, value) {
	        this.children.forEachAt(index, length, function (child, offset, length) {
	            child.formatAt(offset, length, name, value);
	        });
	    };
	    ContainerBlot.prototype.insertAt = function (index, value, def) {
	        var _a = this.children.find(index), child = _a[0], offset = _a[1];
	        if (child) {
	            child.insertAt(offset, value, def);
	        }
	        else {
	            var blot = def == null ? Registry.create('text', value) : Registry.create(value, def);
	            this.appendChild(blot);
	        }
	    };
	    ContainerBlot.prototype.insertBefore = function (childBlot, refBlot) {
	        if (this.statics.allowedChildren != null &&
	            !this.statics.allowedChildren.some(function (child) {
	                return childBlot instanceof child;
	            })) {
	            throw new Registry.ParchmentError("Cannot insert " + childBlot.statics.blotName + " into " + this.statics.blotName);
	        }
	        childBlot.insertInto(this, refBlot);
	    };
	    ContainerBlot.prototype.length = function () {
	        return this.children.reduce(function (memo, child) {
	            return memo + child.length();
	        }, 0);
	    };
	    ContainerBlot.prototype.moveChildren = function (targetParent, refNode) {
	        this.children.forEach(function (child) {
	            targetParent.insertBefore(child, refNode);
	        });
	    };
	    ContainerBlot.prototype.optimize = function (context) {
	        _super.prototype.optimize.call(this, context);
	        if (this.children.length === 0) {
	            if (this.statics.defaultChild != null) {
	                var child = Registry.create(this.statics.defaultChild);
	                this.appendChild(child);
	                child.optimize(context);
	            }
	            else {
	                this.remove();
	            }
	        }
	    };
	    ContainerBlot.prototype.path = function (index, inclusive) {
	        if (inclusive === void 0) { inclusive = false; }
	        var _a = this.children.find(index, inclusive), child = _a[0], offset = _a[1];
	        var position = [[this, index]];
	        if (child instanceof ContainerBlot) {
	            return position.concat(child.path(offset, inclusive));
	        }
	        else if (child != null) {
	            position.push([child, offset]);
	        }
	        return position;
	    };
	    ContainerBlot.prototype.removeChild = function (child) {
	        this.children.remove(child);
	    };
	    ContainerBlot.prototype.replace = function (target) {
	        if (target instanceof ContainerBlot) {
	            target.moveChildren(this);
	        }
	        _super.prototype.replace.call(this, target);
	    };
	    ContainerBlot.prototype.split = function (index, force) {
	        if (force === void 0) { force = false; }
	        if (!force) {
	            if (index === 0)
	                return this;
	            if (index === this.length())
	                return this.next;
	        }
	        var after = this.clone();
	        this.parent.insertBefore(after, this.next);
	        this.children.forEachAt(index, this.length(), function (child, offset, length) {
	            child = child.split(offset, force);
	            after.appendChild(child);
	        });
	        return after;
	    };
	    ContainerBlot.prototype.unwrap = function () {
	        this.moveChildren(this.parent, this.next);
	        this.remove();
	    };
	    ContainerBlot.prototype.update = function (mutations, context) {
	        var _this = this;
	        var addedNodes = [];
	        var removedNodes = [];
	        mutations.forEach(function (mutation) {
	            if (mutation.target === _this.domNode && mutation.type === 'childList') {
	                addedNodes.push.apply(addedNodes, mutation.addedNodes);
	                removedNodes.push.apply(removedNodes, mutation.removedNodes);
	            }
	        });
	        removedNodes.forEach(function (node) {
	            // Check node has actually been removed
	            // One exception is Chrome does not immediately remove IFRAMEs
	            // from DOM but MutationRecord is correct in its reported removal
	            if (node.parentNode != null &&
	                // @ts-ignore
	                node.tagName !== 'IFRAME' &&
	                document.body.compareDocumentPosition(node) & Node.DOCUMENT_POSITION_CONTAINED_BY) {
	                return;
	            }
	            var blot = Registry.find(node);
	            if (blot == null)
	                return;
	            if (blot.domNode.parentNode == null || blot.domNode.parentNode === _this.domNode) {
	                blot.detach();
	            }
	        });
	        addedNodes
	            .filter(function (node) {
	            return node.parentNode == _this.domNode;
	        })
	            .sort(function (a, b) {
	            if (a === b)
	                return 0;
	            if (a.compareDocumentPosition(b) & Node.DOCUMENT_POSITION_FOLLOWING) {
	                return 1;
	            }
	            return -1;
	        })
	            .forEach(function (node) {
	            var refBlot = null;
	            if (node.nextSibling != null) {
	                refBlot = Registry.find(node.nextSibling);
	            }
	            var blot = makeBlot(node);
	            if (blot.next != refBlot || blot.next == null) {
	                if (blot.parent != null) {
	                    blot.parent.removeChild(_this);
	                }
	                _this.insertBefore(blot, refBlot || undefined);
	            }
	        });
	    };
	    return ContainerBlot;
	}(shadow_1.default));
	function makeBlot(node) {
	    var blot = Registry.find(node);
	    if (blot == null) {
	        try {
	            blot = Registry.create(node);
	        }
	        catch (e) {
	            blot = Registry.create(Registry.Scope.INLINE);
	            [].slice.call(node.childNodes).forEach(function (child) {
	                // @ts-ignore
	                blot.domNode.appendChild(child);
	            });
	            if (node.parentNode) {
	                node.parentNode.replaceChild(blot.domNode, node);
	            }
	            blot.attach();
	        }
	    }
	    return blot;
	}
	exports.default = ContainerBlot;
	
	
	/***/ }),
	/* 18 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var attributor_1 = __webpack_require__(12);
	var store_1 = __webpack_require__(31);
	var container_1 = __webpack_require__(17);
	var Registry = __webpack_require__(1);
	var FormatBlot = /** @class */ (function (_super) {
	    __extends(FormatBlot, _super);
	    function FormatBlot(domNode) {
	        var _this = _super.call(this, domNode) || this;
	        _this.attributes = new store_1.default(_this.domNode);
	        return _this;
	    }
	    FormatBlot.formats = function (domNode) {
	        if (typeof this.tagName === 'string') {
	            return true;
	        }
	        else if (Array.isArray(this.tagName)) {
	            return domNode.tagName.toLowerCase();
	        }
	        return undefined;
	    };
	    FormatBlot.prototype.format = function (name, value) {
	        var format = Registry.query(name);
	        if (format instanceof attributor_1.default) {
	            this.attributes.attribute(format, value);
	        }
	        else if (value) {
	            if (format != null && (name !== this.statics.blotName || this.formats()[name] !== value)) {
	                this.replaceWith(name, value);
	            }
	        }
	    };
	    FormatBlot.prototype.formats = function () {
	        var formats = this.attributes.values();
	        var format = this.statics.formats(this.domNode);
	        if (format != null) {
	            formats[this.statics.blotName] = format;
	        }
	        return formats;
	    };
	    FormatBlot.prototype.replaceWith = function (name, value) {
	        var replacement = _super.prototype.replaceWith.call(this, name, value);
	        this.attributes.copy(replacement);
	        return replacement;
	    };
	    FormatBlot.prototype.update = function (mutations, context) {
	        var _this = this;
	        _super.prototype.update.call(this, mutations, context);
	        if (mutations.some(function (mutation) {
	            return mutation.target === _this.domNode && mutation.type === 'attributes';
	        })) {
	            this.attributes.build();
	        }
	    };
	    FormatBlot.prototype.wrap = function (name, value) {
	        var wrapper = _super.prototype.wrap.call(this, name, value);
	        if (wrapper instanceof FormatBlot && wrapper.statics.scope === this.statics.scope) {
	            this.attributes.move(wrapper);
	        }
	        return wrapper;
	    };
	    return FormatBlot;
	}(container_1.default));
	exports.default = FormatBlot;
	
	
	/***/ }),
	/* 19 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var shadow_1 = __webpack_require__(30);
	var Registry = __webpack_require__(1);
	var LeafBlot = /** @class */ (function (_super) {
	    __extends(LeafBlot, _super);
	    function LeafBlot() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    LeafBlot.value = function (domNode) {
	        return true;
	    };
	    LeafBlot.prototype.index = function (node, offset) {
	        if (this.domNode === node ||
	            this.domNode.compareDocumentPosition(node) & Node.DOCUMENT_POSITION_CONTAINED_BY) {
	            return Math.min(offset, 1);
	        }
	        return -1;
	    };
	    LeafBlot.prototype.position = function (index, inclusive) {
	        var offset = [].indexOf.call(this.parent.domNode.childNodes, this.domNode);
	        if (index > 0)
	            offset += 1;
	        return [this.parent.domNode, offset];
	    };
	    LeafBlot.prototype.value = function () {
	        return _a = {}, _a[this.statics.blotName] = this.statics.value(this.domNode) || true, _a;
	        var _a;
	    };
	    LeafBlot.scope = Registry.Scope.INLINE_BLOT;
	    return LeafBlot;
	}(shadow_1.default));
	exports.default = LeafBlot;
	
	
	/***/ }),
	/* 20 */
	/***/ (function(module, exports, __webpack_require__) {
	
	var equal = __webpack_require__(11);
	var extend = __webpack_require__(3);
	
	
	var lib = {
	  attributes: {
	    compose: function (a, b, keepNull) {
	      if (typeof a !== 'object') a = {};
	      if (typeof b !== 'object') b = {};
	      var attributes = extend(true, {}, b);
	      if (!keepNull) {
	        attributes = Object.keys(attributes).reduce(function (copy, key) {
	          if (attributes[key] != null) {
	            copy[key] = attributes[key];
	          }
	          return copy;
	        }, {});
	      }
	      for (var key in a) {
	        if (a[key] !== undefined && b[key] === undefined) {
	          attributes[key] = a[key];
	        }
	      }
	      return Object.keys(attributes).length > 0 ? attributes : undefined;
	    },
	
	    diff: function(a, b) {
	      if (typeof a !== 'object') a = {};
	      if (typeof b !== 'object') b = {};
	      var attributes = Object.keys(a).concat(Object.keys(b)).reduce(function (attributes, key) {
	        if (!equal(a[key], b[key])) {
	          attributes[key] = b[key] === undefined ? null : b[key];
	        }
	        return attributes;
	      }, {});
	      return Object.keys(attributes).length > 0 ? attributes : undefined;
	    },
	
	    transform: function (a, b, priority) {
	      if (typeof a !== 'object') return b;
	      if (typeof b !== 'object') return undefined;
	      if (!priority) return b;  // b simply overwrites us without priority
	      var attributes = Object.keys(b).reduce(function (attributes, key) {
	        if (a[key] === undefined) attributes[key] = b[key];  // null is a valid value
	        return attributes;
	      }, {});
	      return Object.keys(attributes).length > 0 ? attributes : undefined;
	    }
	  },
	
	  iterator: function (ops) {
	    return new Iterator(ops);
	  },
	
	  length: function (op) {
	    if (typeof op['delete'] === 'number') {
	      return op['delete'];
	    } else if (typeof op.retain === 'number') {
	      return op.retain;
	    } else {
	      return typeof op.insert === 'string' ? op.insert.length : 1;
	    }
	  }
	};
	
	
	function Iterator(ops) {
	  this.ops = ops;
	  this.index = 0;
	  this.offset = 0;
	};
	
	Iterator.prototype.hasNext = function () {
	  return this.peekLength() < Infinity;
	};
	
	Iterator.prototype.next = function (length) {
	  if (!length) length = Infinity;
	  var nextOp = this.ops[this.index];
	  if (nextOp) {
	    var offset = this.offset;
	    var opLength = lib.length(nextOp)
	    if (length >= opLength - offset) {
	      length = opLength - offset;
	      this.index += 1;
	      this.offset = 0;
	    } else {
	      this.offset += length;
	    }
	    if (typeof nextOp['delete'] === 'number') {
	      return { 'delete': length };
	    } else {
	      var retOp = {};
	      if (nextOp.attributes) {
	        retOp.attributes = nextOp.attributes;
	      }
	      if (typeof nextOp.retain === 'number') {
	        retOp.retain = length;
	      } else if (typeof nextOp.insert === 'string') {
	        retOp.insert = nextOp.insert.substr(offset, length);
	      } else {
	        // offset should === 0, length should === 1
	        retOp.insert = nextOp.insert;
	      }
	      return retOp;
	    }
	  } else {
	    return { retain: Infinity };
	  }
	};
	
	Iterator.prototype.peek = function () {
	  return this.ops[this.index];
	};
	
	Iterator.prototype.peekLength = function () {
	  if (this.ops[this.index]) {
	    // Should never return 0 if our index is being managed correctly
	    return lib.length(this.ops[this.index]) - this.offset;
	  } else {
	    return Infinity;
	  }
	};
	
	Iterator.prototype.peekType = function () {
	  if (this.ops[this.index]) {
	    if (typeof this.ops[this.index]['delete'] === 'number') {
	      return 'delete';
	    } else if (typeof this.ops[this.index].retain === 'number') {
	      return 'retain';
	    } else {
	      return 'insert';
	    }
	  }
	  return 'retain';
	};
	
	
	module.exports = lib;
	
	
	/***/ }),
	/* 21 */
	/***/ (function(module, exports) {
	
	var clone = (function() {
	'use strict';
	
	function _instanceof(obj, type) {
	  return type != null && obj instanceof type;
	}
	
	var nativeMap;
	try {
	  nativeMap = Map;
	} catch(_) {
	  // maybe a reference error because no `Map`. Give it a dummy value that no
	  // value will ever be an instanceof.
	  nativeMap = function() {};
	}
	
	var nativeSet;
	try {
	  nativeSet = Set;
	} catch(_) {
	  nativeSet = function() {};
	}
	
	var nativePromise;
	try {
	  nativePromise = Promise;
	} catch(_) {
	  nativePromise = function() {};
	}
	
	/**
	 * Clones (copies) an Object using deep copying.
	 *
	 * This function supports circular references by default, but if you are certain
	 * there are no circular references in your object, you can save some CPU time
	 * by calling clone(obj, false).
	 *
	 * Caution: if `circular` is false and `parent` contains circular references,
	 * your program may enter an infinite loop and crash.
	 *
	 * @param `parent` - the object to be cloned
	 * @param `circular` - set to true if the object to be cloned may contain
	 *    circular references. (optional - true by default)
	 * @param `depth` - set to a number if the object is only to be cloned to
	 *    a particular depth. (optional - defaults to Infinity)
	 * @param `prototype` - sets the prototype to be used when cloning an object.
	 *    (optional - defaults to parent prototype).
	 * @param `includeNonEnumerable` - set to true if the non-enumerable properties
	 *    should be cloned as well. Non-enumerable properties on the prototype
	 *    chain will be ignored. (optional - false by default)
	*/
	function clone(parent, circular, depth, prototype, includeNonEnumerable) {
	  if (typeof circular === 'object') {
	    depth = circular.depth;
	    prototype = circular.prototype;
	    includeNonEnumerable = circular.includeNonEnumerable;
	    circular = circular.circular;
	  }
	  // maintain two arrays for circular references, where corresponding parents
	  // and children have the same index
	  var allParents = [];
	  var allChildren = [];
	
	  var useBuffer = typeof Buffer != 'undefined';
	
	  if (typeof circular == 'undefined')
	    circular = true;
	
	  if (typeof depth == 'undefined')
	    depth = Infinity;
	
	  // recurse this function so we don't reset allParents and allChildren
	  function _clone(parent, depth) {
	    // cloning null always returns null
	    if (parent === null)
	      return null;
	
	    if (depth === 0)
	      return parent;
	
	    var child;
	    var proto;
	    if (typeof parent != 'object') {
	      return parent;
	    }
	
	    if (_instanceof(parent, nativeMap)) {
	      child = new nativeMap();
	    } else if (_instanceof(parent, nativeSet)) {
	      child = new nativeSet();
	    } else if (_instanceof(parent, nativePromise)) {
	      child = new nativePromise(function (resolve, reject) {
	        parent.then(function(value) {
	          resolve(_clone(value, depth - 1));
	        }, function(err) {
	          reject(_clone(err, depth - 1));
	        });
	      });
	    } else if (clone.__isArray(parent)) {
	      child = [];
	    } else if (clone.__isRegExp(parent)) {
	      child = new RegExp(parent.source, __getRegExpFlags(parent));
	      if (parent.lastIndex) child.lastIndex = parent.lastIndex;
	    } else if (clone.__isDate(parent)) {
	      child = new Date(parent.getTime());
	    } else if (useBuffer && Buffer.isBuffer(parent)) {
	      child = new Buffer(parent.length);
	      parent.copy(child);
	      return child;
	    } else if (_instanceof(parent, Error)) {
	      child = Object.create(parent);
	    } else {
	      if (typeof prototype == 'undefined') {
	        proto = Object.getPrototypeOf(parent);
	        child = Object.create(proto);
	      }
	      else {
	        child = Object.create(prototype);
	        proto = prototype;
	      }
	    }
	
	    if (circular) {
	      var index = allParents.indexOf(parent);
	
	      if (index != -1) {
	        return allChildren[index];
	      }
	      allParents.push(parent);
	      allChildren.push(child);
	    }
	
	    if (_instanceof(parent, nativeMap)) {
	      parent.forEach(function(value, key) {
	        var keyChild = _clone(key, depth - 1);
	        var valueChild = _clone(value, depth - 1);
	        child.set(keyChild, valueChild);
	      });
	    }
	    if (_instanceof(parent, nativeSet)) {
	      parent.forEach(function(value) {
	        var entryChild = _clone(value, depth - 1);
	        child.add(entryChild);
	      });
	    }
	
	    for (var i in parent) {
	      var attrs;
	      if (proto) {
	        attrs = Object.getOwnPropertyDescriptor(proto, i);
	      }
	
	      if (attrs && attrs.set == null) {
	        continue;
	      }
	      child[i] = _clone(parent[i], depth - 1);
	    }
	
	    if (Object.getOwnPropertySymbols) {
	      var symbols = Object.getOwnPropertySymbols(parent);
	      for (var i = 0; i < symbols.length; i++) {
	        // Don't need to worry about cloning a symbol because it is a primitive,
	        // like a number or string.
	        var symbol = symbols[i];
	        var descriptor = Object.getOwnPropertyDescriptor(parent, symbol);
	        if (descriptor && !descriptor.enumerable && !includeNonEnumerable) {
	          continue;
	        }
	        child[symbol] = _clone(parent[symbol], depth - 1);
	        if (!descriptor.enumerable) {
	          Object.defineProperty(child, symbol, {
	            enumerable: false
	          });
	        }
	      }
	    }
	
	    if (includeNonEnumerable) {
	      var allPropertyNames = Object.getOwnPropertyNames(parent);
	      for (var i = 0; i < allPropertyNames.length; i++) {
	        var propertyName = allPropertyNames[i];
	        var descriptor = Object.getOwnPropertyDescriptor(parent, propertyName);
	        if (descriptor && descriptor.enumerable) {
	          continue;
	        }
	        child[propertyName] = _clone(parent[propertyName], depth - 1);
	        Object.defineProperty(child, propertyName, {
	          enumerable: false
	        });
	      }
	    }
	
	    return child;
	  }
	
	  return _clone(parent, depth);
	}
	
	/**
	 * Simple flat clone using prototype, accepts only objects, usefull for property
	 * override on FLAT configuration object (no nested props).
	 *
	 * USE WITH CAUTION! This may not behave as you wish if you do not know how this
	 * works.
	 */
	clone.clonePrototype = function clonePrototype(parent) {
	  if (parent === null)
	    return null;
	
	  var c = function () {};
	  c.prototype = parent;
	  return new c();
	};
	
	// private utility functions
	
	function __objToStr(o) {
	  return Object.prototype.toString.call(o);
	}
	clone.__objToStr = __objToStr;
	
	function __isDate(o) {
	  return typeof o === 'object' && __objToStr(o) === '[object Date]';
	}
	clone.__isDate = __isDate;
	
	function __isArray(o) {
	  return typeof o === 'object' && __objToStr(o) === '[object Array]';
	}
	clone.__isArray = __isArray;
	
	function __isRegExp(o) {
	  return typeof o === 'object' && __objToStr(o) === '[object RegExp]';
	}
	clone.__isRegExp = __isRegExp;
	
	function __getRegExpFlags(re) {
	  var flags = '';
	  if (re.global) flags += 'g';
	  if (re.ignoreCase) flags += 'i';
	  if (re.multiline) flags += 'm';
	  return flags;
	}
	clone.__getRegExpFlags = __getRegExpFlags;
	
	return clone;
	})();
	
	if (typeof module === 'object' && module.exports) {
	  module.exports = clone;
	}
	
	
	/***/ }),
	/* 22 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };
	
	var _parchment = __webpack_require__(0);
	
	var _parchment2 = _interopRequireDefault(_parchment);
	
	var _emitter = __webpack_require__(8);
	
	var _emitter2 = _interopRequireDefault(_emitter);
	
	var _block = __webpack_require__(4);
	
	var _block2 = _interopRequireDefault(_block);
	
	var _break = __webpack_require__(16);
	
	var _break2 = _interopRequireDefault(_break);
	
	var _code = __webpack_require__(13);
	
	var _code2 = _interopRequireDefault(_code);
	
	var _container = __webpack_require__(25);
	
	var _container2 = _interopRequireDefault(_container);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function isLine(blot) {
	  return blot instanceof _block2.default || blot instanceof _block.BlockEmbed;
	}
	
	var Scroll = function (_Parchment$Scroll) {
	  _inherits(Scroll, _Parchment$Scroll);
	
	  function Scroll(domNode, config) {
	    _classCallCheck(this, Scroll);
	
	    var _this = _possibleConstructorReturn(this, (Scroll.__proto__ || Object.getPrototypeOf(Scroll)).call(this, domNode));
	
	    _this.emitter = config.emitter;
	    if (Array.isArray(config.whitelist)) {
	      _this.whitelist = config.whitelist.reduce(function (whitelist, format) {
	        whitelist[format] = true;
	        return whitelist;
	      }, {});
	    }
	    // Some reason fixes composition issues with character languages in Windows/Chrome, Safari
	    _this.domNode.addEventListener('DOMNodeInserted', function () {});
	    _this.optimize();
	    _this.enable();
	    return _this;
	  }
	
	  _createClass(Scroll, [{
	    key: 'batchStart',
	    value: function batchStart() {
	      this.batch = true;
	    }
	  }, {
	    key: 'batchEnd',
	    value: function batchEnd() {
	      this.batch = false;
	      this.optimize();
	    }
	  }, {
	    key: 'deleteAt',
	    value: function deleteAt(index, length) {
	      var _line = this.line(index),
	          _line2 = _slicedToArray(_line, 2),
	          first = _line2[0],
	          offset = _line2[1];
	
	      var _line3 = this.line(index + length),
	          _line4 = _slicedToArray(_line3, 1),
	          last = _line4[0];
	
	      _get(Scroll.prototype.__proto__ || Object.getPrototypeOf(Scroll.prototype), 'deleteAt', this).call(this, index, length);
	      if (last != null && first !== last && offset > 0) {
	        if (first instanceof _block.BlockEmbed || last instanceof _block.BlockEmbed) {
	          this.optimize();
	          return;
	        }
	        if (first instanceof _code2.default) {
	          var newlineIndex = first.newlineIndex(first.length(), true);
	          if (newlineIndex > -1) {
	            first = first.split(newlineIndex + 1);
	            if (first === last) {
	              this.optimize();
	              return;
	            }
	          }
	        } else if (last instanceof _code2.default) {
	          var _newlineIndex = last.newlineIndex(0);
	          if (_newlineIndex > -1) {
	            last.split(_newlineIndex + 1);
	          }
	        }
	        var ref = last.children.head instanceof _break2.default ? null : last.children.head;
	        first.moveChildren(last, ref);
	        first.remove();
	      }
	      this.optimize();
	    }
	  }, {
	    key: 'enable',
	    value: function enable() {
	      var enabled = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
	
	      this.domNode.setAttribute('contenteditable', enabled);
	    }
	  }, {
	    key: 'formatAt',
	    value: function formatAt(index, length, format, value) {
	      if (this.whitelist != null && !this.whitelist[format]) return;
	      _get(Scroll.prototype.__proto__ || Object.getPrototypeOf(Scroll.prototype), 'formatAt', this).call(this, index, length, format, value);
	      this.optimize();
	    }
	  }, {
	    key: 'insertAt',
	    value: function insertAt(index, value, def) {
	      if (def != null && this.whitelist != null && !this.whitelist[value]) return;
	      if (index >= this.length()) {
	        if (def == null || _parchment2.default.query(value, _parchment2.default.Scope.BLOCK) == null) {
	          var blot = _parchment2.default.create(this.statics.defaultChild);
	          this.appendChild(blot);
	          if (def == null && value.endsWith('\n')) {
	            value = value.slice(0, -1);
	          }
	          blot.insertAt(0, value, def);
	        } else {
	          var embed = _parchment2.default.create(value, def);
	          this.appendChild(embed);
	        }
	      } else {
	        _get(Scroll.prototype.__proto__ || Object.getPrototypeOf(Scroll.prototype), 'insertAt', this).call(this, index, value, def);
	      }
	      this.optimize();
	    }
	  }, {
	    key: 'insertBefore',
	    value: function insertBefore(blot, ref) {
	      if (blot.statics.scope === _parchment2.default.Scope.INLINE_BLOT) {
	        var wrapper = _parchment2.default.create(this.statics.defaultChild);
	        wrapper.appendChild(blot);
	        blot = wrapper;
	      }
	      _get(Scroll.prototype.__proto__ || Object.getPrototypeOf(Scroll.prototype), 'insertBefore', this).call(this, blot, ref);
	    }
	  }, {
	    key: 'leaf',
	    value: function leaf(index) {
	      return this.path(index).pop() || [null, -1];
	    }
	  }, {
	    key: 'line',
	    value: function line(index) {
	      if (index === this.length()) {
	        return this.line(index - 1);
	      }
	      return this.descendant(isLine, index);
	    }
	  }, {
	    key: 'lines',
	    value: function lines() {
	      var index = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
	      var length = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : Number.MAX_VALUE;
	
	      var getLines = function getLines(blot, index, length) {
	        var lines = [],
	            lengthLeft = length;
	        blot.children.forEachAt(index, length, function (child, index, length) {
	          if (isLine(child)) {
	            lines.push(child);
	          } else if (child instanceof _parchment2.default.Container) {
	            lines = lines.concat(getLines(child, index, lengthLeft));
	          }
	          lengthLeft -= length;
	        });
	        return lines;
	      };
	      return getLines(this, index, length);
	    }
	  }, {
	    key: 'optimize',
	    value: function optimize() {
	      var mutations = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	      var context = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	      if (this.batch === true) return;
	      _get(Scroll.prototype.__proto__ || Object.getPrototypeOf(Scroll.prototype), 'optimize', this).call(this, mutations, context);
	      if (mutations.length > 0) {
	        this.emitter.emit(_emitter2.default.events.SCROLL_OPTIMIZE, mutations, context);
	      }
	    }
	  }, {
	    key: 'path',
	    value: function path(index) {
	      return _get(Scroll.prototype.__proto__ || Object.getPrototypeOf(Scroll.prototype), 'path', this).call(this, index).slice(1); // Exclude self
	    }
	  }, {
	    key: 'update',
	    value: function update(mutations) {
	      if (this.batch === true) return;
	      var source = _emitter2.default.sources.USER;
	      if (typeof mutations === 'string') {
	        source = mutations;
	      }
	      if (!Array.isArray(mutations)) {
	        mutations = this.observer.takeRecords();
	      }
	      if (mutations.length > 0) {
	        this.emitter.emit(_emitter2.default.events.SCROLL_BEFORE_UPDATE, source, mutations);
	      }
	      _get(Scroll.prototype.__proto__ || Object.getPrototypeOf(Scroll.prototype), 'update', this).call(this, mutations.concat([])); // pass copy
	      if (mutations.length > 0) {
	        this.emitter.emit(_emitter2.default.events.SCROLL_UPDATE, source, mutations);
	      }
	    }
	  }]);
	
	  return Scroll;
	}(_parchment2.default.Scroll);
	
	Scroll.blotName = 'scroll';
	Scroll.className = 'ql-editor';
	Scroll.tagName = 'DIV';
	Scroll.defaultChild = 'block';
	Scroll.allowedChildren = [_block2.default, _block.BlockEmbed, _container2.default];
	
	exports.default = Scroll;
	
	/***/ }),
	/* 23 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.SHORTKEY = exports.default = undefined;
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _clone = __webpack_require__(21);
	
	var _clone2 = _interopRequireDefault(_clone);
	
	var _deepEqual = __webpack_require__(11);
	
	var _deepEqual2 = _interopRequireDefault(_deepEqual);
	
	var _extend = __webpack_require__(3);
	
	var _extend2 = _interopRequireDefault(_extend);
	
	var _quillDelta = __webpack_require__(2);
	
	var _quillDelta2 = _interopRequireDefault(_quillDelta);
	
	var _op = __webpack_require__(20);
	
	var _op2 = _interopRequireDefault(_op);
	
	var _parchment = __webpack_require__(0);
	
	var _parchment2 = _interopRequireDefault(_parchment);
	
	var _quill = __webpack_require__(5);
	
	var _quill2 = _interopRequireDefault(_quill);
	
	var _logger = __webpack_require__(10);
	
	var _logger2 = _interopRequireDefault(_logger);
	
	var _module = __webpack_require__(9);
	
	var _module2 = _interopRequireDefault(_module);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var debug = (0, _logger2.default)('quill:keyboard');
	
	var SHORTKEY = /Mac/i.test(navigator.platform) ? 'metaKey' : 'ctrlKey';
	
	var Keyboard = function (_Module) {
	  _inherits(Keyboard, _Module);
	
	  _createClass(Keyboard, null, [{
	    key: 'match',
	    value: function match(evt, binding) {
	      binding = normalize(binding);
	      if (['altKey', 'ctrlKey', 'metaKey', 'shiftKey'].some(function (key) {
	        return !!binding[key] !== evt[key] && binding[key] !== null;
	      })) {
	        return false;
	      }
	      return binding.key === (evt.which || evt.keyCode);
	    }
	  }]);
	
	  function Keyboard(quill, options) {
	    _classCallCheck(this, Keyboard);
	
	    var _this = _possibleConstructorReturn(this, (Keyboard.__proto__ || Object.getPrototypeOf(Keyboard)).call(this, quill, options));
	
	    _this.bindings = {};
	    Object.keys(_this.options.bindings).forEach(function (name) {
	      if (name === 'list autofill' && quill.scroll.whitelist != null && !quill.scroll.whitelist['list']) {
	        return;
	      }
	      if (_this.options.bindings[name]) {
	        _this.addBinding(_this.options.bindings[name]);
	      }
	    });
	    _this.addBinding({ key: Keyboard.keys.ENTER, shiftKey: null }, handleEnter);
	    _this.addBinding({ key: Keyboard.keys.ENTER, metaKey: null, ctrlKey: null, altKey: null }, function () {});
	    if (/Firefox/i.test(navigator.userAgent)) {
	      // Need to handle delete and backspace for Firefox in the general case #1171
	      _this.addBinding({ key: Keyboard.keys.BACKSPACE }, { collapsed: true }, handleBackspace);
	      _this.addBinding({ key: Keyboard.keys.DELETE }, { collapsed: true }, handleDelete);
	    } else {
	      _this.addBinding({ key: Keyboard.keys.BACKSPACE }, { collapsed: true, prefix: /^.?$/ }, handleBackspace);
	      _this.addBinding({ key: Keyboard.keys.DELETE }, { collapsed: true, suffix: /^.?$/ }, handleDelete);
	    }
	    _this.addBinding({ key: Keyboard.keys.BACKSPACE }, { collapsed: false }, handleDeleteRange);
	    _this.addBinding({ key: Keyboard.keys.DELETE }, { collapsed: false }, handleDeleteRange);
	    _this.addBinding({ key: Keyboard.keys.BACKSPACE, altKey: null, ctrlKey: null, metaKey: null, shiftKey: null }, { collapsed: true, offset: 0 }, handleBackspace);
	    _this.listen();
	    return _this;
	  }
	
	  _createClass(Keyboard, [{
	    key: 'addBinding',
	    value: function addBinding(key) {
	      var context = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	      var handler = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	
	      var binding = normalize(key);
	      if (binding == null || binding.key == null) {
	        return debug.warn('Attempted to add invalid keyboard binding', binding);
	      }
	      if (typeof context === 'function') {
	        context = { handler: context };
	      }
	      if (typeof handler === 'function') {
	        handler = { handler: handler };
	      }
	      binding = (0, _extend2.default)(binding, context, handler);
	      this.bindings[binding.key] = this.bindings[binding.key] || [];
	      this.bindings[binding.key].push(binding);
	    }
	  }, {
	    key: 'listen',
	    value: function listen() {
	      var _this2 = this;
	
	      this.quill.root.addEventListener('keydown', function (evt) {
	        if (evt.defaultPrevented) return;
	        var which = evt.which || evt.keyCode;
	        var bindings = (_this2.bindings[which] || []).filter(function (binding) {
	          return Keyboard.match(evt, binding);
	        });
	        if (bindings.length === 0) return;
	        var range = _this2.quill.getSelection();
	        if (range == null || !_this2.quill.hasFocus()) return;
	
	        var _quill$getLine = _this2.quill.getLine(range.index),
	            _quill$getLine2 = _slicedToArray(_quill$getLine, 2),
	            line = _quill$getLine2[0],
	            offset = _quill$getLine2[1];
	
	        var _quill$getLeaf = _this2.quill.getLeaf(range.index),
	            _quill$getLeaf2 = _slicedToArray(_quill$getLeaf, 2),
	            leafStart = _quill$getLeaf2[0],
	            offsetStart = _quill$getLeaf2[1];
	
	        var _ref = range.length === 0 ? [leafStart, offsetStart] : _this2.quill.getLeaf(range.index + range.length),
	            _ref2 = _slicedToArray(_ref, 2),
	            leafEnd = _ref2[0],
	            offsetEnd = _ref2[1];
	
	        var prefixText = leafStart instanceof _parchment2.default.Text ? leafStart.value().slice(0, offsetStart) : '';
	        var suffixText = leafEnd instanceof _parchment2.default.Text ? leafEnd.value().slice(offsetEnd) : '';
	        var curContext = {
	          collapsed: range.length === 0,
	          empty: range.length === 0 && line.length() <= 1,
	          format: _this2.quill.getFormat(range),
	          offset: offset,
	          prefix: prefixText,
	          suffix: suffixText
	        };
	        var prevented = bindings.some(function (binding) {
	          if (binding.collapsed != null && binding.collapsed !== curContext.collapsed) return false;
	          if (binding.empty != null && binding.empty !== curContext.empty) return false;
	          if (binding.offset != null && binding.offset !== curContext.offset) return false;
	          if (Array.isArray(binding.format)) {
	            // any format is present
	            if (binding.format.every(function (name) {
	              return curContext.format[name] == null;
	            })) {
	              return false;
	            }
	          } else if (_typeof(binding.format) === 'object') {
	            // all formats must match
	            if (!Object.keys(binding.format).every(function (name) {
	              if (binding.format[name] === true) return curContext.format[name] != null;
	              if (binding.format[name] === false) return curContext.format[name] == null;
	              return (0, _deepEqual2.default)(binding.format[name], curContext.format[name]);
	            })) {
	              return false;
	            }
	          }
	          if (binding.prefix != null && !binding.prefix.test(curContext.prefix)) return false;
	          if (binding.suffix != null && !binding.suffix.test(curContext.suffix)) return false;
	          return binding.handler.call(_this2, range, curContext) !== true;
	        });
	        if (prevented) {
	          evt.preventDefault();
	        }
	      });
	    }
	  }]);
	
	  return Keyboard;
	}(_module2.default);
	
	Keyboard.keys = {
	  BACKSPACE: 8,
	  TAB: 9,
	  ENTER: 13,
	  ESCAPE: 27,
	  LEFT: 37,
	  UP: 38,
	  RIGHT: 39,
	  DOWN: 40,
	  DELETE: 46
	};
	
	Keyboard.DEFAULTS = {
	  bindings: {
	    'bold': makeFormatHandler('bold'),
	    'italic': makeFormatHandler('italic'),
	    'underline': makeFormatHandler('underline'),
	    'indent': {
	      // highlight tab or tab at beginning of list, indent or blockquote
	      key: Keyboard.keys.TAB,
	      format: ['blockquote', 'indent', 'list'],
	      handler: function handler(range, context) {
	        if (context.collapsed && context.offset !== 0) return true;
	        this.quill.format('indent', '+1', _quill2.default.sources.USER);
	      }
	    },
	    'outdent': {
	      key: Keyboard.keys.TAB,
	      shiftKey: true,
	      format: ['blockquote', 'indent', 'list'],
	      // highlight tab or tab at beginning of list, indent or blockquote
	      handler: function handler(range, context) {
	        if (context.collapsed && context.offset !== 0) return true;
	        this.quill.format('indent', '-1', _quill2.default.sources.USER);
	      }
	    },
	    'outdent backspace': {
	      key: Keyboard.keys.BACKSPACE,
	      collapsed: true,
	      shiftKey: null,
	      metaKey: null,
	      ctrlKey: null,
	      altKey: null,
	      format: ['indent', 'list'],
	      offset: 0,
	      handler: function handler(range, context) {
	        if (context.format.indent != null) {
	          this.quill.format('indent', '-1', _quill2.default.sources.USER);
	        } else if (context.format.list != null) {
	          this.quill.format('list', false, _quill2.default.sources.USER);
	        }
	      }
	    },
	    'indent code-block': makeCodeBlockHandler(true),
	    'outdent code-block': makeCodeBlockHandler(false),
	    'remove tab': {
	      key: Keyboard.keys.TAB,
	      shiftKey: true,
	      collapsed: true,
	      prefix: /\t$/,
	      handler: function handler(range) {
	        this.quill.deleteText(range.index - 1, 1, _quill2.default.sources.USER);
	      }
	    },
	    'tab': {
	      key: Keyboard.keys.TAB,
	      handler: function handler(range) {
	        this.quill.history.cutoff();
	        var delta = new _quillDelta2.default().retain(range.index).delete(range.length).insert('\t');
	        this.quill.updateContents(delta, _quill2.default.sources.USER);
	        this.quill.history.cutoff();
	        this.quill.setSelection(range.index + 1, _quill2.default.sources.SILENT);
	      }
	    },
	    'list empty enter': {
	      key: Keyboard.keys.ENTER,
	      collapsed: true,
	      format: ['list'],
	      empty: true,
	      handler: function handler(range, context) {
	        this.quill.format('list', false, _quill2.default.sources.USER);
	        if (context.format.indent) {
	          this.quill.format('indent', false, _quill2.default.sources.USER);
	        }
	      }
	    },
	    'checklist enter': {
	      key: Keyboard.keys.ENTER,
	      collapsed: true,
	      format: { list: 'checked' },
	      handler: function handler(range) {
	        var _quill$getLine3 = this.quill.getLine(range.index),
	            _quill$getLine4 = _slicedToArray(_quill$getLine3, 2),
	            line = _quill$getLine4[0],
	            offset = _quill$getLine4[1];
	
	        var formats = (0, _extend2.default)({}, line.formats(), { list: 'checked' });
	        var delta = new _quillDelta2.default().retain(range.index).insert('\n', formats).retain(line.length() - offset - 1).retain(1, { list: 'unchecked' });
	        this.quill.updateContents(delta, _quill2.default.sources.USER);
	        this.quill.setSelection(range.index + 1, _quill2.default.sources.SILENT);
	        this.quill.scrollIntoView();
	      }
	    },
	    'header enter': {
	      key: Keyboard.keys.ENTER,
	      collapsed: true,
	      format: ['header'],
	      suffix: /^$/,
	      handler: function handler(range, context) {
	        var _quill$getLine5 = this.quill.getLine(range.index),
	            _quill$getLine6 = _slicedToArray(_quill$getLine5, 2),
	            line = _quill$getLine6[0],
	            offset = _quill$getLine6[1];
	
	        var delta = new _quillDelta2.default().retain(range.index).insert('\n', context.format).retain(line.length() - offset - 1).retain(1, { header: null });
	        this.quill.updateContents(delta, _quill2.default.sources.USER);
	        this.quill.setSelection(range.index + 1, _quill2.default.sources.SILENT);
	        this.quill.scrollIntoView();
	      }
	    },
	    'list autofill': {
	      key: ' ',
	      collapsed: true,
	      format: { list: false },
	      prefix: /^\s*?(\d+\.|-|\*|\[ ?\]|\[x\])$/,
	      handler: function handler(range, context) {
	        var length = context.prefix.length;
	
	        var _quill$getLine7 = this.quill.getLine(range.index),
	            _quill$getLine8 = _slicedToArray(_quill$getLine7, 2),
	            line = _quill$getLine8[0],
	            offset = _quill$getLine8[1];
	
	        if (offset > length) return true;
	        var value = void 0;
	        switch (context.prefix.trim()) {
	          case '[]':case '[ ]':
	            value = 'unchecked';
	            break;
	          case '[x]':
	            value = 'checked';
	            break;
	          case '-':case '*':
	            value = 'bullet';
	            break;
	          default:
	            value = 'ordered';
	        }
	        this.quill.insertText(range.index, ' ', _quill2.default.sources.USER);
	        this.quill.history.cutoff();
	        var delta = new _quillDelta2.default().retain(range.index - offset).delete(length + 1).retain(line.length() - 2 - offset).retain(1, { list: value });
	        this.quill.updateContents(delta, _quill2.default.sources.USER);
	        this.quill.history.cutoff();
	        this.quill.setSelection(range.index - length, _quill2.default.sources.SILENT);
	      }
	    },
	    'code exit': {
	      key: Keyboard.keys.ENTER,
	      collapsed: true,
	      format: ['code-block'],
	      prefix: /\n\n$/,
	      suffix: /^\s+$/,
	      handler: function handler(range) {
	        var _quill$getLine9 = this.quill.getLine(range.index),
	            _quill$getLine10 = _slicedToArray(_quill$getLine9, 2),
	            line = _quill$getLine10[0],
	            offset = _quill$getLine10[1];
	
	        var delta = new _quillDelta2.default().retain(range.index + line.length() - offset - 2).retain(1, { 'code-block': null }).delete(1);
	        this.quill.updateContents(delta, _quill2.default.sources.USER);
	      }
	    },
	    'embed left': makeEmbedArrowHandler(Keyboard.keys.LEFT, false),
	    'embed left shift': makeEmbedArrowHandler(Keyboard.keys.LEFT, true),
	    'embed right': makeEmbedArrowHandler(Keyboard.keys.RIGHT, false),
	    'embed right shift': makeEmbedArrowHandler(Keyboard.keys.RIGHT, true)
	  }
	};
	
	function makeEmbedArrowHandler(key, shiftKey) {
	  var _ref3;
	
	  var where = key === Keyboard.keys.LEFT ? 'prefix' : 'suffix';
	  return _ref3 = {
	    key: key,
	    shiftKey: shiftKey,
	    altKey: null
	  }, _defineProperty(_ref3, where, /^$/), _defineProperty(_ref3, 'handler', function handler(range) {
	    var index = range.index;
	    if (key === Keyboard.keys.RIGHT) {
	      index += range.length + 1;
	    }
	
	    var _quill$getLeaf3 = this.quill.getLeaf(index),
	        _quill$getLeaf4 = _slicedToArray(_quill$getLeaf3, 1),
	        leaf = _quill$getLeaf4[0];
	
	    if (!(leaf instanceof _parchment2.default.Embed)) return true;
	    if (key === Keyboard.keys.LEFT) {
	      if (shiftKey) {
	        this.quill.setSelection(range.index - 1, range.length + 1, _quill2.default.sources.USER);
	      } else {
	        this.quill.setSelection(range.index - 1, _quill2.default.sources.USER);
	      }
	    } else {
	      if (shiftKey) {
	        this.quill.setSelection(range.index, range.length + 1, _quill2.default.sources.USER);
	      } else {
	        this.quill.setSelection(range.index + range.length + 1, _quill2.default.sources.USER);
	      }
	    }
	    return false;
	  }), _ref3;
	}
	
	function handleBackspace(range, context) {
	  if (range.index === 0 || this.quill.getLength() <= 1) return;
	
	  var _quill$getLine11 = this.quill.getLine(range.index),
	      _quill$getLine12 = _slicedToArray(_quill$getLine11, 1),
	      line = _quill$getLine12[0];
	
	  var formats = {};
	  if (context.offset === 0) {
	    var _quill$getLine13 = this.quill.getLine(range.index - 1),
	        _quill$getLine14 = _slicedToArray(_quill$getLine13, 1),
	        prev = _quill$getLine14[0];
	
	    if (prev != null && prev.length() > 1) {
	      var curFormats = line.formats();
	      var prevFormats = this.quill.getFormat(range.index - 1, 1);
	      formats = _op2.default.attributes.diff(curFormats, prevFormats) || {};
	    }
	  }
	  // Check for astral symbols
	  var length = /[\uD800-\uDBFF][\uDC00-\uDFFF]$/.test(context.prefix) ? 2 : 1;
	  this.quill.deleteText(range.index - length, length, _quill2.default.sources.USER);
	  if (Object.keys(formats).length > 0) {
	    this.quill.formatLine(range.index - length, length, formats, _quill2.default.sources.USER);
	  }
	  this.quill.focus();
	}
	
	function handleDelete(range, context) {
	  // Check for astral symbols
	  var length = /^[\uD800-\uDBFF][\uDC00-\uDFFF]/.test(context.suffix) ? 2 : 1;
	  if (range.index >= this.quill.getLength() - length) return;
	  var formats = {},
	      nextLength = 0;
	
	  var _quill$getLine15 = this.quill.getLine(range.index),
	      _quill$getLine16 = _slicedToArray(_quill$getLine15, 1),
	      line = _quill$getLine16[0];
	
	  if (context.offset >= line.length() - 1) {
	    var _quill$getLine17 = this.quill.getLine(range.index + 1),
	        _quill$getLine18 = _slicedToArray(_quill$getLine17, 1),
	        next = _quill$getLine18[0];
	
	    if (next) {
	      var curFormats = line.formats();
	      var nextFormats = this.quill.getFormat(range.index, 1);
	      formats = _op2.default.attributes.diff(curFormats, nextFormats) || {};
	      nextLength = next.length();
	    }
	  }
	  this.quill.deleteText(range.index, length, _quill2.default.sources.USER);
	  if (Object.keys(formats).length > 0) {
	    this.quill.formatLine(range.index + nextLength - 1, length, formats, _quill2.default.sources.USER);
	  }
	}
	
	function handleDeleteRange(range) {
	  var lines = this.quill.getLines(range);
	  var formats = {};
	  if (lines.length > 1) {
	    var firstFormats = lines[0].formats();
	    var lastFormats = lines[lines.length - 1].formats();
	    formats = _op2.default.attributes.diff(lastFormats, firstFormats) || {};
	  }
	  this.quill.deleteText(range, _quill2.default.sources.USER);
	  if (Object.keys(formats).length > 0) {
	    this.quill.formatLine(range.index, 1, formats, _quill2.default.sources.USER);
	  }
	  this.quill.setSelection(range.index, _quill2.default.sources.SILENT);
	  this.quill.focus();
	}
	
	function handleEnter(range, context) {
	  var _this3 = this;
	
	  if (range.length > 0) {
	    this.quill.scroll.deleteAt(range.index, range.length); // So we do not trigger text-change
	  }
	  var lineFormats = Object.keys(context.format).reduce(function (lineFormats, format) {
	    if (_parchment2.default.query(format, _parchment2.default.Scope.BLOCK) && !Array.isArray(context.format[format])) {
	      lineFormats[format] = context.format[format];
	    }
	    return lineFormats;
	  }, {});
	  this.quill.insertText(range.index, '\n', lineFormats, _quill2.default.sources.USER);
	  // Earlier scroll.deleteAt might have messed up our selection,
	  // so insertText's built in selection preservation is not reliable
	  this.quill.setSelection(range.index + 1, _quill2.default.sources.SILENT);
	  this.quill.focus();
	  Object.keys(context.format).forEach(function (name) {
	    if (lineFormats[name] != null) return;
	    if (Array.isArray(context.format[name])) return;
	    if (name === 'link') return;
	    _this3.quill.format(name, context.format[name], _quill2.default.sources.USER);
	  });
	}
	
	function makeCodeBlockHandler(indent) {
	  return {
	    key: Keyboard.keys.TAB,
	    shiftKey: !indent,
	    format: { 'code-block': true },
	    handler: function handler(range) {
	      var CodeBlock = _parchment2.default.query('code-block');
	      var index = range.index,
	          length = range.length;
	
	      var _quill$scroll$descend = this.quill.scroll.descendant(CodeBlock, index),
	          _quill$scroll$descend2 = _slicedToArray(_quill$scroll$descend, 2),
	          block = _quill$scroll$descend2[0],
	          offset = _quill$scroll$descend2[1];
	
	      if (block == null) return;
	      var scrollIndex = this.quill.getIndex(block);
	      var start = block.newlineIndex(offset, true) + 1;
	      var end = block.newlineIndex(scrollIndex + offset + length);
	      var lines = block.domNode.textContent.slice(start, end).split('\n');
	      offset = 0;
	      lines.forEach(function (line, i) {
	        if (indent) {
	          block.insertAt(start + offset, CodeBlock.TAB);
	          offset += CodeBlock.TAB.length;
	          if (i === 0) {
	            index += CodeBlock.TAB.length;
	          } else {
	            length += CodeBlock.TAB.length;
	          }
	        } else if (line.startsWith(CodeBlock.TAB)) {
	          block.deleteAt(start + offset, CodeBlock.TAB.length);
	          offset -= CodeBlock.TAB.length;
	          if (i === 0) {
	            index -= CodeBlock.TAB.length;
	          } else {
	            length -= CodeBlock.TAB.length;
	          }
	        }
	        offset += line.length + 1;
	      });
	      this.quill.update(_quill2.default.sources.USER);
	      this.quill.setSelection(index, length, _quill2.default.sources.SILENT);
	    }
	  };
	}
	
	function makeFormatHandler(format) {
	  return {
	    key: format[0].toUpperCase(),
	    shortKey: true,
	    handler: function handler(range, context) {
	      this.quill.format(format, !context.format[format], _quill2.default.sources.USER);
	    }
	  };
	}
	
	function normalize(binding) {
	  if (typeof binding === 'string' || typeof binding === 'number') {
	    return normalize({ key: binding });
	  }
	  if ((typeof binding === 'undefined' ? 'undefined' : _typeof(binding)) === 'object') {
	    binding = (0, _clone2.default)(binding, false);
	  }
	  if (typeof binding.key === 'string') {
	    if (Keyboard.keys[binding.key.toUpperCase()] != null) {
	      binding.key = Keyboard.keys[binding.key.toUpperCase()];
	    } else if (binding.key.length === 1) {
	      binding.key = binding.key.toUpperCase().charCodeAt(0);
	    } else {
	      return null;
	    }
	  }
	  if (binding.shortKey) {
	    binding[SHORTKEY] = binding.shortKey;
	    delete binding.shortKey;
	  }
	  return binding;
	}
	
	exports.default = Keyboard;
	exports.SHORTKEY = SHORTKEY;
	
	/***/ }),
	/* 24 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _parchment = __webpack_require__(0);
	
	var _parchment2 = _interopRequireDefault(_parchment);
	
	var _text = __webpack_require__(7);
	
	var _text2 = _interopRequireDefault(_text);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Cursor = function (_Parchment$Embed) {
	  _inherits(Cursor, _Parchment$Embed);
	
	  _createClass(Cursor, null, [{
	    key: 'value',
	    value: function value() {
	      return undefined;
	    }
	  }]);
	
	  function Cursor(domNode, selection) {
	    _classCallCheck(this, Cursor);
	
	    var _this = _possibleConstructorReturn(this, (Cursor.__proto__ || Object.getPrototypeOf(Cursor)).call(this, domNode));
	
	    _this.selection = selection;
	    _this.textNode = document.createTextNode(Cursor.CONTENTS);
	    _this.domNode.appendChild(_this.textNode);
	    _this._length = 0;
	    return _this;
	  }
	
	  _createClass(Cursor, [{
	    key: 'detach',
	    value: function detach() {
	      // super.detach() will also clear domNode.__blot
	      if (this.parent != null) this.parent.removeChild(this);
	    }
	  }, {
	    key: 'format',
	    value: function format(name, value) {
	      if (this._length !== 0) {
	        return _get(Cursor.prototype.__proto__ || Object.getPrototypeOf(Cursor.prototype), 'format', this).call(this, name, value);
	      }
	      var target = this,
	          index = 0;
	      while (target != null && target.statics.scope !== _parchment2.default.Scope.BLOCK_BLOT) {
	        index += target.offset(target.parent);
	        target = target.parent;
	      }
	      if (target != null) {
	        this._length = Cursor.CONTENTS.length;
	        target.optimize();
	        target.formatAt(index, Cursor.CONTENTS.length, name, value);
	        this._length = 0;
	      }
	    }
	  }, {
	    key: 'index',
	    value: function index(node, offset) {
	      if (node === this.textNode) return 0;
	      return _get(Cursor.prototype.__proto__ || Object.getPrototypeOf(Cursor.prototype), 'index', this).call(this, node, offset);
	    }
	  }, {
	    key: 'length',
	    value: function length() {
	      return this._length;
	    }
	  }, {
	    key: 'position',
	    value: function position() {
	      return [this.textNode, this.textNode.data.length];
	    }
	  }, {
	    key: 'remove',
	    value: function remove() {
	      _get(Cursor.prototype.__proto__ || Object.getPrototypeOf(Cursor.prototype), 'remove', this).call(this);
	      this.parent = null;
	    }
	  }, {
	    key: 'restore',
	    value: function restore() {
	      if (this.selection.composing || this.parent == null) return;
	      var textNode = this.textNode;
	      var range = this.selection.getNativeRange();
	      var restoreText = void 0,
	          start = void 0,
	          end = void 0;
	      if (range != null && range.start.node === textNode && range.end.node === textNode) {
	        var _ref = [textNode, range.start.offset, range.end.offset];
	        restoreText = _ref[0];
	        start = _ref[1];
	        end = _ref[2];
	      }
	      // Link format will insert text outside of anchor tag
	      while (this.domNode.lastChild != null && this.domNode.lastChild !== this.textNode) {
	        this.domNode.parentNode.insertBefore(this.domNode.lastChild, this.domNode);
	      }
	      if (this.textNode.data !== Cursor.CONTENTS) {
	        var text = this.textNode.data.split(Cursor.CONTENTS).join('');
	        if (this.next instanceof _text2.default) {
	          restoreText = this.next.domNode;
	          this.next.insertAt(0, text);
	          this.textNode.data = Cursor.CONTENTS;
	        } else {
	          this.textNode.data = text;
	          this.parent.insertBefore(_parchment2.default.create(this.textNode), this);
	          this.textNode = document.createTextNode(Cursor.CONTENTS);
	          this.domNode.appendChild(this.textNode);
	        }
	      }
	      this.remove();
	      if (start != null) {
	        var _map = [start, end].map(function (offset) {
	          return Math.max(0, Math.min(restoreText.data.length, offset - 1));
	        });
	
	        var _map2 = _slicedToArray(_map, 2);
	
	        start = _map2[0];
	        end = _map2[1];
	
	        return {
	          startNode: restoreText,
	          startOffset: start,
	          endNode: restoreText,
	          endOffset: end
	        };
	      }
	    }
	  }, {
	    key: 'update',
	    value: function update(mutations, context) {
	      var _this2 = this;
	
	      if (mutations.some(function (mutation) {
	        return mutation.type === 'characterData' && mutation.target === _this2.textNode;
	      })) {
	        var range = this.restore();
	        if (range) context.range = range;
	      }
	    }
	  }, {
	    key: 'value',
	    value: function value() {
	      return '';
	    }
	  }]);
	
	  return Cursor;
	}(_parchment2.default.Embed);
	
	Cursor.blotName = 'cursor';
	Cursor.className = 'ql-cursor';
	Cursor.tagName = 'span';
	Cursor.CONTENTS = '\uFEFF'; // Zero width no break space
	
	
	exports.default = Cursor;
	
	/***/ }),
	/* 25 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _parchment = __webpack_require__(0);
	
	var _parchment2 = _interopRequireDefault(_parchment);
	
	var _block = __webpack_require__(4);
	
	var _block2 = _interopRequireDefault(_block);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Container = function (_Parchment$Container) {
	  _inherits(Container, _Parchment$Container);
	
	  function Container() {
	    _classCallCheck(this, Container);
	
	    return _possibleConstructorReturn(this, (Container.__proto__ || Object.getPrototypeOf(Container)).apply(this, arguments));
	  }
	
	  return Container;
	}(_parchment2.default.Container);
	
	Container.allowedChildren = [_block2.default, _block.BlockEmbed, Container];
	
	exports.default = Container;
	
	/***/ }),
	/* 26 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ColorStyle = exports.ColorClass = exports.ColorAttributor = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };
	
	var _parchment = __webpack_require__(0);
	
	var _parchment2 = _interopRequireDefault(_parchment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ColorAttributor = function (_Parchment$Attributor) {
	  _inherits(ColorAttributor, _Parchment$Attributor);
	
	  function ColorAttributor() {
	    _classCallCheck(this, ColorAttributor);
	
	    return _possibleConstructorReturn(this, (ColorAttributor.__proto__ || Object.getPrototypeOf(ColorAttributor)).apply(this, arguments));
	  }
	
	  _createClass(ColorAttributor, [{
	    key: 'value',
	    value: function value(domNode) {
	      var value = _get(ColorAttributor.prototype.__proto__ || Object.getPrototypeOf(ColorAttributor.prototype), 'value', this).call(this, domNode);
	      if (!value.startsWith('rgb(')) return value;
	      value = value.replace(/^[^\d]+/, '').replace(/[^\d]+$/, '');
	      return '#' + value.split(',').map(function (component) {
	        return ('00' + parseInt(component).toString(16)).slice(-2);
	      }).join('');
	    }
	  }]);
	
	  return ColorAttributor;
	}(_parchment2.default.Attributor.Style);
	
	var ColorClass = new _parchment2.default.Attributor.Class('color', 'ql-color', {
	  scope: _parchment2.default.Scope.INLINE
	});
	var ColorStyle = new ColorAttributor('color', 'color', {
	  scope: _parchment2.default.Scope.INLINE
	});
	
	exports.ColorAttributor = ColorAttributor;
	exports.ColorClass = ColorClass;
	exports.ColorStyle = ColorStyle;
	
	/***/ }),
	/* 27 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.sanitize = exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };
	
	var _inline = __webpack_require__(6);
	
	var _inline2 = _interopRequireDefault(_inline);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Link = function (_Inline) {
	  _inherits(Link, _Inline);
	
	  function Link() {
	    _classCallCheck(this, Link);
	
	    return _possibleConstructorReturn(this, (Link.__proto__ || Object.getPrototypeOf(Link)).apply(this, arguments));
	  }
	
	  _createClass(Link, [{
	    key: 'format',
	    value: function format(name, value) {
	      if (name !== this.statics.blotName || !value) return _get(Link.prototype.__proto__ || Object.getPrototypeOf(Link.prototype), 'format', this).call(this, name, value);
	      value = this.constructor.sanitize(value);
	      this.domNode.setAttribute('href', value);
	    }
	  }], [{
	    key: 'create',
	    value: function create(value) {
	      var node = _get(Link.__proto__ || Object.getPrototypeOf(Link), 'create', this).call(this, value);
	      value = this.sanitize(value);
	      node.setAttribute('href', value);
	      node.setAttribute('target', '_blank');
	      return node;
	    }
	  }, {
	    key: 'formats',
	    value: function formats(domNode) {
	      return domNode.getAttribute('href');
	    }
	  }, {
	    key: 'sanitize',
	    value: function sanitize(url) {
	      return _sanitize(url, this.PROTOCOL_WHITELIST) ? url : this.SANITIZED_URL;
	    }
	  }]);
	
	  return Link;
	}(_inline2.default);
	
	Link.blotName = 'link';
	Link.tagName = 'A';
	Link.SANITIZED_URL = 'about:blank';
	Link.PROTOCOL_WHITELIST = ['http', 'https', 'mailto', 'tel'];
	
	function _sanitize(url, protocols) {
	  var anchor = document.createElement('a');
	  anchor.href = url;
	  var protocol = anchor.href.slice(0, anchor.href.indexOf(':'));
	  return protocols.indexOf(protocol) > -1;
	}
	
	exports.default = Link;
	exports.sanitize = _sanitize;
	
	/***/ }),
	/* 28 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _keyboard = __webpack_require__(23);
	
	var _keyboard2 = _interopRequireDefault(_keyboard);
	
	var _dropdown = __webpack_require__(107);
	
	var _dropdown2 = _interopRequireDefault(_dropdown);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var optionsCounter = 0;
	
	function toggleAriaAttribute(element, attribute) {
	  element.setAttribute(attribute, !(element.getAttribute(attribute) === 'true'));
	}
	
	var Picker = function () {
	  function Picker(select) {
	    var _this = this;
	
	    _classCallCheck(this, Picker);
	
	    this.select = select;
	    this.container = document.createElement('span');
	    this.buildPicker();
	    this.select.style.display = 'none';
	    this.select.parentNode.insertBefore(this.container, this.select);
	
	    this.label.addEventListener('mousedown', function () {
	      _this.togglePicker();
	    });
	    this.label.addEventListener('keydown', function (event) {
	      switch (event.keyCode) {
	        // Allows the "Enter" key to open the picker
	        case _keyboard2.default.keys.ENTER:
	          _this.togglePicker();
	          break;
	
	        // Allows the "Escape" key to close the picker
	        case _keyboard2.default.keys.ESCAPE:
	          _this.escape();
	          event.preventDefault();
	          break;
	        default:
	      }
	    });
	    this.select.addEventListener('change', this.update.bind(this));
	  }
	
	  _createClass(Picker, [{
	    key: 'togglePicker',
	    value: function togglePicker() {
	      this.container.classList.toggle('ql-expanded');
	      // Toggle aria-expanded and aria-hidden to make the picker accessible
	      toggleAriaAttribute(this.label, 'aria-expanded');
	      toggleAriaAttribute(this.options, 'aria-hidden');
	    }
	  }, {
	    key: 'buildItem',
	    value: function buildItem(option) {
	      var _this2 = this;
	
	      var item = document.createElement('span');
	      item.tabIndex = '0';
	      item.setAttribute('role', 'button');
	
	      item.classList.add('ql-picker-item');
	      if (option.hasAttribute('value')) {
	        item.setAttribute('data-value', option.getAttribute('value'));
	      }
	      if (option.textContent) {
	        item.setAttribute('data-label', option.textContent);
	      }
	      item.addEventListener('click', function () {
	        _this2.selectItem(item, true);
	      });
	      item.addEventListener('keydown', function (event) {
	        switch (event.keyCode) {
	          // Allows the "Enter" key to select an item
	          case _keyboard2.default.keys.ENTER:
	            _this2.selectItem(item, true);
	            event.preventDefault();
	            break;
	
	          // Allows the "Escape" key to close the picker
	          case _keyboard2.default.keys.ESCAPE:
	            _this2.escape();
	            event.preventDefault();
	            break;
	          default:
	        }
	      });
	
	      return item;
	    }
	  }, {
	    key: 'buildLabel',
	    value: function buildLabel() {
	      var label = document.createElement('span');
	      label.classList.add('ql-picker-label');
	      label.innerHTML = _dropdown2.default;
	      label.tabIndex = '0';
	      label.setAttribute('role', 'button');
	      label.setAttribute('aria-expanded', 'false');
	      this.container.appendChild(label);
	      return label;
	    }
	  }, {
	    key: 'buildOptions',
	    value: function buildOptions() {
	      var _this3 = this;
	
	      var options = document.createElement('span');
	      options.classList.add('ql-picker-options');
	
	      // Don't want screen readers to read this until options are visible
	      options.setAttribute('aria-hidden', 'true');
	      options.tabIndex = '-1';
	
	      // Need a unique id for aria-controls
	      options.id = 'ql-picker-options-' + optionsCounter;
	      optionsCounter += 1;
	      this.label.setAttribute('aria-controls', options.id);
	
	      this.options = options;
	
	      [].slice.call(this.select.options).forEach(function (option) {
	        var item = _this3.buildItem(option);
	        options.appendChild(item);
	        if (option.selected === true) {
	          _this3.selectItem(item);
	        }
	      });
	      this.container.appendChild(options);
	    }
	  }, {
	    key: 'buildPicker',
	    value: function buildPicker() {
	      var _this4 = this;
	
	      [].slice.call(this.select.attributes).forEach(function (item) {
	        _this4.container.setAttribute(item.name, item.value);
	      });
	      this.container.classList.add('ql-picker');
	      this.label = this.buildLabel();
	      this.buildOptions();
	    }
	  }, {
	    key: 'escape',
	    value: function escape() {
	      var _this5 = this;
	
	      // Close menu and return focus to trigger label
	      this.close();
	      // Need setTimeout for accessibility to ensure that the browser executes
	      // focus on the next process thread and after any DOM content changes
	      setTimeout(function () {
	        return _this5.label.focus();
	      }, 1);
	    }
	  }, {
	    key: 'close',
	    value: function close() {
	      this.container.classList.remove('ql-expanded');
	      this.label.setAttribute('aria-expanded', 'false');
	      this.options.setAttribute('aria-hidden', 'true');
	    }
	  }, {
	    key: 'selectItem',
	    value: function selectItem(item) {
	      var trigger = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	
	      var selected = this.container.querySelector('.ql-selected');
	      if (item === selected) return;
	      if (selected != null) {
	        selected.classList.remove('ql-selected');
	      }
	      if (item == null) return;
	      item.classList.add('ql-selected');
	      this.select.selectedIndex = [].indexOf.call(item.parentNode.children, item);
	      if (item.hasAttribute('data-value')) {
	        this.label.setAttribute('data-value', item.getAttribute('data-value'));
	      } else {
	        this.label.removeAttribute('data-value');
	      }
	      if (item.hasAttribute('data-label')) {
	        this.label.setAttribute('data-label', item.getAttribute('data-label'));
	      } else {
	        this.label.removeAttribute('data-label');
	      }
	      if (trigger) {
	        if (typeof Event === 'function') {
	          this.select.dispatchEvent(new Event('change'));
	        } else if ((typeof Event === 'undefined' ? 'undefined' : _typeof(Event)) === 'object') {
	          // IE11
	          var event = document.createEvent('Event');
	          event.initEvent('change', true, true);
	          this.select.dispatchEvent(event);
	        }
	        this.close();
	      }
	    }
	  }, {
	    key: 'update',
	    value: function update() {
	      var option = void 0;
	      if (this.select.selectedIndex > -1) {
	        var item = this.container.querySelector('.ql-picker-options').children[this.select.selectedIndex];
	        option = this.select.options[this.select.selectedIndex];
	        this.selectItem(item);
	      } else {
	        this.selectItem(null);
	      }
	      var isActive = option != null && option !== this.select.querySelector('option[selected]');
	      this.label.classList.toggle('ql-active', isActive);
	    }
	  }]);
	
	  return Picker;
	}();
	
	exports.default = Picker;
	
	/***/ }),
	/* 29 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _parchment = __webpack_require__(0);
	
	var _parchment2 = _interopRequireDefault(_parchment);
	
	var _quill = __webpack_require__(5);
	
	var _quill2 = _interopRequireDefault(_quill);
	
	var _block = __webpack_require__(4);
	
	var _block2 = _interopRequireDefault(_block);
	
	var _break = __webpack_require__(16);
	
	var _break2 = _interopRequireDefault(_break);
	
	var _container = __webpack_require__(25);
	
	var _container2 = _interopRequireDefault(_container);
	
	var _cursor = __webpack_require__(24);
	
	var _cursor2 = _interopRequireDefault(_cursor);
	
	var _embed = __webpack_require__(35);
	
	var _embed2 = _interopRequireDefault(_embed);
	
	var _inline = __webpack_require__(6);
	
	var _inline2 = _interopRequireDefault(_inline);
	
	var _scroll = __webpack_require__(22);
	
	var _scroll2 = _interopRequireDefault(_scroll);
	
	var _text = __webpack_require__(7);
	
	var _text2 = _interopRequireDefault(_text);
	
	var _clipboard = __webpack_require__(55);
	
	var _clipboard2 = _interopRequireDefault(_clipboard);
	
	var _history = __webpack_require__(42);
	
	var _history2 = _interopRequireDefault(_history);
	
	var _keyboard = __webpack_require__(23);
	
	var _keyboard2 = _interopRequireDefault(_keyboard);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	_quill2.default.register({
	  'blots/block': _block2.default,
	  'blots/block/embed': _block.BlockEmbed,
	  'blots/break': _break2.default,
	  'blots/container': _container2.default,
	  'blots/cursor': _cursor2.default,
	  'blots/embed': _embed2.default,
	  'blots/inline': _inline2.default,
	  'blots/scroll': _scroll2.default,
	  'blots/text': _text2.default,
	
	  'modules/clipboard': _clipboard2.default,
	  'modules/history': _history2.default,
	  'modules/keyboard': _keyboard2.default
	});
	
	_parchment2.default.register(_block2.default, _break2.default, _cursor2.default, _inline2.default, _scroll2.default, _text2.default);
	
	exports.default = _quill2.default;
	
	/***/ }),
	/* 30 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	Object.defineProperty(exports, "__esModule", { value: true });
	var Registry = __webpack_require__(1);
	var ShadowBlot = /** @class */ (function () {
	    function ShadowBlot(domNode) {
	        this.domNode = domNode;
	        // @ts-ignore
	        this.domNode[Registry.DATA_KEY] = { blot: this };
	    }
	    Object.defineProperty(ShadowBlot.prototype, "statics", {
	        // Hack for accessing inherited static methods
	        get: function () {
	            return this.constructor;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    ShadowBlot.create = function (value) {
	        if (this.tagName == null) {
	            throw new Registry.ParchmentError('Blot definition missing tagName');
	        }
	        var node;
	        if (Array.isArray(this.tagName)) {
	            if (typeof value === 'string') {
	                value = value.toUpperCase();
	                if (parseInt(value).toString() === value) {
	                    value = parseInt(value);
	                }
	            }
	            if (typeof value === 'number') {
	                node = document.createElement(this.tagName[value - 1]);
	            }
	            else if (this.tagName.indexOf(value) > -1) {
	                node = document.createElement(value);
	            }
	            else {
	                node = document.createElement(this.tagName[0]);
	            }
	        }
	        else {
	            node = document.createElement(this.tagName);
	        }
	        if (this.className) {
	            node.classList.add(this.className);
	        }
	        return node;
	    };
	    ShadowBlot.prototype.attach = function () {
	        if (this.parent != null) {
	            this.scroll = this.parent.scroll;
	        }
	    };
	    ShadowBlot.prototype.clone = function () {
	        var domNode = this.domNode.cloneNode(false);
	        return Registry.create(domNode);
	    };
	    ShadowBlot.prototype.detach = function () {
	        if (this.parent != null)
	            this.parent.removeChild(this);
	        // @ts-ignore
	        delete this.domNode[Registry.DATA_KEY];
	    };
	    ShadowBlot.prototype.deleteAt = function (index, length) {
	        var blot = this.isolate(index, length);
	        blot.remove();
	    };
	    ShadowBlot.prototype.formatAt = function (index, length, name, value) {
	        var blot = this.isolate(index, length);
	        if (Registry.query(name, Registry.Scope.BLOT) != null && value) {
	            blot.wrap(name, value);
	        }
	        else if (Registry.query(name, Registry.Scope.ATTRIBUTE) != null) {
	            var parent = Registry.create(this.statics.scope);
	            blot.wrap(parent);
	            parent.format(name, value);
	        }
	    };
	    ShadowBlot.prototype.insertAt = function (index, value, def) {
	        var blot = def == null ? Registry.create('text', value) : Registry.create(value, def);
	        var ref = this.split(index);
	        this.parent.insertBefore(blot, ref);
	    };
	    ShadowBlot.prototype.insertInto = function (parentBlot, refBlot) {
	        if (refBlot === void 0) { refBlot = null; }
	        if (this.parent != null) {
	            this.parent.children.remove(this);
	        }
	        var refDomNode = null;
	        parentBlot.children.insertBefore(this, refBlot);
	        if (refBlot != null) {
	            refDomNode = refBlot.domNode;
	        }
	        if (this.domNode.parentNode != parentBlot.domNode ||
	            this.domNode.nextSibling != refDomNode) {
	            parentBlot.domNode.insertBefore(this.domNode, refDomNode);
	        }
	        this.parent = parentBlot;
	        this.attach();
	    };
	    ShadowBlot.prototype.isolate = function (index, length) {
	        var target = this.split(index);
	        target.split(length);
	        return target;
	    };
	    ShadowBlot.prototype.length = function () {
	        return 1;
	    };
	    ShadowBlot.prototype.offset = function (root) {
	        if (root === void 0) { root = this.parent; }
	        if (this.parent == null || this == root)
	            return 0;
	        return this.parent.children.offset(this) + this.parent.offset(root);
	    };
	    ShadowBlot.prototype.optimize = function (context) {
	        // TODO clean up once we use WeakMap
	        // @ts-ignore
	        if (this.domNode[Registry.DATA_KEY] != null) {
	            // @ts-ignore
	            delete this.domNode[Registry.DATA_KEY].mutations;
	        }
	    };
	    ShadowBlot.prototype.remove = function () {
	        if (this.domNode.parentNode != null) {
	            this.domNode.parentNode.removeChild(this.domNode);
	        }
	        this.detach();
	    };
	    ShadowBlot.prototype.replace = function (target) {
	        if (target.parent == null)
	            return;
	        target.parent.insertBefore(this, target.next);
	        target.remove();
	    };
	    ShadowBlot.prototype.replaceWith = function (name, value) {
	        var replacement = typeof name === 'string' ? Registry.create(name, value) : name;
	        replacement.replace(this);
	        return replacement;
	    };
	    ShadowBlot.prototype.split = function (index, force) {
	        return index === 0 ? this : this.next;
	    };
	    ShadowBlot.prototype.update = function (mutations, context) {
	        // Nothing to do by default
	    };
	    ShadowBlot.prototype.wrap = function (name, value) {
	        var wrapper = typeof name === 'string' ? Registry.create(name, value) : name;
	        if (this.parent != null) {
	            this.parent.insertBefore(wrapper, this.next);
	        }
	        wrapper.appendChild(this);
	        return wrapper;
	    };
	    ShadowBlot.blotName = 'abstract';
	    return ShadowBlot;
	}());
	exports.default = ShadowBlot;
	
	
	/***/ }),
	/* 31 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	Object.defineProperty(exports, "__esModule", { value: true });
	var attributor_1 = __webpack_require__(12);
	var class_1 = __webpack_require__(32);
	var style_1 = __webpack_require__(33);
	var Registry = __webpack_require__(1);
	var AttributorStore = /** @class */ (function () {
	    function AttributorStore(domNode) {
	        this.attributes = {};
	        this.domNode = domNode;
	        this.build();
	    }
	    AttributorStore.prototype.attribute = function (attribute, value) {
	        // verb
	        if (value) {
	            if (attribute.add(this.domNode, value)) {
	                if (attribute.value(this.domNode) != null) {
	                    this.attributes[attribute.attrName] = attribute;
	                }
	                else {
	                    delete this.attributes[attribute.attrName];
	                }
	            }
	        }
	        else {
	            attribute.remove(this.domNode);
	            delete this.attributes[attribute.attrName];
	        }
	    };
	    AttributorStore.prototype.build = function () {
	        var _this = this;
	        this.attributes = {};
	        var attributes = attributor_1.default.keys(this.domNode);
	        var classes = class_1.default.keys(this.domNode);
	        var styles = style_1.default.keys(this.domNode);
	        attributes
	            .concat(classes)
	            .concat(styles)
	            .forEach(function (name) {
	            var attr = Registry.query(name, Registry.Scope.ATTRIBUTE);
	            if (attr instanceof attributor_1.default) {
	                _this.attributes[attr.attrName] = attr;
	            }
	        });
	    };
	    AttributorStore.prototype.copy = function (target) {
	        var _this = this;
	        Object.keys(this.attributes).forEach(function (key) {
	            var value = _this.attributes[key].value(_this.domNode);
	            target.format(key, value);
	        });
	    };
	    AttributorStore.prototype.move = function (target) {
	        var _this = this;
	        this.copy(target);
	        Object.keys(this.attributes).forEach(function (key) {
	            _this.attributes[key].remove(_this.domNode);
	        });
	        this.attributes = {};
	    };
	    AttributorStore.prototype.values = function () {
	        var _this = this;
	        return Object.keys(this.attributes).reduce(function (attributes, name) {
	            attributes[name] = _this.attributes[name].value(_this.domNode);
	            return attributes;
	        }, {});
	    };
	    return AttributorStore;
	}());
	exports.default = AttributorStore;
	
	
	/***/ }),
	/* 32 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var attributor_1 = __webpack_require__(12);
	function match(node, prefix) {
	    var className = node.getAttribute('class') || '';
	    return className.split(/\s+/).filter(function (name) {
	        return name.indexOf(prefix + "-") === 0;
	    });
	}
	var ClassAttributor = /** @class */ (function (_super) {
	    __extends(ClassAttributor, _super);
	    function ClassAttributor() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    ClassAttributor.keys = function (node) {
	        return (node.getAttribute('class') || '').split(/\s+/).map(function (name) {
	            return name
	                .split('-')
	                .slice(0, -1)
	                .join('-');
	        });
	    };
	    ClassAttributor.prototype.add = function (node, value) {
	        if (!this.canAdd(node, value))
	            return false;
	        this.remove(node);
	        node.classList.add(this.keyName + "-" + value);
	        return true;
	    };
	    ClassAttributor.prototype.remove = function (node) {
	        var matches = match(node, this.keyName);
	        matches.forEach(function (name) {
	            node.classList.remove(name);
	        });
	        if (node.classList.length === 0) {
	            node.removeAttribute('class');
	        }
	    };
	    ClassAttributor.prototype.value = function (node) {
	        var result = match(node, this.keyName)[0] || '';
	        var value = result.slice(this.keyName.length + 1); // +1 for hyphen
	        return this.canAdd(node, value) ? value : '';
	    };
	    return ClassAttributor;
	}(attributor_1.default));
	exports.default = ClassAttributor;
	
	
	/***/ }),
	/* 33 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var attributor_1 = __webpack_require__(12);
	function camelize(name) {
	    var parts = name.split('-');
	    var rest = parts
	        .slice(1)
	        .map(function (part) {
	        return part[0].toUpperCase() + part.slice(1);
	    })
	        .join('');
	    return parts[0] + rest;
	}
	var StyleAttributor = /** @class */ (function (_super) {
	    __extends(StyleAttributor, _super);
	    function StyleAttributor() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    StyleAttributor.keys = function (node) {
	        return (node.getAttribute('style') || '').split(';').map(function (value) {
	            var arr = value.split(':');
	            return arr[0].trim();
	        });
	    };
	    StyleAttributor.prototype.add = function (node, value) {
	        if (!this.canAdd(node, value))
	            return false;
	        // @ts-ignore
	        node.style[camelize(this.keyName)] = value;
	        return true;
	    };
	    StyleAttributor.prototype.remove = function (node) {
	        // @ts-ignore
	        node.style[camelize(this.keyName)] = '';
	        if (!node.getAttribute('style')) {
	            node.removeAttribute('style');
	        }
	    };
	    StyleAttributor.prototype.value = function (node) {
	        // @ts-ignore
	        var value = node.style[camelize(this.keyName)];
	        return this.canAdd(node, value) ? value : '';
	    };
	    return StyleAttributor;
	}(attributor_1.default));
	exports.default = StyleAttributor;
	
	
	/***/ }),
	/* 34 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var Theme = function () {
	  function Theme(quill, options) {
	    _classCallCheck(this, Theme);
	
	    this.quill = quill;
	    this.options = options;
	    this.modules = {};
	  }
	
	  _createClass(Theme, [{
	    key: 'init',
	    value: function init() {
	      var _this = this;
	
	      Object.keys(this.options.modules).forEach(function (name) {
	        if (_this.modules[name] == null) {
	          _this.addModule(name);
	        }
	      });
	    }
	  }, {
	    key: 'addModule',
	    value: function addModule(name) {
	      var moduleClass = this.quill.constructor.import('modules/' + name);
	      this.modules[name] = new moduleClass(this.quill, this.options.modules[name] || {});
	      return this.modules[name];
	    }
	  }]);
	
	  return Theme;
	}();
	
	Theme.DEFAULTS = {
	  modules: {}
	};
	Theme.themes = {
	  'default': Theme
	};
	
	exports.default = Theme;
	
	/***/ }),
	/* 35 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };
	
	var _parchment = __webpack_require__(0);
	
	var _parchment2 = _interopRequireDefault(_parchment);
	
	var _text = __webpack_require__(7);
	
	var _text2 = _interopRequireDefault(_text);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var GUARD_TEXT = '\uFEFF';
	
	var Embed = function (_Parchment$Embed) {
	  _inherits(Embed, _Parchment$Embed);
	
	  function Embed(node) {
	    _classCallCheck(this, Embed);
	
	    var _this = _possibleConstructorReturn(this, (Embed.__proto__ || Object.getPrototypeOf(Embed)).call(this, node));
	
	    _this.contentNode = document.createElement('span');
	    _this.contentNode.setAttribute('contenteditable', false);
	    [].slice.call(_this.domNode.childNodes).forEach(function (childNode) {
	      _this.contentNode.appendChild(childNode);
	    });
	    _this.leftGuard = document.createTextNode(GUARD_TEXT);
	    _this.rightGuard = document.createTextNode(GUARD_TEXT);
	    _this.domNode.appendChild(_this.leftGuard);
	    _this.domNode.appendChild(_this.contentNode);
	    _this.domNode.appendChild(_this.rightGuard);
	    return _this;
	  }
	
	  _createClass(Embed, [{
	    key: 'index',
	    value: function index(node, offset) {
	      if (node === this.leftGuard) return 0;
	      if (node === this.rightGuard) return 1;
	      return _get(Embed.prototype.__proto__ || Object.getPrototypeOf(Embed.prototype), 'index', this).call(this, node, offset);
	    }
	  }, {
	    key: 'restore',
	    value: function restore(node) {
	      var range = void 0,
	          textNode = void 0;
	      var text = node.data.split(GUARD_TEXT).join('');
	      if (node === this.leftGuard) {
	        if (this.prev instanceof _text2.default) {
	          var prevLength = this.prev.length();
	          this.prev.insertAt(prevLength, text);
	          range = {
	            startNode: this.prev.domNode,
	            startOffset: prevLength + text.length
	          };
	        } else {
	          textNode = document.createTextNode(text);
	          this.parent.insertBefore(_parchment2.default.create(textNode), this);
	          range = {
	            startNode: textNode,
	            startOffset: text.length
	          };
	        }
	      } else if (node === this.rightGuard) {
	        if (this.next instanceof _text2.default) {
	          this.next.insertAt(0, text);
	          range = {
	            startNode: this.next.domNode,
	            startOffset: text.length
	          };
	        } else {
	          textNode = document.createTextNode(text);
	          this.parent.insertBefore(_parchment2.default.create(textNode), this.next);
	          range = {
	            startNode: textNode,
	            startOffset: text.length
	          };
	        }
	      }
	      node.data = GUARD_TEXT;
	      return range;
	    }
	  }, {
	    key: 'update',
	    value: function update(mutations, context) {
	      var _this2 = this;
	
	      mutations.forEach(function (mutation) {
	        if (mutation.type === 'characterData' && (mutation.target === _this2.leftGuard || mutation.target === _this2.rightGuard)) {
	          var range = _this2.restore(mutation.target);
	          if (range) context.range = range;
	        }
	      });
	    }
	  }]);
	
	  return Embed;
	}(_parchment2.default.Embed);
	
	exports.default = Embed;
	
	/***/ }),
	/* 36 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.AlignStyle = exports.AlignClass = exports.AlignAttribute = undefined;
	
	var _parchment = __webpack_require__(0);
	
	var _parchment2 = _interopRequireDefault(_parchment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var config = {
	  scope: _parchment2.default.Scope.BLOCK,
	  whitelist: ['right', 'center', 'justify']
	};
	
	var AlignAttribute = new _parchment2.default.Attributor.Attribute('align', 'align', config);
	var AlignClass = new _parchment2.default.Attributor.Class('align', 'ql-align', config);
	var AlignStyle = new _parchment2.default.Attributor.Style('align', 'text-align', config);
	
	exports.AlignAttribute = AlignAttribute;
	exports.AlignClass = AlignClass;
	exports.AlignStyle = AlignStyle;
	
	/***/ }),
	/* 37 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.BackgroundStyle = exports.BackgroundClass = undefined;
	
	var _parchment = __webpack_require__(0);
	
	var _parchment2 = _interopRequireDefault(_parchment);
	
	var _color = __webpack_require__(26);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var BackgroundClass = new _parchment2.default.Attributor.Class('background', 'ql-bg', {
	  scope: _parchment2.default.Scope.INLINE
	});
	var BackgroundStyle = new _color.ColorAttributor('background', 'background-color', {
	  scope: _parchment2.default.Scope.INLINE
	});
	
	exports.BackgroundClass = BackgroundClass;
	exports.BackgroundStyle = BackgroundStyle;
	
	/***/ }),
	/* 38 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.DirectionStyle = exports.DirectionClass = exports.DirectionAttribute = undefined;
	
	var _parchment = __webpack_require__(0);
	
	var _parchment2 = _interopRequireDefault(_parchment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var config = {
	  scope: _parchment2.default.Scope.BLOCK,
	  whitelist: ['rtl']
	};
	
	var DirectionAttribute = new _parchment2.default.Attributor.Attribute('direction', 'dir', config);
	var DirectionClass = new _parchment2.default.Attributor.Class('direction', 'ql-direction', config);
	var DirectionStyle = new _parchment2.default.Attributor.Style('direction', 'direction', config);
	
	exports.DirectionAttribute = DirectionAttribute;
	exports.DirectionClass = DirectionClass;
	exports.DirectionStyle = DirectionStyle;
	
	/***/ }),
	/* 39 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.FontClass = exports.FontStyle = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };
	
	var _parchment = __webpack_require__(0);
	
	var _parchment2 = _interopRequireDefault(_parchment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var config = {
	  scope: _parchment2.default.Scope.INLINE,
	  whitelist: ['serif', 'monospace']
	};
	
	var FontClass = new _parchment2.default.Attributor.Class('font', 'ql-font', config);
	
	var FontStyleAttributor = function (_Parchment$Attributor) {
	  _inherits(FontStyleAttributor, _Parchment$Attributor);
	
	  function FontStyleAttributor() {
	    _classCallCheck(this, FontStyleAttributor);
	
	    return _possibleConstructorReturn(this, (FontStyleAttributor.__proto__ || Object.getPrototypeOf(FontStyleAttributor)).apply(this, arguments));
	  }
	
	  _createClass(FontStyleAttributor, [{
	    key: 'value',
	    value: function value(node) {
	      return _get(FontStyleAttributor.prototype.__proto__ || Object.getPrototypeOf(FontStyleAttributor.prototype), 'value', this).call(this, node).replace(/["']/g, '');
	    }
	  }]);
	
	  return FontStyleAttributor;
	}(_parchment2.default.Attributor.Style);
	
	var FontStyle = new FontStyleAttributor('font', 'font-family', config);
	
	exports.FontStyle = FontStyle;
	exports.FontClass = FontClass;
	
	/***/ }),
	/* 40 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.SizeStyle = exports.SizeClass = undefined;
	
	var _parchment = __webpack_require__(0);
	
	var _parchment2 = _interopRequireDefault(_parchment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SizeClass = new _parchment2.default.Attributor.Class('size', 'ql-size', {
	  scope: _parchment2.default.Scope.INLINE,
	  whitelist: ['small', 'large', 'huge']
	});
	var SizeStyle = new _parchment2.default.Attributor.Style('size', 'font-size', {
	  scope: _parchment2.default.Scope.INLINE,
	  whitelist: ['10px', '18px', '32px']
	});
	
	exports.SizeClass = SizeClass;
	exports.SizeStyle = SizeStyle;
	
	/***/ }),
	/* 41 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	module.exports = {
	  'align': {
	    '': __webpack_require__(76),
	    'center': __webpack_require__(77),
	    'right': __webpack_require__(78),
	    'justify': __webpack_require__(79)
	  },
	  'background': __webpack_require__(80),
	  'blockquote': __webpack_require__(81),
	  'bold': __webpack_require__(82),
	  'clean': __webpack_require__(83),
	  'code': __webpack_require__(58),
	  'code-block': __webpack_require__(58),
	  'color': __webpack_require__(84),
	  'direction': {
	    '': __webpack_require__(85),
	    'rtl': __webpack_require__(86)
	  },
	  'float': {
	    'center': __webpack_require__(87),
	    'full': __webpack_require__(88),
	    'left': __webpack_require__(89),
	    'right': __webpack_require__(90)
	  },
	  'formula': __webpack_require__(91),
	  'header': {
	    '1': __webpack_require__(92),
	    '2': __webpack_require__(93)
	  },
	  'italic': __webpack_require__(94),
	  'image': __webpack_require__(95),
	  'indent': {
	    '+1': __webpack_require__(96),
	    '-1': __webpack_require__(97)
	  },
	  'link': __webpack_require__(98),
	  'list': {
	    'ordered': __webpack_require__(99),
	    'bullet': __webpack_require__(100),
	    'check': __webpack_require__(101)
	  },
	  'script': {
	    'sub': __webpack_require__(102),
	    'super': __webpack_require__(103)
	  },
	  'strike': __webpack_require__(104),
	  'underline': __webpack_require__(105),
	  'video': __webpack_require__(106)
	};
	
	/***/ }),
	/* 42 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getLastChangeIndex = exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _parchment = __webpack_require__(0);
	
	var _parchment2 = _interopRequireDefault(_parchment);
	
	var _quill = __webpack_require__(5);
	
	var _quill2 = _interopRequireDefault(_quill);
	
	var _module = __webpack_require__(9);
	
	var _module2 = _interopRequireDefault(_module);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var History = function (_Module) {
	  _inherits(History, _Module);
	
	  function History(quill, options) {
	    _classCallCheck(this, History);
	
	    var _this = _possibleConstructorReturn(this, (History.__proto__ || Object.getPrototypeOf(History)).call(this, quill, options));
	
	    _this.lastRecorded = 0;
	    _this.ignoreChange = false;
	    _this.clear();
	    _this.quill.on(_quill2.default.events.EDITOR_CHANGE, function (eventName, delta, oldDelta, source) {
	      if (eventName !== _quill2.default.events.TEXT_CHANGE || _this.ignoreChange) return;
	      if (!_this.options.userOnly || source === _quill2.default.sources.USER) {
	        _this.record(delta, oldDelta);
	      } else {
	        _this.transform(delta);
	      }
	    });
	    _this.quill.keyboard.addBinding({ key: 'Z', shortKey: true }, _this.undo.bind(_this));
	    _this.quill.keyboard.addBinding({ key: 'Z', shortKey: true, shiftKey: true }, _this.redo.bind(_this));
	    if (/Win/i.test(navigator.platform)) {
	      _this.quill.keyboard.addBinding({ key: 'Y', shortKey: true }, _this.redo.bind(_this));
	    }
	    return _this;
	  }
	
	  _createClass(History, [{
	    key: 'change',
	    value: function change(source, dest) {
	      if (this.stack[source].length === 0) return;
	      var delta = this.stack[source].pop();
	      this.stack[dest].push(delta);
	      this.lastRecorded = 0;
	      this.ignoreChange = true;
	      this.quill.updateContents(delta[source], _quill2.default.sources.USER);
	      this.ignoreChange = false;
	      var index = getLastChangeIndex(delta[source]);
	      this.quill.setSelection(index);
	    }
	  }, {
	    key: 'clear',
	    value: function clear() {
	      this.stack = { undo: [], redo: [] };
	    }
	  }, {
	    key: 'cutoff',
	    value: function cutoff() {
	      this.lastRecorded = 0;
	    }
	  }, {
	    key: 'record',
	    value: function record(changeDelta, oldDelta) {
	      if (changeDelta.ops.length === 0) return;
	      this.stack.redo = [];
	      var undoDelta = this.quill.getContents().diff(oldDelta);
	      var timestamp = Date.now();
	      if (this.lastRecorded + this.options.delay > timestamp && this.stack.undo.length > 0) {
	        var delta = this.stack.undo.pop();
	        undoDelta = undoDelta.compose(delta.undo);
	        changeDelta = delta.redo.compose(changeDelta);
	      } else {
	        this.lastRecorded = timestamp;
	      }
	      this.stack.undo.push({
	        redo: changeDelta,
	        undo: undoDelta
	      });
	      if (this.stack.undo.length > this.options.maxStack) {
	        this.stack.undo.shift();
	      }
	    }
	  }, {
	    key: 'redo',
	    value: function redo() {
	      this.change('redo', 'undo');
	    }
	  }, {
	    key: 'transform',
	    value: function transform(delta) {
	      this.stack.undo.forEach(function (change) {
	        change.undo = delta.transform(change.undo, true);
	        change.redo = delta.transform(change.redo, true);
	      });
	      this.stack.redo.forEach(function (change) {
	        change.undo = delta.transform(change.undo, true);
	        change.redo = delta.transform(change.redo, true);
	      });
	    }
	  }, {
	    key: 'undo',
	    value: function undo() {
	      this.change('undo', 'redo');
	    }
	  }]);
	
	  return History;
	}(_module2.default);
	
	History.DEFAULTS = {
	  delay: 1000,
	  maxStack: 100,
	  userOnly: false
	};
	
	function endsWithNewlineChange(delta) {
	  var lastOp = delta.ops[delta.ops.length - 1];
	  if (lastOp == null) return false;
	  if (lastOp.insert != null) {
	    return typeof lastOp.insert === 'string' && lastOp.insert.endsWith('\n');
	  }
	  if (lastOp.attributes != null) {
	    return Object.keys(lastOp.attributes).some(function (attr) {
	      return _parchment2.default.query(attr, _parchment2.default.Scope.BLOCK) != null;
	    });
	  }
	  return false;
	}
	
	function getLastChangeIndex(delta) {
	  var deleteLength = delta.reduce(function (length, op) {
	    length += op.delete || 0;
	    return length;
	  }, 0);
	  var changeIndex = delta.length() - deleteLength;
	  if (endsWithNewlineChange(delta)) {
	    changeIndex -= 1;
	  }
	  return changeIndex;
	}
	
	exports.default = History;
	exports.getLastChangeIndex = getLastChangeIndex;
	
	/***/ }),
	/* 43 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.BaseTooltip = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };
	
	var _extend = __webpack_require__(3);
	
	var _extend2 = _interopRequireDefault(_extend);
	
	var _quillDelta = __webpack_require__(2);
	
	var _quillDelta2 = _interopRequireDefault(_quillDelta);
	
	var _emitter = __webpack_require__(8);
	
	var _emitter2 = _interopRequireDefault(_emitter);
	
	var _keyboard = __webpack_require__(23);
	
	var _keyboard2 = _interopRequireDefault(_keyboard);
	
	var _theme = __webpack_require__(34);
	
	var _theme2 = _interopRequireDefault(_theme);
	
	var _colorPicker = __webpack_require__(59);
	
	var _colorPicker2 = _interopRequireDefault(_colorPicker);
	
	var _iconPicker = __webpack_require__(60);
	
	var _iconPicker2 = _interopRequireDefault(_iconPicker);
	
	var _picker = __webpack_require__(28);
	
	var _picker2 = _interopRequireDefault(_picker);
	
	var _tooltip = __webpack_require__(61);
	
	var _tooltip2 = _interopRequireDefault(_tooltip);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ALIGNS = [false, 'center', 'right', 'justify'];
	
	var COLORS = ["#000000", "#e60000", "#ff9900", "#ffff00", "#008a00", "#0066cc", "#9933ff", "#ffffff", "#facccc", "#ffebcc", "#ffffcc", "#cce8cc", "#cce0f5", "#ebd6ff", "#bbbbbb", "#f06666", "#ffc266", "#ffff66", "#66b966", "#66a3e0", "#c285ff", "#888888", "#a10000", "#b26b00", "#b2b200", "#006100", "#0047b2", "#6b24b2", "#444444", "#5c0000", "#663d00", "#666600", "#003700", "#002966", "#3d1466"];
	
	var FONTS = [false, 'serif', 'monospace'];
	
	var HEADERS = ['1', '2', '3', false];
	
	var SIZES = ['small', false, 'large', 'huge'];
	
	var BaseTheme = function (_Theme) {
	  _inherits(BaseTheme, _Theme);
	
	  function BaseTheme(quill, options) {
	    _classCallCheck(this, BaseTheme);
	
	    var _this = _possibleConstructorReturn(this, (BaseTheme.__proto__ || Object.getPrototypeOf(BaseTheme)).call(this, quill, options));
	
	    var listener = function listener(e) {
	      if (!document.body.contains(quill.root)) {
	        return document.body.removeEventListener('click', listener);
	      }
	      if (_this.tooltip != null && !_this.tooltip.root.contains(e.target) && document.activeElement !== _this.tooltip.textbox && !_this.quill.hasFocus()) {
	        _this.tooltip.hide();
	      }
	      if (_this.pickers != null) {
	        _this.pickers.forEach(function (picker) {
	          if (!picker.container.contains(e.target)) {
	            picker.close();
	          }
	        });
	      }
	    };
	    quill.emitter.listenDOM('click', document.body, listener);
	    return _this;
	  }
	
	  _createClass(BaseTheme, [{
	    key: 'addModule',
	    value: function addModule(name) {
	      var module = _get(BaseTheme.prototype.__proto__ || Object.getPrototypeOf(BaseTheme.prototype), 'addModule', this).call(this, name);
	      if (name === 'toolbar') {
	        this.extendToolbar(module);
	      }
	      return module;
	    }
	  }, {
	    key: 'buildButtons',
	    value: function buildButtons(buttons, icons) {
	      buttons.forEach(function (button) {
	        var className = button.getAttribute('class') || '';
	        className.split(/\s+/).forEach(function (name) {
	          if (!name.startsWith('ql-')) return;
	          name = name.slice('ql-'.length);
	          if (icons[name] == null) return;
	          if (name === 'direction') {
	            button.innerHTML = icons[name][''] + icons[name]['rtl'];
	          } else if (typeof icons[name] === 'string') {
	            button.innerHTML = icons[name];
	          } else {
	            var value = button.value || '';
	            if (value != null && icons[name][value]) {
	              button.innerHTML = icons[name][value];
	            }
	          }
	        });
	      });
	    }
	  }, {
	    key: 'buildPickers',
	    value: function buildPickers(selects, icons) {
	      var _this2 = this;
	
	      this.pickers = selects.map(function (select) {
	        if (select.classList.contains('ql-align')) {
	          if (select.querySelector('option') == null) {
	            fillSelect(select, ALIGNS);
	          }
	          return new _iconPicker2.default(select, icons.align);
	        } else if (select.classList.contains('ql-background') || select.classList.contains('ql-color')) {
	          var format = select.classList.contains('ql-background') ? 'background' : 'color';
	          if (select.querySelector('option') == null) {
	            fillSelect(select, COLORS, format === 'background' ? '#ffffff' : '#000000');
	          }
	          return new _colorPicker2.default(select, icons[format]);
	        } else {
	          if (select.querySelector('option') == null) {
	            if (select.classList.contains('ql-font')) {
	              fillSelect(select, FONTS);
	            } else if (select.classList.contains('ql-header')) {
	              fillSelect(select, HEADERS);
	            } else if (select.classList.contains('ql-size')) {
	              fillSelect(select, SIZES);
	            }
	          }
	          return new _picker2.default(select);
	        }
	      });
	      var update = function update() {
	        _this2.pickers.forEach(function (picker) {
	          picker.update();
	        });
	      };
	      this.quill.on(_emitter2.default.events.EDITOR_CHANGE, update);
	    }
	  }]);
	
	  return BaseTheme;
	}(_theme2.default);
	
	BaseTheme.DEFAULTS = (0, _extend2.default)(true, {}, _theme2.default.DEFAULTS, {
	  modules: {
	    toolbar: {
	      handlers: {
	        formula: function formula() {
	          this.quill.theme.tooltip.edit('formula');
	        },
	        image: function image() {
	          var _this3 = this;
	
	          var fileInput = this.container.querySelector('input.ql-image[type=file]');
	          if (fileInput == null) {
	            fileInput = document.createElement('input');
	            fileInput.setAttribute('type', 'file');
	            fileInput.setAttribute('accept', 'image/png, image/gif, image/jpeg, image/bmp, image/x-icon');
	            fileInput.classList.add('ql-image');
	            fileInput.addEventListener('change', function () {
	              if (fileInput.files != null && fileInput.files[0] != null) {
	                var reader = new FileReader();
	                reader.onload = function (e) {
	                  var range = _this3.quill.getSelection(true);
	                  _this3.quill.updateContents(new _quillDelta2.default().retain(range.index).delete(range.length).insert({ image: e.target.result }), _emitter2.default.sources.USER);
	                  _this3.quill.setSelection(range.index + 1, _emitter2.default.sources.SILENT);
	                  fileInput.value = "";
	                };
	                reader.readAsDataURL(fileInput.files[0]);
	              }
	            });
	            this.container.appendChild(fileInput);
	          }
	          fileInput.click();
	        },
	        video: function video() {
	          this.quill.theme.tooltip.edit('video');
	        }
	      }
	    }
	  }
	});
	
	var BaseTooltip = function (_Tooltip) {
	  _inherits(BaseTooltip, _Tooltip);
	
	  function BaseTooltip(quill, boundsContainer) {
	    _classCallCheck(this, BaseTooltip);
	
	    var _this4 = _possibleConstructorReturn(this, (BaseTooltip.__proto__ || Object.getPrototypeOf(BaseTooltip)).call(this, quill, boundsContainer));
	
	    _this4.textbox = _this4.root.querySelector('input[type="text"]');
	    _this4.listen();
	    return _this4;
	  }
	
	  _createClass(BaseTooltip, [{
	    key: 'listen',
	    value: function listen() {
	      var _this5 = this;
	
	      this.textbox.addEventListener('keydown', function (event) {
	        if (_keyboard2.default.match(event, 'enter')) {
	          _this5.save();
	          event.preventDefault();
	        } else if (_keyboard2.default.match(event, 'escape')) {
	          _this5.cancel();
	          event.preventDefault();
	        }
	      });
	    }
	  }, {
	    key: 'cancel',
	    value: function cancel() {
	      this.hide();
	    }
	  }, {
	    key: 'edit',
	    value: function edit() {
	      var mode = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'link';
	      var preview = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
	
	      this.root.classList.remove('ql-hidden');
	      this.root.classList.add('ql-editing');
	      if (preview != null) {
	        this.textbox.value = preview;
	      } else if (mode !== this.root.getAttribute('data-mode')) {
	        this.textbox.value = '';
	      }
	      this.position(this.quill.getBounds(this.quill.selection.savedRange));
	      this.textbox.select();
	      this.textbox.setAttribute('placeholder', this.textbox.getAttribute('data-' + mode) || '');
	      this.root.setAttribute('data-mode', mode);
	    }
	  }, {
	    key: 'restoreFocus',
	    value: function restoreFocus() {
	      var scrollTop = this.quill.scrollingContainer.scrollTop;
	      this.quill.focus();
	      this.quill.scrollingContainer.scrollTop = scrollTop;
	    }
	  }, {
	    key: 'save',
	    value: function save() {
	      var value = this.textbox.value;
	      switch (this.root.getAttribute('data-mode')) {
	        case 'link':
	          {
	            var scrollTop = this.quill.root.scrollTop;
	            if (this.linkRange) {
	              this.quill.formatText(this.linkRange, 'link', value, _emitter2.default.sources.USER);
	              delete this.linkRange;
	            } else {
	              this.restoreFocus();
	              this.quill.format('link', value, _emitter2.default.sources.USER);
	            }
	            this.quill.root.scrollTop = scrollTop;
	            break;
	          }
	        case 'video':
	          {
	            value = extractVideoUrl(value);
	          } // eslint-disable-next-line no-fallthrough
	        case 'formula':
	          {
	            if (!value) break;
	            var range = this.quill.getSelection(true);
	            if (range != null) {
	              var index = range.index + range.length;
	              this.quill.insertEmbed(index, this.root.getAttribute('data-mode'), value, _emitter2.default.sources.USER);
	              if (this.root.getAttribute('data-mode') === 'formula') {
	                this.quill.insertText(index + 1, ' ', _emitter2.default.sources.USER);
	              }
	              this.quill.setSelection(index + 2, _emitter2.default.sources.USER);
	            }
	            break;
	          }
	        default:
	      }
	      this.textbox.value = '';
	      this.hide();
	    }
	  }]);
	
	  return BaseTooltip;
	}(_tooltip2.default);
	
	function extractVideoUrl(url) {
	  var match = url.match(/^(?:(https?):\/\/)?(?:(?:www|m)\.)?youtube\.com\/watch.*v=([a-zA-Z0-9_-]+)/) || url.match(/^(?:(https?):\/\/)?(?:(?:www|m)\.)?youtu\.be\/([a-zA-Z0-9_-]+)/);
	  if (match) {
	    return (match[1] || 'https') + '://www.youtube.com/embed/' + match[2] + '?showinfo=0';
	  }
	  if (match = url.match(/^(?:(https?):\/\/)?(?:www\.)?vimeo\.com\/(\d+)/)) {
	    // eslint-disable-line no-cond-assign
	    return (match[1] || 'https') + '://player.vimeo.com/video/' + match[2] + '/';
	  }
	  return url;
	}
	
	function fillSelect(select, values) {
	  var defaultValue = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
	
	  values.forEach(function (value) {
	    var option = document.createElement('option');
	    if (value === defaultValue) {
	      option.setAttribute('selected', 'selected');
	    } else {
	      option.setAttribute('value', value);
	    }
	    select.appendChild(option);
	  });
	}
	
	exports.BaseTooltip = BaseTooltip;
	exports.default = BaseTheme;
	
	/***/ }),
	/* 44 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	Object.defineProperty(exports, "__esModule", { value: true });
	var LinkedList = /** @class */ (function () {
	    function LinkedList() {
	        this.head = this.tail = null;
	        this.length = 0;
	    }
	    LinkedList.prototype.append = function () {
	        var nodes = [];
	        for (var _i = 0; _i < arguments.length; _i++) {
	            nodes[_i] = arguments[_i];
	        }
	        this.insertBefore(nodes[0], null);
	        if (nodes.length > 1) {
	            this.append.apply(this, nodes.slice(1));
	        }
	    };
	    LinkedList.prototype.contains = function (node) {
	        var cur, next = this.iterator();
	        while ((cur = next())) {
	            if (cur === node)
	                return true;
	        }
	        return false;
	    };
	    LinkedList.prototype.insertBefore = function (node, refNode) {
	        if (!node)
	            return;
	        node.next = refNode;
	        if (refNode != null) {
	            node.prev = refNode.prev;
	            if (refNode.prev != null) {
	                refNode.prev.next = node;
	            }
	            refNode.prev = node;
	            if (refNode === this.head) {
	                this.head = node;
	            }
	        }
	        else if (this.tail != null) {
	            this.tail.next = node;
	            node.prev = this.tail;
	            this.tail = node;
	        }
	        else {
	            node.prev = null;
	            this.head = this.tail = node;
	        }
	        this.length += 1;
	    };
	    LinkedList.prototype.offset = function (target) {
	        var index = 0, cur = this.head;
	        while (cur != null) {
	            if (cur === target)
	                return index;
	            index += cur.length();
	            cur = cur.next;
	        }
	        return -1;
	    };
	    LinkedList.prototype.remove = function (node) {
	        if (!this.contains(node))
	            return;
	        if (node.prev != null)
	            node.prev.next = node.next;
	        if (node.next != null)
	            node.next.prev = node.prev;
	        if (node === this.head)
	            this.head = node.next;
	        if (node === this.tail)
	            this.tail = node.prev;
	        this.length -= 1;
	    };
	    LinkedList.prototype.iterator = function (curNode) {
	        if (curNode === void 0) { curNode = this.head; }
	        // TODO use yield when we can
	        return function () {
	            var ret = curNode;
	            if (curNode != null)
	                curNode = curNode.next;
	            return ret;
	        };
	    };
	    LinkedList.prototype.find = function (index, inclusive) {
	        if (inclusive === void 0) { inclusive = false; }
	        var cur, next = this.iterator();
	        while ((cur = next())) {
	            var length = cur.length();
	            if (index < length ||
	                (inclusive && index === length && (cur.next == null || cur.next.length() !== 0))) {
	                return [cur, index];
	            }
	            index -= length;
	        }
	        return [null, 0];
	    };
	    LinkedList.prototype.forEach = function (callback) {
	        var cur, next = this.iterator();
	        while ((cur = next())) {
	            callback(cur);
	        }
	    };
	    LinkedList.prototype.forEachAt = function (index, length, callback) {
	        if (length <= 0)
	            return;
	        var _a = this.find(index), startNode = _a[0], offset = _a[1];
	        var cur, curIndex = index - offset, next = this.iterator(startNode);
	        while ((cur = next()) && curIndex < index + length) {
	            var curLength = cur.length();
	            if (index > curIndex) {
	                callback(cur, index - curIndex, Math.min(length, curIndex + curLength - index));
	            }
	            else {
	                callback(cur, 0, Math.min(curLength, index + length - curIndex));
	            }
	            curIndex += curLength;
	        }
	    };
	    LinkedList.prototype.map = function (callback) {
	        return this.reduce(function (memo, cur) {
	            memo.push(callback(cur));
	            return memo;
	        }, []);
	    };
	    LinkedList.prototype.reduce = function (callback, memo) {
	        var cur, next = this.iterator();
	        while ((cur = next())) {
	            memo = callback(memo, cur);
	        }
	        return memo;
	    };
	    return LinkedList;
	}());
	exports.default = LinkedList;
	
	
	/***/ }),
	/* 45 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var container_1 = __webpack_require__(17);
	var Registry = __webpack_require__(1);
	var OBSERVER_CONFIG = {
	    attributes: true,
	    characterData: true,
	    characterDataOldValue: true,
	    childList: true,
	    subtree: true,
	};
	var MAX_OPTIMIZE_ITERATIONS = 100;
	var ScrollBlot = /** @class */ (function (_super) {
	    __extends(ScrollBlot, _super);
	    function ScrollBlot(node) {
	        var _this = _super.call(this, node) || this;
	        _this.scroll = _this;
	        _this.observer = new MutationObserver(function (mutations) {
	            _this.update(mutations);
	        });
	        _this.observer.observe(_this.domNode, OBSERVER_CONFIG);
	        _this.attach();
	        return _this;
	    }
	    ScrollBlot.prototype.detach = function () {
	        _super.prototype.detach.call(this);
	        this.observer.disconnect();
	    };
	    ScrollBlot.prototype.deleteAt = function (index, length) {
	        this.update();
	        if (index === 0 && length === this.length()) {
	            this.children.forEach(function (child) {
	                child.remove();
	            });
	        }
	        else {
	            _super.prototype.deleteAt.call(this, index, length);
	        }
	    };
	    ScrollBlot.prototype.formatAt = function (index, length, name, value) {
	        this.update();
	        _super.prototype.formatAt.call(this, index, length, name, value);
	    };
	    ScrollBlot.prototype.insertAt = function (index, value, def) {
	        this.update();
	        _super.prototype.insertAt.call(this, index, value, def);
	    };
	    ScrollBlot.prototype.optimize = function (mutations, context) {
	        var _this = this;
	        if (mutations === void 0) { mutations = []; }
	        if (context === void 0) { context = {}; }
	        _super.prototype.optimize.call(this, context);
	        // We must modify mutations directly, cannot make copy and then modify
	        var records = [].slice.call(this.observer.takeRecords());
	        // Array.push currently seems to be implemented by a non-tail recursive function
	        // so we cannot just mutations.push.apply(mutations, this.observer.takeRecords());
	        while (records.length > 0)
	            mutations.push(records.pop());
	        // TODO use WeakMap
	        var mark = function (blot, markParent) {
	            if (markParent === void 0) { markParent = true; }
	            if (blot == null || blot === _this)
	                return;
	            if (blot.domNode.parentNode == null)
	                return;
	            // @ts-ignore
	            if (blot.domNode[Registry.DATA_KEY].mutations == null) {
	                // @ts-ignore
	                blot.domNode[Registry.DATA_KEY].mutations = [];
	            }
	            if (markParent)
	                mark(blot.parent);
	        };
	        var optimize = function (blot) {
	            // Post-order traversal
	            if (
	            // @ts-ignore
	            blot.domNode[Registry.DATA_KEY] == null ||
	                // @ts-ignore
	                blot.domNode[Registry.DATA_KEY].mutations == null) {
	                return;
	            }
	            if (blot instanceof container_1.default) {
	                blot.children.forEach(optimize);
	            }
	            blot.optimize(context);
	        };
	        var remaining = mutations;
	        for (var i = 0; remaining.length > 0; i += 1) {
	            if (i >= MAX_OPTIMIZE_ITERATIONS) {
	                throw new Error('[Parchment] Maximum optimize iterations reached');
	            }
	            remaining.forEach(function (mutation) {
	                var blot = Registry.find(mutation.target, true);
	                if (blot == null)
	                    return;
	                if (blot.domNode === mutation.target) {
	                    if (mutation.type === 'childList') {
	                        mark(Registry.find(mutation.previousSibling, false));
	                        [].forEach.call(mutation.addedNodes, function (node) {
	                            var child = Registry.find(node, false);
	                            mark(child, false);
	                            if (child instanceof container_1.default) {
	                                child.children.forEach(function (grandChild) {
	                                    mark(grandChild, false);
	                                });
	                            }
	                        });
	                    }
	                    else if (mutation.type === 'attributes') {
	                        mark(blot.prev);
	                    }
	                }
	                mark(blot);
	            });
	            this.children.forEach(optimize);
	            remaining = [].slice.call(this.observer.takeRecords());
	            records = remaining.slice();
	            while (records.length > 0)
	                mutations.push(records.pop());
	        }
	    };
	    ScrollBlot.prototype.update = function (mutations, context) {
	        var _this = this;
	        if (context === void 0) { context = {}; }
	        mutations = mutations || this.observer.takeRecords();
	        // TODO use WeakMap
	        mutations
	            .map(function (mutation) {
	            var blot = Registry.find(mutation.target, true);
	            if (blot == null)
	                return null;
	            // @ts-ignore
	            if (blot.domNode[Registry.DATA_KEY].mutations == null) {
	                // @ts-ignore
	                blot.domNode[Registry.DATA_KEY].mutations = [mutation];
	                return blot;
	            }
	            else {
	                // @ts-ignore
	                blot.domNode[Registry.DATA_KEY].mutations.push(mutation);
	                return null;
	            }
	        })
	            .forEach(function (blot) {
	            if (blot == null ||
	                blot === _this ||
	                //@ts-ignore
	                blot.domNode[Registry.DATA_KEY] == null)
	                return;
	            // @ts-ignore
	            blot.update(blot.domNode[Registry.DATA_KEY].mutations || [], context);
	        });
	        // @ts-ignore
	        if (this.domNode[Registry.DATA_KEY].mutations != null) {
	            // @ts-ignore
	            _super.prototype.update.call(this, this.domNode[Registry.DATA_KEY].mutations, context);
	        }
	        this.optimize(mutations, context);
	    };
	    ScrollBlot.blotName = 'scroll';
	    ScrollBlot.defaultChild = 'block';
	    ScrollBlot.scope = Registry.Scope.BLOCK_BLOT;
	    ScrollBlot.tagName = 'DIV';
	    return ScrollBlot;
	}(container_1.default));
	exports.default = ScrollBlot;
	
	
	/***/ }),
	/* 46 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var format_1 = __webpack_require__(18);
	var Registry = __webpack_require__(1);
	// Shallow object comparison
	function isEqual(obj1, obj2) {
	    if (Object.keys(obj1).length !== Object.keys(obj2).length)
	        return false;
	    // @ts-ignore
	    for (var prop in obj1) {
	        // @ts-ignore
	        if (obj1[prop] !== obj2[prop])
	            return false;
	    }
	    return true;
	}
	var InlineBlot = /** @class */ (function (_super) {
	    __extends(InlineBlot, _super);
	    function InlineBlot() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    InlineBlot.formats = function (domNode) {
	        if (domNode.tagName === InlineBlot.tagName)
	            return undefined;
	        return _super.formats.call(this, domNode);
	    };
	    InlineBlot.prototype.format = function (name, value) {
	        var _this = this;
	        if (name === this.statics.blotName && !value) {
	            this.children.forEach(function (child) {
	                if (!(child instanceof format_1.default)) {
	                    child = child.wrap(InlineBlot.blotName, true);
	                }
	                _this.attributes.copy(child);
	            });
	            this.unwrap();
	        }
	        else {
	            _super.prototype.format.call(this, name, value);
	        }
	    };
	    InlineBlot.prototype.formatAt = function (index, length, name, value) {
	        if (this.formats()[name] != null || Registry.query(name, Registry.Scope.ATTRIBUTE)) {
	            var blot = this.isolate(index, length);
	            blot.format(name, value);
	        }
	        else {
	            _super.prototype.formatAt.call(this, index, length, name, value);
	        }
	    };
	    InlineBlot.prototype.optimize = function (context) {
	        _super.prototype.optimize.call(this, context);
	        var formats = this.formats();
	        if (Object.keys(formats).length === 0) {
	            return this.unwrap(); // unformatted span
	        }
	        var next = this.next;
	        if (next instanceof InlineBlot && next.prev === this && isEqual(formats, next.formats())) {
	            next.moveChildren(this);
	            next.remove();
	        }
	    };
	    InlineBlot.blotName = 'inline';
	    InlineBlot.scope = Registry.Scope.INLINE_BLOT;
	    InlineBlot.tagName = 'SPAN';
	    return InlineBlot;
	}(format_1.default));
	exports.default = InlineBlot;
	
	
	/***/ }),
	/* 47 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var format_1 = __webpack_require__(18);
	var Registry = __webpack_require__(1);
	var BlockBlot = /** @class */ (function (_super) {
	    __extends(BlockBlot, _super);
	    function BlockBlot() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    BlockBlot.formats = function (domNode) {
	        var tagName = Registry.query(BlockBlot.blotName).tagName;
	        if (domNode.tagName === tagName)
	            return undefined;
	        return _super.formats.call(this, domNode);
	    };
	    BlockBlot.prototype.format = function (name, value) {
	        if (Registry.query(name, Registry.Scope.BLOCK) == null) {
	            return;
	        }
	        else if (name === this.statics.blotName && !value) {
	            this.replaceWith(BlockBlot.blotName);
	        }
	        else {
	            _super.prototype.format.call(this, name, value);
	        }
	    };
	    BlockBlot.prototype.formatAt = function (index, length, name, value) {
	        if (Registry.query(name, Registry.Scope.BLOCK) != null) {
	            this.format(name, value);
	        }
	        else {
	            _super.prototype.formatAt.call(this, index, length, name, value);
	        }
	    };
	    BlockBlot.prototype.insertAt = function (index, value, def) {
	        if (def == null || Registry.query(value, Registry.Scope.INLINE) != null) {
	            // Insert text or inline
	            _super.prototype.insertAt.call(this, index, value, def);
	        }
	        else {
	            var after = this.split(index);
	            var blot = Registry.create(value, def);
	            after.parent.insertBefore(blot, after);
	        }
	    };
	    BlockBlot.prototype.update = function (mutations, context) {
	        if (navigator.userAgent.match(/Trident/)) {
	            this.build();
	        }
	        else {
	            _super.prototype.update.call(this, mutations, context);
	        }
	    };
	    BlockBlot.blotName = 'block';
	    BlockBlot.scope = Registry.Scope.BLOCK_BLOT;
	    BlockBlot.tagName = 'P';
	    return BlockBlot;
	}(format_1.default));
	exports.default = BlockBlot;
	
	
	/***/ }),
	/* 48 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var leaf_1 = __webpack_require__(19);
	var EmbedBlot = /** @class */ (function (_super) {
	    __extends(EmbedBlot, _super);
	    function EmbedBlot() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    EmbedBlot.formats = function (domNode) {
	        return undefined;
	    };
	    EmbedBlot.prototype.format = function (name, value) {
	        // super.formatAt wraps, which is what we want in general,
	        // but this allows subclasses to overwrite for formats
	        // that just apply to particular embeds
	        _super.prototype.formatAt.call(this, 0, this.length(), name, value);
	    };
	    EmbedBlot.prototype.formatAt = function (index, length, name, value) {
	        if (index === 0 && length === this.length()) {
	            this.format(name, value);
	        }
	        else {
	            _super.prototype.formatAt.call(this, index, length, name, value);
	        }
	    };
	    EmbedBlot.prototype.formats = function () {
	        return this.statics.formats(this.domNode);
	    };
	    return EmbedBlot;
	}(leaf_1.default));
	exports.default = EmbedBlot;
	
	
	/***/ }),
	/* 49 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var leaf_1 = __webpack_require__(19);
	var Registry = __webpack_require__(1);
	var TextBlot = /** @class */ (function (_super) {
	    __extends(TextBlot, _super);
	    function TextBlot(node) {
	        var _this = _super.call(this, node) || this;
	        _this.text = _this.statics.value(_this.domNode);
	        return _this;
	    }
	    TextBlot.create = function (value) {
	        return document.createTextNode(value);
	    };
	    TextBlot.value = function (domNode) {
	        var text = domNode.data;
	        // @ts-ignore
	        if (text['normalize'])
	            text = text['normalize']();
	        return text;
	    };
	    TextBlot.prototype.deleteAt = function (index, length) {
	        this.domNode.data = this.text = this.text.slice(0, index) + this.text.slice(index + length);
	    };
	    TextBlot.prototype.index = function (node, offset) {
	        if (this.domNode === node) {
	            return offset;
	        }
	        return -1;
	    };
	    TextBlot.prototype.insertAt = function (index, value, def) {
	        if (def == null) {
	            this.text = this.text.slice(0, index) + value + this.text.slice(index);
	            this.domNode.data = this.text;
	        }
	        else {
	            _super.prototype.insertAt.call(this, index, value, def);
	        }
	    };
	    TextBlot.prototype.length = function () {
	        return this.text.length;
	    };
	    TextBlot.prototype.optimize = function (context) {
	        _super.prototype.optimize.call(this, context);
	        this.text = this.statics.value(this.domNode);
	        if (this.text.length === 0) {
	            this.remove();
	        }
	        else if (this.next instanceof TextBlot && this.next.prev === this) {
	            this.insertAt(this.length(), this.next.value());
	            this.next.remove();
	        }
	    };
	    TextBlot.prototype.position = function (index, inclusive) {
	        if (inclusive === void 0) { inclusive = false; }
	        return [this.domNode, index];
	    };
	    TextBlot.prototype.split = function (index, force) {
	        if (force === void 0) { force = false; }
	        if (!force) {
	            if (index === 0)
	                return this;
	            if (index === this.length())
	                return this.next;
	        }
	        var after = Registry.create(this.domNode.splitText(index));
	        this.parent.insertBefore(after, this.next);
	        this.text = this.statics.value(this.domNode);
	        return after;
	    };
	    TextBlot.prototype.update = function (mutations, context) {
	        var _this = this;
	        if (mutations.some(function (mutation) {
	            return mutation.type === 'characterData' && mutation.target === _this.domNode;
	        })) {
	            this.text = this.statics.value(this.domNode);
	        }
	    };
	    TextBlot.prototype.value = function () {
	        return this.text;
	    };
	    TextBlot.blotName = 'text';
	    TextBlot.scope = Registry.Scope.INLINE_BLOT;
	    return TextBlot;
	}(leaf_1.default));
	exports.default = TextBlot;
	
	
	/***/ }),
	/* 50 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	var elem = document.createElement('div');
	elem.classList.toggle('test-class', false);
	if (elem.classList.contains('test-class')) {
	  var _toggle = DOMTokenList.prototype.toggle;
	  DOMTokenList.prototype.toggle = function (token, force) {
	    if (arguments.length > 1 && !this.contains(token) === !force) {
	      return force;
	    } else {
	      return _toggle.call(this, token);
	    }
	  };
	}
	
	if (!String.prototype.startsWith) {
	  String.prototype.startsWith = function (searchString, position) {
	    position = position || 0;
	    return this.substr(position, searchString.length) === searchString;
	  };
	}
	
	if (!String.prototype.endsWith) {
	  String.prototype.endsWith = function (searchString, position) {
	    var subjectString = this.toString();
	    if (typeof position !== 'number' || !isFinite(position) || Math.floor(position) !== position || position > subjectString.length) {
	      position = subjectString.length;
	    }
	    position -= searchString.length;
	    var lastIndex = subjectString.indexOf(searchString, position);
	    return lastIndex !== -1 && lastIndex === position;
	  };
	}
	
	if (!Array.prototype.find) {
	  Object.defineProperty(Array.prototype, "find", {
	    value: function value(predicate) {
	      if (this === null) {
	        throw new TypeError('Array.prototype.find called on null or undefined');
	      }
	      if (typeof predicate !== 'function') {
	        throw new TypeError('predicate must be a function');
	      }
	      var list = Object(this);
	      var length = list.length >>> 0;
	      var thisArg = arguments[1];
	      var value;
	
	      for (var i = 0; i < length; i++) {
	        value = list[i];
	        if (predicate.call(thisArg, value, i, list)) {
	          return value;
	        }
	      }
	      return undefined;
	    }
	  });
	}
	
	document.addEventListener("DOMContentLoaded", function () {
	  // Disable resizing in Firefox
	  document.execCommand("enableObjectResizing", false, false);
	  // Disable automatic linkifying in IE11
	  document.execCommand("autoUrlDetect", false, false);
	});
	
	/***/ }),
	/* 51 */
	/***/ (function(module, exports) {
	
	/**
	 * This library modifies the diff-patch-match library by Neil Fraser
	 * by removing the patch and match functionality and certain advanced
	 * options in the diff function. The original license is as follows:
	 *
	 * ===
	 *
	 * Diff Match and Patch
	 *
	 * Copyright 2006 Google Inc.
	 * http://code.google.com/p/google-diff-match-patch/
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	
	
	/**
	 * The data structure representing a diff is an array of tuples:
	 * [[DIFF_DELETE, 'Hello'], [DIFF_INSERT, 'Goodbye'], [DIFF_EQUAL, ' world.']]
	 * which means: delete 'Hello', add 'Goodbye' and keep ' world.'
	 */
	var DIFF_DELETE = -1;
	var DIFF_INSERT = 1;
	var DIFF_EQUAL = 0;
	
	
	/**
	 * Find the differences between two texts.  Simplifies the problem by stripping
	 * any common prefix or suffix off the texts before diffing.
	 * @param {string} text1 Old string to be diffed.
	 * @param {string} text2 New string to be diffed.
	 * @param {Int} cursor_pos Expected edit position in text1 (optional)
	 * @return {Array} Array of diff tuples.
	 */
	function diff_main(text1, text2, cursor_pos) {
	  // Check for equality (speedup).
	  if (text1 == text2) {
	    if (text1) {
	      return [[DIFF_EQUAL, text1]];
	    }
	    return [];
	  }
	
	  // Check cursor_pos within bounds
	  if (cursor_pos < 0 || text1.length < cursor_pos) {
	    cursor_pos = null;
	  }
	
	  // Trim off common prefix (speedup).
	  var commonlength = diff_commonPrefix(text1, text2);
	  var commonprefix = text1.substring(0, commonlength);
	  text1 = text1.substring(commonlength);
	  text2 = text2.substring(commonlength);
	
	  // Trim off common suffix (speedup).
	  commonlength = diff_commonSuffix(text1, text2);
	  var commonsuffix = text1.substring(text1.length - commonlength);
	  text1 = text1.substring(0, text1.length - commonlength);
	  text2 = text2.substring(0, text2.length - commonlength);
	
	  // Compute the diff on the middle block.
	  var diffs = diff_compute_(text1, text2);
	
	  // Restore the prefix and suffix.
	  if (commonprefix) {
	    diffs.unshift([DIFF_EQUAL, commonprefix]);
	  }
	  if (commonsuffix) {
	    diffs.push([DIFF_EQUAL, commonsuffix]);
	  }
	  diff_cleanupMerge(diffs);
	  if (cursor_pos != null) {
	    diffs = fix_cursor(diffs, cursor_pos);
	  }
	  diffs = fix_emoji(diffs);
	  return diffs;
	};
	
	
	/**
	 * Find the differences between two texts.  Assumes that the texts do not
	 * have any common prefix or suffix.
	 * @param {string} text1 Old string to be diffed.
	 * @param {string} text2 New string to be diffed.
	 * @return {Array} Array of diff tuples.
	 */
	function diff_compute_(text1, text2) {
	  var diffs;
	
	  if (!text1) {
	    // Just add some text (speedup).
	    return [[DIFF_INSERT, text2]];
	  }
	
	  if (!text2) {
	    // Just delete some text (speedup).
	    return [[DIFF_DELETE, text1]];
	  }
	
	  var longtext = text1.length > text2.length ? text1 : text2;
	  var shorttext = text1.length > text2.length ? text2 : text1;
	  var i = longtext.indexOf(shorttext);
	  if (i != -1) {
	    // Shorter text is inside the longer text (speedup).
	    diffs = [[DIFF_INSERT, longtext.substring(0, i)],
	             [DIFF_EQUAL, shorttext],
	             [DIFF_INSERT, longtext.substring(i + shorttext.length)]];
	    // Swap insertions for deletions if diff is reversed.
	    if (text1.length > text2.length) {
	      diffs[0][0] = diffs[2][0] = DIFF_DELETE;
	    }
	    return diffs;
	  }
	
	  if (shorttext.length == 1) {
	    // Single character string.
	    // After the previous speedup, the character can't be an equality.
	    return [[DIFF_DELETE, text1], [DIFF_INSERT, text2]];
	  }
	
	  // Check to see if the problem can be split in two.
	  var hm = diff_halfMatch_(text1, text2);
	  if (hm) {
	    // A half-match was found, sort out the return data.
	    var text1_a = hm[0];
	    var text1_b = hm[1];
	    var text2_a = hm[2];
	    var text2_b = hm[3];
	    var mid_common = hm[4];
	    // Send both pairs off for separate processing.
	    var diffs_a = diff_main(text1_a, text2_a);
	    var diffs_b = diff_main(text1_b, text2_b);
	    // Merge the results.
	    return diffs_a.concat([[DIFF_EQUAL, mid_common]], diffs_b);
	  }
	
	  return diff_bisect_(text1, text2);
	};
	
	
	/**
	 * Find the 'middle snake' of a diff, split the problem in two
	 * and return the recursively constructed diff.
	 * See Myers 1986 paper: An O(ND) Difference Algorithm and Its Variations.
	 * @param {string} text1 Old string to be diffed.
	 * @param {string} text2 New string to be diffed.
	 * @return {Array} Array of diff tuples.
	 * @private
	 */
	function diff_bisect_(text1, text2) {
	  // Cache the text lengths to prevent multiple calls.
	  var text1_length = text1.length;
	  var text2_length = text2.length;
	  var max_d = Math.ceil((text1_length + text2_length) / 2);
	  var v_offset = max_d;
	  var v_length = 2 * max_d;
	  var v1 = new Array(v_length);
	  var v2 = new Array(v_length);
	  // Setting all elements to -1 is faster in Chrome & Firefox than mixing
	  // integers and undefined.
	  for (var x = 0; x < v_length; x++) {
	    v1[x] = -1;
	    v2[x] = -1;
	  }
	  v1[v_offset + 1] = 0;
	  v2[v_offset + 1] = 0;
	  var delta = text1_length - text2_length;
	  // If the total number of characters is odd, then the front path will collide
	  // with the reverse path.
	  var front = (delta % 2 != 0);
	  // Offsets for start and end of k loop.
	  // Prevents mapping of space beyond the grid.
	  var k1start = 0;
	  var k1end = 0;
	  var k2start = 0;
	  var k2end = 0;
	  for (var d = 0; d < max_d; d++) {
	    // Walk the front path one step.
	    for (var k1 = -d + k1start; k1 <= d - k1end; k1 += 2) {
	      var k1_offset = v_offset + k1;
	      var x1;
	      if (k1 == -d || (k1 != d && v1[k1_offset - 1] < v1[k1_offset + 1])) {
	        x1 = v1[k1_offset + 1];
	      } else {
	        x1 = v1[k1_offset - 1] + 1;
	      }
	      var y1 = x1 - k1;
	      while (x1 < text1_length && y1 < text2_length &&
	             text1.charAt(x1) == text2.charAt(y1)) {
	        x1++;
	        y1++;
	      }
	      v1[k1_offset] = x1;
	      if (x1 > text1_length) {
	        // Ran off the right of the graph.
	        k1end += 2;
	      } else if (y1 > text2_length) {
	        // Ran off the bottom of the graph.
	        k1start += 2;
	      } else if (front) {
	        var k2_offset = v_offset + delta - k1;
	        if (k2_offset >= 0 && k2_offset < v_length && v2[k2_offset] != -1) {
	          // Mirror x2 onto top-left coordinate system.
	          var x2 = text1_length - v2[k2_offset];
	          if (x1 >= x2) {
	            // Overlap detected.
	            return diff_bisectSplit_(text1, text2, x1, y1);
	          }
	        }
	      }
	    }
	
	    // Walk the reverse path one step.
	    for (var k2 = -d + k2start; k2 <= d - k2end; k2 += 2) {
	      var k2_offset = v_offset + k2;
	      var x2;
	      if (k2 == -d || (k2 != d && v2[k2_offset - 1] < v2[k2_offset + 1])) {
	        x2 = v2[k2_offset + 1];
	      } else {
	        x2 = v2[k2_offset - 1] + 1;
	      }
	      var y2 = x2 - k2;
	      while (x2 < text1_length && y2 < text2_length &&
	             text1.charAt(text1_length - x2 - 1) ==
	             text2.charAt(text2_length - y2 - 1)) {
	        x2++;
	        y2++;
	      }
	      v2[k2_offset] = x2;
	      if (x2 > text1_length) {
	        // Ran off the left of the graph.
	        k2end += 2;
	      } else if (y2 > text2_length) {
	        // Ran off the top of the graph.
	        k2start += 2;
	      } else if (!front) {
	        var k1_offset = v_offset + delta - k2;
	        if (k1_offset >= 0 && k1_offset < v_length && v1[k1_offset] != -1) {
	          var x1 = v1[k1_offset];
	          var y1 = v_offset + x1 - k1_offset;
	          // Mirror x2 onto top-left coordinate system.
	          x2 = text1_length - x2;
	          if (x1 >= x2) {
	            // Overlap detected.
	            return diff_bisectSplit_(text1, text2, x1, y1);
	          }
	        }
	      }
	    }
	  }
	  // Diff took too long and hit the deadline or
	  // number of diffs equals number of characters, no commonality at all.
	  return [[DIFF_DELETE, text1], [DIFF_INSERT, text2]];
	};
	
	
	/**
	 * Given the location of the 'middle snake', split the diff in two parts
	 * and recurse.
	 * @param {string} text1 Old string to be diffed.
	 * @param {string} text2 New string to be diffed.
	 * @param {number} x Index of split point in text1.
	 * @param {number} y Index of split point in text2.
	 * @return {Array} Array of diff tuples.
	 */
	function diff_bisectSplit_(text1, text2, x, y) {
	  var text1a = text1.substring(0, x);
	  var text2a = text2.substring(0, y);
	  var text1b = text1.substring(x);
	  var text2b = text2.substring(y);
	
	  // Compute both diffs serially.
	  var diffs = diff_main(text1a, text2a);
	  var diffsb = diff_main(text1b, text2b);
	
	  return diffs.concat(diffsb);
	};
	
	
	/**
	 * Determine the common prefix of two strings.
	 * @param {string} text1 First string.
	 * @param {string} text2 Second string.
	 * @return {number} The number of characters common to the start of each
	 *     string.
	 */
	function diff_commonPrefix(text1, text2) {
	  // Quick check for common null cases.
	  if (!text1 || !text2 || text1.charAt(0) != text2.charAt(0)) {
	    return 0;
	  }
	  // Binary search.
	  // Performance analysis: http://neil.fraser.name/news/2007/10/09/
	  var pointermin = 0;
	  var pointermax = Math.min(text1.length, text2.length);
	  var pointermid = pointermax;
	  var pointerstart = 0;
	  while (pointermin < pointermid) {
	    if (text1.substring(pointerstart, pointermid) ==
	        text2.substring(pointerstart, pointermid)) {
	      pointermin = pointermid;
	      pointerstart = pointermin;
	    } else {
	      pointermax = pointermid;
	    }
	    pointermid = Math.floor((pointermax - pointermin) / 2 + pointermin);
	  }
	  return pointermid;
	};
	
	
	/**
	 * Determine the common suffix of two strings.
	 * @param {string} text1 First string.
	 * @param {string} text2 Second string.
	 * @return {number} The number of characters common to the end of each string.
	 */
	function diff_commonSuffix(text1, text2) {
	  // Quick check for common null cases.
	  if (!text1 || !text2 ||
	      text1.charAt(text1.length - 1) != text2.charAt(text2.length - 1)) {
	    return 0;
	  }
	  // Binary search.
	  // Performance analysis: http://neil.fraser.name/news/2007/10/09/
	  var pointermin = 0;
	  var pointermax = Math.min(text1.length, text2.length);
	  var pointermid = pointermax;
	  var pointerend = 0;
	  while (pointermin < pointermid) {
	    if (text1.substring(text1.length - pointermid, text1.length - pointerend) ==
	        text2.substring(text2.length - pointermid, text2.length - pointerend)) {
	      pointermin = pointermid;
	      pointerend = pointermin;
	    } else {
	      pointermax = pointermid;
	    }
	    pointermid = Math.floor((pointermax - pointermin) / 2 + pointermin);
	  }
	  return pointermid;
	};
	
	
	/**
	 * Do the two texts share a substring which is at least half the length of the
	 * longer text?
	 * This speedup can produce non-minimal diffs.
	 * @param {string} text1 First string.
	 * @param {string} text2 Second string.
	 * @return {Array.<string>} Five element Array, containing the prefix of
	 *     text1, the suffix of text1, the prefix of text2, the suffix of
	 *     text2 and the common middle.  Or null if there was no match.
	 */
	function diff_halfMatch_(text1, text2) {
	  var longtext = text1.length > text2.length ? text1 : text2;
	  var shorttext = text1.length > text2.length ? text2 : text1;
	  if (longtext.length < 4 || shorttext.length * 2 < longtext.length) {
	    return null;  // Pointless.
	  }
	
	  /**
	   * Does a substring of shorttext exist within longtext such that the substring
	   * is at least half the length of longtext?
	   * Closure, but does not reference any external variables.
	   * @param {string} longtext Longer string.
	   * @param {string} shorttext Shorter string.
	   * @param {number} i Start index of quarter length substring within longtext.
	   * @return {Array.<string>} Five element Array, containing the prefix of
	   *     longtext, the suffix of longtext, the prefix of shorttext, the suffix
	   *     of shorttext and the common middle.  Or null if there was no match.
	   * @private
	   */
	  function diff_halfMatchI_(longtext, shorttext, i) {
	    // Start with a 1/4 length substring at position i as a seed.
	    var seed = longtext.substring(i, i + Math.floor(longtext.length / 4));
	    var j = -1;
	    var best_common = '';
	    var best_longtext_a, best_longtext_b, best_shorttext_a, best_shorttext_b;
	    while ((j = shorttext.indexOf(seed, j + 1)) != -1) {
	      var prefixLength = diff_commonPrefix(longtext.substring(i),
	                                           shorttext.substring(j));
	      var suffixLength = diff_commonSuffix(longtext.substring(0, i),
	                                           shorttext.substring(0, j));
	      if (best_common.length < suffixLength + prefixLength) {
	        best_common = shorttext.substring(j - suffixLength, j) +
	            shorttext.substring(j, j + prefixLength);
	        best_longtext_a = longtext.substring(0, i - suffixLength);
	        best_longtext_b = longtext.substring(i + prefixLength);
	        best_shorttext_a = shorttext.substring(0, j - suffixLength);
	        best_shorttext_b = shorttext.substring(j + prefixLength);
	      }
	    }
	    if (best_common.length * 2 >= longtext.length) {
	      return [best_longtext_a, best_longtext_b,
	              best_shorttext_a, best_shorttext_b, best_common];
	    } else {
	      return null;
	    }
	  }
	
	  // First check if the second quarter is the seed for a half-match.
	  var hm1 = diff_halfMatchI_(longtext, shorttext,
	                             Math.ceil(longtext.length / 4));
	  // Check again based on the third quarter.
	  var hm2 = diff_halfMatchI_(longtext, shorttext,
	                             Math.ceil(longtext.length / 2));
	  var hm;
	  if (!hm1 && !hm2) {
	    return null;
	  } else if (!hm2) {
	    hm = hm1;
	  } else if (!hm1) {
	    hm = hm2;
	  } else {
	    // Both matched.  Select the longest.
	    hm = hm1[4].length > hm2[4].length ? hm1 : hm2;
	  }
	
	  // A half-match was found, sort out the return data.
	  var text1_a, text1_b, text2_a, text2_b;
	  if (text1.length > text2.length) {
	    text1_a = hm[0];
	    text1_b = hm[1];
	    text2_a = hm[2];
	    text2_b = hm[3];
	  } else {
	    text2_a = hm[0];
	    text2_b = hm[1];
	    text1_a = hm[2];
	    text1_b = hm[3];
	  }
	  var mid_common = hm[4];
	  return [text1_a, text1_b, text2_a, text2_b, mid_common];
	};
	
	
	/**
	 * Reorder and merge like edit sections.  Merge equalities.
	 * Any edit section can move as long as it doesn't cross an equality.
	 * @param {Array} diffs Array of diff tuples.
	 */
	function diff_cleanupMerge(diffs) {
	  diffs.push([DIFF_EQUAL, '']);  // Add a dummy entry at the end.
	  var pointer = 0;
	  var count_delete = 0;
	  var count_insert = 0;
	  var text_delete = '';
	  var text_insert = '';
	  var commonlength;
	  while (pointer < diffs.length) {
	    switch (diffs[pointer][0]) {
	      case DIFF_INSERT:
	        count_insert++;
	        text_insert += diffs[pointer][1];
	        pointer++;
	        break;
	      case DIFF_DELETE:
	        count_delete++;
	        text_delete += diffs[pointer][1];
	        pointer++;
	        break;
	      case DIFF_EQUAL:
	        // Upon reaching an equality, check for prior redundancies.
	        if (count_delete + count_insert > 1) {
	          if (count_delete !== 0 && count_insert !== 0) {
	            // Factor out any common prefixies.
	            commonlength = diff_commonPrefix(text_insert, text_delete);
	            if (commonlength !== 0) {
	              if ((pointer - count_delete - count_insert) > 0 &&
	                  diffs[pointer - count_delete - count_insert - 1][0] ==
	                  DIFF_EQUAL) {
	                diffs[pointer - count_delete - count_insert - 1][1] +=
	                    text_insert.substring(0, commonlength);
	              } else {
	                diffs.splice(0, 0, [DIFF_EQUAL,
	                                    text_insert.substring(0, commonlength)]);
	                pointer++;
	              }
	              text_insert = text_insert.substring(commonlength);
	              text_delete = text_delete.substring(commonlength);
	            }
	            // Factor out any common suffixies.
	            commonlength = diff_commonSuffix(text_insert, text_delete);
	            if (commonlength !== 0) {
	              diffs[pointer][1] = text_insert.substring(text_insert.length -
	                  commonlength) + diffs[pointer][1];
	              text_insert = text_insert.substring(0, text_insert.length -
	                  commonlength);
	              text_delete = text_delete.substring(0, text_delete.length -
	                  commonlength);
	            }
	          }
	          // Delete the offending records and add the merged ones.
	          if (count_delete === 0) {
	            diffs.splice(pointer - count_insert,
	                count_delete + count_insert, [DIFF_INSERT, text_insert]);
	          } else if (count_insert === 0) {
	            diffs.splice(pointer - count_delete,
	                count_delete + count_insert, [DIFF_DELETE, text_delete]);
	          } else {
	            diffs.splice(pointer - count_delete - count_insert,
	                count_delete + count_insert, [DIFF_DELETE, text_delete],
	                [DIFF_INSERT, text_insert]);
	          }
	          pointer = pointer - count_delete - count_insert +
	                    (count_delete ? 1 : 0) + (count_insert ? 1 : 0) + 1;
	        } else if (pointer !== 0 && diffs[pointer - 1][0] == DIFF_EQUAL) {
	          // Merge this equality with the previous one.
	          diffs[pointer - 1][1] += diffs[pointer][1];
	          diffs.splice(pointer, 1);
	        } else {
	          pointer++;
	        }
	        count_insert = 0;
	        count_delete = 0;
	        text_delete = '';
	        text_insert = '';
	        break;
	    }
	  }
	  if (diffs[diffs.length - 1][1] === '') {
	    diffs.pop();  // Remove the dummy entry at the end.
	  }
	
	  // Second pass: look for single edits surrounded on both sides by equalities
	  // which can be shifted sideways to eliminate an equality.
	  // e.g: A<ins>BA</ins>C -> <ins>AB</ins>AC
	  var changes = false;
	  pointer = 1;
	  // Intentionally ignore the first and last element (don't need checking).
	  while (pointer < diffs.length - 1) {
	    if (diffs[pointer - 1][0] == DIFF_EQUAL &&
	        diffs[pointer + 1][0] == DIFF_EQUAL) {
	      // This is a single edit surrounded by equalities.
	      if (diffs[pointer][1].substring(diffs[pointer][1].length -
	          diffs[pointer - 1][1].length) == diffs[pointer - 1][1]) {
	        // Shift the edit over the previous equality.
	        diffs[pointer][1] = diffs[pointer - 1][1] +
	            diffs[pointer][1].substring(0, diffs[pointer][1].length -
	                                        diffs[pointer - 1][1].length);
	        diffs[pointer + 1][1] = diffs[pointer - 1][1] + diffs[pointer + 1][1];
	        diffs.splice(pointer - 1, 1);
	        changes = true;
	      } else if (diffs[pointer][1].substring(0, diffs[pointer + 1][1].length) ==
	          diffs[pointer + 1][1]) {
	        // Shift the edit over the next equality.
	        diffs[pointer - 1][1] += diffs[pointer + 1][1];
	        diffs[pointer][1] =
	            diffs[pointer][1].substring(diffs[pointer + 1][1].length) +
	            diffs[pointer + 1][1];
	        diffs.splice(pointer + 1, 1);
	        changes = true;
	      }
	    }
	    pointer++;
	  }
	  // If shifts were made, the diff needs reordering and another shift sweep.
	  if (changes) {
	    diff_cleanupMerge(diffs);
	  }
	};
	
	
	var diff = diff_main;
	diff.INSERT = DIFF_INSERT;
	diff.DELETE = DIFF_DELETE;
	diff.EQUAL = DIFF_EQUAL;
	
	module.exports = diff;
	
	/*
	 * Modify a diff such that the cursor position points to the start of a change:
	 * E.g.
	 *   cursor_normalize_diff([[DIFF_EQUAL, 'abc']], 1)
	 *     => [1, [[DIFF_EQUAL, 'a'], [DIFF_EQUAL, 'bc']]]
	 *   cursor_normalize_diff([[DIFF_INSERT, 'new'], [DIFF_DELETE, 'xyz']], 2)
	 *     => [2, [[DIFF_INSERT, 'new'], [DIFF_DELETE, 'xy'], [DIFF_DELETE, 'z']]]
	 *
	 * @param {Array} diffs Array of diff tuples
	 * @param {Int} cursor_pos Suggested edit position. Must not be out of bounds!
	 * @return {Array} A tuple [cursor location in the modified diff, modified diff]
	 */
	function cursor_normalize_diff (diffs, cursor_pos) {
	  if (cursor_pos === 0) {
	    return [DIFF_EQUAL, diffs];
	  }
	  for (var current_pos = 0, i = 0; i < diffs.length; i++) {
	    var d = diffs[i];
	    if (d[0] === DIFF_DELETE || d[0] === DIFF_EQUAL) {
	      var next_pos = current_pos + d[1].length;
	      if (cursor_pos === next_pos) {
	        return [i + 1, diffs];
	      } else if (cursor_pos < next_pos) {
	        // copy to prevent side effects
	        diffs = diffs.slice();
	        // split d into two diff changes
	        var split_pos = cursor_pos - current_pos;
	        var d_left = [d[0], d[1].slice(0, split_pos)];
	        var d_right = [d[0], d[1].slice(split_pos)];
	        diffs.splice(i, 1, d_left, d_right);
	        return [i + 1, diffs];
	      } else {
	        current_pos = next_pos;
	      }
	    }
	  }
	  throw new Error('cursor_pos is out of bounds!')
	}
	
	/*
	 * Modify a diff such that the edit position is "shifted" to the proposed edit location (cursor_position).
	 *
	 * Case 1)
	 *   Check if a naive shift is possible:
	 *     [0, X], [ 1, Y] -> [ 1, Y], [0, X]    (if X + Y === Y + X)
	 *     [0, X], [-1, Y] -> [-1, Y], [0, X]    (if X + Y === Y + X) - holds same result
	 * Case 2)
	 *   Check if the following shifts are possible:
	 *     [0, 'pre'], [ 1, 'prefix'] -> [ 1, 'pre'], [0, 'pre'], [ 1, 'fix']
	 *     [0, 'pre'], [-1, 'prefix'] -> [-1, 'pre'], [0, 'pre'], [-1, 'fix']
	 *         ^            ^
	 *         d          d_next
	 *
	 * @param {Array} diffs Array of diff tuples
	 * @param {Int} cursor_pos Suggested edit position. Must not be out of bounds!
	 * @return {Array} Array of diff tuples
	 */
	function fix_cursor (diffs, cursor_pos) {
	  var norm = cursor_normalize_diff(diffs, cursor_pos);
	  var ndiffs = norm[1];
	  var cursor_pointer = norm[0];
	  var d = ndiffs[cursor_pointer];
	  var d_next = ndiffs[cursor_pointer + 1];
	
	  if (d == null) {
	    // Text was deleted from end of original string,
	    // cursor is now out of bounds in new string
	    return diffs;
	  } else if (d[0] !== DIFF_EQUAL) {
	    // A modification happened at the cursor location.
	    // This is the expected outcome, so we can return the original diff.
	    return diffs;
	  } else {
	    if (d_next != null && d[1] + d_next[1] === d_next[1] + d[1]) {
	      // Case 1)
	      // It is possible to perform a naive shift
	      ndiffs.splice(cursor_pointer, 2, d_next, d)
	      return merge_tuples(ndiffs, cursor_pointer, 2)
	    } else if (d_next != null && d_next[1].indexOf(d[1]) === 0) {
	      // Case 2)
	      // d[1] is a prefix of d_next[1]
	      // We can assume that d_next[0] !== 0, since d[0] === 0
	      // Shift edit locations..
	      ndiffs.splice(cursor_pointer, 2, [d_next[0], d[1]], [0, d[1]]);
	      var suffix = d_next[1].slice(d[1].length);
	      if (suffix.length > 0) {
	        ndiffs.splice(cursor_pointer + 2, 0, [d_next[0], suffix]);
	      }
	      return merge_tuples(ndiffs, cursor_pointer, 3)
	    } else {
	      // Not possible to perform any modification
	      return diffs;
	    }
	  }
	}
	
	/*
	 * Check diff did not split surrogate pairs.
	 * Ex. [0, '\uD83D'], [-1, '\uDC36'], [1, '\uDC2F'] -> [-1, '\uD83D\uDC36'], [1, '\uD83D\uDC2F']
	 *     '\uD83D\uDC36' === '🐶', '\uD83D\uDC2F' === '🐯'
	 *
	 * @param {Array} diffs Array of diff tuples
	 * @return {Array} Array of diff tuples
	 */
	function fix_emoji (diffs) {
	  var compact = false;
	  var starts_with_pair_end = function(str) {
	    return str.charCodeAt(0) >= 0xDC00 && str.charCodeAt(0) <= 0xDFFF;
	  }
	  var ends_with_pair_start = function(str) {
	    return str.charCodeAt(str.length-1) >= 0xD800 && str.charCodeAt(str.length-1) <= 0xDBFF;
	  }
	  for (var i = 2; i < diffs.length; i += 1) {
	    if (diffs[i-2][0] === DIFF_EQUAL && ends_with_pair_start(diffs[i-2][1]) &&
	        diffs[i-1][0] === DIFF_DELETE && starts_with_pair_end(diffs[i-1][1]) &&
	        diffs[i][0] === DIFF_INSERT && starts_with_pair_end(diffs[i][1])) {
	      compact = true;
	
	      diffs[i-1][1] = diffs[i-2][1].slice(-1) + diffs[i-1][1];
	      diffs[i][1] = diffs[i-2][1].slice(-1) + diffs[i][1];
	
	      diffs[i-2][1] = diffs[i-2][1].slice(0, -1);
	    }
	  }
	  if (!compact) {
	    return diffs;
	  }
	  var fixed_diffs = [];
	  for (var i = 0; i < diffs.length; i += 1) {
	    if (diffs[i][1].length > 0) {
	      fixed_diffs.push(diffs[i]);
	    }
	  }
	  return fixed_diffs;
	}
	
	/*
	 * Try to merge tuples with their neigbors in a given range.
	 * E.g. [0, 'a'], [0, 'b'] -> [0, 'ab']
	 *
	 * @param {Array} diffs Array of diff tuples.
	 * @param {Int} start Position of the first element to merge (diffs[start] is also merged with diffs[start - 1]).
	 * @param {Int} length Number of consecutive elements to check.
	 * @return {Array} Array of merged diff tuples.
	 */
	function merge_tuples (diffs, start, length) {
	  // Check from (start-1) to (start+length).
	  for (var i = start + length - 1; i >= 0 && i >= start - 1; i--) {
	    if (i + 1 < diffs.length) {
	      var left_d = diffs[i];
	      var right_d = diffs[i+1];
	      if (left_d[0] === right_d[1]) {
	        diffs.splice(i, 2, [left_d[0], left_d[1] + right_d[1]]);
	      }
	    }
	  }
	  return diffs;
	}
	
	
	/***/ }),
	/* 52 */
	/***/ (function(module, exports) {
	
	exports = module.exports = typeof Object.keys === 'function'
	  ? Object.keys : shim;
	
	exports.shim = shim;
	function shim (obj) {
	  var keys = [];
	  for (var key in obj) keys.push(key);
	  return keys;
	}
	
	
	/***/ }),
	/* 53 */
	/***/ (function(module, exports) {
	
	var supportsArgumentsClass = (function(){
	  return Object.prototype.toString.call(arguments)
	})() == '[object Arguments]';
	
	exports = module.exports = supportsArgumentsClass ? supported : unsupported;
	
	exports.supported = supported;
	function supported(object) {
	  return Object.prototype.toString.call(object) == '[object Arguments]';
	};
	
	exports.unsupported = unsupported;
	function unsupported(object){
	  return object &&
	    typeof object == 'object' &&
	    typeof object.length == 'number' &&
	    Object.prototype.hasOwnProperty.call(object, 'callee') &&
	    !Object.prototype.propertyIsEnumerable.call(object, 'callee') ||
	    false;
	};
	
	
	/***/ }),
	/* 54 */
	/***/ (function(module, exports) {
	
	'use strict';
	
	var has = Object.prototype.hasOwnProperty
	  , prefix = '~';
	
	/**
	 * Constructor to create a storage for our `EE` objects.
	 * An `Events` instance is a plain object whose properties are event names.
	 *
	 * @constructor
	 * @api private
	 */
	function Events() {}
	
	//
	// We try to not inherit from `Object.prototype`. In some engines creating an
	// instance in this way is faster than calling `Object.create(null)` directly.
	// If `Object.create(null)` is not supported we prefix the event names with a
	// character to make sure that the built-in object properties are not
	// overridden or used as an attack vector.
	//
	if (Object.create) {
	  Events.prototype = Object.create(null);
	
	  //
	  // This hack is needed because the `__proto__` property is still inherited in
	  // some old browsers like Android 4, iPhone 5.1, Opera 11 and Safari 5.
	  //
	  if (!new Events().__proto__) prefix = false;
	}
	
	/**
	 * Representation of a single event listener.
	 *
	 * @param {Function} fn The listener function.
	 * @param {Mixed} context The context to invoke the listener with.
	 * @param {Boolean} [once=false] Specify if the listener is a one-time listener.
	 * @constructor
	 * @api private
	 */
	function EE(fn, context, once) {
	  this.fn = fn;
	  this.context = context;
	  this.once = once || false;
	}
	
	/**
	 * Minimal `EventEmitter` interface that is molded against the Node.js
	 * `EventEmitter` interface.
	 *
	 * @constructor
	 * @api public
	 */
	function EventEmitter() {
	  this._events = new Events();
	  this._eventsCount = 0;
	}
	
	/**
	 * Return an array listing the events for which the emitter has registered
	 * listeners.
	 *
	 * @returns {Array}
	 * @api public
	 */
	EventEmitter.prototype.eventNames = function eventNames() {
	  var names = []
	    , events
	    , name;
	
	  if (this._eventsCount === 0) return names;
	
	  for (name in (events = this._events)) {
	    if (has.call(events, name)) names.push(prefix ? name.slice(1) : name);
	  }
	
	  if (Object.getOwnPropertySymbols) {
	    return names.concat(Object.getOwnPropertySymbols(events));
	  }
	
	  return names;
	};
	
	/**
	 * Return the listeners registered for a given event.
	 *
	 * @param {String|Symbol} event The event name.
	 * @param {Boolean} exists Only check if there are listeners.
	 * @returns {Array|Boolean}
	 * @api public
	 */
	EventEmitter.prototype.listeners = function listeners(event, exists) {
	  var evt = prefix ? prefix + event : event
	    , available = this._events[evt];
	
	  if (exists) return !!available;
	  if (!available) return [];
	  if (available.fn) return [available.fn];
	
	  for (var i = 0, l = available.length, ee = new Array(l); i < l; i++) {
	    ee[i] = available[i].fn;
	  }
	
	  return ee;
	};
	
	/**
	 * Calls each of the listeners registered for a given event.
	 *
	 * @param {String|Symbol} event The event name.
	 * @returns {Boolean} `true` if the event had listeners, else `false`.
	 * @api public
	 */
	EventEmitter.prototype.emit = function emit(event, a1, a2, a3, a4, a5) {
	  var evt = prefix ? prefix + event : event;
	
	  if (!this._events[evt]) return false;
	
	  var listeners = this._events[evt]
	    , len = arguments.length
	    , args
	    , i;
	
	  if (listeners.fn) {
	    if (listeners.once) this.removeListener(event, listeners.fn, undefined, true);
	
	    switch (len) {
	      case 1: return listeners.fn.call(listeners.context), true;
	      case 2: return listeners.fn.call(listeners.context, a1), true;
	      case 3: return listeners.fn.call(listeners.context, a1, a2), true;
	      case 4: return listeners.fn.call(listeners.context, a1, a2, a3), true;
	      case 5: return listeners.fn.call(listeners.context, a1, a2, a3, a4), true;
	      case 6: return listeners.fn.call(listeners.context, a1, a2, a3, a4, a5), true;
	    }
	
	    for (i = 1, args = new Array(len -1); i < len; i++) {
	      args[i - 1] = arguments[i];
	    }
	
	    listeners.fn.apply(listeners.context, args);
	  } else {
	    var length = listeners.length
	      , j;
	
	    for (i = 0; i < length; i++) {
	      if (listeners[i].once) this.removeListener(event, listeners[i].fn, undefined, true);
	
	      switch (len) {
	        case 1: listeners[i].fn.call(listeners[i].context); break;
	        case 2: listeners[i].fn.call(listeners[i].context, a1); break;
	        case 3: listeners[i].fn.call(listeners[i].context, a1, a2); break;
	        case 4: listeners[i].fn.call(listeners[i].context, a1, a2, a3); break;
	        default:
	          if (!args) for (j = 1, args = new Array(len -1); j < len; j++) {
	            args[j - 1] = arguments[j];
	          }
	
	          listeners[i].fn.apply(listeners[i].context, args);
	      }
	    }
	  }
	
	  return true;
	};
	
	/**
	 * Add a listener for a given event.
	 *
	 * @param {String|Symbol} event The event name.
	 * @param {Function} fn The listener function.
	 * @param {Mixed} [context=this] The context to invoke the listener with.
	 * @returns {EventEmitter} `this`.
	 * @api public
	 */
	EventEmitter.prototype.on = function on(event, fn, context) {
	  var listener = new EE(fn, context || this)
	    , evt = prefix ? prefix + event : event;
	
	  if (!this._events[evt]) this._events[evt] = listener, this._eventsCount++;
	  else if (!this._events[evt].fn) this._events[evt].push(listener);
	  else this._events[evt] = [this._events[evt], listener];
	
	  return this;
	};
	
	/**
	 * Add a one-time listener for a given event.
	 *
	 * @param {String|Symbol} event The event name.
	 * @param {Function} fn The listener function.
	 * @param {Mixed} [context=this] The context to invoke the listener with.
	 * @returns {EventEmitter} `this`.
	 * @api public
	 */
	EventEmitter.prototype.once = function once(event, fn, context) {
	  var listener = new EE(fn, context || this, true)
	    , evt = prefix ? prefix + event : event;
	
	  if (!this._events[evt]) this._events[evt] = listener, this._eventsCount++;
	  else if (!this._events[evt].fn) this._events[evt].push(listener);
	  else this._events[evt] = [this._events[evt], listener];
	
	  return this;
	};
	
	/**
	 * Remove the listeners of a given event.
	 *
	 * @param {String|Symbol} event The event name.
	 * @param {Function} fn Only remove the listeners that match this function.
	 * @param {Mixed} context Only remove the listeners that have this context.
	 * @param {Boolean} once Only remove one-time listeners.
	 * @returns {EventEmitter} `this`.
	 * @api public
	 */
	EventEmitter.prototype.removeListener = function removeListener(event, fn, context, once) {
	  var evt = prefix ? prefix + event : event;
	
	  if (!this._events[evt]) return this;
	  if (!fn) {
	    if (--this._eventsCount === 0) this._events = new Events();
	    else delete this._events[evt];
	    return this;
	  }
	
	  var listeners = this._events[evt];
	
	  if (listeners.fn) {
	    if (
	         listeners.fn === fn
	      && (!once || listeners.once)
	      && (!context || listeners.context === context)
	    ) {
	      if (--this._eventsCount === 0) this._events = new Events();
	      else delete this._events[evt];
	    }
	  } else {
	    for (var i = 0, events = [], length = listeners.length; i < length; i++) {
	      if (
	           listeners[i].fn !== fn
	        || (once && !listeners[i].once)
	        || (context && listeners[i].context !== context)
	      ) {
	        events.push(listeners[i]);
	      }
	    }
	
	    //
	    // Reset the array, or remove it completely if we have no more listeners.
	    //
	    if (events.length) this._events[evt] = events.length === 1 ? events[0] : events;
	    else if (--this._eventsCount === 0) this._events = new Events();
	    else delete this._events[evt];
	  }
	
	  return this;
	};
	
	/**
	 * Remove all listeners, or those of the specified event.
	 *
	 * @param {String|Symbol} [event] The event name.
	 * @returns {EventEmitter} `this`.
	 * @api public
	 */
	EventEmitter.prototype.removeAllListeners = function removeAllListeners(event) {
	  var evt;
	
	  if (event) {
	    evt = prefix ? prefix + event : event;
	    if (this._events[evt]) {
	      if (--this._eventsCount === 0) this._events = new Events();
	      else delete this._events[evt];
	    }
	  } else {
	    this._events = new Events();
	    this._eventsCount = 0;
	  }
	
	  return this;
	};
	
	//
	// Alias methods names because people roll like that.
	//
	EventEmitter.prototype.off = EventEmitter.prototype.removeListener;
	EventEmitter.prototype.addListener = EventEmitter.prototype.on;
	
	//
	// This function doesn't apply anymore.
	//
	EventEmitter.prototype.setMaxListeners = function setMaxListeners() {
	  return this;
	};
	
	//
	// Expose the prefix.
	//
	EventEmitter.prefixed = prefix;
	
	//
	// Allow `EventEmitter` to be imported as module namespace.
	//
	EventEmitter.EventEmitter = EventEmitter;
	
	//
	// Expose the module.
	//
	if ('undefined' !== typeof module) {
	  module.exports = EventEmitter;
	}
	
	
	/***/ }),
	/* 55 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.matchText = exports.matchSpacing = exports.matchNewline = exports.matchBlot = exports.matchAttributor = exports.default = undefined;
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _extend2 = __webpack_require__(3);
	
	var _extend3 = _interopRequireDefault(_extend2);
	
	var _quillDelta = __webpack_require__(2);
	
	var _quillDelta2 = _interopRequireDefault(_quillDelta);
	
	var _parchment = __webpack_require__(0);
	
	var _parchment2 = _interopRequireDefault(_parchment);
	
	var _quill = __webpack_require__(5);
	
	var _quill2 = _interopRequireDefault(_quill);
	
	var _logger = __webpack_require__(10);
	
	var _logger2 = _interopRequireDefault(_logger);
	
	var _module = __webpack_require__(9);
	
	var _module2 = _interopRequireDefault(_module);
	
	var _align = __webpack_require__(36);
	
	var _background = __webpack_require__(37);
	
	var _code = __webpack_require__(13);
	
	var _code2 = _interopRequireDefault(_code);
	
	var _color = __webpack_require__(26);
	
	var _direction = __webpack_require__(38);
	
	var _font = __webpack_require__(39);
	
	var _size = __webpack_require__(40);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var debug = (0, _logger2.default)('quill:clipboard');
	
	var DOM_KEY = '__ql-matcher';
	
	var CLIPBOARD_CONFIG = [[Node.TEXT_NODE, matchText], [Node.TEXT_NODE, matchNewline], ['br', matchBreak], [Node.ELEMENT_NODE, matchNewline], [Node.ELEMENT_NODE, matchBlot], [Node.ELEMENT_NODE, matchSpacing], [Node.ELEMENT_NODE, matchAttributor], [Node.ELEMENT_NODE, matchStyles], ['li', matchIndent], ['b', matchAlias.bind(matchAlias, 'bold')], ['i', matchAlias.bind(matchAlias, 'italic')], ['style', matchIgnore]];
	
	var ATTRIBUTE_ATTRIBUTORS = [_align.AlignAttribute, _direction.DirectionAttribute].reduce(function (memo, attr) {
	  memo[attr.keyName] = attr;
	  return memo;
	}, {});
	
	var STYLE_ATTRIBUTORS = [_align.AlignStyle, _background.BackgroundStyle, _color.ColorStyle, _direction.DirectionStyle, _font.FontStyle, _size.SizeStyle].reduce(function (memo, attr) {
	  memo[attr.keyName] = attr;
	  return memo;
	}, {});
	
	var Clipboard = function (_Module) {
	  _inherits(Clipboard, _Module);
	
	  function Clipboard(quill, options) {
	    _classCallCheck(this, Clipboard);
	
	    var _this = _possibleConstructorReturn(this, (Clipboard.__proto__ || Object.getPrototypeOf(Clipboard)).call(this, quill, options));
	
	    _this.quill.root.addEventListener('paste', _this.onPaste.bind(_this));
	    _this.container = _this.quill.addContainer('ql-clipboard');
	    _this.container.setAttribute('contenteditable', true);
	    _this.container.setAttribute('tabindex', -1);
	    _this.matchers = [];
	    CLIPBOARD_CONFIG.concat(_this.options.matchers).forEach(function (_ref) {
	      var _ref2 = _slicedToArray(_ref, 2),
	          selector = _ref2[0],
	          matcher = _ref2[1];
	
	      if (!options.matchVisual && matcher === matchSpacing) return;
	      _this.addMatcher(selector, matcher);
	    });
	    return _this;
	  }
	
	  _createClass(Clipboard, [{
	    key: 'addMatcher',
	    value: function addMatcher(selector, matcher) {
	      this.matchers.push([selector, matcher]);
	    }
	  }, {
	    key: 'convert',
	    value: function convert(html) {
	      if (typeof html === 'string') {
	        this.container.innerHTML = html.replace(/\>\r?\n +\</g, '><'); // Remove spaces between tags
	        return this.convert();
	      }
	      var formats = this.quill.getFormat(this.quill.selection.savedRange.index);
	      if (formats[_code2.default.blotName]) {
	        var text = this.container.innerText;
	        this.container.innerHTML = '';
	        return new _quillDelta2.default().insert(text, _defineProperty({}, _code2.default.blotName, formats[_code2.default.blotName]));
	      }
	
	      var _prepareMatching = this.prepareMatching(),
	          _prepareMatching2 = _slicedToArray(_prepareMatching, 2),
	          elementMatchers = _prepareMatching2[0],
	          textMatchers = _prepareMatching2[1];
	
	      var delta = traverse(this.container, elementMatchers, textMatchers);
	      // Remove trailing newline
	      if (deltaEndsWith(delta, '\n') && delta.ops[delta.ops.length - 1].attributes == null) {
	        delta = delta.compose(new _quillDelta2.default().retain(delta.length() - 1).delete(1));
	      }
	      debug.log('convert', this.container.innerHTML, delta);
	      this.container.innerHTML = '';
	      return delta;
	    }
	  }, {
	    key: 'dangerouslyPasteHTML',
	    value: function dangerouslyPasteHTML(index, html) {
	      var source = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : _quill2.default.sources.API;
	
	      if (typeof index === 'string') {
	        this.quill.setContents(this.convert(index), html);
	        this.quill.setSelection(0, _quill2.default.sources.SILENT);
	      } else {
	        var paste = this.convert(html);
	        this.quill.updateContents(new _quillDelta2.default().retain(index).concat(paste), source);
	        this.quill.setSelection(index + paste.length(), _quill2.default.sources.SILENT);
	      }
	    }
	  }, {
	    key: 'onPaste',
	    value: function onPaste(e) {
	      var _this2 = this;
	
	      if (e.defaultPrevented || !this.quill.isEnabled()) return;
	      var range = this.quill.getSelection();
	      var delta = new _quillDelta2.default().retain(range.index);
	      var scrollTop = this.quill.scrollingContainer.scrollTop;
	      this.container.focus();
	      this.quill.selection.update(_quill2.default.sources.SILENT);
	      setTimeout(function () {
	        delta = delta.concat(_this2.convert()).delete(range.length);
	        _this2.quill.updateContents(delta, _quill2.default.sources.USER);
	        // range.length contributes to delta.length()
	        _this2.quill.setSelection(delta.length() - range.length, _quill2.default.sources.SILENT);
	        _this2.quill.scrollingContainer.scrollTop = scrollTop;
	        _this2.quill.focus();
	      }, 1);
	    }
	  }, {
	    key: 'prepareMatching',
	    value: function prepareMatching() {
	      var _this3 = this;
	
	      var elementMatchers = [],
	          textMatchers = [];
	      this.matchers.forEach(function (pair) {
	        var _pair = _slicedToArray(pair, 2),
	            selector = _pair[0],
	            matcher = _pair[1];
	
	        switch (selector) {
	          case Node.TEXT_NODE:
	            textMatchers.push(matcher);
	            break;
	          case Node.ELEMENT_NODE:
	            elementMatchers.push(matcher);
	            break;
	          default:
	            [].forEach.call(_this3.container.querySelectorAll(selector), function (node) {
	              // TODO use weakmap
	              node[DOM_KEY] = node[DOM_KEY] || [];
	              node[DOM_KEY].push(matcher);
	            });
	            break;
	        }
	      });
	      return [elementMatchers, textMatchers];
	    }
	  }]);
	
	  return Clipboard;
	}(_module2.default);
	
	Clipboard.DEFAULTS = {
	  matchers: [],
	  matchVisual: true
	};
	
	function applyFormat(delta, format, value) {
	  if ((typeof format === 'undefined' ? 'undefined' : _typeof(format)) === 'object') {
	    return Object.keys(format).reduce(function (delta, key) {
	      return applyFormat(delta, key, format[key]);
	    }, delta);
	  } else {
	    return delta.reduce(function (delta, op) {
	      if (op.attributes && op.attributes[format]) {
	        return delta.push(op);
	      } else {
	        return delta.insert(op.insert, (0, _extend3.default)({}, _defineProperty({}, format, value), op.attributes));
	      }
	    }, new _quillDelta2.default());
	  }
	}
	
	function computeStyle(node) {
	  if (node.nodeType !== Node.ELEMENT_NODE) return {};
	  var DOM_KEY = '__ql-computed-style';
	  return node[DOM_KEY] || (node[DOM_KEY] = window.getComputedStyle(node));
	}
	
	function deltaEndsWith(delta, text) {
	  var endText = "";
	  for (var i = delta.ops.length - 1; i >= 0 && endText.length < text.length; --i) {
	    var op = delta.ops[i];
	    if (typeof op.insert !== 'string') break;
	    endText = op.insert + endText;
	  }
	  return endText.slice(-1 * text.length) === text;
	}
	
	function isLine(node) {
	  if (node.childNodes.length === 0) return false; // Exclude embed blocks
	  var style = computeStyle(node);
	  return ['block', 'list-item'].indexOf(style.display) > -1;
	}
	
	function traverse(node, elementMatchers, textMatchers) {
	  // Post-order
	  if (node.nodeType === node.TEXT_NODE) {
	    return textMatchers.reduce(function (delta, matcher) {
	      return matcher(node, delta);
	    }, new _quillDelta2.default());
	  } else if (node.nodeType === node.ELEMENT_NODE) {
	    return [].reduce.call(node.childNodes || [], function (delta, childNode) {
	      var childrenDelta = traverse(childNode, elementMatchers, textMatchers);
	      if (childNode.nodeType === node.ELEMENT_NODE) {
	        childrenDelta = elementMatchers.reduce(function (childrenDelta, matcher) {
	          return matcher(childNode, childrenDelta);
	        }, childrenDelta);
	        childrenDelta = (childNode[DOM_KEY] || []).reduce(function (childrenDelta, matcher) {
	          return matcher(childNode, childrenDelta);
	        }, childrenDelta);
	      }
	      return delta.concat(childrenDelta);
	    }, new _quillDelta2.default());
	  } else {
	    return new _quillDelta2.default();
	  }
	}
	
	function matchAlias(format, node, delta) {
	  return applyFormat(delta, format, true);
	}
	
	function matchAttributor(node, delta) {
	  var attributes = _parchment2.default.Attributor.Attribute.keys(node);
	  var classes = _parchment2.default.Attributor.Class.keys(node);
	  var styles = _parchment2.default.Attributor.Style.keys(node);
	  var formats = {};
	  attributes.concat(classes).concat(styles).forEach(function (name) {
	    var attr = _parchment2.default.query(name, _parchment2.default.Scope.ATTRIBUTE);
	    if (attr != null) {
	      formats[attr.attrName] = attr.value(node);
	      if (formats[attr.attrName]) return;
	    }
	    attr = ATTRIBUTE_ATTRIBUTORS[name];
	    if (attr != null && (attr.attrName === name || attr.keyName === name)) {
	      formats[attr.attrName] = attr.value(node) || undefined;
	    }
	    attr = STYLE_ATTRIBUTORS[name];
	    if (attr != null && (attr.attrName === name || attr.keyName === name)) {
	      attr = STYLE_ATTRIBUTORS[name];
	      formats[attr.attrName] = attr.value(node) || undefined;
	    }
	  });
	  if (Object.keys(formats).length > 0) {
	    delta = applyFormat(delta, formats);
	  }
	  return delta;
	}
	
	function matchBlot(node, delta) {
	  var match = _parchment2.default.query(node);
	  if (match == null) return delta;
	  if (match.prototype instanceof _parchment2.default.Embed) {
	    var embed = {};
	    var value = match.value(node);
	    if (value != null) {
	      embed[match.blotName] = value;
	      delta = new _quillDelta2.default().insert(embed, match.formats(node));
	    }
	  } else if (typeof match.formats === 'function') {
	    delta = applyFormat(delta, match.blotName, match.formats(node));
	  }
	  return delta;
	}
	
	function matchBreak(node, delta) {
	  if (!deltaEndsWith(delta, '\n')) {
	    delta.insert('\n');
	  }
	  return delta;
	}
	
	function matchIgnore() {
	  return new _quillDelta2.default();
	}
	
	function matchIndent(node, delta) {
	  var match = _parchment2.default.query(node);
	  if (match == null || match.blotName !== 'list-item' || !deltaEndsWith(delta, '\n')) {
	    return delta;
	  }
	  var indent = -1,
	      parent = node.parentNode;
	  while (!parent.classList.contains('ql-clipboard')) {
	    if ((_parchment2.default.query(parent) || {}).blotName === 'list') {
	      indent += 1;
	    }
	    parent = parent.parentNode;
	  }
	  if (indent <= 0) return delta;
	  return delta.compose(new _quillDelta2.default().retain(delta.length() - 1).retain(1, { indent: indent }));
	}
	
	function matchNewline(node, delta) {
	  if (!deltaEndsWith(delta, '\n')) {
	    if (isLine(node) || delta.length() > 0 && node.nextSibling && isLine(node.nextSibling)) {
	      delta.insert('\n');
	    }
	  }
	  return delta;
	}
	
	function matchSpacing(node, delta) {
	  if (isLine(node) && node.nextElementSibling != null && !deltaEndsWith(delta, '\n\n')) {
	    var nodeHeight = node.offsetHeight + parseFloat(computeStyle(node).marginTop) + parseFloat(computeStyle(node).marginBottom);
	    if (node.nextElementSibling.offsetTop > node.offsetTop + nodeHeight * 1.5) {
	      delta.insert('\n');
	    }
	  }
	  return delta;
	}
	
	function matchStyles(node, delta) {
	  var formats = {};
	  var style = node.style || {};
	  if (style.fontStyle && computeStyle(node).fontStyle === 'italic') {
	    formats.italic = true;
	  }
	  if (style.fontWeight && (computeStyle(node).fontWeight.startsWith('bold') || parseInt(computeStyle(node).fontWeight) >= 700)) {
	    formats.bold = true;
	  }
	  if (Object.keys(formats).length > 0) {
	    delta = applyFormat(delta, formats);
	  }
	  if (parseFloat(style.textIndent || 0) > 0) {
	    // Could be 0.5in
	    delta = new _quillDelta2.default().insert('\t').concat(delta);
	  }
	  return delta;
	}
	
	function matchText(node, delta) {
	  var text = node.data;
	  // Word represents empty line with <o:p>&nbsp;</o:p>
	  if (node.parentNode.tagName === 'O:P') {
	    return delta.insert(text.trim());
	  }
	  if (text.trim().length === 0 && node.parentNode.classList.contains('ql-clipboard')) {
	    return delta;
	  }
	  if (!computeStyle(node.parentNode).whiteSpace.startsWith('pre')) {
	    // eslint-disable-next-line func-style
	    var replacer = function replacer(collapse, match) {
	      match = match.replace(/[^\u00a0]/g, ''); // \u00a0 is nbsp;
	      return match.length < 1 && collapse ? ' ' : match;
	    };
	    text = text.replace(/\r\n/g, ' ').replace(/\n/g, ' ');
	    text = text.replace(/\s\s+/g, replacer.bind(replacer, true)); // collapse whitespace
	    if (node.previousSibling == null && isLine(node.parentNode) || node.previousSibling != null && isLine(node.previousSibling)) {
	      text = text.replace(/^\s+/, replacer.bind(replacer, false));
	    }
	    if (node.nextSibling == null && isLine(node.parentNode) || node.nextSibling != null && isLine(node.nextSibling)) {
	      text = text.replace(/\s+$/, replacer.bind(replacer, false));
	    }
	  }
	  return delta.insert(text);
	}
	
	exports.default = Clipboard;
	exports.matchAttributor = matchAttributor;
	exports.matchBlot = matchBlot;
	exports.matchNewline = matchNewline;
	exports.matchSpacing = matchSpacing;
	exports.matchText = matchText;
	
	/***/ }),
	/* 56 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };
	
	var _inline = __webpack_require__(6);
	
	var _inline2 = _interopRequireDefault(_inline);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Bold = function (_Inline) {
	  _inherits(Bold, _Inline);
	
	  function Bold() {
	    _classCallCheck(this, Bold);
	
	    return _possibleConstructorReturn(this, (Bold.__proto__ || Object.getPrototypeOf(Bold)).apply(this, arguments));
	  }
	
	  _createClass(Bold, [{
	    key: 'optimize',
	    value: function optimize(context) {
	      _get(Bold.prototype.__proto__ || Object.getPrototypeOf(Bold.prototype), 'optimize', this).call(this, context);
	      if (this.domNode.tagName !== this.statics.tagName[0]) {
	        this.replaceWith(this.statics.blotName);
	      }
	    }
	  }], [{
	    key: 'create',
	    value: function create() {
	      return _get(Bold.__proto__ || Object.getPrototypeOf(Bold), 'create', this).call(this);
	    }
	  }, {
	    key: 'formats',
	    value: function formats() {
	      return true;
	    }
	  }]);
	
	  return Bold;
	}(_inline2.default);
	
	Bold.blotName = 'bold';
	Bold.tagName = ['STRONG', 'B'];
	
	exports.default = Bold;
	
	/***/ }),
	/* 57 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.addControls = exports.default = undefined;
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _quillDelta = __webpack_require__(2);
	
	var _quillDelta2 = _interopRequireDefault(_quillDelta);
	
	var _parchment = __webpack_require__(0);
	
	var _parchment2 = _interopRequireDefault(_parchment);
	
	var _quill = __webpack_require__(5);
	
	var _quill2 = _interopRequireDefault(_quill);
	
	var _logger = __webpack_require__(10);
	
	var _logger2 = _interopRequireDefault(_logger);
	
	var _module = __webpack_require__(9);
	
	var _module2 = _interopRequireDefault(_module);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var debug = (0, _logger2.default)('quill:toolbar');
	
	var Toolbar = function (_Module) {
	  _inherits(Toolbar, _Module);
	
	  function Toolbar(quill, options) {
	    _classCallCheck(this, Toolbar);
	
	    var _this = _possibleConstructorReturn(this, (Toolbar.__proto__ || Object.getPrototypeOf(Toolbar)).call(this, quill, options));
	
	    if (Array.isArray(_this.options.container)) {
	      var container = document.createElement('div');
	      addControls(container, _this.options.container);
	      quill.container.parentNode.insertBefore(container, quill.container);
	      _this.container = container;
	    } else if (typeof _this.options.container === 'string') {
	      _this.container = document.querySelector(_this.options.container);
	    } else {
	      _this.container = _this.options.container;
	    }
	    if (!(_this.container instanceof HTMLElement)) {
	      var _ret;
	
	      return _ret = debug.error('Container required for toolbar', _this.options), _possibleConstructorReturn(_this, _ret);
	    }
	    _this.container.classList.add('ql-toolbar');
	    _this.controls = [];
	    _this.handlers = {};
	    Object.keys(_this.options.handlers).forEach(function (format) {
	      _this.addHandler(format, _this.options.handlers[format]);
	    });
	    [].forEach.call(_this.container.querySelectorAll('button, select'), function (input) {
	      _this.attach(input);
	    });
	    _this.quill.on(_quill2.default.events.EDITOR_CHANGE, function (type, range) {
	      if (type === _quill2.default.events.SELECTION_CHANGE) {
	        _this.update(range);
	      }
	    });
	    _this.quill.on(_quill2.default.events.SCROLL_OPTIMIZE, function () {
	      var _this$quill$selection = _this.quill.selection.getRange(),
	          _this$quill$selection2 = _slicedToArray(_this$quill$selection, 1),
	          range = _this$quill$selection2[0]; // quill.getSelection triggers update
	
	
	      _this.update(range);
	    });
	    return _this;
	  }
	
	  _createClass(Toolbar, [{
	    key: 'addHandler',
	    value: function addHandler(format, handler) {
	      this.handlers[format] = handler;
	    }
	  }, {
	    key: 'attach',
	    value: function attach(input) {
	      var _this2 = this;
	
	      var format = [].find.call(input.classList, function (className) {
	        return className.indexOf('ql-') === 0;
	      });
	      if (!format) return;
	      format = format.slice('ql-'.length);
	      if (input.tagName === 'BUTTON') {
	        input.setAttribute('type', 'button');
	      }
	      if (this.handlers[format] == null) {
	        if (this.quill.scroll.whitelist != null && this.quill.scroll.whitelist[format] == null) {
	          debug.warn('ignoring attaching to disabled format', format, input);
	          return;
	        }
	        if (_parchment2.default.query(format) == null) {
	          debug.warn('ignoring attaching to nonexistent format', format, input);
	          return;
	        }
	      }
	      var eventName = input.tagName === 'SELECT' ? 'change' : 'click';
	      input.addEventListener(eventName, function (e) {
	        var value = void 0;
	        if (input.tagName === 'SELECT') {
	          if (input.selectedIndex < 0) return;
	          var selected = input.options[input.selectedIndex];
	          if (selected.hasAttribute('selected')) {
	            value = false;
	          } else {
	            value = selected.value || false;
	          }
	        } else {
	          if (input.classList.contains('ql-active')) {
	            value = false;
	          } else {
	            value = input.value || !input.hasAttribute('value');
	          }
	          e.preventDefault();
	        }
	        _this2.quill.focus();
	
	        var _quill$selection$getR = _this2.quill.selection.getRange(),
	            _quill$selection$getR2 = _slicedToArray(_quill$selection$getR, 1),
	            range = _quill$selection$getR2[0];
	
	        if (_this2.handlers[format] != null) {
	          _this2.handlers[format].call(_this2, value);
	        } else if (_parchment2.default.query(format).prototype instanceof _parchment2.default.Embed) {
	          value = prompt('Enter ' + format);
	          if (!value) return;
	          _this2.quill.updateContents(new _quillDelta2.default().retain(range.index).delete(range.length).insert(_defineProperty({}, format, value)), _quill2.default.sources.USER);
	        } else {
	          _this2.quill.format(format, value, _quill2.default.sources.USER);
	        }
	        _this2.update(range);
	      });
	      // TODO use weakmap
	      this.controls.push([format, input]);
	    }
	  }, {
	    key: 'update',
	    value: function update(range) {
	      var formats = range == null ? {} : this.quill.getFormat(range);
	      this.controls.forEach(function (pair) {
	        var _pair = _slicedToArray(pair, 2),
	            format = _pair[0],
	            input = _pair[1];
	
	        if (input.tagName === 'SELECT') {
	          var option = void 0;
	          if (range == null) {
	            option = null;
	          } else if (formats[format] == null) {
	            option = input.querySelector('option[selected]');
	          } else if (!Array.isArray(formats[format])) {
	            var value = formats[format];
	            if (typeof value === 'string') {
	              value = value.replace(/\"/g, '\\"');
	            }
	            option = input.querySelector('option[value="' + value + '"]');
	          }
	          if (option == null) {
	            input.value = ''; // TODO make configurable?
	            input.selectedIndex = -1;
	          } else {
	            option.selected = true;
	          }
	        } else {
	          if (range == null) {
	            input.classList.remove('ql-active');
	          } else if (input.hasAttribute('value')) {
	            // both being null should match (default values)
	            // '1' should match with 1 (headers)
	            var isActive = formats[format] === input.getAttribute('value') || formats[format] != null && formats[format].toString() === input.getAttribute('value') || formats[format] == null && !input.getAttribute('value');
	            input.classList.toggle('ql-active', isActive);
	          } else {
	            input.classList.toggle('ql-active', formats[format] != null);
	          }
	        }
	      });
	    }
	  }]);
	
	  return Toolbar;
	}(_module2.default);
	
	Toolbar.DEFAULTS = {};
	
	function addButton(container, format, value) {
	  var input = document.createElement('button');
	  input.setAttribute('type', 'button');
	  input.classList.add('ql-' + format);
	  if (value != null) {
	    input.value = value;
	  }
	  container.appendChild(input);
	}
	
	function addControls(container, groups) {
	  if (!Array.isArray(groups[0])) {
	    groups = [groups];
	  }
	  groups.forEach(function (controls) {
	    var group = document.createElement('span');
	    group.classList.add('ql-formats');
	    controls.forEach(function (control) {
	      if (typeof control === 'string') {
	        addButton(group, control);
	      } else {
	        var format = Object.keys(control)[0];
	        var value = control[format];
	        if (Array.isArray(value)) {
	          addSelect(group, format, value);
	        } else {
	          addButton(group, format, value);
	        }
	      }
	    });
	    container.appendChild(group);
	  });
	}
	
	function addSelect(container, format, values) {
	  var input = document.createElement('select');
	  input.classList.add('ql-' + format);
	  values.forEach(function (value) {
	    var option = document.createElement('option');
	    if (value !== false) {
	      option.setAttribute('value', value);
	    } else {
	      option.setAttribute('selected', 'selected');
	    }
	    input.appendChild(option);
	  });
	  container.appendChild(input);
	}
	
	Toolbar.DEFAULTS = {
	  container: null,
	  handlers: {
	    clean: function clean() {
	      var _this3 = this;
	
	      var range = this.quill.getSelection();
	      if (range == null) return;
	      if (range.length == 0) {
	        var formats = this.quill.getFormat();
	        Object.keys(formats).forEach(function (name) {
	          // Clean functionality in existing apps only clean inline formats
	          if (_parchment2.default.query(name, _parchment2.default.Scope.INLINE) != null) {
	            _this3.quill.format(name, false);
	          }
	        });
	      } else {
	        this.quill.removeFormat(range, _quill2.default.sources.USER);
	      }
	    },
	    direction: function direction(value) {
	      var align = this.quill.getFormat()['align'];
	      if (value === 'rtl' && align == null) {
	        this.quill.format('align', 'right', _quill2.default.sources.USER);
	      } else if (!value && align === 'right') {
	        this.quill.format('align', false, _quill2.default.sources.USER);
	      }
	      this.quill.format('direction', value, _quill2.default.sources.USER);
	    },
	    indent: function indent(value) {
	      var range = this.quill.getSelection();
	      var formats = this.quill.getFormat(range);
	      var indent = parseInt(formats.indent || 0);
	      if (value === '+1' || value === '-1') {
	        var modifier = value === '+1' ? 1 : -1;
	        if (formats.direction === 'rtl') modifier *= -1;
	        this.quill.format('indent', indent + modifier, _quill2.default.sources.USER);
	      }
	    },
	    link: function link(value) {
	      if (value === true) {
	        value = prompt('Enter link URL:');
	      }
	      this.quill.format('link', value, _quill2.default.sources.USER);
	    },
	    list: function list(value) {
	      var range = this.quill.getSelection();
	      var formats = this.quill.getFormat(range);
	      if (value === 'check') {
	        if (formats['list'] === 'checked' || formats['list'] === 'unchecked') {
	          this.quill.format('list', false, _quill2.default.sources.USER);
	        } else {
	          this.quill.format('list', 'unchecked', _quill2.default.sources.USER);
	        }
	      } else {
	        this.quill.format('list', value, _quill2.default.sources.USER);
	      }
	    }
	  }
	};
	
	exports.default = Toolbar;
	exports.addControls = addControls;
	
	/***/ }),
	/* 58 */
	/***/ (function(module, exports) {
	
	module.exports = "<svg viewbox=\"0 0 18 18\"> <polyline class=\"ql-even ql-stroke\" points=\"5 7 3 9 5 11\"></polyline> <polyline class=\"ql-even ql-stroke\" points=\"13 7 15 9 13 11\"></polyline> <line class=ql-stroke x1=10 x2=8 y1=5 y2=13></line> </svg>";
	
	/***/ }),
	/* 59 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };
	
	var _picker = __webpack_require__(28);
	
	var _picker2 = _interopRequireDefault(_picker);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ColorPicker = function (_Picker) {
	  _inherits(ColorPicker, _Picker);
	
	  function ColorPicker(select, label) {
	    _classCallCheck(this, ColorPicker);
	
	    var _this = _possibleConstructorReturn(this, (ColorPicker.__proto__ || Object.getPrototypeOf(ColorPicker)).call(this, select));
	
	    _this.label.innerHTML = label;
	    _this.container.classList.add('ql-color-picker');
	    [].slice.call(_this.container.querySelectorAll('.ql-picker-item'), 0, 7).forEach(function (item) {
	      item.classList.add('ql-primary');
	    });
	    return _this;
	  }
	
	  _createClass(ColorPicker, [{
	    key: 'buildItem',
	    value: function buildItem(option) {
	      var item = _get(ColorPicker.prototype.__proto__ || Object.getPrototypeOf(ColorPicker.prototype), 'buildItem', this).call(this, option);
	      item.style.backgroundColor = option.getAttribute('value') || '';
	      return item;
	    }
	  }, {
	    key: 'selectItem',
	    value: function selectItem(item, trigger) {
	      _get(ColorPicker.prototype.__proto__ || Object.getPrototypeOf(ColorPicker.prototype), 'selectItem', this).call(this, item, trigger);
	      var colorLabel = this.label.querySelector('.ql-color-label');
	      var value = item ? item.getAttribute('data-value') || '' : '';
	      if (colorLabel) {
	        if (colorLabel.tagName === 'line') {
	          colorLabel.style.stroke = value;
	        } else {
	          colorLabel.style.fill = value;
	        }
	      }
	    }
	  }]);
	
	  return ColorPicker;
	}(_picker2.default);
	
	exports.default = ColorPicker;
	
	/***/ }),
	/* 60 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };
	
	var _picker = __webpack_require__(28);
	
	var _picker2 = _interopRequireDefault(_picker);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var IconPicker = function (_Picker) {
	  _inherits(IconPicker, _Picker);
	
	  function IconPicker(select, icons) {
	    _classCallCheck(this, IconPicker);
	
	    var _this = _possibleConstructorReturn(this, (IconPicker.__proto__ || Object.getPrototypeOf(IconPicker)).call(this, select));
	
	    _this.container.classList.add('ql-icon-picker');
	    [].forEach.call(_this.container.querySelectorAll('.ql-picker-item'), function (item) {
	      item.innerHTML = icons[item.getAttribute('data-value') || ''];
	    });
	    _this.defaultItem = _this.container.querySelector('.ql-selected');
	    _this.selectItem(_this.defaultItem);
	    return _this;
	  }
	
	  _createClass(IconPicker, [{
	    key: 'selectItem',
	    value: function selectItem(item, trigger) {
	      _get(IconPicker.prototype.__proto__ || Object.getPrototypeOf(IconPicker.prototype), 'selectItem', this).call(this, item, trigger);
	      item = item || this.defaultItem;
	      this.label.innerHTML = item.innerHTML;
	    }
	  }]);
	
	  return IconPicker;
	}(_picker2.default);
	
	exports.default = IconPicker;
	
	/***/ }),
	/* 61 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var Tooltip = function () {
	  function Tooltip(quill, boundsContainer) {
	    var _this = this;
	
	    _classCallCheck(this, Tooltip);
	
	    this.quill = quill;
	    this.boundsContainer = boundsContainer || document.body;
	    this.root = quill.addContainer('ql-tooltip');
	    this.root.innerHTML = this.constructor.TEMPLATE;
	    if (this.quill.root === this.quill.scrollingContainer) {
	      this.quill.root.addEventListener('scroll', function () {
	        _this.root.style.marginTop = -1 * _this.quill.root.scrollTop + 'px';
	      });
	    }
	    this.hide();
	  }
	
	  _createClass(Tooltip, [{
	    key: 'hide',
	    value: function hide() {
	      this.root.classList.add('ql-hidden');
	    }
	  }, {
	    key: 'position',
	    value: function position(reference) {
	      var left = reference.left + reference.width / 2 - this.root.offsetWidth / 2;
	      // root.scrollTop should be 0 if scrollContainer !== root
	      var top = reference.bottom + this.quill.root.scrollTop;
	      this.root.style.left = left + 'px';
	      this.root.style.top = top + 'px';
	      this.root.classList.remove('ql-flip');
	      var containerBounds = this.boundsContainer.getBoundingClientRect();
	      var rootBounds = this.root.getBoundingClientRect();
	      var shift = 0;
	      if (rootBounds.right > containerBounds.right) {
	        shift = containerBounds.right - rootBounds.right;
	        this.root.style.left = left + shift + 'px';
	      }
	      if (rootBounds.left < containerBounds.left) {
	        shift = containerBounds.left - rootBounds.left;
	        this.root.style.left = left + shift + 'px';
	      }
	      if (rootBounds.bottom > containerBounds.bottom) {
	        var height = rootBounds.bottom - rootBounds.top;
	        var verticalShift = reference.bottom - reference.top + height;
	        this.root.style.top = top - verticalShift + 'px';
	        this.root.classList.add('ql-flip');
	      }
	      return shift;
	    }
	  }, {
	    key: 'show',
	    value: function show() {
	      this.root.classList.remove('ql-editing');
	      this.root.classList.remove('ql-hidden');
	    }
	  }]);
	
	  return Tooltip;
	}();
	
	exports.default = Tooltip;
	
	/***/ }),
	/* 62 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _extend = __webpack_require__(3);
	
	var _extend2 = _interopRequireDefault(_extend);
	
	var _emitter = __webpack_require__(8);
	
	var _emitter2 = _interopRequireDefault(_emitter);
	
	var _base = __webpack_require__(43);
	
	var _base2 = _interopRequireDefault(_base);
	
	var _link = __webpack_require__(27);
	
	var _link2 = _interopRequireDefault(_link);
	
	var _selection = __webpack_require__(15);
	
	var _icons = __webpack_require__(41);
	
	var _icons2 = _interopRequireDefault(_icons);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var TOOLBAR_CONFIG = [[{ header: ['1', '2', '3', false] }], ['bold', 'italic', 'underline', 'link'], [{ list: 'ordered' }, { list: 'bullet' }], ['clean']];
	
	var SnowTheme = function (_BaseTheme) {
	  _inherits(SnowTheme, _BaseTheme);
	
	  function SnowTheme(quill, options) {
	    _classCallCheck(this, SnowTheme);
	
	    if (options.modules.toolbar != null && options.modules.toolbar.container == null) {
	      options.modules.toolbar.container = TOOLBAR_CONFIG;
	    }
	
	    var _this = _possibleConstructorReturn(this, (SnowTheme.__proto__ || Object.getPrototypeOf(SnowTheme)).call(this, quill, options));
	
	    _this.quill.container.classList.add('ql-snow');
	    return _this;
	  }
	
	  _createClass(SnowTheme, [{
	    key: 'extendToolbar',
	    value: function extendToolbar(toolbar) {
	      toolbar.container.classList.add('ql-snow');
	      this.buildButtons([].slice.call(toolbar.container.querySelectorAll('button')), _icons2.default);
	      this.buildPickers([].slice.call(toolbar.container.querySelectorAll('select')), _icons2.default);
	      this.tooltip = new SnowTooltip(this.quill, this.options.bounds);
	      if (toolbar.container.querySelector('.ql-link')) {
	        this.quill.keyboard.addBinding({ key: 'K', shortKey: true }, function (range, context) {
	          toolbar.handlers['link'].call(toolbar, !context.format.link);
	        });
	      }
	    }
	  }]);
	
	  return SnowTheme;
	}(_base2.default);
	
	SnowTheme.DEFAULTS = (0, _extend2.default)(true, {}, _base2.default.DEFAULTS, {
	  modules: {
	    toolbar: {
	      handlers: {
	        link: function link(value) {
	          if (value) {
	            var range = this.quill.getSelection();
	            if (range == null || range.length == 0) return;
	            var preview = this.quill.getText(range);
	            if (/^\S+@\S+\.\S+$/.test(preview) && preview.indexOf('mailto:') !== 0) {
	              preview = 'mailto:' + preview;
	            }
	            var tooltip = this.quill.theme.tooltip;
	            tooltip.edit('link', preview);
	          } else {
	            this.quill.format('link', false);
	          }
	        }
	      }
	    }
	  }
	});
	
	var SnowTooltip = function (_BaseTooltip) {
	  _inherits(SnowTooltip, _BaseTooltip);
	
	  function SnowTooltip(quill, bounds) {
	    _classCallCheck(this, SnowTooltip);
	
	    var _this2 = _possibleConstructorReturn(this, (SnowTooltip.__proto__ || Object.getPrototypeOf(SnowTooltip)).call(this, quill, bounds));
	
	    _this2.preview = _this2.root.querySelector('a.ql-preview');
	    return _this2;
	  }
	
	  _createClass(SnowTooltip, [{
	    key: 'listen',
	    value: function listen() {
	      var _this3 = this;
	
	      _get(SnowTooltip.prototype.__proto__ || Object.getPrototypeOf(SnowTooltip.prototype), 'listen', this).call(this);
	      this.root.querySelector('a.ql-action').addEventListener('click', function (event) {
	        if (_this3.root.classList.contains('ql-editing')) {
	          _this3.save();
	        } else {
	          _this3.edit('link', _this3.preview.textContent);
	        }
	        event.preventDefault();
	      });
	      this.root.querySelector('a.ql-remove').addEventListener('click', function (event) {
	        if (_this3.linkRange != null) {
	          var range = _this3.linkRange;
	          _this3.restoreFocus();
	          _this3.quill.formatText(range, 'link', false, _emitter2.default.sources.USER);
	          delete _this3.linkRange;
	        }
	        event.preventDefault();
	        _this3.hide();
	      });
	      this.quill.on(_emitter2.default.events.SELECTION_CHANGE, function (range, oldRange, source) {
	        if (range == null) return;
	        if (range.length === 0 && source === _emitter2.default.sources.USER) {
	          var _quill$scroll$descend = _this3.quill.scroll.descendant(_link2.default, range.index),
	              _quill$scroll$descend2 = _slicedToArray(_quill$scroll$descend, 2),
	              link = _quill$scroll$descend2[0],
	              offset = _quill$scroll$descend2[1];
	
	          if (link != null) {
	            _this3.linkRange = new _selection.Range(range.index - offset, link.length());
	            var preview = _link2.default.formats(link.domNode);
	            _this3.preview.textContent = preview;
	            _this3.preview.setAttribute('href', preview);
	            _this3.show();
	            _this3.position(_this3.quill.getBounds(_this3.linkRange));
	            return;
	          }
	        } else {
	          delete _this3.linkRange;
	        }
	        _this3.hide();
	      });
	    }
	  }, {
	    key: 'show',
	    value: function show() {
	      _get(SnowTooltip.prototype.__proto__ || Object.getPrototypeOf(SnowTooltip.prototype), 'show', this).call(this);
	      this.root.removeAttribute('data-mode');
	    }
	  }]);
	
	  return SnowTooltip;
	}(_base.BaseTooltip);
	
	SnowTooltip.TEMPLATE = ['<a class="ql-preview" target="_blank" href="about:blank"></a>', '<input type="text" data-formula="e=mc^2" data-link="https://quilljs.com" data-video="Embed URL">', '<a class="ql-action"></a>', '<a class="ql-remove"></a>'].join('');
	
	exports.default = SnowTheme;
	
	/***/ }),
	/* 63 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _core = __webpack_require__(29);
	
	var _core2 = _interopRequireDefault(_core);
	
	var _align = __webpack_require__(36);
	
	var _direction = __webpack_require__(38);
	
	var _indent = __webpack_require__(64);
	
	var _blockquote = __webpack_require__(65);
	
	var _blockquote2 = _interopRequireDefault(_blockquote);
	
	var _header = __webpack_require__(66);
	
	var _header2 = _interopRequireDefault(_header);
	
	var _list = __webpack_require__(67);
	
	var _list2 = _interopRequireDefault(_list);
	
	var _background = __webpack_require__(37);
	
	var _color = __webpack_require__(26);
	
	var _font = __webpack_require__(39);
	
	var _size = __webpack_require__(40);
	
	var _bold = __webpack_require__(56);
	
	var _bold2 = _interopRequireDefault(_bold);
	
	var _italic = __webpack_require__(68);
	
	var _italic2 = _interopRequireDefault(_italic);
	
	var _link = __webpack_require__(27);
	
	var _link2 = _interopRequireDefault(_link);
	
	var _script = __webpack_require__(69);
	
	var _script2 = _interopRequireDefault(_script);
	
	var _strike = __webpack_require__(70);
	
	var _strike2 = _interopRequireDefault(_strike);
	
	var _underline = __webpack_require__(71);
	
	var _underline2 = _interopRequireDefault(_underline);
	
	var _image = __webpack_require__(72);
	
	var _image2 = _interopRequireDefault(_image);
	
	var _video = __webpack_require__(73);
	
	var _video2 = _interopRequireDefault(_video);
	
	var _code = __webpack_require__(13);
	
	var _code2 = _interopRequireDefault(_code);
	
	var _formula = __webpack_require__(74);
	
	var _formula2 = _interopRequireDefault(_formula);
	
	var _syntax = __webpack_require__(75);
	
	var _syntax2 = _interopRequireDefault(_syntax);
	
	var _toolbar = __webpack_require__(57);
	
	var _toolbar2 = _interopRequireDefault(_toolbar);
	
	var _icons = __webpack_require__(41);
	
	var _icons2 = _interopRequireDefault(_icons);
	
	var _picker = __webpack_require__(28);
	
	var _picker2 = _interopRequireDefault(_picker);
	
	var _colorPicker = __webpack_require__(59);
	
	var _colorPicker2 = _interopRequireDefault(_colorPicker);
	
	var _iconPicker = __webpack_require__(60);
	
	var _iconPicker2 = _interopRequireDefault(_iconPicker);
	
	var _tooltip = __webpack_require__(61);
	
	var _tooltip2 = _interopRequireDefault(_tooltip);
	
	var _bubble = __webpack_require__(108);
	
	var _bubble2 = _interopRequireDefault(_bubble);
	
	var _snow = __webpack_require__(62);
	
	var _snow2 = _interopRequireDefault(_snow);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	_core2.default.register({
	  'attributors/attribute/direction': _direction.DirectionAttribute,
	
	  'attributors/class/align': _align.AlignClass,
	  'attributors/class/background': _background.BackgroundClass,
	  'attributors/class/color': _color.ColorClass,
	  'attributors/class/direction': _direction.DirectionClass,
	  'attributors/class/font': _font.FontClass,
	  'attributors/class/size': _size.SizeClass,
	
	  'attributors/style/align': _align.AlignStyle,
	  'attributors/style/background': _background.BackgroundStyle,
	  'attributors/style/color': _color.ColorStyle,
	  'attributors/style/direction': _direction.DirectionStyle,
	  'attributors/style/font': _font.FontStyle,
	  'attributors/style/size': _size.SizeStyle
	}, true);
	
	_core2.default.register({
	  'formats/align': _align.AlignClass,
	  'formats/direction': _direction.DirectionClass,
	  'formats/indent': _indent.IndentClass,
	
	  'formats/background': _background.BackgroundStyle,
	  'formats/color': _color.ColorStyle,
	  'formats/font': _font.FontClass,
	  'formats/size': _size.SizeClass,
	
	  'formats/blockquote': _blockquote2.default,
	  'formats/code-block': _code2.default,
	  'formats/header': _header2.default,
	  'formats/list': _list2.default,
	
	  'formats/bold': _bold2.default,
	  'formats/code': _code.Code,
	  'formats/italic': _italic2.default,
	  'formats/link': _link2.default,
	  'formats/script': _script2.default,
	  'formats/strike': _strike2.default,
	  'formats/underline': _underline2.default,
	
	  'formats/image': _image2.default,
	  'formats/video': _video2.default,
	
	  'formats/list/item': _list.ListItem,
	
	  'modules/formula': _formula2.default,
	  'modules/syntax': _syntax2.default,
	  'modules/toolbar': _toolbar2.default,
	
	  'themes/bubble': _bubble2.default,
	  'themes/snow': _snow2.default,
	
	  'ui/icons': _icons2.default,
	  'ui/picker': _picker2.default,
	  'ui/icon-picker': _iconPicker2.default,
	  'ui/color-picker': _colorPicker2.default,
	  'ui/tooltip': _tooltip2.default
	}, true);
	
	exports.default = _core2.default;
	
	/***/ }),
	/* 64 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.IndentClass = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };
	
	var _parchment = __webpack_require__(0);
	
	var _parchment2 = _interopRequireDefault(_parchment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var IdentAttributor = function (_Parchment$Attributor) {
	  _inherits(IdentAttributor, _Parchment$Attributor);
	
	  function IdentAttributor() {
	    _classCallCheck(this, IdentAttributor);
	
	    return _possibleConstructorReturn(this, (IdentAttributor.__proto__ || Object.getPrototypeOf(IdentAttributor)).apply(this, arguments));
	  }
	
	  _createClass(IdentAttributor, [{
	    key: 'add',
	    value: function add(node, value) {
	      if (value === '+1' || value === '-1') {
	        var indent = this.value(node) || 0;
	        value = value === '+1' ? indent + 1 : indent - 1;
	      }
	      if (value === 0) {
	        this.remove(node);
	        return true;
	      } else {
	        return _get(IdentAttributor.prototype.__proto__ || Object.getPrototypeOf(IdentAttributor.prototype), 'add', this).call(this, node, value);
	      }
	    }
	  }, {
	    key: 'canAdd',
	    value: function canAdd(node, value) {
	      return _get(IdentAttributor.prototype.__proto__ || Object.getPrototypeOf(IdentAttributor.prototype), 'canAdd', this).call(this, node, value) || _get(IdentAttributor.prototype.__proto__ || Object.getPrototypeOf(IdentAttributor.prototype), 'canAdd', this).call(this, node, parseInt(value));
	    }
	  }, {
	    key: 'value',
	    value: function value(node) {
	      return parseInt(_get(IdentAttributor.prototype.__proto__ || Object.getPrototypeOf(IdentAttributor.prototype), 'value', this).call(this, node)) || undefined; // Don't return NaN
	    }
	  }]);
	
	  return IdentAttributor;
	}(_parchment2.default.Attributor.Class);
	
	var IndentClass = new IdentAttributor('indent', 'ql-indent', {
	  scope: _parchment2.default.Scope.BLOCK,
	  whitelist: [1, 2, 3, 4, 5, 6, 7, 8]
	});
	
	exports.IndentClass = IndentClass;
	
	/***/ }),
	/* 65 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _block = __webpack_require__(4);
	
	var _block2 = _interopRequireDefault(_block);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Blockquote = function (_Block) {
	  _inherits(Blockquote, _Block);
	
	  function Blockquote() {
	    _classCallCheck(this, Blockquote);
	
	    return _possibleConstructorReturn(this, (Blockquote.__proto__ || Object.getPrototypeOf(Blockquote)).apply(this, arguments));
	  }
	
	  return Blockquote;
	}(_block2.default);
	
	Blockquote.blotName = 'blockquote';
	Blockquote.tagName = 'blockquote';
	
	exports.default = Blockquote;
	
	/***/ }),
	/* 66 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _block = __webpack_require__(4);
	
	var _block2 = _interopRequireDefault(_block);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Header = function (_Block) {
	  _inherits(Header, _Block);
	
	  function Header() {
	    _classCallCheck(this, Header);
	
	    return _possibleConstructorReturn(this, (Header.__proto__ || Object.getPrototypeOf(Header)).apply(this, arguments));
	  }
	
	  _createClass(Header, null, [{
	    key: 'formats',
	    value: function formats(domNode) {
	      return this.tagName.indexOf(domNode.tagName) + 1;
	    }
	  }]);
	
	  return Header;
	}(_block2.default);
	
	Header.blotName = 'header';
	Header.tagName = ['H1', 'H2', 'H3', 'H4', 'H5', 'H6'];
	
	exports.default = Header;
	
	/***/ }),
	/* 67 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.ListItem = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };
	
	var _parchment = __webpack_require__(0);
	
	var _parchment2 = _interopRequireDefault(_parchment);
	
	var _block = __webpack_require__(4);
	
	var _block2 = _interopRequireDefault(_block);
	
	var _container = __webpack_require__(25);
	
	var _container2 = _interopRequireDefault(_container);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ListItem = function (_Block) {
	  _inherits(ListItem, _Block);
	
	  function ListItem() {
	    _classCallCheck(this, ListItem);
	
	    return _possibleConstructorReturn(this, (ListItem.__proto__ || Object.getPrototypeOf(ListItem)).apply(this, arguments));
	  }
	
	  _createClass(ListItem, [{
	    key: 'format',
	    value: function format(name, value) {
	      if (name === List.blotName && !value) {
	        this.replaceWith(_parchment2.default.create(this.statics.scope));
	      } else {
	        _get(ListItem.prototype.__proto__ || Object.getPrototypeOf(ListItem.prototype), 'format', this).call(this, name, value);
	      }
	    }
	  }, {
	    key: 'remove',
	    value: function remove() {
	      if (this.prev == null && this.next == null) {
	        this.parent.remove();
	      } else {
	        _get(ListItem.prototype.__proto__ || Object.getPrototypeOf(ListItem.prototype), 'remove', this).call(this);
	      }
	    }
	  }, {
	    key: 'replaceWith',
	    value: function replaceWith(name, value) {
	      this.parent.isolate(this.offset(this.parent), this.length());
	      if (name === this.parent.statics.blotName) {
	        this.parent.replaceWith(name, value);
	        return this;
	      } else {
	        this.parent.unwrap();
	        return _get(ListItem.prototype.__proto__ || Object.getPrototypeOf(ListItem.prototype), 'replaceWith', this).call(this, name, value);
	      }
	    }
	  }], [{
	    key: 'formats',
	    value: function formats(domNode) {
	      return domNode.tagName === this.tagName ? undefined : _get(ListItem.__proto__ || Object.getPrototypeOf(ListItem), 'formats', this).call(this, domNode);
	    }
	  }]);
	
	  return ListItem;
	}(_block2.default);
	
	ListItem.blotName = 'list-item';
	ListItem.tagName = 'LI';
	
	var List = function (_Container) {
	  _inherits(List, _Container);
	
	  _createClass(List, null, [{
	    key: 'create',
	    value: function create(value) {
	      var tagName = value === 'ordered' ? 'OL' : 'UL';
	      var node = _get(List.__proto__ || Object.getPrototypeOf(List), 'create', this).call(this, tagName);
	      if (value === 'checked' || value === 'unchecked') {
	        node.setAttribute('data-checked', value === 'checked');
	      }
	      return node;
	    }
	  }, {
	    key: 'formats',
	    value: function formats(domNode) {
	      if (domNode.tagName === 'OL') return 'ordered';
	      if (domNode.tagName === 'UL') {
	        if (domNode.hasAttribute('data-checked')) {
	          return domNode.getAttribute('data-checked') === 'true' ? 'checked' : 'unchecked';
	        } else {
	          return 'bullet';
	        }
	      }
	      return undefined;
	    }
	  }]);
	
	  function List(domNode) {
	    _classCallCheck(this, List);
	
	    var _this2 = _possibleConstructorReturn(this, (List.__proto__ || Object.getPrototypeOf(List)).call(this, domNode));
	
	    var listEventHandler = function listEventHandler(e) {
	      if (e.target.parentNode !== domNode) return;
	      var format = _this2.statics.formats(domNode);
	      var blot = _parchment2.default.find(e.target);
	      if (format === 'checked') {
	        blot.format('list', 'unchecked');
	      } else if (format === 'unchecked') {
	        blot.format('list', 'checked');
	      }
	    };
	
	    domNode.addEventListener('touchstart', listEventHandler);
	    domNode.addEventListener('mousedown', listEventHandler);
	    return _this2;
	  }
	
	  _createClass(List, [{
	    key: 'format',
	    value: function format(name, value) {
	      if (this.children.length > 0) {
	        this.children.tail.format(name, value);
	      }
	    }
	  }, {
	    key: 'formats',
	    value: function formats() {
	      // We don't inherit from FormatBlot
	      return _defineProperty({}, this.statics.blotName, this.statics.formats(this.domNode));
	    }
	  }, {
	    key: 'insertBefore',
	    value: function insertBefore(blot, ref) {
	      if (blot instanceof ListItem) {
	        _get(List.prototype.__proto__ || Object.getPrototypeOf(List.prototype), 'insertBefore', this).call(this, blot, ref);
	      } else {
	        var index = ref == null ? this.length() : ref.offset(this);
	        var after = this.split(index);
	        after.parent.insertBefore(blot, after);
	      }
	    }
	  }, {
	    key: 'optimize',
	    value: function optimize(context) {
	      _get(List.prototype.__proto__ || Object.getPrototypeOf(List.prototype), 'optimize', this).call(this, context);
	      var next = this.next;
	      if (next != null && next.prev === this && next.statics.blotName === this.statics.blotName && next.domNode.tagName === this.domNode.tagName && next.domNode.getAttribute('data-checked') === this.domNode.getAttribute('data-checked')) {
	        next.moveChildren(this);
	        next.remove();
	      }
	    }
	  }, {
	    key: 'replace',
	    value: function replace(target) {
	      if (target.statics.blotName !== this.statics.blotName) {
	        var item = _parchment2.default.create(this.statics.defaultChild);
	        target.moveChildren(item);
	        this.appendChild(item);
	      }
	      _get(List.prototype.__proto__ || Object.getPrototypeOf(List.prototype), 'replace', this).call(this, target);
	    }
	  }]);
	
	  return List;
	}(_container2.default);
	
	List.blotName = 'list';
	List.scope = _parchment2.default.Scope.BLOCK_BLOT;
	List.tagName = ['OL', 'UL'];
	List.defaultChild = 'list-item';
	List.allowedChildren = [ListItem];
	
	exports.ListItem = ListItem;
	exports.default = List;
	
	/***/ }),
	/* 68 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _bold = __webpack_require__(56);
	
	var _bold2 = _interopRequireDefault(_bold);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Italic = function (_Bold) {
	  _inherits(Italic, _Bold);
	
	  function Italic() {
	    _classCallCheck(this, Italic);
	
	    return _possibleConstructorReturn(this, (Italic.__proto__ || Object.getPrototypeOf(Italic)).apply(this, arguments));
	  }
	
	  return Italic;
	}(_bold2.default);
	
	Italic.blotName = 'italic';
	Italic.tagName = ['EM', 'I'];
	
	exports.default = Italic;
	
	/***/ }),
	/* 69 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };
	
	var _inline = __webpack_require__(6);
	
	var _inline2 = _interopRequireDefault(_inline);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Script = function (_Inline) {
	  _inherits(Script, _Inline);
	
	  function Script() {
	    _classCallCheck(this, Script);
	
	    return _possibleConstructorReturn(this, (Script.__proto__ || Object.getPrototypeOf(Script)).apply(this, arguments));
	  }
	
	  _createClass(Script, null, [{
	    key: 'create',
	    value: function create(value) {
	      if (value === 'super') {
	        return document.createElement('sup');
	      } else if (value === 'sub') {
	        return document.createElement('sub');
	      } else {
	        return _get(Script.__proto__ || Object.getPrototypeOf(Script), 'create', this).call(this, value);
	      }
	    }
	  }, {
	    key: 'formats',
	    value: function formats(domNode) {
	      if (domNode.tagName === 'SUB') return 'sub';
	      if (domNode.tagName === 'SUP') return 'super';
	      return undefined;
	    }
	  }]);
	
	  return Script;
	}(_inline2.default);
	
	Script.blotName = 'script';
	Script.tagName = ['SUB', 'SUP'];
	
	exports.default = Script;
	
	/***/ }),
	/* 70 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _inline = __webpack_require__(6);
	
	var _inline2 = _interopRequireDefault(_inline);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Strike = function (_Inline) {
	  _inherits(Strike, _Inline);
	
	  function Strike() {
	    _classCallCheck(this, Strike);
	
	    return _possibleConstructorReturn(this, (Strike.__proto__ || Object.getPrototypeOf(Strike)).apply(this, arguments));
	  }
	
	  return Strike;
	}(_inline2.default);
	
	Strike.blotName = 'strike';
	Strike.tagName = 'S';
	
	exports.default = Strike;
	
	/***/ }),
	/* 71 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _inline = __webpack_require__(6);
	
	var _inline2 = _interopRequireDefault(_inline);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Underline = function (_Inline) {
	  _inherits(Underline, _Inline);
	
	  function Underline() {
	    _classCallCheck(this, Underline);
	
	    return _possibleConstructorReturn(this, (Underline.__proto__ || Object.getPrototypeOf(Underline)).apply(this, arguments));
	  }
	
	  return Underline;
	}(_inline2.default);
	
	Underline.blotName = 'underline';
	Underline.tagName = 'U';
	
	exports.default = Underline;
	
	/***/ }),
	/* 72 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };
	
	var _parchment = __webpack_require__(0);
	
	var _parchment2 = _interopRequireDefault(_parchment);
	
	var _link = __webpack_require__(27);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ATTRIBUTES = ['alt', 'height', 'width'];
	
	var Image = function (_Parchment$Embed) {
	  _inherits(Image, _Parchment$Embed);
	
	  function Image() {
	    _classCallCheck(this, Image);
	
	    return _possibleConstructorReturn(this, (Image.__proto__ || Object.getPrototypeOf(Image)).apply(this, arguments));
	  }
	
	  _createClass(Image, [{
	    key: 'format',
	    value: function format(name, value) {
	      if (ATTRIBUTES.indexOf(name) > -1) {
	        if (value) {
	          this.domNode.setAttribute(name, value);
	        } else {
	          this.domNode.removeAttribute(name);
	        }
	      } else {
	        _get(Image.prototype.__proto__ || Object.getPrototypeOf(Image.prototype), 'format', this).call(this, name, value);
	      }
	    }
	  }], [{
	    key: 'create',
	    value: function create(value) {
	      var node = _get(Image.__proto__ || Object.getPrototypeOf(Image), 'create', this).call(this, value);
	      if (typeof value === 'string') {
	        node.setAttribute('src', this.sanitize(value));
	      }
	      return node;
	    }
	  }, {
	    key: 'formats',
	    value: function formats(domNode) {
	      return ATTRIBUTES.reduce(function (formats, attribute) {
	        if (domNode.hasAttribute(attribute)) {
	          formats[attribute] = domNode.getAttribute(attribute);
	        }
	        return formats;
	      }, {});
	    }
	  }, {
	    key: 'match',
	    value: function match(url) {
	      return (/\.(jpe?g|gif|png)$/.test(url) || /^data:image\/.+;base64/.test(url)
	      );
	    }
	  }, {
	    key: 'sanitize',
	    value: function sanitize(url) {
	      return (0, _link.sanitize)(url, ['http', 'https', 'data']) ? url : '//:0';
	    }
	  }, {
	    key: 'value',
	    value: function value(domNode) {
	      return domNode.getAttribute('src');
	    }
	  }]);
	
	  return Image;
	}(_parchment2.default.Embed);
	
	Image.blotName = 'image';
	Image.tagName = 'IMG';
	
	exports.default = Image;
	
	/***/ }),
	/* 73 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };
	
	var _block = __webpack_require__(4);
	
	var _link = __webpack_require__(27);
	
	var _link2 = _interopRequireDefault(_link);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ATTRIBUTES = ['height', 'width'];
	
	var Video = function (_BlockEmbed) {
	  _inherits(Video, _BlockEmbed);
	
	  function Video() {
	    _classCallCheck(this, Video);
	
	    return _possibleConstructorReturn(this, (Video.__proto__ || Object.getPrototypeOf(Video)).apply(this, arguments));
	  }
	
	  _createClass(Video, [{
	    key: 'format',
	    value: function format(name, value) {
	      if (ATTRIBUTES.indexOf(name) > -1) {
	        if (value) {
	          this.domNode.setAttribute(name, value);
	        } else {
	          this.domNode.removeAttribute(name);
	        }
	      } else {
	        _get(Video.prototype.__proto__ || Object.getPrototypeOf(Video.prototype), 'format', this).call(this, name, value);
	      }
	    }
	  }], [{
	    key: 'create',
	    value: function create(value) {
	      var node = _get(Video.__proto__ || Object.getPrototypeOf(Video), 'create', this).call(this, value);
	      node.setAttribute('frameborder', '0');
	      node.setAttribute('allowfullscreen', true);
	      node.setAttribute('src', this.sanitize(value));
	      return node;
	    }
	  }, {
	    key: 'formats',
	    value: function formats(domNode) {
	      return ATTRIBUTES.reduce(function (formats, attribute) {
	        if (domNode.hasAttribute(attribute)) {
	          formats[attribute] = domNode.getAttribute(attribute);
	        }
	        return formats;
	      }, {});
	    }
	  }, {
	    key: 'sanitize',
	    value: function sanitize(url) {
	      return _link2.default.sanitize(url);
	    }
	  }, {
	    key: 'value',
	    value: function value(domNode) {
	      return domNode.getAttribute('src');
	    }
	  }]);
	
	  return Video;
	}(_block.BlockEmbed);
	
	Video.blotName = 'video';
	Video.className = 'ql-video';
	Video.tagName = 'IFRAME';
	
	exports.default = Video;
	
	/***/ }),
	/* 74 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.FormulaBlot = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };
	
	var _embed = __webpack_require__(35);
	
	var _embed2 = _interopRequireDefault(_embed);
	
	var _quill = __webpack_require__(5);
	
	var _quill2 = _interopRequireDefault(_quill);
	
	var _module = __webpack_require__(9);
	
	var _module2 = _interopRequireDefault(_module);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var FormulaBlot = function (_Embed) {
	  _inherits(FormulaBlot, _Embed);
	
	  function FormulaBlot() {
	    _classCallCheck(this, FormulaBlot);
	
	    return _possibleConstructorReturn(this, (FormulaBlot.__proto__ || Object.getPrototypeOf(FormulaBlot)).apply(this, arguments));
	  }
	
	  _createClass(FormulaBlot, null, [{
	    key: 'create',
	    value: function create(value) {
	      var node = _get(FormulaBlot.__proto__ || Object.getPrototypeOf(FormulaBlot), 'create', this).call(this, value);
	      if (typeof value === 'string') {
	        window.katex.render(value, node, {
	          throwOnError: false,
	          errorColor: '#f00'
	        });
	        node.setAttribute('data-value', value);
	      }
	      return node;
	    }
	  }, {
	    key: 'value',
	    value: function value(domNode) {
	      return domNode.getAttribute('data-value');
	    }
	  }]);
	
	  return FormulaBlot;
	}(_embed2.default);
	
	FormulaBlot.blotName = 'formula';
	FormulaBlot.className = 'ql-formula';
	FormulaBlot.tagName = 'SPAN';
	
	var Formula = function (_Module) {
	  _inherits(Formula, _Module);
	
	  _createClass(Formula, null, [{
	    key: 'register',
	    value: function register() {
	      _quill2.default.register(FormulaBlot, true);
	    }
	  }]);
	
	  function Formula() {
	    _classCallCheck(this, Formula);
	
	    var _this2 = _possibleConstructorReturn(this, (Formula.__proto__ || Object.getPrototypeOf(Formula)).call(this));
	
	    if (window.katex == null) {
	      throw new Error('Formula module requires KaTeX.');
	    }
	    return _this2;
	  }
	
	  return Formula;
	}(_module2.default);
	
	exports.FormulaBlot = FormulaBlot;
	exports.default = Formula;
	
	/***/ }),
	/* 75 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.CodeToken = exports.CodeBlock = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };
	
	var _parchment = __webpack_require__(0);
	
	var _parchment2 = _interopRequireDefault(_parchment);
	
	var _quill = __webpack_require__(5);
	
	var _quill2 = _interopRequireDefault(_quill);
	
	var _module = __webpack_require__(9);
	
	var _module2 = _interopRequireDefault(_module);
	
	var _code = __webpack_require__(13);
	
	var _code2 = _interopRequireDefault(_code);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var SyntaxCodeBlock = function (_CodeBlock) {
	  _inherits(SyntaxCodeBlock, _CodeBlock);
	
	  function SyntaxCodeBlock() {
	    _classCallCheck(this, SyntaxCodeBlock);
	
	    return _possibleConstructorReturn(this, (SyntaxCodeBlock.__proto__ || Object.getPrototypeOf(SyntaxCodeBlock)).apply(this, arguments));
	  }
	
	  _createClass(SyntaxCodeBlock, [{
	    key: 'replaceWith',
	    value: function replaceWith(block) {
	      this.domNode.textContent = this.domNode.textContent;
	      this.attach();
	      _get(SyntaxCodeBlock.prototype.__proto__ || Object.getPrototypeOf(SyntaxCodeBlock.prototype), 'replaceWith', this).call(this, block);
	    }
	  }, {
	    key: 'highlight',
	    value: function highlight(_highlight) {
	      var text = this.domNode.textContent;
	      if (this.cachedText !== text) {
	        if (text.trim().length > 0 || this.cachedText == null) {
	          this.domNode.innerHTML = _highlight(text);
	          this.domNode.normalize();
	          this.attach();
	        }
	        this.cachedText = text;
	      }
	    }
	  }]);
	
	  return SyntaxCodeBlock;
	}(_code2.default);
	
	SyntaxCodeBlock.className = 'ql-syntax';
	
	var CodeToken = new _parchment2.default.Attributor.Class('token', 'hljs', {
	  scope: _parchment2.default.Scope.INLINE
	});
	
	var Syntax = function (_Module) {
	  _inherits(Syntax, _Module);
	
	  _createClass(Syntax, null, [{
	    key: 'register',
	    value: function register() {
	      _quill2.default.register(CodeToken, true);
	      _quill2.default.register(SyntaxCodeBlock, true);
	    }
	  }]);
	
	  function Syntax(quill, options) {
	    _classCallCheck(this, Syntax);
	
	    var _this2 = _possibleConstructorReturn(this, (Syntax.__proto__ || Object.getPrototypeOf(Syntax)).call(this, quill, options));
	
	    if (typeof _this2.options.highlight !== 'function') {
	      throw new Error('Syntax module requires highlight.js. Please include the library on the page before Quill.');
	    }
	    var timer = null;
	    _this2.quill.on(_quill2.default.events.SCROLL_OPTIMIZE, function () {
	      clearTimeout(timer);
	      timer = setTimeout(function () {
	        _this2.highlight();
	        timer = null;
	      }, _this2.options.interval);
	    });
	    _this2.highlight();
	    return _this2;
	  }
	
	  _createClass(Syntax, [{
	    key: 'highlight',
	    value: function highlight() {
	      var _this3 = this;
	
	      if (this.quill.selection.composing) return;
	      this.quill.update(_quill2.default.sources.USER);
	      var range = this.quill.getSelection();
	      this.quill.scroll.descendants(SyntaxCodeBlock).forEach(function (code) {
	        code.highlight(_this3.options.highlight);
	      });
	      this.quill.update(_quill2.default.sources.SILENT);
	      if (range != null) {
	        this.quill.setSelection(range, _quill2.default.sources.SILENT);
	      }
	    }
	  }]);
	
	  return Syntax;
	}(_module2.default);
	
	Syntax.DEFAULTS = {
	  highlight: function () {
	    if (window.hljs == null) return null;
	    return function (text) {
	      var result = window.hljs.highlightAuto(text);
	      return result.value;
	    };
	  }(),
	  interval: 1000
	};
	
	exports.CodeBlock = SyntaxCodeBlock;
	exports.CodeToken = CodeToken;
	exports.default = Syntax;
	
	/***/ }),
	/* 76 */
	/***/ (function(module, exports) {
	
	module.exports = "<svg viewbox=\"0 0 18 18\"> <line class=ql-stroke x1=3 x2=15 y1=9 y2=9></line> <line class=ql-stroke x1=3 x2=13 y1=14 y2=14></line> <line class=ql-stroke x1=3 x2=9 y1=4 y2=4></line> </svg>";
	
	/***/ }),
	/* 77 */
	/***/ (function(module, exports) {
	
	module.exports = "<svg viewbox=\"0 0 18 18\"> <line class=ql-stroke x1=15 x2=3 y1=9 y2=9></line> <line class=ql-stroke x1=14 x2=4 y1=14 y2=14></line> <line class=ql-stroke x1=12 x2=6 y1=4 y2=4></line> </svg>";
	
	/***/ }),
	/* 78 */
	/***/ (function(module, exports) {
	
	module.exports = "<svg viewbox=\"0 0 18 18\"> <line class=ql-stroke x1=15 x2=3 y1=9 y2=9></line> <line class=ql-stroke x1=15 x2=5 y1=14 y2=14></line> <line class=ql-stroke x1=15 x2=9 y1=4 y2=4></line> </svg>";
	
	/***/ }),
	/* 79 */
	/***/ (function(module, exports) {
	
	module.exports = "<svg viewbox=\"0 0 18 18\"> <line class=ql-stroke x1=15 x2=3 y1=9 y2=9></line> <line class=ql-stroke x1=15 x2=3 y1=14 y2=14></line> <line class=ql-stroke x1=15 x2=3 y1=4 y2=4></line> </svg>";
	
	/***/ }),
	/* 80 */
	/***/ (function(module, exports) {
	
	module.exports = "<svg viewbox=\"0 0 18 18\"> <g class=\"ql-fill ql-color-label\"> <polygon points=\"6 6.868 6 6 5 6 5 7 5.942 7 6 6.868\"></polygon> <rect height=1 width=1 x=4 y=4></rect> <polygon points=\"6.817 5 6 5 6 6 6.38 6 6.817 5\"></polygon> <rect height=1 width=1 x=2 y=6></rect> <rect height=1 width=1 x=3 y=5></rect> <rect height=1 width=1 x=4 y=7></rect> <polygon points=\"4 11.439 4 11 3 11 3 12 3.755 12 4 11.439\"></polygon> <rect height=1 width=1 x=2 y=12></rect> <rect height=1 width=1 x=2 y=9></rect> <rect height=1 width=1 x=2 y=15></rect> <polygon points=\"4.63 10 4 10 4 11 4.192 11 4.63 10\"></polygon> <rect height=1 width=1 x=3 y=8></rect> <path d=M10.832,4.2L11,4.582V4H10.708A1.948,1.948,0,0,1,10.832,4.2Z></path> <path d=M7,4.582L7.168,4.2A1.929,1.929,0,0,1,7.292,4H7V4.582Z></path> <path d=M8,13H7.683l-0.351.8a1.933,1.933,0,0,1-.124.2H8V13Z></path> <rect height=1 width=1 x=12 y=2></rect> <rect height=1 width=1 x=11 y=3></rect> <path d=M9,3H8V3.282A1.985,1.985,0,0,1,9,3Z></path> <rect height=1 width=1 x=2 y=3></rect> <rect height=1 width=1 x=6 y=2></rect> <rect height=1 width=1 x=3 y=2></rect> <rect height=1 width=1 x=5 y=3></rect> <rect height=1 width=1 x=9 y=2></rect> <rect height=1 width=1 x=15 y=14></rect> <polygon points=\"13.447 10.174 13.469 10.225 13.472 10.232 13.808 11 14 11 14 10 13.37 10 13.447 10.174\"></polygon> <rect height=1 width=1 x=13 y=7></rect> <rect height=1 width=1 x=15 y=5></rect> <rect height=1 width=1 x=14 y=6></rect> <rect height=1 width=1 x=15 y=8></rect> <rect height=1 width=1 x=14 y=9></rect> <path d=M3.775,14H3v1H4V14.314A1.97,1.97,0,0,1,3.775,14Z></path> <rect height=1 width=1 x=14 y=3></rect> <polygon points=\"12 6.868 12 6 11.62 6 12 6.868\"></polygon> <rect height=1 width=1 x=15 y=2></rect> <rect height=1 width=1 x=12 y=5></rect> <rect height=1 width=1 x=13 y=4></rect> <polygon points=\"12.933 9 13 9 13 8 12.495 8 12.933 9\"></polygon> <rect height=1 width=1 x=9 y=14></rect> <rect height=1 width=1 x=8 y=15></rect> <path d=M6,14.926V15H7V14.316A1.993,1.993,0,0,1,6,14.926Z></path> <rect height=1 width=1 x=5 y=15></rect> <path d=M10.668,13.8L10.317,13H10v1h0.792A1.947,1.947,0,0,1,10.668,13.8Z></path> <rect height=1 width=1 x=11 y=15></rect> <path d=M14.332,12.2a1.99,1.99,0,0,1,.166.8H15V12H14.245Z></path> <rect height=1 width=1 x=14 y=15></rect> <rect height=1 width=1 x=15 y=11></rect> </g> <polyline class=ql-stroke points=\"5.5 13 9 5 12.5 13\"></polyline> <line class=ql-stroke x1=11.63 x2=6.38 y1=11 y2=11></line> </svg>";
	
	/***/ }),
	/* 81 */
	/***/ (function(module, exports) {
	
	module.exports = "<svg viewbox=\"0 0 18 18\"> <rect class=\"ql-fill ql-stroke\" height=3 width=3 x=4 y=5></rect> <rect class=\"ql-fill ql-stroke\" height=3 width=3 x=11 y=5></rect> <path class=\"ql-even ql-fill ql-stroke\" d=M7,8c0,4.031-3,5-3,5></path> <path class=\"ql-even ql-fill ql-stroke\" d=M14,8c0,4.031-3,5-3,5></path> </svg>";
	
	/***/ }),
	/* 82 */
	/***/ (function(module, exports) {
	
	module.exports = "<svg viewbox=\"0 0 18 18\"> <path class=ql-stroke d=M5,4H9.5A2.5,2.5,0,0,1,12,6.5v0A2.5,2.5,0,0,1,9.5,9H5A0,0,0,0,1,5,9V4A0,0,0,0,1,5,4Z></path> <path class=ql-stroke d=M5,9h5.5A2.5,2.5,0,0,1,13,11.5v0A2.5,2.5,0,0,1,10.5,14H5a0,0,0,0,1,0,0V9A0,0,0,0,1,5,9Z></path> </svg>";
	
	/***/ }),
	/* 83 */
	/***/ (function(module, exports) {
	
	module.exports = "<svg class=\"\" viewbox=\"0 0 18 18\"> <line class=ql-stroke x1=5 x2=13 y1=3 y2=3></line> <line class=ql-stroke x1=6 x2=9.35 y1=12 y2=3></line> <line class=ql-stroke x1=11 x2=15 y1=11 y2=15></line> <line class=ql-stroke x1=15 x2=11 y1=11 y2=15></line> <rect class=ql-fill height=1 rx=0.5 ry=0.5 width=7 x=2 y=14></rect> </svg>";
	
	/***/ }),
	/* 84 */
	/***/ (function(module, exports) {
	
	module.exports = "<svg viewbox=\"0 0 18 18\"> <line class=\"ql-color-label ql-stroke ql-transparent\" x1=3 x2=15 y1=15 y2=15></line> <polyline class=ql-stroke points=\"5.5 11 9 3 12.5 11\"></polyline> <line class=ql-stroke x1=11.63 x2=6.38 y1=9 y2=9></line> </svg>";
	
	/***/ }),
	/* 85 */
	/***/ (function(module, exports) {
	
	module.exports = "<svg viewbox=\"0 0 18 18\"> <polygon class=\"ql-stroke ql-fill\" points=\"3 11 5 9 3 7 3 11\"></polygon> <line class=\"ql-stroke ql-fill\" x1=15 x2=11 y1=4 y2=4></line> <path class=ql-fill d=M11,3a3,3,0,0,0,0,6h1V3H11Z></path> <rect class=ql-fill height=11 width=1 x=11 y=4></rect> <rect class=ql-fill height=11 width=1 x=13 y=4></rect> </svg>";
	
	/***/ }),
	/* 86 */
	/***/ (function(module, exports) {
	
	module.exports = "<svg viewbox=\"0 0 18 18\"> <polygon class=\"ql-stroke ql-fill\" points=\"15 12 13 10 15 8 15 12\"></polygon> <line class=\"ql-stroke ql-fill\" x1=9 x2=5 y1=4 y2=4></line> <path class=ql-fill d=M5,3A3,3,0,0,0,5,9H6V3H5Z></path> <rect class=ql-fill height=11 width=1 x=5 y=4></rect> <rect class=ql-fill height=11 width=1 x=7 y=4></rect> </svg>";
	
	/***/ }),
	/* 87 */
	/***/ (function(module, exports) {
	
	module.exports = "<svg viewbox=\"0 0 18 18\"> <path class=ql-fill d=M14,16H4a1,1,0,0,1,0-2H14A1,1,0,0,1,14,16Z /> <path class=ql-fill d=M14,4H4A1,1,0,0,1,4,2H14A1,1,0,0,1,14,4Z /> <rect class=ql-fill x=3 y=6 width=12 height=6 rx=1 ry=1 /> </svg>";
	
	/***/ }),
	/* 88 */
	/***/ (function(module, exports) {
	
	module.exports = "<svg viewbox=\"0 0 18 18\"> <path class=ql-fill d=M13,16H5a1,1,0,0,1,0-2h8A1,1,0,0,1,13,16Z /> <path class=ql-fill d=M13,4H5A1,1,0,0,1,5,2h8A1,1,0,0,1,13,4Z /> <rect class=ql-fill x=2 y=6 width=14 height=6 rx=1 ry=1 /> </svg>";
	
	/***/ }),
	/* 89 */
	/***/ (function(module, exports) {
	
	module.exports = "<svg viewbox=\"0 0 18 18\"> <path class=ql-fill d=M15,8H13a1,1,0,0,1,0-2h2A1,1,0,0,1,15,8Z /> <path class=ql-fill d=M15,12H13a1,1,0,0,1,0-2h2A1,1,0,0,1,15,12Z /> <path class=ql-fill d=M15,16H5a1,1,0,0,1,0-2H15A1,1,0,0,1,15,16Z /> <path class=ql-fill d=M15,4H5A1,1,0,0,1,5,2H15A1,1,0,0,1,15,4Z /> <rect class=ql-fill x=2 y=6 width=8 height=6 rx=1 ry=1 /> </svg>";
	
	/***/ }),
	/* 90 */
	/***/ (function(module, exports) {
	
	module.exports = "<svg viewbox=\"0 0 18 18\"> <path class=ql-fill d=M5,8H3A1,1,0,0,1,3,6H5A1,1,0,0,1,5,8Z /> <path class=ql-fill d=M5,12H3a1,1,0,0,1,0-2H5A1,1,0,0,1,5,12Z /> <path class=ql-fill d=M13,16H3a1,1,0,0,1,0-2H13A1,1,0,0,1,13,16Z /> <path class=ql-fill d=M13,4H3A1,1,0,0,1,3,2H13A1,1,0,0,1,13,4Z /> <rect class=ql-fill x=8 y=6 width=8 height=6 rx=1 ry=1 transform=\"translate(24 18) rotate(-180)\"/> </svg>";
	
	/***/ }),
	/* 91 */
	/***/ (function(module, exports) {
	
	module.exports = "<svg viewbox=\"0 0 18 18\"> <path class=ql-fill d=M11.759,2.482a2.561,2.561,0,0,0-3.53.607A7.656,7.656,0,0,0,6.8,6.2C6.109,9.188,5.275,14.677,4.15,14.927a1.545,1.545,0,0,0-1.3-.933A0.922,0.922,0,0,0,2,15.036S1.954,16,4.119,16s3.091-2.691,3.7-5.553c0.177-.826.36-1.726,0.554-2.6L8.775,6.2c0.381-1.421.807-2.521,1.306-2.676a1.014,1.014,0,0,0,1.02.56A0.966,0.966,0,0,0,11.759,2.482Z></path> <rect class=ql-fill height=1.6 rx=0.8 ry=0.8 width=5 x=5.15 y=6.2></rect> <path class=ql-fill d=M13.663,12.027a1.662,1.662,0,0,1,.266-0.276q0.193,0.069.456,0.138a2.1,2.1,0,0,0,.535.069,1.075,1.075,0,0,0,.767-0.3,1.044,1.044,0,0,0,.314-0.8,0.84,0.84,0,0,0-.238-0.619,0.8,0.8,0,0,0-.594-0.239,1.154,1.154,0,0,0-.781.3,4.607,4.607,0,0,0-.781,1q-0.091.15-.218,0.346l-0.246.38c-0.068-.288-0.137-0.582-0.212-0.885-0.459-1.847-2.494-.984-2.941-0.8-0.482.2-.353,0.647-0.094,0.529a0.869,0.869,0,0,1,1.281.585c0.217,0.751.377,1.436,0.527,2.038a5.688,5.688,0,0,1-.362.467,2.69,2.69,0,0,1-.264.271q-0.221-.08-0.471-0.147a2.029,2.029,0,0,0-.522-0.066,1.079,1.079,0,0,0-.768.3A1.058,1.058,0,0,0,9,15.131a0.82,0.82,0,0,0,.832.852,1.134,1.134,0,0,0,.787-0.3,5.11,5.11,0,0,0,.776-0.993q0.141-.219.215-0.34c0.046-.076.122-0.194,0.223-0.346a2.786,2.786,0,0,0,.918,1.726,2.582,2.582,0,0,0,2.376-.185c0.317-.181.212-0.565,0-0.494A0.807,0.807,0,0,1,14.176,15a5.159,5.159,0,0,1-.913-2.446l0,0Q13.487,12.24,13.663,12.027Z></path> </svg>";
	
	/***/ }),
	/* 92 */
	/***/ (function(module, exports) {
	
	module.exports = "<svg viewBox=\"0 0 18 18\"> <path class=ql-fill d=M10,4V14a1,1,0,0,1-2,0V10H3v4a1,1,0,0,1-2,0V4A1,1,0,0,1,3,4V8H8V4a1,1,0,0,1,2,0Zm6.06787,9.209H14.98975V7.59863a.54085.54085,0,0,0-.605-.60547h-.62744a1.01119,1.01119,0,0,0-.748.29688L11.645,8.56641a.5435.5435,0,0,0-.022.8584l.28613.30762a.53861.53861,0,0,0,.84717.0332l.09912-.08789a1.2137,1.2137,0,0,0,.2417-.35254h.02246s-.01123.30859-.01123.60547V13.209H12.041a.54085.54085,0,0,0-.605.60547v.43945a.54085.54085,0,0,0,.605.60547h4.02686a.54085.54085,0,0,0,.605-.60547v-.43945A.54085.54085,0,0,0,16.06787,13.209Z /> </svg>";
	
	/***/ }),
	/* 93 */
	/***/ (function(module, exports) {
	
	module.exports = "<svg viewBox=\"0 0 18 18\"> <path class=ql-fill d=M16.73975,13.81445v.43945a.54085.54085,0,0,1-.605.60547H11.855a.58392.58392,0,0,1-.64893-.60547V14.0127c0-2.90527,3.39941-3.42187,3.39941-4.55469a.77675.77675,0,0,0-.84717-.78125,1.17684,1.17684,0,0,0-.83594.38477c-.2749.26367-.561.374-.85791.13184l-.4292-.34082c-.30811-.24219-.38525-.51758-.1543-.81445a2.97155,2.97155,0,0,1,2.45361-1.17676,2.45393,2.45393,0,0,1,2.68408,2.40918c0,2.45312-3.1792,2.92676-3.27832,3.93848h2.79443A.54085.54085,0,0,1,16.73975,13.81445ZM9,3A.99974.99974,0,0,0,8,4V8H3V4A1,1,0,0,0,1,4V14a1,1,0,0,0,2,0V10H8v4a1,1,0,0,0,2,0V4A.99974.99974,0,0,0,9,3Z /> </svg>";
	
	/***/ }),
	/* 94 */
	/***/ (function(module, exports) {
	
	module.exports = "<svg viewbox=\"0 0 18 18\"> <line class=ql-stroke x1=7 x2=13 y1=4 y2=4></line> <line class=ql-stroke x1=5 x2=11 y1=14 y2=14></line> <line class=ql-stroke x1=8 x2=10 y1=14 y2=4></line> </svg>";
	
	/***/ }),
	/* 95 */
	/***/ (function(module, exports) {
	
	module.exports = "<svg viewbox=\"0 0 18 18\"> <rect class=ql-stroke height=10 width=12 x=3 y=4></rect> <circle class=ql-fill cx=6 cy=7 r=1></circle> <polyline class=\"ql-even ql-fill\" points=\"5 12 5 11 7 9 8 10 11 7 13 9 13 12 5 12\"></polyline> </svg>";
	
	/***/ }),
	/* 96 */
	/***/ (function(module, exports) {
	
	module.exports = "<svg viewbox=\"0 0 18 18\"> <line class=ql-stroke x1=3 x2=15 y1=14 y2=14></line> <line class=ql-stroke x1=3 x2=15 y1=4 y2=4></line> <line class=ql-stroke x1=9 x2=15 y1=9 y2=9></line> <polyline class=\"ql-fill ql-stroke\" points=\"3 7 3 11 5 9 3 7\"></polyline> </svg>";
	
	/***/ }),
	/* 97 */
	/***/ (function(module, exports) {
	
	module.exports = "<svg viewbox=\"0 0 18 18\"> <line class=ql-stroke x1=3 x2=15 y1=14 y2=14></line> <line class=ql-stroke x1=3 x2=15 y1=4 y2=4></line> <line class=ql-stroke x1=9 x2=15 y1=9 y2=9></line> <polyline class=ql-stroke points=\"5 7 5 11 3 9 5 7\"></polyline> </svg>";
	
	/***/ }),
	/* 98 */
	/***/ (function(module, exports) {
	
	module.exports = "<svg viewbox=\"0 0 18 18\"> <line class=ql-stroke x1=7 x2=11 y1=7 y2=11></line> <path class=\"ql-even ql-stroke\" d=M8.9,4.577a3.476,3.476,0,0,1,.36,4.679A3.476,3.476,0,0,1,4.577,8.9C3.185,7.5,2.035,6.4,4.217,4.217S7.5,3.185,8.9,4.577Z></path> <path class=\"ql-even ql-stroke\" d=M13.423,9.1a3.476,3.476,0,0,0-4.679-.36,3.476,3.476,0,0,0,.36,4.679c1.392,1.392,2.5,2.542,4.679.36S14.815,10.5,13.423,9.1Z></path> </svg>";
	
	/***/ }),
	/* 99 */
	/***/ (function(module, exports) {
	
	module.exports = "<svg viewbox=\"0 0 18 18\"> <line class=ql-stroke x1=7 x2=15 y1=4 y2=4></line> <line class=ql-stroke x1=7 x2=15 y1=9 y2=9></line> <line class=ql-stroke x1=7 x2=15 y1=14 y2=14></line> <line class=\"ql-stroke ql-thin\" x1=2.5 x2=4.5 y1=5.5 y2=5.5></line> <path class=ql-fill d=M3.5,6A0.5,0.5,0,0,1,3,5.5V3.085l-0.276.138A0.5,0.5,0,0,1,2.053,3c-0.124-.247-0.023-0.324.224-0.447l1-.5A0.5,0.5,0,0,1,4,2.5v3A0.5,0.5,0,0,1,3.5,6Z></path> <path class=\"ql-stroke ql-thin\" d=M4.5,10.5h-2c0-.234,1.85-1.076,1.85-2.234A0.959,0.959,0,0,0,2.5,8.156></path> <path class=\"ql-stroke ql-thin\" d=M2.5,14.846a0.959,0.959,0,0,0,1.85-.109A0.7,0.7,0,0,0,3.75,14a0.688,0.688,0,0,0,.6-0.736,0.959,0.959,0,0,0-1.85-.109></path> </svg>";
	
	/***/ }),
	/* 100 */
	/***/ (function(module, exports) {
	
	module.exports = "<svg viewbox=\"0 0 18 18\"> <line class=ql-stroke x1=6 x2=15 y1=4 y2=4></line> <line class=ql-stroke x1=6 x2=15 y1=9 y2=9></line> <line class=ql-stroke x1=6 x2=15 y1=14 y2=14></line> <line class=ql-stroke x1=3 x2=3 y1=4 y2=4></line> <line class=ql-stroke x1=3 x2=3 y1=9 y2=9></line> <line class=ql-stroke x1=3 x2=3 y1=14 y2=14></line> </svg>";
	
	/***/ }),
	/* 101 */
	/***/ (function(module, exports) {
	
	module.exports = "<svg class=\"\" viewbox=\"0 0 18 18\"> <line class=ql-stroke x1=9 x2=15 y1=4 y2=4></line> <polyline class=ql-stroke points=\"3 4 4 5 6 3\"></polyline> <line class=ql-stroke x1=9 x2=15 y1=14 y2=14></line> <polyline class=ql-stroke points=\"3 14 4 15 6 13\"></polyline> <line class=ql-stroke x1=9 x2=15 y1=9 y2=9></line> <polyline class=ql-stroke points=\"3 9 4 10 6 8\"></polyline> </svg>";
	
	/***/ }),
	/* 102 */
	/***/ (function(module, exports) {
	
	module.exports = "<svg viewbox=\"0 0 18 18\"> <path class=ql-fill d=M15.5,15H13.861a3.858,3.858,0,0,0,1.914-2.975,1.8,1.8,0,0,0-1.6-1.751A1.921,1.921,0,0,0,12.021,11.7a0.50013,0.50013,0,1,0,.957.291h0a0.914,0.914,0,0,1,1.053-.725,0.81,0.81,0,0,1,.744.762c0,1.076-1.16971,1.86982-1.93971,2.43082A1.45639,1.45639,0,0,0,12,15.5a0.5,0.5,0,0,0,.5.5h3A0.5,0.5,0,0,0,15.5,15Z /> <path class=ql-fill d=M9.65,5.241a1,1,0,0,0-1.409.108L6,7.964,3.759,5.349A1,1,0,0,0,2.192,6.59178Q2.21541,6.6213,2.241,6.649L4.684,9.5,2.241,12.35A1,1,0,0,0,3.71,13.70722q0.02557-.02768.049-0.05722L6,11.036,8.241,13.65a1,1,0,1,0,1.567-1.24277Q9.78459,12.3777,9.759,12.35L7.316,9.5,9.759,6.651A1,1,0,0,0,9.65,5.241Z /> </svg>";
	
	/***/ }),
	/* 103 */
	/***/ (function(module, exports) {
	
	module.exports = "<svg viewbox=\"0 0 18 18\"> <path class=ql-fill d=M15.5,7H13.861a4.015,4.015,0,0,0,1.914-2.975,1.8,1.8,0,0,0-1.6-1.751A1.922,1.922,0,0,0,12.021,3.7a0.5,0.5,0,1,0,.957.291,0.917,0.917,0,0,1,1.053-.725,0.81,0.81,0,0,1,.744.762c0,1.077-1.164,1.925-1.934,2.486A1.423,1.423,0,0,0,12,7.5a0.5,0.5,0,0,0,.5.5h3A0.5,0.5,0,0,0,15.5,7Z /> <path class=ql-fill d=M9.651,5.241a1,1,0,0,0-1.41.108L6,7.964,3.759,5.349a1,1,0,1,0-1.519,1.3L4.683,9.5,2.241,12.35a1,1,0,1,0,1.519,1.3L6,11.036,8.241,13.65a1,1,0,0,0,1.519-1.3L7.317,9.5,9.759,6.651A1,1,0,0,0,9.651,5.241Z /> </svg>";
	
	/***/ }),
	/* 104 */
	/***/ (function(module, exports) {
	
	module.exports = "<svg viewbox=\"0 0 18 18\"> <line class=\"ql-stroke ql-thin\" x1=15.5 x2=2.5 y1=8.5 y2=9.5></line> <path class=ql-fill d=M9.007,8C6.542,7.791,6,7.519,6,6.5,6,5.792,7.283,5,9,5c1.571,0,2.765.679,2.969,1.309a1,1,0,0,0,1.9-.617C13.356,4.106,11.354,3,9,3,6.2,3,4,4.538,4,6.5a3.2,3.2,0,0,0,.5,1.843Z></path> <path class=ql-fill d=M8.984,10C11.457,10.208,12,10.479,12,11.5c0,0.708-1.283,1.5-3,1.5-1.571,0-2.765-.679-2.969-1.309a1,1,0,1,0-1.9.617C4.644,13.894,6.646,15,9,15c2.8,0,5-1.538,5-3.5a3.2,3.2,0,0,0-.5-1.843Z></path> </svg>";
	
	/***/ }),
	/* 105 */
	/***/ (function(module, exports) {
	
	module.exports = "<svg viewbox=\"0 0 18 18\"> <path class=ql-stroke d=M5,3V9a4.012,4.012,0,0,0,4,4H9a4.012,4.012,0,0,0,4-4V3></path> <rect class=ql-fill height=1 rx=0.5 ry=0.5 width=12 x=3 y=15></rect> </svg>";
	
	/***/ }),
	/* 106 */
	/***/ (function(module, exports) {
	
	module.exports = "<svg viewbox=\"0 0 18 18\"> <rect class=ql-stroke height=12 width=12 x=3 y=3></rect> <rect class=ql-fill height=12 width=1 x=5 y=3></rect> <rect class=ql-fill height=12 width=1 x=12 y=3></rect> <rect class=ql-fill height=2 width=8 x=5 y=8></rect> <rect class=ql-fill height=1 width=3 x=3 y=5></rect> <rect class=ql-fill height=1 width=3 x=3 y=7></rect> <rect class=ql-fill height=1 width=3 x=3 y=10></rect> <rect class=ql-fill height=1 width=3 x=3 y=12></rect> <rect class=ql-fill height=1 width=3 x=12 y=5></rect> <rect class=ql-fill height=1 width=3 x=12 y=7></rect> <rect class=ql-fill height=1 width=3 x=12 y=10></rect> <rect class=ql-fill height=1 width=3 x=12 y=12></rect> </svg>";
	
	/***/ }),
	/* 107 */
	/***/ (function(module, exports) {
	
	module.exports = "<svg viewbox=\"0 0 18 18\"> <polygon class=ql-stroke points=\"7 11 9 13 11 11 7 11\"></polygon> <polygon class=ql-stroke points=\"7 7 9 5 11 7 7 7\"></polygon> </svg>";
	
	/***/ }),
	/* 108 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.BubbleTooltip = undefined;
	
	var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _extend = __webpack_require__(3);
	
	var _extend2 = _interopRequireDefault(_extend);
	
	var _emitter = __webpack_require__(8);
	
	var _emitter2 = _interopRequireDefault(_emitter);
	
	var _base = __webpack_require__(43);
	
	var _base2 = _interopRequireDefault(_base);
	
	var _selection = __webpack_require__(15);
	
	var _icons = __webpack_require__(41);
	
	var _icons2 = _interopRequireDefault(_icons);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var TOOLBAR_CONFIG = [['bold', 'italic', 'link'], [{ header: 1 }, { header: 2 }, 'blockquote']];
	
	var BubbleTheme = function (_BaseTheme) {
	  _inherits(BubbleTheme, _BaseTheme);
	
	  function BubbleTheme(quill, options) {
	    _classCallCheck(this, BubbleTheme);
	
	    if (options.modules.toolbar != null && options.modules.toolbar.container == null) {
	      options.modules.toolbar.container = TOOLBAR_CONFIG;
	    }
	
	    var _this = _possibleConstructorReturn(this, (BubbleTheme.__proto__ || Object.getPrototypeOf(BubbleTheme)).call(this, quill, options));
	
	    _this.quill.container.classList.add('ql-bubble');
	    return _this;
	  }
	
	  _createClass(BubbleTheme, [{
	    key: 'extendToolbar',
	    value: function extendToolbar(toolbar) {
	      this.tooltip = new BubbleTooltip(this.quill, this.options.bounds);
	      this.tooltip.root.appendChild(toolbar.container);
	      this.buildButtons([].slice.call(toolbar.container.querySelectorAll('button')), _icons2.default);
	      this.buildPickers([].slice.call(toolbar.container.querySelectorAll('select')), _icons2.default);
	    }
	  }]);
	
	  return BubbleTheme;
	}(_base2.default);
	
	BubbleTheme.DEFAULTS = (0, _extend2.default)(true, {}, _base2.default.DEFAULTS, {
	  modules: {
	    toolbar: {
	      handlers: {
	        link: function link(value) {
	          if (!value) {
	            this.quill.format('link', false);
	          } else {
	            this.quill.theme.tooltip.edit();
	          }
	        }
	      }
	    }
	  }
	});
	
	var BubbleTooltip = function (_BaseTooltip) {
	  _inherits(BubbleTooltip, _BaseTooltip);
	
	  function BubbleTooltip(quill, bounds) {
	    _classCallCheck(this, BubbleTooltip);
	
	    var _this2 = _possibleConstructorReturn(this, (BubbleTooltip.__proto__ || Object.getPrototypeOf(BubbleTooltip)).call(this, quill, bounds));
	
	    _this2.quill.on(_emitter2.default.events.EDITOR_CHANGE, function (type, range, oldRange, source) {
	      if (type !== _emitter2.default.events.SELECTION_CHANGE) return;
	      if (range != null && range.length > 0 && source === _emitter2.default.sources.USER) {
	        _this2.show();
	        // Lock our width so we will expand beyond our offsetParent boundaries
	        _this2.root.style.left = '0px';
	        _this2.root.style.width = '';
	        _this2.root.style.width = _this2.root.offsetWidth + 'px';
	        var lines = _this2.quill.getLines(range.index, range.length);
	        if (lines.length === 1) {
	          _this2.position(_this2.quill.getBounds(range));
	        } else {
	          var lastLine = lines[lines.length - 1];
	          var index = _this2.quill.getIndex(lastLine);
	          var length = Math.min(lastLine.length() - 1, range.index + range.length - index);
	          var _bounds = _this2.quill.getBounds(new _selection.Range(index, length));
	          _this2.position(_bounds);
	        }
	      } else if (document.activeElement !== _this2.textbox && _this2.quill.hasFocus()) {
	        _this2.hide();
	      }
	    });
	    return _this2;
	  }
	
	  _createClass(BubbleTooltip, [{
	    key: 'listen',
	    value: function listen() {
	      var _this3 = this;
	
	      _get(BubbleTooltip.prototype.__proto__ || Object.getPrototypeOf(BubbleTooltip.prototype), 'listen', this).call(this);
	      this.root.querySelector('.ql-close').addEventListener('click', function () {
	        _this3.root.classList.remove('ql-editing');
	      });
	      this.quill.on(_emitter2.default.events.SCROLL_OPTIMIZE, function () {
	        // Let selection be restored by toolbar handlers before repositioning
	        setTimeout(function () {
	          if (_this3.root.classList.contains('ql-hidden')) return;
	          var range = _this3.quill.getSelection();
	          if (range != null) {
	            _this3.position(_this3.quill.getBounds(range));
	          }
	        }, 1);
	      });
	    }
	  }, {
	    key: 'cancel',
	    value: function cancel() {
	      this.show();
	    }
	  }, {
	    key: 'position',
	    value: function position(reference) {
	      var shift = _get(BubbleTooltip.prototype.__proto__ || Object.getPrototypeOf(BubbleTooltip.prototype), 'position', this).call(this, reference);
	      var arrow = this.root.querySelector('.ql-tooltip-arrow');
	      arrow.style.marginLeft = '';
	      if (shift === 0) return shift;
	      arrow.style.marginLeft = -1 * shift - arrow.offsetWidth / 2 + 'px';
	    }
	  }]);
	
	  return BubbleTooltip;
	}(_base.BaseTooltip);
	
	BubbleTooltip.TEMPLATE = ['<span class="ql-tooltip-arrow"></span>', '<div class="ql-tooltip-editor">', '<input type="text" data-formula="e=mc^2" data-link="https://quilljs.com" data-video="Embed URL">', '<a class="ql-close"></a>', '</div>'].join('');
	
	exports.BubbleTooltip = BubbleTooltip;
	exports.default = BubbleTheme;
	
	/***/ }),
	/* 109 */
	/***/ (function(module, exports, __webpack_require__) {
	
	module.exports = __webpack_require__(63);
	
	
	/***/ })
	/******/ ])["default"];
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(290).Buffer))

/***/ },
/* 381 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Copyright (c) 2015-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	(function(f) {
	  if (true) {
	    module.exports = f(__webpack_require__(1));
	    /* global define */
	  } else if (typeof define === 'function' && define.amd) {
	    define(['react'], f);
	  } else {
	    var g;
	    if (typeof window !== 'undefined') {
	      g = window;
	    } else if (typeof global !== 'undefined') {
	      g = global;
	    } else if (typeof self !== 'undefined') {
	      g = self;
	    } else {
	      g = this;
	    }
	
	    if (typeof g.React === 'undefined') {
	      throw Error('React module should be required before ReactDOMFactories');
	    }
	
	    g.ReactDOMFactories = f(g.React);
	  }
	})(function(React) {
	  /**
	   * Create a factory that creates HTML tag elements.
	   */
	  function createDOMFactory(type) {
	    var factory = React.createElement.bind(null, type);
	    // Expose the type on the factory and the prototype so that it can be
	    // easily accessed on elements. E.g. `<Foo />.type === Foo`.
	    // This should not be named `constructor` since this may not be the function
	    // that created the element, and it may not even be a constructor.
	    factory.type = type;
	    return factory;
	  };
	
	  /**
	   * Creates a mapping from supported HTML tags to `ReactDOMComponent` classes.
	   */
	  var ReactDOMFactories = {
	    a: createDOMFactory('a'),
	    abbr: createDOMFactory('abbr'),
	    address: createDOMFactory('address'),
	    area: createDOMFactory('area'),
	    article: createDOMFactory('article'),
	    aside: createDOMFactory('aside'),
	    audio: createDOMFactory('audio'),
	    b: createDOMFactory('b'),
	    base: createDOMFactory('base'),
	    bdi: createDOMFactory('bdi'),
	    bdo: createDOMFactory('bdo'),
	    big: createDOMFactory('big'),
	    blockquote: createDOMFactory('blockquote'),
	    body: createDOMFactory('body'),
	    br: createDOMFactory('br'),
	    button: createDOMFactory('button'),
	    canvas: createDOMFactory('canvas'),
	    caption: createDOMFactory('caption'),
	    cite: createDOMFactory('cite'),
	    code: createDOMFactory('code'),
	    col: createDOMFactory('col'),
	    colgroup: createDOMFactory('colgroup'),
	    data: createDOMFactory('data'),
	    datalist: createDOMFactory('datalist'),
	    dd: createDOMFactory('dd'),
	    del: createDOMFactory('del'),
	    details: createDOMFactory('details'),
	    dfn: createDOMFactory('dfn'),
	    dialog: createDOMFactory('dialog'),
	    div: createDOMFactory('div'),
	    dl: createDOMFactory('dl'),
	    dt: createDOMFactory('dt'),
	    em: createDOMFactory('em'),
	    embed: createDOMFactory('embed'),
	    fieldset: createDOMFactory('fieldset'),
	    figcaption: createDOMFactory('figcaption'),
	    figure: createDOMFactory('figure'),
	    footer: createDOMFactory('footer'),
	    form: createDOMFactory('form'),
	    h1: createDOMFactory('h1'),
	    h2: createDOMFactory('h2'),
	    h3: createDOMFactory('h3'),
	    h4: createDOMFactory('h4'),
	    h5: createDOMFactory('h5'),
	    h6: createDOMFactory('h6'),
	    head: createDOMFactory('head'),
	    header: createDOMFactory('header'),
	    hgroup: createDOMFactory('hgroup'),
	    hr: createDOMFactory('hr'),
	    html: createDOMFactory('html'),
	    i: createDOMFactory('i'),
	    iframe: createDOMFactory('iframe'),
	    img: createDOMFactory('img'),
	    input: createDOMFactory('input'),
	    ins: createDOMFactory('ins'),
	    kbd: createDOMFactory('kbd'),
	    keygen: createDOMFactory('keygen'),
	    label: createDOMFactory('label'),
	    legend: createDOMFactory('legend'),
	    li: createDOMFactory('li'),
	    link: createDOMFactory('link'),
	    main: createDOMFactory('main'),
	    map: createDOMFactory('map'),
	    mark: createDOMFactory('mark'),
	    menu: createDOMFactory('menu'),
	    menuitem: createDOMFactory('menuitem'),
	    meta: createDOMFactory('meta'),
	    meter: createDOMFactory('meter'),
	    nav: createDOMFactory('nav'),
	    noscript: createDOMFactory('noscript'),
	    object: createDOMFactory('object'),
	    ol: createDOMFactory('ol'),
	    optgroup: createDOMFactory('optgroup'),
	    option: createDOMFactory('option'),
	    output: createDOMFactory('output'),
	    p: createDOMFactory('p'),
	    param: createDOMFactory('param'),
	    picture: createDOMFactory('picture'),
	    pre: createDOMFactory('pre'),
	    progress: createDOMFactory('progress'),
	    q: createDOMFactory('q'),
	    rp: createDOMFactory('rp'),
	    rt: createDOMFactory('rt'),
	    ruby: createDOMFactory('ruby'),
	    s: createDOMFactory('s'),
	    samp: createDOMFactory('samp'),
	    script: createDOMFactory('script'),
	    section: createDOMFactory('section'),
	    select: createDOMFactory('select'),
	    small: createDOMFactory('small'),
	    source: createDOMFactory('source'),
	    span: createDOMFactory('span'),
	    strong: createDOMFactory('strong'),
	    style: createDOMFactory('style'),
	    sub: createDOMFactory('sub'),
	    summary: createDOMFactory('summary'),
	    sup: createDOMFactory('sup'),
	    table: createDOMFactory('table'),
	    tbody: createDOMFactory('tbody'),
	    td: createDOMFactory('td'),
	    textarea: createDOMFactory('textarea'),
	    tfoot: createDOMFactory('tfoot'),
	    th: createDOMFactory('th'),
	    thead: createDOMFactory('thead'),
	    time: createDOMFactory('time'),
	    title: createDOMFactory('title'),
	    tr: createDOMFactory('tr'),
	    track: createDOMFactory('track'),
	    u: createDOMFactory('u'),
	    ul: createDOMFactory('ul'),
	    var: createDOMFactory('var'),
	    video: createDOMFactory('video'),
	    wbr: createDOMFactory('wbr'),
	
	    // SVG
	    circle: createDOMFactory('circle'),
	    clipPath: createDOMFactory('clipPath'),
	    defs: createDOMFactory('defs'),
	    ellipse: createDOMFactory('ellipse'),
	    g: createDOMFactory('g'),
	    image: createDOMFactory('image'),
	    line: createDOMFactory('line'),
	    linearGradient: createDOMFactory('linearGradient'),
	    mask: createDOMFactory('mask'),
	    path: createDOMFactory('path'),
	    pattern: createDOMFactory('pattern'),
	    polygon: createDOMFactory('polygon'),
	    polyline: createDOMFactory('polyline'),
	    radialGradient: createDOMFactory('radialGradient'),
	    rect: createDOMFactory('rect'),
	    stop: createDOMFactory('stop'),
	    svg: createDOMFactory('svg'),
	    text: createDOMFactory('text'),
	    tspan: createDOMFactory('tspan'),
	  };
	
	  // due to wrapper and conditionals at the top, this will either become
	  // `module.exports ReactDOMFactories` if that is available,
	  // otherwise it will be defined via `define(['react'], ReactDOMFactories)`
	  // if that is available,
	  // otherwise it will be defined as global variable.
	  return ReactDOMFactories;
	});
	


/***/ },
/* 382 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	/**
	 * CSS properties which accept numbers but are not in units of "px".
	 */
	
	var isUnitlessNumber = {
	  animationIterationCount: true,
	  borderImageOutset: true,
	  borderImageSlice: true,
	  borderImageWidth: true,
	  boxFlex: true,
	  boxFlexGroup: true,
	  boxOrdinalGroup: true,
	  columnCount: true,
	  columns: true,
	  flex: true,
	  flexGrow: true,
	  flexPositive: true,
	  flexShrink: true,
	  flexNegative: true,
	  flexOrder: true,
	  gridRow: true,
	  gridRowEnd: true,
	  gridRowSpan: true,
	  gridRowStart: true,
	  gridColumn: true,
	  gridColumnEnd: true,
	  gridColumnSpan: true,
	  gridColumnStart: true,
	  fontWeight: true,
	  lineClamp: true,
	  lineHeight: true,
	  opacity: true,
	  order: true,
	  orphans: true,
	  tabSize: true,
	  widows: true,
	  zIndex: true,
	  zoom: true,
	
	  // SVG-related properties
	  fillOpacity: true,
	  floodOpacity: true,
	  stopOpacity: true,
	  strokeDasharray: true,
	  strokeDashoffset: true,
	  strokeMiterlimit: true,
	  strokeOpacity: true,
	  strokeWidth: true
	};
	
	/**
	 * @param {string} prefix vendor-specific prefix, eg: Webkit
	 * @param {string} key style name, eg: transitionDuration
	 * @return {string} style name prefixed with `prefix`, properly camelCased, eg:
	 * WebkitTransitionDuration
	 */
	function prefixKey(prefix, key) {
	  return prefix + key.charAt(0).toUpperCase() + key.substring(1);
	}
	
	/**
	 * Support style names that may come passed in prefixed by adding permutations
	 * of vendor prefixes.
	 */
	var prefixes = ['Webkit', 'ms', 'Moz', 'O'];
	
	// Using Object.keys here, or else the vanilla for-in loop makes IE8 go into an
	// infinite loop, because it iterates over the newly added props too.
	Object.keys(isUnitlessNumber).forEach(function (prop) {
	  prefixes.forEach(function (prefix) {
	    isUnitlessNumber[prefixKey(prefix, prop)] = isUnitlessNumber[prop];
	  });
	});
	
	/**
	 * Most style properties can be unset by doing .style[prop] = '' but IE8
	 * doesn't like doing that with shorthand properties so for the properties that
	 * IE8 breaks on, which are listed here, we instead unset each of the
	 * individual properties. See http://bugs.jquery.com/ticket/12385.
	 * The 4-value 'clock' properties like margin, padding, border-width seem to
	 * behave without any problems. Curiously, list-style works too without any
	 * special prodding.
	 */
	var shorthandPropertyExpansions = {
	  background: {
	    backgroundAttachment: true,
	    backgroundColor: true,
	    backgroundImage: true,
	    backgroundPositionX: true,
	    backgroundPositionY: true,
	    backgroundRepeat: true
	  },
	  backgroundPosition: {
	    backgroundPositionX: true,
	    backgroundPositionY: true
	  },
	  border: {
	    borderWidth: true,
	    borderStyle: true,
	    borderColor: true
	  },
	  borderBottom: {
	    borderBottomWidth: true,
	    borderBottomStyle: true,
	    borderBottomColor: true
	  },
	  borderLeft: {
	    borderLeftWidth: true,
	    borderLeftStyle: true,
	    borderLeftColor: true
	  },
	  borderRight: {
	    borderRightWidth: true,
	    borderRightStyle: true,
	    borderRightColor: true
	  },
	  borderTop: {
	    borderTopWidth: true,
	    borderTopStyle: true,
	    borderTopColor: true
	  },
	  font: {
	    fontStyle: true,
	    fontVariant: true,
	    fontWeight: true,
	    fontSize: true,
	    lineHeight: true,
	    fontFamily: true
	  },
	  outline: {
	    outlineWidth: true,
	    outlineStyle: true,
	    outlineColor: true
	  }
	};
	
	var CSSProperty = {
	  isUnitlessNumber: isUnitlessNumber,
	  shorthandPropertyExpansions: shorthandPropertyExpansions
	};
	
	module.exports = CSSProperty;

/***/ },
/* 383 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(29);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var PooledClass = __webpack_require__(113);
	
	var invariant = __webpack_require__(21);
	
	/**
	 * A specialized pseudo-event module to help keep track of components waiting to
	 * be notified when their DOM representations are available for use.
	 *
	 * This implements `PooledClass`, so you should never need to instantiate this.
	 * Instead, use `CallbackQueue.getPooled()`.
	 *
	 * @class ReactMountReady
	 * @implements PooledClass
	 * @internal
	 */
	
	var CallbackQueue = function () {
	  function CallbackQueue(arg) {
	    _classCallCheck(this, CallbackQueue);
	
	    this._callbacks = null;
	    this._contexts = null;
	    this._arg = arg;
	  }
	
	  /**
	   * Enqueues a callback to be invoked when `notifyAll` is invoked.
	   *
	   * @param {function} callback Invoked when `notifyAll` is invoked.
	   * @param {?object} context Context to call `callback` with.
	   * @internal
	   */
	
	
	  CallbackQueue.prototype.enqueue = function enqueue(callback, context) {
	    this._callbacks = this._callbacks || [];
	    this._callbacks.push(callback);
	    this._contexts = this._contexts || [];
	    this._contexts.push(context);
	  };
	
	  /**
	   * Invokes all enqueued callbacks and clears the queue. This is invoked after
	   * the DOM representation of a component has been created or updated.
	   *
	   * @internal
	   */
	
	
	  CallbackQueue.prototype.notifyAll = function notifyAll() {
	    var callbacks = this._callbacks;
	    var contexts = this._contexts;
	    var arg = this._arg;
	    if (callbacks && contexts) {
	      !(callbacks.length === contexts.length) ?  false ? invariant(false, 'Mismatched list of contexts in callback queue') : _prodInvariant('24') : void 0;
	      this._callbacks = null;
	      this._contexts = null;
	      for (var i = 0; i < callbacks.length; i++) {
	        callbacks[i].call(contexts[i], arg);
	      }
	      callbacks.length = 0;
	      contexts.length = 0;
	    }
	  };
	
	  CallbackQueue.prototype.checkpoint = function checkpoint() {
	    return this._callbacks ? this._callbacks.length : 0;
	  };
	
	  CallbackQueue.prototype.rollback = function rollback(len) {
	    if (this._callbacks && this._contexts) {
	      this._callbacks.length = len;
	      this._contexts.length = len;
	    }
	  };
	
	  /**
	   * Resets the internal queue.
	   *
	   * @internal
	   */
	
	
	  CallbackQueue.prototype.reset = function reset() {
	    this._callbacks = null;
	    this._contexts = null;
	  };
	
	  /**
	   * `PooledClass` looks for this.
	   */
	
	
	  CallbackQueue.prototype.destructor = function destructor() {
	    this.reset();
	  };
	
	  return CallbackQueue;
	}();
	
	module.exports = PooledClass.addPoolingTo(CallbackQueue);

/***/ },
/* 384 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var DOMProperty = __webpack_require__(128);
	var ReactDOMComponentTree = __webpack_require__(41);
	var ReactInstrumentation = __webpack_require__(62);
	
	var quoteAttributeValueForBrowser = __webpack_require__(1024);
	var warning = __webpack_require__(30);
	
	var VALID_ATTRIBUTE_NAME_REGEX = new RegExp('^[' + DOMProperty.ATTRIBUTE_NAME_START_CHAR + '][' + DOMProperty.ATTRIBUTE_NAME_CHAR + ']*$');
	var illegalAttributeNameCache = {};
	var validatedAttributeNameCache = {};
	
	function isAttributeNameSafe(attributeName) {
	  if (validatedAttributeNameCache.hasOwnProperty(attributeName)) {
	    return true;
	  }
	  if (illegalAttributeNameCache.hasOwnProperty(attributeName)) {
	    return false;
	  }
	  if (VALID_ATTRIBUTE_NAME_REGEX.test(attributeName)) {
	    validatedAttributeNameCache[attributeName] = true;
	    return true;
	  }
	  illegalAttributeNameCache[attributeName] = true;
	   false ? warning(false, 'Invalid attribute name: `%s`', attributeName) : void 0;
	  return false;
	}
	
	function shouldIgnoreValue(propertyInfo, value) {
	  return value == null || propertyInfo.hasBooleanValue && !value || propertyInfo.hasNumericValue && isNaN(value) || propertyInfo.hasPositiveNumericValue && value < 1 || propertyInfo.hasOverloadedBooleanValue && value === false;
	}
	
	/**
	 * Operations for dealing with DOM properties.
	 */
	var DOMPropertyOperations = {
	  /**
	   * Creates markup for the ID property.
	   *
	   * @param {string} id Unescaped ID.
	   * @return {string} Markup string.
	   */
	  createMarkupForID: function (id) {
	    return DOMProperty.ID_ATTRIBUTE_NAME + '=' + quoteAttributeValueForBrowser(id);
	  },
	
	  setAttributeForID: function (node, id) {
	    node.setAttribute(DOMProperty.ID_ATTRIBUTE_NAME, id);
	  },
	
	  createMarkupForRoot: function () {
	    return DOMProperty.ROOT_ATTRIBUTE_NAME + '=""';
	  },
	
	  setAttributeForRoot: function (node) {
	    node.setAttribute(DOMProperty.ROOT_ATTRIBUTE_NAME, '');
	  },
	
	  /**
	   * Creates markup for a property.
	   *
	   * @param {string} name
	   * @param {*} value
	   * @return {?string} Markup string, or null if the property was invalid.
	   */
	  createMarkupForProperty: function (name, value) {
	    var propertyInfo = DOMProperty.properties.hasOwnProperty(name) ? DOMProperty.properties[name] : null;
	    if (propertyInfo) {
	      if (shouldIgnoreValue(propertyInfo, value)) {
	        return '';
	      }
	      var attributeName = propertyInfo.attributeName;
	      if (propertyInfo.hasBooleanValue || propertyInfo.hasOverloadedBooleanValue && value === true) {
	        return attributeName + '=""';
	      }
	      return attributeName + '=' + quoteAttributeValueForBrowser(value);
	    } else if (DOMProperty.isCustomAttribute(name)) {
	      if (value == null) {
	        return '';
	      }
	      return name + '=' + quoteAttributeValueForBrowser(value);
	    }
	    return null;
	  },
	
	  /**
	   * Creates markup for a custom property.
	   *
	   * @param {string} name
	   * @param {*} value
	   * @return {string} Markup string, or empty string if the property was invalid.
	   */
	  createMarkupForCustomAttribute: function (name, value) {
	    if (!isAttributeNameSafe(name) || value == null) {
	      return '';
	    }
	    return name + '=' + quoteAttributeValueForBrowser(value);
	  },
	
	  /**
	   * Sets the value for a property on a node.
	   *
	   * @param {DOMElement} node
	   * @param {string} name
	   * @param {*} value
	   */
	  setValueForProperty: function (node, name, value) {
	    var propertyInfo = DOMProperty.properties.hasOwnProperty(name) ? DOMProperty.properties[name] : null;
	    if (propertyInfo) {
	      var mutationMethod = propertyInfo.mutationMethod;
	      if (mutationMethod) {
	        mutationMethod(node, value);
	      } else if (shouldIgnoreValue(propertyInfo, value)) {
	        this.deleteValueForProperty(node, name);
	        return;
	      } else if (propertyInfo.mustUseProperty) {
	        // Contrary to `setAttribute`, object properties are properly
	        // `toString`ed by IE8/9.
	        node[propertyInfo.propertyName] = value;
	      } else {
	        var attributeName = propertyInfo.attributeName;
	        var namespace = propertyInfo.attributeNamespace;
	        // `setAttribute` with objects becomes only `[object]` in IE8/9,
	        // ('' + value) makes it output the correct toString()-value.
	        if (namespace) {
	          node.setAttributeNS(namespace, attributeName, '' + value);
	        } else if (propertyInfo.hasBooleanValue || propertyInfo.hasOverloadedBooleanValue && value === true) {
	          node.setAttribute(attributeName, '');
	        } else {
	          node.setAttribute(attributeName, '' + value);
	        }
	      }
	    } else if (DOMProperty.isCustomAttribute(name)) {
	      DOMPropertyOperations.setValueForAttribute(node, name, value);
	      return;
	    }
	
	    if (false) {
	      var payload = {};
	      payload[name] = value;
	      ReactInstrumentation.debugTool.onHostOperation({
	        instanceID: ReactDOMComponentTree.getInstanceFromNode(node)._debugID,
	        type: 'update attribute',
	        payload: payload
	      });
	    }
	  },
	
	  setValueForAttribute: function (node, name, value) {
	    if (!isAttributeNameSafe(name)) {
	      return;
	    }
	    if (value == null) {
	      node.removeAttribute(name);
	    } else {
	      node.setAttribute(name, '' + value);
	    }
	
	    if (false) {
	      var payload = {};
	      payload[name] = value;
	      ReactInstrumentation.debugTool.onHostOperation({
	        instanceID: ReactDOMComponentTree.getInstanceFromNode(node)._debugID,
	        type: 'update attribute',
	        payload: payload
	      });
	    }
	  },
	
	  /**
	   * Deletes an attributes from a node.
	   *
	   * @param {DOMElement} node
	   * @param {string} name
	   */
	  deleteValueForAttribute: function (node, name) {
	    node.removeAttribute(name);
	    if (false) {
	      ReactInstrumentation.debugTool.onHostOperation({
	        instanceID: ReactDOMComponentTree.getInstanceFromNode(node)._debugID,
	        type: 'remove attribute',
	        payload: name
	      });
	    }
	  },
	
	  /**
	   * Deletes the value for a property on a node.
	   *
	   * @param {DOMElement} node
	   * @param {string} name
	   */
	  deleteValueForProperty: function (node, name) {
	    var propertyInfo = DOMProperty.properties.hasOwnProperty(name) ? DOMProperty.properties[name] : null;
	    if (propertyInfo) {
	      var mutationMethod = propertyInfo.mutationMethod;
	      if (mutationMethod) {
	        mutationMethod(node, undefined);
	      } else if (propertyInfo.mustUseProperty) {
	        var propName = propertyInfo.propertyName;
	        if (propertyInfo.hasBooleanValue) {
	          node[propName] = false;
	        } else {
	          node[propName] = '';
	        }
	      } else {
	        node.removeAttribute(propertyInfo.attributeName);
	      }
	    } else if (DOMProperty.isCustomAttribute(name)) {
	      node.removeAttribute(name);
	    }
	
	    if (false) {
	      ReactInstrumentation.debugTool.onHostOperation({
	        instanceID: ReactDOMComponentTree.getInstanceFromNode(node)._debugID,
	        type: 'remove attribute',
	        payload: name
	      });
	    }
	  }
	};
	
	module.exports = DOMPropertyOperations;

/***/ },
/* 385 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2015-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ReactDOMComponentFlags = {
	  hasCachedChildNodes: 1 << 0
	};
	
	module.exports = ReactDOMComponentFlags;

/***/ },
/* 386 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var validateDOMNesting = __webpack_require__(264);
	
	var DOC_NODE_TYPE = 9;
	
	function ReactDOMContainerInfo(topLevelWrapper, node) {
	  var info = {
	    _topLevelWrapper: topLevelWrapper,
	    _idCounter: 1,
	    _ownerDocument: node ? node.nodeType === DOC_NODE_TYPE ? node : node.ownerDocument : null,
	    _node: node,
	    _tag: node ? node.nodeName.toLowerCase() : null,
	    _namespaceURI: node ? node.namespaceURI : null
	  };
	  if (false) {
	    info._ancestorInfo = node ? validateDOMNesting.updatedAncestorInfo(null, info._tag, null) : null;
	  }
	  return info;
	}
	
	module.exports = ReactDOMContainerInfo;

/***/ },
/* 387 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(36);
	
	var LinkedValueUtils = __webpack_require__(253);
	var ReactDOMComponentTree = __webpack_require__(41);
	var ReactUpdates = __webpack_require__(74);
	
	var warning = __webpack_require__(30);
	
	var didWarnValueLink = false;
	var didWarnValueDefaultValue = false;
	
	function updateOptionsIfPendingUpdateAndMounted() {
	  if (this._rootNodeID && this._wrapperState.pendingUpdate) {
	    this._wrapperState.pendingUpdate = false;
	
	    var props = this._currentElement.props;
	    var value = LinkedValueUtils.getValue(props);
	
	    if (value != null) {
	      updateOptions(this, Boolean(props.multiple), value);
	    }
	  }
	}
	
	function getDeclarationErrorAddendum(owner) {
	  if (owner) {
	    var name = owner.getName();
	    if (name) {
	      return ' Check the render method of `' + name + '`.';
	    }
	  }
	  return '';
	}
	
	var valuePropNames = ['value', 'defaultValue'];
	
	/**
	 * Validation function for `value` and `defaultValue`.
	 * @private
	 */
	function checkSelectPropTypes(inst, props) {
	  var owner = inst._currentElement._owner;
	  LinkedValueUtils.checkPropTypes('select', props, owner);
	
	  if (props.valueLink !== undefined && !didWarnValueLink) {
	     false ? warning(false, '`valueLink` prop on `select` is deprecated; set `value` and `onChange` instead.') : void 0;
	    didWarnValueLink = true;
	  }
	
	  for (var i = 0; i < valuePropNames.length; i++) {
	    var propName = valuePropNames[i];
	    if (props[propName] == null) {
	      continue;
	    }
	    var isArray = Array.isArray(props[propName]);
	    if (props.multiple && !isArray) {
	       false ? warning(false, 'The `%s` prop supplied to <select> must be an array if ' + '`multiple` is true.%s', propName, getDeclarationErrorAddendum(owner)) : void 0;
	    } else if (!props.multiple && isArray) {
	       false ? warning(false, 'The `%s` prop supplied to <select> must be a scalar ' + 'value if `multiple` is false.%s', propName, getDeclarationErrorAddendum(owner)) : void 0;
	    }
	  }
	}
	
	/**
	 * @param {ReactDOMComponent} inst
	 * @param {boolean} multiple
	 * @param {*} propValue A stringable (with `multiple`, a list of stringables).
	 * @private
	 */
	function updateOptions(inst, multiple, propValue) {
	  var selectedValue, i;
	  var options = ReactDOMComponentTree.getNodeFromInstance(inst).options;
	
	  if (multiple) {
	    selectedValue = {};
	    for (i = 0; i < propValue.length; i++) {
	      selectedValue['' + propValue[i]] = true;
	    }
	    for (i = 0; i < options.length; i++) {
	      var selected = selectedValue.hasOwnProperty(options[i].value);
	      if (options[i].selected !== selected) {
	        options[i].selected = selected;
	      }
	    }
	  } else {
	    // Do not set `select.value` as exact behavior isn't consistent across all
	    // browsers for all cases.
	    selectedValue = '' + propValue;
	    for (i = 0; i < options.length; i++) {
	      if (options[i].value === selectedValue) {
	        options[i].selected = true;
	        return;
	      }
	    }
	    if (options.length) {
	      options[0].selected = true;
	    }
	  }
	}
	
	/**
	 * Implements a <select> host component that allows optionally setting the
	 * props `value` and `defaultValue`. If `multiple` is false, the prop must be a
	 * stringable. If `multiple` is true, the prop must be an array of stringables.
	 *
	 * If `value` is not supplied (or null/undefined), user actions that change the
	 * selected option will trigger updates to the rendered options.
	 *
	 * If it is supplied (and not null/undefined), the rendered options will not
	 * update in response to user actions. Instead, the `value` prop must change in
	 * order for the rendered options to update.
	 *
	 * If `defaultValue` is provided, any options with the supplied values will be
	 * selected.
	 */
	var ReactDOMSelect = {
	  getHostProps: function (inst, props) {
	    return _assign({}, props, {
	      onChange: inst._wrapperState.onChange,
	      value: undefined
	    });
	  },
	
	  mountWrapper: function (inst, props) {
	    if (false) {
	      checkSelectPropTypes(inst, props);
	    }
	
	    var value = LinkedValueUtils.getValue(props);
	    inst._wrapperState = {
	      pendingUpdate: false,
	      initialValue: value != null ? value : props.defaultValue,
	      listeners: null,
	      onChange: _handleChange.bind(inst),
	      wasMultiple: Boolean(props.multiple)
	    };
	
	    if (props.value !== undefined && props.defaultValue !== undefined && !didWarnValueDefaultValue) {
	       false ? warning(false, 'Select elements must be either controlled or uncontrolled ' + '(specify either the value prop, or the defaultValue prop, but not ' + 'both). Decide between using a controlled or uncontrolled select ' + 'element and remove one of these props. More info: ' + 'https://fb.me/react-controlled-components') : void 0;
	      didWarnValueDefaultValue = true;
	    }
	  },
	
	  getSelectValueContext: function (inst) {
	    // ReactDOMOption looks at this initial value so the initial generated
	    // markup has correct `selected` attributes
	    return inst._wrapperState.initialValue;
	  },
	
	  postUpdateWrapper: function (inst) {
	    var props = inst._currentElement.props;
	
	    // After the initial mount, we control selected-ness manually so don't pass
	    // this value down
	    inst._wrapperState.initialValue = undefined;
	
	    var wasMultiple = inst._wrapperState.wasMultiple;
	    inst._wrapperState.wasMultiple = Boolean(props.multiple);
	
	    var value = LinkedValueUtils.getValue(props);
	    if (value != null) {
	      inst._wrapperState.pendingUpdate = false;
	      updateOptions(inst, Boolean(props.multiple), value);
	    } else if (wasMultiple !== Boolean(props.multiple)) {
	      // For simplicity, reapply `defaultValue` if `multiple` is toggled.
	      if (props.defaultValue != null) {
	        updateOptions(inst, Boolean(props.multiple), props.defaultValue);
	      } else {
	        // Revert the select back to its default unselected state.
	        updateOptions(inst, Boolean(props.multiple), props.multiple ? [] : '');
	      }
	    }
	  }
	};
	
	function _handleChange(event) {
	  var props = this._currentElement.props;
	  var returnValue = LinkedValueUtils.executeOnChange(props, event);
	
	  if (this._rootNodeID) {
	    this._wrapperState.pendingUpdate = true;
	  }
	  ReactUpdates.asap(updateOptionsIfPendingUpdateAndMounted, this);
	  return returnValue;
	}
	
	module.exports = ReactDOMSelect;

/***/ },
/* 388 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(36);
	
	var ReactUpdates = __webpack_require__(74);
	var Transaction = __webpack_require__(186);
	
	var emptyFunction = __webpack_require__(80);
	
	var RESET_BATCHED_UPDATES = {
	  initialize: emptyFunction,
	  close: function () {
	    ReactDefaultBatchingStrategy.isBatchingUpdates = false;
	  }
	};
	
	var FLUSH_BATCHED_UPDATES = {
	  initialize: emptyFunction,
	  close: ReactUpdates.flushBatchedUpdates.bind(ReactUpdates)
	};
	
	var TRANSACTION_WRAPPERS = [FLUSH_BATCHED_UPDATES, RESET_BATCHED_UPDATES];
	
	function ReactDefaultBatchingStrategyTransaction() {
	  this.reinitializeTransaction();
	}
	
	_assign(ReactDefaultBatchingStrategyTransaction.prototype, Transaction, {
	  getTransactionWrappers: function () {
	    return TRANSACTION_WRAPPERS;
	  }
	});
	
	var transaction = new ReactDefaultBatchingStrategyTransaction();
	
	var ReactDefaultBatchingStrategy = {
	  isBatchingUpdates: false,
	
	  /**
	   * Call the provided function in a context within which calls to `setState`
	   * and friends are batched such that components aren't updated unnecessarily.
	   */
	  batchedUpdates: function (callback, a, b, c, d, e) {
	    var alreadyBatchingUpdates = ReactDefaultBatchingStrategy.isBatchingUpdates;
	
	    ReactDefaultBatchingStrategy.isBatchingUpdates = true;
	
	    // The code is written this way to avoid extra allocations
	    if (alreadyBatchingUpdates) {
	      return callback(a, b, c, d, e);
	    } else {
	      return transaction.perform(callback, null, a, b, c, d, e);
	    }
	  }
	};
	
	module.exports = ReactDefaultBatchingStrategy;

/***/ },
/* 389 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ARIADOMPropertyConfig = __webpack_require__(966);
	var BeforeInputEventPlugin = __webpack_require__(968);
	var ChangeEventPlugin = __webpack_require__(970);
	var DefaultEventPluginOrder = __webpack_require__(972);
	var EnterLeaveEventPlugin = __webpack_require__(973);
	var HTMLDOMPropertyConfig = __webpack_require__(975);
	var ReactComponentBrowserEnvironment = __webpack_require__(977);
	var ReactDOMComponent = __webpack_require__(980);
	var ReactDOMComponentTree = __webpack_require__(41);
	var ReactDOMEmptyComponent = __webpack_require__(981);
	var ReactDOMTreeTraversal = __webpack_require__(990);
	var ReactDOMTextComponent = __webpack_require__(988);
	var ReactDefaultBatchingStrategy = __webpack_require__(388);
	var ReactEventListener = __webpack_require__(993);
	var ReactInjection = __webpack_require__(994);
	var ReactReconcileTransaction = __webpack_require__(998);
	var SVGDOMPropertyConfig = __webpack_require__(1003);
	var SelectEventPlugin = __webpack_require__(1004);
	var SimpleEventPlugin = __webpack_require__(1005);
	
	var alreadyInjected = false;
	
	function inject() {
	  if (alreadyInjected) {
	    // TODO: This is currently true because these injections are shared between
	    // the client and the server package. They should be built independently
	    // and not share any injection state. Then this problem will be solved.
	    return;
	  }
	  alreadyInjected = true;
	
	  ReactInjection.EventEmitter.injectReactEventListener(ReactEventListener);
	
	  /**
	   * Inject modules for resolving DOM hierarchy and plugin ordering.
	   */
	  ReactInjection.EventPluginHub.injectEventPluginOrder(DefaultEventPluginOrder);
	  ReactInjection.EventPluginUtils.injectComponentTree(ReactDOMComponentTree);
	  ReactInjection.EventPluginUtils.injectTreeTraversal(ReactDOMTreeTraversal);
	
	  /**
	   * Some important event plugins included by default (without having to require
	   * them).
	   */
	  ReactInjection.EventPluginHub.injectEventPluginsByName({
	    SimpleEventPlugin: SimpleEventPlugin,
	    EnterLeaveEventPlugin: EnterLeaveEventPlugin,
	    ChangeEventPlugin: ChangeEventPlugin,
	    SelectEventPlugin: SelectEventPlugin,
	    BeforeInputEventPlugin: BeforeInputEventPlugin
	  });
	
	  ReactInjection.HostComponent.injectGenericComponentClass(ReactDOMComponent);
	
	  ReactInjection.HostComponent.injectTextComponentClass(ReactDOMTextComponent);
	
	  ReactInjection.DOMProperty.injectDOMPropertyConfig(ARIADOMPropertyConfig);
	  ReactInjection.DOMProperty.injectDOMPropertyConfig(HTMLDOMPropertyConfig);
	  ReactInjection.DOMProperty.injectDOMPropertyConfig(SVGDOMPropertyConfig);
	
	  ReactInjection.EmptyComponent.injectEmptyComponentFactory(function (instantiate) {
	    return new ReactDOMEmptyComponent(instantiate);
	  });
	
	  ReactInjection.Updates.injectReconcileTransaction(ReactReconcileTransaction);
	  ReactInjection.Updates.injectBatchingStrategy(ReactDefaultBatchingStrategy);
	
	  ReactInjection.Component.injectEnvironment(ReactComponentBrowserEnvironment);
	}
	
	module.exports = {
	  inject: inject
	};

/***/ },
/* 390 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2014-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var emptyComponentFactory;
	
	var ReactEmptyComponentInjection = {
	  injectEmptyComponentFactory: function (factory) {
	    emptyComponentFactory = factory;
	  }
	};
	
	var ReactEmptyComponent = {
	  create: function (instantiate) {
	    return emptyComponentFactory(instantiate);
	  }
	};
	
	ReactEmptyComponent.injection = ReactEmptyComponentInjection;
	
	module.exports = ReactEmptyComponent;

/***/ },
/* 391 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var ReactFeatureFlags = {
	  // When true, call console.time() before and .timeEnd() after each top-level
	  // render (both initial renders and updates). Useful when looking at prod-mode
	  // timeline profiles in Chrome, for example.
	  logTopLevelRenders: false
	};
	
	module.exports = ReactFeatureFlags;

/***/ },
/* 392 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2014-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(29);
	
	var invariant = __webpack_require__(21);
	
	var genericComponentClass = null;
	var textComponentClass = null;
	
	var ReactHostComponentInjection = {
	  // This accepts a class that receives the tag string. This is a catch all
	  // that can render any kind of tag.
	  injectGenericComponentClass: function (componentClass) {
	    genericComponentClass = componentClass;
	  },
	  // This accepts a text component class that takes the text string to be
	  // rendered as props.
	  injectTextComponentClass: function (componentClass) {
	    textComponentClass = componentClass;
	  }
	};
	
	/**
	 * Get a host internal component class for a specific tag.
	 *
	 * @param {ReactElement} element The element to create.
	 * @return {function} The internal class constructor function.
	 */
	function createInternalComponent(element) {
	  !genericComponentClass ?  false ? invariant(false, 'There is no registered component for the tag %s', element.type) : _prodInvariant('111', element.type) : void 0;
	  return new genericComponentClass(element);
	}
	
	/**
	 * @param {ReactText} text
	 * @return {ReactComponent}
	 */
	function createInstanceForText(text) {
	  return new textComponentClass(text);
	}
	
	/**
	 * @param {ReactComponent} component
	 * @return {boolean}
	 */
	function isTextComponent(component) {
	  return component instanceof textComponentClass;
	}
	
	var ReactHostComponent = {
	  createInternalComponent: createInternalComponent,
	  createInstanceForText: createInstanceForText,
	  isTextComponent: isTextComponent,
	  injection: ReactHostComponentInjection
	};
	
	module.exports = ReactHostComponent;

/***/ },
/* 393 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ReactDOMSelection = __webpack_require__(986);
	
	var containsNode = __webpack_require__(823);
	var focusNode = __webpack_require__(330);
	var getActiveElement = __webpack_require__(331);
	
	function isInDocument(node) {
	  return containsNode(document.documentElement, node);
	}
	
	/**
	 * @ReactInputSelection: React input selection module. Based on Selection.js,
	 * but modified to be suitable for react and has a couple of bug fixes (doesn't
	 * assume buttons have range selections allowed).
	 * Input selection module for React.
	 */
	var ReactInputSelection = {
	  hasSelectionCapabilities: function (elem) {
	    var nodeName = elem && elem.nodeName && elem.nodeName.toLowerCase();
	    return nodeName && (nodeName === 'input' && elem.type === 'text' || nodeName === 'textarea' || elem.contentEditable === 'true');
	  },
	
	  getSelectionInformation: function () {
	    var focusedElem = getActiveElement();
	    return {
	      focusedElem: focusedElem,
	      selectionRange: ReactInputSelection.hasSelectionCapabilities(focusedElem) ? ReactInputSelection.getSelection(focusedElem) : null
	    };
	  },
	
	  /**
	   * @restoreSelection: If any selection information was potentially lost,
	   * restore it. This is useful when performing operations that could remove dom
	   * nodes and place them back in, resulting in focus being lost.
	   */
	  restoreSelection: function (priorSelectionInformation) {
	    var curFocusedElem = getActiveElement();
	    var priorFocusedElem = priorSelectionInformation.focusedElem;
	    var priorSelectionRange = priorSelectionInformation.selectionRange;
	    if (curFocusedElem !== priorFocusedElem && isInDocument(priorFocusedElem)) {
	      if (ReactInputSelection.hasSelectionCapabilities(priorFocusedElem)) {
	        ReactInputSelection.setSelection(priorFocusedElem, priorSelectionRange);
	      }
	      focusNode(priorFocusedElem);
	    }
	  },
	
	  /**
	   * @getSelection: Gets the selection bounds of a focused textarea, input or
	   * contentEditable node.
	   * -@input: Look up selection bounds of this input
	   * -@return {start: selectionStart, end: selectionEnd}
	   */
	  getSelection: function (input) {
	    var selection;
	
	    if ('selectionStart' in input) {
	      // Modern browser with input or textarea.
	      selection = {
	        start: input.selectionStart,
	        end: input.selectionEnd
	      };
	    } else if (document.selection && input.nodeName && input.nodeName.toLowerCase() === 'input') {
	      // IE8 input.
	      var range = document.selection.createRange();
	      // There can only be one selection per document in IE, so it must
	      // be in our element.
	      if (range.parentElement() === input) {
	        selection = {
	          start: -range.moveStart('character', -input.value.length),
	          end: -range.moveEnd('character', -input.value.length)
	        };
	      }
	    } else {
	      // Content editable or old IE textarea.
	      selection = ReactDOMSelection.getOffsets(input);
	    }
	
	    return selection || { start: 0, end: 0 };
	  },
	
	  /**
	   * @setSelection: Sets the selection bounds of a textarea or input and focuses
	   * the input.
	   * -@input     Set selection bounds of this input or textarea
	   * -@offsets   Object of same form that is returned from get*
	   */
	  setSelection: function (input, offsets) {
	    var start = offsets.start;
	    var end = offsets.end;
	    if (end === undefined) {
	      end = start;
	    }
	
	    if ('selectionStart' in input) {
	      input.selectionStart = start;
	      input.selectionEnd = Math.min(end, input.value.length);
	    } else if (document.selection && input.nodeName && input.nodeName.toLowerCase() === 'input') {
	      var range = input.createTextRange();
	      range.collapse(true);
	      range.moveStart('character', start);
	      range.moveEnd('character', end - start);
	      range.select();
	    } else {
	      ReactDOMSelection.setOffsets(input, offsets);
	    }
	  }
	};
	
	module.exports = ReactInputSelection;

/***/ },
/* 394 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var adler32 = __webpack_require__(1016);
	
	var TAG_END = /\/?>/;
	var COMMENT_START = /^<\!\-\-/;
	
	var ReactMarkupChecksum = {
	  CHECKSUM_ATTR_NAME: 'data-react-checksum',
	
	  /**
	   * @param {string} markup Markup string
	   * @return {string} Markup string with checksum attribute attached
	   */
	  addChecksumToMarkup: function (markup) {
	    var checksum = adler32(markup);
	
	    // Add checksum (handle both parent tags, comments and self-closing tags)
	    if (COMMENT_START.test(markup)) {
	      return markup;
	    } else {
	      return markup.replace(TAG_END, ' ' + ReactMarkupChecksum.CHECKSUM_ATTR_NAME + '="' + checksum + '"$&');
	    }
	  },
	
	  /**
	   * @param {string} markup to use
	   * @param {DOMElement} element root React element
	   * @returns {boolean} whether or not the markup is the same
	   */
	  canReuseMarkup: function (markup, element) {
	    var existingChecksum = element.getAttribute(ReactMarkupChecksum.CHECKSUM_ATTR_NAME);
	    existingChecksum = existingChecksum && parseInt(existingChecksum, 10);
	    var markupChecksum = adler32(markup);
	    return markupChecksum === existingChecksum;
	  }
	};
	
	module.exports = ReactMarkupChecksum;

/***/ },
/* 395 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(29);
	
	var DOMLazyTree = __webpack_require__(127);
	var DOMProperty = __webpack_require__(128);
	var React = __webpack_require__(115);
	var ReactBrowserEventEmitter = __webpack_require__(184);
	var ReactCurrentOwner = __webpack_require__(92);
	var ReactDOMComponentTree = __webpack_require__(41);
	var ReactDOMContainerInfo = __webpack_require__(386);
	var ReactDOMFeatureFlags = __webpack_require__(982);
	var ReactFeatureFlags = __webpack_require__(391);
	var ReactInstanceMap = __webpack_require__(146);
	var ReactInstrumentation = __webpack_require__(62);
	var ReactMarkupChecksum = __webpack_require__(394);
	var ReactReconciler = __webpack_require__(114);
	var ReactUpdateQueue = __webpack_require__(256);
	var ReactUpdates = __webpack_require__(74);
	
	var emptyObject = __webpack_require__(141);
	var instantiateReactComponent = __webpack_require__(261);
	var invariant = __webpack_require__(21);
	var setInnerHTML = __webpack_require__(188);
	var shouldUpdateReactComponent = __webpack_require__(263);
	var warning = __webpack_require__(30);
	
	var ATTR_NAME = DOMProperty.ID_ATTRIBUTE_NAME;
	var ROOT_ATTR_NAME = DOMProperty.ROOT_ATTRIBUTE_NAME;
	
	var ELEMENT_NODE_TYPE = 1;
	var DOC_NODE_TYPE = 9;
	var DOCUMENT_FRAGMENT_NODE_TYPE = 11;
	
	var instancesByReactRootID = {};
	
	/**
	 * Finds the index of the first character
	 * that's not common between the two given strings.
	 *
	 * @return {number} the index of the character where the strings diverge
	 */
	function firstDifferenceIndex(string1, string2) {
	  var minLen = Math.min(string1.length, string2.length);
	  for (var i = 0; i < minLen; i++) {
	    if (string1.charAt(i) !== string2.charAt(i)) {
	      return i;
	    }
	  }
	  return string1.length === string2.length ? -1 : minLen;
	}
	
	/**
	 * @param {DOMElement|DOMDocument} container DOM element that may contain
	 * a React component
	 * @return {?*} DOM element that may have the reactRoot ID, or null.
	 */
	function getReactRootElementInContainer(container) {
	  if (!container) {
	    return null;
	  }
	
	  if (container.nodeType === DOC_NODE_TYPE) {
	    return container.documentElement;
	  } else {
	    return container.firstChild;
	  }
	}
	
	function internalGetID(node) {
	  // If node is something like a window, document, or text node, none of
	  // which support attributes or a .getAttribute method, gracefully return
	  // the empty string, as if the attribute were missing.
	  return node.getAttribute && node.getAttribute(ATTR_NAME) || '';
	}
	
	/**
	 * Mounts this component and inserts it into the DOM.
	 *
	 * @param {ReactComponent} componentInstance The instance to mount.
	 * @param {DOMElement} container DOM element to mount into.
	 * @param {ReactReconcileTransaction} transaction
	 * @param {boolean} shouldReuseMarkup If true, do not insert markup
	 */
	function mountComponentIntoNode(wrapperInstance, container, transaction, shouldReuseMarkup, context) {
	  var markerName;
	  if (ReactFeatureFlags.logTopLevelRenders) {
	    var wrappedElement = wrapperInstance._currentElement.props.child;
	    var type = wrappedElement.type;
	    markerName = 'React mount: ' + (typeof type === 'string' ? type : type.displayName || type.name);
	    console.time(markerName);
	  }
	
	  var markup = ReactReconciler.mountComponent(wrapperInstance, transaction, null, ReactDOMContainerInfo(wrapperInstance, container), context, 0 /* parentDebugID */
	  );
	
	  if (markerName) {
	    console.timeEnd(markerName);
	  }
	
	  wrapperInstance._renderedComponent._topLevelWrapper = wrapperInstance;
	  ReactMount._mountImageIntoNode(markup, container, wrapperInstance, shouldReuseMarkup, transaction);
	}
	
	/**
	 * Batched mount.
	 *
	 * @param {ReactComponent} componentInstance The instance to mount.
	 * @param {DOMElement} container DOM element to mount into.
	 * @param {boolean} shouldReuseMarkup If true, do not insert markup
	 */
	function batchedMountComponentIntoNode(componentInstance, container, shouldReuseMarkup, context) {
	  var transaction = ReactUpdates.ReactReconcileTransaction.getPooled(
	  /* useCreateElement */
	  !shouldReuseMarkup && ReactDOMFeatureFlags.useCreateElement);
	  transaction.perform(mountComponentIntoNode, null, componentInstance, container, transaction, shouldReuseMarkup, context);
	  ReactUpdates.ReactReconcileTransaction.release(transaction);
	}
	
	/**
	 * Unmounts a component and removes it from the DOM.
	 *
	 * @param {ReactComponent} instance React component instance.
	 * @param {DOMElement} container DOM element to unmount from.
	 * @final
	 * @internal
	 * @see {ReactMount.unmountComponentAtNode}
	 */
	function unmountComponentFromNode(instance, container, safely) {
	  if (false) {
	    ReactInstrumentation.debugTool.onBeginFlush();
	  }
	  ReactReconciler.unmountComponent(instance, safely);
	  if (false) {
	    ReactInstrumentation.debugTool.onEndFlush();
	  }
	
	  if (container.nodeType === DOC_NODE_TYPE) {
	    container = container.documentElement;
	  }
	
	  // http://jsperf.com/emptying-a-node
	  while (container.lastChild) {
	    container.removeChild(container.lastChild);
	  }
	}
	
	/**
	 * True if the supplied DOM node has a direct React-rendered child that is
	 * not a React root element. Useful for warning in `render`,
	 * `unmountComponentAtNode`, etc.
	 *
	 * @param {?DOMElement} node The candidate DOM node.
	 * @return {boolean} True if the DOM element contains a direct child that was
	 * rendered by React but is not a root element.
	 * @internal
	 */
	function hasNonRootReactChild(container) {
	  var rootEl = getReactRootElementInContainer(container);
	  if (rootEl) {
	    var inst = ReactDOMComponentTree.getInstanceFromNode(rootEl);
	    return !!(inst && inst._hostParent);
	  }
	}
	
	/**
	 * True if the supplied DOM node is a React DOM element and
	 * it has been rendered by another copy of React.
	 *
	 * @param {?DOMElement} node The candidate DOM node.
	 * @return {boolean} True if the DOM has been rendered by another copy of React
	 * @internal
	 */
	function nodeIsRenderedByOtherInstance(container) {
	  var rootEl = getReactRootElementInContainer(container);
	  return !!(rootEl && isReactNode(rootEl) && !ReactDOMComponentTree.getInstanceFromNode(rootEl));
	}
	
	/**
	 * True if the supplied DOM node is a valid node element.
	 *
	 * @param {?DOMElement} node The candidate DOM node.
	 * @return {boolean} True if the DOM is a valid DOM node.
	 * @internal
	 */
	function isValidContainer(node) {
	  return !!(node && (node.nodeType === ELEMENT_NODE_TYPE || node.nodeType === DOC_NODE_TYPE || node.nodeType === DOCUMENT_FRAGMENT_NODE_TYPE));
	}
	
	/**
	 * True if the supplied DOM node is a valid React node element.
	 *
	 * @param {?DOMElement} node The candidate DOM node.
	 * @return {boolean} True if the DOM is a valid React DOM node.
	 * @internal
	 */
	function isReactNode(node) {
	  return isValidContainer(node) && (node.hasAttribute(ROOT_ATTR_NAME) || node.hasAttribute(ATTR_NAME));
	}
	
	function getHostRootInstanceInContainer(container) {
	  var rootEl = getReactRootElementInContainer(container);
	  var prevHostInstance = rootEl && ReactDOMComponentTree.getInstanceFromNode(rootEl);
	  return prevHostInstance && !prevHostInstance._hostParent ? prevHostInstance : null;
	}
	
	function getTopLevelWrapperInContainer(container) {
	  var root = getHostRootInstanceInContainer(container);
	  return root ? root._hostContainerInfo._topLevelWrapper : null;
	}
	
	/**
	 * Temporary (?) hack so that we can store all top-level pending updates on
	 * composites instead of having to worry about different types of components
	 * here.
	 */
	var topLevelRootCounter = 1;
	var TopLevelWrapper = function () {
	  this.rootID = topLevelRootCounter++;
	};
	TopLevelWrapper.prototype.isReactComponent = {};
	if (false) {
	  TopLevelWrapper.displayName = 'TopLevelWrapper';
	}
	TopLevelWrapper.prototype.render = function () {
	  return this.props.child;
	};
	TopLevelWrapper.isReactTopLevelWrapper = true;
	
	/**
	 * Mounting is the process of initializing a React component by creating its
	 * representative DOM elements and inserting them into a supplied `container`.
	 * Any prior content inside `container` is destroyed in the process.
	 *
	 *   ReactMount.render(
	 *     component,
	 *     document.getElementById('container')
	 *   );
	 *
	 *   <div id="container">                   <-- Supplied `container`.
	 *     <div data-reactid=".3">              <-- Rendered reactRoot of React
	 *       // ...                                 component.
	 *     </div>
	 *   </div>
	 *
	 * Inside of `container`, the first element rendered is the "reactRoot".
	 */
	var ReactMount = {
	  TopLevelWrapper: TopLevelWrapper,
	
	  /**
	   * Used by devtools. The keys are not important.
	   */
	  _instancesByReactRootID: instancesByReactRootID,
	
	  /**
	   * This is a hook provided to support rendering React components while
	   * ensuring that the apparent scroll position of its `container` does not
	   * change.
	   *
	   * @param {DOMElement} container The `container` being rendered into.
	   * @param {function} renderCallback This must be called once to do the render.
	   */
	  scrollMonitor: function (container, renderCallback) {
	    renderCallback();
	  },
	
	  /**
	   * Take a component that's already mounted into the DOM and replace its props
	   * @param {ReactComponent} prevComponent component instance already in the DOM
	   * @param {ReactElement} nextElement component instance to render
	   * @param {DOMElement} container container to render into
	   * @param {?function} callback function triggered on completion
	   */
	  _updateRootComponent: function (prevComponent, nextElement, nextContext, container, callback) {
	    ReactMount.scrollMonitor(container, function () {
	      ReactUpdateQueue.enqueueElementInternal(prevComponent, nextElement, nextContext);
	      if (callback) {
	        ReactUpdateQueue.enqueueCallbackInternal(prevComponent, callback);
	      }
	    });
	
	    return prevComponent;
	  },
	
	  /**
	   * Render a new component into the DOM. Hooked by hooks!
	   *
	   * @param {ReactElement} nextElement element to render
	   * @param {DOMElement} container container to render into
	   * @param {boolean} shouldReuseMarkup if we should skip the markup insertion
	   * @return {ReactComponent} nextComponent
	   */
	  _renderNewRootComponent: function (nextElement, container, shouldReuseMarkup, context) {
	    // Various parts of our code (such as ReactCompositeComponent's
	    // _renderValidatedComponent) assume that calls to render aren't nested;
	    // verify that that's the case.
	     false ? warning(ReactCurrentOwner.current == null, '_renderNewRootComponent(): Render methods should be a pure function ' + 'of props and state; triggering nested component updates from ' + 'render is not allowed. If necessary, trigger nested updates in ' + 'componentDidUpdate. Check the render method of %s.', ReactCurrentOwner.current && ReactCurrentOwner.current.getName() || 'ReactCompositeComponent') : void 0;
	
	    !isValidContainer(container) ?  false ? invariant(false, '_registerComponent(...): Target container is not a DOM element.') : _prodInvariant('37') : void 0;
	
	    ReactBrowserEventEmitter.ensureScrollValueMonitoring();
	    var componentInstance = instantiateReactComponent(nextElement, false);
	
	    // The initial render is synchronous but any updates that happen during
	    // rendering, in componentWillMount or componentDidMount, will be batched
	    // according to the current batching strategy.
	
	    ReactUpdates.batchedUpdates(batchedMountComponentIntoNode, componentInstance, container, shouldReuseMarkup, context);
	
	    var wrapperID = componentInstance._instance.rootID;
	    instancesByReactRootID[wrapperID] = componentInstance;
	
	    return componentInstance;
	  },
	
	  /**
	   * Renders a React component into the DOM in the supplied `container`.
	   *
	   * If the React component was previously rendered into `container`, this will
	   * perform an update on it and only mutate the DOM as necessary to reflect the
	   * latest React component.
	   *
	   * @param {ReactComponent} parentComponent The conceptual parent of this render tree.
	   * @param {ReactElement} nextElement Component element to render.
	   * @param {DOMElement} container DOM element to render into.
	   * @param {?function} callback function triggered on completion
	   * @return {ReactComponent} Component instance rendered in `container`.
	   */
	  renderSubtreeIntoContainer: function (parentComponent, nextElement, container, callback) {
	    !(parentComponent != null && ReactInstanceMap.has(parentComponent)) ?  false ? invariant(false, 'parentComponent must be a valid React Component') : _prodInvariant('38') : void 0;
	    return ReactMount._renderSubtreeIntoContainer(parentComponent, nextElement, container, callback);
	  },
	
	  _renderSubtreeIntoContainer: function (parentComponent, nextElement, container, callback) {
	    ReactUpdateQueue.validateCallback(callback, 'ReactDOM.render');
	    !React.isValidElement(nextElement) ?  false ? invariant(false, 'ReactDOM.render(): Invalid component element.%s', typeof nextElement === 'string' ? " Instead of passing a string like 'div', pass " + "React.createElement('div') or <div />." : typeof nextElement === 'function' ? ' Instead of passing a class like Foo, pass ' + 'React.createElement(Foo) or <Foo />.' : // Check if it quacks like an element
	    nextElement != null && nextElement.props !== undefined ? ' This may be caused by unintentionally loading two independent ' + 'copies of React.' : '') : _prodInvariant('39', typeof nextElement === 'string' ? " Instead of passing a string like 'div', pass " + "React.createElement('div') or <div />." : typeof nextElement === 'function' ? ' Instead of passing a class like Foo, pass ' + 'React.createElement(Foo) or <Foo />.' : nextElement != null && nextElement.props !== undefined ? ' This may be caused by unintentionally loading two independent ' + 'copies of React.' : '') : void 0;
	
	     false ? warning(!container || !container.tagName || container.tagName.toUpperCase() !== 'BODY', 'render(): Rendering components directly into document.body is ' + 'discouraged, since its children are often manipulated by third-party ' + 'scripts and browser extensions. This may lead to subtle ' + 'reconciliation issues. Try rendering into a container element created ' + 'for your app.') : void 0;
	
	    var nextWrappedElement = React.createElement(TopLevelWrapper, {
	      child: nextElement
	    });
	
	    var nextContext;
	    if (parentComponent) {
	      var parentInst = ReactInstanceMap.get(parentComponent);
	      nextContext = parentInst._processChildContext(parentInst._context);
	    } else {
	      nextContext = emptyObject;
	    }
	
	    var prevComponent = getTopLevelWrapperInContainer(container);
	
	    if (prevComponent) {
	      var prevWrappedElement = prevComponent._currentElement;
	      var prevElement = prevWrappedElement.props.child;
	      if (shouldUpdateReactComponent(prevElement, nextElement)) {
	        var publicInst = prevComponent._renderedComponent.getPublicInstance();
	        var updatedCallback = callback && function () {
	          callback.call(publicInst);
	        };
	        ReactMount._updateRootComponent(prevComponent, nextWrappedElement, nextContext, container, updatedCallback);
	        return publicInst;
	      } else {
	        ReactMount.unmountComponentAtNode(container);
	      }
	    }
	
	    var reactRootElement = getReactRootElementInContainer(container);
	    var containerHasReactMarkup = reactRootElement && !!internalGetID(reactRootElement);
	    var containerHasNonRootReactChild = hasNonRootReactChild(container);
	
	    if (false) {
	      process.env.NODE_ENV !== 'production' ? warning(!containerHasNonRootReactChild, 'render(...): Replacing React-rendered children with a new root ' + 'component. If you intended to update the children of this node, ' + 'you should instead have the existing children update their state ' + 'and render the new components instead of calling ReactDOM.render.') : void 0;
	
	      if (!containerHasReactMarkup || reactRootElement.nextSibling) {
	        var rootElementSibling = reactRootElement;
	        while (rootElementSibling) {
	          if (internalGetID(rootElementSibling)) {
	            process.env.NODE_ENV !== 'production' ? warning(false, 'render(): Target node has markup rendered by React, but there ' + 'are unrelated nodes as well. This is most commonly caused by ' + 'white-space inserted around server-rendered markup.') : void 0;
	            break;
	          }
	          rootElementSibling = rootElementSibling.nextSibling;
	        }
	      }
	    }
	
	    var shouldReuseMarkup = containerHasReactMarkup && !prevComponent && !containerHasNonRootReactChild;
	    var component = ReactMount._renderNewRootComponent(nextWrappedElement, container, shouldReuseMarkup, nextContext)._renderedComponent.getPublicInstance();
	    if (callback) {
	      callback.call(component);
	    }
	    return component;
	  },
	
	  /**
	   * Renders a React component into the DOM in the supplied `container`.
	   * See https://facebook.github.io/react/docs/top-level-api.html#reactdom.render
	   *
	   * If the React component was previously rendered into `container`, this will
	   * perform an update on it and only mutate the DOM as necessary to reflect the
	   * latest React component.
	   *
	   * @param {ReactElement} nextElement Component element to render.
	   * @param {DOMElement} container DOM element to render into.
	   * @param {?function} callback function triggered on completion
	   * @return {ReactComponent} Component instance rendered in `container`.
	   */
	  render: function (nextElement, container, callback) {
	    return ReactMount._renderSubtreeIntoContainer(null, nextElement, container, callback);
	  },
	
	  /**
	   * Unmounts and destroys the React component rendered in the `container`.
	   * See https://facebook.github.io/react/docs/top-level-api.html#reactdom.unmountcomponentatnode
	   *
	   * @param {DOMElement} container DOM element containing a React component.
	   * @return {boolean} True if a component was found in and unmounted from
	   *                   `container`
	   */
	  unmountComponentAtNode: function (container) {
	    // Various parts of our code (such as ReactCompositeComponent's
	    // _renderValidatedComponent) assume that calls to render aren't nested;
	    // verify that that's the case. (Strictly speaking, unmounting won't cause a
	    // render but we still don't expect to be in a render call here.)
	     false ? warning(ReactCurrentOwner.current == null, 'unmountComponentAtNode(): Render methods should be a pure function ' + 'of props and state; triggering nested component updates from render ' + 'is not allowed. If necessary, trigger nested updates in ' + 'componentDidUpdate. Check the render method of %s.', ReactCurrentOwner.current && ReactCurrentOwner.current.getName() || 'ReactCompositeComponent') : void 0;
	
	    !isValidContainer(container) ?  false ? invariant(false, 'unmountComponentAtNode(...): Target container is not a DOM element.') : _prodInvariant('40') : void 0;
	
	    if (false) {
	      process.env.NODE_ENV !== 'production' ? warning(!nodeIsRenderedByOtherInstance(container), "unmountComponentAtNode(): The node you're attempting to unmount " + 'was rendered by another copy of React.') : void 0;
	    }
	
	    var prevComponent = getTopLevelWrapperInContainer(container);
	    if (!prevComponent) {
	      // Check if the node being unmounted was rendered by React, but isn't a
	      // root node.
	      var containerHasNonRootReactChild = hasNonRootReactChild(container);
	
	      // Check if the container itself is a React root node.
	      var isContainerReactRoot = container.nodeType === 1 && container.hasAttribute(ROOT_ATTR_NAME);
	
	      if (false) {
	        process.env.NODE_ENV !== 'production' ? warning(!containerHasNonRootReactChild, "unmountComponentAtNode(): The node you're attempting to unmount " + 'was rendered by React and is not a top-level container. %s', isContainerReactRoot ? 'You may have accidentally passed in a React root node instead ' + 'of its container.' : 'Instead, have the parent component update its state and ' + 'rerender in order to remove this component.') : void 0;
	      }
	
	      return false;
	    }
	    delete instancesByReactRootID[prevComponent._instance.rootID];
	    ReactUpdates.batchedUpdates(unmountComponentFromNode, prevComponent, container, false);
	    return true;
	  },
	
	  _mountImageIntoNode: function (markup, container, instance, shouldReuseMarkup, transaction) {
	    !isValidContainer(container) ?  false ? invariant(false, 'mountComponentIntoNode(...): Target container is not valid.') : _prodInvariant('41') : void 0;
	
	    if (shouldReuseMarkup) {
	      var rootElement = getReactRootElementInContainer(container);
	      if (ReactMarkupChecksum.canReuseMarkup(markup, rootElement)) {
	        ReactDOMComponentTree.precacheNode(instance, rootElement);
	        return;
	      } else {
	        var checksum = rootElement.getAttribute(ReactMarkupChecksum.CHECKSUM_ATTR_NAME);
	        rootElement.removeAttribute(ReactMarkupChecksum.CHECKSUM_ATTR_NAME);
	
	        var rootMarkup = rootElement.outerHTML;
	        rootElement.setAttribute(ReactMarkupChecksum.CHECKSUM_ATTR_NAME, checksum);
	
	        var normalizedMarkup = markup;
	        if (false) {
	          // because rootMarkup is retrieved from the DOM, various normalizations
	          // will have occurred which will not be present in `markup`. Here,
	          // insert markup into a <div> or <iframe> depending on the container
	          // type to perform the same normalizations before comparing.
	          var normalizer;
	          if (container.nodeType === ELEMENT_NODE_TYPE) {
	            normalizer = document.createElement('div');
	            normalizer.innerHTML = markup;
	            normalizedMarkup = normalizer.innerHTML;
	          } else {
	            normalizer = document.createElement('iframe');
	            document.body.appendChild(normalizer);
	            normalizer.contentDocument.write(markup);
	            normalizedMarkup = normalizer.contentDocument.documentElement.outerHTML;
	            document.body.removeChild(normalizer);
	          }
	        }
	
	        var diffIndex = firstDifferenceIndex(normalizedMarkup, rootMarkup);
	        var difference = ' (client) ' + normalizedMarkup.substring(diffIndex - 20, diffIndex + 20) + '\n (server) ' + rootMarkup.substring(diffIndex - 20, diffIndex + 20);
	
	        !(container.nodeType !== DOC_NODE_TYPE) ?  false ? invariant(false, 'You\'re trying to render a component to the document using server rendering but the checksum was invalid. This usually means you rendered a different component type or props on the client from the one on the server, or your render() methods are impure. React cannot handle this case due to cross-browser quirks by rendering at the document root. You should look for environment dependent code in your components and ensure the props are the same client and server side:\n%s', difference) : _prodInvariant('42', difference) : void 0;
	
	        if (false) {
	          process.env.NODE_ENV !== 'production' ? warning(false, 'React attempted to reuse markup in a container but the ' + 'checksum was invalid. This generally means that you are ' + 'using server rendering and the markup generated on the ' + 'server was not what the client was expecting. React injected ' + 'new markup to compensate which works but you have lost many ' + 'of the benefits of server rendering. Instead, figure out ' + 'why the markup being generated is different on the client ' + 'or server:\n%s', difference) : void 0;
	        }
	      }
	    }
	
	    !(container.nodeType !== DOC_NODE_TYPE) ?  false ? invariant(false, 'You\'re trying to render a component to the document but you didn\'t use server rendering. We can\'t do this without using server rendering due to cross-browser quirks. See ReactDOMServer.renderToString() for server rendering.') : _prodInvariant('43') : void 0;
	
	    if (transaction.useCreateElement) {
	      while (container.lastChild) {
	        container.removeChild(container.lastChild);
	      }
	      DOMLazyTree.insertTreeBefore(container, markup, null);
	    } else {
	      setInnerHTML(container, markup);
	      ReactDOMComponentTree.precacheNode(instance, container.firstChild);
	    }
	
	    if (false) {
	      var hostNode = ReactDOMComponentTree.getInstanceFromNode(container.firstChild);
	      if (hostNode._debugID !== 0) {
	        ReactInstrumentation.debugTool.onHostOperation({
	          instanceID: hostNode._debugID,
	          type: 'mount',
	          payload: markup.toString()
	        });
	      }
	    }
	  }
	};
	
	module.exports = ReactMount;

/***/ },
/* 396 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(29);
	
	var React = __webpack_require__(115);
	
	var invariant = __webpack_require__(21);
	
	var ReactNodeTypes = {
	  HOST: 0,
	  COMPOSITE: 1,
	  EMPTY: 2,
	
	  getType: function (node) {
	    if (node === null || node === false) {
	      return ReactNodeTypes.EMPTY;
	    } else if (React.isValidElement(node)) {
	      if (typeof node.type === 'function') {
	        return ReactNodeTypes.COMPOSITE;
	      } else {
	        return ReactNodeTypes.HOST;
	      }
	    }
	     true ?  false ? invariant(false, 'Unexpected node: %s', node) : _prodInvariant('26', node) : void 0;
	  }
	};
	
	module.exports = ReactNodeTypes;

/***/ },
/* 397 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2014-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(36);
	
	var PooledClass = __webpack_require__(113);
	var Transaction = __webpack_require__(186);
	var ReactInstrumentation = __webpack_require__(62);
	var ReactServerUpdateQueue = __webpack_require__(1002);
	
	/**
	 * Executed within the scope of the `Transaction` instance. Consider these as
	 * being member methods, but with an implied ordering while being isolated from
	 * each other.
	 */
	var TRANSACTION_WRAPPERS = [];
	
	if (false) {
	  TRANSACTION_WRAPPERS.push({
	    initialize: ReactInstrumentation.debugTool.onBeginFlush,
	    close: ReactInstrumentation.debugTool.onEndFlush
	  });
	}
	
	var noopCallbackQueue = {
	  enqueue: function () {}
	};
	
	/**
	 * @class ReactServerRenderingTransaction
	 * @param {boolean} renderToStaticMarkup
	 */
	function ReactServerRenderingTransaction(renderToStaticMarkup) {
	  this.reinitializeTransaction();
	  this.renderToStaticMarkup = renderToStaticMarkup;
	  this.useCreateElement = false;
	  this.updateQueue = new ReactServerUpdateQueue(this);
	}
	
	var Mixin = {
	  /**
	   * @see Transaction
	   * @abstract
	   * @final
	   * @return {array} Empty list of operation wrap procedures.
	   */
	  getTransactionWrappers: function () {
	    return TRANSACTION_WRAPPERS;
	  },
	
	  /**
	   * @return {object} The queue to collect `onDOMReady` callbacks with.
	   */
	  getReactMountReady: function () {
	    return noopCallbackQueue;
	  },
	
	  /**
	   * @return {object} The queue to collect React async events.
	   */
	  getUpdateQueue: function () {
	    return this.updateQueue;
	  },
	
	  /**
	   * `PooledClass` looks for this, and will invoke this before allowing this
	   * instance to be reused.
	   */
	  destructor: function () {},
	
	  checkpoint: function () {},
	
	  rollback: function () {}
	};
	
	_assign(ReactServerRenderingTransaction.prototype, Transaction, Mixin);
	
	PooledClass.addPoolingTo(ReactServerRenderingTransaction);
	
	module.exports = ReactServerRenderingTransaction;

/***/ },
/* 398 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	module.exports = '15.6.2';

/***/ },
/* 399 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ViewportMetrics = {
	  currentScrollLeft: 0,
	
	  currentScrollTop: 0,
	
	  refreshScrollValues: function (scrollPosition) {
	    ViewportMetrics.currentScrollLeft = scrollPosition.x;
	    ViewportMetrics.currentScrollTop = scrollPosition.y;
	  }
	};
	
	module.exports = ViewportMetrics;

/***/ },
/* 400 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2014-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(29);
	
	var invariant = __webpack_require__(21);
	
	/**
	 * Accumulates items that must not be null or undefined into the first one. This
	 * is used to conserve memory by avoiding array allocations, and thus sacrifices
	 * API cleanness. Since `current` can be null before being passed in and not
	 * null after this function, make sure to assign it back to `current`:
	 *
	 * `a = accumulateInto(a, b);`
	 *
	 * This API should be sparingly used. Try `accumulate` for something cleaner.
	 *
	 * @return {*|array<*>} An accumulation of items.
	 */
	
	function accumulateInto(current, next) {
	  !(next != null) ?  false ? invariant(false, 'accumulateInto(...): Accumulated items must not be null or undefined.') : _prodInvariant('30') : void 0;
	
	  if (current == null) {
	    return next;
	  }
	
	  // Both are not empty. Warning: Never call x.concat(y) when you are not
	  // certain that x is an Array (x could be a string with concat method).
	  if (Array.isArray(current)) {
	    if (Array.isArray(next)) {
	      current.push.apply(current, next);
	      return current;
	    }
	    current.push(next);
	    return current;
	  }
	
	  if (Array.isArray(next)) {
	    // A bit too dangerous to mutate `next`.
	    return [current].concat(next);
	  }
	
	  return [current, next];
	}
	
	module.exports = accumulateInto;

/***/ },
/* 401 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	/**
	 * @param {array} arr an "accumulation" of items which is either an Array or
	 * a single item. Useful when paired with the `accumulate` module. This is a
	 * simple utility that allows us to reason about a collection of items, but
	 * handling the case when there is exactly one item (and we do not need to
	 * allocate an array).
	 */
	
	function forEachAccumulated(arr, cb, scope) {
	  if (Array.isArray(arr)) {
	    arr.forEach(cb, scope);
	  } else if (arr) {
	    cb.call(scope, arr);
	  }
	}
	
	module.exports = forEachAccumulated;

/***/ },
/* 402 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ReactNodeTypes = __webpack_require__(396);
	
	function getHostComponentFromComposite(inst) {
	  var type;
	
	  while ((type = inst._renderedNodeType) === ReactNodeTypes.COMPOSITE) {
	    inst = inst._renderedComponent;
	  }
	
	  if (type === ReactNodeTypes.HOST) {
	    return inst._renderedComponent;
	  } else if (type === ReactNodeTypes.EMPTY) {
	    return null;
	  }
	}
	
	module.exports = getHostComponentFromComposite;

/***/ },
/* 403 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ExecutionEnvironment = __webpack_require__(51);
	
	var contentKey = null;
	
	/**
	 * Gets the key used to access text content on a DOM node.
	 *
	 * @return {?string} Key used to access text content.
	 * @internal
	 */
	function getTextContentAccessor() {
	  if (!contentKey && ExecutionEnvironment.canUseDOM) {
	    // Prefer textContent to innerText because many browsers support both but
	    // SVG <text> elements don't support innerText even when <div> does.
	    contentKey = 'textContent' in document.documentElement ? 'textContent' : 'innerText';
	  }
	  return contentKey;
	}
	
	module.exports = getTextContentAccessor;

/***/ },
/* 404 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ReactDOMComponentTree = __webpack_require__(41);
	
	function isCheckable(elem) {
	  var type = elem.type;
	  var nodeName = elem.nodeName;
	  return nodeName && nodeName.toLowerCase() === 'input' && (type === 'checkbox' || type === 'radio');
	}
	
	function getTracker(inst) {
	  return inst._wrapperState.valueTracker;
	}
	
	function attachTracker(inst, tracker) {
	  inst._wrapperState.valueTracker = tracker;
	}
	
	function detachTracker(inst) {
	  inst._wrapperState.valueTracker = null;
	}
	
	function getValueFromNode(node) {
	  var value;
	  if (node) {
	    value = isCheckable(node) ? '' + node.checked : node.value;
	  }
	  return value;
	}
	
	var inputValueTracking = {
	  // exposed for testing
	  _getTrackerFromNode: function (node) {
	    return getTracker(ReactDOMComponentTree.getInstanceFromNode(node));
	  },
	
	
	  track: function (inst) {
	    if (getTracker(inst)) {
	      return;
	    }
	
	    var node = ReactDOMComponentTree.getNodeFromInstance(inst);
	    var valueField = isCheckable(node) ? 'checked' : 'value';
	    var descriptor = Object.getOwnPropertyDescriptor(node.constructor.prototype, valueField);
	
	    var currentValue = '' + node[valueField];
	
	    // if someone has already defined a value or Safari, then bail
	    // and don't track value will cause over reporting of changes,
	    // but it's better then a hard failure
	    // (needed for certain tests that spyOn input values and Safari)
	    if (node.hasOwnProperty(valueField) || typeof descriptor.get !== 'function' || typeof descriptor.set !== 'function') {
	      return;
	    }
	
	    Object.defineProperty(node, valueField, {
	      enumerable: descriptor.enumerable,
	      configurable: true,
	      get: function () {
	        return descriptor.get.call(this);
	      },
	      set: function (value) {
	        currentValue = '' + value;
	        descriptor.set.call(this, value);
	      }
	    });
	
	    attachTracker(inst, {
	      getValue: function () {
	        return currentValue;
	      },
	      setValue: function (value) {
	        currentValue = '' + value;
	      },
	      stopTracking: function () {
	        detachTracker(inst);
	        delete node[valueField];
	      }
	    });
	  },
	
	  updateValueIfChanged: function (inst) {
	    if (!inst) {
	      return false;
	    }
	    var tracker = getTracker(inst);
	
	    if (!tracker) {
	      inputValueTracking.track(inst);
	      return true;
	    }
	
	    var lastValue = tracker.getValue();
	    var nextValue = getValueFromNode(ReactDOMComponentTree.getNodeFromInstance(inst));
	
	    if (nextValue !== lastValue) {
	      tracker.setValue(nextValue);
	      return true;
	    }
	
	    return false;
	  },
	  stopTracking: function (inst) {
	    var tracker = getTracker(inst);
	    if (tracker) {
	      tracker.stopTracking();
	    }
	  }
	};
	
	module.exports = inputValueTracking;

/***/ },
/* 405 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	/**
	 * @see http://www.whatwg.org/specs/web-apps/current-work/multipage/the-input-element.html#input-type-attr-summary
	 */
	
	var supportedInputTypes = {
	  color: true,
	  date: true,
	  datetime: true,
	  'datetime-local': true,
	  email: true,
	  month: true,
	  number: true,
	  password: true,
	  range: true,
	  search: true,
	  tel: true,
	  text: true,
	  time: true,
	  url: true,
	  week: true
	};
	
	function isTextInputElement(elem) {
	  var nodeName = elem && elem.nodeName && elem.nodeName.toLowerCase();
	
	  if (nodeName === 'input') {
	    return !!supportedInputTypes[elem.type];
	  }
	
	  if (nodeName === 'textarea') {
	    return true;
	  }
	
	  return false;
	}
	
	module.exports = isTextInputElement;

/***/ },
/* 406 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ExecutionEnvironment = __webpack_require__(51);
	var escapeTextContentForBrowser = __webpack_require__(187);
	var setInnerHTML = __webpack_require__(188);
	
	/**
	 * Set the textContent property of a node, ensuring that whitespace is preserved
	 * even in IE8. innerText is a poor substitute for textContent and, among many
	 * issues, inserts <br> instead of the literal newline chars. innerHTML behaves
	 * as it should.
	 *
	 * @param {DOMElement} node
	 * @param {string} text
	 * @internal
	 */
	var setTextContent = function (node, text) {
	  if (text) {
	    var firstChild = node.firstChild;
	
	    if (firstChild && firstChild === node.lastChild && firstChild.nodeType === 3) {
	      firstChild.nodeValue = text;
	      return;
	    }
	  }
	  node.textContent = text;
	};
	
	if (ExecutionEnvironment.canUseDOM) {
	  if (!('textContent' in document.documentElement)) {
	    setTextContent = function (node, text) {
	      if (node.nodeType === 3) {
	        node.nodeValue = text;
	        return;
	      }
	      setInnerHTML(node, escapeTextContentForBrowser(text));
	    };
	  }
	}
	
	module.exports = setTextContent;

/***/ },
/* 407 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(29);
	
	var ReactCurrentOwner = __webpack_require__(92);
	var REACT_ELEMENT_TYPE = __webpack_require__(991);
	
	var getIteratorFn = __webpack_require__(1021);
	var invariant = __webpack_require__(21);
	var KeyEscapeUtils = __webpack_require__(252);
	var warning = __webpack_require__(30);
	
	var SEPARATOR = '.';
	var SUBSEPARATOR = ':';
	
	/**
	 * This is inlined from ReactElement since this file is shared between
	 * isomorphic and renderers. We could extract this to a
	 *
	 */
	
	/**
	 * TODO: Test that a single child and an array with one item have the same key
	 * pattern.
	 */
	
	var didWarnAboutMaps = false;
	
	/**
	 * Generate a key string that identifies a component within a set.
	 *
	 * @param {*} component A component that could contain a manual key.
	 * @param {number} index Index that is used if a manual key is not provided.
	 * @return {string}
	 */
	function getComponentKey(component, index) {
	  // Do some typechecking here since we call this blindly. We want to ensure
	  // that we don't block potential future ES APIs.
	  if (component && typeof component === 'object' && component.key != null) {
	    // Explicit key
	    return KeyEscapeUtils.escape(component.key);
	  }
	  // Implicit key determined by the index in the set
	  return index.toString(36);
	}
	
	/**
	 * @param {?*} children Children tree container.
	 * @param {!string} nameSoFar Name of the key path so far.
	 * @param {!function} callback Callback to invoke with each child found.
	 * @param {?*} traverseContext Used to pass information throughout the traversal
	 * process.
	 * @return {!number} The number of children in this subtree.
	 */
	function traverseAllChildrenImpl(children, nameSoFar, callback, traverseContext) {
	  var type = typeof children;
	
	  if (type === 'undefined' || type === 'boolean') {
	    // All of the above are perceived as null.
	    children = null;
	  }
	
	  if (children === null || type === 'string' || type === 'number' ||
	  // The following is inlined from ReactElement. This means we can optimize
	  // some checks. React Fiber also inlines this logic for similar purposes.
	  type === 'object' && children.$$typeof === REACT_ELEMENT_TYPE) {
	    callback(traverseContext, children,
	    // If it's the only child, treat the name as if it was wrapped in an array
	    // so that it's consistent if the number of children grows.
	    nameSoFar === '' ? SEPARATOR + getComponentKey(children, 0) : nameSoFar);
	    return 1;
	  }
	
	  var child;
	  var nextName;
	  var subtreeCount = 0; // Count of children found in the current subtree.
	  var nextNamePrefix = nameSoFar === '' ? SEPARATOR : nameSoFar + SUBSEPARATOR;
	
	  if (Array.isArray(children)) {
	    for (var i = 0; i < children.length; i++) {
	      child = children[i];
	      nextName = nextNamePrefix + getComponentKey(child, i);
	      subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
	    }
	  } else {
	    var iteratorFn = getIteratorFn(children);
	    if (iteratorFn) {
	      var iterator = iteratorFn.call(children);
	      var step;
	      if (iteratorFn !== children.entries) {
	        var ii = 0;
	        while (!(step = iterator.next()).done) {
	          child = step.value;
	          nextName = nextNamePrefix + getComponentKey(child, ii++);
	          subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
	        }
	      } else {
	        if (false) {
	          var mapsAsChildrenAddendum = '';
	          if (ReactCurrentOwner.current) {
	            var mapsAsChildrenOwnerName = ReactCurrentOwner.current.getName();
	            if (mapsAsChildrenOwnerName) {
	              mapsAsChildrenAddendum = ' Check the render method of `' + mapsAsChildrenOwnerName + '`.';
	            }
	          }
	          process.env.NODE_ENV !== 'production' ? warning(didWarnAboutMaps, 'Using Maps as children is not yet fully supported. It is an ' + 'experimental feature that might be removed. Convert it to a ' + 'sequence / iterable of keyed ReactElements instead.%s', mapsAsChildrenAddendum) : void 0;
	          didWarnAboutMaps = true;
	        }
	        // Iterator will provide entry [k,v] tuples rather than values.
	        while (!(step = iterator.next()).done) {
	          var entry = step.value;
	          if (entry) {
	            child = entry[1];
	            nextName = nextNamePrefix + KeyEscapeUtils.escape(entry[0]) + SUBSEPARATOR + getComponentKey(child, 0);
	            subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
	          }
	        }
	      }
	    } else if (type === 'object') {
	      var addendum = '';
	      if (false) {
	        addendum = ' If you meant to render a collection of children, use an array ' + 'instead or wrap the object using createFragment(object) from the ' + 'React add-ons.';
	        if (children._isReactElement) {
	          addendum = " It looks like you're using an element created by a different " + 'version of React. Make sure to use only one copy of React.';
	        }
	        if (ReactCurrentOwner.current) {
	          var name = ReactCurrentOwner.current.getName();
	          if (name) {
	            addendum += ' Check the render method of `' + name + '`.';
	          }
	        }
	      }
	      var childrenString = String(children);
	       true ?  false ? invariant(false, 'Objects are not valid as a React child (found: %s).%s', childrenString === '[object Object]' ? 'object with keys {' + Object.keys(children).join(', ') + '}' : childrenString, addendum) : _prodInvariant('31', childrenString === '[object Object]' ? 'object with keys {' + Object.keys(children).join(', ') + '}' : childrenString, addendum) : void 0;
	    }
	  }
	
	  return subtreeCount;
	}
	
	/**
	 * Traverses children that are typically specified as `props.children`, but
	 * might also be specified through attributes:
	 *
	 * - `traverseAllChildren(this.props.children, ...)`
	 * - `traverseAllChildren(this.props.leftPanelChildren, ...)`
	 *
	 * The `traverseContext` is an optional argument that is passed through the
	 * entire traversal. It can be used to store accumulations or anything else that
	 * the callback might find relevant.
	 *
	 * @param {?*} children Children tree object.
	 * @param {!function} callback To invoke upon traversing each child.
	 * @param {?*} traverseContext Context for traversal.
	 * @return {!number} The number of children in this subtree.
	 */
	function traverseAllChildren(children, callback, traverseContext) {
	  if (children == null) {
	    return 0;
	  }
	
	  return traverseAllChildrenImpl(children, '', callback, traverseContext);
	}
	
	module.exports = traverseAllChildren;

/***/ },
/* 408 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.DailyMotion = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _utils = __webpack_require__(63);
	
	var _singlePlayer = __webpack_require__(81);
	
	var _singlePlayer2 = _interopRequireDefault(_singlePlayer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var SDK_URL = 'https://api.dmcdn.net/all.js';
	var SDK_GLOBAL = 'DM';
	var SDK_GLOBAL_READY = 'dmAsyncInit';
	var MATCH_URL = /dailymotion\.com\/(video|hub)\/([^_]+)[^#]*(#video=([^_&]+))?/;
	
	var DailyMotion = exports.DailyMotion = function (_Component) {
	  _inherits(DailyMotion, _Component);
	
	  function DailyMotion() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, DailyMotion);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = DailyMotion.__proto__ || Object.getPrototypeOf(DailyMotion)).call.apply(_ref, [this].concat(args))), _this), _this.callPlayer = _utils.callPlayer, _this.onDurationChange = function () {
	      var duration = _this.getDuration();
	      _this.props.onDuration(duration);
	    }, _this.mute = function () {
	      _this.callPlayer('setMuted', true);
	    }, _this.unmute = function () {
	      _this.callPlayer('setMuted', false);
	    }, _this.ref = function (container) {
	      _this.container = container;
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(DailyMotion, [{
	    key: 'parseId',
	    value: function parseId(url) {
	      var m = url.match(MATCH_URL);
	      return m[4] || m[2];
	    }
	  }, {
	    key: 'load',
	    value: function load(url) {
	      var _this2 = this;
	
	      var _props = this.props,
	          controls = _props.controls,
	          config = _props.config,
	          onError = _props.onError,
	          playing = _props.playing;
	
	      var id = this.parseId(url);
	      if (this.player) {
	        this.player.load(id, {
	          start: (0, _utils.parseStartTime)(url),
	          autoplay: playing
	        });
	        return;
	      }
	      (0, _utils.getSDK)(SDK_URL, SDK_GLOBAL, SDK_GLOBAL_READY, function (DM) {
	        return DM.player;
	      }).then(function (DM) {
	        if (!_this2.container) return;
	        var Player = DM.player;
	        _this2.player = new Player(_this2.container, {
	          width: '100%',
	          height: '100%',
	          video: id,
	          params: _extends({
	            controls: controls,
	            autoplay: _this2.props.playing,
	            mute: _this2.props.muted,
	            start: (0, _utils.parseStartTime)(url),
	            origin: window.location.origin
	          }, config.dailymotion.params),
	          events: {
	            apiready: _this2.props.onReady,
	            seeked: function seeked() {
	              return _this2.props.onSeek(_this2.player.currentTime);
	            },
	            video_end: _this2.props.onEnded,
	            durationchange: _this2.onDurationChange,
	            pause: _this2.props.onPause,
	            playing: _this2.props.onPlay,
	            waiting: _this2.props.onBuffer,
	            error: function error(event) {
	              return onError(event);
	            }
	          }
	        });
	      }, onError);
	    }
	  }, {
	    key: 'play',
	    value: function play() {
	      this.callPlayer('play');
	    }
	  }, {
	    key: 'pause',
	    value: function pause() {
	      this.callPlayer('pause');
	    }
	  }, {
	    key: 'stop',
	    value: function stop() {
	      // Nothing to do
	    }
	  }, {
	    key: 'seekTo',
	    value: function seekTo(seconds) {
	      this.callPlayer('seek', seconds);
	    }
	  }, {
	    key: 'setVolume',
	    value: function setVolume(fraction) {
	      this.callPlayer('setVolume', fraction);
	    }
	  }, {
	    key: 'getDuration',
	    value: function getDuration() {
	      return this.player.duration || null;
	    }
	  }, {
	    key: 'getCurrentTime',
	    value: function getCurrentTime() {
	      return this.player.currentTime;
	    }
	  }, {
	    key: 'getSecondsLoaded',
	    value: function getSecondsLoaded() {
	      return this.player.bufferedTime;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var style = _extends({
	        width: '100%',
	        height: '100%',
	        backgroundColor: 'black'
	      }, this.props.style);
	      return _react2['default'].createElement(
	        'div',
	        { style: style },
	        _react2['default'].createElement('div', { ref: this.ref })
	      );
	    }
	  }]);
	
	  return DailyMotion;
	}(_react.Component);
	
	DailyMotion.displayName = 'DailyMotion';
	
	DailyMotion.canPlay = function (url) {
	  return MATCH_URL.test(url);
	};
	
	DailyMotion.loopOnEnded = true;
	exports['default'] = (0, _singlePlayer2['default'])(DailyMotion);

/***/ },
/* 409 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.FilePlayer = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _utils = __webpack_require__(63);
	
	var _singlePlayer = __webpack_require__(81);
	
	var _singlePlayer2 = _interopRequireDefault(_singlePlayer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var IOS = typeof navigator !== 'undefined' && /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
	var AUDIO_EXTENSIONS = /\.(m4a|mp4a|mpga|mp2|mp2a|mp3|m2a|m3a|wav|weba|aac|oga|spx)($|\?)/i;
	var VIDEO_EXTENSIONS = /\.(mp4|og[gv]|webm|mov|m4v)($|\?)/i;
	var HLS_EXTENSIONS = /\.(m3u8)($|\?)/i;
	var HLS_SDK_URL = 'https://cdnjs.cloudflare.com/ajax/libs/hls.js/0.9.1/hls.min.js';
	var HLS_GLOBAL = 'Hls';
	var DASH_EXTENSIONS = /\.(mpd)($|\?)/i;
	var DASH_SDK_URL = 'https://cdnjs.cloudflare.com/ajax/libs/dashjs/2.6.5/dash.all.min.js';
	var DASH_GLOBAL = 'dashjs';
	var MATCH_DROPBOX_URL = /www\.dropbox\.com\/.+/;
	
	function canPlay(url) {
	  if (url instanceof Array) {
	    var _iteratorNormalCompletion = true;
	    var _didIteratorError = false;
	    var _iteratorError = undefined;
	
	    try {
	      for (var _iterator = url[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	        var item = _step.value;
	
	        if (typeof item === 'string' && canPlay(item)) {
	          return true;
	        }
	        if (canPlay(item.src)) {
	          return true;
	        }
	      }
	    } catch (err) {
	      _didIteratorError = true;
	      _iteratorError = err;
	    } finally {
	      try {
	        if (!_iteratorNormalCompletion && _iterator['return']) {
	          _iterator['return']();
	        }
	      } finally {
	        if (_didIteratorError) {
	          throw _iteratorError;
	        }
	      }
	    }
	
	    return false;
	  }
	  if ((0, _utils.isMediaStream)(url)) {
	    return true;
	  }
	  return AUDIO_EXTENSIONS.test(url) || VIDEO_EXTENSIONS.test(url) || HLS_EXTENSIONS.test(url) || DASH_EXTENSIONS.test(url);
	}
	
	var FilePlayer = exports.FilePlayer = function (_Component) {
	  _inherits(FilePlayer, _Component);
	
	  function FilePlayer() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, FilePlayer);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = FilePlayer.__proto__ || Object.getPrototypeOf(FilePlayer)).call.apply(_ref, [this].concat(args))), _this), _this.onSeek = function (e) {
	      _this.props.onSeek(e.target.currentTime);
	    }, _this.mute = function () {
	      _this.player.muted = true;
	    }, _this.unmute = function () {
	      _this.player.muted = false;
	    }, _this.renderSourceElement = function (source, index) {
	      if (typeof source === 'string') {
	        return _react2['default'].createElement('source', { key: index, src: source });
	      }
	      return _react2['default'].createElement('source', _extends({ key: index }, source));
	    }, _this.renderTrack = function (track, index) {
	      return _react2['default'].createElement('track', _extends({ key: index }, track));
	    }, _this.ref = function (player) {
	      _this.player = player;
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(FilePlayer, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.addListeners();
	      if (IOS) {
	        this.player.load();
	      }
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (this.shouldUseAudio(this.props) !== this.shouldUseAudio(nextProps)) {
	        this.removeListeners();
	      }
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate(prevProps) {
	      if (this.shouldUseAudio(this.props) !== this.shouldUseAudio(prevProps)) {
	        this.addListeners();
	      }
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      this.removeListeners();
	    }
	  }, {
	    key: 'addListeners',
	    value: function addListeners() {
	      var _props = this.props,
	          onReady = _props.onReady,
	          onPlay = _props.onPlay,
	          onPause = _props.onPause,
	          onEnded = _props.onEnded,
	          onError = _props.onError,
	          playsinline = _props.playsinline;
	
	      this.player.addEventListener('canplay', onReady);
	      this.player.addEventListener('play', onPlay);
	      this.player.addEventListener('pause', onPause);
	      this.player.addEventListener('seeked', this.onSeek);
	      this.player.addEventListener('ended', onEnded);
	      this.player.addEventListener('error', onError);
	      if (playsinline) {
	        this.player.setAttribute('playsinline', '');
	        this.player.setAttribute('webkit-playsinline', '');
	      }
	    }
	  }, {
	    key: 'removeListeners',
	    value: function removeListeners() {
	      var _props2 = this.props,
	          onReady = _props2.onReady,
	          onPlay = _props2.onPlay,
	          onPause = _props2.onPause,
	          onEnded = _props2.onEnded,
	          onError = _props2.onError;
	
	      this.player.removeEventListener('canplay', onReady);
	      this.player.removeEventListener('play', onPlay);
	      this.player.removeEventListener('pause', onPause);
	      this.player.removeEventListener('seeked', this.onSeek);
	      this.player.removeEventListener('ended', onEnded);
	      this.player.removeEventListener('error', onError);
	    }
	  }, {
	    key: 'shouldUseAudio',
	    value: function shouldUseAudio(props) {
	      if (props.config.file.forceVideo) {
	        return false;
	      }
	      if (props.config.file.attributes.poster) {
	        return false; // Use <video> so that poster is shown
	      }
	      return AUDIO_EXTENSIONS.test(props.url) || props.config.file.forceAudio;
	    }
	  }, {
	    key: 'shouldUseHLS',
	    value: function shouldUseHLS(url) {
	      return HLS_EXTENSIONS.test(url) && !IOS || this.props.config.file.forceHLS;
	    }
	  }, {
	    key: 'shouldUseDASH',
	    value: function shouldUseDASH(url) {
	      return DASH_EXTENSIONS.test(url) || this.props.config.file.forceDASH;
	    }
	  }, {
	    key: 'load',
	    value: function load(url) {
	      var _this2 = this;
	
	      if (this.shouldUseHLS(url)) {
	        (0, _utils.getSDK)(HLS_SDK_URL, HLS_GLOBAL).then(function (Hls) {
	          _this2.hls = new Hls(_this2.props.config.file.hlsOptions);
	          _this2.hls.on(Hls.Events.ERROR, function (e, data) {
	            _this2.props.onError(e, data, _this2.hls, Hls);
	          });
	          _this2.hls.loadSource(url);
	          _this2.hls.attachMedia(_this2.player);
	        });
	      }
	      if (this.shouldUseDASH(url)) {
	        (0, _utils.getSDK)(DASH_SDK_URL, DASH_GLOBAL).then(function (dashjs) {
	          _this2.dash = dashjs.MediaPlayer().create();
	          _this2.dash.initialize(_this2.player, url, _this2.props.playing);
	          _this2.dash.getDebug().setLogToBrowserConsole(false);
	        });
	      }
	      if ((0, _utils.isMediaStream)(url)) {
	        try {
	          this.player.srcObject = url;
	        } catch (e) {
	          this.player.src = window.URL.createObjectURL(url);
	        }
	      }
	    }
	  }, {
	    key: 'play',
	    value: function play() {
	      var promise = this.player.play();
	      if (promise) {
	        promise['catch'](this.props.onError);
	      }
	    }
	  }, {
	    key: 'pause',
	    value: function pause() {
	      this.player.pause();
	    }
	  }, {
	    key: 'stop',
	    value: function stop() {
	      this.player.removeAttribute('src');
	      if (this.hls) {
	        this.hls.destroy();
	      }
	      if (this.dash) {
	        this.dash.reset();
	      }
	    }
	  }, {
	    key: 'seekTo',
	    value: function seekTo(seconds) {
	      this.player.currentTime = seconds;
	    }
	  }, {
	    key: 'setVolume',
	    value: function setVolume(fraction) {
	      this.player.volume = fraction;
	    }
	  }, {
	    key: 'setPlaybackRate',
	    value: function setPlaybackRate(rate) {
	      this.player.playbackRate = rate;
	    }
	  }, {
	    key: 'getDuration',
	    value: function getDuration() {
	      return this.player.duration;
	    }
	  }, {
	    key: 'getCurrentTime',
	    value: function getCurrentTime() {
	      return this.player.currentTime;
	    }
	  }, {
	    key: 'getSecondsLoaded',
	    value: function getSecondsLoaded() {
	      var buffered = this.player.buffered;
	
	      if (buffered.length === 0) {
	        return 0;
	      }
	      var end = buffered.end(buffered.length - 1);
	      var duration = this.getDuration();
	      if (end > duration) {
	        return duration;
	      }
	      return end;
	    }
	  }, {
	    key: 'getSource',
	    value: function getSource(url) {
	      var useHLS = this.shouldUseHLS(url);
	      var useDASH = this.shouldUseDASH(url);
	      if (url instanceof Array || (0, _utils.isMediaStream)(url) || useHLS || useDASH) {
	        return undefined;
	      }
	      if (MATCH_DROPBOX_URL.test(url)) {
	        return url.replace('www.dropbox.com', 'dl.dropboxusercontent.com');
	      }
	      return url;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props3 = this.props,
	          url = _props3.url,
	          playing = _props3.playing,
	          loop = _props3.loop,
	          controls = _props3.controls,
	          muted = _props3.muted,
	          config = _props3.config,
	          width = _props3.width,
	          height = _props3.height;
	
	      var useAudio = this.shouldUseAudio(this.props);
	      var Element = useAudio ? 'audio' : 'video';
	      var style = {
	        width: width === 'auto' ? width : '100%',
	        height: height === 'auto' ? height : '100%'
	      };
	      return _react2['default'].createElement(
	        Element,
	        _extends({
	          ref: this.ref,
	          src: this.getSource(url),
	          style: style,
	          preload: 'auto',
	          autoPlay: playing || undefined,
	          controls: controls,
	          muted: muted,
	          loop: loop
	        }, config.file.attributes),
	        url instanceof Array && url.map(this.renderSourceElement),
	        config.file.tracks.map(this.renderTrack)
	      );
	    }
	  }]);
	
	  return FilePlayer;
	}(_react.Component);
	
	FilePlayer.displayName = 'FilePlayer';
	FilePlayer.canPlay = canPlay;
	exports['default'] = (0, _singlePlayer2['default'])(FilePlayer);

/***/ },
/* 410 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.SoundCloud = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _utils = __webpack_require__(63);
	
	var _singlePlayer = __webpack_require__(81);
	
	var _singlePlayer2 = _interopRequireDefault(_singlePlayer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var SDK_URL = 'https://w.soundcloud.com/player/api.js';
	var SDK_GLOBAL = 'SC';
	var MATCH_URL = /(soundcloud\.com|snd\.sc)\/.+$/;
	
	var SoundCloud = exports.SoundCloud = function (_Component) {
	  _inherits(SoundCloud, _Component);
	
	  function SoundCloud() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, SoundCloud);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = SoundCloud.__proto__ || Object.getPrototypeOf(SoundCloud)).call.apply(_ref, [this].concat(args))), _this), _this.callPlayer = _utils.callPlayer, _this.duration = null, _this.currentTime = null, _this.fractionLoaded = null, _this.mute = function () {
	      _this.setVolume(0);
	    }, _this.unmute = function () {
	      if (_this.props.volume !== null) {
	        _this.setVolume(_this.props.volume);
	      }
	    }, _this.ref = function (iframe) {
	      _this.iframe = iframe;
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(SoundCloud, [{
	    key: 'load',
	    value: function load(url, isReady) {
	      var _this2 = this;
	
	      (0, _utils.getSDK)(SDK_URL, SDK_GLOBAL).then(function (SC) {
	        if (!_this2.iframe) return;
	        var _SC$Widget$Events = SC.Widget.Events,
	            PLAY = _SC$Widget$Events.PLAY,
	            PLAY_PROGRESS = _SC$Widget$Events.PLAY_PROGRESS,
	            PAUSE = _SC$Widget$Events.PAUSE,
	            FINISH = _SC$Widget$Events.FINISH,
	            ERROR = _SC$Widget$Events.ERROR;
	
	        if (!isReady) {
	          _this2.player = SC.Widget(_this2.iframe);
	          _this2.player.bind(PLAY, _this2.props.onPlay);
	          _this2.player.bind(PAUSE, _this2.props.onPause);
	          _this2.player.bind(PLAY_PROGRESS, function (e) {
	            _this2.currentTime = e.currentPosition / 1000;
	            _this2.fractionLoaded = e.loadedProgress;
	          });
	          _this2.player.bind(FINISH, function () {
	            return _this2.props.onEnded();
	          });
	          _this2.player.bind(ERROR, function (e) {
	            return _this2.props.onError(e);
	          });
	        }
	        _this2.player.load(url, _extends({}, _this2.props.config.soundcloud.options, {
	          callback: function callback() {
	            _this2.player.getDuration(function (duration) {
	              _this2.duration = duration / 1000;
	              _this2.props.onReady();
	            });
	          }
	        }));
	      });
	    }
	  }, {
	    key: 'play',
	    value: function play() {
	      this.callPlayer('play');
	    }
	  }, {
	    key: 'pause',
	    value: function pause() {
	      this.callPlayer('pause');
	    }
	  }, {
	    key: 'stop',
	    value: function stop() {
	      // Nothing to do
	    }
	  }, {
	    key: 'seekTo',
	    value: function seekTo(seconds) {
	      this.callPlayer('seekTo', seconds * 1000);
	    }
	  }, {
	    key: 'setVolume',
	    value: function setVolume(fraction) {
	      this.callPlayer('setVolume', fraction * 100);
	    }
	  }, {
	    key: 'getDuration',
	    value: function getDuration() {
	      return this.duration;
	    }
	  }, {
	    key: 'getCurrentTime',
	    value: function getCurrentTime() {
	      return this.currentTime;
	    }
	  }, {
	    key: 'getSecondsLoaded',
	    value: function getSecondsLoaded() {
	      return this.fractionLoaded * this.duration;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var style = _extends({
	        width: '100%',
	        height: '100%'
	      }, this.props.style);
	      return _react2['default'].createElement('iframe', {
	        ref: this.ref,
	        src: 'https://w.soundcloud.com/player/?url=' + encodeURIComponent(this.props.url),
	        style: style,
	        frameBorder: 0
	      });
	    }
	  }]);
	
	  return SoundCloud;
	}(_react.Component);
	
	SoundCloud.displayName = 'SoundCloud';
	
	SoundCloud.canPlay = function (url) {
	  return MATCH_URL.test(url);
	};
	
	SoundCloud.loopOnEnded = true;
	exports['default'] = (0, _singlePlayer2['default'])(SoundCloud);

/***/ },
/* 411 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Vimeo = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _utils = __webpack_require__(63);
	
	var _singlePlayer = __webpack_require__(81);
	
	var _singlePlayer2 = _interopRequireDefault(_singlePlayer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var SDK_URL = 'https://player.vimeo.com/api/player.js';
	var SDK_GLOBAL = 'Vimeo';
	var MATCH_URL = /vimeo\.com\/.+/;
	var MATCH_FILE_URL = /vimeo\.com\/external\/.+\.mp4/;
	
	var Vimeo = exports.Vimeo = function (_Component) {
	  _inherits(Vimeo, _Component);
	
	  function Vimeo() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, Vimeo);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Vimeo.__proto__ || Object.getPrototypeOf(Vimeo)).call.apply(_ref, [this].concat(args))), _this), _this.callPlayer = _utils.callPlayer, _this.duration = null, _this.currentTime = null, _this.secondsLoaded = null, _this.mute = function () {
	      _this.setVolume(0);
	    }, _this.unmute = function () {
	      if (_this.props.volume !== null) {
	        _this.setVolume(_this.props.volume);
	      }
	    }, _this.ref = function (container) {
	      _this.container = container;
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(Vimeo, [{
	    key: 'load',
	    value: function load(url) {
	      var _this2 = this;
	
	      this.duration = null;
	      (0, _utils.getSDK)(SDK_URL, SDK_GLOBAL).then(function (Vimeo) {
	        if (!_this2.container) return;
	        _this2.player = new Vimeo.Player(_this2.container, _extends({}, _this2.props.config.vimeo.playerOptions, {
	          url: url,
	          autoplay: _this2.props.playing,
	          muted: _this2.props.muted,
	          loop: _this2.props.loop
	        }));
	        _this2.player.ready().then(function () {
	          var iframe = _this2.container.querySelector('iframe');
	          iframe.style.width = '100%';
	          iframe.style.height = '100%';
	        })['catch'](_this2.props.onError);
	        _this2.player.on('loaded', function () {
	          _this2.props.onReady();
	          _this2.player.getDuration().then(function (duration) {
	            _this2.duration = duration;
	          });
	        });
	        _this2.player.on('play', _this2.props.onPlay);
	        _this2.player.on('pause', _this2.props.onPause);
	        _this2.player.on('seeked', function (e) {
	          return _this2.props.onSeek(e.seconds);
	        });
	        _this2.player.on('ended', _this2.props.onEnded);
	        _this2.player.on('error', _this2.props.onError);
	        _this2.player.on('timeupdate', function (_ref2) {
	          var seconds = _ref2.seconds;
	
	          _this2.currentTime = seconds;
	        });
	        _this2.player.on('progress', function (_ref3) {
	          var seconds = _ref3.seconds;
	
	          _this2.secondsLoaded = seconds;
	        });
	      }, this.props.onError);
	    }
	  }, {
	    key: 'play',
	    value: function play() {
	      this.callPlayer('play');
	    }
	  }, {
	    key: 'pause',
	    value: function pause() {
	      this.callPlayer('pause');
	    }
	  }, {
	    key: 'stop',
	    value: function stop() {
	      this.callPlayer('unload');
	    }
	  }, {
	    key: 'seekTo',
	    value: function seekTo(seconds) {
	      this.callPlayer('setCurrentTime', seconds);
	    }
	  }, {
	    key: 'setVolume',
	    value: function setVolume(fraction) {
	      this.callPlayer('setVolume', fraction);
	    }
	  }, {
	    key: 'getDuration',
	    value: function getDuration() {
	      return this.duration;
	    }
	  }, {
	    key: 'getCurrentTime',
	    value: function getCurrentTime() {
	      return this.currentTime;
	    }
	  }, {
	    key: 'getSecondsLoaded',
	    value: function getSecondsLoaded() {
	      return this.secondsLoaded;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var style = _extends({
	        width: '100%',
	        height: '100%',
	        overflow: 'hidden',
	        backgroundColor: 'black'
	      }, this.props.style);
	      return _react2['default'].createElement('div', {
	        key: this.props.url,
	        ref: this.ref,
	        style: style
	      });
	    }
	  }]);
	
	  return Vimeo;
	}(_react.Component);
	
	Vimeo.displayName = 'Vimeo';
	
	Vimeo.canPlay = function (url) {
	  if (MATCH_FILE_URL.test(url)) {
	    return false;
	  }
	  return MATCH_URL.test(url);
	};
	
	exports['default'] = (0, _singlePlayer2['default'])(Vimeo);

/***/ },
/* 412 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.YouTube = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _utils = __webpack_require__(63);
	
	var _singlePlayer = __webpack_require__(81);
	
	var _singlePlayer2 = _interopRequireDefault(_singlePlayer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var SDK_URL = 'https://www.youtube.com/iframe_api';
	var SDK_GLOBAL = 'YT';
	var SDK_GLOBAL_READY = 'onYouTubeIframeAPIReady';
	var MATCH_URL = /(?:youtu\.be\/|youtube\.com\/(?:embed\/|v\/|watch\?v=|watch\?.+&v=))((\w|-){11})/;
	
	var YouTube = exports.YouTube = function (_Component) {
	  _inherits(YouTube, _Component);
	
	  function YouTube() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, YouTube);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = YouTube.__proto__ || Object.getPrototypeOf(YouTube)).call.apply(_ref, [this].concat(args))), _this), _this.callPlayer = _utils.callPlayer, _this.onStateChange = function (_ref2) {
	      var data = _ref2.data;
	      var _this$props = _this.props,
	          onPlay = _this$props.onPlay,
	          onPause = _this$props.onPause,
	          onBuffer = _this$props.onBuffer,
	          onEnded = _this$props.onEnded,
	          onReady = _this$props.onReady;
	      var _window$SDK_GLOBAL$Pl = window[SDK_GLOBAL].PlayerState,
	          PLAYING = _window$SDK_GLOBAL$Pl.PLAYING,
	          PAUSED = _window$SDK_GLOBAL$Pl.PAUSED,
	          BUFFERING = _window$SDK_GLOBAL$Pl.BUFFERING,
	          ENDED = _window$SDK_GLOBAL$Pl.ENDED,
	          CUED = _window$SDK_GLOBAL$Pl.CUED;
	
	      if (data === PLAYING) onPlay();
	      if (data === PAUSED) onPause();
	      if (data === BUFFERING) onBuffer();
	      if (data === ENDED) onEnded();
	      if (data === CUED) onReady();
	    }, _this.mute = function () {
	      _this.callPlayer('mute');
	    }, _this.unmute = function () {
	      _this.callPlayer('unMute');
	    }, _this.ref = function (container) {
	      _this.container = container;
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(YouTube, [{
	    key: 'load',
	    value: function load(url, isReady) {
	      var _this2 = this;
	
	      var _props = this.props,
	          playing = _props.playing,
	          muted = _props.muted,
	          playsinline = _props.playsinline,
	          controls = _props.controls,
	          config = _props.config,
	          _onError = _props.onError;
	      var playerVars = config.youtube.playerVars;
	
	      var id = url && url.match(MATCH_URL)[1];
	      if (isReady) {
	        this.player.cueVideoById({
	          videoId: id,
	          startSeconds: (0, _utils.parseStartTime)(url) || playerVars.start,
	          endSeconds: (0, _utils.parseEndTime)(url) || playerVars.end
	        });
	        return;
	      }
	      (0, _utils.getSDK)(SDK_URL, SDK_GLOBAL, SDK_GLOBAL_READY, function (YT) {
	        return YT.loaded;
	      }).then(function (YT) {
	        if (!_this2.container) return;
	        _this2.player = new YT.Player(_this2.container, {
	          width: '100%',
	          height: '100%',
	          videoId: id,
	          playerVars: _extends({
	            autoplay: playing ? 1 : 0,
	            mute: muted ? 1 : 0,
	            controls: controls ? 1 : 0,
	            start: (0, _utils.parseStartTime)(url),
	            end: (0, _utils.parseEndTime)(url),
	            origin: window.location.origin,
	            playsinline: playsinline
	          }, playerVars),
	          events: {
	            onReady: _this2.props.onReady,
	            onStateChange: _this2.onStateChange,
	            onError: function onError(event) {
	              return _onError(event.data);
	            }
	          }
	        });
	      }, _onError);
	    }
	  }, {
	    key: 'play',
	    value: function play() {
	      this.callPlayer('playVideo');
	    }
	  }, {
	    key: 'pause',
	    value: function pause() {
	      this.callPlayer('pauseVideo');
	    }
	  }, {
	    key: 'stop',
	    value: function stop() {
	      if (!document.body.contains(this.callPlayer('getIframe'))) return;
	      this.callPlayer('stopVideo');
	    }
	  }, {
	    key: 'seekTo',
	    value: function seekTo(amount) {
	      this.callPlayer('seekTo', amount);
	    }
	  }, {
	    key: 'setVolume',
	    value: function setVolume(fraction) {
	      this.callPlayer('setVolume', fraction * 100);
	    }
	  }, {
	    key: 'setPlaybackRate',
	    value: function setPlaybackRate(rate) {
	      this.callPlayer('setPlaybackRate', rate);
	    }
	  }, {
	    key: 'getDuration',
	    value: function getDuration() {
	      return this.callPlayer('getDuration');
	    }
	  }, {
	    key: 'getCurrentTime',
	    value: function getCurrentTime() {
	      return this.callPlayer('getCurrentTime');
	    }
	  }, {
	    key: 'getSecondsLoaded',
	    value: function getSecondsLoaded() {
	      return this.callPlayer('getVideoLoadedFraction') * this.getDuration();
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var style = _extends({
	        width: '100%',
	        height: '100%'
	      }, this.props.style);
	      return _react2['default'].createElement(
	        'div',
	        { style: style },
	        _react2['default'].createElement('div', { ref: this.ref })
	      );
	    }
	  }]);
	
	  return YouTube;
	}(_react.Component);
	
	YouTube.displayName = 'YouTube';
	
	YouTube.canPlay = function (url) {
	  return MATCH_URL.test(url);
	};
	
	YouTube.loopOnEnded = true;
	exports['default'] = (0, _singlePlayer2['default'])(YouTube);

/***/ },
/* 413 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var Quill = __webpack_require__(380);
	
	var QuillMixin = {
	
		/**
		Creates an editor on the given element. The editor will
		be passed the configuration, have its events bound,
		*/
		createEditor: function($el, config) {
			var editor = new Quill($el, config);
			if (config.tabIndex !== undefined) {
				this.setEditorTabIndex(editor, config.tabIndex);
			}
			this.hookEditor(editor);
			return editor;
		},
	
		hookEditor: function(editor) {
			// Expose the editor on change events via a weaker,
			// unprivileged proxy object that does not allow
			// accidentally modifying editor state.
			var unprivilegedEditor = this.makeUnprivilegedEditor(editor);
	
			this.handleTextChange = function(delta, oldDelta, source) {
				if (this.onEditorChangeText) {
					this.onEditorChangeText(
						editor.root.innerHTML, delta, source,
						unprivilegedEditor
					);
					this.onEditorChangeSelection(
						editor.getSelection(), source,
						unprivilegedEditor
					);
				}
			}.bind(this);
	
			this.handleSelectionChange = function(range, oldRange, source) {
				if (this.onEditorChangeSelection) {
					this.onEditorChangeSelection(
						range, source,
						unprivilegedEditor
					);
				}
			}.bind(this);
	
			editor.on('text-change', this.handleTextChange);
			editor.on('selection-change', this.handleSelectionChange);
		},
	
		unhookEditor: function(editor) {
			editor.off('selection-change');
			editor.off('text-change');
		},
	
		setEditorReadOnly: function(editor, value) {
			value? editor.disable()
			     : editor.enable();
		},
	
		/*
		Replace the contents of the editor, but keep
		the previous selection hanging around so that
		the cursor won't move.
		*/
		setEditorContents: function(editor, value) {
			var sel = editor.getSelection();
	
			if (typeof value === 'string') {
				editor.setContents(editor.clipboard.convert(value));
			} else {
				editor.setContents(value);
			}
	
			if (sel && editor.hasFocus()) this.setEditorSelection(editor, sel);
		},
	
		setEditorSelection: function(editor, range) {
			if (range) {
				// Validate bounds before applying.
				var length = editor.getLength();
				range.index = Math.max(0, Math.min(range.index, length-1));
				range.length = Math.max(0, Math.min(range.length, (length-1) - range.index));
			}
			editor.setSelection(range);
		},
	
		setEditorTabIndex: function(editor, tabIndex) {
			if (editor.editor && editor.editor.scroll && editor.editor.scroll.domNode) {
				editor.editor.scroll.domNode.tabIndex = tabIndex;
			}
		},
	
		/*
		Returns an weaker, unprivileged proxy object that only
		exposes read-only accessors found on the editor instance,
		without any state-modificating methods.
		*/
		makeUnprivilegedEditor: function(editor) {
			var e = editor;
			return {
				getLength:    function(){ return e.getLength.apply(e, arguments); },
				getText:      function(){ return e.getText.apply(e, arguments); },
				getHTML:      function(){ return e.root.innerHTML },
				getContents:  function(){ return e.getContents.apply(e, arguments); },
				getSelection: function(){ return e.getSelection.apply(e, arguments); },
				getBounds:    function(){ return e.getBounds.apply(e, arguments); },
			};
		}
	
	};
	
	module.exports = QuillMixin;


/***/ },
/* 414 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = connectAdvanced;
	
	var _hoistNonReactStatics = __webpack_require__(355);
	
	var _hoistNonReactStatics2 = _interopRequireDefault(_hoistNonReactStatics);
	
	var _invariant = __webpack_require__(46);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _react = __webpack_require__(1);
	
	var _Subscription = __webpack_require__(1044);
	
	var _Subscription2 = _interopRequireDefault(_Subscription);
	
	var _PropTypes = __webpack_require__(416);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var hotReloadingVersion = 0;
	var dummyState = {};
	function noop() {}
	function makeSelectorStateful(sourceSelector, store) {
	  // wrap the selector in an object that tracks its results between runs.
	  var selector = {
	    run: function runComponentSelector(props) {
	      try {
	        var nextProps = sourceSelector(store.getState(), props);
	        if (nextProps !== selector.props || selector.error) {
	          selector.shouldComponentUpdate = true;
	          selector.props = nextProps;
	          selector.error = null;
	        }
	      } catch (error) {
	        selector.shouldComponentUpdate = true;
	        selector.error = error;
	      }
	    }
	  };
	
	  return selector;
	}
	
	function connectAdvanced(
	/*
	  selectorFactory is a func that is responsible for returning the selector function used to
	  compute new props from state, props, and dispatch. For example:
	     export default connectAdvanced((dispatch, options) => (state, props) => ({
	      thing: state.things[props.thingId],
	      saveThing: fields => dispatch(actionCreators.saveThing(props.thingId, fields)),
	    }))(YourComponent)
	   Access to dispatch is provided to the factory so selectorFactories can bind actionCreators
	  outside of their selector as an optimization. Options passed to connectAdvanced are passed to
	  the selectorFactory, along with displayName and WrappedComponent, as the second argument.
	   Note that selectorFactory is responsible for all caching/memoization of inbound and outbound
	  props. Do not use connectAdvanced directly without memoizing results between calls to your
	  selector, otherwise the Connect component will re-render on every state or props change.
	*/
	selectorFactory) {
	  var _contextTypes, _childContextTypes;
	
	  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
	      _ref$getDisplayName = _ref.getDisplayName,
	      getDisplayName = _ref$getDisplayName === undefined ? function (name) {
	    return 'ConnectAdvanced(' + name + ')';
	  } : _ref$getDisplayName,
	      _ref$methodName = _ref.methodName,
	      methodName = _ref$methodName === undefined ? 'connectAdvanced' : _ref$methodName,
	      _ref$renderCountProp = _ref.renderCountProp,
	      renderCountProp = _ref$renderCountProp === undefined ? undefined : _ref$renderCountProp,
	      _ref$shouldHandleStat = _ref.shouldHandleStateChanges,
	      shouldHandleStateChanges = _ref$shouldHandleStat === undefined ? true : _ref$shouldHandleStat,
	      _ref$storeKey = _ref.storeKey,
	      storeKey = _ref$storeKey === undefined ? 'store' : _ref$storeKey,
	      _ref$withRef = _ref.withRef,
	      withRef = _ref$withRef === undefined ? false : _ref$withRef,
	      connectOptions = _objectWithoutProperties(_ref, ['getDisplayName', 'methodName', 'renderCountProp', 'shouldHandleStateChanges', 'storeKey', 'withRef']);
	
	  var subscriptionKey = storeKey + 'Subscription';
	  var version = hotReloadingVersion++;
	
	  var contextTypes = (_contextTypes = {}, _contextTypes[storeKey] = _PropTypes.storeShape, _contextTypes[subscriptionKey] = _PropTypes.subscriptionShape, _contextTypes);
	  var childContextTypes = (_childContextTypes = {}, _childContextTypes[subscriptionKey] = _PropTypes.subscriptionShape, _childContextTypes);
	
	  return function wrapWithConnect(WrappedComponent) {
	    (0, _invariant2.default)(typeof WrappedComponent == 'function', 'You must pass a component to the function returned by ' + (methodName + '. Instead received ' + JSON.stringify(WrappedComponent)));
	
	    var wrappedComponentName = WrappedComponent.displayName || WrappedComponent.name || 'Component';
	
	    var displayName = getDisplayName(wrappedComponentName);
	
	    var selectorFactoryOptions = _extends({}, connectOptions, {
	      getDisplayName: getDisplayName,
	      methodName: methodName,
	      renderCountProp: renderCountProp,
	      shouldHandleStateChanges: shouldHandleStateChanges,
	      storeKey: storeKey,
	      withRef: withRef,
	      displayName: displayName,
	      wrappedComponentName: wrappedComponentName,
	      WrappedComponent: WrappedComponent
	    });
	
	    var Connect = function (_Component) {
	      _inherits(Connect, _Component);
	
	      function Connect(props, context) {
	        _classCallCheck(this, Connect);
	
	        var _this = _possibleConstructorReturn(this, _Component.call(this, props, context));
	
	        _this.version = version;
	        _this.state = {};
	        _this.renderCount = 0;
	        _this.store = props[storeKey] || context[storeKey];
	        _this.propsMode = Boolean(props[storeKey]);
	        _this.setWrappedInstance = _this.setWrappedInstance.bind(_this);
	
	        (0, _invariant2.default)(_this.store, 'Could not find "' + storeKey + '" in either the context or props of ' + ('"' + displayName + '". Either wrap the root component in a <Provider>, ') + ('or explicitly pass "' + storeKey + '" as a prop to "' + displayName + '".'));
	
	        _this.initSelector();
	        _this.initSubscription();
	        return _this;
	      }
	
	      Connect.prototype.getChildContext = function getChildContext() {
	        var _ref2;
	
	        // If this component received store from props, its subscription should be transparent
	        // to any descendants receiving store+subscription from context; it passes along
	        // subscription passed to it. Otherwise, it shadows the parent subscription, which allows
	        // Connect to control ordering of notifications to flow top-down.
	        var subscription = this.propsMode ? null : this.subscription;
	        return _ref2 = {}, _ref2[subscriptionKey] = subscription || this.context[subscriptionKey], _ref2;
	      };
	
	      Connect.prototype.componentDidMount = function componentDidMount() {
	        if (!shouldHandleStateChanges) return;
	
	        // componentWillMount fires during server side rendering, but componentDidMount and
	        // componentWillUnmount do not. Because of this, trySubscribe happens during ...didMount.
	        // Otherwise, unsubscription would never take place during SSR, causing a memory leak.
	        // To handle the case where a child component may have triggered a state change by
	        // dispatching an action in its componentWillMount, we have to re-run the select and maybe
	        // re-render.
	        this.subscription.trySubscribe();
	        this.selector.run(this.props);
	        if (this.selector.shouldComponentUpdate) this.forceUpdate();
	      };
	
	      Connect.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	        this.selector.run(nextProps);
	      };
	
	      Connect.prototype.shouldComponentUpdate = function shouldComponentUpdate() {
	        return this.selector.shouldComponentUpdate;
	      };
	
	      Connect.prototype.componentWillUnmount = function componentWillUnmount() {
	        if (this.subscription) this.subscription.tryUnsubscribe();
	        this.subscription = null;
	        this.notifyNestedSubs = noop;
	        this.store = null;
	        this.selector.run = noop;
	        this.selector.shouldComponentUpdate = false;
	      };
	
	      Connect.prototype.getWrappedInstance = function getWrappedInstance() {
	        (0, _invariant2.default)(withRef, 'To access the wrapped instance, you need to specify ' + ('{ withRef: true } in the options argument of the ' + methodName + '() call.'));
	        return this.wrappedInstance;
	      };
	
	      Connect.prototype.setWrappedInstance = function setWrappedInstance(ref) {
	        this.wrappedInstance = ref;
	      };
	
	      Connect.prototype.initSelector = function initSelector() {
	        var sourceSelector = selectorFactory(this.store.dispatch, selectorFactoryOptions);
	        this.selector = makeSelectorStateful(sourceSelector, this.store);
	        this.selector.run(this.props);
	      };
	
	      Connect.prototype.initSubscription = function initSubscription() {
	        if (!shouldHandleStateChanges) return;
	
	        // parentSub's source should match where store came from: props vs. context. A component
	        // connected to the store via props shouldn't use subscription from context, or vice versa.
	        var parentSub = (this.propsMode ? this.props : this.context)[subscriptionKey];
	        this.subscription = new _Subscription2.default(this.store, parentSub, this.onStateChange.bind(this));
	
	        // `notifyNestedSubs` is duplicated to handle the case where the component is  unmounted in
	        // the middle of the notification loop, where `this.subscription` will then be null. An
	        // extra null check every change can be avoided by copying the method onto `this` and then
	        // replacing it with a no-op on unmount. This can probably be avoided if Subscription's
	        // listeners logic is changed to not call listeners that have been unsubscribed in the
	        // middle of the notification loop.
	        this.notifyNestedSubs = this.subscription.notifyNestedSubs.bind(this.subscription);
	      };
	
	      Connect.prototype.onStateChange = function onStateChange() {
	        this.selector.run(this.props);
	
	        if (!this.selector.shouldComponentUpdate) {
	          this.notifyNestedSubs();
	        } else {
	          this.componentDidUpdate = this.notifyNestedSubsOnComponentDidUpdate;
	          this.setState(dummyState);
	        }
	      };
	
	      Connect.prototype.notifyNestedSubsOnComponentDidUpdate = function notifyNestedSubsOnComponentDidUpdate() {
	        // `componentDidUpdate` is conditionally implemented when `onStateChange` determines it
	        // needs to notify nested subs. Once called, it unimplements itself until further state
	        // changes occur. Doing it this way vs having a permanent `componentDidUpdate` that does
	        // a boolean check every time avoids an extra method call most of the time, resulting
	        // in some perf boost.
	        this.componentDidUpdate = undefined;
	        this.notifyNestedSubs();
	      };
	
	      Connect.prototype.isSubscribed = function isSubscribed() {
	        return Boolean(this.subscription) && this.subscription.isSubscribed();
	      };
	
	      Connect.prototype.addExtraProps = function addExtraProps(props) {
	        if (!withRef && !renderCountProp && !(this.propsMode && this.subscription)) return props;
	        // make a shallow copy so that fields added don't leak to the original selector.
	        // this is especially important for 'ref' since that's a reference back to the component
	        // instance. a singleton memoized selector would then be holding a reference to the
	        // instance, preventing the instance from being garbage collected, and that would be bad
	        var withExtras = _extends({}, props);
	        if (withRef) withExtras.ref = this.setWrappedInstance;
	        if (renderCountProp) withExtras[renderCountProp] = this.renderCount++;
	        if (this.propsMode && this.subscription) withExtras[subscriptionKey] = this.subscription;
	        return withExtras;
	      };
	
	      Connect.prototype.render = function render() {
	        var selector = this.selector;
	        selector.shouldComponentUpdate = false;
	
	        if (selector.error) {
	          throw selector.error;
	        } else {
	          return (0, _react.createElement)(WrappedComponent, this.addExtraProps(selector.props));
	        }
	      };
	
	      return Connect;
	    }(_react.Component);
	
	    Connect.WrappedComponent = WrappedComponent;
	    Connect.displayName = displayName;
	    Connect.childContextTypes = childContextTypes;
	    Connect.contextTypes = contextTypes;
	    Connect.propTypes = contextTypes;
	
	    if (false) {
	      Connect.prototype.componentWillUpdate = function componentWillUpdate() {
	        var _this2 = this;
	
	        // We are hot reloading!
	        if (this.version !== version) {
	          this.version = version;
	          this.initSelector();
	
	          // If any connected descendants don't hot reload (and resubscribe in the process), their
	          // listeners will be lost when we unsubscribe. Unfortunately, by copying over all
	          // listeners, this does mean that the old versions of connected descendants will still be
	          // notified of state changes; however, their onStateChange function is a no-op so this
	          // isn't a huge deal.
	          var oldListeners = [];
	
	          if (this.subscription) {
	            oldListeners = this.subscription.listeners.get();
	            this.subscription.tryUnsubscribe();
	          }
	          this.initSubscription();
	          if (shouldHandleStateChanges) {
	            this.subscription.trySubscribe();
	            oldListeners.forEach(function (listener) {
	              return _this2.subscription.listeners.subscribe(listener);
	            });
	          }
	        }
	      };
	    }
	
	    return (0, _hoistNonReactStatics2.default)(Connect, WrappedComponent);
	  };
	}

/***/ },
/* 415 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.wrapMapToPropsConstant = wrapMapToPropsConstant;
	exports.getDependsOnOwnProps = getDependsOnOwnProps;
	exports.wrapMapToPropsFunc = wrapMapToPropsFunc;
	
	var _verifyPlainObject = __webpack_require__(417);
	
	var _verifyPlainObject2 = _interopRequireDefault(_verifyPlainObject);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function wrapMapToPropsConstant(getConstant) {
	  return function initConstantSelector(dispatch, options) {
	    var constant = getConstant(dispatch, options);
	
	    function constantSelector() {
	      return constant;
	    }
	    constantSelector.dependsOnOwnProps = false;
	    return constantSelector;
	  };
	}
	
	// dependsOnOwnProps is used by createMapToPropsProxy to determine whether to pass props as args
	// to the mapToProps function being wrapped. It is also used by makePurePropsSelector to determine
	// whether mapToProps needs to be invoked when props have changed.
	// 
	// A length of one signals that mapToProps does not depend on props from the parent component.
	// A length of zero is assumed to mean mapToProps is getting args via arguments or ...args and
	// therefore not reporting its length accurately..
	function getDependsOnOwnProps(mapToProps) {
	  return mapToProps.dependsOnOwnProps !== null && mapToProps.dependsOnOwnProps !== undefined ? Boolean(mapToProps.dependsOnOwnProps) : mapToProps.length !== 1;
	}
	
	// Used by whenMapStateToPropsIsFunction and whenMapDispatchToPropsIsFunction,
	// this function wraps mapToProps in a proxy function which does several things:
	// 
	//  * Detects whether the mapToProps function being called depends on props, which
	//    is used by selectorFactory to decide if it should reinvoke on props changes.
	//    
	//  * On first call, handles mapToProps if returns another function, and treats that
	//    new function as the true mapToProps for subsequent calls.
	//    
	//  * On first call, verifies the first result is a plain object, in order to warn
	//    the developer that their mapToProps function is not returning a valid result.
	//    
	function wrapMapToPropsFunc(mapToProps, methodName) {
	  return function initProxySelector(dispatch, _ref) {
	    var displayName = _ref.displayName;
	
	    var proxy = function mapToPropsProxy(stateOrDispatch, ownProps) {
	      return proxy.dependsOnOwnProps ? proxy.mapToProps(stateOrDispatch, ownProps) : proxy.mapToProps(stateOrDispatch);
	    };
	
	    // allow detectFactoryAndVerify to get ownProps
	    proxy.dependsOnOwnProps = true;
	
	    proxy.mapToProps = function detectFactoryAndVerify(stateOrDispatch, ownProps) {
	      proxy.mapToProps = mapToProps;
	      proxy.dependsOnOwnProps = getDependsOnOwnProps(mapToProps);
	      var props = proxy(stateOrDispatch, ownProps);
	
	      if (typeof props === 'function') {
	        proxy.mapToProps = props;
	        proxy.dependsOnOwnProps = getDependsOnOwnProps(props);
	        props = proxy(stateOrDispatch, ownProps);
	      }
	
	      if (false) (0, _verifyPlainObject2.default)(props, displayName, methodName);
	
	      return props;
	    };
	
	    return proxy;
	  };
	}

/***/ },
/* 416 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.storeShape = exports.subscriptionShape = undefined;
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var subscriptionShape = exports.subscriptionShape = _propTypes2.default.shape({
	  trySubscribe: _propTypes2.default.func.isRequired,
	  tryUnsubscribe: _propTypes2.default.func.isRequired,
	  notifyNestedSubs: _propTypes2.default.func.isRequired,
	  isSubscribed: _propTypes2.default.func.isRequired
	});
	
	var storeShape = exports.storeShape = _propTypes2.default.shape({
	  subscribe: _propTypes2.default.func.isRequired,
	  dispatch: _propTypes2.default.func.isRequired,
	  getState: _propTypes2.default.func.isRequired
	});

/***/ },
/* 417 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = verifyPlainObject;
	
	var _isPlainObject = __webpack_require__(246);
	
	var _isPlainObject2 = _interopRequireDefault(_isPlainObject);
	
	var _warning = __webpack_require__(266);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function verifyPlainObject(value, displayName, methodName) {
	  if (!(0, _isPlainObject2.default)(value)) {
	    (0, _warning2.default)(methodName + '() in ' + displayName + ' must return a plain object. Instead received ' + value + '.');
	  }
	}

/***/ },
/* 418 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _createReactClass = __webpack_require__(73);
	
	var _createReactClass2 = _interopRequireDefault(_createReactClass);
	
	var _propTypes = __webpack_require__(2);
	
	var _invariant = __webpack_require__(46);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _PropTypes = __webpack_require__(269);
	
	var _ContextUtils = __webpack_require__(268);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function isLeftClickEvent(event) {
	  return event.button === 0;
	}
	
	function isModifiedEvent(event) {
	  return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
	}
	
	// TODO: De-duplicate against hasAnyProperties in createTransitionManager.
	function isEmptyObject(object) {
	  for (var p in object) {
	    if (Object.prototype.hasOwnProperty.call(object, p)) return false;
	  }return true;
	}
	
	function resolveToLocation(to, router) {
	  return typeof to === 'function' ? to(router.location) : to;
	}
	
	/**
	 * A <Link> is used to create an <a> element that links to a route.
	 * When that route is active, the link gets the value of its
	 * activeClassName prop.
	 *
	 * For example, assuming you have the following route:
	 *
	 *   <Route path="/posts/:postID" component={Post} />
	 *
	 * You could use the following component to link to that route:
	 *
	 *   <Link to={`/posts/${post.id}`} />
	 */
	var Link = (0, _createReactClass2.default)({
	  displayName: 'Link',
	
	  mixins: [(0, _ContextUtils.ContextSubscriber)('router')],
	
	  contextTypes: {
	    router: _PropTypes.routerShape
	  },
	
	  propTypes: {
	    to: (0, _propTypes.oneOfType)([_propTypes.string, _propTypes.object, _propTypes.func]),
	    activeStyle: _propTypes.object,
	    activeClassName: _propTypes.string,
	    onlyActiveOnIndex: _propTypes.bool.isRequired,
	    onClick: _propTypes.func,
	    target: _propTypes.string
	  },
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      onlyActiveOnIndex: false,
	      style: {}
	    };
	  },
	  handleClick: function handleClick(event) {
	    if (this.props.onClick) this.props.onClick(event);
	
	    if (event.defaultPrevented) return;
	
	    var router = this.context.router;
	
	    !router ?  false ? (0, _invariant2.default)(false, '<Link>s rendered outside of a router context cannot navigate.') : (0, _invariant2.default)(false) : void 0;
	
	    if (isModifiedEvent(event) || !isLeftClickEvent(event)) return;
	
	    // If target prop is set (e.g. to "_blank"), let browser handle link.
	    /* istanbul ignore if: untestable with Karma */
	    if (this.props.target) return;
	
	    event.preventDefault();
	
	    router.push(resolveToLocation(this.props.to, router));
	  },
	  render: function render() {
	    var _props = this.props,
	        to = _props.to,
	        activeClassName = _props.activeClassName,
	        activeStyle = _props.activeStyle,
	        onlyActiveOnIndex = _props.onlyActiveOnIndex,
	        props = _objectWithoutProperties(_props, ['to', 'activeClassName', 'activeStyle', 'onlyActiveOnIndex']);
	
	    // Ignore if rendered outside the context of router to simplify unit testing.
	
	
	    var router = this.context.router;
	
	
	    if (router) {
	      // If user does not specify a `to` prop, return an empty anchor tag.
	      if (!to) {
	        return _react2.default.createElement('a', props);
	      }
	
	      var toLocation = resolveToLocation(to, router);
	      props.href = router.createHref(toLocation);
	
	      if (activeClassName || activeStyle != null && !isEmptyObject(activeStyle)) {
	        if (router.isActive(toLocation, onlyActiveOnIndex)) {
	          if (activeClassName) {
	            if (props.className) {
	              props.className += ' ' + activeClassName;
	            } else {
	              props.className = activeClassName;
	            }
	          }
	
	          if (activeStyle) props.style = _extends({}, props.style, activeStyle);
	        }
	      }
	    }
	
	    return _react2.default.createElement('a', _extends({}, props, { onClick: this.handleClick }));
	  }
	});
	
	exports.default = Link;
	module.exports = exports['default'];

/***/ },
/* 419 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports.isPromise = isPromise;
	function isPromise(obj) {
	  return obj && typeof obj.then === 'function';
	}

/***/ },
/* 420 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _createReactClass = __webpack_require__(73);
	
	var _createReactClass2 = _interopRequireDefault(_createReactClass);
	
	var _propTypes = __webpack_require__(2);
	
	var _invariant = __webpack_require__(46);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _RouteUtils = __webpack_require__(100);
	
	var _PatternUtils = __webpack_require__(129);
	
	var _InternalPropTypes = __webpack_require__(148);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * A <Redirect> is used to declare another URL path a client should
	 * be sent to when they request a given URL.
	 *
	 * Redirects are placed alongside routes in the route configuration
	 * and are traversed in the same manner.
	 */
	/* eslint-disable react/require-render-return */
	var Redirect = (0, _createReactClass2.default)({
	  displayName: 'Redirect',
	
	  statics: {
	    createRouteFromReactElement: function createRouteFromReactElement(element) {
	      var route = (0, _RouteUtils.createRouteFromReactElement)(element);
	
	      if (route.from) route.path = route.from;
	
	      route.onEnter = function (nextState, replace) {
	        var location = nextState.location,
	            params = nextState.params;
	
	
	        var pathname = void 0;
	        if (route.to.charAt(0) === '/') {
	          pathname = (0, _PatternUtils.formatPattern)(route.to, params);
	        } else if (!route.to) {
	          pathname = location.pathname;
	        } else {
	          var routeIndex = nextState.routes.indexOf(route);
	          var parentPattern = Redirect.getRoutePattern(nextState.routes, routeIndex - 1);
	          var pattern = parentPattern.replace(/\/*$/, '/') + route.to;
	          pathname = (0, _PatternUtils.formatPattern)(pattern, params);
	        }
	
	        replace({
	          pathname: pathname,
	          query: route.query || location.query,
	          state: route.state || location.state
	        });
	      };
	
	      return route;
	    },
	    getRoutePattern: function getRoutePattern(routes, routeIndex) {
	      var parentPattern = '';
	
	      for (var i = routeIndex; i >= 0; i--) {
	        var route = routes[i];
	        var pattern = route.path || '';
	
	        parentPattern = pattern.replace(/\/*$/, '/') + parentPattern;
	
	        if (pattern.indexOf('/') === 0) break;
	      }
	
	      return '/' + parentPattern;
	    }
	  },
	
	  propTypes: {
	    path: _propTypes.string,
	    from: _propTypes.string, // Alias for path
	    to: _propTypes.string.isRequired,
	    query: _propTypes.object,
	    state: _propTypes.object,
	    onEnter: _InternalPropTypes.falsy,
	    children: _InternalPropTypes.falsy
	  },
	
	  /* istanbul ignore next: sanity check */
	  render: function render() {
	     true ?  false ? (0, _invariant2.default)(false, '<Redirect> elements are for router configuration only and should not be rendered') : (0, _invariant2.default)(false) : void 0;
	  }
	});
	
	exports.default = Redirect;
	module.exports = exports['default'];

/***/ },
/* 421 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.createRouterObject = createRouterObject;
	exports.assignRouterState = assignRouterState;
	function createRouterObject(history, transitionManager, state) {
	  var router = _extends({}, history, {
	    setRouteLeaveHook: transitionManager.listenBeforeLeavingRoute,
	    isActive: transitionManager.isActive
	  });
	
	  return assignRouterState(router, state);
	}
	
	function assignRouterState(router, _ref) {
	  var location = _ref.location,
	      params = _ref.params,
	      routes = _ref.routes;
	
	  router.location = location;
	  router.params = params;
	  router.routes = routes;
	
	  return router;
	}

/***/ },
/* 422 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = createMemoryHistory;
	
	var _useQueries = __webpack_require__(354);
	
	var _useQueries2 = _interopRequireDefault(_useQueries);
	
	var _useBasename = __webpack_require__(353);
	
	var _useBasename2 = _interopRequireDefault(_useBasename);
	
	var _createMemoryHistory = __webpack_require__(842);
	
	var _createMemoryHistory2 = _interopRequireDefault(_createMemoryHistory);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function createMemoryHistory(options) {
	  // signatures and type checking differ between `useQueries` and
	  // `createMemoryHistory`, have to create `memoryHistory` first because
	  // `useQueries` doesn't understand the signature
	  var memoryHistory = (0, _createMemoryHistory2.default)(options);
	  var createHistory = function createHistory() {
	    return memoryHistory;
	  };
	  var history = (0, _useQueries2.default)((0, _useBasename2.default)(createHistory))(options);
	  return history;
	}
	module.exports = exports['default'];

/***/ },
/* 423 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = createRouterHistory;
	
	var _useRouterHistory = __webpack_require__(425);
	
	var _useRouterHistory2 = _interopRequireDefault(_useRouterHistory);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
	
	function createRouterHistory(createHistory) {
	  var history = void 0;
	  if (canUseDOM) history = (0, _useRouterHistory2.default)(createHistory)();
	  return history;
	}
	module.exports = exports['default'];

/***/ },
/* 424 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = createTransitionManager;
	
	var _routerWarning = __webpack_require__(130);
	
	var _routerWarning2 = _interopRequireDefault(_routerWarning);
	
	var _computeChangedRoutes2 = __webpack_require__(1054);
	
	var _computeChangedRoutes3 = _interopRequireDefault(_computeChangedRoutes2);
	
	var _TransitionUtils = __webpack_require__(1051);
	
	var _TransitionUtils2 = _interopRequireDefault(_TransitionUtils);
	
	var _isActive2 = __webpack_require__(1058);
	
	var _isActive3 = _interopRequireDefault(_isActive2);
	
	var _getComponents = __webpack_require__(1055);
	
	var _getComponents2 = _interopRequireDefault(_getComponents);
	
	var _matchRoutes = __webpack_require__(1060);
	
	var _matchRoutes2 = _interopRequireDefault(_matchRoutes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function hasAnyProperties(object) {
	  for (var p in object) {
	    if (Object.prototype.hasOwnProperty.call(object, p)) return true;
	  }return false;
	}
	
	function createTransitionManager(history, routes) {
	  var state = {};
	
	  var _getTransitionUtils = (0, _TransitionUtils2.default)(),
	      runEnterHooks = _getTransitionUtils.runEnterHooks,
	      runChangeHooks = _getTransitionUtils.runChangeHooks,
	      runLeaveHooks = _getTransitionUtils.runLeaveHooks;
	
	  // Signature should be (location, indexOnly), but needs to support (path,
	  // query, indexOnly)
	
	
	  function isActive(location, indexOnly) {
	    location = history.createLocation(location);
	
	    return (0, _isActive3.default)(location, indexOnly, state.location, state.routes, state.params);
	  }
	
	  var partialNextState = void 0;
	
	  function match(location, callback) {
	    if (partialNextState && partialNextState.location === location) {
	      // Continue from where we left off.
	      finishMatch(partialNextState, callback);
	    } else {
	      (0, _matchRoutes2.default)(routes, location, function (error, nextState) {
	        if (error) {
	          callback(error);
	        } else if (nextState) {
	          finishMatch(_extends({}, nextState, { location: location }), callback);
	        } else {
	          callback();
	        }
	      });
	    }
	  }
	
	  function finishMatch(nextState, callback) {
	    var _computeChangedRoutes = (0, _computeChangedRoutes3.default)(state, nextState),
	        leaveRoutes = _computeChangedRoutes.leaveRoutes,
	        changeRoutes = _computeChangedRoutes.changeRoutes,
	        enterRoutes = _computeChangedRoutes.enterRoutes;
	
	    runLeaveHooks(leaveRoutes, state);
	
	    // Tear down confirmation hooks for left routes
	    leaveRoutes.filter(function (route) {
	      return enterRoutes.indexOf(route) === -1;
	    }).forEach(removeListenBeforeHooksForRoute);
	
	    // change and enter hooks are run in series
	    runChangeHooks(changeRoutes, state, nextState, function (error, redirectInfo) {
	      if (error || redirectInfo) return handleErrorOrRedirect(error, redirectInfo);
	
	      runEnterHooks(enterRoutes, nextState, finishEnterHooks);
	    });
	
	    function finishEnterHooks(error, redirectInfo) {
	      if (error || redirectInfo) return handleErrorOrRedirect(error, redirectInfo);
	
	      // TODO: Fetch components after state is updated.
	      (0, _getComponents2.default)(nextState, function (error, components) {
	        if (error) {
	          callback(error);
	        } else {
	          // TODO: Make match a pure function and have some other API
	          // for "match and update state".
	          callback(null, null, state = _extends({}, nextState, { components: components }));
	        }
	      });
	    }
	
	    function handleErrorOrRedirect(error, redirectInfo) {
	      if (error) callback(error);else callback(null, redirectInfo);
	    }
	  }
	
	  var RouteGuid = 1;
	
	  function getRouteID(route) {
	    var create = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	
	    return route.__id__ || create && (route.__id__ = RouteGuid++);
	  }
	
	  var RouteHooks = Object.create(null);
	
	  function getRouteHooksForRoutes(routes) {
	    return routes.map(function (route) {
	      return RouteHooks[getRouteID(route)];
	    }).filter(function (hook) {
	      return hook;
	    });
	  }
	
	  function transitionHook(location, callback) {
	    (0, _matchRoutes2.default)(routes, location, function (error, nextState) {
	      if (nextState == null) {
	        // TODO: We didn't actually match anything, but hang
	        // onto error/nextState so we don't have to matchRoutes
	        // again in the listen callback.
	        callback();
	        return;
	      }
	
	      // Cache some state here so we don't have to
	      // matchRoutes() again in the listen callback.
	      partialNextState = _extends({}, nextState, { location: location });
	
	      var hooks = getRouteHooksForRoutes((0, _computeChangedRoutes3.default)(state, partialNextState).leaveRoutes);
	
	      var result = void 0;
	      for (var i = 0, len = hooks.length; result == null && i < len; ++i) {
	        // Passing the location arg here indicates to
	        // the user that this is a transition hook.
	        result = hooks[i](location);
	      }
	
	      callback(result);
	    });
	  }
	
	  /* istanbul ignore next: untestable with Karma */
	  function beforeUnloadHook() {
	    // Synchronously check to see if any route hooks want
	    // to prevent the current window/tab from closing.
	    if (state.routes) {
	      var hooks = getRouteHooksForRoutes(state.routes);
	
	      var message = void 0;
	      for (var i = 0, len = hooks.length; typeof message !== 'string' && i < len; ++i) {
	        // Passing no args indicates to the user that this is a
	        // beforeunload hook. We don't know the next location.
	        message = hooks[i]();
	      }
	
	      return message;
	    }
	  }
	
	  var unlistenBefore = void 0,
	      unlistenBeforeUnload = void 0;
	
	  function removeListenBeforeHooksForRoute(route) {
	    var routeID = getRouteID(route);
	    if (!routeID) {
	      return;
	    }
	
	    delete RouteHooks[routeID];
	
	    if (!hasAnyProperties(RouteHooks)) {
	      // teardown transition & beforeunload hooks
	      if (unlistenBefore) {
	        unlistenBefore();
	        unlistenBefore = null;
	      }
	
	      if (unlistenBeforeUnload) {
	        unlistenBeforeUnload();
	        unlistenBeforeUnload = null;
	      }
	    }
	  }
	
	  /**
	   * Registers the given hook function to run before leaving the given route.
	   *
	   * During a normal transition, the hook function receives the next location
	   * as its only argument and can return either a prompt message (string) to show the user,
	   * to make sure they want to leave the page; or `false`, to prevent the transition.
	   * Any other return value will have no effect.
	   *
	   * During the beforeunload event (in browsers) the hook receives no arguments.
	   * In this case it must return a prompt message to prevent the transition.
	   *
	   * Returns a function that may be used to unbind the listener.
	   */
	  function listenBeforeLeavingRoute(route, hook) {
	    var thereWereNoRouteHooks = !hasAnyProperties(RouteHooks);
	    var routeID = getRouteID(route, true);
	
	    RouteHooks[routeID] = hook;
	
	    if (thereWereNoRouteHooks) {
	      // setup transition & beforeunload hooks
	      unlistenBefore = history.listenBefore(transitionHook);
	
	      if (history.listenBeforeUnload) unlistenBeforeUnload = history.listenBeforeUnload(beforeUnloadHook);
	    }
	
	    return function () {
	      removeListenBeforeHooksForRoute(route);
	    };
	  }
	
	  /**
	   * This is the API for stateful environments. As the location
	   * changes, we update state and call the listener. We can also
	   * gracefully handle errors and redirects.
	   */
	  function listen(listener) {
	    function historyListener(location) {
	      if (state.location === location) {
	        listener(null, state);
	      } else {
	        match(location, function (error, redirectLocation, nextState) {
	          if (error) {
	            listener(error);
	          } else if (redirectLocation) {
	            history.replace(redirectLocation);
	          } else if (nextState) {
	            listener(null, nextState);
	          } else {
	             false ? (0, _routerWarning2.default)(false, 'Location "%s" did not match any routes', location.pathname + location.search + location.hash) : void 0;
	          }
	        });
	      }
	    }
	
	    // TODO: Only use a single history listener. Otherwise we'll end up with
	    // multiple concurrent calls to match.
	
	    // Set up the history listener first in case the initial match redirects.
	    var unsubscribe = history.listen(historyListener);
	
	    if (state.location) {
	      // Picking up on a matchContext.
	      listener(null, state);
	    } else {
	      historyListener(history.getCurrentLocation());
	    }
	
	    return unsubscribe;
	  }
	
	  return {
	    isActive: isActive,
	    match: match,
	    listenBeforeLeavingRoute: listenBeforeLeavingRoute,
	    listen: listen
	  };
	}
	module.exports = exports['default'];

/***/ },
/* 425 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = useRouterHistory;
	
	var _useQueries = __webpack_require__(354);
	
	var _useQueries2 = _interopRequireDefault(_useQueries);
	
	var _useBasename = __webpack_require__(353);
	
	var _useBasename2 = _interopRequireDefault(_useBasename);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function useRouterHistory(createHistory) {
	  return function (options) {
	    var history = (0, _useQueries2.default)((0, _useBasename2.default)(createHistory))(options);
	    return history;
	  };
	}
	module.exports = exports['default'];

/***/ },
/* 426 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(149),
	    _assign = __webpack_require__(36);
	
	var ReactNoopUpdateQueue = __webpack_require__(429);
	
	var canDefineProperty = __webpack_require__(430);
	var emptyObject = __webpack_require__(141);
	var invariant = __webpack_require__(21);
	var lowPriorityWarning = __webpack_require__(1071);
	
	/**
	 * Base class helpers for the updating state of a component.
	 */
	function ReactComponent(props, context, updater) {
	  this.props = props;
	  this.context = context;
	  this.refs = emptyObject;
	  // We initialize the default updater but the real one gets injected by the
	  // renderer.
	  this.updater = updater || ReactNoopUpdateQueue;
	}
	
	ReactComponent.prototype.isReactComponent = {};
	
	/**
	 * Sets a subset of the state. Always use this to mutate
	 * state. You should treat `this.state` as immutable.
	 *
	 * There is no guarantee that `this.state` will be immediately updated, so
	 * accessing `this.state` after calling this method may return the old value.
	 *
	 * There is no guarantee that calls to `setState` will run synchronously,
	 * as they may eventually be batched together.  You can provide an optional
	 * callback that will be executed when the call to setState is actually
	 * completed.
	 *
	 * When a function is provided to setState, it will be called at some point in
	 * the future (not synchronously). It will be called with the up to date
	 * component arguments (state, props, context). These values can be different
	 * from this.* because your function may be called after receiveProps but before
	 * shouldComponentUpdate, and this new state, props, and context will not yet be
	 * assigned to this.
	 *
	 * @param {object|function} partialState Next partial state or function to
	 *        produce next partial state to be merged with current state.
	 * @param {?function} callback Called after state is updated.
	 * @final
	 * @protected
	 */
	ReactComponent.prototype.setState = function (partialState, callback) {
	  !(typeof partialState === 'object' || typeof partialState === 'function' || partialState == null) ?  false ? invariant(false, 'setState(...): takes an object of state variables to update or a function which returns an object of state variables.') : _prodInvariant('85') : void 0;
	  this.updater.enqueueSetState(this, partialState);
	  if (callback) {
	    this.updater.enqueueCallback(this, callback, 'setState');
	  }
	};
	
	/**
	 * Forces an update. This should only be invoked when it is known with
	 * certainty that we are **not** in a DOM transaction.
	 *
	 * You may want to call this when you know that some deeper aspect of the
	 * component's state has changed but `setState` was not called.
	 *
	 * This will not invoke `shouldComponentUpdate`, but it will invoke
	 * `componentWillUpdate` and `componentDidUpdate`.
	 *
	 * @param {?function} callback Called after update is complete.
	 * @final
	 * @protected
	 */
	ReactComponent.prototype.forceUpdate = function (callback) {
	  this.updater.enqueueForceUpdate(this);
	  if (callback) {
	    this.updater.enqueueCallback(this, callback, 'forceUpdate');
	  }
	};
	
	/**
	 * Deprecated APIs. These APIs used to exist on classic React classes but since
	 * we would like to deprecate them, we're not going to move them over to this
	 * modern base class. Instead, we define a getter that warns if it's accessed.
	 */
	if (false) {
	  var deprecatedAPIs = {
	    isMounted: ['isMounted', 'Instead, make sure to clean up subscriptions and pending requests in ' + 'componentWillUnmount to prevent memory leaks.'],
	    replaceState: ['replaceState', 'Refactor your code to use setState instead (see ' + 'https://github.com/facebook/react/issues/3236).']
	  };
	  var defineDeprecationWarning = function (methodName, info) {
	    if (canDefineProperty) {
	      Object.defineProperty(ReactComponent.prototype, methodName, {
	        get: function () {
	          lowPriorityWarning(false, '%s(...) is deprecated in plain JavaScript React classes. %s', info[0], info[1]);
	          return undefined;
	        }
	      });
	    }
	  };
	  for (var fnName in deprecatedAPIs) {
	    if (deprecatedAPIs.hasOwnProperty(fnName)) {
	      defineDeprecationWarning(fnName, deprecatedAPIs[fnName]);
	    }
	  }
	}
	
	/**
	 * Base class helpers for the updating state of a component.
	 */
	function ReactPureComponent(props, context, updater) {
	  // Duplicated from ReactComponent.
	  this.props = props;
	  this.context = context;
	  this.refs = emptyObject;
	  // We initialize the default updater but the real one gets injected by the
	  // renderer.
	  this.updater = updater || ReactNoopUpdateQueue;
	}
	
	function ComponentDummy() {}
	ComponentDummy.prototype = ReactComponent.prototype;
	ReactPureComponent.prototype = new ComponentDummy();
	ReactPureComponent.prototype.constructor = ReactPureComponent;
	// Avoid an extra prototype jump for these methods.
	_assign(ReactPureComponent.prototype, ReactComponent.prototype);
	ReactPureComponent.prototype.isPureReactComponent = true;
	
	module.exports = {
	  Component: ReactComponent,
	  PureComponent: ReactPureComponent
	};

/***/ },
/* 427 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2016-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(149);
	
	var ReactCurrentOwner = __webpack_require__(92);
	
	var invariant = __webpack_require__(21);
	var warning = __webpack_require__(30);
	
	function isNative(fn) {
	  // Based on isNative() from Lodash
	  var funcToString = Function.prototype.toString;
	  var hasOwnProperty = Object.prototype.hasOwnProperty;
	  var reIsNative = RegExp('^' + funcToString
	  // Take an example native function source for comparison
	  .call(hasOwnProperty
	  // Strip regex characters so we can use it for regex
	  ).replace(/[\\^$.*+?()[\]{}|]/g, '\\$&'
	  // Remove hasOwnProperty from the template to make it generic
	  ).replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$');
	  try {
	    var source = funcToString.call(fn);
	    return reIsNative.test(source);
	  } catch (err) {
	    return false;
	  }
	}
	
	var canUseCollections =
	// Array.from
	typeof Array.from === 'function' &&
	// Map
	typeof Map === 'function' && isNative(Map) &&
	// Map.prototype.keys
	Map.prototype != null && typeof Map.prototype.keys === 'function' && isNative(Map.prototype.keys) &&
	// Set
	typeof Set === 'function' && isNative(Set) &&
	// Set.prototype.keys
	Set.prototype != null && typeof Set.prototype.keys === 'function' && isNative(Set.prototype.keys);
	
	var setItem;
	var getItem;
	var removeItem;
	var getItemIDs;
	var addRoot;
	var removeRoot;
	var getRootIDs;
	
	if (canUseCollections) {
	  var itemMap = new Map();
	  var rootIDSet = new Set();
	
	  setItem = function (id, item) {
	    itemMap.set(id, item);
	  };
	  getItem = function (id) {
	    return itemMap.get(id);
	  };
	  removeItem = function (id) {
	    itemMap['delete'](id);
	  };
	  getItemIDs = function () {
	    return Array.from(itemMap.keys());
	  };
	
	  addRoot = function (id) {
	    rootIDSet.add(id);
	  };
	  removeRoot = function (id) {
	    rootIDSet['delete'](id);
	  };
	  getRootIDs = function () {
	    return Array.from(rootIDSet.keys());
	  };
	} else {
	  var itemByKey = {};
	  var rootByKey = {};
	
	  // Use non-numeric keys to prevent V8 performance issues:
	  // https://github.com/facebook/react/pull/7232
	  var getKeyFromID = function (id) {
	    return '.' + id;
	  };
	  var getIDFromKey = function (key) {
	    return parseInt(key.substr(1), 10);
	  };
	
	  setItem = function (id, item) {
	    var key = getKeyFromID(id);
	    itemByKey[key] = item;
	  };
	  getItem = function (id) {
	    var key = getKeyFromID(id);
	    return itemByKey[key];
	  };
	  removeItem = function (id) {
	    var key = getKeyFromID(id);
	    delete itemByKey[key];
	  };
	  getItemIDs = function () {
	    return Object.keys(itemByKey).map(getIDFromKey);
	  };
	
	  addRoot = function (id) {
	    var key = getKeyFromID(id);
	    rootByKey[key] = true;
	  };
	  removeRoot = function (id) {
	    var key = getKeyFromID(id);
	    delete rootByKey[key];
	  };
	  getRootIDs = function () {
	    return Object.keys(rootByKey).map(getIDFromKey);
	  };
	}
	
	var unmountedIDs = [];
	
	function purgeDeep(id) {
	  var item = getItem(id);
	  if (item) {
	    var childIDs = item.childIDs;
	
	    removeItem(id);
	    childIDs.forEach(purgeDeep);
	  }
	}
	
	function describeComponentFrame(name, source, ownerName) {
	  return '\n    in ' + (name || 'Unknown') + (source ? ' (at ' + source.fileName.replace(/^.*[\\\/]/, '') + ':' + source.lineNumber + ')' : ownerName ? ' (created by ' + ownerName + ')' : '');
	}
	
	function getDisplayName(element) {
	  if (element == null) {
	    return '#empty';
	  } else if (typeof element === 'string' || typeof element === 'number') {
	    return '#text';
	  } else if (typeof element.type === 'string') {
	    return element.type;
	  } else {
	    return element.type.displayName || element.type.name || 'Unknown';
	  }
	}
	
	function describeID(id) {
	  var name = ReactComponentTreeHook.getDisplayName(id);
	  var element = ReactComponentTreeHook.getElement(id);
	  var ownerID = ReactComponentTreeHook.getOwnerID(id);
	  var ownerName;
	  if (ownerID) {
	    ownerName = ReactComponentTreeHook.getDisplayName(ownerID);
	  }
	   false ? warning(element, 'ReactComponentTreeHook: Missing React element for debugID %s when ' + 'building stack', id) : void 0;
	  return describeComponentFrame(name, element && element._source, ownerName);
	}
	
	var ReactComponentTreeHook = {
	  onSetChildren: function (id, nextChildIDs) {
	    var item = getItem(id);
	    !item ?  false ? invariant(false, 'Item must have been set') : _prodInvariant('144') : void 0;
	    item.childIDs = nextChildIDs;
	
	    for (var i = 0; i < nextChildIDs.length; i++) {
	      var nextChildID = nextChildIDs[i];
	      var nextChild = getItem(nextChildID);
	      !nextChild ?  false ? invariant(false, 'Expected hook events to fire for the child before its parent includes it in onSetChildren().') : _prodInvariant('140') : void 0;
	      !(nextChild.childIDs != null || typeof nextChild.element !== 'object' || nextChild.element == null) ?  false ? invariant(false, 'Expected onSetChildren() to fire for a container child before its parent includes it in onSetChildren().') : _prodInvariant('141') : void 0;
	      !nextChild.isMounted ?  false ? invariant(false, 'Expected onMountComponent() to fire for the child before its parent includes it in onSetChildren().') : _prodInvariant('71') : void 0;
	      if (nextChild.parentID == null) {
	        nextChild.parentID = id;
	        // TODO: This shouldn't be necessary but mounting a new root during in
	        // componentWillMount currently causes not-yet-mounted components to
	        // be purged from our tree data so their parent id is missing.
	      }
	      !(nextChild.parentID === id) ?  false ? invariant(false, 'Expected onBeforeMountComponent() parent and onSetChildren() to be consistent (%s has parents %s and %s).', nextChildID, nextChild.parentID, id) : _prodInvariant('142', nextChildID, nextChild.parentID, id) : void 0;
	    }
	  },
	  onBeforeMountComponent: function (id, element, parentID) {
	    var item = {
	      element: element,
	      parentID: parentID,
	      text: null,
	      childIDs: [],
	      isMounted: false,
	      updateCount: 0
	    };
	    setItem(id, item);
	  },
	  onBeforeUpdateComponent: function (id, element) {
	    var item = getItem(id);
	    if (!item || !item.isMounted) {
	      // We may end up here as a result of setState() in componentWillUnmount().
	      // In this case, ignore the element.
	      return;
	    }
	    item.element = element;
	  },
	  onMountComponent: function (id) {
	    var item = getItem(id);
	    !item ?  false ? invariant(false, 'Item must have been set') : _prodInvariant('144') : void 0;
	    item.isMounted = true;
	    var isRoot = item.parentID === 0;
	    if (isRoot) {
	      addRoot(id);
	    }
	  },
	  onUpdateComponent: function (id) {
	    var item = getItem(id);
	    if (!item || !item.isMounted) {
	      // We may end up here as a result of setState() in componentWillUnmount().
	      // In this case, ignore the element.
	      return;
	    }
	    item.updateCount++;
	  },
	  onUnmountComponent: function (id) {
	    var item = getItem(id);
	    if (item) {
	      // We need to check if it exists.
	      // `item` might not exist if it is inside an error boundary, and a sibling
	      // error boundary child threw while mounting. Then this instance never
	      // got a chance to mount, but it still gets an unmounting event during
	      // the error boundary cleanup.
	      item.isMounted = false;
	      var isRoot = item.parentID === 0;
	      if (isRoot) {
	        removeRoot(id);
	      }
	    }
	    unmountedIDs.push(id);
	  },
	  purgeUnmountedComponents: function () {
	    if (ReactComponentTreeHook._preventPurging) {
	      // Should only be used for testing.
	      return;
	    }
	
	    for (var i = 0; i < unmountedIDs.length; i++) {
	      var id = unmountedIDs[i];
	      purgeDeep(id);
	    }
	    unmountedIDs.length = 0;
	  },
	  isMounted: function (id) {
	    var item = getItem(id);
	    return item ? item.isMounted : false;
	  },
	  getCurrentStackAddendum: function (topElement) {
	    var info = '';
	    if (topElement) {
	      var name = getDisplayName(topElement);
	      var owner = topElement._owner;
	      info += describeComponentFrame(name, topElement._source, owner && owner.getName());
	    }
	
	    var currentOwner = ReactCurrentOwner.current;
	    var id = currentOwner && currentOwner._debugID;
	
	    info += ReactComponentTreeHook.getStackAddendumByID(id);
	    return info;
	  },
	  getStackAddendumByID: function (id) {
	    var info = '';
	    while (id) {
	      info += describeID(id);
	      id = ReactComponentTreeHook.getParentID(id);
	    }
	    return info;
	  },
	  getChildIDs: function (id) {
	    var item = getItem(id);
	    return item ? item.childIDs : [];
	  },
	  getDisplayName: function (id) {
	    var element = ReactComponentTreeHook.getElement(id);
	    if (!element) {
	      return null;
	    }
	    return getDisplayName(element);
	  },
	  getElement: function (id) {
	    var item = getItem(id);
	    return item ? item.element : null;
	  },
	  getOwnerID: function (id) {
	    var element = ReactComponentTreeHook.getElement(id);
	    if (!element || !element._owner) {
	      return null;
	    }
	    return element._owner._debugID;
	  },
	  getParentID: function (id) {
	    var item = getItem(id);
	    return item ? item.parentID : null;
	  },
	  getSource: function (id) {
	    var item = getItem(id);
	    var element = item ? item.element : null;
	    var source = element != null ? element._source : null;
	    return source;
	  },
	  getText: function (id) {
	    var element = ReactComponentTreeHook.getElement(id);
	    if (typeof element === 'string') {
	      return element;
	    } else if (typeof element === 'number') {
	      return '' + element;
	    } else {
	      return null;
	    }
	  },
	  getUpdateCount: function (id) {
	    var item = getItem(id);
	    return item ? item.updateCount : 0;
	  },
	
	
	  getRootIDs: getRootIDs,
	  getRegisteredIDs: getItemIDs,
	
	  pushNonStandardWarningStack: function (isCreatingElement, currentSource) {
	    if (typeof console.reactStack !== 'function') {
	      return;
	    }
	
	    var stack = [];
	    var currentOwner = ReactCurrentOwner.current;
	    var id = currentOwner && currentOwner._debugID;
	
	    try {
	      if (isCreatingElement) {
	        stack.push({
	          name: id ? ReactComponentTreeHook.getDisplayName(id) : null,
	          fileName: currentSource ? currentSource.fileName : null,
	          lineNumber: currentSource ? currentSource.lineNumber : null
	        });
	      }
	
	      while (id) {
	        var element = ReactComponentTreeHook.getElement(id);
	        var parentID = ReactComponentTreeHook.getParentID(id);
	        var ownerID = ReactComponentTreeHook.getOwnerID(id);
	        var ownerName = ownerID ? ReactComponentTreeHook.getDisplayName(ownerID) : null;
	        var source = element && element._source;
	        stack.push({
	          name: ownerName,
	          fileName: source ? source.fileName : null,
	          lineNumber: source ? source.lineNumber : null
	        });
	        id = parentID;
	      }
	    } catch (err) {
	      // Internal state is messed up.
	      // Stop building the stack (it's just a nice to have).
	    }
	
	    console.reactStack(stack);
	  },
	  popNonStandardWarningStack: function () {
	    if (typeof console.reactStackEnd !== 'function') {
	      return;
	    }
	    console.reactStackEnd();
	  }
	};
	
	module.exports = ReactComponentTreeHook;

/***/ },
/* 428 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2014-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	// The Symbol used to tag the ReactElement type. If there is no native Symbol
	// nor polyfill, then a plain number is used for performance.
	
	var REACT_ELEMENT_TYPE = typeof Symbol === 'function' && Symbol['for'] && Symbol['for']('react.element') || 0xeac7;
	
	module.exports = REACT_ELEMENT_TYPE;

/***/ },
/* 429 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2015-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var warning = __webpack_require__(30);
	
	function warnNoop(publicInstance, callerName) {
	  if (false) {
	    var constructor = publicInstance.constructor;
	    process.env.NODE_ENV !== 'production' ? warning(false, '%s(...): Can only update a mounted or mounting component. ' + 'This usually means you called %s() on an unmounted component. ' + 'This is a no-op. Please check the code for the %s component.', callerName, callerName, constructor && (constructor.displayName || constructor.name) || 'ReactClass') : void 0;
	  }
	}
	
	/**
	 * This is the abstract API for an update queue.
	 */
	var ReactNoopUpdateQueue = {
	  /**
	   * Checks whether or not this composite component is mounted.
	   * @param {ReactClass} publicInstance The instance we want to test.
	   * @return {boolean} True if mounted, false otherwise.
	   * @protected
	   * @final
	   */
	  isMounted: function (publicInstance) {
	    return false;
	  },
	
	  /**
	   * Enqueue a callback that will be executed after all the pending updates
	   * have processed.
	   *
	   * @param {ReactClass} publicInstance The instance to use as `this` context.
	   * @param {?function} callback Called after state is updated.
	   * @internal
	   */
	  enqueueCallback: function (publicInstance, callback) {},
	
	  /**
	   * Forces an update. This should only be invoked when it is known with
	   * certainty that we are **not** in a DOM transaction.
	   *
	   * You may want to call this when you know that some deeper aspect of the
	   * component's state has changed but `setState` was not called.
	   *
	   * This will not invoke `shouldComponentUpdate`, but it will invoke
	   * `componentWillUpdate` and `componentDidUpdate`.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @internal
	   */
	  enqueueForceUpdate: function (publicInstance) {
	    warnNoop(publicInstance, 'forceUpdate');
	  },
	
	  /**
	   * Replaces all of the state. Always use this or `setState` to mutate state.
	   * You should treat `this.state` as immutable.
	   *
	   * There is no guarantee that `this.state` will be immediately updated, so
	   * accessing `this.state` after calling this method may return the old value.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @param {object} completeState Next state.
	   * @internal
	   */
	  enqueueReplaceState: function (publicInstance, completeState) {
	    warnNoop(publicInstance, 'replaceState');
	  },
	
	  /**
	   * Sets a subset of the state. This only exists because _pendingState is
	   * internal. This provides a merging strategy that is not available to deep
	   * properties which is confusing. TODO: Expose pendingState or don't use it
	   * during the merge.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @param {object} partialState Next partial state to be merged with state.
	   * @internal
	   */
	  enqueueSetState: function (publicInstance, partialState) {
	    warnNoop(publicInstance, 'setState');
	  }
	};
	
	module.exports = ReactNoopUpdateQueue;

/***/ },
/* 430 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var canDefineProperty = false;
	if (false) {
	  try {
	    // $FlowFixMe https://github.com/facebook/flow/issues/285
	    Object.defineProperty({}, 'x', { get: function () {} });
	    canDefineProperty = true;
	  } catch (x) {
	    // IE will fail on defineProperty
	  }
	}
	
	module.exports = canDefineProperty;

/***/ },
/* 431 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports["default"] = compose;
	/**
	 * Composes single-argument functions from right to left. The rightmost
	 * function can take multiple arguments as it provides the signature for
	 * the resulting composite function.
	 *
	 * @param {...Function} funcs The functions to compose.
	 * @returns {Function} A function obtained by composing the argument functions
	 * from right to left. For example, compose(f, g, h) is identical to doing
	 * (...args) => f(g(h(...args))).
	 */
	
	function compose() {
	  for (var _len = arguments.length, funcs = Array(_len), _key = 0; _key < _len; _key++) {
	    funcs[_key] = arguments[_key];
	  }
	
	  if (funcs.length === 0) {
	    return function (arg) {
	      return arg;
	    };
	  }
	
	  if (funcs.length === 1) {
	    return funcs[0];
	  }
	
	  return funcs.reduce(function (a, b) {
	    return function () {
	      return a(b.apply(undefined, arguments));
	    };
	  });
	}

/***/ },
/* 432 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.ActionTypes = undefined;
	exports['default'] = createStore;
	
	var _isPlainObject = __webpack_require__(246);
	
	var _isPlainObject2 = _interopRequireDefault(_isPlainObject);
	
	var _symbolObservable = __webpack_require__(1092);
	
	var _symbolObservable2 = _interopRequireDefault(_symbolObservable);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	/**
	 * These are private action types reserved by Redux.
	 * For any unknown actions, you must return the current state.
	 * If the current state is undefined, you must return the initial state.
	 * Do not reference these action types directly in your code.
	 */
	var ActionTypes = exports.ActionTypes = {
	  INIT: '@@redux/INIT'
	
	  /**
	   * Creates a Redux store that holds the state tree.
	   * The only way to change the data in the store is to call `dispatch()` on it.
	   *
	   * There should only be a single store in your app. To specify how different
	   * parts of the state tree respond to actions, you may combine several reducers
	   * into a single reducer function by using `combineReducers`.
	   *
	   * @param {Function} reducer A function that returns the next state tree, given
	   * the current state tree and the action to handle.
	   *
	   * @param {any} [preloadedState] The initial state. You may optionally specify it
	   * to hydrate the state from the server in universal apps, or to restore a
	   * previously serialized user session.
	   * If you use `combineReducers` to produce the root reducer function, this must be
	   * an object with the same shape as `combineReducers` keys.
	   *
	   * @param {Function} [enhancer] The store enhancer. You may optionally specify it
	   * to enhance the store with third-party capabilities such as middleware,
	   * time travel, persistence, etc. The only store enhancer that ships with Redux
	   * is `applyMiddleware()`.
	   *
	   * @returns {Store} A Redux store that lets you read the state, dispatch actions
	   * and subscribe to changes.
	   */
	};function createStore(reducer, preloadedState, enhancer) {
	  var _ref2;
	
	  if (typeof preloadedState === 'function' && typeof enhancer === 'undefined') {
	    enhancer = preloadedState;
	    preloadedState = undefined;
	  }
	
	  if (typeof enhancer !== 'undefined') {
	    if (typeof enhancer !== 'function') {
	      throw new Error('Expected the enhancer to be a function.');
	    }
	
	    return enhancer(createStore)(reducer, preloadedState);
	  }
	
	  if (typeof reducer !== 'function') {
	    throw new Error('Expected the reducer to be a function.');
	  }
	
	  var currentReducer = reducer;
	  var currentState = preloadedState;
	  var currentListeners = [];
	  var nextListeners = currentListeners;
	  var isDispatching = false;
	
	  function ensureCanMutateNextListeners() {
	    if (nextListeners === currentListeners) {
	      nextListeners = currentListeners.slice();
	    }
	  }
	
	  /**
	   * Reads the state tree managed by the store.
	   *
	   * @returns {any} The current state tree of your application.
	   */
	  function getState() {
	    return currentState;
	  }
	
	  /**
	   * Adds a change listener. It will be called any time an action is dispatched,
	   * and some part of the state tree may potentially have changed. You may then
	   * call `getState()` to read the current state tree inside the callback.
	   *
	   * You may call `dispatch()` from a change listener, with the following
	   * caveats:
	   *
	   * 1. The subscriptions are snapshotted just before every `dispatch()` call.
	   * If you subscribe or unsubscribe while the listeners are being invoked, this
	   * will not have any effect on the `dispatch()` that is currently in progress.
	   * However, the next `dispatch()` call, whether nested or not, will use a more
	   * recent snapshot of the subscription list.
	   *
	   * 2. The listener should not expect to see all state changes, as the state
	   * might have been updated multiple times during a nested `dispatch()` before
	   * the listener is called. It is, however, guaranteed that all subscribers
	   * registered before the `dispatch()` started will be called with the latest
	   * state by the time it exits.
	   *
	   * @param {Function} listener A callback to be invoked on every dispatch.
	   * @returns {Function} A function to remove this change listener.
	   */
	  function subscribe(listener) {
	    if (typeof listener !== 'function') {
	      throw new Error('Expected listener to be a function.');
	    }
	
	    var isSubscribed = true;
	
	    ensureCanMutateNextListeners();
	    nextListeners.push(listener);
	
	    return function unsubscribe() {
	      if (!isSubscribed) {
	        return;
	      }
	
	      isSubscribed = false;
	
	      ensureCanMutateNextListeners();
	      var index = nextListeners.indexOf(listener);
	      nextListeners.splice(index, 1);
	    };
	  }
	
	  /**
	   * Dispatches an action. It is the only way to trigger a state change.
	   *
	   * The `reducer` function, used to create the store, will be called with the
	   * current state tree and the given `action`. Its return value will
	   * be considered the **next** state of the tree, and the change listeners
	   * will be notified.
	   *
	   * The base implementation only supports plain object actions. If you want to
	   * dispatch a Promise, an Observable, a thunk, or something else, you need to
	   * wrap your store creating function into the corresponding middleware. For
	   * example, see the documentation for the `redux-thunk` package. Even the
	   * middleware will eventually dispatch plain object actions using this method.
	   *
	   * @param {Object} action A plain object representing “what changed”. It is
	   * a good idea to keep actions serializable so you can record and replay user
	   * sessions, or use the time travelling `redux-devtools`. An action must have
	   * a `type` property which may not be `undefined`. It is a good idea to use
	   * string constants for action types.
	   *
	   * @returns {Object} For convenience, the same action object you dispatched.
	   *
	   * Note that, if you use a custom middleware, it may wrap `dispatch()` to
	   * return something else (for example, a Promise you can await).
	   */
	  function dispatch(action) {
	    if (!(0, _isPlainObject2['default'])(action)) {
	      throw new Error('Actions must be plain objects. ' + 'Use custom middleware for async actions.');
	    }
	
	    if (typeof action.type === 'undefined') {
	      throw new Error('Actions may not have an undefined "type" property. ' + 'Have you misspelled a constant?');
	    }
	
	    if (isDispatching) {
	      throw new Error('Reducers may not dispatch actions.');
	    }
	
	    try {
	      isDispatching = true;
	      currentState = currentReducer(currentState, action);
	    } finally {
	      isDispatching = false;
	    }
	
	    var listeners = currentListeners = nextListeners;
	    for (var i = 0; i < listeners.length; i++) {
	      var listener = listeners[i];
	      listener();
	    }
	
	    return action;
	  }
	
	  /**
	   * Replaces the reducer currently used by the store to calculate the state.
	   *
	   * You might need this if your app implements code splitting and you want to
	   * load some of the reducers dynamically. You might also need this if you
	   * implement a hot reloading mechanism for Redux.
	   *
	   * @param {Function} nextReducer The reducer for the store to use instead.
	   * @returns {void}
	   */
	  function replaceReducer(nextReducer) {
	    if (typeof nextReducer !== 'function') {
	      throw new Error('Expected the nextReducer to be a function.');
	    }
	
	    currentReducer = nextReducer;
	    dispatch({ type: ActionTypes.INIT });
	  }
	
	  /**
	   * Interoperability point for observable/reactive libraries.
	   * @returns {observable} A minimal observable of state changes.
	   * For more information, see the observable proposal:
	   * https://github.com/tc39/proposal-observable
	   */
	  function observable() {
	    var _ref;
	
	    var outerSubscribe = subscribe;
	    return _ref = {
	      /**
	       * The minimal observable subscription method.
	       * @param {Object} observer Any object that can be used as an observer.
	       * The observer object should have a `next` method.
	       * @returns {subscription} An object with an `unsubscribe` method that can
	       * be used to unsubscribe the observable from the store, and prevent further
	       * emission of values from the observable.
	       */
	      subscribe: function subscribe(observer) {
	        if (typeof observer !== 'object') {
	          throw new TypeError('Expected the observer to be an object.');
	        }
	
	        function observeState() {
	          if (observer.next) {
	            observer.next(getState());
	          }
	        }
	
	        observeState();
	        var unsubscribe = outerSubscribe(observeState);
	        return { unsubscribe: unsubscribe };
	      }
	    }, _ref[_symbolObservable2['default']] = function () {
	      return this;
	    }, _ref;
	  }
	
	  // When a store is created, an "INIT" action is dispatched so that every
	  // reducer returns their initial state. This effectively populates
	  // the initial state tree.
	  dispatch({ type: ActionTypes.INIT });
	
	  return _ref2 = {
	    dispatch: dispatch,
	    subscribe: subscribe,
	    getState: getState,
	    replaceReducer: replaceReducer
	  }, _ref2[_symbolObservable2['default']] = observable, _ref2;
	}

/***/ },
/* 433 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports['default'] = warning;
	/**
	 * Prints a warning in the console if it exists.
	 *
	 * @param {String} message The warning message.
	 * @returns {void}
	 */
	function warning(message) {
	  /* eslint-disable no-console */
	  if (typeof console !== 'undefined' && typeof console.error === 'function') {
	    console.error(message);
	  }
	  /* eslint-enable no-console */
	  try {
	    // This error was thrown as a convenience so that if you enable
	    // "break on all exceptions" in your console,
	    // it would pause the execution at this line.
	    throw new Error(message);
	    /* eslint-disable no-empty */
	  } catch (e) {}
	  /* eslint-enable no-empty */
	}

/***/ },
/* 434 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _util = __webpack_require__(1091);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var process = process || { env: {} };
	
	var InlineSVG = function (_React$Component) {
	    _inherits(InlineSVG, _React$Component);
	
	    function InlineSVG() {
	        _classCallCheck(this, InlineSVG);
	
	        return _possibleConstructorReturn(this, (InlineSVG.__proto__ || Object.getPrototypeOf(InlineSVG)).apply(this, arguments));
	    }
	
	    _createClass(InlineSVG, [{
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(_ref) {
	            var children = _ref.children;
	
	            if ("production" !== process.env.NODE_ENV && children != null) {
	                console.info('<InlineSVG />: `children` prop will be ignored.');
	            }
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var Element = void 0,
	                __html = void 0,
	                svgProps = void 0;
	
	            var _props = this.props,
	                element = _props.element,
	                raw = _props.raw,
	                src = _props.src,
	                otherProps = _objectWithoutProperties(_props, ['element', 'raw', 'src']);
	
	            if (raw === true) {
	                Element = 'svg';
	                svgProps = (0, _util.extractSVGProps)(src);
	                __html = (0, _util.getSVGFromSource)(src).innerHTML;
	            }
	            __html = __html || src;
	            Element = Element || element;
	            svgProps = svgProps || {};
	
	            return _react2.default.createElement(Element, _extends({}, svgProps, otherProps, { src: null, children: null,
	                dangerouslySetInnerHTML: { __html: __html } }));
	        }
	    }]);
	
	    return InlineSVG;
	}(_react2.default.Component);
	
	exports.default = InlineSVG;
	
	
	InlineSVG.defaultProps = {
	    element: 'i',
	    raw: false,
	    src: ''
	};
	
	InlineSVG.propTypes = {
	    src: _propTypes.string.isRequired,
	    element: _propTypes.string,
	    raw: _propTypes.bool
	};

/***/ },
/* 435 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "assets/fonts/Guroo-Producer.svg";

/***/ },
/* 436 */
/***/ function(module, exports, __webpack_require__) {

	// see https://tools.ietf.org/html/rfc1808
	
	/* jshint ignore:start */
	(function(root) { 
	/* jshint ignore:end */
	
	  var URL_REGEX = /^((?:[a-zA-Z0-9+\-.]+:)?)(\/\/[^\/?#]*)?((?:[^\/\?#]*\/)*.*?)??(;.*?)?(\?.*?)?(#.*?)?$/;
	  var FIRST_SEGMENT_REGEX = /^([^\/?#]*)(.*)$/;
	  var SLASH_DOT_REGEX = /(?:\/|^)\.(?=\/)/g;
	  var SLASH_DOT_DOT_REGEX = /(?:\/|^)\.\.\/(?!\.\.\/).*?(?=\/)/g;
	
	  var URLToolkit = { // jshint ignore:line
	    // If opts.alwaysNormalize is true then the path will always be normalized even when it starts with / or //
	    // E.g
	    // With opts.alwaysNormalize = false (default, spec compliant)
	    // http://a.com/b/cd + /e/f/../g => http://a.com/e/f/../g
	    // With opts.alwaysNormalize = true (not spec compliant)
	    // http://a.com/b/cd + /e/f/../g => http://a.com/e/g
	    buildAbsoluteURL: function(baseURL, relativeURL, opts) {
	      opts = opts || {};
	      // remove any remaining space and CRLF
	      baseURL = baseURL.trim();
	      relativeURL = relativeURL.trim();
	      if (!relativeURL) {
	        // 2a) If the embedded URL is entirely empty, it inherits the
	        // entire base URL (i.e., is set equal to the base URL)
	        // and we are done.
	        if (!opts.alwaysNormalize) {
	          return baseURL;
	        }
	        var basePartsForNormalise = URLToolkit.parseURL(baseURL);
	        if (!basePartsForNormalise) {
	          throw new Error('Error trying to parse base URL.');
	        }
	        basePartsForNormalise.path = URLToolkit.normalizePath(basePartsForNormalise.path);
	        return URLToolkit.buildURLFromParts(basePartsForNormalise);
	      }
	      var relativeParts = URLToolkit.parseURL(relativeURL);
	      if (!relativeParts) {
	        throw new Error('Error trying to parse relative URL.');
	      }
	      if (relativeParts.scheme) {
	        // 2b) If the embedded URL starts with a scheme name, it is
	        // interpreted as an absolute URL and we are done.
	        if (!opts.alwaysNormalize) {
	          return relativeURL;
	        }
	        relativeParts.path = URLToolkit.normalizePath(relativeParts.path);
	        return URLToolkit.buildURLFromParts(relativeParts);
	      }
	      var baseParts = URLToolkit.parseURL(baseURL);
	      if (!baseParts) {
	        throw new Error('Error trying to parse base URL.');
	      }
	      if (!baseParts.netLoc && baseParts.path && baseParts.path[0] !== '/') {
	        // If netLoc missing and path doesn't start with '/', assume everthing before the first '/' is the netLoc
	        // This causes 'example.com/a' to be handled as '//example.com/a' instead of '/example.com/a'
	        var pathParts = FIRST_SEGMENT_REGEX.exec(baseParts.path);
	        baseParts.netLoc = pathParts[1];
	        baseParts.path = pathParts[2];
	      }
	      if (baseParts.netLoc && !baseParts.path) {
	        baseParts.path = '/';
	      }
	      var builtParts = {
	        // 2c) Otherwise, the embedded URL inherits the scheme of
	        // the base URL.
	        scheme: baseParts.scheme,
	        netLoc: relativeParts.netLoc,
	        path: null,
	        params: relativeParts.params,
	        query: relativeParts.query,
	        fragment: relativeParts.fragment
	      };
	      if (!relativeParts.netLoc) {
	        // 3) If the embedded URL's <net_loc> is non-empty, we skip to
	        // Step 7.  Otherwise, the embedded URL inherits the <net_loc>
	        // (if any) of the base URL.
	        builtParts.netLoc = baseParts.netLoc;
	        // 4) If the embedded URL path is preceded by a slash "/", the
	        // path is not relative and we skip to Step 7.
	        if (relativeParts.path[0] !== '/') {
	          if (!relativeParts.path) {
	            // 5) If the embedded URL path is empty (and not preceded by a
	            // slash), then the embedded URL inherits the base URL path
	            builtParts.path = baseParts.path;
	            // 5a) if the embedded URL's <params> is non-empty, we skip to
	            // step 7; otherwise, it inherits the <params> of the base
	            // URL (if any) and
	            if (!relativeParts.params) {
	              builtParts.params = baseParts.params;
	              // 5b) if the embedded URL's <query> is non-empty, we skip to
	              // step 7; otherwise, it inherits the <query> of the base
	              // URL (if any) and we skip to step 7.
	              if (!relativeParts.query) {
	                builtParts.query = baseParts.query;
	              }
	            }
	          } else {
	            // 6) The last segment of the base URL's path (anything
	            // following the rightmost slash "/", or the entire path if no
	            // slash is present) is removed and the embedded URL's path is
	            // appended in its place.
	            var baseURLPath = baseParts.path;
	            var newPath = baseURLPath.substring(0, baseURLPath.lastIndexOf('/') + 1) + relativeParts.path;
	            builtParts.path = URLToolkit.normalizePath(newPath);
	          }
	        }
	      }
	      if (builtParts.path === null) {
	        builtParts.path = opts.alwaysNormalize ? URLToolkit.normalizePath(relativeParts.path) : relativeParts.path;
	      }
	      return URLToolkit.buildURLFromParts(builtParts);
	    },
	    parseURL: function(url) {
	      var parts = URL_REGEX.exec(url);
	      if (!parts) {
	        return null;
	      }
	      return {
	        scheme: parts[1] || '',
	        netLoc: parts[2] || '',
	        path: parts[3] || '',
	        params: parts[4] || '',
	        query: parts[5] || '',
	        fragment: parts[6] || ''
	      };
	    },
	    normalizePath: function(path) {
	      // The following operations are
	      // then applied, in order, to the new path:
	      // 6a) All occurrences of "./", where "." is a complete path
	      // segment, are removed.
	      // 6b) If the path ends with "." as a complete path segment,
	      // that "." is removed.
	      path = path.split('').reverse().join('').replace(SLASH_DOT_REGEX, '');
	      // 6c) All occurrences of "<segment>/../", where <segment> is a
	      // complete path segment not equal to "..", are removed.
	      // Removal of these path segments is performed iteratively,
	      // removing the leftmost matching pattern on each iteration,
	      // until no matching pattern remains.
	      // 6d) If the path ends with "<segment>/..", where <segment> is a
	      // complete path segment not equal to "..", that
	      // "<segment>/.." is removed.
	      while (path.length !== (path = path.replace(SLASH_DOT_DOT_REGEX, '')).length) {} // jshint ignore:line
	      return path.split('').reverse().join('');
	    },
	    buildURLFromParts: function(parts) {
	      return parts.scheme + parts.netLoc + parts.path + parts.params + parts.query + parts.fragment;
	    }
	  };
	
	/* jshint ignore:start */
	  if(true)
	    module.exports = URLToolkit;
	  else if(typeof define === 'function' && define.amd)
	    define([], function() { return URLToolkit; });
	  else if(typeof exports === 'object')
	    exports["URLToolkit"] = URLToolkit;
	  else
	    root["URLToolkit"] = URLToolkit;
	})(this);
	/* jshint ignore:end */


/***/ },
/* 437 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * @license
	 * Video.js 7.2.3 <http://videojs.com/>
	 * Copyright Brightcove, Inc. <https://www.brightcove.com/>
	 * Available under Apache License Version 2.0
	 * <https://github.com/videojs/video.js/blob/master/LICENSE>
	 *
	 * Includes vtt.js <https://github.com/mozilla/vtt.js>
	 * Available under Apache License Version 2.0
	 * <https://github.com/mozilla/vtt.js/blob/master/LICENSE>
	 */
	
	function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }
	
	var window$1 = _interopDefault(__webpack_require__(170));
	var document = _interopDefault(__webpack_require__(835));
	var tsml = _interopDefault(__webpack_require__(1096));
	var xhr = _interopDefault(__webpack_require__(1130));
	var vtt = _interopDefault(__webpack_require__(1126));
	var safeParseTuple = _interopDefault(__webpack_require__(1082));
	var URLToolkit = _interopDefault(__webpack_require__(436));
	var m3u8Parser = __webpack_require__(941);
	var mpdParser = __webpack_require__(942);
	var mp4probe = _interopDefault(__webpack_require__(183));
	var mp4 = __webpack_require__(953);
	var tsInspector = _interopDefault(__webpack_require__(956));
	var aesDecrypter = __webpack_require__(438);
	
	var version = "7.2.3";
	
	/**
	 * @file log.js
	 * @module log
	 */
	
	var log = void 0;
	
	// This is the private tracking variable for logging level.
	var level = 'info';
	
	// This is the private tracking variable for the logging history.
	var history = [];
	
	/**
	 * Log messages to the console and history based on the type of message
	 *
	 * @private
	 * @param  {string} type
	 *         The name of the console method to use.
	 *
	 * @param  {Array} args
	 *         The arguments to be passed to the matching console method.
	 */
	var logByType = function logByType(type, args) {
	  var lvl = log.levels[level];
	  var lvlRegExp = new RegExp('^(' + lvl + ')$');
	
	  if (type !== 'log') {
	
	    // Add the type to the front of the message when it's not "log".
	    args.unshift(type.toUpperCase() + ':');
	  }
	
	  // Add a clone of the args at this point to history.
	  if (history) {
	    history.push([].concat(args));
	  }
	
	  // Add console prefix after adding to history.
	  args.unshift('VIDEOJS:');
	
	  // If there's no console then don't try to output messages, but they will
	  // still be stored in history.
	  if (!window$1.console) {
	    return;
	  }
	
	  // Was setting these once outside of this function, but containing them
	  // in the function makes it easier to test cases where console doesn't exist
	  // when the module is executed.
	  var fn = window$1.console[type];
	
	  if (!fn && type === 'debug') {
	    // Certain browsers don't have support for console.debug. For those, we
	    // should default to the closest comparable log.
	    fn = window$1.console.info || window$1.console.log;
	  }
	
	  // Bail out if there's no console or if this type is not allowed by the
	  // current logging level.
	  if (!fn || !lvl || !lvlRegExp.test(type)) {
	    return;
	  }
	
	  fn[Array.isArray(args) ? 'apply' : 'call'](window$1.console, args);
	};
	
	/**
	 * Logs plain debug messages. Similar to `console.log`.
	 *
	 * @class
	 * @param    {Mixed[]} args
	 *           One or more messages or objects that should be logged.
	 */
	log = function log() {
	  for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	    args[_key] = arguments[_key];
	  }
	
	  logByType('log', args);
	};
	
	/**
	 * Enumeration of available logging levels, where the keys are the level names
	 * and the values are `|`-separated strings containing logging methods allowed
	 * in that logging level. These strings are used to create a regular expression
	 * matching the function name being called.
	 *
	 * Levels provided by video.js are:
	 *
	 * - `off`: Matches no calls. Any value that can be cast to `false` will have
	 *   this effect. The most restrictive.
	 * - `all`: Matches only Video.js-provided functions (`debug`, `log`,
	 *   `log.warn`, and `log.error`).
	 * - `debug`: Matches `log.debug`, `log`, `log.warn`, and `log.error` calls.
	 * - `info` (default): Matches `log`, `log.warn`, and `log.error` calls.
	 * - `warn`: Matches `log.warn` and `log.error` calls.
	 * - `error`: Matches only `log.error` calls.
	 *
	 * @type {Object}
	 */
	log.levels = {
	  all: 'debug|log|warn|error',
	  off: '',
	  debug: 'debug|log|warn|error',
	  info: 'log|warn|error',
	  warn: 'warn|error',
	  error: 'error',
	  DEFAULT: level
	};
	
	/**
	 * Get or set the current logging level. If a string matching a key from
	 * {@link log.levels} is provided, acts as a setter. Regardless of argument,
	 * returns the current logging level.
	 *
	 * @param  {string} [lvl]
	 *         Pass to set a new logging level.
	 *
	 * @return {string}
	 *         The current logging level.
	 */
	log.level = function (lvl) {
	  if (typeof lvl === 'string') {
	    if (!log.levels.hasOwnProperty(lvl)) {
	      throw new Error('"' + lvl + '" in not a valid log level');
	    }
	    level = lvl;
	  }
	  return level;
	};
	
	/**
	 * Returns an array containing everything that has been logged to the history.
	 *
	 * This array is a shallow clone of the internal history record. However, its
	 * contents are _not_ cloned; so, mutating objects inside this array will
	 * mutate them in history.
	 *
	 * @return {Array}
	 */
	log.history = function () {
	  return history ? [].concat(history) : [];
	};
	
	/**
	 * Clears the internal history tracking, but does not prevent further history
	 * tracking.
	 */
	log.history.clear = function () {
	  if (history) {
	    history.length = 0;
	  }
	};
	
	/**
	 * Disable history tracking if it is currently enabled.
	 */
	log.history.disable = function () {
	  if (history !== null) {
	    history.length = 0;
	    history = null;
	  }
	};
	
	/**
	 * Enable history tracking if it is currently disabled.
	 */
	log.history.enable = function () {
	  if (history === null) {
	    history = [];
	  }
	};
	
	/**
	 * Logs error messages. Similar to `console.error`.
	 *
	 * @param {Mixed[]} args
	 *        One or more messages or objects that should be logged as an error
	 */
	log.error = function () {
	  for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
	    args[_key2] = arguments[_key2];
	  }
	
	  return logByType('error', args);
	};
	
	/**
	 * Logs warning messages. Similar to `console.warn`.
	 *
	 * @param {Mixed[]} args
	 *        One or more messages or objects that should be logged as a warning.
	 */
	log.warn = function () {
	  for (var _len3 = arguments.length, args = Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
	    args[_key3] = arguments[_key3];
	  }
	
	  return logByType('warn', args);
	};
	
	/**
	 * Logs debug messages. Similar to `console.debug`, but may also act as a comparable
	 * log if `console.debug` is not available
	 *
	 * @param {Mixed[]} args
	 *        One or more messages or objects that should be logged as debug.
	 */
	log.debug = function () {
	  for (var _len4 = arguments.length, args = Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
	    args[_key4] = arguments[_key4];
	  }
	
	  return logByType('debug', args);
	};
	
	var log$1 = log;
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {
	  return typeof obj;
	} : function (obj) {
	  return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
	};
	
	var classCallCheck = function (instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	};
	
	var inherits = function (subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
	  }
	
	  subClass.prototype = Object.create(superClass && superClass.prototype, {
	    constructor: {
	      value: subClass,
	      enumerable: false,
	      writable: true,
	      configurable: true
	    }
	  });
	  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
	};
	
	var possibleConstructorReturn = function (self, call) {
	  if (!self) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }
	
	  return call && (typeof call === "object" || typeof call === "function") ? call : self;
	};
	
	var taggedTemplateLiteralLoose = function (strings, raw) {
	  strings.raw = raw;
	  return strings;
	};
	
	/**
	 * @file obj.js
	 * @module obj
	 */
	
	/**
	 * @callback obj:EachCallback
	 *
	 * @param {Mixed} value
	 *        The current key for the object that is being iterated over.
	 *
	 * @param {string} key
	 *        The current key-value for object that is being iterated over
	 */
	
	/**
	 * @callback obj:ReduceCallback
	 *
	 * @param {Mixed} accum
	 *        The value that is accumulating over the reduce loop.
	 *
	 * @param {Mixed} value
	 *        The current key for the object that is being iterated over.
	 *
	 * @param {string} key
	 *        The current key-value for object that is being iterated over
	 *
	 * @return {Mixed}
	 *         The new accumulated value.
	 */
	var toString = Object.prototype.toString;
	
	/**
	 * Get the keys of an Object
	 *
	 * @param {Object}
	 *        The Object to get the keys from
	 *
	 * @return {string[]}
	 *         An array of the keys from the object. Returns an empty array if the
	 *         object passed in was invalid or had no keys.
	 *
	 * @private
	 */
	var keys = function keys(object) {
	  return isObject(object) ? Object.keys(object) : [];
	};
	
	/**
	 * Array-like iteration for objects.
	 *
	 * @param {Object} object
	 *        The object to iterate over
	 *
	 * @param {obj:EachCallback} fn
	 *        The callback function which is called for each key in the object.
	 */
	function each(object, fn) {
	  keys(object).forEach(function (key) {
	    return fn(object[key], key);
	  });
	}
	
	/**
	 * Array-like reduce for objects.
	 *
	 * @param {Object} object
	 *        The Object that you want to reduce.
	 *
	 * @param {Function} fn
	 *         A callback function which is called for each key in the object. It
	 *         receives the accumulated value and the per-iteration value and key
	 *         as arguments.
	 *
	 * @param {Mixed} [initial = 0]
	 *        Starting value
	 *
	 * @return {Mixed}
	 *         The final accumulated value.
	 */
	function reduce(object, fn) {
	  var initial = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
	
	  return keys(object).reduce(function (accum, key) {
	    return fn(accum, object[key], key);
	  }, initial);
	}
	
	/**
	 * Object.assign-style object shallow merge/extend.
	 *
	 * @param  {Object} target
	 * @param  {Object} ...sources
	 * @return {Object}
	 */
	function assign(target) {
	  for (var _len = arguments.length, sources = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	    sources[_key - 1] = arguments[_key];
	  }
	
	  if (Object.assign) {
	    return Object.assign.apply(Object, [target].concat(sources));
	  }
	
	  sources.forEach(function (source) {
	    if (!source) {
	      return;
	    }
	
	    each(source, function (value, key) {
	      target[key] = value;
	    });
	  });
	
	  return target;
	}
	
	/**
	 * Returns whether a value is an object of any kind - including DOM nodes,
	 * arrays, regular expressions, etc. Not functions, though.
	 *
	 * This avoids the gotcha where using `typeof` on a `null` value
	 * results in `'object'`.
	 *
	 * @param  {Object} value
	 * @return {Boolean}
	 */
	function isObject(value) {
	  return !!value && (typeof value === 'undefined' ? 'undefined' : _typeof(value)) === 'object';
	}
	
	/**
	 * Returns whether an object appears to be a "plain" object - that is, a
	 * direct instance of `Object`.
	 *
	 * @param  {Object} value
	 * @return {Boolean}
	 */
	function isPlain(value) {
	  return isObject(value) && toString.call(value) === '[object Object]' && value.constructor === Object;
	}
	
	/**
	 * @file computed-style.js
	 * @module computed-style
	 */
	
	/**
	 * A safe getComputedStyle.
	 *
	 * This is needed because in Firefox, if the player is loaded in an iframe with
	 * `display:none`, then `getComputedStyle` returns `null`, so, we do a null-check to
	 * make sure  that the player doesn't break in these cases.
	 *
	 * @param {Element} el
	 *        The element you want the computed style of
	 *
	 * @param {string} prop
	 *        The property name you want
	 *
	 * @see https://bugzilla.mozilla.org/show_bug.cgi?id=548397
	 *
	 * @static
	 * @const
	 */
	function computedStyle(el, prop) {
	  if (!el || !prop) {
	    return '';
	  }
	
	  if (typeof window$1.getComputedStyle === 'function') {
	    var cs = window$1.getComputedStyle(el);
	
	    return cs ? cs[prop] : '';
	  }
	
	  return '';
	}
	
	var _templateObject = taggedTemplateLiteralLoose(['Setting attributes in the second argument of createEl()\n                has been deprecated. Use the third argument instead.\n                createEl(type, properties, attributes). Attempting to set ', ' to ', '.'], ['Setting attributes in the second argument of createEl()\n                has been deprecated. Use the third argument instead.\n                createEl(type, properties, attributes). Attempting to set ', ' to ', '.']);
	
	/**
	 * Detect if a value is a string with any non-whitespace characters.
	 *
	 * @param {string} str
	 *        The string to check
	 *
	 * @return {boolean}
	 *         - True if the string is non-blank
	 *         - False otherwise
	 *
	 */
	function isNonBlankString(str) {
	  return typeof str === 'string' && /\S/.test(str);
	}
	
	/**
	 * Throws an error if the passed string has whitespace. This is used by
	 * class methods to be relatively consistent with the classList API.
	 *
	 * @param {string} str
	 *         The string to check for whitespace.
	 *
	 * @throws {Error}
	 *         Throws an error if there is whitespace in the string.
	 *
	 */
	function throwIfWhitespace(str) {
	  if (/\s/.test(str)) {
	    throw new Error('class has illegal whitespace characters');
	  }
	}
	
	/**
	 * Produce a regular expression for matching a className within an elements className.
	 *
	 * @param {string} className
	 *         The className to generate the RegExp for.
	 *
	 * @return {RegExp}
	 *         The RegExp that will check for a specific `className` in an elements
	 *         className.
	 */
	function classRegExp(className) {
	  return new RegExp('(^|\\s)' + className + '($|\\s)');
	}
	
	/**
	 * Whether the current DOM interface appears to be real.
	 *
	 * @return {Boolean}
	 */
	function isReal() {
	  // Both document and window will never be undefined thanks to `global`.
	  return document === window$1.document;
	}
	
	/**
	 * Determines, via duck typing, whether or not a value is a DOM element.
	 *
	 * @param {Mixed} value
	 *        The thing to check
	 *
	 * @return {boolean}
	 *         - True if it is a DOM element
	 *         - False otherwise
	 */
	function isEl(value) {
	  return isObject(value) && value.nodeType === 1;
	}
	
	/**
	 * Determines if the current DOM is embedded in an iframe.
	 *
	 * @return {boolean}
	 *
	 */
	function isInFrame() {
	
	  // We need a try/catch here because Safari will throw errors when attempting
	  // to get either `parent` or `self`
	  try {
	    return window$1.parent !== window$1.self;
	  } catch (x) {
	    return true;
	  }
	}
	
	/**
	 * Creates functions to query the DOM using a given method.
	 *
	 * @param {string} method
	 *         The method to create the query with.
	 *
	 * @return {Function}
	 *         The query method
	 */
	function createQuerier(method) {
	  return function (selector, context) {
	    if (!isNonBlankString(selector)) {
	      return document[method](null);
	    }
	    if (isNonBlankString(context)) {
	      context = document.querySelector(context);
	    }
	
	    var ctx = isEl(context) ? context : document;
	
	    return ctx[method] && ctx[method](selector);
	  };
	}
	
	/**
	 * Creates an element and applies properties.
	 *
	 * @param {string} [tagName='div']
	 *         Name of tag to be created.
	 *
	 * @param {Object} [properties={}]
	 *         Element properties to be applied.
	 *
	 * @param {Object} [attributes={}]
	 *         Element attributes to be applied.
	 *
	 * @param {String|Element|TextNode|Array|Function} [content]
	 *         Contents for the element (see: {@link dom:normalizeContent})
	 *
	 * @return {Element}
	 *         The element that was created.
	 */
	function createEl() {
	  var tagName = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'div';
	  var properties = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	  var attributes = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	  var content = arguments[3];
	
	  var el = document.createElement(tagName);
	
	  Object.getOwnPropertyNames(properties).forEach(function (propName) {
	    var val = properties[propName];
	
	    // See #2176
	    // We originally were accepting both properties and attributes in the
	    // same object, but that doesn't work so well.
	    if (propName.indexOf('aria-') !== -1 || propName === 'role' || propName === 'type') {
	      log$1.warn(tsml(_templateObject, propName, val));
	      el.setAttribute(propName, val);
	
	      // Handle textContent since it's not supported everywhere and we have a
	      // method for it.
	    } else if (propName === 'textContent') {
	      textContent(el, val);
	    } else {
	      el[propName] = val;
	    }
	  });
	
	  Object.getOwnPropertyNames(attributes).forEach(function (attrName) {
	    el.setAttribute(attrName, attributes[attrName]);
	  });
	
	  if (content) {
	    appendContent(el, content);
	  }
	
	  return el;
	}
	
	/**
	 * Injects text into an element, replacing any existing contents entirely.
	 *
	 * @param {Element} el
	 *        The element to add text content into
	 *
	 * @param {string} text
	 *        The text content to add.
	 *
	 * @return {Element}
	 *         The element with added text content.
	 */
	function textContent(el, text) {
	  if (typeof el.textContent === 'undefined') {
	    el.innerText = text;
	  } else {
	    el.textContent = text;
	  }
	  return el;
	}
	
	/**
	 * Insert an element as the first child node of another
	 *
	 * @param {Element} child
	 *        Element to insert
	 *
	 * @param {Element} parent
	 *        Element to insert child into
	 */
	function prependTo(child, parent) {
	  if (parent.firstChild) {
	    parent.insertBefore(child, parent.firstChild);
	  } else {
	    parent.appendChild(child);
	  }
	}
	
	/**
	 * Check if an element has a CSS class
	 *
	 * @param {Element} element
	 *        Element to check
	 *
	 * @param {string} classToCheck
	 *        Class name to check for
	 *
	 * @return {boolean}
	 *         - True if the element had the class
	 *         - False otherwise.
	 *
	 * @throws {Error}
	 *         Throws an error if `classToCheck` has white space.
	 */
	function hasClass(element, classToCheck) {
	  throwIfWhitespace(classToCheck);
	  if (element.classList) {
	    return element.classList.contains(classToCheck);
	  }
	  return classRegExp(classToCheck).test(element.className);
	}
	
	/**
	 * Add a CSS class name to an element
	 *
	 * @param {Element} element
	 *        Element to add class name to.
	 *
	 * @param {string} classToAdd
	 *        Class name to add.
	 *
	 * @return {Element}
	 *         The dom element with the added class name.
	 */
	function addClass(element, classToAdd) {
	  if (element.classList) {
	    element.classList.add(classToAdd);
	
	    // Don't need to `throwIfWhitespace` here because `hasElClass` will do it
	    // in the case of classList not being supported.
	  } else if (!hasClass(element, classToAdd)) {
	    element.className = (element.className + ' ' + classToAdd).trim();
	  }
	
	  return element;
	}
	
	/**
	 * Remove a CSS class name from an element
	 *
	 * @param {Element} element
	 *        Element to remove a class name from.
	 *
	 * @param {string} classToRemove
	 *        Class name to remove
	 *
	 * @return {Element}
	 *         The dom element with class name removed.
	 */
	function removeClass(element, classToRemove) {
	  if (element.classList) {
	    element.classList.remove(classToRemove);
	  } else {
	    throwIfWhitespace(classToRemove);
	    element.className = element.className.split(/\s+/).filter(function (c) {
	      return c !== classToRemove;
	    }).join(' ');
	  }
	
	  return element;
	}
	
	/**
	 * The callback definition for toggleElClass.
	 *
	 * @callback Dom~PredicateCallback
	 * @param {Element} element
	 *        The DOM element of the Component.
	 *
	 * @param {string} classToToggle
	 *        The `className` that wants to be toggled
	 *
	 * @return {boolean|undefined}
	 *         - If true the `classToToggle` will get added to `element`.
	 *         - If false the `classToToggle` will get removed from `element`.
	 *         - If undefined this callback will be ignored
	 */
	
	/**
	 * Adds or removes a CSS class name on an element depending on an optional
	 * condition or the presence/absence of the class name.
	 *
	 * @param {Element} element
	 *        The element to toggle a class name on.
	 *
	 * @param {string} classToToggle
	 *        The class that should be toggled
	 *
	 * @param {boolean|PredicateCallback} [predicate]
	 *        See the return value for {@link Dom~PredicateCallback}
	 *
	 * @return {Element}
	 *         The element with a class that has been toggled.
	 */
	function toggleClass(element, classToToggle, predicate) {
	
	  // This CANNOT use `classList` internally because IE11 does not support the
	  // second parameter to the `classList.toggle()` method! Which is fine because
	  // `classList` will be used by the add/remove functions.
	  var has = hasClass(element, classToToggle);
	
	  if (typeof predicate === 'function') {
	    predicate = predicate(element, classToToggle);
	  }
	
	  if (typeof predicate !== 'boolean') {
	    predicate = !has;
	  }
	
	  // If the necessary class operation matches the current state of the
	  // element, no action is required.
	  if (predicate === has) {
	    return;
	  }
	
	  if (predicate) {
	    addClass(element, classToToggle);
	  } else {
	    removeClass(element, classToToggle);
	  }
	
	  return element;
	}
	
	/**
	 * Apply attributes to an HTML element.
	 *
	 * @param {Element} el
	 *        Element to add attributes to.
	 *
	 * @param {Object} [attributes]
	 *        Attributes to be applied.
	 */
	function setAttributes(el, attributes) {
	  Object.getOwnPropertyNames(attributes).forEach(function (attrName) {
	    var attrValue = attributes[attrName];
	
	    if (attrValue === null || typeof attrValue === 'undefined' || attrValue === false) {
	      el.removeAttribute(attrName);
	    } else {
	      el.setAttribute(attrName, attrValue === true ? '' : attrValue);
	    }
	  });
	}
	
	/**
	 * Get an element's attribute values, as defined on the HTML tag
	 * Attributes are not the same as properties. They're defined on the tag
	 * or with setAttribute (which shouldn't be used with HTML)
	 * This will return true or false for boolean attributes.
	 *
	 * @param {Element} tag
	 *        Element from which to get tag attributes.
	 *
	 * @return {Object}
	 *         All attributes of the element.
	 */
	function getAttributes(tag) {
	  var obj = {};
	
	  // known boolean attributes
	  // we can check for matching boolean properties, but not all browsers
	  // and not all tags know about these attributes, so, we still want to check them manually
	  var knownBooleans = ',' + 'autoplay,controls,playsinline,loop,muted,default,defaultMuted' + ',';
	
	  if (tag && tag.attributes && tag.attributes.length > 0) {
	    var attrs = tag.attributes;
	
	    for (var i = attrs.length - 1; i >= 0; i--) {
	      var attrName = attrs[i].name;
	      var attrVal = attrs[i].value;
	
	      // check for known booleans
	      // the matching element property will return a value for typeof
	      if (typeof tag[attrName] === 'boolean' || knownBooleans.indexOf(',' + attrName + ',') !== -1) {
	        // the value of an included boolean attribute is typically an empty
	        // string ('') which would equal false if we just check for a false value.
	        // we also don't want support bad code like autoplay='false'
	        attrVal = attrVal !== null ? true : false;
	      }
	
	      obj[attrName] = attrVal;
	    }
	  }
	
	  return obj;
	}
	
	/**
	 * Get the value of an element's attribute
	 *
	 * @param {Element} el
	 *        A DOM element
	 *
	 * @param {string} attribute
	 *        Attribute to get the value of
	 *
	 * @return {string}
	 *         value of the attribute
	 */
	function getAttribute(el, attribute) {
	  return el.getAttribute(attribute);
	}
	
	/**
	 * Set the value of an element's attribute
	 *
	 * @param {Element} el
	 *        A DOM element
	 *
	 * @param {string} attribute
	 *        Attribute to set
	 *
	 * @param {string} value
	 *        Value to set the attribute to
	 */
	function setAttribute(el, attribute, value) {
	  el.setAttribute(attribute, value);
	}
	
	/**
	 * Remove an element's attribute
	 *
	 * @param {Element} el
	 *        A DOM element
	 *
	 * @param {string} attribute
	 *        Attribute to remove
	 */
	function removeAttribute(el, attribute) {
	  el.removeAttribute(attribute);
	}
	
	/**
	 * Attempt to block the ability to select text while dragging controls
	 */
	function blockTextSelection() {
	  document.body.focus();
	  document.onselectstart = function () {
	    return false;
	  };
	}
	
	/**
	 * Turn off text selection blocking
	 */
	function unblockTextSelection() {
	  document.onselectstart = function () {
	    return true;
	  };
	}
	
	/**
	 * Identical to the native `getBoundingClientRect` function, but ensures that
	 * the method is supported at all (it is in all browsers we claim to support)
	 * and that the element is in the DOM before continuing.
	 *
	 * This wrapper function also shims properties which are not provided by some
	 * older browsers (namely, IE8).
	 *
	 * Additionally, some browsers do not support adding properties to a
	 * `ClientRect`/`DOMRect` object; so, we shallow-copy it with the standard
	 * properties (except `x` and `y` which are not widely supported). This helps
	 * avoid implementations where keys are non-enumerable.
	 *
	 * @param  {Element} el
	 *         Element whose `ClientRect` we want to calculate.
	 *
	 * @return {Object|undefined}
	 *         Always returns a plain
	 */
	function getBoundingClientRect(el) {
	  if (el && el.getBoundingClientRect && el.parentNode) {
	    var rect = el.getBoundingClientRect();
	    var result = {};
	
	    ['bottom', 'height', 'left', 'right', 'top', 'width'].forEach(function (k) {
	      if (rect[k] !== undefined) {
	        result[k] = rect[k];
	      }
	    });
	
	    if (!result.height) {
	      result.height = parseFloat(computedStyle(el, 'height'));
	    }
	
	    if (!result.width) {
	      result.width = parseFloat(computedStyle(el, 'width'));
	    }
	
	    return result;
	  }
	}
	
	/**
	 * The postion of a DOM element on the page.
	 *
	 * @typedef {Object} module:dom~Position
	 *
	 * @property {number} left
	 *           Pixels to the left
	 *
	 * @property {number} top
	 *           Pixels on top
	 */
	
	/**
	 * Offset Left.
	 * getBoundingClientRect technique from
	 * John Resig
	 *
	 * @see http://ejohn.org/blog/getboundingclientrect-is-awesome/
	 *
	 * @param {Element} el
	 *        Element from which to get offset
	 *
	 * @return {module:dom~Position}
	 *         The position of the element that was passed in.
	 */
	function findPosition(el) {
	  var box = void 0;
	
	  if (el.getBoundingClientRect && el.parentNode) {
	    box = el.getBoundingClientRect();
	  }
	
	  if (!box) {
	    return {
	      left: 0,
	      top: 0
	    };
	  }
	
	  var docEl = document.documentElement;
	  var body = document.body;
	
	  var clientLeft = docEl.clientLeft || body.clientLeft || 0;
	  var scrollLeft = window$1.pageXOffset || body.scrollLeft;
	  var left = box.left + scrollLeft - clientLeft;
	
	  var clientTop = docEl.clientTop || body.clientTop || 0;
	  var scrollTop = window$1.pageYOffset || body.scrollTop;
	  var top = box.top + scrollTop - clientTop;
	
	  // Android sometimes returns slightly off decimal values, so need to round
	  return {
	    left: Math.round(left),
	    top: Math.round(top)
	  };
	}
	
	/**
	 * x and y coordinates for a dom element or mouse pointer
	 *
	 * @typedef {Object} Dom~Coordinates
	 *
	 * @property {number} x
	 *           x coordinate in pixels
	 *
	 * @property {number} y
	 *           y coordinate in pixels
	 */
	
	/**
	 * Get pointer position in element
	 * Returns an object with x and y coordinates.
	 * The base on the coordinates are the bottom left of the element.
	 *
	 * @param {Element} el
	 *        Element on which to get the pointer position on
	 *
	 * @param {EventTarget~Event} event
	 *        Event object
	 *
	 * @return {Dom~Coordinates}
	 *         A Coordinates object corresponding to the mouse position.
	 *
	 */
	function getPointerPosition(el, event) {
	  var position = {};
	  var box = findPosition(el);
	  var boxW = el.offsetWidth;
	  var boxH = el.offsetHeight;
	
	  var boxY = box.top;
	  var boxX = box.left;
	  var pageY = event.pageY;
	  var pageX = event.pageX;
	
	  if (event.changedTouches) {
	    pageX = event.changedTouches[0].pageX;
	    pageY = event.changedTouches[0].pageY;
	  }
	
	  position.y = Math.max(0, Math.min(1, (boxY - pageY + boxH) / boxH));
	  position.x = Math.max(0, Math.min(1, (pageX - boxX) / boxW));
	
	  return position;
	}
	
	/**
	 * Determines, via duck typing, whether or not a value is a text node.
	 *
	 * @param {Mixed} value
	 *        Check if this value is a text node.
	 *
	 * @return {boolean}
	 *         - True if it is a text node
	 *         - False otherwise
	 */
	function isTextNode(value) {
	  return isObject(value) && value.nodeType === 3;
	}
	
	/**
	 * Empties the contents of an element.
	 *
	 * @param {Element} el
	 *        The element to empty children from
	 *
	 * @return {Element}
	 *         The element with no children
	 */
	function emptyEl(el) {
	  while (el.firstChild) {
	    el.removeChild(el.firstChild);
	  }
	  return el;
	}
	
	/**
	 * Normalizes content for eventual insertion into the DOM.
	 *
	 * This allows a wide range of content definition methods, but protects
	 * from falling into the trap of simply writing to `innerHTML`, which is
	 * an XSS concern.
	 *
	 * The content for an element can be passed in multiple types and
	 * combinations, whose behavior is as follows:
	 *
	 * @param {String|Element|TextNode|Array|Function} content
	 *        - String: Normalized into a text node.
	 *        - Element/TextNode: Passed through.
	 *        - Array: A one-dimensional array of strings, elements, nodes, or functions
	 *          (which return single strings, elements, or nodes).
	 *        - Function: If the sole argument, is expected to produce a string, element,
	 *          node, or array as defined above.
	 *
	 * @return {Array}
	 *         All of the content that was passed in normalized.
	 */
	function normalizeContent(content) {
	
	  // First, invoke content if it is a function. If it produces an array,
	  // that needs to happen before normalization.
	  if (typeof content === 'function') {
	    content = content();
	  }
	
	  // Next up, normalize to an array, so one or many items can be normalized,
	  // filtered, and returned.
	  return (Array.isArray(content) ? content : [content]).map(function (value) {
	
	    // First, invoke value if it is a function to produce a new value,
	    // which will be subsequently normalized to a Node of some kind.
	    if (typeof value === 'function') {
	      value = value();
	    }
	
	    if (isEl(value) || isTextNode(value)) {
	      return value;
	    }
	
	    if (typeof value === 'string' && /\S/.test(value)) {
	      return document.createTextNode(value);
	    }
	  }).filter(function (value) {
	    return value;
	  });
	}
	
	/**
	 * Normalizes and appends content to an element.
	 *
	 * @param {Element} el
	 *        Element to append normalized content to.
	 *
	 *
	 * @param {String|Element|TextNode|Array|Function} content
	 *        See the `content` argument of {@link dom:normalizeContent}
	 *
	 * @return {Element}
	 *         The element with appended normalized content.
	 */
	function appendContent(el, content) {
	  normalizeContent(content).forEach(function (node) {
	    return el.appendChild(node);
	  });
	  return el;
	}
	
	/**
	 * Normalizes and inserts content into an element; this is identical to
	 * `appendContent()`, except it empties the element first.
	 *
	 * @param {Element} el
	 *        Element to insert normalized content into.
	 *
	 * @param {String|Element|TextNode|Array|Function} content
	 *        See the `content` argument of {@link dom:normalizeContent}
	 *
	 * @return {Element}
	 *         The element with inserted normalized content.
	 *
	 */
	function insertContent(el, content) {
	  return appendContent(emptyEl(el), content);
	}
	
	/**
	 * Check if event was a single left click
	 *
	 * @param {EventTarget~Event} event
	 *        Event object
	 *
	 * @return {boolean}
	 *         - True if a left click
	 *         - False if not a left click
	 */
	function isSingleLeftClick(event) {
	  // Note: if you create something draggable, be sure to
	  // call it on both `mousedown` and `mousemove` event,
	  // otherwise `mousedown` should be enough for a button
	
	  if (event.button === undefined && event.buttons === undefined) {
	    // Why do we need `buttons` ?
	    // Because, middle mouse sometimes have this:
	    // e.button === 0 and e.buttons === 4
	    // Furthermore, we want to prevent combination click, something like
	    // HOLD middlemouse then left click, that would be
	    // e.button === 0, e.buttons === 5
	    // just `button` is not gonna work
	
	    // Alright, then what this block does ?
	    // this is for chrome `simulate mobile devices`
	    // I want to support this as well
	
	    return true;
	  }
	
	  if (event.button === 0 && event.buttons === undefined) {
	    // Touch screen, sometimes on some specific device, `buttons`
	    // doesn't have anything (safari on ios, blackberry...)
	
	    return true;
	  }
	
	  if (event.button !== 0 || event.buttons !== 1) {
	    // This is the reason we have those if else block above
	    // if any special case we can catch and let it slide
	    // we do it above, when get to here, this definitely
	    // is-not-left-click
	
	    return false;
	  }
	
	  return true;
	}
	
	/**
	 * Finds a single DOM element matching `selector` within the optional
	 * `context` of another DOM element (defaulting to `document`).
	 *
	 * @param {string} selector
	 *        A valid CSS selector, which will be passed to `querySelector`.
	 *
	 * @param {Element|String} [context=document]
	 *        A DOM element within which to query. Can also be a selector
	 *        string in which case the first matching element will be used
	 *        as context. If missing (or no element matches selector), falls
	 *        back to `document`.
	 *
	 * @return {Element|null}
	 *         The element that was found or null.
	 */
	var $ = createQuerier('querySelector');
	
	/**
	 * Finds a all DOM elements matching `selector` within the optional
	 * `context` of another DOM element (defaulting to `document`).
	 *
	 * @param {string} selector
	 *           A valid CSS selector, which will be passed to `querySelectorAll`.
	 *
	 * @param {Element|String} [context=document]
	 *           A DOM element within which to query. Can also be a selector
	 *           string in which case the first matching element will be used
	 *           as context. If missing (or no element matches selector), falls
	 *           back to `document`.
	 *
	 * @return {NodeList}
	 *         A element list of elements that were found. Will be empty if none were found.
	 *
	 */
	var $$ = createQuerier('querySelectorAll');
	
	var Dom = /*#__PURE__*/Object.freeze({
	  isReal: isReal,
	  isEl: isEl,
	  isInFrame: isInFrame,
	  createEl: createEl,
	  textContent: textContent,
	  prependTo: prependTo,
	  hasClass: hasClass,
	  addClass: addClass,
	  removeClass: removeClass,
	  toggleClass: toggleClass,
	  setAttributes: setAttributes,
	  getAttributes: getAttributes,
	  getAttribute: getAttribute,
	  setAttribute: setAttribute,
	  removeAttribute: removeAttribute,
	  blockTextSelection: blockTextSelection,
	  unblockTextSelection: unblockTextSelection,
	  getBoundingClientRect: getBoundingClientRect,
	  findPosition: findPosition,
	  getPointerPosition: getPointerPosition,
	  isTextNode: isTextNode,
	  emptyEl: emptyEl,
	  normalizeContent: normalizeContent,
	  appendContent: appendContent,
	  insertContent: insertContent,
	  isSingleLeftClick: isSingleLeftClick,
	  $: $,
	  $$: $$
	});
	
	/**
	 * @file guid.js
	 * @module guid
	 */
	
	/**
	 * Unique ID for an element or function
	 * @type {Number}
	 */
	var _guid = 1;
	
	/**
	 * Get a unique auto-incrementing ID by number that has not been returned before.
	 *
	 * @return {number}
	 *         A new unique ID.
	 */
	function newGUID() {
	  return _guid++;
	}
	
	/**
	 * @file dom-data.js
	 * @module dom-data
	 */
	
	/**
	 * Element Data Store.
	 *
	 * Allows for binding data to an element without putting it directly on the
	 * element. Ex. Event listeners are stored here.
	 * (also from jsninja.com, slightly modified and updated for closure compiler)
	 *
	 * @type {Object}
	 * @private
	 */
	var elData = {};
	
	/*
	 * Unique attribute name to store an element's guid in
	 *
	 * @type {String}
	 * @constant
	 * @private
	 */
	var elIdAttr = 'vdata' + new Date().getTime();
	
	/**
	 * Returns the cache object where data for an element is stored
	 *
	 * @param {Element} el
	 *        Element to store data for.
	 *
	 * @return {Object}
	 *         The cache object for that el that was passed in.
	 */
	function getData(el) {
	  var id = el[elIdAttr];
	
	  if (!id) {
	    id = el[elIdAttr] = newGUID();
	  }
	
	  if (!elData[id]) {
	    elData[id] = {};
	  }
	
	  return elData[id];
	}
	
	/**
	 * Returns whether or not an element has cached data
	 *
	 * @param {Element} el
	 *        Check if this element has cached data.
	 *
	 * @return {boolean}
	 *         - True if the DOM element has cached data.
	 *         - False otherwise.
	 */
	function hasData(el) {
	  var id = el[elIdAttr];
	
	  if (!id) {
	    return false;
	  }
	
	  return !!Object.getOwnPropertyNames(elData[id]).length;
	}
	
	/**
	 * Delete data for the element from the cache and the guid attr from getElementById
	 *
	 * @param {Element} el
	 *        Remove cached data for this element.
	 */
	function removeData(el) {
	  var id = el[elIdAttr];
	
	  if (!id) {
	    return;
	  }
	
	  // Remove all stored data
	  delete elData[id];
	
	  // Remove the elIdAttr property from the DOM node
	  try {
	    delete el[elIdAttr];
	  } catch (e) {
	    if (el.removeAttribute) {
	      el.removeAttribute(elIdAttr);
	    } else {
	      // IE doesn't appear to support removeAttribute on the document element
	      el[elIdAttr] = null;
	    }
	  }
	}
	
	/**
	 * @file events.js. An Event System (John Resig - Secrets of a JS Ninja http://jsninja.com/)
	 * (Original book version wasn't completely usable, so fixed some things and made Closure Compiler compatible)
	 * This should work very similarly to jQuery's events, however it's based off the book version which isn't as
	 * robust as jquery's, so there's probably some differences.
	 *
	 * @module events
	 */
	
	/**
	 * Clean up the listener cache and dispatchers
	 *
	 * @param {Element|Object} elem
	 *        Element to clean up
	 *
	 * @param {string} type
	 *        Type of event to clean up
	 */
	function _cleanUpEvents(elem, type) {
	  var data = getData(elem);
	
	  // Remove the events of a particular type if there are none left
	  if (data.handlers[type].length === 0) {
	    delete data.handlers[type];
	    // data.handlers[type] = null;
	    // Setting to null was causing an error with data.handlers
	
	    // Remove the meta-handler from the element
	    if (elem.removeEventListener) {
	      elem.removeEventListener(type, data.dispatcher, false);
	    } else if (elem.detachEvent) {
	      elem.detachEvent('on' + type, data.dispatcher);
	    }
	  }
	
	  // Remove the events object if there are no types left
	  if (Object.getOwnPropertyNames(data.handlers).length <= 0) {
	    delete data.handlers;
	    delete data.dispatcher;
	    delete data.disabled;
	  }
	
	  // Finally remove the element data if there is no data left
	  if (Object.getOwnPropertyNames(data).length === 0) {
	    removeData(elem);
	  }
	}
	
	/**
	 * Loops through an array of event types and calls the requested method for each type.
	 *
	 * @param {Function} fn
	 *        The event method we want to use.
	 *
	 * @param {Element|Object} elem
	 *        Element or object to bind listeners to
	 *
	 * @param {string} type
	 *        Type of event to bind to.
	 *
	 * @param {EventTarget~EventListener} callback
	 *        Event listener.
	 */
	function _handleMultipleEvents(fn, elem, types, callback) {
	  types.forEach(function (type) {
	    // Call the event method for each one of the types
	    fn(elem, type, callback);
	  });
	}
	
	/**
	 * Fix a native event to have standard property values
	 *
	 * @param {Object} event
	 *        Event object to fix.
	 *
	 * @return {Object}
	 *         Fixed event object.
	 */
	function fixEvent(event) {
	
	  function returnTrue() {
	    return true;
	  }
	
	  function returnFalse() {
	    return false;
	  }
	
	  // Test if fixing up is needed
	  // Used to check if !event.stopPropagation instead of isPropagationStopped
	  // But native events return true for stopPropagation, but don't have
	  // other expected methods like isPropagationStopped. Seems to be a problem
	  // with the Javascript Ninja code. So we're just overriding all events now.
	  if (!event || !event.isPropagationStopped) {
	    var old = event || window$1.event;
	
	    event = {};
	    // Clone the old object so that we can modify the values event = {};
	    // IE8 Doesn't like when you mess with native event properties
	    // Firefox returns false for event.hasOwnProperty('type') and other props
	    //  which makes copying more difficult.
	    // TODO: Probably best to create a whitelist of event props
	    for (var key in old) {
	      // Safari 6.0.3 warns you if you try to copy deprecated layerX/Y
	      // Chrome warns you if you try to copy deprecated keyboardEvent.keyLocation
	      // and webkitMovementX/Y
	      if (key !== 'layerX' && key !== 'layerY' && key !== 'keyLocation' && key !== 'webkitMovementX' && key !== 'webkitMovementY') {
	        // Chrome 32+ warns if you try to copy deprecated returnValue, but
	        // we still want to if preventDefault isn't supported (IE8).
	        if (!(key === 'returnValue' && old.preventDefault)) {
	          event[key] = old[key];
	        }
	      }
	    }
	
	    // The event occurred on this element
	    if (!event.target) {
	      event.target = event.srcElement || document;
	    }
	
	    // Handle which other element the event is related to
	    if (!event.relatedTarget) {
	      event.relatedTarget = event.fromElement === event.target ? event.toElement : event.fromElement;
	    }
	
	    // Stop the default browser action
	    event.preventDefault = function () {
	      if (old.preventDefault) {
	        old.preventDefault();
	      }
	      event.returnValue = false;
	      old.returnValue = false;
	      event.defaultPrevented = true;
	    };
	
	    event.defaultPrevented = false;
	
	    // Stop the event from bubbling
	    event.stopPropagation = function () {
	      if (old.stopPropagation) {
	        old.stopPropagation();
	      }
	      event.cancelBubble = true;
	      old.cancelBubble = true;
	      event.isPropagationStopped = returnTrue;
	    };
	
	    event.isPropagationStopped = returnFalse;
	
	    // Stop the event from bubbling and executing other handlers
	    event.stopImmediatePropagation = function () {
	      if (old.stopImmediatePropagation) {
	        old.stopImmediatePropagation();
	      }
	      event.isImmediatePropagationStopped = returnTrue;
	      event.stopPropagation();
	    };
	
	    event.isImmediatePropagationStopped = returnFalse;
	
	    // Handle mouse position
	    if (event.clientX !== null && event.clientX !== undefined) {
	      var doc = document.documentElement;
	      var body = document.body;
	
	      event.pageX = event.clientX + (doc && doc.scrollLeft || body && body.scrollLeft || 0) - (doc && doc.clientLeft || body && body.clientLeft || 0);
	      event.pageY = event.clientY + (doc && doc.scrollTop || body && body.scrollTop || 0) - (doc && doc.clientTop || body && body.clientTop || 0);
	    }
	
	    // Handle key presses
	    event.which = event.charCode || event.keyCode;
	
	    // Fix button for mouse clicks:
	    // 0 == left; 1 == middle; 2 == right
	    if (event.button !== null && event.button !== undefined) {
	
	      // The following is disabled because it does not pass videojs-standard
	      // and... yikes.
	      /* eslint-disable */
	      event.button = event.button & 1 ? 0 : event.button & 4 ? 1 : event.button & 2 ? 2 : 0;
	      /* eslint-enable */
	    }
	  }
	
	  // Returns fixed-up instance
	  return event;
	}
	
	/**
	 * Whether passive event listeners are supported
	 */
	var _supportsPassive = false;
	
	(function () {
	  try {
	    var opts = Object.defineProperty({}, 'passive', {
	      get: function get() {
	        _supportsPassive = true;
	      }
	    });
	
	    window$1.addEventListener('test', null, opts);
	    window$1.removeEventListener('test', null, opts);
	  } catch (e) {
	    // disregard
	  }
	})();
	
	/**
	 * Touch events Chrome expects to be passive
	 */
	var passiveEvents = ['touchstart', 'touchmove'];
	
	/**
	 * Add an event listener to element
	 * It stores the handler function in a separate cache object
	 * and adds a generic handler to the element's event,
	 * along with a unique id (guid) to the element.
	 *
	 * @param {Element|Object} elem
	 *        Element or object to bind listeners to
	 *
	 * @param {string|string[]} type
	 *        Type of event to bind to.
	 *
	 * @param {EventTarget~EventListener} fn
	 *        Event listener.
	 */
	function on(elem, type, fn) {
	  if (Array.isArray(type)) {
	    return _handleMultipleEvents(on, elem, type, fn);
	  }
	
	  var data = getData(elem);
	
	  // We need a place to store all our handler data
	  if (!data.handlers) {
	    data.handlers = {};
	  }
	
	  if (!data.handlers[type]) {
	    data.handlers[type] = [];
	  }
	
	  if (!fn.guid) {
	    fn.guid = newGUID();
	  }
	
	  data.handlers[type].push(fn);
	
	  if (!data.dispatcher) {
	    data.disabled = false;
	
	    data.dispatcher = function (event, hash) {
	
	      if (data.disabled) {
	        return;
	      }
	
	      event = fixEvent(event);
	
	      var handlers = data.handlers[event.type];
	
	      if (handlers) {
	        // Copy handlers so if handlers are added/removed during the process it doesn't throw everything off.
	        var handlersCopy = handlers.slice(0);
	
	        for (var m = 0, n = handlersCopy.length; m < n; m++) {
	          if (event.isImmediatePropagationStopped()) {
	            break;
	          } else {
	            try {
	              handlersCopy[m].call(elem, event, hash);
	            } catch (e) {
	              log$1.error(e);
	            }
	          }
	        }
	      }
	    };
	  }
	
	  if (data.handlers[type].length === 1) {
	    if (elem.addEventListener) {
	      var options = false;
	
	      if (_supportsPassive && passiveEvents.indexOf(type) > -1) {
	        options = { passive: true };
	      }
	      elem.addEventListener(type, data.dispatcher, options);
	    } else if (elem.attachEvent) {
	      elem.attachEvent('on' + type, data.dispatcher);
	    }
	  }
	}
	
	/**
	 * Removes event listeners from an element
	 *
	 * @param {Element|Object} elem
	 *        Object to remove listeners from.
	 *
	 * @param {string|string[]} [type]
	 *        Type of listener to remove. Don't include to remove all events from element.
	 *
	 * @param {EventTarget~EventListener} [fn]
	 *        Specific listener to remove. Don't include to remove listeners for an event
	 *        type.
	 */
	function off(elem, type, fn) {
	  // Don't want to add a cache object through getElData if not needed
	  if (!hasData(elem)) {
	    return;
	  }
	
	  var data = getData(elem);
	
	  // If no events exist, nothing to unbind
	  if (!data.handlers) {
	    return;
	  }
	
	  if (Array.isArray(type)) {
	    return _handleMultipleEvents(off, elem, type, fn);
	  }
	
	  // Utility function
	  var removeType = function removeType(el, t) {
	    data.handlers[t] = [];
	    _cleanUpEvents(el, t);
	  };
	
	  // Are we removing all bound events?
	  if (type === undefined) {
	    for (var t in data.handlers) {
	      if (Object.prototype.hasOwnProperty.call(data.handlers || {}, t)) {
	        removeType(elem, t);
	      }
	    }
	    return;
	  }
	
	  var handlers = data.handlers[type];
	
	  // If no handlers exist, nothing to unbind
	  if (!handlers) {
	    return;
	  }
	
	  // If no listener was provided, remove all listeners for type
	  if (!fn) {
	    removeType(elem, type);
	    return;
	  }
	
	  // We're only removing a single handler
	  if (fn.guid) {
	    for (var n = 0; n < handlers.length; n++) {
	      if (handlers[n].guid === fn.guid) {
	        handlers.splice(n--, 1);
	      }
	    }
	  }
	
	  _cleanUpEvents(elem, type);
	}
	
	/**
	 * Trigger an event for an element
	 *
	 * @param {Element|Object} elem
	 *        Element to trigger an event on
	 *
	 * @param {EventTarget~Event|string} event
	 *        A string (the type) or an event object with a type attribute
	 *
	 * @param {Object} [hash]
	 *        data hash to pass along with the event
	 *
	 * @return {boolean|undefined}
	 *         - Returns the opposite of `defaultPrevented` if default was prevented
	 *         - Otherwise returns undefined
	 */
	function trigger(elem, event, hash) {
	  // Fetches element data and a reference to the parent (for bubbling).
	  // Don't want to add a data object to cache for every parent,
	  // so checking hasElData first.
	  var elemData = hasData(elem) ? getData(elem) : {};
	  var parent = elem.parentNode || elem.ownerDocument;
	  // type = event.type || event,
	  // handler;
	
	  // If an event name was passed as a string, creates an event out of it
	  if (typeof event === 'string') {
	    event = { type: event, target: elem };
	  } else if (!event.target) {
	    event.target = elem;
	  }
	
	  // Normalizes the event properties.
	  event = fixEvent(event);
	
	  // If the passed element has a dispatcher, executes the established handlers.
	  if (elemData.dispatcher) {
	    elemData.dispatcher.call(elem, event, hash);
	  }
	
	  // Unless explicitly stopped or the event does not bubble (e.g. media events)
	  // recursively calls this function to bubble the event up the DOM.
	  if (parent && !event.isPropagationStopped() && event.bubbles === true) {
	    trigger.call(null, parent, event, hash);
	
	    // If at the top of the DOM, triggers the default action unless disabled.
	  } else if (!parent && !event.defaultPrevented) {
	    var targetData = getData(event.target);
	
	    // Checks if the target has a default action for this event.
	    if (event.target[event.type]) {
	      // Temporarily disables event dispatching on the target as we have already executed the handler.
	      targetData.disabled = true;
	      // Executes the default action.
	      if (typeof event.target[event.type] === 'function') {
	        event.target[event.type]();
	      }
	      // Re-enables event dispatching.
	      targetData.disabled = false;
	    }
	  }
	
	  // Inform the triggerer if the default was prevented by returning false
	  return !event.defaultPrevented;
	}
	
	/**
	 * Trigger a listener only once for an event
	 *
	 * @param {Element|Object} elem
	 *        Element or object to bind to.
	 *
	 * @param {string|string[]} type
	 *        Name/type of event
	 *
	 * @param {Event~EventListener} fn
	 *        Event Listener function
	 */
	function one(elem, type, fn) {
	  if (Array.isArray(type)) {
	    return _handleMultipleEvents(one, elem, type, fn);
	  }
	  var func = function func() {
	    off(elem, type, func);
	    fn.apply(this, arguments);
	  };
	
	  // copy the guid to the new function so it can removed using the original function's ID
	  func.guid = fn.guid = fn.guid || newGUID();
	  on(elem, type, func);
	}
	
	var Events = /*#__PURE__*/Object.freeze({
	  fixEvent: fixEvent,
	  on: on,
	  off: off,
	  trigger: trigger,
	  one: one
	});
	
	/**
	 * @file setup.js - Functions for setting up a player without
	 * user interaction based on the data-setup `attribute` of the video tag.
	 *
	 * @module setup
	 */
	
	var _windowLoaded = false;
	var videojs = void 0;
	
	/**
	 * Set up any tags that have a data-setup `attribute` when the player is started.
	 */
	var autoSetup = function autoSetup() {
	
	  // Protect against breakage in non-browser environments and check global autoSetup option.
	  if (!isReal() || videojs.options.autoSetup === false) {
	    return;
	  }
	
	  var vids = Array.prototype.slice.call(document.getElementsByTagName('video'));
	  var audios = Array.prototype.slice.call(document.getElementsByTagName('audio'));
	  var divs = Array.prototype.slice.call(document.getElementsByTagName('video-js'));
	  var mediaEls = vids.concat(audios, divs);
	
	  // Check if any media elements exist
	  if (mediaEls && mediaEls.length > 0) {
	
	    for (var i = 0, e = mediaEls.length; i < e; i++) {
	      var mediaEl = mediaEls[i];
	
	      // Check if element exists, has getAttribute func.
	      if (mediaEl && mediaEl.getAttribute) {
	
	        // Make sure this player hasn't already been set up.
	        if (mediaEl.player === undefined) {
	          var options = mediaEl.getAttribute('data-setup');
	
	          // Check if data-setup attr exists.
	          // We only auto-setup if they've added the data-setup attr.
	          if (options !== null) {
	            // Create new video.js instance.
	            videojs(mediaEl);
	          }
	        }
	
	        // If getAttribute isn't defined, we need to wait for the DOM.
	      } else {
	        autoSetupTimeout(1);
	        break;
	      }
	    }
	
	    // No videos were found, so keep looping unless page is finished loading.
	  } else if (!_windowLoaded) {
	    autoSetupTimeout(1);
	  }
	};
	
	/**
	 * Wait until the page is loaded before running autoSetup. This will be called in
	 * autoSetup if `hasLoaded` returns false.
	 *
	 * @param {number} wait
	 *        How long to wait in ms
	 *
	 * @param {module:videojs} [vjs]
	 *        The videojs library function
	 */
	function autoSetupTimeout(wait, vjs) {
	  if (vjs) {
	    videojs = vjs;
	  }
	
	  window$1.setTimeout(autoSetup, wait);
	}
	
	if (isReal() && document.readyState === 'complete') {
	  _windowLoaded = true;
	} else {
	  /**
	   * Listen for the load event on window, and set _windowLoaded to true.
	   *
	   * @listens load
	   */
	  one(window$1, 'load', function () {
	    _windowLoaded = true;
	  });
	}
	
	/**
	 * @file stylesheet.js
	 * @module stylesheet
	 */
	
	/**
	 * Create a DOM syle element given a className for it.
	 *
	 * @param {string} className
	 *        The className to add to the created style element.
	 *
	 * @return {Element}
	 *         The element that was created.
	 */
	var createStyleElement = function createStyleElement(className) {
	  var style = document.createElement('style');
	
	  style.className = className;
	
	  return style;
	};
	
	/**
	 * Add text to a DOM element.
	 *
	 * @param {Element} el
	 *        The Element to add text content to.
	 *
	 * @param {string} content
	 *        The text to add to the element.
	 */
	var setTextContent = function setTextContent(el, content) {
	  if (el.styleSheet) {
	    el.styleSheet.cssText = content;
	  } else {
	    el.textContent = content;
	  }
	};
	
	/**
	 * @file fn.js
	 * @module fn
	 */
	
	/**
	 * Bind (a.k.a proxy or Context). A simple method for changing the context of a function
	 * It also stores a unique id on the function so it can be easily removed from events.
	 *
	 * @param {Mixed} context
	 *        The object to bind as scope.
	 *
	 * @param {Function} fn
	 *        The function to be bound to a scope.
	 *
	 * @param {number} [uid]
	 *        An optional unique ID for the function to be set
	 *
	 * @return {Function}
	 *         The new function that will be bound into the context given
	 */
	var bind = function bind(context, fn, uid) {
	  // Make sure the function has a unique ID
	  if (!fn.guid) {
	    fn.guid = newGUID();
	  }
	
	  // Create the new function that changes the context
	  var bound = function bound() {
	    return fn.apply(context, arguments);
	  };
	
	  // Allow for the ability to individualize this function
	  // Needed in the case where multiple objects might share the same prototype
	  // IF both items add an event listener with the same function, then you try to remove just one
	  // it will remove both because they both have the same guid.
	  // when using this, you need to use the bind method when you remove the listener as well.
	  // currently used in text tracks
	  bound.guid = uid ? uid + '_' + fn.guid : fn.guid;
	
	  return bound;
	};
	
	/**
	 * Wraps the given function, `fn`, with a new function that only invokes `fn`
	 * at most once per every `wait` milliseconds.
	 *
	 * @param  {Function} fn
	 *         The function to be throttled.
	 *
	 * @param  {Number}   wait
	 *         The number of milliseconds by which to throttle.
	 *
	 * @return {Function}
	 */
	var throttle = function throttle(fn, wait) {
	  var last = Date.now();
	
	  var throttled = function throttled() {
	    var now = Date.now();
	
	    if (now - last >= wait) {
	      fn.apply(undefined, arguments);
	      last = now;
	    }
	  };
	
	  return throttled;
	};
	
	/**
	 * Creates a debounced function that delays invoking `func` until after `wait`
	 * milliseconds have elapsed since the last time the debounced function was
	 * invoked.
	 *
	 * Inspired by lodash and underscore implementations.
	 *
	 * @param  {Function} func
	 *         The function to wrap with debounce behavior.
	 *
	 * @param  {number} wait
	 *         The number of milliseconds to wait after the last invocation.
	 *
	 * @param  {boolean} [immediate]
	 *         Whether or not to invoke the function immediately upon creation.
	 *
	 * @param  {Object} [context=window]
	 *         The "context" in which the debounced function should debounce. For
	 *         example, if this function should be tied to a Video.js player,
	 *         the player can be passed here. Alternatively, defaults to the
	 *         global `window` object.
	 *
	 * @return {Function}
	 *         A debounced function.
	 */
	var debounce = function debounce(func, wait, immediate) {
	  var context = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : window$1;
	
	  var timeout = void 0;
	
	  var cancel = function cancel() {
	    context.clearTimeout(timeout);
	    timeout = null;
	  };
	
	  /* eslint-disable consistent-this */
	  var debounced = function debounced() {
	    var self = this;
	    var args = arguments;
	
	    var _later = function later() {
	      timeout = null;
	      _later = null;
	      if (!immediate) {
	        func.apply(self, args);
	      }
	    };
	
	    if (!timeout && immediate) {
	      func.apply(self, args);
	    }
	
	    context.clearTimeout(timeout);
	    timeout = context.setTimeout(_later, wait);
	  };
	  /* eslint-enable consistent-this */
	
	  debounced.cancel = cancel;
	
	  return debounced;
	};
	
	/**
	 * @file src/js/event-target.js
	 */
	
	/**
	 * `EventTarget` is a class that can have the same API as the DOM `EventTarget`. It
	 * adds shorthand functions that wrap around lengthy functions. For example:
	 * the `on` function is a wrapper around `addEventListener`.
	 *
	 * @see [EventTarget Spec]{@link https://www.w3.org/TR/DOM-Level-2-Events/events.html#Events-EventTarget}
	 * @class EventTarget
	 */
	var EventTarget = function EventTarget() {};
	
	/**
	 * A Custom DOM event.
	 *
	 * @typedef {Object} EventTarget~Event
	 * @see [Properties]{@link https://developer.mozilla.org/en-US/docs/Web/API/CustomEvent}
	 */
	
	/**
	 * All event listeners should follow the following format.
	 *
	 * @callback EventTarget~EventListener
	 * @this {EventTarget}
	 *
	 * @param {EventTarget~Event} event
	 *        the event that triggered this function
	 *
	 * @param {Object} [hash]
	 *        hash of data sent during the event
	 */
	
	/**
	 * An object containing event names as keys and booleans as values.
	 *
	 * > NOTE: If an event name is set to a true value here {@link EventTarget#trigger}
	 *         will have extra functionality. See that function for more information.
	 *
	 * @property EventTarget.prototype.allowedEvents_
	 * @private
	 */
	EventTarget.prototype.allowedEvents_ = {};
	
	/**
	 * Adds an `event listener` to an instance of an `EventTarget`. An `event listener` is a
	 * function that will get called when an event with a certain name gets triggered.
	 *
	 * @param {string|string[]} type
	 *        An event name or an array of event names.
	 *
	 * @param {EventTarget~EventListener} fn
	 *        The function to call with `EventTarget`s
	 */
	EventTarget.prototype.on = function (type, fn) {
	  // Remove the addEventListener alias before calling Events.on
	  // so we don't get into an infinite type loop
	  var ael = this.addEventListener;
	
	  this.addEventListener = function () {};
	  on(this, type, fn);
	  this.addEventListener = ael;
	};
	
	/**
	 * An alias of {@link EventTarget#on}. Allows `EventTarget` to mimic
	 * the standard DOM API.
	 *
	 * @function
	 * @see {@link EventTarget#on}
	 */
	EventTarget.prototype.addEventListener = EventTarget.prototype.on;
	
	/**
	 * Removes an `event listener` for a specific event from an instance of `EventTarget`.
	 * This makes it so that the `event listener` will no longer get called when the
	 * named event happens.
	 *
	 * @param {string|string[]} type
	 *        An event name or an array of event names.
	 *
	 * @param {EventTarget~EventListener} fn
	 *        The function to remove.
	 */
	EventTarget.prototype.off = function (type, fn) {
	  off(this, type, fn);
	};
	
	/**
	 * An alias of {@link EventTarget#off}. Allows `EventTarget` to mimic
	 * the standard DOM API.
	 *
	 * @function
	 * @see {@link EventTarget#off}
	 */
	EventTarget.prototype.removeEventListener = EventTarget.prototype.off;
	
	/**
	 * This function will add an `event listener` that gets triggered only once. After the
	 * first trigger it will get removed. This is like adding an `event listener`
	 * with {@link EventTarget#on} that calls {@link EventTarget#off} on itself.
	 *
	 * @param {string|string[]} type
	 *        An event name or an array of event names.
	 *
	 * @param {EventTarget~EventListener} fn
	 *        The function to be called once for each event name.
	 */
	EventTarget.prototype.one = function (type, fn) {
	  // Remove the addEventListener alialing Events.on
	  // so we don't get into an infinite type loop
	  var ael = this.addEventListener;
	
	  this.addEventListener = function () {};
	  one(this, type, fn);
	  this.addEventListener = ael;
	};
	
	/**
	 * This function causes an event to happen. This will then cause any `event listeners`
	 * that are waiting for that event, to get called. If there are no `event listeners`
	 * for an event then nothing will happen.
	 *
	 * If the name of the `Event` that is being triggered is in `EventTarget.allowedEvents_`.
	 * Trigger will also call the `on` + `uppercaseEventName` function.
	 *
	 * Example:
	 * 'click' is in `EventTarget.allowedEvents_`, so, trigger will attempt to call
	 * `onClick` if it exists.
	 *
	 * @param {string|EventTarget~Event|Object} event
	 *        The name of the event, an `Event`, or an object with a key of type set to
	 *        an event name.
	 */
	EventTarget.prototype.trigger = function (event) {
	  var type = event.type || event;
	
	  if (typeof event === 'string') {
	    event = { type: type };
	  }
	  event = fixEvent(event);
	
	  if (this.allowedEvents_[type] && this['on' + type]) {
	    this['on' + type](event);
	  }
	
	  trigger(this, event);
	};
	
	/**
	 * An alias of {@link EventTarget#trigger}. Allows `EventTarget` to mimic
	 * the standard DOM API.
	 *
	 * @function
	 * @see {@link EventTarget#trigger}
	 */
	EventTarget.prototype.dispatchEvent = EventTarget.prototype.trigger;
	
	var EVENT_MAP = void 0;
	
	EventTarget.prototype.queueTrigger = function (event) {
	  var _this = this;
	
	  // only set up EVENT_MAP if it'll be used
	  if (!EVENT_MAP) {
	    EVENT_MAP = new Map();
	  }
	
	  var type = event.type || event;
	  var map = EVENT_MAP.get(this);
	
	  if (!map) {
	    map = new Map();
	    EVENT_MAP.set(this, map);
	  }
	
	  var oldTimeout = map.get(type);
	
	  map.delete(type);
	  window$1.clearTimeout(oldTimeout);
	
	  var timeout = window$1.setTimeout(function () {
	    // if we cleared out all timeouts for the current target, delete its map
	    if (map.size === 0) {
	      map = null;
	      EVENT_MAP.delete(_this);
	    }
	
	    _this.trigger(event);
	  }, 0);
	
	  map.set(type, timeout);
	};
	
	/**
	 * @file mixins/evented.js
	 * @module evented
	 */
	
	/**
	 * Returns whether or not an object has had the evented mixin applied.
	 *
	 * @param  {Object} object
	 *         An object to test.
	 *
	 * @return {boolean}
	 *         Whether or not the object appears to be evented.
	 */
	var isEvented = function isEvented(object) {
	  return object instanceof EventTarget || !!object.eventBusEl_ && ['on', 'one', 'off', 'trigger'].every(function (k) {
	    return typeof object[k] === 'function';
	  });
	};
	
	/**
	 * Whether a value is a valid event type - non-empty string or array.
	 *
	 * @private
	 * @param  {string|Array} type
	 *         The type value to test.
	 *
	 * @return {boolean}
	 *         Whether or not the type is a valid event type.
	 */
	var isValidEventType = function isValidEventType(type) {
	  return (
	    // The regex here verifies that the `type` contains at least one non-
	    // whitespace character.
	    typeof type === 'string' && /\S/.test(type) || Array.isArray(type) && !!type.length
	  );
	};
	
	/**
	 * Validates a value to determine if it is a valid event target. Throws if not.
	 *
	 * @private
	 * @throws {Error}
	 *         If the target does not appear to be a valid event target.
	 *
	 * @param  {Object} target
	 *         The object to test.
	 */
	var validateTarget = function validateTarget(target) {
	  if (!target.nodeName && !isEvented(target)) {
	    throw new Error('Invalid target; must be a DOM node or evented object.');
	  }
	};
	
	/**
	 * Validates a value to determine if it is a valid event target. Throws if not.
	 *
	 * @private
	 * @throws {Error}
	 *         If the type does not appear to be a valid event type.
	 *
	 * @param  {string|Array} type
	 *         The type to test.
	 */
	var validateEventType = function validateEventType(type) {
	  if (!isValidEventType(type)) {
	    throw new Error('Invalid event type; must be a non-empty string or array.');
	  }
	};
	
	/**
	 * Validates a value to determine if it is a valid listener. Throws if not.
	 *
	 * @private
	 * @throws {Error}
	 *         If the listener is not a function.
	 *
	 * @param  {Function} listener
	 *         The listener to test.
	 */
	var validateListener = function validateListener(listener) {
	  if (typeof listener !== 'function') {
	    throw new Error('Invalid listener; must be a function.');
	  }
	};
	
	/**
	 * Takes an array of arguments given to `on()` or `one()`, validates them, and
	 * normalizes them into an object.
	 *
	 * @private
	 * @param  {Object} self
	 *         The evented object on which `on()` or `one()` was called. This
	 *         object will be bound as the `this` value for the listener.
	 *
	 * @param  {Array} args
	 *         An array of arguments passed to `on()` or `one()`.
	 *
	 * @return {Object}
	 *         An object containing useful values for `on()` or `one()` calls.
	 */
	var normalizeListenArgs = function normalizeListenArgs(self, args) {
	
	  // If the number of arguments is less than 3, the target is always the
	  // evented object itself.
	  var isTargetingSelf = args.length < 3 || args[0] === self || args[0] === self.eventBusEl_;
	  var target = void 0;
	  var type = void 0;
	  var listener = void 0;
	
	  if (isTargetingSelf) {
	    target = self.eventBusEl_;
	
	    // Deal with cases where we got 3 arguments, but we are still listening to
	    // the evented object itself.
	    if (args.length >= 3) {
	      args.shift();
	    }
	
	    type = args[0];
	    listener = args[1];
	  } else {
	    target = args[0];
	    type = args[1];
	    listener = args[2];
	  }
	
	  validateTarget(target);
	  validateEventType(type);
	  validateListener(listener);
	
	  listener = bind(self, listener);
	
	  return { isTargetingSelf: isTargetingSelf, target: target, type: type, listener: listener };
	};
	
	/**
	 * Adds the listener to the event type(s) on the target, normalizing for
	 * the type of target.
	 *
	 * @private
	 * @param  {Element|Object} target
	 *         A DOM node or evented object.
	 *
	 * @param  {string} method
	 *         The event binding method to use ("on" or "one").
	 *
	 * @param  {string|Array} type
	 *         One or more event type(s).
	 *
	 * @param  {Function} listener
	 *         A listener function.
	 */
	var listen = function listen(target, method, type, listener) {
	  validateTarget(target);
	
	  if (target.nodeName) {
	    Events[method](target, type, listener);
	  } else {
	    target[method](type, listener);
	  }
	};
	
	/**
	 * Contains methods that provide event capabilities to an object which is passed
	 * to {@link module:evented|evented}.
	 *
	 * @mixin EventedMixin
	 */
	var EventedMixin = {
	
	  /**
	   * Add a listener to an event (or events) on this object or another evented
	   * object.
	   *
	   * @param  {string|Array|Element|Object} targetOrType
	   *         If this is a string or array, it represents the event type(s)
	   *         that will trigger the listener.
	   *
	   *         Another evented object can be passed here instead, which will
	   *         cause the listener to listen for events on _that_ object.
	   *
	   *         In either case, the listener's `this` value will be bound to
	   *         this object.
	   *
	   * @param  {string|Array|Function} typeOrListener
	   *         If the first argument was a string or array, this should be the
	   *         listener function. Otherwise, this is a string or array of event
	   *         type(s).
	   *
	   * @param  {Function} [listener]
	   *         If the first argument was another evented object, this will be
	   *         the listener function.
	   */
	  on: function on$$1() {
	    var _this = this;
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    var _normalizeListenArgs = normalizeListenArgs(this, args),
	        isTargetingSelf = _normalizeListenArgs.isTargetingSelf,
	        target = _normalizeListenArgs.target,
	        type = _normalizeListenArgs.type,
	        listener = _normalizeListenArgs.listener;
	
	    listen(target, 'on', type, listener);
	
	    // If this object is listening to another evented object.
	    if (!isTargetingSelf) {
	
	      // If this object is disposed, remove the listener.
	      var removeListenerOnDispose = function removeListenerOnDispose() {
	        return _this.off(target, type, listener);
	      };
	
	      // Use the same function ID as the listener so we can remove it later it
	      // using the ID of the original listener.
	      removeListenerOnDispose.guid = listener.guid;
	
	      // Add a listener to the target's dispose event as well. This ensures
	      // that if the target is disposed BEFORE this object, we remove the
	      // removal listener that was just added. Otherwise, we create a memory leak.
	      var removeRemoverOnTargetDispose = function removeRemoverOnTargetDispose() {
	        return _this.off('dispose', removeListenerOnDispose);
	      };
	
	      // Use the same function ID as the listener so we can remove it later
	      // it using the ID of the original listener.
	      removeRemoverOnTargetDispose.guid = listener.guid;
	
	      listen(this, 'on', 'dispose', removeListenerOnDispose);
	      listen(target, 'on', 'dispose', removeRemoverOnTargetDispose);
	    }
	  },
	
	
	  /**
	   * Add a listener to an event (or events) on this object or another evented
	   * object. The listener will only be called once and then removed.
	   *
	   * @param  {string|Array|Element|Object} targetOrType
	   *         If this is a string or array, it represents the event type(s)
	   *         that will trigger the listener.
	   *
	   *         Another evented object can be passed here instead, which will
	   *         cause the listener to listen for events on _that_ object.
	   *
	   *         In either case, the listener's `this` value will be bound to
	   *         this object.
	   *
	   * @param  {string|Array|Function} typeOrListener
	   *         If the first argument was a string or array, this should be the
	   *         listener function. Otherwise, this is a string or array of event
	   *         type(s).
	   *
	   * @param  {Function} [listener]
	   *         If the first argument was another evented object, this will be
	   *         the listener function.
	   */
	  one: function one$$1() {
	    var _this2 = this;
	
	    for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
	      args[_key2] = arguments[_key2];
	    }
	
	    var _normalizeListenArgs2 = normalizeListenArgs(this, args),
	        isTargetingSelf = _normalizeListenArgs2.isTargetingSelf,
	        target = _normalizeListenArgs2.target,
	        type = _normalizeListenArgs2.type,
	        listener = _normalizeListenArgs2.listener;
	
	    // Targeting this evented object.
	
	
	    if (isTargetingSelf) {
	      listen(target, 'one', type, listener);
	
	      // Targeting another evented object.
	    } else {
	      var wrapper = function wrapper() {
	        for (var _len3 = arguments.length, largs = Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
	          largs[_key3] = arguments[_key3];
	        }
	
	        _this2.off(target, type, wrapper);
	        listener.apply(null, largs);
	      };
	
	      // Use the same function ID as the listener so we can remove it later
	      // it using the ID of the original listener.
	      wrapper.guid = listener.guid;
	      listen(target, 'one', type, wrapper);
	    }
	  },
	
	
	  /**
	   * Removes listener(s) from event(s) on an evented object.
	   *
	   * @param  {string|Array|Element|Object} [targetOrType]
	   *         If this is a string or array, it represents the event type(s).
	   *
	   *         Another evented object can be passed here instead, in which case
	   *         ALL 3 arguments are _required_.
	   *
	   * @param  {string|Array|Function} [typeOrListener]
	   *         If the first argument was a string or array, this may be the
	   *         listener function. Otherwise, this is a string or array of event
	   *         type(s).
	   *
	   * @param  {Function} [listener]
	   *         If the first argument was another evented object, this will be
	   *         the listener function; otherwise, _all_ listeners bound to the
	   *         event type(s) will be removed.
	   */
	  off: function off$$1(targetOrType, typeOrListener, listener) {
	
	    // Targeting this evented object.
	    if (!targetOrType || isValidEventType(targetOrType)) {
	      off(this.eventBusEl_, targetOrType, typeOrListener);
	
	      // Targeting another evented object.
	    } else {
	      var target = targetOrType;
	      var type = typeOrListener;
	
	      // Fail fast and in a meaningful way!
	      validateTarget(target);
	      validateEventType(type);
	      validateListener(listener);
	
	      // Ensure there's at least a guid, even if the function hasn't been used
	      listener = bind(this, listener);
	
	      // Remove the dispose listener on this evented object, which was given
	      // the same guid as the event listener in on().
	      this.off('dispose', listener);
	
	      if (target.nodeName) {
	        off(target, type, listener);
	        off(target, 'dispose', listener);
	      } else if (isEvented(target)) {
	        target.off(type, listener);
	        target.off('dispose', listener);
	      }
	    }
	  },
	
	
	  /**
	   * Fire an event on this evented object, causing its listeners to be called.
	   *
	   * @param   {string|Object} event
	   *          An event type or an object with a type property.
	   *
	   * @param   {Object} [hash]
	   *          An additional object to pass along to listeners.
	   *
	   * @returns {boolean}
	   *          Whether or not the default behavior was prevented.
	   */
	  trigger: function trigger$$1(event, hash) {
	    return trigger(this.eventBusEl_, event, hash);
	  }
	};
	
	/**
	 * Applies {@link module:evented~EventedMixin|EventedMixin} to a target object.
	 *
	 * @param  {Object} target
	 *         The object to which to add event methods.
	 *
	 * @param  {Object} [options={}]
	 *         Options for customizing the mixin behavior.
	 *
	 * @param  {String} [options.eventBusKey]
	 *         By default, adds a `eventBusEl_` DOM element to the target object,
	 *         which is used as an event bus. If the target object already has a
	 *         DOM element that should be used, pass its key here.
	 *
	 * @return {Object}
	 *         The target object.
	 */
	function evented(target) {
	  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	  var eventBusKey = options.eventBusKey;
	
	  // Set or create the eventBusEl_.
	
	  if (eventBusKey) {
	    if (!target[eventBusKey].nodeName) {
	      throw new Error('The eventBusKey "' + eventBusKey + '" does not refer to an element.');
	    }
	    target.eventBusEl_ = target[eventBusKey];
	  } else {
	    target.eventBusEl_ = createEl('span', { className: 'vjs-event-bus' });
	  }
	
	  assign(target, EventedMixin);
	
	  // When any evented object is disposed, it removes all its listeners.
	  target.on('dispose', function () {
	    target.off();
	    window$1.setTimeout(function () {
	      target.eventBusEl_ = null;
	    }, 0);
	  });
	
	  return target;
	}
	
	/**
	 * @file mixins/stateful.js
	 * @module stateful
	 */
	
	/**
	 * Contains methods that provide statefulness to an object which is passed
	 * to {@link module:stateful}.
	 *
	 * @mixin StatefulMixin
	 */
	var StatefulMixin = {
	
	  /**
	   * A hash containing arbitrary keys and values representing the state of
	   * the object.
	   *
	   * @type {Object}
	   */
	  state: {},
	
	  /**
	   * Set the state of an object by mutating its
	   * {@link module:stateful~StatefulMixin.state|state} object in place.
	   *
	   * @fires   module:stateful~StatefulMixin#statechanged
	   * @param   {Object|Function} stateUpdates
	   *          A new set of properties to shallow-merge into the plugin state.
	   *          Can be a plain object or a function returning a plain object.
	   *
	   * @returns {Object|undefined}
	   *          An object containing changes that occurred. If no changes
	   *          occurred, returns `undefined`.
	   */
	  setState: function setState(stateUpdates) {
	    var _this = this;
	
	    // Support providing the `stateUpdates` state as a function.
	    if (typeof stateUpdates === 'function') {
	      stateUpdates = stateUpdates();
	    }
	
	    var changes = void 0;
	
	    each(stateUpdates, function (value, key) {
	
	      // Record the change if the value is different from what's in the
	      // current state.
	      if (_this.state[key] !== value) {
	        changes = changes || {};
	        changes[key] = {
	          from: _this.state[key],
	          to: value
	        };
	      }
	
	      _this.state[key] = value;
	    });
	
	    // Only trigger "statechange" if there were changes AND we have a trigger
	    // function. This allows us to not require that the target object be an
	    // evented object.
	    if (changes && isEvented(this)) {
	
	      /**
	       * An event triggered on an object that is both
	       * {@link module:stateful|stateful} and {@link module:evented|evented}
	       * indicating that its state has changed.
	       *
	       * @event    module:stateful~StatefulMixin#statechanged
	       * @type     {Object}
	       * @property {Object} changes
	       *           A hash containing the properties that were changed and
	       *           the values they were changed `from` and `to`.
	       */
	      this.trigger({
	        changes: changes,
	        type: 'statechanged'
	      });
	    }
	
	    return changes;
	  }
	};
	
	/**
	 * Applies {@link module:stateful~StatefulMixin|StatefulMixin} to a target
	 * object.
	 *
	 * If the target object is {@link module:evented|evented} and has a
	 * `handleStateChanged` method, that method will be automatically bound to the
	 * `statechanged` event on itself.
	 *
	 * @param   {Object} target
	 *          The object to be made stateful.
	 *
	 * @param   {Object} [defaultState]
	 *          A default set of properties to populate the newly-stateful object's
	 *          `state` property.
	 *
	 * @returns {Object}
	 *          Returns the `target`.
	 */
	function stateful(target, defaultState) {
	  assign(target, StatefulMixin);
	
	  // This happens after the mixing-in because we need to replace the `state`
	  // added in that step.
	  target.state = assign({}, target.state, defaultState);
	
	  // Auto-bind the `handleStateChanged` method of the target object if it exists.
	  if (typeof target.handleStateChanged === 'function' && isEvented(target)) {
	    target.on('statechanged', target.handleStateChanged);
	  }
	
	  return target;
	}
	
	/**
	 * @file to-title-case.js
	 * @module to-title-case
	 */
	
	/**
	 * Uppercase the first letter of a string.
	 *
	 * @param {string} string
	 *        String to be uppercased
	 *
	 * @return {string}
	 *         The string with an uppercased first letter
	 */
	function toTitleCase(string) {
	  if (typeof string !== 'string') {
	    return string;
	  }
	
	  return string.charAt(0).toUpperCase() + string.slice(1);
	}
	
	/**
	 * Compares the TitleCase versions of the two strings for equality.
	 *
	 * @param {string} str1
	 *        The first string to compare
	 *
	 * @param {string} str2
	 *        The second string to compare
	 *
	 * @return {boolean}
	 *         Whether the TitleCase versions of the strings are equal
	 */
	function titleCaseEquals(str1, str2) {
	  return toTitleCase(str1) === toTitleCase(str2);
	}
	
	/**
	 * @file merge-options.js
	 * @module merge-options
	 */
	
	/**
	 * Deep-merge one or more options objects, recursively merging **only** plain
	 * object properties.
	 *
	 * @param   {Object[]} sources
	 *          One or more objects to merge into a new object.
	 *
	 * @returns {Object}
	 *          A new object that is the merged result of all sources.
	 */
	function mergeOptions() {
	  var result = {};
	
	  for (var _len = arguments.length, sources = Array(_len), _key = 0; _key < _len; _key++) {
	    sources[_key] = arguments[_key];
	  }
	
	  sources.forEach(function (source) {
	    if (!source) {
	      return;
	    }
	
	    each(source, function (value, key) {
	      if (!isPlain(value)) {
	        result[key] = value;
	        return;
	      }
	
	      if (!isPlain(result[key])) {
	        result[key] = {};
	      }
	
	      result[key] = mergeOptions(result[key], value);
	    });
	  });
	
	  return result;
	}
	
	/**
	 * Player Component - Base class for all UI objects
	 *
	 * @file component.js
	 */
	
	/**
	 * Base class for all UI Components.
	 * Components are UI objects which represent both a javascript object and an element
	 * in the DOM. They can be children of other components, and can have
	 * children themselves.
	 *
	 * Components can also use methods from {@link EventTarget}
	 */
	
	var Component = function () {
	
	  /**
	   * A callback that is called when a component is ready. Does not have any
	   * paramters and any callback value will be ignored.
	   *
	   * @callback Component~ReadyCallback
	   * @this Component
	   */
	
	  /**
	   * Creates an instance of this class.
	   *
	   * @param {Player} player
	   *        The `Player` that this class should be attached to.
	   *
	   * @param {Object} [options]
	   *        The key/value store of player options.
	   *
	   * @param {Object[]} [options.children]
	   *        An array of children objects to intialize this component with. Children objects have
	   *        a name property that will be used if more than one component of the same type needs to be
	   *        added.
	   *
	   * @param {Component~ReadyCallback} [ready]
	   *        Function that gets called when the `Component` is ready.
	   */
	  function Component(player, options, ready) {
	    classCallCheck(this, Component);
	
	
	    // The component might be the player itself and we can't pass `this` to super
	    if (!player && this.play) {
	      this.player_ = player = this; // eslint-disable-line
	    } else {
	      this.player_ = player;
	    }
	
	    // Make a copy of prototype.options_ to protect against overriding defaults
	    this.options_ = mergeOptions({}, this.options_);
	
	    // Updated options with supplied options
	    options = this.options_ = mergeOptions(this.options_, options);
	
	    // Get ID from options or options element if one is supplied
	    this.id_ = options.id || options.el && options.el.id;
	
	    // If there was no ID from the options, generate one
	    if (!this.id_) {
	      // Don't require the player ID function in the case of mock players
	      var id = player && player.id && player.id() || 'no_player';
	
	      this.id_ = id + '_component_' + newGUID();
	    }
	
	    this.name_ = options.name || null;
	
	    // Create element if one wasn't provided in options
	    if (options.el) {
	      this.el_ = options.el;
	    } else if (options.createEl !== false) {
	      this.el_ = this.createEl();
	    }
	
	    // if evented is anything except false, we want to mixin in evented
	    if (options.evented !== false) {
	      // Make this an evented object and use `el_`, if available, as its event bus
	      evented(this, { eventBusKey: this.el_ ? 'el_' : null });
	    }
	    stateful(this, this.constructor.defaultState);
	
	    this.children_ = [];
	    this.childIndex_ = {};
	    this.childNameIndex_ = {};
	
	    // Add any child components in options
	    if (options.initChildren !== false) {
	      this.initChildren();
	    }
	
	    this.ready(ready);
	    // Don't want to trigger ready here or it will before init is actually
	    // finished for all children that run this constructor
	
	    if (options.reportTouchActivity !== false) {
	      this.enableTouchActivity();
	    }
	  }
	
	  /**
	   * Dispose of the `Component` and all child components.
	   *
	   * @fires Component#dispose
	   */
	
	
	  Component.prototype.dispose = function dispose() {
	
	    /**
	     * Triggered when a `Component` is disposed.
	     *
	     * @event Component#dispose
	     * @type {EventTarget~Event}
	     *
	     * @property {boolean} [bubbles=false]
	     *           set to false so that the close event does not
	     *           bubble up
	     */
	    this.trigger({ type: 'dispose', bubbles: false });
	
	    // Dispose all children.
	    if (this.children_) {
	      for (var i = this.children_.length - 1; i >= 0; i--) {
	        if (this.children_[i].dispose) {
	          this.children_[i].dispose();
	        }
	      }
	    }
	
	    // Delete child references
	    this.children_ = null;
	    this.childIndex_ = null;
	    this.childNameIndex_ = null;
	
	    if (this.el_) {
	      // Remove element from DOM
	      if (this.el_.parentNode) {
	        this.el_.parentNode.removeChild(this.el_);
	      }
	
	      removeData(this.el_);
	      this.el_ = null;
	    }
	
	    // remove reference to the player after disposing of the element
	    this.player_ = null;
	  };
	
	  /**
	   * Return the {@link Player} that the `Component` has attached to.
	   *
	   * @return {Player}
	   *         The player that this `Component` has attached to.
	   */
	
	
	  Component.prototype.player = function player() {
	    return this.player_;
	  };
	
	  /**
	   * Deep merge of options objects with new options.
	   * > Note: When both `obj` and `options` contain properties whose values are objects.
	   *         The two properties get merged using {@link module:mergeOptions}
	   *
	   * @param {Object} obj
	   *        The object that contains new options.
	   *
	   * @return {Object}
	   *         A new object of `this.options_` and `obj` merged together.
	   *
	   * @deprecated since version 5
	   */
	
	
	  Component.prototype.options = function options(obj) {
	    log$1.warn('this.options() has been deprecated and will be moved to the constructor in 6.0');
	
	    if (!obj) {
	      return this.options_;
	    }
	
	    this.options_ = mergeOptions(this.options_, obj);
	    return this.options_;
	  };
	
	  /**
	   * Get the `Component`s DOM element
	   *
	   * @return {Element}
	   *         The DOM element for this `Component`.
	   */
	
	
	  Component.prototype.el = function el() {
	    return this.el_;
	  };
	
	  /**
	   * Create the `Component`s DOM element.
	   *
	   * @param {string} [tagName]
	   *        Element's DOM node type. e.g. 'div'
	   *
	   * @param {Object} [properties]
	   *        An object of properties that should be set.
	   *
	   * @param {Object} [attributes]
	   *        An object of attributes that should be set.
	   *
	   * @return {Element}
	   *         The element that gets created.
	   */
	
	
	  Component.prototype.createEl = function createEl$$1(tagName, properties, attributes) {
	    return createEl(tagName, properties, attributes);
	  };
	
	  /**
	   * Localize a string given the string in english.
	   *
	   * If tokens are provided, it'll try and run a simple token replacement on the provided string.
	   * The tokens it looks for look like `{1}` with the index being 1-indexed into the tokens array.
	   *
	   * If a `defaultValue` is provided, it'll use that over `string`,
	   * if a value isn't found in provided language files.
	   * This is useful if you want to have a descriptive key for token replacement
	   * but have a succinct localized string and not require `en.json` to be included.
	   *
	   * Currently, it is used for the progress bar timing.
	   * ```js
	   * {
	   *   "progress bar timing: currentTime={1} duration={2}": "{1} of {2}"
	   * }
	   * ```
	   * It is then used like so:
	   * ```js
	   * this.localize('progress bar timing: currentTime={1} duration{2}',
	   *               [this.player_.currentTime(), this.player_.duration()],
	   *               '{1} of {2}');
	   * ```
	   *
	   * Which outputs something like: `01:23 of 24:56`.
	   *
	   *
	   * @param {string} string
	   *        The string to localize and the key to lookup in the language files.
	   * @param {string[]} [tokens]
	   *        If the current item has token replacements, provide the tokens here.
	   * @param {string} [defaultValue]
	   *        Defaults to `string`. Can be a default value to use for token replacement
	   *        if the lookup key is needed to be separate.
	   *
	   * @return {string}
	   *         The localized string or if no localization exists the english string.
	   */
	
	
	  Component.prototype.localize = function localize(string, tokens) {
	    var defaultValue = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : string;
	
	    var code = this.player_.language && this.player_.language();
	    var languages = this.player_.languages && this.player_.languages();
	    var language = languages && languages[code];
	    var primaryCode = code && code.split('-')[0];
	    var primaryLang = languages && languages[primaryCode];
	
	    var localizedString = defaultValue;
	
	    if (language && language[string]) {
	      localizedString = language[string];
	    } else if (primaryLang && primaryLang[string]) {
	      localizedString = primaryLang[string];
	    }
	
	    if (tokens) {
	      localizedString = localizedString.replace(/\{(\d+)\}/g, function (match, index) {
	        var value = tokens[index - 1];
	        var ret = value;
	
	        if (typeof value === 'undefined') {
	          ret = match;
	        }
	
	        return ret;
	      });
	    }
	
	    return localizedString;
	  };
	
	  /**
	   * Return the `Component`s DOM element. This is where children get inserted.
	   * This will usually be the the same as the element returned in {@link Component#el}.
	   *
	   * @return {Element}
	   *         The content element for this `Component`.
	   */
	
	
	  Component.prototype.contentEl = function contentEl() {
	    return this.contentEl_ || this.el_;
	  };
	
	  /**
	   * Get this `Component`s ID
	   *
	   * @return {string}
	   *         The id of this `Component`
	   */
	
	
	  Component.prototype.id = function id() {
	    return this.id_;
	  };
	
	  /**
	   * Get the `Component`s name. The name gets used to reference the `Component`
	   * and is set during registration.
	   *
	   * @return {string}
	   *         The name of this `Component`.
	   */
	
	
	  Component.prototype.name = function name() {
	    return this.name_;
	  };
	
	  /**
	   * Get an array of all child components
	   *
	   * @return {Array}
	   *         The children
	   */
	
	
	  Component.prototype.children = function children() {
	    return this.children_;
	  };
	
	  /**
	   * Returns the child `Component` with the given `id`.
	   *
	   * @param {string} id
	   *        The id of the child `Component` to get.
	   *
	   * @return {Component|undefined}
	   *         The child `Component` with the given `id` or undefined.
	   */
	
	
	  Component.prototype.getChildById = function getChildById(id) {
	    return this.childIndex_[id];
	  };
	
	  /**
	   * Returns the child `Component` with the given `name`.
	   *
	   * @param {string} name
	   *        The name of the child `Component` to get.
	   *
	   * @return {Component|undefined}
	   *         The child `Component` with the given `name` or undefined.
	   */
	
	
	  Component.prototype.getChild = function getChild(name) {
	    if (!name) {
	      return;
	    }
	
	    name = toTitleCase(name);
	
	    return this.childNameIndex_[name];
	  };
	
	  /**
	   * Add a child `Component` inside the current `Component`.
	   *
	   *
	   * @param {string|Component} child
	   *        The name or instance of a child to add.
	   *
	   * @param {Object} [options={}]
	   *        The key/value store of options that will get passed to children of
	   *        the child.
	   *
	   * @param {number} [index=this.children_.length]
	   *        The index to attempt to add a child into.
	   *
	   * @return {Component}
	   *         The `Component` that gets added as a child. When using a string the
	   *         `Component` will get created by this process.
	   */
	
	
	  Component.prototype.addChild = function addChild(child) {
	    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	    var index = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : this.children_.length;
	
	    var component = void 0;
	    var componentName = void 0;
	
	    // If child is a string, create component with options
	    if (typeof child === 'string') {
	      componentName = toTitleCase(child);
	
	      var componentClassName = options.componentClass || componentName;
	
	      // Set name through options
	      options.name = componentName;
	
	      // Create a new object & element for this controls set
	      // If there's no .player_, this is a player
	      var ComponentClass = Component.getComponent(componentClassName);
	
	      if (!ComponentClass) {
	        throw new Error('Component ' + componentClassName + ' does not exist');
	      }
	
	      // data stored directly on the videojs object may be
	      // misidentified as a component to retain
	      // backwards-compatibility with 4.x. check to make sure the
	      // component class can be instantiated.
	      if (typeof ComponentClass !== 'function') {
	        return null;
	      }
	
	      component = new ComponentClass(this.player_ || this, options);
	
	      // child is a component instance
	    } else {
	      component = child;
	    }
	
	    this.children_.splice(index, 0, component);
	
	    if (typeof component.id === 'function') {
	      this.childIndex_[component.id()] = component;
	    }
	
	    // If a name wasn't used to create the component, check if we can use the
	    // name function of the component
	    componentName = componentName || component.name && toTitleCase(component.name());
	
	    if (componentName) {
	      this.childNameIndex_[componentName] = component;
	    }
	
	    // Add the UI object's element to the container div (box)
	    // Having an element is not required
	    if (typeof component.el === 'function' && component.el()) {
	      var childNodes = this.contentEl().children;
	      var refNode = childNodes[index] || null;
	
	      this.contentEl().insertBefore(component.el(), refNode);
	    }
	
	    // Return so it can stored on parent object if desired.
	    return component;
	  };
	
	  /**
	   * Remove a child `Component` from this `Component`s list of children. Also removes
	   * the child `Component`s element from this `Component`s element.
	   *
	   * @param {Component} component
	   *        The child `Component` to remove.
	   */
	
	
	  Component.prototype.removeChild = function removeChild(component) {
	    if (typeof component === 'string') {
	      component = this.getChild(component);
	    }
	
	    if (!component || !this.children_) {
	      return;
	    }
	
	    var childFound = false;
	
	    for (var i = this.children_.length - 1; i >= 0; i--) {
	      if (this.children_[i] === component) {
	        childFound = true;
	        this.children_.splice(i, 1);
	        break;
	      }
	    }
	
	    if (!childFound) {
	      return;
	    }
	
	    this.childIndex_[component.id()] = null;
	    this.childNameIndex_[component.name()] = null;
	
	    var compEl = component.el();
	
	    if (compEl && compEl.parentNode === this.contentEl()) {
	      this.contentEl().removeChild(component.el());
	    }
	  };
	
	  /**
	   * Add and initialize default child `Component`s based upon options.
	   */
	
	
	  Component.prototype.initChildren = function initChildren() {
	    var _this = this;
	
	    var children = this.options_.children;
	
	    if (children) {
	      // `this` is `parent`
	      var parentOptions = this.options_;
	
	      var handleAdd = function handleAdd(child) {
	        var name = child.name;
	        var opts = child.opts;
	
	        // Allow options for children to be set at the parent options
	        // e.g. videojs(id, { controlBar: false });
	        // instead of videojs(id, { children: { controlBar: false });
	        if (parentOptions[name] !== undefined) {
	          opts = parentOptions[name];
	        }
	
	        // Allow for disabling default components
	        // e.g. options['children']['posterImage'] = false
	        if (opts === false) {
	          return;
	        }
	
	        // Allow options to be passed as a simple boolean if no configuration
	        // is necessary.
	        if (opts === true) {
	          opts = {};
	        }
	
	        // We also want to pass the original player options
	        // to each component as well so they don't need to
	        // reach back into the player for options later.
	        opts.playerOptions = _this.options_.playerOptions;
	
	        // Create and add the child component.
	        // Add a direct reference to the child by name on the parent instance.
	        // If two of the same component are used, different names should be supplied
	        // for each
	        var newChild = _this.addChild(name, opts);
	
	        if (newChild) {
	          _this[name] = newChild;
	        }
	      };
	
	      // Allow for an array of children details to passed in the options
	      var workingChildren = void 0;
	      var Tech = Component.getComponent('Tech');
	
	      if (Array.isArray(children)) {
	        workingChildren = children;
	      } else {
	        workingChildren = Object.keys(children);
	      }
	
	      workingChildren
	      // children that are in this.options_ but also in workingChildren  would
	      // give us extra children we do not want. So, we want to filter them out.
	      .concat(Object.keys(this.options_).filter(function (child) {
	        return !workingChildren.some(function (wchild) {
	          if (typeof wchild === 'string') {
	            return child === wchild;
	          }
	          return child === wchild.name;
	        });
	      })).map(function (child) {
	        var name = void 0;
	        var opts = void 0;
	
	        if (typeof child === 'string') {
	          name = child;
	          opts = children[name] || _this.options_[name] || {};
	        } else {
	          name = child.name;
	          opts = child;
	        }
	
	        return { name: name, opts: opts };
	      }).filter(function (child) {
	        // we have to make sure that child.name isn't in the techOrder since
	        // techs are registerd as Components but can't aren't compatible
	        // See https://github.com/videojs/video.js/issues/2772
	        var c = Component.getComponent(child.opts.componentClass || toTitleCase(child.name));
	
	        return c && !Tech.isTech(c);
	      }).forEach(handleAdd);
	    }
	  };
	
	  /**
	   * Builds the default DOM class name. Should be overriden by sub-components.
	   *
	   * @return {string}
	   *         The DOM class name for this object.
	   *
	   * @abstract
	   */
	
	
	  Component.prototype.buildCSSClass = function buildCSSClass() {
	    // Child classes can include a function that does:
	    // return 'CLASS NAME' + this._super();
	    return '';
	  };
	
	  /**
	   * Bind a listener to the component's ready state.
	   * Different from event listeners in that if the ready event has already happened
	   * it will trigger the function immediately.
	   *
	   * @return {Component}
	   *         Returns itself; method can be chained.
	   */
	
	
	  Component.prototype.ready = function ready(fn) {
	    var sync = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	
	    if (!fn) {
	      return;
	    }
	
	    if (!this.isReady_) {
	      this.readyQueue_ = this.readyQueue_ || [];
	      this.readyQueue_.push(fn);
	      return;
	    }
	
	    if (sync) {
	      fn.call(this);
	    } else {
	      // Call the function asynchronously by default for consistency
	      this.setTimeout(fn, 1);
	    }
	  };
	
	  /**
	   * Trigger all the ready listeners for this `Component`.
	   *
	   * @fires Component#ready
	   */
	
	
	  Component.prototype.triggerReady = function triggerReady() {
	    this.isReady_ = true;
	
	    // Ensure ready is triggered asynchronously
	    this.setTimeout(function () {
	      var readyQueue = this.readyQueue_;
	
	      // Reset Ready Queue
	      this.readyQueue_ = [];
	
	      if (readyQueue && readyQueue.length > 0) {
	        readyQueue.forEach(function (fn) {
	          fn.call(this);
	        }, this);
	      }
	
	      // Allow for using event listeners also
	      /**
	       * Triggered when a `Component` is ready.
	       *
	       * @event Component#ready
	       * @type {EventTarget~Event}
	       */
	      this.trigger('ready');
	    }, 1);
	  };
	
	  /**
	   * Find a single DOM element matching a `selector`. This can be within the `Component`s
	   * `contentEl()` or another custom context.
	   *
	   * @param {string} selector
	   *        A valid CSS selector, which will be passed to `querySelector`.
	   *
	   * @param {Element|string} [context=this.contentEl()]
	   *        A DOM element within which to query. Can also be a selector string in
	   *        which case the first matching element will get used as context. If
	   *        missing `this.contentEl()` gets used. If  `this.contentEl()` returns
	   *        nothing it falls back to `document`.
	   *
	   * @return {Element|null}
	   *         the dom element that was found, or null
	   *
	   * @see [Information on CSS Selectors](https://developer.mozilla.org/en-US/docs/Web/Guide/CSS/Getting_Started/Selectors)
	   */
	
	
	  Component.prototype.$ = function $$$1(selector, context) {
	    return $(selector, context || this.contentEl());
	  };
	
	  /**
	   * Finds all DOM element matching a `selector`. This can be within the `Component`s
	   * `contentEl()` or another custom context.
	   *
	   * @param {string} selector
	   *        A valid CSS selector, which will be passed to `querySelectorAll`.
	   *
	   * @param {Element|string} [context=this.contentEl()]
	   *        A DOM element within which to query. Can also be a selector string in
	   *        which case the first matching element will get used as context. If
	   *        missing `this.contentEl()` gets used. If  `this.contentEl()` returns
	   *        nothing it falls back to `document`.
	   *
	   * @return {NodeList}
	   *         a list of dom elements that were found
	   *
	   * @see [Information on CSS Selectors](https://developer.mozilla.org/en-US/docs/Web/Guide/CSS/Getting_Started/Selectors)
	   */
	
	
	  Component.prototype.$$ = function $$$$1(selector, context) {
	    return $$(selector, context || this.contentEl());
	  };
	
	  /**
	   * Check if a component's element has a CSS class name.
	   *
	   * @param {string} classToCheck
	   *        CSS class name to check.
	   *
	   * @return {boolean}
	   *         - True if the `Component` has the class.
	   *         - False if the `Component` does not have the class`
	   */
	
	
	  Component.prototype.hasClass = function hasClass$$1(classToCheck) {
	    return hasClass(this.el_, classToCheck);
	  };
	
	  /**
	   * Add a CSS class name to the `Component`s element.
	   *
	   * @param {string} classToAdd
	   *        CSS class name to add
	   */
	
	
	  Component.prototype.addClass = function addClass$$1(classToAdd) {
	    addClass(this.el_, classToAdd);
	  };
	
	  /**
	   * Remove a CSS class name from the `Component`s element.
	   *
	   * @param {string} classToRemove
	   *        CSS class name to remove
	   */
	
	
	  Component.prototype.removeClass = function removeClass$$1(classToRemove) {
	    removeClass(this.el_, classToRemove);
	  };
	
	  /**
	   * Add or remove a CSS class name from the component's element.
	   * - `classToToggle` gets added when {@link Component#hasClass} would return false.
	   * - `classToToggle` gets removed when {@link Component#hasClass} would return true.
	   *
	   * @param  {string} classToToggle
	   *         The class to add or remove based on (@link Component#hasClass}
	   *
	   * @param  {boolean|Dom~predicate} [predicate]
	   *         An {@link Dom~predicate} function or a boolean
	   */
	
	
	  Component.prototype.toggleClass = function toggleClass$$1(classToToggle, predicate) {
	    toggleClass(this.el_, classToToggle, predicate);
	  };
	
	  /**
	   * Show the `Component`s element if it is hidden by removing the
	   * 'vjs-hidden' class name from it.
	   */
	
	
	  Component.prototype.show = function show() {
	    this.removeClass('vjs-hidden');
	  };
	
	  /**
	   * Hide the `Component`s element if it is currently showing by adding the
	   * 'vjs-hidden` class name to it.
	   */
	
	
	  Component.prototype.hide = function hide() {
	    this.addClass('vjs-hidden');
	  };
	
	  /**
	   * Lock a `Component`s element in its visible state by adding the 'vjs-lock-showing'
	   * class name to it. Used during fadeIn/fadeOut.
	   *
	   * @private
	   */
	
	
	  Component.prototype.lockShowing = function lockShowing() {
	    this.addClass('vjs-lock-showing');
	  };
	
	  /**
	   * Unlock a `Component`s element from its visible state by removing the 'vjs-lock-showing'
	   * class name from it. Used during fadeIn/fadeOut.
	   *
	   * @private
	   */
	
	
	  Component.prototype.unlockShowing = function unlockShowing() {
	    this.removeClass('vjs-lock-showing');
	  };
	
	  /**
	   * Get the value of an attribute on the `Component`s element.
	   *
	   * @param {string} attribute
	   *        Name of the attribute to get the value from.
	   *
	   * @return {string|null}
	   *         - The value of the attribute that was asked for.
	   *         - Can be an empty string on some browsers if the attribute does not exist
	   *           or has no value
	   *         - Most browsers will return null if the attibute does not exist or has
	   *           no value.
	   *
	   * @see [DOM API]{@link https://developer.mozilla.org/en-US/docs/Web/API/Element/getAttribute}
	   */
	
	
	  Component.prototype.getAttribute = function getAttribute$$1(attribute) {
	    return getAttribute(this.el_, attribute);
	  };
	
	  /**
	   * Set the value of an attribute on the `Component`'s element
	   *
	   * @param {string} attribute
	   *        Name of the attribute to set.
	   *
	   * @param {string} value
	   *        Value to set the attribute to.
	   *
	   * @see [DOM API]{@link https://developer.mozilla.org/en-US/docs/Web/API/Element/setAttribute}
	   */
	
	
	  Component.prototype.setAttribute = function setAttribute$$1(attribute, value) {
	    setAttribute(this.el_, attribute, value);
	  };
	
	  /**
	   * Remove an attribute from the `Component`s element.
	   *
	   * @param {string} attribute
	   *        Name of the attribute to remove.
	   *
	   * @see [DOM API]{@link https://developer.mozilla.org/en-US/docs/Web/API/Element/removeAttribute}
	   */
	
	
	  Component.prototype.removeAttribute = function removeAttribute$$1(attribute) {
	    removeAttribute(this.el_, attribute);
	  };
	
	  /**
	   * Get or set the width of the component based upon the CSS styles.
	   * See {@link Component#dimension} for more detailed information.
	   *
	   * @param {number|string} [num]
	   *        The width that you want to set postfixed with '%', 'px' or nothing.
	   *
	   * @param {boolean} [skipListeners]
	   *        Skip the componentresize event trigger
	   *
	   * @return {number|string}
	   *         The width when getting, zero if there is no width. Can be a string
	   *           postpixed with '%' or 'px'.
	   */
	
	
	  Component.prototype.width = function width(num, skipListeners) {
	    return this.dimension('width', num, skipListeners);
	  };
	
	  /**
	   * Get or set the height of the component based upon the CSS styles.
	   * See {@link Component#dimension} for more detailed information.
	   *
	   * @param {number|string} [num]
	   *        The height that you want to set postfixed with '%', 'px' or nothing.
	   *
	   * @param {boolean} [skipListeners]
	   *        Skip the componentresize event trigger
	   *
	   * @return {number|string}
	   *         The width when getting, zero if there is no width. Can be a string
	   *         postpixed with '%' or 'px'.
	   */
	
	
	  Component.prototype.height = function height(num, skipListeners) {
	    return this.dimension('height', num, skipListeners);
	  };
	
	  /**
	   * Set both the width and height of the `Component` element at the same time.
	   *
	   * @param  {number|string} width
	   *         Width to set the `Component`s element to.
	   *
	   * @param  {number|string} height
	   *         Height to set the `Component`s element to.
	   */
	
	
	  Component.prototype.dimensions = function dimensions(width, height) {
	    // Skip componentresize listeners on width for optimization
	    this.width(width, true);
	    this.height(height);
	  };
	
	  /**
	   * Get or set width or height of the `Component` element. This is the shared code
	   * for the {@link Component#width} and {@link Component#height}.
	   *
	   * Things to know:
	   * - If the width or height in an number this will return the number postfixed with 'px'.
	   * - If the width/height is a percent this will return the percent postfixed with '%'
	   * - Hidden elements have a width of 0 with `window.getComputedStyle`. This function
	   *   defaults to the `Component`s `style.width` and falls back to `window.getComputedStyle`.
	   *   See [this]{@link http://www.foliotek.com/devblog/getting-the-width-of-a-hidden-element-with-jquery-using-width/}
	   *   for more information
	   * - If you want the computed style of the component, use {@link Component#currentWidth}
	   *   and {@link {Component#currentHeight}
	   *
	   * @fires Component#componentresize
	   *
	   * @param {string} widthOrHeight
	   8        'width' or 'height'
	   *
	   * @param  {number|string} [num]
	   8         New dimension
	   *
	   * @param  {boolean} [skipListeners]
	   *         Skip componentresize event trigger
	   *
	   * @return {number}
	   *         The dimension when getting or 0 if unset
	   */
	
	
	  Component.prototype.dimension = function dimension(widthOrHeight, num, skipListeners) {
	    if (num !== undefined) {
	      // Set to zero if null or literally NaN (NaN !== NaN)
	      if (num === null || num !== num) {
	        num = 0;
	      }
	
	      // Check if using css width/height (% or px) and adjust
	      if (('' + num).indexOf('%') !== -1 || ('' + num).indexOf('px') !== -1) {
	        this.el_.style[widthOrHeight] = num;
	      } else if (num === 'auto') {
	        this.el_.style[widthOrHeight] = '';
	      } else {
	        this.el_.style[widthOrHeight] = num + 'px';
	      }
	
	      // skipListeners allows us to avoid triggering the resize event when setting both width and height
	      if (!skipListeners) {
	        /**
	         * Triggered when a component is resized.
	         *
	         * @event Component#componentresize
	         * @type {EventTarget~Event}
	         */
	        this.trigger('componentresize');
	      }
	
	      return;
	    }
	
	    // Not setting a value, so getting it
	    // Make sure element exists
	    if (!this.el_) {
	      return 0;
	    }
	
	    // Get dimension value from style
	    var val = this.el_.style[widthOrHeight];
	    var pxIndex = val.indexOf('px');
	
	    if (pxIndex !== -1) {
	      // Return the pixel value with no 'px'
	      return parseInt(val.slice(0, pxIndex), 10);
	    }
	
	    // No px so using % or no style was set, so falling back to offsetWidth/height
	    // If component has display:none, offset will return 0
	    // TODO: handle display:none and no dimension style using px
	    return parseInt(this.el_['offset' + toTitleCase(widthOrHeight)], 10);
	  };
	
	  /**
	   * Get the width or the height of the `Component` elements computed style. Uses
	   * `window.getComputedStyle`.
	   *
	   * @param {string} widthOrHeight
	   *        A string containing 'width' or 'height'. Whichever one you want to get.
	   *
	   * @return {number}
	   *         The dimension that gets asked for or 0 if nothing was set
	   *         for that dimension.
	   */
	
	
	  Component.prototype.currentDimension = function currentDimension(widthOrHeight) {
	    var computedWidthOrHeight = 0;
	
	    if (widthOrHeight !== 'width' && widthOrHeight !== 'height') {
	      throw new Error('currentDimension only accepts width or height value');
	    }
	
	    if (typeof window$1.getComputedStyle === 'function') {
	      var computedStyle = window$1.getComputedStyle(this.el_);
	
	      computedWidthOrHeight = computedStyle.getPropertyValue(widthOrHeight) || computedStyle[widthOrHeight];
	    }
	
	    // remove 'px' from variable and parse as integer
	    computedWidthOrHeight = parseFloat(computedWidthOrHeight);
	
	    // if the computed value is still 0, it's possible that the browser is lying
	    // and we want to check the offset values.
	    // This code also runs wherever getComputedStyle doesn't exist.
	    if (computedWidthOrHeight === 0) {
	      var rule = 'offset' + toTitleCase(widthOrHeight);
	
	      computedWidthOrHeight = this.el_[rule];
	    }
	
	    return computedWidthOrHeight;
	  };
	
	  /**
	   * An object that contains width and height values of the `Component`s
	   * computed style. Uses `window.getComputedStyle`.
	   *
	   * @typedef {Object} Component~DimensionObject
	   *
	   * @property {number} width
	   *           The width of the `Component`s computed style.
	   *
	   * @property {number} height
	   *           The height of the `Component`s computed style.
	   */
	
	  /**
	   * Get an object that contains width and height values of the `Component`s
	   * computed style.
	   *
	   * @return {Component~DimensionObject}
	   *         The dimensions of the components element
	   */
	
	
	  Component.prototype.currentDimensions = function currentDimensions() {
	    return {
	      width: this.currentDimension('width'),
	      height: this.currentDimension('height')
	    };
	  };
	
	  /**
	   * Get the width of the `Component`s computed style. Uses `window.getComputedStyle`.
	   *
	   * @return {number} width
	   *           The width of the `Component`s computed style.
	   */
	
	
	  Component.prototype.currentWidth = function currentWidth() {
	    return this.currentDimension('width');
	  };
	
	  /**
	   * Get the height of the `Component`s computed style. Uses `window.getComputedStyle`.
	   *
	   * @return {number} height
	   *           The height of the `Component`s computed style.
	   */
	
	
	  Component.prototype.currentHeight = function currentHeight() {
	    return this.currentDimension('height');
	  };
	
	  /**
	   * Set the focus to this component
	   */
	
	
	  Component.prototype.focus = function focus() {
	    this.el_.focus();
	  };
	
	  /**
	   * Remove the focus from this component
	   */
	
	
	  Component.prototype.blur = function blur() {
	    this.el_.blur();
	  };
	
	  /**
	   * Emit a 'tap' events when touch event support gets detected. This gets used to
	   * support toggling the controls through a tap on the video. They get enabled
	   * because every sub-component would have extra overhead otherwise.
	   *
	   * @private
	   * @fires Component#tap
	   * @listens Component#touchstart
	   * @listens Component#touchmove
	   * @listens Component#touchleave
	   * @listens Component#touchcancel
	   * @listens Component#touchend
	    */
	
	
	  Component.prototype.emitTapEvents = function emitTapEvents() {
	    // Track the start time so we can determine how long the touch lasted
	    var touchStart = 0;
	    var firstTouch = null;
	
	    // Maximum movement allowed during a touch event to still be considered a tap
	    // Other popular libs use anywhere from 2 (hammer.js) to 15,
	    // so 10 seems like a nice, round number.
	    var tapMovementThreshold = 10;
	
	    // The maximum length a touch can be while still being considered a tap
	    var touchTimeThreshold = 200;
	
	    var couldBeTap = void 0;
	
	    this.on('touchstart', function (event) {
	      // If more than one finger, don't consider treating this as a click
	      if (event.touches.length === 1) {
	        // Copy pageX/pageY from the object
	        firstTouch = {
	          pageX: event.touches[0].pageX,
	          pageY: event.touches[0].pageY
	        };
	        // Record start time so we can detect a tap vs. "touch and hold"
	        touchStart = new Date().getTime();
	        // Reset couldBeTap tracking
	        couldBeTap = true;
	      }
	    });
	
	    this.on('touchmove', function (event) {
	      // If more than one finger, don't consider treating this as a click
	      if (event.touches.length > 1) {
	        couldBeTap = false;
	      } else if (firstTouch) {
	        // Some devices will throw touchmoves for all but the slightest of taps.
	        // So, if we moved only a small distance, this could still be a tap
	        var xdiff = event.touches[0].pageX - firstTouch.pageX;
	        var ydiff = event.touches[0].pageY - firstTouch.pageY;
	        var touchDistance = Math.sqrt(xdiff * xdiff + ydiff * ydiff);
	
	        if (touchDistance > tapMovementThreshold) {
	          couldBeTap = false;
	        }
	      }
	    });
	
	    var noTap = function noTap() {
	      couldBeTap = false;
	    };
	
	    // TODO: Listen to the original target. http://youtu.be/DujfpXOKUp8?t=13m8s
	    this.on('touchleave', noTap);
	    this.on('touchcancel', noTap);
	
	    // When the touch ends, measure how long it took and trigger the appropriate
	    // event
	    this.on('touchend', function (event) {
	      firstTouch = null;
	      // Proceed only if the touchmove/leave/cancel event didn't happen
	      if (couldBeTap === true) {
	        // Measure how long the touch lasted
	        var touchTime = new Date().getTime() - touchStart;
	
	        // Make sure the touch was less than the threshold to be considered a tap
	        if (touchTime < touchTimeThreshold) {
	          // Don't let browser turn this into a click
	          event.preventDefault();
	          /**
	           * Triggered when a `Component` is tapped.
	           *
	           * @event Component#tap
	           * @type {EventTarget~Event}
	           */
	          this.trigger('tap');
	          // It may be good to copy the touchend event object and change the
	          // type to tap, if the other event properties aren't exact after
	          // Events.fixEvent runs (e.g. event.target)
	        }
	      }
	    });
	  };
	
	  /**
	   * This function reports user activity whenever touch events happen. This can get
	   * turned off by any sub-components that wants touch events to act another way.
	   *
	   * Report user touch activity when touch events occur. User activity gets used to
	   * determine when controls should show/hide. It is simple when it comes to mouse
	   * events, because any mouse event should show the controls. So we capture mouse
	   * events that bubble up to the player and report activity when that happens.
	   * With touch events it isn't as easy as `touchstart` and `touchend` toggle player
	   * controls. So touch events can't help us at the player level either.
	   *
	   * User activity gets checked asynchronously. So what could happen is a tap event
	   * on the video turns the controls off. Then the `touchend` event bubbles up to
	   * the player. Which, if it reported user activity, would turn the controls right
	   * back on. We also don't want to completely block touch events from bubbling up.
	   * Furthermore a `touchmove` event and anything other than a tap, should not turn
	   * controls back on.
	   *
	   * @listens Component#touchstart
	   * @listens Component#touchmove
	   * @listens Component#touchend
	   * @listens Component#touchcancel
	   */
	
	
	  Component.prototype.enableTouchActivity = function enableTouchActivity() {
	    // Don't continue if the root player doesn't support reporting user activity
	    if (!this.player() || !this.player().reportUserActivity) {
	      return;
	    }
	
	    // listener for reporting that the user is active
	    var report = bind(this.player(), this.player().reportUserActivity);
	
	    var touchHolding = void 0;
	
	    this.on('touchstart', function () {
	      report();
	      // For as long as the they are touching the device or have their mouse down,
	      // we consider them active even if they're not moving their finger or mouse.
	      // So we want to continue to update that they are active
	      this.clearInterval(touchHolding);
	      // report at the same interval as activityCheck
	      touchHolding = this.setInterval(report, 250);
	    });
	
	    var touchEnd = function touchEnd(event) {
	      report();
	      // stop the interval that maintains activity if the touch is holding
	      this.clearInterval(touchHolding);
	    };
	
	    this.on('touchmove', report);
	    this.on('touchend', touchEnd);
	    this.on('touchcancel', touchEnd);
	  };
	
	  /**
	   * A callback that has no parameters and is bound into `Component`s context.
	   *
	   * @callback Component~GenericCallback
	   * @this Component
	   */
	
	  /**
	   * Creates a function that runs after an `x` millisecond timeout. This function is a
	   * wrapper around `window.setTimeout`. There are a few reasons to use this one
	   * instead though:
	   * 1. It gets cleared via  {@link Component#clearTimeout} when
	   *    {@link Component#dispose} gets called.
	   * 2. The function callback will gets turned into a {@link Component~GenericCallback}
	   *
	   * > Note: You can't use `window.clearTimeout` on the id returned by this function. This
	   *         will cause its dispose listener not to get cleaned up! Please use
	   *         {@link Component#clearTimeout} or {@link Component#dispose} instead.
	   *
	   * @param {Component~GenericCallback} fn
	   *        The function that will be run after `timeout`.
	   *
	   * @param {number} timeout
	   *        Timeout in milliseconds to delay before executing the specified function.
	   *
	   * @return {number}
	   *         Returns a timeout ID that gets used to identify the timeout. It can also
	   *         get used in {@link Component#clearTimeout} to clear the timeout that
	   *         was set.
	   *
	   * @listens Component#dispose
	   * @see [Similar to]{@link https://developer.mozilla.org/en-US/docs/Web/API/WindowTimers/setTimeout}
	   */
	
	
	  Component.prototype.setTimeout = function setTimeout(fn, timeout) {
	    var _this2 = this;
	
	    // declare as variables so they are properly available in timeout function
	    // eslint-disable-next-line
	    var timeoutId, disposeFn;
	
	    fn = bind(this, fn);
	
	    timeoutId = window$1.setTimeout(function () {
	      _this2.off('dispose', disposeFn);
	      fn();
	    }, timeout);
	
	    disposeFn = function disposeFn() {
	      return _this2.clearTimeout(timeoutId);
	    };
	
	    disposeFn.guid = 'vjs-timeout-' + timeoutId;
	
	    this.on('dispose', disposeFn);
	
	    return timeoutId;
	  };
	
	  /**
	   * Clears a timeout that gets created via `window.setTimeout` or
	   * {@link Component#setTimeout}. If you set a timeout via {@link Component#setTimeout}
	   * use this function instead of `window.clearTimout`. If you don't your dispose
	   * listener will not get cleaned up until {@link Component#dispose}!
	   *
	   * @param {number} timeoutId
	   *        The id of the timeout to clear. The return value of
	   *        {@link Component#setTimeout} or `window.setTimeout`.
	   *
	   * @return {number}
	   *         Returns the timeout id that was cleared.
	   *
	   * @see [Similar to]{@link https://developer.mozilla.org/en-US/docs/Web/API/WindowTimers/clearTimeout}
	   */
	
	
	  Component.prototype.clearTimeout = function clearTimeout(timeoutId) {
	    window$1.clearTimeout(timeoutId);
	
	    var disposeFn = function disposeFn() {};
	
	    disposeFn.guid = 'vjs-timeout-' + timeoutId;
	
	    this.off('dispose', disposeFn);
	
	    return timeoutId;
	  };
	
	  /**
	   * Creates a function that gets run every `x` milliseconds. This function is a wrapper
	   * around `window.setInterval`. There are a few reasons to use this one instead though.
	   * 1. It gets cleared via  {@link Component#clearInterval} when
	   *    {@link Component#dispose} gets called.
	   * 2. The function callback will be a {@link Component~GenericCallback}
	   *
	   * @param {Component~GenericCallback} fn
	   *        The function to run every `x` seconds.
	   *
	   * @param {number} interval
	   *        Execute the specified function every `x` milliseconds.
	   *
	   * @return {number}
	   *         Returns an id that can be used to identify the interval. It can also be be used in
	   *         {@link Component#clearInterval} to clear the interval.
	   *
	   * @listens Component#dispose
	   * @see [Similar to]{@link https://developer.mozilla.org/en-US/docs/Web/API/WindowTimers/setInterval}
	   */
	
	
	  Component.prototype.setInterval = function setInterval(fn, interval) {
	    var _this3 = this;
	
	    fn = bind(this, fn);
	
	    var intervalId = window$1.setInterval(fn, interval);
	
	    var disposeFn = function disposeFn() {
	      return _this3.clearInterval(intervalId);
	    };
	
	    disposeFn.guid = 'vjs-interval-' + intervalId;
	
	    this.on('dispose', disposeFn);
	
	    return intervalId;
	  };
	
	  /**
	   * Clears an interval that gets created via `window.setInterval` or
	   * {@link Component#setInterval}. If you set an inteval via {@link Component#setInterval}
	   * use this function instead of `window.clearInterval`. If you don't your dispose
	   * listener will not get cleaned up until {@link Component#dispose}!
	   *
	   * @param {number} intervalId
	   *        The id of the interval to clear. The return value of
	   *        {@link Component#setInterval} or `window.setInterval`.
	   *
	   * @return {number}
	   *         Returns the interval id that was cleared.
	   *
	   * @see [Similar to]{@link https://developer.mozilla.org/en-US/docs/Web/API/WindowTimers/clearInterval}
	   */
	
	
	  Component.prototype.clearInterval = function clearInterval(intervalId) {
	    window$1.clearInterval(intervalId);
	
	    var disposeFn = function disposeFn() {};
	
	    disposeFn.guid = 'vjs-interval-' + intervalId;
	
	    this.off('dispose', disposeFn);
	
	    return intervalId;
	  };
	
	  /**
	   * Queues up a callback to be passed to requestAnimationFrame (rAF), but
	   * with a few extra bonuses:
	   *
	   * - Supports browsers that do not support rAF by falling back to
	   *   {@link Component#setTimeout}.
	   *
	   * - The callback is turned into a {@link Component~GenericCallback} (i.e.
	   *   bound to the component).
	   *
	   * - Automatic cancellation of the rAF callback is handled if the component
	   *   is disposed before it is called.
	   *
	   * @param  {Component~GenericCallback} fn
	   *         A function that will be bound to this component and executed just
	   *         before the browser's next repaint.
	   *
	   * @return {number}
	   *         Returns an rAF ID that gets used to identify the timeout. It can
	   *         also be used in {@link Component#cancelAnimationFrame} to cancel
	   *         the animation frame callback.
	   *
	   * @listens Component#dispose
	   * @see [Similar to]{@link https://developer.mozilla.org/en-US/docs/Web/API/window/requestAnimationFrame}
	   */
	
	
	  Component.prototype.requestAnimationFrame = function requestAnimationFrame(fn) {
	    var _this4 = this;
	
	    // declare as variables so they are properly available in rAF function
	    // eslint-disable-next-line
	    var id, disposeFn;
	
	    if (this.supportsRaf_) {
	      fn = bind(this, fn);
	
	      id = window$1.requestAnimationFrame(function () {
	        _this4.off('dispose', disposeFn);
	        fn();
	      });
	
	      disposeFn = function disposeFn() {
	        return _this4.cancelAnimationFrame(id);
	      };
	
	      disposeFn.guid = 'vjs-raf-' + id;
	      this.on('dispose', disposeFn);
	
	      return id;
	    }
	
	    // Fall back to using a timer.
	    return this.setTimeout(fn, 1000 / 60);
	  };
	
	  /**
	   * Cancels a queued callback passed to {@link Component#requestAnimationFrame}
	   * (rAF).
	   *
	   * If you queue an rAF callback via {@link Component#requestAnimationFrame},
	   * use this function instead of `window.cancelAnimationFrame`. If you don't,
	   * your dispose listener will not get cleaned up until {@link Component#dispose}!
	   *
	   * @param {number} id
	   *        The rAF ID to clear. The return value of {@link Component#requestAnimationFrame}.
	   *
	   * @return {number}
	   *         Returns the rAF ID that was cleared.
	   *
	   * @see [Similar to]{@link https://developer.mozilla.org/en-US/docs/Web/API/window/cancelAnimationFrame}
	   */
	
	
	  Component.prototype.cancelAnimationFrame = function cancelAnimationFrame(id) {
	    if (this.supportsRaf_) {
	      window$1.cancelAnimationFrame(id);
	
	      var disposeFn = function disposeFn() {};
	
	      disposeFn.guid = 'vjs-raf-' + id;
	
	      this.off('dispose', disposeFn);
	
	      return id;
	    }
	
	    // Fall back to using a timer.
	    return this.clearTimeout(id);
	  };
	
	  /**
	   * Register a `Component` with `videojs` given the name and the component.
	   *
	   * > NOTE: {@link Tech}s should not be registered as a `Component`. {@link Tech}s
	   *         should be registered using {@link Tech.registerTech} or
	   *         {@link videojs:videojs.registerTech}.
	   *
	   * > NOTE: This function can also be seen on videojs as
	   *         {@link videojs:videojs.registerComponent}.
	   *
	   * @param {string} name
	   *        The name of the `Component` to register.
	   *
	   * @param {Component} ComponentToRegister
	   *        The `Component` class to register.
	   *
	   * @return {Component}
	   *         The `Component` that was registered.
	   */
	
	
	  Component.registerComponent = function registerComponent(name, ComponentToRegister) {
	    if (typeof name !== 'string' || !name) {
	      throw new Error('Illegal component name, "' + name + '"; must be a non-empty string.');
	    }
	
	    var Tech = Component.getComponent('Tech');
	
	    // We need to make sure this check is only done if Tech has been registered.
	    var isTech = Tech && Tech.isTech(ComponentToRegister);
	    var isComp = Component === ComponentToRegister || Component.prototype.isPrototypeOf(ComponentToRegister.prototype);
	
	    if (isTech || !isComp) {
	      var reason = void 0;
	
	      if (isTech) {
	        reason = 'techs must be registered using Tech.registerTech()';
	      } else {
	        reason = 'must be a Component subclass';
	      }
	
	      throw new Error('Illegal component, "' + name + '"; ' + reason + '.');
	    }
	
	    name = toTitleCase(name);
	
	    if (!Component.components_) {
	      Component.components_ = {};
	    }
	
	    var Player = Component.getComponent('Player');
	
	    if (name === 'Player' && Player && Player.players) {
	      var players = Player.players;
	      var playerNames = Object.keys(players);
	
	      // If we have players that were disposed, then their name will still be
	      // in Players.players. So, we must loop through and verify that the value
	      // for each item is not null. This allows registration of the Player component
	      // after all players have been disposed or before any were created.
	      if (players && playerNames.length > 0 && playerNames.map(function (pname) {
	        return players[pname];
	      }).every(Boolean)) {
	        throw new Error('Can not register Player component after player has been created.');
	      }
	    }
	
	    Component.components_[name] = ComponentToRegister;
	
	    return ComponentToRegister;
	  };
	
	  /**
	   * Get a `Component` based on the name it was registered with.
	   *
	   * @param {string} name
	   *        The Name of the component to get.
	   *
	   * @return {Component}
	   *         The `Component` that got registered under the given name.
	   *
	   * @deprecated In `videojs` 6 this will not return `Component`s that were not
	   *             registered using {@link Component.registerComponent}. Currently we
	   *             check the global `videojs` object for a `Component` name and
	   *             return that if it exists.
	   */
	
	
	  Component.getComponent = function getComponent(name) {
	    if (!name) {
	      return;
	    }
	
	    name = toTitleCase(name);
	
	    if (Component.components_ && Component.components_[name]) {
	      return Component.components_[name];
	    }
	  };
	
	  return Component;
	}();
	
	/**
	 * Whether or not this component supports `requestAnimationFrame`.
	 *
	 * This is exposed primarily for testing purposes.
	 *
	 * @private
	 * @type {Boolean}
	 */
	
	
	Component.prototype.supportsRaf_ = typeof window$1.requestAnimationFrame === 'function' && typeof window$1.cancelAnimationFrame === 'function';
	
	Component.registerComponent('Component', Component);
	
	/**
	 * @file browser.js
	 * @module browser
	 */
	
	var USER_AGENT = window$1.navigator && window$1.navigator.userAgent || '';
	var webkitVersionMap = /AppleWebKit\/([\d.]+)/i.exec(USER_AGENT);
	var appleWebkitVersion = webkitVersionMap ? parseFloat(webkitVersionMap.pop()) : null;
	
	/*
	 * Device is an iPhone
	 *
	 * @type {Boolean}
	 * @constant
	 * @private
	 */
	var IS_IPAD = /iPad/i.test(USER_AGENT);
	
	// The Facebook app's UIWebView identifies as both an iPhone and iPad, so
	// to identify iPhones, we need to exclude iPads.
	// http://artsy.github.io/blog/2012/10/18/the-perils-of-ios-user-agent-sniffing/
	var IS_IPHONE = /iPhone/i.test(USER_AGENT) && !IS_IPAD;
	var IS_IPOD = /iPod/i.test(USER_AGENT);
	var IS_IOS = IS_IPHONE || IS_IPAD || IS_IPOD;
	
	var IOS_VERSION = function () {
	  var match = USER_AGENT.match(/OS (\d+)_/i);
	
	  if (match && match[1]) {
	    return match[1];
	  }
	  return null;
	}();
	
	var IS_ANDROID = /Android/i.test(USER_AGENT);
	var ANDROID_VERSION = function () {
	  // This matches Android Major.Minor.Patch versions
	  // ANDROID_VERSION is Major.Minor as a Number, if Minor isn't available, then only Major is returned
	  var match = USER_AGENT.match(/Android (\d+)(?:\.(\d+))?(?:\.(\d+))*/i);
	
	  if (!match) {
	    return null;
	  }
	
	  var major = match[1] && parseFloat(match[1]);
	  var minor = match[2] && parseFloat(match[2]);
	
	  if (major && minor) {
	    return parseFloat(match[1] + '.' + match[2]);
	  } else if (major) {
	    return major;
	  }
	  return null;
	}();
	
	var IS_NATIVE_ANDROID = IS_ANDROID && ANDROID_VERSION < 5 && appleWebkitVersion < 537;
	
	var IS_FIREFOX = /Firefox/i.test(USER_AGENT);
	var IS_EDGE = /Edge/i.test(USER_AGENT);
	var IS_CHROME = !IS_EDGE && (/Chrome/i.test(USER_AGENT) || /CriOS/i.test(USER_AGENT));
	var CHROME_VERSION = function () {
	  var match = USER_AGENT.match(/(Chrome|CriOS)\/(\d+)/);
	
	  if (match && match[2]) {
	    return parseFloat(match[2]);
	  }
	  return null;
	}();
	var IE_VERSION = function () {
	  var result = /MSIE\s(\d+)\.\d/.exec(USER_AGENT);
	  var version = result && parseFloat(result[1]);
	
	  if (!version && /Trident\/7.0/i.test(USER_AGENT) && /rv:11.0/.test(USER_AGENT)) {
	    // IE 11 has a different user agent string than other IE versions
	    version = 11.0;
	  }
	
	  return version;
	}();
	
	var IS_SAFARI = /Safari/i.test(USER_AGENT) && !IS_CHROME && !IS_ANDROID && !IS_EDGE;
	var IS_ANY_SAFARI = (IS_SAFARI || IS_IOS) && !IS_CHROME;
	
	var TOUCH_ENABLED = isReal() && ('ontouchstart' in window$1 || window$1.navigator.maxTouchPoints || window$1.DocumentTouch && window$1.document instanceof window$1.DocumentTouch);
	
	var browser = /*#__PURE__*/Object.freeze({
	  IS_IPAD: IS_IPAD,
	  IS_IPHONE: IS_IPHONE,
	  IS_IPOD: IS_IPOD,
	  IS_IOS: IS_IOS,
	  IOS_VERSION: IOS_VERSION,
	  IS_ANDROID: IS_ANDROID,
	  ANDROID_VERSION: ANDROID_VERSION,
	  IS_NATIVE_ANDROID: IS_NATIVE_ANDROID,
	  IS_FIREFOX: IS_FIREFOX,
	  IS_EDGE: IS_EDGE,
	  IS_CHROME: IS_CHROME,
	  CHROME_VERSION: CHROME_VERSION,
	  IE_VERSION: IE_VERSION,
	  IS_SAFARI: IS_SAFARI,
	  IS_ANY_SAFARI: IS_ANY_SAFARI,
	  TOUCH_ENABLED: TOUCH_ENABLED
	});
	
	/**
	 * @file time-ranges.js
	 * @module time-ranges
	 */
	
	/**
	 * Returns the time for the specified index at the start or end
	 * of a TimeRange object.
	 *
	 * @function time-ranges:indexFunction
	 *
	 * @param {number} [index=0]
	 *        The range number to return the time for.
	 *
	 * @return {number}
	 *         The time that offset at the specified index.
	 *
	 * @depricated index must be set to a value, in the future this will throw an error.
	 */
	
	/**
	 * An object that contains ranges of time for various reasons.
	 *
	 * @typedef {Object} TimeRange
	 *
	 * @property {number} length
	 *           The number of time ranges represented by this Object
	 *
	 * @property {time-ranges:indexFunction} start
	 *           Returns the time offset at which a specified time range begins.
	 *
	 * @property {time-ranges:indexFunction} end
	 *           Returns the time offset at which a specified time range ends.
	 *
	 * @see https://developer.mozilla.org/en-US/docs/Web/API/TimeRanges
	 */
	
	/**
	 * Check if any of the time ranges are over the maximum index.
	 *
	 * @param {string} fnName
	 *        The function name to use for logging
	 *
	 * @param {number} index
	 *        The index to check
	 *
	 * @param {number} maxIndex
	 *        The maximum possible index
	 *
	 * @throws {Error} if the timeRanges provided are over the maxIndex
	 */
	function rangeCheck(fnName, index, maxIndex) {
	  if (typeof index !== 'number' || index < 0 || index > maxIndex) {
	    throw new Error('Failed to execute \'' + fnName + '\' on \'TimeRanges\': The index provided (' + index + ') is non-numeric or out of bounds (0-' + maxIndex + ').');
	  }
	}
	
	/**
	 * Get the time for the specified index at the start or end
	 * of a TimeRange object.
	 *
	 * @param {string} fnName
	 *        The function name to use for logging
	 *
	 * @param {string} valueIndex
	 *        The property that should be used to get the time. should be 'start' or 'end'
	 *
	 * @param {Array} ranges
	 *        An array of time ranges
	 *
	 * @param {Array} [rangeIndex=0]
	 *        The index to start the search at
	 *
	 * @return {number}
	 *         The time that offset at the specified index.
	 *
	 *
	 * @depricated rangeIndex must be set to a value, in the future this will throw an error.
	 * @throws {Error} if rangeIndex is more than the length of ranges
	 */
	function getRange(fnName, valueIndex, ranges, rangeIndex) {
	  rangeCheck(fnName, rangeIndex, ranges.length - 1);
	  return ranges[rangeIndex][valueIndex];
	}
	
	/**
	 * Create a time range object given ranges of time.
	 *
	 * @param {Array} [ranges]
	 *        An array of time ranges.
	 */
	function createTimeRangesObj(ranges) {
	  if (ranges === undefined || ranges.length === 0) {
	    return {
	      length: 0,
	      start: function start() {
	        throw new Error('This TimeRanges object is empty');
	      },
	      end: function end() {
	        throw new Error('This TimeRanges object is empty');
	      }
	    };
	  }
	  return {
	    length: ranges.length,
	    start: getRange.bind(null, 'start', 0, ranges),
	    end: getRange.bind(null, 'end', 1, ranges)
	  };
	}
	
	/**
	 * Should create a fake `TimeRange` object which mimics an HTML5 time range instance.
	 *
	 * @param {number|Array} start
	 *        The start of a single range or an array of ranges
	 *
	 * @param {number} end
	 *        The end of a single range.
	 *
	 * @private
	 */
	function createTimeRanges(start, end) {
	  if (Array.isArray(start)) {
	    return createTimeRangesObj(start);
	  } else if (start === undefined || end === undefined) {
	    return createTimeRangesObj();
	  }
	  return createTimeRangesObj([[start, end]]);
	}
	
	/**
	 * @file buffer.js
	 * @module buffer
	 */
	
	/**
	 * Compute the percentage of the media that has been buffered.
	 *
	 * @param {TimeRange} buffered
	 *        The current `TimeRange` object representing buffered time ranges
	 *
	 * @param {number} duration
	 *        Total duration of the media
	 *
	 * @return {number}
	 *         Percent buffered of the total duration in decimal form.
	 */
	function bufferedPercent(buffered, duration) {
	  var bufferedDuration = 0;
	  var start = void 0;
	  var end = void 0;
	
	  if (!duration) {
	    return 0;
	  }
	
	  if (!buffered || !buffered.length) {
	    buffered = createTimeRanges(0, 0);
	  }
	
	  for (var i = 0; i < buffered.length; i++) {
	    start = buffered.start(i);
	    end = buffered.end(i);
	
	    // buffered end can be bigger than duration by a very small fraction
	    if (end > duration) {
	      end = duration;
	    }
	
	    bufferedDuration += end - start;
	  }
	
	  return bufferedDuration / duration;
	}
	
	/**
	 * @file fullscreen-api.js
	 * @module fullscreen-api
	 * @private
	 */
	
	/**
	 * Store the browser-specific methods for the fullscreen API.
	 *
	 * @type {Object}
	 * @see [Specification]{@link https://fullscreen.spec.whatwg.org}
	 * @see [Map Approach From Screenfull.js]{@link https://github.com/sindresorhus/screenfull.js}
	 */
	var FullscreenApi = {};
	
	// browser API methods
	var apiMap = [['requestFullscreen', 'exitFullscreen', 'fullscreenElement', 'fullscreenEnabled', 'fullscreenchange', 'fullscreenerror'],
	// WebKit
	['webkitRequestFullscreen', 'webkitExitFullscreen', 'webkitFullscreenElement', 'webkitFullscreenEnabled', 'webkitfullscreenchange', 'webkitfullscreenerror'],
	// Old WebKit (Safari 5.1)
	['webkitRequestFullScreen', 'webkitCancelFullScreen', 'webkitCurrentFullScreenElement', 'webkitCancelFullScreen', 'webkitfullscreenchange', 'webkitfullscreenerror'],
	// Mozilla
	['mozRequestFullScreen', 'mozCancelFullScreen', 'mozFullScreenElement', 'mozFullScreenEnabled', 'mozfullscreenchange', 'mozfullscreenerror'],
	// Microsoft
	['msRequestFullscreen', 'msExitFullscreen', 'msFullscreenElement', 'msFullscreenEnabled', 'MSFullscreenChange', 'MSFullscreenError']];
	
	var specApi = apiMap[0];
	var browserApi = void 0;
	
	// determine the supported set of functions
	for (var i = 0; i < apiMap.length; i++) {
	  // check for exitFullscreen function
	  if (apiMap[i][1] in document) {
	    browserApi = apiMap[i];
	    break;
	  }
	}
	
	// map the browser API names to the spec API names
	if (browserApi) {
	  for (var _i = 0; _i < browserApi.length; _i++) {
	    FullscreenApi[specApi[_i]] = browserApi[_i];
	  }
	}
	
	/**
	 * @file media-error.js
	 */
	
	/**
	 * A Custom `MediaError` class which mimics the standard HTML5 `MediaError` class.
	 *
	 * @param {number|string|Object|MediaError} value
	 *        This can be of multiple types:
	 *        - number: should be a standard error code
	 *        - string: an error message (the code will be 0)
	 *        - Object: arbitrary properties
	 *        - `MediaError` (native): used to populate a video.js `MediaError` object
	 *        - `MediaError` (video.js): will return itself if it's already a
	 *          video.js `MediaError` object.
	 *
	 * @see [MediaError Spec]{@link https://dev.w3.org/html5/spec-author-view/video.html#mediaerror}
	 * @see [Encrypted MediaError Spec]{@link https://www.w3.org/TR/2013/WD-encrypted-media-20130510/#error-codes}
	 *
	 * @class MediaError
	 */
	function MediaError(value) {
	
	  // Allow redundant calls to this constructor to avoid having `instanceof`
	  // checks peppered around the code.
	  if (value instanceof MediaError) {
	    return value;
	  }
	
	  if (typeof value === 'number') {
	    this.code = value;
	  } else if (typeof value === 'string') {
	    // default code is zero, so this is a custom error
	    this.message = value;
	  } else if (isObject(value)) {
	
	    // We assign the `code` property manually because native `MediaError` objects
	    // do not expose it as an own/enumerable property of the object.
	    if (typeof value.code === 'number') {
	      this.code = value.code;
	    }
	
	    assign(this, value);
	  }
	
	  if (!this.message) {
	    this.message = MediaError.defaultMessages[this.code] || '';
	  }
	}
	
	/**
	 * The error code that refers two one of the defined `MediaError` types
	 *
	 * @type {Number}
	 */
	MediaError.prototype.code = 0;
	
	/**
	 * An optional message that to show with the error. Message is not part of the HTML5
	 * video spec but allows for more informative custom errors.
	 *
	 * @type {String}
	 */
	MediaError.prototype.message = '';
	
	/**
	 * An optional status code that can be set by plugins to allow even more detail about
	 * the error. For example a plugin might provide a specific HTTP status code and an
	 * error message for that code. Then when the plugin gets that error this class will
	 * know how to display an error message for it. This allows a custom message to show
	 * up on the `Player` error overlay.
	 *
	 * @type {Array}
	 */
	MediaError.prototype.status = null;
	
	/**
	 * Errors indexed by the W3C standard. The order **CANNOT CHANGE**! See the
	 * specification listed under {@link MediaError} for more information.
	 *
	 * @enum {array}
	 * @readonly
	 * @property {string} 0 - MEDIA_ERR_CUSTOM
	 * @property {string} 1 - MEDIA_ERR_CUSTOM
	 * @property {string} 2 - MEDIA_ERR_ABORTED
	 * @property {string} 3 - MEDIA_ERR_NETWORK
	 * @property {string} 4 - MEDIA_ERR_SRC_NOT_SUPPORTED
	 * @property {string} 5 - MEDIA_ERR_ENCRYPTED
	 */
	MediaError.errorTypes = ['MEDIA_ERR_CUSTOM', 'MEDIA_ERR_ABORTED', 'MEDIA_ERR_NETWORK', 'MEDIA_ERR_DECODE', 'MEDIA_ERR_SRC_NOT_SUPPORTED', 'MEDIA_ERR_ENCRYPTED'];
	
	/**
	 * The default `MediaError` messages based on the {@link MediaError.errorTypes}.
	 *
	 * @type {Array}
	 * @constant
	 */
	MediaError.defaultMessages = {
	  1: 'You aborted the media playback',
	  2: 'A network error caused the media download to fail part-way.',
	  3: 'The media playback was aborted due to a corruption problem or because the media used features your browser did not support.',
	  4: 'The media could not be loaded, either because the server or network failed or because the format is not supported.',
	  5: 'The media is encrypted and we do not have the keys to decrypt it.'
	};
	
	// Add types as properties on MediaError
	// e.g. MediaError.MEDIA_ERR_SRC_NOT_SUPPORTED = 4;
	for (var errNum = 0; errNum < MediaError.errorTypes.length; errNum++) {
	  MediaError[MediaError.errorTypes[errNum]] = errNum;
	  // values should be accessible on both the class and instance
	  MediaError.prototype[MediaError.errorTypes[errNum]] = errNum;
	}
	
	/**
	 * Returns whether an object is `Promise`-like (i.e. has a `then` method).
	 *
	 * @param  {Object}  value
	 *         An object that may or may not be `Promise`-like.
	 *
	 * @return {Boolean}
	 *         Whether or not the object is `Promise`-like.
	 */
	function isPromise(value) {
	  return value !== undefined && value !== null && typeof value.then === 'function';
	}
	
	/**
	 * Silence a Promise-like object.
	 *
	 * This is useful for avoiding non-harmful, but potentially confusing "uncaught
	 * play promise" rejection error messages.
	 *
	 * @param  {Object} value
	 *         An object that may or may not be `Promise`-like.
	 */
	function silencePromise(value) {
	  if (isPromise(value)) {
	    value.then(null, function (e) {});
	  }
	}
	
	/**
	 * @file text-track-list-converter.js Utilities for capturing text track state and
	 * re-creating tracks based on a capture.
	 *
	 * @module text-track-list-converter
	 */
	
	/**
	 * Examine a single {@link TextTrack} and return a JSON-compatible javascript object that
	 * represents the {@link TextTrack}'s state.
	 *
	 * @param {TextTrack} track
	 *        The text track to query.
	 *
	 * @return {Object}
	 *         A serializable javascript representation of the TextTrack.
	 * @private
	 */
	var trackToJson_ = function trackToJson_(track) {
	  var ret = ['kind', 'label', 'language', 'id', 'inBandMetadataTrackDispatchType', 'mode', 'src'].reduce(function (acc, prop, i) {
	
	    if (track[prop]) {
	      acc[prop] = track[prop];
	    }
	
	    return acc;
	  }, {
	    cues: track.cues && Array.prototype.map.call(track.cues, function (cue) {
	      return {
	        startTime: cue.startTime,
	        endTime: cue.endTime,
	        text: cue.text,
	        id: cue.id
	      };
	    })
	  });
	
	  return ret;
	};
	
	/**
	 * Examine a {@link Tech} and return a JSON-compatible javascript array that represents the
	 * state of all {@link TextTrack}s currently configured. The return array is compatible with
	 * {@link text-track-list-converter:jsonToTextTracks}.
	 *
	 * @param {Tech} tech
	 *        The tech object to query
	 *
	 * @return {Array}
	 *         A serializable javascript representation of the {@link Tech}s
	 *         {@link TextTrackList}.
	 */
	var textTracksToJson = function textTracksToJson(tech) {
	
	  var trackEls = tech.$$('track');
	
	  var trackObjs = Array.prototype.map.call(trackEls, function (t) {
	    return t.track;
	  });
	  var tracks = Array.prototype.map.call(trackEls, function (trackEl) {
	    var json = trackToJson_(trackEl.track);
	
	    if (trackEl.src) {
	      json.src = trackEl.src;
	    }
	    return json;
	  });
	
	  return tracks.concat(Array.prototype.filter.call(tech.textTracks(), function (track) {
	    return trackObjs.indexOf(track) === -1;
	  }).map(trackToJson_));
	};
	
	/**
	 * Create a set of remote {@link TextTrack}s on a {@link Tech} based on an array of javascript
	 * object {@link TextTrack} representations.
	 *
	 * @param {Array} json
	 *        An array of `TextTrack` representation objects, like those that would be
	 *        produced by `textTracksToJson`.
	 *
	 * @param {Tech} tech
	 *        The `Tech` to create the `TextTrack`s on.
	 */
	var jsonToTextTracks = function jsonToTextTracks(json, tech) {
	  json.forEach(function (track) {
	    var addedTrack = tech.addRemoteTextTrack(track).track;
	
	    if (!track.src && track.cues) {
	      track.cues.forEach(function (cue) {
	        return addedTrack.addCue(cue);
	      });
	    }
	  });
	
	  return tech.textTracks();
	};
	
	var textTrackConverter = { textTracksToJson: textTracksToJson, jsonToTextTracks: jsonToTextTracks, trackToJson_: trackToJson_ };
	
	/**
	 * @file modal-dialog.js
	 */
	
	var MODAL_CLASS_NAME = 'vjs-modal-dialog';
	var ESC = 27;
	
	/**
	 * The `ModalDialog` displays over the video and its controls, which blocks
	 * interaction with the player until it is closed.
	 *
	 * Modal dialogs include a "Close" button and will close when that button
	 * is activated - or when ESC is pressed anywhere.
	 *
	 * @extends Component
	 */
	
	var ModalDialog = function (_Component) {
	  inherits(ModalDialog, _Component);
	
	  /**
	   * Create an instance of this class.
	   *
	   * @param {Player} player
	   *        The `Player` that this class should be attached to.
	   *
	   * @param {Object} [options]
	   *        The key/value store of player options.
	   *
	   * @param {Mixed} [options.content=undefined]
	   *        Provide customized content for this modal.
	   *
	   * @param {string} [options.description]
	   *        A text description for the modal, primarily for accessibility.
	   *
	   * @param {boolean} [options.fillAlways=false]
	   *        Normally, modals are automatically filled only the first time
	   *        they open. This tells the modal to refresh its content
	   *        every time it opens.
	   *
	   * @param {string} [options.label]
	   *        A text label for the modal, primarily for accessibility.
	   *
	   * @param {boolean} [options.temporary=true]
	   *        If `true`, the modal can only be opened once; it will be
	   *        disposed as soon as it's closed.
	   *
	   * @param {boolean} [options.uncloseable=false]
	   *        If `true`, the user will not be able to close the modal
	   *        through the UI in the normal ways. Programmatic closing is
	   *        still possible.
	   */
	  function ModalDialog(player, options) {
	    classCallCheck(this, ModalDialog);
	
	    var _this = possibleConstructorReturn(this, _Component.call(this, player, options));
	
	    _this.opened_ = _this.hasBeenOpened_ = _this.hasBeenFilled_ = false;
	
	    _this.closeable(!_this.options_.uncloseable);
	    _this.content(_this.options_.content);
	
	    // Make sure the contentEl is defined AFTER any children are initialized
	    // because we only want the contents of the modal in the contentEl
	    // (not the UI elements like the close button).
	    _this.contentEl_ = createEl('div', {
	      className: MODAL_CLASS_NAME + '-content'
	    }, {
	      role: 'document'
	    });
	
	    _this.descEl_ = createEl('p', {
	      className: MODAL_CLASS_NAME + '-description vjs-control-text',
	      id: _this.el().getAttribute('aria-describedby')
	    });
	
	    textContent(_this.descEl_, _this.description());
	    _this.el_.appendChild(_this.descEl_);
	    _this.el_.appendChild(_this.contentEl_);
	    return _this;
	  }
	
	  /**
	   * Create the `ModalDialog`'s DOM element
	   *
	   * @return {Element}
	   *         The DOM element that gets created.
	   */
	
	
	  ModalDialog.prototype.createEl = function createEl$$1() {
	    return _Component.prototype.createEl.call(this, 'div', {
	      className: this.buildCSSClass(),
	      tabIndex: -1
	    }, {
	      'aria-describedby': this.id() + '_description',
	      'aria-hidden': 'true',
	      'aria-label': this.label(),
	      'role': 'dialog'
	    });
	  };
	
	  ModalDialog.prototype.dispose = function dispose() {
	    this.contentEl_ = null;
	    this.descEl_ = null;
	    this.previouslyActiveEl_ = null;
	
	    _Component.prototype.dispose.call(this);
	  };
	
	  /**
	   * Builds the default DOM `className`.
	   *
	   * @return {string}
	   *         The DOM `className` for this object.
	   */
	
	
	  ModalDialog.prototype.buildCSSClass = function buildCSSClass() {
	    return MODAL_CLASS_NAME + ' vjs-hidden ' + _Component.prototype.buildCSSClass.call(this);
	  };
	
	  /**
	   * Handles `keydown` events on the document, looking for ESC, which closes
	   * the modal.
	   *
	   * @param {EventTarget~Event} e
	   *        The keypress that triggered this event.
	   *
	   * @listens keydown
	   */
	
	
	  ModalDialog.prototype.handleKeyPress = function handleKeyPress(e) {
	    if (e.which === ESC && this.closeable()) {
	      this.close();
	    }
	  };
	
	  /**
	   * Returns the label string for this modal. Primarily used for accessibility.
	   *
	   * @return {string}
	   *         the localized or raw label of this modal.
	   */
	
	
	  ModalDialog.prototype.label = function label() {
	    return this.localize(this.options_.label || 'Modal Window');
	  };
	
	  /**
	   * Returns the description string for this modal. Primarily used for
	   * accessibility.
	   *
	   * @return {string}
	   *         The localized or raw description of this modal.
	   */
	
	
	  ModalDialog.prototype.description = function description() {
	    var desc = this.options_.description || this.localize('This is a modal window.');
	
	    // Append a universal closeability message if the modal is closeable.
	    if (this.closeable()) {
	      desc += ' ' + this.localize('This modal can be closed by pressing the Escape key or activating the close button.');
	    }
	
	    return desc;
	  };
	
	  /**
	   * Opens the modal.
	   *
	   * @fires ModalDialog#beforemodalopen
	   * @fires ModalDialog#modalopen
	   */
	
	
	  ModalDialog.prototype.open = function open() {
	    if (!this.opened_) {
	      var player = this.player();
	
	      /**
	        * Fired just before a `ModalDialog` is opened.
	        *
	        * @event ModalDialog#beforemodalopen
	        * @type {EventTarget~Event}
	        */
	      this.trigger('beforemodalopen');
	      this.opened_ = true;
	
	      // Fill content if the modal has never opened before and
	      // never been filled.
	      if (this.options_.fillAlways || !this.hasBeenOpened_ && !this.hasBeenFilled_) {
	        this.fill();
	      }
	
	      // If the player was playing, pause it and take note of its previously
	      // playing state.
	      this.wasPlaying_ = !player.paused();
	
	      if (this.options_.pauseOnOpen && this.wasPlaying_) {
	        player.pause();
	      }
	
	      if (this.closeable()) {
	        this.on(this.el_.ownerDocument, 'keydown', bind(this, this.handleKeyPress));
	      }
	
	      // Hide controls and note if they were enabled.
	      this.hadControls_ = player.controls();
	      player.controls(false);
	
	      this.show();
	      this.conditionalFocus_();
	      this.el().setAttribute('aria-hidden', 'false');
	
	      /**
	        * Fired just after a `ModalDialog` is opened.
	        *
	        * @event ModalDialog#modalopen
	        * @type {EventTarget~Event}
	        */
	      this.trigger('modalopen');
	      this.hasBeenOpened_ = true;
	    }
	  };
	
	  /**
	   * If the `ModalDialog` is currently open or closed.
	   *
	   * @param  {boolean} [value]
	   *         If given, it will open (`true`) or close (`false`) the modal.
	   *
	   * @return {boolean}
	   *         the current open state of the modaldialog
	   */
	
	
	  ModalDialog.prototype.opened = function opened(value) {
	    if (typeof value === 'boolean') {
	      this[value ? 'open' : 'close']();
	    }
	    return this.opened_;
	  };
	
	  /**
	   * Closes the modal, does nothing if the `ModalDialog` is
	   * not open.
	   *
	   * @fires ModalDialog#beforemodalclose
	   * @fires ModalDialog#modalclose
	   */
	
	
	  ModalDialog.prototype.close = function close() {
	    if (!this.opened_) {
	      return;
	    }
	    var player = this.player();
	
	    /**
	      * Fired just before a `ModalDialog` is closed.
	      *
	      * @event ModalDialog#beforemodalclose
	      * @type {EventTarget~Event}
	      */
	    this.trigger('beforemodalclose');
	    this.opened_ = false;
	
	    if (this.wasPlaying_ && this.options_.pauseOnOpen) {
	      player.play();
	    }
	
	    if (this.closeable()) {
	      this.off(this.el_.ownerDocument, 'keydown', bind(this, this.handleKeyPress));
	    }
	
	    if (this.hadControls_) {
	      player.controls(true);
	    }
	
	    this.hide();
	    this.el().setAttribute('aria-hidden', 'true');
	
	    /**
	      * Fired just after a `ModalDialog` is closed.
	      *
	      * @event ModalDialog#modalclose
	      * @type {EventTarget~Event}
	      */
	    this.trigger('modalclose');
	    this.conditionalBlur_();
	
	    if (this.options_.temporary) {
	      this.dispose();
	    }
	  };
	
	  /**
	   * Check to see if the `ModalDialog` is closeable via the UI.
	   *
	   * @param  {boolean} [value]
	   *         If given as a boolean, it will set the `closeable` option.
	   *
	   * @return {boolean}
	   *         Returns the final value of the closable option.
	   */
	
	
	  ModalDialog.prototype.closeable = function closeable(value) {
	    if (typeof value === 'boolean') {
	      var closeable = this.closeable_ = !!value;
	      var close = this.getChild('closeButton');
	
	      // If this is being made closeable and has no close button, add one.
	      if (closeable && !close) {
	
	        // The close button should be a child of the modal - not its
	        // content element, so temporarily change the content element.
	        var temp = this.contentEl_;
	
	        this.contentEl_ = this.el_;
	        close = this.addChild('closeButton', { controlText: 'Close Modal Dialog' });
	        this.contentEl_ = temp;
	        this.on(close, 'close', this.close);
	      }
	
	      // If this is being made uncloseable and has a close button, remove it.
	      if (!closeable && close) {
	        this.off(close, 'close', this.close);
	        this.removeChild(close);
	        close.dispose();
	      }
	    }
	    return this.closeable_;
	  };
	
	  /**
	   * Fill the modal's content element with the modal's "content" option.
	   * The content element will be emptied before this change takes place.
	   */
	
	
	  ModalDialog.prototype.fill = function fill() {
	    this.fillWith(this.content());
	  };
	
	  /**
	   * Fill the modal's content element with arbitrary content.
	   * The content element will be emptied before this change takes place.
	   *
	   * @fires ModalDialog#beforemodalfill
	   * @fires ModalDialog#modalfill
	   *
	   * @param {Mixed} [content]
	   *        The same rules apply to this as apply to the `content` option.
	   */
	
	
	  ModalDialog.prototype.fillWith = function fillWith(content) {
	    var contentEl = this.contentEl();
	    var parentEl = contentEl.parentNode;
	    var nextSiblingEl = contentEl.nextSibling;
	
	    /**
	     * Fired just before a `ModalDialog` is filled with content.
	     *
	     * @event ModalDialog#beforemodalfill
	     * @type {EventTarget~Event}
	     */
	    this.trigger('beforemodalfill');
	    this.hasBeenFilled_ = true;
	
	    // Detach the content element from the DOM before performing
	    // manipulation to avoid modifying the live DOM multiple times.
	    parentEl.removeChild(contentEl);
	    this.empty();
	    insertContent(contentEl, content);
	    /**
	     * Fired just after a `ModalDialog` is filled with content.
	     *
	     * @event ModalDialog#modalfill
	     * @type {EventTarget~Event}
	     */
	    this.trigger('modalfill');
	
	    // Re-inject the re-filled content element.
	    if (nextSiblingEl) {
	      parentEl.insertBefore(contentEl, nextSiblingEl);
	    } else {
	      parentEl.appendChild(contentEl);
	    }
	
	    // make sure that the close button is last in the dialog DOM
	    var closeButton = this.getChild('closeButton');
	
	    if (closeButton) {
	      parentEl.appendChild(closeButton.el_);
	    }
	  };
	
	  /**
	   * Empties the content element. This happens anytime the modal is filled.
	   *
	   * @fires ModalDialog#beforemodalempty
	   * @fires ModalDialog#modalempty
	   */
	
	
	  ModalDialog.prototype.empty = function empty() {
	    /**
	     * Fired just before a `ModalDialog` is emptied.
	     *
	     * @event ModalDialog#beforemodalempty
	     * @type {EventTarget~Event}
	     */
	    this.trigger('beforemodalempty');
	    emptyEl(this.contentEl());
	
	    /**
	     * Fired just after a `ModalDialog` is emptied.
	     *
	     * @event ModalDialog#modalempty
	     * @type {EventTarget~Event}
	     */
	    this.trigger('modalempty');
	  };
	
	  /**
	   * Gets or sets the modal content, which gets normalized before being
	   * rendered into the DOM.
	   *
	   * This does not update the DOM or fill the modal, but it is called during
	   * that process.
	   *
	   * @param  {Mixed} [value]
	   *         If defined, sets the internal content value to be used on the
	   *         next call(s) to `fill`. This value is normalized before being
	   *         inserted. To "clear" the internal content value, pass `null`.
	   *
	   * @return {Mixed}
	   *         The current content of the modal dialog
	   */
	
	
	  ModalDialog.prototype.content = function content(value) {
	    if (typeof value !== 'undefined') {
	      this.content_ = value;
	    }
	    return this.content_;
	  };
	
	  /**
	   * conditionally focus the modal dialog if focus was previously on the player.
	   *
	   * @private
	   */
	
	
	  ModalDialog.prototype.conditionalFocus_ = function conditionalFocus_() {
	    var activeEl = document.activeElement;
	    var playerEl = this.player_.el_;
	
	    this.previouslyActiveEl_ = null;
	
	    if (playerEl.contains(activeEl) || playerEl === activeEl) {
	      this.previouslyActiveEl_ = activeEl;
	
	      this.focus();
	
	      this.on(document, 'keydown', this.handleKeyDown);
	    }
	  };
	
	  /**
	   * conditionally blur the element and refocus the last focused element
	   *
	   * @private
	   */
	
	
	  ModalDialog.prototype.conditionalBlur_ = function conditionalBlur_() {
	    if (this.previouslyActiveEl_) {
	      this.previouslyActiveEl_.focus();
	      this.previouslyActiveEl_ = null;
	    }
	
	    this.off(document, 'keydown', this.handleKeyDown);
	  };
	
	  /**
	   * Keydown handler. Attached when modal is focused.
	   *
	   * @listens keydown
	   */
	
	
	  ModalDialog.prototype.handleKeyDown = function handleKeyDown(event) {
	    // exit early if it isn't a tab key
	    if (event.which !== 9) {
	      return;
	    }
	
	    var focusableEls = this.focusableEls_();
	    var activeEl = this.el_.querySelector(':focus');
	    var focusIndex = void 0;
	
	    for (var i = 0; i < focusableEls.length; i++) {
	      if (activeEl === focusableEls[i]) {
	        focusIndex = i;
	        break;
	      }
	    }
	
	    if (document.activeElement === this.el_) {
	      focusIndex = 0;
	    }
	
	    if (event.shiftKey && focusIndex === 0) {
	      focusableEls[focusableEls.length - 1].focus();
	      event.preventDefault();
	    } else if (!event.shiftKey && focusIndex === focusableEls.length - 1) {
	      focusableEls[0].focus();
	      event.preventDefault();
	    }
	  };
	
	  /**
	   * get all focusable elements
	   *
	   * @private
	   */
	
	
	  ModalDialog.prototype.focusableEls_ = function focusableEls_() {
	    var allChildren = this.el_.querySelectorAll('*');
	
	    return Array.prototype.filter.call(allChildren, function (child) {
	      return (child instanceof window$1.HTMLAnchorElement || child instanceof window$1.HTMLAreaElement) && child.hasAttribute('href') || (child instanceof window$1.HTMLInputElement || child instanceof window$1.HTMLSelectElement || child instanceof window$1.HTMLTextAreaElement || child instanceof window$1.HTMLButtonElement) && !child.hasAttribute('disabled') || child instanceof window$1.HTMLIFrameElement || child instanceof window$1.HTMLObjectElement || child instanceof window$1.HTMLEmbedElement || child.hasAttribute('tabindex') && child.getAttribute('tabindex') !== -1 || child.hasAttribute('contenteditable');
	    });
	  };
	
	  return ModalDialog;
	}(Component);
	
	/**
	 * Default options for `ModalDialog` default options.
	 *
	 * @type {Object}
	 * @private
	 */
	
	
	ModalDialog.prototype.options_ = {
	  pauseOnOpen: true,
	  temporary: true
	};
	
	Component.registerComponent('ModalDialog', ModalDialog);
	
	/**
	 * @file track-list.js
	 */
	
	/**
	 * Common functionaliy between {@link TextTrackList}, {@link AudioTrackList}, and
	 * {@link VideoTrackList}
	 *
	 * @extends EventTarget
	 */
	
	var TrackList = function (_EventTarget) {
	  inherits(TrackList, _EventTarget);
	
	  /**
	   * Create an instance of this class
	   *
	   * @param {Track[]} tracks
	   *        A list of tracks to initialize the list with.
	   *
	   * @abstract
	   */
	  function TrackList() {
	    var tracks = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	    classCallCheck(this, TrackList);
	
	    var _this = possibleConstructorReturn(this, _EventTarget.call(this));
	
	    _this.tracks_ = [];
	
	    /**
	     * @memberof TrackList
	     * @member {number} length
	     *         The current number of `Track`s in the this Trackist.
	     * @instance
	     */
	    Object.defineProperty(_this, 'length', {
	      get: function get$$1() {
	        return this.tracks_.length;
	      }
	    });
	
	    for (var i = 0; i < tracks.length; i++) {
	      _this.addTrack(tracks[i]);
	    }
	    return _this;
	  }
	
	  /**
	   * Add a {@link Track} to the `TrackList`
	   *
	   * @param {Track} track
	   *        The audio, video, or text track to add to the list.
	   *
	   * @fires TrackList#addtrack
	   */
	
	
	  TrackList.prototype.addTrack = function addTrack(track) {
	    var index = this.tracks_.length;
	
	    if (!('' + index in this)) {
	      Object.defineProperty(this, index, {
	        get: function get$$1() {
	          return this.tracks_[index];
	        }
	      });
	    }
	
	    // Do not add duplicate tracks
	    if (this.tracks_.indexOf(track) === -1) {
	      this.tracks_.push(track);
	      /**
	       * Triggered when a track is added to a track list.
	       *
	       * @event TrackList#addtrack
	       * @type {EventTarget~Event}
	       * @property {Track} track
	       *           A reference to track that was added.
	       */
	      this.trigger({
	        track: track,
	        type: 'addtrack'
	      });
	    }
	  };
	
	  /**
	   * Remove a {@link Track} from the `TrackList`
	   *
	   * @param {Track} rtrack
	   *        The audio, video, or text track to remove from the list.
	   *
	   * @fires TrackList#removetrack
	   */
	
	
	  TrackList.prototype.removeTrack = function removeTrack(rtrack) {
	    var track = void 0;
	
	    for (var i = 0, l = this.length; i < l; i++) {
	      if (this[i] === rtrack) {
	        track = this[i];
	        if (track.off) {
	          track.off();
	        }
	
	        this.tracks_.splice(i, 1);
	
	        break;
	      }
	    }
	
	    if (!track) {
	      return;
	    }
	
	    /**
	     * Triggered when a track is removed from track list.
	     *
	     * @event TrackList#removetrack
	     * @type {EventTarget~Event}
	     * @property {Track} track
	     *           A reference to track that was removed.
	     */
	    this.trigger({
	      track: track,
	      type: 'removetrack'
	    });
	  };
	
	  /**
	   * Get a Track from the TrackList by a tracks id
	   *
	   * @param {String} id - the id of the track to get
	   * @method getTrackById
	   * @return {Track}
	   * @private
	   */
	
	
	  TrackList.prototype.getTrackById = function getTrackById(id) {
	    var result = null;
	
	    for (var i = 0, l = this.length; i < l; i++) {
	      var track = this[i];
	
	      if (track.id === id) {
	        result = track;
	        break;
	      }
	    }
	
	    return result;
	  };
	
	  return TrackList;
	}(EventTarget);
	
	/**
	 * Triggered when a different track is selected/enabled.
	 *
	 * @event TrackList#change
	 * @type {EventTarget~Event}
	 */
	
	/**
	 * Events that can be called with on + eventName. See {@link EventHandler}.
	 *
	 * @property {Object} TrackList#allowedEvents_
	 * @private
	 */
	
	
	TrackList.prototype.allowedEvents_ = {
	  change: 'change',
	  addtrack: 'addtrack',
	  removetrack: 'removetrack'
	};
	
	// emulate attribute EventHandler support to allow for feature detection
	for (var event in TrackList.prototype.allowedEvents_) {
	  TrackList.prototype['on' + event] = null;
	}
	
	/**
	 * @file audio-track-list.js
	 */
	
	/**
	 * Anywhere we call this function we diverge from the spec
	 * as we only support one enabled audiotrack at a time
	 *
	 * @param {AudioTrackList} list
	 *        list to work on
	 *
	 * @param {AudioTrack} track
	 *        The track to skip
	 *
	 * @private
	 */
	var disableOthers = function disableOthers(list, track) {
	  for (var i = 0; i < list.length; i++) {
	    if (!Object.keys(list[i]).length || track.id === list[i].id) {
	      continue;
	    }
	    // another audio track is enabled, disable it
	    list[i].enabled = false;
	  }
	};
	
	/**
	 * The current list of {@link AudioTrack} for a media file.
	 *
	 * @see [Spec]{@link https://html.spec.whatwg.org/multipage/embedded-content.html#audiotracklist}
	 * @extends TrackList
	 */
	
	var AudioTrackList = function (_TrackList) {
	  inherits(AudioTrackList, _TrackList);
	
	  /**
	   * Create an instance of this class.
	   *
	   * @param {AudioTrack[]} [tracks=[]]
	   *        A list of `AudioTrack` to instantiate the list with.
	   */
	  function AudioTrackList() {
	    var tracks = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	    classCallCheck(this, AudioTrackList);
	
	    // make sure only 1 track is enabled
	    // sorted from last index to first index
	    for (var i = tracks.length - 1; i >= 0; i--) {
	      if (tracks[i].enabled) {
	        disableOthers(tracks, tracks[i]);
	        break;
	      }
	    }
	
	    var _this = possibleConstructorReturn(this, _TrackList.call(this, tracks));
	
	    _this.changing_ = false;
	    return _this;
	  }
	
	  /**
	   * Add an {@link AudioTrack} to the `AudioTrackList`.
	   *
	   * @param {AudioTrack} track
	   *        The AudioTrack to add to the list
	   *
	   * @fires TrackList#addtrack
	   */
	
	
	  AudioTrackList.prototype.addTrack = function addTrack(track) {
	    var _this2 = this;
	
	    if (track.enabled) {
	      disableOthers(this, track);
	    }
	
	    _TrackList.prototype.addTrack.call(this, track);
	    // native tracks don't have this
	    if (!track.addEventListener) {
	      return;
	    }
	
	    /**
	     * @listens AudioTrack#enabledchange
	     * @fires TrackList#change
	     */
	    track.addEventListener('enabledchange', function () {
	      // when we are disabling other tracks (since we don't support
	      // more than one track at a time) we will set changing_
	      // to true so that we don't trigger additional change events
	      if (_this2.changing_) {
	        return;
	      }
	      _this2.changing_ = true;
	      disableOthers(_this2, track);
	      _this2.changing_ = false;
	      _this2.trigger('change');
	    });
	  };
	
	  return AudioTrackList;
	}(TrackList);
	
	/**
	 * @file video-track-list.js
	 */
	
	/**
	 * Un-select all other {@link VideoTrack}s that are selected.
	 *
	 * @param {VideoTrackList} list
	 *        list to work on
	 *
	 * @param {VideoTrack} track
	 *        The track to skip
	 *
	 * @private
	 */
	var disableOthers$1 = function disableOthers(list, track) {
	  for (var i = 0; i < list.length; i++) {
	    if (!Object.keys(list[i]).length || track.id === list[i].id) {
	      continue;
	    }
	    // another video track is enabled, disable it
	    list[i].selected = false;
	  }
	};
	
	/**
	 * The current list of {@link VideoTrack} for a video.
	 *
	 * @see [Spec]{@link https://html.spec.whatwg.org/multipage/embedded-content.html#videotracklist}
	 * @extends TrackList
	 */
	
	var VideoTrackList = function (_TrackList) {
	  inherits(VideoTrackList, _TrackList);
	
	  /**
	   * Create an instance of this class.
	   *
	   * @param {VideoTrack[]} [tracks=[]]
	   *        A list of `VideoTrack` to instantiate the list with.
	   */
	  function VideoTrackList() {
	    var tracks = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	    classCallCheck(this, VideoTrackList);
	
	    // make sure only 1 track is enabled
	    // sorted from last index to first index
	    for (var i = tracks.length - 1; i >= 0; i--) {
	      if (tracks[i].selected) {
	        disableOthers$1(tracks, tracks[i]);
	        break;
	      }
	    }
	
	    var _this = possibleConstructorReturn(this, _TrackList.call(this, tracks));
	
	    _this.changing_ = false;
	
	    /**
	     * @member {number} VideoTrackList#selectedIndex
	     *         The current index of the selected {@link VideoTrack`}.
	     */
	    Object.defineProperty(_this, 'selectedIndex', {
	      get: function get$$1() {
	        for (var _i = 0; _i < this.length; _i++) {
	          if (this[_i].selected) {
	            return _i;
	          }
	        }
	        return -1;
	      },
	      set: function set$$1() {}
	    });
	    return _this;
	  }
	
	  /**
	   * Add a {@link VideoTrack} to the `VideoTrackList`.
	   *
	   * @param {VideoTrack} track
	   *        The VideoTrack to add to the list
	   *
	   * @fires TrackList#addtrack
	   */
	
	
	  VideoTrackList.prototype.addTrack = function addTrack(track) {
	    var _this2 = this;
	
	    if (track.selected) {
	      disableOthers$1(this, track);
	    }
	
	    _TrackList.prototype.addTrack.call(this, track);
	    // native tracks don't have this
	    if (!track.addEventListener) {
	      return;
	    }
	
	    /**
	     * @listens VideoTrack#selectedchange
	     * @fires TrackList#change
	     */
	    track.addEventListener('selectedchange', function () {
	      if (_this2.changing_) {
	        return;
	      }
	      _this2.changing_ = true;
	      disableOthers$1(_this2, track);
	      _this2.changing_ = false;
	      _this2.trigger('change');
	    });
	  };
	
	  return VideoTrackList;
	}(TrackList);
	
	/**
	 * @file text-track-list.js
	 */
	
	/**
	 * The current list of {@link TextTrack} for a media file.
	 *
	 * @see [Spec]{@link https://html.spec.whatwg.org/multipage/embedded-content.html#texttracklist}
	 * @extends TrackList
	 */
	
	var TextTrackList = function (_TrackList) {
	  inherits(TextTrackList, _TrackList);
	
	  function TextTrackList() {
	    classCallCheck(this, TextTrackList);
	    return possibleConstructorReturn(this, _TrackList.apply(this, arguments));
	  }
	
	  /**
	   * Add a {@link TextTrack} to the `TextTrackList`
	   *
	   * @param {TextTrack} track
	   *        The text track to add to the list.
	   *
	   * @fires TrackList#addtrack
	   */
	  TextTrackList.prototype.addTrack = function addTrack(track) {
	    _TrackList.prototype.addTrack.call(this, track);
	
	    /**
	     * @listens TextTrack#modechange
	     * @fires TrackList#change
	     */
	    track.addEventListener('modechange', bind(this, function () {
	      this.queueTrigger('change');
	    }));
	
	    var nonLanguageTextTrackKind = ['metadata', 'chapters'];
	
	    if (nonLanguageTextTrackKind.indexOf(track.kind) === -1) {
	      track.addEventListener('modechange', bind(this, function () {
	        this.trigger('selectedlanguagechange');
	      }));
	    }
	  };
	
	  return TextTrackList;
	}(TrackList);
	
	/**
	 * @file html-track-element-list.js
	 */
	
	/**
	 * The current list of {@link HtmlTrackElement}s.
	 */
	var HtmlTrackElementList = function () {
	
	  /**
	   * Create an instance of this class.
	   *
	   * @param {HtmlTrackElement[]} [tracks=[]]
	   *        A list of `HtmlTrackElement` to instantiate the list with.
	   */
	  function HtmlTrackElementList() {
	    var trackElements = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	    classCallCheck(this, HtmlTrackElementList);
	
	    this.trackElements_ = [];
	
	    /**
	     * @memberof HtmlTrackElementList
	     * @member {number} length
	     *         The current number of `Track`s in the this Trackist.
	     * @instance
	     */
	    Object.defineProperty(this, 'length', {
	      get: function get$$1() {
	        return this.trackElements_.length;
	      }
	    });
	
	    for (var i = 0, length = trackElements.length; i < length; i++) {
	      this.addTrackElement_(trackElements[i]);
	    }
	  }
	
	  /**
	   * Add an {@link HtmlTrackElement} to the `HtmlTrackElementList`
	   *
	   * @param {HtmlTrackElement} trackElement
	   *        The track element to add to the list.
	   *
	   * @private
	   */
	
	
	  HtmlTrackElementList.prototype.addTrackElement_ = function addTrackElement_(trackElement) {
	    var index = this.trackElements_.length;
	
	    if (!('' + index in this)) {
	      Object.defineProperty(this, index, {
	        get: function get$$1() {
	          return this.trackElements_[index];
	        }
	      });
	    }
	
	    // Do not add duplicate elements
	    if (this.trackElements_.indexOf(trackElement) === -1) {
	      this.trackElements_.push(trackElement);
	    }
	  };
	
	  /**
	   * Get an {@link HtmlTrackElement} from the `HtmlTrackElementList` given an
	   * {@link TextTrack}.
	   *
	   * @param {TextTrack} track
	   *        The track associated with a track element.
	   *
	   * @return {HtmlTrackElement|undefined}
	   *         The track element that was found or undefined.
	   *
	   * @private
	   */
	
	
	  HtmlTrackElementList.prototype.getTrackElementByTrack_ = function getTrackElementByTrack_(track) {
	    var trackElement_ = void 0;
	
	    for (var i = 0, length = this.trackElements_.length; i < length; i++) {
	      if (track === this.trackElements_[i].track) {
	        trackElement_ = this.trackElements_[i];
	
	        break;
	      }
	    }
	
	    return trackElement_;
	  };
	
	  /**
	   * Remove a {@link HtmlTrackElement} from the `HtmlTrackElementList`
	   *
	   * @param {HtmlTrackElement} trackElement
	   *        The track element to remove from the list.
	   *
	   * @private
	   */
	
	
	  HtmlTrackElementList.prototype.removeTrackElement_ = function removeTrackElement_(trackElement) {
	    for (var i = 0, length = this.trackElements_.length; i < length; i++) {
	      if (trackElement === this.trackElements_[i]) {
	        this.trackElements_.splice(i, 1);
	
	        break;
	      }
	    }
	  };
	
	  return HtmlTrackElementList;
	}();
	
	/**
	 * @file text-track-cue-list.js
	 */
	
	/**
	 * @typedef {Object} TextTrackCueList~TextTrackCue
	 *
	 * @property {string} id
	 *           The unique id for this text track cue
	 *
	 * @property {number} startTime
	 *           The start time for this text track cue
	 *
	 * @property {number} endTime
	 *           The end time for this text track cue
	 *
	 * @property {boolean} pauseOnExit
	 *           Pause when the end time is reached if true.
	 *
	 * @see [Spec]{@link https://html.spec.whatwg.org/multipage/embedded-content.html#texttrackcue}
	 */
	
	/**
	 * A List of TextTrackCues.
	 *
	 * @see [Spec]{@link https://html.spec.whatwg.org/multipage/embedded-content.html#texttrackcuelist}
	 */
	var TextTrackCueList = function () {
	
	  /**
	   * Create an instance of this class..
	   *
	   * @param {Array} cues
	   *        A list of cues to be initialized with
	   */
	  function TextTrackCueList(cues) {
	    classCallCheck(this, TextTrackCueList);
	
	    TextTrackCueList.prototype.setCues_.call(this, cues);
	
	    /**
	     * @memberof TextTrackCueList
	     * @member {number} length
	     *         The current number of `TextTrackCue`s in the TextTrackCueList.
	     * @instance
	     */
	    Object.defineProperty(this, 'length', {
	      get: function get$$1() {
	        return this.length_;
	      }
	    });
	  }
	
	  /**
	   * A setter for cues in this list. Creates getters
	   * an an index for the cues.
	   *
	   * @param {Array} cues
	   *        An array of cues to set
	   *
	   * @private
	   */
	
	
	  TextTrackCueList.prototype.setCues_ = function setCues_(cues) {
	    var oldLength = this.length || 0;
	    var i = 0;
	    var l = cues.length;
	
	    this.cues_ = cues;
	    this.length_ = cues.length;
	
	    var defineProp = function defineProp(index) {
	      if (!('' + index in this)) {
	        Object.defineProperty(this, '' + index, {
	          get: function get$$1() {
	            return this.cues_[index];
	          }
	        });
	      }
	    };
	
	    if (oldLength < l) {
	      i = oldLength;
	
	      for (; i < l; i++) {
	        defineProp.call(this, i);
	      }
	    }
	  };
	
	  /**
	   * Get a `TextTrackCue` that is currently in the `TextTrackCueList` by id.
	   *
	   * @param {string} id
	   *        The id of the cue that should be searched for.
	   *
	   * @return {TextTrackCueList~TextTrackCue|null}
	   *         A single cue or null if none was found.
	   */
	
	
	  TextTrackCueList.prototype.getCueById = function getCueById(id) {
	    var result = null;
	
	    for (var i = 0, l = this.length; i < l; i++) {
	      var cue = this[i];
	
	      if (cue.id === id) {
	        result = cue;
	        break;
	      }
	    }
	
	    return result;
	  };
	
	  return TextTrackCueList;
	}();
	
	/**
	 * @file track-kinds.js
	 */
	
	/**
	 * All possible `VideoTrackKind`s
	 *
	 * @see https://html.spec.whatwg.org/multipage/embedded-content.html#dom-videotrack-kind
	 * @typedef VideoTrack~Kind
	 * @enum
	 */
	var VideoTrackKind = {
	  alternative: 'alternative',
	  captions: 'captions',
	  main: 'main',
	  sign: 'sign',
	  subtitles: 'subtitles',
	  commentary: 'commentary'
	};
	
	/**
	 * All possible `AudioTrackKind`s
	 *
	 * @see https://html.spec.whatwg.org/multipage/embedded-content.html#dom-audiotrack-kind
	 * @typedef AudioTrack~Kind
	 * @enum
	 */
	var AudioTrackKind = {
	  'alternative': 'alternative',
	  'descriptions': 'descriptions',
	  'main': 'main',
	  'main-desc': 'main-desc',
	  'translation': 'translation',
	  'commentary': 'commentary'
	};
	
	/**
	 * All possible `TextTrackKind`s
	 *
	 * @see https://html.spec.whatwg.org/multipage/embedded-content.html#dom-texttrack-kind
	 * @typedef TextTrack~Kind
	 * @enum
	 */
	var TextTrackKind = {
	  subtitles: 'subtitles',
	  captions: 'captions',
	  descriptions: 'descriptions',
	  chapters: 'chapters',
	  metadata: 'metadata'
	};
	
	/**
	 * All possible `TextTrackMode`s
	 *
	 * @see https://html.spec.whatwg.org/multipage/embedded-content.html#texttrackmode
	 * @typedef TextTrack~Mode
	 * @enum
	 */
	var TextTrackMode = {
	  disabled: 'disabled',
	  hidden: 'hidden',
	  showing: 'showing'
	};
	
	/**
	 * @file track.js
	 */
	
	/**
	 * A Track class that contains all of the common functionality for {@link AudioTrack},
	 * {@link VideoTrack}, and {@link TextTrack}.
	 *
	 * > Note: This class should not be used directly
	 *
	 * @see {@link https://html.spec.whatwg.org/multipage/embedded-content.html}
	 * @extends EventTarget
	 * @abstract
	 */
	
	var Track = function (_EventTarget) {
	  inherits(Track, _EventTarget);
	
	  /**
	   * Create an instance of this class.
	   *
	   * @param {Object} [options={}]
	   *        Object of option names and values
	   *
	   * @param {string} [options.kind='']
	   *        A valid kind for the track type you are creating.
	   *
	   * @param {string} [options.id='vjs_track_' + Guid.newGUID()]
	   *        A unique id for this AudioTrack.
	   *
	   * @param {string} [options.label='']
	   *        The menu label for this track.
	   *
	   * @param {string} [options.language='']
	   *        A valid two character language code.
	   *
	   * @abstract
	   */
	  function Track() {
	    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	    classCallCheck(this, Track);
	
	    var _this = possibleConstructorReturn(this, _EventTarget.call(this));
	
	    var trackProps = {
	      id: options.id || 'vjs_track_' + newGUID(),
	      kind: options.kind || '',
	      label: options.label || '',
	      language: options.language || ''
	    };
	
	    /**
	     * @memberof Track
	     * @member {string} id
	     *         The id of this track. Cannot be changed after creation.
	     * @instance
	     *
	     * @readonly
	     */
	
	    /**
	     * @memberof Track
	     * @member {string} kind
	     *         The kind of track that this is. Cannot be changed after creation.
	     * @instance
	     *
	     * @readonly
	     */
	
	    /**
	     * @memberof Track
	     * @member {string} label
	     *         The label of this track. Cannot be changed after creation.
	     * @instance
	     *
	     * @readonly
	     */
	
	    /**
	     * @memberof Track
	     * @member {string} language
	     *         The two letter language code for this track. Cannot be changed after
	     *         creation.
	     * @instance
	     *
	     * @readonly
	     */
	
	    var _loop = function _loop(key) {
	      Object.defineProperty(_this, key, {
	        get: function get$$1() {
	          return trackProps[key];
	        },
	        set: function set$$1() {}
	      });
	    };
	
	    for (var key in trackProps) {
	      _loop(key);
	    }
	    return _this;
	  }
	
	  return Track;
	}(EventTarget);
	
	/**
	 * @file url.js
	 * @module url
	 */
	
	/**
	 * @typedef {Object} url:URLObject
	 *
	 * @property {string} protocol
	 *           The protocol of the url that was parsed.
	 *
	 * @property {string} hostname
	 *           The hostname of the url that was parsed.
	 *
	 * @property {string} port
	 *           The port of the url that was parsed.
	 *
	 * @property {string} pathname
	 *           The pathname of the url that was parsed.
	 *
	 * @property {string} search
	 *           The search query of the url that was parsed.
	 *
	 * @property {string} hash
	 *           The hash of the url that was parsed.
	 *
	 * @property {string} host
	 *           The host of the url that was parsed.
	 */
	
	/**
	 * Resolve and parse the elements of a URL.
	 *
	 * @param  {String} url
	 *         The url to parse
	 *
	 * @return {url:URLObject}
	 *         An object of url details
	 */
	var parseUrl = function parseUrl(url) {
	  var props = ['protocol', 'hostname', 'port', 'pathname', 'search', 'hash', 'host'];
	
	  // add the url to an anchor and let the browser parse the URL
	  var a = document.createElement('a');
	
	  a.href = url;
	
	  // IE8 (and 9?) Fix
	  // ie8 doesn't parse the URL correctly until the anchor is actually
	  // added to the body, and an innerHTML is needed to trigger the parsing
	  var addToBody = a.host === '' && a.protocol !== 'file:';
	  var div = void 0;
	
	  if (addToBody) {
	    div = document.createElement('div');
	    div.innerHTML = '<a href="' + url + '"></a>';
	    a = div.firstChild;
	    // prevent the div from affecting layout
	    div.setAttribute('style', 'display:none; position:absolute;');
	    document.body.appendChild(div);
	  }
	
	  // Copy the specific URL properties to a new object
	  // This is also needed for IE8 because the anchor loses its
	  // properties when it's removed from the dom
	  var details = {};
	
	  for (var i = 0; i < props.length; i++) {
	    details[props[i]] = a[props[i]];
	  }
	
	  // IE9 adds the port to the host property unlike everyone else. If
	  // a port identifier is added for standard ports, strip it.
	  if (details.protocol === 'http:') {
	    details.host = details.host.replace(/:80$/, '');
	  }
	
	  if (details.protocol === 'https:') {
	    details.host = details.host.replace(/:443$/, '');
	  }
	
	  if (!details.protocol) {
	    details.protocol = window$1.location.protocol;
	  }
	
	  if (addToBody) {
	    document.body.removeChild(div);
	  }
	
	  return details;
	};
	
	/**
	 * Get absolute version of relative URL. Used to tell flash correct URL.
	 *
	 *
	 * @param  {string} url
	 *         URL to make absolute
	 *
	 * @return {string}
	 *         Absolute URL
	 *
	 * @see http://stackoverflow.com/questions/470832/getting-an-absolute-url-from-a-relative-one-ie6-issue
	 */
	var getAbsoluteURL = function getAbsoluteURL(url) {
	  // Check if absolute URL
	  if (!url.match(/^https?:\/\//)) {
	    // Convert to absolute URL. Flash hosted off-site needs an absolute URL.
	    var div = document.createElement('div');
	
	    div.innerHTML = '<a href="' + url + '">x</a>';
	    url = div.firstChild.href;
	  }
	
	  return url;
	};
	
	/**
	 * Returns the extension of the passed file name. It will return an empty string
	 * if passed an invalid path.
	 *
	 * @param {string} path
	 *        The fileName path like '/path/to/file.mp4'
	 *
	 * @returns {string}
	 *          The extension in lower case or an empty string if no
	 *          extension could be found.
	 */
	var getFileExtension = function getFileExtension(path) {
	  if (typeof path === 'string') {
	    var splitPathRe = /^(\/?)([\s\S]*?)((?:\.{1,2}|[^\/]+?)(\.([^\.\/\?]+)))(?:[\/]*|[\?].*)$/i;
	    var pathParts = splitPathRe.exec(path);
	
	    if (pathParts) {
	      return pathParts.pop().toLowerCase();
	    }
	  }
	
	  return '';
	};
	
	/**
	 * Returns whether the url passed is a cross domain request or not.
	 *
	 * @param {string} url
	 *        The url to check.
	 *
	 * @return {boolean}
	 *         Whether it is a cross domain request or not.
	 */
	var isCrossOrigin = function isCrossOrigin(url) {
	  var winLoc = window$1.location;
	  var urlInfo = parseUrl(url);
	
	  // IE8 protocol relative urls will return ':' for protocol
	  var srcProtocol = urlInfo.protocol === ':' ? winLoc.protocol : urlInfo.protocol;
	
	  // Check if url is for another domain/origin
	  // IE8 doesn't know location.origin, so we won't rely on it here
	  var crossOrigin = srcProtocol + urlInfo.host !== winLoc.protocol + winLoc.host;
	
	  return crossOrigin;
	};
	
	var Url = /*#__PURE__*/Object.freeze({
	  parseUrl: parseUrl,
	  getAbsoluteURL: getAbsoluteURL,
	  getFileExtension: getFileExtension,
	  isCrossOrigin: isCrossOrigin
	});
	
	/**
	 * @file text-track.js
	 */
	
	/**
	 * Takes a webvtt file contents and parses it into cues
	 *
	 * @param {string} srcContent
	 *        webVTT file contents
	 *
	 * @param {TextTrack} track
	 *        TextTrack to add cues to. Cues come from the srcContent.
	 *
	 * @private
	 */
	var parseCues = function parseCues(srcContent, track) {
	  var parser = new window$1.WebVTT.Parser(window$1, window$1.vttjs, window$1.WebVTT.StringDecoder());
	  var errors = [];
	
	  parser.oncue = function (cue) {
	    track.addCue(cue);
	  };
	
	  parser.onparsingerror = function (error) {
	    errors.push(error);
	  };
	
	  parser.onflush = function () {
	    track.trigger({
	      type: 'loadeddata',
	      target: track
	    });
	  };
	
	  parser.parse(srcContent);
	  if (errors.length > 0) {
	    if (window$1.console && window$1.console.groupCollapsed) {
	      window$1.console.groupCollapsed('Text Track parsing errors for ' + track.src);
	    }
	    errors.forEach(function (error) {
	      return log$1.error(error);
	    });
	    if (window$1.console && window$1.console.groupEnd) {
	      window$1.console.groupEnd();
	    }
	  }
	
	  parser.flush();
	};
	
	/**
	 * Load a `TextTrack` from a specified url.
	 *
	 * @param {string} src
	 *        Url to load track from.
	 *
	 * @param {TextTrack} track
	 *        Track to add cues to. Comes from the content at the end of `url`.
	 *
	 * @private
	 */
	var loadTrack = function loadTrack(src, track) {
	  var opts = {
	    uri: src
	  };
	  var crossOrigin = isCrossOrigin(src);
	
	  if (crossOrigin) {
	    opts.cors = crossOrigin;
	  }
	
	  xhr(opts, bind(this, function (err, response, responseBody) {
	    if (err) {
	      return log$1.error(err, response);
	    }
	
	    track.loaded_ = true;
	
	    // Make sure that vttjs has loaded, otherwise, wait till it finished loading
	    // NOTE: this is only used for the alt/video.novtt.js build
	    if (typeof window$1.WebVTT !== 'function') {
	      if (track.tech_) {
	        var loadHandler = function loadHandler() {
	          return parseCues(responseBody, track);
	        };
	
	        track.tech_.on('vttjsloaded', loadHandler);
	        track.tech_.on('vttjserror', function () {
	          log$1.error('vttjs failed to load, stopping trying to process ' + track.src);
	          track.tech_.off('vttjsloaded', loadHandler);
	        });
	      }
	    } else {
	      parseCues(responseBody, track);
	    }
	  }));
	};
	
	/**
	 * A representation of a single `TextTrack`.
	 *
	 * @see [Spec]{@link https://html.spec.whatwg.org/multipage/embedded-content.html#texttrack}
	 * @extends Track
	 */
	
	var TextTrack = function (_Track) {
	  inherits(TextTrack, _Track);
	
	  /**
	   * Create an instance of this class.
	   *
	   * @param {Object} options={}
	   *        Object of option names and values
	   *
	   * @param {Tech} options.tech
	   *        A reference to the tech that owns this TextTrack.
	   *
	   * @param {TextTrack~Kind} [options.kind='subtitles']
	   *        A valid text track kind.
	   *
	   * @param {TextTrack~Mode} [options.mode='disabled']
	   *        A valid text track mode.
	   *
	   * @param {string} [options.id='vjs_track_' + Guid.newGUID()]
	   *        A unique id for this TextTrack.
	   *
	   * @param {string} [options.label='']
	   *        The menu label for this track.
	   *
	   * @param {string} [options.language='']
	   *        A valid two character language code.
	   *
	   * @param {string} [options.srclang='']
	   *        A valid two character language code. An alternative, but deprioritized
	   *        version of `options.language`
	   *
	   * @param {string} [options.src]
	   *        A url to TextTrack cues.
	   *
	   * @param {boolean} [options.default]
	   *        If this track should default to on or off.
	   */
	  function TextTrack() {
	    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	    classCallCheck(this, TextTrack);
	
	    if (!options.tech) {
	      throw new Error('A tech was not provided.');
	    }
	
	    var settings = mergeOptions(options, {
	      kind: TextTrackKind[options.kind] || 'subtitles',
	      language: options.language || options.srclang || ''
	    });
	    var mode = TextTrackMode[settings.mode] || 'disabled';
	    var default_ = settings.default;
	
	    if (settings.kind === 'metadata' || settings.kind === 'chapters') {
	      mode = 'hidden';
	    }
	
	    var _this = possibleConstructorReturn(this, _Track.call(this, settings));
	
	    _this.tech_ = settings.tech;
	
	    _this.cues_ = [];
	    _this.activeCues_ = [];
	
	    var cues = new TextTrackCueList(_this.cues_);
	    var activeCues = new TextTrackCueList(_this.activeCues_);
	    var changed = false;
	    var timeupdateHandler = bind(_this, function () {
	
	      // Accessing this.activeCues for the side-effects of updating itself
	      // due to it's nature as a getter function. Do not remove or cues will
	      // stop updating!
	      // Use the setter to prevent deletion from uglify (pure_getters rule)
	      this.activeCues = this.activeCues;
	      if (changed) {
	        this.trigger('cuechange');
	        changed = false;
	      }
	    });
	
	    if (mode !== 'disabled') {
	      _this.tech_.ready(function () {
	        _this.tech_.on('timeupdate', timeupdateHandler);
	      }, true);
	    }
	
	    Object.defineProperties(_this, {
	      /**
	       * @memberof TextTrack
	       * @member {boolean} default
	       *         If this track was set to be on or off by default. Cannot be changed after
	       *         creation.
	       * @instance
	       *
	       * @readonly
	       */
	      default: {
	        get: function get$$1() {
	          return default_;
	        },
	        set: function set$$1() {}
	      },
	
	      /**
	       * @memberof TextTrack
	       * @member {string} mode
	       *         Set the mode of this TextTrack to a valid {@link TextTrack~Mode}. Will
	       *         not be set if setting to an invalid mode.
	       * @instance
	       *
	       * @fires TextTrack#modechange
	       */
	      mode: {
	        get: function get$$1() {
	          return mode;
	        },
	        set: function set$$1(newMode) {
	          var _this2 = this;
	
	          if (!TextTrackMode[newMode]) {
	            return;
	          }
	          mode = newMode;
	          if (mode === 'showing') {
	
	            this.tech_.ready(function () {
	              _this2.tech_.on('timeupdate', timeupdateHandler);
	            }, true);
	          }
	          /**
	           * An event that fires when mode changes on this track. This allows
	           * the TextTrackList that holds this track to act accordingly.
	           *
	           * > Note: This is not part of the spec!
	           *
	           * @event TextTrack#modechange
	           * @type {EventTarget~Event}
	           */
	          this.trigger('modechange');
	        }
	      },
	
	      /**
	       * @memberof TextTrack
	       * @member {TextTrackCueList} cues
	       *         The text track cue list for this TextTrack.
	       * @instance
	       */
	      cues: {
	        get: function get$$1() {
	          if (!this.loaded_) {
	            return null;
	          }
	
	          return cues;
	        },
	        set: function set$$1() {}
	      },
	
	      /**
	       * @memberof TextTrack
	       * @member {TextTrackCueList} activeCues
	       *         The list text track cues that are currently active for this TextTrack.
	       * @instance
	       */
	      activeCues: {
	        get: function get$$1() {
	          if (!this.loaded_) {
	            return null;
	          }
	
	          // nothing to do
	          if (this.cues.length === 0) {
	            return activeCues;
	          }
	
	          var ct = this.tech_.currentTime();
	          var active = [];
	
	          for (var i = 0, l = this.cues.length; i < l; i++) {
	            var cue = this.cues[i];
	
	            if (cue.startTime <= ct && cue.endTime >= ct) {
	              active.push(cue);
	            } else if (cue.startTime === cue.endTime && cue.startTime <= ct && cue.startTime + 0.5 >= ct) {
	              active.push(cue);
	            }
	          }
	
	          changed = false;
	
	          if (active.length !== this.activeCues_.length) {
	            changed = true;
	          } else {
	            for (var _i = 0; _i < active.length; _i++) {
	              if (this.activeCues_.indexOf(active[_i]) === -1) {
	                changed = true;
	              }
	            }
	          }
	
	          this.activeCues_ = active;
	          activeCues.setCues_(this.activeCues_);
	
	          return activeCues;
	        },
	
	
	        // /!\ Keep this setter empty (see the timeupdate handler above)
	        set: function set$$1() {}
	      }
	    });
	
	    if (settings.src) {
	      _this.src = settings.src;
	      loadTrack(settings.src, _this);
	    } else {
	      _this.loaded_ = true;
	    }
	    return _this;
	  }
	
	  /**
	   * Add a cue to the internal list of cues.
	   *
	   * @param {TextTrack~Cue} cue
	   *        The cue to add to our internal list
	   */
	
	
	  TextTrack.prototype.addCue = function addCue(originalCue) {
	    var cue = originalCue;
	
	    if (window$1.vttjs && !(originalCue instanceof window$1.vttjs.VTTCue)) {
	      cue = new window$1.vttjs.VTTCue(originalCue.startTime, originalCue.endTime, originalCue.text);
	
	      for (var prop in originalCue) {
	        if (!(prop in cue)) {
	          cue[prop] = originalCue[prop];
	        }
	      }
	
	      // make sure that `id` is copied over
	      cue.id = originalCue.id;
	      cue.originalCue_ = originalCue;
	    }
	
	    var tracks = this.tech_.textTracks();
	
	    for (var i = 0; i < tracks.length; i++) {
	      if (tracks[i] !== this) {
	        tracks[i].removeCue(cue);
	      }
	    }
	
	    this.cues_.push(cue);
	    this.cues.setCues_(this.cues_);
	  };
	
	  /**
	   * Remove a cue from our internal list
	   *
	   * @param {TextTrack~Cue} removeCue
	   *        The cue to remove from our internal list
	   */
	
	
	  TextTrack.prototype.removeCue = function removeCue(_removeCue) {
	    var i = this.cues_.length;
	
	    while (i--) {
	      var cue = this.cues_[i];
	
	      if (cue === _removeCue || cue.originalCue_ && cue.originalCue_ === _removeCue) {
	        this.cues_.splice(i, 1);
	        this.cues.setCues_(this.cues_);
	        break;
	      }
	    }
	  };
	
	  return TextTrack;
	}(Track);
	
	/**
	 * cuechange - One or more cues in the track have become active or stopped being active.
	 */
	
	
	TextTrack.prototype.allowedEvents_ = {
	  cuechange: 'cuechange'
	};
	
	/**
	 * A representation of a single `AudioTrack`. If it is part of an {@link AudioTrackList}
	 * only one `AudioTrack` in the list will be enabled at a time.
	 *
	 * @see [Spec]{@link https://html.spec.whatwg.org/multipage/embedded-content.html#audiotrack}
	 * @extends Track
	 */
	
	var AudioTrack = function (_Track) {
	  inherits(AudioTrack, _Track);
	
	  /**
	   * Create an instance of this class.
	   *
	   * @param {Object} [options={}]
	   *        Object of option names and values
	   *
	   * @param {AudioTrack~Kind} [options.kind='']
	   *        A valid audio track kind
	   *
	   * @param {string} [options.id='vjs_track_' + Guid.newGUID()]
	   *        A unique id for this AudioTrack.
	   *
	   * @param {string} [options.label='']
	   *        The menu label for this track.
	   *
	   * @param {string} [options.language='']
	   *        A valid two character language code.
	   *
	   * @param {boolean} [options.enabled]
	   *        If this track is the one that is currently playing. If this track is part of
	   *        an {@link AudioTrackList}, only one {@link AudioTrack} will be enabled.
	   */
	  function AudioTrack() {
	    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	    classCallCheck(this, AudioTrack);
	
	    var settings = mergeOptions(options, {
	      kind: AudioTrackKind[options.kind] || ''
	    });
	
	    var _this = possibleConstructorReturn(this, _Track.call(this, settings));
	
	    var enabled = false;
	
	    /**
	     * @memberof AudioTrack
	     * @member {boolean} enabled
	     *         If this `AudioTrack` is enabled or not. When setting this will
	     *         fire {@link AudioTrack#enabledchange} if the state of enabled is changed.
	     * @instance
	     *
	     * @fires VideoTrack#selectedchange
	     */
	    Object.defineProperty(_this, 'enabled', {
	      get: function get$$1() {
	        return enabled;
	      },
	      set: function set$$1(newEnabled) {
	        // an invalid or unchanged value
	        if (typeof newEnabled !== 'boolean' || newEnabled === enabled) {
	          return;
	        }
	        enabled = newEnabled;
	
	        /**
	         * An event that fires when enabled changes on this track. This allows
	         * the AudioTrackList that holds this track to act accordingly.
	         *
	         * > Note: This is not part of the spec! Native tracks will do
	         *         this internally without an event.
	         *
	         * @event AudioTrack#enabledchange
	         * @type {EventTarget~Event}
	         */
	        this.trigger('enabledchange');
	      }
	    });
	
	    // if the user sets this track to selected then
	    // set selected to that true value otherwise
	    // we keep it false
	    if (settings.enabled) {
	      _this.enabled = settings.enabled;
	    }
	    _this.loaded_ = true;
	    return _this;
	  }
	
	  return AudioTrack;
	}(Track);
	
	/**
	 * A representation of a single `VideoTrack`.
	 *
	 * @see [Spec]{@link https://html.spec.whatwg.org/multipage/embedded-content.html#videotrack}
	 * @extends Track
	 */
	
	var VideoTrack = function (_Track) {
	  inherits(VideoTrack, _Track);
	
	  /**
	   * Create an instance of this class.
	   *
	   * @param {Object} [options={}]
	   *        Object of option names and values
	   *
	   * @param {string} [options.kind='']
	   *        A valid {@link VideoTrack~Kind}
	   *
	   * @param {string} [options.id='vjs_track_' + Guid.newGUID()]
	   *        A unique id for this AudioTrack.
	   *
	   * @param {string} [options.label='']
	   *        The menu label for this track.
	   *
	   * @param {string} [options.language='']
	   *        A valid two character language code.
	   *
	   * @param {boolean} [options.selected]
	   *        If this track is the one that is currently playing.
	   */
	  function VideoTrack() {
	    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	    classCallCheck(this, VideoTrack);
	
	    var settings = mergeOptions(options, {
	      kind: VideoTrackKind[options.kind] || ''
	    });
	
	    var _this = possibleConstructorReturn(this, _Track.call(this, settings));
	
	    var selected = false;
	
	    /**
	     * @memberof VideoTrack
	     * @member {boolean} selected
	     *         If this `VideoTrack` is selected or not. When setting this will
	     *         fire {@link VideoTrack#selectedchange} if the state of selected changed.
	     * @instance
	     *
	     * @fires VideoTrack#selectedchange
	     */
	    Object.defineProperty(_this, 'selected', {
	      get: function get$$1() {
	        return selected;
	      },
	      set: function set$$1(newSelected) {
	        // an invalid or unchanged value
	        if (typeof newSelected !== 'boolean' || newSelected === selected) {
	          return;
	        }
	        selected = newSelected;
	
	        /**
	         * An event that fires when selected changes on this track. This allows
	         * the VideoTrackList that holds this track to act accordingly.
	         *
	         * > Note: This is not part of the spec! Native tracks will do
	         *         this internally without an event.
	         *
	         * @event VideoTrack#selectedchange
	         * @type {EventTarget~Event}
	         */
	        this.trigger('selectedchange');
	      }
	    });
	
	    // if the user sets this track to selected then
	    // set selected to that true value otherwise
	    // we keep it false
	    if (settings.selected) {
	      _this.selected = settings.selected;
	    }
	    return _this;
	  }
	
	  return VideoTrack;
	}(Track);
	
	/**
	 * @file html-track-element.js
	 */
	
	/**
	 * @memberof HTMLTrackElement
	 * @typedef {HTMLTrackElement~ReadyState}
	 * @enum {number}
	 */
	var NONE = 0;
	var LOADING = 1;
	var LOADED = 2;
	var ERROR = 3;
	
	/**
	 * A single track represented in the DOM.
	 *
	 * @see [Spec]{@link https://html.spec.whatwg.org/multipage/embedded-content.html#htmltrackelement}
	 * @extends EventTarget
	 */
	
	var HTMLTrackElement = function (_EventTarget) {
	  inherits(HTMLTrackElement, _EventTarget);
	
	  /**
	   * Create an instance of this class.
	   *
	   * @param {Object} options={}
	   *        Object of option names and values
	   *
	   * @param {Tech} options.tech
	   *        A reference to the tech that owns this HTMLTrackElement.
	   *
	   * @param {TextTrack~Kind} [options.kind='subtitles']
	   *        A valid text track kind.
	   *
	   * @param {TextTrack~Mode} [options.mode='disabled']
	   *        A valid text track mode.
	   *
	   * @param {string} [options.id='vjs_track_' + Guid.newGUID()]
	   *        A unique id for this TextTrack.
	   *
	   * @param {string} [options.label='']
	   *        The menu label for this track.
	   *
	   * @param {string} [options.language='']
	   *        A valid two character language code.
	   *
	   * @param {string} [options.srclang='']
	   *        A valid two character language code. An alternative, but deprioritized
	   *        vesion of `options.language`
	   *
	   * @param {string} [options.src]
	   *        A url to TextTrack cues.
	   *
	   * @param {boolean} [options.default]
	   *        If this track should default to on or off.
	   */
	  function HTMLTrackElement() {
	    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	    classCallCheck(this, HTMLTrackElement);
	
	    var _this = possibleConstructorReturn(this, _EventTarget.call(this));
	
	    var readyState = void 0;
	
	    var track = new TextTrack(options);
	
	    _this.kind = track.kind;
	    _this.src = track.src;
	    _this.srclang = track.language;
	    _this.label = track.label;
	    _this.default = track.default;
	
	    Object.defineProperties(_this, {
	
	      /**
	       * @memberof HTMLTrackElement
	       * @member {HTMLTrackElement~ReadyState} readyState
	       *         The current ready state of the track element.
	       * @instance
	       */
	      readyState: {
	        get: function get$$1() {
	          return readyState;
	        }
	      },
	
	      /**
	       * @memberof HTMLTrackElement
	       * @member {TextTrack} track
	       *         The underlying TextTrack object.
	       * @instance
	       *
	       */
	      track: {
	        get: function get$$1() {
	          return track;
	        }
	      }
	    });
	
	    readyState = NONE;
	
	    /**
	     * @listens TextTrack#loadeddata
	     * @fires HTMLTrackElement#load
	     */
	    track.addEventListener('loadeddata', function () {
	      readyState = LOADED;
	
	      _this.trigger({
	        type: 'load',
	        target: _this
	      });
	    });
	    return _this;
	  }
	
	  return HTMLTrackElement;
	}(EventTarget);
	
	HTMLTrackElement.prototype.allowedEvents_ = {
	  load: 'load'
	};
	
	HTMLTrackElement.NONE = NONE;
	HTMLTrackElement.LOADING = LOADING;
	HTMLTrackElement.LOADED = LOADED;
	HTMLTrackElement.ERROR = ERROR;
	
	/*
	 * This file contains all track properties that are used in
	 * player.js, tech.js, html5.js and possibly other techs in the future.
	 */
	
	var NORMAL = {
	  audio: {
	    ListClass: AudioTrackList,
	    TrackClass: AudioTrack,
	    capitalName: 'Audio'
	  },
	  video: {
	    ListClass: VideoTrackList,
	    TrackClass: VideoTrack,
	    capitalName: 'Video'
	  },
	  text: {
	    ListClass: TextTrackList,
	    TrackClass: TextTrack,
	    capitalName: 'Text'
	  }
	};
	
	Object.keys(NORMAL).forEach(function (type) {
	  NORMAL[type].getterName = type + 'Tracks';
	  NORMAL[type].privateName = type + 'Tracks_';
	});
	
	var REMOTE = {
	  remoteText: {
	    ListClass: TextTrackList,
	    TrackClass: TextTrack,
	    capitalName: 'RemoteText',
	    getterName: 'remoteTextTracks',
	    privateName: 'remoteTextTracks_'
	  },
	  remoteTextEl: {
	    ListClass: HtmlTrackElementList,
	    TrackClass: HTMLTrackElement,
	    capitalName: 'RemoteTextTrackEls',
	    getterName: 'remoteTextTrackEls',
	    privateName: 'remoteTextTrackEls_'
	  }
	};
	
	var ALL = mergeOptions(NORMAL, REMOTE);
	
	REMOTE.names = Object.keys(REMOTE);
	NORMAL.names = Object.keys(NORMAL);
	ALL.names = [].concat(REMOTE.names).concat(NORMAL.names);
	
	/**
	 * @file tech.js
	 */
	
	/**
	 * An Object containing a structure like: `{src: 'url', type: 'mimetype'}` or string
	 * that just contains the src url alone.
	 * * `var SourceObject = {src: 'http://ex.com/video.mp4', type: 'video/mp4'};`
	   * `var SourceString = 'http://example.com/some-video.mp4';`
	 *
	 * @typedef {Object|string} Tech~SourceObject
	 *
	 * @property {string} src
	 *           The url to the source
	 *
	 * @property {string} type
	 *           The mime type of the source
	 */
	
	/**
	 * A function used by {@link Tech} to create a new {@link TextTrack}.
	 *
	 * @private
	 *
	 * @param {Tech} self
	 *        An instance of the Tech class.
	 *
	 * @param {string} kind
	 *        `TextTrack` kind (subtitles, captions, descriptions, chapters, or metadata)
	 *
	 * @param {string} [label]
	 *        Label to identify the text track
	 *
	 * @param {string} [language]
	 *        Two letter language abbreviation
	 *
	 * @param {Object} [options={}]
	 *        An object with additional text track options
	 *
	 * @return {TextTrack}
	 *          The text track that was created.
	 */
	function createTrackHelper(self, kind, label, language) {
	  var options = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {};
	
	  var tracks = self.textTracks();
	
	  options.kind = kind;
	
	  if (label) {
	    options.label = label;
	  }
	  if (language) {
	    options.language = language;
	  }
	  options.tech = self;
	
	  var track = new ALL.text.TrackClass(options);
	
	  tracks.addTrack(track);
	
	  return track;
	}
	
	/**
	 * This is the base class for media playback technology controllers, such as
	 * {@link Flash} and {@link HTML5}
	 *
	 * @extends Component
	 */
	
	var Tech = function (_Component) {
	  inherits(Tech, _Component);
	
	  /**
	   * Create an instance of this Tech.
	   *
	   * @param {Object} [options]
	   *        The key/value store of player options.
	   *
	   * @param {Component~ReadyCallback} ready
	   *        Callback function to call when the `HTML5` Tech is ready.
	   */
	  function Tech() {
	    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	    var ready = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function () {};
	    classCallCheck(this, Tech);
	
	    // we don't want the tech to report user activity automatically.
	    // This is done manually in addControlsListeners
	    options.reportTouchActivity = false;
	
	    // keep track of whether the current source has played at all to
	    // implement a very limited played()
	    var _this = possibleConstructorReturn(this, _Component.call(this, null, options, ready));
	
	    _this.hasStarted_ = false;
	    _this.on('playing', function () {
	      this.hasStarted_ = true;
	    });
	    _this.on('loadstart', function () {
	      this.hasStarted_ = false;
	    });
	
	    ALL.names.forEach(function (name) {
	      var props = ALL[name];
	
	      if (options && options[props.getterName]) {
	        _this[props.privateName] = options[props.getterName];
	      }
	    });
	
	    // Manually track progress in cases where the browser/flash player doesn't report it.
	    if (!_this.featuresProgressEvents) {
	      _this.manualProgressOn();
	    }
	
	    // Manually track timeupdates in cases where the browser/flash player doesn't report it.
	    if (!_this.featuresTimeupdateEvents) {
	      _this.manualTimeUpdatesOn();
	    }
	
	    ['Text', 'Audio', 'Video'].forEach(function (track) {
	      if (options['native' + track + 'Tracks'] === false) {
	        _this['featuresNative' + track + 'Tracks'] = false;
	      }
	    });
	
	    if (options.nativeCaptions === false || options.nativeTextTracks === false) {
	      _this.featuresNativeTextTracks = false;
	    } else if (options.nativeCaptions === true || options.nativeTextTracks === true) {
	      _this.featuresNativeTextTracks = true;
	    }
	
	    if (!_this.featuresNativeTextTracks) {
	      _this.emulateTextTracks();
	    }
	
	    _this.autoRemoteTextTracks_ = new ALL.text.ListClass();
	
	    _this.initTrackListeners();
	
	    // Turn on component tap events only if not using native controls
	    if (!options.nativeControlsForTouch) {
	      _this.emitTapEvents();
	    }
	
	    if (_this.constructor) {
	      _this.name_ = _this.constructor.name || 'Unknown Tech';
	    }
	    return _this;
	  }
	
	  /**
	   * A special function to trigger source set in a way that will allow player
	   * to re-trigger if the player or tech are not ready yet.
	   *
	   * @fires Tech#sourceset
	   * @param {string} src The source string at the time of the source changing.
	   */
	
	
	  Tech.prototype.triggerSourceset = function triggerSourceset(src) {
	    var _this2 = this;
	
	    if (!this.isReady_) {
	      // on initial ready we have to trigger source set
	      // 1ms after ready so that player can watch for it.
	      this.one('ready', function () {
	        return _this2.setTimeout(function () {
	          return _this2.triggerSourceset(src);
	        }, 1);
	      });
	    }
	
	    /**
	     * Fired when the source is set on the tech causing the media element
	     * to reload.
	     *
	     * @see {@link Player#event:sourceset}
	     * @event Tech#sourceset
	     * @type {EventTarget~Event}
	     */
	    this.trigger({
	      src: src,
	      type: 'sourceset'
	    });
	  };
	
	  /* Fallbacks for unsupported event types
	  ================================================================================ */
	
	  /**
	   * Polyfill the `progress` event for browsers that don't support it natively.
	   *
	   * @see {@link Tech#trackProgress}
	   */
	
	
	  Tech.prototype.manualProgressOn = function manualProgressOn() {
	    this.on('durationchange', this.onDurationChange);
	
	    this.manualProgress = true;
	
	    // Trigger progress watching when a source begins loading
	    this.one('ready', this.trackProgress);
	  };
	
	  /**
	   * Turn off the polyfill for `progress` events that was created in
	   * {@link Tech#manualProgressOn}
	   */
	
	
	  Tech.prototype.manualProgressOff = function manualProgressOff() {
	    this.manualProgress = false;
	    this.stopTrackingProgress();
	
	    this.off('durationchange', this.onDurationChange);
	  };
	
	  /**
	   * This is used to trigger a `progress` event when the buffered percent changes. It
	   * sets an interval function that will be called every 500 milliseconds to check if the
	   * buffer end percent has changed.
	   *
	   * > This function is called by {@link Tech#manualProgressOn}
	   *
	   * @param {EventTarget~Event} event
	   *        The `ready` event that caused this to run.
	   *
	   * @listens Tech#ready
	   * @fires Tech#progress
	   */
	
	
	  Tech.prototype.trackProgress = function trackProgress(event) {
	    this.stopTrackingProgress();
	    this.progressInterval = this.setInterval(bind(this, function () {
	      // Don't trigger unless buffered amount is greater than last time
	
	      var numBufferedPercent = this.bufferedPercent();
	
	      if (this.bufferedPercent_ !== numBufferedPercent) {
	        /**
	         * See {@link Player#progress}
	         *
	         * @event Tech#progress
	         * @type {EventTarget~Event}
	         */
	        this.trigger('progress');
	      }
	
	      this.bufferedPercent_ = numBufferedPercent;
	
	      if (numBufferedPercent === 1) {
	        this.stopTrackingProgress();
	      }
	    }), 500);
	  };
	
	  /**
	   * Update our internal duration on a `durationchange` event by calling
	   * {@link Tech#duration}.
	   *
	   * @param {EventTarget~Event} event
	   *        The `durationchange` event that caused this to run.
	   *
	   * @listens Tech#durationchange
	   */
	
	
	  Tech.prototype.onDurationChange = function onDurationChange(event) {
	    this.duration_ = this.duration();
	  };
	
	  /**
	   * Get and create a `TimeRange` object for buffering.
	   *
	   * @return {TimeRange}
	   *         The time range object that was created.
	   */
	
	
	  Tech.prototype.buffered = function buffered() {
	    return createTimeRanges(0, 0);
	  };
	
	  /**
	   * Get the percentage of the current video that is currently buffered.
	   *
	   * @return {number}
	   *         A number from 0 to 1 that represents the decimal percentage of the
	   *         video that is buffered.
	   *
	   */
	
	
	  Tech.prototype.bufferedPercent = function bufferedPercent$$1() {
	    return bufferedPercent(this.buffered(), this.duration_);
	  };
	
	  /**
	   * Turn off the polyfill for `progress` events that was created in
	   * {@link Tech#manualProgressOn}
	   * Stop manually tracking progress events by clearing the interval that was set in
	   * {@link Tech#trackProgress}.
	   */
	
	
	  Tech.prototype.stopTrackingProgress = function stopTrackingProgress() {
	    this.clearInterval(this.progressInterval);
	  };
	
	  /**
	   * Polyfill the `timeupdate` event for browsers that don't support it.
	   *
	   * @see {@link Tech#trackCurrentTime}
	   */
	
	
	  Tech.prototype.manualTimeUpdatesOn = function manualTimeUpdatesOn() {
	    this.manualTimeUpdates = true;
	
	    this.on('play', this.trackCurrentTime);
	    this.on('pause', this.stopTrackingCurrentTime);
	  };
	
	  /**
	   * Turn off the polyfill for `timeupdate` events that was created in
	   * {@link Tech#manualTimeUpdatesOn}
	   */
	
	
	  Tech.prototype.manualTimeUpdatesOff = function manualTimeUpdatesOff() {
	    this.manualTimeUpdates = false;
	    this.stopTrackingCurrentTime();
	    this.off('play', this.trackCurrentTime);
	    this.off('pause', this.stopTrackingCurrentTime);
	  };
	
	  /**
	   * Sets up an interval function to track current time and trigger `timeupdate` every
	   * 250 milliseconds.
	   *
	   * @listens Tech#play
	   * @triggers Tech#timeupdate
	   */
	
	
	  Tech.prototype.trackCurrentTime = function trackCurrentTime() {
	    if (this.currentTimeInterval) {
	      this.stopTrackingCurrentTime();
	    }
	    this.currentTimeInterval = this.setInterval(function () {
	      /**
	       * Triggered at an interval of 250ms to indicated that time is passing in the video.
	       *
	       * @event Tech#timeupdate
	       * @type {EventTarget~Event}
	       */
	      this.trigger({ type: 'timeupdate', target: this, manuallyTriggered: true });
	
	      // 42 = 24 fps // 250 is what Webkit uses // FF uses 15
	    }, 250);
	  };
	
	  /**
	   * Stop the interval function created in {@link Tech#trackCurrentTime} so that the
	   * `timeupdate` event is no longer triggered.
	   *
	   * @listens {Tech#pause}
	   */
	
	
	  Tech.prototype.stopTrackingCurrentTime = function stopTrackingCurrentTime() {
	    this.clearInterval(this.currentTimeInterval);
	
	    // #1002 - if the video ends right before the next timeupdate would happen,
	    // the progress bar won't make it all the way to the end
	    this.trigger({ type: 'timeupdate', target: this, manuallyTriggered: true });
	  };
	
	  /**
	   * Turn off all event polyfills, clear the `Tech`s {@link AudioTrackList},
	   * {@link VideoTrackList}, and {@link TextTrackList}, and dispose of this Tech.
	   *
	   * @fires Component#dispose
	   */
	
	
	  Tech.prototype.dispose = function dispose() {
	
	    // clear out all tracks because we can't reuse them between techs
	    this.clearTracks(NORMAL.names);
	
	    // Turn off any manual progress or timeupdate tracking
	    if (this.manualProgress) {
	      this.manualProgressOff();
	    }
	
	    if (this.manualTimeUpdates) {
	      this.manualTimeUpdatesOff();
	    }
	
	    _Component.prototype.dispose.call(this);
	  };
	
	  /**
	   * Clear out a single `TrackList` or an array of `TrackLists` given their names.
	   *
	   * > Note: Techs without source handlers should call this between sources for `video`
	   *         & `audio` tracks. You don't want to use them between tracks!
	   *
	   * @param {string[]|string} types
	   *        TrackList names to clear, valid names are `video`, `audio`, and
	   *        `text`.
	   */
	
	
	  Tech.prototype.clearTracks = function clearTracks(types) {
	    var _this3 = this;
	
	    types = [].concat(types);
	    // clear out all tracks because we can't reuse them between techs
	    types.forEach(function (type) {
	      var list = _this3[type + 'Tracks']() || [];
	      var i = list.length;
	
	      while (i--) {
	        var track = list[i];
	
	        if (type === 'text') {
	          _this3.removeRemoteTextTrack(track);
	        }
	        list.removeTrack(track);
	      }
	    });
	  };
	
	  /**
	   * Remove any TextTracks added via addRemoteTextTrack that are
	   * flagged for automatic garbage collection
	   */
	
	
	  Tech.prototype.cleanupAutoTextTracks = function cleanupAutoTextTracks() {
	    var list = this.autoRemoteTextTracks_ || [];
	    var i = list.length;
	
	    while (i--) {
	      var track = list[i];
	
	      this.removeRemoteTextTrack(track);
	    }
	  };
	
	  /**
	   * Reset the tech, which will removes all sources and reset the internal readyState.
	   *
	   * @abstract
	   */
	
	
	  Tech.prototype.reset = function reset() {};
	
	  /**
	   * Get or set an error on the Tech.
	   *
	   * @param {MediaError} [err]
	   *        Error to set on the Tech
	   *
	   * @return {MediaError|null}
	   *         The current error object on the tech, or null if there isn't one.
	   */
	
	
	  Tech.prototype.error = function error(err) {
	    if (err !== undefined) {
	      this.error_ = new MediaError(err);
	      this.trigger('error');
	    }
	    return this.error_;
	  };
	
	  /**
	   * Returns the `TimeRange`s that have been played through for the current source.
	   *
	   * > NOTE: This implementation is incomplete. It does not track the played `TimeRange`.
	   *         It only checks whether the source has played at all or not.
	   *
	   * @return {TimeRange}
	   *         - A single time range if this video has played
	   *         - An empty set of ranges if not.
	   */
	
	
	  Tech.prototype.played = function played() {
	    if (this.hasStarted_) {
	      return createTimeRanges(0, 0);
	    }
	    return createTimeRanges();
	  };
	
	  /**
	   * Causes a manual time update to occur if {@link Tech#manualTimeUpdatesOn} was
	   * previously called.
	   *
	   * @fires Tech#timeupdate
	   */
	
	
	  Tech.prototype.setCurrentTime = function setCurrentTime() {
	    // improve the accuracy of manual timeupdates
	    if (this.manualTimeUpdates) {
	      /**
	       * A manual `timeupdate` event.
	       *
	       * @event Tech#timeupdate
	       * @type {EventTarget~Event}
	       */
	      this.trigger({ type: 'timeupdate', target: this, manuallyTriggered: true });
	    }
	  };
	
	  /**
	   * Turn on listeners for {@link VideoTrackList}, {@link {AudioTrackList}, and
	   * {@link TextTrackList} events.
	   *
	   * This adds {@link EventTarget~EventListeners} for `addtrack`, and  `removetrack`.
	   *
	   * @fires Tech#audiotrackchange
	   * @fires Tech#videotrackchange
	   * @fires Tech#texttrackchange
	   */
	
	
	  Tech.prototype.initTrackListeners = function initTrackListeners() {
	    var _this4 = this;
	
	    /**
	     * Triggered when tracks are added or removed on the Tech {@link AudioTrackList}
	     *
	     * @event Tech#audiotrackchange
	     * @type {EventTarget~Event}
	     */
	
	    /**
	     * Triggered when tracks are added or removed on the Tech {@link VideoTrackList}
	     *
	     * @event Tech#videotrackchange
	     * @type {EventTarget~Event}
	     */
	
	    /**
	     * Triggered when tracks are added or removed on the Tech {@link TextTrackList}
	     *
	     * @event Tech#texttrackchange
	     * @type {EventTarget~Event}
	     */
	    NORMAL.names.forEach(function (name) {
	      var props = NORMAL[name];
	      var trackListChanges = function trackListChanges() {
	        _this4.trigger(name + 'trackchange');
	      };
	
	      var tracks = _this4[props.getterName]();
	
	      tracks.addEventListener('removetrack', trackListChanges);
	      tracks.addEventListener('addtrack', trackListChanges);
	
	      _this4.on('dispose', function () {
	        tracks.removeEventListener('removetrack', trackListChanges);
	        tracks.removeEventListener('addtrack', trackListChanges);
	      });
	    });
	  };
	
	  /**
	   * Emulate TextTracks using vtt.js if necessary
	   *
	   * @fires Tech#vttjsloaded
	   * @fires Tech#vttjserror
	   */
	
	
	  Tech.prototype.addWebVttScript_ = function addWebVttScript_() {
	    var _this5 = this;
	
	    if (window$1.WebVTT) {
	      return;
	    }
	
	    // Initially, Tech.el_ is a child of a dummy-div wait until the Component system
	    // signals that the Tech is ready at which point Tech.el_ is part of the DOM
	    // before inserting the WebVTT script
	    if (document.body.contains(this.el())) {
	
	      // load via require if available and vtt.js script location was not passed in
	      // as an option. novtt builds will turn the above require call into an empty object
	      // which will cause this if check to always fail.
	      if (!this.options_['vtt.js'] && isPlain(vtt) && Object.keys(vtt).length > 0) {
	        this.trigger('vttjsloaded');
	        return;
	      }
	
	      // load vtt.js via the script location option or the cdn of no location was
	      // passed in
	      var script = document.createElement('script');
	
	      script.src = this.options_['vtt.js'] || 'https://vjs.zencdn.net/vttjs/0.14.1/vtt.min.js';
	      script.onload = function () {
	        /**
	         * Fired when vtt.js is loaded.
	         *
	         * @event Tech#vttjsloaded
	         * @type {EventTarget~Event}
	         */
	        _this5.trigger('vttjsloaded');
	      };
	      script.onerror = function () {
	        /**
	         * Fired when vtt.js was not loaded due to an error
	         *
	         * @event Tech#vttjsloaded
	         * @type {EventTarget~Event}
	         */
	        _this5.trigger('vttjserror');
	      };
	      this.on('dispose', function () {
	        script.onload = null;
	        script.onerror = null;
	      });
	      // but have not loaded yet and we set it to true before the inject so that
	      // we don't overwrite the injected window.WebVTT if it loads right away
	      window$1.WebVTT = true;
	      this.el().parentNode.appendChild(script);
	    } else {
	      this.ready(this.addWebVttScript_);
	    }
	  };
	
	  /**
	   * Emulate texttracks
	   *
	   */
	
	
	  Tech.prototype.emulateTextTracks = function emulateTextTracks() {
	    var _this6 = this;
	
	    var tracks = this.textTracks();
	    var remoteTracks = this.remoteTextTracks();
	    var handleAddTrack = function handleAddTrack(e) {
	      return tracks.addTrack(e.track);
	    };
	    var handleRemoveTrack = function handleRemoveTrack(e) {
	      return tracks.removeTrack(e.track);
	    };
	
	    remoteTracks.on('addtrack', handleAddTrack);
	    remoteTracks.on('removetrack', handleRemoveTrack);
	
	    this.addWebVttScript_();
	
	    var updateDisplay = function updateDisplay() {
	      return _this6.trigger('texttrackchange');
	    };
	
	    var textTracksChanges = function textTracksChanges() {
	      updateDisplay();
	
	      for (var i = 0; i < tracks.length; i++) {
	        var track = tracks[i];
	
	        track.removeEventListener('cuechange', updateDisplay);
	        if (track.mode === 'showing') {
	          track.addEventListener('cuechange', updateDisplay);
	        }
	      }
	    };
	
	    textTracksChanges();
	    tracks.addEventListener('change', textTracksChanges);
	    tracks.addEventListener('addtrack', textTracksChanges);
	    tracks.addEventListener('removetrack', textTracksChanges);
	
	    this.on('dispose', function () {
	      remoteTracks.off('addtrack', handleAddTrack);
	      remoteTracks.off('removetrack', handleRemoveTrack);
	      tracks.removeEventListener('change', textTracksChanges);
	      tracks.removeEventListener('addtrack', textTracksChanges);
	      tracks.removeEventListener('removetrack', textTracksChanges);
	
	      for (var i = 0; i < tracks.length; i++) {
	        var track = tracks[i];
	
	        track.removeEventListener('cuechange', updateDisplay);
	      }
	    });
	  };
	
	  /**
	   * Create and returns a remote {@link TextTrack} object.
	   *
	   * @param {string} kind
	   *        `TextTrack` kind (subtitles, captions, descriptions, chapters, or metadata)
	   *
	   * @param {string} [label]
	   *        Label to identify the text track
	   *
	   * @param {string} [language]
	   *        Two letter language abbreviation
	   *
	   * @return {TextTrack}
	   *         The TextTrack that gets created.
	   */
	
	
	  Tech.prototype.addTextTrack = function addTextTrack(kind, label, language) {
	    if (!kind) {
	      throw new Error('TextTrack kind is required but was not provided');
	    }
	
	    return createTrackHelper(this, kind, label, language);
	  };
	
	  /**
	   * Create an emulated TextTrack for use by addRemoteTextTrack
	   *
	   * This is intended to be overridden by classes that inherit from
	   * Tech in order to create native or custom TextTracks.
	   *
	   * @param {Object} options
	   *        The object should contain the options to initialize the TextTrack with.
	   *
	   * @param {string} [options.kind]
	   *        `TextTrack` kind (subtitles, captions, descriptions, chapters, or metadata).
	   *
	   * @param {string} [options.label].
	   *        Label to identify the text track
	   *
	   * @param {string} [options.language]
	   *        Two letter language abbreviation.
	   *
	   * @return {HTMLTrackElement}
	   *         The track element that gets created.
	   */
	
	
	  Tech.prototype.createRemoteTextTrack = function createRemoteTextTrack(options) {
	    var track = mergeOptions(options, {
	      tech: this
	    });
	
	    return new REMOTE.remoteTextEl.TrackClass(track);
	  };
	
	  /**
	   * Creates a remote text track object and returns an html track element.
	   *
	   * > Note: This can be an emulated {@link HTMLTrackElement} or a native one.
	   *
	   * @param {Object} options
	   *        See {@link Tech#createRemoteTextTrack} for more detailed properties.
	   *
	   * @param {boolean} [manualCleanup=true]
	   *        - When false: the TextTrack will be automatically removed from the video
	   *          element whenever the source changes
	   *        - When True: The TextTrack will have to be cleaned up manually
	   *
	   * @return {HTMLTrackElement}
	   *         An Html Track Element.
	   *
	   * @deprecated The default functionality for this function will be equivalent
	   *             to "manualCleanup=false" in the future. The manualCleanup parameter will
	   *             also be removed.
	   */
	
	
	  Tech.prototype.addRemoteTextTrack = function addRemoteTextTrack() {
	    var _this7 = this;
	
	    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	    var manualCleanup = arguments[1];
	
	    var htmlTrackElement = this.createRemoteTextTrack(options);
	
	    if (manualCleanup !== true && manualCleanup !== false) {
	      // deprecation warning
	      log$1.warn('Calling addRemoteTextTrack without explicitly setting the "manualCleanup" parameter to `true` is deprecated and default to `false` in future version of video.js');
	      manualCleanup = true;
	    }
	
	    // store HTMLTrackElement and TextTrack to remote list
	    this.remoteTextTrackEls().addTrackElement_(htmlTrackElement);
	    this.remoteTextTracks().addTrack(htmlTrackElement.track);
	
	    if (manualCleanup !== true) {
	      // create the TextTrackList if it doesn't exist
	      this.ready(function () {
	        return _this7.autoRemoteTextTracks_.addTrack(htmlTrackElement.track);
	      });
	    }
	
	    return htmlTrackElement;
	  };
	
	  /**
	   * Remove a remote text track from the remote `TextTrackList`.
	   *
	   * @param {TextTrack} track
	   *        `TextTrack` to remove from the `TextTrackList`
	   */
	
	
	  Tech.prototype.removeRemoteTextTrack = function removeRemoteTextTrack(track) {
	    var trackElement = this.remoteTextTrackEls().getTrackElementByTrack_(track);
	
	    // remove HTMLTrackElement and TextTrack from remote list
	    this.remoteTextTrackEls().removeTrackElement_(trackElement);
	    this.remoteTextTracks().removeTrack(track);
	    this.autoRemoteTextTracks_.removeTrack(track);
	  };
	
	  /**
	   * Gets available media playback quality metrics as specified by the W3C's Media
	   * Playback Quality API.
	   *
	   * @see [Spec]{@link https://wicg.github.io/media-playback-quality}
	   *
	   * @return {Object}
	   *         An object with supported media playback quality metrics
	   *
	   * @abstract
	   */
	
	
	  Tech.prototype.getVideoPlaybackQuality = function getVideoPlaybackQuality() {
	    return {};
	  };
	
	  /**
	   * A method to set a poster from a `Tech`.
	   *
	   * @abstract
	   */
	
	
	  Tech.prototype.setPoster = function setPoster() {};
	
	  /**
	   * A method to check for the presence of the 'playsinline' <video> attribute.
	   *
	   * @abstract
	   */
	
	
	  Tech.prototype.playsinline = function playsinline() {};
	
	  /**
	   * A method to set or unset the 'playsinline' <video> attribute.
	   *
	   * @abstract
	   */
	
	
	  Tech.prototype.setPlaysinline = function setPlaysinline() {};
	
	  /**
	   * Attempt to force override of native audio tracks.
	   *
	   * @param {Boolean} override - If set to true native audio will be overridden,
	   * otherwise native audio will potentially be used.
	   *
	   * @abstract
	   */
	
	
	  Tech.prototype.overrideNativeAudioTracks = function overrideNativeAudioTracks() {};
	
	  /**
	   * Attempt to force override of native video tracks.
	   *
	   * @param {Boolean} override - If set to true native video will be overridden,
	   * otherwise native video will potentially be used.
	   *
	   * @abstract
	   */
	
	
	  Tech.prototype.overrideNativeVideoTracks = function overrideNativeVideoTracks() {};
	
	  /*
	   * Check if the tech can support the given mime-type.
	   *
	   * The base tech does not support any type, but source handlers might
	   * overwrite this.
	   *
	   * @param  {string} type
	   *         The mimetype to check for support
	   *
	   * @return {string}
	   *         'probably', 'maybe', or empty string
	   *
	   * @see [Spec]{@link https://developer.mozilla.org/en-US/docs/Web/API/HTMLMediaElement/canPlayType}
	   *
	   * @abstract
	   */
	
	
	  Tech.prototype.canPlayType = function canPlayType() {
	    return '';
	  };
	
	  /**
	   * Check if the type is supported by this tech.
	   *
	   * The base tech does not support any type, but source handlers might
	   * overwrite this.
	   *
	   * @param {string} type
	   *        The media type to check
	   * @return {string} Returns the native video element's response
	   */
	
	
	  Tech.canPlayType = function canPlayType() {
	    return '';
	  };
	
	  /**
	   * Check if the tech can support the given source
	   * @param {Object} srcObj
	   *        The source object
	   * @param {Object} options
	   *        The options passed to the tech
	   * @return {string} 'probably', 'maybe', or '' (empty string)
	   */
	
	
	  Tech.canPlaySource = function canPlaySource(srcObj, options) {
	    return Tech.canPlayType(srcObj.type);
	  };
	
	  /*
	   * Return whether the argument is a Tech or not.
	   * Can be passed either a Class like `Html5` or a instance like `player.tech_`
	   *
	   * @param {Object} component
	   *        The item to check
	   *
	   * @return {boolean}
	   *         Whether it is a tech or not
	   *         - True if it is a tech
	   *         - False if it is not
	   */
	
	
	  Tech.isTech = function isTech(component) {
	    return component.prototype instanceof Tech || component instanceof Tech || component === Tech;
	  };
	
	  /**
	   * Registers a `Tech` into a shared list for videojs.
	   *
	   * @param {string} name
	   *        Name of the `Tech` to register.
	   *
	   * @param {Object} tech
	   *        The `Tech` class to register.
	   */
	
	
	  Tech.registerTech = function registerTech(name, tech) {
	    if (!Tech.techs_) {
	      Tech.techs_ = {};
	    }
	
	    if (!Tech.isTech(tech)) {
	      throw new Error('Tech ' + name + ' must be a Tech');
	    }
	
	    if (!Tech.canPlayType) {
	      throw new Error('Techs must have a static canPlayType method on them');
	    }
	    if (!Tech.canPlaySource) {
	      throw new Error('Techs must have a static canPlaySource method on them');
	    }
	
	    name = toTitleCase(name);
	
	    Tech.techs_[name] = tech;
	    if (name !== 'Tech') {
	      // camel case the techName for use in techOrder
	      Tech.defaultTechOrder_.push(name);
	    }
	    return tech;
	  };
	
	  /**
	   * Get a `Tech` from the shared list by name.
	   *
	   * @param {string} name
	   *        `camelCase` or `TitleCase` name of the Tech to get
	   *
	   * @return {Tech|undefined}
	   *         The `Tech` or undefined if there was no tech with the name requested.
	   */
	
	
	  Tech.getTech = function getTech(name) {
	    if (!name) {
	      return;
	    }
	
	    name = toTitleCase(name);
	
	    if (Tech.techs_ && Tech.techs_[name]) {
	      return Tech.techs_[name];
	    }
	
	    if (window$1 && window$1.videojs && window$1.videojs[name]) {
	      log$1.warn('The ' + name + ' tech was added to the videojs object when it should be registered using videojs.registerTech(name, tech)');
	      return window$1.videojs[name];
	    }
	  };
	
	  return Tech;
	}(Component);
	
	/**
	 * Get the {@link VideoTrackList}
	 *
	 * @returns {VideoTrackList}
	 * @method Tech.prototype.videoTracks
	 */
	
	/**
	 * Get the {@link AudioTrackList}
	 *
	 * @returns {AudioTrackList}
	 * @method Tech.prototype.audioTracks
	 */
	
	/**
	 * Get the {@link TextTrackList}
	 *
	 * @returns {TextTrackList}
	 * @method Tech.prototype.textTracks
	 */
	
	/**
	 * Get the remote element {@link TextTrackList}
	 *
	 * @returns {TextTrackList}
	 * @method Tech.prototype.remoteTextTracks
	 */
	
	/**
	 * Get the remote element {@link HtmlTrackElementList}
	 *
	 * @returns {HtmlTrackElementList}
	 * @method Tech.prototype.remoteTextTrackEls
	 */
	
	ALL.names.forEach(function (name) {
	  var props = ALL[name];
	
	  Tech.prototype[props.getterName] = function () {
	    this[props.privateName] = this[props.privateName] || new props.ListClass();
	    return this[props.privateName];
	  };
	});
	
	/**
	 * List of associated text tracks
	 *
	 * @type {TextTrackList}
	 * @private
	 * @property Tech#textTracks_
	 */
	
	/**
	 * List of associated audio tracks.
	 *
	 * @type {AudioTrackList}
	 * @private
	 * @property Tech#audioTracks_
	 */
	
	/**
	 * List of associated video tracks.
	 *
	 * @type {VideoTrackList}
	 * @private
	 * @property Tech#videoTracks_
	 */
	
	/**
	 * Boolean indicating whether the `Tech` supports volume control.
	 *
	 * @type {boolean}
	 * @default
	 */
	Tech.prototype.featuresVolumeControl = true;
	
	/**
	 * Boolean indicating whether the `Tech` supports muting volume.
	 *
	 * @type {bolean}
	 * @default
	 */
	Tech.prototype.featuresMuteControl = true;
	
	/**
	 * Boolean indicating whether the `Tech` supports fullscreen resize control.
	 * Resizing plugins using request fullscreen reloads the plugin
	 *
	 * @type {boolean}
	 * @default
	 */
	Tech.prototype.featuresFullscreenResize = false;
	
	/**
	 * Boolean indicating whether the `Tech` supports changing the speed at which the video
	 * plays. Examples:
	 *   - Set player to play 2x (twice) as fast
	 *   - Set player to play 0.5x (half) as fast
	 *
	 * @type {boolean}
	 * @default
	 */
	Tech.prototype.featuresPlaybackRate = false;
	
	/**
	 * Boolean indicating whether the `Tech` supports the `progress` event. This is currently
	 * not triggered by video-js-swf. This will be used to determine if
	 * {@link Tech#manualProgressOn} should be called.
	 *
	 * @type {boolean}
	 * @default
	 */
	Tech.prototype.featuresProgressEvents = false;
	
	/**
	 * Boolean indicating whether the `Tech` supports the `sourceset` event.
	 *
	 * A tech should set this to `true` and then use {@link Tech#triggerSourceset}
	 * to trigger a {@link Tech#event:sourceset} at the earliest time after getting
	 * a new source.
	 *
	 * @type {boolean}
	 * @default
	 */
	Tech.prototype.featuresSourceset = false;
	
	/**
	 * Boolean indicating whether the `Tech` supports the `timeupdate` event. This is currently
	 * not triggered by video-js-swf. This will be used to determine if
	 * {@link Tech#manualTimeUpdates} should be called.
	 *
	 * @type {boolean}
	 * @default
	 */
	Tech.prototype.featuresTimeupdateEvents = false;
	
	/**
	 * Boolean indicating whether the `Tech` supports the native `TextTrack`s.
	 * This will help us integrate with native `TextTrack`s if the browser supports them.
	 *
	 * @type {boolean}
	 * @default
	 */
	Tech.prototype.featuresNativeTextTracks = false;
	
	/**
	 * A functional mixin for techs that want to use the Source Handler pattern.
	 * Source handlers are scripts for handling specific formats.
	 * The source handler pattern is used for adaptive formats (HLS, DASH) that
	 * manually load video data and feed it into a Source Buffer (Media Source Extensions)
	 * Example: `Tech.withSourceHandlers.call(MyTech);`
	 *
	 * @param {Tech} _Tech
	 *        The tech to add source handler functions to.
	 *
	 * @mixes Tech~SourceHandlerAdditions
	 */
	Tech.withSourceHandlers = function (_Tech) {
	
	  /**
	   * Register a source handler
	   *
	   * @param {Function} handler
	   *        The source handler class
	   *
	   * @param {number} [index]
	   *        Register it at the following index
	   */
	  _Tech.registerSourceHandler = function (handler, index) {
	    var handlers = _Tech.sourceHandlers;
	
	    if (!handlers) {
	      handlers = _Tech.sourceHandlers = [];
	    }
	
	    if (index === undefined) {
	      // add to the end of the list
	      index = handlers.length;
	    }
	
	    handlers.splice(index, 0, handler);
	  };
	
	  /**
	   * Check if the tech can support the given type. Also checks the
	   * Techs sourceHandlers.
	   *
	   * @param {string} type
	   *         The mimetype to check.
	   *
	   * @return {string}
	   *         'probably', 'maybe', or '' (empty string)
	   */
	  _Tech.canPlayType = function (type) {
	    var handlers = _Tech.sourceHandlers || [];
	    var can = void 0;
	
	    for (var i = 0; i < handlers.length; i++) {
	      can = handlers[i].canPlayType(type);
	
	      if (can) {
	        return can;
	      }
	    }
	
	    return '';
	  };
	
	  /**
	   * Returns the first source handler that supports the source.
	   *
	   * TODO: Answer question: should 'probably' be prioritized over 'maybe'
	   *
	   * @param {Tech~SourceObject} source
	   *        The source object
	   *
	   * @param {Object} options
	   *        The options passed to the tech
	   *
	   * @return {SourceHandler|null}
	   *          The first source handler that supports the source or null if
	   *          no SourceHandler supports the source
	   */
	  _Tech.selectSourceHandler = function (source, options) {
	    var handlers = _Tech.sourceHandlers || [];
	    var can = void 0;
	
	    for (var i = 0; i < handlers.length; i++) {
	      can = handlers[i].canHandleSource(source, options);
	
	      if (can) {
	        return handlers[i];
	      }
	    }
	
	    return null;
	  };
	
	  /**
	   * Check if the tech can support the given source.
	   *
	   * @param {Tech~SourceObject} srcObj
	   *        The source object
	   *
	   * @param {Object} options
	   *        The options passed to the tech
	   *
	   * @return {string}
	   *         'probably', 'maybe', or '' (empty string)
	   */
	  _Tech.canPlaySource = function (srcObj, options) {
	    var sh = _Tech.selectSourceHandler(srcObj, options);
	
	    if (sh) {
	      return sh.canHandleSource(srcObj, options);
	    }
	
	    return '';
	  };
	
	  /**
	   * When using a source handler, prefer its implementation of
	   * any function normally provided by the tech.
	   */
	  var deferrable = ['seekable', 'seeking', 'duration'];
	
	  /**
	   * A wrapper around {@link Tech#seekable} that will call a `SourceHandler`s seekable
	   * function if it exists, with a fallback to the Techs seekable function.
	   *
	   * @method _Tech.seekable
	   */
	
	  /**
	   * A wrapper around {@link Tech#duration} that will call a `SourceHandler`s duration
	   * function if it exists, otherwise it will fallback to the techs duration function.
	   *
	   * @method _Tech.duration
	   */
	
	  deferrable.forEach(function (fnName) {
	    var originalFn = this[fnName];
	
	    if (typeof originalFn !== 'function') {
	      return;
	    }
	
	    this[fnName] = function () {
	      if (this.sourceHandler_ && this.sourceHandler_[fnName]) {
	        return this.sourceHandler_[fnName].apply(this.sourceHandler_, arguments);
	      }
	      return originalFn.apply(this, arguments);
	    };
	  }, _Tech.prototype);
	
	  /**
	   * Create a function for setting the source using a source object
	   * and source handlers.
	   * Should never be called unless a source handler was found.
	   *
	   * @param {Tech~SourceObject} source
	   *        A source object with src and type keys
	   */
	  _Tech.prototype.setSource = function (source) {
	    var sh = _Tech.selectSourceHandler(source, this.options_);
	
	    if (!sh) {
	      // Fall back to a native source hander when unsupported sources are
	      // deliberately set
	      if (_Tech.nativeSourceHandler) {
	        sh = _Tech.nativeSourceHandler;
	      } else {
	        log$1.error('No source handler found for the current source.');
	      }
	    }
	
	    // Dispose any existing source handler
	    this.disposeSourceHandler();
	    this.off('dispose', this.disposeSourceHandler);
	
	    if (sh !== _Tech.nativeSourceHandler) {
	      this.currentSource_ = source;
	    }
	
	    this.sourceHandler_ = sh.handleSource(source, this, this.options_);
	    this.on('dispose', this.disposeSourceHandler);
	  };
	
	  /**
	   * Clean up any existing SourceHandlers and listeners when the Tech is disposed.
	   *
	   * @listens Tech#dispose
	   */
	  _Tech.prototype.disposeSourceHandler = function () {
	    // if we have a source and get another one
	    // then we are loading something new
	    // than clear all of our current tracks
	    if (this.currentSource_) {
	      this.clearTracks(['audio', 'video']);
	      this.currentSource_ = null;
	    }
	
	    // always clean up auto-text tracks
	    this.cleanupAutoTextTracks();
	
	    if (this.sourceHandler_) {
	
	      if (this.sourceHandler_.dispose) {
	        this.sourceHandler_.dispose();
	      }
	
	      this.sourceHandler_ = null;
	    }
	  };
	};
	
	// The base Tech class needs to be registered as a Component. It is the only
	// Tech that can be registered as a Component.
	Component.registerComponent('Tech', Tech);
	Tech.registerTech('Tech', Tech);
	
	/**
	 * A list of techs that should be added to techOrder on Players
	 *
	 * @private
	 */
	Tech.defaultTechOrder_ = [];
	
	var middlewares = {};
	var middlewareInstances = {};
	
	var TERMINATOR = {};
	
	function use(type, middleware) {
	  middlewares[type] = middlewares[type] || [];
	  middlewares[type].push(middleware);
	}
	
	function setSource(player, src, next) {
	  player.setTimeout(function () {
	    return setSourceHelper(src, middlewares[src.type], next, player);
	  }, 1);
	}
	
	function setTech(middleware, tech) {
	  middleware.forEach(function (mw) {
	    return mw.setTech && mw.setTech(tech);
	  });
	}
	
	/**
	 * Calls a getter on the tech first, through each middleware
	 * from right to left to the player.
	 */
	function get$1(middleware, tech, method) {
	  return middleware.reduceRight(middlewareIterator(method), tech[method]());
	}
	
	/**
	 * Takes the argument given to the player and calls the setter method on each
	 * middleware from left to right to the tech.
	 */
	function set$1(middleware, tech, method, arg) {
	  return tech[method](middleware.reduce(middlewareIterator(method), arg));
	}
	
	/**
	 * Takes the argument given to the player and calls the `call` version of the method
	 * on each middleware from left to right.
	 * Then, call the passed in method on the tech and return the result unchanged
	 * back to the player, through middleware, this time from right to left.
	 */
	function mediate(middleware, tech, method) {
	  var arg = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
	
	  var callMethod = 'call' + toTitleCase(method);
	  var middlewareValue = middleware.reduce(middlewareIterator(callMethod), arg);
	  var terminated = middlewareValue === TERMINATOR;
	  var returnValue = terminated ? null : tech[method](middlewareValue);
	
	  executeRight(middleware, method, returnValue, terminated);
	
	  return returnValue;
	}
	
	var allowedGetters = {
	  buffered: 1,
	  currentTime: 1,
	  duration: 1,
	  seekable: 1,
	  played: 1,
	  paused: 1
	};
	
	var allowedSetters = {
	  setCurrentTime: 1
	};
	
	var allowedMediators = {
	  play: 1,
	  pause: 1
	};
	
	function middlewareIterator(method) {
	  return function (value, mw) {
	    // if the previous middleware terminated, pass along the termination
	    if (value === TERMINATOR) {
	      return TERMINATOR;
	    }
	
	    if (mw[method]) {
	      return mw[method](value);
	    }
	
	    return value;
	  };
	}
	
	function executeRight(mws, method, value, terminated) {
	  for (var i = mws.length - 1; i >= 0; i--) {
	    var mw = mws[i];
	
	    if (mw[method]) {
	      mw[method](terminated, value);
	    }
	  }
	}
	
	function clearCacheForPlayer(player) {
	  middlewareInstances[player.id()] = null;
	}
	
	/**
	 * {
	 *  [playerId]: [[mwFactory, mwInstance], ...]
	 * }
	 */
	function getOrCreateFactory(player, mwFactory) {
	  var mws = middlewareInstances[player.id()];
	  var mw = null;
	
	  if (mws === undefined || mws === null) {
	    mw = mwFactory(player);
	    middlewareInstances[player.id()] = [[mwFactory, mw]];
	    return mw;
	  }
	
	  for (var i = 0; i < mws.length; i++) {
	    var _mws$i = mws[i],
	        mwf = _mws$i[0],
	        mwi = _mws$i[1];
	
	
	    if (mwf !== mwFactory) {
	      continue;
	    }
	
	    mw = mwi;
	  }
	
	  if (mw === null) {
	    mw = mwFactory(player);
	    mws.push([mwFactory, mw]);
	  }
	
	  return mw;
	}
	
	function setSourceHelper() {
	  var src = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	  var middleware = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
	  var next = arguments[2];
	  var player = arguments[3];
	  var acc = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : [];
	  var lastRun = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : false;
	  var mwFactory = middleware[0],
	      mwrest = middleware.slice(1);
	
	  // if mwFactory is a string, then we're at a fork in the road
	
	  if (typeof mwFactory === 'string') {
	    setSourceHelper(src, middlewares[mwFactory], next, player, acc, lastRun);
	
	    // if we have an mwFactory, call it with the player to get the mw,
	    // then call the mw's setSource method
	  } else if (mwFactory) {
	    var mw = getOrCreateFactory(player, mwFactory);
	
	    // if setSource isn't present, implicitly select this middleware
	    if (!mw.setSource) {
	      acc.push(mw);
	      return setSourceHelper(src, mwrest, next, player, acc, lastRun);
	    }
	
	    mw.setSource(assign({}, src), function (err, _src) {
	
	      // something happened, try the next middleware on the current level
	      // make sure to use the old src
	      if (err) {
	        return setSourceHelper(src, mwrest, next, player, acc, lastRun);
	      }
	
	      // we've succeeded, now we need to go deeper
	      acc.push(mw);
	
	      // if it's the same type, continue down the current chain
	      // otherwise, we want to go down the new chain
	      setSourceHelper(_src, src.type === _src.type ? mwrest : middlewares[_src.type], next, player, acc, lastRun);
	    });
	  } else if (mwrest.length) {
	    setSourceHelper(src, mwrest, next, player, acc, lastRun);
	  } else if (lastRun) {
	    next(src, acc);
	  } else {
	    setSourceHelper(src, middlewares['*'], next, player, acc, true);
	  }
	}
	
	/**
	 * Mimetypes
	 *
	 * @see http://hul.harvard.edu/ois/////systems/wax/wax-public-help/mimetypes.htm
	 * @typedef Mimetypes~Kind
	 * @enum
	 */
	var MimetypesKind = {
	  opus: 'video/ogg',
	  ogv: 'video/ogg',
	  mp4: 'video/mp4',
	  mov: 'video/mp4',
	  m4v: 'video/mp4',
	  mkv: 'video/x-matroska',
	  mp3: 'audio/mpeg',
	  aac: 'audio/aac',
	  oga: 'audio/ogg',
	  m3u8: 'application/x-mpegURL'
	};
	
	/**
	 * Get the mimetype of a given src url if possible
	 *
	 * @param {string} src
	 *        The url to the src
	 *
	 * @return {string}
	 *         return the mimetype if it was known or empty string otherwise
	 */
	var getMimetype = function getMimetype() {
	  var src = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
	
	  var ext = getFileExtension(src);
	  var mimetype = MimetypesKind[ext.toLowerCase()];
	
	  return mimetype || '';
	};
	
	/**
	 * Find the mime type of a given source string if possible. Uses the player
	 * source cache.
	 *
	 * @param {Player} player
	 *        The player object
	 *
	 * @param {string} src
	 *        The source string
	 *
	 * @return {string}
	 *         The type that was found
	 */
	var findMimetype = function findMimetype(player, src) {
	  if (!src) {
	    return '';
	  }
	
	  // 1. check for the type in the `source` cache
	  if (player.cache_.source.src === src && player.cache_.source.type) {
	    return player.cache_.source.type;
	  }
	
	  // 2. see if we have this source in our `currentSources` cache
	  var matchingSources = player.cache_.sources.filter(function (s) {
	    return s.src === src;
	  });
	
	  if (matchingSources.length) {
	    return matchingSources[0].type;
	  }
	
	  // 3. look for the src url in source elements and use the type there
	  var sources = player.$$('source');
	
	  for (var i = 0; i < sources.length; i++) {
	    var s = sources[i];
	
	    if (s.type && s.src && s.src === src) {
	      return s.type;
	    }
	  }
	
	  // 4. finally fallback to our list of mime types based on src url extension
	  return getMimetype(src);
	};
	
	/**
	 * @module filter-source
	 */
	
	/**
	 * Filter out single bad source objects or multiple source objects in an
	 * array. Also flattens nested source object arrays into a 1 dimensional
	 * array of source objects.
	 *
	 * @param {Tech~SourceObject|Tech~SourceObject[]} src
	 *        The src object to filter
	 *
	 * @return {Tech~SourceObject[]}
	 *         An array of sourceobjects containing only valid sources
	 *
	 * @private
	 */
	var filterSource = function filterSource(src) {
	  // traverse array
	  if (Array.isArray(src)) {
	    var newsrc = [];
	
	    src.forEach(function (srcobj) {
	      srcobj = filterSource(srcobj);
	
	      if (Array.isArray(srcobj)) {
	        newsrc = newsrc.concat(srcobj);
	      } else if (isObject(srcobj)) {
	        newsrc.push(srcobj);
	      }
	    });
	
	    src = newsrc;
	  } else if (typeof src === 'string' && src.trim()) {
	    // convert string into object
	    src = [fixSource({ src: src })];
	  } else if (isObject(src) && typeof src.src === 'string' && src.src && src.src.trim()) {
	    // src is already valid
	    src = [fixSource(src)];
	  } else {
	    // invalid source, turn it into an empty array
	    src = [];
	  }
	
	  return src;
	};
	
	/**
	 * Checks src mimetype, adding it when possible
	 *
	 * @param {Tech~SourceObject} src
	 *        The src object to check
	 * @return {Tech~SourceObject}
	 *        src Object with known type
	 */
	function fixSource(src) {
	  var mimetype = getMimetype(src.src);
	
	  if (!src.type && mimetype) {
	    src.type = mimetype;
	  }
	
	  return src;
	}
	
	/**
	 * @file loader.js
	 */
	
	/**
	 * The `MediaLoader` is the `Component` that decides which playback technology to load
	 * when a player is initialized.
	 *
	 * @extends Component
	 */
	
	var MediaLoader = function (_Component) {
	  inherits(MediaLoader, _Component);
	
	  /**
	   * Create an instance of this class.
	   *
	   * @param {Player} player
	   *        The `Player` that this class should attach to.
	   *
	   * @param {Object} [options]
	   *        The key/value store of player options.
	   *
	   * @param {Component~ReadyCallback} [ready]
	   *        The function that is run when this component is ready.
	   */
	  function MediaLoader(player, options, ready) {
	    classCallCheck(this, MediaLoader);
	
	    // MediaLoader has no element
	    var options_ = mergeOptions({ createEl: false }, options);
	
	    // If there are no sources when the player is initialized,
	    // load the first supported playback technology.
	
	    var _this = possibleConstructorReturn(this, _Component.call(this, player, options_, ready));
	
	    if (!options.playerOptions.sources || options.playerOptions.sources.length === 0) {
	      for (var i = 0, j = options.playerOptions.techOrder; i < j.length; i++) {
	        var techName = toTitleCase(j[i]);
	        var tech = Tech.getTech(techName);
	
	        // Support old behavior of techs being registered as components.
	        // Remove once that deprecated behavior is removed.
	        if (!techName) {
	          tech = Component.getComponent(techName);
	        }
	
	        // Check if the browser supports this technology
	        if (tech && tech.isSupported()) {
	          player.loadTech_(techName);
	          break;
	        }
	      }
	    } else {
	      // Loop through playback technologies (HTML5, Flash) and check for support.
	      // Then load the best source.
	      // A few assumptions here:
	      //   All playback technologies respect preload false.
	      player.src(options.playerOptions.sources);
	    }
	    return _this;
	  }
	
	  return MediaLoader;
	}(Component);
	
	Component.registerComponent('MediaLoader', MediaLoader);
	
	/**
	 * @file clickable-component.js
	 */
	
	/**
	 * Clickable Component which is clickable or keyboard actionable,
	 * but is not a native HTML button.
	 *
	 * @extends Component
	 */
	
	var ClickableComponent = function (_Component) {
	  inherits(ClickableComponent, _Component);
	
	  /**
	   * Creates an instance of this class.
	   *
	   * @param  {Player} player
	   *         The `Player` that this class should be attached to.
	   *
	   * @param  {Object} [options]
	   *         The key/value store of player options.
	   */
	  function ClickableComponent(player, options) {
	    classCallCheck(this, ClickableComponent);
	
	    var _this = possibleConstructorReturn(this, _Component.call(this, player, options));
	
	    _this.emitTapEvents();
	
	    _this.enable();
	    return _this;
	  }
	
	  /**
	   * Create the `Component`s DOM element.
	   *
	   * @param {string} [tag=div]
	   *        The element's node type.
	   *
	   * @param {Object} [props={}]
	   *        An object of properties that should be set on the element.
	   *
	   * @param {Object} [attributes={}]
	   *        An object of attributes that should be set on the element.
	   *
	   * @return {Element}
	   *         The element that gets created.
	   */
	
	
	  ClickableComponent.prototype.createEl = function createEl$$1() {
	    var tag = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'div';
	    var props = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	    var attributes = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	
	    props = assign({
	      innerHTML: '<span aria-hidden="true" class="vjs-icon-placeholder"></span>',
	      className: this.buildCSSClass(),
	      tabIndex: 0
	    }, props);
	
	    if (tag === 'button') {
	      log$1.error('Creating a ClickableComponent with an HTML element of ' + tag + ' is not supported; use a Button instead.');
	    }
	
	    // Add ARIA attributes for clickable element which is not a native HTML button
	    attributes = assign({
	      role: 'button'
	    }, attributes);
	
	    this.tabIndex_ = props.tabIndex;
	
	    var el = _Component.prototype.createEl.call(this, tag, props, attributes);
	
	    this.createControlTextEl(el);
	
	    return el;
	  };
	
	  ClickableComponent.prototype.dispose = function dispose() {
	    // remove controlTextEl_ on dispose
	    this.controlTextEl_ = null;
	
	    _Component.prototype.dispose.call(this);
	  };
	
	  /**
	   * Create a control text element on this `Component`
	   *
	   * @param {Element} [el]
	   *        Parent element for the control text.
	   *
	   * @return {Element}
	   *         The control text element that gets created.
	   */
	
	
	  ClickableComponent.prototype.createControlTextEl = function createControlTextEl(el) {
	    this.controlTextEl_ = createEl('span', {
	      className: 'vjs-control-text'
	    }, {
	      // let the screen reader user know that the text of the element may change
	      'aria-live': 'polite'
	    });
	
	    if (el) {
	      el.appendChild(this.controlTextEl_);
	    }
	
	    this.controlText(this.controlText_, el);
	
	    return this.controlTextEl_;
	  };
	
	  /**
	   * Get or set the localize text to use for the controls on the `Component`.
	   *
	   * @param {string} [text]
	   *        Control text for element.
	   *
	   * @param {Element} [el=this.el()]
	   *        Element to set the title on.
	   *
	   * @return {string}
	   *         - The control text when getting
	   */
	
	
	  ClickableComponent.prototype.controlText = function controlText(text) {
	    var el = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.el();
	
	    if (text === undefined) {
	      return this.controlText_ || 'Need Text';
	    }
	
	    var localizedText = this.localize(text);
	
	    this.controlText_ = text;
	    textContent(this.controlTextEl_, localizedText);
	    if (!this.nonIconControl) {
	      // Set title attribute if only an icon is shown
	      el.setAttribute('title', localizedText);
	    }
	  };
	
	  /**
	   * Builds the default DOM `className`.
	   *
	   * @return {string}
	   *         The DOM `className` for this object.
	   */
	
	
	  ClickableComponent.prototype.buildCSSClass = function buildCSSClass() {
	    return 'vjs-control vjs-button ' + _Component.prototype.buildCSSClass.call(this);
	  };
	
	  /**
	   * Enable this `Component`s element.
	   */
	
	
	  ClickableComponent.prototype.enable = function enable() {
	    if (!this.enabled_) {
	      this.enabled_ = true;
	      this.removeClass('vjs-disabled');
	      this.el_.setAttribute('aria-disabled', 'false');
	      if (typeof this.tabIndex_ !== 'undefined') {
	        this.el_.setAttribute('tabIndex', this.tabIndex_);
	      }
	      this.on(['tap', 'click'], this.handleClick);
	      this.on('focus', this.handleFocus);
	      this.on('blur', this.handleBlur);
	    }
	  };
	
	  /**
	   * Disable this `Component`s element.
	   */
	
	
	  ClickableComponent.prototype.disable = function disable() {
	    this.enabled_ = false;
	    this.addClass('vjs-disabled');
	    this.el_.setAttribute('aria-disabled', 'true');
	    if (typeof this.tabIndex_ !== 'undefined') {
	      this.el_.removeAttribute('tabIndex');
	    }
	    this.off(['tap', 'click'], this.handleClick);
	    this.off('focus', this.handleFocus);
	    this.off('blur', this.handleBlur);
	  };
	
	  /**
	   * This gets called when a `ClickableComponent` gets:
	   * - Clicked (via the `click` event, listening starts in the constructor)
	   * - Tapped (via the `tap` event, listening starts in the constructor)
	   * - The following things happen in order:
	   *   1. {@link ClickableComponent#handleFocus} is called via a `focus` event on the
	   *      `ClickableComponent`.
	   *   2. {@link ClickableComponent#handleFocus} adds a listener for `keydown` on using
	   *      {@link ClickableComponent#handleKeyPress}.
	   *   3. `ClickableComponent` has not had a `blur` event (`blur` means that focus was lost). The user presses
	   *      the space or enter key.
	   *   4. {@link ClickableComponent#handleKeyPress} calls this function with the `keydown`
	   *      event as a parameter.
	   *
	   * @param {EventTarget~Event} event
	   *        The `keydown`, `tap`, or `click` event that caused this function to be
	   *        called.
	   *
	   * @listens tap
	   * @listens click
	   * @abstract
	   */
	
	
	  ClickableComponent.prototype.handleClick = function handleClick(event) {};
	
	  /**
	   * This gets called when a `ClickableComponent` gains focus via a `focus` event.
	   * Turns on listening for `keydown` events. When they happen it
	   * calls `this.handleKeyPress`.
	   *
	   * @param {EventTarget~Event} event
	   *        The `focus` event that caused this function to be called.
	   *
	   * @listens focus
	   */
	
	
	  ClickableComponent.prototype.handleFocus = function handleFocus(event) {
	    on(document, 'keydown', bind(this, this.handleKeyPress));
	  };
	
	  /**
	   * Called when this ClickableComponent has focus and a key gets pressed down. By
	   * default it will call `this.handleClick` when the key is space or enter.
	   *
	   * @param {EventTarget~Event} event
	   *        The `keydown` event that caused this function to be called.
	   *
	   * @listens keydown
	   */
	
	
	  ClickableComponent.prototype.handleKeyPress = function handleKeyPress(event) {
	
	    // Support Space (32) or Enter (13) key operation to fire a click event
	    if (event.which === 32 || event.which === 13) {
	      event.preventDefault();
	      this.trigger('click');
	    } else if (_Component.prototype.handleKeyPress) {
	
	      // Pass keypress handling up for unsupported keys
	      _Component.prototype.handleKeyPress.call(this, event);
	    }
	  };
	
	  /**
	   * Called when a `ClickableComponent` loses focus. Turns off the listener for
	   * `keydown` events. Which Stops `this.handleKeyPress` from getting called.
	   *
	   * @param {EventTarget~Event} event
	   *        The `blur` event that caused this function to be called.
	   *
	   * @listens blur
	   */
	
	
	  ClickableComponent.prototype.handleBlur = function handleBlur(event) {
	    off(document, 'keydown', bind(this, this.handleKeyPress));
	  };
	
	  return ClickableComponent;
	}(Component);
	
	Component.registerComponent('ClickableComponent', ClickableComponent);
	
	/**
	 * @file poster-image.js
	 */
	
	/**
	 * A `ClickableComponent` that handles showing the poster image for the player.
	 *
	 * @extends ClickableComponent
	 */
	
	var PosterImage = function (_ClickableComponent) {
	  inherits(PosterImage, _ClickableComponent);
	
	  /**
	   * Create an instance of this class.
	   *
	   * @param {Player} player
	   *        The `Player` that this class should attach to.
	   *
	   * @param {Object} [options]
	   *        The key/value store of player options.
	   */
	  function PosterImage(player, options) {
	    classCallCheck(this, PosterImage);
	
	    var _this = possibleConstructorReturn(this, _ClickableComponent.call(this, player, options));
	
	    _this.update();
	    player.on('posterchange', bind(_this, _this.update));
	    return _this;
	  }
	
	  /**
	   * Clean up and dispose of the `PosterImage`.
	   */
	
	
	  PosterImage.prototype.dispose = function dispose() {
	    this.player().off('posterchange', this.update);
	    _ClickableComponent.prototype.dispose.call(this);
	  };
	
	  /**
	   * Create the `PosterImage`s DOM element.
	   *
	   * @return {Element}
	   *         The element that gets created.
	   */
	
	
	  PosterImage.prototype.createEl = function createEl$$1() {
	    var el = createEl('div', {
	      className: 'vjs-poster',
	
	      // Don't want poster to be tabbable.
	      tabIndex: -1
	    });
	
	    return el;
	  };
	
	  /**
	   * An {@link EventTarget~EventListener} for {@link Player#posterchange} events.
	   *
	   * @listens Player#posterchange
	   *
	   * @param {EventTarget~Event} [event]
	   *        The `Player#posterchange` event that triggered this function.
	   */
	
	
	  PosterImage.prototype.update = function update(event) {
	    var url = this.player().poster();
	
	    this.setSrc(url);
	
	    // If there's no poster source we should display:none on this component
	    // so it's not still clickable or right-clickable
	    if (url) {
	      this.show();
	    } else {
	      this.hide();
	    }
	  };
	
	  /**
	   * Set the source of the `PosterImage` depending on the display method.
	   *
	   * @param {string} url
	   *        The URL to the source for the `PosterImage`.
	   */
	
	
	  PosterImage.prototype.setSrc = function setSrc(url) {
	    var backgroundImage = '';
	
	    // Any falsy value should stay as an empty string, otherwise
	    // this will throw an extra error
	    if (url) {
	      backgroundImage = 'url("' + url + '")';
	    }
	
	    this.el_.style.backgroundImage = backgroundImage;
	  };
	
	  /**
	   * An {@link EventTarget~EventListener} for clicks on the `PosterImage`. See
	   * {@link ClickableComponent#handleClick} for instances where this will be triggered.
	   *
	   * @listens tap
	   * @listens click
	   * @listens keydown
	   *
	   * @param {EventTarget~Event} event
	   +        The `click`, `tap` or `keydown` event that caused this function to be called.
	   */
	
	
	  PosterImage.prototype.handleClick = function handleClick(event) {
	    // We don't want a click to trigger playback when controls are disabled
	    if (!this.player_.controls()) {
	      return;
	    }
	
	    if (this.player_.paused()) {
	      silencePromise(this.player_.play());
	    } else {
	      this.player_.pause();
	    }
	  };
	
	  return PosterImage;
	}(ClickableComponent);
	
	Component.registerComponent('PosterImage', PosterImage);
	
	/**
	 * @file text-track-display.js
	 */
	
	var darkGray = '#222';
	var lightGray = '#ccc';
	var fontMap = {
	  monospace: 'monospace',
	  sansSerif: 'sans-serif',
	  serif: 'serif',
	  monospaceSansSerif: '"Andale Mono", "Lucida Console", monospace',
	  monospaceSerif: '"Courier New", monospace',
	  proportionalSansSerif: 'sans-serif',
	  proportionalSerif: 'serif',
	  casual: '"Comic Sans MS", Impact, fantasy',
	  script: '"Monotype Corsiva", cursive',
	  smallcaps: '"Andale Mono", "Lucida Console", monospace, sans-serif'
	};
	
	/**
	 * Construct an rgba color from a given hex color code.
	 *
	 * @param {number} color
	 *        Hex number for color, like #f0e or #f604e2.
	 *
	 * @param {number} opacity
	 *        Value for opacity, 0.0 - 1.0.
	 *
	 * @return {string}
	 *         The rgba color that was created, like 'rgba(255, 0, 0, 0.3)'.
	 */
	function constructColor(color, opacity) {
	  var hex = void 0;
	
	  if (color.length === 4) {
	    // color looks like "#f0e"
	    hex = color[1] + color[1] + color[2] + color[2] + color[3] + color[3];
	  } else if (color.length === 7) {
	    // color looks like "#f604e2"
	    hex = color.slice(1);
	  } else {
	    throw new Error('Invalid color code provided, ' + color + '; must be formatted as e.g. #f0e or #f604e2.');
	  }
	  return 'rgba(' + parseInt(hex.slice(0, 2), 16) + ',' + parseInt(hex.slice(2, 4), 16) + ',' + parseInt(hex.slice(4, 6), 16) + ',' + opacity + ')';
	}
	
	/**
	 * Try to update the style of a DOM element. Some style changes will throw an error,
	 * particularly in IE8. Those should be noops.
	 *
	 * @param {Element} el
	 *        The DOM element to be styled.
	 *
	 * @param {string} style
	 *        The CSS property on the element that should be styled.
	 *
	 * @param {string} rule
	 *        The style rule that should be applied to the property.
	 *
	 * @private
	 */
	function tryUpdateStyle(el, style, rule) {
	  try {
	    el.style[style] = rule;
	  } catch (e) {
	
	    // Satisfies linter.
	    return;
	  }
	}
	
	/**
	 * The component for displaying text track cues.
	 *
	 * @extends Component
	 */
	
	var TextTrackDisplay = function (_Component) {
	  inherits(TextTrackDisplay, _Component);
	
	  /**
	   * Creates an instance of this class.
	   *
	   * @param {Player} player
	   *        The `Player` that this class should be attached to.
	   *
	   * @param {Object} [options]
	   *        The key/value store of player options.
	   *
	   * @param {Component~ReadyCallback} [ready]
	   *        The function to call when `TextTrackDisplay` is ready.
	   */
	  function TextTrackDisplay(player, options, ready) {
	    classCallCheck(this, TextTrackDisplay);
	
	    var _this = possibleConstructorReturn(this, _Component.call(this, player, options, ready));
	
	    player.on('loadstart', bind(_this, _this.toggleDisplay));
	    player.on('texttrackchange', bind(_this, _this.updateDisplay));
	    player.on('loadstart', bind(_this, _this.preselectTrack));
	
	    // This used to be called during player init, but was causing an error
	    // if a track should show by default and the display hadn't loaded yet.
	    // Should probably be moved to an external track loader when we support
	    // tracks that don't need a display.
	    player.ready(bind(_this, function () {
	      if (player.tech_ && player.tech_.featuresNativeTextTracks) {
	        this.hide();
	        return;
	      }
	
	      player.on('fullscreenchange', bind(this, this.updateDisplay));
	
	      var tracks = this.options_.playerOptions.tracks || [];
	
	      for (var i = 0; i < tracks.length; i++) {
	        this.player_.addRemoteTextTrack(tracks[i], true);
	      }
	
	      this.preselectTrack();
	    }));
	    return _this;
	  }
	
	  /**
	  * Preselect a track following this precedence:
	  * - matches the previously selected {@link TextTrack}'s language and kind
	  * - matches the previously selected {@link TextTrack}'s language only
	  * - is the first default captions track
	  * - is the first default descriptions track
	  *
	  * @listens Player#loadstart
	  */
	
	
	  TextTrackDisplay.prototype.preselectTrack = function preselectTrack() {
	    var modes = { captions: 1, subtitles: 1 };
	    var trackList = this.player_.textTracks();
	    var userPref = this.player_.cache_.selectedLanguage;
	    var firstDesc = void 0;
	    var firstCaptions = void 0;
	    var preferredTrack = void 0;
	
	    for (var i = 0; i < trackList.length; i++) {
	      var track = trackList[i];
	
	      if (userPref && userPref.enabled && userPref.language === track.language) {
	        // Always choose the track that matches both language and kind
	        if (track.kind === userPref.kind) {
	          preferredTrack = track;
	          // or choose the first track that matches language
	        } else if (!preferredTrack) {
	          preferredTrack = track;
	        }
	
	        // clear everything if offTextTrackMenuItem was clicked
	      } else if (userPref && !userPref.enabled) {
	        preferredTrack = null;
	        firstDesc = null;
	        firstCaptions = null;
	      } else if (track.default) {
	        if (track.kind === 'descriptions' && !firstDesc) {
	          firstDesc = track;
	        } else if (track.kind in modes && !firstCaptions) {
	          firstCaptions = track;
	        }
	      }
	    }
	
	    // The preferredTrack matches the user preference and takes
	    // precedence over all the other tracks.
	    // So, display the preferredTrack before the first default track
	    // and the subtitles/captions track before the descriptions track
	    if (preferredTrack) {
	      preferredTrack.mode = 'showing';
	    } else if (firstCaptions) {
	      firstCaptions.mode = 'showing';
	    } else if (firstDesc) {
	      firstDesc.mode = 'showing';
	    }
	  };
	
	  /**
	   * Turn display of {@link TextTrack}'s from the current state into the other state.
	   * There are only two states:
	   * - 'shown'
	   * - 'hidden'
	   *
	   * @listens Player#loadstart
	   */
	
	
	  TextTrackDisplay.prototype.toggleDisplay = function toggleDisplay() {
	    if (this.player_.tech_ && this.player_.tech_.featuresNativeTextTracks) {
	      this.hide();
	    } else {
	      this.show();
	    }
	  };
	
	  /**
	   * Create the {@link Component}'s DOM element.
	   *
	   * @return {Element}
	   *         The element that was created.
	   */
	
	
	  TextTrackDisplay.prototype.createEl = function createEl() {
	    return _Component.prototype.createEl.call(this, 'div', {
	      className: 'vjs-text-track-display'
	    }, {
	      'aria-live': 'off',
	      'aria-atomic': 'true'
	    });
	  };
	
	  /**
	   * Clear all displayed {@link TextTrack}s.
	   */
	
	
	  TextTrackDisplay.prototype.clearDisplay = function clearDisplay() {
	    if (typeof window$1.WebVTT === 'function') {
	      window$1.WebVTT.processCues(window$1, [], this.el_);
	    }
	  };
	
	  /**
	   * Update the displayed TextTrack when a either a {@link Player#texttrackchange} or
	   * a {@link Player#fullscreenchange} is fired.
	   *
	   * @listens Player#texttrackchange
	   * @listens Player#fullscreenchange
	   */
	
	
	  TextTrackDisplay.prototype.updateDisplay = function updateDisplay() {
	    var tracks = this.player_.textTracks();
	
	    this.clearDisplay();
	
	    // Track display prioritization model: if multiple tracks are 'showing',
	    //  display the first 'subtitles' or 'captions' track which is 'showing',
	    //  otherwise display the first 'descriptions' track which is 'showing'
	
	    var descriptionsTrack = null;
	    var captionsSubtitlesTrack = null;
	    var i = tracks.length;
	
	    while (i--) {
	      var track = tracks[i];
	
	      if (track.mode === 'showing') {
	        if (track.kind === 'descriptions') {
	          descriptionsTrack = track;
	        } else {
	          captionsSubtitlesTrack = track;
	        }
	      }
	    }
	
	    if (captionsSubtitlesTrack) {
	      if (this.getAttribute('aria-live') !== 'off') {
	        this.setAttribute('aria-live', 'off');
	      }
	      this.updateForTrack(captionsSubtitlesTrack);
	    } else if (descriptionsTrack) {
	      if (this.getAttribute('aria-live') !== 'assertive') {
	        this.setAttribute('aria-live', 'assertive');
	      }
	      this.updateForTrack(descriptionsTrack);
	    }
	  };
	
	  /**
	   * Add an {@link TextTrack} to to the {@link Tech}s {@link TextTrackList}.
	   *
	   * @param {TextTrack} track
	   *        Text track object to be added to the list.
	   */
	
	
	  TextTrackDisplay.prototype.updateForTrack = function updateForTrack(track) {
	    if (typeof window$1.WebVTT !== 'function' || !track.activeCues) {
	      return;
	    }
	
	    var cues = [];
	
	    for (var _i = 0; _i < track.activeCues.length; _i++) {
	      cues.push(track.activeCues[_i]);
	    }
	
	    window$1.WebVTT.processCues(window$1, cues, this.el_);
	
	    if (!this.player_.textTrackSettings) {
	      return;
	    }
	
	    var overrides = this.player_.textTrackSettings.getValues();
	
	    var i = cues.length;
	
	    while (i--) {
	      var cue = cues[i];
	
	      if (!cue) {
	        continue;
	      }
	
	      var cueDiv = cue.displayState;
	
	      if (overrides.color) {
	        cueDiv.firstChild.style.color = overrides.color;
	      }
	      if (overrides.textOpacity) {
	        tryUpdateStyle(cueDiv.firstChild, 'color', constructColor(overrides.color || '#fff', overrides.textOpacity));
	      }
	      if (overrides.backgroundColor) {
	        cueDiv.firstChild.style.backgroundColor = overrides.backgroundColor;
	      }
	      if (overrides.backgroundOpacity) {
	        tryUpdateStyle(cueDiv.firstChild, 'backgroundColor', constructColor(overrides.backgroundColor || '#000', overrides.backgroundOpacity));
	      }
	      if (overrides.windowColor) {
	        if (overrides.windowOpacity) {
	          tryUpdateStyle(cueDiv, 'backgroundColor', constructColor(overrides.windowColor, overrides.windowOpacity));
	        } else {
	          cueDiv.style.backgroundColor = overrides.windowColor;
	        }
	      }
	      if (overrides.edgeStyle) {
	        if (overrides.edgeStyle === 'dropshadow') {
	          cueDiv.firstChild.style.textShadow = '2px 2px 3px ' + darkGray + ', 2px 2px 4px ' + darkGray + ', 2px 2px 5px ' + darkGray;
	        } else if (overrides.edgeStyle === 'raised') {
	          cueDiv.firstChild.style.textShadow = '1px 1px ' + darkGray + ', 2px 2px ' + darkGray + ', 3px 3px ' + darkGray;
	        } else if (overrides.edgeStyle === 'depressed') {
	          cueDiv.firstChild.style.textShadow = '1px 1px ' + lightGray + ', 0 1px ' + lightGray + ', -1px -1px ' + darkGray + ', 0 -1px ' + darkGray;
	        } else if (overrides.edgeStyle === 'uniform') {
	          cueDiv.firstChild.style.textShadow = '0 0 4px ' + darkGray + ', 0 0 4px ' + darkGray + ', 0 0 4px ' + darkGray + ', 0 0 4px ' + darkGray;
	        }
	      }
	      if (overrides.fontPercent && overrides.fontPercent !== 1) {
	        var fontSize = window$1.parseFloat(cueDiv.style.fontSize);
	
	        cueDiv.style.fontSize = fontSize * overrides.fontPercent + 'px';
	        cueDiv.style.height = 'auto';
	        cueDiv.style.top = 'auto';
	        cueDiv.style.bottom = '2px';
	      }
	      if (overrides.fontFamily && overrides.fontFamily !== 'default') {
	        if (overrides.fontFamily === 'small-caps') {
	          cueDiv.firstChild.style.fontVariant = 'small-caps';
	        } else {
	          cueDiv.firstChild.style.fontFamily = fontMap[overrides.fontFamily];
	        }
	      }
	    }
	  };
	
	  return TextTrackDisplay;
	}(Component);
	
	Component.registerComponent('TextTrackDisplay', TextTrackDisplay);
	
	/**
	 * @file loading-spinner.js
	 */
	
	/**
	 * A loading spinner for use during waiting/loading events.
	 *
	 * @extends Component
	 */
	
	var LoadingSpinner = function (_Component) {
	  inherits(LoadingSpinner, _Component);
	
	  function LoadingSpinner() {
	    classCallCheck(this, LoadingSpinner);
	    return possibleConstructorReturn(this, _Component.apply(this, arguments));
	  }
	
	  /**
	   * Create the `LoadingSpinner`s DOM element.
	   *
	   * @return {Element}
	   *         The dom element that gets created.
	   */
	  LoadingSpinner.prototype.createEl = function createEl$$1() {
	    var isAudio = this.player_.isAudio();
	    var playerType = this.localize(isAudio ? 'Audio Player' : 'Video Player');
	    var controlText = createEl('span', {
	      className: 'vjs-control-text',
	      innerHTML: this.localize('{1} is loading.', [playerType])
	    });
	
	    var el = _Component.prototype.createEl.call(this, 'div', {
	      className: 'vjs-loading-spinner',
	      dir: 'ltr'
	    });
	
	    el.appendChild(controlText);
	
	    return el;
	  };
	
	  return LoadingSpinner;
	}(Component);
	
	Component.registerComponent('LoadingSpinner', LoadingSpinner);
	
	/**
	 * @file button.js
	 */
	
	/**
	 * Base class for all buttons.
	 *
	 * @extends ClickableComponent
	 */
	
	var Button = function (_ClickableComponent) {
	  inherits(Button, _ClickableComponent);
	
	  function Button() {
	    classCallCheck(this, Button);
	    return possibleConstructorReturn(this, _ClickableComponent.apply(this, arguments));
	  }
	
	  /**
	   * Create the `Button`s DOM element.
	   *
	   * @param {string} [tag="button"]
	   *        The element's node type. This argument is IGNORED: no matter what
	   *        is passed, it will always create a `button` element.
	   *
	   * @param {Object} [props={}]
	   *        An object of properties that should be set on the element.
	   *
	   * @param {Object} [attributes={}]
	   *        An object of attributes that should be set on the element.
	   *
	   * @return {Element}
	   *         The element that gets created.
	   */
	  Button.prototype.createEl = function createEl(tag) {
	    var props = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	    var attributes = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	
	    tag = 'button';
	
	    props = assign({
	      innerHTML: '<span aria-hidden="true" class="vjs-icon-placeholder"></span>',
	      className: this.buildCSSClass()
	    }, props);
	
	    // Add attributes for button element
	    attributes = assign({
	
	      // Necessary since the default button type is "submit"
	      type: 'button'
	    }, attributes);
	
	    var el = Component.prototype.createEl.call(this, tag, props, attributes);
	
	    this.createControlTextEl(el);
	
	    return el;
	  };
	
	  /**
	   * Add a child `Component` inside of this `Button`.
	   *
	   * @param {string|Component} child
	   *        The name or instance of a child to add.
	   *
	   * @param {Object} [options={}]
	   *        The key/value store of options that will get passed to children of
	   *        the child.
	   *
	   * @return {Component}
	   *         The `Component` that gets added as a child. When using a string the
	   *         `Component` will get created by this process.
	   *
	   * @deprecated since version 5
	   */
	
	
	  Button.prototype.addChild = function addChild(child) {
	    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	    var className = this.constructor.name;
	
	    log$1.warn('Adding an actionable (user controllable) child to a Button (' + className + ') is not supported; use a ClickableComponent instead.');
	
	    // Avoid the error message generated by ClickableComponent's addChild method
	    return Component.prototype.addChild.call(this, child, options);
	  };
	
	  /**
	   * Enable the `Button` element so that it can be activated or clicked. Use this with
	   * {@link Button#disable}.
	   */
	
	
	  Button.prototype.enable = function enable() {
	    _ClickableComponent.prototype.enable.call(this);
	    this.el_.removeAttribute('disabled');
	  };
	
	  /**
	   * Disable the `Button` element so that it cannot be activated or clicked. Use this with
	   * {@link Button#enable}.
	   */
	
	
	  Button.prototype.disable = function disable() {
	    _ClickableComponent.prototype.disable.call(this);
	    this.el_.setAttribute('disabled', 'disabled');
	  };
	
	  /**
	   * This gets called when a `Button` has focus and `keydown` is triggered via a key
	   * press.
	   *
	   * @param {EventTarget~Event} event
	   *        The event that caused this function to get called.
	   *
	   * @listens keydown
	   */
	
	
	  Button.prototype.handleKeyPress = function handleKeyPress(event) {
	
	    // Ignore Space (32) or Enter (13) key operation, which is handled by the browser for a button.
	    if (event.which === 32 || event.which === 13) {
	      return;
	    }
	
	    // Pass keypress handling up for unsupported keys
	    _ClickableComponent.prototype.handleKeyPress.call(this, event);
	  };
	
	  return Button;
	}(ClickableComponent);
	
	Component.registerComponent('Button', Button);
	
	/**
	 * @file big-play-button.js
	 */
	
	/**
	 * The initial play button that shows before the video has played. The hiding of the
	 * `BigPlayButton` get done via CSS and `Player` states.
	 *
	 * @extends Button
	 */
	
	var BigPlayButton = function (_Button) {
	  inherits(BigPlayButton, _Button);
	
	  function BigPlayButton(player, options) {
	    classCallCheck(this, BigPlayButton);
	
	    var _this = possibleConstructorReturn(this, _Button.call(this, player, options));
	
	    _this.mouseused_ = false;
	
	    _this.on('mousedown', _this.handleMouseDown);
	    return _this;
	  }
	
	  /**
	   * Builds the default DOM `className`.
	   *
	   * @return {string}
	   *         The DOM `className` for this object. Always returns 'vjs-big-play-button'.
	   */
	
	
	  BigPlayButton.prototype.buildCSSClass = function buildCSSClass() {
	    return 'vjs-big-play-button';
	  };
	
	  /**
	   * This gets called when a `BigPlayButton` "clicked". See {@link ClickableComponent}
	   * for more detailed information on what a click can be.
	   *
	   * @param {EventTarget~Event} event
	   *        The `keydown`, `tap`, or `click` event that caused this function to be
	   *        called.
	   *
	   * @listens tap
	   * @listens click
	   */
	
	
	  BigPlayButton.prototype.handleClick = function handleClick(event) {
	    var playPromise = this.player_.play();
	
	    // exit early if clicked via the mouse
	    if (this.mouseused_ && event.clientX && event.clientY) {
	      silencePromise(playPromise);
	      return;
	    }
	
	    var cb = this.player_.getChild('controlBar');
	    var playToggle = cb && cb.getChild('playToggle');
	
	    if (!playToggle) {
	      this.player_.focus();
	      return;
	    }
	
	    var playFocus = function playFocus() {
	      return playToggle.focus();
	    };
	
	    if (isPromise(playPromise)) {
	      playPromise.then(playFocus, function () {});
	    } else {
	      this.setTimeout(playFocus, 1);
	    }
	  };
	
	  BigPlayButton.prototype.handleKeyPress = function handleKeyPress(event) {
	    this.mouseused_ = false;
	
	    _Button.prototype.handleKeyPress.call(this, event);
	  };
	
	  BigPlayButton.prototype.handleMouseDown = function handleMouseDown(event) {
	    this.mouseused_ = true;
	  };
	
	  return BigPlayButton;
	}(Button);
	
	/**
	 * The text that should display over the `BigPlayButton`s controls. Added to for localization.
	 *
	 * @type {string}
	 * @private
	 */
	
	
	BigPlayButton.prototype.controlText_ = 'Play Video';
	
	Component.registerComponent('BigPlayButton', BigPlayButton);
	
	/**
	 * @file close-button.js
	 */
	
	/**
	 * The `CloseButton` is a `{@link Button}` that fires a `close` event when
	 * it gets clicked.
	 *
	 * @extends Button
	 */
	
	var CloseButton = function (_Button) {
	  inherits(CloseButton, _Button);
	
	  /**
	   * Creates an instance of the this class.
	   *
	   * @param  {Player} player
	   *         The `Player` that this class should be attached to.
	   *
	   * @param  {Object} [options]
	   *         The key/value store of player options.
	   */
	  function CloseButton(player, options) {
	    classCallCheck(this, CloseButton);
	
	    var _this = possibleConstructorReturn(this, _Button.call(this, player, options));
	
	    _this.controlText(options && options.controlText || _this.localize('Close'));
	    return _this;
	  }
	
	  /**
	   * Builds the default DOM `className`.
	   *
	   * @return {string}
	   *         The DOM `className` for this object.
	   */
	
	
	  CloseButton.prototype.buildCSSClass = function buildCSSClass() {
	    return 'vjs-close-button ' + _Button.prototype.buildCSSClass.call(this);
	  };
	
	  /**
	   * This gets called when a `CloseButton` gets clicked. See
	   * {@link ClickableComponent#handleClick} for more information on when this will be
	   * triggered
	   *
	   * @param {EventTarget~Event} event
	   *        The `keydown`, `tap`, or `click` event that caused this function to be
	   *        called.
	   *
	   * @listens tap
	   * @listens click
	   * @fires CloseButton#close
	   */
	
	
	  CloseButton.prototype.handleClick = function handleClick(event) {
	
	    /**
	     * Triggered when the a `CloseButton` is clicked.
	     *
	     * @event CloseButton#close
	     * @type {EventTarget~Event}
	     *
	     * @property {boolean} [bubbles=false]
	     *           set to false so that the close event does not
	     *           bubble up to parents if there is no listener
	     */
	    this.trigger({ type: 'close', bubbles: false });
	  };
	
	  return CloseButton;
	}(Button);
	
	Component.registerComponent('CloseButton', CloseButton);
	
	/**
	 * @file play-toggle.js
	 */
	
	/**
	 * Button to toggle between play and pause.
	 *
	 * @extends Button
	 */
	
	var PlayToggle = function (_Button) {
	  inherits(PlayToggle, _Button);
	
	  /**
	   * Creates an instance of this class.
	   *
	   * @param {Player} player
	   *        The `Player` that this class should be attached to.
	   *
	   * @param {Object} [options]
	   *        The key/value store of player options.
	   */
	  function PlayToggle(player, options) {
	    classCallCheck(this, PlayToggle);
	
	    var _this = possibleConstructorReturn(this, _Button.call(this, player, options));
	
	    _this.on(player, 'play', _this.handlePlay);
	    _this.on(player, 'pause', _this.handlePause);
	    _this.on(player, 'ended', _this.handleEnded);
	    return _this;
	  }
	
	  /**
	   * Builds the default DOM `className`.
	   *
	   * @return {string}
	   *         The DOM `className` for this object.
	   */
	
	
	  PlayToggle.prototype.buildCSSClass = function buildCSSClass() {
	    return 'vjs-play-control ' + _Button.prototype.buildCSSClass.call(this);
	  };
	
	  /**
	   * This gets called when an `PlayToggle` is "clicked". See
	   * {@link ClickableComponent} for more detailed information on what a click can be.
	   *
	   * @param {EventTarget~Event} [event]
	   *        The `keydown`, `tap`, or `click` event that caused this function to be
	   *        called.
	   *
	   * @listens tap
	   * @listens click
	   */
	
	
	  PlayToggle.prototype.handleClick = function handleClick(event) {
	    if (this.player_.paused()) {
	      this.player_.play();
	    } else {
	      this.player_.pause();
	    }
	  };
	
	  /**
	   * This gets called once after the video has ended and the user seeks so that
	   * we can change the replay button back to a play button.
	   *
	   * @param {EventTarget~Event} [event]
	   *        The event that caused this function to run.
	   *
	   * @listens Player#seeked
	   */
	
	
	  PlayToggle.prototype.handleSeeked = function handleSeeked(event) {
	    this.removeClass('vjs-ended');
	
	    if (this.player_.paused()) {
	      this.handlePause(event);
	    } else {
	      this.handlePlay(event);
	    }
	  };
	
	  /**
	   * Add the vjs-playing class to the element so it can change appearance.
	   *
	   * @param {EventTarget~Event} [event]
	   *        The event that caused this function to run.
	   *
	   * @listens Player#play
	   */
	
	
	  PlayToggle.prototype.handlePlay = function handlePlay(event) {
	    this.removeClass('vjs-ended');
	    this.removeClass('vjs-paused');
	    this.addClass('vjs-playing');
	    // change the button text to "Pause"
	    this.controlText('Pause');
	  };
	
	  /**
	   * Add the vjs-paused class to the element so it can change appearance.
	   *
	   * @param {EventTarget~Event} [event]
	   *        The event that caused this function to run.
	   *
	   * @listens Player#pause
	   */
	
	
	  PlayToggle.prototype.handlePause = function handlePause(event) {
	    this.removeClass('vjs-playing');
	    this.addClass('vjs-paused');
	    // change the button text to "Play"
	    this.controlText('Play');
	  };
	
	  /**
	   * Add the vjs-ended class to the element so it can change appearance
	   *
	   * @param {EventTarget~Event} [event]
	   *        The event that caused this function to run.
	   *
	   * @listens Player#ended
	   */
	
	
	  PlayToggle.prototype.handleEnded = function handleEnded(event) {
	    this.removeClass('vjs-playing');
	    this.addClass('vjs-ended');
	    // change the button text to "Replay"
	    this.controlText('Replay');
	
	    // on the next seek remove the replay button
	    this.one(this.player_, 'seeked', this.handleSeeked);
	  };
	
	  return PlayToggle;
	}(Button);
	
	/**
	 * The text that should display over the `PlayToggle`s controls. Added for localization.
	 *
	 * @type {string}
	 * @private
	 */
	
	
	PlayToggle.prototype.controlText_ = 'Play';
	
	Component.registerComponent('PlayToggle', PlayToggle);
	
	/**
	 * @file format-time.js
	 * @module format-time
	 */
	
	/**
	* Format seconds as a time string, H:MM:SS or M:SS. Supplying a guide (in seconds)
	* will force a number of leading zeros to cover the length of the guide.
	*
	* @param {number} seconds
	*        Number of seconds to be turned into a string
	*
	* @param {number} guide
	*        Number (in seconds) to model the string after
	*
	* @return {string}
	*         Time formatted as H:MM:SS or M:SS
	*/
	var defaultImplementation = function defaultImplementation(seconds, guide) {
	  seconds = seconds < 0 ? 0 : seconds;
	  var s = Math.floor(seconds % 60);
	  var m = Math.floor(seconds / 60 % 60);
	  var h = Math.floor(seconds / 3600);
	  var gm = Math.floor(guide / 60 % 60);
	  var gh = Math.floor(guide / 3600);
	
	  // handle invalid times
	  if (isNaN(seconds) || seconds === Infinity) {
	    // '-' is false for all relational operators (e.g. <, >=) so this setting
	    // will add the minimum number of fields specified by the guide
	    h = m = s = '-';
	  }
	
	  // Check if we need to show hours
	  h = h > 0 || gh > 0 ? h + ':' : '';
	
	  // If hours are showing, we may need to add a leading zero.
	  // Always show at least one digit of minutes.
	  m = ((h || gm >= 10) && m < 10 ? '0' + m : m) + ':';
	
	  // Check if leading zero is need for seconds
	  s = s < 10 ? '0' + s : s;
	
	  return h + m + s;
	};
	
	var implementation = defaultImplementation;
	
	/**
	 * Replaces the default formatTime implementation with a custom implementation.
	 *
	 * @param {Function} customImplementation
	 *        A function which will be used in place of the default formatTime implementation.
	 *        Will receive the current time in seconds and the guide (in seconds) as arguments.
	 */
	function setFormatTime(customImplementation) {
	  implementation = customImplementation;
	}
	
	/**
	 * Resets formatTime to the default implementation.
	 */
	function resetFormatTime() {
	  implementation = defaultImplementation;
	}
	
	function formatTime (seconds) {
	  var guide = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : seconds;
	
	  return implementation(seconds, guide);
	}
	
	/**
	 * @file time-display.js
	 */
	
	/**
	 * Displays the time left in the video
	 *
	 * @extends Component
	 */
	
	var TimeDisplay = function (_Component) {
	  inherits(TimeDisplay, _Component);
	
	  /**
	   * Creates an instance of this class.
	   *
	   * @param {Player} player
	   *        The `Player` that this class should be attached to.
	   *
	   * @param {Object} [options]
	   *        The key/value store of player options.
	   */
	  function TimeDisplay(player, options) {
	    classCallCheck(this, TimeDisplay);
	
	    var _this = possibleConstructorReturn(this, _Component.call(this, player, options));
	
	    _this.throttledUpdateContent = throttle(bind(_this, _this.updateContent), 25);
	    _this.on(player, 'timeupdate', _this.throttledUpdateContent);
	    return _this;
	  }
	
	  /**
	   * Create the `Component`'s DOM element
	   *
	   * @return {Element}
	   *         The element that was created.
	   */
	
	
	  TimeDisplay.prototype.createEl = function createEl$$1(plainName) {
	    var className = this.buildCSSClass();
	    var el = _Component.prototype.createEl.call(this, 'div', {
	      className: className + ' vjs-time-control vjs-control',
	      innerHTML: '<span class="vjs-control-text">' + this.localize(this.labelText_) + '\xA0</span>'
	    });
	
	    this.contentEl_ = createEl('span', {
	      className: className + '-display'
	    }, {
	      // tell screen readers not to automatically read the time as it changes
	      'aria-live': 'off'
	    });
	
	    this.updateTextNode_();
	    el.appendChild(this.contentEl_);
	    return el;
	  };
	
	  TimeDisplay.prototype.dispose = function dispose() {
	    this.contentEl_ = null;
	    this.textNode_ = null;
	
	    _Component.prototype.dispose.call(this);
	  };
	
	  /**
	   * Updates the "remaining time" text node with new content using the
	   * contents of the `formattedTime_` property.
	   *
	   * @private
	   */
	
	
	  TimeDisplay.prototype.updateTextNode_ = function updateTextNode_() {
	    if (!this.contentEl_) {
	      return;
	    }
	
	    while (this.contentEl_.firstChild) {
	      this.contentEl_.removeChild(this.contentEl_.firstChild);
	    }
	
	    this.textNode_ = document.createTextNode(this.formattedTime_ || this.formatTime_(0));
	    this.contentEl_.appendChild(this.textNode_);
	  };
	
	  /**
	   * Generates a formatted time for this component to use in display.
	   *
	   * @param  {number} time
	   *         A numeric time, in seconds.
	   *
	   * @return {string}
	   *         A formatted time
	   *
	   * @private
	   */
	
	
	  TimeDisplay.prototype.formatTime_ = function formatTime_(time) {
	    return formatTime(time);
	  };
	
	  /**
	   * Updates the time display text node if it has what was passed in changed
	   * the formatted time.
	   *
	   * @param {number} time
	   *        The time to update to
	   *
	   * @private
	   */
	
	
	  TimeDisplay.prototype.updateFormattedTime_ = function updateFormattedTime_(time) {
	    var formattedTime = this.formatTime_(time);
	
	    if (formattedTime === this.formattedTime_) {
	      return;
	    }
	
	    this.formattedTime_ = formattedTime;
	    this.requestAnimationFrame(this.updateTextNode_);
	  };
	
	  /**
	   * To be filled out in the child class, should update the displayed time
	   * in accordance with the fact that the current time has changed.
	   *
	   * @param {EventTarget~Event} [event]
	   *        The `timeupdate`  event that caused this to run.
	   *
	   * @listens Player#timeupdate
	   */
	
	
	  TimeDisplay.prototype.updateContent = function updateContent(event) {};
	
	  return TimeDisplay;
	}(Component);
	
	/**
	 * The text that is added to the `TimeDisplay` for screen reader users.
	 *
	 * @type {string}
	 * @private
	 */
	
	
	TimeDisplay.prototype.labelText_ = 'Time';
	
	/**
	 * The text that should display over the `TimeDisplay`s controls. Added to for localization.
	 *
	 * @type {string}
	 * @private
	 *
	 * @deprecated in v7; controlText_ is not used in non-active display Components
	 */
	TimeDisplay.prototype.controlText_ = 'Time';
	
	Component.registerComponent('TimeDisplay', TimeDisplay);
	
	/**
	 * @file current-time-display.js
	 */
	
	/**
	 * Displays the current time
	 *
	 * @extends Component
	 */
	
	var CurrentTimeDisplay = function (_TimeDisplay) {
	  inherits(CurrentTimeDisplay, _TimeDisplay);
	
	  /**
	   * Creates an instance of this class.
	   *
	   * @param {Player} player
	   *        The `Player` that this class should be attached to.
	   *
	   * @param {Object} [options]
	   *        The key/value store of player options.
	   */
	  function CurrentTimeDisplay(player, options) {
	    classCallCheck(this, CurrentTimeDisplay);
	
	    var _this = possibleConstructorReturn(this, _TimeDisplay.call(this, player, options));
	
	    _this.on(player, 'ended', _this.handleEnded);
	    return _this;
	  }
	
	  /**
	   * Builds the default DOM `className`.
	   *
	   * @return {string}
	   *         The DOM `className` for this object.
	   */
	
	
	  CurrentTimeDisplay.prototype.buildCSSClass = function buildCSSClass() {
	    return 'vjs-current-time';
	  };
	
	  /**
	   * Update current time display
	   *
	   * @param {EventTarget~Event} [event]
	   *        The `timeupdate` event that caused this function to run.
	   *
	   * @listens Player#timeupdate
	   */
	
	
	  CurrentTimeDisplay.prototype.updateContent = function updateContent(event) {
	    // Allows for smooth scrubbing, when player can't keep up.
	    var time = this.player_.scrubbing() ? this.player_.getCache().currentTime : this.player_.currentTime();
	
	    this.updateFormattedTime_(time);
	  };
	
	  /**
	   * When the player fires ended there should be no time left. Sadly
	   * this is not always the case, lets make it seem like that is the case
	   * for users.
	   *
	   * @param {EventTarget~Event} [event]
	   *        The `ended` event that caused this to run.
	   *
	   * @listens Player#ended
	   */
	
	
	  CurrentTimeDisplay.prototype.handleEnded = function handleEnded(event) {
	    if (!this.player_.duration()) {
	      return;
	    }
	    this.updateFormattedTime_(this.player_.duration());
	  };
	
	  return CurrentTimeDisplay;
	}(TimeDisplay);
	
	/**
	 * The text that is added to the `CurrentTimeDisplay` for screen reader users.
	 *
	 * @type {string}
	 * @private
	 */
	
	
	CurrentTimeDisplay.prototype.labelText_ = 'Current Time';
	
	/**
	 * The text that should display over the `CurrentTimeDisplay`s controls. Added to for localization.
	 *
	 * @type {string}
	 * @private
	 *
	 * @deprecated in v7; controlText_ is not used in non-active display Components
	 */
	CurrentTimeDisplay.prototype.controlText_ = 'Current Time';
	
	Component.registerComponent('CurrentTimeDisplay', CurrentTimeDisplay);
	
	/**
	 * @file duration-display.js
	 */
	
	/**
	 * Displays the duration
	 *
	 * @extends Component
	 */
	
	var DurationDisplay = function (_TimeDisplay) {
	  inherits(DurationDisplay, _TimeDisplay);
	
	  /**
	   * Creates an instance of this class.
	   *
	   * @param {Player} player
	   *        The `Player` that this class should be attached to.
	   *
	   * @param {Object} [options]
	   *        The key/value store of player options.
	   */
	  function DurationDisplay(player, options) {
	    classCallCheck(this, DurationDisplay);
	
	    // we do not want to/need to throttle duration changes,
	    // as they should always display the changed duration as
	    // it has changed
	    var _this = possibleConstructorReturn(this, _TimeDisplay.call(this, player, options));
	
	    _this.on(player, 'durationchange', _this.updateContent);
	
	    // Also listen for timeupdate (in the parent) and loadedmetadata because removing those
	    // listeners could have broken dependent applications/libraries. These
	    // can likely be removed for 7.0.
	    _this.on(player, 'loadedmetadata', _this.throttledUpdateContent);
	    return _this;
	  }
	
	  /**
	   * Builds the default DOM `className`.
	   *
	   * @return {string}
	   *         The DOM `className` for this object.
	   */
	
	
	  DurationDisplay.prototype.buildCSSClass = function buildCSSClass() {
	    return 'vjs-duration';
	  };
	
	  /**
	   * Update duration time display.
	   *
	   * @param {EventTarget~Event} [event]
	   *        The `durationchange`, `timeupdate`, or `loadedmetadata` event that caused
	   *        this function to be called.
	   *
	   * @listens Player#durationchange
	   * @listens Player#timeupdate
	   * @listens Player#loadedmetadata
	   */
	
	
	  DurationDisplay.prototype.updateContent = function updateContent(event) {
	    var duration = this.player_.duration();
	
	    if (duration && this.duration_ !== duration) {
	      this.duration_ = duration;
	      this.updateFormattedTime_(duration);
	    }
	  };
	
	  return DurationDisplay;
	}(TimeDisplay);
	
	/**
	 * The text that is added to the `DurationDisplay` for screen reader users.
	 *
	 * @type {string}
	 * @private
	 */
	
	
	DurationDisplay.prototype.labelText_ = 'Duration';
	
	/**
	 * The text that should display over the `DurationDisplay`s controls. Added to for localization.
	 *
	 * @type {string}
	 * @private
	 *
	 * @deprecated in v7; controlText_ is not used in non-active display Components
	 */
	DurationDisplay.prototype.controlText_ = 'Duration';
	
	Component.registerComponent('DurationDisplay', DurationDisplay);
	
	/**
	 * @file time-divider.js
	 */
	
	/**
	 * The separator between the current time and duration.
	 * Can be hidden if it's not needed in the design.
	 *
	 * @extends Component
	 */
	
	var TimeDivider = function (_Component) {
	  inherits(TimeDivider, _Component);
	
	  function TimeDivider() {
	    classCallCheck(this, TimeDivider);
	    return possibleConstructorReturn(this, _Component.apply(this, arguments));
	  }
	
	  /**
	   * Create the component's DOM element
	   *
	   * @return {Element}
	   *         The element that was created.
	   */
	  TimeDivider.prototype.createEl = function createEl() {
	    return _Component.prototype.createEl.call(this, 'div', {
	      className: 'vjs-time-control vjs-time-divider',
	      innerHTML: '<div><span>/</span></div>'
	    });
	  };
	
	  return TimeDivider;
	}(Component);
	
	Component.registerComponent('TimeDivider', TimeDivider);
	
	/**
	 * @file remaining-time-display.js
	 */
	/**
	 * Displays the time left in the video
	 *
	 * @extends Component
	 */
	
	var RemainingTimeDisplay = function (_TimeDisplay) {
	  inherits(RemainingTimeDisplay, _TimeDisplay);
	
	  /**
	   * Creates an instance of this class.
	   *
	   * @param {Player} player
	   *        The `Player` that this class should be attached to.
	   *
	   * @param {Object} [options]
	   *        The key/value store of player options.
	   */
	  function RemainingTimeDisplay(player, options) {
	    classCallCheck(this, RemainingTimeDisplay);
	
	    var _this = possibleConstructorReturn(this, _TimeDisplay.call(this, player, options));
	
	    _this.on(player, 'durationchange', _this.throttledUpdateContent);
	    _this.on(player, 'ended', _this.handleEnded);
	    return _this;
	  }
	
	  /**
	   * Builds the default DOM `className`.
	   *
	   * @return {string}
	   *         The DOM `className` for this object.
	   */
	
	
	  RemainingTimeDisplay.prototype.buildCSSClass = function buildCSSClass() {
	    return 'vjs-remaining-time';
	  };
	
	  /**
	   * The remaining time display prefixes numbers with a "minus" character.
	   *
	   * @param  {number} time
	   *         A numeric time, in seconds.
	   *
	   * @return {string}
	   *         A formatted time
	   *
	   * @private
	   */
	
	
	  RemainingTimeDisplay.prototype.formatTime_ = function formatTime_(time) {
	    // TODO: The "-" should be decorative, and not announced by a screen reader
	    return '-' + _TimeDisplay.prototype.formatTime_.call(this, time);
	  };
	
	  /**
	   * Update remaining time display.
	   *
	   * @param {EventTarget~Event} [event]
	   *        The `timeupdate` or `durationchange` event that caused this to run.
	   *
	   * @listens Player#timeupdate
	   * @listens Player#durationchange
	   */
	
	
	  RemainingTimeDisplay.prototype.updateContent = function updateContent(event) {
	    if (!this.player_.duration()) {
	      return;
	    }
	
	    // @deprecated We should only use remainingTimeDisplay
	    // as of video.js 7
	    if (this.player_.remainingTimeDisplay) {
	      this.updateFormattedTime_(this.player_.remainingTimeDisplay());
	    } else {
	      this.updateFormattedTime_(this.player_.remainingTime());
	    }
	  };
	
	  /**
	   * When the player fires ended there should be no time left. Sadly
	   * this is not always the case, lets make it seem like that is the case
	   * for users.
	   *
	   * @param {EventTarget~Event} [event]
	   *        The `ended` event that caused this to run.
	   *
	   * @listens Player#ended
	   */
	
	
	  RemainingTimeDisplay.prototype.handleEnded = function handleEnded(event) {
	    if (!this.player_.duration()) {
	      return;
	    }
	    this.updateFormattedTime_(0);
	  };
	
	  return RemainingTimeDisplay;
	}(TimeDisplay);
	
	/**
	 * The text that is added to the `RemainingTimeDisplay` for screen reader users.
	 *
	 * @type {string}
	 * @private
	 */
	
	
	RemainingTimeDisplay.prototype.labelText_ = 'Remaining Time';
	
	/**
	 * The text that should display over the `RemainingTimeDisplay`s controls. Added to for localization.
	 *
	 * @type {string}
	 * @private
	 *
	 * @deprecated in v7; controlText_ is not used in non-active display Components
	 */
	RemainingTimeDisplay.prototype.controlText_ = 'Remaining Time';
	
	Component.registerComponent('RemainingTimeDisplay', RemainingTimeDisplay);
	
	/**
	 * @file live-display.js
	 */
	
	// TODO - Future make it click to snap to live
	
	/**
	 * Displays the live indicator when duration is Infinity.
	 *
	 * @extends Component
	 */
	
	var LiveDisplay = function (_Component) {
	  inherits(LiveDisplay, _Component);
	
	  /**
	   * Creates an instance of this class.
	   *
	   * @param {Player} player
	   *        The `Player` that this class should be attached to.
	   *
	   * @param {Object} [options]
	   *        The key/value store of player options.
	   */
	  function LiveDisplay(player, options) {
	    classCallCheck(this, LiveDisplay);
	
	    var _this = possibleConstructorReturn(this, _Component.call(this, player, options));
	
	    _this.updateShowing();
	    _this.on(_this.player(), 'durationchange', _this.updateShowing);
	    return _this;
	  }
	
	  /**
	   * Create the `Component`'s DOM element
	   *
	   * @return {Element}
	   *         The element that was created.
	   */
	
	
	  LiveDisplay.prototype.createEl = function createEl$$1() {
	    var el = _Component.prototype.createEl.call(this, 'div', {
	      className: 'vjs-live-control vjs-control'
	    });
	
	    this.contentEl_ = createEl('div', {
	      className: 'vjs-live-display',
	      innerHTML: '<span class="vjs-control-text">' + this.localize('Stream Type') + '\xA0</span>' + this.localize('LIVE')
	    }, {
	      'aria-live': 'off'
	    });
	
	    el.appendChild(this.contentEl_);
	    return el;
	  };
	
	  LiveDisplay.prototype.dispose = function dispose() {
	    this.contentEl_ = null;
	
	    _Component.prototype.dispose.call(this);
	  };
	
	  /**
	   * Check the duration to see if the LiveDisplay should be showing or not. Then show/hide
	   * it accordingly
	   *
	   * @param {EventTarget~Event} [event]
	   *        The {@link Player#durationchange} event that caused this function to run.
	   *
	   * @listens Player#durationchange
	   */
	
	
	  LiveDisplay.prototype.updateShowing = function updateShowing(event) {
	    if (this.player().duration() === Infinity) {
	      this.show();
	    } else {
	      this.hide();
	    }
	  };
	
	  return LiveDisplay;
	}(Component);
	
	Component.registerComponent('LiveDisplay', LiveDisplay);
	
	/**
	 * @file slider.js
	 */
	
	/**
	 * The base functionality for a slider. Can be vertical or horizontal.
	 * For instance the volume bar or the seek bar on a video is a slider.
	 *
	 * @extends Component
	 */
	
	var Slider = function (_Component) {
	  inherits(Slider, _Component);
	
	  /**
	   * Create an instance of this class
	   *
	   * @param {Player} player
	   *        The `Player` that this class should be attached to.
	   *
	   * @param {Object} [options]
	   *        The key/value store of player options.
	   */
	  function Slider(player, options) {
	    classCallCheck(this, Slider);
	
	    // Set property names to bar to match with the child Slider class is looking for
	    var _this = possibleConstructorReturn(this, _Component.call(this, player, options));
	
	    _this.bar = _this.getChild(_this.options_.barName);
	
	    // Set a horizontal or vertical class on the slider depending on the slider type
	    _this.vertical(!!_this.options_.vertical);
	
	    _this.enable();
	    return _this;
	  }
	
	  /**
	   * Are controls are currently enabled for this slider or not.
	   *
	   * @return {boolean}
	   *         true if controls are enabled, false otherwise
	   */
	
	
	  Slider.prototype.enabled = function enabled() {
	    return this.enabled_;
	  };
	
	  /**
	   * Enable controls for this slider if they are disabled
	   */
	
	
	  Slider.prototype.enable = function enable() {
	    if (this.enabled()) {
	      return;
	    }
	
	    this.on('mousedown', this.handleMouseDown);
	    this.on('touchstart', this.handleMouseDown);
	    this.on('focus', this.handleFocus);
	    this.on('blur', this.handleBlur);
	    this.on('click', this.handleClick);
	
	    this.on(this.player_, 'controlsvisible', this.update);
	
	    if (this.playerEvent) {
	      this.on(this.player_, this.playerEvent, this.update);
	    }
	
	    this.removeClass('disabled');
	    this.setAttribute('tabindex', 0);
	
	    this.enabled_ = true;
	  };
	
	  /**
	   * Disable controls for this slider if they are enabled
	   */
	
	
	  Slider.prototype.disable = function disable() {
	    if (!this.enabled()) {
	      return;
	    }
	    var doc = this.bar.el_.ownerDocument;
	
	    this.off('mousedown', this.handleMouseDown);
	    this.off('touchstart', this.handleMouseDown);
	    this.off('focus', this.handleFocus);
	    this.off('blur', this.handleBlur);
	    this.off('click', this.handleClick);
	    this.off(this.player_, 'controlsvisible', this.update);
	    this.off(doc, 'mousemove', this.handleMouseMove);
	    this.off(doc, 'mouseup', this.handleMouseUp);
	    this.off(doc, 'touchmove', this.handleMouseMove);
	    this.off(doc, 'touchend', this.handleMouseUp);
	    this.removeAttribute('tabindex');
	
	    this.addClass('disabled');
	
	    if (this.playerEvent) {
	      this.off(this.player_, this.playerEvent, this.update);
	    }
	    this.enabled_ = false;
	  };
	
	  /**
	   * Create the `Slider`s DOM element.
	   *
	   * @param {string} type
	   *        Type of element to create.
	   *
	   * @param {Object} [props={}]
	   *        List of properties in Object form.
	   *
	   * @param {Object} [attributes={}]
	   *        list of attributes in Object form.
	   *
	   * @return {Element}
	   *         The element that gets created.
	   */
	
	
	  Slider.prototype.createEl = function createEl$$1(type) {
	    var props = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	    var attributes = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	
	    // Add the slider element class to all sub classes
	    props.className = props.className + ' vjs-slider';
	    props = assign({
	      tabIndex: 0
	    }, props);
	
	    attributes = assign({
	      'role': 'slider',
	      'aria-valuenow': 0,
	      'aria-valuemin': 0,
	      'aria-valuemax': 100,
	      'tabIndex': 0
	    }, attributes);
	
	    return _Component.prototype.createEl.call(this, type, props, attributes);
	  };
	
	  /**
	   * Handle `mousedown` or `touchstart` events on the `Slider`.
	   *
	   * @param {EventTarget~Event} event
	   *        `mousedown` or `touchstart` event that triggered this function
	   *
	   * @listens mousedown
	   * @listens touchstart
	   * @fires Slider#slideractive
	   */
	
	
	  Slider.prototype.handleMouseDown = function handleMouseDown(event) {
	    var doc = this.bar.el_.ownerDocument;
	
	    if (event.type === 'mousedown') {
	      event.preventDefault();
	    }
	    // Do not call preventDefault() on touchstart in Chrome
	    // to avoid console warnings. Use a 'touch-action: none' style
	    // instead to prevent unintented scrolling.
	    // https://developers.google.com/web/updates/2017/01/scrolling-intervention
	    if (event.type === 'touchstart' && !IS_CHROME) {
	      event.preventDefault();
	    }
	    blockTextSelection();
	
	    this.addClass('vjs-sliding');
	    /**
	     * Triggered when the slider is in an active state
	     *
	     * @event Slider#slideractive
	     * @type {EventTarget~Event}
	     */
	    this.trigger('slideractive');
	
	    this.on(doc, 'mousemove', this.handleMouseMove);
	    this.on(doc, 'mouseup', this.handleMouseUp);
	    this.on(doc, 'touchmove', this.handleMouseMove);
	    this.on(doc, 'touchend', this.handleMouseUp);
	
	    this.handleMouseMove(event);
	  };
	
	  /**
	   * Handle the `mousemove`, `touchmove`, and `mousedown` events on this `Slider`.
	   * The `mousemove` and `touchmove` events will only only trigger this function during
	   * `mousedown` and `touchstart`. This is due to {@link Slider#handleMouseDown} and
	   * {@link Slider#handleMouseUp}.
	   *
	   * @param {EventTarget~Event} event
	   *        `mousedown`, `mousemove`, `touchstart`, or `touchmove` event that triggered
	   *        this function
	   *
	   * @listens mousemove
	   * @listens touchmove
	   */
	
	
	  Slider.prototype.handleMouseMove = function handleMouseMove(event) {};
	
	  /**
	   * Handle `mouseup` or `touchend` events on the `Slider`.
	   *
	   * @param {EventTarget~Event} event
	   *        `mouseup` or `touchend` event that triggered this function.
	   *
	   * @listens touchend
	   * @listens mouseup
	   * @fires Slider#sliderinactive
	   */
	
	
	  Slider.prototype.handleMouseUp = function handleMouseUp() {
	    var doc = this.bar.el_.ownerDocument;
	
	    unblockTextSelection();
	
	    this.removeClass('vjs-sliding');
	    /**
	     * Triggered when the slider is no longer in an active state.
	     *
	     * @event Slider#sliderinactive
	     * @type {EventTarget~Event}
	     */
	    this.trigger('sliderinactive');
	
	    this.off(doc, 'mousemove', this.handleMouseMove);
	    this.off(doc, 'mouseup', this.handleMouseUp);
	    this.off(doc, 'touchmove', this.handleMouseMove);
	    this.off(doc, 'touchend', this.handleMouseUp);
	
	    this.update();
	  };
	
	  /**
	   * Update the progress bar of the `Slider`.
	   *
	   * @returns {number}
	   *          The percentage of progress the progress bar represents as a
	   *          number from 0 to 1.
	   */
	
	
	  Slider.prototype.update = function update() {
	
	    // In VolumeBar init we have a setTimeout for update that pops and update
	    // to the end of the execution stack. The player is destroyed before then
	    // update will cause an error
	    if (!this.el_) {
	      return;
	    }
	
	    // If scrubbing, we could use a cached value to make the handle keep up
	    // with the user's mouse. On HTML5 browsers scrubbing is really smooth, but
	    // some flash players are slow, so we might want to utilize this later.
	    // var progress =  (this.player_.scrubbing()) ? this.player_.getCache().currentTime / this.player_.duration() : this.player_.currentTime() / this.player_.duration();
	    var progress = this.getPercent();
	    var bar = this.bar;
	
	    // If there's no bar...
	    if (!bar) {
	      return;
	    }
	
	    // Protect against no duration and other division issues
	    if (typeof progress !== 'number' || progress !== progress || progress < 0 || progress === Infinity) {
	      progress = 0;
	    }
	
	    // Convert to a percentage for setting
	    var percentage = (progress * 100).toFixed(2) + '%';
	    var style = bar.el().style;
	
	    // Set the new bar width or height
	    if (this.vertical()) {
	      style.height = percentage;
	    } else {
	      style.width = percentage;
	    }
	
	    return progress;
	  };
	
	  /**
	   * Calculate distance for slider
	   *
	   * @param {EventTarget~Event} event
	   *        The event that caused this function to run.
	   *
	   * @return {number}
	   *         The current position of the Slider.
	   *         - position.x for vertical `Slider`s
	   *         - position.y for horizontal `Slider`s
	   */
	
	
	  Slider.prototype.calculateDistance = function calculateDistance(event) {
	    var position = getPointerPosition(this.el_, event);
	
	    if (this.vertical()) {
	      return position.y;
	    }
	    return position.x;
	  };
	
	  /**
	   * Handle a `focus` event on this `Slider`.
	   *
	   * @param {EventTarget~Event} event
	   *        The `focus` event that caused this function to run.
	   *
	   * @listens focus
	   */
	
	
	  Slider.prototype.handleFocus = function handleFocus() {
	    this.on(this.bar.el_.ownerDocument, 'keydown', this.handleKeyPress);
	  };
	
	  /**
	   * Handle a `keydown` event on the `Slider`. Watches for left, rigth, up, and down
	   * arrow keys. This function will only be called when the slider has focus. See
	   * {@link Slider#handleFocus} and {@link Slider#handleBlur}.
	   *
	   * @param {EventTarget~Event} event
	   *        the `keydown` event that caused this function to run.
	   *
	   * @listens keydown
	   */
	
	
	  Slider.prototype.handleKeyPress = function handleKeyPress(event) {
	    // Left and Down Arrows
	    if (event.which === 37 || event.which === 40) {
	      event.preventDefault();
	      this.stepBack();
	
	      // Up and Right Arrows
	    } else if (event.which === 38 || event.which === 39) {
	      event.preventDefault();
	      this.stepForward();
	    }
	  };
	
	  /**
	   * Handle a `blur` event on this `Slider`.
	   *
	   * @param {EventTarget~Event} event
	   *        The `blur` event that caused this function to run.
	   *
	   * @listens blur
	   */
	
	  Slider.prototype.handleBlur = function handleBlur() {
	    this.off(this.bar.el_.ownerDocument, 'keydown', this.handleKeyPress);
	  };
	
	  /**
	   * Listener for click events on slider, used to prevent clicks
	   *   from bubbling up to parent elements like button menus.
	   *
	   * @param {Object} event
	   *        Event that caused this object to run
	   */
	
	
	  Slider.prototype.handleClick = function handleClick(event) {
	    event.stopImmediatePropagation();
	    event.preventDefault();
	  };
	
	  /**
	   * Get/set if slider is horizontal for vertical
	   *
	   * @param {boolean} [bool]
	   *        - true if slider is vertical,
	   *        - false is horizontal
	   *
	   * @return {boolean}
	   *         - true if slider is vertical, and getting
	   *         - false if the slider is horizontal, and getting
	   */
	
	
	  Slider.prototype.vertical = function vertical(bool) {
	    if (bool === undefined) {
	      return this.vertical_ || false;
	    }
	
	    this.vertical_ = !!bool;
	
	    if (this.vertical_) {
	      this.addClass('vjs-slider-vertical');
	    } else {
	      this.addClass('vjs-slider-horizontal');
	    }
	  };
	
	  return Slider;
	}(Component);
	
	Component.registerComponent('Slider', Slider);
	
	/**
	 * @file load-progress-bar.js
	 */
	
	/**
	 * Shows loading progress
	 *
	 * @extends Component
	 */
	
	var LoadProgressBar = function (_Component) {
	  inherits(LoadProgressBar, _Component);
	
	  /**
	   * Creates an instance of this class.
	   *
	   * @param {Player} player
	   *        The `Player` that this class should be attached to.
	   *
	   * @param {Object} [options]
	   *        The key/value store of player options.
	   */
	  function LoadProgressBar(player, options) {
	    classCallCheck(this, LoadProgressBar);
	
	    var _this = possibleConstructorReturn(this, _Component.call(this, player, options));
	
	    _this.partEls_ = [];
	    _this.on(player, 'progress', _this.update);
	    return _this;
	  }
	
	  /**
	   * Create the `Component`'s DOM element
	   *
	   * @return {Element}
	   *         The element that was created.
	   */
	
	
	  LoadProgressBar.prototype.createEl = function createEl$$1() {
	    return _Component.prototype.createEl.call(this, 'div', {
	      className: 'vjs-load-progress',
	      innerHTML: '<span class="vjs-control-text"><span>' + this.localize('Loaded') + '</span>: 0%</span>'
	    });
	  };
	
	  LoadProgressBar.prototype.dispose = function dispose() {
	    this.partEls_ = null;
	
	    _Component.prototype.dispose.call(this);
	  };
	
	  /**
	   * Update progress bar
	   *
	   * @param {EventTarget~Event} [event]
	   *        The `progress` event that caused this function to run.
	   *
	   * @listens Player#progress
	   */
	
	
	  LoadProgressBar.prototype.update = function update(event) {
	    var buffered = this.player_.buffered();
	    var duration = this.player_.duration();
	    var bufferedEnd = this.player_.bufferedEnd();
	    var children = this.partEls_;
	
	    // get the percent width of a time compared to the total end
	    var percentify = function percentify(time, end) {
	      // no NaN
	      var percent = time / end || 0;
	
	      return (percent >= 1 ? 1 : percent) * 100 + '%';
	    };
	
	    // update the width of the progress bar
	    this.el_.style.width = percentify(bufferedEnd, duration);
	
	    // add child elements to represent the individual buffered time ranges
	    for (var i = 0; i < buffered.length; i++) {
	      var start = buffered.start(i);
	      var end = buffered.end(i);
	      var part = children[i];
	
	      if (!part) {
	        part = this.el_.appendChild(createEl());
	        children[i] = part;
	      }
	
	      // set the percent based on the width of the progress bar (bufferedEnd)
	      part.style.left = percentify(start, bufferedEnd);
	      part.style.width = percentify(end - start, bufferedEnd);
	    }
	
	    // remove unused buffered range elements
	    for (var _i = children.length; _i > buffered.length; _i--) {
	      this.el_.removeChild(children[_i - 1]);
	    }
	    children.length = buffered.length;
	  };
	
	  return LoadProgressBar;
	}(Component);
	
	Component.registerComponent('LoadProgressBar', LoadProgressBar);
	
	/**
	 * @file time-tooltip.js
	 */
	
	/**
	 * Time tooltips display a time above the progress bar.
	 *
	 * @extends Component
	 */
	
	var TimeTooltip = function (_Component) {
	  inherits(TimeTooltip, _Component);
	
	  function TimeTooltip() {
	    classCallCheck(this, TimeTooltip);
	    return possibleConstructorReturn(this, _Component.apply(this, arguments));
	  }
	
	  /**
	   * Create the time tooltip DOM element
	   *
	   * @return {Element}
	   *         The element that was created.
	   */
	  TimeTooltip.prototype.createEl = function createEl$$1() {
	    return _Component.prototype.createEl.call(this, 'div', {
	      className: 'vjs-time-tooltip'
	    });
	  };
	
	  /**
	   * Updates the position of the time tooltip relative to the `SeekBar`.
	   *
	   * @param {Object} seekBarRect
	   *        The `ClientRect` for the {@link SeekBar} element.
	   *
	   * @param {number} seekBarPoint
	   *        A number from 0 to 1, representing a horizontal reference point
	   *        from the left edge of the {@link SeekBar}
	   */
	
	
	  TimeTooltip.prototype.update = function update(seekBarRect, seekBarPoint, content) {
	    var tooltipRect = getBoundingClientRect(this.el_);
	    var playerRect = getBoundingClientRect(this.player_.el());
	    var seekBarPointPx = seekBarRect.width * seekBarPoint;
	
	    // do nothing if either rect isn't available
	    // for example, if the player isn't in the DOM for testing
	    if (!playerRect || !tooltipRect) {
	      return;
	    }
	
	    // This is the space left of the `seekBarPoint` available within the bounds
	    // of the player. We calculate any gap between the left edge of the player
	    // and the left edge of the `SeekBar` and add the number of pixels in the
	    // `SeekBar` before hitting the `seekBarPoint`
	    var spaceLeftOfPoint = seekBarRect.left - playerRect.left + seekBarPointPx;
	
	    // This is the space right of the `seekBarPoint` available within the bounds
	    // of the player. We calculate the number of pixels from the `seekBarPoint`
	    // to the right edge of the `SeekBar` and add to that any gap between the
	    // right edge of the `SeekBar` and the player.
	    var spaceRightOfPoint = seekBarRect.width - seekBarPointPx + (playerRect.right - seekBarRect.right);
	
	    // This is the number of pixels by which the tooltip will need to be pulled
	    // further to the right to center it over the `seekBarPoint`.
	    var pullTooltipBy = tooltipRect.width / 2;
	
	    // Adjust the `pullTooltipBy` distance to the left or right depending on
	    // the results of the space calculations above.
	    if (spaceLeftOfPoint < pullTooltipBy) {
	      pullTooltipBy += pullTooltipBy - spaceLeftOfPoint;
	    } else if (spaceRightOfPoint < pullTooltipBy) {
	      pullTooltipBy = spaceRightOfPoint;
	    }
	
	    // Due to the imprecision of decimal/ratio based calculations and varying
	    // rounding behaviors, there are cases where the spacing adjustment is off
	    // by a pixel or two. This adds insurance to these calculations.
	    if (pullTooltipBy < 0) {
	      pullTooltipBy = 0;
	    } else if (pullTooltipBy > tooltipRect.width) {
	      pullTooltipBy = tooltipRect.width;
	    }
	
	    this.el_.style.right = '-' + pullTooltipBy + 'px';
	    textContent(this.el_, content);
	  };
	
	  return TimeTooltip;
	}(Component);
	
	Component.registerComponent('TimeTooltip', TimeTooltip);
	
	/**
	 * @file play-progress-bar.js
	 */
	
	/**
	 * Used by {@link SeekBar} to display media playback progress as part of the
	 * {@link ProgressControl}.
	 *
	 * @extends Component
	 */
	
	var PlayProgressBar = function (_Component) {
	  inherits(PlayProgressBar, _Component);
	
	  function PlayProgressBar() {
	    classCallCheck(this, PlayProgressBar);
	    return possibleConstructorReturn(this, _Component.apply(this, arguments));
	  }
	
	  /**
	   * Create the the DOM element for this class.
	   *
	   * @return {Element}
	   *         The element that was created.
	   */
	  PlayProgressBar.prototype.createEl = function createEl() {
	    return _Component.prototype.createEl.call(this, 'div', {
	      className: 'vjs-play-progress vjs-slider-bar',
	      innerHTML: '<span class="vjs-control-text"><span>' + this.localize('Progress') + '</span>: 0%</span>'
	    });
	  };
	
	  /**
	   * Enqueues updates to its own DOM as well as the DOM of its
	   * {@link TimeTooltip} child.
	   *
	   * @param {Object} seekBarRect
	   *        The `ClientRect` for the {@link SeekBar} element.
	   *
	   * @param {number} seekBarPoint
	   *        A number from 0 to 1, representing a horizontal reference point
	   *        from the left edge of the {@link SeekBar}
	   */
	
	
	  PlayProgressBar.prototype.update = function update(seekBarRect, seekBarPoint) {
	    var _this2 = this;
	
	    // If there is an existing rAF ID, cancel it so we don't over-queue.
	    if (this.rafId_) {
	      this.cancelAnimationFrame(this.rafId_);
	    }
	
	    this.rafId_ = this.requestAnimationFrame(function () {
	      var time = _this2.player_.scrubbing() ? _this2.player_.getCache().currentTime : _this2.player_.currentTime();
	
	      var content = formatTime(time, _this2.player_.duration());
	      var timeTooltip = _this2.getChild('timeTooltip');
	
	      if (timeTooltip) {
	        timeTooltip.update(seekBarRect, seekBarPoint, content);
	      }
	    });
	  };
	
	  return PlayProgressBar;
	}(Component);
	
	/**
	 * Default options for {@link PlayProgressBar}.
	 *
	 * @type {Object}
	 * @private
	 */
	
	
	PlayProgressBar.prototype.options_ = {
	  children: []
	};
	
	// Time tooltips should not be added to a player on mobile devices
	if (!IS_IOS && !IS_ANDROID) {
	  PlayProgressBar.prototype.options_.children.push('timeTooltip');
	}
	
	Component.registerComponent('PlayProgressBar', PlayProgressBar);
	
	/**
	 * @file mouse-time-display.js
	 */
	
	/**
	 * The {@link MouseTimeDisplay} component tracks mouse movement over the
	 * {@link ProgressControl}. It displays an indicator and a {@link TimeTooltip}
	 * indicating the time which is represented by a given point in the
	 * {@link ProgressControl}.
	 *
	 * @extends Component
	 */
	
	var MouseTimeDisplay = function (_Component) {
	  inherits(MouseTimeDisplay, _Component);
	
	  /**
	   * Creates an instance of this class.
	   *
	   * @param {Player} player
	   *        The {@link Player} that this class should be attached to.
	   *
	   * @param {Object} [options]
	   *        The key/value store of player options.
	   */
	  function MouseTimeDisplay(player, options) {
	    classCallCheck(this, MouseTimeDisplay);
	
	    var _this = possibleConstructorReturn(this, _Component.call(this, player, options));
	
	    _this.update = throttle(bind(_this, _this.update), 25);
	    return _this;
	  }
	
	  /**
	   * Create the DOM element for this class.
	   *
	   * @return {Element}
	   *         The element that was created.
	   */
	
	
	  MouseTimeDisplay.prototype.createEl = function createEl() {
	    return _Component.prototype.createEl.call(this, 'div', {
	      className: 'vjs-mouse-display'
	    });
	  };
	
	  /**
	   * Enqueues updates to its own DOM as well as the DOM of its
	   * {@link TimeTooltip} child.
	   *
	   * @param {Object} seekBarRect
	   *        The `ClientRect` for the {@link SeekBar} element.
	   *
	   * @param {number} seekBarPoint
	   *        A number from 0 to 1, representing a horizontal reference point
	   *        from the left edge of the {@link SeekBar}
	   */
	
	
	  MouseTimeDisplay.prototype.update = function update(seekBarRect, seekBarPoint) {
	    var _this2 = this;
	
	    // If there is an existing rAF ID, cancel it so we don't over-queue.
	    if (this.rafId_) {
	      this.cancelAnimationFrame(this.rafId_);
	    }
	
	    this.rafId_ = this.requestAnimationFrame(function () {
	      var duration = _this2.player_.duration();
	      var content = formatTime(seekBarPoint * duration, duration);
	
	      _this2.el_.style.left = seekBarRect.width * seekBarPoint + 'px';
	      _this2.getChild('timeTooltip').update(seekBarRect, seekBarPoint, content);
	    });
	  };
	
	  return MouseTimeDisplay;
	}(Component);
	
	/**
	 * Default options for `MouseTimeDisplay`
	 *
	 * @type {Object}
	 * @private
	 */
	
	
	MouseTimeDisplay.prototype.options_ = {
	  children: ['timeTooltip']
	};
	
	Component.registerComponent('MouseTimeDisplay', MouseTimeDisplay);
	
	/**
	 * @file seek-bar.js
	 */
	
	// The number of seconds the `step*` functions move the timeline.
	var STEP_SECONDS = 5;
	
	// The interval at which the bar should update as it progresses.
	var UPDATE_REFRESH_INTERVAL = 30;
	
	/**
	 * Seek bar and container for the progress bars. Uses {@link PlayProgressBar}
	 * as its `bar`.
	 *
	 * @extends Slider
	 */
	
	var SeekBar = function (_Slider) {
	  inherits(SeekBar, _Slider);
	
	  /**
	   * Creates an instance of this class.
	   *
	   * @param {Player} player
	   *        The `Player` that this class should be attached to.
	   *
	   * @param {Object} [options]
	   *        The key/value store of player options.
	   */
	  function SeekBar(player, options) {
	    classCallCheck(this, SeekBar);
	
	    var _this = possibleConstructorReturn(this, _Slider.call(this, player, options));
	
	    _this.setEventHandlers_();
	    return _this;
	  }
	
	  /**
	   * Sets the event handlers
	   *
	   * @private
	   */
	
	
	  SeekBar.prototype.setEventHandlers_ = function setEventHandlers_() {
	    var _this2 = this;
	
	    this.update = throttle(bind(this, this.update), UPDATE_REFRESH_INTERVAL);
	
	    this.on(this.player_, 'timeupdate', this.update);
	    this.on(this.player_, 'ended', this.handleEnded);
	
	    // when playing, let's ensure we smoothly update the play progress bar
	    // via an interval
	    this.updateInterval = null;
	
	    this.on(this.player_, ['playing'], function () {
	      _this2.clearInterval(_this2.updateInterval);
	
	      _this2.updateInterval = _this2.setInterval(function () {
	        _this2.requestAnimationFrame(function () {
	          _this2.update();
	        });
	      }, UPDATE_REFRESH_INTERVAL);
	    });
	
	    this.on(this.player_, ['ended', 'pause', 'waiting'], function () {
	      _this2.clearInterval(_this2.updateInterval);
	    });
	
	    this.on(this.player_, ['timeupdate', 'ended'], this.update);
	  };
	
	  /**
	   * Create the `Component`'s DOM element
	   *
	   * @return {Element}
	   *         The element that was created.
	   */
	
	
	  SeekBar.prototype.createEl = function createEl$$1() {
	    return _Slider.prototype.createEl.call(this, 'div', {
	      className: 'vjs-progress-holder'
	    }, {
	      'aria-label': this.localize('Progress Bar')
	    });
	  };
	
	  /**
	   * This function updates the play progress bar and accessibility
	   * attributes to whatever is passed in.
	   *
	   * @param {number} currentTime
	   *        The currentTime value that should be used for accessibility
	   *
	   * @param {number} percent
	   *        The percentage as a decimal that the bar should be filled from 0-1.
	   *
	   * @private
	   */
	
	
	  SeekBar.prototype.update_ = function update_(currentTime, percent) {
	    var duration = this.player_.duration();
	
	    // machine readable value of progress bar (percentage complete)
	    this.el_.setAttribute('aria-valuenow', (percent * 100).toFixed(2));
	
	    // human readable value of progress bar (time complete)
	    this.el_.setAttribute('aria-valuetext', this.localize('progress bar timing: currentTime={1} duration={2}', [formatTime(currentTime, duration), formatTime(duration, duration)], '{1} of {2}'));
	
	    // Update the `PlayProgressBar`.
	    this.bar.update(getBoundingClientRect(this.el_), percent);
	  };
	
	  /**
	   * Update the seek bar's UI.
	   *
	   * @param {EventTarget~Event} [event]
	   *        The `timeupdate` or `ended` event that caused this to run.
	   *
	   * @listens Player#timeupdate
	   *
	   * @returns {number}
	   *          The current percent at a number from 0-1
	   */
	
	
	  SeekBar.prototype.update = function update(event) {
	    var percent = _Slider.prototype.update.call(this);
	
	    this.update_(this.getCurrentTime_(), percent);
	    return percent;
	  };
	
	  /**
	   * Get the value of current time but allows for smooth scrubbing,
	   * when player can't keep up.
	   *
	   * @return {number}
	   *         The current time value to display
	   *
	   * @private
	   */
	
	
	  SeekBar.prototype.getCurrentTime_ = function getCurrentTime_() {
	    return this.player_.scrubbing() ? this.player_.getCache().currentTime : this.player_.currentTime();
	  };
	
	  /**
	   * We want the seek bar to be full on ended
	   * no matter what the actual internal values are. so we force it.
	   *
	   * @param {EventTarget~Event} [event]
	   *        The `timeupdate` or `ended` event that caused this to run.
	   *
	   * @listens Player#ended
	   */
	
	
	  SeekBar.prototype.handleEnded = function handleEnded(event) {
	    this.update_(this.player_.duration(), 1);
	  };
	
	  /**
	   * Get the percentage of media played so far.
	   *
	   * @return {number}
	   *         The percentage of media played so far (0 to 1).
	   */
	
	
	  SeekBar.prototype.getPercent = function getPercent() {
	    var percent = this.getCurrentTime_() / this.player_.duration();
	
	    return percent >= 1 ? 1 : percent || 0;
	  };
	
	  /**
	   * Handle mouse down on seek bar
	   *
	   * @param {EventTarget~Event} event
	   *        The `mousedown` event that caused this to run.
	   *
	   * @listens mousedown
	   */
	
	
	  SeekBar.prototype.handleMouseDown = function handleMouseDown(event) {
	    if (!isSingleLeftClick(event)) {
	      return;
	    }
	
	    // Stop event propagation to prevent double fire in progress-control.js
	    event.stopPropagation();
	    this.player_.scrubbing(true);
	
	    this.videoWasPlaying = !this.player_.paused();
	    this.player_.pause();
	
	    _Slider.prototype.handleMouseDown.call(this, event);
	  };
	
	  /**
	   * Handle mouse move on seek bar
	   *
	   * @param {EventTarget~Event} event
	   *        The `mousemove` event that caused this to run.
	   *
	   * @listens mousemove
	   */
	
	
	  SeekBar.prototype.handleMouseMove = function handleMouseMove(event) {
	    if (!isSingleLeftClick(event)) {
	      return;
	    }
	
	    var newTime = this.calculateDistance(event) * this.player_.duration();
	
	    // Don't let video end while scrubbing.
	    if (newTime === this.player_.duration()) {
	      newTime = newTime - 0.1;
	    }
	
	    // Set new time (tell player to seek to new time)
	    this.player_.currentTime(newTime);
	  };
	
	  SeekBar.prototype.enable = function enable() {
	    _Slider.prototype.enable.call(this);
	    var mouseTimeDisplay = this.getChild('mouseTimeDisplay');
	
	    if (!mouseTimeDisplay) {
	      return;
	    }
	
	    mouseTimeDisplay.show();
	  };
	
	  SeekBar.prototype.disable = function disable() {
	    _Slider.prototype.disable.call(this);
	    var mouseTimeDisplay = this.getChild('mouseTimeDisplay');
	
	    if (!mouseTimeDisplay) {
	      return;
	    }
	
	    mouseTimeDisplay.hide();
	  };
	
	  /**
	   * Handle mouse up on seek bar
	   *
	   * @param {EventTarget~Event} event
	   *        The `mouseup` event that caused this to run.
	   *
	   * @listens mouseup
	   */
	
	
	  SeekBar.prototype.handleMouseUp = function handleMouseUp(event) {
	    _Slider.prototype.handleMouseUp.call(this, event);
	
	    // Stop event propagation to prevent double fire in progress-control.js
	    if (event) {
	      event.stopPropagation();
	    }
	    this.player_.scrubbing(false);
	
	    /**
	     * Trigger timeupdate because we're done seeking and the time has changed.
	     * This is particularly useful for if the player is paused to time the time displays.
	     *
	     * @event Tech#timeupdate
	     * @type {EventTarget~Event}
	     */
	    this.player_.trigger({ type: 'timeupdate', target: this, manuallyTriggered: true });
	    if (this.videoWasPlaying) {
	      silencePromise(this.player_.play());
	    }
	  };
	
	  /**
	   * Move more quickly fast forward for keyboard-only users
	   */
	
	
	  SeekBar.prototype.stepForward = function stepForward() {
	    this.player_.currentTime(this.player_.currentTime() + STEP_SECONDS);
	  };
	
	  /**
	   * Move more quickly rewind for keyboard-only users
	   */
	
	
	  SeekBar.prototype.stepBack = function stepBack() {
	    this.player_.currentTime(this.player_.currentTime() - STEP_SECONDS);
	  };
	
	  /**
	   * Toggles the playback state of the player
	   * This gets called when enter or space is used on the seekbar
	   *
	   * @param {EventTarget~Event} event
	   *        The `keydown` event that caused this function to be called
	   *
	   */
	
	
	  SeekBar.prototype.handleAction = function handleAction(event) {
	    if (this.player_.paused()) {
	      this.player_.play();
	    } else {
	      this.player_.pause();
	    }
	  };
	
	  /**
	   * Called when this SeekBar has focus and a key gets pressed down. By
	   * default it will call `this.handleAction` when the key is space or enter.
	   *
	   * @param {EventTarget~Event} event
	   *        The `keydown` event that caused this function to be called.
	   *
	   * @listens keydown
	   */
	
	
	  SeekBar.prototype.handleKeyPress = function handleKeyPress(event) {
	
	    // Support Space (32) or Enter (13) key operation to fire a click event
	    if (event.which === 32 || event.which === 13) {
	      event.preventDefault();
	      this.handleAction(event);
	    } else if (_Slider.prototype.handleKeyPress) {
	
	      // Pass keypress handling up for unsupported keys
	      _Slider.prototype.handleKeyPress.call(this, event);
	    }
	  };
	
	  return SeekBar;
	}(Slider);
	
	/**
	 * Default options for the `SeekBar`
	 *
	 * @type {Object}
	 * @private
	 */
	
	
	SeekBar.prototype.options_ = {
	  children: ['loadProgressBar', 'playProgressBar'],
	  barName: 'playProgressBar'
	};
	
	// MouseTimeDisplay tooltips should not be added to a player on mobile devices
	if (!IS_IOS && !IS_ANDROID) {
	  SeekBar.prototype.options_.children.splice(1, 0, 'mouseTimeDisplay');
	}
	
	/**
	 * Call the update event for this Slider when this event happens on the player.
	 *
	 * @type {string}
	 */
	SeekBar.prototype.playerEvent = 'timeupdate';
	
	Component.registerComponent('SeekBar', SeekBar);
	
	/**
	 * @file progress-control.js
	 */
	
	/**
	 * The Progress Control component contains the seek bar, load progress,
	 * and play progress.
	 *
	 * @extends Component
	 */
	
	var ProgressControl = function (_Component) {
	  inherits(ProgressControl, _Component);
	
	  /**
	   * Creates an instance of this class.
	   *
	   * @param {Player} player
	   *        The `Player` that this class should be attached to.
	   *
	   * @param {Object} [options]
	   *        The key/value store of player options.
	   */
	  function ProgressControl(player, options) {
	    classCallCheck(this, ProgressControl);
	
	    var _this = possibleConstructorReturn(this, _Component.call(this, player, options));
	
	    _this.handleMouseMove = throttle(bind(_this, _this.handleMouseMove), 25);
	    _this.throttledHandleMouseSeek = throttle(bind(_this, _this.handleMouseSeek), 25);
	
	    _this.enable();
	    return _this;
	  }
	
	  /**
	   * Create the `Component`'s DOM element
	   *
	   * @return {Element}
	   *         The element that was created.
	   */
	
	
	  ProgressControl.prototype.createEl = function createEl$$1() {
	    return _Component.prototype.createEl.call(this, 'div', {
	      className: 'vjs-progress-control vjs-control'
	    });
	  };
	
	  /**
	   * When the mouse moves over the `ProgressControl`, the pointer position
	   * gets passed down to the `MouseTimeDisplay` component.
	   *
	   * @param {EventTarget~Event} event
	   *        The `mousemove` event that caused this function to run.
	   *
	   * @listen mousemove
	   */
	
	
	  ProgressControl.prototype.handleMouseMove = function handleMouseMove(event) {
	    var seekBar = this.getChild('seekBar');
	
	    if (seekBar) {
	      var mouseTimeDisplay = seekBar.getChild('mouseTimeDisplay');
	      var seekBarEl = seekBar.el();
	      var seekBarRect = getBoundingClientRect(seekBarEl);
	      var seekBarPoint = getPointerPosition(seekBarEl, event).x;
	
	      // The default skin has a gap on either side of the `SeekBar`. This means
	      // that it's possible to trigger this behavior outside the boundaries of
	      // the `SeekBar`. This ensures we stay within it at all times.
	      if (seekBarPoint > 1) {
	        seekBarPoint = 1;
	      } else if (seekBarPoint < 0) {
	        seekBarPoint = 0;
	      }
	
	      if (mouseTimeDisplay) {
	        mouseTimeDisplay.update(seekBarRect, seekBarPoint);
	      }
	    }
	  };
	
	  /**
	   * A throttled version of the {@link ProgressControl#handleMouseSeek} listener.
	   *
	   * @method ProgressControl#throttledHandleMouseSeek
	   * @param {EventTarget~Event} event
	   *        The `mousemove` event that caused this function to run.
	   *
	   * @listen mousemove
	   * @listen touchmove
	   */
	
	  /**
	   * Handle `mousemove` or `touchmove` events on the `ProgressControl`.
	   *
	   * @param {EventTarget~Event} event
	   *        `mousedown` or `touchstart` event that triggered this function
	   *
	   * @listens mousemove
	   * @listens touchmove
	   */
	
	
	  ProgressControl.prototype.handleMouseSeek = function handleMouseSeek(event) {
	    var seekBar = this.getChild('seekBar');
	
	    if (seekBar) {
	      seekBar.handleMouseMove(event);
	    }
	  };
	
	  /**
	   * Are controls are currently enabled for this progress control.
	   *
	   * @return {boolean}
	   *         true if controls are enabled, false otherwise
	   */
	
	
	  ProgressControl.prototype.enabled = function enabled() {
	    return this.enabled_;
	  };
	
	  /**
	   * Disable all controls on the progress control and its children
	   */
	
	
	  ProgressControl.prototype.disable = function disable() {
	    this.children().forEach(function (child) {
	      return child.disable && child.disable();
	    });
	
	    if (!this.enabled()) {
	      return;
	    }
	
	    this.off(['mousedown', 'touchstart'], this.handleMouseDown);
	    this.off(this.el_, 'mousemove', this.handleMouseMove);
	    this.handleMouseUp();
	
	    this.addClass('disabled');
	
	    this.enabled_ = false;
	  };
	
	  /**
	   * Enable all controls on the progress control and its children
	   */
	
	
	  ProgressControl.prototype.enable = function enable() {
	    this.children().forEach(function (child) {
	      return child.enable && child.enable();
	    });
	
	    if (this.enabled()) {
	      return;
	    }
	
	    this.on(['mousedown', 'touchstart'], this.handleMouseDown);
	    this.on(this.el_, 'mousemove', this.handleMouseMove);
	    this.removeClass('disabled');
	
	    this.enabled_ = true;
	  };
	
	  /**
	   * Handle `mousedown` or `touchstart` events on the `ProgressControl`.
	   *
	   * @param {EventTarget~Event} event
	   *        `mousedown` or `touchstart` event that triggered this function
	   *
	   * @listens mousedown
	   * @listens touchstart
	   */
	
	
	  ProgressControl.prototype.handleMouseDown = function handleMouseDown(event) {
	    var doc = this.el_.ownerDocument;
	    var seekBar = this.getChild('seekBar');
	
	    if (seekBar) {
	      seekBar.handleMouseDown(event);
	    }
	
	    this.on(doc, 'mousemove', this.throttledHandleMouseSeek);
	    this.on(doc, 'touchmove', this.throttledHandleMouseSeek);
	    this.on(doc, 'mouseup', this.handleMouseUp);
	    this.on(doc, 'touchend', this.handleMouseUp);
	  };
	
	  /**
	   * Handle `mouseup` or `touchend` events on the `ProgressControl`.
	   *
	   * @param {EventTarget~Event} event
	   *        `mouseup` or `touchend` event that triggered this function.
	   *
	   * @listens touchend
	   * @listens mouseup
	   */
	
	
	  ProgressControl.prototype.handleMouseUp = function handleMouseUp(event) {
	    var doc = this.el_.ownerDocument;
	    var seekBar = this.getChild('seekBar');
	
	    if (seekBar) {
	      seekBar.handleMouseUp(event);
	    }
	
	    this.off(doc, 'mousemove', this.throttledHandleMouseSeek);
	    this.off(doc, 'touchmove', this.throttledHandleMouseSeek);
	    this.off(doc, 'mouseup', this.handleMouseUp);
	    this.off(doc, 'touchend', this.handleMouseUp);
	  };
	
	  return ProgressControl;
	}(Component);
	
	/**
	 * Default options for `ProgressControl`
	 *
	 * @type {Object}
	 * @private
	 */
	
	
	ProgressControl.prototype.options_ = {
	  children: ['seekBar']
	};
	
	Component.registerComponent('ProgressControl', ProgressControl);
	
	/**
	 * @file fullscreen-toggle.js
	 */
	
	/**
	 * Toggle fullscreen video
	 *
	 * @extends Button
	 */
	
	var FullscreenToggle = function (_Button) {
	  inherits(FullscreenToggle, _Button);
	
	  /**
	   * Creates an instance of this class.
	   *
	   * @param {Player} player
	   *        The `Player` that this class should be attached to.
	   *
	   * @param {Object} [options]
	   *        The key/value store of player options.
	   */
	  function FullscreenToggle(player, options) {
	    classCallCheck(this, FullscreenToggle);
	
	    var _this = possibleConstructorReturn(this, _Button.call(this, player, options));
	
	    _this.on(player, 'fullscreenchange', _this.handleFullscreenChange);
	
	    if (document[FullscreenApi.fullscreenEnabled] === false) {
	      _this.disable();
	    }
	    return _this;
	  }
	
	  /**
	   * Builds the default DOM `className`.
	   *
	   * @return {string}
	   *         The DOM `className` for this object.
	   */
	
	
	  FullscreenToggle.prototype.buildCSSClass = function buildCSSClass() {
	    return 'vjs-fullscreen-control ' + _Button.prototype.buildCSSClass.call(this);
	  };
	
	  /**
	   * Handles fullscreenchange on the player and change control text accordingly.
	   *
	   * @param {EventTarget~Event} [event]
	   *        The {@link Player#fullscreenchange} event that caused this function to be
	   *        called.
	   *
	   * @listens Player#fullscreenchange
	   */
	
	
	  FullscreenToggle.prototype.handleFullscreenChange = function handleFullscreenChange(event) {
	    if (this.player_.isFullscreen()) {
	      this.controlText('Non-Fullscreen');
	    } else {
	      this.controlText('Fullscreen');
	    }
	  };
	
	  /**
	   * This gets called when an `FullscreenToggle` is "clicked". See
	   * {@link ClickableComponent} for more detailed information on what a click can be.
	   *
	   * @param {EventTarget~Event} [event]
	   *        The `keydown`, `tap`, or `click` event that caused this function to be
	   *        called.
	   *
	   * @listens tap
	   * @listens click
	   */
	
	
	  FullscreenToggle.prototype.handleClick = function handleClick(event) {
	    if (!this.player_.isFullscreen()) {
	      this.player_.requestFullscreen();
	    } else {
	      this.player_.exitFullscreen();
	    }
	  };
	
	  return FullscreenToggle;
	}(Button);
	
	/**
	 * The text that should display over the `FullscreenToggle`s controls. Added for localization.
	 *
	 * @type {string}
	 * @private
	 */
	
	
	FullscreenToggle.prototype.controlText_ = 'Fullscreen';
	
	Component.registerComponent('FullscreenToggle', FullscreenToggle);
	
	/**
	 * Check if volume control is supported and if it isn't hide the
	 * `Component` that was passed  using the `vjs-hidden` class.
	 *
	 * @param {Component} self
	 *        The component that should be hidden if volume is unsupported
	 *
	 * @param {Player} player
	 *        A reference to the player
	 *
	 * @private
	 */
	var checkVolumeSupport = function checkVolumeSupport(self, player) {
	  // hide volume controls when they're not supported by the current tech
	  if (player.tech_ && !player.tech_.featuresVolumeControl) {
	    self.addClass('vjs-hidden');
	  }
	
	  self.on(player, 'loadstart', function () {
	    if (!player.tech_.featuresVolumeControl) {
	      self.addClass('vjs-hidden');
	    } else {
	      self.removeClass('vjs-hidden');
	    }
	  });
	};
	
	/**
	 * @file volume-level.js
	 */
	
	/**
	 * Shows volume level
	 *
	 * @extends Component
	 */
	
	var VolumeLevel = function (_Component) {
	  inherits(VolumeLevel, _Component);
	
	  function VolumeLevel() {
	    classCallCheck(this, VolumeLevel);
	    return possibleConstructorReturn(this, _Component.apply(this, arguments));
	  }
	
	  /**
	   * Create the `Component`'s DOM element
	   *
	   * @return {Element}
	   *         The element that was created.
	   */
	  VolumeLevel.prototype.createEl = function createEl() {
	    return _Component.prototype.createEl.call(this, 'div', {
	      className: 'vjs-volume-level',
	      innerHTML: '<span class="vjs-control-text"></span>'
	    });
	  };
	
	  return VolumeLevel;
	}(Component);
	
	Component.registerComponent('VolumeLevel', VolumeLevel);
	
	/**
	 * @file volume-bar.js
	 */
	
	/**
	 * The bar that contains the volume level and can be clicked on to adjust the level
	 *
	 * @extends Slider
	 */
	
	var VolumeBar = function (_Slider) {
	  inherits(VolumeBar, _Slider);
	
	  /**
	   * Creates an instance of this class.
	   *
	   * @param {Player} player
	   *        The `Player` that this class should be attached to.
	   *
	   * @param {Object} [options]
	   *        The key/value store of player options.
	   */
	  function VolumeBar(player, options) {
	    classCallCheck(this, VolumeBar);
	
	    var _this = possibleConstructorReturn(this, _Slider.call(this, player, options));
	
	    _this.on('slideractive', _this.updateLastVolume_);
	    _this.on(player, 'volumechange', _this.updateARIAAttributes);
	    player.ready(function () {
	      return _this.updateARIAAttributes();
	    });
	    return _this;
	  }
	
	  /**
	   * Create the `Component`'s DOM element
	   *
	   * @return {Element}
	   *         The element that was created.
	   */
	
	
	  VolumeBar.prototype.createEl = function createEl$$1() {
	    return _Slider.prototype.createEl.call(this, 'div', {
	      className: 'vjs-volume-bar vjs-slider-bar'
	    }, {
	      'aria-label': this.localize('Volume Level'),
	      'aria-live': 'polite'
	    });
	  };
	
	  /**
	   * Handle mouse down on volume bar
	   *
	   * @param {EventTarget~Event} event
	   *        The `mousedown` event that caused this to run.
	   *
	   * @listens mousedown
	   */
	
	
	  VolumeBar.prototype.handleMouseDown = function handleMouseDown(event) {
	    if (!isSingleLeftClick(event)) {
	      return;
	    }
	
	    _Slider.prototype.handleMouseDown.call(this, event);
	  };
	
	  /**
	   * Handle movement events on the {@link VolumeMenuButton}.
	   *
	   * @param {EventTarget~Event} event
	   *        The event that caused this function to run.
	   *
	   * @listens mousemove
	   */
	
	
	  VolumeBar.prototype.handleMouseMove = function handleMouseMove(event) {
	    if (!isSingleLeftClick(event)) {
	      return;
	    }
	
	    this.checkMuted();
	    this.player_.volume(this.calculateDistance(event));
	  };
	
	  /**
	   * If the player is muted unmute it.
	   */
	
	
	  VolumeBar.prototype.checkMuted = function checkMuted() {
	    if (this.player_.muted()) {
	      this.player_.muted(false);
	    }
	  };
	
	  /**
	   * Get percent of volume level
	   *
	   * @return {number}
	   *         Volume level percent as a decimal number.
	   */
	
	
	  VolumeBar.prototype.getPercent = function getPercent() {
	    if (this.player_.muted()) {
	      return 0;
	    }
	    return this.player_.volume();
	  };
	
	  /**
	   * Increase volume level for keyboard users
	   */
	
	
	  VolumeBar.prototype.stepForward = function stepForward() {
	    this.checkMuted();
	    this.player_.volume(this.player_.volume() + 0.1);
	  };
	
	  /**
	   * Decrease volume level for keyboard users
	   */
	
	
	  VolumeBar.prototype.stepBack = function stepBack() {
	    this.checkMuted();
	    this.player_.volume(this.player_.volume() - 0.1);
	  };
	
	  /**
	   * Update ARIA accessibility attributes
	   *
	   * @param {EventTarget~Event} [event]
	   *        The `volumechange` event that caused this function to run.
	   *
	   * @listens Player#volumechange
	   */
	
	
	  VolumeBar.prototype.updateARIAAttributes = function updateARIAAttributes(event) {
	    var ariaValue = this.player_.muted() ? 0 : this.volumeAsPercentage_();
	
	    this.el_.setAttribute('aria-valuenow', ariaValue);
	    this.el_.setAttribute('aria-valuetext', ariaValue + '%');
	  };
	
	  /**
	   * Returns the current value of the player volume as a percentage
	   *
	   * @private
	   */
	
	
	  VolumeBar.prototype.volumeAsPercentage_ = function volumeAsPercentage_() {
	    return Math.round(this.player_.volume() * 100);
	  };
	
	  /**
	   * When user starts dragging the VolumeBar, store the volume and listen for
	   * the end of the drag. When the drag ends, if the volume was set to zero,
	   * set lastVolume to the stored volume.
	   *
	   * @listens slideractive
	   * @private
	   */
	
	
	  VolumeBar.prototype.updateLastVolume_ = function updateLastVolume_() {
	    var _this2 = this;
	
	    var volumeBeforeDrag = this.player_.volume();
	
	    this.one('sliderinactive', function () {
	      if (_this2.player_.volume() === 0) {
	        _this2.player_.lastVolume_(volumeBeforeDrag);
	      }
	    });
	  };
	
	  return VolumeBar;
	}(Slider);
	
	/**
	 * Default options for the `VolumeBar`
	 *
	 * @type {Object}
	 * @private
	 */
	
	
	VolumeBar.prototype.options_ = {
	  children: ['volumeLevel'],
	  barName: 'volumeLevel'
	};
	
	/**
	 * Call the update event for this Slider when this event happens on the player.
	 *
	 * @type {string}
	 */
	VolumeBar.prototype.playerEvent = 'volumechange';
	
	Component.registerComponent('VolumeBar', VolumeBar);
	
	/**
	 * @file volume-control.js
	 */
	
	/**
	 * The component for controlling the volume level
	 *
	 * @extends Component
	 */
	
	var VolumeControl = function (_Component) {
	  inherits(VolumeControl, _Component);
	
	  /**
	   * Creates an instance of this class.
	   *
	   * @param {Player} player
	   *        The `Player` that this class should be attached to.
	   *
	   * @param {Object} [options={}]
	   *        The key/value store of player options.
	   */
	  function VolumeControl(player) {
	    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	    classCallCheck(this, VolumeControl);
	
	    options.vertical = options.vertical || false;
	
	    // Pass the vertical option down to the VolumeBar if
	    // the VolumeBar is turned on.
	    if (typeof options.volumeBar === 'undefined' || isPlain(options.volumeBar)) {
	      options.volumeBar = options.volumeBar || {};
	      options.volumeBar.vertical = options.vertical;
	    }
	
	    // hide this control if volume support is missing
	    var _this = possibleConstructorReturn(this, _Component.call(this, player, options));
	
	    checkVolumeSupport(_this, player);
	
	    _this.throttledHandleMouseMove = throttle(bind(_this, _this.handleMouseMove), 25);
	
	    _this.on('mousedown', _this.handleMouseDown);
	    _this.on('touchstart', _this.handleMouseDown);
	
	    // while the slider is active (the mouse has been pressed down and
	    // is dragging) or in focus we do not want to hide the VolumeBar
	    _this.on(_this.volumeBar, ['focus', 'slideractive'], function () {
	      _this.volumeBar.addClass('vjs-slider-active');
	      _this.addClass('vjs-slider-active');
	      _this.trigger('slideractive');
	    });
	
	    _this.on(_this.volumeBar, ['blur', 'sliderinactive'], function () {
	      _this.volumeBar.removeClass('vjs-slider-active');
	      _this.removeClass('vjs-slider-active');
	      _this.trigger('sliderinactive');
	    });
	    return _this;
	  }
	
	  /**
	   * Create the `Component`'s DOM element
	   *
	   * @return {Element}
	   *         The element that was created.
	   */
	
	
	  VolumeControl.prototype.createEl = function createEl() {
	    var orientationClass = 'vjs-volume-horizontal';
	
	    if (this.options_.vertical) {
	      orientationClass = 'vjs-volume-vertical';
	    }
	
	    return _Component.prototype.createEl.call(this, 'div', {
	      className: 'vjs-volume-control vjs-control ' + orientationClass
	    });
	  };
	
	  /**
	   * Handle `mousedown` or `touchstart` events on the `VolumeControl`.
	   *
	   * @param {EventTarget~Event} event
	   *        `mousedown` or `touchstart` event that triggered this function
	   *
	   * @listens mousedown
	   * @listens touchstart
	   */
	
	
	  VolumeControl.prototype.handleMouseDown = function handleMouseDown(event) {
	    var doc = this.el_.ownerDocument;
	
	    this.on(doc, 'mousemove', this.throttledHandleMouseMove);
	    this.on(doc, 'touchmove', this.throttledHandleMouseMove);
	    this.on(doc, 'mouseup', this.handleMouseUp);
	    this.on(doc, 'touchend', this.handleMouseUp);
	  };
	
	  /**
	   * Handle `mouseup` or `touchend` events on the `VolumeControl`.
	   *
	   * @param {EventTarget~Event} event
	   *        `mouseup` or `touchend` event that triggered this function.
	   *
	   * @listens touchend
	   * @listens mouseup
	   */
	
	
	  VolumeControl.prototype.handleMouseUp = function handleMouseUp(event) {
	    var doc = this.el_.ownerDocument;
	
	    this.off(doc, 'mousemove', this.throttledHandleMouseMove);
	    this.off(doc, 'touchmove', this.throttledHandleMouseMove);
	    this.off(doc, 'mouseup', this.handleMouseUp);
	    this.off(doc, 'touchend', this.handleMouseUp);
	  };
	
	  /**
	   * Handle `mousedown` or `touchstart` events on the `VolumeControl`.
	   *
	   * @param {EventTarget~Event} event
	   *        `mousedown` or `touchstart` event that triggered this function
	   *
	   * @listens mousedown
	   * @listens touchstart
	   */
	
	
	  VolumeControl.prototype.handleMouseMove = function handleMouseMove(event) {
	    this.volumeBar.handleMouseMove(event);
	  };
	
	  return VolumeControl;
	}(Component);
	
	/**
	 * Default options for the `VolumeControl`
	 *
	 * @type {Object}
	 * @private
	 */
	
	
	VolumeControl.prototype.options_ = {
	  children: ['volumeBar']
	};
	
	Component.registerComponent('VolumeControl', VolumeControl);
	
	/**
	 * Check if muting volume is supported and if it isn't hide the mute toggle
	 * button.
	 *
	 * @param {Component} self
	 *        A reference to the mute toggle button
	 *
	 * @param {Player} player
	 *        A reference to the player
	 *
	 * @private
	 */
	var checkMuteSupport = function checkMuteSupport(self, player) {
	  // hide mute toggle button if it's not supported by the current tech
	  if (player.tech_ && !player.tech_.featuresMuteControl) {
	    self.addClass('vjs-hidden');
	  }
	
	  self.on(player, 'loadstart', function () {
	    if (!player.tech_.featuresMuteControl) {
	      self.addClass('vjs-hidden');
	    } else {
	      self.removeClass('vjs-hidden');
	    }
	  });
	};
	
	/**
	 * @file mute-toggle.js
	 */
	
	/**
	 * A button component for muting the audio.
	 *
	 * @extends Button
	 */
	
	var MuteToggle = function (_Button) {
	  inherits(MuteToggle, _Button);
	
	  /**
	   * Creates an instance of this class.
	   *
	   * @param {Player} player
	   *        The `Player` that this class should be attached to.
	   *
	   * @param {Object} [options]
	   *        The key/value store of player options.
	   */
	  function MuteToggle(player, options) {
	    classCallCheck(this, MuteToggle);
	
	    // hide this control if volume support is missing
	    var _this = possibleConstructorReturn(this, _Button.call(this, player, options));
	
	    checkMuteSupport(_this, player);
	
	    _this.on(player, ['loadstart', 'volumechange'], _this.update);
	    return _this;
	  }
	
	  /**
	   * Builds the default DOM `className`.
	   *
	   * @return {string}
	   *         The DOM `className` for this object.
	   */
	
	
	  MuteToggle.prototype.buildCSSClass = function buildCSSClass() {
	    return 'vjs-mute-control ' + _Button.prototype.buildCSSClass.call(this);
	  };
	
	  /**
	   * This gets called when an `MuteToggle` is "clicked". See
	   * {@link ClickableComponent} for more detailed information on what a click can be.
	   *
	   * @param {EventTarget~Event} [event]
	   *        The `keydown`, `tap`, or `click` event that caused this function to be
	   *        called.
	   *
	   * @listens tap
	   * @listens click
	   */
	
	
	  MuteToggle.prototype.handleClick = function handleClick(event) {
	    var vol = this.player_.volume();
	    var lastVolume = this.player_.lastVolume_();
	
	    if (vol === 0) {
	      var volumeToSet = lastVolume < 0.1 ? 0.1 : lastVolume;
	
	      this.player_.volume(volumeToSet);
	      this.player_.muted(false);
	    } else {
	      this.player_.muted(this.player_.muted() ? false : true);
	    }
	  };
	
	  /**
	   * Update the `MuteToggle` button based on the state of `volume` and `muted`
	   * on the player.
	   *
	   * @param {EventTarget~Event} [event]
	   *        The {@link Player#loadstart} event if this function was called
	   *        through an event.
	   *
	   * @listens Player#loadstart
	   * @listens Player#volumechange
	   */
	
	
	  MuteToggle.prototype.update = function update(event) {
	    this.updateIcon_();
	    this.updateControlText_();
	  };
	
	  /**
	   * Update the appearance of the `MuteToggle` icon.
	   *
	   * Possible states (given `level` variable below):
	   * - 0: crossed out
	   * - 1: zero bars of volume
	   * - 2: one bar of volume
	   * - 3: two bars of volume
	   *
	   * @private
	   */
	
	
	  MuteToggle.prototype.updateIcon_ = function updateIcon_() {
	    var vol = this.player_.volume();
	    var level = 3;
	
	    // in iOS when a player is loaded with muted attribute
	    // and volume is changed with a native mute button
	    // we want to make sure muted state is updated
	    if (IS_IOS) {
	      this.player_.muted(this.player_.tech_.el_.muted);
	    }
	
	    if (vol === 0 || this.player_.muted()) {
	      level = 0;
	    } else if (vol < 0.33) {
	      level = 1;
	    } else if (vol < 0.67) {
	      level = 2;
	    }
	
	    // TODO improve muted icon classes
	    for (var i = 0; i < 4; i++) {
	      removeClass(this.el_, 'vjs-vol-' + i);
	    }
	    addClass(this.el_, 'vjs-vol-' + level);
	  };
	
	  /**
	   * If `muted` has changed on the player, update the control text
	   * (`title` attribute on `vjs-mute-control` element and content of
	   * `vjs-control-text` element).
	   *
	   * @private
	   */
	
	
	  MuteToggle.prototype.updateControlText_ = function updateControlText_() {
	    var soundOff = this.player_.muted() || this.player_.volume() === 0;
	    var text = soundOff ? 'Unmute' : 'Mute';
	
	    if (this.controlText() !== text) {
	      this.controlText(text);
	    }
	  };
	
	  return MuteToggle;
	}(Button);
	
	/**
	 * The text that should display over the `MuteToggle`s controls. Added for localization.
	 *
	 * @type {string}
	 * @private
	 */
	
	
	MuteToggle.prototype.controlText_ = 'Mute';
	
	Component.registerComponent('MuteToggle', MuteToggle);
	
	/**
	 * @file volume-control.js
	 */
	
	/**
	 * A Component to contain the MuteToggle and VolumeControl so that
	 * they can work together.
	 *
	 * @extends Component
	 */
	
	var VolumePanel = function (_Component) {
	  inherits(VolumePanel, _Component);
	
	  /**
	   * Creates an instance of this class.
	   *
	   * @param {Player} player
	   *        The `Player` that this class should be attached to.
	   *
	   * @param {Object} [options={}]
	   *        The key/value store of player options.
	   */
	  function VolumePanel(player) {
	    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	    classCallCheck(this, VolumePanel);
	
	    if (typeof options.inline !== 'undefined') {
	      options.inline = options.inline;
	    } else {
	      options.inline = true;
	    }
	
	    // pass the inline option down to the VolumeControl as vertical if
	    // the VolumeControl is on.
	    if (typeof options.volumeControl === 'undefined' || isPlain(options.volumeControl)) {
	      options.volumeControl = options.volumeControl || {};
	      options.volumeControl.vertical = !options.inline;
	    }
	
	    var _this = possibleConstructorReturn(this, _Component.call(this, player, options));
	
	    _this.on(player, ['loadstart'], _this.volumePanelState_);
	
	    // while the slider is active (the mouse has been pressed down and
	    // is dragging) we do not want to hide the VolumeBar
	    _this.on(_this.volumeControl, ['slideractive'], _this.sliderActive_);
	
	    _this.on(_this.volumeControl, ['sliderinactive'], _this.sliderInactive_);
	    return _this;
	  }
	
	  /**
	   * Add vjs-slider-active class to the VolumePanel
	   *
	   * @listens VolumeControl#slideractive
	   * @private
	   */
	
	
	  VolumePanel.prototype.sliderActive_ = function sliderActive_() {
	    this.addClass('vjs-slider-active');
	  };
	
	  /**
	   * Removes vjs-slider-active class to the VolumePanel
	   *
	   * @listens VolumeControl#sliderinactive
	   * @private
	   */
	
	
	  VolumePanel.prototype.sliderInactive_ = function sliderInactive_() {
	    this.removeClass('vjs-slider-active');
	  };
	
	  /**
	   * Adds vjs-hidden or vjs-mute-toggle-only to the VolumePanel
	   * depending on MuteToggle and VolumeControl state
	   *
	   * @listens Player#loadstart
	   * @private
	   */
	
	
	  VolumePanel.prototype.volumePanelState_ = function volumePanelState_() {
	    // hide volume panel if neither volume control or mute toggle
	    // are displayed
	    if (this.volumeControl.hasClass('vjs-hidden') && this.muteToggle.hasClass('vjs-hidden')) {
	      this.addClass('vjs-hidden');
	    }
	
	    // if only mute toggle is visible we don't want
	    // volume panel expanding when hovered or active
	    if (this.volumeControl.hasClass('vjs-hidden') && !this.muteToggle.hasClass('vjs-hidden')) {
	      this.addClass('vjs-mute-toggle-only');
	    }
	  };
	
	  /**
	   * Create the `Component`'s DOM element
	   *
	   * @return {Element}
	   *         The element that was created.
	   */
	
	
	  VolumePanel.prototype.createEl = function createEl() {
	    var orientationClass = 'vjs-volume-panel-horizontal';
	
	    if (!this.options_.inline) {
	      orientationClass = 'vjs-volume-panel-vertical';
	    }
	
	    return _Component.prototype.createEl.call(this, 'div', {
	      className: 'vjs-volume-panel vjs-control ' + orientationClass
	    });
	  };
	
	  return VolumePanel;
	}(Component);
	
	/**
	 * Default options for the `VolumeControl`
	 *
	 * @type {Object}
	 * @private
	 */
	
	
	VolumePanel.prototype.options_ = {
	  children: ['muteToggle', 'volumeControl']
	};
	
	Component.registerComponent('VolumePanel', VolumePanel);
	
	/**
	 * @file menu.js
	 */
	
	/**
	 * The Menu component is used to build popup menus, including subtitle and
	 * captions selection menus.
	 *
	 * @extends Component
	 */
	
	var Menu = function (_Component) {
	  inherits(Menu, _Component);
	
	  /**
	   * Create an instance of this class.
	   *
	   * @param {Player} player
	   *        the player that this component should attach to
	   *
	   * @param {Object} [options]
	   *        Object of option names and values
	   *
	   */
	  function Menu(player, options) {
	    classCallCheck(this, Menu);
	
	    var _this = possibleConstructorReturn(this, _Component.call(this, player, options));
	
	    if (options) {
	      _this.menuButton_ = options.menuButton;
	    }
	
	    _this.focusedChild_ = -1;
	
	    _this.on('keydown', _this.handleKeyPress);
	    return _this;
	  }
	
	  /**
	   * Add a {@link MenuItem} to the menu.
	   *
	   * @param {Object|string} component
	   *        The name or instance of the `MenuItem` to add.
	   *
	   */
	
	
	  Menu.prototype.addItem = function addItem(component) {
	    this.addChild(component);
	    component.on('click', bind(this, function (event) {
	      // Unpress the associated MenuButton, and move focus back to it
	      if (this.menuButton_) {
	        this.menuButton_.unpressButton();
	
	        // don't focus menu button if item is a caption settings item
	        // because focus will move elsewhere
	        if (component.name() !== 'CaptionSettingsMenuItem') {
	          this.menuButton_.focus();
	        }
	      }
	    }));
	  };
	
	  /**
	   * Create the `Menu`s DOM element.
	   *
	   * @return {Element}
	   *         the element that was created
	   */
	
	
	  Menu.prototype.createEl = function createEl$$1() {
	    var contentElType = this.options_.contentElType || 'ul';
	
	    this.contentEl_ = createEl(contentElType, {
	      className: 'vjs-menu-content'
	    });
	
	    this.contentEl_.setAttribute('role', 'menu');
	
	    var el = _Component.prototype.createEl.call(this, 'div', {
	      append: this.contentEl_,
	      className: 'vjs-menu'
	    });
	
	    el.appendChild(this.contentEl_);
	
	    // Prevent clicks from bubbling up. Needed for Menu Buttons,
	    // where a click on the parent is significant
	    on(el, 'click', function (event) {
	      event.preventDefault();
	      event.stopImmediatePropagation();
	    });
	
	    return el;
	  };
	
	  Menu.prototype.dispose = function dispose() {
	    this.contentEl_ = null;
	
	    _Component.prototype.dispose.call(this);
	  };
	
	  /**
	   * Handle a `keydown` event on this menu. This listener is added in the constructor.
	   *
	   * @param {EventTarget~Event} event
	   *        A `keydown` event that happened on the menu.
	   *
	   * @listens keydown
	   */
	
	
	  Menu.prototype.handleKeyPress = function handleKeyPress(event) {
	    // Left and Down Arrows
	    if (event.which === 37 || event.which === 40) {
	      event.preventDefault();
	      this.stepForward();
	
	      // Up and Right Arrows
	    } else if (event.which === 38 || event.which === 39) {
	      event.preventDefault();
	      this.stepBack();
	    }
	  };
	
	  /**
	   * Move to next (lower) menu item for keyboard users.
	   */
	
	
	  Menu.prototype.stepForward = function stepForward() {
	    var stepChild = 0;
	
	    if (this.focusedChild_ !== undefined) {
	      stepChild = this.focusedChild_ + 1;
	    }
	    this.focus(stepChild);
	  };
	
	  /**
	   * Move to previous (higher) menu item for keyboard users.
	   */
	
	
	  Menu.prototype.stepBack = function stepBack() {
	    var stepChild = 0;
	
	    if (this.focusedChild_ !== undefined) {
	      stepChild = this.focusedChild_ - 1;
	    }
	    this.focus(stepChild);
	  };
	
	  /**
	   * Set focus on a {@link MenuItem} in the `Menu`.
	   *
	   * @param {Object|string} [item=0]
	   *        Index of child item set focus on.
	   */
	
	
	  Menu.prototype.focus = function focus() {
	    var item = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
	
	    var children = this.children().slice();
	    var haveTitle = children.length && children[0].className && /vjs-menu-title/.test(children[0].className);
	
	    if (haveTitle) {
	      children.shift();
	    }
	
	    if (children.length > 0) {
	      if (item < 0) {
	        item = 0;
	      } else if (item >= children.length) {
	        item = children.length - 1;
	      }
	
	      this.focusedChild_ = item;
	
	      children[item].el_.focus();
	    }
	  };
	
	  return Menu;
	}(Component);
	
	Component.registerComponent('Menu', Menu);
	
	/**
	 * @file menu-button.js
	 */
	
	/**
	 * A `MenuButton` class for any popup {@link Menu}.
	 *
	 * @extends Component
	 */
	
	var MenuButton = function (_Component) {
	  inherits(MenuButton, _Component);
	
	  /**
	   * Creates an instance of this class.
	   *
	   * @param {Player} player
	   *        The `Player` that this class should be attached to.
	   *
	   * @param {Object} [options={}]
	   *        The key/value store of player options.
	   */
	  function MenuButton(player) {
	    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	    classCallCheck(this, MenuButton);
	
	    var _this = possibleConstructorReturn(this, _Component.call(this, player, options));
	
	    _this.menuButton_ = new Button(player, options);
	
	    _this.menuButton_.controlText(_this.controlText_);
	    _this.menuButton_.el_.setAttribute('aria-haspopup', 'true');
	
	    // Add buildCSSClass values to the button, not the wrapper
	    var buttonClass = Button.prototype.buildCSSClass();
	
	    _this.menuButton_.el_.className = _this.buildCSSClass() + ' ' + buttonClass;
	    _this.menuButton_.removeClass('vjs-control');
	
	    _this.addChild(_this.menuButton_);
	
	    _this.update();
	
	    _this.enabled_ = true;
	
	    _this.on(_this.menuButton_, 'tap', _this.handleClick);
	    _this.on(_this.menuButton_, 'click', _this.handleClick);
	    _this.on(_this.menuButton_, 'focus', _this.handleFocus);
	    _this.on(_this.menuButton_, 'blur', _this.handleBlur);
	
	    _this.on('keydown', _this.handleSubmenuKeyPress);
	    return _this;
	  }
	
	  /**
	   * Update the menu based on the current state of its items.
	   */
	
	
	  MenuButton.prototype.update = function update() {
	    var menu = this.createMenu();
	
	    if (this.menu) {
	      this.menu.dispose();
	      this.removeChild(this.menu);
	    }
	
	    this.menu = menu;
	    this.addChild(menu);
	
	    /**
	     * Track the state of the menu button
	     *
	     * @type {Boolean}
	     * @private
	     */
	    this.buttonPressed_ = false;
	    this.menuButton_.el_.setAttribute('aria-expanded', 'false');
	
	    if (this.items && this.items.length <= this.hideThreshold_) {
	      this.hide();
	    } else {
	      this.show();
	    }
	  };
	
	  /**
	   * Create the menu and add all items to it.
	   *
	   * @return {Menu}
	   *         The constructed menu
	   */
	
	
	  MenuButton.prototype.createMenu = function createMenu() {
	    var menu = new Menu(this.player_, { menuButton: this });
	
	    /**
	     * Hide the menu if the number of items is less than or equal to this threshold. This defaults
	     * to 0 and whenever we add items which can be hidden to the menu we'll increment it. We list
	     * it here because every time we run `createMenu` we need to reset the value.
	     *
	     * @protected
	     * @type {Number}
	     */
	    this.hideThreshold_ = 0;
	
	    // Add a title list item to the top
	    if (this.options_.title) {
	      var title = createEl('li', {
	        className: 'vjs-menu-title',
	        innerHTML: toTitleCase(this.options_.title),
	        tabIndex: -1
	      });
	
	      this.hideThreshold_ += 1;
	
	      menu.children_.unshift(title);
	      prependTo(title, menu.contentEl());
	    }
	
	    this.items = this.createItems();
	
	    if (this.items) {
	      // Add menu items to the menu
	      for (var i = 0; i < this.items.length; i++) {
	        menu.addItem(this.items[i]);
	      }
	    }
	
	    return menu;
	  };
	
	  /**
	   * Create the list of menu items. Specific to each subclass.
	   *
	   * @abstract
	   */
	
	
	  MenuButton.prototype.createItems = function createItems() {};
	
	  /**
	   * Create the `MenuButtons`s DOM element.
	   *
	   * @return {Element}
	   *         The element that gets created.
	   */
	
	
	  MenuButton.prototype.createEl = function createEl$$1() {
	    return _Component.prototype.createEl.call(this, 'div', {
	      className: this.buildWrapperCSSClass()
	    }, {});
	  };
	
	  /**
	   * Allow sub components to stack CSS class names for the wrapper element
	   *
	   * @return {string}
	   *         The constructed wrapper DOM `className`
	   */
	
	
	  MenuButton.prototype.buildWrapperCSSClass = function buildWrapperCSSClass() {
	    var menuButtonClass = 'vjs-menu-button';
	
	    // If the inline option is passed, we want to use different styles altogether.
	    if (this.options_.inline === true) {
	      menuButtonClass += '-inline';
	    } else {
	      menuButtonClass += '-popup';
	    }
	
	    // TODO: Fix the CSS so that this isn't necessary
	    var buttonClass = Button.prototype.buildCSSClass();
	
	    return 'vjs-menu-button ' + menuButtonClass + ' ' + buttonClass + ' ' + _Component.prototype.buildCSSClass.call(this);
	  };
	
	  /**
	   * Builds the default DOM `className`.
	   *
	   * @return {string}
	   *         The DOM `className` for this object.
	   */
	
	
	  MenuButton.prototype.buildCSSClass = function buildCSSClass() {
	    var menuButtonClass = 'vjs-menu-button';
	
	    // If the inline option is passed, we want to use different styles altogether.
	    if (this.options_.inline === true) {
	      menuButtonClass += '-inline';
	    } else {
	      menuButtonClass += '-popup';
	    }
	
	    return 'vjs-menu-button ' + menuButtonClass + ' ' + _Component.prototype.buildCSSClass.call(this);
	  };
	
	  /**
	   * Get or set the localized control text that will be used for accessibility.
	   *
	   * > NOTE: This will come from the internal `menuButton_` element.
	   *
	   * @param {string} [text]
	   *        Control text for element.
	   *
	   * @param {Element} [el=this.menuButton_.el()]
	   *        Element to set the title on.
	   *
	   * @return {string}
	   *         - The control text when getting
	   */
	
	
	  MenuButton.prototype.controlText = function controlText(text) {
	    var el = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.menuButton_.el();
	
	    return this.menuButton_.controlText(text, el);
	  };
	
	  /**
	   * Handle a click on a `MenuButton`.
	   * See {@link ClickableComponent#handleClick} for instances where this is called.
	   *
	   * @param {EventTarget~Event} event
	   *        The `keydown`, `tap`, or `click` event that caused this function to be
	   *        called.
	   *
	   * @listens tap
	   * @listens click
	   */
	
	
	  MenuButton.prototype.handleClick = function handleClick(event) {
	    // When you click the button it adds focus, which will show the menu.
	    // So we'll remove focus when the mouse leaves the button. Focus is needed
	    // for tab navigation.
	
	    this.one(this.menu.contentEl(), 'mouseleave', bind(this, function (e) {
	      this.unpressButton();
	      this.el_.blur();
	    }));
	    if (this.buttonPressed_) {
	      this.unpressButton();
	    } else {
	      this.pressButton();
	    }
	  };
	
	  /**
	   * Set the focus to the actual button, not to this element
	   */
	
	
	  MenuButton.prototype.focus = function focus() {
	    this.menuButton_.focus();
	  };
	
	  /**
	   * Remove the focus from the actual button, not this element
	   */
	
	
	  MenuButton.prototype.blur = function blur() {
	    this.menuButton_.blur();
	  };
	
	  /**
	   * This gets called when a `MenuButton` gains focus via a `focus` event.
	   * Turns on listening for `keydown` events. When they happen it
	   * calls `this.handleKeyPress`.
	   *
	   * @param {EventTarget~Event} event
	   *        The `focus` event that caused this function to be called.
	   *
	   * @listens focus
	   */
	
	
	  MenuButton.prototype.handleFocus = function handleFocus() {
	    on(document, 'keydown', bind(this, this.handleKeyPress));
	  };
	
	  /**
	   * Called when a `MenuButton` loses focus. Turns off the listener for
	   * `keydown` events. Which Stops `this.handleKeyPress` from getting called.
	   *
	   * @param {EventTarget~Event} event
	   *        The `blur` event that caused this function to be called.
	   *
	   * @listens blur
	   */
	
	
	  MenuButton.prototype.handleBlur = function handleBlur() {
	    off(document, 'keydown', bind(this, this.handleKeyPress));
	  };
	
	  /**
	   * Handle tab, escape, down arrow, and up arrow keys for `MenuButton`. See
	   * {@link ClickableComponent#handleKeyPress} for instances where this is called.
	   *
	   * @param {EventTarget~Event} event
	   *        The `keydown` event that caused this function to be called.
	   *
	   * @listens keydown
	   */
	
	
	  MenuButton.prototype.handleKeyPress = function handleKeyPress(event) {
	
	    // Escape (27) key or Tab (9) key unpress the 'button'
	    if (event.which === 27 || event.which === 9) {
	      if (this.buttonPressed_) {
	        this.unpressButton();
	      }
	      // Don't preventDefault for Tab key - we still want to lose focus
	      if (event.which !== 9) {
	        event.preventDefault();
	        // Set focus back to the menu button's button
	        this.menuButton_.el_.focus();
	      }
	      // Up (38) key or Down (40) key press the 'button'
	    } else if (event.which === 38 || event.which === 40) {
	      if (!this.buttonPressed_) {
	        this.pressButton();
	        event.preventDefault();
	      }
	    }
	  };
	
	  /**
	   * Handle a `keydown` event on a sub-menu. The listener for this is added in
	   * the constructor.
	   *
	   * @param {EventTarget~Event} event
	   *        Key press event
	   *
	   * @listens keydown
	   */
	
	
	  MenuButton.prototype.handleSubmenuKeyPress = function handleSubmenuKeyPress(event) {
	
	    // Escape (27) key or Tab (9) key unpress the 'button'
	    if (event.which === 27 || event.which === 9) {
	      if (this.buttonPressed_) {
	        this.unpressButton();
	      }
	      // Don't preventDefault for Tab key - we still want to lose focus
	      if (event.which !== 9) {
	        event.preventDefault();
	        // Set focus back to the menu button's button
	        this.menuButton_.el_.focus();
	      }
	    }
	  };
	
	  /**
	   * Put the current `MenuButton` into a pressed state.
	   */
	
	
	  MenuButton.prototype.pressButton = function pressButton() {
	    if (this.enabled_) {
	      this.buttonPressed_ = true;
	      this.menu.lockShowing();
	      this.menuButton_.el_.setAttribute('aria-expanded', 'true');
	
	      // set the focus into the submenu, except on iOS where it is resulting in
	      // undesired scrolling behavior when the player is in an iframe
	      if (IS_IOS && isInFrame()) {
	        // Return early so that the menu isn't focused
	        return;
	      }
	
	      this.menu.focus();
	    }
	  };
	
	  /**
	   * Take the current `MenuButton` out of a pressed state.
	   */
	
	
	  MenuButton.prototype.unpressButton = function unpressButton() {
	    if (this.enabled_) {
	      this.buttonPressed_ = false;
	      this.menu.unlockShowing();
	      this.menuButton_.el_.setAttribute('aria-expanded', 'false');
	    }
	  };
	
	  /**
	   * Disable the `MenuButton`. Don't allow it to be clicked.
	   */
	
	
	  MenuButton.prototype.disable = function disable() {
	    this.unpressButton();
	
	    this.enabled_ = false;
	    this.addClass('vjs-disabled');
	
	    this.menuButton_.disable();
	  };
	
	  /**
	   * Enable the `MenuButton`. Allow it to be clicked.
	   */
	
	
	  MenuButton.prototype.enable = function enable() {
	    this.enabled_ = true;
	    this.removeClass('vjs-disabled');
	
	    this.menuButton_.enable();
	  };
	
	  return MenuButton;
	}(Component);
	
	Component.registerComponent('MenuButton', MenuButton);
	
	/**
	 * @file track-button.js
	 */
	
	/**
	 * The base class for buttons that toggle specific  track types (e.g. subtitles).
	 *
	 * @extends MenuButton
	 */
	
	var TrackButton = function (_MenuButton) {
	  inherits(TrackButton, _MenuButton);
	
	  /**
	   * Creates an instance of this class.
	   *
	   * @param {Player} player
	   *        The `Player` that this class should be attached to.
	   *
	   * @param {Object} [options]
	   *        The key/value store of player options.
	   */
	  function TrackButton(player, options) {
	    classCallCheck(this, TrackButton);
	
	    var tracks = options.tracks;
	
	    var _this = possibleConstructorReturn(this, _MenuButton.call(this, player, options));
	
	    if (_this.items.length <= 1) {
	      _this.hide();
	    }
	
	    if (!tracks) {
	      return possibleConstructorReturn(_this);
	    }
	
	    var updateHandler = bind(_this, _this.update);
	
	    tracks.addEventListener('removetrack', updateHandler);
	    tracks.addEventListener('addtrack', updateHandler);
	    _this.player_.on('ready', updateHandler);
	
	    _this.player_.on('dispose', function () {
	      tracks.removeEventListener('removetrack', updateHandler);
	      tracks.removeEventListener('addtrack', updateHandler);
	    });
	    return _this;
	  }
	
	  return TrackButton;
	}(MenuButton);
	
	Component.registerComponent('TrackButton', TrackButton);
	
	/**
	 * @file menu-item.js
	 */
	
	/**
	 * The component for a menu item. `<li>`
	 *
	 * @extends ClickableComponent
	 */
	
	var MenuItem = function (_ClickableComponent) {
	  inherits(MenuItem, _ClickableComponent);
	
	  /**
	   * Creates an instance of the this class.
	   *
	   * @param {Player} player
	   *        The `Player` that this class should be attached to.
	   *
	   * @param {Object} [options={}]
	   *        The key/value store of player options.
	   *
	   */
	  function MenuItem(player, options) {
	    classCallCheck(this, MenuItem);
	
	    var _this = possibleConstructorReturn(this, _ClickableComponent.call(this, player, options));
	
	    _this.selectable = options.selectable;
	    _this.isSelected_ = options.selected || false;
	    _this.multiSelectable = options.multiSelectable;
	
	    _this.selected(_this.isSelected_);
	
	    if (_this.selectable) {
	      if (_this.multiSelectable) {
	        _this.el_.setAttribute('role', 'menuitemcheckbox');
	      } else {
	        _this.el_.setAttribute('role', 'menuitemradio');
	      }
	    } else {
	      _this.el_.setAttribute('role', 'menuitem');
	    }
	    return _this;
	  }
	
	  /**
	   * Create the `MenuItem's DOM element
	   *
	   * @param {string} [type=li]
	   *        Element's node type, not actually used, always set to `li`.
	   *
	   * @param {Object} [props={}]
	   *        An object of properties that should be set on the element
	   *
	   * @param {Object} [attrs={}]
	   *        An object of attributes that should be set on the element
	   *
	   * @return {Element}
	   *         The element that gets created.
	   */
	
	
	  MenuItem.prototype.createEl = function createEl(type, props, attrs) {
	    // The control is textual, not just an icon
	    this.nonIconControl = true;
	
	    return _ClickableComponent.prototype.createEl.call(this, 'li', assign({
	      className: 'vjs-menu-item',
	      innerHTML: '<span class="vjs-menu-item-text">' + this.localize(this.options_.label) + '</span>',
	      tabIndex: -1
	    }, props), attrs);
	  };
	
	  /**
	   * Any click on a `MenuItem` puts it into the selected state.
	   * See {@link ClickableComponent#handleClick} for instances where this is called.
	   *
	   * @param {EventTarget~Event} event
	   *        The `keydown`, `tap`, or `click` event that caused this function to be
	   *        called.
	   *
	   * @listens tap
	   * @listens click
	   */
	
	
	  MenuItem.prototype.handleClick = function handleClick(event) {
	    this.selected(true);
	  };
	
	  /**
	   * Set the state for this menu item as selected or not.
	   *
	   * @param {boolean} selected
	   *        if the menu item is selected or not
	   */
	
	
	  MenuItem.prototype.selected = function selected(_selected) {
	    if (this.selectable) {
	      if (_selected) {
	        this.addClass('vjs-selected');
	        this.el_.setAttribute('aria-checked', 'true');
	        // aria-checked isn't fully supported by browsers/screen readers,
	        // so indicate selected state to screen reader in the control text.
	        this.controlText(', selected');
	        this.isSelected_ = true;
	      } else {
	        this.removeClass('vjs-selected');
	        this.el_.setAttribute('aria-checked', 'false');
	        // Indicate un-selected state to screen reader
	        this.controlText('');
	        this.isSelected_ = false;
	      }
	    }
	  };
	
	  return MenuItem;
	}(ClickableComponent);
	
	Component.registerComponent('MenuItem', MenuItem);
	
	/**
	 * @file text-track-menu-item.js
	 */
	
	/**
	 * The specific menu item type for selecting a language within a text track kind
	 *
	 * @extends MenuItem
	 */
	
	var TextTrackMenuItem = function (_MenuItem) {
	  inherits(TextTrackMenuItem, _MenuItem);
	
	  /**
	   * Creates an instance of this class.
	   *
	   * @param {Player} player
	   *        The `Player` that this class should be attached to.
	   *
	   * @param {Object} [options]
	   *        The key/value store of player options.
	   */
	  function TextTrackMenuItem(player, options) {
	    classCallCheck(this, TextTrackMenuItem);
	
	    var track = options.track;
	    var tracks = player.textTracks();
	
	    // Modify options for parent MenuItem class's init.
	    options.label = track.label || track.language || 'Unknown';
	    options.selected = track.mode === 'showing';
	
	    var _this = possibleConstructorReturn(this, _MenuItem.call(this, player, options));
	
	    _this.track = track;
	    var changeHandler = function changeHandler() {
	      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	        args[_key] = arguments[_key];
	      }
	
	      _this.handleTracksChange.apply(_this, args);
	    };
	    var selectedLanguageChangeHandler = function selectedLanguageChangeHandler() {
	      for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
	        args[_key2] = arguments[_key2];
	      }
	
	      _this.handleSelectedLanguageChange.apply(_this, args);
	    };
	
	    player.on(['loadstart', 'texttrackchange'], changeHandler);
	    tracks.addEventListener('change', changeHandler);
	    tracks.addEventListener('selectedlanguagechange', selectedLanguageChangeHandler);
	    _this.on('dispose', function () {
	      player.off(['loadstart', 'texttrackchange'], changeHandler);
	      tracks.removeEventListener('change', changeHandler);
	      tracks.removeEventListener('selectedlanguagechange', selectedLanguageChangeHandler);
	    });
	
	    // iOS7 doesn't dispatch change events to TextTrackLists when an
	    // associated track's mode changes. Without something like
	    // Object.observe() (also not present on iOS7), it's not
	    // possible to detect changes to the mode attribute and polyfill
	    // the change event. As a poor substitute, we manually dispatch
	    // change events whenever the controls modify the mode.
	    if (tracks.onchange === undefined) {
	      var event = void 0;
	
	      _this.on(['tap', 'click'], function () {
	        if (_typeof(window$1.Event) !== 'object') {
	          // Android 2.3 throws an Illegal Constructor error for window.Event
	          try {
	            event = new window$1.Event('change');
	          } catch (err) {
	            // continue regardless of error
	          }
	        }
	
	        if (!event) {
	          event = document.createEvent('Event');
	          event.initEvent('change', true, true);
	        }
	
	        tracks.dispatchEvent(event);
	      });
	    }
	
	    // set the default state based on current tracks
	    _this.handleTracksChange();
	    return _this;
	  }
	
	  /**
	   * This gets called when an `TextTrackMenuItem` is "clicked". See
	   * {@link ClickableComponent} for more detailed information on what a click can be.
	   *
	   * @param {EventTarget~Event} event
	   *        The `keydown`, `tap`, or `click` event that caused this function to be
	   *        called.
	   *
	   * @listens tap
	   * @listens click
	   */
	
	
	  TextTrackMenuItem.prototype.handleClick = function handleClick(event) {
	    var kind = this.track.kind;
	    var kinds = this.track.kinds;
	    var tracks = this.player_.textTracks();
	
	    if (!kinds) {
	      kinds = [kind];
	    }
	
	    _MenuItem.prototype.handleClick.call(this, event);
	
	    if (!tracks) {
	      return;
	    }
	
	    for (var i = 0; i < tracks.length; i++) {
	      var track = tracks[i];
	
	      if (track === this.track && kinds.indexOf(track.kind) > -1) {
	        if (track.mode !== 'showing') {
	          track.mode = 'showing';
	        }
	      } else if (track.mode !== 'disabled') {
	        track.mode = 'disabled';
	      }
	    }
	  };
	
	  /**
	   * Handle text track list change
	   *
	   * @param {EventTarget~Event} event
	   *        The `change` event that caused this function to be called.
	   *
	   * @listens TextTrackList#change
	   */
	
	
	  TextTrackMenuItem.prototype.handleTracksChange = function handleTracksChange(event) {
	    var shouldBeSelected = this.track.mode === 'showing';
	
	    // Prevent redundant selected() calls because they may cause
	    // screen readers to read the appended control text unnecessarily
	    if (shouldBeSelected !== this.isSelected_) {
	      this.selected(shouldBeSelected);
	    }
	  };
	
	  TextTrackMenuItem.prototype.handleSelectedLanguageChange = function handleSelectedLanguageChange(event) {
	    if (this.track.mode === 'showing') {
	      var selectedLanguage = this.player_.cache_.selectedLanguage;
	
	      // Don't replace the kind of track across the same language
	      if (selectedLanguage && selectedLanguage.enabled && selectedLanguage.language === this.track.language && selectedLanguage.kind !== this.track.kind) {
	        return;
	      }
	
	      this.player_.cache_.selectedLanguage = {
	        enabled: true,
	        language: this.track.language,
	        kind: this.track.kind
	      };
	    }
	  };
	
	  TextTrackMenuItem.prototype.dispose = function dispose() {
	    // remove reference to track object on dispose
	    this.track = null;
	
	    _MenuItem.prototype.dispose.call(this);
	  };
	
	  return TextTrackMenuItem;
	}(MenuItem);
	
	Component.registerComponent('TextTrackMenuItem', TextTrackMenuItem);
	
	/**
	 * @file off-text-track-menu-item.js
	 */
	
	/**
	 * A special menu item for turning of a specific type of text track
	 *
	 * @extends TextTrackMenuItem
	 */
	
	var OffTextTrackMenuItem = function (_TextTrackMenuItem) {
	  inherits(OffTextTrackMenuItem, _TextTrackMenuItem);
	
	  /**
	   * Creates an instance of this class.
	   *
	   * @param {Player} player
	   *        The `Player` that this class should be attached to.
	   *
	   * @param {Object} [options]
	   *        The key/value store of player options.
	   */
	  function OffTextTrackMenuItem(player, options) {
	    classCallCheck(this, OffTextTrackMenuItem);
	
	    // Create pseudo track info
	    // Requires options['kind']
	    options.track = {
	      player: player,
	      kind: options.kind,
	      kinds: options.kinds,
	      default: false,
	      mode: 'disabled'
	    };
	
	    if (!options.kinds) {
	      options.kinds = [options.kind];
	    }
	
	    if (options.label) {
	      options.track.label = options.label;
	    } else {
	      options.track.label = options.kinds.join(' and ') + ' off';
	    }
	
	    // MenuItem is selectable
	    options.selectable = true;
	    // MenuItem is NOT multiSelectable (i.e. only one can be marked "selected" at a time)
	    options.multiSelectable = false;
	
	    return possibleConstructorReturn(this, _TextTrackMenuItem.call(this, player, options));
	  }
	
	  /**
	   * Handle text track change
	   *
	   * @param {EventTarget~Event} event
	   *        The event that caused this function to run
	   */
	
	
	  OffTextTrackMenuItem.prototype.handleTracksChange = function handleTracksChange(event) {
	    var tracks = this.player().textTracks();
	    var shouldBeSelected = true;
	
	    for (var i = 0, l = tracks.length; i < l; i++) {
	      var track = tracks[i];
	
	      if (this.options_.kinds.indexOf(track.kind) > -1 && track.mode === 'showing') {
	        shouldBeSelected = false;
	        break;
	      }
	    }
	
	    // Prevent redundant selected() calls because they may cause
	    // screen readers to read the appended control text unnecessarily
	    if (shouldBeSelected !== this.isSelected_) {
	      this.selected(shouldBeSelected);
	    }
	  };
	
	  OffTextTrackMenuItem.prototype.handleSelectedLanguageChange = function handleSelectedLanguageChange(event) {
	    var tracks = this.player().textTracks();
	    var allHidden = true;
	
	    for (var i = 0, l = tracks.length; i < l; i++) {
	      var track = tracks[i];
	
	      if (['captions', 'descriptions', 'subtitles'].indexOf(track.kind) > -1 && track.mode === 'showing') {
	        allHidden = false;
	        break;
	      }
	    }
	
	    if (allHidden) {
	      this.player_.cache_.selectedLanguage = {
	        enabled: false
	      };
	    }
	  };
	
	  return OffTextTrackMenuItem;
	}(TextTrackMenuItem);
	
	Component.registerComponent('OffTextTrackMenuItem', OffTextTrackMenuItem);
	
	/**
	 * @file text-track-button.js
	 */
	
	/**
	 * The base class for buttons that toggle specific text track types (e.g. subtitles)
	 *
	 * @extends MenuButton
	 */
	
	var TextTrackButton = function (_TrackButton) {
	  inherits(TextTrackButton, _TrackButton);
	
	  /**
	   * Creates an instance of this class.
	   *
	   * @param {Player} player
	   *        The `Player` that this class should be attached to.
	   *
	   * @param {Object} [options={}]
	   *        The key/value store of player options.
	   */
	  function TextTrackButton(player) {
	    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	    classCallCheck(this, TextTrackButton);
	
	    options.tracks = player.textTracks();
	
	    return possibleConstructorReturn(this, _TrackButton.call(this, player, options));
	  }
	
	  /**
	   * Create a menu item for each text track
	   *
	   * @param {TextTrackMenuItem[]} [items=[]]
	   *        Existing array of items to use during creation
	   *
	   * @return {TextTrackMenuItem[]}
	   *         Array of menu items that were created
	   */
	
	
	  TextTrackButton.prototype.createItems = function createItems() {
	    var items = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	    var TrackMenuItem = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : TextTrackMenuItem;
	
	
	    // Label is an override for the [track] off label
	    // USed to localise captions/subtitles
	    var label = void 0;
	
	    if (this.label_) {
	      label = this.label_ + ' off';
	    }
	    // Add an OFF menu item to turn all tracks off
	    items.push(new OffTextTrackMenuItem(this.player_, {
	      kinds: this.kinds_,
	      kind: this.kind_,
	      label: label
	    }));
	
	    this.hideThreshold_ += 1;
	
	    var tracks = this.player_.textTracks();
	
	    if (!Array.isArray(this.kinds_)) {
	      this.kinds_ = [this.kind_];
	    }
	
	    for (var i = 0; i < tracks.length; i++) {
	      var track = tracks[i];
	
	      // only add tracks that are of an appropriate kind and have a label
	      if (this.kinds_.indexOf(track.kind) > -1) {
	
	        var item = new TrackMenuItem(this.player_, {
	          track: track,
	          // MenuItem is selectable
	          selectable: true,
	          // MenuItem is NOT multiSelectable (i.e. only one can be marked "selected" at a time)
	          multiSelectable: false
	        });
	
	        item.addClass('vjs-' + track.kind + '-menu-item');
	        items.push(item);
	      }
	    }
	
	    return items;
	  };
	
	  return TextTrackButton;
	}(TrackButton);
	
	Component.registerComponent('TextTrackButton', TextTrackButton);
	
	/**
	 * @file chapters-track-menu-item.js
	 */
	
	/**
	 * The chapter track menu item
	 *
	 * @extends MenuItem
	 */
	
	var ChaptersTrackMenuItem = function (_MenuItem) {
	  inherits(ChaptersTrackMenuItem, _MenuItem);
	
	  /**
	   * Creates an instance of this class.
	   *
	   * @param {Player} player
	   *        The `Player` that this class should be attached to.
	   *
	   * @param {Object} [options]
	   *        The key/value store of player options.
	   */
	  function ChaptersTrackMenuItem(player, options) {
	    classCallCheck(this, ChaptersTrackMenuItem);
	
	    var track = options.track;
	    var cue = options.cue;
	    var currentTime = player.currentTime();
	
	    // Modify options for parent MenuItem class's init.
	    options.selectable = true;
	    options.multiSelectable = false;
	    options.label = cue.text;
	    options.selected = cue.startTime <= currentTime && currentTime < cue.endTime;
	
	    var _this = possibleConstructorReturn(this, _MenuItem.call(this, player, options));
	
	    _this.track = track;
	    _this.cue = cue;
	    track.addEventListener('cuechange', bind(_this, _this.update));
	    return _this;
	  }
	
	  /**
	   * This gets called when an `ChaptersTrackMenuItem` is "clicked". See
	   * {@link ClickableComponent} for more detailed information on what a click can be.
	   *
	   * @param {EventTarget~Event} [event]
	   *        The `keydown`, `tap`, or `click` event that caused this function to be
	   *        called.
	   *
	   * @listens tap
	   * @listens click
	   */
	
	
	  ChaptersTrackMenuItem.prototype.handleClick = function handleClick(event) {
	    _MenuItem.prototype.handleClick.call(this);
	    this.player_.currentTime(this.cue.startTime);
	    this.update(this.cue.startTime);
	  };
	
	  /**
	   * Update chapter menu item
	   *
	   * @param {EventTarget~Event} [event]
	   *        The `cuechange` event that caused this function to run.
	   *
	   * @listens TextTrack#cuechange
	   */
	
	
	  ChaptersTrackMenuItem.prototype.update = function update(event) {
	    var cue = this.cue;
	    var currentTime = this.player_.currentTime();
	
	    // vjs.log(currentTime, cue.startTime);
	    this.selected(cue.startTime <= currentTime && currentTime < cue.endTime);
	  };
	
	  return ChaptersTrackMenuItem;
	}(MenuItem);
	
	Component.registerComponent('ChaptersTrackMenuItem', ChaptersTrackMenuItem);
	
	/**
	 * @file chapters-button.js
	 */
	
	/**
	 * The button component for toggling and selecting chapters
	 * Chapters act much differently than other text tracks
	 * Cues are navigation vs. other tracks of alternative languages
	 *
	 * @extends TextTrackButton
	 */
	
	var ChaptersButton = function (_TextTrackButton) {
	  inherits(ChaptersButton, _TextTrackButton);
	
	  /**
	   * Creates an instance of this class.
	   *
	   * @param {Player} player
	   *        The `Player` that this class should be attached to.
	   *
	   * @param {Object} [options]
	   *        The key/value store of player options.
	   *
	   * @param {Component~ReadyCallback} [ready]
	   *        The function to call when this function is ready.
	   */
	  function ChaptersButton(player, options, ready) {
	    classCallCheck(this, ChaptersButton);
	    return possibleConstructorReturn(this, _TextTrackButton.call(this, player, options, ready));
	  }
	
	  /**
	   * Builds the default DOM `className`.
	   *
	   * @return {string}
	   *         The DOM `className` for this object.
	   */
	
	
	  ChaptersButton.prototype.buildCSSClass = function buildCSSClass() {
	    return 'vjs-chapters-button ' + _TextTrackButton.prototype.buildCSSClass.call(this);
	  };
	
	  ChaptersButton.prototype.buildWrapperCSSClass = function buildWrapperCSSClass() {
	    return 'vjs-chapters-button ' + _TextTrackButton.prototype.buildWrapperCSSClass.call(this);
	  };
	
	  /**
	   * Update the menu based on the current state of its items.
	   *
	   * @param {EventTarget~Event} [event]
	   *        An event that triggered this function to run.
	   *
	   * @listens TextTrackList#addtrack
	   * @listens TextTrackList#removetrack
	   * @listens TextTrackList#change
	   */
	
	
	  ChaptersButton.prototype.update = function update(event) {
	    if (!this.track_ || event && (event.type === 'addtrack' || event.type === 'removetrack')) {
	      this.setTrack(this.findChaptersTrack());
	    }
	    _TextTrackButton.prototype.update.call(this);
	  };
	
	  /**
	   * Set the currently selected track for the chapters button.
	   *
	   * @param {TextTrack} track
	   *        The new track to select. Nothing will change if this is the currently selected
	   *        track.
	   */
	
	
	  ChaptersButton.prototype.setTrack = function setTrack(track) {
	    if (this.track_ === track) {
	      return;
	    }
	
	    if (!this.updateHandler_) {
	      this.updateHandler_ = this.update.bind(this);
	    }
	
	    // here this.track_ refers to the old track instance
	    if (this.track_) {
	      var remoteTextTrackEl = this.player_.remoteTextTrackEls().getTrackElementByTrack_(this.track_);
	
	      if (remoteTextTrackEl) {
	        remoteTextTrackEl.removeEventListener('load', this.updateHandler_);
	      }
	
	      this.track_ = null;
	    }
	
	    this.track_ = track;
	
	    // here this.track_ refers to the new track instance
	    if (this.track_) {
	      this.track_.mode = 'hidden';
	
	      var _remoteTextTrackEl = this.player_.remoteTextTrackEls().getTrackElementByTrack_(this.track_);
	
	      if (_remoteTextTrackEl) {
	        _remoteTextTrackEl.addEventListener('load', this.updateHandler_);
	      }
	    }
	  };
	
	  /**
	   * Find the track object that is currently in use by this ChaptersButton
	   *
	   * @return {TextTrack|undefined}
	   *         The current track or undefined if none was found.
	   */
	
	
	  ChaptersButton.prototype.findChaptersTrack = function findChaptersTrack() {
	    var tracks = this.player_.textTracks() || [];
	
	    for (var i = tracks.length - 1; i >= 0; i--) {
	      // We will always choose the last track as our chaptersTrack
	      var track = tracks[i];
	
	      if (track.kind === this.kind_) {
	        return track;
	      }
	    }
	  };
	
	  /**
	   * Get the caption for the ChaptersButton based on the track label. This will also
	   * use the current tracks localized kind as a fallback if a label does not exist.
	   *
	   * @return {string}
	   *         The tracks current label or the localized track kind.
	   */
	
	
	  ChaptersButton.prototype.getMenuCaption = function getMenuCaption() {
	    if (this.track_ && this.track_.label) {
	      return this.track_.label;
	    }
	    return this.localize(toTitleCase(this.kind_));
	  };
	
	  /**
	   * Create menu from chapter track
	   *
	   * @return {Menu}
	   *         New menu for the chapter buttons
	   */
	
	
	  ChaptersButton.prototype.createMenu = function createMenu() {
	    this.options_.title = this.getMenuCaption();
	    return _TextTrackButton.prototype.createMenu.call(this);
	  };
	
	  /**
	   * Create a menu item for each text track
	   *
	   * @return {TextTrackMenuItem[]}
	   *         Array of menu items
	   */
	
	
	  ChaptersButton.prototype.createItems = function createItems() {
	    var items = [];
	
	    if (!this.track_) {
	      return items;
	    }
	
	    var cues = this.track_.cues;
	
	    if (!cues) {
	      return items;
	    }
	
	    for (var i = 0, l = cues.length; i < l; i++) {
	      var cue = cues[i];
	      var mi = new ChaptersTrackMenuItem(this.player_, { track: this.track_, cue: cue });
	
	      items.push(mi);
	    }
	
	    return items;
	  };
	
	  return ChaptersButton;
	}(TextTrackButton);
	
	/**
	 * `kind` of TextTrack to look for to associate it with this menu.
	 *
	 * @type {string}
	 * @private
	 */
	
	
	ChaptersButton.prototype.kind_ = 'chapters';
	
	/**
	 * The text that should display over the `ChaptersButton`s controls. Added for localization.
	 *
	 * @type {string}
	 * @private
	 */
	ChaptersButton.prototype.controlText_ = 'Chapters';
	
	Component.registerComponent('ChaptersButton', ChaptersButton);
	
	/**
	 * @file descriptions-button.js
	 */
	
	/**
	 * The button component for toggling and selecting descriptions
	 *
	 * @extends TextTrackButton
	 */
	
	var DescriptionsButton = function (_TextTrackButton) {
	  inherits(DescriptionsButton, _TextTrackButton);
	
	  /**
	   * Creates an instance of this class.
	   *
	   * @param {Player} player
	   *        The `Player` that this class should be attached to.
	   *
	   * @param {Object} [options]
	   *        The key/value store of player options.
	   *
	   * @param {Component~ReadyCallback} [ready]
	   *        The function to call when this component is ready.
	   */
	  function DescriptionsButton(player, options, ready) {
	    classCallCheck(this, DescriptionsButton);
	
	    var _this = possibleConstructorReturn(this, _TextTrackButton.call(this, player, options, ready));
	
	    var tracks = player.textTracks();
	    var changeHandler = bind(_this, _this.handleTracksChange);
	
	    tracks.addEventListener('change', changeHandler);
	    _this.on('dispose', function () {
	      tracks.removeEventListener('change', changeHandler);
	    });
	    return _this;
	  }
	
	  /**
	   * Handle text track change
	   *
	   * @param {EventTarget~Event} event
	   *        The event that caused this function to run
	   *
	   * @listens TextTrackList#change
	   */
	
	
	  DescriptionsButton.prototype.handleTracksChange = function handleTracksChange(event) {
	    var tracks = this.player().textTracks();
	    var disabled = false;
	
	    // Check whether a track of a different kind is showing
	    for (var i = 0, l = tracks.length; i < l; i++) {
	      var track = tracks[i];
	
	      if (track.kind !== this.kind_ && track.mode === 'showing') {
	        disabled = true;
	        break;
	      }
	    }
	
	    // If another track is showing, disable this menu button
	    if (disabled) {
	      this.disable();
	    } else {
	      this.enable();
	    }
	  };
	
	  /**
	   * Builds the default DOM `className`.
	   *
	   * @return {string}
	   *         The DOM `className` for this object.
	   */
	
	
	  DescriptionsButton.prototype.buildCSSClass = function buildCSSClass() {
	    return 'vjs-descriptions-button ' + _TextTrackButton.prototype.buildCSSClass.call(this);
	  };
	
	  DescriptionsButton.prototype.buildWrapperCSSClass = function buildWrapperCSSClass() {
	    return 'vjs-descriptions-button ' + _TextTrackButton.prototype.buildWrapperCSSClass.call(this);
	  };
	
	  return DescriptionsButton;
	}(TextTrackButton);
	
	/**
	 * `kind` of TextTrack to look for to associate it with this menu.
	 *
	 * @type {string}
	 * @private
	 */
	
	
	DescriptionsButton.prototype.kind_ = 'descriptions';
	
	/**
	 * The text that should display over the `DescriptionsButton`s controls. Added for localization.
	 *
	 * @type {string}
	 * @private
	 */
	DescriptionsButton.prototype.controlText_ = 'Descriptions';
	
	Component.registerComponent('DescriptionsButton', DescriptionsButton);
	
	/**
	 * @file subtitles-button.js
	 */
	
	/**
	 * The button component for toggling and selecting subtitles
	 *
	 * @extends TextTrackButton
	 */
	
	var SubtitlesButton = function (_TextTrackButton) {
	  inherits(SubtitlesButton, _TextTrackButton);
	
	  /**
	   * Creates an instance of this class.
	   *
	   * @param {Player} player
	   *        The `Player` that this class should be attached to.
	   *
	   * @param {Object} [options]
	   *        The key/value store of player options.
	   *
	   * @param {Component~ReadyCallback} [ready]
	   *        The function to call when this component is ready.
	   */
	  function SubtitlesButton(player, options, ready) {
	    classCallCheck(this, SubtitlesButton);
	    return possibleConstructorReturn(this, _TextTrackButton.call(this, player, options, ready));
	  }
	
	  /**
	   * Builds the default DOM `className`.
	   *
	   * @return {string}
	   *         The DOM `className` for this object.
	   */
	
	
	  SubtitlesButton.prototype.buildCSSClass = function buildCSSClass() {
	    return 'vjs-subtitles-button ' + _TextTrackButton.prototype.buildCSSClass.call(this);
	  };
	
	  SubtitlesButton.prototype.buildWrapperCSSClass = function buildWrapperCSSClass() {
	    return 'vjs-subtitles-button ' + _TextTrackButton.prototype.buildWrapperCSSClass.call(this);
	  };
	
	  return SubtitlesButton;
	}(TextTrackButton);
	
	/**
	 * `kind` of TextTrack to look for to associate it with this menu.
	 *
	 * @type {string}
	 * @private
	 */
	
	
	SubtitlesButton.prototype.kind_ = 'subtitles';
	
	/**
	 * The text that should display over the `SubtitlesButton`s controls. Added for localization.
	 *
	 * @type {string}
	 * @private
	 */
	SubtitlesButton.prototype.controlText_ = 'Subtitles';
	
	Component.registerComponent('SubtitlesButton', SubtitlesButton);
	
	/**
	 * @file caption-settings-menu-item.js
	 */
	
	/**
	 * The menu item for caption track settings menu
	 *
	 * @extends TextTrackMenuItem
	 */
	
	var CaptionSettingsMenuItem = function (_TextTrackMenuItem) {
	  inherits(CaptionSettingsMenuItem, _TextTrackMenuItem);
	
	  /**
	   * Creates an instance of this class.
	   *
	   * @param {Player} player
	   *        The `Player` that this class should be attached to.
	   *
	   * @param {Object} [options]
	   *        The key/value store of player options.
	   */
	  function CaptionSettingsMenuItem(player, options) {
	    classCallCheck(this, CaptionSettingsMenuItem);
	
	    options.track = {
	      player: player,
	      kind: options.kind,
	      label: options.kind + ' settings',
	      selectable: false,
	      default: false,
	      mode: 'disabled'
	    };
	
	    // CaptionSettingsMenuItem has no concept of 'selected'
	    options.selectable = false;
	
	    options.name = 'CaptionSettingsMenuItem';
	
	    var _this = possibleConstructorReturn(this, _TextTrackMenuItem.call(this, player, options));
	
	    _this.addClass('vjs-texttrack-settings');
	    _this.controlText(', opens ' + options.kind + ' settings dialog');
	    return _this;
	  }
	
	  /**
	   * This gets called when an `CaptionSettingsMenuItem` is "clicked". See
	   * {@link ClickableComponent} for more detailed information on what a click can be.
	   *
	   * @param {EventTarget~Event} [event]
	   *        The `keydown`, `tap`, or `click` event that caused this function to be
	   *        called.
	   *
	   * @listens tap
	   * @listens click
	   */
	
	
	  CaptionSettingsMenuItem.prototype.handleClick = function handleClick(event) {
	    this.player().getChild('textTrackSettings').open();
	  };
	
	  return CaptionSettingsMenuItem;
	}(TextTrackMenuItem);
	
	Component.registerComponent('CaptionSettingsMenuItem', CaptionSettingsMenuItem);
	
	/**
	 * @file captions-button.js
	 */
	
	/**
	 * The button component for toggling and selecting captions
	 *
	 * @extends TextTrackButton
	 */
	
	var CaptionsButton = function (_TextTrackButton) {
	  inherits(CaptionsButton, _TextTrackButton);
	
	  /**
	   * Creates an instance of this class.
	   *
	   * @param {Player} player
	   *        The `Player` that this class should be attached to.
	   *
	   * @param {Object} [options]
	   *        The key/value store of player options.
	   *
	   * @param {Component~ReadyCallback} [ready]
	   *        The function to call when this component is ready.
	   */
	  function CaptionsButton(player, options, ready) {
	    classCallCheck(this, CaptionsButton);
	    return possibleConstructorReturn(this, _TextTrackButton.call(this, player, options, ready));
	  }
	
	  /**
	   * Builds the default DOM `className`.
	   *
	   * @return {string}
	   *         The DOM `className` for this object.
	   */
	
	
	  CaptionsButton.prototype.buildCSSClass = function buildCSSClass() {
	    return 'vjs-captions-button ' + _TextTrackButton.prototype.buildCSSClass.call(this);
	  };
	
	  CaptionsButton.prototype.buildWrapperCSSClass = function buildWrapperCSSClass() {
	    return 'vjs-captions-button ' + _TextTrackButton.prototype.buildWrapperCSSClass.call(this);
	  };
	
	  /**
	   * Create caption menu items
	   *
	   * @return {CaptionSettingsMenuItem[]}
	   *         The array of current menu items.
	   */
	
	
	  CaptionsButton.prototype.createItems = function createItems() {
	    var items = [];
	
	    if (!(this.player().tech_ && this.player().tech_.featuresNativeTextTracks) && this.player().getChild('textTrackSettings')) {
	      items.push(new CaptionSettingsMenuItem(this.player_, { kind: this.kind_ }));
	
	      this.hideThreshold_ += 1;
	    }
	
	    return _TextTrackButton.prototype.createItems.call(this, items);
	  };
	
	  return CaptionsButton;
	}(TextTrackButton);
	
	/**
	 * `kind` of TextTrack to look for to associate it with this menu.
	 *
	 * @type {string}
	 * @private
	 */
	
	
	CaptionsButton.prototype.kind_ = 'captions';
	
	/**
	 * The text that should display over the `CaptionsButton`s controls. Added for localization.
	 *
	 * @type {string}
	 * @private
	 */
	CaptionsButton.prototype.controlText_ = 'Captions';
	
	Component.registerComponent('CaptionsButton', CaptionsButton);
	
	/**
	 * @file subs-caps-menu-item.js
	 */
	
	/**
	 * SubsCapsMenuItem has an [cc] icon to distinguish captions from subtitles
	 * in the SubsCapsMenu.
	 *
	 * @extends TextTrackMenuItem
	 */
	
	var SubsCapsMenuItem = function (_TextTrackMenuItem) {
	  inherits(SubsCapsMenuItem, _TextTrackMenuItem);
	
	  function SubsCapsMenuItem() {
	    classCallCheck(this, SubsCapsMenuItem);
	    return possibleConstructorReturn(this, _TextTrackMenuItem.apply(this, arguments));
	  }
	
	  SubsCapsMenuItem.prototype.createEl = function createEl(type, props, attrs) {
	    var innerHTML = '<span class="vjs-menu-item-text">' + this.localize(this.options_.label);
	
	    if (this.options_.track.kind === 'captions') {
	      innerHTML += '\n        <span aria-hidden="true" class="vjs-icon-placeholder"></span>\n        <span class="vjs-control-text"> ' + this.localize('Captions') + '</span>\n      ';
	    }
	
	    innerHTML += '</span>';
	
	    var el = _TextTrackMenuItem.prototype.createEl.call(this, type, assign({
	      innerHTML: innerHTML
	    }, props), attrs);
	
	    return el;
	  };
	
	  return SubsCapsMenuItem;
	}(TextTrackMenuItem);
	
	Component.registerComponent('SubsCapsMenuItem', SubsCapsMenuItem);
	
	/**
	 * @file sub-caps-button.js
	 */
	/**
	 * The button component for toggling and selecting captions and/or subtitles
	 *
	 * @extends TextTrackButton
	 */
	
	var SubsCapsButton = function (_TextTrackButton) {
	  inherits(SubsCapsButton, _TextTrackButton);
	
	  function SubsCapsButton(player) {
	    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	    classCallCheck(this, SubsCapsButton);
	
	    // Although North America uses "captions" in most cases for
	    // "captions and subtitles" other locales use "subtitles"
	    var _this = possibleConstructorReturn(this, _TextTrackButton.call(this, player, options));
	
	    _this.label_ = 'subtitles';
	    if (['en', 'en-us', 'en-ca', 'fr-ca'].indexOf(_this.player_.language_) > -1) {
	      _this.label_ = 'captions';
	    }
	    _this.menuButton_.controlText(toTitleCase(_this.label_));
	    return _this;
	  }
	
	  /**
	   * Builds the default DOM `className`.
	   *
	   * @return {string}
	   *         The DOM `className` for this object.
	   */
	
	
	  SubsCapsButton.prototype.buildCSSClass = function buildCSSClass() {
	    return 'vjs-subs-caps-button ' + _TextTrackButton.prototype.buildCSSClass.call(this);
	  };
	
	  SubsCapsButton.prototype.buildWrapperCSSClass = function buildWrapperCSSClass() {
	    return 'vjs-subs-caps-button ' + _TextTrackButton.prototype.buildWrapperCSSClass.call(this);
	  };
	
	  /**
	   * Create caption/subtitles menu items
	   *
	   * @return {CaptionSettingsMenuItem[]}
	   *         The array of current menu items.
	   */
	
	
	  SubsCapsButton.prototype.createItems = function createItems() {
	    var items = [];
	
	    if (!(this.player().tech_ && this.player().tech_.featuresNativeTextTracks) && this.player().getChild('textTrackSettings')) {
	      items.push(new CaptionSettingsMenuItem(this.player_, { kind: this.label_ }));
	
	      this.hideThreshold_ += 1;
	    }
	
	    items = _TextTrackButton.prototype.createItems.call(this, items, SubsCapsMenuItem);
	    return items;
	  };
	
	  return SubsCapsButton;
	}(TextTrackButton);
	
	/**
	 * `kind`s of TextTrack to look for to associate it with this menu.
	 *
	 * @type {array}
	 * @private
	 */
	
	
	SubsCapsButton.prototype.kinds_ = ['captions', 'subtitles'];
	
	/**
	 * The text that should display over the `SubsCapsButton`s controls.
	 *
	 *
	 * @type {string}
	 * @private
	 */
	SubsCapsButton.prototype.controlText_ = 'Subtitles';
	
	Component.registerComponent('SubsCapsButton', SubsCapsButton);
	
	/**
	 * @file audio-track-menu-item.js
	 */
	
	/**
	 * An {@link AudioTrack} {@link MenuItem}
	 *
	 * @extends MenuItem
	 */
	
	var AudioTrackMenuItem = function (_MenuItem) {
	  inherits(AudioTrackMenuItem, _MenuItem);
	
	  /**
	   * Creates an instance of this class.
	   *
	   * @param {Player} player
	   *        The `Player` that this class should be attached to.
	   *
	   * @param {Object} [options]
	   *        The key/value store of player options.
	   */
	  function AudioTrackMenuItem(player, options) {
	    classCallCheck(this, AudioTrackMenuItem);
	
	    var track = options.track;
	    var tracks = player.audioTracks();
	
	    // Modify options for parent MenuItem class's init.
	    options.label = track.label || track.language || 'Unknown';
	    options.selected = track.enabled;
	
	    var _this = possibleConstructorReturn(this, _MenuItem.call(this, player, options));
	
	    _this.track = track;
	
	    _this.addClass('vjs-' + track.kind + '-menu-item');
	
	    var changeHandler = function changeHandler() {
	      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	        args[_key] = arguments[_key];
	      }
	
	      _this.handleTracksChange.apply(_this, args);
	    };
	
	    tracks.addEventListener('change', changeHandler);
	    _this.on('dispose', function () {
	      tracks.removeEventListener('change', changeHandler);
	    });
	    return _this;
	  }
	
	  AudioTrackMenuItem.prototype.createEl = function createEl(type, props, attrs) {
	    var innerHTML = '<span class="vjs-menu-item-text">' + this.localize(this.options_.label);
	
	    if (this.options_.track.kind === 'main-desc') {
	      innerHTML += '\n        <span aria-hidden="true" class="vjs-icon-placeholder"></span>\n        <span class="vjs-control-text"> ' + this.localize('Descriptions') + '</span>\n      ';
	    }
	
	    innerHTML += '</span>';
	
	    var el = _MenuItem.prototype.createEl.call(this, type, assign({
	      innerHTML: innerHTML
	    }, props), attrs);
	
	    return el;
	  };
	
	  /**
	   * This gets called when an `AudioTrackMenuItem is "clicked". See {@link ClickableComponent}
	   * for more detailed information on what a click can be.
	   *
	   * @param {EventTarget~Event} [event]
	   *        The `keydown`, `tap`, or `click` event that caused this function to be
	   *        called.
	   *
	   * @listens tap
	   * @listens click
	   */
	
	
	  AudioTrackMenuItem.prototype.handleClick = function handleClick(event) {
	    var tracks = this.player_.audioTracks();
	
	    _MenuItem.prototype.handleClick.call(this, event);
	
	    for (var i = 0; i < tracks.length; i++) {
	      var track = tracks[i];
	
	      track.enabled = track === this.track;
	    }
	  };
	
	  /**
	   * Handle any {@link AudioTrack} change.
	   *
	   * @param {EventTarget~Event} [event]
	   *        The {@link AudioTrackList#change} event that caused this to run.
	   *
	   * @listens AudioTrackList#change
	   */
	
	
	  AudioTrackMenuItem.prototype.handleTracksChange = function handleTracksChange(event) {
	    this.selected(this.track.enabled);
	  };
	
	  return AudioTrackMenuItem;
	}(MenuItem);
	
	Component.registerComponent('AudioTrackMenuItem', AudioTrackMenuItem);
	
	/**
	 * @file audio-track-button.js
	 */
	
	/**
	 * The base class for buttons that toggle specific {@link AudioTrack} types.
	 *
	 * @extends TrackButton
	 */
	
	var AudioTrackButton = function (_TrackButton) {
	  inherits(AudioTrackButton, _TrackButton);
	
	  /**
	   * Creates an instance of this class.
	   *
	   * @param {Player} player
	   *        The `Player` that this class should be attached to.
	   *
	   * @param {Object} [options={}]
	   *        The key/value store of player options.
	   */
	  function AudioTrackButton(player) {
	    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	    classCallCheck(this, AudioTrackButton);
	
	    options.tracks = player.audioTracks();
	
	    return possibleConstructorReturn(this, _TrackButton.call(this, player, options));
	  }
	
	  /**
	   * Builds the default DOM `className`.
	   *
	   * @return {string}
	   *         The DOM `className` for this object.
	   */
	
	
	  AudioTrackButton.prototype.buildCSSClass = function buildCSSClass() {
	    return 'vjs-audio-button ' + _TrackButton.prototype.buildCSSClass.call(this);
	  };
	
	  AudioTrackButton.prototype.buildWrapperCSSClass = function buildWrapperCSSClass() {
	    return 'vjs-audio-button ' + _TrackButton.prototype.buildWrapperCSSClass.call(this);
	  };
	
	  /**
	   * Create a menu item for each audio track
	   *
	   * @param {AudioTrackMenuItem[]} [items=[]]
	   *        An array of existing menu items to use.
	   *
	   * @return {AudioTrackMenuItem[]}
	   *         An array of menu items
	   */
	
	
	  AudioTrackButton.prototype.createItems = function createItems() {
	    var items = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	
	    // if there's only one audio track, there no point in showing it
	    this.hideThreshold_ = 1;
	
	    var tracks = this.player_.audioTracks();
	
	    for (var i = 0; i < tracks.length; i++) {
	      var track = tracks[i];
	
	      items.push(new AudioTrackMenuItem(this.player_, {
	        track: track,
	        // MenuItem is selectable
	        selectable: true,
	        // MenuItem is NOT multiSelectable (i.e. only one can be marked "selected" at a time)
	        multiSelectable: false
	      }));
	    }
	
	    return items;
	  };
	
	  return AudioTrackButton;
	}(TrackButton);
	
	/**
	 * The text that should display over the `AudioTrackButton`s controls. Added for localization.
	 *
	 * @type {string}
	 * @private
	 */
	
	
	AudioTrackButton.prototype.controlText_ = 'Audio Track';
	Component.registerComponent('AudioTrackButton', AudioTrackButton);
	
	/**
	 * @file playback-rate-menu-item.js
	 */
	
	/**
	 * The specific menu item type for selecting a playback rate.
	 *
	 * @extends MenuItem
	 */
	
	var PlaybackRateMenuItem = function (_MenuItem) {
	  inherits(PlaybackRateMenuItem, _MenuItem);
	
	  /**
	   * Creates an instance of this class.
	   *
	   * @param {Player} player
	   *        The `Player` that this class should be attached to.
	   *
	   * @param {Object} [options]
	   *        The key/value store of player options.
	   */
	  function PlaybackRateMenuItem(player, options) {
	    classCallCheck(this, PlaybackRateMenuItem);
	
	    var label = options.rate;
	    var rate = parseFloat(label, 10);
	
	    // Modify options for parent MenuItem class's init.
	    options.label = label;
	    options.selected = rate === 1;
	    options.selectable = true;
	    options.multiSelectable = false;
	
	    var _this = possibleConstructorReturn(this, _MenuItem.call(this, player, options));
	
	    _this.label = label;
	    _this.rate = rate;
	
	    _this.on(player, 'ratechange', _this.update);
	    return _this;
	  }
	
	  /**
	   * This gets called when an `PlaybackRateMenuItem` is "clicked". See
	   * {@link ClickableComponent} for more detailed information on what a click can be.
	   *
	   * @param {EventTarget~Event} [event]
	   *        The `keydown`, `tap`, or `click` event that caused this function to be
	   *        called.
	   *
	   * @listens tap
	   * @listens click
	   */
	
	
	  PlaybackRateMenuItem.prototype.handleClick = function handleClick(event) {
	    _MenuItem.prototype.handleClick.call(this);
	    this.player().playbackRate(this.rate);
	  };
	
	  /**
	   * Update the PlaybackRateMenuItem when the playbackrate changes.
	   *
	   * @param {EventTarget~Event} [event]
	   *        The `ratechange` event that caused this function to run.
	   *
	   * @listens Player#ratechange
	   */
	
	
	  PlaybackRateMenuItem.prototype.update = function update(event) {
	    this.selected(this.player().playbackRate() === this.rate);
	  };
	
	  return PlaybackRateMenuItem;
	}(MenuItem);
	
	/**
	 * The text that should display over the `PlaybackRateMenuItem`s controls. Added for localization.
	 *
	 * @type {string}
	 * @private
	 */
	
	
	PlaybackRateMenuItem.prototype.contentElType = 'button';
	
	Component.registerComponent('PlaybackRateMenuItem', PlaybackRateMenuItem);
	
	/**
	 * @file playback-rate-menu-button.js
	 */
	
	/**
	 * The component for controlling the playback rate.
	 *
	 * @extends MenuButton
	 */
	
	var PlaybackRateMenuButton = function (_MenuButton) {
	  inherits(PlaybackRateMenuButton, _MenuButton);
	
	  /**
	   * Creates an instance of this class.
	   *
	   * @param {Player} player
	   *        The `Player` that this class should be attached to.
	   *
	   * @param {Object} [options]
	   *        The key/value store of player options.
	   */
	  function PlaybackRateMenuButton(player, options) {
	    classCallCheck(this, PlaybackRateMenuButton);
	
	    var _this = possibleConstructorReturn(this, _MenuButton.call(this, player, options));
	
	    _this.updateVisibility();
	    _this.updateLabel();
	
	    _this.on(player, 'loadstart', _this.updateVisibility);
	    _this.on(player, 'ratechange', _this.updateLabel);
	    return _this;
	  }
	
	  /**
	   * Create the `Component`'s DOM element
	   *
	   * @return {Element}
	   *         The element that was created.
	   */
	
	
	  PlaybackRateMenuButton.prototype.createEl = function createEl$$1() {
	    var el = _MenuButton.prototype.createEl.call(this);
	
	    this.labelEl_ = createEl('div', {
	      className: 'vjs-playback-rate-value',
	      innerHTML: '1x'
	    });
	
	    el.appendChild(this.labelEl_);
	
	    return el;
	  };
	
	  PlaybackRateMenuButton.prototype.dispose = function dispose() {
	    this.labelEl_ = null;
	
	    _MenuButton.prototype.dispose.call(this);
	  };
	
	  /**
	   * Builds the default DOM `className`.
	   *
	   * @return {string}
	   *         The DOM `className` for this object.
	   */
	
	
	  PlaybackRateMenuButton.prototype.buildCSSClass = function buildCSSClass() {
	    return 'vjs-playback-rate ' + _MenuButton.prototype.buildCSSClass.call(this);
	  };
	
	  PlaybackRateMenuButton.prototype.buildWrapperCSSClass = function buildWrapperCSSClass() {
	    return 'vjs-playback-rate ' + _MenuButton.prototype.buildWrapperCSSClass.call(this);
	  };
	
	  /**
	   * Create the playback rate menu
	   *
	   * @return {Menu}
	   *         Menu object populated with {@link PlaybackRateMenuItem}s
	   */
	
	
	  PlaybackRateMenuButton.prototype.createMenu = function createMenu() {
	    var menu = new Menu(this.player());
	    var rates = this.playbackRates();
	
	    if (rates) {
	      for (var i = rates.length - 1; i >= 0; i--) {
	        menu.addChild(new PlaybackRateMenuItem(this.player(), { rate: rates[i] + 'x' }));
	      }
	    }
	
	    return menu;
	  };
	
	  /**
	   * Updates ARIA accessibility attributes
	   */
	
	
	  PlaybackRateMenuButton.prototype.updateARIAAttributes = function updateARIAAttributes() {
	    // Current playback rate
	    this.el().setAttribute('aria-valuenow', this.player().playbackRate());
	  };
	
	  /**
	   * This gets called when an `PlaybackRateMenuButton` is "clicked". See
	   * {@link ClickableComponent} for more detailed information on what a click can be.
	   *
	   * @param {EventTarget~Event} [event]
	   *        The `keydown`, `tap`, or `click` event that caused this function to be
	   *        called.
	   *
	   * @listens tap
	   * @listens click
	   */
	
	
	  PlaybackRateMenuButton.prototype.handleClick = function handleClick(event) {
	    // select next rate option
	    var currentRate = this.player().playbackRate();
	    var rates = this.playbackRates();
	
	    // this will select first one if the last one currently selected
	    var newRate = rates[0];
	
	    for (var i = 0; i < rates.length; i++) {
	      if (rates[i] > currentRate) {
	        newRate = rates[i];
	        break;
	      }
	    }
	    this.player().playbackRate(newRate);
	  };
	
	  /**
	   * Get possible playback rates
	   *
	   * @return {Array}
	   *         All possible playback rates
	   */
	
	
	  PlaybackRateMenuButton.prototype.playbackRates = function playbackRates() {
	    return this.options_.playbackRates || this.options_.playerOptions && this.options_.playerOptions.playbackRates;
	  };
	
	  /**
	   * Get whether playback rates is supported by the tech
	   * and an array of playback rates exists
	   *
	   * @return {boolean}
	   *         Whether changing playback rate is supported
	   */
	
	
	  PlaybackRateMenuButton.prototype.playbackRateSupported = function playbackRateSupported() {
	    return this.player().tech_ && this.player().tech_.featuresPlaybackRate && this.playbackRates() && this.playbackRates().length > 0;
	  };
	
	  /**
	   * Hide playback rate controls when they're no playback rate options to select
	   *
	   * @param {EventTarget~Event} [event]
	   *        The event that caused this function to run.
	   *
	   * @listens Player#loadstart
	   */
	
	
	  PlaybackRateMenuButton.prototype.updateVisibility = function updateVisibility(event) {
	    if (this.playbackRateSupported()) {
	      this.removeClass('vjs-hidden');
	    } else {
	      this.addClass('vjs-hidden');
	    }
	  };
	
	  /**
	   * Update button label when rate changed
	   *
	   * @param {EventTarget~Event} [event]
	   *        The event that caused this function to run.
	   *
	   * @listens Player#ratechange
	   */
	
	
	  PlaybackRateMenuButton.prototype.updateLabel = function updateLabel(event) {
	    if (this.playbackRateSupported()) {
	      this.labelEl_.innerHTML = this.player().playbackRate() + 'x';
	    }
	  };
	
	  return PlaybackRateMenuButton;
	}(MenuButton);
	
	/**
	 * The text that should display over the `FullscreenToggle`s controls. Added for localization.
	 *
	 * @type {string}
	 * @private
	 */
	
	
	PlaybackRateMenuButton.prototype.controlText_ = 'Playback Rate';
	
	Component.registerComponent('PlaybackRateMenuButton', PlaybackRateMenuButton);
	
	/**
	 * @file spacer.js
	 */
	
	/**
	 * Just an empty spacer element that can be used as an append point for plugins, etc.
	 * Also can be used to create space between elements when necessary.
	 *
	 * @extends Component
	 */
	
	var Spacer = function (_Component) {
	  inherits(Spacer, _Component);
	
	  function Spacer() {
	    classCallCheck(this, Spacer);
	    return possibleConstructorReturn(this, _Component.apply(this, arguments));
	  }
	
	  /**
	   * Builds the default DOM `className`.
	   *
	   * @return {string}
	   *         The DOM `className` for this object.
	   */
	  Spacer.prototype.buildCSSClass = function buildCSSClass() {
	    return 'vjs-spacer ' + _Component.prototype.buildCSSClass.call(this);
	  };
	
	  /**
	   * Create the `Component`'s DOM element
	   *
	   * @return {Element}
	   *         The element that was created.
	   */
	
	
	  Spacer.prototype.createEl = function createEl() {
	    return _Component.prototype.createEl.call(this, 'div', {
	      className: this.buildCSSClass()
	    });
	  };
	
	  return Spacer;
	}(Component);
	
	Component.registerComponent('Spacer', Spacer);
	
	/**
	 * @file custom-control-spacer.js
	 */
	
	/**
	 * Spacer specifically meant to be used as an insertion point for new plugins, etc.
	 *
	 * @extends Spacer
	 */
	
	var CustomControlSpacer = function (_Spacer) {
	  inherits(CustomControlSpacer, _Spacer);
	
	  function CustomControlSpacer() {
	    classCallCheck(this, CustomControlSpacer);
	    return possibleConstructorReturn(this, _Spacer.apply(this, arguments));
	  }
	
	  /**
	   * Builds the default DOM `className`.
	   *
	   * @return {string}
	   *         The DOM `className` for this object.
	   */
	  CustomControlSpacer.prototype.buildCSSClass = function buildCSSClass() {
	    return 'vjs-custom-control-spacer ' + _Spacer.prototype.buildCSSClass.call(this);
	  };
	
	  /**
	   * Create the `Component`'s DOM element
	   *
	   * @return {Element}
	   *         The element that was created.
	   */
	
	
	  CustomControlSpacer.prototype.createEl = function createEl() {
	    var el = _Spacer.prototype.createEl.call(this, {
	      className: this.buildCSSClass()
	    });
	
	    // No-flex/table-cell mode requires there be some content
	    // in the cell to fill the remaining space of the table.
	    el.innerHTML = '\xA0';
	    return el;
	  };
	
	  return CustomControlSpacer;
	}(Spacer);
	
	Component.registerComponent('CustomControlSpacer', CustomControlSpacer);
	
	/**
	 * @file control-bar.js
	 */
	
	/**
	 * Container of main controls.
	 *
	 * @extends Component
	 */
	
	var ControlBar = function (_Component) {
	  inherits(ControlBar, _Component);
	
	  function ControlBar() {
	    classCallCheck(this, ControlBar);
	    return possibleConstructorReturn(this, _Component.apply(this, arguments));
	  }
	
	  /**
	   * Create the `Component`'s DOM element
	   *
	   * @return {Element}
	   *         The element that was created.
	   */
	  ControlBar.prototype.createEl = function createEl() {
	    return _Component.prototype.createEl.call(this, 'div', {
	      className: 'vjs-control-bar',
	      dir: 'ltr'
	    });
	  };
	
	  return ControlBar;
	}(Component);
	
	/**
	 * Default options for `ControlBar`
	 *
	 * @type {Object}
	 * @private
	 */
	
	
	ControlBar.prototype.options_ = {
	  children: ['playToggle', 'volumePanel', 'currentTimeDisplay', 'timeDivider', 'durationDisplay', 'progressControl', 'liveDisplay', 'remainingTimeDisplay', 'customControlSpacer', 'playbackRateMenuButton', 'chaptersButton', 'descriptionsButton', 'subsCapsButton', 'audioTrackButton', 'fullscreenToggle']
	};
	
	Component.registerComponent('ControlBar', ControlBar);
	
	/**
	 * @file error-display.js
	 */
	
	/**
	 * A display that indicates an error has occurred. This means that the video
	 * is unplayable.
	 *
	 * @extends ModalDialog
	 */
	
	var ErrorDisplay = function (_ModalDialog) {
	  inherits(ErrorDisplay, _ModalDialog);
	
	  /**
	   * Creates an instance of this class.
	   *
	   * @param  {Player} player
	   *         The `Player` that this class should be attached to.
	   *
	   * @param  {Object} [options]
	   *         The key/value store of player options.
	   */
	  function ErrorDisplay(player, options) {
	    classCallCheck(this, ErrorDisplay);
	
	    var _this = possibleConstructorReturn(this, _ModalDialog.call(this, player, options));
	
	    _this.on(player, 'error', _this.open);
	    return _this;
	  }
	
	  /**
	   * Builds the default DOM `className`.
	   *
	   * @return {string}
	   *         The DOM `className` for this object.
	   *
	   * @deprecated Since version 5.
	   */
	
	
	  ErrorDisplay.prototype.buildCSSClass = function buildCSSClass() {
	    return 'vjs-error-display ' + _ModalDialog.prototype.buildCSSClass.call(this);
	  };
	
	  /**
	   * Gets the localized error message based on the `Player`s error.
	   *
	   * @return {string}
	   *         The `Player`s error message localized or an empty string.
	   */
	
	
	  ErrorDisplay.prototype.content = function content() {
	    var error = this.player().error();
	
	    return error ? this.localize(error.message) : '';
	  };
	
	  return ErrorDisplay;
	}(ModalDialog);
	
	/**
	 * The default options for an `ErrorDisplay`.
	 *
	 * @private
	 */
	
	
	ErrorDisplay.prototype.options_ = mergeOptions(ModalDialog.prototype.options_, {
	  pauseOnOpen: false,
	  fillAlways: true,
	  temporary: false,
	  uncloseable: true
	});
	
	Component.registerComponent('ErrorDisplay', ErrorDisplay);
	
	/**
	 * @file text-track-settings.js
	 */
	
	var LOCAL_STORAGE_KEY = 'vjs-text-track-settings';
	
	var COLOR_BLACK = ['#000', 'Black'];
	var COLOR_BLUE = ['#00F', 'Blue'];
	var COLOR_CYAN = ['#0FF', 'Cyan'];
	var COLOR_GREEN = ['#0F0', 'Green'];
	var COLOR_MAGENTA = ['#F0F', 'Magenta'];
	var COLOR_RED = ['#F00', 'Red'];
	var COLOR_WHITE = ['#FFF', 'White'];
	var COLOR_YELLOW = ['#FF0', 'Yellow'];
	
	var OPACITY_OPAQUE = ['1', 'Opaque'];
	var OPACITY_SEMI = ['0.5', 'Semi-Transparent'];
	var OPACITY_TRANS = ['0', 'Transparent'];
	
	// Configuration for the various <select> elements in the DOM of this component.
	//
	// Possible keys include:
	//
	// `default`:
	//   The default option index. Only needs to be provided if not zero.
	// `parser`:
	//   A function which is used to parse the value from the selected option in
	//   a customized way.
	// `selector`:
	//   The selector used to find the associated <select> element.
	var selectConfigs = {
	  backgroundColor: {
	    selector: '.vjs-bg-color > select',
	    id: 'captions-background-color-%s',
	    label: 'Color',
	    options: [COLOR_BLACK, COLOR_WHITE, COLOR_RED, COLOR_GREEN, COLOR_BLUE, COLOR_YELLOW, COLOR_MAGENTA, COLOR_CYAN]
	  },
	
	  backgroundOpacity: {
	    selector: '.vjs-bg-opacity > select',
	    id: 'captions-background-opacity-%s',
	    label: 'Transparency',
	    options: [OPACITY_OPAQUE, OPACITY_SEMI, OPACITY_TRANS]
	  },
	
	  color: {
	    selector: '.vjs-fg-color > select',
	    id: 'captions-foreground-color-%s',
	    label: 'Color',
	    options: [COLOR_WHITE, COLOR_BLACK, COLOR_RED, COLOR_GREEN, COLOR_BLUE, COLOR_YELLOW, COLOR_MAGENTA, COLOR_CYAN]
	  },
	
	  edgeStyle: {
	    selector: '.vjs-edge-style > select',
	    id: '%s',
	    label: 'Text Edge Style',
	    options: [['none', 'None'], ['raised', 'Raised'], ['depressed', 'Depressed'], ['uniform', 'Uniform'], ['dropshadow', 'Dropshadow']]
	  },
	
	  fontFamily: {
	    selector: '.vjs-font-family > select',
	    id: 'captions-font-family-%s',
	    label: 'Font Family',
	    options: [['proportionalSansSerif', 'Proportional Sans-Serif'], ['monospaceSansSerif', 'Monospace Sans-Serif'], ['proportionalSerif', 'Proportional Serif'], ['monospaceSerif', 'Monospace Serif'], ['casual', 'Casual'], ['script', 'Script'], ['small-caps', 'Small Caps']]
	  },
	
	  fontPercent: {
	    selector: '.vjs-font-percent > select',
	    id: 'captions-font-size-%s',
	    label: 'Font Size',
	    options: [['0.50', '50%'], ['0.75', '75%'], ['1.00', '100%'], ['1.25', '125%'], ['1.50', '150%'], ['1.75', '175%'], ['2.00', '200%'], ['3.00', '300%'], ['4.00', '400%']],
	    default: 2,
	    parser: function parser(v) {
	      return v === '1.00' ? null : Number(v);
	    }
	  },
	
	  textOpacity: {
	    selector: '.vjs-text-opacity > select',
	    id: 'captions-foreground-opacity-%s',
	    label: 'Transparency',
	    options: [OPACITY_OPAQUE, OPACITY_SEMI]
	  },
	
	  // Options for this object are defined below.
	  windowColor: {
	    selector: '.vjs-window-color > select',
	    id: 'captions-window-color-%s',
	    label: 'Color'
	  },
	
	  // Options for this object are defined below.
	  windowOpacity: {
	    selector: '.vjs-window-opacity > select',
	    id: 'captions-window-opacity-%s',
	    label: 'Transparency',
	    options: [OPACITY_TRANS, OPACITY_SEMI, OPACITY_OPAQUE]
	  }
	};
	
	selectConfigs.windowColor.options = selectConfigs.backgroundColor.options;
	
	/**
	 * Get the actual value of an option.
	 *
	 * @param  {string} value
	 *         The value to get
	 *
	 * @param  {Function} [parser]
	 *         Optional function to adjust the value.
	 *
	 * @return {Mixed}
	 *         - Will be `undefined` if no value exists
	 *         - Will be `undefined` if the given value is "none".
	 *         - Will be the actual value otherwise.
	 *
	 * @private
	 */
	function parseOptionValue(value, parser) {
	  if (parser) {
	    value = parser(value);
	  }
	
	  if (value && value !== 'none') {
	    return value;
	  }
	}
	
	/**
	 * Gets the value of the selected <option> element within a <select> element.
	 *
	 * @param  {Element} el
	 *         the element to look in
	 *
	 * @param  {Function} [parser]
	 *         Optional function to adjust the value.
	 *
	 * @return {Mixed}
	 *         - Will be `undefined` if no value exists
	 *         - Will be `undefined` if the given value is "none".
	 *         - Will be the actual value otherwise.
	 *
	 * @private
	 */
	function getSelectedOptionValue(el, parser) {
	  var value = el.options[el.options.selectedIndex].value;
	
	  return parseOptionValue(value, parser);
	}
	
	/**
	 * Sets the selected <option> element within a <select> element based on a
	 * given value.
	 *
	 * @param {Element} el
	 *        The element to look in.
	 *
	 * @param {string} value
	 *        the property to look on.
	 *
	 * @param {Function} [parser]
	 *        Optional function to adjust the value before comparing.
	 *
	 * @private
	 */
	function setSelectedOption(el, value, parser) {
	  if (!value) {
	    return;
	  }
	
	  for (var i = 0; i < el.options.length; i++) {
	    if (parseOptionValue(el.options[i].value, parser) === value) {
	      el.selectedIndex = i;
	      break;
	    }
	  }
	}
	
	/**
	 * Manipulate Text Tracks settings.
	 *
	 * @extends ModalDialog
	 */
	
	var TextTrackSettings = function (_ModalDialog) {
	  inherits(TextTrackSettings, _ModalDialog);
	
	  /**
	   * Creates an instance of this class.
	   *
	   * @param {Player} player
	   *         The `Player` that this class should be attached to.
	   *
	   * @param {Object} [options]
	   *         The key/value store of player options.
	   */
	  function TextTrackSettings(player, options) {
	    classCallCheck(this, TextTrackSettings);
	
	    options.temporary = false;
	
	    var _this = possibleConstructorReturn(this, _ModalDialog.call(this, player, options));
	
	    _this.updateDisplay = bind(_this, _this.updateDisplay);
	
	    // fill the modal and pretend we have opened it
	    _this.fill();
	    _this.hasBeenOpened_ = _this.hasBeenFilled_ = true;
	
	    _this.endDialog = createEl('p', {
	      className: 'vjs-control-text',
	      textContent: _this.localize('End of dialog window.')
	    });
	    _this.el().appendChild(_this.endDialog);
	
	    _this.setDefaults();
	
	    // Grab `persistTextTrackSettings` from the player options if not passed in child options
	    if (options.persistTextTrackSettings === undefined) {
	      _this.options_.persistTextTrackSettings = _this.options_.playerOptions.persistTextTrackSettings;
	    }
	
	    _this.on(_this.$('.vjs-done-button'), 'click', function () {
	      _this.saveSettings();
	      _this.close();
	    });
	
	    _this.on(_this.$('.vjs-default-button'), 'click', function () {
	      _this.setDefaults();
	      _this.updateDisplay();
	    });
	
	    each(selectConfigs, function (config) {
	      _this.on(_this.$(config.selector), 'change', _this.updateDisplay);
	    });
	
	    if (_this.options_.persistTextTrackSettings) {
	      _this.restoreSettings();
	    }
	    return _this;
	  }
	
	  TextTrackSettings.prototype.dispose = function dispose() {
	    this.endDialog = null;
	
	    _ModalDialog.prototype.dispose.call(this);
	  };
	
	  /**
	   * Create a <select> element with configured options.
	   *
	   * @param {string} key
	   *        Configuration key to use during creation.
	   *
	   * @return {string}
	   *         An HTML string.
	   *
	   * @private
	   */
	
	
	  TextTrackSettings.prototype.createElSelect_ = function createElSelect_(key) {
	    var _this2 = this;
	
	    var legendId = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
	    var type = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'label';
	
	    var config = selectConfigs[key];
	    var id = config.id.replace('%s', this.id_);
	    var selectLabelledbyIds = [legendId, id].join(' ').trim();
	
	    return ['<' + type + ' id="' + id + '" class="' + (type === 'label' ? 'vjs-label' : '') + '">', this.localize(config.label), '</' + type + '>', '<select aria-labelledby="' + selectLabelledbyIds + '">'].concat(config.options.map(function (o) {
	      var optionId = id + '-' + o[1].replace(/\W+/g, '');
	
	      return ['<option id="' + optionId + '" value="' + o[0] + '" ', 'aria-labelledby="' + selectLabelledbyIds + ' ' + optionId + '">', _this2.localize(o[1]), '</option>'].join('');
	    })).concat('</select>').join('');
	  };
	
	  /**
	   * Create foreground color element for the component
	   *
	   * @return {string}
	   *         An HTML string.
	   *
	   * @private
	   */
	
	
	  TextTrackSettings.prototype.createElFgColor_ = function createElFgColor_() {
	    var legendId = 'captions-text-legend-' + this.id_;
	
	    return ['<fieldset class="vjs-fg-color vjs-track-setting">', '<legend id="' + legendId + '">', this.localize('Text'), '</legend>', this.createElSelect_('color', legendId), '<span class="vjs-text-opacity vjs-opacity">', this.createElSelect_('textOpacity', legendId), '</span>', '</fieldset>'].join('');
	  };
	
	  /**
	   * Create background color element for the component
	   *
	   * @return {string}
	   *         An HTML string.
	   *
	   * @private
	   */
	
	
	  TextTrackSettings.prototype.createElBgColor_ = function createElBgColor_() {
	    var legendId = 'captions-background-' + this.id_;
	
	    return ['<fieldset class="vjs-bg-color vjs-track-setting">', '<legend id="' + legendId + '">', this.localize('Background'), '</legend>', this.createElSelect_('backgroundColor', legendId), '<span class="vjs-bg-opacity vjs-opacity">', this.createElSelect_('backgroundOpacity', legendId), '</span>', '</fieldset>'].join('');
	  };
	
	  /**
	   * Create window color element for the component
	   *
	   * @return {string}
	   *         An HTML string.
	   *
	   * @private
	   */
	
	
	  TextTrackSettings.prototype.createElWinColor_ = function createElWinColor_() {
	    var legendId = 'captions-window-' + this.id_;
	
	    return ['<fieldset class="vjs-window-color vjs-track-setting">', '<legend id="' + legendId + '">', this.localize('Window'), '</legend>', this.createElSelect_('windowColor', legendId), '<span class="vjs-window-opacity vjs-opacity">', this.createElSelect_('windowOpacity', legendId), '</span>', '</fieldset>'].join('');
	  };
	
	  /**
	   * Create color elements for the component
	   *
	   * @return {Element}
	   *         The element that was created
	   *
	   * @private
	   */
	
	
	  TextTrackSettings.prototype.createElColors_ = function createElColors_() {
	    return createEl('div', {
	      className: 'vjs-track-settings-colors',
	      innerHTML: [this.createElFgColor_(), this.createElBgColor_(), this.createElWinColor_()].join('')
	    });
	  };
	
	  /**
	   * Create font elements for the component
	   *
	   * @return {Element}
	   *         The element that was created.
	   *
	   * @private
	   */
	
	
	  TextTrackSettings.prototype.createElFont_ = function createElFont_() {
	    return createEl('div', {
	      className: 'vjs-track-settings-font',
	      innerHTML: ['<fieldset class="vjs-font-percent vjs-track-setting">', this.createElSelect_('fontPercent', '', 'legend'), '</fieldset>', '<fieldset class="vjs-edge-style vjs-track-setting">', this.createElSelect_('edgeStyle', '', 'legend'), '</fieldset>', '<fieldset class="vjs-font-family vjs-track-setting">', this.createElSelect_('fontFamily', '', 'legend'), '</fieldset>'].join('')
	    });
	  };
	
	  /**
	   * Create controls for the component
	   *
	   * @return {Element}
	   *         The element that was created.
	   *
	   * @private
	   */
	
	
	  TextTrackSettings.prototype.createElControls_ = function createElControls_() {
	    var defaultsDescription = this.localize('restore all settings to the default values');
	
	    return createEl('div', {
	      className: 'vjs-track-settings-controls',
	      innerHTML: ['<button class="vjs-default-button" title="' + defaultsDescription + '">', this.localize('Reset'), '<span class="vjs-control-text"> ' + defaultsDescription + '</span>', '</button>', '<button class="vjs-done-button">' + this.localize('Done') + '</button>'].join('')
	    });
	  };
	
	  TextTrackSettings.prototype.content = function content() {
	    return [this.createElColors_(), this.createElFont_(), this.createElControls_()];
	  };
	
	  TextTrackSettings.prototype.label = function label() {
	    return this.localize('Caption Settings Dialog');
	  };
	
	  TextTrackSettings.prototype.description = function description() {
	    return this.localize('Beginning of dialog window. Escape will cancel and close the window.');
	  };
	
	  TextTrackSettings.prototype.buildCSSClass = function buildCSSClass() {
	    return _ModalDialog.prototype.buildCSSClass.call(this) + ' vjs-text-track-settings';
	  };
	
	  /**
	   * Gets an object of text track settings (or null).
	   *
	   * @return {Object}
	   *         An object with config values parsed from the DOM or localStorage.
	   */
	
	
	  TextTrackSettings.prototype.getValues = function getValues() {
	    var _this3 = this;
	
	    return reduce(selectConfigs, function (accum, config, key) {
	      var value = getSelectedOptionValue(_this3.$(config.selector), config.parser);
	
	      if (value !== undefined) {
	        accum[key] = value;
	      }
	
	      return accum;
	    }, {});
	  };
	
	  /**
	   * Sets text track settings from an object of values.
	   *
	   * @param {Object} values
	   *        An object with config values parsed from the DOM or localStorage.
	   */
	
	
	  TextTrackSettings.prototype.setValues = function setValues(values) {
	    var _this4 = this;
	
	    each(selectConfigs, function (config, key) {
	      setSelectedOption(_this4.$(config.selector), values[key], config.parser);
	    });
	  };
	
	  /**
	   * Sets all `<select>` elements to their default values.
	   */
	
	
	  TextTrackSettings.prototype.setDefaults = function setDefaults() {
	    var _this5 = this;
	
	    each(selectConfigs, function (config) {
	      var index = config.hasOwnProperty('default') ? config.default : 0;
	
	      _this5.$(config.selector).selectedIndex = index;
	    });
	  };
	
	  /**
	   * Restore texttrack settings from localStorage
	   */
	
	
	  TextTrackSettings.prototype.restoreSettings = function restoreSettings() {
	    var values = void 0;
	
	    try {
	      values = JSON.parse(window$1.localStorage.getItem(LOCAL_STORAGE_KEY));
	    } catch (err) {
	      log$1.warn(err);
	    }
	
	    if (values) {
	      this.setValues(values);
	    }
	  };
	
	  /**
	   * Save text track settings to localStorage
	   */
	
	
	  TextTrackSettings.prototype.saveSettings = function saveSettings() {
	    if (!this.options_.persistTextTrackSettings) {
	      return;
	    }
	
	    var values = this.getValues();
	
	    try {
	      if (Object.keys(values).length) {
	        window$1.localStorage.setItem(LOCAL_STORAGE_KEY, JSON.stringify(values));
	      } else {
	        window$1.localStorage.removeItem(LOCAL_STORAGE_KEY);
	      }
	    } catch (err) {
	      log$1.warn(err);
	    }
	  };
	
	  /**
	   * Update display of text track settings
	   */
	
	
	  TextTrackSettings.prototype.updateDisplay = function updateDisplay() {
	    var ttDisplay = this.player_.getChild('textTrackDisplay');
	
	    if (ttDisplay) {
	      ttDisplay.updateDisplay();
	    }
	  };
	
	  /**
	   * conditionally blur the element and refocus the captions button
	   *
	   * @private
	   */
	
	
	  TextTrackSettings.prototype.conditionalBlur_ = function conditionalBlur_() {
	    this.previouslyActiveEl_ = null;
	    this.off(document, 'keydown', this.handleKeyDown);
	
	    var cb = this.player_.controlBar;
	    var subsCapsBtn = cb && cb.subsCapsButton;
	    var ccBtn = cb && cb.captionsButton;
	
	    if (subsCapsBtn) {
	      subsCapsBtn.focus();
	    } else if (ccBtn) {
	      ccBtn.focus();
	    }
	  };
	
	  return TextTrackSettings;
	}(ModalDialog);
	
	Component.registerComponent('TextTrackSettings', TextTrackSettings);
	
	/**
	 * @file resize-manager.js
	 */
	
	/**
	 * A Resize Manager. It is in charge of triggering `playerresize` on the player in the right conditions.
	 *
	 * It'll either create an iframe and use a debounced resize handler on it or use the new {@link https://wicg.github.io/ResizeObserver/|ResizeObserver}.
	 *
	 * If the ResizeObserver is available natively, it will be used. A polyfill can be passed in as an option.
	 * If a `playerresize` event is not needed, the ResizeManager component can be removed from the player, see the example below.
	 * @example <caption>How to disable the resize manager</caption>
	 * const player = videojs('#vid', {
	 *   resizeManager: false
	 * });
	 *
	 * @see {@link https://wicg.github.io/ResizeObserver/|ResizeObserver specification}
	 *
	 * @extends Component
	 */
	
	var ResizeManager = function (_Component) {
	  inherits(ResizeManager, _Component);
	
	  /**
	   * Create the ResizeManager.
	   *
	   * @param {Object} player
	   *        The `Player` that this class should be attached to.
	   *
	   * @param {Object} [options]
	   *        The key/value store of ResizeManager options.
	   *
	   * @param {Object} [options.ResizeObserver]
	   *        A polyfill for ResizeObserver can be passed in here.
	   *        If this is set to null it will ignore the native ResizeObserver and fall back to the iframe fallback.
	   */
	  function ResizeManager(player, options) {
	    classCallCheck(this, ResizeManager);
	
	    var RESIZE_OBSERVER_AVAILABLE = options.ResizeObserver || window$1.ResizeObserver;
	
	    // if `null` was passed, we want to disable the ResizeObserver
	    if (options.ResizeObserver === null) {
	      RESIZE_OBSERVER_AVAILABLE = false;
	    }
	
	    // Only create an element when ResizeObserver isn't available
	    var options_ = mergeOptions({
	      createEl: !RESIZE_OBSERVER_AVAILABLE,
	      reportTouchActivity: false
	    }, options);
	
	    var _this = possibleConstructorReturn(this, _Component.call(this, player, options_));
	
	    _this.ResizeObserver = options.ResizeObserver || window$1.ResizeObserver;
	    _this.loadListener_ = null;
	    _this.resizeObserver_ = null;
	    _this.debouncedHandler_ = debounce(function () {
	      _this.resizeHandler();
	    }, 100, false, _this);
	
	    if (RESIZE_OBSERVER_AVAILABLE) {
	      _this.resizeObserver_ = new _this.ResizeObserver(_this.debouncedHandler_);
	      _this.resizeObserver_.observe(player.el());
	    } else {
	      _this.loadListener_ = function () {
	        if (!_this.el_ || !_this.el_.contentWindow) {
	          return;
	        }
	
	        on(_this.el_.contentWindow, 'resize', _this.debouncedHandler_);
	      };
	
	      _this.one('load', _this.loadListener_);
	    }
	    return _this;
	  }
	
	  ResizeManager.prototype.createEl = function createEl() {
	    return _Component.prototype.createEl.call(this, 'iframe', {
	      className: 'vjs-resize-manager'
	    });
	  };
	
	  /**
	   * Called when a resize is triggered on the iframe or a resize is observed via the ResizeObserver
	   *
	   * @fires Player#playerresize
	   */
	
	
	  ResizeManager.prototype.resizeHandler = function resizeHandler() {
	    /**
	     * Called when the player size has changed
	     *
	     * @event Player#playerresize
	     * @type {EventTarget~Event}
	     */
	    // make sure player is still around to trigger
	    // prevents this from causing an error after dispose
	    if (!this.player_ || !this.player_.trigger) {
	      return;
	    }
	
	    this.player_.trigger('playerresize');
	  };
	
	  ResizeManager.prototype.dispose = function dispose() {
	    if (this.debouncedHandler_) {
	      this.debouncedHandler_.cancel();
	    }
	
	    if (this.resizeObserver_) {
	      if (this.player_.el()) {
	        this.resizeObserver_.unobserve(this.player_.el());
	      }
	      this.resizeObserver_.disconnect();
	    }
	
	    if (this.el_ && this.el_.contentWindow) {
	      off(this.el_.contentWindow, 'resize', this.debouncedHandler_);
	    }
	
	    if (this.loadListener_) {
	      this.off('load', this.loadListener_);
	    }
	
	    this.ResizeObserver = null;
	    this.resizeObserver = null;
	    this.debouncedHandler_ = null;
	    this.loadListener_ = null;
	  };
	
	  return ResizeManager;
	}(Component);
	
	Component.registerComponent('ResizeManager', ResizeManager);
	
	/**
	 * This function is used to fire a sourceset when there is something
	 * similar to `mediaEl.load()` being called. It will try to find the source via
	 * the `src` attribute and then the `<source>` elements. It will then fire `sourceset`
	 * with the source that was found or empty string if we cannot know. If it cannot
	 * find a source then `sourceset` will not be fired.
	 *
	 * @param {Html5} tech
	 *        The tech object that sourceset was setup on
	 *
	 * @return {boolean}
	 *         returns false if the sourceset was not fired and true otherwise.
	 */
	var sourcesetLoad = function sourcesetLoad(tech) {
	  var el = tech.el();
	
	  // if `el.src` is set, that source will be loaded.
	  if (el.hasAttribute('src')) {
	    tech.triggerSourceset(el.src);
	    return true;
	  }
	
	  /**
	   * Since there isn't a src property on the media element, source elements will be used for
	   * implementing the source selection algorithm. This happens asynchronously and
	   * for most cases were there is more than one source we cannot tell what source will
	   * be loaded, without re-implementing the source selection algorithm. At this time we are not
	   * going to do that. There are three special cases that we do handle here though:
	   *
	   * 1. If there are no sources, do not fire `sourceset`.
	   * 2. If there is only one `<source>` with a `src` property/attribute that is our `src`
	   * 3. If there is more than one `<source>` but all of them have the same `src` url.
	   *    That will be our src.
	   */
	  var sources = tech.$$('source');
	  var srcUrls = [];
	  var src = '';
	
	  // if there are no sources, do not fire sourceset
	  if (!sources.length) {
	    return false;
	  }
	
	  // only count valid/non-duplicate source elements
	  for (var i = 0; i < sources.length; i++) {
	    var url = sources[i].src;
	
	    if (url && srcUrls.indexOf(url) === -1) {
	      srcUrls.push(url);
	    }
	  }
	
	  // there were no valid sources
	  if (!srcUrls.length) {
	    return false;
	  }
	
	  // there is only one valid source element url
	  // use that
	  if (srcUrls.length === 1) {
	    src = srcUrls[0];
	  }
	
	  tech.triggerSourceset(src);
	  return true;
	};
	
	/**
	 * our implementation of an `innerHTML` descriptor for browsers
	 * that do not have one.
	 */
	var innerHTMLDescriptorPolyfill = Object.defineProperty({}, 'innerHTML', {
	  get: function get() {
	    return this.cloneNode(true).innerHTML;
	  },
	  set: function set(v) {
	    // make a dummy node to use innerHTML on
	    var dummy = document.createElement(this.nodeName.toLowerCase());
	
	    // set innerHTML to the value provided
	    dummy.innerHTML = v;
	
	    // make a document fragment to hold the nodes from dummy
	    var docFrag = document.createDocumentFragment();
	
	    // copy all of the nodes created by the innerHTML on dummy
	    // to the document fragment
	    while (dummy.childNodes.length) {
	      docFrag.appendChild(dummy.childNodes[0]);
	    }
	
	    // remove content
	    this.innerText = '';
	
	    // now we add all of that html in one by appending the
	    // document fragment. This is how innerHTML does it.
	    window$1.Element.prototype.appendChild.call(this, docFrag);
	
	    // then return the result that innerHTML's setter would
	    return this.innerHTML;
	  }
	});
	
	/**
	 * Get a property descriptor given a list of priorities and the
	 * property to get.
	 */
	var getDescriptor = function getDescriptor(priority, prop) {
	  var descriptor = {};
	
	  for (var i = 0; i < priority.length; i++) {
	    descriptor = Object.getOwnPropertyDescriptor(priority[i], prop);
	
	    if (descriptor && descriptor.set && descriptor.get) {
	      break;
	    }
	  }
	
	  descriptor.enumerable = true;
	  descriptor.configurable = true;
	
	  return descriptor;
	};
	
	var getInnerHTMLDescriptor = function getInnerHTMLDescriptor(tech) {
	  return getDescriptor([tech.el(), window$1.HTMLMediaElement.prototype, window$1.Element.prototype, innerHTMLDescriptorPolyfill], 'innerHTML');
	};
	
	/**
	 * Patches browser internal functions so that we can tell synchronously
	 * if a `<source>` was appended to the media element. For some reason this
	 * causes a `sourceset` if the the media element is ready and has no source.
	 * This happens when:
	 * - The page has just loaded and the media element does not have a source.
	 * - The media element was emptied of all sources, then `load()` was called.
	 *
	 * It does this by patching the following functions/properties when they are supported:
	 *
	 * - `append()` - can be used to add a `<source>` element to the media element
	 * - `appendChild()` - can be used to add a `<source>` element to the media element
	 * - `insertAdjacentHTML()` -  can be used to add a `<source>` element to the media element
	 * - `innerHTML` -  can be used to add a `<source>` element to the media element
	 *
	 * @param {Html5} tech
	 *        The tech object that sourceset is being setup on.
	 */
	var firstSourceWatch = function firstSourceWatch(tech) {
	  var el = tech.el();
	
	  // make sure firstSourceWatch isn't setup twice.
	  if (el.resetSourceWatch_) {
	    return;
	  }
	
	  var old = {};
	  var innerDescriptor = getInnerHTMLDescriptor(tech);
	  var appendWrapper = function appendWrapper(appendFn) {
	    return function () {
	      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	        args[_key] = arguments[_key];
	      }
	
	      var retval = appendFn.apply(el, args);
	
	      sourcesetLoad(tech);
	
	      return retval;
	    };
	  };
	
	  ['append', 'appendChild', 'insertAdjacentHTML'].forEach(function (k) {
	    if (!el[k]) {
	      return;
	    }
	
	    // store the old function
	    old[k] = el[k];
	
	    // call the old function with a sourceset if a source
	    // was loaded
	    el[k] = appendWrapper(old[k]);
	  });
	
	  Object.defineProperty(el, 'innerHTML', mergeOptions(innerDescriptor, {
	    set: appendWrapper(innerDescriptor.set)
	  }));
	
	  el.resetSourceWatch_ = function () {
	    el.resetSourceWatch_ = null;
	    Object.keys(old).forEach(function (k) {
	      el[k] = old[k];
	    });
	
	    Object.defineProperty(el, 'innerHTML', innerDescriptor);
	  };
	
	  // on the first sourceset, we need to revert our changes
	  tech.one('sourceset', el.resetSourceWatch_);
	};
	
	/**
	 * our implementation of a `src` descriptor for browsers
	 * that do not have one.
	 */
	var srcDescriptorPolyfill = Object.defineProperty({}, 'src', {
	  get: function get() {
	    if (this.hasAttribute('src')) {
	      return getAbsoluteURL(window$1.Element.prototype.getAttribute.call(this, 'src'));
	    }
	
	    return '';
	  },
	  set: function set(v) {
	    window$1.Element.prototype.setAttribute.call(this, 'src', v);
	
	    return v;
	  }
	});
	
	var getSrcDescriptor = function getSrcDescriptor(tech) {
	  return getDescriptor([tech.el(), window$1.HTMLMediaElement.prototype, srcDescriptorPolyfill], 'src');
	};
	
	/**
	 * setup `sourceset` handling on the `Html5` tech. This function
	 * patches the following element properties/functions:
	 *
	 * - `src` - to determine when `src` is set
	 * - `setAttribute()` - to determine when `src` is set
	 * - `load()` - this re-triggers the source selection algorithm, and can
	 *              cause a sourceset.
	 *
	 * If there is no source when we are adding `sourceset` support or during a `load()`
	 * we also patch the functions listed in `firstSourceWatch`.
	 *
	 * @param {Html5} tech
	 *        The tech to patch
	 */
	var setupSourceset = function setupSourceset(tech) {
	  if (!tech.featuresSourceset) {
	    return;
	  }
	
	  var el = tech.el();
	
	  // make sure sourceset isn't setup twice.
	  if (el.resetSourceset_) {
	    return;
	  }
	
	  var srcDescriptor = getSrcDescriptor(tech);
	  var oldSetAttribute = el.setAttribute;
	  var oldLoad = el.load;
	
	  Object.defineProperty(el, 'src', mergeOptions(srcDescriptor, {
	    set: function set(v) {
	      var retval = srcDescriptor.set.call(el, v);
	
	      // we use the getter here to get the actual value set on src
	      tech.triggerSourceset(el.src);
	
	      return retval;
	    }
	  }));
	
	  el.setAttribute = function (n, v) {
	    var retval = oldSetAttribute.call(el, n, v);
	
	    if (/src/i.test(n)) {
	      tech.triggerSourceset(el.src);
	    }
	
	    return retval;
	  };
	
	  el.load = function () {
	    var retval = oldLoad.call(el);
	
	    // if load was called, but there was no source to fire
	    // sourceset on. We have to watch for a source append
	    // as that can trigger a `sourceset` when the media element
	    // has no source
	    if (!sourcesetLoad(tech)) {
	      tech.triggerSourceset('');
	      firstSourceWatch(tech);
	    }
	
	    return retval;
	  };
	
	  if (el.currentSrc) {
	    tech.triggerSourceset(el.currentSrc);
	  } else if (!sourcesetLoad(tech)) {
	    firstSourceWatch(tech);
	  }
	
	  el.resetSourceset_ = function () {
	    el.resetSourceset_ = null;
	    el.load = oldLoad;
	    el.setAttribute = oldSetAttribute;
	    Object.defineProperty(el, 'src', srcDescriptor);
	    if (el.resetSourceWatch_) {
	      el.resetSourceWatch_();
	    }
	  };
	};
	
	var _templateObject$1 = taggedTemplateLiteralLoose(['Text Tracks are being loaded from another origin but the crossorigin attribute isn\'t used.\n            This may prevent text tracks from loading.'], ['Text Tracks are being loaded from another origin but the crossorigin attribute isn\'t used.\n            This may prevent text tracks from loading.']);
	
	/**
	 * HTML5 Media Controller - Wrapper for HTML5 Media API
	 *
	 * @mixes Tech~SourceHandlerAdditions
	 * @extends Tech
	 */
	
	var Html5 = function (_Tech) {
	  inherits(Html5, _Tech);
	
	  /**
	   * Create an instance of this Tech.
	   *
	   * @param {Object} [options]
	   *        The key/value store of player options.
	   *
	   * @param {Component~ReadyCallback} ready
	   *        Callback function to call when the `HTML5` Tech is ready.
	   */
	  function Html5(options, ready) {
	    classCallCheck(this, Html5);
	
	    var _this = possibleConstructorReturn(this, _Tech.call(this, options, ready));
	
	    var source = options.source;
	    var crossoriginTracks = false;
	
	    // Set the source if one is provided
	    // 1) Check if the source is new (if not, we want to keep the original so playback isn't interrupted)
	    // 2) Check to see if the network state of the tag was failed at init, and if so, reset the source
	    // anyway so the error gets fired.
	    if (source && (_this.el_.currentSrc !== source.src || options.tag && options.tag.initNetworkState_ === 3)) {
	      _this.setSource(source);
	    } else {
	      _this.handleLateInit_(_this.el_);
	    }
	
	    // setup sourceset after late sourceset/init
	    if (options.enableSourceset) {
	      _this.setupSourcesetHandling_();
	    }
	
	    if (_this.el_.hasChildNodes()) {
	
	      var nodes = _this.el_.childNodes;
	      var nodesLength = nodes.length;
	      var removeNodes = [];
	
	      while (nodesLength--) {
	        var node = nodes[nodesLength];
	        var nodeName = node.nodeName.toLowerCase();
	
	        if (nodeName === 'track') {
	          if (!_this.featuresNativeTextTracks) {
	            // Empty video tag tracks so the built-in player doesn't use them also.
	            // This may not be fast enough to stop HTML5 browsers from reading the tags
	            // so we'll need to turn off any default tracks if we're manually doing
	            // captions and subtitles. videoElement.textTracks
	            removeNodes.push(node);
	          } else {
	            // store HTMLTrackElement and TextTrack to remote list
	            _this.remoteTextTrackEls().addTrackElement_(node);
	            _this.remoteTextTracks().addTrack(node.track);
	            _this.textTracks().addTrack(node.track);
	            if (!crossoriginTracks && !_this.el_.hasAttribute('crossorigin') && isCrossOrigin(node.src)) {
	              crossoriginTracks = true;
	            }
	          }
	        }
	      }
	
	      for (var i = 0; i < removeNodes.length; i++) {
	        _this.el_.removeChild(removeNodes[i]);
	      }
	    }
	
	    _this.proxyNativeTracks_();
	    if (_this.featuresNativeTextTracks && crossoriginTracks) {
	      log$1.warn(tsml(_templateObject$1));
	    }
	
	    // prevent iOS Safari from disabling metadata text tracks during native playback
	    _this.restoreMetadataTracksInIOSNativePlayer_();
	
	    // Determine if native controls should be used
	    // Our goal should be to get the custom controls on mobile solid everywhere
	    // so we can remove this all together. Right now this will block custom
	    // controls on touch enabled laptops like the Chrome Pixel
	    if ((TOUCH_ENABLED || IS_IPHONE || IS_NATIVE_ANDROID) && options.nativeControlsForTouch === true) {
	      _this.setControls(true);
	    }
	
	    // on iOS, we want to proxy `webkitbeginfullscreen` and `webkitendfullscreen`
	    // into a `fullscreenchange` event
	    _this.proxyWebkitFullscreen_();
	
	    _this.triggerReady();
	    return _this;
	  }
	
	  /**
	   * Dispose of `HTML5` media element and remove all tracks.
	   */
	
	
	  Html5.prototype.dispose = function dispose() {
	    if (this.el_ && this.el_.resetSourceset_) {
	      this.el_.resetSourceset_();
	    }
	    Html5.disposeMediaElement(this.el_);
	    this.options_ = null;
	
	    // tech will handle clearing of the emulated track list
	    _Tech.prototype.dispose.call(this);
	  };
	
	  /**
	   * Modify the media element so that we can detect when
	   * the source is changed. Fires `sourceset` just after the source has changed
	   */
	
	
	  Html5.prototype.setupSourcesetHandling_ = function setupSourcesetHandling_() {
	    setupSourceset(this);
	  };
	
	  /**
	   * When a captions track is enabled in the iOS Safari native player, all other
	   * tracks are disabled (including metadata tracks), which nulls all of their
	   * associated cue points. This will restore metadata tracks to their pre-fullscreen
	   * state in those cases so that cue points are not needlessly lost.
	   *
	   * @private
	   */
	
	
	  Html5.prototype.restoreMetadataTracksInIOSNativePlayer_ = function restoreMetadataTracksInIOSNativePlayer_() {
	    var textTracks = this.textTracks();
	    var metadataTracksPreFullscreenState = void 0;
	
	    // captures a snapshot of every metadata track's current state
	    var takeMetadataTrackSnapshot = function takeMetadataTrackSnapshot() {
	      metadataTracksPreFullscreenState = [];
	
	      for (var i = 0; i < textTracks.length; i++) {
	        var track = textTracks[i];
	
	        if (track.kind === 'metadata') {
	          metadataTracksPreFullscreenState.push({
	            track: track,
	            storedMode: track.mode
	          });
	        }
	      }
	    };
	
	    // snapshot each metadata track's initial state, and update the snapshot
	    // each time there is a track 'change' event
	    takeMetadataTrackSnapshot();
	    textTracks.addEventListener('change', takeMetadataTrackSnapshot);
	
	    this.on('dispose', function () {
	      return textTracks.removeEventListener('change', takeMetadataTrackSnapshot);
	    });
	
	    var restoreTrackMode = function restoreTrackMode() {
	      for (var i = 0; i < metadataTracksPreFullscreenState.length; i++) {
	        var storedTrack = metadataTracksPreFullscreenState[i];
	
	        if (storedTrack.track.mode === 'disabled' && storedTrack.track.mode !== storedTrack.storedMode) {
	          storedTrack.track.mode = storedTrack.storedMode;
	        }
	      }
	      // we only want this handler to be executed on the first 'change' event
	      textTracks.removeEventListener('change', restoreTrackMode);
	    };
	
	    // when we enter fullscreen playback, stop updating the snapshot and
	    // restore all track modes to their pre-fullscreen state
	    this.on('webkitbeginfullscreen', function () {
	      textTracks.removeEventListener('change', takeMetadataTrackSnapshot);
	
	      // remove the listener before adding it just in case it wasn't previously removed
	      textTracks.removeEventListener('change', restoreTrackMode);
	      textTracks.addEventListener('change', restoreTrackMode);
	    });
	
	    // start updating the snapshot again after leaving fullscreen
	    this.on('webkitendfullscreen', function () {
	      // remove the listener before adding it just in case it wasn't previously removed
	      textTracks.removeEventListener('change', takeMetadataTrackSnapshot);
	      textTracks.addEventListener('change', takeMetadataTrackSnapshot);
	
	      // remove the restoreTrackMode handler in case it wasn't triggered during fullscreen playback
	      textTracks.removeEventListener('change', restoreTrackMode);
	    });
	  };
	
	  /**
	   * Attempt to force override of tracks for the given type
	   *
	   * @param {String} type - Track type to override, possible values include 'Audio',
	   * 'Video', and 'Text'.
	   * @param {Boolean} override - If set to true native audio/video will be overridden,
	   * otherwise native audio/video will potentially be used.
	   * @private
	   */
	
	
	  Html5.prototype.overrideNative_ = function overrideNative_(type, override) {
	    var _this2 = this;
	
	    // If there is no behavioral change don't add/remove listeners
	    if (override !== this['featuresNative' + type + 'Tracks']) {
	      return;
	    }
	
	    var lowerCaseType = type.toLowerCase();
	
	    if (this[lowerCaseType + 'TracksListeners_']) {
	      Object.keys(this[lowerCaseType + 'TracksListeners_']).forEach(function (eventName) {
	        var elTracks = _this2.el()[lowerCaseType + 'Tracks'];
	
	        elTracks.removeEventListener(eventName, _this2[lowerCaseType + 'TracksListeners_'][eventName]);
	      });
	    }
	
	    this['featuresNative' + type + 'Tracks'] = !override;
	    this[lowerCaseType + 'TracksListeners_'] = null;
	
	    this.proxyNativeTracksForType_(lowerCaseType);
	  };
	
	  /**
	   * Attempt to force override of native audio tracks.
	   *
	   * @param {Boolean} override - If set to true native audio will be overridden,
	   * otherwise native audio will potentially be used.
	   */
	
	
	  Html5.prototype.overrideNativeAudioTracks = function overrideNativeAudioTracks(override) {
	    this.overrideNative_('Audio', override);
	  };
	
	  /**
	   * Attempt to force override of native video tracks.
	   *
	   * @param {Boolean} override - If set to true native video will be overridden,
	   * otherwise native video will potentially be used.
	   */
	
	
	  Html5.prototype.overrideNativeVideoTracks = function overrideNativeVideoTracks(override) {
	    this.overrideNative_('Video', override);
	  };
	
	  /**
	    * Proxy native track list events for the given type to our track
	    * lists if the browser we are playing in supports that type of track list.
	    *
	    * @param {string} name - Track type; values include 'audio', 'video', and 'text'
	    * @private
	    */
	
	
	  Html5.prototype.proxyNativeTracksForType_ = function proxyNativeTracksForType_(name) {
	    var _this3 = this;
	
	    var props = NORMAL[name];
	    var elTracks = this.el()[props.getterName];
	    var techTracks = this[props.getterName]();
	
	    if (!this['featuresNative' + props.capitalName + 'Tracks'] || !elTracks || !elTracks.addEventListener) {
	      return;
	    }
	    var listeners = {
	      change: function change(e) {
	        techTracks.trigger({
	          type: 'change',
	          target: techTracks,
	          currentTarget: techTracks,
	          srcElement: techTracks
	        });
	      },
	      addtrack: function addtrack(e) {
	        techTracks.addTrack(e.track);
	      },
	      removetrack: function removetrack(e) {
	        techTracks.removeTrack(e.track);
	      }
	    };
	    var removeOldTracks = function removeOldTracks() {
	      var removeTracks = [];
	
	      for (var i = 0; i < techTracks.length; i++) {
	        var found = false;
	
	        for (var j = 0; j < elTracks.length; j++) {
	          if (elTracks[j] === techTracks[i]) {
	            found = true;
	            break;
	          }
	        }
	
	        if (!found) {
	          removeTracks.push(techTracks[i]);
	        }
	      }
	
	      while (removeTracks.length) {
	        techTracks.removeTrack(removeTracks.shift());
	      }
	    };
	
	    this[props.getterName + 'Listeners_'] = listeners;
	
	    Object.keys(listeners).forEach(function (eventName) {
	      var listener = listeners[eventName];
	
	      elTracks.addEventListener(eventName, listener);
	      _this3.on('dispose', function (e) {
	        return elTracks.removeEventListener(eventName, listener);
	      });
	    });
	
	    // Remove (native) tracks that are not used anymore
	    this.on('loadstart', removeOldTracks);
	    this.on('dispose', function (e) {
	      return _this3.off('loadstart', removeOldTracks);
	    });
	  };
	
	  /**
	   * Proxy all native track list events to our track lists if the browser we are playing
	   * in supports that type of track list.
	   *
	   * @private
	   */
	
	
	  Html5.prototype.proxyNativeTracks_ = function proxyNativeTracks_() {
	    var _this4 = this;
	
	    NORMAL.names.forEach(function (name) {
	      _this4.proxyNativeTracksForType_(name);
	    });
	  };
	
	  /**
	   * Create the `Html5` Tech's DOM element.
	   *
	   * @return {Element}
	   *         The element that gets created.
	   */
	
	
	  Html5.prototype.createEl = function createEl$$1() {
	    var el = this.options_.tag;
	
	    // Check if this browser supports moving the element into the box.
	    // On the iPhone video will break if you move the element,
	    // So we have to create a brand new element.
	    // If we ingested the player div, we do not need to move the media element.
	    if (!el || !(this.options_.playerElIngest || this.movingMediaElementInDOM)) {
	
	      // If the original tag is still there, clone and remove it.
	      if (el) {
	        var clone = el.cloneNode(true);
	
	        if (el.parentNode) {
	          el.parentNode.insertBefore(clone, el);
	        }
	        Html5.disposeMediaElement(el);
	        el = clone;
	      } else {
	        el = document.createElement('video');
	
	        // determine if native controls should be used
	        var tagAttributes = this.options_.tag && getAttributes(this.options_.tag);
	        var attributes = mergeOptions({}, tagAttributes);
	
	        if (!TOUCH_ENABLED || this.options_.nativeControlsForTouch !== true) {
	          delete attributes.controls;
	        }
	
	        setAttributes(el, assign(attributes, {
	          id: this.options_.techId,
	          class: 'vjs-tech'
	        }));
	      }
	
	      el.playerId = this.options_.playerId;
	    }
	
	    if (typeof this.options_.preload !== 'undefined') {
	      setAttribute(el, 'preload', this.options_.preload);
	    }
	
	    // Update specific tag settings, in case they were overridden
	    // `autoplay` has to be *last* so that `muted` and `playsinline` are present
	    // when iOS/Safari or other browsers attempt to autoplay.
	    var settingsAttrs = ['loop', 'muted', 'playsinline', 'autoplay'];
	
	    for (var i = 0; i < settingsAttrs.length; i++) {
	      var attr = settingsAttrs[i];
	      var value = this.options_[attr];
	
	      if (typeof value !== 'undefined') {
	        if (value) {
	          setAttribute(el, attr, attr);
	        } else {
	          removeAttribute(el, attr);
	        }
	        el[attr] = value;
	      }
	    }
	
	    return el;
	  };
	
	  /**
	   * This will be triggered if the loadstart event has already fired, before videojs was
	   * ready. Two known examples of when this can happen are:
	   * 1. If we're loading the playback object after it has started loading
	   * 2. The media is already playing the (often with autoplay on) then
	   *
	   * This function will fire another loadstart so that videojs can catchup.
	   *
	   * @fires Tech#loadstart
	   *
	   * @return {undefined}
	   *         returns nothing.
	   */
	
	
	  Html5.prototype.handleLateInit_ = function handleLateInit_(el) {
	    if (el.networkState === 0 || el.networkState === 3) {
	      // The video element hasn't started loading the source yet
	      // or didn't find a source
	      return;
	    }
	
	    if (el.readyState === 0) {
	      // NetworkState is set synchronously BUT loadstart is fired at the
	      // end of the current stack, usually before setInterval(fn, 0).
	      // So at this point we know loadstart may have already fired or is
	      // about to fire, and either way the player hasn't seen it yet.
	      // We don't want to fire loadstart prematurely here and cause a
	      // double loadstart so we'll wait and see if it happens between now
	      // and the next loop, and fire it if not.
	      // HOWEVER, we also want to make sure it fires before loadedmetadata
	      // which could also happen between now and the next loop, so we'll
	      // watch for that also.
	      var loadstartFired = false;
	      var setLoadstartFired = function setLoadstartFired() {
	        loadstartFired = true;
	      };
	
	      this.on('loadstart', setLoadstartFired);
	
	      var triggerLoadstart = function triggerLoadstart() {
	        // We did miss the original loadstart. Make sure the player
	        // sees loadstart before loadedmetadata
	        if (!loadstartFired) {
	          this.trigger('loadstart');
	        }
	      };
	
	      this.on('loadedmetadata', triggerLoadstart);
	
	      this.ready(function () {
	        this.off('loadstart', setLoadstartFired);
	        this.off('loadedmetadata', triggerLoadstart);
	
	        if (!loadstartFired) {
	          // We did miss the original native loadstart. Fire it now.
	          this.trigger('loadstart');
	        }
	      });
	
	      return;
	    }
	
	    // From here on we know that loadstart already fired and we missed it.
	    // The other readyState events aren't as much of a problem if we double
	    // them, so not going to go to as much trouble as loadstart to prevent
	    // that unless we find reason to.
	    var eventsToTrigger = ['loadstart'];
	
	    // loadedmetadata: newly equal to HAVE_METADATA (1) or greater
	    eventsToTrigger.push('loadedmetadata');
	
	    // loadeddata: newly increased to HAVE_CURRENT_DATA (2) or greater
	    if (el.readyState >= 2) {
	      eventsToTrigger.push('loadeddata');
	    }
	
	    // canplay: newly increased to HAVE_FUTURE_DATA (3) or greater
	    if (el.readyState >= 3) {
	      eventsToTrigger.push('canplay');
	    }
	
	    // canplaythrough: newly equal to HAVE_ENOUGH_DATA (4)
	    if (el.readyState >= 4) {
	      eventsToTrigger.push('canplaythrough');
	    }
	
	    // We still need to give the player time to add event listeners
	    this.ready(function () {
	      eventsToTrigger.forEach(function (type) {
	        this.trigger(type);
	      }, this);
	    });
	  };
	
	  /**
	   * Set current time for the `HTML5` tech.
	   *
	   * @param {number} seconds
	   *        Set the current time of the media to this.
	   */
	
	
	  Html5.prototype.setCurrentTime = function setCurrentTime(seconds) {
	    try {
	      this.el_.currentTime = seconds;
	    } catch (e) {
	      log$1(e, 'Video is not ready. (Video.js)');
	      // this.warning(VideoJS.warnings.videoNotReady);
	    }
	  };
	
	  /**
	   * Get the current duration of the HTML5 media element.
	   *
	   * @return {number}
	   *         The duration of the media or 0 if there is no duration.
	   */
	
	
	  Html5.prototype.duration = function duration() {
	    var _this5 = this;
	
	    // Android Chrome will report duration as Infinity for VOD HLS until after
	    // playback has started, which triggers the live display erroneously.
	    // Return NaN if playback has not started and trigger a durationupdate once
	    // the duration can be reliably known.
	    if (this.el_.duration === Infinity && IS_ANDROID && IS_CHROME && this.el_.currentTime === 0) {
	      // Wait for the first `timeupdate` with currentTime > 0 - there may be
	      // several with 0
	      var checkProgress = function checkProgress() {
	        if (_this5.el_.currentTime > 0) {
	          // Trigger durationchange for genuinely live video
	          if (_this5.el_.duration === Infinity) {
	            _this5.trigger('durationchange');
	          }
	          _this5.off('timeupdate', checkProgress);
	        }
	      };
	
	      this.on('timeupdate', checkProgress);
	      return NaN;
	    }
	    return this.el_.duration || NaN;
	  };
	
	  /**
	   * Get the current width of the HTML5 media element.
	   *
	   * @return {number}
	   *         The width of the HTML5 media element.
	   */
	
	
	  Html5.prototype.width = function width() {
	    return this.el_.offsetWidth;
	  };
	
	  /**
	   * Get the current height of the HTML5 media element.
	   *
	   * @return {number}
	   *         The height of the HTML5 media element.
	   */
	
	
	  Html5.prototype.height = function height() {
	    return this.el_.offsetHeight;
	  };
	
	  /**
	   * Proxy iOS `webkitbeginfullscreen` and `webkitendfullscreen` into
	   * `fullscreenchange` event.
	   *
	   * @private
	   * @fires fullscreenchange
	   * @listens webkitendfullscreen
	   * @listens webkitbeginfullscreen
	   * @listens webkitbeginfullscreen
	   */
	
	
	  Html5.prototype.proxyWebkitFullscreen_ = function proxyWebkitFullscreen_() {
	    var _this6 = this;
	
	    if (!('webkitDisplayingFullscreen' in this.el_)) {
	      return;
	    }
	
	    var endFn = function endFn() {
	      this.trigger('fullscreenchange', { isFullscreen: false });
	    };
	
	    var beginFn = function beginFn() {
	      if ('webkitPresentationMode' in this.el_ && this.el_.webkitPresentationMode !== 'picture-in-picture') {
	        this.one('webkitendfullscreen', endFn);
	
	        this.trigger('fullscreenchange', { isFullscreen: true });
	      }
	    };
	
	    this.on('webkitbeginfullscreen', beginFn);
	    this.on('dispose', function () {
	      _this6.off('webkitbeginfullscreen', beginFn);
	      _this6.off('webkitendfullscreen', endFn);
	    });
	  };
	
	  /**
	   * Check if fullscreen is supported on the current playback device.
	   *
	   * @return {boolean}
	   *         - True if fullscreen is supported.
	   *         - False if fullscreen is not supported.
	   */
	
	
	  Html5.prototype.supportsFullScreen = function supportsFullScreen() {
	    if (typeof this.el_.webkitEnterFullScreen === 'function') {
	      var userAgent = window$1.navigator && window$1.navigator.userAgent || '';
	
	      // Seems to be broken in Chromium/Chrome && Safari in Leopard
	      if (/Android/.test(userAgent) || !/Chrome|Mac OS X 10.5/.test(userAgent)) {
	        return true;
	      }
	    }
	    return false;
	  };
	
	  /**
	   * Request that the `HTML5` Tech enter fullscreen.
	   */
	
	
	  Html5.prototype.enterFullScreen = function enterFullScreen() {
	    var video = this.el_;
	
	    if (video.paused && video.networkState <= video.HAVE_METADATA) {
	      // attempt to prime the video element for programmatic access
	      // this isn't necessary on the desktop but shouldn't hurt
	      this.el_.play();
	
	      // playing and pausing synchronously during the transition to fullscreen
	      // can get iOS ~6.1 devices into a play/pause loop
	      this.setTimeout(function () {
	        video.pause();
	        video.webkitEnterFullScreen();
	      }, 0);
	    } else {
	      video.webkitEnterFullScreen();
	    }
	  };
	
	  /**
	   * Request that the `HTML5` Tech exit fullscreen.
	   */
	
	
	  Html5.prototype.exitFullScreen = function exitFullScreen() {
	    this.el_.webkitExitFullScreen();
	  };
	
	  /**
	   * A getter/setter for the `Html5` Tech's source object.
	   * > Note: Please use {@link Html5#setSource}
	   *
	   * @param {Tech~SourceObject} [src]
	   *        The source object you want to set on the `HTML5` techs element.
	   *
	   * @return {Tech~SourceObject|undefined}
	   *         - The current source object when a source is not passed in.
	   *         - undefined when setting
	   *
	   * @deprecated Since version 5.
	   */
	
	
	  Html5.prototype.src = function src(_src) {
	    if (_src === undefined) {
	      return this.el_.src;
	    }
	
	    // Setting src through `src` instead of `setSrc` will be deprecated
	    this.setSrc(_src);
	  };
	
	  /**
	   * Reset the tech by removing all sources and then calling
	   * {@link Html5.resetMediaElement}.
	   */
	
	
	  Html5.prototype.reset = function reset() {
	    Html5.resetMediaElement(this.el_);
	  };
	
	  /**
	   * Get the current source on the `HTML5` Tech. Falls back to returning the source from
	   * the HTML5 media element.
	   *
	   * @return {Tech~SourceObject}
	   *         The current source object from the HTML5 tech. With a fallback to the
	   *         elements source.
	   */
	
	
	  Html5.prototype.currentSrc = function currentSrc() {
	    if (this.currentSource_) {
	      return this.currentSource_.src;
	    }
	    return this.el_.currentSrc;
	  };
	
	  /**
	   * Set controls attribute for the HTML5 media Element.
	   *
	   * @param {string} val
	   *        Value to set the controls attribute to
	   */
	
	
	  Html5.prototype.setControls = function setControls(val) {
	    this.el_.controls = !!val;
	  };
	
	  /**
	   * Create and returns a remote {@link TextTrack} object.
	   *
	   * @param {string} kind
	   *        `TextTrack` kind (subtitles, captions, descriptions, chapters, or metadata)
	   *
	   * @param {string} [label]
	   *        Label to identify the text track
	   *
	   * @param {string} [language]
	   *        Two letter language abbreviation
	   *
	   * @return {TextTrack}
	   *         The TextTrack that gets created.
	   */
	
	
	  Html5.prototype.addTextTrack = function addTextTrack(kind, label, language) {
	    if (!this.featuresNativeTextTracks) {
	      return _Tech.prototype.addTextTrack.call(this, kind, label, language);
	    }
	
	    return this.el_.addTextTrack(kind, label, language);
	  };
	
	  /**
	   * Creates either native TextTrack or an emulated TextTrack depending
	   * on the value of `featuresNativeTextTracks`
	   *
	   * @param {Object} options
	   *        The object should contain the options to initialize the TextTrack with.
	   *
	   * @param {string} [options.kind]
	   *        `TextTrack` kind (subtitles, captions, descriptions, chapters, or metadata).
	   *
	   * @param {string} [options.label]
	   *        Label to identify the text track
	   *
	   * @param {string} [options.language]
	   *        Two letter language abbreviation.
	   *
	   * @param {boolean} [options.default]
	   *        Default this track to on.
	   *
	   * @param {string} [options.id]
	   *        The internal id to assign this track.
	   *
	   * @param {string} [options.src]
	   *        A source url for the track.
	   *
	   * @return {HTMLTrackElement}
	   *         The track element that gets created.
	   */
	
	
	  Html5.prototype.createRemoteTextTrack = function createRemoteTextTrack(options) {
	    if (!this.featuresNativeTextTracks) {
	      return _Tech.prototype.createRemoteTextTrack.call(this, options);
	    }
	    var htmlTrackElement = document.createElement('track');
	
	    if (options.kind) {
	      htmlTrackElement.kind = options.kind;
	    }
	    if (options.label) {
	      htmlTrackElement.label = options.label;
	    }
	    if (options.language || options.srclang) {
	      htmlTrackElement.srclang = options.language || options.srclang;
	    }
	    if (options.default) {
	      htmlTrackElement.default = options.default;
	    }
	    if (options.id) {
	      htmlTrackElement.id = options.id;
	    }
	    if (options.src) {
	      htmlTrackElement.src = options.src;
	    }
	
	    return htmlTrackElement;
	  };
	
	  /**
	   * Creates a remote text track object and returns an html track element.
	   *
	   * @param {Object} options The object should contain values for
	   * kind, language, label, and src (location of the WebVTT file)
	   * @param {Boolean} [manualCleanup=true] if set to false, the TextTrack will be
	   * automatically removed from the video element whenever the source changes
	   * @return {HTMLTrackElement} An Html Track Element.
	   * This can be an emulated {@link HTMLTrackElement} or a native one.
	   * @deprecated The default value of the "manualCleanup" parameter will default
	   * to "false" in upcoming versions of Video.js
	   */
	
	
	  Html5.prototype.addRemoteTextTrack = function addRemoteTextTrack(options, manualCleanup) {
	    var htmlTrackElement = _Tech.prototype.addRemoteTextTrack.call(this, options, manualCleanup);
	
	    if (this.featuresNativeTextTracks) {
	      this.el().appendChild(htmlTrackElement);
	    }
	
	    return htmlTrackElement;
	  };
	
	  /**
	   * Remove remote `TextTrack` from `TextTrackList` object
	   *
	   * @param {TextTrack} track
	   *        `TextTrack` object to remove
	   */
	
	
	  Html5.prototype.removeRemoteTextTrack = function removeRemoteTextTrack(track) {
	    _Tech.prototype.removeRemoteTextTrack.call(this, track);
	
	    if (this.featuresNativeTextTracks) {
	      var tracks = this.$$('track');
	
	      var i = tracks.length;
	
	      while (i--) {
	        if (track === tracks[i] || track === tracks[i].track) {
	          this.el().removeChild(tracks[i]);
	        }
	      }
	    }
	  };
	
	  /**
	   * Gets available media playback quality metrics as specified by the W3C's Media
	   * Playback Quality API.
	   *
	   * @see [Spec]{@link https://wicg.github.io/media-playback-quality}
	   *
	   * @return {Object}
	   *         An object with supported media playback quality metrics
	   */
	
	
	  Html5.prototype.getVideoPlaybackQuality = function getVideoPlaybackQuality() {
	    if (typeof this.el().getVideoPlaybackQuality === 'function') {
	      return this.el().getVideoPlaybackQuality();
	    }
	
	    var videoPlaybackQuality = {};
	
	    if (typeof this.el().webkitDroppedFrameCount !== 'undefined' && typeof this.el().webkitDecodedFrameCount !== 'undefined') {
	      videoPlaybackQuality.droppedVideoFrames = this.el().webkitDroppedFrameCount;
	      videoPlaybackQuality.totalVideoFrames = this.el().webkitDecodedFrameCount;
	    }
	
	    if (window$1.performance && typeof window$1.performance.now === 'function') {
	      videoPlaybackQuality.creationTime = window$1.performance.now();
	    } else if (window$1.performance && window$1.performance.timing && typeof window$1.performance.timing.navigationStart === 'number') {
	      videoPlaybackQuality.creationTime = window$1.Date.now() - window$1.performance.timing.navigationStart;
	    }
	
	    return videoPlaybackQuality;
	  };
	
	  return Html5;
	}(Tech);
	
	/* HTML5 Support Testing ---------------------------------------------------- */
	
	if (isReal()) {
	
	  /**
	   * Element for testing browser HTML5 media capabilities
	   *
	   * @type {Element}
	   * @constant
	   * @private
	   */
	  Html5.TEST_VID = document.createElement('video');
	  var track = document.createElement('track');
	
	  track.kind = 'captions';
	  track.srclang = 'en';
	  track.label = 'English';
	  Html5.TEST_VID.appendChild(track);
	}
	
	/**
	 * Check if HTML5 media is supported by this browser/device.
	 *
	 * @return {boolean}
	 *         - True if HTML5 media is supported.
	 *         - False if HTML5 media is not supported.
	 */
	Html5.isSupported = function () {
	  // IE with no Media Player is a LIAR! (#984)
	  try {
	    Html5.TEST_VID.volume = 0.5;
	  } catch (e) {
	    return false;
	  }
	
	  return !!(Html5.TEST_VID && Html5.TEST_VID.canPlayType);
	};
	
	/**
	 * Check if the tech can support the given type
	 *
	 * @param {string} type
	 *        The mimetype to check
	 * @return {string} 'probably', 'maybe', or '' (empty string)
	 */
	Html5.canPlayType = function (type) {
	  return Html5.TEST_VID.canPlayType(type);
	};
	
	/**
	 * Check if the tech can support the given source
	 * @param {Object} srcObj
	 *        The source object
	 * @param {Object} options
	 *        The options passed to the tech
	 * @return {string} 'probably', 'maybe', or '' (empty string)
	 */
	Html5.canPlaySource = function (srcObj, options) {
	  return Html5.canPlayType(srcObj.type);
	};
	
	/**
	 * Check if the volume can be changed in this browser/device.
	 * Volume cannot be changed in a lot of mobile devices.
	 * Specifically, it can't be changed from 1 on iOS.
	 *
	 * @return {boolean}
	 *         - True if volume can be controlled
	 *         - False otherwise
	 */
	Html5.canControlVolume = function () {
	  // IE will error if Windows Media Player not installed #3315
	  try {
	    var volume = Html5.TEST_VID.volume;
	
	    Html5.TEST_VID.volume = volume / 2 + 0.1;
	    return volume !== Html5.TEST_VID.volume;
	  } catch (e) {
	    return false;
	  }
	};
	
	/**
	 * Check if the volume can be muted in this browser/device.
	 * Some devices, e.g. iOS, don't allow changing volume
	 * but permits muting/unmuting.
	 *
	 * @return {bolean}
	 *      - True if volume can be muted
	 *      - False otherwise
	 */
	Html5.canMuteVolume = function () {
	  try {
	    var muted = Html5.TEST_VID.muted;
	
	    // in some versions of iOS muted property doesn't always
	    // work, so we want to set both property and attribute
	    Html5.TEST_VID.muted = !muted;
	    if (Html5.TEST_VID.muted) {
	      setAttribute(Html5.TEST_VID, 'muted', 'muted');
	    } else {
	      removeAttribute(Html5.TEST_VID, 'muted', 'muted');
	    }
	    return muted !== Html5.TEST_VID.muted;
	  } catch (e) {
	    return false;
	  }
	};
	
	/**
	 * Check if the playback rate can be changed in this browser/device.
	 *
	 * @return {boolean}
	 *         - True if playback rate can be controlled
	 *         - False otherwise
	 */
	Html5.canControlPlaybackRate = function () {
	  // Playback rate API is implemented in Android Chrome, but doesn't do anything
	  // https://github.com/videojs/video.js/issues/3180
	  if (IS_ANDROID && IS_CHROME && CHROME_VERSION < 58) {
	    return false;
	  }
	  // IE will error if Windows Media Player not installed #3315
	  try {
	    var playbackRate = Html5.TEST_VID.playbackRate;
	
	    Html5.TEST_VID.playbackRate = playbackRate / 2 + 0.1;
	    return playbackRate !== Html5.TEST_VID.playbackRate;
	  } catch (e) {
	    return false;
	  }
	};
	
	/**
	 * Check if we can override a video/audio elements attributes, with
	 * Object.defineProperty.
	 *
	 * @return {boolean}
	 *         - True if builtin attributes can be overridden
	 *         - False otherwise
	 */
	Html5.canOverrideAttributes = function () {
	  // if we cannot overwrite the src/innerHTML property, there is no support
	  // iOS 7 safari for instance cannot do this.
	  try {
	    var noop = function noop() {};
	
	    Object.defineProperty(document.createElement('video'), 'src', { get: noop, set: noop });
	    Object.defineProperty(document.createElement('audio'), 'src', { get: noop, set: noop });
	    Object.defineProperty(document.createElement('video'), 'innerHTML', { get: noop, set: noop });
	    Object.defineProperty(document.createElement('audio'), 'innerHTML', { get: noop, set: noop });
	  } catch (e) {
	    return false;
	  }
	
	  return true;
	};
	
	/**
	 * Check to see if native `TextTrack`s are supported by this browser/device.
	 *
	 * @return {boolean}
	 *         - True if native `TextTrack`s are supported.
	 *         - False otherwise
	 */
	Html5.supportsNativeTextTracks = function () {
	  return IS_ANY_SAFARI || IS_IOS && IS_CHROME;
	};
	
	/**
	 * Check to see if native `VideoTrack`s are supported by this browser/device
	 *
	 * @return {boolean}
	 *        - True if native `VideoTrack`s are supported.
	 *        - False otherwise
	 */
	Html5.supportsNativeVideoTracks = function () {
	  return !!(Html5.TEST_VID && Html5.TEST_VID.videoTracks);
	};
	
	/**
	 * Check to see if native `AudioTrack`s are supported by this browser/device
	 *
	 * @return {boolean}
	 *        - True if native `AudioTrack`s are supported.
	 *        - False otherwise
	 */
	Html5.supportsNativeAudioTracks = function () {
	  return !!(Html5.TEST_VID && Html5.TEST_VID.audioTracks);
	};
	
	/**
	 * An array of events available on the Html5 tech.
	 *
	 * @private
	 * @type {Array}
	 */
	Html5.Events = ['loadstart', 'suspend', 'abort', 'error', 'emptied', 'stalled', 'loadedmetadata', 'loadeddata', 'canplay', 'canplaythrough', 'playing', 'waiting', 'seeking', 'seeked', 'ended', 'durationchange', 'timeupdate', 'progress', 'play', 'pause', 'ratechange', 'resize', 'volumechange'];
	
	/**
	 * Boolean indicating whether the `Tech` supports volume control.
	 *
	 * @type {boolean}
	 * @default {@link Html5.canControlVolume}
	 */
	Html5.prototype.featuresVolumeControl = Html5.canControlVolume();
	
	/**
	 * Boolean indicating whether the `Tech` supports muting volume.
	 *
	 * @type {bolean}
	 * @default {@link Html5.canMuteVolume}
	 */
	Html5.prototype.featuresMuteControl = Html5.canMuteVolume();
	
	/**
	 * Boolean indicating whether the `Tech` supports changing the speed at which the media
	 * plays. Examples:
	 *   - Set player to play 2x (twice) as fast
	 *   - Set player to play 0.5x (half) as fast
	 *
	 * @type {boolean}
	 * @default {@link Html5.canControlPlaybackRate}
	 */
	Html5.prototype.featuresPlaybackRate = Html5.canControlPlaybackRate();
	
	/**
	 * Boolean indicating whether the `Tech` supports the `sourceset` event.
	 *
	 * @type {boolean}
	 * @default
	 */
	Html5.prototype.featuresSourceset = Html5.canOverrideAttributes();
	
	/**
	 * Boolean indicating whether the `HTML5` tech currently supports the media element
	 * moving in the DOM. iOS breaks if you move the media element, so this is set this to
	 * false there. Everywhere else this should be true.
	 *
	 * @type {boolean}
	 * @default
	 */
	Html5.prototype.movingMediaElementInDOM = !IS_IOS;
	
	// TODO: Previous comment: No longer appears to be used. Can probably be removed.
	//       Is this true?
	/**
	 * Boolean indicating whether the `HTML5` tech currently supports automatic media resize
	 * when going into fullscreen.
	 *
	 * @type {boolean}
	 * @default
	 */
	Html5.prototype.featuresFullscreenResize = true;
	
	/**
	 * Boolean indicating whether the `HTML5` tech currently supports the progress event.
	 * If this is false, manual `progress` events will be triggered instead.
	 *
	 * @type {boolean}
	 * @default
	 */
	Html5.prototype.featuresProgressEvents = true;
	
	/**
	 * Boolean indicating whether the `HTML5` tech currently supports the timeupdate event.
	 * If this is false, manual `timeupdate` events will be triggered instead.
	 *
	 * @default
	 */
	Html5.prototype.featuresTimeupdateEvents = true;
	
	/**
	 * Boolean indicating whether the `HTML5` tech currently supports native `TextTrack`s.
	 *
	 * @type {boolean}
	 * @default {@link Html5.supportsNativeTextTracks}
	 */
	Html5.prototype.featuresNativeTextTracks = Html5.supportsNativeTextTracks();
	
	/**
	 * Boolean indicating whether the `HTML5` tech currently supports native `VideoTrack`s.
	 *
	 * @type {boolean}
	 * @default {@link Html5.supportsNativeVideoTracks}
	 */
	Html5.prototype.featuresNativeVideoTracks = Html5.supportsNativeVideoTracks();
	
	/**
	 * Boolean indicating whether the `HTML5` tech currently supports native `AudioTrack`s.
	 *
	 * @type {boolean}
	 * @default {@link Html5.supportsNativeAudioTracks}
	 */
	Html5.prototype.featuresNativeAudioTracks = Html5.supportsNativeAudioTracks();
	
	// HTML5 Feature detection and Device Fixes --------------------------------- //
	var canPlayType = Html5.TEST_VID && Html5.TEST_VID.constructor.prototype.canPlayType;
	var mpegurlRE = /^application\/(?:x-|vnd\.apple\.)mpegurl/i;
	
	Html5.patchCanPlayType = function () {
	
	  // Android 4.0 and above can play HLS to some extent but it reports being unable to do so
	  // Firefox and Chrome report correctly
	  if (ANDROID_VERSION >= 4.0 && !IS_FIREFOX && !IS_CHROME) {
	    Html5.TEST_VID.constructor.prototype.canPlayType = function (type) {
	      if (type && mpegurlRE.test(type)) {
	        return 'maybe';
	      }
	      return canPlayType.call(this, type);
	    };
	  }
	};
	
	Html5.unpatchCanPlayType = function () {
	  var r = Html5.TEST_VID.constructor.prototype.canPlayType;
	
	  Html5.TEST_VID.constructor.prototype.canPlayType = canPlayType;
	  return r;
	};
	
	// by default, patch the media element
	Html5.patchCanPlayType();
	
	Html5.disposeMediaElement = function (el) {
	  if (!el) {
	    return;
	  }
	
	  if (el.parentNode) {
	    el.parentNode.removeChild(el);
	  }
	
	  // remove any child track or source nodes to prevent their loading
	  while (el.hasChildNodes()) {
	    el.removeChild(el.firstChild);
	  }
	
	  // remove any src reference. not setting `src=''` because that causes a warning
	  // in firefox
	  el.removeAttribute('src');
	
	  // force the media element to update its loading state by calling load()
	  // however IE on Windows 7N has a bug that throws an error so need a try/catch (#793)
	  if (typeof el.load === 'function') {
	    // wrapping in an iife so it's not deoptimized (#1060#discussion_r10324473)
	    (function () {
	      try {
	        el.load();
	      } catch (e) {
	        // not supported
	      }
	    })();
	  }
	};
	
	Html5.resetMediaElement = function (el) {
	  if (!el) {
	    return;
	  }
	
	  var sources = el.querySelectorAll('source');
	  var i = sources.length;
	
	  while (i--) {
	    el.removeChild(sources[i]);
	  }
	
	  // remove any src reference.
	  // not setting `src=''` because that throws an error
	  el.removeAttribute('src');
	
	  if (typeof el.load === 'function') {
	    // wrapping in an iife so it's not deoptimized (#1060#discussion_r10324473)
	    (function () {
	      try {
	        el.load();
	      } catch (e) {
	        // satisfy linter
	      }
	    })();
	  }
	};
	
	/* Native HTML5 element property wrapping ----------------------------------- */
	// Wrap native boolean attributes with getters that check both property and attribute
	// The list is as followed:
	// muted, defaultMuted, autoplay, controls, loop, playsinline
	[
	/**
	 * Get the value of `muted` from the media element. `muted` indicates
	 * that the volume for the media should be set to silent. This does not actually change
	 * the `volume` attribute.
	 *
	 * @method Html5#muted
	 * @return {boolean}
	 *         - True if the value of `volume` should be ignored and the audio set to silent.
	 *         - False if the value of `volume` should be used.
	 *
	 * @see [Spec]{@link https://www.w3.org/TR/html5/embedded-content-0.html#dom-media-muted}
	 */
	'muted',
	
	/**
	 * Get the value of `defaultMuted` from the media element. `defaultMuted` indicates
	 * whether the media should start muted or not. Only changes the default state of the
	 * media. `muted` and `defaultMuted` can have different values. {@link Html5#muted} indicates the
	 * current state.
	 *
	 * @method Html5#defaultMuted
	 * @return {boolean}
	 *         - The value of `defaultMuted` from the media element.
	 *         - True indicates that the media should start muted.
	 *         - False indicates that the media should not start muted
	 *
	 * @see [Spec]{@link https://www.w3.org/TR/html5/embedded-content-0.html#dom-media-defaultmuted}
	 */
	'defaultMuted',
	
	/**
	 * Get the value of `autoplay` from the media element. `autoplay` indicates
	 * that the media should start to play as soon as the page is ready.
	 *
	 * @method Html5#autoplay
	 * @return {boolean}
	 *         - The value of `autoplay` from the media element.
	 *         - True indicates that the media should start as soon as the page loads.
	 *         - False indicates that the media should not start as soon as the page loads.
	 *
	 * @see [Spec]{@link https://www.w3.org/TR/html5/embedded-content-0.html#attr-media-autoplay}
	 */
	'autoplay',
	
	/**
	 * Get the value of `controls` from the media element. `controls` indicates
	 * whether the native media controls should be shown or hidden.
	 *
	 * @method Html5#controls
	 * @return {boolean}
	 *         - The value of `controls` from the media element.
	 *         - True indicates that native controls should be showing.
	 *         - False indicates that native controls should be hidden.
	 *
	 * @see [Spec]{@link https://www.w3.org/TR/html5/embedded-content-0.html#attr-media-controls}
	 */
	'controls',
	
	/**
	 * Get the value of `loop` from the media element. `loop` indicates
	 * that the media should return to the start of the media and continue playing once
	 * it reaches the end.
	 *
	 * @method Html5#loop
	 * @return {boolean}
	 *         - The value of `loop` from the media element.
	 *         - True indicates that playback should seek back to start once
	 *           the end of a media is reached.
	 *         - False indicates that playback should not loop back to the start when the
	 *           end of the media is reached.
	 *
	 * @see [Spec]{@link https://www.w3.org/TR/html5/embedded-content-0.html#attr-media-loop}
	 */
	'loop',
	
	/**
	 * Get the value of `playsinline` from the media element. `playsinline` indicates
	 * to the browser that non-fullscreen playback is preferred when fullscreen
	 * playback is the native default, such as in iOS Safari.
	 *
	 * @method Html5#playsinline
	 * @return {boolean}
	 *         - The value of `playsinline` from the media element.
	 *         - True indicates that the media should play inline.
	 *         - False indicates that the media should not play inline.
	 *
	 * @see [Spec]{@link https://html.spec.whatwg.org/#attr-video-playsinline}
	 */
	'playsinline'].forEach(function (prop) {
	  Html5.prototype[prop] = function () {
	    return this.el_[prop] || this.el_.hasAttribute(prop);
	  };
	});
	
	// Wrap native boolean attributes with setters that set both property and attribute
	// The list is as followed:
	// setMuted, setDefaultMuted, setAutoplay, setLoop, setPlaysinline
	// setControls is special-cased above
	[
	/**
	 * Set the value of `muted` on the media element. `muted` indicates that the current
	 * audio level should be silent.
	 *
	 * @method Html5#setMuted
	 * @param {boolean} muted
	 *        - True if the audio should be set to silent
	 *        - False otherwise
	 *
	 * @see [Spec]{@link https://www.w3.org/TR/html5/embedded-content-0.html#dom-media-muted}
	 */
	'muted',
	
	/**
	 * Set the value of `defaultMuted` on the media element. `defaultMuted` indicates that the current
	 * audio level should be silent, but will only effect the muted level on intial playback..
	 *
	 * @method Html5.prototype.setDefaultMuted
	 * @param {boolean} defaultMuted
	 *        - True if the audio should be set to silent
	 *        - False otherwise
	 *
	 * @see [Spec]{@link https://www.w3.org/TR/html5/embedded-content-0.html#dom-media-defaultmuted}
	 */
	'defaultMuted',
	
	/**
	 * Set the value of `autoplay` on the media element. `autoplay` indicates
	 * that the media should start to play as soon as the page is ready.
	 *
	 * @method Html5#setAutoplay
	 * @param {boolean} autoplay
	 *         - True indicates that the media should start as soon as the page loads.
	 *         - False indicates that the media should not start as soon as the page loads.
	 *
	 * @see [Spec]{@link https://www.w3.org/TR/html5/embedded-content-0.html#attr-media-autoplay}
	 */
	'autoplay',
	
	/**
	 * Set the value of `loop` on the media element. `loop` indicates
	 * that the media should return to the start of the media and continue playing once
	 * it reaches the end.
	 *
	 * @method Html5#setLoop
	 * @param {boolean} loop
	 *         - True indicates that playback should seek back to start once
	 *           the end of a media is reached.
	 *         - False indicates that playback should not loop back to the start when the
	 *           end of the media is reached.
	 *
	 * @see [Spec]{@link https://www.w3.org/TR/html5/embedded-content-0.html#attr-media-loop}
	 */
	'loop',
	
	/**
	 * Set the value of `playsinline` from the media element. `playsinline` indicates
	 * to the browser that non-fullscreen playback is preferred when fullscreen
	 * playback is the native default, such as in iOS Safari.
	 *
	 * @method Html5#setPlaysinline
	 * @param {boolean} playsinline
	 *         - True indicates that the media should play inline.
	 *         - False indicates that the media should not play inline.
	 *
	 * @see [Spec]{@link https://html.spec.whatwg.org/#attr-video-playsinline}
	 */
	'playsinline'].forEach(function (prop) {
	  Html5.prototype['set' + toTitleCase(prop)] = function (v) {
	    this.el_[prop] = v;
	
	    if (v) {
	      this.el_.setAttribute(prop, prop);
	    } else {
	      this.el_.removeAttribute(prop);
	    }
	  };
	});
	
	// Wrap native properties with a getter
	// The list is as followed
	// paused, currentTime, buffered, volume, poster, preload, error, seeking
	// seekable, ended, playbackRate, defaultPlaybackRate, played, networkState
	// readyState, videoWidth, videoHeight
	[
	/**
	 * Get the value of `paused` from the media element. `paused` indicates whether the media element
	 * is currently paused or not.
	 *
	 * @method Html5#paused
	 * @return {boolean}
	 *         The value of `paused` from the media element.
	 *
	 * @see [Spec]{@link https://www.w3.org/TR/html5/embedded-content-0.html#dom-media-paused}
	 */
	'paused',
	
	/**
	 * Get the value of `currentTime` from the media element. `currentTime` indicates
	 * the current second that the media is at in playback.
	 *
	 * @method Html5#currentTime
	 * @return {number}
	 *         The value of `currentTime` from the media element.
	 *
	 * @see [Spec]{@link https://www.w3.org/TR/html5/embedded-content-0.html#dom-media-currenttime}
	 */
	'currentTime',
	
	/**
	 * Get the value of `buffered` from the media element. `buffered` is a `TimeRange`
	 * object that represents the parts of the media that are already downloaded and
	 * available for playback.
	 *
	 * @method Html5#buffered
	 * @return {TimeRange}
	 *         The value of `buffered` from the media element.
	 *
	 * @see [Spec]{@link https://www.w3.org/TR/html5/embedded-content-0.html#dom-media-buffered}
	 */
	'buffered',
	
	/**
	 * Get the value of `volume` from the media element. `volume` indicates
	 * the current playback volume of audio for a media. `volume` will be a value from 0
	 * (silent) to 1 (loudest and default).
	 *
	 * @method Html5#volume
	 * @return {number}
	 *         The value of `volume` from the media element. Value will be between 0-1.
	 *
	 * @see [Spec]{@link https://www.w3.org/TR/html5/embedded-content-0.html#dom-a-volume}
	 */
	'volume',
	
	/**
	 * Get the value of `poster` from the media element. `poster` indicates
	 * that the url of an image file that can/will be shown when no media data is available.
	 *
	 * @method Html5#poster
	 * @return {string}
	 *         The value of `poster` from the media element. Value will be a url to an
	 *         image.
	 *
	 * @see [Spec]{@link https://www.w3.org/TR/html5/embedded-content-0.html#attr-video-poster}
	 */
	'poster',
	
	/**
	 * Get the value of `preload` from the media element. `preload` indicates
	 * what should download before the media is interacted with. It can have the following
	 * values:
	 * - none: nothing should be downloaded
	 * - metadata: poster and the first few frames of the media may be downloaded to get
	 *   media dimensions and other metadata
	 * - auto: allow the media and metadata for the media to be downloaded before
	 *    interaction
	 *
	 * @method Html5#preload
	 * @return {string}
	 *         The value of `preload` from the media element. Will be 'none', 'metadata',
	 *         or 'auto'.
	 *
	 * @see [Spec]{@link https://www.w3.org/TR/html5/embedded-content-0.html#attr-media-preload}
	 */
	'preload',
	
	/**
	 * Get the value of the `error` from the media element. `error` indicates any
	 * MediaError that may have occurred during playback. If error returns null there is no
	 * current error.
	 *
	 * @method Html5#error
	 * @return {MediaError|null}
	 *         The value of `error` from the media element. Will be `MediaError` if there
	 *         is a current error and null otherwise.
	 *
	 * @see [Spec]{@link https://www.w3.org/TR/html5/embedded-content-0.html#dom-media-error}
	 */
	'error',
	
	/**
	 * Get the value of `seeking` from the media element. `seeking` indicates whether the
	 * media is currently seeking to a new position or not.
	 *
	 * @method Html5#seeking
	 * @return {boolean}
	 *         - The value of `seeking` from the media element.
	 *         - True indicates that the media is currently seeking to a new position.
	 *         - False indicates that the media is not seeking to a new position at this time.
	 *
	 * @see [Spec]{@link https://www.w3.org/TR/html5/embedded-content-0.html#dom-media-seeking}
	 */
	'seeking',
	
	/**
	 * Get the value of `seekable` from the media element. `seekable` returns a
	 * `TimeRange` object indicating ranges of time that can currently be `seeked` to.
	 *
	 * @method Html5#seekable
	 * @return {TimeRange}
	 *         The value of `seekable` from the media element. A `TimeRange` object
	 *         indicating the current ranges of time that can be seeked to.
	 *
	 * @see [Spec]{@link https://www.w3.org/TR/html5/embedded-content-0.html#dom-media-seekable}
	 */
	'seekable',
	
	/**
	 * Get the value of `ended` from the media element. `ended` indicates whether
	 * the media has reached the end or not.
	 *
	 * @method Html5#ended
	 * @return {boolean}
	 *         - The value of `ended` from the media element.
	 *         - True indicates that the media has ended.
	 *         - False indicates that the media has not ended.
	 *
	 * @see [Spec]{@link https://www.w3.org/TR/html5/embedded-content-0.html#dom-media-ended}
	 */
	'ended',
	
	/**
	 * Get the value of `playbackRate` from the media element. `playbackRate` indicates
	 * the rate at which the media is currently playing back. Examples:
	 *   - if playbackRate is set to 2, media will play twice as fast.
	 *   - if playbackRate is set to 0.5, media will play half as fast.
	 *
	 * @method Html5#playbackRate
	 * @return {number}
	 *         The value of `playbackRate` from the media element. A number indicating
	 *         the current playback speed of the media, where 1 is normal speed.
	 *
	 * @see [Spec]{@link https://www.w3.org/TR/html5/embedded-content-0.html#dom-media-playbackrate}
	 */
	'playbackRate',
	
	/**
	 * Get the value of `defaultPlaybackRate` from the media element. `defaultPlaybackRate` indicates
	 * the rate at which the media is currently playing back. This value will not indicate the current
	 * `playbackRate` after playback has started, use {@link Html5#playbackRate} for that.
	 *
	 * Examples:
	 *   - if defaultPlaybackRate is set to 2, media will play twice as fast.
	 *   - if defaultPlaybackRate is set to 0.5, media will play half as fast.
	 *
	 * @method Html5.prototype.defaultPlaybackRate
	 * @return {number}
	 *         The value of `defaultPlaybackRate` from the media element. A number indicating
	 *         the current playback speed of the media, where 1 is normal speed.
	 *
	 * @see [Spec]{@link https://www.w3.org/TR/html5/embedded-content-0.html#dom-media-playbackrate}
	 */
	'defaultPlaybackRate',
	
	/**
	 * Get the value of `played` from the media element. `played` returns a `TimeRange`
	 * object representing points in the media timeline that have been played.
	 *
	 * @method Html5#played
	 * @return {TimeRange}
	 *         The value of `played` from the media element. A `TimeRange` object indicating
	 *         the ranges of time that have been played.
	 *
	 * @see [Spec]{@link https://www.w3.org/TR/html5/embedded-content-0.html#dom-media-played}
	 */
	'played',
	
	/**
	 * Get the value of `networkState` from the media element. `networkState` indicates
	 * the current network state. It returns an enumeration from the following list:
	 * - 0: NETWORK_EMPTY
	 * - 1: NETWORK_IDLE
	 * - 2: NETWORK_LOADING
	 * - 3: NETWORK_NO_SOURCE
	 *
	 * @method Html5#networkState
	 * @return {number}
	 *         The value of `networkState` from the media element. This will be a number
	 *         from the list in the description.
	 *
	 * @see [Spec] {@link https://www.w3.org/TR/html5/embedded-content-0.html#dom-media-networkstate}
	 */
	'networkState',
	
	/**
	 * Get the value of `readyState` from the media element. `readyState` indicates
	 * the current state of the media element. It returns an enumeration from the
	 * following list:
	 * - 0: HAVE_NOTHING
	 * - 1: HAVE_METADATA
	 * - 2: HAVE_CURRENT_DATA
	 * - 3: HAVE_FUTURE_DATA
	 * - 4: HAVE_ENOUGH_DATA
	 *
	 * @method Html5#readyState
	 * @return {number}
	 *         The value of `readyState` from the media element. This will be a number
	 *         from the list in the description.
	 *
	 * @see [Spec] {@link https://www.w3.org/TR/html5/embedded-content-0.html#ready-states}
	 */
	'readyState',
	
	/**
	 * Get the value of `videoWidth` from the video element. `videoWidth` indicates
	 * the current width of the video in css pixels.
	 *
	 * @method Html5#videoWidth
	 * @return {number}
	 *         The value of `videoWidth` from the video element. This will be a number
	 *         in css pixels.
	 *
	 * @see [Spec] {@link https://www.w3.org/TR/html5/embedded-content-0.html#dom-video-videowidth}
	 */
	'videoWidth',
	
	/**
	 * Get the value of `videoHeight` from the video element. `videoHeight` indicates
	 * the current height of the video in css pixels.
	 *
	 * @method Html5#videoHeight
	 * @return {number}
	 *         The value of `videoHeight` from the video element. This will be a number
	 *         in css pixels.
	 *
	 * @see [Spec] {@link https://www.w3.org/TR/html5/embedded-content-0.html#dom-video-videowidth}
	 */
	'videoHeight'].forEach(function (prop) {
	  Html5.prototype[prop] = function () {
	    return this.el_[prop];
	  };
	});
	
	// Wrap native properties with a setter in this format:
	// set + toTitleCase(name)
	// The list is as follows:
	// setVolume, setSrc, setPoster, setPreload, setPlaybackRate, setDefaultPlaybackRate
	[
	/**
	 * Set the value of `volume` on the media element. `volume` indicates the current
	 * audio level as a percentage in decimal form. This means that 1 is 100%, 0.5 is 50%, and
	 * so on.
	 *
	 * @method Html5#setVolume
	 * @param {number} percentAsDecimal
	 *        The volume percent as a decimal. Valid range is from 0-1.
	 *
	 * @see [Spec]{@link https://www.w3.org/TR/html5/embedded-content-0.html#dom-a-volume}
	 */
	'volume',
	
	/**
	 * Set the value of `src` on the media element. `src` indicates the current
	 * {@link Tech~SourceObject} for the media.
	 *
	 * @method Html5#setSrc
	 * @param {Tech~SourceObject} src
	 *        The source object to set as the current source.
	 *
	 * @see [Spec]{@link https://www.w3.org/TR/html5/embedded-content-0.html#dom-media-src}
	 */
	'src',
	
	/**
	 * Set the value of `poster` on the media element. `poster` is the url to
	 * an image file that can/will be shown when no media data is available.
	 *
	 * @method Html5#setPoster
	 * @param {string} poster
	 *        The url to an image that should be used as the `poster` for the media
	 *        element.
	 *
	 * @see [Spec]{@link https://www.w3.org/TR/html5/embedded-content-0.html#attr-media-poster}
	 */
	'poster',
	
	/**
	 * Set the value of `preload` on the media element. `preload` indicates
	 * what should download before the media is interacted with. It can have the following
	 * values:
	 * - none: nothing should be downloaded
	 * - metadata: poster and the first few frames of the media may be downloaded to get
	 *   media dimensions and other metadata
	 * - auto: allow the media and metadata for the media to be downloaded before
	 *    interaction
	 *
	 * @method Html5#setPreload
	 * @param {string} preload
	 *         The value of `preload` to set on the media element. Must be 'none', 'metadata',
	 *         or 'auto'.
	 *
	 * @see [Spec]{@link https://www.w3.org/TR/html5/embedded-content-0.html#attr-media-preload}
	 */
	'preload',
	
	/**
	 * Set the value of `playbackRate` on the media element. `playbackRate` indicates
	 * the rate at which the media should play back. Examples:
	 *   - if playbackRate is set to 2, media will play twice as fast.
	 *   - if playbackRate is set to 0.5, media will play half as fast.
	 *
	 * @method Html5#setPlaybackRate
	 * @return {number}
	 *         The value of `playbackRate` from the media element. A number indicating
	 *         the current playback speed of the media, where 1 is normal speed.
	 *
	 * @see [Spec]{@link https://www.w3.org/TR/html5/embedded-content-0.html#dom-media-playbackrate}
	 */
	'playbackRate',
	
	/**
	 * Set the value of `defaultPlaybackRate` on the media element. `defaultPlaybackRate` indicates
	 * the rate at which the media should play back upon initial startup. Changing this value
	 * after a video has started will do nothing. Instead you should used {@link Html5#setPlaybackRate}.
	 *
	 * Example Values:
	 *   - if playbackRate is set to 2, media will play twice as fast.
	 *   - if playbackRate is set to 0.5, media will play half as fast.
	 *
	 * @method Html5.prototype.setDefaultPlaybackRate
	 * @return {number}
	 *         The value of `defaultPlaybackRate` from the media element. A number indicating
	 *         the current playback speed of the media, where 1 is normal speed.
	 *
	 * @see [Spec]{@link https://www.w3.org/TR/html5/embedded-content-0.html#dom-media-defaultplaybackrate}
	 */
	'defaultPlaybackRate'].forEach(function (prop) {
	  Html5.prototype['set' + toTitleCase(prop)] = function (v) {
	    this.el_[prop] = v;
	  };
	});
	
	// wrap native functions with a function
	// The list is as follows:
	// pause, load, play
	[
	/**
	 * A wrapper around the media elements `pause` function. This will call the `HTML5`
	 * media elements `pause` function.
	 *
	 * @method Html5#pause
	 * @see [Spec]{@link https://www.w3.org/TR/html5/embedded-content-0.html#dom-media-pause}
	 */
	'pause',
	
	/**
	 * A wrapper around the media elements `load` function. This will call the `HTML5`s
	 * media element `load` function.
	 *
	 * @method Html5#load
	 * @see [Spec]{@link https://www.w3.org/TR/html5/embedded-content-0.html#dom-media-load}
	 */
	'load',
	
	/**
	 * A wrapper around the media elements `play` function. This will call the `HTML5`s
	 * media element `play` function.
	 *
	 * @method Html5#play
	 * @see [Spec]{@link https://www.w3.org/TR/html5/embedded-content-0.html#dom-media-play}
	 */
	'play'].forEach(function (prop) {
	  Html5.prototype[prop] = function () {
	    return this.el_[prop]();
	  };
	});
	
	Tech.withSourceHandlers(Html5);
	
	/**
	 * Native source handler for Html5, simply passes the source to the media element.
	 *
	 * @property {Tech~SourceObject} source
	 *        The source object
	 *
	 * @property {Html5} tech
	 *        The instance of the HTML5 tech.
	 */
	Html5.nativeSourceHandler = {};
	
	/**
	 * Check if the media element can play the given mime type.
	 *
	 * @param {string} type
	 *        The mimetype to check
	 *
	 * @return {string}
	 *         'probably', 'maybe', or '' (empty string)
	 */
	Html5.nativeSourceHandler.canPlayType = function (type) {
	  // IE without MediaPlayer throws an error (#519)
	  try {
	    return Html5.TEST_VID.canPlayType(type);
	  } catch (e) {
	    return '';
	  }
	};
	
	/**
	 * Check if the media element can handle a source natively.
	 *
	 * @param {Tech~SourceObject} source
	 *         The source object
	 *
	 * @param {Object} [options]
	 *         Options to be passed to the tech.
	 *
	 * @return {string}
	 *         'probably', 'maybe', or '' (empty string).
	 */
	Html5.nativeSourceHandler.canHandleSource = function (source, options) {
	
	  // If a type was provided we should rely on that
	  if (source.type) {
	    return Html5.nativeSourceHandler.canPlayType(source.type);
	
	    // If no type, fall back to checking 'video/[EXTENSION]'
	  } else if (source.src) {
	    var ext = getFileExtension(source.src);
	
	    return Html5.nativeSourceHandler.canPlayType('video/' + ext);
	  }
	
	  return '';
	};
	
	/**
	 * Pass the source to the native media element.
	 *
	 * @param {Tech~SourceObject} source
	 *        The source object
	 *
	 * @param {Html5} tech
	 *        The instance of the Html5 tech
	 *
	 * @param {Object} [options]
	 *        The options to pass to the source
	 */
	Html5.nativeSourceHandler.handleSource = function (source, tech, options) {
	  tech.setSrc(source.src);
	};
	
	/**
	 * A noop for the native dispose function, as cleanup is not needed.
	 */
	Html5.nativeSourceHandler.dispose = function () {};
	
	// Register the native source handler
	Html5.registerSourceHandler(Html5.nativeSourceHandler);
	
	Tech.registerTech('Html5', Html5);
	
	var _templateObject$2 = taggedTemplateLiteralLoose(['\n        Using the tech directly can be dangerous. I hope you know what you\'re doing.\n        See https://github.com/videojs/video.js/issues/2617 for more info.\n      '], ['\n        Using the tech directly can be dangerous. I hope you know what you\'re doing.\n        See https://github.com/videojs/video.js/issues/2617 for more info.\n      ']);
	
	// The following tech events are simply re-triggered
	// on the player when they happen
	var TECH_EVENTS_RETRIGGER = [
	/**
	 * Fired while the user agent is downloading media data.
	 *
	 * @event Player#progress
	 * @type {EventTarget~Event}
	 */
	/**
	 * Retrigger the `progress` event that was triggered by the {@link Tech}.
	 *
	 * @private
	 * @method Player#handleTechProgress_
	 * @fires Player#progress
	 * @listens Tech#progress
	 */
	'progress',
	
	/**
	 * Fires when the loading of an audio/video is aborted.
	 *
	 * @event Player#abort
	 * @type {EventTarget~Event}
	 */
	/**
	 * Retrigger the `abort` event that was triggered by the {@link Tech}.
	 *
	 * @private
	 * @method Player#handleTechAbort_
	 * @fires Player#abort
	 * @listens Tech#abort
	 */
	'abort',
	
	/**
	 * Fires when the browser is intentionally not getting media data.
	 *
	 * @event Player#suspend
	 * @type {EventTarget~Event}
	 */
	/**
	 * Retrigger the `suspend` event that was triggered by the {@link Tech}.
	 *
	 * @private
	 * @method Player#handleTechSuspend_
	 * @fires Player#suspend
	 * @listens Tech#suspend
	 */
	'suspend',
	
	/**
	 * Fires when the current playlist is empty.
	 *
	 * @event Player#emptied
	 * @type {EventTarget~Event}
	 */
	/**
	 * Retrigger the `emptied` event that was triggered by the {@link Tech}.
	 *
	 * @private
	 * @method Player#handleTechEmptied_
	 * @fires Player#emptied
	 * @listens Tech#emptied
	 */
	'emptied',
	/**
	 * Fires when the browser is trying to get media data, but data is not available.
	 *
	 * @event Player#stalled
	 * @type {EventTarget~Event}
	 */
	/**
	 * Retrigger the `stalled` event that was triggered by the {@link Tech}.
	 *
	 * @private
	 * @method Player#handleTechStalled_
	 * @fires Player#stalled
	 * @listens Tech#stalled
	 */
	'stalled',
	
	/**
	 * Fires when the browser has loaded meta data for the audio/video.
	 *
	 * @event Player#loadedmetadata
	 * @type {EventTarget~Event}
	 */
	/**
	 * Retrigger the `stalled` event that was triggered by the {@link Tech}.
	 *
	 * @private
	 * @method Player#handleTechLoadedmetadata_
	 * @fires Player#loadedmetadata
	 * @listens Tech#loadedmetadata
	 */
	'loadedmetadata',
	
	/**
	 * Fires when the browser has loaded the current frame of the audio/video.
	 *
	 * @event Player#loadeddata
	 * @type {event}
	 */
	/**
	 * Retrigger the `loadeddata` event that was triggered by the {@link Tech}.
	 *
	 * @private
	 * @method Player#handleTechLoaddeddata_
	 * @fires Player#loadeddata
	 * @listens Tech#loadeddata
	 */
	'loadeddata',
	
	/**
	 * Fires when the current playback position has changed.
	 *
	 * @event Player#timeupdate
	 * @type {event}
	 */
	/**
	 * Retrigger the `timeupdate` event that was triggered by the {@link Tech}.
	 *
	 * @private
	 * @method Player#handleTechTimeUpdate_
	 * @fires Player#timeupdate
	 * @listens Tech#timeupdate
	 */
	'timeupdate',
	
	/**
	 * Fires when the video's intrinsic dimensions change
	 *
	 * @event Player#resize
	 * @type {event}
	 */
	/**
	 * Retrigger the `resize` event that was triggered by the {@link Tech}.
	 *
	 * @private
	 * @method Player#handleTechResize_
	 * @fires Player#resize
	 * @listens Tech#resize
	 */
	'resize',
	
	/**
	 * Fires when the volume has been changed
	 *
	 * @event Player#volumechange
	 * @type {event}
	 */
	/**
	 * Retrigger the `volumechange` event that was triggered by the {@link Tech}.
	 *
	 * @private
	 * @method Player#handleTechVolumechange_
	 * @fires Player#volumechange
	 * @listens Tech#volumechange
	 */
	'volumechange',
	
	/**
	 * Fires when the text track has been changed
	 *
	 * @event Player#texttrackchange
	 * @type {event}
	 */
	/**
	 * Retrigger the `texttrackchange` event that was triggered by the {@link Tech}.
	 *
	 * @private
	 * @method Player#handleTechTexttrackchange_
	 * @fires Player#texttrackchange
	 * @listens Tech#texttrackchange
	 */
	'texttrackchange'];
	
	// events to queue when playback rate is zero
	// this is a hash for the sole purpose of mapping non-camel-cased event names
	// to camel-cased function names
	var TECH_EVENTS_QUEUE = {
	  canplay: 'CanPlay',
	  canplaythrough: 'CanPlayThrough',
	  playing: 'Playing',
	  seeked: 'Seeked'
	};
	
	/**
	 * An instance of the `Player` class is created when any of the Video.js setup methods
	 * are used to initialize a video.
	 *
	 * After an instance has been created it can be accessed globally in two ways:
	 * 1. By calling `videojs('example_video_1');`
	 * 2. By using it directly via  `videojs.players.example_video_1;`
	 *
	 * @extends Component
	 */
	
	var Player = function (_Component) {
	  inherits(Player, _Component);
	
	  /**
	   * Create an instance of this class.
	   *
	   * @param {Element} tag
	   *        The original video DOM element used for configuring options.
	   *
	   * @param {Object} [options]
	   *        Object of option names and values.
	   *
	   * @param {Component~ReadyCallback} [ready]
	   *        Ready callback function.
	   */
	  function Player(tag, options, ready) {
	    classCallCheck(this, Player);
	
	    // Make sure tag ID exists
	    tag.id = tag.id || options.id || 'vjs_video_' + newGUID();
	
	    // Set Options
	    // The options argument overrides options set in the video tag
	    // which overrides globally set options.
	    // This latter part coincides with the load order
	    // (tag must exist before Player)
	    options = assign(Player.getTagSettings(tag), options);
	
	    // Delay the initialization of children because we need to set up
	    // player properties first, and can't use `this` before `super()`
	    options.initChildren = false;
	
	    // Same with creating the element
	    options.createEl = false;
	
	    // don't auto mixin the evented mixin
	    options.evented = false;
	
	    // we don't want the player to report touch activity on itself
	    // see enableTouchActivity in Component
	    options.reportTouchActivity = false;
	
	    // If language is not set, get the closest lang attribute
	    if (!options.language) {
	      if (typeof tag.closest === 'function') {
	        var closest = tag.closest('[lang]');
	
	        if (closest && closest.getAttribute) {
	          options.language = closest.getAttribute('lang');
	        }
	      } else {
	        var element = tag;
	
	        while (element && element.nodeType === 1) {
	          if (getAttributes(element).hasOwnProperty('lang')) {
	            options.language = element.getAttribute('lang');
	            break;
	          }
	          element = element.parentNode;
	        }
	      }
	    }
	
	    // Run base component initializing with new options
	
	    // Tracks when a tech changes the poster
	    var _this = possibleConstructorReturn(this, _Component.call(this, null, options, ready));
	
	    _this.isPosterFromTech_ = false;
	
	    // Holds callback info that gets queued when playback rate is zero
	    // and a seek is happening
	    _this.queuedCallbacks_ = [];
	
	    // Turn off API access because we're loading a new tech that might load asynchronously
	    _this.isReady_ = false;
	
	    // Init state hasStarted_
	    _this.hasStarted_ = false;
	
	    // Init state userActive_
	    _this.userActive_ = false;
	
	    // if the global option object was accidentally blown away by
	    // someone, bail early with an informative error
	    if (!_this.options_ || !_this.options_.techOrder || !_this.options_.techOrder.length) {
	      throw new Error('No techOrder specified. Did you overwrite ' + 'videojs.options instead of just changing the ' + 'properties you want to override?');
	    }
	
	    // Store the original tag used to set options
	    _this.tag = tag;
	
	    // Store the tag attributes used to restore html5 element
	    _this.tagAttributes = tag && getAttributes(tag);
	
	    // Update current language
	    _this.language(_this.options_.language);
	
	    // Update Supported Languages
	    if (options.languages) {
	      // Normalise player option languages to lowercase
	      var languagesToLower = {};
	
	      Object.getOwnPropertyNames(options.languages).forEach(function (name$$1) {
	        languagesToLower[name$$1.toLowerCase()] = options.languages[name$$1];
	      });
	      _this.languages_ = languagesToLower;
	    } else {
	      _this.languages_ = Player.prototype.options_.languages;
	    }
	
	    // Cache for video property values.
	    _this.cache_ = {};
	
	    // Set poster
	    _this.poster_ = options.poster || '';
	
	    // Set controls
	    _this.controls_ = !!options.controls;
	
	    // Set default values for lastVolume
	    _this.cache_.lastVolume = 1;
	
	    // Original tag settings stored in options
	    // now remove immediately so native controls don't flash.
	    // May be turned back on by HTML5 tech if nativeControlsForTouch is true
	    tag.controls = false;
	    tag.removeAttribute('controls');
	
	    // the attribute overrides the option
	    if (tag.hasAttribute('autoplay')) {
	      _this.options_.autoplay = true;
	    } else {
	      // otherwise use the setter to validate and
	      // set the correct value.
	      _this.autoplay(_this.options_.autoplay);
	    }
	
	    /*
	     * Store the internal state of scrubbing
	     *
	     * @private
	     * @return {Boolean} True if the user is scrubbing
	     */
	    _this.scrubbing_ = false;
	
	    _this.el_ = _this.createEl();
	
	    // Set default value for lastPlaybackRate
	    _this.cache_.lastPlaybackRate = _this.defaultPlaybackRate();
	
	    // Make this an evented object and use `el_` as its event bus.
	    evented(_this, { eventBusKey: 'el_' });
	
	    // We also want to pass the original player options to each component and plugin
	    // as well so they don't need to reach back into the player for options later.
	    // We also need to do another copy of this.options_ so we don't end up with
	    // an infinite loop.
	    var playerOptionsCopy = mergeOptions(_this.options_);
	
	    // Load plugins
	    if (options.plugins) {
	      var plugins = options.plugins;
	
	      Object.keys(plugins).forEach(function (name$$1) {
	        if (typeof this[name$$1] === 'function') {
	          this[name$$1](plugins[name$$1]);
	        } else {
	          throw new Error('plugin "' + name$$1 + '" does not exist');
	        }
	      }, _this);
	    }
	
	    _this.options_.playerOptions = playerOptionsCopy;
	
	    _this.middleware_ = [];
	
	    _this.initChildren();
	
	    // Set isAudio based on whether or not an audio tag was used
	    _this.isAudio(tag.nodeName.toLowerCase() === 'audio');
	
	    // Update controls className. Can't do this when the controls are initially
	    // set because the element doesn't exist yet.
	    if (_this.controls()) {
	      _this.addClass('vjs-controls-enabled');
	    } else {
	      _this.addClass('vjs-controls-disabled');
	    }
	
	    // Set ARIA label and region role depending on player type
	    _this.el_.setAttribute('role', 'region');
	    if (_this.isAudio()) {
	      _this.el_.setAttribute('aria-label', _this.localize('Audio Player'));
	    } else {
	      _this.el_.setAttribute('aria-label', _this.localize('Video Player'));
	    }
	
	    if (_this.isAudio()) {
	      _this.addClass('vjs-audio');
	    }
	
	    if (_this.flexNotSupported_()) {
	      _this.addClass('vjs-no-flex');
	    }
	
	    // TODO: Make this smarter. Toggle user state between touching/mousing
	    // using events, since devices can have both touch and mouse events.
	    // if (browser.TOUCH_ENABLED) {
	    //   this.addClass('vjs-touch-enabled');
	    // }
	
	    // iOS Safari has broken hover handling
	    if (!IS_IOS) {
	      _this.addClass('vjs-workinghover');
	    }
	
	    // Make player easily findable by ID
	    Player.players[_this.id_] = _this;
	
	    // Add a major version class to aid css in plugins
	    var majorVersion = version.split('.')[0];
	
	    _this.addClass('vjs-v' + majorVersion);
	
	    // When the player is first initialized, trigger activity so components
	    // like the control bar show themselves if needed
	    _this.userActive(true);
	    _this.reportUserActivity();
	
	    _this.one('play', _this.listenForUserActivity_);
	    _this.on('fullscreenchange', _this.handleFullscreenChange_);
	    _this.on('stageclick', _this.handleStageClick_);
	
	    _this.changingSrc_ = false;
	    _this.playWaitingForReady_ = false;
	    _this.playOnLoadstart_ = null;
	    return _this;
	  }
	
	  /**
	   * Destroys the video player and does any necessary cleanup.
	   *
	   * This is especially helpful if you are dynamically adding and removing videos
	   * to/from the DOM.
	   *
	   * @fires Player#dispose
	   */
	
	
	  Player.prototype.dispose = function dispose() {
	    /**
	     * Called when the player is being disposed of.
	     *
	     * @event Player#dispose
	     * @type {EventTarget~Event}
	     */
	    this.trigger('dispose');
	    // prevent dispose from being called twice
	    this.off('dispose');
	
	    if (this.styleEl_ && this.styleEl_.parentNode) {
	      this.styleEl_.parentNode.removeChild(this.styleEl_);
	      this.styleEl_ = null;
	    }
	
	    // Kill reference to this player
	    Player.players[this.id_] = null;
	
	    if (this.tag && this.tag.player) {
	      this.tag.player = null;
	    }
	
	    if (this.el_ && this.el_.player) {
	      this.el_.player = null;
	    }
	
	    if (this.tech_) {
	      this.tech_.dispose();
	      this.isPosterFromTech_ = false;
	      this.poster_ = '';
	    }
	
	    if (this.playerElIngest_) {
	      this.playerElIngest_ = null;
	    }
	
	    if (this.tag) {
	      this.tag = null;
	    }
	
	    clearCacheForPlayer(this);
	
	    // the actual .el_ is removed here
	    _Component.prototype.dispose.call(this);
	  };
	
	  /**
	   * Create the `Player`'s DOM element.
	   *
	   * @return {Element}
	   *         The DOM element that gets created.
	   */
	
	
	  Player.prototype.createEl = function createEl$$1() {
	    var tag = this.tag;
	    var el = void 0;
	    var playerElIngest = this.playerElIngest_ = tag.parentNode && tag.parentNode.hasAttribute && tag.parentNode.hasAttribute('data-vjs-player');
	    var divEmbed = this.tag.tagName.toLowerCase() === 'video-js';
	
	    if (playerElIngest) {
	      el = this.el_ = tag.parentNode;
	    } else if (!divEmbed) {
	      el = this.el_ = _Component.prototype.createEl.call(this, 'div');
	    }
	
	    // Copy over all the attributes from the tag, including ID and class
	    // ID will now reference player box, not the video tag
	    var attrs = getAttributes(tag);
	
	    if (divEmbed) {
	      el = this.el_ = tag;
	      tag = this.tag = document.createElement('video');
	      while (el.children.length) {
	        tag.appendChild(el.firstChild);
	      }
	
	      if (!hasClass(el, 'video-js')) {
	        addClass(el, 'video-js');
	      }
	
	      el.appendChild(tag);
	
	      playerElIngest = this.playerElIngest_ = el;
	      // move properties over from our custom `video-js` element
	      // to our new `video` element. This will move things like
	      // `src` or `controls` that were set via js before the player
	      // was initialized.
	      Object.keys(el).forEach(function (k) {
	        tag[k] = el[k];
	      });
	    }
	
	    // set tabindex to -1 to remove the video element from the focus order
	    tag.setAttribute('tabindex', '-1');
	    attrs.tabindex = '-1';
	
	    // Workaround for #4583 (JAWS+IE doesn't announce BPB or play button)
	    // See https://github.com/FreedomScientific/VFO-standards-support/issues/78
	    // Note that we can't detect if JAWS is being used, but this ARIA attribute
	    //  doesn't change behavior of IE11 if JAWS is not being used
	    if (IE_VERSION) {
	      tag.setAttribute('role', 'application');
	      attrs.role = 'application';
	    }
	
	    // Remove width/height attrs from tag so CSS can make it 100% width/height
	    tag.removeAttribute('width');
	    tag.removeAttribute('height');
	
	    if ('width' in attrs) {
	      delete attrs.width;
	    }
	    if ('height' in attrs) {
	      delete attrs.height;
	    }
	
	    Object.getOwnPropertyNames(attrs).forEach(function (attr) {
	      // don't copy over the class attribute to the player element when we're in a div embed
	      // the class is already set up properly in the divEmbed case
	      // and we want to make sure that the `video-js` class doesn't get lost
	      if (!(divEmbed && attr === 'class')) {
	        el.setAttribute(attr, attrs[attr]);
	      }
	
	      if (divEmbed) {
	        tag.setAttribute(attr, attrs[attr]);
	      }
	    });
	
	    // Update tag id/class for use as HTML5 playback tech
	    // Might think we should do this after embedding in container so .vjs-tech class
	    // doesn't flash 100% width/height, but class only applies with .video-js parent
	    tag.playerId = tag.id;
	    tag.id += '_html5_api';
	    tag.className = 'vjs-tech';
	
	    // Make player findable on elements
	    tag.player = el.player = this;
	    // Default state of video is paused
	    this.addClass('vjs-paused');
	
	    // Add a style element in the player that we'll use to set the width/height
	    // of the player in a way that's still overrideable by CSS, just like the
	    // video element
	    if (window$1.VIDEOJS_NO_DYNAMIC_STYLE !== true) {
	      this.styleEl_ = createStyleElement('vjs-styles-dimensions');
	      var defaultsStyleEl = $('.vjs-styles-defaults');
	      var head = $('head');
	
	      head.insertBefore(this.styleEl_, defaultsStyleEl ? defaultsStyleEl.nextSibling : head.firstChild);
	    }
	
	    // Pass in the width/height/aspectRatio options which will update the style el
	    this.width(this.options_.width);
	    this.height(this.options_.height);
	    this.fluid(this.options_.fluid);
	    this.aspectRatio(this.options_.aspectRatio);
	
	    // Hide any links within the video/audio tag,
	    // because IE doesn't hide them completely from screen readers.
	    var links = tag.getElementsByTagName('a');
	
	    for (var i = 0; i < links.length; i++) {
	      var linkEl = links.item(i);
	
	      addClass(linkEl, 'vjs-hidden');
	      linkEl.setAttribute('hidden', 'hidden');
	    }
	
	    // insertElFirst seems to cause the networkState to flicker from 3 to 2, so
	    // keep track of the original for later so we can know if the source originally failed
	    tag.initNetworkState_ = tag.networkState;
	
	    // Wrap video tag in div (el/box) container
	    if (tag.parentNode && !playerElIngest) {
	      tag.parentNode.insertBefore(el, tag);
	    }
	
	    // insert the tag as the first child of the player element
	    // then manually add it to the children array so that this.addChild
	    // will work properly for other components
	    //
	    // Breaks iPhone, fixed in HTML5 setup.
	    prependTo(tag, el);
	    this.children_.unshift(tag);
	
	    // Set lang attr on player to ensure CSS :lang() in consistent with player
	    // if it's been set to something different to the doc
	    this.el_.setAttribute('lang', this.language_);
	
	    this.el_ = el;
	
	    return el;
	  };
	
	  /**
	   * A getter/setter for the `Player`'s width. Returns the player's configured value.
	   * To get the current width use `currentWidth()`.
	   *
	   * @param {number} [value]
	   *        The value to set the `Player`'s width to.
	   *
	   * @return {number}
	   *         The current width of the `Player` when getting.
	   */
	
	
	  Player.prototype.width = function width(value) {
	    return this.dimension('width', value);
	  };
	
	  /**
	   * A getter/setter for the `Player`'s height. Returns the player's configured value.
	   * To get the current height use `currentheight()`.
	   *
	   * @param {number} [value]
	   *        The value to set the `Player`'s heigth to.
	   *
	   * @return {number}
	   *         The current height of the `Player` when getting.
	   */
	
	
	  Player.prototype.height = function height(value) {
	    return this.dimension('height', value);
	  };
	
	  /**
	   * A getter/setter for the `Player`'s width & height.
	   *
	   * @param {string} dimension
	   *        This string can be:
	   *        - 'width'
	   *        - 'height'
	   *
	   * @param {number} [value]
	   *        Value for dimension specified in the first argument.
	   *
	   * @return {number}
	   *         The dimension arguments value when getting (width/height).
	   */
	
	
	  Player.prototype.dimension = function dimension(_dimension, value) {
	    var privDimension = _dimension + '_';
	
	    if (value === undefined) {
	      return this[privDimension] || 0;
	    }
	
	    if (value === '') {
	      // If an empty string is given, reset the dimension to be automatic
	      this[privDimension] = undefined;
	      this.updateStyleEl_();
	      return;
	    }
	
	    var parsedVal = parseFloat(value);
	
	    if (isNaN(parsedVal)) {
	      log$1.error('Improper value "' + value + '" supplied for for ' + _dimension);
	      return;
	    }
	
	    this[privDimension] = parsedVal;
	    this.updateStyleEl_();
	  };
	
	  /**
	   * A getter/setter/toggler for the vjs-fluid `className` on the `Player`.
	   *
	   * @param {boolean} [bool]
	   *        - A value of true adds the class.
	   *        - A value of false removes the class.
	   *        - No value will toggle the fluid class.
	   *
	   * @return {boolean|undefined}
	   *         - The value of fluid when getting.
	   *         - `undefined` when setting.
	   */
	
	
	  Player.prototype.fluid = function fluid(bool) {
	    if (bool === undefined) {
	      return !!this.fluid_;
	    }
	
	    this.fluid_ = !!bool;
	
	    if (bool) {
	      this.addClass('vjs-fluid');
	    } else {
	      this.removeClass('vjs-fluid');
	    }
	
	    this.updateStyleEl_();
	  };
	
	  /**
	   * Get/Set the aspect ratio
	   *
	   * @param {string} [ratio]
	   *        Aspect ratio for player
	   *
	   * @return {string|undefined}
	   *         returns the current aspect ratio when getting
	   */
	
	  /**
	   * A getter/setter for the `Player`'s aspect ratio.
	   *
	   * @param {string} [ratio]
	   *        The value to set the `Player's aspect ratio to.
	   *
	   * @return {string|undefined}
	   *         - The current aspect ratio of the `Player` when getting.
	   *         - undefined when setting
	   */
	
	
	  Player.prototype.aspectRatio = function aspectRatio(ratio) {
	    if (ratio === undefined) {
	      return this.aspectRatio_;
	    }
	
	    // Check for width:height format
	    if (!/^\d+\:\d+$/.test(ratio)) {
	      throw new Error('Improper value supplied for aspect ratio. The format should be width:height, for example 16:9.');
	    }
	    this.aspectRatio_ = ratio;
	
	    // We're assuming if you set an aspect ratio you want fluid mode,
	    // because in fixed mode you could calculate width and height yourself.
	    this.fluid(true);
	
	    this.updateStyleEl_();
	  };
	
	  /**
	   * Update styles of the `Player` element (height, width and aspect ratio).
	   *
	   * @private
	   * @listens Tech#loadedmetadata
	   */
	
	
	  Player.prototype.updateStyleEl_ = function updateStyleEl_() {
	    if (window$1.VIDEOJS_NO_DYNAMIC_STYLE === true) {
	      var _width = typeof this.width_ === 'number' ? this.width_ : this.options_.width;
	      var _height = typeof this.height_ === 'number' ? this.height_ : this.options_.height;
	      var techEl = this.tech_ && this.tech_.el();
	
	      if (techEl) {
	        if (_width >= 0) {
	          techEl.width = _width;
	        }
	        if (_height >= 0) {
	          techEl.height = _height;
	        }
	      }
	
	      return;
	    }
	
	    var width = void 0;
	    var height = void 0;
	    var aspectRatio = void 0;
	    var idClass = void 0;
	
	    // The aspect ratio is either used directly or to calculate width and height.
	    if (this.aspectRatio_ !== undefined && this.aspectRatio_ !== 'auto') {
	      // Use any aspectRatio that's been specifically set
	      aspectRatio = this.aspectRatio_;
	    } else if (this.videoWidth() > 0) {
	      // Otherwise try to get the aspect ratio from the video metadata
	      aspectRatio = this.videoWidth() + ':' + this.videoHeight();
	    } else {
	      // Or use a default. The video element's is 2:1, but 16:9 is more common.
	      aspectRatio = '16:9';
	    }
	
	    // Get the ratio as a decimal we can use to calculate dimensions
	    var ratioParts = aspectRatio.split(':');
	    var ratioMultiplier = ratioParts[1] / ratioParts[0];
	
	    if (this.width_ !== undefined) {
	      // Use any width that's been specifically set
	      width = this.width_;
	    } else if (this.height_ !== undefined) {
	      // Or calulate the width from the aspect ratio if a height has been set
	      width = this.height_ / ratioMultiplier;
	    } else {
	      // Or use the video's metadata, or use the video el's default of 300
	      width = this.videoWidth() || 300;
	    }
	
	    if (this.height_ !== undefined) {
	      // Use any height that's been specifically set
	      height = this.height_;
	    } else {
	      // Otherwise calculate the height from the ratio and the width
	      height = width * ratioMultiplier;
	    }
	
	    // Ensure the CSS class is valid by starting with an alpha character
	    if (/^[^a-zA-Z]/.test(this.id())) {
	      idClass = 'dimensions-' + this.id();
	    } else {
	      idClass = this.id() + '-dimensions';
	    }
	
	    // Ensure the right class is still on the player for the style element
	    this.addClass(idClass);
	
	    setTextContent(this.styleEl_, '\n      .' + idClass + ' {\n        width: ' + width + 'px;\n        height: ' + height + 'px;\n      }\n\n      .' + idClass + '.vjs-fluid {\n        padding-top: ' + ratioMultiplier * 100 + '%;\n      }\n    ');
	  };
	
	  /**
	   * Load/Create an instance of playback {@link Tech} including element
	   * and API methods. Then append the `Tech` element in `Player` as a child.
	   *
	   * @param {string} techName
	   *        name of the playback technology
	   *
	   * @param {string} source
	   *        video source
	   *
	   * @private
	   */
	
	
	  Player.prototype.loadTech_ = function loadTech_(techName, source) {
	    var _this2 = this;
	
	    // Pause and remove current playback technology
	    if (this.tech_) {
	      this.unloadTech_();
	    }
	
	    var titleTechName = toTitleCase(techName);
	    var camelTechName = techName.charAt(0).toLowerCase() + techName.slice(1);
	
	    // get rid of the HTML5 video tag as soon as we are using another tech
	    if (titleTechName !== 'Html5' && this.tag) {
	      Tech.getTech('Html5').disposeMediaElement(this.tag);
	      this.tag.player = null;
	      this.tag = null;
	    }
	
	    this.techName_ = titleTechName;
	
	    // Turn off API access because we're loading a new tech that might load asynchronously
	    this.isReady_ = false;
	
	    // if autoplay is a string we pass false to the tech
	    // because the player is going to handle autoplay on `loadstart`
	    var autoplay = typeof this.autoplay() === 'string' ? false : this.autoplay();
	
	    // Grab tech-specific options from player options and add source and parent element to use.
	    var techOptions = {
	      source: source,
	      autoplay: autoplay,
	      'nativeControlsForTouch': this.options_.nativeControlsForTouch,
	      'playerId': this.id(),
	      'techId': this.id() + '_' + camelTechName + '_api',
	      'playsinline': this.options_.playsinline,
	      'preload': this.options_.preload,
	      'loop': this.options_.loop,
	      'muted': this.options_.muted,
	      'poster': this.poster(),
	      'language': this.language(),
	      'playerElIngest': this.playerElIngest_ || false,
	      'vtt.js': this.options_['vtt.js'],
	      'canOverridePoster': !!this.options_.techCanOverridePoster,
	      'enableSourceset': this.options_.enableSourceset
	    };
	
	    ALL.names.forEach(function (name$$1) {
	      var props = ALL[name$$1];
	
	      techOptions[props.getterName] = _this2[props.privateName];
	    });
	
	    assign(techOptions, this.options_[titleTechName]);
	    assign(techOptions, this.options_[camelTechName]);
	    assign(techOptions, this.options_[techName.toLowerCase()]);
	
	    if (this.tag) {
	      techOptions.tag = this.tag;
	    }
	
	    if (source && source.src === this.cache_.src && this.cache_.currentTime > 0) {
	      techOptions.startTime = this.cache_.currentTime;
	    }
	
	    // Initialize tech instance
	    var TechClass = Tech.getTech(techName);
	
	    if (!TechClass) {
	      throw new Error('No Tech named \'' + titleTechName + '\' exists! \'' + titleTechName + '\' should be registered using videojs.registerTech()\'');
	    }
	
	    this.tech_ = new TechClass(techOptions);
	
	    // player.triggerReady is always async, so don't need this to be async
	    this.tech_.ready(bind(this, this.handleTechReady_), true);
	
	    textTrackConverter.jsonToTextTracks(this.textTracksJson_ || [], this.tech_);
	
	    // Listen to all HTML5-defined events and trigger them on the player
	    TECH_EVENTS_RETRIGGER.forEach(function (event) {
	      _this2.on(_this2.tech_, event, _this2['handleTech' + toTitleCase(event) + '_']);
	    });
	
	    Object.keys(TECH_EVENTS_QUEUE).forEach(function (event) {
	      _this2.on(_this2.tech_, event, function (eventObj) {
	        if (_this2.tech_.playbackRate() === 0 && _this2.tech_.seeking()) {
	          _this2.queuedCallbacks_.push({
	            callback: _this2['handleTech' + TECH_EVENTS_QUEUE[event] + '_'].bind(_this2),
	            event: eventObj
	          });
	          return;
	        }
	        _this2['handleTech' + TECH_EVENTS_QUEUE[event] + '_'](eventObj);
	      });
	    });
	
	    this.on(this.tech_, 'loadstart', this.handleTechLoadStart_);
	    this.on(this.tech_, 'sourceset', this.handleTechSourceset_);
	    this.on(this.tech_, 'waiting', this.handleTechWaiting_);
	    this.on(this.tech_, 'ended', this.handleTechEnded_);
	    this.on(this.tech_, 'seeking', this.handleTechSeeking_);
	    this.on(this.tech_, 'play', this.handleTechPlay_);
	    this.on(this.tech_, 'firstplay', this.handleTechFirstPlay_);
	    this.on(this.tech_, 'pause', this.handleTechPause_);
	    this.on(this.tech_, 'durationchange', this.handleTechDurationChange_);
	    this.on(this.tech_, 'fullscreenchange', this.handleTechFullscreenChange_);
	    this.on(this.tech_, 'error', this.handleTechError_);
	    this.on(this.tech_, 'loadedmetadata', this.updateStyleEl_);
	    this.on(this.tech_, 'posterchange', this.handleTechPosterChange_);
	    this.on(this.tech_, 'textdata', this.handleTechTextData_);
	    this.on(this.tech_, 'ratechange', this.handleTechRateChange_);
	
	    this.usingNativeControls(this.techGet_('controls'));
	
	    if (this.controls() && !this.usingNativeControls()) {
	      this.addTechControlsListeners_();
	    }
	
	    // Add the tech element in the DOM if it was not already there
	    // Make sure to not insert the original video element if using Html5
	    if (this.tech_.el().parentNode !== this.el() && (titleTechName !== 'Html5' || !this.tag)) {
	      prependTo(this.tech_.el(), this.el());
	    }
	
	    // Get rid of the original video tag reference after the first tech is loaded
	    if (this.tag) {
	      this.tag.player = null;
	      this.tag = null;
	    }
	  };
	
	  /**
	   * Unload and dispose of the current playback {@link Tech}.
	   *
	   * @private
	   */
	
	
	  Player.prototype.unloadTech_ = function unloadTech_() {
	    var _this3 = this;
	
	    // Save the current text tracks so that we can reuse the same text tracks with the next tech
	    ALL.names.forEach(function (name$$1) {
	      var props = ALL[name$$1];
	
	      _this3[props.privateName] = _this3[props.getterName]();
	    });
	    this.textTracksJson_ = textTrackConverter.textTracksToJson(this.tech_);
	
	    this.isReady_ = false;
	
	    this.tech_.dispose();
	
	    this.tech_ = false;
	
	    if (this.isPosterFromTech_) {
	      this.poster_ = '';
	      this.trigger('posterchange');
	    }
	
	    this.isPosterFromTech_ = false;
	  };
	
	  /**
	   * Return a reference to the current {@link Tech}.
	   * It will print a warning by default about the danger of using the tech directly
	   * but any argument that is passed in will silence the warning.
	   *
	   * @param {*} [safety]
	   *        Anything passed in to silence the warning
	   *
	   * @return {Tech}
	   *         The Tech
	   */
	
	
	  Player.prototype.tech = function tech(safety) {
	    if (safety === undefined) {
	      log$1.warn(tsml(_templateObject$2));
	    }
	
	    return this.tech_;
	  };
	
	  /**
	   * Set up click and touch listeners for the playback element
	   *
	   * - On desktops: a click on the video itself will toggle playback
	   * - On mobile devices: a click on the video toggles controls
	   *   which is done by toggling the user state between active and
	   *   inactive
	   * - A tap can signal that a user has become active or has become inactive
	   *   e.g. a quick tap on an iPhone movie should reveal the controls. Another
	   *   quick tap should hide them again (signaling the user is in an inactive
	   *   viewing state)
	   * - In addition to this, we still want the user to be considered inactive after
	   *   a few seconds of inactivity.
	   *
	   * > Note: the only part of iOS interaction we can't mimic with this setup
	   * is a touch and hold on the video element counting as activity in order to
	   * keep the controls showing, but that shouldn't be an issue. A touch and hold
	   * on any controls will still keep the user active
	   *
	   * @private
	   */
	
	
	  Player.prototype.addTechControlsListeners_ = function addTechControlsListeners_() {
	    // Make sure to remove all the previous listeners in case we are called multiple times.
	    this.removeTechControlsListeners_();
	
	    // Some browsers (Chrome & IE) don't trigger a click on a flash swf, but do
	    // trigger mousedown/up.
	    // http://stackoverflow.com/questions/1444562/javascript-onclick-event-over-flash-object
	    // Any touch events are set to block the mousedown event from happening
	    this.on(this.tech_, 'mousedown', this.handleTechClick_);
	    this.on(this.tech_, 'dblclick', this.handleTechDoubleClick_);
	
	    // If the controls were hidden we don't want that to change without a tap event
	    // so we'll check if the controls were already showing before reporting user
	    // activity
	    this.on(this.tech_, 'touchstart', this.handleTechTouchStart_);
	    this.on(this.tech_, 'touchmove', this.handleTechTouchMove_);
	    this.on(this.tech_, 'touchend', this.handleTechTouchEnd_);
	
	    // The tap listener needs to come after the touchend listener because the tap
	    // listener cancels out any reportedUserActivity when setting userActive(false)
	    this.on(this.tech_, 'tap', this.handleTechTap_);
	  };
	
	  /**
	   * Remove the listeners used for click and tap controls. This is needed for
	   * toggling to controls disabled, where a tap/touch should do nothing.
	   *
	   * @private
	   */
	
	
	  Player.prototype.removeTechControlsListeners_ = function removeTechControlsListeners_() {
	    // We don't want to just use `this.off()` because there might be other needed
	    // listeners added by techs that extend this.
	    this.off(this.tech_, 'tap', this.handleTechTap_);
	    this.off(this.tech_, 'touchstart', this.handleTechTouchStart_);
	    this.off(this.tech_, 'touchmove', this.handleTechTouchMove_);
	    this.off(this.tech_, 'touchend', this.handleTechTouchEnd_);
	    this.off(this.tech_, 'mousedown', this.handleTechClick_);
	    this.off(this.tech_, 'dblclick', this.handleTechDoubleClick_);
	  };
	
	  /**
	   * Player waits for the tech to be ready
	   *
	   * @private
	   */
	
	
	  Player.prototype.handleTechReady_ = function handleTechReady_() {
	    this.triggerReady();
	
	    // Keep the same volume as before
	    if (this.cache_.volume) {
	      this.techCall_('setVolume', this.cache_.volume);
	    }
	
	    // Look if the tech found a higher resolution poster while loading
	    this.handleTechPosterChange_();
	
	    // Update the duration if available
	    this.handleTechDurationChange_();
	  };
	
	  /**
	   * Retrigger the `loadstart` event that was triggered by the {@link Tech}. This
	   * function will also trigger {@link Player#firstplay} if it is the first loadstart
	   * for a video.
	   *
	   * @fires Player#loadstart
	   * @fires Player#firstplay
	   * @listens Tech#loadstart
	   * @private
	   */
	
	
	  Player.prototype.handleTechLoadStart_ = function handleTechLoadStart_() {
	    // TODO: Update to use `emptied` event instead. See #1277.
	
	    this.removeClass('vjs-ended');
	    this.removeClass('vjs-seeking');
	
	    // reset the error state
	    this.error(null);
	
	    // If it's already playing we want to trigger a firstplay event now.
	    // The firstplay event relies on both the play and loadstart events
	    // which can happen in any order for a new source
	    if (!this.paused()) {
	      /**
	       * Fired when the user agent begins looking for media data
	       *
	       * @event Player#loadstart
	       * @type {EventTarget~Event}
	       */
	      this.trigger('loadstart');
	      this.trigger('firstplay');
	    } else {
	      // reset the hasStarted state
	      this.hasStarted(false);
	      this.trigger('loadstart');
	    }
	
	    // autoplay happens after loadstart for the browser,
	    // so we mimic that behavior
	    this.manualAutoplay_(this.autoplay());
	  };
	
	  /**
	   * Handle autoplay string values, rather than the typical boolean
	   * values that should be handled by the tech. Note that this is not
	   * part of any specification. Valid values and what they do can be
	   * found on the autoplay getter at Player#autoplay()
	   */
	
	
	  Player.prototype.manualAutoplay_ = function manualAutoplay_(type) {
	    var _this4 = this;
	
	    if (!this.tech_ || typeof type !== 'string') {
	      return;
	    }
	
	    var muted = function muted() {
	      var previouslyMuted = _this4.muted();
	
	      _this4.muted(true);
	
	      var playPromise = _this4.play();
	
	      if (!playPromise || !playPromise.then || !playPromise.catch) {
	        return;
	      }
	
	      return playPromise.catch(function (e) {
	        // restore old value of muted on failure
	        _this4.muted(previouslyMuted);
	      });
	    };
	
	    var promise = void 0;
	
	    if (type === 'any') {
	      promise = this.play();
	
	      if (promise && promise.then && promise.catch) {
	        promise.catch(function () {
	          return muted();
	        });
	      }
	    } else if (type === 'muted') {
	      promise = muted();
	    } else {
	      promise = this.play();
	    }
	
	    if (!promise || !promise.then || !promise.catch) {
	      return;
	    }
	
	    return promise.then(function () {
	      _this4.trigger({ type: 'autoplay-success', autoplay: type });
	    }).catch(function (e) {
	      _this4.trigger({ type: 'autoplay-failure', autoplay: type });
	    });
	  };
	
	  /**
	   * Update the internal source caches so that we return the correct source from
	   * `src()`, `currentSource()`, and `currentSources()`.
	   *
	   * > Note: `currentSources` will not be updated if the source that is passed in exists
	   *         in the current `currentSources` cache.
	   *
	   *
	   * @param {Tech~SourceObject} srcObj
	   *        A string or object source to update our caches to.
	   */
	
	
	  Player.prototype.updateSourceCaches_ = function updateSourceCaches_() {
	    var srcObj = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
	
	
	    var src = srcObj;
	    var type = '';
	
	    if (typeof src !== 'string') {
	      src = srcObj.src;
	      type = srcObj.type;
	    }
	
	    // if we are a blob url, don't update the source cache
	    // blob urls can arise when playback is done via Media Source Extension (MSE)
	    // such as m3u8 sources with @videojs/http-streaming (VHS)
	    if (/^blob:/.test(src)) {
	      return;
	    }
	
	    // make sure all the caches are set to default values
	    // to prevent null checking
	    this.cache_.source = this.cache_.source || {};
	    this.cache_.sources = this.cache_.sources || [];
	
	    // try to get the type of the src that was passed in
	    if (src && !type) {
	      type = findMimetype(this, src);
	    }
	
	    // update `currentSource` cache always
	    this.cache_.source = mergeOptions({}, srcObj, { src: src, type: type });
	
	    var matchingSources = this.cache_.sources.filter(function (s) {
	      return s.src && s.src === src;
	    });
	    var sourceElSources = [];
	    var sourceEls = this.$$('source');
	    var matchingSourceEls = [];
	
	    for (var i = 0; i < sourceEls.length; i++) {
	      var sourceObj = getAttributes(sourceEls[i]);
	
	      sourceElSources.push(sourceObj);
	
	      if (sourceObj.src && sourceObj.src === src) {
	        matchingSourceEls.push(sourceObj.src);
	      }
	    }
	
	    // if we have matching source els but not matching sources
	    // the current source cache is not up to date
	    if (matchingSourceEls.length && !matchingSources.length) {
	      this.cache_.sources = sourceElSources;
	      // if we don't have matching source or source els set the
	      // sources cache to the `currentSource` cache
	    } else if (!matchingSources.length) {
	      this.cache_.sources = [this.cache_.source];
	    }
	
	    // update the tech `src` cache
	    this.cache_.src = src;
	  };
	
	  /**
	   * *EXPERIMENTAL* Fired when the source is set or changed on the {@link Tech}
	   * causing the media element to reload.
	   *
	   * It will fire for the initial source and each subsequent source.
	   * This event is a custom event from Video.js and is triggered by the {@link Tech}.
	   *
	   * The event object for this event contains a `src` property that will contain the source
	   * that was available when the event was triggered. This is generally only necessary if Video.js
	   * is switching techs while the source was being changed.
	   *
	   * It is also fired when `load` is called on the player (or media element)
	   * because the {@link https://html.spec.whatwg.org/multipage/media.html#dom-media-load|specification for `load`}
	   * says that the resource selection algorithm needs to be aborted and restarted.
	   * In this case, it is very likely that the `src` property will be set to the
	   * empty string `""` to indicate we do not know what the source will be but
	   * that it is changing.
	   *
	   * *This event is currently still experimental and may change in minor releases.*
	   * __To use this, pass `enableSourceset` option to the player.__
	   *
	   * @event Player#sourceset
	   * @type {EventTarget~Event}
	   * @prop {string} src
	   *                The source url available when the `sourceset` was triggered.
	   *                It will be an empty string if we cannot know what the source is
	   *                but know that the source will change.
	   */
	  /**
	   * Retrigger the `sourceset` event that was triggered by the {@link Tech}.
	   *
	   * @fires Player#sourceset
	   * @listens Tech#sourceset
	   * @private
	   */
	
	
	  Player.prototype.handleTechSourceset_ = function handleTechSourceset_(event) {
	    var _this5 = this;
	
	    // only update the source cache when the source
	    // was not updated using the player api
	    if (!this.changingSrc_) {
	      // update the source to the intial source right away
	      // in some cases this will be empty string
	      this.updateSourceCaches_(event.src);
	
	      // if the `sourceset` `src` was an empty string
	      // wait for a `loadstart` to update the cache to `currentSrc`.
	      // If a sourceset happens before a `loadstart`, we reset the state
	      // as this function will be called again.
	      if (!event.src) {
	        var updateCache = function updateCache(e) {
	          if (e.type !== 'sourceset') {
	            _this5.updateSourceCaches_(_this5.techGet_('currentSrc'));
	          }
	
	          _this5.tech_.off(['sourceset', 'loadstart'], updateCache);
	        };
	
	        this.tech_.one(['sourceset', 'loadstart'], updateCache);
	      }
	    }
	
	    this.trigger({
	      src: event.src,
	      type: 'sourceset'
	    });
	  };
	
	  /**
	   * Add/remove the vjs-has-started class
	   *
	   * @fires Player#firstplay
	   *
	   * @param {boolean} request
	   *        - true: adds the class
	   *        - false: remove the class
	   *
	   * @return {boolean}
	   *         the boolean value of hasStarted_
	   */
	
	
	  Player.prototype.hasStarted = function hasStarted(request) {
	    if (request === undefined) {
	      // act as getter, if we have no request to change
	      return this.hasStarted_;
	    }
	
	    if (request === this.hasStarted_) {
	      return;
	    }
	
	    this.hasStarted_ = request;
	
	    if (this.hasStarted_) {
	      this.addClass('vjs-has-started');
	      this.trigger('firstplay');
	    } else {
	      this.removeClass('vjs-has-started');
	    }
	  };
	
	  /**
	   * Fired whenever the media begins or resumes playback
	   *
	   * @see [Spec]{@link https://html.spec.whatwg.org/multipage/embedded-content.html#dom-media-play}
	   * @fires Player#play
	   * @listens Tech#play
	   * @private
	   */
	
	
	  Player.prototype.handleTechPlay_ = function handleTechPlay_() {
	    this.removeClass('vjs-ended');
	    this.removeClass('vjs-paused');
	    this.addClass('vjs-playing');
	
	    // hide the poster when the user hits play
	    this.hasStarted(true);
	    /**
	     * Triggered whenever an {@link Tech#play} event happens. Indicates that
	     * playback has started or resumed.
	     *
	     * @event Player#play
	     * @type {EventTarget~Event}
	     */
	    this.trigger('play');
	  };
	
	  /**
	   * Retrigger the `ratechange` event that was triggered by the {@link Tech}.
	   *
	   * If there were any events queued while the playback rate was zero, fire
	   * those events now.
	   *
	   * @private
	   * @method Player#handleTechRateChange_
	   * @fires Player#ratechange
	   * @listens Tech#ratechange
	   */
	
	
	  Player.prototype.handleTechRateChange_ = function handleTechRateChange_() {
	    if (this.tech_.playbackRate() > 0 && this.cache_.lastPlaybackRate === 0) {
	      this.queuedCallbacks_.forEach(function (queued) {
	        return queued.callback(queued.event);
	      });
	      this.queuedCallbacks_ = [];
	    }
	    this.cache_.lastPlaybackRate = this.tech_.playbackRate();
	    /**
	     * Fires when the playing speed of the audio/video is changed
	     *
	     * @event Player#ratechange
	     * @type {event}
	     */
	    this.trigger('ratechange');
	  };
	
	  /**
	   * Retrigger the `waiting` event that was triggered by the {@link Tech}.
	   *
	   * @fires Player#waiting
	   * @listens Tech#waiting
	   * @private
	   */
	
	
	  Player.prototype.handleTechWaiting_ = function handleTechWaiting_() {
	    var _this6 = this;
	
	    this.addClass('vjs-waiting');
	    /**
	     * A readyState change on the DOM element has caused playback to stop.
	     *
	     * @event Player#waiting
	     * @type {EventTarget~Event}
	     */
	    this.trigger('waiting');
	    this.one('timeupdate', function () {
	      return _this6.removeClass('vjs-waiting');
	    });
	  };
	
	  /**
	   * Retrigger the `canplay` event that was triggered by the {@link Tech}.
	   * > Note: This is not consistent between browsers. See #1351
	   *
	   * @fires Player#canplay
	   * @listens Tech#canplay
	   * @private
	   */
	
	
	  Player.prototype.handleTechCanPlay_ = function handleTechCanPlay_() {
	    this.removeClass('vjs-waiting');
	    /**
	     * The media has a readyState of HAVE_FUTURE_DATA or greater.
	     *
	     * @event Player#canplay
	     * @type {EventTarget~Event}
	     */
	    this.trigger('canplay');
	  };
	
	  /**
	   * Retrigger the `canplaythrough` event that was triggered by the {@link Tech}.
	   *
	   * @fires Player#canplaythrough
	   * @listens Tech#canplaythrough
	   * @private
	   */
	
	
	  Player.prototype.handleTechCanPlayThrough_ = function handleTechCanPlayThrough_() {
	    this.removeClass('vjs-waiting');
	    /**
	     * The media has a readyState of HAVE_ENOUGH_DATA or greater. This means that the
	     * entire media file can be played without buffering.
	     *
	     * @event Player#canplaythrough
	     * @type {EventTarget~Event}
	     */
	    this.trigger('canplaythrough');
	  };
	
	  /**
	   * Retrigger the `playing` event that was triggered by the {@link Tech}.
	   *
	   * @fires Player#playing
	   * @listens Tech#playing
	   * @private
	   */
	
	
	  Player.prototype.handleTechPlaying_ = function handleTechPlaying_() {
	    this.removeClass('vjs-waiting');
	    /**
	     * The media is no longer blocked from playback, and has started playing.
	     *
	     * @event Player#playing
	     * @type {EventTarget~Event}
	     */
	    this.trigger('playing');
	  };
	
	  /**
	   * Retrigger the `seeking` event that was triggered by the {@link Tech}.
	   *
	   * @fires Player#seeking
	   * @listens Tech#seeking
	   * @private
	   */
	
	
	  Player.prototype.handleTechSeeking_ = function handleTechSeeking_() {
	    this.addClass('vjs-seeking');
	    /**
	     * Fired whenever the player is jumping to a new time
	     *
	     * @event Player#seeking
	     * @type {EventTarget~Event}
	     */
	    this.trigger('seeking');
	  };
	
	  /**
	   * Retrigger the `seeked` event that was triggered by the {@link Tech}.
	   *
	   * @fires Player#seeked
	   * @listens Tech#seeked
	   * @private
	   */
	
	
	  Player.prototype.handleTechSeeked_ = function handleTechSeeked_() {
	    this.removeClass('vjs-seeking');
	    /**
	     * Fired when the player has finished jumping to a new time
	     *
	     * @event Player#seeked
	     * @type {EventTarget~Event}
	     */
	    this.trigger('seeked');
	  };
	
	  /**
	   * Retrigger the `firstplay` event that was triggered by the {@link Tech}.
	   *
	   * @fires Player#firstplay
	   * @listens Tech#firstplay
	   * @deprecated As of 6.0 firstplay event is deprecated.
	   *             As of 6.0 passing the `starttime` option to the player and the firstplay event are deprecated.
	   * @private
	   */
	
	
	  Player.prototype.handleTechFirstPlay_ = function handleTechFirstPlay_() {
	    // If the first starttime attribute is specified
	    // then we will start at the given offset in seconds
	    if (this.options_.starttime) {
	      log$1.warn('Passing the `starttime` option to the player will be deprecated in 6.0');
	      this.currentTime(this.options_.starttime);
	    }
	
	    this.addClass('vjs-has-started');
	    /**
	     * Fired the first time a video is played. Not part of the HLS spec, and this is
	     * probably not the best implementation yet, so use sparingly. If you don't have a
	     * reason to prevent playback, use `myPlayer.one('play');` instead.
	     *
	     * @event Player#firstplay
	     * @deprecated As of 6.0 firstplay event is deprecated.
	     * @type {EventTarget~Event}
	     */
	    this.trigger('firstplay');
	  };
	
	  /**
	   * Retrigger the `pause` event that was triggered by the {@link Tech}.
	   *
	   * @fires Player#pause
	   * @listens Tech#pause
	   * @private
	   */
	
	
	  Player.prototype.handleTechPause_ = function handleTechPause_() {
	    this.removeClass('vjs-playing');
	    this.addClass('vjs-paused');
	    /**
	     * Fired whenever the media has been paused
	     *
	     * @event Player#pause
	     * @type {EventTarget~Event}
	     */
	    this.trigger('pause');
	  };
	
	  /**
	   * Retrigger the `ended` event that was triggered by the {@link Tech}.
	   *
	   * @fires Player#ended
	   * @listens Tech#ended
	   * @private
	   */
	
	
	  Player.prototype.handleTechEnded_ = function handleTechEnded_() {
	    this.addClass('vjs-ended');
	    if (this.options_.loop) {
	      this.currentTime(0);
	      this.play();
	    } else if (!this.paused()) {
	      this.pause();
	    }
	
	    /**
	     * Fired when the end of the media resource is reached (currentTime == duration)
	     *
	     * @event Player#ended
	     * @type {EventTarget~Event}
	     */
	    this.trigger('ended');
	  };
	
	  /**
	   * Fired when the duration of the media resource is first known or changed
	   *
	   * @listens Tech#durationchange
	   * @private
	   */
	
	
	  Player.prototype.handleTechDurationChange_ = function handleTechDurationChange_() {
	    this.duration(this.techGet_('duration'));
	  };
	
	  /**
	   * Handle a click on the media element to play/pause
	   *
	   * @param {EventTarget~Event} event
	   *        the event that caused this function to trigger
	   *
	   * @listens Tech#mousedown
	   * @private
	   */
	
	
	  Player.prototype.handleTechClick_ = function handleTechClick_(event) {
	    if (!isSingleLeftClick(event)) {
	      return;
	    }
	
	    // When controls are disabled a click should not toggle playback because
	    // the click is considered a control
	    if (!this.controls_) {
	      return;
	    }
	
	    if (this.paused()) {
	      silencePromise(this.play());
	    } else {
	      this.pause();
	    }
	  };
	
	  /**
	   * Handle a double-click on the media element to enter/exit fullscreen
	   *
	   * @param {EventTarget~Event} event
	   *        the event that caused this function to trigger
	   *
	   * @listens Tech#dblclick
	   * @private
	   */
	
	
	  Player.prototype.handleTechDoubleClick_ = function handleTechDoubleClick_(event) {
	    if (!this.controls_) {
	      return;
	    }
	
	    // we do not want to toggle fullscreen state
	    // when double-clicking inside a control bar or a modal
	    var inAllowedEls = Array.prototype.some.call(this.$$('.vjs-control-bar, .vjs-modal-dialog'), function (el) {
	      return el.contains(event.target);
	    });
	
	    if (!inAllowedEls) {
	      if (this.isFullscreen()) {
	        this.exitFullscreen();
	      } else {
	        this.requestFullscreen();
	      }
	    }
	  };
	
	  /**
	   * Handle a tap on the media element. It will toggle the user
	   * activity state, which hides and shows the controls.
	   *
	   * @listens Tech#tap
	   * @private
	   */
	
	
	  Player.prototype.handleTechTap_ = function handleTechTap_() {
	    this.userActive(!this.userActive());
	  };
	
	  /**
	   * Handle touch to start
	   *
	   * @listens Tech#touchstart
	   * @private
	   */
	
	
	  Player.prototype.handleTechTouchStart_ = function handleTechTouchStart_() {
	    this.userWasActive = this.userActive();
	  };
	
	  /**
	   * Handle touch to move
	   *
	   * @listens Tech#touchmove
	   * @private
	   */
	
	
	  Player.prototype.handleTechTouchMove_ = function handleTechTouchMove_() {
	    if (this.userWasActive) {
	      this.reportUserActivity();
	    }
	  };
	
	  /**
	   * Handle touch to end
	   *
	   * @param {EventTarget~Event} event
	   *        the touchend event that triggered
	   *        this function
	   *
	   * @listens Tech#touchend
	   * @private
	   */
	
	
	  Player.prototype.handleTechTouchEnd_ = function handleTechTouchEnd_(event) {
	    // Stop the mouse events from also happening
	    event.preventDefault();
	  };
	
	  /**
	   * Fired when the player switches in or out of fullscreen mode
	   *
	   * @private
	   * @listens Player#fullscreenchange
	   */
	
	
	  Player.prototype.handleFullscreenChange_ = function handleFullscreenChange_() {
	    if (this.isFullscreen()) {
	      this.addClass('vjs-fullscreen');
	    } else {
	      this.removeClass('vjs-fullscreen');
	    }
	  };
	
	  /**
	   * native click events on the SWF aren't triggered on IE11, Win8.1RT
	   * use stageclick events triggered from inside the SWF instead
	   *
	   * @private
	   * @listens stageclick
	   */
	
	
	  Player.prototype.handleStageClick_ = function handleStageClick_() {
	    this.reportUserActivity();
	  };
	
	  /**
	   * Handle Tech Fullscreen Change
	   *
	   * @param {EventTarget~Event} event
	   *        the fullscreenchange event that triggered this function
	   *
	   * @param {Object} data
	   *        the data that was sent with the event
	   *
	   * @private
	   * @listens Tech#fullscreenchange
	   * @fires Player#fullscreenchange
	   */
	
	
	  Player.prototype.handleTechFullscreenChange_ = function handleTechFullscreenChange_(event, data) {
	    if (data) {
	      this.isFullscreen(data.isFullscreen);
	    }
	    /**
	     * Fired when going in and out of fullscreen.
	     *
	     * @event Player#fullscreenchange
	     * @type {EventTarget~Event}
	     */
	    this.trigger('fullscreenchange');
	  };
	
	  /**
	   * Fires when an error occurred during the loading of an audio/video.
	   *
	   * @private
	   * @listens Tech#error
	   */
	
	
	  Player.prototype.handleTechError_ = function handleTechError_() {
	    var error = this.tech_.error();
	
	    this.error(error);
	  };
	
	  /**
	   * Retrigger the `textdata` event that was triggered by the {@link Tech}.
	   *
	   * @fires Player#textdata
	   * @listens Tech#textdata
	   * @private
	   */
	
	
	  Player.prototype.handleTechTextData_ = function handleTechTextData_() {
	    var data = null;
	
	    if (arguments.length > 1) {
	      data = arguments[1];
	    }
	
	    /**
	     * Fires when we get a textdata event from tech
	     *
	     * @event Player#textdata
	     * @type {EventTarget~Event}
	     */
	    this.trigger('textdata', data);
	  };
	
	  /**
	   * Get object for cached values.
	   *
	   * @return {Object}
	   *         get the current object cache
	   */
	
	
	  Player.prototype.getCache = function getCache() {
	    return this.cache_;
	  };
	
	  /**
	   * Pass values to the playback tech
	   *
	   * @param {string} [method]
	   *        the method to call
	   *
	   * @param {Object} arg
	   *        the argument to pass
	   *
	   * @private
	   */
	
	
	  Player.prototype.techCall_ = function techCall_(method, arg) {
	    // If it's not ready yet, call method when it is
	
	    this.ready(function () {
	      if (method in allowedSetters) {
	        return set$1(this.middleware_, this.tech_, method, arg);
	      } else if (method in allowedMediators) {
	        return mediate(this.middleware_, this.tech_, method, arg);
	      }
	
	      try {
	        if (this.tech_) {
	          this.tech_[method](arg);
	        }
	      } catch (e) {
	        log$1(e);
	        throw e;
	      }
	    }, true);
	  };
	
	  /**
	   * Get calls can't wait for the tech, and sometimes don't need to.
	   *
	   * @param {string} method
	   *        Tech method
	   *
	   * @return {Function|undefined}
	   *         the method or undefined
	   *
	   * @private
	   */
	
	
	  Player.prototype.techGet_ = function techGet_(method) {
	    if (!this.tech_ || !this.tech_.isReady_) {
	      return;
	    }
	
	    if (method in allowedGetters) {
	      return get$1(this.middleware_, this.tech_, method);
	    } else if (method in allowedMediators) {
	      return mediate(this.middleware_, this.tech_, method);
	    }
	
	    // Flash likes to die and reload when you hide or reposition it.
	    // In these cases the object methods go away and we get errors.
	    // When that happens we'll catch the errors and inform tech that it's not ready any more.
	    try {
	      return this.tech_[method]();
	    } catch (e) {
	
	      // When building additional tech libs, an expected method may not be defined yet
	      if (this.tech_[method] === undefined) {
	        log$1('Video.js: ' + method + ' method not defined for ' + this.techName_ + ' playback technology.', e);
	        throw e;
	      }
	
	      // When a method isn't available on the object it throws a TypeError
	      if (e.name === 'TypeError') {
	        log$1('Video.js: ' + method + ' unavailable on ' + this.techName_ + ' playback technology element.', e);
	        this.tech_.isReady_ = false;
	        throw e;
	      }
	
	      // If error unknown, just log and throw
	      log$1(e);
	      throw e;
	    }
	  };
	
	  /**
	   * Attempt to begin playback at the first opportunity.
	   *
	   * @return {Promise|undefined}
	   *         Returns a promise if the browser supports Promises (or one
	   *         was passed in as an option). This promise will be resolved on
	   *         the return value of play. If this is undefined it will fulfill the
	   *         promise chain otherwise the promise chain will be fulfilled when
	   *         the promise from play is fulfilled.
	   */
	
	
	  Player.prototype.play = function play() {
	    var _this7 = this;
	
	    var PromiseClass = this.options_.Promise || window$1.Promise;
	
	    if (PromiseClass) {
	      return new PromiseClass(function (resolve) {
	        _this7.play_(resolve);
	      });
	    }
	
	    return this.play_();
	  };
	
	  /**
	   * The actual logic for play, takes a callback that will be resolved on the
	   * return value of play. This allows us to resolve to the play promise if there
	   * is one on modern browsers.
	   *
	   * @private
	   * @param {Function} [callback]
	   *        The callback that should be called when the techs play is actually called
	   */
	
	
	  Player.prototype.play_ = function play_() {
	    var _this8 = this;
	
	    var callback = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : silencePromise;
	
	    // If this is called while we have a play queued up on a loadstart, remove
	    // that listener to avoid getting in a potentially bad state.
	    if (this.playOnLoadstart_) {
	      this.off('loadstart', this.playOnLoadstart_);
	    }
	
	    // If the player/tech is not ready, queue up another call to `play()` for
	    // when it is. This will loop back into this method for another attempt at
	    // playback when the tech is ready.
	    if (!this.isReady_) {
	
	      // Bail out if we're already waiting for `ready`!
	      if (this.playWaitingForReady_) {
	        return;
	      }
	
	      this.playWaitingForReady_ = true;
	      this.ready(function () {
	        _this8.playWaitingForReady_ = false;
	        callback(_this8.play());
	      });
	
	      // If the player/tech is ready and we have a source, we can attempt playback.
	    } else if (!this.changingSrc_ && (this.src() || this.currentSrc())) {
	      callback(this.techGet_('play'));
	      return;
	
	      // If the tech is ready, but we do not have a source, we'll need to wait
	      // for both the `ready` and a `loadstart` when the source is finally
	      // resolved by middleware and set on the player.
	      //
	      // This can happen if `play()` is called while changing sources or before
	      // one has been set on the player.
	    } else {
	
	      this.playOnLoadstart_ = function () {
	        _this8.playOnLoadstart_ = null;
	        callback(_this8.play());
	      };
	
	      this.one('loadstart', this.playOnLoadstart_);
	    }
	  };
	
	  /**
	   * Pause the video playback
	   *
	   * @return {Player}
	   *         A reference to the player object this function was called on
	   */
	
	
	  Player.prototype.pause = function pause() {
	    this.techCall_('pause');
	  };
	
	  /**
	   * Check if the player is paused or has yet to play
	   *
	   * @return {boolean}
	   *         - false: if the media is currently playing
	   *         - true: if media is not currently playing
	   */
	
	
	  Player.prototype.paused = function paused() {
	    // The initial state of paused should be true (in Safari it's actually false)
	    return this.techGet_('paused') === false ? false : true;
	  };
	
	  /**
	   * Get a TimeRange object representing the current ranges of time that the user
	   * has played.
	   *
	   * @return {TimeRange}
	   *         A time range object that represents all the increments of time that have
	   *         been played.
	   */
	
	
	  Player.prototype.played = function played() {
	    return this.techGet_('played') || createTimeRanges(0, 0);
	  };
	
	  /**
	   * Returns whether or not the user is "scrubbing". Scrubbing is
	   * when the user has clicked the progress bar handle and is
	   * dragging it along the progress bar.
	   *
	   * @param {boolean} [isScrubbing]
	   *        whether the user is or is not scrubbing
	   *
	   * @return {boolean}
	   *         The value of scrubbing when getting
	   */
	
	
	  Player.prototype.scrubbing = function scrubbing(isScrubbing) {
	    if (typeof isScrubbing === 'undefined') {
	      return this.scrubbing_;
	    }
	    this.scrubbing_ = !!isScrubbing;
	
	    if (isScrubbing) {
	      this.addClass('vjs-scrubbing');
	    } else {
	      this.removeClass('vjs-scrubbing');
	    }
	  };
	
	  /**
	   * Get or set the current time (in seconds)
	   *
	   * @param {number|string} [seconds]
	   *        The time to seek to in seconds
	   *
	   * @return {number}
	   *         - the current time in seconds when getting
	   */
	
	
	  Player.prototype.currentTime = function currentTime(seconds) {
	    if (typeof seconds !== 'undefined') {
	      if (seconds < 0) {
	        seconds = 0;
	      }
	      this.techCall_('setCurrentTime', seconds);
	      return;
	    }
	
	    // cache last currentTime and return. default to 0 seconds
	    //
	    // Caching the currentTime is meant to prevent a massive amount of reads on the tech's
	    // currentTime when scrubbing, but may not provide much performance benefit afterall.
	    // Should be tested. Also something has to read the actual current time or the cache will
	    // never get updated.
	    this.cache_.currentTime = this.techGet_('currentTime') || 0;
	    return this.cache_.currentTime;
	  };
	
	  /**
	   * Normally gets the length in time of the video in seconds;
	   * in all but the rarest use cases an argument will NOT be passed to the method
	   *
	   * > **NOTE**: The video must have started loading before the duration can be
	   * known, and in the case of Flash, may not be known until the video starts
	   * playing.
	   *
	   * @fires Player#durationchange
	   *
	   * @param {number} [seconds]
	   *        The duration of the video to set in seconds
	   *
	   * @return {number}
	   *         - The duration of the video in seconds when getting
	   */
	
	
	  Player.prototype.duration = function duration(seconds) {
	    if (seconds === undefined) {
	      // return NaN if the duration is not known
	      return this.cache_.duration !== undefined ? this.cache_.duration : NaN;
	    }
	
	    seconds = parseFloat(seconds);
	
	    // Standardize on Infinity for signaling video is live
	    if (seconds < 0) {
	      seconds = Infinity;
	    }
	
	    if (seconds !== this.cache_.duration) {
	      // Cache the last set value for optimized scrubbing (esp. Flash)
	      this.cache_.duration = seconds;
	
	      if (seconds === Infinity) {
	        this.addClass('vjs-live');
	      } else {
	        this.removeClass('vjs-live');
	      }
	      /**
	       * @event Player#durationchange
	       * @type {EventTarget~Event}
	       */
	      this.trigger('durationchange');
	    }
	  };
	
	  /**
	   * Calculates how much time is left in the video. Not part
	   * of the native video API.
	   *
	   * @return {number}
	   *         The time remaining in seconds
	   */
	
	
	  Player.prototype.remainingTime = function remainingTime() {
	    return this.duration() - this.currentTime();
	  };
	
	  /**
	   * A remaining time function that is intented to be used when
	   * the time is to be displayed directly to the user.
	   *
	   * @return {number}
	   *         The rounded time remaining in seconds
	   */
	
	
	  Player.prototype.remainingTimeDisplay = function remainingTimeDisplay() {
	    return Math.floor(this.duration()) - Math.floor(this.currentTime());
	  };
	
	  //
	  // Kind of like an array of portions of the video that have been downloaded.
	
	  /**
	   * Get a TimeRange object with an array of the times of the video
	   * that have been downloaded. If you just want the percent of the
	   * video that's been downloaded, use bufferedPercent.
	   *
	   * @see [Buffered Spec]{@link http://dev.w3.org/html5/spec/video.html#dom-media-buffered}
	   *
	   * @return {TimeRange}
	   *         A mock TimeRange object (following HTML spec)
	   */
	
	
	  Player.prototype.buffered = function buffered() {
	    var buffered = this.techGet_('buffered');
	
	    if (!buffered || !buffered.length) {
	      buffered = createTimeRanges(0, 0);
	    }
	
	    return buffered;
	  };
	
	  /**
	   * Get the percent (as a decimal) of the video that's been downloaded.
	   * This method is not a part of the native HTML video API.
	   *
	   * @return {number}
	   *         A decimal between 0 and 1 representing the percent
	   *         that is buffered 0 being 0% and 1 being 100%
	   */
	
	
	  Player.prototype.bufferedPercent = function bufferedPercent$$1() {
	    return bufferedPercent(this.buffered(), this.duration());
	  };
	
	  /**
	   * Get the ending time of the last buffered time range
	   * This is used in the progress bar to encapsulate all time ranges.
	   *
	   * @return {number}
	   *         The end of the last buffered time range
	   */
	
	
	  Player.prototype.bufferedEnd = function bufferedEnd() {
	    var buffered = this.buffered();
	    var duration = this.duration();
	    var end = buffered.end(buffered.length - 1);
	
	    if (end > duration) {
	      end = duration;
	    }
	
	    return end;
	  };
	
	  /**
	   * Get or set the current volume of the media
	   *
	   * @param  {number} [percentAsDecimal]
	   *         The new volume as a decimal percent:
	   *         - 0 is muted/0%/off
	   *         - 1.0 is 100%/full
	   *         - 0.5 is half volume or 50%
	   *
	   * @return {number}
	   *         The current volume as a percent when getting
	   */
	
	
	  Player.prototype.volume = function volume(percentAsDecimal) {
	    var vol = void 0;
	
	    if (percentAsDecimal !== undefined) {
	      // Force value to between 0 and 1
	      vol = Math.max(0, Math.min(1, parseFloat(percentAsDecimal)));
	      this.cache_.volume = vol;
	      this.techCall_('setVolume', vol);
	
	      if (vol > 0) {
	        this.lastVolume_(vol);
	      }
	
	      return;
	    }
	
	    // Default to 1 when returning current volume.
	    vol = parseFloat(this.techGet_('volume'));
	    return isNaN(vol) ? 1 : vol;
	  };
	
	  /**
	   * Get the current muted state, or turn mute on or off
	   *
	   * @param {boolean} [muted]
	   *        - true to mute
	   *        - false to unmute
	   *
	   * @return {boolean}
	   *         - true if mute is on and getting
	   *         - false if mute is off and getting
	   */
	
	
	  Player.prototype.muted = function muted(_muted) {
	    if (_muted !== undefined) {
	      this.techCall_('setMuted', _muted);
	      return;
	    }
	    return this.techGet_('muted') || false;
	  };
	
	  /**
	   * Get the current defaultMuted state, or turn defaultMuted on or off. defaultMuted
	   * indicates the state of muted on initial playback.
	   *
	   * ```js
	   *   var myPlayer = videojs('some-player-id');
	   *
	   *   myPlayer.src("http://www.example.com/path/to/video.mp4");
	   *
	   *   // get, should be false
	   *   console.log(myPlayer.defaultMuted());
	   *   // set to true
	   *   myPlayer.defaultMuted(true);
	   *   // get should be true
	   *   console.log(myPlayer.defaultMuted());
	   * ```
	   *
	   * @param {boolean} [defaultMuted]
	   *        - true to mute
	   *        - false to unmute
	   *
	   * @return {boolean|Player}
	   *         - true if defaultMuted is on and getting
	   *         - false if defaultMuted is off and getting
	   *         - A reference to the current player when setting
	   */
	
	
	  Player.prototype.defaultMuted = function defaultMuted(_defaultMuted) {
	    if (_defaultMuted !== undefined) {
	      return this.techCall_('setDefaultMuted', _defaultMuted);
	    }
	    return this.techGet_('defaultMuted') || false;
	  };
	
	  /**
	   * Get the last volume, or set it
	   *
	   * @param  {number} [percentAsDecimal]
	   *         The new last volume as a decimal percent:
	   *         - 0 is muted/0%/off
	   *         - 1.0 is 100%/full
	   *         - 0.5 is half volume or 50%
	   *
	   * @return {number}
	   *         the current value of lastVolume as a percent when getting
	   *
	   * @private
	   */
	
	
	  Player.prototype.lastVolume_ = function lastVolume_(percentAsDecimal) {
	    if (percentAsDecimal !== undefined && percentAsDecimal !== 0) {
	      this.cache_.lastVolume = percentAsDecimal;
	      return;
	    }
	    return this.cache_.lastVolume;
	  };
	
	  /**
	   * Check if current tech can support native fullscreen
	   * (e.g. with built in controls like iOS, so not our flash swf)
	   *
	   * @return {boolean}
	   *         if native fullscreen is supported
	   */
	
	
	  Player.prototype.supportsFullScreen = function supportsFullScreen() {
	    return this.techGet_('supportsFullScreen') || false;
	  };
	
	  /**
	   * Check if the player is in fullscreen mode or tell the player that it
	   * is or is not in fullscreen mode.
	   *
	   * > NOTE: As of the latest HTML5 spec, isFullscreen is no longer an official
	   * property and instead document.fullscreenElement is used. But isFullscreen is
	   * still a valuable property for internal player workings.
	   *
	   * @param  {boolean} [isFS]
	   *         Set the players current fullscreen state
	   *
	   * @return {boolean}
	   *         - true if fullscreen is on and getting
	   *         - false if fullscreen is off and getting
	   */
	
	
	  Player.prototype.isFullscreen = function isFullscreen(isFS) {
	    if (isFS !== undefined) {
	      this.isFullscreen_ = !!isFS;
	      return;
	    }
	    return !!this.isFullscreen_;
	  };
	
	  /**
	   * Increase the size of the video to full screen
	   * In some browsers, full screen is not supported natively, so it enters
	   * "full window mode", where the video fills the browser window.
	   * In browsers and devices that support native full screen, sometimes the
	   * browser's default controls will be shown, and not the Video.js custom skin.
	   * This includes most mobile devices (iOS, Android) and older versions of
	   * Safari.
	   *
	   * @fires Player#fullscreenchange
	   */
	
	
	  Player.prototype.requestFullscreen = function requestFullscreen() {
	    var fsApi = FullscreenApi;
	
	    this.isFullscreen(true);
	
	    if (fsApi.requestFullscreen) {
	      // the browser supports going fullscreen at the element level so we can
	      // take the controls fullscreen as well as the video
	
	      // Trigger fullscreenchange event after change
	      // We have to specifically add this each time, and remove
	      // when canceling fullscreen. Otherwise if there's multiple
	      // players on a page, they would all be reacting to the same fullscreen
	      // events
	      on(document, fsApi.fullscreenchange, bind(this, function documentFullscreenChange(e) {
	        this.isFullscreen(document[fsApi.fullscreenElement]);
	
	        // If cancelling fullscreen, remove event listener.
	        if (this.isFullscreen() === false) {
	          off(document, fsApi.fullscreenchange, documentFullscreenChange);
	        }
	        /**
	         * @event Player#fullscreenchange
	         * @type {EventTarget~Event}
	         */
	        this.trigger('fullscreenchange');
	      }));
	
	      this.el_[fsApi.requestFullscreen]();
	    } else if (this.tech_.supportsFullScreen()) {
	      // we can't take the video.js controls fullscreen but we can go fullscreen
	      // with native controls
	      this.techCall_('enterFullScreen');
	    } else {
	      // fullscreen isn't supported so we'll just stretch the video element to
	      // fill the viewport
	      this.enterFullWindow();
	      /**
	       * @event Player#fullscreenchange
	       * @type {EventTarget~Event}
	       */
	      this.trigger('fullscreenchange');
	    }
	  };
	
	  /**
	   * Return the video to its normal size after having been in full screen mode
	   *
	   * @fires Player#fullscreenchange
	   */
	
	
	  Player.prototype.exitFullscreen = function exitFullscreen() {
	    var fsApi = FullscreenApi;
	
	    this.isFullscreen(false);
	
	    // Check for browser element fullscreen support
	    if (fsApi.requestFullscreen) {
	      document[fsApi.exitFullscreen]();
	    } else if (this.tech_.supportsFullScreen()) {
	      this.techCall_('exitFullScreen');
	    } else {
	      this.exitFullWindow();
	      /**
	       * @event Player#fullscreenchange
	       * @type {EventTarget~Event}
	       */
	      this.trigger('fullscreenchange');
	    }
	  };
	
	  /**
	   * When fullscreen isn't supported we can stretch the
	   * video container to as wide as the browser will let us.
	   *
	   * @fires Player#enterFullWindow
	   */
	
	
	  Player.prototype.enterFullWindow = function enterFullWindow() {
	    this.isFullWindow = true;
	
	    // Storing original doc overflow value to return to when fullscreen is off
	    this.docOrigOverflow = document.documentElement.style.overflow;
	
	    // Add listener for esc key to exit fullscreen
	    on(document, 'keydown', bind(this, this.fullWindowOnEscKey));
	
	    // Hide any scroll bars
	    document.documentElement.style.overflow = 'hidden';
	
	    // Apply fullscreen styles
	    addClass(document.body, 'vjs-full-window');
	
	    /**
	     * @event Player#enterFullWindow
	     * @type {EventTarget~Event}
	     */
	    this.trigger('enterFullWindow');
	  };
	
	  /**
	   * Check for call to either exit full window or
	   * full screen on ESC key
	   *
	   * @param {string} event
	   *        Event to check for key press
	   */
	
	
	  Player.prototype.fullWindowOnEscKey = function fullWindowOnEscKey(event) {
	    if (event.keyCode === 27) {
	      if (this.isFullscreen() === true) {
	        this.exitFullscreen();
	      } else {
	        this.exitFullWindow();
	      }
	    }
	  };
	
	  /**
	   * Exit full window
	   *
	   * @fires Player#exitFullWindow
	   */
	
	
	  Player.prototype.exitFullWindow = function exitFullWindow() {
	    this.isFullWindow = false;
	    off(document, 'keydown', this.fullWindowOnEscKey);
	
	    // Unhide scroll bars.
	    document.documentElement.style.overflow = this.docOrigOverflow;
	
	    // Remove fullscreen styles
	    removeClass(document.body, 'vjs-full-window');
	
	    // Resize the box, controller, and poster to original sizes
	    // this.positionAll();
	    /**
	     * @event Player#exitFullWindow
	     * @type {EventTarget~Event}
	     */
	    this.trigger('exitFullWindow');
	  };
	
	  /**
	   * Check whether the player can play a given mimetype
	   *
	   * @see https://www.w3.org/TR/2011/WD-html5-20110113/video.html#dom-navigator-canplaytype
	   *
	   * @param {string} type
	   *        The mimetype to check
	   *
	   * @return {string}
	   *         'probably', 'maybe', or '' (empty string)
	   */
	
	
	  Player.prototype.canPlayType = function canPlayType(type) {
	    var can = void 0;
	
	    // Loop through each playback technology in the options order
	    for (var i = 0, j = this.options_.techOrder; i < j.length; i++) {
	      var techName = j[i];
	      var tech = Tech.getTech(techName);
	
	      // Support old behavior of techs being registered as components.
	      // Remove once that deprecated behavior is removed.
	      if (!tech) {
	        tech = Component.getComponent(techName);
	      }
	
	      // Check if the current tech is defined before continuing
	      if (!tech) {
	        log$1.error('The "' + techName + '" tech is undefined. Skipped browser support check for that tech.');
	        continue;
	      }
	
	      // Check if the browser supports this technology
	      if (tech.isSupported()) {
	        can = tech.canPlayType(type);
	
	        if (can) {
	          return can;
	        }
	      }
	    }
	
	    return '';
	  };
	
	  /**
	   * Select source based on tech-order or source-order
	   * Uses source-order selection if `options.sourceOrder` is truthy. Otherwise,
	   * defaults to tech-order selection
	   *
	   * @param {Array} sources
	   *        The sources for a media asset
	   *
	   * @return {Object|boolean}
	   *         Object of source and tech order or false
	   */
	
	
	  Player.prototype.selectSource = function selectSource(sources) {
	    var _this9 = this;
	
	    // Get only the techs specified in `techOrder` that exist and are supported by the
	    // current platform
	    var techs = this.options_.techOrder.map(function (techName) {
	      return [techName, Tech.getTech(techName)];
	    }).filter(function (_ref) {
	      var techName = _ref[0],
	          tech = _ref[1];
	
	      // Check if the current tech is defined before continuing
	      if (tech) {
	        // Check if the browser supports this technology
	        return tech.isSupported();
	      }
	
	      log$1.error('The "' + techName + '" tech is undefined. Skipped browser support check for that tech.');
	      return false;
	    });
	
	    // Iterate over each `innerArray` element once per `outerArray` element and execute
	    // `tester` with both. If `tester` returns a non-falsy value, exit early and return
	    // that value.
	    var findFirstPassingTechSourcePair = function findFirstPassingTechSourcePair(outerArray, innerArray, tester) {
	      var found = void 0;
	
	      outerArray.some(function (outerChoice) {
	        return innerArray.some(function (innerChoice) {
	          found = tester(outerChoice, innerChoice);
	
	          if (found) {
	            return true;
	          }
	        });
	      });
	
	      return found;
	    };
	
	    var foundSourceAndTech = void 0;
	    var flip = function flip(fn) {
	      return function (a, b) {
	        return fn(b, a);
	      };
	    };
	    var finder = function finder(_ref2, source) {
	      var techName = _ref2[0],
	          tech = _ref2[1];
	
	      if (tech.canPlaySource(source, _this9.options_[techName.toLowerCase()])) {
	        return { source: source, tech: techName };
	      }
	    };
	
	    // Depending on the truthiness of `options.sourceOrder`, we swap the order of techs and sources
	    // to select from them based on their priority.
	    if (this.options_.sourceOrder) {
	      // Source-first ordering
	      foundSourceAndTech = findFirstPassingTechSourcePair(sources, techs, flip(finder));
	    } else {
	      // Tech-first ordering
	      foundSourceAndTech = findFirstPassingTechSourcePair(techs, sources, finder);
	    }
	
	    return foundSourceAndTech || false;
	  };
	
	  /**
	   * Get or set the video source.
	   *
	   * @param {Tech~SourceObject|Tech~SourceObject[]|string} [source]
	   *        A SourceObject, an array of SourceObjects, or a string referencing
	   *        a URL to a media source. It is _highly recommended_ that an object
	   *        or array of objects is used here, so that source selection
	   *        algorithms can take the `type` into account.
	   *
	   *        If not provided, this method acts as a getter.
	   *
	   * @return {string|undefined}
	   *         If the `source` argument is missing, returns the current source
	   *         URL. Otherwise, returns nothing/undefined.
	   */
	
	
	  Player.prototype.src = function src(source) {
	    var _this10 = this;
	
	    // getter usage
	    if (typeof source === 'undefined') {
	      return this.cache_.src || '';
	    }
	    // filter out invalid sources and turn our source into
	    // an array of source objects
	    var sources = filterSource(source);
	
	    // if a source was passed in then it is invalid because
	    // it was filtered to a zero length Array. So we have to
	    // show an error
	    if (!sources.length) {
	      this.setTimeout(function () {
	        this.error({ code: 4, message: this.localize(this.options_.notSupportedMessage) });
	      }, 0);
	      return;
	    }
	
	    // intial sources
	    this.changingSrc_ = true;
	
	    this.cache_.sources = sources;
	    this.updateSourceCaches_(sources[0]);
	
	    // middlewareSource is the source after it has been changed by middleware
	    setSource(this, sources[0], function (middlewareSource, mws) {
	      _this10.middleware_ = mws;
	
	      // since sourceSet is async we have to update the cache again after we select a source since
	      // the source that is selected could be out of order from the cache update above this callback.
	      _this10.cache_.sources = sources;
	      _this10.updateSourceCaches_(middlewareSource);
	
	      var err = _this10.src_(middlewareSource);
	
	      if (err) {
	        if (sources.length > 1) {
	          return _this10.src(sources.slice(1));
	        }
	
	        _this10.changingSrc_ = false;
	
	        // We need to wrap this in a timeout to give folks a chance to add error event handlers
	        _this10.setTimeout(function () {
	          this.error({ code: 4, message: this.localize(this.options_.notSupportedMessage) });
	        }, 0);
	
	        // we could not find an appropriate tech, but let's still notify the delegate that this is it
	        // this needs a better comment about why this is needed
	        _this10.triggerReady();
	
	        return;
	      }
	
	      setTech(mws, _this10.tech_);
	    });
	  };
	
	  /**
	   * Set the source object on the tech, returns a boolean that indicates whether
	   * there is a tech that can play the source or not
	   *
	   * @param {Tech~SourceObject} source
	   *        The source object to set on the Tech
	   *
	   * @return {Boolean}
	   *         - True if there is no Tech to playback this source
	   *         - False otherwise
	   *
	   * @private
	   */
	
	
	  Player.prototype.src_ = function src_(source) {
	    var _this11 = this;
	
	    var sourceTech = this.selectSource([source]);
	
	    if (!sourceTech) {
	      return true;
	    }
	
	    if (!titleCaseEquals(sourceTech.tech, this.techName_)) {
	      this.changingSrc_ = true;
	      // load this technology with the chosen source
	      this.loadTech_(sourceTech.tech, sourceTech.source);
	      this.tech_.ready(function () {
	        _this11.changingSrc_ = false;
	      });
	      return false;
	    }
	
	    // wait until the tech is ready to set the source
	    // and set it synchronously if possible (#2326)
	    this.ready(function () {
	
	      // The setSource tech method was added with source handlers
	      // so older techs won't support it
	      // We need to check the direct prototype for the case where subclasses
	      // of the tech do not support source handlers
	      if (this.tech_.constructor.prototype.hasOwnProperty('setSource')) {
	        this.techCall_('setSource', source);
	      } else {
	        this.techCall_('src', source.src);
	      }
	
	      this.changingSrc_ = false;
	    }, true);
	
	    return false;
	  };
	
	  /**
	   * Begin loading the src data.
	   */
	
	
	  Player.prototype.load = function load() {
	    this.techCall_('load');
	  };
	
	  /**
	   * Reset the player. Loads the first tech in the techOrder,
	   * and calls `reset` on the tech`.
	   */
	
	
	  Player.prototype.reset = function reset() {
	    if (this.tech_) {
	      this.tech_.clearTracks('text');
	    }
	    this.loadTech_(this.options_.techOrder[0], null);
	    this.techCall_('reset');
	  };
	
	  /**
	   * Returns all of the current source objects.
	   *
	   * @return {Tech~SourceObject[]}
	   *         The current source objects
	   */
	
	
	  Player.prototype.currentSources = function currentSources() {
	    var source = this.currentSource();
	    var sources = [];
	
	    // assume `{}` or `{ src }`
	    if (Object.keys(source).length !== 0) {
	      sources.push(source);
	    }
	
	    return this.cache_.sources || sources;
	  };
	
	  /**
	   * Returns the current source object.
	   *
	   * @return {Tech~SourceObject}
	   *         The current source object
	   */
	
	
	  Player.prototype.currentSource = function currentSource() {
	    return this.cache_.source || {};
	  };
	
	  /**
	   * Returns the fully qualified URL of the current source value e.g. http://mysite.com/video.mp4
	   * Can be used in conjunction with `currentType` to assist in rebuilding the current source object.
	   *
	   * @return {string}
	   *         The current source
	   */
	
	
	  Player.prototype.currentSrc = function currentSrc() {
	    return this.currentSource() && this.currentSource().src || '';
	  };
	
	  /**
	   * Get the current source type e.g. video/mp4
	   * This can allow you rebuild the current source object so that you could load the same
	   * source and tech later
	   *
	   * @return {string}
	   *         The source MIME type
	   */
	
	
	  Player.prototype.currentType = function currentType() {
	    return this.currentSource() && this.currentSource().type || '';
	  };
	
	  /**
	   * Get or set the preload attribute
	   *
	   * @param {boolean} [value]
	   *        - true means that we should preload
	   *        - false means that we should not preload
	   *
	   * @return {string}
	   *         The preload attribute value when getting
	   */
	
	
	  Player.prototype.preload = function preload(value) {
	    if (value !== undefined) {
	      this.techCall_('setPreload', value);
	      this.options_.preload = value;
	      return;
	    }
	    return this.techGet_('preload');
	  };
	
	  /**
	   * Get or set the autoplay option. When this is a boolean it will
	   * modify the attribute on the tech. When this is a string the attribute on
	   * the tech will be removed and `Player` will handle autoplay on loadstarts.
	   *
	   * @param {boolean|string} [value]
	   *        - true: autoplay using the browser behavior
	   *        - false: do not autoplay
	   *        - 'play': call play() on every loadstart
	   *        - 'muted': call muted() then play() on every loadstart
	   *        - 'any': call play() on every loadstart. if that fails call muted() then play().
	   *        - *: values other than those listed here will be set `autoplay` to true
	   *
	   * @return {boolean|string}
	   *         The current value of autoplay when getting
	   */
	
	
	  Player.prototype.autoplay = function autoplay(value) {
	    // getter usage
	    if (value === undefined) {
	      return this.options_.autoplay || false;
	    }
	
	    var techAutoplay = void 0;
	
	    // if the value is a valid string set it to that
	    if (typeof value === 'string' && /(any|play|muted)/.test(value)) {
	      this.options_.autoplay = value;
	      this.manualAutoplay_(value);
	      techAutoplay = false;
	
	      // any falsy value sets autoplay to false in the browser,
	      // lets do the same
	    } else if (!value) {
	      this.options_.autoplay = false;
	
	      // any other value (ie truthy) sets autoplay to true
	    } else {
	      this.options_.autoplay = true;
	    }
	
	    techAutoplay = techAutoplay || this.options_.autoplay;
	
	    // if we don't have a tech then we do not queue up
	    // a setAutoplay call on tech ready. We do this because the
	    // autoplay option will be passed in the constructor and we
	    // do not need to set it twice
	    if (this.tech_) {
	      this.techCall_('setAutoplay', techAutoplay);
	    }
	  };
	
	  /**
	   * Set or unset the playsinline attribute.
	   * Playsinline tells the browser that non-fullscreen playback is preferred.
	   *
	   * @param {boolean} [value]
	   *        - true means that we should try to play inline by default
	   *        - false means that we should use the browser's default playback mode,
	   *          which in most cases is inline. iOS Safari is a notable exception
	   *          and plays fullscreen by default.
	   *
	   * @return {string|Player}
	   *         - the current value of playsinline
	   *         - the player when setting
	   *
	   * @see [Spec]{@link https://html.spec.whatwg.org/#attr-video-playsinline}
	   */
	
	
	  Player.prototype.playsinline = function playsinline(value) {
	    if (value !== undefined) {
	      this.techCall_('setPlaysinline', value);
	      this.options_.playsinline = value;
	      return this;
	    }
	    return this.techGet_('playsinline');
	  };
	
	  /**
	   * Get or set the loop attribute on the video element.
	   *
	   * @param {boolean} [value]
	   *        - true means that we should loop the video
	   *        - false means that we should not loop the video
	   *
	   * @return {string}
	   *         The current value of loop when getting
	   */
	
	
	  Player.prototype.loop = function loop(value) {
	    if (value !== undefined) {
	      this.techCall_('setLoop', value);
	      this.options_.loop = value;
	      return;
	    }
	    return this.techGet_('loop');
	  };
	
	  /**
	   * Get or set the poster image source url
	   *
	   * @fires Player#posterchange
	   *
	   * @param {string} [src]
	   *        Poster image source URL
	   *
	   * @return {string}
	   *         The current value of poster when getting
	   */
	
	
	  Player.prototype.poster = function poster(src) {
	    if (src === undefined) {
	      return this.poster_;
	    }
	
	    // The correct way to remove a poster is to set as an empty string
	    // other falsey values will throw errors
	    if (!src) {
	      src = '';
	    }
	
	    if (src === this.poster_) {
	      return;
	    }
	
	    // update the internal poster variable
	    this.poster_ = src;
	
	    // update the tech's poster
	    this.techCall_('setPoster', src);
	
	    this.isPosterFromTech_ = false;
	
	    // alert components that the poster has been set
	    /**
	     * This event fires when the poster image is changed on the player.
	     *
	     * @event Player#posterchange
	     * @type {EventTarget~Event}
	     */
	    this.trigger('posterchange');
	  };
	
	  /**
	   * Some techs (e.g. YouTube) can provide a poster source in an
	   * asynchronous way. We want the poster component to use this
	   * poster source so that it covers up the tech's controls.
	   * (YouTube's play button). However we only want to use this
	   * source if the player user hasn't set a poster through
	   * the normal APIs.
	   *
	   * @fires Player#posterchange
	   * @listens Tech#posterchange
	   * @private
	   */
	
	
	  Player.prototype.handleTechPosterChange_ = function handleTechPosterChange_() {
	    if ((!this.poster_ || this.options_.techCanOverridePoster) && this.tech_ && this.tech_.poster) {
	      var newPoster = this.tech_.poster() || '';
	
	      if (newPoster !== this.poster_) {
	        this.poster_ = newPoster;
	        this.isPosterFromTech_ = true;
	
	        // Let components know the poster has changed
	        this.trigger('posterchange');
	      }
	    }
	  };
	
	  /**
	   * Get or set whether or not the controls are showing.
	   *
	   * @fires Player#controlsenabled
	   *
	   * @param {boolean} [bool]
	   *        - true to turn controls on
	   *        - false to turn controls off
	   *
	   * @return {boolean}
	   *         The current value of controls when getting
	   */
	
	
	  Player.prototype.controls = function controls(bool) {
	    if (bool === undefined) {
	      return !!this.controls_;
	    }
	
	    bool = !!bool;
	
	    // Don't trigger a change event unless it actually changed
	    if (this.controls_ === bool) {
	      return;
	    }
	
	    this.controls_ = bool;
	
	    if (this.usingNativeControls()) {
	      this.techCall_('setControls', bool);
	    }
	
	    if (this.controls_) {
	      this.removeClass('vjs-controls-disabled');
	      this.addClass('vjs-controls-enabled');
	      /**
	       * @event Player#controlsenabled
	       * @type {EventTarget~Event}
	       */
	      this.trigger('controlsenabled');
	      if (!this.usingNativeControls()) {
	        this.addTechControlsListeners_();
	      }
	    } else {
	      this.removeClass('vjs-controls-enabled');
	      this.addClass('vjs-controls-disabled');
	      /**
	       * @event Player#controlsdisabled
	       * @type {EventTarget~Event}
	       */
	      this.trigger('controlsdisabled');
	      if (!this.usingNativeControls()) {
	        this.removeTechControlsListeners_();
	      }
	    }
	  };
	
	  /**
	   * Toggle native controls on/off. Native controls are the controls built into
	   * devices (e.g. default iPhone controls), Flash, or other techs
	   * (e.g. Vimeo Controls)
	   * **This should only be set by the current tech, because only the tech knows
	   * if it can support native controls**
	   *
	   * @fires Player#usingnativecontrols
	   * @fires Player#usingcustomcontrols
	   *
	   * @param {boolean} [bool]
	   *        - true to turn native controls on
	   *        - false to turn native controls off
	   *
	   * @return {boolean}
	   *         The current value of native controls when getting
	   */
	
	
	  Player.prototype.usingNativeControls = function usingNativeControls(bool) {
	    if (bool === undefined) {
	      return !!this.usingNativeControls_;
	    }
	
	    bool = !!bool;
	
	    // Don't trigger a change event unless it actually changed
	    if (this.usingNativeControls_ === bool) {
	      return;
	    }
	
	    this.usingNativeControls_ = bool;
	
	    if (this.usingNativeControls_) {
	      this.addClass('vjs-using-native-controls');
	
	      /**
	       * player is using the native device controls
	       *
	       * @event Player#usingnativecontrols
	       * @type {EventTarget~Event}
	       */
	      this.trigger('usingnativecontrols');
	    } else {
	      this.removeClass('vjs-using-native-controls');
	
	      /**
	       * player is using the custom HTML controls
	       *
	       * @event Player#usingcustomcontrols
	       * @type {EventTarget~Event}
	       */
	      this.trigger('usingcustomcontrols');
	    }
	  };
	
	  /**
	   * Set or get the current MediaError
	   *
	   * @fires Player#error
	   *
	   * @param  {MediaError|string|number} [err]
	   *         A MediaError or a string/number to be turned
	   *         into a MediaError
	   *
	   * @return {MediaError|null}
	   *         The current MediaError when getting (or null)
	   */
	
	
	  Player.prototype.error = function error(err) {
	    if (err === undefined) {
	      return this.error_ || null;
	    }
	
	    // restoring to default
	    if (err === null) {
	      this.error_ = err;
	      this.removeClass('vjs-error');
	      if (this.errorDisplay) {
	        this.errorDisplay.close();
	      }
	      return;
	    }
	
	    this.error_ = new MediaError(err);
	
	    // add the vjs-error classname to the player
	    this.addClass('vjs-error');
	
	    // log the name of the error type and any message
	    // IE11 logs "[object object]" and required you to expand message to see error object
	    log$1.error('(CODE:' + this.error_.code + ' ' + MediaError.errorTypes[this.error_.code] + ')', this.error_.message, this.error_);
	
	    /**
	     * @event Player#error
	     * @type {EventTarget~Event}
	     */
	    this.trigger('error');
	
	    return;
	  };
	
	  /**
	   * Report user activity
	   *
	   * @param {Object} event
	   *        Event object
	   */
	
	
	  Player.prototype.reportUserActivity = function reportUserActivity(event) {
	    this.userActivity_ = true;
	  };
	
	  /**
	   * Get/set if user is active
	   *
	   * @fires Player#useractive
	   * @fires Player#userinactive
	   *
	   * @param {boolean} [bool]
	   *        - true if the user is active
	   *        - false if the user is inactive
	   *
	   * @return {boolean}
	   *         The current value of userActive when getting
	   */
	
	
	  Player.prototype.userActive = function userActive(bool) {
	    if (bool === undefined) {
	      return this.userActive_;
	    }
	
	    bool = !!bool;
	
	    if (bool === this.userActive_) {
	      return;
	    }
	
	    this.userActive_ = bool;
	
	    if (this.userActive_) {
	      this.userActivity_ = true;
	      this.removeClass('vjs-user-inactive');
	      this.addClass('vjs-user-active');
	      /**
	       * @event Player#useractive
	       * @type {EventTarget~Event}
	       */
	      this.trigger('useractive');
	      return;
	    }
	
	    // Chrome/Safari/IE have bugs where when you change the cursor it can
	    // trigger a mousemove event. This causes an issue when you're hiding
	    // the cursor when the user is inactive, and a mousemove signals user
	    // activity. Making it impossible to go into inactive mode. Specifically
	    // this happens in fullscreen when we really need to hide the cursor.
	    //
	    // When this gets resolved in ALL browsers it can be removed
	    // https://code.google.com/p/chromium/issues/detail?id=103041
	    if (this.tech_) {
	      this.tech_.one('mousemove', function (e) {
	        e.stopPropagation();
	        e.preventDefault();
	      });
	    }
	
	    this.userActivity_ = false;
	    this.removeClass('vjs-user-active');
	    this.addClass('vjs-user-inactive');
	    /**
	     * @event Player#userinactive
	     * @type {EventTarget~Event}
	     */
	    this.trigger('userinactive');
	  };
	
	  /**
	   * Listen for user activity based on timeout value
	   *
	   * @private
	   */
	
	
	  Player.prototype.listenForUserActivity_ = function listenForUserActivity_() {
	    var mouseInProgress = void 0;
	    var lastMoveX = void 0;
	    var lastMoveY = void 0;
	    var handleActivity = bind(this, this.reportUserActivity);
	
	    var handleMouseMove = function handleMouseMove(e) {
	      // #1068 - Prevent mousemove spamming
	      // Chrome Bug: https://code.google.com/p/chromium/issues/detail?id=366970
	      if (e.screenX !== lastMoveX || e.screenY !== lastMoveY) {
	        lastMoveX = e.screenX;
	        lastMoveY = e.screenY;
	        handleActivity();
	      }
	    };
	
	    var handleMouseDown = function handleMouseDown() {
	      handleActivity();
	      // For as long as the they are touching the device or have their mouse down,
	      // we consider them active even if they're not moving their finger or mouse.
	      // So we want to continue to update that they are active
	      this.clearInterval(mouseInProgress);
	      // Setting userActivity=true now and setting the interval to the same time
	      // as the activityCheck interval (250) should ensure we never miss the
	      // next activityCheck
	      mouseInProgress = this.setInterval(handleActivity, 250);
	    };
	
	    var handleMouseUp = function handleMouseUp(event) {
	      handleActivity();
	      // Stop the interval that maintains activity if the mouse/touch is down
	      this.clearInterval(mouseInProgress);
	    };
	
	    // Any mouse movement will be considered user activity
	    this.on('mousedown', handleMouseDown);
	    this.on('mousemove', handleMouseMove);
	    this.on('mouseup', handleMouseUp);
	
	    // Listen for keyboard navigation
	    // Shouldn't need to use inProgress interval because of key repeat
	    this.on('keydown', handleActivity);
	    this.on('keyup', handleActivity);
	
	    // Run an interval every 250 milliseconds instead of stuffing everything into
	    // the mousemove/touchmove function itself, to prevent performance degradation.
	    // `this.reportUserActivity` simply sets this.userActivity_ to true, which
	    // then gets picked up by this loop
	    // http://ejohn.org/blog/learning-from-twitter/
	    var inactivityTimeout = void 0;
	
	    this.setInterval(function () {
	      // Check to see if mouse/touch activity has happened
	      if (!this.userActivity_) {
	        return;
	      }
	
	      // Reset the activity tracker
	      this.userActivity_ = false;
	
	      // If the user state was inactive, set the state to active
	      this.userActive(true);
	
	      // Clear any existing inactivity timeout to start the timer over
	      this.clearTimeout(inactivityTimeout);
	
	      var timeout = this.options_.inactivityTimeout;
	
	      if (timeout <= 0) {
	        return;
	      }
	
	      // In <timeout> milliseconds, if no more activity has occurred the
	      // user will be considered inactive
	      inactivityTimeout = this.setTimeout(function () {
	        // Protect against the case where the inactivityTimeout can trigger just
	        // before the next user activity is picked up by the activity check loop
	        // causing a flicker
	        if (!this.userActivity_) {
	          this.userActive(false);
	        }
	      }, timeout);
	    }, 250);
	  };
	
	  /**
	   * Gets or sets the current playback rate. A playback rate of
	   * 1.0 represents normal speed and 0.5 would indicate half-speed
	   * playback, for instance.
	   *
	   * @see https://html.spec.whatwg.org/multipage/embedded-content.html#dom-media-playbackrate
	   *
	   * @param {number} [rate]
	   *       New playback rate to set.
	   *
	   * @return {number}
	   *         The current playback rate when getting or 1.0
	   */
	
	
	  Player.prototype.playbackRate = function playbackRate(rate) {
	    if (rate !== undefined) {
	      // NOTE: this.cache_.lastPlaybackRate is set from the tech handler
	      // that is registered above
	      this.techCall_('setPlaybackRate', rate);
	      return;
	    }
	
	    if (this.tech_ && this.tech_.featuresPlaybackRate) {
	      return this.cache_.lastPlaybackRate || this.techGet_('playbackRate');
	    }
	    return 1.0;
	  };
	
	  /**
	   * Gets or sets the current default playback rate. A default playback rate of
	   * 1.0 represents normal speed and 0.5 would indicate half-speed playback, for instance.
	   * defaultPlaybackRate will only represent what the initial playbackRate of a video was, not
	   * not the current playbackRate.
	   *
	   * @see https://html.spec.whatwg.org/multipage/embedded-content.html#dom-media-defaultplaybackrate
	   *
	   * @param {number} [rate]
	   *       New default playback rate to set.
	   *
	   * @return {number|Player}
	   *         - The default playback rate when getting or 1.0
	   *         - the player when setting
	   */
	
	
	  Player.prototype.defaultPlaybackRate = function defaultPlaybackRate(rate) {
	    if (rate !== undefined) {
	      return this.techCall_('setDefaultPlaybackRate', rate);
	    }
	
	    if (this.tech_ && this.tech_.featuresPlaybackRate) {
	      return this.techGet_('defaultPlaybackRate');
	    }
	    return 1.0;
	  };
	
	  /**
	   * Gets or sets the audio flag
	   *
	   * @param {boolean} bool
	   *        - true signals that this is an audio player
	   *        - false signals that this is not an audio player
	   *
	   * @return {boolean}
	   *         The current value of isAudio when getting
	   */
	
	
	  Player.prototype.isAudio = function isAudio(bool) {
	    if (bool !== undefined) {
	      this.isAudio_ = !!bool;
	      return;
	    }
	
	    return !!this.isAudio_;
	  };
	
	  /**
	   * A helper method for adding a {@link TextTrack} to our
	   * {@link TextTrackList}.
	   *
	   * In addition to the W3C settings we allow adding additional info through options.
	   *
	   * @see http://www.w3.org/html/wg/drafts/html/master/embedded-content-0.html#dom-media-addtexttrack
	   *
	   * @param {string} [kind]
	   *        the kind of TextTrack you are adding
	   *
	   * @param {string} [label]
	   *        the label to give the TextTrack label
	   *
	   * @param {string} [language]
	   *        the language to set on the TextTrack
	   *
	   * @return {TextTrack|undefined}
	   *         the TextTrack that was added or undefined
	   *         if there is no tech
	   */
	
	
	  Player.prototype.addTextTrack = function addTextTrack(kind, label, language) {
	    if (this.tech_) {
	      return this.tech_.addTextTrack(kind, label, language);
	    }
	  };
	
	  /**
	   * Create a remote {@link TextTrack} and an {@link HTMLTrackElement}. It will
	   * automatically removed from the video element whenever the source changes, unless
	   * manualCleanup is set to false.
	   *
	   * @param {Object} options
	   *        Options to pass to {@link HTMLTrackElement} during creation. See
	   *        {@link HTMLTrackElement} for object properties that you should use.
	   *
	   * @param {boolean} [manualCleanup=true] if set to false, the TextTrack will be
	   *
	   * @return {HtmlTrackElement}
	   *         the HTMLTrackElement that was created and added
	   *         to the HtmlTrackElementList and the remote
	   *         TextTrackList
	   *
	   * @deprecated The default value of the "manualCleanup" parameter will default
	   *             to "false" in upcoming versions of Video.js
	   */
	
	
	  Player.prototype.addRemoteTextTrack = function addRemoteTextTrack(options, manualCleanup) {
	    if (this.tech_) {
	      return this.tech_.addRemoteTextTrack(options, manualCleanup);
	    }
	  };
	
	  /**
	   * Remove a remote {@link TextTrack} from the respective
	   * {@link TextTrackList} and {@link HtmlTrackElementList}.
	   *
	   * @param {Object} track
	   *        Remote {@link TextTrack} to remove
	   *
	   * @return {undefined}
	   *         does not return anything
	   */
	
	
	  Player.prototype.removeRemoteTextTrack = function removeRemoteTextTrack() {
	    var _ref3 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
	        _ref3$track = _ref3.track,
	        track = _ref3$track === undefined ? arguments[0] : _ref3$track;
	
	    // destructure the input into an object with a track argument, defaulting to arguments[0]
	    // default the whole argument to an empty object if nothing was passed in
	
	    if (this.tech_) {
	      return this.tech_.removeRemoteTextTrack(track);
	    }
	  };
	
	  /**
	   * Gets available media playback quality metrics as specified by the W3C's Media
	   * Playback Quality API.
	   *
	   * @see [Spec]{@link https://wicg.github.io/media-playback-quality}
	   *
	   * @return {Object|undefined}
	   *         An object with supported media playback quality metrics or undefined if there
	   *         is no tech or the tech does not support it.
	   */
	
	
	  Player.prototype.getVideoPlaybackQuality = function getVideoPlaybackQuality() {
	    return this.techGet_('getVideoPlaybackQuality');
	  };
	
	  /**
	   * Get video width
	   *
	   * @return {number}
	   *         current video width
	   */
	
	
	  Player.prototype.videoWidth = function videoWidth() {
	    return this.tech_ && this.tech_.videoWidth && this.tech_.videoWidth() || 0;
	  };
	
	  /**
	   * Get video height
	   *
	   * @return {number}
	   *         current video height
	   */
	
	
	  Player.prototype.videoHeight = function videoHeight() {
	    return this.tech_ && this.tech_.videoHeight && this.tech_.videoHeight() || 0;
	  };
	
	  /**
	   * The player's language code
	   * NOTE: The language should be set in the player options if you want the
	   * the controls to be built with a specific language. Changing the language
	   * later will not update controls text.
	   *
	   * @param {string} [code]
	   *        the language code to set the player to
	   *
	   * @return {string}
	   *         The current language code when getting
	   */
	
	
	  Player.prototype.language = function language(code) {
	    if (code === undefined) {
	      return this.language_;
	    }
	
	    this.language_ = String(code).toLowerCase();
	  };
	
	  /**
	   * Get the player's language dictionary
	   * Merge every time, because a newly added plugin might call videojs.addLanguage() at any time
	   * Languages specified directly in the player options have precedence
	   *
	   * @return {Array}
	   *         An array of of supported languages
	   */
	
	
	  Player.prototype.languages = function languages() {
	    return mergeOptions(Player.prototype.options_.languages, this.languages_);
	  };
	
	  /**
	   * returns a JavaScript object reperesenting the current track
	   * information. **DOES not return it as JSON**
	   *
	   * @return {Object}
	   *         Object representing the current of track info
	   */
	
	
	  Player.prototype.toJSON = function toJSON() {
	    var options = mergeOptions(this.options_);
	    var tracks = options.tracks;
	
	    options.tracks = [];
	
	    for (var i = 0; i < tracks.length; i++) {
	      var track = tracks[i];
	
	      // deep merge tracks and null out player so no circular references
	      track = mergeOptions(track);
	      track.player = undefined;
	      options.tracks[i] = track;
	    }
	
	    return options;
	  };
	
	  /**
	   * Creates a simple modal dialog (an instance of the {@link ModalDialog}
	   * component) that immediately overlays the player with arbitrary
	   * content and removes itself when closed.
	   *
	   * @param {string|Function|Element|Array|null} content
	   *        Same as {@link ModalDialog#content}'s param of the same name.
	   *        The most straight-forward usage is to provide a string or DOM
	   *        element.
	   *
	   * @param {Object} [options]
	   *        Extra options which will be passed on to the {@link ModalDialog}.
	   *
	   * @return {ModalDialog}
	   *         the {@link ModalDialog} that was created
	   */
	
	
	  Player.prototype.createModal = function createModal(content, options) {
	    var _this12 = this;
	
	    options = options || {};
	    options.content = content || '';
	
	    var modal = new ModalDialog(this, options);
	
	    this.addChild(modal);
	    modal.on('dispose', function () {
	      _this12.removeChild(modal);
	    });
	
	    modal.open();
	    return modal;
	  };
	
	  /**
	   * Gets tag settings
	   *
	   * @param {Element} tag
	   *        The player tag
	   *
	   * @return {Object}
	   *         An object containing all of the settings
	   *         for a player tag
	   */
	
	
	  Player.getTagSettings = function getTagSettings(tag) {
	    var baseOptions = {
	      sources: [],
	      tracks: []
	    };
	
	    var tagOptions = getAttributes(tag);
	    var dataSetup = tagOptions['data-setup'];
	
	    if (hasClass(tag, 'vjs-fluid')) {
	      tagOptions.fluid = true;
	    }
	
	    // Check if data-setup attr exists.
	    if (dataSetup !== null) {
	      // Parse options JSON
	      // If empty string, make it a parsable json object.
	      var _safeParseTuple = safeParseTuple(dataSetup || '{}'),
	          err = _safeParseTuple[0],
	          data = _safeParseTuple[1];
	
	      if (err) {
	        log$1.error(err);
	      }
	      assign(tagOptions, data);
	    }
	
	    assign(baseOptions, tagOptions);
	
	    // Get tag children settings
	    if (tag.hasChildNodes()) {
	      var children = tag.childNodes;
	
	      for (var i = 0, j = children.length; i < j; i++) {
	        var child = children[i];
	        // Change case needed: http://ejohn.org/blog/nodename-case-sensitivity/
	        var childName = child.nodeName.toLowerCase();
	
	        if (childName === 'source') {
	          baseOptions.sources.push(getAttributes(child));
	        } else if (childName === 'track') {
	          baseOptions.tracks.push(getAttributes(child));
	        }
	      }
	    }
	
	    return baseOptions;
	  };
	
	  /**
	   * Determine whether or not flexbox is supported
	   *
	   * @return {boolean}
	   *         - true if flexbox is supported
	   *         - false if flexbox is not supported
	   */
	
	
	  Player.prototype.flexNotSupported_ = function flexNotSupported_() {
	    var elem = document.createElement('i');
	
	    // Note: We don't actually use flexBasis (or flexOrder), but it's one of the more
	    // common flex features that we can rely on when checking for flex support.
	    return !('flexBasis' in elem.style || 'webkitFlexBasis' in elem.style || 'mozFlexBasis' in elem.style || 'msFlexBasis' in elem.style ||
	    // IE10-specific (2012 flex spec), available for completeness
	    'msFlexOrder' in elem.style);
	  };
	
	  return Player;
	}(Component);
	
	/**
	 * Get the {@link VideoTrackList}
	 * @link https://html.spec.whatwg.org/multipage/embedded-content.html#videotracklist
	 *
	 * @return {VideoTrackList}
	 *         the current video track list
	 *
	 * @method Player.prototype.videoTracks
	 */
	
	/**
	 * Get the {@link AudioTrackList}
	 * @link https://html.spec.whatwg.org/multipage/embedded-content.html#audiotracklist
	 *
	 * @return {AudioTrackList}
	 *         the current audio track list
	 *
	 * @method Player.prototype.audioTracks
	 */
	
	/**
	 * Get the {@link TextTrackList}
	 *
	 * @link http://www.w3.org/html/wg/drafts/html/master/embedded-content-0.html#dom-media-texttracks
	 *
	 * @return {TextTrackList}
	 *         the current text track list
	 *
	 * @method Player.prototype.textTracks
	 */
	
	/**
	 * Get the remote {@link TextTrackList}
	 *
	 * @return {TextTrackList}
	 *         The current remote text track list
	 *
	 * @method Player.prototype.remoteTextTracks
	 */
	
	/**
	 * Get the remote {@link HtmlTrackElementList} tracks.
	 *
	 * @return {HtmlTrackElementList}
	 *         The current remote text track element list
	 *
	 * @method Player.prototype.remoteTextTrackEls
	 */
	
	ALL.names.forEach(function (name$$1) {
	  var props = ALL[name$$1];
	
	  Player.prototype[props.getterName] = function () {
	    if (this.tech_) {
	      return this.tech_[props.getterName]();
	    }
	
	    // if we have not yet loadTech_, we create {video,audio,text}Tracks_
	    // these will be passed to the tech during loading
	    this[props.privateName] = this[props.privateName] || new props.ListClass();
	    return this[props.privateName];
	  };
	});
	
	/**
	 * Global player list
	 *
	 * @type {Object}
	 */
	Player.players = {};
	
	var navigator = window$1.navigator;
	
	/*
	 * Player instance options, surfaced using options
	 * options = Player.prototype.options_
	 * Make changes in options, not here.
	 *
	 * @type {Object}
	 * @private
	 */
	Player.prototype.options_ = {
	  // Default order of fallback technology
	  techOrder: Tech.defaultTechOrder_,
	
	  html5: {},
	  flash: {},
	
	  // default inactivity timeout
	  inactivityTimeout: 2000,
	
	  // default playback rates
	  playbackRates: [],
	  // Add playback rate selection by adding rates
	  // 'playbackRates': [0.5, 1, 1.5, 2],
	
	  // Included control sets
	  children: ['mediaLoader', 'posterImage', 'textTrackDisplay', 'loadingSpinner', 'bigPlayButton', 'controlBar', 'errorDisplay', 'textTrackSettings', 'resizeManager'],
	
	  language: navigator && (navigator.languages && navigator.languages[0] || navigator.userLanguage || navigator.language) || 'en',
	
	  // locales and their language translations
	  languages: {},
	
	  // Default message to show when a video cannot be played.
	  notSupportedMessage: 'No compatible source was found for this media.'
	};
	
	[
	/**
	 * Returns whether or not the player is in the "ended" state.
	 *
	 * @return {Boolean} True if the player is in the ended state, false if not.
	 * @method Player#ended
	 */
	'ended',
	/**
	 * Returns whether or not the player is in the "seeking" state.
	 *
	 * @return {Boolean} True if the player is in the seeking state, false if not.
	 * @method Player#seeking
	 */
	'seeking',
	/**
	 * Returns the TimeRanges of the media that are currently available
	 * for seeking to.
	 *
	 * @return {TimeRanges} the seekable intervals of the media timeline
	 * @method Player#seekable
	 */
	'seekable',
	/**
	 * Returns the current state of network activity for the element, from
	 * the codes in the list below.
	 * - NETWORK_EMPTY (numeric value 0)
	 *   The element has not yet been initialised. All attributes are in
	 *   their initial states.
	 * - NETWORK_IDLE (numeric value 1)
	 *   The element's resource selection algorithm is active and has
	 *   selected a resource, but it is not actually using the network at
	 *   this time.
	 * - NETWORK_LOADING (numeric value 2)
	 *   The user agent is actively trying to download data.
	 * - NETWORK_NO_SOURCE (numeric value 3)
	 *   The element's resource selection algorithm is active, but it has
	 *   not yet found a resource to use.
	 *
	 * @see https://html.spec.whatwg.org/multipage/embedded-content.html#network-states
	 * @return {number} the current network activity state
	 * @method Player#networkState
	 */
	'networkState',
	/**
	 * Returns a value that expresses the current state of the element
	 * with respect to rendering the current playback position, from the
	 * codes in the list below.
	 * - HAVE_NOTHING (numeric value 0)
	 *   No information regarding the media resource is available.
	 * - HAVE_METADATA (numeric value 1)
	 *   Enough of the resource has been obtained that the duration of the
	 *   resource is available.
	 * - HAVE_CURRENT_DATA (numeric value 2)
	 *   Data for the immediate current playback position is available.
	 * - HAVE_FUTURE_DATA (numeric value 3)
	 *   Data for the immediate current playback position is available, as
	 *   well as enough data for the user agent to advance the current
	 *   playback position in the direction of playback.
	 * - HAVE_ENOUGH_DATA (numeric value 4)
	 *   The user agent estimates that enough data is available for
	 *   playback to proceed uninterrupted.
	 *
	 * @see https://html.spec.whatwg.org/multipage/embedded-content.html#dom-media-readystate
	 * @return {number} the current playback rendering state
	 * @method Player#readyState
	 */
	'readyState'].forEach(function (fn) {
	  Player.prototype[fn] = function () {
	    return this.techGet_(fn);
	  };
	});
	
	TECH_EVENTS_RETRIGGER.forEach(function (event) {
	  Player.prototype['handleTech' + toTitleCase(event) + '_'] = function () {
	    return this.trigger(event);
	  };
	});
	
	/**
	 * Fired when the player has initial duration and dimension information
	 *
	 * @event Player#loadedmetadata
	 * @type {EventTarget~Event}
	 */
	
	/**
	 * Fired when the player has downloaded data at the current playback position
	 *
	 * @event Player#loadeddata
	 * @type {EventTarget~Event}
	 */
	
	/**
	 * Fired when the current playback position has changed *
	 * During playback this is fired every 15-250 milliseconds, depending on the
	 * playback technology in use.
	 *
	 * @event Player#timeupdate
	 * @type {EventTarget~Event}
	 */
	
	/**
	 * Fired when the volume changes
	 *
	 * @event Player#volumechange
	 * @type {EventTarget~Event}
	 */
	
	/**
	 * Reports whether or not a player has a plugin available.
	 *
	 * This does not report whether or not the plugin has ever been initialized
	 * on this player. For that, [usingPlugin]{@link Player#usingPlugin}.
	 *
	 * @method Player#hasPlugin
	 * @param  {string}  name
	 *         The name of a plugin.
	 *
	 * @return {boolean}
	 *         Whether or not this player has the requested plugin available.
	 */
	
	/**
	 * Reports whether or not a player is using a plugin by name.
	 *
	 * For basic plugins, this only reports whether the plugin has _ever_ been
	 * initialized on this player.
	 *
	 * @method Player#usingPlugin
	 * @param  {string} name
	 *         The name of a plugin.
	 *
	 * @return {boolean}
	 *         Whether or not this player is using the requested plugin.
	 */
	
	Component.registerComponent('Player', Player);
	
	/**
	 * @file plugin.js
	 */
	
	/**
	 * The base plugin name.
	 *
	 * @private
	 * @constant
	 * @type {string}
	 */
	var BASE_PLUGIN_NAME = 'plugin';
	
	/**
	 * The key on which a player's active plugins cache is stored.
	 *
	 * @private
	 * @constant
	 * @type     {string}
	 */
	var PLUGIN_CACHE_KEY = 'activePlugins_';
	
	/**
	 * Stores registered plugins in a private space.
	 *
	 * @private
	 * @type    {Object}
	 */
	var pluginStorage = {};
	
	/**
	 * Reports whether or not a plugin has been registered.
	 *
	 * @private
	 * @param   {string} name
	 *          The name of a plugin.
	 *
	 * @returns {boolean}
	 *          Whether or not the plugin has been registered.
	 */
	var pluginExists = function pluginExists(name) {
	  return pluginStorage.hasOwnProperty(name);
	};
	
	/**
	 * Get a single registered plugin by name.
	 *
	 * @private
	 * @param   {string} name
	 *          The name of a plugin.
	 *
	 * @returns {Function|undefined}
	 *          The plugin (or undefined).
	 */
	var getPlugin = function getPlugin(name) {
	  return pluginExists(name) ? pluginStorage[name] : undefined;
	};
	
	/**
	 * Marks a plugin as "active" on a player.
	 *
	 * Also, ensures that the player has an object for tracking active plugins.
	 *
	 * @private
	 * @param   {Player} player
	 *          A Video.js player instance.
	 *
	 * @param   {string} name
	 *          The name of a plugin.
	 */
	var markPluginAsActive = function markPluginAsActive(player, name) {
	  player[PLUGIN_CACHE_KEY] = player[PLUGIN_CACHE_KEY] || {};
	  player[PLUGIN_CACHE_KEY][name] = true;
	};
	
	/**
	 * Triggers a pair of plugin setup events.
	 *
	 * @private
	 * @param  {Player} player
	 *         A Video.js player instance.
	 *
	 * @param  {Plugin~PluginEventHash} hash
	 *         A plugin event hash.
	 *
	 * @param  {Boolean} [before]
	 *         If true, prefixes the event name with "before". In other words,
	 *         use this to trigger "beforepluginsetup" instead of "pluginsetup".
	 */
	var triggerSetupEvent = function triggerSetupEvent(player, hash, before) {
	  var eventName = (before ? 'before' : '') + 'pluginsetup';
	
	  player.trigger(eventName, hash);
	  player.trigger(eventName + ':' + hash.name, hash);
	};
	
	/**
	 * Takes a basic plugin function and returns a wrapper function which marks
	 * on the player that the plugin has been activated.
	 *
	 * @private
	 * @param   {string} name
	 *          The name of the plugin.
	 *
	 * @param   {Function} plugin
	 *          The basic plugin.
	 *
	 * @returns {Function}
	 *          A wrapper function for the given plugin.
	 */
	var createBasicPlugin = function createBasicPlugin(name, plugin) {
	  var basicPluginWrapper = function basicPluginWrapper() {
	
	    // We trigger the "beforepluginsetup" and "pluginsetup" events on the player
	    // regardless, but we want the hash to be consistent with the hash provided
	    // for advanced plugins.
	    //
	    // The only potentially counter-intuitive thing here is the `instance` in
	    // the "pluginsetup" event is the value returned by the `plugin` function.
	    triggerSetupEvent(this, { name: name, plugin: plugin, instance: null }, true);
	
	    var instance = plugin.apply(this, arguments);
	
	    markPluginAsActive(this, name);
	    triggerSetupEvent(this, { name: name, plugin: plugin, instance: instance });
	
	    return instance;
	  };
	
	  Object.keys(plugin).forEach(function (prop) {
	    basicPluginWrapper[prop] = plugin[prop];
	  });
	
	  return basicPluginWrapper;
	};
	
	/**
	 * Takes a plugin sub-class and returns a factory function for generating
	 * instances of it.
	 *
	 * This factory function will replace itself with an instance of the requested
	 * sub-class of Plugin.
	 *
	 * @private
	 * @param   {string} name
	 *          The name of the plugin.
	 *
	 * @param   {Plugin} PluginSubClass
	 *          The advanced plugin.
	 *
	 * @returns {Function}
	 */
	var createPluginFactory = function createPluginFactory(name, PluginSubClass) {
	
	  // Add a `name` property to the plugin prototype so that each plugin can
	  // refer to itself by name.
	  PluginSubClass.prototype.name = name;
	
	  return function () {
	    triggerSetupEvent(this, { name: name, plugin: PluginSubClass, instance: null }, true);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    var instance = new (Function.prototype.bind.apply(PluginSubClass, [null].concat([this].concat(args))))();
	
	    // The plugin is replaced by a function that returns the current instance.
	    this[name] = function () {
	      return instance;
	    };
	
	    triggerSetupEvent(this, instance.getEventHash());
	
	    return instance;
	  };
	};
	
	/**
	 * Parent class for all advanced plugins.
	 *
	 * @mixes   module:evented~EventedMixin
	 * @mixes   module:stateful~StatefulMixin
	 * @fires   Player#beforepluginsetup
	 * @fires   Player#beforepluginsetup:$name
	 * @fires   Player#pluginsetup
	 * @fires   Player#pluginsetup:$name
	 * @listens Player#dispose
	 * @throws  {Error}
	 *          If attempting to instantiate the base {@link Plugin} class
	 *          directly instead of via a sub-class.
	 */
	
	var Plugin = function () {
	
	  /**
	   * Creates an instance of this class.
	   *
	   * Sub-classes should call `super` to ensure plugins are properly initialized.
	   *
	   * @param {Player} player
	   *        A Video.js player instance.
	   */
	  function Plugin(player) {
	    classCallCheck(this, Plugin);
	
	    if (this.constructor === Plugin) {
	      throw new Error('Plugin must be sub-classed; not directly instantiated.');
	    }
	
	    this.player = player;
	
	    // Make this object evented, but remove the added `trigger` method so we
	    // use the prototype version instead.
	    evented(this);
	    delete this.trigger;
	
	    stateful(this, this.constructor.defaultState);
	    markPluginAsActive(player, this.name);
	
	    // Auto-bind the dispose method so we can use it as a listener and unbind
	    // it later easily.
	    this.dispose = bind(this, this.dispose);
	
	    // If the player is disposed, dispose the plugin.
	    player.on('dispose', this.dispose);
	  }
	
	  /**
	   * Get the version of the plugin that was set on <pluginName>.VERSION
	   */
	
	
	  Plugin.prototype.version = function version() {
	    return this.constructor.VERSION;
	  };
	
	  /**
	   * Each event triggered by plugins includes a hash of additional data with
	   * conventional properties.
	   *
	   * This returns that object or mutates an existing hash.
	   *
	   * @param   {Object} [hash={}]
	   *          An object to be used as event an event hash.
	   *
	   * @returns {Plugin~PluginEventHash}
	   *          An event hash object with provided properties mixed-in.
	   */
	
	
	  Plugin.prototype.getEventHash = function getEventHash() {
	    var hash = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	    hash.name = this.name;
	    hash.plugin = this.constructor;
	    hash.instance = this;
	    return hash;
	  };
	
	  /**
	   * Triggers an event on the plugin object and overrides
	   * {@link module:evented~EventedMixin.trigger|EventedMixin.trigger}.
	   *
	   * @param   {string|Object} event
	   *          An event type or an object with a type property.
	   *
	   * @param   {Object} [hash={}]
	   *          Additional data hash to merge with a
	   *          {@link Plugin~PluginEventHash|PluginEventHash}.
	   *
	   * @returns {boolean}
	   *          Whether or not default was prevented.
	   */
	
	
	  Plugin.prototype.trigger = function trigger$$1(event) {
	    var hash = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	    return trigger(this.eventBusEl_, event, this.getEventHash(hash));
	  };
	
	  /**
	   * Handles "statechanged" events on the plugin. No-op by default, override by
	   * subclassing.
	   *
	   * @abstract
	   * @param    {Event} e
	   *           An event object provided by a "statechanged" event.
	   *
	   * @param    {Object} e.changes
	   *           An object describing changes that occurred with the "statechanged"
	   *           event.
	   */
	
	
	  Plugin.prototype.handleStateChanged = function handleStateChanged(e) {};
	
	  /**
	   * Disposes a plugin.
	   *
	   * Subclasses can override this if they want, but for the sake of safety,
	   * it's probably best to subscribe the "dispose" event.
	   *
	   * @fires Plugin#dispose
	   */
	
	
	  Plugin.prototype.dispose = function dispose() {
	    var name = this.name,
	        player = this.player;
	
	    /**
	     * Signals that a advanced plugin is about to be disposed.
	     *
	     * @event Plugin#dispose
	     * @type  {EventTarget~Event}
	     */
	
	    this.trigger('dispose');
	    this.off();
	    player.off('dispose', this.dispose);
	
	    // Eliminate any possible sources of leaking memory by clearing up
	    // references between the player and the plugin instance and nulling out
	    // the plugin's state and replacing methods with a function that throws.
	    player[PLUGIN_CACHE_KEY][name] = false;
	    this.player = this.state = null;
	
	    // Finally, replace the plugin name on the player with a new factory
	    // function, so that the plugin is ready to be set up again.
	    player[name] = createPluginFactory(name, pluginStorage[name]);
	  };
	
	  /**
	   * Determines if a plugin is a basic plugin (i.e. not a sub-class of `Plugin`).
	   *
	   * @param   {string|Function} plugin
	   *          If a string, matches the name of a plugin. If a function, will be
	   *          tested directly.
	   *
	   * @returns {boolean}
	   *          Whether or not a plugin is a basic plugin.
	   */
	
	
	  Plugin.isBasic = function isBasic(plugin) {
	    var p = typeof plugin === 'string' ? getPlugin(plugin) : plugin;
	
	    return typeof p === 'function' && !Plugin.prototype.isPrototypeOf(p.prototype);
	  };
	
	  /**
	   * Register a Video.js plugin.
	   *
	   * @param   {string} name
	   *          The name of the plugin to be registered. Must be a string and
	   *          must not match an existing plugin or a method on the `Player`
	   *          prototype.
	   *
	   * @param   {Function} plugin
	   *          A sub-class of `Plugin` or a function for basic plugins.
	   *
	   * @returns {Function}
	   *          For advanced plugins, a factory function for that plugin. For
	   *          basic plugins, a wrapper function that initializes the plugin.
	   */
	
	
	  Plugin.registerPlugin = function registerPlugin(name, plugin) {
	    if (typeof name !== 'string') {
	      throw new Error('Illegal plugin name, "' + name + '", must be a string, was ' + (typeof name === 'undefined' ? 'undefined' : _typeof(name)) + '.');
	    }
	
	    if (pluginExists(name)) {
	      log$1.warn('A plugin named "' + name + '" already exists. You may want to avoid re-registering plugins!');
	    } else if (Player.prototype.hasOwnProperty(name)) {
	      throw new Error('Illegal plugin name, "' + name + '", cannot share a name with an existing player method!');
	    }
	
	    if (typeof plugin !== 'function') {
	      throw new Error('Illegal plugin for "' + name + '", must be a function, was ' + (typeof plugin === 'undefined' ? 'undefined' : _typeof(plugin)) + '.');
	    }
	
	    pluginStorage[name] = plugin;
	
	    // Add a player prototype method for all sub-classed plugins (but not for
	    // the base Plugin class).
	    if (name !== BASE_PLUGIN_NAME) {
	      if (Plugin.isBasic(plugin)) {
	        Player.prototype[name] = createBasicPlugin(name, plugin);
	      } else {
	        Player.prototype[name] = createPluginFactory(name, plugin);
	      }
	    }
	
	    return plugin;
	  };
	
	  /**
	   * De-register a Video.js plugin.
	   *
	   * @param {string} name
	   *        The name of the plugin to be deregistered.
	   */
	
	
	  Plugin.deregisterPlugin = function deregisterPlugin(name) {
	    if (name === BASE_PLUGIN_NAME) {
	      throw new Error('Cannot de-register base plugin.');
	    }
	    if (pluginExists(name)) {
	      delete pluginStorage[name];
	      delete Player.prototype[name];
	    }
	  };
	
	  /**
	   * Gets an object containing multiple Video.js plugins.
	   *
	   * @param   {Array} [names]
	   *          If provided, should be an array of plugin names. Defaults to _all_
	   *          plugin names.
	   *
	   * @returns {Object|undefined}
	   *          An object containing plugin(s) associated with their name(s) or
	   *          `undefined` if no matching plugins exist).
	   */
	
	
	  Plugin.getPlugins = function getPlugins() {
	    var names = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : Object.keys(pluginStorage);
	
	    var result = void 0;
	
	    names.forEach(function (name) {
	      var plugin = getPlugin(name);
	
	      if (plugin) {
	        result = result || {};
	        result[name] = plugin;
	      }
	    });
	
	    return result;
	  };
	
	  /**
	   * Gets a plugin's version, if available
	   *
	   * @param   {string} name
	   *          The name of a plugin.
	   *
	   * @returns {string}
	   *          The plugin's version or an empty string.
	   */
	
	
	  Plugin.getPluginVersion = function getPluginVersion(name) {
	    var plugin = getPlugin(name);
	
	    return plugin && plugin.VERSION || '';
	  };
	
	  return Plugin;
	}();
	
	/**
	 * Gets a plugin by name if it exists.
	 *
	 * @static
	 * @method   getPlugin
	 * @memberOf Plugin
	 * @param    {string} name
	 *           The name of a plugin.
	 *
	 * @returns  {Function|undefined}
	 *           The plugin (or `undefined`).
	 */
	
	
	Plugin.getPlugin = getPlugin;
	
	/**
	 * The name of the base plugin class as it is registered.
	 *
	 * @type {string}
	 */
	Plugin.BASE_PLUGIN_NAME = BASE_PLUGIN_NAME;
	
	Plugin.registerPlugin(BASE_PLUGIN_NAME, Plugin);
	
	/**
	 * Documented in player.js
	 *
	 * @ignore
	 */
	Player.prototype.usingPlugin = function (name) {
	  return !!this[PLUGIN_CACHE_KEY] && this[PLUGIN_CACHE_KEY][name] === true;
	};
	
	/**
	 * Documented in player.js
	 *
	 * @ignore
	 */
	Player.prototype.hasPlugin = function (name) {
	  return !!pluginExists(name);
	};
	
	/**
	 * @file extend.js
	 * @module extend
	 */
	
	/**
	 * A combination of node inherits and babel's inherits (after transpile).
	 * Both work the same but node adds `super_` to the subClass
	 * and Bable adds the superClass as __proto__. Both seem useful.
	 *
	 * @param {Object} subClass
	 *        The class to inherit to
	 *
	 * @param {Object} superClass
	 *        The class to inherit from
	 *
	 * @private
	 */
	var _inherits = function _inherits(subClass, superClass) {
	  if (typeof superClass !== 'function' && superClass !== null) {
	    throw new TypeError('Super expression must either be null or a function, not ' + (typeof superClass === 'undefined' ? 'undefined' : _typeof(superClass)));
	  }
	
	  subClass.prototype = Object.create(superClass && superClass.prototype, {
	    constructor: {
	      value: subClass,
	      enumerable: false,
	      writable: true,
	      configurable: true
	    }
	  });
	
	  if (superClass) {
	    // node
	    subClass.super_ = superClass;
	  }
	};
	
	/**
	 * Function for subclassing using the same inheritance that
	 * videojs uses internally
	 *
	 * @static
	 * @const
	 *
	 * @param {Object} superClass
	 *        The class to inherit from
	 *
	 * @param {Object} [subClassMethods={}]
	 *        The class to inherit to
	 *
	 * @return {Object}
	 *         The new object with subClassMethods that inherited superClass.
	 */
	var extendFn = function extendFn(superClass) {
	  var subClassMethods = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	  var subClass = function subClass() {
	    superClass.apply(this, arguments);
	  };
	
	  var methods = {};
	
	  if ((typeof subClassMethods === 'undefined' ? 'undefined' : _typeof(subClassMethods)) === 'object') {
	    if (subClassMethods.constructor !== Object.prototype.constructor) {
	      subClass = subClassMethods.constructor;
	    }
	    methods = subClassMethods;
	  } else if (typeof subClassMethods === 'function') {
	    subClass = subClassMethods;
	  }
	
	  _inherits(subClass, superClass);
	
	  // Extend subObj's prototype with functions and other properties from props
	  for (var name in methods) {
	    if (methods.hasOwnProperty(name)) {
	      subClass.prototype[name] = methods[name];
	    }
	  }
	
	  return subClass;
	};
	
	/**
	 * @file video.js
	 * @module videojs
	 */
	
	/**
	 * Normalize an `id` value by trimming off a leading `#`
	 *
	 * @param   {string} id
	 *          A string, maybe with a leading `#`.
	 *
	 * @returns {string}
	 *          The string, without any leading `#`.
	 */
	var normalizeId = function normalizeId(id) {
	  return id.indexOf('#') === 0 ? id.slice(1) : id;
	};
	
	/**
	 * Doubles as the main function for users to create a player instance and also
	 * the main library object.
	 * The `videojs` function can be used to initialize or retrieve a player.
	  *
	 * @param {string|Element} id
	 *        Video element or video element ID
	 *
	 * @param {Object} [options]
	 *        Optional options object for config/settings
	 *
	 * @param {Component~ReadyCallback} [ready]
	 *        Optional ready callback
	 *
	 * @return {Player}
	 *         A player instance
	 */
	function videojs$1(id, options, ready) {
	  var player = videojs$1.getPlayer(id);
	
	  if (player) {
	    if (options) {
	      log$1.warn('Player "' + id + '" is already initialised. Options will not be applied.');
	    }
	    if (ready) {
	      player.ready(ready);
	    }
	    return player;
	  }
	
	  var el = typeof id === 'string' ? $('#' + normalizeId(id)) : id;
	
	  if (!isEl(el)) {
	    throw new TypeError('The element or ID supplied is not valid. (videojs)');
	  }
	
	  if (!document.body.contains(el)) {
	    log$1.warn('The element supplied is not included in the DOM');
	  }
	
	  options = options || {};
	
	  videojs$1.hooks('beforesetup').forEach(function (hookFunction) {
	    var opts = hookFunction(el, mergeOptions(options));
	
	    if (!isObject(opts) || Array.isArray(opts)) {
	      log$1.error('please return an object in beforesetup hooks');
	      return;
	    }
	
	    options = mergeOptions(options, opts);
	  });
	
	  // We get the current "Player" component here in case an integration has
	  // replaced it with a custom player.
	  var PlayerComponent = Component.getComponent('Player');
	
	  player = new PlayerComponent(el, options, ready);
	
	  videojs$1.hooks('setup').forEach(function (hookFunction) {
	    return hookFunction(player);
	  });
	
	  return player;
	}
	
	/**
	 * An Object that contains lifecycle hooks as keys which point to an array
	 * of functions that are run when a lifecycle is triggered
	 */
	videojs$1.hooks_ = {};
	
	/**
	 * Get a list of hooks for a specific lifecycle
	 * @function videojs.hooks
	 *
	 * @param {string} type
	 *        the lifecyle to get hooks from
	 *
	 * @param {Function|Function[]} [fn]
	 *        Optionally add a hook (or hooks) to the lifecycle that your are getting.
	 *
	 * @return {Array}
	 *         an array of hooks, or an empty array if there are none.
	 */
	videojs$1.hooks = function (type, fn) {
	  videojs$1.hooks_[type] = videojs$1.hooks_[type] || [];
	  if (fn) {
	    videojs$1.hooks_[type] = videojs$1.hooks_[type].concat(fn);
	  }
	  return videojs$1.hooks_[type];
	};
	
	/**
	 * Add a function hook to a specific videojs lifecycle.
	 *
	 * @param {string} type
	 *        the lifecycle to hook the function to.
	 *
	 * @param {Function|Function[]}
	 *        The function or array of functions to attach.
	 */
	videojs$1.hook = function (type, fn) {
	  videojs$1.hooks(type, fn);
	};
	
	/**
	 * Add a function hook that will only run once to a specific videojs lifecycle.
	 *
	 * @param {string} type
	 *        the lifecycle to hook the function to.
	 *
	 * @param {Function|Function[]}
	 *        The function or array of functions to attach.
	 */
	videojs$1.hookOnce = function (type, fn) {
	  videojs$1.hooks(type, [].concat(fn).map(function (original) {
	    var wrapper = function wrapper() {
	      videojs$1.removeHook(type, wrapper);
	      return original.apply(undefined, arguments);
	    };
	
	    return wrapper;
	  }));
	};
	
	/**
	 * Remove a hook from a specific videojs lifecycle.
	 *
	 * @param {string} type
	 *        the lifecycle that the function hooked to
	 *
	 * @param {Function} fn
	 *        The hooked function to remove
	 *
	 * @return {boolean}
	 *         The function that was removed or undef
	 */
	videojs$1.removeHook = function (type, fn) {
	  var index = videojs$1.hooks(type).indexOf(fn);
	
	  if (index <= -1) {
	    return false;
	  }
	
	  videojs$1.hooks_[type] = videojs$1.hooks_[type].slice();
	  videojs$1.hooks_[type].splice(index, 1);
	
	  return true;
	};
	
	// Add default styles
	if (window$1.VIDEOJS_NO_DYNAMIC_STYLE !== true && isReal()) {
	  var style$1 = $('.vjs-styles-defaults');
	
	  if (!style$1) {
	    style$1 = createStyleElement('vjs-styles-defaults');
	    var head = $('head');
	
	    if (head) {
	      head.insertBefore(style$1, head.firstChild);
	    }
	    setTextContent(style$1, '\n      .video-js {\n        width: 300px;\n        height: 150px;\n      }\n\n      .vjs-fluid {\n        padding-top: 56.25%\n      }\n    ');
	  }
	}
	
	// Run Auto-load players
	// You have to wait at least once in case this script is loaded after your
	// video in the DOM (weird behavior only with minified version)
	autoSetupTimeout(1, videojs$1);
	
	/**
	 * Current software version. Follows semver.
	 *
	 * @type {string}
	 */
	videojs$1.VERSION = version;
	
	/**
	 * The global options object. These are the settings that take effect
	 * if no overrides are specified when the player is created.
	 *
	 * @type {Object}
	 */
	videojs$1.options = Player.prototype.options_;
	
	/**
	 * Get an object with the currently created players, keyed by player ID
	 *
	 * @return {Object}
	 *         The created players
	 */
	videojs$1.getPlayers = function () {
	  return Player.players;
	};
	
	/**
	 * Get a single player based on an ID or DOM element.
	 *
	 * This is useful if you want to check if an element or ID has an associated
	 * Video.js player, but not create one if it doesn't.
	 *
	 * @param   {string|Element} id
	 *          An HTML element - `<video>`, `<audio>`, or `<video-js>` -
	 *          or a string matching the `id` of such an element.
	 *
	 * @returns {Player|undefined}
	 *          A player instance or `undefined` if there is no player instance
	 *          matching the argument.
	 */
	videojs$1.getPlayer = function (id) {
	  var players = Player.players;
	  var tag = void 0;
	
	  if (typeof id === 'string') {
	    var nId = normalizeId(id);
	    var player = players[nId];
	
	    if (player) {
	      return player;
	    }
	
	    tag = $('#' + nId);
	  } else {
	    tag = id;
	  }
	
	  if (isEl(tag)) {
	    var _tag = tag,
	        _player = _tag.player,
	        playerId = _tag.playerId;
	
	    // Element may have a `player` property referring to an already created
	    // player instance. If so, return that.
	
	    if (_player || players[playerId]) {
	      return _player || players[playerId];
	    }
	  }
	};
	
	/**
	 * Returns an array of all current players.
	 *
	 * @return {Array}
	 *         An array of all players. The array will be in the order that
	 *         `Object.keys` provides, which could potentially vary between
	 *         JavaScript engines.
	 *
	 */
	videojs$1.getAllPlayers = function () {
	  return (
	
	    // Disposed players leave a key with a `null` value, so we need to make sure
	    // we filter those out.
	    Object.keys(Player.players).map(function (k) {
	      return Player.players[k];
	    }).filter(Boolean)
	  );
	};
	
	/**
	 * Expose players object.
	 *
	 * @memberOf videojs
	 * @property {Object} players
	 */
	videojs$1.players = Player.players;
	
	/**
	 * Get a component class object by name
	 *
	 * @borrows Component.getComponent as videojs.getComponent
	 */
	videojs$1.getComponent = Component.getComponent;
	
	/**
	 * Register a component so it can referred to by name. Used when adding to other
	 * components, either through addChild `component.addChild('myComponent')` or through
	 * default children options  `{ children: ['myComponent'] }`.
	 *
	 * > NOTE: You could also just initialize the component before adding.
	 * `component.addChild(new MyComponent());`
	 *
	 * @param {string} name
	 *        The class name of the component
	 *
	 * @param {Component} comp
	 *        The component class
	 *
	 * @return {Component}
	 *         The newly registered component
	 */
	videojs$1.registerComponent = function (name$$1, comp) {
	  if (Tech.isTech(comp)) {
	    log$1.warn('The ' + name$$1 + ' tech was registered as a component. It should instead be registered using videojs.registerTech(name, tech)');
	  }
	
	  Component.registerComponent.call(Component, name$$1, comp);
	};
	
	/**
	 * Get a Tech class object by name
	 *
	 * @borrows Tech.getTech as videojs.getTech
	 */
	videojs$1.getTech = Tech.getTech;
	
	/**
	 * Register a Tech so it can referred to by name.
	 * This is used in the tech order for the player.
	 *
	 * @borrows Tech.registerTech as videojs.registerTech
	 */
	videojs$1.registerTech = Tech.registerTech;
	
	/**
	 * Register a middleware to a source type.
	 *
	 * @param {String} type A string representing a MIME type.
	 * @param {function(player):object} middleware A middleware factory that takes a player.
	 */
	videojs$1.use = use;
	
	/**
	 * An object that can be returned by a middleware to signify
	 * that the middleware is being terminated.
	 *
	 * @type {object}
	 * @memberOf {videojs}
	 * @property {object} middleware.TERMINATOR
	 */
	Object.defineProperty(videojs$1, 'middleware', {
	  value: {},
	  writeable: false,
	  enumerable: true
	});
	
	Object.defineProperty(videojs$1.middleware, 'TERMINATOR', {
	  value: TERMINATOR,
	  writeable: false,
	  enumerable: true
	});
	
	/**
	 * A suite of browser and device tests from {@link browser}.
	 *
	 * @type {Object}
	 * @private
	 */
	videojs$1.browser = browser;
	
	/**
	 * Whether or not the browser supports touch events. Included for backward
	 * compatibility with 4.x, but deprecated. Use `videojs.browser.TOUCH_ENABLED`
	 * instead going forward.
	 *
	 * @deprecated since version 5.0
	 * @type {boolean}
	 */
	videojs$1.TOUCH_ENABLED = TOUCH_ENABLED;
	
	/**
	 * Subclass an existing class
	 * Mimics ES6 subclassing with the `extend` keyword
	 *
	 * @borrows extend:extendFn as videojs.extend
	 */
	videojs$1.extend = extendFn;
	
	/**
	 * Merge two options objects recursively
	 * Performs a deep merge like lodash.merge but **only merges plain objects**
	 * (not arrays, elements, anything else)
	 * Other values will be copied directly from the second object.
	 *
	 * @borrows merge-options:mergeOptions as videojs.mergeOptions
	 */
	videojs$1.mergeOptions = mergeOptions;
	
	/**
	 * Change the context (this) of a function
	 *
	 * > NOTE: as of v5.0 we require an ES5 shim, so you should use the native
	 * `function() {}.bind(newContext);` instead of this.
	 *
	 * @borrows fn:bind as videojs.bind
	 */
	videojs$1.bind = bind;
	
	/**
	 * Register a Video.js plugin.
	 *
	 * @borrows plugin:registerPlugin as videojs.registerPlugin
	 * @method registerPlugin
	 *
	 * @param  {string} name
	 *         The name of the plugin to be registered. Must be a string and
	 *         must not match an existing plugin or a method on the `Player`
	 *         prototype.
	 *
	 * @param  {Function} plugin
	 *         A sub-class of `Plugin` or a function for basic plugins.
	 *
	 * @return {Function}
	 *         For advanced plugins, a factory function for that plugin. For
	 *         basic plugins, a wrapper function that initializes the plugin.
	 */
	videojs$1.registerPlugin = Plugin.registerPlugin;
	
	/**
	 * Deregister a Video.js plugin.
	 *
	 * @borrows plugin:deregisterPlugin as videojs.deregisterPlugin
	 * @method deregisterPlugin
	 *
	 * @param  {string} name
	 *         The name of the plugin to be deregistered. Must be a string and
	 *         must match an existing plugin or a method on the `Player`
	 *         prototype.
	 *
	 */
	videojs$1.deregisterPlugin = Plugin.deregisterPlugin;
	
	/**
	 * Deprecated method to register a plugin with Video.js
	 *
	 * @deprecated
	 *        videojs.plugin() is deprecated; use videojs.registerPlugin() instead
	 *
	 * @param {string} name
	 *        The plugin name
	 *
	 * @param {Plugin|Function} plugin
	 *         The plugin sub-class or function
	 */
	videojs$1.plugin = function (name$$1, plugin) {
	  log$1.warn('videojs.plugin() is deprecated; use videojs.registerPlugin() instead');
	  return Plugin.registerPlugin(name$$1, plugin);
	};
	
	/**
	 * Gets an object containing multiple Video.js plugins.
	 *
	 * @param  {Array} [names]
	 *         If provided, should be an array of plugin names. Defaults to _all_
	 *         plugin names.
	 *
	 * @return {Object|undefined}
	 *         An object containing plugin(s) associated with their name(s) or
	 *         `undefined` if no matching plugins exist).
	 */
	videojs$1.getPlugins = Plugin.getPlugins;
	
	/**
	 * Gets a plugin by name if it exists.
	 *
	 * @param  {string} name
	 *         The name of a plugin.
	 *
	 * @return {Function|undefined}
	 *         The plugin (or `undefined`).
	 */
	videojs$1.getPlugin = Plugin.getPlugin;
	
	/**
	 * Gets a plugin's version, if available
	 *
	 * @param  {string} name
	 *         The name of a plugin.
	 *
	 * @return {string}
	 *         The plugin's version or an empty string.
	 */
	videojs$1.getPluginVersion = Plugin.getPluginVersion;
	
	/**
	 * Adding languages so that they're available to all players.
	 * Example: `videojs.addLanguage('es', { 'Hello': 'Hola' });`
	 *
	 * @param {string} code
	 *        The language code or dictionary property
	 *
	 * @param {Object} data
	 *        The data values to be translated
	 *
	 * @return {Object}
	 *         The resulting language dictionary object
	 */
	videojs$1.addLanguage = function (code, data) {
	  var _mergeOptions;
	
	  code = ('' + code).toLowerCase();
	
	  videojs$1.options.languages = mergeOptions(videojs$1.options.languages, (_mergeOptions = {}, _mergeOptions[code] = data, _mergeOptions));
	
	  return videojs$1.options.languages[code];
	};
	
	/**
	 * Log messages
	 *
	 * @borrows log:log as videojs.log
	 */
	videojs$1.log = log$1;
	
	/**
	 * Creates an emulated TimeRange object.
	 *
	 * @borrows time-ranges:createTimeRanges as videojs.createTimeRange
	 */
	/**
	 * @borrows time-ranges:createTimeRanges as videojs.createTimeRanges
	 */
	videojs$1.createTimeRange = videojs$1.createTimeRanges = createTimeRanges;
	
	/**
	 * Format seconds as a time string, H:MM:SS or M:SS
	 * Supplying a guide (in seconds) will force a number of leading zeros
	 * to cover the length of the guide
	 *
	 * @borrows format-time:formatTime as videojs.formatTime
	 */
	videojs$1.formatTime = formatTime;
	
	/**
	 * Replaces format-time with a custom implementation, to be used in place of the default.
	 *
	 * @borrows format-time:setFormatTime as videojs.setFormatTime
	 *
	 * @method setFormatTime
	 *
	 * @param {Function} customFn
	 *        A custom format-time function which will be called with the current time and guide (in seconds) as arguments.
	 *        Passed fn should return a string.
	 */
	videojs$1.setFormatTime = setFormatTime;
	
	/**
	 * Resets format-time to the default implementation.
	 *
	 * @borrows format-time:resetFormatTime as videojs.resetFormatTime
	 *
	 * @method resetFormatTime
	 */
	videojs$1.resetFormatTime = resetFormatTime;
	
	/**
	 * Resolve and parse the elements of a URL
	 *
	 * @borrows url:parseUrl as videojs.parseUrl
	 *
	 */
	videojs$1.parseUrl = parseUrl;
	
	/**
	 * Returns whether the url passed is a cross domain request or not.
	 *
	 * @borrows url:isCrossOrigin as videojs.isCrossOrigin
	 */
	videojs$1.isCrossOrigin = isCrossOrigin;
	
	/**
	 * Event target class.
	 *
	 * @borrows EventTarget as videojs.EventTarget
	 */
	videojs$1.EventTarget = EventTarget;
	
	/**
	 * Add an event listener to element
	 * It stores the handler function in a separate cache object
	 * and adds a generic handler to the element's event,
	 * along with a unique id (guid) to the element.
	 *
	 * @borrows events:on as videojs.on
	 */
	videojs$1.on = on;
	
	/**
	 * Trigger a listener only once for an event
	 *
	 * @borrows events:one as videojs.one
	 */
	videojs$1.one = one;
	
	/**
	 * Removes event listeners from an element
	 *
	 * @borrows events:off as videojs.off
	 */
	videojs$1.off = off;
	
	/**
	 * Trigger an event for an element
	 *
	 * @borrows events:trigger as videojs.trigger
	 */
	videojs$1.trigger = trigger;
	
	/**
	 * A cross-browser XMLHttpRequest wrapper. Here's a simple example:
	 *
	 * @param {Object} options
	 *        settings for the request.
	 *
	 * @return {XMLHttpRequest|XDomainRequest}
	 *         The request object.
	 *
	 * @see https://github.com/Raynos/xhr
	 */
	videojs$1.xhr = xhr;
	
	/**
	 * TextTrack class
	 *
	 * @borrows TextTrack as videojs.TextTrack
	 */
	videojs$1.TextTrack = TextTrack;
	
	/**
	 * export the AudioTrack class so that source handlers can create
	 * AudioTracks and then add them to the players AudioTrackList
	 *
	 * @borrows AudioTrack as videojs.AudioTrack
	 */
	videojs$1.AudioTrack = AudioTrack;
	
	/**
	 * export the VideoTrack class so that source handlers can create
	 * VideoTracks and then add them to the players VideoTrackList
	 *
	 * @borrows VideoTrack as videojs.VideoTrack
	 */
	videojs$1.VideoTrack = VideoTrack;
	
	/**
	 * Determines, via duck typing, whether or not a value is a DOM element.
	 *
	 * @borrows dom:isEl as videojs.isEl
	 * @deprecated Use videojs.dom.isEl() instead
	 */
	
	/**
	 * Determines, via duck typing, whether or not a value is a text node.
	 *
	 * @borrows dom:isTextNode as videojs.isTextNode
	 * @deprecated Use videojs.dom.isTextNode() instead
	 */
	
	/**
	 * Creates an element and applies properties.
	 *
	 * @borrows dom:createEl as videojs.createEl
	 * @deprecated Use videojs.dom.createEl() instead
	 */
	
	/**
	 * Check if an element has a CSS class
	 *
	 * @borrows dom:hasElClass as videojs.hasClass
	 * @deprecated Use videojs.dom.hasClass() instead
	 */
	
	/**
	 * Add a CSS class name to an element
	 *
	 * @borrows dom:addElClass as videojs.addClass
	 * @deprecated Use videojs.dom.addClass() instead
	 */
	
	/**
	 * Remove a CSS class name from an element
	 *
	 * @borrows dom:removeElClass as videojs.removeClass
	 * @deprecated Use videojs.dom.removeClass() instead
	 */
	
	/**
	 * Adds or removes a CSS class name on an element depending on an optional
	 * condition or the presence/absence of the class name.
	 *
	 * @borrows dom:toggleElClass as videojs.toggleClass
	 * @deprecated Use videojs.dom.toggleClass() instead
	 */
	
	/**
	 * Apply attributes to an HTML element.
	 *
	 * @borrows dom:setElAttributes as videojs.setAttribute
	 * @deprecated Use videojs.dom.setAttributes() instead
	 */
	
	/**
	 * Get an element's attribute values, as defined on the HTML tag
	 * Attributes are not the same as properties. They're defined on the tag
	 * or with setAttribute (which shouldn't be used with HTML)
	 * This will return true or false for boolean attributes.
	 *
	 * @borrows dom:getElAttributes as videojs.getAttributes
	 * @deprecated Use videojs.dom.getAttributes() instead
	 */
	
	/**
	 * Empties the contents of an element.
	 *
	 * @borrows dom:emptyEl as videojs.emptyEl
	 * @deprecated Use videojs.dom.emptyEl() instead
	 */
	
	/**
	 * Normalizes and appends content to an element.
	 *
	 * The content for an element can be passed in multiple types and
	 * combinations, whose behavior is as follows:
	 *
	 * - String
	 *   Normalized into a text node.
	 *
	 * - Element, TextNode
	 *   Passed through.
	 *
	 * - Array
	 *   A one-dimensional array of strings, elements, nodes, or functions (which
	 *   return single strings, elements, or nodes).
	 *
	 * - Function
	 *   If the sole argument, is expected to produce a string, element,
	 *   node, or array.
	 *
	 * @borrows dom:appendContents as videojs.appendContet
	 * @deprecated Use videojs.dom.appendContent() instead
	 */
	
	/**
	 * Normalizes and inserts content into an element; this is identical to
	 * `appendContent()`, except it empties the element first.
	 *
	 * The content for an element can be passed in multiple types and
	 * combinations, whose behavior is as follows:
	 *
	 * - String
	 *   Normalized into a text node.
	 *
	 * - Element, TextNode
	 *   Passed through.
	 *
	 * - Array
	 *   A one-dimensional array of strings, elements, nodes, or functions (which
	 *   return single strings, elements, or nodes).
	 *
	 * - Function
	 *   If the sole argument, is expected to produce a string, element,
	 *   node, or array.
	 *
	 * @borrows dom:insertContent as videojs.insertContent
	 * @deprecated Use videojs.dom.insertContent() instead
	 */
	['isEl', 'isTextNode', 'createEl', 'hasClass', 'addClass', 'removeClass', 'toggleClass', 'setAttributes', 'getAttributes', 'emptyEl', 'appendContent', 'insertContent'].forEach(function (k) {
	  videojs$1[k] = function () {
	    log$1.warn('videojs.' + k + '() is deprecated; use videojs.dom.' + k + '() instead');
	    return Dom[k].apply(null, arguments);
	  };
	});
	
	/**
	 * A safe getComputedStyle.
	 *
	 * This is because in Firefox, if the player is loaded in an iframe with `display:none`,
	 * then `getComputedStyle` returns `null`, so, we do a null-check to make sure
	 * that the player doesn't break in these cases.
	 * See https://bugzilla.mozilla.org/show_bug.cgi?id=548397 for more details.
	 *
	 * @borrows computed-style:computedStyle as videojs.computedStyle
	 */
	videojs$1.computedStyle = computedStyle;
	
	/**
	 * Export the Dom utilities for use in external plugins
	 * and Tech's
	 */
	videojs$1.dom = Dom;
	
	/**
	 * Export the Url utilities for use in external plugins
	 * and Tech's
	 */
	videojs$1.url = Url;
	
	/**
	 * @videojs/http-streaming
	 * @version 1.2.5
	 * @copyright 2018 Brightcove, Inc
	 * @license Apache-2.0
	 */
	
	/**
	 * @file resolve-url.js
	 */
	
	var resolveUrl = function resolveUrl(baseURL, relativeURL) {
	  // return early if we don't need to resolve
	  if (/^[a-z]+:/i.test(relativeURL)) {
	    return relativeURL;
	  }
	
	  // if the base URL is relative then combine with the current location
	  if (!/\/\//i.test(baseURL)) {
	    baseURL = URLToolkit.buildAbsoluteURL(window$1.location.href, baseURL);
	  }
	
	  return URLToolkit.buildAbsoluteURL(baseURL, relativeURL);
	};
	
	var classCallCheck$1 = function classCallCheck$$1(instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	};
	
	var createClass$1 = function () {
	  function defineProperties(target, props) {
	    for (var i = 0; i < props.length; i++) {
	      var descriptor = props[i];
	      descriptor.enumerable = descriptor.enumerable || false;
	      descriptor.configurable = true;
	      if ("value" in descriptor) descriptor.writable = true;
	      Object.defineProperty(target, descriptor.key, descriptor);
	    }
	  }
	
	  return function (Constructor, protoProps, staticProps) {
	    if (protoProps) defineProperties(Constructor.prototype, protoProps);
	    if (staticProps) defineProperties(Constructor, staticProps);
	    return Constructor;
	  };
	}();
	
	var get$2 = function get$$1(object, property, receiver) {
	  if (object === null) object = Function.prototype;
	  var desc = Object.getOwnPropertyDescriptor(object, property);
	
	  if (desc === undefined) {
	    var parent = Object.getPrototypeOf(object);
	
	    if (parent === null) {
	      return undefined;
	    } else {
	      return get$$1(parent, property, receiver);
	    }
	  } else if ("value" in desc) {
	    return desc.value;
	  } else {
	    var getter = desc.get;
	
	    if (getter === undefined) {
	      return undefined;
	    }
	
	    return getter.call(receiver);
	  }
	};
	
	var inherits$1 = function inherits$$1(subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === 'undefined' ? 'undefined' : _typeof(superClass)));
	  }
	
	  subClass.prototype = Object.create(superClass && superClass.prototype, {
	    constructor: {
	      value: subClass,
	      enumerable: false,
	      writable: true,
	      configurable: true
	    }
	  });
	  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
	};
	
	var possibleConstructorReturn$1 = function possibleConstructorReturn$$1(self, call) {
	  if (!self) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }
	
	  return call && ((typeof call === 'undefined' ? 'undefined' : _typeof(call)) === "object" || typeof call === "function") ? call : self;
	};
	
	var slicedToArray$1 = function () {
	  function sliceIterator(arr, i) {
	    var _arr = [];
	    var _n = true;
	    var _d = false;
	    var _e = undefined;
	
	    try {
	      for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
	        _arr.push(_s.value);
	
	        if (i && _arr.length === i) break;
	      }
	    } catch (err) {
	      _d = true;
	      _e = err;
	    } finally {
	      try {
	        if (!_n && _i["return"]) _i["return"]();
	      } finally {
	        if (_d) throw _e;
	      }
	    }
	
	    return _arr;
	  }
	
	  return function (arr, i) {
	    if (Array.isArray(arr)) {
	      return arr;
	    } else if (Symbol.iterator in Object(arr)) {
	      return sliceIterator(arr, i);
	    } else {
	      throw new TypeError("Invalid attempt to destructure non-iterable instance");
	    }
	  };
	}();
	
	/**
	 * @file playlist-loader.js
	 *
	 * A state machine that manages the loading, caching, and updating of
	 * M3U8 playlists.
	 *
	 */
	
	var mergeOptions$1 = videojs$1.mergeOptions,
	    EventTarget$1 = videojs$1.EventTarget,
	    log$2 = videojs$1.log;
	
	/**
	 * Loops through all supported media groups in master and calls the provided
	 * callback for each group
	 *
	 * @param {Object} master
	 *        The parsed master manifest object
	 * @param {Function} callback
	 *        Callback to call for each media group
	 */
	
	var forEachMediaGroup = function forEachMediaGroup(master, callback) {
	  ['AUDIO', 'SUBTITLES'].forEach(function (mediaType) {
	    for (var groupKey in master.mediaGroups[mediaType]) {
	      for (var labelKey in master.mediaGroups[mediaType][groupKey]) {
	        var mediaProperties = master.mediaGroups[mediaType][groupKey][labelKey];
	
	        callback(mediaProperties, mediaType, groupKey, labelKey);
	      }
	    }
	  });
	};
	
	/**
	  * Returns a new array of segments that is the result of merging
	  * properties from an older list of segments onto an updated
	  * list. No properties on the updated playlist will be overridden.
	  *
	  * @param {Array} original the outdated list of segments
	  * @param {Array} update the updated list of segments
	  * @param {Number=} offset the index of the first update
	  * segment in the original segment list. For non-live playlists,
	  * this should always be zero and does not need to be
	  * specified. For live playlists, it should be the difference
	  * between the media sequence numbers in the original and updated
	  * playlists.
	  * @return a list of merged segment objects
	  */
	var updateSegments = function updateSegments(original, update, offset) {
	  var result = update.slice();
	
	  offset = offset || 0;
	  var length = Math.min(original.length, update.length + offset);
	
	  for (var i = offset; i < length; i++) {
	    result[i - offset] = mergeOptions$1(original[i], result[i - offset]);
	  }
	  return result;
	};
	
	var resolveSegmentUris = function resolveSegmentUris(segment, baseUri) {
	  if (!segment.resolvedUri) {
	    segment.resolvedUri = resolveUrl(baseUri, segment.uri);
	  }
	  if (segment.key && !segment.key.resolvedUri) {
	    segment.key.resolvedUri = resolveUrl(baseUri, segment.key.uri);
	  }
	  if (segment.map && !segment.map.resolvedUri) {
	    segment.map.resolvedUri = resolveUrl(baseUri, segment.map.uri);
	  }
	};
	
	/**
	  * Returns a new master playlist that is the result of merging an
	  * updated media playlist into the original version. If the
	  * updated media playlist does not match any of the playlist
	  * entries in the original master playlist, null is returned.
	  *
	  * @param {Object} master a parsed master M3U8 object
	  * @param {Object} media a parsed media M3U8 object
	  * @return {Object} a new object that represents the original
	  * master playlist with the updated media playlist merged in, or
	  * null if the merge produced no change.
	  */
	var updateMaster = function updateMaster(master, media) {
	  var result = mergeOptions$1(master, {});
	  var playlist = result.playlists[media.uri];
	
	  if (!playlist) {
	    return null;
	  }
	
	  // consider the playlist unchanged if the number of segments is equal and the media
	  // sequence number is unchanged
	  if (playlist.segments && media.segments && playlist.segments.length === media.segments.length && playlist.mediaSequence === media.mediaSequence) {
	    return null;
	  }
	
	  var mergedPlaylist = mergeOptions$1(playlist, media);
	
	  // if the update could overlap existing segment information, merge the two segment lists
	  if (playlist.segments) {
	    mergedPlaylist.segments = updateSegments(playlist.segments, media.segments, media.mediaSequence - playlist.mediaSequence);
	  }
	
	  // resolve any segment URIs to prevent us from having to do it later
	  mergedPlaylist.segments.forEach(function (segment) {
	    resolveSegmentUris(segment, mergedPlaylist.resolvedUri);
	  });
	
	  // TODO Right now in the playlists array there are two references to each playlist, one
	  // that is referenced by index, and one by URI. The index reference may no longer be
	  // necessary.
	  for (var i = 0; i < result.playlists.length; i++) {
	    if (result.playlists[i].uri === media.uri) {
	      result.playlists[i] = mergedPlaylist;
	    }
	  }
	  result.playlists[media.uri] = mergedPlaylist;
	
	  return result;
	};
	
	var setupMediaPlaylists = function setupMediaPlaylists(master) {
	  // setup by-URI lookups and resolve media playlist URIs
	  var i = master.playlists.length;
	
	  while (i--) {
	    var playlist = master.playlists[i];
	
	    master.playlists[playlist.uri] = playlist;
	    playlist.resolvedUri = resolveUrl(master.uri, playlist.uri);
	    playlist.id = i;
	
	    if (!playlist.attributes) {
	      // Although the spec states an #EXT-X-STREAM-INF tag MUST have a
	      // BANDWIDTH attribute, we can play the stream without it. This means a poorly
	      // formatted master playlist may not have an attribute list. An attributes
	      // property is added here to prevent undefined references when we encounter
	      // this scenario.
	      playlist.attributes = {};
	
	      log$2.warn('Invalid playlist STREAM-INF detected. Missing BANDWIDTH attribute.');
	    }
	  }
	};
	
	var resolveMediaGroupUris = function resolveMediaGroupUris(master) {
	  forEachMediaGroup(master, function (properties) {
	    if (properties.uri) {
	      properties.resolvedUri = resolveUrl(master.uri, properties.uri);
	    }
	  });
	};
	
	/**
	 * Calculates the time to wait before refreshing a live playlist
	 *
	 * @param {Object} media
	 *        The current media
	 * @param {Boolean} update
	 *        True if there were any updates from the last refresh, false otherwise
	 * @return {Number}
	 *         The time in ms to wait before refreshing the live playlist
	 */
	var refreshDelay = function refreshDelay(media, update) {
	  var lastSegment = media.segments[media.segments.length - 1];
	  var delay = void 0;
	
	  if (update && lastSegment && lastSegment.duration) {
	    delay = lastSegment.duration * 1000;
	  } else {
	    // if the playlist is unchanged since the last reload or last segment duration
	    // cannot be determined, try again after half the target duration
	    delay = (media.targetDuration || 10) * 500;
	  }
	  return delay;
	};
	
	/**
	 * Load a playlist from a remote location
	 *
	 * @class PlaylistLoader
	 * @extends Stream
	 * @param {String} srcUrl the url to start with
	 * @param {Boolean} withCredentials the withCredentials xhr option
	 * @constructor
	 */
	
	var PlaylistLoader = function (_EventTarget) {
	  inherits$1(PlaylistLoader, _EventTarget);
	
	  function PlaylistLoader(srcUrl, hls, withCredentials) {
	    classCallCheck$1(this, PlaylistLoader);
	
	    var _this = possibleConstructorReturn$1(this, (PlaylistLoader.__proto__ || Object.getPrototypeOf(PlaylistLoader)).call(this));
	
	    _this.srcUrl = srcUrl;
	    _this.hls_ = hls;
	    _this.withCredentials = withCredentials;
	
	    if (!_this.srcUrl) {
	      throw new Error('A non-empty playlist URL is required');
	    }
	
	    // initialize the loader state
	    _this.state = 'HAVE_NOTHING';
	
	    // live playlist staleness timeout
	    _this.on('mediaupdatetimeout', function () {
	      if (_this.state !== 'HAVE_METADATA') {
	        // only refresh the media playlist if no other activity is going on
	        return;
	      }
	
	      _this.state = 'HAVE_CURRENT_METADATA';
	
	      _this.request = _this.hls_.xhr({
	        uri: resolveUrl(_this.master.uri, _this.media().uri),
	        withCredentials: _this.withCredentials
	      }, function (error, req) {
	        // disposed
	        if (!_this.request) {
	          return;
	        }
	
	        if (error) {
	          return _this.playlistRequestError(_this.request, _this.media().uri, 'HAVE_METADATA');
	        }
	
	        _this.haveMetadata(_this.request, _this.media().uri);
	      });
	    });
	    return _this;
	  }
	
	  createClass$1(PlaylistLoader, [{
	    key: 'playlistRequestError',
	    value: function playlistRequestError(xhr$$1, url, startingState) {
	      // any in-flight request is now finished
	      this.request = null;
	
	      if (startingState) {
	        this.state = startingState;
	      }
	
	      this.error = {
	        playlist: this.master.playlists[url],
	        status: xhr$$1.status,
	        message: 'HLS playlist request error at URL: ' + url,
	        responseText: xhr$$1.responseText,
	        code: xhr$$1.status >= 500 ? 4 : 2
	      };
	
	      this.trigger('error');
	    }
	
	    // update the playlist loader's state in response to a new or
	    // updated playlist.
	
	  }, {
	    key: 'haveMetadata',
	    value: function haveMetadata(xhr$$1, url) {
	      var _this2 = this;
	
	      // any in-flight request is now finished
	      this.request = null;
	      this.state = 'HAVE_METADATA';
	
	      var parser = new m3u8Parser.Parser();
	
	      parser.push(xhr$$1.responseText);
	      parser.end();
	      parser.manifest.uri = url;
	      // m3u8-parser does not attach an attributes property to media playlists so make
	      // sure that the property is attached to avoid undefined reference errors
	      parser.manifest.attributes = parser.manifest.attributes || {};
	
	      // merge this playlist into the master
	      var update = updateMaster(this.master, parser.manifest);
	
	      this.targetDuration = parser.manifest.targetDuration;
	
	      if (update) {
	        this.master = update;
	        this.media_ = this.master.playlists[parser.manifest.uri];
	      } else {
	        this.trigger('playlistunchanged');
	      }
	
	      // refresh live playlists after a target duration passes
	      if (!this.media().endList) {
	        window$1.clearTimeout(this.mediaUpdateTimeout);
	        this.mediaUpdateTimeout = window$1.setTimeout(function () {
	          _this2.trigger('mediaupdatetimeout');
	        }, refreshDelay(this.media(), !!update));
	      }
	
	      this.trigger('loadedplaylist');
	    }
	
	    /**
	     * Abort any outstanding work and clean up.
	     */
	
	  }, {
	    key: 'dispose',
	    value: function dispose() {
	      this.stopRequest();
	      window$1.clearTimeout(this.mediaUpdateTimeout);
	    }
	  }, {
	    key: 'stopRequest',
	    value: function stopRequest() {
	      if (this.request) {
	        var oldRequest = this.request;
	
	        this.request = null;
	        oldRequest.onreadystatechange = null;
	        oldRequest.abort();
	      }
	    }
	
	    /**
	     * When called without any arguments, returns the currently
	     * active media playlist. When called with a single argument,
	     * triggers the playlist loader to asynchronously switch to the
	     * specified media playlist. Calling this method while the
	     * loader is in the HAVE_NOTHING causes an error to be emitted
	     * but otherwise has no effect.
	     *
	     * @param {Object=} playlist the parsed media playlist
	     * object to switch to
	     * @return {Playlist} the current loaded media
	     */
	
	  }, {
	    key: 'media',
	    value: function media(playlist) {
	      var _this3 = this;
	
	      // getter
	      if (!playlist) {
	        return this.media_;
	      }
	
	      // setter
	      if (this.state === 'HAVE_NOTHING') {
	        throw new Error('Cannot switch media playlist from ' + this.state);
	      }
	
	      var startingState = this.state;
	
	      // find the playlist object if the target playlist has been
	      // specified by URI
	      if (typeof playlist === 'string') {
	        if (!this.master.playlists[playlist]) {
	          throw new Error('Unknown playlist URI: ' + playlist);
	        }
	        playlist = this.master.playlists[playlist];
	      }
	
	      var mediaChange = !this.media_ || playlist.uri !== this.media_.uri;
	
	      // switch to fully loaded playlists immediately
	      if (this.master.playlists[playlist.uri].endList) {
	        // abort outstanding playlist requests
	        if (this.request) {
	          this.request.onreadystatechange = null;
	          this.request.abort();
	          this.request = null;
	        }
	        this.state = 'HAVE_METADATA';
	        this.media_ = playlist;
	
	        // trigger media change if the active media has been updated
	        if (mediaChange) {
	          this.trigger('mediachanging');
	          this.trigger('mediachange');
	        }
	        return;
	      }
	
	      // switching to the active playlist is a no-op
	      if (!mediaChange) {
	        return;
	      }
	
	      this.state = 'SWITCHING_MEDIA';
	
	      // there is already an outstanding playlist request
	      if (this.request) {
	        if (resolveUrl(this.master.uri, playlist.uri) === this.request.url) {
	          // requesting to switch to the same playlist multiple times
	          // has no effect after the first
	          return;
	        }
	        this.request.onreadystatechange = null;
	        this.request.abort();
	        this.request = null;
	      }
	
	      // request the new playlist
	      if (this.media_) {
	        this.trigger('mediachanging');
	      }
	
	      this.request = this.hls_.xhr({
	        uri: resolveUrl(this.master.uri, playlist.uri),
	        withCredentials: this.withCredentials
	      }, function (error, req) {
	        // disposed
	        if (!_this3.request) {
	          return;
	        }
	
	        if (error) {
	          return _this3.playlistRequestError(_this3.request, playlist.uri, startingState);
	        }
	
	        _this3.haveMetadata(req, playlist.uri);
	
	        // fire loadedmetadata the first time a media playlist is loaded
	        if (startingState === 'HAVE_MASTER') {
	          _this3.trigger('loadedmetadata');
	        } else {
	          _this3.trigger('mediachange');
	        }
	      });
	    }
	
	    /**
	     * pause loading of the playlist
	     */
	
	  }, {
	    key: 'pause',
	    value: function pause() {
	      this.stopRequest();
	      window$1.clearTimeout(this.mediaUpdateTimeout);
	      if (this.state === 'HAVE_NOTHING') {
	        // If we pause the loader before any data has been retrieved, its as if we never
	        // started, so reset to an unstarted state.
	        this.started = false;
	      }
	      // Need to restore state now that no activity is happening
	      if (this.state === 'SWITCHING_MEDIA') {
	        // if the loader was in the process of switching media, it should either return to
	        // HAVE_MASTER or HAVE_METADATA depending on if the loader has loaded a media
	        // playlist yet. This is determined by the existence of loader.media_
	        if (this.media_) {
	          this.state = 'HAVE_METADATA';
	        } else {
	          this.state = 'HAVE_MASTER';
	        }
	      } else if (this.state === 'HAVE_CURRENT_METADATA') {
	        this.state = 'HAVE_METADATA';
	      }
	    }
	
	    /**
	     * start loading of the playlist
	     */
	
	  }, {
	    key: 'load',
	    value: function load(isFinalRendition) {
	      var _this4 = this;
	
	      window$1.clearTimeout(this.mediaUpdateTimeout);
	
	      var media = this.media();
	
	      if (isFinalRendition) {
	        var delay = media ? media.targetDuration / 2 * 1000 : 5 * 1000;
	
	        this.mediaUpdateTimeout = window$1.setTimeout(function () {
	          return _this4.load();
	        }, delay);
	        return;
	      }
	
	      if (!this.started) {
	        this.start();
	        return;
	      }
	
	      if (media && !media.endList) {
	        this.trigger('mediaupdatetimeout');
	      } else {
	        this.trigger('loadedplaylist');
	      }
	    }
	
	    /**
	     * start loading of the playlist
	     */
	
	  }, {
	    key: 'start',
	    value: function start() {
	      var _this5 = this;
	
	      this.started = true;
	
	      // request the specified URL
	      this.request = this.hls_.xhr({
	        uri: this.srcUrl,
	        withCredentials: this.withCredentials
	      }, function (error, req) {
	        // disposed
	        if (!_this5.request) {
	          return;
	        }
	
	        // clear the loader's request reference
	        _this5.request = null;
	
	        if (error) {
	          _this5.error = {
	            status: req.status,
	            message: 'HLS playlist request error at URL: ' + _this5.srcUrl,
	            responseText: req.responseText,
	            // MEDIA_ERR_NETWORK
	            code: 2
	          };
	          if (_this5.state === 'HAVE_NOTHING') {
	            _this5.started = false;
	          }
	          return _this5.trigger('error');
	        }
	
	        var parser = new m3u8Parser.Parser();
	
	        parser.push(req.responseText);
	        parser.end();
	
	        _this5.state = 'HAVE_MASTER';
	
	        parser.manifest.uri = _this5.srcUrl;
	
	        // loaded a master playlist
	        if (parser.manifest.playlists) {
	          _this5.master = parser.manifest;
	
	          setupMediaPlaylists(_this5.master);
	          resolveMediaGroupUris(_this5.master);
	
	          _this5.trigger('loadedplaylist');
	          if (!_this5.request) {
	            // no media playlist was specifically selected so start
	            // from the first listed one
	            _this5.media(parser.manifest.playlists[0]);
	          }
	          return;
	        }
	
	        // loaded a media playlist
	        // infer a master playlist if none was previously requested
	        _this5.master = {
	          mediaGroups: {
	            'AUDIO': {},
	            'VIDEO': {},
	            'CLOSED-CAPTIONS': {},
	            'SUBTITLES': {}
	          },
	          uri: window$1.location.href,
	          playlists: [{
	            uri: _this5.srcUrl,
	            id: 0
	          }]
	        };
	        _this5.master.playlists[_this5.srcUrl] = _this5.master.playlists[0];
	        _this5.master.playlists[0].resolvedUri = _this5.srcUrl;
	        // m3u8-parser does not attach an attributes property to media playlists so make
	        // sure that the property is attached to avoid undefined reference errors
	        _this5.master.playlists[0].attributes = _this5.master.playlists[0].attributes || {};
	        _this5.haveMetadata(req, _this5.srcUrl);
	        return _this5.trigger('loadedmetadata');
	      });
	    }
	  }]);
	  return PlaylistLoader;
	}(EventTarget$1);
	
	/**
	 * @file playlist.js
	 *
	 * Playlist related utilities.
	 */
	
	var createTimeRange = videojs$1.createTimeRange;
	
	/**
	 * walk backward until we find a duration we can use
	 * or return a failure
	 *
	 * @param {Playlist} playlist the playlist to walk through
	 * @param {Number} endSequence the mediaSequence to stop walking on
	 */
	
	var backwardDuration = function backwardDuration(playlist, endSequence) {
	  var result = 0;
	  var i = endSequence - playlist.mediaSequence;
	  // if a start time is available for segment immediately following
	  // the interval, use it
	  var segment = playlist.segments[i];
	
	  // Walk backward until we find the latest segment with timeline
	  // information that is earlier than endSequence
	  if (segment) {
	    if (typeof segment.start !== 'undefined') {
	      return { result: segment.start, precise: true };
	    }
	    if (typeof segment.end !== 'undefined') {
	      return {
	        result: segment.end - segment.duration,
	        precise: true
	      };
	    }
	  }
	  while (i--) {
	    segment = playlist.segments[i];
	    if (typeof segment.end !== 'undefined') {
	      return { result: result + segment.end, precise: true };
	    }
	
	    result += segment.duration;
	
	    if (typeof segment.start !== 'undefined') {
	      return { result: result + segment.start, precise: true };
	    }
	  }
	  return { result: result, precise: false };
	};
	
	/**
	 * walk forward until we find a duration we can use
	 * or return a failure
	 *
	 * @param {Playlist} playlist the playlist to walk through
	 * @param {Number} endSequence the mediaSequence to stop walking on
	 */
	var forwardDuration = function forwardDuration(playlist, endSequence) {
	  var result = 0;
	  var segment = void 0;
	  var i = endSequence - playlist.mediaSequence;
	  // Walk forward until we find the earliest segment with timeline
	  // information
	
	  for (; i < playlist.segments.length; i++) {
	    segment = playlist.segments[i];
	    if (typeof segment.start !== 'undefined') {
	      return {
	        result: segment.start - result,
	        precise: true
	      };
	    }
	
	    result += segment.duration;
	
	    if (typeof segment.end !== 'undefined') {
	      return {
	        result: segment.end - result,
	        precise: true
	      };
	    }
	  }
	  // indicate we didn't find a useful duration estimate
	  return { result: -1, precise: false };
	};
	
	/**
	  * Calculate the media duration from the segments associated with a
	  * playlist. The duration of a subinterval of the available segments
	  * may be calculated by specifying an end index.
	  *
	  * @param {Object} playlist a media playlist object
	  * @param {Number=} endSequence an exclusive upper boundary
	  * for the playlist.  Defaults to playlist length.
	  * @param {Number} expired the amount of time that has dropped
	  * off the front of the playlist in a live scenario
	  * @return {Number} the duration between the first available segment
	  * and end index.
	  */
	var intervalDuration = function intervalDuration(playlist, endSequence, expired) {
	  var backward = void 0;
	  var forward = void 0;
	
	  if (typeof endSequence === 'undefined') {
	    endSequence = playlist.mediaSequence + playlist.segments.length;
	  }
	
	  if (endSequence < playlist.mediaSequence) {
	    return 0;
	  }
	
	  // do a backward walk to estimate the duration
	  backward = backwardDuration(playlist, endSequence);
	  if (backward.precise) {
	    // if we were able to base our duration estimate on timing
	    // information provided directly from the Media Source, return
	    // it
	    return backward.result;
	  }
	
	  // walk forward to see if a precise duration estimate can be made
	  // that way
	  forward = forwardDuration(playlist, endSequence);
	  if (forward.precise) {
	    // we found a segment that has been buffered and so it's
	    // position is known precisely
	    return forward.result;
	  }
	
	  // return the less-precise, playlist-based duration estimate
	  return backward.result + expired;
	};
	
	/**
	  * Calculates the duration of a playlist. If a start and end index
	  * are specified, the duration will be for the subset of the media
	  * timeline between those two indices. The total duration for live
	  * playlists is always Infinity.
	  *
	  * @param {Object} playlist a media playlist object
	  * @param {Number=} endSequence an exclusive upper
	  * boundary for the playlist. Defaults to the playlist media
	  * sequence number plus its length.
	  * @param {Number=} expired the amount of time that has
	  * dropped off the front of the playlist in a live scenario
	  * @return {Number} the duration between the start index and end
	  * index.
	  */
	var duration = function duration(playlist, endSequence, expired) {
	  if (!playlist) {
	    return 0;
	  }
	
	  if (typeof expired !== 'number') {
	    expired = 0;
	  }
	
	  // if a slice of the total duration is not requested, use
	  // playlist-level duration indicators when they're present
	  if (typeof endSequence === 'undefined') {
	    // if present, use the duration specified in the playlist
	    if (playlist.totalDuration) {
	      return playlist.totalDuration;
	    }
	
	    // duration should be Infinity for live playlists
	    if (!playlist.endList) {
	      return window$1.Infinity;
	    }
	  }
	
	  // calculate the total duration based on the segment durations
	  return intervalDuration(playlist, endSequence, expired);
	};
	
	/**
	  * Calculate the time between two indexes in the current playlist
	  * neight the start- nor the end-index need to be within the current
	  * playlist in which case, the targetDuration of the playlist is used
	  * to approximate the durations of the segments
	  *
	  * @param {Object} playlist a media playlist object
	  * @param {Number} startIndex
	  * @param {Number} endIndex
	  * @return {Number} the number of seconds between startIndex and endIndex
	  */
	var sumDurations = function sumDurations(playlist, startIndex, endIndex) {
	  var durations = 0;
	
	  if (startIndex > endIndex) {
	    var _ref = [endIndex, startIndex];
	    startIndex = _ref[0];
	    endIndex = _ref[1];
	  }
	
	  if (startIndex < 0) {
	    for (var i = startIndex; i < Math.min(0, endIndex); i++) {
	      durations += playlist.targetDuration;
	    }
	    startIndex = 0;
	  }
	
	  for (var _i = startIndex; _i < endIndex; _i++) {
	    durations += playlist.segments[_i].duration;
	  }
	
	  return durations;
	};
	
	/**
	 * Determines the media index of the segment corresponding to the safe edge of the live
	 * window which is the duration of the last segment plus 2 target durations from the end
	 * of the playlist.
	 *
	 * @param {Object} playlist
	 *        a media playlist object
	 * @return {Number}
	 *         The media index of the segment at the safe live point. 0 if there is no "safe"
	 *         point.
	 * @function safeLiveIndex
	 */
	var safeLiveIndex = function safeLiveIndex(playlist) {
	  if (!playlist.segments.length) {
	    return 0;
	  }
	
	  var i = playlist.segments.length - 1;
	  var distanceFromEnd = playlist.segments[i].duration || playlist.targetDuration;
	  var safeDistance = distanceFromEnd + playlist.targetDuration * 2;
	
	  while (i--) {
	    distanceFromEnd += playlist.segments[i].duration;
	
	    if (distanceFromEnd >= safeDistance) {
	      break;
	    }
	  }
	
	  return Math.max(0, i);
	};
	
	/**
	 * Calculates the playlist end time
	 *
	 * @param {Object} playlist a media playlist object
	 * @param {Number=} expired the amount of time that has
	 *                  dropped off the front of the playlist in a live scenario
	 * @param {Boolean|false} useSafeLiveEnd a boolean value indicating whether or not the
	 *                        playlist end calculation should consider the safe live end
	 *                        (truncate the playlist end by three segments). This is normally
	 *                        used for calculating the end of the playlist's seekable range.
	 * @returns {Number} the end time of playlist
	 * @function playlistEnd
	 */
	var playlistEnd = function playlistEnd(playlist, expired, useSafeLiveEnd) {
	  if (!playlist || !playlist.segments) {
	    return null;
	  }
	  if (playlist.endList) {
	    return duration(playlist);
	  }
	
	  if (expired === null) {
	    return null;
	  }
	
	  expired = expired || 0;
	
	  var endSequence = useSafeLiveEnd ? safeLiveIndex(playlist) : playlist.segments.length;
	
	  return intervalDuration(playlist, playlist.mediaSequence + endSequence, expired);
	};
	
	/**
	  * Calculates the interval of time that is currently seekable in a
	  * playlist. The returned time ranges are relative to the earliest
	  * moment in the specified playlist that is still available. A full
	  * seekable implementation for live streams would need to offset
	  * these values by the duration of content that has expired from the
	  * stream.
	  *
	  * @param {Object} playlist a media playlist object
	  * dropped off the front of the playlist in a live scenario
	  * @param {Number=} expired the amount of time that has
	  * dropped off the front of the playlist in a live scenario
	  * @return {TimeRanges} the periods of time that are valid targets
	  * for seeking
	  */
	var seekable = function seekable(playlist, expired) {
	  var useSafeLiveEnd = true;
	  var seekableStart = expired || 0;
	  var seekableEnd = playlistEnd(playlist, expired, useSafeLiveEnd);
	
	  if (seekableEnd === null) {
	    return createTimeRange();
	  }
	  return createTimeRange(seekableStart, seekableEnd);
	};
	
	var isWholeNumber = function isWholeNumber(num) {
	  return num - Math.floor(num) === 0;
	};
	
	var roundSignificantDigit = function roundSignificantDigit(increment, num) {
	  // If we have a whole number, just add 1 to it
	  if (isWholeNumber(num)) {
	    return num + increment * 0.1;
	  }
	
	  var numDecimalDigits = num.toString().split('.')[1].length;
	
	  for (var i = 1; i <= numDecimalDigits; i++) {
	    var scale = Math.pow(10, i);
	    var temp = num * scale;
	
	    if (isWholeNumber(temp) || i === numDecimalDigits) {
	      return (temp + increment) / scale;
	    }
	  }
	};
	
	var ceilLeastSignificantDigit = roundSignificantDigit.bind(null, 1);
	var floorLeastSignificantDigit = roundSignificantDigit.bind(null, -1);
	
	/**
	 * Determine the index and estimated starting time of the segment that
	 * contains a specified playback position in a media playlist.
	 *
	 * @param {Object} playlist the media playlist to query
	 * @param {Number} currentTime The number of seconds since the earliest
	 * possible position to determine the containing segment for
	 * @param {Number} startIndex
	 * @param {Number} startTime
	 * @return {Object}
	 */
	var getMediaInfoForTime = function getMediaInfoForTime(playlist, currentTime, startIndex, startTime) {
	  var i = void 0;
	  var segment = void 0;
	  var numSegments = playlist.segments.length;
	
	  var time = currentTime - startTime;
	
	  if (time < 0) {
	    // Walk backward from startIndex in the playlist, adding durations
	    // until we find a segment that contains `time` and return it
	    if (startIndex > 0) {
	      for (i = startIndex - 1; i >= 0; i--) {
	        segment = playlist.segments[i];
	        time += floorLeastSignificantDigit(segment.duration);
	        if (time > 0) {
	          return {
	            mediaIndex: i,
	            startTime: startTime - sumDurations(playlist, startIndex, i)
	          };
	        }
	      }
	    }
	    // We were unable to find a good segment within the playlist
	    // so select the first segment
	    return {
	      mediaIndex: 0,
	      startTime: currentTime
	    };
	  }
	
	  // When startIndex is negative, we first walk forward to first segment
	  // adding target durations. If we "run out of time" before getting to
	  // the first segment, return the first segment
	  if (startIndex < 0) {
	    for (i = startIndex; i < 0; i++) {
	      time -= playlist.targetDuration;
	      if (time < 0) {
	        return {
	          mediaIndex: 0,
	          startTime: currentTime
	        };
	      }
	    }
	    startIndex = 0;
	  }
	
	  // Walk forward from startIndex in the playlist, subtracting durations
	  // until we find a segment that contains `time` and return it
	  for (i = startIndex; i < numSegments; i++) {
	    segment = playlist.segments[i];
	    time -= ceilLeastSignificantDigit(segment.duration);
	    if (time < 0) {
	      return {
	        mediaIndex: i,
	        startTime: startTime + sumDurations(playlist, startIndex, i)
	      };
	    }
	  }
	
	  // We are out of possible candidates so load the last one...
	  return {
	    mediaIndex: numSegments - 1,
	    startTime: currentTime
	  };
	};
	
	/**
	 * Check whether the playlist is blacklisted or not.
	 *
	 * @param {Object} playlist the media playlist object
	 * @return {boolean} whether the playlist is blacklisted or not
	 * @function isBlacklisted
	 */
	var isBlacklisted = function isBlacklisted(playlist) {
	  return playlist.excludeUntil && playlist.excludeUntil > Date.now();
	};
	
	/**
	 * Check whether the playlist is compatible with current playback configuration or has
	 * been blacklisted permanently for being incompatible.
	 *
	 * @param {Object} playlist the media playlist object
	 * @return {boolean} whether the playlist is incompatible or not
	 * @function isIncompatible
	 */
	var isIncompatible = function isIncompatible(playlist) {
	  return playlist.excludeUntil && playlist.excludeUntil === Infinity;
	};
	
	/**
	 * Check whether the playlist is enabled or not.
	 *
	 * @param {Object} playlist the media playlist object
	 * @return {boolean} whether the playlist is enabled or not
	 * @function isEnabled
	 */
	var isEnabled = function isEnabled(playlist) {
	  var blacklisted = isBlacklisted(playlist);
	
	  return !playlist.disabled && !blacklisted;
	};
	
	/**
	 * Check whether the playlist has been manually disabled through the representations api.
	 *
	 * @param {Object} playlist the media playlist object
	 * @return {boolean} whether the playlist is disabled manually or not
	 * @function isDisabled
	 */
	var isDisabled = function isDisabled(playlist) {
	  return playlist.disabled;
	};
	
	/**
	 * Returns whether the current playlist is an AES encrypted HLS stream
	 *
	 * @return {Boolean} true if it's an AES encrypted HLS stream
	 */
	var isAes = function isAes(media) {
	  for (var i = 0; i < media.segments.length; i++) {
	    if (media.segments[i].key) {
	      return true;
	    }
	  }
	  return false;
	};
	
	/**
	 * Returns whether the current playlist contains fMP4
	 *
	 * @return {Boolean} true if the playlist contains fMP4
	 */
	var isFmp4 = function isFmp4(media) {
	  for (var i = 0; i < media.segments.length; i++) {
	    if (media.segments[i].map) {
	      return true;
	    }
	  }
	  return false;
	};
	
	/**
	 * Checks if the playlist has a value for the specified attribute
	 *
	 * @param {String} attr
	 *        Attribute to check for
	 * @param {Object} playlist
	 *        The media playlist object
	 * @return {Boolean}
	 *         Whether the playlist contains a value for the attribute or not
	 * @function hasAttribute
	 */
	var hasAttribute = function hasAttribute(attr, playlist) {
	  return playlist.attributes && playlist.attributes[attr];
	};
	
	/**
	 * Estimates the time required to complete a segment download from the specified playlist
	 *
	 * @param {Number} segmentDuration
	 *        Duration of requested segment
	 * @param {Number} bandwidth
	 *        Current measured bandwidth of the player
	 * @param {Object} playlist
	 *        The media playlist object
	 * @param {Number=} bytesReceived
	 *        Number of bytes already received for the request. Defaults to 0
	 * @return {Number|NaN}
	 *         The estimated time to request the segment. NaN if bandwidth information for
	 *         the given playlist is unavailable
	 * @function estimateSegmentRequestTime
	 */
	var estimateSegmentRequestTime = function estimateSegmentRequestTime(segmentDuration, bandwidth, playlist) {
	  var bytesReceived = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;
	
	  if (!hasAttribute('BANDWIDTH', playlist)) {
	    return NaN;
	  }
	
	  var size = segmentDuration * playlist.attributes.BANDWIDTH;
	
	  return (size - bytesReceived * 8) / bandwidth;
	};
	
	/*
	 * Returns whether the current playlist is the lowest rendition
	 *
	 * @return {Boolean} true if on lowest rendition
	 */
	var isLowestEnabledRendition = function isLowestEnabledRendition(master, media) {
	  if (master.playlists.length === 1) {
	    return true;
	  }
	
	  var currentBandwidth = media.attributes.BANDWIDTH || Number.MAX_VALUE;
	
	  return master.playlists.filter(function (playlist) {
	    if (!isEnabled(playlist)) {
	      return false;
	    }
	
	    return (playlist.attributes.BANDWIDTH || 0) < currentBandwidth;
	  }).length === 0;
	};
	
	// exports
	var Playlist = {
	  duration: duration,
	  seekable: seekable,
	  safeLiveIndex: safeLiveIndex,
	  getMediaInfoForTime: getMediaInfoForTime,
	  isEnabled: isEnabled,
	  isDisabled: isDisabled,
	  isBlacklisted: isBlacklisted,
	  isIncompatible: isIncompatible,
	  playlistEnd: playlistEnd,
	  isAes: isAes,
	  isFmp4: isFmp4,
	  hasAttribute: hasAttribute,
	  estimateSegmentRequestTime: estimateSegmentRequestTime,
	  isLowestEnabledRendition: isLowestEnabledRendition
	};
	
	/**
	 * @file xhr.js
	 */
	
	var videojsXHR = videojs$1.xhr,
	    mergeOptions$1$1 = videojs$1.mergeOptions;
	
	var xhrFactory = function xhrFactory() {
	  var xhr$$1 = function XhrFunction(options, callback) {
	    // Add a default timeout for all hls requests
	    options = mergeOptions$1$1({
	      timeout: 45e3
	    }, options);
	
	    // Allow an optional user-specified function to modify the option
	    // object before we construct the xhr request
	    var beforeRequest = XhrFunction.beforeRequest || videojs$1.Hls.xhr.beforeRequest;
	
	    if (beforeRequest && typeof beforeRequest === 'function') {
	      var newOptions = beforeRequest(options);
	
	      if (newOptions) {
	        options = newOptions;
	      }
	    }
	
	    var request = videojsXHR(options, function (error, response) {
	      var reqResponse = request.response;
	
	      if (!error && reqResponse) {
	        request.responseTime = Date.now();
	        request.roundTripTime = request.responseTime - request.requestTime;
	        request.bytesReceived = reqResponse.byteLength || reqResponse.length;
	        if (!request.bandwidth) {
	          request.bandwidth = Math.floor(request.bytesReceived / request.roundTripTime * 8 * 1000);
	        }
	      }
	
	      if (response.headers) {
	        request.responseHeaders = response.headers;
	      }
	
	      // videojs.xhr now uses a specific code on the error
	      // object to signal that a request has timed out instead
	      // of setting a boolean on the request object
	      if (error && error.code === 'ETIMEDOUT') {
	        request.timedout = true;
	      }
	
	      // videojs.xhr no longer considers status codes outside of 200 and 0
	      // (for file uris) to be errors, but the old XHR did, so emulate that
	      // behavior. Status 206 may be used in response to byterange requests.
	      if (!error && !request.aborted && response.statusCode !== 200 && response.statusCode !== 206 && response.statusCode !== 0) {
	        error = new Error('XHR Failed with a response of: ' + (request && (reqResponse || request.responseText)));
	      }
	
	      callback(error, request);
	    });
	    var originalAbort = request.abort;
	
	    request.abort = function () {
	      request.aborted = true;
	      return originalAbort.apply(request, arguments);
	    };
	    request.uri = options.uri;
	    request.requestTime = Date.now();
	    return request;
	  };
	
	  return xhr$$1;
	};
	
	/**
	 * @file bin-utils.js
	 */
	
	/**
	 * convert a TimeRange to text
	 *
	 * @param {TimeRange} range the timerange to use for conversion
	 * @param {Number} i the iterator on the range to convert
	 */
	var textRange = function textRange(range, i) {
	  return range.start(i) + '-' + range.end(i);
	};
	
	/**
	 * format a number as hex string
	 *
	 * @param {Number} e The number
	 * @param {Number} i the iterator
	 */
	var formatHexString = function formatHexString(e, i) {
	  var value = e.toString(16);
	
	  return '00'.substring(0, 2 - value.length) + value + (i % 2 ? ' ' : '');
	};
	var formatAsciiString = function formatAsciiString(e) {
	  if (e >= 0x20 && e < 0x7e) {
	    return String.fromCharCode(e);
	  }
	  return '.';
	};
	
	/**
	 * Creates an object for sending to a web worker modifying properties that are TypedArrays
	 * into a new object with seperated properties for the buffer, byteOffset, and byteLength.
	 *
	 * @param {Object} message
	 *        Object of properties and values to send to the web worker
	 * @return {Object}
	 *         Modified message with TypedArray values expanded
	 * @function createTransferableMessage
	 */
	var createTransferableMessage = function createTransferableMessage(message) {
	  var transferable = {};
	
	  Object.keys(message).forEach(function (key) {
	    var value = message[key];
	
	    if (ArrayBuffer.isView(value)) {
	      transferable[key] = {
	        bytes: value.buffer,
	        byteOffset: value.byteOffset,
	        byteLength: value.byteLength
	      };
	    } else {
	      transferable[key] = value;
	    }
	  });
	
	  return transferable;
	};
	
	/**
	 * Returns a unique string identifier for a media initialization
	 * segment.
	 */
	var initSegmentId = function initSegmentId(initSegment) {
	  var byterange = initSegment.byterange || {
	    length: Infinity,
	    offset: 0
	  };
	
	  return [byterange.length, byterange.offset, initSegment.resolvedUri].join(',');
	};
	
	/**
	 * utils to help dump binary data to the console
	 */
	var hexDump = function hexDump(data) {
	  var bytes = Array.prototype.slice.call(data);
	  var step = 16;
	  var result = '';
	  var hex = void 0;
	  var ascii = void 0;
	
	  for (var j = 0; j < bytes.length / step; j++) {
	    hex = bytes.slice(j * step, j * step + step).map(formatHexString).join('');
	    ascii = bytes.slice(j * step, j * step + step).map(formatAsciiString).join('');
	    result += hex + ' ' + ascii + '\n';
	  }
	
	  return result;
	};
	
	var tagDump = function tagDump(_ref) {
	  var bytes = _ref.bytes;
	  return hexDump(bytes);
	};
	
	var textRanges = function textRanges(ranges) {
	  var result = '';
	  var i = void 0;
	
	  for (i = 0; i < ranges.length; i++) {
	    result += textRange(ranges, i) + ' ';
	  }
	  return result;
	};
	
	var utils = /*#__PURE__*/Object.freeze({
	  createTransferableMessage: createTransferableMessage,
	  initSegmentId: initSegmentId,
	  hexDump: hexDump,
	  tagDump: tagDump,
	  textRanges: textRanges
	});
	
	/**
	 * ranges
	 *
	 * Utilities for working with TimeRanges.
	 *
	 */
	
	// Fudge factor to account for TimeRanges rounding
	var TIME_FUDGE_FACTOR = 1 / 30;
	// Comparisons between time values such as current time and the end of the buffered range
	// can be misleading because of precision differences or when the current media has poorly
	// aligned audio and video, which can cause values to be slightly off from what you would
	// expect. This value is what we consider to be safe to use in such comparisons to account
	// for these scenarios.
	var SAFE_TIME_DELTA = TIME_FUDGE_FACTOR * 3;
	var filterRanges = function filterRanges(timeRanges, predicate) {
	  var results = [];
	  var i = void 0;
	
	  if (timeRanges && timeRanges.length) {
	    // Search for ranges that match the predicate
	    for (i = 0; i < timeRanges.length; i++) {
	      if (predicate(timeRanges.start(i), timeRanges.end(i))) {
	        results.push([timeRanges.start(i), timeRanges.end(i)]);
	      }
	    }
	  }
	
	  return videojs$1.createTimeRanges(results);
	};
	
	/**
	 * Attempts to find the buffered TimeRange that contains the specified
	 * time.
	 * @param {TimeRanges} buffered - the TimeRanges object to query
	 * @param {number} time  - the time to filter on.
	 * @returns {TimeRanges} a new TimeRanges object
	 */
	var findRange = function findRange(buffered, time) {
	  return filterRanges(buffered, function (start, end) {
	    return start - TIME_FUDGE_FACTOR <= time && end + TIME_FUDGE_FACTOR >= time;
	  });
	};
	
	/**
	 * Returns the TimeRanges that begin later than the specified time.
	 * @param {TimeRanges} timeRanges - the TimeRanges object to query
	 * @param {number} time - the time to filter on.
	 * @returns {TimeRanges} a new TimeRanges object.
	 */
	var findNextRange = function findNextRange(timeRanges, time) {
	  return filterRanges(timeRanges, function (start) {
	    return start - TIME_FUDGE_FACTOR >= time;
	  });
	};
	
	/**
	 * Returns gaps within a list of TimeRanges
	 * @param {TimeRanges} buffered - the TimeRanges object
	 * @return {TimeRanges} a TimeRanges object of gaps
	 */
	var findGaps = function findGaps(buffered) {
	  if (buffered.length < 2) {
	    return videojs$1.createTimeRanges();
	  }
	
	  var ranges = [];
	
	  for (var i = 1; i < buffered.length; i++) {
	    var start = buffered.end(i - 1);
	    var end = buffered.start(i);
	
	    ranges.push([start, end]);
	  }
	
	  return videojs$1.createTimeRanges(ranges);
	};
	
	/**
	 * Gets a human readable string for a TimeRange
	 *
	 * @param {TimeRange} range
	 * @returns {String} a human readable string
	 */
	var printableRange = function printableRange(range) {
	  var strArr = [];
	
	  if (!range || !range.length) {
	    return '';
	  }
	
	  for (var i = 0; i < range.length; i++) {
	    strArr.push(range.start(i) + ' => ' + range.end(i));
	  }
	
	  return strArr.join(', ');
	};
	
	/**
	 * Calculates the amount of time left in seconds until the player hits the end of the
	 * buffer and causes a rebuffer
	 *
	 * @param {TimeRange} buffered
	 *        The state of the buffer
	 * @param {Numnber} currentTime
	 *        The current time of the player
	 * @param {Number} playbackRate
	 *        The current playback rate of the player. Defaults to 1.
	 * @return {Number}
	 *         Time until the player has to start rebuffering in seconds.
	 * @function timeUntilRebuffer
	 */
	var timeUntilRebuffer = function timeUntilRebuffer(buffered, currentTime) {
	  var playbackRate = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;
	
	  var bufferedEnd = buffered.length ? buffered.end(buffered.length - 1) : 0;
	
	  return (bufferedEnd - currentTime) / playbackRate;
	};
	
	/**
	 * Converts a TimeRanges object into an array representation
	 * @param {TimeRanges} timeRanges
	 * @returns {Array}
	 */
	var timeRangesToArray = function timeRangesToArray(timeRanges) {
	  var timeRangesList = [];
	
	  for (var i = 0; i < timeRanges.length; i++) {
	    timeRangesList.push({
	      start: timeRanges.start(i),
	      end: timeRanges.end(i)
	    });
	  }
	
	  return timeRangesList;
	};
	
	/**
	 * @file create-text-tracks-if-necessary.js
	 */
	
	/**
	 * Create text tracks on video.js if they exist on a segment.
	 *
	 * @param {Object} sourceBuffer the VSB or FSB
	 * @param {Object} mediaSource the HTML media source
	 * @param {Object} segment the segment that may contain the text track
	 * @private
	 */
	var createTextTracksIfNecessary = function createTextTracksIfNecessary(sourceBuffer, mediaSource, segment) {
	  var player = mediaSource.player_;
	
	  // create an in-band caption track if one is present in the segment
	  if (segment.captions && segment.captions.length) {
	    if (!sourceBuffer.inbandTextTracks_) {
	      sourceBuffer.inbandTextTracks_ = {};
	    }
	
	    for (var trackId in segment.captionStreams) {
	      if (!sourceBuffer.inbandTextTracks_[trackId]) {
	        player.tech_.trigger({ type: 'usage', name: 'hls-608' });
	        var track = player.textTracks().getTrackById(trackId);
	
	        if (track) {
	          // Resuse an existing track with a CC# id because this was
	          // very likely created by videojs-contrib-hls from information
	          // in the m3u8 for us to use
	          sourceBuffer.inbandTextTracks_[trackId] = track;
	        } else {
	          // Otherwise, create a track with the default `CC#` label and
	          // without a language
	          sourceBuffer.inbandTextTracks_[trackId] = player.addRemoteTextTrack({
	            kind: 'captions',
	            id: trackId,
	            label: trackId
	          }, false).track;
	        }
	      }
	    }
	  }
	
	  if (segment.metadata && segment.metadata.length && !sourceBuffer.metadataTrack_) {
	    sourceBuffer.metadataTrack_ = player.addRemoteTextTrack({
	      kind: 'metadata',
	      label: 'Timed Metadata'
	    }, false).track;
	    sourceBuffer.metadataTrack_.inBandMetadataTrackDispatchType = segment.metadata.dispatchType;
	  }
	};
	
	/**
	 * @file remove-cues-from-track.js
	 */
	
	/**
	 * Remove cues from a track on video.js.
	 *
	 * @param {Double} start start of where we should remove the cue
	 * @param {Double} end end of where the we should remove the cue
	 * @param {Object} track the text track to remove the cues from
	 * @private
	 */
	var removeCuesFromTrack = function removeCuesFromTrack(start, end, track) {
	  var i = void 0;
	  var cue = void 0;
	
	  if (!track) {
	    return;
	  }
	
	  if (!track.cues) {
	    return;
	  }
	
	  i = track.cues.length;
	
	  while (i--) {
	    cue = track.cues[i];
	
	    // Remove any overlapping cue
	    if (cue.startTime <= end && cue.endTime >= start) {
	      track.removeCue(cue);
	    }
	  }
	};
	
	/**
	 * @file add-text-track-data.js
	 */
	/**
	 * Define properties on a cue for backwards compatability,
	 * but warn the user that the way that they are using it
	 * is depricated and will be removed at a later date.
	 *
	 * @param {Cue} cue the cue to add the properties on
	 * @private
	 */
	var deprecateOldCue = function deprecateOldCue(cue) {
	  Object.defineProperties(cue.frame, {
	    id: {
	      get: function get$$1() {
	        videojs$1.log.warn('cue.frame.id is deprecated. Use cue.value.key instead.');
	        return cue.value.key;
	      }
	    },
	    value: {
	      get: function get$$1() {
	        videojs$1.log.warn('cue.frame.value is deprecated. Use cue.value.data instead.');
	        return cue.value.data;
	      }
	    },
	    privateData: {
	      get: function get$$1() {
	        videojs$1.log.warn('cue.frame.privateData is deprecated. Use cue.value.data instead.');
	        return cue.value.data;
	      }
	    }
	  });
	};
	
	var durationOfVideo = function durationOfVideo(duration) {
	  var dur = void 0;
	
	  if (isNaN(duration) || Math.abs(duration) === Infinity) {
	    dur = Number.MAX_VALUE;
	  } else {
	    dur = duration;
	  }
	  return dur;
	};
	/**
	 * Add text track data to a source handler given the captions and
	 * metadata from the buffer.
	 *
	 * @param {Object} sourceHandler the virtual source buffer
	 * @param {Array} captionArray an array of caption data
	 * @param {Array} metadataArray an array of meta data
	 * @private
	 */
	var addTextTrackData = function addTextTrackData(sourceHandler, captionArray, metadataArray) {
	  var Cue = window$1.WebKitDataCue || window$1.VTTCue;
	
	  if (captionArray) {
	    captionArray.forEach(function (caption) {
	      var track = caption.stream;
	
	      this.inbandTextTracks_[track].addCue(new Cue(caption.startTime + this.timestampOffset, caption.endTime + this.timestampOffset, caption.text));
	    }, sourceHandler);
	  }
	
	  if (metadataArray) {
	    var videoDuration = durationOfVideo(sourceHandler.mediaSource_.duration);
	
	    metadataArray.forEach(function (metadata) {
	      var time = metadata.cueTime + this.timestampOffset;
	
	      metadata.frames.forEach(function (frame) {
	        var cue = new Cue(time, time, frame.value || frame.url || frame.data || '');
	
	        cue.frame = frame;
	        cue.value = frame;
	        deprecateOldCue(cue);
	
	        this.metadataTrack_.addCue(cue);
	      }, this);
	    }, sourceHandler);
	
	    // Updating the metadeta cues so that
	    // the endTime of each cue is the startTime of the next cue
	    // the endTime of last cue is the duration of the video
	    if (sourceHandler.metadataTrack_ && sourceHandler.metadataTrack_.cues && sourceHandler.metadataTrack_.cues.length) {
	      var cues = sourceHandler.metadataTrack_.cues;
	      var cuesArray = [];
	
	      // Create a copy of the TextTrackCueList...
	      // ...disregarding cues with a falsey value
	      for (var i = 0; i < cues.length; i++) {
	        if (cues[i]) {
	          cuesArray.push(cues[i]);
	        }
	      }
	
	      // Group cues by their startTime value
	      var cuesGroupedByStartTime = cuesArray.reduce(function (obj, cue) {
	        var timeSlot = obj[cue.startTime] || [];
	
	        timeSlot.push(cue);
	        obj[cue.startTime] = timeSlot;
	
	        return obj;
	      }, {});
	
	      // Sort startTimes by ascending order
	      var sortedStartTimes = Object.keys(cuesGroupedByStartTime).sort(function (a, b) {
	        return Number(a) - Number(b);
	      });
	
	      // Map each cue group's endTime to the next group's startTime
	      sortedStartTimes.forEach(function (startTime, idx) {
	        var cueGroup = cuesGroupedByStartTime[startTime];
	        var nextTime = Number(sortedStartTimes[idx + 1]) || videoDuration;
	
	        // Map each cue's endTime the next group's startTime
	        cueGroup.forEach(function (cue) {
	          cue.endTime = nextTime;
	        });
	      });
	    }
	  }
	};
	
	var win = typeof window !== 'undefined' ? window : {},
	    TARGET = typeof Symbol === 'undefined' ? '__target' : Symbol(),
	    SCRIPT_TYPE = 'application/javascript',
	    BlobBuilder = win.BlobBuilder || win.WebKitBlobBuilder || win.MozBlobBuilder || win.MSBlobBuilder,
	    URL = win.URL || win.webkitURL || URL && URL.msURL,
	    Worker = win.Worker;
	
	/**
	 * Returns a wrapper around Web Worker code that is constructible.
	 *
	 * @function shimWorker
	 *
	 * @param { String }    filename    The name of the file
	 * @param { Function }  fn          Function wrapping the code of the worker
	 */
	function shimWorker(filename, fn) {
	  return function ShimWorker(forceFallback) {
	    var o = this;
	
	    if (!fn) {
	      return new Worker(filename);
	    } else if (Worker && !forceFallback) {
	      // Convert the function's inner code to a string to construct the worker
	      var source = fn.toString().replace(/^function.+?{/, '').slice(0, -1),
	          objURL = createSourceObject(source);
	
	      this[TARGET] = new Worker(objURL);
	      wrapTerminate(this[TARGET], objURL);
	      return this[TARGET];
	    } else {
	      var selfShim = {
	        postMessage: function postMessage(m) {
	          if (o.onmessage) {
	            setTimeout(function () {
	              o.onmessage({ data: m, target: selfShim });
	            });
	          }
	        }
	      };
	
	      fn.call(selfShim);
	      this.postMessage = function (m) {
	        setTimeout(function () {
	          selfShim.onmessage({ data: m, target: o });
	        });
	      };
	      this.isThisThread = true;
	    }
	  };
	}
	// Test Worker capabilities
	if (Worker) {
	  var testWorker,
	      objURL = createSourceObject('self.onmessage = function () {}'),
	      testArray = new Uint8Array(1);
	
	  try {
	    testWorker = new Worker(objURL);
	
	    // Native browser on some Samsung devices throws for transferables, let's detect it
	    testWorker.postMessage(testArray, [testArray.buffer]);
	  } catch (e) {
	    Worker = null;
	  } finally {
	    URL.revokeObjectURL(objURL);
	    if (testWorker) {
	      testWorker.terminate();
	    }
	  }
	}
	
	function createSourceObject(str) {
	  try {
	    return URL.createObjectURL(new Blob([str], { type: SCRIPT_TYPE }));
	  } catch (e) {
	    var blob = new BlobBuilder();
	    blob.append(str);
	    return URL.createObjectURL(blob.getBlob(type));
	  }
	}
	
	function wrapTerminate(worker, objURL) {
	  if (!worker || !objURL) return;
	  var term = worker.terminate;
	  worker.objURL = objURL;
	  worker.terminate = function () {
	    if (worker.objURL) URL.revokeObjectURL(worker.objURL);
	    term.call(worker);
	  };
	}
	
	var TransmuxWorker = new shimWorker("./transmuxer-worker.worker.js", function (window, document$$1) {
	  var self = this;
	  var transmuxerWorker = function () {
	
	    /**
	     * mux.js
	     *
	     * Copyright (c) 2015 Brightcove
	     * All rights reserved.
	     *
	     * Functions that generate fragmented MP4s suitable for use with Media
	     * Source Extensions.
	     */
	
	    var UINT32_MAX = Math.pow(2, 32) - 1;
	
	    var box, dinf, esds, ftyp, mdat, mfhd, minf, moof, moov, mvex, mvhd, trak, tkhd, mdia, mdhd, hdlr, sdtp, stbl, stsd, traf, trex, trun, types, MAJOR_BRAND, MINOR_VERSION, AVC1_BRAND, VIDEO_HDLR, AUDIO_HDLR, HDLR_TYPES, VMHD, SMHD, DREF, STCO, STSC, STSZ, STTS;
	
	    // pre-calculate constants
	    (function () {
	      var i;
	      types = {
	        avc1: [], // codingname
	        avcC: [],
	        btrt: [],
	        dinf: [],
	        dref: [],
	        esds: [],
	        ftyp: [],
	        hdlr: [],
	        mdat: [],
	        mdhd: [],
	        mdia: [],
	        mfhd: [],
	        minf: [],
	        moof: [],
	        moov: [],
	        mp4a: [], // codingname
	        mvex: [],
	        mvhd: [],
	        sdtp: [],
	        smhd: [],
	        stbl: [],
	        stco: [],
	        stsc: [],
	        stsd: [],
	        stsz: [],
	        stts: [],
	        styp: [],
	        tfdt: [],
	        tfhd: [],
	        traf: [],
	        trak: [],
	        trun: [],
	        trex: [],
	        tkhd: [],
	        vmhd: []
	      };
	
	      // In environments where Uint8Array is undefined (e.g., IE8), skip set up so that we
	      // don't throw an error
	      if (typeof Uint8Array === 'undefined') {
	        return;
	      }
	
	      for (i in types) {
	        if (types.hasOwnProperty(i)) {
	          types[i] = [i.charCodeAt(0), i.charCodeAt(1), i.charCodeAt(2), i.charCodeAt(3)];
	        }
	      }
	
	      MAJOR_BRAND = new Uint8Array(['i'.charCodeAt(0), 's'.charCodeAt(0), 'o'.charCodeAt(0), 'm'.charCodeAt(0)]);
	      AVC1_BRAND = new Uint8Array(['a'.charCodeAt(0), 'v'.charCodeAt(0), 'c'.charCodeAt(0), '1'.charCodeAt(0)]);
	      MINOR_VERSION = new Uint8Array([0, 0, 0, 1]);
	      VIDEO_HDLR = new Uint8Array([0x00, // version 0
	      0x00, 0x00, 0x00, // flags
	      0x00, 0x00, 0x00, 0x00, // pre_defined
	      0x76, 0x69, 0x64, 0x65, // handler_type: 'vide'
	      0x00, 0x00, 0x00, 0x00, // reserved
	      0x00, 0x00, 0x00, 0x00, // reserved
	      0x00, 0x00, 0x00, 0x00, // reserved
	      0x56, 0x69, 0x64, 0x65, 0x6f, 0x48, 0x61, 0x6e, 0x64, 0x6c, 0x65, 0x72, 0x00 // name: 'VideoHandler'
	      ]);
	      AUDIO_HDLR = new Uint8Array([0x00, // version 0
	      0x00, 0x00, 0x00, // flags
	      0x00, 0x00, 0x00, 0x00, // pre_defined
	      0x73, 0x6f, 0x75, 0x6e, // handler_type: 'soun'
	      0x00, 0x00, 0x00, 0x00, // reserved
	      0x00, 0x00, 0x00, 0x00, // reserved
	      0x00, 0x00, 0x00, 0x00, // reserved
	      0x53, 0x6f, 0x75, 0x6e, 0x64, 0x48, 0x61, 0x6e, 0x64, 0x6c, 0x65, 0x72, 0x00 // name: 'SoundHandler'
	      ]);
	      HDLR_TYPES = {
	        video: VIDEO_HDLR,
	        audio: AUDIO_HDLR
	      };
	      DREF = new Uint8Array([0x00, // version 0
	      0x00, 0x00, 0x00, // flags
	      0x00, 0x00, 0x00, 0x01, // entry_count
	      0x00, 0x00, 0x00, 0x0c, // entry_size
	      0x75, 0x72, 0x6c, 0x20, // 'url' type
	      0x00, // version 0
	      0x00, 0x00, 0x01 // entry_flags
	      ]);
	      SMHD = new Uint8Array([0x00, // version
	      0x00, 0x00, 0x00, // flags
	      0x00, 0x00, // balance, 0 means centered
	      0x00, 0x00 // reserved
	      ]);
	      STCO = new Uint8Array([0x00, // version
	      0x00, 0x00, 0x00, // flags
	      0x00, 0x00, 0x00, 0x00 // entry_count
	      ]);
	      STSC = STCO;
	      STSZ = new Uint8Array([0x00, // version
	      0x00, 0x00, 0x00, // flags
	      0x00, 0x00, 0x00, 0x00, // sample_size
	      0x00, 0x00, 0x00, 0x00 // sample_count
	      ]);
	      STTS = STCO;
	      VMHD = new Uint8Array([0x00, // version
	      0x00, 0x00, 0x01, // flags
	      0x00, 0x00, // graphicsmode
	      0x00, 0x00, 0x00, 0x00, 0x00, 0x00 // opcolor
	      ]);
	    })();
	
	    box = function box(type) {
	      var payload = [],
	          size = 0,
	          i,
	          result,
	          view;
	
	      for (i = 1; i < arguments.length; i++) {
	        payload.push(arguments[i]);
	      }
	
	      i = payload.length;
	
	      // calculate the total size we need to allocate
	      while (i--) {
	        size += payload[i].byteLength;
	      }
	      result = new Uint8Array(size + 8);
	      view = new DataView(result.buffer, result.byteOffset, result.byteLength);
	      view.setUint32(0, result.byteLength);
	      result.set(type, 4);
	
	      // copy the payload into the result
	      for (i = 0, size = 8; i < payload.length; i++) {
	        result.set(payload[i], size);
	        size += payload[i].byteLength;
	      }
	      return result;
	    };
	
	    dinf = function dinf() {
	      return box(types.dinf, box(types.dref, DREF));
	    };
	
	    esds = function esds(track) {
	      return box(types.esds, new Uint8Array([0x00, // version
	      0x00, 0x00, 0x00, // flags
	
	      // ES_Descriptor
	      0x03, // tag, ES_DescrTag
	      0x19, // length
	      0x00, 0x00, // ES_ID
	      0x00, // streamDependenceFlag, URL_flag, reserved, streamPriority
	
	      // DecoderConfigDescriptor
	      0x04, // tag, DecoderConfigDescrTag
	      0x11, // length
	      0x40, // object type
	      0x15, // streamType
	      0x00, 0x06, 0x00, // bufferSizeDB
	      0x00, 0x00, 0xda, 0xc0, // maxBitrate
	      0x00, 0x00, 0xda, 0xc0, // avgBitrate
	
	      // DecoderSpecificInfo
	      0x05, // tag, DecoderSpecificInfoTag
	      0x02, // length
	      // ISO/IEC 14496-3, AudioSpecificConfig
	      // for samplingFrequencyIndex see ISO/IEC 13818-7:2006, 8.1.3.2.2, Table 35
	      track.audioobjecttype << 3 | track.samplingfrequencyindex >>> 1, track.samplingfrequencyindex << 7 | track.channelcount << 3, 0x06, 0x01, 0x02 // GASpecificConfig
	      ]));
	    };
	
	    ftyp = function ftyp() {
	      return box(types.ftyp, MAJOR_BRAND, MINOR_VERSION, MAJOR_BRAND, AVC1_BRAND);
	    };
	
	    hdlr = function hdlr(type) {
	      return box(types.hdlr, HDLR_TYPES[type]);
	    };
	    mdat = function mdat(data) {
	      return box(types.mdat, data);
	    };
	    mdhd = function mdhd(track) {
	      var result = new Uint8Array([0x00, // version 0
	      0x00, 0x00, 0x00, // flags
	      0x00, 0x00, 0x00, 0x02, // creation_time
	      0x00, 0x00, 0x00, 0x03, // modification_time
	      0x00, 0x01, 0x5f, 0x90, // timescale, 90,000 "ticks" per second
	
	      track.duration >>> 24 & 0xFF, track.duration >>> 16 & 0xFF, track.duration >>> 8 & 0xFF, track.duration & 0xFF, // duration
	      0x55, 0xc4, // 'und' language (undetermined)
	      0x00, 0x00]);
	
	      // Use the sample rate from the track metadata, when it is
	      // defined. The sample rate can be parsed out of an ADTS header, for
	      // instance.
	      if (track.samplerate) {
	        result[12] = track.samplerate >>> 24 & 0xFF;
	        result[13] = track.samplerate >>> 16 & 0xFF;
	        result[14] = track.samplerate >>> 8 & 0xFF;
	        result[15] = track.samplerate & 0xFF;
	      }
	
	      return box(types.mdhd, result);
	    };
	    mdia = function mdia(track) {
	      return box(types.mdia, mdhd(track), hdlr(track.type), minf(track));
	    };
	    mfhd = function mfhd(sequenceNumber) {
	      return box(types.mfhd, new Uint8Array([0x00, 0x00, 0x00, 0x00, // flags
	      (sequenceNumber & 0xFF000000) >> 24, (sequenceNumber & 0xFF0000) >> 16, (sequenceNumber & 0xFF00) >> 8, sequenceNumber & 0xFF // sequence_number
	      ]));
	    };
	    minf = function minf(track) {
	      return box(types.minf, track.type === 'video' ? box(types.vmhd, VMHD) : box(types.smhd, SMHD), dinf(), stbl(track));
	    };
	    moof = function moof(sequenceNumber, tracks) {
	      var trackFragments = [],
	          i = tracks.length;
	      // build traf boxes for each track fragment
	      while (i--) {
	        trackFragments[i] = traf(tracks[i]);
	      }
	      return box.apply(null, [types.moof, mfhd(sequenceNumber)].concat(trackFragments));
	    };
	    /**
	     * Returns a movie box.
	     * @param tracks {array} the tracks associated with this movie
	     * @see ISO/IEC 14496-12:2012(E), section 8.2.1
	     */
	    moov = function moov(tracks) {
	      var i = tracks.length,
	          boxes = [];
	
	      while (i--) {
	        boxes[i] = trak(tracks[i]);
	      }
	
	      return box.apply(null, [types.moov, mvhd(0xffffffff)].concat(boxes).concat(mvex(tracks)));
	    };
	    mvex = function mvex(tracks) {
	      var i = tracks.length,
	          boxes = [];
	
	      while (i--) {
	        boxes[i] = trex(tracks[i]);
	      }
	      return box.apply(null, [types.mvex].concat(boxes));
	    };
	    mvhd = function mvhd(duration) {
	      var bytes = new Uint8Array([0x00, // version 0
	      0x00, 0x00, 0x00, // flags
	      0x00, 0x00, 0x00, 0x01, // creation_time
	      0x00, 0x00, 0x00, 0x02, // modification_time
	      0x00, 0x01, 0x5f, 0x90, // timescale, 90,000 "ticks" per second
	      (duration & 0xFF000000) >> 24, (duration & 0xFF0000) >> 16, (duration & 0xFF00) >> 8, duration & 0xFF, // duration
	      0x00, 0x01, 0x00, 0x00, // 1.0 rate
	      0x01, 0x00, // 1.0 volume
	      0x00, 0x00, // reserved
	      0x00, 0x00, 0x00, 0x00, // reserved
	      0x00, 0x00, 0x00, 0x00, // reserved
	      0x00, 0x01, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x01, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x40, 0x00, 0x00, 0x00, // transformation: unity matrix
	      0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, // pre_defined
	      0xff, 0xff, 0xff, 0xff // next_track_ID
	      ]);
	      return box(types.mvhd, bytes);
	    };
	
	    sdtp = function sdtp(track) {
	      var samples = track.samples || [],
	          bytes = new Uint8Array(4 + samples.length),
	          flags,
	          i;
	
	      // leave the full box header (4 bytes) all zero
	
	      // write the sample table
	      for (i = 0; i < samples.length; i++) {
	        flags = samples[i].flags;
	
	        bytes[i + 4] = flags.dependsOn << 4 | flags.isDependedOn << 2 | flags.hasRedundancy;
	      }
	
	      return box(types.sdtp, bytes);
	    };
	
	    stbl = function stbl(track) {
	      return box(types.stbl, stsd(track), box(types.stts, STTS), box(types.stsc, STSC), box(types.stsz, STSZ), box(types.stco, STCO));
	    };
	
	    (function () {
	      var videoSample, audioSample;
	
	      stsd = function stsd(track) {
	
	        return box(types.stsd, new Uint8Array([0x00, // version 0
	        0x00, 0x00, 0x00, // flags
	        0x00, 0x00, 0x00, 0x01]), track.type === 'video' ? videoSample(track) : audioSample(track));
	      };
	
	      videoSample = function videoSample(track) {
	        var sps = track.sps || [],
	            pps = track.pps || [],
	            sequenceParameterSets = [],
	            pictureParameterSets = [],
	            i;
	
	        // assemble the SPSs
	        for (i = 0; i < sps.length; i++) {
	          sequenceParameterSets.push((sps[i].byteLength & 0xFF00) >>> 8);
	          sequenceParameterSets.push(sps[i].byteLength & 0xFF); // sequenceParameterSetLength
	          sequenceParameterSets = sequenceParameterSets.concat(Array.prototype.slice.call(sps[i])); // SPS
	        }
	
	        // assemble the PPSs
	        for (i = 0; i < pps.length; i++) {
	          pictureParameterSets.push((pps[i].byteLength & 0xFF00) >>> 8);
	          pictureParameterSets.push(pps[i].byteLength & 0xFF);
	          pictureParameterSets = pictureParameterSets.concat(Array.prototype.slice.call(pps[i]));
	        }
	
	        return box(types.avc1, new Uint8Array([0x00, 0x00, 0x00, 0x00, 0x00, 0x00, // reserved
	        0x00, 0x01, // data_reference_index
	        0x00, 0x00, // pre_defined
	        0x00, 0x00, // reserved
	        0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, // pre_defined
	        (track.width & 0xff00) >> 8, track.width & 0xff, // width
	        (track.height & 0xff00) >> 8, track.height & 0xff, // height
	        0x00, 0x48, 0x00, 0x00, // horizresolution
	        0x00, 0x48, 0x00, 0x00, // vertresolution
	        0x00, 0x00, 0x00, 0x00, // reserved
	        0x00, 0x01, // frame_count
	        0x13, 0x76, 0x69, 0x64, 0x65, 0x6f, 0x6a, 0x73, 0x2d, 0x63, 0x6f, 0x6e, 0x74, 0x72, 0x69, 0x62, 0x2d, 0x68, 0x6c, 0x73, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, // compressorname
	        0x00, 0x18, // depth = 24
	        0x11, 0x11 // pre_defined = -1
	        ]), box(types.avcC, new Uint8Array([0x01, // configurationVersion
	        track.profileIdc, // AVCProfileIndication
	        track.profileCompatibility, // profile_compatibility
	        track.levelIdc, // AVCLevelIndication
	        0xff // lengthSizeMinusOne, hard-coded to 4 bytes
	        ].concat([sps.length // numOfSequenceParameterSets
	        ]).concat(sequenceParameterSets).concat([pps.length // numOfPictureParameterSets
	        ]).concat(pictureParameterSets))), // "PPS"
	        box(types.btrt, new Uint8Array([0x00, 0x1c, 0x9c, 0x80, // bufferSizeDB
	        0x00, 0x2d, 0xc6, 0xc0, // maxBitrate
	        0x00, 0x2d, 0xc6, 0xc0])) // avgBitrate
	        );
	      };
	
	      audioSample = function audioSample(track) {
	        return box(types.mp4a, new Uint8Array([
	
	        // SampleEntry, ISO/IEC 14496-12
	        0x00, 0x00, 0x00, 0x00, 0x00, 0x00, // reserved
	        0x00, 0x01, // data_reference_index
	
	        // AudioSampleEntry, ISO/IEC 14496-12
	        0x00, 0x00, 0x00, 0x00, // reserved
	        0x00, 0x00, 0x00, 0x00, // reserved
	        (track.channelcount & 0xff00) >> 8, track.channelcount & 0xff, // channelcount
	
	        (track.samplesize & 0xff00) >> 8, track.samplesize & 0xff, // samplesize
	        0x00, 0x00, // pre_defined
	        0x00, 0x00, // reserved
	
	        (track.samplerate & 0xff00) >> 8, track.samplerate & 0xff, 0x00, 0x00 // samplerate, 16.16
	
	        // MP4AudioSampleEntry, ISO/IEC 14496-14
	        ]), esds(track));
	      };
	    })();
	
	    tkhd = function tkhd(track) {
	      var result = new Uint8Array([0x00, // version 0
	      0x00, 0x00, 0x07, // flags
	      0x00, 0x00, 0x00, 0x00, // creation_time
	      0x00, 0x00, 0x00, 0x00, // modification_time
	      (track.id & 0xFF000000) >> 24, (track.id & 0xFF0000) >> 16, (track.id & 0xFF00) >> 8, track.id & 0xFF, // track_ID
	      0x00, 0x00, 0x00, 0x00, // reserved
	      (track.duration & 0xFF000000) >> 24, (track.duration & 0xFF0000) >> 16, (track.duration & 0xFF00) >> 8, track.duration & 0xFF, // duration
	      0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, // reserved
	      0x00, 0x00, // layer
	      0x00, 0x00, // alternate_group
	      0x01, 0x00, // non-audio track volume
	      0x00, 0x00, // reserved
	      0x00, 0x01, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x01, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x40, 0x00, 0x00, 0x00, // transformation: unity matrix
	      (track.width & 0xFF00) >> 8, track.width & 0xFF, 0x00, 0x00, // width
	      (track.height & 0xFF00) >> 8, track.height & 0xFF, 0x00, 0x00 // height
	      ]);
	
	      return box(types.tkhd, result);
	    };
	
	    /**
	     * Generate a track fragment (traf) box. A traf box collects metadata
	     * about tracks in a movie fragment (moof) box.
	     */
	    traf = function traf(track) {
	      var trackFragmentHeader, trackFragmentDecodeTime, trackFragmentRun, sampleDependencyTable, dataOffset, upperWordBaseMediaDecodeTime, lowerWordBaseMediaDecodeTime;
	
	      trackFragmentHeader = box(types.tfhd, new Uint8Array([0x00, // version 0
	      0x00, 0x00, 0x3a, // flags
	      (track.id & 0xFF000000) >> 24, (track.id & 0xFF0000) >> 16, (track.id & 0xFF00) >> 8, track.id & 0xFF, // track_ID
	      0x00, 0x00, 0x00, 0x01, // sample_description_index
	      0x00, 0x00, 0x00, 0x00, // default_sample_duration
	      0x00, 0x00, 0x00, 0x00, // default_sample_size
	      0x00, 0x00, 0x00, 0x00 // default_sample_flags
	      ]));
	
	      upperWordBaseMediaDecodeTime = Math.floor(track.baseMediaDecodeTime / (UINT32_MAX + 1));
	      lowerWordBaseMediaDecodeTime = Math.floor(track.baseMediaDecodeTime % (UINT32_MAX + 1));
	
	      trackFragmentDecodeTime = box(types.tfdt, new Uint8Array([0x01, // version 1
	      0x00, 0x00, 0x00, // flags
	      // baseMediaDecodeTime
	      upperWordBaseMediaDecodeTime >>> 24 & 0xFF, upperWordBaseMediaDecodeTime >>> 16 & 0xFF, upperWordBaseMediaDecodeTime >>> 8 & 0xFF, upperWordBaseMediaDecodeTime & 0xFF, lowerWordBaseMediaDecodeTime >>> 24 & 0xFF, lowerWordBaseMediaDecodeTime >>> 16 & 0xFF, lowerWordBaseMediaDecodeTime >>> 8 & 0xFF, lowerWordBaseMediaDecodeTime & 0xFF]));
	
	      // the data offset specifies the number of bytes from the start of
	      // the containing moof to the first payload byte of the associated
	      // mdat
	      dataOffset = 32 + // tfhd
	      20 + // tfdt
	      8 + // traf header
	      16 + // mfhd
	      8 + // moof header
	      8; // mdat header
	
	      // audio tracks require less metadata
	      if (track.type === 'audio') {
	        trackFragmentRun = trun(track, dataOffset);
	        return box(types.traf, trackFragmentHeader, trackFragmentDecodeTime, trackFragmentRun);
	      }
	
	      // video tracks should contain an independent and disposable samples
	      // box (sdtp)
	      // generate one and adjust offsets to match
	      sampleDependencyTable = sdtp(track);
	      trackFragmentRun = trun(track, sampleDependencyTable.length + dataOffset);
	      return box(types.traf, trackFragmentHeader, trackFragmentDecodeTime, trackFragmentRun, sampleDependencyTable);
	    };
	
	    /**
	     * Generate a track box.
	     * @param track {object} a track definition
	     * @return {Uint8Array} the track box
	     */
	    trak = function trak(track) {
	      track.duration = track.duration || 0xffffffff;
	      return box(types.trak, tkhd(track), mdia(track));
	    };
	
	    trex = function trex(track) {
	      var result = new Uint8Array([0x00, // version 0
	      0x00, 0x00, 0x00, // flags
	      (track.id & 0xFF000000) >> 24, (track.id & 0xFF0000) >> 16, (track.id & 0xFF00) >> 8, track.id & 0xFF, // track_ID
	      0x00, 0x00, 0x00, 0x01, // default_sample_description_index
	      0x00, 0x00, 0x00, 0x00, // default_sample_duration
	      0x00, 0x00, 0x00, 0x00, // default_sample_size
	      0x00, 0x01, 0x00, 0x01 // default_sample_flags
	      ]);
	      // the last two bytes of default_sample_flags is the sample
	      // degradation priority, a hint about the importance of this sample
	      // relative to others. Lower the degradation priority for all sample
	      // types other than video.
	      if (track.type !== 'video') {
	        result[result.length - 1] = 0x00;
	      }
	
	      return box(types.trex, result);
	    };
	
	    (function () {
	      var audioTrun, videoTrun, trunHeader;
	
	      // This method assumes all samples are uniform. That is, if a
	      // duration is present for the first sample, it will be present for
	      // all subsequent samples.
	      // see ISO/IEC 14496-12:2012, Section 8.8.8.1
	      trunHeader = function trunHeader(samples, offset) {
	        var durationPresent = 0,
	            sizePresent = 0,
	            flagsPresent = 0,
	            compositionTimeOffset = 0;
	
	        // trun flag constants
	        if (samples.length) {
	          if (samples[0].duration !== undefined) {
	            durationPresent = 0x1;
	          }
	          if (samples[0].size !== undefined) {
	            sizePresent = 0x2;
	          }
	          if (samples[0].flags !== undefined) {
	            flagsPresent = 0x4;
	          }
	          if (samples[0].compositionTimeOffset !== undefined) {
	            compositionTimeOffset = 0x8;
	          }
	        }
	
	        return [0x00, // version 0
	        0x00, durationPresent | sizePresent | flagsPresent | compositionTimeOffset, 0x01, // flags
	        (samples.length & 0xFF000000) >>> 24, (samples.length & 0xFF0000) >>> 16, (samples.length & 0xFF00) >>> 8, samples.length & 0xFF, // sample_count
	        (offset & 0xFF000000) >>> 24, (offset & 0xFF0000) >>> 16, (offset & 0xFF00) >>> 8, offset & 0xFF // data_offset
	        ];
	      };
	
	      videoTrun = function videoTrun(track, offset) {
	        var bytes, samples, sample, i;
	
	        samples = track.samples || [];
	        offset += 8 + 12 + 16 * samples.length;
	
	        bytes = trunHeader(samples, offset);
	
	        for (i = 0; i < samples.length; i++) {
	          sample = samples[i];
	          bytes = bytes.concat([(sample.duration & 0xFF000000) >>> 24, (sample.duration & 0xFF0000) >>> 16, (sample.duration & 0xFF00) >>> 8, sample.duration & 0xFF, // sample_duration
	          (sample.size & 0xFF000000) >>> 24, (sample.size & 0xFF0000) >>> 16, (sample.size & 0xFF00) >>> 8, sample.size & 0xFF, // sample_size
	          sample.flags.isLeading << 2 | sample.flags.dependsOn, sample.flags.isDependedOn << 6 | sample.flags.hasRedundancy << 4 | sample.flags.paddingValue << 1 | sample.flags.isNonSyncSample, sample.flags.degradationPriority & 0xF0 << 8, sample.flags.degradationPriority & 0x0F, // sample_flags
	          (sample.compositionTimeOffset & 0xFF000000) >>> 24, (sample.compositionTimeOffset & 0xFF0000) >>> 16, (sample.compositionTimeOffset & 0xFF00) >>> 8, sample.compositionTimeOffset & 0xFF // sample_composition_time_offset
	          ]);
	        }
	        return box(types.trun, new Uint8Array(bytes));
	      };
	
	      audioTrun = function audioTrun(track, offset) {
	        var bytes, samples, sample, i;
	
	        samples = track.samples || [];
	        offset += 8 + 12 + 8 * samples.length;
	
	        bytes = trunHeader(samples, offset);
	
	        for (i = 0; i < samples.length; i++) {
	          sample = samples[i];
	          bytes = bytes.concat([(sample.duration & 0xFF000000) >>> 24, (sample.duration & 0xFF0000) >>> 16, (sample.duration & 0xFF00) >>> 8, sample.duration & 0xFF, // sample_duration
	          (sample.size & 0xFF000000) >>> 24, (sample.size & 0xFF0000) >>> 16, (sample.size & 0xFF00) >>> 8, sample.size & 0xFF]); // sample_size
	        }
	
	        return box(types.trun, new Uint8Array(bytes));
	      };
	
	      trun = function trun(track, offset) {
	        if (track.type === 'audio') {
	          return audioTrun(track, offset);
	        }
	
	        return videoTrun(track, offset);
	      };
	    })();
	
	    var mp4Generator = {
	      ftyp: ftyp,
	      mdat: mdat,
	      moof: moof,
	      moov: moov,
	      initSegment: function initSegment(tracks) {
	        var fileType = ftyp(),
	            movie = moov(tracks),
	            result;
	
	        result = new Uint8Array(fileType.byteLength + movie.byteLength);
	        result.set(fileType);
	        result.set(movie, fileType.byteLength);
	        return result;
	      }
	    };
	
	    var toUnsigned = function toUnsigned(value) {
	      return value >>> 0;
	    };
	
	    var bin = {
	      toUnsigned: toUnsigned
	    };
	
	    var toUnsigned$1 = bin.toUnsigned;
	    var _findBox, parseType, timescale, startTime, getVideoTrackIds;
	
	    // Find the data for a box specified by its path
	    _findBox = function findBox(data, path) {
	      var results = [],
	          i,
	          size,
	          type,
	          end,
	          subresults;
	
	      if (!path.length) {
	        // short-circuit the search for empty paths
	        return null;
	      }
	
	      for (i = 0; i < data.byteLength;) {
	        size = toUnsigned$1(data[i] << 24 | data[i + 1] << 16 | data[i + 2] << 8 | data[i + 3]);
	
	        type = parseType(data.subarray(i + 4, i + 8));
	
	        end = size > 1 ? i + size : data.byteLength;
	
	        if (type === path[0]) {
	          if (path.length === 1) {
	            // this is the end of the path and we've found the box we were
	            // looking for
	            results.push(data.subarray(i + 8, end));
	          } else {
	            // recursively search for the next box along the path
	            subresults = _findBox(data.subarray(i + 8, end), path.slice(1));
	            if (subresults.length) {
	              results = results.concat(subresults);
	            }
	          }
	        }
	        i = end;
	      }
	
	      // we've finished searching all of data
	      return results;
	    };
	
	    /**
	     * Returns the string representation of an ASCII encoded four byte buffer.
	     * @param buffer {Uint8Array} a four-byte buffer to translate
	     * @return {string} the corresponding string
	     */
	    parseType = function parseType(buffer) {
	      var result = '';
	      result += String.fromCharCode(buffer[0]);
	      result += String.fromCharCode(buffer[1]);
	      result += String.fromCharCode(buffer[2]);
	      result += String.fromCharCode(buffer[3]);
	      return result;
	    };
	
	    /**
	     * Parses an MP4 initialization segment and extracts the timescale
	     * values for any declared tracks. Timescale values indicate the
	     * number of clock ticks per second to assume for time-based values
	     * elsewhere in the MP4.
	     *
	     * To determine the start time of an MP4, you need two pieces of
	     * information: the timescale unit and the earliest base media decode
	     * time. Multiple timescales can be specified within an MP4 but the
	     * base media decode time is always expressed in the timescale from
	     * the media header box for the track:
	     * ```
	     * moov > trak > mdia > mdhd.timescale
	     * ```
	     * @param init {Uint8Array} the bytes of the init segment
	     * @return {object} a hash of track ids to timescale values or null if
	     * the init segment is malformed.
	     */
	    timescale = function timescale(init) {
	      var result = {},
	          traks = _findBox(init, ['moov', 'trak']);
	
	      // mdhd timescale
	      return traks.reduce(function (result, trak) {
	        var tkhd, version, index, id, mdhd;
	
	        tkhd = _findBox(trak, ['tkhd'])[0];
	        if (!tkhd) {
	          return null;
	        }
	        version = tkhd[0];
	        index = version === 0 ? 12 : 20;
	        id = toUnsigned$1(tkhd[index] << 24 | tkhd[index + 1] << 16 | tkhd[index + 2] << 8 | tkhd[index + 3]);
	
	        mdhd = _findBox(trak, ['mdia', 'mdhd'])[0];
	        if (!mdhd) {
	          return null;
	        }
	        version = mdhd[0];
	        index = version === 0 ? 12 : 20;
	        result[id] = toUnsigned$1(mdhd[index] << 24 | mdhd[index + 1] << 16 | mdhd[index + 2] << 8 | mdhd[index + 3]);
	        return result;
	      }, result);
	    };
	
	    /**
	     * Determine the base media decode start time, in seconds, for an MP4
	     * fragment. If multiple fragments are specified, the earliest time is
	     * returned.
	     *
	     * The base media decode time can be parsed from track fragment
	     * metadata:
	     * ```
	     * moof > traf > tfdt.baseMediaDecodeTime
	     * ```
	     * It requires the timescale value from the mdhd to interpret.
	     *
	     * @param timescale {object} a hash of track ids to timescale values.
	     * @return {number} the earliest base media decode start time for the
	     * fragment, in seconds
	     */
	    startTime = function startTime(timescale, fragment) {
	      var trafs, baseTimes, result;
	
	      // we need info from two childrend of each track fragment box
	      trafs = _findBox(fragment, ['moof', 'traf']);
	
	      // determine the start times for each track
	      baseTimes = [].concat.apply([], trafs.map(function (traf) {
	        return _findBox(traf, ['tfhd']).map(function (tfhd) {
	          var id, scale, baseTime;
	
	          // get the track id from the tfhd
	          id = toUnsigned$1(tfhd[4] << 24 | tfhd[5] << 16 | tfhd[6] << 8 | tfhd[7]);
	          // assume a 90kHz clock if no timescale was specified
	          scale = timescale[id] || 90e3;
	
	          // get the base media decode time from the tfdt
	          baseTime = _findBox(traf, ['tfdt']).map(function (tfdt) {
	            var version, result;
	
	            version = tfdt[0];
	            result = toUnsigned$1(tfdt[4] << 24 | tfdt[5] << 16 | tfdt[6] << 8 | tfdt[7]);
	            if (version === 1) {
	              result *= Math.pow(2, 32);
	              result += toUnsigned$1(tfdt[8] << 24 | tfdt[9] << 16 | tfdt[10] << 8 | tfdt[11]);
	            }
	            return result;
	          })[0];
	          baseTime = baseTime || Infinity;
	
	          // convert base time to seconds
	          return baseTime / scale;
	        });
	      }));
	
	      // return the minimum
	      result = Math.min.apply(null, baseTimes);
	      return isFinite(result) ? result : 0;
	    };
	
	    /**
	      * Find the trackIds of the video tracks in this source.
	      * Found by parsing the Handler Reference and Track Header Boxes:
	      *   moov > trak > mdia > hdlr
	      *   moov > trak > tkhd
	      *
	      * @param {Uint8Array} init - The bytes of the init segment for this source
	      * @return {Number[]} A list of trackIds
	      *
	      * @see ISO-BMFF-12/2015, Section 8.4.3
	     **/
	    getVideoTrackIds = function getVideoTrackIds(init) {
	      var traks = _findBox(init, ['moov', 'trak']);
	      var videoTrackIds = [];
	
	      traks.forEach(function (trak) {
	        var hdlrs = _findBox(trak, ['mdia', 'hdlr']);
	        var tkhds = _findBox(trak, ['tkhd']);
	
	        hdlrs.forEach(function (hdlr, index) {
	          var handlerType = parseType(hdlr.subarray(8, 12));
	          var tkhd = tkhds[index];
	          var view;
	          var version;
	          var trackId;
	
	          if (handlerType === 'vide') {
	            view = new DataView(tkhd.buffer, tkhd.byteOffset, tkhd.byteLength);
	            version = view.getUint8(0);
	            trackId = version === 0 ? view.getUint32(12) : view.getUint32(20);
	
	            videoTrackIds.push(trackId);
	          }
	        });
	      });
	
	      return videoTrackIds;
	    };
	
	    var probe = {
	      findBox: _findBox,
	      parseType: parseType,
	      timescale: timescale,
	      startTime: startTime,
	      videoTrackIds: getVideoTrackIds
	    };
	
	    /**
	     * mux.js
	     *
	     * Copyright (c) 2014 Brightcove
	     * All rights reserved.
	     *
	     * A lightweight readable stream implemention that handles event dispatching.
	     * Objects that inherit from streams should call init in their constructors.
	     */
	
	    var Stream = function Stream() {
	      this.init = function () {
	        var listeners = {};
	        /**
	         * Add a listener for a specified event type.
	         * @param type {string} the event name
	         * @param listener {function} the callback to be invoked when an event of
	         * the specified type occurs
	         */
	        this.on = function (type, listener) {
	          if (!listeners[type]) {
	            listeners[type] = [];
	          }
	          listeners[type] = listeners[type].concat(listener);
	        };
	        /**
	         * Remove a listener for a specified event type.
	         * @param type {string} the event name
	         * @param listener {function} a function previously registered for this
	         * type of event through `on`
	         */
	        this.off = function (type, listener) {
	          var index;
	          if (!listeners[type]) {
	            return false;
	          }
	          index = listeners[type].indexOf(listener);
	          listeners[type] = listeners[type].slice();
	          listeners[type].splice(index, 1);
	          return index > -1;
	        };
	        /**
	         * Trigger an event of the specified type on this stream. Any additional
	         * arguments to this function are passed as parameters to event listeners.
	         * @param type {string} the event name
	         */
	        this.trigger = function (type) {
	          var callbacks, i, length, args;
	          callbacks = listeners[type];
	          if (!callbacks) {
	            return;
	          }
	          // Slicing the arguments on every invocation of this method
	          // can add a significant amount of overhead. Avoid the
	          // intermediate object creation for the common case of a
	          // single callback argument
	          if (arguments.length === 2) {
	            length = callbacks.length;
	            for (i = 0; i < length; ++i) {
	              callbacks[i].call(this, arguments[1]);
	            }
	          } else {
	            args = [];
	            i = arguments.length;
	            for (i = 1; i < arguments.length; ++i) {
	              args.push(arguments[i]);
	            }
	            length = callbacks.length;
	            for (i = 0; i < length; ++i) {
	              callbacks[i].apply(this, args);
	            }
	          }
	        };
	        /**
	         * Destroys the stream and cleans up.
	         */
	        this.dispose = function () {
	          listeners = {};
	        };
	      };
	    };
	
	    /**
	     * Forwards all `data` events on this stream to the destination stream. The
	     * destination stream should provide a method `push` to receive the data
	     * events as they arrive.
	     * @param destination {stream} the stream that will receive all `data` events
	     * @param autoFlush {boolean} if false, we will not call `flush` on the destination
	     *                            when the current stream emits a 'done' event
	     * @see http://nodejs.org/api/stream.html#stream_readable_pipe_destination_options
	     */
	    Stream.prototype.pipe = function (destination) {
	      this.on('data', function (data) {
	        destination.push(data);
	      });
	
	      this.on('done', function (flushSource) {
	        destination.flush(flushSource);
	      });
	
	      return destination;
	    };
	
	    // Default stream functions that are expected to be overridden to perform
	    // actual work. These are provided by the prototype as a sort of no-op
	    // implementation so that we don't have to check for their existence in the
	    // `pipe` function above.
	    Stream.prototype.push = function (data) {
	      this.trigger('data', data);
	    };
	
	    Stream.prototype.flush = function (flushSource) {
	      this.trigger('done', flushSource);
	    };
	
	    var stream = Stream;
	
	    // Convert an array of nal units into an array of frames with each frame being
	    // composed of the nal units that make up that frame
	    // Also keep track of cummulative data about the frame from the nal units such
	    // as the frame duration, starting pts, etc.
	    var groupNalsIntoFrames = function groupNalsIntoFrames(nalUnits) {
	      var i,
	          currentNal,
	          currentFrame = [],
	          frames = [];
	
	      currentFrame.byteLength = 0;
	
	      for (i = 0; i < nalUnits.length; i++) {
	        currentNal = nalUnits[i];
	
	        // Split on 'aud'-type nal units
	        if (currentNal.nalUnitType === 'access_unit_delimiter_rbsp') {
	          // Since the very first nal unit is expected to be an AUD
	          // only push to the frames array when currentFrame is not empty
	          if (currentFrame.length) {
	            currentFrame.duration = currentNal.dts - currentFrame.dts;
	            frames.push(currentFrame);
	          }
	          currentFrame = [currentNal];
	          currentFrame.byteLength = currentNal.data.byteLength;
	          currentFrame.pts = currentNal.pts;
	          currentFrame.dts = currentNal.dts;
	        } else {
	          // Specifically flag key frames for ease of use later
	          if (currentNal.nalUnitType === 'slice_layer_without_partitioning_rbsp_idr') {
	            currentFrame.keyFrame = true;
	          }
	          currentFrame.duration = currentNal.dts - currentFrame.dts;
	          currentFrame.byteLength += currentNal.data.byteLength;
	          currentFrame.push(currentNal);
	        }
	      }
	
	      // For the last frame, use the duration of the previous frame if we
	      // have nothing better to go on
	      if (frames.length && (!currentFrame.duration || currentFrame.duration <= 0)) {
	        currentFrame.duration = frames[frames.length - 1].duration;
	      }
	
	      // Push the final frame
	      frames.push(currentFrame);
	      return frames;
	    };
	
	    // Convert an array of frames into an array of Gop with each Gop being composed
	    // of the frames that make up that Gop
	    // Also keep track of cummulative data about the Gop from the frames such as the
	    // Gop duration, starting pts, etc.
	    var groupFramesIntoGops = function groupFramesIntoGops(frames) {
	      var i,
	          currentFrame,
	          currentGop = [],
	          gops = [];
	
	      // We must pre-set some of the values on the Gop since we
	      // keep running totals of these values
	      currentGop.byteLength = 0;
	      currentGop.nalCount = 0;
	      currentGop.duration = 0;
	      currentGop.pts = frames[0].pts;
	      currentGop.dts = frames[0].dts;
	
	      // store some metadata about all the Gops
	      gops.byteLength = 0;
	      gops.nalCount = 0;
	      gops.duration = 0;
	      gops.pts = frames[0].pts;
	      gops.dts = frames[0].dts;
	
	      for (i = 0; i < frames.length; i++) {
	        currentFrame = frames[i];
	
	        if (currentFrame.keyFrame) {
	          // Since the very first frame is expected to be an keyframe
	          // only push to the gops array when currentGop is not empty
	          if (currentGop.length) {
	            gops.push(currentGop);
	            gops.byteLength += currentGop.byteLength;
	            gops.nalCount += currentGop.nalCount;
	            gops.duration += currentGop.duration;
	          }
	
	          currentGop = [currentFrame];
	          currentGop.nalCount = currentFrame.length;
	          currentGop.byteLength = currentFrame.byteLength;
	          currentGop.pts = currentFrame.pts;
	          currentGop.dts = currentFrame.dts;
	          currentGop.duration = currentFrame.duration;
	        } else {
	          currentGop.duration += currentFrame.duration;
	          currentGop.nalCount += currentFrame.length;
	          currentGop.byteLength += currentFrame.byteLength;
	          currentGop.push(currentFrame);
	        }
	      }
	
	      if (gops.length && currentGop.duration <= 0) {
	        currentGop.duration = gops[gops.length - 1].duration;
	      }
	      gops.byteLength += currentGop.byteLength;
	      gops.nalCount += currentGop.nalCount;
	      gops.duration += currentGop.duration;
	
	      // push the final Gop
	      gops.push(currentGop);
	      return gops;
	    };
	
	    /*
	     * Search for the first keyframe in the GOPs and throw away all frames
	     * until that keyframe. Then extend the duration of the pulled keyframe
	     * and pull the PTS and DTS of the keyframe so that it covers the time
	     * range of the frames that were disposed.
	     *
	     * @param {Array} gops video GOPs
	     * @returns {Array} modified video GOPs
	     */
	    var extendFirstKeyFrame = function extendFirstKeyFrame(gops) {
	      var currentGop;
	
	      if (!gops[0][0].keyFrame && gops.length > 1) {
	        // Remove the first GOP
	        currentGop = gops.shift();
	
	        gops.byteLength -= currentGop.byteLength;
	        gops.nalCount -= currentGop.nalCount;
	
	        // Extend the first frame of what is now the
	        // first gop to cover the time period of the
	        // frames we just removed
	        gops[0][0].dts = currentGop.dts;
	        gops[0][0].pts = currentGop.pts;
	        gops[0][0].duration += currentGop.duration;
	      }
	
	      return gops;
	    };
	
	    /**
	     * Default sample object
	     * see ISO/IEC 14496-12:2012, section 8.6.4.3
	     */
	    var createDefaultSample = function createDefaultSample() {
	      return {
	        size: 0,
	        flags: {
	          isLeading: 0,
	          dependsOn: 1,
	          isDependedOn: 0,
	          hasRedundancy: 0,
	          degradationPriority: 0,
	          isNonSyncSample: 1
	        }
	      };
	    };
	
	    /*
	     * Collates information from a video frame into an object for eventual
	     * entry into an MP4 sample table.
	     *
	     * @param {Object} frame the video frame
	     * @param {Number} dataOffset the byte offset to position the sample
	     * @return {Object} object containing sample table info for a frame
	     */
	    var sampleForFrame = function sampleForFrame(frame, dataOffset) {
	      var sample = createDefaultSample();
	
	      sample.dataOffset = dataOffset;
	      sample.compositionTimeOffset = frame.pts - frame.dts;
	      sample.duration = frame.duration;
	      sample.size = 4 * frame.length; // Space for nal unit size
	      sample.size += frame.byteLength;
	
	      if (frame.keyFrame) {
	        sample.flags.dependsOn = 2;
	        sample.flags.isNonSyncSample = 0;
	      }
	
	      return sample;
	    };
	
	    // generate the track's sample table from an array of gops
	    var generateSampleTable = function generateSampleTable(gops, baseDataOffset) {
	      var h,
	          i,
	          sample,
	          currentGop,
	          currentFrame,
	          dataOffset = baseDataOffset || 0,
	          samples = [];
	
	      for (h = 0; h < gops.length; h++) {
	        currentGop = gops[h];
	
	        for (i = 0; i < currentGop.length; i++) {
	          currentFrame = currentGop[i];
	
	          sample = sampleForFrame(currentFrame, dataOffset);
	
	          dataOffset += sample.size;
	
	          samples.push(sample);
	        }
	      }
	      return samples;
	    };
	
	    // generate the track's raw mdat data from an array of gops
	    var concatenateNalData = function concatenateNalData(gops) {
	      var h,
	          i,
	          j,
	          currentGop,
	          currentFrame,
	          currentNal,
	          dataOffset = 0,
	          nalsByteLength = gops.byteLength,
	          numberOfNals = gops.nalCount,
	          totalByteLength = nalsByteLength + 4 * numberOfNals,
	          data = new Uint8Array(totalByteLength),
	          view = new DataView(data.buffer);
	
	      // For each Gop..
	      for (h = 0; h < gops.length; h++) {
	        currentGop = gops[h];
	
	        // For each Frame..
	        for (i = 0; i < currentGop.length; i++) {
	          currentFrame = currentGop[i];
	
	          // For each NAL..
	          for (j = 0; j < currentFrame.length; j++) {
	            currentNal = currentFrame[j];
	
	            view.setUint32(dataOffset, currentNal.data.byteLength);
	            dataOffset += 4;
	            data.set(currentNal.data, dataOffset);
	            dataOffset += currentNal.data.byteLength;
	          }
	        }
	      }
	      return data;
	    };
	
	    var frameUtils = {
	      groupNalsIntoFrames: groupNalsIntoFrames,
	      groupFramesIntoGops: groupFramesIntoGops,
	      extendFirstKeyFrame: extendFirstKeyFrame,
	      generateSampleTable: generateSampleTable,
	      concatenateNalData: concatenateNalData
	    };
	
	    var ONE_SECOND_IN_TS = 90000; // 90kHz clock
	
	    /**
	     * Store information about the start and end of the track and the
	     * duration for each frame/sample we process in order to calculate
	     * the baseMediaDecodeTime
	     */
	    var collectDtsInfo = function collectDtsInfo(track, data) {
	      if (typeof data.pts === 'number') {
	        if (track.timelineStartInfo.pts === undefined) {
	          track.timelineStartInfo.pts = data.pts;
	        }
	
	        if (track.minSegmentPts === undefined) {
	          track.minSegmentPts = data.pts;
	        } else {
	          track.minSegmentPts = Math.min(track.minSegmentPts, data.pts);
	        }
	
	        if (track.maxSegmentPts === undefined) {
	          track.maxSegmentPts = data.pts;
	        } else {
	          track.maxSegmentPts = Math.max(track.maxSegmentPts, data.pts);
	        }
	      }
	
	      if (typeof data.dts === 'number') {
	        if (track.timelineStartInfo.dts === undefined) {
	          track.timelineStartInfo.dts = data.dts;
	        }
	
	        if (track.minSegmentDts === undefined) {
	          track.minSegmentDts = data.dts;
	        } else {
	          track.minSegmentDts = Math.min(track.minSegmentDts, data.dts);
	        }
	
	        if (track.maxSegmentDts === undefined) {
	          track.maxSegmentDts = data.dts;
	        } else {
	          track.maxSegmentDts = Math.max(track.maxSegmentDts, data.dts);
	        }
	      }
	    };
	
	    /**
	     * Clear values used to calculate the baseMediaDecodeTime between
	     * tracks
	     */
	    var clearDtsInfo = function clearDtsInfo(track) {
	      delete track.minSegmentDts;
	      delete track.maxSegmentDts;
	      delete track.minSegmentPts;
	      delete track.maxSegmentPts;
	    };
	
	    /**
	     * Calculate the track's baseMediaDecodeTime based on the earliest
	     * DTS the transmuxer has ever seen and the minimum DTS for the
	     * current track
	     * @param track {object} track metadata configuration
	     * @param keepOriginalTimestamps {boolean} If true, keep the timestamps
	     *        in the source; false to adjust the first segment to start at 0.
	     */
	    var calculateTrackBaseMediaDecodeTime = function calculateTrackBaseMediaDecodeTime(track, keepOriginalTimestamps) {
	      var baseMediaDecodeTime,
	          scale,
	          minSegmentDts = track.minSegmentDts;
	
	      // Optionally adjust the time so the first segment starts at zero.
	      if (!keepOriginalTimestamps) {
	        minSegmentDts -= track.timelineStartInfo.dts;
	      }
	
	      // track.timelineStartInfo.baseMediaDecodeTime is the location, in time, where
	      // we want the start of the first segment to be placed
	      baseMediaDecodeTime = track.timelineStartInfo.baseMediaDecodeTime;
	
	      // Add to that the distance this segment is from the very first
	      baseMediaDecodeTime += minSegmentDts;
	
	      // baseMediaDecodeTime must not become negative
	      baseMediaDecodeTime = Math.max(0, baseMediaDecodeTime);
	
	      if (track.type === 'audio') {
	        // Audio has a different clock equal to the sampling_rate so we need to
	        // scale the PTS values into the clock rate of the track
	        scale = track.samplerate / ONE_SECOND_IN_TS;
	        baseMediaDecodeTime *= scale;
	        baseMediaDecodeTime = Math.floor(baseMediaDecodeTime);
	      }
	
	      return baseMediaDecodeTime;
	    };
	
	    var trackDecodeInfo = {
	      clearDtsInfo: clearDtsInfo,
	      calculateTrackBaseMediaDecodeTime: calculateTrackBaseMediaDecodeTime,
	      collectDtsInfo: collectDtsInfo
	    };
	
	    /**
	     * mux.js
	     *
	     * Copyright (c) 2015 Brightcove
	     * All rights reserved.
	     *
	     * Reads in-band caption information from a video elementary
	     * stream. Captions must follow the CEA-708 standard for injection
	     * into an MPEG-2 transport streams.
	     * @see https://en.wikipedia.org/wiki/CEA-708
	     * @see https://www.gpo.gov/fdsys/pkg/CFR-2007-title47-vol1/pdf/CFR-2007-title47-vol1-sec15-119.pdf
	     */
	
	    // Supplemental enhancement information (SEI) NAL units have a
	    // payload type field to indicate how they are to be
	    // interpreted. CEAS-708 caption content is always transmitted with
	    // payload type 0x04.
	
	    var USER_DATA_REGISTERED_ITU_T_T35 = 4,
	        RBSP_TRAILING_BITS = 128;
	
	    /**
	      * Parse a supplemental enhancement information (SEI) NAL unit.
	      * Stops parsing once a message of type ITU T T35 has been found.
	      *
	      * @param bytes {Uint8Array} the bytes of a SEI NAL unit
	      * @return {object} the parsed SEI payload
	      * @see Rec. ITU-T H.264, 7.3.2.3.1
	      */
	    var parseSei = function parseSei(bytes) {
	      var i = 0,
	          result = {
	        payloadType: -1,
	        payloadSize: 0
	      },
	          payloadType = 0,
	          payloadSize = 0;
	
	      // go through the sei_rbsp parsing each each individual sei_message
	      while (i < bytes.byteLength) {
	        // stop once we have hit the end of the sei_rbsp
	        if (bytes[i] === RBSP_TRAILING_BITS) {
	          break;
	        }
	
	        // Parse payload type
	        while (bytes[i] === 0xFF) {
	          payloadType += 255;
	          i++;
	        }
	        payloadType += bytes[i++];
	
	        // Parse payload size
	        while (bytes[i] === 0xFF) {
	          payloadSize += 255;
	          i++;
	        }
	        payloadSize += bytes[i++];
	
	        // this sei_message is a 608/708 caption so save it and break
	        // there can only ever be one caption message in a frame's sei
	        if (!result.payload && payloadType === USER_DATA_REGISTERED_ITU_T_T35) {
	          result.payloadType = payloadType;
	          result.payloadSize = payloadSize;
	          result.payload = bytes.subarray(i, i + payloadSize);
	          break;
	        }
	
	        // skip the payload and parse the next message
	        i += payloadSize;
	        payloadType = 0;
	        payloadSize = 0;
	      }
	
	      return result;
	    };
	
	    // see ANSI/SCTE 128-1 (2013), section 8.1
	    var parseUserData = function parseUserData(sei) {
	      // itu_t_t35_contry_code must be 181 (United States) for
	      // captions
	      if (sei.payload[0] !== 181) {
	        return null;
	      }
	
	      // itu_t_t35_provider_code should be 49 (ATSC) for captions
	      if ((sei.payload[1] << 8 | sei.payload[2]) !== 49) {
	        return null;
	      }
	
	      // the user_identifier should be "GA94" to indicate ATSC1 data
	      if (String.fromCharCode(sei.payload[3], sei.payload[4], sei.payload[5], sei.payload[6]) !== 'GA94') {
	        return null;
	      }
	
	      // finally, user_data_type_code should be 0x03 for caption data
	      if (sei.payload[7] !== 0x03) {
	        return null;
	      }
	
	      // return the user_data_type_structure and strip the trailing
	      // marker bits
	      return sei.payload.subarray(8, sei.payload.length - 1);
	    };
	
	    // see CEA-708-D, section 4.4
	    var parseCaptionPackets = function parseCaptionPackets(pts, userData) {
	      var results = [],
	          i,
	          count,
	          offset,
	          data;
	
	      // if this is just filler, return immediately
	      if (!(userData[0] & 0x40)) {
	        return results;
	      }
	
	      // parse out the cc_data_1 and cc_data_2 fields
	      count = userData[0] & 0x1f;
	      for (i = 0; i < count; i++) {
	        offset = i * 3;
	        data = {
	          type: userData[offset + 2] & 0x03,
	          pts: pts
	        };
	
	        // capture cc data when cc_valid is 1
	        if (userData[offset + 2] & 0x04) {
	          data.ccData = userData[offset + 3] << 8 | userData[offset + 4];
	          results.push(data);
	        }
	      }
	      return results;
	    };
	
	    var discardEmulationPreventionBytes = function discardEmulationPreventionBytes(data) {
	      var length = data.byteLength,
	          emulationPreventionBytesPositions = [],
	          i = 1,
	          newLength,
	          newData;
	
	      // Find all `Emulation Prevention Bytes`
	      while (i < length - 2) {
	        if (data[i] === 0 && data[i + 1] === 0 && data[i + 2] === 0x03) {
	          emulationPreventionBytesPositions.push(i + 2);
	          i += 2;
	        } else {
	          i++;
	        }
	      }
	
	      // If no Emulation Prevention Bytes were found just return the original
	      // array
	      if (emulationPreventionBytesPositions.length === 0) {
	        return data;
	      }
	
	      // Create a new array to hold the NAL unit data
	      newLength = length - emulationPreventionBytesPositions.length;
	      newData = new Uint8Array(newLength);
	      var sourceIndex = 0;
	
	      for (i = 0; i < newLength; sourceIndex++, i++) {
	        if (sourceIndex === emulationPreventionBytesPositions[0]) {
	          // Skip this byte
	          sourceIndex++;
	          // Remove this position index
	          emulationPreventionBytesPositions.shift();
	        }
	        newData[i] = data[sourceIndex];
	      }
	
	      return newData;
	    };
	
	    // exports
	    var captionPacketParser = {
	      parseSei: parseSei,
	      parseUserData: parseUserData,
	      parseCaptionPackets: parseCaptionPackets,
	      discardEmulationPreventionBytes: discardEmulationPreventionBytes,
	      USER_DATA_REGISTERED_ITU_T_T35: USER_DATA_REGISTERED_ITU_T_T35
	    };
	
	    // -----------------
	    // Link To Transport
	    // -----------------
	
	
	    var CaptionStream = function CaptionStream() {
	
	      CaptionStream.prototype.init.call(this);
	
	      this.captionPackets_ = [];
	
	      this.ccStreams_ = [new Cea608Stream(0, 0), // eslint-disable-line no-use-before-define
	      new Cea608Stream(0, 1), // eslint-disable-line no-use-before-define
	      new Cea608Stream(1, 0), // eslint-disable-line no-use-before-define
	      new Cea608Stream(1, 1) // eslint-disable-line no-use-before-define
	      ];
	
	      this.reset();
	
	      // forward data and done events from CCs to this CaptionStream
	      this.ccStreams_.forEach(function (cc) {
	        cc.on('data', this.trigger.bind(this, 'data'));
	        cc.on('done', this.trigger.bind(this, 'done'));
	      }, this);
	    };
	
	    CaptionStream.prototype = new stream();
	    CaptionStream.prototype.push = function (event) {
	      var sei, userData, newCaptionPackets;
	
	      // only examine SEI NALs
	      if (event.nalUnitType !== 'sei_rbsp') {
	        return;
	      }
	
	      // parse the sei
	      sei = captionPacketParser.parseSei(event.escapedRBSP);
	
	      // ignore everything but user_data_registered_itu_t_t35
	      if (sei.payloadType !== captionPacketParser.USER_DATA_REGISTERED_ITU_T_T35) {
	        return;
	      }
	
	      // parse out the user data payload
	      userData = captionPacketParser.parseUserData(sei);
	
	      // ignore unrecognized userData
	      if (!userData) {
	        return;
	      }
	
	      // Sometimes, the same segment # will be downloaded twice. To stop the
	      // caption data from being processed twice, we track the latest dts we've
	      // received and ignore everything with a dts before that. However, since
	      // data for a specific dts can be split across packets on either side of
	      // a segment boundary, we need to make sure we *don't* ignore the packets
	      // from the *next* segment that have dts === this.latestDts_. By constantly
	      // tracking the number of packets received with dts === this.latestDts_, we
	      // know how many should be ignored once we start receiving duplicates.
	      if (event.dts < this.latestDts_) {
	        // We've started getting older data, so set the flag.
	        this.ignoreNextEqualDts_ = true;
	        return;
	      } else if (event.dts === this.latestDts_ && this.ignoreNextEqualDts_) {
	        this.numSameDts_--;
	        if (!this.numSameDts_) {
	          // We've received the last duplicate packet, time to start processing again
	          this.ignoreNextEqualDts_ = false;
	        }
	        return;
	      }
	
	      // parse out CC data packets and save them for later
	      newCaptionPackets = captionPacketParser.parseCaptionPackets(event.pts, userData);
	      this.captionPackets_ = this.captionPackets_.concat(newCaptionPackets);
	      if (this.latestDts_ !== event.dts) {
	        this.numSameDts_ = 0;
	      }
	      this.numSameDts_++;
	      this.latestDts_ = event.dts;
	    };
	
	    CaptionStream.prototype.flush = function () {
	      // make sure we actually parsed captions before proceeding
	      if (!this.captionPackets_.length) {
	        this.ccStreams_.forEach(function (cc) {
	          cc.flush();
	        }, this);
	        return;
	      }
	
	      // In Chrome, the Array#sort function is not stable so add a
	      // presortIndex that we can use to ensure we get a stable-sort
	      this.captionPackets_.forEach(function (elem, idx) {
	        elem.presortIndex = idx;
	      });
	
	      // sort caption byte-pairs based on their PTS values
	      this.captionPackets_.sort(function (a, b) {
	        if (a.pts === b.pts) {
	          return a.presortIndex - b.presortIndex;
	        }
	        return a.pts - b.pts;
	      });
	
	      this.captionPackets_.forEach(function (packet) {
	        if (packet.type < 2) {
	          // Dispatch packet to the right Cea608Stream
	          this.dispatchCea608Packet(packet);
	        }
	        // this is where an 'else' would go for a dispatching packets
	        // to a theoretical Cea708Stream that handles SERVICEn data
	      }, this);
	
	      this.captionPackets_.length = 0;
	      this.ccStreams_.forEach(function (cc) {
	        cc.flush();
	      }, this);
	      return;
	    };
	
	    CaptionStream.prototype.reset = function () {
	      this.latestDts_ = null;
	      this.ignoreNextEqualDts_ = false;
	      this.numSameDts_ = 0;
	      this.activeCea608Channel_ = [null, null];
	      this.ccStreams_.forEach(function (ccStream) {
	        ccStream.reset();
	      });
	    };
	
	    CaptionStream.prototype.dispatchCea608Packet = function (packet) {
	      // NOTE: packet.type is the CEA608 field
	      if (this.setsChannel1Active(packet)) {
	        this.activeCea608Channel_[packet.type] = 0;
	      } else if (this.setsChannel2Active(packet)) {
	        this.activeCea608Channel_[packet.type] = 1;
	      }
	      if (this.activeCea608Channel_[packet.type] === null) {
	        // If we haven't received anything to set the active channel, discard the
	        // data; we don't want jumbled captions
	        return;
	      }
	      this.ccStreams_[(packet.type << 1) + this.activeCea608Channel_[packet.type]].push(packet);
	    };
	
	    CaptionStream.prototype.setsChannel1Active = function (packet) {
	      return (packet.ccData & 0x7800) === 0x1000;
	    };
	    CaptionStream.prototype.setsChannel2Active = function (packet) {
	      return (packet.ccData & 0x7800) === 0x1800;
	    };
	
	    // ----------------------
	    // Session to Application
	    // ----------------------
	
	    // This hash maps non-ASCII, special, and extended character codes to their
	    // proper Unicode equivalent. The first keys that are only a single byte
	    // are the non-standard ASCII characters, which simply map the CEA608 byte
	    // to the standard ASCII/Unicode. The two-byte keys that follow are the CEA608
	    // character codes, but have their MSB bitmasked with 0x03 so that a lookup
	    // can be performed regardless of the field and data channel on which the
	    // character code was received.
	    var CHARACTER_TRANSLATION = {
	      0x2a: 0xe1, // á
	      0x5c: 0xe9, // é
	      0x5e: 0xed, // í
	      0x5f: 0xf3, // ó
	      0x60: 0xfa, // ú
	      0x7b: 0xe7, // ç
	      0x7c: 0xf7, // ÷
	      0x7d: 0xd1, // Ñ
	      0x7e: 0xf1, // ñ
	      0x7f: 0x2588, // █
	      0x0130: 0xae, // ®
	      0x0131: 0xb0, // °
	      0x0132: 0xbd, // ½
	      0x0133: 0xbf, // ¿
	      0x0134: 0x2122, // ™
	      0x0135: 0xa2, // ¢
	      0x0136: 0xa3, // £
	      0x0137: 0x266a, // ♪
	      0x0138: 0xe0, // à
	      0x0139: 0xa0, //
	      0x013a: 0xe8, // è
	      0x013b: 0xe2, // â
	      0x013c: 0xea, // ê
	      0x013d: 0xee, // î
	      0x013e: 0xf4, // ô
	      0x013f: 0xfb, // û
	      0x0220: 0xc1, // Á
	      0x0221: 0xc9, // É
	      0x0222: 0xd3, // Ó
	      0x0223: 0xda, // Ú
	      0x0224: 0xdc, // Ü
	      0x0225: 0xfc, // ü
	      0x0226: 0x2018, // ‘
	      0x0227: 0xa1, // ¡
	      0x0228: 0x2a, // *
	      0x0229: 0x27, // '
	      0x022a: 0x2014, // —
	      0x022b: 0xa9, // ©
	      0x022c: 0x2120, // ℠
	      0x022d: 0x2022, // •
	      0x022e: 0x201c, // “
	      0x022f: 0x201d, // ”
	      0x0230: 0xc0, // À
	      0x0231: 0xc2, // Â
	      0x0232: 0xc7, // Ç
	      0x0233: 0xc8, // È
	      0x0234: 0xca, // Ê
	      0x0235: 0xcb, // Ë
	      0x0236: 0xeb, // ë
	      0x0237: 0xce, // Î
	      0x0238: 0xcf, // Ï
	      0x0239: 0xef, // ï
	      0x023a: 0xd4, // Ô
	      0x023b: 0xd9, // Ù
	      0x023c: 0xf9, // ù
	      0x023d: 0xdb, // Û
	      0x023e: 0xab, // «
	      0x023f: 0xbb, // »
	      0x0320: 0xc3, // Ã
	      0x0321: 0xe3, // ã
	      0x0322: 0xcd, // Í
	      0x0323: 0xcc, // Ì
	      0x0324: 0xec, // ì
	      0x0325: 0xd2, // Ò
	      0x0326: 0xf2, // ò
	      0x0327: 0xd5, // Õ
	      0x0328: 0xf5, // õ
	      0x0329: 0x7b, // {
	      0x032a: 0x7d, // }
	      0x032b: 0x5c, // \
	      0x032c: 0x5e, // ^
	      0x032d: 0x5f, // _
	      0x032e: 0x7c, // |
	      0x032f: 0x7e, // ~
	      0x0330: 0xc4, // Ä
	      0x0331: 0xe4, // ä
	      0x0332: 0xd6, // Ö
	      0x0333: 0xf6, // ö
	      0x0334: 0xdf, // ß
	      0x0335: 0xa5, // ¥
	      0x0336: 0xa4, // ¤
	      0x0337: 0x2502, // │
	      0x0338: 0xc5, // Å
	      0x0339: 0xe5, // å
	      0x033a: 0xd8, // Ø
	      0x033b: 0xf8, // ø
	      0x033c: 0x250c, // ┌
	      0x033d: 0x2510, // ┐
	      0x033e: 0x2514, // └
	      0x033f: 0x2518 // ┘
	    };
	
	    var getCharFromCode = function getCharFromCode(code) {
	      if (code === null) {
	        return '';
	      }
	      code = CHARACTER_TRANSLATION[code] || code;
	      return String.fromCharCode(code);
	    };
	
	    // the index of the last row in a CEA-608 display buffer
	    var BOTTOM_ROW = 14;
	
	    // This array is used for mapping PACs -> row #, since there's no way of
	    // getting it through bit logic.
	    var ROWS = [0x1100, 0x1120, 0x1200, 0x1220, 0x1500, 0x1520, 0x1600, 0x1620, 0x1700, 0x1720, 0x1000, 0x1300, 0x1320, 0x1400, 0x1420];
	
	    // CEA-608 captions are rendered onto a 34x15 matrix of character
	    // cells. The "bottom" row is the last element in the outer array.
	    var createDisplayBuffer = function createDisplayBuffer() {
	      var result = [],
	          i = BOTTOM_ROW + 1;
	      while (i--) {
	        result.push('');
	      }
	      return result;
	    };
	
	    var Cea608Stream = function Cea608Stream(field, dataChannel) {
	      Cea608Stream.prototype.init.call(this);
	
	      this.field_ = field || 0;
	      this.dataChannel_ = dataChannel || 0;
	
	      this.name_ = 'CC' + ((this.field_ << 1 | this.dataChannel_) + 1);
	
	      this.setConstants();
	      this.reset();
	
	      this.push = function (packet) {
	        var data, swap, char0, char1, text;
	        // remove the parity bits
	        data = packet.ccData & 0x7f7f;
	
	        // ignore duplicate control codes; the spec demands they're sent twice
	        if (data === this.lastControlCode_) {
	          this.lastControlCode_ = null;
	          return;
	        }
	
	        // Store control codes
	        if ((data & 0xf000) === 0x1000) {
	          this.lastControlCode_ = data;
	        } else if (data !== this.PADDING_) {
	          this.lastControlCode_ = null;
	        }
	
	        char0 = data >>> 8;
	        char1 = data & 0xff;
	
	        if (data === this.PADDING_) {
	          return;
	        } else if (data === this.RESUME_CAPTION_LOADING_) {
	          this.mode_ = 'popOn';
	        } else if (data === this.END_OF_CAPTION_) {
	          // If an EOC is received while in paint-on mode, the displayed caption
	          // text should be swapped to non-displayed memory as if it was a pop-on
	          // caption. Because of that, we should explicitly switch back to pop-on
	          // mode
	          this.mode_ = 'popOn';
	          this.clearFormatting(packet.pts);
	          // if a caption was being displayed, it's gone now
	          this.flushDisplayed(packet.pts);
	
	          // flip memory
	          swap = this.displayed_;
	          this.displayed_ = this.nonDisplayed_;
	          this.nonDisplayed_ = swap;
	
	          // start measuring the time to display the caption
	          this.startPts_ = packet.pts;
	        } else if (data === this.ROLL_UP_2_ROWS_) {
	          this.rollUpRows_ = 2;
	          this.setRollUp(packet.pts);
	        } else if (data === this.ROLL_UP_3_ROWS_) {
	          this.rollUpRows_ = 3;
	          this.setRollUp(packet.pts);
	        } else if (data === this.ROLL_UP_4_ROWS_) {
	          this.rollUpRows_ = 4;
	          this.setRollUp(packet.pts);
	        } else if (data === this.CARRIAGE_RETURN_) {
	          this.clearFormatting(packet.pts);
	          this.flushDisplayed(packet.pts);
	          this.shiftRowsUp_();
	          this.startPts_ = packet.pts;
	        } else if (data === this.BACKSPACE_) {
	          if (this.mode_ === 'popOn') {
	            this.nonDisplayed_[this.row_] = this.nonDisplayed_[this.row_].slice(0, -1);
	          } else {
	            this.displayed_[this.row_] = this.displayed_[this.row_].slice(0, -1);
	          }
	        } else if (data === this.ERASE_DISPLAYED_MEMORY_) {
	          this.flushDisplayed(packet.pts);
	          this.displayed_ = createDisplayBuffer();
	        } else if (data === this.ERASE_NON_DISPLAYED_MEMORY_) {
	          this.nonDisplayed_ = createDisplayBuffer();
	        } else if (data === this.RESUME_DIRECT_CAPTIONING_) {
	          if (this.mode_ !== 'paintOn') {
	            // NOTE: This should be removed when proper caption positioning is
	            // implemented
	            this.flushDisplayed(packet.pts);
	            this.displayed_ = createDisplayBuffer();
	          }
	          this.mode_ = 'paintOn';
	          this.startPts_ = packet.pts;
	
	          // Append special characters to caption text
	        } else if (this.isSpecialCharacter(char0, char1)) {
	          // Bitmask char0 so that we can apply character transformations
	          // regardless of field and data channel.
	          // Then byte-shift to the left and OR with char1 so we can pass the
	          // entire character code to `getCharFromCode`.
	          char0 = (char0 & 0x03) << 8;
	          text = getCharFromCode(char0 | char1);
	          this[this.mode_](packet.pts, text);
	          this.column_++;
	
	          // Append extended characters to caption text
	        } else if (this.isExtCharacter(char0, char1)) {
	          // Extended characters always follow their "non-extended" equivalents.
	          // IE if a "è" is desired, you'll always receive "eè"; non-compliant
	          // decoders are supposed to drop the "è", while compliant decoders
	          // backspace the "e" and insert "è".
	
	          // Delete the previous character
	          if (this.mode_ === 'popOn') {
	            this.nonDisplayed_[this.row_] = this.nonDisplayed_[this.row_].slice(0, -1);
	          } else {
	            this.displayed_[this.row_] = this.displayed_[this.row_].slice(0, -1);
	          }
	
	          // Bitmask char0 so that we can apply character transformations
	          // regardless of field and data channel.
	          // Then byte-shift to the left and OR with char1 so we can pass the
	          // entire character code to `getCharFromCode`.
	          char0 = (char0 & 0x03) << 8;
	          text = getCharFromCode(char0 | char1);
	          this[this.mode_](packet.pts, text);
	          this.column_++;
	
	          // Process mid-row codes
	        } else if (this.isMidRowCode(char0, char1)) {
	          // Attributes are not additive, so clear all formatting
	          this.clearFormatting(packet.pts);
	
	          // According to the standard, mid-row codes
	          // should be replaced with spaces, so add one now
	          this[this.mode_](packet.pts, ' ');
	          this.column_++;
	
	          if ((char1 & 0xe) === 0xe) {
	            this.addFormatting(packet.pts, ['i']);
	          }
	
	          if ((char1 & 0x1) === 0x1) {
	            this.addFormatting(packet.pts, ['u']);
	          }
	
	          // Detect offset control codes and adjust cursor
	        } else if (this.isOffsetControlCode(char0, char1)) {
	          // Cursor position is set by indent PAC (see below) in 4-column
	          // increments, with an additional offset code of 1-3 to reach any
	          // of the 32 columns specified by CEA-608. So all we need to do
	          // here is increment the column cursor by the given offset.
	          this.column_ += char1 & 0x03;
	
	          // Detect PACs (Preamble Address Codes)
	        } else if (this.isPAC(char0, char1)) {
	
	          // There's no logic for PAC -> row mapping, so we have to just
	          // find the row code in an array and use its index :(
	          var row = ROWS.indexOf(data & 0x1f20);
	
	          // Configure the caption window if we're in roll-up mode
	          if (this.mode_ === 'rollUp') {
	            this.setRollUp(packet.pts, row);
	          }
	
	          if (row !== this.row_) {
	            // formatting is only persistent for current row
	            this.clearFormatting(packet.pts);
	            this.row_ = row;
	          }
	          // All PACs can apply underline, so detect and apply
	          // (All odd-numbered second bytes set underline)
	          if (char1 & 0x1 && this.formatting_.indexOf('u') === -1) {
	            this.addFormatting(packet.pts, ['u']);
	          }
	
	          if ((data & 0x10) === 0x10) {
	            // We've got an indent level code. Each successive even number
	            // increments the column cursor by 4, so we can get the desired
	            // column position by bit-shifting to the right (to get n/2)
	            // and multiplying by 4.
	            this.column_ = ((data & 0xe) >> 1) * 4;
	          }
	
	          if (this.isColorPAC(char1)) {
	            // it's a color code, though we only support white, which
	            // can be either normal or italicized. white italics can be
	            // either 0x4e or 0x6e depending on the row, so we just
	            // bitwise-and with 0xe to see if italics should be turned on
	            if ((char1 & 0xe) === 0xe) {
	              this.addFormatting(packet.pts, ['i']);
	            }
	          }
	
	          // We have a normal character in char0, and possibly one in char1
	        } else if (this.isNormalChar(char0)) {
	          if (char1 === 0x00) {
	            char1 = null;
	          }
	          text = getCharFromCode(char0);
	          text += getCharFromCode(char1);
	          this[this.mode_](packet.pts, text);
	          this.column_ += text.length;
	        } // finish data processing
	      };
	    };
	    Cea608Stream.prototype = new stream();
	    // Trigger a cue point that captures the current state of the
	    // display buffer
	    Cea608Stream.prototype.flushDisplayed = function (pts) {
	      var content = this.displayed_
	      // remove spaces from the start and end of the string
	      .map(function (row) {
	        return row.trim();
	      })
	      // combine all text rows to display in one cue
	      .join('\n')
	      // and remove blank rows from the start and end, but not the middle
	      .replace(/^\n+|\n+$/g, '');
	
	      if (content.length) {
	        this.trigger('data', {
	          startPts: this.startPts_,
	          endPts: pts,
	          text: content,
	          stream: this.name_
	        });
	      }
	    };
	
	    /**
	     * Zero out the data, used for startup and on seek
	     */
	    Cea608Stream.prototype.reset = function () {
	      this.mode_ = 'popOn';
	      // When in roll-up mode, the index of the last row that will
	      // actually display captions. If a caption is shifted to a row
	      // with a lower index than this, it is cleared from the display
	      // buffer
	      this.topRow_ = 0;
	      this.startPts_ = 0;
	      this.displayed_ = createDisplayBuffer();
	      this.nonDisplayed_ = createDisplayBuffer();
	      this.lastControlCode_ = null;
	
	      // Track row and column for proper line-breaking and spacing
	      this.column_ = 0;
	      this.row_ = BOTTOM_ROW;
	      this.rollUpRows_ = 2;
	
	      // This variable holds currently-applied formatting
	      this.formatting_ = [];
	    };
	
	    /**
	     * Sets up control code and related constants for this instance
	     */
	    Cea608Stream.prototype.setConstants = function () {
	      // The following attributes have these uses:
	      // ext_ :    char0 for mid-row codes, and the base for extended
	      //           chars (ext_+0, ext_+1, and ext_+2 are char0s for
	      //           extended codes)
	      // control_: char0 for control codes, except byte-shifted to the
	      //           left so that we can do this.control_ | CONTROL_CODE
	      // offset_:  char0 for tab offset codes
	      //
	      // It's also worth noting that control codes, and _only_ control codes,
	      // differ between field 1 and field2. Field 2 control codes are always
	      // their field 1 value plus 1. That's why there's the "| field" on the
	      // control value.
	      if (this.dataChannel_ === 0) {
	        this.BASE_ = 0x10;
	        this.EXT_ = 0x11;
	        this.CONTROL_ = (0x14 | this.field_) << 8;
	        this.OFFSET_ = 0x17;
	      } else if (this.dataChannel_ === 1) {
	        this.BASE_ = 0x18;
	        this.EXT_ = 0x19;
	        this.CONTROL_ = (0x1c | this.field_) << 8;
	        this.OFFSET_ = 0x1f;
	      }
	
	      // Constants for the LSByte command codes recognized by Cea608Stream. This
	      // list is not exhaustive. For a more comprehensive listing and semantics see
	      // http://www.gpo.gov/fdsys/pkg/CFR-2010-title47-vol1/pdf/CFR-2010-title47-vol1-sec15-119.pdf
	      // Padding
	      this.PADDING_ = 0x0000;
	      // Pop-on Mode
	      this.RESUME_CAPTION_LOADING_ = this.CONTROL_ | 0x20;
	      this.END_OF_CAPTION_ = this.CONTROL_ | 0x2f;
	      // Roll-up Mode
	      this.ROLL_UP_2_ROWS_ = this.CONTROL_ | 0x25;
	      this.ROLL_UP_3_ROWS_ = this.CONTROL_ | 0x26;
	      this.ROLL_UP_4_ROWS_ = this.CONTROL_ | 0x27;
	      this.CARRIAGE_RETURN_ = this.CONTROL_ | 0x2d;
	      // paint-on mode
	      this.RESUME_DIRECT_CAPTIONING_ = this.CONTROL_ | 0x29;
	      // Erasure
	      this.BACKSPACE_ = this.CONTROL_ | 0x21;
	      this.ERASE_DISPLAYED_MEMORY_ = this.CONTROL_ | 0x2c;
	      this.ERASE_NON_DISPLAYED_MEMORY_ = this.CONTROL_ | 0x2e;
	    };
	
	    /**
	     * Detects if the 2-byte packet data is a special character
	     *
	     * Special characters have a second byte in the range 0x30 to 0x3f,
	     * with the first byte being 0x11 (for data channel 1) or 0x19 (for
	     * data channel 2).
	     *
	     * @param  {Integer} char0 The first byte
	     * @param  {Integer} char1 The second byte
	     * @return {Boolean}       Whether the 2 bytes are an special character
	     */
	    Cea608Stream.prototype.isSpecialCharacter = function (char0, char1) {
	      return char0 === this.EXT_ && char1 >= 0x30 && char1 <= 0x3f;
	    };
	
	    /**
	     * Detects if the 2-byte packet data is an extended character
	     *
	     * Extended characters have a second byte in the range 0x20 to 0x3f,
	     * with the first byte being 0x12 or 0x13 (for data channel 1) or
	     * 0x1a or 0x1b (for data channel 2).
	     *
	     * @param  {Integer} char0 The first byte
	     * @param  {Integer} char1 The second byte
	     * @return {Boolean}       Whether the 2 bytes are an extended character
	     */
	    Cea608Stream.prototype.isExtCharacter = function (char0, char1) {
	      return (char0 === this.EXT_ + 1 || char0 === this.EXT_ + 2) && char1 >= 0x20 && char1 <= 0x3f;
	    };
	
	    /**
	     * Detects if the 2-byte packet is a mid-row code
	     *
	     * Mid-row codes have a second byte in the range 0x20 to 0x2f, with
	     * the first byte being 0x11 (for data channel 1) or 0x19 (for data
	     * channel 2).
	     *
	     * @param  {Integer} char0 The first byte
	     * @param  {Integer} char1 The second byte
	     * @return {Boolean}       Whether the 2 bytes are a mid-row code
	     */
	    Cea608Stream.prototype.isMidRowCode = function (char0, char1) {
	      return char0 === this.EXT_ && char1 >= 0x20 && char1 <= 0x2f;
	    };
	
	    /**
	     * Detects if the 2-byte packet is an offset control code
	     *
	     * Offset control codes have a second byte in the range 0x21 to 0x23,
	     * with the first byte being 0x17 (for data channel 1) or 0x1f (for
	     * data channel 2).
	     *
	     * @param  {Integer} char0 The first byte
	     * @param  {Integer} char1 The second byte
	     * @return {Boolean}       Whether the 2 bytes are an offset control code
	     */
	    Cea608Stream.prototype.isOffsetControlCode = function (char0, char1) {
	      return char0 === this.OFFSET_ && char1 >= 0x21 && char1 <= 0x23;
	    };
	
	    /**
	     * Detects if the 2-byte packet is a Preamble Address Code
	     *
	     * PACs have a first byte in the range 0x10 to 0x17 (for data channel 1)
	     * or 0x18 to 0x1f (for data channel 2), with the second byte in the
	     * range 0x40 to 0x7f.
	     *
	     * @param  {Integer} char0 The first byte
	     * @param  {Integer} char1 The second byte
	     * @return {Boolean}       Whether the 2 bytes are a PAC
	     */
	    Cea608Stream.prototype.isPAC = function (char0, char1) {
	      return char0 >= this.BASE_ && char0 < this.BASE_ + 8 && char1 >= 0x40 && char1 <= 0x7f;
	    };
	
	    /**
	     * Detects if a packet's second byte is in the range of a PAC color code
	     *
	     * PAC color codes have the second byte be in the range 0x40 to 0x4f, or
	     * 0x60 to 0x6f.
	     *
	     * @param  {Integer} char1 The second byte
	     * @return {Boolean}       Whether the byte is a color PAC
	     */
	    Cea608Stream.prototype.isColorPAC = function (char1) {
	      return char1 >= 0x40 && char1 <= 0x4f || char1 >= 0x60 && char1 <= 0x7f;
	    };
	
	    /**
	     * Detects if a single byte is in the range of a normal character
	     *
	     * Normal text bytes are in the range 0x20 to 0x7f.
	     *
	     * @param  {Integer} char  The byte
	     * @return {Boolean}       Whether the byte is a normal character
	     */
	    Cea608Stream.prototype.isNormalChar = function (char) {
	      return char >= 0x20 && char <= 0x7f;
	    };
	
	    /**
	     * Configures roll-up
	     *
	     * @param  {Integer} pts         Current PTS
	     * @param  {Integer} newBaseRow  Used by PACs to slide the current window to
	     *                               a new position
	     */
	    Cea608Stream.prototype.setRollUp = function (pts, newBaseRow) {
	      // Reset the base row to the bottom row when switching modes
	      if (this.mode_ !== 'rollUp') {
	        this.row_ = BOTTOM_ROW;
	        this.mode_ = 'rollUp';
	        // Spec says to wipe memories when switching to roll-up
	        this.flushDisplayed(pts);
	        this.nonDisplayed_ = createDisplayBuffer();
	        this.displayed_ = createDisplayBuffer();
	      }
	
	      if (newBaseRow !== undefined && newBaseRow !== this.row_) {
	        // move currently displayed captions (up or down) to the new base row
	        for (var i = 0; i < this.rollUpRows_; i++) {
	          this.displayed_[newBaseRow - i] = this.displayed_[this.row_ - i];
	          this.displayed_[this.row_ - i] = '';
	        }
	      }
	
	      if (newBaseRow === undefined) {
	        newBaseRow = this.row_;
	      }
	      this.topRow_ = newBaseRow - this.rollUpRows_ + 1;
	    };
	
	    // Adds the opening HTML tag for the passed character to the caption text,
	    // and keeps track of it for later closing
	    Cea608Stream.prototype.addFormatting = function (pts, format) {
	      this.formatting_ = this.formatting_.concat(format);
	      var text = format.reduce(function (text, format) {
	        return text + '<' + format + '>';
	      }, '');
	      this[this.mode_](pts, text);
	    };
	
	    // Adds HTML closing tags for current formatting to caption text and
	    // clears remembered formatting
	    Cea608Stream.prototype.clearFormatting = function (pts) {
	      if (!this.formatting_.length) {
	        return;
	      }
	      var text = this.formatting_.reverse().reduce(function (text, format) {
	        return text + '</' + format + '>';
	      }, '');
	      this.formatting_ = [];
	      this[this.mode_](pts, text);
	    };
	
	    // Mode Implementations
	    Cea608Stream.prototype.popOn = function (pts, text) {
	      var baseRow = this.nonDisplayed_[this.row_];
	
	      // buffer characters
	      baseRow += text;
	      this.nonDisplayed_[this.row_] = baseRow;
	    };
	
	    Cea608Stream.prototype.rollUp = function (pts, text) {
	      var baseRow = this.displayed_[this.row_];
	
	      baseRow += text;
	      this.displayed_[this.row_] = baseRow;
	    };
	
	    Cea608Stream.prototype.shiftRowsUp_ = function () {
	      var i;
	      // clear out inactive rows
	      for (i = 0; i < this.topRow_; i++) {
	        this.displayed_[i] = '';
	      }
	      for (i = this.row_ + 1; i < BOTTOM_ROW + 1; i++) {
	        this.displayed_[i] = '';
	      }
	      // shift displayed rows up
	      for (i = this.topRow_; i < this.row_; i++) {
	        this.displayed_[i] = this.displayed_[i + 1];
	      }
	      // clear out the bottom row
	      this.displayed_[this.row_] = '';
	    };
	
	    Cea608Stream.prototype.paintOn = function (pts, text) {
	      var baseRow = this.displayed_[this.row_];
	
	      baseRow += text;
	      this.displayed_[this.row_] = baseRow;
	    };
	
	    // exports
	    var captionStream = {
	      CaptionStream: CaptionStream,
	      Cea608Stream: Cea608Stream
	    };
	
	    var streamTypes = {
	      H264_STREAM_TYPE: 0x1B,
	      ADTS_STREAM_TYPE: 0x0F,
	      METADATA_STREAM_TYPE: 0x15
	    };
	
	    var MAX_TS = 8589934592;
	
	    var RO_THRESH = 4294967296;
	
	    var handleRollover = function handleRollover(value, reference) {
	      var direction = 1;
	
	      if (value > reference) {
	        // If the current timestamp value is greater than our reference timestamp and we detect a
	        // timestamp rollover, this means the roll over is happening in the opposite direction.
	        // Example scenario: Enter a long stream/video just after a rollover occurred. The reference
	        // point will be set to a small number, e.g. 1. The user then seeks backwards over the
	        // rollover point. In loading this segment, the timestamp values will be very large,
	        // e.g. 2^33 - 1. Since this comes before the data we loaded previously, we want to adjust
	        // the time stamp to be `value - 2^33`.
	        direction = -1;
	      }
	
	      // Note: A seek forwards or back that is greater than the RO_THRESH (2^32, ~13 hours) will
	      // cause an incorrect adjustment.
	      while (Math.abs(reference - value) > RO_THRESH) {
	        value += direction * MAX_TS;
	      }
	
	      return value;
	    };
	
	    var TimestampRolloverStream = function TimestampRolloverStream(type) {
	      var lastDTS, referenceDTS;
	
	      TimestampRolloverStream.prototype.init.call(this);
	
	      this.type_ = type;
	
	      this.push = function (data) {
	        if (data.type !== this.type_) {
	          return;
	        }
	
	        if (referenceDTS === undefined) {
	          referenceDTS = data.dts;
	        }
	
	        data.dts = handleRollover(data.dts, referenceDTS);
	        data.pts = handleRollover(data.pts, referenceDTS);
	
	        lastDTS = data.dts;
	
	        this.trigger('data', data);
	      };
	
	      this.flush = function () {
	        referenceDTS = lastDTS;
	        this.trigger('done');
	      };
	
	      this.discontinuity = function () {
	        referenceDTS = void 0;
	        lastDTS = void 0;
	      };
	    };
	
	    TimestampRolloverStream.prototype = new stream();
	
	    var timestampRolloverStream = {
	      TimestampRolloverStream: TimestampRolloverStream,
	      handleRollover: handleRollover
	    };
	
	    var percentEncode = function percentEncode(bytes, start, end) {
	      var i,
	          result = '';
	      for (i = start; i < end; i++) {
	        result += '%' + ('00' + bytes[i].toString(16)).slice(-2);
	      }
	      return result;
	    },
	
	
	    // return the string representation of the specified byte range,
	    // interpreted as UTf-8.
	    parseUtf8 = function parseUtf8(bytes, start, end) {
	      return decodeURIComponent(percentEncode(bytes, start, end));
	    },
	
	
	    // return the string representation of the specified byte range,
	    // interpreted as ISO-8859-1.
	    parseIso88591 = function parseIso88591(bytes, start, end) {
	      return unescape(percentEncode(bytes, start, end)); // jshint ignore:line
	    },
	        parseSyncSafeInteger = function parseSyncSafeInteger(data) {
	      return data[0] << 21 | data[1] << 14 | data[2] << 7 | data[3];
	    },
	        tagParsers = {
	      TXXX: function TXXX(tag) {
	        var i;
	        if (tag.data[0] !== 3) {
	          // ignore frames with unrecognized character encodings
	          return;
	        }
	
	        for (i = 1; i < tag.data.length; i++) {
	          if (tag.data[i] === 0) {
	            // parse the text fields
	            tag.description = parseUtf8(tag.data, 1, i);
	            // do not include the null terminator in the tag value
	            tag.value = parseUtf8(tag.data, i + 1, tag.data.length).replace(/\0*$/, '');
	            break;
	          }
	        }
	        tag.data = tag.value;
	      },
	      WXXX: function WXXX(tag) {
	        var i;
	        if (tag.data[0] !== 3) {
	          // ignore frames with unrecognized character encodings
	          return;
	        }
	
	        for (i = 1; i < tag.data.length; i++) {
	          if (tag.data[i] === 0) {
	            // parse the description and URL fields
	            tag.description = parseUtf8(tag.data, 1, i);
	            tag.url = parseUtf8(tag.data, i + 1, tag.data.length);
	            break;
	          }
	        }
	      },
	      PRIV: function PRIV(tag) {
	        var i;
	
	        for (i = 0; i < tag.data.length; i++) {
	          if (tag.data[i] === 0) {
	            // parse the description and URL fields
	            tag.owner = parseIso88591(tag.data, 0, i);
	            break;
	          }
	        }
	        tag.privateData = tag.data.subarray(i + 1);
	        tag.data = tag.privateData;
	      }
	    },
	        _MetadataStream;
	
	    _MetadataStream = function MetadataStream(options) {
	      var settings = {
	        debug: !!(options && options.debug),
	
	        // the bytes of the program-level descriptor field in MP2T
	        // see ISO/IEC 13818-1:2013 (E), section 2.6 "Program and
	        // program element descriptors"
	        descriptor: options && options.descriptor
	      },
	
	
	      // the total size in bytes of the ID3 tag being parsed
	      tagSize = 0,
	
	
	      // tag data that is not complete enough to be parsed
	      buffer = [],
	
	
	      // the total number of bytes currently in the buffer
	      bufferSize = 0,
	          i;
	
	      _MetadataStream.prototype.init.call(this);
	
	      // calculate the text track in-band metadata track dispatch type
	      // https://html.spec.whatwg.org/multipage/embedded-content.html#steps-to-expose-a-media-resource-specific-text-track
	      this.dispatchType = streamTypes.METADATA_STREAM_TYPE.toString(16);
	      if (settings.descriptor) {
	        for (i = 0; i < settings.descriptor.length; i++) {
	          this.dispatchType += ('00' + settings.descriptor[i].toString(16)).slice(-2);
	        }
	      }
	
	      this.push = function (chunk) {
	        var tag, frameStart, frameSize, frame, i, frameHeader;
	        if (chunk.type !== 'timed-metadata') {
	          return;
	        }
	
	        // if data_alignment_indicator is set in the PES header,
	        // we must have the start of a new ID3 tag. Assume anything
	        // remaining in the buffer was malformed and throw it out
	        if (chunk.dataAlignmentIndicator) {
	          bufferSize = 0;
	          buffer.length = 0;
	        }
	
	        // ignore events that don't look like ID3 data
	        if (buffer.length === 0 && (chunk.data.length < 10 || chunk.data[0] !== 'I'.charCodeAt(0) || chunk.data[1] !== 'D'.charCodeAt(0) || chunk.data[2] !== '3'.charCodeAt(0))) {
	          if (settings.debug) {
	            // eslint-disable-next-line no-console
	            console.log('Skipping unrecognized metadata packet');
	          }
	          return;
	        }
	
	        // add this chunk to the data we've collected so far
	
	        buffer.push(chunk);
	        bufferSize += chunk.data.byteLength;
	
	        // grab the size of the entire frame from the ID3 header
	        if (buffer.length === 1) {
	          // the frame size is transmitted as a 28-bit integer in the
	          // last four bytes of the ID3 header.
	          // The most significant bit of each byte is dropped and the
	          // results concatenated to recover the actual value.
	          tagSize = parseSyncSafeInteger(chunk.data.subarray(6, 10));
	
	          // ID3 reports the tag size excluding the header but it's more
	          // convenient for our comparisons to include it
	          tagSize += 10;
	        }
	
	        // if the entire frame has not arrived, wait for more data
	        if (bufferSize < tagSize) {
	          return;
	        }
	
	        // collect the entire frame so it can be parsed
	        tag = {
	          data: new Uint8Array(tagSize),
	          frames: [],
	          pts: buffer[0].pts,
	          dts: buffer[0].dts
	        };
	        for (i = 0; i < tagSize;) {
	          tag.data.set(buffer[0].data.subarray(0, tagSize - i), i);
	          i += buffer[0].data.byteLength;
	          bufferSize -= buffer[0].data.byteLength;
	          buffer.shift();
	        }
	
	        // find the start of the first frame and the end of the tag
	        frameStart = 10;
	        if (tag.data[5] & 0x40) {
	          // advance the frame start past the extended header
	          frameStart += 4; // header size field
	          frameStart += parseSyncSafeInteger(tag.data.subarray(10, 14));
	
	          // clip any padding off the end
	          tagSize -= parseSyncSafeInteger(tag.data.subarray(16, 20));
	        }
	
	        // parse one or more ID3 frames
	        // http://id3.org/id3v2.3.0#ID3v2_frame_overview
	        do {
	          // determine the number of bytes in this frame
	          frameSize = parseSyncSafeInteger(tag.data.subarray(frameStart + 4, frameStart + 8));
	          if (frameSize < 1) {
	            // eslint-disable-next-line no-console
	            return console.log('Malformed ID3 frame encountered. Skipping metadata parsing.');
	          }
	          frameHeader = String.fromCharCode(tag.data[frameStart], tag.data[frameStart + 1], tag.data[frameStart + 2], tag.data[frameStart + 3]);
	
	          frame = {
	            id: frameHeader,
	            data: tag.data.subarray(frameStart + 10, frameStart + frameSize + 10)
	          };
	          frame.key = frame.id;
	          if (tagParsers[frame.id]) {
	            tagParsers[frame.id](frame);
	
	            // handle the special PRIV frame used to indicate the start
	            // time for raw AAC data
	            if (frame.owner === 'com.apple.streaming.transportStreamTimestamp') {
	              var d = frame.data,
	                  size = (d[3] & 0x01) << 30 | d[4] << 22 | d[5] << 14 | d[6] << 6 | d[7] >>> 2;
	
	              size *= 4;
	              size += d[7] & 0x03;
	              frame.timeStamp = size;
	              // in raw AAC, all subsequent data will be timestamped based
	              // on the value of this frame
	              // we couldn't have known the appropriate pts and dts before
	              // parsing this ID3 tag so set those values now
	              if (tag.pts === undefined && tag.dts === undefined) {
	                tag.pts = frame.timeStamp;
	                tag.dts = frame.timeStamp;
	              }
	              this.trigger('timestamp', frame);
	            }
	          }
	          tag.frames.push(frame);
	
	          frameStart += 10; // advance past the frame header
	          frameStart += frameSize; // advance past the frame body
	        } while (frameStart < tagSize);
	        this.trigger('data', tag);
	      };
	    };
	    _MetadataStream.prototype = new stream();
	
	    var metadataStream = _MetadataStream;
	
	    var TimestampRolloverStream$1 = timestampRolloverStream.TimestampRolloverStream;
	
	    // object types
	    var _TransportPacketStream, _TransportParseStream, _ElementaryStream;
	
	    // constants
	    var MP2T_PACKET_LENGTH = 188,
	
	
	    // bytes
	    SYNC_BYTE = 0x47;
	
	    /**
	     * Splits an incoming stream of binary data into MPEG-2 Transport
	     * Stream packets.
	     */
	    _TransportPacketStream = function TransportPacketStream() {
	      var buffer = new Uint8Array(MP2T_PACKET_LENGTH),
	          bytesInBuffer = 0;
	
	      _TransportPacketStream.prototype.init.call(this);
	
	      // Deliver new bytes to the stream.
	
	      /**
	       * Split a stream of data into M2TS packets
	      **/
	      this.push = function (bytes) {
	        var startIndex = 0,
	            endIndex = MP2T_PACKET_LENGTH,
	            everything;
	
	        // If there are bytes remaining from the last segment, prepend them to the
	        // bytes that were pushed in
	        if (bytesInBuffer) {
	          everything = new Uint8Array(bytes.byteLength + bytesInBuffer);
	          everything.set(buffer.subarray(0, bytesInBuffer));
	          everything.set(bytes, bytesInBuffer);
	          bytesInBuffer = 0;
	        } else {
	          everything = bytes;
	        }
	
	        // While we have enough data for a packet
	        while (endIndex < everything.byteLength) {
	          // Look for a pair of start and end sync bytes in the data..
	          if (everything[startIndex] === SYNC_BYTE && everything[endIndex] === SYNC_BYTE) {
	            // We found a packet so emit it and jump one whole packet forward in
	            // the stream
	            this.trigger('data', everything.subarray(startIndex, endIndex));
	            startIndex += MP2T_PACKET_LENGTH;
	            endIndex += MP2T_PACKET_LENGTH;
	            continue;
	          }
	          // If we get here, we have somehow become de-synchronized and we need to step
	          // forward one byte at a time until we find a pair of sync bytes that denote
	          // a packet
	          startIndex++;
	          endIndex++;
	        }
	
	        // If there was some data left over at the end of the segment that couldn't
	        // possibly be a whole packet, keep it because it might be the start of a packet
	        // that continues in the next segment
	        if (startIndex < everything.byteLength) {
	          buffer.set(everything.subarray(startIndex), 0);
	          bytesInBuffer = everything.byteLength - startIndex;
	        }
	      };
	
	      /**
	       * Passes identified M2TS packets to the TransportParseStream to be parsed
	      **/
	      this.flush = function () {
	        // If the buffer contains a whole packet when we are being flushed, emit it
	        // and empty the buffer. Otherwise hold onto the data because it may be
	        // important for decoding the next segment
	        if (bytesInBuffer === MP2T_PACKET_LENGTH && buffer[0] === SYNC_BYTE) {
	          this.trigger('data', buffer);
	          bytesInBuffer = 0;
	        }
	        this.trigger('done');
	      };
	    };
	    _TransportPacketStream.prototype = new stream();
	
	    /**
	     * Accepts an MP2T TransportPacketStream and emits data events with parsed
	     * forms of the individual transport stream packets.
	     */
	    _TransportParseStream = function TransportParseStream() {
	      var parsePsi, parsePat, parsePmt, self;
	      _TransportParseStream.prototype.init.call(this);
	      self = this;
	
	      this.packetsWaitingForPmt = [];
	      this.programMapTable = undefined;
	
	      parsePsi = function parsePsi(payload, psi) {
	        var offset = 0;
	
	        // PSI packets may be split into multiple sections and those
	        // sections may be split into multiple packets. If a PSI
	        // section starts in this packet, the payload_unit_start_indicator
	        // will be true and the first byte of the payload will indicate
	        // the offset from the current position to the start of the
	        // section.
	        if (psi.payloadUnitStartIndicator) {
	          offset += payload[offset] + 1;
	        }
	
	        if (psi.type === 'pat') {
	          parsePat(payload.subarray(offset), psi);
	        } else {
	          parsePmt(payload.subarray(offset), psi);
	        }
	      };
	
	      parsePat = function parsePat(payload, pat) {
	        pat.section_number = payload[7]; // eslint-disable-line camelcase
	        pat.last_section_number = payload[8]; // eslint-disable-line camelcase
	
	        // skip the PSI header and parse the first PMT entry
	        self.pmtPid = (payload[10] & 0x1F) << 8 | payload[11];
	        pat.pmtPid = self.pmtPid;
	      };
	
	      /**
	       * Parse out the relevant fields of a Program Map Table (PMT).
	       * @param payload {Uint8Array} the PMT-specific portion of an MP2T
	       * packet. The first byte in this array should be the table_id
	       * field.
	       * @param pmt {object} the object that should be decorated with
	       * fields parsed from the PMT.
	       */
	      parsePmt = function parsePmt(payload, pmt) {
	        var sectionLength, tableEnd, programInfoLength, offset;
	
	        // PMTs can be sent ahead of the time when they should actually
	        // take effect. We don't believe this should ever be the case
	        // for HLS but we'll ignore "forward" PMT declarations if we see
	        // them. Future PMT declarations have the current_next_indicator
	        // set to zero.
	        if (!(payload[5] & 0x01)) {
	          return;
	        }
	
	        // overwrite any existing program map table
	        self.programMapTable = {
	          video: null,
	          audio: null,
	          'timed-metadata': {}
	        };
	
	        // the mapping table ends at the end of the current section
	        sectionLength = (payload[1] & 0x0f) << 8 | payload[2];
	        tableEnd = 3 + sectionLength - 4;
	
	        // to determine where the table is, we have to figure out how
	        // long the program info descriptors are
	        programInfoLength = (payload[10] & 0x0f) << 8 | payload[11];
	
	        // advance the offset to the first entry in the mapping table
	        offset = 12 + programInfoLength;
	        while (offset < tableEnd) {
	          var streamType = payload[offset];
	          var pid = (payload[offset + 1] & 0x1F) << 8 | payload[offset + 2];
	
	          // only map a single elementary_pid for audio and video stream types
	          // TODO: should this be done for metadata too? for now maintain behavior of
	          //       multiple metadata streams
	          if (streamType === streamTypes.H264_STREAM_TYPE && self.programMapTable.video === null) {
	            self.programMapTable.video = pid;
	          } else if (streamType === streamTypes.ADTS_STREAM_TYPE && self.programMapTable.audio === null) {
	            self.programMapTable.audio = pid;
	          } else if (streamType === streamTypes.METADATA_STREAM_TYPE) {
	            // map pid to stream type for metadata streams
	            self.programMapTable['timed-metadata'][pid] = streamType;
	          }
	
	          // move to the next table entry
	          // skip past the elementary stream descriptors, if present
	          offset += ((payload[offset + 3] & 0x0F) << 8 | payload[offset + 4]) + 5;
	        }
	
	        // record the map on the packet as well
	        pmt.programMapTable = self.programMapTable;
	      };
	
	      /**
	       * Deliver a new MP2T packet to the next stream in the pipeline.
	       */
	      this.push = function (packet) {
	        var result = {},
	            offset = 4;
	
	        result.payloadUnitStartIndicator = !!(packet[1] & 0x40);
	
	        // pid is a 13-bit field starting at the last bit of packet[1]
	        result.pid = packet[1] & 0x1f;
	        result.pid <<= 8;
	        result.pid |= packet[2];
	
	        // if an adaption field is present, its length is specified by the
	        // fifth byte of the TS packet header. The adaptation field is
	        // used to add stuffing to PES packets that don't fill a complete
	        // TS packet, and to specify some forms of timing and control data
	        // that we do not currently use.
	        if ((packet[3] & 0x30) >>> 4 > 0x01) {
	          offset += packet[offset] + 1;
	        }
	
	        // parse the rest of the packet based on the type
	        if (result.pid === 0) {
	          result.type = 'pat';
	          parsePsi(packet.subarray(offset), result);
	          this.trigger('data', result);
	        } else if (result.pid === this.pmtPid) {
	          result.type = 'pmt';
	          parsePsi(packet.subarray(offset), result);
	          this.trigger('data', result);
	
	          // if there are any packets waiting for a PMT to be found, process them now
	          while (this.packetsWaitingForPmt.length) {
	            this.processPes_.apply(this, this.packetsWaitingForPmt.shift());
	          }
	        } else if (this.programMapTable === undefined) {
	          // When we have not seen a PMT yet, defer further processing of
	          // PES packets until one has been parsed
	          this.packetsWaitingForPmt.push([packet, offset, result]);
	        } else {
	          this.processPes_(packet, offset, result);
	        }
	      };
	
	      this.processPes_ = function (packet, offset, result) {
	        // set the appropriate stream type
	        if (result.pid === this.programMapTable.video) {
	          result.streamType = streamTypes.H264_STREAM_TYPE;
	        } else if (result.pid === this.programMapTable.audio) {
	          result.streamType = streamTypes.ADTS_STREAM_TYPE;
	        } else {
	          // if not video or audio, it is timed-metadata or unknown
	          // if unknown, streamType will be undefined
	          result.streamType = this.programMapTable['timed-metadata'][result.pid];
	        }
	
	        result.type = 'pes';
	        result.data = packet.subarray(offset);
	
	        this.trigger('data', result);
	      };
	    };
	    _TransportParseStream.prototype = new stream();
	    _TransportParseStream.STREAM_TYPES = {
	      h264: 0x1b,
	      adts: 0x0f
	    };
	
	    /**
	     * Reconsistutes program elementary stream (PES) packets from parsed
	     * transport stream packets. That is, if you pipe an
	     * mp2t.TransportParseStream into a mp2t.ElementaryStream, the output
	     * events will be events which capture the bytes for individual PES
	     * packets plus relevant metadata that has been extracted from the
	     * container.
	     */
	    _ElementaryStream = function ElementaryStream() {
	      var self = this,
	
	
	      // PES packet fragments
	      video = {
	        data: [],
	        size: 0
	      },
	          audio = {
	        data: [],
	        size: 0
	      },
	          timedMetadata = {
	        data: [],
	        size: 0
	      },
	          parsePes = function parsePes(payload, pes) {
	        var ptsDtsFlags;
	
	        // get the packet length, this will be 0 for video
	        pes.packetLength = 6 + (payload[4] << 8 | payload[5]);
	
	        // find out if this packets starts a new keyframe
	        pes.dataAlignmentIndicator = (payload[6] & 0x04) !== 0;
	        // PES packets may be annotated with a PTS value, or a PTS value
	        // and a DTS value. Determine what combination of values is
	        // available to work with.
	        ptsDtsFlags = payload[7];
	
	        // PTS and DTS are normally stored as a 33-bit number.  Javascript
	        // performs all bitwise operations on 32-bit integers but javascript
	        // supports a much greater range (52-bits) of integer using standard
	        // mathematical operations.
	        // We construct a 31-bit value using bitwise operators over the 31
	        // most significant bits and then multiply by 4 (equal to a left-shift
	        // of 2) before we add the final 2 least significant bits of the
	        // timestamp (equal to an OR.)
	        if (ptsDtsFlags & 0xC0) {
	          // the PTS and DTS are not written out directly. For information
	          // on how they are encoded, see
	          // http://dvd.sourceforge.net/dvdinfo/pes-hdr.html
	          pes.pts = (payload[9] & 0x0E) << 27 | (payload[10] & 0xFF) << 20 | (payload[11] & 0xFE) << 12 | (payload[12] & 0xFF) << 5 | (payload[13] & 0xFE) >>> 3;
	          pes.pts *= 4; // Left shift by 2
	          pes.pts += (payload[13] & 0x06) >>> 1; // OR by the two LSBs
	          pes.dts = pes.pts;
	          if (ptsDtsFlags & 0x40) {
	            pes.dts = (payload[14] & 0x0E) << 27 | (payload[15] & 0xFF) << 20 | (payload[16] & 0xFE) << 12 | (payload[17] & 0xFF) << 5 | (payload[18] & 0xFE) >>> 3;
	            pes.dts *= 4; // Left shift by 2
	            pes.dts += (payload[18] & 0x06) >>> 1; // OR by the two LSBs
	          }
	        }
	        // the data section starts immediately after the PES header.
	        // pes_header_data_length specifies the number of header bytes
	        // that follow the last byte of the field.
	        pes.data = payload.subarray(9 + payload[8]);
	      },
	
	
	      /**
	        * Pass completely parsed PES packets to the next stream in the pipeline
	       **/
	      flushStream = function flushStream(stream$$1, type, forceFlush) {
	        var packetData = new Uint8Array(stream$$1.size),
	            event = {
	          type: type
	        },
	            i = 0,
	            offset = 0,
	            packetFlushable = false,
	            fragment;
	
	        // do nothing if there is not enough buffered data for a complete
	        // PES header
	        if (!stream$$1.data.length || stream$$1.size < 9) {
	          return;
	        }
	        event.trackId = stream$$1.data[0].pid;
	
	        // reassemble the packet
	        for (i = 0; i < stream$$1.data.length; i++) {
	          fragment = stream$$1.data[i];
	
	          packetData.set(fragment.data, offset);
	          offset += fragment.data.byteLength;
	        }
	
	        // parse assembled packet's PES header
	        parsePes(packetData, event);
	
	        // non-video PES packets MUST have a non-zero PES_packet_length
	        // check that there is enough stream data to fill the packet
	        packetFlushable = type === 'video' || event.packetLength <= stream$$1.size;
	
	        // flush pending packets if the conditions are right
	        if (forceFlush || packetFlushable) {
	          stream$$1.size = 0;
	          stream$$1.data.length = 0;
	        }
	
	        // only emit packets that are complete. this is to avoid assembling
	        // incomplete PES packets due to poor segmentation
	        if (packetFlushable) {
	          self.trigger('data', event);
	        }
	      };
	
	      _ElementaryStream.prototype.init.call(this);
	
	      /**
	       * Identifies M2TS packet types and parses PES packets using metadata
	       * parsed from the PMT
	       **/
	      this.push = function (data) {
	        ({
	          pat: function pat() {
	            // we have to wait for the PMT to arrive as well before we
	            // have any meaningful metadata
	          },
	          pes: function pes() {
	            var stream$$1, streamType;
	
	            switch (data.streamType) {
	              case streamTypes.H264_STREAM_TYPE:
	              case streamTypes.H264_STREAM_TYPE:
	                stream$$1 = video;
	                streamType = 'video';
	                break;
	              case streamTypes.ADTS_STREAM_TYPE:
	                stream$$1 = audio;
	                streamType = 'audio';
	                break;
	              case streamTypes.METADATA_STREAM_TYPE:
	                stream$$1 = timedMetadata;
	                streamType = 'timed-metadata';
	                break;
	              default:
	                // ignore unknown stream types
	                return;
	            }
	
	            // if a new packet is starting, we can flush the completed
	            // packet
	            if (data.payloadUnitStartIndicator) {
	              flushStream(stream$$1, streamType, true);
	            }
	
	            // buffer this fragment until we are sure we've received the
	            // complete payload
	            stream$$1.data.push(data);
	            stream$$1.size += data.data.byteLength;
	          },
	          pmt: function pmt() {
	            var event = {
	              type: 'metadata',
	              tracks: []
	            },
	                programMapTable = data.programMapTable;
	
	            // translate audio and video streams to tracks
	            if (programMapTable.video !== null) {
	              event.tracks.push({
	                timelineStartInfo: {
	                  baseMediaDecodeTime: 0
	                },
	                id: +programMapTable.video,
	                codec: 'avc',
	                type: 'video'
	              });
	            }
	            if (programMapTable.audio !== null) {
	              event.tracks.push({
	                timelineStartInfo: {
	                  baseMediaDecodeTime: 0
	                },
	                id: +programMapTable.audio,
	                codec: 'adts',
	                type: 'audio'
	              });
	            }
	
	            self.trigger('data', event);
	          }
	        })[data.type]();
	      };
	
	      /**
	       * Flush any remaining input. Video PES packets may be of variable
	       * length. Normally, the start of a new video packet can trigger the
	       * finalization of the previous packet. That is not possible if no
	       * more video is forthcoming, however. In that case, some other
	       * mechanism (like the end of the file) has to be employed. When it is
	       * clear that no additional data is forthcoming, calling this method
	       * will flush the buffered packets.
	       */
	      this.flush = function () {
	        // !!THIS ORDER IS IMPORTANT!!
	        // video first then audio
	        flushStream(video, 'video');
	        flushStream(audio, 'audio');
	        flushStream(timedMetadata, 'timed-metadata');
	        this.trigger('done');
	      };
	    };
	    _ElementaryStream.prototype = new stream();
	
	    var m2ts = {
	      PAT_PID: 0x0000,
	      MP2T_PACKET_LENGTH: MP2T_PACKET_LENGTH,
	      TransportPacketStream: _TransportPacketStream,
	      TransportParseStream: _TransportParseStream,
	      ElementaryStream: _ElementaryStream,
	      TimestampRolloverStream: TimestampRolloverStream$1,
	      CaptionStream: captionStream.CaptionStream,
	      Cea608Stream: captionStream.Cea608Stream,
	      MetadataStream: metadataStream
	    };
	
	    for (var type in streamTypes) {
	      if (streamTypes.hasOwnProperty(type)) {
	        m2ts[type] = streamTypes[type];
	      }
	    }
	
	    var m2ts_1 = m2ts;
	
	    var _AdtsStream;
	
	    var ADTS_SAMPLING_FREQUENCIES = [96000, 88200, 64000, 48000, 44100, 32000, 24000, 22050, 16000, 12000, 11025, 8000, 7350];
	
	    /*
	     * Accepts a ElementaryStream and emits data events with parsed
	     * AAC Audio Frames of the individual packets. Input audio in ADTS
	     * format is unpacked and re-emitted as AAC frames.
	     *
	     * @see http://wiki.multimedia.cx/index.php?title=ADTS
	     * @see http://wiki.multimedia.cx/?title=Understanding_AAC
	     */
	    _AdtsStream = function AdtsStream() {
	      var buffer;
	
	      _AdtsStream.prototype.init.call(this);
	
	      this.push = function (packet) {
	        var i = 0,
	            frameNum = 0,
	            frameLength,
	            protectionSkipBytes,
	            frameEnd,
	            oldBuffer,
	            sampleCount,
	            adtsFrameDuration;
	
	        if (packet.type !== 'audio') {
	          // ignore non-audio data
	          return;
	        }
	
	        // Prepend any data in the buffer to the input data so that we can parse
	        // aac frames the cross a PES packet boundary
	        if (buffer) {
	          oldBuffer = buffer;
	          buffer = new Uint8Array(oldBuffer.byteLength + packet.data.byteLength);
	          buffer.set(oldBuffer);
	          buffer.set(packet.data, oldBuffer.byteLength);
	        } else {
	          buffer = packet.data;
	        }
	
	        // unpack any ADTS frames which have been fully received
	        // for details on the ADTS header, see http://wiki.multimedia.cx/index.php?title=ADTS
	        while (i + 5 < buffer.length) {
	
	          // Loook for the start of an ADTS header..
	          if (buffer[i] !== 0xFF || (buffer[i + 1] & 0xF6) !== 0xF0) {
	            // If a valid header was not found,  jump one forward and attempt to
	            // find a valid ADTS header starting at the next byte
	            i++;
	            continue;
	          }
	
	          // The protection skip bit tells us if we have 2 bytes of CRC data at the
	          // end of the ADTS header
	          protectionSkipBytes = (~buffer[i + 1] & 0x01) * 2;
	
	          // Frame length is a 13 bit integer starting 16 bits from the
	          // end of the sync sequence
	          frameLength = (buffer[i + 3] & 0x03) << 11 | buffer[i + 4] << 3 | (buffer[i + 5] & 0xe0) >> 5;
	
	          sampleCount = ((buffer[i + 6] & 0x03) + 1) * 1024;
	          adtsFrameDuration = sampleCount * 90000 / ADTS_SAMPLING_FREQUENCIES[(buffer[i + 2] & 0x3c) >>> 2];
	
	          frameEnd = i + frameLength;
	
	          // If we don't have enough data to actually finish this ADTS frame, return
	          // and wait for more data
	          if (buffer.byteLength < frameEnd) {
	            return;
	          }
	
	          // Otherwise, deliver the complete AAC frame
	          this.trigger('data', {
	            pts: packet.pts + frameNum * adtsFrameDuration,
	            dts: packet.dts + frameNum * adtsFrameDuration,
	            sampleCount: sampleCount,
	            audioobjecttype: (buffer[i + 2] >>> 6 & 0x03) + 1,
	            channelcount: (buffer[i + 2] & 1) << 2 | (buffer[i + 3] & 0xc0) >>> 6,
	            samplerate: ADTS_SAMPLING_FREQUENCIES[(buffer[i + 2] & 0x3c) >>> 2],
	            samplingfrequencyindex: (buffer[i + 2] & 0x3c) >>> 2,
	            // assume ISO/IEC 14496-12 AudioSampleEntry default of 16
	            samplesize: 16,
	            data: buffer.subarray(i + 7 + protectionSkipBytes, frameEnd)
	          });
	
	          // If the buffer is empty, clear it and return
	          if (buffer.byteLength === frameEnd) {
	            buffer = undefined;
	            return;
	          }
	
	          frameNum++;
	
	          // Remove the finished frame from the buffer and start the process again
	          buffer = buffer.subarray(frameEnd);
	        }
	      };
	      this.flush = function () {
	        this.trigger('done');
	      };
	    };
	
	    _AdtsStream.prototype = new stream();
	
	    var adts = _AdtsStream;
	
	    var ExpGolomb;
	
	    /**
	     * Parser for exponential Golomb codes, a variable-bitwidth number encoding
	     * scheme used by h264.
	     */
	    ExpGolomb = function ExpGolomb(workingData) {
	      var
	      // the number of bytes left to examine in workingData
	      workingBytesAvailable = workingData.byteLength,
	
	
	      // the current word being examined
	      workingWord = 0,
	
	
	      // :uint
	
	      // the number of bits left to examine in the current word
	      workingBitsAvailable = 0; // :uint;
	
	      // ():uint
	      this.length = function () {
	        return 8 * workingBytesAvailable;
	      };
	
	      // ():uint
	      this.bitsAvailable = function () {
	        return 8 * workingBytesAvailable + workingBitsAvailable;
	      };
	
	      // ():void
	      this.loadWord = function () {
	        var position = workingData.byteLength - workingBytesAvailable,
	            workingBytes = new Uint8Array(4),
	            availableBytes = Math.min(4, workingBytesAvailable);
	
	        if (availableBytes === 0) {
	          throw new Error('no bytes available');
	        }
	
	        workingBytes.set(workingData.subarray(position, position + availableBytes));
	        workingWord = new DataView(workingBytes.buffer).getUint32(0);
	
	        // track the amount of workingData that has been processed
	        workingBitsAvailable = availableBytes * 8;
	        workingBytesAvailable -= availableBytes;
	      };
	
	      // (count:int):void
	      this.skipBits = function (count) {
	        var skipBytes; // :int
	        if (workingBitsAvailable > count) {
	          workingWord <<= count;
	          workingBitsAvailable -= count;
	        } else {
	          count -= workingBitsAvailable;
	          skipBytes = Math.floor(count / 8);
	
	          count -= skipBytes * 8;
	          workingBytesAvailable -= skipBytes;
	
	          this.loadWord();
	
	          workingWord <<= count;
	          workingBitsAvailable -= count;
	        }
	      };
	
	      // (size:int):uint
	      this.readBits = function (size) {
	        var bits = Math.min(workingBitsAvailable, size),
	
	
	        // :uint
	        valu = workingWord >>> 32 - bits; // :uint
	        // if size > 31, handle error
	        workingBitsAvailable -= bits;
	        if (workingBitsAvailable > 0) {
	          workingWord <<= bits;
	        } else if (workingBytesAvailable > 0) {
	          this.loadWord();
	        }
	
	        bits = size - bits;
	        if (bits > 0) {
	          return valu << bits | this.readBits(bits);
	        }
	        return valu;
	      };
	
	      // ():uint
	      this.skipLeadingZeros = function () {
	        var leadingZeroCount; // :uint
	        for (leadingZeroCount = 0; leadingZeroCount < workingBitsAvailable; ++leadingZeroCount) {
	          if ((workingWord & 0x80000000 >>> leadingZeroCount) !== 0) {
	            // the first bit of working word is 1
	            workingWord <<= leadingZeroCount;
	            workingBitsAvailable -= leadingZeroCount;
	            return leadingZeroCount;
	          }
	        }
	
	        // we exhausted workingWord and still have not found a 1
	        this.loadWord();
	        return leadingZeroCount + this.skipLeadingZeros();
	      };
	
	      // ():void
	      this.skipUnsignedExpGolomb = function () {
	        this.skipBits(1 + this.skipLeadingZeros());
	      };
	
	      // ():void
	      this.skipExpGolomb = function () {
	        this.skipBits(1 + this.skipLeadingZeros());
	      };
	
	      // ():uint
	      this.readUnsignedExpGolomb = function () {
	        var clz = this.skipLeadingZeros(); // :uint
	        return this.readBits(clz + 1) - 1;
	      };
	
	      // ():int
	      this.readExpGolomb = function () {
	        var valu = this.readUnsignedExpGolomb(); // :int
	        if (0x01 & valu) {
	          // the number is odd if the low order bit is set
	          return 1 + valu >>> 1; // add 1 to make it even, and divide by 2
	        }
	        return -1 * (valu >>> 1); // divide by two then make it negative
	      };
	
	      // Some convenience functions
	      // :Boolean
	      this.readBoolean = function () {
	        return this.readBits(1) === 1;
	      };
	
	      // ():int
	      this.readUnsignedByte = function () {
	        return this.readBits(8);
	      };
	
	      this.loadWord();
	    };
	
	    var expGolomb = ExpGolomb;
	
	    var _H264Stream, _NalByteStream;
	    var PROFILES_WITH_OPTIONAL_SPS_DATA;
	
	    /**
	     * Accepts a NAL unit byte stream and unpacks the embedded NAL units.
	     */
	    _NalByteStream = function NalByteStream() {
	      var syncPoint = 0,
	          i,
	          buffer;
	      _NalByteStream.prototype.init.call(this);
	
	      /*
	       * Scans a byte stream and triggers a data event with the NAL units found.
	       * @param {Object} data Event received from H264Stream
	       * @param {Uint8Array} data.data The h264 byte stream to be scanned
	       *
	       * @see H264Stream.push
	       */
	      this.push = function (data) {
	        var swapBuffer;
	
	        if (!buffer) {
	          buffer = data.data;
	        } else {
	          swapBuffer = new Uint8Array(buffer.byteLength + data.data.byteLength);
	          swapBuffer.set(buffer);
	          swapBuffer.set(data.data, buffer.byteLength);
	          buffer = swapBuffer;
	        }
	
	        // Rec. ITU-T H.264, Annex B
	        // scan for NAL unit boundaries
	
	        // a match looks like this:
	        // 0 0 1 .. NAL .. 0 0 1
	        // ^ sync point        ^ i
	        // or this:
	        // 0 0 1 .. NAL .. 0 0 0
	        // ^ sync point        ^ i
	
	        // advance the sync point to a NAL start, if necessary
	        for (; syncPoint < buffer.byteLength - 3; syncPoint++) {
	          if (buffer[syncPoint + 2] === 1) {
	            // the sync point is properly aligned
	            i = syncPoint + 5;
	            break;
	          }
	        }
	
	        while (i < buffer.byteLength) {
	          // look at the current byte to determine if we've hit the end of
	          // a NAL unit boundary
	          switch (buffer[i]) {
	            case 0:
	              // skip past non-sync sequences
	              if (buffer[i - 1] !== 0) {
	                i += 2;
	                break;
	              } else if (buffer[i - 2] !== 0) {
	                i++;
	                break;
	              }
	
	              // deliver the NAL unit if it isn't empty
	              if (syncPoint + 3 !== i - 2) {
	                this.trigger('data', buffer.subarray(syncPoint + 3, i - 2));
	              }
	
	              // drop trailing zeroes
	              do {
	                i++;
	              } while (buffer[i] !== 1 && i < buffer.length);
	              syncPoint = i - 2;
	              i += 3;
	              break;
	            case 1:
	              // skip past non-sync sequences
	              if (buffer[i - 1] !== 0 || buffer[i - 2] !== 0) {
	                i += 3;
	                break;
	              }
	
	              // deliver the NAL unit
	              this.trigger('data', buffer.subarray(syncPoint + 3, i - 2));
	              syncPoint = i - 2;
	              i += 3;
	              break;
	            default:
	              // the current byte isn't a one or zero, so it cannot be part
	              // of a sync sequence
	              i += 3;
	              break;
	          }
	        }
	        // filter out the NAL units that were delivered
	        buffer = buffer.subarray(syncPoint);
	        i -= syncPoint;
	        syncPoint = 0;
	      };
	
	      this.flush = function () {
	        // deliver the last buffered NAL unit
	        if (buffer && buffer.byteLength > 3) {
	          this.trigger('data', buffer.subarray(syncPoint + 3));
	        }
	        // reset the stream state
	        buffer = null;
	        syncPoint = 0;
	        this.trigger('done');
	      };
	    };
	    _NalByteStream.prototype = new stream();
	
	    // values of profile_idc that indicate additional fields are included in the SPS
	    // see Recommendation ITU-T H.264 (4/2013),
	    // 7.3.2.1.1 Sequence parameter set data syntax
	    PROFILES_WITH_OPTIONAL_SPS_DATA = {
	      100: true,
	      110: true,
	      122: true,
	      244: true,
	      44: true,
	      83: true,
	      86: true,
	      118: true,
	      128: true,
	      138: true,
	      139: true,
	      134: true
	    };
	
	    /**
	     * Accepts input from a ElementaryStream and produces H.264 NAL unit data
	     * events.
	     */
	    _H264Stream = function H264Stream() {
	      var nalByteStream = new _NalByteStream(),
	          self,
	          trackId,
	          currentPts,
	          currentDts,
	          discardEmulationPreventionBytes,
	          readSequenceParameterSet,
	          skipScalingList;
	
	      _H264Stream.prototype.init.call(this);
	      self = this;
	
	      /*
	       * Pushes a packet from a stream onto the NalByteStream
	       *
	       * @param {Object} packet - A packet received from a stream
	       * @param {Uint8Array} packet.data - The raw bytes of the packet
	       * @param {Number} packet.dts - Decode timestamp of the packet
	       * @param {Number} packet.pts - Presentation timestamp of the packet
	       * @param {Number} packet.trackId - The id of the h264 track this packet came from
	       * @param {('video'|'audio')} packet.type - The type of packet
	       *
	       */
	      this.push = function (packet) {
	        if (packet.type !== 'video') {
	          return;
	        }
	        trackId = packet.trackId;
	        currentPts = packet.pts;
	        currentDts = packet.dts;
	
	        nalByteStream.push(packet);
	      };
	
	      /*
	       * Identify NAL unit types and pass on the NALU, trackId, presentation and decode timestamps
	       * for the NALUs to the next stream component.
	       * Also, preprocess caption and sequence parameter NALUs.
	       *
	       * @param {Uint8Array} data - A NAL unit identified by `NalByteStream.push`
	       * @see NalByteStream.push
	       */
	      nalByteStream.on('data', function (data) {
	        var event = {
	          trackId: trackId,
	          pts: currentPts,
	          dts: currentDts,
	          data: data
	        };
	
	        switch (data[0] & 0x1f) {
	          case 0x05:
	            event.nalUnitType = 'slice_layer_without_partitioning_rbsp_idr';
	            break;
	          case 0x06:
	            event.nalUnitType = 'sei_rbsp';
	            event.escapedRBSP = discardEmulationPreventionBytes(data.subarray(1));
	            break;
	          case 0x07:
	            event.nalUnitType = 'seq_parameter_set_rbsp';
	            event.escapedRBSP = discardEmulationPreventionBytes(data.subarray(1));
	            event.config = readSequenceParameterSet(event.escapedRBSP);
	            break;
	          case 0x08:
	            event.nalUnitType = 'pic_parameter_set_rbsp';
	            break;
	          case 0x09:
	            event.nalUnitType = 'access_unit_delimiter_rbsp';
	            break;
	
	          default:
	            break;
	        }
	        // This triggers data on the H264Stream
	        self.trigger('data', event);
	      });
	      nalByteStream.on('done', function () {
	        self.trigger('done');
	      });
	
	      this.flush = function () {
	        nalByteStream.flush();
	      };
	
	      /**
	       * Advance the ExpGolomb decoder past a scaling list. The scaling
	       * list is optionally transmitted as part of a sequence parameter
	       * set and is not relevant to transmuxing.
	       * @param count {number} the number of entries in this scaling list
	       * @param expGolombDecoder {object} an ExpGolomb pointed to the
	       * start of a scaling list
	       * @see Recommendation ITU-T H.264, Section 7.3.2.1.1.1
	       */
	      skipScalingList = function skipScalingList(count, expGolombDecoder) {
	        var lastScale = 8,
	            nextScale = 8,
	            j,
	            deltaScale;
	
	        for (j = 0; j < count; j++) {
	          if (nextScale !== 0) {
	            deltaScale = expGolombDecoder.readExpGolomb();
	            nextScale = (lastScale + deltaScale + 256) % 256;
	          }
	
	          lastScale = nextScale === 0 ? lastScale : nextScale;
	        }
	      };
	
	      /**
	       * Expunge any "Emulation Prevention" bytes from a "Raw Byte
	       * Sequence Payload"
	       * @param data {Uint8Array} the bytes of a RBSP from a NAL
	       * unit
	       * @return {Uint8Array} the RBSP without any Emulation
	       * Prevention Bytes
	       */
	      discardEmulationPreventionBytes = function discardEmulationPreventionBytes(data) {
	        var length = data.byteLength,
	            emulationPreventionBytesPositions = [],
	            i = 1,
	            newLength,
	            newData;
	
	        // Find all `Emulation Prevention Bytes`
	        while (i < length - 2) {
	          if (data[i] === 0 && data[i + 1] === 0 && data[i + 2] === 0x03) {
	            emulationPreventionBytesPositions.push(i + 2);
	            i += 2;
	          } else {
	            i++;
	          }
	        }
	
	        // If no Emulation Prevention Bytes were found just return the original
	        // array
	        if (emulationPreventionBytesPositions.length === 0) {
	          return data;
	        }
	
	        // Create a new array to hold the NAL unit data
	        newLength = length - emulationPreventionBytesPositions.length;
	        newData = new Uint8Array(newLength);
	        var sourceIndex = 0;
	
	        for (i = 0; i < newLength; sourceIndex++, i++) {
	          if (sourceIndex === emulationPreventionBytesPositions[0]) {
	            // Skip this byte
	            sourceIndex++;
	            // Remove this position index
	            emulationPreventionBytesPositions.shift();
	          }
	          newData[i] = data[sourceIndex];
	        }
	
	        return newData;
	      };
	
	      /**
	       * Read a sequence parameter set and return some interesting video
	       * properties. A sequence parameter set is the H264 metadata that
	       * describes the properties of upcoming video frames.
	       * @param data {Uint8Array} the bytes of a sequence parameter set
	       * @return {object} an object with configuration parsed from the
	       * sequence parameter set, including the dimensions of the
	       * associated video frames.
	       */
	      readSequenceParameterSet = function readSequenceParameterSet(data) {
	        var frameCropLeftOffset = 0,
	            frameCropRightOffset = 0,
	            frameCropTopOffset = 0,
	            frameCropBottomOffset = 0,
	            sarScale = 1,
	            expGolombDecoder,
	            profileIdc,
	            levelIdc,
	            profileCompatibility,
	            chromaFormatIdc,
	            picOrderCntType,
	            numRefFramesInPicOrderCntCycle,
	            picWidthInMbsMinus1,
	            picHeightInMapUnitsMinus1,
	            frameMbsOnlyFlag,
	            scalingListCount,
	            sarRatio,
	            aspectRatioIdc,
	            i;
	
	        expGolombDecoder = new expGolomb(data);
	        profileIdc = expGolombDecoder.readUnsignedByte(); // profile_idc
	        profileCompatibility = expGolombDecoder.readUnsignedByte(); // constraint_set[0-5]_flag
	        levelIdc = expGolombDecoder.readUnsignedByte(); // level_idc u(8)
	        expGolombDecoder.skipUnsignedExpGolomb(); // seq_parameter_set_id
	
	        // some profiles have more optional data we don't need
	        if (PROFILES_WITH_OPTIONAL_SPS_DATA[profileIdc]) {
	          chromaFormatIdc = expGolombDecoder.readUnsignedExpGolomb();
	          if (chromaFormatIdc === 3) {
	            expGolombDecoder.skipBits(1); // separate_colour_plane_flag
	          }
	          expGolombDecoder.skipUnsignedExpGolomb(); // bit_depth_luma_minus8
	          expGolombDecoder.skipUnsignedExpGolomb(); // bit_depth_chroma_minus8
	          expGolombDecoder.skipBits(1); // qpprime_y_zero_transform_bypass_flag
	          if (expGolombDecoder.readBoolean()) {
	            // seq_scaling_matrix_present_flag
	            scalingListCount = chromaFormatIdc !== 3 ? 8 : 12;
	            for (i = 0; i < scalingListCount; i++) {
	              if (expGolombDecoder.readBoolean()) {
	                // seq_scaling_list_present_flag[ i ]
	                if (i < 6) {
	                  skipScalingList(16, expGolombDecoder);
	                } else {
	                  skipScalingList(64, expGolombDecoder);
	                }
	              }
	            }
	          }
	        }
	
	        expGolombDecoder.skipUnsignedExpGolomb(); // log2_max_frame_num_minus4
	        picOrderCntType = expGolombDecoder.readUnsignedExpGolomb();
	
	        if (picOrderCntType === 0) {
	          expGolombDecoder.readUnsignedExpGolomb(); // log2_max_pic_order_cnt_lsb_minus4
	        } else if (picOrderCntType === 1) {
	          expGolombDecoder.skipBits(1); // delta_pic_order_always_zero_flag
	          expGolombDecoder.skipExpGolomb(); // offset_for_non_ref_pic
	          expGolombDecoder.skipExpGolomb(); // offset_for_top_to_bottom_field
	          numRefFramesInPicOrderCntCycle = expGolombDecoder.readUnsignedExpGolomb();
	          for (i = 0; i < numRefFramesInPicOrderCntCycle; i++) {
	            expGolombDecoder.skipExpGolomb(); // offset_for_ref_frame[ i ]
	          }
	        }
	
	        expGolombDecoder.skipUnsignedExpGolomb(); // max_num_ref_frames
	        expGolombDecoder.skipBits(1); // gaps_in_frame_num_value_allowed_flag
	
	        picWidthInMbsMinus1 = expGolombDecoder.readUnsignedExpGolomb();
	        picHeightInMapUnitsMinus1 = expGolombDecoder.readUnsignedExpGolomb();
	
	        frameMbsOnlyFlag = expGolombDecoder.readBits(1);
	        if (frameMbsOnlyFlag === 0) {
	          expGolombDecoder.skipBits(1); // mb_adaptive_frame_field_flag
	        }
	
	        expGolombDecoder.skipBits(1); // direct_8x8_inference_flag
	        if (expGolombDecoder.readBoolean()) {
	          // frame_cropping_flag
	          frameCropLeftOffset = expGolombDecoder.readUnsignedExpGolomb();
	          frameCropRightOffset = expGolombDecoder.readUnsignedExpGolomb();
	          frameCropTopOffset = expGolombDecoder.readUnsignedExpGolomb();
	          frameCropBottomOffset = expGolombDecoder.readUnsignedExpGolomb();
	        }
	        if (expGolombDecoder.readBoolean()) {
	          // vui_parameters_present_flag
	          if (expGolombDecoder.readBoolean()) {
	            // aspect_ratio_info_present_flag
	            aspectRatioIdc = expGolombDecoder.readUnsignedByte();
	            switch (aspectRatioIdc) {
	              case 1:
	                sarRatio = [1, 1];break;
	              case 2:
	                sarRatio = [12, 11];break;
	              case 3:
	                sarRatio = [10, 11];break;
	              case 4:
	                sarRatio = [16, 11];break;
	              case 5:
	                sarRatio = [40, 33];break;
	              case 6:
	                sarRatio = [24, 11];break;
	              case 7:
	                sarRatio = [20, 11];break;
	              case 8:
	                sarRatio = [32, 11];break;
	              case 9:
	                sarRatio = [80, 33];break;
	              case 10:
	                sarRatio = [18, 11];break;
	              case 11:
	                sarRatio = [15, 11];break;
	              case 12:
	                sarRatio = [64, 33];break;
	              case 13:
	                sarRatio = [160, 99];break;
	              case 14:
	                sarRatio = [4, 3];break;
	              case 15:
	                sarRatio = [3, 2];break;
	              case 16:
	                sarRatio = [2, 1];break;
	              case 255:
	                {
	                  sarRatio = [expGolombDecoder.readUnsignedByte() << 8 | expGolombDecoder.readUnsignedByte(), expGolombDecoder.readUnsignedByte() << 8 | expGolombDecoder.readUnsignedByte()];
	                  break;
	                }
	            }
	            if (sarRatio) {
	              sarScale = sarRatio[0] / sarRatio[1];
	            }
	          }
	        }
	        return {
	          profileIdc: profileIdc,
	          levelIdc: levelIdc,
	          profileCompatibility: profileCompatibility,
	          width: Math.ceil(((picWidthInMbsMinus1 + 1) * 16 - frameCropLeftOffset * 2 - frameCropRightOffset * 2) * sarScale),
	          height: (2 - frameMbsOnlyFlag) * (picHeightInMapUnitsMinus1 + 1) * 16 - frameCropTopOffset * 2 - frameCropBottomOffset * 2
	        };
	      };
	    };
	    _H264Stream.prototype = new stream();
	
	    var h264 = {
	      H264Stream: _H264Stream,
	      NalByteStream: _NalByteStream
	    };
	
	    // Constants
	    var _AacStream;
	
	    /**
	     * Splits an incoming stream of binary data into ADTS and ID3 Frames.
	     */
	
	    _AacStream = function AacStream() {
	      var everything = new Uint8Array(),
	          timeStamp = 0;
	
	      _AacStream.prototype.init.call(this);
	
	      this.setTimestamp = function (timestamp) {
	        timeStamp = timestamp;
	      };
	
	      this.parseId3TagSize = function (header, byteIndex) {
	        var returnSize = header[byteIndex + 6] << 21 | header[byteIndex + 7] << 14 | header[byteIndex + 8] << 7 | header[byteIndex + 9],
	            flags = header[byteIndex + 5],
	            footerPresent = (flags & 16) >> 4;
	
	        if (footerPresent) {
	          return returnSize + 20;
	        }
	        return returnSize + 10;
	      };
	
	      this.parseAdtsSize = function (header, byteIndex) {
	        var lowThree = (header[byteIndex + 5] & 0xE0) >> 5,
	            middle = header[byteIndex + 4] << 3,
	            highTwo = header[byteIndex + 3] & 0x3 << 11;
	
	        return highTwo | middle | lowThree;
	      };
	
	      this.push = function (bytes) {
	        var frameSize = 0,
	            byteIndex = 0,
	            bytesLeft,
	            chunk,
	            packet,
	            tempLength;
	
	        // If there are bytes remaining from the last segment, prepend them to the
	        // bytes that were pushed in
	        if (everything.length) {
	          tempLength = everything.length;
	          everything = new Uint8Array(bytes.byteLength + tempLength);
	          everything.set(everything.subarray(0, tempLength));
	          everything.set(bytes, tempLength);
	        } else {
	          everything = bytes;
	        }
	
	        while (everything.length - byteIndex >= 3) {
	          if (everything[byteIndex] === 'I'.charCodeAt(0) && everything[byteIndex + 1] === 'D'.charCodeAt(0) && everything[byteIndex + 2] === '3'.charCodeAt(0)) {
	
	            // Exit early because we don't have enough to parse
	            // the ID3 tag header
	            if (everything.length - byteIndex < 10) {
	              break;
	            }
	
	            // check framesize
	            frameSize = this.parseId3TagSize(everything, byteIndex);
	
	            // Exit early if we don't have enough in the buffer
	            // to emit a full packet
	            if (frameSize > everything.length) {
	              break;
	            }
	            chunk = {
	              type: 'timed-metadata',
	              data: everything.subarray(byteIndex, byteIndex + frameSize)
	            };
	            this.trigger('data', chunk);
	            byteIndex += frameSize;
	            continue;
	          } else if (everything[byteIndex] & 0xff === 0xff && (everything[byteIndex + 1] & 0xf0) === 0xf0) {
	
	            // Exit early because we don't have enough to parse
	            // the ADTS frame header
	            if (everything.length - byteIndex < 7) {
	              break;
	            }
	
	            frameSize = this.parseAdtsSize(everything, byteIndex);
	
	            // Exit early if we don't have enough in the buffer
	            // to emit a full packet
	            if (frameSize > everything.length) {
	              break;
	            }
	
	            packet = {
	              type: 'audio',
	              data: everything.subarray(byteIndex, byteIndex + frameSize),
	              pts: timeStamp,
	              dts: timeStamp
	            };
	            this.trigger('data', packet);
	            byteIndex += frameSize;
	            continue;
	          }
	          byteIndex++;
	        }
	        bytesLeft = everything.length - byteIndex;
	
	        if (bytesLeft > 0) {
	          everything = everything.subarray(byteIndex);
	        } else {
	          everything = new Uint8Array();
	        }
	      };
	    };
	
	    _AacStream.prototype = new stream();
	
	    var aac = _AacStream;
	
	    var highPrefix = [33, 16, 5, 32, 164, 27];
	    var lowPrefix = [33, 65, 108, 84, 1, 2, 4, 8, 168, 2, 4, 8, 17, 191, 252];
	    var zeroFill = function zeroFill(count) {
	      var a = [];
	      while (count--) {
	        a.push(0);
	      }
	      return a;
	    };
	
	    var makeTable = function makeTable(metaTable) {
	      return Object.keys(metaTable).reduce(function (obj, key) {
	        obj[key] = new Uint8Array(metaTable[key].reduce(function (arr, part) {
	          return arr.concat(part);
	        }, []));
	        return obj;
	      }, {});
	    };
	
	    // Frames-of-silence to use for filling in missing AAC frames
	    var coneOfSilence = {
	      96000: [highPrefix, [227, 64], zeroFill(154), [56]],
	      88200: [highPrefix, [231], zeroFill(170), [56]],
	      64000: [highPrefix, [248, 192], zeroFill(240), [56]],
	      48000: [highPrefix, [255, 192], zeroFill(268), [55, 148, 128], zeroFill(54), [112]],
	      44100: [highPrefix, [255, 192], zeroFill(268), [55, 163, 128], zeroFill(84), [112]],
	      32000: [highPrefix, [255, 192], zeroFill(268), [55, 234], zeroFill(226), [112]],
	      24000: [highPrefix, [255, 192], zeroFill(268), [55, 255, 128], zeroFill(268), [111, 112], zeroFill(126), [224]],
	      16000: [highPrefix, [255, 192], zeroFill(268), [55, 255, 128], zeroFill(268), [111, 255], zeroFill(269), [223, 108], zeroFill(195), [1, 192]],
	      12000: [lowPrefix, zeroFill(268), [3, 127, 248], zeroFill(268), [6, 255, 240], zeroFill(268), [13, 255, 224], zeroFill(268), [27, 253, 128], zeroFill(259), [56]],
	      11025: [lowPrefix, zeroFill(268), [3, 127, 248], zeroFill(268), [6, 255, 240], zeroFill(268), [13, 255, 224], zeroFill(268), [27, 255, 192], zeroFill(268), [55, 175, 128], zeroFill(108), [112]],
	      8000: [lowPrefix, zeroFill(268), [3, 121, 16], zeroFill(47), [7]]
	    };
	
	    var silence = makeTable(coneOfSilence);
	
	    var ONE_SECOND_IN_TS$1 = 90000,
	
	
	    // 90kHz clock
	    secondsToVideoTs,
	        secondsToAudioTs,
	        videoTsToSeconds,
	        audioTsToSeconds,
	        audioTsToVideoTs,
	        videoTsToAudioTs;
	
	    secondsToVideoTs = function secondsToVideoTs(seconds) {
	      return seconds * ONE_SECOND_IN_TS$1;
	    };
	
	    secondsToAudioTs = function secondsToAudioTs(seconds, sampleRate) {
	      return seconds * sampleRate;
	    };
	
	    videoTsToSeconds = function videoTsToSeconds(timestamp) {
	      return timestamp / ONE_SECOND_IN_TS$1;
	    };
	
	    audioTsToSeconds = function audioTsToSeconds(timestamp, sampleRate) {
	      return timestamp / sampleRate;
	    };
	
	    audioTsToVideoTs = function audioTsToVideoTs(timestamp, sampleRate) {
	      return secondsToVideoTs(audioTsToSeconds(timestamp, sampleRate));
	    };
	
	    videoTsToAudioTs = function videoTsToAudioTs(timestamp, sampleRate) {
	      return secondsToAudioTs(videoTsToSeconds(timestamp), sampleRate);
	    };
	
	    var clock = {
	      secondsToVideoTs: secondsToVideoTs,
	      secondsToAudioTs: secondsToAudioTs,
	      videoTsToSeconds: videoTsToSeconds,
	      audioTsToSeconds: audioTsToSeconds,
	      audioTsToVideoTs: audioTsToVideoTs,
	      videoTsToAudioTs: videoTsToAudioTs
	    };
	
	    var H264Stream = h264.H264Stream;
	
	    // constants
	    var AUDIO_PROPERTIES = ['audioobjecttype', 'channelcount', 'samplerate', 'samplingfrequencyindex', 'samplesize'];
	
	    var VIDEO_PROPERTIES = ['width', 'height', 'profileIdc', 'levelIdc', 'profileCompatibility'];
	
	    var ONE_SECOND_IN_TS$2 = 90000; // 90kHz clock
	
	    // object types
	    var _VideoSegmentStream, _AudioSegmentStream, _Transmuxer, _CoalesceStream;
	
	    // Helper functions
	    var isLikelyAacData, arrayEquals, sumFrameByteLengths;
	
	    isLikelyAacData = function isLikelyAacData(data) {
	      if (data[0] === 'I'.charCodeAt(0) && data[1] === 'D'.charCodeAt(0) && data[2] === '3'.charCodeAt(0)) {
	        return true;
	      }
	      return false;
	    };
	
	    /**
	     * Compare two arrays (even typed) for same-ness
	     */
	    arrayEquals = function arrayEquals(a, b) {
	      var i;
	
	      if (a.length !== b.length) {
	        return false;
	      }
	
	      // compare the value of each element in the array
	      for (i = 0; i < a.length; i++) {
	        if (a[i] !== b[i]) {
	          return false;
	        }
	      }
	
	      return true;
	    };
	
	    /**
	     * Sum the `byteLength` properties of the data in each AAC frame
	     */
	    sumFrameByteLengths = function sumFrameByteLengths(array) {
	      var i,
	          currentObj,
	          sum = 0;
	
	      // sum the byteLength's all each nal unit in the frame
	      for (i = 0; i < array.length; i++) {
	        currentObj = array[i];
	        sum += currentObj.data.byteLength;
	      }
	
	      return sum;
	    };
	
	    /**
	     * Constructs a single-track, ISO BMFF media segment from AAC data
	     * events. The output of this stream can be fed to a SourceBuffer
	     * configured with a suitable initialization segment.
	     * @param track {object} track metadata configuration
	     * @param options {object} transmuxer options object
	     * @param options.keepOriginalTimestamps {boolean} If true, keep the timestamps
	     *        in the source; false to adjust the first segment to start at 0.
	     */
	    _AudioSegmentStream = function AudioSegmentStream(track, options) {
	      var adtsFrames = [],
	          sequenceNumber = 0,
	          earliestAllowedDts = 0,
	          audioAppendStartTs = 0,
	          videoBaseMediaDecodeTime = Infinity;
	
	      options = options || {};
	
	      _AudioSegmentStream.prototype.init.call(this);
	
	      this.push = function (data) {
	        trackDecodeInfo.collectDtsInfo(track, data);
	
	        if (track) {
	          AUDIO_PROPERTIES.forEach(function (prop) {
	            track[prop] = data[prop];
	          });
	        }
	
	        // buffer audio data until end() is called
	        adtsFrames.push(data);
	      };
	
	      this.setEarliestDts = function (earliestDts) {
	        earliestAllowedDts = earliestDts - track.timelineStartInfo.baseMediaDecodeTime;
	      };
	
	      this.setVideoBaseMediaDecodeTime = function (baseMediaDecodeTime) {
	        videoBaseMediaDecodeTime = baseMediaDecodeTime;
	      };
	
	      this.setAudioAppendStart = function (timestamp) {
	        audioAppendStartTs = timestamp;
	      };
	
	      this.flush = function () {
	        var frames, moof, mdat, boxes;
	
	        // return early if no audio data has been observed
	        if (adtsFrames.length === 0) {
	          this.trigger('done', 'AudioSegmentStream');
	          return;
	        }
	
	        frames = this.trimAdtsFramesByEarliestDts_(adtsFrames);
	        track.baseMediaDecodeTime = trackDecodeInfo.calculateTrackBaseMediaDecodeTime(track, options.keepOriginalTimestamps);
	
	        this.prefixWithSilence_(track, frames);
	
	        // we have to build the index from byte locations to
	        // samples (that is, adts frames) in the audio data
	        track.samples = this.generateSampleTable_(frames);
	
	        // concatenate the audio data to constuct the mdat
	        mdat = mp4Generator.mdat(this.concatenateFrameData_(frames));
	
	        adtsFrames = [];
	
	        moof = mp4Generator.moof(sequenceNumber, [track]);
	        boxes = new Uint8Array(moof.byteLength + mdat.byteLength);
	
	        // bump the sequence number for next time
	        sequenceNumber++;
	
	        boxes.set(moof);
	        boxes.set(mdat, moof.byteLength);
	
	        trackDecodeInfo.clearDtsInfo(track);
	
	        this.trigger('data', { track: track, boxes: boxes });
	        this.trigger('done', 'AudioSegmentStream');
	      };
	
	      // Possibly pad (prefix) the audio track with silence if appending this track
	      // would lead to the introduction of a gap in the audio buffer
	      this.prefixWithSilence_ = function (track, frames) {
	        var baseMediaDecodeTimeTs,
	            frameDuration = 0,
	            audioGapDuration = 0,
	            audioFillFrameCount = 0,
	            audioFillDuration = 0,
	            silentFrame,
	            i;
	
	        if (!frames.length) {
	          return;
	        }
	
	        baseMediaDecodeTimeTs = clock.audioTsToVideoTs(track.baseMediaDecodeTime, track.samplerate);
	        // determine frame clock duration based on sample rate, round up to avoid overfills
	        frameDuration = Math.ceil(ONE_SECOND_IN_TS$2 / (track.samplerate / 1024));
	
	        if (audioAppendStartTs && videoBaseMediaDecodeTime) {
	          // insert the shortest possible amount (audio gap or audio to video gap)
	          audioGapDuration = baseMediaDecodeTimeTs - Math.max(audioAppendStartTs, videoBaseMediaDecodeTime);
	          // number of full frames in the audio gap
	          audioFillFrameCount = Math.floor(audioGapDuration / frameDuration);
	          audioFillDuration = audioFillFrameCount * frameDuration;
	        }
	
	        // don't attempt to fill gaps smaller than a single frame or larger
	        // than a half second
	        if (audioFillFrameCount < 1 || audioFillDuration > ONE_SECOND_IN_TS$2 / 2) {
	          return;
	        }
	
	        silentFrame = silence[track.samplerate];
	
	        if (!silentFrame) {
	          // we don't have a silent frame pregenerated for the sample rate, so use a frame
	          // from the content instead
	          silentFrame = frames[0].data;
	        }
	
	        for (i = 0; i < audioFillFrameCount; i++) {
	          frames.splice(i, 0, {
	            data: silentFrame
	          });
	        }
	
	        track.baseMediaDecodeTime -= Math.floor(clock.videoTsToAudioTs(audioFillDuration, track.samplerate));
	      };
	
	      // If the audio segment extends before the earliest allowed dts
	      // value, remove AAC frames until starts at or after the earliest
	      // allowed DTS so that we don't end up with a negative baseMedia-
	      // DecodeTime for the audio track
	      this.trimAdtsFramesByEarliestDts_ = function (adtsFrames) {
	        if (track.minSegmentDts >= earliestAllowedDts) {
	          return adtsFrames;
	        }
	
	        // We will need to recalculate the earliest segment Dts
	        track.minSegmentDts = Infinity;
	
	        return adtsFrames.filter(function (currentFrame) {
	          // If this is an allowed frame, keep it and record it's Dts
	          if (currentFrame.dts >= earliestAllowedDts) {
	            track.minSegmentDts = Math.min(track.minSegmentDts, currentFrame.dts);
	            track.minSegmentPts = track.minSegmentDts;
	            return true;
	          }
	          // Otherwise, discard it
	          return false;
	        });
	      };
	
	      // generate the track's raw mdat data from an array of frames
	      this.generateSampleTable_ = function (frames) {
	        var i,
	            currentFrame,
	            samples = [];
	
	        for (i = 0; i < frames.length; i++) {
	          currentFrame = frames[i];
	          samples.push({
	            size: currentFrame.data.byteLength,
	            duration: 1024 // For AAC audio, all samples contain 1024 samples
	          });
	        }
	        return samples;
	      };
	
	      // generate the track's sample table from an array of frames
	      this.concatenateFrameData_ = function (frames) {
	        var i,
	            currentFrame,
	            dataOffset = 0,
	            data = new Uint8Array(sumFrameByteLengths(frames));
	
	        for (i = 0; i < frames.length; i++) {
	          currentFrame = frames[i];
	
	          data.set(currentFrame.data, dataOffset);
	          dataOffset += currentFrame.data.byteLength;
	        }
	        return data;
	      };
	    };
	
	    _AudioSegmentStream.prototype = new stream();
	
	    /**
	     * Constructs a single-track, ISO BMFF media segment from H264 data
	     * events. The output of this stream can be fed to a SourceBuffer
	     * configured with a suitable initialization segment.
	     * @param track {object} track metadata configuration
	     * @param options {object} transmuxer options object
	     * @param options.alignGopsAtEnd {boolean} If true, start from the end of the
	     *        gopsToAlignWith list when attempting to align gop pts
	     * @param options.keepOriginalTimestamps {boolean} If true, keep the timestamps
	     *        in the source; false to adjust the first segment to start at 0.
	     */
	    _VideoSegmentStream = function VideoSegmentStream(track, options) {
	      var sequenceNumber = 0,
	          nalUnits = [],
	          gopsToAlignWith = [],
	          config,
	          pps;
	
	      options = options || {};
	
	      _VideoSegmentStream.prototype.init.call(this);
	
	      delete track.minPTS;
	
	      this.gopCache_ = [];
	
	      /**
	        * Constructs a ISO BMFF segment given H264 nalUnits
	        * @param {Object} nalUnit A data event representing a nalUnit
	        * @param {String} nalUnit.nalUnitType
	        * @param {Object} nalUnit.config Properties for a mp4 track
	        * @param {Uint8Array} nalUnit.data The nalUnit bytes
	        * @see lib/codecs/h264.js
	       **/
	      this.push = function (nalUnit) {
	        trackDecodeInfo.collectDtsInfo(track, nalUnit);
	
	        // record the track config
	        if (nalUnit.nalUnitType === 'seq_parameter_set_rbsp' && !config) {
	          config = nalUnit.config;
	          track.sps = [nalUnit.data];
	
	          VIDEO_PROPERTIES.forEach(function (prop) {
	            track[prop] = config[prop];
	          }, this);
	        }
	
	        if (nalUnit.nalUnitType === 'pic_parameter_set_rbsp' && !pps) {
	          pps = nalUnit.data;
	          track.pps = [nalUnit.data];
	        }
	
	        // buffer video until flush() is called
	        nalUnits.push(nalUnit);
	      };
	
	      /**
	        * Pass constructed ISO BMFF track and boxes on to the
	        * next stream in the pipeline
	       **/
	      this.flush = function () {
	        var frames, gopForFusion, gops, moof, mdat, boxes;
	
	        // Throw away nalUnits at the start of the byte stream until
	        // we find the first AUD
	        while (nalUnits.length) {
	          if (nalUnits[0].nalUnitType === 'access_unit_delimiter_rbsp') {
	            break;
	          }
	          nalUnits.shift();
	        }
	
	        // Return early if no video data has been observed
	        if (nalUnits.length === 0) {
	          this.resetStream_();
	          this.trigger('done', 'VideoSegmentStream');
	          return;
	        }
	
	        // Organize the raw nal-units into arrays that represent
	        // higher-level constructs such as frames and gops
	        // (group-of-pictures)
	        frames = frameUtils.groupNalsIntoFrames(nalUnits);
	        gops = frameUtils.groupFramesIntoGops(frames);
	
	        // If the first frame of this fragment is not a keyframe we have
	        // a problem since MSE (on Chrome) requires a leading keyframe.
	        //
	        // We have two approaches to repairing this situation:
	        // 1) GOP-FUSION:
	        //    This is where we keep track of the GOPS (group-of-pictures)
	        //    from previous fragments and attempt to find one that we can
	        //    prepend to the current fragment in order to create a valid
	        //    fragment.
	        // 2) KEYFRAME-PULLING:
	        //    Here we search for the first keyframe in the fragment and
	        //    throw away all the frames between the start of the fragment
	        //    and that keyframe. We then extend the duration and pull the
	        //    PTS of the keyframe forward so that it covers the time range
	        //    of the frames that were disposed of.
	        //
	        // #1 is far prefereable over #2 which can cause "stuttering" but
	        // requires more things to be just right.
	        if (!gops[0][0].keyFrame) {
	          // Search for a gop for fusion from our gopCache
	          gopForFusion = this.getGopForFusion_(nalUnits[0], track);
	
	          if (gopForFusion) {
	            gops.unshift(gopForFusion);
	            // Adjust Gops' metadata to account for the inclusion of the
	            // new gop at the beginning
	            gops.byteLength += gopForFusion.byteLength;
	            gops.nalCount += gopForFusion.nalCount;
	            gops.pts = gopForFusion.pts;
	            gops.dts = gopForFusion.dts;
	            gops.duration += gopForFusion.duration;
	          } else {
	            // If we didn't find a candidate gop fall back to keyframe-pulling
	            gops = frameUtils.extendFirstKeyFrame(gops);
	          }
	        }
	
	        // Trim gops to align with gopsToAlignWith
	        if (gopsToAlignWith.length) {
	          var alignedGops;
	
	          if (options.alignGopsAtEnd) {
	            alignedGops = this.alignGopsAtEnd_(gops);
	          } else {
	            alignedGops = this.alignGopsAtStart_(gops);
	          }
	
	          if (!alignedGops) {
	            // save all the nals in the last GOP into the gop cache
	            this.gopCache_.unshift({
	              gop: gops.pop(),
	              pps: track.pps,
	              sps: track.sps
	            });
	
	            // Keep a maximum of 6 GOPs in the cache
	            this.gopCache_.length = Math.min(6, this.gopCache_.length);
	
	            // Clear nalUnits
	            nalUnits = [];
	
	            // return early no gops can be aligned with desired gopsToAlignWith
	            this.resetStream_();
	            this.trigger('done', 'VideoSegmentStream');
	            return;
	          }
	
	          // Some gops were trimmed. clear dts info so minSegmentDts and pts are correct
	          // when recalculated before sending off to CoalesceStream
	          trackDecodeInfo.clearDtsInfo(track);
	
	          gops = alignedGops;
	        }
	
	        trackDecodeInfo.collectDtsInfo(track, gops);
	
	        // First, we have to build the index from byte locations to
	        // samples (that is, frames) in the video data
	        track.samples = frameUtils.generateSampleTable(gops);
	
	        // Concatenate the video data and construct the mdat
	        mdat = mp4Generator.mdat(frameUtils.concatenateNalData(gops));
	
	        track.baseMediaDecodeTime = trackDecodeInfo.calculateTrackBaseMediaDecodeTime(track, options.keepOriginalTimestamps);
	
	        this.trigger('processedGopsInfo', gops.map(function (gop) {
	          return {
	            pts: gop.pts,
	            dts: gop.dts,
	            byteLength: gop.byteLength
	          };
	        }));
	
	        // save all the nals in the last GOP into the gop cache
	        this.gopCache_.unshift({
	          gop: gops.pop(),
	          pps: track.pps,
	          sps: track.sps
	        });
	
	        // Keep a maximum of 6 GOPs in the cache
	        this.gopCache_.length = Math.min(6, this.gopCache_.length);
	
	        // Clear nalUnits
	        nalUnits = [];
	
	        this.trigger('baseMediaDecodeTime', track.baseMediaDecodeTime);
	        this.trigger('timelineStartInfo', track.timelineStartInfo);
	
	        moof = mp4Generator.moof(sequenceNumber, [track]);
	
	        // it would be great to allocate this array up front instead of
	        // throwing away hundreds of media segment fragments
	        boxes = new Uint8Array(moof.byteLength + mdat.byteLength);
	
	        // Bump the sequence number for next time
	        sequenceNumber++;
	
	        boxes.set(moof);
	        boxes.set(mdat, moof.byteLength);
	
	        this.trigger('data', { track: track, boxes: boxes });
	
	        this.resetStream_();
	
	        // Continue with the flush process now
	        this.trigger('done', 'VideoSegmentStream');
	      };
	
	      this.resetStream_ = function () {
	        trackDecodeInfo.clearDtsInfo(track);
	
	        // reset config and pps because they may differ across segments
	        // for instance, when we are rendition switching
	        config = undefined;
	        pps = undefined;
	      };
	
	      // Search for a candidate Gop for gop-fusion from the gop cache and
	      // return it or return null if no good candidate was found
	      this.getGopForFusion_ = function (nalUnit) {
	        var halfSecond = 45000,
	
	
	        // Half-a-second in a 90khz clock
	        allowableOverlap = 10000,
	
	
	        // About 3 frames @ 30fps
	        nearestDistance = Infinity,
	            dtsDistance,
	            nearestGopObj,
	            currentGop,
	            currentGopObj,
	            i;
	
	        // Search for the GOP nearest to the beginning of this nal unit
	        for (i = 0; i < this.gopCache_.length; i++) {
	          currentGopObj = this.gopCache_[i];
	          currentGop = currentGopObj.gop;
	
	          // Reject Gops with different SPS or PPS
	          if (!(track.pps && arrayEquals(track.pps[0], currentGopObj.pps[0])) || !(track.sps && arrayEquals(track.sps[0], currentGopObj.sps[0]))) {
	            continue;
	          }
	
	          // Reject Gops that would require a negative baseMediaDecodeTime
	          if (currentGop.dts < track.timelineStartInfo.dts) {
	            continue;
	          }
	
	          // The distance between the end of the gop and the start of the nalUnit
	          dtsDistance = nalUnit.dts - currentGop.dts - currentGop.duration;
	
	          // Only consider GOPS that start before the nal unit and end within
	          // a half-second of the nal unit
	          if (dtsDistance >= -allowableOverlap && dtsDistance <= halfSecond) {
	
	            // Always use the closest GOP we found if there is more than
	            // one candidate
	            if (!nearestGopObj || nearestDistance > dtsDistance) {
	              nearestGopObj = currentGopObj;
	              nearestDistance = dtsDistance;
	            }
	          }
	        }
	
	        if (nearestGopObj) {
	          return nearestGopObj.gop;
	        }
	        return null;
	      };
	
	      // trim gop list to the first gop found that has a matching pts with a gop in the list
	      // of gopsToAlignWith starting from the START of the list
	      this.alignGopsAtStart_ = function (gops) {
	        var alignIndex, gopIndex, align, gop, byteLength, nalCount, duration, alignedGops;
	
	        byteLength = gops.byteLength;
	        nalCount = gops.nalCount;
	        duration = gops.duration;
	        alignIndex = gopIndex = 0;
	
	        while (alignIndex < gopsToAlignWith.length && gopIndex < gops.length) {
	          align = gopsToAlignWith[alignIndex];
	          gop = gops[gopIndex];
	
	          if (align.pts === gop.pts) {
	            break;
	          }
	
	          if (gop.pts > align.pts) {
	            // this current gop starts after the current gop we want to align on, so increment
	            // align index
	            alignIndex++;
	            continue;
	          }
	
	          // current gop starts before the current gop we want to align on. so increment gop
	          // index
	          gopIndex++;
	          byteLength -= gop.byteLength;
	          nalCount -= gop.nalCount;
	          duration -= gop.duration;
	        }
	
	        if (gopIndex === 0) {
	          // no gops to trim
	          return gops;
	        }
	
	        if (gopIndex === gops.length) {
	          // all gops trimmed, skip appending all gops
	          return null;
	        }
	
	        alignedGops = gops.slice(gopIndex);
	        alignedGops.byteLength = byteLength;
	        alignedGops.duration = duration;
	        alignedGops.nalCount = nalCount;
	        alignedGops.pts = alignedGops[0].pts;
	        alignedGops.dts = alignedGops[0].dts;
	
	        return alignedGops;
	      };
	
	      // trim gop list to the first gop found that has a matching pts with a gop in the list
	      // of gopsToAlignWith starting from the END of the list
	      this.alignGopsAtEnd_ = function (gops) {
	        var alignIndex, gopIndex, align, gop, alignEndIndex, matchFound;
	
	        alignIndex = gopsToAlignWith.length - 1;
	        gopIndex = gops.length - 1;
	        alignEndIndex = null;
	        matchFound = false;
	
	        while (alignIndex >= 0 && gopIndex >= 0) {
	          align = gopsToAlignWith[alignIndex];
	          gop = gops[gopIndex];
	
	          if (align.pts === gop.pts) {
	            matchFound = true;
	            break;
	          }
	
	          if (align.pts > gop.pts) {
	            alignIndex--;
	            continue;
	          }
	
	          if (alignIndex === gopsToAlignWith.length - 1) {
	            // gop.pts is greater than the last alignment candidate. If no match is found
	            // by the end of this loop, we still want to append gops that come after this
	            // point
	            alignEndIndex = gopIndex;
	          }
	
	          gopIndex--;
	        }
	
	        if (!matchFound && alignEndIndex === null) {
	          return null;
	        }
	
	        var trimIndex;
	
	        if (matchFound) {
	          trimIndex = gopIndex;
	        } else {
	          trimIndex = alignEndIndex;
	        }
	
	        if (trimIndex === 0) {
	          return gops;
	        }
	
	        var alignedGops = gops.slice(trimIndex);
	        var metadata = alignedGops.reduce(function (total, gop) {
	          total.byteLength += gop.byteLength;
	          total.duration += gop.duration;
	          total.nalCount += gop.nalCount;
	          return total;
	        }, { byteLength: 0, duration: 0, nalCount: 0 });
	
	        alignedGops.byteLength = metadata.byteLength;
	        alignedGops.duration = metadata.duration;
	        alignedGops.nalCount = metadata.nalCount;
	        alignedGops.pts = alignedGops[0].pts;
	        alignedGops.dts = alignedGops[0].dts;
	
	        return alignedGops;
	      };
	
	      this.alignGopsWith = function (newGopsToAlignWith) {
	        gopsToAlignWith = newGopsToAlignWith;
	      };
	    };
	
	    _VideoSegmentStream.prototype = new stream();
	
	    /**
	     * A Stream that can combine multiple streams (ie. audio & video)
	     * into a single output segment for MSE. Also supports audio-only
	     * and video-only streams.
	     */
	    _CoalesceStream = function CoalesceStream(options, metadataStream) {
	      // Number of Tracks per output segment
	      // If greater than 1, we combine multiple
	      // tracks into a single segment
	      this.numberOfTracks = 0;
	      this.metadataStream = metadataStream;
	
	      if (typeof options.remux !== 'undefined') {
	        this.remuxTracks = !!options.remux;
	      } else {
	        this.remuxTracks = true;
	      }
	
	      this.pendingTracks = [];
	      this.videoTrack = null;
	      this.pendingBoxes = [];
	      this.pendingCaptions = [];
	      this.pendingMetadata = [];
	      this.pendingBytes = 0;
	      this.emittedTracks = 0;
	
	      _CoalesceStream.prototype.init.call(this);
	
	      // Take output from multiple
	      this.push = function (output) {
	        // buffer incoming captions until the associated video segment
	        // finishes
	        if (output.text) {
	          return this.pendingCaptions.push(output);
	        }
	        // buffer incoming id3 tags until the final flush
	        if (output.frames) {
	          return this.pendingMetadata.push(output);
	        }
	
	        // Add this track to the list of pending tracks and store
	        // important information required for the construction of
	        // the final segment
	        this.pendingTracks.push(output.track);
	        this.pendingBoxes.push(output.boxes);
	        this.pendingBytes += output.boxes.byteLength;
	
	        if (output.track.type === 'video') {
	          this.videoTrack = output.track;
	        }
	        if (output.track.type === 'audio') {
	          this.audioTrack = output.track;
	        }
	      };
	    };
	
	    _CoalesceStream.prototype = new stream();
	    _CoalesceStream.prototype.flush = function (flushSource) {
	      var offset = 0,
	          event = {
	        captions: [],
	        captionStreams: {},
	        metadata: [],
	        info: {}
	      },
	          caption,
	          id3,
	          initSegment,
	          timelineStartPts = 0,
	          i;
	
	      if (this.pendingTracks.length < this.numberOfTracks) {
	        if (flushSource !== 'VideoSegmentStream' && flushSource !== 'AudioSegmentStream') {
	          // Return because we haven't received a flush from a data-generating
	          // portion of the segment (meaning that we have only recieved meta-data
	          // or captions.)
	          return;
	        } else if (this.remuxTracks) {
	          // Return until we have enough tracks from the pipeline to remux (if we
	          // are remuxing audio and video into a single MP4)
	          return;
	        } else if (this.pendingTracks.length === 0) {
	          // In the case where we receive a flush without any data having been
	          // received we consider it an emitted track for the purposes of coalescing
	          // `done` events.
	          // We do this for the case where there is an audio and video track in the
	          // segment but no audio data. (seen in several playlists with alternate
	          // audio tracks and no audio present in the main TS segments.)
	          this.emittedTracks++;
	
	          if (this.emittedTracks >= this.numberOfTracks) {
	            this.trigger('done');
	            this.emittedTracks = 0;
	          }
	          return;
	        }
	      }
	
	      if (this.videoTrack) {
	        timelineStartPts = this.videoTrack.timelineStartInfo.pts;
	        VIDEO_PROPERTIES.forEach(function (prop) {
	          event.info[prop] = this.videoTrack[prop];
	        }, this);
	      } else if (this.audioTrack) {
	        timelineStartPts = this.audioTrack.timelineStartInfo.pts;
	        AUDIO_PROPERTIES.forEach(function (prop) {
	          event.info[prop] = this.audioTrack[prop];
	        }, this);
	      }
	
	      if (this.pendingTracks.length === 1) {
	        event.type = this.pendingTracks[0].type;
	      } else {
	        event.type = 'combined';
	      }
	
	      this.emittedTracks += this.pendingTracks.length;
	
	      initSegment = mp4Generator.initSegment(this.pendingTracks);
	
	      // Create a new typed array to hold the init segment
	      event.initSegment = new Uint8Array(initSegment.byteLength);
	
	      // Create an init segment containing a moov
	      // and track definitions
	      event.initSegment.set(initSegment);
	
	      // Create a new typed array to hold the moof+mdats
	      event.data = new Uint8Array(this.pendingBytes);
	
	      // Append each moof+mdat (one per track) together
	      for (i = 0; i < this.pendingBoxes.length; i++) {
	        event.data.set(this.pendingBoxes[i], offset);
	        offset += this.pendingBoxes[i].byteLength;
	      }
	
	      // Translate caption PTS times into second offsets into the
	      // video timeline for the segment, and add track info
	      for (i = 0; i < this.pendingCaptions.length; i++) {
	        caption = this.pendingCaptions[i];
	        caption.startTime = caption.startPts - timelineStartPts;
	        caption.startTime /= 90e3;
	        caption.endTime = caption.endPts - timelineStartPts;
	        caption.endTime /= 90e3;
	        event.captionStreams[caption.stream] = true;
	        event.captions.push(caption);
	      }
	
	      // Translate ID3 frame PTS times into second offsets into the
	      // video timeline for the segment
	      for (i = 0; i < this.pendingMetadata.length; i++) {
	        id3 = this.pendingMetadata[i];
	        id3.cueTime = id3.pts - timelineStartPts;
	        id3.cueTime /= 90e3;
	        event.metadata.push(id3);
	      }
	      // We add this to every single emitted segment even though we only need
	      // it for the first
	      event.metadata.dispatchType = this.metadataStream.dispatchType;
	
	      // Reset stream state
	      this.pendingTracks.length = 0;
	      this.videoTrack = null;
	      this.pendingBoxes.length = 0;
	      this.pendingCaptions.length = 0;
	      this.pendingBytes = 0;
	      this.pendingMetadata.length = 0;
	
	      // Emit the built segment
	      this.trigger('data', event);
	
	      // Only emit `done` if all tracks have been flushed and emitted
	      if (this.emittedTracks >= this.numberOfTracks) {
	        this.trigger('done');
	        this.emittedTracks = 0;
	      }
	    };
	    /**
	     * A Stream that expects MP2T binary data as input and produces
	     * corresponding media segments, suitable for use with Media Source
	     * Extension (MSE) implementations that support the ISO BMFF byte
	     * stream format, like Chrome.
	     */
	    _Transmuxer = function Transmuxer(options) {
	      var self = this,
	          hasFlushed = true,
	          videoTrack,
	          audioTrack;
	
	      _Transmuxer.prototype.init.call(this);
	
	      options = options || {};
	      this.baseMediaDecodeTime = options.baseMediaDecodeTime || 0;
	      this.transmuxPipeline_ = {};
	
	      this.setupAacPipeline = function () {
	        var pipeline = {};
	        this.transmuxPipeline_ = pipeline;
	
	        pipeline.type = 'aac';
	        pipeline.metadataStream = new m2ts_1.MetadataStream();
	
	        // set up the parsing pipeline
	        pipeline.aacStream = new aac();
	        pipeline.audioTimestampRolloverStream = new m2ts_1.TimestampRolloverStream('audio');
	        pipeline.timedMetadataTimestampRolloverStream = new m2ts_1.TimestampRolloverStream('timed-metadata');
	        pipeline.adtsStream = new adts();
	        pipeline.coalesceStream = new _CoalesceStream(options, pipeline.metadataStream);
	        pipeline.headOfPipeline = pipeline.aacStream;
	
	        pipeline.aacStream.pipe(pipeline.audioTimestampRolloverStream).pipe(pipeline.adtsStream);
	        pipeline.aacStream.pipe(pipeline.timedMetadataTimestampRolloverStream).pipe(pipeline.metadataStream).pipe(pipeline.coalesceStream);
	
	        pipeline.metadataStream.on('timestamp', function (frame) {
	          pipeline.aacStream.setTimestamp(frame.timeStamp);
	        });
	
	        pipeline.aacStream.on('data', function (data) {
	          if (data.type === 'timed-metadata' && !pipeline.audioSegmentStream) {
	            audioTrack = audioTrack || {
	              timelineStartInfo: {
	                baseMediaDecodeTime: self.baseMediaDecodeTime
	              },
	              codec: 'adts',
	              type: 'audio'
	            };
	            // hook up the audio segment stream to the first track with aac data
	            pipeline.coalesceStream.numberOfTracks++;
	            pipeline.audioSegmentStream = new _AudioSegmentStream(audioTrack, options);
	            // Set up the final part of the audio pipeline
	            pipeline.adtsStream.pipe(pipeline.audioSegmentStream).pipe(pipeline.coalesceStream);
	          }
	        });
	
	        // Re-emit any data coming from the coalesce stream to the outside world
	        pipeline.coalesceStream.on('data', this.trigger.bind(this, 'data'));
	        // Let the consumer know we have finished flushing the entire pipeline
	        pipeline.coalesceStream.on('done', this.trigger.bind(this, 'done'));
	      };
	
	      this.setupTsPipeline = function () {
	        var pipeline = {};
	        this.transmuxPipeline_ = pipeline;
	
	        pipeline.type = 'ts';
	        pipeline.metadataStream = new m2ts_1.MetadataStream();
	
	        // set up the parsing pipeline
	        pipeline.packetStream = new m2ts_1.TransportPacketStream();
	        pipeline.parseStream = new m2ts_1.TransportParseStream();
	        pipeline.elementaryStream = new m2ts_1.ElementaryStream();
	        pipeline.videoTimestampRolloverStream = new m2ts_1.TimestampRolloverStream('video');
	        pipeline.audioTimestampRolloverStream = new m2ts_1.TimestampRolloverStream('audio');
	        pipeline.timedMetadataTimestampRolloverStream = new m2ts_1.TimestampRolloverStream('timed-metadata');
	        pipeline.adtsStream = new adts();
	        pipeline.h264Stream = new H264Stream();
	        pipeline.captionStream = new m2ts_1.CaptionStream();
	        pipeline.coalesceStream = new _CoalesceStream(options, pipeline.metadataStream);
	        pipeline.headOfPipeline = pipeline.packetStream;
	
	        // disassemble MPEG2-TS packets into elementary streams
	        pipeline.packetStream.pipe(pipeline.parseStream).pipe(pipeline.elementaryStream);
	
	        // !!THIS ORDER IS IMPORTANT!!
	        // demux the streams
	        pipeline.elementaryStream.pipe(pipeline.videoTimestampRolloverStream).pipe(pipeline.h264Stream);
	        pipeline.elementaryStream.pipe(pipeline.audioTimestampRolloverStream).pipe(pipeline.adtsStream);
	
	        pipeline.elementaryStream.pipe(pipeline.timedMetadataTimestampRolloverStream).pipe(pipeline.metadataStream).pipe(pipeline.coalesceStream);
	
	        // Hook up CEA-608/708 caption stream
	        pipeline.h264Stream.pipe(pipeline.captionStream).pipe(pipeline.coalesceStream);
	
	        pipeline.elementaryStream.on('data', function (data) {
	          var i;
	
	          if (data.type === 'metadata') {
	            i = data.tracks.length;
	
	            // scan the tracks listed in the metadata
	            while (i--) {
	              if (!videoTrack && data.tracks[i].type === 'video') {
	                videoTrack = data.tracks[i];
	                videoTrack.timelineStartInfo.baseMediaDecodeTime = self.baseMediaDecodeTime;
	              } else if (!audioTrack && data.tracks[i].type === 'audio') {
	                audioTrack = data.tracks[i];
	                audioTrack.timelineStartInfo.baseMediaDecodeTime = self.baseMediaDecodeTime;
	              }
	            }
	
	            // hook up the video segment stream to the first track with h264 data
	            if (videoTrack && !pipeline.videoSegmentStream) {
	              pipeline.coalesceStream.numberOfTracks++;
	              pipeline.videoSegmentStream = new _VideoSegmentStream(videoTrack, options);
	
	              pipeline.videoSegmentStream.on('timelineStartInfo', function (timelineStartInfo) {
	                // When video emits timelineStartInfo data after a flush, we forward that
	                // info to the AudioSegmentStream, if it exists, because video timeline
	                // data takes precedence.
	                if (audioTrack) {
	                  audioTrack.timelineStartInfo = timelineStartInfo;
	                  // On the first segment we trim AAC frames that exist before the
	                  // very earliest DTS we have seen in video because Chrome will
	                  // interpret any video track with a baseMediaDecodeTime that is
	                  // non-zero as a gap.
	                  pipeline.audioSegmentStream.setEarliestDts(timelineStartInfo.dts);
	                }
	              });
	
	              pipeline.videoSegmentStream.on('processedGopsInfo', self.trigger.bind(self, 'gopInfo'));
	
	              pipeline.videoSegmentStream.on('baseMediaDecodeTime', function (baseMediaDecodeTime) {
	                if (audioTrack) {
	                  pipeline.audioSegmentStream.setVideoBaseMediaDecodeTime(baseMediaDecodeTime);
	                }
	              });
	
	              // Set up the final part of the video pipeline
	              pipeline.h264Stream.pipe(pipeline.videoSegmentStream).pipe(pipeline.coalesceStream);
	            }
	
	            if (audioTrack && !pipeline.audioSegmentStream) {
	              // hook up the audio segment stream to the first track with aac data
	              pipeline.coalesceStream.numberOfTracks++;
	              pipeline.audioSegmentStream = new _AudioSegmentStream(audioTrack, options);
	
	              // Set up the final part of the audio pipeline
	              pipeline.adtsStream.pipe(pipeline.audioSegmentStream).pipe(pipeline.coalesceStream);
	            }
	          }
	        });
	
	        // Re-emit any data coming from the coalesce stream to the outside world
	        pipeline.coalesceStream.on('data', this.trigger.bind(this, 'data'));
	        // Let the consumer know we have finished flushing the entire pipeline
	        pipeline.coalesceStream.on('done', this.trigger.bind(this, 'done'));
	      };
	
	      // hook up the segment streams once track metadata is delivered
	      this.setBaseMediaDecodeTime = function (baseMediaDecodeTime) {
	        var pipeline = this.transmuxPipeline_;
	
	        this.baseMediaDecodeTime = baseMediaDecodeTime;
	        if (audioTrack) {
	          audioTrack.timelineStartInfo.dts = undefined;
	          audioTrack.timelineStartInfo.pts = undefined;
	          trackDecodeInfo.clearDtsInfo(audioTrack);
	          audioTrack.timelineStartInfo.baseMediaDecodeTime = baseMediaDecodeTime;
	          if (pipeline.audioTimestampRolloverStream) {
	            pipeline.audioTimestampRolloverStream.discontinuity();
	          }
	        }
	        if (videoTrack) {
	          if (pipeline.videoSegmentStream) {
	            pipeline.videoSegmentStream.gopCache_ = [];
	            pipeline.videoTimestampRolloverStream.discontinuity();
	          }
	          videoTrack.timelineStartInfo.dts = undefined;
	          videoTrack.timelineStartInfo.pts = undefined;
	          trackDecodeInfo.clearDtsInfo(videoTrack);
	          pipeline.captionStream.reset();
	          videoTrack.timelineStartInfo.baseMediaDecodeTime = baseMediaDecodeTime;
	        }
	
	        if (pipeline.timedMetadataTimestampRolloverStream) {
	          pipeline.timedMetadataTimestampRolloverStream.discontinuity();
	        }
	      };
	
	      this.setAudioAppendStart = function (timestamp) {
	        if (audioTrack) {
	          this.transmuxPipeline_.audioSegmentStream.setAudioAppendStart(timestamp);
	        }
	      };
	
	      this.alignGopsWith = function (gopsToAlignWith) {
	        if (videoTrack && this.transmuxPipeline_.videoSegmentStream) {
	          this.transmuxPipeline_.videoSegmentStream.alignGopsWith(gopsToAlignWith);
	        }
	      };
	
	      // feed incoming data to the front of the parsing pipeline
	      this.push = function (data) {
	        if (hasFlushed) {
	          var isAac = isLikelyAacData(data);
	
	          if (isAac && this.transmuxPipeline_.type !== 'aac') {
	            this.setupAacPipeline();
	          } else if (!isAac && this.transmuxPipeline_.type !== 'ts') {
	            this.setupTsPipeline();
	          }
	          hasFlushed = false;
	        }
	        this.transmuxPipeline_.headOfPipeline.push(data);
	      };
	
	      // flush any buffered data
	      this.flush = function () {
	        hasFlushed = true;
	        // Start at the top of the pipeline and flush all pending work
	        this.transmuxPipeline_.headOfPipeline.flush();
	      };
	
	      // Caption data has to be reset when seeking outside buffered range
	      this.resetCaptions = function () {
	        if (this.transmuxPipeline_.captionStream) {
	          this.transmuxPipeline_.captionStream.reset();
	        }
	      };
	    };
	    _Transmuxer.prototype = new stream();
	
	    var transmuxer = {
	      Transmuxer: _Transmuxer,
	      VideoSegmentStream: _VideoSegmentStream,
	      AudioSegmentStream: _AudioSegmentStream,
	      AUDIO_PROPERTIES: AUDIO_PROPERTIES,
	      VIDEO_PROPERTIES: VIDEO_PROPERTIES
	    };
	
	    var inspectMp4,
	        _textifyMp,
	        parseType$1 = probe.parseType,
	        parseMp4Date = function parseMp4Date(seconds) {
	      return new Date(seconds * 1000 - 2082844800000);
	    },
	        parseSampleFlags = function parseSampleFlags(flags) {
	      return {
	        isLeading: (flags[0] & 0x0c) >>> 2,
	        dependsOn: flags[0] & 0x03,
	        isDependedOn: (flags[1] & 0xc0) >>> 6,
	        hasRedundancy: (flags[1] & 0x30) >>> 4,
	        paddingValue: (flags[1] & 0x0e) >>> 1,
	        isNonSyncSample: flags[1] & 0x01,
	        degradationPriority: flags[2] << 8 | flags[3]
	      };
	    },
	        nalParse = function nalParse(avcStream) {
	      var avcView = new DataView(avcStream.buffer, avcStream.byteOffset, avcStream.byteLength),
	          result = [],
	          i,
	          length;
	      for (i = 0; i + 4 < avcStream.length; i += length) {
	        length = avcView.getUint32(i);
	        i += 4;
	
	        // bail if this doesn't appear to be an H264 stream
	        if (length <= 0) {
	          result.push('<span style=\'color:red;\'>MALFORMED DATA</span>');
	          continue;
	        }
	
	        switch (avcStream[i] & 0x1F) {
	          case 0x01:
	            result.push('slice_layer_without_partitioning_rbsp');
	            break;
	          case 0x05:
	            result.push('slice_layer_without_partitioning_rbsp_idr');
	            break;
	          case 0x06:
	            result.push('sei_rbsp');
	            break;
	          case 0x07:
	            result.push('seq_parameter_set_rbsp');
	            break;
	          case 0x08:
	            result.push('pic_parameter_set_rbsp');
	            break;
	          case 0x09:
	            result.push('access_unit_delimiter_rbsp');
	            break;
	          default:
	            result.push('UNKNOWN NAL - ' + avcStream[i] & 0x1F);
	            break;
	        }
	      }
	      return result;
	    },
	
	
	    // registry of handlers for individual mp4 box types
	    parse$$1 = {
	      // codingname, not a first-class box type. stsd entries share the
	      // same format as real boxes so the parsing infrastructure can be
	      // shared
	      avc1: function avc1(data) {
	        var view = new DataView(data.buffer, data.byteOffset, data.byteLength);
	        return {
	          dataReferenceIndex: view.getUint16(6),
	          width: view.getUint16(24),
	          height: view.getUint16(26),
	          horizresolution: view.getUint16(28) + view.getUint16(30) / 16,
	          vertresolution: view.getUint16(32) + view.getUint16(34) / 16,
	          frameCount: view.getUint16(40),
	          depth: view.getUint16(74),
	          config: inspectMp4(data.subarray(78, data.byteLength))
	        };
	      },
	      avcC: function avcC(data) {
	        var view = new DataView(data.buffer, data.byteOffset, data.byteLength),
	            result = {
	          configurationVersion: data[0],
	          avcProfileIndication: data[1],
	          profileCompatibility: data[2],
	          avcLevelIndication: data[3],
	          lengthSizeMinusOne: data[4] & 0x03,
	          sps: [],
	          pps: []
	        },
	            numOfSequenceParameterSets = data[5] & 0x1f,
	            numOfPictureParameterSets,
	            nalSize,
	            offset,
	            i;
	
	        // iterate past any SPSs
	        offset = 6;
	        for (i = 0; i < numOfSequenceParameterSets; i++) {
	          nalSize = view.getUint16(offset);
	          offset += 2;
	          result.sps.push(new Uint8Array(data.subarray(offset, offset + nalSize)));
	          offset += nalSize;
	        }
	        // iterate past any PPSs
	        numOfPictureParameterSets = data[offset];
	        offset++;
	        for (i = 0; i < numOfPictureParameterSets; i++) {
	          nalSize = view.getUint16(offset);
	          offset += 2;
	          result.pps.push(new Uint8Array(data.subarray(offset, offset + nalSize)));
	          offset += nalSize;
	        }
	        return result;
	      },
	      btrt: function btrt(data) {
	        var view = new DataView(data.buffer, data.byteOffset, data.byteLength);
	        return {
	          bufferSizeDB: view.getUint32(0),
	          maxBitrate: view.getUint32(4),
	          avgBitrate: view.getUint32(8)
	        };
	      },
	      esds: function esds(data) {
	        return {
	          version: data[0],
	          flags: new Uint8Array(data.subarray(1, 4)),
	          esId: data[6] << 8 | data[7],
	          streamPriority: data[8] & 0x1f,
	          decoderConfig: {
	            objectProfileIndication: data[11],
	            streamType: data[12] >>> 2 & 0x3f,
	            bufferSize: data[13] << 16 | data[14] << 8 | data[15],
	            maxBitrate: data[16] << 24 | data[17] << 16 | data[18] << 8 | data[19],
	            avgBitrate: data[20] << 24 | data[21] << 16 | data[22] << 8 | data[23],
	            decoderConfigDescriptor: {
	              tag: data[24],
	              length: data[25],
	              audioObjectType: data[26] >>> 3 & 0x1f,
	              samplingFrequencyIndex: (data[26] & 0x07) << 1 | data[27] >>> 7 & 0x01,
	              channelConfiguration: data[27] >>> 3 & 0x0f
	            }
	          }
	        };
	      },
	      ftyp: function ftyp(data) {
	        var view = new DataView(data.buffer, data.byteOffset, data.byteLength),
	            result = {
	          majorBrand: parseType$1(data.subarray(0, 4)),
	          minorVersion: view.getUint32(4),
	          compatibleBrands: []
	        },
	            i = 8;
	        while (i < data.byteLength) {
	          result.compatibleBrands.push(parseType$1(data.subarray(i, i + 4)));
	          i += 4;
	        }
	        return result;
	      },
	      dinf: function dinf(data) {
	        return {
	          boxes: inspectMp4(data)
	        };
	      },
	      dref: function dref(data) {
	        return {
	          version: data[0],
	          flags: new Uint8Array(data.subarray(1, 4)),
	          dataReferences: inspectMp4(data.subarray(8))
	        };
	      },
	      hdlr: function hdlr(data) {
	        var view = new DataView(data.buffer, data.byteOffset, data.byteLength),
	            result = {
	          version: view.getUint8(0),
	          flags: new Uint8Array(data.subarray(1, 4)),
	          handlerType: parseType$1(data.subarray(8, 12)),
	          name: ''
	        },
	            i = 8;
	
	        // parse out the name field
	        for (i = 24; i < data.byteLength; i++) {
	          if (data[i] === 0x00) {
	            // the name field is null-terminated
	            i++;
	            break;
	          }
	          result.name += String.fromCharCode(data[i]);
	        }
	        // decode UTF-8 to javascript's internal representation
	        // see http://ecmanaut.blogspot.com/2006/07/encoding-decoding-utf8-in-javascript.html
	        result.name = decodeURIComponent(escape(result.name));
	
	        return result;
	      },
	      mdat: function mdat(data) {
	        return {
	          byteLength: data.byteLength,
	          nals: nalParse(data)
	        };
	      },
	      mdhd: function mdhd(data) {
	        var view = new DataView(data.buffer, data.byteOffset, data.byteLength),
	            i = 4,
	            language,
	            result = {
	          version: view.getUint8(0),
	          flags: new Uint8Array(data.subarray(1, 4)),
	          language: ''
	        };
	        if (result.version === 1) {
	          i += 4;
	          result.creationTime = parseMp4Date(view.getUint32(i)); // truncating top 4 bytes
	          i += 8;
	          result.modificationTime = parseMp4Date(view.getUint32(i)); // truncating top 4 bytes
	          i += 4;
	          result.timescale = view.getUint32(i);
	          i += 8;
	          result.duration = view.getUint32(i); // truncating top 4 bytes
	        } else {
	          result.creationTime = parseMp4Date(view.getUint32(i));
	          i += 4;
	          result.modificationTime = parseMp4Date(view.getUint32(i));
	          i += 4;
	          result.timescale = view.getUint32(i);
	          i += 4;
	          result.duration = view.getUint32(i);
	        }
	        i += 4;
	        // language is stored as an ISO-639-2/T code in an array of three 5-bit fields
	        // each field is the packed difference between its ASCII value and 0x60
	        language = view.getUint16(i);
	        result.language += String.fromCharCode((language >> 10) + 0x60);
	        result.language += String.fromCharCode(((language & 0x03e0) >> 5) + 0x60);
	        result.language += String.fromCharCode((language & 0x1f) + 0x60);
	
	        return result;
	      },
	      mdia: function mdia(data) {
	        return {
	          boxes: inspectMp4(data)
	        };
	      },
	      mfhd: function mfhd(data) {
	        return {
	          version: data[0],
	          flags: new Uint8Array(data.subarray(1, 4)),
	          sequenceNumber: data[4] << 24 | data[5] << 16 | data[6] << 8 | data[7]
	        };
	      },
	      minf: function minf(data) {
	        return {
	          boxes: inspectMp4(data)
	        };
	      },
	      // codingname, not a first-class box type. stsd entries share the
	      // same format as real boxes so the parsing infrastructure can be
	      // shared
	      mp4a: function mp4a(data) {
	        var view = new DataView(data.buffer, data.byteOffset, data.byteLength),
	            result = {
	          // 6 bytes reserved
	          dataReferenceIndex: view.getUint16(6),
	          // 4 + 4 bytes reserved
	          channelcount: view.getUint16(16),
	          samplesize: view.getUint16(18),
	          // 2 bytes pre_defined
	          // 2 bytes reserved
	          samplerate: view.getUint16(24) + view.getUint16(26) / 65536
	        };
	
	        // if there are more bytes to process, assume this is an ISO/IEC
	        // 14496-14 MP4AudioSampleEntry and parse the ESDBox
	        if (data.byteLength > 28) {
	          result.streamDescriptor = inspectMp4(data.subarray(28))[0];
	        }
	        return result;
	      },
	      moof: function moof(data) {
	        return {
	          boxes: inspectMp4(data)
	        };
	      },
	      moov: function moov(data) {
	        return {
	          boxes: inspectMp4(data)
	        };
	      },
	      mvex: function mvex(data) {
	        return {
	          boxes: inspectMp4(data)
	        };
	      },
	      mvhd: function mvhd(data) {
	        var view = new DataView(data.buffer, data.byteOffset, data.byteLength),
	            i = 4,
	            result = {
	          version: view.getUint8(0),
	          flags: new Uint8Array(data.subarray(1, 4))
	        };
	
	        if (result.version === 1) {
	          i += 4;
	          result.creationTime = parseMp4Date(view.getUint32(i)); // truncating top 4 bytes
	          i += 8;
	          result.modificationTime = parseMp4Date(view.getUint32(i)); // truncating top 4 bytes
	          i += 4;
	          result.timescale = view.getUint32(i);
	          i += 8;
	          result.duration = view.getUint32(i); // truncating top 4 bytes
	        } else {
	          result.creationTime = parseMp4Date(view.getUint32(i));
	          i += 4;
	          result.modificationTime = parseMp4Date(view.getUint32(i));
	          i += 4;
	          result.timescale = view.getUint32(i);
	          i += 4;
	          result.duration = view.getUint32(i);
	        }
	        i += 4;
	
	        // convert fixed-point, base 16 back to a number
	        result.rate = view.getUint16(i) + view.getUint16(i + 2) / 16;
	        i += 4;
	        result.volume = view.getUint8(i) + view.getUint8(i + 1) / 8;
	        i += 2;
	        i += 2;
	        i += 2 * 4;
	        result.matrix = new Uint32Array(data.subarray(i, i + 9 * 4));
	        i += 9 * 4;
	        i += 6 * 4;
	        result.nextTrackId = view.getUint32(i);
	        return result;
	      },
	      pdin: function pdin(data) {
	        var view = new DataView(data.buffer, data.byteOffset, data.byteLength);
	        return {
	          version: view.getUint8(0),
	          flags: new Uint8Array(data.subarray(1, 4)),
	          rate: view.getUint32(4),
	          initialDelay: view.getUint32(8)
	        };
	      },
	      sdtp: function sdtp(data) {
	        var result = {
	          version: data[0],
	          flags: new Uint8Array(data.subarray(1, 4)),
	          samples: []
	        },
	            i;
	
	        for (i = 4; i < data.byteLength; i++) {
	          result.samples.push({
	            dependsOn: (data[i] & 0x30) >> 4,
	            isDependedOn: (data[i] & 0x0c) >> 2,
	            hasRedundancy: data[i] & 0x03
	          });
	        }
	        return result;
	      },
	      sidx: function sidx(data) {
	        var view = new DataView(data.buffer, data.byteOffset, data.byteLength),
	            result = {
	          version: data[0],
	          flags: new Uint8Array(data.subarray(1, 4)),
	          references: [],
	          referenceId: view.getUint32(4),
	          timescale: view.getUint32(8),
	          earliestPresentationTime: view.getUint32(12),
	          firstOffset: view.getUint32(16)
	        },
	            referenceCount = view.getUint16(22),
	            i;
	
	        for (i = 24; referenceCount; i += 12, referenceCount--) {
	          result.references.push({
	            referenceType: (data[i] & 0x80) >>> 7,
	            referencedSize: view.getUint32(i) & 0x7FFFFFFF,
	            subsegmentDuration: view.getUint32(i + 4),
	            startsWithSap: !!(data[i + 8] & 0x80),
	            sapType: (data[i + 8] & 0x70) >>> 4,
	            sapDeltaTime: view.getUint32(i + 8) & 0x0FFFFFFF
	          });
	        }
	
	        return result;
	      },
	      smhd: function smhd(data) {
	        return {
	          version: data[0],
	          flags: new Uint8Array(data.subarray(1, 4)),
	          balance: data[4] + data[5] / 256
	        };
	      },
	      stbl: function stbl(data) {
	        return {
	          boxes: inspectMp4(data)
	        };
	      },
	      stco: function stco(data) {
	        var view = new DataView(data.buffer, data.byteOffset, data.byteLength),
	            result = {
	          version: data[0],
	          flags: new Uint8Array(data.subarray(1, 4)),
	          chunkOffsets: []
	        },
	            entryCount = view.getUint32(4),
	            i;
	        for (i = 8; entryCount; i += 4, entryCount--) {
	          result.chunkOffsets.push(view.getUint32(i));
	        }
	        return result;
	      },
	      stsc: function stsc(data) {
	        var view = new DataView(data.buffer, data.byteOffset, data.byteLength),
	            entryCount = view.getUint32(4),
	            result = {
	          version: data[0],
	          flags: new Uint8Array(data.subarray(1, 4)),
	          sampleToChunks: []
	        },
	            i;
	        for (i = 8; entryCount; i += 12, entryCount--) {
	          result.sampleToChunks.push({
	            firstChunk: view.getUint32(i),
	            samplesPerChunk: view.getUint32(i + 4),
	            sampleDescriptionIndex: view.getUint32(i + 8)
	          });
	        }
	        return result;
	      },
	      stsd: function stsd(data) {
	        return {
	          version: data[0],
	          flags: new Uint8Array(data.subarray(1, 4)),
	          sampleDescriptions: inspectMp4(data.subarray(8))
	        };
	      },
	      stsz: function stsz(data) {
	        var view = new DataView(data.buffer, data.byteOffset, data.byteLength),
	            result = {
	          version: data[0],
	          flags: new Uint8Array(data.subarray(1, 4)),
	          sampleSize: view.getUint32(4),
	          entries: []
	        },
	            i;
	        for (i = 12; i < data.byteLength; i += 4) {
	          result.entries.push(view.getUint32(i));
	        }
	        return result;
	      },
	      stts: function stts(data) {
	        var view = new DataView(data.buffer, data.byteOffset, data.byteLength),
	            result = {
	          version: data[0],
	          flags: new Uint8Array(data.subarray(1, 4)),
	          timeToSamples: []
	        },
	            entryCount = view.getUint32(4),
	            i;
	
	        for (i = 8; entryCount; i += 8, entryCount--) {
	          result.timeToSamples.push({
	            sampleCount: view.getUint32(i),
	            sampleDelta: view.getUint32(i + 4)
	          });
	        }
	        return result;
	      },
	      styp: function styp(data) {
	        return parse$$1.ftyp(data);
	      },
	      tfdt: function tfdt(data) {
	        var result = {
	          version: data[0],
	          flags: new Uint8Array(data.subarray(1, 4)),
	          baseMediaDecodeTime: data[4] << 24 | data[5] << 16 | data[6] << 8 | data[7]
	        };
	        if (result.version === 1) {
	          result.baseMediaDecodeTime *= Math.pow(2, 32);
	          result.baseMediaDecodeTime += data[8] << 24 | data[9] << 16 | data[10] << 8 | data[11];
	        }
	        return result;
	      },
	      tfhd: function tfhd(data) {
	        var view = new DataView(data.buffer, data.byteOffset, data.byteLength),
	            result = {
	          version: data[0],
	          flags: new Uint8Array(data.subarray(1, 4)),
	          trackId: view.getUint32(4)
	        },
	            baseDataOffsetPresent = result.flags[2] & 0x01,
	            sampleDescriptionIndexPresent = result.flags[2] & 0x02,
	            defaultSampleDurationPresent = result.flags[2] & 0x08,
	            defaultSampleSizePresent = result.flags[2] & 0x10,
	            defaultSampleFlagsPresent = result.flags[2] & 0x20,
	            durationIsEmpty = result.flags[0] & 0x010000,
	            defaultBaseIsMoof = result.flags[0] & 0x020000,
	            i;
	
	        i = 8;
	        if (baseDataOffsetPresent) {
	          i += 4; // truncate top 4 bytes
	          // FIXME: should we read the full 64 bits?
	          result.baseDataOffset = view.getUint32(12);
	          i += 4;
	        }
	        if (sampleDescriptionIndexPresent) {
	          result.sampleDescriptionIndex = view.getUint32(i);
	          i += 4;
	        }
	        if (defaultSampleDurationPresent) {
	          result.defaultSampleDuration = view.getUint32(i);
	          i += 4;
	        }
	        if (defaultSampleSizePresent) {
	          result.defaultSampleSize = view.getUint32(i);
	          i += 4;
	        }
	        if (defaultSampleFlagsPresent) {
	          result.defaultSampleFlags = view.getUint32(i);
	        }
	        if (durationIsEmpty) {
	          result.durationIsEmpty = true;
	        }
	        if (!baseDataOffsetPresent && defaultBaseIsMoof) {
	          result.baseDataOffsetIsMoof = true;
	        }
	        return result;
	      },
	      tkhd: function tkhd(data) {
	        var view = new DataView(data.buffer, data.byteOffset, data.byteLength),
	            i = 4,
	            result = {
	          version: view.getUint8(0),
	          flags: new Uint8Array(data.subarray(1, 4))
	        };
	        if (result.version === 1) {
	          i += 4;
	          result.creationTime = parseMp4Date(view.getUint32(i)); // truncating top 4 bytes
	          i += 8;
	          result.modificationTime = parseMp4Date(view.getUint32(i)); // truncating top 4 bytes
	          i += 4;
	          result.trackId = view.getUint32(i);
	          i += 4;
	          i += 8;
	          result.duration = view.getUint32(i); // truncating top 4 bytes
	        } else {
	          result.creationTime = parseMp4Date(view.getUint32(i));
	          i += 4;
	          result.modificationTime = parseMp4Date(view.getUint32(i));
	          i += 4;
	          result.trackId = view.getUint32(i);
	          i += 4;
	          i += 4;
	          result.duration = view.getUint32(i);
	        }
	        i += 4;
	        i += 2 * 4;
	        result.layer = view.getUint16(i);
	        i += 2;
	        result.alternateGroup = view.getUint16(i);
	        i += 2;
	        // convert fixed-point, base 16 back to a number
	        result.volume = view.getUint8(i) + view.getUint8(i + 1) / 8;
	        i += 2;
	        i += 2;
	        result.matrix = new Uint32Array(data.subarray(i, i + 9 * 4));
	        i += 9 * 4;
	        result.width = view.getUint16(i) + view.getUint16(i + 2) / 16;
	        i += 4;
	        result.height = view.getUint16(i) + view.getUint16(i + 2) / 16;
	        return result;
	      },
	      traf: function traf(data) {
	        return {
	          boxes: inspectMp4(data)
	        };
	      },
	      trak: function trak(data) {
	        return {
	          boxes: inspectMp4(data)
	        };
	      },
	      trex: function trex(data) {
	        var view = new DataView(data.buffer, data.byteOffset, data.byteLength);
	        return {
	          version: data[0],
	          flags: new Uint8Array(data.subarray(1, 4)),
	          trackId: view.getUint32(4),
	          defaultSampleDescriptionIndex: view.getUint32(8),
	          defaultSampleDuration: view.getUint32(12),
	          defaultSampleSize: view.getUint32(16),
	          sampleDependsOn: data[20] & 0x03,
	          sampleIsDependedOn: (data[21] & 0xc0) >> 6,
	          sampleHasRedundancy: (data[21] & 0x30) >> 4,
	          samplePaddingValue: (data[21] & 0x0e) >> 1,
	          sampleIsDifferenceSample: !!(data[21] & 0x01),
	          sampleDegradationPriority: view.getUint16(22)
	        };
	      },
	      trun: function trun(data) {
	        var result = {
	          version: data[0],
	          flags: new Uint8Array(data.subarray(1, 4)),
	          samples: []
	        },
	            view = new DataView(data.buffer, data.byteOffset, data.byteLength),
	
	
	        // Flag interpretation
	        dataOffsetPresent = result.flags[2] & 0x01,
	
	
	        // compare with 2nd byte of 0x1
	        firstSampleFlagsPresent = result.flags[2] & 0x04,
	
	
	        // compare with 2nd byte of 0x4
	        sampleDurationPresent = result.flags[1] & 0x01,
	
	
	        // compare with 2nd byte of 0x100
	        sampleSizePresent = result.flags[1] & 0x02,
	
	
	        // compare with 2nd byte of 0x200
	        sampleFlagsPresent = result.flags[1] & 0x04,
	
	
	        // compare with 2nd byte of 0x400
	        sampleCompositionTimeOffsetPresent = result.flags[1] & 0x08,
	
	
	        // compare with 2nd byte of 0x800
	        sampleCount = view.getUint32(4),
	            offset = 8,
	            sample;
	
	        if (dataOffsetPresent) {
	          // 32 bit signed integer
	          result.dataOffset = view.getInt32(offset);
	          offset += 4;
	        }
	
	        // Overrides the flags for the first sample only. The order of
	        // optional values will be: duration, size, compositionTimeOffset
	        if (firstSampleFlagsPresent && sampleCount) {
	          sample = {
	            flags: parseSampleFlags(data.subarray(offset, offset + 4))
	          };
	          offset += 4;
	          if (sampleDurationPresent) {
	            sample.duration = view.getUint32(offset);
	            offset += 4;
	          }
	          if (sampleSizePresent) {
	            sample.size = view.getUint32(offset);
	            offset += 4;
	          }
	          if (sampleCompositionTimeOffsetPresent) {
	            // Note: this should be a signed int if version is 1
	            sample.compositionTimeOffset = view.getUint32(offset);
	            offset += 4;
	          }
	          result.samples.push(sample);
	          sampleCount--;
	        }
	
	        while (sampleCount--) {
	          sample = {};
	          if (sampleDurationPresent) {
	            sample.duration = view.getUint32(offset);
	            offset += 4;
	          }
	          if (sampleSizePresent) {
	            sample.size = view.getUint32(offset);
	            offset += 4;
	          }
	          if (sampleFlagsPresent) {
	            sample.flags = parseSampleFlags(data.subarray(offset, offset + 4));
	            offset += 4;
	          }
	          if (sampleCompositionTimeOffsetPresent) {
	            // Note: this should be a signed int if version is 1
	            sample.compositionTimeOffset = view.getUint32(offset);
	            offset += 4;
	          }
	          result.samples.push(sample);
	        }
	        return result;
	      },
	      'url ': function url(data) {
	        return {
	          version: data[0],
	          flags: new Uint8Array(data.subarray(1, 4))
	        };
	      },
	      vmhd: function vmhd(data) {
	        var view = new DataView(data.buffer, data.byteOffset, data.byteLength);
	        return {
	          version: data[0],
	          flags: new Uint8Array(data.subarray(1, 4)),
	          graphicsmode: view.getUint16(4),
	          opcolor: new Uint16Array([view.getUint16(6), view.getUint16(8), view.getUint16(10)])
	        };
	      }
	    };
	
	    /**
	     * Return a javascript array of box objects parsed from an ISO base
	     * media file.
	     * @param data {Uint8Array} the binary data of the media to be inspected
	     * @return {array} a javascript array of potentially nested box objects
	     */
	    inspectMp4 = function inspectMp4(data) {
	      var i = 0,
	          result = [],
	          view,
	          size,
	          type,
	          end,
	          box;
	
	      // Convert data from Uint8Array to ArrayBuffer, to follow Dataview API
	      var ab = new ArrayBuffer(data.length);
	      var v = new Uint8Array(ab);
	      for (var z = 0; z < data.length; ++z) {
	        v[z] = data[z];
	      }
	      view = new DataView(ab);
	
	      while (i < data.byteLength) {
	        // parse box data
	        size = view.getUint32(i);
	        type = parseType$1(data.subarray(i + 4, i + 8));
	        end = size > 1 ? i + size : data.byteLength;
	
	        // parse type-specific data
	        box = (parse$$1[type] || function (data) {
	          return {
	            data: data
	          };
	        })(data.subarray(i + 8, end));
	        box.size = size;
	        box.type = type;
	
	        // store this box and move to the next
	        result.push(box);
	        i = end;
	      }
	      return result;
	    };
	
	    /**
	     * Returns a textual representation of the javascript represtentation
	     * of an MP4 file. You can use it as an alternative to
	     * JSON.stringify() to compare inspected MP4s.
	     * @param inspectedMp4 {array} the parsed array of boxes in an MP4
	     * file
	     * @param depth {number} (optional) the number of ancestor boxes of
	     * the elements of inspectedMp4. Assumed to be zero if unspecified.
	     * @return {string} a text representation of the parsed MP4
	     */
	    _textifyMp = function textifyMp4(inspectedMp4, depth) {
	      var indent;
	      depth = depth || 0;
	      indent = new Array(depth * 2 + 1).join(' ');
	
	      // iterate over all the boxes
	      return inspectedMp4.map(function (box, index) {
	
	        // list the box type first at the current indentation level
	        return indent + box.type + '\n' +
	
	        // the type is already included and handle child boxes separately
	        Object.keys(box).filter(function (key) {
	          return key !== 'type' && key !== 'boxes';
	
	          // output all the box properties
	        }).map(function (key) {
	          var prefix = indent + '  ' + key + ': ',
	              value = box[key];
	
	          // print out raw bytes as hexademical
	          if (value instanceof Uint8Array || value instanceof Uint32Array) {
	            var bytes = Array.prototype.slice.call(new Uint8Array(value.buffer, value.byteOffset, value.byteLength)).map(function (byte) {
	              return ' ' + ('00' + byte.toString(16)).slice(-2);
	            }).join('').match(/.{1,24}/g);
	            if (!bytes) {
	              return prefix + '<>';
	            }
	            if (bytes.length === 1) {
	              return prefix + '<' + bytes.join('').slice(1) + '>';
	            }
	            return prefix + '<\n' + bytes.map(function (line) {
	              return indent + '  ' + line;
	            }).join('\n') + '\n' + indent + '  >';
	          }
	
	          // stringify generic objects
	          return prefix + JSON.stringify(value, null, 2).split('\n').map(function (line, index) {
	            if (index === 0) {
	              return line;
	            }
	            return indent + '  ' + line;
	          }).join('\n');
	        }).join('\n') + (
	
	        // recursively textify the child boxes
	        box.boxes ? '\n' + _textifyMp(box.boxes, depth + 1) : '');
	      }).join('\n');
	    };
	
	    var mp4Inspector = {
	      inspect: inspectMp4,
	      textify: _textifyMp,
	      parseTfdt: parse$$1.tfdt,
	      parseHdlr: parse$$1.hdlr,
	      parseTfhd: parse$$1.tfhd,
	      parseTrun: parse$$1.trun
	    };
	
	    var discardEmulationPreventionBytes$1 = captionPacketParser.discardEmulationPreventionBytes;
	    var CaptionStream$1 = captionStream.CaptionStream;
	
	    /**
	      * Maps an offset in the mdat to a sample based on the the size of the samples.
	      * Assumes that `parseSamples` has been called first.
	      *
	      * @param {Number} offset - The offset into the mdat
	      * @param {Object[]} samples - An array of samples, parsed using `parseSamples`
	      * @return {?Object} The matching sample, or null if no match was found.
	      *
	      * @see ISO-BMFF-12/2015, Section 8.8.8
	     **/
	    var mapToSample = function mapToSample(offset, samples) {
	      var approximateOffset = offset;
	
	      for (var i = 0; i < samples.length; i++) {
	        var sample = samples[i];
	
	        if (approximateOffset < sample.size) {
	          return sample;
	        }
	
	        approximateOffset -= sample.size;
	      }
	
	      return null;
	    };
	
	    /**
	      * Finds SEI nal units contained in a Media Data Box.
	      * Assumes that `parseSamples` has been called first.
	      *
	      * @param {Uint8Array} avcStream - The bytes of the mdat
	      * @param {Object[]} samples - The samples parsed out by `parseSamples`
	      * @param {Number} trackId - The trackId of this video track
	      * @return {Object[]} seiNals - the parsed SEI NALUs found.
	      *   The contents of the seiNal should match what is expected by
	      *   CaptionStream.push (nalUnitType, size, data, escapedRBSP, pts, dts)
	      *
	      * @see ISO-BMFF-12/2015, Section 8.1.1
	      * @see Rec. ITU-T H.264, 7.3.2.3.1
	     **/
	    var findSeiNals = function findSeiNals(avcStream, samples, trackId) {
	      var avcView = new DataView(avcStream.buffer, avcStream.byteOffset, avcStream.byteLength),
	          result = [],
	          seiNal,
	          i,
	          length,
	          lastMatchedSample;
	
	      for (i = 0; i + 4 < avcStream.length; i += length) {
	        length = avcView.getUint32(i);
	        i += 4;
	
	        // Bail if this doesn't appear to be an H264 stream
	        if (length <= 0) {
	          continue;
	        }
	
	        switch (avcStream[i] & 0x1F) {
	          case 0x06:
	            var data = avcStream.subarray(i + 1, i + 1 + length);
	            var matchingSample = mapToSample(i, samples);
	
	            seiNal = {
	              nalUnitType: 'sei_rbsp',
	              size: length,
	              data: data,
	              escapedRBSP: discardEmulationPreventionBytes$1(data),
	              trackId: trackId
	            };
	
	            if (matchingSample) {
	              seiNal.pts = matchingSample.pts;
	              seiNal.dts = matchingSample.dts;
	              lastMatchedSample = matchingSample;
	            } else {
	              // If a matching sample cannot be found, use the last
	              // sample's values as they should be as close as possible
	              seiNal.pts = lastMatchedSample.pts;
	              seiNal.dts = lastMatchedSample.dts;
	            }
	
	            result.push(seiNal);
	            break;
	          default:
	            break;
	        }
	      }
	
	      return result;
	    };
	
	    /**
	      * Parses sample information out of Track Run Boxes and calculates
	      * the absolute presentation and decode timestamps of each sample.
	      *
	      * @param {Array<Uint8Array>} truns - The Trun Run boxes to be parsed
	      * @param {Number} baseMediaDecodeTime - base media decode time from tfdt
	          @see ISO-BMFF-12/2015, Section 8.8.12
	      * @param {Object} tfhd - The parsed Track Fragment Header
	      *   @see inspect.parseTfhd
	      * @return {Object[]} the parsed samples
	      *
	      * @see ISO-BMFF-12/2015, Section 8.8.8
	     **/
	    var parseSamples = function parseSamples(truns, baseMediaDecodeTime, tfhd) {
	      var currentDts = baseMediaDecodeTime;
	      var defaultSampleDuration = tfhd.defaultSampleDuration || 0;
	      var defaultSampleSize = tfhd.defaultSampleSize || 0;
	      var trackId = tfhd.trackId;
	      var allSamples = [];
	
	      truns.forEach(function (trun) {
	        // Note: We currently do not parse the sample table as well
	        // as the trun. It's possible some sources will require this.
	        // moov > trak > mdia > minf > stbl
	        var trackRun = mp4Inspector.parseTrun(trun);
	        var samples = trackRun.samples;
	
	        samples.forEach(function (sample) {
	          if (sample.duration === undefined) {
	            sample.duration = defaultSampleDuration;
	          }
	          if (sample.size === undefined) {
	            sample.size = defaultSampleSize;
	          }
	          sample.trackId = trackId;
	          sample.dts = currentDts;
	          if (sample.compositionTimeOffset === undefined) {
	            sample.compositionTimeOffset = 0;
	          }
	          sample.pts = currentDts + sample.compositionTimeOffset;
	
	          currentDts += sample.duration;
	        });
	
	        allSamples = allSamples.concat(samples);
	      });
	
	      return allSamples;
	    };
	
	    /**
	      * Parses out caption nals from an FMP4 segment's video tracks.
	      *
	      * @param {Uint8Array} segment - The bytes of a single segment
	      * @param {Number} videoTrackId - The trackId of a video track in the segment
	      * @return {Object.<Number, Object[]>} A mapping of video trackId to
	      *   a list of seiNals found in that track
	     **/
	    var parseCaptionNals = function parseCaptionNals(segment, videoTrackId) {
	      // To get the samples
	      var trafs = probe.findBox(segment, ['moof', 'traf']);
	      // To get SEI NAL units
	      var mdats = probe.findBox(segment, ['mdat']);
	      var captionNals = {};
	      var mdatTrafPairs = [];
	
	      // Pair up each traf with a mdat as moofs and mdats are in pairs
	      mdats.forEach(function (mdat, index) {
	        var matchingTraf = trafs[index];
	        mdatTrafPairs.push({
	          mdat: mdat,
	          traf: matchingTraf
	        });
	      });
	
	      mdatTrafPairs.forEach(function (pair) {
	        var mdat = pair.mdat;
	        var traf = pair.traf;
	        var tfhd = probe.findBox(traf, ['tfhd']);
	        // Exactly 1 tfhd per traf
	        var headerInfo = mp4Inspector.parseTfhd(tfhd[0]);
	        var trackId = headerInfo.trackId;
	        var tfdt = probe.findBox(traf, ['tfdt']);
	        // Either 0 or 1 tfdt per traf
	        var baseMediaDecodeTime = tfdt.length > 0 ? mp4Inspector.parseTfdt(tfdt[0]).baseMediaDecodeTime : 0;
	        var truns = probe.findBox(traf, ['trun']);
	        var samples;
	        var seiNals;
	
	        // Only parse video data for the chosen video track
	        if (videoTrackId === trackId && truns.length > 0) {
	          samples = parseSamples(truns, baseMediaDecodeTime, headerInfo);
	
	          seiNals = findSeiNals(mdat, samples, trackId);
	
	          if (!captionNals[trackId]) {
	            captionNals[trackId] = [];
	          }
	
	          captionNals[trackId] = captionNals[trackId].concat(seiNals);
	        }
	      });
	
	      return captionNals;
	    };
	
	    /**
	      * Parses out inband captions from an MP4 container and returns
	      * caption objects that can be used by WebVTT and the TextTrack API.
	      * @see https://developer.mozilla.org/en-US/docs/Web/API/VTTCue
	      * @see https://developer.mozilla.org/en-US/docs/Web/API/TextTrack
	      * Assumes that `probe.getVideoTrackIds` and `probe.timescale` have been called first
	      *
	      * @param {Uint8Array} segment - The fmp4 segment containing embedded captions
	      * @param {Number} trackId - The id of the video track to parse
	      * @param {Number} timescale - The timescale for the video track from the init segment
	      *
	      * @return {?Object[]} parsedCaptions - A list of captions or null if no video tracks
	      * @return {Number} parsedCaptions[].startTime - The time to show the caption in seconds
	      * @return {Number} parsedCaptions[].endTime - The time to stop showing the caption in seconds
	      * @return {String} parsedCaptions[].text - The visible content of the caption
	     **/
	    var parseEmbeddedCaptions = function parseEmbeddedCaptions(segment, trackId, timescale) {
	      var seiNals;
	
	      if (!trackId) {
	        return null;
	      }
	
	      seiNals = parseCaptionNals(segment, trackId);
	
	      return {
	        seiNals: seiNals[trackId],
	        timescale: timescale
	      };
	    };
	
	    /**
	      * Converts SEI NALUs into captions that can be used by video.js
	     **/
	    var CaptionParser$$1 = function CaptionParser$$1() {
	      var isInitialized = false;
	      var captionStream$$1;
	
	      // Stores segments seen before trackId and timescale are set
	      var segmentCache;
	      // Stores video track ID of the track being parsed
	      var trackId;
	      // Stores the timescale of the track being parsed
	      var timescale;
	      // Stores captions parsed so far
	      var parsedCaptions;
	
	      /**
	        * A method to indicate whether a CaptionParser has been initalized
	        * @returns {Boolean}
	       **/
	      this.isInitialized = function () {
	        return isInitialized;
	      };
	
	      /**
	        * Initializes the underlying CaptionStream, SEI NAL parsing
	        * and management, and caption collection
	       **/
	      this.init = function () {
	        captionStream$$1 = new CaptionStream$1();
	        isInitialized = true;
	
	        // Collect dispatched captions
	        captionStream$$1.on('data', function (event) {
	          // Convert to seconds in the source's timescale
	          event.startTime = event.startPts / timescale;
	          event.endTime = event.endPts / timescale;
	
	          parsedCaptions.captions.push(event);
	          parsedCaptions.captionStreams[event.stream] = true;
	        });
	      };
	
	      /**
	        * Determines if a new video track will be selected
	        * or if the timescale changed
	        * @return {Boolean}
	       **/
	      this.isNewInit = function (videoTrackIds, timescales) {
	        if (videoTrackIds && videoTrackIds.length === 0 || timescales && (typeof timescales === 'undefined' ? 'undefined' : _typeof(timescales)) === 'object' && Object.keys(timescales).length === 0) {
	          return false;
	        }
	
	        return trackId !== videoTrackIds[0] || timescale !== timescales[trackId];
	      };
	
	      /**
	        * Parses out SEI captions and interacts with underlying
	        * CaptionStream to return dispatched captions
	        *
	        * @param {Uint8Array} segment - The fmp4 segment containing embedded captions
	        * @param {Number[]} videoTrackIds - A list of video tracks found in the init segment
	        * @param {Object.<Number, Number>} timescales - The timescales found in the init segment
	        * @see parseEmbeddedCaptions
	        * @see m2ts/caption-stream.js
	       **/
	      this.parse = function (segment, videoTrackIds, timescales) {
	        var parsedData;
	
	        if (!this.isInitialized()) {
	          return null;
	
	          // This is not likely to be a video segment
	        } else if (!videoTrackIds || !timescales) {
	          return null;
	        } else if (this.isNewInit(videoTrackIds, timescales)) {
	          // Use the first video track only as there is no
	          // mechanism to switch to other video tracks
	          trackId = videoTrackIds[0];
	          timescale = timescales[trackId];
	
	          // If an init segment has not been seen yet, hold onto segment
	          // data until we have one
	        } else if (!trackId || !timescale) {
	          segmentCache.push(segment);
	          return null;
	        }
	
	        // Now that a timescale and trackId is set, parse cached segments
	        while (segmentCache.length > 0) {
	          var cachedSegment = segmentCache.shift();
	
	          this.parse(cachedSegment, videoTrackIds, timescales);
	        }
	
	        parsedData = parseEmbeddedCaptions(segment, trackId, timescale);
	
	        if (parsedData === null || !parsedData.seiNals) {
	          return null;
	        }
	
	        this.pushNals(parsedData.seiNals);
	        // Force the parsed captions to be dispatched
	        this.flushStream();
	
	        return parsedCaptions;
	      };
	
	      /**
	        * Pushes SEI NALUs onto CaptionStream
	        * @param {Object[]} nals - A list of SEI nals parsed using `parseCaptionNals`
	        * Assumes that `parseCaptionNals` has been called first
	        * @see m2ts/caption-stream.js
	        **/
	      this.pushNals = function (nals) {
	        if (!this.isInitialized() || !nals || nals.length === 0) {
	          return null;
	        }
	
	        nals.forEach(function (nal) {
	          captionStream$$1.push(nal);
	        });
	      };
	
	      /**
	        * Flushes underlying CaptionStream to dispatch processed, displayable captions
	        * @see m2ts/caption-stream.js
	       **/
	      this.flushStream = function () {
	        if (!this.isInitialized()) {
	          return null;
	        }
	
	        captionStream$$1.flush();
	      };
	
	      /**
	        * Reset caption buckets for new data
	       **/
	      this.clearParsedCaptions = function () {
	        parsedCaptions.captions = [];
	        parsedCaptions.captionStreams = {};
	      };
	
	      /**
	        * Resets underlying CaptionStream
	        * @see m2ts/caption-stream.js
	       **/
	      this.resetCaptionStream = function () {
	        if (!this.isInitialized()) {
	          return null;
	        }
	
	        captionStream$$1.reset();
	      };
	
	      /**
	        * Convenience method to clear all captions flushed from the
	        * CaptionStream and still being parsed
	        * @see m2ts/caption-stream.js
	       **/
	      this.clearAllCaptions = function () {
	        this.clearParsedCaptions();
	        this.resetCaptionStream();
	      };
	
	      /**
	        * Reset caption parser
	       **/
	      this.reset = function () {
	        segmentCache = [];
	        trackId = null;
	        timescale = null;
	
	        if (!parsedCaptions) {
	          parsedCaptions = {
	            captions: [],
	            // CC1, CC2, CC3, CC4
	            captionStreams: {}
	          };
	        } else {
	          this.clearParsedCaptions();
	        }
	
	        this.resetCaptionStream();
	      };
	
	      this.reset();
	    };
	
	    var captionParser = CaptionParser$$1;
	
	    var mp4$$1 = {
	      generator: mp4Generator,
	      probe: probe,
	      Transmuxer: transmuxer.Transmuxer,
	      AudioSegmentStream: transmuxer.AudioSegmentStream,
	      VideoSegmentStream: transmuxer.VideoSegmentStream,
	      CaptionParser: captionParser
	    };
	
	    var classCallCheck$$1 = function classCallCheck$$1(instance, Constructor) {
	      if (!(instance instanceof Constructor)) {
	        throw new TypeError("Cannot call a class as a function");
	      }
	    };
	
	    var createClass$$1 = function () {
	      function defineProperties(target, props) {
	        for (var i = 0; i < props.length; i++) {
	          var descriptor = props[i];
	          descriptor.enumerable = descriptor.enumerable || false;
	          descriptor.configurable = true;
	          if ("value" in descriptor) descriptor.writable = true;
	          Object.defineProperty(target, descriptor.key, descriptor);
	        }
	      }
	
	      return function (Constructor, protoProps, staticProps) {
	        if (protoProps) defineProperties(Constructor.prototype, protoProps);
	        if (staticProps) defineProperties(Constructor, staticProps);
	        return Constructor;
	      };
	    }();
	
	    /**
	     * @file transmuxer-worker.js
	     */
	
	    /**
	     * Re-emits transmuxer events by converting them into messages to the
	     * world outside the worker.
	     *
	     * @param {Object} transmuxer the transmuxer to wire events on
	     * @private
	     */
	    var wireTransmuxerEvents = function wireTransmuxerEvents(self, transmuxer) {
	      transmuxer.on('data', function (segment) {
	        // transfer ownership of the underlying ArrayBuffer
	        // instead of doing a copy to save memory
	        // ArrayBuffers are transferable but generic TypedArrays are not
	        // @link https://developer.mozilla.org/en-US/docs/Web/API/Web_Workers_API/Using_web_workers#Passing_data_by_transferring_ownership_(transferable_objects)
	        var initArray = segment.initSegment;
	
	        segment.initSegment = {
	          data: initArray.buffer,
	          byteOffset: initArray.byteOffset,
	          byteLength: initArray.byteLength
	        };
	
	        var typedArray = segment.data;
	
	        segment.data = typedArray.buffer;
	        self.postMessage({
	          action: 'data',
	          segment: segment,
	          byteOffset: typedArray.byteOffset,
	          byteLength: typedArray.byteLength
	        }, [segment.data]);
	      });
	
	      if (transmuxer.captionStream) {
	        transmuxer.captionStream.on('data', function (caption) {
	          self.postMessage({
	            action: 'caption',
	            data: caption
	          });
	        });
	      }
	
	      transmuxer.on('done', function (data) {
	        self.postMessage({ action: 'done' });
	      });
	
	      transmuxer.on('gopInfo', function (gopInfo) {
	        self.postMessage({
	          action: 'gopInfo',
	          gopInfo: gopInfo
	        });
	      });
	    };
	
	    /**
	     * All incoming messages route through this hash. If no function exists
	     * to handle an incoming message, then we ignore the message.
	     *
	     * @class MessageHandlers
	     * @param {Object} options the options to initialize with
	     */
	
	    var MessageHandlers = function () {
	      function MessageHandlers(self, options) {
	        classCallCheck$$1(this, MessageHandlers);
	
	        this.options = options || {};
	        this.self = self;
	        this.init();
	      }
	
	      /**
	       * initialize our web worker and wire all the events.
	       */
	
	      createClass$$1(MessageHandlers, [{
	        key: 'init',
	        value: function init() {
	          if (this.transmuxer) {
	            this.transmuxer.dispose();
	          }
	          this.transmuxer = new mp4$$1.Transmuxer(this.options);
	          wireTransmuxerEvents(this.self, this.transmuxer);
	        }
	
	        /**
	         * Adds data (a ts segment) to the start of the transmuxer pipeline for
	         * processing.
	         *
	         * @param {ArrayBuffer} data data to push into the muxer
	         */
	
	      }, {
	        key: 'push',
	        value: function push(data) {
	          // Cast array buffer to correct type for transmuxer
	          var segment = new Uint8Array(data.data, data.byteOffset, data.byteLength);
	
	          this.transmuxer.push(segment);
	        }
	
	        /**
	         * Recreate the transmuxer so that the next segment added via `push`
	         * start with a fresh transmuxer.
	         */
	
	      }, {
	        key: 'reset',
	        value: function reset() {
	          this.init();
	        }
	
	        /**
	         * Set the value that will be used as the `baseMediaDecodeTime` time for the
	         * next segment pushed in. Subsequent segments will have their `baseMediaDecodeTime`
	         * set relative to the first based on the PTS values.
	         *
	         * @param {Object} data used to set the timestamp offset in the muxer
	         */
	
	      }, {
	        key: 'setTimestampOffset',
	        value: function setTimestampOffset(data) {
	          var timestampOffset = data.timestampOffset || 0;
	
	          this.transmuxer.setBaseMediaDecodeTime(Math.round(timestampOffset * 90000));
	        }
	      }, {
	        key: 'setAudioAppendStart',
	        value: function setAudioAppendStart(data) {
	          this.transmuxer.setAudioAppendStart(Math.ceil(data.appendStart * 90000));
	        }
	
	        /**
	         * Forces the pipeline to finish processing the last segment and emit it's
	         * results.
	         *
	         * @param {Object} data event data, not really used
	         */
	
	      }, {
	        key: 'flush',
	        value: function flush(data) {
	          this.transmuxer.flush();
	        }
	      }, {
	        key: 'resetCaptions',
	        value: function resetCaptions() {
	          this.transmuxer.resetCaptions();
	        }
	      }, {
	        key: 'alignGopsWith',
	        value: function alignGopsWith(data) {
	          this.transmuxer.alignGopsWith(data.gopsToAlignWith.slice());
	        }
	      }]);
	      return MessageHandlers;
	    }();
	
	    /**
	     * Our web wroker interface so that things can talk to mux.js
	     * that will be running in a web worker. the scope is passed to this by
	     * webworkify.
	     *
	     * @param {Object} self the scope for the web worker
	     */
	
	    var TransmuxerWorker = function TransmuxerWorker(self) {
	      self.onmessage = function (event) {
	        if (event.data.action === 'init' && event.data.options) {
	          this.messageHandlers = new MessageHandlers(self, event.data.options);
	          return;
	        }
	
	        if (!this.messageHandlers) {
	          this.messageHandlers = new MessageHandlers(self);
	        }
	
	        if (event.data && event.data.action && event.data.action !== 'init') {
	          if (this.messageHandlers[event.data.action]) {
	            this.messageHandlers[event.data.action](event.data);
	          }
	        }
	      };
	    };
	
	    var transmuxerWorker = new TransmuxerWorker(self);
	
	    return transmuxerWorker;
	  }();
	});
	
	/**
	 * @file - codecs.js - Handles tasks regarding codec strings such as translating them to
	 * codec strings, or translating codec strings into objects that can be examined.
	 */
	
	// Default codec parameters if none were provided for video and/or audio
	var defaultCodecs = {
	  videoCodec: 'avc1',
	  videoObjectTypeIndicator: '.4d400d',
	  // AAC-LC
	  audioProfile: '2'
	};
	
	/**
	 * Replace the old apple-style `avc1.<dd>.<dd>` codec string with the standard
	 * `avc1.<hhhhhh>`
	 *
	 * @param {Array} codecs an array of codec strings to fix
	 * @return {Array} the translated codec array
	 * @private
	 */
	var translateLegacyCodecs = function translateLegacyCodecs(codecs) {
	  return codecs.map(function (codec) {
	    return codec.replace(/avc1\.(\d+)\.(\d+)/i, function (orig, profile, avcLevel) {
	      var profileHex = ('00' + Number(profile).toString(16)).slice(-2);
	      var avcLevelHex = ('00' + Number(avcLevel).toString(16)).slice(-2);
	
	      return 'avc1.' + profileHex + '00' + avcLevelHex;
	    });
	  });
	};
	
	/**
	 * Parses a codec string to retrieve the number of codecs specified,
	 * the video codec and object type indicator, and the audio profile.
	 */
	
	var parseCodecs = function parseCodecs() {
	  var codecs = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
	
	  var result = {
	    codecCount: 0
	  };
	  var parsed = void 0;
	
	  result.codecCount = codecs.split(',').length;
	  result.codecCount = result.codecCount || 2;
	
	  // parse the video codec
	  parsed = /(^|\s|,)+(avc[13])([^ ,]*)/i.exec(codecs);
	  if (parsed) {
	    result.videoCodec = parsed[2];
	    result.videoObjectTypeIndicator = parsed[3];
	  }
	
	  // parse the last field of the audio codec
	  result.audioProfile = /(^|\s|,)+mp4a.[0-9A-Fa-f]+\.([0-9A-Fa-f]+)/i.exec(codecs);
	  result.audioProfile = result.audioProfile && result.audioProfile[2];
	
	  return result;
	};
	
	/**
	 * Replace codecs in the codec string with the old apple-style `avc1.<dd>.<dd>` to the
	 * standard `avc1.<hhhhhh>`.
	 *
	 * @param codecString {String} the codec string
	 * @return {String} the codec string with old apple-style codecs replaced
	 *
	 * @private
	 */
	var mapLegacyAvcCodecs = function mapLegacyAvcCodecs(codecString) {
	  return codecString.replace(/avc1\.(\d+)\.(\d+)/i, function (match) {
	    return translateLegacyCodecs([match])[0];
	  });
	};
	
	/**
	 * Build a media mime-type string from a set of parameters
	 * @param {String} type either 'audio' or 'video'
	 * @param {String} container either 'mp2t' or 'mp4'
	 * @param {Array} codecs an array of codec strings to add
	 * @return {String} a valid media mime-type
	 */
	var makeMimeTypeString = function makeMimeTypeString(type, container, codecs) {
	  // The codecs array is filtered so that falsey values are
	  // dropped and don't cause Array#join to create spurious
	  // commas
	  return type + '/' + container + '; codecs="' + codecs.filter(function (c) {
	    return !!c;
	  }).join(', ') + '"';
	};
	
	/**
	 * Returns the type container based on information in the playlist
	 * @param {Playlist} media the current media playlist
	 * @return {String} a valid media container type
	 */
	var getContainerType = function getContainerType(media) {
	  // An initialization segment means the media playlist is an iframe
	  // playlist or is using the mp4 container. We don't currently
	  // support iframe playlists, so assume this is signalling mp4
	  // fragments.
	  if (media.segments && media.segments.length && media.segments[0].map) {
	    return 'mp4';
	  }
	  return 'mp2t';
	};
	
	/**
	 * Returns a set of codec strings parsed from the playlist or the default
	 * codec strings if no codecs were specified in the playlist
	 * @param {Playlist} media the current media playlist
	 * @return {Object} an object with the video and audio codecs
	 */
	var getCodecs = function getCodecs(media) {
	  // if the codecs were explicitly specified, use them instead of the
	  // defaults
	  var mediaAttributes = media.attributes || {};
	
	  if (mediaAttributes.CODECS) {
	    return parseCodecs(mediaAttributes.CODECS);
	  }
	  return defaultCodecs;
	};
	
	var audioProfileFromDefault = function audioProfileFromDefault(master, audioGroupId) {
	  if (!master.mediaGroups.AUDIO || !audioGroupId) {
	    return null;
	  }
	
	  var audioGroup = master.mediaGroups.AUDIO[audioGroupId];
	
	  if (!audioGroup) {
	    return null;
	  }
	
	  for (var name in audioGroup) {
	    var audioType = audioGroup[name];
	
	    if (audioType.default && audioType.playlists) {
	      // codec should be the same for all playlists within the audio type
	      return parseCodecs(audioType.playlists[0].attributes.CODECS).audioProfile;
	    }
	  }
	
	  return null;
	};
	
	/**
	 * Calculates the MIME type strings for a working configuration of
	 * SourceBuffers to play variant streams in a master playlist. If
	 * there is no possible working configuration, an empty array will be
	 * returned.
	 *
	 * @param master {Object} the m3u8 object for the master playlist
	 * @param media {Object} the m3u8 object for the variant playlist
	 * @return {Array} the MIME type strings. If the array has more than
	 * one entry, the first element should be applied to the video
	 * SourceBuffer and the second to the audio SourceBuffer.
	 *
	 * @private
	 */
	var mimeTypesForPlaylist = function mimeTypesForPlaylist(master, media) {
	  var containerType = getContainerType(media);
	  var codecInfo = getCodecs(media);
	  var mediaAttributes = media.attributes || {};
	  // Default condition for a traditional HLS (no demuxed audio/video)
	  var isMuxed = true;
	  var isMaat = false;
	
	  if (!media) {
	    // Not enough information
	    return [];
	  }
	
	  if (master.mediaGroups.AUDIO && mediaAttributes.AUDIO) {
	    var audioGroup = master.mediaGroups.AUDIO[mediaAttributes.AUDIO];
	
	    // Handle the case where we are in a multiple-audio track scenario
	    if (audioGroup) {
	      isMaat = true;
	      // Start with the everything demuxed then...
	      isMuxed = false;
	      // ...check to see if any audio group tracks are muxed (ie. lacking a uri)
	      for (var groupId in audioGroup) {
	        // either a uri is present (if the case of HLS and an external playlist), or
	        // playlists is present (in the case of DASH where we don't have external audio
	        // playlists)
	        if (!audioGroup[groupId].uri && !audioGroup[groupId].playlists) {
	          isMuxed = true;
	          break;
	        }
	      }
	    }
	  }
	
	  // HLS with multiple-audio tracks must always get an audio codec.
	  // Put another way, there is no way to have a video-only multiple-audio HLS!
	  if (isMaat && !codecInfo.audioProfile) {
	    if (!isMuxed) {
	      // It is possible for codecs to be specified on the audio media group playlist but
	      // not on the rendition playlist. This is mostly the case for DASH, where audio and
	      // video are always separate (and separately specified).
	      codecInfo.audioProfile = audioProfileFromDefault(master, mediaAttributes.AUDIO);
	    }
	
	    if (!codecInfo.audioProfile) {
	      videojs$1.log.warn('Multiple audio tracks present but no audio codec string is specified. ' + 'Attempting to use the default audio codec (mp4a.40.2)');
	      codecInfo.audioProfile = defaultCodecs.audioProfile;
	    }
	  }
	
	  // Generate the final codec strings from the codec object generated above
	  var codecStrings = {};
	
	  if (codecInfo.videoCodec) {
	    codecStrings.video = '' + codecInfo.videoCodec + codecInfo.videoObjectTypeIndicator;
	  }
	
	  if (codecInfo.audioProfile) {
	    codecStrings.audio = 'mp4a.40.' + codecInfo.audioProfile;
	  }
	
	  // Finally, make and return an array with proper mime-types depending on
	  // the configuration
	  var justAudio = makeMimeTypeString('audio', containerType, [codecStrings.audio]);
	  var justVideo = makeMimeTypeString('video', containerType, [codecStrings.video]);
	  var bothVideoAudio = makeMimeTypeString('video', containerType, [codecStrings.video, codecStrings.audio]);
	
	  if (isMaat) {
	    if (!isMuxed && codecStrings.video) {
	      return [justVideo, justAudio];
	    }
	
	    if (!isMuxed && !codecStrings.video) {
	      // There is no muxed content and no video codec string, so this is an audio only
	      // stream with alternate audio.
	      return [justAudio, justAudio];
	    }
	
	    // There exists the possiblity that this will return a `video/container`
	    // mime-type for the first entry in the array even when there is only audio.
	    // This doesn't appear to be a problem and simplifies the code.
	    return [bothVideoAudio, justAudio];
	  }
	
	  // If there is no video codec at all, always just return a single
	  // audio/<container> mime-type
	  if (!codecStrings.video) {
	    return [justAudio];
	  }
	
	  // When not using separate audio media groups, audio and video is
	  // *always* muxed
	  return [bothVideoAudio];
	};
	
	/**
	 * Parse a content type header into a type and parameters
	 * object
	 *
	 * @param {String} type the content type header
	 * @return {Object} the parsed content-type
	 * @private
	 */
	var parseContentType = function parseContentType(type) {
	  var object = { type: '', parameters: {} };
	  var parameters = type.trim().split(';');
	
	  // first parameter should always be content-type
	  object.type = parameters.shift().trim();
	  parameters.forEach(function (parameter) {
	    var pair = parameter.trim().split('=');
	
	    if (pair.length > 1) {
	      var name = pair[0].replace(/"/g, '').trim();
	      var value = pair[1].replace(/"/g, '').trim();
	
	      object.parameters[name] = value;
	    }
	  });
	
	  return object;
	};
	
	/**
	 * Check if a codec string refers to an audio codec.
	 *
	 * @param {String} codec codec string to check
	 * @return {Boolean} if this is an audio codec
	 * @private
	 */
	var isAudioCodec = function isAudioCodec(codec) {
	  return (/mp4a\.\d+.\d+/i.test(codec)
	  );
	};
	
	/**
	 * Check if a codec string refers to a video codec.
	 *
	 * @param {String} codec codec string to check
	 * @return {Boolean} if this is a video codec
	 * @private
	 */
	var isVideoCodec = function isVideoCodec(codec) {
	  return (/avc1\.[\da-f]+/i.test(codec)
	  );
	};
	
	/**
	 * Returns a list of gops in the buffer that have a pts value of 3 seconds or more in
	 * front of current time.
	 *
	 * @param {Array} buffer
	 *        The current buffer of gop information
	 * @param {Number} currentTime
	 *        The current time
	 * @param {Double} mapping
	 *        Offset to map display time to stream presentation time
	 * @return {Array}
	 *         List of gops considered safe to append over
	 */
	var gopsSafeToAlignWith = function gopsSafeToAlignWith(buffer, currentTime, mapping) {
	  if (typeof currentTime === 'undefined' || currentTime === null || !buffer.length) {
	    return [];
	  }
	
	  // pts value for current time + 3 seconds to give a bit more wiggle room
	  var currentTimePts = Math.ceil((currentTime - mapping + 3) * 90000);
	
	  var i = void 0;
	
	  for (i = 0; i < buffer.length; i++) {
	    if (buffer[i].pts > currentTimePts) {
	      break;
	    }
	  }
	
	  return buffer.slice(i);
	};
	
	/**
	 * Appends gop information (timing and byteLength) received by the transmuxer for the
	 * gops appended in the last call to appendBuffer
	 *
	 * @param {Array} buffer
	 *        The current buffer of gop information
	 * @param {Array} gops
	 *        List of new gop information
	 * @param {boolean} replace
	 *        If true, replace the buffer with the new gop information. If false, append the
	 *        new gop information to the buffer in the right location of time.
	 * @return {Array}
	 *         Updated list of gop information
	 */
	var updateGopBuffer = function updateGopBuffer(buffer, gops, replace) {
	  if (!gops.length) {
	    return buffer;
	  }
	
	  if (replace) {
	    // If we are in safe append mode, then completely overwrite the gop buffer
	    // with the most recent appeneded data. This will make sure that when appending
	    // future segments, we only try to align with gops that are both ahead of current
	    // time and in the last segment appended.
	    return gops.slice();
	  }
	
	  var start = gops[0].pts;
	
	  var i = 0;
	
	  for (i; i < buffer.length; i++) {
	    if (buffer[i].pts >= start) {
	      break;
	    }
	  }
	
	  return buffer.slice(0, i).concat(gops);
	};
	
	/**
	 * Removes gop information in buffer that overlaps with provided start and end
	 *
	 * @param {Array} buffer
	 *        The current buffer of gop information
	 * @param {Double} start
	 *        position to start the remove at
	 * @param {Double} end
	 *        position to end the remove at
	 * @param {Double} mapping
	 *        Offset to map display time to stream presentation time
	 */
	var removeGopBuffer = function removeGopBuffer(buffer, start, end, mapping) {
	  var startPts = Math.ceil((start - mapping) * 90000);
	  var endPts = Math.ceil((end - mapping) * 90000);
	  var updatedBuffer = buffer.slice();
	
	  var i = buffer.length;
	
	  while (i--) {
	    if (buffer[i].pts <= endPts) {
	      break;
	    }
	  }
	
	  if (i === -1) {
	    // no removal because end of remove range is before start of buffer
	    return updatedBuffer;
	  }
	
	  var j = i + 1;
	
	  while (j--) {
	    if (buffer[j].pts <= startPts) {
	      break;
	    }
	  }
	
	  // clamp remove range start to 0 index
	  j = Math.max(j, 0);
	
	  updatedBuffer.splice(j, i - j + 1);
	
	  return updatedBuffer;
	};
	
	var buffered = function buffered(videoBuffer, audioBuffer, audioDisabled) {
	  var start = null;
	  var end = null;
	  var arity = 0;
	  var extents = [];
	  var ranges = [];
	
	  // neither buffer has been created yet
	  if (!videoBuffer && !audioBuffer) {
	    return videojs$1.createTimeRange();
	  }
	
	  // only one buffer is configured
	  if (!videoBuffer) {
	    return audioBuffer.buffered;
	  }
	  if (!audioBuffer) {
	    return videoBuffer.buffered;
	  }
	
	  // both buffers are configured
	  if (audioDisabled) {
	    return videoBuffer.buffered;
	  }
	
	  // both buffers are empty
	  if (videoBuffer.buffered.length === 0 && audioBuffer.buffered.length === 0) {
	    return videojs$1.createTimeRange();
	  }
	
	  // Handle the case where we have both buffers and create an
	  // intersection of the two
	  var videoBuffered = videoBuffer.buffered;
	  var audioBuffered = audioBuffer.buffered;
	  var count = videoBuffered.length;
	
	  // A) Gather up all start and end times
	  while (count--) {
	    extents.push({ time: videoBuffered.start(count), type: 'start' });
	    extents.push({ time: videoBuffered.end(count), type: 'end' });
	  }
	  count = audioBuffered.length;
	  while (count--) {
	    extents.push({ time: audioBuffered.start(count), type: 'start' });
	    extents.push({ time: audioBuffered.end(count), type: 'end' });
	  }
	  // B) Sort them by time
	  extents.sort(function (a, b) {
	    return a.time - b.time;
	  });
	
	  // C) Go along one by one incrementing arity for start and decrementing
	  //    arity for ends
	  for (count = 0; count < extents.length; count++) {
	    if (extents[count].type === 'start') {
	      arity++;
	
	      // D) If arity is ever incremented to 2 we are entering an
	      //    overlapping range
	      if (arity === 2) {
	        start = extents[count].time;
	      }
	    } else if (extents[count].type === 'end') {
	      arity--;
	
	      // E) If arity is ever decremented to 1 we leaving an
	      //    overlapping range
	      if (arity === 1) {
	        end = extents[count].time;
	      }
	    }
	
	    // F) Record overlapping ranges
	    if (start !== null && end !== null) {
	      ranges.push([start, end]);
	      start = null;
	      end = null;
	    }
	  }
	
	  return videojs$1.createTimeRanges(ranges);
	};
	
	/**
	 * @file virtual-source-buffer.js
	 */
	
	// We create a wrapper around the SourceBuffer so that we can manage the
	// state of the `updating` property manually. We have to do this because
	// Firefox changes `updating` to false long before triggering `updateend`
	// events and that was causing strange problems in videojs-contrib-hls
	var makeWrappedSourceBuffer = function makeWrappedSourceBuffer(mediaSource, mimeType) {
	  var sourceBuffer = mediaSource.addSourceBuffer(mimeType);
	  var wrapper = Object.create(null);
	
	  wrapper.updating = false;
	  wrapper.realBuffer_ = sourceBuffer;
	
	  var _loop = function _loop(key) {
	    if (typeof sourceBuffer[key] === 'function') {
	      wrapper[key] = function () {
	        return sourceBuffer[key].apply(sourceBuffer, arguments);
	      };
	    } else if (typeof wrapper[key] === 'undefined') {
	      Object.defineProperty(wrapper, key, {
	        get: function get$$1() {
	          return sourceBuffer[key];
	        },
	        set: function set$$1(v) {
	          return sourceBuffer[key] = v;
	        }
	      });
	    }
	  };
	
	  for (var key in sourceBuffer) {
	    _loop(key);
	  }
	
	  return wrapper;
	};
	
	/**
	 * VirtualSourceBuffers exist so that we can transmux non native formats
	 * into a native format, but keep the same api as a native source buffer.
	 * It creates a transmuxer, that works in its own thread (a web worker) and
	 * that transmuxer muxes the data into a native format. VirtualSourceBuffer will
	 * then send all of that data to the naive sourcebuffer so that it is
	 * indestinguishable from a natively supported format.
	 *
	 * @param {HtmlMediaSource} mediaSource the parent mediaSource
	 * @param {Array} codecs array of codecs that we will be dealing with
	 * @class VirtualSourceBuffer
	 * @extends video.js.EventTarget
	 */
	
	var VirtualSourceBuffer = function (_videojs$EventTarget) {
	  inherits$1(VirtualSourceBuffer, _videojs$EventTarget);
	
	  function VirtualSourceBuffer(mediaSource, codecs) {
	    classCallCheck$1(this, VirtualSourceBuffer);
	
	    var _this = possibleConstructorReturn$1(this, (VirtualSourceBuffer.__proto__ || Object.getPrototypeOf(VirtualSourceBuffer)).call(this, videojs$1.EventTarget));
	
	    _this.timestampOffset_ = 0;
	    _this.pendingBuffers_ = [];
	    _this.bufferUpdating_ = false;
	
	    _this.mediaSource_ = mediaSource;
	    _this.codecs_ = codecs;
	    _this.audioCodec_ = null;
	    _this.videoCodec_ = null;
	    _this.audioDisabled_ = false;
	    _this.appendAudioInitSegment_ = true;
	    _this.gopBuffer_ = [];
	    _this.timeMapping_ = 0;
	    _this.safeAppend_ = videojs$1.browser.IE_VERSION >= 11;
	
	    var options = {
	      remux: false,
	      alignGopsAtEnd: _this.safeAppend_
	    };
	
	    _this.codecs_.forEach(function (codec) {
	      if (isAudioCodec(codec)) {
	        _this.audioCodec_ = codec;
	      } else if (isVideoCodec(codec)) {
	        _this.videoCodec_ = codec;
	      }
	    });
	
	    // append muxed segments to their respective native buffers as
	    // soon as they are available
	    _this.transmuxer_ = new TransmuxWorker();
	    _this.transmuxer_.postMessage({ action: 'init', options: options });
	
	    _this.transmuxer_.onmessage = function (event) {
	      if (event.data.action === 'data') {
	        return _this.data_(event);
	      }
	
	      if (event.data.action === 'done') {
	        return _this.done_(event);
	      }
	
	      if (event.data.action === 'gopInfo') {
	        return _this.appendGopInfo_(event);
	      }
	    };
	
	    // this timestampOffset is a property with the side-effect of resetting
	    // baseMediaDecodeTime in the transmuxer on the setter
	    Object.defineProperty(_this, 'timestampOffset', {
	      get: function get$$1() {
	        return this.timestampOffset_;
	      },
	      set: function set$$1(val) {
	        if (typeof val === 'number' && val >= 0) {
	          this.timestampOffset_ = val;
	          this.appendAudioInitSegment_ = true;
	
	          // reset gop buffer on timestampoffset as this signals a change in timeline
	          this.gopBuffer_.length = 0;
	          this.timeMapping_ = 0;
	
	          // We have to tell the transmuxer to set the baseMediaDecodeTime to
	          // the desired timestampOffset for the next segment
	          this.transmuxer_.postMessage({
	            action: 'setTimestampOffset',
	            timestampOffset: val
	          });
	        }
	      }
	    });
	
	    // setting the append window affects both source buffers
	    Object.defineProperty(_this, 'appendWindowStart', {
	      get: function get$$1() {
	        return (this.videoBuffer_ || this.audioBuffer_).appendWindowStart;
	      },
	      set: function set$$1(start) {
	        if (this.videoBuffer_) {
	          this.videoBuffer_.appendWindowStart = start;
	        }
	        if (this.audioBuffer_) {
	          this.audioBuffer_.appendWindowStart = start;
	        }
	      }
	    });
	
	    // this buffer is "updating" if either of its native buffers are
	    Object.defineProperty(_this, 'updating', {
	      get: function get$$1() {
	        return !!(this.bufferUpdating_ || !this.audioDisabled_ && this.audioBuffer_ && this.audioBuffer_.updating || this.videoBuffer_ && this.videoBuffer_.updating);
	      }
	    });
	
	    // the buffered property is the intersection of the buffered
	    // ranges of the native source buffers
	    Object.defineProperty(_this, 'buffered', {
	      get: function get$$1() {
	        return buffered(this.videoBuffer_, this.audioBuffer_, this.audioDisabled_);
	      }
	    });
	    return _this;
	  }
	
	  /**
	   * When we get a data event from the transmuxer
	   * we call this function and handle the data that
	   * was sent to us
	   *
	   * @private
	   * @param {Event} event the data event from the transmuxer
	   */
	
	  createClass$1(VirtualSourceBuffer, [{
	    key: 'data_',
	    value: function data_(event) {
	      var segment = event.data.segment;
	
	      // Cast ArrayBuffer to TypedArray
	      segment.data = new Uint8Array(segment.data, event.data.byteOffset, event.data.byteLength);
	
	      segment.initSegment = new Uint8Array(segment.initSegment.data, segment.initSegment.byteOffset, segment.initSegment.byteLength);
	
	      createTextTracksIfNecessary(this, this.mediaSource_, segment);
	
	      // Add the segments to the pendingBuffers array
	      this.pendingBuffers_.push(segment);
	      return;
	    }
	
	    /**
	     * When we get a done event from the transmuxer
	     * we call this function and we process all
	     * of the pending data that we have been saving in the
	     * data_ function
	     *
	     * @private
	     * @param {Event} event the done event from the transmuxer
	     */
	
	  }, {
	    key: 'done_',
	    value: function done_(event) {
	      // Don't process and append data if the mediaSource is closed
	      if (this.mediaSource_.readyState === 'closed') {
	        this.pendingBuffers_.length = 0;
	        return;
	      }
	
	      // All buffers should have been flushed from the muxer
	      // start processing anything we have received
	      this.processPendingSegments_();
	      return;
	    }
	
	    /**
	     * Create our internal native audio/video source buffers and add
	     * event handlers to them with the following conditions:
	     * 1. they do not already exist on the mediaSource
	     * 2. this VSB has a codec for them
	     *
	     * @private
	     */
	
	  }, {
	    key: 'createRealSourceBuffers_',
	    value: function createRealSourceBuffers_() {
	      var _this2 = this;
	
	      var types = ['audio', 'video'];
	
	      types.forEach(function (type) {
	        // Don't create a SourceBuffer of this type if we don't have a
	        // codec for it
	        if (!_this2[type + 'Codec_']) {
	          return;
	        }
	
	        // Do nothing if a SourceBuffer of this type already exists
	        if (_this2[type + 'Buffer_']) {
	          return;
	        }
	
	        var buffer = null;
	
	        // If the mediasource already has a SourceBuffer for the codec
	        // use that
	        if (_this2.mediaSource_[type + 'Buffer_']) {
	          buffer = _this2.mediaSource_[type + 'Buffer_'];
	          // In multiple audio track cases, the audio source buffer is disabled
	          // on the main VirtualSourceBuffer by the HTMLMediaSource much earlier
	          // than createRealSourceBuffers_ is called to create the second
	          // VirtualSourceBuffer because that happens as a side-effect of
	          // videojs-contrib-hls starting the audioSegmentLoader. As a result,
	          // the audioBuffer is essentially "ownerless" and no one will toggle
	          // the `updating` state back to false once the `updateend` event is received
	          //
	          // Setting `updating` to false manually will work around this
	          // situation and allow work to continue
	          buffer.updating = false;
	        } else {
	          var codecProperty = type + 'Codec_';
	          var mimeType = type + '/mp4;codecs="' + _this2[codecProperty] + '"';
	
	          buffer = makeWrappedSourceBuffer(_this2.mediaSource_.nativeMediaSource_, mimeType);
	
	          _this2.mediaSource_[type + 'Buffer_'] = buffer;
	        }
	
	        _this2[type + 'Buffer_'] = buffer;
	
	        // Wire up the events to the SourceBuffer
	        ['update', 'updatestart', 'updateend'].forEach(function (event) {
	          buffer.addEventListener(event, function () {
	            // if audio is disabled
	            if (type === 'audio' && _this2.audioDisabled_) {
	              return;
	            }
	
	            if (event === 'updateend') {
	              _this2[type + 'Buffer_'].updating = false;
	            }
	
	            var shouldTrigger = types.every(function (t) {
	              // skip checking audio's updating status if audio
	              // is not enabled
	              if (t === 'audio' && _this2.audioDisabled_) {
	                return true;
	              }
	              // if the other type if updating we don't trigger
	              if (type !== t && _this2[t + 'Buffer_'] && _this2[t + 'Buffer_'].updating) {
	                return false;
	              }
	              return true;
	            });
	
	            if (shouldTrigger) {
	              return _this2.trigger(event);
	            }
	          });
	        });
	      });
	    }
	
	    /**
	     * Emulate the native mediasource function, but our function will
	     * send all of the proposed segments to the transmuxer so that we
	     * can transmux them before we append them to our internal
	     * native source buffers in the correct format.
	     *
	     * @link https://developer.mozilla.org/en-US/docs/Web/API/SourceBuffer/appendBuffer
	     * @param {Uint8Array} segment the segment to append to the buffer
	     */
	
	  }, {
	    key: 'appendBuffer',
	    value: function appendBuffer(segment) {
	      // Start the internal "updating" state
	      this.bufferUpdating_ = true;
	
	      if (this.audioBuffer_ && this.audioBuffer_.buffered.length) {
	        var audioBuffered = this.audioBuffer_.buffered;
	
	        this.transmuxer_.postMessage({
	          action: 'setAudioAppendStart',
	          appendStart: audioBuffered.end(audioBuffered.length - 1)
	        });
	      }
	
	      if (this.videoBuffer_) {
	        this.transmuxer_.postMessage({
	          action: 'alignGopsWith',
	          gopsToAlignWith: gopsSafeToAlignWith(this.gopBuffer_, this.mediaSource_.player_ ? this.mediaSource_.player_.currentTime() : null, this.timeMapping_)
	        });
	      }
	
	      this.transmuxer_.postMessage({
	        action: 'push',
	        // Send the typed-array of data as an ArrayBuffer so that
	        // it can be sent as a "Transferable" and avoid the costly
	        // memory copy
	        data: segment.buffer,
	
	        // To recreate the original typed-array, we need information
	        // about what portion of the ArrayBuffer it was a view into
	        byteOffset: segment.byteOffset,
	        byteLength: segment.byteLength
	      }, [segment.buffer]);
	      this.transmuxer_.postMessage({ action: 'flush' });
	    }
	
	    /**
	     * Appends gop information (timing and byteLength) received by the transmuxer for the
	     * gops appended in the last call to appendBuffer
	     *
	     * @param {Event} event
	     *        The gopInfo event from the transmuxer
	     * @param {Array} event.data.gopInfo
	     *        List of gop info to append
	     */
	
	  }, {
	    key: 'appendGopInfo_',
	    value: function appendGopInfo_(event) {
	      this.gopBuffer_ = updateGopBuffer(this.gopBuffer_, event.data.gopInfo, this.safeAppend_);
	    }
	
	    /**
	     * Emulate the native mediasource function and remove parts
	     * of the buffer from any of our internal buffers that exist
	     *
	     * @link https://developer.mozilla.org/en-US/docs/Web/API/SourceBuffer/remove
	     * @param {Double} start position to start the remove at
	     * @param {Double} end position to end the remove at
	     */
	
	  }, {
	    key: 'remove',
	    value: function remove(start, end) {
	      if (this.videoBuffer_) {
	        this.videoBuffer_.updating = true;
	        this.videoBuffer_.remove(start, end);
	        this.gopBuffer_ = removeGopBuffer(this.gopBuffer_, start, end, this.timeMapping_);
	      }
	      if (!this.audioDisabled_ && this.audioBuffer_) {
	        this.audioBuffer_.updating = true;
	        this.audioBuffer_.remove(start, end);
	      }
	
	      // Remove Metadata Cues (id3)
	      removeCuesFromTrack(start, end, this.metadataTrack_);
	
	      // Remove Any Captions
	      if (this.inbandTextTracks_) {
	        for (var track in this.inbandTextTracks_) {
	          removeCuesFromTrack(start, end, this.inbandTextTracks_[track]);
	        }
	      }
	    }
	
	    /**
	     * Process any segments that the muxer has output
	     * Concatenate segments together based on type and append them into
	     * their respective sourceBuffers
	     *
	     * @private
	     */
	
	  }, {
	    key: 'processPendingSegments_',
	    value: function processPendingSegments_() {
	      var sortedSegments = {
	        video: {
	          segments: [],
	          bytes: 0
	        },
	        audio: {
	          segments: [],
	          bytes: 0
	        },
	        captions: [],
	        metadata: []
	      };
	
	      // Sort segments into separate video/audio arrays and
	      // keep track of their total byte lengths
	      sortedSegments = this.pendingBuffers_.reduce(function (segmentObj, segment) {
	        var type = segment.type;
	        var data = segment.data;
	        var initSegment = segment.initSegment;
	
	        segmentObj[type].segments.push(data);
	        segmentObj[type].bytes += data.byteLength;
	
	        segmentObj[type].initSegment = initSegment;
	
	        // Gather any captions into a single array
	        if (segment.captions) {
	          segmentObj.captions = segmentObj.captions.concat(segment.captions);
	        }
	
	        if (segment.info) {
	          segmentObj[type].info = segment.info;
	        }
	
	        // Gather any metadata into a single array
	        if (segment.metadata) {
	          segmentObj.metadata = segmentObj.metadata.concat(segment.metadata);
	        }
	
	        return segmentObj;
	      }, sortedSegments);
	
	      // Create the real source buffers if they don't exist by now since we
	      // finally are sure what tracks are contained in the source
	      if (!this.videoBuffer_ && !this.audioBuffer_) {
	        // Remove any codecs that may have been specified by default but
	        // are no longer applicable now
	        if (sortedSegments.video.bytes === 0) {
	          this.videoCodec_ = null;
	        }
	        if (sortedSegments.audio.bytes === 0) {
	          this.audioCodec_ = null;
	        }
	
	        this.createRealSourceBuffers_();
	      }
	
	      if (sortedSegments.audio.info) {
	        this.mediaSource_.trigger({ type: 'audioinfo', info: sortedSegments.audio.info });
	      }
	      if (sortedSegments.video.info) {
	        this.mediaSource_.trigger({ type: 'videoinfo', info: sortedSegments.video.info });
	      }
	
	      if (this.appendAudioInitSegment_) {
	        if (!this.audioDisabled_ && this.audioBuffer_) {
	          sortedSegments.audio.segments.unshift(sortedSegments.audio.initSegment);
	          sortedSegments.audio.bytes += sortedSegments.audio.initSegment.byteLength;
	        }
	        this.appendAudioInitSegment_ = false;
	      }
	
	      var triggerUpdateend = false;
	
	      // Merge multiple video and audio segments into one and append
	      if (this.videoBuffer_ && sortedSegments.video.bytes) {
	        sortedSegments.video.segments.unshift(sortedSegments.video.initSegment);
	        sortedSegments.video.bytes += sortedSegments.video.initSegment.byteLength;
	        this.concatAndAppendSegments_(sortedSegments.video, this.videoBuffer_);
	        // TODO: are video tracks the only ones with text tracks?
	        addTextTrackData(this, sortedSegments.captions, sortedSegments.metadata);
	      } else if (this.videoBuffer_ && (this.audioDisabled_ || !this.audioBuffer_)) {
	        // The transmuxer did not return any bytes of video, meaning it was all trimmed
	        // for gop alignment. Since we have a video buffer and audio is disabled, updateend
	        // will never be triggered by this source buffer, which will cause contrib-hls
	        // to be stuck forever waiting for updateend. If audio is not disabled, updateend
	        // will be triggered by the audio buffer, which will be sent upwards since the video
	        // buffer will not be in an updating state.
	        triggerUpdateend = true;
	      }
	
	      if (!this.audioDisabled_ && this.audioBuffer_) {
	        this.concatAndAppendSegments_(sortedSegments.audio, this.audioBuffer_);
	      }
	
	      this.pendingBuffers_.length = 0;
	
	      if (triggerUpdateend) {
	        this.trigger('updateend');
	      }
	
	      // We are no longer in the internal "updating" state
	      this.bufferUpdating_ = false;
	    }
	
	    /**
	     * Combine all segments into a single Uint8Array and then append them
	     * to the destination buffer
	     *
	     * @param {Object} segmentObj
	     * @param {SourceBuffer} destinationBuffer native source buffer to append data to
	     * @private
	     */
	
	  }, {
	    key: 'concatAndAppendSegments_',
	    value: function concatAndAppendSegments_(segmentObj, destinationBuffer) {
	      var offset = 0;
	      var tempBuffer = void 0;
	
	      if (segmentObj.bytes) {
	        tempBuffer = new Uint8Array(segmentObj.bytes);
	
	        // Combine the individual segments into one large typed-array
	        segmentObj.segments.forEach(function (segment) {
	          tempBuffer.set(segment, offset);
	          offset += segment.byteLength;
	        });
	
	        try {
	          destinationBuffer.updating = true;
	          destinationBuffer.appendBuffer(tempBuffer);
	        } catch (error) {
	          if (this.mediaSource_.player_) {
	            this.mediaSource_.player_.error({
	              code: -3,
	              type: 'APPEND_BUFFER_ERR',
	              message: error.message,
	              originalError: error
	            });
	          }
	        }
	      }
	    }
	
	    /**
	     * Emulate the native mediasource function. abort any soureBuffer
	     * actions and throw out any un-appended data.
	     *
	     * @link https://developer.mozilla.org/en-US/docs/Web/API/SourceBuffer/abort
	     */
	
	  }, {
	    key: 'abort',
	    value: function abort() {
	      if (this.videoBuffer_) {
	        this.videoBuffer_.abort();
	      }
	      if (!this.audioDisabled_ && this.audioBuffer_) {
	        this.audioBuffer_.abort();
	      }
	      if (this.transmuxer_) {
	        this.transmuxer_.postMessage({ action: 'reset' });
	      }
	      this.pendingBuffers_.length = 0;
	      this.bufferUpdating_ = false;
	    }
	  }]);
	  return VirtualSourceBuffer;
	}(videojs$1.EventTarget);
	
	/**
	 * @file html-media-source.js
	 */
	
	/**
	 * Our MediaSource implementation in HTML, mimics native
	 * MediaSource where/if possible.
	 *
	 * @link https://developer.mozilla.org/en-US/docs/Web/API/MediaSource
	 * @class HtmlMediaSource
	 * @extends videojs.EventTarget
	 */
	
	var HtmlMediaSource = function (_videojs$EventTarget) {
	  inherits$1(HtmlMediaSource, _videojs$EventTarget);
	
	  function HtmlMediaSource() {
	    classCallCheck$1(this, HtmlMediaSource);
	
	    var _this = possibleConstructorReturn$1(this, (HtmlMediaSource.__proto__ || Object.getPrototypeOf(HtmlMediaSource)).call(this));
	
	    var property = void 0;
	
	    _this.nativeMediaSource_ = new window$1.MediaSource();
	    // delegate to the native MediaSource's methods by default
	    for (property in _this.nativeMediaSource_) {
	      if (!(property in HtmlMediaSource.prototype) && typeof _this.nativeMediaSource_[property] === 'function') {
	        _this[property] = _this.nativeMediaSource_[property].bind(_this.nativeMediaSource_);
	      }
	    }
	
	    // emulate `duration` and `seekable` until seeking can be
	    // handled uniformly for live streams
	    // see https://github.com/w3c/media-source/issues/5
	    _this.duration_ = NaN;
	    Object.defineProperty(_this, 'duration', {
	      get: function get$$1() {
	        if (this.duration_ === Infinity) {
	          return this.duration_;
	        }
	        return this.nativeMediaSource_.duration;
	      },
	      set: function set$$1(duration) {
	        this.duration_ = duration;
	        if (duration !== Infinity) {
	          this.nativeMediaSource_.duration = duration;
	          return;
	        }
	      }
	    });
	    Object.defineProperty(_this, 'seekable', {
	      get: function get$$1() {
	        if (this.duration_ === Infinity) {
	          return videojs$1.createTimeRanges([[0, this.nativeMediaSource_.duration]]);
	        }
	        return this.nativeMediaSource_.seekable;
	      }
	    });
	
	    Object.defineProperty(_this, 'readyState', {
	      get: function get$$1() {
	        return this.nativeMediaSource_.readyState;
	      }
	    });
	
	    Object.defineProperty(_this, 'activeSourceBuffers', {
	      get: function get$$1() {
	        return this.activeSourceBuffers_;
	      }
	    });
	
	    // the list of virtual and native SourceBuffers created by this
	    // MediaSource
	    _this.sourceBuffers = [];
	
	    _this.activeSourceBuffers_ = [];
	
	    /**
	     * update the list of active source buffers based upon various
	     * imformation from HLS and video.js
	     *
	     * @private
	     */
	    _this.updateActiveSourceBuffers_ = function () {
	      // Retain the reference but empty the array
	      _this.activeSourceBuffers_.length = 0;
	
	      // If there is only one source buffer, then it will always be active and audio will
	      // be disabled based on the codec of the source buffer
	      if (_this.sourceBuffers.length === 1) {
	        var sourceBuffer = _this.sourceBuffers[0];
	
	        sourceBuffer.appendAudioInitSegment_ = true;
	        sourceBuffer.audioDisabled_ = !sourceBuffer.audioCodec_;
	        _this.activeSourceBuffers_.push(sourceBuffer);
	        return;
	      }
	
	      // There are 2 source buffers, a combined (possibly video only) source buffer and
	      // and an audio only source buffer.
	      // By default, the audio in the combined virtual source buffer is enabled
	      // and the audio-only source buffer (if it exists) is disabled.
	      var disableCombined = false;
	      var disableAudioOnly = true;
	
	      // TODO: maybe we can store the sourcebuffers on the track objects?
	      // safari may do something like this
	      for (var i = 0; i < _this.player_.audioTracks().length; i++) {
	        var track = _this.player_.audioTracks()[i];
	
	        if (track.enabled && track.kind !== 'main') {
	          // The enabled track is an alternate audio track so disable the audio in
	          // the combined source buffer and enable the audio-only source buffer.
	          disableCombined = true;
	          disableAudioOnly = false;
	          break;
	        }
	      }
	
	      _this.sourceBuffers.forEach(function (sourceBuffer, index) {
	        /* eslinst-disable */
	        // TODO once codecs are required, we can switch to using the codecs to determine
	        //      what stream is the video stream, rather than relying on videoTracks
	        /* eslinst-enable */
	
	        sourceBuffer.appendAudioInitSegment_ = true;
	
	        if (sourceBuffer.videoCodec_ && sourceBuffer.audioCodec_) {
	          // combined
	          sourceBuffer.audioDisabled_ = disableCombined;
	        } else if (sourceBuffer.videoCodec_ && !sourceBuffer.audioCodec_) {
	          // If the "combined" source buffer is video only, then we do not want
	          // disable the audio-only source buffer (this is mostly for demuxed
	          // audio and video hls)
	          sourceBuffer.audioDisabled_ = true;
	          disableAudioOnly = false;
	        } else if (!sourceBuffer.videoCodec_ && sourceBuffer.audioCodec_) {
	          // audio only
	          // In the case of audio only with alternate audio and disableAudioOnly is true
	          // this means we want to disable the audio on the alternate audio sourcebuffer
	          // but not the main "combined" source buffer. The "combined" source buffer is
	          // always at index 0, so this ensures audio won't be disabled in both source
	          // buffers.
	          sourceBuffer.audioDisabled_ = index ? disableAudioOnly : !disableAudioOnly;
	          if (sourceBuffer.audioDisabled_) {
	            return;
	          }
	        }
	
	        _this.activeSourceBuffers_.push(sourceBuffer);
	      });
	    };
	
	    _this.onPlayerMediachange_ = function () {
	      _this.sourceBuffers.forEach(function (sourceBuffer) {
	        sourceBuffer.appendAudioInitSegment_ = true;
	      });
	    };
	
	    _this.onHlsReset_ = function () {
	      _this.sourceBuffers.forEach(function (sourceBuffer) {
	        if (sourceBuffer.transmuxer_) {
	          sourceBuffer.transmuxer_.postMessage({ action: 'resetCaptions' });
	        }
	      });
	    };
	
	    _this.onHlsSegmentTimeMapping_ = function (event) {
	      _this.sourceBuffers.forEach(function (buffer) {
	        return buffer.timeMapping_ = event.mapping;
	      });
	    };
	
	    // Re-emit MediaSource events on the polyfill
	    ['sourceopen', 'sourceclose', 'sourceended'].forEach(function (eventName) {
	      this.nativeMediaSource_.addEventListener(eventName, this.trigger.bind(this));
	    }, _this);
	
	    // capture the associated player when the MediaSource is
	    // successfully attached
	    _this.on('sourceopen', function (event) {
	      // Get the player this MediaSource is attached to
	      var video = document.querySelector('[src="' + _this.url_ + '"]');
	
	      if (!video) {
	        return;
	      }
	
	      _this.player_ = videojs$1(video.parentNode);
	
	      // hls-reset is fired by videojs.Hls on to the tech after the main SegmentLoader
	      // resets its state and flushes the buffer
	      _this.player_.tech_.on('hls-reset', _this.onHlsReset_);
	      // hls-segment-time-mapping is fired by videojs.Hls on to the tech after the main
	      // SegmentLoader inspects an MTS segment and has an accurate stream to display
	      // time mapping
	      _this.player_.tech_.on('hls-segment-time-mapping', _this.onHlsSegmentTimeMapping_);
	
	      if (_this.player_.audioTracks && _this.player_.audioTracks()) {
	        _this.player_.audioTracks().on('change', _this.updateActiveSourceBuffers_);
	        _this.player_.audioTracks().on('addtrack', _this.updateActiveSourceBuffers_);
	        _this.player_.audioTracks().on('removetrack', _this.updateActiveSourceBuffers_);
	      }
	
	      _this.player_.on('mediachange', _this.onPlayerMediachange_);
	    });
	
	    _this.on('sourceended', function (event) {
	      var duration = durationOfVideo(_this.duration);
	
	      for (var i = 0; i < _this.sourceBuffers.length; i++) {
	        var sourcebuffer = _this.sourceBuffers[i];
	        var cues = sourcebuffer.metadataTrack_ && sourcebuffer.metadataTrack_.cues;
	
	        if (cues && cues.length) {
	          cues[cues.length - 1].endTime = duration;
	        }
	      }
	    });
	
	    // explicitly terminate any WebWorkers that were created
	    // by SourceHandlers
	    _this.on('sourceclose', function (event) {
	      this.sourceBuffers.forEach(function (sourceBuffer) {
	        if (sourceBuffer.transmuxer_) {
	          sourceBuffer.transmuxer_.terminate();
	        }
	      });
	
	      this.sourceBuffers.length = 0;
	      if (!this.player_) {
	        return;
	      }
	
	      if (this.player_.audioTracks && this.player_.audioTracks()) {
	        this.player_.audioTracks().off('change', this.updateActiveSourceBuffers_);
	        this.player_.audioTracks().off('addtrack', this.updateActiveSourceBuffers_);
	        this.player_.audioTracks().off('removetrack', this.updateActiveSourceBuffers_);
	      }
	
	      // We can only change this if the player hasn't been disposed of yet
	      // because `off` eventually tries to use the el_ property. If it has
	      // been disposed of, then don't worry about it because there are no
	      // event handlers left to unbind anyway
	      if (this.player_.el_) {
	        this.player_.off('mediachange', this.onPlayerMediachange_);
	        this.player_.tech_.off('hls-reset', this.onHlsReset_);
	        this.player_.tech_.off('hls-segment-time-mapping', this.onHlsSegmentTimeMapping_);
	      }
	    });
	    return _this;
	  }
	
	  /**
	   * Add a range that that can now be seeked to.
	   *
	   * @param {Double} start where to start the addition
	   * @param {Double} end where to end the addition
	   * @private
	   */
	
	  createClass$1(HtmlMediaSource, [{
	    key: 'addSeekableRange_',
	    value: function addSeekableRange_(start, end) {
	      var error = void 0;
	
	      if (this.duration !== Infinity) {
	        error = new Error('MediaSource.addSeekableRange() can only be invoked ' + 'when the duration is Infinity');
	        error.name = 'InvalidStateError';
	        error.code = 11;
	        throw error;
	      }
	
	      if (end > this.nativeMediaSource_.duration || isNaN(this.nativeMediaSource_.duration)) {
	        this.nativeMediaSource_.duration = end;
	      }
	    }
	
	    /**
	     * Add a source buffer to the media source.
	     *
	     * @link https://developer.mozilla.org/en-US/docs/Web/API/MediaSource/addSourceBuffer
	     * @param {String} type the content-type of the content
	     * @return {Object} the created source buffer
	     */
	
	  }, {
	    key: 'addSourceBuffer',
	    value: function addSourceBuffer(type) {
	      var buffer = void 0;
	      var parsedType = parseContentType(type);
	
	      // Create a VirtualSourceBuffer to transmux MPEG-2 transport
	      // stream segments into fragmented MP4s
	      if (/^(video|audio)\/mp2t$/i.test(parsedType.type)) {
	        var codecs = [];
	
	        if (parsedType.parameters && parsedType.parameters.codecs) {
	          codecs = parsedType.parameters.codecs.split(',');
	          codecs = translateLegacyCodecs(codecs);
	          codecs = codecs.filter(function (codec) {
	            return isAudioCodec(codec) || isVideoCodec(codec);
	          });
	        }
	
	        if (codecs.length === 0) {
	          codecs = ['avc1.4d400d', 'mp4a.40.2'];
	        }
	
	        buffer = new VirtualSourceBuffer(this, codecs);
	
	        if (this.sourceBuffers.length !== 0) {
	          // If another VirtualSourceBuffer already exists, then we are creating a
	          // SourceBuffer for an alternate audio track and therefore we know that
	          // the source has both an audio and video track.
	          // That means we should trigger the manual creation of the real
	          // SourceBuffers instead of waiting for the transmuxer to return data
	          this.sourceBuffers[0].createRealSourceBuffers_();
	          buffer.createRealSourceBuffers_();
	
	          // Automatically disable the audio on the first source buffer if
	          // a second source buffer is ever created
	          this.sourceBuffers[0].audioDisabled_ = true;
	        }
	      } else {
	        // delegate to the native implementation
	        buffer = this.nativeMediaSource_.addSourceBuffer(type);
	      }
	
	      this.sourceBuffers.push(buffer);
	      return buffer;
	    }
	  }]);
	  return HtmlMediaSource;
	}(videojs$1.EventTarget);
	
	/**
	 * @file videojs-contrib-media-sources.js
	 */
	var urlCount = 0;
	
	// ------------
	// Media Source
	// ------------
	
	// store references to the media sources so they can be connected
	// to a video element (a swf object)
	// TODO: can we store this somewhere local to this module?
	videojs$1.mediaSources = {};
	
	/**
	 * Provide a method for a swf object to notify JS that a
	 * media source is now open.
	 *
	 * @param {String} msObjectURL string referencing the MSE Object URL
	 * @param {String} swfId the swf id
	 */
	var open = function open(msObjectURL, swfId) {
	  var mediaSource = videojs$1.mediaSources[msObjectURL];
	
	  if (mediaSource) {
	    mediaSource.trigger({ type: 'sourceopen', swfId: swfId });
	  } else {
	    throw new Error('Media Source not found (Video.js)');
	  }
	};
	
	/**
	 * Check to see if the native MediaSource object exists and supports
	 * an MP4 container with both H.264 video and AAC-LC audio.
	 *
	 * @return {Boolean} if  native media sources are supported
	 */
	var supportsNativeMediaSources = function supportsNativeMediaSources() {
	  return !!window$1.MediaSource && !!window$1.MediaSource.isTypeSupported && window$1.MediaSource.isTypeSupported('video/mp4;codecs="avc1.4d400d,mp4a.40.2"');
	};
	
	/**
	 * An emulation of the MediaSource API so that we can support
	 * native and non-native functionality. returns an instance of
	 * HtmlMediaSource.
	 *
	 * @link https://developer.mozilla.org/en-US/docs/Web/API/MediaSource/MediaSource
	 */
	var MediaSource = function MediaSource() {
	  this.MediaSource = {
	    open: open,
	    supportsNativeMediaSources: supportsNativeMediaSources
	  };
	
	  if (supportsNativeMediaSources()) {
	    return new HtmlMediaSource();
	  }
	
	  throw new Error('Cannot use create a virtual MediaSource for this video');
	};
	
	MediaSource.open = open;
	MediaSource.supportsNativeMediaSources = supportsNativeMediaSources;
	
	/**
	 * A wrapper around the native URL for our MSE object
	 * implementation, this object is exposed under videojs.URL
	 *
	 * @link https://developer.mozilla.org/en-US/docs/Web/API/URL/URL
	 */
	var URL$1 = {
	  /**
	   * A wrapper around the native createObjectURL for our objects.
	   * This function maps a native or emulated mediaSource to a blob
	   * url so that it can be loaded into video.js
	   *
	   * @link https://developer.mozilla.org/en-US/docs/Web/API/URL/createObjectURL
	   * @param {MediaSource} object the object to create a blob url to
	   */
	  createObjectURL: function createObjectURL(object) {
	    var objectUrlPrefix = 'blob:vjs-media-source/';
	    var url = void 0;
	
	    // use the native MediaSource to generate an object URL
	    if (object instanceof HtmlMediaSource) {
	      url = window$1.URL.createObjectURL(object.nativeMediaSource_);
	      object.url_ = url;
	      return url;
	    }
	    // if the object isn't an emulated MediaSource, delegate to the
	    // native implementation
	    if (!(object instanceof HtmlMediaSource)) {
	      url = window$1.URL.createObjectURL(object);
	      object.url_ = url;
	      return url;
	    }
	
	    // build a URL that can be used to map back to the emulated
	    // MediaSource
	    url = objectUrlPrefix + urlCount;
	
	    urlCount++;
	
	    // setup the mapping back to object
	    videojs$1.mediaSources[url] = object;
	
	    return url;
	  }
	};
	
	videojs$1.MediaSource = MediaSource;
	videojs$1.URL = URL$1;
	
	var EventTarget$1$1 = videojs$1.EventTarget,
	    mergeOptions$2 = videojs$1.mergeOptions;
	
	/**
	 * Returns a new master manifest that is the result of merging an updated master manifest
	 * into the original version.
	 *
	 * @param {Object} oldMaster
	 *        The old parsed mpd object
	 * @param {Object} newMaster
	 *        The updated parsed mpd object
	 * @return {Object}
	 *         A new object representing the original master manifest with the updated media
	 *         playlists merged in
	 */
	
	var updateMaster$1 = function updateMaster$$1(oldMaster, newMaster) {
	  var update = mergeOptions$2(oldMaster, {
	    // These are top level properties that can be updated
	    duration: newMaster.duration,
	    minimumUpdatePeriod: newMaster.minimumUpdatePeriod
	  });
	
	  // First update the playlists in playlist list
	  for (var i = 0; i < newMaster.playlists.length; i++) {
	    var playlistUpdate = updateMaster(update, newMaster.playlists[i]);
	
	    if (playlistUpdate) {
	      update = playlistUpdate;
	    }
	  }
	
	  // Then update media group playlists
	  forEachMediaGroup(newMaster, function (properties, type, group, label) {
	    if (properties.playlists && properties.playlists.length) {
	      var uri = properties.playlists[0].uri;
	      var _playlistUpdate = updateMaster(update, properties.playlists[0]);
	
	      if (_playlistUpdate) {
	        update = _playlistUpdate;
	        // update the playlist reference within media groups
	        update.mediaGroups[type][group][label].playlists[0] = update.playlists[uri];
	      }
	    }
	  });
	
	  return update;
	};
	
	var DashPlaylistLoader = function (_EventTarget) {
	  inherits$1(DashPlaylistLoader, _EventTarget);
	
	  // DashPlaylistLoader must accept either a src url or a playlist because subsequent
	  // playlist loader setups from media groups will expect to be able to pass a playlist
	  // (since there aren't external URLs to media playlists with DASH)
	  function DashPlaylistLoader(srcUrlOrPlaylist, hls, withCredentials, masterPlaylistLoader) {
	    classCallCheck$1(this, DashPlaylistLoader);
	
	    var _this = possibleConstructorReturn$1(this, (DashPlaylistLoader.__proto__ || Object.getPrototypeOf(DashPlaylistLoader)).call(this));
	
	    _this.hls_ = hls;
	    _this.withCredentials = withCredentials;
	
	    if (!srcUrlOrPlaylist) {
	      throw new Error('A non-empty playlist URL or playlist is required');
	    }
	
	    // event naming?
	    _this.on('minimumUpdatePeriod', function () {
	      _this.refreshXml_();
	    });
	
	    // live playlist staleness timeout
	    _this.on('mediaupdatetimeout', function () {
	      _this.refreshMedia_();
	    });
	
	    // initialize the loader state
	    if (typeof srcUrlOrPlaylist === 'string') {
	      _this.srcUrl = srcUrlOrPlaylist;
	      _this.state = 'HAVE_NOTHING';
	      return possibleConstructorReturn$1(_this);
	    }
	
	    _this.masterPlaylistLoader_ = masterPlaylistLoader;
	
	    _this.state = 'HAVE_METADATA';
	    _this.started = true;
	    // we only should have one playlist so select it
	    _this.media(srcUrlOrPlaylist);
	    // trigger async to mimic behavior of HLS, where it must request a playlist
	    window$1.setTimeout(function () {
	      _this.trigger('loadedmetadata');
	    }, 0);
	    return _this;
	  }
	
	  createClass$1(DashPlaylistLoader, [{
	    key: 'dispose',
	    value: function dispose() {
	      this.stopRequest();
	      window$1.clearTimeout(this.mediaUpdateTimeout);
	    }
	  }, {
	    key: 'stopRequest',
	    value: function stopRequest() {
	      if (this.request) {
	        var oldRequest = this.request;
	
	        this.request = null;
	        oldRequest.onreadystatechange = null;
	        oldRequest.abort();
	      }
	    }
	  }, {
	    key: 'media',
	    value: function media(playlist) {
	      // getter
	      if (!playlist) {
	        return this.media_;
	      }
	
	      // setter
	      if (this.state === 'HAVE_NOTHING') {
	        throw new Error('Cannot switch media playlist from ' + this.state);
	      }
	
	      var startingState = this.state;
	
	      // find the playlist object if the target playlist has been specified by URI
	      if (typeof playlist === 'string') {
	        if (!this.master.playlists[playlist]) {
	          throw new Error('Unknown playlist URI: ' + playlist);
	        }
	        playlist = this.master.playlists[playlist];
	      }
	
	      var mediaChange = !this.media_ || playlist.uri !== this.media_.uri;
	
	      this.state = 'HAVE_METADATA';
	
	      // switching to the active playlist is a no-op
	      if (!mediaChange) {
	        return;
	      }
	
	      // switching from an already loaded playlist
	      if (this.media_) {
	        this.trigger('mediachanging');
	      }
	
	      this.media_ = playlist;
	
	      this.refreshMedia_();
	
	      // trigger media change if the active media has been updated
	      if (startingState !== 'HAVE_MASTER') {
	        this.trigger('mediachange');
	      }
	    }
	  }, {
	    key: 'pause',
	    value: function pause() {
	      this.stopRequest();
	      if (this.state === 'HAVE_NOTHING') {
	        // If we pause the loader before any data has been retrieved, its as if we never
	        // started, so reset to an unstarted state.
	        this.started = false;
	      }
	    }
	  }, {
	    key: 'load',
	    value: function load() {
	      // because the playlists are internal to the manifest, load should either load the
	      // main manifest, or do nothing but trigger an event
	      if (!this.started) {
	        this.start();
	        return;
	      }
	
	      this.trigger('loadedplaylist');
	    }
	
	    /**
	     * Parses the master xml string and updates playlist uri references
	     *
	     * @return {Object}
	     *         The parsed mpd manifest object
	     */
	
	  }, {
	    key: 'parseMasterXml',
	    value: function parseMasterXml() {
	      var master = mpdParser.parse(this.masterXml_, {
	        manifestUri: this.srcUrl,
	        clientOffset: this.clientOffset_
	      });
	
	      master.uri = this.srcUrl;
	
	      // Set up phony URIs for the playlists since we won't have external URIs for DASH
	      // but reference playlists by their URI throughout the project
	      // TODO: Should we create the dummy uris in mpd-parser as well (leaning towards yes).
	      for (var i = 0; i < master.playlists.length; i++) {
	        var phonyUri = 'placeholder-uri-' + i;
	
	        master.playlists[i].uri = phonyUri;
	        // set up by URI references
	        master.playlists[phonyUri] = master.playlists[i];
	      }
	
	      // set up phony URIs for the media group playlists since we won't have external
	      // URIs for DASH but reference playlists by their URI throughout the project
	      forEachMediaGroup(master, function (properties, mediaType, groupKey, labelKey) {
	        if (properties.playlists && properties.playlists.length) {
	          var _phonyUri = 'placeholder-uri-' + mediaType + '-' + groupKey + '-' + labelKey;
	
	          properties.playlists[0].uri = _phonyUri;
	          // setup URI references
	          master.playlists[_phonyUri] = properties.playlists[0];
	        }
	      });
	
	      setupMediaPlaylists(master);
	      resolveMediaGroupUris(master);
	
	      return master;
	    }
	  }, {
	    key: 'start',
	    value: function start() {
	      var _this2 = this;
	
	      this.started = true;
	
	      // request the specified URL
	      this.request = this.hls_.xhr({
	        uri: this.srcUrl,
	        withCredentials: this.withCredentials
	      }, function (error, req) {
	        // disposed
	        if (!_this2.request) {
	          return;
	        }
	
	        // clear the loader's request reference
	        _this2.request = null;
	
	        if (error) {
	          _this2.error = {
	            status: req.status,
	            message: 'DASH playlist request error at URL: ' + _this2.srcUrl,
	            responseText: req.responseText,
	            // MEDIA_ERR_NETWORK
	            code: 2
	          };
	          if (_this2.state === 'HAVE_NOTHING') {
	            _this2.started = false;
	          }
	          return _this2.trigger('error');
	        }
	
	        _this2.masterXml_ = req.responseText;
	
	        if (req.responseHeaders && req.responseHeaders.date) {
	          _this2.masterLoaded_ = Date.parse(req.responseHeaders.date);
	        } else {
	          _this2.masterLoaded_ = Date.now();
	        }
	
	        _this2.syncClientServerClock_(_this2.onClientServerClockSync_.bind(_this2));
	      });
	    }
	
	    /**
	     * Parses the master xml for UTCTiming node to sync the client clock to the server
	     * clock. If the UTCTiming node requires a HEAD or GET request, that request is made.
	     *
	     * @param {Function} done
	     *        Function to call when clock sync has completed
	     */
	
	  }, {
	    key: 'syncClientServerClock_',
	    value: function syncClientServerClock_(done) {
	      var _this3 = this;
	
	      var utcTiming = mpdParser.parseUTCTiming(this.masterXml_);
	
	      // No UTCTiming element found in the mpd. Use Date header from mpd request as the
	      // server clock
	      if (utcTiming === null) {
	        this.clientOffset_ = this.masterLoaded_ - Date.now();
	        return done();
	      }
	
	      if (utcTiming.method === 'DIRECT') {
	        this.clientOffset_ = utcTiming.value - Date.now();
	        return done();
	      }
	
	      this.request = this.hls_.xhr({
	        uri: resolveUrl(this.srcUrl, utcTiming.value),
	        method: utcTiming.method,
	        withCredentials: this.withCredentials
	      }, function (error, req) {
	        // disposed
	        if (!_this3.request) {
	          return;
	        }
	
	        if (error) {
	          // sync request failed, fall back to using date header from mpd
	          // TODO: log warning
	          _this3.clientOffset_ = _this3.masterLoaded_ - Date.now();
	          return done();
	        }
	
	        var serverTime = void 0;
	
	        if (utcTiming.method === 'HEAD') {
	          if (!req.responseHeaders || !req.responseHeaders.date) {
	            // expected date header not preset, fall back to using date header from mpd
	            // TODO: log warning
	            serverTime = _this3.masterLoaded_;
	          } else {
	            serverTime = Date.parse(req.responseHeaders.date);
	          }
	        } else {
	          serverTime = Date.parse(req.responseText);
	        }
	
	        _this3.clientOffset_ = serverTime - Date.now();
	
	        done();
	      });
	    }
	
	    /**
	     * Handler for after client/server clock synchronization has happened. Sets up
	     * xml refresh timer if specificed by the manifest.
	     */
	
	  }, {
	    key: 'onClientServerClockSync_',
	    value: function onClientServerClockSync_() {
	      var _this4 = this;
	
	      this.master = this.parseMasterXml();
	
	      this.state = 'HAVE_MASTER';
	
	      this.trigger('loadedplaylist');
	
	      if (!this.media_) {
	        // no media playlist was specifically selected so start
	        // from the first listed one
	        this.media(this.master.playlists[0]);
	      }
	      // trigger loadedmetadata to resolve setup of media groups
	      // trigger async to mimic behavior of HLS, where it must request a playlist
	      window$1.setTimeout(function () {
	        _this4.trigger('loadedmetadata');
	      }, 0);
	
	      // TODO: minimumUpdatePeriod can have a value of 0. Currently the manifest will not
	      // be refreshed when this is the case. The inter-op guide says that when the
	      // minimumUpdatePeriod is 0, the manifest should outline all currently available
	      // segments, but future segments may require an update. I think a good solution
	      // would be to update the manifest at the same rate that the media playlists
	      // are "refreshed", i.e. every targetDuration.
	      if (this.master.minimumUpdatePeriod) {
	        window$1.setTimeout(function () {
	          _this4.trigger('minimumUpdatePeriod');
	        }, this.master.minimumUpdatePeriod);
	      }
	    }
	
	    /**
	     * Sends request to refresh the master xml and updates the parsed master manifest
	     * TODO: Does the client offset need to be recalculated when the xml is refreshed?
	     */
	
	  }, {
	    key: 'refreshXml_',
	    value: function refreshXml_() {
	      var _this5 = this;
	
	      this.request = this.hls_.xhr({
	        uri: this.srcUrl,
	        withCredentials: this.withCredentials
	      }, function (error, req) {
	        // disposed
	        if (!_this5.request) {
	          return;
	        }
	
	        // clear the loader's request reference
	        _this5.request = null;
	
	        if (error) {
	          _this5.error = {
	            status: req.status,
	            message: 'DASH playlist request error at URL: ' + _this5.srcUrl,
	            responseText: req.responseText,
	            // MEDIA_ERR_NETWORK
	            code: 2
	          };
	          if (_this5.state === 'HAVE_NOTHING') {
	            _this5.started = false;
	          }
	          return _this5.trigger('error');
	        }
	
	        _this5.masterXml_ = req.responseText;
	
	        var newMaster = _this5.parseMasterXml();
	
	        _this5.master = updateMaster$1(_this5.master, newMaster);
	
	        window$1.setTimeout(function () {
	          _this5.trigger('minimumUpdatePeriod');
	        }, _this5.master.minimumUpdatePeriod);
	      });
	    }
	
	    /**
	     * Refreshes the media playlist by re-parsing the master xml and updating playlist
	     * references. If this is an alternate loader, the updated parsed manifest is retrieved
	     * from the master loader.
	     */
	
	  }, {
	    key: 'refreshMedia_',
	    value: function refreshMedia_() {
	      var _this6 = this;
	
	      var oldMaster = void 0;
	      var newMaster = void 0;
	
	      if (this.masterPlaylistLoader_) {
	        oldMaster = this.masterPlaylistLoader_.master;
	        newMaster = this.masterPlaylistLoader_.parseMasterXml();
	      } else {
	        oldMaster = this.master;
	        newMaster = this.parseMasterXml();
	      }
	
	      var updatedMaster = updateMaster$1(oldMaster, newMaster);
	
	      if (updatedMaster) {
	        if (this.masterPlaylistLoader_) {
	          this.masterPlaylistLoader_.master = updatedMaster;
	        } else {
	          this.master = updatedMaster;
	        }
	        this.media_ = updatedMaster.playlists[this.media_.uri];
	      } else {
	        this.trigger('playlistunchanged');
	      }
	
	      if (!this.media().endList) {
	        this.mediaUpdateTimeout = window$1.setTimeout(function () {
	          _this6.trigger('mediaupdatetimeout');
	        }, refreshDelay(this.media(), !!updatedMaster));
	      }
	
	      this.trigger('loadedplaylist');
	    }
	  }]);
	  return DashPlaylistLoader;
	}(EventTarget$1$1);
	
	var logger = function logger(source) {
	  if (videojs$1.log.debug) {
	    return videojs$1.log.debug.bind(videojs$1, 'VHS:', source + ' >');
	  }
	
	  return function () {};
	};
	
	function noop() {}
	
	/**
	 * @file source-updater.js
	 */
	
	/**
	 * A queue of callbacks to be serialized and applied when a
	 * MediaSource and its associated SourceBuffers are not in the
	 * updating state. It is used by the segment loader to update the
	 * underlying SourceBuffers when new data is loaded, for instance.
	 *
	 * @class SourceUpdater
	 * @param {MediaSource} mediaSource the MediaSource to create the
	 * SourceBuffer from
	 * @param {String} mimeType the desired MIME type of the underlying
	 * SourceBuffer
	 * @param {Object} sourceBufferEmitter an event emitter that fires when a source buffer is
	 * added to the media source
	 */
	
	var SourceUpdater = function () {
	  function SourceUpdater(mediaSource, mimeType, type, sourceBufferEmitter) {
	    classCallCheck$1(this, SourceUpdater);
	
	    this.callbacks_ = [];
	    this.pendingCallback_ = null;
	    this.timestampOffset_ = 0;
	    this.mediaSource = mediaSource;
	    this.processedAppend_ = false;
	    this.type_ = type;
	    this.mimeType_ = mimeType;
	    this.logger_ = logger('SourceUpdater[' + type + '][' + mimeType + ']');
	
	    if (mediaSource.readyState === 'closed') {
	      mediaSource.addEventListener('sourceopen', this.createSourceBuffer_.bind(this, mimeType, sourceBufferEmitter));
	    } else {
	      this.createSourceBuffer_(mimeType, sourceBufferEmitter);
	    }
	  }
	
	  createClass$1(SourceUpdater, [{
	    key: 'createSourceBuffer_',
	    value: function createSourceBuffer_(mimeType, sourceBufferEmitter) {
	      var _this = this;
	
	      this.sourceBuffer_ = this.mediaSource.addSourceBuffer(mimeType);
	
	      this.logger_('created SourceBuffer');
	
	      if (sourceBufferEmitter) {
	        sourceBufferEmitter.trigger('sourcebufferadded');
	
	        if (this.mediaSource.sourceBuffers.length < 2) {
	          // There's another source buffer we must wait for before we can start updating
	          // our own (or else we can get into a bad state, i.e., appending video/audio data
	          // before the other video/audio source buffer is available and leading to a video
	          // or audio only buffer).
	          sourceBufferEmitter.on('sourcebufferadded', function () {
	            _this.start_();
	          });
	          return;
	        }
	      }
	
	      this.start_();
	    }
	  }, {
	    key: 'start_',
	    value: function start_() {
	      var _this2 = this;
	
	      this.started_ = true;
	
	      // run completion handlers and process callbacks as updateend
	      // events fire
	      this.onUpdateendCallback_ = function () {
	        var pendingCallback = _this2.pendingCallback_;
	
	        _this2.pendingCallback_ = null;
	
	        _this2.logger_('buffered [' + printableRange(_this2.buffered()) + ']');
	
	        if (pendingCallback) {
	          pendingCallback();
	        }
	
	        _this2.runCallback_();
	      };
	
	      this.sourceBuffer_.addEventListener('updateend', this.onUpdateendCallback_);
	
	      this.runCallback_();
	    }
	
	    /**
	     * Aborts the current segment and resets the segment parser.
	     *
	     * @param {Function} done function to call when done
	     * @see http://w3c.github.io/media-source/#widl-SourceBuffer-abort-void
	     */
	
	  }, {
	    key: 'abort',
	    value: function abort(done) {
	      var _this3 = this;
	
	      if (this.processedAppend_) {
	        this.queueCallback_(function () {
	          _this3.sourceBuffer_.abort();
	        }, done);
	      }
	    }
	
	    /**
	     * Queue an update to append an ArrayBuffer.
	     *
	     * @param {ArrayBuffer} bytes
	     * @param {Function} done the function to call when done
	     * @see http://www.w3.org/TR/media-source/#widl-SourceBuffer-appendBuffer-void-ArrayBuffer-data
	     */
	
	  }, {
	    key: 'appendBuffer',
	    value: function appendBuffer(bytes, done) {
	      var _this4 = this;
	
	      this.processedAppend_ = true;
	      this.queueCallback_(function () {
	        _this4.sourceBuffer_.appendBuffer(bytes);
	      }, done);
	    }
	
	    /**
	     * Indicates what TimeRanges are buffered in the managed SourceBuffer.
	     *
	     * @see http://www.w3.org/TR/media-source/#widl-SourceBuffer-buffered
	     */
	
	  }, {
	    key: 'buffered',
	    value: function buffered() {
	      if (!this.sourceBuffer_) {
	        return videojs$1.createTimeRanges();
	      }
	      return this.sourceBuffer_.buffered;
	    }
	
	    /**
	     * Queue an update to remove a time range from the buffer.
	     *
	     * @param {Number} start where to start the removal
	     * @param {Number} end where to end the removal
	     * @param {Function} [done=noop] optional callback to be executed when the remove
	     * operation is complete
	     * @see http://www.w3.org/TR/media-source/#widl-SourceBuffer-remove-void-double-start-unrestricted-double-end
	     */
	
	  }, {
	    key: 'remove',
	    value: function remove(start, end) {
	      var _this5 = this;
	
	      var done = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : noop;
	
	      if (this.processedAppend_) {
	        this.queueCallback_(function () {
	          _this5.logger_('remove [' + start + ' => ' + end + ']');
	          _this5.sourceBuffer_.remove(start, end);
	        }, done);
	      }
	    }
	
	    /**
	     * Whether the underlying sourceBuffer is updating or not
	     *
	     * @return {Boolean} the updating status of the SourceBuffer
	     */
	
	  }, {
	    key: 'updating',
	    value: function updating() {
	      return !this.sourceBuffer_ || this.sourceBuffer_.updating || this.pendingCallback_;
	    }
	
	    /**
	     * Set/get the timestampoffset on the SourceBuffer
	     *
	     * @return {Number} the timestamp offset
	     */
	
	  }, {
	    key: 'timestampOffset',
	    value: function timestampOffset(offset) {
	      var _this6 = this;
	
	      if (typeof offset !== 'undefined') {
	        this.queueCallback_(function () {
	          _this6.sourceBuffer_.timestampOffset = offset;
	        });
	        this.timestampOffset_ = offset;
	      }
	      return this.timestampOffset_;
	    }
	
	    /**
	     * Queue a callback to run
	     */
	
	  }, {
	    key: 'queueCallback_',
	    value: function queueCallback_(callback, done) {
	      this.callbacks_.push([callback.bind(this), done]);
	      this.runCallback_();
	    }
	
	    /**
	     * Run a queued callback
	     */
	
	  }, {
	    key: 'runCallback_',
	    value: function runCallback_() {
	      var callbacks = void 0;
	
	      if (!this.updating() && this.callbacks_.length && this.started_) {
	        callbacks = this.callbacks_.shift();
	        this.pendingCallback_ = callbacks[1];
	        callbacks[0]();
	      }
	    }
	
	    /**
	     * dispose of the source updater and the underlying sourceBuffer
	     */
	
	  }, {
	    key: 'dispose',
	    value: function dispose() {
	      this.sourceBuffer_.removeEventListener('updateend', this.onUpdateendCallback_);
	      if (this.sourceBuffer_ && this.mediaSource.readyState === 'open') {
	        this.sourceBuffer_.abort();
	      }
	    }
	  }]);
	  return SourceUpdater;
	}();
	
	var Config = {
	  GOAL_BUFFER_LENGTH: 30,
	  MAX_GOAL_BUFFER_LENGTH: 60,
	  GOAL_BUFFER_LENGTH_RATE: 1,
	  // A fudge factor to apply to advertised playlist bitrates to account for
	  // temporary flucations in client bandwidth
	  BANDWIDTH_VARIANCE: 1.2,
	  // How much of the buffer must be filled before we consider upswitching
	  BUFFER_LOW_WATER_LINE: 0,
	  MAX_BUFFER_LOW_WATER_LINE: 30,
	  BUFFER_LOW_WATER_LINE_RATE: 1
	};
	
	var REQUEST_ERRORS = {
	  FAILURE: 2,
	  TIMEOUT: -101,
	  ABORTED: -102
	};
	
	/**
	 * Turns segment byterange into a string suitable for use in
	 * HTTP Range requests
	 *
	 * @param {Object} byterange - an object with two values defining the start and end
	 *                             of a byte-range
	 */
	var byterangeStr = function byterangeStr(byterange) {
	  var byterangeStart = void 0;
	  var byterangeEnd = void 0;
	
	  // `byterangeEnd` is one less than `offset + length` because the HTTP range
	  // header uses inclusive ranges
	  byterangeEnd = byterange.offset + byterange.length - 1;
	  byterangeStart = byterange.offset;
	  return 'bytes=' + byterangeStart + '-' + byterangeEnd;
	};
	
	/**
	 * Defines headers for use in the xhr request for a particular segment.
	 *
	 * @param {Object} segment - a simplified copy of the segmentInfo object
	 *                           from SegmentLoader
	 */
	var segmentXhrHeaders = function segmentXhrHeaders(segment) {
	  var headers = {};
	
	  if (segment.byterange) {
	    headers.Range = byterangeStr(segment.byterange);
	  }
	  return headers;
	};
	
	/**
	 * Abort all requests
	 *
	 * @param {Object} activeXhrs - an object that tracks all XHR requests
	 */
	var abortAll = function abortAll(activeXhrs) {
	  activeXhrs.forEach(function (xhr$$1) {
	    xhr$$1.abort();
	  });
	};
	
	/**
	 * Gather important bandwidth stats once a request has completed
	 *
	 * @param {Object} request - the XHR request from which to gather stats
	 */
	var getRequestStats = function getRequestStats(request) {
	  return {
	    bandwidth: request.bandwidth,
	    bytesReceived: request.bytesReceived || 0,
	    roundTripTime: request.roundTripTime || 0
	  };
	};
	
	/**
	 * If possible gather bandwidth stats as a request is in
	 * progress
	 *
	 * @param {Event} progressEvent - an event object from an XHR's progress event
	 */
	var getProgressStats = function getProgressStats(progressEvent) {
	  var request = progressEvent.target;
	  var roundTripTime = Date.now() - request.requestTime;
	  var stats = {
	    bandwidth: Infinity,
	    bytesReceived: 0,
	    roundTripTime: roundTripTime || 0
	  };
	
	  stats.bytesReceived = progressEvent.loaded;
	  // This can result in Infinity if stats.roundTripTime is 0 but that is ok
	  // because we should only use bandwidth stats on progress to determine when
	  // abort a request early due to insufficient bandwidth
	  stats.bandwidth = Math.floor(stats.bytesReceived / stats.roundTripTime * 8 * 1000);
	
	  return stats;
	};
	
	/**
	 * Handle all error conditions in one place and return an object
	 * with all the information
	 *
	 * @param {Error|null} error - if non-null signals an error occured with the XHR
	 * @param {Object} request -  the XHR request that possibly generated the error
	 */
	var handleErrors = function handleErrors(error, request) {
	  if (request.timedout) {
	    return {
	      status: request.status,
	      message: 'HLS request timed-out at URL: ' + request.uri,
	      code: REQUEST_ERRORS.TIMEOUT,
	      xhr: request
	    };
	  }
	
	  if (request.aborted) {
	    return {
	      status: request.status,
	      message: 'HLS request aborted at URL: ' + request.uri,
	      code: REQUEST_ERRORS.ABORTED,
	      xhr: request
	    };
	  }
	
	  if (error) {
	    return {
	      status: request.status,
	      message: 'HLS request errored at URL: ' + request.uri,
	      code: REQUEST_ERRORS.FAILURE,
	      xhr: request
	    };
	  }
	
	  return null;
	};
	
	/**
	 * Handle responses for key data and convert the key data to the correct format
	 * for the decryption step later
	 *
	 * @param {Object} segment - a simplified copy of the segmentInfo object
	 *                           from SegmentLoader
	 * @param {Function} finishProcessingFn - a callback to execute to continue processing
	 *                                        this request
	 */
	var handleKeyResponse = function handleKeyResponse(segment, finishProcessingFn) {
	  return function (error, request) {
	    var response = request.response;
	    var errorObj = handleErrors(error, request);
	
	    if (errorObj) {
	      return finishProcessingFn(errorObj, segment);
	    }
	
	    if (response.byteLength !== 16) {
	      return finishProcessingFn({
	        status: request.status,
	        message: 'Invalid HLS key at URL: ' + request.uri,
	        code: REQUEST_ERRORS.FAILURE,
	        xhr: request
	      }, segment);
	    }
	
	    var view = new DataView(response);
	
	    segment.key.bytes = new Uint32Array([view.getUint32(0), view.getUint32(4), view.getUint32(8), view.getUint32(12)]);
	    return finishProcessingFn(null, segment);
	  };
	};
	
	/**
	 * Handle init-segment responses
	 *
	 * @param {Object} segment - a simplified copy of the segmentInfo object
	 *                           from SegmentLoader
	 * @param {Function} finishProcessingFn - a callback to execute to continue processing
	 *                                        this request
	 */
	var handleInitSegmentResponse = function handleInitSegmentResponse(segment, captionParser, finishProcessingFn) {
	  return function (error, request) {
	    var response = request.response;
	    var errorObj = handleErrors(error, request);
	
	    if (errorObj) {
	      return finishProcessingFn(errorObj, segment);
	    }
	
	    // stop processing if received empty content
	    if (response.byteLength === 0) {
	      return finishProcessingFn({
	        status: request.status,
	        message: 'Empty HLS segment content at URL: ' + request.uri,
	        code: REQUEST_ERRORS.FAILURE,
	        xhr: request
	      }, segment);
	    }
	
	    segment.map.bytes = new Uint8Array(request.response);
	
	    // Initialize CaptionParser if it hasn't been yet
	    if (!captionParser.isInitialized()) {
	      captionParser.init();
	    }
	
	    segment.map.timescales = mp4probe.timescale(segment.map.bytes);
	    segment.map.videoTrackIds = mp4probe.videoTrackIds(segment.map.bytes);
	
	    return finishProcessingFn(null, segment);
	  };
	};
	
	/**
	 * Response handler for segment-requests being sure to set the correct
	 * property depending on whether the segment is encryped or not
	 * Also records and keeps track of stats that are used for ABR purposes
	 *
	 * @param {Object} segment - a simplified copy of the segmentInfo object
	 *                           from SegmentLoader
	 * @param {Function} finishProcessingFn - a callback to execute to continue processing
	 *                                        this request
	 */
	var handleSegmentResponse = function handleSegmentResponse(segment, captionParser, finishProcessingFn) {
	  return function (error, request) {
	    var response = request.response;
	    var errorObj = handleErrors(error, request);
	    var parsed = void 0;
	
	    if (errorObj) {
	      return finishProcessingFn(errorObj, segment);
	    }
	
	    // stop processing if received empty content
	    if (response.byteLength === 0) {
	      return finishProcessingFn({
	        status: request.status,
	        message: 'Empty HLS segment content at URL: ' + request.uri,
	        code: REQUEST_ERRORS.FAILURE,
	        xhr: request
	      }, segment);
	    }
	
	    segment.stats = getRequestStats(request);
	
	    if (segment.key) {
	      segment.encryptedBytes = new Uint8Array(request.response);
	    } else {
	      segment.bytes = new Uint8Array(request.response);
	    }
	
	    // This is likely an FMP4 and has the init segment.
	    // Run through the CaptionParser in case there are captions.
	    if (segment.map && segment.map.bytes) {
	      // Initialize CaptionParser if it hasn't been yet
	      if (!captionParser.isInitialized()) {
	        captionParser.init();
	      }
	
	      parsed = captionParser.parse(segment.bytes, segment.map.videoTrackIds, segment.map.timescales);
	
	      if (parsed && parsed.captions) {
	        segment.captionStreams = parsed.captionStreams;
	        segment.fmp4Captions = parsed.captions;
	      }
	    }
	
	    return finishProcessingFn(null, segment);
	  };
	};
	
	/**
	 * Decrypt the segment via the decryption web worker
	 *
	 * @param {WebWorker} decrypter - a WebWorker interface to AES-128 decryption routines
	 * @param {Object} segment - a simplified copy of the segmentInfo object
	 *                           from SegmentLoader
	 * @param {Function} doneFn - a callback that is executed after decryption has completed
	 */
	var decryptSegment = function decryptSegment(decrypter, segment, doneFn) {
	  var decryptionHandler = function decryptionHandler(event) {
	    if (event.data.source === segment.requestId) {
	      decrypter.removeEventListener('message', decryptionHandler);
	      var decrypted = event.data.decrypted;
	
	      segment.bytes = new Uint8Array(decrypted.bytes, decrypted.byteOffset, decrypted.byteLength);
	      return doneFn(null, segment);
	    }
	  };
	
	  decrypter.addEventListener('message', decryptionHandler);
	
	  // this is an encrypted segment
	  // incrementally decrypt the segment
	  decrypter.postMessage(createTransferableMessage({
	    source: segment.requestId,
	    encrypted: segment.encryptedBytes,
	    key: segment.key.bytes,
	    iv: segment.key.iv
	  }), [segment.encryptedBytes.buffer, segment.key.bytes.buffer]);
	};
	
	/**
	 * The purpose of this function is to get the most pertinent error from the
	 * array of errors.
	 * For instance if a timeout and two aborts occur, then the aborts were
	 * likely triggered by the timeout so return that error object.
	 */
	var getMostImportantError = function getMostImportantError(errors) {
	  return errors.reduce(function (prev, err) {
	    return err.code > prev.code ? err : prev;
	  });
	};
	
	/**
	 * This function waits for all XHRs to finish (with either success or failure)
	 * before continueing processing via it's callback. The function gathers errors
	 * from each request into a single errors array so that the error status for
	 * each request can be examined later.
	 *
	 * @param {Object} activeXhrs - an object that tracks all XHR requests
	 * @param {WebWorker} decrypter - a WebWorker interface to AES-128 decryption routines
	 * @param {Function} doneFn - a callback that is executed after all resources have been
	 *                            downloaded and any decryption completed
	 */
	var waitForCompletion = function waitForCompletion(activeXhrs, decrypter, doneFn) {
	  var errors = [];
	  var count = 0;
	
	  return function (error, segment) {
	    if (error) {
	      // If there are errors, we have to abort any outstanding requests
	      abortAll(activeXhrs);
	      errors.push(error);
	    }
	    count += 1;
	
	    if (count === activeXhrs.length) {
	      // Keep track of when *all* of the requests have completed
	      segment.endOfAllRequests = Date.now();
	
	      if (errors.length > 0) {
	        var worstError = getMostImportantError(errors);
	
	        return doneFn(worstError, segment);
	      }
	      if (segment.encryptedBytes) {
	        return decryptSegment(decrypter, segment, doneFn);
	      }
	      // Otherwise, everything is ready just continue
	      return doneFn(null, segment);
	    }
	  };
	};
	
	/**
	 * Simple progress event callback handler that gathers some stats before
	 * executing a provided callback with the `segment` object
	 *
	 * @param {Object} segment - a simplified copy of the segmentInfo object
	 *                           from SegmentLoader
	 * @param {Function} progressFn - a callback that is executed each time a progress event
	 *                                is received
	 * @param {Event} event - the progress event object from XMLHttpRequest
	 */
	var handleProgress = function handleProgress(segment, progressFn) {
	  return function (event) {
	    segment.stats = videojs$1.mergeOptions(segment.stats, getProgressStats(event));
	
	    // record the time that we receive the first byte of data
	    if (!segment.stats.firstBytesReceivedAt && segment.stats.bytesReceived) {
	      segment.stats.firstBytesReceivedAt = Date.now();
	    }
	
	    return progressFn(event, segment);
	  };
	};
	
	/**
	 * Load all resources and does any processing necessary for a media-segment
	 *
	 * Features:
	 *   decrypts the media-segment if it has a key uri and an iv
	 *   aborts *all* requests if *any* one request fails
	 *
	 * The segment object, at minimum, has the following format:
	 * {
	 *   resolvedUri: String,
	 *   [byterange]: {
	 *     offset: Number,
	 *     length: Number
	 *   },
	 *   [key]: {
	 *     resolvedUri: String
	 *     [byterange]: {
	 *       offset: Number,
	 *       length: Number
	 *     },
	 *     iv: {
	 *       bytes: Uint32Array
	 *     }
	 *   },
	 *   [map]: {
	 *     resolvedUri: String,
	 *     [byterange]: {
	 *       offset: Number,
	 *       length: Number
	 *     },
	 *     [bytes]: Uint8Array
	 *   }
	 * }
	 * ...where [name] denotes optional properties
	 *
	 * @param {Function} xhr - an instance of the xhr wrapper in xhr.js
	 * @param {Object} xhrOptions - the base options to provide to all xhr requests
	 * @param {WebWorker} decryptionWorker - a WebWorker interface to AES-128
	 *                                       decryption routines
	 * @param {Object} segment - a simplified copy of the segmentInfo object
	 *                           from SegmentLoader
	 * @param {Function} progressFn - a callback that receives progress events from the main
	 *                                segment's xhr request
	 * @param {Function} doneFn - a callback that is executed only once all requests have
	 *                            succeeded or failed
	 * @returns {Function} a function that, when invoked, immediately aborts all
	 *                     outstanding requests
	 */
	var mediaSegmentRequest = function mediaSegmentRequest(xhr$$1, xhrOptions, decryptionWorker, captionParser, segment, progressFn, doneFn) {
	  var activeXhrs = [];
	  var finishProcessingFn = waitForCompletion(activeXhrs, decryptionWorker, doneFn);
	
	  // optionally, request the decryption key
	  if (segment.key) {
	    var keyRequestOptions = videojs$1.mergeOptions(xhrOptions, {
	      uri: segment.key.resolvedUri,
	      responseType: 'arraybuffer'
	    });
	    var keyRequestCallback = handleKeyResponse(segment, finishProcessingFn);
	    var keyXhr = xhr$$1(keyRequestOptions, keyRequestCallback);
	
	    activeXhrs.push(keyXhr);
	  }
	
	  // optionally, request the associated media init segment
	  if (segment.map && !segment.map.bytes) {
	    var initSegmentOptions = videojs$1.mergeOptions(xhrOptions, {
	      uri: segment.map.resolvedUri,
	      responseType: 'arraybuffer',
	      headers: segmentXhrHeaders(segment.map)
	    });
	    var initSegmentRequestCallback = handleInitSegmentResponse(segment, captionParser, finishProcessingFn);
	    var initSegmentXhr = xhr$$1(initSegmentOptions, initSegmentRequestCallback);
	
	    activeXhrs.push(initSegmentXhr);
	  }
	
	  var segmentRequestOptions = videojs$1.mergeOptions(xhrOptions, {
	    uri: segment.resolvedUri,
	    responseType: 'arraybuffer',
	    headers: segmentXhrHeaders(segment)
	  });
	  var segmentRequestCallback = handleSegmentResponse(segment, captionParser, finishProcessingFn);
	  var segmentXhr = xhr$$1(segmentRequestOptions, segmentRequestCallback);
	
	  segmentXhr.addEventListener('progress', handleProgress(segment, progressFn));
	  activeXhrs.push(segmentXhr);
	
	  return function () {
	    return abortAll(activeXhrs);
	  };
	};
	
	// Utilities
	
	/**
	 * Returns the CSS value for the specified property on an element
	 * using `getComputedStyle`. Firefox has a long-standing issue where
	 * getComputedStyle() may return null when running in an iframe with
	 * `display: none`.
	 *
	 * @see https://bugzilla.mozilla.org/show_bug.cgi?id=548397
	 * @param {HTMLElement} el the htmlelement to work on
	 * @param {string} the proprety to get the style for
	 */
	var safeGetComputedStyle = function safeGetComputedStyle(el, property) {
	  var result = void 0;
	
	  if (!el) {
	    return '';
	  }
	
	  result = window$1.getComputedStyle(el);
	  if (!result) {
	    return '';
	  }
	
	  return result[property];
	};
	
	/**
	 * Resuable stable sort function
	 *
	 * @param {Playlists} array
	 * @param {Function} sortFn Different comparators
	 * @function stableSort
	 */
	var stableSort = function stableSort(array, sortFn) {
	  var newArray = array.slice();
	
	  array.sort(function (left, right) {
	    var cmp = sortFn(left, right);
	
	    if (cmp === 0) {
	      return newArray.indexOf(left) - newArray.indexOf(right);
	    }
	    return cmp;
	  });
	};
	
	/**
	 * A comparator function to sort two playlist object by bandwidth.
	 *
	 * @param {Object} left a media playlist object
	 * @param {Object} right a media playlist object
	 * @return {Number} Greater than zero if the bandwidth attribute of
	 * left is greater than the corresponding attribute of right. Less
	 * than zero if the bandwidth of right is greater than left and
	 * exactly zero if the two are equal.
	 */
	var comparePlaylistBandwidth = function comparePlaylistBandwidth(left, right) {
	  var leftBandwidth = void 0;
	  var rightBandwidth = void 0;
	
	  if (left.attributes.BANDWIDTH) {
	    leftBandwidth = left.attributes.BANDWIDTH;
	  }
	  leftBandwidth = leftBandwidth || window$1.Number.MAX_VALUE;
	  if (right.attributes.BANDWIDTH) {
	    rightBandwidth = right.attributes.BANDWIDTH;
	  }
	  rightBandwidth = rightBandwidth || window$1.Number.MAX_VALUE;
	
	  return leftBandwidth - rightBandwidth;
	};
	
	/**
	 * A comparator function to sort two playlist object by resolution (width).
	 * @param {Object} left a media playlist object
	 * @param {Object} right a media playlist object
	 * @return {Number} Greater than zero if the resolution.width attribute of
	 * left is greater than the corresponding attribute of right. Less
	 * than zero if the resolution.width of right is greater than left and
	 * exactly zero if the two are equal.
	 */
	var comparePlaylistResolution = function comparePlaylistResolution(left, right) {
	  var leftWidth = void 0;
	  var rightWidth = void 0;
	
	  if (left.attributes.RESOLUTION && left.attributes.RESOLUTION.width) {
	    leftWidth = left.attributes.RESOLUTION.width;
	  }
	
	  leftWidth = leftWidth || window$1.Number.MAX_VALUE;
	
	  if (right.attributes.RESOLUTION && right.attributes.RESOLUTION.width) {
	    rightWidth = right.attributes.RESOLUTION.width;
	  }
	
	  rightWidth = rightWidth || window$1.Number.MAX_VALUE;
	
	  // NOTE - Fallback to bandwidth sort as appropriate in cases where multiple renditions
	  // have the same media dimensions/ resolution
	  if (leftWidth === rightWidth && left.attributes.BANDWIDTH && right.attributes.BANDWIDTH) {
	    return left.attributes.BANDWIDTH - right.attributes.BANDWIDTH;
	  }
	  return leftWidth - rightWidth;
	};
	
	/**
	 * Chooses the appropriate media playlist based on bandwidth and player size
	 *
	 * @param {Object} master
	 *        Object representation of the master manifest
	 * @param {Number} playerBandwidth
	 *        Current calculated bandwidth of the player
	 * @param {Number} playerWidth
	 *        Current width of the player element
	 * @param {Number} playerHeight
	 *        Current height of the player element
	 * @return {Playlist} the highest bitrate playlist less than the
	 * currently detected bandwidth, accounting for some amount of
	 * bandwidth variance
	 */
	var simpleSelector = function simpleSelector(master, playerBandwidth, playerWidth, playerHeight) {
	  // convert the playlists to an intermediary representation to make comparisons easier
	  var sortedPlaylistReps = master.playlists.map(function (playlist) {
	    var width = void 0;
	    var height = void 0;
	    var bandwidth = void 0;
	
	    width = playlist.attributes.RESOLUTION && playlist.attributes.RESOLUTION.width;
	    height = playlist.attributes.RESOLUTION && playlist.attributes.RESOLUTION.height;
	    bandwidth = playlist.attributes.BANDWIDTH;
	
	    bandwidth = bandwidth || window$1.Number.MAX_VALUE;
	
	    return {
	      bandwidth: bandwidth,
	      width: width,
	      height: height,
	      playlist: playlist
	    };
	  });
	
	  stableSort(sortedPlaylistReps, function (left, right) {
	    return left.bandwidth - right.bandwidth;
	  });
	
	  // filter out any playlists that have been excluded due to
	  // incompatible configurations
	  sortedPlaylistReps = sortedPlaylistReps.filter(function (rep) {
	    return !Playlist.isIncompatible(rep.playlist);
	  });
	
	  // filter out any playlists that have been disabled manually through the representations
	  // api or blacklisted temporarily due to playback errors.
	  var enabledPlaylistReps = sortedPlaylistReps.filter(function (rep) {
	    return Playlist.isEnabled(rep.playlist);
	  });
	
	  if (!enabledPlaylistReps.length) {
	    // if there are no enabled playlists, then they have all been blacklisted or disabled
	    // by the user through the representations api. In this case, ignore blacklisting and
	    // fallback to what the user wants by using playlists the user has not disabled.
	    enabledPlaylistReps = sortedPlaylistReps.filter(function (rep) {
	      return !Playlist.isDisabled(rep.playlist);
	    });
	  }
	
	  // filter out any variant that has greater effective bitrate
	  // than the current estimated bandwidth
	  var bandwidthPlaylistReps = enabledPlaylistReps.filter(function (rep) {
	    return rep.bandwidth * Config.BANDWIDTH_VARIANCE < playerBandwidth;
	  });
	
	  var highestRemainingBandwidthRep = bandwidthPlaylistReps[bandwidthPlaylistReps.length - 1];
	
	  // get all of the renditions with the same (highest) bandwidth
	  // and then taking the very first element
	  var bandwidthBestRep = bandwidthPlaylistReps.filter(function (rep) {
	    return rep.bandwidth === highestRemainingBandwidthRep.bandwidth;
	  })[0];
	
	  // filter out playlists without resolution information
	  var haveResolution = bandwidthPlaylistReps.filter(function (rep) {
	    return rep.width && rep.height;
	  });
	
	  // sort variants by resolution
	  stableSort(haveResolution, function (left, right) {
	    return left.width - right.width;
	  });
	
	  // if we have the exact resolution as the player use it
	  var resolutionBestRepList = haveResolution.filter(function (rep) {
	    return rep.width === playerWidth && rep.height === playerHeight;
	  });
	
	  highestRemainingBandwidthRep = resolutionBestRepList[resolutionBestRepList.length - 1];
	  // ensure that we pick the highest bandwidth variant that have exact resolution
	  var resolutionBestRep = resolutionBestRepList.filter(function (rep) {
	    return rep.bandwidth === highestRemainingBandwidthRep.bandwidth;
	  })[0];
	
	  var resolutionPlusOneList = void 0;
	  var resolutionPlusOneSmallest = void 0;
	  var resolutionPlusOneRep = void 0;
	
	  // find the smallest variant that is larger than the player
	  // if there is no match of exact resolution
	  if (!resolutionBestRep) {
	    resolutionPlusOneList = haveResolution.filter(function (rep) {
	      return rep.width > playerWidth || rep.height > playerHeight;
	    });
	
	    // find all the variants have the same smallest resolution
	    resolutionPlusOneSmallest = resolutionPlusOneList.filter(function (rep) {
	      return rep.width === resolutionPlusOneList[0].width && rep.height === resolutionPlusOneList[0].height;
	    });
	
	    // ensure that we also pick the highest bandwidth variant that
	    // is just-larger-than the video player
	    highestRemainingBandwidthRep = resolutionPlusOneSmallest[resolutionPlusOneSmallest.length - 1];
	    resolutionPlusOneRep = resolutionPlusOneSmallest.filter(function (rep) {
	      return rep.bandwidth === highestRemainingBandwidthRep.bandwidth;
	    })[0];
	  }
	
	  // fallback chain of variants
	  var chosenRep = resolutionPlusOneRep || resolutionBestRep || bandwidthBestRep || enabledPlaylistReps[0] || sortedPlaylistReps[0];
	
	  return chosenRep ? chosenRep.playlist : null;
	};
	
	// Playlist Selectors
	
	/**
	 * Chooses the appropriate media playlist based on the most recent
	 * bandwidth estimate and the player size.
	 *
	 * Expects to be called within the context of an instance of HlsHandler
	 *
	 * @return {Playlist} the highest bitrate playlist less than the
	 * currently detected bandwidth, accounting for some amount of
	 * bandwidth variance
	 */
	var lastBandwidthSelector = function lastBandwidthSelector() {
	  return simpleSelector(this.playlists.master, this.systemBandwidth, parseInt(safeGetComputedStyle(this.tech_.el(), 'width'), 10), parseInt(safeGetComputedStyle(this.tech_.el(), 'height'), 10));
	};
	
	/**
	 * Chooses the appropriate media playlist based on the potential to rebuffer
	 *
	 * @param {Object} settings
	 *        Object of information required to use this selector
	 * @param {Object} settings.master
	 *        Object representation of the master manifest
	 * @param {Number} settings.currentTime
	 *        The current time of the player
	 * @param {Number} settings.bandwidth
	 *        Current measured bandwidth
	 * @param {Number} settings.duration
	 *        Duration of the media
	 * @param {Number} settings.segmentDuration
	 *        Segment duration to be used in round trip time calculations
	 * @param {Number} settings.timeUntilRebuffer
	 *        Time left in seconds until the player has to rebuffer
	 * @param {Number} settings.currentTimeline
	 *        The current timeline segments are being loaded from
	 * @param {SyncController} settings.syncController
	 *        SyncController for determining if we have a sync point for a given playlist
	 * @return {Object|null}
	 *         {Object} return.playlist
	 *         The highest bandwidth playlist with the least amount of rebuffering
	 *         {Number} return.rebufferingImpact
	 *         The amount of time in seconds switching to this playlist will rebuffer. A
	 *         negative value means that switching will cause zero rebuffering.
	 */
	var minRebufferMaxBandwidthSelector = function minRebufferMaxBandwidthSelector(settings) {
	  var master = settings.master,
	      currentTime = settings.currentTime,
	      bandwidth = settings.bandwidth,
	      duration$$1 = settings.duration,
	      segmentDuration = settings.segmentDuration,
	      timeUntilRebuffer = settings.timeUntilRebuffer,
	      currentTimeline = settings.currentTimeline,
	      syncController = settings.syncController;
	
	  // filter out any playlists that have been excluded due to
	  // incompatible configurations
	
	  var compatiblePlaylists = master.playlists.filter(function (playlist) {
	    return !Playlist.isIncompatible(playlist);
	  });
	
	  // filter out any playlists that have been disabled manually through the representations
	  // api or blacklisted temporarily due to playback errors.
	  var enabledPlaylists = compatiblePlaylists.filter(Playlist.isEnabled);
	
	  if (!enabledPlaylists.length) {
	    // if there are no enabled playlists, then they have all been blacklisted or disabled
	    // by the user through the representations api. In this case, ignore blacklisting and
	    // fallback to what the user wants by using playlists the user has not disabled.
	    enabledPlaylists = compatiblePlaylists.filter(function (playlist) {
	      return !Playlist.isDisabled(playlist);
	    });
	  }
	
	  var bandwidthPlaylists = enabledPlaylists.filter(Playlist.hasAttribute.bind(null, 'BANDWIDTH'));
	
	  var rebufferingEstimates = bandwidthPlaylists.map(function (playlist) {
	    var syncPoint = syncController.getSyncPoint(playlist, duration$$1, currentTimeline, currentTime);
	    // If there is no sync point for this playlist, switching to it will require a
	    // sync request first. This will double the request time
	    var numRequests = syncPoint ? 1 : 2;
	    var requestTimeEstimate = Playlist.estimateSegmentRequestTime(segmentDuration, bandwidth, playlist);
	    var rebufferingImpact = requestTimeEstimate * numRequests - timeUntilRebuffer;
	
	    return {
	      playlist: playlist,
	      rebufferingImpact: rebufferingImpact
	    };
	  });
	
	  var noRebufferingPlaylists = rebufferingEstimates.filter(function (estimate) {
	    return estimate.rebufferingImpact <= 0;
	  });
	
	  // Sort by bandwidth DESC
	  stableSort(noRebufferingPlaylists, function (a, b) {
	    return comparePlaylistBandwidth(b.playlist, a.playlist);
	  });
	
	  if (noRebufferingPlaylists.length) {
	    return noRebufferingPlaylists[0];
	  }
	
	  stableSort(rebufferingEstimates, function (a, b) {
	    return a.rebufferingImpact - b.rebufferingImpact;
	  });
	
	  return rebufferingEstimates[0] || null;
	};
	
	/**
	 * Chooses the appropriate media playlist, which in this case is the lowest bitrate
	 * one with video.  If no renditions with video exist, return the lowest audio rendition.
	 *
	 * Expects to be called within the context of an instance of HlsHandler
	 *
	 * @return {Object|null}
	 *         {Object} return.playlist
	 *         The lowest bitrate playlist that contains a video codec.  If no such rendition
	 *         exists pick the lowest audio rendition.
	 */
	var lowestBitrateCompatibleVariantSelector = function lowestBitrateCompatibleVariantSelector() {
	  // filter out any playlists that have been excluded due to
	  // incompatible configurations or playback errors
	  var playlists = this.playlists.master.playlists.filter(Playlist.isEnabled);
	
	  // Sort ascending by bitrate
	  stableSort(playlists, function (a, b) {
	    return comparePlaylistBandwidth(a, b);
	  });
	
	  // Parse and assume that playlists with no video codec have no video
	  // (this is not necessarily true, although it is generally true).
	  //
	  // If an entire manifest has no valid videos everything will get filtered
	  // out.
	  var playlistsWithVideo = playlists.filter(function (playlist) {
	    return parseCodecs(playlist.attributes.CODECS).videoCodec;
	  });
	
	  return playlistsWithVideo[0] || null;
	};
	
	/**
	 * Create captions text tracks on video.js if they do not exist
	 *
	 * @param {Object} inbandTextTracks a reference to current inbandTextTracks
	 * @param {Object} tech the video.js tech
	 * @param {Object} captionStreams the caption streams to create
	 * @private
	 */
	var createCaptionsTrackIfNotExists = function createCaptionsTrackIfNotExists(inbandTextTracks, tech, captionStreams) {
	  for (var trackId in captionStreams) {
	    if (!inbandTextTracks[trackId]) {
	      tech.trigger({ type: 'usage', name: 'hls-608' });
	      var track = tech.textTracks().getTrackById(trackId);
	
	      if (track) {
	        // Resuse an existing track with a CC# id because this was
	        // very likely created by videojs-contrib-hls from information
	        // in the m3u8 for us to use
	        inbandTextTracks[trackId] = track;
	      } else {
	        // Otherwise, create a track with the default `CC#` label and
	        // without a language
	        inbandTextTracks[trackId] = tech.addRemoteTextTrack({
	          kind: 'captions',
	          id: trackId,
	          label: trackId
	        }, false).track;
	      }
	    }
	  }
	};
	
	var addCaptionData = function addCaptionData(_ref) {
	  var inbandTextTracks = _ref.inbandTextTracks,
	      captionArray = _ref.captionArray,
	      timestampOffset = _ref.timestampOffset;
	
	  if (!captionArray) {
	    return;
	  }
	
	  var Cue = window.WebKitDataCue || window.VTTCue;
	
	  captionArray.forEach(function (caption) {
	    var track = caption.stream;
	    var startTime = caption.startTime;
	    var endTime = caption.endTime;
	
	    if (!inbandTextTracks[track]) {
	      return;
	    }
	
	    startTime += timestampOffset;
	    endTime += timestampOffset;
	
	    inbandTextTracks[track].addCue(new Cue(startTime, endTime, caption.text));
	  });
	};
	
	/**
	 * @file segment-loader.js
	 */
	
	// in ms
	var CHECK_BUFFER_DELAY = 500;
	
	/**
	 * Determines if we should call endOfStream on the media source based
	 * on the state of the buffer or if appened segment was the final
	 * segment in the playlist.
	 *
	 * @param {Object} playlist a media playlist object
	 * @param {Object} mediaSource the MediaSource object
	 * @param {Number} segmentIndex the index of segment we last appended
	 * @returns {Boolean} do we need to call endOfStream on the MediaSource
	 */
	var detectEndOfStream = function detectEndOfStream(playlist, mediaSource, segmentIndex) {
	  if (!playlist || !mediaSource) {
	    return false;
	  }
	
	  var segments = playlist.segments;
	
	  // determine a few boolean values to help make the branch below easier
	  // to read
	  var appendedLastSegment = segmentIndex === segments.length;
	
	  // if we've buffered to the end of the video, we need to call endOfStream
	  // so that MediaSources can trigger the `ended` event when it runs out of
	  // buffered data instead of waiting for me
	  return playlist.endList && mediaSource.readyState === 'open' && appendedLastSegment;
	};
	
	var finite = function finite(num) {
	  return typeof num === 'number' && isFinite(num);
	};
	
	var illegalMediaSwitch = function illegalMediaSwitch(loaderType, startingMedia, newSegmentMedia) {
	  // Although these checks should most likely cover non 'main' types, for now it narrows
	  // the scope of our checks.
	  if (loaderType !== 'main' || !startingMedia || !newSegmentMedia) {
	    return null;
	  }
	
	  if (!newSegmentMedia.containsAudio && !newSegmentMedia.containsVideo) {
	    return 'Neither audio nor video found in segment.';
	  }
	
	  if (startingMedia.containsVideo && !newSegmentMedia.containsVideo) {
	    return 'Only audio found in segment when we expected video.' + ' We can\'t switch to audio only from a stream that had video.' + ' To get rid of this message, please add codec information to the manifest.';
	  }
	
	  if (!startingMedia.containsVideo && newSegmentMedia.containsVideo) {
	    return 'Video found in segment when we expected only audio.' + ' We can\'t switch to a stream with video from an audio only stream.' + ' To get rid of this message, please add codec information to the manifest.';
	  }
	
	  return null;
	};
	
	/**
	 * Calculates a time value that is safe to remove from the back buffer without interupting
	 * playback.
	 *
	 * @param {TimeRange} seekable
	 *        The current seekable range
	 * @param {Number} currentTime
	 *        The current time of the player
	 * @param {Number} targetDuration
	 *        The target duration of the current playlist
	 * @return {Number}
	 *         Time that is safe to remove from the back buffer without interupting playback
	 */
	var safeBackBufferTrimTime = function safeBackBufferTrimTime(seekable$$1, currentTime, targetDuration) {
	  var removeToTime = void 0;
	
	  if (seekable$$1.length && seekable$$1.start(0) > 0 && seekable$$1.start(0) < currentTime) {
	    // If we have a seekable range use that as the limit for what can be removed safely
	    removeToTime = seekable$$1.start(0);
	  } else {
	    // otherwise remove anything older than 30 seconds before the current play head
	    removeToTime = currentTime - 30;
	  }
	
	  // Don't allow removing from the buffer within target duration of current time
	  // to avoid the possibility of removing the GOP currently being played which could
	  // cause playback stalls.
	  return Math.min(removeToTime, currentTime - targetDuration);
	};
	
	var segmentInfoString = function segmentInfoString(segmentInfo) {
	  var _segmentInfo$segment = segmentInfo.segment,
	      start = _segmentInfo$segment.start,
	      end = _segmentInfo$segment.end,
	      _segmentInfo$playlist = segmentInfo.playlist,
	      seq = _segmentInfo$playlist.mediaSequence,
	      id = _segmentInfo$playlist.id,
	      _segmentInfo$playlist2 = _segmentInfo$playlist.segments,
	      segments = _segmentInfo$playlist2 === undefined ? [] : _segmentInfo$playlist2,
	      index = segmentInfo.mediaIndex,
	      timeline = segmentInfo.timeline;
	
	  return ['appending [' + index + '] of [' + seq + ', ' + (seq + segments.length) + '] from playlist [' + id + ']', '[' + start + ' => ' + end + '] in timeline [' + timeline + ']'].join(' ');
	};
	
	/**
	 * An object that manages segment loading and appending.
	 *
	 * @class SegmentLoader
	 * @param {Object} options required and optional options
	 * @extends videojs.EventTarget
	 */
	
	var SegmentLoader = function (_videojs$EventTarget) {
	  inherits$1(SegmentLoader, _videojs$EventTarget);
	
	  function SegmentLoader(settings) {
	    classCallCheck$1(this, SegmentLoader);
	
	    // check pre-conditions
	    var _this = possibleConstructorReturn$1(this, (SegmentLoader.__proto__ || Object.getPrototypeOf(SegmentLoader)).call(this));
	
	    if (!settings) {
	      throw new TypeError('Initialization settings are required');
	    }
	    if (typeof settings.currentTime !== 'function') {
	      throw new TypeError('No currentTime getter specified');
	    }
	    if (!settings.mediaSource) {
	      throw new TypeError('No MediaSource specified');
	    }
	    // public properties
	    _this.bandwidth = settings.bandwidth;
	    _this.throughput = { rate: 0, count: 0 };
	    _this.roundTrip = NaN;
	    _this.resetStats_();
	    _this.mediaIndex = null;
	
	    // private settings
	    _this.hasPlayed_ = settings.hasPlayed;
	    _this.currentTime_ = settings.currentTime;
	    _this.seekable_ = settings.seekable;
	    _this.seeking_ = settings.seeking;
	    _this.duration_ = settings.duration;
	    _this.mediaSource_ = settings.mediaSource;
	    _this.hls_ = settings.hls;
	    _this.loaderType_ = settings.loaderType;
	    _this.startingMedia_ = void 0;
	    _this.segmentMetadataTrack_ = settings.segmentMetadataTrack;
	    _this.goalBufferLength_ = settings.goalBufferLength;
	    _this.sourceType_ = settings.sourceType;
	    _this.inbandTextTracks_ = settings.inbandTextTracks;
	    _this.state_ = 'INIT';
	
	    // private instance variables
	    _this.checkBufferTimeout_ = null;
	    _this.error_ = void 0;
	    _this.currentTimeline_ = -1;
	    _this.pendingSegment_ = null;
	    _this.mimeType_ = null;
	    _this.sourceUpdater_ = null;
	    _this.xhrOptions_ = null;
	
	    // Fragmented mp4 playback
	    _this.activeInitSegmentId_ = null;
	    _this.initSegments_ = {};
	    // Fmp4 CaptionParser
	    _this.captionParser_ = new mp4.CaptionParser();
	
	    _this.decrypter_ = settings.decrypter;
	
	    // Manages the tracking and generation of sync-points, mappings
	    // between a time in the display time and a segment index within
	    // a playlist
	    _this.syncController_ = settings.syncController;
	    _this.syncPoint_ = {
	      segmentIndex: 0,
	      time: 0
	    };
	
	    _this.syncController_.on('syncinfoupdate', function () {
	      return _this.trigger('syncinfoupdate');
	    });
	
	    _this.mediaSource_.addEventListener('sourceopen', function () {
	      return _this.ended_ = false;
	    });
	
	    // ...for determining the fetch location
	    _this.fetchAtBuffer_ = false;
	
	    _this.logger_ = logger('SegmentLoader[' + _this.loaderType_ + ']');
	
	    Object.defineProperty(_this, 'state', {
	      get: function get$$1() {
	        return this.state_;
	      },
	      set: function set$$1(newState) {
	        if (newState !== this.state_) {
	          this.logger_(this.state_ + ' -> ' + newState);
	          this.state_ = newState;
	        }
	      }
	    });
	    return _this;
	  }
	
	  /**
	   * reset all of our media stats
	   *
	   * @private
	   */
	
	  createClass$1(SegmentLoader, [{
	    key: 'resetStats_',
	    value: function resetStats_() {
	      this.mediaBytesTransferred = 0;
	      this.mediaRequests = 0;
	      this.mediaRequestsAborted = 0;
	      this.mediaRequestsTimedout = 0;
	      this.mediaRequestsErrored = 0;
	      this.mediaTransferDuration = 0;
	      this.mediaSecondsLoaded = 0;
	    }
	
	    /**
	     * dispose of the SegmentLoader and reset to the default state
	     */
	
	  }, {
	    key: 'dispose',
	    value: function dispose() {
	      this.state = 'DISPOSED';
	      this.pause();
	      this.abort_();
	      if (this.sourceUpdater_) {
	        this.sourceUpdater_.dispose();
	      }
	      this.resetStats_();
	      this.captionParser_.reset();
	    }
	
	    /**
	     * abort anything that is currently doing on with the SegmentLoader
	     * and reset to a default state
	     */
	
	  }, {
	    key: 'abort',
	    value: function abort() {
	      if (this.state !== 'WAITING') {
	        if (this.pendingSegment_) {
	          this.pendingSegment_ = null;
	        }
	        return;
	      }
	
	      this.abort_();
	
	      // We aborted the requests we were waiting on, so reset the loader's state to READY
	      // since we are no longer "waiting" on any requests. XHR callback is not always run
	      // when the request is aborted. This will prevent the loader from being stuck in the
	      // WAITING state indefinitely.
	      this.state = 'READY';
	
	      // don't wait for buffer check timeouts to begin fetching the
	      // next segment
	      if (!this.paused()) {
	        this.monitorBuffer_();
	      }
	    }
	
	    /**
	     * abort all pending xhr requests and null any pending segements
	     *
	     * @private
	     */
	
	  }, {
	    key: 'abort_',
	    value: function abort_() {
	      if (this.pendingSegment_) {
	        this.pendingSegment_.abortRequests();
	      }
	
	      // clear out the segment being processed
	      this.pendingSegment_ = null;
	    }
	
	    /**
	     * set an error on the segment loader and null out any pending segements
	     *
	     * @param {Error} error the error to set on the SegmentLoader
	     * @return {Error} the error that was set or that is currently set
	     */
	
	  }, {
	    key: 'error',
	    value: function error(_error) {
	      if (typeof _error !== 'undefined') {
	        this.error_ = _error;
	      }
	
	      this.pendingSegment_ = null;
	      return this.error_;
	    }
	  }, {
	    key: 'endOfStream',
	    value: function endOfStream() {
	      this.ended_ = true;
	      this.pause();
	      this.trigger('ended');
	    }
	
	    /**
	     * Indicates which time ranges are buffered
	     *
	     * @return {TimeRange}
	     *         TimeRange object representing the current buffered ranges
	     */
	
	  }, {
	    key: 'buffered_',
	    value: function buffered_() {
	      if (!this.sourceUpdater_) {
	        return videojs$1.createTimeRanges();
	      }
	
	      return this.sourceUpdater_.buffered();
	    }
	
	    /**
	     * Gets and sets init segment for the provided map
	     *
	     * @param {Object} map
	     *        The map object representing the init segment to get or set
	     * @param {Boolean=} set
	     *        If true, the init segment for the provided map should be saved
	     * @return {Object}
	     *         map object for desired init segment
	     */
	
	  }, {
	    key: 'initSegment',
	    value: function initSegment(map) {
	      var set$$1 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	
	      if (!map) {
	        return null;
	      }
	
	      var id = initSegmentId(map);
	      var storedMap = this.initSegments_[id];
	
	      if (set$$1 && !storedMap && map.bytes) {
	        this.initSegments_[id] = storedMap = {
	          resolvedUri: map.resolvedUri,
	          byterange: map.byterange,
	          bytes: map.bytes,
	          timescales: map.timescales,
	          videoTrackIds: map.videoTrackIds
	        };
	      }
	
	      return storedMap || map;
	    }
	
	    /**
	     * Returns true if all configuration required for loading is present, otherwise false.
	     *
	     * @return {Boolean} True if the all configuration is ready for loading
	     * @private
	     */
	
	  }, {
	    key: 'couldBeginLoading_',
	    value: function couldBeginLoading_() {
	      return this.playlist_ && (
	      // the source updater is created when init_ is called, so either having a
	      // source updater or being in the INIT state with a mimeType is enough
	      // to say we have all the needed configuration to start loading.
	      this.sourceUpdater_ || this.mimeType_ && this.state === 'INIT') && !this.paused();
	    }
	
	    /**
	     * load a playlist and start to fill the buffer
	     */
	
	  }, {
	    key: 'load',
	    value: function load() {
	      // un-pause
	      this.monitorBuffer_();
	
	      // if we don't have a playlist yet, keep waiting for one to be
	      // specified
	      if (!this.playlist_) {
	        return;
	      }
	
	      // not sure if this is the best place for this
	      this.syncController_.setDateTimeMapping(this.playlist_);
	
	      // if all the configuration is ready, initialize and begin loading
	      if (this.state === 'INIT' && this.couldBeginLoading_()) {
	        return this.init_();
	      }
	
	      // if we're in the middle of processing a segment already, don't
	      // kick off an additional segment request
	      if (!this.couldBeginLoading_() || this.state !== 'READY' && this.state !== 'INIT') {
	        return;
	      }
	
	      this.state = 'READY';
	    }
	
	    /**
	     * Once all the starting parameters have been specified, begin
	     * operation. This method should only be invoked from the INIT
	     * state.
	     *
	     * @private
	     */
	
	  }, {
	    key: 'init_',
	    value: function init_() {
	      this.state = 'READY';
	      this.sourceUpdater_ = new SourceUpdater(this.mediaSource_, this.mimeType_, this.loaderType_, this.sourceBufferEmitter_);
	      this.resetEverything();
	      return this.monitorBuffer_();
	    }
	
	    /**
	     * set a playlist on the segment loader
	     *
	     * @param {PlaylistLoader} media the playlist to set on the segment loader
	     */
	
	  }, {
	    key: 'playlist',
	    value: function playlist(newPlaylist) {
	      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	      if (!newPlaylist) {
	        return;
	      }
	
	      var oldPlaylist = this.playlist_;
	      var segmentInfo = this.pendingSegment_;
	
	      this.playlist_ = newPlaylist;
	      this.xhrOptions_ = options;
	
	      // when we haven't started playing yet, the start of a live playlist
	      // is always our zero-time so force a sync update each time the playlist
	      // is refreshed from the server
	      if (!this.hasPlayed_()) {
	        newPlaylist.syncInfo = {
	          mediaSequence: newPlaylist.mediaSequence,
	          time: 0
	        };
	      }
	
	      var oldId = oldPlaylist ? oldPlaylist.id : null;
	
	      this.logger_('playlist update [' + oldId + ' => ' + newPlaylist.id + ']');
	
	      // in VOD, this is always a rendition switch (or we updated our syncInfo above)
	      // in LIVE, we always want to update with new playlists (including refreshes)
	      this.trigger('syncinfoupdate');
	
	      // if we were unpaused but waiting for a playlist, start
	      // buffering now
	      if (this.state === 'INIT' && this.couldBeginLoading_()) {
	        return this.init_();
	      }
	
	      if (!oldPlaylist || oldPlaylist.uri !== newPlaylist.uri) {
	        if (this.mediaIndex !== null) {
	          // we must "resync" the segment loader when we switch renditions and
	          // the segment loader is already synced to the previous rendition
	          this.resyncLoader();
	        }
	
	        // the rest of this function depends on `oldPlaylist` being defined
	        return;
	      }
	
	      // we reloaded the same playlist so we are in a live scenario
	      // and we will likely need to adjust the mediaIndex
	      var mediaSequenceDiff = newPlaylist.mediaSequence - oldPlaylist.mediaSequence;
	
	      this.logger_('live window shift [' + mediaSequenceDiff + ']');
	
	      // update the mediaIndex on the SegmentLoader
	      // this is important because we can abort a request and this value must be
	      // equal to the last appended mediaIndex
	      if (this.mediaIndex !== null) {
	        this.mediaIndex -= mediaSequenceDiff;
	      }
	
	      // update the mediaIndex on the SegmentInfo object
	      // this is important because we will update this.mediaIndex with this value
	      // in `handleUpdateEnd_` after the segment has been successfully appended
	      if (segmentInfo) {
	        segmentInfo.mediaIndex -= mediaSequenceDiff;
	
	        // we need to update the referenced segment so that timing information is
	        // saved for the new playlist's segment, however, if the segment fell off the
	        // playlist, we can leave the old reference and just lose the timing info
	        if (segmentInfo.mediaIndex >= 0) {
	          segmentInfo.segment = newPlaylist.segments[segmentInfo.mediaIndex];
	        }
	      }
	
	      this.syncController_.saveExpiredSegmentInfo(oldPlaylist, newPlaylist);
	    }
	
	    /**
	     * Prevent the loader from fetching additional segments. If there
	     * is a segment request outstanding, it will finish processing
	     * before the loader halts. A segment loader can be unpaused by
	     * calling load().
	     */
	
	  }, {
	    key: 'pause',
	    value: function pause() {
	      if (this.checkBufferTimeout_) {
	        window$1.clearTimeout(this.checkBufferTimeout_);
	
	        this.checkBufferTimeout_ = null;
	      }
	    }
	
	    /**
	     * Returns whether the segment loader is fetching additional
	     * segments when given the opportunity. This property can be
	     * modified through calls to pause() and load().
	     */
	
	  }, {
	    key: 'paused',
	    value: function paused() {
	      return this.checkBufferTimeout_ === null;
	    }
	
	    /**
	     * create/set the following mimetype on the SourceBuffer through a
	     * SourceUpdater
	     *
	     * @param {String} mimeType the mime type string to use
	     * @param {Object} sourceBufferEmitter an event emitter that fires when a source buffer
	     * is added to the media source
	     */
	
	  }, {
	    key: 'mimeType',
	    value: function mimeType(_mimeType, sourceBufferEmitter) {
	      if (this.mimeType_) {
	        return;
	      }
	
	      this.mimeType_ = _mimeType;
	      this.sourceBufferEmitter_ = sourceBufferEmitter;
	      // if we were unpaused but waiting for a sourceUpdater, start
	      // buffering now
	      if (this.state === 'INIT' && this.couldBeginLoading_()) {
	        this.init_();
	      }
	    }
	
	    /**
	     * Delete all the buffered data and reset the SegmentLoader
	     * @param {Function} [done] an optional callback to be executed when the remove
	     * operation is complete
	     */
	
	  }, {
	    key: 'resetEverything',
	    value: function resetEverything(done) {
	      this.ended_ = false;
	      this.resetLoader();
	      this.remove(0, this.duration_(), done);
	      // clears fmp4 captions
	      this.captionParser_.clearAllCaptions();
	      this.trigger('reseteverything');
	    }
	
	    /**
	     * Force the SegmentLoader to resync and start loading around the currentTime instead
	     * of starting at the end of the buffer
	     *
	     * Useful for fast quality changes
	     */
	
	  }, {
	    key: 'resetLoader',
	    value: function resetLoader() {
	      this.fetchAtBuffer_ = false;
	      this.resyncLoader();
	    }
	
	    /**
	     * Force the SegmentLoader to restart synchronization and make a conservative guess
	     * before returning to the simple walk-forward method
	     */
	
	  }, {
	    key: 'resyncLoader',
	    value: function resyncLoader() {
	      this.mediaIndex = null;
	      this.syncPoint_ = null;
	      this.abort();
	    }
	
	    /**
	     * Remove any data in the source buffer between start and end times
	     * @param {Number} start - the start time of the region to remove from the buffer
	     * @param {Number} end - the end time of the region to remove from the buffer
	     * @param {Function} [done] - an optional callback to be executed when the remove
	     * operation is complete
	     */
	
	  }, {
	    key: 'remove',
	    value: function remove(start, end, done) {
	      if (this.sourceUpdater_) {
	        this.sourceUpdater_.remove(start, end, done);
	      }
	      removeCuesFromTrack(start, end, this.segmentMetadataTrack_);
	
	      if (this.inbandTextTracks_) {
	        for (var id in this.inbandTextTracks_) {
	          removeCuesFromTrack(start, end, this.inbandTextTracks_[id]);
	        }
	      }
	    }
	
	    /**
	     * (re-)schedule monitorBufferTick_ to run as soon as possible
	     *
	     * @private
	     */
	
	  }, {
	    key: 'monitorBuffer_',
	    value: function monitorBuffer_() {
	      if (this.checkBufferTimeout_) {
	        window$1.clearTimeout(this.checkBufferTimeout_);
	      }
	
	      this.checkBufferTimeout_ = window$1.setTimeout(this.monitorBufferTick_.bind(this), 1);
	    }
	
	    /**
	     * As long as the SegmentLoader is in the READY state, periodically
	     * invoke fillBuffer_().
	     *
	     * @private
	     */
	
	  }, {
	    key: 'monitorBufferTick_',
	    value: function monitorBufferTick_() {
	      if (this.state === 'READY') {
	        this.fillBuffer_();
	      }
	
	      if (this.checkBufferTimeout_) {
	        window$1.clearTimeout(this.checkBufferTimeout_);
	      }
	
	      this.checkBufferTimeout_ = window$1.setTimeout(this.monitorBufferTick_.bind(this), CHECK_BUFFER_DELAY);
	    }
	
	    /**
	     * fill the buffer with segements unless the sourceBuffers are
	     * currently updating
	     *
	     * Note: this function should only ever be called by monitorBuffer_
	     * and never directly
	     *
	     * @private
	     */
	
	  }, {
	    key: 'fillBuffer_',
	    value: function fillBuffer_() {
	      if (this.sourceUpdater_.updating()) {
	        return;
	      }
	
	      if (!this.syncPoint_) {
	        this.syncPoint_ = this.syncController_.getSyncPoint(this.playlist_, this.duration_(), this.currentTimeline_, this.currentTime_());
	      }
	
	      // see if we need to begin loading immediately
	      var segmentInfo = this.checkBuffer_(this.buffered_(), this.playlist_, this.mediaIndex, this.hasPlayed_(), this.currentTime_(), this.syncPoint_);
	
	      if (!segmentInfo) {
	        return;
	      }
	
	      var isEndOfStream = detectEndOfStream(this.playlist_, this.mediaSource_, segmentInfo.mediaIndex);
	
	      if (isEndOfStream) {
	        this.endOfStream();
	        return;
	      }
	
	      if (segmentInfo.mediaIndex === this.playlist_.segments.length - 1 && this.mediaSource_.readyState === 'ended' && !this.seeking_()) {
	        return;
	      }
	
	      // We will need to change timestampOffset of the sourceBuffer if either of
	      // the following conditions are true:
	      // - The segment.timeline !== this.currentTimeline
	      //   (we are crossing a discontinuity somehow)
	      // - The "timestampOffset" for the start of this segment is less than
	      //   the currently set timestampOffset
	      // Also, clear captions if we are crossing a discontinuity boundary
	      if (segmentInfo.timeline !== this.currentTimeline_ || segmentInfo.startOfSegment !== null && segmentInfo.startOfSegment < this.sourceUpdater_.timestampOffset()) {
	        this.syncController_.reset();
	        segmentInfo.timestampOffset = segmentInfo.startOfSegment;
	        this.captionParser_.clearAllCaptions();
	      }
	
	      this.loadSegment_(segmentInfo);
	    }
	
	    /**
	     * Determines what segment request should be made, given current playback
	     * state.
	     *
	     * @param {TimeRanges} buffered - the state of the buffer
	     * @param {Object} playlist - the playlist object to fetch segments from
	     * @param {Number} mediaIndex - the previous mediaIndex fetched or null
	     * @param {Boolean} hasPlayed - a flag indicating whether we have played or not
	     * @param {Number} currentTime - the playback position in seconds
	     * @param {Object} syncPoint - a segment info object that describes the
	     * @returns {Object} a segment request object that describes the segment to load
	     */
	
	  }, {
	    key: 'checkBuffer_',
	    value: function checkBuffer_(buffered, playlist, mediaIndex, hasPlayed, currentTime, syncPoint) {
	      var lastBufferedEnd = 0;
	      var startOfSegment = void 0;
	
	      if (buffered.length) {
	        lastBufferedEnd = buffered.end(buffered.length - 1);
	      }
	
	      var bufferedTime = Math.max(0, lastBufferedEnd - currentTime);
	
	      if (!playlist.segments.length) {
	        return null;
	      }
	
	      // if there is plenty of content buffered, and the video has
	      // been played before relax for awhile
	      if (bufferedTime >= this.goalBufferLength_()) {
	        return null;
	      }
	
	      // if the video has not yet played once, and we already have
	      // one segment downloaded do nothing
	      if (!hasPlayed && bufferedTime >= 1) {
	        return null;
	      }
	
	      // When the syncPoint is null, there is no way of determining a good
	      // conservative segment index to fetch from
	      // The best thing to do here is to get the kind of sync-point data by
	      // making a request
	      if (syncPoint === null) {
	        mediaIndex = this.getSyncSegmentCandidate_(playlist);
	        return this.generateSegmentInfo_(playlist, mediaIndex, null, true);
	      }
	
	      // Under normal playback conditions fetching is a simple walk forward
	      if (mediaIndex !== null) {
	        var segment = playlist.segments[mediaIndex];
	
	        if (segment && segment.end) {
	          startOfSegment = segment.end;
	        } else {
	          startOfSegment = lastBufferedEnd;
	        }
	        return this.generateSegmentInfo_(playlist, mediaIndex + 1, startOfSegment, false);
	      }
	
	      // There is a sync-point but the lack of a mediaIndex indicates that
	      // we need to make a good conservative guess about which segment to
	      // fetch
	      if (this.fetchAtBuffer_) {
	        // Find the segment containing the end of the buffer
	        var mediaSourceInfo = Playlist.getMediaInfoForTime(playlist, lastBufferedEnd, syncPoint.segmentIndex, syncPoint.time);
	
	        mediaIndex = mediaSourceInfo.mediaIndex;
	        startOfSegment = mediaSourceInfo.startTime;
	      } else {
	        // Find the segment containing currentTime
	        var _mediaSourceInfo = Playlist.getMediaInfoForTime(playlist, currentTime, syncPoint.segmentIndex, syncPoint.time);
	
	        mediaIndex = _mediaSourceInfo.mediaIndex;
	        startOfSegment = _mediaSourceInfo.startTime;
	      }
	
	      return this.generateSegmentInfo_(playlist, mediaIndex, startOfSegment, false);
	    }
	
	    /**
	     * The segment loader has no recourse except to fetch a segment in the
	     * current playlist and use the internal timestamps in that segment to
	     * generate a syncPoint. This function returns a good candidate index
	     * for that process.
	     *
	     * @param {Object} playlist - the playlist object to look for a
	     * @returns {Number} An index of a segment from the playlist to load
	     */
	
	  }, {
	    key: 'getSyncSegmentCandidate_',
	    value: function getSyncSegmentCandidate_(playlist) {
	      var _this2 = this;
	
	      if (this.currentTimeline_ === -1) {
	        return 0;
	      }
	
	      var segmentIndexArray = playlist.segments.map(function (s, i) {
	        return {
	          timeline: s.timeline,
	          segmentIndex: i
	        };
	      }).filter(function (s) {
	        return s.timeline === _this2.currentTimeline_;
	      });
	
	      if (segmentIndexArray.length) {
	        return segmentIndexArray[Math.min(segmentIndexArray.length - 1, 1)].segmentIndex;
	      }
	
	      return Math.max(playlist.segments.length - 1, 0);
	    }
	  }, {
	    key: 'generateSegmentInfo_',
	    value: function generateSegmentInfo_(playlist, mediaIndex, startOfSegment, isSyncRequest) {
	      if (mediaIndex < 0 || mediaIndex >= playlist.segments.length) {
	        return null;
	      }
	
	      var segment = playlist.segments[mediaIndex];
	
	      return {
	        requestId: 'segment-loader-' + Math.random(),
	        // resolve the segment URL relative to the playlist
	        uri: segment.resolvedUri,
	        // the segment's mediaIndex at the time it was requested
	        mediaIndex: mediaIndex,
	        // whether or not to update the SegmentLoader's state with this
	        // segment's mediaIndex
	        isSyncRequest: isSyncRequest,
	        startOfSegment: startOfSegment,
	        // the segment's playlist
	        playlist: playlist,
	        // unencrypted bytes of the segment
	        bytes: null,
	        // when a key is defined for this segment, the encrypted bytes
	        encryptedBytes: null,
	        // The target timestampOffset for this segment when we append it
	        // to the source buffer
	        timestampOffset: null,
	        // The timeline that the segment is in
	        timeline: segment.timeline,
	        // The expected duration of the segment in seconds
	        duration: segment.duration,
	        // retain the segment in case the playlist updates while doing an async process
	        segment: segment
	      };
	    }
	
	    /**
	     * Determines if the network has enough bandwidth to complete the current segment
	     * request in a timely manner. If not, the request will be aborted early and bandwidth
	     * updated to trigger a playlist switch.
	     *
	     * @param {Object} stats
	     *        Object containing stats about the request timing and size
	     * @return {Boolean} True if the request was aborted, false otherwise
	     * @private
	     */
	
	  }, {
	    key: 'abortRequestEarly_',
	    value: function abortRequestEarly_(stats) {
	      if (this.hls_.tech_.paused() ||
	      // Don't abort if the current playlist is on the lowestEnabledRendition
	      // TODO: Replace using timeout with a boolean indicating whether this playlist is
	      //       the lowestEnabledRendition.
	      !this.xhrOptions_.timeout ||
	      // Don't abort if we have no bandwidth information to estimate segment sizes
	      !this.playlist_.attributes.BANDWIDTH) {
	        return false;
	      }
	
	      // Wait at least 1 second since the first byte of data has been received before
	      // using the calculated bandwidth from the progress event to allow the bitrate
	      // to stabilize
	      if (Date.now() - (stats.firstBytesReceivedAt || Date.now()) < 1000) {
	        return false;
	      }
	
	      var currentTime = this.currentTime_();
	      var measuredBandwidth = stats.bandwidth;
	      var segmentDuration = this.pendingSegment_.duration;
	
	      var requestTimeRemaining = Playlist.estimateSegmentRequestTime(segmentDuration, measuredBandwidth, this.playlist_, stats.bytesReceived);
	
	      // Subtract 1 from the timeUntilRebuffer so we still consider an early abort
	      // if we are only left with less than 1 second when the request completes.
	      // A negative timeUntilRebuffering indicates we are already rebuffering
	      var timeUntilRebuffer$$1 = timeUntilRebuffer(this.buffered_(), currentTime, this.hls_.tech_.playbackRate()) - 1;
	
	      // Only consider aborting early if the estimated time to finish the download
	      // is larger than the estimated time until the player runs out of forward buffer
	      if (requestTimeRemaining <= timeUntilRebuffer$$1) {
	        return false;
	      }
	
	      var switchCandidate = minRebufferMaxBandwidthSelector({
	        master: this.hls_.playlists.master,
	        currentTime: currentTime,
	        bandwidth: measuredBandwidth,
	        duration: this.duration_(),
	        segmentDuration: segmentDuration,
	        timeUntilRebuffer: timeUntilRebuffer$$1,
	        currentTimeline: this.currentTimeline_,
	        syncController: this.syncController_
	      });
	
	      if (!switchCandidate) {
	        return;
	      }
	
	      var rebufferingImpact = requestTimeRemaining - timeUntilRebuffer$$1;
	
	      var timeSavedBySwitching = rebufferingImpact - switchCandidate.rebufferingImpact;
	
	      var minimumTimeSaving = 0.5;
	
	      // If we are already rebuffering, increase the amount of variance we add to the
	      // potential round trip time of the new request so that we are not too aggressive
	      // with switching to a playlist that might save us a fraction of a second.
	      if (timeUntilRebuffer$$1 <= TIME_FUDGE_FACTOR) {
	        minimumTimeSaving = 1;
	      }
	
	      if (!switchCandidate.playlist || switchCandidate.playlist.uri === this.playlist_.uri || timeSavedBySwitching < minimumTimeSaving) {
	        return false;
	      }
	
	      // set the bandwidth to that of the desired playlist being sure to scale by
	      // BANDWIDTH_VARIANCE and add one so the playlist selector does not exclude it
	      // don't trigger a bandwidthupdate as the bandwidth is artifial
	      this.bandwidth = switchCandidate.playlist.attributes.BANDWIDTH * Config.BANDWIDTH_VARIANCE + 1;
	      this.abort();
	      this.trigger('earlyabort');
	      return true;
	    }
	
	    /**
	     * XHR `progress` event handler
	     *
	     * @param {Event}
	     *        The XHR `progress` event
	     * @param {Object} simpleSegment
	     *        A simplified segment object copy
	     * @private
	     */
	
	  }, {
	    key: 'handleProgress_',
	    value: function handleProgress_(event, simpleSegment) {
	      if (!this.pendingSegment_ || simpleSegment.requestId !== this.pendingSegment_.requestId || this.abortRequestEarly_(simpleSegment.stats)) {
	        return;
	      }
	
	      this.trigger('progress');
	    }
	
	    /**
	     * load a specific segment from a request into the buffer
	     *
	     * @private
	     */
	
	  }, {
	    key: 'loadSegment_',
	    value: function loadSegment_(segmentInfo) {
	      this.state = 'WAITING';
	      this.pendingSegment_ = segmentInfo;
	      this.trimBackBuffer_(segmentInfo);
	
	      segmentInfo.abortRequests = mediaSegmentRequest(this.hls_.xhr, this.xhrOptions_, this.decrypter_, this.captionParser_, this.createSimplifiedSegmentObj_(segmentInfo),
	      // progress callback
	      this.handleProgress_.bind(this), this.segmentRequestFinished_.bind(this));
	    }
	
	    /**
	     * trim the back buffer so that we don't have too much data
	     * in the source buffer
	     *
	     * @private
	     *
	     * @param {Object} segmentInfo - the current segment
	     */
	
	  }, {
	    key: 'trimBackBuffer_',
	    value: function trimBackBuffer_(segmentInfo) {
	      var removeToTime = safeBackBufferTrimTime(this.seekable_(), this.currentTime_(), this.playlist_.targetDuration || 10);
	
	      // Chrome has a hard limit of 150MB of
	      // buffer and a very conservative "garbage collector"
	      // We manually clear out the old buffer to ensure
	      // we don't trigger the QuotaExceeded error
	      // on the source buffer during subsequent appends
	
	      if (removeToTime > 0) {
	        this.remove(0, removeToTime);
	      }
	    }
	
	    /**
	     * created a simplified copy of the segment object with just the
	     * information necessary to perform the XHR and decryption
	     *
	     * @private
	     *
	     * @param {Object} segmentInfo - the current segment
	     * @returns {Object} a simplified segment object copy
	     */
	
	  }, {
	    key: 'createSimplifiedSegmentObj_',
	    value: function createSimplifiedSegmentObj_(segmentInfo) {
	      var segment = segmentInfo.segment;
	      var simpleSegment = {
	        resolvedUri: segment.resolvedUri,
	        byterange: segment.byterange,
	        requestId: segmentInfo.requestId
	      };
	
	      if (segment.key) {
	        // if the media sequence is greater than 2^32, the IV will be incorrect
	        // assuming 10s segments, that would be about 1300 years
	        var iv = segment.key.iv || new Uint32Array([0, 0, 0, segmentInfo.mediaIndex + segmentInfo.playlist.mediaSequence]);
	
	        simpleSegment.key = {
	          resolvedUri: segment.key.resolvedUri,
	          iv: iv
	        };
	      }
	
	      if (segment.map) {
	        simpleSegment.map = this.initSegment(segment.map);
	      }
	
	      return simpleSegment;
	    }
	
	    /**
	     * Handle the callback from the segmentRequest function and set the
	     * associated SegmentLoader state and errors if necessary
	     *
	     * @private
	     */
	
	  }, {
	    key: 'segmentRequestFinished_',
	    value: function segmentRequestFinished_(error, simpleSegment) {
	      // every request counts as a media request even if it has been aborted
	      // or canceled due to a timeout
	      this.mediaRequests += 1;
	
	      if (simpleSegment.stats) {
	        this.mediaBytesTransferred += simpleSegment.stats.bytesReceived;
	        this.mediaTransferDuration += simpleSegment.stats.roundTripTime;
	      }
	
	      // The request was aborted and the SegmentLoader has already been reset
	      if (!this.pendingSegment_) {
	        this.mediaRequestsAborted += 1;
	        return;
	      }
	
	      // the request was aborted and the SegmentLoader has already started
	      // another request. this can happen when the timeout for an aborted
	      // request triggers due to a limitation in the XHR library
	      // do not count this as any sort of request or we risk double-counting
	      if (simpleSegment.requestId !== this.pendingSegment_.requestId) {
	        return;
	      }
	
	      // an error occurred from the active pendingSegment_ so reset everything
	      if (error) {
	        this.pendingSegment_ = null;
	        this.state = 'READY';
	
	        // the requests were aborted just record the aborted stat and exit
	        // this is not a true error condition and nothing corrective needs
	        // to be done
	        if (error.code === REQUEST_ERRORS.ABORTED) {
	          this.mediaRequestsAborted += 1;
	          return;
	        }
	
	        this.pause();
	
	        // the error is really just that at least one of the requests timed-out
	        // set the bandwidth to a very low value and trigger an ABR switch to
	        // take emergency action
	        if (error.code === REQUEST_ERRORS.TIMEOUT) {
	          this.mediaRequestsTimedout += 1;
	          this.bandwidth = 1;
	          this.roundTrip = NaN;
	          this.trigger('bandwidthupdate');
	          return;
	        }
	
	        // if control-flow has arrived here, then the error is real
	        // emit an error event to blacklist the current playlist
	        this.mediaRequestsErrored += 1;
	        this.error(error);
	        this.trigger('error');
	        return;
	      }
	
	      // the response was a success so set any bandwidth stats the request
	      // generated for ABR purposes
	      this.bandwidth = simpleSegment.stats.bandwidth;
	      this.roundTrip = simpleSegment.stats.roundTripTime;
	
	      // if this request included an initialization segment, save that data
	      // to the initSegment cache
	      if (simpleSegment.map) {
	        simpleSegment.map = this.initSegment(simpleSegment.map, true);
	      }
	
	      this.processSegmentResponse_(simpleSegment);
	    }
	
	    /**
	     * Move any important data from the simplified segment object
	     * back to the real segment object for future phases
	     *
	     * @private
	     */
	
	  }, {
	    key: 'processSegmentResponse_',
	    value: function processSegmentResponse_(simpleSegment) {
	      var segmentInfo = this.pendingSegment_;
	
	      segmentInfo.bytes = simpleSegment.bytes;
	      if (simpleSegment.map) {
	        segmentInfo.segment.map.bytes = simpleSegment.map.bytes;
	      }
	
	      segmentInfo.endOfAllRequests = simpleSegment.endOfAllRequests;
	
	      // This has fmp4 captions, add them to text tracks
	      if (simpleSegment.fmp4Captions) {
	        createCaptionsTrackIfNotExists(this.inbandTextTracks_, this.hls_.tech_, simpleSegment.captionStreams);
	        addCaptionData({
	          inbandTextTracks: this.inbandTextTracks_,
	          captionArray: simpleSegment.fmp4Captions,
	          // fmp4s will not have a timestamp offset
	          timestampOffset: 0
	        });
	        // Reset stored captions since we added parsed
	        // captions to a text track at this point
	        this.captionParser_.clearParsedCaptions();
	      }
	
	      this.handleSegment_();
	    }
	
	    /**
	     * append a decrypted segement to the SourceBuffer through a SourceUpdater
	     *
	     * @private
	     */
	
	  }, {
	    key: 'handleSegment_',
	    value: function handleSegment_() {
	      var _this3 = this;
	
	      if (!this.pendingSegment_) {
	        this.state = 'READY';
	        return;
	      }
	
	      var segmentInfo = this.pendingSegment_;
	      var segment = segmentInfo.segment;
	      var timingInfo = this.syncController_.probeSegmentInfo(segmentInfo);
	
	      // When we have our first timing info, determine what media types this loader is
	      // dealing with. Although we're maintaining extra state, it helps to preserve the
	      // separation of segment loader from the actual source buffers.
	      if (typeof this.startingMedia_ === 'undefined' && timingInfo && (
	      // Guard against cases where we're not getting timing info at all until we are
	      // certain that all streams will provide it.
	      timingInfo.containsAudio || timingInfo.containsVideo)) {
	        this.startingMedia_ = {
	          containsAudio: timingInfo.containsAudio,
	          containsVideo: timingInfo.containsVideo
	        };
	      }
	
	      var illegalMediaSwitchError = illegalMediaSwitch(this.loaderType_, this.startingMedia_, timingInfo);
	
	      if (illegalMediaSwitchError) {
	        this.error({
	          message: illegalMediaSwitchError,
	          blacklistDuration: Infinity
	        });
	        this.trigger('error');
	        return;
	      }
	
	      if (segmentInfo.isSyncRequest) {
	        this.trigger('syncinfoupdate');
	        this.pendingSegment_ = null;
	        this.state = 'READY';
	        return;
	      }
	
	      if (segmentInfo.timestampOffset !== null && segmentInfo.timestampOffset !== this.sourceUpdater_.timestampOffset()) {
	        this.sourceUpdater_.timestampOffset(segmentInfo.timestampOffset);
	        // fired when a timestamp offset is set in HLS (can also identify discontinuities)
	        this.trigger('timestampoffset');
	      }
	
	      var timelineMapping = this.syncController_.mappingForTimeline(segmentInfo.timeline);
	
	      if (timelineMapping !== null) {
	        this.trigger({
	          type: 'segmenttimemapping',
	          mapping: timelineMapping
	        });
	      }
	
	      this.state = 'APPENDING';
	
	      // if the media initialization segment is changing, append it
	      // before the content segment
	      if (segment.map) {
	        var initId = initSegmentId(segment.map);
	
	        if (!this.activeInitSegmentId_ || this.activeInitSegmentId_ !== initId) {
	          var initSegment = this.initSegment(segment.map);
	
	          this.sourceUpdater_.appendBuffer(initSegment.bytes, function () {
	            _this3.activeInitSegmentId_ = initId;
	          });
	        }
	      }
	
	      segmentInfo.byteLength = segmentInfo.bytes.byteLength;
	      if (typeof segment.start === 'number' && typeof segment.end === 'number') {
	        this.mediaSecondsLoaded += segment.end - segment.start;
	      } else {
	        this.mediaSecondsLoaded += segment.duration;
	      }
	
	      this.logger_(segmentInfoString(segmentInfo));
	
	      this.sourceUpdater_.appendBuffer(segmentInfo.bytes, this.handleUpdateEnd_.bind(this));
	    }
	
	    /**
	     * callback to run when appendBuffer is finished. detects if we are
	     * in a good state to do things with the data we got, or if we need
	     * to wait for more
	     *
	     * @private
	     */
	
	  }, {
	    key: 'handleUpdateEnd_',
	    value: function handleUpdateEnd_() {
	      if (!this.pendingSegment_) {
	        this.state = 'READY';
	        if (!this.paused()) {
	          this.monitorBuffer_();
	        }
	        return;
	      }
	
	      var segmentInfo = this.pendingSegment_;
	      var segment = segmentInfo.segment;
	      var isWalkingForward = this.mediaIndex !== null;
	
	      this.pendingSegment_ = null;
	      this.recordThroughput_(segmentInfo);
	      this.addSegmentMetadataCue_(segmentInfo);
	
	      this.state = 'READY';
	
	      this.mediaIndex = segmentInfo.mediaIndex;
	      this.fetchAtBuffer_ = true;
	      this.currentTimeline_ = segmentInfo.timeline;
	
	      // We must update the syncinfo to recalculate the seekable range before
	      // the following conditional otherwise it may consider this a bad "guess"
	      // and attempt to resync when the post-update seekable window and live
	      // point would mean that this was the perfect segment to fetch
	      this.trigger('syncinfoupdate');
	
	      // If we previously appended a segment that ends more than 3 targetDurations before
	      // the currentTime_ that means that our conservative guess was too conservative.
	      // In that case, reset the loader state so that we try to use any information gained
	      // from the previous request to create a new, more accurate, sync-point.
	      if (segment.end && this.currentTime_() - segment.end > segmentInfo.playlist.targetDuration * 3) {
	        this.resetEverything();
	        return;
	      }
	
	      // Don't do a rendition switch unless we have enough time to get a sync segment
	      // and conservatively guess
	      if (isWalkingForward) {
	        this.trigger('bandwidthupdate');
	      }
	      this.trigger('progress');
	
	      // any time an update finishes and the last segment is in the
	      // buffer, end the stream. this ensures the "ended" event will
	      // fire if playback reaches that point.
	      var isEndOfStream = detectEndOfStream(segmentInfo.playlist, this.mediaSource_, segmentInfo.mediaIndex + 1);
	
	      if (isEndOfStream) {
	        this.endOfStream();
	      }
	
	      if (!this.paused()) {
	        this.monitorBuffer_();
	      }
	    }
	
	    /**
	     * Records the current throughput of the decrypt, transmux, and append
	     * portion of the semgment pipeline. `throughput.rate` is a the cumulative
	     * moving average of the throughput. `throughput.count` is the number of
	     * data points in the average.
	     *
	     * @private
	     * @param {Object} segmentInfo the object returned by loadSegment
	     */
	
	  }, {
	    key: 'recordThroughput_',
	    value: function recordThroughput_(segmentInfo) {
	      var rate = this.throughput.rate;
	      // Add one to the time to ensure that we don't accidentally attempt to divide
	      // by zero in the case where the throughput is ridiculously high
	      var segmentProcessingTime = Date.now() - segmentInfo.endOfAllRequests + 1;
	      // Multiply by 8000 to convert from bytes/millisecond to bits/second
	      var segmentProcessingThroughput = Math.floor(segmentInfo.byteLength / segmentProcessingTime * 8 * 1000);
	
	      // This is just a cumulative moving average calculation:
	      //   newAvg = oldAvg + (sample - oldAvg) / (sampleCount + 1)
	      this.throughput.rate += (segmentProcessingThroughput - rate) / ++this.throughput.count;
	    }
	
	    /**
	     * Adds a cue to the segment-metadata track with some metadata information about the
	     * segment
	     *
	     * @private
	     * @param {Object} segmentInfo
	     *        the object returned by loadSegment
	     * @method addSegmentMetadataCue_
	     */
	
	  }, {
	    key: 'addSegmentMetadataCue_',
	    value: function addSegmentMetadataCue_(segmentInfo) {
	      if (!this.segmentMetadataTrack_) {
	        return;
	      }
	
	      var segment = segmentInfo.segment;
	      var start = segment.start;
	      var end = segment.end;
	
	      // Do not try adding the cue if the start and end times are invalid.
	      if (!finite(start) || !finite(end)) {
	        return;
	      }
	
	      removeCuesFromTrack(start, end, this.segmentMetadataTrack_);
	
	      var Cue = window$1.WebKitDataCue || window$1.VTTCue;
	      var value = {
	        bandwidth: segmentInfo.playlist.attributes.BANDWIDTH,
	        resolution: segmentInfo.playlist.attributes.RESOLUTION,
	        codecs: segmentInfo.playlist.attributes.CODECS,
	        byteLength: segmentInfo.byteLength,
	        uri: segmentInfo.uri,
	        timeline: segmentInfo.timeline,
	        playlist: segmentInfo.playlist.uri,
	        start: start,
	        end: end
	      };
	      var data = JSON.stringify(value);
	      var cue = new Cue(start, end, data);
	
	      // Attach the metadata to the value property of the cue to keep consistency between
	      // the differences of WebKitDataCue in safari and VTTCue in other browsers
	      cue.value = value;
	
	      this.segmentMetadataTrack_.addCue(cue);
	    }
	  }]);
	  return SegmentLoader;
	}(videojs$1.EventTarget);
	
	var uint8ToUtf8 = function uint8ToUtf8(uintArray) {
	  return decodeURIComponent(escape(String.fromCharCode.apply(null, uintArray)));
	};
	
	/**
	 * @file vtt-segment-loader.js
	 */
	
	var VTT_LINE_TERMINATORS = new Uint8Array('\n\n'.split('').map(function (char) {
	  return char.charCodeAt(0);
	}));
	
	/**
	 * An object that manages segment loading and appending.
	 *
	 * @class VTTSegmentLoader
	 * @param {Object} options required and optional options
	 * @extends videojs.EventTarget
	 */
	
	var VTTSegmentLoader = function (_SegmentLoader) {
	  inherits$1(VTTSegmentLoader, _SegmentLoader);
	
	  function VTTSegmentLoader(settings) {
	    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	    classCallCheck$1(this, VTTSegmentLoader);
	
	    // SegmentLoader requires a MediaSource be specified or it will throw an error;
	    // however, VTTSegmentLoader has no need of a media source, so delete the reference
	    var _this = possibleConstructorReturn$1(this, (VTTSegmentLoader.__proto__ || Object.getPrototypeOf(VTTSegmentLoader)).call(this, settings, options));
	
	    _this.mediaSource_ = null;
	
	    _this.subtitlesTrack_ = null;
	    return _this;
	  }
	
	  /**
	   * Indicates which time ranges are buffered
	   *
	   * @return {TimeRange}
	   *         TimeRange object representing the current buffered ranges
	   */
	
	  createClass$1(VTTSegmentLoader, [{
	    key: 'buffered_',
	    value: function buffered_() {
	      if (!this.subtitlesTrack_ || !this.subtitlesTrack_.cues.length) {
	        return videojs$1.createTimeRanges();
	      }
	
	      var cues = this.subtitlesTrack_.cues;
	      var start = cues[0].startTime;
	      var end = cues[cues.length - 1].startTime;
	
	      return videojs$1.createTimeRanges([[start, end]]);
	    }
	
	    /**
	     * Gets and sets init segment for the provided map
	     *
	     * @param {Object} map
	     *        The map object representing the init segment to get or set
	     * @param {Boolean=} set
	     *        If true, the init segment for the provided map should be saved
	     * @return {Object}
	     *         map object for desired init segment
	     */
	
	  }, {
	    key: 'initSegment',
	    value: function initSegment(map) {
	      var set$$1 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	
	      if (!map) {
	        return null;
	      }
	
	      var id = initSegmentId(map);
	      var storedMap = this.initSegments_[id];
	
	      if (set$$1 && !storedMap && map.bytes) {
	        // append WebVTT line terminators to the media initialization segment if it exists
	        // to follow the WebVTT spec (https://w3c.github.io/webvtt/#file-structure) that
	        // requires two or more WebVTT line terminators between the WebVTT header and the
	        // rest of the file
	        var combinedByteLength = VTT_LINE_TERMINATORS.byteLength + map.bytes.byteLength;
	        var combinedSegment = new Uint8Array(combinedByteLength);
	
	        combinedSegment.set(map.bytes);
	        combinedSegment.set(VTT_LINE_TERMINATORS, map.bytes.byteLength);
	
	        this.initSegments_[id] = storedMap = {
	          resolvedUri: map.resolvedUri,
	          byterange: map.byterange,
	          bytes: combinedSegment
	        };
	      }
	
	      return storedMap || map;
	    }
	
	    /**
	     * Returns true if all configuration required for loading is present, otherwise false.
	     *
	     * @return {Boolean} True if the all configuration is ready for loading
	     * @private
	     */
	
	  }, {
	    key: 'couldBeginLoading_',
	    value: function couldBeginLoading_() {
	      return this.playlist_ && this.subtitlesTrack_ && !this.paused();
	    }
	
	    /**
	     * Once all the starting parameters have been specified, begin
	     * operation. This method should only be invoked from the INIT
	     * state.
	     *
	     * @private
	     */
	
	  }, {
	    key: 'init_',
	    value: function init_() {
	      this.state = 'READY';
	      this.resetEverything();
	      return this.monitorBuffer_();
	    }
	
	    /**
	     * Set a subtitle track on the segment loader to add subtitles to
	     *
	     * @param {TextTrack=} track
	     *        The text track to add loaded subtitles to
	     * @return {TextTrack}
	     *        Returns the subtitles track
	     */
	
	  }, {
	    key: 'track',
	    value: function track(_track) {
	      if (typeof _track === 'undefined') {
	        return this.subtitlesTrack_;
	      }
	
	      this.subtitlesTrack_ = _track;
	
	      // if we were unpaused but waiting for a sourceUpdater, start
	      // buffering now
	      if (this.state === 'INIT' && this.couldBeginLoading_()) {
	        this.init_();
	      }
	
	      return this.subtitlesTrack_;
	    }
	
	    /**
	     * Remove any data in the source buffer between start and end times
	     * @param {Number} start - the start time of the region to remove from the buffer
	     * @param {Number} end - the end time of the region to remove from the buffer
	     */
	
	  }, {
	    key: 'remove',
	    value: function remove(start, end) {
	      removeCuesFromTrack(start, end, this.subtitlesTrack_);
	    }
	
	    /**
	     * fill the buffer with segements unless the sourceBuffers are
	     * currently updating
	     *
	     * Note: this function should only ever be called by monitorBuffer_
	     * and never directly
	     *
	     * @private
	     */
	
	  }, {
	    key: 'fillBuffer_',
	    value: function fillBuffer_() {
	      var _this2 = this;
	
	      if (!this.syncPoint_) {
	        this.syncPoint_ = this.syncController_.getSyncPoint(this.playlist_, this.duration_(), this.currentTimeline_, this.currentTime_());
	      }
	
	      // see if we need to begin loading immediately
	      var segmentInfo = this.checkBuffer_(this.buffered_(), this.playlist_, this.mediaIndex, this.hasPlayed_(), this.currentTime_(), this.syncPoint_);
	
	      segmentInfo = this.skipEmptySegments_(segmentInfo);
	
	      if (!segmentInfo) {
	        return;
	      }
	
	      if (this.syncController_.timestampOffsetForTimeline(segmentInfo.timeline) === null) {
	        // We don't have the timestamp offset that we need to sync subtitles.
	        // Rerun on a timestamp offset or user interaction.
	        var checkTimestampOffset = function checkTimestampOffset() {
	          _this2.state = 'READY';
	          if (!_this2.paused()) {
	            // if not paused, queue a buffer check as soon as possible
	            _this2.monitorBuffer_();
	          }
	        };
	
	        this.syncController_.one('timestampoffset', checkTimestampOffset);
	        this.state = 'WAITING_ON_TIMELINE';
	        return;
	      }
	
	      this.loadSegment_(segmentInfo);
	    }
	
	    /**
	     * Prevents the segment loader from requesting segments we know contain no subtitles
	     * by walking forward until we find the next segment that we don't know whether it is
	     * empty or not.
	     *
	     * @param {Object} segmentInfo
	     *        a segment info object that describes the current segment
	     * @return {Object}
	     *         a segment info object that describes the current segment
	     */
	
	  }, {
	    key: 'skipEmptySegments_',
	    value: function skipEmptySegments_(segmentInfo) {
	      while (segmentInfo && segmentInfo.segment.empty) {
	        segmentInfo = this.generateSegmentInfo_(segmentInfo.playlist, segmentInfo.mediaIndex + 1, segmentInfo.startOfSegment + segmentInfo.duration, segmentInfo.isSyncRequest);
	      }
	      return segmentInfo;
	    }
	
	    /**
	     * append a decrypted segement to the SourceBuffer through a SourceUpdater
	     *
	     * @private
	     */
	
	  }, {
	    key: 'handleSegment_',
	    value: function handleSegment_() {
	      var _this3 = this;
	
	      if (!this.pendingSegment_ || !this.subtitlesTrack_) {
	        this.state = 'READY';
	        return;
	      }
	
	      this.state = 'APPENDING';
	
	      var segmentInfo = this.pendingSegment_;
	      var segment = segmentInfo.segment;
	
	      // Make sure that vttjs has loaded, otherwise, wait till it finished loading
	      if (typeof window$1.WebVTT !== 'function' && this.subtitlesTrack_ && this.subtitlesTrack_.tech_) {
	
	        var loadHandler = function loadHandler() {
	          _this3.handleSegment_();
	        };
	
	        this.state = 'WAITING_ON_VTTJS';
	        this.subtitlesTrack_.tech_.one('vttjsloaded', loadHandler);
	        this.subtitlesTrack_.tech_.one('vttjserror', function () {
	          _this3.subtitlesTrack_.tech_.off('vttjsloaded', loadHandler);
	          _this3.error({
	            message: 'Error loading vtt.js'
	          });
	          _this3.state = 'READY';
	          _this3.pause();
	          _this3.trigger('error');
	        });
	
	        return;
	      }
	
	      segment.requested = true;
	
	      try {
	        this.parseVTTCues_(segmentInfo);
	      } catch (e) {
	        this.error({
	          message: e.message
	        });
	        this.state = 'READY';
	        this.pause();
	        return this.trigger('error');
	      }
	
	      this.updateTimeMapping_(segmentInfo, this.syncController_.timelines[segmentInfo.timeline], this.playlist_);
	
	      if (segmentInfo.isSyncRequest) {
	        this.trigger('syncinfoupdate');
	        this.pendingSegment_ = null;
	        this.state = 'READY';
	        return;
	      }
	
	      segmentInfo.byteLength = segmentInfo.bytes.byteLength;
	
	      this.mediaSecondsLoaded += segment.duration;
	
	      if (segmentInfo.cues.length) {
	        // remove any overlapping cues to prevent doubling
	        this.remove(segmentInfo.cues[0].endTime, segmentInfo.cues[segmentInfo.cues.length - 1].endTime);
	      }
	
	      segmentInfo.cues.forEach(function (cue) {
	        _this3.subtitlesTrack_.addCue(cue);
	      });
	
	      this.handleUpdateEnd_();
	    }
	
	    /**
	     * Uses the WebVTT parser to parse the segment response
	     *
	     * @param {Object} segmentInfo
	     *        a segment info object that describes the current segment
	     * @private
	     */
	
	  }, {
	    key: 'parseVTTCues_',
	    value: function parseVTTCues_(segmentInfo) {
	      var decoder = void 0;
	      var decodeBytesToString = false;
	
	      if (typeof window$1.TextDecoder === 'function') {
	        decoder = new window$1.TextDecoder('utf8');
	      } else {
	        decoder = window$1.WebVTT.StringDecoder();
	        decodeBytesToString = true;
	      }
	
	      var parser = new window$1.WebVTT.Parser(window$1, window$1.vttjs, decoder);
	
	      segmentInfo.cues = [];
	      segmentInfo.timestampmap = { MPEGTS: 0, LOCAL: 0 };
	
	      parser.oncue = segmentInfo.cues.push.bind(segmentInfo.cues);
	      parser.ontimestampmap = function (map) {
	        return segmentInfo.timestampmap = map;
	      };
	      parser.onparsingerror = function (error) {
	        videojs$1.log.warn('Error encountered when parsing cues: ' + error.message);
	      };
	
	      if (segmentInfo.segment.map) {
	        var mapData = segmentInfo.segment.map.bytes;
	
	        if (decodeBytesToString) {
	          mapData = uint8ToUtf8(mapData);
	        }
	
	        parser.parse(mapData);
	      }
	
	      var segmentData = segmentInfo.bytes;
	
	      if (decodeBytesToString) {
	        segmentData = uint8ToUtf8(segmentData);
	      }
	
	      parser.parse(segmentData);
	      parser.flush();
	    }
	
	    /**
	     * Updates the start and end times of any cues parsed by the WebVTT parser using
	     * the information parsed from the X-TIMESTAMP-MAP header and a TS to media time mapping
	     * from the SyncController
	     *
	     * @param {Object} segmentInfo
	     *        a segment info object that describes the current segment
	     * @param {Object} mappingObj
	     *        object containing a mapping from TS to media time
	     * @param {Object} playlist
	     *        the playlist object containing the segment
	     * @private
	     */
	
	  }, {
	    key: 'updateTimeMapping_',
	    value: function updateTimeMapping_(segmentInfo, mappingObj, playlist) {
	      var segment = segmentInfo.segment;
	
	      if (!mappingObj) {
	        // If the sync controller does not have a mapping of TS to Media Time for the
	        // timeline, then we don't have enough information to update the cue
	        // start/end times
	        return;
	      }
	
	      if (!segmentInfo.cues.length) {
	        // If there are no cues, we also do not have enough information to figure out
	        // segment timing. Mark that the segment contains no cues so we don't re-request
	        // an empty segment.
	        segment.empty = true;
	        return;
	      }
	
	      var timestampmap = segmentInfo.timestampmap;
	      var diff = timestampmap.MPEGTS / 90000 - timestampmap.LOCAL + mappingObj.mapping;
	
	      segmentInfo.cues.forEach(function (cue) {
	        // First convert cue time to TS time using the timestamp-map provided within the vtt
	        cue.startTime += diff;
	        cue.endTime += diff;
	      });
	
	      if (!playlist.syncInfo) {
	        var firstStart = segmentInfo.cues[0].startTime;
	        var lastStart = segmentInfo.cues[segmentInfo.cues.length - 1].startTime;
	
	        playlist.syncInfo = {
	          mediaSequence: playlist.mediaSequence + segmentInfo.mediaIndex,
	          time: Math.min(firstStart, lastStart - segment.duration)
	        };
	      }
	    }
	  }]);
	  return VTTSegmentLoader;
	}(SegmentLoader);
	
	/**
	 * @file ad-cue-tags.js
	 */
	
	/**
	 * Searches for an ad cue that overlaps with the given mediaTime
	 */
	var findAdCue = function findAdCue(track, mediaTime) {
	  var cues = track.cues;
	
	  for (var i = 0; i < cues.length; i++) {
	    var cue = cues[i];
	
	    if (mediaTime >= cue.adStartTime && mediaTime <= cue.adEndTime) {
	      return cue;
	    }
	  }
	  return null;
	};
	
	var updateAdCues = function updateAdCues(media, track) {
	  var offset = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
	
	  if (!media.segments) {
	    return;
	  }
	
	  var mediaTime = offset;
	  var cue = void 0;
	
	  for (var i = 0; i < media.segments.length; i++) {
	    var segment = media.segments[i];
	
	    if (!cue) {
	      // Since the cues will span for at least the segment duration, adding a fudge
	      // factor of half segment duration will prevent duplicate cues from being
	      // created when timing info is not exact (e.g. cue start time initialized
	      // at 10.006677, but next call mediaTime is 10.003332 )
	      cue = findAdCue(track, mediaTime + segment.duration / 2);
	    }
	
	    if (cue) {
	      if ('cueIn' in segment) {
	        // Found a CUE-IN so end the cue
	        cue.endTime = mediaTime;
	        cue.adEndTime = mediaTime;
	        mediaTime += segment.duration;
	        cue = null;
	        continue;
	      }
	
	      if (mediaTime < cue.endTime) {
	        // Already processed this mediaTime for this cue
	        mediaTime += segment.duration;
	        continue;
	      }
	
	      // otherwise extend cue until a CUE-IN is found
	      cue.endTime += segment.duration;
	    } else {
	      if ('cueOut' in segment) {
	        cue = new window$1.VTTCue(mediaTime, mediaTime + segment.duration, segment.cueOut);
	        cue.adStartTime = mediaTime;
	        // Assumes tag format to be
	        // #EXT-X-CUE-OUT:30
	        cue.adEndTime = mediaTime + parseFloat(segment.cueOut);
	        track.addCue(cue);
	      }
	
	      if ('cueOutCont' in segment) {
	        // Entered into the middle of an ad cue
	        var adOffset = void 0;
	        var adTotal = void 0;
	
	        // Assumes tag formate to be
	        // #EXT-X-CUE-OUT-CONT:10/30
	
	        var _segment$cueOutCont$s = segment.cueOutCont.split('/').map(parseFloat);
	
	        var _segment$cueOutCont$s2 = slicedToArray$1(_segment$cueOutCont$s, 2);
	
	        adOffset = _segment$cueOutCont$s2[0];
	        adTotal = _segment$cueOutCont$s2[1];
	
	        cue = new window$1.VTTCue(mediaTime, mediaTime + segment.duration, '');
	        cue.adStartTime = mediaTime - adOffset;
	        cue.adEndTime = cue.adStartTime + adTotal;
	        track.addCue(cue);
	      }
	    }
	    mediaTime += segment.duration;
	  }
	};
	
	/**
	 * @file sync-controller.js
	 */
	
	var tsprobe = tsInspector.inspect;
	
	var syncPointStrategies = [
	// Stategy "VOD": Handle the VOD-case where the sync-point is *always*
	//                the equivalence display-time 0 === segment-index 0
	{
	  name: 'VOD',
	  run: function run(syncController, playlist, duration$$1, currentTimeline, currentTime) {
	    if (duration$$1 !== Infinity) {
	      var syncPoint = {
	        time: 0,
	        segmentIndex: 0
	      };
	
	      return syncPoint;
	    }
	    return null;
	  }
	},
	// Stategy "ProgramDateTime": We have a program-date-time tag in this playlist
	{
	  name: 'ProgramDateTime',
	  run: function run(syncController, playlist, duration$$1, currentTimeline, currentTime) {
	    if (!syncController.datetimeToDisplayTime) {
	      return null;
	    }
	
	    var segments = playlist.segments || [];
	    var syncPoint = null;
	    var lastDistance = null;
	
	    currentTime = currentTime || 0;
	
	    for (var i = 0; i < segments.length; i++) {
	      var segment = segments[i];
	
	      if (segment.dateTimeObject) {
	        var segmentTime = segment.dateTimeObject.getTime() / 1000;
	        var segmentStart = segmentTime + syncController.datetimeToDisplayTime;
	        var distance = Math.abs(currentTime - segmentStart);
	
	        // Once the distance begins to increase, we have passed
	        // currentTime and can stop looking for better candidates
	        if (lastDistance !== null && lastDistance < distance) {
	          break;
	        }
	
	        lastDistance = distance;
	        syncPoint = {
	          time: segmentStart,
	          segmentIndex: i
	        };
	      }
	    }
	    return syncPoint;
	  }
	},
	// Stategy "Segment": We have a known time mapping for a timeline and a
	//                    segment in the current timeline with timing data
	{
	  name: 'Segment',
	  run: function run(syncController, playlist, duration$$1, currentTimeline, currentTime) {
	    var segments = playlist.segments || [];
	    var syncPoint = null;
	    var lastDistance = null;
	
	    currentTime = currentTime || 0;
	
	    for (var i = 0; i < segments.length; i++) {
	      var segment = segments[i];
	
	      if (segment.timeline === currentTimeline && typeof segment.start !== 'undefined') {
	        var distance = Math.abs(currentTime - segment.start);
	
	        // Once the distance begins to increase, we have passed
	        // currentTime and can stop looking for better candidates
	        if (lastDistance !== null && lastDistance < distance) {
	          break;
	        }
	
	        if (!syncPoint || lastDistance === null || lastDistance >= distance) {
	          lastDistance = distance;
	          syncPoint = {
	            time: segment.start,
	            segmentIndex: i
	          };
	        }
	      }
	    }
	    return syncPoint;
	  }
	},
	// Stategy "Discontinuity": We have a discontinuity with a known
	//                          display-time
	{
	  name: 'Discontinuity',
	  run: function run(syncController, playlist, duration$$1, currentTimeline, currentTime) {
	    var syncPoint = null;
	
	    currentTime = currentTime || 0;
	
	    if (playlist.discontinuityStarts && playlist.discontinuityStarts.length) {
	      var lastDistance = null;
	
	      for (var i = 0; i < playlist.discontinuityStarts.length; i++) {
	        var segmentIndex = playlist.discontinuityStarts[i];
	        var discontinuity = playlist.discontinuitySequence + i + 1;
	        var discontinuitySync = syncController.discontinuities[discontinuity];
	
	        if (discontinuitySync) {
	          var distance = Math.abs(currentTime - discontinuitySync.time);
	
	          // Once the distance begins to increase, we have passed
	          // currentTime and can stop looking for better candidates
	          if (lastDistance !== null && lastDistance < distance) {
	            break;
	          }
	
	          if (!syncPoint || lastDistance === null || lastDistance >= distance) {
	            lastDistance = distance;
	            syncPoint = {
	              time: discontinuitySync.time,
	              segmentIndex: segmentIndex
	            };
	          }
	        }
	      }
	    }
	    return syncPoint;
	  }
	},
	// Stategy "Playlist": We have a playlist with a known mapping of
	//                     segment index to display time
	{
	  name: 'Playlist',
	  run: function run(syncController, playlist, duration$$1, currentTimeline, currentTime) {
	    if (playlist.syncInfo) {
	      var syncPoint = {
	        time: playlist.syncInfo.time,
	        segmentIndex: playlist.syncInfo.mediaSequence - playlist.mediaSequence
	      };
	
	      return syncPoint;
	    }
	    return null;
	  }
	}];
	
	var SyncController = function (_videojs$EventTarget) {
	  inherits$1(SyncController, _videojs$EventTarget);
	
	  function SyncController() {
	    classCallCheck$1(this, SyncController);
	
	    // Segment Loader state variables...
	    // ...for synching across variants
	    var _this = possibleConstructorReturn$1(this, (SyncController.__proto__ || Object.getPrototypeOf(SyncController)).call(this));
	
	    _this.inspectCache_ = undefined;
	
	    // ...for synching across variants
	    _this.timelines = [];
	    _this.discontinuities = [];
	    _this.datetimeToDisplayTime = null;
	
	    _this.logger_ = logger('SyncController');
	    return _this;
	  }
	
	  /**
	   * Find a sync-point for the playlist specified
	   *
	   * A sync-point is defined as a known mapping from display-time to
	   * a segment-index in the current playlist.
	   *
	   * @param {Playlist} playlist
	   *        The playlist that needs a sync-point
	   * @param {Number} duration
	   *        Duration of the MediaSource (Infinite if playing a live source)
	   * @param {Number} currentTimeline
	   *        The last timeline from which a segment was loaded
	   * @returns {Object}
	   *          A sync-point object
	   */
	
	  createClass$1(SyncController, [{
	    key: 'getSyncPoint',
	    value: function getSyncPoint(playlist, duration$$1, currentTimeline, currentTime) {
	      var syncPoints = this.runStrategies_(playlist, duration$$1, currentTimeline, currentTime);
	
	      if (!syncPoints.length) {
	        // Signal that we need to attempt to get a sync-point manually
	        // by fetching a segment in the playlist and constructing
	        // a sync-point from that information
	        return null;
	      }
	
	      // Now find the sync-point that is closest to the currentTime because
	      // that should result in the most accurate guess about which segment
	      // to fetch
	      return this.selectSyncPoint_(syncPoints, { key: 'time', value: currentTime });
	    }
	
	    /**
	     * Calculate the amount of time that has expired off the playlist during playback
	     *
	     * @param {Playlist} playlist
	     *        Playlist object to calculate expired from
	     * @param {Number} duration
	     *        Duration of the MediaSource (Infinity if playling a live source)
	     * @returns {Number|null}
	     *          The amount of time that has expired off the playlist during playback. Null
	     *          if no sync-points for the playlist can be found.
	     */
	
	  }, {
	    key: 'getExpiredTime',
	    value: function getExpiredTime(playlist, duration$$1) {
	      if (!playlist || !playlist.segments) {
	        return null;
	      }
	
	      var syncPoints = this.runStrategies_(playlist, duration$$1, playlist.discontinuitySequence, 0);
	
	      // Without sync-points, there is not enough information to determine the expired time
	      if (!syncPoints.length) {
	        return null;
	      }
	
	      var syncPoint = this.selectSyncPoint_(syncPoints, {
	        key: 'segmentIndex',
	        value: 0
	      });
	
	      // If the sync-point is beyond the start of the playlist, we want to subtract the
	      // duration from index 0 to syncPoint.segmentIndex instead of adding.
	      if (syncPoint.segmentIndex > 0) {
	        syncPoint.time *= -1;
	      }
	
	      return Math.abs(syncPoint.time + sumDurations(playlist, syncPoint.segmentIndex, 0));
	    }
	
	    /**
	     * Runs each sync-point strategy and returns a list of sync-points returned by the
	     * strategies
	     *
	     * @private
	     * @param {Playlist} playlist
	     *        The playlist that needs a sync-point
	     * @param {Number} duration
	     *        Duration of the MediaSource (Infinity if playing a live source)
	     * @param {Number} currentTimeline
	     *        The last timeline from which a segment was loaded
	     * @returns {Array}
	     *          A list of sync-point objects
	     */
	
	  }, {
	    key: 'runStrategies_',
	    value: function runStrategies_(playlist, duration$$1, currentTimeline, currentTime) {
	      var syncPoints = [];
	
	      // Try to find a sync-point in by utilizing various strategies...
	      for (var i = 0; i < syncPointStrategies.length; i++) {
	        var strategy = syncPointStrategies[i];
	        var syncPoint = strategy.run(this, playlist, duration$$1, currentTimeline, currentTime);
	
	        if (syncPoint) {
	          syncPoint.strategy = strategy.name;
	          syncPoints.push({
	            strategy: strategy.name,
	            syncPoint: syncPoint
	          });
	        }
	      }
	
	      return syncPoints;
	    }
	
	    /**
	     * Selects the sync-point nearest the specified target
	     *
	     * @private
	     * @param {Array} syncPoints
	     *        List of sync-points to select from
	     * @param {Object} target
	     *        Object specifying the property and value we are targeting
	     * @param {String} target.key
	     *        Specifies the property to target. Must be either 'time' or 'segmentIndex'
	     * @param {Number} target.value
	     *        The value to target for the specified key.
	     * @returns {Object}
	     *          The sync-point nearest the target
	     */
	
	  }, {
	    key: 'selectSyncPoint_',
	    value: function selectSyncPoint_(syncPoints, target) {
	      var bestSyncPoint = syncPoints[0].syncPoint;
	      var bestDistance = Math.abs(syncPoints[0].syncPoint[target.key] - target.value);
	      var bestStrategy = syncPoints[0].strategy;
	
	      for (var i = 1; i < syncPoints.length; i++) {
	        var newDistance = Math.abs(syncPoints[i].syncPoint[target.key] - target.value);
	
	        if (newDistance < bestDistance) {
	          bestDistance = newDistance;
	          bestSyncPoint = syncPoints[i].syncPoint;
	          bestStrategy = syncPoints[i].strategy;
	        }
	      }
	
	      this.logger_('syncPoint for [' + target.key + ': ' + target.value + '] chosen with strategy' + (' [' + bestStrategy + ']: [time:' + bestSyncPoint.time + ',') + (' segmentIndex:' + bestSyncPoint.segmentIndex + ']'));
	
	      return bestSyncPoint;
	    }
	
	    /**
	     * Save any meta-data present on the segments when segments leave
	     * the live window to the playlist to allow for synchronization at the
	     * playlist level later.
	     *
	     * @param {Playlist} oldPlaylist - The previous active playlist
	     * @param {Playlist} newPlaylist - The updated and most current playlist
	     */
	
	  }, {
	    key: 'saveExpiredSegmentInfo',
	    value: function saveExpiredSegmentInfo(oldPlaylist, newPlaylist) {
	      var mediaSequenceDiff = newPlaylist.mediaSequence - oldPlaylist.mediaSequence;
	
	      // When a segment expires from the playlist and it has a start time
	      // save that information as a possible sync-point reference in future
	      for (var i = mediaSequenceDiff - 1; i >= 0; i--) {
	        var lastRemovedSegment = oldPlaylist.segments[i];
	
	        if (lastRemovedSegment && typeof lastRemovedSegment.start !== 'undefined') {
	          newPlaylist.syncInfo = {
	            mediaSequence: oldPlaylist.mediaSequence + i,
	            time: lastRemovedSegment.start
	          };
	          this.logger_('playlist refresh sync: [time:' + newPlaylist.syncInfo.time + ',' + (' mediaSequence: ' + newPlaylist.syncInfo.mediaSequence + ']'));
	          this.trigger('syncinfoupdate');
	          break;
	        }
	      }
	    }
	
	    /**
	     * Save the mapping from playlist's ProgramDateTime to display. This should
	     * only ever happen once at the start of playback.
	     *
	     * @param {Playlist} playlist - The currently active playlist
	     */
	
	  }, {
	    key: 'setDateTimeMapping',
	    value: function setDateTimeMapping(playlist) {
	      if (!this.datetimeToDisplayTime && playlist.segments && playlist.segments.length && playlist.segments[0].dateTimeObject) {
	        var playlistTimestamp = playlist.segments[0].dateTimeObject.getTime() / 1000;
	
	        this.datetimeToDisplayTime = -playlistTimestamp;
	      }
	    }
	
	    /**
	     * Reset the state of the inspection cache when we do a rendition
	     * switch
	     */
	
	  }, {
	    key: 'reset',
	    value: function reset() {
	      this.inspectCache_ = undefined;
	    }
	
	    /**
	     * Probe or inspect a fmp4 or an mpeg2-ts segment to determine the start
	     * and end of the segment in it's internal "media time". Used to generate
	     * mappings from that internal "media time" to the display time that is
	     * shown on the player.
	     *
	     * @param {SegmentInfo} segmentInfo - The current active request information
	     */
	
	  }, {
	    key: 'probeSegmentInfo',
	    value: function probeSegmentInfo(segmentInfo) {
	      var segment = segmentInfo.segment;
	      var playlist = segmentInfo.playlist;
	      var timingInfo = void 0;
	
	      if (segment.map) {
	        timingInfo = this.probeMp4Segment_(segmentInfo);
	      } else {
	        timingInfo = this.probeTsSegment_(segmentInfo);
	      }
	
	      if (timingInfo) {
	        if (this.calculateSegmentTimeMapping_(segmentInfo, timingInfo)) {
	          this.saveDiscontinuitySyncInfo_(segmentInfo);
	
	          // If the playlist does not have sync information yet, record that information
	          // now with segment timing information
	          if (!playlist.syncInfo) {
	            playlist.syncInfo = {
	              mediaSequence: playlist.mediaSequence + segmentInfo.mediaIndex,
	              time: segment.start
	            };
	          }
	        }
	      }
	
	      return timingInfo;
	    }
	
	    /**
	     * Probe an fmp4 or an mpeg2-ts segment to determine the start of the segment
	     * in it's internal "media time".
	     *
	     * @private
	     * @param {SegmentInfo} segmentInfo - The current active request information
	     * @return {object} The start and end time of the current segment in "media time"
	     */
	
	  }, {
	    key: 'probeMp4Segment_',
	    value: function probeMp4Segment_(segmentInfo) {
	      var segment = segmentInfo.segment;
	      var timescales = mp4probe.timescale(segment.map.bytes);
	      var startTime = mp4probe.startTime(timescales, segmentInfo.bytes);
	
	      if (segmentInfo.timestampOffset !== null) {
	        segmentInfo.timestampOffset -= startTime;
	      }
	
	      return {
	        start: startTime,
	        end: startTime + segment.duration
	      };
	    }
	
	    /**
	     * Probe an mpeg2-ts segment to determine the start and end of the segment
	     * in it's internal "media time".
	     *
	     * @private
	     * @param {SegmentInfo} segmentInfo - The current active request information
	     * @return {object} The start and end time of the current segment in "media time"
	     */
	
	  }, {
	    key: 'probeTsSegment_',
	    value: function probeTsSegment_(segmentInfo) {
	      var timeInfo = tsprobe(segmentInfo.bytes, this.inspectCache_);
	      var segmentStartTime = void 0;
	      var segmentEndTime = void 0;
	
	      if (!timeInfo) {
	        return null;
	      }
	
	      if (timeInfo.video && timeInfo.video.length === 2) {
	        this.inspectCache_ = timeInfo.video[1].dts;
	        segmentStartTime = timeInfo.video[0].dtsTime;
	        segmentEndTime = timeInfo.video[1].dtsTime;
	      } else if (timeInfo.audio && timeInfo.audio.length === 2) {
	        this.inspectCache_ = timeInfo.audio[1].dts;
	        segmentStartTime = timeInfo.audio[0].dtsTime;
	        segmentEndTime = timeInfo.audio[1].dtsTime;
	      }
	
	      return {
	        start: segmentStartTime,
	        end: segmentEndTime,
	        containsVideo: timeInfo.video && timeInfo.video.length === 2,
	        containsAudio: timeInfo.audio && timeInfo.audio.length === 2
	      };
	    }
	  }, {
	    key: 'timestampOffsetForTimeline',
	    value: function timestampOffsetForTimeline(timeline) {
	      if (typeof this.timelines[timeline] === 'undefined') {
	        return null;
	      }
	      return this.timelines[timeline].time;
	    }
	  }, {
	    key: 'mappingForTimeline',
	    value: function mappingForTimeline(timeline) {
	      if (typeof this.timelines[timeline] === 'undefined') {
	        return null;
	      }
	      return this.timelines[timeline].mapping;
	    }
	
	    /**
	     * Use the "media time" for a segment to generate a mapping to "display time" and
	     * save that display time to the segment.
	     *
	     * @private
	     * @param {SegmentInfo} segmentInfo
	     *        The current active request information
	     * @param {object} timingInfo
	     *        The start and end time of the current segment in "media time"
	     * @returns {Boolean}
	     *          Returns false if segment time mapping could not be calculated
	     */
	
	  }, {
	    key: 'calculateSegmentTimeMapping_',
	    value: function calculateSegmentTimeMapping_(segmentInfo, timingInfo) {
	      var segment = segmentInfo.segment;
	      var mappingObj = this.timelines[segmentInfo.timeline];
	
	      if (segmentInfo.timestampOffset !== null) {
	        mappingObj = {
	          time: segmentInfo.startOfSegment,
	          mapping: segmentInfo.startOfSegment - timingInfo.start
	        };
	        this.timelines[segmentInfo.timeline] = mappingObj;
	        this.trigger('timestampoffset');
	
	        this.logger_('time mapping for timeline ' + segmentInfo.timeline + ': ' + ('[time: ' + mappingObj.time + '] [mapping: ' + mappingObj.mapping + ']'));
	
	        segment.start = segmentInfo.startOfSegment;
	        segment.end = timingInfo.end + mappingObj.mapping;
	      } else if (mappingObj) {
	        segment.start = timingInfo.start + mappingObj.mapping;
	        segment.end = timingInfo.end + mappingObj.mapping;
	      } else {
	        return false;
	      }
	
	      return true;
	    }
	
	    /**
	     * Each time we have discontinuity in the playlist, attempt to calculate the location
	     * in display of the start of the discontinuity and save that. We also save an accuracy
	     * value so that we save values with the most accuracy (closest to 0.)
	     *
	     * @private
	     * @param {SegmentInfo} segmentInfo - The current active request information
	     */
	
	  }, {
	    key: 'saveDiscontinuitySyncInfo_',
	    value: function saveDiscontinuitySyncInfo_(segmentInfo) {
	      var playlist = segmentInfo.playlist;
	      var segment = segmentInfo.segment;
	
	      // If the current segment is a discontinuity then we know exactly where
	      // the start of the range and it's accuracy is 0 (greater accuracy values
	      // mean more approximation)
	      if (segment.discontinuity) {
	        this.discontinuities[segment.timeline] = {
	          time: segment.start,
	          accuracy: 0
	        };
	      } else if (playlist.discontinuityStarts && playlist.discontinuityStarts.length) {
	        // Search for future discontinuities that we can provide better timing
	        // information for and save that information for sync purposes
	        for (var i = 0; i < playlist.discontinuityStarts.length; i++) {
	          var segmentIndex = playlist.discontinuityStarts[i];
	          var discontinuity = playlist.discontinuitySequence + i + 1;
	          var mediaIndexDiff = segmentIndex - segmentInfo.mediaIndex;
	          var accuracy = Math.abs(mediaIndexDiff);
	
	          if (!this.discontinuities[discontinuity] || this.discontinuities[discontinuity].accuracy > accuracy) {
	            var time = void 0;
	
	            if (mediaIndexDiff < 0) {
	              time = segment.start - sumDurations(playlist, segmentInfo.mediaIndex, segmentIndex);
	            } else {
	              time = segment.end + sumDurations(playlist, segmentInfo.mediaIndex + 1, segmentIndex);
	            }
	
	            this.discontinuities[discontinuity] = {
	              time: time,
	              accuracy: accuracy
	            };
	          }
	        }
	      }
	    }
	  }]);
	  return SyncController;
	}(videojs$1.EventTarget);
	
	var Decrypter$1 = new shimWorker("./decrypter-worker.worker.js", function (window, document$$1) {
	  var self = this;
	  var decrypterWorker = function () {
	
	    /*
	     * pkcs7.pad
	     * https://github.com/brightcove/pkcs7
	     *
	     * Copyright (c) 2014 Brightcove
	     * Licensed under the apache2 license.
	     */
	
	    /**
	     * Returns the subarray of a Uint8Array without PKCS#7 padding.
	     * @param padded {Uint8Array} unencrypted bytes that have been padded
	     * @return {Uint8Array} the unpadded bytes
	     * @see http://tools.ietf.org/html/rfc5652
	     */
	
	    function unpad(padded) {
	      return padded.subarray(0, padded.byteLength - padded[padded.byteLength - 1]);
	    }
	
	    var classCallCheck$$1 = function classCallCheck$$1(instance, Constructor) {
	      if (!(instance instanceof Constructor)) {
	        throw new TypeError("Cannot call a class as a function");
	      }
	    };
	
	    var createClass$$1 = function () {
	      function defineProperties(target, props) {
	        for (var i = 0; i < props.length; i++) {
	          var descriptor = props[i];
	          descriptor.enumerable = descriptor.enumerable || false;
	          descriptor.configurable = true;
	          if ("value" in descriptor) descriptor.writable = true;
	          Object.defineProperty(target, descriptor.key, descriptor);
	        }
	      }
	
	      return function (Constructor, protoProps, staticProps) {
	        if (protoProps) defineProperties(Constructor.prototype, protoProps);
	        if (staticProps) defineProperties(Constructor, staticProps);
	        return Constructor;
	      };
	    }();
	
	    var inherits$$1 = function inherits$$1(subClass, superClass) {
	      if (typeof superClass !== "function" && superClass !== null) {
	        throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === 'undefined' ? 'undefined' : _typeof(superClass)));
	      }
	
	      subClass.prototype = Object.create(superClass && superClass.prototype, {
	        constructor: {
	          value: subClass,
	          enumerable: false,
	          writable: true,
	          configurable: true
	        }
	      });
	      if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
	    };
	
	    var possibleConstructorReturn$$1 = function possibleConstructorReturn$$1(self, call) {
	      if (!self) {
	        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	      }
	
	      return call && ((typeof call === 'undefined' ? 'undefined' : _typeof(call)) === "object" || typeof call === "function") ? call : self;
	    };
	
	    /**
	     * @file aes.js
	     *
	     * This file contains an adaptation of the AES decryption algorithm
	     * from the Standford Javascript Cryptography Library. That work is
	     * covered by the following copyright and permissions notice:
	     *
	     * Copyright 2009-2010 Emily Stark, Mike Hamburg, Dan Boneh.
	     * All rights reserved.
	     *
	     * Redistribution and use in source and binary forms, with or without
	     * modification, are permitted provided that the following conditions are
	     * met:
	     *
	     * 1. Redistributions of source code must retain the above copyright
	     *    notice, this list of conditions and the following disclaimer.
	     *
	     * 2. Redistributions in binary form must reproduce the above
	     *    copyright notice, this list of conditions and the following
	     *    disclaimer in the documentation and/or other materials provided
	     *    with the distribution.
	     *
	     * THIS SOFTWARE IS PROVIDED BY THE AUTHORS ``AS IS'' AND ANY EXPRESS OR
	     * IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
	     * WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE
	     * DISCLAIMED. IN NO EVENT SHALL <COPYRIGHT HOLDER> OR CONTRIBUTORS BE
	     * LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR
	     * CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF
	     * SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR PROFITS; OR
	     * BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY,
	     * WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE
	     * OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN
	     * IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
	     *
	     * The views and conclusions contained in the software and documentation
	     * are those of the authors and should not be interpreted as representing
	     * official policies, either expressed or implied, of the authors.
	     */
	
	    /**
	     * Expand the S-box tables.
	     *
	     * @private
	     */
	    var precompute = function precompute() {
	      var tables = [[[], [], [], [], []], [[], [], [], [], []]];
	      var encTable = tables[0];
	      var decTable = tables[1];
	      var sbox = encTable[4];
	      var sboxInv = decTable[4];
	      var i = void 0;
	      var x = void 0;
	      var xInv = void 0;
	      var d = [];
	      var th = [];
	      var x2 = void 0;
	      var x4 = void 0;
	      var x8 = void 0;
	      var s = void 0;
	      var tEnc = void 0;
	      var tDec = void 0;
	
	      // Compute double and third tables
	      for (i = 0; i < 256; i++) {
	        th[(d[i] = i << 1 ^ (i >> 7) * 283) ^ i] = i;
	      }
	
	      for (x = xInv = 0; !sbox[x]; x ^= x2 || 1, xInv = th[xInv] || 1) {
	        // Compute sbox
	        s = xInv ^ xInv << 1 ^ xInv << 2 ^ xInv << 3 ^ xInv << 4;
	        s = s >> 8 ^ s & 255 ^ 99;
	        sbox[x] = s;
	        sboxInv[s] = x;
	
	        // Compute MixColumns
	        x8 = d[x4 = d[x2 = d[x]]];
	        tDec = x8 * 0x1010101 ^ x4 * 0x10001 ^ x2 * 0x101 ^ x * 0x1010100;
	        tEnc = d[s] * 0x101 ^ s * 0x1010100;
	
	        for (i = 0; i < 4; i++) {
	          encTable[i][x] = tEnc = tEnc << 24 ^ tEnc >>> 8;
	          decTable[i][s] = tDec = tDec << 24 ^ tDec >>> 8;
	        }
	      }
	
	      // Compactify. Considerable speedup on Firefox.
	      for (i = 0; i < 5; i++) {
	        encTable[i] = encTable[i].slice(0);
	        decTable[i] = decTable[i].slice(0);
	      }
	      return tables;
	    };
	    var aesTables = null;
	
	    /**
	     * Schedule out an AES key for both encryption and decryption. This
	     * is a low-level class. Use a cipher mode to do bulk encryption.
	     *
	     * @class AES
	     * @param key {Array} The key as an array of 4, 6 or 8 words.
	     */
	
	    var AES = function () {
	      function AES(key) {
	        classCallCheck$$1(this, AES);
	
	        /**
	         * The expanded S-box and inverse S-box tables. These will be computed
	         * on the client so that we don't have to send them down the wire.
	         *
	         * There are two tables, _tables[0] is for encryption and
	         * _tables[1] is for decryption.
	         *
	         * The first 4 sub-tables are the expanded S-box with MixColumns. The
	         * last (_tables[01][4]) is the S-box itself.
	         *
	         * @private
	         */
	        // if we have yet to precompute the S-box tables
	        // do so now
	        if (!aesTables) {
	          aesTables = precompute();
	        }
	        // then make a copy of that object for use
	        this._tables = [[aesTables[0][0].slice(), aesTables[0][1].slice(), aesTables[0][2].slice(), aesTables[0][3].slice(), aesTables[0][4].slice()], [aesTables[1][0].slice(), aesTables[1][1].slice(), aesTables[1][2].slice(), aesTables[1][3].slice(), aesTables[1][4].slice()]];
	        var i = void 0;
	        var j = void 0;
	        var tmp = void 0;
	        var encKey = void 0;
	        var decKey = void 0;
	        var sbox = this._tables[0][4];
	        var decTable = this._tables[1];
	        var keyLen = key.length;
	        var rcon = 1;
	
	        if (keyLen !== 4 && keyLen !== 6 && keyLen !== 8) {
	          throw new Error('Invalid aes key size');
	        }
	
	        encKey = key.slice(0);
	        decKey = [];
	        this._key = [encKey, decKey];
	
	        // schedule encryption keys
	        for (i = keyLen; i < 4 * keyLen + 28; i++) {
	          tmp = encKey[i - 1];
	
	          // apply sbox
	          if (i % keyLen === 0 || keyLen === 8 && i % keyLen === 4) {
	            tmp = sbox[tmp >>> 24] << 24 ^ sbox[tmp >> 16 & 255] << 16 ^ sbox[tmp >> 8 & 255] << 8 ^ sbox[tmp & 255];
	
	            // shift rows and add rcon
	            if (i % keyLen === 0) {
	              tmp = tmp << 8 ^ tmp >>> 24 ^ rcon << 24;
	              rcon = rcon << 1 ^ (rcon >> 7) * 283;
	            }
	          }
	
	          encKey[i] = encKey[i - keyLen] ^ tmp;
	        }
	
	        // schedule decryption keys
	        for (j = 0; i; j++, i--) {
	          tmp = encKey[j & 3 ? i : i - 4];
	          if (i <= 4 || j < 4) {
	            decKey[j] = tmp;
	          } else {
	            decKey[j] = decTable[0][sbox[tmp >>> 24]] ^ decTable[1][sbox[tmp >> 16 & 255]] ^ decTable[2][sbox[tmp >> 8 & 255]] ^ decTable[3][sbox[tmp & 255]];
	          }
	        }
	      }
	
	      /**
	       * Decrypt 16 bytes, specified as four 32-bit words.
	       *
	       * @param {Number} encrypted0 the first word to decrypt
	       * @param {Number} encrypted1 the second word to decrypt
	       * @param {Number} encrypted2 the third word to decrypt
	       * @param {Number} encrypted3 the fourth word to decrypt
	       * @param {Int32Array} out the array to write the decrypted words
	       * into
	       * @param {Number} offset the offset into the output array to start
	       * writing results
	       * @return {Array} The plaintext.
	       */
	
	      AES.prototype.decrypt = function decrypt$$1(encrypted0, encrypted1, encrypted2, encrypted3, out, offset) {
	        var key = this._key[1];
	        // state variables a,b,c,d are loaded with pre-whitened data
	        var a = encrypted0 ^ key[0];
	        var b = encrypted3 ^ key[1];
	        var c = encrypted2 ^ key[2];
	        var d = encrypted1 ^ key[3];
	        var a2 = void 0;
	        var b2 = void 0;
	        var c2 = void 0;
	
	        // key.length === 2 ?
	        var nInnerRounds = key.length / 4 - 2;
	        var i = void 0;
	        var kIndex = 4;
	        var table = this._tables[1];
	
	        // load up the tables
	        var table0 = table[0];
	        var table1 = table[1];
	        var table2 = table[2];
	        var table3 = table[3];
	        var sbox = table[4];
	
	        // Inner rounds. Cribbed from OpenSSL.
	        for (i = 0; i < nInnerRounds; i++) {
	          a2 = table0[a >>> 24] ^ table1[b >> 16 & 255] ^ table2[c >> 8 & 255] ^ table3[d & 255] ^ key[kIndex];
	          b2 = table0[b >>> 24] ^ table1[c >> 16 & 255] ^ table2[d >> 8 & 255] ^ table3[a & 255] ^ key[kIndex + 1];
	          c2 = table0[c >>> 24] ^ table1[d >> 16 & 255] ^ table2[a >> 8 & 255] ^ table3[b & 255] ^ key[kIndex + 2];
	          d = table0[d >>> 24] ^ table1[a >> 16 & 255] ^ table2[b >> 8 & 255] ^ table3[c & 255] ^ key[kIndex + 3];
	          kIndex += 4;
	          a = a2;b = b2;c = c2;
	        }
	
	        // Last round.
	        for (i = 0; i < 4; i++) {
	          out[(3 & -i) + offset] = sbox[a >>> 24] << 24 ^ sbox[b >> 16 & 255] << 16 ^ sbox[c >> 8 & 255] << 8 ^ sbox[d & 255] ^ key[kIndex++];
	          a2 = a;a = b;b = c;c = d;d = a2;
	        }
	      };
	
	      return AES;
	    }();
	
	    /**
	     * @file stream.js
	     */
	    /**
	     * A lightweight readable stream implemention that handles event dispatching.
	     *
	     * @class Stream
	     */
	    var Stream = function () {
	      function Stream() {
	        classCallCheck$$1(this, Stream);
	
	        this.listeners = {};
	      }
	
	      /**
	       * Add a listener for a specified event type.
	       *
	       * @param {String} type the event name
	       * @param {Function} listener the callback to be invoked when an event of
	       * the specified type occurs
	       */
	
	      Stream.prototype.on = function on(type, listener) {
	        if (!this.listeners[type]) {
	          this.listeners[type] = [];
	        }
	        this.listeners[type].push(listener);
	      };
	
	      /**
	       * Remove a listener for a specified event type.
	       *
	       * @param {String} type the event name
	       * @param {Function} listener  a function previously registered for this
	       * type of event through `on`
	       * @return {Boolean} if we could turn it off or not
	       */
	
	      Stream.prototype.off = function off(type, listener) {
	        if (!this.listeners[type]) {
	          return false;
	        }
	
	        var index = this.listeners[type].indexOf(listener);
	
	        this.listeners[type].splice(index, 1);
	        return index > -1;
	      };
	
	      /**
	       * Trigger an event of the specified type on this stream. Any additional
	       * arguments to this function are passed as parameters to event listeners.
	       *
	       * @param {String} type the event name
	       */
	
	      Stream.prototype.trigger = function trigger(type) {
	        var callbacks = this.listeners[type];
	
	        if (!callbacks) {
	          return;
	        }
	
	        // Slicing the arguments on every invocation of this method
	        // can add a significant amount of overhead. Avoid the
	        // intermediate object creation for the common case of a
	        // single callback argument
	        if (arguments.length === 2) {
	          var length = callbacks.length;
	
	          for (var i = 0; i < length; ++i) {
	            callbacks[i].call(this, arguments[1]);
	          }
	        } else {
	          var args = Array.prototype.slice.call(arguments, 1);
	          var _length = callbacks.length;
	
	          for (var _i = 0; _i < _length; ++_i) {
	            callbacks[_i].apply(this, args);
	          }
	        }
	      };
	
	      /**
	       * Destroys the stream and cleans up.
	       */
	
	      Stream.prototype.dispose = function dispose() {
	        this.listeners = {};
	      };
	      /**
	       * Forwards all `data` events on this stream to the destination stream. The
	       * destination stream should provide a method `push` to receive the data
	       * events as they arrive.
	       *
	       * @param {Stream} destination the stream that will receive all `data` events
	       * @see http://nodejs.org/api/stream.html#stream_readable_pipe_destination_options
	       */
	
	      Stream.prototype.pipe = function pipe(destination) {
	        this.on('data', function (data) {
	          destination.push(data);
	        });
	      };
	
	      return Stream;
	    }();
	
	    /**
	     * @file async-stream.js
	     */
	    /**
	     * A wrapper around the Stream class to use setTiemout
	     * and run stream "jobs" Asynchronously
	     *
	     * @class AsyncStream
	     * @extends Stream
	     */
	
	    var AsyncStream$$1 = function (_Stream) {
	      inherits$$1(AsyncStream$$1, _Stream);
	
	      function AsyncStream$$1() {
	        classCallCheck$$1(this, AsyncStream$$1);
	
	        var _this = possibleConstructorReturn$$1(this, _Stream.call(this, Stream));
	
	        _this.jobs = [];
	        _this.delay = 1;
	        _this.timeout_ = null;
	        return _this;
	      }
	
	      /**
	       * process an async job
	       *
	       * @private
	       */
	
	      AsyncStream$$1.prototype.processJob_ = function processJob_() {
	        this.jobs.shift()();
	        if (this.jobs.length) {
	          this.timeout_ = setTimeout(this.processJob_.bind(this), this.delay);
	        } else {
	          this.timeout_ = null;
	        }
	      };
	
	      /**
	       * push a job into the stream
	       *
	       * @param {Function} job the job to push into the stream
	       */
	
	      AsyncStream$$1.prototype.push = function push(job) {
	        this.jobs.push(job);
	        if (!this.timeout_) {
	          this.timeout_ = setTimeout(this.processJob_.bind(this), this.delay);
	        }
	      };
	
	      return AsyncStream$$1;
	    }(Stream);
	
	    /**
	     * @file decrypter.js
	     *
	     * An asynchronous implementation of AES-128 CBC decryption with
	     * PKCS#7 padding.
	     */
	
	    /**
	     * Convert network-order (big-endian) bytes into their little-endian
	     * representation.
	     */
	    var ntoh = function ntoh(word) {
	      return word << 24 | (word & 0xff00) << 8 | (word & 0xff0000) >> 8 | word >>> 24;
	    };
	
	    /**
	     * Decrypt bytes using AES-128 with CBC and PKCS#7 padding.
	     *
	     * @param {Uint8Array} encrypted the encrypted bytes
	     * @param {Uint32Array} key the bytes of the decryption key
	     * @param {Uint32Array} initVector the initialization vector (IV) to
	     * use for the first round of CBC.
	     * @return {Uint8Array} the decrypted bytes
	     *
	     * @see http://en.wikipedia.org/wiki/Advanced_Encryption_Standard
	     * @see http://en.wikipedia.org/wiki/Block_cipher_mode_of_operation#Cipher_Block_Chaining_.28CBC.29
	     * @see https://tools.ietf.org/html/rfc2315
	     */
	    var decrypt$$1 = function decrypt$$1(encrypted, key, initVector) {
	      // word-level access to the encrypted bytes
	      var encrypted32 = new Int32Array(encrypted.buffer, encrypted.byteOffset, encrypted.byteLength >> 2);
	
	      var decipher = new AES(Array.prototype.slice.call(key));
	
	      // byte and word-level access for the decrypted output
	      var decrypted = new Uint8Array(encrypted.byteLength);
	      var decrypted32 = new Int32Array(decrypted.buffer);
	
	      // temporary variables for working with the IV, encrypted, and
	      // decrypted data
	      var init0 = void 0;
	      var init1 = void 0;
	      var init2 = void 0;
	      var init3 = void 0;
	      var encrypted0 = void 0;
	      var encrypted1 = void 0;
	      var encrypted2 = void 0;
	      var encrypted3 = void 0;
	
	      // iteration variable
	      var wordIx = void 0;
	
	      // pull out the words of the IV to ensure we don't modify the
	      // passed-in reference and easier access
	      init0 = initVector[0];
	      init1 = initVector[1];
	      init2 = initVector[2];
	      init3 = initVector[3];
	
	      // decrypt four word sequences, applying cipher-block chaining (CBC)
	      // to each decrypted block
	      for (wordIx = 0; wordIx < encrypted32.length; wordIx += 4) {
	        // convert big-endian (network order) words into little-endian
	        // (javascript order)
	        encrypted0 = ntoh(encrypted32[wordIx]);
	        encrypted1 = ntoh(encrypted32[wordIx + 1]);
	        encrypted2 = ntoh(encrypted32[wordIx + 2]);
	        encrypted3 = ntoh(encrypted32[wordIx + 3]);
	
	        // decrypt the block
	        decipher.decrypt(encrypted0, encrypted1, encrypted2, encrypted3, decrypted32, wordIx);
	
	        // XOR with the IV, and restore network byte-order to obtain the
	        // plaintext
	        decrypted32[wordIx] = ntoh(decrypted32[wordIx] ^ init0);
	        decrypted32[wordIx + 1] = ntoh(decrypted32[wordIx + 1] ^ init1);
	        decrypted32[wordIx + 2] = ntoh(decrypted32[wordIx + 2] ^ init2);
	        decrypted32[wordIx + 3] = ntoh(decrypted32[wordIx + 3] ^ init3);
	
	        // setup the IV for the next round
	        init0 = encrypted0;
	        init1 = encrypted1;
	        init2 = encrypted2;
	        init3 = encrypted3;
	      }
	
	      return decrypted;
	    };
	
	    /**
	     * The `Decrypter` class that manages decryption of AES
	     * data through `AsyncStream` objects and the `decrypt`
	     * function
	     *
	     * @param {Uint8Array} encrypted the encrypted bytes
	     * @param {Uint32Array} key the bytes of the decryption key
	     * @param {Uint32Array} initVector the initialization vector (IV) to
	     * @param {Function} done the function to run when done
	     * @class Decrypter
	     */
	
	    var Decrypter$$1 = function () {
	      function Decrypter$$1(encrypted, key, initVector, done) {
	        classCallCheck$$1(this, Decrypter$$1);
	
	        var step = Decrypter$$1.STEP;
	        var encrypted32 = new Int32Array(encrypted.buffer);
	        var decrypted = new Uint8Array(encrypted.byteLength);
	        var i = 0;
	
	        this.asyncStream_ = new AsyncStream$$1();
	
	        // split up the encryption job and do the individual chunks asynchronously
	        this.asyncStream_.push(this.decryptChunk_(encrypted32.subarray(i, i + step), key, initVector, decrypted));
	        for (i = step; i < encrypted32.length; i += step) {
	          initVector = new Uint32Array([ntoh(encrypted32[i - 4]), ntoh(encrypted32[i - 3]), ntoh(encrypted32[i - 2]), ntoh(encrypted32[i - 1])]);
	          this.asyncStream_.push(this.decryptChunk_(encrypted32.subarray(i, i + step), key, initVector, decrypted));
	        }
	        // invoke the done() callback when everything is finished
	        this.asyncStream_.push(function () {
	          // remove pkcs#7 padding from the decrypted bytes
	          done(null, unpad(decrypted));
	        });
	      }
	
	      /**
	       * a getter for step the maximum number of bytes to process at one time
	       *
	       * @return {Number} the value of step 32000
	       */
	
	      /**
	       * @private
	       */
	      Decrypter$$1.prototype.decryptChunk_ = function decryptChunk_(encrypted, key, initVector, decrypted) {
	        return function () {
	          var bytes = decrypt$$1(encrypted, key, initVector);
	
	          decrypted.set(bytes, encrypted.byteOffset);
	        };
	      };
	
	      createClass$$1(Decrypter$$1, null, [{
	        key: 'STEP',
	        get: function get$$1() {
	          // 4 * 8000;
	          return 32000;
	        }
	      }]);
	      return Decrypter$$1;
	    }();
	
	    /**
	     * @file bin-utils.js
	     */
	
	    /**
	     * Creates an object for sending to a web worker modifying properties that are TypedArrays
	     * into a new object with seperated properties for the buffer, byteOffset, and byteLength.
	     *
	     * @param {Object} message
	     *        Object of properties and values to send to the web worker
	     * @return {Object}
	     *         Modified message with TypedArray values expanded
	     * @function createTransferableMessage
	     */
	    var createTransferableMessage = function createTransferableMessage(message) {
	      var transferable = {};
	
	      Object.keys(message).forEach(function (key) {
	        var value = message[key];
	
	        if (ArrayBuffer.isView(value)) {
	          transferable[key] = {
	            bytes: value.buffer,
	            byteOffset: value.byteOffset,
	            byteLength: value.byteLength
	          };
	        } else {
	          transferable[key] = value;
	        }
	      });
	
	      return transferable;
	    };
	
	    /**
	     * Our web worker interface so that things can talk to aes-decrypter
	     * that will be running in a web worker. the scope is passed to this by
	     * webworkify.
	     *
	     * @param {Object} self
	     *        the scope for the web worker
	     */
	    var DecrypterWorker = function DecrypterWorker(self) {
	      self.onmessage = function (event) {
	        var data = event.data;
	        var encrypted = new Uint8Array(data.encrypted.bytes, data.encrypted.byteOffset, data.encrypted.byteLength);
	        var key = new Uint32Array(data.key.bytes, data.key.byteOffset, data.key.byteLength / 4);
	        var iv = new Uint32Array(data.iv.bytes, data.iv.byteOffset, data.iv.byteLength / 4);
	
	        /* eslint-disable no-new, handle-callback-err */
	        new Decrypter$$1(encrypted, key, iv, function (err, bytes) {
	          self.postMessage(createTransferableMessage({
	            source: data.source,
	            decrypted: bytes
	          }), [bytes.buffer]);
	        });
	        /* eslint-enable */
	      };
	    };
	
	    var decrypterWorker = new DecrypterWorker(self);
	
	    return decrypterWorker;
	  }();
	});
	
	/**
	 * Convert the properties of an HLS track into an audioTrackKind.
	 *
	 * @private
	 */
	var audioTrackKind_ = function audioTrackKind_(properties) {
	  var kind = properties.default ? 'main' : 'alternative';
	
	  if (properties.characteristics && properties.characteristics.indexOf('public.accessibility.describes-video') >= 0) {
	    kind = 'main-desc';
	  }
	
	  return kind;
	};
	
	/**
	 * Pause provided segment loader and playlist loader if active
	 *
	 * @param {SegmentLoader} segmentLoader
	 *        SegmentLoader to pause
	 * @param {Object} mediaType
	 *        Active media type
	 * @function stopLoaders
	 */
	var stopLoaders = function stopLoaders(segmentLoader, mediaType) {
	  segmentLoader.abort();
	  segmentLoader.pause();
	
	  if (mediaType && mediaType.activePlaylistLoader) {
	    mediaType.activePlaylistLoader.pause();
	    mediaType.activePlaylistLoader = null;
	  }
	};
	
	/**
	 * Start loading provided segment loader and playlist loader
	 *
	 * @param {PlaylistLoader} playlistLoader
	 *        PlaylistLoader to start loading
	 * @param {Object} mediaType
	 *        Active media type
	 * @function startLoaders
	 */
	var startLoaders = function startLoaders(playlistLoader, mediaType) {
	  // Segment loader will be started after `loadedmetadata` or `loadedplaylist` from the
	  // playlist loader
	  mediaType.activePlaylistLoader = playlistLoader;
	  playlistLoader.load();
	};
	
	/**
	 * Returns a function to be called when the media group changes. It performs a
	 * non-destructive (preserve the buffer) resync of the SegmentLoader. This is because a
	 * change of group is merely a rendition switch of the same content at another encoding,
	 * rather than a change of content, such as switching audio from English to Spanish.
	 *
	 * @param {String} type
	 *        MediaGroup type
	 * @param {Object} settings
	 *        Object containing required information for media groups
	 * @return {Function}
	 *         Handler for a non-destructive resync of SegmentLoader when the active media
	 *         group changes.
	 * @function onGroupChanged
	 */
	var onGroupChanged = function onGroupChanged(type, settings) {
	  return function () {
	    var _settings$segmentLoad = settings.segmentLoaders,
	        segmentLoader = _settings$segmentLoad[type],
	        mainSegmentLoader = _settings$segmentLoad.main,
	        mediaType = settings.mediaTypes[type];
	
	    var activeTrack = mediaType.activeTrack();
	    var activeGroup = mediaType.activeGroup(activeTrack);
	    var previousActiveLoader = mediaType.activePlaylistLoader;
	
	    stopLoaders(segmentLoader, mediaType);
	
	    if (!activeGroup) {
	      // there is no group active
	      return;
	    }
	
	    if (!activeGroup.playlistLoader) {
	      if (previousActiveLoader) {
	        // The previous group had a playlist loader but the new active group does not
	        // this means we are switching from demuxed to muxed audio. In this case we want to
	        // do a destructive reset of the main segment loader and not restart the audio
	        // loaders.
	        mainSegmentLoader.resetEverything();
	      }
	      return;
	    }
	
	    // Non-destructive resync
	    segmentLoader.resyncLoader();
	
	    startLoaders(activeGroup.playlistLoader, mediaType);
	  };
	};
	
	/**
	 * Returns a function to be called when the media track changes. It performs a
	 * destructive reset of the SegmentLoader to ensure we start loading as close to
	 * currentTime as possible.
	 *
	 * @param {String} type
	 *        MediaGroup type
	 * @param {Object} settings
	 *        Object containing required information for media groups
	 * @return {Function}
	 *         Handler for a destructive reset of SegmentLoader when the active media
	 *         track changes.
	 * @function onTrackChanged
	 */
	var onTrackChanged = function onTrackChanged(type, settings) {
	  return function () {
	    var _settings$segmentLoad2 = settings.segmentLoaders,
	        segmentLoader = _settings$segmentLoad2[type],
	        mainSegmentLoader = _settings$segmentLoad2.main,
	        mediaType = settings.mediaTypes[type];
	
	    var activeTrack = mediaType.activeTrack();
	    var activeGroup = mediaType.activeGroup(activeTrack);
	    var previousActiveLoader = mediaType.activePlaylistLoader;
	
	    stopLoaders(segmentLoader, mediaType);
	
	    if (!activeGroup) {
	      // there is no group active so we do not want to restart loaders
	      return;
	    }
	
	    if (!activeGroup.playlistLoader) {
	      // when switching from demuxed audio/video to muxed audio/video (noted by no playlist
	      // loader for the audio group), we want to do a destructive reset of the main segment
	      // loader and not restart the audio loaders
	      mainSegmentLoader.resetEverything();
	      return;
	    }
	
	    if (previousActiveLoader === activeGroup.playlistLoader) {
	      // Nothing has actually changed. This can happen because track change events can fire
	      // multiple times for a "single" change. One for enabling the new active track, and
	      // one for disabling the track that was active
	      startLoaders(activeGroup.playlistLoader, mediaType);
	      return;
	    }
	
	    if (segmentLoader.track) {
	      // For WebVTT, set the new text track in the segmentloader
	      segmentLoader.track(activeTrack);
	    }
	
	    // destructive reset
	    segmentLoader.resetEverything();
	
	    startLoaders(activeGroup.playlistLoader, mediaType);
	  };
	};
	
	var onError = {
	  /**
	   * Returns a function to be called when a SegmentLoader or PlaylistLoader encounters
	   * an error.
	   *
	   * @param {String} type
	   *        MediaGroup type
	   * @param {Object} settings
	   *        Object containing required information for media groups
	   * @return {Function}
	   *         Error handler. Logs warning (or error if the playlist is blacklisted) to
	   *         console and switches back to default audio track.
	   * @function onError.AUDIO
	   */
	  AUDIO: function AUDIO(type, settings) {
	    return function () {
	      var segmentLoader = settings.segmentLoaders[type],
	          mediaType = settings.mediaTypes[type],
	          blacklistCurrentPlaylist = settings.blacklistCurrentPlaylist;
	
	      stopLoaders(segmentLoader, mediaType);
	
	      // switch back to default audio track
	      var activeTrack = mediaType.activeTrack();
	      var activeGroup = mediaType.activeGroup();
	      var id = (activeGroup.filter(function (group) {
	        return group.default;
	      })[0] || activeGroup[0]).id;
	      var defaultTrack = mediaType.tracks[id];
	
	      if (activeTrack === defaultTrack) {
	        // Default track encountered an error. All we can do now is blacklist the current
	        // rendition and hope another will switch audio groups
	        blacklistCurrentPlaylist({
	          message: 'Problem encountered loading the default audio track.'
	        });
	        return;
	      }
	
	      videojs$1.log.warn('Problem encountered loading the alternate audio track.' + 'Switching back to default.');
	
	      for (var trackId in mediaType.tracks) {
	        mediaType.tracks[trackId].enabled = mediaType.tracks[trackId] === defaultTrack;
	      }
	
	      mediaType.onTrackChanged();
	    };
	  },
	  /**
	   * Returns a function to be called when a SegmentLoader or PlaylistLoader encounters
	   * an error.
	   *
	   * @param {String} type
	   *        MediaGroup type
	   * @param {Object} settings
	   *        Object containing required information for media groups
	   * @return {Function}
	   *         Error handler. Logs warning to console and disables the active subtitle track
	   * @function onError.SUBTITLES
	   */
	  SUBTITLES: function SUBTITLES(type, settings) {
	    return function () {
	      var segmentLoader = settings.segmentLoaders[type],
	          mediaType = settings.mediaTypes[type];
	
	      videojs$1.log.warn('Problem encountered loading the subtitle track.' + 'Disabling subtitle track.');
	
	      stopLoaders(segmentLoader, mediaType);
	
	      var track = mediaType.activeTrack();
	
	      if (track) {
	        track.mode = 'disabled';
	      }
	
	      mediaType.onTrackChanged();
	    };
	  }
	};
	
	var setupListeners = {
	  /**
	   * Setup event listeners for audio playlist loader
	   *
	   * @param {String} type
	   *        MediaGroup type
	   * @param {PlaylistLoader|null} playlistLoader
	   *        PlaylistLoader to register listeners on
	   * @param {Object} settings
	   *        Object containing required information for media groups
	   * @function setupListeners.AUDIO
	   */
	  AUDIO: function AUDIO(type, playlistLoader, settings) {
	    if (!playlistLoader) {
	      // no playlist loader means audio will be muxed with the video
	      return;
	    }
	
	    var tech = settings.tech,
	        requestOptions = settings.requestOptions,
	        segmentLoader = settings.segmentLoaders[type];
	
	    playlistLoader.on('loadedmetadata', function () {
	      var media = playlistLoader.media();
	
	      segmentLoader.playlist(media, requestOptions);
	
	      // if the video is already playing, or if this isn't a live video and preload
	      // permits, start downloading segments
	      if (!tech.paused() || media.endList && tech.preload() !== 'none') {
	        segmentLoader.load();
	      }
	    });
	
	    playlistLoader.on('loadedplaylist', function () {
	      segmentLoader.playlist(playlistLoader.media(), requestOptions);
	
	      // If the player isn't paused, ensure that the segment loader is running
	      if (!tech.paused()) {
	        segmentLoader.load();
	      }
	    });
	
	    playlistLoader.on('error', onError[type](type, settings));
	  },
	  /**
	   * Setup event listeners for subtitle playlist loader
	   *
	   * @param {String} type
	   *        MediaGroup type
	   * @param {PlaylistLoader|null} playlistLoader
	   *        PlaylistLoader to register listeners on
	   * @param {Object} settings
	   *        Object containing required information for media groups
	   * @function setupListeners.SUBTITLES
	   */
	  SUBTITLES: function SUBTITLES(type, playlistLoader, settings) {
	    var tech = settings.tech,
	        requestOptions = settings.requestOptions,
	        segmentLoader = settings.segmentLoaders[type],
	        mediaType = settings.mediaTypes[type];
	
	    playlistLoader.on('loadedmetadata', function () {
	      var media = playlistLoader.media();
	
	      segmentLoader.playlist(media, requestOptions);
	      segmentLoader.track(mediaType.activeTrack());
	
	      // if the video is already playing, or if this isn't a live video and preload
	      // permits, start downloading segments
	      if (!tech.paused() || media.endList && tech.preload() !== 'none') {
	        segmentLoader.load();
	      }
	    });
	
	    playlistLoader.on('loadedplaylist', function () {
	      segmentLoader.playlist(playlistLoader.media(), requestOptions);
	
	      // If the player isn't paused, ensure that the segment loader is running
	      if (!tech.paused()) {
	        segmentLoader.load();
	      }
	    });
	
	    playlistLoader.on('error', onError[type](type, settings));
	  }
	};
	
	var byGroupId = function byGroupId(type, groupId) {
	  return function (playlist) {
	    return playlist.attributes[type] === groupId;
	  };
	};
	
	var byResolvedUri = function byResolvedUri(resolvedUri) {
	  return function (playlist) {
	    return playlist.resolvedUri === resolvedUri;
	  };
	};
	
	var initialize = {
	  /**
	   * Setup PlaylistLoaders and AudioTracks for the audio groups
	   *
	   * @param {String} type
	   *        MediaGroup type
	   * @param {Object} settings
	   *        Object containing required information for media groups
	   * @function initialize.AUDIO
	   */
	  'AUDIO': function AUDIO(type, settings) {
	    var hls = settings.hls,
	        sourceType = settings.sourceType,
	        segmentLoader = settings.segmentLoaders[type],
	        withCredentials = settings.requestOptions.withCredentials,
	        _settings$master = settings.master,
	        mediaGroups = _settings$master.mediaGroups,
	        playlists = _settings$master.playlists,
	        _settings$mediaTypes$ = settings.mediaTypes[type],
	        groups = _settings$mediaTypes$.groups,
	        tracks = _settings$mediaTypes$.tracks,
	        masterPlaylistLoader = settings.masterPlaylistLoader;
	
	    // force a default if we have none
	
	    if (!mediaGroups[type] || Object.keys(mediaGroups[type]).length === 0) {
	      mediaGroups[type] = { main: { default: { default: true } } };
	    }
	
	    for (var groupId in mediaGroups[type]) {
	      if (!groups[groupId]) {
	        groups[groupId] = [];
	      }
	
	      // List of playlists that have an AUDIO attribute value matching the current
	      // group ID
	      var groupPlaylists = playlists.filter(byGroupId(type, groupId));
	
	      for (var variantLabel in mediaGroups[type][groupId]) {
	        var properties = mediaGroups[type][groupId][variantLabel];
	
	        // List of playlists for the current group ID that have a matching uri with
	        // this alternate audio variant
	        var matchingPlaylists = groupPlaylists.filter(byResolvedUri(properties.resolvedUri));
	
	        if (matchingPlaylists.length) {
	          // If there is a playlist that has the same uri as this audio variant, assume
	          // that the playlist is audio only. We delete the resolvedUri property here
	          // to prevent a playlist loader from being created so that we don't have
	          // both the main and audio segment loaders loading the same audio segments
	          // from the same playlist.
	          delete properties.resolvedUri;
	        }
	
	        var playlistLoader = void 0;
	
	        if (properties.resolvedUri) {
	          playlistLoader = new PlaylistLoader(properties.resolvedUri, hls, withCredentials);
	        } else if (properties.playlists && sourceType === 'dash') {
	          playlistLoader = new DashPlaylistLoader(properties.playlists[0], hls, withCredentials, masterPlaylistLoader);
	        } else {
	          // no resolvedUri means the audio is muxed with the video when using this
	          // audio track
	          playlistLoader = null;
	        }
	
	        properties = videojs$1.mergeOptions({ id: variantLabel, playlistLoader: playlistLoader }, properties);
	
	        setupListeners[type](type, properties.playlistLoader, settings);
	
	        groups[groupId].push(properties);
	
	        if (typeof tracks[variantLabel] === 'undefined') {
	          var track = new videojs$1.AudioTrack({
	            id: variantLabel,
	            kind: audioTrackKind_(properties),
	            enabled: false,
	            language: properties.language,
	            default: properties.default,
	            label: variantLabel
	          });
	
	          tracks[variantLabel] = track;
	        }
	      }
	    }
	
	    // setup single error event handler for the segment loader
	    segmentLoader.on('error', onError[type](type, settings));
	  },
	  /**
	   * Setup PlaylistLoaders and TextTracks for the subtitle groups
	   *
	   * @param {String} type
	   *        MediaGroup type
	   * @param {Object} settings
	   *        Object containing required information for media groups
	   * @function initialize.SUBTITLES
	   */
	  'SUBTITLES': function SUBTITLES(type, settings) {
	    var tech = settings.tech,
	        hls = settings.hls,
	        sourceType = settings.sourceType,
	        segmentLoader = settings.segmentLoaders[type],
	        withCredentials = settings.requestOptions.withCredentials,
	        mediaGroups = settings.master.mediaGroups,
	        _settings$mediaTypes$2 = settings.mediaTypes[type],
	        groups = _settings$mediaTypes$2.groups,
	        tracks = _settings$mediaTypes$2.tracks,
	        masterPlaylistLoader = settings.masterPlaylistLoader;
	
	    for (var groupId in mediaGroups[type]) {
	      if (!groups[groupId]) {
	        groups[groupId] = [];
	      }
	
	      for (var variantLabel in mediaGroups[type][groupId]) {
	        if (mediaGroups[type][groupId][variantLabel].forced) {
	          // Subtitle playlists with the forced attribute are not selectable in Safari.
	          // According to Apple's HLS Authoring Specification:
	          //   If content has forced subtitles and regular subtitles in a given language,
	          //   the regular subtitles track in that language MUST contain both the forced
	          //   subtitles and the regular subtitles for that language.
	          // Because of this requirement and that Safari does not add forced subtitles,
	          // forced subtitles are skipped here to maintain consistent experience across
	          // all platforms
	          continue;
	        }
	
	        var properties = mediaGroups[type][groupId][variantLabel];
	
	        var playlistLoader = void 0;
	
	        if (sourceType === 'hls') {
	          playlistLoader = new PlaylistLoader(properties.resolvedUri, hls, withCredentials);
	        } else if (sourceType === 'dash') {
	          playlistLoader = new DashPlaylistLoader(properties.playlists[0], hls, withCredentials, masterPlaylistLoader);
	        }
	
	        properties = videojs$1.mergeOptions({
	          id: variantLabel,
	          playlistLoader: playlistLoader
	        }, properties);
	
	        setupListeners[type](type, properties.playlistLoader, settings);
	
	        groups[groupId].push(properties);
	
	        if (typeof tracks[variantLabel] === 'undefined') {
	          var track = tech.addRemoteTextTrack({
	            id: variantLabel,
	            kind: 'subtitles',
	            enabled: false,
	            language: properties.language,
	            label: variantLabel
	          }, false).track;
	
	          tracks[variantLabel] = track;
	        }
	      }
	    }
	
	    // setup single error event handler for the segment loader
	    segmentLoader.on('error', onError[type](type, settings));
	  },
	  /**
	   * Setup TextTracks for the closed-caption groups
	   *
	   * @param {String} type
	   *        MediaGroup type
	   * @param {Object} settings
	   *        Object containing required information for media groups
	   * @function initialize['CLOSED-CAPTIONS']
	   */
	  'CLOSED-CAPTIONS': function CLOSEDCAPTIONS(type, settings) {
	    var tech = settings.tech,
	        mediaGroups = settings.master.mediaGroups,
	        _settings$mediaTypes$3 = settings.mediaTypes[type],
	        groups = _settings$mediaTypes$3.groups,
	        tracks = _settings$mediaTypes$3.tracks;
	
	    for (var groupId in mediaGroups[type]) {
	      if (!groups[groupId]) {
	        groups[groupId] = [];
	      }
	
	      for (var variantLabel in mediaGroups[type][groupId]) {
	        var properties = mediaGroups[type][groupId][variantLabel];
	
	        // We only support CEA608 captions for now, so ignore anything that
	        // doesn't use a CCx INSTREAM-ID
	        if (!properties.instreamId.match(/CC\d/)) {
	          continue;
	        }
	
	        // No PlaylistLoader is required for Closed-Captions because the captions are
	        // embedded within the video stream
	        groups[groupId].push(videojs$1.mergeOptions({ id: variantLabel }, properties));
	
	        if (typeof tracks[variantLabel] === 'undefined') {
	          var track = tech.addRemoteTextTrack({
	            id: properties.instreamId,
	            kind: 'captions',
	            enabled: false,
	            language: properties.language,
	            label: variantLabel
	          }, false).track;
	
	          tracks[variantLabel] = track;
	        }
	      }
	    }
	  }
	};
	
	/**
	 * Returns a function used to get the active group of the provided type
	 *
	 * @param {String} type
	 *        MediaGroup type
	 * @param {Object} settings
	 *        Object containing required information for media groups
	 * @return {Function}
	 *         Function that returns the active media group for the provided type. Takes an
	 *         optional parameter {TextTrack} track. If no track is provided, a list of all
	 *         variants in the group, otherwise the variant corresponding to the provided
	 *         track is returned.
	 * @function activeGroup
	 */
	var activeGroup = function activeGroup(type, settings) {
	  return function (track) {
	    var masterPlaylistLoader = settings.masterPlaylistLoader,
	        groups = settings.mediaTypes[type].groups;
	
	    var media = masterPlaylistLoader.media();
	
	    if (!media) {
	      return null;
	    }
	
	    var variants = null;
	
	    if (media.attributes[type]) {
	      variants = groups[media.attributes[type]];
	    }
	
	    variants = variants || groups.main;
	
	    if (typeof track === 'undefined') {
	      return variants;
	    }
	
	    if (track === null) {
	      // An active track was specified so a corresponding group is expected. track === null
	      // means no track is currently active so there is no corresponding group
	      return null;
	    }
	
	    return variants.filter(function (props) {
	      return props.id === track.id;
	    })[0] || null;
	  };
	};
	
	var activeTrack = {
	  /**
	   * Returns a function used to get the active track of type provided
	   *
	   * @param {String} type
	   *        MediaGroup type
	   * @param {Object} settings
	   *        Object containing required information for media groups
	   * @return {Function}
	   *         Function that returns the active media track for the provided type. Returns
	   *         null if no track is active
	   * @function activeTrack.AUDIO
	   */
	  AUDIO: function AUDIO(type, settings) {
	    return function () {
	      var tracks = settings.mediaTypes[type].tracks;
	
	      for (var id in tracks) {
	        if (tracks[id].enabled) {
	          return tracks[id];
	        }
	      }
	
	      return null;
	    };
	  },
	  /**
	   * Returns a function used to get the active track of type provided
	   *
	   * @param {String} type
	   *        MediaGroup type
	   * @param {Object} settings
	   *        Object containing required information for media groups
	   * @return {Function}
	   *         Function that returns the active media track for the provided type. Returns
	   *         null if no track is active
	   * @function activeTrack.SUBTITLES
	   */
	  SUBTITLES: function SUBTITLES(type, settings) {
	    return function () {
	      var tracks = settings.mediaTypes[type].tracks;
	
	      for (var id in tracks) {
	        if (tracks[id].mode === 'showing') {
	          return tracks[id];
	        }
	      }
	
	      return null;
	    };
	  }
	};
	
	/**
	 * Setup PlaylistLoaders and Tracks for media groups (Audio, Subtitles,
	 * Closed-Captions) specified in the master manifest.
	 *
	 * @param {Object} settings
	 *        Object containing required information for setting up the media groups
	 * @param {SegmentLoader} settings.segmentLoaders.AUDIO
	 *        Audio segment loader
	 * @param {SegmentLoader} settings.segmentLoaders.SUBTITLES
	 *        Subtitle segment loader
	 * @param {SegmentLoader} settings.segmentLoaders.main
	 *        Main segment loader
	 * @param {Tech} settings.tech
	 *        The tech of the player
	 * @param {Object} settings.requestOptions
	 *        XHR request options used by the segment loaders
	 * @param {PlaylistLoader} settings.masterPlaylistLoader
	 *        PlaylistLoader for the master source
	 * @param {HlsHandler} settings.hls
	 *        HLS SourceHandler
	 * @param {Object} settings.master
	 *        The parsed master manifest
	 * @param {Object} settings.mediaTypes
	 *        Object to store the loaders, tracks, and utility methods for each media type
	 * @param {Function} settings.blacklistCurrentPlaylist
	 *        Blacklists the current rendition and forces a rendition switch.
	 * @function setupMediaGroups
	 */
	var setupMediaGroups = function setupMediaGroups(settings) {
	  ['AUDIO', 'SUBTITLES', 'CLOSED-CAPTIONS'].forEach(function (type) {
	    initialize[type](type, settings);
	  });
	
	  var mediaTypes = settings.mediaTypes,
	      masterPlaylistLoader = settings.masterPlaylistLoader,
	      tech = settings.tech,
	      hls = settings.hls;
	
	  // setup active group and track getters and change event handlers
	
	  ['AUDIO', 'SUBTITLES'].forEach(function (type) {
	    mediaTypes[type].activeGroup = activeGroup(type, settings);
	    mediaTypes[type].activeTrack = activeTrack[type](type, settings);
	    mediaTypes[type].onGroupChanged = onGroupChanged(type, settings);
	    mediaTypes[type].onTrackChanged = onTrackChanged(type, settings);
	  });
	
	  // DO NOT enable the default subtitle or caption track.
	  // DO enable the default audio track
	  var audioGroup = mediaTypes.AUDIO.activeGroup();
	  var groupId = (audioGroup.filter(function (group) {
	    return group.default;
	  })[0] || audioGroup[0]).id;
	
	  mediaTypes.AUDIO.tracks[groupId].enabled = true;
	  mediaTypes.AUDIO.onTrackChanged();
	
	  masterPlaylistLoader.on('mediachange', function () {
	    ['AUDIO', 'SUBTITLES'].forEach(function (type) {
	      return mediaTypes[type].onGroupChanged();
	    });
	  });
	
	  // custom audio track change event handler for usage event
	  var onAudioTrackChanged = function onAudioTrackChanged() {
	    mediaTypes.AUDIO.onTrackChanged();
	    tech.trigger({ type: 'usage', name: 'hls-audio-change' });
	  };
	
	  tech.audioTracks().addEventListener('change', onAudioTrackChanged);
	  tech.remoteTextTracks().addEventListener('change', mediaTypes.SUBTITLES.onTrackChanged);
	
	  hls.on('dispose', function () {
	    tech.audioTracks().removeEventListener('change', onAudioTrackChanged);
	    tech.remoteTextTracks().removeEventListener('change', mediaTypes.SUBTITLES.onTrackChanged);
	  });
	
	  // clear existing audio tracks and add the ones we just created
	  tech.clearTracks('audio');
	
	  for (var id in mediaTypes.AUDIO.tracks) {
	    tech.audioTracks().addTrack(mediaTypes.AUDIO.tracks[id]);
	  }
	};
	
	/**
	 * Creates skeleton object used to store the loaders, tracks, and utility methods for each
	 * media type
	 *
	 * @return {Object}
	 *         Object to store the loaders, tracks, and utility methods for each media type
	 * @function createMediaTypes
	 */
	var createMediaTypes = function createMediaTypes() {
	  var mediaTypes = {};
	
	  ['AUDIO', 'SUBTITLES', 'CLOSED-CAPTIONS'].forEach(function (type) {
	    mediaTypes[type] = {
	      groups: {},
	      tracks: {},
	      activePlaylistLoader: null,
	      activeGroup: noop,
	      activeTrack: noop,
	      onGroupChanged: noop,
	      onTrackChanged: noop
	    };
	  });
	
	  return mediaTypes;
	};
	
	/**
	 * @file master-playlist-controller.js
	 */
	
	var ABORT_EARLY_BLACKLIST_SECONDS = 60 * 2;
	
	var Hls = void 0;
	
	// SegmentLoader stats that need to have each loader's
	// values summed to calculate the final value
	var loaderStats = ['mediaRequests', 'mediaRequestsAborted', 'mediaRequestsTimedout', 'mediaRequestsErrored', 'mediaTransferDuration', 'mediaBytesTransferred'];
	var sumLoaderStat = function sumLoaderStat(stat) {
	  return this.audioSegmentLoader_[stat] + this.mainSegmentLoader_[stat];
	};
	
	/**
	 * the master playlist controller controller all interactons
	 * between playlists and segmentloaders. At this time this mainly
	 * involves a master playlist and a series of audio playlists
	 * if they are available
	 *
	 * @class MasterPlaylistController
	 * @extends videojs.EventTarget
	 */
	var MasterPlaylistController = function (_videojs$EventTarget) {
	  inherits$1(MasterPlaylistController, _videojs$EventTarget);
	
	  function MasterPlaylistController(options) {
	    classCallCheck$1(this, MasterPlaylistController);
	
	    var _this = possibleConstructorReturn$1(this, (MasterPlaylistController.__proto__ || Object.getPrototypeOf(MasterPlaylistController)).call(this));
	
	    var url = options.url,
	        withCredentials = options.withCredentials,
	        tech = options.tech,
	        bandwidth = options.bandwidth,
	        externHls = options.externHls,
	        useCueTags = options.useCueTags,
	        blacklistDuration = options.blacklistDuration,
	        enableLowInitialPlaylist = options.enableLowInitialPlaylist,
	        sourceType = options.sourceType,
	        seekTo = options.seekTo;
	
	    if (!url) {
	      throw new Error('A non-empty playlist URL is required');
	    }
	
	    Hls = externHls;
	
	    _this.withCredentials = withCredentials;
	    _this.tech_ = tech;
	    _this.hls_ = tech.hls;
	    _this.seekTo_ = seekTo;
	    _this.sourceType_ = sourceType;
	    _this.useCueTags_ = useCueTags;
	    _this.blacklistDuration = blacklistDuration;
	    _this.enableLowInitialPlaylist = enableLowInitialPlaylist;
	    if (_this.useCueTags_) {
	      _this.cueTagsTrack_ = _this.tech_.addTextTrack('metadata', 'ad-cues');
	      _this.cueTagsTrack_.inBandMetadataTrackDispatchType = '';
	    }
	
	    _this.requestOptions_ = {
	      withCredentials: _this.withCredentials,
	      timeout: null
	    };
	
	    _this.mediaTypes_ = createMediaTypes();
	
	    _this.mediaSource = new videojs$1.MediaSource();
	
	    // load the media source into the player
	    _this.mediaSource.addEventListener('sourceopen', _this.handleSourceOpen_.bind(_this));
	
	    _this.seekable_ = videojs$1.createTimeRanges();
	    _this.hasPlayed_ = function () {
	      return false;
	    };
	
	    _this.syncController_ = new SyncController(options);
	    _this.segmentMetadataTrack_ = tech.addRemoteTextTrack({
	      kind: 'metadata',
	      label: 'segment-metadata'
	    }, false).track;
	
	    _this.decrypter_ = new Decrypter$1();
	    _this.inbandTextTracks_ = {};
	
	    var segmentLoaderSettings = {
	      hls: _this.hls_,
	      mediaSource: _this.mediaSource,
	      currentTime: _this.tech_.currentTime.bind(_this.tech_),
	      seekable: function seekable$$1() {
	        return _this.seekable();
	      },
	      seeking: function seeking() {
	        return _this.tech_.seeking();
	      },
	      duration: function duration$$1() {
	        return _this.mediaSource.duration;
	      },
	      hasPlayed: function hasPlayed() {
	        return _this.hasPlayed_();
	      },
	      goalBufferLength: function goalBufferLength() {
	        return _this.goalBufferLength();
	      },
	      bandwidth: bandwidth,
	      syncController: _this.syncController_,
	      decrypter: _this.decrypter_,
	      sourceType: _this.sourceType_,
	      inbandTextTracks: _this.inbandTextTracks_
	    };
	
	    _this.masterPlaylistLoader_ = _this.sourceType_ === 'dash' ? new DashPlaylistLoader(url, _this.hls_, _this.withCredentials) : new PlaylistLoader(url, _this.hls_, _this.withCredentials);
	    _this.setupMasterPlaylistLoaderListeners_();
	
	    // setup segment loaders
	    // combined audio/video or just video when alternate audio track is selected
	    _this.mainSegmentLoader_ = new SegmentLoader(videojs$1.mergeOptions(segmentLoaderSettings, {
	      segmentMetadataTrack: _this.segmentMetadataTrack_,
	      loaderType: 'main'
	    }), options);
	
	    // alternate audio track
	    _this.audioSegmentLoader_ = new SegmentLoader(videojs$1.mergeOptions(segmentLoaderSettings, {
	      loaderType: 'audio'
	    }), options);
	
	    _this.subtitleSegmentLoader_ = new VTTSegmentLoader(videojs$1.mergeOptions(segmentLoaderSettings, {
	      loaderType: 'vtt'
	    }), options);
	
	    _this.setupSegmentLoaderListeners_();
	
	    // Create SegmentLoader stat-getters
	    loaderStats.forEach(function (stat) {
	      _this[stat + '_'] = sumLoaderStat.bind(_this, stat);
	    });
	
	    _this.logger_ = logger('MPC');
	
	    _this.masterPlaylistLoader_.load();
	    return _this;
	  }
	
	  /**
	   * Register event handlers on the master playlist loader. A helper
	   * function for construction time.
	   *
	   * @private
	   */
	
	  createClass$1(MasterPlaylistController, [{
	    key: 'setupMasterPlaylistLoaderListeners_',
	    value: function setupMasterPlaylistLoaderListeners_() {
	      var _this2 = this;
	
	      this.masterPlaylistLoader_.on('loadedmetadata', function () {
	        var media = _this2.masterPlaylistLoader_.media();
	        var requestTimeout = _this2.masterPlaylistLoader_.targetDuration * 1.5 * 1000;
	
	        // If we don't have any more available playlists, we don't want to
	        // timeout the request.
	        if (isLowestEnabledRendition(_this2.masterPlaylistLoader_.master, _this2.masterPlaylistLoader_.media())) {
	          _this2.requestOptions_.timeout = 0;
	        } else {
	          _this2.requestOptions_.timeout = requestTimeout;
	        }
	
	        // if this isn't a live video and preload permits, start
	        // downloading segments
	        if (media.endList && _this2.tech_.preload() !== 'none') {
	          _this2.mainSegmentLoader_.playlist(media, _this2.requestOptions_);
	          _this2.mainSegmentLoader_.load();
	        }
	
	        setupMediaGroups({
	          sourceType: _this2.sourceType_,
	          segmentLoaders: {
	            AUDIO: _this2.audioSegmentLoader_,
	            SUBTITLES: _this2.subtitleSegmentLoader_,
	            main: _this2.mainSegmentLoader_
	          },
	          tech: _this2.tech_,
	          requestOptions: _this2.requestOptions_,
	          masterPlaylistLoader: _this2.masterPlaylistLoader_,
	          hls: _this2.hls_,
	          master: _this2.master(),
	          mediaTypes: _this2.mediaTypes_,
	          blacklistCurrentPlaylist: _this2.blacklistCurrentPlaylist.bind(_this2)
	        });
	
	        _this2.triggerPresenceUsage_(_this2.master(), media);
	
	        try {
	          _this2.setupSourceBuffers_();
	        } catch (e) {
	          videojs$1.log.warn('Failed to create SourceBuffers', e);
	          return _this2.mediaSource.endOfStream('decode');
	        }
	        _this2.setupFirstPlay();
	
	        _this2.trigger('selectedinitialmedia');
	      });
	
	      this.masterPlaylistLoader_.on('loadedplaylist', function () {
	        var updatedPlaylist = _this2.masterPlaylistLoader_.media();
	
	        if (!updatedPlaylist) {
	          // blacklist any variants that are not supported by the browser before selecting
	          // an initial media as the playlist selectors do not consider browser support
	          _this2.excludeUnsupportedVariants_();
	
	          var selectedMedia = void 0;
	
	          if (_this2.enableLowInitialPlaylist) {
	            selectedMedia = _this2.selectInitialPlaylist();
	          }
	
	          if (!selectedMedia) {
	            selectedMedia = _this2.selectPlaylist();
	          }
	
	          _this2.initialMedia_ = selectedMedia;
	          _this2.masterPlaylistLoader_.media(_this2.initialMedia_);
	          return;
	        }
	
	        if (_this2.useCueTags_) {
	          _this2.updateAdCues_(updatedPlaylist);
	        }
	
	        // TODO: Create a new event on the PlaylistLoader that signals
	        // that the segments have changed in some way and use that to
	        // update the SegmentLoader instead of doing it twice here and
	        // on `mediachange`
	        _this2.mainSegmentLoader_.playlist(updatedPlaylist, _this2.requestOptions_);
	        _this2.updateDuration();
	
	        // If the player isn't paused, ensure that the segment loader is running,
	        // as it is possible that it was temporarily stopped while waiting for
	        // a playlist (e.g., in case the playlist errored and we re-requested it).
	        if (!_this2.tech_.paused()) {
	          _this2.mainSegmentLoader_.load();
	          if (_this2.audioSegmentLoader_) {
	            _this2.audioSegmentLoader_.load();
	          }
	        }
	
	        if (!updatedPlaylist.endList) {
	          var addSeekableRange = function addSeekableRange() {
	            var seekable$$1 = _this2.seekable();
	
	            if (seekable$$1.length !== 0) {
	              _this2.mediaSource.addSeekableRange_(seekable$$1.start(0), seekable$$1.end(0));
	            }
	          };
	
	          if (_this2.duration() !== Infinity) {
	            var onDurationchange = function onDurationchange() {
	              if (_this2.duration() === Infinity) {
	                addSeekableRange();
	              } else {
	                _this2.tech_.one('durationchange', onDurationchange);
	              }
	            };
	
	            _this2.tech_.one('durationchange', onDurationchange);
	          } else {
	            addSeekableRange();
	          }
	        }
	      });
	
	      this.masterPlaylistLoader_.on('error', function () {
	        _this2.blacklistCurrentPlaylist(_this2.masterPlaylistLoader_.error);
	      });
	
	      this.masterPlaylistLoader_.on('mediachanging', function () {
	        _this2.mainSegmentLoader_.abort();
	        _this2.mainSegmentLoader_.pause();
	      });
	
	      this.masterPlaylistLoader_.on('mediachange', function () {
	        var media = _this2.masterPlaylistLoader_.media();
	        var requestTimeout = _this2.masterPlaylistLoader_.targetDuration * 1.5 * 1000;
	
	        // If we don't have any more available playlists, we don't want to
	        // timeout the request.
	        if (isLowestEnabledRendition(_this2.masterPlaylistLoader_.master, _this2.masterPlaylistLoader_.media())) {
	          _this2.requestOptions_.timeout = 0;
	        } else {
	          _this2.requestOptions_.timeout = requestTimeout;
	        }
	
	        // TODO: Create a new event on the PlaylistLoader that signals
	        // that the segments have changed in some way and use that to
	        // update the SegmentLoader instead of doing it twice here and
	        // on `loadedplaylist`
	        _this2.mainSegmentLoader_.playlist(media, _this2.requestOptions_);
	
	        _this2.mainSegmentLoader_.load();
	
	        _this2.tech_.trigger({
	          type: 'mediachange',
	          bubbles: true
	        });
	      });
	
	      this.masterPlaylistLoader_.on('playlistunchanged', function () {
	        var updatedPlaylist = _this2.masterPlaylistLoader_.media();
	        var playlistOutdated = _this2.stuckAtPlaylistEnd_(updatedPlaylist);
	
	        if (playlistOutdated) {
	          // Playlist has stopped updating and we're stuck at its end. Try to
	          // blacklist it and switch to another playlist in the hope that that
	          // one is updating (and give the player a chance to re-adjust to the
	          // safe live point).
	          _this2.blacklistCurrentPlaylist({
	            message: 'Playlist no longer updating.'
	          });
	          // useful for monitoring QoS
	          _this2.tech_.trigger('playliststuck');
	        }
	      });
	
	      this.masterPlaylistLoader_.on('renditiondisabled', function () {
	        _this2.tech_.trigger({ type: 'usage', name: 'hls-rendition-disabled' });
	      });
	      this.masterPlaylistLoader_.on('renditionenabled', function () {
	        _this2.tech_.trigger({ type: 'usage', name: 'hls-rendition-enabled' });
	      });
	    }
	
	    /**
	     * A helper function for triggerring presence usage events once per source
	     *
	     * @private
	     */
	
	  }, {
	    key: 'triggerPresenceUsage_',
	    value: function triggerPresenceUsage_(master, media) {
	      var mediaGroups = master.mediaGroups || {};
	      var defaultDemuxed = true;
	      var audioGroupKeys = Object.keys(mediaGroups.AUDIO);
	
	      for (var mediaGroup in mediaGroups.AUDIO) {
	        for (var label in mediaGroups.AUDIO[mediaGroup]) {
	          var properties = mediaGroups.AUDIO[mediaGroup][label];
	
	          if (!properties.uri) {
	            defaultDemuxed = false;
	          }
	        }
	      }
	
	      if (defaultDemuxed) {
	        this.tech_.trigger({ type: 'usage', name: 'hls-demuxed' });
	      }
	
	      if (Object.keys(mediaGroups.SUBTITLES).length) {
	        this.tech_.trigger({ type: 'usage', name: 'hls-webvtt' });
	      }
	
	      if (Hls.Playlist.isAes(media)) {
	        this.tech_.trigger({ type: 'usage', name: 'hls-aes' });
	      }
	
	      if (Hls.Playlist.isFmp4(media)) {
	        this.tech_.trigger({ type: 'usage', name: 'hls-fmp4' });
	      }
	
	      if (audioGroupKeys.length && Object.keys(mediaGroups.AUDIO[audioGroupKeys[0]]).length > 1) {
	        this.tech_.trigger({ type: 'usage', name: 'hls-alternate-audio' });
	      }
	
	      if (this.useCueTags_) {
	        this.tech_.trigger({ type: 'usage', name: 'hls-playlist-cue-tags' });
	      }
	    }
	    /**
	     * Register event handlers on the segment loaders. A helper function
	     * for construction time.
	     *
	     * @private
	     */
	
	  }, {
	    key: 'setupSegmentLoaderListeners_',
	    value: function setupSegmentLoaderListeners_() {
	      var _this3 = this;
	
	      this.mainSegmentLoader_.on('bandwidthupdate', function () {
	        var nextPlaylist = _this3.selectPlaylist();
	        var currentPlaylist = _this3.masterPlaylistLoader_.media();
	        var buffered = _this3.tech_.buffered();
	        var forwardBuffer = buffered.length ? buffered.end(buffered.length - 1) - _this3.tech_.currentTime() : 0;
	
	        var bufferLowWaterLine = _this3.bufferLowWaterLine();
	
	        // If the playlist is live, then we want to not take low water line into account.
	        // This is because in LIVE, the player plays 3 segments from the end of the
	        // playlist, and if `BUFFER_LOW_WATER_LINE` is greater than the duration availble
	        // in those segments, a viewer will never experience a rendition upswitch.
	        if (!currentPlaylist.endList ||
	        // For the same reason as LIVE, we ignore the low water line when the VOD
	        // duration is below the max potential low water line
	        _this3.duration() < Config.MAX_BUFFER_LOW_WATER_LINE ||
	        // we want to switch down to lower resolutions quickly to continue playback, but
	        nextPlaylist.attributes.BANDWIDTH < currentPlaylist.attributes.BANDWIDTH ||
	        // ensure we have some buffer before we switch up to prevent us running out of
	        // buffer while loading a higher rendition.
	        forwardBuffer >= bufferLowWaterLine) {
	          _this3.masterPlaylistLoader_.media(nextPlaylist);
	        }
	
	        _this3.tech_.trigger('bandwidthupdate');
	      });
	      this.mainSegmentLoader_.on('progress', function () {
	        _this3.trigger('progress');
	      });
	
	      this.mainSegmentLoader_.on('error', function () {
	        _this3.blacklistCurrentPlaylist(_this3.mainSegmentLoader_.error());
	      });
	
	      this.mainSegmentLoader_.on('syncinfoupdate', function () {
	        _this3.onSyncInfoUpdate_();
	      });
	
	      this.mainSegmentLoader_.on('timestampoffset', function () {
	        _this3.tech_.trigger({ type: 'usage', name: 'hls-timestamp-offset' });
	      });
	      this.audioSegmentLoader_.on('syncinfoupdate', function () {
	        _this3.onSyncInfoUpdate_();
	      });
	
	      this.mainSegmentLoader_.on('ended', function () {
	        _this3.onEndOfStream();
	      });
	
	      this.mainSegmentLoader_.on('earlyabort', function () {
	        _this3.blacklistCurrentPlaylist({
	          message: 'Aborted early because there isn\'t enough bandwidth to complete the ' + 'request without rebuffering.'
	        }, ABORT_EARLY_BLACKLIST_SECONDS);
	      });
	
	      this.mainSegmentLoader_.on('reseteverything', function () {
	        // If playing an MTS stream, a videojs.MediaSource is listening for
	        // hls-reset to reset caption parsing state in the transmuxer
	        _this3.tech_.trigger('hls-reset');
	      });
	
	      this.mainSegmentLoader_.on('segmenttimemapping', function (event) {
	        // If playing an MTS stream in html, a videojs.MediaSource is listening for
	        // hls-segment-time-mapping update its internal mapping of stream to display time
	        _this3.tech_.trigger({
	          type: 'hls-segment-time-mapping',
	          mapping: event.mapping
	        });
	      });
	
	      this.audioSegmentLoader_.on('ended', function () {
	        _this3.onEndOfStream();
	      });
	    }
	  }, {
	    key: 'mediaSecondsLoaded_',
	    value: function mediaSecondsLoaded_() {
	      return Math.max(this.audioSegmentLoader_.mediaSecondsLoaded + this.mainSegmentLoader_.mediaSecondsLoaded);
	    }
	
	    /**
	     * Call load on our SegmentLoaders
	     */
	
	  }, {
	    key: 'load',
	    value: function load() {
	      this.mainSegmentLoader_.load();
	      if (this.mediaTypes_.AUDIO.activePlaylistLoader) {
	        this.audioSegmentLoader_.load();
	      }
	      if (this.mediaTypes_.SUBTITLES.activePlaylistLoader) {
	        this.subtitleSegmentLoader_.load();
	      }
	    }
	
	    /**
	     * Re-tune playback quality level for the current player
	     * conditions without performing destructive actions, like
	     * removing already buffered content
	     *
	     * @private
	     */
	
	  }, {
	    key: 'smoothQualityChange_',
	    value: function smoothQualityChange_() {
	      var media = this.selectPlaylist();
	
	      if (media !== this.masterPlaylistLoader_.media()) {
	        this.masterPlaylistLoader_.media(media);
	
	        this.mainSegmentLoader_.resetLoader();
	        // don't need to reset audio as it is reset when media changes
	      }
	    }
	
	    /**
	     * Re-tune playback quality level for the current player
	     * conditions. This method will perform destructive actions like removing
	     * already buffered content in order to readjust the currently active
	     * playlist quickly. This is good for manual quality changes
	     *
	     * @private
	     */
	
	  }, {
	    key: 'fastQualityChange_',
	    value: function fastQualityChange_() {
	      var _this4 = this;
	
	      var media = this.selectPlaylist();
	
	      if (media === this.masterPlaylistLoader_.media()) {
	        return;
	      }
	
	      this.masterPlaylistLoader_.media(media);
	
	      // delete all buffered data to allow an immediate quality switch, then seek
	      // in place to give the browser a kick to remove any cached frames from the
	      // previous rendition
	      this.mainSegmentLoader_.resetEverything(function () {
	        // Since this is not a typical seek, we avoid the seekTo method which can cause
	        // segments from the previously enabled rendition to load before the new playlist
	        // has finished loading
	        _this4.tech_.setCurrentTime(_this4.tech_.currentTime());
	      });
	
	      // don't need to reset audio as it is reset when media changes
	    }
	
	    /**
	     * Begin playback.
	     */
	
	  }, {
	    key: 'play',
	    value: function play() {
	      if (this.setupFirstPlay()) {
	        return;
	      }
	
	      if (this.tech_.ended()) {
	        this.seekTo_(0);
	      }
	
	      if (this.hasPlayed_()) {
	        this.load();
	      }
	
	      var seekable$$1 = this.tech_.seekable();
	
	      // if the viewer has paused and we fell out of the live window,
	      // seek forward to the live point
	      if (this.tech_.duration() === Infinity) {
	        if (this.tech_.currentTime() < seekable$$1.start(0)) {
	          return this.seekTo_(seekable$$1.end(seekable$$1.length - 1));
	        }
	      }
	    }
	
	    /**
	     * Seek to the latest media position if this is a live video and the
	     * player and video are loaded and initialized.
	     */
	
	  }, {
	    key: 'setupFirstPlay',
	    value: function setupFirstPlay() {
	      var _this5 = this;
	
	      var media = this.masterPlaylistLoader_.media();
	
	      // Check that everything is ready to begin buffering for the first call to play
	      //  If 1) there is no active media
	      //     2) the player is paused
	      //     3) the first play has already been setup
	      // then exit early
	      if (!media || this.tech_.paused() || this.hasPlayed_()) {
	        return false;
	      }
	
	      // when the video is a live stream
	      if (!media.endList) {
	        var seekable$$1 = this.seekable();
	
	        if (!seekable$$1.length) {
	          // without a seekable range, the player cannot seek to begin buffering at the live
	          // point
	          return false;
	        }
	
	        if (videojs$1.browser.IE_VERSION && this.tech_.readyState() === 0) {
	          // IE11 throws an InvalidStateError if you try to set currentTime while the
	          // readyState is 0, so it must be delayed until the tech fires loadedmetadata.
	          this.tech_.one('loadedmetadata', function () {
	            _this5.trigger('firstplay');
	            _this5.seekTo_(seekable$$1.end(0));
	            _this5.hasPlayed_ = function () {
	              return true;
	            };
	          });
	
	          return false;
	        }
	
	        // trigger firstplay to inform the source handler to ignore the next seek event
	        this.trigger('firstplay');
	        // seek to the live point
	        this.seekTo_(seekable$$1.end(0));
	      }
	
	      this.hasPlayed_ = function () {
	        return true;
	      };
	      // we can begin loading now that everything is ready
	      this.load();
	      return true;
	    }
	
	    /**
	     * handle the sourceopen event on the MediaSource
	     *
	     * @private
	     */
	
	  }, {
	    key: 'handleSourceOpen_',
	    value: function handleSourceOpen_() {
	      // Only attempt to create the source buffer if none already exist.
	      // handleSourceOpen is also called when we are "re-opening" a source buffer
	      // after `endOfStream` has been called (in response to a seek for instance)
	      try {
	        this.setupSourceBuffers_();
	      } catch (e) {
	        videojs$1.log.warn('Failed to create Source Buffers', e);
	        return this.mediaSource.endOfStream('decode');
	      }
	
	      // if autoplay is enabled, begin playback. This is duplicative of
	      // code in video.js but is required because play() must be invoked
	      // *after* the media source has opened.
	      if (this.tech_.autoplay()) {
	        var playPromise = this.tech_.play();
	
	        // Catch/silence error when a pause interrupts a play request
	        // on browsers which return a promise
	        if (typeof playPromise !== 'undefined' && typeof playPromise.then === 'function') {
	          playPromise.then(null, function (e) {});
	        }
	      }
	
	      this.trigger('sourceopen');
	    }
	
	    /**
	     * Calls endOfStream on the media source when all active stream types have called
	     * endOfStream
	     *
	     * @param {string} streamType
	     *        Stream type of the segment loader that called endOfStream
	     * @private
	     */
	
	  }, {
	    key: 'onEndOfStream',
	    value: function onEndOfStream() {
	      var isEndOfStream = this.mainSegmentLoader_.ended_;
	
	      if (this.mediaTypes_.AUDIO.activePlaylistLoader) {
	        // if the audio playlist loader exists, then alternate audio is active
	        if (!this.mainSegmentLoader_.startingMedia_ || this.mainSegmentLoader_.startingMedia_.containsVideo) {
	          // if we do not know if the main segment loader contains video yet or if we
	          // definitively know the main segment loader contains video, then we need to wait
	          // for both main and audio segment loaders to call endOfStream
	          isEndOfStream = isEndOfStream && this.audioSegmentLoader_.ended_;
	        } else {
	          // otherwise just rely on the audio loader
	          isEndOfStream = this.audioSegmentLoader_.ended_;
	        }
	      }
	
	      if (isEndOfStream) {
	        this.mediaSource.endOfStream();
	      }
	    }
	
	    /**
	     * Check if a playlist has stopped being updated
	     * @param {Object} playlist the media playlist object
	     * @return {boolean} whether the playlist has stopped being updated or not
	     */
	
	  }, {
	    key: 'stuckAtPlaylistEnd_',
	    value: function stuckAtPlaylistEnd_(playlist) {
	      var seekable$$1 = this.seekable();
	
	      if (!seekable$$1.length) {
	        // playlist doesn't have enough information to determine whether we are stuck
	        return false;
	      }
	
	      var expired = this.syncController_.getExpiredTime(playlist, this.mediaSource.duration);
	
	      if (expired === null) {
	        return false;
	      }
	
	      // does not use the safe live end to calculate playlist end, since we
	      // don't want to say we are stuck while there is still content
	      var absolutePlaylistEnd = Hls.Playlist.playlistEnd(playlist, expired);
	      var currentTime = this.tech_.currentTime();
	      var buffered = this.tech_.buffered();
	
	      if (!buffered.length) {
	        // return true if the playhead reached the absolute end of the playlist
	        return absolutePlaylistEnd - currentTime <= SAFE_TIME_DELTA;
	      }
	      var bufferedEnd = buffered.end(buffered.length - 1);
	
	      // return true if there is too little buffer left and buffer has reached absolute
	      // end of playlist
	      return bufferedEnd - currentTime <= SAFE_TIME_DELTA && absolutePlaylistEnd - bufferedEnd <= SAFE_TIME_DELTA;
	    }
	
	    /**
	     * Blacklists a playlist when an error occurs for a set amount of time
	     * making it unavailable for selection by the rendition selection algorithm
	     * and then forces a new playlist (rendition) selection.
	     *
	     * @param {Object=} error an optional error that may include the playlist
	     * to blacklist
	     * @param {Number=} blacklistDuration an optional number of seconds to blacklist the
	     * playlist
	     */
	
	  }, {
	    key: 'blacklistCurrentPlaylist',
	    value: function blacklistCurrentPlaylist() {
	      var error = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	      var blacklistDuration = arguments[1];
	
	      var currentPlaylist = void 0;
	      var nextPlaylist = void 0;
	
	      // If the `error` was generated by the playlist loader, it will contain
	      // the playlist we were trying to load (but failed) and that should be
	      // blacklisted instead of the currently selected playlist which is likely
	      // out-of-date in this scenario
	      currentPlaylist = error.playlist || this.masterPlaylistLoader_.media();
	
	      blacklistDuration = blacklistDuration || error.blacklistDuration || this.blacklistDuration;
	
	      // If there is no current playlist, then an error occurred while we were
	      // trying to load the master OR while we were disposing of the tech
	      if (!currentPlaylist) {
	        this.error = error;
	
	        try {
	          return this.mediaSource.endOfStream('network');
	        } catch (e) {
	          return this.trigger('error');
	        }
	      }
	
	      var isFinalRendition = this.masterPlaylistLoader_.master.playlists.filter(isEnabled).length === 1;
	
	      if (isFinalRendition) {
	        // Never blacklisting this playlist because it's final rendition
	        videojs$1.log.warn('Problem encountered with the current ' + 'HLS playlist. Trying again since it is the final playlist.');
	
	        this.tech_.trigger('retryplaylist');
	        return this.masterPlaylistLoader_.load(isFinalRendition);
	      }
	      // Blacklist this playlist
	      currentPlaylist.excludeUntil = Date.now() + blacklistDuration * 1000;
	      this.tech_.trigger('blacklistplaylist');
	      this.tech_.trigger({ type: 'usage', name: 'hls-rendition-blacklisted' });
	
	      // Select a new playlist
	      nextPlaylist = this.selectPlaylist();
	      videojs$1.log.warn('Problem encountered with the current HLS playlist.' + (error.message ? ' ' + error.message : '') + ' Switching to another playlist.');
	
	      return this.masterPlaylistLoader_.media(nextPlaylist);
	    }
	
	    /**
	     * Pause all segment loaders
	     */
	
	  }, {
	    key: 'pauseLoading',
	    value: function pauseLoading() {
	      this.mainSegmentLoader_.pause();
	      if (this.mediaTypes_.AUDIO.activePlaylistLoader) {
	        this.audioSegmentLoader_.pause();
	      }
	      if (this.mediaTypes_.SUBTITLES.activePlaylistLoader) {
	        this.subtitleSegmentLoader_.pause();
	      }
	    }
	
	    /**
	     * set the current time on all segment loaders
	     *
	     * @param {TimeRange} currentTime the current time to set
	     * @return {TimeRange} the current time
	     */
	
	  }, {
	    key: 'setCurrentTime',
	    value: function setCurrentTime(currentTime) {
	      var buffered = findRange(this.tech_.buffered(), currentTime);
	
	      if (!(this.masterPlaylistLoader_ && this.masterPlaylistLoader_.media())) {
	        // return immediately if the metadata is not ready yet
	        return 0;
	      }
	
	      // it's clearly an edge-case but don't thrown an error if asked to
	      // seek within an empty playlist
	      if (!this.masterPlaylistLoader_.media().segments) {
	        return 0;
	      }
	
	      // In flash playback, the segment loaders should be reset on every seek, even
	      // in buffer seeks. If the seek location is already buffered, continue buffering as
	      // usual
	      // TODO: redo this comment
	      if (buffered && buffered.length) {
	        return currentTime;
	      }
	
	      // cancel outstanding requests so we begin buffering at the new
	      // location
	      this.mainSegmentLoader_.resetEverything();
	      this.mainSegmentLoader_.abort();
	      if (this.mediaTypes_.AUDIO.activePlaylistLoader) {
	        this.audioSegmentLoader_.resetEverything();
	        this.audioSegmentLoader_.abort();
	      }
	      if (this.mediaTypes_.SUBTITLES.activePlaylistLoader) {
	        this.subtitleSegmentLoader_.resetEverything();
	        this.subtitleSegmentLoader_.abort();
	      }
	
	      // start segment loader loading in case they are paused
	      this.load();
	    }
	
	    /**
	     * get the current duration
	     *
	     * @return {TimeRange} the duration
	     */
	
	  }, {
	    key: 'duration',
	    value: function duration$$1() {
	      if (!this.masterPlaylistLoader_) {
	        return 0;
	      }
	
	      if (this.mediaSource) {
	        return this.mediaSource.duration;
	      }
	
	      return Hls.Playlist.duration(this.masterPlaylistLoader_.media());
	    }
	
	    /**
	     * check the seekable range
	     *
	     * @return {TimeRange} the seekable range
	     */
	
	  }, {
	    key: 'seekable',
	    value: function seekable$$1() {
	      return this.seekable_;
	    }
	  }, {
	    key: 'onSyncInfoUpdate_',
	    value: function onSyncInfoUpdate_() {
	      var mainSeekable = void 0;
	      var audioSeekable = void 0;
	
	      if (!this.masterPlaylistLoader_) {
	        return;
	      }
	
	      var media = this.masterPlaylistLoader_.media();
	
	      if (!media) {
	        return;
	      }
	
	      var expired = this.syncController_.getExpiredTime(media, this.mediaSource.duration);
	
	      if (expired === null) {
	        // not enough information to update seekable
	        return;
	      }
	
	      mainSeekable = Hls.Playlist.seekable(media, expired);
	
	      if (mainSeekable.length === 0) {
	        return;
	      }
	
	      if (this.mediaTypes_.AUDIO.activePlaylistLoader) {
	        media = this.mediaTypes_.AUDIO.activePlaylistLoader.media();
	        expired = this.syncController_.getExpiredTime(media, this.mediaSource.duration);
	
	        if (expired === null) {
	          return;
	        }
	
	        audioSeekable = Hls.Playlist.seekable(media, expired);
	
	        if (audioSeekable.length === 0) {
	          return;
	        }
	      }
	
	      if (!audioSeekable) {
	        // seekable has been calculated based on buffering video data so it
	        // can be returned directly
	        this.seekable_ = mainSeekable;
	      } else if (audioSeekable.start(0) > mainSeekable.end(0) || mainSeekable.start(0) > audioSeekable.end(0)) {
	        // seekables are pretty far off, rely on main
	        this.seekable_ = mainSeekable;
	      } else {
	        this.seekable_ = videojs$1.createTimeRanges([[audioSeekable.start(0) > mainSeekable.start(0) ? audioSeekable.start(0) : mainSeekable.start(0), audioSeekable.end(0) < mainSeekable.end(0) ? audioSeekable.end(0) : mainSeekable.end(0)]]);
	      }
	
	      this.logger_('seekable updated [' + printableRange(this.seekable_) + ']');
	
	      this.tech_.trigger('seekablechanged');
	    }
	
	    /**
	     * Update the player duration
	     */
	
	  }, {
	    key: 'updateDuration',
	    value: function updateDuration() {
	      var _this6 = this;
	
	      var oldDuration = this.mediaSource.duration;
	      var newDuration = Hls.Playlist.duration(this.masterPlaylistLoader_.media());
	      var buffered = this.tech_.buffered();
	      var setDuration = function setDuration() {
	        _this6.mediaSource.duration = newDuration;
	        _this6.tech_.trigger('durationchange');
	
	        _this6.mediaSource.removeEventListener('sourceopen', setDuration);
	      };
	
	      if (buffered.length > 0) {
	        newDuration = Math.max(newDuration, buffered.end(buffered.length - 1));
	      }
	
	      // if the duration has changed, invalidate the cached value
	      if (oldDuration !== newDuration) {
	        // update the duration
	        if (this.mediaSource.readyState !== 'open') {
	          this.mediaSource.addEventListener('sourceopen', setDuration);
	        } else {
	          setDuration();
	        }
	      }
	    }
	
	    /**
	     * dispose of the MasterPlaylistController and everything
	     * that it controls
	     */
	
	  }, {
	    key: 'dispose',
	    value: function dispose() {
	      var _this7 = this;
	
	      this.decrypter_.terminate();
	      this.masterPlaylistLoader_.dispose();
	      this.mainSegmentLoader_.dispose();
	
	      ['AUDIO', 'SUBTITLES'].forEach(function (type) {
	        var groups = _this7.mediaTypes_[type].groups;
	
	        for (var id in groups) {
	          groups[id].forEach(function (group) {
	            if (group.playlistLoader) {
	              group.playlistLoader.dispose();
	            }
	          });
	        }
	      });
	
	      this.audioSegmentLoader_.dispose();
	      this.subtitleSegmentLoader_.dispose();
	    }
	
	    /**
	     * return the master playlist object if we have one
	     *
	     * @return {Object} the master playlist object that we parsed
	     */
	
	  }, {
	    key: 'master',
	    value: function master() {
	      return this.masterPlaylistLoader_.master;
	    }
	
	    /**
	     * return the currently selected playlist
	     *
	     * @return {Object} the currently selected playlist object that we parsed
	     */
	
	  }, {
	    key: 'media',
	    value: function media() {
	      // playlist loader will not return media if it has not been fully loaded
	      return this.masterPlaylistLoader_.media() || this.initialMedia_;
	    }
	
	    /**
	     * setup our internal source buffers on our segment Loaders
	     *
	     * @private
	     */
	
	  }, {
	    key: 'setupSourceBuffers_',
	    value: function setupSourceBuffers_() {
	      var media = this.masterPlaylistLoader_.media();
	      var mimeTypes = void 0;
	
	      // wait until a media playlist is available and the Media Source is
	      // attached
	      if (!media || this.mediaSource.readyState !== 'open') {
	        return;
	      }
	
	      mimeTypes = mimeTypesForPlaylist(this.masterPlaylistLoader_.master, media);
	      if (mimeTypes.length < 1) {
	        this.error = 'No compatible SourceBuffer configuration for the variant stream:' + media.resolvedUri;
	        return this.mediaSource.endOfStream('decode');
	      }
	
	      this.configureLoaderMimeTypes_(mimeTypes);
	      // exclude any incompatible variant streams from future playlist
	      // selection
	      this.excludeIncompatibleVariants_(media);
	    }
	  }, {
	    key: 'configureLoaderMimeTypes_',
	    value: function configureLoaderMimeTypes_(mimeTypes) {
	      // If the content is demuxed, we can't start appending segments to a source buffer
	      // until both source buffers are set up, or else the browser may not let us add the
	      // second source buffer (it will assume we are playing either audio only or video
	      // only).
	      var sourceBufferEmitter =
	      // If there is more than one mime type
	      mimeTypes.length > 1 &&
	      // and the first mime type does not have muxed video and audio
	      mimeTypes[0].indexOf(',') === -1 &&
	      // and the two mime types are different (they can be the same in the case of audio
	      // only with alternate audio)
	      mimeTypes[0] !== mimeTypes[1] ?
	      // then we want to wait on the second source buffer
	      new videojs$1.EventTarget() :
	      // otherwise there is no need to wait as the content is either audio only,
	      // video only, or muxed content.
	      null;
	
	      this.mainSegmentLoader_.mimeType(mimeTypes[0], sourceBufferEmitter);
	      if (mimeTypes[1]) {
	        this.audioSegmentLoader_.mimeType(mimeTypes[1], sourceBufferEmitter);
	      }
	    }
	
	    /**
	     * Blacklists playlists with codecs that are unsupported by the browser.
	     */
	
	  }, {
	    key: 'excludeUnsupportedVariants_',
	    value: function excludeUnsupportedVariants_() {
	      this.master().playlists.forEach(function (variant) {
	        if (variant.attributes.CODECS && window$1.MediaSource && window$1.MediaSource.isTypeSupported && !window$1.MediaSource.isTypeSupported('video/mp4; codecs="' + mapLegacyAvcCodecs(variant.attributes.CODECS) + '"')) {
	          variant.excludeUntil = Infinity;
	        }
	      });
	    }
	
	    /**
	     * Blacklist playlists that are known to be codec or
	     * stream-incompatible with the SourceBuffer configuration. For
	     * instance, Media Source Extensions would cause the video element to
	     * stall waiting for video data if you switched from a variant with
	     * video and audio to an audio-only one.
	     *
	     * @param {Object} media a media playlist compatible with the current
	     * set of SourceBuffers. Variants in the current master playlist that
	     * do not appear to have compatible codec or stream configurations
	     * will be excluded from the default playlist selection algorithm
	     * indefinitely.
	     * @private
	     */
	
	  }, {
	    key: 'excludeIncompatibleVariants_',
	    value: function excludeIncompatibleVariants_(media) {
	      var codecCount = 2;
	      var videoCodec = null;
	      var codecs = void 0;
	
	      if (media.attributes.CODECS) {
	        codecs = parseCodecs(media.attributes.CODECS);
	        videoCodec = codecs.videoCodec;
	        codecCount = codecs.codecCount;
	      }
	
	      this.master().playlists.forEach(function (variant) {
	        var variantCodecs = {
	          codecCount: 2,
	          videoCodec: null
	        };
	
	        if (variant.attributes.CODECS) {
	          variantCodecs = parseCodecs(variant.attributes.CODECS);
	        }
	
	        // if the streams differ in the presence or absence of audio or
	        // video, they are incompatible
	        if (variantCodecs.codecCount !== codecCount) {
	          variant.excludeUntil = Infinity;
	        }
	
	        // if h.264 is specified on the current playlist, some flavor of
	        // it must be specified on all compatible variants
	        if (variantCodecs.videoCodec !== videoCodec) {
	          variant.excludeUntil = Infinity;
	        }
	      });
	    }
	  }, {
	    key: 'updateAdCues_',
	    value: function updateAdCues_(media) {
	      var offset = 0;
	      var seekable$$1 = this.seekable();
	
	      if (seekable$$1.length) {
	        offset = seekable$$1.start(0);
	      }
	
	      updateAdCues(media, this.cueTagsTrack_, offset);
	    }
	
	    /**
	     * Calculates the desired forward buffer length based on current time
	     *
	     * @return {Number} Desired forward buffer length in seconds
	     */
	
	  }, {
	    key: 'goalBufferLength',
	    value: function goalBufferLength() {
	      var currentTime = this.tech_.currentTime();
	      var initial = Config.GOAL_BUFFER_LENGTH;
	      var rate = Config.GOAL_BUFFER_LENGTH_RATE;
	      var max = Math.max(initial, Config.MAX_GOAL_BUFFER_LENGTH);
	
	      return Math.min(initial + currentTime * rate, max);
	    }
	
	    /**
	     * Calculates the desired buffer low water line based on current time
	     *
	     * @return {Number} Desired buffer low water line in seconds
	     */
	
	  }, {
	    key: 'bufferLowWaterLine',
	    value: function bufferLowWaterLine() {
	      var currentTime = this.tech_.currentTime();
	      var initial = Config.BUFFER_LOW_WATER_LINE;
	      var rate = Config.BUFFER_LOW_WATER_LINE_RATE;
	      var max = Math.max(initial, Config.MAX_BUFFER_LOW_WATER_LINE);
	
	      return Math.min(initial + currentTime * rate, max);
	    }
	  }]);
	  return MasterPlaylistController;
	}(videojs$1.EventTarget);
	
	/**
	 * Returns a function that acts as the Enable/disable playlist function.
	 *
	 * @param {PlaylistLoader} loader - The master playlist loader
	 * @param {String} playlistUri - uri of the playlist
	 * @param {Function} changePlaylistFn - A function to be called after a
	 * playlist's enabled-state has been changed. Will NOT be called if a
	 * playlist's enabled-state is unchanged
	 * @param {Boolean=} enable - Value to set the playlist enabled-state to
	 * or if undefined returns the current enabled-state for the playlist
	 * @return {Function} Function for setting/getting enabled
	 */
	var enableFunction = function enableFunction(loader, playlistUri, changePlaylistFn) {
	  return function (enable) {
	    var playlist = loader.master.playlists[playlistUri];
	    var incompatible = isIncompatible(playlist);
	    var currentlyEnabled = isEnabled(playlist);
	
	    if (typeof enable === 'undefined') {
	      return currentlyEnabled;
	    }
	
	    if (enable) {
	      delete playlist.disabled;
	    } else {
	      playlist.disabled = true;
	    }
	
	    if (enable !== currentlyEnabled && !incompatible) {
	      // Ensure the outside world knows about our changes
	      changePlaylistFn();
	      if (enable) {
	        loader.trigger('renditionenabled');
	      } else {
	        loader.trigger('renditiondisabled');
	      }
	    }
	    return enable;
	  };
	};
	
	/**
	 * The representation object encapsulates the publicly visible information
	 * in a media playlist along with a setter/getter-type function (enabled)
	 * for changing the enabled-state of a particular playlist entry
	 *
	 * @class Representation
	 */
	
	var Representation = function Representation(hlsHandler, playlist, id) {
	  classCallCheck$1(this, Representation);
	
	  // Get a reference to a bound version of fastQualityChange_
	  var fastChangeFunction = hlsHandler.masterPlaylistController_.fastQualityChange_.bind(hlsHandler.masterPlaylistController_);
	
	  // some playlist attributes are optional
	  if (playlist.attributes.RESOLUTION) {
	    var resolution = playlist.attributes.RESOLUTION;
	
	    this.width = resolution.width;
	    this.height = resolution.height;
	  }
	
	  this.bandwidth = playlist.attributes.BANDWIDTH;
	
	  // The id is simply the ordinality of the media playlist
	  // within the master playlist
	  this.id = id;
	
	  // Partially-apply the enableFunction to create a playlist-
	  // specific variant
	  this.enabled = enableFunction(hlsHandler.playlists, playlist.uri, fastChangeFunction);
	};
	
	/**
	 * A mixin function that adds the `representations` api to an instance
	 * of the HlsHandler class
	 * @param {HlsHandler} hlsHandler - An instance of HlsHandler to add the
	 * representation API into
	 */
	
	var renditionSelectionMixin = function renditionSelectionMixin(hlsHandler) {
	  var playlists = hlsHandler.playlists;
	
	  // Add a single API-specific function to the HlsHandler instance
	  hlsHandler.representations = function () {
	    return playlists.master.playlists.filter(function (media) {
	      return !isIncompatible(media);
	    }).map(function (e, i) {
	      return new Representation(hlsHandler, e, e.uri);
	    });
	  };
	};
	
	/**
	 * @file playback-watcher.js
	 *
	 * Playback starts, and now my watch begins. It shall not end until my death. I shall
	 * take no wait, hold no uncleared timeouts, father no bad seeks. I shall wear no crowns
	 * and win no glory. I shall live and die at my post. I am the corrector of the underflow.
	 * I am the watcher of gaps. I am the shield that guards the realms of seekable. I pledge
	 * my life and honor to the Playback Watch, for this Player and all the Players to come.
	 */
	
	// Set of events that reset the playback-watcher time check logic and clear the timeout
	var timerCancelEvents = ['seeking', 'seeked', 'pause', 'playing', 'error'];
	
	/**
	 * @class PlaybackWatcher
	 */
	
	var PlaybackWatcher = function () {
	  /**
	   * Represents an PlaybackWatcher object.
	   * @constructor
	   * @param {object} options an object that includes the tech and settings
	   */
	  function PlaybackWatcher(options) {
	    var _this = this;
	
	    classCallCheck$1(this, PlaybackWatcher);
	
	    this.tech_ = options.tech;
	    this.seekable = options.seekable;
	    this.seekTo = options.seekTo;
	
	    this.consecutiveUpdates = 0;
	    this.lastRecordedTime = null;
	    this.timer_ = null;
	    this.checkCurrentTimeTimeout_ = null;
	    this.logger_ = logger('PlaybackWatcher');
	
	    this.logger_('initialize');
	
	    var canPlayHandler = function canPlayHandler() {
	      return _this.monitorCurrentTime_();
	    };
	    var waitingHandler = function waitingHandler() {
	      return _this.techWaiting_();
	    };
	    var cancelTimerHandler = function cancelTimerHandler() {
	      return _this.cancelTimer_();
	    };
	    var fixesBadSeeksHandler = function fixesBadSeeksHandler() {
	      return _this.fixesBadSeeks_();
	    };
	
	    this.tech_.on('seekablechanged', fixesBadSeeksHandler);
	    this.tech_.on('waiting', waitingHandler);
	    this.tech_.on(timerCancelEvents, cancelTimerHandler);
	    this.tech_.on('canplay', canPlayHandler);
	
	    // Define the dispose function to clean up our events
	    this.dispose = function () {
	      _this.logger_('dispose');
	      _this.tech_.off('seekablechanged', fixesBadSeeksHandler);
	      _this.tech_.off('waiting', waitingHandler);
	      _this.tech_.off(timerCancelEvents, cancelTimerHandler);
	      _this.tech_.off('canplay', canPlayHandler);
	      if (_this.checkCurrentTimeTimeout_) {
	        window$1.clearTimeout(_this.checkCurrentTimeTimeout_);
	      }
	      _this.cancelTimer_();
	    };
	  }
	
	  /**
	   * Periodically check current time to see if playback stopped
	   *
	   * @private
	   */
	
	  createClass$1(PlaybackWatcher, [{
	    key: 'monitorCurrentTime_',
	    value: function monitorCurrentTime_() {
	      this.checkCurrentTime_();
	
	      if (this.checkCurrentTimeTimeout_) {
	        window$1.clearTimeout(this.checkCurrentTimeTimeout_);
	      }
	
	      // 42 = 24 fps // 250 is what Webkit uses // FF uses 15
	      this.checkCurrentTimeTimeout_ = window$1.setTimeout(this.monitorCurrentTime_.bind(this), 250);
	    }
	
	    /**
	     * The purpose of this function is to emulate the "waiting" event on
	     * browsers that do not emit it when they are waiting for more
	     * data to continue playback
	     *
	     * @private
	     */
	
	  }, {
	    key: 'checkCurrentTime_',
	    value: function checkCurrentTime_() {
	      if (this.tech_.seeking() && this.fixesBadSeeks_()) {
	        this.consecutiveUpdates = 0;
	        this.lastRecordedTime = this.tech_.currentTime();
	        return;
	      }
	
	      if (this.tech_.paused() || this.tech_.seeking()) {
	        return;
	      }
	
	      var currentTime = this.tech_.currentTime();
	      var buffered = this.tech_.buffered();
	
	      if (this.lastRecordedTime === currentTime && (!buffered.length || currentTime + SAFE_TIME_DELTA >= buffered.end(buffered.length - 1))) {
	        // If current time is at the end of the final buffered region, then any playback
	        // stall is most likely caused by buffering in a low bandwidth environment. The tech
	        // should fire a `waiting` event in this scenario, but due to browser and tech
	        // inconsistencies. Calling `techWaiting_` here allows us to simulate
	        // responding to a native `waiting` event when the tech fails to emit one.
	        return this.techWaiting_();
	      }
	
	      if (this.consecutiveUpdates >= 5 && currentTime === this.lastRecordedTime) {
	        this.consecutiveUpdates++;
	        this.waiting_();
	      } else if (currentTime === this.lastRecordedTime) {
	        this.consecutiveUpdates++;
	      } else {
	        this.consecutiveUpdates = 0;
	        this.lastRecordedTime = currentTime;
	      }
	    }
	
	    /**
	     * Cancels any pending timers and resets the 'timeupdate' mechanism
	     * designed to detect that we are stalled
	     *
	     * @private
	     */
	
	  }, {
	    key: 'cancelTimer_',
	    value: function cancelTimer_() {
	      this.consecutiveUpdates = 0;
	
	      if (this.timer_) {
	        this.logger_('cancelTimer_');
	        clearTimeout(this.timer_);
	      }
	
	      this.timer_ = null;
	    }
	
	    /**
	     * Fixes situations where there's a bad seek
	     *
	     * @return {Boolean} whether an action was taken to fix the seek
	     * @private
	     */
	
	  }, {
	    key: 'fixesBadSeeks_',
	    value: function fixesBadSeeks_() {
	      var seeking = this.tech_.seeking();
	      var seekable = this.seekable();
	      var currentTime = this.tech_.currentTime();
	      var seekTo = void 0;
	
	      if (seeking && this.afterSeekableWindow_(seekable, currentTime)) {
	        var seekableEnd = seekable.end(seekable.length - 1);
	
	        // sync to live point (if VOD, our seekable was updated and we're simply adjusting)
	        seekTo = seekableEnd;
	      }
	
	      if (seeking && this.beforeSeekableWindow_(seekable, currentTime)) {
	        var seekableStart = seekable.start(0);
	
	        // sync to the beginning of the live window
	        // provide a buffer of .1 seconds to handle rounding/imprecise numbers
	        seekTo = seekableStart + SAFE_TIME_DELTA;
	      }
	
	      if (typeof seekTo !== 'undefined') {
	        this.logger_('Trying to seek outside of seekable at time ' + currentTime + ' with ' + ('seekable range ' + printableRange(seekable) + '. Seeking to ') + (seekTo + '.'));
	
	        this.seekTo(seekTo);
	        return true;
	      }
	
	      return false;
	    }
	
	    /**
	     * Handler for situations when we determine the player is waiting.
	     *
	     * @private
	     */
	
	  }, {
	    key: 'waiting_',
	    value: function waiting_() {
	      if (this.techWaiting_()) {
	        return;
	      }
	
	      // All tech waiting checks failed. Use last resort correction
	      var currentTime = this.tech_.currentTime();
	      var buffered = this.tech_.buffered();
	      var currentRange = findRange(buffered, currentTime);
	
	      // Sometimes the player can stall for unknown reasons within a contiguous buffered
	      // region with no indication that anything is amiss (seen in Firefox). Seeking to
	      // currentTime is usually enough to kickstart the player. This checks that the player
	      // is currently within a buffered region before attempting a corrective seek.
	      // Chrome does not appear to continue `timeupdate` events after a `waiting` event
	      // until there is ~ 3 seconds of forward buffer available. PlaybackWatcher should also
	      // make sure there is ~3 seconds of forward buffer before taking any corrective action
	      // to avoid triggering an `unknownwaiting` event when the network is slow.
	      if (currentRange.length && currentTime + 3 <= currentRange.end(0)) {
	        this.cancelTimer_();
	        this.seekTo(currentTime);
	
	        this.logger_('Stopped at ' + currentTime + ' while inside a buffered region ' + ('[' + currentRange.start(0) + ' -> ' + currentRange.end(0) + ']. Attempting to resume ') + 'playback by seeking to the current time.');
	
	        // unknown waiting corrections may be useful for monitoring QoS
	        this.tech_.trigger({ type: 'usage', name: 'hls-unknown-waiting' });
	        return;
	      }
	    }
	
	    /**
	     * Handler for situations when the tech fires a `waiting` event
	     *
	     * @return {Boolean}
	     *         True if an action (or none) was needed to correct the waiting. False if no
	     *         checks passed
	     * @private
	     */
	
	  }, {
	    key: 'techWaiting_',
	    value: function techWaiting_() {
	      var seekable = this.seekable();
	      var currentTime = this.tech_.currentTime();
	
	      if (this.tech_.seeking() && this.fixesBadSeeks_()) {
	        // Tech is seeking or bad seek fixed, no action needed
	        return true;
	      }
	
	      if (this.tech_.seeking() || this.timer_ !== null) {
	        // Tech is seeking or already waiting on another action, no action needed
	        return true;
	      }
	
	      if (this.beforeSeekableWindow_(seekable, currentTime)) {
	        var livePoint = seekable.end(seekable.length - 1);
	
	        this.logger_('Fell out of live window at time ' + currentTime + '. Seeking to ' + ('live point (seekable end) ' + livePoint));
	        this.cancelTimer_();
	        this.seekTo(livePoint);
	
	        // live window resyncs may be useful for monitoring QoS
	        this.tech_.trigger({ type: 'usage', name: 'hls-live-resync' });
	        return true;
	      }
	
	      var buffered = this.tech_.buffered();
	      var nextRange = findNextRange(buffered, currentTime);
	
	      if (this.videoUnderflow_(nextRange, buffered, currentTime)) {
	        // Even though the video underflowed and was stuck in a gap, the audio overplayed
	        // the gap, leading currentTime into a buffered range. Seeking to currentTime
	        // allows the video to catch up to the audio position without losing any audio
	        // (only suffering ~3 seconds of frozen video and a pause in audio playback).
	        this.cancelTimer_();
	        this.seekTo(currentTime);
	
	        // video underflow may be useful for monitoring QoS
	        this.tech_.trigger({ type: 'usage', name: 'hls-video-underflow' });
	        return true;
	      }
	
	      // check for gap
	      if (nextRange.length > 0) {
	        var difference = nextRange.start(0) - currentTime;
	
	        this.logger_('Stopped at ' + currentTime + ', setting timer for ' + difference + ', seeking ' + ('to ' + nextRange.start(0)));
	
	        this.timer_ = setTimeout(this.skipTheGap_.bind(this), difference * 1000, currentTime);
	        return true;
	      }
	
	      // All checks failed. Returning false to indicate failure to correct waiting
	      return false;
	    }
	  }, {
	    key: 'afterSeekableWindow_',
	    value: function afterSeekableWindow_(seekable, currentTime) {
	      if (!seekable.length) {
	        // we can't make a solid case if there's no seekable, default to false
	        return false;
	      }
	
	      if (currentTime > seekable.end(seekable.length - 1) + SAFE_TIME_DELTA) {
	        return true;
	      }
	
	      return false;
	    }
	  }, {
	    key: 'beforeSeekableWindow_',
	    value: function beforeSeekableWindow_(seekable, currentTime) {
	      if (seekable.length &&
	      // can't fall before 0 and 0 seekable start identifies VOD stream
	      seekable.start(0) > 0 && currentTime < seekable.start(0) - SAFE_TIME_DELTA) {
	        return true;
	      }
	
	      return false;
	    }
	  }, {
	    key: 'videoUnderflow_',
	    value: function videoUnderflow_(nextRange, buffered, currentTime) {
	      if (nextRange.length === 0) {
	        // Even if there is no available next range, there is still a possibility we are
	        // stuck in a gap due to video underflow.
	        var gap = this.gapFromVideoUnderflow_(buffered, currentTime);
	
	        if (gap) {
	          this.logger_('Encountered a gap in video from ' + gap.start + ' to ' + gap.end + '. ' + ('Seeking to current time ' + currentTime));
	
	          return true;
	        }
	      }
	
	      return false;
	    }
	
	    /**
	     * Timer callback. If playback still has not proceeded, then we seek
	     * to the start of the next buffered region.
	     *
	     * @private
	     */
	
	  }, {
	    key: 'skipTheGap_',
	    value: function skipTheGap_(scheduledCurrentTime) {
	      var buffered = this.tech_.buffered();
	      var currentTime = this.tech_.currentTime();
	      var nextRange = findNextRange(buffered, currentTime);
	
	      this.cancelTimer_();
	
	      if (nextRange.length === 0 || currentTime !== scheduledCurrentTime) {
	        return;
	      }
	
	      this.logger_('skipTheGap_:', 'currentTime:', currentTime, 'scheduled currentTime:', scheduledCurrentTime, 'nextRange start:', nextRange.start(0));
	
	      // only seek if we still have not played
	      this.seekTo(nextRange.start(0) + TIME_FUDGE_FACTOR);
	
	      this.tech_.trigger({ type: 'usage', name: 'hls-gap-skip' });
	    }
	  }, {
	    key: 'gapFromVideoUnderflow_',
	    value: function gapFromVideoUnderflow_(buffered, currentTime) {
	      // At least in Chrome, if there is a gap in the video buffer, the audio will continue
	      // playing for ~3 seconds after the video gap starts. This is done to account for
	      // video buffer underflow/underrun (note that this is not done when there is audio
	      // buffer underflow/underrun -- in that case the video will stop as soon as it
	      // encounters the gap, as audio stalls are more noticeable/jarring to a user than
	      // video stalls). The player's time will reflect the playthrough of audio, so the
	      // time will appear as if we are in a buffered region, even if we are stuck in a
	      // "gap."
	      //
	      // Example:
	      // video buffer:   0 => 10.1, 10.2 => 20
	      // audio buffer:   0 => 20
	      // overall buffer: 0 => 10.1, 10.2 => 20
	      // current time: 13
	      //
	      // Chrome's video froze at 10 seconds, where the video buffer encountered the gap,
	      // however, the audio continued playing until it reached ~3 seconds past the gap
	      // (13 seconds), at which point it stops as well. Since current time is past the
	      // gap, findNextRange will return no ranges.
	      //
	      // To check for this issue, we see if there is a gap that starts somewhere within
	      // a 3 second range (3 seconds +/- 1 second) back from our current time.
	      var gaps = findGaps(buffered);
	
	      for (var i = 0; i < gaps.length; i++) {
	        var start = gaps.start(i);
	        var end = gaps.end(i);
	
	        // gap is starts no more than 4 seconds back
	        if (currentTime - start < 4 && currentTime - start > 2) {
	          return {
	            start: start,
	            end: end
	          };
	        }
	      }
	
	      return null;
	    }
	  }]);
	  return PlaybackWatcher;
	}();
	
	var defaultOptions = {
	  errorInterval: 30,
	  getSource: function getSource(next) {
	    var tech = this.tech({ IWillNotUseThisInPlugins: true });
	    var sourceObj = tech.currentSource_;
	
	    return next(sourceObj);
	  }
	};
	
	/**
	 * Main entry point for the plugin
	 *
	 * @param {Player} player a reference to a videojs Player instance
	 * @param {Object} [options] an object with plugin options
	 * @private
	 */
	var initPlugin = function initPlugin(player, options) {
	  var lastCalled = 0;
	  var seekTo = 0;
	  var localOptions = videojs$1.mergeOptions(defaultOptions, options);
	
	  player.ready(function () {
	    player.trigger({ type: 'usage', name: 'hls-error-reload-initialized' });
	  });
	
	  /**
	   * Player modifications to perform that must wait until `loadedmetadata`
	   * has been triggered
	   *
	   * @private
	   */
	  var loadedMetadataHandler = function loadedMetadataHandler() {
	    if (seekTo) {
	      player.currentTime(seekTo);
	    }
	  };
	
	  /**
	   * Set the source on the player element, play, and seek if necessary
	   *
	   * @param {Object} sourceObj An object specifying the source url and mime-type to play
	   * @private
	   */
	  var setSource = function setSource(sourceObj) {
	    if (sourceObj === null || sourceObj === undefined) {
	      return;
	    }
	    seekTo = player.duration() !== Infinity && player.currentTime() || 0;
	
	    player.one('loadedmetadata', loadedMetadataHandler);
	
	    player.src(sourceObj);
	    player.trigger({ type: 'usage', name: 'hls-error-reload' });
	    player.play();
	  };
	
	  /**
	   * Attempt to get a source from either the built-in getSource function
	   * or a custom function provided via the options
	   *
	   * @private
	   */
	  var errorHandler = function errorHandler() {
	    // Do not attempt to reload the source if a source-reload occurred before
	    // 'errorInterval' time has elapsed since the last source-reload
	    if (Date.now() - lastCalled < localOptions.errorInterval * 1000) {
	      player.trigger({ type: 'usage', name: 'hls-error-reload-canceled' });
	      return;
	    }
	
	    if (!localOptions.getSource || typeof localOptions.getSource !== 'function') {
	      videojs$1.log.error('ERROR: reloadSourceOnError - The option getSource must be a function!');
	      return;
	    }
	    lastCalled = Date.now();
	
	    return localOptions.getSource.call(player, setSource);
	  };
	
	  /**
	   * Unbind any event handlers that were bound by the plugin
	   *
	   * @private
	   */
	  var cleanupEvents = function cleanupEvents() {
	    player.off('loadedmetadata', loadedMetadataHandler);
	    player.off('error', errorHandler);
	    player.off('dispose', cleanupEvents);
	  };
	
	  /**
	   * Cleanup before re-initializing the plugin
	   *
	   * @param {Object} [newOptions] an object with plugin options
	   * @private
	   */
	  var reinitPlugin = function reinitPlugin(newOptions) {
	    cleanupEvents();
	    initPlugin(player, newOptions);
	  };
	
	  player.on('error', errorHandler);
	  player.on('dispose', cleanupEvents);
	
	  // Overwrite the plugin function so that we can correctly cleanup before
	  // initializing the plugin
	  player.reloadSourceOnError = reinitPlugin;
	};
	
	/**
	 * Reload the source when an error is detected as long as there
	 * wasn't an error previously within the last 30 seconds
	 *
	 * @param {Object} [options] an object with plugin options
	 */
	var reloadSourceOnError = function reloadSourceOnError(options) {
	  initPlugin(this, options);
	};
	
	var version$1 = "1.2.5";
	
	// since VHS handles HLS and DASH (and in the future, more types), use * to capture all
	videojs$1.use('*', function (player) {
	  return {
	    setSource: function setSource(srcObj, next) {
	      // pass null as the first argument to indicate that the source is not rejected
	      next(null, srcObj);
	    },
	
	    // VHS needs to know when seeks happen. For external seeks (generated at the player
	    // level), this middleware will capture the action. For internal seeks (generated at
	    // the tech level), we use a wrapped function so that we can handle it on our own
	    // (specified elsewhere).
	    setCurrentTime: function setCurrentTime(time) {
	      if (player.vhs && player.currentSource().src === player.vhs.source_.src) {
	        player.vhs.setCurrentTime(time);
	      }
	
	      return time;
	    },
	
	    // Sync VHS after play requests.
	    // This specifically handles replay where the order of actions is
	    // play, video element will seek to 0 (skipping the setCurrentTime middleware)
	    // then triggers a play event.
	    play: function play() {
	      if (player.vhs && player.currentSource().src === player.vhs.source_.src) {
	        player.vhs.setCurrentTime(player.currentTime());
	      }
	    }
	  };
	});
	
	/**
	 * @file videojs-http-streaming.js
	 *
	 * The main file for the HLS project.
	 * License: https://github.com/videojs/videojs-http-streaming/blob/master/LICENSE
	 */
	
	var Hls$1 = {
	  PlaylistLoader: PlaylistLoader,
	  Playlist: Playlist,
	  Decrypter: aesDecrypter.Decrypter,
	  AsyncStream: aesDecrypter.AsyncStream,
	  decrypt: aesDecrypter.decrypt,
	  utils: utils,
	
	  STANDARD_PLAYLIST_SELECTOR: lastBandwidthSelector,
	  INITIAL_PLAYLIST_SELECTOR: lowestBitrateCompatibleVariantSelector,
	  comparePlaylistBandwidth: comparePlaylistBandwidth,
	  comparePlaylistResolution: comparePlaylistResolution,
	
	  xhr: xhrFactory()
	};
	
	// 0.5 MB/s
	var INITIAL_BANDWIDTH = 4194304;
	
	// Define getter/setters for config properites
	['GOAL_BUFFER_LENGTH', 'MAX_GOAL_BUFFER_LENGTH', 'GOAL_BUFFER_LENGTH_RATE', 'BUFFER_LOW_WATER_LINE', 'MAX_BUFFER_LOW_WATER_LINE', 'BUFFER_LOW_WATER_LINE_RATE', 'BANDWIDTH_VARIANCE'].forEach(function (prop) {
	  Object.defineProperty(Hls$1, prop, {
	    get: function get$$1() {
	      videojs$1.log.warn('using Hls.' + prop + ' is UNSAFE be sure you know what you are doing');
	      return Config[prop];
	    },
	    set: function set$$1(value) {
	      videojs$1.log.warn('using Hls.' + prop + ' is UNSAFE be sure you know what you are doing');
	
	      if (typeof value !== 'number' || value < 0) {
	        videojs$1.log.warn('value of Hls.' + prop + ' must be greater than or equal to 0');
	        return;
	      }
	
	      Config[prop] = value;
	    }
	  });
	});
	
	var simpleTypeFromSourceType = function simpleTypeFromSourceType(type) {
	  var mpegurlRE = /^(audio|video|application)\/(x-|vnd\.apple\.)?mpegurl/i;
	
	  if (mpegurlRE.test(type)) {
	    return 'hls';
	  }
	
	  var dashRE = /^application\/dash\+xml/i;
	
	  if (dashRE.test(type)) {
	    return 'dash';
	  }
	
	  return null;
	};
	
	/**
	 * Updates the selectedIndex of the QualityLevelList when a mediachange happens in hls.
	 *
	 * @param {QualityLevelList} qualityLevels The QualityLevelList to update.
	 * @param {PlaylistLoader} playlistLoader PlaylistLoader containing the new media info.
	 * @function handleHlsMediaChange
	 */
	var handleHlsMediaChange = function handleHlsMediaChange(qualityLevels, playlistLoader) {
	  var newPlaylist = playlistLoader.media();
	  var selectedIndex = -1;
	
	  for (var i = 0; i < qualityLevels.length; i++) {
	    if (qualityLevels[i].id === newPlaylist.uri) {
	      selectedIndex = i;
	      break;
	    }
	  }
	
	  qualityLevels.selectedIndex_ = selectedIndex;
	  qualityLevels.trigger({
	    selectedIndex: selectedIndex,
	    type: 'change'
	  });
	};
	
	/**
	 * Adds quality levels to list once playlist metadata is available
	 *
	 * @param {QualityLevelList} qualityLevels The QualityLevelList to attach events to.
	 * @param {Object} hls Hls object to listen to for media events.
	 * @function handleHlsLoadedMetadata
	 */
	var handleHlsLoadedMetadata = function handleHlsLoadedMetadata(qualityLevels, hls) {
	  hls.representations().forEach(function (rep) {
	    qualityLevels.addQualityLevel(rep);
	  });
	  handleHlsMediaChange(qualityLevels, hls.playlists);
	};
	
	// HLS is a source handler, not a tech. Make sure attempts to use it
	// as one do not cause exceptions.
	Hls$1.canPlaySource = function () {
	  return videojs$1.log.warn('HLS is no longer a tech. Please remove it from ' + 'your player\'s techOrder.');
	};
	
	var emeKeySystems = function emeKeySystems(keySystemOptions, videoPlaylist, audioPlaylist) {
	  if (!keySystemOptions) {
	    return keySystemOptions;
	  }
	
	  // upsert the content types based on the selected playlist
	  var keySystemContentTypes = {};
	
	  for (var keySystem in keySystemOptions) {
	    keySystemContentTypes[keySystem] = {
	      audioContentType: 'audio/mp4; codecs="' + audioPlaylist.attributes.CODECS + '"',
	      videoContentType: 'video/mp4; codecs="' + videoPlaylist.attributes.CODECS + '"'
	    };
	
	    if (videoPlaylist.contentProtection && videoPlaylist.contentProtection[keySystem] && videoPlaylist.contentProtection[keySystem].pssh) {
	      keySystemContentTypes[keySystem].pssh = videoPlaylist.contentProtection[keySystem].pssh;
	    }
	
	    // videojs-contrib-eme accepts the option of specifying: 'com.some.cdm': 'url'
	    // so we need to prevent overwriting the URL entirely
	    if (typeof keySystemOptions[keySystem] === 'string') {
	      keySystemContentTypes[keySystem].url = keySystemOptions[keySystem];
	    }
	  }
	
	  return videojs$1.mergeOptions(keySystemOptions, keySystemContentTypes);
	};
	
	var setupEmeOptions = function setupEmeOptions(hlsHandler) {
	  if (hlsHandler.options_.sourceType !== 'dash') {
	    return;
	  }
	  var player = videojs$1.players[hlsHandler.tech_.options_.playerId];
	
	  if (player.eme) {
	    var sourceOptions = emeKeySystems(hlsHandler.source_.keySystems, hlsHandler.playlists.media(), hlsHandler.masterPlaylistController_.mediaTypes_.AUDIO.activePlaylistLoader.media());
	
	    if (sourceOptions) {
	      player.currentSource().keySystems = sourceOptions;
	    }
	  }
	};
	
	/**
	 * Whether the browser has built-in HLS support.
	 */
	Hls$1.supportsNativeHls = function () {
	  var video = document.createElement('video');
	
	  // native HLS is definitely not supported if HTML5 video isn't
	  if (!videojs$1.getTech('Html5').isSupported()) {
	    return false;
	  }
	
	  // HLS manifests can go by many mime-types
	  var canPlay = [
	  // Apple santioned
	  'application/vnd.apple.mpegurl',
	  // Apple sanctioned for backwards compatibility
	  'audio/mpegurl',
	  // Very common
	  'audio/x-mpegurl',
	  // Very common
	  'application/x-mpegurl',
	  // Included for completeness
	  'video/x-mpegurl', 'video/mpegurl', 'application/mpegurl'];
	
	  return canPlay.some(function (canItPlay) {
	    return (/maybe|probably/i.test(video.canPlayType(canItPlay))
	    );
	  });
	}();
	
	Hls$1.supportsNativeDash = function () {
	  if (!videojs$1.getTech('Html5').isSupported()) {
	    return false;
	  }
	
	  return (/maybe|probably/i.test(document.createElement('video').canPlayType('application/dash+xml'))
	  );
	}();
	
	Hls$1.supportsTypeNatively = function (type) {
	  if (type === 'hls') {
	    return Hls$1.supportsNativeHls;
	  }
	
	  if (type === 'dash') {
	    return Hls$1.supportsNativeDash;
	  }
	
	  return false;
	};
	
	/**
	 * HLS is a source handler, not a tech. Make sure attempts to use it
	 * as one do not cause exceptions.
	 */
	Hls$1.isSupported = function () {
	  return videojs$1.log.warn('HLS is no longer a tech. Please remove it from ' + 'your player\'s techOrder.');
	};
	
	var Component$1 = videojs$1.getComponent('Component');
	
	/**
	 * The Hls Handler object, where we orchestrate all of the parts
	 * of HLS to interact with video.js
	 *
	 * @class HlsHandler
	 * @extends videojs.Component
	 * @param {Object} source the soruce object
	 * @param {Tech} tech the parent tech object
	 * @param {Object} options optional and required options
	 */
	
	var HlsHandler = function (_Component) {
	  inherits$1(HlsHandler, _Component);
	
	  function HlsHandler(source, tech, options) {
	    classCallCheck$1(this, HlsHandler);
	
	    // tech.player() is deprecated but setup a reference to HLS for
	    // backwards-compatibility
	    var _this = possibleConstructorReturn$1(this, (HlsHandler.__proto__ || Object.getPrototypeOf(HlsHandler)).call(this, tech, options.hls));
	
	    if (tech.options_ && tech.options_.playerId) {
	      var _player = videojs$1(tech.options_.playerId);
	
	      if (!_player.hasOwnProperty('hls')) {
	        Object.defineProperty(_player, 'hls', {
	          get: function get$$1() {
	            videojs$1.log.warn('player.hls is deprecated. Use player.tech().hls instead.');
	            tech.trigger({ type: 'usage', name: 'hls-player-access' });
	            return _this;
	          }
	        });
	      }
	
	      // Set up a reference to the HlsHandler from player.vhs. This allows users to start
	      // migrating from player.tech_.hls... to player.vhs... for API access. Although this
	      // isn't the most appropriate form of reference for video.js (since all APIs should
	      // be provided through core video.js), it is a common pattern for plugins, and vhs
	      // will act accordingly.
	      _player.vhs = _this;
	      // deprecated, for backwards compatibility
	      _player.dash = _this;
	    }
	
	    _this.tech_ = tech;
	    _this.source_ = source;
	    _this.stats = {};
	    _this.setOptions_();
	
	    if (_this.options_.overrideNative && tech.overrideNativeAudioTracks && tech.overrideNativeVideoTracks) {
	      tech.overrideNativeAudioTracks(true);
	      tech.overrideNativeVideoTracks(true);
	    } else if (_this.options_.overrideNative && (tech.featuresNativeVideoTracks || tech.featuresNativeAudioTracks)) {
	      // overriding native HLS only works if audio tracks have been emulated
	      // error early if we're misconfigured
	      throw new Error('Overriding native HLS requires emulated tracks. ' + 'See https://git.io/vMpjB');
	    }
	
	    // listen for fullscreenchange events for this player so that we
	    // can adjust our quality selection quickly
	    _this.on(document, ['fullscreenchange', 'webkitfullscreenchange', 'mozfullscreenchange', 'MSFullscreenChange'], function (event) {
	      var fullscreenElement = document.fullscreenElement || document.webkitFullscreenElement || document.mozFullScreenElement || document.msFullscreenElement;
	
	      if (fullscreenElement && fullscreenElement.contains(_this.tech_.el())) {
	        _this.masterPlaylistController_.smoothQualityChange_();
	      }
	    });
	    _this.on(_this.tech_, 'error', function () {
	      if (this.masterPlaylistController_) {
	        this.masterPlaylistController_.pauseLoading();
	      }
	    });
	
	    _this.on(_this.tech_, 'play', _this.play);
	    return _this;
	  }
	
	  createClass$1(HlsHandler, [{
	    key: 'setOptions_',
	    value: function setOptions_() {
	      var _this2 = this;
	
	      // defaults
	      this.options_.withCredentials = this.options_.withCredentials || false;
	
	      if (typeof this.options_.blacklistDuration !== 'number') {
	        this.options_.blacklistDuration = 5 * 60;
	      }
	
	      // start playlist selection at a reasonable bandwidth for
	      // broadband internet (0.5 MB/s) or mobile (0.0625 MB/s)
	      if (typeof this.options_.bandwidth !== 'number') {
	        this.options_.bandwidth = INITIAL_BANDWIDTH;
	      }
	
	      // If the bandwidth number is unchanged from the initial setting
	      // then this takes precedence over the enableLowInitialPlaylist option
	      this.options_.enableLowInitialPlaylist = this.options_.enableLowInitialPlaylist && this.options_.bandwidth === INITIAL_BANDWIDTH;
	
	      // grab options passed to player.src
	      ['withCredentials', 'bandwidth'].forEach(function (option) {
	        if (typeof _this2.source_[option] !== 'undefined') {
	          _this2.options_[option] = _this2.source_[option];
	        }
	      });
	
	      this.bandwidth = this.options_.bandwidth;
	    }
	    /**
	     * called when player.src gets called, handle a new source
	     *
	     * @param {Object} src the source object to handle
	     */
	
	  }, {
	    key: 'src',
	    value: function src(_src, type) {
	      var _this3 = this;
	
	      // do nothing if the src is falsey
	      if (!_src) {
	        return;
	      }
	      this.setOptions_();
	      // add master playlist controller options
	      this.options_.url = this.source_.src;
	      this.options_.tech = this.tech_;
	      this.options_.externHls = Hls$1;
	      this.options_.sourceType = simpleTypeFromSourceType(type);
	      // Whenever we seek internally, we should update both the tech and call our own
	      // setCurrentTime function. This is needed because "seeking" events aren't always
	      // reliable. External seeks (via the player object) are handled via middleware.
	      this.options_.seekTo = function (time) {
	        _this3.tech_.setCurrentTime(time);
	        _this3.setCurrentTime(time);
	      };
	
	      this.masterPlaylistController_ = new MasterPlaylistController(this.options_);
	      this.playbackWatcher_ = new PlaybackWatcher(videojs$1.mergeOptions(this.options_, {
	        seekable: function seekable$$1() {
	          return _this3.seekable();
	        }
	      }));
	
	      this.masterPlaylistController_.on('error', function () {
	        var player = videojs$1.players[_this3.tech_.options_.playerId];
	
	        player.error(_this3.masterPlaylistController_.error);
	      });
	
	      // `this` in selectPlaylist should be the HlsHandler for backwards
	      // compatibility with < v2
	      this.masterPlaylistController_.selectPlaylist = this.selectPlaylist ? this.selectPlaylist.bind(this) : Hls$1.STANDARD_PLAYLIST_SELECTOR.bind(this);
	
	      this.masterPlaylistController_.selectInitialPlaylist = Hls$1.INITIAL_PLAYLIST_SELECTOR.bind(this);
	
	      // re-expose some internal objects for backwards compatibility with < v2
	      this.playlists = this.masterPlaylistController_.masterPlaylistLoader_;
	      this.mediaSource = this.masterPlaylistController_.mediaSource;
	
	      // Proxy assignment of some properties to the master playlist
	      // controller. Using a custom property for backwards compatibility
	      // with < v2
	      Object.defineProperties(this, {
	        selectPlaylist: {
	          get: function get$$1() {
	            return this.masterPlaylistController_.selectPlaylist;
	          },
	          set: function set$$1(selectPlaylist) {
	            this.masterPlaylistController_.selectPlaylist = selectPlaylist.bind(this);
	          }
	        },
	        throughput: {
	          get: function get$$1() {
	            return this.masterPlaylistController_.mainSegmentLoader_.throughput.rate;
	          },
	          set: function set$$1(throughput) {
	            this.masterPlaylistController_.mainSegmentLoader_.throughput.rate = throughput;
	            // By setting `count` to 1 the throughput value becomes the starting value
	            // for the cumulative average
	            this.masterPlaylistController_.mainSegmentLoader_.throughput.count = 1;
	          }
	        },
	        bandwidth: {
	          get: function get$$1() {
	            return this.masterPlaylistController_.mainSegmentLoader_.bandwidth;
	          },
	          set: function set$$1(bandwidth) {
	            this.masterPlaylistController_.mainSegmentLoader_.bandwidth = bandwidth;
	            // setting the bandwidth manually resets the throughput counter
	            // `count` is set to zero that current value of `rate` isn't included
	            // in the cumulative average
	            this.masterPlaylistController_.mainSegmentLoader_.throughput = {
	              rate: 0,
	              count: 0
	            };
	          }
	        },
	        /**
	         * `systemBandwidth` is a combination of two serial processes bit-rates. The first
	         * is the network bitrate provided by `bandwidth` and the second is the bitrate of
	         * the entire process after that - decryption, transmuxing, and appending - provided
	         * by `throughput`.
	         *
	         * Since the two process are serial, the overall system bandwidth is given by:
	         *   sysBandwidth = 1 / (1 / bandwidth + 1 / throughput)
	         */
	        systemBandwidth: {
	          get: function get$$1() {
	            var invBandwidth = 1 / (this.bandwidth || 1);
	            var invThroughput = void 0;
	
	            if (this.throughput > 0) {
	              invThroughput = 1 / this.throughput;
	            } else {
	              invThroughput = 0;
	            }
	
	            var systemBitrate = Math.floor(1 / (invBandwidth + invThroughput));
	
	            return systemBitrate;
	          },
	          set: function set$$1() {
	            videojs$1.log.error('The "systemBandwidth" property is read-only');
	          }
	        }
	      });
	
	      Object.defineProperties(this.stats, {
	        bandwidth: {
	          get: function get$$1() {
	            return _this3.bandwidth || 0;
	          },
	          enumerable: true
	        },
	        mediaRequests: {
	          get: function get$$1() {
	            return _this3.masterPlaylistController_.mediaRequests_() || 0;
	          },
	          enumerable: true
	        },
	        mediaRequestsAborted: {
	          get: function get$$1() {
	            return _this3.masterPlaylistController_.mediaRequestsAborted_() || 0;
	          },
	          enumerable: true
	        },
	        mediaRequestsTimedout: {
	          get: function get$$1() {
	            return _this3.masterPlaylistController_.mediaRequestsTimedout_() || 0;
	          },
	          enumerable: true
	        },
	        mediaRequestsErrored: {
	          get: function get$$1() {
	            return _this3.masterPlaylistController_.mediaRequestsErrored_() || 0;
	          },
	          enumerable: true
	        },
	        mediaTransferDuration: {
	          get: function get$$1() {
	            return _this3.masterPlaylistController_.mediaTransferDuration_() || 0;
	          },
	          enumerable: true
	        },
	        mediaBytesTransferred: {
	          get: function get$$1() {
	            return _this3.masterPlaylistController_.mediaBytesTransferred_() || 0;
	          },
	          enumerable: true
	        },
	        mediaSecondsLoaded: {
	          get: function get$$1() {
	            return _this3.masterPlaylistController_.mediaSecondsLoaded_() || 0;
	          },
	          enumerable: true
	        },
	        buffered: {
	          get: function get$$1() {
	            return timeRangesToArray(_this3.tech_.buffered());
	          },
	          enumerable: true
	        },
	        currentTime: {
	          get: function get$$1() {
	            return _this3.tech_.currentTime();
	          },
	          enumerable: true
	        },
	        currentSource: {
	          get: function get$$1() {
	            return _this3.tech_.currentSource_;
	          },
	          enumerable: true
	        },
	        currentTech: {
	          get: function get$$1() {
	            return _this3.tech_.name_;
	          },
	          enumerable: true
	        },
	        duration: {
	          get: function get$$1() {
	            return _this3.tech_.duration();
	          },
	          enumerable: true
	        },
	        master: {
	          get: function get$$1() {
	            return _this3.playlists.master;
	          },
	          enumerable: true
	        },
	        playerDimensions: {
	          get: function get$$1() {
	            return _this3.tech_.currentDimensions();
	          },
	          enumerable: true
	        },
	        seekable: {
	          get: function get$$1() {
	            return timeRangesToArray(_this3.tech_.seekable());
	          },
	          enumerable: true
	        },
	        timestamp: {
	          get: function get$$1() {
	            return Date.now();
	          },
	          enumerable: true
	        },
	        videoPlaybackQuality: {
	          get: function get$$1() {
	            return _this3.tech_.getVideoPlaybackQuality();
	          },
	          enumerable: true
	        }
	      });
	
	      this.tech_.one('canplay', this.masterPlaylistController_.setupFirstPlay.bind(this.masterPlaylistController_));
	
	      this.masterPlaylistController_.on('selectedinitialmedia', function () {
	        // Add the manual rendition mix-in to HlsHandler
	        renditionSelectionMixin(_this3);
	        setupEmeOptions(_this3);
	      });
	
	      // the bandwidth of the primary segment loader is our best
	      // estimate of overall bandwidth
	      this.on(this.masterPlaylistController_, 'progress', function () {
	        this.tech_.trigger('progress');
	      });
	
	      this.tech_.ready(function () {
	        return _this3.setupQualityLevels_();
	      });
	
	      // do nothing if the tech has been disposed already
	      // this can occur if someone sets the src in player.ready(), for instance
	      if (!this.tech_.el()) {
	        return;
	      }
	
	      this.tech_.src(videojs$1.URL.createObjectURL(this.masterPlaylistController_.mediaSource));
	    }
	
	    /**
	     * Initializes the quality levels and sets listeners to update them.
	     *
	     * @method setupQualityLevels_
	     * @private
	     */
	
	  }, {
	    key: 'setupQualityLevels_',
	    value: function setupQualityLevels_() {
	      var _this4 = this;
	
	      var player = videojs$1.players[this.tech_.options_.playerId];
	
	      if (player && player.qualityLevels) {
	        this.qualityLevels_ = player.qualityLevels();
	
	        this.masterPlaylistController_.on('selectedinitialmedia', function () {
	          handleHlsLoadedMetadata(_this4.qualityLevels_, _this4);
	        });
	
	        this.playlists.on('mediachange', function () {
	          handleHlsMediaChange(_this4.qualityLevels_, _this4.playlists);
	        });
	      }
	    }
	
	    /**
	     * Begin playing the video.
	     */
	
	  }, {
	    key: 'play',
	    value: function play() {
	      this.masterPlaylistController_.play();
	    }
	
	    /**
	     * a wrapper around the function in MasterPlaylistController
	     */
	
	  }, {
	    key: 'setCurrentTime',
	    value: function setCurrentTime(currentTime) {
	      this.masterPlaylistController_.setCurrentTime(currentTime);
	    }
	
	    /**
	     * a wrapper around the function in MasterPlaylistController
	     */
	
	  }, {
	    key: 'duration',
	    value: function duration$$1() {
	      return this.masterPlaylistController_.duration();
	    }
	
	    /**
	     * a wrapper around the function in MasterPlaylistController
	     */
	
	  }, {
	    key: 'seekable',
	    value: function seekable$$1() {
	      return this.masterPlaylistController_.seekable();
	    }
	
	    /**
	     * Abort all outstanding work and cleanup.
	     */
	
	  }, {
	    key: 'dispose',
	    value: function dispose() {
	      if (this.playbackWatcher_) {
	        this.playbackWatcher_.dispose();
	      }
	      if (this.masterPlaylistController_) {
	        this.masterPlaylistController_.dispose();
	      }
	      if (this.qualityLevels_) {
	        this.qualityLevels_.dispose();
	      }
	      get$2(HlsHandler.prototype.__proto__ || Object.getPrototypeOf(HlsHandler.prototype), 'dispose', this).call(this);
	    }
	  }]);
	  return HlsHandler;
	}(Component$1);
	
	/**
	 * The Source Handler object, which informs video.js what additional
	 * MIME types are supported and sets up playback. It is registered
	 * automatically to the appropriate tech based on the capabilities of
	 * the browser it is running in. It is not necessary to use or modify
	 * this object in normal usage.
	 */
	
	var HlsSourceHandler = {
	  name: 'videojs-http-streaming',
	  VERSION: version$1,
	  canHandleSource: function canHandleSource(srcObj) {
	    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	    var localOptions = videojs$1.mergeOptions(videojs$1.options, options);
	
	    return HlsSourceHandler.canPlayType(srcObj.type, localOptions);
	  },
	  handleSource: function handleSource(source, tech) {
	    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	
	    var localOptions = videojs$1.mergeOptions(videojs$1.options, options);
	
	    tech.hls = new HlsHandler(source, tech, localOptions);
	    tech.hls.xhr = xhrFactory();
	
	    tech.hls.src(source.src, source.type);
	    return tech.hls;
	  },
	  canPlayType: function canPlayType(type) {
	    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	    var _videojs$mergeOptions = videojs$1.mergeOptions(videojs$1.options, options),
	        overrideNative = _videojs$mergeOptions.hls.overrideNative;
	
	    var supportedType = simpleTypeFromSourceType(type);
	    var canUseMsePlayback = supportedType && (!Hls$1.supportsTypeNatively(supportedType) || overrideNative);
	
	    return canUseMsePlayback ? 'maybe' : '';
	  }
	};
	
	if (typeof videojs$1.MediaSource === 'undefined' || typeof videojs$1.URL === 'undefined') {
	  videojs$1.MediaSource = MediaSource;
	  videojs$1.URL = URL$1;
	}
	
	// register source handlers with the appropriate techs
	if (MediaSource.supportsNativeMediaSources()) {
	  videojs$1.getTech('Html5').registerSourceHandler(HlsSourceHandler, 0);
	}
	
	videojs$1.HlsHandler = HlsHandler;
	videojs$1.HlsSourceHandler = HlsSourceHandler;
	videojs$1.Hls = Hls$1;
	if (!videojs$1.use) {
	  videojs$1.registerComponent('Hls', Hls$1);
	}
	videojs$1.options.hls = videojs$1.options.hls || {};
	
	if (videojs$1.registerPlugin) {
	  videojs$1.registerPlugin('reloadSourceOnError', reloadSourceOnError);
	} else {
	  videojs$1.plugin('reloadSourceOnError', reloadSourceOnError);
	}
	
	module.exports = videojs$1;


/***/ },
/* 438 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var pkcs7 = __webpack_require__(961);
	
	var classCallCheck = function (instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	};
	
	var createClass = function () {
	  function defineProperties(target, props) {
	    for (var i = 0; i < props.length; i++) {
	      var descriptor = props[i];
	      descriptor.enumerable = descriptor.enumerable || false;
	      descriptor.configurable = true;
	      if ("value" in descriptor) descriptor.writable = true;
	      Object.defineProperty(target, descriptor.key, descriptor);
	    }
	  }
	
	  return function (Constructor, protoProps, staticProps) {
	    if (protoProps) defineProperties(Constructor.prototype, protoProps);
	    if (staticProps) defineProperties(Constructor, staticProps);
	    return Constructor;
	  };
	}();
	
	
	
	
	
	
	
	
	
	var inherits = function (subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
	  }
	
	  subClass.prototype = Object.create(superClass && superClass.prototype, {
	    constructor: {
	      value: subClass,
	      enumerable: false,
	      writable: true,
	      configurable: true
	    }
	  });
	  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
	};
	
	
	
	
	
	
	
	
	
	
	
	var possibleConstructorReturn = function (self, call) {
	  if (!self) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }
	
	  return call && (typeof call === "object" || typeof call === "function") ? call : self;
	};
	
	/**
	 * @file aes.js
	 *
	 * This file contains an adaptation of the AES decryption algorithm
	 * from the Standford Javascript Cryptography Library. That work is
	 * covered by the following copyright and permissions notice:
	 *
	 * Copyright 2009-2010 Emily Stark, Mike Hamburg, Dan Boneh.
	 * All rights reserved.
	 *
	 * Redistribution and use in source and binary forms, with or without
	 * modification, are permitted provided that the following conditions are
	 * met:
	 *
	 * 1. Redistributions of source code must retain the above copyright
	 *    notice, this list of conditions and the following disclaimer.
	 *
	 * 2. Redistributions in binary form must reproduce the above
	 *    copyright notice, this list of conditions and the following
	 *    disclaimer in the documentation and/or other materials provided
	 *    with the distribution.
	 *
	 * THIS SOFTWARE IS PROVIDED BY THE AUTHORS ``AS IS'' AND ANY EXPRESS OR
	 * IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
	 * WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE
	 * DISCLAIMED. IN NO EVENT SHALL <COPYRIGHT HOLDER> OR CONTRIBUTORS BE
	 * LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR
	 * CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF
	 * SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR PROFITS; OR
	 * BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY,
	 * WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE
	 * OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN
	 * IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
	 *
	 * The views and conclusions contained in the software and documentation
	 * are those of the authors and should not be interpreted as representing
	 * official policies, either expressed or implied, of the authors.
	 */
	
	/**
	 * Expand the S-box tables.
	 *
	 * @private
	 */
	var precompute = function precompute() {
	  var tables = [[[], [], [], [], []], [[], [], [], [], []]];
	  var encTable = tables[0];
	  var decTable = tables[1];
	  var sbox = encTable[4];
	  var sboxInv = decTable[4];
	  var i = void 0;
	  var x = void 0;
	  var xInv = void 0;
	  var d = [];
	  var th = [];
	  var x2 = void 0;
	  var x4 = void 0;
	  var x8 = void 0;
	  var s = void 0;
	  var tEnc = void 0;
	  var tDec = void 0;
	
	  // Compute double and third tables
	  for (i = 0; i < 256; i++) {
	    th[(d[i] = i << 1 ^ (i >> 7) * 283) ^ i] = i;
	  }
	
	  for (x = xInv = 0; !sbox[x]; x ^= x2 || 1, xInv = th[xInv] || 1) {
	    // Compute sbox
	    s = xInv ^ xInv << 1 ^ xInv << 2 ^ xInv << 3 ^ xInv << 4;
	    s = s >> 8 ^ s & 255 ^ 99;
	    sbox[x] = s;
	    sboxInv[s] = x;
	
	    // Compute MixColumns
	    x8 = d[x4 = d[x2 = d[x]]];
	    tDec = x8 * 0x1010101 ^ x4 * 0x10001 ^ x2 * 0x101 ^ x * 0x1010100;
	    tEnc = d[s] * 0x101 ^ s * 0x1010100;
	
	    for (i = 0; i < 4; i++) {
	      encTable[i][x] = tEnc = tEnc << 24 ^ tEnc >>> 8;
	      decTable[i][s] = tDec = tDec << 24 ^ tDec >>> 8;
	    }
	  }
	
	  // Compactify. Considerable speedup on Firefox.
	  for (i = 0; i < 5; i++) {
	    encTable[i] = encTable[i].slice(0);
	    decTable[i] = decTable[i].slice(0);
	  }
	  return tables;
	};
	var aesTables = null;
	
	/**
	 * Schedule out an AES key for both encryption and decryption. This
	 * is a low-level class. Use a cipher mode to do bulk encryption.
	 *
	 * @class AES
	 * @param key {Array} The key as an array of 4, 6 or 8 words.
	 */
	
	var AES = function () {
	  function AES(key) {
	    classCallCheck(this, AES);
	
	    /**
	     * The expanded S-box and inverse S-box tables. These will be computed
	     * on the client so that we don't have to send them down the wire.
	     *
	     * There are two tables, _tables[0] is for encryption and
	     * _tables[1] is for decryption.
	     *
	     * The first 4 sub-tables are the expanded S-box with MixColumns. The
	     * last (_tables[01][4]) is the S-box itself.
	     *
	     * @private
	     */
	    // if we have yet to precompute the S-box tables
	    // do so now
	    if (!aesTables) {
	      aesTables = precompute();
	    }
	    // then make a copy of that object for use
	    this._tables = [[aesTables[0][0].slice(), aesTables[0][1].slice(), aesTables[0][2].slice(), aesTables[0][3].slice(), aesTables[0][4].slice()], [aesTables[1][0].slice(), aesTables[1][1].slice(), aesTables[1][2].slice(), aesTables[1][3].slice(), aesTables[1][4].slice()]];
	    var i = void 0;
	    var j = void 0;
	    var tmp = void 0;
	    var encKey = void 0;
	    var decKey = void 0;
	    var sbox = this._tables[0][4];
	    var decTable = this._tables[1];
	    var keyLen = key.length;
	    var rcon = 1;
	
	    if (keyLen !== 4 && keyLen !== 6 && keyLen !== 8) {
	      throw new Error('Invalid aes key size');
	    }
	
	    encKey = key.slice(0);
	    decKey = [];
	    this._key = [encKey, decKey];
	
	    // schedule encryption keys
	    for (i = keyLen; i < 4 * keyLen + 28; i++) {
	      tmp = encKey[i - 1];
	
	      // apply sbox
	      if (i % keyLen === 0 || keyLen === 8 && i % keyLen === 4) {
	        tmp = sbox[tmp >>> 24] << 24 ^ sbox[tmp >> 16 & 255] << 16 ^ sbox[tmp >> 8 & 255] << 8 ^ sbox[tmp & 255];
	
	        // shift rows and add rcon
	        if (i % keyLen === 0) {
	          tmp = tmp << 8 ^ tmp >>> 24 ^ rcon << 24;
	          rcon = rcon << 1 ^ (rcon >> 7) * 283;
	        }
	      }
	
	      encKey[i] = encKey[i - keyLen] ^ tmp;
	    }
	
	    // schedule decryption keys
	    for (j = 0; i; j++, i--) {
	      tmp = encKey[j & 3 ? i : i - 4];
	      if (i <= 4 || j < 4) {
	        decKey[j] = tmp;
	      } else {
	        decKey[j] = decTable[0][sbox[tmp >>> 24]] ^ decTable[1][sbox[tmp >> 16 & 255]] ^ decTable[2][sbox[tmp >> 8 & 255]] ^ decTable[3][sbox[tmp & 255]];
	      }
	    }
	  }
	
	  /**
	   * Decrypt 16 bytes, specified as four 32-bit words.
	   *
	   * @param {Number} encrypted0 the first word to decrypt
	   * @param {Number} encrypted1 the second word to decrypt
	   * @param {Number} encrypted2 the third word to decrypt
	   * @param {Number} encrypted3 the fourth word to decrypt
	   * @param {Int32Array} out the array to write the decrypted words
	   * into
	   * @param {Number} offset the offset into the output array to start
	   * writing results
	   * @return {Array} The plaintext.
	   */
	
	
	  AES.prototype.decrypt = function decrypt(encrypted0, encrypted1, encrypted2, encrypted3, out, offset) {
	    var key = this._key[1];
	    // state variables a,b,c,d are loaded with pre-whitened data
	    var a = encrypted0 ^ key[0];
	    var b = encrypted3 ^ key[1];
	    var c = encrypted2 ^ key[2];
	    var d = encrypted1 ^ key[3];
	    var a2 = void 0;
	    var b2 = void 0;
	    var c2 = void 0;
	
	    // key.length === 2 ?
	    var nInnerRounds = key.length / 4 - 2;
	    var i = void 0;
	    var kIndex = 4;
	    var table = this._tables[1];
	
	    // load up the tables
	    var table0 = table[0];
	    var table1 = table[1];
	    var table2 = table[2];
	    var table3 = table[3];
	    var sbox = table[4];
	
	    // Inner rounds. Cribbed from OpenSSL.
	    for (i = 0; i < nInnerRounds; i++) {
	      a2 = table0[a >>> 24] ^ table1[b >> 16 & 255] ^ table2[c >> 8 & 255] ^ table3[d & 255] ^ key[kIndex];
	      b2 = table0[b >>> 24] ^ table1[c >> 16 & 255] ^ table2[d >> 8 & 255] ^ table3[a & 255] ^ key[kIndex + 1];
	      c2 = table0[c >>> 24] ^ table1[d >> 16 & 255] ^ table2[a >> 8 & 255] ^ table3[b & 255] ^ key[kIndex + 2];
	      d = table0[d >>> 24] ^ table1[a >> 16 & 255] ^ table2[b >> 8 & 255] ^ table3[c & 255] ^ key[kIndex + 3];
	      kIndex += 4;
	      a = a2;b = b2;c = c2;
	    }
	
	    // Last round.
	    for (i = 0; i < 4; i++) {
	      out[(3 & -i) + offset] = sbox[a >>> 24] << 24 ^ sbox[b >> 16 & 255] << 16 ^ sbox[c >> 8 & 255] << 8 ^ sbox[d & 255] ^ key[kIndex++];
	      a2 = a;a = b;b = c;c = d;d = a2;
	    }
	  };
	
	  return AES;
	}();
	
	/**
	 * @file stream.js
	 */
	/**
	 * A lightweight readable stream implemention that handles event dispatching.
	 *
	 * @class Stream
	 */
	var Stream = function () {
	  function Stream() {
	    classCallCheck(this, Stream);
	
	    this.listeners = {};
	  }
	
	  /**
	   * Add a listener for a specified event type.
	   *
	   * @param {String} type the event name
	   * @param {Function} listener the callback to be invoked when an event of
	   * the specified type occurs
	   */
	
	
	  Stream.prototype.on = function on(type, listener) {
	    if (!this.listeners[type]) {
	      this.listeners[type] = [];
	    }
	    this.listeners[type].push(listener);
	  };
	
	  /**
	   * Remove a listener for a specified event type.
	   *
	   * @param {String} type the event name
	   * @param {Function} listener  a function previously registered for this
	   * type of event through `on`
	   * @return {Boolean} if we could turn it off or not
	   */
	
	
	  Stream.prototype.off = function off(type, listener) {
	    if (!this.listeners[type]) {
	      return false;
	    }
	
	    var index = this.listeners[type].indexOf(listener);
	
	    this.listeners[type].splice(index, 1);
	    return index > -1;
	  };
	
	  /**
	   * Trigger an event of the specified type on this stream. Any additional
	   * arguments to this function are passed as parameters to event listeners.
	   *
	   * @param {String} type the event name
	   */
	
	
	  Stream.prototype.trigger = function trigger(type) {
	    var callbacks = this.listeners[type];
	
	    if (!callbacks) {
	      return;
	    }
	
	    // Slicing the arguments on every invocation of this method
	    // can add a significant amount of overhead. Avoid the
	    // intermediate object creation for the common case of a
	    // single callback argument
	    if (arguments.length === 2) {
	      var length = callbacks.length;
	
	      for (var i = 0; i < length; ++i) {
	        callbacks[i].call(this, arguments[1]);
	      }
	    } else {
	      var args = Array.prototype.slice.call(arguments, 1);
	      var _length = callbacks.length;
	
	      for (var _i = 0; _i < _length; ++_i) {
	        callbacks[_i].apply(this, args);
	      }
	    }
	  };
	
	  /**
	   * Destroys the stream and cleans up.
	   */
	
	
	  Stream.prototype.dispose = function dispose() {
	    this.listeners = {};
	  };
	  /**
	   * Forwards all `data` events on this stream to the destination stream. The
	   * destination stream should provide a method `push` to receive the data
	   * events as they arrive.
	   *
	   * @param {Stream} destination the stream that will receive all `data` events
	   * @see http://nodejs.org/api/stream.html#stream_readable_pipe_destination_options
	   */
	
	
	  Stream.prototype.pipe = function pipe(destination) {
	    this.on('data', function (data) {
	      destination.push(data);
	    });
	  };
	
	  return Stream;
	}();
	
	/**
	 * @file async-stream.js
	 */
	/**
	 * A wrapper around the Stream class to use setTiemout
	 * and run stream "jobs" Asynchronously
	 *
	 * @class AsyncStream
	 * @extends Stream
	 */
	
	var AsyncStream = function (_Stream) {
	  inherits(AsyncStream, _Stream);
	
	  function AsyncStream() {
	    classCallCheck(this, AsyncStream);
	
	    var _this = possibleConstructorReturn(this, _Stream.call(this, Stream));
	
	    _this.jobs = [];
	    _this.delay = 1;
	    _this.timeout_ = null;
	    return _this;
	  }
	
	  /**
	   * process an async job
	   *
	   * @private
	   */
	
	
	  AsyncStream.prototype.processJob_ = function processJob_() {
	    this.jobs.shift()();
	    if (this.jobs.length) {
	      this.timeout_ = setTimeout(this.processJob_.bind(this), this.delay);
	    } else {
	      this.timeout_ = null;
	    }
	  };
	
	  /**
	   * push a job into the stream
	   *
	   * @param {Function} job the job to push into the stream
	   */
	
	
	  AsyncStream.prototype.push = function push(job) {
	    this.jobs.push(job);
	    if (!this.timeout_) {
	      this.timeout_ = setTimeout(this.processJob_.bind(this), this.delay);
	    }
	  };
	
	  return AsyncStream;
	}(Stream);
	
	/**
	 * @file decrypter.js
	 *
	 * An asynchronous implementation of AES-128 CBC decryption with
	 * PKCS#7 padding.
	 */
	
	/**
	 * Convert network-order (big-endian) bytes into their little-endian
	 * representation.
	 */
	var ntoh = function ntoh(word) {
	  return word << 24 | (word & 0xff00) << 8 | (word & 0xff0000) >> 8 | word >>> 24;
	};
	
	/**
	 * Decrypt bytes using AES-128 with CBC and PKCS#7 padding.
	 *
	 * @param {Uint8Array} encrypted the encrypted bytes
	 * @param {Uint32Array} key the bytes of the decryption key
	 * @param {Uint32Array} initVector the initialization vector (IV) to
	 * use for the first round of CBC.
	 * @return {Uint8Array} the decrypted bytes
	 *
	 * @see http://en.wikipedia.org/wiki/Advanced_Encryption_Standard
	 * @see http://en.wikipedia.org/wiki/Block_cipher_mode_of_operation#Cipher_Block_Chaining_.28CBC.29
	 * @see https://tools.ietf.org/html/rfc2315
	 */
	var decrypt = function decrypt(encrypted, key, initVector) {
	  // word-level access to the encrypted bytes
	  var encrypted32 = new Int32Array(encrypted.buffer, encrypted.byteOffset, encrypted.byteLength >> 2);
	
	  var decipher = new AES(Array.prototype.slice.call(key));
	
	  // byte and word-level access for the decrypted output
	  var decrypted = new Uint8Array(encrypted.byteLength);
	  var decrypted32 = new Int32Array(decrypted.buffer);
	
	  // temporary variables for working with the IV, encrypted, and
	  // decrypted data
	  var init0 = void 0;
	  var init1 = void 0;
	  var init2 = void 0;
	  var init3 = void 0;
	  var encrypted0 = void 0;
	  var encrypted1 = void 0;
	  var encrypted2 = void 0;
	  var encrypted3 = void 0;
	
	  // iteration variable
	  var wordIx = void 0;
	
	  // pull out the words of the IV to ensure we don't modify the
	  // passed-in reference and easier access
	  init0 = initVector[0];
	  init1 = initVector[1];
	  init2 = initVector[2];
	  init3 = initVector[3];
	
	  // decrypt four word sequences, applying cipher-block chaining (CBC)
	  // to each decrypted block
	  for (wordIx = 0; wordIx < encrypted32.length; wordIx += 4) {
	    // convert big-endian (network order) words into little-endian
	    // (javascript order)
	    encrypted0 = ntoh(encrypted32[wordIx]);
	    encrypted1 = ntoh(encrypted32[wordIx + 1]);
	    encrypted2 = ntoh(encrypted32[wordIx + 2]);
	    encrypted3 = ntoh(encrypted32[wordIx + 3]);
	
	    // decrypt the block
	    decipher.decrypt(encrypted0, encrypted1, encrypted2, encrypted3, decrypted32, wordIx);
	
	    // XOR with the IV, and restore network byte-order to obtain the
	    // plaintext
	    decrypted32[wordIx] = ntoh(decrypted32[wordIx] ^ init0);
	    decrypted32[wordIx + 1] = ntoh(decrypted32[wordIx + 1] ^ init1);
	    decrypted32[wordIx + 2] = ntoh(decrypted32[wordIx + 2] ^ init2);
	    decrypted32[wordIx + 3] = ntoh(decrypted32[wordIx + 3] ^ init3);
	
	    // setup the IV for the next round
	    init0 = encrypted0;
	    init1 = encrypted1;
	    init2 = encrypted2;
	    init3 = encrypted3;
	  }
	
	  return decrypted;
	};
	
	/**
	 * The `Decrypter` class that manages decryption of AES
	 * data through `AsyncStream` objects and the `decrypt`
	 * function
	 *
	 * @param {Uint8Array} encrypted the encrypted bytes
	 * @param {Uint32Array} key the bytes of the decryption key
	 * @param {Uint32Array} initVector the initialization vector (IV) to
	 * @param {Function} done the function to run when done
	 * @class Decrypter
	 */
	
	var Decrypter = function () {
	  function Decrypter(encrypted, key, initVector, done) {
	    classCallCheck(this, Decrypter);
	
	    var step = Decrypter.STEP;
	    var encrypted32 = new Int32Array(encrypted.buffer);
	    var decrypted = new Uint8Array(encrypted.byteLength);
	    var i = 0;
	
	    this.asyncStream_ = new AsyncStream();
	
	    // split up the encryption job and do the individual chunks asynchronously
	    this.asyncStream_.push(this.decryptChunk_(encrypted32.subarray(i, i + step), key, initVector, decrypted));
	    for (i = step; i < encrypted32.length; i += step) {
	      initVector = new Uint32Array([ntoh(encrypted32[i - 4]), ntoh(encrypted32[i - 3]), ntoh(encrypted32[i - 2]), ntoh(encrypted32[i - 1])]);
	      this.asyncStream_.push(this.decryptChunk_(encrypted32.subarray(i, i + step), key, initVector, decrypted));
	    }
	    // invoke the done() callback when everything is finished
	    this.asyncStream_.push(function () {
	      // remove pkcs#7 padding from the decrypted bytes
	      done(null, pkcs7.unpad(decrypted));
	    });
	  }
	
	  /**
	   * a getter for step the maximum number of bytes to process at one time
	   *
	   * @return {Number} the value of step 32000
	   */
	
	
	  /**
	   * @private
	   */
	  Decrypter.prototype.decryptChunk_ = function decryptChunk_(encrypted, key, initVector, decrypted) {
	    return function () {
	      var bytes = decrypt(encrypted, key, initVector);
	
	      decrypted.set(bytes, encrypted.byteOffset);
	    };
	  };
	
	  createClass(Decrypter, null, [{
	    key: 'STEP',
	    get: function get$$1() {
	      // 4 * 8000;
	      return 32000;
	    }
	  }]);
	  return Decrypter;
	}();
	
	/**
	 * @file index.js
	 *
	 * Index module to easily import the primary components of AES-128
	 * decryption. Like this:
	 *
	 * ```js
	 * import {Decrypter, decrypt, AsyncStream} from 'aes-decrypter';
	 * ```
	 */
	
	exports.decrypt = decrypt;
	exports.Decrypter = Decrypter;
	exports.AsyncStream = AsyncStream;


/***/ },
/* 439 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRouter = __webpack_require__(45);
	
	var _reactRedux = __webpack_require__(5);
	
	var _redux = __webpack_require__(4);
	
	var _initActions = __webpack_require__(64);
	
	var initActions = _interopRequireWildcard(_initActions);
	
	var _trackingDataActions = __webpack_require__(7);
	
	var trackingDataActions = _interopRequireWildcard(_trackingDataActions);
	
	var _userDataActions = __webpack_require__(20);
	
	var userDataActions = _interopRequireWildcard(_userDataActions);
	
	var _resourcesActions = __webpack_require__(150);
	
	var resourceActions = _interopRequireWildcard(_resourcesActions);
	
	var _objectConstants = __webpack_require__(9);
	
	var objectConstants = _interopRequireWildcard(_objectConstants);
	
	var _appConstants = __webpack_require__(13);
	
	var appConstants = _interopRequireWildcard(_appConstants);
	
	var _appModels = __webpack_require__(68);
	
	var _AppFooter = __webpack_require__(442);
	
	var _AppFooter2 = _interopRequireDefault(_AppFooter);
	
	var _actionTypes = __webpack_require__(22);
	
	var actionTypes = _interopRequireWildcard(_actionTypes);
	
	var _appHelper = __webpack_require__(3);
	
	var appHelper = _interopRequireWildcard(_appHelper);
	
	var _dataHelper = __webpack_require__(11);
	
	var dataHelper = _interopRequireWildcard(_dataHelper);
	
	var _localStorage = __webpack_require__(17);
	
	var localStorage = _interopRequireWildcard(_localStorage);
	
	var _keyboardConstants = __webpack_require__(14);
	
	var keyboardConstants = _interopRequireWildcard(_keyboardConstants);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var App = function (_React$Component) {
	    _inherits(App, _React$Component);
	
	    function App(props, context) {
	        _classCallCheck(this, App);
	
	        var _this = _possibleConstructorReturn(this, (App.__proto__ || Object.getPrototypeOf(App)).call(this, props, context));
	
	        _this.state = {
	            lang: _this.props.lang,
	            showFooter: false,
	            lesson_location: _this.props.lesson_location,
	            tracking_type: _this.props.tracking_type,
	            activeResourcesId: _this.props.activeResourcesId,
	            audio: _this.props.audio,
	            fontSize: _this.props.fontSize,
	            showResources: false,
	            checkForUpdate: false,
	            bookmark: 0,
	            audioFiles: [],
	            dataReady: false,
	            audioLoaded: false,
	            checkPlayAudio: false,
	            audioIsPlaying: false,
	            audioQue: []
	        };
	
	        _this.redirect = _this.redirect.bind(_this);
	        _this.onUnload = _this.onUnload.bind(_this);
	        _this.setFooter = _this.setFooter.bind(_this);
	        _this.footerTextExists = _this.footerTextExists.bind(_this);
	        _this.onMessage = _this.onMessage.bind(_this);
	        _this.setScreenId = _this.setScreenId.bind(_this);
	        _this.openResources = _this.openResources.bind(_this);
	        _this.goToBite = _this.goToBite.bind(_this);
	        _this.getAudioFiles = _this.getAudioFiles.bind(_this);
	        _this.getAssetPath = _this.getAssetPath.bind(_this);
	        _this.readyAudio = _this.readyAudio.bind(_this);
	        _this.checkAudio = _this.checkAudio.bind(_this);
	        _this.playAudioRef = _this.playAudioRef.bind(_this);
	        _this.pauseAudioRef = _this.pauseAudioRef.bind(_this);
	        _this.skipToMainContent = _this.skipToMainContent.bind(_this);
	        _this.onSetLanguage = _this.onSetLanguage.bind(_this);
	        return _this;
	    }
	
	    _createClass(App, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            var app = document.getElementById("app");
	            app.style.fontSize = this.state.fontSize.currentFontSize + '%';
	            window.addEventListener("beforeunload", this.onUnload);
	            window.addEventListener("message", this.onMessage, false);
	            var path = '/';
	            this.redirect(path);
	        }
	    }, {
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(nextProps) {
	            if (appHelper.isDefined(this.props.contentData.experience) && !this.state.showFooter) {
	                this.setFooter();
	            }
	
	            if (this.state.tracking_type !== nextProps.tracking_type) {
	                this.setState({ tracking_type: nextProps.tracking_type });
	            }
	
	            if (this.state.lesson_location !== nextProps.lesson_location && !isNaN(nextProps.lesson_location) && this.state.tracking_type === appConstants.TRACKING_TYPE_OPEN) {
	                this.setState({ lesson_location: nextProps.lesson_location });
	                window.parent.postMessage({
	                    'func': 'setScreenId',
	                    'message': nextProps.lesson_location
	                }, "*");
	            }
	
	            if (this.state.lang !== nextProps.lang) {
	                this.setState({ lang: nextProps.lang });
	                window.parent.postMessage({
	                    'func': 'onSetLanguage',
	                    'message': nextProps.lang
	                }, "*");
	            }
	
	            if (this.state.activeResourcesId !== nextProps.activeResourcesId) {
	                this.setState({ activeResourcesId: nextProps.activeResourcesId, showResources: true });
	            }
	
	            if (!this.state.dataReady && appHelper.isDefined(this.props.contentData.experience) && appHelper.isDefined(this.props.contentData.experience.experience_id)) {
	                this.getAudioFiles();
	            }
	
	            if (this.state.audio.audioRef !== nextProps.audio.audioRef) {
	                if (nextProps.audio.audioRef.length > 0) {
	                    if (appHelper.getArrayObjectIndexByKey(this.state.audioQue, "audioRef", nextProps.audio.audioRef) === -1) {
	                        this.setState({
	                            audio: Object.assign({}, nextProps.audio),
	                            audioQue: dataHelper.immutablePush(this.state.audioQue, nextProps.audio)
	                        });
	                    }
	                } else {
	                    this.pauseAudioRef(this.state.audioQue[0]);
	                    var audioQue = dataHelper.immutableSplice(this.state.audioQue, 0, this.state.audioQue.length);
	                    this.setState({
	                        audio: Object.assign({}, nextProps.audio),
	                        audioQue: audioQue,
	                        audioIsPlaying: false
	                    });
	                }
	            }
	            if (this.state.fontSize !== nextProps.fontSize) {
	                this.setState({ fontSize: nextProps.fontSize });
	                var app = document.getElementById("app");
	                app.style.fontSize = nextProps.fontSize.currentFontSize + '%';
	            }
	        }
	    }, {
	        key: 'componentDidUpdate',
	        value: function componentDidUpdate() {
	            if (this.state.showResources) {
	                this.openResources();
	            }
	
	            if (this.state.checkForUpdate && this.state.bookmark !== 0) {
	                this.goToBite();
	            }
	
	            if (this.state.audioFiles.length > 0 && !this.state.audioLoaded) {
	                this.readyAudio();
	            }
	
	            if (!this.state.audioIsPlaying && this.state.audioQue.length > 0) {
	                this.playAudioRef();
	            }
	        }
	    }, {
	        key: 'componentWillUnmount',
	        value: function componentWillUnmount() {
	            window.removeEventListener("beforeunload", this.onUnload);
	            window.removeEventListener("message", this.onMessage, false);
	        }
	    }, {
	        key: 'getAudioFiles',
	        value: function getAudioFiles() {
	            this.setState({
	                dataReady: true,
	                audioFiles: Object.assign([], appHelper.getAudioToPreload(this.props.contentData.experience.assets))
	            });
	        }
	    }, {
	        key: 'onMessage',
	        value: function onMessage(e) {
	            var data = e.data;
	            if (appHelper.isDefined(data.message)) {
	                if (appHelper.isDefined(data.message.screen_id)) {
	                    this.setScreenId(data.message);
	                } else if (appHelper.isDefined(data.message.language_code)) {
	                    this.onSetLanguage(data.message.language_code);
	                }
	            }
	        }
	    }, {
	        key: 'onSetLanguage',
	        value: function onSetLanguage(language_code) {
	            this.props.actions.updateExperienceLocale(language_code);
	        }
	    }, {
	        key: 'setScreenId',
	        value: function setScreenId(message) {
	            if (appHelper.isDefined(message)) {
	                if (appHelper.isDefined(message.screen_type) && appHelper.isDefined(message.screen_id)) {
	                    if (message.screen_type === objectConstants.TYPE_MENU && message.screen_id === -1) {
	                        this.context.router.push('/menu');
	                    } else if (message.screen_type === objectConstants.TYPE_RESOURCE) {
	                        var resourceProps = Object.assign({}, _appModels.RESOURCE_PROPS, {
	                            activeResourcesId: message.screen_id,
	                            sourceId: ""
	                        });
	                        this.props.actions.setResourcesProps(resourceProps);
	                    } else if (message.screen_type === objectConstants.TYPE_SCREEN) {
	                        var bookmark = appHelper.getBiteByScreenId(message.screen_id);
	                        this.props.actions.setNewLessonLocation(message.screen_id);
	                        this.context.router.push('/' + bookmark);
	                    }
	                }
	            }
	        }
	    }, {
	        key: 'goToBite',
	        value: function goToBite() {
	            this.setState({ checkForUpdate: false });
	            this.context.router.push(this.state.bookmark);
	        }
	    }, {
	        key: 'footerTextExists',
	        value: function footerTextExists() {
	            if (appHelper.isDefined(this.props.contentData.experience)) {
	                var locale = appHelper.getLocalData(this.props.contentData.experience);
	                return appHelper.isDefined(locale.footer_text) && locale.footer_text.length > 0;
	            } else {
	                return false;
	            }
	        }
	    }, {
	        key: 'setFooter',
	        value: function setFooter() {
	            this.setState({ showFooter: this.footerTextExists() });
	        }
	    }, {
	        key: 'redirect',
	        value: function redirect(path) {
	            this.context.router.push(path);
	        }
	    }, {
	        key: 'onUnload',
	        value: function onUnload(event) {
	            this.props.actions.doQuickLMSCommit(this.props.contentData.experience.tracking_type);
	            this.props.actions.doQuickLMSFinish(this.props.contentData.experience.tracking_type);
	            event.returnValue = "";
	        }
	    }, {
	        key: 'openResources',
	        value: function openResources() {
	            this.setState({ showResources: false });
	            if (this.state.activeResourcesId !== 0 && this.props.displayResources === actionTypes.STATUS_CLOSED) {
	                // this.props.actions.setResourcesDisplay(actionTypes.STATUS_OPENING);
	            }
	        }
	    }, {
	        key: 'playAudioRef',
	        value: function playAudioRef() {
	            var audioRef = this.refs['' + this.state.audioQue[0].audioRef];
	            if (appHelper.isDefined(audioRef)) {
	                audioRef.currentTime = 0;
	                audioRef.play();
	
	                audioRef.onplay = function () {
	                    this.setState({ audioIsPlaying: true });
	                }.bind(this);
	
	                audioRef.onended = function () {
	                    var audioQue = dataHelper.immutableSplice(this.state.audioQue, 0, 1);
	                    this.setState({
	                        audioQue: Object.assign([], audioQue),
	                        audioIsPlaying: false
	                    });
	                }.bind(this);
	            }
	        }
	    }, {
	        key: 'pauseAudioRef',
	        value: function pauseAudioRef(audio) {
	            if (appHelper.isDefined(audio)) {
	                var audioRef = this.refs['' + audio.audioRef];
	                if (appHelper.isDefined(audioRef)) {
	                    audioRef.pause();
	                }
	            }
	        }
	    }, {
	        key: 'getAssetPath',
	        value: function getAssetPath(asset) {
	            if (appConstants.DEVELOPMENT_MODE) {
	                if (appHelper.isDefined(asset) && asset.length > 0) {
	                    return __webpack_require__(16)("./" + asset);
	                }
	            } else {
	                return asset;
	            }
	        }
	    }, {
	        key: 'checkAudio',
	        value: function checkAudio() {
	            //this.readyAudio();
	        }
	    }, {
	        key: 'readyAudio',
	        value: function readyAudio() {
	
	            this.setState({ audioLoaded: true });
	            for (var i = 0; i < this.state.audioFiles.length; i++) {
	                var audio = this.state.audioFiles[i];
	                var audioRef = this.refs['audio_' + audio.id + '_' + audio.type];
	                if (appHelper.isDefined(audioRef)) {
	                    audioRef.load();
	                    audioRef.currentTime = 0;
	                    audioRef.pause();
	                }
	            }
	        }
	    }, {
	        key: 'skipToMainContent',
	        value: function skipToMainContent(event) {
	            var targetEl = document.getElementById("appScreen");
	            targetEl.focus();
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this2 = this;
	
	            return _react2.default.createElement(
	                'div',
	                { className: 'main-content-wrapper' },
	                _react2.default.createElement(
	                    'button',
	                    { id: 'skipToMainContent', className: 'hidden-el', style: { background: "red" }, tabIndex: '0', onClick: this.skipToMainContent, onKeyDown: this.skipToMainContent },
	                    'Skip to main content'
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'main', id: 'main-wrapper' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'content-body' },
	                        this.props.children
	                    )
	                ),
	                this.state.showFooter ? _react2.default.createElement(_AppFooter2.default, null) : null,
	                this.state.audioFiles.length > 0 ? this.state.audioFiles.map(function (audio) {
	                    return _react2.default.createElement('audio', { key: 'audio_' + audio.id + '_' + audio.type, ref: 'audio_' + audio.id + '_' + audio.type,
	                        src: _this2.getAssetPath(audio.src), preload: 'auto' });
	                }) : null
	            );
	        }
	    }]);
	
	    return App;
	}(_react2.default.Component);
	
	App.propTypes = {
	    children: _propTypes2.default.object.isRequired,
	    navigation: _propTypes2.default.object,
	    actions: _propTypes2.default.object.isRequired,
	    dialogPopup: _propTypes2.default.object.isRequired,
	    contentData: _propTypes2.default.object.isRequired,
	    displayMainMenu: _propTypes2.default.string.isRequired,
	    displayResources: _propTypes2.default.string.isRequired,
	    lesson_location: _propTypes2.default.number.isRequired,
	    tracking_type: _propTypes2.default.string.isRequired,
	    activeResourcesId: _propTypes2.default.number.isRequired,
	    audio: _propTypes2.default.object.isRequired,
	    fontSize: _propTypes2.default.object.isRequired,
	    lang: _propTypes2.default.string.isRequired
	};
	
	App.contextTypes = {
	    router: _propTypes2.default.object
	};
	
	function mapStateToProps(state, ownProps) {
	    var lesson_location = 0;
	    var tracking_type = "";
	
	    if (appHelper.isDefined(state.trackingData)) {
	        lesson_location = state.trackingData.lesson_location;
	    }
	
	    if (appHelper.isDefined(state.contentData.experience)) {
	        tracking_type = state.contentData.experience.tracking_type;
	    }
	    return {
	        navigation: state.navigation,
	        dialogPopup: state.dialogPopup,
	        contentData: state.contentData,
	        displayMainMenu: state.displayMainMenu,
	        displayResources: state.displayResources,
	        lesson_location: parseInt(lesson_location),
	        tracking_type: tracking_type,
	        activeResourcesId: state.resourceProps.activeResourcesId,
	        audio: state.audio,
	        fontSize: state.fontSize,
	        lang: appHelper.isDefined(state.userData.lang) ? state.userData.lang : ""
	    };
	}
	
	function mapDispatchToProps(dispatch) {
	    return {
	        actions: (0, _redux.bindActionCreators)(Object.assign({}, initActions, trackingDataActions, resourceActions, userDataActions), dispatch)
	    };
	}
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(App);

/***/ },
/* 440 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRouter = __webpack_require__(45);
	
	var _reactRedux = __webpack_require__(5);
	
	var _redux = __webpack_require__(4);
	
	var _appDataActions = __webpack_require__(12);
	
	var appDataActions = _interopRequireWildcard(_appDataActions);
	
	var _trackingDataActions = __webpack_require__(7);
	
	var trackingDataActions = _interopRequireWildcard(_trackingDataActions);
	
	var _appHelper = __webpack_require__(3);
	
	var appHelper = _interopRequireWildcard(_appHelper);
	
	var _componentHelper = __webpack_require__(31);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var AppBite = function (_React$Component) {
	    _inherits(AppBite, _React$Component);
	
	    function AppBite(props, context) {
	        _classCallCheck(this, AppBite);
	
	        var _this = _possibleConstructorReturn(this, (AppBite.__proto__ || Object.getPrototypeOf(AppBite)).call(this, props, context));
	
	        _this.state = {
	            bite: _this.props.bite,
	            bite_type: {}
	        };
	
	        _this.getBiteType = _this.getBiteType.bind(_this);
	        return _this;
	    }
	
	    _createClass(AppBite, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            //console.log(this.state.md.mobile());
	            this.getBiteType();
	        }
	    }, {
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(nextProps) {
	            if (this.state.bite.bite_id !== nextProps.bite.bite_id) {
	                this.setState({
	                    bite: Object.assign({}, nextProps.bite),
	                    bite_type: Object.assign({}, {})
	                });
	            }
	        }
	    }, {
	        key: 'componentDidUpdate',
	        value: function componentDidUpdate() {
	            if (appHelper.isDefined(this.state.bite.bite_id) && !appHelper.isDefined(this.state.bite_type.component)) {
	                this.getBiteType();
	            }
	        }
	    }, {
	        key: 'getBiteType',
	        value: function getBiteType() {
	            var biteType = Object.assign({}, (0, _componentHelper.getBiteComponentByType)(this.state.bite.bite_type));
	            this.setState({ bite_type: Object.assign({}, biteType) });
	            this.props.actions.clearAudio();
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	
	            return _react2.default.createElement(
	                'div',
	                { className: 'app-bite' },
	                typeof this.state.bite_type.component !== 'undefined' ? _react2.default.createElement(this.state.bite_type.component, { bite: this.state.bite }) : null
	            );
	        }
	    }]);
	
	    return AppBite;
	}(_react2.default.Component);
	
	AppBite.propTypes = {
	    bite: _propTypes2.default.object.isRequired,
	    actions: _propTypes2.default.object.isRequired
	};
	
	AppBite.contextTypes = {
	    router: _propTypes2.default.object
	};
	
	function mapStateToProps(state, ownProps) {
	    var bite_id = ownProps.params.bite_id;
	    return {
	        bite: Object.assign({}, appHelper.getBiteById(bite_id))
	    };
	}
	
	function mapDispatchToProps(dispatch) {
	    return {
	        actions: (0, _redux.bindActionCreators)(Object.assign({}, appDataActions, trackingDataActions), dispatch)
	    };
	}
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(AppBite);

/***/ },
/* 441 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(5);
	
	var _redux = __webpack_require__(4);
	
	var _appDataActions = __webpack_require__(12);
	
	var appDataActions = _interopRequireWildcard(_appDataActions);
	
	var _trackingDataActions = __webpack_require__(7);
	
	var trackingDataActions = _interopRequireWildcard(_trackingDataActions);
	
	var _appHelper = __webpack_require__(3);
	
	var appHelper = _interopRequireWildcard(_appHelper);
	
	var _componentHelper = __webpack_require__(31);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var AppBiteMenu = function (_React$Component) {
	    _inherits(AppBiteMenu, _React$Component);
	
	    function AppBiteMenu(props, context) {
	        _classCallCheck(this, AppBiteMenu);
	
	        var _this = _possibleConstructorReturn(this, (AppBiteMenu.__proto__ || Object.getPrototypeOf(AppBiteMenu)).call(this, props, context));
	
	        _this.state = {
	            menu_type: {}
	        };
	
	        _this.getMenuType = _this.getMenuType.bind(_this);
	        return _this;
	    }
	
	    _createClass(AppBiteMenu, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            this.getMenuType();
	        }
	    }, {
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(nextProps) {}
	    }, {
	        key: 'getMenuType',
	        value: function getMenuType() {
	
	            if (appHelper.isDefined(this.props.contentData.experience)) {
	                var menu_type = Object.assign({}, (0, _componentHelper.getMenuComponentByType)(this.props.contentData.experience.experience_learning_model));
	                this.setState({ menu_type: Object.assign({}, menu_type), render: false });
	            }
	            this.props.actions.clearAudio();
	            //let biteType = Object.assign({},getBiteComponentByType(this.state.bite.bite_type));
	            //this.setState({bite_type: Object.assign({},biteType), render: false});
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	
	            return _react2.default.createElement(
	                'div',
	                { className: 'app-bite' },
	                typeof this.state.menu_type.component !== 'undefined' ? _react2.default.createElement(this.state.menu_type.component, null) : null
	            );
	        }
	    }]);
	
	    return AppBiteMenu;
	}(_react2.default.Component);
	
	AppBiteMenu.propTypes = {
	    contentData: _propTypes2.default.object.isRequired,
	    actions: _propTypes2.default.object.isRequired
	};
	
	AppBiteMenu.contextTypes = {
	    router: _propTypes2.default.object
	};
	
	function mapStateToProps(state) {
	    return {
	        contentData: state.contentData
	    };
	}
	
	function mapDispatchToProps(dispatch) {
	    return {
	        actions: (0, _redux.bindActionCreators)(Object.assign({}, appDataActions, trackingDataActions), dispatch)
	    };
	}
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(AppBiteMenu);

/***/ },
/* 442 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRouter = __webpack_require__(45);
	
	var _reactRedux = __webpack_require__(5);
	
	var _redux = __webpack_require__(4);
	
	var _appHelper = __webpack_require__(3);
	
	var appHelper = _interopRequireWildcard(_appHelper);
	
	var _appConstants = __webpack_require__(13);
	
	var appConstants = _interopRequireWildcard(_appConstants);
	
	var _localStorage = __webpack_require__(17);
	
	var localStorage = _interopRequireWildcard(_localStorage);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var AppFooter = function (_React$Component) {
	    _inherits(AppFooter, _React$Component);
	
	    function AppFooter(props, context) {
	        _classCallCheck(this, AppFooter);
	
	        var _this = _possibleConstructorReturn(this, (AppFooter.__proto__ || Object.getPrototypeOf(AppFooter)).call(this, props, context));
	
	        _this.state = {
	            lang: _this.props.lang,
	            locale: {},
	            assets: {
	                logo: {
	                    src: ""
	                }
	            },
	            setLocale: false
	        };
	        _this.getLocale = _this.getLocale.bind(_this);
	        _this.getAssets = _this.getAssets.bind(_this);
	        _this.getImagePath = _this.getImagePath.bind(_this);
	        return _this;
	    }
	
	    _createClass(AppFooter, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            this.getLocale();
	            this.getAssets();
	        }
	    }, {
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(nextProps) {
	            if (this.state.lang !== nextProps.lang) {
	                this.setState({
	                    lang: nextProps.lang,
	                    setLocale: true
	                });
	            }
	        }
	    }, {
	        key: 'componentDidUpdate',
	        value: function componentDidUpdate() {
	            if (this.state.setLocale) {
	                this.getLocale();
	            }
	        }
	    }, {
	        key: 'getLocale',
	        value: function getLocale() {
	            var locale = appHelper.getLocalData(this.props.contentData.experience);
	            this.setState({ locale: Object.assign({}, locale), setLocale: false });
	        }
	    }, {
	        key: 'getAssets',
	        value: function getAssets() {
	
	            var logoAsset = appHelper.getFooterLogoAsset(this.props.contentData.experience.footer_logo);
	            if (appHelper.isDefined(logoAsset)) {
	                this.setState({
	                    assets: Object.assign({}, this.state.assets, {
	                        logo: logoAsset
	                    })
	                });
	            }
	        }
	    }, {
	        key: 'getImagePath',
	        value: function getImagePath(image) {
	            if (appConstants.DEVELOPMENT_MODE) {
	                if (appHelper.isDefined(image) && image.length > 0) {
	                    return __webpack_require__(16)("./" + image);
	                }
	            } else {
	                return image;
	            }
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            return _react2.default.createElement(
	                'div',
	                { className: 'footer' },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'inline-content' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'content-item footer-text' },
	                        appHelper.isDefined(this.state.locale.footer_text) ? _react2.default.createElement('div', { dangerouslySetInnerHTML: { __html: this.state.locale.footer_text } }) : null
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'content-item text-right' },
	                        this.state.assets.logo.src.length > 0 ? _react2.default.createElement(
	                            'div',
	                            { className: 'footer-logo-container' },
	                            appHelper.isDefined(this.state.assets.logo) && this.state.assets.logo.src.length > 0 ? _react2.default.createElement('img', { src: this.getImagePath(this.state.assets.logo.src), alt: '' }) : null
	                        ) : null
	                    )
	                )
	            );
	        }
	    }]);
	
	    return AppFooter;
	}(_react2.default.Component);
	
	AppFooter.propTypes = {
	    contentData: _propTypes2.default.object.isRequired,
	    lang: _propTypes2.default.string
	};
	
	AppFooter.contextTypes = {
	    router: _propTypes2.default.object
	};
	
	function mapStateToProps(state, ownProps) {
	    var lang = state.userData.lang;
	    return {
	        contentData: state.contentData,
	        lang: lang
	    };
	}
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps)(AppFooter);

/***/ },
/* 443 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRouter = __webpack_require__(45);
	
	var _reactRedux = __webpack_require__(5);
	
	var _redux = __webpack_require__(4);
	
	var _appDataActions = __webpack_require__(12);
	
	var appDataActions = _interopRequireWildcard(_appDataActions);
	
	var _trackingDataActions = __webpack_require__(7);
	
	var trackingDataActions = _interopRequireWildcard(_trackingDataActions);
	
	var _appHelper = __webpack_require__(3);
	
	var appHelper = _interopRequireWildcard(_appHelper);
	
	var _componentHelper = __webpack_require__(31);
	
	var _environmentHelper = __webpack_require__(56);
	
	var enviromentHelper = _interopRequireWildcard(_environmentHelper);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var AppScreen = function (_React$Component) {
	    _inherits(AppScreen, _React$Component);
	
	    function AppScreen(props, context) {
	        _classCallCheck(this, AppScreen);
	
	        var _this = _possibleConstructorReturn(this, (AppScreen.__proto__ || Object.getPrototypeOf(AppScreen)).call(this, props, context));
	
	        _this.state = {
	            bite: _this.props.bite,
	            lesson_location: _this.props.trackingData.lesson_location,
	            env: enviromentHelper.getEnvironment(),
	            screen: {},
	            screen_type: {},
	            searchForScreen: true,
	            setFocus: false
	        };
	        _this.getScreen = _this.getScreen.bind(_this);
	        _this.getScreenType = _this.getScreenType.bind(_this);
	        _this.componentWatcher = _this.componentWatcher.bind(_this);
	        _this.setElFocus = _this.setElFocus.bind(_this);
	        return _this;
	    }
	
	    _createClass(AppScreen, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            window.addEventListener("resize", this.componentWatcher);
	            this.getScreen();
	        }
	    }, {
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(nextProps) {
	            if (this.state.lesson_location !== nextProps.trackingData.lesson_location) {
	                this.setState({
	                    lesson_location: nextProps.trackingData.lesson_location,
	                    screen_type: Object.assign({}, {})
	                });
	            }
	        }
	    }, {
	        key: 'componentDidUpdate',
	        value: function componentDidUpdate() {
	            if (typeof this.state.screen_type.component === 'undefined' && this.state.searchForScreen) {
	                this.getScreen();
	            }
	
	            if (this.state.setFocus) {
	                this.setElFocus();
	            }
	        }
	    }, {
	        key: 'componentWillUnmount',
	        value: function componentWillUnmount() {
	            window.removeEventListener("resize", this.componentWatcher);
	        }
	    }, {
	        key: 'componentWatcher',
	        value: function componentWatcher() {
	            var env = enviromentHelper.getEnvironment();
	            if (env.window.size !== this.state.env.window.size || env.window.orientation !== this.state.env.window.orientation) {
	                this.setState({ env: env });
	            }
	        }
	    }, {
	        key: 'getScreen',
	        value: function getScreen() {
	            var screen_id = this.state.lesson_location;
	            var screen = Object.assign({}, this.state.bite.screens[0]);
	            if (!isNaN(parseInt(screen_id))) {
	                screen = Object.assign({}, appHelper.getBiteScreen(this.state.bite.bite_id, screen_id));
	                if (appHelper.isDefined(screen.screen_id)) {
	                    this.getScreenType(screen);
	                    this.setState({ searchForScreen: true });
	                } else {
	                    var bite_id = appHelper.getBiteByScreenId(screen_id);
	                    var bite = appHelper.getBiteById(bite_id);
	                    this.setState({ bite: Object.assign({}, bite) });
	                    this.context.router.push('/' + bite_id);
	                }
	            } else {
	                this.getScreenType(screen);
	                this.setState({ searchForScreen: true });
	            }
	        }
	    }, {
	        key: 'getScreenType',
	        value: function getScreenType(screen) {
	            var screenType = Object.assign({}, (0, _componentHelper.getScreenComponentByType)(screen.screen_type));
	            this.setState({
	                screen: Object.assign({}, screen),
	                screen_type: Object.assign({}, screenType),
	                setFocus: true
	            });
	            this.props.actions.clearAudio();
	        }
	    }, {
	        key: 'setElFocus',
	        value: function setElFocus() {
	            var focusEl = document.getElementById("appScreen");
	            focusEl.focus();
	            this.setState({ setFocus: false });
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var Component = this.state.screen_type.component;
	            if (this.state.screen_type.isAdaptive) {
	                if (appHelper.isDefined(this.state.screen_type.adaptiveComponentSizes[this.state.env.window.size]) && appHelper.isDefined(this.state.screen_type.adaptiveComponentSizes[this.state.env.window.size][this.state.env.window.orientation])) {
	                    Component = this.state.screen_type.adaptiveComponentSizes[this.state.env.window.size][this.state.env.window.orientation];
	                } else {
	                    Component = this.state.screen_type.component;
	                }
	            }
	            return _react2.default.createElement(
	                'div',
	                { className: 'app-screen', id: 'appScreen', role: 'main', tabIndex: '0' },
	                appHelper.isDefined(Component) ? _react2.default.createElement(Component, { screen: this.state.screen, biteCallbacks: this.props.biteCallbacks }) : null
	            );
	        }
	    }]);
	
	    return AppScreen;
	}(_react2.default.Component);
	
	/*
	
	 <div className="top-level">{this.state.env.window.size} - {this.state.env.window.orientation}</div>
	 */
	
	AppScreen.propTypes = {
	    bite: _propTypes2.default.object.isRequired,
	    biteCallbacks: _propTypes2.default.object.isRequired,
	    trackingData: _propTypes2.default.object.isRequired,
	    actions: _propTypes2.default.object.isRequired
	};
	
	AppScreen.contextTypes = {
	    router: _propTypes2.default.object
	};
	
	function mapStateToProps(state, ownProps) {
	    return {
	        trackingData: state.trackingData
	    };
	}
	
	function mapDispatchToProps(dispatch) {
	    return {
	        actions: (0, _redux.bindActionCreators)(Object.assign({}, appDataActions, trackingDataActions), dispatch)
	    };
	}
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(AppScreen);

/***/ },
/* 444 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(5);
	
	var _redux = __webpack_require__(4);
	
	var _ScenarioBiteHeader = __webpack_require__(445);
	
	var _ScenarioBiteHeader2 = _interopRequireDefault(_ScenarioBiteHeader);
	
	var _ScenarioBiteProgress = __webpack_require__(446);
	
	var _ScenarioBiteProgress2 = _interopRequireDefault(_ScenarioBiteProgress);
	
	var _appDataActions = __webpack_require__(12);
	
	var appDataActions = _interopRequireWildcard(_appDataActions);
	
	var _trackingDataActions = __webpack_require__(7);
	
	var trackingDataActions = _interopRequireWildcard(_trackingDataActions);
	
	var _actionTypes = __webpack_require__(22);
	
	var actionTypes = _interopRequireWildcard(_actionTypes);
	
	var _MainMenu = __webpack_require__(454);
	
	var _MainMenu2 = _interopRequireDefault(_MainMenu);
	
	var _Resources = __webpack_require__(457);
	
	var _Resources2 = _interopRequireDefault(_Resources);
	
	var _AppScreen = __webpack_require__(443);
	
	var _AppScreen2 = _interopRequireDefault(_AppScreen);
	
	var _appHelper = __webpack_require__(3);
	
	var appHelper = _interopRequireWildcard(_appHelper);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ScenarioBite = function (_React$Component) {
	    _inherits(ScenarioBite, _React$Component);
	
	    function ScenarioBite(props, context) {
	        _classCallCheck(this, ScenarioBite);
	
	        var _this = _possibleConstructorReturn(this, (ScenarioBite.__proto__ || Object.getPrototypeOf(ScenarioBite)).call(this, props, context));
	
	        _this.state = {
	            bite: _this.props.bite,
	            showHeader: true,
	            biteCallbacks: {},
	            fontSize: _this.props.fontSize,
	            height: undefined,
	            updateHeight: false
	
	        };
	
	        _this.setBiteCallbacks = _this.setBiteCallbacks.bind(_this);
	        _this.showHeader = _this.showHeader.bind(_this);
	        _this.getClass = _this.getClass.bind(_this);
	        _this.getBiteId = _this.getBiteId.bind(_this);
	        _this.getBlurEffect = _this.getBlurEffect.bind(_this);
	        _this.setHeight = _this.setHeight.bind(_this);
	        _this.getHeight = _this.getHeight.bind(_this);
	        return _this;
	    }
	
	    _createClass(ScenarioBite, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            this.setHeight();
	            this.setBiteCallbacks();
	        }
	    }, {
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(nextProps) {
	            if (this.state.fontSize !== nextProps.fontSize) {
	                this.setState({ fontSize: nextProps.fontSize, updateHeight: true });
	            }
	        }
	    }, {
	        key: 'componentDidUpdate',
	        value: function componentDidUpdate() {
	            if (this.state.updateHeight) {
	                this.setHeight();
	            }
	        }
	    }, {
	        key: 'setBiteCallbacks',
	        value: function setBiteCallbacks() {
	            this.setState({
	                biteCallbacks: Object.assign({}, this.state.biteCallbacks, {
	                    showHeader: this.showHeader,
	                    getBiteId: this.getBiteId,
	                    setToolTip: this.setToolTip
	                })
	            });
	        }
	    }, {
	        key: 'showHeader',
	        value: function showHeader(show) {
	            this.setState({ showHeader: show });
	        }
	    }, {
	        key: 'getBiteId',
	        value: function getBiteId() {
	            return this.state.bite.bite_id;
	        }
	    }, {
	        key: 'getClass',
	        value: function getClass() {
	            if (this.state.showHeader) {
	                return "screen-wrapper";
	            } else {
	                return "screen-wrapper full-screen";
	            }
	        }
	    }, {
	        key: 'getBlurEffect',
	        value: function getBlurEffect() {
	
	            if (this.props.dialogPopup.render || this.props.assetDialog.render || this.props.screenDialog.render || this.props.displayResources !== actionTypes.STATUS_CLOSED || this.props.displayMainMenu !== actionTypes.STATUS_CLOSED) {
	                return 'blur on';
	            } else {
	                return 'blur off';
	            }
	        }
	    }, {
	        key: 'setHeight',
	        value: function setHeight() {
	            this.setState({ updateHeight: false });
	            var mainWrapper = document.getElementById('main-wrapper');
	            var header = document.getElementById('scenarioBiteHeader');
	            var progress = document.getElementById('scenarioBiteProgress');
	            if (appHelper.isDefined(header)) {
	                var newHeight = mainWrapper.offsetHeight - header.offsetHeight - progress.offsetHeight;
	                this.setState({ height: newHeight });
	            }
	        }
	    }, {
	        key: 'getHeight',
	        value: function getHeight() {
	
	            if (this.state.showHeader && appHelper.isDefined(this.state.height)) {
	                return {
	                    height: this.state.height + 'px',
	                    minHeight: this.state.height + 'px'
	                };
	            } else {
	                return {};
	            }
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var Dialog = this.props.dialogPopup.component;
	            var AssetDialog = this.props.assetDialog.component;
	            var ScreenDialog = this.props.screenDialog.component;
	            return _react2.default.createElement(
	                'div',
	                { className: 'scenario-bite' },
	                this.state.showHeader ? _react2.default.createElement(_ScenarioBiteHeader2.default, { bite: this.state.bite }) : null,
	                this.state.showHeader ? _react2.default.createElement(_ScenarioBiteProgress2.default, { bite: this.state.bite }) : null,
	                _react2.default.createElement(
	                    'div',
	                    { className: 'scenario-bite-content' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: this.getClass() + ' ' + this.getBlurEffect(), id: 'screenWrapper', style: this.getHeight() },
	                        _react2.default.createElement(_AppScreen2.default, { bite: this.state.bite, biteCallbacks: this.state.biteCallbacks })
	                    ),
	                    this.props.screenDialog.render ? _react2.default.createElement(ScreenDialog, null) : null,
	                    this.props.dialogPopup.render ? _react2.default.createElement(Dialog, null) : null,
	                    this.props.displayResources !== actionTypes.STATUS_CLOSED ? _react2.default.createElement(_Resources2.default, null) : null,
	                    this.props.displayMainMenu !== actionTypes.STATUS_CLOSED ? _react2.default.createElement(_MainMenu2.default, null) : null,
	                    this.props.assetDialog.render ? _react2.default.createElement(AssetDialog, null) : null
	                )
	            );
	        }
	    }]);
	
	    return ScenarioBite;
	}(_react2.default.Component);
	
	ScenarioBite.propTypes = {
	    bite: _propTypes2.default.object.isRequired,
	    trackingData: _propTypes2.default.object.isRequired,
	    dialogPopup: _propTypes2.default.object.isRequired,
	    displayMainMenu: _propTypes2.default.string.isRequired,
	    displayResources: _propTypes2.default.string.isRequired,
	    assetDialog: _propTypes2.default.object.isRequired,
	    screenDialog: _propTypes2.default.object.isRequired,
	    actions: _propTypes2.default.object.isRequired,
	    fontSize: _propTypes2.default.object.isRequired
	};
	
	ScenarioBite.contextTypes = {
	    router: _propTypes2.default.object
	};
	
	function mapStateToProps(state, ownProps) {
	    return {
	        trackingData: state.trackingData,
	        dialogPopup: state.dialogPopup,
	        displayMainMenu: state.displayMainMenu,
	        displayResources: state.displayResources,
	        assetDialog: state.assetDialog,
	        screenDialog: state.screenDialog,
	        fontSize: state.fontSize
	    };
	}
	
	function mapDispatchToProps(dispatch) {
	    return {
	        actions: (0, _redux.bindActionCreators)(Object.assign({}, trackingDataActions, appDataActions), dispatch)
	    };
	}
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(ScenarioBite);

/***/ },
/* 445 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(5);
	
	var _redux = __webpack_require__(4);
	
	var _KpiButton = __webpack_require__(481);
	
	var _KpiButton2 = _interopRequireDefault(_KpiButton);
	
	var _BadgesButton = __webpack_require__(474);
	
	var _BadgesButton2 = _interopRequireDefault(_BadgesButton);
	
	var _MenuButton = __webpack_require__(456);
	
	var _MenuButton2 = _interopRequireDefault(_MenuButton);
	
	var _ResourcesBtn = __webpack_require__(458);
	
	var _ResourcesBtn2 = _interopRequireDefault(_ResourcesBtn);
	
	var _BackButton = __webpack_require__(448);
	
	var _BackButton2 = _interopRequireDefault(_BackButton);
	
	var _ExitButton = __webpack_require__(274);
	
	var _ExitButton2 = _interopRequireDefault(_ExitButton);
	
	var _TextResize = __webpack_require__(273);
	
	var _TextResize2 = _interopRequireDefault(_TextResize);
	
	var _LocalePicker = __webpack_require__(194);
	
	var _LocalePicker2 = _interopRequireDefault(_LocalePicker);
	
	var _appDataActions = __webpack_require__(12);
	
	var appDataActions = _interopRequireWildcard(_appDataActions);
	
	var _trackingDataActions = __webpack_require__(7);
	
	var trackingDataActions = _interopRequireWildcard(_trackingDataActions);
	
	var _dialogPopupActions = __webpack_require__(19);
	
	var dialogPopupActions = _interopRequireWildcard(_dialogPopupActions);
	
	var _appHelper = __webpack_require__(3);
	
	var appHelper = _interopRequireWildcard(_appHelper);
	
	var _kpiHelper = __webpack_require__(35);
	
	var kpiHelper = _interopRequireWildcard(_kpiHelper);
	
	var _badgeHelper = __webpack_require__(201);
	
	var badgeHelper = _interopRequireWildcard(_badgeHelper);
	
	var _userDataHelper = __webpack_require__(15);
	
	var userDataHelper = _interopRequireWildcard(_userDataHelper);
	
	var _dataHelper = __webpack_require__(11);
	
	var dataHelper = _interopRequireWildcard(_dataHelper);
	
	var _objectConstants = __webpack_require__(9);
	
	var objectConstants = _interopRequireWildcard(_objectConstants);
	
	var _keyboardConstants = __webpack_require__(14);
	
	var keyboardConstants = _interopRequireWildcard(_keyboardConstants);
	
	var _localStorage = __webpack_require__(17);
	
	var localeStorage = _interopRequireWildcard(_localStorage);
	
	var _actionTypes = __webpack_require__(22);
	
	var actionTypes = _interopRequireWildcard(_actionTypes);
	
	var _dialogModels = __webpack_require__(32);
	
	var _environmentHelper = __webpack_require__(56);
	
	var enviromentHelper = _interopRequireWildcard(_environmentHelper);
	
	var _kpiConstants = __webpack_require__(37);
	
	var kpiConstants = _interopRequireWildcard(_kpiConstants);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ScenarioBiteHeader = function (_React$Component) {
	    _inherits(ScenarioBiteHeader, _React$Component);
	
	    function ScenarioBiteHeader(props, context) {
	        _classCallCheck(this, ScenarioBiteHeader);
	
	        var _this = _possibleConstructorReturn(this, (ScenarioBiteHeader.__proto__ || Object.getPrototypeOf(ScenarioBiteHeader)).call(this, props, context));
	
	        _this.state = {
	            lang: _this.props.lang,
	            env: enviromentHelper.getEnvironment(),
	            bite: _this.props.bite,
	            titles: _this.props.titles,
	            locale: appHelper.getLocalData(_this.props.bite),
	            showMenu: appHelper.biteHasScreensVisibleToMenu(_this.props.bite.screens),
	            showResources: appHelper.isDefined(localeStorage.resources) && localeStorage.resources.length > 0,
	            //kpis
	            showBadges: badgeHelper.biteHasvisibleBadges(_this.props.bite),
	            showKpis: kpiHelper.biteHasVisibleKpis(_this.props.bite),
	            showToolTipKpis: false,
	            kpiParams: {
	                bite_id: _this.props.bite.bite_id,
	                showTitle: true,
	                displayState: kpiConstants.KPI_DISPLAY_STATE_CURRENT_VALUE_WITH_LABEL
	
	            },
	            badgeParams: {
	                bite_id: _this.props.bite.bite_id,
	                showTitle: true
	            },
	            showBackBtn: appHelper.isDefined(_this.props.contentData.experience) ? _this.props.contentData.experience.include_back_button : false,
	            showExitBtn: appHelper.isDefined(_this.props.contentData.experience) ? _this.props.contentData.experience.include_exit_button : false,
	            ariaHasPopup: true,
	            setLocale: false,
	            badges_label: appHelper.getLocaleString("badges_label"),
	            performance_btn_label: appHelper.getLocaleString("performance_btn_label"),
	            performance_and_badges_label: appHelper.getLocaleString("performance_and_badges_label"),
	            showLocaleTitle: false
	        };
	        _this.componentWatcher = _this.componentWatcher.bind(_this);
	        _this.getPageProgressClass = _this.getPageProgressClass.bind(_this);
	        //MENU
	        _this.getMenuDisabled = _this.getMenuDisabled.bind(_this);
	        //RESOURCES
	        _this.getResourcesDisabled = _this.getResourcesDisabled.bind(_this);
	        //KPIs
	        _this.geKpiBtnDisabled = _this.geKpiBtnDisabled.bind(_this);
	        _this.openPerformanceDialog = _this.openPerformanceDialog.bind(_this);
	        _this.hideOnMobile = _this.hideOnMobile.bind(_this);
	        _this.setBtnState = _this.setBtnState.bind(_this);
	        //this.jumpToBite = this.jumpToBite.bind(this);
	        _this.setKeyboardAccessibility = _this.setKeyboardAccessibility.bind(_this);
	
	        return _this;
	    }
	
	    _createClass(ScenarioBiteHeader, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            window.addEventListener("resize", this.componentWatcher);
	            this.setBtnState();
	        }
	    }, {
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(nextProps) {
	            if (this.state.titles !== nextProps.titles) {
	                this.setState({ titles: Object.assign({}, nextProps.titles) });
	            }
	
	            if (this.state.lang !== nextProps.lang) {
	                this.setState({
	                    lang: nextProps.lang,
	                    badges_label: appHelper.getLocaleString("badges_label"),
	                    performance_btn_label: appHelper.getLocaleString("performance_btn_label"),
	                    performance_and_badges_label: appHelper.getLocaleString("performance_and_badges_label"),
	                    setLocale: true
	                });
	            }
	        }
	    }, {
	        key: 'componentDidUpdate',
	        value: function componentDidUpdate() {
	            if (this.state.setLocale) {
	                this.getLocale();
	            }
	        }
	    }, {
	        key: 'componentWillUnmount',
	        value: function componentWillUnmount() {
	            window.removeEventListener("resize", this.componentWatcher);
	        }
	    }, {
	        key: 'componentWatcher',
	        value: function componentWatcher() {
	            var env = enviromentHelper.getEnvironment();
	            if (env.window.size !== this.state.env.window.size || env.window.orientation !== this.state.env.window.orientation) {
	                this.setState({ env: env });
	            }
	        }
	    }, {
	        key: 'getLocale',
	        value: function getLocale() {
	            var locale = appHelper.getLocalData(this.props.bite);
	            this.setState({ locale: Object.assign({}, locale), setLocale: false });
	        }
	    }, {
	        key: 'setBtnState',
	        value: function setBtnState() {
	            this.setState({
	                showBackBtn: appHelper.isDefined(this.props.contentData.experience) ? this.props.contentData.experience.include_back_button : false,
	                showExitBtn: appHelper.isDefined(this.props.contentData.experience) ? this.props.contentData.experience.include_exit_button : false
	            });
	        }
	    }, {
	        key: 'hideOnMobile',
	        value: function hideOnMobile() {
	            if (this.state.showBadges) {
	                if (this.state.showKpis && this.state.env.window.size === "xs" && this.state.env.window.orientation === "portrait") {
	                    return false;
	                } else {
	                    return true;
	                }
	            } else {
	                return false;
	            }
	        }
	    }, {
	        key: 'getPageProgressClass',
	        value: function getPageProgressClass() {
	            var screenId = this.props.trackingData.lesson_location;
	            var screenUserData = userDataHelper.getScreenUserData(this.props.userData, screenId);
	            if (appHelper.isDefined(screenUserData)) {
	                switch (screenUserData.status) {
	                    case objectConstants.STATUS_NOT_REQUIRED:
	                        return objectConstants.CLASS_NOT_REQUIRED;
	                    case objectConstants.STATUS_IN_PROGRESS:
	                        return objectConstants.CLASS_IN_PROGRESS;
	                    case objectConstants.STATUS_COMPLETE:
	                        return objectConstants.CLASS_COMPLETE;
	                    default:
	                        return objectConstants.CLASS_NOT_STARTED;
	                }
	            } else {
	                return objectConstants.CLASS_NOT_STARTED;
	            }
	        }
	    }, {
	        key: 'getMenuDisabled',
	        value: function getMenuDisabled() {
	            var disabled = false;
	
	            if (this.props.displayResources !== actionTypes.STATUS_CLOSED /*|| this.props.dialogPopup.render*/ || this.props.assetDialog.render || this.props.screenDialog.render || this.props.dialogPopup.render) {
	                disabled = true;
	            }
	            return disabled;
	        }
	    }, {
	        key: 'getResourcesDisabled',
	        value: function getResourcesDisabled() {
	            var disabled = false;
	            if (this.props.displayMainMenu !== actionTypes.STATUS_CLOSED || this.props.assetDialog.render || this.props.dialogPopup.render) {
	                disabled = true;
	            }
	            return disabled;
	        }
	    }, {
	        key: 'geKpiBtnDisabled',
	        value: function geKpiBtnDisabled() {
	            var disabled = false;
	            if (this.props.displayResources !== actionTypes.STATUS_CLOSED || this.props.displayMainMenu !== actionTypes.STATUS_CLOSED || this.props.assetDialog.render || this.props.screenDialog.render || this.props.dialogPopup.render) {
	                disabled = true;
	            }
	            return disabled;
	        }
	    }, {
	        key: 'openPerformanceDialog',
	        value: function openPerformanceDialog(sourceId) {
	
	            if (!this.geKpiBtnDisabled()) {
	                var title = this.state.performance_and_badges_label;
	                var childComponents = [];
	
	                if (!this.state.showKpis && this.state.showBadges) {
	                    title = this.state.badges_label;
	                } else if (this.state.showKpis && !this.state.showBadges) {
	                    title = this.state.performance_btn_label;
	                }
	
	                var config = Object.assign({}, _dialogModels.PERFORMANCE_CONFIG, {
	                    title: title,
	                    sourceId: sourceId
	                });
	
	                for (var i = 0; i < config.childComponents.length; i++) {
	                    var child = config.childComponents[i];
	                    //console.log(child);
	                    if (child.id === 'KpiDashboard') {
	                        child.componentProps = Object.assign({}, this.state.kpiParams);
	
	                        if (this.state.showKpis) {
	                            childComponents = dataHelper.immutablePush(childComponents, child);
	                        }
	                    }
	                    if (child.id === 'BadgeDashboard') {
	                        child.componentProps = Object.assign({}, this.state.badgeParams);
	                        if (this.state.showBadges) {
	                            childComponents = dataHelper.immutablePush(childComponents, child);
	                        }
	                    }
	                }
	
	                config = Object.assign({}, config, {
	                    childComponents: childComponents
	                });
	
	                this.props.actions.setNewDialog(config);
	            }
	        }
	    }, {
	        key: 'setKeyboardAccessibility',
	        value: function setKeyboardAccessibility(event) {
	            if (event.which === keyboardConstants.ENTER_KEY || event.which === keyboardConstants.SPACEBAR_KEY) {
	                event.preventDefault();
	                this.openPerformanceDialog();
	            }
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            return _react2.default.createElement(
	                'div',
	                { className: 'header guroo-header', role: 'banner', id: 'scenarioBiteHeader' },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'header-nav-container' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'header-left-col' },
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'col-row' },
	                            this.state.showBackBtn ? _react2.default.createElement(
	                                'div',
	                                { className: 'flex-item' },
	                                _react2.default.createElement(_BackButton2.default, { disabled: this.geKpiBtnDisabled() })
	                            ) : null,
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'flex-item' },
	                                this.state.showMenu.toString ? _react2.default.createElement(_MenuButton2.default, { disabled: this.getMenuDisabled() }) : null
	                            )
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'header-center-col' },
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'col-row' },
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'truncate-text-container' },
	                                _react2.default.createElement('h2', { dangerouslySetInnerHTML: { __html: this.state.locale.title } })
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'col-row' },
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'truncate-text-container' },
	                                _react2.default.createElement('h3', { className: 'screen-title ' + this.getPageProgressClass(),
	                                    dangerouslySetInnerHTML: { __html: this.state.titles.screenTitle } })
	                            )
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'header-right-col' },
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'col-row' },
	                            Object.keys(localeStorage.localeOptions).length > 1 && _react2.default.createElement(
	                                'div',
	                                { className: 'flex-item' },
	                                _react2.default.createElement(_LocalePicker2.default, { showTitle: this.state.showLocaleTitle })
	                            ),
	                            this.state.showKpis ? _react2.default.createElement(
	                                'div',
	                                { className: 'flex-item' },
	                                _react2.default.createElement(_KpiButton2.default, { onClickFunc: this.openPerformanceDialog,
	                                    bite_id: this.state.bite.bite_id,
	                                    kpis: kpiHelper.getKpis(this.state.bite),
	                                    disabled: this.geKpiBtnDisabled() })
	                            ) : null,
	                            this.state.showBadges && this.hideOnMobile() ? _react2.default.createElement(
	                                'div',
	                                { className: 'flex-item' },
	                                _react2.default.createElement(_BadgesButton2.default, { onClickFunc: this.openPerformanceDialog,
	                                    bite_id: this.state.bite.bite_id, disabled: this.geKpiBtnDisabled() })
	                            ) : null,
	                            this.state.showResources ? _react2.default.createElement(
	                                'div',
	                                { className: 'flex-item' },
	                                _react2.default.createElement(_ResourcesBtn2.default, { disabled: this.getResourcesDisabled() })
	                            ) : null,
	                            this.state.showExitBtn ? _react2.default.createElement(
	                                'div',
	                                { className: 'flex-item' },
	                                _react2.default.createElement(_ExitButton2.default, { disabled: this.geKpiBtnDisabled() })
	                            ) : null
	                        )
	                    )
	                )
	            );
	        }
	    }]);
	
	    return ScenarioBiteHeader;
	}(_react2.default.Component);
	
	//<div>{document.getElementById('main-wrapper').clientWidth.toString()} * {document.getElementById('main-wrapper').clientHeight.toString()}</div>
	
	
	ScenarioBiteHeader.propTypes = {
	    lang: _propTypes2.default.string.isRequired,
	    bite: _propTypes2.default.object.isRequired,
	    trackingData: _propTypes2.default.object.isRequired,
	    contentData: _propTypes2.default.object.isRequired,
	    userData: _propTypes2.default.object.isRequired,
	    dialogPopup: _propTypes2.default.object.isRequired,
	    assetDialog: _propTypes2.default.object.isRequired,
	    screenDialog: _propTypes2.default.object.isRequired,
	    displayMainMenu: _propTypes2.default.string.isRequired,
	    displayResources: _propTypes2.default.string.isRequired,
	    titles: _propTypes2.default.object.isRequired,
	    actions: _propTypes2.default.object.isRequired
	};
	
	ScenarioBiteHeader.contextTypes = {
	    router: _propTypes2.default.object
	};
	
	function mapStateToProps(state, ownProps) {
	    var lang = state.userData.lang;
	    return {
	        lang: lang,
	        trackingData: state.trackingData,
	        contentData: state.contentData,
	        userData: state.userData,
	        titles: state.titles,
	        dialogPopup: state.dialogPopup,
	        assetDialog: state.assetDialog,
	        screenDialog: state.screenDialog,
	        displayMainMenu: state.displayMainMenu,
	        displayResources: state.displayResources
	
	    };
	}
	
	function mapDispatchToProps(dispatch) {
	    return {
	        actions: (0, _redux.bindActionCreators)(Object.assign({}, trackingDataActions, appDataActions, dialogPopupActions), dispatch)
	    };
	}
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(ScenarioBiteHeader);

/***/ },
/* 446 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(5);
	
	var _redux = __webpack_require__(4);
	
	var _appDataActions = __webpack_require__(12);
	
	var appDataActions = _interopRequireWildcard(_appDataActions);
	
	var _trackingDataActions = __webpack_require__(7);
	
	var trackingDataActions = _interopRequireWildcard(_trackingDataActions);
	
	var _appHelper = __webpack_require__(3);
	
	var appHelper = _interopRequireWildcard(_appHelper);
	
	var _objectConstants = __webpack_require__(9);
	
	var objectConstants = _interopRequireWildcard(_objectConstants);
	
	var _gsap = __webpack_require__(8);
	
	var _gsapReactPlugin = __webpack_require__(10);
	
	var _gsapReactPlugin2 = _interopRequireDefault(_gsapReactPlugin);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ScenarioBiteProgress = function (_React$Component) {
	    _inherits(ScenarioBiteProgress, _React$Component);
	
	    function ScenarioBiteProgress(props, context) {
	        _classCallCheck(this, ScenarioBiteProgress);
	
	        var _this = _possibleConstructorReturn(this, (ScenarioBiteProgress.__proto__ || Object.getPrototypeOf(ScenarioBiteProgress)).call(this, props, context));
	
	        _this.state = {
	            lang: _this.props.lang,
	            percentageComplete: _this.props.percentageComplete,
	            allowUpdate: false,
	            className: "",
	            this_module_is_label: appHelper.getLocaleString("this_module_is_label"),
	            complete_label: appHelper.getLocaleString("complete_label")
	        };
	        _this.updateProgress = _this.updateProgress.bind(_this);
	        _this.onUpdateComplete = _this.onUpdateComplete.bind(_this);
	        return _this;
	    }
	
	    _createClass(ScenarioBiteProgress, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            this.updateProgress();
	        }
	    }, {
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(nextProps) {
	            if (this.state.percentageComplete !== nextProps.percentageComplete) {
	                this.setState({
	                    percentageComplete: nextProps.percentageComplete,
	                    allowUpdate: true
	                });
	            }
	            if (this.state.lang !== nextProps.lang) {
	                this.setState({
	                    lang: nextProps.lang,
	                    this_module_is_label: appHelper.getLocaleString("this_module_is_label"),
	                    complete_label: appHelper.getLocaleString("complete_label")
	                });
	            }
	        }
	    }, {
	        key: 'componentDidUpdate',
	        value: function componentDidUpdate() {
	            if (this.state.allowUpdate) {
	                this.updateProgress();
	            }
	        }
	    }, {
	        key: 'updateProgress',
	        value: function updateProgress() {
	            this.setState({ allowUpdate: false });
	            var optionRef = this.refs.progressMeter;
	
	            _gsap.TweenLite.to(optionRef, objectConstants.PROGRESS_UPDATE_DURATION, {
	                width: this.state.percentageComplete + '%',
	                ease: _gsap.Expo.easeInOut
	            }).eventCallback("onComplete", this.onUpdateComplete);
	        }
	    }, {
	        key: 'onUpdateComplete',
	        value: function onUpdateComplete() {
	            if (this.state.percentageComplete === 100) {
	                this.setState({
	                    className: "complete"
	                });
	            }
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            return _react2.default.createElement(
	                'div',
	                { className: 'bite-progress-bar', role: 'presentation', id: 'scenarioBiteProgress' },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'progress-meter ' + this.state.className, ref: 'progressMeter', role: 'progressbar', 'aria-valuenow': this.state.percentageComplete, 'aria-valuemin': '0', 'aria-valuemax': '100' },
	                    _react2.default.createElement(
	                        'span',
	                        { className: 'hidden-el' },
	                        this.state.this_module_is_label,
	                        ' ',
	                        this.state.percentageComplete,
	                        '% ',
	                        this.state.complete_label,
	                        '.'
	                    )
	                )
	            );
	        }
	    }]);
	
	    return ScenarioBiteProgress;
	}(_react2.default.Component);
	
	ScenarioBiteProgress.propTypes = {
	    bite: _propTypes2.default.object.isRequired,
	    lang: _propTypes2.default.string.isRequired,
	    percentageComplete: _propTypes2.default.number.isRequired,
	    actions: _propTypes2.default.object.isRequired
	};
	
	ScenarioBiteProgress.contextTypes = {
	    router: _propTypes2.default.object
	};
	
	function mapStateToProps(state, ownProps) {
	    var userBite = appHelper.getArrayObjectByKey(state.userData.bites, "bite_id", ownProps.bite.bite_id);
	    var lang = state.userData.lang;
	    return {
	        lang: lang,
	        percentageComplete: userBite.percentageComplete
	    };
	}
	
	function mapDispatchToProps(dispatch) {
	    return {
	        actions: (0, _redux.bindActionCreators)(Object.assign({}, trackingDataActions, appDataActions), dispatch)
	    };
	}
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(ScenarioBiteProgress);

/***/ },
/* 447 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(5);
	
	var _redux = __webpack_require__(4);
	
	var _initActions = __webpack_require__(64);
	
	var initActions = _interopRequireWildcard(_initActions);
	
	var _trackingDataActions = __webpack_require__(7);
	
	var trackingDataActions = _interopRequireWildcard(_trackingDataActions);
	
	var _appHelper = __webpack_require__(3);
	
	var appHelper = _interopRequireWildcard(_appHelper);
	
	var _gsap = __webpack_require__(8);
	
	var _gsapReactPlugin = __webpack_require__(10);
	
	var _gsapReactPlugin2 = _interopRequireDefault(_gsapReactPlugin);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var AbsoluteButton = function (_React$Component) {
	    _inherits(AbsoluteButton, _React$Component);
	
	    function AbsoluteButton(props, context) {
	        _classCallCheck(this, AbsoluteButton);
	
	        var _this = _possibleConstructorReturn(this, (AbsoluteButton.__proto__ || Object.getPrototypeOf(AbsoluteButton)).call(this, props, context));
	
	        _this.state = {};
	        _this.onComplete = _this.onComplete.bind(_this);
	        return _this;
	    }
	
	    _createClass(AbsoluteButton, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {}
	    }, {
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(nextProps) {}
	    }, {
	        key: 'onComplete',
	        value: function onComplete() {}
	    }, {
	        key: 'render',
	        value: function render() {
	
	            return _react2.default.createElement(
	                'button',
	                { className: 'btn btn-lg guroo-btn abs-btn ' + this.props.class, ref: this.props.id, disabled: this.props.isDisabled, onClick: this.props.onClick },
	                this.props.label
	            );
	        }
	    }]);
	
	    return AbsoluteButton;
	}(_react2.default.Component);
	
	AbsoluteButton.propTypes = {
	    label: _propTypes2.default.string,
	    class: _propTypes2.default.string.isRequired,
	    onClick: _propTypes2.default.func.isRequired,
	    id: _propTypes2.default.string.isRequired,
	    alignment: _propTypes2.default.string,
	    isDisabled: _propTypes2.default.bool
	};
	
	AbsoluteButton.contextTypes = {
	    router: _propTypes2.default.object
	};
	
	function mapStateToProps(state, ownProps) {
	    return {};
	}
	
	function mapDispatchToProps(dispatch) {
	    return {
	        actions: (0, _redux.bindActionCreators)(Object.assign({}, initActions, trackingDataActions), dispatch)
	    };
	}
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(AbsoluteButton);

/***/ },
/* 448 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(5);
	
	var _redux = __webpack_require__(4);
	
	var _trackingDataActions = __webpack_require__(7);
	
	var trackingDataActions = _interopRequireWildcard(_trackingDataActions);
	
	var _appHelper = __webpack_require__(3);
	
	var appHelper = _interopRequireWildcard(_appHelper);
	
	var _keyboardConstants = __webpack_require__(14);
	
	var keyboardConstants = _interopRequireWildcard(_keyboardConstants);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var BackButton = function (_React$Component) {
	    _inherits(BackButton, _React$Component);
	
	    function BackButton(props, context) {
	        _classCallCheck(this, BackButton);
	
	        var _this = _possibleConstructorReturn(this, (BackButton.__proto__ || Object.getPrototypeOf(BackButton)).call(this, props, context));
	
	        _this.state = {
	            last_lesson_location: _this.props.last_lesson_location,
	            lang: _this.props.lang,
	            label: appHelper.getLocaleString("back_label")
	        };
	        _this.onBackClick = _this.onBackClick.bind(_this);
	        _this.setBtnClass = _this.setBtnClass.bind(_this);
	        _this.setIconClass = _this.setIconClass.bind(_this);
	        _this.setKeyboardAccessibility = _this.setKeyboardAccessibility.bind(_this);
	        return _this;
	    }
	
	    _createClass(BackButton, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {}
	    }, {
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(nextProps) {
	            if (this.state.last_lesson_location !== nextProps.last_lesson_location) {
	                this.setState({ last_lesson_location: nextProps.last_lesson_location });
	            }
	
	            if (this.state.lang !== nextProps.lang) {
	                this.setState({
	                    lang: nextProps.lang,
	                    label: appHelper.getLocaleString("back_label")
	                });
	            }
	        }
	    }, {
	        key: 'onBackClick',
	        value: function onBackClick() {
	            var disabled = false;
	            if (appHelper.isDefined(this.props.disabled)) {
	                disabled = this.props.disabled;
	            }
	
	            if (!disabled && this.state.last_lesson_location !== 0) {
	                this.props.actions.setNewLessonLocation(this.state.last_lesson_location);
	            }
	        }
	    }, {
	        key: 'setBtnClass',
	        value: function setBtnClass() {
	            var disabled = false;
	            if (appHelper.isDefined(this.props.disabled)) {
	                disabled = this.props.disabled;
	            }
	            if (this.state.last_lesson_location === 0) {
	                disabled = true;
	            }
	            return disabled ? "disabled" : "";
	        }
	    }, {
	        key: 'setIconClass',
	        value: function setIconClass() {
	            return "icons8-undo";
	        }
	    }, {
	        key: 'setKeyboardAccessibility',
	        value: function setKeyboardAccessibility(event) {
	            if (event.which === keyboardConstants.ENTER_KEY || event.which === keyboardConstants.SPACEBAR_KEY) {
	                event.preventDefault();
	                this.onBackClick();
	            }
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            return _react2.default.createElement(
	                'div',
	                { className: 'header-btn back ' + this.setBtnClass(), onClick: this.onBackClick, onKeyDown: this.setKeyboardAccessibility, role: 'link', tabIndex: '0', 'aria-controls': 'back', title: this.state.label, 'aria-disabled': this.props.disabled },
	                _react2.default.createElement('div', { className: 'icon icons8-undo ' }),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'btn-label' },
	                    this.state.label
	                )
	            );
	        }
	    }]);
	
	    return BackButton;
	}(_react2.default.Component);
	
	BackButton.propTypes = {
	    disabled: _propTypes2.default.bool,
	    last_lesson_location: _propTypes2.default.number.isRequired,
	    lang: _propTypes2.default.string.isRequired,
	    actions: _propTypes2.default.object.isRequired
	
	};
	
	BackButton.contextTypes = {
	    router: _propTypes2.default.object
	};
	
	function mapStateToProps(state, ownProps) {
	    var lang = state.userData.lang;
	    return {
	        lang: lang,
	        last_lesson_location: state.trackingData.last_lesson_location
	    };
	}
	
	function mapDispatchToProps(dispatch) {
	    return {
	        actions: (0, _redux.bindActionCreators)(Object.assign({}, trackingDataActions), dispatch)
	    };
	}
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(BackButton);

/***/ },
/* 449 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRouter = __webpack_require__(45);
	
	var _reactRedux = __webpack_require__(5);
	
	var _redux = __webpack_require__(4);
	
	var _appDataActions = __webpack_require__(12);
	
	var appDataActions = _interopRequireWildcard(_appDataActions);
	
	var _trackingDataActions = __webpack_require__(7);
	
	var trackingDataActions = _interopRequireWildcard(_trackingDataActions);
	
	var _mainMenuActions = __webpack_require__(134);
	
	var mainMenuActions = _interopRequireWildcard(_mainMenuActions);
	
	var _appHelper = __webpack_require__(3);
	
	var appHelper = _interopRequireWildcard(_appHelper);
	
	var _actionTypes = __webpack_require__(22);
	
	var actionTypes = _interopRequireWildcard(_actionTypes);
	
	var _componentHelper = __webpack_require__(31);
	
	var _keyboardConstants = __webpack_require__(14);
	
	var keyboardConstants = _interopRequireWildcard(_keyboardConstants);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var HomeButton = function (_React$Component) {
	    _inherits(HomeButton, _React$Component);
	
	    function HomeButton(props, context) {
	        _classCallCheck(this, HomeButton);
	
	        var _this = _possibleConstructorReturn(this, (HomeButton.__proto__ || Object.getPrototypeOf(HomeButton)).call(this, props, context));
	
	        _this.state = {
	            lang: _this.props.lang,
	            label: appHelper.getLocaleString("home_label")
	        };
	        _this.onHomeClick = _this.onHomeClick.bind(_this);
	        _this.setKeyboardAccessibility = _this.setKeyboardAccessibility.bind(_this);
	        return _this;
	    }
	
	    _createClass(HomeButton, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {}
	    }, {
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(nextProps) {
	            if (this.state.lang !== nextProps.lang) {
	                this.setState({
	                    lang: nextProps.lang,
	                    label: appHelper.getLocaleString("home_label")
	                });
	            }
	        }
	    }, {
	        key: 'onHomeClick',
	        value: function onHomeClick(e) {
	            e.preventDefault();
	            e.stopPropagation();
	            this.props.closeMenu();
	            this.context.router.push('menu');
	        }
	    }, {
	        key: 'setKeyboardAccessibility',
	        value: function setKeyboardAccessibility(event) {
	            if (event.which === keyboardConstants.ENTER_KEY || event.which === keyboardConstants.SPACEBAR_KEY) {
	                event.preventDefault();
	                this.props.closeMenu();
	                this.context.router.push('menu');
	            }
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            return _react2.default.createElement(
	                'button',
	                { className: 'btn guroo-btn home-btn', onClick: this.onHomeClick, onKeyDown: this.setKeyboardAccessibility, role: 'link', tabIndex: '0', 'aria-controls': 'bite_menu', title: this.state.label },
	                this.state.label
	            );
	        }
	    }]);
	
	    return HomeButton;
	}(_react2.default.Component);
	
	HomeButton.propTypes = {
	    closeMenu: _propTypes2.default.func.isRequired,
	    lang: _propTypes2.default.string.isRequired,
	    actions: _propTypes2.default.object.isRequired
	
	};
	
	HomeButton.contextTypes = {
	    router: _propTypes2.default.object
	};
	
	function mapStateToProps(state, ownProps) {
	    var lang = state.userData.lang;
	    return {
	        lang: lang
	    };
	}
	
	function mapDispatchToProps(dispatch) {
	    return {
	        actions: (0, _redux.bindActionCreators)(Object.assign({}, mainMenuActions), dispatch)
	    };
	}
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(HomeButton);

/***/ },
/* 450 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.AssetDialog = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _gsap = __webpack_require__(8);
	
	var _gsapReactPlugin = __webpack_require__(10);
	
	var _gsapReactPlugin2 = _interopRequireDefault(_gsapReactPlugin);
	
	var _reactDom = __webpack_require__(55);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _reactRedux = __webpack_require__(5);
	
	var _redux = __webpack_require__(4);
	
	var _dialogPopupActions = __webpack_require__(19);
	
	var dialogPopupActions = _interopRequireWildcard(_dialogPopupActions);
	
	var _keyboardConstants = __webpack_require__(14);
	
	var keyboardConstants = _interopRequireWildcard(_keyboardConstants);
	
	var _objectConstants = __webpack_require__(9);
	
	var objectConstants = _interopRequireWildcard(_objectConstants);
	
	var _appHelper = __webpack_require__(3);
	
	var appHelper = _interopRequireWildcard(_appHelper);
	
	var _dataHelper = __webpack_require__(11);
	
	var dataHelper = _interopRequireWildcard(_dataHelper);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	//import ReactCSSTransitionGroup from 'react-addons-css-transition-group';
	
	
	//import toastr from 'toastr';
	
	var AssetDialog = exports.AssetDialog = function (_React$Component) {
	    _inherits(AssetDialog, _React$Component);
	
	    function AssetDialog(props, context) {
	        _classCallCheck(this, AssetDialog);
	
	        var _this = _possibleConstructorReturn(this, (AssetDialog.__proto__ || Object.getPrototypeOf(AssetDialog)).call(this, props, context));
	
	        _this.state = {
	            currentOpacity: 0,
	            currentTop: 0,
	            isOpenOpacity: 1,
	            isOpenTop: 0,
	            isClosedOpacity: 0,
	            isClosedTop: 0,
	            assetDialog: _this.props.assetDialog,
	            tabbableElements: [],
	            assetViewed: false,
	            isOpen: false,
	            elementInterval: {},
	            guid: dataHelper.createGuid()
	
	        };
	        _this.openDialog = _this.openDialog.bind(_this);
	        _this.isOpenFunc = _this.isOpenFunc.bind(_this);
	        _this.closeDialog = _this.closeDialog.bind(_this);
	        _this.isClosedFunc = _this.isClosedFunc.bind(_this);
	        _this.onAssetViewed = _this.onAssetViewed.bind(_this);
	        _this.setTabbableElements = _this.setTabbableElements.bind(_this);
	        _this.setKeyboardAccessibility = _this.setKeyboardAccessibility.bind(_this);
	        _this.setInitialFocus = _this.setInitialFocus.bind(_this);
	        _this.onKeyDown = _this.onKeyDown.bind(_this);
	        _this.onKeyUp = _this.onKeyUp.bind(_this);
	        _this.setElementInterval = _this.setElementInterval.bind(_this);
	        return _this;
	    }
	
	    _createClass(AssetDialog, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            window.addEventListener("keydown", this.onKeyDown);
	            window.addEventListener("keyup", this.onKeyUp);
	            this.setElementInterval();
	            var func = this.openDialog;
	            setTimeout(function () {
	
	                func();
	            }, 200);
	        }
	    }, {
	        key: 'componentDidUpdate',
	        value: function componentDidUpdate() {
	            if (!this.state.isOpen && this.state.assetDialog.isOpen) {
	                this.setInitialFocus();
	            }
	        }
	    }, {
	        key: 'componentWillUnmount',
	        value: function componentWillUnmount() {
	            window.removeEventListener("keydown", this.onKeyDown);
	            window.removeEventListener("keyup", this.onKeyUp);
	            clearInterval(this.state.elementInterval);
	        }
	    }, {
	        key: 'setElementInterval',
	        value: function setElementInterval() {
	            var interval = setInterval(this.setTabbableElements, 2000);
	            this.setState({ elementInterval: interval });
	        }
	    }, {
	        key: 'openDialog',
	        value: function openDialog() {
	            if (appHelper.isDefined(this) && this !== null) {
	                _gsap.TweenLite.to(this, objectConstants.DIALOG_DURATION, {
	                    state: {
	                        currentOpacity: this.state.isOpenOpacity,
	                        currentTop: this.state.isOpenTop
	                    }
	                }).eventCallback("onComplete", this.isOpenFunc);
	            }
	        }
	    }, {
	        key: 'isOpenFunc',
	        value: function isOpenFunc() {
	            this.setState({
	                assetDialog: Object.assign({}, this.state.assetDialog, {
	                    isOpen: true,
	                    currentClassState: this.state.assetDialog.classStates.isOpen
	                })
	            });
	        }
	    }, {
	        key: 'closeDialog',
	        value: function closeDialog() {
	            var focusEl = document.getElementById(this.state.assetDialog.config.sourceId);
	            if (appHelper.isDefined(focusEl)) {
	                focusEl.focus();
	            }
	            this.setState({
	                assetDialog: Object.assign({}, this.state.assetDialog, {
	                    isOpen: false,
	                    currentClassState: this.state.assetDialog.classStates.isClosed
	                })
	            });
	            if (appHelper.isDefined(this) && this !== null) {
	                _gsap.TweenLite.to(this, objectConstants.DIALOG_DURATION, {
	                    state: {
	                        currentOpacity: this.state.isClosedOpacity,
	                        currentTop: this.state.isClosedTop
	                    }, delay: 0.5
	                }).eventCallback("onComplete", this.isClosedFunc);
	            }
	        }
	    }, {
	        key: 'isClosedFunc',
	        value: function isClosedFunc() {
	            this.props.actions.removeAssetDialog();
	            this.state.assetDialog.config.onClose(this.state.assetViewed);
	        }
	    }, {
	        key: 'onAssetViewed',
	        value: function onAssetViewed() {
	            this.setState({ assetViewed: true });
	        }
	    }, {
	        key: 'onKeyDown',
	        value: function onKeyDown(event) {
	            var shiftPressed = this.state.shiftPressed;
	            var tabPressed = this.state.tabPressed;
	
	            if (event.which === keyboardConstants.ESCAPE_KEY) {
	                event.preventDefault();
	                this.closeDialog();
	            }
	
	            if (event.which === keyboardConstants.TAB_KEY) {
	                tabPressed = true;
	                this.setState({
	                    tabPressed: tabPressed
	                });
	            }
	
	            if (event.which === keyboardConstants.SHIFT_KEY) {
	                shiftPressed = true;
	                this.setState({
	                    shiftPressed: shiftPressed
	                });
	            }
	        }
	    }, {
	        key: 'onKeyUp',
	        value: function onKeyUp(event) {
	            var activeItem = document.activeElement;
	            var activeItemId = activeItem.id;
	            //console.log(activeItemId);
	            if (activeItemId === this.state.tabbableElements[0].id) {
	                //go to last
	                //console.log(this.state.tabbableElements[this.state.tabbableElements.length - 2]);
	                this.state.tabbableElements[this.state.tabbableElements.length - 2].focus();
	            } else if (activeItemId === this.state.tabbableElements[this.state.tabbableElements.length - 1].id) {
	                this.state.tabbableElements[1].focus();
	            }
	
	            this.setState({
	                tabPressed: false,
	                shiftPressed: false
	            });
	        }
	    }, {
	        key: 'setKeyboardAccessibility',
	        value: function setKeyboardAccessibility(event) {
	            if (event.which === keyboardConstants.ENTER_KEY || event.which === keyboardConstants.SPACEBAR_KEY) {
	                event.preventDefault();
	                this.closeDialog();
	            }
	        }
	    }, {
	        key: 'setTabbableElements',
	        value: function setTabbableElements() {
	            var dialog = this.refs.assetDialog;
	            this.setState({ tabbableElements: Object.assign([], dataHelper.getAllTabbableElements(dialog)) });
	            if (!this.state.isOpen && this.state.assetDialog.isOpen) {
	
	                this.setInitialFocus();
	            }
	        }
	    }, {
	        key: 'setInitialFocus',
	        value: function setInitialFocus() {
	            var initFocusEl = this.state.tabbableElements[1];
	            if (appHelper.isDefined(initFocusEl)) {
	                this.state.tabbableElements[1].focus();
	                this.setState({ isOpen: true });
	            }
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this2 = this;
	
	            return _react2.default.createElement(
	                'div',
	                { className: 'dialog-page ' + this.state.assetDialog.currentClassState,
	                    style: { opacity: this.state.currentOpacity }, role: 'dialog', 'aria-modal': this.state.isDialog,
	                    ref: 'assetDialog', id: 'assetDialog' },
	                _react2.default.createElement('div', { id: 'firstTabIndex_asset_dialog_' + this.state.guid, tabIndex: '0', role: 'button' }),
	                _react2.default.createElement(
	                    'div',
	                    { className: this.state.assetDialog.className + ' ' + this.state.assetDialog.config.theme },
	                    this.state.assetDialog.config.showCloseBtn ? _react2.default.createElement(
	                        'div',
	                        { className: 'dialog-header' },
	                        _react2.default.createElement(
	                            'p',
	                            null,
	                            ' ',
	                            this.state.assetDialog.config.title
	                        ),
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'close-btn icon-first icons8-multiply', role: 'link', tabIndex: '0',
	                                onClick: this.closeDialog, onKeyDown: this.setKeyboardAccessibility,
	                                ref: 'closeAssetDialogBtn' },
	                            'Close'
	                        )
	                    ) : null,
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'dialog-body' },
	                        this.state.assetDialog.config.childComponents.map(function (component) {
	                            return _react2.default.createElement(
	                                'div',
	                                { key: "container_" + component.id, className: 'component-seperator' },
	                                component.componentProps != null ? _react2.default.createElement(component.childComponent, _extends({ key: component.id }, component.componentProps, {
	                                    onAssetViewed: _this2.onAssetViewed,
	                                    closeDialog: _this2.closeDialog })) : _react2.default.createElement(component.childComponent, { key: component.id, onAssetViewed: _this2.onAssetViewed,
	                                    closeDialog: _this2.closeDialog })
	                            );
	                        })
	                    )
	                ),
	                _react2.default.createElement('div', { id: 'lastTabIndex_assetDialog_' + this.state.guid, tabIndex: '0', role: 'button' })
	            );
	        }
	    }]);
	
	    return AssetDialog;
	}(_react2.default.Component);
	
	AssetDialog.propTypes = {
	    assetDialog: _propTypes2.default.object.isRequired,
	    actions: _propTypes2.default.object.isRequired
	};
	
	//Pull in the React Router context so router is available on this.context.router.
	AssetDialog.contextTypes = {
	    router: _propTypes2.default.object
	};
	
	//Init
	function mapStateToProps(state, ownProps) {
	    return {
	        assetDialog: state.assetDialog
	    };
	}
	
	function mapDispatchToProps(dispatch) {
	    return {
	        actions: (0, _redux.bindActionCreators)(Object.assign({}, dialogPopupActions), dispatch)
	    };
	}
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(AssetDialog);

/***/ },
/* 451 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.ContentDialog = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(5);
	
	var _redux = __webpack_require__(4);
	
	var _dialogPopupActions = __webpack_require__(19);
	
	var dialogPopupActions = _interopRequireWildcard(_dialogPopupActions);
	
	var _keyboardConstants = __webpack_require__(14);
	
	var keyboardConstants = _interopRequireWildcard(_keyboardConstants);
	
	var _dataHelper = __webpack_require__(11);
	
	var dataHelper = _interopRequireWildcard(_dataHelper);
	
	var _appHelper = __webpack_require__(3);
	
	var appHelper = _interopRequireWildcard(_appHelper);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ContentDialog = exports.ContentDialog = function (_React$Component) {
	    _inherits(ContentDialog, _React$Component);
	
	    function ContentDialog(props, context) {
	        _classCallCheck(this, ContentDialog);
	
	        var _this = _possibleConstructorReturn(this, (ContentDialog.__proto__ || Object.getPrototypeOf(ContentDialog)).call(this, props, context));
	
	        _this.state = {
	            dialogPopup: _this.props.dialogPopup,
	            tabbableElements: [],
	            isDialog: true,
	            isOpen: false,
	            elementInterval: {},
	            guid: dataHelper.createGuid(),
	            fontSize: _this.props.fontSize,
	            height: undefined,
	            updateHeight: true
	
	        };
	        _this.setTabbableElements = _this.setTabbableElements.bind(_this);
	        _this.setKeyboardAccessibility = _this.setKeyboardAccessibility.bind(_this);
	        _this.setInitialFocus = _this.setInitialFocus.bind(_this);
	        _this.onKeyDown = _this.onKeyDown.bind(_this);
	        _this.onKeyUp = _this.onKeyUp.bind(_this);
	        _this.setElementInterval = _this.setElementInterval.bind(_this);
	        _this.setHeight = _this.setHeight.bind(_this);
	        _this.getHeight = _this.getHeight.bind(_this);
	        return _this;
	    }
	
	    _createClass(ContentDialog, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            this.setTabbableElements();
	            window.addEventListener("keydown", this.onKeyDown);
	            window.addEventListener("keyup", this.onKeyUp);
	            this.setElementInterval();
	        }
	    }, {
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(nextProps) {
	            if (this.state.dialogPopup !== nextProps.dialogPopup) {
	                this.setState({ dialogPopup: Object.assign({}, nextProps.dialogPopup) });
	            }
	
	            if (this.state.fontSize !== nextProps.fontSize) {
	                this.setState({ fontSize: nextProps.fontSize, updateHeight: true });
	            }
	        }
	    }, {
	        key: 'componentDidUpdate',
	        value: function componentDidUpdate() {
	            if (!this.state.isOpen && this.state.dialogPopup.isOpen) {
	                this.setInitialFocus();
	            }
	
	            if (this.state.updateHeight) {
	                this.setHeight();
	            }
	        }
	    }, {
	        key: 'componentWillUnmount',
	        value: function componentWillUnmount() {
	            window.removeEventListener("keydown", this.onKeyDown);
	            window.removeEventListener("keyup", this.onKeyUp);
	            clearInterval(this.state.elementInterval);
	        }
	    }, {
	        key: 'setElementInterval',
	        value: function setElementInterval() {
	            var interval = setInterval(this.setTabbableElements, 2000);
	            this.setState({ elementInterval: interval });
	        }
	    }, {
	        key: 'setTabbableElements',
	        value: function setTabbableElements() {
	            var dialog = this.refs.contentDialog;
	            this.setState({ tabbableElements: Object.assign([], dataHelper.getAllTabbableElements(dialog)) });
	        }
	    }, {
	        key: 'setKeyboardAccessibility',
	        value: function setKeyboardAccessibility(event) {
	            if (event.which === keyboardConstants.ENTER_KEY || event.which === keyboardConstants.SPACEBAR_KEY) {
	                event.preventDefault();
	                this.props.onCloseDialog();
	            }
	        }
	    }, {
	        key: 'setInitialFocus',
	        value: function setInitialFocus() {
	            this.setState({ isOpen: true });
	            var closePanel = this.refs['closeDialogBtn'];
	            var func = this.openDialog;
	            if (appHelper.isDefined(closePanel)) {
	                setTimeout(function () {
	                    closePanel.focus();
	                }, 1000);
	            }
	        }
	    }, {
	        key: 'onKeyDown',
	        value: function onKeyDown(event) {
	            var shiftPressed = this.state.shiftPressed;
	            var tabPressed = this.state.tabPressed;
	
	            if (event.which === keyboardConstants.ESCAPE_KEY) {
	                event.preventDefault();
	                this.props.onCloseDialog();
	            }
	
	            if (event.which === keyboardConstants.TAB_KEY) {
	                tabPressed = true;
	                this.setState({
	                    tabPressed: tabPressed
	                });
	            }
	
	            if (event.which === keyboardConstants.SHIFT_KEY) {
	                this.setState({
	                    shiftPressed: shiftPressed
	                });
	            }
	        }
	    }, {
	        key: 'onKeyUp',
	        value: function onKeyUp(event) {
	            var activeItem = document.activeElement;
	            var activeItemId = activeItem.id;
	            //console.log(activeItemId);
	            if (activeItemId === this.state.tabbableElements[0].id) {
	                //go to last
	                //console.log(this.state.tabbableElements[this.state.tabbableElements.length - 2]);
	                this.state.tabbableElements[this.state.tabbableElements.length - 2].focus();
	            } else if (activeItemId === this.state.tabbableElements[this.state.tabbableElements.length - 1].id) {
	                this.state.tabbableElements[1].focus();
	            }
	
	            this.setState({
	                tabPressed: false,
	                shiftPressed: false
	            });
	        }
	    }, {
	        key: 'setHeight',
	        value: function setHeight() {
	
	            this.setState({ updateHeight: false });
	            var screenWrapper = document.getElementById('screenWrapper');
	            var header = document.getElementById('dialogHeader_' + this.state.guid);
	
	            if (appHelper.isDefined(header) && header !== null) {
	                var newHeight = screenWrapper.offsetHeight - header.offsetHeight;
	                this.setState({ height: newHeight });
	            }
	        }
	    }, {
	        key: 'getHeight',
	        value: function getHeight() {
	            if (appHelper.isDefined(this.state.height)) {
	                return {
	                    height: this.state.height + 'px',
	                    minHeight: this.state.height + 'px'
	                };
	            } else {
	                return {};
	            }
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            return _react2.default.createElement(
	                'div',
	                { className: this.state.dialogPopup.className + " " + this.state.dialogPopup.config.theme, ref: 'contentDialog', id: 'content-dialog', role: 'dialog', 'aria-modal': this.state.isDialog, 'aria-labelledby': 'content-dialog' },
	                this.state.isOpen ? _react2.default.createElement(
	                    'div',
	                    null,
	                    _react2.default.createElement('div', { id: 'firstTabIndex_contentDialog_' + this.state.guid, tabIndex: '0', role: 'button' }),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'dialog-header truncate-text-container guroo-dialog-header',
	                            id: 'dialogHeader_' + this.state.guid },
	                        _react2.default.createElement(
	                            'div',
	                            { className: this.state.dialogPopup.config.icon + ' icon-first dialog-title', role: 'link',
	                                tabIndex: '0', ref: 'closeDialogBtn', id: 'closeDialogBtn',
	                                onClick: this.props.onCloseDialog,
	                                onKeyDown: this.setKeyboardAccessibility },
	                            this.state.dialogPopup.config.title
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'dialog-body', style: this.getHeight() },
	                        this.state.dialogPopup.config.childComponents.map(function (component) {
	                            return _react2.default.createElement(
	                                'div',
	                                { key: "container_" + component.id, className: 'component-seperator' },
	                                component.componentProps !== null ? _react2.default.createElement(component.childComponent, _extends({ key: component.id }, component.componentProps)) : _react2.default.createElement(component.childComponent, { key: component.id })
	                            );
	                        })
	                    ),
	                    _react2.default.createElement('div', { id: 'lastTabIndex_contentDialog_' + this.state.guid, tabIndex: '0', role: 'button' })
	                ) : null
	            );
	        }
	    }]);
	
	    return ContentDialog;
	}(_react2.default.Component);
	
	ContentDialog.propTypes = {
	    dialogPopup: _propTypes2.default.object.isRequired,
	    onCloseDialog: _propTypes2.default.func.isRequired,
	    actions: _propTypes2.default.object.isRequired,
	    fontSize: _propTypes2.default.object.isRequired
	};
	
	//Pull in the React Router context so router is available on this.context.router.
	ContentDialog.contextTypes = {
	    router: _propTypes2.default.object
	};
	
	//Init
	function mapStateToProps(state, ownProps) {
	    return {
	        fontSize: state.fontSize
	    };
	}
	
	function mapDispatchToProps(dispatch) {
	    return {
	
	        actions: (0, _redux.bindActionCreators)(Object.assign({}, dialogPopupActions), dispatch)
	    };
	}
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(ContentDialog);
	
	/*
	ContentDialog.propTypes ={
	    dialogPopup: React.PropTypes.object.isRequired,
	    onCloseDialog: React.PropTypes.func.isRequired,
	};

	export default ContentDialog;*/

/***/ },
/* 452 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.DialogPopup = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _gsap = __webpack_require__(8);
	
	var _gsapReactPlugin = __webpack_require__(10);
	
	var _gsapReactPlugin2 = _interopRequireDefault(_gsapReactPlugin);
	
	var _reactDom = __webpack_require__(55);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _reactRedux = __webpack_require__(5);
	
	var _redux = __webpack_require__(4);
	
	var _dialogPopupActions = __webpack_require__(19);
	
	var dialogPopupActions = _interopRequireWildcard(_dialogPopupActions);
	
	var _keyboardConstants = __webpack_require__(14);
	
	var keyboardConstants = _interopRequireWildcard(_keyboardConstants);
	
	var _objectConstants = __webpack_require__(9);
	
	var objectConstants = _interopRequireWildcard(_objectConstants);
	
	var _appHelper = __webpack_require__(3);
	
	var appHelper = _interopRequireWildcard(_appHelper);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	//import ReactCSSTransitionGroup from 'react-addons-css-transition-group';
	
	
	//import toastr from 'toastr';
	
	var DialogPopup = exports.DialogPopup = function (_React$Component) {
	    _inherits(DialogPopup, _React$Component);
	
	    function DialogPopup(props, context) {
	        _classCallCheck(this, DialogPopup);
	
	        var _this = _possibleConstructorReturn(this, (DialogPopup.__proto__ || Object.getPrototypeOf(DialogPopup)).call(this, props, context));
	
	        _this.state = {
	            currentOpacity: 0,
	            currentTop: 0,
	
	            isOpenOpacity: 1,
	            isOpenTop: 0,
	
	            isClosedOpacity: 0,
	            isClosedTop: 0,
	
	            dialogPopup: Object.assign({}, _this.props.dialogPopup)
	
	        };
	        _this.openDialog = _this.openDialog.bind(_this);
	        _this.isOpenFunc = _this.isOpenFunc.bind(_this);
	        _this.closeDialog = _this.closeDialog.bind(_this);
	        _this.isClosedFunc = _this.isClosedFunc.bind(_this);
	        _this.setAccessibleExit = _this.setAccessibleExit.bind(_this);
	        return _this;
	    }
	
	    _createClass(DialogPopup, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            window.addEventListener("keydown", this.setAccessibleExit);
	
	            var func = this.openDialog;
	            setTimeout(function () {
	
	                func();
	            }, 200);
	        }
	    }, {
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(nextProps) {
	            if (this.state.dialogPopup !== nextProps.dialogPopup) {
	
	                //console.log(`nextProps.dialogPopup`,nextProps.dialogPopup);
	                this.setState({ dialogPopup: Object.assign({}, nextProps.dialogPopup, {
	                        isOpen: this.state.dialogPopup.isOpen,
	                        currentClassState: this.state.dialogPopup.currentClassState
	                    }) });
	            }
	        }
	    }, {
	        key: 'componentWillUnmount',
	        value: function componentWillUnmount() {
	            window.removeEventListener("keydown", this.setAccessibleExit);
	        }
	    }, {
	        key: 'openDialog',
	        value: function openDialog() {
	            var ref = this.refs.dialogPage;
	            if (appHelper.isDefined(ref) && ref !== null) {
	                _gsap.TweenLite.to(ref, objectConstants.DIALOG_DURATION, {
	                    opacity: this.state.isOpenOpacity,
	                    top: this.state.isOpenTop,
	                    delay: 0,
	                    ease: _gsap.Expo.easeInOut
	                }).eventCallback("onComplete", this.isOpenFunc);
	            }
	        }
	        //TweenLite.to(ref, 0.2, {opacity: this.state.isOpenOpacity, top: this.state.isOpenTop}).eventCallback("onComplete", this.isOpenFunc);//.eventCallback("onComplete", this.isOpenFunc);
	        //}
	
	    }, {
	        key: 'isOpenFunc',
	        value: function isOpenFunc() {
	            this.setState({ dialogPopup: Object.assign({}, this.state.dialogPopup, {
	                    isOpen: true,
	                    currentClassState: this.state.dialogPopup.classStates.isOpen
	                }) });
	        }
	    }, {
	        key: 'closeDialog',
	        value: function closeDialog() {
	            var dialogSource = document.getElementById(this.state.dialogPopup.config.sourceId);
	            if (appHelper.isDefined(dialogSource) && dialogSource !== null) {
	                dialogSource.focus();
	            }
	            this.setState({
	                dialogPopup: Object.assign({}, this.state.dialogPopup, {
	                    isOpen: false,
	                    currentClassState: this.state.dialogPopup.classStates.isClosed
	                })
	            });
	            if (appHelper.isDefined(this) && this !== null) {
	                _gsap.TweenLite.to(this, objectConstants.DIALOG_DURATION, {
	                    state: {
	                        currentOpacity: this.state.isClosedOpacity,
	                        currentTop: this.state.isClosedTop
	                    }, delay: 0.5
	                }).eventCallback("onComplete", this.isClosedFunc);
	            }
	        }
	    }, {
	        key: 'isClosedFunc',
	        value: function isClosedFunc() {
	            this.props.actions.removeDialog();
	        }
	    }, {
	        key: 'setAccessibleExit',
	        value: function setAccessibleExit(event) {
	            if (event.which === keyboardConstants.ESCAPE_KEY) {
	                event.preventDefault();
	                this.closeDialog();
	            }
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var DialogComponent = this.state.dialogPopup.config.dialogComponent;
	            return _react2.default.createElement(
	                'div',
	                { ref: 'dialogPage', className: "dialog-page " + this.state.dialogPopup.currentClassState, style: { opacity: this.state.currentOpacity }, role: 'dialog' },
	                _react2.default.createElement(DialogComponent, { dialogPopup: this.state.dialogPopup, onCloseDialog: this.closeDialog, style: { opacity: this.state.currentOpacity, top: this.state.currentTop } })
	            );
	        }
	    }]);
	
	    return DialogPopup;
	}(_react2.default.Component);
	
	DialogPopup.propTypes = {
	    dialogPopup: _propTypes2.default.object.isRequired,
	    actions: _propTypes2.default.object.isRequired
	};
	
	//Pull in the React Router context so router is available on this.context.router.
	DialogPopup.contextTypes = {
	    router: _propTypes2.default.object
	};
	
	//Init
	function mapStateToProps(state, ownProps) {
	    return {
	        dialogPopup: state.dialogPopup
	    };
	}
	
	function mapDispatchToProps(dispatch) {
	    return {
	        actions: (0, _redux.bindActionCreators)(Object.assign({}, dialogPopupActions), dispatch)
	    };
	}
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(DialogPopup);

/***/ },
/* 453 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.InitDialog = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(5);
	
	var _redux = __webpack_require__(4);
	
	var _reactDom = __webpack_require__(55);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _dialogPopupActions = __webpack_require__(19);
	
	var dialogPopupActions = _interopRequireWildcard(_dialogPopupActions);
	
	var _keyboardConstants = __webpack_require__(14);
	
	var keyboardConstants = _interopRequireWildcard(_keyboardConstants);
	
	var _dataHelper = __webpack_require__(11);
	
	var dataHelper = _interopRequireWildcard(_dataHelper);
	
	var _appHelper = __webpack_require__(3);
	
	var appHelper = _interopRequireWildcard(_appHelper);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var InitDialog = exports.InitDialog = function (_React$Component) {
	    _inherits(InitDialog, _React$Component);
	
	    function InitDialog(props, context) {
	        _classCallCheck(this, InitDialog);
	
	        var _this = _possibleConstructorReturn(this, (InitDialog.__proto__ || Object.getPrototypeOf(InitDialog)).call(this, props, context));
	
	        _this.state = {
	            dialogPopup: _this.props.dialogPopup,
	            firstTabIndex: "firstTabIndex",
	            lastTabIndex: "lastTabIndex",
	            tabbableElements: [],
	            isDialog: true,
	            isOpen: false,
	            guid: dataHelper.createGuid()
	        };
	        _this.setTabbableElements = _this.setTabbableElements.bind(_this);
	        _this.setKeyboardAccessibility = _this.setKeyboardAccessibility.bind(_this);
	        _this.setInitialFocus = _this.setInitialFocus.bind(_this);
	        _this.onKeyDown = _this.onKeyDown.bind(_this);
	        _this.onKeyUp = _this.onKeyUp.bind(_this);
	        return _this;
	    }
	
	    _createClass(InitDialog, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            this.setTabbableElements();
	            window.addEventListener("keydown", this.onKeyDown);
	            window.addEventListener("keyup", this.onKeyUp);
	        }
	    }, {
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(nextProps) {
	            if (this.state.dialogPopup !== nextProps.dialogPopup) {
	                this.setState({ dialogPopup: Object.assign({}, nextProps.dialogPopup) });
	            }
	        }
	    }, {
	        key: 'componentDidUpdate',
	        value: function componentDidUpdate() {
	            if (!this.state.isOpen && this.state.dialogPopup.isOpen) {
	                this.setInitialFocus();
	            }
	        }
	    }, {
	        key: 'componentWillUnmount',
	        value: function componentWillUnmount() {
	            window.removeEventListener("keydown", this.onKeyDown);
	            window.removeEventListener("keyup", this.onKeyUp);
	        }
	    }, {
	        key: 'setTabbableElements',
	        value: function setTabbableElements() {
	            var dialog = this.refs.initDialog;
	            this.setState({ tabbableElements: Object.assign([], dataHelper.getAllTabbableElements(dialog)) });
	        }
	    }, {
	        key: 'setKeyboardAccessibility',
	        value: function setKeyboardAccessibility(event) {
	            if (event.which === keyboardConstants.ENTER_KEY || event.which === keyboardConstants.SPACEBAR_KEY) {
	                event.preventDefault();
	                this.props.onCloseDialog();
	            }
	        }
	    }, {
	        key: 'setInitialFocus',
	        value: function setInitialFocus() {
	            this.setState({ isOpen: true });
	            var firstFocus = this.state.tabbableElements[1];
	            var func = this.openDialog;
	            setTimeout(function () {
	                firstFocus.focus();
	            }, 1000);
	        }
	    }, {
	        key: 'onKeyDown',
	        value: function onKeyDown(event) {
	            var shiftPressed = this.state.shiftPressed;
	            var tabPressed = this.state.tabPressed;
	
	            if (event.which === keyboardConstants.ESCAPE_KEY) {
	                event.preventDefault();
	                this.props.actions.removeDialog();
	                if (appHelper.isDefined(this.state.dialogPopup.config.sourceId)) {
	                    var sourceElement = document.getElementById(this.state.dialogPopup.config.sourceId);
	                    if (appHelper.isDefined(sourceElement)) {
	                        sourceElement.focus();
	                    }
	                }
	            }
	
	            if (event.which === keyboardConstants.TAB_KEY) {
	                tabPressed = true;
	                this.setState({
	                    tabPressed: tabPressed
	                });
	            }
	
	            if (event.which === keyboardConstants.SHIFT_KEY) {
	                shiftPressed = true;
	                this.setState({
	                    shiftPressed: shiftPressed
	                });
	            }
	        }
	    }, {
	        key: 'onKeyUp',
	        value: function onKeyUp(event) {
	            var activeItem = document.activeElement;
	            var activeItemId = activeItem.id;
	
	            if (activeItemId === this.state.tabbableElements[0].id) {
	                //go to last
	                this.state.tabbableElements[this.state.tabbableElements.length - 2].focus();
	            } else if (activeItemId === this.state.tabbableElements[this.state.tabbableElements.length - 1].id) {
	                this.state.tabbableElements[1].focus();
	            }
	
	            this.setState({
	                tabPressed: false,
	                shiftPressed: false
	            });
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	
	            return _react2.default.createElement(
	                'div',
	                { className: this.state.dialogPopup.className + " " + this.state.dialogPopup.config.theme, ref: 'initDialog', id: 'initDialog', role: 'dialog', 'aria-modal': this.state.isDialog, 'aria-labelledby': 'initDialog' },
	                _react2.default.createElement('div', { id: 'firstTabIndex_initDialog_' + this.state.guid, tabIndex: '0', role: 'button' }),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'dialog-header truncate-text-container guroo-dialog-header' },
	                    _react2.default.createElement(
	                        'div',
	                        {
	                            className: this.state.dialogPopup.config.icon + ' icon-first dialog-title' },
	                        this.state.dialogPopup.config.title
	                    )
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'dialog-body' },
	                    this.state.dialogPopup.config.childComponents.map(function (component) {
	                        return _react2.default.createElement(
	                            'div',
	                            { key: "container_" + component.id, className: 'component-seperator' },
	                            component.componentProps != null ? _react2.default.createElement(component.childComponent, _extends({ key: component.id }, component.componentProps)) : _react2.default.createElement(component.childComponent, { key: component.id })
	                        );
	                    })
	                ),
	                _react2.default.createElement('div', { id: 'lastTabIndex_initDialog_' + this.state.guid, tabIndex: '0', role: 'button' })
	            );
	        }
	    }]);
	
	    return InitDialog;
	}(_react2.default.Component);
	
	InitDialog.propTypes = {
	    dialogPopup: _propTypes2.default.object.isRequired,
	    onCloseDialog: _propTypes2.default.func.isRequired,
	    actions: _propTypes2.default.object.isRequired
	};
	
	//Pull in the React Router context so router is available on this.context.router.
	InitDialog.contextTypes = {
	    router: _propTypes2.default.object
	};
	
	//Init
	function mapStateToProps(state, ownProps) {
	    return {};
	}
	
	function mapDispatchToProps(dispatch) {
	    return {
	        actions: (0, _redux.bindActionCreators)(Object.assign({}, dialogPopupActions), dispatch)
	    };
	}
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(InitDialog);

/***/ },
/* 454 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _redux = __webpack_require__(4);
	
	var _reactRedux = __webpack_require__(5);
	
	var _mainMenuActions = __webpack_require__(134);
	
	var mainMenuActions = _interopRequireWildcard(_mainMenuActions);
	
	var _actionTypes = __webpack_require__(22);
	
	var actionTypes = _interopRequireWildcard(_actionTypes);
	
	var _appHelper = __webpack_require__(3);
	
	var appHelper = _interopRequireWildcard(_appHelper);
	
	var _dataHelper = __webpack_require__(11);
	
	var dataHelper = _interopRequireWildcard(_dataHelper);
	
	var _userDataHelper = __webpack_require__(15);
	
	var userDataHelper = _interopRequireWildcard(_userDataHelper);
	
	var _trackingDataActions = __webpack_require__(7);
	
	var trackingDataActions = _interopRequireWildcard(_trackingDataActions);
	
	var _MainMenuItem = __webpack_require__(276);
	
	var _MainMenuItem2 = _interopRequireDefault(_MainMenuItem);
	
	var _MainMenuAccordionBtn = __webpack_require__(455);
	
	var _MainMenuAccordionBtn2 = _interopRequireDefault(_MainMenuAccordionBtn);
	
	var _HomeButton = __webpack_require__(449);
	
	var _HomeButton2 = _interopRequireDefault(_HomeButton);
	
	var _TextResize = __webpack_require__(273);
	
	var _TextResize2 = _interopRequireDefault(_TextResize);
	
	var _LocalePicker = __webpack_require__(194);
	
	var _LocalePicker2 = _interopRequireDefault(_LocalePicker);
	
	var _objectConstants = __webpack_require__(9);
	
	var objectConstants = _interopRequireWildcard(_objectConstants);
	
	var _keyboardConstants = __webpack_require__(14);
	
	var keyboardConstants = _interopRequireWildcard(_keyboardConstants);
	
	var _localStorage = __webpack_require__(17);
	
	var localeStorage = _interopRequireWildcard(_localStorage);
	
	var _gsap = __webpack_require__(8);
	
	var _lodash = __webpack_require__(28);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _gsapReactPlugin = __webpack_require__(10);
	
	var _gsapReactPlugin2 = _interopRequireDefault(_gsapReactPlugin);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var MainMenu = function (_React$Component) {
	    _inherits(MainMenu, _React$Component);
	
	    function MainMenu(props, context) {
	        _classCallCheck(this, MainMenu);
	
	        var _this = _possibleConstructorReturn(this, (MainMenu.__proto__ || Object.getPrototypeOf(MainMenu)).call(this, props, context));
	
	        var bite_id = appHelper.getBiteByScreenId(_this.props.trackingData.lesson_location);
	        if (!appHelper.isDefined(bite_id)) {
	            bite_id = localeStorage.contentData.experience.bites[0].bite_id;
	        }
	
	        _this.state = {
	            lang: _this.props.lang,
	            bite: appHelper.getBiteById(bite_id),
	            screens: [],
	            setCurrentScreen: false,
	            current_screen_id: _this.props.trackingData.lesson_location,
	            currentFocusedScreenIndex: undefined,
	            currentFocusedSubScreenIndex: undefined,
	            isDialog: true,
	            tabPressed: false,
	            shiftPressed: false,
	            goToFirst: false,
	            goToLast: true,
	            accordionBtnPreId: "menuNavAccordionBtn_",
	            itemPreId: "menuNavItem_",
	            tabbableElements: [],
	            doSetTabbableElements: false,
	            guid: dataHelper.createGuid(),
	            fontSize: _this.props.fontSize,
	            height: undefined,
	            updateHeight: true,
	            main_menu_label: appHelper.getLocaleString("main_menu_label"),
	            showLocaleTitle: false
	        };
	
	        _this.setScreenStructure = _this.setScreenStructure.bind(_this);
	        _this.getScreenByParentScreenId = _this.getScreenByParentScreenId.bind(_this);
	        _this.setMainMenuStatus = _this.setMainMenuStatus.bind(_this);
	        _this.setMainMenuAnimation = _this.setMainMenuAnimation.bind(_this);
	        _this.showMenu = _this.showMenu.bind(_this);
	        _this.hideMenu = _this.hideMenu.bind(_this);
	        _this.closeMenu = _this.closeMenu.bind(_this);
	        _this.getClass = _this.getClass.bind(_this);
	        _this.setInitialFocus = _this.setInitialFocus.bind(_this);
	        _this.setKeyboardAccessibility = _this.setKeyboardAccessibility.bind(_this);
	        _this.onKeyDown = _this.onKeyDown.bind(_this);
	        _this.onKeyUp = _this.onKeyUp.bind(_this);
	        _this.setTabbableElements = _this.setTabbableElements.bind(_this);
	        _this.setHeight = _this.setHeight.bind(_this);
	        _this.getHeight = _this.getHeight.bind(_this);
	        return _this;
	    }
	
	    _createClass(MainMenu, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            window.addEventListener("keydown", this.onKeyDown);
	            window.addEventListener("keyup", this.onKeyUp);
	            this.setMainMenuAnimation();
	            this.setScreenStructure();
	        }
	    }, {
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(nextProps) {
	            if (this.state.fontSize !== nextProps.fontSize) {
	                this.setState({ fontSize: nextProps.fontSize, updateHeight: true });
	            }
	            if (this.state.lang !== nextProps.lang) {
	                this.setState({
	                    lang: nextProps.lang,
	                    main_menu_label: appHelper.getLocaleString("main_menu_label")
	                });
	            }
	        }
	    }, {
	        key: 'componentDidUpdate',
	        value: function componentDidUpdate() {
	            this.setMainMenuAnimation();
	
	            if (this.state.doSetTabbableElements) {
	                this.setTabbableElements();
	            }
	
	            if (this.state.updateHeight) {
	                this.setHeight();
	            }
	        }
	    }, {
	        key: 'componentWillUnmount',
	        value: function componentWillUnmount() {
	            window.removeEventListener("keydown", this.onKeyDown);
	            window.removeEventListener("keyup", this.onKeyUp);
	        }
	    }, {
	        key: 'setTabbableElements',
	        value: function setTabbableElements() {
	            var dialog = this.refs['main-menu'];
	            var tabbableElements = dataHelper.getAllTabbableElements(dialog);
	            this.setState({ doSetTabbableElements: false, tabbableElements: Object.assign([], tabbableElements) });
	        }
	    }, {
	        key: 'setInitialFocus',
	        value: function setInitialFocus() {
	            var mainMenuPanel = this.refs['closeMenuBtn'];
	            mainMenuPanel.focus();
	        }
	    }, {
	        key: 'setScreenStructure',
	        value: function setScreenStructure() {
	            //parent_screen_id
	            var topLevelScreens = this.getScreenByParentScreenId(null);
	            for (var i = 0; i < topLevelScreens.length; i++) {
	                var topLevelScreen = topLevelScreens[i];
	
	                var firstChildScreen = Object.assign({}, topLevelScreen);
	                var childScreens = this.getScreenByParentScreenId(topLevelScreen.screen_id);
	                if (childScreens.length > 0) {
	                    childScreens = dataHelper.immutableUnshift(childScreens, firstChildScreen);
	                }
	                topLevelScreen = Object.assign({}, topLevelScreen, {
	                    hasChildren: childScreens.length > 0,
	                    childScreens: childScreens
	                });
	
	                topLevelScreens = dataHelper.immutableSplice(topLevelScreens, i, 1, topLevelScreen);
	            }
	
	            this.setState({
	                setCurrentScreen: true,
	                screens: Object.assign([], topLevelScreens),
	                doSetTabbableElements: true
	            });
	        }
	    }, {
	        key: 'getScreenByParentScreenId',
	        value: function getScreenByParentScreenId(value) {
	            var screens = [];
	
	            for (var i = 0; i < this.state.bite.screens.length; i++) {
	                var screen = this.state.bite.screens[i];
	                if (value === null) {
	                    if (!appHelper.isDefined(screen.parent_screen_id) || screen.parent_screen_id === value) {
	                        if (this.state.bite.show_target_screens_in_menu && screen.screen_rule_type === objectConstants.SCREEN_RULE_TYPE_TARGET) {
	                            screens = dataHelper.immutablePush(screens, screen);
	                        } else if (screen.screen_rule_type !== objectConstants.SCREEN_RULE_TYPE_TARGET) {
	                            screens = dataHelper.immutablePush(screens, screen);
	                        }
	                    }
	                } else {
	                    if (appHelper.isDefined(screen.parent_screen_id) && screen.parent_screen_id === value) {
	                        if (this.state.bite.show_target_screens_in_menu && screen.screen_rule_type === objectConstants.SCREEN_RULE_TYPE_TARGET) {
	                            screens = dataHelper.immutablePush(screens, screen);
	                        } else if (screen.screen_rule_type !== objectConstants.SCREEN_RULE_TYPE_TARGET) {
	                            screens = dataHelper.immutablePush(screens, screen);
	                        }
	                    }
	                }
	            }
	
	            return screens;
	
	            //TODO: change to simpler 1 line code once we know that parent_screen_id exists everywhere
	            //return this.state.bite.screens.filter(obj => obj.parent_screen_id === value);
	        }
	    }, {
	        key: 'setMainMenuAnimation',
	        value: function setMainMenuAnimation() {
	            switch (this.props.displayMainMenu) {
	                case actionTypes.STATUS_OPENING:
	                    this.showMenu();
	                    break;
	                case actionTypes.STATUS_CLOSING:
	                    this.hideMenu();
	                    break;
	                default:
	                    break;
	            }
	        }
	    }, {
	        key: 'setMainMenuStatus',
	        value: function setMainMenuStatus() {
	            switch (this.props.displayMainMenu) {
	                case actionTypes.STATUS_OPENING:
	                    this.props.actions.setMainMenuDisplay(actionTypes.STATUS_OPEN);
	                    this.setInitialFocus();
	                    break;
	                case actionTypes.STATUS_CLOSING:
	                    this.props.actions.setMainMenuDisplay(actionTypes.STATUS_CLOSED);
	                    break;
	                default:
	                    break;
	            }
	        }
	    }, {
	        key: 'showMenu',
	        value: function showMenu() {
	            var mainMenuPanel = this.refs['main-menu'];
	            //TweenLite.set(mainMenuPanel, {height: "auto", opacity: 1});
	            _gsap.TweenLite.to(mainMenuPanel, objectConstants.DIALOG_DURATION, {
	                opacity: 1,
	                delay: 0,
	                ease: _gsap.Expo.easeInOut
	            }).eventCallback("onComplete", this.setMainMenuStatus);
	        }
	    }, {
	        key: 'hideMenu',
	        value: function hideMenu() {
	            this.getClass();
	            var mainMenuPanel = this.refs['main-menu'];
	            //TweenLite.set(mainMenuPanel, {height: 0, opacity: 0});
	            _gsap.TweenLite.to(mainMenuPanel, objectConstants.DIALOG_DURATION, {
	
	                opacity: 0,
	                ease: _gsap.Expo.easeInOut
	            }).eventCallback("onComplete", this.setMainMenuStatus);
	        }
	    }, {
	        key: 'getClass',
	        value: function getClass() {
	            if (this.props.displayMainMenu === actionTypes.STATUS_OPEN) {
	                return "dialog-open";
	            } else {
	                return "dialog-closed";
	            }
	        }
	    }, {
	        key: 'closeMenu',
	        value: function closeMenu() {
	            var mainMenuBtn = document.getElementById("mainMenuBtn");
	
	            setTimeout(function () {
	                mainMenuBtn.focus();
	            }, 1000);
	            this.props.actions.setMainMenuDisplay(actionTypes.STATUS_CLOSING);
	        }
	    }, {
	        key: 'getHeaderClass',
	        value: function getHeaderClass() {}
	    }, {
	        key: 'setKeyboardAccessibility',
	        value: function setKeyboardAccessibility(event) {
	            if (event.which === keyboardConstants.ENTER_KEY || event.which === keyboardConstants.SPACEBAR_KEY) {
	                event.preventDefault();
	                this.closeMenu();
	            }
	        }
	    }, {
	        key: 'onKeyDown',
	        value: function onKeyDown(event) {
	            var shiftPressed = this.state.shiftPressed;
	            var tabPressed = this.state.tabPressed;
	
	            if (event.which === keyboardConstants.ESCAPE_KEY) {
	
	                event.preventDefault();
	                this.closeMenu();
	            }
	
	            if (event.which === keyboardConstants.TAB_KEY) {
	
	                tabPressed = true;
	                this.setState({
	                    tabPressed: tabPressed
	                });
	            }
	
	            if (event.which === keyboardConstants.SHIFT_KEY) {
	                shiftPressed = true;
	                this.setState({
	                    shiftPressed: shiftPressed
	                });
	            }
	        }
	    }, {
	        key: 'onKeyUp',
	        value: function onKeyUp(event) {
	            var activeItem = document.activeElement;
	            var activeItemId = activeItem.id;
	            if (activeItemId === this.state.tabbableElements[0].id) {
	                //go to last
	                this.state.tabbableElements[this.state.tabbableElements.length - 2].focus();
	            } else if (activeItemId === this.state.tabbableElements[this.state.tabbableElements.length - 1].id) {
	                this.state.tabbableElements[1].focus();
	            }
	
	            this.setState({
	                tabPressed: false,
	                shiftPressed: false
	            });
	        }
	    }, {
	        key: 'setHeight',
	        value: function setHeight() {
	            this.setState({ updateHeight: false });
	            var screenWrapper = document.getElementById('screenWrapper');
	            var header = document.getElementById('closeMenuBtn');
	            if (appHelper.isDefined(header)) {
	                var newHeight = screenWrapper.offsetHeight - header.offsetHeight;
	                this.setState({ height: newHeight });
	            }
	        }
	    }, {
	        key: 'getHeight',
	        value: function getHeight() {
	            if (appHelper.isDefined(this.state.height)) {
	                return {
	                    height: this.state.height + 'px',
	                    minHeight: this.state.height + 'px'
	                };
	            } else {
	                return {};
	            }
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this2 = this;
	
	            return _react2.default.createElement(
	                'div',
	                { className: 'dialog-page menu-page ' + this.getClass(), ref: 'main-menu', id: 'main-menu', role: 'dialog',
	                    'aria-modal': this.state.isDialog, 'aria-labelledby': 'main-menu' },
	                _react2.default.createElement('div', { id: 'firstTabIndex_mainMenu_' + this.state.guid, tabIndex: '0', role: 'button' }),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'content-dialog main-menu' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'dialog-header guroo-dialog-header', onClick: this.closeMenu, ref: 'closeMenuBtn',
	                            id: 'closeMenuBtn',
	                            onKeyDown: this.setKeyboardAccessibility, role: 'link', tabIndex: '0' },
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'flex-row-nowrap flex-align-items-center' },
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'flex-1' },
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: 'icons8-menu icon-first dialog-title' },
	                                    this.state.main_menu_label
	                                )
	                            ),
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'flex-1 text-right' },
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: 'flex-row-nowrap flex-align-items-center flex-justify-content-end' },
	                                    Object.keys(localeStorage.localeOptions).length > 1 && _react2.default.createElement(
	                                        'div',
	                                        null,
	                                        _react2.default.createElement(_LocalePicker2.default, { showTitle: this.state.showLocaleTitle })
	                                    ),
	                                    _react2.default.createElement(
	                                        'div',
	                                        null,
	                                        _react2.default.createElement(_TextResize2.default, null)
	                                    ),
	                                    localeStorage.bites.length > 1 && userDataHelper.getBiteStatus(this.props.userData.bites[0]) === objectConstants.STATUS_COMPLETE ? _react2.default.createElement(
	                                        'div',
	                                        null,
	                                        _react2.default.createElement(_HomeButton2.default, { closeMenu: this.closeMenu })
	                                    ) : null
	                                )
	                            )
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'dialog-body', style: this.getHeight() },
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'main-menu-nav', role: 'menu' },
	                            this.state.screens.map(function (screen) {
	                                return !screen.hasChildren ? !_this2.state.bite.show_target_screens_in_menu || _this2.state.bite.show_target_screens_in_menu && screen.screen_rule_type === objectConstants.SCREEN_RULE_TYPE_TARGET ? _react2.default.createElement(_MainMenuItem2.default, {
	                                    key: screen.screen_id,
	                                    screen: screen,
	                                    className: 'list-group-item list-group-item-action'
	                                }) : null : _react2.default.createElement(_MainMenuAccordionBtn2.default, { key: screen.screen_id,
	                                    screen: screen,
	                                    className: 'list-group-item list-group-item-action' });
	                            })
	                        ),
	                        _react2.default.createElement('div', { id: 'lastTabIndex_mainMenu_' + this.state.guid, tabIndex: '0', role: 'button' })
	                    )
	                )
	            );
	        }
	    }]);
	
	    return MainMenu;
	}(_react2.default.Component);
	
	MainMenu.propTypes = {
	    children: _react2.default.PropTypes.node,
	    displayMainMenu: _propTypes2.default.string.isRequired,
	    userData: _propTypes2.default.object.isRequired,
	    trackingData: _propTypes2.default.object.isRequired,
	    actions: _propTypes2.default.object.isRequired,
	    fontSize: _propTypes2.default.object.isRequired,
	    lang: _propTypes2.default.string.isRequired
	};
	
	function mapStateToProps(state, ownProps) {
	    var lang = state.userData.lang;
	    return {
	        lang: lang,
	        displayMainMenu: state.displayMainMenu,
	        userData: state.userData,
	        trackingData: state.trackingData,
	        fontSize: state.fontSize
	
	    };
	}
	
	function mapDispatchToProps(dispatch) {
	    return {
	        actions: (0, _redux.bindActionCreators)(Object.assign({}, mainMenuActions, trackingDataActions), dispatch)
	    };
	}
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(MainMenu);

/***/ },
/* 455 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _redux = __webpack_require__(4);
	
	var _reactRedux = __webpack_require__(5);
	
	var _MainMenuItem = __webpack_require__(276);
	
	var _MainMenuItem2 = _interopRequireDefault(_MainMenuItem);
	
	var _trackingDataActions = __webpack_require__(7);
	
	var trackingDataActions = _interopRequireWildcard(_trackingDataActions);
	
	var _mainMenuActions = __webpack_require__(134);
	
	var mainMenuActions = _interopRequireWildcard(_mainMenuActions);
	
	var _actionTypes = __webpack_require__(22);
	
	var actionTypes = _interopRequireWildcard(_actionTypes);
	
	var _userDataHelper = __webpack_require__(15);
	
	var _appHelper = __webpack_require__(3);
	
	var appHelper = _interopRequireWildcard(_appHelper);
	
	var _objectConstants = __webpack_require__(9);
	
	var objectConstants = _interopRequireWildcard(_objectConstants);
	
	var _keyboardConstants = __webpack_require__(14);
	
	var keyboardConstants = _interopRequireWildcard(_keyboardConstants);
	
	var _lodash = __webpack_require__(28);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _gsap = __webpack_require__(8);
	
	var _gsapReactPlugin = __webpack_require__(10);
	
	var _gsapReactPlugin2 = _interopRequireDefault(_gsapReactPlugin);
	
	var _reactDom = __webpack_require__(55);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var MainMenuAccordionBtn = function (_React$Component) {
	    _inherits(MainMenuAccordionBtn, _React$Component);
	
	    function MainMenuAccordionBtn(props, context) {
	        _classCallCheck(this, MainMenuAccordionBtn);
	
	        var _this = _possibleConstructorReturn(this, (MainMenuAccordionBtn.__proto__ || Object.getPrototypeOf(MainMenuAccordionBtn)).call(this, props, context));
	
	        _this.state = {
	            lang: _this.props.lang,
	            locale: appHelper.getLocalData(_this.props.screen),
	            bite: appHelper.getBiteById(_this.props.bite_id),
	            userBite: _this.props.userBite,
	            userScreen: _this.props.userScreen,
	            screen_status: _this.props.userScreen.status,
	            section_status: objectConstants.STATUS_NOT_STARTED,
	            //current_screen_id: this.props.current_screen_id,
	            current_screen_id: _this.props.trackingData.lesson_location,
	            is_current_section: false,
	            accordionIsOpen: false,
	            canClickMenu: false,
	            isEnabled: false,
	            checkEnabledState: false,
	            setLocale: false
	        };
	
	        _this.toggleAccordion = _this.toggleAccordion.bind(_this);
	        _this.hideAccordionMenu = _this.hideAccordionMenu.bind(_this);
	        _this.showAccordionMenu = _this.showAccordionMenu.bind(_this);
	        _this.onMenuHandledComplete = _this.onMenuHandledComplete.bind(_this);
	        _this.setSectionProgress = _this.setSectionProgress.bind(_this);
	        _this.isCurrentSection = _this.isCurrentSection.bind(_this);
	        _this.setClass = _this.setClass.bind(_this);
	        _this.setIsActive = _this.setIsActive.bind(_this);
	        _this.loadScreen = _this.loadScreen.bind(_this);
	        _this.setEnabledState = _this.setEnabledState.bind(_this);
	        _this.setKeyboardAccessibility = _this.setKeyboardAccessibility.bind(_this);
	        _this.loadScreenByKeyboardAccessibility = _this.loadScreenByKeyboardAccessibility.bind(_this);
	        _this.getLocale = _this.getLocale.bind(_this);
	        return _this;
	    }
	
	    _createClass(MainMenuAccordionBtn, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            this.setEnabledState();
	            this.isCurrentSection();
	            this.setSectionProgress();
	        }
	    }, {
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(nextProps) {
	            if (this.state.userBite !== nextProps.userBite) {
	                this.setState({
	                    userBite: Object.assign({}, nextProps.userBite),
	                    userScreen: Object.assign({}, nextProps.userScreen),
	                    screen_status: nextProps.userScreen.status,
	                    checkEnabledState: true
	                });
	            }
	
	            if (this.state.lang !== nextProps.lang) {
	                this.setState({
	                    lang: nextProps.lang,
	                    locale: Object.assign({}, appHelper.getLocalData(this.props.screen))
	                });
	            }
	        }
	    }, {
	        key: 'componentDidUpdate',
	        value: function componentDidUpdate() {
	            if (this.state.checkEnabledState) {
	                this.setEnabledState();
	            }
	
	            if (this.state.setLocale) {
	                this.getLocale();
	            }
	        }
	    }, {
	        key: 'getLocale',
	        value: function getLocale() {
	            var locale = appHelper.getLocalData(this.state.screen);
	            this.setState({ locale: Object.assign({}, locale), setLocale: false });
	        }
	    }, {
	        key: 'setEnabledState',
	        value: function setEnabledState() {
	
	            var isEnabled = false;
	            if (this.state.bite.navigation_type === objectConstants.LINEAR) {
	                isEnabled = appHelper.checkLinearScreenEnabled(this.state.userScreen, this.state.userBite);
	            } else {
	                isEnabled = true;
	            }
	
	            this.setState({
	                checkEnabledState: false,
	                isEnabled: isEnabled
	            });
	        }
	    }, {
	        key: 'isCurrentSection',
	        value: function isCurrentSection() {
	            var _this2 = this;
	
	            var isCurrentSection = this.props.screen.childScreens.filter(function (obj) {
	                return obj.screen_id === _this2.state.current_screen_id;
	            }).length > 0;
	            this.setState({
	                is_current_section: isCurrentSection
	
	            });
	            if (isCurrentSection && !appHelper.isDefined(this.props.screen.show_children_screens_in_menu) || appHelper.isDefined(this.props.screen.show_children_screens_in_menu) && this.props.screen.show_children_screens_in_menu) {
	                this.showAccordionMenu();
	            }
	
	            this.setSectionProgress();
	        }
	    }, {
	        key: 'setSectionProgress',
	        value: function setSectionProgress() {
	            var status = objectConstants.STATUS_NOT_STARTED;
	            var not_started_screens = 0;
	            var not_required_screens = 0;
	            var in_progress_screens = 0;
	            var completed_screens = 0;
	
	            for (var i = 0; i < this.props.screen.childScreens.length; i++) {
	                var screen = this.props.screen.childScreens[i];
	                var userScreen = (0, _userDataHelper.getScreenUserData)(this.props.userData, screen.screen_id);
	                if (userScreen.status === objectConstants.STATUS_NOT_STARTED) {
	                    not_started_screens++;
	                } else if (userScreen.status === objectConstants.STATUS_NOT_REQUIRED) {
	                    not_required_screens++;
	                } else if (userScreen.status === objectConstants.STATUS_IN_PROGRESS) {
	                    in_progress_screens++;
	                } else if (userScreen.status === objectConstants.STATUS_COMPLETE) {
	                    completed_screens++;
	                }
	            }
	
	            var complete_and_non_required_screens = completed_screens + not_required_screens;
	
	            if (complete_and_non_required_screens === this.props.screen.childScreens.length && not_required_screens < completed_screens) {
	                status = objectConstants.STATUS_COMPLETE;
	            } else if (not_required_screens === this.props.screen.childScreens.length) {
	                status = objectConstants.STATUS_NOT_REQUIRED;
	            } else if (in_progress_screens > 0 || completed_screens > 0) {
	                status = objectConstants.STATUS_IN_PROGRESS;
	            }
	            this.setState({ section_status: status });
	        }
	    }, {
	        key: 'toggleAccordion',
	        value: function toggleAccordion() {
	            if (this.state.isEnabled) {
	                if (this.state.accordionIsOpen) {
	                    this.hideAccordionMenu();
	                } else {
	                    this.showAccordionMenu();
	                }
	            }
	        }
	    }, {
	        key: 'hideAccordionMenu',
	        value: function hideAccordionMenu() {
	            this.setState({ accordionIsOpen: false, canClickMenu: false });
	            var mainMenu = this.refs['accordion_' + this.props.screen.screen_id];
	            _gsap.TweenLite.to(mainMenu, objectConstants.ACCORDION_BUTTON_DURATION, { height: 0, ease: _gsap.Expo.easeInOut }).eventCallback("onComplete", this.onMenuHandledComplete);
	        }
	    }, {
	        key: 'showAccordionMenu',
	        value: function showAccordionMenu() {
	            this.setState({ accordionIsOpen: true, canClickMenu: false });
	            var mainMenu = this.refs['accordion_' + this.props.screen.screen_id];
	            _gsap.TweenLite.set(mainMenu, { height: "auto" });
	            _gsap.TweenLite.from(mainMenu, objectConstants.ACCORDION_BUTTON_DURATION, { height: 0, ease: _gsap.Expo.easeInOut }).eventCallback("onComplete", this.onMenuHandledComplete);
	        }
	    }, {
	        key: 'onMenuHandledComplete',
	        value: function onMenuHandledComplete() {
	            if (this.state.allowStateUpdates) {
	                this.setState({ canClickMenu: true });
	            }
	        }
	    }, {
	        key: 'loadScreen',
	        value: function loadScreen() {
	            if (this.state.isEnabled) {
	                this.props.actions.setNewLessonLocation(this.props.screen.screen_id);
	                this.props.actions.setMainMenuDisplay(actionTypes.STATUS_CLOSING);
	            }
	        }
	    }, {
	        key: 'setClass',
	        value: function setClass() {
	            var className = '';
	            if (this.state.isEnabled) {
	                if (this.state.accordionIsOpen) {
	                    className += 'open ';
	                } else {
	                    className += 'closed ';
	                }
	            } else {
	                className += 'disabled closed ';
	            }
	
	            if (this.state.section_status === objectConstants.STATUS_NOT_REQUIRED) {
	                className += objectConstants.CLASS_NOT_REQUIRED + ' ';
	            } else if (this.state.section_status === objectConstants.STATUS_IN_PROGRESS) {
	                className += objectConstants.CLASS_IN_PROGRESS + ' ';
	            } else if (this.state.section_status === objectConstants.STATUS_COMPLETE) {
	                className += objectConstants.CLASS_COMPLETE + ' ';
	            } else {
	                className += objectConstants.CLASS_NOT_STARTED + ' ';
	            }
	
	            return className;
	        }
	    }, {
	        key: 'setIsActive',
	        value: function setIsActive() {
	            return this.state.is_current_section ? "active" : "";
	        }
	    }, {
	        key: 'setKeyboardAccessibility',
	        value: function setKeyboardAccessibility(event) {
	            if (event.which === keyboardConstants.ENTER_KEY || event.which === keyboardConstants.SPACEBAR_KEY) {
	                event.preventDefault();
	                this.toggleAccordion();
	            }
	        }
	    }, {
	        key: 'loadScreenByKeyboardAccessibility',
	        value: function loadScreenByKeyboardAccessibility(event) {
	            if (event.which === keyboardConstants.ENTER_KEY || event.which === keyboardConstants.SPACEBAR_KEY) {
	                event.preventDefault();
	                this.loadScreen();
	            }
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this3 = this;
	
	            return !appHelper.isDefined(this.props.screen.show_children_screens_in_menu) || appHelper.isDefined(this.props.screen.show_children_screens_in_menu) && this.props.screen.show_children_screens_in_menu ? _react2.default.createElement(
	                'div',
	                { className: 'menu-nav-accordion' },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'menu-nav-accordion-btn ' + this.setClass(), onClick: this.toggleAccordion, onKeyDown: this.setKeyboardAccessibility, tabIndex: '0', role: 'link', id: 'menuNavAccordionBtn_' + this.props.screen.screen_id },
	                    _react2.default.createElement('div', { className: 'label-padding', dangerouslySetInnerHTML: { __html: this.state.locale.title } })
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'accordion-list', ref: 'accordion_' + this.props.screen.screen_id, role: 'menu' },
	                    this.props.screen.childScreens.map(function (childScreen) {
	                        return _react2.default.createElement(_MainMenuItem2.default, {
	                            key: childScreen.screen_id,
	                            screen: childScreen,
	                            current_screen_id: _this3.state.current_screen_id,
	                            className: 'list-group-item list-group-item-action',
	                            isAccessible: _this3.state.accordionIsOpen
	                        });
	                    })
	                )
	            ) : _react2.default.createElement('div', { className: 'menu-nav-item ' + this.setClass() + ' ' + this.setIsActive(), onClick: this.loadScreen, onKeyDown: this.loadScreenByKeyboardAccessibility, dangerouslySetInnerHTML: { __html: this.state.locale.title }, role: 'link', tabIndex: '0', id: 'menuNavItem_' + this.props.screen.screen_id });
	        }
	    }]);
	
	    return MainMenuAccordionBtn;
	}(_react2.default.Component);
	
	MainMenuAccordionBtn.propTypes = {
	    screen: _propTypes2.default.object.isRequired,
	    userData: _propTypes2.default.object.isRequired,
	    bite_id: _propTypes2.default.number.isRequired,
	    screen_id: _propTypes2.default.number.isRequired,
	    userBite: _propTypes2.default.object.isRequired,
	    userScreen: _propTypes2.default.object.isRequired,
	    lang: _propTypes2.default.string.isRequired,
	    //current_screen_id: PropTypes.string.isRequired,
	    trackingData: _propTypes2.default.object.isRequired,
	    actions: _propTypes2.default.object.isRequired
	};
	
	function mapStateToProps(state, ownProps) {
	    var bite_id = appHelper.getBiteByScreenId(state.trackingData.lesson_location);
	    var screen_id = ownProps.screen.screen_id;
	
	    var userBite = _lodash2.default.find(state.userData.bites, function (bites) {
	        return bites.bite_id === bite_id;
	    });
	
	    var userScreen = _lodash2.default.find(userBite.screens, function (screen) {
	        return screen.screen_id === screen_id;
	    });
	
	    var lang = state.userData.lang;
	
	    return {
	        screen: ownProps.screen,
	        userData: state.userData,
	        bite_id: bite_id,
	        screen_id: screen_id,
	        userBite: userBite,
	        userScreen: userScreen,
	        trackingData: state.trackingData,
	        lang: lang
	    };
	}
	
	function mapDispatchToProps(dispatch) {
	    return {
	        actions: (0, _redux.bindActionCreators)(Object.assign({}, trackingDataActions, mainMenuActions), dispatch)
	    };
	}
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(MainMenuAccordionBtn);

/***/ },
/* 456 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRouter = __webpack_require__(45);
	
	var _reactRedux = __webpack_require__(5);
	
	var _redux = __webpack_require__(4);
	
	var _appDataActions = __webpack_require__(12);
	
	var appDataActions = _interopRequireWildcard(_appDataActions);
	
	var _trackingDataActions = __webpack_require__(7);
	
	var trackingDataActions = _interopRequireWildcard(_trackingDataActions);
	
	var _mainMenuActions = __webpack_require__(134);
	
	var mainMenuActions = _interopRequireWildcard(_mainMenuActions);
	
	var _appHelper = __webpack_require__(3);
	
	var appHelper = _interopRequireWildcard(_appHelper);
	
	var _actionTypes = __webpack_require__(22);
	
	var actionTypes = _interopRequireWildcard(_actionTypes);
	
	var _componentHelper = __webpack_require__(31);
	
	var _keyboardConstants = __webpack_require__(14);
	
	var keyboardConstants = _interopRequireWildcard(_keyboardConstants);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var MenuButton = function (_React$Component) {
	    _inherits(MenuButton, _React$Component);
	
	    function MenuButton(props, context) {
	        _classCallCheck(this, MenuButton);
	
	        var _this = _possibleConstructorReturn(this, (MenuButton.__proto__ || Object.getPrototypeOf(MenuButton)).call(this, props, context));
	
	        _this.state = {
	            lang: _this.props.lang,
	            label: appHelper.getLocaleString("menu_label"),
	            ariaHasPopup: true
	        };
	        _this.setMainMenuStatus = _this.setMainMenuStatus.bind(_this);
	        _this.setBtnClass = _this.setBtnClass.bind(_this);
	        _this.setIconClass = _this.setIconClass.bind(_this);
	        _this.setKeyboardAccessibility = _this.setKeyboardAccessibility.bind(_this);
	        return _this;
	    }
	
	    _createClass(MenuButton, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {}
	    }, {
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(nextProps) {
	            if (this.state.lang !== nextProps.lang) {
	                this.setState({
	                    lang: nextProps.lang,
	                    label: appHelper.getLocaleString("menu_label")
	                });
	            }
	        }
	    }, {
	        key: 'setMainMenuStatus',
	        value: function setMainMenuStatus() {
	            var disabled = false;
	            if (appHelper.isDefined(this.props.disabled)) {
	                disabled = this.props.disabled;
	            }
	
	            if (!disabled) {
	                switch (this.props.displayMainMenu) {
	                    case actionTypes.STATUS_CLOSED:
	                        this.props.actions.setMainMenuDisplay(actionTypes.STATUS_OPENING);
	                        break;
	                    case actionTypes.STATUS_OPEN:
	                        this.props.actions.setMainMenuDisplay(actionTypes.STATUS_CLOSING);
	                        break;
	                    default:
	                        break;
	                }
	            }
	        }
	    }, {
	        key: 'setKeyboardAccessibility',
	        value: function setKeyboardAccessibility(event) {
	            if (event.which === keyboardConstants.ENTER_KEY || event.which === keyboardConstants.SPACEBAR_KEY) {
	                event.preventDefault();
	                this.setMainMenuStatus();
	            }
	        }
	    }, {
	        key: 'setBtnClass',
	        value: function setBtnClass() {
	            var disabled = false;
	            if (appHelper.isDefined(this.props.disabled)) {
	                disabled = this.props.disabled;
	            }
	
	            return disabled ? "disabled" : "";
	        }
	    }, {
	        key: 'setIconClass',
	        value: function setIconClass() {
	            if (this.props.displayMainMenu === actionTypes.STATUS_OPEN) {
	                return "icons8-multiply";
	            } else {
	                return "icons8-menu";
	            }
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            return _react2.default.createElement(
	                'div',
	                { className: 'header-btn ' + this.setBtnClass(), onClick: this.setMainMenuStatus, onKeyDown: this.setKeyboardAccessibility, id: 'mainMenuBtn', role: 'link', tabIndex: !this.props.disabled ? "0" : "-1", 'aria-controls': 'main-menu', title: this.state.label, 'aria-haspopup': this.state.ariaHasPopup, 'aria-disabled': this.props.disabled },
	                _react2.default.createElement('div', { className: 'icon ' + this.setIconClass() + ' ' }),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'btn-label' },
	                    this.state.label
	                )
	            );
	        }
	    }]);
	
	    return MenuButton;
	}(_react2.default.Component);
	
	MenuButton.propTypes = {
	    disabled: _propTypes2.default.bool,
	    displayMainMenu: _propTypes2.default.string.isRequired,
	    lang: _propTypes2.default.string.isRequired,
	    actions: _propTypes2.default.object.isRequired
	
	};
	
	MenuButton.contextTypes = {
	    router: _propTypes2.default.object
	};
	
	function mapStateToProps(state, ownProps) {
	    var lang = state.userData.lang;
	    return {
	        displayMainMenu: state.displayMainMenu,
	        lang: lang
	    };
	}
	
	function mapDispatchToProps(dispatch) {
	    return {
	        actions: (0, _redux.bindActionCreators)(Object.assign({}, mainMenuActions), dispatch)
	    };
	}
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(MenuButton);

/***/ },
/* 457 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _redux = __webpack_require__(4);
	
	var _reactRedux = __webpack_require__(5);
	
	var _ResourcesMenu = __webpack_require__(459);
	
	var _ResourcesMenu2 = _interopRequireDefault(_ResourcesMenu);
	
	var _appModels = __webpack_require__(68);
	
	var _resourcesActions = __webpack_require__(150);
	
	var resourcesActions = _interopRequireWildcard(_resourcesActions);
	
	var _actionTypes = __webpack_require__(22);
	
	var actionTypes = _interopRequireWildcard(_actionTypes);
	
	var _appHelper = __webpack_require__(3);
	
	var appHelper = _interopRequireWildcard(_appHelper);
	
	var _dataHelper = __webpack_require__(11);
	
	var dataHelper = _interopRequireWildcard(_dataHelper);
	
	var _trackingDataActions = __webpack_require__(7);
	
	var trackingDataActions = _interopRequireWildcard(_trackingDataActions);
	
	var _keyboardConstants = __webpack_require__(14);
	
	var keyboardConstants = _interopRequireWildcard(_keyboardConstants);
	
	var _objectConstants = __webpack_require__(9);
	
	var objectConstants = _interopRequireWildcard(_objectConstants);
	
	var _componentHelper = __webpack_require__(31);
	
	var _gsap = __webpack_require__(8);
	
	var _localStorage = __webpack_require__(17);
	
	var localeStorage = _interopRequireWildcard(_localStorage);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Resources = function (_React$Component) {
	    _inherits(Resources, _React$Component);
	
	    function Resources(props, context) {
	        _classCallCheck(this, Resources);
	
	        var _this = _possibleConstructorReturn(this, (Resources.__proto__ || Object.getPrototypeOf(Resources)).call(this, props, context));
	
	        var bite_id = appHelper.getBiteByScreenId(_this.props.trackingData.lesson_location);
	        _this.state = {
	            lang: _this.props.lang,
	            bite: appHelper.getBiteById(bite_id),
	            resources: localeStorage.resources,
	            activeResource: _this.props.activeResourcesId !== 0 && appHelper.isDefined(appHelper.getArrayObjectByKey(localeStorage.resources, "screen_id", _this.props.activeResourcesId).screen_id) ? appHelper.getArrayObjectByKey(localeStorage.resources, "screen_id", _this.props.activeResourcesId) : localeStorage.resources[0],
	            activeResourcesId: _this.props.activeResourcesId,
	            resources_screen_type: {},
	            callbacks: {},
	            tabbableElements: [],
	            doSetTabbableElements: false,
	            doSetIntitialFocus: false,
	            initalFocusSet: false,
	            isDialog: true,
	            elementInterval: {},
	            guid: dataHelper.createGuid(),
	            back_label: appHelper.getLocaleString("back_label"),
	            next_label: appHelper.getLocaleString("next_label")
	        };
	
	        _this.getResources = _this.getResources.bind(_this);
	        _this.getResourcesScreenType = _this.getResourcesScreenType.bind(_this);
	        _this.setResourcesStatus = _this.setResourcesStatus.bind(_this);
	        _this.setResourcesAnimation = _this.setResourcesAnimation.bind(_this);
	        _this.showResources = _this.showResources.bind(_this);
	        _this.hideResources = _this.hideResources.bind(_this);
	        _this.closeResources = _this.closeResources.bind(_this);
	        _this.getClass = _this.getClass.bind(_this);
	        _this.setActiveResource = _this.setActiveResource.bind(_this);
	        _this.setCallbacks = _this.setCallbacks.bind(_this);
	        _this.showHeader = _this.showHeader.bind(_this);
	        _this.getBiteId = _this.getBiteId.bind(_this);
	        _this.setToolTip = _this.setToolTip.bind(_this);
	        _this.getPreviousBtnClass = _this.getPreviousBtnClass.bind(_this);
	        _this.getNextBtnClass = _this.getNextBtnClass.bind(_this);
	        _this.getPreviousResource = _this.getPreviousResource.bind(_this);
	        _this.getNextResource = _this.getNextResource.bind(_this);
	        _this.setAccessibleExit = _this.setAccessibleExit.bind(_this);
	        _this.keyboardGetPreviousResource = _this.keyboardGetPreviousResource.bind(_this);
	        _this.keyboardGetNextResource = _this.keyboardGetNextResource.bind(_this);
	        _this.setTabbableElements = _this.setTabbableElements.bind(_this);
	        _this.setInitialFocus = _this.setInitialFocus.bind(_this);
	        _this.onKeyDown = _this.onKeyDown.bind(_this);
	        _this.onKeyUp = _this.onKeyUp.bind(_this);
	        _this.updateTabbableElements = _this.updateTabbableElements.bind(_this);
	        _this.setElementInterval = _this.setElementInterval.bind(_this);
	        return _this;
	    }
	
	    _createClass(Resources, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            window.addEventListener("keydown", this.onKeyDown);
	            window.addEventListener("keyup", this.onKeyUp);
	            this.updateTabbableElements();
	            this.setCallbacks();
	            this.setResourcesAnimation();
	            this.setElementInterval();
	        }
	    }, {
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(nextProps) {
	            if (this.state.lang !== nextProps.lang) {
	                this.setState({
	                    lang: nextProps.lang,
	
	                    back_label: appHelper.getLocaleString("back_label"),
	                    next_label: appHelper.getLocaleString("next_label")
	                });
	            }
	        }
	    }, {
	        key: 'componentDidUpdate',
	        value: function componentDidUpdate() {
	            this.setResourcesAnimation();
	            if (typeof this.state.resources_screen_type.component === 'undefined') {
	                this.getResources();
	            }
	            if (this.state.doSetTabbableElements) {
	                this.setTabbableElements();
	            }
	
	            if (this.state.doSetIntitialFocus && !this.state.initalFocusSet) {
	                this.setInitialFocus();
	            }
	
	            //this.setTabbableElements();
	        }
	    }, {
	        key: 'componentWillUnmount',
	        value: function componentWillUnmount() {
	            window.removeEventListener("keyup", this.onKeyUp);
	            clearInterval(this.state.elementInterval);
	        }
	    }, {
	        key: 'setElementInterval',
	        value: function setElementInterval() {
	            var interval = setInterval(this.setTabbableElements, 2000);
	            this.setState({ elementInterval: interval });
	        }
	    }, {
	        key: 'getPreviousBtnClass',
	        value: function getPreviousBtnClass() {
	            var resource = appHelper.getPreviousResource(this.state.activeResource);
	            return !appHelper.isDefined(resource.screen_id) ? "disabled" : "";
	        }
	    }, {
	        key: 'getNextBtnClass',
	        value: function getNextBtnClass() {
	            var resource = appHelper.getNextResource(this.state.activeResource);
	            return !appHelper.isDefined(resource.screen_id) ? "disabled" : "";
	        }
	    }, {
	        key: 'getPreviousResource',
	        value: function getPreviousResource() {
	            var resource = appHelper.getPreviousResource(this.state.activeResource);
	            if (appHelper.isDefined(resource.screen_id)) {
	                this.setActiveResource(resource);
	            }
	        }
	    }, {
	        key: 'getNextResource',
	        value: function getNextResource() {
	            var resource = appHelper.getNextResource(this.state.activeResource);
	            if (appHelper.isDefined(resource.screen_id)) {
	                this.setActiveResource(resource);
	            }
	        }
	    }, {
	        key: 'setCallbacks',
	        value: function setCallbacks() {
	            this.setState({
	                callbacks: Object.assign({}, this.state.callbacks, {
	                    showHeader: this.showHeader,
	                    getBiteId: this.getBiteId,
	                    setToolTip: this.setToolTip
	                })
	            });
	        }
	    }, {
	        key: 'showHeader',
	        value: function showHeader() {}
	    }, {
	        key: 'getBiteId',
	        value: function getBiteId() {
	            return appHelper.getBiteByScreenId(this.props.trackingData.lesson_location);
	        }
	    }, {
	        key: 'setToolTip',
	        value: function setToolTip() {}
	    }, {
	        key: 'getResources',
	        value: function getResources() {
	            //let resources = appHelper.getResources();
	            this.getResourcesScreenType();
	        }
	    }, {
	        key: 'getResourcesScreenType',
	        value: function getResourcesScreenType() {
	            var screenType = Object.assign({}, (0, _componentHelper.getScreenComponentByType)(this.state.activeResource.screen_type));
	            this.setState({
	                resources_screen_type: Object.assign({}, screenType)
	            });
	        }
	    }, {
	        key: 'setResourcesAnimation',
	        value: function setResourcesAnimation() {
	            switch (this.props.displayResources) {
	                case actionTypes.STATUS_OPENING:
	                    this.showResources();
	                    break;
	                case actionTypes.STATUS_CLOSING:
	                    this.hideResources();
	                    break;
	                default:
	                    break;
	            }
	        }
	    }, {
	        key: 'setResourcesStatus',
	        value: function setResourcesStatus() {
	            var resourceProps = Object.assign({}, _appModels.RESOURCE_PROPS, {
	                activeResourcesId: 0,
	                sourceId: ""
	            });
	
	            switch (this.props.displayResources) {
	                case actionTypes.STATUS_OPENING:
	                    this.props.actions.setResourcesDisplay(actionTypes.STATUS_OPEN);
	                    this.setState({ doSetTabbableElements: true });
	                    break;
	                case actionTypes.STATUS_CLOSING:
	                    this.props.actions.setResourcesDisplay(actionTypes.STATUS_CLOSED);
	                    this.props.actions.setResourcesProps(resourceProps);
	                    break;
	                default:
	                    break;
	            }
	        }
	    }, {
	        key: 'showResources',
	        value: function showResources() {
	            var resourcesPanel = this.refs['resources'];
	            //TweenLite.set(mainMenuPanel, {height: "auto", opacity: 1});
	            _gsap.TweenLite.to(resourcesPanel, objectConstants.DIALOG_DURATION, {
	                opacity: 1,
	                delay: 0,
	                ease: _gsap.Expo.easeInOut
	            }).eventCallback("onComplete", this.setResourcesStatus);
	        }
	    }, {
	        key: 'hideResources',
	        value: function hideResources() {
	            this.getClass();
	            var resourcesPanel = this.refs['resources'];
	            //TweenLite.set(mainMenuPanel, {height: 0, opacity: 0});
	            _gsap.TweenLite.to(resourcesPanel, objectConstants.DIALOG_DURATION, {
	
	                opacity: 0,
	                ease: _gsap.Expo.easeInOut
	            }).eventCallback("onComplete", this.setResourcesStatus);
	        }
	    }, {
	        key: 'closeResources',
	        value: function closeResources() {
	            if (appHelper.isDefined(this.props.sourceId) && this.props.sourceId.length > 0) {
	                var focusEl = document.getElementById(this.props.sourceId);
	                if (appHelper.isDefined(focusEl)) {
	                    focusEl.focus();
	                } else {
	                    document.getElementById("resourcesBtn").focus();
	                }
	            } else {
	                document.getElementById("resourcesBtn").focus();
	            }
	            this.props.actions.setResourcesDisplay(actionTypes.STATUS_CLOSING);
	        }
	    }, {
	        key: 'getClass',
	        value: function getClass() {
	            if (this.props.displayResources === actionTypes.STATUS_OPEN) {
	                return "dialog-open";
	            } else {
	                return "dialog-closed";
	            }
	        }
	    }, {
	        key: 'setActiveResource',
	        value: function setActiveResource(resource) {
	            this.setState({
	                activeResource: Object.assign({}, resource),
	                resources_screen_type: Object.assign({}, {})
	
	            });
	            //let setTabbableElements = this.setTabbableElements;
	        }
	    }, {
	        key: 'setAccessibleExit',
	        value: function setAccessibleExit(event) {
	            if (event.which === keyboardConstants.ESCAPE_KEY) {
	                event.preventDefault();
	                this.closeResources();
	            }
	        }
	    }, {
	        key: 'keyboardGetPreviousResource',
	        value: function keyboardGetPreviousResource(event) {
	            if (event.which === keyboardConstants.ENTER_KEY || event.which === keyboardConstants.SPACEBAR_KEY) {
	                event.preventDefault();
	                this.getPreviousResource();
	            }
	        }
	    }, {
	        key: 'keyboardGetNextResource',
	        value: function keyboardGetNextResource(event) {
	            if (event.which === keyboardConstants.ENTER_KEY || event.which === keyboardConstants.SPACEBAR_KEY) {
	                event.preventDefault();
	                this.getNextResource();
	            }
	        }
	    }, {
	        key: 'setTabbableElements',
	        value: function setTabbableElements() {
	            //console.log(`setTabbableElements`);
	            var dialog = this.refs['resources'];
	            var tabbableElements = dataHelper.getAllTabbableElements(dialog);
	            this.setState({
	                doSetTabbableElements: false,
	                tabbableElements: Object.assign([], tabbableElements),
	                doSetIntitialFocus: !this.state.initalFocusSet
	            });
	        }
	    }, {
	        key: 'setInitialFocus',
	        value: function setInitialFocus() {
	            var focusTarget = this.state.tabbableElements[1];
	            this.setState({ initalFocusSet: true });
	            setTimeout(function () {
	                focusTarget.focus();
	            }, 1000);
	        }
	    }, {
	        key: 'updateTabbableElements',
	        value: function updateTabbableElements() {
	            this.setTabbableElements();
	        }
	    }, {
	        key: 'onKeyDown',
	        value: function onKeyDown(event) {
	            var shiftPressed = this.state.shiftPressed;
	            var tabPressed = this.state.tabPressed;
	            if (event.which === keyboardConstants.ESCAPE_KEY) {
	
	                event.preventDefault();
	                this.closeResources();
	            }
	
	            if (event.which === keyboardConstants.TAB_KEY) {
	                tabPressed = true;
	                this.setState({
	                    tabPressed: tabPressed
	                });
	            }
	
	            if (event.which === keyboardConstants.SHIFT_KEY) {
	                shiftPressed = true;
	                this.setState({
	                    shiftPressed: shiftPressed
	                });
	            }
	        }
	    }, {
	        key: 'onKeyUp',
	        value: function onKeyUp(event) {
	            var activeItem = document.activeElement;
	            var activeItemId = activeItem.id;
	
	            if (this.state.tabbableElements.length > 0) {
	                if (activeItemId === this.state.tabbableElements[0].id) {
	                    //go to last
	                    this.state.tabbableElements[this.state.tabbableElements.length - 2].focus();
	                } else if (activeItemId === this.state.tabbableElements[this.state.tabbableElements.length - 1].id) {
	                    this.state.tabbableElements[1].focus();
	                }
	            }
	            this.setState({
	                tabPressed: false,
	                shiftPressed: false
	            });
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var Component = this.state.resources_screen_type.resourcesComponent;
	            return _react2.default.createElement(
	                'div',
	                { className: 'dialog-page resources ' + this.getClass(), ref: 'resources', role: 'dialog',
	                    'aria-modal': this.state.isDialog, 'aria-labelledby': 'resources' },
	                _react2.default.createElement('div', { id: 'firstTabIndex_resources_' + this.state.guid, tabIndex: '0', role: 'button' }),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'content-dialog resources' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'dialog-header guroo-dialog-header' },
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'resources-header-layout' },
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'flex-item flex-3' },
	                                _react2.default.createElement(_ResourcesMenu2.default, { menuData: this.state.resources,
	                                    currentSelection: this.state.activeResource,
	                                    onMenuSelect: this.setActiveResource,
	                                    idKey: 'screen_id',
	                                    labelKey: 'label' })
	                            ),
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'flex-item flex-1 text-right' },
	                                _react2.default.createElement(
	                                    'ul',
	                                    { className: 'resources-nav' },
	                                    _react2.default.createElement(
	                                        'li',
	                                        { className: 'resources-nav-item ' + this.getPreviousBtnClass(),
	                                            role: 'presentation' },
	                                        _react2.default.createElement(
	                                            'div',
	                                            { className: 'resources-back-btn', role: 'link', tabIndex: '0',
	                                                onClick: this.getPreviousResource,
	                                                onKeyDown: this.keyboardGetPreviousResource,
	                                                'aria-disabled': appHelper.isDefined(appHelper.getPreviousResource(this.state.activeResource)) },
	                                            this.state.back_label
	                                        )
	                                    ),
	                                    _react2.default.createElement(
	                                        'li',
	                                        { className: 'resources-nav-item ' + this.getNextBtnClass(), role: 'presentation' },
	                                        _react2.default.createElement(
	                                            'div',
	                                            { className: 'resources-next-btn', role: 'link', tabIndex: '0',
	                                                onClick: this.getNextResource, onKeyDown: this.keyboardGetNextResource,
	                                                'aria-disabled': appHelper.isDefined(appHelper.getNextResource(this.state.activeResource)) },
	                                            this.state.next_label
	                                        )
	                                    )
	                                )
	                            )
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'dialog-body', ref: 'resources_feed' },
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'resources-content' },
	                            appHelper.isDefined(Component) ? _react2.default.createElement(Component, { screen: this.state.activeResource, biteCallbacks: this.state.callbacks }) : null
	                        )
	                    )
	                ),
	                _react2.default.createElement('div', { id: 'lastTabIndex_resources_' + this.state.guid, tabIndex: '0', role: 'button' })
	            );
	        }
	    }]);
	
	    return Resources;
	}(_react2.default.Component);
	
	Resources.propTypes = {
	    children: _react2.default.PropTypes.node,
	    displayResources: _propTypes2.default.string.isRequired,
	    activeResourcesId: _propTypes2.default.number,
	    sourceId: _propTypes2.default.string,
	    trackingData: _propTypes2.default.object.isRequired,
	    lang: _propTypes2.default.string.isRequired,
	    actions: _propTypes2.default.object.isRequired
	};
	
	function mapStateToProps(state, ownProps) {
	    var lang = state.userData.lang;
	    return {
	        lang: lang,
	        displayResources: state.displayResources,
	        activeResourcesId: state.resourceProps.activeResourcesId,
	        sourceId: state.resourceProps.sourceId,
	        trackingData: state.trackingData
	    };
	}
	
	function mapDispatchToProps(dispatch) {
	    return {
	        actions: (0, _redux.bindActionCreators)(Object.assign({}, resourcesActions, trackingDataActions), dispatch)
	    };
	}
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(Resources);

/***/ },
/* 458 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRouter = __webpack_require__(45);
	
	var _reactRedux = __webpack_require__(5);
	
	var _redux = __webpack_require__(4);
	
	var _appDataActions = __webpack_require__(12);
	
	var appDataActions = _interopRequireWildcard(_appDataActions);
	
	var _trackingDataActions = __webpack_require__(7);
	
	var trackingDataActions = _interopRequireWildcard(_trackingDataActions);
	
	var _appHelper = __webpack_require__(3);
	
	var appHelper = _interopRequireWildcard(_appHelper);
	
	var _componentHelper = __webpack_require__(31);
	
	var _resourcesActions = __webpack_require__(150);
	
	var resourcesActions = _interopRequireWildcard(_resourcesActions);
	
	var _actionTypes = __webpack_require__(22);
	
	var actionTypes = _interopRequireWildcard(_actionTypes);
	
	var _localStorage = __webpack_require__(17);
	
	var localeStorage = _interopRequireWildcard(_localStorage);
	
	var _keyboardConstants = __webpack_require__(14);
	
	var keyboardConstants = _interopRequireWildcard(_keyboardConstants);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ResourcesButton = function (_React$Component) {
	    _inherits(ResourcesButton, _React$Component);
	
	    function ResourcesButton(props, context) {
	        _classCallCheck(this, ResourcesButton);
	
	        var _this = _possibleConstructorReturn(this, (ResourcesButton.__proto__ || Object.getPrototypeOf(ResourcesButton)).call(this, props, context));
	
	        _this.state = {
	            ariaHasPopup: true,
	            lang: _this.props.lang,
	            label: appHelper.getLocaleString("resources_label")
	        };
	        _this.setResourcesStatus = _this.setResourcesStatus.bind(_this);
	        _this.setBtnClass = _this.setBtnClass.bind(_this);
	        _this.setIconClass = _this.setIconClass.bind(_this);
	        _this.setKeyboardAccessibility = _this.setKeyboardAccessibility.bind(_this);
	
	        return _this;
	    }
	
	    _createClass(ResourcesButton, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {}
	    }, {
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(nextProps) {
	            if (this.state.lang !== nextProps.lang) {
	                this.setState({
	                    lang: nextProps.lang,
	                    label: appHelper.getLocaleString("resources_label")
	                });
	            }
	        }
	    }, {
	        key: 'setResourcesStatus',
	        value: function setResourcesStatus() {
	            if (!this.props.disabled || this.props.displayResources === actionTypes.STATUS_OPEN) {
	                switch (this.props.displayResources) {
	                    case actionTypes.STATUS_CLOSED:
	                        this.props.actions.setResourcesDisplay(actionTypes.STATUS_OPENING);
	                        break;
	                    case actionTypes.STATUS_OPEN:
	                        this.props.actions.setResourcesDisplay(actionTypes.STATUS_CLOSING);
	                        break;
	                    default:
	                        break;
	                }
	            }
	        }
	    }, {
	        key: 'setBtnClass',
	        value: function setBtnClass() {
	            return this.props.disabled && this.props.displayResources !== actionTypes.STATUS_OPEN ? "disabled" : "";
	        }
	    }, {
	        key: 'setIconClass',
	        value: function setIconClass() {
	            if (this.props.displayResources === actionTypes.STATUS_OPEN) {
	                return "icons8-multiply";
	            } else {
	                return "icons8-toolbox-filled";
	            }
	        }
	    }, {
	        key: 'setKeyboardAccessibility',
	        value: function setKeyboardAccessibility(event) {
	            if (event.which === keyboardConstants.ENTER_KEY || event.which === keyboardConstants.SPACEBAR_KEY) {
	                event.preventDefault();
	                this.setResourcesStatus();
	            }
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            return _react2.default.createElement(
	                'div',
	                { className: 'header-btn ' + this.setBtnClass(), onClick: this.setResourcesStatus, onKeyDown: this.setKeyboardAccessibility, role: 'link', tabIndex: '0', 'aria-controls': 'resources', id: 'resourcesBtn', title: appHelper.getLocaleString("resources_label"), 'aria-haspopup': this.state.ariaHasPopup },
	                _react2.default.createElement('div', { className: 'icon ' + this.setIconClass() + ' ' }),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'btn-label' },
	                    this.state.label
	                )
	            );
	        }
	    }]);
	
	    return ResourcesButton;
	}(_react2.default.Component);
	
	ResourcesButton.propTypes = {
	    disabled: _propTypes2.default.bool.isRequired,
	    displayResources: _propTypes2.default.string.isRequired,
	    lang: _propTypes2.default.string.isRequired,
	    actions: _propTypes2.default.object.isRequired
	};
	
	ResourcesButton.contextTypes = {
	    router: _propTypes2.default.object
	};
	
	function mapStateToProps(state, ownProps) {
	    var lang = state.userData.lang;
	    return {
	        displayResources: state.displayResources,
	        lang: lang
	    };
	}
	
	function mapDispatchToProps(dispatch) {
	    return {
	        actions: (0, _redux.bindActionCreators)(Object.assign({}, trackingDataActions, appDataActions, resourcesActions), dispatch)
	    };
	}
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(ResourcesButton);

/***/ },
/* 459 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.ResourcesMenu = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(5);
	
	var _redux = __webpack_require__(4);
	
	var _initActions = __webpack_require__(64);
	
	var initActions = _interopRequireWildcard(_initActions);
	
	var _appHelper = __webpack_require__(3);
	
	var appHelper = _interopRequireWildcard(_appHelper);
	
	var _userDataHelper = __webpack_require__(15);
	
	var userDataHelper = _interopRequireWildcard(_userDataHelper);
	
	var _objectConstants = __webpack_require__(9);
	
	var objectConstants = _interopRequireWildcard(_objectConstants);
	
	var _keyboardConstants = __webpack_require__(14);
	
	var keyboardConstants = _interopRequireWildcard(_keyboardConstants);
	
	var _ResourcesMenuOption = __webpack_require__(460);
	
	var _ResourcesMenuOption2 = _interopRequireDefault(_ResourcesMenuOption);
	
	var _gsap = __webpack_require__(8);
	
	var _gsapReactPlugin = __webpack_require__(10);
	
	var _gsapReactPlugin2 = _interopRequireDefault(_gsapReactPlugin);
	
	var _reactDom = __webpack_require__(55);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ResourcesMenu = exports.ResourcesMenu = function (_React$Component) {
	    _inherits(ResourcesMenu, _React$Component);
	
	    function ResourcesMenu(props, context) {
	        _classCallCheck(this, ResourcesMenu);
	
	        var _this = _possibleConstructorReturn(this, (ResourcesMenu.__proto__ || Object.getPrototypeOf(ResourcesMenu)).call(this, props, context));
	
	        _this.state = {
	            lang: _this.props.lang,
	            menuData: _this.props.menuData,
	            userData: _this.props.userData,
	            currentSelection: _this.props.currentSelection,
	            canClickMenu: true,
	            isOpen: false,
	            allowStateUpdates: true,
	            currentFocus: _this.props.menuData[0]
	        };
	
	        _this.onSelect = _this.onSelect.bind(_this);
	        _this.checkIsActive = _this.checkIsActive.bind(_this);
	        _this.handleMenu = _this.handleMenu.bind(_this);
	        _this.showMenu = _this.showMenu.bind(_this);
	        _this.hideMenu = _this.hideMenu.bind(_this);
	        _this.onMenuHandledComplete = _this.onMenuHandledComplete.bind(_this);
	        _this.onMenuOpenComplete = _this.onMenuOpenComplete.bind(_this);
	        _this.onMenuCloseComplete = _this.onMenuCloseComplete.bind(_this);
	        _this.getLocale = _this.getLocale.bind(_this);
	        _this.setClass = _this.setClass.bind(_this);
	        _this.setOptionItemClass = _this.setOptionItemClass.bind(_this);
	        _this.getPreviousOption = _this.getPreviousOption.bind(_this);
	        _this.getNextOption = _this.getNextOption.bind(_this);
	        _this.setKeyboardAccessibility = _this.setKeyboardAccessibility.bind(_this);
	        _this.setKeyboardNavigationControls = _this.setKeyboardNavigationControls.bind(_this);
	        return _this;
	    }
	
	    _createClass(ResourcesMenu, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {}
	    }, {
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(nextProps) {
	            this.setState({ currentSelection: Object.assign({}, nextProps.currentSelection) });
	
	            if (this.state.userData !== nextProps.userData) {
	                this.setState({ userData: Object.assign({}, nextProps.userData) });
	            }
	        }
	    }, {
	        key: 'checkIsActive',
	        value: function checkIsActive(id) {
	            if (id === this.state.currentFocus[this.props.idKey]) {
	                return 'active';
	            } else {
	                return "";
	            }
	        }
	    }, {
	        key: 'onSelect',
	        value: function onSelect(data) {
	            this.props.onMenuSelect(data);
	            this.hideMenu();
	        }
	    }, {
	        key: 'handleMenu',
	        value: function handleMenu(event) {
	            event.stopPropagation();
	            if (this.state.canClickMenu) {
	                if (this.state.menuIsOpen) {
	                    this.hideMenu();
	                } else {
	                    this.showMenu();
	                }
	            }
	        }
	    }, {
	        key: 'hideMenu',
	        value: function hideMenu() {
	            if (this.state.menuIsOpen) {
	                var rotator = this.refs.rotator;
	                _gsap.TweenLite.to(rotator, objectConstants.DROPDOWN_MENU_CLOSE_DURATION, {
	                    rotation: '+=' + 180 + 'deg',
	                    ease: _gsap.Expo.easeInOut
	                }).eventCallback("onComplete", this.onMenuHandledComplete);
	            }
	            this.setState({ menuIsOpen: false, canClickMenu: false });
	            var mainMenu = this.refs.menu;
	            _gsap.TweenLite.to(mainMenu, objectConstants.DROPDOWN_MENU_CLOSE_DURATION, {
	                height: 0,
	                ease: _gsap.Expo.easeInOut
	            }).eventCallback("onComplete", this.onMenuCloseComplete);
	        }
	    }, {
	        key: 'showMenu',
	        value: function showMenu() {
	            this.setState({ menuIsOpen: true, canClickMenu: false });
	            var mainMenu = this.refs.menu;
	            var rotator = this.refs.rotator;
	            _gsap.TweenLite.to(rotator, objectConstants.DROPDOWN_MENU_OPEN_DURATION, {
	                rotation: '+=' + 180 + 'deg',
	                ease: _gsap.Expo.easeInOut
	            }).eventCallback("onComplete", this.onMenuHandledComplete);
	            _gsap.TweenLite.set(mainMenu, { height: "auto" });
	            _gsap.TweenLite.from(mainMenu, objectConstants.DROPDOWN_MENU_OPEN_DURATION, {
	                height: 0,
	                ease: _gsap.Expo.easeInOut
	            }).eventCallback("onComplete", this.onMenuOpenComplete);
	        }
	    }, {
	        key: 'onMenuHandledComplete',
	        value: function onMenuHandledComplete() {
	            if (this.state.allowStateUpdates) {
	                this.setState({ canClickMenu: true });
	            }
	        }
	    }, {
	        key: 'onMenuOpenComplete',
	        value: function onMenuOpenComplete() {
	            var menuList = this.refs['menuList'];
	            //console.log(menuList);
	            menuList.focus();
	            //this.setState({currentFocus: this.state.menuData[0]});
	        }
	    }, {
	        key: 'onMenuCloseComplete',
	        value: function onMenuCloseComplete() {}
	    }, {
	        key: 'getLocale',
	        value: function getLocale(obj) {
	            return appHelper.isDefined(obj) ? appHelper.getLocalData(obj) : {};
	        }
	    }, {
	        key: 'setClass',
	        value: function setClass() {
	            var className = "";
	            var userDataObject = userDataHelper.getResourceScreenUserData(this.state.userData, this.state.currentSelection.screen_id);
	            if (appHelper.isDefined(userDataObject)) {
	                if (userDataObject.status === objectConstants.STATUS_NOT_STARTED) {
	                    className += objectConstants.CLASS_NOT_STARTED + ' ';
	                } else if (userDataObject.status === objectConstants.STATUS_IN_PROGRESS) {
	                    className += objectConstants.CLASS_IN_PROGRESS + ' ';
	                } else if (userDataObject.status === objectConstants.STATUS_COMPLETE) {
	                    className += objectConstants.CLASS_COMPLETE + ' ';
	                }
	            }
	
	            return className;
	        }
	    }, {
	        key: 'setOptionItemClass',
	        value: function setOptionItemClass(nav) {
	            return nav.parent_screen_id === null ? "option-item" : "option-item child";
	        }
	    }, {
	        key: 'setKeyboardAccessibility',
	        value: function setKeyboardAccessibility(event) {
	
	            if (event.which === keyboardConstants.ENTER_KEY || event.which === keyboardConstants.SPACEBAR_KEY) {
	                event.stopPropagation();
	                event.preventDefault();
	                if (this.state.canClickMenu) {
	                    if (this.state.menuIsOpen) {
	                        this.hideMenu();
	                    } else {
	                        this.showMenu();
	                    }
	                }
	            }
	        }
	    }, {
	        key: 'getPreviousOption',
	        value: function getPreviousOption() {
	            var currentFocusIndex = appHelper.getArrayObjectIndexByKey(this.state.menuData, "screen_id", this.state.currentFocus.screen_id);
	            var prevIndex = currentFocusIndex - 1;
	
	            if (prevIndex < 0) {
	                prevIndex = this.state.menuData.length - 1;
	            }
	
	            var nextFocus = this.state.menuData[prevIndex];
	
	            this.setState({ currentFocus: Object.assign({}, nextFocus) });
	        }
	    }, {
	        key: 'getNextOption',
	        value: function getNextOption() {
	            var currentFocusIndex = appHelper.getArrayObjectIndexByKey(this.state.menuData, "screen_id", this.state.currentFocus.screen_id);
	
	            var nextIndex = currentFocusIndex + 1;
	
	            if (nextIndex === this.state.menuData.length) {
	                nextIndex = 0;
	            }
	
	            var nextFocus = this.state.menuData[nextIndex];
	
	            this.setState({ currentFocus: Object.assign({}, nextFocus) });
	        }
	    }, {
	        key: 'setKeyboardNavigationControls',
	        value: function setKeyboardNavigationControls(event) {
	            event.stopPropagation();
	            if (event.which === keyboardConstants.ARROW_DOWN_KEY) {
	                event.stopPropagation();
	                event.preventDefault();
	                this.getNextOption();
	            }
	            if (event.which === keyboardConstants.ARROW_UP_KEY) {
	                event.stopPropagation();
	                event.preventDefault();
	                this.getPreviousOption();
	            }
	
	            if (event.which === keyboardConstants.ENTER_KEY || event.which === keyboardConstants.SPACEBAR_KEY) {
	                event.preventDefault();
	                this.props.onMenuSelect(this.state.currentFocus);
	                this.hideMenu();
	                var referenceMenuBtn = this.refs['resourceMenuBtn'];
	                referenceMenuBtn.focus();
	            }
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this2 = this;
	
	            return _react2.default.createElement(
	                'div',
	                { className: 'selection-menu resources' },
	                _react2.default.createElement(
	                    'div',
	                    { onClick: this.handleMenu, onKeyDown: this.setKeyboardAccessibility, role: 'button', id: 'resourceMenuBtn', ref: 'resourceMenuBtn', tabIndex: '0', 'aria-haspopup': 'true', className: 'selection-menu-btn' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'selected-title ' + this.setClass(),
	                            id: 'menuCurrentSelection' },
	                        ' ',
	                        this.getLocale(this.state.currentSelection).title
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'menu-icon' },
	                        _react2.default.createElement('div', { ref: 'rotator', className: 'rotating-icon icons8-circled-arrow-down-filled' })
	                    )
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { ref: 'menu', className: 'menu-option-container' },
	                    _react2.default.createElement(
	                        'ul',
	                        { className: 'menu-option-list', role: 'listbox', id: 'menuList',
	                            onKeyDown: this.setKeyboardNavigationControls, ref: 'menuList',
	                            'aria-labelledby': 'menuCurrentSelection', tabIndex: this.state.menuIsOpen ? 0 : -1 },
	                        this.state.menuData.map(function (nav) {
	                            return _react2.default.createElement(
	                                'li',
	                                { className: '' + _this2.setOptionItemClass(nav), key: nav[_this2.props.idKey] },
	                                _react2.default.createElement(_ResourcesMenuOption2.default, { onSelectFunc: _this2.onSelect,
	                                    params: nav,
	                                    label: '' + _this2.getLocale(nav).title,
	                                    activeClass: _this2.checkIsActive(nav[_this2.props.idKey]),
	                                    activeScreenId: _this2.state.currentSelection.screen_id,
	                                    isOpen: _this2.state.isOpen,
	                                    currentFocus: _this2.state.currentFocus
	                                })
	                            );
	                        })
	                    )
	                )
	            );
	        }
	    }]);
	
	    return ResourcesMenu;
	}(_react2.default.Component);
	
	ResourcesMenu.propTypes = {
	    menuData: _propTypes2.default.array,
	    currentSelection: _propTypes2.default.object,
	    onMenuSelect: _propTypes2.default.func,
	    idKey: _propTypes2.default.string,
	    labelKey: _propTypes2.default.string,
	    userData: _propTypes2.default.object,
	    contentData: _propTypes2.default.object,
	    lang: _propTypes2.default.string.isRequired,
	    actions: _propTypes2.default.object
	};
	
	//Pull in the React Router context so router is available on this.context.router.
	ResourcesMenu.contextTypes = {
	    router: _propTypes2.default.object
	};
	
	//Init
	function mapStateToProps(state, ownProps) {
	    var lang = state.userData.lang;
	    return {
	        contentData: state.contentData,
	        userData: state.userData,
	        lang: lang
	    };
	}
	
	function mapDispatchToProps(dispatch) {
	    return {
	        actions: (0, _redux.bindActionCreators)(Object.assign({}, initActions), dispatch)
	    };
	}
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(ResourcesMenu);

/***/ },
/* 460 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(5);
	
	var _redux = __webpack_require__(4);
	
	var _trackingDataActions = __webpack_require__(7);
	
	var trackingDataActions = _interopRequireWildcard(_trackingDataActions);
	
	var _appHelper = __webpack_require__(3);
	
	var appHelper = _interopRequireWildcard(_appHelper);
	
	var _userDataHelper = __webpack_require__(15);
	
	var userDataHelper = _interopRequireWildcard(_userDataHelper);
	
	var _objectConstants = __webpack_require__(9);
	
	var objectConstants = _interopRequireWildcard(_objectConstants);
	
	var _keyboardConstants = __webpack_require__(14);
	
	var keyboardConstants = _interopRequireWildcard(_keyboardConstants);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ResourcesMenuOption = function (_React$Component) {
	    _inherits(ResourcesMenuOption, _React$Component);
	
	    function ResourcesMenuOption(props, context) {
	        _classCallCheck(this, ResourcesMenuOption);
	
	        var _this = _possibleConstructorReturn(this, (ResourcesMenuOption.__proto__ || Object.getPrototypeOf(ResourcesMenuOption)).call(this, props, context));
	
	        _this.state = {
	            userData: _this.props.userData,
	            isOpen: _this.props.isOpen,
	            currentFocus: _this.props.currentFocus
	        };
	        _this.setClass = _this.setClass.bind(_this);
	        _this.onSelect = _this.onSelect.bind(_this);
	        _this.setKeyboardAccessibility = _this.setKeyboardAccessibility.bind(_this);
	        return _this;
	    }
	
	    _createClass(ResourcesMenuOption, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {}
	    }, {
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(nextProps) {
	            if (this.state.userData !== nextProps.userData) {
	                this.setState({ userData: Object.assign({}, nextProps.userData) });
	            }
	            if (this.state.isOpen !== nextProps.isOpen) {
	                this.setState({ isOpen: nextProps.isOpen });
	            }
	            if (this.state.currentFocus !== nextProps.currentFocus) {
	                this.setState({ currentFocus: Object.assign({}, nextProps.currentFocus) });
	            }
	        }
	    }, {
	        key: 'componentDidUpdate',
	        value: function componentDidUpdate() {}
	    }, {
	        key: 'onSelect',
	        value: function onSelect() {
	            this.props.onSelectFunc(this.props.params);
	        }
	    }, {
	        key: 'setClass',
	        value: function setClass() {
	            var className = "";
	            var userDataObject = userDataHelper.getResourceScreenUserData(this.state.userData, this.props.params.screen_id);
	            if (appHelper.isDefined(userDataObject)) {
	                if (userDataObject.status === objectConstants.STATUS_NOT_STARTED) {
	                    className += objectConstants.CLASS_NOT_STARTED + ' ';
	                } else if (userDataObject.status === objectConstants.STATUS_IN_PROGRESS) {
	                    className += objectConstants.CLASS_IN_PROGRESS + ' ';
	                } else if (userDataObject.status === objectConstants.STATUS_COMPLETE) {
	                    className += objectConstants.CLASS_COMPLETE + ' ';
	                }
	            }
	
	            return className;
	        }
	    }, {
	        key: 'onClicked',
	        value: function onClicked() {
	            this.props.onClickFunc(this.state.screen);
	        }
	    }, {
	        key: 'setKeyboardAccessibility',
	        value: function setKeyboardAccessibility(event) {
	            if (event.which === keyboardConstants.ENTER_KEY || event.which === keyboardConstants.SPACEBAR_KEY) {
	                event.preventDefault();
	                this.onSelect();
	            }
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            return _react2.default.createElement('div', { className: 'option-label ' + this.setClass() + ' ' + this.props.activeClass,
	                onClick: this.onSelect, dangerouslySetInnerHTML: { __html: this.props.label }, onKeyDown: this.setKeyboardAccessibility, role: 'link', tabIndex: this.state.isOpen && this.props.params.screen_id === this.state.currentFocus.screen_id ? "0" : "-1" });
	        }
	    }]);
	
	    return ResourcesMenuOption;
	}(_react2.default.Component);
	
	ResourcesMenuOption.propTypes = {
	    onSelectFunc: _propTypes2.default.func,
	    params: _propTypes2.default.object.isRequired,
	    label: _propTypes2.default.string,
	    activeClass: _propTypes2.default.string,
	    activeScreenId: _propTypes2.default.number,
	    onClickFunc: _propTypes2.default.func,
	    isOpen: _propTypes2.default.bool,
	    currentFocus: _propTypes2.default.object,
	    userData: _propTypes2.default.object,
	    contentData: _propTypes2.default.object,
	    trackingData: _propTypes2.default.object,
	    actions: _propTypes2.default.object
	};
	
	ResourcesMenuOption.contextTypes = {
	    router: _propTypes2.default.object
	};
	
	function mapStateToProps(state, ownProps) {
	    return {
	        contentData: state.contentData,
	        userData: state.userData
	    };
	}
	
	function mapDispatchToProps(dispatch) {
	    return {
	        actions: (0, _redux.bindActionCreators)(Object.assign({}, trackingDataActions), dispatch)
	    };
	}
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(ResourcesMenuOption);

/***/ },
/* 461 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.ScreenDialog = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _gsap = __webpack_require__(8);
	
	var _gsapReactPlugin = __webpack_require__(10);
	
	var _gsapReactPlugin2 = _interopRequireDefault(_gsapReactPlugin);
	
	var _reactDom = __webpack_require__(55);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _reactRedux = __webpack_require__(5);
	
	var _redux = __webpack_require__(4);
	
	var _appDataActions = __webpack_require__(12);
	
	var appDataActions = _interopRequireWildcard(_appDataActions);
	
	var _dialogPopupActions = __webpack_require__(19);
	
	var dialogPopupActions = _interopRequireWildcard(_dialogPopupActions);
	
	var _appHelper = __webpack_require__(3);
	
	var appHelper = _interopRequireWildcard(_appHelper);
	
	var _userDataHelper = __webpack_require__(15);
	
	var userDataHelper = _interopRequireWildcard(_userDataHelper);
	
	var _dataHelper = __webpack_require__(11);
	
	var dataHelper = _interopRequireWildcard(_dataHelper);
	
	var _objectConstants = __webpack_require__(9);
	
	var objectConstants = _interopRequireWildcard(_objectConstants);
	
	var _keyboardConstants = __webpack_require__(14);
	
	var keyboardConstants = _interopRequireWildcard(_keyboardConstants);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	//import ReactCSSTransitionGroup from 'react-addons-css-transition-group';
	
	
	//import toastr from 'toastr';
	
	var ScreenDialog = exports.ScreenDialog = function (_React$Component) {
	    _inherits(ScreenDialog, _React$Component);
	
	    function ScreenDialog(props, context) {
	        _classCallCheck(this, ScreenDialog);
	
	        var _this = _possibleConstructorReturn(this, (ScreenDialog.__proto__ || Object.getPrototypeOf(ScreenDialog)).call(this, props, context));
	
	        _this.state = {
	            lang: _this.props.lang,
	            screenDialog: _this.props.screenDialog,
	            userData: _this.props.userData,
	            currentOpacity: 0,
	            currentTop: 0,
	            isOpenOpacity: 1,
	            isOpenTop: 0,
	            isClosedOpacity: 0,
	            isClosedTop: 0,
	            assetViewed: false,
	            config: _this.props.screenDialog.config,
	            //locale: appHelper.getLocalData(this.props.screenDialog.config.screen),
	            parentScreen: appHelper.getScreenData({
	                bite_id: _this.props.screenDialog.config.biteCallbacks.getBiteId(),
	                screen_id: _this.props.screenDialog.config.parentScreen.screen_id
	            }),
	            screen: appHelper.getSubScreen({
	                bite_id: _this.props.screenDialog.config.biteCallbacks.getBiteId(),
	                parent_screen_id: _this.props.screenDialog.config.parentScreen.screen_id,
	                screen_id: _this.props.screenDialog.config.screen.screen_id
	            }),
	            tabbableElements: [],
	            isOpen: false,
	            elementInterval: {},
	            guid: dataHelper.createGuid(),
	            label: appHelper.getLocaleString("done_label"),
	            close_label: appHelper.getLocaleString("close_label"),
	            locale: {}
	        };
	        _this.openDialog = _this.openDialog.bind(_this);
	        _this.isOpenFunc = _this.isOpenFunc.bind(_this);
	        _this.closeDialog = _this.closeDialog.bind(_this);
	        _this.isClosedFunc = _this.isClosedFunc.bind(_this);
	        _this.onAssetViewed = _this.onAssetViewed.bind(_this);
	        _this.getStatus = _this.getStatus.bind(_this);
	        _this.onKeyDown = _this.onKeyDown.bind(_this);
	        _this.onKeyUp = _this.onKeyUp.bind(_this);
	        _this.setTabbableElements = _this.setTabbableElements.bind(_this);
	        _this.setTabbedInterval = _this.setTabbedInterval.bind(_this);
	        //this.setKeyboardAccessibility = this.setKeyboardAccessibility.bind(this);
	        _this.setInitialFocus = _this.setInitialFocus.bind(_this);
	        _this.getLocale();
	        return _this;
	    }
	
	    _createClass(ScreenDialog, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            window.addEventListener("keydown", this.onKeyDown);
	            window.addEventListener("keyup", this.onKeyUp);
	            this.getLocale();
	            this.setTabbedInterval();
	
	            var func = this.openDialog;
	            setTimeout(function () {
	
	                func();
	            }, 200);
	        }
	    }, {
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(nextProps) {
	            if (this.state.userData !== nextProps.userData) {
	                this.setState({
	                    userData: Object.assign({}, nextProps.userData)
	                });
	            }
	            if (this.state.lang !== nextProps.lang) {
	                this.setState({
	                    lang: nextProps.lang,
	                    locale: appHelper.getLocalData(this.state.screen),
	                    label: appHelper.getLocaleString("done_label"),
	                    close_label: appHelper.getLocaleString("close_label")
	                });
	            }
	        }
	    }, {
	        key: 'componentDidUpdate',
	        value: function componentDidUpdate() {
	            /* if (!this.state.isOpen && this.state.screenDialog.isOpen) {
	                 this.setInitialFocus();
	             }*/
	        }
	    }, {
	        key: 'componentWillUnmount',
	        value: function componentWillUnmount() {
	            window.removeEventListener("keydown", this.onKeyDown);
	            window.removeEventListener("keyup", this.onKeyUp);
	            clearInterval(this.state.elementInterval);
	        }
	    }, {
	        key: 'getLocale',
	        value: function getLocale() {
	            this.setState({
	
	                locale: appHelper.getLocalData(this.state.screen)
	
	            });
	        }
	    }, {
	        key: 'setTabbedInterval',
	        value: function setTabbedInterval() {
	            var interval = setInterval(this.setTabbableElements, 2000);
	            this.setState({ elementInterval: interval });
	        }
	    }, {
	        key: 'openDialog',
	        value: function openDialog() {
	            if (appHelper.isDefined(this) && this !== null) {
	                _gsap.TweenLite.to(this, objectConstants.DIALOG_DURATION, {
	                    state: {
	                        currentOpacity: this.state.isOpenOpacity,
	                        currentTop: this.state.isOpenTop
	                    }
	                }).eventCallback("onComplete", this.isOpenFunc);
	            }
	        }
	    }, {
	        key: 'isOpenFunc',
	        value: function isOpenFunc() {
	            this.setState({ screenDialog: Object.assign({}, this.state.screenDialog, {
	                    isOpen: true,
	                    currentClassState: this.state.screenDialog.classStates.isOpen
	                }) });
	        }
	    }, {
	        key: 'closeDialog',
	        value: function closeDialog() {
	            var focusEl = document.getElementById(this.state.screenDialog.config.sourceId);
	
	            if (appHelper.isDefined(focusEl) && focusEl !== null) {
	                focusEl.focus();
	            }
	            this.setState({
	                screenDialog: Object.assign({}, this.state.screenDialog, {
	                    isOpen: false,
	                    currentClassState: this.state.screenDialog.classStates.isClosed
	                })
	            });
	            if (appHelper.isDefined(this) && this !== null) {
	                _gsap.TweenLite.to(this, objectConstants.DIALOG_DURATION, {
	                    state: {
	                        currentOpacity: this.state.isClosedOpacity,
	                        currentTop: this.state.isClosedTop
	                    }, delay: 0.5
	                }).eventCallback("onComplete", this.isClosedFunc);
	            }
	        }
	    }, {
	        key: 'isClosedFunc',
	        value: function isClosedFunc() {
	            this.props.actions.removeScreenDialog();
	            this.state.screenDialog.config.onClose(this.state.assetViewed);
	        }
	    }, {
	        key: 'onAssetViewed',
	        value: function onAssetViewed() {
	            this.setState({ assetViewed: true });
	        }
	    }, {
	        key: 'setAccessibleExit',
	        value: function setAccessibleExit(event) {
	            if (event.which === keyboardConstants.ESCAPE_KEY) {
	                event.preventDefault();
	                this.closeDialog();
	            }
	        }
	    }, {
	        key: 'getStatus',
	        value: function getStatus() {
	
	            var screenUserData = userDataHelper.getSubScreenUserData(this.state.userData, this.state.config.parentScreen.screen_id, this.state.screen.screen_id);
	            if (screenUserData.status === objectConstants.STATUS_NOT_STARTED) {
	                return "not-started";
	            } else if (screenUserData.status === objectConstants.STATUS_IN_PROGRESS) {
	                return "in-progress";
	            } else if (screenUserData.status === objectConstants.STATUS_COMPLETE) {
	                return "complete";
	            } else if (screenUserData.status === objectConstants.STATUS_NOT_REQUIRED) {
	                return "not-required";
	            }
	        }
	    }, {
	        key: 'onKeyDown',
	        value: function onKeyDown(event) {
	            var shiftPressed = this.state.shiftPressed;
	            var tabPressed = this.state.tabPressed;
	
	            if (event.which === keyboardConstants.ESCAPE_KEY) {
	                event.preventDefault();
	                this.closeDialog();
	            }
	
	            if (event.which === keyboardConstants.TAB_KEY) {
	
	                tabPressed = true;
	                this.setState({
	                    tabPressed: tabPressed
	                });
	            }
	
	            if (event.which === keyboardConstants.SHIFT_KEY) {
	                shiftPressed = true;
	                this.setState({
	                    shiftPressed: shiftPressed
	                });
	            }
	        }
	    }, {
	        key: 'onKeyUp',
	        value: function onKeyUp(event) {
	            var activeItem = document.activeElement;
	            var activeItemId = activeItem.id;
	            //console.log(activeItemId);
	            if (activeItemId === this.state.tabbableElements[0].id) {
	                //go to last
	                //console.log(this.state.tabbableElements[this.state.tabbableElements.length - 2]);
	                this.state.tabbableElements[this.state.tabbableElements.length - 2].focus();
	            } else if (activeItemId === this.state.tabbableElements[this.state.tabbableElements.length - 1].id) {
	                this.state.tabbableElements[1].focus();
	            }
	
	            this.setState({
	                tabPressed: false,
	                shiftPressed: false
	            });
	        }
	    }, {
	        key: 'setTabbableElements',
	        value: function setTabbableElements() {
	            var dialog = this.refs.screenDialog;
	            var tabbableElements = dataHelper.getAllTabbableElements(dialog);
	            this.setState({ tabbableElements: Object.assign([], dataHelper.getAllTabbableElements(dialog)) });
	            if (!this.state.isOpen && this.state.screenDialog.isOpen) {
	                this.setInitialFocus();
	            }
	        }
	    }, {
	        key: 'setInitialFocus',
	        value: function setInitialFocus() {
	            var initFocusEl = this.state.tabbableElements[1];
	            if (appHelper.isDefined(initFocusEl)) {
	                this.state.tabbableElements[1].focus();
	                this.setState({ isOpen: true });
	            }
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var config = this.state.screenDialog.config;
	            var Component = config.component;
	
	            return _react2.default.createElement(
	                'div',
	                { className: 'dialog-page ' + this.state.screenDialog.currentClassState, style: { opacity: this.state.currentOpacity }, ref: 'screenDialog', id: 'screenDialog', role: 'dialog' },
	                _react2.default.createElement('div', { id: 'firstTabIndex_screenDialog_' + this.state.guid, tabIndex: '0', role: 'button' }),
	                _react2.default.createElement(
	                    'div',
	                    { className: this.state.screenDialog.className + ' ' + this.state.screen.hotspot_layout_type },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'dialog-header', role: 'button', tabIndex: this.getStatus() === "complete" || this.getStatus() === "not-required" ? -1 : 0 },
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'title-col' },
	                            _react2.default.createElement('div', { className: 'title ' + this.getStatus(), dangerouslySetInnerHTML: { __html: this.state.locale.title } })
	                        ),
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'nav-col' },
	                            this.getStatus() === "complete" || this.getStatus() === "not-required" ? _react2.default.createElement(
	                                'button',
	                                { className: 'btn guroo-btn', onClick: this.closeDialog },
	                                this.state.label
	                            ) : _react2.default.createElement(
	                                'button',
	                                { className: 'btn guroo-btn', onClick: this.closeDialog },
	                                this.state.close_label
	                            )
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'dialog-body ' + this.state.screenDialog.config.screen.screen_type_code },
	                        _react2.default.createElement(Component, { screen: this.state.screen, parentScreen: this.state.parentScreen, biteCallbacks: config.biteCallbacks, closeDialog: this.closeDialog })
	                    )
	                ),
	                _react2.default.createElement('div', { id: 'lastTabIndex_screenDialog_' + this.state.guid, tabIndex: '0', role: 'button' })
	            );
	        }
	    }]);
	
	    return ScreenDialog;
	}(_react2.default.Component);
	
	ScreenDialog.propTypes = {
	    screenDialog: _propTypes2.default.object.isRequired,
	    userData: _propTypes2.default.object.isRequired,
	    lang: _propTypes2.default.string.isRequired,
	    actions: _propTypes2.default.object.isRequired
	};
	
	//Pull in the React Router context so router is available on this.context.router.
	ScreenDialog.contextTypes = {
	    router: _propTypes2.default.object
	};
	
	//Init
	function mapStateToProps(state, ownProps) {
	    var lang = state.userData.lang;
	    return {
	        screenDialog: state.screenDialog,
	        userData: state.userData,
	        lang: lang
	    };
	}
	
	function mapDispatchToProps(dispatch) {
	    return {
	        actions: (0, _redux.bindActionCreators)(Object.assign({}, appDataActions, dialogPopupActions), dispatch)
	    };
	}
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(ScreenDialog);

/***/ },
/* 462 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(5);
	
	var _redux = __webpack_require__(4);
	
	var _keyboardConstants = __webpack_require__(14);
	
	var keyboardConstants = _interopRequireWildcard(_keyboardConstants);
	
	var _trackingDataActions = __webpack_require__(7);
	
	var trackingDataActions = _interopRequireWildcard(_trackingDataActions);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	//eslint-disable-line import/no-named-as-default
	
	var SelectMenuOption = function (_React$Component) {
		_inherits(SelectMenuOption, _React$Component);
	
		function SelectMenuOption(props, context) {
			_classCallCheck(this, SelectMenuOption);
	
			var _this = _possibleConstructorReturn(this, (SelectMenuOption.__proto__ || Object.getPrototypeOf(SelectMenuOption)).call(this, props, context));
	
			_this.state = {
				onSelectFunc: _this.props.onSelectFunc,
				params: _this.props.params,
				label: _this.props.label,
				activeClass: _this.props.activeClass,
				isOpen: _this.props.isOpen,
				currentFocus: _this.props.currentFocus
			};
	
			_this.onSelect = _this.onSelect.bind(_this);
			_this.setKeyboardAccessibility = _this.setKeyboardAccessibility.bind(_this);
			return _this;
		}
	
		_createClass(SelectMenuOption, [{
			key: 'componentWillReceiveProps',
			value: function componentWillReceiveProps(nextProps) {
				if (this.state.isOpen !== nextProps.isOpen) {
					this.setState({ isOpen: nextProps.isOpen });
				}
				if (this.state.currentFocus !== nextProps.currentFocus) {
					this.setState({ currentFocus: Object.assign({}, nextProps.currentFocus) });
				}
				if (this.state.activeClass !== nextProps.activeClass) {
					this.setState({ activeClass: Object.assign({}, nextProps.activeClass) });
				}
	
				if (this.state.params !== nextProps.params) {
					this.setState({ params: Object.assign({}, nextProps.params) });
				}
	
				if (this.state.label !== nextProps.label) {
					this.setState({ label: nextProps.label });
				}
			}
		}, {
			key: 'onSelect',
			value: function onSelect() {
				this.state.onSelectFunc(this.state.params);
			}
		}, {
			key: 'setKeyboardAccessibility',
			value: function setKeyboardAccessibility(event) {
				if (event.which === keyboardConstants.ENTER_KEY || event.which === keyboardConstants.SPACEBAR_KEY) {
					event.preventDefault();
					this.onSelect();
				}
			}
		}, {
			key: 'render',
			value: function render() {
				return _react2.default.createElement('div', { className: 'option-label ' + (this.props.params.constant === this.state.currentFocus.constant ? 'active' : ''), onClick: this.onSelect, onKeyDown: this.setKeyboardAccessibility, role: 'link', tabIndex: this.state.isOpen && this.props.params.constant === this.state.currentFocus.constant ? "0" : "-1", dangerouslySetInnerHTML: { __html: this.state.label } });
			}
		}]);
	
		return SelectMenuOption;
	}(_react2.default.Component);
	
	SelectMenuOption.propTypes = {
		onSelectFunc: _react.PropTypes.func,
		params: _react.PropTypes.object.isRequired,
		label: _react.PropTypes.string,
		activeClass: _react.PropTypes.string,
		isOpen: _react.PropTypes.bool,
		currentFocus: _react.PropTypes.object
	
	};
	
	SelectMenuOption.contextTypes = {
		router: _react.PropTypes.object
	};
	
	function mapStateToProps(state, ownProps) {
		return {
			contentData: state.contentData,
			userData: state.userData
		};
	}
	
	function mapDispatchToProps(dispatch) {
		return {
			actions: (0, _redux.bindActionCreators)(Object.assign({}, trackingDataActions), dispatch)
		};
	}
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(SelectMenuOption);

/***/ },
/* 463 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(5);
	
	var _redux = __webpack_require__(4);
	
	var _TextInput = __webpack_require__(195);
	
	var _TextInput2 = _interopRequireDefault(_TextInput);
	
	var _EmailInput = __webpack_require__(193);
	
	var _EmailInput2 = _interopRequireDefault(_EmailInput);
	
	var _initActions = __webpack_require__(64);
	
	var initActions = _interopRequireWildcard(_initActions);
	
	var _trackingDataActions = __webpack_require__(7);
	
	var trackingDataActions = _interopRequireWildcard(_trackingDataActions);
	
	var _dialogPopupActions = __webpack_require__(19);
	
	var dialogPopupActions = _interopRequireWildcard(_dialogPopupActions);
	
	var _appConstants = __webpack_require__(13);
	
	var appConstants = _interopRequireWildcard(_appConstants);
	
	var _formValidationHelper = __webpack_require__(152);
	
	var formValidationHelper = _interopRequireWildcard(_formValidationHelper);
	
	var _appHelper = __webpack_require__(3);
	
	var appHelper = _interopRequireWildcard(_appHelper);
	
	var _navigationHelper = __webpack_require__(153);
	
	var navHelper = _interopRequireWildcard(_navigationHelper);
	
	var _dataHelper = __webpack_require__(11);
	
	var dataHelper = _interopRequireWildcard(_dataHelper);
	
	var _keyboardConstants = __webpack_require__(14);
	
	var keyboardConstants = _interopRequireWildcard(_keyboardConstants);
	
	var _gsap = __webpack_require__(8);
	
	var _gsapReactPlugin = __webpack_require__(10);
	
	var _gsapReactPlugin2 = _interopRequireDefault(_gsapReactPlugin);
	
	var _localStorage = __webpack_require__(17);
	
	var localStorage = _interopRequireWildcard(_localStorage);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } //eslint-disable-line import/no-named-as-default
	//eslint-disable-line import/no-named-as-default
	
	
	var ActorPrompt = function (_React$Component) {
	    _inherits(ActorPrompt, _React$Component);
	
	    function ActorPrompt(props, context) {
	        _classCallCheck(this, ActorPrompt);
	
	        var _this = _possibleConstructorReturn(this, (ActorPrompt.__proto__ || Object.getPrototypeOf(ActorPrompt)).call(this, props, context));
	
	        _this.state = {
	            lang: _this.props.lang,
	            trackingData: _this.props.trackingData,
	            formParams: {
	                name: "",
	                email_address: ""
	            },
	            actor: {},
	            errors: {
	                name: "",
	                email_address: ""
	            },
	            checkFormCanBeSubmitted: false,
	            canSubmit: false,
	            processing: false,
	            checkActor: false,
	            actor_prompt_instruction: appHelper.getLocaleString("actor_prompt_instruction"),
	            name_label: appHelper.getLocaleString("name_label"),
	            email_address_label: appHelper.getLocaleString("email_address_label"),
	            please_wait_label: appHelper.getLocaleString("please_wait_label"),
	            continue_label: appHelper.getLocaleString("continue_label"),
	            continue_as_guest_label: appHelper.getLocaleString("continue_as_guest_label")
	        };
	        _this.updateFormState = _this.updateFormState.bind(_this);
	        _this.checkFormCanBeSubmitted = _this.checkFormCanBeSubmitted.bind(_this);
	        _this.validateForm = _this.validateForm.bind(_this);
	        _this.onContinue = _this.onContinue.bind(_this);
	        _this.checkActorDefined = _this.checkActorDefined.bind(_this);
	        _this.continueAsGuess = _this.continueAsGuess.bind(_this);
	        _this.setCookie = _this.setCookie.bind(_this);
	        _this.getCookie = _this.getCookie.bind(_this);
	        _this.setKeyboardAccessibility = _this.setKeyboardAccessibility.bind(_this);
	        return _this;
	    }
	
	    _createClass(ActorPrompt, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {}
	    }, {
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(nextProps) {
	            if (this.state.trackingData !== nextProps.trackingData) {
	                this.setState({
	                    trackingData: Object.assign({}, nextProps.trackingData),
	                    checkActor: true
	                });
	            }
	
	            if (this.state.lang !== nextProps.lang) {
	                this.setState({
	                    lang: nextProps.lang,
	                    actor_prompt_instruction: appHelper.getLocaleString("actor_prompt_instruction"),
	                    name_label: appHelper.getLocaleString("name_label"),
	                    email_address_label: appHelper.getLocaleString("email_address_label"),
	                    please_wait_label: appHelper.getLocaleString("please_wait_label"),
	                    continue_label: appHelper.getLocaleString("continue_label"),
	                    continue_as_guest_label: appHelper.getLocaleString("continue_as_guest_label")
	                });
	            }
	        }
	    }, {
	        key: 'componentDidUpdate',
	        value: function componentDidUpdate() {
	            if (this.state.checkFormCanBeSubmitted) {
	                this.checkFormCanBeSubmitted();
	            }
	
	            if (this.state.checkActor) {
	                this.checkActorDefined();
	            }
	        }
	    }, {
	        key: 'updateFormState',
	        value: function updateFormState(event) {
	            var field = event.target.name;
	            var formParams = this.state.formParams;
	            formParams[field] = event.target.value;
	            this.setState({
	                formParams: formParams,
	                checkFormCanBeSubmitted: true
	            });
	        }
	    }, {
	        key: 'checkFormCanBeSubmitted',
	        value: function checkFormCanBeSubmitted() {
	
	            this.setState({ checkFormCanBeSubmitted: false });
	            var canSubmit = true;
	
	            var nameValid = formValidationHelper.validateLength(this.state.formParams.name);
	            var emailValid = formValidationHelper.validateLength(this.state.formParams.email_address);
	
	            if (!nameValid.result) {
	                canSubmit = false;
	            }
	
	            if (!emailValid.result) {
	                canSubmit = false;
	            }
	
	            this.setState({ canSubmit: canSubmit });
	        }
	    }, {
	        key: 'validateForm',
	        value: function validateForm() {
	
	            this.setState({ checkFormCanBeSubmitted: false });
	            var formIsValid = true;
	            var errors = {};
	
	            var nameValid = formValidationHelper.validateLength(this.state.formParams.name);
	            var emailValid = formValidationHelper.validateEmail(this.state.formParams.email_address);
	
	            if (!nameValid.result) {
	                errors.name = 'Name ' + nameValid.message;
	                formIsValid = false;
	            }
	
	            if (!emailValid.result) {
	                errors.email_address = emailValid.message;
	                formIsValid = false;
	            }
	
	            this.setState({
	                errors: errors
	            });
	
	            return formIsValid;
	        }
	    }, {
	        key: 'onContinue',
	        value: function onContinue(event) {
	            event.preventDefault();
	
	            if (!this.validateForm()) {
	                return;
	            }
	
	            this.setState({ processing: true });
	
	            var actor = {
	                objectType: "Agent",
	                name: this.state.formParams.name,
	                mbox: 'mailto:' + this.state.formParams.email_address
	            };
	            // this.context.router.push(`/?actor=${encodeURI(JSON.stringify(actorObject))}`);
	            this.props.actions.setActorDetails(actor);
	        }
	    }, {
	        key: 'checkActorDefined',
	        value: function checkActorDefined() {
	            this.setState({ checkActor: false });
	            if (appHelper.isDefined(this.state.trackingData.actor)) {
	                this.props.actions.initTracking(this.props.contentData);
	            }
	        }
	    }, {
	        key: 'continueAsGuess',
	        value: function continueAsGuess() {
	            var cookieName = "actor";
	            var actor = {};
	            var actorCookie = this.getCookie(cookieName);
	            //let actorCookie = "";
	            var formParams = this.state.formParams;
	
	            formParams['name'] = 'Guest';
	
	            this.setState({
	                formParams: formParams,
	                processing: true
	            });
	
	            if (actorCookie === "") {
	                var d = new Date();
	                var n = d.getTime();
	                var email_address = String(n) + '@guest.com';
	                var name = 'Guest ' + String(n);
	
	                actor = {
	                    objectType: "Agent",
	                    name: name,
	                    mbox: 'mailto:' + email_address
	                };
	
	                this.setCookie(cookieName, JSON.stringify(actor), 2);
	
	                this.props.actions.setActorDetails(actor);
	            } else {
	                actor = JSON.parse(actorCookie);
	                this.props.actions.setActorDetails(actor);
	            }
	        }
	    }, {
	        key: 'setCookie',
	        value: function setCookie(cname, cvalue, exdays) {
	            var d = new Date();
	            d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);
	            var expires = "expires=" + d.toUTCString();
	            document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
	        }
	    }, {
	        key: 'getCookie',
	        value: function getCookie(cname) {
	            var name = cname + "=";
	            var decodedCookie = decodeURIComponent(document.cookie);
	            var ca = decodedCookie.split(';');
	            for (var i = 0; i < ca.length; i++) {
	                var c = ca[i];
	                while (c.charAt(0) == ' ') {
	                    c = c.substring(1);
	                }
	                if (c.indexOf(name) == 0) {
	                    return c.substring(name.length, c.length);
	                }
	            }
	            return "";
	        }
	    }, {
	        key: 'setKeyboardAccessibility',
	        value: function setKeyboardAccessibility(event) {
	            if (event.which === keyboardConstants.ENTER_KEY || event.which === keyboardConstants.SPACEBAR_KEY) {
	                event.preventDefault();
	                this.continueAsGuess();
	            }
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            return _react2.default.createElement(
	                'div',
	                { className: 'init-prompt-content' },
	                !this.state.processing ? _react2.default.createElement(
	                    'div',
	                    null,
	                    _react2.default.createElement('div', { dangerouslySetInnerHTML: { __html: this.state.actor_prompt_instruction } }),
	                    _react2.default.createElement(
	                        'form',
	                        null,
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'row' },
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'col-xs-12' },
	                                _react2.default.createElement(_TextInput2.default, {
	                                    name: 'name',
	                                    label: '' + this.state.name_label,
	                                    className: '',
	                                    value: this.state.formParams.name,
	                                    onChange: this.updateFormState,
	                                    error: this.state.errors.name
	                                })
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'row' },
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'col-xs-12' },
	                                _react2.default.createElement(_EmailInput2.default, {
	                                    name: 'email_address',
	                                    label: '' + this.state.email_address_label,
	                                    className: '',
	                                    value: this.state.formParams.email_address,
	                                    onChange: this.updateFormState,
	                                    error: this.state.errors.email_address
	                                })
	                            )
	                        ),
	                        _react2.default.createElement('br', null),
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'text-center' },
	                            _react2.default.createElement('input', {
	                                type: 'submit',
	                                disabled: !this.state.canSubmit || this.state.processing,
	                                value: this.state.processing ? '' + this.state.please_wait_label : '' + this.state.continue_label,
	                                className: 'btn btn-lg guroo-btn',
	                                onClick: this.onContinue
	                            })
	                        ),
	                        _react2.default.createElement('br', null),
	                        appHelper.isDefined(localStorage.contentData.experience.include_continue_as_guest) && localStorage.contentData.experience.include_continue_as_guest ? _react2.default.createElement(
	                            'div',
	                            { className: 'text-center' },
	                            _react2.default.createElement('div', { onClick: this.continueAsGuess, className: 'guroo-active-link', role: 'button', tabIndex: '0', onKeyDown: this.setKeyboardAccessibility, dangerouslySetInnerHTML: { __html: this.state.continue_as_guest_label } })
	                        ) : null
	                    )
	                ) : _react2.default.createElement(
	                    'div',
	                    { className: 'text-center' },
	                    _react2.default.createElement(
	                        'p',
	                        null,
	                        'Thanks ',
	                        this.state.formParams.name,
	                        ','
	                    ),
	                    _react2.default.createElement(
	                        'p',
	                        null,
	                        'One moment please.'
	                    ),
	                    _react2.default.createElement('br', null),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'preloader-image-container' },
	                        _react2.default.createElement('img', { src: __webpack_require__(1099), alt: '' })
	                    )
	                )
	            );
	        }
	    }]);
	
	    return ActorPrompt;
	}(_react2.default.Component);
	
	ActorPrompt.propTypes = {
	    initData: _propTypes2.default.object.isRequired,
	    contentData: _propTypes2.default.object.isRequired,
	    trackingData: _propTypes2.default.object.isRequired,
	    lang: _propTypes2.default.string.isRequired,
	    actions: _propTypes2.default.object.isRequired
	};
	
	ActorPrompt.contextTypes = {
	    router: _propTypes2.default.object
	};
	
	function mapStateToProps(state, ownProps) {
	    var lang = state.userData.lang;
	    return {
	        lang: lang,
	        initData: state.initData,
	        contentData: state.contentData,
	        trackingData: state.trackingData
	    };
	}
	
	function mapDispatchToProps(dispatch) {
	    return {
	        actions: (0, _redux.bindActionCreators)(Object.assign({}, initActions, trackingDataActions, dialogPopupActions), dispatch)
	    };
	}
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(ActorPrompt);

/***/ },
/* 464 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(5);
	
	var _redux = __webpack_require__(4);
	
	var _trackingDataActions = __webpack_require__(7);
	
	var trackingDataActions = _interopRequireWildcard(_trackingDataActions);
	
	var _dialogPopupActions = __webpack_require__(19);
	
	var dialogPopupActions = _interopRequireWildcard(_dialogPopupActions);
	
	var _appHelper = __webpack_require__(3);
	
	var appHelper = _interopRequireWildcard(_appHelper);
	
	var _localStorage = __webpack_require__(17);
	
	var localStorage = _interopRequireWildcard(_localStorage);
	
	var _gsap = __webpack_require__(8);
	
	var _gsapReactPlugin = __webpack_require__(10);
	
	var _gsapReactPlugin2 = _interopRequireDefault(_gsapReactPlugin);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ExitPrompt = function (_React$Component) {
	    _inherits(ExitPrompt, _React$Component);
	
	    function ExitPrompt(props, context) {
	        _classCallCheck(this, ExitPrompt);
	
	        var _this = _possibleConstructorReturn(this, (ExitPrompt.__proto__ || Object.getPrototypeOf(ExitPrompt)).call(this, props, context));
	
	        _this.state = {
	            lang: _this.props.lang,
	            exit_message: appHelper.getLocaleString("goodbye_label"),
	            save_and_exit_label: appHelper.getLocaleString("save_and_exit_label"),
	            cancel_label: appHelper.getLocaleString("cancel_label")
	
	        };
	
	        _this.onClose = _this.onClose.bind(_this);
	        _this.onExit = _this.onExit.bind(_this);
	        _this.returnToPortal = _this.returnToPortal.bind(_this);
	        return _this;
	    }
	
	    _createClass(ExitPrompt, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {}
	    }, {
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(nextProps) {
	            if (this.state.lang !== nextProps.lang) {
	                this.setState({
	                    lang: nextProps.lang,
	                    exit_message: appHelper.getLocaleString("goodbye_label"),
	                    save_and_exit_label: appHelper.getLocaleString("save_and_exit_label"),
	                    cancel_label: appHelper.getLocaleString("cancel_label")
	                });
	            }
	        }
	    }, {
	        key: 'componentDidUpdate',
	        value: function componentDidUpdate() {}
	    }, {
	        key: 'onClose',
	        value: function onClose(event) {
	            appHelper.closeWindow();
	        }
	    }, {
	        key: 'onExit',
	        value: function onExit() {
	            this.props.actions.doLMSExit(this.props.tracking_type);
	        }
	    }, {
	        key: 'returnToPortal',
	        value: function returnToPortal() {
	
	            window.parent.postMessage({
	                'func': 'onExitModule',
	                'message': true
	            }, "*");
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            return _react2.default.createElement(
	                'div',
	                { className: 'init-prompt-content text-center' },
	                _react2.default.createElement(
	                    'p',
	                    null,
	                    this.state.goodbye_label,
	                    this.props.trackingData.first_name.length > 0 ? _react2.default.createElement(
	                        'span',
	                        null,
	                        ' ',
	                        this.props.trackingData.first_name.includes('Guest') ? "" : this.props.trackingData.first_name
	                    ) : null,
	                    '.'
	                ),
	                _react2.default.createElement(
	                    'p',
	                    null,
	                    this.state.exit_message
	                ),
	                _react2.default.createElement('br', null),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'object-container' },
	                    appHelper.isDefined(localStorage.contentData.experience.use_bridge_exit) && localStorage.contentData.experience.use_bridge_exit ? _react2.default.createElement('button', { className: 'btn btn-lg guroo-btn', onClick: this.onExit, id: 'saveExitBtn', dangerouslySetInnerHTML: { __html: this.state.save_and_exit_label } }) : appHelper.isDefined(localStorage.contentData.experience.return_to_portal_on_exit) && localStorage.contentData.experience.return_to_portal_on_exit ? _react2.default.createElement('button', { className: 'btn btn-lg guroo-btn', onClick: this.returnToPortal, id: 'saveExitBtn', dangerouslySetInnerHTML: { __html: this.state.save_and_exit_label } }) : _react2.default.createElement('button', { className: 'btn btn-lg guroo-btn', onClick: this.onClose, id: 'saveExitBtn', dangerouslySetInnerHTML: { __html: this.state.save_and_exit_label } })
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'object-container' },
	                    _react2.default.createElement('button', { className: 'btn btn-lg guroo-btn', onClick: this.props.actions.removeDialog, id: 'cancelExitBtn', dangerouslySetInnerHTML: { __html: this.state.cancel_label } })
	                )
	            );
	        }
	    }]);
	
	    return ExitPrompt;
	}(_react2.default.Component);
	
	/*
	* {appHelper.isDefined(localStorage.contentData.experience.exit_url) && localStorage.contentData.experience.exit_url.length > 0
	                        ?
	                        <a className="btn btn-lg guroo-btn" href={localStorage.contentData.experience.exit_url}>Save & Exit</a>
	                        :
	                        <button className="btn btn-lg guroo-btn" onClick={this.onClose}>Save & Exit</button>
	                    }*/
	
	ExitPrompt.propTypes = {
	    initData: _propTypes2.default.object.isRequired,
	    contentData: _propTypes2.default.object.isRequired,
	    trackingData: _propTypes2.default.object.isRequired,
	    tracking_type: _propTypes2.default.string.isRequired,
	    actions: _propTypes2.default.object.isRequired,
	    lang: _propTypes2.default.string.isRequired
	};
	
	ExitPrompt.contextTypes = {
	    router: _propTypes2.default.object
	};
	
	function mapStateToProps(state, ownProps) {
	    var tracking_type = "";
	    if (appHelper.isDefined(state.contentData.experience)) {
	        tracking_type = state.contentData.experience.tracking_type;
	    }
	    var lang = state.userData.lang;
	    return {
	        lang: lang,
	        initData: state.initData,
	        contentData: state.contentData,
	        trackingData: state.trackingData,
	        tracking_type: tracking_type
	    };
	}
	
	function mapDispatchToProps(dispatch) {
	    return {
	        actions: (0, _redux.bindActionCreators)(Object.assign({}, trackingDataActions, dialogPopupActions), dispatch)
	    };
	}
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(ExitPrompt);

/***/ },
/* 465 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(5);
	
	var _redux = __webpack_require__(4);
	
	var _Preloader = __webpack_require__(467);
	
	var _Preloader2 = _interopRequireDefault(_Preloader);
	
	var _initActions = __webpack_require__(64);
	
	var initActions = _interopRequireWildcard(_initActions);
	
	var _trackingDataActions = __webpack_require__(7);
	
	var trackingDataActions = _interopRequireWildcard(_trackingDataActions);
	
	var _dialogPopupActions = __webpack_require__(19);
	
	var dialogPopupActions = _interopRequireWildcard(_dialogPopupActions);
	
	var _userDataActions = __webpack_require__(20);
	
	var userDataActions = _interopRequireWildcard(_userDataActions);
	
	var _appDataActions = __webpack_require__(12);
	
	var appDataActions = _interopRequireWildcard(_appDataActions);
	
	var _appConstants = __webpack_require__(13);
	
	var appConstants = _interopRequireWildcard(_appConstants);
	
	var _appHelper = __webpack_require__(3);
	
	var appHelper = _interopRequireWildcard(_appHelper);
	
	var _navigationHelper = __webpack_require__(153);
	
	var navHelper = _interopRequireWildcard(_navigationHelper);
	
	var _dataHelper = __webpack_require__(11);
	
	var dataHelper = _interopRequireWildcard(_dataHelper);
	
	var _environmentHelper = __webpack_require__(56);
	
	var enviromentHelper = _interopRequireWildcard(_environmentHelper);
	
	var _dialogModels = __webpack_require__(32);
	
	var _shortHandModels = __webpack_require__(287);
	
	var shortHandModels = _interopRequireWildcard(_shortHandModels);
	
	var _gsap = __webpack_require__(8);
	
	var _gsapReactPlugin = __webpack_require__(10);
	
	var _gsapReactPlugin2 = _interopRequireDefault(_gsapReactPlugin);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Initialisation = function (_React$Component) {
	    _inherits(Initialisation, _React$Component);
	
	    function Initialisation(props, context) {
	        _classCallCheck(this, Initialisation);
	
	        var _this = _possibleConstructorReturn(this, (Initialisation.__proto__ || Object.getPrototypeOf(Initialisation)).call(this, props, context));
	
	        _this.state = {
	            initData: _this.props.initData,
	            contentData: _this.props.contentData,
	            dialogPopup: _this.props.dialogPopup,
	            contentLoadingStarted: false,
	            trackingData: _this.props.trackingData,
	            trackingStarted: false,
	            imagesReadyToPreload: false,
	            imagesToLoad: [],
	            loadedImages: [],
	            checkInitialisation: false,
	            env: enviromentHelper.getEnvironment(),
	            checkSetInitialScreen: true,
	            localisedStringsSet: false
	        };
	        _this.loadedImages = [];
	        _this.imagesLoaded = false;
	
	        _this.checkInitialised = _this.checkInitialised.bind(_this);
	        _this.getInitStateByContsant = _this.getInitStateByContsant.bind(_this);
	        _this.updateInitialisedState = _this.updateInitialisedState.bind(_this);
	        _this.getImagePath = _this.getImagePath.bind(_this);
	        _this.onImageLoaded = _this.onImageLoaded.bind(_this);
	        _this.setInitialScreen = _this.setInitialScreen.bind(_this);
	        return _this;
	    }
	
	    _createClass(Initialisation, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            this.checkInitialised();
	        }
	    }, {
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(nextProps) {
	            if (!this.state.initData.initialised || this.state.initData !== nextProps.initData || this.state.contentData !== nextProps.contentData || this.state.trackingData !== nextProps.trackingData) {
	                this.setState({
	                    initData: nextProps.initData,
	                    contentData: nextProps.contentData,
	                    trackingData: nextProps.trackingData
	                });
	                this.checkInitialised();
	            }
	
	            if (this.state.trackingData !== nextProps.trackingData && !nextProps.initData.initialised) {
	                this.setState({
	                    trackingData: nextProps.trackingData,
	                    checkInitialisation: true
	                });
	            }
	
	            if (this.state.dialogPopup !== nextProps.dialogPopup) {
	                this.setState({
	                    dialogPopup: nextProps.dialogPopup
	                });
	            }
	        }
	    }, {
	        key: 'componentDidUpdate',
	        value: function componentDidUpdate() {
	            if (this.state.checkInitialisation) {
	                this.checkInitialised();
	            }
	        }
	    }, {
	        key: 'checkInitialised',
	        value: function checkInitialised() {
	            var _this2 = this;
	
	            this.setState({
	                checkInitialisation: false
	            });
	            var initData = this.state.initData;
	            if (!initData.initialised) {
	                switch (initData.currentState) {
	                    case appConstants.INIT_STATE_DATA_LOADED:
	
	                        if (!this.props.contentData.contentLoaded) {
	                            this.props.actions.loadContentData(initData);
	                        } else {
	
	                            //let default_langauge = this.props.contentData.experience.default_langauge;
	                            var default_langauge = appHelper.getArrayObjectByKey(this.props.contentData.experience.languages, "is_selected", true).language_code;
	
	                            appHelper.setContentData();
	                            this.props.actions.setProjectTitle(this.props.contentData.experience.locale[default_langauge].experience_title);
	                            this.props.actions.setInitialUserData(this.props.contentData.experience);
	                            this.setState({ imagesToLoad: Object.assign([], appHelper.getImagesToPreload(default_langauge, this.props.contentData.experience.assets)) });
	                            this.updateInitialisedState(appConstants.INIT_STATE_DATA_LOADED);
	                        }
	                        break;
	                    case appConstants.INIT_STATE_IMAGES_PRE_LOADED:
	                        if (!this.imagesLoaded) {
	                            this.setState({ imagesReadyToPreload: true });
	                        } else {
	                            this.updateInitialisedState(appConstants.INIT_STATE_IMAGES_PRE_LOADED);
	                        }
	                        break;
	                    case appConstants.INIT_STATE_TRACKING_READY:
	                        if (!this.props.trackingData.initialised && !this.state.trackingStarted) {
	                            this.setState({ trackingStarted: true });
	                            this.props.actions.initTracking(this.props.contentData, this.props.userData);
	                        } else {
	                            if (this.state.trackingData.initialised && Object.keys(this.props.contentData.experience.locale).length > 1 && !this.props.initData.lang_preference_invoked && !this.props.initData.lang_suspend_data_set) {
	                                this.props.actions.updateUserDataWithSuspendData().then(function (userData) {
	                                    var tempInitData = Object.assign({}, _this2.props.initData, {
	                                        lang_suspend_data_set: true
	                                    });
	
	                                    _this2.props.actions.updateInitData(tempInitData);
	                                }).catch(function (error) {
	                                    console.log('initialisation suspend_data error', error);
	                                });
	                            } else if (this.state.trackingData.initialised && Object.keys(this.props.contentData.experience.locale).length > 1 && !this.props.initData.lang_preference_invoked && this.props.initData.lang_suspend_data_set && !this.props.initData.lang_preference_set) {
	                                var _default_langauge = appHelper.getArrayObjectByKey(this.props.contentData.experience.languages, "is_selected", true).language_code;
	                                var title = this.props.contentData.experience.locale[_default_langauge].experience_title;
	                                var dialogConfig = Object.assign({}, _dialogModels.LOCALE_CONFIG, {
	                                    title: title
	                                });
	
	                                var tempInitData = Object.assign({}, this.props.initData, {
	                                    lang_preference_invoked: true
	                                });
	
	                                this.props.actions.updateInitData(tempInitData);
	                                this.props.actions.setNewDialog(dialogConfig);
	                            } else if (this.state.trackingData.initialised && Object.keys(this.props.contentData.experience.locale).length > 1 && this.props.initData.lang_preference_set) {
	                                this.updateInitialisedState(appConstants.INIT_STATE_TRACKING_READY);
	                            } else if (this.state.trackingData.initialised && Object.keys(this.props.contentData.experience.locale).length === 1) {
	                                this.props.actions.updateUserDataWithSuspendData();
	                                this.updateInitialisedState(appConstants.INIT_STATE_TRACKING_READY);
	                            }
	                        }
	                        break;
	
	                    default:
	                        break;
	                }
	            } else {
	                if (this.state.checkSetInitialScreen) {
	                    this.setInitialScreen();
	                }
	            }
	        }
	    }, {
	        key: 'setInitialScreen',
	        value: function setInitialScreen() {
	            //console.log(`setInitialScreen`);
	            this.props.actions.removeDialog();
	            var biteCount = this.props.contentData.experience.bites.length;
	
	            if (parseInt(this.props.trackingData.lesson_location) === -1 || this.props.contentData.experience.lesson_location === -1) {
	                var tempInitData = Object.assign({}, this.props.initData, {
	                    resumed: true
	                });
	
	                this.props.actions.updateInitData(tempInitData);
	                var contentDataExperience = Object.assign({}, this.props.contentData.experience, {
	                    lesson_location: 0
	                });
	
	                var contentData = Object.assign({}, this.props.contentData, {
	                    experience: contentDataExperience
	                });
	
	                /* if(this.props.trackingData.lesson_location === -1 && this.props.contentData.experience.include_resume_dailog && appHelper.isDefined(this.props.trackingData.suspend_data[sh_bite])){
	                     this.setState({checkSetInitialScreen: false});
	                     this.props.actions.setNewDialog(RESUME_CONFIG);
	                 }else{*/
	
	                this.props.actions.updateContentData(contentData);
	                this.context.router.push('/menu');
	                //}
	
	            } else {
	                var devBookMark = undefined;
	
	                if (appHelper.isDefined(this.props.contentData.experience.lesson_location) && parseInt(this.props.contentData.experience.lesson_location) > 0) {
	                    devBookMark = appHelper.getBiteByScreenId(this.props.contentData.experience.lesson_location);
	                }
	
	                var bookmark = appHelper.getBiteByScreenId(this.props.trackingData.lesson_location);
	                if (appHelper.isDefined(devBookMark) && this.props.trackingData.lesson_location === 0) {
	                    var _tempInitData = Object.assign({}, this.props.initData, {
	                        resumed: true
	                    });
	
	                    this.props.actions.updateInitData(_tempInitData);
	                    var _bookmark = appHelper.getBiteByScreenId(this.props.contentData.experience.lesson_location);
	                    //console.log(`bookmark goto ${bookmark} ${this.state.initData.initialised}`, this.props.trackingData);
	                    //console.log(`line 179`);
	                    this.props.actions.setLessonLocation(this.props.contentData.experience.lesson_location);
	                    this.context.router.push('/' + _bookmark);
	                } else if (appHelper.isDefined(bookmark) && !isNaN(this.props.trackingData.lesson_location)) {
	                    var sh_bite = appHelper.getShortHandKeyByRef("bites").key;
	
	                    if (this.props.contentData.experience.include_resume_dailog && appHelper.isDefined(this.props.trackingData.suspend_data[sh_bite]) && this.props.contentData.experience.tracking_type !== "open" && !this.state.initData.resumed) {
	                        this.setState({ checkSetInitialScreen: false });
	                        var _tempInitData2 = Object.assign({}, this.props.initData, {
	                            resumed: true
	                        });
	
	                        this.props.actions.updateInitData(_tempInitData2);
	                        this.props.actions.setNewDialog(_dialogModels.RESUME_CONFIG);
	                    } else {
	                        var _tempInitData3 = Object.assign({}, this.props.initData, {
	                            resumed: true
	                        });
	
	                        this.props.actions.updateInitData(_tempInitData3);
	                        //console.log(`line 201`);
	                        this.props.actions.setLessonLocation(this.props.trackingData.lesson_location);
	                        this.context.router.push('/' + bookmark);
	                    }
	                } else {
	                    var _tempInitData4 = Object.assign({}, this.props.initData, {
	                        resumed: true
	                    });
	
	                    this.props.actions.updateInitData(_tempInitData4);
	                    var _bookmark2 = appHelper.getBiteByScreenId(this.props.contentData.experience.bites[0].screens[0].screen_id);
	                    //console.log(`line 211`);
	                    this.props.actions.setLessonLocation(this.props.contentData.experience.bites[0].screens[0].screen_id);
	                    this.context.router.push('/' + _bookmark2);
	                }
	            }
	        }
	    }, {
	        key: 'updateInitialisedState',
	        value: function updateInitialisedState(constant) {
	            var initData = Object.assign({}, this.props.initData);
	            var default_langauge = appHelper.getArrayObjectByKey(this.props.contentData.experience.languages, "is_selected", true).language_code;
	
	            var strings = this.props.contentData.experience.strings[default_langauge];
	            var initStates = [];
	
	            for (var i = 0; i < initData.initialisedStates.length; i++) {
	                var initState = initData.initialisedStates[i];
	                initState = Object.assign({}, initState, {
	                    message: strings[initState.localeStringConstant]
	                });
	                initStates = dataHelper.immutablePush(initStates, initState);
	            }
	
	            initData = Object.assign({}, initData, {
	                initialisedStates: Object.assign([], initStates),
	                mainMessage: strings[initData.localeStringConstant]
	            });
	
	            var updatedInitData = Object.assign({}, appHelper.updateInitDataState(initData, constant));
	            this.props.actions.updateInitData(updatedInitData);
	
	            //this.setState({initData: Object.assign({}, updatedInitData)});
	        }
	    }, {
	        key: 'getInitStateByContsant',
	        value: function getInitStateByContsant(constant) {
	            var tempData = Object.assign({}, this.props.initData);
	            return appHelper.getInitStateByConstant(tempData.initialisedStates, constant);
	        }
	    }, {
	        key: 'onImageLoaded',
	        value: function onImageLoaded(event) {
	            this.loadedImages = this.loadedImages + 1;
	            if (this.loadedImages.length === this.state.imagesToLoad.length) {
	                this.imagesLoaded = true;
	                var checkInitialised = this.checkInitialised;
	                setTimeout(function () {
	                    checkInitialised();
	                }, 2000);
	            }
	        }
	    }, {
	        key: 'getImagePath',
	        value: function getImagePath(image) {
	            if (appConstants.DEVELOPMENT_MODE) {
	                if (appHelper.isDefined(image) && image.length > 0) {
	                    return __webpack_require__(16)("./" + image);
	                }
	            } else {
	                return image;
	            }
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this3 = this;
	
	            var initData = this.state.initData;
	            var trackingData = this.props.trackingData;
	            var Dialog = this.props.dialogPopup.component;
	            return _react2.default.createElement(
	                'div',
	                { className: 'screen guroo', ref: 'screen', role: 'alert', 'aria-busy': 'true' },
	                _react2.default.createElement(_Preloader2.default, null),
	                !initData.initialised && this.state.imagesToLoad.length > 0 ? _react2.default.createElement(
	                    'div',
	                    {
	                        className: this.state.env.window.size === 'xs' ? 'abs-centered-panel-sml-mobile' : 'abs-centered-panel-sml' },
	                    _react2.default.createElement(
	                        'span',
	                        null,
	                        _react2.default.createElement(
	                            'p',
	                            null,
	                            initData.mainMessage
	                        ),
	                        initData.initialisedStates.map(function (state) {
	                            return state.constant === initData.currentState ? _react2.default.createElement(
	                                'p',
	                                { key: state.constant },
	                                state.message
	                            ) : null;
	                        })
	                    )
	                ) : _react2.default.createElement(
	                    'div',
	                    {
	                        className: this.state.env.window.size === 'xs' ? 'abs-centered-panel-sml-mobile' : 'abs-centered-panel-sml' },
	                    _react2.default.createElement(
	                        'span',
	                        null,
	                        _react2.default.createElement(
	                            'p',
	                            null,
	                            appHelper.getLocaleString("welcome_label"),
	                            ' ',
	                            trackingData.first_name.includes('Guest') ? "" : trackingData.first_name + ' ' + trackingData.last_name
	                        )
	                    )
	                ),
	                this.state.imagesReadyToPreload && this.state.imagesToLoad.length > 0 ? this.state.imagesToLoad.map(function (image) {
	                    return _react2.default.createElement(
	                        'div',
	                        { key: image, className: 'preloading-image', ref: image },
	                        _react2.default.createElement('img', { src: _this3.getImagePath(image), name: image, value: image, onLoad: _this3.onImageLoaded,
	                            alt: '',
	                            onError: _this3.onImageNotLoaded })
	                    );
	                }) : null,
	                this.state.dialogPopup.render ? _react2.default.createElement(Dialog, null) : null
	            );
	        }
	    }]);
	
	    return Initialisation;
	}(_react2.default.Component);
	
	Initialisation.propTypes = {
	    initData: _propTypes2.default.object.isRequired,
	    contentData: _propTypes2.default.object.isRequired,
	    trackingData: _propTypes2.default.object.isRequired,
	    userData: _propTypes2.default.object.isRequired,
	    dialogPopup: _propTypes2.default.object.isRequired,
	    actions: _propTypes2.default.object.isRequired
	};
	
	Initialisation.contextTypes = {
	    router: _propTypes2.default.object
	};
	
	function mapStateToProps(state, ownProps) {
	    return {
	        initData: state.initData,
	        contentData: state.contentData,
	        trackingData: state.trackingData,
	        dialogPopup: state.dialogPopup,
	        userData: state.userData
	    };
	}
	
	function mapDispatchToProps(dispatch) {
	    return {
	        actions: (0, _redux.bindActionCreators)(Object.assign({}, initActions, trackingDataActions, userDataActions, appDataActions, dialogPopupActions), dispatch)
	    };
	}
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(Initialisation);

/***/ },
/* 466 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(5);
	
	var _redux = __webpack_require__(4);
	
	var _TextInput = __webpack_require__(195);
	
	var _TextInput2 = _interopRequireDefault(_TextInput);
	
	var _EmailInput = __webpack_require__(193);
	
	var _EmailInput2 = _interopRequireDefault(_EmailInput);
	
	var _initActions = __webpack_require__(64);
	
	var initActions = _interopRequireWildcard(_initActions);
	
	var _trackingDataActions = __webpack_require__(7);
	
	var trackingDataActions = _interopRequireWildcard(_trackingDataActions);
	
	var _dialogPopupActions = __webpack_require__(19);
	
	var dialogPopupActions = _interopRequireWildcard(_dialogPopupActions);
	
	var _appConstants = __webpack_require__(13);
	
	var appConstants = _interopRequireWildcard(_appConstants);
	
	var _LocalePicker = __webpack_require__(194);
	
	var _LocalePicker2 = _interopRequireDefault(_LocalePicker);
	
	var _formValidationHelper = __webpack_require__(152);
	
	var formValidationHelper = _interopRequireWildcard(_formValidationHelper);
	
	var _appHelper = __webpack_require__(3);
	
	var appHelper = _interopRequireWildcard(_appHelper);
	
	var _navigationHelper = __webpack_require__(153);
	
	var navHelper = _interopRequireWildcard(_navigationHelper);
	
	var _dataHelper = __webpack_require__(11);
	
	var dataHelper = _interopRequireWildcard(_dataHelper);
	
	var _keyboardConstants = __webpack_require__(14);
	
	var keyboardConstants = _interopRequireWildcard(_keyboardConstants);
	
	var _dialogModels = __webpack_require__(32);
	
	var _gsap = __webpack_require__(8);
	
	var _gsapReactPlugin = __webpack_require__(10);
	
	var _gsapReactPlugin2 = _interopRequireDefault(_gsapReactPlugin);
	
	var _localStorage = __webpack_require__(17);
	
	var localStorage = _interopRequireWildcard(_localStorage);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } //eslint-disable-line import/no-named-as-default
	//eslint-disable-line import/no-named-as-default
	
	
	var ActorPrompt = function (_React$Component) {
	    _inherits(ActorPrompt, _React$Component);
	
	    function ActorPrompt(props, context) {
	        _classCallCheck(this, ActorPrompt);
	
	        var _this = _possibleConstructorReturn(this, (ActorPrompt.__proto__ || Object.getPrototypeOf(ActorPrompt)).call(this, props, context));
	
	        _this.state = {
	            lang: props.lang,
	            locale_prompt_instruction: appHelper.getLocaleString("locale_prompt_instruction"),
	            continue_label: appHelper.getLocaleString("continue_label"),
	            updateDialog: false
	        };
	        _this.onContinue = _this.onContinue.bind(_this);
	        _this.updateDialog = _this.updateDialog.bind(_this);
	        return _this;
	    }
	
	    _createClass(ActorPrompt, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            this.updateDialog();
	        }
	    }, {
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(nextProps) {
	            if (this.state.lang !== nextProps.lang) {
	                this.setState({
	                    lang: nextProps.lang,
	                    locale_prompt_instruction: appHelper.getLocaleString("locale_prompt_instruction"),
	                    continue_label: appHelper.getLocaleString("continue_label"),
	                    updateDialog: true
	                });
	            }
	        }
	    }, {
	        key: 'componentDidUpdate',
	        value: function componentDidUpdate() {
	            if (this.state.updateDialog) {
	                this.updateDialog();
	            }
	        }
	    }, {
	        key: 'updateDialog',
	        value: function updateDialog() {
	            this.setState({ updateDialog: false });
	            var title = this.props.contentData.experience.locale[this.state.lang].experience_title;
	            var dialogConfig = Object.assign({}, _dialogModels.LOCALE_CONFIG, {
	                title: title
	            });
	
	            this.props.actions.updateDialog(dialogConfig);
	        }
	    }, {
	        key: 'onContinue',
	        value: function onContinue() {
	            this.props.actions.removeDialog();
	            var tempInitData = Object.assign({}, this.props.initData, {
	                lang_preference_set: true
	            });
	
	            this.props.actions.updateInitData(tempInitData);
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            return _react2.default.createElement(
	                'div',
	                { className: 'locale-prompt-content' },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'row' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'col-xs-12' },
	                        _react2.default.createElement('div', { dangerouslySetInnerHTML: { __html: this.state.locale_prompt_instruction } })
	                    )
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'row' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'col-xs-12' },
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'text-center' },
	                            _react2.default.createElement('br', null),
	                            _react2.default.createElement(_LocalePicker2.default, null)
	                        )
	                    )
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'row' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'col-xs-12' },
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'text-center' },
	                            _react2.default.createElement('br', null),
	                            _react2.default.createElement('button', { className: 'btn btn-lg guroo-btn',
	                                onClick: this.onContinue, dangerouslySetInnerHTML: { __html: this.state.continue_label } })
	                        )
	                    )
	                )
	            );
	        }
	    }]);
	
	    return ActorPrompt;
	}(_react2.default.Component);
	
	ActorPrompt.propTypes = {
	    initData: _propTypes2.default.object.isRequired,
	    contentData: _propTypes2.default.object.isRequired,
	    trackingData: _propTypes2.default.object.isRequired,
	    lang: _propTypes2.default.string.isRequired,
	    actions: _propTypes2.default.object.isRequired
	};
	
	ActorPrompt.contextTypes = {
	    router: _propTypes2.default.object
	};
	
	function mapStateToProps(state, ownProps) {
	    var lang = state.userData.lang;
	    return {
	        lang: lang,
	        initData: state.initData,
	        contentData: state.contentData,
	        trackingData: state.trackingData
	    };
	}
	
	function mapDispatchToProps(dispatch) {
	    return {
	        actions: (0, _redux.bindActionCreators)(Object.assign({}, initActions, trackingDataActions, dialogPopupActions), dispatch)
	    };
	}
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(ActorPrompt);

/***/ },
/* 467 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(5);
	
	var _redux = __webpack_require__(4);
	
	var _dialogPopupActions = __webpack_require__(19);
	
	var dialogPopupActions = _interopRequireWildcard(_dialogPopupActions);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Preloader = function (_React$Component) {
	    _inherits(Preloader, _React$Component);
	
	    function Preloader(props, context) {
	        _classCallCheck(this, Preloader);
	
	        var _this = _possibleConstructorReturn(this, (Preloader.__proto__ || Object.getPrototypeOf(Preloader)).call(this, props, context));
	
	        _this.state = {};
	
	        return _this;
	    }
	
	    _createClass(Preloader, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {}
	    }, {
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(nextProps) {}
	    }, {
	        key: 'componentDidUpdate',
	        value: function componentDidUpdate() {}
	    }, {
	        key: 'render',
	        value: function render() {
	            return _react2.default.createElement(
	                'div',
	                { className: 'pl-circle' },
	                _react2.default.createElement('div', { className: 'pl-circle1 pl-child' }),
	                _react2.default.createElement('div', { className: 'pl-circle2 pl-child' }),
	                _react2.default.createElement('div', { className: 'pl-circle3 pl-child' }),
	                _react2.default.createElement('div', { className: 'pl-circle4 pl-child' }),
	                _react2.default.createElement('div', { className: 'pl-circle5 pl-child' }),
	                _react2.default.createElement('div', { className: 'pl-circle6 pl-child' }),
	                _react2.default.createElement('div', { className: 'pl-circle7 pl-child' }),
	                _react2.default.createElement('div', { className: 'pl-circle8 pl-child' }),
	                _react2.default.createElement('div', { className: 'pl-circle9 pl-child' }),
	                _react2.default.createElement('div', { className: 'pl-circle10 pl-child' }),
	                _react2.default.createElement('div', { className: 'pl-circle11 pl-child' }),
	                _react2.default.createElement('div', { className: 'pl-circle12 pl-child' })
	            );
	        }
	    }]);
	
	    return Preloader;
	}(_react2.default.Component);
	
	Preloader.propTypes = {
	    initData: _propTypes2.default.object.isRequired,
	    contentData: _propTypes2.default.object.isRequired,
	    trackingData: _propTypes2.default.object.isRequired,
	    actions: _propTypes2.default.object.isRequired
	};
	
	Preloader.contextTypes = {
	    router: _propTypes2.default.object
	};
	
	function mapStateToProps(state, ownProps) {
	    return {
	        initData: state.initData,
	        contentData: state.contentData,
	        trackingData: state.trackingData
	    };
	}
	
	function mapDispatchToProps(dispatch) {
	    return {
	        actions: (0, _redux.bindActionCreators)(Object.assign({}, dialogPopupActions), dispatch)
	    };
	}
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(Preloader);

/***/ },
/* 468 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(5);
	
	var _redux = __webpack_require__(4);
	
	var _TextInput = __webpack_require__(195);
	
	var _TextInput2 = _interopRequireDefault(_TextInput);
	
	var _EmailInput = __webpack_require__(193);
	
	var _EmailInput2 = _interopRequireDefault(_EmailInput);
	
	var _initActions = __webpack_require__(64);
	
	var initActions = _interopRequireWildcard(_initActions);
	
	var _trackingDataActions = __webpack_require__(7);
	
	var trackingDataActions = _interopRequireWildcard(_trackingDataActions);
	
	var _dialogPopupActions = __webpack_require__(19);
	
	var dialogPopupActions = _interopRequireWildcard(_dialogPopupActions);
	
	var _userDataActions = __webpack_require__(20);
	
	var userDataActions = _interopRequireWildcard(_userDataActions);
	
	var _appConstants = __webpack_require__(13);
	
	var appConstants = _interopRequireWildcard(_appConstants);
	
	var _formValidationHelper = __webpack_require__(152);
	
	var formValidationHelper = _interopRequireWildcard(_formValidationHelper);
	
	var _appHelper = __webpack_require__(3);
	
	var appHelper = _interopRequireWildcard(_appHelper);
	
	var _navigationHelper = __webpack_require__(153);
	
	var navHelper = _interopRequireWildcard(_navigationHelper);
	
	var _dataHelper = __webpack_require__(11);
	
	var dataHelper = _interopRequireWildcard(_dataHelper);
	
	var _gsap = __webpack_require__(8);
	
	var _gsapReactPlugin = __webpack_require__(10);
	
	var _gsapReactPlugin2 = _interopRequireDefault(_gsapReactPlugin);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } //eslint-disable-line import/no-named-as-default
	//eslint-disable-line import/no-named-as-default
	
	
	var ExitPrompt = function (_React$Component) {
	    _inherits(ExitPrompt, _React$Component);
	
	    function ExitPrompt(props, context) {
	        _classCallCheck(this, ExitPrompt);
	
	        var _this = _possibleConstructorReturn(this, (ExitPrompt.__proto__ || Object.getPrototypeOf(ExitPrompt)).call(this, props, context));
	
	        _this.state = {
	            lang: _this.props.lang,
	            welcome_back_label: appHelper.getLocaleString("welcome_back_label"),
	            guest_label: appHelper.getLocaleString("guest_label"),
	            resume_prompt: appHelper.getLocaleString("resume_prompt"),
	            resume_continue_label: appHelper.getLocaleString("resume_continue_label"),
	            review_from_beginning_label: appHelper.getLocaleString("review_from_beginning_label"),
	            clear_and_restart_label: appHelper.getLocaleString("clear_and_restart_label")
	
	        };
	        _this.resumeContinue = _this.resumeContinue.bind(_this);
	        _this.resumeReview = _this.resumeReview.bind(_this);
	        _this.clearResults = _this.clearResults.bind(_this);
	
	        return _this;
	    }
	
	    _createClass(ExitPrompt, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {}
	    }, {
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(nextProps) {
	            if (this.state.lang !== nextProps.lang) {
	                this.setState({
	                    lang: nextProps.lang,
	                    welcome_back_label: appHelper.getLocaleString("welcome_back_label"),
	                    guest_label: appHelper.getLocaleString("guest_label"),
	                    resume_prompt: appHelper.getLocaleString("resume_prompt"),
	                    resume_continue_label: appHelper.getLocaleString("resume_continue_label"),
	                    review_from_beginning_label: appHelper.getLocaleString("review_from_beginning_label"),
	                    clear_and_restart_label: appHelper.getLocaleString("clear_and_restart_label")
	                });
	            }
	        }
	    }, {
	        key: 'componentDidUpdate',
	        value: function componentDidUpdate() {}
	    }, {
	        key: 'resumeContinue',
	        value: function resumeContinue() {
	            this.props.actions.removeDialog();
	            var lesson_location = this.props.trackingData.lesson_location;
	            var bookmark = appHelper.getBiteByScreenId(lesson_location);
	            this.props.actions.setLessonLocation(lesson_location);
	            this.context.router.push('/' + bookmark);
	        }
	    }, {
	        key: 'resumeReview',
	        value: function resumeReview() {
	            this.props.actions.removeDialog();
	            var lesson_location = this.props.contentData.experience.bites[0].screens[0].screen_id;
	            var bookmark = appHelper.getBiteByScreenId(lesson_location);
	            this.props.actions.setLessonLocation(lesson_location);
	            this.context.router.push('/' + bookmark);
	        }
	    }, {
	        key: 'clearResults',
	        value: function clearResults() {
	            var _this2 = this;
	
	            this.props.actions.setInitialUserData(this.props.contentData.experience).then(function (userData) {
	                _this2.props.actions.setSuspendData(userData).then(function (userData) {
	                    _this2.resumeReview();
	                }).catch(function (error) {});
	            }).catch(function (error) {});
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            return _react2.default.createElement(
	                'div',
	                { className: 'init-prompt-content text-center' },
	                _react2.default.createElement(
	                    'p',
	                    null,
	                    this.state.welcome_back_label,
	                    this.props.trackingData.first_name.length > 0 ? _react2.default.createElement(
	                        'span',
	                        null,
	                        ' ',
	                        this.props.trackingData.first_name.includes('Guest') ? "" : this.props.trackingData.first_name
	                    ) : null
	                ),
	                _react2.default.createElement(
	                    'p',
	                    null,
	                    this.state.resume_prompt
	                ),
	                _react2.default.createElement('br', null),
	                this.props.contentData.experience.include_continue_from_last_screen ? _react2.default.createElement(
	                    'div',
	                    { className: 'object-container' },
	                    _react2.default.createElement('button', { className: 'btn btn-lg guroo-btn', onClick: this.resumeContinue, dangerouslySetInnerHTML: { __html: this.state.resume_continue_label } })
	                ) : null,
	                this.props.contentData.experience.include_review_from_beginning ? _react2.default.createElement(
	                    'div',
	                    { className: 'object-container' },
	                    _react2.default.createElement('button', { className: 'btn btn-lg guroo-btn', onClick: this.resumeReview, dangerouslySetInnerHTML: { __html: this.state.review_from_beginning_label } })
	                ) : null,
	                this.props.contentData.experience.include_clear_history_and_start_over ? _react2.default.createElement(
	                    'div',
	                    { className: 'object-container' },
	                    _react2.default.createElement('button', { className: 'btn btn-lg guroo-btn', onClick: this.clearResults, dangerouslySetInnerHTML: { __html: this.state.clear_and_restart_label } })
	                ) : null
	            );
	        }
	    }]);
	
	    return ExitPrompt;
	}(_react2.default.Component);
	
	ExitPrompt.propTypes = {
	    initData: _propTypes2.default.object.isRequired,
	    contentData: _propTypes2.default.object.isRequired,
	    trackingData: _propTypes2.default.object.isRequired,
	    lang: _propTypes2.default.string.isRequired,
	    actions: _propTypes2.default.object.isRequired
	};
	
	ExitPrompt.contextTypes = {
	    router: _propTypes2.default.object
	};
	
	function mapStateToProps(state, ownProps) {
	    var lang = state.userData.lang;
	    return {
	        lang: lang,
	        initData: state.initData,
	        contentData: state.contentData,
	        trackingData: state.trackingData
	    };
	}
	
	function mapDispatchToProps(dispatch) {
	    return {
	        actions: (0, _redux.bindActionCreators)(Object.assign({}, initActions, trackingDataActions, dialogPopupActions, userDataActions), dispatch)
	    };
	}
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(ExitPrompt);

/***/ },
/* 469 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(45);
	
	var _reactRedux = __webpack_require__(5);
	
	var _redux = __webpack_require__(4);
	
	var _svgInlineReact = __webpack_require__(434);
	
	var _svgInlineReact2 = _interopRequireDefault(_svgInlineReact);
	
	var _RotationKpiMeter = __webpack_require__(82);
	
	var _RotationKpiMeter2 = _interopRequireDefault(_RotationKpiMeter);
	
	var _Badge = __webpack_require__(135);
	
	var _Badge2 = _interopRequireDefault(_Badge);
	
	var _localStorage = __webpack_require__(17);
	
	var localStorage = _interopRequireWildcard(_localStorage);
	
	var _trackingDataActions = __webpack_require__(7);
	
	var trackingDataActions = _interopRequireWildcard(_trackingDataActions);
	
	var _appHelper = __webpack_require__(3);
	
	var appHelper = _interopRequireWildcard(_appHelper);
	
	var _userDataHelper = __webpack_require__(15);
	
	var userDataHelper = _interopRequireWildcard(_userDataHelper);
	
	var _kpiHelper = __webpack_require__(35);
	
	var kpiHelper = _interopRequireWildcard(_kpiHelper);
	
	var _kpiModels = __webpack_require__(57);
	
	var kpiModels = _interopRequireWildcard(_kpiModels);
	
	var _kpiConstants = __webpack_require__(37);
	
	var kpiConstants = _interopRequireWildcard(_kpiConstants);
	
	var _objectConstants = __webpack_require__(9);
	
	var objectConstants = _interopRequireWildcard(_objectConstants);
	
	var _componentConstants = __webpack_require__(49);
	
	var componentConstants = _interopRequireWildcard(_componentConstants);
	
	var _appConstants = __webpack_require__(13);
	
	var appConstants = _interopRequireWildcard(_appConstants);
	
	var _keyboardConstants = __webpack_require__(14);
	
	var keyboardConstants = _interopRequireWildcard(_keyboardConstants);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var LearninPlanBitePanel = function (_React$Component) {
	    _inherits(LearninPlanBitePanel, _React$Component);
	
	    function LearninPlanBitePanel(props, context) {
	        _classCallCheck(this, LearninPlanBitePanel);
	
	        var _this = _possibleConstructorReturn(this, (LearninPlanBitePanel.__proto__ || Object.getPrototypeOf(LearninPlanBitePanel)).call(this, props, context));
	
	        _this.state = {
	            filter: _this.props.filter,
	            userBite: _this.props.userBite,
	            lang: _this.props.lang,
	            locale: appHelper.getLocalData(_this.props.menuData),
	            biteLocale: appHelper.getLocalData(_this.props.bite),
	            primaryKpi: appHelper.isDefined(_this.props.bite.score_kpi) ? _this.props.bite.score_kpi : {},
	            performance_kpis: appHelper.isDefined(_this.props.bite.performance_kpis) && _this.props.bite.performance_kpis.length ? _this.props.bite.performance_kpis : [],
	            assets: {
	                thumbnail: {
	                    src: "",
	                    type: "",
	                    type_id: ""
	                },
	                icon: {
	                    src: "",
	                    type: "",
	                    type_id: ""
	                }
	            },
	            checkForUpdate: false,
	            badges: _this.props.bite.badges,
	            badgeUserData: _this.props.userBite.badges,
	            showAchievedCount: true,
	            showAchievedState: true,
	            isEnabled: false,
	            updateEnabledBite: false,
	            optionLabel: appHelper.getLocaleString("optional_label")
	        };
	        _this.getAssets = _this.getAssets.bind(_this);
	        _this.getImagePath = _this.getImagePath.bind(_this);
	        _this.setBite = _this.setBite.bind(_this);
	        _this.goToBite = _this.goToBite.bind(_this);
	        _this.getUserProgressClass = _this.getUserProgressClass.bind(_this);
	        _this.setEnabledState = _this.setEnabledState.bind(_this);
	        _this.isBiteEnabled = _this.isBiteEnabled.bind(_this);
	        _this.getBiteEnabledState = _this.getBiteEnabledState.bind(_this);
	        _this.getUserBadge = _this.getUserBadge.bind(_this);
	        _this.setKeyboardAccessibility = _this.setKeyboardAccessibility.bind(_this);
	        return _this;
	    }
	
	    _createClass(LearninPlanBitePanel, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            this.getAssets();
	            this.setEnabledState();
	        }
	    }, {
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(nextProps) {
	            if (this.state.filter !== nextProps.filter) {
	                this.setState({ filter: nextProps.filter });
	            }
	            if (this.state.userBite !== nextProps.userBite) {
	                this.setState({
	                    userBite: Object.assign({}, nextProps.userBite),
	                    badgeUserData: Object.assign([], nextProps.userBite.badges),
	                    updateEnabledBite: true
	                });
	            }
	
	            if (this.state.lang !== nextProps.lang) {
	                this.setState({
	                    lang: nextProps.lang,
	                    locale: appHelper.getLocalData(this.props.menuData),
	                    biteLocale: appHelper.getLocalData(this.props.bite),
	                    optionLabel: appHelper.getLocaleString("optional_label")
	                });
	            }
	        }
	    }, {
	        key: 'componentDidUpdate',
	        value: function componentDidUpdate() {
	            if (this.state.checkForUpdate && this.props.trackingData.lesson_location === this.props.bite.screens[0].screen_id) {
	                this.goToBite();
	            }
	
	            if (this.state.updateEnabledBite) {
	                this.setEnabledState();
	            }
	        }
	    }, {
	        key: 'getAssets',
	        value: function getAssets() {
	
	            var iconAsset = appHelper.getIconAsset(this.props.menuData.icon);
	
	            this.setState({
	                assets: Object.assign({}, this.state.assets, {
	                    icon: iconAsset
	                })
	            });
	        }
	    }, {
	        key: 'getImagePath',
	        value: function getImagePath(image) {
	            if (appConstants.DEVELOPMENT_MODE) {
	                if (appHelper.isDefined(image) && image.length > 0) {
	                    return __webpack_require__(16)("./" + image);
	                }
	            } else {
	                return image;
	            }
	        }
	    }, {
	        key: 'setBite',
	        value: function setBite() {
	
	            if (this.isBiteEnabled()) {
	                var screen_id = this.props.bite.screens[0].screen_id;
	                this.props.actions.setNewLessonLocation(screen_id);
	                this.setState({ checkForUpdate: true });
	                //this.context.router.push(this.props.bite.bite_id);
	            }
	        }
	    }, {
	        key: 'goToBite',
	        value: function goToBite() {
	            this.setState({ checkForUpdate: false });
	            this.context.router.push(this.props.bite.bite_id);
	        }
	    }, {
	        key: 'getUserProgressClass',
	        value: function getUserProgressClass() {
	            var className = '';
	
	            if (this.state.userBite.status === objectConstants.STATUS_NOT_REQUIRED) {
	                className += objectConstants.CLASS_NOT_REQUIRED + ' ';
	            } else if (this.state.userBite.status === objectConstants.STATUS_IN_PROGRESS) {
	                className += objectConstants.CLASS_IN_PROGRESS + ' ';
	            } else if (this.state.userBite.status === objectConstants.STATUS_COMPLETE) {
	                className += objectConstants.CLASS_COMPLETE + ' ';
	            } else {
	                className += objectConstants.CLASS_NOT_STARTED + ' ';
	            }
	
	            return className;
	        }
	    }, {
	        key: 'setEnabledState',
	        value: function setEnabledState() {
	            this.setState({
	                updateEnabledBite: false
	            });
	            var isEnabled = false;
	            switch (this.props.contentData.experience.experience_learning_model) {
	                case componentConstants.MENU_TYPE_LINEAR_LEARNING_PLAN:
	                    isEnabled = appHelper.checkLinearMenuBiteEnabled(this.state.userBite, this.props.userData);
	                    break;
	                case componentConstants.MENU_TYPE_OPEN_LEARNING_PLAN:
	                    isEnabled = appHelper.checkOpenMenuBiteEnabled(this.state.userBite, this.props.userData);
	                    break;
	                case componentConstants.MENU_TYPE_FIRST_ANY_LAST_LEARNING_PLAN:
	                    isEnabled = appHelper.checkFirstLastAnyMenuBiteEnabled(this.state.userBite, this.props.userData);
	                    break;
	                case componentConstants.MENU_TYPE_PERSONAL_LEARNING_PLAN:
	                    isEnabled = appHelper.checkOpenMenuBiteEnabled(this.state.userBite, this.props.userData);
	                    break;
	                default:
	                    isEnabled = appHelper.checkLinearMenuBiteEnabled(this.state.userBite, this.props.userData);
	            }
	
	            this.setState({ isEnabled: isEnabled });
	        }
	    }, {
	        key: 'isBiteEnabled',
	        value: function isBiteEnabled() {
	            return this.state.isEnabled;
	        }
	    }, {
	        key: 'getBiteEnabledState',
	        value: function getBiteEnabledState() {
	            return this.isBiteEnabled() ? "" : "disabled";
	        }
	    }, {
	        key: 'getUserBadge',
	        value: function getUserBadge(badge) {
	            return appHelper.getArrayObjectByKey(this.state.badgeUserData, "badge_id", badge.badge_id);
	        }
	    }, {
	        key: 'setKeyboardAccessibility',
	        value: function setKeyboardAccessibility(event) {
	
	            if (event.which === keyboardConstants.ENTER_KEY || event.which === keyboardConstants.SPACEBAR_KEY) {
	                event.preventDefault();
	                event.stopPropagation();
	                this.setBite();
	            }
	        }
	
	        // <InlineSVG className="guroo-icon" src={this.getImagePath(this.state.assets.icon.src)}/>
	
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this2 = this;
	
	            return _react2.default.createElement(
	                'div',
	                null,
	                this.state.filter === "required" && this.props.required || this.state.filter !== "required" ? _react2.default.createElement(
	                    'div',
	                    { className: 'menu-panel ' + this.getBiteEnabledState(), onClick: this.setBite, onKeyDown: this.setKeyboardAccessibility, tabIndex: 0, role: 'link' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'icon-container ' + this.getUserProgressClass() },
	                        appHelper.isDefined(this.state.assets.icon) && this.state.assets.icon.src.length > 0 ? _react2.default.createElement(
	                            'div',
	                            { className: 'thumbnail-icon' },
	                            _react2.default.createElement('img', { className: 'guroo-icon', src: this.getImagePath(this.state.assets.icon.src), alt: '' })
	                        ) : null
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'content-container' },
	                        appHelper.isDefined(this.state.primaryKpi.kpi_id) && this.state.primaryKpi.kpi_id !== null && this.state.primaryKpi.is_visible && (appHelper.isDefined(this.props.menuData.display_score) && this.props.menuData.display_score || !appHelper.isDefined(this.props.menuData.display_score)) ? _react2.default.createElement(
	                            'div',
	                            { className: 'kpi-meter-container' },
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'kpi-meter' },
	                                _react2.default.createElement(_RotationKpiMeter2.default, { bite_id: this.props.bite.bite_id,
	                                    kpiDefaults: this.state.primaryKpi,
	                                    meterParams: kpiModels.DEFAULT_KPI_ROTATION_METER_PARAMS,
	                                    displayState: kpiConstants.KPI_DISPLAY_STATE_CURRENT_VALUE_NO_LABEL })
	                            )
	                        ) : null,
	                        this.state.badges.length > 0 && (appHelper.isDefined(this.props.menuData.display_badges) && this.props.menuData.display_badges || !appHelper.isDefined(this.props.menuData.display_badges)) ? _react2.default.createElement(
	                            'div',
	                            { className: 'thumbnail-badge-container' },
	                            _react2.default.createElement(
	                                'ul',
	                                { className: 'badge-grid' },
	                                this.state.badges.map(function (badge) {
	                                    return !appHelper.isDefined(badge.is_visible) || appHelper.isDefined(badge.is_visible) && badge.is_visible ? _react2.default.createElement(
	                                        'li',
	                                        { key: badge.badge_id, className: 'badge-grid-item' },
	                                        _react2.default.createElement(_Badge2.default, { badge: badge,
	                                            userBadge: _this2.getUserBadge(badge),
	                                            showAchievedCount: _this2.state.showAchievedCount,
	                                            showAchievedState: _this2.state.showAchievedState
	                                        })
	                                    ) : null;
	                                })
	                            )
	                        ) : null,
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'bite-title' },
	                            appHelper.isDefined(this.state.locale.sur_title) && this.state.locale.sur_title !== null && this.state.locale.sur_title.length > 0 ? _react2.default.createElement(
	                                'div',
	                                { className: 'sur-title' },
	                                this.state.locale.sur_title
	                            ) : null,
	                            _react2.default.createElement(
	                                'span',
	                                {
	                                    className: 'title ' + this.getUserProgressClass() },
	                                ' ',
	                                this.state.biteLocale.title
	                            ),
	                            !this.props.required ? _react2.default.createElement(
	                                'span',
	                                { className: 'required' },
	                                this.state.optionLabel
	                            ) : null
	                        ),
	                        appHelper.isDefined(this.state.locale.description) && this.state.locale.description !== null && this.state.locale.description.length > 0 ? _react2.default.createElement('div', { className: 'description',
	                            dangerouslySetInnerHTML: { __html: this.state.locale.description } }) : null
	                    )
	                ) : null
	            );
	        }
	    }]);
	
	    return LearninPlanBitePanel;
	}(_react2.default.Component);
	
	/*
	* {this.state.performance_kpis.length > 0
	                                    ?
	                                    this.state.performance_kpis.map(kpi =>
	                                    <div className="kpi-meter-container" key={kpi.kpi_id}>
	                                        <div className="kpi-meter">
	                                            <RotationMeter bite_id={this.props.bite.bite_id}
	                                                           kpiDefaults={kpi}
	                                                           meterParams={kpiModels.DEFAULT_KPI_ROTATION_METER_PARAMS}
	                                                           displayState={kpiConstants.KPI_DISPLAY_STATE_CURRENT_VALUE_NO_LABEL}/>
	                                        </div>
	                                    </div>
	                                     )
	                                    :null
	                                }
	
	* */
	
	
	LearninPlanBitePanel.propTypes = {
	    menuData: _react.PropTypes.object.isRequired,
	    bite: _react.PropTypes.object.isRequired,
	    required: _react.PropTypes.bool.isRequired,
	    filter: _react.PropTypes.string.isRequired,
	    userBite: _react.PropTypes.object.isRequired,
	    userData: _react.PropTypes.object.isRequired,
	    trackingData: _react.PropTypes.object.isRequired,
	    contentData: _react.PropTypes.object.isRequired,
	    lang: _react.PropTypes.string.isRequired,
	    actions: _react.PropTypes.object.isRequired
	};
	
	LearninPlanBitePanel.contextTypes = {
	    router: _react.PropTypes.object
	};
	
	function mapStateToProps(state, ownProps) {
	    var lang = state.userData.lang;
	    return {
	        lang: lang,
	        userBite: userDataHelper.getBiteUserData(state.userData, ownProps.bite.bite_id),
	        userData: state.userData,
	        trackingData: state.trackingData,
	        contentData: state.contentData
	
	    };
	}
	
	function mapDispatchToProps(dispatch) {
	    return {
	        actions: (0, _redux.bindActionCreators)(Object.assign({}, trackingDataActions), dispatch)
	    };
	}
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(LearninPlanBitePanel);

/***/ },
/* 470 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(5);
	
	var _redux = __webpack_require__(4);
	
	var _LearninPlanBitePanel = __webpack_require__(469);
	
	var _LearninPlanBitePanel2 = _interopRequireDefault(_LearninPlanBitePanel);
	
	var _trackingDataActions = __webpack_require__(7);
	
	var trackingDataActions = _interopRequireWildcard(_trackingDataActions);
	
	var _appHelper = __webpack_require__(3);
	
	var appHelper = _interopRequireWildcard(_appHelper);
	
	var _dataHelper = __webpack_require__(11);
	
	var dataHelper = _interopRequireWildcard(_dataHelper);
	
	var _userDataHelper = __webpack_require__(15);
	
	var userDataHelper = _interopRequireWildcard(_userDataHelper);
	
	var _environmentHelper = __webpack_require__(56);
	
	var enviromentHelper = _interopRequireWildcard(_environmentHelper);
	
	var _objectConstants = __webpack_require__(9);
	
	var objectConstants = _interopRequireWildcard(_objectConstants);
	
	var _appConstants = __webpack_require__(13);
	
	var appConstants = _interopRequireWildcard(_appConstants);
	
	var _ExitButton = __webpack_require__(274);
	
	var _ExitButton2 = _interopRequireDefault(_ExitButton);
	
	var _lodash = __webpack_require__(28);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var LearningPlanMenu = function (_React$Component) {
	    _inherits(LearningPlanMenu, _React$Component);
	
	    function LearningPlanMenu(props, context) {
	        _classCallCheck(this, LearningPlanMenu);
	
	        var _this = _possibleConstructorReturn(this, (LearningPlanMenu.__proto__ || Object.getPrototypeOf(LearningPlanMenu)).call(this, props, context));
	
	        _this.state = {
	            lang: _this.props.lang,
	            userData: _this.props.userData,
	            learningPlan: _this.props.contentData.experience.learning_plan,
	            lessonStatus: userDataHelper.getLessonStatus(_this.props.userData.bites),
	            fontSize: _this.props.fontSize,
	            height: undefined,
	            updateHeight: false,
	            bites: [],
	            locale: appHelper.getLocalData(_this.props.contentData.experience.learning_plan),
	            filter: "required",
	            hasOptionalBites: false,
	            updateLEarningPlan: false,
	            assets: {
	                background: {
	                    src: "",
	                    type: "",
	                    type_id: ""
	                },
	                character: {
	                    src: "",
	                    pose: "",
	                    position: ""
	                }
	            },
	            instruction: "",
	            updateInstruction: false,
	            show_label: appHelper.getLocaleString("show_label"),
	            required_only_label: appHelper.getLocaleString("required_only_label"),
	            all_label: appHelper.getLocaleString("all_label"),
	            showExitBtn: appHelper.isDefined(_this.props.contentData.experience) ? _this.props.contentData.experience.include_exit_button : false,
	            env: enviromentHelper.getEnvironment()
	        };
	        _this.getAssets = _this.getAssets.bind(_this);
	        _this.getInstruction = _this.getInstruction.bind(_this);
	        _this.getImagePath = _this.getImagePath.bind(_this);
	        _this.setFilterRequired = _this.setFilterRequired.bind(_this);
	        _this.setFilterAll = _this.setFilterAll.bind(_this);
	        _this.getFilterBtnClass = _this.getFilterBtnClass.bind(_this);
	        _this.setPersonalLearningPlanBites = _this.setPersonalLearningPlanBites.bind(_this);
	        //this.jumpToBite = this.jumpToBite.bind(this);
	        _this.setHeight = _lodash2.default.debounce(_this.setHeight.bind(_this).bind(_this), 100);
	        _this.getHeight = _this.getHeight.bind(_this);
	
	        _this.componentWatcher = _lodash2.default.debounce(_this.componentWatcher.bind(_this), 100);
	        return _this;
	    }
	
	    _createClass(LearningPlanMenu, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            window.addEventListener("resize", this.componentWatcher);
	            this.props.actions.setNewLessonLocation(-1);
	            this.setPersonalLearningPlanBites();
	            this.getAssets();
	            this.setHeight();
	            this.getInstruction();
	        }
	    }, {
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(nextProps) {
	            if (this.state.userData !== nextProps.userData) {
	                this.setState({
	                    userData: Object.assign({}, nextProps.userData),
	                    updateLEarningPlan: true
	                });
	            }
	
	            if (this.state.fontSize !== nextProps.fontSize) {
	                this.setState({ fontSize: nextProps.fontSize, updateHeight: true });
	            }
	
	            if (this.state.lang !== nextProps.lang) {
	                this.setState({
	                    lang: nextProps.lang,
	                    locale: appHelper.getLocalData(this.props.contentData.experience.learning_plan),
	                    show_label: appHelper.getLocaleString("show_label"),
	                    required_only_label: appHelper.getLocaleString("required_only_label"),
	                    all_label: appHelper.getLocaleString("all_label"),
	                    updateInstruction: true
	                });
	            }
	        }
	    }, {
	        key: 'componentDidUpdate',
	        value: function componentDidUpdate() {
	            if (this.state.updateLEarningPlan) {
	                this.setPersonalLearningPlanBites();
	            }
	
	            if (this.state.updateHeight) {
	                this.setHeight();
	            }
	
	            if (this.updateInstruction) {
	                this.getInstruction();
	            }
	        }
	    }, {
	        key: 'componentWillUnmount',
	        value: function componentWillUnmount() {
	            window.removeEventListener("resize", this.componentWatcher);
	        }
	    }, {
	        key: 'componentWatcher',
	        value: function componentWatcher() {
	
	            var env = enviromentHelper.getEnvironment();
	            if (env.window.size !== this.state.env.window.size || env.window.orientation !== this.state.env.window.orientation) {
	                this.setState({ env: Object.assign({}, env) });
	                this.setHeight();
	            }
	        }
	    }, {
	        key: 'setPersonalLearningPlanBites',
	        value: function setPersonalLearningPlanBites() {
	            this.setState({ updateLEarningPlan: false });
	            var bites = [];
	            var hasOptionalBites = false;
	
	            for (var i = 0; i < this.state.userData.bites.length; i++) {
	                var bite = this.state.userData.bites[i];
	                if (!bite.required && bite.visible) {
	                    hasOptionalBites = true;
	                }
	
	                bites = dataHelper.immutablePush(bites, bite);
	            }
	            //if(!appHelper.isDefined(localStorage.menu.reorder_optional_items) || (appHelper.isDefined(localStorage.menu.reorder_optional_items) && localStorage.menu.reorder_optional_items)) {
	            bites.sort(function (a, b) {
	                if (b.required < a.required) return -1;
	                if (b.required > a.required) return 1;
	                return 0;
	            });
	            //}
	
	
	            this.setState({ bites: Object.assign([], bites), hasOptionalBites: hasOptionalBites });
	        }
	    }, {
	        key: 'getAssets',
	        value: function getAssets() {
	            var backgroundAsset = Object.assign(this.state.assets.background);
	            var screenCharacter = {};
	            var characterAsset = Object.assign(this.state.assets.character);
	
	            if (appHelper.isDefined(this.state.learningPlan.assets.background)) {
	                backgroundAsset = appHelper.getBackgroundAsset(this.state.learningPlan.assets.background);
	            }
	
	            if (appHelper.isDefined(this.state.learningPlan.assets.character)) {
	                screenCharacter = appHelper.getCharacterAsset(this.state.learningPlan.assets.character);
	                characterAsset = appHelper.getCharacterPose(screenCharacter, this.state.learningPlan.assets.character);
	            }
	
	            this.setState({
	                assets: Object.assign({}, this.state.assets, {
	                    background: backgroundAsset,
	                    character: characterAsset
	                })
	            });
	        }
	    }, {
	        key: 'getImagePath',
	        value: function getImagePath(image) {
	            if (appConstants.DEVELOPMENT_MODE) {
	                if (appHelper.isDefined(image) && image.length > 0) {
	                    return __webpack_require__(16)("./" + image);
	                }
	            } else {
	                return image;
	            }
	        }
	    }, {
	        key: 'getInstruction',
	        value: function getInstruction() {
	            var instruction = "";
	            if (this.state.lessonStatus !== objectConstants.STATUS_COMPLETE) {
	                instruction = this.state.locale.description;
	            } else {
	                if (appHelper.isDefined(this.state.locale.completion_text)) {
	                    instruction = this.state.locale.completion_text;
	                } else {
	                    instruction = this.state.locale.description;
	                }
	            }
	
	            this.setState({ instruction: instruction, updateInstruction: false });
	        }
	    }, {
	        key: 'setFilterRequired',
	        value: function setFilterRequired() {
	            this.setState({ filter: "required" });
	        }
	    }, {
	        key: 'setFilterAll',
	        value: function setFilterAll() {
	            this.setState({ filter: "all" });
	        }
	    }, {
	        key: 'getFilterBtnClass',
	        value: function getFilterBtnClass(value) {
	            return value === this.state.filter ? 'active' : '';
	        }
	
	        /*jumpToBite(){
	            console.log('jump to bite');
	            window.parent.postMessage({
	                'func': 'setScreenId',
	                'message' : {
	                    'screen_type': 'screen',
	                    'screen_id': 333
	                }
	            }, "*");
	        }*/
	
	    }, {
	        key: 'setHeight',
	        value: function setHeight() {
	            this.setState({ updateHeight: false });
	            var mainWrapper = document.getElementById('main-wrapper');
	            var header = document.getElementById('learningPlanMenuHeader');
	
	            if (appHelper.isDefined(header)) {
	                var newHeight = mainWrapper.offsetHeight - header.offsetHeight;
	                this.setState({ height: newHeight });
	            }
	        }
	    }, {
	        key: 'getHeight',
	        value: function getHeight() {
	            var header = document.getElementById('learningPlanMenuHeader');
	            if (header !== null && appHelper.isDefined(this.state.height)) {
	                return {
	                    height: this.state.height + 'px',
	                    minHeight: this.state.height + 'px'
	                };
	            } else {
	                return {};
	            }
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this2 = this;
	
	            var Dialog = this.props.dialogPopup.component;
	            return _react2.default.createElement(
	                'div',
	                { className: 'scenario-bite ' },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'scenario-bite-content' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'screen-wrapper full-screen' },
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'menu-screen' },
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'background-container' },
	                                _react2.default.createElement('img', { src: this.getImagePath(this.state.assets.background.src), alt: '' })
	                            ),
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'screen-container full-screen-tight' },
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: 'personalised-menu-header include-filter', id: 'learningPlanMenuHeader' },
	                                    this.state.assets.character.src.length > 0 ? _react2.default.createElement(
	                                        'div',
	                                        { className: 'character-image' },
	                                        _react2.default.createElement('img', { src: this.getImagePath(this.state.assets.character.src), alt: '' })
	                                    ) : null,
	                                    _react2.default.createElement(
	                                        'div',
	                                        { className: 'label-panel ' + (this.state.showExitBtn ? "include-nav" : "") },
	                                        appHelper.isDefined(this.state.locale.title) && this.state.locale.title.length > 0 ? _react2.default.createElement(
	                                            'div',
	                                            { className: 'flex-1' },
	                                            _react2.default.createElement(
	                                                'h3',
	                                                { className: 'text-center' },
	                                                this.state.locale.title
	                                            )
	                                        ) : null,
	                                        this.state.showExitBtn ? _react2.default.createElement(
	                                            'div',
	                                            { className: 'nav-item' },
	                                            _react2.default.createElement(_ExitButton2.default, null)
	                                        ) : null
	                                    ),
	                                    _react2.default.createElement(
	                                        'div',
	                                        { className: 'filter-panel' },
	                                        appHelper.isDefined(this.state.locale.description) && this.state.locale.description !== null && this.state.locale.description.length > 0 ? _react2.default.createElement('div', { className: 'instruction-text',
	                                            dangerouslySetInnerHTML: { __html: this.state.instruction } }) : null,
	                                        this.state.hasOptionalBites ? _react2.default.createElement(
	                                            'div',
	                                            { className: 'inline-block' },
	                                            _react2.default.createElement(
	                                                'div',
	                                                { className: 'inline-block' },
	                                                _react2.default.createElement(
	                                                    'div',
	                                                    { className: 'text-right' },
	                                                    this.state.show_label,
	                                                    ': \xA0 \xA0'
	                                                )
	                                            ),
	                                            _react2.default.createElement(
	                                                'div',
	                                                { className: 'btn-group text-right' },
	                                                _react2.default.createElement(
	                                                    'button',
	                                                    { type: 'button',
	                                                        className: 'btn ' + this.getFilterBtnClass("required"),
	                                                        onClick: this.setFilterRequired },
	                                                    this.state.required_only_label
	                                                ),
	                                                _react2.default.createElement(
	                                                    'button',
	                                                    { type: 'button',
	                                                        className: 'btn ' + this.getFilterBtnClass("all"),
	                                                        onClick: this.setFilterAll },
	                                                    this.state.all_label
	                                                )
	                                            )
	                                        ) : null
	                                    )
	                                ),
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: 'personalised-menu-body', style: this.getHeight() },
	                                    this.state.bites.length > 0 ? _react2.default.createElement(
	                                        'ul',
	                                        { className: 'menu-panel-list' },
	                                        this.state.learningPlan.bites.map(function (menuBiteData) {
	                                            return _react2.default.createElement(
	                                                'li',
	                                                { className: 'panel-item', key: menuBiteData.bite_id },
	                                                _react2.default.createElement(_LearninPlanBitePanel2.default, { menuData: menuBiteData,
	                                                    bite: appHelper.getBiteById(menuBiteData.bite_id),
	                                                    required: appHelper.getArrayObjectByKey(_this2.state.bites, "bite_id", menuBiteData.bite_id).required,
	                                                    filter: _this2.state.filter })
	                                            );
	                                        })
	                                    ) : null
	                                )
	                            )
	                        )
	                    ),
	                    this.props.dialogPopup.render ? _react2.default.createElement(Dialog, null) : null
	                )
	            );
	        }
	    }]);
	
	    return LearningPlanMenu;
	}(_react2.default.Component);
	
	LearningPlanMenu.propTypes = {
	    contentData: _propTypes2.default.object.isRequired,
	    userData: _propTypes2.default.object.isRequired,
	    trackingData: _propTypes2.default.object.isRequired,
	    fontSize: _propTypes2.default.object.isRequired,
	    lang: _propTypes2.default.string.isRequired,
	    dialogPopup: _propTypes2.default.object.isRequired,
	    actions: _propTypes2.default.object.isRequired
	};
	
	LearningPlanMenu.contextTypes = {
	    router: _propTypes2.default.object
	
	};
	
	function mapStateToProps(state, ownProps) {
	    var lang = state.userData.lang;
	    return {
	        lang: lang,
	        contentData: state.contentData,
	        userData: state.userData,
	        trackingData: state.trackingData,
	        fontSize: state.fontSize,
	        dialogPopup: state.dialogPopup
	
	    };
	}
	
	function mapDispatchToProps(dispatch) {
	    return {
	        actions: (0, _redux.bindActionCreators)(Object.assign({}, trackingDataActions), dispatch)
	    };
	}
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(LearningPlanMenu);

/***/ },
/* 471 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(5);
	
	var _redux = __webpack_require__(4);
	
	var _BadgeCollect = __webpack_require__(47);
	
	var _BadgeCollect2 = _interopRequireDefault(_BadgeCollect);
	
	var _Button = __webpack_require__(18);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _appDataActions = __webpack_require__(12);
	
	var appDataActions = _interopRequireWildcard(_appDataActions);
	
	var _trackingDataActions = __webpack_require__(7);
	
	var trackingDataActions = _interopRequireWildcard(_trackingDataActions);
	
	var _dataHelper = __webpack_require__(11);
	
	var dataHelper = _interopRequireWildcard(_dataHelper);
	
	var _appHelper = __webpack_require__(3);
	
	var appHelper = _interopRequireWildcard(_appHelper);
	
	var _kpiHelper = __webpack_require__(35);
	
	var kpiHelper = _interopRequireWildcard(_kpiHelper);
	
	var _userDataHelper = __webpack_require__(15);
	
	var userDataHelper = _interopRequireWildcard(_userDataHelper);
	
	var _objectConstants = __webpack_require__(9);
	
	var objectConstants = _interopRequireWildcard(_objectConstants);
	
	var _localStorage = __webpack_require__(17);
	
	var localStorage = _interopRequireWildcard(_localStorage);
	
	var _gsap = __webpack_require__(8);
	
	var _gsapReactPlugin = __webpack_require__(10);
	
	var _gsapReactPlugin2 = _interopRequireDefault(_gsapReactPlugin);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } //eslint-disable-line import/no-named-as-default
	
	
	var AwardBadge = function (_React$Component) {
	    _inherits(AwardBadge, _React$Component);
	
	    function AwardBadge(props, context) {
	        _classCallCheck(this, AwardBadge);
	
	        var _this = _possibleConstructorReturn(this, (AwardBadge.__proto__ || Object.getPrototypeOf(AwardBadge)).call(this, props, context));
	
	        _this.state = {
	            lang: _this.props.lang,
	            status: objectConstants.STATUS_NOT_STARTED,
	            userData: _this.props.userData,
	            screenObject: _this.props.screenObject,
	            bite_id: _this.props.callbacks.getBiteId(),
	            badgeUserData: _this.props.badgeUserData,
	            locale: appHelper.getLocalData(_this.props.screenObject),
	            badges: appHelper.getArrayObjectByKey(localStorage.bites, "bite_id", _this.props.callbacks.getBiteId()).badges,
	            showAchieved: false,
	            screenStatus: "",
	            checkComplete: false,
	            allowScroll: appHelper.allowScroll(_this.props.callbacks.getBiteId(), _this.props.callbacks.getScreenId(), _this.props.screenObject.asset_id),
	            progressionHandled: false,
	            continue_label: appHelper.getLocaleString("continue_label")
	        };
	
	        _this.show = _this.show.bind(_this);
	        _this.getUserBadge = _this.getUserBadge.bind(_this);
	        _this.onComplete = _this.onComplete.bind(_this);
	        _this.handleProgression = _this.handleProgression.bind(_this);
	        _this.enableProgression = _this.enableProgression.bind(_this);
	        _this.onProgressionBtnClicked = _this.onProgressionBtnClicked.bind(_this);
	        _this.getScreenStatus = _this.getScreenStatus.bind(_this);
	        _this.getObjectStatus = _this.getObjectStatus.bind(_this);
	        _this.onCollected = _this.onCollected.bind(_this);
	        _this.scrollToTop = _this.scrollToTop.bind(_this);
	
	        return _this;
	    }
	
	    _createClass(AwardBadge, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            this.show();
	            this.getScreenStatus();
	            if (appHelper.isDefined(this.props.callbacks.updateCharacterExpression) && appHelper.isDefined(this.state.screenObject.character_pose)) {
	                this.props.callbacks.updateCharacterExpression(this.state.screenObject.character_pose);
	            }
	        }
	    }, {
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(nextProps) {
	            this.setState({
	                lang: nextProps.lang,
	                locale: appHelper.getLocalData(this.state.screenObject),
	                continue_label: appHelper.getLocaleString("continue_label")
	            });
	        }
	    }, {
	        key: 'componentDidUpdate',
	        value: function componentDidUpdate() {
	            if (this.state.checkComplete) {
	                this.onComplete();
	            }
	        }
	    }, {
	        key: 'scrollToTop',
	        value: function scrollToTop() {
	            if (this.state.allowScroll && this.state.status !== objectConstants.STATUS_COMPLETE) {
	                var object = this.refs['award_badge'];
	                var scrollTo = this.props.callbacks.scrollTo;
	                setTimeout(function () {
	                    if (appHelper.isDefined(scrollTo)) {
	                        scrollTo(object.offsetTop);
	                    }
	                }, objectConstants.SCROLL_TO);
	            }
	        }
	    }, {
	        key: 'getUserBadge',
	        value: function getUserBadge(badge) {
	            return appHelper.getArrayObjectByKey(this.state.badgeUserData, "badge_id", badge.badge_id);
	        }
	    }, {
	        key: 'getScreenStatus',
	        value: function getScreenStatus() {
	            var screenStatus = this.props.callbacks.getScreenStatus();
	            this.setState({
	                screenStatus: screenStatus,
	                status: screenStatus === objectConstants.STATUS_COMPLETE ? objectConstants.STATUS_COMPLETE : this.state.status
	            });
	        }
	    }, {
	        key: 'getObjectStatus',
	        value: function getObjectStatus() {
	            if (this.state.screenStatus === objectConstants.STATUS_COMPLETE) {
	                this.onComplete();
	            } else {
	                var objectUserData = {};
	                if (this.state.status !== objectConstants.STATUS_COMPLETE) {
	                    var subScreenParent = this.props.callbacks.getSubScreenParent();
	                    var screen_id = this.props.callbacks.getScreenId();
	                    if (appHelper.isDefined(subScreenParent)) {
	                        objectUserData = userDataHelper.getSubScreenObjectStatus(this.state.userData, subScreenParent.screen_id, screen_id, this.state.screenObject.asset_id);
	                    } else {
	                        objectUserData = userDataHelper.getObjectStatus(this.state.userData, screen_id, this.state.screenObject.asset_id);
	                    }
	                }
	                if (objectUserData.status === objectConstants.STATUS_COMPLETE) {
	                    this.setState({ status: objectConstants.STATUS_COMPLETE, checkComplete: true });
	                }
	            }
	        }
	    }, {
	        key: 'onObjectComplete',
	        value: function onObjectComplete(kpi) {
	            var index = appHelper.getArrayObjectIndexByKey(this.state.completeObjects, "kpi_id", kpi.kpi_id);
	            if (index === -1) {
	                this.setState({
	                    completeObjects: dataHelper.immutablePush(this.state.completeObjects, kpi),
	                    status: objectConstants.STATUS_IN_PROGRESS
	                });
	            }
	        }
	    }, {
	        key: 'onComplete',
	        value: function onComplete() {
	            //console.log('onComplete');
	            this.setState({ checkComplete: false });
	            var hasNextObject = this.props.callbacks.hasNextObject(this.props.index);
	            if (appHelper.isDefined(this.state.screenObject.progression) && this.state.screenObject.progression === objectConstants.OBJECT_PROGRESSION_CONTINUE && (this.state.status !== objectConstants.STATUS_COMPLETE || !hasNextObject)) {
	                if (!hasNextObject) {
	                    this.handleProgression();
	                    this.enableProgression();
	                } else {
	                    this.enableProgression();
	                }
	            } else {
	                this.handleProgression();
	            }
	            this.scrollToTop();
	        }
	    }, {
	        key: 'onCollected',
	        value: function onCollected() {
	            this.setState({ checkComplete: true, status: objectConstants.STATUS_COMPLETE });
	        }
	    }, {
	        key: 'enableProgression',
	        value: function enableProgression() {
	            if (!this.props.callbacks.isReviewMode()) {
	                this.setState({ showProgressionButton: true });
	            }
	        }
	    }, {
	        key: 'handleProgression',
	        value: function handleProgression() {
	
	            if (!this.state.progressionHandled) {
	                this.setState({ progressionHandled: true });
	                var progressionRule = appHelper.isDefined(this.state.screenObject.progression) ? this.state.screenObject.progression : objectConstants.OBJECT_PROGRESSION_CONTINUE;
	                var progressionType = appHelper.isDefined(this.state.screenObject.progression_type) ? this.state.screenObject.progression_type : undefined;
	                var progressionGoToId = appHelper.isDefined(this.state.screenObject.progression_goto_id) ? this.state.screenObject.progression_goto_id : undefined;
	                var completionData = {
	                    progression: progressionRule,
	                    progressionType: progressionType,
	                    progressionGoToId: progressionGoToId,
	                    asset_id: this.state.screenObject.asset_id,
	                    status: objectConstants.STATUS_COMPLETE,
	                    asset_type_code: this.state.screenObject.asset_type_code,
	                    navigateToNextScreen: appHelper.isDefined(this.state.screenObject.progression) && this.state.screenObject.progression === objectConstants.OBJECT_PROGRESSION_CONTINUE,
	                    index: this.props.index
	                };
	
	                this.props.callbacks.onObjectComplete(completionData);
	            }
	        }
	    }, {
	        key: 'onProgressionBtnClicked',
	        value: function onProgressionBtnClicked() {
	            this.setState({ showProgressionButton: false });
	            if (this.props.callbacks.hasNextObject(this.props.index)) {
	                this.handleProgression();
	            } else {
	                this.props.callbacks.navigateToNextScreen();
	            }
	        }
	    }, {
	        key: 'show',
	        value: function show() {
	            var badgeRef = this.refs.award_badge;
	            if (appHelper.isDefined(badgeRef)) {
	                _gsap.TweenLite.set(badgeRef, { opacity: 1, height: "auto" });
	                _gsap.TweenLite.from(badgeRef, objectConstants.SHOW_PANEL_DURATION, {
	                    height: 0,
	                    ease: _gsap.Expo.easeInOut
	                }).eventCallback("onComplete", this.getObjectStatus);
	            }
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	
	            return _react2.default.createElement(
	                'div',
	                { className: 'object-container', ref: 'award_badge' },
	                _react2.default.createElement(_BadgeCollect2.default, { badge_id: this.state.screenObject.badge_id, bite_id: this.props.callbacks.getBiteId(), asset_id: this.state.screenObject.asset_id, onCollected: this.onCollected }),
	                this.state.showProgressionButton ? _react2.default.createElement(_Button2.default, { label: this.state.continue_label,
	                    id: this.state.screenObject + '_button',
	                    onClick: this.onProgressionBtnClicked }) : null
	            );
	        }
	    }]);
	
	    return AwardBadge;
	}(_react2.default.Component);
	
	AwardBadge.propTypes = {
	    screenObject: _propTypes2.default.object.isRequired,
	    badgeUserData: _propTypes2.default.array.isRequired,
	    callbacks: _propTypes2.default.object.isRequired,
	    index: _propTypes2.default.number,
	    userData: _propTypes2.default.object,
	    lang: _propTypes2.default.string.isRequired,
	    trackingData: _propTypes2.default.object
	};
	
	AwardBadge.contextTypes = {
	    router: _propTypes2.default.object
	};
	
	function mapStateToProps(state, ownProps) {
	    var lang = state.userData.lang;
	    return {
	        lang: lang,
	        userData: state.userData,
	        trackingData: state.trackingData,
	        badgeUserData: appHelper.getArrayObjectByKey(state.userData.bites, "bite_id", ownProps.callbacks.getBiteId()).badges
	
	    };
	}
	
	function mapDispatchToProps(dispatch) {
	    return {
	        actions: (0, _redux.bindActionCreators)(Object.assign({}, trackingDataActions, appDataActions), dispatch)
	    };
	}
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(AwardBadge);

/***/ },
/* 472 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRouter = __webpack_require__(45);
	
	var _reactRedux = __webpack_require__(5);
	
	var _redux = __webpack_require__(4);
	
	var _Badge = __webpack_require__(135);
	
	var _Badge2 = _interopRequireDefault(_Badge);
	
	var _appDataActions = __webpack_require__(12);
	
	var appDataActions = _interopRequireWildcard(_appDataActions);
	
	var _trackingDataActions = __webpack_require__(7);
	
	var trackingDataActions = _interopRequireWildcard(_trackingDataActions);
	
	var _localStorage = __webpack_require__(17);
	
	var localStorage = _interopRequireWildcard(_localStorage);
	
	var _appHelper = __webpack_require__(3);
	
	var appHelper = _interopRequireWildcard(_appHelper);
	
	var _appConstants = __webpack_require__(13);
	
	var appConstants = _interopRequireWildcard(_appConstants);
	
	var _componentHelper = __webpack_require__(31);
	
	var _componentConstants = __webpack_require__(49);
	
	var _gsap = __webpack_require__(8);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var BadgeDescription = function (_React$Component) {
	    _inherits(BadgeDescription, _React$Component);
	
	    function BadgeDescription(props, context) {
	        _classCallCheck(this, BadgeDescription);
	
	        var _this = _possibleConstructorReturn(this, (BadgeDescription.__proto__ || Object.getPrototypeOf(BadgeDescription)).call(this, props, context));
	
	        _this.state = {
	            lang: _this.props.lang,
	            badge: _this.props.badge,
	            userBadge: _this.props.userBadge,
	            showAchievedCount: false,
	            showAchievedState: false,
	            locale: {}
	        };
	        _this.getLocale = _this.getLocale.bind(_this);
	        _this.handleProgression = _this.handleProgression.bind(_this);
	        return _this;
	    }
	
	    _createClass(BadgeDescription, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            this.getLocale();
	        }
	    }, {
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(nextProps) {
	            if (this.state.userBadge !== nextProps.userBadge) {
	                this.setState({ userBadge: Object.assign({}, nextProps.userBadge) });
	            }
	            if (this.state.lang !== nextProps.lang) {
	                this.setState({
	                    lang: nextProps.lang,
	                    locale: appHelper.getLocalData(this.state.badge)
	                });
	            }
	        }
	    }, {
	        key: 'getLocale',
	        value: function getLocale() {
	            var locale = appHelper.getLocalData(this.state.badge);
	            this.setState({ locale: Object.assign({}, locale) });
	        }
	    }, {
	        key: 'handleProgression',
	        value: function handleProgression() {}
	    }, {
	        key: 'render',
	        value: function render() {
	            return _react2.default.createElement(
	                'div',
	                { className: 'kpi-overview-row' },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'kpi-meter-col' },
	                    _react2.default.createElement(_Badge2.default, { badge: this.state.badge,
	                        userBadge: this.state.userBadge,
	                        showAchievedCount: this.state.showAchievedCount,
	                        showAchievedState: this.state.showAchievedState })
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'kpi-content-col' },
	                    appHelper.isDefined(this.state.locale.long_title) && this.state.locale.long_title !== null && this.state.locale.long_title.length > 0 ? _react2.default.createElement(
	                        'h4',
	                        null,
	                        _react2.default.createElement(
	                            'strong',
	                            null,
	                            this.state.locale.long_title
	                        )
	                    ) : null,
	                    appHelper.isDefined(this.state.locale.description) && this.state.locale.description !== null && this.state.locale.description.length > 0 ? _react2.default.createElement('div', { dangerouslySetInnerHTML: { __html: this.state.locale.description } }) : null
	                )
	            );
	        }
	    }]);
	
	    return BadgeDescription;
	}(_react2.default.Component);
	
	BadgeDescription.propTypes = {
	    badge: _propTypes2.default.object.isRequired,
	    userBadge: _propTypes2.default.object.isRequired,
	    showAchieved: _propTypes2.default.bool.isRequired,
	    bite_id: _propTypes2.default.number,
	    lang: _propTypes2.default.string.isRequired,
	    actions: _propTypes2.default.object.isRequired
	};
	
	BadgeDescription.contextTypes = {
	    router: _propTypes2.default.object
	};
	
	function mapStateToProps(state, ownProps) {
	    var lang = state.userData.lang;
	    return {
	        lang: lang,
	        badgeUserData: appHelper.getArrayObjectByKey(state.userData.bites, "bite_id", ownProps.bite_id).badges
	    };
	}
	
	function mapDispatchToProps(dispatch) {
	    return {
	        actions: (0, _redux.bindActionCreators)(Object.assign({}, trackingDataActions, appDataActions), dispatch)
	    };
	}
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(BadgeDescription);

/***/ },
/* 473 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(5);
	
	var _redux = __webpack_require__(4);
	
	var _BadgeDescription = __webpack_require__(472);
	
	var _BadgeDescription2 = _interopRequireDefault(_BadgeDescription);
	
	var _Button = __webpack_require__(18);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _appDataActions = __webpack_require__(12);
	
	var appDataActions = _interopRequireWildcard(_appDataActions);
	
	var _trackingDataActions = __webpack_require__(7);
	
	var trackingDataActions = _interopRequireWildcard(_trackingDataActions);
	
	var _dataHelper = __webpack_require__(11);
	
	var dataHelper = _interopRequireWildcard(_dataHelper);
	
	var _appHelper = __webpack_require__(3);
	
	var appHelper = _interopRequireWildcard(_appHelper);
	
	var _kpiHelper = __webpack_require__(35);
	
	var kpiHelper = _interopRequireWildcard(_kpiHelper);
	
	var _userDataHelper = __webpack_require__(15);
	
	var userDataHelper = _interopRequireWildcard(_userDataHelper);
	
	var _objectConstants = __webpack_require__(9);
	
	var objectConstants = _interopRequireWildcard(_objectConstants);
	
	var _localStorage = __webpack_require__(17);
	
	var localStorage = _interopRequireWildcard(_localStorage);
	
	var _gsap = __webpack_require__(8);
	
	var _gsapReactPlugin = __webpack_require__(10);
	
	var _gsapReactPlugin2 = _interopRequireDefault(_gsapReactPlugin);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } //eslint-disable-line import/no-named-as-default
	
	
	var BadgeOverview = function (_React$Component) {
	    _inherits(BadgeOverview, _React$Component);
	
	    function BadgeOverview(props, context) {
	        _classCallCheck(this, BadgeOverview);
	
	        var _this = _possibleConstructorReturn(this, (BadgeOverview.__proto__ || Object.getPrototypeOf(BadgeOverview)).call(this, props, context));
	
	        _this.state = {
	            lang: _this.props.lang,
	            status: objectConstants.STATUS_NOT_STARTED,
	            userData: _this.props.userData,
	            screenObject: _this.props.screenObject,
	            bite_id: _this.props.callbacks.getBiteId(),
	            badgeUserData: _this.props.badgeUserData,
	            locale: appHelper.getLocalData(_this.props.screenObject),
	            badges: _this.props.badges,
	            showAchieved: false,
	            screenStatus: "",
	            checkComplete: false,
	            allowScroll: appHelper.allowScroll(_this.props.callbacks.getBiteId(), _this.props.callbacks.getScreenId(), _this.props.screenObject.asset_id),
	            continue_label: appHelper.getLocaleString("continue_label")
	        };
	
	        _this.show = _this.show.bind(_this);
	        _this.getUserBadge = _this.getUserBadge.bind(_this);
	        _this.onComplete = _this.onComplete.bind(_this);
	        _this.handleProgression = _this.handleProgression.bind(_this);
	        _this.enableProgression = _this.enableProgression.bind(_this);
	        _this.onProgressionBtnClicked = _this.onProgressionBtnClicked.bind(_this);
	        _this.getScreenStatus = _this.getScreenStatus.bind(_this);
	        _this.getObjectStatus = _this.getObjectStatus.bind(_this);
	        _this.scrollToTop = _this.scrollToTop.bind(_this);
	
	        return _this;
	    }
	
	    _createClass(BadgeOverview, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            this.show();
	            this.getScreenStatus();
	            if (appHelper.isDefined(this.props.callbacks.updateCharacterExpression) && appHelper.isDefined(this.state.screenObject.character_pose)) {
	                this.props.callbacks.updateCharacterExpression(this.state.screenObject.character_pose);
	            }
	        }
	    }, {
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(nextProps) {
	            if (this.state.lang !== nextProps.lang) {
	                this.setState({
	                    lang: nextProps.lang,
	                    locale: appHelper.getLocalData(this.state.screenObject),
	                    continue_label: appHelper.getLocaleString("continue_label")
	                });
	            }
	        }
	    }, {
	        key: 'componentDidUpdate',
	        value: function componentDidUpdate() {
	            if (this.state.checkComplete) {
	                this.onComplete();
	            }
	        }
	    }, {
	        key: 'scrollToTop',
	        value: function scrollToTop() {
	            if (this.state.allowScroll && this.state.status !== objectConstants.STATUS_COMPLETE) {
	                var object = this.refs['badge_overview'];
	                var scrollTo = this.props.callbacks.scrollTo;
	                setTimeout(function () {
	                    if (appHelper.isDefined(scrollTo)) {
	                        scrollTo(object.offsetTop);
	                    }
	                }, objectConstants.SCROLL_TO);
	            }
	        }
	    }, {
	        key: 'getUserBadge',
	        value: function getUserBadge(badge) {
	            return appHelper.getArrayObjectByKey(this.state.badgeUserData, "badge_id", badge.badge_id);
	        }
	    }, {
	        key: 'getScreenStatus',
	        value: function getScreenStatus() {
	            var screenStatus = this.props.callbacks.getScreenStatus();
	            this.setState({
	                screenStatus: screenStatus,
	                status: screenStatus === objectConstants.STATUS_COMPLETE ? objectConstants.STATUS_COMPLETE : this.state.status
	            });
	        }
	    }, {
	        key: 'getObjectStatus',
	        value: function getObjectStatus() {
	            if (this.state.screenStatus === objectConstants.STATUS_COMPLETE) {
	                this.onComplete();
	            } else {
	                var objectUserData = {};
	                if (this.state.status !== objectConstants.STATUS_COMPLETE) {
	                    var subScreenParent = this.props.callbacks.getSubScreenParent();
	                    var screen_id = this.props.callbacks.getScreenId();
	                    if (appHelper.isDefined(subScreenParent)) {
	                        objectUserData = userDataHelper.getSubScreenObjectStatus(this.state.userData, subScreenParent.screen_id, screen_id, this.state.screenObject.asset_id);
	                    } else {
	                        objectUserData = userDataHelper.getObjectStatus(this.state.userData, screen_id, this.state.screenObject.asset_id);
	                    }
	                }
	                if (objectUserData.status === objectConstants.STATUS_COMPLETE) {
	                    this.setState({ status: objectConstants.STATUS_COMPLETE, checkComplete: true });
	                } else {
	                    this.setState({ checkComplete: true });
	                }
	            }
	        }
	    }, {
	        key: 'onObjectComplete',
	        value: function onObjectComplete(kpi) {
	            var index = appHelper.getArrayObjectIndexByKey(this.state.completeObjects, "kpi_id", kpi.kpi_id);
	            if (index === -1) {
	                this.setState({
	                    completeObjects: dataHelper.immutablePush(this.state.completeObjects, kpi),
	                    status: objectConstants.STATUS_IN_PROGRESS
	                });
	            }
	        }
	    }, {
	        key: 'onComplete',
	        value: function onComplete() {
	            this.setState({ checkComplete: false });
	            var hasNextObject = this.props.callbacks.hasNextObject(this.props.index);
	            if (appHelper.isDefined(this.state.screenObject.progression) && this.state.screenObject.progression === objectConstants.OBJECT_PROGRESSION_CONTINUE && (this.state.status !== objectConstants.STATUS_COMPLETE || !hasNextObject)) {
	                if (!hasNextObject) {
	                    this.handleProgression();
	                    this.enableProgression();
	                } else {
	                    this.enableProgression();
	                }
	            } else {
	                this.handleProgression();
	            }
	            this.scrollToTop();
	        }
	    }, {
	        key: 'enableProgression',
	        value: function enableProgression() {
	            if (!this.props.callbacks.isReviewMode()) {
	                this.setState({ showProgressionButton: true });
	            }
	        }
	    }, {
	        key: 'handleProgression',
	        value: function handleProgression() {
	            var progressionRule = appHelper.isDefined(this.state.screenObject.progression) ? this.state.screenObject.progression : objectConstants.OBJECT_PROGRESSION_CONTINUE;
	            var progressionType = appHelper.isDefined(this.state.screenObject.progression_type) ? this.state.screenObject.progression_type : undefined;
	            var progressionGoToId = appHelper.isDefined(this.state.screenObject.progression_goto_id) ? this.state.screenObject.progression_goto_id : undefined;
	            var completionData = {
	                progression: progressionRule,
	                progressionType: progressionType,
	                progressionGoToId: progressionGoToId,
	                asset_id: this.state.screenObject.asset_id,
	                status: objectConstants.STATUS_COMPLETE,
	                asset_type_code: this.state.screenObject.asset_type_code,
	                navigateToNextScreen: appHelper.isDefined(this.state.screenObject.progression) && this.state.screenObject.progression === objectConstants.OBJECT_PROGRESSION_CONTINUE,
	                index: this.props.index
	            };
	
	            this.props.callbacks.onObjectComplete(completionData);
	        }
	    }, {
	        key: 'onProgressionBtnClicked',
	        value: function onProgressionBtnClicked() {
	            this.setState({ showProgressionButton: false });
	            if (this.props.callbacks.hasNextObject(this.props.index)) {
	                this.handleProgression();
	            } else {
	                this.props.callbacks.navigateToNextScreen();
	            }
	        }
	    }, {
	        key: 'show',
	        value: function show() {
	            var badgeRef = this.refs.badge_overview;
	            if (appHelper.isDefined(badgeRef)) {
	                _gsap.TweenLite.set(badgeRef, { opacity: 1, height: "auto" });
	                _gsap.TweenLite.from(badgeRef, objectConstants.SHOW_PANEL_DURATION, {
	                    height: 0,
	                    ease: _gsap.Expo.easeInOut
	                }).eventCallback("onComplete", this.getObjectStatus);
	            }
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this2 = this;
	
	            return _react2.default.createElement(
	                'div',
	                { className: 'object-container', ref: 'badge_overview' },
	                this.state.screenObject.show_title && this.state.locale.label !== null && appHelper.isDefined(this.state.locale.label) ? _react2.default.createElement('h4', { className: 'bold', dangerouslySetInnerHTML: { __html: this.state.locale.label } }) : null,
	                appHelper.isDefined(this.state.locale.description) && this.state.locale.description !== null && this.state.locale.description.length > 0 ? _react2.default.createElement('div', { dangerouslySetInnerHTML: { __html: this.state.locale.description } }) : null,
	                _react2.default.createElement('br', null),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'kpi-overview-panel' },
	                    this.state.badges.map(function (badge) {
	                        return _react2.default.createElement(_BadgeDescription2.default, { key: badge.badge_id, badge: badge, userBadge: _this2.getUserBadge(badge), showAchieved: _this2.state.showAchieved, bite_id: _this2.state.bite_id });
	                    })
	                ),
	                this.state.showProgressionButton ? _react2.default.createElement(_Button2.default, { label: this.state.continue_label,
	                    id: this.state.screenObject + '_button',
	                    onClick: this.onProgressionBtnClicked }) : null
	            );
	        }
	    }]);
	
	    return BadgeOverview;
	}(_react2.default.Component);
	
	BadgeOverview.propTypes = {
	    screenObject: _propTypes2.default.object.isRequired,
	    badges: _propTypes2.default.array.isRequired,
	    badgeUserData: _propTypes2.default.array.isRequired,
	    callbacks: _propTypes2.default.object.isRequired,
	    index: _propTypes2.default.number,
	    userData: _propTypes2.default.object,
	    lang: _propTypes2.default.string.isRequired,
	    trackingData: _propTypes2.default.object
	};
	
	BadgeOverview.contextTypes = {
	    router: _propTypes2.default.object
	};
	
	function mapStateToProps(state, ownProps) {
	    var badges = ownProps.screenObject.display_method === objectConstants.DISPLAY_ALL_BADGES ? appHelper.getAllBadges() : appHelper.getArrayObjectByKey(localStorage.bites, "bite_id", ownProps.callbacks.getBiteId()).badges;
	    var badgeUserData = ownProps.screenObject.display_method === objectConstants.DISPLAY_ALL_BADGES ? userDataHelper.getAllUserBadges(state.userData) : appHelper.getArrayObjectByKey(state.userData.bites, "bite_id", ownProps.callbacks.getBiteId()).badges;
	    var lang = state.userData.lang;
	    return {
	        lang: lang,
	        userData: state.userData,
	        trackingData: state.trackingData,
	        badges: badges,
	        badgeUserData: badgeUserData
	
	    };
	}
	
	function mapDispatchToProps(dispatch) {
	    return {
	        actions: (0, _redux.bindActionCreators)(Object.assign({}, trackingDataActions, appDataActions), dispatch)
	    };
	}
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(BadgeOverview);

/***/ },
/* 474 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRouter = __webpack_require__(45);
	
	var _reactRedux = __webpack_require__(5);
	
	var _redux = __webpack_require__(4);
	
	var _appDataActions = __webpack_require__(12);
	
	var appDataActions = _interopRequireWildcard(_appDataActions);
	
	var _trackingDataActions = __webpack_require__(7);
	
	var trackingDataActions = _interopRequireWildcard(_trackingDataActions);
	
	var _badgeHelper = __webpack_require__(201);
	
	var badgeHelper = _interopRequireWildcard(_badgeHelper);
	
	var _appHelper = __webpack_require__(3);
	
	var appHelper = _interopRequireWildcard(_appHelper);
	
	var _keyboardConstants = __webpack_require__(14);
	
	var keyboardConstants = _interopRequireWildcard(_keyboardConstants);
	
	var _localStorage = __webpack_require__(17);
	
	var localStorage = _interopRequireWildcard(_localStorage);
	
	var _componentConstants = __webpack_require__(49);
	
	var _gsap = __webpack_require__(8);
	
	var _reactDom = __webpack_require__(55);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var BadgeButton = function (_React$Component) {
	    _inherits(BadgeButton, _React$Component);
	
	    function BadgeButton(props, context) {
	        _classCallCheck(this, BadgeButton);
	
	        var _this = _possibleConstructorReturn(this, (BadgeButton.__proto__ || Object.getPrototypeOf(BadgeButton)).call(this, props, context));
	
	        _this.state = {
	            badges: _this.props.badges,
	            totalAchieved: 0,
	            updateBadges: false,
	            ariaHasPopup: true,
	            lang: _this.props.lang,
	            label: appHelper.getLocaleString("badges_label"),
	            collected_label: appHelper.getLocaleString("collected_label")
	        };
	        _this.setBtnClass = _this.setBtnClass.bind(_this);
	        _this.setBadgeCount = _this.setBadgeCount.bind(_this);
	        _this.setKeyboardAccessibility = _this.setKeyboardAccessibility.bind(_this);
	        _this.onClickFunc = _this.onClickFunc.bind(_this);
	        return _this;
	    }
	
	    _createClass(BadgeButton, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            this.setBadgeCount();
	        }
	    }, {
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(nextProps) {
	            if (this.state.badges !== nextProps.badges) {
	                this.setState({
	                    badges: Object.assign([], nextProps.badges),
	                    updateBadges: true
	                });
	            }
	
	            if (this.state.lang !== nextProps.lang) {
	                this.setState({
	                    lang: nextProps.lang,
	                    label: appHelper.getLocaleString("badges_label"),
	                    collected_label: appHelper.getLocaleString("collected_label")
	                });
	            }
	        }
	    }, {
	        key: 'componentDidUpdate',
	        value: function componentDidUpdate() {
	            if (this.state.updateBadges) {
	                this.setBadgeCount();
	            }
	        }
	    }, {
	        key: 'setBadgeCount',
	        value: function setBadgeCount() {
	            this.setState({
	                updateBadges: false,
	                totalAchieved: badgeHelper.getTotalAchievedCount(this.state.badges)
	            });
	        }
	    }, {
	        key: 'setBtnClass',
	        value: function setBtnClass() {
	            return this.props.disabled ? "disabled" : "";
	        }
	    }, {
	        key: 'onClickFunc',
	        value: function onClickFunc() {
	            this.props.onClickFunc("badgesBtn");
	        }
	    }, {
	        key: 'setKeyboardAccessibility',
	        value: function setKeyboardAccessibility(event) {
	            if (event.which === keyboardConstants.ENTER_KEY || event.which === keyboardConstants.SPACEBAR_KEY) {
	                event.preventDefault();
	                this.onClickFunc();
	            }
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            return _react2.default.createElement(
	                'div',
	                { className: 'header-btn badge-btn ' + this.setBtnClass(), onClick: this.onClickFunc, onKeyDown: this.setKeyboardAccessibility, role: 'link', tabIndex: !this.props.disabled ? "0" : "-1", id: 'badgesBtn', 'aria-controls': 'performance', title: this.state.label, 'aria-haspopup': this.state.ariaHasPopup, 'aria-disabled': this.props.disabled },
	                appHelper.isDefined(localStorage.contentData.experience.badge_shape) && localStorage.contentData.experience.badge_shape === "circle" ? _react2.default.createElement('div', { className: 'icon icons8-radio-answered', role: 'presentation' }) : _react2.default.createElement('div', { className: 'icon icons8-achievement-filled', role: 'presentation' }),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'badge-count' },
	                    _react2.default.createElement(
	                        'span',
	                        { className: 'status-indicator' },
	                        this.state.totalAchieved
	                    )
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'btn-label' },
	                    this.state.label,
	                    ' ',
	                    _react2.default.createElement(
	                        'span',
	                        { className: 'hidden-el' },
	                        this.state.collected_label
	                    )
	                )
	            );
	        }
	    }]);
	
	    return BadgeButton;
	}(_react2.default.Component);
	/*
	*  {this.state.showToolTip && !this.props.disabled
	                    ? <div className="tool-tip-pointer badge-tool-tip"/>
	                    : null
	                }*/
	
	
	BadgeButton.propTypes = {
	    onClickFunc: _propTypes2.default.func.isRequired,
	    disabled: _propTypes2.default.bool.isRequired,
	    badges: _propTypes2.default.array.isRequired,
	    bite_id: _propTypes2.default.number,
	    lang: _propTypes2.default.string.isRequired,
	    actions: _propTypes2.default.object.isRequired
	};
	
	BadgeButton.contextTypes = {
	    router: _propTypes2.default.object
	};
	
	function mapStateToProps(state, ownProps) {
	    var lang = state.userData.lang;
	    return {
	        badges: appHelper.getArrayObjectByKey(state.userData.bites, "bite_id", ownProps.bite_id).badges,
	        lang: lang
	    };
	}
	
	function mapDispatchToProps(dispatch) {
	    return {
	        actions: (0, _redux.bindActionCreators)(Object.assign({}, trackingDataActions, appDataActions), dispatch)
	    };
	}
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(BadgeButton);

/***/ },
/* 475 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(5);
	
	var _redux = __webpack_require__(4);
	
	var _CharacterSpeak = __webpack_require__(196);
	
	var _CharacterSpeak2 = _interopRequireDefault(_CharacterSpeak);
	
	var _LearnerSpeak = __webpack_require__(197);
	
	var _LearnerSpeak2 = _interopRequireDefault(_LearnerSpeak);
	
	var _Button = __webpack_require__(18);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _appDataActions = __webpack_require__(12);
	
	var appDataActions = _interopRequireWildcard(_appDataActions);
	
	var _trackingDataActions = __webpack_require__(7);
	
	var trackingDataActions = _interopRequireWildcard(_trackingDataActions);
	
	var _appHelper = __webpack_require__(3);
	
	var appHelper = _interopRequireWildcard(_appHelper);
	
	var _objectConstants = __webpack_require__(9);
	
	var objectConstants = _interopRequireWildcard(_objectConstants);
	
	var _dataHelper = __webpack_require__(11);
	
	var dataHelper = _interopRequireWildcard(_dataHelper);
	
	var _userDataHelper = __webpack_require__(15);
	
	var userDataHelper = _interopRequireWildcard(_userDataHelper);
	
	var _appConstants = __webpack_require__(13);
	
	var appConstants = _interopRequireWildcard(_appConstants);
	
	var _gsap = __webpack_require__(8);
	
	var _gsapReactPlugin = __webpack_require__(10);
	
	var _gsapReactPlugin2 = _interopRequireDefault(_gsapReactPlugin);
	
	var _componentHelper = __webpack_require__(31);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } //eslint-disable-line import/no-named-as-default
	//eslint-disable-line import/no-named-as-default
	//eslint-disable-line import/no-named-as-default
	
	
	var ConversationDialog = function (_React$Component) {
	    _inherits(ConversationDialog, _React$Component);
	
	    function ConversationDialog(props, context) {
	        _classCallCheck(this, ConversationDialog);
	
	        var _this = _possibleConstructorReturn(this, (ConversationDialog.__proto__ || Object.getPrototypeOf(ConversationDialog)).call(this, props, context));
	
	        _this.state = {
	            lang: _this.props.lang,
	            initialised: false,
	            userData: _this.props.userData,
	            status: objectConstants.STATUS_NOT_STARTED,
	            screenObject: _this.props.screenObject,
	            locale: appHelper.getLocalData(_this.props.screenObject),
	            renderedDialogs: [],
	            responseData: {
	                latestResponse: {}
	            },
	            callbacks: {},
	
	            showProgressionButton: false,
	            maxSpeechCounter: 2,
	            speechCounter: 0,
	            currentIndex: 0,
	            showStepProgressionButton: false,
	            speechDelay: 0.2,
	            readyForNextBubble: false,
	            screenStatus: "",
	            allowScroll: appHelper.allowScroll(_this.props.callbacks.getBiteId(), _this.props.callbacks.getScreenId(), _this.props.screenObject.asset_id),
	            continue_label: appHelper.getLocaleString("continue_label"),
	            progressionHandled: false
	        };
	
	        _this.handleProgression = _this.handleProgression.bind(_this);
	        _this.scrollToTop = _this.scrollToTop.bind(_this);
	        _this.onComplete = _this.onComplete.bind(_this);
	        _this.enableProgression = _this.enableProgression.bind(_this);
	        _this.setDialog = _this.setDialog.bind(_this);
	        _this.setCallbacks = _this.setCallbacks.bind(_this);
	        _this.onObjectComplete = _this.onObjectComplete.bind(_this);
	        _this.onProgressionBtnClicked = _this.onProgressionBtnClicked.bind(_this);
	        _this.onStepProgressionBtnClicked = _this.onStepProgressionBtnClicked.bind(_this);
	        _this.getScreenStatus = _this.getScreenStatus.bind(_this);
	        _this.getSpeechDelay = _this.getSpeechDelay.bind(_this);
	        _this.getObjectStatus = _this.getObjectStatus.bind(_this);
	        _this.getAssets = _this.getAssets.bind(_this);
	        _this.getImagePath = _this.getImagePath.bind(_this);
	
	        return _this;
	    }
	
	    _createClass(ConversationDialog, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            this.getAssets();
	            this.setCallbacks();
	            this.setDialog(0);
	            if (appHelper.isDefined(this.props.callbacks.updateCharacterExpression) && appHelper.isDefined(this.state.screenObject.character_pose)) {
	                this.props.callbacks.updateCharacterExpression(this.state.screenObject.character_pose);
	            }
	            this.getScreenStatus();
	            this.scrollToTop();
	            this.getObjectStatus();
	        }
	    }, {
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(nextProps) {
	            this.getScreenStatus();
	            this.getObjectStatus();
	            if (this.state.userData !== nextProps.userData) {
	                this.setState({ userData: Object.assign({}, nextProps.userData) });
	            }
	            if (this.state.lang !== nextProps.lang) {
	                this.setState({
	                    lang: nextProps.lang,
	                    locale: appHelper.getLocalData(this.state.screenObject),
	                    continue_label: appHelper.getLocaleString("continue_label")
	                });
	            }
	        }
	    }, {
	        key: 'componentDidUpdate',
	        value: function componentDidUpdate() {
	            if (this.state.readyForNextBubble) {
	                this.setDialog(this.state.currentIndex);
	            }
	        }
	    }, {
	        key: 'getAssets',
	        value: function getAssets() {
	            var objectUserData = {};
	            if (this.state.status !== objectConstants.STATUS_COMPLETE) {
	                var subScreenParent = this.props.callbacks.getSubScreenParent();
	                var screen_id = this.props.callbacks.getScreenId();
	                if (appHelper.isDefined(subScreenParent)) {
	                    objectUserData = userDataHelper.getSubScreenObjectStatus(this.state.userData, subScreenParent.screen_id, screen_id, this.state.screenObject.asset_id);
	                } else if (this.state.isResourceObject) {
	                    objectUserData = userDataHelper.getResourceScreenObjectUserData(this.state.userData, screen_id, this.state.screenObject.asset_id);
	                } else {
	                    objectUserData = userDataHelper.getObjectStatus(this.state.userData, screen_id, this.state.screenObject.asset_id);
	                }
	            }
	
	            if (appHelper.isDefined(this.state.screenObject.audio)) {
	                var audio = appHelper.getAudioAsset(this.state.screenObject.audio);
	                var audioObj = {
	                    audioRef: 'audio_' + audio.id + '_' + audio.type
	                };
	
	                if (objectUserData.status !== objectConstants.STATUS_COMPLETE) {
	                    this.props.actions.setAudio(audioObj);
	                }
	            }
	        }
	    }, {
	        key: 'getObjectStatus',
	        value: function getObjectStatus() {
	            var objectUserData = {};
	            if (this.state.status !== objectConstants.STATUS_COMPLETE) {
	                var subScreenParent = this.props.callbacks.getSubScreenParent();
	                var screen_id = this.props.callbacks.getScreenId();
	                if (appHelper.isDefined(subScreenParent)) {
	                    objectUserData = userDataHelper.getSubScreenObjectStatus(this.state.userData, subScreenParent.screen_id, screen_id, this.state.screenObject.asset_id);
	                } else {
	                    objectUserData = userDataHelper.getObjectStatus(this.state.userData, screen_id, this.state.screenObject.asset_id);
	                }
	            }
	
	            if (objectUserData.status === objectConstants.STATUS_COMPLETE) {
	                this.setState({ status: objectConstants.STATUS_COMPLETE });
	            }
	        }
	    }, {
	        key: 'setCallbacks',
	        value: function setCallbacks() {
	            this.setState({
	                callbacks: Object.assign({}, this.props.callbacks, {
	                    onObjectComplete: this.onObjectComplete
	                })
	            });
	        }
	    }, {
	        key: 'getScreenStatus',
	        value: function getScreenStatus() {
	            var screenStatus = this.props.callbacks.getScreenStatus();
	            this.setState({
	                screenStatus: screenStatus,
	                status: screenStatus === objectConstants.STATUS_COMPLETE ? objectConstants.STATUS_COMPLETE : this.state.status
	            });
	        }
	    }, {
	        key: 'onObjectComplete',
	        value: function onObjectComplete(index) {
	            var nextIndex = index + 1;
	            if (nextIndex < this.state.screenObject.dialogs.length) {
	                /*if(this.state.speechCounter + 1 >= this.state.maxSpeechCounter && this.state.status !== objectConstants.STATUS_COMPLETE){
	                    this.setState({
	                        //showStepProgressionButton: true,
	                        showStepProgressionButton: false,
	                        currentIndex: nextIndex
	                    });
	                }else{*/
	                this.scrollToTop();
	                this.setState({
	                    currentIndex: nextIndex,
	                    readyForNextBubble: true,
	                    speechCounter: this.state.speechCounter + 1
	                });
	                /* }*/
	            } else {
	                this.onComplete();
	            }
	        }
	    }, {
	        key: 'setDialog',
	        value: function setDialog(index) {
	            this.setState({ readyForNextBubble: false });
	            var dialog = Object.assign({}, this.state.screenObject.dialogs[index]);
	            var dialogType = Object.assign({}, (0, _componentHelper.getChildObjectComponentByType)(dialog.object_type), {
	                data: dialog,
	                index: index
	            });
	            this.setState({ renderedDialogs: dataHelper.immutablePush(this.state.renderedDialogs, dialogType) });
	        }
	    }, {
	        key: 'scrollToTop',
	        value: function scrollToTop() {
	            if (this.state.allowScroll && this.state.status !== objectConstants.STATUS_COMPLETE) {
	                var question = this.refs[this.state.screenObject.asset_id];
	                var scrollTo = this.props.callbacks.scrollTo;
	                setTimeout(function () {
	                    if (appHelper.isDefined(scrollTo)) {
	                        scrollTo(question.offsetTop);
	                    }
	                }, objectConstants.SCROLL_TO);
	            }
	        }
	    }, {
	        key: 'onComplete',
	        value: function onComplete() {
	            var hasNextObject = this.props.callbacks.hasNextObject(this.props.index);
	            if (appHelper.isDefined(this.state.screenObject.progression) && this.state.screenObject.progression === objectConstants.OBJECT_PROGRESSION_CONTINUE && (this.state.status !== objectConstants.STATUS_COMPLETE || !hasNextObject)) {
	                if (!hasNextObject) {
	                    this.handleProgression();
	                    this.enableProgression();
	                } else {
	                    this.enableProgression();
	                }
	            } else {
	                this.handleProgression();
	            }
	            this.scrollToTop();
	        }
	    }, {
	        key: 'handleProgression',
	        value: function handleProgression() {
	            if (!this.state.progressionHandled) {
	                this.setState({ progressionHandled: true });
	                var progressionRule = appHelper.isDefined(this.state.screenObject.progression) ? this.state.screenObject.progression : objectConstants.OBJECT_PROGRESSION_CONTINUE;
	                var progressionType = appHelper.isDefined(this.state.screenObject.progression_type) ? this.state.screenObject.progression_type : undefined;
	                var progressionGoToId = appHelper.isDefined(this.state.screenObject.progression_goto_id) ? this.state.screenObject.progression_goto_id : undefined;
	                var completionData = {
	                    progression: progressionRule,
	                    progressionType: progressionType,
	                    progressionGoToId: progressionGoToId,
	                    asset_id: this.state.screenObject.asset_id,
	                    status: objectConstants.STATUS_COMPLETE,
	                    asset_type_code: this.state.screenObject.asset_type_code,
	                    navigateToNextScreen: appHelper.isDefined(this.state.screenObject.progression) && this.state.screenObject.progression === objectConstants.OBJECT_PROGRESSION_CONTINUE,
	                    index: this.props.index
	                };
	
	                this.props.callbacks.onObjectComplete(completionData);
	            }
	        }
	    }, {
	        key: 'enableProgression',
	        value: function enableProgression() {
	            //if(!this.props.callbacks.isReviewMode()){
	            this.setState({ showProgressionButton: true });
	            //}
	            this.scrollToTop();
	        }
	    }, {
	        key: 'onProgressionBtnClicked',
	        value: function onProgressionBtnClicked() {
	            this.setState({ showProgressionButton: false });
	            if (this.props.callbacks.hasNextObject(this.props.index)) {
	                this.handleProgression();
	            } else {
	                this.props.callbacks.navigateToNextScreen();
	            }
	        }
	    }, {
	        key: 'onStepProgressionBtnClicked',
	        value: function onStepProgressionBtnClicked() {
	            this.setState({
	                readyForNextBubble: true,
	                speechCounter: 0,
	                showStepProgressionButton: false
	            });
	        }
	    }, {
	        key: 'getSpeechDelay',
	        value: function getSpeechDelay() {
	            return this.state.speechCounter === 0 || this.state.status === objectConstants.STATUS_COMPLETE ? 0 : this.state.speechDelay;
	        }
	    }, {
	        key: 'getImagePath',
	        value: function getImagePath(image) {
	            if (appConstants.DEVELOPMENT_MODE) {
	                if (appHelper.isDefined(image) && image.length > 0) {
	                    return __webpack_require__(16)("./" + image);
	                }
	            } else {
	                return image;
	            }
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this2 = this;
	
	            return _react2.default.createElement(
	                'div',
	                { className: 'content-dialogs', ref: this.state.screenObject.asset_id },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'object-wrapper' },
	                    appHelper.isDefined(this.props.characterPose) && appHelper.isDefined(this.props.characterPose.src) && this.props.characterPose.src.length > 0 ? _react2.default.createElement(
	                        'div',
	                        { className: 'content-character-expression' },
	                        _react2.default.createElement('img', { src: this.getImagePath(this.props.characterPose.src), alt: '' })
	                    ) : null,
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'conversation-dialog' },
	                        this.state.screenObject.show_title ? _react2.default.createElement('h4', { className: 'bold', dangerouslySetInnerHTML: { __html: this.state.locale.label } }) : null,
	                        this.state.renderedDialogs.map(function (dialog) {
	                            return _react2.default.createElement(
	                                'div',
	                                { key: 'diaglog_' + dialog.index },
	                                _react2.default.createElement(dialog.component, { asset_id: _this2.state.screenObject.asset_id,
	                                    index: dialog.index, dialog: dialog.data,
	                                    callbacks: _this2.state.callbacks,
	                                    delay: _this2.getSpeechDelay() })
	                            );
	                        }),
	                        this.state.showStepProgressionButton ? _react2.default.createElement(_Button2.default, { label: this.state.continue_label,
	                            id: this.state.screenObject.asset_id + '_step_button',
	                            onClick: this.onStepProgressionBtnClicked }) : null
	                    ),
	                    this.state.showProgressionButton ? _react2.default.createElement(_Button2.default, { label: this.state.continue_label,
	                        id: this.state.screenObject.asset_id + '_button',
	                        onClick: this.onProgressionBtnClicked }) : null
	                )
	            );
	        }
	    }]);
	
	    return ConversationDialog;
	}(_react2.default.Component);
	
	ConversationDialog.propTypes = {
	    screenObject: _propTypes2.default.object.isRequired,
	    callbacks: _propTypes2.default.object.isRequired,
	    characterPose: _propTypes2.default.object,
	    userData: _propTypes2.default.object.isRequired,
	    index: _propTypes2.default.number,
	    lang: _propTypes2.default.string.isRequired,
	    actions: _propTypes2.default.object
	};
	
	ConversationDialog.contextTypes = {
	    router: _propTypes2.default.object
	};
	
	function mapStateToProps(state, ownProps) {
	    var lang = state.userData.lang;
	    return {
	        lang: lang,
	        userData: state.userData
	    };
	}
	
	function mapDispatchToProps(dispatch) {
	    return {
	        actions: (0, _redux.bindActionCreators)(Object.assign({}, appDataActions, trackingDataActions), dispatch)
	    };
	}
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(ConversationDialog);

/***/ },
/* 476 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(5);
	
	var _redux = __webpack_require__(4);
	
	var _trackingDataActions = __webpack_require__(7);
	
	var trackingDataActions = _interopRequireWildcard(_trackingDataActions);
	
	var _appHelper = __webpack_require__(3);
	
	var appHelper = _interopRequireWildcard(_appHelper);
	
	var _objectConstants = __webpack_require__(9);
	
	var objectConstants = _interopRequireWildcard(_objectConstants);
	
	var _gsap = __webpack_require__(8);
	
	var _gsapReactPlugin = __webpack_require__(10);
	
	var _gsapReactPlugin2 = _interopRequireDefault(_gsapReactPlugin);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var NarratorSpeak = function (_React$Component) {
	    _inherits(NarratorSpeak, _React$Component);
	
	    function NarratorSpeak(props, context) {
	        _classCallCheck(this, NarratorSpeak);
	
	        var _this = _possibleConstructorReturn(this, (NarratorSpeak.__proto__ || Object.getPrototypeOf(NarratorSpeak)).call(this, props, context));
	
	        _this.state = {
	            lang: _this.props.lang,
	            locale: appHelper.getLocalData(_this.props.dialog)
	        };
	
	        _this.showResponse = _this.showResponse.bind(_this);
	        _this.handleProgression = _this.handleProgression.bind(_this);
	        _this.onComplete = _this.onComplete.bind(_this);
	        return _this;
	    }
	
	    _createClass(NarratorSpeak, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            this.showResponse();
	        }
	    }, {
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(nextProps) {
	            if (this.state.lang !== nextProps.lang) {
	                this.setState({
	                    lang: nextProps.lang,
	                    locale: appHelper.getLocalData(this.props.dialog)
	                });
	            }
	        }
	    }, {
	        key: 'showResponse',
	        value: function showResponse() {
	            var objectRef = this.refs['narratorSpeak_' + this.props.index];
	            _gsap.TweenLite.set(objectRef, { height: "auto" });
	            _gsap.TweenLite.from(objectRef, objectConstants.SPEECH_BUBBLE_DURATION, {
	                height: 0,
	                ease: _gsap.Expo.easeInOut,
	                delay: this.props.delay
	            }).eventCallback("onComplete", this.onComplete);
	        }
	    }, {
	        key: 'onComplete',
	        value: function onComplete() {
	            this.handleProgression();
	        }
	    }, {
	        key: 'handleProgression',
	        value: function handleProgression() {
	            this.props.callbacks.onObjectComplete(this.props.index);
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            return _react2.default.createElement(
	                'div',
	                { className: 'object-container-conversation', ref: 'narratorSpeak_' + this.props.index },
	                _react2.default.createElement('div', { dangerouslySetInnerHTML: { __html: this.state.locale.label } })
	            );
	        }
	    }]);
	
	    return NarratorSpeak;
	}(_react2.default.Component);
	
	NarratorSpeak.propTypes = {
	    asset_id: _propTypes2.default.number.isRequired,
	    option_id: _propTypes2.default.number,
	    index: _propTypes2.default.number.isRequired,
	    dialog: _propTypes2.default.object.isRequired,
	    delay: _propTypes2.default.number.isRequired,
	    callbacks: _propTypes2.default.object.isRequired,
	    trackingData: _propTypes2.default.object.isRequired,
	    lang: _propTypes2.default.string.isRequired,
	    actions: _propTypes2.default.object
	};
	
	NarratorSpeak.contextTypes = {
	    router: _propTypes2.default.object
	};
	
	function mapStateToProps(state, ownProps) {
	    var lang = state.userData.lang;
	    return {
	        lang: lang,
	        trackingData: state.trackingData
	    };
	}
	
	function mapDispatchToProps(dispatch) {
	    return {
	        actions: (0, _redux.bindActionCreators)(Object.assign({}, trackingDataActions), dispatch)
	    };
	}
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(NarratorSpeak);

/***/ },
/* 477 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(5);
	
	var _redux = __webpack_require__(4);
	
	var _Button = __webpack_require__(18);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _userDataActions = __webpack_require__(20);
	
	var userDataActions = _interopRequireWildcard(_userDataActions);
	
	var _trackingDataActions = __webpack_require__(7);
	
	var trackingDataActions = _interopRequireWildcard(_trackingDataActions);
	
	var _appHelper = __webpack_require__(3);
	
	var appHelper = _interopRequireWildcard(_appHelper);
	
	var _userDataHelper = __webpack_require__(15);
	
	var userDataHelper = _interopRequireWildcard(_userDataHelper);
	
	var _appConstants = __webpack_require__(13);
	
	var appConstants = _interopRequireWildcard(_appConstants);
	
	var _objectConstants = __webpack_require__(9);
	
	var objectConstants = _interopRequireWildcard(_objectConstants);
	
	var _gsap = __webpack_require__(8);
	
	var _gsapReactPlugin = __webpack_require__(10);
	
	var _gsapReactPlugin2 = _interopRequireDefault(_gsapReactPlugin);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } //eslint-disable-line import/no-named-as-default
	
	
	var Document = function (_React$Component) {
	    _inherits(Document, _React$Component);
	
	    function Document(props, context) {
	        _classCallCheck(this, Document);
	
	        var _this = _possibleConstructorReturn(this, (Document.__proto__ || Object.getPrototypeOf(Document)).call(this, props, context));
	
	        _this.state = {
	            lang: _this.props.lang,
	            screenObject: _this.props.screenObject,
	            userData: _this.props.userData,
	            status: objectConstants.STATUS_NOT_STARTED,
	            locale: appHelper.getLocalData(_this.props.screenObject),
	            showProgressionButton: false,
	            document: {},
	            screenStatus: "",
	            isResourceObject: appHelper.isDefined(_this.props.callbacks.checkIsResourceScreen) && _this.props.callbacks.checkIsResourceScreen(),
	            allowScroll: appHelper.allowScroll(_this.props.callbacks.getBiteId(), _this.props.callbacks.getScreenId(), _this.props.screenObject.asset_id),
	            continue_label: appHelper.getLocaleString("continue_label")
	        };
	        _this.getAssets = _this.getAssets.bind(_this);
	        _this.show = _this.show.bind(_this);
	        _this.handleProgression = _this.handleProgression.bind(_this);
	        _this.onOpen = _this.onOpen.bind(_this);
	        _this.setClass = _this.setClass.bind(_this);
	        _this.scrollToTop = _this.scrollToTop.bind(_this);
	        _this.getFilePath = _this.getFilePath.bind(_this);
	        _this.getImagePath = _this.getImagePath.bind(_this);
	        _this.getObjectStatus = _this.getObjectStatus.bind(_this);
	        _this.enableProgression = _this.enableProgression.bind(_this);
	        _this.disableProgression = _this.disableProgression.bind(_this);
	        _this.onProgressionBtnClicked = _this.onProgressionBtnClicked.bind(_this);
	        _this.onComplete = _this.onComplete.bind(_this);
	        _this.getScreenStatus = _this.getScreenStatus.bind(_this);
	        _this.onRendered = _this.onRendered.bind(_this);
	
	        return _this;
	    }
	
	    _createClass(Document, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            this.getAssets();
	            this.getScreenStatus();
	            this.show();
	            if (appHelper.isDefined(this.props.callbacks.updateCharacterExpression) && appHelper.isDefined(this.state.screenObject.character_pose)) {
	                this.props.callbacks.updateCharacterExpression(this.state.screenObject.character_pose);
	            }
	        }
	    }, {
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(nextProps) {
	            if (this.state.userData !== nextProps.userData) {
	                this.setState({ userData: Object.assign({}, nextProps.userData) });
	            }
	
	            if (this.state.lang !== nextProps.lang) {
	                var document = appHelper.getDocumentAsset(this.state.screenObject);
	                this.setState({
	                    lang: nextProps.lang,
	                    locale: appHelper.getLocalData(this.state.screenObject),
	                    document: appHelper.isDefined(document.locale) ? appHelper.getLocalData(document) : document,
	                    continue_label: appHelper.getLocaleString("continue_label")
	                });
	            }
	        }
	    }, {
	        key: 'componentDidUpdate',
	        value: function componentDidUpdate() {}
	    }, {
	        key: 'getScreenStatus',
	        value: function getScreenStatus() {
	            var screenStatus = this.props.callbacks.getScreenStatus();
	            this.setState({
	                screenStatus: screenStatus,
	                status: screenStatus === objectConstants.STATUS_COMPLETE || this.state.status === objectConstants.STATUS_COMPLETE ? objectConstants.STATUS_COMPLETE : this.state.status
	            });
	        }
	    }, {
	        key: 'getObjectStatus',
	        value: function getObjectStatus() {
	
	            if (this.state.screenStatus === objectConstants.STATUS_COMPLETE) {
	                this.onComplete();
	            } else {
	                var objectUserData = {};
	                if (this.state.status !== objectConstants.STATUS_COMPLETE) {
	                    var subScreenParent = this.props.callbacks.getSubScreenParent();
	                    var screen_id = this.props.callbacks.getScreenId();
	                    if (appHelper.isDefined(subScreenParent)) {
	                        objectUserData = userDataHelper.getSubScreenObjectStatus(this.state.userData, subScreenParent.screen_id, screen_id, this.state.screenObject.asset_id);
	                    } else if (this.state.isResourceObject) {
	                        objectUserData = userDataHelper.getResourceScreenObjectUserData(this.state.userData, screen_id, this.state.screenObject.asset_id);
	                    } else {
	                        objectUserData = userDataHelper.getObjectStatus(this.state.userData, screen_id, this.state.screenObject.asset_id);
	                    }
	                }
	
	                if (!this.state.screenObject.required_for_completion || objectUserData.status === objectConstants.STATUS_COMPLETE) {
	                    this.setState({ status: objectConstants.STATUS_COMPLETE });
	                    this.onComplete();
	                }
	            }
	        }
	    }, {
	        key: 'getAssets',
	        value: function getAssets() {
	            var document = appHelper.getDocumentAsset(this.state.screenObject);
	            this.setState({ document: appHelper.isDefined(document.locale) ? appHelper.getLocalData(document) : document });
	        }
	    }, {
	        key: 'show',
	        value: function show() {
	            var fileRef = this.refs['document_' + this.state.screenObject.asset_id];
	            if (appHelper.isDefined(fileRef)) {
	                _gsap.TweenLite.set(fileRef, { opacity: 1, height: "auto" });
	                _gsap.TweenLite.from(fileRef, objectConstants.SHOW_PANEL_DURATION, {
	                    height: 0,
	                    opacity: 0,
	                    ease: _gsap.Expo.easeInOut
	                }).eventCallback("onComplete", this.onRendered);
	            }
	        }
	    }, {
	        key: 'onRendered',
	        value: function onRendered() {
	            if (this.state.isResourceObject) {
	                this.props.callbacks.onObjectRendered();
	            }
	            this.getObjectStatus();
	        }
	    }, {
	        key: 'scrollToTop',
	        value: function scrollToTop() {
	            if (this.state.allowScroll && this.state.status !== objectConstants.STATUS_COMPLETE) {
	                var question = this.refs['document_' + this.state.screenObject.asset_id];
	                var scrollTo = this.props.callbacks.scrollTo;
	                setTimeout(function () {
	                    if (appHelper.isDefined(scrollTo)) {
	                        scrollTo(question.offsetTop);
	                    }
	                }, objectConstants.SCROLL_TO);
	            }
	        }
	    }, {
	        key: 'getFilePath',
	        value: function getFilePath(src) {
	            if (appConstants.DEVELOPMENT_MODE) {
	                if (appHelper.isDefined(src) && src.length > 0) {
	                    return __webpack_require__(16)("./" + src);
	                }
	            } else {
	                return src;
	            }
	        }
	    }, {
	        key: 'getImagePath',
	        value: function getImagePath(image) {
	            if (appConstants.DEVELOPMENT_MODE) {
	                if (appHelper.isDefined(image) && image.length > 0) {
	                    return __webpack_require__(16)("./" + image);
	                }
	            } else {
	                return image;
	            }
	        }
	    }, {
	        key: 'onOpen',
	        value: function onOpen() {
	            if (this.state.status !== objectConstants.STATUS_COMPLETE) {
	                this.setState({ status: objectConstants.STATUS_COMPLETE });
	                this.onComplete();
	            }
	        }
	    }, {
	        key: 'setClass',
	        value: function setClass() {
	            if (this.state.status === objectConstants.STATUS_COMPLETE) {
	                return "complete";
	            } else {
	                return "not-started";
	            }
	        }
	    }, {
	        key: 'onComplete',
	        value: function onComplete() {
	            this.setState({ checkComplete: false });
	            var hasNextObject = this.props.callbacks.hasNextObject(this.props.index);
	            if (appHelper.isDefined(this.state.screenObject.progression) && this.state.screenObject.progression === objectConstants.OBJECT_PROGRESSION_CONTINUE && (this.state.status !== objectConstants.STATUS_COMPLETE || !hasNextObject)) {
	                if (!hasNextObject && !this.state.isResourceObject) {
	                    this.handleProgression();
	                    this.enableProgression();
	                } else if (!hasNextObject && this.state.isResourceObject) {
	                    this.handleProgression();
	                } else if (this.state.isResourceObject) {
	                    this.handleProgression();
	                } else {
	                    this.enableProgression();
	                }
	            } else {
	                this.handleProgression();
	            }
	            this.scrollToTop();
	        }
	    }, {
	        key: 'enableProgression',
	        value: function enableProgression() {
	            if (!this.props.callbacks.isReviewMode()) {
	                this.setState({ showProgressionButton: true });
	            }
	        }
	    }, {
	        key: 'disableProgression',
	        value: function disableProgression() {
	            this.setState({ showProgressionButton: false });
	        }
	    }, {
	        key: 'handleProgression',
	        value: function handleProgression() {
	            var progressionRule = appHelper.isDefined(this.state.screenObject.progression) ? this.state.screenObject.progression : objectConstants.OBJECT_PROGRESSION_CONTINUE;
	            var progressionType = appHelper.isDefined(this.state.screenObject.progression_type) ? this.state.screenObject.progression_type : undefined;
	            var progressionGoToId = appHelper.isDefined(this.state.screenObject.progression_goto_id) ? this.state.screenObject.progression_goto_id : undefined;
	            var completionData = {
	                progression: progressionRule,
	                progressionType: progressionType,
	                progressionGoToId: progressionGoToId,
	                asset_id: this.state.screenObject.asset_id,
	                status: objectConstants.STATUS_COMPLETE,
	                showProgressionButton: false,
	                asset_type_code: this.state.screenObject.asset_type_code,
	                navigateToNextScreen: !this.state.isResourceObject && appHelper.isDefined(this.state.screenObject.progression) && this.state.screenObject.progression === objectConstants.OBJECT_PROGRESSION_CONTINUE,
	                index: this.props.index
	            };
	
	            this.props.callbacks.onObjectComplete(completionData);
	            //t
	        }
	    }, {
	        key: 'onProgressionBtnClicked',
	        value: function onProgressionBtnClicked() {
	            this.setState({ showProgressionButton: false });
	            if (this.props.callbacks.hasNextObject(this.props.index) || this.state.isResourceObject) {
	                this.handleProgression();
	            } else {
	                this.props.callbacks.navigateToNextScreen();
	            }
	        }
	
	        /*<div className="flex-item">
	                            <div className="icon file"/>
	                        </div>*/
	
	    }, {
	        key: 'render',
	        value: function render() {
	            return _react2.default.createElement(
	                'div',
	                { className: 'object-container', ref: 'document_' + this.state.screenObject.asset_id },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'document-panel file ' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'flex-item' },
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'document-header' },
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'link-title file ' + this.setClass() },
	                                _react2.default.createElement('a', { href: this.getFilePath(this.state.document.src),
	                                    target: '_blank',
	                                    onClick: this.onOpen,
	                                    tabIndex: 0,
	                                    dangerouslySetInnerHTML: { __html: this.state.locale.label } })
	                            )
	                        ),
	                        appHelper.isDefined(this.state.locale.description) && this.state.locale.description !== null && this.state.locale.description.length > 0 ? _react2.default.createElement('div', { className: 'document-description',
	                            dangerouslySetInnerHTML: { __html: this.state.locale.description } }) : null
	                    )
	                ),
	                this.state.showProgressionButton ? _react2.default.createElement(_Button2.default, { label: this.state.continue_label,
	                    id: this.state.screenObject + '_button',
	                    onClick: this.onProgressionBtnClicked }) : null
	            );
	        }
	    }]);
	
	    return Document;
	}(_react2.default.Component);
	
	/*<div className="flex-item">
	                        <div className={`thumbnail-container file ${this.setClass()}`}>
	                            <img src={this.getImagePath(this.state.document.thumbnail)} />
	                        </div>
	                    </div>*/
	
	
	Document.propTypes = {
	    screenObject: _propTypes2.default.object.isRequired,
	    callbacks: _propTypes2.default.object.isRequired,
	    index: _propTypes2.default.number,
	    userData: _propTypes2.default.object.isRequired,
	    lang: _propTypes2.default.string.isRequired,
	    actions: _propTypes2.default.object.isRequired
	};
	
	Document.contextTypes = {
	    router: _propTypes2.default.object
	};
	
	/*
	* <ParagraphText screenObject={this.state.screenObject}
	                                   ref={`${this.state.screenObject.asset_id}_paragraph`}
	                                   id={`${this.state.screenObject}_description`}
	                                   class_name="document-description"
	                                   objectKey={`description`}/>*/
	
	function mapStateToProps(state, ownProps) {
	    var lang = state.userData.lang;
	    return {
	        lang: lang,
	        userData: state.userData
	    };
	}
	
	function mapDispatchToProps(dispatch) {
	    return {
	        actions: (0, _redux.bindActionCreators)(Object.assign({}, userDataActions, trackingDataActions), dispatch)
	    };
	}
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(Document);

/***/ },
/* 478 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(5);
	
	var _redux = __webpack_require__(4);
	
	var _Button = __webpack_require__(18);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _AssetImage = __webpack_require__(136);
	
	var _AssetImage2 = _interopRequireDefault(_AssetImage);
	
	var _userDataActions = __webpack_require__(20);
	
	var userDataActions = _interopRequireWildcard(_userDataActions);
	
	var _trackingDataActions = __webpack_require__(7);
	
	var trackingDataActions = _interopRequireWildcard(_trackingDataActions);
	
	var _dialogPopupActions = __webpack_require__(19);
	
	var dialogPopupActions = _interopRequireWildcard(_dialogPopupActions);
	
	var _appHelper = __webpack_require__(3);
	
	var appHelper = _interopRequireWildcard(_appHelper);
	
	var _userDataHelper = __webpack_require__(15);
	
	var userDataHelper = _interopRequireWildcard(_userDataHelper);
	
	var _dataHelper = __webpack_require__(11);
	
	var dataHelper = _interopRequireWildcard(_dataHelper);
	
	var _appConstants = __webpack_require__(13);
	
	var appConstants = _interopRequireWildcard(_appConstants);
	
	var _objectConstants = __webpack_require__(9);
	
	var objectConstants = _interopRequireWildcard(_objectConstants);
	
	var _keyboardConstants = __webpack_require__(14);
	
	var keyboardConstants = _interopRequireWildcard(_keyboardConstants);
	
	var _dialogModels = __webpack_require__(32);
	
	var _gsap = __webpack_require__(8);
	
	var _gsapReactPlugin = __webpack_require__(10);
	
	var _gsapReactPlugin2 = _interopRequireDefault(_gsapReactPlugin);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } //eslint-disable-line import/no-named-as-default
	
	
	var Image = function (_React$Component) {
	    _inherits(Image, _React$Component);
	
	    function Image(props, context) {
	        _classCallCheck(this, Image);
	
	        var _this = _possibleConstructorReturn(this, (Image.__proto__ || Object.getPrototypeOf(Image)).call(this, props, context));
	
	        _this.state = {
	            lang: _this.props.lang,
	            screenObject: _this.props.screenObject,
	            userData: _this.props.userData,
	            status: objectConstants.STATUS_NOT_STARTED,
	            locale: appHelper.getLocalData(_this.props.screenObject),
	            showProgressionButton: false,
	            image: {},
	            screenStatus: "",
	            checkComplete: false,
	            isResourceObject: appHelper.isDefined(_this.props.callbacks.checkIsResourceScreen) && _this.props.callbacks.checkIsResourceScreen(),
	            allowScroll: appHelper.allowScroll(_this.props.callbacks.getBiteId(), _this.props.callbacks.getScreenId(), _this.props.screenObject.asset_id),
	            isTracking: !appHelper.isDefined(_this.props.isTracking) || appHelper.isDefined(_this.props.isTracking) && _this.props.isTracking,
	            continue_label: appHelper.getLocaleString("continue_label")
	        };
	        _this.getAssets = _this.getAssets.bind(_this);
	        _this.show = _this.show.bind(_this);
	        _this.handleProgression = _this.handleProgression.bind(_this);
	        _this.setClass = _this.setClass.bind(_this);
	        _this.scrollToTop = _this.scrollToTop.bind(_this);
	        _this.getImagePath = _this.getImagePath.bind(_this);
	        _this.getObjectStatus = _this.getObjectStatus.bind(_this);
	        _this.enableProgression = _this.enableProgression.bind(_this);
	        _this.disableProgression = _this.disableProgression.bind(_this);
	        _this.onProgressionBtnClicked = _this.onProgressionBtnClicked.bind(_this);
	        _this.onComplete = _this.onComplete.bind(_this);
	        _this.getScreenStatus = _this.getScreenStatus.bind(_this);
	        _this.getObjectStatus = _this.getObjectStatus.bind(_this);
	        _this.onCloseAssetDialog = _this.onCloseAssetDialog.bind(_this);
	        _this.launchAsset = _this.launchAsset.bind(_this);
	        _this.onRendered = _this.onRendered.bind(_this);
	        _this.setKeyboardAccessibility = _this.setKeyboardAccessibility.bind(_this);
	
	        return _this;
	    }
	
	    _createClass(Image, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            this.getAssets();
	            this.getScreenStatus();
	            this.show();
	            if (appHelper.isDefined(this.props.callbacks.updateCharacterExpression) && appHelper.isDefined(this.state.screenObject.character_pose)) {
	                this.props.callbacks.updateCharacterExpression(this.state.screenObject.character_pose);
	            }
	        }
	    }, {
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(nextProps) {
	            if (this.state.userData !== nextProps.userData) {
	                this.setState({ userData: Object.assign({}, nextProps.userData) });
	            }
	
	            if (this.state.lang !== nextProps.lang) {
	                var image = appHelper.getImageAsset(this.state.screenObject);
	                this.setState({
	                    lang: nextProps.lang,
	                    locale: appHelper.getLocalData(this.state.screenObject),
	                    image: appHelper.isDefined(image.locale) ? appHelper.getLocalData(image) : image,
	                    continue_label: appHelper.getLocaleString("continue_label")
	                });
	            }
	        }
	    }, {
	        key: 'componentDidUpdate',
	        value: function componentDidUpdate() {
	
	            if (this.state.checkComplete) {
	                this.onComplete();
	            }
	        }
	    }, {
	        key: 'getScreenStatus',
	        value: function getScreenStatus() {
	            var screenStatus = this.props.callbacks.getScreenStatus();
	            this.setState({
	                screenStatus: screenStatus,
	                status: screenStatus === objectConstants.STATUS_COMPLETE ? objectConstants.STATUS_COMPLETE : this.state.status
	            });
	        }
	    }, {
	        key: 'getObjectStatus',
	        value: function getObjectStatus() {
	            if (this.state.screenStatus === objectConstants.STATUS_COMPLETE) {
	                this.onComplete();
	            } else {
	                var objectUserData = {};
	                if (this.state.status !== objectConstants.STATUS_COMPLETE) {
	                    var subScreenParent = this.props.callbacks.getSubScreenParent();
	                    var screen_id = this.props.callbacks.getScreenId();
	                    if (appHelper.isDefined(subScreenParent)) {
	                        objectUserData = userDataHelper.getSubScreenObjectStatus(this.state.userData, subScreenParent.screen_id, screen_id, this.state.screenObject.asset_id);
	                    } else if (this.state.isResourceObject) {
	                        objectUserData = userDataHelper.getResourceScreenObjectUserData(this.state.userData, screen_id, this.state.screenObject.asset_id);
	                    } else {
	                        objectUserData = userDataHelper.getObjectStatus(this.state.userData, screen_id, this.state.screenObject.asset_id);
	                    }
	                }
	                if (objectUserData.status === objectConstants.STATUS_COMPLETE) {
	                    this.setState({ status: objectConstants.STATUS_COMPLETE, checkComplete: true });
	                } else {
	                    this.setState({ checkComplete: true });
	                }
	            }
	        }
	    }, {
	        key: 'getAssets',
	        value: function getAssets() {
	            var image = appHelper.getImageAsset(this.state.screenObject);
	            this.setState({ image: appHelper.isDefined(image.locale) ? appHelper.getLocalData(image) : image });
	        }
	    }, {
	        key: 'show',
	        value: function show() {
	            var fileRef = this.refs['image_' + this.state.screenObject.asset_id];
	            if (appHelper.isDefined(fileRef)) {
	                _gsap.TweenLite.set(fileRef, { opacity: 1, height: "auto" });
	                _gsap.TweenLite.from(fileRef, objectConstants.SHOW_PANEL_DURATION, {
	                    height: 0,
	                    opacity: 0,
	                    ease: _gsap.Expo.easeInOut
	                }).eventCallback("onComplete", this.onRendered);
	            }
	        }
	    }, {
	        key: 'onRendered',
	        value: function onRendered() {
	            if (this.state.isResourceObject) {
	                this.props.callbacks.onObjectRendered();
	            }
	            this.getObjectStatus();
	        }
	    }, {
	        key: 'scrollToTop',
	        value: function scrollToTop() {
	            if (this.state.allowScroll && this.state.status !== objectConstants.STATUS_COMPLETE) {
	                var question = this.refs['image_' + this.state.screenObject.asset_id];
	                var scrollTo = this.props.callbacks.scrollTo;
	                setTimeout(function () {
	                    if (appHelper.isDefined(scrollTo)) {
	                        scrollTo(question.offsetTop);
	                    }
	                }, objectConstants.SCROLL_TO);
	            }
	        }
	    }, {
	        key: 'getImagePath',
	        value: function getImagePath(image) {
	            if (appConstants.DEVELOPMENT_MODE) {
	                if (appHelper.isDefined(image) && image.length > 0) {
	                    return __webpack_require__(16)("./" + image);
	                }
	            } else {
	                return image;
	            }
	        }
	    }, {
	        key: 'setClass',
	        value: function setClass() {
	            if (this.state.status === objectConstants.STATUS_COMPLETE) {
	                return "complete";
	            } else {
	                return "not-started";
	            }
	        }
	    }, {
	        key: 'onComplete',
	        value: function onComplete() {
	            this.setState({ checkComplete: false });
	            if (this.state.isTracking) {
	                var hasNextObject = this.props.callbacks.hasNextObject(this.props.index);
	                if (appHelper.isDefined(this.state.screenObject.progression) && this.state.screenObject.progression === objectConstants.OBJECT_PROGRESSION_CONTINUE && (this.state.status !== objectConstants.STATUS_COMPLETE || !hasNextObject)) {
	                    if (!hasNextObject && !this.state.isResourceObject) {
	                        this.handleProgression();
	                        this.enableProgression();
	                    } else if (!hasNextObject && this.state.isResourceObject) {
	                        this.handleProgression();
	                    } else if (this.state.isResourceObject) {
	                        this.handleProgression();
	                    } else {
	                        this.enableProgression();
	                    }
	                } else {
	                    this.handleProgression();
	                }
	            }
	            this.scrollToTop();
	        }
	    }, {
	        key: 'enableProgression',
	        value: function enableProgression() {
	            if (!this.props.callbacks.isReviewMode()) {
	                this.setState({ showProgressionButton: true });
	            }
	        }
	    }, {
	        key: 'disableProgression',
	        value: function disableProgression() {
	            this.setState({ showProgressionButton: false });
	        }
	    }, {
	        key: 'handleProgression',
	        value: function handleProgression() {
	            var progressionRule = appHelper.isDefined(this.state.screenObject.progression) ? this.state.screenObject.progression : objectConstants.OBJECT_PROGRESSION_CONTINUE;
	            var progressionType = appHelper.isDefined(this.state.screenObject.progression_type) ? this.state.screenObject.progression_type : undefined;
	            var progressionGoToId = appHelper.isDefined(this.state.screenObject.progression_goto_id) ? this.state.screenObject.progression_goto_id : undefined;
	            var completionData = {
	                progression: progressionRule,
	                progressionType: progressionType,
	                progressionGoToId: progressionGoToId,
	                asset_id: this.state.screenObject.asset_id,
	                status: objectConstants.STATUS_COMPLETE,
	                showProgressionButton: false,
	                asset_type_code: this.state.screenObject.asset_type_code,
	                navigateToNextScreen: !this.state.isResourceObject && appHelper.isDefined(this.state.screenObject.progression) && this.state.screenObject.progression === objectConstants.OBJECT_PROGRESSION_CONTINUE,
	                index: this.props.index
	            };
	
	            this.props.callbacks.onObjectComplete(completionData);
	            //t
	        }
	    }, {
	        key: 'onProgressionBtnClicked',
	        value: function onProgressionBtnClicked() {
	            this.setState({ showProgressionButton: false });
	            if (this.props.callbacks.hasNextObject(this.props.index) || this.state.isResourceObject) {
	                this.handleProgression();
	            } else {
	                this.props.callbacks.navigateToNextScreen();
	            }
	        }
	    }, {
	        key: 'onCloseAssetDialog',
	        value: function onCloseAssetDialog(viewed) {
	            /*let objectUserData = userDataHelper.getAttachmentObjectUserData(this.state.userData, this.state.resource.asset_id);
	            if(objectUserData.status !== objectConstants.STATUS_COMPLETE && viewed) {
	                this.updateResourceObjectResult();
	            }*/
	        }
	    }, {
	        key: 'launchAsset',
	        value: function launchAsset() {
	            var childComponenents = [];
	            var config = Object.assign({}, _dialogModels.ASSET_CONFIG, {
	                title: this.state.locale.label,
	                onClose: this.onCloseAssetDialog,
	                showCloseBtn: false,
	                theme: "dialog-asset-image",
	                sourceId: 'image_btn_' + this.state.screenObject.asset_id
	            });
	
	            for (var i = 0; i < config.childComponents.length; i++) {
	                var child = config.childComponents[i];
	                child = Object.assign({}, child, {
	                    childComponent: _AssetImage2.default,
	                    componentProps: Object.assign({}, {
	                        screenObject: this.state.screenObject,
	                        callbacks: {}
	
	                    })
	                });
	
	                childComponenents = dataHelper.immutablePush(childComponenents, child);
	            }
	            config = Object.assign({}, config, {
	                childComponents: childComponenents
	            });
	
	            this.props.actions.setNewAssetDialog(config);
	        }
	    }, {
	        key: 'setKeyboardAccessibility',
	        value: function setKeyboardAccessibility(event) {
	
	            if (event.which === keyboardConstants.ENTER_KEY || event.which === keyboardConstants.SPACEBAR_KEY) {
	                event.preventDefault();
	                event.stopPropagation();
	                this.launchAsset();
	            }
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            return _react2.default.createElement(
	                'div',
	                { className: 'object-container', ref: 'image_' + this.state.screenObject.asset_id },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'asset-image', onClick: this.launchAsset, id: 'image_btn_' + this.state.screenObject.asset_id, onKeyDown: this.setKeyboardAccessibility, role: 'link', tabIndex: 0 },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'img-container' },
	                        _react2.default.createElement('img', { src: this.getImagePath(this.state.image.src), alt: this.state.locale.label })
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'asset-desc' },
	                        appHelper.isDefined(this.state.locale.label) && this.state.locale.label.length > 0 ? _react2.default.createElement('div', { className: 'title', dangerouslySetInnerHTML: { __html: this.state.locale.label } }) : null,
	                        appHelper.isDefined(this.state.locale.description) && this.state.locale.description !== null && this.state.locale.description.length > 0 ? _react2.default.createElement('div', { className: 'desc-text', dangerouslySetInnerHTML: { __html: this.state.locale.description } }) : null
	                    )
	                ),
	                this.state.showProgressionButton ? _react2.default.createElement(_Button2.default, { label: this.state.continue_label,
	                    id: this.state.screenObject + '_button',
	                    onClick: this.onProgressionBtnClicked }) : null
	            );
	        }
	    }]);
	
	    return Image;
	}(_react2.default.Component);
	
	Image.propTypes = {
	    screenObject: _propTypes2.default.object.isRequired,
	    callbacks: _propTypes2.default.object.isRequired,
	    isTracking: _propTypes2.default.bool,
	    index: _propTypes2.default.number,
	    userData: _propTypes2.default.object.isRequired,
	    lang: _propTypes2.default.string.isRequired,
	    actions: _propTypes2.default.object.isRequired
	};
	
	Image.contextTypes = {
	    router: _propTypes2.default.object
	};
	
	/*
	* <ParagraphText screenObject={this.state.screenObject}
	                                   ref={`${this.state.screenObject.asset_id}_paragraph`}
	                                   id={`${this.state.screenObject}_description`}
	                                   class_name="document-description"
	                                   objectKey={`description`}/>*/
	
	function mapStateToProps(state, ownProps) {
	    var lang = state.userData.lang;
	    return {
	        lang: lang,
	        userData: state.userData
	    };
	}
	
	function mapDispatchToProps(dispatch) {
	    return {
	        actions: (0, _redux.bindActionCreators)(Object.assign({}, userDataActions, trackingDataActions, dialogPopupActions), dispatch)
	    };
	}
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(Image);

/***/ },
/* 479 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(5);
	
	var _redux = __webpack_require__(4);
	
	var _Button = __webpack_require__(18);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _AssetImage = __webpack_require__(136);
	
	var _AssetImage2 = _interopRequireDefault(_AssetImage);
	
	var _userDataActions = __webpack_require__(20);
	
	var userDataActions = _interopRequireWildcard(_userDataActions);
	
	var _trackingDataActions = __webpack_require__(7);
	
	var trackingDataActions = _interopRequireWildcard(_trackingDataActions);
	
	var _dialogPopupActions = __webpack_require__(19);
	
	var dialogPopupActions = _interopRequireWildcard(_dialogPopupActions);
	
	var _appHelper = __webpack_require__(3);
	
	var appHelper = _interopRequireWildcard(_appHelper);
	
	var _userDataHelper = __webpack_require__(15);
	
	var userDataHelper = _interopRequireWildcard(_userDataHelper);
	
	var _dataHelper = __webpack_require__(11);
	
	var dataHelper = _interopRequireWildcard(_dataHelper);
	
	var _appConstants = __webpack_require__(13);
	
	var appConstants = _interopRequireWildcard(_appConstants);
	
	var _objectConstants = __webpack_require__(9);
	
	var objectConstants = _interopRequireWildcard(_objectConstants);
	
	var _dialogModels = __webpack_require__(32);
	
	var _imageHelper = __webpack_require__(203);
	
	var imageHelper = _interopRequireWildcard(_imageHelper);
	
	var _gsap = __webpack_require__(8);
	
	var _gsapReactPlugin = __webpack_require__(10);
	
	var _gsapReactPlugin2 = _interopRequireDefault(_gsapReactPlugin);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } //eslint-disable-line import/no-named-as-default
	
	
	var LibraryImage = function (_React$Component) {
	    _inherits(LibraryImage, _React$Component);
	
	    function LibraryImage(props, context) {
	        _classCallCheck(this, LibraryImage);
	
	        var _this = _possibleConstructorReturn(this, (LibraryImage.__proto__ || Object.getPrototypeOf(LibraryImage)).call(this, props, context));
	
	        _this.state = {
	            lang: _this.props.lang,
	            screenObject: _this.props.screenObject,
	            userData: _this.props.userData,
	            status: objectConstants.STATUS_NOT_STARTED,
	            locale: appHelper.getLocalData(_this.props.screenObject),
	            showProgressionButton: false,
	            image: {
	                src: ""
	            },
	            screenStatus: "",
	            checkComplete: false,
	            isResourceObject: appHelper.isDefined(_this.props.callbacks.checkIsResourceScreen) && _this.props.callbacks.checkIsResourceScreen(),
	            allowScroll: appHelper.allowScroll(_this.props.callbacks.getBiteId(), _this.props.callbacks.getScreenId(), _this.props.screenObject.asset_id),
	            isTracking: !appHelper.isDefined(_this.props.isTracking) || appHelper.isDefined(_this.props.isTracking) && _this.props.isTracking,
	            imageClass: "",
	            imageStylesSet: false,
	            updateImageStyles: false,
	            refValue: 'image_' + _this.props.screenObject.asset_id,
	            asset: {},
	            doShow: false,
	            continue_label: appHelper.getLocaleString("continue_label"),
	            credit_label: appHelper.getLocaleString("credit_label")
	        };
	        _this.getAssets = _this.getAssets.bind(_this);
	        _this.show = _this.show.bind(_this);
	        _this.handleProgression = _this.handleProgression.bind(_this);
	        _this.setClass = _this.setClass.bind(_this);
	        _this.scrollToTop = _this.scrollToTop.bind(_this);
	        _this.getImagePath = _this.getImagePath.bind(_this);
	        _this.getObjectStatus = _this.getObjectStatus.bind(_this);
	        _this.enableProgression = _this.enableProgression.bind(_this);
	        _this.disableProgression = _this.disableProgression.bind(_this);
	        _this.onProgressionBtnClicked = _this.onProgressionBtnClicked.bind(_this);
	        _this.onComplete = _this.onComplete.bind(_this);
	        _this.getScreenStatus = _this.getScreenStatus.bind(_this);
	        _this.getObjectStatus = _this.getObjectStatus.bind(_this);
	        _this.onCloseAssetDialog = _this.onCloseAssetDialog.bind(_this);
	        _this.getImageStyles = _this.getImageStyles.bind(_this);
	        return _this;
	    }
	
	    _createClass(LibraryImage, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            this.getAssets();
	            this.getScreenStatus();
	
	            if (appHelper.isDefined(this.props.callbacks.updateCharacterExpression) && appHelper.isDefined(this.state.screenObject.character_pose)) {
	                this.props.callbacks.updateCharacterExpression(this.state.screenObject.character_pose);
	            }
	        }
	    }, {
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(nextProps) {
	            if (this.state.userData !== nextProps.userData) {
	                this.setState({ userData: Object.assign({}, nextProps.userData) });
	            }
	
	            if (this.state.lang !== nextProps.lang) {
	                this.setState({
	                    lang: nextProps.lang,
	                    locale: appHelper.getLocalData(this.state.screenObject),
	                    continue_label: appHelper.getLocaleString("continue_label"),
	                    credit_label: appHelper.getLocaleString("credit_label")
	                });
	            }
	        }
	    }, {
	        key: 'componentDidUpdate',
	        value: function componentDidUpdate() {
	
	            if (this.state.checkComplete) {
	                this.onComplete();
	            }
	            if (!this.state.imageStylesSet) {
	                this.getImageStyles();
	            }
	            if (this.state.doShow) {
	                this.show();
	            }
	        }
	    }, {
	        key: 'getScreenStatus',
	        value: function getScreenStatus() {
	            var screenStatus = this.props.callbacks.getScreenStatus();
	            this.setState({
	                screenStatus: screenStatus,
	                status: screenStatus === objectConstants.STATUS_COMPLETE ? objectConstants.STATUS_COMPLETE : this.state.status
	            });
	        }
	    }, {
	        key: 'getObjectStatus',
	        value: function getObjectStatus() {
	            if (this.state.screenStatus === objectConstants.STATUS_COMPLETE) {
	                this.onComplete();
	            } else {
	                var objectUserData = {};
	                if (this.state.status !== objectConstants.STATUS_COMPLETE) {
	                    var subScreenParent = this.props.callbacks.getSubScreenParent();
	                    var screen_id = this.props.callbacks.getScreenId();
	                    if (appHelper.isDefined(subScreenParent)) {
	                        objectUserData = userDataHelper.getSubScreenObjectStatus(this.state.userData, subScreenParent.screen_id, screen_id, this.state.screenObject.asset_id);
	                    } else if (this.state.isResourceObject) {
	                        objectUserData = userDataHelper.getResourceScreenObjectUserData(this.state.userData, screen_id, this.state.screenObject.asset_id);
	                    } else {
	                        objectUserData = userDataHelper.getObjectStatus(this.state.userData, screen_id, this.state.screenObject.asset_id);
	                    }
	                }
	                if (objectUserData.status === objectConstants.STATUS_COMPLETE) {
	                    this.setState({ status: objectConstants.STATUS_COMPLETE, checkComplete: true });
	                } else {
	                    this.setState({ checkComplete: true });
	                }
	            }
	        }
	    }, {
	        key: 'getAssets',
	        value: function getAssets() {
	            var image = appHelper.getLibraryImageAsset(this.state.screenObject);
	            this.setState({
	                image: image,
	                asset: Object.assign({}, this.state.screenObject, {
	                    image: image
	                }),
	                updateImageStyles: true
	            });
	        }
	    }, {
	        key: 'show',
	        value: function show() {
	            this.setState({ doShow: false });
	            var fileRef = this.refs['image_' + this.state.screenObject.asset_id];
	            if (appHelper.isDefined(fileRef)) {
	                _gsap.TweenLite.set(fileRef, { opacity: 1, height: "auto" });
	                _gsap.TweenLite.from(fileRef, objectConstants.SHOW_PANEL_DURATION, {
	                    height: 0,
	                    opacity: 0,
	                    ease: _gsap.Expo.easeInOut
	                }).eventCallback("onComplete", this.getObjectStatus);
	            }
	        }
	    }, {
	        key: 'scrollToTop',
	        value: function scrollToTop() {
	            if (this.state.allowScroll && this.state.status !== objectConstants.STATUS_COMPLETE) {
	                var question = this.refs['image_' + this.state.screenObject.asset_id];
	                var scrollTo = this.props.callbacks.scrollTo;
	                setTimeout(function () {
	                    if (appHelper.isDefined(scrollTo)) {
	                        scrollTo(question.offsetTop);
	                    }
	                }, objectConstants.SCROLL_TO);
	            }
	        }
	    }, {
	        key: 'getImagePath',
	        value: function getImagePath(image) {
	            if (appConstants.DEVELOPMENT_MODE) {
	                if (appHelper.isDefined(image) && image.length > 0) {
	                    return __webpack_require__(16)("./" + image);
	                }
	            } else {
	                return image;
	            }
	        }
	    }, {
	        key: 'setClass',
	        value: function setClass() {
	            if (this.state.status === objectConstants.STATUS_COMPLETE) {
	                return "complete";
	            } else {
	                return "not-started";
	            }
	        }
	    }, {
	        key: 'onComplete',
	        value: function onComplete() {
	            this.setState({ checkComplete: false });
	            if (this.state.isTracking) {
	                var hasNextObject = this.props.callbacks.hasNextObject(this.props.index);
	                if (appHelper.isDefined(this.state.screenObject.progression) && this.state.screenObject.progression === objectConstants.OBJECT_PROGRESSION_CONTINUE && (this.state.status !== objectConstants.STATUS_COMPLETE || !hasNextObject)) {
	                    if (!hasNextObject && !this.state.isResourceObject) {
	                        this.handleProgression();
	                        this.enableProgression();
	                    } else if (!hasNextObject && this.state.isResourceObject) {
	                        this.handleProgression();
	                    } else {
	                        this.enableProgression();
	                    }
	                } else {
	                    this.handleProgression();
	                }
	            }
	            this.scrollToTop();
	        }
	    }, {
	        key: 'enableProgression',
	        value: function enableProgression() {
	            if (!this.props.callbacks.isReviewMode()) {
	                this.setState({ showProgressionButton: true });
	            }
	        }
	    }, {
	        key: 'disableProgression',
	        value: function disableProgression() {
	            this.setState({ showProgressionButton: false });
	        }
	    }, {
	        key: 'handleProgression',
	        value: function handleProgression() {
	            var progressionRule = appHelper.isDefined(this.state.screenObject.progression) ? this.state.screenObject.progression : objectConstants.OBJECT_PROGRESSION_CONTINUE;
	            var progressionType = appHelper.isDefined(this.state.screenObject.progression_type) ? this.state.screenObject.progression_type : undefined;
	            var progressionGoToId = appHelper.isDefined(this.state.screenObject.progression_goto_id) ? this.state.screenObject.progression_goto_id : undefined;
	            var completionData = {
	                progression: progressionRule,
	                progressionType: progressionType,
	                progressionGoToId: progressionGoToId,
	                asset_id: this.state.screenObject.asset_id,
	                status: objectConstants.STATUS_COMPLETE,
	                showProgressionButton: false,
	                asset_type_code: this.state.screenObject.asset_type_code,
	                navigateToNextScreen: !this.state.isResourceObject && appHelper.isDefined(this.state.screenObject.progression) && this.state.screenObject.progression === objectConstants.OBJECT_PROGRESSION_CONTINUE,
	                index: this.props.index
	            };
	
	            this.props.callbacks.onObjectComplete(completionData);
	            //t
	        }
	    }, {
	        key: 'onProgressionBtnClicked',
	        value: function onProgressionBtnClicked() {
	            this.setState({ showProgressionButton: false });
	            if (this.props.callbacks.hasNextObject(this.props.index) || this.state.isResourceObject) {
	                this.handleProgression();
	            } else {
	                this.props.callbacks.navigateToNextScreen();
	            }
	        }
	    }, {
	        key: 'onCloseAssetDialog',
	        value: function onCloseAssetDialog(viewed) {
	            /*let objectUserData = userDataHelper.getAttachmentObjectUserData(this.state.userData, this.state.resource.asset_id);
	            if(objectUserData.status !== objectConstants.STATUS_COMPLETE && viewed) {
	                this.updateResourceObjectResult();
	            }*/
	        }
	    }, {
	        key: 'getImageStyles',
	        value: function getImageStyles() {
	            var refValue = this.refs[this.state.refValue];
	            if (appHelper.isDefined(refValue) && refValue !== null && appHelper.isDefined(this.state.asset.asset_id) && this.state.image.src.length > 0) {
	                var assetStyles = imageHelper.checkAssetImageWidth(this.state.asset, this.state.image, refValue.offsetWidth).styles;
	
	                this.setState({
	                    updateImageStyles: false,
	                    imageStylesSet: true,
	                    imageStyles: Object.assign({}, assetStyles),
	                    imageClass: imageHelper.getAssetImageClass(this.state.asset),
	                    doShow: true
	                });
	            }
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            return _react2.default.createElement(
	                'div',
	                { className: 'object-container text-center', ref: 'image_' + this.state.screenObject.asset_id },
	                this.state.imageStylesSet ? _react2.default.createElement(
	                    'div',
	                    { className: 'library-image-object' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'asset-image-wrapper ' + this.state.imageClass, style: this.state.imageStyles },
	                        _react2.default.createElement('img', { src: this.getImagePath(this.state.image.src), alt: this.state.screenObject.name })
	                    ),
	                    appHelper.isDefined(this.state.image.credit) && this.state.image.credit.length > 0 && _react2.default.createElement(
	                        'div',
	                        { className: 'image-credit center', style: this.state.imageStyles },
	                        this.state.credit_label,
	                        ': ',
	                        this.state.image.credit
	                    )
	                ) : null,
	                this.state.showProgressionButton ? _react2.default.createElement(_Button2.default, { label: this.state.continue_label,
	                    id: this.state.screenObject + '_button',
	                    onClick: this.onProgressionBtnClicked }) : null
	            );
	        }
	    }]);
	
	    return LibraryImage;
	}(_react2.default.Component);
	
	LibraryImage.propTypes = {
	    screenObject: _propTypes2.default.object.isRequired,
	    callbacks: _propTypes2.default.object.isRequired,
	    isTracking: _propTypes2.default.bool,
	    index: _propTypes2.default.number,
	    userData: _propTypes2.default.object.isRequired,
	    lang: _propTypes2.default.string.isRequired,
	    actions: _propTypes2.default.object.isRequired
	};
	
	LibraryImage.contextTypes = {
	    router: _propTypes2.default.object
	};
	
	/*
	* <ParagraphText screenObject={this.state.screenObject}
	                                   ref={`${this.state.screenObject.asset_id}_paragraph`}
	                                   id={`${this.state.screenObject}_description`}
	                                   class_name="document-description"
	                                   objectKey={`description`}/>*/
	
	function mapStateToProps(state, ownProps) {
	    var lang = state.userData.lang;
	    return {
	        lang: lang,
	        userData: state.userData
	    };
	}
	
	function mapDispatchToProps(dispatch) {
	    return {
	        actions: (0, _redux.bindActionCreators)(Object.assign({}, userDataActions, trackingDataActions, dialogPopupActions), dispatch)
	    };
	}
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(LibraryImage);

/***/ },
/* 480 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRouter = __webpack_require__(45);
	
	var _reactRedux = __webpack_require__(5);
	
	var _redux = __webpack_require__(4);
	
	var _KpiResultReview = __webpack_require__(151);
	
	var _KpiResultReview2 = _interopRequireDefault(_KpiResultReview);
	
	var _Badge = __webpack_require__(135);
	
	var _Badge2 = _interopRequireDefault(_Badge);
	
	var _dialogPopupActions = __webpack_require__(19);
	
	var dialogPopupActions = _interopRequireWildcard(_dialogPopupActions);
	
	var _trackingDataActions = __webpack_require__(7);
	
	var trackingDataActions = _interopRequireWildcard(_trackingDataActions);
	
	var _dataHelper = __webpack_require__(11);
	
	var dataHelper = _interopRequireWildcard(_dataHelper);
	
	var _appHelper = __webpack_require__(3);
	
	var appHelper = _interopRequireWildcard(_appHelper);
	
	var _dialogHelper = __webpack_require__(202);
	
	var dialogHelper = _interopRequireWildcard(_dialogHelper);
	
	var _objectConstants = __webpack_require__(9);
	
	var objectConstants = _interopRequireWildcard(_objectConstants);
	
	var _componentConstants = __webpack_require__(49);
	
	var componentConstants = _interopRequireWildcard(_componentConstants);
	
	var _userDataHelper = __webpack_require__(15);
	
	var userDataHelper = _interopRequireWildcard(_userDataHelper);
	
	var _localStorage = __webpack_require__(17);
	
	var localStorage = _interopRequireWildcard(_localStorage);
	
	var _keyboardConstants = __webpack_require__(14);
	
	var keyboardConstants = _interopRequireWildcard(_keyboardConstants);
	
	var _dialogModels = __webpack_require__(32);
	
	var _gsap = __webpack_require__(8);
	
	var _gsapReactPlugin = __webpack_require__(10);
	
	var _gsapReactPlugin2 = _interopRequireDefault(_gsapReactPlugin);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var KpiBarGraphItem = function (_React$Component) {
	    _inherits(KpiBarGraphItem, _React$Component);
	
	    function KpiBarGraphItem(props, context) {
	        _classCallCheck(this, KpiBarGraphItem);
	
	        var _this = _possibleConstructorReturn(this, (KpiBarGraphItem.__proto__ || Object.getPrototypeOf(KpiBarGraphItem)).call(this, props, context));
	
	        _this.state = {
	            lang: _this.props.lang,
	            guid: dataHelper.createGuid(),
	            userData: _this.props.userData,
	            kpiData: _this.props.kpiData,
	            userDataKpi: _this.props.userDataKpi,
	            tooltipId: 'tooltip_' + _this.props.userDataKpi.asset_id,
	            optionDetails: _this.props.userDataKpi.option_id.length > 0 ? appHelper.getOptionParentDetails(_this.props.userDataKpi.option_id[0]) : appHelper.getAssetParentDetails(_this.props.userDataKpi.asset_id),
	            objectLocale: {},
	            //kpiDefaults: appHelper.getArrayObjectByKey(this.props.bite.kpis, "code", this.props.kpi_id),
	            showTooltip: false,
	            currentTooltipId: _this.props.currentTooltipId,
	            checkTooltipState: false,
	            responseData: {},
	            //badges
	            badgesEarned: [],
	            checkBadgeEarned: false,
	            showAchievedState: false,
	            showAchievedCount: false,
	            //
	            updateTooltip: false,
	            updateChart: false,
	            review_response_label: appHelper.getLocaleString("review_response_label"),
	            go_to_screen_label: appHelper.getLocaleString("go_to_screen_label")
	        };
	
	        _this.setObjectLocale = _this.setObjectLocale.bind(_this);
	        _this.setResponseData = _this.setResponseData.bind(_this);
	        _this.setSingleAnswerResponseData = _this.setSingleAnswerResponseData.bind(_this);
	        _this.setMultiAnswerResponseData = _this.setMultiAnswerResponseData.bind(_this);
	        _this.setSelfRatingResponseData = _this.setSelfRatingResponseData.bind(_this);
	        _this.setItemHeight = _this.setItemHeight.bind(_this);
	        _this.setGraphItemClass = _this.setGraphItemClass.bind(_this);
	        _this.setToolTipClass = _this.setToolTipClass.bind(_this);
	        _this.onReviewObject = _this.onReviewObject.bind(_this);
	        _this.setTooltipVisibility = _this.setTooltipVisibility.bind(_this);
	        _this.onToolGraphItemHit = _this.onToolGraphItemHit.bind(_this);
	        _this.onToolGraphItemClicked = _this.onToolGraphItemClicked.bind(_this);
	        _this.toggleTooltip = _this.toggleTooltip.bind(_this);
	        _this.showTooltip = _this.showTooltip.bind(_this);
	        _this.hideTooltip = _this.hideTooltip.bind(_this);
	        _this.goToScreen = _this.goToScreen.bind(_this);
	        //badges
	        _this.checkBadgeEarnedOnObject = _this.checkBadgeEarnedOnObject.bind(_this);
	        _this.getBadge = _this.getBadge.bind(_this);
	        _this.onToolGraphItemKeyboardAccessed = _this.onToolGraphItemKeyboardAccessed.bind(_this);
	        _this.goToScreenKeyBoardAccessed = _this.goToScreenKeyBoardAccessed.bind(_this);
	        return _this;
	    }
	
	    _createClass(KpiBarGraphItem, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            this.setTooltipVisibility();
	            this.setResponseData();
	            this.setObjectLocale();
	            this.setItemHeight();
	            this.checkBadgeEarnedOnObject();
	        }
	    }, {
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(nextProps) {
	            if (this.state.userData !== nextProps.userData) {
	                this.setState({
	                    userData: Object.assign({}, nextProps.userData),
	                    checkBadgeEarnedOnObject: true
	                });
	            }
	            if (this.state.currentTooltipId !== nextProps.currentTooltipId) {
	                this.setState({ currentTooltipId: nextProps.currentTooltipId, updateTooltip: true });
	            }
	
	            if (this.state.userDataKpi !== nextProps.userDataKpi) {
	                this.setState({
	                    userDataKpi: Object.assign({}, nextProps.userDataKpi),
	                    updateChart: true
	                    //optionDetails: appHelper.getOptionParentDetails(nextProps.option_id[0]),
	                    //tooltipId: `tooltip_${nextProps.userDataKpi.option_id[0]}`,
	                });
	            }
	
	            if (this.state.kpiData !== nextProps.kpiData) {
	                this.setState({ kpiData: Object.assign({}, nextProps.kpiData), updateChart: true });
	            }
	
	            if (this.state.lang !== nextProps.lang) {
	                this.setState({
	                    lang: nextProps.lang,
	                    objectLocale: appHelper.getLocalData(this.state.optionDetails.object),
	                    review_response_label: appHelper.getLocaleString("review_response_label"),
	                    go_to_screen_label: appHelper.getLocaleString("go_to_screen_label")
	                });
	            }
	        }
	    }, {
	        key: 'componentDidUpdate',
	        value: function componentDidUpdate() {
	            if (this.checkBadgeEarned) {
	                this.checkBadgeEarnedOnObject();
	            }
	
	            if (this.state.updateTooltip) {
	                this.setTooltipVisibility();
	            }
	
	            if (this.state.updateChart) {
	                this.setItemHeight();
	                this.setObjectLocale();
	            }
	        }
	    }, {
	        key: 'setResponseData',
	        value: function setResponseData() {
	            if (this.props.userDataKpi.option_id.length > 0) {
	                if (this.props.userDataKpi.option_id.length === 1 && this.state.optionDetails.object.selection_type !== objectConstants.SELECTION_TYPE_SELECT_MANY) {
	                    this.setSingleAnswerResponseData();
	                } else {
	                    this.setMultiAnswerResponseData();
	                }
	            } else {
	                this.setSelfRatingResponseData();
	            }
	        }
	    }, {
	        key: 'setSingleAnswerResponseData',
	        value: function setSingleAnswerResponseData() {
	            var responses = [];
	            var response = {
	                selectedOption: this.state.optionDetails.option
	            };
	            this.setState({
	                responseData: Object.assign({}, this.state.responseData, {
	                    bite_id: this.state.optionDetails.bite.bite_id,
	                    screen_id: this.state.optionDetails.screen.screen_id,
	                    object_id: this.state.optionDetails.object.object_id,
	                    currentAttempt: 1,
	                    currentStatus: objectConstants.STATUS_COMPLETE,
	                    displayState: objectConstants.OBJECT_DISPLAY_STATE_REVIEW,
	                    responses: dataHelper.immutablePush(responses, response),
	                    latestResponse: this.state.optionDetails.option
	                })
	            });
	        }
	    }, {
	        key: 'setMultiAnswerResponseData',
	        value: function setMultiAnswerResponseData() {
	            this.setState({
	                responseData: Object.assign({}, this.state.responseData, {
	                    bite_id: this.state.optionDetails.bite.bite_id,
	                    screen_id: this.state.optionDetails.screen.screen_id,
	                    object_id: this.state.optionDetails.object.object_id,
	                    currentAttempt: 1,
	                    currentStatus: objectConstants.STATUS_COMPLETE,
	                    displayState: objectConstants.OBJECT_DISPLAY_STATE_REVIEW,
	                    userSelections: appHelper.getObjectCheckedOptionsByKpiHistoryOptions(this.props.userDataKpi.option_id),
	                    checkedOptions: appHelper.getObjectCheckedOptionsByKpiHistoryOptions(this.props.userDataKpi.option_id),
	                    outcome: appHelper.getObjectOutcomeByKpiHistoryOptions(this.props.userDataKpi.option_id)
	                })
	            });
	        }
	    }, {
	        key: 'setSelfRatingResponseData',
	        value: function setSelfRatingResponseData() {
	            this.setState({
	                responseData: Object.assign({}, this.state.responseData, {
	                    bite_id: this.state.optionDetails.bite.bite_id,
	                    screen_id: this.state.optionDetails.screen.screen_id,
	                    object_id: this.state.optionDetails.object.asset_id,
	                    asset_id: this.state.optionDetails.object.asset_id,
	                    currentAttempt: 1,
	                    currentStatus: objectConstants.STATUS_COMPLETE,
	                    displayState: objectConstants.OBJECT_DISPLAY_STATE_REVIEW,
	                    kpis: [{
	                        kpi_id: this.props.kpi_id,
	                        value: appHelper.isDefined(this.state.userDataKpi.statusIndicatorClass.value) && !isNaN(this.state.userDataKpi.statusIndicatorClass.value) ? this.state.userDataKpi.statusIndicatorClass.value : null
	                    }]
	                })
	            });
	        }
	    }, {
	        key: 'setObjectLocale',
	        value: function setObjectLocale() {
	            var locale = appHelper.getLocalData(this.state.optionDetails.object);
	            this.setState({ objectLocale: Object.assign({}, locale) });
	        }
	    }, {
	        key: 'setItemHeight',
	        value: function setItemHeight() {
	            this.setState({ updateChart: false });
	            var itemHeight = dataHelper.getRangePercentage(this.props.min, this.props.max, this.props.userDataKpi.current);
	            var itemWidth = 100 / this.props.totalItems;
	            var leftPos = itemWidth * this.props.index;
	            var item = this.refs[this.state.userDataKpi.asset_id];
	            _gsap.TweenLite.set(item, {
	                height: itemHeight + '%',
	                width: itemWidth + '%',
	                left: leftPos + '%',
	                opacity: 1
	            });
	            _gsap.TweenLite.from(item, 0, {
	                height: 0,
	                width: itemWidth + '%',
	                left: leftPos + '%',
	                opacity: 0,
	                ease: _gsap.Expo.easeInOut
	            });
	        }
	    }, {
	        key: 'setGraphItemClass',
	        value: function setGraphItemClass() {
	            var itemClass = "";
	            //console.log(this.state.userDataKpi);
	            //console.log(`statusIndicatorClass`,this.state.userDataKpi.statusIndicatorClass);
	            if (appHelper.isDefined(this.state.userDataKpi.statusIndicatorClass)) {
	                if (this.state.userDataKpi.statusIndicatorClass.class === "negative-single" || this.state.userDataKpi.statusIndicatorClass.class === "negative-double") {
	                    itemClass += "negative ";
	                } else if (this.state.userDataKpi.statusIndicatorClass.class === "positive-single" || this.state.userDataKpi.statusIndicatorClass.class === "positive-double") {
	                    itemClass += "positive ";
	                } else if (!this.state.userDataKpi.hasValue) {
	                    itemClass += "reflective ";
	                } else {
	                    itemClass += "neutral ";
	                }
	            } else {
	                itemClass += "reflective ";
	            }
	
	            if (this.state.currentTooltipId === this.state.tooltipId) {
	                itemClass += "active ";
	            }
	
	            if (this.state.badgesEarned.length > 0) {
	                itemClass += "has-badges";
	            }
	
	            return itemClass;
	        }
	    }, {
	        key: 'setToolTipClass',
	        value: function setToolTipClass() {
	            if (this.props.index + 1 <= this.props.totalItems / 2 || this.props.totalItems <= 2) {
	                return "left";
	            } else {
	                return "right";
	            }
	        }
	    }, {
	        key: 'onReviewObject',
	        value: function onReviewObject() {
	            var reviewActionCongigType = _dialogModels.LEANER_ACTION_REVIEW_CONFIG;
	
	            if (this.state.optionDetails.object.object_type === componentConstants.MULTIPLE_CHOICE || this.state.optionDetails.object.object_type === componentConstants.GRID_CHOICE || this.state.optionDetails.object.object_type === componentConstants.SWIPE_HORIZONTAL) {
	                if (this.state.optionDetails.object.selection_type === objectConstants.SELECTION_TYPE_SELECT_ONE) {
	                    reviewActionCongigType = _dialogModels.MULTIPLE_CHOICE_REVIEW_CONFIG;
	                } else if (this.state.optionDetails.object.selection_type === objectConstants.SELECTION_TYPE_SELECT_MANY) {
	                    reviewActionCongigType = _dialogModels.MULTIPLE_ANSWER_REVIEW_CONFIG;
	                }
	            } else if (this.state.optionDetails.object.object_type === componentConstants.SHORT_RESPONSE) {
	
	                reviewActionCongigType = _dialogModels.SHORT_ANSWER_REVIEW_CONFIG;
	            }
	
	            var config = Object.assign({}, reviewActionCongigType, {
	                title: this.state.objectLocale.label,
	                sourceId: '' + this.state.userDataKpi.asset_id
	            });
	
	            for (var i = 0; i < config.childComponents.length; i++) {
	                var child = config.childComponents[i];
	                child.componentProps = Object.assign({}, {
	                    screenObject: this.state.optionDetails.object,
	                    responseData: Object.assign({}, this.state.responseData)
	                });
	            }
	
	            this.props.actions.setNewDialog(config);
	        }
	    }, {
	        key: 'toggleTooltip',
	        value: function toggleTooltip() {
	            this.setState({ showTooltip: !this.state.showTooltip });
	        }
	    }, {
	        key: 'onToolGraphItemHit',
	        value: function onToolGraphItemHit(event) {
	            if (this.state.tooltipId !== this.state.currentTooltipId) {
	                this.props.onSetTooltip(this.state.tooltipId);
	            }
	        }
	    }, {
	        key: 'onToolGraphItemClicked',
	        value: function onToolGraphItemClicked(event) {
	            /*if(this.state.tooltipId !== this.state.currentTooltipId){
	                this.props.onSetTooltip(this.state.tooltipId);
	            }*/
	            this.onReviewObject();
	        }
	    }, {
	        key: 'onToolGraphItemKeyboardAccessed',
	        value: function onToolGraphItemKeyboardAccessed(event) {
	            if (event.which === keyboardConstants.ENTER_KEY || event.which === keyboardConstants.SPACEBAR_KEY) {
	                event.preventDefault();
	                this.onReviewObject();
	            }
	        }
	    }, {
	        key: 'setTooltipVisibility',
	        value: function setTooltipVisibility() {
	            this.setState({ updateTooltip: false });
	            if (this.state.currentTooltipId === this.state.tooltipId) {
	                this.showTooltip();
	            } else {
	                this.hideTooltip();
	            }
	        }
	    }, {
	        key: 'showTooltip',
	        value: function showTooltip() {
	            this.setState({ showTooltip: true });
	        }
	    }, {
	        key: 'hideTooltip',
	        value: function hideTooltip() {
	            this.setState({ showTooltip: false });
	        }
	    }, {
	        key: 'goToScreen',
	        value: function goToScreen(event) {
	            event.stopPropagation();
	            var screen_id = this.state.optionDetails.screen.screen_id;
	            this.props.actions.setNewLessonLocation(screen_id);
	        }
	    }, {
	        key: 'goToScreenKeyBoardAccessed',
	        value: function goToScreenKeyBoardAccessed(event) {
	            if (event.which === keyboardConstants.ENTER_KEY || event.which === keyboardConstants.SPACEBAR_KEY) {
	                event.preventDefault();
	                event.stopPropagation();
	                var screen_id = this.state.optionDetails.screen.screen_id;
	                this.props.actions.setNewLessonLocation(screen_id);
	            }
	        }
	    }, {
	        key: 'checkBadgeEarnedOnObject',
	        value: function checkBadgeEarnedOnObject() {
	            var params = {
	                bite_id: this.state.optionDetails.bite.bite_id,
	                asset_id: this.state.optionDetails.object.asset_id
	            };
	
	            var badgesEarned = userDataHelper.checkBadgeEarnedOnObject(this.state.userData, params);
	            this.setState({
	                checkBadgesEarned: false,
	                badgesEarned: Object.assign([], badgesEarned)
	            });
	        }
	    }, {
	        key: 'getBadge',
	        value: function getBadge(badge_id) {
	            var badges = appHelper.getArrayObjectByKey(localStorage.bites, "bite_id", this.state.optionDetails.bite.bite_id).badges;
	            return appHelper.getArrayObjectByKey(badges, "badge_id", badge_id);
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this2 = this;
	
	            return _react2.default.createElement(
	                'div',
	                { className: 'graph-item ' + this.setGraphItemClass(), ref: this.state.userDataKpi.asset_id, id: this.state.userDataKpi.asset_id, onMouseEnter: this.onToolGraphItemHit, onFocus: this.onToolGraphItemHit, onClick: this.onToolGraphItemClicked, onKeyDown: this.onToolGraphItemKeyboardAccessed, role: 'link', tabIndex: '0' },
	                this.state.badgesEarned.length ? _react2.default.createElement('div', { className: 'badge-earned' }) : null,
	                _react2.default.createElement('div', { className: 'graph-item-marker' }),
	                this.state.showTooltip ? _react2.default.createElement(
	                    'div',
	                    { className: 'graph-item-tool-tip ' + this.setToolTipClass() + ' ' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'tool-tip-title' },
	                        _react2.default.createElement(
	                            'span',
	                            null,
	                            this.state.objectLocale.label
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'flex-row' },
	                        this.state.badgesEarned.length > 0 ? _react2.default.createElement(
	                            'div',
	                            { className: 'flex-item' },
	                            _react2.default.createElement(
	                                'ul',
	                                { className: 'badge-grid' },
	                                this.state.badgesEarned.map(function (badge) {
	                                    return _react2.default.createElement(
	                                        'li',
	                                        { key: badge.badge_id, className: 'badge-grid-item' },
	                                        _react2.default.createElement(_Badge2.default, { badge: _this2.getBadge(badge.badge_id),
	                                            userBadge: badge,
	                                            showAchievedCount: _this2.state.showAchievedCount,
	                                            showAchievedState: _this2.state.showAchievedState })
	                                    );
	                                })
	                            )
	                        ) : null,
	                        this.props.userDataKpi.hasValue ? _react2.default.createElement(
	                            'div',
	                            { className: 'flex-item' },
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'kpi-meter-wrapper' },
	                                _react2.default.createElement(_KpiResultReview2.default, { kpiDefaults: this.state.kpiData,
	                                    kpi: { value: this.props.userDataKpi.statusIndicatorClass.value, kpi_id: this.props.userDataKpi.kpi_id } })
	                            )
	                        ) : null
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'inline-content mobile-block even-widths text-center' },
	                        _react2.default.createElement('div', { className: 'content-item-review  guroo-active-link no-wrap ', id: 'link_' + this.state.userDataKpi.asset_id, onClick: this.onReviewObject, onKeyDown: this.onToolGraphItemKeyboardAccessed, role: 'link', tabIndex: '0', dangerouslySetInnerHTML: { __html: this.state.review_response_label } })
	                    )
	                ) : null,
	                this.state.showTooltip ? _react2.default.createElement('div', { className: 'graph-item-tool-tip-arrow' }) : null
	            );
	        }
	    }]);
	
	    return KpiBarGraphItem;
	}(_react2.default.Component);
	
	/*
	*  <div className="content-item-spacer "/>
	                            <div className="content-item-review  guroo-active-link no-wrap" onClick={this.goToScreen} onKeyDown={this.goToScreenKeyBoardAccessed} role="link" tabIndex="0" dangerouslySetInnerHTML={{__html: this.state.go_to_screen_label}} />
	* */
	
	KpiBarGraphItem.propTypes = {
	    kpi_id: _propTypes2.default.number.isRequired,
	    kpiData: _propTypes2.default.object.isRequired,
	    userDataKpi: _propTypes2.default.object.isRequired,
	    totalItems: _propTypes2.default.number.isRequired,
	    index: _propTypes2.default.number.isRequired,
	    min: _propTypes2.default.number.isRequired,
	    max: _propTypes2.default.number.isRequired,
	    currentTooltipId: _propTypes2.default.string.isRequired,
	    onSetTooltip: _propTypes2.default.func.isRequired,
	    userData: _propTypes2.default.object.isRequired,
	    lang: _propTypes2.default.string.isRequired,
	    actions: _propTypes2.default.object
	
	};
	
	KpiBarGraphItem.contextTypes = {
	    router: _propTypes2.default.object
	};
	
	function mapStateToProps(state, ownProps) {
	    var lang = state.userData.lang;
	    return {
	        lang: lang,
	        userData: state.userData
	    };
	}
	
	function mapDispatchToProps(dispatch) {
	    return {
	        actions: (0, _redux.bindActionCreators)(Object.assign({}, dialogPopupActions, trackingDataActions), dispatch)
	    };
	}
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(KpiBarGraphItem);

/***/ },
/* 481 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRouter = __webpack_require__(45);
	
	var _reactRedux = __webpack_require__(5);
	
	var _redux = __webpack_require__(4);
	
	var _RotationKpiMeter = __webpack_require__(82);
	
	var _RotationKpiMeter2 = _interopRequireDefault(_RotationKpiMeter);
	
	var _appDataActions = __webpack_require__(12);
	
	var appDataActions = _interopRequireWildcard(_appDataActions);
	
	var _trackingDataActions = __webpack_require__(7);
	
	var trackingDataActions = _interopRequireWildcard(_trackingDataActions);
	
	var _dialogPopupActions = __webpack_require__(19);
	
	var dialogPopupActions = _interopRequireWildcard(_dialogPopupActions);
	
	var _appHelper = __webpack_require__(3);
	
	var appHelper = _interopRequireWildcard(_appHelper);
	
	var _kpiHelper = __webpack_require__(35);
	
	var kpiHelper = _interopRequireWildcard(_kpiHelper);
	
	var _kpiModels = __webpack_require__(57);
	
	var kpiModels = _interopRequireWildcard(_kpiModels);
	
	var _keyboardConstants = __webpack_require__(14);
	
	var keyboardConstants = _interopRequireWildcard(_keyboardConstants);
	
	var _componentConstants = __webpack_require__(49);
	
	var _dialogModels = __webpack_require__(32);
	
	var _kpiConstants = __webpack_require__(37);
	
	var kpiConstants = _interopRequireWildcard(_kpiConstants);
	
	var _gsap = __webpack_require__(8);
	
	var _gsapReactPlugin = __webpack_require__(10);
	
	var _gsapReactPlugin2 = _interopRequireDefault(_gsapReactPlugin);
	
	var _reactDom = __webpack_require__(55);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var KpiButton = function (_React$Component) {
	    _inherits(KpiButton, _React$Component);
	
	    function KpiButton(props, context) {
	        _classCallCheck(this, KpiButton);
	
	        var _this = _possibleConstructorReturn(this, (KpiButton.__proto__ || Object.getPrototypeOf(KpiButton)).call(this, props, context));
	
	        _this.state = {
	            staticKpiData: _this.props.kpis,
	            staticPrimaryKpi: kpiHelper.getPrimaryKpi(_this.props.kpis),
	            userBite: _this.props.userBite,
	            primaryKpi: _this.props.primaryKpi,
	            ariaHasPopup: true,
	            lang: _this.props.lang,
	            label: appHelper.getLocaleString("performance_btn_label")
	        };
	
	        _this.setBtnClass = _this.setBtnClass.bind(_this);
	        _this.setKeyboardAccessibility = _this.setKeyboardAccessibility.bind(_this);
	        _this.onClickFunc = _this.onClickFunc.bind(_this);
	
	        return _this;
	    }
	
	    _createClass(KpiButton, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {}
	    }, {
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(nextProps) {
	            if (appHelper.isDefined(this.state.primaryKpi) && appHelper.isDefined(nextProps.primaryKpi) && this.state.primaryKpi.current !== nextProps.primaryKpi.current) {
	                this.setState({
	                    userBite: Object.assign({}, nextProps.userBite),
	                    primaryKpi: Object.assign({}, nextProps.primaryKpi)
	                });
	            }
	
	            if (this.state.lang !== nextProps.lang) {
	                this.setState({
	                    lang: nextProps.lang,
	                    label: appHelper.getLocaleString("performance_btn_label")
	                });
	            }
	        }
	    }, {
	        key: 'setBtnClass',
	        value: function setBtnClass() {
	            return this.props.disabled ? "disabled" : "";
	        }
	    }, {
	        key: 'onClickFunc',
	        value: function onClickFunc() {
	            this.props.onClickFunc("performanceBtn");
	        }
	    }, {
	        key: 'setKeyboardAccessibility',
	        value: function setKeyboardAccessibility(event) {
	            if (event.which === keyboardConstants.ENTER_KEY || event.which === keyboardConstants.SPACEBAR_KEY) {
	                event.preventDefault();
	                this.onClickFunc();
	            }
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var Component = _componentConstants.COMPONENT_TOOLTIP_OBJECT;
	            return appHelper.isDefined(this.state.staticPrimaryKpi) ? _react2.default.createElement(
	                'div',
	                { className: 'kpi-btn ' + this.setBtnClass(), onClick: this.onClickFunc, onKeyDown: this.setKeyboardAccessibility, role: 'link', tabIndex: !this.props.disabled ? "0" : "-1", id: 'performanceBtn', 'aria-controls': 'performance', title: this.state.label, 'aria-haspopup': this.state.ariaHasPopup, 'aria-disabled': this.props.disabled },
	                _react2.default.createElement(_RotationKpiMeter2.default, { bite_id: this.state.userBite.bite_id, kpiDefaults: this.state.staticPrimaryKpi, meterParams: kpiModels.HEADER_KPI_ROTATION_METER_PARAMS, displayState: kpiConstants.KPI_DISPLAY_STATE_CURRENT_VALUE_NO_LABEL })
	            ) : _react2.default.createElement(
	                'div',
	                { className: 'header-btn performance-btn', onClick: this.onClickFunc, onKeyDown: this.setKeyboardAccessibility, role: 'link', tabIndex: !this.props.disabled ? "0" : "-1", id: 'performanceBtn', 'aria-controls': 'performance', title: this.state.label, 'aria-haspopup': this.state.ariaHasPopup, 'aria-disabled': this.props.disabled },
	                _react2.default.createElement('div', { className: 'icon icons8-speed-2' }),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'btn-label' },
	                    this.state.label
	                )
	            );
	        }
	    }]);
	
	    return KpiButton;
	}(_react2.default.Component);
	
	KpiButton.propTypes = {
	    onClickFunc: _propTypes2.default.func.isRequired,
	    disabled: _propTypes2.default.bool.isRequired,
	    bite_id: _propTypes2.default.number.isRequired,
	    kpis: _propTypes2.default.array.isRequired,
	    userBite: _propTypes2.default.object.isRequired,
	    primaryKpi: _propTypes2.default.object,
	    lang: _propTypes2.default.string.isRequired,
	    actions: _propTypes2.default.object.isRequired
	};
	
	KpiButton.contextTypes = {
	    router: _propTypes2.default.object
	};
	
	function mapStateToProps(state, ownProps) {
	    var userBite = appHelper.getArrayObjectByKey(state.userData.bites, "bite_id", ownProps.bite_id);
	    var lang = state.userData.lang;
	    return {
	        userBite: userBite,
	        primaryKpi: kpiHelper.getPrimaryKpi(userBite.kpis),
	        lang: lang
	    };
	}
	
	function mapDispatchToProps(dispatch) {
	    return {
	        actions: (0, _redux.bindActionCreators)(Object.assign({}, trackingDataActions, appDataActions, dialogPopupActions), dispatch)
	    };
	}
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(KpiButton);

/***/ },
/* 482 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRouter = __webpack_require__(45);
	
	var _reactRedux = __webpack_require__(5);
	
	var _redux = __webpack_require__(4);
	
	var _KpiBarGraphItem = __webpack_require__(480);
	
	var _KpiBarGraphItem2 = _interopRequireDefault(_KpiBarGraphItem);
	
	var _appDataActions = __webpack_require__(12);
	
	var appDataActions = _interopRequireWildcard(_appDataActions);
	
	var _trackingDataActions = __webpack_require__(7);
	
	var trackingDataActions = _interopRequireWildcard(_trackingDataActions);
	
	var _dataHelper = __webpack_require__(11);
	
	var dataHelper = _interopRequireWildcard(_dataHelper);
	
	var _appHelper = __webpack_require__(3);
	
	var appHelper = _interopRequireWildcard(_appHelper);
	
	var _kpiHelper = __webpack_require__(35);
	
	var kpiHelper = _interopRequireWildcard(_kpiHelper);
	
	var _kpiConstants = __webpack_require__(37);
	
	var kpiConstants = _interopRequireWildcard(_kpiConstants);
	
	var _kpiModels = __webpack_require__(57);
	
	var kpiModels = _interopRequireWildcard(_kpiModels);
	
	var _gsap = __webpack_require__(8);
	
	var _gsapReactPlugin = __webpack_require__(10);
	
	var _gsapReactPlugin2 = _interopRequireDefault(_gsapReactPlugin);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var KpiGraph = function (_React$Component) {
	    _inherits(KpiGraph, _React$Component);
	
	    function KpiGraph(props, context) {
	        _classCallCheck(this, KpiGraph);
	
	        var _this = _possibleConstructorReturn(this, (KpiGraph.__proto__ || Object.getPrototypeOf(KpiGraph)).call(this, props, context));
	
	        _this.state = {
	            lang: _this.props.lang,
	            userDataKpi: _this.props.userDataKpi,
	            kpiData: _this.props.kpiData,
	            locale: appHelper.getLocalData(_this.props.kpiData),
	            activeKpi: {},
	            activeKpiLocale: {},
	            updateChart: false,
	            currentTooltipId: ""
	        };
	
	        _this.setZoneMarkers = _this.setZoneMarkers.bind(_this);
	        _this.setCurrentToolTipId = _this.setCurrentToolTipId.bind(_this);
	        _this.clearCurrentToolTipId = _this.clearCurrentToolTipId.bind(_this);
	        return _this;
	    }
	
	    _createClass(KpiGraph, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            this.setZoneMarkers();
	        }
	    }, {
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(nextProps) {
	            if (this.state.userDataKpi !== nextProps.userDataKpi) {
	                this.setState({ userDataKpi: Object.assign({}, nextProps.userDataKpi), updateChart: true });
	            }
	
	            if (this.state.kpiData !== nextProps.kpiData) {
	                this.setState({ kpiData: Object.assign({}, nextProps.kpiData), locale: appHelper.getLocalData(nextProps.kpiData), updateChart: true });
	            }
	
	            if (this.state.lang !== nextProps.lang) {
	                this.setState({
	                    lang: nextProps.lang,
	                    locale: appHelper.getLocalData(this.state.kpiData),
	                    updateChart: true
	                });
	            }
	        }
	    }, {
	        key: 'componentDidUpdate',
	        value: function componentDidUpdate() {
	            if (this.state.updateChart) {
	                this.setZoneMarkers();
	            }
	        }
	    }, {
	        key: 'setZoneMarkers',
	        value: function setZoneMarkers() {
	            var yellowZoneHeight = dataHelper.getRangePercentage(this.props.userDataKpi.min, this.props.userDataKpi.max, this.props.userDataKpi.yellow);
	            var greenZoneHeight = dataHelper.getRangePercentage(this.props.userDataKpi.min, this.props.userDataKpi.max, this.props.userDataKpi.green);
	            var yellowZoneMarker = this.refs.yellowZoneMarker;
	            var greenZoneMarker = this.refs.greenZoneMarker;
	            var minZoneMarker = this.refs.minZoneMarker;
	            var maxZoneMarker = this.refs.maxZoneMarker;
	            _gsap.TweenLite.set(yellowZoneMarker, { height: yellowZoneHeight + '%' });
	            _gsap.TweenLite.set(greenZoneMarker, { height: greenZoneHeight + '%' });
	            _gsap.TweenLite.set(minZoneMarker, { height: '2%' });
	            _gsap.TweenLite.set(maxZoneMarker, { height: '100%' });
	            /*TweenLite.from(yellowZoneMarker, 0.3, {
	                height: 0,
	                opacity: 0,
	                ease: Expo.easeInOut
	            });
	            TweenLite.from(greenZoneMarker, 0.3, {
	                height: 0,
	                opacity: 0,
	                ease: Expo.easeInOut
	            });*/
	            this.setState({
	                updateChart: false
	            });
	        }
	    }, {
	        key: 'setCurrentToolTipId',
	        value: function setCurrentToolTipId(tooltipId) {
	            this.setState({
	                currentTooltipId: tooltipId
	            });
	        }
	    }, {
	        key: 'clearCurrentToolTipId',
	        value: function clearCurrentToolTipId() {
	            this.setState({
	                currentTooltipId: ""
	            });
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this2 = this;
	
	            return _react2.default.createElement(
	                'div',
	                { className: 'kpi-graph-container', ref: 'kpi-graph', onMouseLeave: this.clearCurrentToolTipId },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'graph-y-title' },
	                    this.state.locale.long_title
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'kpi-graph' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'zone-marker', ref: 'maxZoneMarker' },
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'zone-marker-label' },
	                            this.props.userDataKpi.max
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'yellow-zone-marker', ref: 'yellowZoneMarker' },
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'zone-marker-label' },
	                            this.props.userDataKpi.yellow
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'green-zone-marker', ref: 'greenZoneMarker' },
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'zone-marker-label' },
	                            this.props.userDataKpi.green
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'zone-marker', ref: 'minZoneMarker' },
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'zone-marker-label' },
	                            this.props.userDataKpi.min
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'bar-graph-items' },
	                        this.state.userDataKpi.history.map(function (kpi) {
	                            return _react2.default.createElement(_KpiBarGraphItem2.default, { key: '' + kpi.asset_id,
	                                kpi_id: _this2.state.userDataKpi.kpi_id,
	                                kpiData: _this2.state.kpiData,
	                                userDataKpi: kpi,
	                                min: _this2.props.userDataKpi.min,
	                                max: _this2.props.userDataKpi.max,
	                                totalItems: _this2.props.userDataKpi.history.length,
	                                index: appHelper.getArrayObjectIndexByKey(_this2.state.userDataKpi.history, "option_id", kpi.option_id),
	                                currentTooltipId: _this2.state.currentTooltipId,
	                                onSetTooltip: _this2.setCurrentToolTipId });
	                        })
	                    )
	                )
	            );
	        }
	    }]);
	
	    return KpiGraph;
	}(_react2.default.Component);
	
	KpiGraph.propTypes = {
	    userDataKpi: _propTypes2.default.object.isRequired,
	    kpiData: _propTypes2.default.object.isRequired,
	    lang: _propTypes2.default.string.isRequired
	};
	
	KpiGraph.contextTypes = {
	    router: _propTypes2.default.object
	};
	
	function mapStateToProps(state, ownProps) {
	    var lang = state.userData.lang;
	    return {
	        lang: lang
	    };
	}
	
	function mapDispatchToProps(dispatch) {
	    return {
	        actions: (0, _redux.bindActionCreators)(Object.assign({}, trackingDataActions, appDataActions), dispatch)
	    };
	}
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(KpiGraph);

/***/ },
/* 483 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(5);
	
	var _redux = __webpack_require__(4);
	
	var _Button = __webpack_require__(18);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _KpiGraph = __webpack_require__(482);
	
	var _KpiGraph2 = _interopRequireDefault(_KpiGraph);
	
	var _KpiResultsPanel = __webpack_require__(282);
	
	var _KpiResultsPanel2 = _interopRequireDefault(_KpiResultsPanel);
	
	var _appDataActions = __webpack_require__(12);
	
	var appDataActions = _interopRequireWildcard(_appDataActions);
	
	var _trackingDataActions = __webpack_require__(7);
	
	var trackingDataActions = _interopRequireWildcard(_trackingDataActions);
	
	var _appConstants = __webpack_require__(13);
	
	var appConstants = _interopRequireWildcard(_appConstants);
	
	var _appHelper = __webpack_require__(3);
	
	var appHelper = _interopRequireWildcard(_appHelper);
	
	var _userDataHelper = __webpack_require__(15);
	
	var userDataHelper = _interopRequireWildcard(_userDataHelper);
	
	var _objectConstants = __webpack_require__(9);
	
	var objectConstants = _interopRequireWildcard(_objectConstants);
	
	var _kpiHelper = __webpack_require__(35);
	
	var kpiHelper = _interopRequireWildcard(_kpiHelper);
	
	var _dataHelper = __webpack_require__(11);
	
	var dataHelper = _interopRequireWildcard(_dataHelper);
	
	var _localStorage = __webpack_require__(17);
	
	var localStorage = _interopRequireWildcard(_localStorage);
	
	var _gsap = __webpack_require__(8);
	
	var _gsapReactPlugin = __webpack_require__(10);
	
	var _gsapReactPlugin2 = _interopRequireDefault(_gsapReactPlugin);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } //eslint-disable-line import/no-named-as-default
	//eslint-disable-line import/no-named-as-default
	//eslint-disable-line import/no-named-as-default
	
	
	var KpiGraphResults = function (_React$Component) {
	    _inherits(KpiGraphResults, _React$Component);
	
	    function KpiGraphResults(props, context) {
	        _classCallCheck(this, KpiGraphResults);
	
	        var _this = _possibleConstructorReturn(this, (KpiGraphResults.__proto__ || Object.getPrototypeOf(KpiGraphResults)).call(this, props, context));
	
	        _this.state = {
	            lang: _this.props.lang,
	            screenObject: _this.props.screenObject,
	            userData: _this.props.userData,
	            userDataKpis: appHelper.getArrayObjectByKey(_this.props.userData.bites, "bite_id", _this.props.callbacks.getBiteId()).kpis,
	            renderableKpis: [],
	            completeKpis: [],
	            activeKpi: {},
	            status: objectConstants.STATUS_NOT_STARTED,
	            locale: appHelper.getLocalData(_this.props.screenObject),
	            showProgressionButton: false,
	            icon: {
	                src: ""
	            },
	            screenStatus: "",
	            checkComplete: false,
	            updateKpis: false,
	            kpiMenuData: {
	                menu: [],
	                currentKpi: {},
	                onMenuSelect: {},
	                idKey: "kpi_id",
	                labelKey: "label"
	            },
	            allowScroll: appHelper.allowScroll(_this.props.callbacks.getBiteId(), _this.props.callbacks.getScreenId(), _this.props.screenObject.asset_id),
	            isComplete: false,
	            progressionHandled: false,
	            continue_label: appHelper.getLocaleString("continue_label")
	        };
	        _this.handleProgression = _this.handleProgression.bind(_this);
	        _this.scrollToTop = _this.scrollToTop.bind(_this);
	        _this.onComplete = _this.onComplete.bind(_this);
	        _this.enableProgression = _this.enableProgression.bind(_this);
	        _this.disableProgression = _this.disableProgression.bind(_this);
	        _this.getAssets = _this.getAssets.bind(_this);
	        _this.getImagePath = _this.getImagePath.bind(_this);
	        _this.show = _this.show.bind(_this);
	        _this.onShowComplete = _this.onShowComplete.bind(_this);
	        _this.onProgressionBtnClicked = _this.onProgressionBtnClicked.bind(_this);
	        _this.getScreenStatus = _this.getScreenStatus.bind(_this);
	        _this.getObjectStatus = _this.getObjectStatus.bind(_this);
	        _this.getKpisToDisplay = _this.getKpisToDisplay.bind(_this);
	        _this.onSelectKpi = _this.onSelectKpi.bind(_this);
	        _this.onKpiComplete = _this.onKpiComplete.bind(_this);
	        return _this;
	    }
	
	    _createClass(KpiGraphResults, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            var biteData = appHelper.getArrayObjectByKey(localStorage.bites, "bite_id", this.props.callbacks.getBiteId());
	            var kpis = kpiHelper.getKpis(biteData);
	            if (appHelper.isDefined(this.props.callbacks.updateCharacterExpression) && appHelper.isDefined(this.state.screenObject.character_pose)) {
	                this.props.callbacks.updateCharacterExpression(this.state.screenObject.character_pose);
	            }
	
	            this.getAssets();
	            this.getScreenStatus();
	            this.show();
	            this.getKpisToDisplay();
	        }
	    }, {
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(nextProps) {
	
	            if (this.state.userData !== nextProps.userData) {
	
	                var userDataKpis = appHelper.getArrayObjectByKey(nextProps.userData.bites, "bite_id", this.props.callbacks.getBiteId()).kpis;
	                this.setState({
	                    userData: Object.assign({}, nextProps.userData),
	                    userDataKpis: Object.assign([], userDataKpis),
	                    updateKpis: true
	                });
	            }
	            if (this.state.lang !== nextProps.lang) {
	                this.setState({
	                    lang: nextProps.lang,
	                    locale: appHelper.getLocalData(this.state.screenObject),
	                    continue_label: appHelper.getLocaleString("continue_label"),
	                    updateKpis: true
	                });
	            }
	        }
	    }, {
	        key: 'componentDidUpdate',
	        value: function componentDidUpdate() {
	
	            if (this.state.checkComplete) {
	                this.onComplete();
	            }
	
	            if (this.state.updateKpis) {
	                this.getKpisToDisplay();
	            }
	        }
	    }, {
	        key: 'getScreenStatus',
	        value: function getScreenStatus() {
	            var screenStatus = this.props.callbacks.getScreenStatus();
	            this.setState({
	                screenStatus: screenStatus,
	                status: screenStatus === objectConstants.STATUS_COMPLETE ? objectConstants.STATUS_COMPLETE : this.state.status
	            });
	        }
	    }, {
	        key: 'getObjectStatus',
	        value: function getObjectStatus() {
	
	            if (this.state.screenStatus === objectConstants.STATUS_COMPLETE) {
	                this.setState({ status: objectConstants.STATUS_COMPLETE, checkComplete: true, completeKpis: Object.assign([], this.state.renderableKpis) });
	            } else {
	                var objectUserData = {};
	                if (this.state.status !== objectConstants.STATUS_COMPLETE) {
	                    var subScreenParent = this.props.callbacks.getSubScreenParent();
	                    var screen_id = this.props.callbacks.getScreenId();
	                    if (appHelper.isDefined(subScreenParent)) {
	                        objectUserData = userDataHelper.getSubScreenObjectStatus(this.state.userData, subScreenParent.screen_id, screen_id, this.state.screenObject.asset_id);
	                    } else {
	                        objectUserData = userDataHelper.getObjectStatus(this.state.userData, screen_id, this.state.screenObject.asset_id);
	                    }
	                }
	                if (objectUserData.status === objectConstants.STATUS_COMPLETE) {
	                    this.setState({ status: objectConstants.STATUS_COMPLETE, checkComplete: true, completeKpis: Object.assign([], this.state.renderableKpis) });
	                } else {
	                    this.setState({ checkComplete: true });
	                }
	            }
	        }
	    }, {
	        key: 'getKpisToDisplay',
	        value: function getKpisToDisplay() {
	            var renderableKpis = [];
	            var biteData = appHelper.getArrayObjectByKey(localStorage.bites, "bite_id", this.props.callbacks.getBiteId());
	            var kpis = kpiHelper.getAllKpis(biteData);
	
	            for (var i = 0; i < kpis.length; i++) {
	                var kpi = kpis[i];
	                var kpiDataObj = {
	                    kpi_id: kpi.kpi_id,
	                    data: kpi,
	                    userData: appHelper.getArrayObjectByKey(this.state.userDataKpis, "kpi_id", kpi.kpi_id)
	                };
	                renderableKpis = dataHelper.immutablePush(renderableKpis, kpiDataObj);
	            }
	
	            var activeIndex = 0;
	            if (appHelper.isDefined(this.state.activeKpi.kpi_id)) {
	                activeIndex = appHelper.getArrayObjectIndexByKey(renderableKpis, "kpi_id", this.state.activeKpi.kpi_id);
	            }
	
	            if (this.state.screenObject.display_method === objectConstants.RESULT_DISPLAY_METHOD_SCORE_ONLY) {
	                renderableKpis = kpiHelper.removeObjectivesFromKpisToDisplay(renderableKpis);
	            } else if (this.state.screenObject.display_method === objectConstants.RESULT_DISPLAY_METHOD_OBJECTIVES_ONLY) {
	                renderableKpis = kpiHelper.removeScoreFromKpisToDisplay(renderableKpis);
	                if (this.state.screenObject.hide_objectives.length > 0) {
	                    renderableKpis = kpiHelper.removeKpisFromKpisToDisplay(renderableKpis, this.state.screenObject.hide_objectives);
	                }
	            } else {
	                if (this.state.screenObject.hide_objectives.length > 0) {
	                    renderableKpis = kpiHelper.removeKpisFromKpisToDisplay(renderableKpis, this.state.screenObject.hide_objectives);
	                }
	            }
	
	            var kpiMenu = kpiHelper.setKpiMenuData(renderableKpis);
	
	            this.setState({
	                updateKpis: false,
	                renderableKpis: Object.assign([], renderableKpis),
	                completeKpis: this.state.status === objectConstants.STATUS_COMPLETE ? renderableKpis : this.state.completeKpis,
	                activeKpi: renderableKpis[activeIndex],
	                kpiMenuData: Object.assign({}, this.state.kpiMenuData, {
	                    menu: kpiMenu,
	                    currentKpi: !appHelper.isDefined(this.state.kpiMenuData.currentKpi.kpi_id) ? kpiMenu[0] : kpiMenu[activeIndex],
	                    onMenuSelect: this.onSelectKpi
	                })
	            });
	        }
	    }, {
	        key: 'onSelectKpi',
	        value: function onSelectKpi(result) {
	            var activeKpi = appHelper.getArrayObjectByKey(this.state.renderableKpis, "kpi_id", result.kpi_id);
	            var activeMenuItem = appHelper.getArrayObjectByKey(this.state.kpiMenuData.menu, "kpi_id", result.kpi_id);
	            this.setState({
	                activeKpi: activeKpi,
	                kpiMenuData: Object.assign({}, this.state.kpiMenuData, {
	                    currentKpi: activeMenuItem
	                })
	            });
	        }
	    }, {
	        key: 'getImagePath',
	        value: function getImagePath(image) {
	            if (appConstants.DEVELOPMENT_MODE) {
	                if (appHelper.isDefined(image) && image.length > 0) {
	                    return __webpack_require__(16)("./" + image);
	                }
	            } else {
	                return image;
	            }
	        }
	    }, {
	        key: 'getAssets',
	        value: function getAssets() {
	            if (appHelper.isDefined(this.state.screenObject.icon)) {
	                var icon = appHelper.getIconAsset(this.state.screenObject.icon);
	                if (appHelper.isDefined(icon) && icon.src.length > 0) {
	                    this.setState({ icon: icon });
	                }
	            }
	        }
	    }, {
	        key: 'show',
	        value: function show() {
	            var optionRef = this.refs[this.state.screenObject.asset_id + '_asset'];
	            _gsap.TweenLite.set(optionRef, { height: "auto" });
	            _gsap.TweenLite.from(optionRef, objectConstants.SHOW_PANEL_DURATION, {
	                height: 0,
	                ease: _gsap.Expo.easeInOut
	            }).eventCallback("onComplete", this.getObjectStatus);
	        }
	    }, {
	        key: 'onShowComplete',
	        value: function onShowComplete() {
	            this.setState({ isVisible: true, checkComplete: false });
	        }
	    }, {
	        key: 'scrollToTop',
	        value: function scrollToTop() {
	            if (this.state.allowScroll && this.state.status !== objectConstants.STATUS_COMPLETE) {
	                var question = this.refs[this.state.screenObject.asset_id + '_asset'];
	                var scrollTo = this.props.callbacks.scrollTo;
	                setTimeout(function () {
	                    if (appHelper.isDefined(scrollTo)) {
	                        scrollTo(question.offsetTop);
	                    }
	                }, objectConstants.SCROLL_TO);
	            }
	        }
	    }, {
	        key: 'onComplete',
	        value: function onComplete() {
	            this.setState({ checkComplete: false });
	            if (this.state.renderableKpis.length === this.state.completeKpis.length && !this.state.isComplete) {
	
	                var hasNextObject = this.props.callbacks.hasNextObject(this.props.index);
	                if (appHelper.isDefined(this.state.screenObject.progression) && this.state.screenObject.progression === objectConstants.OBJECT_PROGRESSION_CONTINUE && (this.state.status !== objectConstants.STATUS_COMPLETE || !hasNextObject)) {
	                    if (!hasNextObject) {
	                        this.handleProgression();
	                        this.enableProgression();
	                    } else {
	                        this.enableProgression();
	                    }
	                } else {
	                    this.handleProgression();
	                }
	            }
	        }
	    }, {
	        key: 'enableProgression',
	        value: function enableProgression() {
	            if (!this.props.callbacks.isReviewMode()) {
	                this.setState({ showProgressionButton: true });
	            }
	        }
	    }, {
	        key: 'disableProgression',
	        value: function disableProgression() {
	            this.setState({ showProgressionButton: false });
	        }
	    }, {
	        key: 'handleProgression',
	        value: function handleProgression() {
	            if (!this.state.progressionHandled) {
	
	                this.setState({ progressionHandled: true });
	                var progressionRule = appHelper.isDefined(this.state.screenObject.progression) ? this.state.screenObject.progression : objectConstants.OBJECT_PROGRESSION_CONTINUE;
	                var progressionType = appHelper.isDefined(this.state.screenObject.progression_type) ? this.state.screenObject.progression_type : undefined;
	                var progressionGoToId = appHelper.isDefined(this.state.screenObject.progression_goto_id) ? this.state.screenObject.progression_goto_id : undefined;
	                var completionData = {
	                    progression: progressionRule,
	                    progressionType: progressionType,
	                    progressionGoToId: progressionGoToId,
	                    asset_id: this.state.screenObject.asset_id,
	                    status: objectConstants.STATUS_COMPLETE,
	                    showProgressionButton: false,
	                    asset_type_code: this.state.screenObject.asset_type_code,
	                    navigateToNextScreen: appHelper.isDefined(this.state.screenObject.progression) && this.state.screenObject.progression === objectConstants.OBJECT_PROGRESSION_CONTINUE,
	                    index: this.props.index
	                };
	
	                this.props.callbacks.onObjectComplete(completionData);
	            }
	            //t
	        }
	    }, {
	        key: 'onProgressionBtnClicked',
	        value: function onProgressionBtnClicked() {
	            this.setState({ showProgressionButton: false });
	            if (this.props.callbacks.hasNextObject(this.props.index)) {
	                this.handleProgression();
	            } else {
	                this.props.callbacks.navigateToNextScreen();
	            }
	        }
	    }, {
	        key: 'onKpiComplete',
	        value: function onKpiComplete(kpi) {
	            var index = appHelper.getArrayObjectIndexByKey(this.state.completeKpis, "kpi_id", kpi.kpi_id);
	            if (index === -1) {
	                this.setState({
	                    completeKpis: dataHelper.immutablePush(this.state.completeKpis, kpi),
	                    checkComplete: true
	                });
	            }
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            return _react2.default.createElement(
	                'div',
	                { className: 'object-container', ref: this.state.screenObject.asset_id + '_asset' },
	                this.state.screenObject.show_title ? _react2.default.createElement('h4', { dangerouslySetInnerHTML: { __html: this.state.locale.label } }) : null,
	                _react2.default.createElement(
	                    'div',
	                    null,
	                    appHelper.isDefined(this.state.activeKpi) && appHelper.isDefined(this.state.activeKpi.userData) ? _react2.default.createElement(_KpiResultsPanel2.default, { kpiData: this.state.activeKpi.data, userDataKpi: this.state.activeKpi.userData, bite_id: this.props.callbacks.getBiteId(), asset_id: this.state.screenObject.asset_id, kpiMenuData: this.state.kpiMenuData, onComplete: this.onKpiComplete, completeKpis: this.state.completeKpis }) : null,
	                    appHelper.isDefined(this.state.activeKpi) && appHelper.isDefined(this.state.activeKpi.userData) ? _react2.default.createElement(_KpiGraph2.default, { kpiData: this.state.activeKpi.data, userDataKpi: this.state.activeKpi.userData }) : null
	                ),
	                this.state.showProgressionButton ? _react2.default.createElement(_Button2.default, { label: this.state.continue_label,
	                    id: this.state.screenObject + '_button',
	                    onClick: this.onProgressionBtnClicked }) : null
	            );
	        }
	    }]);
	
	    return KpiGraphResults;
	}(_react2.default.Component);
	
	KpiGraphResults.propTypes = {
	    screenObject: _propTypes2.default.object.isRequired,
	    callbacks: _propTypes2.default.object.isRequired,
	    index: _propTypes2.default.number,
	    contentData: _propTypes2.default.object.isRequired,
	    trackingData: _propTypes2.default.object.isRequired,
	    userData: _propTypes2.default.object.isRequired,
	    lang: _propTypes2.default.string.isRequired,
	    actions: _propTypes2.default.object.isRequired
	};
	
	KpiGraphResults.contextTypes = {
	    router: _propTypes2.default.object
	};
	
	function mapStateToProps(state, ownProps) {
	    var lang = state.userData.lang;
	    return {
	        lang: lang,
	        contentData: state.contentData,
	        trackingData: state.trackingData,
	        userData: state.userData
	    };
	}
	
	function mapDispatchToProps(dispatch) {
	    return {
	        actions: (0, _redux.bindActionCreators)(Object.assign({}, appDataActions, trackingDataActions), dispatch)
	    };
	}
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(KpiGraphResults);

/***/ },
/* 484 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(5);
	
	var _redux = __webpack_require__(4);
	
	var _KpiDescription = __webpack_require__(281);
	
	var _KpiDescription2 = _interopRequireDefault(_KpiDescription);
	
	var _KpiOverviewBtn = __webpack_require__(485);
	
	var _KpiOverviewBtn2 = _interopRequireDefault(_KpiOverviewBtn);
	
	var _Button = __webpack_require__(18);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _appDataActions = __webpack_require__(12);
	
	var appDataActions = _interopRequireWildcard(_appDataActions);
	
	var _trackingDataActions = __webpack_require__(7);
	
	var trackingDataActions = _interopRequireWildcard(_trackingDataActions);
	
	var _dataHelper = __webpack_require__(11);
	
	var dataHelper = _interopRequireWildcard(_dataHelper);
	
	var _appHelper = __webpack_require__(3);
	
	var appHelper = _interopRequireWildcard(_appHelper);
	
	var _kpiHelper = __webpack_require__(35);
	
	var kpiHelper = _interopRequireWildcard(_kpiHelper);
	
	var _userDataHelper = __webpack_require__(15);
	
	var userDataHelper = _interopRequireWildcard(_userDataHelper);
	
	var _objectConstants = __webpack_require__(9);
	
	var objectConstants = _interopRequireWildcard(_objectConstants);
	
	var _gsap = __webpack_require__(8);
	
	var _gsapReactPlugin = __webpack_require__(10);
	
	var _gsapReactPlugin2 = _interopRequireDefault(_gsapReactPlugin);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } //eslint-disable-line import/no-named-as-default
	
	
	var KpiOverview = function (_React$Component) {
	    _inherits(KpiOverview, _React$Component);
	
	    function KpiOverview(props, context) {
	        _classCallCheck(this, KpiOverview);
	
	        var _this = _possibleConstructorReturn(this, (KpiOverview.__proto__ || Object.getPrototypeOf(KpiOverview)).call(this, props, context));
	
	        _this.state = {
	            lang: _this.props.lang,
	            status: objectConstants.STATUS_NOT_STARTED,
	            userData: _this.props.userData,
	            screenObject: _this.props.screenObject,
	            bite_id: _this.props.callbacks.getBiteId(),
	            kpis: appHelper.getBiteById(_this.props.callbacks.getBiteId()).performance_kpis,
	            locale: appHelper.getLocalData(_this.props.screenObject),
	            activeKpi: {},
	            activeKpiLocale: {},
	            primaryKpi: {},
	            secondaryKpis: [],
	            objectCallbacks: {},
	            completeObjects: [],
	            guid: dataHelper.createGuid(),
	            screenStatus: "",
	            checkComplete: false,
	            allowScroll: appHelper.allowScroll(_this.props.callbacks.getBiteId(), _this.props.callbacks.getScreenId(), _this.props.screenObject.asset_id),
	            continue_label: appHelper.getLocaleString("continue_label")
	        };
	
	        _this.setKpis = _this.setKpis.bind(_this);
	        _this.show = _this.show.bind(_this);
	        _this.setActiveKpi = _this.setActiveKpi.bind(_this);
	        _this.setCallbacks = _this.setCallbacks.bind(_this);
	        _this.onObjectComplete = _this.onObjectComplete.bind(_this);
	        _this.checkBtnComplete = _this.checkBtnComplete.bind(_this);
	        _this.onComplete = _this.onComplete.bind(_this);
	        _this.handleProgression = _this.handleProgression.bind(_this);
	        _this.enableProgression = _this.enableProgression.bind(_this);
	        _this.onProgressionBtnClicked = _this.onProgressionBtnClicked.bind(_this);
	        _this.getScreenStatus = _this.getScreenStatus.bind(_this);
	        _this.getObjectStatus = _this.getObjectStatus.bind(_this);
	        _this.scrollToTop = _this.scrollToTop.bind(_this);
	        return _this;
	    }
	
	    _createClass(KpiOverview, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            this.setCallbacks();
	            this.setKpis(kpiHelper.getPrimaryKpi(this.state.kpis));
	            this.show();
	            this.getScreenStatus();
	            if (appHelper.isDefined(this.props.callbacks.updateCharacterExpression) && appHelper.isDefined(this.state.screenObject.character_pose)) {
	                this.props.callbacks.updateCharacterExpression(this.state.screenObject.character_pose);
	            }
	            //this.getStatus();
	            //this.setActiveKpi(kpiHelper.getPrimaryKpi(this.state.kpis));
	
	            //this.getPrimaryKpi();
	            //this.getSecondaryKpis();
	        }
	    }, {
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(nextProps) {
	            if (this.state.lang !== nextProps.lang) {
	                this.setState({
	                    lang: nextProps.lang,
	                    locale: appHelper.getLocalData(this.state.screenObject),
	                    activeKpiLocale: Object.assign({}, appHelper.getLocalData(this.state.activeKpi)),
	                    continue_label: appHelper.getLocaleString("continue_label")
	                });
	            }
	        }
	    }, {
	        key: 'componentDidUpdate',
	        value: function componentDidUpdate() {
	            if (this.state.checkComplete) {
	                this.onComplete();
	            }
	        }
	    }, {
	        key: 'scrollToTop',
	        value: function scrollToTop() {
	            if (this.state.allowScroll && this.state.status !== objectConstants.STATUS_COMPLETE) {
	                var object = this.refs['kpi_overview'];
	                var scrollTo = this.props.callbacks.scrollTo;
	                setTimeout(function () {
	                    scrollTo(object.offsetTop);
	                }, objectConstants.SCROLL_TO);
	            }
	        }
	    }, {
	        key: 'setCallbacks',
	        value: function setCallbacks() {
	            this.setState({
	                objectCallbacks: Object.assign({}, this.state.objectCallbacks, {
	                    onObjectComplete: this.onObjectComplete
	                })
	            });
	        }
	    }, {
	        key: 'getScreenStatus',
	        value: function getScreenStatus() {
	            var screenStatus = this.props.callbacks.getScreenStatus();
	            this.setState({
	                screenStatus: screenStatus,
	                status: screenStatus === objectConstants.STATUS_COMPLETE ? objectConstants.STATUS_COMPLETE : this.state.status
	            });
	        }
	    }, {
	        key: 'getObjectStatus',
	        value: function getObjectStatus() {
	            if (this.state.screenStatus === objectConstants.STATUS_COMPLETE) {
	                this.setState({
	                    status: objectConstants.STATUS_COMPLETE,
	                    checkComplete: true
	                });
	            } else {
	                var objectUserData = {};
	                if (this.state.status !== objectConstants.STATUS_COMPLETE) {
	                    var subScreenParent = this.props.callbacks.getSubScreenParent();
	                    var screen_id = this.props.callbacks.getScreenId();
	                    if (appHelper.isDefined(subScreenParent)) {
	                        objectUserData = userDataHelper.getSubScreenObjectStatus(this.state.userData, subScreenParent.screen_id, screen_id, this.state.screenObject.asset_id);
	                    } else {
	                        objectUserData = userDataHelper.getObjectStatus(this.state.userData, screen_id, this.state.screenObject.asset_id);
	                    }
	                }
	
	                if (objectUserData.status === objectConstants.STATUS_COMPLETE) {
	                    this.setState({ status: objectConstants.STATUS_COMPLETE, checkComplete: true });
	                } else {
	                    this.setState({ checkComplete: true });
	                }
	            }
	        }
	    }, {
	        key: 'setKpis',
	        value: function setKpis() {
	            this.setActiveKpi(this.state.kpis[0]);
	        }
	    }, {
	        key: 'setActiveKpi',
	        value: function setActiveKpi(kpi) {
	            this.onObjectComplete(kpi);
	            this.setState({
	                activeKpi: Object.assign({}, kpi),
	                activeKpiLocale: Object.assign({}, appHelper.getLocalData(kpi))
	            });
	        }
	    }, {
	        key: 'onObjectComplete',
	        value: function onObjectComplete(kpi) {
	            var index = appHelper.getArrayObjectIndexByKey(this.state.completeObjects, "kpi_id", kpi.kpi_id);
	            if (index === -1) {
	                this.setState({
	                    completeObjects: dataHelper.immutablePush(this.state.completeObjects, kpi),
	                    status: objectConstants.STATUS_IN_PROGRESS
	                });
	            }
	        }
	    }, {
	        key: 'onComplete',
	        value: function onComplete() {
	            this.setState({ checkComplete: false });
	            var hasNextObject = this.props.callbacks.hasNextObject(this.props.index);
	            if (appHelper.isDefined(this.state.screenObject.progression) && this.state.screenObject.progression === objectConstants.OBJECT_PROGRESSION_CONTINUE && (this.state.status !== objectConstants.STATUS_COMPLETE || !hasNextObject)) {
	                if (!hasNextObject) {
	                    this.handleProgression();
	                    this.enableProgression();
	                } else {
	                    this.enableProgression();
	                }
	            } else {
	                this.handleProgression();
	            }
	            this.scrollToTop();
	        }
	    }, {
	        key: 'enableProgression',
	        value: function enableProgression() {
	            if (!this.props.callbacks.isReviewMode()) {
	                this.setState({ showProgressionButton: true });
	            }
	        }
	    }, {
	        key: 'handleProgression',
	        value: function handleProgression() {
	            var progressionRule = appHelper.isDefined(this.state.screenObject.progression) ? this.state.screenObject.progression : objectConstants.OBJECT_PROGRESSION_CONTINUE;
	            var progressionType = appHelper.isDefined(this.state.screenObject.progression_type) ? this.state.screenObject.progression_type : undefined;
	            var progressionGoToId = appHelper.isDefined(this.state.screenObject.progression_goto_id) ? this.state.screenObject.progression_goto_id : undefined;
	            var completionData = {
	                progression: progressionRule,
	                progressionType: progressionType,
	                progressionGoToId: progressionGoToId,
	                asset_id: this.state.screenObject.asset_id,
	                status: objectConstants.STATUS_COMPLETE,
	                asset_type_code: this.state.screenObject.asset_type_code,
	                navigateToNextScreen: appHelper.isDefined(this.state.screenObject.progression) && this.state.screenObject.progression === objectConstants.OBJECT_PROGRESSION_CONTINUE,
	                index: this.props.index
	            };
	
	            this.props.callbacks.onObjectComplete(completionData);
	            //t
	        }
	    }, {
	        key: 'onProgressionBtnClicked',
	        value: function onProgressionBtnClicked() {
	            this.setState({ showProgressionButton: false });
	            if (this.props.callbacks.hasNextObject(this.props.index)) {
	                this.handleProgression();
	            } else {
	                this.props.callbacks.navigateToNextScreen();
	            }
	        }
	    }, {
	        key: 'show',
	        value: function show() {
	            var kpiRef = this.refs.kpi_overview;
	            if (appHelper.isDefined(kpiRef)) {
	                _gsap.TweenLite.set(kpiRef, { opacity: 1, height: "auto" });
	                _gsap.TweenLite.from(kpiRef, objectConstants.SHOW_PANEL_DURATION, {
	                    height: 0,
	                    ease: _gsap.Expo.easeInOut
	                }).eventCallback("onComplete", this.getObjectStatus);
	            }
	        }
	    }, {
	        key: 'checkBtnComplete',
	        value: function checkBtnComplete(kpi) {
	            return this.state.status === objectConstants.STATUS_COMPLETE || appHelper.getArrayObjectIndexByKey(this.state.completeObjects, "code", kpi.code) > -1;
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this2 = this;
	
	            return _react2.default.createElement(
	                'div',
	                { className: 'object-container', ref: 'kpi_overview' },
	                this.state.screenObject.show_title && appHelper.isDefined(this.state.locale.label) && this.state.locale.label !== null && this.state.locale.label.length > 0 ? _react2.default.createElement('h4', { className: 'bold', dangerouslySetInnerHTML: { __html: this.state.locale.label } }) : null,
	                appHelper.isDefined(this.state.locale.description) && this.state.locale.description !== null && this.state.locale.description.length > 0 ? _react2.default.createElement('div', { dangerouslySetInnerHTML: { __html: this.state.locale.description } }) : null,
	                _react2.default.createElement('br', null),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'kpi-overview-panel' },
	                    this.state.kpis.map(function (kpi) {
	                        return _react2.default.createElement(_KpiDescription2.default, { key: kpi.kpi_id,
	                            kpi: kpi,
	                            bite_id: _this2.state.bite_id,
	                            callbacks: _this2.state.objectCallbacks });
	                    })
	                ),
	                this.state.showProgressionButton ? _react2.default.createElement(_Button2.default, { label: this.state.continue_label,
	                    id: this.state.screenObject + '_button',
	                    onClick: this.onProgressionBtnClicked }) : null
	            );
	        }
	    }]);
	
	    return KpiOverview;
	}(_react2.default.Component);
	
	KpiOverview.propTypes = {
	    screenObject: _propTypes2.default.object.isRequired,
	    callbacks: _propTypes2.default.object.isRequired,
	    index: _propTypes2.default.number,
	    userData: _propTypes2.default.object,
	    lang: _propTypes2.default.string.isRequired,
	    trackingData: _propTypes2.default.object
	};
	
	KpiOverview.contextTypes = {
	    router: _propTypes2.default.object
	};
	
	function mapStateToProps(state, ownProps) {
	    var lang = state.userData.lang;
	    return {
	        lang: lang,
	        userData: state.userData,
	        trackingData: state.trackingData
	    };
	}
	
	function mapDispatchToProps(dispatch) {
	    return {
	        actions: (0, _redux.bindActionCreators)(Object.assign({}, trackingDataActions, appDataActions), dispatch)
	    };
	}
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(KpiOverview);

/***/ },
/* 485 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(5);
	
	var _redux = __webpack_require__(4);
	
	var _RotationKpiMeter = __webpack_require__(82);
	
	var _RotationKpiMeter2 = _interopRequireDefault(_RotationKpiMeter);
	
	var _appDataActions = __webpack_require__(12);
	
	var appDataActions = _interopRequireWildcard(_appDataActions);
	
	var _trackingDataActions = __webpack_require__(7);
	
	var trackingDataActions = _interopRequireWildcard(_trackingDataActions);
	
	var _dataHelper = __webpack_require__(11);
	
	var dataHelper = _interopRequireWildcard(_dataHelper);
	
	var _appHelper = __webpack_require__(3);
	
	var appHelper = _interopRequireWildcard(_appHelper);
	
	var _kpiConstants = __webpack_require__(37);
	
	var kpiConstants = _interopRequireWildcard(_kpiConstants);
	
	var _kpiModels = __webpack_require__(57);
	
	var kpiModels = _interopRequireWildcard(_kpiModels);
	
	var _keyboardConstants = __webpack_require__(14);
	
	var keyboardConstants = _interopRequireWildcard(_keyboardConstants);
	
	var _gsap = __webpack_require__(8);
	
	var _gsapReactPlugin = __webpack_require__(10);
	
	var _gsapReactPlugin2 = _interopRequireDefault(_gsapReactPlugin);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var KpiOverviewBtn = function (_React$Component) {
	    _inherits(KpiOverviewBtn, _React$Component);
	
	    function KpiOverviewBtn(props, context) {
	        _classCallCheck(this, KpiOverviewBtn);
	
	        var _this = _possibleConstructorReturn(this, (KpiOverviewBtn.__proto__ || Object.getPrototypeOf(KpiOverviewBtn)).call(this, props, context));
	
	        _this.state = {
	            kpi: _this.props.kpi,
	            activeKpi: _this.props.activeKpi,
	            className: "",
	
	            guid: dataHelper.createGuid(),
	            allowUpdates: true
	        };
	
	        _this.getKpiMeterParams = _this.getKpiMeterParams.bind(_this);
	        _this.onComplete = _this.onComplete.bind(_this);
	        _this.setClass = _this.setClass.bind(_this);
	        _this.setProgressClass = _this.setProgressClass.bind(_this);
	        _this.onKpiBtnClicked = _this.onKpiBtnClicked.bind(_this);
	        _this.setKeyboardAccessibility = _this.setKeyboardAccessibility.bind(_this);
	        return _this;
	    }
	
	    _createClass(KpiOverviewBtn, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            this.setClass();
	        }
	    }, {
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(nextProps) {
	            if (this.state.activeKpi !== nextProps.activeKpi) {
	                this.setState({
	                    activeKpi: nextProps.activeKpi,
	                    update: true
	                });
	            }
	        }
	    }, {
	        key: 'componentDidUpdate',
	        value: function componentDidUpdate() {
	            if (this.state.update) {
	                this.setClass();
	            }
	        }
	    }, {
	        key: 'getKpiMeterParams',
	        value: function getKpiMeterParams(is_primary) {
	            //if (is_primary) {
	            return kpiModels.PRIMARY_KPI_ROTATION_METER_PARAMS;
	            /*} else {
	                if(this.props.bite.kpis.length < 3){
	                    return kpiModels.PRIMARY_KPI_ROTATION_METER_PARAMS;
	                }else{
	                    return kpiModels.DEFAULT_KPI_ROTATION_METER_PARAMS;
	                }
	            }*/
	        }
	    }, {
	        key: 'setClass',
	        value: function setClass() {
	            var className = "";
	
	            if (this.props.activeKpi.kpi_id === this.state.kpi.kpi_id) {
	                className += " active";
	            }
	
	            return className;
	        }
	    }, {
	        key: 'setProgressClass',
	        value: function setProgressClass() {
	            var className = "";
	
	            if (this.props.isComplete) {
	                className += " complete";
	            } else {
	                className += " incomplete";
	            }
	
	            return className;
	        }
	    }, {
	        key: 'onKpiBtnClicked',
	        value: function onKpiBtnClicked() {
	
	            if (this.state.activeKpi.kpi_id !== this.state.kpi.kpi_id) {
	                this.props.onClickFunc(this.state.kpi);
	            }
	        }
	    }, {
	        key: 'onComplete',
	        value: function onComplete() {
	            this.setState({ allowUpdates: false });
	        }
	    }, {
	        key: 'setKeyboardAccessibility',
	        value: function setKeyboardAccessibility(event) {
	
	            if (event.which === keyboardConstants.ENTER_KEY || event.which === keyboardConstants.SPACEBAR_KEY) {
	                event.stopPropagation();
	                event.preventDefault();
	                this.onKpiBtnClicked();
	            }
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            return _react2.default.createElement(
	                'div',
	                { className: 'inline-item kpi-review-btn ' + this.setClass(),
	                    key: this.state.kpi.kpi_id + '_' + dataHelper.createGuid(), onClick: this.onKpiBtnClicked, onKeyDown: this.setKeyboardAccessibility, role: 'link', tabIndex: 0 },
	                _react2.default.createElement('div', { className: 'progress-indicator ' + this.setProgressClass() }),
	                _react2.default.createElement(_RotationKpiMeter2.default, { bite_id: this.props.bite_id,
	                    kpiDefaults: this.state.kpi,
	                    meterParams: this.getKpiMeterParams(this.state.kpi.is_primary),
	                    displayState: kpiConstants.KPI_DISPLAY_STATE_START
	                })
	            );
	        }
	    }]);
	
	    return KpiOverviewBtn;
	}(_react2.default.Component);
	
	KpiOverviewBtn.propTypes = {
	    kpi: _propTypes2.default.object.isRequired,
	    bite_id: _propTypes2.default.number.isRequired,
	    activeKpi: _propTypes2.default.object.isRequired,
	    onClickFunc: _propTypes2.default.func.isRequired,
	    isComplete: _propTypes2.default.bool
	};
	
	KpiOverviewBtn.contextTypes = {
	    router: _propTypes2.default.object
	};
	
	function mapStateToProps() {
	    return {};
	}
	
	function mapDispatchToProps(dispatch) {
	    return {
	        actions: (0, _redux.bindActionCreators)(Object.assign({}, trackingDataActions, appDataActions), dispatch)
	    };
	}
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(KpiOverviewBtn);

/***/ },
/* 486 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(5);
	
	var _redux = __webpack_require__(4);
	
	var _Button = __webpack_require__(18);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _KpiResultsPanel = __webpack_require__(282);
	
	var _KpiResultsPanel2 = _interopRequireDefault(_KpiResultsPanel);
	
	var _appDataActions = __webpack_require__(12);
	
	var appDataActions = _interopRequireWildcard(_appDataActions);
	
	var _trackingDataActions = __webpack_require__(7);
	
	var trackingDataActions = _interopRequireWildcard(_trackingDataActions);
	
	var _appConstants = __webpack_require__(13);
	
	var appConstants = _interopRequireWildcard(_appConstants);
	
	var _appHelper = __webpack_require__(3);
	
	var appHelper = _interopRequireWildcard(_appHelper);
	
	var _userDataHelper = __webpack_require__(15);
	
	var userDataHelper = _interopRequireWildcard(_userDataHelper);
	
	var _objectConstants = __webpack_require__(9);
	
	var objectConstants = _interopRequireWildcard(_objectConstants);
	
	var _kpiHelper = __webpack_require__(35);
	
	var kpiHelper = _interopRequireWildcard(_kpiHelper);
	
	var _dataHelper = __webpack_require__(11);
	
	var dataHelper = _interopRequireWildcard(_dataHelper);
	
	var _localStorage = __webpack_require__(17);
	
	var localStorage = _interopRequireWildcard(_localStorage);
	
	var _gsap = __webpack_require__(8);
	
	var _gsapReactPlugin = __webpack_require__(10);
	
	var _gsapReactPlugin2 = _interopRequireDefault(_gsapReactPlugin);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } //eslint-disable-line import/no-named-as-default
	//eslint-disable-line import/no-named-as-default
	
	
	var KpiResultsList = function (_React$Component) {
	    _inherits(KpiResultsList, _React$Component);
	
	    function KpiResultsList(props, context) {
	        _classCallCheck(this, KpiResultsList);
	
	        var _this = _possibleConstructorReturn(this, (KpiResultsList.__proto__ || Object.getPrototypeOf(KpiResultsList)).call(this, props, context));
	
	        _this.state = {
	            lang: _this.props.lang,
	            screenObject: _this.props.screenObject,
	            userData: _this.props.userData,
	            kpis: kpiHelper.getKpis(appHelper.getArrayObjectByKey(localStorage.bites), "bite_id", _this.props.callbacks.getBiteId()),
	            userDataKpis: appHelper.getArrayObjectByKey(_this.props.userData.bites, "bite_id", _this.props.callbacks.getBiteId()).kpis,
	            renderableKpis: [],
	            completeKpis: [],
	            activeKpi: {},
	            status: objectConstants.STATUS_NOT_STARTED,
	            locale: appHelper.getLocalData(_this.props.screenObject),
	            showProgressionButton: false,
	            icon: {
	                src: ""
	            },
	            screenStatus: "",
	            isReviewMode: false,
	            checkComplete: false,
	            updateKpis: false,
	            kpiMenuData: {
	                menu: [],
	                currentKpi: {},
	                onMenuSelect: {},
	                idKey: "kpi_id",
	                labelKey: "label"
	            },
	            allowScroll: appHelper.allowScroll(_this.props.callbacks.getBiteId(), _this.props.callbacks.getScreenId(), _this.props.screenObject.asset_id),
	            isComplete: false,
	            continue_label: appHelper.getLocaleString("continue_label")
	        };
	        _this.handleProgression = _this.handleProgression.bind(_this);
	        _this.scrollToTop = _this.scrollToTop.bind(_this);
	        _this.onComplete = _this.onComplete.bind(_this);
	        _this.enableProgression = _this.enableProgression.bind(_this);
	        _this.disableProgression = _this.disableProgression.bind(_this);
	        _this.getAssets = _this.getAssets.bind(_this);
	        _this.getImagePath = _this.getImagePath.bind(_this);
	        _this.show = _this.show.bind(_this);
	        _this.onShowComplete = _this.onShowComplete.bind(_this);
	        _this.onProgressionBtnClicked = _this.onProgressionBtnClicked.bind(_this);
	        _this.getScreenStatus = _this.getScreenStatus.bind(_this);
	        _this.getObjectStatus = _this.getObjectStatus.bind(_this);
	        _this.getKpisToDisplay = _this.getKpisToDisplay.bind(_this);
	        _this.onSelectKpi = _this.onSelectKpi.bind(_this);
	        _this.onKpiComplete = _this.onKpiComplete.bind(_this);
	        return _this;
	    }
	
	    _createClass(KpiResultsList, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	
	            this.getAssets();
	            this.getScreenStatus();
	            this.show();
	            if (appHelper.isDefined(this.props.callbacks.updateCharacterExpression) && appHelper.isDefined(this.state.screenObject.character_pose)) {
	                this.props.callbacks.updateCharacterExpression(this.state.screenObject.character_pose);
	            }
	            this.getKpisToDisplay();
	        }
	    }, {
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(nextProps) {
	            if (this.state.userData !== nextProps.userData) {
	                this.setState({
	                    userData: Object.assign({}, nextProps.userData),
	                    userDataKpis: appHelper.getArrayObjectByKey(nextProps.userData.bites, "bite_id", this.props.callbacks.getBiteId()).kpis,
	                    updateKpis: true
	                });
	            }
	            if (this.state.lang !== nextProps.lang) {
	                this.setState({
	                    lang: nextProps.lang,
	                    locale: appHelper.getLocalData(this.state.screenObject),
	                    continue_label: appHelper.getLocaleString("continue_label"),
	                    updateKpis: true
	                });
	            }
	        }
	    }, {
	        key: 'componentDidUpdate',
	        value: function componentDidUpdate() {
	
	            if (this.state.checkComplete) {
	                this.onComplete();
	            }
	
	            if (this.state.updateKpis) {
	                this.getKpisToDisplay();
	            }
	        }
	    }, {
	        key: 'getScreenStatus',
	        value: function getScreenStatus() {
	            var screenStatus = this.props.callbacks.getScreenStatus();
	            this.setState({
	                screenStatus: screenStatus,
	                status: screenStatus === objectConstants.STATUS_COMPLETE ? objectConstants.STATUS_COMPLETE : this.state.status,
	                isReviewMode: true
	            });
	        }
	    }, {
	        key: 'getObjectStatus',
	        value: function getObjectStatus() {
	            if (this.state.screenStatus === objectConstants.STATUS_COMPLETE) {
	                this.onComplete();
	            } else {
	                var objectUserData = {};
	                if (this.state.status !== objectConstants.STATUS_COMPLETE) {
	                    var subScreenParent = this.props.callbacks.getSubScreenParent();
	                    var screen_id = this.props.callbacks.getScreenId();
	                    if (appHelper.isDefined(subScreenParent)) {
	                        objectUserData = userDataHelper.getSubScreenObjectStatus(this.state.userData, subScreenParent.screen_id, screen_id, this.state.screenObject.asset_id);
	                    } else {
	                        objectUserData = userDataHelper.getObjectStatus(this.state.userData, screen_id, this.state.screenObject.asset_id);
	                    }
	                }
	                if (objectUserData.status === objectConstants.STATUS_COMPLETE) {
	                    this.setState({ status: objectConstants.STATUS_COMPLETE, checkComplete: true, isReviewMode: true });
	                } else {
	                    this.setState({ checkComplete: true });
	                }
	            }
	        }
	    }, {
	        key: 'getKpisToDisplay',
	        value: function getKpisToDisplay() {
	
	            var renderableKpis = [];
	            for (var i = 0; i < this.state.kpis.length; i++) {
	                var kpi = this.state.kpis[i];
	                var kpiDataObj = {
	                    kpi_id: kpi.kpi_id,
	                    data: kpi,
	                    userData: appHelper.getArrayObjectByKey(this.state.userDataKpis, "kpi_id", kpi.kpi_id)
	                };
	
	                renderableKpis = dataHelper.immutablePush(renderableKpis, kpiDataObj);
	            }
	
	            if (this.state.screenObject.display_method === objectConstants.RESULT_DISPLAY_METHOD_SCORE_ONLY) {
	                renderableKpis = kpiHelper.removeObjectivesFromKpisToDisplay(renderableKpis);
	            } else if (this.state.screenObject.display_method === objectConstants.RESULT_DISPLAY_METHOD_OBJECTIVES_ONLY) {
	                renderableKpis = kpiHelper.removeScoreFromKpisToDisplay(renderableKpis);
	                if (this.state.screenObject.hide_objectives.length > 0) {
	                    renderableKpis = kpiHelper.removeKpisFromKpisToDisplay(renderableKpis, this.state.screenObject.hide_objectives);
	                }
	            } else {
	                if (this.state.screenObject.hide_objectives.length > 0) {
	                    renderableKpis = kpiHelper.removeKpisFromKpisToDisplay(renderableKpis, this.state.screenObject.hide_objectives);
	                }
	            }
	
	            var kpiMenu = kpiHelper.setKpiMenuData(renderableKpis);
	
	            var activeIndex = 0;
	            if (appHelper.isDefined(this.state.activeKpi.kpi_id)) {
	                activeIndex = appHelper.getArrayObjectIndexByKey(renderableKpis, "kpi_id", this.state.activeKpi.kpi_id);
	            }
	
	            this.setState({
	                updateKpis: false,
	                renderableKpis: Object.assign([], renderableKpis),
	                activeKpi: renderableKpis[activeIndex],
	                completeKpis: this.state.status === objectConstants.STATUS_COMPLETE ? renderableKpis : this.state.completeKpis,
	                kpiMenuData: Object.assign({}, this.state.kpiMenuData, {
	                    menu: kpiMenu,
	                    currentKpi: kpiMenu[0],
	                    onMenuSelect: this.onSelectKpi
	                })
	            });
	        }
	    }, {
	        key: 'onSelectKpi',
	        value: function onSelectKpi(result) {
	            var activeKpi = appHelper.getArrayObjectByKey(this.state.renderableKpis, "kpi_id", result.kpi_id);
	            var activeMenuItem = appHelper.getArrayObjectByKey(this.state.kpiMenuData.menu, "kpi_id", result.kpi_id);
	            this.setState({
	                activeKpi: activeKpi,
	                kpiMenuData: Object.assign({}, this.state.kpiMenuData, {
	                    currentKpi: activeMenuItem
	                })
	            });
	        }
	    }, {
	        key: 'getImagePath',
	        value: function getImagePath(image) {
	            if (appConstants.DEVELOPMENT_MODE) {
	                if (appHelper.isDefined(image) && image.length > 0) {
	                    return __webpack_require__(16)("./" + image);
	                }
	            } else {
	                return image;
	            }
	        }
	    }, {
	        key: 'getAssets',
	        value: function getAssets() {
	            if (appHelper.isDefined(this.state.screenObject.icon)) {
	                var icon = appHelper.getIconAsset(this.state.screenObject.icon);
	                if (appHelper.isDefined(icon) && icon.src.length > 0) {
	                    this.setState({ icon: icon });
	                }
	            }
	        }
	    }, {
	        key: 'show',
	        value: function show() {
	            var optionRef = this.refs[this.state.screenObject.asset_id + '_asset'];
	            _gsap.TweenLite.set(optionRef, { height: "auto" });
	            _gsap.TweenLite.from(optionRef, objectConstants.SHOW_PANEL_DURATION, {
	                height: 0,
	                ease: _gsap.Expo.easeInOut
	            }).eventCallback("onComplete", this.getObjectStatus);
	        }
	    }, {
	        key: 'onShowComplete',
	        value: function onShowComplete() {
	            this.setState({ isVisible: true, checkComplete: false });
	        }
	    }, {
	        key: 'scrollToTop',
	        value: function scrollToTop() {
	            if (this.state.allowScroll && this.state.status !== objectConstants.STATUS_COMPLETE) {
	                var question = this.refs[this.state.screenObject.asset_id + '_asset'];
	                var scrollTo = this.props.callbacks.scrollTo;
	                setTimeout(function () {
	                    if (appHelper.isDefined(scrollTo)) {
	                        scrollTo(question.offsetTop);
	                    }
	                }, objectConstants.SCROLL_TO);
	            }
	        }
	    }, {
	        key: 'onComplete',
	        value: function onComplete() {
	            this.setState({ checkComplete: false });
	
	            if (this.state.renderableKpis.length === this.state.completeKpis.length && !this.state.isComplete) {
	                this.setState({ isComplete: true });
	                var hasNextObject = this.props.callbacks.hasNextObject(this.props.index);
	                if (appHelper.isDefined(this.state.screenObject.progression) && this.state.screenObject.progression === objectConstants.OBJECT_PROGRESSION_CONTINUE && (this.state.status !== objectConstants.STATUS_COMPLETE || !hasNextObject)) {
	                    if (!hasNextObject) {
	                        this.handleProgression();
	                        this.enableProgression();
	                    } else {
	                        this.enableProgression();
	                    }
	                } else {
	                    this.handleProgression();
	                }
	                this.scrollToTop();
	            }
	        }
	    }, {
	        key: 'enableProgression',
	        value: function enableProgression() {
	            if (!this.props.callbacks.isReviewMode()) {
	                this.setState({ showProgressionButton: true });
	            }
	        }
	    }, {
	        key: 'disableProgression',
	        value: function disableProgression() {
	            this.setState({ showProgressionButton: false });
	        }
	    }, {
	        key: 'handleProgression',
	        value: function handleProgression() {
	            var progressionRule = appHelper.isDefined(this.state.screenObject.progression) ? this.state.screenObject.progression : objectConstants.OBJECT_PROGRESSION_CONTINUE;
	            var progressionType = appHelper.isDefined(this.state.screenObject.progression_type) ? this.state.screenObject.progression_type : undefined;
	            var progressionGoToId = appHelper.isDefined(this.state.screenObject.progression_goto_id) ? this.state.screenObject.progression_goto_id : undefined;
	            var completionData = {
	                progression: progressionRule,
	                progressionType: progressionType,
	                progressionGoToId: progressionGoToId,
	                asset_id: this.state.screenObject.asset_id,
	                status: objectConstants.STATUS_COMPLETE,
	                showProgressionButton: false,
	                asset_type_code: this.state.screenObject.asset_type_code,
	                navigateToNextScreen: appHelper.isDefined(this.state.screenObject.progression) && this.state.screenObject.progression === objectConstants.OBJECT_PROGRESSION_CONTINUE,
	                index: this.props.index
	            };
	
	            this.props.callbacks.onObjectComplete(completionData);
	            //t
	        }
	    }, {
	        key: 'onProgressionBtnClicked',
	        value: function onProgressionBtnClicked() {
	            this.setState({ showProgressionButton: false });
	            if (this.props.callbacks.hasNextObject(this.props.index)) {
	                this.handleProgression();
	            } else {
	                this.props.callbacks.navigateToNextScreen();
	            }
	        }
	    }, {
	        key: 'onKpiComplete',
	        value: function onKpiComplete(kpi) {
	            var index = appHelper.getArrayObjectIndexByKey(this.state.completeKpis, "kpi_id", kpi.kpi_id);
	            if (index === -1) {
	                this.setState({
	                    completeKpis: dataHelper.immutablePush(this.state.completeKpis, kpi),
	                    checkComplete: true
	                });
	            }
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this2 = this;
	
	            return _react2.default.createElement(
	                'div',
	                { className: 'object-container', ref: this.state.screenObject.asset_id + '_asset' },
	                this.state.screenObject.show_title ? _react2.default.createElement('h4', { dangerouslySetInnerHTML: { __html: this.state.locale.label } }) : null,
	                this.state.renderableKpis.map(function (kpi) {
	                    return _react2.default.createElement(_KpiResultsPanel2.default, { key: kpi.kpi_id, kpiData: kpi.data, userDataKpi: kpi.userData, bite_id: _this2.props.callbacks.getBiteId(), asset_id: _this2.state.screenObject.asset_id, onComplete: _this2.onKpiComplete, completeKpis: _this2.state.completeKpis });
	                }),
	                this.state.showProgressionButton ? _react2.default.createElement(_Button2.default, { label: this.state.continue_label,
	                    id: this.state.screenObject + '_button',
	                    onClick: this.onProgressionBtnClicked }) : null
	            );
	        }
	    }]);
	
	    return KpiResultsList;
	}(_react2.default.Component);
	
	KpiResultsList.propTypes = {
	    screenObject: _propTypes2.default.object.isRequired,
	    callbacks: _propTypes2.default.object.isRequired,
	    contentData: _propTypes2.default.object.isRequired,
	    trackingData: _propTypes2.default.object.isRequired,
	    index: _propTypes2.default.number,
	    lang: _propTypes2.default.string.isRequired,
	    userData: _propTypes2.default.object.isRequired,
	    actions: _propTypes2.default.object.isRequired
	};
	
	KpiResultsList.contextTypes = {
	    router: _propTypes2.default.object
	};
	
	function mapStateToProps(state, ownProps) {
	    var lang = state.userData.lang;
	    return {
	        lang: lang,
	        contentData: state.contentData,
	        trackingData: state.trackingData,
	        userData: state.userData
	    };
	}
	
	function mapDispatchToProps(dispatch) {
	    return {
	        actions: (0, _redux.bindActionCreators)(Object.assign({}, appDataActions, trackingDataActions), dispatch)
	    };
	}
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(KpiResultsList);

/***/ },
/* 487 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(5);
	
	var _redux = __webpack_require__(4);
	
	var _RotationKpiMeter = __webpack_require__(82);
	
	var _RotationKpiMeter2 = _interopRequireDefault(_RotationKpiMeter);
	
	var _appDataActions = __webpack_require__(12);
	
	var appDataActions = _interopRequireWildcard(_appDataActions);
	
	var _trackingDataActions = __webpack_require__(7);
	
	var trackingDataActions = _interopRequireWildcard(_trackingDataActions);
	
	var _appHelper = __webpack_require__(3);
	
	var appHelper = _interopRequireWildcard(_appHelper);
	
	var _keyboardConstants = __webpack_require__(14);
	
	var keyboardConstants = _interopRequireWildcard(_keyboardConstants);
	
	var _kpiConstants = __webpack_require__(37);
	
	var kpiConstants = _interopRequireWildcard(_kpiConstants);
	
	var _dataHelper = __webpack_require__(11);
	
	var dataHelper = _interopRequireWildcard(_dataHelper);
	
	var _objectConstants = __webpack_require__(9);
	
	var objectConstants = _interopRequireWildcard(_objectConstants);
	
	var _gsap = __webpack_require__(8);
	
	var _gsapReactPlugin = __webpack_require__(10);
	
	var _gsapReactPlugin2 = _interopRequireDefault(_gsapReactPlugin);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var KpiSelfRatingItem = function (_React$Component) {
	    _inherits(KpiSelfRatingItem, _React$Component);
	
	    function KpiSelfRatingItem(props, context) {
	        _classCallCheck(this, KpiSelfRatingItem);
	
	        var _this = _possibleConstructorReturn(this, (KpiSelfRatingItem.__proto__ || Object.getPrototypeOf(KpiSelfRatingItem)).call(this, props, context));
	
	        _this.state = {
	            lang: _this.props.lang,
	            kpi: _this.props.kpi,
	            activeKpi: _this.props.activeKpi,
	            locale: appHelper.getLocalData(_this.props.kpi)
	
	        };
	        _this.setActiveClass = _this.setActiveClass.bind(_this);
	        _this.onClickFunc = _this.onClickFunc.bind(_this);
	        _this.setKeyboardAccessibility = _this.setKeyboardAccessibility.bind(_this);
	
	        return _this;
	    }
	
	    _createClass(KpiSelfRatingItem, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {}
	    }, {
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(nextProps) {
	            if (this.state.activeKpi !== nextProps.activeKpi) {
	                this.setState({ activeKpi: Object.assign(nextProps.activeKpi) });
	            }
	
	            if (this.state.lang !== nextProps.lang) {
	                this.setState({
	                    lang: nextProps.lang,
	                    locale: appHelper.getLocalData(this.state.kpi)
	                });
	            }
	        }
	    }, {
	        key: 'setActiveClass',
	        value: function setActiveClass() {
	            //console.log(`${this.state.kpi.value} === ${this.state.activeKpi.value}`);
	            return this.state.kpi.value === this.state.activeKpi.value ? "active" : "";
	        }
	    }, {
	        key: 'onClickFunc',
	        value: function onClickFunc(event) {
	            event.stopPropagation();
	            this.props.onClickFunc(this.state.kpi);
	        }
	    }, {
	        key: 'setKeyboardAccessibility',
	        value: function setKeyboardAccessibility(event) {
	
	            if (event.which === keyboardConstants.ENTER_KEY || event.which === keyboardConstants.SPACEBAR_KEY) {
	                event.stopPropagation();
	                event.preventDefault();
	                this.onClickFunc();
	            }
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            return _react2.default.createElement('div', { className: this.props.kpi.class + ' ' + this.setActiveClass(), onClick: this.onClickFunc, onKeyDown: this.setKeyboardAccessibility, role: 'link', tabIndex: 0 });
	        }
	    }]);
	
	    return KpiSelfRatingItem;
	}(_react2.default.Component);
	
	KpiSelfRatingItem.propTypes = {
	    kpi: _propTypes2.default.object.isRequired,
	    activeKpi: _propTypes2.default.object.isRequired,
	    onClickFunc: _propTypes2.default.func.isRequired,
	    lang: _propTypes2.default.string.isRequired,
	    actions: _propTypes2.default.object
	};
	
	KpiSelfRatingItem.contextTypes = {
	    router: _propTypes2.default.object
	};
	
	function mapStateToProps(state, ownProps) {
	    var lang = state.userData.lang;
	    return {
	        lang: lang
	    };
	}
	
	function mapDispatchToProps(dispatch) {
	    return {
	        actions: (0, _redux.bindActionCreators)(Object.assign({}, appDataActions, trackingDataActions), dispatch)
	    };
	}
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(KpiSelfRatingItem);

/***/ },
/* 488 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(5);
	
	var _redux = __webpack_require__(4);
	
	var _KpiSelfRatingItem = __webpack_require__(487);
	
	var _KpiSelfRatingItem2 = _interopRequireDefault(_KpiSelfRatingItem);
	
	var _appDataActions = __webpack_require__(12);
	
	var appDataActions = _interopRequireWildcard(_appDataActions);
	
	var _trackingDataActions = __webpack_require__(7);
	
	var trackingDataActions = _interopRequireWildcard(_trackingDataActions);
	
	var _appHelper = __webpack_require__(3);
	
	var appHelper = _interopRequireWildcard(_appHelper);
	
	var _kpiModels = __webpack_require__(57);
	
	var _gsap = __webpack_require__(8);
	
	var _gsapReactPlugin = __webpack_require__(10);
	
	var _gsapReactPlugin2 = _interopRequireDefault(_gsapReactPlugin);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var KpiSelfRatingPanel = function (_React$Component) {
	    _inherits(KpiSelfRatingPanel, _React$Component);
	
	    function KpiSelfRatingPanel(props, context) {
	        _classCallCheck(this, KpiSelfRatingPanel);
	
	        var _this = _possibleConstructorReturn(this, (KpiSelfRatingPanel.__proto__ || Object.getPrototypeOf(KpiSelfRatingPanel)).call(this, props, context));
	
	        _this.state = {
	            lang: _this.props.lang,
	            kpi: _this.props.kpi,
	            activeKpi: {
	                value: undefined
	            },
	            label: appHelper.getLocaleString("self_rating_prompt")
	
	        };
	        _this.setActiveKpi = _this.setActiveKpi.bind(_this);
	        return _this;
	    }
	
	    _createClass(KpiSelfRatingPanel, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {}
	    }, {
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(nextProps) {
	            if (this.state.lang !== nextProps.lang) {
	                this.setState({
	                    lang: nextProps.lang,
	                    label: appHelper.getLocaleString("self_rating_prompt")
	                });
	            }
	        }
	    }, {
	        key: 'setActiveKpi',
	        value: function setActiveKpi(kpi) {
	            this.setState({ activeKpi: Object.assign(kpi) });
	            this.props.onComplete(kpi);
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this2 = this;
	
	            return _react2.default.createElement(
	                'div',
	                { className: 'text-center' },
	                _react2.default.createElement(
	                    'div',
	                    null,
	                    _react2.default.createElement(
	                        'strong',
	                        null,
	                        this.state.label
	                    )
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'kpi-self-rating-list' },
	                    _kpiModels.KPI_SELF_RATING_LIST.map(function (kpi) {
	                        return _react2.default.createElement(_KpiSelfRatingItem2.default, { key: kpi.value, kpi: kpi, onClickFunc: _this2.setActiveKpi, activeKpi: _this2.state.activeKpi });
	                    })
	                )
	            );
	        }
	    }]);
	
	    return KpiSelfRatingPanel;
	}(_react2.default.Component);
	
	KpiSelfRatingPanel.propTypes = {
	    kpi: _propTypes2.default.object.isRequired,
	    bite_id: _propTypes2.default.number.isRequired,
	    onComplete: _propTypes2.default.func.isRequired,
	    lang: _propTypes2.default.string.isRequired,
	    actions: _propTypes2.default.object
	};
	
	KpiSelfRatingPanel.contextTypes = {
	    router: _propTypes2.default.object
	};
	
	function mapStateToProps(state, ownProps) {
	    var lang = state.userData.lang;
	    return {
	        lang: lang
	    };
	}
	
	function mapDispatchToProps(dispatch) {
	    return {
	        actions: (0, _redux.bindActionCreators)(Object.assign({}, appDataActions, trackingDataActions), dispatch)
	    };
	}
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(KpiSelfRatingPanel);

/***/ },
/* 489 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(5);
	
	var _redux = __webpack_require__(4);
	
	var _RotationKpiMeter = __webpack_require__(82);
	
	var _RotationKpiMeter2 = _interopRequireDefault(_RotationKpiMeter);
	
	var _Button = __webpack_require__(18);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _KpiDescription = __webpack_require__(281);
	
	var _KpiDescription2 = _interopRequireDefault(_KpiDescription);
	
	var _appDataActions = __webpack_require__(12);
	
	var appDataActions = _interopRequireWildcard(_appDataActions);
	
	var _trackingDataActions = __webpack_require__(7);
	
	var trackingDataActions = _interopRequireWildcard(_trackingDataActions);
	
	var _appHelper = __webpack_require__(3);
	
	var appHelper = _interopRequireWildcard(_appHelper);
	
	var _kpiModels = __webpack_require__(57);
	
	var kpiModels = _interopRequireWildcard(_kpiModels);
	
	var _kpiConstants = __webpack_require__(37);
	
	var kpiConstants = _interopRequireWildcard(_kpiConstants);
	
	var _dataHelper = __webpack_require__(11);
	
	var dataHelper = _interopRequireWildcard(_dataHelper);
	
	var _userDataHelper = __webpack_require__(15);
	
	var userDataHelper = _interopRequireWildcard(_userDataHelper);
	
	var _objectConstants = __webpack_require__(9);
	
	var objectConstants = _interopRequireWildcard(_objectConstants);
	
	var _gsap = __webpack_require__(8);
	
	var _gsapReactPlugin = __webpack_require__(10);
	
	var _gsapReactPlugin2 = _interopRequireDefault(_gsapReactPlugin);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } //eslint-disable-line import/no-named-as-default
	
	
	var ScoreIntroduction = function (_React$Component) {
	    _inherits(ScoreIntroduction, _React$Component);
	
	    function ScoreIntroduction(props, context) {
	        _classCallCheck(this, ScoreIntroduction);
	
	        var _this = _possibleConstructorReturn(this, (ScoreIntroduction.__proto__ || Object.getPrototypeOf(ScoreIntroduction)).call(this, props, context));
	
	        _this.state = {
	            lang: _this.props.lang,
	            status: objectConstants.STATUS_NOT_STARTED,
	            screenObject: _this.props.screenObject,
	            userData: _this.props.userData,
	            bite_id: _this.props.callbacks.getBiteId(),
	            score_kpi: appHelper.getBiteById(_this.props.callbacks.getBiteId()).score_kpi,
	            kpis: appHelper.getBiteById(_this.props.callbacks.getBiteId()).performance_kpis,
	            locale: appHelper.getLocalData(_this.props.screenObject),
	            score_kpi_locale: {},
	            showProgressionButton: false,
	            screenStatus: "",
	            checkComplete: false,
	            allowScroll: appHelper.allowScroll(_this.props.callbacks.getBiteId(), _this.props.callbacks.getScreenId(), _this.props.screenObject.asset_id),
	            continue_label: appHelper.getLocaleString("continue_label")
	        };
	        _this.getLocale = _this.getLocale.bind(_this);
	        _this.show = _this.show.bind(_this);
	        _this.onComplete = _this.onComplete.bind(_this);
	        _this.handleProgression = _this.handleProgression.bind(_this);
	        _this.enableProgression = _this.enableProgression.bind(_this);
	        _this.onProgressionBtnClicked = _this.onProgressionBtnClicked.bind(_this);
	        _this.getScreenStatus = _this.getScreenStatus.bind(_this);
	        _this.getObjectStatus = _this.getObjectStatus.bind(_this);
	        _this.scrollToTop = _this.scrollToTop.bind(_this);
	
	        return _this;
	    }
	
	    _createClass(ScoreIntroduction, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            this.getLocale();
	            this.getScreenStatus();
	            this.show();
	            if (appHelper.isDefined(this.props.callbacks.updateCharacterExpression) && appHelper.isDefined(this.state.screenObject.character_pose)) {
	                this.props.callbacks.updateCharacterExpression(this.state.screenObject.character_pose);
	            }
	        }
	    }, {
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(nextProps) {
	            if (this.state.lang !== nextProps.lang) {
	                this.setState({
	                    lang: nextProps.lang,
	                    locale: appHelper.getLocalData(this.state.bite_id),
	                    score_kpi_locale: appHelper.getLocalData(this.state.score_kpi),
	                    continue_label: appHelper.getLocaleString("continue_label")
	                });
	            }
	        }
	    }, {
	        key: 'componentDidUpdate',
	        value: function componentDidUpdate() {
	            if (this.state.checkComplete) {
	                this.onComplete();
	            }
	        }
	    }, {
	        key: 'scrollToTop',
	        value: function scrollToTop() {
	            if (this.state.allowScroll && this.state.status !== objectConstants.STATUS_COMPLETE) {
	                var object = this.refs[this.state.score_kpi.kpi_id + '_description'];
	                var scrollTo = this.props.callbacks.scrollTo;
	                setTimeout(function () {
	                    scrollTo(object.offsetTop);
	                }, objectConstants.SCROLL_TO);
	            }
	        }
	    }, {
	        key: 'getScreenStatus',
	        value: function getScreenStatus() {
	            var screenStatus = this.props.callbacks.getScreenStatus();
	            this.setState({
	                screenStatus: screenStatus,
	                status: screenStatus === objectConstants.STATUS_COMPLETE ? objectConstants.STATUS_COMPLETE : this.state.status
	            });
	        }
	    }, {
	        key: 'getObjectStatus',
	        value: function getObjectStatus() {
	            if (this.state.screenStatus === objectConstants.STATUS_COMPLETE) {
	                this.onComplete();
	            } else {
	                var objectUserData = {};
	                if (this.state.status !== objectConstants.STATUS_COMPLETE) {
	                    var subScreenParent = this.props.callbacks.getSubScreenParent();
	                    var screen_id = this.props.callbacks.getScreenId();
	                    if (appHelper.isDefined(subScreenParent)) {
	                        objectUserData = userDataHelper.getSubScreenObjectStatus(this.state.userData, subScreenParent.screen_id, screen_id, this.state.screenObject.asset_id);
	                    } else {
	                        objectUserData = userDataHelper.getObjectStatus(this.state.userData, screen_id, this.state.screenObject.asset_id);
	                    }
	                }
	
	                if (objectUserData.status === objectConstants.STATUS_COMPLETE) {
	                    this.setState({ status: objectConstants.STATUS_COMPLETE, checkComplete: true });
	                } else {
	                    this.setState({ checkComplete: true });
	                }
	            }
	        }
	    }, {
	        key: 'getLocale',
	        value: function getLocale() {
	            var locale = appHelper.getLocalData(this.state.score_kpi);
	            this.setState({ score_kpi_locale: Object.assign({}, locale) });
	        }
	    }, {
	        key: 'show',
	        value: function show() {
	            var optionRef = this.refs[this.state.score_kpi.kpi_id + '_description'];
	            _gsap.TweenLite.set(optionRef, { height: "auto", opacity: 1 });
	            _gsap.TweenLite.from(optionRef, objectConstants.SHOW_PANEL_DURATION, {
	                height: 0,
	                ease: _gsap.Expo.easeInOut
	            }).eventCallback("onComplete", this.getObjectStatus);
	        }
	    }, {
	        key: 'onComplete',
	        value: function onComplete() {
	            this.setState({ checkComplete: false });
	            var hasNextObject = this.props.callbacks.hasNextObject(this.props.index);
	            if (appHelper.isDefined(this.state.screenObject.progression) && this.state.screenObject.progression === objectConstants.OBJECT_PROGRESSION_CONTINUE && (this.state.status !== objectConstants.STATUS_COMPLETE || !hasNextObject)) {
	                if (!hasNextObject) {
	                    this.handleProgression();
	                    this.enableProgression();
	                } else {
	                    this.enableProgression();
	                }
	            } else {
	                this.handleProgression();
	            }
	            this.scrollToTop();
	        }
	    }, {
	        key: 'enableProgression',
	        value: function enableProgression() {
	            if (!this.props.callbacks.isReviewMode()) {
	                this.setState({ showProgressionButton: true });
	            }
	        }
	    }, {
	        key: 'handleProgression',
	        value: function handleProgression() {
	            var progressionRule = appHelper.isDefined(this.state.screenObject.progression) ? this.state.screenObject.progression : objectConstants.OBJECT_PROGRESSION_CONTINUE;
	            var progressionType = appHelper.isDefined(this.state.screenObject.progression_type) ? this.state.screenObject.progression_type : undefined;
	            var progressionGoToId = appHelper.isDefined(this.state.screenObject.progression_goto_id) ? this.state.screenObject.progression_goto_id : undefined;
	            var completionData = {
	                progression: progressionRule,
	                progressionType: progressionType,
	                progressionGoToId: progressionGoToId,
	                asset_id: this.state.screenObject.asset_id,
	                status: objectConstants.STATUS_COMPLETE,
	                asset_type_code: this.state.screenObject.asset_type_code,
	                navigateToNextScreen: appHelper.isDefined(this.state.screenObject.progression) && this.state.screenObject.progression === objectConstants.OBJECT_PROGRESSION_CONTINUE,
	                index: this.props.index
	            };
	
	            this.props.callbacks.onObjectComplete(completionData);
	            //t
	        }
	    }, {
	        key: 'onProgressionBtnClicked',
	        value: function onProgressionBtnClicked() {
	            this.setState({ showProgressionButton: false });
	            if (this.props.callbacks.hasNextObject(this.props.index)) {
	                this.handleProgression();
	            } else {
	                this.props.callbacks.navigateToNextScreen();
	            }
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this2 = this;
	
	            return _react2.default.createElement(
	                'div',
	                { className: 'object-container', ref: this.state.score_kpi.kpi_id + '_description' },
	                this.state.screenObject.show_title && appHelper.isDefined(this.state.locale.label) && this.state.locale.label !== null && this.state.locale.label.length > 0 ? _react2.default.createElement('h4', { className: 'bold', dangerouslySetInnerHTML: { __html: this.state.locale.label } }) : null,
	                appHelper.isDefined(this.state.locale.description) && this.state.locale.description !== null && this.state.locale.description.length > 0 && (this.state.screenObject.display_scope === objectConstants.KPI_DISPLAY_SCOPE_BOTH || this.state.screenObject.display_scope === objectConstants.KPI_DISPLAY_SCOPE_PRIMARY) ? _react2.default.createElement('div', { dangerouslySetInnerHTML: { __html: this.state.locale.description } }) : null,
	                this.state.screenObject.display_scope === objectConstants.KPI_DISPLAY_SCOPE_BOTH || this.state.screenObject.display_scope === objectConstants.KPI_DISPLAY_SCOPE_PRIMARY ? _react2.default.createElement(
	                    'div',
	                    { ref: this.state.score_kpi.kpi_id + '_description', className: 'kpi-overview-panel' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'kpi-overview-row' },
	                        _react2.default.createElement(_KpiDescription2.default, { kpi: this.state.score_kpi,
	                            bite_id: this.state.bite_id,
	                            callbacks: this.state.objectCallbacks })
	                    )
	                ) : null,
	                this.state.screenObject.display_scope === objectConstants.KPI_DISPLAY_SCOPE_BOTH ? _react2.default.createElement('br', null) : null,
	                appHelper.isDefined(this.state.locale.secondary_metrics_description) && this.state.locale.secondary_metrics_description !== null && this.state.locale.secondary_metrics_description.length > 0 && (this.state.screenObject.display_scope === objectConstants.KPI_DISPLAY_SCOPE_BOTH || this.state.screenObject.display_scope === objectConstants.KPI_DISPLAY_SCOPE_SECONDARY) ? _react2.default.createElement('div', { dangerouslySetInnerHTML: { __html: this.state.locale.secondary_metrics_description } }) : null,
	                appHelper.isDefined(this.state.locale.secondary_metrics_description) && this.state.locale.secondary_metrics_description !== null && this.state.locale.secondary_metrics_description.length > 0 && (this.state.screenObject.display_scope === objectConstants.KPI_DISPLAY_SCOPE_BOTH || this.state.screenObject.display_scope === objectConstants.KPI_DISPLAY_SCOPE_SECONDARY) ? _react2.default.createElement('br', null) : null,
	                this.state.screenObject.display_scope === objectConstants.KPI_DISPLAY_SCOPE_BOTH || this.state.screenObject.display_scope === objectConstants.KPI_DISPLAY_SCOPE_SECONDARY ? _react2.default.createElement(
	                    'div',
	                    { className: 'kpi-overview-panel' },
	                    this.state.kpis.map(function (kpi) {
	                        return _react2.default.createElement(_KpiDescription2.default, { key: kpi.kpi_id,
	                            kpi: kpi,
	                            bite_id: _this2.state.bite_id,
	                            callbacks: _this2.state.objectCallbacks });
	                    })
	                ) : null,
	                this.state.showProgressionButton ? _react2.default.createElement(_Button2.default, { label: this.state.continue_label,
	                    id: this.state.screenObject + '_button',
	                    onClick: this.onProgressionBtnClicked }) : null
	            );
	        }
	    }]);
	
	    return ScoreIntroduction;
	}(_react2.default.Component);
	
	ScoreIntroduction.propTypes = {
	    screenObject: _propTypes2.default.object.isRequired,
	    callbacks: _propTypes2.default.object.isRequired,
	    index: _propTypes2.default.number,
	    userData: _propTypes2.default.object.isRequired,
	    lang: _propTypes2.default.string.isRequired,
	    actions: _propTypes2.default.object
	};
	
	ScoreIntroduction.contextTypes = {
	    router: _propTypes2.default.object
	};
	
	function mapStateToProps(state, ownProps) {
	    var lang = state.userData.lang;
	    return {
	        lang: lang,
	        userData: state.userData
	    };
	}
	
	function mapDispatchToProps(dispatch) {
	    return {
	        actions: (0, _redux.bindActionCreators)(Object.assign({}, appDataActions, trackingDataActions), dispatch)
	    };
	}
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(ScoreIntroduction);

/***/ },
/* 490 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(5);
	
	var _redux = __webpack_require__(4);
	
	var _Button = __webpack_require__(18);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _userDataActions = __webpack_require__(20);
	
	var userDataActions = _interopRequireWildcard(_userDataActions);
	
	var _trackingDataActions = __webpack_require__(7);
	
	var trackingDataActions = _interopRequireWildcard(_trackingDataActions);
	
	var _appHelper = __webpack_require__(3);
	
	var appHelper = _interopRequireWildcard(_appHelper);
	
	var _userDataHelper = __webpack_require__(15);
	
	var userDataHelper = _interopRequireWildcard(_userDataHelper);
	
	var _appConstants = __webpack_require__(13);
	
	var appConstants = _interopRequireWildcard(_appConstants);
	
	var _objectConstants = __webpack_require__(9);
	
	var objectConstants = _interopRequireWildcard(_objectConstants);
	
	var _gsap = __webpack_require__(8);
	
	var _gsapReactPlugin = __webpack_require__(10);
	
	var _gsapReactPlugin2 = _interopRequireDefault(_gsapReactPlugin);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } //eslint-disable-line import/no-named-as-default
	
	
	var Link = function (_React$Component) {
	    _inherits(Link, _React$Component);
	
	    function Link(props, context) {
	        _classCallCheck(this, Link);
	
	        var _this = _possibleConstructorReturn(this, (Link.__proto__ || Object.getPrototypeOf(Link)).call(this, props, context));
	
	        _this.state = {
	            lang: _this.props.lang,
	            screenObject: _this.props.screenObject,
	            userData: _this.props.userData,
	            status: objectConstants.STATUS_NOT_STARTED,
	            locale: appHelper.getLocalData(_this.props.screenObject),
	            showProgressionButton: false,
	            link: {},
	            screenStatus: "",
	            isResourceObject: appHelper.isDefined(_this.props.callbacks.checkIsResourceScreen) && _this.props.callbacks.checkIsResourceScreen(),
	            allowScroll: appHelper.allowScroll(_this.props.callbacks.getBiteId(), _this.props.callbacks.getScreenId(), _this.props.screenObject.asset_id),
	            continue_label: appHelper.getLocaleString("continue_label")
	        };
	        _this.getAssets = _this.getAssets.bind(_this);
	        _this.show = _this.show.bind(_this);
	        _this.handleProgression = _this.handleProgression.bind(_this);
	        _this.onOpen = _this.onOpen.bind(_this);
	        _this.setClass = _this.setClass.bind(_this);
	        _this.getObjectStatus = _this.getObjectStatus.bind(_this);
	        _this.scrollToTop = _this.scrollToTop.bind(_this);
	        _this.getImagePath = _this.getImagePath.bind(_this);
	        _this.enableProgression = _this.enableProgression.bind(_this);
	        _this.disableProgression = _this.disableProgression.bind(_this);
	        _this.onProgressionBtnClicked = _this.onProgressionBtnClicked.bind(_this);
	        _this.onComplete = _this.onComplete.bind(_this);
	        _this.getScreenStatus = _this.getScreenStatus.bind(_this);
	        _this.onRendered = _this.onRendered.bind(_this);
	        return _this;
	    }
	
	    _createClass(Link, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            this.getAssets();
	            this.getScreenStatus();
	            if (appHelper.isDefined(this.props.callbacks.updateCharacterExpression) && appHelper.isDefined(this.state.screenObject.character_pose)) {
	                this.props.callbacks.updateCharacterExpression(this.state.screenObject.character_pose);
	            }
	        }
	    }, {
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(nextProps) {
	            if (this.state.userData !== nextProps.userData) {
	                this.setState({ userData: Object.assign({}, nextProps.userData) });
	            }
	            if (this.state.lang !== nextProps.lang) {
	                var link = appHelper.getLinkAsset(this.state.screenObject);
	                this.setState({
	                    lang: nextProps.lang,
	                    locale: appHelper.getLocalData(this.state.screenObject),
	                    link: appHelper.isDefined(link.locale) ? appHelper.getLocalData(link) : link,
	                    continue_label: appHelper.getLocaleString("continue_label")
	                });
	            }
	        }
	    }, {
	        key: 'componentDidUpdate',
	        value: function componentDidUpdate() {
	            if (this.state.userDataUpdated) {
	                this.getObjectStatus();
	            }
	        }
	    }, {
	        key: 'getScreenStatus',
	        value: function getScreenStatus() {
	            var screenStatus = this.props.callbacks.getScreenStatus();
	            this.setState({
	                screenStatus: screenStatus,
	                status: screenStatus === objectConstants.STATUS_COMPLETE ? objectConstants.STATUS_COMPLETE : this.state.status
	            });
	        }
	    }, {
	        key: 'getObjectStatus',
	        value: function getObjectStatus() {
	            this.setState({ userDataUpdated: false });
	            if (this.state.screenStatus === objectConstants.STATUS_COMPLETE) {
	                this.onComplete();
	            } else {
	                var objectUserData = {};
	                if (this.state.status !== objectConstants.STATUS_COMPLETE) {
	                    var subScreenParent = this.props.callbacks.getSubScreenParent();
	                    var screen_id = this.props.callbacks.getScreenId();
	                    if (appHelper.isDefined(subScreenParent)) {
	                        objectUserData = userDataHelper.getSubScreenObjectStatus(this.state.userData, subScreenParent.screen_id, screen_id, this.state.screenObject.asset_id);
	                    } else if (this.state.isResourceObject) {
	                        objectUserData = userDataHelper.getResourceScreenObjectUserData(this.state.userData, screen_id, this.state.screenObject.asset_id);
	                    } else {
	                        objectUserData = userDataHelper.getObjectStatus(this.state.userData, screen_id, this.state.screenObject.asset_id);
	                    }
	                }
	
	                if (!this.state.screenObject.required_for_completion || objectUserData.status === objectConstants.STATUS_COMPLETE) {
	                    this.setState({ status: objectConstants.STATUS_COMPLETE });
	                    this.onComplete();
	                }
	            }
	        }
	    }, {
	        key: 'getAssets',
	        value: function getAssets() {
	            var link = appHelper.getLinkAsset(this.state.screenObject);
	            this.setState({ link: appHelper.isDefined(link.locale) ? appHelper.getLocalData(link) : link });
	            this.show();
	        }
	    }, {
	        key: 'show',
	        value: function show() {
	            var fileRef = this.refs['link_' + this.state.screenObject.asset_id];
	            if (appHelper.isDefined(fileRef)) {
	                _gsap.TweenLite.set(fileRef, { opacity: 1, height: "auto" });
	                _gsap.TweenLite.from(fileRef, objectConstants.SHOW_PANEL_DURATION, {
	                    height: 0,
	                    opacity: 0,
	                    ease: _gsap.Expo.easeInOut
	                }).eventCallback("onComplete", this.onRendered);
	            }
	        }
	    }, {
	        key: 'onRendered',
	        value: function onRendered() {
	            if (this.state.isResourceObject) {
	                this.props.callbacks.onObjectRendered();
	            }
	            this.getObjectStatus();
	        }
	    }, {
	        key: 'scrollToTop',
	        value: function scrollToTop() {
	            if (this.state.allowScroll && this.state.status !== objectConstants.STATUS_COMPLETE) {
	                var question = this.refs['link_' + this.state.screenObject.asset_id];
	                var scrollTo = this.props.callbacks.scrollTo;
	                setTimeout(function () {
	                    if (appHelper.isDefined(scrollTo)) {
	                        scrollTo(question.offsetTop);
	                    }
	                }, objectConstants.SCROLL_TO);
	            }
	        }
	    }, {
	        key: 'getImagePath',
	        value: function getImagePath(image) {
	            if (appConstants.DEVELOPMENT_MODE) {
	                if (appHelper.isDefined(image) && image.length > 0) {
	                    return __webpack_require__(16)("./" + image);
	                }
	            } else {
	                return image;
	            }
	        }
	    }, {
	        key: 'onOpen',
	        value: function onOpen() {
	            if (this.state.status !== objectConstants.STATUS_COMPLETE) {
	                this.setState({ status: objectConstants.STATUS_COMPLETE });
	                this.onComplete();
	            }
	        }
	    }, {
	        key: 'setClass',
	        value: function setClass() {
	            if (this.state.status === objectConstants.STATUS_COMPLETE) {
	                return "complete";
	            } else {
	                return "not-started";
	            }
	        }
	    }, {
	        key: 'onComplete',
	        value: function onComplete() {
	            this.setState({ checkComplete: false });
	            var hasNextObject = this.props.callbacks.hasNextObject(this.props.index);
	            if (appHelper.isDefined(this.state.screenObject.progression) && this.state.screenObject.progression === objectConstants.OBJECT_PROGRESSION_CONTINUE && (this.state.status !== objectConstants.STATUS_COMPLETE || !hasNextObject)) {
	                if (!hasNextObject && !this.state.isResourceObject) {
	                    this.handleProgression();
	                    this.enableProgression();
	                } else if (!hasNextObject && this.state.isResourceObject) {
	                    this.handleProgression();
	                } else if (this.state.isResourceObject) {
	                    this.handleProgression();
	                } else {
	                    this.enableProgression();
	                }
	            } else {
	                this.handleProgression();
	            }
	            this.scrollToTop();
	        }
	    }, {
	        key: 'enableProgression',
	        value: function enableProgression() {
	            if (!this.props.callbacks.isReviewMode()) {
	                this.setState({ showProgressionButton: true });
	            }
	        }
	    }, {
	        key: 'disableProgression',
	        value: function disableProgression() {
	            this.setState({ showProgressionButton: false });
	        }
	    }, {
	        key: 'handleProgression',
	        value: function handleProgression() {
	            var progressionRule = appHelper.isDefined(this.state.screenObject.progression) ? this.state.screenObject.progression : objectConstants.OBJECT_PROGRESSION_CONTINUE;
	            var progressionType = appHelper.isDefined(this.state.screenObject.progression_type) ? this.state.screenObject.progression_type : undefined;
	            var progressionGoToId = appHelper.isDefined(this.state.screenObject.progression_goto_id) ? this.state.screenObject.progression_goto_id : undefined;
	            var completionData = {
	                progression: progressionRule,
	                progressionType: progressionType,
	                progressionGoToId: progressionGoToId,
	                asset_id: this.state.screenObject.asset_id,
	                status: objectConstants.STATUS_COMPLETE,
	                showProgressionButton: false,
	                asset_type_code: this.state.screenObject.asset_type_code,
	                navigateToNextScreen: !this.state.isResourceObject && appHelper.isDefined(this.state.screenObject.progression) && this.state.screenObject.progression === objectConstants.OBJECT_PROGRESSION_CONTINUE,
	                index: this.props.index
	            };
	
	            this.props.callbacks.onObjectComplete(completionData);
	            //t
	        }
	    }, {
	        key: 'onProgressionBtnClicked',
	        value: function onProgressionBtnClicked() {
	            this.setState({ showProgressionButton: false });
	            if (this.props.callbacks.hasNextObject(this.props.index) || this.state.isResourceObject) {
	                this.handleProgression();
	            } else {
	                this.props.callbacks.navigateToNextScreen();
	            }
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            return _react2.default.createElement(
	                'div',
	                { className: 'object-container', ref: 'link_' + this.state.screenObject.asset_id },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'document-panel link ' + this.setClass() },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'flex-item' },
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'document-header' },
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'link-title link ' + this.setClass() },
	                                _react2.default.createElement('a', { href: this.state.link.src,
	                                    target: '_blank',
	                                    onClick: this.onOpen,
	                                    tabIndex: '-1',
	                                    dangerouslySetInnerHTML: { __html: this.state.locale.label } })
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'link-sub-title' },
	                            _react2.default.createElement('a', { href: this.state.link.src,
	                                target: '_blank',
	                                id: 'link_url_' + this.state.screenObject.asset_id,
	                                onClick: this.onOpen,
	                                tabIndex: 0,
	                                dangerouslySetInnerHTML: { __html: this.state.link.src } })
	                        ),
	                        appHelper.isDefined(this.state.locale.description) && this.state.locale.description !== null && this.state.locale.description.length > 0 ? _react2.default.createElement('div', { className: 'document-description',
	                            dangerouslySetInnerHTML: { __html: this.state.locale.description } }) : null
	                    )
	                ),
	                this.state.showProgressionButton ? _react2.default.createElement(_Button2.default, { label: this.state.continue_label,
	                    id: this.state.screenObject + '_button',
	                    onClick: this.onProgressionBtnClicked }) : null
	            );
	        }
	    }]);
	
	    return Link;
	}(_react2.default.Component);
	/*<div className="flex-item">
	                        <div className={`thumbnail-container link ${this.setClass()}`}>
	                            <img src={this.getImagePath(this.state.link.thumbnail)}/>
	                        </div>
	                    </div>
	*/
	
	
	Link.propTypes = {
	    screenObject: _propTypes2.default.object.isRequired,
	    callbacks: _propTypes2.default.object.isRequired,
	    userData: _propTypes2.default.object.isRequired,
	    index: _propTypes2.default.number,
	    lang: _propTypes2.default.string.isRequired,
	    actions: _propTypes2.default.object.isRequired
	};
	
	Link.contextTypes = {
	    router: _propTypes2.default.object
	};
	
	function mapStateToProps(state, ownProps) {
	    var lang = state.userData.lang;
	    return {
	        lang: lang,
	        userData: state.userData
	    };
	}
	
	function mapDispatchToProps(dispatch) {
	    return {
	        actions: (0, _redux.bindActionCreators)(Object.assign({}, userDataActions, trackingDataActions), dispatch)
	    };
	}
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(Link);

/***/ },
/* 491 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(5);
	
	var _redux = __webpack_require__(4);
	
	var _Prompt = __webpack_require__(83);
	
	var _Prompt2 = _interopRequireDefault(_Prompt);
	
	var _DialogPrompt = __webpack_require__(94);
	
	var _DialogPrompt2 = _interopRequireDefault(_DialogPrompt);
	
	var _Button = __webpack_require__(18);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _appDataActions = __webpack_require__(12);
	
	var appDataActions = _interopRequireWildcard(_appDataActions);
	
	var _trackingDataActions = __webpack_require__(7);
	
	var trackingDataActions = _interopRequireWildcard(_trackingDataActions);
	
	var _dialogPopupActions = __webpack_require__(19);
	
	var dialogPopupActions = _interopRequireWildcard(_dialogPopupActions);
	
	var _appHelper = __webpack_require__(3);
	
	var appHelper = _interopRequireWildcard(_appHelper);
	
	var _dataHelper = __webpack_require__(11);
	
	var dataHelper = _interopRequireWildcard(_dataHelper);
	
	var _userDataHelper = __webpack_require__(15);
	
	var userDataHelper = _interopRequireWildcard(_userDataHelper);
	
	var _objectConstants = __webpack_require__(9);
	
	var objectConstants = _interopRequireWildcard(_objectConstants);
	
	var _componentHelper = __webpack_require__(31);
	
	var _gsap = __webpack_require__(8);
	
	var _gsapReactPlugin = __webpack_require__(10);
	
	var _gsapReactPlugin2 = _interopRequireDefault(_gsapReactPlugin);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } //eslint-disable-line import/no-named-as-default
	
	//import {MULTIPLE_CHOICE_REVIEW_CONFIG} from '../../../models/dialogModels';
	
	
	var MultipleChoice = function (_React$Component) {
	    _inherits(MultipleChoice, _React$Component);
	
	    function MultipleChoice(props, context) {
	        _classCallCheck(this, MultipleChoice);
	
	        var _this = _possibleConstructorReturn(this, (MultipleChoice.__proto__ || Object.getPrototypeOf(MultipleChoice)).call(this, props, context));
	
	        _this.state = {
	            lang: _this.props.lang,
	            initialised: false,
	            userData: _this.props.userData,
	            status: objectConstants.STATUS_NOT_STARTED,
	            character_name: appHelper.isDefined(_this.props.callbacks) ? _this.props.callbacks.getCharacterName() : appHelper.getScreenCharacterNameByAssetId(_this.props.screenObject.asset_id),
	            screenObject: _this.props.screenObject,
	            locale: appHelper.getLocalData(_this.props.screenObject),
	            questionType: {},
	            promptRevealed: _this.props.screenObject.prompt_type === objectConstants.PROMPT_TYPE_SHOW_NO_PROMPT,
	            callbacks: {},
	            allowScroll: appHelper.allowScroll(_this.props.callbacks.getBiteId(), _this.props.callbacks.getScreenId(), _this.props.screenObject.asset_id),
	            checkObjectStatus: false
	        };
	        _this.getAssets = _this.getAssets.bind(_this);
	        _this.getQuestionType = _this.getQuestionType.bind(_this);
	        _this.onPromptRevealed = _this.onPromptRevealed.bind(_this);
	        _this.scrollToTop = _this.scrollToTop.bind(_this);
	        _this.scrollToFeedback = _this.scrollToFeedback.bind(_this);
	        _this.scrollToSubmitBtn = _this.scrollToSubmitBtn.bind(_this);
	        _this.setCallbacks = _this.setCallbacks.bind(_this);
	        _this.scrollOptionsToTop = _this.scrollOptionsToTop.bind(_this);
	        _this.scrollToContinue = _this.scrollToContinue.bind(_this);
	        return _this;
	    }
	
	    _createClass(MultipleChoice, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            this.setCallbacks();
	            this.getQuestionType();
	            if (appHelper.isDefined(this.props.callbacks.updateCharacterExpression) && appHelper.isDefined(this.state.screenObject.character_pose)) {
	                this.props.callbacks.updateCharacterExpression(this.state.screenObject.character_pose);
	            }
	            this.getAssets();
	        }
	    }, {
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(nextProps) {
	            if (this.state.userData !== nextProps.userData) {
	                this.setState({ userData: Object.assign({}, nextProps.userData) });
	            }
	
	            if (this.state.lang !== nextProps.lang) {
	                this.setState({
	                    lang: nextProps.lang,
	                    locale: appHelper.getLocalData(this.state.screenObject)
	                });
	            }
	        }
	    }, {
	        key: 'componentDidUpdate',
	        value: function componentDidUpdate() {}
	    }, {
	        key: 'getAssets',
	        value: function getAssets() {
	            var objectUserData = {};
	            if (this.state.status !== objectConstants.STATUS_COMPLETE) {
	                var subScreenParent = this.props.callbacks.getSubScreenParent();
	                var screen_id = this.props.callbacks.getScreenId();
	                if (appHelper.isDefined(subScreenParent)) {
	                    objectUserData = userDataHelper.getSubScreenObjectStatus(this.state.userData, subScreenParent.screen_id, screen_id, this.state.screenObject.asset_id);
	                } else if (this.state.isResourceObject) {
	                    objectUserData = userDataHelper.getResourceScreenObjectUserData(this.state.userData, screen_id, this.state.screenObject.asset_id);
	                } else {
	                    objectUserData = userDataHelper.getObjectStatus(this.state.userData, screen_id, this.state.screenObject.asset_id);
	                }
	            }
	
	            if (appHelper.isDefined(this.state.screenObject.audio)) {
	                var audio = appHelper.getAudioAsset(this.state.screenObject.audio);
	                var audioObj = {
	                    audioRef: 'audio_' + audio.id + '_' + audio.type
	                };
	
	                if (objectUserData.status !== objectConstants.STATUS_COMPLETE) {
	                    this.props.actions.setAudio(audioObj);
	                }
	            }
	        }
	    }, {
	        key: 'getQuestionType',
	        value: function getQuestionType() {
	            var questionType = Object.assign({}, (0, _componentHelper.getChildObjectComponentByType)(this.state.screenObject.asset_type_code + '_' + this.state.screenObject.selection_type), {
	                data: this.state.screenObject
	            });
	            this.setState({
	                questionType: Object.assign({}, questionType),
	                initialised: true
	            });
	        }
	    }, {
	        key: 'onPromptRevealed',
	        value: function onPromptRevealed() {
	            this.setState({ promptRevealed: true });
	        }
	    }, {
	        key: 'setCallbacks',
	        value: function setCallbacks() {
	            this.setState({ callbacks: Object.assign({}, this.props.callbacks, {
	                    scrollToTop: this.scrollToTop,
	                    scrollToFeedback: this.scrollToFeedback,
	                    scrollToSubmitBtn: this.scrollToSubmitBtn,
	                    scrollOptionsToTop: this.scrollOptionsToTop,
	                    scrollToContinue: this.scrollToContinue
	                }) });
	        }
	    }, {
	        key: 'scrollToTop',
	        value: function scrollToTop() {
	            var subScreenParent = this.props.callbacks.getSubScreenParent();
	            var objectUserData = {};
	            var screen_id = this.props.callbacks.getScreenId();
	            if (appHelper.isDefined(subScreenParent)) {
	                objectUserData = userDataHelper.getSubScreenObjectStatus(this.state.userData, subScreenParent.screen_id, screen_id, this.state.screenObject.asset_id);
	            } else {
	                objectUserData = userDataHelper.getObjectStatus(this.state.userData, screen_id, this.state.screenObject.asset_id);
	            }
	            if (this.state.allowScroll && objectUserData.status !== objectConstants.STATUS_COMPLETE) {
	                var question = this.refs[this.state.screenObject.asset_id + '_question'];
	                var scrollTo = this.props.callbacks.scrollTo;
	                setTimeout(function () {
	                    scrollTo(question.offsetTop);
	                }, objectConstants.SCROLL_TO);
	            }
	        }
	    }, {
	        key: 'scrollToFeedback',
	        value: function scrollToFeedback(feedbackPos) {
	            var question = this.refs[this.state.screenObject.asset_id + '_question'];
	            var scrollTo = this.props.callbacks.scrollTo;
	            setTimeout(function () {
	                scrollTo(question.offsetTop + feedbackPos, true);
	            }, objectConstants.SCROLL_TO);
	        }
	    }, {
	        key: 'scrollToSubmitBtn',
	        value: function scrollToSubmitBtn(submitBtnOffset) {
	            var question = this.refs[this.state.screenObject.asset_id + '_question'];
	            var scrollTo = this.props.callbacks.scrollTo;
	            setTimeout(function () {
	                scrollTo(question.offsetTop + submitBtnOffset);
	            }, objectConstants.SCROLL_TO);
	        }
	    }, {
	        key: 'scrollOptionsToTop',
	        value: function scrollOptionsToTop(questionOptionsOffset) {
	
	            var question = this.refs[this.state.screenObject.asset_id + '_question'];
	            var scrollTo = this.props.callbacks.scrollTo;
	            setTimeout(function () {
	                scrollTo(question.offsetTop + questionOptionsOffset);
	            }, objectConstants.SCROLL_TO);
	        }
	    }, {
	        key: 'scrollToContinue',
	        value: function scrollToContinue() {
	            var question = this.refs[this.state.screenObject.asset_id + '_question'];
	            var scrollTo = this.props.callbacks.scrollTo;
	            setTimeout(function () {
	                scrollTo(question.offsetTop, true);
	            }, objectConstants.SCROLL_TO);
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var QuestionType = this.state.questionType;
	            return _react2.default.createElement(
	                'div',
	                { ref: this.state.screenObject.asset_id + '_question' },
	                this.state.initialised ? _react2.default.createElement(QuestionType.component, { screenObject: QuestionType.data, callbacks: this.state.callbacks, characterPose: this.props.characterPose, index: this.props.index }) : null
	            );
	        }
	    }]);
	
	    return MultipleChoice;
	}(_react2.default.Component);
	
	MultipleChoice.propTypes = {
	    screenObject: _propTypes2.default.object.isRequired,
	    callbacks: _propTypes2.default.object.isRequired,
	    characterPose: _propTypes2.default.object,
	    contentData: _propTypes2.default.object.isRequired,
	    index: _propTypes2.default.number,
	    trackingData: _propTypes2.default.object.isRequired,
	    userData: _propTypes2.default.object.isRequired,
	    lang: _propTypes2.default.string.isRequired,
	    actions: _propTypes2.default.object.isRequired
	};
	
	MultipleChoice.contextTypes = {
	    router: _propTypes2.default.object
	};
	
	function mapStateToProps(state) {
	    var lang = state.userData.lang;
	    return {
	        lang: lang,
	        contentData: state.contentData,
	        trackingData: state.trackingData,
	        userData: state.userData
	
	    };
	}
	
	function mapDispatchToProps(dispatch) {
	    return {
	        actions: (0, _redux.bindActionCreators)(Object.assign({}, appDataActions, trackingDataActions, dialogPopupActions), dispatch)
	    };
	}
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(MultipleChoice);

/***/ },
/* 492 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(5);
	
	var _redux = __webpack_require__(4);
	
	var _Prompt = __webpack_require__(83);
	
	var _Prompt2 = _interopRequireDefault(_Prompt);
	
	var _DialogPrompt = __webpack_require__(94);
	
	var _DialogPrompt2 = _interopRequireDefault(_DialogPrompt);
	
	var _ConversationSingleAnswerOption = __webpack_require__(494);
	
	var _ConversationSingleAnswerOption2 = _interopRequireDefault(_ConversationSingleAnswerOption);
	
	var _Button = __webpack_require__(18);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _keyboardConstants = __webpack_require__(14);
	
	var keyboardConstants = _interopRequireWildcard(_keyboardConstants);
	
	var _componentConstants = __webpack_require__(49);
	
	var componentConstants = _interopRequireWildcard(_componentConstants);
	
	var _SingleAnswerFeedback = __webpack_require__(200);
	
	var _SingleAnswerFeedback2 = _interopRequireDefault(_SingleAnswerFeedback);
	
	var _Label = __webpack_require__(523);
	
	var _Label2 = _interopRequireDefault(_Label);
	
	var _ChildConversationDialog = __webpack_require__(65);
	
	var _ChildConversationDialog2 = _interopRequireDefault(_ChildConversationDialog);
	
	var _BadgeCollect = __webpack_require__(47);
	
	var _BadgeCollect2 = _interopRequireDefault(_BadgeCollect);
	
	var _appDataActions = __webpack_require__(12);
	
	var appDataActions = _interopRequireWildcard(_appDataActions);
	
	var _trackingDataActions = __webpack_require__(7);
	
	var trackingDataActions = _interopRequireWildcard(_trackingDataActions);
	
	var _dialogPopupActions = __webpack_require__(19);
	
	var dialogPopupActions = _interopRequireWildcard(_dialogPopupActions);
	
	var _appHelper = __webpack_require__(3);
	
	var appHelper = _interopRequireWildcard(_appHelper);
	
	var _dataHelper = __webpack_require__(11);
	
	var dataHelper = _interopRequireWildcard(_dataHelper);
	
	var _userDataHelper = __webpack_require__(15);
	
	var userDataHelper = _interopRequireWildcard(_userDataHelper);
	
	var _xAPIHelper = __webpack_require__(86);
	
	var xAPIHelper = _interopRequireWildcard(_xAPIHelper);
	
	var _kpiHelper = __webpack_require__(35);
	
	var kpiHelper = _interopRequireWildcard(_kpiHelper);
	
	var _objectConstants = __webpack_require__(9);
	
	var objectConstants = _interopRequireWildcard(_objectConstants);
	
	var _appConstants = __webpack_require__(13);
	
	var appConstants = _interopRequireWildcard(_appConstants);
	
	var _localStorage = __webpack_require__(17);
	
	var localStorage = _interopRequireWildcard(_localStorage);
	
	var _dialogModels = __webpack_require__(32);
	
	var _gsap = __webpack_require__(8);
	
	var _gsapReactPlugin = __webpack_require__(10);
	
	var _gsapReactPlugin2 = _interopRequireDefault(_gsapReactPlugin);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } //eslint-disable-line import/no-named-as-default
	
	
	var ConversationSingleAnswer = function (_React$Component) {
	    _inherits(ConversationSingleAnswer, _React$Component);
	
	    function ConversationSingleAnswer(props, context) {
	        _classCallCheck(this, ConversationSingleAnswer);
	
	        var _this = _possibleConstructorReturn(this, (ConversationSingleAnswer.__proto__ || Object.getPrototypeOf(ConversationSingleAnswer)).call(this, props, context));
	
	        _this.state = {
	            lang: _this.props.lang,
	            screenObject: _this.props.screenObject,
	            userData: _this.props.userData,
	            options: _this.props.screenObject.options,
	            objectStates: objectConstants.OBJECT_DISPLAY_STATES,
	            locale: appHelper.getLocalData(_this.props.screenObject),
	            reviewMode: false,
	            propsUpdated: false,
	            responseData: {
	                bite_id: _this.props.callbacks.getBiteId(),
	                screen_id: _this.props.callbacks.getScreenId(),
	                asset_id: _this.props.screenObject.asset_id,
	                currentAttempt: 1,
	                currentStatus: objectConstants.STATUS_NOT_STARTED,
	                displayState: objectConstants.OBJECT_DISPLAY_STATE_INITIAL,
	                responses: [],
	                latestResponse: {},
	                scoring_type: _this.props.screenObject.scoring_type
	            },
	            showPrompt: true,
	            showOptions: false,
	            showFeedback: false,
	            showResponse: false,
	            selectedOption: "",
	            optionCanUpdate: true,
	            animateResponse: true,
	            noFeedback: {
	                feedbackRequested: false,
	                responseHandled: false
	            },
	            screenStatus: "",
	            checkObjectStatus: false,
	            handleCompletion: false,
	            checkPostXAPIResponse: false,
	            questionIsChecked: false,
	            character_name: appHelper.isDefined(_this.props.callbacks) ? _this.props.callbacks.getCharacterName() : appHelper.getScreenCharacterNameByAssetId(_this.props.screenObject.asset_id),
	            focusedOption: _this.props.screenObject.options[0],
	            focusOnFeedback: false,
	            optionCallbacks: {},
	            updateFocus: false,
	            showProgression: false,
	            hideFeedback: false,
	            progression_label: "",
	            hasBadges: false,
	            badgesCollected: false,
	            animateBadge: true,
	            completionSent: false,
	            multiple_choice_single_answer_question_label: appHelper.getLocaleString("multiple_choice_single_answer_question_label"),
	            continue_label: appHelper.getLocaleString("continue_label"),
	            try_again_label: appHelper.getLocaleString("try_again_label"),
	            xApiResponseObj: {}
	        };
	
	        _this.getLocale = _this.getLocale.bind(_this);
	        _this.randomiseOptions = _this.randomiseOptions.bind(_this);
	        _this.renderOptions = _this.renderOptions.bind(_this);
	        _this.onOptionClick = _this.onOptionClick.bind(_this);
	        _this.showFeedback = _this.showFeedback.bind(_this);
	        _this.showResponse = _this.showResponse.bind(_this);
	        _this.handleResponse = _this.handleResponse.bind(_this);
	        _this.handleProgression = _this.handleProgression.bind(_this);
	        _this.reattempt = _this.reattempt.bind(_this);
	        _this.onReviewObject = _this.onReviewObject.bind(_this);
	        _this.getObjectStatus = _this.getObjectStatus.bind(_this);
	        _this.setReviewMode = _this.setReviewMode.bind(_this);
	        _this.scrollOptionsToTop = _this.scrollOptionsToTop.bind(_this);
	        _this.setOptionCanUpdate = _this.setOptionCanUpdate.bind(_this);
	        _this.getOptionCanUpdate = _this.getOptionCanUpdate.bind(_this);
	        _this.handleNoFeedback = _this.handleNoFeedback.bind(_this);
	        _this.getAssets = _this.getAssets.bind(_this);
	        _this.onFeedbackComplete = _this.onFeedbackComplete.bind(_this);
	        _this.handleAttemptComplete = _this.handleAttemptComplete.bind(_this);
	        _this.handleResponseComplete = _this.handleResponseComplete.bind(_this);
	        _this.postXAPIResponse = _this.postXAPIResponse.bind(_this);
	        _this.getOptionListClass = _this.getOptionListClass.bind(_this);
	        _this.getImagePath = _this.getImagePath.bind(_this);
	        _this.getPrevOption = _this.getPrevOption.bind(_this);
	        _this.getNextOption = _this.getNextOption.bind(_this);
	        _this.setKeyboardAccessibility = _this.setKeyboardAccessibility.bind(_this);
	        _this.allowKeyAccessibility = _this.allowKeyAccessibility.bind(_this);
	        _this.onFocusOnFeedback = _this.onFocusOnFeedback.bind(_this);
	        _this.setOptionCallbacks = _this.setOptionCallbacks.bind(_this);
	        _this.setOptionFocus = _this.setOptionFocus.bind(_this);
	        _this.enableProgression = _this.enableProgression.bind(_this);
	        _this.onProgressionClicked = _this.onProgressionClicked.bind(_this);
	        _this.onPromptRevealed = _this.onPromptRevealed.bind(_this);
	        _this.onBadgeCollected = _this.onBadgeCollected.bind(_this);
	        _this.checkResponses = _this.checkResponses.bind(_this);
	        return _this;
	    }
	
	    _createClass(ConversationSingleAnswer, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            if (this.state.screenObject.prompt_type === objectConstants.PROMPT_TYPE_SHOW_NO_PROMPT || !this.state.screenObject.show_prompt) {
	                this.randomiseOptions();
	            }
	            this.setOptionCallbacks();
	            if (localStorage.tracking_type === appConstants.TRACKING_TYPE_XAPI || localStorage.tracking_type === appConstants.TRACKING_TYPE_BLENDED_XAPI_SCORM_1_2) {
	                this.checkResponses();
	            } else {
	                this.getObjectStatus();
	            }
	            if (appHelper.isDefined(this.props.callbacks.updateCharacterExpression) && appHelper.isDefined(this.state.screenObject.character_pose)) {
	                this.props.callbacks.updateCharacterExpression(this.state.screenObject.character_pose);
	            }
	        }
	    }, {
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(nextProps) {
	
	            if (this.state.userData !== nextProps.userData) {
	                this.setState({
	                    userData: Object.assign({}, nextProps.userData),
	                    checkObjectStatus: true
	                });
	            }
	            if (this.state.lang !== nextProps.lang) {
	                var progression_label = "";
	                if (this.state.progression_label === this.state.try_again_label) {
	                    progression_label = appHelper.getLocaleString("try_again_label");
	                } else if (this.state.progression_label === this.state.continue_label) {
	                    progression_label = appHelper.getLocaleString("continue_label");
	                }
	                this.setState({
	                    lang: nextProps.lang,
	                    locale: appHelper.getLocalData(this.state.screenObject),
	                    progression_label: progression_label,
	                    multiple_choice_single_answer_question_label: appHelper.getLocaleString("multiple_choice_single_answer_question_label"),
	                    continue_label: appHelper.getLocaleString("continue_label"),
	                    try_again_label: appHelper.getLocaleString("try_again_label")
	                });
	            }
	        }
	    }, {
	        key: 'componentDidUpdate',
	        value: function componentDidUpdate() {
	            if (this.state.propsUpdated && this.state.responseData.displayState === objectConstants.OBJECT_DISPLAY_STATE_REVIEW) {
	                this.setReviewMode();
	            }
	
	            if (this.state.checkObjectStatus) {
	                this.getObjectStatus();
	            }
	
	            if (this.state.noFeedback.feedbackRequested && !this.state.noFeedback.responseHandled) {
	                this.handleNoFeedback();
	            }
	
	            if (this.state.handleCompletion) {
	                this.handleProgression();
	            }
	            if (this.state.checkPostXAPIResponse) {
	                this.postXAPIResponse();
	            }
	            if (this.state.focusOnFeedback) {
	                this.onFocusOnFeedback();
	            }
	
	            if (this.state.updateFocus) {
	                this.setOptionFocus();
	            }
	        }
	    }, {
	        key: 'postXAPIResponse',
	        value: function postXAPIResponse() {
	            this.setState({ checkPostXAPIResponse: false });
	            var interactionData = xAPIHelper.setSingleAnwserChoiceInteractionData(this.state.screenObject, this.state.responseData);
	            if (localStorage.tracking_type === appConstants.TRACKING_TYPE_XAPI || localStorage.tracking_type === appConstants.TRACKING_TYPE_BLENDED_XAPI_SCORM_1_2) {
	                var screen = appHelper.getScreenByAssetId(this.state.screenObject.asset_id);
	                var category = {
	                    constant: componentConstants.CONVERSATION_CHOICE,
	                    label: componentConstants.CONVERSATION_SINGLE_ANSWER_LABEL
	                };
	                this.props.actions.postActvityStatement(screen, interactionData, category);
	            }
	        }
	    }, {
	        key: 'getAssets',
	        value: function getAssets() {
	            var characterAsset = appHelper.getCharacterAsset(this.state.screenObject.assets);
	
	            if (characterAsset.src.length > 0) {
	                this.props.callbacks.updateCharacterExpression(characterAsset);
	            }
	        }
	    }, {
	        key: 'checkResponses',
	        value: function checkResponses() {
	            var _this2 = this;
	
	            if (localStorage.tracking_type === appConstants.TRACKING_TYPE_XAPI || localStorage.tracking_type === appConstants.TRACKING_TYPE_BLENDED_XAPI_SCORM_1_2) {
	                var parentScreen = this.props.callbacks.getSubScreenParent();
	                var params = {
	
	                    bite_id: this.props.callbacks.getBiteId(),
	                    screen_id: this.props.callbacks.getScreenId(),
	                    parent_screen_id: appHelper.isDefined(parentScreen) ? parentScreen.screen_id : undefined,
	                    asset_id: this.state.screenObject.asset_id
	                };
	
	                var interactionData = xAPIHelper.getMultipleChoiceIds(params);
	
	                this.props.actions.getActvityStatement(interactionData).then(function (responseObj) {
	                    if (appHelper.isDefined(responseObj.statement.result.completion)) {
	                        _this2.setState({
	                            xApiResponseObj: Object.assign({}, responseObj),
	                            reviewMode: true,
	                            propsUpdated: true,
	                            responseData: Object.assign({}, _this2.state.responseData, {
	                                currentStatus: objectConstants.STATUS_COMPLETE,
	                                displayState: objectConstants.OBJECT_DISPLAY_STATE_REVIEW
	                            })
	                        });
	                    }
	                });
	            }
	        }
	    }, {
	        key: 'getObjectStatus',
	        value: function getObjectStatus() {
	            this.setState({ checkObjectStatus: false });
	            if (this.state.responseData.currentStatus !== objectConstants.STATUS_COMPLETE) {
	                var screenStatus = userDataHelper.getObjectStatus(this.state.userData, this.props.screenObject.asset_id);
	                if (screenStatus === objectConstants.STATUS_COMPLETE && this.state.screenObject.attempt_type === objectConstants.ATTEMPT_TYPE_FIRST) {
	                    this.setState({
	                        reviewMode: true,
	                        propsUpdated: true,
	                        responseData: Object.assign({}, this.state.responseData, {
	                            currentStatus: objectConstants.STATUS_COMPLETE,
	                            displayState: objectConstants.OBJECT_DISPLAY_STATE_REVIEW
	                        })
	                    });
	                } else {
	                    var objectUserData = {};
	                    if (this.state.status !== objectConstants.STATUS_COMPLETE) {
	                        var subScreenParent = this.props.callbacks.getSubScreenParent();
	                        var screen_id = this.props.callbacks.getScreenId();
	                        if (appHelper.isDefined(subScreenParent)) {
	                            objectUserData = userDataHelper.getSubScreenObjectStatus(this.state.userData, subScreenParent.screen_id, screen_id, this.state.screenObject.asset_id);
	                        } else {
	                            objectUserData = userDataHelper.getObjectStatus(this.state.userData, screen_id, this.state.screenObject.asset_id);
	                        }
	                    }
	
	                    if (objectUserData.status === objectConstants.STATUS_COMPLETE && this.state.screenObject.attempt_type === objectConstants.ATTEMPT_TYPE_FIRST) {
	                        this.setState({
	                            reviewMode: true,
	                            propsUpdated: true,
	                            responseData: Object.assign({}, this.state.responseData, {
	                                currentStatus: objectConstants.STATUS_COMPLETE,
	                                displayState: objectConstants.OBJECT_DISPLAY_STATE_REVIEW
	                            })
	                        });
	                    }
	                }
	            }
	        }
	    }, {
	        key: 'setReviewMode',
	        value: function setReviewMode() {
	            var optionIds = appHelper.getObjectOptionIds(this.state.screenObject);
	            var kpiUserData = userDataHelper.getUserResponseByOptionIds(this.state.userData, this.props.callbacks.getBiteId(), optionIds);
	            if (appHelper.isDefined(kpiUserData)) {
	                var optionDetails = appHelper.getOptionParentDetails(kpiUserData.option_id[0]);
	                var showResponse = false;
	
	                if (appHelper.isDefined(optionDetails)) {
	                    var responses = [];
	                    var response = {
	                        selectedOption: optionDetails.option
	                    };
	
	                    if (appHelper.isDefined(optionDetails.option.dialogs) && optionDetails.option.dialogs.length > 0) {
	                        showResponse = true;
	                    }
	
	                    var hasBadges = appHelper.isDefined(optionDetails.option.badges) && optionDetails.option.badges.length > 0;
	
	                    //this.state.showResponse
	                    this.setState({
	                        showProgression: !this.props.callbacks.hasNextObject(this.props.index) && optionDetails.option.enable_feedback,
	                        hasBadges: hasBadges,
	                        badgesCollected: hasBadges,
	                        handleCompletion: true,
	                        showPrompt: !this.state.screenObject.hide_prompt_after_completion,
	                        propsUpdated: false,
	                        showOptions: true,
	                        showResponse: showResponse,
	                        options: dataHelper.immutableSplice(this.state.options, 0, this.state.options.length, optionDetails.option),
	                        progression_label: optionDetails.option.progression === objectConstants.OBJECT_PROGRESSION_TRY_AGAIN ? this.state.try_again_label : this.state.continue_label,
	                        responseData: Object.assign({}, this.state.responseData, {
	                            responses: dataHelper.immutablePush(responses, response),
	                            latestResponse: optionDetails.option
	                        }),
	                        optionCanUpdate: false
	                    });
	
	                    this.props.callbacks.updateCharacterExpression(optionDetails.option.character_pose);
	                }
	            } else if (localStorage.tracking_type === appConstants.TRACKING_TYPE_XAPI || localStorage.tracking_type === appConstants.TRACKING_TYPE_BLENDED_XAPI_SCORM_1_2) {
	                var responseObj = Object.assign({}, this.state.xApiResponseObj);
	                if (appHelper.isDefined(responseObj.statement)) {
	                    var responseString = responseObj.statement.result.response;
	                    var choices = responseObj.statement.object.definition.choices;
	                    var optionResponse = xAPIHelper.getChoiceByDescription(choices, responseString);
	                    //let optionDetails = appHelper.getOptionByLabelName(responseString, this.state.screenObject.options);
	                    var _optionDetails = appHelper.getOptionParentDetails(parseInt(optionResponse.id));
	                    if (appHelper.isDefined(_optionDetails)) {
	                        var _showResponse = false;
	                        var _responses = [];
	                        var _response = {
	                            selectedOption: _optionDetails.option
	                        };
	
	                        if (appHelper.isDefined(_optionDetails.option.dialogs) && _optionDetails.option.dialogs.length > 0) {
	                            _showResponse = true;
	                        }
	
	                        var _hasBadges = appHelper.isDefined(_optionDetails.option.badges) && _optionDetails.option.badges.length > 0;
	                        this.setState({
	                            showProgression: !this.props.callbacks.hasNextObject(this.props.index) && _optionDetails.option.enable_feedback,
	                            hasBadges: _hasBadges,
	                            badgesCollected: _hasBadges,
	                            handleCompletion: true,
	                            showPrompt: !this.state.screenObject.hide_prompt_after_completion,
	                            propsUpdated: false,
	                            showOptions: true,
	                            showResponse: _showResponse,
	                            options: dataHelper.immutableSplice(this.state.options, 0, this.state.options.length, _optionDetails.option),
	                            progression_label: _optionDetails.option.progression === objectConstants.OBJECT_PROGRESSION_TRY_AGAIN ? this.state.try_again_label : this.state.continue_label,
	                            responseData: Object.assign({}, this.state.responseData, {
	                                responses: dataHelper.immutablePush(_responses, _response),
	                                latestResponse: _optionDetails.option
	                            }),
	                            optionCanUpdate: false
	                        });
	                    } else {
	                        this.setState({
	                            reviewMode: false,
	                            propsUpdated: true,
	                            responseData: Object.assign({}, this.state.responseData, {
	                                currentStatus: objectConstants.STATUS_NOT_STARTED,
	                                displayState: objectConstants.OBJECT_DISPLAY_STATE_INITIAL
	                            })
	                        });
	                    }
	                } else {
	                    this.setState({ renderQuestions: true });
	                }
	            } else {
	                this.setState({
	                    reviewMode: false,
	                    propsUpdated: true,
	                    responseData: Object.assign({}, this.state.responseData, {
	                        currentStatus: objectConstants.STATUS_NOT_STARTED,
	                        displayState: objectConstants.OBJECT_DISPLAY_STATE_INITIAL
	                    })
	                });
	            }
	        }
	    }, {
	        key: 'getLocale',
	        value: function getLocale() {
	            var locale = appHelper.getLocalData(this.state.screenObject.locale);
	            this.setState({ locale: Object.assign({}, locale) });
	            if (this.state.screenObject.show_title_in_header) {
	                this.props.actions.setScreenTitle(locale.title);
	            }
	        }
	    }, {
	        key: 'scrollOptionsToTop',
	        value: function scrollOptionsToTop() {
	            var questionOptions = this.refs[this.state.screenObject.asset_id + '_questionOptions'];
	            this.props.callbacks.scrollOptionsToTop(questionOptions.offsetTop);
	        }
	    }, {
	        key: 'randomiseOptions',
	        value: function randomiseOptions() {
	            if (this.state.screenObject.randomise_options) {
	                var options = dataHelper.randomiseArray(this.state.options);
	                this.setState({
	                    options: options,
	                    showOptions: true,
	                    focusedOption: options[0]
	                });
	            } else {
	                this.setState({ showOptions: true });
	            }
	            this.props.callbacks.scrollToTop();
	        }
	    }, {
	        key: 'onPromptRevealed',
	        value: function onPromptRevealed() {
	            this.randomiseOptions();
	        }
	    }, {
	        key: 'renderOptions',
	        value: function renderOptions() {
	            if (!this.state.showOptions && this.state.responseData.currentStatus === objectConstants.STATUS_NOT_STARTED) {
	                this.setState({ showOptions: true });
	            }
	            this.props.callbacks.scrollToTop();
	        }
	    }, {
	        key: 'onOptionClick',
	        value: function onOptionClick(event) {
	            document.activeElement.blur();
	            this.setOptionCanUpdate(true);
	            var response = {
	                selectedOption: appHelper.getObjectOption(this.state.screenObject.options, event.target.value)
	            };
	            this.setState({
	                responseData: Object.assign({}, this.state.responseData, {
	                    responses: dataHelper.immutablePush(this.state.responseData.responses, response),
	                    latestResponse: Object.assign({}, response.selectedOption)
	                }),
	                progression_label: response.selectedOption.progression === objectConstants.OBJECT_PROGRESSION_TRY_AGAIN ? this.state.try_again_label : this.state.continue_label,
	                checkPostXAPIResponse: true,
	                questionIsChecked: true
	            });
	        }
	    }, {
	        key: 'handleAttemptComplete',
	        value: function handleAttemptComplete() {
	
	            if (appHelper.isDefined(this.state.responseData.latestResponse.dialogs) && this.state.responseData.latestResponse.dialogs.length > 0) {
	                this.setState({ showResponse: true, focusOnFeedback: true });
	            } else {
	                this.showFeedback();
	            }
	        }
	    }, {
	        key: 'handleResponseComplete',
	        value: function handleResponseComplete() {
	            this.showFeedback();
	        }
	    }, {
	        key: 'showFeedback',
	        value: function showFeedback() {
	            var latestResponseFeedbackLocale = appHelper.getLocalData(this.state.responseData.latestResponse);
	            var optionHasFeedback = appHelper.isDefined(latestResponseFeedbackLocale.feedback);
	            if (optionHasFeedback && latestResponseFeedbackLocale.feedback.length === 0 || latestResponseFeedbackLocale.feedback === "<p><br></p>") {
	                optionHasFeedback = false;
	            }
	            if (appHelper.isDefined(this.state.responseData.latestResponse.feedback_id)) {
	                optionHasFeedback = true;
	            }
	
	            if (appHelper.isDefined(this.state.responseData.latestResponse.resources) && this.state.responseData.latestResponse.resources.length > 0) {
	                optionHasFeedback = true;
	            }
	
	            if (this.state.responseData.latestResponse.progression === objectConstants.OBJECT_PROGRESSION_TRY_AGAIN) {
	                optionHasFeedback = true;
	            }
	
	            var bite = appHelper.getBite(this.props.callbacks.getBiteId());
	            var score_kpi = kpiHelper.getScoreKpi(bite);
	
	            if (this.state.screenObject.scoring_type === objectConstants.ASSESSED_TYPE_SCORED && score_kpi.is_visible) {
	                optionHasFeedback = true;
	            }
	
	            if (appHelper.isDefined(this.state.responseData.latestResponse.badges) && this.state.responseData.latestResponse.badges.length > 0) {
	                optionHasFeedback = true;
	            }
	
	            var enable_feedback = this.state.responseData.latestResponse.enable_feedback;
	
	            if (this.state.responseData.currentStatus !== objectConstants.STATUS_COMPLETE && enable_feedback) {
	
	                this.setState({
	                    showFeedback: true,
	                    focusOnFeedback: true
	
	                });
	            } else if (!enable_feedback && !this.state.noFeedback.feedbackRequested || !optionHasFeedback && !this.state.noFeedback.feedbackRequested) {
	                var latestResponse = this.state.responseData.latestResponse;
	
	                var selectedOptions = [latestResponse.option_id];
	
	                var responseObj = {
	                    asset_id: this.state.screenObject.asset_id,
	                    selectedOptions: selectedOptions,
	                    kpis: latestResponse.kpis !== null ? latestResponse.kpis : []
	                };
	
	                this.props.callbacks.storeUserResponse(responseObj);
	                if (this.state.responseData.latestResponse.progression === objectConstants.OBJECT_PROGRESSION_TRY_AGAIN) {
	                    this.setState({
	                        showProgression: true,
	                        progression_label: this.state.try_again_label
	                    });
	                } else {
	                    this.setState({
	                        noFeedback: Object.assign({}, this.state.noFeedback, {
	                            feedbackRequested: true
	                        })
	                    });
	                }
	            }
	        }
	    }, {
	        key: 'handleNoFeedback',
	        value: function handleNoFeedback() {
	            var enable_feedback = this.state.responseData.latestResponse.enable_feedback;
	
	            if (appHelper.isDefined(this.state.responseData.latestResponse.audio)) {
	                var audio = appHelper.getAudioAsset(this.state.responseData.latestResponse.audio);
	                var audioObj = {
	                    audioRef: 'audio_' + audio.id + '_' + audio.type
	                };
	
	                this.props.actions.setAudio(audioObj);
	            }
	
	            var hasBadges = appHelper.isDefined(this.state.responseData.latestResponse.badges) && this.state.responseData.latestResponse.badges.length > 0 && !enable_feedback;
	
	            this.setState({
	
	                noFeedback: Object.assign({}, this.state.noFeedback, {
	                    responseHandled: true
	                }),
	                hasBadges: hasBadges
	            });
	
	            if (!this.props.callbacks.hasNextObject(this.props.index)) {
	                setTimeout(function () {
	                    this.enableProgression(appHelper.getLocalData(this.state.responseData.latestResponse).progression_label);
	                }.bind(this), 500);
	            }
	
	            if (appHelper.isDefined(this.props.callbacks.updateCharacterExpression) && appHelper.isDefined(this.state.responseData.latestResponse.character_pose)) {
	                this.props.callbacks.updateCharacterExpression(this.state.responseData.latestResponse.character_pose);
	            }
	            //this.handleResponse();
	            if (!hasBadges) {
	                var handleResponse = this.handleResponse;
	                setTimeout(function () {
	                    handleResponse();
	                }, 1000);
	            }
	        }
	    }, {
	        key: 'showResponse',
	        value: function showResponse() {
	
	            var optionLocale = appHelper.getLocalData(this.state.responseData.latestResponse);
	            var showResponse = true;
	            if (!appHelper.isDefined(optionLocale.character_response)) {
	                showResponse = false;
	            } else if (appHelper.isDefined(optionLocale.character_response) && optionLocale.character_response.length === 0) {
	                showResponse = false;
	            } else if (this.state.responseData.latestResponse.progression === objectConstants.OBJECT_PROGRESSION_TERMINAL) {
	                showResponse = false;
	            }
	        }
	    }, {
	        key: 'handleResponse',
	        value: function handleResponse() {
	            this.setState({ hideFeedback: false });
	            var progressionRule = this.state.responseData.latestResponse.progression;
	            if (progressionRule === objectConstants.OBJECT_PROGRESSION_TRY_AGAIN) {
	                this.reattempt();
	            } else {
	                var optionLocale = appHelper.getLocalData(this.state.responseData.latestResponse);
	                var enable_feedback = this.state.responseData.latestResponse.enable_feedback;
	
	                /*if(!this.props.callbacks.hasNextObject(this.props.index)){
	                    this.setState({
	                        showProgression: true,
	                        progression_label: appHelper.getLocalData(this.state.responseData.latestResponse).progression_label
	                    });
	                    this.props.callbacks.scrollToContinue();
	                }*/
	
	                this.setState({
	                    showFeedback: !this.props.callbacks.hasNextObject(this.props.index) && enable_feedback,
	                    focusOnFeedback: !this.props.callbacks.hasNextObject(this.props.index) && enable_feedback,
	                    showPrompt: !this.state.screenObject.hide_prompt_after_completion,
	                    options: dataHelper.immutableSplice(this.state.options, 0, this.state.options.length, this.state.responseData.latestResponse),
	                    responseData: Object.assign({}, this.state.responseData, {
	                        currentStatus: objectConstants.STATUS_COMPLETE,
	                        displayState: objectConstants.OBJECT_DISPLAY_STATE_ANSWERED
	                    })
	                });
	                this.handleProgression();
	            }
	        }
	    }, {
	        key: 'handleProgression',
	        value: function handleProgression() {
	            this.setState({ handleCompletion: false });
	            if (!this.state.completionSent) {
	                this.setState({ completionSent: true });
	                /*l
	                let navigateToNextScreen = true;
	                this.props.callbacks.onObjectComplete(progressionRule, this.state.screenObject.asset_id, this.state.responseData.latestResponse, navigateToNextScreen);*/
	                var enable_feedback = this.state.responseData.latestResponse.enable_feedback;
	
	                var progressionRule = this.state.responseData.latestResponse.progression;
	                var progressionType = appHelper.isDefined(this.state.responseData.latestResponse.progression_type) ? this.state.responseData.latestResponse.progression_type : undefined;
	                var progressionGoToId = appHelper.isDefined(this.state.responseData.latestResponse.progression_goto_id) ? this.state.responseData.latestResponse.progression_goto_id : undefined;
	                var completionData = {
	                    progression: progressionRule,
	                    asset_id: this.state.screenObject.asset_id,
	                    status: objectConstants.STATUS_COMPLETE,
	                    asset_type_code: this.state.screenObject.asset_type_code,
	                    navigateToNextScreen: progressionType !== objectConstants.GO_TO_TYPE_SCREEN,
	                    progressionType: progressionType,
	                    progressionGoToId: progressionGoToId,
	                    index: this.props.index
	                };
	
	                this.props.callbacks.onObjectComplete(completionData);
	            }
	        }
	    }, {
	        key: 'reattempt',
	        value: function reattempt() {
	            this.setState({
	                showFeedback: false,
	                showResponse: false,
	                questionIsChecked: false,
	                focusedOption: this.state.options[0],
	                updateFocus: true,
	                responseData: Object.assign({}, this.state.responseData, {
	                    currentAttempt: this.state.responseData.currentAttempt + 1,
	                    currentStatus: objectConstants.STATUS_ATTEMPTED,
	                    displayState: objectConstants.OBJECT_DISPLAY_STATE_RETRY
	                }),
	                noFeedback: Object.assign({}, this.state.noFeedback, {
	                    responseHandled: false
	                })
	            });
	        }
	
	        //REVEW POPUP
	
	    }, {
	        key: 'onReviewObject',
	        value: function onReviewObject(sourceId) {
	            //console.log(sourceId);
	            var config = Object.assign({}, _dialogModels.LEANER_ACTION_REVIEW_CONFIG, {
	                title: this.state.locale.label,
	                sourceId: sourceId
	            });
	            //locale.title
	
	            for (var i = 0; i < config.childComponents.length; i++) {
	                var child = config.childComponents[i];
	                child.componentProps = Object.assign({}, {
	                    screenObject: this.state.screenObject,
	                    responseData: Object.assign({}, this.state.responseData, {
	                        displayState: objectConstants.OBJECT_DISPLAY_STATE_REVIEW,
	                        callbacks: this.props.callbacks
	
	                    }),
	                    callbacks: this.props.callbacks,
	                    optionCanUpdate: false
	                });
	            }
	            this.props.actions.setNewDialog(config);
	        }
	    }, {
	        key: 'setOptionCanUpdate',
	        value: function setOptionCanUpdate(canUpdate) {
	            this.setState({ optionCanUpdate: canUpdate });
	        }
	    }, {
	        key: 'getOptionCanUpdate',
	        value: function getOptionCanUpdate() {
	            return this.state.optionCanUpdate;
	        }
	    }, {
	        key: 'onFeedbackComplete',
	        value: function onFeedbackComplete() {}
	    }, {
	        key: 'getOptionListClass',
	        value: function getOptionListClass() {
	            return this.state.questionIsChecked ? "question-checked" : "";
	        }
	    }, {
	        key: 'getImagePath',
	        value: function getImagePath(image) {
	            if (appConstants.DEVELOPMENT_MODE) {
	                if (appHelper.isDefined(image) && image.length > 0) {
	                    return __webpack_require__(16)("./" + image);
	                }
	            } else {
	                return image;
	            }
	        }
	    }, {
	        key: 'getPrevOption',
	        value: function getPrevOption() {
	            var optionIndex = appHelper.getArrayObjectIndexByKey(this.state.options, "option_id", this.state.focusedOption.option_id);
	            var nextOption = this.state.options[optionIndex - 1];
	            if (optionIndex <= 0) {
	                nextOption = this.state.options[this.state.options.length - 1];
	            }
	
	            this.setState({ focusedOption: Object.assign({}, nextOption), updateFocus: true });
	        }
	    }, {
	        key: 'getNextOption',
	        value: function getNextOption() {
	            var optionIndex = appHelper.getArrayObjectIndexByKey(this.state.options, "option_id", this.state.focusedOption.option_id);
	            var nextOption = this.state.options[optionIndex + 1];
	            if (optionIndex === this.state.options.length - 1) {
	                nextOption = this.state.options[0];
	            }
	            this.setState({ focusedOption: Object.assign({}, nextOption), updateFocus: true });
	        }
	    }, {
	        key: 'allowKeyAccessibility',
	        value: function allowKeyAccessibility() {
	            var responseData = this.state.responseData;
	            //if (responseData.displayState === objectConstants.OBJECT_DISPLAY_STATE_INITIAL) {
	            if (responseData.currentAttempt === responseData.responses.length) {
	                return false;
	            } else {
	                //console.log()
	                for (var i = 0; i < this.state.responseData.responses.length; i++) {
	                    var response = this.state.responseData.responses[i];
	                    if (response.selectedOption.option_id === this.state.focusedOption.option_id) {
	                        return false;
	                    }
	                }
	                return true;
	            }
	        }
	    }, {
	        key: 'setKeyboardAccessibility',
	        value: function setKeyboardAccessibility(event) {
	            if (event.which === keyboardConstants.ENTER_KEY || event.which === keyboardConstants.SPACEBAR_KEY) {
	                event.preventDefault();
	                if (this.allowKeyAccessibility()) {
	                    this.onOptionClick({ target: { value: this.state.focusedOption.option_id } });
	                } else {
	                    var responseData = this.state.responseData;
	                    if (responseData.displayState === objectConstants.OBJECT_DISPLAY_STATE_ANSWERED || responseData.displayState === objectConstants.OBJECT_DISPLAY_STATE_REVIEW && this.props.contentData.experience.include_explore_feedback) {
	                        this.onReviewObject('option_' + this.state.focusedOption.option_id);
	                    }
	                }
	            }
	
	            if (event.which === keyboardConstants.ARROW_LEFT_KEY) {
	                event.preventDefault();
	                this.getPrevOption();
	            }
	
	            if (event.which === keyboardConstants.ARROW_RIGHT_KEY) {
	                event.preventDefault();
	                this.getNextOption();
	            }
	
	            if (event.which === keyboardConstants.ARROW_UP_KEY) {
	                event.preventDefault();
	                this.getPrevOption();
	            }
	
	            if (event.which === keyboardConstants.ARROW_DOWN_KEY) {
	                event.preventDefault();
	                this.getNextOption();
	            }
	        }
	    }, {
	        key: 'onFocusOnFeedback',
	        value: function onFocusOnFeedback() {
	            var focusEl = document.getElementById('feedback_wrapper_' + this.state.screenObject.asset_id);
	            if (appHelper.isDefined(focusEl) && focusEl !== null) {
	                focusEl.focus();
	            }
	            this.setState({ focusOnFeedback: false });
	        }
	    }, {
	        key: 'setOptionCallbacks',
	        value: function setOptionCallbacks() {
	            this.setState({
	                optionCallbacks: Object.assign({}, this.state.optionCallbacks, {
	                    setKeyboardAccessibility: this.setKeyboardAccessibility
	                })
	            });
	        }
	    }, {
	        key: 'setOptionFocus',
	        value: function setOptionFocus() {
	            var focusEl = document.getElementById('option_' + this.state.focusedOption.option_id);
	            focusEl.focus();
	            this.setState({ updateFocus: false });
	        }
	    }, {
	        key: 'enableProgression',
	        value: function enableProgression(progression_label) {
	            var hasBadges = appHelper.isDefined(this.state.responseData.latestResponse.badges) && this.state.responseData.latestResponse.badges.length > 0;
	            var progressionType = appHelper.isDefined(this.state.responseData.latestResponse.progression_type) ? this.state.responseData.latestResponse.progression_type : undefined;
	
	            var showProgression = !hasBadges;
	            if (!this.props.callbacks.hasNextObject(this.props.index)) {
	                showProgression = !hasBadges && progressionType !== objectConstants.GO_TO_TYPE_SCREEN;
	            }
	            this.setState({
	                showProgression: showProgression,
	                hasBadges: hasBadges,
	                progression_label: this.state.responseData.latestResponse.progression === objectConstants.OBJECT_PROGRESSION_TRY_AGAIN ? this.state.try_again_label : this.state.continue_label
	            });
	            this.props.callbacks.scrollToContinue();
	        }
	    }, {
	        key: 'onProgressionClicked',
	        value: function onProgressionClicked() {
	            this.setState({
	                showProgression: false,
	                hideFeedback: this.props.callbacks.hasNextObject(this.props.index) && this.state.responseData.latestResponse.progression !== objectConstants.OBJECT_PROGRESSION_TRY_AGAIN
	            });
	            var enable_feedback = this.state.responseData.latestResponse.enable_feedback;
	
	            if (!this.props.callbacks.hasNextObject(this.props.index) && this.state.responseData.latestResponse.progression !== objectConstants.OBJECT_PROGRESSION_TRY_AGAIN) {
	                this.props.callbacks.navigateToNextScreen();
	            } else if (this.state.responseData.latestResponse.progression === objectConstants.OBJECT_PROGRESSION_TRY_AGAIN) {
	                this.reattempt();
	            }
	        }
	    }, {
	        key: 'onBadgeCollected',
	        value: function onBadgeCollected() {
	            this.setState({ badgesCollected: true });
	
	            if (!this.props.callbacks.hasNextObject(this.props.index)) {
	                this.setState({
	                    showProgression: true,
	                    progression_label: this.state.responseData.latestResponse.progression === objectConstants.OBJECT_PROGRESSION_TRY_AGAIN ? this.state.try_again_label : this.state.continue_label
	                });
	                this.props.callbacks.scrollToContinue();
	            }
	            this.handleResponse();
	
	            //this.hide();
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this3 = this;
	
	            return _react2.default.createElement(
	                'div',
	                { className: 'learner-action' },
	                _react2.default.createElement(
	                    'p',
	                    { className: 'hidden-el' },
	                    this.state.multiple_choice_single_answer_question_label
	                ),
	                appHelper.isDefined(this.props.characterPose) && appHelper.isDefined(this.props.characterPose.src) && this.props.characterPose.src.length > 0 ? _react2.default.createElement(
	                    'div',
	                    { className: 'content-character-expression' },
	                    _react2.default.createElement('img', { src: this.getImagePath(this.props.characterPose.src), alt: '' })
	                ) : null,
	                _react2.default.createElement(
	                    'div',
	                    { className: 'question-wrapper conversation' },
	                    this.state.screenObject.prompt_type !== objectConstants.PROMPT_TYPE_SHOW_NO_PROMPT && this.state.screenObject.show_prompt ? this.state.screenObject.prompt_type === objectConstants.PROMPT_TYPE_DIALOG_PROMPT ? _react2.default.createElement(_DialogPrompt2.default, { character_name: this.state.character_name,
	                        id: this.state.screenObject.asset_id, locale: this.state.locale,
	                        show_title: this.state.screenObject.show_title,
	                        onComplete: this.onPromptRevealed }) : _react2.default.createElement(_Prompt2.default, { id: this.state.screenObject.asset_id, locale: this.state.locale,
	                        show_title: this.state.screenObject.show_title,
	                        onComplete: this.onPromptRevealed }) : null,
	                    this.state.showOptions ? _react2.default.createElement(
	                        'div',
	                        null,
	                        this.props.trackingData.first_name.length > 0 && !this.props.trackingData.first_name.includes('Guest') ? _react2.default.createElement(_Label2.default, { screenObject: this.state.screenObject,
	                            id: this.state.screenObject.asset_id + '_user_name',
	                            container_class_name: 'object-container-no-margin',
	                            class_name: 'user_name_label',
	                            htmlFor: '',
	                            text: this.props.trackingData.first_name }) : _react2.default.createElement(_Label2.default, { screenObject: this.state.screenObject,
	                            id: this.state.screenObject.asset_id + '_user_name',
	                            container_class_name: 'object-container-no-margin',
	                            class_name: 'user_name_label',
	                            htmlFor: '',
	                            text: 'You' })
	                    ) : null,
	                    this.state.showOptions ? _react2.default.createElement(
	                        'div',
	                        { className: 'learner-action-option-list user theme-active ' + this.getOptionListClass(),
	                            role: 'radiogroup', ref: this.state.screenObject.asset_id + '_questionOptions' },
	                        this.state.options.map(function (option) {
	                            return _react2.default.createElement(_ConversationSingleAnswerOption2.default, { key: option.option_id, option: option,
	                                asset_id: _this3.state.screenObject.asset_id,
	                                questionChecked: _this3.state.questionChecked,
	                                onOptionClick: _this3.onOptionClick,
	                                responseData: _this3.state.responseData,
	                                onAttemptComplete: _this3.handleAttemptComplete,
	                                onOptionRevealed: _this3.scrollOptionsToTop,
	                                onReviewObject: _this3.onReviewObject,
	                                index: appHelper.getObjectOptionIndex(_this3.state.screenObject.options, option.option_id),
	                                showFeedback: appHelper.isDefined(_this3.state.responseData.latestResponse.enable_feedback) && _this3.state.responseData.latestResponse.enable_feedback,
	                                setOptionCanUpdate: _this3.setOptionCanUpdate,
	                                getOptionCanUpdate: _this3.getOptionCanUpdate,
	                                optionCanUpdate: _this3.state.optionCanUpdate,
	                                focusedOption: _this3.state.focusedOption,
	                                optionCallbacks: _this3.state.optionCallbacks
	                            });
	                        })
	                    ) : null,
	                    this.state.showResponse || this.state.showFeedback ? _react2.default.createElement(
	                        'div',
	                        { ref: 'feedback_wrapper_' + this.state.screenObject.asset_id,
	                            id: 'feedback_wrapper_' + this.state.screenObject.asset_id,
	                            role: 'article',
	                            tabIndex: 0,
	                            className: 'feedback-focus' },
	                        this.state.showResponse ? _react2.default.createElement(_ChildConversationDialog2.default, { asset_id: this.state.screenObject.asset_id,
	                            option_id: this.state.responseData.latestResponse.option_id,
	                            dialogs: this.state.responseData.latestResponse.dialogs,
	                            callbacks: this.props.callbacks,
	                            onComplete: this.handleResponseComplete }) : null,
	                        this.state.showFeedback ? _react2.default.createElement(_SingleAnswerFeedback2.default, { screenObject: this.state.screenObject,
	                            option: this.state.responseData.latestResponse,
	                            options: this.state.screenObject.options,
	                            asset_id: this.state.screenObject.asset_id,
	                            responseData: this.state.responseData,
	                            onComplete: this.handleResponse,
	                            onShowReview: this.onReviewObject,
	                            showFeedback: appHelper.isDefined(this.state.responseData.latestResponse.enable_feedback) && !this.state.responseData.latestResponse.enable_feedback,
	                            onEnableProgression: this.enableProgression,
	                            hideFeedback: this.state.hideFeedback,
	                            index: this.props.index,
	                            callbacks: this.props.callbacks }) : null
	                    ) : null,
	                    (this.state.showResponse || this.state.showFeedback) && this.state.hasBadges ? _react2.default.createElement('br', null) : null,
	                    this.state.hasBadges ? _react2.default.createElement(
	                        'div',
	                        { className: 'badge-wrapper' },
	                        this.state.responseData.latestResponse.badges.map(function (badge) {
	                            return _react2.default.createElement(_BadgeCollect2.default, { key: badge.badge_id, badge_id: badge.badge_id,
	                                bite_id: _this3.props.callbacks.getBiteId(),
	                                asset_id: _this3.state.screenObject.asset_id,
	                                onCollected: _this3.onBadgeCollected,
	                                animate: _this3.state.animateBadge });
	                        })
	                    ) : null
	                ),
	                this.state.showProgression ? _react2.default.createElement(_Button2.default, { label: this.state.progression_label, id: this.state.screenObject.asset_id + '_button', ref: this.state.screenObject.asset_id + '_button',
	                    onClick: this.onProgressionClicked }) : null
	            );
	        }
	    }]);
	
	    return ConversationSingleAnswer;
	}(_react2.default.Component);
	
	ConversationSingleAnswer.propTypes = {
	    screenObject: _propTypes2.default.object.isRequired,
	    callbacks: _propTypes2.default.object.isRequired,
	    characterPose: _propTypes2.default.object,
	    contentData: _propTypes2.default.object.isRequired,
	    index: _propTypes2.default.number,
	    trackingData: _propTypes2.default.object.isRequired,
	    userData: _propTypes2.default.object.isRequired,
	    lang: _propTypes2.default.string.isRequired,
	    actions: _propTypes2.default.object.isRequired
	};
	
	ConversationSingleAnswer.contextTypes = {
	    router: _propTypes2.default.object
	};
	
	function mapStateToProps(state) {
	    var lang = state.userData.lang;
	    return {
	        lang: lang,
	        contentData: state.contentData,
	        trackingData: state.trackingData,
	        userData: state.userData
	
	    };
	}
	
	function mapDispatchToProps(dispatch) {
	    return {
	        actions: (0, _redux.bindActionCreators)(Object.assign({}, appDataActions, trackingDataActions, dialogPopupActions), dispatch)
	    };
	}
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(ConversationSingleAnswer);

/***/ },
/* 493 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(5);
	
	var _redux = __webpack_require__(4);
	
	var _KpiDashboard = __webpack_require__(93);
	
	var _KpiDashboard2 = _interopRequireDefault(_KpiDashboard);
	
	var _ResourceLinks = __webpack_require__(48);
	
	var _ResourceLinks2 = _interopRequireDefault(_ResourceLinks);
	
	var _ChildConversationDialog = __webpack_require__(65);
	
	var _ChildConversationDialog2 = _interopRequireDefault(_ChildConversationDialog);
	
	var _trackingDataActions = __webpack_require__(7);
	
	var trackingDataActions = _interopRequireWildcard(_trackingDataActions);
	
	var _userDataActions = __webpack_require__(20);
	
	var userDataActions = _interopRequireWildcard(_userDataActions);
	
	var _appHelper = __webpack_require__(3);
	
	var appHelper = _interopRequireWildcard(_appHelper);
	
	var _appConstants = __webpack_require__(13);
	
	var appConstants = _interopRequireWildcard(_appConstants);
	
	var _objectConstants = __webpack_require__(9);
	
	var objectConstants = _interopRequireWildcard(_objectConstants);
	
	var _kpiConstants = __webpack_require__(37);
	
	var kpiConstants = _interopRequireWildcard(_kpiConstants);
	
	var _gsap = __webpack_require__(8);
	
	var _gsapReactPlugin = __webpack_require__(10);
	
	var _gsapReactPlugin2 = _interopRequireDefault(_gsapReactPlugin);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } //eslint-disable-line import/no-named-as-default
	
	
	var ConversationSingleAnswerFeedbackReview = function (_React$Component) {
	    _inherits(ConversationSingleAnswerFeedbackReview, _React$Component);
	
	    function ConversationSingleAnswerFeedbackReview(props, context) {
	        _classCallCheck(this, ConversationSingleAnswerFeedbackReview);
	
	        var _this = _possibleConstructorReturn(this, (ConversationSingleAnswerFeedbackReview.__proto__ || Object.getPrototypeOf(ConversationSingleAnswerFeedbackReview)).call(this, props, context));
	
	        _this.state = {
	            lang: _this.props.lang,
	            option: _this.props.option,
	            locale: appHelper.getLocalData(_this.props.option),
	            assets: {
	                character: {
	                    src: "",
	                    type: "",
	                    type_id: ""
	                }
	            },
	            showResponse: false,
	            showFeedbackContent: false,
	            showKpis: appHelper.isDefined(_this.props.option.kpis) && _this.props.option.kpis !== null,
	            kpiDashboardParams: {
	                responseReview: true,
	                showTitle: false,
	                showImmediateImpact: true,
	                allowUpdates: false
	            },
	            hasDialogs: appHelper.isDefined(_this.props.option.dialogs) && _this.props.option.dialogs.length > 0,
	            dialogComplete: !appHelper.isDefined(_this.props.option.dialogs) || _this.props.option.dialogs.length === 0,
	            callbacks: {},
	            resourceLinks: [],
	            hasResources: false,
	            resourcesAreComplete: true
	        };
	        _this.getAssets = _this.getAssets.bind(_this);
	        _this.getImagePath = _this.getImagePath.bind(_this);
	        _this.show = _this.show.bind(_this);
	        _this.onFeedbackRevealed = _this.onFeedbackRevealed.bind(_this);
	        _this.showFeedbackContent = _this.showFeedbackContent.bind(_this);
	        _this.showKpiDashboard = _this.showKpiDashboard.bind(_this);
	        _this.dialogsOnComplete = _this.dialogsOnComplete.bind(_this);
	        _this.setCallbacks = _this.setCallbacks.bind(_this);
	        _this.onResourcesComplete = _this.onResourcesComplete.bind(_this);
	        _this.setResources = _this.setResources.bind(_this);
	        _this.getInheritedFeedback = _this.getInheritedFeedback.bind(_this);
	        return _this;
	    }
	
	    _createClass(ConversationSingleAnswerFeedbackReview, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	
	            this.setCallbacks();
	            this.setResources();
	            this.getAssets();
	        }
	    }, {
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(nextProps) {
	            if (this.state.lang !== nextProps.lang) {
	                this.setState({
	                    lang: nextProps.lang,
	                    locale: appHelper.getLocalData(this.state.option)
	                });
	            }
	            if (this.state.locale !== nextProps.locale) {
	                this.setState({ locale: Object.assign({}, nextProps.locale) });
	            }
	        }
	    }, {
	        key: 'getAssets',
	        value: function getAssets() {
	            /*let characterAsset = appHelper.getCharacterAsset(this.state.option.assets);
	            let imageAsset = appHelper.getImageAsset(this.state.option.assets);
	            if (appHelper.isDefined(characterAsset)) {
	                this.setState({
	                    assets: Object.assign({}, this.state.assets, {
	                        character: Object.assign({}, characterAsset),
	                        image: appHelper.isDefined(imageAsset) ? Object.assign({}, imageAsset) : Object.assign({}, this.state.assets.image)
	                    })
	                });
	            }else if(appHelper.isDefined(imageAsset)){
	                this.setState({
	                    assets: Object.assign({}, this.state.assets, {
	                        image: Object.assign({}, imageAsset),
	                    })
	                });
	            }*/
	        }
	    }, {
	        key: 'getImagePath',
	        value: function getImagePath(image) {
	            if (appConstants.DEVELOPMENT_MODE) {
	                if (appHelper.isDefined(image) && image.length > 0) {
	                    return __webpack_require__(16)("./" + image);
	                }
	            } else {
	                return image;
	            }
	        }
	    }, {
	        key: 'show',
	        value: function show() {
	
	            var feedbackPanel = this.refs[this.state.option.option_id + '_feedbackPanel'];
	            if (appHelper.isDefined(feedbackPanel)) {
	                _gsap.TweenLite.set(feedbackPanel, { height: "auto", opacity: 1 });
	                _gsap.TweenLite.from(feedbackPanel, objectConstants.FEEDBACK_DURATION, {
	                    height: 0,
	                    opacity: 0,
	                    ease: _gsap.Linear.easeIn
	                }).eventCallback("onComplete", this.onFeedbackRevealed);
	            }
	        }
	    }, {
	        key: 'onFeedbackRevealed',
	        value: function onFeedbackRevealed() {
	            if (appHelper.isDefined(this.state.locale.character_response) && this.state.locale.character_response.length > 0) {
	                this.setState({ showResponse: true });
	            } else {
	                this.showFeedbackContent();
	            }
	        }
	    }, {
	        key: 'showFeedbackContent',
	        value: function showFeedbackContent() {
	            this.setState({ showFeedbackContent: true, showKpis: true });
	        }
	    }, {
	        key: 'showKpiDashboard',
	        value: function showKpiDashboard() {}
	    }, {
	        key: 'dialogsOnComplete',
	        value: function dialogsOnComplete() {
	            this.setState({ dialogComplete: true });
	        }
	    }, {
	        key: 'setCallbacks',
	        value: function setCallbacks() {}
	    }, {
	        key: 'setResources',
	        value: function setResources() {
	            var resourceLinks = appHelper.setResourceLinks(this.state.option);
	            var hasRequiredResources = appHelper.hasRequiredResources(resourceLinks);
	            this.setState({
	                resourceLinks: Object.assign([], resourceLinks),
	                hasResources: resourceLinks.length > 0,
	                resourcesAreComplete: resourceLinks.length === 0 || !hasRequiredResources
	            });
	        }
	    }, {
	        key: 'onResourcesComplete',
	        value: function onResourcesComplete() {
	            if (!this.state.resourcesAreComplete) {
	                this.setState({ resourcesAreComplete: true, checkComplete: true });
	            }
	        }
	    }, {
	        key: 'getInheritedFeedback',
	        value: function getInheritedFeedback(feedback_id) {
	            var option = appHelper.getArrayObjectByKey(this.props.options, "option_id", feedback_id);
	            var optionLocale = appHelper.getLocalData(option);
	            return optionLocale.feedback;
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            return _react2.default.createElement(
	                'div',
	                { className: 'clear-both' },
	                this.state.hasDialogs ? _react2.default.createElement(_ChildConversationDialog2.default, { asset_id: this.props.asset_id, option_id: this.state.option.option_id,
	                    dialogs: this.state.option.dialogs, callbacks: this.state.callbacks,
	                    onComplete: this.dialogsOnComplete }) : null,
	                this.state.dialogComplete && (appHelper.isDefined(this.state.locale.feedback) || this.state.showKpis || this.state.hasResources) || appHelper.isDefined(this.state.option.feedback_id) ? _react2.default.createElement(
	                    'div',
	                    { className: 'feedback-panel ' + this.state.option.result + ' review',
	                        ref: this.state.option.option_id + '_feedbackPanel' },
	                    _react2.default.createElement('img', { src: __webpack_require__(133)("./" + this.state.option.result + '.svg'), style: kpiConstants.WATERMARK_STYLES, alt: '' }),
	                    appHelper.isDefined(this.state.assets.character) && appHelper.isDefined(this.state.locale.character_response) && this.state.locale.character_response.length > 0 ? _react2.default.createElement(
	                        'div',
	                        { className: 'feedback-character-col' },
	                        appHelper.isDefined(this.state.assets.character.src) && this.state.assets.character.src.length > 0 ? _react2.default.createElement('img', { src: this.getImagePath(this.state.assets.character.src), alt: '' }) : null
	                    ) : null,
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'feedback-content-col' },
	                        this.state.showKpis ? _react2.default.createElement(_KpiDashboard2.default, { displayState: kpiConstants.KPI_DISPLAY_STATE_REVIEW_POINTS_AWARDED,
	                            bite_id: this.props.responseData.bite_id,
	                            screen_id: this.props.responseData.screen_id,
	                            asset_id: this.props.responseData.asset_id,
	                            option: this.props.option,
	                            responseReview: this.state.kpiDashboardParams.responseReview,
	                            showImmediateImpact: this.state.kpiDashboardParams.showImmediateImpact,
	                            showTitle: this.state.kpiDashboardParams.showTitle }) : null,
	                        appHelper.isDefined(this.state.locale.feedback) && this.state.locale.feedback.length > 0 ? _react2.default.createElement('div', { className: 'object-container',
	                            dangerouslySetInnerHTML: { __html: this.state.locale.feedback } }) : appHelper.isDefined(this.state.option.feedback_id) ? _react2.default.createElement('div', { className: 'object-container',
	                            dangerouslySetInnerHTML: { __html: this.getInheritedFeedback(this.state.option.feedback_id) } }) : null,
	                        this.state.hasResources ? _react2.default.createElement(_ResourceLinks2.default, { resources: this.state.resourceLinks,
	                            onResourcesComplete: this.onResourcesComplete }) : null
	                    )
	                ) : null
	            );
	        }
	    }]);
	
	    return ConversationSingleAnswerFeedbackReview;
	}(_react2.default.Component);
	
	ConversationSingleAnswerFeedbackReview.propTypes = {
	    option: _propTypes2.default.object.isRequired,
	    options: _propTypes2.default.array.isRequired,
	    locale: _propTypes2.default.object,
	    responseData: _propTypes2.default.object.isRequired,
	    asset_id: _propTypes2.default.number.isRequired,
	    callbacks: _propTypes2.default.object,
	    onComplete: _propTypes2.default.func,
	    lang: _propTypes2.default.string.isRequired,
	    actions: _propTypes2.default.object
	};
	
	ConversationSingleAnswerFeedbackReview.contextTypes = {
	    router: _propTypes2.default.object
	};
	
	function mapStateToProps(state) {
	    var lang = state.userData.lang;
	    return {
	        lang: lang
	    };
	}
	
	function mapDispatchToProps(dispatch) {
	    return {
	        actions: (0, _redux.bindActionCreators)(Object.assign({}, trackingDataActions, userDataActions), dispatch)
	    };
	}
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(ConversationSingleAnswerFeedbackReview);

/***/ },
/* 494 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(5);
	
	var _redux = __webpack_require__(4);
	
	var _appDataActions = __webpack_require__(12);
	
	var appDataActions = _interopRequireWildcard(_appDataActions);
	
	var _trackingDataActions = __webpack_require__(7);
	
	var trackingDataActions = _interopRequireWildcard(_trackingDataActions);
	
	var _dialogPopupActions = __webpack_require__(19);
	
	var dialogPopupActions = _interopRequireWildcard(_dialogPopupActions);
	
	var _appHelper = __webpack_require__(3);
	
	var appHelper = _interopRequireWildcard(_appHelper);
	
	var _dataHelper = __webpack_require__(11);
	
	var dataHelper = _interopRequireWildcard(_dataHelper);
	
	var _userDataHelper = __webpack_require__(15);
	
	var userDataHelper = _interopRequireWildcard(_userDataHelper);
	
	var _keyboardConstants = __webpack_require__(14);
	
	var keyboardConstants = _interopRequireWildcard(_keyboardConstants);
	
	var _objectConstants = __webpack_require__(9);
	
	var objectConstants = _interopRequireWildcard(_objectConstants);
	
	var _gsap = __webpack_require__(8);
	
	var _gsapReactPlugin = __webpack_require__(10);
	
	var _gsapReactPlugin2 = _interopRequireDefault(_gsapReactPlugin);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	//import {SINGLE_ANSWER_REVIEW_CONFIG} from '../../../../models/dialogModels';
	
	
	var ConversationSingleAnswerOption = function (_React$Component) {
	    _inherits(ConversationSingleAnswerOption, _React$Component);
	
	    function ConversationSingleAnswerOption(props, context) {
	        _classCallCheck(this, ConversationSingleAnswerOption);
	
	        var _this = _possibleConstructorReturn(this, (ConversationSingleAnswerOption.__proto__ || Object.getPrototypeOf(ConversationSingleAnswerOption)).call(this, props, context));
	
	        _this.state = {
	            lang: _this.props.lang,
	            option: _this.props.option,
	            focusedOption: _this.props.focusedOption,
	            initialised: false,
	            locale: appHelper.getLocalData(_this.props.option),
	            responseData: _this.props.responseData,
	            isAnimating: false,
	            focusedClass: "not-focused"
	        };
	
	        _this.hideOption = _this.hideOption.bind(_this);
	        _this.showOption = _this.showOption.bind(_this);
	        _this.scaleOptionHeight = _this.scaleOptionHeight.bind(_this);
	        _this.removeOption = _this.removeOption.bind(_this);
	        _this.roundCorners = _this.roundCorners.bind(_this);
	        _this.setOptionAsSelected = _this.setOptionAsSelected.bind(_this);
	        _this.onOptionHidden = _this.onOptionHidden.bind(_this);
	        _this.onOptionRevealed = _this.onOptionRevealed.bind(_this);
	        _this.getDisabledState = _this.getDisabledState.bind(_this);
	        _this.getOptionClass = _this.getOptionClass.bind(_this);
	        _this.getClickFunction = _this.getClickFunction.bind(_this);
	        _this.handleOptionVisibility = _this.handleOptionVisibility.bind(_this);
	        _this.onAttemptComplete = _this.onAttemptComplete.bind(_this);
	        _this.setAnimationStart = _this.setAnimationStart.bind(_this);
	        _this.setAnimationEnd = _this.setAnimationEnd.bind(_this);
	        _this.getIsChecked = _this.getIsChecked.bind(_this);
	        _this.getIsDisabled = _this.getIsDisabled.bind(_this);
	        _this.setFocus = _this.setFocus.bind(_this);
	        _this.setBlur = _this.setBlur.bind(_this);
	        _this.getScreenReaderOptionClass = _this.getScreenReaderOptionClass.bind(_this);
	        return _this;
	    }
	
	    _createClass(ConversationSingleAnswerOption, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            this.handleOptionVisibility();
	        }
	    }, {
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(nextProps) {
	            if (this.state.responseData !== nextProps.responseData) {
	                this.setState({ responseData: Object.assign({}, nextProps.responseData) });
	            }
	
	            if (this.state.focusedOption !== nextProps.focusedOption) {
	                this.setState({ focusedOption: Object.assign({}, nextProps.focusedOption) });
	            }
	            if (this.state.lang !== nextProps.lang) {
	                this.setState({
	                    lang: nextProps.lang,
	                    locale: appHelper.getLocalData(this.state.option)
	                });
	            }
	        }
	    }, {
	        key: 'componentDidUpdate',
	        value: function componentDidUpdate() {
	            var optionRef = this.refs[this.state.option.option_id];
	            optionRef.classList.remove("rounded");
	            if (this.props.getOptionCanUpdate()) {
	                this.handleOptionVisibility();
	            }
	        }
	    }, {
	        key: 'setAnimationStart',
	        value: function setAnimationStart() {
	
	            if (!this.state.isAnimating) {
	                this.setState({ isAnimating: true });
	            }
	        }
	    }, {
	        key: 'setAnimationEnd',
	        value: function setAnimationEnd() {
	            this.props.setOptionCanUpdate(false);
	            if (this.state.isAnimating) {
	                this.setState({ isAnimating: false });
	            }
	        }
	    }, {
	        key: 'getOptionClass',
	        value: function getOptionClass() {
	            var responseData = this.state.responseData;
	            var latestResponse = appHelper.getLastItemOfArray(responseData.responses);
	            if (responseData.displayState !== objectConstants.OBJECT_DISPLAY_STATE_REVIEW) {
	                if (responseData.currentAttempt === responseData.responses.length && latestResponse.selectedOption.option_id === this.state.option.option_id) {
	                    if (responseData.displayState !== objectConstants.OBJECT_DISPLAY_STATE_ANSWERED || !this.props.showFeedback) {
	                        return 'active';
	                    } else {
	                        return 'selected answered ' + this.state.option.result;
	                    }
	                } else {
	                    for (var i = 0; i < this.state.responseData.responses.length; i++) {
	                        var response = this.state.responseData.responses[i];
	                        if (response.selectedOption.option_id === this.state.option.option_id) {
	                            return 'show-answer ' + this.state.option.result;
	                        }
	                    }
	                }
	            } else if (responseData.displayState === objectConstants.OBJECT_DISPLAY_STATE_REVIEW && this.props.showFeedback) {
	                if (responseData.currentAttempt === responseData.responses.length && latestResponse.selectedOption.option_id === this.state.option.option_id) {
	                    return 'review-selected answered ' + this.state.option.result;
	                } else {
	                    return 'review ' + this.state.option.result;
	                }
	            }
	
	            return "";
	        }
	    }, {
	        key: 'getScreenReaderOptionClass',
	        value: function getScreenReaderOptionClass() {
	            var responseData = this.state.responseData;
	            var latestResponse = appHelper.getLastItemOfArray(responseData.responses);
	            if (responseData.displayState !== objectConstants.OBJECT_DISPLAY_STATE_REVIEW) {
	                if (responseData.currentAttempt === responseData.responses.length && latestResponse.selectedOption.option_id === this.state.option.option_id) {
	                    if (responseData.displayState !== objectConstants.OBJECT_DISPLAY_STATE_ANSWERED || !this.props.showFeedback) {
	                        return "";
	                    } else {
	                        return appHelper.getOptionResultString(this.state.option.result, true);
	                    }
	                } else {
	                    for (var i = 0; i < this.state.responseData.responses.length; i++) {
	                        var response = this.state.responseData.responses[i];
	                        if (response.selectedOption.option_id === this.state.option.option_id) {
	                            return appHelper.getOptionResultString(this.state.option.result, true);
	                        }
	                    }
	                }
	            } else if (responseData.displayState === objectConstants.OBJECT_DISPLAY_STATE_REVIEW && this.props.showFeedback) {
	                if (responseData.currentAttempt === responseData.responses.length && latestResponse.selectedOption.option_id === this.state.option.option_id) {
	                    return appHelper.getOptionResultString(this.state.option.result, false);
	                } else {
	                    return appHelper.getOptionResultString(this.state.option.result, false);
	                }
	            }
	
	            return "";
	        }
	    }, {
	        key: 'getClickFunction',
	        value: function getClickFunction() {
	            var responseData = this.state.responseData;
	            var latestResponse = appHelper.getLastItemOfArray(responseData.responses);
	            if (responseData.currentAttempt === responseData.responses.length && latestResponse.selectedOption.option_id === this.state.option.option_id && this.props.showFeedback) {
	                if (responseData.displayState == objectConstants.OBJECT_DISPLAY_STATE_ANSWERED || responseData.displayState === objectConstants.OBJECT_DISPLAY_STATE_REVIEW && this.props.contentData.experience.include_explore_feedback) {
	                    this.props.onReviewObject('option_' + this.state.option.option_id);
	                }
	            }
	        }
	    }, {
	        key: 'getDisabledState',
	        value: function getDisabledState() {
	            var responseData = this.state.responseData;
	            //if (responseData.displayState === objectConstants.OBJECT_DISPLAY_STATE_INITIAL) {
	            if (responseData.currentAttempt === responseData.responses.length || this.state.isAnimating) {
	                return 'disabled';
	            } else {
	                for (var i = 0; i < this.state.responseData.responses.length; i++) {
	                    var response = this.state.responseData.responses[i];
	                    if (response.selectedOption.option_id === this.state.option.option_id) {
	                        return 'disabled';
	                    }
	                }
	                return null;
	            }
	        }
	    }, {
	        key: 'handleOptionVisibility',
	        value: function handleOptionVisibility() {
	            var responseData = this.state.responseData;
	            var latestResponse = appHelper.getLastItemOfArray(responseData.responses);
	
	            //if user responsed have been logged
	            if (typeof latestResponse !== 'undefined' && responseData.displayState !== objectConstants.OBJECT_DISPLAY_STATE_REVIEW) {
	                // if currentAttempt has been answered and the current option id does not equal the selected option if then hide it
	                if (responseData.currentAttempt === responseData.responses.length && latestResponse.selectedOption.option_id !== this.state.option.option_id) {
	                    this.hideOption();
	                    // if currentAttempt has been answered and the current option id does equal the selected option if then show it but and the corners
	                } else if (responseData.currentAttempt === responseData.responses.length && latestResponse.selectedOption.option_id === this.state.option.option_id) {
	                    this.roundCorners();
	                    // if currentAttempt has not been answered then render all options with no animation
	                } else if (responseData.currentAttempt > responseData.responses.length && latestResponse.selectedOption.option_id !== this.state.option.option_id) {
	                    this.showOption(0.5, 0);
	                }
	                //if in review then reveal all options
	            } else if (responseData.displayState === objectConstants.OBJECT_DISPLAY_STATE_REVIEW && appHelper.isDefined(latestResponse) && latestResponse.selectedOption.option_id === this.state.option.option_id) {
	                this.showOption(0, 0);
	            } else {
	                if (!this.state.initialised) {
	                    this.showOption(0.5, this.props.index * 0.5);
	                }
	            }
	        }
	    }, {
	        key: 'hideOption',
	        value: function hideOption() {
	
	            this.setAnimationStart();
	            var optionRef = this.refs[this.state.option.option_id];
	
	            if (appHelper.isDefined(optionRef) && optionRef.style.opacity !== "0") {
	                _gsap.TweenLite.to(optionRef, objectConstants.SPEECH_BUBBLE_DURATION, {
	                    opacity: 0,
	                    delay: 0,
	                    ease: _gsap.Expo.easeOut
	                }).eventCallback("onComplete", this.scaleOptionHeight);
	            }
	        }
	    }, {
	        key: 'showOption',
	        value: function showOption(duration, delay) {
	            this.setAnimationStart();
	            var optionRef = this.refs[this.state.option.option_id];
	            optionRef.classList.remove("rounded");
	            if (appHelper.isDefined(optionRef)) {
	
	                _gsap.TweenLite.set(optionRef, { height: 0, opacity: 0 });
	                _gsap.TweenLite.to(optionRef, objectConstants.SPEECH_BUBBLE_DURATION, {
	                    height: "auto",
	                    opacity: 1,
	                    delay: 0,
	                    ease: _gsap.Expo.easeInOut
	                }).eventCallback("onComplete", this.onOptionRevealed);
	
	                if (!this.state.initialised) {
	                    this.setState({ initialised: true });
	                }
	            }
	        }
	    }, {
	        key: 'onOptionRevealed',
	        value: function onOptionRevealed() {
	            var optionRef = this.refs[this.state.option.option_id];
	            if (appHelper.isDefined(optionRef)) {
	                optionRef.classList.remove("rounded");
	            }
	            this.setAnimationEnd();
	            this.props.onOptionRevealed();
	        }
	    }, {
	        key: 'roundCorners',
	        value: function roundCorners() {
	
	            var optionRef = this.refs[this.state.option.option_id];
	            if (appHelper.isDefined(optionRef) && !optionRef.classList.contains("rounded")) {
	                _gsap.TweenLite.to(optionRef, objectConstants.SPEECH_BUBBLE_DURATION, {
	                    css: { className: '+=rounded' },
	                    delay: 0
	
	                }).eventCallback("onComplete", this.setOptionAsSelected);
	            }
	        }
	    }, {
	        key: 'setOptionAsSelected',
	        value: function setOptionAsSelected() {
	            var optionRef = this.refs[this.state.option.option_id];
	            if (appHelper.isDefined(optionRef)) {
	                _gsap.TweenLite.to(optionRef, objectConstants.SPEECH_BUBBLE_DURATION, {
	                    css: { className: this.props.showFeedback ? '+=selected ' + this.state.option.result : '+=selected' },
	                    delay: 0
	                });
	            }
	        }
	    }, {
	        key: 'onOptionHidden',
	        value: function onOptionHidden() {
	            var responseData = this.state.responseData;
	            var latestResponse = appHelper.getLastItemOfArray(responseData.responses);
	
	            //if selected option is first in the list
	            if (latestResponse.index === 0) {
	                this.removeOption();
	            } else {
	                this.scaleOptionHeight();
	            }
	        }
	    }, {
	        key: 'scaleOptionHeight',
	        value: function scaleOptionHeight() {
	            this.setAnimationStart();
	            var optionRef = this.refs[this.state.option.option_id];
	            if (appHelper.isDefined(optionRef)) {
	                _gsap.TweenLite.to(optionRef, objectConstants.SPEECH_BUBBLE_DURATION, {
	                    height: 0,
	                    ease: _gsap.Expo.easeInOut
	                }).eventCallback("onComplete", this.onAttemptComplete);
	            }
	        }
	    }, {
	        key: 'onAttemptComplete',
	        value: function onAttemptComplete() {
	
	            this.props.onAttemptComplete();
	        }
	    }, {
	        key: 'removeOption',
	        value: function removeOption() {
	            //this.setState({render: false});
	        }
	    }, {
	        key: 'getIsChecked',
	        value: function getIsChecked() {
	            var responseData = this.state.responseData;
	            var latestResponse = appHelper.getLastItemOfArray(responseData.responses);
	            return appHelper.isDefined(latestResponse) && responseData.currentAttempt === responseData.responses.length && latestResponse.selectedOption.option_id === this.state.option.option_id;
	        }
	    }, {
	        key: 'getIsDisabled',
	        value: function getIsDisabled() {
	            var responseData = this.state.responseData;
	            //if (responseData.displayState === objectConstants.OBJECT_DISPLAY_STATE_INITIAL) {
	            if (responseData.currentAttempt === responseData.responses.length || this.state.isAnimating) {
	                return true;
	            } else {
	                for (var i = 0; i < this.state.responseData.responses.length; i++) {
	                    var response = this.state.responseData.responses[i];
	                    if (response.selectedOption.option_id === this.state.option.option_id) {
	                        return true;
	                    }
	                }
	                return false;
	            }
	        }
	    }, {
	        key: 'setFocus',
	        value: function setFocus() {
	            this.setState({ focusedClass: "focused" });
	        }
	    }, {
	        key: 'setBlur',
	        value: function setBlur() {
	            this.setState({ focusedClass: "not-focused" });
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	
	            return _react2.default.createElement(
	                'div',
	                { className: 'learner-action-option speak ' + this.getOptionClass() + ' ' + this.state.focusedClass,
	                    ref: this.state.option.option_id,
	                    id: 'option_' + this.state.option.option_id,
	                    onClick: this.getClickFunction,
	                    onKeyDown: this.props.optionCallbacks.setKeyboardAccessibility,
	                    onFocus: this.setFocus,
	                    onBlur: this.setBlur,
	                    role: 'radio',
	                    tabIndex: this.state.focusedOption.option_id === this.state.option.option_id ? 0 : -1,
	                    'aria-checked': this.getIsChecked(),
	                    'aria-disabled': this.getIsDisabled() },
	                _react2.default.createElement('input', { id: this.props.asset_id + '_' + this.state.option.option_id, type: 'radio',
	                    disabled: this.getDisabledState(),
	                    name: this.props.asset_id,
	                    value: this.state.option.option_id,
	                    onChange: this.props.onOptionClick
	
	                }),
	                _react2.default.createElement(
	                    'label',
	                    { htmlFor: this.props.asset_id + '_' + this.state.option.option_id },
	                    _react2.default.createElement('span', { dangerouslySetInnerHTML: { __html: '' + this.state.locale.option } }),
	                    _react2.default.createElement(
	                        'span',
	                        { className: 'hidden-el' },
	                        this.getScreenReaderOptionClass()
	                    )
	                )
	            );
	        }
	    }]);
	
	    return ConversationSingleAnswerOption;
	}(_react2.default.Component);
	
	ConversationSingleAnswerOption.propTypes = {
	    option: _propTypes2.default.object.isRequired,
	    asset_id: _propTypes2.default.number.isRequired,
	    responseData: _propTypes2.default.object.isRequired,
	    index: _propTypes2.default.number.isRequired,
	    setOptionCanUpdate: _propTypes2.default.func.isRequired,
	    getOptionCanUpdate: _propTypes2.default.func.isRequired,
	    onOptionClick: _propTypes2.default.func,
	    onAttemptComplete: _propTypes2.default.func,
	    onReviewObject: _propTypes2.default.func,
	    onOptionRevealed: _propTypes2.default.func,
	    showFeedback: _propTypes2.default.bool,
	    focusedOption: _propTypes2.default.object,
	    optionCallbacks: _propTypes2.default.object,
	    contentData: _propTypes2.default.object,
	    trackingData: _propTypes2.default.object,
	    lang: _propTypes2.default.string.isRequired,
	    actions: _propTypes2.default.object
	};
	
	ConversationSingleAnswerOption.contextTypes = {
	    router: _propTypes2.default.object
	};
	
	function mapStateToProps(state) {
	    var lang = state.userData.lang;
	    return {
	        lang: lang,
	        contentData: state.contentData,
	        trackingData: state.trackingData
	    };
	}
	
	function mapDispatchToProps(dispatch) {
	    return {
	        actions: (0, _redux.bindActionCreators)(Object.assign({}, appDataActions, trackingDataActions, dialogPopupActions), dispatch)
	    };
	}
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(ConversationSingleAnswerOption);

/***/ },
/* 495 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(5);
	
	var _redux = __webpack_require__(4);
	
	var _trackingDataActions = __webpack_require__(7);
	
	var trackingDataActions = _interopRequireWildcard(_trackingDataActions);
	
	var _appHelper = __webpack_require__(3);
	
	var appHelper = _interopRequireWildcard(_appHelper);
	
	var _objectConstants = __webpack_require__(9);
	
	var objectConstants = _interopRequireWildcard(_objectConstants);
	
	var _keyboardConstants = __webpack_require__(14);
	
	var keyboardConstants = _interopRequireWildcard(_keyboardConstants);
	
	var _gsap = __webpack_require__(8);
	
	var _gsapReactPlugin = __webpack_require__(10);
	
	var _gsapReactPlugin2 = _interopRequireDefault(_gsapReactPlugin);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ConversationSingleAnswerOptionReview = function (_React$Component) {
	    _inherits(ConversationSingleAnswerOptionReview, _React$Component);
	
	    function ConversationSingleAnswerOptionReview(props, context) {
	        _classCallCheck(this, ConversationSingleAnswerOptionReview);
	
	        var _this = _possibleConstructorReturn(this, (ConversationSingleAnswerOptionReview.__proto__ || Object.getPrototypeOf(ConversationSingleAnswerOptionReview)).call(this, props, context));
	
	        _this.state = {
	            lang: _this.props.lang,
	            option: _this.props.option,
	            locale: appHelper.getLocalData(_this.props.option),
	            responseData: _this.props.responseData,
	            focusedOption: _this.props.focusedOption,
	            focusedClass: "not-focused"
	        };
	        _this.showOption = _this.showOption.bind(_this);
	        _this.onObjectSelected = _this.onObjectSelected.bind(_this);
	        _this.getDisabledState = _this.getDisabledState.bind(_this);
	        _this.getOptionClass = _this.getOptionClass.bind(_this);
	        _this.handleOptionVisibility = _this.handleOptionVisibility.bind(_this);
	        _this.setFocus = _this.setFocus.bind(_this);
	        _this.setBlur = _this.setBlur.bind(_this);
	        return _this;
	    }
	
	    _createClass(ConversationSingleAnswerOptionReview, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            this.handleOptionVisibility();
	        }
	    }, {
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(nextProps) {
	            if (this.state.responseData !== nextProps.responseData) {
	                this.setState({ responseData: nextProps.responseData });
	            }
	
	            if (this.state.focusedOption !== nextProps.focusedOption) {
	                this.setState({ focusedOption: Object.assign({}, nextProps.focusedOption) });
	            }
	
	            if (this.state.lang !== nextProps.lang) {
	                this.setState({
	                    lang: nextProps.lang,
	                    locale: appHelper.getLocalData(this.state.option)
	                });
	            }
	        }
	    }, {
	        key: 'componentDidUpdate',
	        value: function componentDidUpdate() {
	            this.handleOptionVisibility();
	        }
	    }, {
	        key: 'getOptionClass',
	        value: function getOptionClass() {
	            var responseData = this.state.responseData;
	            var latestResponse = appHelper.getLastItemOfArray(responseData.responses);
	            var activeClass = "";
	            if (this.props.optionReviewId === this.state.option.option_id) {
	                activeClass = "review-current";
	            }
	            if (responseData.currentAttempt === responseData.responses.length && latestResponse.selectedOption.option_id === this.state.option.option_id) {
	                return 'review-selected ' + this.state.option.result + ' ' + activeClass;
	            } else {
	                return 'review ' + this.state.option.result + ' ' + activeClass;
	            }
	        }
	    }, {
	        key: 'getDisabledState',
	        value: function getDisabledState() {
	            return 'disabled';
	        }
	    }, {
	        key: 'handleOptionVisibility',
	        value: function handleOptionVisibility() {
	            this.showOption(0, 0);
	        }
	    }, {
	        key: 'showOption',
	        value: function showOption(duration, delay) {
	            var optionRef = this.refs[this.state.option.option_id];
	            if (appHelper.isDefined(optionRef)) {
	                _gsap.TweenLite.set(optionRef, { height: "auto", opacity: 1 });
	                _gsap.TweenLite.from(optionRef, duration, {
	                    height: 0,
	                    opacity: 0,
	                    delay: delay,
	                    ease: _gsap.Expo.easeInOut
	                });
	            }
	        }
	    }, {
	        key: 'onObjectSelected',
	        value: function onObjectSelected() {
	            this.props.onOptionClick(this.state.option);
	        }
	    }, {
	        key: 'setFocus',
	        value: function setFocus() {
	            this.setState({ focusedClass: "focused" });
	        }
	    }, {
	        key: 'setBlur',
	        value: function setBlur() {
	            this.setState({ focusedClass: "not-focused" });
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	
	            return _react2.default.createElement(
	                'div',
	                { className: 'learner-action-option speak  ' + this.getOptionClass() + ' ' + this.state.focusedClass,
	                    ref: this.state.option.option_id,
	                    id: 'option_review_' + this.state.option.option_id,
	                    onKeyDown: this.props.optionCallbacks.setKeyboardAccessibility,
	                    onFocus: this.setFocus,
	                    onBlur: this.setBlur,
	                    role: 'radio',
	                    tabIndex: this.state.focusedOption.option_id === this.state.option.option_id ? 0 : -1,
	                    'aria-checked': this.props.optionReviewId === this.state.option.option_id,
	                    'aria-disabled': 'false' },
	                _react2.default.createElement(
	                    'label',
	                    { htmlFor: this.props.asset_id + '_' + this.state.option.option_id + '_review' },
	                    _react2.default.createElement('input', { id: this.props.asset_id + '_' + this.state.option.option_id + '_review', type: 'radio',
	                        name: this.props.asset_id + '_review',
	                        value: this.state.option.option_id,
	                        onClick: this.onObjectSelected
	
	                    }),
	                    _react2.default.createElement('span', { dangerouslySetInnerHTML: { __html: this.state.locale.option } }),
	                    _react2.default.createElement(
	                        'span',
	                        { className: 'hidden-el' },
	                        appHelper.getOptionResultString(this.state.option.result, false)
	                    )
	                )
	            );
	        }
	    }]);
	
	    return ConversationSingleAnswerOptionReview;
	}(_react2.default.Component);
	
	ConversationSingleAnswerOptionReview.propTypes = {
	    option: _propTypes2.default.object.isRequired,
	    asset_id: _propTypes2.default.number.isRequired,
	    responseData: _propTypes2.default.object.isRequired,
	    optionReviewId: _propTypes2.default.number,
	    onOptionClick: _propTypes2.default.func,
	    focusedOption: _propTypes2.default.object,
	    contentData: _propTypes2.default.object,
	    trackingData: _propTypes2.default.object,
	    optionCallbacks: _propTypes2.default.object,
	    lang: _propTypes2.default.string.isRequired,
	    actions: _propTypes2.default.object
	};
	
	ConversationSingleAnswerOptionReview.contextTypes = {
	    router: _propTypes2.default.object
	};
	
	function mapStateToProps(state, ownProps) {
	    var lang = state.userData.lang;
	    return {
	        lang: lang,
	        contentData: state.contentData,
	        trackingData: state.trackingData
	    };
	}
	
	function mapDispatchToProps(dispatch) {
	    return {
	        actions: (0, _redux.bindActionCreators)(Object.assign({}, trackingDataActions), dispatch)
	    };
	}
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(ConversationSingleAnswerOptionReview);

/***/ },
/* 496 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(5);
	
	var _redux = __webpack_require__(4);
	
	var _ConversationSingleAnswerOptionReview = __webpack_require__(495);
	
	var _ConversationSingleAnswerOptionReview2 = _interopRequireDefault(_ConversationSingleAnswerOptionReview);
	
	var _ConversationSingleAnswerFeedbackReview = __webpack_require__(493);
	
	var _ConversationSingleAnswerFeedbackReview2 = _interopRequireDefault(_ConversationSingleAnswerFeedbackReview);
	
	var _Prompt = __webpack_require__(83);
	
	var _Prompt2 = _interopRequireDefault(_Prompt);
	
	var _DialogPrompt = __webpack_require__(94);
	
	var _DialogPrompt2 = _interopRequireDefault(_DialogPrompt);
	
	var _BadgeCollect = __webpack_require__(47);
	
	var _BadgeCollect2 = _interopRequireDefault(_BadgeCollect);
	
	var _userDataHelper = __webpack_require__(15);
	
	var userDataHelper = _interopRequireWildcard(_userDataHelper);
	
	var _appHelper = __webpack_require__(3);
	
	var appHelper = _interopRequireWildcard(_appHelper);
	
	var _dataHelper = __webpack_require__(11);
	
	var dataHelper = _interopRequireWildcard(_dataHelper);
	
	var _objectConstants = __webpack_require__(9);
	
	var objectConstants = _interopRequireWildcard(_objectConstants);
	
	var _keyboardConstants = __webpack_require__(14);
	
	var keyboardConstants = _interopRequireWildcard(_keyboardConstants);
	
	var _localStorage = __webpack_require__(17);
	
	var localStorage = _interopRequireWildcard(_localStorage);
	
	var _gsap = __webpack_require__(8);
	
	var _gsapReactPlugin = __webpack_require__(10);
	
	var _gsapReactPlugin2 = _interopRequireDefault(_gsapReactPlugin);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } //eslint-disable-line import/no-named-as-default
	//eslint-disable-line import/no-named-as-default
	
	
	var ConversationSingleAnswerReview = function (_React$Component) {
	    _inherits(ConversationSingleAnswerReview, _React$Component);
	
	    function ConversationSingleAnswerReview(props, context) {
	        _classCallCheck(this, ConversationSingleAnswerReview);
	
	        var _this = _possibleConstructorReturn(this, (ConversationSingleAnswerReview.__proto__ || Object.getPrototypeOf(ConversationSingleAnswerReview)).call(this, props, context));
	
	        _this.state = {
	            lang: _this.props.lang,
	            screenObject: _this.props.screenObject,
	            userData: _this.props.userData,
	            objectStates: objectConstants.OBJECT_DISPLAY_STATES,
	            responseData: _this.props.responseData,
	            feedbackData: _this.props.responseData.latestResponse,
	            locale: appHelper.getLocalData(_this.props.screenObject),
	            showOptions: true,
	            showResponse: true,
	            showFeedback: true,
	            selectedOption: "",
	            //badges
	            badgesEarned: [],
	            checkBadgesEarned: false,
	            collected: true,
	            character_name: appHelper.isDefined(_this.props.callbacks) ? _this.props.callbacks.getCharacterName() : appHelper.getScreenCharacterNameByAssetId(_this.props.screenObject.asset_id),
	            focusedOption: _this.props.responseData.latestResponse,
	            optionCallbacks: {},
	            updateFocus: false
	        };
	        _this.randomiseOptions = _this.randomiseOptions.bind(_this);
	        _this.onOptionClick = _this.onOptionClick.bind(_this);
	        _this.renderFeedback = _this.renderFeedback.bind(_this);
	        _this.renderOptions = _this.renderOptions.bind(_this);
	        //badges
	        _this.checkBadgeEarnedOnObject = _this.checkBadgeEarnedOnObject.bind(_this);
	        _this.getBadge = _this.getBadge.bind(_this);
	        _this.getPrevOption = _this.getPrevOption.bind(_this);
	        _this.getNextOption = _this.getNextOption.bind(_this);
	        _this.setKeyboardAccessibility = _this.setKeyboardAccessibility.bind(_this);
	        _this.setOptionCallbacks = _this.setOptionCallbacks.bind(_this);
	        _this.setOptionFocus = _this.setOptionFocus.bind(_this);
	        return _this;
	    }
	
	    _createClass(ConversationSingleAnswerReview, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            this.checkBadgeEarnedOnObject();
	            this.setOptionCallbacks();
	        }
	    }, {
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(nextProps) {
	            if (this.state.userData !== nextProps.userData) {
	                this.setState({
	                    userData: Object.assign({}, nextProps.userData),
	                    checkBadgesEarned: true
	                });
	            }
	
	            if (this.state.lang !== nextProps.lang) {
	                this.setState({
	                    lang: nextProps.lang,
	                    locale: appHelper.getLocalData(this.state.screenObject)
	                });
	            }
	        }
	    }, {
	        key: 'componentDidUpdate',
	        value: function componentDidUpdate() {
	            if (!this.state.showFeedback) {
	                this.renderFeedback();
	            }
	
	            if (this.checkBadgesEarned) {
	                this.checkBadgeEarnedOnObject();
	            }
	
	            if (this.state.updateFocus) {
	                this.setOptionFocus();
	            }
	        }
	    }, {
	        key: 'checkBadgeEarnedOnObject',
	        value: function checkBadgeEarnedOnObject() {
	            var params = {
	                bite_id: this.state.responseData.bite_id,
	                asset_id: this.state.screenObject.asset_id
	            };
	
	            var badgesEarned = userDataHelper.checkBadgeEarnedOnObject(this.state.userData, params);
	            this.setState({
	                checkBadgesEarned: false,
	                badgesEarned: Object.assign([], badgesEarned)
	            });
	        }
	    }, {
	        key: 'getBadge',
	        value: function getBadge(badge_id) {
	            //return appHelper.getArrayObjectByKey(localStorage.achievements, "code", code);
	        }
	    }, {
	        key: 'renderFeedback',
	        value: function renderFeedback() {
	            this.setState({ showFeedback: true });
	        }
	    }, {
	        key: 'randomiseOptions',
	        value: function randomiseOptions() {
	            this.setState({
	                screenObject: Object.assign({}, this.state.screenObject, {
	                    options: dataHelper.randomiseArray(this.state.screenObject.options)
	                })
	            });
	        }
	    }, {
	        key: 'onOptionClick',
	        value: function onOptionClick(option) {
	            this.setState({
	                feedbackData: Object.assign({}, option),
	                showFeedback: false
	            });
	
	            this.refs['feedback_wrapper_' + this.state.screenObject.asset_id].focus();
	        }
	    }, {
	        key: 'renderOptions',
	        value: function renderOptions() {}
	    }, {
	        key: 'getPrevOption',
	        value: function getPrevOption() {
	            var optionIndex = appHelper.getArrayObjectIndexByKey(this.state.screenObject.options, "option_id", this.state.focusedOption.option_id);
	            var nextOption = this.state.screenObject.options[optionIndex - 1];
	            if (optionIndex <= 0) {
	                nextOption = this.state.screenObject.options[this.state.screenObject.options.length - 1];
	            }
	            this.setState({ focusedOption: Object.assign({}, nextOption), updateFocus: true });
	        }
	    }, {
	        key: 'getNextOption',
	        value: function getNextOption() {
	            var optionIndex = appHelper.getArrayObjectIndexByKey(this.state.screenObject.options, "option_id", this.state.focusedOption.option_id);
	            var nextOption = this.state.screenObject.options[optionIndex + 1];
	            if (optionIndex === this.state.screenObject.options.length - 1) {
	                nextOption = this.state.screenObject.options[0];
	            }
	            this.setState({ focusedOption: Object.assign({}, nextOption), updateFocus: true });
	        }
	    }, {
	        key: 'setKeyboardAccessibility',
	        value: function setKeyboardAccessibility(event) {
	            if (event.which === keyboardConstants.ENTER_KEY || event.which === keyboardConstants.SPACEBAR_KEY) {
	                event.preventDefault();
	                this.onOptionClick(this.state.focusedOption);
	            }
	
	            if (event.which === keyboardConstants.ARROW_LEFT_KEY) {
	                event.preventDefault();
	                this.getPrevOption();
	            }
	
	            if (event.which === keyboardConstants.ARROW_RIGHT_KEY) {
	                event.preventDefault();
	                this.getNextOption();
	            }
	
	            if (event.which === keyboardConstants.ARROW_UP_KEY) {
	                event.preventDefault();
	                this.getPrevOption();
	            }
	
	            if (event.which === keyboardConstants.ARROW_DOWN_KEY) {
	                event.preventDefault();
	                this.getNextOption();
	            }
	        }
	    }, {
	        key: 'setOptionCallbacks',
	        value: function setOptionCallbacks() {
	            this.setState({
	                optionCallbacks: Object.assign({}, this.state.optionCallbacks, {
	                    setKeyboardAccessibility: this.setKeyboardAccessibility
	                })
	            });
	        }
	    }, {
	        key: 'setOptionFocus',
	        value: function setOptionFocus() {
	            var focusEl = document.getElementById('option_review_' + this.state.focusedOption.option_id);
	            focusEl.focus();
	            this.setState({ updateFocus: false });
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this2 = this;
	
	            return _react2.default.createElement(
	                'div',
	                { className: 'learner-action' },
	                this.state.badgesEarned.length > 0 ? _react2.default.createElement(
	                    'div',
	                    null,
	                    this.state.badgesEarned.map(function (badge) {
	                        return _react2.default.createElement(_BadgeCollect2.default, { key: badge.badge_id, badge_id: badge.badge_id,
	                            bite_id: _this2.state.responseData.bite_id,
	                            asset_id: _this2.state.responseData.asset_id,
	                            collected: _this2.state.collected });
	                    }),
	                    _react2.default.createElement('br', null)
	                ) : null,
	                this.state.screenObject.prompt_type === objectConstants.PROMPT_TYPE_DIALOG_PROMPT ? _react2.default.createElement(
	                    'div',
	                    { className: 'object-container' },
	                    _react2.default.createElement(_DialogPrompt2.default, { character_name: this.state.character_name, id: this.state.screenObject.asset_id,
	                        locale: this.state.locale, show_title: this.state.screenObject.show_title,
	                        onComplete: this.renderOptions })
	                ) : _react2.default.createElement(
	                    'div',
	                    { className: 'horz-padding' },
	                    _react2.default.createElement(_Prompt2.default, { id: this.state.screenObject.asset_id, locale: this.state.locale,
	                        show_title: this.state.screenObject.show_title, onComplete: this.renderOptions })
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'learner-action-option-list user', role: 'radiogroup' },
	                    this.state.screenObject.options.map(function (option) {
	                        return _react2.default.createElement(_ConversationSingleAnswerOptionReview2.default, { key: option.option_id, option: option,
	                            asset_id: _this2.state.screenObject.asset_id,
	                            responseData: _this2.state.responseData,
	                            onOptionClick: _this2.onOptionClick,
	                            optionReviewId: _this2.state.feedbackData.option_id,
	                            focusedOption: _this2.state.focusedOption,
	                            optionCallbacks: _this2.state.optionCallbacks });
	                    })
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { ref: 'feedback_wrapper_' + this.state.screenObject.asset_id,
	                        id: 'feedback_wrapper_' + this.state.screenObject.asset_id, role: 'button', tabIndex: 0,
	                        className: 'feedback-focus' },
	                    this.state.showFeedback ? _react2.default.createElement(_ConversationSingleAnswerFeedbackReview2.default, { option: this.state.feedbackData,
	                        options: this.state.screenObject.options,
	                        locale: this.state.locale,
	                        asset_id: this.state.screenObject.asset_id,
	                        responseData: this.state.responseData
	                    }) : null
	                )
	            );
	        }
	    }]);
	
	    return ConversationSingleAnswerReview;
	}(_react2.default.Component);
	
	ConversationSingleAnswerReview.propTypes = {
	    screenObject: _propTypes2.default.object.isRequired,
	    responseData: _propTypes2.default.object.isRequired,
	    index: _propTypes2.default.number,
	    userData: _propTypes2.default.object.isRequired,
	    lang: _propTypes2.default.string.isRequired,
	    callbacks: _propTypes2.default.object
	};
	
	ConversationSingleAnswerReview.contextTypes = {
	    router: _propTypes2.default.object
	};
	
	function mapStateToProps(state, ownProps) {
	    var lang = state.userData.lang;
	    return {
	        lang: lang,
	        userData: state.userData
	    };
	}
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps)(ConversationSingleAnswerReview);

/***/ },
/* 497 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(5);
	
	var _redux = __webpack_require__(4);
	
	var _GridChoiceOption = __webpack_require__(498);
	
	var _GridChoiceOption2 = _interopRequireDefault(_GridChoiceOption);
	
	var _Button = __webpack_require__(18);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _Prompt = __webpack_require__(83);
	
	var _Prompt2 = _interopRequireDefault(_Prompt);
	
	var _DialogPrompt = __webpack_require__(94);
	
	var _DialogPrompt2 = _interopRequireDefault(_DialogPrompt);
	
	var _SingleAnswerFeedback = __webpack_require__(200);
	
	var _SingleAnswerFeedback2 = _interopRequireDefault(_SingleAnswerFeedback);
	
	var _ChildConversationDialog = __webpack_require__(65);
	
	var _ChildConversationDialog2 = _interopRequireDefault(_ChildConversationDialog);
	
	var _BadgeCollect = __webpack_require__(47);
	
	var _BadgeCollect2 = _interopRequireDefault(_BadgeCollect);
	
	var _appDataActions = __webpack_require__(12);
	
	var appDataActions = _interopRequireWildcard(_appDataActions);
	
	var _trackingDataActions = __webpack_require__(7);
	
	var trackingDataActions = _interopRequireWildcard(_trackingDataActions);
	
	var _dialogPopupActions = __webpack_require__(19);
	
	var dialogPopupActions = _interopRequireWildcard(_dialogPopupActions);
	
	var _appHelper = __webpack_require__(3);
	
	var appHelper = _interopRequireWildcard(_appHelper);
	
	var _dataHelper = __webpack_require__(11);
	
	var dataHelper = _interopRequireWildcard(_dataHelper);
	
	var _userDataHelper = __webpack_require__(15);
	
	var userDataHelper = _interopRequireWildcard(_userDataHelper);
	
	var _kpiHelper = __webpack_require__(35);
	
	var kpiHelper = _interopRequireWildcard(_kpiHelper);
	
	var _objectConstants = __webpack_require__(9);
	
	var objectConstants = _interopRequireWildcard(_objectConstants);
	
	var _appConstants = __webpack_require__(13);
	
	var appConstants = _interopRequireWildcard(_appConstants);
	
	var _componentConstants = __webpack_require__(49);
	
	var componentConstants = _interopRequireWildcard(_componentConstants);
	
	var _xAPIHelper = __webpack_require__(86);
	
	var xAPIHelper = _interopRequireWildcard(_xAPIHelper);
	
	var _localStorage = __webpack_require__(17);
	
	var localStorage = _interopRequireWildcard(_localStorage);
	
	var _keyboardConstants = __webpack_require__(14);
	
	var keyboardConstants = _interopRequireWildcard(_keyboardConstants);
	
	var _dialogModels = __webpack_require__(32);
	
	var _gsap = __webpack_require__(8);
	
	var _gsapReactPlugin = __webpack_require__(10);
	
	var _gsapReactPlugin2 = _interopRequireDefault(_gsapReactPlugin);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } //eslint-disable-line import/no-named-as-default
	
	
	var GridChoice = function (_React$Component) {
	    _inherits(GridChoice, _React$Component);
	
	    function GridChoice(props, context) {
	        _classCallCheck(this, GridChoice);
	
	        var _this = _possibleConstructorReturn(this, (GridChoice.__proto__ || Object.getPrototypeOf(GridChoice)).call(this, props, context));
	
	        _this.state = {
	            lang: _this.props.lang,
	            screenObject: _this.props.screenObject,
	            userData: _this.props.userData,
	            options: _this.props.screenObject.options,
	            locale: appHelper.getLocalData(_this.props.screenObject),
	            questionChecked: false,
	            currentlyChecked: false,
	            reviewMode: false,
	            propsUpdated: false,
	            responseData: {
	                bite_id: _this.props.callbacks.getBiteId(),
	                screen_id: _this.props.callbacks.getScreenId(),
	                asset_id: _this.props.screenObject.asset_id,
	                currentAttempt: 1,
	                currentStatus: objectConstants.STATUS_NOT_STARTED,
	                displayState: objectConstants.OBJECT_DISPLAY_STATE_INITIAL,
	                responses: [],
	                latestResponse: {},
	                scoring_type: _this.props.screenObject.scoring_type
	
	            },
	            showOptions: false,
	            enableCheckBtn: false,
	            showCheckBtn: false,
	            showFeedback: false,
	            showResponse: false,
	            revealedOptions: [],
	            watchCheckBtnState: true,
	            skipFeedback: false,
	            screenStatus: "",
	            checkObjectStatus: false,
	            handleCompletion: false,
	            checkPostXAPIResponse: false,
	            character_name: appHelper.isDefined(_this.props.callbacks) ? _this.props.callbacks.getCharacterName() : appHelper.getScreenCharacterNameByAssetId(_this.props.screenObject.asset_id),
	            show_images_in_feedback: false,
	            focusedOption: _this.props.screenObject.options[0],
	            focusOnFeedback: false,
	            optionCallbacks: {},
	            updateFocus: false,
	            showProgression: false,
	            hideFeedback: false,
	            progression_label: "",
	            hasBadges: false,
	            badgesCollected: false,
	            animateBadge: true,
	            submit_label: appHelper.getLocaleString("submit_label"),
	            multiple_choice_single_answer_question_label: appHelper.getLocaleString("multiple_choice_single_answer_question_label"),
	            continue_label: appHelper.getLocaleString("continue_label"),
	            try_again_label: appHelper.getLocaleString("try_again_label"),
	            progressionHandled: false,
	            xApiResponseObj: {}
	
	        };
	        _this.randomiseOptions = _this.randomiseOptions.bind(_this);
	        _this.renderOptions = _this.renderOptions.bind(_this);
	        _this.onOptionClick = _this.onOptionClick.bind(_this);
	        _this.checkAnswers = _this.checkAnswers.bind(_this);
	        _this.showFeedback = _this.showFeedback.bind(_this);
	        _this.handleResponse = _this.handleResponse.bind(_this);
	        _this.handleProgression = _this.handleProgression.bind(_this);
	        _this.reattempt = _this.reattempt.bind(_this);
	        _this.getObjectStatus = _this.getObjectStatus.bind(_this);
	        _this.onReviewObject = _this.onReviewObject.bind(_this);
	        _this.setReviewMode = _this.setReviewMode.bind(_this);
	        _this.onOptionRevealed = _this.onOptionRevealed.bind(_this);
	        _this.setCheckBtnState = _this.setCheckBtnState.bind(_this);
	        _this.handleSkipFeedback = _this.handleSkipFeedback.bind(_this);
	        _this.scrollToSubmitBtn = _this.scrollToSubmitBtn.bind(_this);
	        _this.getClass = _this.getClass.bind(_this);
	        _this.postXAPIResponse = _this.postXAPIResponse.bind(_this);
	        _this.handleResponseComplete = _this.handleResponseComplete.bind(_this);
	        _this.getStatusClass = _this.getStatusClass.bind(_this);
	        _this.onPanelClick = _this.onPanelClick.bind(_this);
	        _this.getImagePath = _this.getImagePath.bind(_this);
	        _this.hasFeedbackToShow = _this.hasFeedbackToShow.bind(_this);
	        _this.setFocusedOption = _this.setFocusedOption.bind(_this);
	        _this.clearFocusedOption = _this.clearFocusedOption.bind(_this);
	        _this.getPrevOption = _this.getPrevOption.bind(_this);
	        _this.getNextOption = _this.getNextOption.bind(_this);
	        _this.setKeyboardAccessibility = _this.setKeyboardAccessibility.bind(_this);
	        _this.allowKeyAccessibility = _this.allowKeyAccessibility.bind(_this);
	        _this.getTabIndex = _this.getTabIndex.bind(_this);
	        _this.onKeyboardPanelClick = _this.onKeyboardPanelClick.bind(_this);
	        _this.onFocusOnFeedback = _this.onFocusOnFeedback.bind(_this);
	        _this.setOptionCallbacks = _this.setOptionCallbacks.bind(_this);
	        _this.setOptionFocus = _this.setOptionFocus.bind(_this);
	        _this.enableProgression = _this.enableProgression.bind(_this);
	        _this.onProgressionClicked = _this.onProgressionClicked.bind(_this);
	        _this.onBadgeCollected = _this.onBadgeCollected.bind(_this);
	        _this.checkResponses = _this.checkResponses.bind(_this);
	        return _this;
	    }
	
	    _createClass(GridChoice, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            this.randomiseOptions();
	            this.setOptionCallbacks();
	            if (localStorage.tracking_type === appConstants.TRACKING_TYPE_XAPI || localStorage.tracking_type === appConstants.TRACKING_TYPE_BLENDED_XAPI_SCORM_1_2) {
	                this.checkResponses();
	            } else {
	                this.getObjectStatus();
	            }
	        }
	    }, {
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(nextProps) {
	
	            if (this.state.userData !== nextProps.userData) {
	                this.setState({
	                    userData: Object.assign({}, nextProps.userData),
	                    checkObjectStatus: true
	                });
	            }
	
	            if (this.state.lang !== nextProps.lang) {
	                var progression_label = "";
	                if (this.state.progression_label === this.state.try_again_label) {
	                    progression_label = appHelper.getLocaleString("try_again_label");
	                } else if (this.state.progression_label === this.state.continue_label) {
	                    progression_label = appHelper.getLocaleString("continue_label");
	                }
	                this.setState({
	                    lang: nextProps.lang,
	                    locale: appHelper.getLocalData(this.state.screenObject),
	                    submit_label: appHelper.getLocaleString("submit_label"),
	                    multiple_choice_single_answer_question_label: appHelper.getLocaleString("multiple_choice_single_answer_question_label"),
	                    progression_label: progression_label,
	                    continue_label: appHelper.getLocaleString("continue_label"),
	                    try_again_label: appHelper.getLocaleString("try_again_label")
	                });
	            }
	        }
	    }, {
	        key: 'componentDidUpdate',
	        value: function componentDidUpdate() {
	            if (this.state.propsUpdated && this.state.responseData.displayState === objectConstants.OBJECT_DISPLAY_STATE_REVIEW) {
	                this.setReviewMode();
	            }
	
	            if (this.state.watchCheckBtnState) {
	                //console.log(`${this.state.revealedOptions.length} >= ${this.props.screenObject.options.length}`)
	                this.setCheckBtnState(this.state.revealedOptions.length >= this.props.screenObject.options.length);
	            }
	
	            if (this.state.skipFeedback) {
	                this.handleSkipFeedback();
	            }
	
	            if (this.state.checkObjectStatus) {
	                this.getObjectStatus();
	            }
	
	            if (this.state.handleCompletion) {
	                this.handleProgression();
	            }
	            if (this.state.checkPostXAPIResponse) {
	                this.postXAPIResponse();
	            }
	            if (this.state.focusOnFeedback) {
	                this.onFocusOnFeedback();
	            }
	            if (this.state.updateFocus) {
	                this.setOptionFocus();
	            }
	        }
	    }, {
	        key: 'onFocusOnFeedback',
	        value: function onFocusOnFeedback() {
	            var focusEl = document.getElementById('feedback_wrapper_' + this.state.screenObject.asset_id);
	            if (appHelper.isDefined(focusEl) && focusEl !== null) {
	                focusEl.focus();
	            }
	            this.setState({ focusOnFeedback: false });
	        }
	    }, {
	        key: 'postXAPIResponse',
	        value: function postXAPIResponse() {
	            this.setState({ checkPostXAPIResponse: false });
	            var interactionData = xAPIHelper.setSingleAnwserChoiceInteractionData(this.state.screenObject, this.state.responseData);
	            if (localStorage.tracking_type === appConstants.TRACKING_TYPE_XAPI || localStorage.tracking_type === appConstants.TRACKING_TYPE_BLENDED_XAPI_SCORM_1_2) {
	
	                var screen = appHelper.getScreenByAssetId(this.state.screenObject.asset_id);
	                var category = {
	                    constant: componentConstants.GRID_CHOICE,
	                    label: componentConstants.GRID_CHOICE_LABEL
	                };
	
	                this.props.actions.postActvityStatement(screen, interactionData, category);
	            }
	        }
	    }, {
	        key: 'handleSkipFeedback',
	        value: function handleSkipFeedback() {
	            var latestResponse = appHelper.getLastItemOfArray(this.state.responseData.responses);
	            var selectedOptions = [latestResponse.selectedOption.option_id];
	            if (appHelper.isDefined(latestResponse.audio)) {
	                var audio = appHelper.getAudioAsset(latestResponse.audio);
	                var audioObj = {
	                    audioRef: 'audio_' + audio.id + '_' + audio.type
	                };
	
	                this.props.actions.setAudio(audioObj);
	            }
	            var responseObj = {
	                asset_id: this.state.screenObject.asset_id,
	                selectedOptions: selectedOptions,
	                kpis: latestResponse.selectedOption.kpis !== null ? latestResponse.selectedOption.kpis : []
	            };
	            this.props.callbacks.storeUserResponse(responseObj);
	
	            this.setState({ skipFeedback: false });
	
	            if (!this.state.hasBadges) {
	
	                var handleResponse = this.handleResponse;
	
	                setTimeout(function () {
	                    handleResponse();
	                }, 1000);
	            }
	        }
	    }, {
	        key: 'checkResponses',
	        value: function checkResponses() {
	            var _this2 = this;
	
	            if (localStorage.tracking_type === appConstants.TRACKING_TYPE_XAPI || localStorage.tracking_type === appConstants.TRACKING_TYPE_BLENDED_XAPI_SCORM_1_2) {
	                var parentScreen = this.props.callbacks.getSubScreenParent();
	                var params = {
	
	                    bite_id: this.props.callbacks.getBiteId(),
	                    screen_id: this.props.callbacks.getScreenId(),
	                    parent_screen_id: appHelper.isDefined(parentScreen) ? parentScreen.screen_id : undefined,
	                    asset_id: this.state.screenObject.asset_id
	                };
	
	                var interactionData = xAPIHelper.getMultipleChoiceIds(params);
	
	                this.props.actions.getActvityStatement(interactionData).then(function (responseObj) {
	                    if (appHelper.isDefined(responseObj.statement.result.completion)) {
	                        _this2.setState({
	                            xApiResponseObj: Object.assign({}, responseObj),
	                            reviewMode: true,
	                            propsUpdated: true,
	                            responseData: Object.assign({}, _this2.state.responseData, {
	                                currentStatus: objectConstants.STATUS_COMPLETE,
	                                displayState: objectConstants.OBJECT_DISPLAY_STATE_REVIEW
	                            })
	                        });
	                    }
	                });
	            }
	        }
	    }, {
	        key: 'getObjectStatus',
	        value: function getObjectStatus() {
	            this.setState({ checkObjectStatus: false });
	            if (this.state.responseData.currentStatus !== objectConstants.STATUS_COMPLETE) {
	                var screenStatus = userDataHelper.getObjectStatus(this.state.userData, this.props.screenObject.asset_id);
	                if (screenStatus === objectConstants.STATUS_COMPLETE && this.state.screenObject.attempt_type === objectConstants.ATTEMPT_TYPE_FIRST) {
	                    this.setState({
	                        reviewMode: true,
	                        propsUpdated: true,
	                        responseData: Object.assign({}, this.state.responseData, {
	                            currentStatus: objectConstants.STATUS_COMPLETE,
	                            displayState: objectConstants.OBJECT_DISPLAY_STATE_REVIEW
	                        })
	                    });
	                } else {
	                    var objectUserData = {};
	                    if (this.state.status !== objectConstants.STATUS_COMPLETE) {
	                        var subScreenParent = this.props.callbacks.getSubScreenParent();
	                        var screen_id = this.props.callbacks.getScreenId();
	                        if (appHelper.isDefined(subScreenParent)) {
	                            objectUserData = userDataHelper.getSubScreenObjectStatus(this.state.userData, subScreenParent.screen_id, screen_id, this.state.screenObject.asset_id);
	                        } else {
	                            objectUserData = userDataHelper.getObjectStatus(this.state.userData, screen_id, this.state.screenObject.asset_id);
	                        }
	                    }
	
	                    if (objectUserData.status === objectConstants.STATUS_COMPLETE && this.state.screenObject.attempt_type === objectConstants.ATTEMPT_TYPE_FIRST) {
	                        this.setState({
	                            reviewMode: true,
	                            propsUpdated: true,
	                            responseData: Object.assign({}, this.state.responseData, {
	                                currentStatus: objectConstants.STATUS_COMPLETE,
	                                displayState: objectConstants.OBJECT_DISPLAY_STATE_REVIEW
	                            })
	                        });
	                    }
	                }
	            }
	        }
	    }, {
	        key: 'setReviewMode',
	        value: function setReviewMode() {
	            var optionIds = appHelper.getObjectOptionIds(this.state.screenObject);
	            var kpiUserData = userDataHelper.getUserResponseByOptionIds(this.state.userData, this.props.callbacks.getBiteId(), optionIds);
	            if (appHelper.isDefined(kpiUserData)) {
	                var optionDetails = appHelper.getOptionParentDetails(kpiUserData.option_id[0]);
	                var showResponse = false;
	
	                if (appHelper.isDefined(optionDetails)) {
	                    var responses = [];
	                    var response = {
	                        selectedOption: optionDetails.option
	                    };
	
	                    if (appHelper.isDefined(optionDetails.option.dialogs) && optionDetails.option.dialogs.length > 0) {
	                        showResponse = true;
	                    }
	
	                    var hasBadges = appHelper.isDefined(optionDetails.option.badges) && optionDetails.option.badges.length > 0;
	
	                    this.setState({
	                        showProgression: !this.props.callbacks.hasNextObject(this.props.index) && optionDetails.option.enable_feedback,
	                        hasBadges: hasBadges,
	                        badgesCollected: hasBadges,
	                        handleCompletion: true,
	                        propsUpdated: false,
	                        showOptions: true,
	                        questionChecked: true,
	                        currentlyChecked: true,
	                        showCheckBtn: false,
	                        options: dataHelper.immutableSplice(this.state.options, 0, this.state.options.length, optionDetails.option),
	                        showResponse: showResponse,
	                        progression_label: response.selectedOption.progression === objectConstants.OBJECT_PROGRESSION_TRY_AGAIN ? this.state.try_again_label : this.state.continue_label,
	                        responseData: Object.assign({}, this.state.responseData, {
	                            responses: dataHelper.immutablePush(responses, response),
	                            latestResponse: optionDetails.option
	                        })
	                    });
	                }
	            } else if (localStorage.tracking_type === appConstants.TRACKING_TYPE_XAPI || localStorage.tracking_type === appConstants.TRACKING_TYPE_BLENDED_XAPI_SCORM_1_2) {
	                var responseObj = Object.assign({}, this.state.xApiResponseObj);
	
	                if (appHelper.isDefined(responseObj.statement)) {
	                    var responseString = responseObj.statement.result.response;
	                    var choices = responseObj.statement.object.definition.choices;
	                    var optionResponse = xAPIHelper.getChoiceByDescription(choices, responseString);
	                    //let optionDetails = appHelper.getOptionByLabelName(responseString, this.state.screenObject.options);
	                    var _optionDetails = appHelper.getOptionParentDetails(parseInt(optionResponse.id));
	                    if (appHelper.isDefined(_optionDetails)) {
	                        var _showResponse = false;
	                        var _responses = [];
	                        var _response = {
	                            selectedOption: _optionDetails.option
	                        };
	
	                        if (appHelper.isDefined(_optionDetails.option.dialogs) && _optionDetails.option.dialogs.length > 0) {
	                            _showResponse = true;
	                        }
	
	                        var _hasBadges = appHelper.isDefined(_optionDetails.option.badges) && _optionDetails.option.badges.length > 0;
	                        this.setState({
	                            showProgression: !this.props.callbacks.hasNextObject(this.props.index) && _optionDetails.option.enable_feedback,
	                            hasBadges: _hasBadges,
	                            badgesCollected: _hasBadges,
	                            handleCompletion: true,
	                            propsUpdated: false,
	                            showOptions: true,
	                            questionChecked: true,
	                            currentlyChecked: true,
	                            showCheckBtn: false,
	                            options: dataHelper.immutableSplice(this.state.options, 0, this.state.options.length, _optionDetails.option),
	                            showResponse: _showResponse,
	                            progression_label: _response.selectedOption.progression === objectConstants.OBJECT_PROGRESSION_TRY_AGAIN ? this.state.try_again_label : this.state.continue_label,
	                            responseData: Object.assign({}, this.state.responseData, {
	                                responses: dataHelper.immutablePush(_responses, _response),
	                                latestResponse: _optionDetails.option
	                            })
	                        });
	                    } else {
	                        this.setState({
	                            reviewMode: false,
	                            propsUpdated: true,
	                            responseData: Object.assign({}, this.state.responseData, {
	                                currentStatus: objectConstants.STATUS_NOT_STARTED,
	                                displayState: objectConstants.OBJECT_DISPLAY_STATE_INITIAL
	                            })
	                        });
	                    }
	                } else {
	                    this.setState({ renderQuestions: true });
	                }
	            } else {
	                this.setState({
	                    reviewMode: false,
	                    propsUpdated: true,
	                    responseData: Object.assign({}, this.state.responseData, {
	                        currentStatus: objectConstants.STATUS_NOT_STARTED,
	                        displayState: objectConstants.OBJECT_DISPLAY_STATE_INITIAL
	                    })
	                });
	            }
	        }
	    }, {
	        key: 'scrollToSubmitBtn',
	        value: function scrollToSubmitBtn() {
	            var submitBtn = this.refs[this.state.screenObject.asset_id + '_check'];
	            this.props.callbacks.scrollToSubmitBtn(submitBtn.offsetTop);
	        }
	    }, {
	        key: 'setCheckBtnState',
	        value: function setCheckBtnState(state) {
	
	            if (this.state.responseData.displayState !== objectConstants.OBJECT_DISPLAY_STATE_REVIEW) {
	                this.setState({ showCheckBtn: state, watchCheckBtnState: false });
	            }
	        }
	    }, {
	        key: 'onOptionRevealed',
	        value: function onOptionRevealed(option) {
	            var index = appHelper.getArrayObjectIndexByKey(this.state.revealedOptions, "option_id", option.option_id);
	            if (index === -1) {
	                this.setState({
	                    revealedOptions: dataHelper.immutablePush(this.state.revealedOptions, option),
	                    watchCheckBtnState: true
	                });
	            }
	        }
	    }, {
	        key: 'randomiseOptions',
	        value: function randomiseOptions() {
	            if (this.state.screenObject.randomise_options) {
	                var options = dataHelper.randomiseArray(this.state.options);
	                this.setState({
	                    options: options,
	                    showOptions: true,
	                    focusedOption: options[0]
	                });
	            } else {
	                this.setState({ showOptions: true });
	            }
	            this.props.callbacks.scrollToTop();
	        }
	    }, {
	        key: 'renderOptions',
	        value: function renderOptions() {
	            if (!this.state.showOptions && this.state.responseData.currentStatus === objectConstants.STATUS_NOT_STARTED) {
	                this.setState({ showOptions: true });
	            }
	
	            this.props.callbacks.scrollToTop();
	        }
	    }, {
	        key: 'onOptionClick',
	        value: function onOptionClick(event) {
	            // console.log(this.state.responseData.latestResponse)
	            var response = {
	                selectedOption: appHelper.getObjectOption(this.state.screenObject.options, event.target.value)
	            };
	            // console.log(response.selectedOption);
	            this.setState({
	                responseData: Object.assign({}, this.state.responseData, {
	                    //responses: dataHelper.immutablePush(this.state.responseData.responses, response),
	                    latestResponse: Object.assign({}, response.selectedOption)
	                }),
	                enableCheckBtn: true
	            });
	            this.scrollToSubmitBtn();
	        }
	    }, {
	        key: 'checkAnswers',
	        value: function checkAnswers() {
	            var response = {
	                selectedOption: this.state.responseData.latestResponse
	            };
	            var showResponse = false;
	            if (appHelper.isDefined(this.state.responseData.latestResponse.dialogs) && this.state.responseData.latestResponse.dialogs.length > 0) {
	                showResponse = true;
	            }
	            var enable_feedback = this.state.responseData.latestResponse.enable_feedback;
	            var hasBadges = appHelper.isDefined(this.state.responseData.latestResponse.badges) && this.state.responseData.latestResponse.badges.length > 0 && !enable_feedback && !showResponse;
	            var progressionType = appHelper.isDefined(this.state.responseData.latestResponse.progression_type) ? this.state.responseData.latestResponse.progression_type : undefined;
	            this.setState({
	                showOptions: true,
	                responseData: Object.assign({}, this.state.responseData, {
	                    responses: dataHelper.immutablePush(this.state.responseData.responses, response),
	                    displayState: objectConstants.OBJECT_DISPLAY_STATE_ANSWERED
	                    //latestResponse: Object.assign({}, this.state.responseData.latestResponse)
	                }),
	                showFeedback: enable_feedback && !showResponse,
	                focusOnFeedback: enable_feedback && !showResponse,
	                skipFeedback: !enable_feedback && this.state.responseData.latestResponse.progression !== objectConstants.OBJECT_PROGRESSION_TRY_AGAIN && !showResponse,
	                showProgression: !enable_feedback && this.state.responseData.latestResponse.progression === objectConstants.OBJECT_PROGRESSION_TRY_AGAIN || !enable_feedback && this.state.responseData.latestResponse.progression !== objectConstants.OBJECT_PROGRESSION_TRY_AGAIN && !this.props.callbacks.hasNextObject(this.props.index) && progressionType !== objectConstants.GO_TO_TYPE_SCREEN && !showResponse,
	                progression_label: this.state.responseData.latestResponse.progression === objectConstants.OBJECT_PROGRESSION_TRY_AGAIN ? this.state.try_again_label : this.state.continue_label,
	                showResponse: showResponse,
	                hasBadges: hasBadges,
	                questionChecked: true,
	                currentlyChecked: true,
	                showCheckBtn: false,
	                enableCheckBtn: false,
	
	                checkPostXAPIResponse: true
	            });
	        }
	    }, {
	        key: 'showFeedback',
	        value: function showFeedback() {
	            // console.log("showFeedback");
	            if (this.state.responseData.currentStatus !== objectConstants.STATUS_COMPLETE) {
	                this.setState({ showFeedback: true, showOptions: false, focusOnFeedback: true });
	            }
	        }
	    }, {
	        key: 'handleResponse',
	        value: function handleResponse() {
	            this.setState({ hideFeedback: false });
	            var showResponse = false;
	            if (appHelper.isDefined(this.state.responseData.latestResponse.dialogs) && this.state.responseData.latestResponse.dialogs.length > 0) {
	                showResponse = true;
	            }
	
	            var latestResponseFeedbackLocale = appHelper.getLocalData(this.state.responseData.latestResponse);
	
	            var progressionRule = this.state.responseData.latestResponse.progression;
	            if (progressionRule === objectConstants.OBJECT_PROGRESSION_TRY_AGAIN) {
	                this.reattempt();
	            } else {
	                var _showResponse2 = false;
	                if (appHelper.isDefined(this.state.responseData.latestResponse.dialogs) && this.state.responseData.latestResponse.dialogs.length > 0) {
	                    _showResponse2 = true;
	                }
	                this.setState({
	                    showFeedback: !this.props.callbacks.hasNextObject(this.props.index) && this.hasFeedbackToShow(),
	                    focusOnFeedback: !this.props.callbacks.hasNextObject(this.props.index) && this.hasFeedbackToShow(),
	                    showOptions: true,
	                    showResponse: _showResponse2,
	                    options: dataHelper.immutableSplice(this.state.options, 0, this.state.options.length, this.state.responseData.latestResponse),
	                    responseData: Object.assign({}, this.state.responseData, {
	                        currentStatus: objectConstants.STATUS_COMPLETE,
	                        displayState: objectConstants.OBJECT_DISPLAY_STATE_REVIEW
	
	                    })
	                });
	
	                this.handleProgression();
	            }
	        }
	    }, {
	        key: 'hasFeedbackToShow',
	        value: function hasFeedbackToShow() {
	            var enable_feedback = this.state.responseData.latestResponse.enable_feedback;
	            return enable_feedback;
	        }
	    }, {
	        key: 'handleProgression',
	        value: function handleProgression() {
	            /*l
	            let navigateToNextScreen = true;
	            this.props.callbacks.onObjectComplete(progressionRule, this.state.screenObject.asset_id, this.state.responseData.latestResponse, navigateToNextScreen);*/
	
	            this.setState({ handleCompletion: false });
	            if (!this.state.progressionHandled) {
	                this.setState({ progressionHandled: true });
	                var enable_feedback = this.state.responseData.latestResponse.enable_feedback;
	                var progressionRule = this.state.responseData.latestResponse.progression;
	                var progressionType = appHelper.isDefined(this.state.responseData.latestResponse.progression_type) ? this.state.responseData.latestResponse.progression_type : undefined;
	                var progressionGoToId = appHelper.isDefined(this.state.responseData.latestResponse.progression_goto_id) ? this.state.responseData.latestResponse.progression_goto_id : undefined;
	                var completionData = {
	                    progression: progressionRule,
	                    asset_id: this.state.screenObject.asset_id,
	                    status: objectConstants.STATUS_COMPLETE,
	                    asset_type_code: this.state.screenObject.asset_type_code,
	                    navigateToNextScreen: progressionType !== objectConstants.GO_TO_TYPE_SCREEN,
	                    progressionType: progressionType,
	                    progressionGoToId: progressionGoToId,
	                    index: this.props.index
	                };
	
	                this.props.callbacks.onObjectComplete(completionData);
	            }
	        }
	    }, {
	        key: 'reattempt',
	        value: function reattempt() {
	
	            this.setState({
	                showFeedback: false,
	                enableCheckBtn: false,
	                showCheckBtn: true,
	                revealedOptions: dataHelper.immutableSplice(this.state.revealedOptions, 0, this.state.revealedOptions.length),
	                showOptions: true,
	                showResponse: false,
	                currentlyChecked: false,
	                focusedOption: this.state.options[0],
	                updateFocus: true,
	                responseData: Object.assign({}, this.state.responseData, {
	                    currentAttempt: this.state.responseData.currentAttempt + 1,
	                    currentStatus: objectConstants.STATUS_ATTEMPTED,
	                    displayState: objectConstants.OBJECT_DISPLAY_STATE_RETRY,
	                    latestResponse: Object.assign({}, {})
	
	                })
	            });
	        }
	
	        //REVEW POPUP
	
	    }, {
	        key: 'onReviewObject',
	        value: function onReviewObject(sourceId) {
	
	            if (this.hasFeedbackToShow()) {
	                var config = Object.assign({}, _dialogModels.MULTIPLE_CHOICE_REVIEW_CONFIG, {
	                    title: this.state.locale.label,
	                    sourceId: sourceId
	                });
	                //locale.title
	
	                for (var i = 0; i < config.childComponents.length; i++) {
	                    var child = config.childComponents[i];
	                    child.componentProps = Object.assign({}, {
	                        screenObject: this.state.screenObject,
	                        responseData: Object.assign({}, this.state.responseData, {
	                            displayState: objectConstants.OBJECT_DISPLAY_STATE_REVIEW
	                        }),
	                        callbacks: this.props.callbacks
	                    });
	                }
	                this.props.actions.setNewDialog(config);
	            }
	        }
	    }, {
	        key: 'getClass',
	        value: function getClass() {
	            return this.state.responseData.displayState === objectConstants.OBJECT_DISPLAY_STATE_REVIEW || this.state.responseData.displayState === objectConstants.OBJECT_DISPLAY_STATE_ANSWERED ? "multiple-choice-option-list" : "grid-choice-option-list";
	        }
	    }, {
	        key: 'handleResponseComplete',
	        value: function handleResponseComplete() {
	            var enable_feedback = this.state.responseData.latestResponse.enable_feedback;
	            var progressionType = appHelper.isDefined(this.state.responseData.latestResponse.progression_type) ? this.state.responseData.latestResponse.progression_type : undefined;
	
	            this.setState({
	                showFeedback: enable_feedback && this.state.responseData.displayState !== objectConstants.OBJECT_DISPLAY_STATE_REVIEW,
	                focusOnFeedback: enable_feedback && this.state.responseData.displayState !== objectConstants.OBJECT_DISPLAY_STATE_REVIEW,
	                hasBadges: appHelper.isDefined(this.state.responseData.latestResponse.badges) && this.state.responseData.latestResponse.badges.length > 0 && !enable_feedback,
	                skipFeedback: !enable_feedback && this.state.responseData.latestResponse.progression !== objectConstants.OBJECT_PROGRESSION_TRY_AGAIN,
	                showProgression: !enable_feedback && this.state.responseData.latestResponse.progression === objectConstants.OBJECT_PROGRESSION_TRY_AGAIN || !enable_feedback && this.state.responseData.latestResponse.progression !== objectConstants.OBJECT_PROGRESSION_TRY_AGAIN && !this.props.callbacks.hasNextObject(this.props.index) && progressionType !== objectConstants.GO_TO_TYPE_SCREEN
	
	            });
	        }
	    }, {
	        key: 'getStatusClass',
	        value: function getStatusClass() {
	            return this.state.responseData.displayState === objectConstants.OBJECT_DISPLAY_STATE_REVIEW && this.props.contentData.experience.include_explore_feedback && this.hasFeedbackToShow() ? "complete" : "";
	        }
	    }, {
	        key: 'getTabIndex',
	        value: function getTabIndex() {
	            return this.state.responseData.displayState === objectConstants.OBJECT_DISPLAY_STATE_REVIEW && this.props.contentData.experience.include_explore_feedback ? 0 : -1;
	        }
	    }, {
	        key: 'onPanelClick',
	        value: function onPanelClick() {
	
	            if (this.state.responseData.displayState === objectConstants.OBJECT_DISPLAY_STATE_REVIEW && this.props.contentData.experience.include_explore_feedback && this.hasFeedbackToShow()) {
	                this.onReviewObject('question_wrapper_' + this.state.screenObject.asset_id);
	            }
	        }
	    }, {
	        key: 'onKeyboardPanelClick',
	        value: function onKeyboardPanelClick(event) {
	            if (event.which === keyboardConstants.ENTER_KEY || event.which === keyboardConstants.SPACEBAR_KEY) {
	                event.preventDefault();
	                if (this.state.responseData.displayState === objectConstants.OBJECT_DISPLAY_STATE_REVIEW && this.props.contentData.experience.include_explore_feedback) {
	                    this.onReviewObject('question_wrapper_' + this.state.screenObject.asset_id);
	                }
	            }
	        }
	    }, {
	        key: 'getImagePath',
	        value: function getImagePath(image) {
	            if (appConstants.DEVELOPMENT_MODE) {
	                if (appHelper.isDefined(image) && image.length > 0) {
	                    return __webpack_require__(16)("./" + image);
	                }
	            } else {
	                return image;
	            }
	        }
	    }, {
	        key: 'setFocusedOption',
	        value: function setFocusedOption() {
	            this.setState({ focusedOption: Object.assign({}, this.state.options[0]) });
	        }
	    }, {
	        key: 'clearFocusedOption',
	        value: function clearFocusedOption() {
	            this.setState({ focusedOption: Object.assign({}, {}) });
	        }
	    }, {
	        key: 'getPrevOption',
	        value: function getPrevOption() {
	            var optionIndex = appHelper.getArrayObjectIndexByKey(this.state.options, "option_id", this.state.focusedOption.option_id);
	            var nextOption = this.state.options[optionIndex - 1];
	            if (optionIndex <= 0) {
	                nextOption = this.state.options[this.state.options.length - 1];
	            }
	
	            this.setState({ focusedOption: Object.assign({}, nextOption), updateFocus: true });
	        }
	    }, {
	        key: 'getNextOption',
	        value: function getNextOption() {
	            var optionIndex = appHelper.getArrayObjectIndexByKey(this.state.options, "option_id", this.state.focusedOption.option_id);
	            var nextOption = this.state.options[optionIndex + 1];
	            if (optionIndex === this.state.options.length - 1) {
	                nextOption = this.state.options[0];
	            }
	            this.setState({ focusedOption: Object.assign({}, nextOption), updateFocus: true });
	        }
	    }, {
	        key: 'allowKeyAccessibility',
	        value: function allowKeyAccessibility() {
	            var responseData = this.state.responseData;
	            //if (responseData.displayState === objectConstants.OBJECT_DISPLAY_STATE_INITIAL) {
	            if (responseData.currentAttempt === responseData.responses.length) {
	                return false;
	            } else {
	                for (var i = 0; i < this.state.responseData.responses.length; i++) {
	                    var response = this.state.responseData.responses[i];
	                    if (response.selectedOption.option_id === this.state.focusedOption.option_id) {
	                        return false;
	                    }
	                }
	                return true;
	            }
	        }
	    }, {
	        key: 'setKeyboardAccessibility',
	        value: function setKeyboardAccessibility(event) {
	            if (event.which === keyboardConstants.ENTER_KEY || event.which === keyboardConstants.SPACEBAR_KEY) {
	                event.preventDefault();
	
	                if (this.allowKeyAccessibility()) {
	                    this.onOptionClick({ target: { value: this.state.focusedOption.option_id } });
	                } else {
	                    var responseData = this.state.responseData;
	                    if (responseData.displayState === objectConstants.OBJECT_DISPLAY_STATE_ANSWERED || responseData.displayState === objectConstants.OBJECT_DISPLAY_STATE_REVIEW && this.props.contentData.experience.include_explore_feedback) {
	                        this.onReviewObject('option_' + this.state.focusedOption.option_id);
	                    }
	                }
	            }
	
	            if (event.which === keyboardConstants.ARROW_LEFT_KEY) {
	                event.preventDefault();
	                this.getPrevOption();
	            }
	
	            if (event.which === keyboardConstants.ARROW_RIGHT_KEY) {
	                event.preventDefault();
	                this.getNextOption();
	            }
	
	            if (event.which === keyboardConstants.ARROW_UP_KEY) {
	                event.preventDefault();
	                this.getPrevOption();
	            }
	
	            if (event.which === keyboardConstants.ARROW_DOWN_KEY) {
	                event.preventDefault();
	                this.getNextOption();
	            }
	        }
	    }, {
	        key: 'setOptionCallbacks',
	        value: function setOptionCallbacks() {
	            this.setState({
	                optionCallbacks: Object.assign({}, this.state.optionCallbacks, {
	                    setKeyboardAccessibility: this.setKeyboardAccessibility
	                })
	            });
	        }
	    }, {
	        key: 'setOptionFocus',
	        value: function setOptionFocus() {
	
	            var focusEl = document.getElementById('option_' + this.state.focusedOption.option_id);
	            focusEl.focus();
	            this.setState({ updateFocus: false });
	        }
	    }, {
	        key: 'enableProgression',
	        value: function enableProgression(progression_label) {
	            var hasBadges = appHelper.isDefined(this.state.responseData.latestResponse.badges) && this.state.responseData.latestResponse.badges.length > 0;
	            var progressionType = appHelper.isDefined(this.state.responseData.latestResponse.progression_type) ? this.state.responseData.latestResponse.progression_type : undefined;
	            var showProgression = !hasBadges;
	
	            if (!this.props.callbacks.hasNextObject(this.props.index)) {
	                showProgression = !hasBadges && progressionType !== objectConstants.GO_TO_TYPE_SCREEN;
	            }
	            this.setState({
	                showProgression: showProgression,
	                hasBadges: hasBadges,
	                progression_label: this.state.responseData.latestResponse.progression === objectConstants.OBJECT_PROGRESSION_TRY_AGAIN ? this.state.try_again_label : this.state.continue_label
	            });
	            this.props.callbacks.scrollToContinue();
	        }
	    }, {
	        key: 'onProgressionClicked',
	        value: function onProgressionClicked() {
	            this.setState({
	                showProgression: false,
	                hideFeedback: this.props.callbacks.hasNextObject(this.props.index) && this.state.responseData.latestResponse.progression !== objectConstants.OBJECT_PROGRESSION_TRY_AGAIN
	            });
	
	            var enable_feedback = this.state.responseData.latestResponse.enable_feedback;
	
	            if (!this.props.callbacks.hasNextObject(this.props.index) && this.state.responseData.latestResponse.progression !== objectConstants.OBJECT_PROGRESSION_TRY_AGAIN) {
	                this.props.callbacks.navigateToNextScreen();
	            } else if (this.state.responseData.latestResponse.progression === objectConstants.OBJECT_PROGRESSION_TRY_AGAIN) {
	                this.reattempt();
	            }
	        }
	    }, {
	        key: 'onBadgeCollected',
	        value: function onBadgeCollected() {
	            this.setState({ badgesCollected: true });
	
	            if (!this.props.callbacks.hasNextObject(this.props.index)) {
	                this.setState({
	                    showProgression: true,
	                    progression_label: this.state.responseData.latestResponse.progression === objectConstants.OBJECT_PROGRESSION_TRY_AGAIN ? this.state.try_again_label : this.state.continue_label
	                });
	                this.props.callbacks.scrollToContinue();
	            }
	            this.handleResponse();
	
	            //this.hide();
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this3 = this;
	
	            return _react2.default.createElement(
	                'div',
	                { className: 'learner-action' },
	                _react2.default.createElement(
	                    'p',
	                    { className: 'hidden-el' },
	                    this.state.multiple_choice_single_answer_question_label
	                ),
	                appHelper.isDefined(this.props.characterPose) && appHelper.isDefined(this.props.characterPose.src) && this.props.characterPose.src.length > 0 ? _react2.default.createElement(
	                    'div',
	                    { className: 'content-character-expression' },
	                    _react2.default.createElement('img', { src: this.getImagePath(this.props.characterPose.src), alt: '' })
	                ) : null,
	                _react2.default.createElement(
	                    'div',
	                    { className: 'question-wrapper ' + this.getStatusClass(), tabIndex: this.getTabIndex(), id: 'question_wrapper_' + this.state.screenObject.asset_id,
	                        role: 'presentation', onClick: this.onPanelClick, onKeyDown: this.onKeyboardPanelClick },
	                    this.state.screenObject.prompt_type !== objectConstants.PROMPT_TYPE_SHOW_NO_PROMPT && this.state.screenObject.show_prompt ? this.state.screenObject.prompt_type === objectConstants.PROMPT_TYPE_DIALOG_PROMPT ? _react2.default.createElement(
	                        'div',
	                        { className: 'object-container' },
	                        _react2.default.createElement(_DialogPrompt2.default, { character_name: this.state.character_name,
	                            id: this.state.screenObject.asset_id, locale: this.state.locale,
	                            show_title: this.state.screenObject.show_title,
	                            onComplete: this.onPromptRevealed })
	                    ) : _react2.default.createElement(_Prompt2.default, { id: this.state.screenObject.asset_id, locale: this.state.locale,
	                        show_title: this.state.screenObject.show_title,
	                        onComplete: this.onPromptRevealed }) : null,
	                    this.state.showOptions ? _react2.default.createElement(
	                        'div',
	                        { className: this.getClass() + ' theme-active',
	                            ref: this.state.screenObject.asset_id + '_questionOptions',
	                            role: 'radiogroup' },
	                        this.state.options.map(function (option) {
	                            return _react2.default.createElement(_GridChoiceOption2.default, { key: option.option_id, option: option,
	                                asset_id: _this3.state.screenObject.asset_id,
	                                questionChecked: _this3.state.questionChecked,
	                                currentlyChecked: _this3.state.currentlyChecked,
	                                onOptionClick: _this3.onOptionClick,
	                                responseData: _this3.state.responseData,
	                                onAttemptComplete: _this3.showFeedback,
	                                onOptionRevealed: _this3.onOptionRevealed,
	                                onReviewObject: _this3.onReviewObject,
	                                focusedOption: _this3.state.focusedOption,
	                                optionCallbacks: _this3.state.optionCallbacks,
	                                index: appHelper.getObjectOptionIndex(_this3.state.screenObject.options, option.option_id),
	                                showFeedback: appHelper.isDefined(_this3.state.responseData.latestResponse.enable_feedback) && _this3.state.responseData.latestResponse.enable_feedback
	                            });
	                        })
	                    ) : null,
	                    this.state.showCheckBtn ? _react2.default.createElement(
	                        'div',
	                        { ref: this.state.screenObject.asset_id + '_check' },
	                        _react2.default.createElement(_Button2.default, { label: this.state.submit_label,
	                            id: this.state.screenObject.asset_id + '_check_button',
	                            isDisabled: !this.state.enableCheckBtn,
	                            onRevealed: this.props.callbacks.scrollToTop,
	                            onClick: this.checkAnswers
	                        })
	                    ) : null,
	                    this.state.showResponse || this.state.showFeedback ? _react2.default.createElement(
	                        'div',
	                        { ref: 'feedback_wrapper_' + this.state.screenObject.asset_id,
	                            id: 'feedback_wrapper_' + this.state.screenObject.asset_id,
	                            role: 'link',
	                            tabIndex: 0,
	                            className: 'feedback-focus' },
	                        this.state.showResponse ? _react2.default.createElement(_ChildConversationDialog2.default, { asset_id: this.state.screenObject.asset_id,
	                            option_id: this.state.responseData.latestResponse.option_id,
	                            dialogs: this.state.responseData.latestResponse.dialogs,
	                            callbacks: this.props.callbacks,
	                            onComplete: this.handleResponseComplete }) : null,
	                        this.state.showFeedback ? _react2.default.createElement(_SingleAnswerFeedback2.default, { screenObject: this.state.screenObject,
	                            option: this.state.responseData.latestResponse,
	                            options: this.state.screenObject.options,
	                            asset_id: this.state.screenObject.asset_id,
	                            responseData: this.state.responseData,
	                            onComplete: this.handleResponse,
	                            onShowReview: this.onReviewObject,
	                            callbacks: this.props.callbacks,
	                            onEnableProgression: this.enableProgression,
	                            hideFeedback: this.state.hideFeedback,
	                            index: this.props.index,
	                            showImages: this.state.show_images_in_feedback }) : null
	                    ) : null,
	                    (this.state.showResponse || this.state.showFeedback) && this.state.hasBadges ? _react2.default.createElement('br', null) : null,
	                    this.state.hasBadges ? _react2.default.createElement(
	                        'div',
	                        { className: 'badge-wrapper' },
	                        this.state.responseData.latestResponse.badges.map(function (badge) {
	                            return _react2.default.createElement(_BadgeCollect2.default, { key: badge.badge_id, badge_id: badge.badge_id,
	                                bite_id: _this3.props.callbacks.getBiteId(),
	                                asset_id: _this3.state.screenObject.asset_id,
	                                onCollected: _this3.onBadgeCollected,
	                                animate: _this3.state.animateBadge
	                            });
	                        })
	                    ) : null
	                ),
	                this.state.showProgression ? _react2.default.createElement(_Button2.default, { label: this.state.progression_label, id: this.state.screenObject.asset_id + '_button', ref: this.state.screenObject.asset_id + '_button',
	                    onClick: this.onProgressionClicked }) : null
	            );
	        }
	    }]);
	
	    return GridChoice;
	}(_react2.default.Component);
	
	GridChoice.propTypes = {
	    screenObject: _propTypes2.default.object.isRequired,
	    callbacks: _propTypes2.default.object.isRequired,
	    index: _propTypes2.default.number,
	    characterPose: _propTypes2.default.object,
	    contentData: _propTypes2.default.object.isRequired,
	    trackingData: _propTypes2.default.object.isRequired,
	    userData: _propTypes2.default.object.isRequired,
	    lang: _propTypes2.default.string.isRequired,
	    actions: _propTypes2.default.object.isRequired
	};
	
	GridChoice.contextTypes = {
	    router: _propTypes2.default.object
	};
	
	function mapStateToProps(state) {
	    var lang = state.userData.lang;
	    return {
	        lang: lang,
	        contentData: state.contentData,
	        trackingData: state.trackingData,
	        userData: state.userData
	
	    };
	}
	
	function mapDispatchToProps(dispatch) {
	    return {
	        actions: (0, _redux.bindActionCreators)(Object.assign({}, appDataActions, trackingDataActions, dialogPopupActions), dispatch)
	    };
	}
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(GridChoice);

/***/ },
/* 498 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(5);
	
	var _redux = __webpack_require__(4);
	
	var _SecondaryImage = __webpack_require__(66);
	
	var _SecondaryImage2 = _interopRequireDefault(_SecondaryImage);
	
	var _SecondaryLibraryImage = __webpack_require__(67);
	
	var _SecondaryLibraryImage2 = _interopRequireDefault(_SecondaryLibraryImage);
	
	var _appDataActions = __webpack_require__(12);
	
	var appDataActions = _interopRequireWildcard(_appDataActions);
	
	var _trackingDataActions = __webpack_require__(7);
	
	var trackingDataActions = _interopRequireWildcard(_trackingDataActions);
	
	var _dialogPopupActions = __webpack_require__(19);
	
	var dialogPopupActions = _interopRequireWildcard(_dialogPopupActions);
	
	var _appHelper = __webpack_require__(3);
	
	var appHelper = _interopRequireWildcard(_appHelper);
	
	var _dataHelper = __webpack_require__(11);
	
	var dataHelper = _interopRequireWildcard(_dataHelper);
	
	var _userDataHelper = __webpack_require__(15);
	
	var userDataHelper = _interopRequireWildcard(_userDataHelper);
	
	var _objectConstants = __webpack_require__(9);
	
	var objectConstants = _interopRequireWildcard(_objectConstants);
	
	var _assetConstants = __webpack_require__(33);
	
	var assetConstants = _interopRequireWildcard(_assetConstants);
	
	var _appConstants = __webpack_require__(13);
	
	var appConstants = _interopRequireWildcard(_appConstants);
	
	var _gsap = __webpack_require__(8);
	
	var _keyboardConstants = __webpack_require__(14);
	
	var keyboardConstants = _interopRequireWildcard(_keyboardConstants);
	
	var _gsapReactPlugin = __webpack_require__(10);
	
	var _gsapReactPlugin2 = _interopRequireDefault(_gsapReactPlugin);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	//import {SINGLE_ANSWER_REVIEW_CONFIG} from '../../../../models/dialogModels';
	
	
	var GridChoiceOption = function (_React$Component) {
	    _inherits(GridChoiceOption, _React$Component);
	
	    function GridChoiceOption(props, context) {
	        _classCallCheck(this, GridChoiceOption);
	
	        var _this = _possibleConstructorReturn(this, (GridChoiceOption.__proto__ || Object.getPrototypeOf(GridChoiceOption)).call(this, props, context));
	
	        _this.state = {
	            lang: _this.props.lang,
	            option: _this.props.option,
	            locale: appHelper.getLocalData(_this.props.option),
	            responseData: _this.props.responseData,
	            optionAsset: {
	                src: ""
	            },
	            assetData: {},
	            focusedOption: _this.props.focusedOption,
	            focusedClass: "not-focused"
	        };
	        _this.getAssets = _this.getAssets.bind(_this);
	        _this.getAssetType = _this.getAssetType.bind(_this);
	        _this.hideOption = _this.hideOption.bind(_this);
	        _this.showOption = _this.showOption.bind(_this);
	        _this.removeOption = _this.removeOption.bind(_this);
	        _this.onOptionHidden = _this.onOptionHidden.bind(_this);
	        _this.getDisabledState = _this.getDisabledState.bind(_this);
	        _this.getOptionClass = _this.getOptionClass.bind(_this);
	        _this.handleOptionVisibility = _this.handleOptionVisibility.bind(_this);
	        _this.onOptionRevealed = _this.onOptionRevealed.bind(_this);
	        _this.getImagePath = _this.getImagePath.bind(_this);
	        _this.renderOption = _this.renderOption.bind(_this);
	        _this.getCheckedState = _this.getCheckedState.bind(_this);
	        _this.getIsChecked = _this.getIsChecked.bind(_this);
	        _this.getIsDisabled = _this.getIsDisabled.bind(_this);
	        _this.setFocus = _this.setFocus.bind(_this);
	        _this.setBlur = _this.setBlur.bind(_this);
	        _this.getScreenReaderOptionClass = _this.getScreenReaderOptionClass.bind(_this);
	        return _this;
	    }
	
	    _createClass(GridChoiceOption, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            this.getAssets();
	            this.showOption(1, 0);
	        }
	    }, {
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(nextProps) {
	            if (this.state.responseData !== nextProps.responseData) {
	                this.setState({ responseData: nextProps.responseData });
	            }
	
	            if (this.state.focusedOption !== nextProps.focusedOption) {
	                this.setState({ focusedOption: Object.assign({}, nextProps.focusedOption) });
	            }
	
	            if (this.state.lang !== nextProps.lang) {
	                this.setState({
	                    lang: nextProps.lang,
	                    locale: appHelper.getLocalData(this.state.option)
	                });
	            }
	        }
	    }, {
	        key: 'componentDidUpdate',
	        value: function componentDidUpdate() {}
	    }, {
	        key: 'getAssets',
	        value: function getAssets() {
	            var screenAsset = {};
	            var assetData = {};
	
	            if (appHelper.isDefined(this.state.option.image)) {
	                screenAsset = this.getAssetType(this.state.option.image);
	                assetData = Object.assign({}, this.state.option.image);
	            }
	
	            this.setState({
	                screenAsset: Object.assign({}, screenAsset),
	                assetData: Object.assign({}, assetData)
	            });
	        }
	    }, {
	        key: 'getAssetType',
	        value: function getAssetType(asset) {
	            /*
	             screenCharacter = appHelper.getCharacterAsset(this.state.screen.assets.left);
	                //console.log(screenCharacter);
	                characterAsset = appHelper.getCharacterPose(screenCharacter, this.state.screen.assets.left);
	            * */
	            var returnAsset = {};
	            if (asset.constant === assetConstants.ASSET_TYPE_ICON) {
	                returnAsset = appHelper.getIconAsset(asset);
	            } else if (asset.constant === assetConstants.ASSET_TYPE_IMAGE) {
	                returnAsset = appHelper.getImageAsset(asset);
	            } else if (asset.constant === assetConstants.ASSET_TYPE_LIBRARY_IMAGE) {
	                returnAsset = appHelper.getLibraryImageAsset(asset);
	            } else if (asset.constant === assetConstants.ASSET_TYPE_ID_CHARACTER) {
	                var characterAsset = appHelper.getCharacterAsset(asset);
	                returnAsset = appHelper.getCharacterPose(characterAsset, asset);
	            }
	
	            returnAsset = appHelper.isDefined(returnAsset.locale) ? appHelper.getLocalData(returnAsset) : returnAsset;
	
	            if (appHelper.isDefined(asset.constant) && !appHelper.isDefined(returnAsset.type)) {
	                returnAsset = Object.assign({}, returnAsset, {
	                    type: asset.constant
	                });
	            }
	            return returnAsset;
	        }
	    }, {
	        key: 'getImagePath',
	        value: function getImagePath(image) {
	            if (appConstants.DEVELOPMENT_MODE) {
	                if (appHelper.isDefined(image) && image.length > 0) {
	                    return __webpack_require__(16)("./" + image);
	                }
	            } else {
	                return image;
	            }
	        }
	    }, {
	        key: 'getOptionClass',
	        value: function getOptionClass() {
	            var responseData = this.state.responseData;
	            var latestResponse = appHelper.getLastItemOfArray(responseData.responses);
	            if (this.props.questionChecked) {
	
	                if (responseData.displayState !== objectConstants.OBJECT_DISPLAY_STATE_REVIEW) {
	                    if (responseData.currentAttempt === responseData.responses.length && latestResponse.selectedOption.option_id === this.state.option.option_id) {
	                        if (responseData.displayState !== objectConstants.OBJECT_DISPLAY_STATE_ANSWERED) {
	                            return 'active ' + this.state.option.result;
	                        } else if (responseData.displayState === objectConstants.OBJECT_DISPLAY_STATE_ANSWERED && this.props.showFeedback) {
	                            return 'selected ' + this.state.option.result;
	                        } else if (responseData.displayState === objectConstants.OBJECT_DISPLAY_STATE_ANSWERED && !this.props.showFeedback) {
	                            return 'selected inactive-answered ' + this.state.option.result;
	                        }
	                    } else {
	                        for (var i = 0; i < this.state.responseData.responses.length; i++) {
	                            var response = this.state.responseData.responses[i];
	                            if (response.selectedOption.option_id === this.state.option.option_id) {
	                                return 'show-answer ' + this.state.option.result;
	                            }
	                        }
	                    }
	                } else if (responseData.displayState === objectConstants.OBJECT_DISPLAY_STATE_REVIEW) {
	                    if (responseData.currentAttempt === responseData.responses.length && latestResponse.selectedOption.option_id === this.state.option.option_id && this.props.showFeedback) {
	                        return 'selected answered ' + this.state.option.result;
	                    } else if (responseData.currentAttempt === responseData.responses.length && latestResponse.selectedOption.option_id === this.state.option.option_id && !this.props.showFeedback) {
	                        return 'selected inactive-answered ' + this.state.option.result;
	                    } else {
	                        return 'review ' + this.state.option.result;
	                    }
	                }
	            }
	
	            if (appHelper.isDefined(responseData.latestResponse) && responseData.latestResponse.option_id === this.state.option.option_id) {
	                return "checked";
	            }
	
	            return "";
	        }
	    }, {
	        key: 'getScreenReaderOptionClass',
	        value: function getScreenReaderOptionClass() {
	            var responseData = this.state.responseData;
	            var latestResponse = appHelper.getLastItemOfArray(responseData.responses);
	            if (this.props.questionChecked) {
	
	                if (responseData.displayState !== objectConstants.OBJECT_DISPLAY_STATE_REVIEW) {
	                    if (responseData.currentAttempt === responseData.responses.length && latestResponse.selectedOption.option_id === this.state.option.option_id) {
	                        if (responseData.displayState !== objectConstants.OBJECT_DISPLAY_STATE_ANSWERED) {
	                            return "";
	                        } else if (responseData.displayState === objectConstants.OBJECT_DISPLAY_STATE_ANSWERED && this.props.showFeedback) {
	                            return appHelper.getOptionResultString(this.state.option.result, false);
	                        } else if (responseData.displayState === objectConstants.OBJECT_DISPLAY_STATE_ANSWERED && !this.props.showFeedback) {
	                            return appHelper.getOptionResultString(this.state.option.result, false);
	                        }
	                    } else {
	                        for (var i = 0; i < this.state.responseData.responses.length; i++) {
	                            var response = this.state.responseData.responses[i];
	                            if (response.selectedOption.option_id === this.state.option.option_id) {
	                                return appHelper.getOptionResultString(this.state.option.result, true);
	                            }
	                        }
	                    }
	                } else if (responseData.displayState === objectConstants.OBJECT_DISPLAY_STATE_REVIEW) {
	                    if (responseData.currentAttempt === responseData.responses.length && latestResponse.selectedOption.option_id === this.state.option.option_id && this.props.showFeedback) {
	                        return appHelper.getOptionResultString(this.state.option.result, false);
	                    } else if (responseData.currentAttempt === responseData.responses.length && latestResponse.selectedOption.option_id === this.state.option.option_id && !this.props.showFeedback) {
	                        return appHelper.getOptionResultString(this.state.option.result, false);
	                    } else {
	                        return appHelper.getOptionResultString(this.state.option.result, false);
	                    }
	                }
	            }
	
	            return "";
	        }
	    }, {
	        key: 'renderOption',
	        value: function renderOption() {
	            var responseData = this.state.responseData;
	            var latestResponse = appHelper.getLastItemOfArray(responseData.responses);
	            if (this.props.questionChecked && this.props.currentlyChecked) {
	                if (latestResponse.selectedOption.option_id === this.state.option.option_id) {
	                    return true;
	                } else {
	                    return false;
	                }
	            } else {
	                return true;
	            }
	        }
	    }, {
	        key: 'getDisabledState',
	        value: function getDisabledState() {
	            var responseData = this.state.responseData;
	            //if (responseData.displayState === objectConstants.OBJECT_DISPLAY_STATE_INITIAL) {
	            if (responseData.currentAttempt === responseData.responses.length && this.props.questionChecked) {
	                return 'disabled';
	            } else {
	                for (var i = 0; i < this.state.responseData.responses.length; i++) {
	                    var response = this.state.responseData.responses[i];
	                    if (response.selectedOption.option_id === this.state.option.option_id && this.props.questionChecked) {
	                        return 'disabled';
	                    }
	                }
	                return null;
	            }
	        }
	    }, {
	        key: 'getCheckedState',
	        value: function getCheckedState() {
	            var responseData = this.state.responseData;
	            var latestResponse = responseData.latestResponse;
	            //console.log(`getCheckedState`,latestResponse);
	            if (appHelper.isDefined(latestResponse.option_id) && latestResponse.option_id === this.state.option.option_id) {
	                //console.log(`getCheckedState`, latestResponse);
	                return 'checked';
	            }
	        }
	    }, {
	        key: 'handleOptionVisibility',
	        value: function handleOptionVisibility() {
	            var responseData = this.state.responseData;
	            var latestResponse = appHelper.getLastItemOfArray(responseData.responses);
	            //if user responsed have been logged
	            if (typeof latestResponse !== 'undefined' && responseData.displayState !== objectConstants.OBJECT_DISPLAY_STATE_REVIEW) {
	
	                // if currentAttempt has been answered and the current option id does not equal the selected option if then hide it
	                if (responseData.currentAttempt === responseData.responses.length && latestResponse.selectedOption.option_id !== this.state.option.option_id && this.props.questionChecked) {
	                    this.hideOption();
	                    // if currentAttempt has been answered and the current option id does equal the selected option if then show it but and the corners
	                } else if (responseData.currentAttempt === responseData.responses.length && latestResponse.selectedOption.option_id === this.state.option.option_id && this.props.questionChecked) {
	                    this.roundCorners();
	                    // if currentAttempt has not been answered then render all options with no animation
	                } else if (responseData.currentAttempt > responseData.responses.length && latestResponse.selectedOption.option_id !== this.state.option.option_id && !appHelper.isDefined(responseData.latestResponse.option_id)) {
	                    this.showOption(1, 0);
	                }
	                //if in review then reveal all options
	            } else if (responseData.displayState === objectConstants.OBJECT_DISPLAY_STATE_REVIEW) {
	                this.showOption(0, 0);
	            } else if (!appHelper.isDefined(responseData.latestResponse.option_id)) {
	                //if no user response has been logged yet then animate the
	                this.showOption(1, this.props.index / 2);
	            }
	        }
	    }, {
	        key: 'hideOption',
	        value: function hideOption() {
	            var optionRef = this.refs[this.state.option.option_id];
	            _gsap.TweenLite.to(optionRef, objectConstants.MC_OPTION_DURATION, {
	                opacity: 0,
	                delay: 0.5,
	                ease: _gsap.Expo.easeOut
	            }).eventCallback("onComplete", this.scaleOptionHeight);
	        }
	    }, {
	        key: 'showOption',
	        value: function showOption(duration, delay) {
	            var optionRef = this.refs[this.state.option.option_id];
	            _gsap.TweenLite.set(optionRef, { height: "auto", opacity: 1 });
	            _gsap.TweenLite.from(optionRef, objectConstants.MC_OPTION_DURATION, {
	                height: 0,
	                opacity: 0,
	                delay: delay,
	                ease: _gsap.Expo.easeInOut
	            }).eventCallback("onComplete", this.onOptionRevealed);
	        }
	    }, {
	        key: 'onOptionRevealed',
	        value: function onOptionRevealed() {
	            this.props.onOptionRevealed(this.props.option);
	        }
	    }, {
	        key: 'onOptionHidden',
	        value: function onOptionHidden() {
	            var responseData = this.state.responseData;
	            var latestResponse = appHelper.getLastItemOfArray(responseData.responses);
	
	            //if selected option is first in the list
	            if (latestResponse.index === 0) {
	                this.removeOption();
	            } else {
	                this.scaleOptionHeight();
	            }
	        }
	    }, {
	        key: 'removeOption',
	        value: function removeOption() {
	            //this.setState({render: false});
	        }
	    }, {
	        key: 'getIsChecked',
	        value: function getIsChecked() {
	            var responseData = this.state.responseData;
	            var latestResponse = responseData.latestResponse;
	            //console.log(`getCheckedState`,latestResponse);
	            if (appHelper.isDefined(latestResponse.option_id) && latestResponse.option_id === this.state.option.option_id) {
	                //console.log(`getCheckedState`, latestResponse);
	                return true;
	            } else {
	                return false;
	            }
	        }
	    }, {
	        key: 'getIsDisabled',
	        value: function getIsDisabled() {
	            var responseData = this.state.responseData;
	            //if (responseData.displayState === objectConstants.OBJECT_DISPLAY_STATE_INITIAL) {
	            if (responseData.currentAttempt === responseData.responses.length || this.state.isAnimating) {
	                return true;
	            } else {
	                for (var i = 0; i < this.state.responseData.responses.length; i++) {
	                    var response = this.state.responseData.responses[i];
	                    if (response.selectedOption.option_id === this.state.option.option_id) {
	                        return true;
	                    }
	                }
	                return false;
	            }
	        }
	    }, {
	        key: 'setFocus',
	        value: function setFocus() {
	            this.setState({ focusedClass: "focused" });
	        }
	    }, {
	        key: 'setBlur',
	        value: function setBlur() {
	            this.setState({ focusedClass: "not-focused" });
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	
	            return this.renderOption() ? _react2.default.createElement(
	                'div',
	                { className: 'multiple-choice-option ' + this.getOptionClass() + ' ' + this.state.focusedClass,
	                    ref: this.state.option.option_id,
	                    id: 'option_' + this.state.option.option_id,
	                    onClick: this.getClickFunction,
	                    onKeyDown: this.props.optionCallbacks.setKeyboardAccessibility,
	                    onFocus: this.setFocus,
	                    onBlur: this.setBlur,
	                    role: 'radio',
	                    tabIndex: this.state.focusedOption.option_id === this.state.option.option_id ? 0 : -1,
	                    'aria-checked': this.getIsChecked(),
	                    'aria-disabled': this.getIsDisabled() },
	                _react2.default.createElement('input', { id: this.props.asset_id + '_' + this.state.option.option_id, type: 'radio',
	                    disabled: this.getDisabledState(),
	                    name: this.props.asset_id,
	                    checked: this.getCheckedState(),
	                    value: this.state.option.option_id, onChange: this.props.onOptionClick }),
	                _react2.default.createElement(
	                    'label',
	                    { htmlFor: this.props.asset_id + '_' + this.state.option.option_id },
	                    _react2.default.createElement('div', { className: 'label-text', dangerouslySetInnerHTML: { __html: this.state.locale.option } }),
	                    appHelper.isDefined(this.state.assetData.constant) ? _react2.default.createElement(
	                        'div',
	                        { className: 'image-container' },
	                        this.state.assetData.constant === assetConstants.ASSET_TYPE_IMAGE || this.state.assetData.constant === assetConstants.ASSET_TYPE_LIBRARY_IMAGE ? this.state.assetData.constant === assetConstants.ASSET_TYPE_IMAGE ? _react2.default.createElement(_SecondaryImage2.default, { screenObject: this.state.assetData }) : _react2.default.createElement(_SecondaryLibraryImage2.default, { screenObject: this.state.assetData }) : _react2.default.createElement(
	                            'div',
	                            null,
	                            _react2.default.createElement('img', { src: this.getImagePath(this.state.screenAsset.src), alt: '' })
	                        )
	                    ) : null,
	                    _react2.default.createElement(
	                        'span',
	                        { className: 'hidden-el' },
	                        this.getScreenReaderOptionClass()
	                    )
	                )
	            ) : null;
	        }
	    }]);
	
	    return GridChoiceOption;
	}(_react2.default.Component);
	
	GridChoiceOption.propTypes = {
	    option: _propTypes2.default.object.isRequired,
	    asset_id: _propTypes2.default.number.isRequired,
	    questionChecked: _propTypes2.default.bool.isRequired,
	    currentlyChecked: _propTypes2.default.bool.isRequired,
	    responseData: _propTypes2.default.object.isRequired,
	    index: _propTypes2.default.number.isRequired,
	    onOptionClick: _propTypes2.default.func,
	    onAttemptComplete: _propTypes2.default.func,
	    onReviewObject: _propTypes2.default.func,
	    onOptionRevealed: _propTypes2.default.func,
	    showFeedback: _propTypes2.default.bool,
	    focusedOption: _propTypes2.default.object,
	    optionCallbacks: _propTypes2.default.object,
	    contentData: _propTypes2.default.object,
	    trackingData: _propTypes2.default.object,
	    lang: _propTypes2.default.string.isRequired,
	    actions: _propTypes2.default.object
	};
	
	GridChoiceOption.contextTypes = {
	    router: _propTypes2.default.object
	};
	
	function mapStateToProps(state) {
	    var lang = state.userData.lang;
	    return {
	        lang: lang,
	        contentData: state.contentData,
	        trackingData: state.trackingData
	    };
	}
	
	function mapDispatchToProps(dispatch) {
	    return {
	        actions: (0, _redux.bindActionCreators)(Object.assign({}, appDataActions, trackingDataActions, dialogPopupActions), dispatch)
	    };
	}
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(GridChoiceOption);

/***/ },
/* 499 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(5);
	
	var _redux = __webpack_require__(4);
	
	var _Prompt = __webpack_require__(83);
	
	var _Prompt2 = _interopRequireDefault(_Prompt);
	
	var _DialogPrompt = __webpack_require__(94);
	
	var _DialogPrompt2 = _interopRequireDefault(_DialogPrompt);
	
	var _MultipleAnswerOption = __webpack_require__(502);
	
	var _MultipleAnswerOption2 = _interopRequireDefault(_MultipleAnswerOption);
	
	var _Button = __webpack_require__(18);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _MultipleAnswerFeedback = __webpack_require__(500);
	
	var _MultipleAnswerFeedback2 = _interopRequireDefault(_MultipleAnswerFeedback);
	
	var _ChildConversationDialog = __webpack_require__(65);
	
	var _ChildConversationDialog2 = _interopRequireDefault(_ChildConversationDialog);
	
	var _BadgeCollect = __webpack_require__(47);
	
	var _BadgeCollect2 = _interopRequireDefault(_BadgeCollect);
	
	var _appDataActions = __webpack_require__(12);
	
	var appDataActions = _interopRequireWildcard(_appDataActions);
	
	var _trackingDataActions = __webpack_require__(7);
	
	var trackingDataActions = _interopRequireWildcard(_trackingDataActions);
	
	var _dialogPopupActions = __webpack_require__(19);
	
	var dialogPopupActions = _interopRequireWildcard(_dialogPopupActions);
	
	var _appHelper = __webpack_require__(3);
	
	var appHelper = _interopRequireWildcard(_appHelper);
	
	var _dataHelper = __webpack_require__(11);
	
	var dataHelper = _interopRequireWildcard(_dataHelper);
	
	var _kpiHelper = __webpack_require__(35);
	
	var kpiHelper = _interopRequireWildcard(_kpiHelper);
	
	var _userDataHelper = __webpack_require__(15);
	
	var userDataHelper = _interopRequireWildcard(_userDataHelper);
	
	var _xAPIHelper = __webpack_require__(86);
	
	var xAPIHelper = _interopRequireWildcard(_xAPIHelper);
	
	var _objectConstants = __webpack_require__(9);
	
	var objectConstants = _interopRequireWildcard(_objectConstants);
	
	var _appConstants = __webpack_require__(13);
	
	var appConstants = _interopRequireWildcard(_appConstants);
	
	var _localStorage = __webpack_require__(17);
	
	var localStorage = _interopRequireWildcard(_localStorage);
	
	var _keyboardConstants = __webpack_require__(14);
	
	var keyboardConstants = _interopRequireWildcard(_keyboardConstants);
	
	var _componentConstants = __webpack_require__(49);
	
	var componentConstants = _interopRequireWildcard(_componentConstants);
	
	var _dialogModels = __webpack_require__(32);
	
	var _gsap = __webpack_require__(8);
	
	var _gsapReactPlugin = __webpack_require__(10);
	
	var _gsapReactPlugin2 = _interopRequireDefault(_gsapReactPlugin);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } //eslint-disable-line import/no-named-as-default
	
	
	var MultipleAnswer = function (_React$Component) {
	    _inherits(MultipleAnswer, _React$Component);
	
	    function MultipleAnswer(props, context) {
	        _classCallCheck(this, MultipleAnswer);
	
	        var _this = _possibleConstructorReturn(this, (MultipleAnswer.__proto__ || Object.getPrototypeOf(MultipleAnswer)).call(this, props, context));
	
	        _this.state = {
	            lang: _this.props.lang,
	            screenObject: _this.props.screenObject,
	            userData: _this.props.userData,
	            locale: appHelper.getLocalData(_this.props.screenObject),
	            options: _this.props.screenObject.options,
	            reviewMode: false,
	            propsUpdated: false,
	            questionChecked: false,
	            currentlyChecked: false,
	            correctAnswerCount: appHelper.getTypeCount(_this.props.screenObject.options, "result", "best").length,
	            responseData: {
	                bite_id: _this.props.callbacks.getBiteId(),
	                screen_id: _this.props.callbacks.getScreenId(),
	                asset_id: _this.props.screenObject.asset_id,
	                currentAttempt: 1,
	                currentStatus: objectConstants.STATUS_NOT_STARTED,
	                displayState: objectConstants.OBJECT_DISPLAY_STATE_INITIAL,
	                outcome: {},
	                responses: [],
	                checkedOptions: [],
	                userSelections: [],
	                latestResponse: {},
	                initialised: false,
	                scoring_type: _this.props.screenObject.scoring_type
	            },
	            showOptions: false,
	            enableCheckBtn: false,
	            showCheckBtn: false,
	            showFeedback: false,
	            skipFeedback: false,
	            showResponse: false,
	            revealedOptions: [],
	            watchCheckBtnState: true,
	            screenStatus: "",
	            checkObjectStatus: false,
	            handleCompletion: false,
	            progressionHandled: false,
	            checkPostXAPIResponse: false,
	            checkedForMissedOptions: false,
	            missedOptions: {
	                show: false,
	                options: []
	            },
	            character_name: appHelper.isDefined(_this.props.callbacks) ? _this.props.callbacks.getCharacterName() : appHelper.getScreenCharacterNameByAssetId(_this.props.screenObject.asset_id),
	            focusOnFeedback: false,
	            showProgression: false,
	            hideFeedback: false,
	            progression_label: "",
	            hasBadges: false,
	            badgesCollected: false,
	            animateBadge: true,
	            allowShowFeedback: true,
	            multiple_choice_question_label: appHelper.getLocaleString("multiple_choice_question_label"),
	            submit_label: appHelper.getLocaleString("submit_label"),
	            continue_label: appHelper.getLocaleString("continue_label"),
	            try_again_label: appHelper.getLocaleString("try_again_label"),
	            missed_options_label: appHelper.getLocaleString("missed_options_label"),
	            xApiResponseObj: {}
	
	        };
	
	        _this.randomiseOptions = _this.randomiseOptions.bind(_this);
	        _this.renderOptions = _this.renderOptions.bind(_this);
	        _this.onOptionClick = _this.onOptionClick.bind(_this);
	        _this.checkAnswers = _this.checkAnswers.bind(_this);
	        _this.showFeedback = _this.showFeedback.bind(_this);
	        _this.handleResponse = _this.handleResponse.bind(_this);
	        _this.handleProgression = _this.handleProgression.bind(_this);
	        _this.reattempt = _this.reattempt.bind(_this);
	        _this.onReviewObject = _this.onReviewObject.bind(_this);
	        _this.getObjectStatus = _this.getObjectStatus.bind(_this);
	        _this.setReviewMode = _this.setReviewMode.bind(_this);
	        _this.onOptionRevealed = _this.onOptionRevealed.bind(_this);
	        _this.setCheckBtnState = _this.setCheckBtnState.bind(_this);
	        _this.handleResponseComplete = _this.handleResponseComplete.bind(_this);
	        _this.postXAPIResponse = _this.postXAPIResponse.bind(_this);
	        _this.getStatusClass = _this.getStatusClass.bind(_this);
	        _this.onPanelClick = _this.onPanelClick.bind(_this);
	        _this.getMissedOptions = _this.getMissedOptions.bind(_this);
	        _this.getImagePath = _this.getImagePath.bind(_this);
	        _this.getTabIndex = _this.getTabIndex.bind(_this);
	        _this.onKeyboardPanelClick = _this.onKeyboardPanelClick.bind(_this);
	        _this.onFocusOnFeedback = _this.onFocusOnFeedback.bind(_this);
	        _this.handleSkipFeedback = _this.handleSkipFeedback.bind(_this);
	        _this.hasFeedbackToShow = _this.hasFeedbackToShow.bind(_this);
	        _this.enableProgression = _this.enableProgression.bind(_this);
	        _this.onProgressionClicked = _this.onProgressionClicked.bind(_this);
	        _this.onBadgeCollected = _this.onBadgeCollected.bind(_this);
	        _this.checkResponses = _this.checkResponses.bind(_this);
	        return _this;
	    }
	
	    _createClass(MultipleAnswer, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            this.randomiseOptions();
	            if (localStorage.tracking_type === appConstants.TRACKING_TYPE_XAPI || localStorage.tracking_type === appConstants.TRACKING_TYPE_BLENDED_XAPI_SCORM_1_2) {
	                this.checkResponses();
	            } else {
	                this.getObjectStatus();
	            }
	        }
	    }, {
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(nextProps) {
	            if (this.state.userData !== nextProps.userData) {
	                this.setState({
	                    userData: Object.assign({}, nextProps.userData),
	                    checkObjectStatus: true
	                });
	            }
	
	            if (this.state.lang !== nextProps.lang) {
	                var progression_label = "";
	                if (this.state.progression_label === this.state.try_again_label) {
	                    progression_label = appHelper.getLocaleString("try_again_label");
	                } else if (this.state.progression_label === this.state.continue_label) {
	                    progression_label = appHelper.getLocaleString("continue_label");
	                }
	                this.setState({
	                    lang: nextProps.lang,
	                    locale: appHelper.getLocalData(this.state.screenObject),
	                    multiple_choice_question_label: appHelper.getLocaleString("multiple_choice_question_label"),
	                    submit_label: appHelper.getLocaleString("submit_label"),
	                    progression_label: progression_label,
	                    continue_label: appHelper.getLocaleString("continue_label"),
	                    try_again_label: appHelper.getLocaleString("try_again_label"),
	                    missed_options_label: appHelper.getLocaleString("missed_options_label"),
	                    checkedForMissedOptions: true
	                });
	            }
	        }
	    }, {
	        key: 'componentDidUpdate',
	        value: function componentDidUpdate() {
	            if (this.state.propsUpdated && this.state.responseData.displayState === objectConstants.OBJECT_DISPLAY_STATE_REVIEW) {
	                this.setReviewMode();
	            }
	
	            if (this.state.watchCheckBtnState && !this.props.callbacks.isReviewMode()) {
	                //console.log(`${this.state.revealedOptions.length} >= ${this.props.screenObject.options.length}`)
	                this.setCheckBtnState(this.state.revealedOptions.length >= this.props.screenObject.options.length);
	            }
	
	            if (this.state.skipFeedback) {
	                this.handleSkipFeedback();
	            }
	
	            if (this.state.checkObjectStatus) {
	                this.getObjectStatus();
	            }
	
	            if (this.state.handleCompletion && !this.state.progressionHandled) {
	                this.handleProgression();
	            }
	
	            if (this.state.checkPostXAPIResponse) {
	                this.postXAPIResponse();
	            }
	
	            if (this.state.checkedForMissedOptions) {
	                this.getMissedOptions();
	            }
	
	            if (this.state.skipFeedback) {
	                this.handleSkipFeedback();
	            }
	
	            if (this.state.focusOnFeedback) {
	                this.onFocusOnFeedback();
	            }
	        }
	    }, {
	        key: 'onFocusOnFeedback',
	        value: function onFocusOnFeedback() {
	            var focusEl = document.getElementById('feedback_wrapper_' + this.state.screenObject.asset_id);
	            if (appHelper.isDefined(focusEl) && focusEl !== null) {
	                focusEl.focus();
	            }
	            this.setState({ focusOnFeedback: false });
	        }
	    }, {
	        key: 'postXAPIResponse',
	        value: function postXAPIResponse() {
	            this.setState({ checkPostXAPIResponse: false });
	            var interactionData = xAPIHelper.setMultiAnswerChoiceInteractionData(this.state.screenObject, this.state.responseData);
	            if (localStorage.tracking_type === appConstants.TRACKING_TYPE_XAPI || localStorage.tracking_type === appConstants.TRACKING_TYPE_BLENDED_XAPI_SCORM_1_2) {
	
	                var screen = appHelper.getScreenByAssetId(this.state.screenObject.asset_id);
	                var category = {
	                    constant: componentConstants.MULTIPLE_ANSWER,
	                    label: componentConstants.MULTIPLE_CHOICE_MULTIPLE_ANSWER_LABEL
	                };
	
	                this.props.actions.postActvityStatement(screen, interactionData, category);
	            }
	        }
	    }, {
	        key: 'handleSkipFeedback',
	        value: function handleSkipFeedback() {
	            var selectedOptions = [];
	            for (var i = 0; i < this.state.responseData.checkedOptions.length; i++) {
	                var selectedOption = this.state.responseData.checkedOptions[i];
	                selectedOptions = dataHelper.immutablePush(selectedOptions, selectedOption.option_id);
	            }
	
	            var responseObj = {
	                asset_id: this.state.screenObject.asset_id,
	                selectedOptions: selectedOptions,
	                kpis: !appHelper.isDefined(this.state.responseData.outcome.kpis) || this.state.responseData.outcome.kpis !== null ? this.state.responseData.outcome.kpis : []
	            };
	
	            this.setState({ skipFeedback: false });
	            //console.log(responseObj);
	            //console.log(this.props.callbacks);
	            this.props.callbacks.storeUserResponse(responseObj);
	            if (!this.state.hasBadges) {
	                var handleResponse = this.handleResponse;
	
	                setTimeout(function () {
	                    handleResponse();
	                }, 1000);
	            }
	        }
	    }, {
	        key: 'setCheckBtnState',
	        value: function setCheckBtnState(state) {
	            if (this.state.responseData.displayState !== objectConstants.OBJECT_DISPLAY_STATE_REVIEW) {
	                this.setState({ showCheckBtn: state, watchCheckBtnState: false });
	            }
	        }
	
	        //options functions
	
	    }, {
	        key: 'randomiseOptions',
	        value: function randomiseOptions() {
	            if (this.state.screenObject.randomise_options) {
	                this.setState({
	                    options: dataHelper.randomiseArray(this.state.options),
	                    showOptions: true
	                });
	            } else {
	                this.setState({ showOptions: true });
	            }
	            this.props.callbacks.scrollToTop();
	        }
	    }, {
	        key: 'renderOptions',
	        value: function renderOptions() {
	            if (!this.state.showOptions && this.state.responseData.currentStatus === objectConstants.STATUS_NOT_STARTED) {
	                this.setState({ showOptions: true });
	            }
	
	            this.props.callbacks.scrollToTop();
	        }
	    }, {
	        key: 'onOptionRevealed',
	        value: function onOptionRevealed(option) {
	            var index = appHelper.getArrayObjectIndexByKey(this.state.revealedOptions, "option_id", option.option_id);
	            if (index === -1) {
	                this.setState({
	                    revealedOptions: dataHelper.immutablePush(this.state.revealedOptions, option),
	                    watchCheckBtnState: true
	                });
	            }
	        }
	    }, {
	        key: 'onOptionClick',
	        value: function onOptionClick(event) {
	            var checkedOptions = Object.assign([], this.state.responseData.checkedOptions);
	            var option = appHelper.getObjectOption(this.state.screenObject.options, event.target.value);
	            var optionIndex = appHelper.getArrayObjectIndexByKey(checkedOptions, "option_id", option.option_id);
	            if (optionIndex == -1) {
	                checkedOptions = dataHelper.immutablePush(checkedOptions, option);
	            } else {
	                checkedOptions = dataHelper.immutableSplice(checkedOptions, optionIndex, 1);
	            }
	            //console.log(checkedOptions);
	            this.setState({
	                responseData: Object.assign({}, this.state.responseData, {
	                    checkedOptions: Object.assign([], checkedOptions),
	                    initialised: true
	                }),
	                enableCheckBtn: checkedOptions.length > 0
	
	            });
	        }
	
	        //interaction control
	
	    }, {
	        key: 'checkAnswers',
	        value: function checkAnswers() {
	            var correctAnswers = appHelper.getTypeCount(this.state.responseData.checkedOptions, "result", "best");
	            var incorrectAnswers = appHelper.getNotOfTypeCount(this.state.responseData.checkedOptions, "result", "best");
	            var kpis = kpiHelper.averageKpis(this.state.responseData.checkedOptions);
	            var outcome = {};
	            if (correctAnswers.length === this.state.correctAnswerCount && incorrectAnswers.length === 0) {
	                outcome = Object.assign({}, appHelper.getArrayObjectByKey(this.state.screenObject.outcomes, "result", "best"), {
	                    kpis: kpis
	                });
	            } else {
	                if (correctAnswers.length > 0) {
	                    outcome = Object.assign({}, appHelper.getArrayObjectByKey(this.state.screenObject.outcomes, "result", "ok"), {
	                        kpis: kpis
	                    });
	                    if (!appHelper.isDefined(outcome.result)) {
	                        outcome = Object.assign({}, appHelper.getArrayObjectByKey(this.state.screenObject.outcomes, "result", "poor"), {
	                            kpis: kpis
	                        });
	                    }
	                } else {
	                    outcome = Object.assign({}, appHelper.getArrayObjectByKey(this.state.screenObject.outcomes, "result", "poor"), {
	                        kpis: kpis
	                    });
	                }
	            }
	
	            if (this.state.screenObject.scoring_type === objectConstants.SCORING_TYPE_REFLECTIVE) {
	                outcome = Object.assign({}, appHelper.getArrayObjectByKey(this.state.screenObject.outcomes, "result", "best"), {
	                    kpis: kpis,
	                    result: "reflective"
	                });
	            }
	
	            var showResponse = false;
	            if (appHelper.isDefined(outcome.dialogs) && outcome.dialogs.length > 0) {
	                showResponse = true;
	            }
	
	            var hasBadges = appHelper.isDefined(outcome.badges) && outcome.badges.length > 0 && !outcome.enable_feedback && !showResponse;
	            var enable_feedback = outcome.enable_feedback;
	
	            this.setState({
	                responseData: Object.assign({}, this.state.responseData, {
	                    outcome: outcome,
	                    displayState: objectConstants.OBJECT_DISPLAY_STATE_ANSWERED
	                }),
	                showResponse: showResponse,
	                showFeedback: enable_feedback && !showResponse,
	                focusOnFeedback: enable_feedback && !showResponse,
	                skipFeedback: !enable_feedback && outcome.progression !== objectConstants.OBJECT_PROGRESSION_TRY_AGAIN && !showResponse,
	                showProgression: !enable_feedback && outcome.progression === objectConstants.OBJECT_PROGRESSION_TRY_AGAIN && !showResponse,
	                progression_label: outcome.progression === objectConstants.OBJECT_PROGRESSION_TRY_AGAIN ? this.state.try_again_label : this.state.continue_label,
	                hasBadges: hasBadges,
	                questionChecked: true,
	                currentlyChecked: true,
	                showCheckBtn: false,
	                enableCheckBtn: false,
	                showOptions: true,
	                initialised: false,
	                checkPostXAPIResponse: true,
	                checkedForMissedOptions: true
	
	            });
	        }
	    }, {
	        key: 'handleResponse',
	        value: function handleResponse() {
	            this.setState({ hideFeedback: false });
	            var progressionRule = this.state.responseData.outcome.progression;
	
	            var showResponse = false;
	            if (appHelper.isDefined(this.state.responseData.outcome.dialogs) && this.state.responseData.outcome.dialogs.length > 0) {
	                showResponse = true;
	            }
	
	            if (progressionRule === objectConstants.OBJECT_PROGRESSION_TRY_AGAIN) {
	                this.reattempt();
	            } else {
	                this.setState({
	                    showFeedback: !this.props.callbacks.hasNextObject(this.props.index) && this.hasFeedbackToShow(),
	                    focusOnFeedback: !this.props.callbacks.hasNextObject(this.props.index) && this.hasFeedbackToShow(),
	                    showOptions: true,
	                    options: Object.assign([], this.state.responseData.checkedOptions),
	                    responseData: Object.assign({}, this.state.responseData, {
	                        currentStatus: objectConstants.STATUS_COMPLETE,
	                        displayState: objectConstants.OBJECT_DISPLAY_STATE_REVIEW
	                    }),
	                    handleCompletion: true
	                });
	            }
	        }
	    }, {
	        key: 'hasFeedbackToShow',
	        value: function hasFeedbackToShow() {
	            var enable_feedback = this.state.responseData.outcome.enable_feedback;
	
	            return enable_feedback;
	        }
	    }, {
	        key: 'handleProgression',
	        value: function handleProgression() {
	            var enable_feedback = this.state.responseData.outcome.enable_feedback;
	
	            var progressionRule = appHelper.isDefined(this.state.responseData.outcome.progression) ? this.state.responseData.outcome.progression : objectConstants.OBJECT_PROGRESSION_CONTINUE;
	            var progressionType = appHelper.isDefined(this.state.responseData.outcome.progression_type) ? this.state.responseData.outcome.progression_type : undefined;
	            var progressionGoToId = appHelper.isDefined(this.state.responseData.outcome.progression_goto_id) ? this.state.responseData.outcome.progression_goto_id : undefined;
	            this.setState({ handleCompletion: false, progressionHandled: true });
	            var completionData = {
	                progression: progressionRule,
	                asset_id: this.state.screenObject.asset_id,
	                status: objectConstants.STATUS_COMPLETE,
	                asset_type_code: this.state.screenObject.asset_type_code,
	                navigateToNextScreen: enable_feedback && progressionType !== objectConstants.GO_TO_TYPE_SCREEN,
	                progressionType: progressionType,
	                progressionGoToId: progressionGoToId,
	                index: this.props.index
	            };
	
	            this.props.callbacks.onObjectComplete(completionData);
	        }
	    }, {
	        key: 'showFeedback',
	        value: function showFeedback() {
	            // console.log("showFeedback");
	            if (this.state.responseData.currentStatus !== objectConstants.STATUS_COMPLETE) {
	                this.setState({ showFeedback: true, focusOnFeedback: true });
	            }
	        }
	    }, {
	        key: 'checkResponses',
	        value: function checkResponses() {
	            var _this2 = this;
	
	            if (localStorage.tracking_type === appConstants.TRACKING_TYPE_XAPI || localStorage.tracking_type === appConstants.TRACKING_TYPE_BLENDED_XAPI_SCORM_1_2) {
	                var parentScreen = this.props.callbacks.getSubScreenParent();
	                var params = {
	
	                    bite_id: this.props.callbacks.getBiteId(),
	                    screen_id: this.props.callbacks.getScreenId(),
	                    parent_screen_id: appHelper.isDefined(parentScreen) ? parentScreen.screen_id : undefined,
	                    asset_id: this.state.screenObject.asset_id
	                };
	
	                var interactionData = xAPIHelper.getMultipleChoiceIds(params);
	
	                this.props.actions.getActvityStatement(interactionData).then(function (responseObj) {
	                    if (appHelper.isDefined(responseObj.statement.result.completion)) {
	                        _this2.setState({
	                            xApiResponseObj: Object.assign({}, responseObj),
	                            reviewMode: true,
	                            propsUpdated: true,
	                            responseData: Object.assign({}, _this2.state.responseData, {
	                                currentStatus: objectConstants.STATUS_COMPLETE,
	                                displayState: objectConstants.OBJECT_DISPLAY_STATE_REVIEW
	                            })
	                        });
	                    }
	                });
	            }
	        }
	    }, {
	        key: 'getObjectStatus',
	        value: function getObjectStatus() {
	            this.setState({ checkObjectStatus: false });
	            if (this.state.responseData.currentStatus !== objectConstants.STATUS_COMPLETE) {
	                var screenStatus = userDataHelper.getObjectStatus(this.state.userData, this.props.screenObject.asset_id);
	                if (screenStatus === objectConstants.STATUS_COMPLETE && this.state.screenObject.attempt_type === objectConstants.ATTEMPT_TYPE_FIRST) {
	                    this.setState({
	                        reviewMode: true,
	                        propsUpdated: true,
	                        responseData: Object.assign({}, this.state.responseData, {
	                            currentStatus: objectConstants.STATUS_COMPLETE,
	                            displayState: objectConstants.OBJECT_DISPLAY_STATE_REVIEW
	                        })
	                    });
	                } else {
	                    var objectUserData = {};
	                    if (this.state.status !== objectConstants.STATUS_COMPLETE) {
	                        var subScreenParent = this.props.callbacks.getSubScreenParent();
	                        var screen_id = this.props.callbacks.getScreenId();
	                        if (appHelper.isDefined(subScreenParent)) {
	                            objectUserData = userDataHelper.getSubScreenObjectStatus(this.state.userData, subScreenParent.screen_id, screen_id, this.state.screenObject.asset_id);
	                        } else {
	                            objectUserData = userDataHelper.getObjectStatus(this.state.userData, screen_id, this.state.screenObject.asset_id);
	                        }
	                    }
	
	                    if (objectUserData.status === objectConstants.STATUS_COMPLETE && this.state.screenObject.attempt_type === objectConstants.ATTEMPT_TYPE_FIRST) {
	                        this.setState({
	                            reviewMode: true,
	                            propsUpdated: true,
	                            responseData: Object.assign({}, this.state.responseData, {
	                                currentStatus: objectConstants.STATUS_COMPLETE,
	                                displayState: objectConstants.OBJECT_DISPLAY_STATE_REVIEW
	                            })
	                        });
	                    }
	                }
	            }
	        }
	    }, {
	        key: 'setReviewMode',
	        value: function setReviewMode() {
	            var optionIds = appHelper.getObjectOptionIds(this.state.screenObject);
	            var kpiUserData = userDataHelper.getUserResponseByOptionIds(this.state.userData, this.props.callbacks.getBiteId(), optionIds);
	            var showResponse = false;
	
	            if (appHelper.isDefined(kpiUserData)) {
	                var checkedOptions = appHelper.getObjectCheckedOptionsByKpiHistoryOptions(kpiUserData.option_id);
	                var outcome = appHelper.getObjectOutcomeByKpiHistoryOptions(kpiUserData.option_id);
	                if (appHelper.isDefined(outcome.dialogs) && outcome.dialogs.length > 0) {
	                    showResponse = true;
	                }
	                var responseData = Object.assign({}, this.state.responseData, {
	                    checkedOptions: checkedOptions,
	                    outcome: outcome
	                });
	
	                var enable_feedback = outcome.enable_feedback;
	                var hasBadges = appHelper.isDefined(outcome.badges) && outcome.badges.length > 0;
	                this.setState({
	                    showProgression: !this.props.callbacks.hasNextObject(this.props.index) && enable_feedback,
	                    hasBadges: hasBadges,
	                    badgesCollected: hasBadges,
	                    handleCompletion: true,
	                    showResponse: showResponse,
	                    progression_label: outcome.progression === objectConstants.OBJECT_PROGRESSION_TRY_AGAIN ? this.state.try_again_label : this.state.continue_label,
	                    propsUpdated: false,
	                    showOptions: true,
	                    options: Object.assign([], checkedOptions),
	                    showCheckBtn: false,
	                    responseData: responseData,
	                    checkedForMissedOptions: true,
	                    allowShowFeedback: false
	                });
	            } else if (localStorage.tracking_type === appConstants.TRACKING_TYPE_XAPI || localStorage.tracking_type === appConstants.TRACKING_TYPE_BLENDED_XAPI_SCORM_1_2) {
	                var responseObj = Object.assign({}, this.state.xApiResponseObj);
	                if (appHelper.isDefined(responseObj.statement)) {
	                    var responseString = responseObj.statement.result.response;
	                    var choices = responseObj.statement.object.definition.choices;
	                    var responseArray = responseString.split("[,]");
	                    var selectedOptions = [];
	
	                    for (var i = 0; i < responseArray.length; i++) {
	                        var _responseString = responseArray[i];
	                        var optionResponse = xAPIHelper.getChoiceByDescription(choices, _responseString);
	                        var optionDetails = appHelper.getOptionParentDetails(parseInt(optionResponse.id));
	                        //let optionDetails = appHelper.getOptionByLabelName(responseString, this.state.screenObject.options);
	                        if (appHelper.isDefined(optionDetails.option.option_id)) {
	                            selectedOptions = dataHelper.immutablePush(selectedOptions, optionDetails.option);
	                        }
	                    }
	
	                    var correctAnswers = appHelper.getTypeCount(selectedOptions, "result", "best");
	                    var incorrectAnswers = appHelper.getNotOfTypeCount(selectedOptions, "result", "best");
	                    var kpis = kpiHelper.averageKpis(selectedOptions);
	                    var _outcome = {};
	                    if (correctAnswers.length === this.state.correctAnswerCount && incorrectAnswers.length === 0) {
	                        _outcome = Object.assign({}, appHelper.getArrayObjectByKey(this.state.screenObject.outcomes, "result", "best"), {
	                            kpis: kpis
	                        });
	                    } else {
	                        if (correctAnswers.length > 0) {
	                            _outcome = Object.assign({}, appHelper.getArrayObjectByKey(this.state.screenObject.outcomes, "result", "ok"), {
	                                kpis: kpis
	                            });
	                            if (!appHelper.isDefined(_outcome.result)) {
	                                _outcome = Object.assign({}, appHelper.getArrayObjectByKey(this.state.screenObject.outcomes, "result", "poor"), {
	                                    kpis: kpis
	                                });
	                            }
	                        } else {
	                            _outcome = Object.assign({}, appHelper.getArrayObjectByKey(this.state.screenObject.outcomes, "result", "poor"), {
	                                kpis: kpis
	                            });
	                        }
	                    }
	
	                    if (this.state.screenObject.scoring_type === objectConstants.SCORING_TYPE_REFLECTIVE) {
	                        _outcome = Object.assign({}, appHelper.getArrayObjectByKey(this.state.screenObject.outcomes, "result", "best"), {
	                            kpis: kpis,
	                            result: "reflective"
	                        });
	                    }
	
	                    if (appHelper.isDefined(_outcome.dialogs) && _outcome.dialogs.length > 0) {
	                        showResponse = true;
	                    }
	                    var _responseData = Object.assign({}, this.state.responseData, {
	                        checkedOptions: selectedOptions,
	                        outcome: _outcome
	                    });
	
	                    var _enable_feedback = _outcome.enable_feedback;
	                    var _hasBadges = appHelper.isDefined(_outcome.badges) && _outcome.badges.length > 0;
	                    this.setState({
	                        showProgression: !this.props.callbacks.hasNextObject(this.props.index) && _enable_feedback,
	                        hasBadges: _hasBadges,
	                        badgesCollected: _hasBadges,
	                        handleCompletion: true,
	                        showResponse: showResponse,
	                        progression_label: _outcome.progression === objectConstants.OBJECT_PROGRESSION_TRY_AGAIN ? this.state.try_again_label : this.state.continue_label,
	                        propsUpdated: false,
	                        showOptions: true,
	                        options: Object.assign([], selectedOptions),
	                        showCheckBtn: false,
	                        responseData: _responseData,
	                        checkedForMissedOptions: true,
	                        allowShowFeedback: false
	                    });
	                }
	            } else {
	                this.setState({
	                    reviewMode: false,
	                    propsUpdated: true,
	                    responseData: Object.assign({}, this.state.responseData, {
	                        currentStatus: objectConstants.STATUS_NOT_STARTED,
	                        displayState: objectConstants.OBJECT_DISPLAY_STATE_INITIAL
	                    })
	                });
	            }
	        }
	    }, {
	        key: 'reattempt',
	        value: function reattempt() {
	            var focusEl = this.refs[this.state.screenObject.asset_id + '_questionOptions'];
	            focusEl.focus();
	            var correctAnswers = appHelper.getTypeCount(this.state.responseData.checkedOptions, "correct", true);
	            this.setState({
	                showFeedback: false,
	                hideFeedback: false,
	                showCheckBtn: true,
	                revealedOptions: dataHelper.immutableSplice(this.state.revealedOptions, 0, this.state.revealedOptions.length),
	                enableCheckBtn: correctAnswers.length > 0,
	                showOptions: true,
	                showResponse: false,
	                currentlyChecked: false,
	                responseData: Object.assign({}, this.state.responseData, {
	                    currentAttempt: this.state.responseData.currentAttempt + 1,
	                    currentStatus: objectConstants.STATUS_ATTEMPTED,
	                    displayState: objectConstants.OBJECT_DISPLAY_STATE_RETRY,
	                    outcome: Object.assign({}, {}),
	                    checkedOptions: Object.assign([], correctAnswers)
	
	                })
	            });
	        }
	    }, {
	        key: 'onReviewObject',
	        value: function onReviewObject(sourceId) {
	            if (this.hasFeedbackToShow()) {
	                var config = Object.assign({}, _dialogModels.MULTIPLE_ANSWER_REVIEW_CONFIG, {
	                    title: this.state.locale.label,
	                    sourceId: sourceId
	                });
	                //locale.title
	
	
	                for (var i = 0; i < config.childComponents.length; i++) {
	                    var child = config.childComponents[i];
	                    child.componentProps = Object.assign({}, {
	                        screenObject: this.state.screenObject,
	                        responseData: Object.assign({}, this.state.responseData, {
	                            displayState: objectConstants.OBJECT_DISPLAY_STATE_REVIEW,
	                            userSelections: Object.assign([], this.state.responseData.checkedOptions)
	                        }),
	                        callbacks: this.props.callbacks
	                    });
	                }
	                this.props.actions.setNewDialog(config);
	            }
	        }
	    }, {
	        key: 'handleResponseComplete',
	        value: function handleResponseComplete() {
	            var enable_feedback = this.state.responseData.outcome.enable_feedback;
	
	            this.setState({
	                showFeedback: enable_feedback && this.state.responseData.displayState !== objectConstants.OBJECT_DISPLAY_STATE_REVIEW,
	                focusOnFeedback: enable_feedback && this.state.responseData.displayState !== objectConstants.OBJECT_DISPLAY_STATE_REVIEW,
	                hasBadges: appHelper.isDefined(this.state.responseData.outcome.badges) && this.state.responseData.outcome.badges.length > 0 && !enable_feedback,
	                skipFeedback: !enable_feedback && this.state.responseData.outcome.progression !== objectConstants.OBJECT_PROGRESSION_TRY_AGAIN,
	                showProgression: !enable_feedback && this.state.responseData.outcome.progression === objectConstants.OBJECT_PROGRESSION_TRY_AGAIN
	            });
	        }
	    }, {
	        key: 'getStatusClass',
	        value: function getStatusClass() {
	            return this.state.responseData.displayState === objectConstants.OBJECT_DISPLAY_STATE_REVIEW && this.props.contentData.experience.include_explore_feedback && this.hasFeedbackToShow() ? "complete" : "";
	        }
	    }, {
	        key: 'getTabIndex',
	        value: function getTabIndex() {
	            return this.state.responseData.displayState === objectConstants.OBJECT_DISPLAY_STATE_REVIEW && this.props.contentData.experience.include_explore_feedback ? 0 : -1;
	        }
	    }, {
	        key: 'onPanelClick',
	        value: function onPanelClick() {
	
	            if (this.state.responseData.displayState === objectConstants.OBJECT_DISPLAY_STATE_REVIEW && this.props.contentData.experience.include_explore_feedback && this.hasFeedbackToShow()) {
	                this.onReviewObject('question_wrapper_' + this.state.screenObject.asset_id);
	            }
	        }
	    }, {
	        key: 'onKeyboardPanelClick',
	        value: function onKeyboardPanelClick(event) {
	            if (event.which === keyboardConstants.ENTER_KEY || event.which === keyboardConstants.SPACEBAR_KEY) {
	                event.preventDefault();
	                if (this.state.responseData.displayState === objectConstants.OBJECT_DISPLAY_STATE_REVIEW && this.props.contentData.experience.include_explore_feedback) {
	                    this.onReviewObject('question_wrapper_' + this.state.screenObject.asset_id);
	                }
	            }
	        }
	    }, {
	        key: 'getMissedOptions',
	        value: function getMissedOptions() {
	            this.setState({ checkedForMissedOptions: false });
	            var missedOptions = [];
	            for (var o = 0; o < this.state.screenObject.options.length; o++) {
	                var option = this.state.screenObject.options[o];
	                var locale = appHelper.getLocalData(option);
	                var optionCheckedIndex = appHelper.getArrayObjectIndexByKey(this.state.responseData.checkedOptions, "option_id", option.option_id);
	                var optionObject = {
	                    result: option.result,
	                    className: optionCheckedIndex > -1 ? 'checked' : 'missed',
	                    option_text: locale.option,
	                    option_id: option.option_id
	                };
	                if (optionCheckedIndex === -1 && this.state.responseData.outcome.result !== objectConstants.RESULT_BEST && option.result === objectConstants.RESULT_BEST && this.state.responseData.outcome.progression === objectConstants.OBJECT_PROGRESSION_CONTINUE) {
	                    missedOptions = dataHelper.immutablePush(missedOptions, optionObject);
	                }
	            }
	            if (missedOptions.length > 0) {
	                this.setState({
	                    missedOptions: Object.assign({}, this.state.missedOptions, {
	                        show: true,
	                        options: Object.assign([], missedOptions)
	                    })
	                });
	            }
	        }
	    }, {
	        key: 'getImagePath',
	        value: function getImagePath(image) {
	            if (appConstants.DEVELOPMENT_MODE) {
	                if (appHelper.isDefined(image) && image.length > 0) {
	                    return __webpack_require__(16)("./" + image);
	                }
	            } else {
	                return image;
	            }
	        }
	    }, {
	        key: 'enableProgression',
	        value: function enableProgression(progression_label) {
	            var hasBadges = appHelper.isDefined(this.state.responseData.outcome.badges) && this.state.responseData.outcome.badges.length > 0;
	            var progressionType = appHelper.isDefined(this.state.responseData.outcome.progression_type) ? this.state.responseData.outcome.progression_type : undefined;
	            var showProgression = !hasBadges || this.state.showProgression;
	            if (!this.props.callbacks.hasNextObject(this.props.index)) {
	                showProgression = (!hasBadges || this.state.showProgression) && progressionType !== objectConstants.GO_TO_TYPE_SCREEN;
	            }
	            this.setState({
	                showProgression: showProgression,
	                hasBadges: hasBadges,
	                progression_label: this.state.responseData.outcome.progression === objectConstants.OBJECT_PROGRESSION_TRY_AGAIN ? this.state.try_again_label : this.state.continue_label
	            });
	            this.props.callbacks.scrollToContinue();
	        }
	    }, {
	        key: 'onProgressionClicked',
	        value: function onProgressionClicked() {
	            this.setState({
	                showProgression: false,
	                hideFeedback: this.props.callbacks.hasNextObject(this.props.index) && this.state.responseData.outcome.progression !== objectConstants.OBJECT_PROGRESSION_TRY_AGAIN
	            });
	            var enable_feedback = this.state.responseData.outcome.enable_feedback;
	
	            if (!this.props.callbacks.hasNextObject(this.props.index) && this.state.responseData.outcome.progression !== objectConstants.OBJECT_PROGRESSION_TRY_AGAIN) {
	                this.props.callbacks.navigateToNextScreen();
	            } else if (this.state.responseData.outcome.progression === objectConstants.OBJECT_PROGRESSION_TRY_AGAIN) {
	                this.reattempt();
	            }
	        }
	    }, {
	        key: 'onBadgeCollected',
	        value: function onBadgeCollected() {
	
	            this.setState({ badgesCollected: true });
	            if (!this.props.callbacks.hasNextObject(this.props.index)) {
	                this.setState({
	                    showProgression: true,
	                    progression_label: this.state.responseData.outcome.progression === objectConstants.OBJECT_PROGRESSION_TRY_AGAIN ? this.state.try_again_label : this.state.continue_label
	                });
	                this.props.callbacks.scrollToContinue();
	            }
	
	            this.handleResponse();
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this3 = this;
	
	            return _react2.default.createElement(
	                'div',
	                { className: 'learner-action' },
	                _react2.default.createElement(
	                    'p',
	                    { className: 'hidden-el' },
	                    this.state.multiple_choice_question_label
	                ),
	                appHelper.isDefined(this.props.characterPose) && appHelper.isDefined(this.props.characterPose.src) && this.props.characterPose.src.length > 0 ? _react2.default.createElement(
	                    'div',
	                    { className: 'content-character-expression' },
	                    _react2.default.createElement('img', { src: this.getImagePath(this.props.characterPose.src), alt: '' })
	                ) : null,
	                _react2.default.createElement(
	                    'div',
	                    { className: 'question-wrapper ' + this.getStatusClass(), tabIndex: this.getTabIndex(),
	                        id: 'question_wrapper_' + this.state.screenObject.asset_id,
	                        role: 'presentation', onClick: this.onPanelClick, onKeyDown: this.onKeyboardPanelClick },
	                    this.state.screenObject.prompt_type !== objectConstants.PROMPT_TYPE_SHOW_NO_PROMPT && this.state.screenObject.show_prompt ? this.state.screenObject.prompt_type === objectConstants.PROMPT_TYPE_DIALOG_PROMPT ? _react2.default.createElement(_DialogPrompt2.default, { character_name: this.state.character_name,
	                        id: this.state.screenObject.asset_id, locale: this.state.locale,
	                        show_title: this.state.screenObject.show_title,
	                        onComplete: this.onPromptRevealed }) : _react2.default.createElement(_Prompt2.default, { id: this.state.screenObject.asset_id, locale: this.state.locale,
	                        show_title: this.state.screenObject.show_title,
	                        onComplete: this.onPromptRevealed }) : null,
	                    this.state.showOptions ? _react2.default.createElement(
	                        'div',
	                        { className: 'multiple-choice-option-list theme-active',
	                            id: this.state.screenObject.asset_id + '_questionOptions',
	                            ref: this.state.screenObject.asset_id + '_questionOptions'
	                        },
	                        this.state.options.map(function (option) {
	                            return _react2.default.createElement(_MultipleAnswerOption2.default, { key: 'option_' + option.option_id,
	                                option: option,
	                                asset_id: _this3.state.screenObject.asset_id,
	                                questionChecked: _this3.state.questionChecked,
	                                currentlyChecked: _this3.state.currentlyChecked,
	                                onOptionClick: _this3.onOptionClick,
	                                responseData: _this3.state.responseData,
	                                onAttemptComplete: _this3.showFeedback,
	                                onOptionRevealed: _this3.onOptionRevealed,
	                                onShowReview: _this3.onReviewObject,
	                                index: appHelper.getObjectOptionIndex(_this3.state.screenObject.options, option.option_id),
	                                callbacks: _this3.props.callbacks
	                            });
	                        })
	                    ) : null,
	                    this.state.missedOptions.show ? _react2.default.createElement(
	                        'div',
	                        { className: 'object-container' },
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'missed-options' },
	                            _react2.default.createElement('div', { className: 'missed-options-label', dangerouslySetInnerHTML: { __html: this.state.missed_options_label } }),
	                            _react2.default.createElement(
	                                'ul',
	                                { className: 'multiple-choice-option-list' },
	                                this.state.missedOptions.options.map(function (missed_option) {
	                                    return _react2.default.createElement(
	                                        'li',
	                                        { className: 'multiple-choice-option ' + missed_option.className,
	                                            key: 'option_' + missed_option.option_id },
	                                        _react2.default.createElement('input', { id: _this3.state.id, name: _this3.state.id, type: 'checkbox',
	                                            disabled: 'disabled', tabIndex: '-1', 'aria-disabled': 'true',
	                                            'aria-checked': 'false' }),
	                                        _react2.default.createElement(
	                                            'label',
	                                            { htmlFor: _this3.state.id },
	                                            _react2.default.createElement('span', { dangerouslySetInnerHTML: { __html: missed_option.option_text } })
	                                        )
	                                    );
	                                })
	                            )
	                        )
	                    ) : null,
	                    this.state.showCheckBtn ? _react2.default.createElement(_Button2.default, { label: this.state.submit_label,
	                        id: this.state.screenObject.asset_id + '_check_button',
	                        isDisabled: !this.state.enableCheckBtn,
	                        onRevealed: this.props.callbacks.scrollToTop,
	                        onClick: this.checkAnswers }) : null,
	                    this.state.showResponse || this.state.showFeedback ? _react2.default.createElement(
	                        'div',
	                        { ref: 'feedback_wrapper_' + this.state.screenObject.asset_id,
	                            id: 'feedback_wrapper_' + this.state.screenObject.asset_id,
	                            role: 'article',
	                            tabIndex: 0,
	                            className: 'feedback-focus' },
	                        this.state.showResponse ? _react2.default.createElement(_ChildConversationDialog2.default, { asset_id: this.state.screenObject.asset_id,
	                            option_id: this.state.responseData.outcome.option_id,
	                            dialogs: this.state.responseData.outcome.dialogs,
	                            callbacks: this.props.callbacks,
	                            onComplete: this.handleResponseComplete }) : null,
	                        this.state.showFeedback && this.state.allowShowFeedback ? _react2.default.createElement(_MultipleAnswerFeedback2.default, { screenObject: this.state.screenObject,
	                            options: this.state.screenObject.options,
	                            asset_id: this.state.screenObject.asset_id,
	                            responseData: this.state.responseData,
	                            onComplete: this.handleResponse,
	                            onShowReview: this.onReviewObject,
	                            onEnableProgression: this.enableProgression,
	                            hideFeedback: this.state.hideFeedback,
	                            callbacks: this.props.callbacks,
	                            index: this.props.index
	                        }) : null
	                    ) : null,
	                    (this.state.showResponse || this.state.showFeedback) && this.state.hasBadges ? _react2.default.createElement('br', null) : null,
	                    this.state.hasBadges ? _react2.default.createElement(
	                        'div',
	                        { className: 'badge-wrapper' },
	                        this.state.responseData.outcome.badges.map(function (badge) {
	                            return _react2.default.createElement(_BadgeCollect2.default, { key: badge.badge_id, badge_id: badge.badge_id,
	                                bite_id: _this3.props.callbacks.getBiteId(),
	                                asset_id: _this3.state.screenObject.asset_id,
	                                onCollected: _this3.onBadgeCollected,
	                                animate: _this3.state.animateBadge });
	                        })
	                    ) : null
	                ),
	                this.state.showProgression ? _react2.default.createElement(_Button2.default, { label: this.state.progression_label, id: this.state.screenObject.asset_id + '_button',
	                    onClick: this.onProgressionClicked }) : null
	            );
	        }
	    }]);
	
	    return MultipleAnswer;
	}(_react2.default.Component);
	
	MultipleAnswer.propTypes = {
	    screenObject: _propTypes2.default.object.isRequired,
	    callbacks: _propTypes2.default.object.isRequired,
	    characterPose: _propTypes2.default.object,
	    index: _propTypes2.default.number,
	    contentData: _propTypes2.default.object.isRequired,
	    trackingData: _propTypes2.default.object.isRequired,
	    userData: _propTypes2.default.object.isRequired,
	    lang: _propTypes2.default.string.isRequired,
	    actions: _propTypes2.default.object.isRequired
	};
	
	MultipleAnswer.contextTypes = {
	    router: _propTypes2.default.object
	};
	
	function mapStateToProps(state) {
	    var lang = state.userData.lang;
	    return {
	        lang: lang,
	        contentData: state.contentData,
	        trackingData: state.trackingData,
	        userData: state.userData
	
	    };
	}
	
	function mapDispatchToProps(dispatch) {
	    return {
	        actions: (0, _redux.bindActionCreators)(Object.assign({}, appDataActions, trackingDataActions, dialogPopupActions), dispatch)
	    };
	}
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(MultipleAnswer);

/***/ },
/* 500 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(5);
	
	var _redux = __webpack_require__(4);
	
	var _appDataActions = __webpack_require__(12);
	
	var appDataActions = _interopRequireWildcard(_appDataActions);
	
	var _OptionFeedback = __webpack_require__(199);
	
	var _OptionFeedback2 = _interopRequireDefault(_OptionFeedback);
	
	var _Button = __webpack_require__(18);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _ScoreKpi = __webpack_require__(198);
	
	var _ScoreKpi2 = _interopRequireDefault(_ScoreKpi);
	
	var _BadgeCollect = __webpack_require__(47);
	
	var _BadgeCollect2 = _interopRequireDefault(_BadgeCollect);
	
	var _ChildConversationDialog = __webpack_require__(65);
	
	var _ChildConversationDialog2 = _interopRequireDefault(_ChildConversationDialog);
	
	var _ResourceLinks = __webpack_require__(48);
	
	var _ResourceLinks2 = _interopRequireDefault(_ResourceLinks);
	
	var _trackingDataActions = __webpack_require__(7);
	
	var trackingDataActions = _interopRequireWildcard(_trackingDataActions);
	
	var _userDataActions = __webpack_require__(20);
	
	var userDataActions = _interopRequireWildcard(_userDataActions);
	
	var _appHelper = __webpack_require__(3);
	
	var appHelper = _interopRequireWildcard(_appHelper);
	
	var _dataHelper = __webpack_require__(11);
	
	var dataHelper = _interopRequireWildcard(_dataHelper);
	
	var _objectConstants = __webpack_require__(9);
	
	var objectConstants = _interopRequireWildcard(_objectConstants);
	
	var _kpiConstants = __webpack_require__(37);
	
	var kpiConstants = _interopRequireWildcard(_kpiConstants);
	
	var _localStorage = __webpack_require__(17);
	
	var localStorage = _interopRequireWildcard(_localStorage);
	
	var _appConstants = __webpack_require__(13);
	
	var appConstants = _interopRequireWildcard(_appConstants);
	
	var _keyboardConstants = __webpack_require__(14);
	
	var keyboardConstants = _interopRequireWildcard(_keyboardConstants);
	
	var _gsap = __webpack_require__(8);
	
	var _gsapReactPlugin = __webpack_require__(10);
	
	var _gsapReactPlugin2 = _interopRequireDefault(_gsapReactPlugin);
	
	var _lodash = __webpack_require__(28);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } //eslint-disable-line import/no-named-as-default
	//eslint-disable-line import/no-named-as-default
	//eslint-disable-line import/no-named-as-default
	
	
	var MultipleAnswerFeedback = function (_React$Component) {
	    _inherits(MultipleAnswerFeedback, _React$Component);
	
	    function MultipleAnswerFeedback(props, context) {
	        _classCallCheck(this, MultipleAnswerFeedback);
	
	        var _this = _possibleConstructorReturn(this, (MultipleAnswerFeedback.__proto__ || Object.getPrototypeOf(MultipleAnswerFeedback)).call(this, props, context));
	
	        _this.state = {
	            lang: _this.props.lang,
	            options: _this.props.options,
	            locale: appHelper.getLocalData(_this.props.responseData.outcome),
	            hideFeedback: _this.props.hideFeedback,
	            showFeedbackContent: false,
	            showKpis: appHelper.isDefined(_this.props.responseData.outcome.kpis) && _this.props.responseData.outcome.kpis.length > 0,
	            showProgression: false,
	            enableProgression: appHelper.isDefined(_this.props.responseData.outcome.kpis) && _this.props.responseData.outcome.kpis.length === 0,
	            optionFeedback: [],
	            kpiDashboardParams: {
	                showTitle: false,
	                showImmediateImpact: true,
	                allowUpdates: false
	            },
	            hasDialogs: false,
	            dialogComplete: true,
	            hasBadges: appHelper.isDefined(_this.props.responseData.outcome.badges) && _this.props.responseData.outcome.badges.length > 0,
	            badgesCollected: false,
	            resourceLinks: [],
	            hasResources: false,
	            resourcesAreComplete: true,
	            missedOptions: {
	                show: false,
	                options: []
	            },
	            completionCalled: false,
	            feedbackInterval: {},
	            review_other_options_label: appHelper.getLocaleString("review_other_options_label"),
	            updateLocale: false
	        };
	        _this.show = _this.show.bind(_this);
	        _this.onFeedbackRevealed = _this.onFeedbackRevealed.bind(_this);
	        _this.onFeedbackHidden = _this.onFeedbackHidden.bind(_this);
	        _this.onProgressionClicked = _this.onProgressionClicked.bind(_this);
	        _this.handleOptionFeedback = _this.handleOptionFeedback.bind(_this);
	        _this.scrollToTop = _this.scrollToTop.bind(_this);
	        _this.storeUserResponse = _this.storeUserResponse.bind(_this);
	        _this.enableProgression = _this.enableProgression.bind(_this);
	        _this.getLinkClass = _this.getLinkClass.bind(_this);
	        _this.getDisabledState = _this.getDisabledState.bind(_this);
	        _this.onKeyMessageToolboxComplete = _this.onKeyMessageToolboxComplete.bind(_this);
	        _this.setKeyMessageToolboxCallbacks = _this.setKeyMessageToolboxCallbacks.bind(_this);
	        _this.checkAllKeyMessageToolboxesComplete = _this.checkAllKeyMessageToolboxesComplete.bind(_this);
	        _this.getAssets = _this.getAssets.bind(_this);
	        _this.getImagePath = _this.getImagePath.bind(_this);
	        _this.dialogsOnComplete = _this.dialogsOnComplete.bind(_this);
	        _this.onBadgeCollected = _this.onBadgeCollected.bind(_this);
	        _this.onResourcesComplete = _this.onResourcesComplete.bind(_this);
	        _this.setResources = _this.setResources.bind(_this);
	        _this.getMissedOptions = _this.getMissedOptions.bind(_this);
	        _this.checkIsReadyToComplete = _this.checkIsReadyToComplete.bind(_this);
	        _this.setComplete = _this.setComplete.bind(_this);
	        _this.showProgressButton = _this.showProgressButton.bind(_this);
	        _this.setKeyboardAccessibility = _this.setKeyboardAccessibility.bind(_this);
	        _this.onReview = _this.onReview.bind(_this);
	        _this.setFeedbackInterval = _this.setFeedbackInterval.bind(_this);
	        _this.checkShowProgressButton = _this.checkShowProgressButton.bind(_this);
	        return _this;
	    }
	
	    _createClass(MultipleAnswerFeedback, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            if (appHelper.isDefined(this.props.callbacks.updateCharacterExpression) && appHelper.isDefined(this.props.responseData.outcome.character_pose)) {
	                this.props.callbacks.updateCharacterExpression(this.props.responseData.outcome.character_pose);
	            }
	            //this.setResources();
	            this.getAssets();
	            this.getMissedOptions();
	            this.handleOptionFeedback();
	            this.setFeedbackInterval();
	            this.show();
	        }
	    }, {
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(nextProps) {
	            if (this.state.hideFeedback !== nextProps.hideFeedback) {
	                this.setState({ hideFeedback: nextProps.hideFeedback });
	            }
	            if (this.state.lang !== nextProps.lang) {
	                this.setState({
	                    lang: nextProps.lang,
	                    locale: appHelper.getLocalData(this.props.responseData.outcome),
	                    review_other_options_label: appHelper.getLocaleString("review_other_options_label"),
	                    updateLocale: true
	                });
	            }
	        }
	    }, {
	        key: 'componentDidUpdate',
	        value: function componentDidUpdate() {
	            if (this.checkIsReadyToComplete()) {
	                this.setComplete();
	            }
	
	            if (this.state.hideFeedback) {
	                this.hide();
	            }
	
	            if (this.state.updateLocale) {
	                this.handleOptionFeedback();
	            }
	        }
	    }, {
	        key: 'componentWillUnmount',
	        value: function componentWillUnmount() {
	            clearInterval(this.state.feedbackInterval);
	        }
	    }, {
	        key: 'setFeedbackInterval',
	        value: function setFeedbackInterval() {
	            var interval = setInterval(this.checkShowProgressButton, 500);
	            this.setState({ feedbackInterval: interval });
	        }
	    }, {
	        key: 'checkShowProgressButton',
	        value: function checkShowProgressButton() {
	            if (this.showProgressButton()) {
	                this.props.onEnableProgression(this.state.locale.progression_label);
	                clearInterval(this.state.feedbackInterval);
	            }
	        }
	    }, {
	        key: 'storeUserResponse',
	        value: function storeUserResponse() {
	            //console.log(`storeUserResponse`);
	            var selectedOptions = [];
	            for (var i = 0; i < this.props.responseData.checkedOptions.length; i++) {
	                var selectedOption = this.props.responseData.checkedOptions[i];
	                selectedOptions = dataHelper.immutablePush(selectedOptions, selectedOption.option_id);
	            }
	
	            var responseObj = {
	                asset_id: this.props.asset_id,
	                selectedOptions: selectedOptions,
	                kpis: !appHelper.isDefined(this.props.responseData.outcome.kpis) || this.props.responseData.outcome.kpis !== null ? this.props.responseData.outcome.kpis : []
	            };
	
	            //console.log(responseObj);
	            //console.log(this.props.callbacks);
	            this.props.callbacks.storeUserResponse(responseObj);
	        }
	    }, {
	        key: 'getLocale',
	        value: function getLocale() {
	            this.setState({ locale: Object.assign({}, appHelper.getLocalData(this.props.responseData.outcome)) });
	        }
	    }, {
	        key: 'getImagePath',
	        value: function getImagePath(image) {
	            if (appConstants.DEVELOPMENT_MODE) {
	                if (appHelper.isDefined(image) && image.length > 0) {
	                    return __webpack_require__(16)("./" + image);
	                }
	            } else {
	                return image;
	            }
	        }
	    }, {
	        key: 'getAssets',
	        value: function getAssets() {
	            if (appHelper.isDefined(this.props.responseData.outcome.assets)) {
	                var imageAsset = appHelper.getImageAsset(this.props.responseData.outcome.assets);
	                //imageAsset = appHelper.isDefined(imageAsset.locale) ? appHelper.getLocalData(imageAsset) : imageAsset;
	
	                if (appHelper.isDefined(imageAsset) && imageAsset.src.length > 0) {
	                    this.setState({ imageAsset: imageAsset });
	                }
	            }
	
	            if (appHelper.isDefined(this.props.responseData.outcome.audio)) {
	                var audio = appHelper.getAudioAsset(this.props.responseData.outcome.audio);
	                var audioObj = {
	                    audioRef: 'audio_' + audio.id + '_' + audio.type
	                };
	
	                this.props.actions.setAudio(audioObj);
	            }
	        }
	    }, {
	        key: 'onFeedbackRevealed',
	        value: function onFeedbackRevealed() {
	            this.storeUserResponse();
	            this.scrollToTop();
	        }
	    }, {
	        key: 'scrollToTop',
	        value: function scrollToTop() {
	            var feedback = document.getElementById('feedback_wrapper_' + this.props.asset_id);
	            this.props.callbacks.scrollToFeedback(feedback.offsetTop);
	        }
	    }, {
	        key: 'enableProgression',
	        value: function enableProgression() {
	            this.setState({ enableProgression: true });
	        }
	    }, {
	        key: 'getLinkClass',
	        value: function getLinkClass() {
	            return this.state.enableProgression ? "" : "disabled-link";
	        }
	    }, {
	        key: 'getDisabledState',
	        value: function getDisabledState() {
	            return !this.state.enableProgression;
	        }
	    }, {
	        key: 'handleOptionFeedback',
	        value: function handleOptionFeedback() {
	            this.setState({ updateLocale: false });
	            var optionFeeback = [];
	            var resources = [];
	
	            //set parent array with feedback
	            for (var i = 0; i < this.state.options.length; i++) {
	                var option = this.state.options[i];
	                var locale = appHelper.getLocalData(option);
	                var feedback = "";
	
	                if (appHelper.isDefined(locale.feedback) && locale.feedback.length > 0 && locale.feedback !== "<p><br></p>") {
	                    feedback = locale.feedback;
	                } else if (appHelper.isDefined(option.feedback_id)) {
	                    var feedbackOption = appHelper.getArrayObjectByKey(this.state.options, "option_id", option.feedback_id);
	                    var feedbackOptionLocale = appHelper.getLocalData(feedbackOption);
	                    feedback = feedbackOptionLocale.feedback;
	                }
	                var feedbackObj = {
	                    option_id: option.option_id,
	                    feedback: feedback,
	                    options: [],
	                    checked: false
	                };
	
	                optionFeeback = dataHelper.immutablePush(optionFeeback, feedbackObj);
	            }
	
	            for (var o = 0; o < this.state.options.length; o++) {
	                var _option = this.state.options[o];
	                var _locale = appHelper.getLocalData(_option);
	                var optionCheckedIndex = appHelper.getArrayObjectIndexByKey(this.props.responseData.checkedOptions, "option_id", _option.option_id);
	                var optionObject = {
	                    result: _option.result,
	                    className: optionCheckedIndex > -1 ? 'checked' : 'unchecked',
	                    option_text: _locale.option,
	                    option_id: _option.option_id,
	                    kpis: appHelper.isDefined(_option.kpis) && _option.kpis !== null ? _option.kpis : []
	                };
	
	                //if (optionCheckedIndex > -1 || this.props.responseData.outcome.result !== objectConstants.RESULT_BEST && option.result === objectConstants.RESULT_BEST && this.props.responseData.outcome.progression === objectConstants.OBJECT_PROGRESSION_CONTINUE) {
	                if (optionCheckedIndex > -1) {
	                    if (!appHelper.isDefined(_option.feedback_id)) {
	                        var optionFeedbackObj = appHelper.getArrayObjectByKey(optionFeeback, "option_id", _option.option_id);
	                        var optionFeedbackObjIndex = appHelper.getArrayObjectIndexByKey(optionFeeback, "option_id", _option.option_id);
	
	                        optionFeedbackObj = Object.assign({}, optionFeedbackObj, {
	                            options: dataHelper.immutablePush(optionFeedbackObj.options, optionObject),
	                            checked: !optionFeedbackObj.checked && optionCheckedIndex > -1
	                        });
	                        optionFeeback = dataHelper.immutableSplice(optionFeeback, optionFeedbackObjIndex, 1, optionFeedbackObj);
	                    } else {
	                        var _optionFeedbackObj = appHelper.getArrayObjectByKey(optionFeeback, "option_id", _option.feedback_id);
	                        var _optionFeedbackObjIndex = appHelper.getArrayObjectIndexByKey(optionFeeback, "option_id", _option.feedback_id);
	
	                        _optionFeedbackObj = Object.assign({}, _optionFeedbackObj, {
	                            options: dataHelper.immutablePush(_optionFeedbackObj.options, optionObject),
	                            checked: !_optionFeedbackObj.checked && optionCheckedIndex > -1
	                        });
	                        optionFeeback = dataHelper.immutableSplice(optionFeeback, _optionFeedbackObjIndex, 1, _optionFeedbackObj);
	                    }
	
	                    var resourceLinks = appHelper.setResourceLinks(_option);
	                    _lodash2.default.forEach(resourceLinks, function (resource) {
	                        resources = dataHelper.immutablePush(resources, resource);
	                    });
	                }
	            }
	
	            if (optionFeeback.length > 1) {
	
	                optionFeeback.sort(function (a, b) {
	                    if (a.checked > b.checked) return -1;
	                    if (a.checked < b.checked) return 1;
	                    return 0;
	                });
	            }
	
	            this.setState({ optionFeedback: Object.assign([], optionFeeback) });
	
	            this.setResources(resources);
	        }
	    }, {
	        key: 'getMissedOptions',
	        value: function getMissedOptions() {
	            var missedOptions = [];
	            for (var o = 0; o < this.state.options.length; o++) {
	                var option = this.state.options[o];
	                var locale = appHelper.getLocalData(option);
	                var optionCheckedIndex = appHelper.getArrayObjectIndexByKey(this.props.responseData.checkedOptions, "option_id", option.option_id);
	                var optionObject = {
	                    result: option.result,
	                    className: optionCheckedIndex > -1 ? 'checked' : 'unchecked',
	                    option_text: locale.option,
	                    option_id: option.option_id
	                };
	                if (optionCheckedIndex === -1 && this.props.responseData.outcome.result !== objectConstants.RESULT_BEST && option.result === objectConstants.RESULT_BEST && this.props.responseData.outcome.progression === objectConstants.OBJECT_PROGRESSION_CONTINUE) {
	                    missedOptions = dataHelper.immutablePush(missedOptions, optionObject);
	                }
	            }
	            if (missedOptions.length > 0) {
	                this.setState({ missedOptions: Object.assign({}, this.state.missedOptions, {
	                        show: true,
	                        options: Object.assign([], missedOptions)
	                    }) });
	            }
	        }
	    }, {
	        key: 'onFeedbackHidden',
	        value: function onFeedbackHidden() {
	            this.setState({
	                //showResponse: false,
	                showFeedbackContent: false,
	                showKpis: false,
	                showProgression: false
	            });
	            //this.props.callbacks.resizeWatcher();
	            if (typeof this.props.onComplete !== 'undefined') {
	                this.props.onComplete();
	            }
	        }
	    }, {
	        key: 'onProgressionClicked',
	        value: function onProgressionClicked() {
	            this.hide();
	        }
	    }, {
	        key: 'show',
	        value: function show() {
	
	            var feedbackPanel = this.refs[this.props.asset_id + '_feedbackPanel'];
	            _gsap.TweenLite.set(feedbackPanel, { height: "auto", opacity: 1 });
	            _gsap.TweenLite.from(feedbackPanel, objectConstants.FEEDBACK_DURATION, {
	                height: 0,
	                opacity: 0,
	                ease: _gsap.Linear.easeIn
	            }).eventCallback("onComplete", this.onFeedbackRevealed);
	        }
	    }, {
	        key: 'hide',
	        value: function hide() {
	            this.setState({ hideFeedback: false });
	            var feedbackPanel = this.refs[this.props.asset_id + '_feedbackPanel'];
	
	            _gsap.TweenLite.to(feedbackPanel, objectConstants.FEEDBACK_DURATION, {
	                height: 0,
	                opacity: 0,
	                ease: _gsap.Expo.easeInOut
	            }).eventCallback("onComplete", this.onFeedbackHidden);
	        }
	    }, {
	        key: 'onToolboxComplete',
	        value: function onToolboxComplete() {
	            this.setState({ toolboxIsComplete: true });
	        }
	    }, {
	        key: 'setToolboxCallbacks',
	        value: function setToolboxCallbacks() {
	            this.setState({
	                toolboxCallbacks: Object.assign({}, this.state.toolboxCallbacks, {
	                    onObjectComplete: this.onToolboxComplete,
	                    isReviewMode: function isReviewMode() {
	                        return false;
	                    }
	                })
	            });
	        }
	    }, {
	        key: 'onKeyMessageToolboxComplete',
	        value: function onKeyMessageToolboxComplete() {
	            this.setState({
	                completeKeyMessageToolboxes: this.state.completeKeyMessageToolboxes + 1,
	                checkKeyMessageToolboxesCount: true
	            });
	            //console.log(`onKeyMessageToolboxComplete ${this.state.keyMessagesToolbox.length}`);
	            //this.setState({keyMessageToolboxIsComplete: true});
	        }
	    }, {
	        key: 'checkAllKeyMessageToolboxesComplete',
	        value: function checkAllKeyMessageToolboxesComplete() {
	
	            this.setState({
	                checkKeyMessageToolboxesCount: false,
	                keyMessageToolboxIsComplete: this.state.completeKeyMessageToolboxes >= this.state.keyMessagesToolbox.length
	            });
	        }
	    }, {
	        key: 'setKeyMessageToolboxCallbacks',
	        value: function setKeyMessageToolboxCallbacks() {
	            this.setState({
	                keyMessageToolboxCallbacks: Object.assign({}, this.state.keyMessageToolboxCallbacks, {
	                    onObjectComplete: this.onKeyMessageToolboxComplete,
	                    isReviewMode: function isReviewMode() {
	                        return false;
	                    }
	                })
	            });
	        }
	    }, {
	        key: 'onBadgeCollected',
	        value: function onBadgeCollected() {
	            this.setState({ badgesCollected: true });
	            //this.hide();
	        }
	    }, {
	        key: 'dialogsOnComplete',
	        value: function dialogsOnComplete() {
	            this.setState({ dialogComplete: true });
	        }
	    }, {
	        key: 'setResources',
	        value: function setResources(resources) {
	            var outcomeLinks = appHelper.setResourceLinks(this.props.responseData.outcome);
	            var resourceLinks = [].concat(_toConsumableArray(resources), _toConsumableArray(outcomeLinks));
	            var hasRequiredResources = appHelper.hasRequiredResources(resourceLinks);
	            this.setState({
	                resourceLinks: Object.assign([], resourceLinks),
	                hasResources: resourceLinks.length > 0,
	                resourcesAreComplete: resourceLinks.length === 0 || !hasRequiredResources
	            });
	        }
	    }, {
	        key: 'onResourcesComplete',
	        value: function onResourcesComplete() {
	            if (!this.state.resourcesAreComplete) {
	                this.setState({ resourcesAreComplete: true, checkComplete: true });
	            }
	        }
	    }, {
	        key: 'checkIsReadyToComplete',
	        value: function checkIsReadyToComplete() {
	            return !this.props.callbacks.hasNextObject(this.props.index) && this.props.responseData.outcome.progression !== objectConstants.OBJECT_PROGRESSION_TRY_AGAIN && this.state.enableProgression && !this.state.completionCalled
	            //&& ((this.state.hasBadges && this.state.badgesCollected) || !this.state.hasBadges )
	            && this.state.resourcesAreComplete;
	        }
	    }, {
	        key: 'setComplete',
	        value: function setComplete() {
	            this.setState({ completionCalled: true });
	            this.props.onComplete();
	        }
	    }, {
	        key: 'showProgressButton',
	        value: function showProgressButton() {
	            /*return (
	                (!this.props.callbacks.hasNextObject(this.props.screenObject) && this.props.responseData.outcome.progression === objectConstants.OBJECT_PROGRESSION_TRY_AGAIN) || this.props.callbacks.hasNextObject(this.props.screenObject))
	                && appHelper.isDefined(this.state.locale.progression_label)
	                && ((this.state.hasBadges && this.state.badgesCollected) || !this.state.hasBadges )
	                && this.state.resourcesAreComplete;*/
	
	            return this.state.enableProgression && appHelper.isDefined(this.state.locale.progression_label)
	            // && ((this.state.hasBadges && this.state.badgesCollected) || !this.state.hasBadges )
	            && this.state.resourcesAreComplete;
	        }
	    }, {
	        key: 'setKeyboardAccessibility',
	        value: function setKeyboardAccessibility(event) {
	
	            if (event.which === keyboardConstants.ENTER_KEY || event.which === keyboardConstants.SPACEBAR_KEY) {
	                event.preventDefault();
	                if (this.state.enableProgression) {
	                    this.onReview();
	                }
	            }
	        }
	    }, {
	        key: 'onReview',
	        value: function onReview() {
	            this.props.onShowReview('review_link_' + this.props.asset_id);
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            return _react2.default.createElement(
	                'div',
	                { className: 'feedback-panel ' + this.props.responseData.outcome.result,
	                    ref: this.props.asset_id + '_feedbackPanel' },
	                _react2.default.createElement('img', { src: __webpack_require__(133)("./" + this.props.responseData.outcome.result + '.svg'), style: kpiConstants.WATERMARK_STYLES, alt: '' }),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'feedback-content-col' },
	                    this.state.showKpis ? _react2.default.createElement(_ScoreKpi2.default, { bite_id: this.props.responseData.bite_id,
	                        displayState: kpiConstants.KPI_DISPLAY_STATE_CURRENT_VALUE_NO_LABEL,
	                        showImmediateImpact: this.state.kpiDashboardParams.showImmediateImpact,
	                        showTitle: this.state.kpiDashboardParams.showTitle,
	                        onUpdateComplete: this.enableProgression }) : null,
	                    appHelper.isDefined(this.state.locale.feedback) && this.state.dialogComplete && this.state.locale.feedback !== "<p><br></p>" && this.props.responseData.outcome.enable_feedback ? _react2.default.createElement('div', { dangerouslySetInnerHTML: { __html: this.state.locale.feedback } }) : null,
	                    this.state.optionFeedback.length > 0 && this.state.dialogComplete && this.props.responseData.outcome.enable_feedback ? _react2.default.createElement(_OptionFeedback2.default, { feedback_options: this.state.optionFeedback,
	                        asset_id: this.props.asset_id,
	                        responseData: this.props.responseData,
	                        missedOptions: this.state.missedOptions }) : null,
	                    this.state.hasResources ? _react2.default.createElement(_ResourceLinks2.default, { resources: this.state.resourceLinks,
	                        onResourcesComplete: this.onResourcesComplete }) : null,
	                    this.props.responseData.outcome.progression === objectConstants.OBJECT_PROGRESSION_CONTINUE && this.state.dialogComplete && this.state.resourcesAreComplete && this.props.contentData.experience.include_explore_feedback ? _react2.default.createElement(
	                        'div',
	                        { className: 'guroo-active-link text-center ' + this.getLinkClass(), role: 'link', tabIndex: '0',
	                            id: 'review_link_' + this.props.asset_id,
	                            onKeyDown: this.setKeyboardAccessibility,
	                            onClick: this.onReview },
	                        this.state.review_other_options_label
	                    ) : null
	                )
	            );
	        }
	    }]);
	
	    return MultipleAnswerFeedback;
	}(_react2.default.Component);
	
	/*
	*  {this.state.keyMessages.length > 0
	                        ? <KeyMessages key_messages={this.state.keyMessages}
	                                       asset_id={this.props.asset_id}
	                                       toolboxCallbacks={this.state.keyMessageToolboxCallbacks}
	                                       onComplete={this.showProgressionButton}/>
	                        : null
	                    }*/
	
	
	MultipleAnswerFeedback.propTypes = {
	    screenObject: _propTypes2.default.object,
	    options: _propTypes2.default.array.isRequired,
	    key_messages: _propTypes2.default.array,
	    responseData: _propTypes2.default.object.isRequired,
	    callbacks: _propTypes2.default.object.isRequired,
	    asset_id: _propTypes2.default.number.isRequired,
	    index: _propTypes2.default.number,
	    onShowReview: _propTypes2.default.func,
	    onComplete: _propTypes2.default.func,
	    onEnableProgression: _propTypes2.default.func,
	    hideFeedback: _propTypes2.default.bool,
	    contentData: _propTypes2.default.object.isRequired,
	    lang: _propTypes2.default.string.isRequired,
	    actions: _propTypes2.default.object
	};
	
	MultipleAnswerFeedback.contextTypes = {
	    router: _propTypes2.default.object
	};
	
	function mapStateToProps(state) {
	    var lang = state.userData.lang;
	    return {
	        lang: lang,
	        contentData: state.contentData
	    };
	}
	
	function mapDispatchToProps(dispatch) {
	    return {
	        actions: (0, _redux.bindActionCreators)(Object.assign({}, appDataActions, trackingDataActions, userDataActions), dispatch)
	    };
	}
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(MultipleAnswerFeedback);

/***/ },
/* 501 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(5);
	
	var _redux = __webpack_require__(4);
	
	var _ChildConversationDialog = __webpack_require__(65);
	
	var _ChildConversationDialog2 = _interopRequireDefault(_ChildConversationDialog);
	
	var _ResourceLinks = __webpack_require__(48);
	
	var _ResourceLinks2 = _interopRequireDefault(_ResourceLinks);
	
	var _trackingDataActions = __webpack_require__(7);
	
	var trackingDataActions = _interopRequireWildcard(_trackingDataActions);
	
	var _userDataActions = __webpack_require__(20);
	
	var userDataActions = _interopRequireWildcard(_userDataActions);
	
	var _appHelper = __webpack_require__(3);
	
	var appHelper = _interopRequireWildcard(_appHelper);
	
	var _dataHelper = __webpack_require__(11);
	
	var dataHelper = _interopRequireWildcard(_dataHelper);
	
	var _objectConstants = __webpack_require__(9);
	
	var objectConstants = _interopRequireWildcard(_objectConstants);
	
	var _kpiConstants = __webpack_require__(37);
	
	var kpiConstants = _interopRequireWildcard(_kpiConstants);
	
	var _gsap = __webpack_require__(8);
	
	var _gsapReactPlugin = __webpack_require__(10);
	
	var _gsapReactPlugin2 = _interopRequireDefault(_gsapReactPlugin);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var MultipleAnswerFeedbackReview = function (_React$Component) {
	    _inherits(MultipleAnswerFeedbackReview, _React$Component);
	
	    function MultipleAnswerFeedbackReview(props, context) {
	        _classCallCheck(this, MultipleAnswerFeedbackReview);
	
	        var _this = _possibleConstructorReturn(this, (MultipleAnswerFeedbackReview.__proto__ || Object.getPrototypeOf(MultipleAnswerFeedbackReview)).call(this, props, context));
	
	        _this.state = {
	            lang: _this.props.lang,
	            options: _this.props.options,
	            locale: appHelper.getLocalData(_this.props.responseData.outcome),
	            showFeedbackContent: false,
	            showKpis: appHelper.isDefined(_this.props.responseData.outcome.kpis) && _this.props.responseData.outcome.kpis.length > 0,
	            showProgression: false,
	            kpiDashboardParams: {
	                responseReview: true,
	                showTitle: false,
	                showImmediateImpact: true,
	                allowUpdates: false
	            },
	            hasDialogs: appHelper.isDefined(_this.props.responseData.outcome.dialogs) && _this.props.responseData.outcome.dialogs.length > 0,
	            dialogComplete: !appHelper.isDefined(_this.props.responseData.outcome.dialogs) || _this.props.responseData.outcome.dialogs.length === 0,
	            callbacks: {},
	            resourceLinks: [],
	            hasResources: false,
	            resourcesAreComplete: true
	        };
	        _this.show = _this.show.bind(_this);
	        _this.showFeedbackContent = _this.showFeedbackContent.bind(_this);
	        _this.showKpiDashboard = _this.showKpiDashboard.bind(_this);
	        _this.showProgressionButton = _this.showProgressionButton.bind(_this);
	        _this.onFeedbackRevealed = _this.onFeedbackRevealed.bind(_this);
	        _this.onFeedbackHidden = _this.onFeedbackHidden.bind(_this);
	        _this.onProgressionClicked = _this.onProgressionClicked.bind(_this);
	        _this.dialogsOnComplete = _this.dialogsOnComplete.bind(_this);
	        _this.setCallbacks = _this.setCallbacks.bind(_this);
	        _this.onResourcesComplete = _this.onResourcesComplete.bind(_this);
	        _this.setResources = _this.setResources.bind(_this);
	        return _this;
	    }
	
	    _createClass(MultipleAnswerFeedbackReview, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            this.setCallbacks();
	            this.setResources();
	            this.show();
	        }
	    }, {
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(nextProps) {
	            if (this.state.lang !== nextProps.lang) {
	                this.setState({
	                    lang: nextProps.lang,
	                    locale: appHelper.getLocalData(this.props.responseData.outcome)
	                });
	            }
	        }
	    }, {
	        key: 'onFeedbackRevealed',
	        value: function onFeedbackRevealed() {
	            //this.setState({showResponse: true});
	            this.showKpiDashboard();
	        }
	    }, {
	        key: 'onFeedbackHidden',
	        value: function onFeedbackHidden() {
	            this.setState({
	                //showResponse: false,
	                showFeedbackContent: false,
	                showKpis: false,
	                showProgression: false
	            });
	        }
	    }, {
	        key: 'showFeedbackContent',
	        value: function showFeedbackContent() {
	            this.setState({ showFeedbackContent: true });
	        }
	    }, {
	        key: 'showKpiDashboard',
	        value: function showKpiDashboard() {
	            if (appHelper.isDefined(this.props.responseData.outcome.kpis) && this.props.responseData.outcome.kpis.length > 0) {
	                this.setState({ showKpis: true });
	            } else {
	                this.showFeedbackContent();
	            }
	        }
	    }, {
	        key: 'showProgressionButton',
	        value: function showProgressionButton() {
	            var selectedOptions = [];
	            for (var i = 0; i < this.props.responseData.checkedOptions.length; i++) {
	                var selectedOption = this.props.responseData.checkedOptions[i];
	                selectedOptions = dataHelper.immutablePush(selectedOptions, selectedOption.option_id);
	            }
	            this.setState({ showProgression: true });
	        }
	    }, {
	        key: 'onProgressionClicked',
	        value: function onProgressionClicked() {
	            this.hide();
	        }
	    }, {
	        key: 'show',
	        value: function show() {
	
	            var feedbackPanel = this.refs[this.props.asset_id + '_feedbackPanel'];
	            _gsap.TweenLite.set(feedbackPanel, { height: "auto", opacity: 1 });
	            _gsap.TweenLite.from(feedbackPanel, objectConstants.FEEDBACK_DURATION, {
	                height: 0,
	                opacity: 0,
	                ease: _gsap.Linear.easeIn
	            }).eventCallback("onComplete", this.onFeedbackRevealed);
	        }
	    }, {
	        key: 'hide',
	        value: function hide() {
	            var feedbackPanel = this.refs[this.props.asset_id + '_feedbackPanel'];
	
	            _gsap.TweenLite.to(feedbackPanel, objectConstants.FEEDBACK_DURATION, {
	                height: 0,
	                opacity: 0,
	                ease: _gsap.Linear.easeIn
	            }).eventCallback("onComplete", this.onFeedbackHidden);
	        }
	    }, {
	        key: 'dialogsOnComplete',
	        value: function dialogsOnComplete() {
	            this.setState({ dialogComplete: true });
	        }
	    }, {
	        key: 'setCallbacks',
	        value: function setCallbacks() {}
	    }, {
	        key: 'setResources',
	        value: function setResources() {
	            var resourceLinks = appHelper.setResourceLinks(this.props.responseData.outcome);
	
	            this.setState({
	                resourceLinks: Object.assign([], resourceLinks),
	                hasResources: resourceLinks.length > 0
	            });
	        }
	    }, {
	        key: 'onResourcesComplete',
	        value: function onResourcesComplete() {
	            if (!this.state.resourcesAreComplete) {
	                this.setState({ resourcesAreComplete: true, checkComplete: true });
	            }
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            return _react2.default.createElement(
	                'div',
	                { className: 'clear-both' },
	                this.state.hasDialogs ? _react2.default.createElement(_ChildConversationDialog2.default, { asset_id: this.props.asset_id, option_id: this.props.responseData.outcome.option_id, dialogs: this.props.responseData.outcome.dialogs, callbacks: this.state.callbacks, onComplete: this.dialogsOnComplete }) : null,
	                _react2.default.createElement(
	                    'div',
	                    { className: 'feedback-panel ' + this.props.responseData.outcome.result, ref: this.props.asset_id + '_feedbackPanel' },
	                    _react2.default.createElement('img', { src: __webpack_require__(133)("./" + this.props.responseData.outcome.result + '.svg'), style: kpiConstants.WATERMARK_STYLES, alt: '' }),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'feedback-content-col' },
	                        appHelper.isDefined(this.state.locale.feedback) && this.state.dialogComplete ? _react2.default.createElement('div', { dangerouslySetInnerHTML: { __html: this.state.locale.feedback } }) : null,
	                        this.state.hasResources ? _react2.default.createElement(_ResourceLinks2.default, { resources: this.state.resourceLinks,
	                            onResourcesComplete: this.onResourcesComplete }) : null
	                    )
	                )
	            );
	        }
	    }]);
	
	    return MultipleAnswerFeedbackReview;
	}(_react2.default.Component);
	
	MultipleAnswerFeedbackReview.propTypes = {
	    options: _propTypes2.default.array.isRequired,
	    key_messages: _propTypes2.default.array,
	    responseData: _propTypes2.default.object.isRequired,
	    asset_id: _propTypes2.default.number.isRequired,
	    lang: _propTypes2.default.string.isRequired,
	    actions: _propTypes2.default.object
	};
	
	MultipleAnswerFeedbackReview.contextTypes = {
	    router: _propTypes2.default.object
	};
	
	function mapStateToProps(state) {
	    var lang = state.userData.lang;
	    return {
	        lang: lang
	    };
	}
	
	function mapDispatchToProps(dispatch) {
	    return {
	        actions: (0, _redux.bindActionCreators)(Object.assign({}, trackingDataActions, userDataActions), dispatch)
	    };
	}
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(MultipleAnswerFeedbackReview);

/***/ },
/* 502 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(5);
	
	var _redux = __webpack_require__(4);
	
	var _appDataActions = __webpack_require__(12);
	
	var appDataActions = _interopRequireWildcard(_appDataActions);
	
	var _trackingDataActions = __webpack_require__(7);
	
	var trackingDataActions = _interopRequireWildcard(_trackingDataActions);
	
	var _dialogPopupActions = __webpack_require__(19);
	
	var dialogPopupActions = _interopRequireWildcard(_dialogPopupActions);
	
	var _appHelper = __webpack_require__(3);
	
	var appHelper = _interopRequireWildcard(_appHelper);
	
	var _dataHelper = __webpack_require__(11);
	
	var dataHelper = _interopRequireWildcard(_dataHelper);
	
	var _userDataHelper = __webpack_require__(15);
	
	var userDataHelper = _interopRequireWildcard(_userDataHelper);
	
	var _objectConstants = __webpack_require__(9);
	
	var objectConstants = _interopRequireWildcard(_objectConstants);
	
	var _dialogModels = __webpack_require__(32);
	
	var _keyboardConstants = __webpack_require__(14);
	
	var keyboardConstants = _interopRequireWildcard(_keyboardConstants);
	
	var _gsap = __webpack_require__(8);
	
	var _gsapReactPlugin = __webpack_require__(10);
	
	var _gsapReactPlugin2 = _interopRequireDefault(_gsapReactPlugin);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var MultipleAnswerOption = function (_React$Component) {
	    _inherits(MultipleAnswerOption, _React$Component);
	
	    function MultipleAnswerOption(props, context) {
	        _classCallCheck(this, MultipleAnswerOption);
	
	        var _this = _possibleConstructorReturn(this, (MultipleAnswerOption.__proto__ || Object.getPrototypeOf(MultipleAnswerOption)).call(this, props, context));
	
	        _this.state = {
	            lang: _this.props.lang,
	            option: _this.props.option,
	            asset_id: _this.props.asset_id,
	            responseData: _this.props.responseData,
	            locale: appHelper.getLocalData(_this.props.option),
	            id: _this.props.asset_id + '_' + _this.props.option.option_id,
	            ref: 'ref_option_' + _this.props.option.option_id
	        };
	        _this.showOption = _this.showOption.bind(_this);
	        _this.onOptionRevealed = _this.onOptionRevealed.bind(_this);
	        _this.removeOption = _this.removeOption.bind(_this);
	        _this.getDisabledState = _this.getDisabledState.bind(_this);
	        _this.getCheckedState = _this.getCheckedState.bind(_this);
	        _this.getOptionClass = _this.getOptionClass.bind(_this);
	        _this.onClickFunction = _this.onClickFunction.bind(_this);
	        _this.renderOption = _this.renderOption.bind(_this);
	        _this.setKeyboardAccessibility = _this.setKeyboardAccessibility.bind(_this);
	        _this.getScreenReaderOptionClass = _this.getScreenReaderOptionClass.bind(_this);
	        return _this;
	    }
	
	    _createClass(MultipleAnswerOption, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            this.showOption(1, 0);
	        }
	    }, {
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(nextProps) {
	            if (this.state.responseData !== nextProps.responseData) {
	                this.setState({ responseData: Object.assign({}, nextProps.responseData) });
	            }
	
	            if (this.state.lang !== nextProps.lang) {
	                this.setState({
	                    lang: nextProps.lang,
	                    locale: appHelper.getLocalData(this.state.option)
	                });
	            }
	        }
	    }, {
	        key: 'componentDidUpdate',
	        value: function componentDidUpdate() {}
	    }, {
	        key: 'onClickFunction',
	        value: function onClickFunction() {
	            if (this.state.responseData.displayState === objectConstants.OBJECT_DISPLAY_STATE_REVIEW) {
	                this.props.onShowReview();
	            }
	        }
	    }, {
	        key: 'getOptionClass',
	        value: function getOptionClass() {
	            var checkedIndex = appHelper.getArrayObjectIndexByKey(this.state.responseData.checkedOptions, "option_id", this.state.option.option_id);
	            if (appHelper.isDefined(this.state.responseData.outcome.result) && checkedIndex > -1) {
	                return 'answered ' + this.state.option.result;
	            }
	        }
	    }, {
	        key: 'getScreenReaderOptionClass',
	        value: function getScreenReaderOptionClass() {
	            var checkedIndex = appHelper.getArrayObjectIndexByKey(this.state.responseData.checkedOptions, "option_id", this.state.option.option_id);
	            if (appHelper.isDefined(this.state.responseData.outcome.result) && checkedIndex > -1) {
	                return appHelper.getOptionResultString(this.state.option.result, false);
	            }
	        }
	    }, {
	        key: 'renderOption',
	        value: function renderOption() {
	            var responseData = this.state.responseData;
	            var latestResponse = appHelper.getLastItemOfArray(responseData.responses);
	            if (this.props.questionChecked && this.props.currentlyChecked) {
	                var checkedIndex = appHelper.getArrayObjectIndexByKey(this.state.responseData.checkedOptions, "option_id", this.state.option.option_id);
	                if (appHelper.isDefined(this.state.responseData.outcome.result) && checkedIndex > -1) {
	                    return true;
	                } else {
	                    return false;
	                }
	            } else {
	                return true;
	            }
	        }
	    }, {
	        key: 'getDisabledState',
	        value: function getDisabledState() {
	            if (appHelper.isDefined(this.state.responseData.outcome.result)) {
	                return 'disabled';
	            }
	            return null;
	        }
	    }, {
	        key: 'getCheckedState',
	        value: function getCheckedState() {
	            var checkedIndex = appHelper.getArrayObjectIndexByKey(this.state.responseData.checkedOptions, "option_id", this.state.option.option_id);
	            if (checkedIndex > -1) {
	                return 'checked';
	            }
	            return null;
	        }
	    }, {
	        key: 'showOption',
	        value: function showOption(duration, delay) {
	            var optionRef = this.refs[this.state.ref];
	            _gsap.TweenLite.set(optionRef, { height: "auto", opacity: 1 });
	            _gsap.TweenLite.from(optionRef, objectConstants.MC_OPTION_DURATION, {
	                height: 0,
	                opacity: 0,
	                delay: delay,
	                ease: _gsap.Expo.easeInOut
	            }).eventCallback("onComplete", this.onOptionRevealed);
	        }
	    }, {
	        key: 'onOptionRevealed',
	        value: function onOptionRevealed() {
	            this.props.onOptionRevealed(this.props.option);
	        }
	    }, {
	        key: 'removeOption',
	        value: function removeOption() {
	            //this.setState({render: false});
	        }
	    }, {
	        key: 'setKeyboardAccessibility',
	        value: function setKeyboardAccessibility(event) {
	            if (event.which === keyboardConstants.ENTER_KEY || event.which === keyboardConstants.SPACEBAR_KEY) {
	                event.preventDefault();
	                if (this.getDisabledState() !== 'disabled') {
	                    this.props.onOptionClick({ target: { value: this.state.option.option_id } });
	                }
	            }
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            return this.renderOption() ? _react2.default.createElement(
	                'div',
	                { className: 'multiple-choice-option ' + this.state.option.choice_type + ' ' + this.getOptionClass(), ref: this.state.ref, tabIndex: '0', role: 'button', onKeyDown: this.setKeyboardAccessibility },
	                _react2.default.createElement('input', { id: this.state.id,
	                    type: 'checkbox',
	                    disabled: this.getDisabledState(),
	                    checked: this.getCheckedState(),
	                    name: this.state.id,
	                    value: this.state.option.option_id,
	                    onChange: this.props.onOptionClick
	
	                }),
	                _react2.default.createElement(
	                    'label',
	                    { htmlFor: this.state.id },
	                    _react2.default.createElement('span', { dangerouslySetInnerHTML: { __html: this.state.locale.option } }),
	                    _react2.default.createElement(
	                        'span',
	                        { className: 'hidden-el' },
	                        this.getScreenReaderOptionClass()
	                    )
	                )
	            ) : null;
	        }
	    }]);
	
	    return MultipleAnswerOption;
	}(_react2.default.Component);
	
	MultipleAnswerOption.propTypes = {
	    option: _propTypes2.default.object.isRequired,
	    asset_id: _propTypes2.default.number.isRequired,
	    questionChecked: _propTypes2.default.bool.isRequired,
	    currentlyChecked: _propTypes2.default.bool.isRequired,
	    responseData: _propTypes2.default.object.isRequired,
	    index: _propTypes2.default.number.isRequired,
	    onOptionClick: _propTypes2.default.func,
	    onAttemptComplete: _propTypes2.default.func,
	    onShowReview: _propTypes2.default.func,
	    onOptionRevealed: _propTypes2.default.func,
	    callbacks: _propTypes2.default.object,
	    contentData: _propTypes2.default.object,
	    trackingData: _propTypes2.default.object,
	    userData: _propTypes2.default.object,
	    lang: _propTypes2.default.string.isRequired,
	    actions: _propTypes2.default.object
	};
	
	MultipleAnswerOption.contextTypes = {
	    router: _propTypes2.default.object
	};
	
	function mapStateToProps(state) {
	    var lang = state.userData.lang;
	    return {
	        lang: lang,
	        contentData: state.contentData,
	        trackingData: state.trackingData,
	        userData: state.userData
	
	    };
	}
	
	function mapDispatchToProps(dispatch) {
	    return {
	        actions: (0, _redux.bindActionCreators)(Object.assign({}, appDataActions, trackingDataActions, dialogPopupActions), dispatch)
	    };
	}
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(MultipleAnswerOption);

/***/ },
/* 503 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(5);
	
	var _redux = __webpack_require__(4);
	
	var _KpiDashboard = __webpack_require__(93);
	
	var _KpiDashboard2 = _interopRequireDefault(_KpiDashboard);
	
	var _dialogPopupActions = __webpack_require__(19);
	
	var dialogActions = _interopRequireWildcard(_dialogPopupActions);
	
	var _trackingDataActions = __webpack_require__(7);
	
	var trackingDataActions = _interopRequireWildcard(_trackingDataActions);
	
	var _appHelper = __webpack_require__(3);
	
	var appHelper = _interopRequireWildcard(_appHelper);
	
	var _kpiHelper = __webpack_require__(35);
	
	var kpiHelper = _interopRequireWildcard(_kpiHelper);
	
	var _objectConstants = __webpack_require__(9);
	
	var objectConstants = _interopRequireWildcard(_objectConstants);
	
	var _kpiConstants = __webpack_require__(37);
	
	var kpiConstants = _interopRequireWildcard(_kpiConstants);
	
	var _keyboardConstants = __webpack_require__(14);
	
	var keyboardConstants = _interopRequireWildcard(_keyboardConstants);
	
	var _gsap = __webpack_require__(8);
	
	var _gsapReactPlugin = __webpack_require__(10);
	
	var _gsapReactPlugin2 = _interopRequireDefault(_gsapReactPlugin);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } //eslint-disable-line import/no-named-as-default
	
	
	var MultipleAnswerOptionReview = function (_React$Component) {
	    _inherits(MultipleAnswerOptionReview, _React$Component);
	
	    function MultipleAnswerOptionReview(props, context) {
	        _classCallCheck(this, MultipleAnswerOptionReview);
	
	        var _this = _possibleConstructorReturn(this, (MultipleAnswerOptionReview.__proto__ || Object.getPrototypeOf(MultipleAnswerOptionReview)).call(this, props, context));
	
	        _this.state = {
	            lang: _this.props.lang,
	            option: _this.props.option,
	            optionRendered: false,
	            optionFeedbackRendered: false,
	            checkForFeedbackRendered: true,
	            locale: {},
	            responseData: _this.props.responseData,
	            feedbackOption: {},
	            feedbackOptionLocale: {},
	            kpiDashboardParams: {
	                responseReview: true,
	                showTitle: false,
	                showImmediateImpact: true,
	                allowUpdates: false
	            }
	        };
	        _this.getLocale = _this.getLocale.bind(_this);
	        _this.hideOption = _this.hideOption.bind(_this);
	        _this.showOption = _this.showOption.bind(_this);
	        _this.onOptionRendered = _this.onOptionRendered.bind(_this);
	        _this.removeOption = _this.removeOption.bind(_this);
	        _this.onOptionHidden = _this.onOptionHidden.bind(_this);
	        _this.getDisabledState = _this.getDisabledState.bind(_this);
	        _this.getCheckedState = _this.getCheckedState.bind(_this);
	        _this.getOptionClass = _this.getOptionClass.bind(_this);
	        _this.getClickFunction = _this.getClickFunction.bind(_this);
	        _this.checkRenderOptionFeedback = _this.checkRenderOptionFeedback.bind(_this);
	        _this.showOptionFeedback = _this.showOptionFeedback.bind(_this);
	        _this.hideOptionFeedback = _this.hideOptionFeedback.bind(_this);
	        _this.showOptionFeedbackComplete = _this.showOptionFeedbackComplete.bind(_this);
	        _this.getShowKpis = _this.getShowKpis.bind(_this);
	        _this.getShowFeedback = _this.getShowFeedback.bind(_this);
	        _this.setKeyboardAccessibility = _this.setKeyboardAccessibility.bind(_this);
	        _this.onObjectSelected = _this.onObjectSelected.bind(_this);
	        return _this;
	    }
	
	    _createClass(MultipleAnswerOptionReview, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            this.getLocale();
	            this.showOption(1, this.props.index / 4);
	        }
	    }, {
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(nextProps) {
	            if (this.state.responseData !== nextProps.responseData) {
	                this.setState({ responseData: nextProps.responseData });
	            }
	            if (this.state.lang !== nextProps.lang) {
	                this.setState({
	                    lang: nextProps.lang,
	                    locale: appHelper.getLocalData(this.state.option),
	                    feedbackOption: appHelper.isDefined(this.state.option.feedback_id) ? Object.assign({}, appHelper.getArrayObjectByKey(this.props.options, "option_id", this.state.option.option_id)) : Object.assign({}, appHelper.getArrayObjectByKey(this.props.options, "option_id", this.state.option.feedback_id))
	                });
	            }
	        }
	    }, {
	        key: 'componentDidUpdate',
	        value: function componentDidUpdate() {
	            var checkedIndex = appHelper.getArrayObjectIndexByKey(this.state.responseData.checkedOptions, "option_id", this.state.option.option_id);
	            if (checkedIndex > -1 && this.state.checkForFeedbackRendered) {
	                this.checkRenderOptionFeedback();
	            } else if (checkedIndex === -1 && this.state.optionFeedbackRendered) {
	                this.hideOptionFeedback();
	            }
	        }
	    }, {
	        key: 'getLocale',
	        value: function getLocale() {
	            var locale = appHelper.getLocalData(this.state.option);
	            var feedbackOption = {};
	            if (!appHelper.isDefined(this.state.option.feedback_id)) {
	                feedbackOption = Object.assign({}, appHelper.getArrayObjectByKey(this.props.options, "option_id", this.state.option.option_id));
	            } else {
	                feedbackOption = Object.assign({}, appHelper.getArrayObjectByKey(this.props.options, "option_id", this.state.option.feedback_id));
	            }
	
	            this.setState({
	                locale: Object.assign({}, locale),
	                feedbackOption: Object.assign({}, feedbackOption),
	                feedbackOptionLocale: appHelper.getLocalData(feedbackOption)
	            });
	        }
	    }, {
	        key: 'checkRenderOptionFeedback',
	        value: function checkRenderOptionFeedback() {
	            var checkedIndex = appHelper.getArrayObjectIndexByKey(this.state.responseData.checkedOptions, "option_id", this.state.option.option_id);
	            if (checkedIndex > -1 && this.state.checkForFeedbackRendered) {
	                if (this.state.optionRendered) {
	                    this.showOptionFeedback();
	                }
	            } else {
	                this.setState({ optionFeedbackRendered: false });
	            }
	        }
	    }, {
	        key: 'showOptionFeedback',
	        value: function showOptionFeedback() {
	            var feedbackPanel = this.refs[this.state.feedbackOption.option_id + '_feedBackPanel'];
	            if (appHelper.isDefined(feedbackPanel)) {
	                _gsap.TweenLite.set(feedbackPanel, { height: "auto", opacity: 1 });
	                _gsap.TweenLite.from(feedbackPanel, 0.2, {
	                    height: 0,
	                    opacity: 0,
	                    ease: _gsap.Expo.easeInOut
	                }).eventCallback("onComplete", this.showOptionFeedbackComplete);
	            }
	        }
	    }, {
	        key: 'showOptionFeedbackComplete',
	        value: function showOptionFeedbackComplete() {
	            this.setState({ optionFeedbackRendered: true, checkForFeedbackRendered: false });
	        }
	    }, {
	        key: 'hideOptionFeedback',
	        value: function hideOptionFeedback() {
	            this.setState({ optionFeedbackRendered: false, checkForFeedbackRendered: true });
	        }
	    }, {
	        key: 'getOptionClass',
	        value: function getOptionClass() {
	            var checkedIndex = appHelper.getArrayObjectIndexByKey(this.state.responseData.checkedOptions, "option_id", this.state.option.option_id);
	            var answerIndex = appHelper.getArrayObjectIndexByKey(this.props.responseData.userSelections, "option_id", this.state.option.option_id);
	            if (appHelper.isDefined(this.state.responseData.outcome.result) && answerIndex > -1) {
	                if (checkedIndex > -1 && appHelper.isDefined(this.state.feedbackOption.option_id) && (appHelper.isDefined(this.state.feedbackOptionLocale.feedback) && this.state.feedbackOptionLocale.feedback.length > 0 || this.state.option.kpis !== null)) {
	                    return 'review-selected review-current ' + this.state.option.result;
	                } else {
	                    return 'review-selected ' + this.state.option.result;
	                }
	            } else {
	                if (checkedIndex > -1 && appHelper.isDefined(this.state.feedbackOption.option_id)) {
	                    return 'review review-current ' + this.state.option.result;
	                } else {
	                    return 'review ' + this.state.option.result;
	                }
	            }
	        }
	    }, {
	        key: 'getShowKpis',
	        value: function getShowKpis() {
	            var answerIndex = appHelper.getArrayObjectIndexByKey(this.props.responseData.userSelections, "option_id", this.state.option.option_id);
	            return appHelper.isDefined(this.state.responseData.outcome.result) && answerIndex > -1;
	        }
	    }, {
	        key: 'getClickFunction',
	        value: function getClickFunction() {
	            var responseData = this.state.responseData;
	            var latestResponse = appHelper.getLastItemOfArray(responseData.responses);
	            if (responseData.currentAttempt === responseData.responses.length && latestResponse.selectedOption.option_id == this.state.option.option_id) {
	                if (responseData.displayState === objectConstants.OBJECT_DISPLAY_STATE_ANSWERED) {
	                    this.props.onReviewObject();
	                }
	            }
	        }
	    }, {
	        key: 'getDisabledState',
	        value: function getDisabledState() {
	            /*if(!appHelper.isDefined(this.state.feedbackOption.option_id)){
	                return "disabled";
	            }*/
	            return null;
	        }
	    }, {
	        key: 'getCheckedState',
	        value: function getCheckedState() {
	            var checkedIndex = appHelper.getArrayObjectIndexByKey(this.state.responseData.checkedOptions, "option_id", this.state.option.option_id);
	            if (appHelper.isDefined(this.state.responseData.outcome.result) && checkedIndex > -1) {
	                return 'checked';
	            }
	            return null;
	        }
	    }, {
	        key: 'hideOption',
	        value: function hideOption() {
	            var optionRef = this.refs[this.state.option.option_id];
	            _gsap.TweenLite.to(optionRef, objectConstants.MC_OPTION_DURATION, {
	                opacity: 0,
	                delay: 0.5,
	                ease: _gsap.Expo.easeOut
	            }).eventCallback("onComplete", this.scaleOptionHeight);
	        }
	    }, {
	        key: 'showOption',
	        value: function showOption(duration, delay) {
	            var optionRef = this.refs[this.state.option.option_id];
	            _gsap.TweenLite.set(optionRef, { height: "auto", opacity: 1 });
	            _gsap.TweenLite.from(optionRef, objectConstants.MC_OPTION_DURATION, {
	                height: 0,
	                opacity: 0,
	                delay: delay,
	                ease: _gsap.Expo.easeInOut
	            }).eventCallback("onComplete", this.onOptionRendered);
	        }
	    }, {
	        key: 'onOptionRendered',
	        value: function onOptionRendered() {
	            var checkedIndex = appHelper.getArrayObjectIndexByKey(this.state.responseData.checkedOptions, "option_id", this.state.option.option_id);
	            this.setState({
	                optionRendered: true,
	                optionFeedbackRendered: checkedIndex > -1,
	                checkForFeedbackRendered: checkedIndex === -1
	            });
	        }
	    }, {
	        key: 'onOptionHidden',
	        value: function onOptionHidden() {
	            var responseData = this.state.responseData;
	            var latestResponse = appHelper.getLastItemOfArray(responseData.responses);
	
	            //if selected option is first in the list
	            if (latestResponse.index === 0) {
	                this.removeOption();
	            } else {
	                this.scaleOptionHeight();
	            }
	        }
	    }, {
	        key: 'removeOption',
	        value: function removeOption() {
	            //this.setState({render: false});
	        }
	    }, {
	        key: 'getShowFeedback',
	        value: function getShowFeedback() {
	            var optionIndex = appHelper.getArrayObjectIndexByKey(this.state.responseData.checkedOptions, "option_id", this.state.option.option_id);
	            return optionIndex > -1 && (appHelper.isDefined(this.state.feedbackOptionLocale.feedback) && this.state.feedbackOptionLocale.feedback.length > 0 || this.state.option.kpis !== null && kpiHelper.kpisAreVisible(this.state.option.kpis, this.state.responseData.bite_id));
	        }
	    }, {
	        key: 'onObjectSelected',
	        value: function onObjectSelected() {
	            this.props.onOptionClick(this.state.option);
	        }
	    }, {
	        key: 'setKeyboardAccessibility',
	        value: function setKeyboardAccessibility(event) {
	            if (event.which === keyboardConstants.ENTER_KEY || event.which === keyboardConstants.SPACEBAR_KEY) {
	                event.preventDefault();
	                this.onObjectSelected();
	            }
	
	            if (event.which === keyboardConstants.ARROW_UP_KEY) {
	                event.preventDefault();
	                var optionIndex = appHelper.getArrayObjectIndexByKey(this.props.options, "option_id", this.state.option.option_id);
	                var nextIndex = optionIndex - 1;
	
	                if (optionIndex === 0) {
	                    nextIndex = this.props.options.length - 1;
	                }
	                var nextItem = Object.assign({}, this.props.options[nextIndex]);
	                var focusItem = document.getElementById('review_option_' + nextItem.option_id);
	                focusItem.focus();
	            }
	
	            if (event.which === keyboardConstants.ARROW_DOWN_KEY) {
	                event.preventDefault();
	                var _optionIndex = appHelper.getArrayObjectIndexByKey(this.props.options, "option_id", this.state.option.option_id);
	                var _nextIndex = _optionIndex + 1;
	                if (_optionIndex === this.props.options.length - 1) {
	                    _nextIndex = 0;
	                }
	
	                var _nextItem = Object.assign({}, this.props.options[_nextIndex]);
	                var _focusItem = document.getElementById('review_option_' + _nextItem.option_id);
	                _focusItem.focus();
	            }
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	
	            return _react2.default.createElement(
	                'div',
	                { className: 'multiple-choice-option ' + this.getOptionClass(),
	                    ref: this.state.option.option_id,
	                    id: 'review_option_' + this.state.option.option_id,
	                    role: 'button', tabIndex: 0,
	
	                    onKeyDown: this.setKeyboardAccessibility,
	                    'aria-controls': 'review_feedback_wrapper_' + this.state.option.option_id,
	                    'aria-expanded': appHelper.getArrayObjectIndexByKey(this.state.responseData.checkedOptions, "option_id", this.state.option.option_id) > -1 },
	                _react2.default.createElement('input', { id: this.props.asset_id + '_' + this.state.option.option_id + '_review', type: 'radio',
	                    name: this.props.asset_id + '_' + this.state.option.option_id + '_review',
	                    tabIndex: '-1',
	                    'aria-hidden': 'true', 'aria-disabled': 'true',
	                    value: this.state.option.option_id, onClick: this.onObjectSelected }),
	                _react2.default.createElement(
	                    'label',
	                    { htmlFor: this.props.asset_id + '_' + this.state.option.option_id + '_review' },
	                    _react2.default.createElement('span', { dangerouslySetInnerHTML: { __html: this.state.locale.option } }),
	                    _react2.default.createElement(
	                        'span',
	                        { className: 'hidden-el' },
	                        appHelper.getOptionResultString(this.state.option.result, false)
	                    )
	                ),
	                this.getShowFeedback() ? _react2.default.createElement(
	                    'div',
	                    { ref: this.state.feedbackOption.option_id + '_feedBackPanel',
	                        className: 'feedback-panel ' + this.state.option.result + ' object-container' },
	                    appHelper.isDefined(this.state.option.kpis) && this.state.option.kpis !== null && this.state.option.kpis.length > 0 ? _react2.default.createElement(_KpiDashboard2.default, {
	                        displayState: kpiConstants.KPI_DISPLAY_STATE_REVIEW_POINTS_AWARDED,
	                        bite_id: this.props.responseData.bite_id,
	                        screen_id: this.props.responseData.screen_id,
	                        object_id: this.props.responseData.asset_id,
	                        option: this.state.option,
	                        responseReview: this.state.kpiDashboardParams.responseReview,
	                        showImmediateImpact: this.state.kpiDashboardParams.showImmediate,
	                        showTitle: this.state.kpiDashboardParams.showTitle }) : null,
	                    appHelper.isDefined(this.state.feedbackOptionLocale) && appHelper.isDefined(this.state.feedbackOptionLocale.feedback) && this.state.feedbackOptionLocale.feedback.length > 0 ? _react2.default.createElement('div', {
	                        dangerouslySetInnerHTML: { __html: this.state.feedbackOptionLocale.feedback } }) : null
	                ) : null
	            );
	        }
	    }]);
	
	    return MultipleAnswerOptionReview;
	}(_react2.default.Component);
	
	/* */
	
	MultipleAnswerOptionReview.propTypes = {
	    option: _propTypes2.default.object.isRequired,
	    asset_id: _propTypes2.default.number.isRequired,
	    questionChecked: _propTypes2.default.bool.isRequired,
	    responseData: _propTypes2.default.object.isRequired,
	    index: _propTypes2.default.number.isRequired,
	    options: _propTypes2.default.array.isRequired,
	    onOptionClick: _propTypes2.default.func,
	    onAttemptComplete: _propTypes2.default.func,
	    onReviewObject: _propTypes2.default.func,
	    contentData: _propTypes2.default.object,
	    trackingData: _propTypes2.default.object,
	    lang: _propTypes2.default.string, //.isRequired,
	    actions: _propTypes2.default.object
	};
	
	MultipleAnswerOptionReview.contextTypes = {
	    router: _propTypes2.default.object
	};
	
	function mapStateToProps(ownProps, state) {
	    return {
	        lang: appHelper.isDefined(state.userData) ? state.userData.lang : localStorage.default_langauge,
	        contentData: state.contentData,
	        trackingData: state.trackingData
	    };
	}
	
	function mapDispatchToProps(dispatch) {
	    return {
	        actions: (0, _redux.bindActionCreators)(Object.assign({}, trackingDataActions, dialogActions), dispatch)
	    };
	}
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(MultipleAnswerOptionReview);

/***/ },
/* 504 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(5);
	
	var _redux = __webpack_require__(4);
	
	var _Prompt = __webpack_require__(83);
	
	var _Prompt2 = _interopRequireDefault(_Prompt);
	
	var _DialogPrompt = __webpack_require__(94);
	
	var _DialogPrompt2 = _interopRequireDefault(_DialogPrompt);
	
	var _BadgeCollect = __webpack_require__(47);
	
	var _BadgeCollect2 = _interopRequireDefault(_BadgeCollect);
	
	var _Button = __webpack_require__(18);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _MultipleAnswerOptionReview = __webpack_require__(503);
	
	var _MultipleAnswerOptionReview2 = _interopRequireDefault(_MultipleAnswerOptionReview);
	
	var _MultipleAnswerFeedbackReview = __webpack_require__(501);
	
	var _MultipleAnswerFeedbackReview2 = _interopRequireDefault(_MultipleAnswerFeedbackReview);
	
	var _appDataActions = __webpack_require__(12);
	
	var appDataActions = _interopRequireWildcard(_appDataActions);
	
	var _trackingDataActions = __webpack_require__(7);
	
	var trackingDataActions = _interopRequireWildcard(_trackingDataActions);
	
	var _dialogPopupActions = __webpack_require__(19);
	
	var dialogPopupActions = _interopRequireWildcard(_dialogPopupActions);
	
	var _appHelper = __webpack_require__(3);
	
	var appHelper = _interopRequireWildcard(_appHelper);
	
	var _dataHelper = __webpack_require__(11);
	
	var dataHelper = _interopRequireWildcard(_dataHelper);
	
	var _kpiHelper = __webpack_require__(35);
	
	var kpiHelper = _interopRequireWildcard(_kpiHelper);
	
	var _objectConstants = __webpack_require__(9);
	
	var objectConstants = _interopRequireWildcard(_objectConstants);
	
	var _userDataHelper = __webpack_require__(15);
	
	var userDataHelper = _interopRequireWildcard(_userDataHelper);
	
	var _dialogModels = __webpack_require__(32);
	
	var _gsap = __webpack_require__(8);
	
	var _gsapReactPlugin = __webpack_require__(10);
	
	var _gsapReactPlugin2 = _interopRequireDefault(_gsapReactPlugin);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } //eslint-disable-line import/no-named-as-default
	//eslint-disable-line import/no-named-as-default
	//eslint-disable-line import/no-named-as-default
	
	
	var MultipleAnswerReview = function (_React$Component) {
	    _inherits(MultipleAnswerReview, _React$Component);
	
	    function MultipleAnswerReview(props, context) {
	        _classCallCheck(this, MultipleAnswerReview);
	
	        var _this = _possibleConstructorReturn(this, (MultipleAnswerReview.__proto__ || Object.getPrototypeOf(MultipleAnswerReview)).call(this, props, context));
	
	        _this.state = {
	            lang: _this.props.lang,
	            screenObject: _this.props.screenObject,
	            userData: _this.props.userData,
	            objectStates: objectConstants.OBJECT_DISPLAY_STATES,
	            locale: appHelper.getLocalData(_this.props.screenObject),
	            outcomeLocale: {},
	            questionChecked: false,
	            correctAnswerCount: appHelper.getTypeCount(_this.props.screenObject.options, "result", "best").length,
	            responseData: _this.props.responseData,
	            showOptions: true,
	            showCheckBtn: false,
	            showFeedback: true,
	            checkAnswers: true,
	            //badges
	            badgesEarned: [],
	            checkBadgesEarned: false,
	            collected: true,
	            character_name: appHelper.getScreenCharacterNameByAssetId(_this.props.screenObject.asset_id)
	        };
	        _this.randomiseOptions = _this.randomiseOptions.bind(_this);
	        _this.renderOptions = _this.renderOptions.bind(_this);
	        _this.onOptionClick = _this.onOptionClick.bind(_this);
	        _this.checkAnswers = _this.checkAnswers.bind(_this);
	        _this.showFeedback = _this.showFeedback.bind(_this);
	        _this.reattempt = _this.reattempt.bind(_this);
	        //badges
	        _this.checkBadgeEarnedOnObject = _this.checkBadgeEarnedOnObject.bind(_this);
	        _this.getBadge = _this.getBadge.bind(_this);
	        return _this;
	    }
	
	    _createClass(MultipleAnswerReview, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            this.checkAnswers();
	            this.checkBadgeEarnedOnObject();
	        }
	    }, {
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(nextProps) {
	            if (this.state.userData !== nextProps.userData) {
	                this.setState({
	                    userData: Object.assign({}, nextProps.userData),
	                    checkBadgesEarned: true
	                });
	            }
	
	            if (this.state.lang !== nextProps.lang) {
	                this.setState({
	                    lang: nextProps.lang,
	                    locale: appHelper.getLocalData(this.state.screenObject)
	                });
	            }
	        }
	    }, {
	        key: 'componentDidUpdate',
	        value: function componentDidUpdate() {
	            if (this.state.checkAnswers) {
	                this.checkAnswers();
	            }
	
	            if (this.checkBadgesEarned) {
	                this.checkBadgeEarnedOnObject();
	            }
	        }
	    }, {
	        key: 'checkBadgeEarnedOnObject',
	        value: function checkBadgeEarnedOnObject() {
	            var params = {
	                bite_id: this.state.responseData.bite_id,
	                asset_id: this.state.screenObject.asset_id
	            };
	
	            var badgesEarned = userDataHelper.checkBadgeEarnedOnObject(this.state.userData, params);
	            this.setState({
	                checkBadgesEarned: false,
	                badgesEarned: Object.assign([], badgesEarned)
	            });
	        }
	    }, {
	        key: 'getBadge',
	        value: function getBadge(badge_id) {
	            //return appHelper.getArrayObjectByKey(localStorage.achievements, "code", code);
	        }
	    }, {
	        key: 'randomiseOptions',
	        value: function randomiseOptions() {
	            this.setState({
	                screenObject: Object.assign({}, this.state.screenObject, {
	                    options: dataHelper.randomiseArray(this.state.screenObject.options)
	                })
	            });
	        }
	    }, {
	        key: 'renderOptions',
	        value: function renderOptions() {
	            if (!this.state.showOptions && this.state.responseData.currentStatus == objectConstants.STATUS_NOT_STARTED) {
	                this.setState({ showOptions: true });
	            }
	        }
	    }, {
	        key: 'onOptionClick',
	        value: function onOptionClick(option) {
	            var locale_checkedOptions = Object.assign([], this.state.responseData.checkedOptions);
	            var optionIndex = appHelper.getArrayObjectIndexByKey(locale_checkedOptions, "option_id", option.option_id);
	            if (optionIndex == -1) {
	                locale_checkedOptions = dataHelper.immutablePush(locale_checkedOptions, option);
	            } else {
	                locale_checkedOptions = dataHelper.immutableSplice(locale_checkedOptions, optionIndex, 1);
	            }
	
	            this.setState({
	                responseData: Object.assign({}, this.state.responseData, {
	                    checkedOptions: dataHelper.immutableSplice(this.state.responseData.checkedOptions, 0, this.state.responseData.checkedOptions.length, option),
	                    userSelections: Object.assign([], this.state.responseData.userSelections),
	                    initialised: true
	                }),
	                showFeedback: true,
	                showCheckBtn: locale_checkedOptions.length > 0,
	                checkAnswers: false
	            });
	        }
	
	        //checkedOptions
	
	    }, {
	        key: 'checkAnswers',
	        value: function checkAnswers() {
	            var correctAnswers = appHelper.getTypeCount(this.state.responseData.checkedOptions, "result", "best");
	            var incorrectAnswers = appHelper.getNotOfTypeCount(this.state.responseData.checkedOptions, "result", "best");
	            var kpis = kpiHelper.averageKpis(this.state.responseData.checkedOptions);
	            var outcome = {};
	            if (correctAnswers.length === this.state.correctAnswerCount && incorrectAnswers.length === 0) {
	                outcome = Object.assign({}, appHelper.getArrayObjectByKey(this.state.screenObject.outcomes, "result", "best"), {
	                    kpis: kpis
	                });
	            } else {
	                //if (this.state.screenObject.allowPartlyCorrectResponses) {
	
	                if (correctAnswers.length > 0) {
	                    outcome = Object.assign({}, appHelper.getArrayObjectByKey(this.state.screenObject.outcomes, "result", "ok"), {
	                        kpis: kpis
	                    });
	                    if (!appHelper.isDefined(outcome.result)) {
	                        outcome = Object.assign({}, appHelper.getArrayObjectByKey(this.state.screenObject.outcomes, "result", "poor"), {
	                            kpis: kpis
	                        });
	                    }
	                } else {
	                    outcome = Object.assign({}, appHelper.getArrayObjectByKey(this.state.screenObject.outcomes, "result", "poor"), {
	                        kpis: kpis
	                    });
	                }
	                /*} else {
	                    outcome = Object.assign({}, appHelper.getArrayObjectByKey(this.state.screenObject.outcomes, "result_type", "incorrect"));
	                }*/
	            }
	
	            if (this.state.screenObject.scoring_type === objectConstants.SCORING_TYPE_REFLECTIVE) {
	                outcome = Object.assign({}, appHelper.getArrayObjectByKey(this.state.screenObject.outcomes, "result", "best"), {
	                    kpis: kpis,
	                    result: "reflective"
	                });
	            }
	
	            var outcomeLocale = appHelper.getLocalData(outcome);
	
	            var firstCheckedOption = {};
	            for (var i = 0; i < this.state.screenObject.options.length; i++) {
	                var option = this.state.screenObject.options[i];
	                var checkedIndex = appHelper.getArrayObjectIndexByKey(this.state.responseData.checkedOptions, "option_id", option.option_id);
	                if (checkedIndex > -1) {
	                    firstCheckedOption = Object.assign({}, option);
	                    break;
	                }
	            }
	
	            this.setState({
	                responseData: Object.assign({}, this.state.responseData, {
	                    outcome: outcome,
	                    checkedOptions: dataHelper.immutableSplice(this.state.responseData.checkedOptions, 0, this.state.responseData.checkedOptions.length, firstCheckedOption)
	                }),
	                showFeedback: true,
	                questionChecked: true,
	                checkAnswers: false,
	                outcomeLocale: outcomeLocale
	            });
	        }
	    }, {
	        key: 'showFeedback',
	        value: function showFeedback() {
	            // console.log("showFeedback");
	            if (this.state.responseData.currentStatus !== objectConstants.STATUS_COMPLETE) {
	                this.setState({ showFeedback: true });
	            }
	        }
	    }, {
	        key: 'reattempt',
	        value: function reattempt() {
	            this.setState({
	                showFeedback: false,
	                responseData: Object.assign({}, this.state.responseData, {
	                    currentAttempt: this.state.responseData.currentAttempt + 1,
	                    currentStatus: objectConstants.STATUS_ATTEMPTED,
	                    displayState: objectConstants.OBJECT_DISPLAY_STATE_RETRY,
	                    outcome: Object.assign({}, {}),
	                    checkedOptions: dataHelper.immutableSplice(this.state.responseData.checkedOptions, 0, this.state.responseData.checkedOptions.length)
	
	                })
	            });
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this2 = this;
	
	            return _react2.default.createElement(
	                'div',
	                { className: 'learner-action' },
	                this.state.badgesEarned.length > 0 ? _react2.default.createElement(
	                    'div',
	                    null,
	                    this.state.badgesEarned.map(function (badge) {
	                        return _react2.default.createElement(_BadgeCollect2.default, { key: badge.badge_id, badge_id: badge.badge_id, bite_id: _this2.state.responseData.bite_id, asset_id: _this2.state.responseData.asset_id, collected: _this2.state.collected });
	                    }),
	                    _react2.default.createElement('br', null)
	                ) : null,
	                this.state.screenObject.prompt_type === objectConstants.PROMPT_TYPE_DIALOG_PROMPT ? _react2.default.createElement(
	                    'div',
	                    { className: 'object-container' },
	                    _react2.default.createElement(_DialogPrompt2.default, { character_name: this.state.character_name, id: this.state.screenObject.asset_id,
	                        locale: this.state.locale, show_title: this.state.screenObject.show_title,
	                        onComplete: this.renderOptions })
	                ) : _react2.default.createElement(
	                    'div',
	                    { className: 'horz-padding' },
	                    _react2.default.createElement(_Prompt2.default, { id: this.state.screenObject.asset_id, locale: this.state.locale,
	                        show_title: this.state.screenObject.show_title, onComplete: this.renderOptions })
	                ),
	                this.state.showFeedback && appHelper.isDefined(this.state.outcomeLocale.feedback) && this.state.outcomeLocale.feedback.length > 0 ? _react2.default.createElement(_MultipleAnswerFeedbackReview2.default, { options: this.state.screenObject.options,
	                    key_messages: this.state.screenObject.key_messages,
	                    asset_id: this.state.screenObject.asset_id,
	                    responseData: this.state.responseData
	                }) : null,
	                this.state.showOptions ? _react2.default.createElement(
	                    'div',
	                    { className: 'question-wrapper' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'multiple-choice-option-list theme-active' },
	                        this.state.screenObject.options.map(function (option) {
	                            return _react2.default.createElement(_MultipleAnswerOptionReview2.default, { key: option.option_id, option: option,
	                                asset_id: _this2.state.screenObject.asset_id,
	                                questionChecked: _this2.state.questionChecked,
	                                onOptionClick: _this2.onOptionClick,
	                                options: _this2.state.screenObject.options,
	                                responseData: _this2.state.responseData,
	                                index: appHelper.getObjectOptionIndex(_this2.state.screenObject.options, option.option_id)
	                            });
	                        })
	                    )
	                ) : null
	            );
	        }
	    }]);
	
	    return MultipleAnswerReview;
	}(_react2.default.Component);
	
	MultipleAnswerReview.propTypes = {
	    screenObject: _propTypes2.default.object.isRequired,
	    responseData: _propTypes2.default.object.isRequired,
	    userData: _propTypes2.default.object.isRequired,
	    lang: _propTypes2.default.string.isRequired,
	    actions: _propTypes2.default.object.isRequired
	};
	
	MultipleAnswerReview.contextTypes = {
	    router: _propTypes2.default.object
	};
	
	function mapStateToProps(state, ownProps) {
	    var lang = state.userData.lang;
	    return {
	        lang: lang,
	        userData: state.userData
	
	    };
	}
	
	function mapDispatchToProps(dispatch) {
	    return {
	        actions: (0, _redux.bindActionCreators)(Object.assign({}, appDataActions, trackingDataActions, dialogPopupActions), dispatch)
	    };
	}
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(MultipleAnswerReview);

/***/ },
/* 505 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(5);
	
	var _redux = __webpack_require__(4);
	
	var _Prompt = __webpack_require__(83);
	
	var _Prompt2 = _interopRequireDefault(_Prompt);
	
	var _DialogPrompt = __webpack_require__(94);
	
	var _DialogPrompt2 = _interopRequireDefault(_DialogPrompt);
	
	var _SingleAnswerOption = __webpack_require__(507);
	
	var _SingleAnswerOption2 = _interopRequireDefault(_SingleAnswerOption);
	
	var _Button = __webpack_require__(18);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _SingleAnswerFeedback = __webpack_require__(200);
	
	var _SingleAnswerFeedback2 = _interopRequireDefault(_SingleAnswerFeedback);
	
	var _ChildConversationDialog = __webpack_require__(65);
	
	var _ChildConversationDialog2 = _interopRequireDefault(_ChildConversationDialog);
	
	var _BadgeCollect = __webpack_require__(47);
	
	var _BadgeCollect2 = _interopRequireDefault(_BadgeCollect);
	
	var _appDataActions = __webpack_require__(12);
	
	var appDataActions = _interopRequireWildcard(_appDataActions);
	
	var _trackingDataActions = __webpack_require__(7);
	
	var trackingDataActions = _interopRequireWildcard(_trackingDataActions);
	
	var _dialogPopupActions = __webpack_require__(19);
	
	var dialogPopupActions = _interopRequireWildcard(_dialogPopupActions);
	
	var _appHelper = __webpack_require__(3);
	
	var appHelper = _interopRequireWildcard(_appHelper);
	
	var _dataHelper = __webpack_require__(11);
	
	var dataHelper = _interopRequireWildcard(_dataHelper);
	
	var _userDataHelper = __webpack_require__(15);
	
	var userDataHelper = _interopRequireWildcard(_userDataHelper);
	
	var _xAPIHelper = __webpack_require__(86);
	
	var xAPIHelper = _interopRequireWildcard(_xAPIHelper);
	
	var _kpiHelper = __webpack_require__(35);
	
	var kpiHelper = _interopRequireWildcard(_kpiHelper);
	
	var _objectConstants = __webpack_require__(9);
	
	var objectConstants = _interopRequireWildcard(_objectConstants);
	
	var _appConstants = __webpack_require__(13);
	
	var appConstants = _interopRequireWildcard(_appConstants);
	
	var _localStorage = __webpack_require__(17);
	
	var localStorage = _interopRequireWildcard(_localStorage);
	
	var _keyboardConstants = __webpack_require__(14);
	
	var keyboardConstants = _interopRequireWildcard(_keyboardConstants);
	
	var _componentConstants = __webpack_require__(49);
	
	var componentConstants = _interopRequireWildcard(_componentConstants);
	
	var _dialogModels = __webpack_require__(32);
	
	var _gsap = __webpack_require__(8);
	
	var _gsapReactPlugin = __webpack_require__(10);
	
	var _gsapReactPlugin2 = _interopRequireDefault(_gsapReactPlugin);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } //eslint-disable-line import/no-named-as-default
	
	
	var SingleAnswer = function (_React$Component) {
	    _inherits(SingleAnswer, _React$Component);
	
	    function SingleAnswer(props, context) {
	        _classCallCheck(this, SingleAnswer);
	
	        var _this = _possibleConstructorReturn(this, (SingleAnswer.__proto__ || Object.getPrototypeOf(SingleAnswer)).call(this, props, context));
	
	        _this.state = {
	            lang: _this.props.lang,
	            screenObject: _this.props.screenObject,
	            userData: _this.props.userData,
	            options: _this.props.screenObject.options,
	            locale: appHelper.getLocalData(_this.props.screenObject),
	            questionChecked: false,
	            currentlyChecked: false,
	            reviewMode: false,
	            propsUpdated: false,
	            responseData: {
	                bite_id: _this.props.callbacks.getBiteId(),
	                screen_id: _this.props.callbacks.getScreenId(),
	                asset_id: _this.props.screenObject.asset_id,
	                currentAttempt: 1,
	                currentStatus: objectConstants.STATUS_NOT_STARTED,
	                displayState: objectConstants.OBJECT_DISPLAY_STATE_INITIAL,
	                responses: [],
	                latestResponse: {}
	            },
	            showOptions: false,
	            enableCheckBtn: false,
	            showCheckBtn: false,
	            showFeedback: false,
	            showResponse: false,
	            revealedOptions: [],
	            watchCheckBtnState: true,
	            skipFeedback: false,
	            screenStatus: "",
	            checkObjectStatus: false,
	            handleCompletion: false,
	            scoring_type: _this.props.screenObject.scoring_type,
	            checkPostXAPIResponse: false,
	            character_name: appHelper.isDefined(_this.props.callbacks) ? _this.props.callbacks.getCharacterName() : appHelper.getScreenCharacterNameByAssetId(_this.props.screenObject.asset_id),
	            focusedOption: _this.props.screenObject.options[0],
	            focusOnFeedback: false,
	            optionCallbacks: {},
	            updateFocus: false,
	            showProgression: false,
	            hideFeedback: false,
	            progression_label: "",
	            hasBadges: false,
	            badgesCollected: false,
	            animateBadge: true,
	            multiple_choice_single_answer_question_label: appHelper.getLocaleString("multiple_choice_single_answer_question_label"),
	            submit_label: appHelper.getLocaleString("submit_label"),
	            continue_label: appHelper.getLocaleString("continue_label"),
	            try_again_label: appHelper.getLocaleString("try_again_label"),
	            progressionHandled: false,
	            xApiResponseObj: {}
	        };
	        _this.randomiseOptions = _this.randomiseOptions.bind(_this);
	        _this.renderOptions = _this.renderOptions.bind(_this);
	        _this.onOptionClick = _this.onOptionClick.bind(_this);
	        _this.checkAnswers = _this.checkAnswers.bind(_this);
	        _this.showFeedback = _this.showFeedback.bind(_this);
	        _this.handleResponse = _this.handleResponse.bind(_this);
	        _this.handleProgression = _this.handleProgression.bind(_this);
	        _this.reattempt = _this.reattempt.bind(_this);
	        _this.getObjectStatus = _this.getObjectStatus.bind(_this);
	        _this.onReviewObject = _this.onReviewObject.bind(_this);
	        _this.setReviewMode = _this.setReviewMode.bind(_this);
	        _this.onOptionRevealed = _this.onOptionRevealed.bind(_this);
	        _this.setCheckBtnState = _this.setCheckBtnState.bind(_this);
	        _this.handleSkipFeedback = _this.handleSkipFeedback.bind(_this);
	        _this.scrollToSubmitBtn = _this.scrollToSubmitBtn.bind(_this);
	        _this.handleResponseComplete = _this.handleResponseComplete.bind(_this);
	        _this.postXAPIResponse = _this.postXAPIResponse.bind(_this);
	        _this.getStatusClass = _this.getStatusClass.bind(_this);
	        _this.onPanelClick = _this.onPanelClick.bind(_this);
	        _this.getImagePath = _this.getImagePath.bind(_this);
	        _this.hasFeedbackToShow = _this.hasFeedbackToShow.bind(_this);
	        _this.getPrevOption = _this.getPrevOption.bind(_this);
	        _this.getNextOption = _this.getNextOption.bind(_this);
	        _this.setKeyboardAccessibility = _this.setKeyboardAccessibility.bind(_this);
	        _this.allowKeyAccessibility = _this.allowKeyAccessibility.bind(_this);
	        _this.getTabIndex = _this.getTabIndex.bind(_this);
	        _this.onKeyboardPanelClick = _this.onKeyboardPanelClick.bind(_this);
	        _this.onFocusOnFeedback = _this.onFocusOnFeedback.bind(_this);
	        _this.setOptionCallbacks = _this.setOptionCallbacks.bind(_this);
	        _this.setOptionFocus = _this.setOptionFocus.bind(_this);
	        _this.enableProgression = _this.enableProgression.bind(_this);
	        _this.onProgressionClicked = _this.onProgressionClicked.bind(_this);
	        _this.onBadgeCollected = _this.onBadgeCollected.bind(_this);
	        _this.checkResponses = _this.checkResponses.bind(_this);
	        return _this;
	    }
	
	    _createClass(SingleAnswer, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            this.randomiseOptions();
	            this.setOptionCallbacks();
	
	            if (localStorage.tracking_type === appConstants.TRACKING_TYPE_XAPI || localStorage.tracking_type === appConstants.TRACKING_TYPE_BLENDED_XAPI_SCORM_1_2) {
	                this.checkResponses();
	            } else {
	                this.getObjectStatus();
	            }
	        }
	    }, {
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(nextProps) {
	
	            if (this.state.userData !== nextProps.userData) {
	                this.setState({
	                    userData: Object.assign({}, nextProps.userData),
	                    checkObjectStatus: true
	                });
	            }
	
	            if (this.state.lang !== nextProps.lang) {
	                var progression_label = "";
	
	                if (this.state.progression_label === this.state.try_again_label) {
	                    progression_label = appHelper.getLocaleString("try_again_label");
	                } else if (this.state.progression_label === this.state.continue_label) {
	                    progression_label = appHelper.getLocaleString("continue_label");
	                }
	
	                this.setState({
	                    lang: nextProps.lang,
	                    locale: appHelper.getLocalData(this.state.screenObject),
	                    multiple_choice_single_answer_question_label: appHelper.getLocaleString("multiple_choice_single_answer_question_label"),
	                    submit_label: appHelper.getLocaleString("submit_label"),
	                    progression_label: progression_label,
	                    continue_label: appHelper.getLocaleString("continue_label"),
	                    try_again_label: appHelper.getLocaleString("try_again_label")
	                });
	            }
	        }
	    }, {
	        key: 'componentDidUpdate',
	        value: function componentDidUpdate() {
	            if (this.state.propsUpdated && this.state.responseData.displayState === objectConstants.OBJECT_DISPLAY_STATE_REVIEW) {
	                this.setReviewMode();
	            }
	
	            if (this.state.watchCheckBtnState) {
	                this.setCheckBtnState(this.state.revealedOptions.length >= this.props.screenObject.options.length);
	            }
	
	            if (this.state.skipFeedback) {
	                this.handleSkipFeedback();
	            }
	
	            if (this.state.checkObjectStatus) {
	                this.getObjectStatus();
	            }
	
	            if (this.state.handleCompletion) {
	                this.handleProgression();
	            }
	
	            if (this.state.checkPostXAPIResponse) {
	                this.postXAPIResponse();
	            }
	
	            if (this.state.focusOnFeedback) {
	                this.onFocusOnFeedback();
	            }
	
	            if (this.state.updateFocus) {
	                this.setOptionFocus();
	            }
	        }
	    }, {
	        key: 'postXAPIResponse',
	        value: function postXAPIResponse() {
	            this.setState({ checkPostXAPIResponse: false });
	            var interactionData = xAPIHelper.setSingleAnwserChoiceInteractionData(this.state.screenObject, this.state.responseData);
	            if (localStorage.tracking_type === appConstants.TRACKING_TYPE_XAPI || localStorage.tracking_type === appConstants.TRACKING_TYPE_BLENDED_XAPI_SCORM_1_2) {
	
	                var screen = appHelper.getScreenByAssetId(this.state.screenObject.asset_id);
	                var category = {
	                    constant: componentConstants.SINGLE_ANSWER,
	                    label: componentConstants.MULTIPLE_CHOICE_SINGLE_ANSWER_LABEL
	                };
	
	                this.props.actions.postActvityStatement(screen, interactionData, category);
	            }
	        }
	    }, {
	        key: 'handleSkipFeedback',
	        value: function handleSkipFeedback() {
	            var latestResponse = appHelper.getLastItemOfArray(this.state.responseData.responses);
	            var selectedOptions = [latestResponse.selectedOption.option_id];
	            if (appHelper.isDefined(latestResponse.audio)) {
	                var audio = appHelper.getAudioAsset(latestResponse.audio);
	                var audioObj = {
	                    audioRef: 'audio_' + audio.id + '_' + audio.type
	                };
	
	                this.props.actions.setAudio(audioObj);
	            }
	            var responseObj = {
	                asset_id: this.state.screenObject.asset_id,
	                selectedOptions: selectedOptions,
	                kpis: latestResponse.selectedOption.kpis !== null ? latestResponse.selectedOption.kpis : []
	            };
	            this.props.callbacks.storeUserResponse(responseObj);
	            this.setState({ skipFeedback: false });
	            if (!this.state.hasBadges) {
	
	                var handleResponse = this.handleResponse;
	
	                setTimeout(function () {
	                    handleResponse();
	                }, 1000);
	            }
	        }
	    }, {
	        key: 'checkResponses',
	        value: function checkResponses() {
	            var _this2 = this;
	
	            if (localStorage.tracking_type === appConstants.TRACKING_TYPE_XAPI || localStorage.tracking_type === appConstants.TRACKING_TYPE_BLENDED_XAPI_SCORM_1_2) {
	                var parentScreen = this.props.callbacks.getSubScreenParent();
	                var params = {
	
	                    bite_id: this.props.callbacks.getBiteId(),
	                    screen_id: this.props.callbacks.getScreenId(),
	                    parent_screen_id: appHelper.isDefined(parentScreen) ? parentScreen.screen_id : undefined,
	                    asset_id: this.state.screenObject.asset_id
	                };
	
	                var interactionData = xAPIHelper.getMultipleChoiceIds(params);
	
	                this.props.actions.getActvityStatement(interactionData).then(function (responseObj) {
	                    if (appHelper.isDefined(responseObj.statement.result.completion)) {
	                        _this2.setState({
	                            xApiResponseObj: Object.assign({}, responseObj),
	                            reviewMode: true,
	                            propsUpdated: true,
	                            responseData: Object.assign({}, _this2.state.responseData, {
	                                currentStatus: objectConstants.STATUS_COMPLETE,
	                                displayState: objectConstants.OBJECT_DISPLAY_STATE_REVIEW
	                            })
	                        });
	                    }
	                });
	            }
	        }
	    }, {
	        key: 'getObjectStatus',
	        value: function getObjectStatus() {
	            this.setState({ checkObjectStatus: false });
	            if (this.state.responseData.currentStatus !== objectConstants.STATUS_COMPLETE) {
	                var screenStatus = userDataHelper.getObjectStatus(this.state.userData, this.props.screenObject.asset_id);
	                if (screenStatus === objectConstants.STATUS_COMPLETE && this.state.screenObject.attempt_type === objectConstants.ATTEMPT_TYPE_FIRST) {
	                    this.setState({
	                        reviewMode: true,
	                        propsUpdated: true,
	                        responseData: Object.assign({}, this.state.responseData, {
	                            currentStatus: objectConstants.STATUS_COMPLETE,
	                            displayState: objectConstants.OBJECT_DISPLAY_STATE_REVIEW
	                        })
	                    });
	                } else {
	                    var objectUserData = {};
	                    if (this.state.status !== objectConstants.STATUS_COMPLETE) {
	                        var subScreenParent = this.props.callbacks.getSubScreenParent();
	                        var screen_id = this.props.callbacks.getScreenId();
	                        if (appHelper.isDefined(subScreenParent)) {
	                            objectUserData = userDataHelper.getSubScreenObjectStatus(this.state.userData, subScreenParent.screen_id, screen_id, this.state.screenObject.asset_id);
	                        } else {
	                            objectUserData = userDataHelper.getObjectStatus(this.state.userData, screen_id, this.state.screenObject.asset_id);
	                        }
	                    }
	
	                    if (objectUserData.status === objectConstants.STATUS_COMPLETE && this.state.screenObject.attempt_type === objectConstants.ATTEMPT_TYPE_FIRST) {
	                        this.setState({
	                            reviewMode: true,
	                            propsUpdated: true,
	                            responseData: Object.assign({}, this.state.responseData, {
	                                currentStatus: objectConstants.STATUS_COMPLETE,
	                                displayState: objectConstants.OBJECT_DISPLAY_STATE_REVIEW
	                            })
	                        });
	                    }
	                }
	            }
	        }
	    }, {
	        key: 'setReviewMode',
	        value: function setReviewMode() {
	            var optionIds = appHelper.getObjectOptionIds(this.state.screenObject);
	            var kpiUserData = userDataHelper.getUserResponseByOptionIds(this.state.userData, this.props.callbacks.getBiteId(), optionIds);
	            if (appHelper.isDefined(kpiUserData)) {
	                var optionDetails = appHelper.getOptionParentDetails(kpiUserData.option_id[0]);
	                var showResponse = false;
	
	                if (appHelper.isDefined(optionDetails)) {
	                    var responses = [];
	                    var response = {
	                        selectedOption: optionDetails.option
	                    };
	
	                    if (appHelper.isDefined(optionDetails.option.dialogs) && optionDetails.option.dialogs.length > 0) {
	                        showResponse = true;
	                    }
	
	                    var hasBadges = appHelper.isDefined(optionDetails.option.badges) && optionDetails.option.badges.length > 0;
	
	                    this.setState({
	                        showProgression: !this.props.callbacks.hasNextObject(this.props.index) && optionDetails.option.enable_feedback,
	                        hasBadges: hasBadges,
	                        badgesCollected: hasBadges,
	                        handleCompletion: true,
	                        propsUpdated: false,
	                        showOptions: true,
	                        questionChecked: true,
	                        currentlyChecked: true,
	                        showCheckBtn: false,
	                        options: dataHelper.immutableSplice(this.state.options, 0, this.state.options.length, optionDetails.option),
	                        showResponse: showResponse,
	                        progression_label: response.selectedOption.progression === objectConstants.OBJECT_PROGRESSION_TRY_AGAIN ? this.state.try_again_label : this.state.continue_label,
	                        responseData: Object.assign({}, this.state.responseData, {
	                            responses: dataHelper.immutablePush(responses, response),
	                            latestResponse: optionDetails.option
	                        })
	                    });
	                }
	            } else if (localStorage.tracking_type === appConstants.TRACKING_TYPE_XAPI || localStorage.tracking_type === appConstants.TRACKING_TYPE_BLENDED_XAPI_SCORM_1_2) {
	
	                var responseObj = Object.assign({}, this.state.xApiResponseObj);
	
	                if (appHelper.isDefined(responseObj.statement)) {
	                    var responseString = responseObj.statement.result.response;
	                    var choices = responseObj.statement.object.definition.choices;
	                    var optionResponse = xAPIHelper.getChoiceByDescription(choices, responseString);
	                    //let optionDetails = appHelper.getOptionByLabelName(responseString, this.state.screenObject.options);
	                    var _optionDetails = appHelper.getOptionParentDetails(parseInt(optionResponse.id));
	                    if (appHelper.isDefined(_optionDetails)) {
	                        var _showResponse = false;
	                        var _responses = [];
	                        var _response = {
	                            selectedOption: _optionDetails.option
	                        };
	
	                        if (appHelper.isDefined(_optionDetails.option.dialogs) && _optionDetails.option.dialogs.length > 0) {
	                            _showResponse = true;
	                        }
	
	                        var _hasBadges = appHelper.isDefined(_optionDetails.option.badges) && _optionDetails.option.badges.length > 0;
	                        this.setState({
	                            showProgression: !this.props.callbacks.hasNextObject(this.props.index) && _optionDetails.option.enable_feedback,
	                            hasBadges: _hasBadges,
	                            badgesCollected: _hasBadges,
	                            handleCompletion: true,
	                            propsUpdated: false,
	                            showOptions: true,
	                            questionChecked: true,
	                            currentlyChecked: true,
	                            showCheckBtn: false,
	                            options: dataHelper.immutableSplice(this.state.options, 0, this.state.options.length, _optionDetails.option),
	                            showResponse: _showResponse,
	                            progression_label: _response.selectedOption.progression === objectConstants.OBJECT_PROGRESSION_TRY_AGAIN ? this.state.try_again_label : this.state.continue_label,
	                            responseData: Object.assign({}, this.state.responseData, {
	                                responses: dataHelper.immutablePush(_responses, _response),
	                                latestResponse: _optionDetails.option
	                            })
	                        });
	                    } else {
	                        this.setState({
	                            reviewMode: false,
	                            propsUpdated: true,
	                            responseData: Object.assign({}, this.state.responseData, {
	                                currentStatus: objectConstants.STATUS_NOT_STARTED,
	                                displayState: objectConstants.OBJECT_DISPLAY_STATE_INITIAL
	                            })
	                        });
	                    }
	                } else {
	                    this.setState({ renderQuestions: true });
	                }
	            } else {
	                this.setState({
	                    reviewMode: false,
	                    propsUpdated: true,
	                    responseData: Object.assign({}, this.state.responseData, {
	                        currentStatus: objectConstants.STATUS_NOT_STARTED,
	                        displayState: objectConstants.OBJECT_DISPLAY_STATE_INITIAL
	                    })
	                });
	            }
	        }
	    }, {
	        key: 'getLocale',
	        value: function getLocale() {
	            var locale = appHelper.getLocalData(this.state.screenObject);
	            this.setState({ locale: Object.assign({}, locale) });
	            if (this.state.screenObject.show_title_in_header) {
	                this.props.actions.setScreenTitle(locale.title);
	            }
	        }
	    }, {
	        key: 'scrollToSubmitBtn',
	        value: function scrollToSubmitBtn() {
	            var submitBtn = this.refs[this.state.screenObject.asset_id + '_check'];
	            this.props.callbacks.scrollToSubmitBtn(submitBtn.offsetTop);
	        }
	    }, {
	        key: 'setCheckBtnState',
	        value: function setCheckBtnState(state) {
	
	            if (this.state.responseData.displayState !== objectConstants.OBJECT_DISPLAY_STATE_REVIEW) {
	                this.setState({ showCheckBtn: state, watchCheckBtnState: false });
	            }
	        }
	    }, {
	        key: 'onOptionRevealed',
	        value: function onOptionRevealed(option) {
	            var index = appHelper.getArrayObjectIndexByKey(this.state.revealedOptions, "option_id", option.option_id);
	            if (index === -1) {
	                this.setState({
	                    revealedOptions: dataHelper.immutablePush(this.state.revealedOptions, option),
	                    watchCheckBtnState: true
	                });
	            }
	        }
	    }, {
	        key: 'randomiseOptions',
	        value: function randomiseOptions() {
	            if (this.state.screenObject.randomise_options) {
	                var options = dataHelper.randomiseArray(this.state.options);
	                this.setState({
	                    options: options,
	                    showOptions: true,
	                    focusedOption: options[0]
	                });
	            } else {
	                this.setState({ showOptions: true });
	            }
	            this.props.callbacks.scrollToTop();
	        }
	    }, {
	        key: 'renderOptions',
	        value: function renderOptions() {
	            if (!this.state.showOptions && this.state.responseData.currentStatus === objectConstants.STATUS_NOT_STARTED) {
	                this.setState({ showOptions: true });
	            }
	
	            this.props.callbacks.scrollToTop();
	        }
	    }, {
	        key: 'onOptionClick',
	        value: function onOptionClick(event) {
	            var response = {
	                selectedOption: appHelper.getObjectOption(this.state.screenObject.options, event.target.value)
	            };
	            this.setState({
	                responseData: Object.assign({}, this.state.responseData, {
	                    //responses: dataHelper.immutablePush(this.state.responseData.responses, response),
	                    latestResponse: Object.assign({}, response.selectedOption)
	                }),
	                enableCheckBtn: true
	            });
	            this.scrollToSubmitBtn();
	        }
	    }, {
	        key: 'checkAnswers',
	        value: function checkAnswers() {
	            var response = {
	                selectedOption: this.state.responseData.latestResponse
	            };
	            var showResponse = false;
	            if (appHelper.isDefined(this.state.responseData.latestResponse.dialogs) && this.state.responseData.latestResponse.dialogs.length > 0) {
	                showResponse = true;
	            }
	            var enable_feedback = this.state.responseData.latestResponse.enable_feedback;
	
	            var hasBadges = appHelper.isDefined(this.state.responseData.latestResponse.badges) && this.state.responseData.latestResponse.badges.length > 0 && !enable_feedback && !showResponse;
	            var progressionType = appHelper.isDefined(this.state.responseData.latestResponse.progression_type) ? this.state.responseData.latestResponse.progression_type : undefined;
	
	            this.setState({
	                responseData: Object.assign({}, this.state.responseData, {
	                    responses: dataHelper.immutablePush(this.state.responseData.responses, response),
	                    displayState: objectConstants.OBJECT_DISPLAY_STATE_ANSWERED
	                }),
	                showFeedback: enable_feedback && !showResponse,
	                focusOnFeedback: enable_feedback && !showResponse,
	                skipFeedback: !enable_feedback && this.state.responseData.latestResponse.progression !== objectConstants.OBJECT_PROGRESSION_TRY_AGAIN && !showResponse,
	                showProgression: !enable_feedback && this.state.responseData.latestResponse.progression === objectConstants.OBJECT_PROGRESSION_TRY_AGAIN || !enable_feedback && this.state.responseData.latestResponse.progression !== objectConstants.OBJECT_PROGRESSION_TRY_AGAIN && !this.props.callbacks.hasNextObject(this.props.index) && progressionType !== objectConstants.GO_TO_TYPE_SCREEN && !showResponse,
	                progression_label: this.state.responseData.latestResponse.progression === objectConstants.OBJECT_PROGRESSION_TRY_AGAIN ? this.state.try_again_label : this.state.continue_label,
	                hasBadges: hasBadges,
	                showResponse: showResponse,
	                questionChecked: true,
	                currentlyChecked: true,
	                showCheckBtn: false,
	                enableCheckBtn: false,
	                showOptions: true,
	                checkPostXAPIResponse: true
	            });
	        }
	    }, {
	        key: 'showFeedback',
	        value: function showFeedback() {
	            if (this.state.responseData.currentStatus !== objectConstants.STATUS_COMPLETE) {
	                this.setState({ showFeedback: true, focusOnFeedback: true });
	            }
	        }
	    }, {
	        key: 'handleResponse',
	        value: function handleResponse() {
	            this.setState({ hideFeedback: false });
	            var showResponse = false;
	            if (appHelper.isDefined(this.state.responseData.latestResponse.dialogs) && this.state.responseData.latestResponse.dialogs.length > 0) {
	                showResponse = true;
	            }
	
	            var latestResponseFeedbackLocale = appHelper.getLocalData(this.state.responseData.latestResponse);
	            var optionHasFeedback = appHelper.isDefined(latestResponseFeedbackLocale.feedback);
	            if (optionHasFeedback && latestResponseFeedbackLocale.feedback.length === 0 || latestResponseFeedbackLocale.feedback === "<p><br></p>") {
	                optionHasFeedback = false;
	            }
	
	            if (appHelper.isDefined(this.state.responseData.latestResponse.resources) && this.state.responseData.latestResponse.resources.length > 0) {
	                optionHasFeedback = true;
	            }
	
	            var progressionRule = this.state.responseData.latestResponse.progression;
	            if (progressionRule === objectConstants.OBJECT_PROGRESSION_TRY_AGAIN) {
	                this.reattempt();
	            } else {
	                this.setState({
	                    showFeedback: !this.props.callbacks.hasNextObject(this.props.index) && this.hasFeedbackToShow(),
	                    focusOnFeedback: !this.props.callbacks.hasNextObject(this.props.index) && this.hasFeedbackToShow(),
	                    showOptions: true,
	                    options: dataHelper.immutableSplice(this.state.options, 0, this.state.options.length, this.state.responseData.latestResponse),
	                    responseData: Object.assign({}, this.state.responseData, {
	                        currentStatus: objectConstants.STATUS_COMPLETE,
	                        displayState: objectConstants.OBJECT_DISPLAY_STATE_REVIEW
	
	                    })
	                });
	
	                this.handleProgression();
	            }
	        }
	    }, {
	        key: 'hasFeedbackToShow',
	        value: function hasFeedbackToShow() {
	            var enable_feedback = this.state.responseData.latestResponse.enable_feedback;
	            return enable_feedback;
	        }
	    }, {
	        key: 'handleProgression',
	        value: function handleProgression() {
	
	            this.setState({ handleCompletion: false });
	            if (!this.state.progressionHandled) {
	                this.setState({ progressionHandled: true });
	                var enable_feedback = this.state.responseData.latestResponse.enable_feedback;
	                var progressionRule = this.state.responseData.latestResponse.progression;
	                var progressionType = appHelper.isDefined(this.state.responseData.latestResponse.progression_type) ? this.state.responseData.latestResponse.progression_type : undefined;
	                var progressionGoToId = appHelper.isDefined(this.state.responseData.latestResponse.progression_goto_id) ? this.state.responseData.latestResponse.progression_goto_id : undefined;
	                var completionData = {
	                    progression: progressionRule,
	                    asset_id: this.state.screenObject.asset_id,
	                    status: objectConstants.STATUS_COMPLETE,
	                    asset_type_code: this.state.screenObject.asset_type_code,
	                    navigateToNextScreen: progressionType !== objectConstants.GO_TO_TYPE_SCREEN,
	                    progressionType: progressionType,
	                    progressionGoToId: progressionGoToId,
	                    index: this.props.index
	                };
	
	                this.props.callbacks.onObjectComplete(completionData);
	            }
	        }
	    }, {
	        key: 'reattempt',
	        value: function reattempt() {
	            var focusEl = this.refs[this.state.screenObject.asset_id + '_questionOptions'];
	            focusEl.focus();
	
	            this.setState({
	                showFeedback: false,
	                enableCheckBtn: false,
	                showCheckBtn: true,
	                revealedOptions: dataHelper.immutableSplice(this.state.revealedOptions, 0, this.state.revealedOptions.length),
	                showOptions: true,
	                showResponse: false,
	                currentlyChecked: false,
	                focusedOption: this.state.options[0],
	                updateFocus: true,
	                responseData: Object.assign({}, this.state.responseData, {
	                    currentAttempt: this.state.responseData.currentAttempt + 1,
	                    currentStatus: objectConstants.STATUS_ATTEMPTED,
	                    displayState: objectConstants.OBJECT_DISPLAY_STATE_RETRY,
	                    latestResponse: Object.assign({}, {})
	
	                })
	            });
	        }
	
	        //REVEW POPUP
	
	    }, {
	        key: 'onReviewObject',
	        value: function onReviewObject(sourceId) {
	            if (this.hasFeedbackToShow()) {
	                var config = Object.assign({}, _dialogModels.MULTIPLE_CHOICE_REVIEW_CONFIG, {
	                    title: this.state.locale.label,
	                    sourceId: sourceId
	                });
	                //locale.title
	
	                for (var i = 0; i < config.childComponents.length; i++) {
	                    var child = config.childComponents[i];
	                    child.componentProps = Object.assign({}, {
	                        screenObject: this.state.screenObject,
	                        responseData: Object.assign({}, this.state.responseData, {
	                            displayState: objectConstants.OBJECT_DISPLAY_STATE_REVIEW
	                        }),
	                        callbacks: this.props.callbacks
	                    });
	                }
	                this.props.actions.setNewDialog(config);
	            }
	        }
	    }, {
	        key: 'handleResponseComplete',
	        value: function handleResponseComplete() {
	            var enable_feedback = this.state.responseData.latestResponse.enable_feedback;
	            var progressionType = appHelper.isDefined(this.state.responseData.latestResponse.progression_type) ? this.state.responseData.latestResponse.progression_type : undefined;
	
	            this.setState({
	                showFeedback: enable_feedback && this.state.responseData.displayState !== objectConstants.OBJECT_DISPLAY_STATE_REVIEW,
	                focusOnFeedback: enable_feedback && this.state.responseData.displayState !== objectConstants.OBJECT_DISPLAY_STATE_REVIEW,
	                hasBadges: appHelper.isDefined(this.state.responseData.latestResponse.badges) && this.state.responseData.latestResponse.badges.length > 0 && !enable_feedback,
	                skipFeedback: !enable_feedback && this.state.responseData.latestResponse.progression !== objectConstants.OBJECT_PROGRESSION_TRY_AGAIN,
	                showProgression: !enable_feedback && this.state.responseData.latestResponse.progression === objectConstants.OBJECT_PROGRESSION_TRY_AGAIN || !enable_feedback && this.state.responseData.latestResponse.progression !== objectConstants.OBJECT_PROGRESSION_TRY_AGAIN && !this.props.callbacks.hasNextObject(this.props.index) && progressionType !== objectConstants.GO_TO_TYPE_SCREEN
	
	            });
	        }
	    }, {
	        key: 'getStatusClass',
	        value: function getStatusClass() {
	            return this.state.responseData.displayState === objectConstants.OBJECT_DISPLAY_STATE_REVIEW && this.props.contentData.experience.include_explore_feedback && this.hasFeedbackToShow() ? "complete" : "";
	        }
	    }, {
	        key: 'getTabIndex',
	        value: function getTabIndex() {
	            return this.state.responseData.displayState === objectConstants.OBJECT_DISPLAY_STATE_REVIEW && this.props.contentData.experience.include_explore_feedback ? 0 : -1;
	        }
	    }, {
	        key: 'onPanelClick',
	        value: function onPanelClick() {
	            if (this.state.responseData.displayState === objectConstants.OBJECT_DISPLAY_STATE_REVIEW && this.props.contentData.experience.include_explore_feedback && this.hasFeedbackToShow()) {
	                this.onReviewObject('question_wrapper_' + this.state.screenObject.asset_id);
	            }
	        }
	    }, {
	        key: 'onKeyboardPanelClick',
	        value: function onKeyboardPanelClick(event) {
	            if (event.which === keyboardConstants.ENTER_KEY || event.which === keyboardConstants.SPACEBAR_KEY) {
	                event.preventDefault();
	                if (this.state.responseData.displayState === objectConstants.OBJECT_DISPLAY_STATE_REVIEW && this.props.contentData.experience.include_explore_feedback) {
	                    this.onReviewObject('question_wrapper_' + this.state.screenObject.asset_id);
	                }
	            }
	        }
	    }, {
	        key: 'getImagePath',
	        value: function getImagePath(image) {
	            if (appConstants.DEVELOPMENT_MODE) {
	                if (appHelper.isDefined(image) && image.length > 0) {
	                    return __webpack_require__(16)("./" + image);
	                }
	            } else {
	                return image;
	            }
	        }
	    }, {
	        key: 'getPrevOption',
	        value: function getPrevOption() {
	            var optionIndex = appHelper.getArrayObjectIndexByKey(this.state.options, "option_id", this.state.focusedOption.option_id);
	            var nextOption = this.state.options[optionIndex - 1];
	            if (optionIndex <= 0) {
	                nextOption = this.state.options[this.state.options.length - 1];
	            }
	
	            this.setState({ focusedOption: Object.assign({}, nextOption), updateFocus: true });
	        }
	    }, {
	        key: 'getNextOption',
	        value: function getNextOption() {
	            var optionIndex = appHelper.getArrayObjectIndexByKey(this.state.options, "option_id", this.state.focusedOption.option_id);
	            var nextOption = this.state.options[optionIndex + 1];
	            if (optionIndex === this.state.options.length - 1) {
	                nextOption = this.state.options[0];
	            }
	            this.setState({ focusedOption: Object.assign({}, nextOption), updateFocus: true });
	        }
	    }, {
	        key: 'allowKeyAccessibility',
	        value: function allowKeyAccessibility() {
	            var responseData = this.state.responseData;
	            //if (responseData.displayState === objectConstants.OBJECT_DISPLAY_STATE_INITIAL) {
	            if (responseData.currentAttempt === responseData.responses.length) {
	                return false;
	            } else {
	                for (var i = 0; i < this.state.responseData.responses.length; i++) {
	                    var response = this.state.responseData.responses[i];
	                    if (response.selectedOption.option_id === this.state.focusedOption.option_id) {
	                        return false;
	                    }
	                }
	                return true;
	            }
	        }
	    }, {
	        key: 'setKeyboardAccessibility',
	        value: function setKeyboardAccessibility(event) {
	            if (event.which === keyboardConstants.ENTER_KEY || event.which === keyboardConstants.SPACEBAR_KEY) {
	                event.preventDefault();
	                if (this.allowKeyAccessibility()) {
	                    this.onOptionClick({ target: { value: this.state.focusedOption.option_id } });
	                } else {
	                    var responseData = this.state.responseData;
	                    if (responseData.displayState === objectConstants.OBJECT_DISPLAY_STATE_ANSWERED || responseData.displayState === objectConstants.OBJECT_DISPLAY_STATE_REVIEW && this.props.contentData.experience.include_explore_feedback) {
	                        this.onReviewObject('option_' + this.state.focusedOption.option_id);
	                    }
	                }
	            }
	
	            if (event.which === keyboardConstants.ARROW_LEFT_KEY) {
	                event.preventDefault();
	                this.getPrevOption();
	            }
	
	            if (event.which === keyboardConstants.ARROW_RIGHT_KEY) {
	                event.preventDefault();
	                this.getNextOption();
	            }
	
	            if (event.which === keyboardConstants.ARROW_UP_KEY) {
	                event.preventDefault();
	                this.getPrevOption();
	            }
	
	            if (event.which === keyboardConstants.ARROW_DOWN_KEY) {
	                event.preventDefault();
	                this.getNextOption();
	            }
	        }
	    }, {
	        key: 'onFocusOnFeedback',
	        value: function onFocusOnFeedback() {
	            var focusEl = document.getElementById('feedback_wrapper_' + this.state.screenObject.asset_id);
	            if (appHelper.isDefined(focusEl) && focusEl !== null) {
	                focusEl.focus();
	            }
	            this.setState({ focusOnFeedback: false });
	        }
	    }, {
	        key: 'setOptionCallbacks',
	        value: function setOptionCallbacks() {
	            this.setState({
	                optionCallbacks: Object.assign({}, this.state.optionCallbacks, {
	                    setKeyboardAccessibility: this.setKeyboardAccessibility
	                })
	            });
	        }
	    }, {
	        key: 'setOptionFocus',
	        value: function setOptionFocus() {
	            var focusEl = document.getElementById('option_' + this.state.focusedOption.option_id);
	            focusEl.focus();
	            this.setState({ updateFocus: false });
	        }
	    }, {
	        key: 'enableProgression',
	        value: function enableProgression(progression_label) {
	            var hasBadges = appHelper.isDefined(this.state.responseData.latestResponse.badges) && this.state.responseData.latestResponse.badges.length > 0;
	            var progressionType = appHelper.isDefined(this.state.responseData.latestResponse.progression_type) ? this.state.responseData.latestResponse.progression_type : undefined;
	
	            var showProgression = !hasBadges;
	            if (!this.props.callbacks.hasNextObject(this.props.index)) {
	                showProgression = !hasBadges && progressionType !== objectConstants.GO_TO_TYPE_SCREEN;
	            }
	            this.setState({
	                showProgression: showProgression,
	                hasBadges: hasBadges,
	                progression_label: this.state.responseData.latestResponse.progression === objectConstants.OBJECT_PROGRESSION_TRY_AGAIN ? this.state.try_again_label : this.state.continue_label
	            });
	            this.props.callbacks.scrollToContinue();
	        }
	    }, {
	        key: 'onProgressionClicked',
	        value: function onProgressionClicked() {
	            this.setState({
	                showProgression: false,
	                hideFeedback: this.props.callbacks.hasNextObject(this.props.index) && this.state.responseData.latestResponse.progression !== objectConstants.OBJECT_PROGRESSION_TRY_AGAIN
	            });
	            var enable_feedback = this.state.responseData.latestResponse.enable_feedback;
	
	            if (!this.props.callbacks.hasNextObject(this.props.index) && this.state.responseData.latestResponse.progression !== objectConstants.OBJECT_PROGRESSION_TRY_AGAIN) {
	                this.props.callbacks.navigateToNextScreen();
	            } else if (this.state.responseData.latestResponse.progression === objectConstants.OBJECT_PROGRESSION_TRY_AGAIN) {
	                this.reattempt();
	            }
	        }
	    }, {
	        key: 'onBadgeCollected',
	        value: function onBadgeCollected() {
	            this.setState({ badgesCollected: true });
	
	            if (!this.props.callbacks.hasNextObject(this.props.index)) {
	                this.setState({
	                    showProgression: true,
	                    progression_label: this.state.responseData.latestResponse.progression === objectConstants.OBJECT_PROGRESSION_TRY_AGAIN ? this.state.try_again_label : this.state.continue_label
	                });
	                this.props.callbacks.scrollToContinue();
	            }
	            this.handleResponse();
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this3 = this;
	
	            return _react2.default.createElement(
	                'div',
	                { className: 'learner-action' },
	                _react2.default.createElement(
	                    'p',
	                    { className: 'hidden-el' },
	                    this.state.multiple_choice_single_answer_question_label
	                ),
	                appHelper.isDefined(this.props.characterPose) && appHelper.isDefined(this.props.characterPose.src) && this.props.characterPose.src.length > 0 ? _react2.default.createElement(
	                    'div',
	                    { className: 'content-character-expression' },
	                    _react2.default.createElement('img', { src: this.getImagePath(this.props.characterPose.src), alt: '' })
	                ) : null,
	                _react2.default.createElement(
	                    'div',
	                    { className: 'question-wrapper ' + this.getStatusClass(), tabIndex: this.getTabIndex(),
	                        id: 'question_wrapper_' + this.state.screenObject.asset_id,
	                        role: 'presentation', onClick: this.onPanelClick, onKeyDown: this.onKeyboardPanelClick },
	                    this.state.screenObject.prompt_type !== objectConstants.PROMPT_TYPE_SHOW_NO_PROMPT && this.state.screenObject.show_prompt ? this.state.screenObject.prompt_type === objectConstants.PROMPT_TYPE_DIALOG_PROMPT ? _react2.default.createElement(
	                        'div',
	                        { className: 'object-container' },
	                        _react2.default.createElement(_DialogPrompt2.default, { character_name: this.state.character_name,
	                            id: this.state.screenObject.asset_id, locale: this.state.locale,
	                            show_title: this.state.screenObject.show_title,
	                            onComplete: this.onPromptRevealed })
	                    ) : _react2.default.createElement(_Prompt2.default, { id: this.state.screenObject.asset_id, locale: this.state.locale,
	                        show_title: this.state.screenObject.show_title,
	                        onComplete: this.onPromptRevealed }) : null,
	                    this.state.showOptions ? _react2.default.createElement(
	                        'div',
	                        { className: 'multiple-choice-option-list theme-active feedback-focus',
	                            ref: this.state.screenObject.asset_id + '_questionOptions',
	                            role: 'radiogroup' },
	                        this.state.options.map(function (option) {
	                            return _react2.default.createElement(_SingleAnswerOption2.default, { key: option.option_id, option: option,
	                                asset_id: _this3.state.screenObject.asset_id,
	                                questionChecked: _this3.state.questionChecked,
	                                currentlyChecked: _this3.state.currentlyChecked,
	                                onOptionClick: _this3.onOptionClick,
	                                responseData: _this3.state.responseData,
	                                onAttemptComplete: _this3.showFeedback,
	                                onOptionRevealed: _this3.onOptionRevealed,
	                                onReviewObject: _this3.onReviewObject,
	                                focusedOption: _this3.state.focusedOption,
	                                optionCallbacks: _this3.state.optionCallbacks,
	                                index: appHelper.getObjectOptionIndex(_this3.state.screenObject.options, option.option_id),
	                                showFeedback: appHelper.isDefined(_this3.state.responseData.latestResponse.enable_feedback) && _this3.state.responseData.latestResponse.enable_feedback
	                            });
	                        })
	                    ) : null,
	                    this.state.showCheckBtn ? _react2.default.createElement(
	                        'div',
	                        { ref: this.state.screenObject.asset_id + '_check' },
	                        _react2.default.createElement(_Button2.default, { label: this.state.submit_label,
	                            id: this.state.screenObject.asset_id + '_check_button',
	                            isDisabled: !this.state.enableCheckBtn,
	                            onRevealed: this.props.callbacks.scrollToTop,
	                            onClick: this.checkAnswers })
	                    ) : null,
	                    this.state.showResponse || this.state.showFeedback ? _react2.default.createElement(
	                        'div',
	                        { ref: 'feedback_wrapper_' + this.state.screenObject.asset_id,
	                            id: 'feedback_wrapper_' + this.state.screenObject.asset_id,
	                            role: 'link',
	                            tabIndex: 0,
	                            className: 'feedback-focus' },
	                        this.state.showResponse ? _react2.default.createElement(_ChildConversationDialog2.default, { asset_id: this.state.screenObject.asset_id,
	                            option_id: this.state.responseData.latestResponse.option_id,
	                            dialogs: this.state.responseData.latestResponse.dialogs,
	                            callbacks: this.props.callbacks,
	                            onComplete: this.handleResponseComplete }) : null,
	                        this.state.showFeedback ? _react2.default.createElement(_SingleAnswerFeedback2.default, { screenObject: this.state.screenObject,
	                            option: this.state.responseData.latestResponse,
	                            options: this.state.screenObject.options,
	                            asset_id: this.state.screenObject.asset_id,
	                            responseData: this.state.responseData,
	                            onComplete: this.handleResponse,
	                            onShowReview: this.onReviewObject,
	                            onEnableProgression: this.enableProgression,
	                            hideFeedback: this.state.hideFeedback,
	                            index: this.props.index,
	                            callbacks: this.props.callbacks }) : null
	                    ) : null,
	                    (this.state.showResponse || this.state.showFeedback) && this.state.hasBadges ? _react2.default.createElement('br', null) : null,
	                    this.state.hasBadges ? _react2.default.createElement(
	                        'div',
	                        { className: 'badge-wrapper' },
	                        this.state.responseData.latestResponse.badges.map(function (badge) {
	                            return _react2.default.createElement(_BadgeCollect2.default, { key: badge.badge_id, badge_id: badge.badge_id,
	                                bite_id: _this3.props.callbacks.getBiteId(),
	                                asset_id: _this3.state.screenObject.asset_id,
	                                onCollected: _this3.onBadgeCollected,
	                                animate: _this3.state.animateBadge
	                            });
	                        })
	                    ) : null
	                ),
	                this.state.showProgression ? _react2.default.createElement(_Button2.default, { label: this.state.progression_label, id: this.state.screenObject.asset_id + '_button',
	                    onClick: this.onProgressionClicked }) : null
	            );
	        }
	    }]);
	
	    return SingleAnswer;
	}(_react2.default.Component);
	
	SingleAnswer.propTypes = {
	    screenObject: _propTypes2.default.object.isRequired,
	    callbacks: _propTypes2.default.object.isRequired,
	    index: _propTypes2.default.number,
	    characterPose: _propTypes2.default.object,
	    contentData: _propTypes2.default.object.isRequired,
	    trackingData: _propTypes2.default.object.isRequired,
	    userData: _propTypes2.default.object.isRequired,
	    lang: _propTypes2.default.string.isRequired,
	    actions: _propTypes2.default.object.isRequired
	};
	
	SingleAnswer.contextTypes = {
	    router: _propTypes2.default.object
	};
	
	function mapStateToProps(state) {
	    var lang = state.userData.lang;
	    return {
	        lang: lang,
	        contentData: state.contentData,
	        trackingData: state.trackingData,
	        userData: state.userData
	
	    };
	}
	
	function mapDispatchToProps(dispatch) {
	    return {
	        actions: (0, _redux.bindActionCreators)(Object.assign({}, appDataActions, trackingDataActions, dialogPopupActions), dispatch)
	    };
	}
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(SingleAnswer);

/***/ },
/* 506 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(5);
	
	var _redux = __webpack_require__(4);
	
	var _KpiDashboard = __webpack_require__(93);
	
	var _KpiDashboard2 = _interopRequireDefault(_KpiDashboard);
	
	var _ChildConversationDialog = __webpack_require__(65);
	
	var _ChildConversationDialog2 = _interopRequireDefault(_ChildConversationDialog);
	
	var _ResourceLinks = __webpack_require__(48);
	
	var _ResourceLinks2 = _interopRequireDefault(_ResourceLinks);
	
	var _trackingDataActions = __webpack_require__(7);
	
	var trackingDataActions = _interopRequireWildcard(_trackingDataActions);
	
	var _userDataActions = __webpack_require__(20);
	
	var userDataActions = _interopRequireWildcard(_userDataActions);
	
	var _appHelper = __webpack_require__(3);
	
	var appHelper = _interopRequireWildcard(_appHelper);
	
	var _appConstants = __webpack_require__(13);
	
	var appConstants = _interopRequireWildcard(_appConstants);
	
	var _kpiConstants = __webpack_require__(37);
	
	var kpiConstants = _interopRequireWildcard(_kpiConstants);
	
	var _objectConstants = __webpack_require__(9);
	
	var objectConstants = _interopRequireWildcard(_objectConstants);
	
	var _gsap = __webpack_require__(8);
	
	var _gsapReactPlugin = __webpack_require__(10);
	
	var _gsapReactPlugin2 = _interopRequireDefault(_gsapReactPlugin);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } //eslint-disable-line import/no-named-as-default
	
	
	var SingleAnswerFeedbackReview = function (_React$Component) {
	    _inherits(SingleAnswerFeedbackReview, _React$Component);
	
	    function SingleAnswerFeedbackReview(props, context) {
	        _classCallCheck(this, SingleAnswerFeedbackReview);
	
	        var _this = _possibleConstructorReturn(this, (SingleAnswerFeedbackReview.__proto__ || Object.getPrototypeOf(SingleAnswerFeedbackReview)).call(this, props, context));
	
	        _this.state = {
	            lang: _this.props.lang,
	            option: _this.props.option,
	            locale: appHelper.getLocalData(_this.props.option),
	            showFeedbackContent: false,
	            showKpis: appHelper.isDefined(_this.props.option.kpis) && _this.props.option.kpis !== null,
	            kpiDashboardParams: {
	                responseReview: true,
	                showTitle: false,
	                showImmediateImpact: true,
	                allowUpdates: false
	            },
	            hasDialogs: appHelper.isDefined(_this.props.option.dialogs) && _this.props.option.dialogs.length > 0,
	            dialogComplete: !appHelper.isDefined(_this.props.option.dialogs) || _this.props.option.dialogs.length === 0,
	            callbacks: {},
	            resourceLinks: [],
	            hasResources: false,
	            resourcesAreComplete: true
	        };
	
	        _this.show = _this.show.bind(_this);
	        _this.onFeedbackRevealed = _this.onFeedbackRevealed.bind(_this);
	        _this.showFeedbackContent = _this.showFeedbackContent.bind(_this);
	        _this.showKpiDashboard = _this.showKpiDashboard.bind(_this);
	        _this.dialogsOnComplete = _this.dialogsOnComplete.bind(_this);
	        _this.setCallbacks = _this.setCallbacks.bind(_this);
	        _this.onResourcesComplete = _this.onResourcesComplete.bind(_this);
	        _this.setResources = _this.setResources.bind(_this);
	        _this.getInheritedFeedback = _this.getInheritedFeedback.bind(_this);
	        return _this;
	    }
	
	    _createClass(SingleAnswerFeedbackReview, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            this.setCallbacks();
	            this.setResources();
	            this.show();
	        }
	    }, {
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(nextProps) {
	            if (this.state.lang !== nextProps.lang) {
	                this.setState({
	                    lang: nextProps.lang,
	                    locale: appHelper.getLocalData(this.state.option)
	                });
	            }
	        }
	    }, {
	        key: 'show',
	        value: function show() {
	
	            var feedbackPanel = this.refs[this.state.option.option_id + '_feedbackPanel'];
	            _gsap.TweenLite.set(feedbackPanel, { height: "auto", opacity: 1 });
	            _gsap.TweenLite.from(feedbackPanel, objectConstants.FEEDBACK_DURATION, {
	                height: 0,
	                opacity: 0,
	                ease: _gsap.Expo.easeInOut
	            }).eventCallback("onComplete", this.onFeedbackRevealed);
	        }
	    }, {
	        key: 'onFeedbackRevealed',
	        value: function onFeedbackRevealed() {
	            // this.setState({showResponse: true});
	            this.showFeedbackContent();
	        }
	    }, {
	        key: 'showFeedbackContent',
	        value: function showFeedbackContent() {
	            if (appHelper.isDefined(this.state.option.kpis) && this.state.option.kpis !== null) {
	                this.setState({ showFeedbackContent: true, showKpis: true });
	            } else {
	                this.setState({ showFeedbackContent: true });
	            }
	        }
	    }, {
	        key: 'showKpiDashboard',
	        value: function showKpiDashboard() {}
	    }, {
	        key: 'dialogsOnComplete',
	        value: function dialogsOnComplete() {
	            this.setState({ dialogComplete: true });
	        }
	    }, {
	        key: 'setCallbacks',
	        value: function setCallbacks() {}
	    }, {
	        key: 'setResources',
	        value: function setResources() {
	            var resourceLinks = appHelper.setResourceLinks(this.state.option);
	            var hasRequiredResources = appHelper.hasRequiredResources(resourceLinks);
	            this.setState({
	                resourceLinks: Object.assign([], resourceLinks),
	                hasResources: resourceLinks.length > 0,
	                resourcesAreComplete: resourceLinks.length === 0 || !hasRequiredResources
	            });
	        }
	    }, {
	        key: 'onResourcesComplete',
	        value: function onResourcesComplete() {
	            if (!this.state.resourcesAreComplete) {
	                this.setState({ resourcesAreComplete: true, checkComplete: true });
	            }
	        }
	    }, {
	        key: 'getInheritedFeedback',
	        value: function getInheritedFeedback(feedback_id) {
	            var option = appHelper.getArrayObjectByKey(this.props.options, "option_id", feedback_id);
	            var optionLocale = appHelper.getLocalData(option);
	            return optionLocale.feedback;
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            return _react2.default.createElement(
	                'div',
	                { className: 'clear-both' },
	                this.state.hasDialogs ? _react2.default.createElement(_ChildConversationDialog2.default, { asset_id: this.props.asset_id, option_id: this.state.option.option_id,
	                    dialogs: this.state.option.dialogs, callbacks: this.state.callbacks,
	                    onComplete: this.dialogsOnComplete }) : null,
	                this.state.hasDialogs ? _react2.default.createElement('br', null) : null,
	                _react2.default.createElement(
	                    'div',
	                    { className: 'feedback-panel ' + this.state.option.result + ' review object-container',
	                        ref: this.state.option.option_id + '_feedbackPanel' },
	                    _react2.default.createElement('img', { src: __webpack_require__(133)("./" + this.state.option.result + '.svg'), style: kpiConstants.WATERMARK_STYLES, alt: '' }),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'feedback-content-col' },
	                        this.state.showKpis && this.state.dialogComplete ? _react2.default.createElement(_KpiDashboard2.default, { displayState: kpiConstants.KPI_DISPLAY_STATE_REVIEW_POINTS_AWARDED,
	                            bite_id: this.props.responseData.bite_id,
	                            screen_id: this.props.responseData.screen_id,
	                            asset_id: parseInt(this.props.responseData.asset_id),
	                            option: this.props.option,
	                            responseReview: this.state.kpiDashboardParams.responseReview,
	                            showImmediateImpact: this.state.kpiDashboardParams.showImmediateImpact,
	                            showTitle: this.state.kpiDashboardParams.showTitle }) : null,
	                        appHelper.isDefined(this.state.locale.feedback) && this.state.dialogComplete && this.state.locale.feedback.length > 0 ? _react2.default.createElement('div', { dangerouslySetInnerHTML: { __html: this.state.locale.feedback } }) : appHelper.isDefined(this.state.option.feedback_id) ? _react2.default.createElement('div', {
	                            dangerouslySetInnerHTML: { __html: this.getInheritedFeedback(this.state.option.feedback_id) } }) : null,
	                        this.state.hasResources ? _react2.default.createElement(_ResourceLinks2.default, { resources: this.state.resourceLinks,
	                            onResourcesComplete: this.onResourcesComplete }) : null
	                    )
	                )
	            );
	        }
	    }]);
	
	    return SingleAnswerFeedbackReview;
	}(_react2.default.Component);
	
	SingleAnswerFeedbackReview.propTypes = {
	    option: _propTypes2.default.object.isRequired,
	    options: _propTypes2.default.array.isRequired,
	    responseData: _propTypes2.default.object.isRequired,
	    asset_id: _propTypes2.default.number.isRequired,
	    callbacks: _propTypes2.default.object,
	    onComplete: _propTypes2.default.func,
	    lang: _propTypes2.default.string.isRequired,
	    actions: _propTypes2.default.object
	};
	
	SingleAnswerFeedbackReview.contextTypes = {
	    router: _propTypes2.default.object
	};
	
	function mapStateToProps(state, ownProps) {
	    var lang = state.userData.lang;
	    return {
	        lang: lang
	    };
	}
	
	function mapDispatchToProps(dispatch) {
	    return {
	        actions: (0, _redux.bindActionCreators)(Object.assign({}, trackingDataActions, userDataActions), dispatch)
	    };
	}
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(SingleAnswerFeedbackReview);

/***/ },
/* 507 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(5);
	
	var _redux = __webpack_require__(4);
	
	var _appDataActions = __webpack_require__(12);
	
	var appDataActions = _interopRequireWildcard(_appDataActions);
	
	var _trackingDataActions = __webpack_require__(7);
	
	var trackingDataActions = _interopRequireWildcard(_trackingDataActions);
	
	var _dialogPopupActions = __webpack_require__(19);
	
	var dialogPopupActions = _interopRequireWildcard(_dialogPopupActions);
	
	var _appHelper = __webpack_require__(3);
	
	var appHelper = _interopRequireWildcard(_appHelper);
	
	var _dataHelper = __webpack_require__(11);
	
	var dataHelper = _interopRequireWildcard(_dataHelper);
	
	var _userDataHelper = __webpack_require__(15);
	
	var userDataHelper = _interopRequireWildcard(_userDataHelper);
	
	var _objectConstants = __webpack_require__(9);
	
	var objectConstants = _interopRequireWildcard(_objectConstants);
	
	var _keyboardConstants = __webpack_require__(14);
	
	var keyboardConstants = _interopRequireWildcard(_keyboardConstants);
	
	var _gsap = __webpack_require__(8);
	
	var _gsapReactPlugin = __webpack_require__(10);
	
	var _gsapReactPlugin2 = _interopRequireDefault(_gsapReactPlugin);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	//import {SINGLE_ANSWER_REVIEW_CONFIG} from '../../../../models/dialogModels';
	
	
	var SingleAnswerOption = function (_React$Component) {
	    _inherits(SingleAnswerOption, _React$Component);
	
	    function SingleAnswerOption(props, context) {
	        _classCallCheck(this, SingleAnswerOption);
	
	        var _this = _possibleConstructorReturn(this, (SingleAnswerOption.__proto__ || Object.getPrototypeOf(SingleAnswerOption)).call(this, props, context));
	
	        _this.state = {
	            lang: _this.props.lang,
	            option: _this.props.option,
	            locale: appHelper.getLocalData(_this.props.option),
	            responseData: _this.props.responseData,
	            focusedOption: _this.props.focusedOption,
	            focusedClass: "not-focused"
	        };
	
	        _this.hideOption = _this.hideOption.bind(_this);
	        _this.showOption = _this.showOption.bind(_this);
	        _this.removeOption = _this.removeOption.bind(_this);
	        _this.setOptionAsSelected = _this.setOptionAsSelected.bind(_this);
	        _this.onOptionHidden = _this.onOptionHidden.bind(_this);
	        _this.getDisabledState = _this.getDisabledState.bind(_this);
	        _this.getOptionClass = _this.getOptionClass.bind(_this);
	        _this.getClickFunction = _this.getClickFunction.bind(_this);
	        _this.handleOptionVisibility = _this.handleOptionVisibility.bind(_this);
	        _this.onOptionRevealed = _this.onOptionRevealed.bind(_this);
	        _this.renderOption = _this.renderOption.bind(_this);
	        _this.getCheckedState = _this.getCheckedState.bind(_this);
	        _this.getIsChecked = _this.getIsChecked.bind(_this);
	        _this.getIsDisabled = _this.getIsDisabled.bind(_this);
	        _this.setFocus = _this.setFocus.bind(_this);
	        _this.setBlur = _this.setBlur.bind(_this);
	        _this.getScreenReaderOptionClass = _this.getScreenReaderOptionClass.bind(_this);
	
	        return _this;
	    }
	
	    _createClass(SingleAnswerOption, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            this.showOption(1, 0);
	        }
	    }, {
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(nextProps) {
	            if (this.state.responseData !== nextProps.responseData) {
	                this.setState({ responseData: nextProps.responseData });
	            }
	            if (this.state.focusedOption !== nextProps.focusedOption) {
	                this.setState({ focusedOption: Object.assign({}, nextProps.focusedOption) });
	            }
	
	            if (this.state.lang !== nextProps.lang) {
	                this.setState({
	                    lang: nextProps.lang,
	                    locale: appHelper.getLocalData(this.state.option)
	                });
	            }
	        }
	    }, {
	        key: 'componentDidUpdate',
	        value: function componentDidUpdate() {}
	    }, {
	        key: 'getOptionClass',
	        value: function getOptionClass() {
	            var responseData = this.state.responseData;
	            var latestResponse = appHelper.getLastItemOfArray(responseData.responses);
	            if (this.props.questionChecked) {
	                if (responseData.displayState !== objectConstants.OBJECT_DISPLAY_STATE_REVIEW) {
	                    if (responseData.currentAttempt === responseData.responses.length && latestResponse.selectedOption.option_id == this.state.option.option_id) {
	
	                        if (responseData.displayState !== objectConstants.OBJECT_DISPLAY_STATE_ANSWERED) {
	                            return 'active ' + this.state.option.result;
	                        } else if (responseData.displayState === objectConstants.OBJECT_DISPLAY_STATE_ANSWERED && this.props.showFeedback) {
	                            return 'selected ' + this.state.option.result;
	                        } else if (responseData.displayState === objectConstants.OBJECT_DISPLAY_STATE_ANSWERED && !this.props.showFeedback) {
	                            return 'selected ' + this.state.option.result;
	                        }
	                    } else {
	                        for (var i = 0; i < this.state.responseData.responses.length; i++) {
	                            var response = this.state.responseData.responses[i];
	                            if (response.selectedOption.option_id === this.state.option.option_id) {
	                                return 'show-answer ' + this.state.option.result;
	                            }
	                        }
	                    }
	                } else if (responseData.displayState === objectConstants.OBJECT_DISPLAY_STATE_REVIEW) {
	                    if (responseData.currentAttempt === responseData.responses.length && latestResponse.selectedOption.option_id == this.state.option.option_id && this.props.showFeedback) {
	                        return 'selected answered ' + this.state.option.result;
	                    } else if (responseData.currentAttempt === responseData.responses.length && latestResponse.selectedOption.option_id == this.state.option.option_id && !this.props.showFeedback) {
	                        return 'selected inactive-answered ' + this.state.option.result;
	                    } else {
	                        return 'review ' + this.state.option.result;
	                    }
	                }
	            }
	            return "";
	        }
	    }, {
	        key: 'getScreenReaderOptionClass',
	        value: function getScreenReaderOptionClass() {
	            var responseData = this.state.responseData;
	            var latestResponse = appHelper.getLastItemOfArray(responseData.responses);
	            if (this.props.questionChecked) {
	                if (responseData.displayState !== objectConstants.OBJECT_DISPLAY_STATE_REVIEW) {
	                    if (responseData.currentAttempt === responseData.responses.length && latestResponse.selectedOption.option_id == this.state.option.option_id) {
	
	                        if (responseData.displayState !== objectConstants.OBJECT_DISPLAY_STATE_ANSWERED) {
	                            return "";
	                        } else if (responseData.displayState === objectConstants.OBJECT_DISPLAY_STATE_ANSWERED && this.props.showFeedback) {
	                            return appHelper.getOptionResultString(this.state.option.result, false);
	                        } else if (responseData.displayState === objectConstants.OBJECT_DISPLAY_STATE_ANSWERED && !this.props.showFeedback) {
	                            return appHelper.getOptionResultString(this.state.option.result, false);
	                        }
	                    } else {
	                        for (var i = 0; i < this.state.responseData.responses.length; i++) {
	                            var response = this.state.responseData.responses[i];
	                            if (response.selectedOption.option_id === this.state.option.option_id) {
	                                return appHelper.getOptionResultString(this.state.option.result, true);
	                            }
	                        }
	                    }
	                } else if (responseData.displayState === objectConstants.OBJECT_DISPLAY_STATE_REVIEW) {
	                    if (responseData.currentAttempt === responseData.responses.length && latestResponse.selectedOption.option_id === this.state.option.option_id && this.props.showFeedback) {
	                        return appHelper.getOptionResultString(this.state.option.result, false);
	                    } else if (responseData.currentAttempt === responseData.responses.length && latestResponse.selectedOption.option_id === this.state.option.option_id && !this.props.showFeedback) {
	                        return appHelper.getOptionResultString(this.state.option.result, false);
	                    } else {
	                        return appHelper.getOptionResultString(this.state.option.result, false);
	                    }
	                }
	            }
	            return "";
	        }
	    }, {
	        key: 'renderOption',
	        value: function renderOption() {
	            var responseData = this.state.responseData;
	            var latestResponse = appHelper.getLastItemOfArray(responseData.responses);
	            if (this.props.questionChecked && this.props.currentlyChecked) {
	                if (latestResponse.selectedOption.option_id === this.state.option.option_id) {
	                    return true;
	                } else {
	                    return false;
	                }
	            } else {
	                return true;
	            }
	        }
	    }, {
	        key: 'getClickFunction',
	        value: function getClickFunction() {
	            var responseData = this.state.responseData;
	            var latestResponse = appHelper.getLastItemOfArray(responseData.responses);
	            if (responseData.currentAttempt === responseData.responses.length && latestResponse.selectedOption.option_id == this.state.option.option_id && this.props.showFeedback) {
	                if (responseData.displayState == objectConstants.OBJECT_DISPLAY_STATE_REVIEW) {
	                    this.props.onReviewObject('option_' + this.state.option.option_id);
	                }
	            }
	        }
	    }, {
	        key: 'getDisabledState',
	        value: function getDisabledState() {
	            var responseData = this.state.responseData;
	            //if (responseData.displayState === objectConstants.OBJECT_DISPLAY_STATE_INITIAL) {
	            if (responseData.currentAttempt === responseData.responses.length && this.props.questionChecked) {
	                return 'disabled';
	            } else {
	                for (var i = 0; i < this.state.responseData.responses.length; i++) {
	                    var response = this.state.responseData.responses[i];
	                    if (response.selectedOption.option_id === this.state.option.option_id && this.props.questionChecked) {
	                        return 'disabled';
	                    }
	                }
	                return null;
	            }
	        }
	    }, {
	        key: 'handleOptionVisibility',
	        value: function handleOptionVisibility() {
	            var responseData = this.state.responseData;
	            var latestResponse = appHelper.getLastItemOfArray(responseData.responses);
	            //if user responsed have been logged
	            if (typeof latestResponse !== 'undefined' && responseData.displayState !== objectConstants.OBJECT_DISPLAY_STATE_REVIEW) {
	
	                // if currentAttempt has been answered and the current option id does not equal the selected option if then hide it
	                if (responseData.currentAttempt === responseData.responses.length && latestResponse.selectedOption.option_id !== this.state.option.option_id && this.props.questionChecked) {
	                    this.hideOption();
	                    // if currentAttempt has been answered and the current option id does equal the selected option if then show it but and the corners
	                } else if (responseData.currentAttempt === responseData.responses.length && latestResponse.selectedOption.option_id === this.state.option.option_id && this.props.questionChecked) {
	                    this.roundCorners();
	                    // if currentAttempt has not been answered then render all options with no animation
	                } else if (responseData.currentAttempt > responseData.responses.length && latestResponse.selectedOption.option_id !== this.state.option.option_id && !appHelper.isDefined(responseData.latestResponse.option_id)) {
	                    this.showOption(1, 0);
	                }
	                //if in review then reveal all options
	            } else if (responseData.displayState === objectConstants.OBJECT_DISPLAY_STATE_REVIEW) {
	                this.showOption(0, 0);
	            } else if (!appHelper.isDefined(responseData.latestResponse.option_id)) {
	                //if no user response has been logged yet then animate the
	                this.showOption(1, this.props.index / 2);
	            }
	        }
	    }, {
	        key: 'hideOption',
	        value: function hideOption() {
	            var optionRef = this.refs[this.state.option.option_id];
	            _gsap.TweenLite.to(optionRef, objectConstants.MC_OPTION_DURATION, {
	                opacity: 0,
	                delay: 0.5,
	                ease: _gsap.Expo.easeOut
	            }).eventCallback("onComplete", this.scaleOptionHeight);
	        }
	    }, {
	        key: 'showOption',
	        value: function showOption(duration, delay) {
	            var optionRef = this.refs[this.state.option.option_id];
	            _gsap.TweenLite.set(optionRef, { height: "auto", opacity: 1 });
	            _gsap.TweenLite.from(optionRef, objectConstants.MC_OPTION_DURATION, {
	                height: 0,
	                opacity: 0,
	                delay: delay,
	                ease: _gsap.Expo.easeInOut
	            }).eventCallback("onComplete", this.onOptionRevealed);
	        }
	    }, {
	        key: 'onOptionRevealed',
	        value: function onOptionRevealed() {
	            this.props.onOptionRevealed(this.props.option);
	        }
	    }, {
	        key: 'setOptionAsSelected',
	        value: function setOptionAsSelected() {
	            var optionRef = this.refs[this.state.option.option_id];
	            _gsap.TweenLite.to(optionRef, 0.5, {
	                css: { className: '+=selected' },
	                delay: 0.5
	            });
	        }
	    }, {
	        key: 'onOptionHidden',
	        value: function onOptionHidden() {
	            var responseData = this.state.responseData;
	            var latestResponse = appHelper.getLastItemOfArray(responseData.responses);
	
	            //if selected option is first in the list
	            if (latestResponse.index === 0) {
	                this.removeOption();
	            } else {
	                this.scaleOptionHeight();
	            }
	        }
	    }, {
	        key: 'removeOption',
	        value: function removeOption() {
	            //this.setState({render: false});
	        }
	    }, {
	        key: 'getCheckedState',
	        value: function getCheckedState() {
	            var responseData = this.state.responseData;
	            var latestResponse = responseData.latestResponse;
	            if (appHelper.isDefined(latestResponse.option_id) && latestResponse.option_id === this.state.option.option_id) {
	                //console.log(`getCheckedState`, latestResponse);
	                return 'checked';
	            }
	        }
	    }, {
	        key: 'getIsChecked',
	        value: function getIsChecked() {
	            var responseData = this.state.responseData;
	            var latestResponse = responseData.latestResponse;
	            //console.log(`getCheckedState`,latestResponse);
	            if (appHelper.isDefined(latestResponse.option_id) && latestResponse.option_id === this.state.option.option_id) {
	                //console.log(`getCheckedState`, latestResponse);
	                return true;
	            } else {
	                return false;
	            }
	        }
	    }, {
	        key: 'getIsDisabled',
	        value: function getIsDisabled() {
	            var responseData = this.state.responseData;
	            //if (responseData.displayState === objectConstants.OBJECT_DISPLAY_STATE_INITIAL) {
	            if (responseData.currentAttempt === responseData.responses.length || this.state.isAnimating) {
	                return true;
	            } else {
	                for (var i = 0; i < this.state.responseData.responses.length; i++) {
	                    var response = this.state.responseData.responses[i];
	                    if (response.selectedOption.option_id === this.state.option.option_id) {
	                        return true;
	                    }
	                }
	                return false;
	            }
	        }
	    }, {
	        key: 'setFocus',
	        value: function setFocus() {
	            this.setState({ focusedClass: "focused" });
	        }
	    }, {
	        key: 'setBlur',
	        value: function setBlur() {
	            this.setState({ focusedClass: "not-focused" });
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	
	            return this.renderOption() ? _react2.default.createElement(
	                'div',
	                { className: 'multiple-choice-option ' + this.getOptionClass() + ' ' + this.state.focusedClass,
	                    ref: this.state.option.option_id,
	                    id: 'option_' + this.state.option.option_id,
	                    onClick: this.getClickFunction,
	                    onKeyDown: this.props.optionCallbacks.setKeyboardAccessibility,
	                    onFocus: this.setFocus,
	                    onBlur: this.setBlur,
	                    role: 'radio',
	                    tabIndex: this.state.focusedOption.option_id === this.state.option.option_id || this.getIsChecked() ? 0 : -1,
	                    'aria-checked': this.getIsChecked(),
	                    'aria-disabled': this.getIsDisabled() },
	                _react2.default.createElement('input', { id: this.props.asset_id + '_' + this.state.option.option_id, type: 'radio',
	                    disabled: this.getDisabledState(),
	                    name: this.props.asset_id + '_' + this.state.option.option_id,
	                    checked: this.getCheckedState(),
	                    value: this.state.option.option_id, onChange: this.props.onOptionClick }),
	                _react2.default.createElement(
	                    'label',
	                    { htmlFor: this.props.asset_id + '_' + this.state.option.option_id },
	                    _react2.default.createElement('span', { dangerouslySetInnerHTML: { __html: this.state.locale.option } }),
	                    _react2.default.createElement(
	                        'span',
	                        { className: 'hidden-el' },
	                        this.getScreenReaderOptionClass()
	                    )
	                )
	            ) : null;
	        }
	    }]);
	
	    return SingleAnswerOption;
	}(_react2.default.Component);
	
	SingleAnswerOption.propTypes = {
	    option: _propTypes2.default.object.isRequired,
	    asset_id: _propTypes2.default.number.isRequired,
	    questionChecked: _propTypes2.default.bool.isRequired,
	    currentlyChecked: _propTypes2.default.bool.isRequired,
	    responseData: _propTypes2.default.object.isRequired,
	    index: _propTypes2.default.number.isRequired,
	    onOptionClick: _propTypes2.default.func,
	    onAttemptComplete: _propTypes2.default.func,
	    onReviewObject: _propTypes2.default.func,
	    onOptionRevealed: _propTypes2.default.func,
	    focusedOption: _propTypes2.default.object,
	    showFeedback: _propTypes2.default.bool,
	    contentData: _propTypes2.default.object,
	    trackingData: _propTypes2.default.object,
	    optionCallbacks: _propTypes2.default.object,
	    lang: _propTypes2.default.string.isRequired,
	    actions: _propTypes2.default.object
	};
	
	SingleAnswerOption.contextTypes = {
	    router: _propTypes2.default.object
	};
	
	function mapStateToProps(state) {
	    var lang = state.userData.lang;
	    return {
	        lang: lang,
	        contentData: state.contentData,
	        trackingData: state.trackingData
	    };
	}
	
	function mapDispatchToProps(dispatch) {
	    return {
	        actions: (0, _redux.bindActionCreators)(Object.assign({}, appDataActions, trackingDataActions, dialogPopupActions), dispatch)
	    };
	}
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(SingleAnswerOption);

/***/ },
/* 508 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(5);
	
	var _redux = __webpack_require__(4);
	
	var _SecondaryImage = __webpack_require__(66);
	
	var _SecondaryImage2 = _interopRequireDefault(_SecondaryImage);
	
	var _SecondaryLibraryImage = __webpack_require__(67);
	
	var _SecondaryLibraryImage2 = _interopRequireDefault(_SecondaryLibraryImage);
	
	var _SingleAnswerFeedbackReview = __webpack_require__(506);
	
	var _SingleAnswerFeedbackReview2 = _interopRequireDefault(_SingleAnswerFeedbackReview);
	
	var _trackingDataActions = __webpack_require__(7);
	
	var trackingDataActions = _interopRequireWildcard(_trackingDataActions);
	
	var _appHelper = __webpack_require__(3);
	
	var appHelper = _interopRequireWildcard(_appHelper);
	
	var _objectConstants = __webpack_require__(9);
	
	var objectConstants = _interopRequireWildcard(_objectConstants);
	
	var _assetConstants = __webpack_require__(33);
	
	var assetConstants = _interopRequireWildcard(_assetConstants);
	
	var _appConstants = __webpack_require__(13);
	
	var appConstants = _interopRequireWildcard(_appConstants);
	
	var _keyboardConstants = __webpack_require__(14);
	
	var keyboardConstants = _interopRequireWildcard(_keyboardConstants);
	
	var _gsap = __webpack_require__(8);
	
	var _gsapReactPlugin = __webpack_require__(10);
	
	var _gsapReactPlugin2 = _interopRequireDefault(_gsapReactPlugin);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } //eslint-disable-line import/no-named-as-default
	
	
	var SingleAnswerOptionReview = function (_React$Component) {
	    _inherits(SingleAnswerOptionReview, _React$Component);
	
	    function SingleAnswerOptionReview(props, context) {
	        _classCallCheck(this, SingleAnswerOptionReview);
	
	        var _this = _possibleConstructorReturn(this, (SingleAnswerOptionReview.__proto__ || Object.getPrototypeOf(SingleAnswerOptionReview)).call(this, props, context));
	
	        _this.state = {
	            lang: _this.props.lang,
	            option: _this.props.option,
	            locale: appHelper.getLocalData(_this.props.option),
	            responseData: _this.props.responseData,
	            optionAsset: {
	                src: ""
	            },
	            assetData: {}
	        };
	        _this.showOption = _this.showOption.bind(_this);
	        _this.onObjectSelected = _this.onObjectSelected.bind(_this);
	        _this.getDisabledState = _this.getDisabledState.bind(_this);
	        _this.getOptionClass = _this.getOptionClass.bind(_this);
	        _this.handleOptionVisibility = _this.handleOptionVisibility.bind(_this);
	        _this.getAssets = _this.getAssets.bind(_this);
	        _this.getAssetType = _this.getAssetType.bind(_this);
	        _this.getImagePath = _this.getImagePath.bind(_this);
	        _this.setKeyboardAccessibility = _this.setKeyboardAccessibility.bind(_this);
	        return _this;
	    }
	
	    _createClass(SingleAnswerOptionReview, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            this.getAssets();
	        }
	    }, {
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(nextProps) {
	            if (this.state.responseData !== nextProps.responseData) {
	                this.setState({ responseData: nextProps.responseData });
	            }
	
	            if (this.state.lang !== nextProps.lang) {
	                this.setState({
	                    lang: nextProps.lang,
	                    locale: appHelper.getLocalData(this.state.option)
	                });
	            }
	        }
	    }, {
	        key: 'componentDidUpdate',
	        value: function componentDidUpdate() {
	            this.handleOptionVisibility();
	        }
	    }, {
	        key: 'getAssets',
	        value: function getAssets() {
	            var screenAsset = {};
	            var assetData = {};
	
	            if (appHelper.isDefined(this.state.option.image)) {
	                screenAsset = this.getAssetType(this.state.option.image);
	                assetData = Object.assign({}, this.state.option.image);
	            }
	
	            this.setState({
	                screenAsset: Object.assign({}, screenAsset),
	                assetData: Object.assign({}, assetData)
	            });
	        }
	    }, {
	        key: 'getAssetType',
	        value: function getAssetType(asset) {
	            /*
	             screenCharacter = appHelper.getCharacterAsset(this.state.screen.assets.left);
	                //console.log(screenCharacter);
	                characterAsset = appHelper.getCharacterPose(screenCharacter, this.state.screen.assets.left);
	            * */
	            var returnAsset = {};
	            if (asset.constant === assetConstants.ASSET_TYPE_ICON) {
	                returnAsset = appHelper.getIconAsset(asset);
	            } else if (asset.constant === assetConstants.ASSET_TYPE_IMAGE) {
	                returnAsset = appHelper.getImageAsset(asset);
	            } else if (asset.constant === assetConstants.ASSET_TYPE_LIBRARY_IMAGE) {
	                returnAsset = appHelper.getLibraryImageAsset(asset);
	            } else if (asset.constant === assetConstants.ASSET_TYPE_ID_CHARACTER) {
	                var characterAsset = appHelper.getCharacterAsset(asset);
	                returnAsset = appHelper.getCharacterPose(characterAsset, asset);
	            }
	            returnAsset = appHelper.isDefined(returnAsset.locale) ? appHelper.getLocalData(returnAsset) : returnAsset;
	
	            if (appHelper.isDefined(asset.constant) && !appHelper.isDefined(returnAsset.type)) {
	                returnAsset = Object.assign({}, returnAsset, {
	                    type: asset.constant
	                });
	            }
	
	            return returnAsset;
	        }
	    }, {
	        key: 'getImagePath',
	        value: function getImagePath(image) {
	            if (appConstants.DEVELOPMENT_MODE) {
	                if (appHelper.isDefined(image) && image.length > 0) {
	                    return __webpack_require__(16)("./" + image);
	                }
	            } else {
	                return image;
	            }
	        }
	    }, {
	        key: 'getOptionClass',
	        value: function getOptionClass() {
	            var responseData = this.state.responseData;
	            var latestResponse = appHelper.getLastItemOfArray(responseData.responses);
	            var activeClass = "";
	            if (this.props.optionReviewId === this.state.option.option_id) {
	                activeClass = "review-current";
	            }
	            if (responseData.currentAttempt === responseData.responses.length && latestResponse.selectedOption.option_id === this.state.option.option_id) {
	                return 'review-selected ' + this.state.option.result + ' ' + activeClass;
	            } else {
	                return 'review ' + this.state.option.result + ' ' + activeClass;
	            }
	        }
	    }, {
	        key: 'getDisabledState',
	        value: function getDisabledState() {
	            return 'disabled';
	        }
	    }, {
	        key: 'handleOptionVisibility',
	        value: function handleOptionVisibility() {
	            this.showOption(0, 0);
	        }
	    }, {
	        key: 'showOption',
	        value: function showOption(duration, delay) {
	            var optionRef = this.refs[this.state.option.option_id];
	            _gsap.TweenLite.set(optionRef, { height: "auto", opacity: 1 });
	            _gsap.TweenLite.from(optionRef, duration, {
	                height: 0,
	                opacity: 0,
	                delay: delay,
	                ease: _gsap.Expo.easeInOut
	            });
	        }
	    }, {
	        key: 'onObjectSelected',
	        value: function onObjectSelected() {
	            this.props.onOptionClick(this.state.option);
	        }
	    }, {
	        key: 'setKeyboardAccessibility',
	        value: function setKeyboardAccessibility(event) {
	            if (event.which === keyboardConstants.ENTER_KEY || event.which === keyboardConstants.SPACEBAR_KEY) {
	                event.preventDefault();
	                this.onObjectSelected();
	            }
	
	            if (event.which === keyboardConstants.ARROW_UP_KEY) {
	                event.preventDefault();
	                var optionIndex = appHelper.getArrayObjectIndexByKey(this.props.options, "option_id", this.state.option.option_id);
	                var nextIndex = optionIndex - 1;
	
	                if (optionIndex === 0) {
	                    nextIndex = this.props.options.length - 1;
	                }
	                //console.log(nextIndex);
	                var nextItem = Object.assign({}, this.props.options[nextIndex]);
	                var focusItem = document.getElementById('review_option_' + nextItem.option_id);
	                focusItem.focus();
	            }
	
	            if (event.which === keyboardConstants.ARROW_DOWN_KEY) {
	                event.preventDefault();
	                var _optionIndex = appHelper.getArrayObjectIndexByKey(this.props.options, "option_id", this.state.option.option_id);
	                var _nextIndex = _optionIndex + 1;
	                if (_optionIndex === this.props.options.length - 1) {
	                    _nextIndex = 0;
	                }
	
	                var _nextItem = Object.assign({}, this.props.options[_nextIndex]);
	                var _focusItem = document.getElementById('review_option_' + _nextItem.option_id);
	                _focusItem.focus();
	            }
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	
	            return _react2.default.createElement(
	                'div',
	                { className: 'multiple-choice-option ' + this.state.option.choice_type + ' ' + this.getOptionClass(),
	                    ref: this.state.option.option_id,
	                    id: 'review_option_' + this.state.option.option_id,
	                    onClick: this.onObjectSelected,
	                    onKeyDown: this.setKeyboardAccessibility,
	                    tabIndex: 0,
	                    role: 'button',
	                    'aria-controls': 'review_feedback_wrapper_' + this.state.option.option_id,
	                    'aria-expanded': this.props.optionReviewId === this.state.option.option_id },
	                _react2.default.createElement('input', { id: this.props.asset_id + '_' + this.state.option.option_id + '_review', type: 'radio',
	                    name: this.props.asset_id + '_' + this.state.option.option_id + '_review',
	                    tabIndex: '-1',
	                    'aria-hidden': 'true', 'aria-disabled': 'true',
	                    value: this.state.option.option_id, onChange: this.onObjectSelected }),
	                _react2.default.createElement(
	                    'label',
	                    { htmlFor: this.props.asset_id + '_' + this.state.option.option_id + '_review' },
	                    _react2.default.createElement('div', { className: 'label-text', dangerouslySetInnerHTML: { __html: this.state.locale.option } }),
	                    _react2.default.createElement(
	                        'span',
	                        { className: 'hidden-el' },
	                        appHelper.getOptionResultString(this.state.option.result, false)
	                    ),
	                    appHelper.isDefined(this.state.assetData.constant) ? _react2.default.createElement(
	                        'div',
	                        { className: 'image-container' },
	                        this.state.assetData.constant === assetConstants.ASSET_TYPE_IMAGE || this.state.assetData.constant === assetConstants.ASSET_TYPE_LIBRARY_IMAGE ? this.state.assetData.constant === assetConstants.ASSET_TYPE_IMAGE ? _react2.default.createElement(_SecondaryImage2.default, { screenObject: this.state.assetData }) : _react2.default.createElement(_SecondaryLibraryImage2.default, { screenObject: this.state.assetData }) : _react2.default.createElement('img', { src: this.getImagePath(this.state.screenAsset.src), alt: '' })
	                    ) : null
	                ),
	                this.props.optionReviewId === this.state.option.option_id ? _react2.default.createElement(
	                    'div',
	                    { role: 'region', id: 'review_feedback_wrapper_' + this.state.option.option_id,
	                        'aria-labelledby': 'review_option_' + this.state.option.option_id },
	                    _react2.default.createElement(_SingleAnswerFeedbackReview2.default, { option: this.state.option,
	                        options: this.props.options,
	                        asset_id: this.props.asset_id,
	                        responseData: this.state.responseData })
	                ) : null
	            );
	        }
	    }]);
	
	    return SingleAnswerOptionReview;
	}(_react2.default.Component);
	
	SingleAnswerOptionReview.propTypes = {
	    option: _propTypes2.default.object.isRequired,
	    options: _propTypes2.default.array.isRequired,
	    asset_id: _propTypes2.default.number.isRequired,
	    responseData: _propTypes2.default.object.isRequired,
	    optionReviewId: _propTypes2.default.number,
	    onOptionClick: _propTypes2.default.func,
	    contentData: _propTypes2.default.object,
	    trackingData: _propTypes2.default.object,
	    lang: _propTypes2.default.string.isRequired,
	    actions: _propTypes2.default.object
	};
	
	SingleAnswerOptionReview.contextTypes = {
	    router: _propTypes2.default.object
	};
	
	function mapStateToProps(state, ownProps) {
	    var lang = state.userData.lang;
	    return {
	        lang: lang,
	        contentData: state.contentData,
	        trackingData: state.trackingData
	    };
	}
	
	function mapDispatchToProps(dispatch) {
	    return {
	        actions: (0, _redux.bindActionCreators)(Object.assign({}, trackingDataActions), dispatch)
	    };
	}
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(SingleAnswerOptionReview);

/***/ },
/* 509 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(5);
	
	var _redux = __webpack_require__(4);
	
	var _Prompt = __webpack_require__(83);
	
	var _Prompt2 = _interopRequireDefault(_Prompt);
	
	var _DialogPrompt = __webpack_require__(94);
	
	var _DialogPrompt2 = _interopRequireDefault(_DialogPrompt);
	
	var _BadgeCollect = __webpack_require__(47);
	
	var _BadgeCollect2 = _interopRequireDefault(_BadgeCollect);
	
	var _SingleAnswerOptionReview = __webpack_require__(508);
	
	var _SingleAnswerOptionReview2 = _interopRequireDefault(_SingleAnswerOptionReview);
	
	var _userDataHelper = __webpack_require__(15);
	
	var userDataHelper = _interopRequireWildcard(_userDataHelper);
	
	var _localStorage = __webpack_require__(17);
	
	var localStorage = _interopRequireWildcard(_localStorage);
	
	var _appDataActions = __webpack_require__(12);
	
	var appDataActions = _interopRequireWildcard(_appDataActions);
	
	var _trackingDataActions = __webpack_require__(7);
	
	var trackingDataActions = _interopRequireWildcard(_trackingDataActions);
	
	var _dialogPopupActions = __webpack_require__(19);
	
	var dialogPopupActions = _interopRequireWildcard(_dialogPopupActions);
	
	var _appHelper = __webpack_require__(3);
	
	var appHelper = _interopRequireWildcard(_appHelper);
	
	var _dataHelper = __webpack_require__(11);
	
	var dataHelper = _interopRequireWildcard(_dataHelper);
	
	var _objectConstants = __webpack_require__(9);
	
	var objectConstants = _interopRequireWildcard(_objectConstants);
	
	var _gsap = __webpack_require__(8);
	
	var _gsapReactPlugin = __webpack_require__(10);
	
	var _gsapReactPlugin2 = _interopRequireDefault(_gsapReactPlugin);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } //eslint-disable-line import/no-named-as-default
	
	
	var SingleAnswerReview = function (_React$Component) {
	    _inherits(SingleAnswerReview, _React$Component);
	
	    function SingleAnswerReview(props, context) {
	        _classCallCheck(this, SingleAnswerReview);
	
	        var _this = _possibleConstructorReturn(this, (SingleAnswerReview.__proto__ || Object.getPrototypeOf(SingleAnswerReview)).call(this, props, context));
	
	        _this.state = {
	            lang: _this.props.lang,
	            screenObject: _this.props.screenObject,
	            locale: appHelper.getLocalData(_this.props.screenObject),
	            userData: _this.props.userData,
	            objectStates: objectConstants.OBJECT_DISPLAY_STATES,
	            responseData: _this.props.responseData,
	            feedbackData: _this.props.responseData.latestResponse,
	            showOptions: true,
	            showFeedback: true,
	            selectedOption: "",
	            //badges
	            badgesEarned: [],
	            checkBadgesEarned: false,
	            collected: true,
	            character_name: appHelper.isDefined(_this.props.callbacks) ? _this.props.callbacks.getCharacterName() : appHelper.getScreenCharacterNameByAssetId(_this.props.screenObject.asset_id)
	        };
	        _this.onOptionClick = _this.onOptionClick.bind(_this);
	        _this.renderFeedback = _this.renderFeedback.bind(_this);
	        _this.renderOptions = _this.renderOptions.bind(_this);
	        //badges
	        _this.checkBadgeEarnedOnObject = _this.checkBadgeEarnedOnObject.bind(_this);
	        _this.getBadge = _this.getBadge.bind(_this);
	        return _this;
	    }
	
	    _createClass(SingleAnswerReview, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            this.checkBadgeEarnedOnObject();
	        }
	    }, {
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(nextProps) {
	            if (this.state.userData !== nextProps.userData) {
	                this.setState({
	                    userData: Object.assign({}, nextProps.userData),
	                    checkBadgesEarned: true
	                });
	            }
	            if (this.state.lang !== nextProps.lang) {
	                this.setState({
	                    lang: nextProps.lang,
	                    locale: appHelper.getLocalData(this.state.screenObject)
	                });
	            }
	        }
	    }, {
	        key: 'componentDidUpdate',
	        value: function componentDidUpdate() {
	            if (!this.state.showFeedback) {
	                this.renderFeedback();
	            }
	            if (this.checkBadgesEarned) {
	                this.checkBadgeEarnedOnObject();
	            }
	        }
	    }, {
	        key: 'checkBadgeEarnedOnObject',
	        value: function checkBadgeEarnedOnObject() {
	            var params = {
	                bite_id: this.state.responseData.bite_id,
	                asset_id: this.state.screenObject.asset_id
	            };
	
	            var badgesEarned = userDataHelper.checkBadgeEarnedOnObject(this.state.userData, params);
	            this.setState({
	                checkBadgesEarned: false,
	                badgesEarned: Object.assign([], badgesEarned)
	            });
	        }
	    }, {
	        key: 'getBadge',
	        value: function getBadge(badge_id) {
	            //return appHelper.getArrayObjectByKey(localStorage.achievements, "code", code);
	        }
	    }, {
	        key: 'renderFeedback',
	        value: function renderFeedback() {
	            this.setState({ showFeedback: true });
	        }
	    }, {
	        key: 'onOptionClick',
	        value: function onOptionClick(option) {
	            this.setState({
	                feedbackData: Object.assign({}, option),
	                showFeedback: false
	            });
	        }
	    }, {
	        key: 'renderOptions',
	        value: function renderOptions() {}
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this2 = this;
	
	            return _react2.default.createElement(
	                'div',
	                { className: 'learner-action' },
	                this.state.badgesEarned.length > 0 ? _react2.default.createElement(
	                    'div',
	                    null,
	                    this.state.badgesEarned.map(function (badge) {
	                        return _react2.default.createElement(_BadgeCollect2.default, { key: badge.badge_id, badge_id: badge.badge_id, bite_id: _this2.state.responseData.bite_id, asset_id: _this2.state.responseData.asset_id, collected: _this2.state.collected });
	                    }),
	                    ' ',
	                    _react2.default.createElement('br', null)
	                ) : null,
	                this.state.screenObject.prompt_type === objectConstants.PROMPT_TYPE_DIALOG_PROMPT ? _react2.default.createElement(
	                    'div',
	                    { className: 'object-container' },
	                    _react2.default.createElement(_DialogPrompt2.default, { character_name: this.state.character_name, id: this.state.screenObject.asset_id,
	                        locale: this.state.locale, show_title: this.state.screenObject.show_title,
	                        onComplete: this.renderOptions })
	                ) : _react2.default.createElement(
	                    'div',
	                    { className: 'horz-padding' },
	                    _react2.default.createElement(_Prompt2.default, { id: this.state.screenObject.asset_id, locale: this.state.locale,
	                        show_title: this.state.screenObject.show_title, onComplete: this.renderOptions })
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'multiple-choice-option-list' },
	                    this.state.screenObject.options.map(function (option) {
	                        return _react2.default.createElement(_SingleAnswerOptionReview2.default, { key: option.option_id, option: option,
	                            options: _this2.state.screenObject.options,
	                            asset_id: _this2.state.screenObject.asset_id,
	                            responseData: _this2.state.responseData,
	                            onOptionClick: _this2.onOptionClick,
	                            optionReviewId: _this2.state.feedbackData.option_id
	
	                        });
	                    })
	                )
	            );
	        }
	    }]);
	
	    return SingleAnswerReview;
	}(_react2.default.Component);
	
	SingleAnswerReview.propTypes = {
	    screenObject: _propTypes2.default.object.isRequired,
	    responseData: _propTypes2.default.object.isRequired,
	    userData: _propTypes2.default.object.isRequired,
	    lang: _propTypes2.default.string.isRequired,
	    callbacks: _propTypes2.default.object
	};
	
	SingleAnswerReview.contextTypes = {
	    router: _propTypes2.default.object
	};
	
	function mapStateToProps(state, ownProps) {
	    var lang = state.userData.lang;
	    return {
	        lang: lang,
	        userData: state.userData
	
	    };
	}
	
	function mapDispatchToProps(dispatch) {
	    return {
	        actions: (0, _redux.bindActionCreators)(Object.assign({}, appDataActions, trackingDataActions, dialogPopupActions), dispatch)
	    };
	}
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(SingleAnswerReview);

/***/ },
/* 510 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(5);
	
	var _redux = __webpack_require__(4);
	
	var _userDataActions = __webpack_require__(20);
	
	var userDataActions = _interopRequireWildcard(_userDataActions);
	
	var _appConstants = __webpack_require__(13);
	
	var appConstants = _interopRequireWildcard(_appConstants);
	
	var _appHelper = __webpack_require__(3);
	
	var appHelper = _interopRequireWildcard(_appHelper);
	
	var _userDataHelper = __webpack_require__(15);
	
	var userDataHelper = _interopRequireWildcard(_userDataHelper);
	
	var _objectConstants = __webpack_require__(9);
	
	var objectConstants = _interopRequireWildcard(_objectConstants);
	
	var _gsap = __webpack_require__(8);
	
	var _gsapReactPlugin = __webpack_require__(10);
	
	var _gsapReactPlugin2 = _interopRequireDefault(_gsapReactPlugin);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ResourceDocumentLink = function (_React$Component) {
	    _inherits(ResourceDocumentLink, _React$Component);
	
	    function ResourceDocumentLink(props, context) {
	        _classCallCheck(this, ResourceDocumentLink);
	
	        var _this = _possibleConstructorReturn(this, (ResourceDocumentLink.__proto__ || Object.getPrototypeOf(ResourceDocumentLink)).call(this, props, context));
	
	        _this.state = {
	            lang: _this.props.lang,
	            resource: _this.props.resource,
	            userData: _this.props.userData,
	            locale: appHelper.getLocalData(_this.props.resource),
	            document: {},
	            required_label: appHelper.getLocaleString("required_label")
	        };
	        _this.onOpen = _this.onOpen.bind(_this);
	        _this.getStatusClass = _this.getStatusClass.bind(_this);
	        _this.getAssets = _this.getAssets.bind(_this);
	        _this.getFilePath = _this.getFilePath.bind(_this);
	        _this.updateResourceObjectResult = _this.updateResourceObjectResult.bind(_this);
	        return _this;
	    }
	
	    _createClass(ResourceDocumentLink, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            this.getAssets();
	        }
	    }, {
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(nextProps) {
	            if (this.state.userData !== nextProps.userData) {
	                this.setState({ userData: Object.assign({}, nextProps.userData) });
	            }
	
	            if (this.state.lang !== nextProps.lang) {
	                var document = appHelper.getDocumentAsset(this.state.resource);
	                this.setState({
	                    lang: nextProps.lang,
	                    locale: appHelper.getLocalData(this.state.resource),
	                    document: appHelper.isDefined(document.locale) ? appHelper.getLocalData(document) : document,
	                    required_label: appHelper.getLocaleString("required_label")
	                });
	            }
	        }
	    }, {
	        key: 'componentDidUpdate',
	        value: function componentDidUpdate() {}
	    }, {
	        key: 'getAssets',
	        value: function getAssets() {
	            var document = appHelper.getDocumentAsset(this.state.resource);
	            this.setState({ document: appHelper.isDefined(document.locale) ? appHelper.getLocalData(document) : document });
	        }
	    }, {
	        key: 'getFilePath',
	        value: function getFilePath(src) {
	            if (appConstants.DEVELOPMENT_MODE) {
	                if (appHelper.isDefined(src) && src.length > 0) {
	                    return __webpack_require__(16)("./" + src);
	                }
	            } else {
	                return src;
	            }
	        }
	    }, {
	        key: 'getStatusClass',
	        value: function getStatusClass() {
	            var objectUserData = userDataHelper.getAttachmentObjectUserData(this.state.userData, this.state.resource.asset_id);
	
	            if (objectUserData.status === objectConstants.STATUS_NOT_STARTED) {
	                return "not-started";
	            } else if (objectUserData.status === objectConstants.STATUS_IN_PROGRESS) {
	                return "in-progress";
	            } else if (objectUserData.status === objectConstants.STATUS_COMPLETE) {
	                return "complete";
	            }
	        }
	    }, {
	        key: 'onOpen',
	        value: function onOpen() {
	            this.updateResourceObjectResult();
	        }
	    }, {
	        key: 'updateResourceObjectResult',
	        value: function updateResourceObjectResult() {
	            var _this2 = this;
	
	            var params = {
	                asset_id: this.state.resource.asset_id,
	                asset_type_code: this.state.resource.object_type,
	                status: objectConstants.STATUS_COMPLETE
	            };
	
	            this.props.actions.updateResourceObjectResult(params).then(function (userData) {
	                _this2.props.actions.setSuspendData(userData).then(function (trackingData) {}).catch(function (error) {});
	            }).catch(function (error) {});
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            return _react2.default.createElement(
	                'li',
	                { className: 'resource-link ' + this.getStatusClass() },
	                _react2.default.createElement('a', { className: 'document', onClick: this.onOpen, href: this.getFilePath(this.state.document.src), target: '_blank', dangerouslySetInnerHTML: { __html: this.state.locale.label } }),
	                this.state.resource.required ? _react2.default.createElement(
	                    'span',
	                    { className: 'required-label' },
	                    ' - ',
	                    this.state.required_label
	                ) : null
	            );
	        }
	    }]);
	
	    return ResourceDocumentLink;
	}(_react2.default.Component);
	
	ResourceDocumentLink.propTypes = {
	    resource: _propTypes2.default.object.isRequired,
	    trackingData: _propTypes2.default.object.isRequired,
	    userData: _propTypes2.default.object.isRequired,
	    lang: _propTypes2.default.string.isRequired,
	    actions: _propTypes2.default.object.isRequired
	};
	
	ResourceDocumentLink.contextTypes = {
	    router: _propTypes2.default.object
	};
	
	function mapStateToProps(state, ownProps) {
	    var lang = state.userData.lang;
	    return {
	        lang: lang,
	        contentData: state.contentData,
	        trackingData: state.trackingData,
	        userData: state.userData
	    };
	}
	
	function mapDispatchToProps(dispatch) {
	    return {
	        actions: (0, _redux.bindActionCreators)(Object.assign({}, userDataActions), dispatch)
	    };
	}
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(ResourceDocumentLink);

/***/ },
/* 511 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(5);
	
	var _redux = __webpack_require__(4);
	
	var _AssetImage = __webpack_require__(136);
	
	var _AssetImage2 = _interopRequireDefault(_AssetImage);
	
	var _userDataActions = __webpack_require__(20);
	
	var userDataActions = _interopRequireWildcard(_userDataActions);
	
	var _dialogPopupActions = __webpack_require__(19);
	
	var dialogPopupActions = _interopRequireWildcard(_dialogPopupActions);
	
	var _appConstants = __webpack_require__(13);
	
	var appConstants = _interopRequireWildcard(_appConstants);
	
	var _appHelper = __webpack_require__(3);
	
	var appHelper = _interopRequireWildcard(_appHelper);
	
	var _dataHelper = __webpack_require__(11);
	
	var dataHelper = _interopRequireWildcard(_dataHelper);
	
	var _userDataHelper = __webpack_require__(15);
	
	var userDataHelper = _interopRequireWildcard(_userDataHelper);
	
	var _objectConstants = __webpack_require__(9);
	
	var objectConstants = _interopRequireWildcard(_objectConstants);
	
	var _keyboardConstants = __webpack_require__(14);
	
	var keyboardConstants = _interopRequireWildcard(_keyboardConstants);
	
	var _dialogModels = __webpack_require__(32);
	
	var _gsap = __webpack_require__(8);
	
	var _gsapReactPlugin = __webpack_require__(10);
	
	var _gsapReactPlugin2 = _interopRequireDefault(_gsapReactPlugin);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ResourceImageLink = function (_React$Component) {
	    _inherits(ResourceImageLink, _React$Component);
	
	    function ResourceImageLink(props, context) {
	        _classCallCheck(this, ResourceImageLink);
	
	        var _this = _possibleConstructorReturn(this, (ResourceImageLink.__proto__ || Object.getPrototypeOf(ResourceImageLink)).call(this, props, context));
	
	        _this.state = {
	            lang: _this.props.lang,
	            resource: _this.props.resource,
	            userData: _this.props.userData,
	            locale: appHelper.getLocalData(_this.props.resource),
	            required_label: appHelper.getLocaleString("required_label")
	        };
	        _this.onOpen = _this.onOpen.bind(_this);
	        _this.getStatusClass = _this.getStatusClass.bind(_this);
	        _this.updateResourceObjectResult = _this.updateResourceObjectResult.bind(_this);
	        _this.onCloseAssetDialog = _this.onCloseAssetDialog.bind(_this);
	        _this.launchAsset = _this.launchAsset.bind(_this);
	        _this.setKeyboardAccessibility = _this.setKeyboardAccessibility.bind(_this);
	
	        return _this;
	    }
	
	    _createClass(ResourceImageLink, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {}
	    }, {
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(nextProps) {
	            if (this.state.userData !== nextProps.userData) {
	                this.setState({ userData: Object.assign({}, nextProps.userData) });
	            }
	
	            if (this.state.lang !== nextProps.lang) {
	                this.setState({
	                    lang: nextProps.lang,
	                    locale: appHelper.getLocalData(this.state.resource),
	                    required_label: appHelper.getLocaleString("required_label")
	                });
	            }
	        }
	    }, {
	        key: 'componentDidUpdate',
	        value: function componentDidUpdate() {}
	    }, {
	        key: 'onCloseAssetDialog',
	        value: function onCloseAssetDialog(viewed) {
	            var objectUserData = userDataHelper.getAttachmentObjectUserData(this.state.userData, this.state.resource.asset_id);
	            if (objectUserData.status !== objectConstants.STATUS_COMPLETE && viewed) {
	                this.updateResourceObjectResult();
	            }
	        }
	    }, {
	        key: 'launchAsset',
	        value: function launchAsset() {
	            var childComponenents = [];
	            var config = Object.assign({}, _dialogModels.ASSET_CONFIG, {
	                title: this.state.locale.label,
	                onClose: this.onCloseAssetDialog,
	                showCloseBtn: false,
	                theme: "dialog-asset-image",
	                sourceId: 'resource_link_' + this.state.resource.screen_id
	            });
	
	            for (var i = 0; i < config.childComponents.length; i++) {
	                var child = config.childComponents[i];
	                child = Object.assign({}, child, {
	                    childComponent: _AssetImage2.default,
	                    componentProps: Object.assign({}, {
	                        screenObject: this.state.resource,
	                        callbacks: {}
	
	                    })
	                });
	
	                childComponenents = dataHelper.immutablePush(childComponenents, child);
	            }
	            config = Object.assign({}, config, {
	                childComponents: childComponenents
	            });
	
	            this.props.actions.setNewAssetDialog(config);
	        }
	    }, {
	        key: 'getStatusClass',
	        value: function getStatusClass() {
	            var objectUserData = userDataHelper.getAttachmentObjectUserData(this.state.userData, this.state.resource.asset_id);
	            if (objectUserData.status === objectConstants.STATUS_NOT_STARTED) {
	                return "not-started";
	            } else if (objectUserData.status === objectConstants.STATUS_IN_PROGRESS) {
	                return "in-progress";
	            } else if (objectUserData.status === objectConstants.STATUS_COMPLETE) {
	                return "complete";
	            }
	        }
	    }, {
	        key: 'onOpen',
	        value: function onOpen() {
	            // this.updateResourceObjectResult();
	            this.launchAsset();
	        }
	    }, {
	        key: 'updateResourceObjectResult',
	        value: function updateResourceObjectResult() {
	            var _this2 = this;
	
	            var params = {
	                asset_id: this.state.resource.asset_id,
	                asset_type_code: this.state.resource.object_type,
	                status: objectConstants.STATUS_COMPLETE
	            };
	
	            this.props.actions.updateResourceObjectResult(params).then(function (userData) {
	                _this2.props.actions.setSuspendData(userData).then(function (trackingData) {}).catch(function (error) {});
	            }).catch(function (error) {});
	        }
	    }, {
	        key: 'setKeyboardAccessibility',
	        value: function setKeyboardAccessibility(event) {
	            if (event.which === keyboardConstants.ENTER_KEY || event.which === keyboardConstants.SPACEBAR_KEY) {
	                event.preventDefault();
	                this.onOpen();
	            }
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            return _react2.default.createElement(
	                'li',
	                { className: 'resource-link ' + this.getStatusClass() },
	                _react2.default.createElement('span', { className: 'image', onClick: this.onOpen, onKeyDown: this.setKeyboardAccessibility, role: 'link', tabIndex: '0', id: 'resource_link_' + this.state.resource.screen_id, dangerouslySetInnerHTML: { __html: this.state.locale.label } }),
	                this.state.resource.required ? _react2.default.createElement(
	                    'span',
	                    { className: 'required-label' },
	                    ' - ',
	                    this.state.required_label
	                ) : null
	            );
	        }
	    }]);
	
	    return ResourceImageLink;
	}(_react2.default.Component);
	
	ResourceImageLink.propTypes = {
	    resource: _propTypes2.default.object.isRequired,
	    trackingData: _propTypes2.default.object.isRequired,
	    userData: _propTypes2.default.object.isRequired,
	    lang: _propTypes2.default.string.isRequired,
	    actions: _propTypes2.default.object.isRequired
	};
	
	ResourceImageLink.contextTypes = {
	    router: _propTypes2.default.object
	};
	
	function mapStateToProps(state, ownProps) {
	    var lang = state.userData.lang;
	    return {
	        lang: lang,
	        contentData: state.contentData,
	        trackingData: state.trackingData,
	        userData: state.userData
	    };
	}
	
	function mapDispatchToProps(dispatch) {
	    return {
	        actions: (0, _redux.bindActionCreators)(Object.assign({}, userDataActions, dialogPopupActions), dispatch)
	    };
	}
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(ResourceImageLink);

/***/ },
/* 512 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(5);
	
	var _redux = __webpack_require__(4);
	
	var _userDataActions = __webpack_require__(20);
	
	var userDataActions = _interopRequireWildcard(_userDataActions);
	
	var _trackingDataActions = __webpack_require__(7);
	
	var trackingDataActions = _interopRequireWildcard(_trackingDataActions);
	
	var _resourcesActions = __webpack_require__(150);
	
	var resourceActions = _interopRequireWildcard(_resourcesActions);
	
	var _appModels = __webpack_require__(68);
	
	var _appConstants = __webpack_require__(13);
	
	var appConstants = _interopRequireWildcard(_appConstants);
	
	var _appHelper = __webpack_require__(3);
	
	var appHelper = _interopRequireWildcard(_appHelper);
	
	var _userDataHelper = __webpack_require__(15);
	
	var userDataHelper = _interopRequireWildcard(_userDataHelper);
	
	var _objectConstants = __webpack_require__(9);
	
	var objectConstants = _interopRequireWildcard(_objectConstants);
	
	var _actionTypes = __webpack_require__(22);
	
	var actionTypes = _interopRequireWildcard(_actionTypes);
	
	var _keyboardConstants = __webpack_require__(14);
	
	var keyboardConstants = _interopRequireWildcard(_keyboardConstants);
	
	var _gsap = __webpack_require__(8);
	
	var _gsapReactPlugin = __webpack_require__(10);
	
	var _gsapReactPlugin2 = _interopRequireDefault(_gsapReactPlugin);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ResourceScreenLink = function (_React$Component) {
	    _inherits(ResourceScreenLink, _React$Component);
	
	    function ResourceScreenLink(props, context) {
	        _classCallCheck(this, ResourceScreenLink);
	
	        var _this = _possibleConstructorReturn(this, (ResourceScreenLink.__proto__ || Object.getPrototypeOf(ResourceScreenLink)).call(this, props, context));
	
	        _this.state = {
	            lang: _this.props.lang,
	            resource: _this.props.resource,
	            userData: _this.props.userData,
	            activeResourcesId: _this.props.activeResourcesId,
	            locale: appHelper.getLocalData(_this.props.resource),
	            showResources: false,
	            checkCompletion: false,
	            required_label: appHelper.getLocaleString("required_label")
	        };
	        _this.onOpen = _this.onOpen.bind(_this);
	        _this.getStatusClass = _this.getStatusClass.bind(_this);
	        _this.setActiveResourceId = _this.setActiveResourceId.bind(_this);
	        _this.openResources = _this.openResources.bind(_this);
	        _this.setKeyboardAccessibility = _this.setKeyboardAccessibility.bind(_this);
	
	        return _this;
	    }
	
	    _createClass(ResourceScreenLink, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {}
	    }, {
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(nextProps) {
	            if (this.state.userData !== nextProps.userData) {
	                this.setState({ userData: Object.assign({}, nextProps.userData) });
	            }
	
	            if (this.state.activeResourcesId !== nextProps.activeResourcesId) {
	                this.setState({ activeResourcesId: nextProps.activeResourcesId, showResources: true });
	            }
	
	            if (this.state.lang !== nextProps.lang) {
	                this.setState({
	                    lang: nextProps.lang,
	                    locale: appHelper.getLocalData(this.state.resource),
	                    required_label: appHelper.getLocaleString("required_label")
	                });
	            }
	        }
	    }, {
	        key: 'componentDidUpdate',
	        value: function componentDidUpdate() {
	            if (this.state.showResources) {
	                this.openResources();
	            }
	        }
	    }, {
	        key: 'getStatusClass',
	        value: function getStatusClass() {
	            var screenUserData = userDataHelper.getResourceScreenUserData(this.state.userData, this.state.resource.screen_id);
	
	            if (screenUserData.status === objectConstants.STATUS_NOT_STARTED) {
	                return "not-started";
	            } else if (screenUserData.status === objectConstants.STATUS_IN_PROGRESS) {
	                return "in-progress";
	            } else if (screenUserData.status === objectConstants.STATUS_COMPLETE) {
	                return "complete";
	            }
	        }
	    }, {
	        key: 'onOpen',
	        value: function onOpen() {
	            this.setActiveResourceId();
	        }
	    }, {
	        key: 'setActiveResourceId',
	        value: function setActiveResourceId() {
	            var resourceProps = Object.assign({}, _appModels.RESOURCE_PROPS, {
	                activeResourcesId: this.state.resource.screen_id,
	                sourceId: 'resource_link_' + this.state.resource.screen_id
	            });
	            this.props.actions.setResourcesProps(resourceProps);
	        }
	    }, {
	        key: 'openResources',
	        value: function openResources() {
	            this.setState({ showResources: false });
	            if (this.state.activeResourcesId != "") {
	                this.props.actions.setResourcesDisplay(actionTypes.STATUS_OPENING);
	            }
	        }
	    }, {
	        key: 'setKeyboardAccessibility',
	        value: function setKeyboardAccessibility(event) {
	            if (event.which === keyboardConstants.ENTER_KEY || event.which === keyboardConstants.SPACEBAR_KEY) {
	                event.preventDefault();
	                this.onOpen();
	            }
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            return _react2.default.createElement(
	                'li',
	                { className: 'resource-link ' + this.getStatusClass() },
	                _react2.default.createElement('span', { className: 'resources', onClick: this.onOpen, onKeyDown: this.setKeyboardAccessibility, role: 'link', tabIndex: '0', id: 'resource_link_' + this.state.resource.screen_id, dangerouslySetInnerHTML: { __html: this.state.locale.label } }),
	                this.state.resource.required ? _react2.default.createElement(
	                    'span',
	                    { className: 'required-label' },
	                    ' - ',
	                    this.state.required_label
	                ) : null
	            );
	        }
	    }]);
	
	    return ResourceScreenLink;
	}(_react2.default.Component);
	
	ResourceScreenLink.propTypes = {
	    resource: _propTypes2.default.object.isRequired,
	    trackingData: _propTypes2.default.object.isRequired,
	    userData: _propTypes2.default.object.isRequired,
	    displayResources: _propTypes2.default.string.isRequired,
	    activeResourcesId: _propTypes2.default.number.isRequired,
	    lang: _propTypes2.default.string.isRequired,
	    actions: _propTypes2.default.object.isRequired
	};
	
	ResourceScreenLink.contextTypes = {
	    router: _propTypes2.default.object
	};
	
	function mapStateToProps(state, ownProps) {
	    var lang = state.userData.lang;
	    return {
	        lang: lang,
	        contentData: state.contentData,
	        trackingData: state.trackingData,
	        userData: state.userData,
	        displayResources: state.displayResources,
	        activeResourcesId: state.resourceProps.activeResourcesId
	    };
	}
	
	function mapDispatchToProps(dispatch) {
	    return {
	        actions: (0, _redux.bindActionCreators)(Object.assign({}, userDataActions, trackingDataActions, resourceActions), dispatch)
	    };
	}
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(ResourceScreenLink);

/***/ },
/* 513 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(5);
	
	var _redux = __webpack_require__(4);
	
	var _userDataActions = __webpack_require__(20);
	
	var userDataActions = _interopRequireWildcard(_userDataActions);
	
	var _appConstants = __webpack_require__(13);
	
	var appConstants = _interopRequireWildcard(_appConstants);
	
	var _appHelper = __webpack_require__(3);
	
	var appHelper = _interopRequireWildcard(_appHelper);
	
	var _userDataHelper = __webpack_require__(15);
	
	var userDataHelper = _interopRequireWildcard(_userDataHelper);
	
	var _objectConstants = __webpack_require__(9);
	
	var objectConstants = _interopRequireWildcard(_objectConstants);
	
	var _gsap = __webpack_require__(8);
	
	var _gsapReactPlugin = __webpack_require__(10);
	
	var _gsapReactPlugin2 = _interopRequireDefault(_gsapReactPlugin);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ResourceUrlLink = function (_React$Component) {
	    _inherits(ResourceUrlLink, _React$Component);
	
	    function ResourceUrlLink(props, context) {
	        _classCallCheck(this, ResourceUrlLink);
	
	        var _this = _possibleConstructorReturn(this, (ResourceUrlLink.__proto__ || Object.getPrototypeOf(ResourceUrlLink)).call(this, props, context));
	
	        _this.state = {
	            lang: _this.props.lang,
	            resource: _this.props.resource,
	            userData: _this.props.userData,
	            locale: appHelper.getLocalData(_this.props.resource),
	            link: {},
	            required_label: appHelper.getLocaleString("required_label")
	        };
	        _this.onOpen = _this.onOpen.bind(_this);
	        _this.getStatusClass = _this.getStatusClass.bind(_this);
	        _this.getAssets = _this.getAssets.bind(_this);
	        _this.updateResourceObjectResult = _this.updateResourceObjectResult.bind(_this);
	
	        return _this;
	    }
	
	    _createClass(ResourceUrlLink, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            this.getAssets();
	        }
	    }, {
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(nextProps) {
	            if (this.state.userData !== nextProps.userData) {
	                this.setState({ userData: Object.assign({}, nextProps.userData) });
	            }
	            if (this.state.lang !== nextProps.lang) {
	                var link = appHelper.getLinkAsset(this.state.resource);
	                this.setState({
	                    lang: nextProps.lang,
	                    locale: appHelper.getLocalData(this.state.resource),
	                    link: appHelper.isDefined(link.locale) ? appHelper.getLocalData(link) : link,
	                    required_label: appHelper.getLocaleString("required_label")
	                });
	            }
	        }
	    }, {
	        key: 'componentDidUpdate',
	        value: function componentDidUpdate() {}
	    }, {
	        key: 'getAssets',
	        value: function getAssets() {
	            var link = appHelper.getLinkAsset(this.state.resource);
	            this.setState({ link: appHelper.isDefined(link.locale) ? appHelper.getLocalData(link) : link });
	        }
	    }, {
	        key: 'getStatusClass',
	        value: function getStatusClass() {
	            var objectUserData = userDataHelper.getAttachmentObjectUserData(this.state.userData, this.state.resource.asset_id);
	
	            if (objectUserData.status === objectConstants.STATUS_NOT_STARTED) {
	                return "not-started";
	            } else if (objectUserData.status === objectConstants.STATUS_IN_PROGRESS) {
	                return "in-progress";
	            } else if (objectUserData.status === objectConstants.STATUS_COMPLETE) {
	                return "complete";
	            }
	        }
	    }, {
	        key: 'onOpen',
	        value: function onOpen() {
	            this.updateResourceObjectResult();
	        }
	    }, {
	        key: 'updateResourceObjectResult',
	        value: function updateResourceObjectResult() {
	            var _this2 = this;
	
	            var params = {
	                asset_id: this.state.resource.asset_id,
	                asset_type_code: this.state.resource.object_type,
	                status: objectConstants.STATUS_COMPLETE
	            };
	
	            this.props.actions.updateResourceObjectResult(params).then(function (userData) {
	                _this2.props.actions.setSuspendData(userData).then(function (trackingData) {}).catch(function (error) {});
	            }).catch(function (error) {});
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            return _react2.default.createElement(
	                'li',
	                { className: 'resource-link ' + this.getStatusClass() },
	                _react2.default.createElement('a', { className: 'link', href: this.state.link.src, target: '_blank', onClick: this.onOpen, dangerouslySetInnerHTML: { __html: this.state.locale.label } }),
	                this.state.resource.required ? _react2.default.createElement(
	                    'span',
	                    { className: 'required-label' },
	                    ' - ',
	                    this.state.required_label
	                ) : null
	            );
	        }
	    }]);
	
	    return ResourceUrlLink;
	}(_react2.default.Component);
	
	ResourceUrlLink.propTypes = {
	    resource: _propTypes2.default.object.isRequired,
	    trackingData: _propTypes2.default.object.isRequired,
	    userData: _propTypes2.default.object.isRequired,
	    lang: _propTypes2.default.string.isRequired,
	    actions: _propTypes2.default.object.isRequired
	};
	
	ResourceUrlLink.contextTypes = {
	    router: _propTypes2.default.object
	};
	
	function mapStateToProps(state, ownProps) {
	    var lang = state.userData.lang;
	    return {
	        lang: lang,
	        contentData: state.contentData,
	        trackingData: state.trackingData,
	        userData: state.userData
	    };
	}
	
	function mapDispatchToProps(dispatch) {
	    return {
	        actions: (0, _redux.bindActionCreators)(Object.assign({}, userDataActions), dispatch)
	    };
	}
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(ResourceUrlLink);

/***/ },
/* 514 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(5);
	
	var _redux = __webpack_require__(4);
	
	var _userDataActions = __webpack_require__(20);
	
	var userDataActions = _interopRequireWildcard(_userDataActions);
	
	var _dialogPopupActions = __webpack_require__(19);
	
	var dialogPopupActions = _interopRequireWildcard(_dialogPopupActions);
	
	var _appConstants = __webpack_require__(13);
	
	var appConstants = _interopRequireWildcard(_appConstants);
	
	var _appHelper = __webpack_require__(3);
	
	var appHelper = _interopRequireWildcard(_appHelper);
	
	var _dataHelper = __webpack_require__(11);
	
	var dataHelper = _interopRequireWildcard(_dataHelper);
	
	var _userDataHelper = __webpack_require__(15);
	
	var userDataHelper = _interopRequireWildcard(_userDataHelper);
	
	var _objectConstants = __webpack_require__(9);
	
	var objectConstants = _interopRequireWildcard(_objectConstants);
	
	var _dialogModels = __webpack_require__(32);
	
	var _componentHelper = __webpack_require__(31);
	
	var _keyboardConstants = __webpack_require__(14);
	
	var keyboardConstants = _interopRequireWildcard(_keyboardConstants);
	
	var _gsap = __webpack_require__(8);
	
	var _gsapReactPlugin = __webpack_require__(10);
	
	var _gsapReactPlugin2 = _interopRequireDefault(_gsapReactPlugin);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ResourceVideoLink = function (_React$Component) {
	    _inherits(ResourceVideoLink, _React$Component);
	
	    function ResourceVideoLink(props, context) {
	        _classCallCheck(this, ResourceVideoLink);
	
	        var _this = _possibleConstructorReturn(this, (ResourceVideoLink.__proto__ || Object.getPrototypeOf(ResourceVideoLink)).call(this, props, context));
	
	        _this.state = {
	            lang: _this.props.lang,
	            resource: _this.props.resource,
	            userData: _this.props.userData,
	            locale: appHelper.getLocalData(_this.props.resource),
	            videoType: {},
	            video: {
	                src: ""
	            },
	            setVideoType: false,
	            required_label: appHelper.getLocaleString("required_label")
	        };
	        _this.onOpen = _this.onOpen.bind(_this);
	        _this.getStatusClass = _this.getStatusClass.bind(_this);
	        _this.updateResourceObjectResult = _this.updateResourceObjectResult.bind(_this);
	        _this.getAssets = _this.getAssets.bind(_this);
	        _this.onCloseVideoDialog = _this.onCloseVideoDialog.bind(_this);
	        _this.launchVideo = _this.launchVideo.bind(_this);
	        _this.setKeyboardAccessibility = _this.setKeyboardAccessibility.bind(_this);
	
	        return _this;
	    }
	
	    _createClass(ResourceVideoLink, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            this.getAssets();
	        }
	    }, {
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(nextProps) {
	            if (this.state.userData !== nextProps.userData) {
	                this.setState({ userData: Object.assign({}, nextProps.userData) });
	            }
	            if (this.state.lang !== nextProps.lang) {
	                var video = appHelper.getLocalData(video);
	                var videoType = Object.assign({}, (0, _componentHelper.getChildObjectComponentByType)('' + video.sub_type));
	                this.setState({
	                    lang: nextProps.lang,
	                    locale: appHelper.getLocalData(this.state.resource),
	                    video: appHelper.isDefined(video) && video.src.length > 0 ? video : this.state.video,
	                    videoType: appHelper.isDefined(video) && video.src.length > 0 ? videoType : this.state.videoType,
	                    required_label: appHelper.getLocaleString("required_label")
	                });
	            }
	        }
	    }, {
	        key: 'componentDidUpdate',
	        value: function componentDidUpdate() {
	            if (this.state.setVideoType) {
	                this.getVideoType();
	            }
	        }
	    }, {
	        key: 'getAssets',
	        value: function getAssets() {
	            var video = appHelper.getVideoAsset(this.state.resource);
	            video = appHelper.getLocalData(video);
	            var videoType = Object.assign({}, (0, _componentHelper.getChildObjectComponentByType)('' + video.sub_type));
	            if (appHelper.isDefined(video) && video.src.length > 0) {
	                this.setState({
	                    video: video,
	                    videoType: videoType
	                });
	            }
	        }
	    }, {
	        key: 'onCloseVideoDialog',
	        value: function onCloseVideoDialog(viewed) {
	            var objectUserData = userDataHelper.getAttachmentObjectUserData(this.state.userData, this.state.resource.screen_id, this.state.resource.asset_id);
	            if (objectUserData.status !== objectConstants.STATUS_COMPLETE && viewed) {
	                this.updateResourceObjectResult();
	            }
	        }
	    }, {
	        key: 'launchVideo',
	        value: function launchVideo() {
	            var childComponenents = [];
	            var config = Object.assign({}, _dialogModels.ASSET_CONFIG, {
	                title: this.state.locale.label,
	                onClose: this.onCloseVideoDialog,
	                showCloseBtn: false,
	                theme: "dialog-asset-image",
	                sourceId: 'resource_link_' + this.state.resource.screen_id
	            });
	
	            for (var i = 0; i < config.childComponents.length; i++) {
	                var child = config.childComponents[i];
	                child = Object.assign({}, child, {
	                    childComponent: this.state.videoType.component,
	                    componentProps: Object.assign({}, {
	                        screenObject: this.state.resource,
	                        callbacks: {},
	                        video: this.state.video
	                    })
	                });
	
	                childComponenents = dataHelper.immutablePush(childComponenents, child);
	            }
	            config = Object.assign({}, config, {
	                childComponents: childComponenents
	            });
	
	            this.props.actions.setNewAssetDialog(config);
	        }
	    }, {
	        key: 'getStatusClass',
	        value: function getStatusClass() {
	            var objectUserData = userDataHelper.getAttachmentObjectUserData(this.state.userData, this.state.resource.asset_id);
	
	            if (objectUserData.status === objectConstants.STATUS_NOT_STARTED) {
	                return "not-started";
	            } else if (objectUserData.status === objectConstants.STATUS_IN_PROGRESS) {
	                return "in-progress";
	            } else if (objectUserData.status === objectConstants.STATUS_COMPLETE) {
	                return "complete";
	            }
	        }
	    }, {
	        key: 'onOpen',
	        value: function onOpen() {
	            this.launchVideo();
	        }
	    }, {
	        key: 'updateResourceObjectResult',
	        value: function updateResourceObjectResult() {
	            var _this2 = this;
	
	            var params = {
	                asset_id: this.state.resource.asset_id,
	                asset_type_code: this.state.resource.object_type,
	                status: objectConstants.STATUS_COMPLETE
	            };
	
	            this.props.actions.updateResourceObjectResult(params).then(function (userData) {
	                _this2.props.actions.setSuspendData(userData).then(function (trackingData) {}).catch(function (error) {});
	            }).catch(function (error) {});
	        }
	    }, {
	        key: 'setKeyboardAccessibility',
	        value: function setKeyboardAccessibility(event) {
	            if (event.which === keyboardConstants.ENTER_KEY || event.which === keyboardConstants.SPACEBAR_KEY) {
	                event.preventDefault();
	                this.onOpen();
	            }
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            return _react2.default.createElement(
	                'li',
	                { className: 'resource-link ' + this.getStatusClass() },
	                _react2.default.createElement('span', { className: 'video', onClick: this.onOpen, onKeyDown: this.setKeyboardAccessibility, role: 'link', tabIndex: '0', id: 'resource_link_' + this.state.resource.screen_id, dangerouslySetInnerHTML: { __html: this.state.locale.label } }),
	                this.state.resource.required ? _react2.default.createElement(
	                    'span',
	                    { className: 'required-label' },
	                    ' - ',
	                    this.state.required_label
	                ) : null
	            );
	        }
	    }]);
	
	    return ResourceVideoLink;
	}(_react2.default.Component);
	
	ResourceVideoLink.propTypes = {
	    resource: _propTypes2.default.object.isRequired,
	    trackingData: _propTypes2.default.object.isRequired,
	    userData: _propTypes2.default.object.isRequired,
	    lang: _propTypes2.default.string.isRequired,
	    actions: _propTypes2.default.object.isRequired
	};
	
	ResourceVideoLink.contextTypes = {
	    router: _propTypes2.default.object
	};
	
	function mapStateToProps(state, ownProps) {
	    var lang = state.userData.lang;
	    return {
	        lang: lang,
	        contentData: state.contentData,
	        trackingData: state.trackingData,
	        userData: state.userData
	    };
	}
	
	function mapDispatchToProps(dispatch) {
	    return {
	        actions: (0, _redux.bindActionCreators)(Object.assign({}, userDataActions, dialogPopupActions), dispatch)
	    };
	}
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(ResourceVideoLink);

/***/ },
/* 515 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(5);
	
	var _redux = __webpack_require__(4);
	
	var _Button = __webpack_require__(18);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _ResourceLinks = __webpack_require__(48);
	
	var _ResourceLinks2 = _interopRequireDefault(_ResourceLinks);
	
	var _SecondaryImage = __webpack_require__(66);
	
	var _SecondaryImage2 = _interopRequireDefault(_SecondaryImage);
	
	var _SecondaryLibraryImage = __webpack_require__(67);
	
	var _SecondaryLibraryImage2 = _interopRequireDefault(_SecondaryLibraryImage);
	
	var _appDataActions = __webpack_require__(12);
	
	var appDataActions = _interopRequireWildcard(_appDataActions);
	
	var _trackingDataActions = __webpack_require__(7);
	
	var trackingDataActions = _interopRequireWildcard(_trackingDataActions);
	
	var _appConstants = __webpack_require__(13);
	
	var appConstants = _interopRequireWildcard(_appConstants);
	
	var _appHelper = __webpack_require__(3);
	
	var appHelper = _interopRequireWildcard(_appHelper);
	
	var _dataHelper = __webpack_require__(11);
	
	var dataHelper = _interopRequireWildcard(_dataHelper);
	
	var _userDataHelper = __webpack_require__(15);
	
	var userDataHelper = _interopRequireWildcard(_userDataHelper);
	
	var _objectConstants = __webpack_require__(9);
	
	var objectConstants = _interopRequireWildcard(_objectConstants);
	
	var _assetConstants = __webpack_require__(33);
	
	var assetConstants = _interopRequireWildcard(_assetConstants);
	
	var _xAPIHelper = __webpack_require__(86);
	
	var xAPIHelper = _interopRequireWildcard(_xAPIHelper);
	
	var _localStorage = __webpack_require__(17);
	
	var localStorage = _interopRequireWildcard(_localStorage);
	
	var _gsap = __webpack_require__(8);
	
	var _gsapReactPlugin = __webpack_require__(10);
	
	var _gsapReactPlugin2 = _interopRequireDefault(_gsapReactPlugin);
	
	var _lodash = __webpack_require__(28);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } //eslint-disable-line import/no-named-as-default
	
	
	var PrintResponses = function (_React$Component) {
	    _inherits(PrintResponses, _React$Component);
	
	    function PrintResponses(props, context) {
	        _classCallCheck(this, PrintResponses);
	
	        var _this = _possibleConstructorReturn(this, (PrintResponses.__proto__ || Object.getPrototypeOf(PrintResponses)).call(this, props, context));
	
	        _this.state = {
	            lang: _this.props.lang,
	            screenObject: _this.props.screenObject,
	            userData: _this.props.userData,
	            shortResponseQuestions: _this.props.shortResponseQuestions,
	            status: objectConstants.STATUS_NOT_STARTED,
	            locale: appHelper.getLocalData(_this.props.screenObject),
	            showProgressionButton: false,
	            printableAssets: [],
	            renderQuestions: false,
	            checkGetXAPIResponse: false,
	            screenStatus: "",
	            checkComplete: false,
	            resourceLinks: [],
	            isResourceObject: appHelper.isDefined(_this.props.callbacks.checkIsResourceScreen) && _this.props.callbacks.checkIsResourceScreen(),
	            hasResources: false,
	            resourcesAreComplete: false,
	            allowScroll: appHelper.allowScroll(_this.props.callbacks.getBiteId(), _this.props.callbacks.getScreenId(), _this.props.screenObject.asset_id),
	            print_label: appHelper.getLocaleString("print_label"),
	            no_response_provided_label: appHelper.getLocaleString("no_response_provided_label")
	        };
	        _this.handleProgression = _this.handleProgression.bind(_this);
	        _this.scrollToTop = _this.scrollToTop.bind(_this);
	        _this.onComplete = _this.onComplete.bind(_this);
	        _this.enableProgression = _this.enableProgression.bind(_this);
	        _this.disableProgression = _this.disableProgression.bind(_this);
	        _this.show = _this.show.bind(_this);
	        _this.onShowComplete = _this.onShowComplete.bind(_this);
	        _this.onProgressionBtnClicked = _this.onProgressionBtnClicked.bind(_this);
	        _this.getScreenStatus = _this.getScreenStatus.bind(_this);
	        _this.getObjectStatus = _this.getObjectStatus.bind(_this);
	        _this.onResourcesComplete = _this.onResourcesComplete.bind(_this);
	        _this.setResources = _this.setResources.bind(_this);
	        _this.onRendered = _this.onRendered.bind(_this);
	        _this.getAssetsToPrint = _this.getAssetsToPrint.bind(_this);
	        _this.getXAPIResponse = _this.getXAPIResponse.bind(_this);
	        _this.print = _this.print.bind(_this);
	        _this.printStyles = _this.printStyles.bind(_this);
	        return _this;
	    }
	
	    _createClass(PrintResponses, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            this.setResources();
	            this.getScreenStatus();
	            this.show();
	            this.getAssetsToPrint();
	            if (appHelper.isDefined(this.props.callbacks.updateCharacterExpression) && appHelper.isDefined(this.state.screenObject.character_pose)) {
	                this.props.callbacks.updateCharacterExpression(this.state.screenObject.character_pose);
	            }
	        }
	    }, {
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(nextProps) {
	            if (this.state.userData !== nextProps.userData) {
	                this.setState({ userData: Object.assign({}, nextProps.userData) });
	            }
	            if (this.state.lang !== nextProps.lang) {
	                this.setState({
	                    lang: nextProps.lang,
	                    locale: appHelper.getLocalData(this.state.screenObject),
	                    print_label: appHelper.getLocaleString("print_label"),
	                    no_response_provided_label: appHelper.getLocaleString("no_response_provided_label")
	                });
	            }
	        }
	    }, {
	        key: 'componentDidUpdate',
	        value: function componentDidUpdate() {
	
	            if (this.state.checkComplete) {
	
	                this.onComplete();
	            }
	
	            if (this.state.checkGetXAPIResponse) {
	                this.getXAPIResponse();
	            }
	        }
	    }, {
	        key: 'getAssetsToPrint',
	        value: function getAssetsToPrint() {
	            var printableAssets = [];
	            var tempAssests = [];
	            var allQuestions = Object.assign([], this.state.shortResponseQuestions);
	
	            if (this.state.screenObject.print_responses_from === objectConstants.PRINT_FROM_THIS_BITE) {
	                tempAssests = appHelper.getPrintableAssetsByBite(this.props.callbacks.getBiteId());
	            } else {
	                //all tempAssests
	                printableAssets = appHelper.getAllPrintableAssets();
	            }
	
	            var _loop = function _loop(i) {
	                var asset = tempAssests[i];
	                var assetLocale = appHelper.getLocalData(asset);
	                var renderedQuestions = [];
	                _lodash2.default.forEach(asset.questions, function (question) {
	                    var questionData = appHelper.getArrayObjectByKey(allQuestions, "id", question.id);
	                    if (appHelper.isDefined(questionData.id)) {
	                        renderedQuestions = dataHelper.immutablePush(renderedQuestions, questionData);
	                    }
	                });
	
	                var renderedQuestion = {
	                    bite_id: asset.bite_id,
	                    screen_id: asset.screen_id,
	                    asset_id: asset.asset_id,
	                    locale: assetLocale,
	                    show_title: asset.show_title,
	                    renderedQuestions: renderedQuestions
	                };
	
	                printableAssets = dataHelper.immutablePush(printableAssets, renderedQuestion);
	            };
	
	            for (var i = 0; i < tempAssests.length; i++) {
	                _loop(i);
	            }
	
	            this.setState({
	                printableAssets: Object.assign([], printableAssets),
	                renderQuestions: localStorage.tracking_type !== appConstants.TRACKING_TYPE_XAPI && localStorage.tracking_type !== appConstants.TRACKING_TYPE_BLENDED_XAPI_SCORM_1_2,
	                checkGetXAPIResponse: true
	            });
	        }
	    }, {
	        key: 'getXAPIResponse',
	        value: function getXAPIResponse() {
	            var _this2 = this;
	
	            this.setState({ checkGetXAPIResponse: false });
	
	            if (localStorage.tracking_type === appConstants.TRACKING_TYPE_XAPI || localStorage.tracking_type === appConstants.TRACKING_TYPE_BLENDED_XAPI_SCORM_1_2) {
	                (function () {
	                    var updatedAssets = 0;
	                    var printableAssets = Object.assign([], _this2.state.printableAssets);
	
	                    var _loop2 = function _loop2(a) {
	                        var asset = printableAssets[a];
	                        var renderedQuestions = Object.assign([], asset.renderedQuestions);
	                        var returnedResponses = 0;
	                        var params = {
	                            renderedQuestions: renderedQuestions,
	                            bite_id: asset.bite_id,
	                            screen_id: asset.screen_id,
	                            asset_id: asset.asset_id
	                        };
	
	                        var interactionDataArray = xAPIHelper.getShortResponseIds(asset, params);
	
	                        for (var i = 0; i < interactionDataArray.length; i++) {
	                            var interactionData = interactionDataArray[i];
	                            _this2.props.actions.getActvityStatement(interactionData).then(function (responseObj) {
	                                if (appHelper.isDefined(responseObj.statement)) {
	                                    var response = responseObj.statement.result.response;
	                                    var responseQuestion = appHelper.getArrayObjectByKey(renderedQuestions, "id", responseObj.id);
	                                    var responseQuestionIndex = appHelper.getArrayObjectIndexByKey(renderedQuestions, "id", responseObj.id);
	                                    responseQuestion = Object.assign({}, responseQuestion, {
	                                        response: response
	                                    });
	                                    renderedQuestions = dataHelper.immutableSplice(renderedQuestions, responseQuestionIndex, 1, responseQuestion);
	                                    returnedResponses++;
	
	                                    if (returnedResponses === renderedQuestions.length) {
	                                        updatedAssets++;
	                                        asset = Object.assign({}, asset, {
	                                            renderedQuestions: renderedQuestions
	                                        });
	
	                                        printableAssets = dataHelper.immutableSplice(printableAssets, a, 1, asset);
	                                    }
	                                } else {
	                                    updatedAssets++;
	                                    asset = Object.assign({}, asset, {
	                                        renderedQuestions: renderedQuestions
	                                    });
	                                    printableAssets = dataHelper.immutableSplice(printableAssets, a, 1, asset);
	                                }
	
	                                if (updatedAssets === printableAssets.length) {
	                                    _this2.setState({
	                                        printableAssets: Object.assign([], printableAssets),
	                                        renderQuestions: true
	                                    });
	                                }
	                            }).catch(function (error) {});
	                        }
	                    };
	
	                    for (var a = 0; a < printableAssets.length; a++) {
	                        _loop2(a);
	                    }
	                })();
	            }
	        }
	    }, {
	        key: 'setResources',
	        value: function setResources() {
	            var resourceLinks = appHelper.setResourceLinks(this.state.screenObject);
	            var hasRequiredResources = appHelper.hasRequiredResources(resourceLinks);
	
	            this.setState({
	                resourceLinks: Object.assign([], resourceLinks),
	                hasResources: resourceLinks.length > 0,
	                resourcesAreComplete: resourceLinks.length === 0 || !hasRequiredResources
	            });
	        }
	    }, {
	        key: 'getScreenStatus',
	        value: function getScreenStatus() {
	            var screenStatus = this.props.callbacks.getScreenStatus();
	            this.setState({
	                screenStatus: screenStatus,
	                status: screenStatus === objectConstants.STATUS_COMPLETE ? objectConstants.STATUS_COMPLETE : this.state.status
	            });
	        }
	    }, {
	        key: 'getObjectStatus',
	        value: function getObjectStatus() {
	            if (this.state.screenStatus === objectConstants.STATUS_COMPLETE) {
	
	                this.onComplete();
	            } else {
	                var objectUserData = {};
	                if (this.state.status !== objectConstants.STATUS_COMPLETE) {
	                    var subScreenParent = this.props.callbacks.getSubScreenParent();
	                    var screen_id = this.props.callbacks.getScreenId();
	                    if (appHelper.isDefined(subScreenParent)) {
	                        objectUserData = userDataHelper.getSubScreenObjectStatus(this.state.userData, subScreenParent.screen_id, screen_id, this.state.screenObject.asset_id);
	                    } else if (this.state.isResourceObject) {
	                        objectUserData = userDataHelper.getResourceScreenObjectUserData(this.state.userData, screen_id, this.state.screenObject.asset_id);
	                    } else {
	                        objectUserData = userDataHelper.getObjectStatus(this.state.userData, screen_id, this.state.screenObject.asset_id);
	                    }
	                }
	                if (objectUserData.status === objectConstants.STATUS_COMPLETE) {
	                    this.setState({ status: objectConstants.STATUS_COMPLETE, checkComplete: true });
	                } else {
	                    this.setState({ checkComplete: true });
	                }
	            }
	        }
	    }, {
	        key: 'show',
	        value: function show() {
	            this.scrollToTop();
	            var optionRef = this.refs[this.state.screenObject.asset_id + '_text'];
	            _gsap.TweenLite.set(optionRef, { height: "auto" });
	            _gsap.TweenLite.from(optionRef, objectConstants.SHOW_PANEL_DURATION, {
	                height: 0,
	                ease: _gsap.Expo.easeInOut
	            }).eventCallback("onComplete", this.onRendered);
	        }
	    }, {
	        key: 'onRendered',
	        value: function onRendered() {
	            if (this.state.isResourceObject) {
	                this.props.callbacks.onObjectRendered();
	            }
	            this.getObjectStatus();
	        }
	    }, {
	        key: 'onShowComplete',
	        value: function onShowComplete() {
	            this.setState({ isVisible: true, checkComplete: false });
	        }
	    }, {
	        key: 'scrollToTop',
	        value: function scrollToTop() {
	            if (this.state.allowScroll && this.state.status !== objectConstants.STATUS_COMPLETE) {
	                var question = this.refs[this.state.screenObject.asset_id + '_text'];
	                var scrollTo = this.props.callbacks.scrollTo;
	
	                setTimeout(function () {
	                    if (appHelper.isDefined(scrollTo)) {
	                        scrollTo(question.offsetTop);
	                    }
	                }, objectConstants.SCROLL_TO);
	            }
	        }
	    }, {
	        key: 'onComplete',
	        value: function onComplete() {
	            this.setState({ checkComplete: false });
	            var hasNextObject = this.props.callbacks.hasNextObject(this.props.index);
	            if (this.state.resourcesAreComplete) {
	                if (appHelper.isDefined(this.state.screenObject.progression) && this.state.screenObject.progression === objectConstants.OBJECT_PROGRESSION_CONTINUE && (this.state.status !== objectConstants.STATUS_COMPLETE || !hasNextObject)) {
	                    if (!hasNextObject && !this.state.isResourceObject) {
	                        //console.log('progression 1')
	                        this.handleProgression();
	                        this.enableProgression();
	                    } else if (!hasNextObject && this.state.isResourceObject) {
	                        this.handleProgression();
	                    } else if (this.state.isResourceObject) {
	                        this.handleProgression();
	                    } else {
	                        this.enableProgression();
	                    }
	                } else {
	                    this.handleProgression();
	                }
	            }
	            this.scrollToTop();
	        }
	    }, {
	        key: 'enableProgression',
	        value: function enableProgression() {
	            if (!this.props.callbacks.isReviewMode()) {
	                this.setState({ showProgressionButton: true });
	            }
	        }
	    }, {
	        key: 'disableProgression',
	        value: function disableProgression() {
	            this.setState({ showProgressionButton: false });
	        }
	    }, {
	        key: 'handleProgression',
	        value: function handleProgression() {
	            var progressionRule = this.state.screenObject.progression;
	            var progressionType = appHelper.isDefined(this.state.screenObject.progression_type) ? this.state.screenObject.progression_type : undefined;
	            var progressionGoToId = appHelper.isDefined(this.state.screenObject.progression_goto_id) ? this.state.screenObject.progression_goto_id : undefined;
	            var completionData = {
	                progression: progressionRule,
	                progressionType: progressionType,
	                progressionGoToId: progressionGoToId,
	                asset_id: this.state.screenObject.asset_id,
	                status: objectConstants.STATUS_COMPLETE,
	                showProgressionButton: false,
	                asset_type_code: this.state.screenObject.asset_type_code,
	                navigateToNextScreen: !this.state.isResourceObject && appHelper.isDefined(this.state.screenObject.progression) && this.state.screenObject.progression === objectConstants.OBJECT_PROGRESSION_CONTINUE
	            };
	
	            this.props.callbacks.onObjectComplete(completionData);
	            //t
	        }
	    }, {
	        key: 'onProgressionBtnClicked',
	        value: function onProgressionBtnClicked() {
	            this.setState({ showProgressionButton: false });
	            if (this.props.callbacks.hasNextObject(this.props.index) || this.state.isResourceObject) {
	                this.handleProgression();
	            } else {
	                this.props.callbacks.navigateToNextScreen();
	            }
	        }
	    }, {
	        key: 'onResourcesComplete',
	        value: function onResourcesComplete() {
	            if (!this.state.resourcesAreComplete) {
	                this.setState({ resourcesAreComplete: true, checkComplete: true });
	            }
	        }
	    }, {
	        key: 'print',
	        value: function print() {
	            var mywindow = window.open('', 'Print', 'height=800,width=600');
	            mywindow.document.write('<html><head><title>' + this.state.locale.label + '</title>');
	            mywindow.document.write('</head><body >');
	            mywindow.document.write('<style type="text/css" >');
	            mywindow.document.write(this.printStyles());
	            mywindow.document.write('</style>');
	            mywindow.document.write('<p class="title">' + this.state.locale.label + '</p>');
	            if (appHelper.isDefined(this.state.locale.description) && this.state.locale.description.length > 0 && this.state.locale.description !== "<p><br></p>") {
	                mywindow.document.write('<p>' + this.state.locale.description + '</p>');
	            }
	
	            for (var a = 0; a < this.state.printableAssets.length; a++) {
	                var _asset = this.state.printableAssets[a];
	                mywindow.document.write('<div class="question-separator-container">');
	                if (_asset.show_title) {
	                    mywindow.document.write('<p class="question">' + _asset.locale.label + '</p>');
	                }
	
	                if (appHelper.isDefined(_asset.locale.description) && _asset.locale.description.length > 0 && _asset.locale.description !== "<p><br></p>") {
	                    mywindow.document.write('<p class="label">' + _asset.locale.description + '</p>');
	                }
	
	                for (var i = 0; i < _asset.renderedQuestions.length; i++) {
	                    var question = _asset.renderedQuestions[i];
	                    var qLocale = appHelper.getLocalData(question);
	                    mywindow.document.write('<p class="label"><strong>' + qLocale.prompt + '</strong></p>');
	                    if (question.response.length > 0) {
	                        mywindow.document.write('<div class="embedded-response">' + question.response + '</div>');
	                    } else {
	                        mywindow.document.write('<div class="embedded-response"><em>' + this.state.no_response_provided_label + '.</em></div>');
	                    }
	                }
	
	                mywindow.document.write('</div>');
	            }
	            mywindow.document.write('</body></html>');
	
	            mywindow.document.close();
	            mywindow.focus();
	            mywindow.print();
	            mywindow.close();
	
	            return true;
	        }
	    }, {
	        key: 'printStyles',
	        value: function printStyles() {
	            return '\n        @media print {\n            html, body {\n               font-family: \'Helvetica Neue\', Helvetica, Arial, san-serif;\n\t            line-height: 130%;\n\t            padding: 0;\n\t            font-size: 12px;\n\t            color: #333;\n            }\n            \n            .question-separator-container{\n            \n                padding: 20px 12px;\n                border-top: 1px solid #e5e5e5;\n            }\n            \n            .title{\n                text-align: center;\n                font-size: 16px;\n                font-family: Arial Rounded MT Bold, Helvetica Rounded, Arial, sans-serif;\n            }\n            \n            .question{\n                font-family: Arial Rounded MT Bold, Helvetica Rounded, Arial, sans-serif;\n                font-size: 14px;\n            }\n           \n            .label{\n                display: block;\n          \n                font-weight: bold;\n             \n            }\n            \n            .response{\n                padding: 0 0 0 20px;\n            }\n            \n            .embedded-response{\n              font-family: \'Helvetica Neue\', Helvetica, Arial, san-serif;\n                padding: 0 12px;\n            }\n        }';
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this3 = this;
	
	            return _react2.default.createElement(
	                'div',
	                { className: 'learner-action', ref: this.state.screenObject.asset_id + '_text' },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'question-wrapper' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'object-container' },
	                        this.state.screenObject.show_title && appHelper.isDefined(this.state.locale.label) && this.state.locale.label.length > 0 ? _react2.default.createElement('h4', { dangerouslySetInnerHTML: { __html: this.state.locale.label } }) : null,
	                        appHelper.isDefined(this.state.locale.description) && this.state.locale.description !== null && this.state.locale.description.length > 0 ? _react2.default.createElement('div', { dangerouslySetInnerHTML: { __html: this.state.locale.description } }) : null
	                    ),
	                    this.state.renderQuestions ? _react2.default.createElement(
	                        'div',
	                        null,
	                        this.state.printableAssets.map(function (asset) {
	                            return _react2.default.createElement(
	                                'div',
	                                { className: 'question-separator object-container', key: asset.asset_id },
	                                asset.show_title ? _react2.default.createElement('h4', { dangerouslySetInnerHTML: { __html: asset.locale.label } }) : null,
	                                appHelper.isDefined(asset.locale.description) && asset.locale.description.length > 0 && asset.locale.description !== "<p><br></p>" ? _react2.default.createElement('div', { dangerouslySetInnerHTML: { __html: asset.locale.description } }) : null,
	                                asset.renderedQuestions.map(function (question) {
	                                    return _react2.default.createElement(
	                                        'div',
	                                        { key: question.id },
	                                        _react2.default.createElement('br', null),
	                                        _react2.default.createElement('div', {
	                                            dangerouslySetInnerHTML: { __html: appHelper.getLocalData(question).prompt } }),
	                                        question.response.length > 0 ? _react2.default.createElement('div', { className: 'embedded-response',
	                                            dangerouslySetInnerHTML: { __html: question.response } }) : _react2.default.createElement(
	                                            'div',
	                                            { className: 'embedded-response' },
	                                            _react2.default.createElement(
	                                                'em',
	                                                null,
	                                                _this3.state.no_response_provided_label,
	                                                '.'
	                                            )
	                                        )
	                                    );
	                                })
	                            );
	                        }),
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'text-center' },
	                            _react2.default.createElement(
	                                'button',
	                                { className: 'btn btn-lg guroo-btn print-btn',
	                                    onClick: this.print },
	                                this.state.print_label
	                            )
	                        )
	                    ) : _react2.default.createElement(
	                        'div',
	                        { className: 'pl-circle content' },
	                        _react2.default.createElement('div', { className: 'pl-circle1 pl-child' }),
	                        _react2.default.createElement('div', { className: 'pl-circle2 pl-child' }),
	                        _react2.default.createElement('div', { className: 'pl-circle3 pl-child' }),
	                        _react2.default.createElement('div', { className: 'pl-circle4 pl-child' }),
	                        _react2.default.createElement('div', { className: 'pl-circle5 pl-child' }),
	                        _react2.default.createElement('div', { className: 'pl-circle6 pl-child' }),
	                        _react2.default.createElement('div', { className: 'pl-circle7 pl-child' }),
	                        _react2.default.createElement('div', { className: 'pl-circle8 pl-child' }),
	                        _react2.default.createElement('div', { className: 'pl-circle9 pl-child' }),
	                        _react2.default.createElement('div', { className: 'pl-circle10 pl-child' }),
	                        _react2.default.createElement('div', { className: 'pl-circle11 pl-child' }),
	                        _react2.default.createElement('div', { className: 'pl-circle12 pl-child' })
	                    )
	                ),
	                this.state.showProgressionButton && this.state.renderQuestions ? _react2.default.createElement(_Button2.default, { label: this.state.locale.progression_label,
	                    id: this.state.screenObject + '_button',
	                    onClick: this.onProgressionBtnClicked }) : null
	            );
	        }
	    }]);
	
	    return PrintResponses;
	}(_react2.default.Component);
	
	PrintResponses.propTypes = {
	    screenObject: _propTypes2.default.object.isRequired,
	    index: _propTypes2.default.number,
	    callbacks: _propTypes2.default.object.isRequired,
	    shortResponseQuestions: _propTypes2.default.array.isRequired,
	    characterPose: _propTypes2.default.object,
	    contentData: _propTypes2.default.object.isRequired,
	    trackingData: _propTypes2.default.object.isRequired,
	    userData: _propTypes2.default.object.isRequired,
	    lang: _propTypes2.default.string.isRequired,
	    actions: _propTypes2.default.object.isRequired
	};
	
	PrintResponses.contextTypes = {
	    router: _propTypes2.default.object
	};
	
	function mapStateToProps(state, ownProps) {
	    var lang = state.userData.lang;
	    return {
	        lang: lang,
	        shortResponseQuestions: state.userData.short_response_questions,
	        contentData: state.contentData,
	        trackingData: state.trackingData,
	        userData: state.userData
	    };
	}
	
	function mapDispatchToProps(dispatch) {
	    return {
	        actions: (0, _redux.bindActionCreators)(Object.assign({}, appDataActions, trackingDataActions), dispatch)
	    };
	}
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(PrintResponses);

/***/ },
/* 516 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(5);
	
	var _redux = __webpack_require__(4);
	
	var _Button = __webpack_require__(18);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _ResourceLinks = __webpack_require__(48);
	
	var _ResourceLinks2 = _interopRequireDefault(_ResourceLinks);
	
	var _ShortResponseTextArea = __webpack_require__(284);
	
	var _ShortResponseTextArea2 = _interopRequireDefault(_ShortResponseTextArea);
	
	var _ShortResponseQuestion = __webpack_require__(283);
	
	var _ShortResponseQuestion2 = _interopRequireDefault(_ShortResponseQuestion);
	
	var _ShortResponseFeedback = __webpack_require__(517);
	
	var _ShortResponseFeedback2 = _interopRequireDefault(_ShortResponseFeedback);
	
	var _appDataActions = __webpack_require__(12);
	
	var appDataActions = _interopRequireWildcard(_appDataActions);
	
	var _trackingDataActions = __webpack_require__(7);
	
	var trackingDataActions = _interopRequireWildcard(_trackingDataActions);
	
	var _userDataActions = __webpack_require__(20);
	
	var userDataActions = _interopRequireWildcard(_userDataActions);
	
	var _dialogPopupActions = __webpack_require__(19);
	
	var dialogPopupActions = _interopRequireWildcard(_dialogPopupActions);
	
	var _appConstants = __webpack_require__(13);
	
	var appConstants = _interopRequireWildcard(_appConstants);
	
	var _appHelper = __webpack_require__(3);
	
	var appHelper = _interopRequireWildcard(_appHelper);
	
	var _userDataHelper = __webpack_require__(15);
	
	var userDataHelper = _interopRequireWildcard(_userDataHelper);
	
	var _dataHelper = __webpack_require__(11);
	
	var dataHelper = _interopRequireWildcard(_dataHelper);
	
	var _xAPIHelper = __webpack_require__(86);
	
	var xAPIHelper = _interopRequireWildcard(_xAPIHelper);
	
	var _objectConstants = __webpack_require__(9);
	
	var objectConstants = _interopRequireWildcard(_objectConstants);
	
	var _assetConstants = __webpack_require__(33);
	
	var assetConstants = _interopRequireWildcard(_assetConstants);
	
	var _localStorage = __webpack_require__(17);
	
	var localStorage = _interopRequireWildcard(_localStorage);
	
	var _keyboardConstants = __webpack_require__(14);
	
	var keyboardConstants = _interopRequireWildcard(_keyboardConstants);
	
	var _componentConstants = __webpack_require__(49);
	
	var componentConstants = _interopRequireWildcard(_componentConstants);
	
	var _dialogModels = __webpack_require__(32);
	
	var _gsap = __webpack_require__(8);
	
	var _gsapReactPlugin = __webpack_require__(10);
	
	var _gsapReactPlugin2 = _interopRequireDefault(_gsapReactPlugin);
	
	var _lodash = __webpack_require__(28);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } //eslint-disable-line import/no-named-as-default
	
	
	var ShortResponse = function (_React$Component) {
	    _inherits(ShortResponse, _React$Component);
	
	    function ShortResponse(props, context) {
	        _classCallCheck(this, ShortResponse);
	
	        var _this = _possibleConstructorReturn(this, (ShortResponse.__proto__ || Object.getPrototypeOf(ShortResponse)).call(this, props, context));
	
	        _this.state = {
	            lang: _this.props.lang,
	            screenObject: _this.props.screenObject,
	            userData: _this.props.userData,
	            shortResponseQuestions: _this.props.shortResponseQuestions,
	            questionsRespondedTo: [],
	            kpis: [],
	            status: objectConstants.STATUS_NOT_STARTED,
	            locale: appHelper.getLocalData(_this.props.screenObject),
	            renderQuestions: false,
	            renderedQuestions: [],
	            displayInline: (_this.props.screenObject.respond_type === objectConstants.RESPOND_TYPE_INLINE || _this.props.screenObject.respond_type === objectConstants.RESPOND_TYPE_ELSEWHERE_IF_SCORM && _this.props.contentData.experience.tracking_type !== appConstants.TRACKING_TYPE_SCORM) && _this.props.contentData.experience.tracking_type !== appConstants.TRACKING_TYPE_SCORM,
	            submitted: false,
	            showFeedback: false,
	            feedbackViewed: false,
	            selfRate: _this.props.screenObject.assess_type !== objectConstants.ASSESSED_TYPE_NONE,
	            saveRating: _this.props.screenObject.assess_type === objectConstants.ASSESSED_TYPE_SCORED && appHelper.isDefined(appHelper.getBite(_this.props.callbacks.getBiteId()).score_kpi),
	            callbacks: {},
	            showProgressionButton: false,
	            assetData: {},
	            screenStatus: "",
	            checkComplete: false,
	            resourceLinks: [],
	            isResourceObject: appHelper.isDefined(_this.props.callbacks.checkIsResourceScreen) && _this.props.callbacks.checkIsResourceScreen(),
	            hasResources: false,
	            resourcesAreComplete: false,
	            allowScroll: appHelper.allowScroll(_this.props.callbacks.getBiteId(), _this.props.callbacks.getScreenId(), _this.props.screenObject.asset_id),
	            score_kpi: appHelper.getBite(_this.props.callbacks.getBiteId()).score_kpi,
	            userDataKpi: {},
	            kpi_user_rating: {
	                kpi_id: appHelper.isDefined(appHelper.getBite(_this.props.callbacks.getBiteId()).score_kpi) ? appHelper.getBite(_this.props.callbacks.getBiteId()).score_kpi.kpi_id : null,
	                value: null
	            },
	            checkPostXAPIResponse: false,
	            checkGetXAPIResponse: false,
	            currentAttempt: 1,
	            navigate: false,
	            submit_label: appHelper.getLocaleString("submit_label"),
	            continue_label: appHelper.getLocaleString("continue_label"),
	            complete_activity_label: appHelper.getLocaleString("complete_activity_label")
	        };
	        _this.handleProgression = _this.handleProgression.bind(_this);
	        _this.scrollToTop = _this.scrollToTop.bind(_this);
	        _this.onComplete = _this.onComplete.bind(_this);
	        _this.enableProgression = _this.enableProgression.bind(_this);
	        _this.disableProgression = _this.disableProgression.bind(_this);
	        _this.show = _this.show.bind(_this);
	        _this.onShowComplete = _this.onShowComplete.bind(_this);
	        _this.onProgressionBtnClicked = _this.onProgressionBtnClicked.bind(_this);
	        _this.getScreenStatus = _this.getScreenStatus.bind(_this);
	        _this.getObjectStatus = _this.getObjectStatus.bind(_this);
	        _this.onResourcesComplete = _this.onResourcesComplete.bind(_this);
	        _this.setResources = _this.setResources.bind(_this);
	        _this.onRendered = _this.onRendered.bind(_this);
	        _this.setRenderedQuestions = _this.setRenderedQuestions.bind(_this);
	        _this.setCallbacks = _this.setCallbacks.bind(_this);
	        _this.updateField = _this.updateField.bind(_this);
	        _this.onSubmit = _this.onSubmit.bind(_this);
	        _this.editResponses = _this.editResponses.bind(_this);
	        _this.onContinue = _this.onContinue.bind(_this);
	        _this.scrollToFeedback = _this.scrollToFeedback.bind(_this);
	        _this.setStatusClass = _this.setStatusClass.bind(_this);
	        _this.onFeedbackComplete = _this.onFeedbackComplete.bind(_this);
	        _this.storeUserResponse = _this.storeUserResponse.bind(_this);
	        _this.storeUserShortResponses = _this.storeUserResponse.bind(_this);
	        _this.onPanelClick = _this.onPanelClick.bind(_this);
	        _this.onReviewObject = _this.onReviewObject.bind(_this);
	        _this.postXAPIResponse = _this.postXAPIResponse.bind(_this);
	        _this.getXAPIResponse = _this.getXAPIResponse.bind(_this);
	        _this.updateUserRating = _this.updateUserRating.bind(_this);
	        _this.onPanelClickByKeyboardAccessibility = _this.onPanelClickByKeyboardAccessibility.bind(_this);
	        _this.editResponsesOnKeyboardAccessibility = _this.editResponsesOnKeyboardAccessibility.bind(_this);
	        _this.setKeyboardAcessibility = _this.setKeyboardAcessibility.bind(_this);
	        _this.getPreviousResponse = _this.getPreviousResponse.bind(_this);
	        _this.getNextResponse = _this.getNextResponse.bind(_this);
	        _this.updateSumbission = _this.updateSumbission.bind(_this);
	        _this.handleNoFeedback = _this.handleNoFeedback.bind(_this);
	        _this.getImagePath = _this.getImagePath.bind(_this);
	        return _this;
	    }
	
	    _createClass(ShortResponse, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            this.setCallbacks();
	
	            this.setRenderedQuestions();
	            this.setResources();
	            this.getScreenStatus();
	            this.show();
	
	            if (appHelper.isDefined(this.props.callbacks.updateCharacterExpression) && appHelper.isDefined(this.state.screenObject.character_pose)) {
	                this.props.callbacks.updateCharacterExpression(this.state.screenObject.character_pose);
	            }
	        }
	    }, {
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(nextProps) {
	            if (this.state.userData !== nextProps.userData) {
	                this.setState({ userData: Object.assign({}, nextProps.userData) });
	            }
	            if (this.state.shortResponseQuestions !== nextProps.shortResponseQuestions) {
	                this.setState({ shortResponseQuestions: Object.assign([], nextProps.shortResponseQuestions) });
	            }
	
	            if (this.state.lang !== nextProps.lang) {
	                this.setState({
	                    lang: nextProps.lang,
	                    locale: appHelper.getLocalData(this.state.screenObject),
	                    submit_label: appHelper.getLocaleString("submit_label"),
	                    continue_label: appHelper.getLocaleString("continue_label"),
	                    complete_activity_label: appHelper.getLocaleString("complete_activity_label")
	                });
	            }
	        }
	    }, {
	        key: 'componentDidUpdate',
	        value: function componentDidUpdate() {
	            if (this.state.checkComplete) {
	
	                this.onComplete();
	            }
	            if (this.state.checkPostXAPIResponse) {
	                this.postXAPIResponse();
	            }
	
	            if (this.state.checkGetXAPIResponse) {
	                this.getXAPIResponse();
	            }
	        }
	    }, {
	        key: 'postXAPIResponse',
	        value: function postXAPIResponse() {
	            this.setState({ checkPostXAPIResponse: false });
	            var voidCompleteRecords = true;
	            var parentScreen = this.props.callbacks.getSubScreenParent();
	            var params = {
	                renderedQuestions: this.state.renderedQuestions,
	                userData: this.state.userData,
	                bite_id: this.props.callbacks.getBiteId(),
	                screen_id: this.props.callbacks.getScreenId(),
	                parent_screen_id: appHelper.isDefined(parentScreen) ? parentScreen.screen_id : undefined,
	                asset_id: this.state.screenObject.asset_id,
	                currentAttempt: 1,
	                kpi_user_rating: this.state.kpi_user_rating
	            };
	            var interactionDataArray = xAPIHelper.setShortResponseInteractions(this.state.screenObject, params);
	            if (localStorage.tracking_type === appConstants.TRACKING_TYPE_XAPI || localStorage.tracking_type === appConstants.TRACKING_TYPE_BLENDED_XAPI_SCORM_1_2) {
	                for (var i = 0; i < interactionDataArray.length; i++) {
	                    var interactionData = interactionDataArray[i];
	                    var screen = appHelper.getScreenByAssetId(this.state.screenObject.asset_id);
	                    var category = {
	                        constant: componentConstants.SHORT_RESPONSE,
	                        label: componentConstants.SHORT_RESPONSE_LABEL
	                    };
	                    this.props.actions.postActvityStatement(screen, interactionData, category, voidCompleteRecords);
	                }
	            }
	        }
	    }, {
	        key: 'getXAPIResponse',
	        value: function getXAPIResponse() {
	            var _this2 = this;
	
	            this.setState({ checkGetXAPIResponse: false });
	            if (localStorage.tracking_type === appConstants.TRACKING_TYPE_XAPI || localStorage.tracking_type === appConstants.TRACKING_TYPE_BLENDED_XAPI_SCORM_1_2) {
	                (function () {
	                    var renderedQuestions = Object.assign([], _this2.state.renderedQuestions);
	                    var returnedResponses = 0;
	                    var parentScreen = _this2.props.callbacks.getSubScreenParent();
	                    var params = {
	                        renderedQuestions: _this2.state.renderedQuestions,
	                        bite_id: _this2.props.callbacks.getBiteId(),
	                        screen_id: _this2.props.callbacks.getScreenId(),
	                        parent_screen_id: appHelper.isDefined(parentScreen) ? parentScreen.screen_id : undefined,
	                        asset_id: _this2.state.screenObject.asset_id
	                    };
	
	                    var interactionDataArray = xAPIHelper.getShortResponseIds(_this2.state.screenObject, params);
	
	                    for (var i = 0; i < interactionDataArray.length; i++) {
	                        var interactionData = interactionDataArray[i];
	                        _this2.props.actions.getActvityStatement(interactionData).then(function (responseObj) {
	                            if (appHelper.isDefined(responseObj.statement)) {
	                                var response = responseObj.statement.result.response;
	                                var responseQuestion = appHelper.getArrayObjectByKey(renderedQuestions, "id", responseObj.id);
	                                var responseQuestionIndex = appHelper.getArrayObjectIndexByKey(renderedQuestions, "id", responseObj.id);
	                                responseQuestion = Object.assign({}, responseQuestion, {
	                                    response: response
	                                });
	
	                                renderedQuestions = dataHelper.immutableSplice(renderedQuestions, responseQuestionIndex, 1, responseQuestion);
	                                returnedResponses++;
	                                if (returnedResponses === renderedQuestions.length) {
	                                    _this2.setState({
	                                        renderedQuestions: Object.assign([], renderedQuestions),
	                                        renderQuestions: true
	                                    });
	                                }
	                            } else {
	                                _this2.setState({ renderQuestions: true });
	                            }
	                        }).catch(function (error) {});
	                    }
	                })();
	            }
	        }
	    }, {
	        key: 'updateUserRating',
	        value: function updateUserRating(kpi_user_rating) {
	            this.setState({ kpi_user_rating: Object.assign({}, kpi_user_rating) });
	        }
	    }, {
	        key: 'setCallbacks',
	        value: function setCallbacks() {
	            this.setState({
	                callbacks: Object.assign({}, this.props.callbacks, {
	                    updateField: this.updateField,
	                    updateUserRating: this.updateUserRating
	                })
	            });
	        }
	    }, {
	        key: 'updateField',
	        value: function updateField(data) {
	            var question = appHelper.getArrayObjectByKey(this.state.renderedQuestions, "id", data.id);
	            var questionIndex = appHelper.getArrayObjectIndexByKey(this.state.renderedQuestions, "id", data.id);
	            question = Object.assign({}, question, {
	                response: data.response
	            });
	            var updatedQuestions = dataHelper.immutableSplice(this.state.renderedQuestions, questionIndex, 1, question);
	            this.setState({ renderedQuestions: Object.assign([], updatedQuestions) });
	        }
	    }, {
	        key: 'setRenderedQuestions',
	        value: function setRenderedQuestions() {
	            var renderedQuestions = [];
	            var allQuestions = Object.assign([], this.state.shortResponseQuestions);
	            _lodash2.default.forEach(this.state.screenObject.questions, function (question) {
	                var questionData = appHelper.getArrayObjectByKey(allQuestions, "id", question.id);
	
	                if (appHelper.isDefined(questionData.id)) {
	                    renderedQuestions = dataHelper.immutablePush(renderedQuestions, questionData);
	                }
	            });
	
	            this.setState({
	                renderQuestions: localStorage.tracking_type !== appConstants.TRACKING_TYPE_XAPI && localStorage.tracking_type !== appConstants.TRACKING_TYPE_BLENDED_XAPI_SCORM_1_2,
	                renderedQuestions: Object.assign([], renderedQuestions),
	                checkGetXAPIResponse: true
	            });
	        }
	    }, {
	        key: 'setResources',
	        value: function setResources() {
	            var resourceLinks = appHelper.setResourceLinks(this.state.screenObject);
	            var hasRequiredResources = appHelper.hasRequiredResources(resourceLinks);
	
	            this.setState({
	                resourceLinks: Object.assign([], resourceLinks),
	                hasResources: resourceLinks.length > 0,
	                resourcesAreComplete: resourceLinks.length === 0 || !hasRequiredResources
	            });
	        }
	    }, {
	        key: 'getScreenStatus',
	        value: function getScreenStatus() {
	            var screenStatus = this.props.callbacks.getScreenStatus();
	            this.setState({
	                screenStatus: screenStatus,
	                status: screenStatus === objectConstants.STATUS_COMPLETE ? objectConstants.STATUS_COMPLETE : this.state.status,
	                submitted: screenStatus === objectConstants.STATUS_COMPLETE,
	                feedbackViewed: screenStatus === objectConstants.STATUS_COMPLETE
	            });
	        }
	    }, {
	        key: 'getObjectStatus',
	        value: function getObjectStatus() {
	            if (this.state.screenStatus === objectConstants.STATUS_COMPLETE) {
	
	                this.onComplete();
	            } else {
	                var objectUserData = {};
	                if (this.state.status !== objectConstants.STATUS_COMPLETE) {
	                    var subScreenParent = this.props.callbacks.getSubScreenParent();
	                    var screen_id = this.props.callbacks.getScreenId();
	                    if (appHelper.isDefined(subScreenParent)) {
	                        objectUserData = userDataHelper.getSubScreenObjectStatus(this.state.userData, subScreenParent.screen_id, screen_id, this.state.screenObject.asset_id);
	                    } else if (this.state.isResourceObject) {
	                        objectUserData = userDataHelper.getResourceScreenObjectUserData(this.state.userData, screen_id, this.state.screenObject.asset_id);
	                    } else {
	                        objectUserData = userDataHelper.getObjectStatus(this.state.userData, screen_id, this.state.screenObject.asset_id);
	                    }
	                }
	                if (objectUserData.status === objectConstants.STATUS_COMPLETE) {
	                    this.setState({
	                        status: objectConstants.STATUS_COMPLETE,
	                        submitted: true,
	                        checkComplete: true,
	                        feedbackViewed: true
	                    });
	                }
	            }
	        }
	    }, {
	        key: 'show',
	        value: function show() {
	            this.scrollToTop();
	            var optionRef = this.refs[this.state.screenObject.asset_id + '_question'];
	            _gsap.TweenLite.set(optionRef, { height: "auto" });
	            _gsap.TweenLite.from(optionRef, objectConstants.SHOW_PANEL_DURATION, {
	                height: 0,
	                ease: _gsap.Expo.easeInOut
	            }).eventCallback("onComplete", this.getObjectStatus);
	        }
	    }, {
	        key: 'onRendered',
	        value: function onRendered() {
	            if (this.state.isResourceObject) {
	                this.props.callbacks.onObjectRendered();
	            }
	            this.getObjectStatus();
	        }
	    }, {
	        key: 'onShowComplete',
	        value: function onShowComplete() {
	            this.setState({ isVisible: true, checkComplete: false });
	        }
	    }, {
	        key: 'scrollToTop',
	        value: function scrollToTop() {
	            if (this.state.allowScroll && this.state.status !== objectConstants.STATUS_COMPLETE) {
	                var question = this.refs[this.state.screenObject.asset_id + '_question'];
	                var scrollTo = this.props.callbacks.scrollTo;
	
	                setTimeout(function () {
	                    if (appHelper.isDefined(scrollTo)) {
	                        scrollTo(question.offsetTop);
	                    }
	                }, objectConstants.SCROLL_TO);
	            }
	        }
	    }, {
	        key: 'onComplete',
	        value: function onComplete() {
	            this.setState({ checkComplete: false });
	            var hasNextObject = this.props.callbacks.hasNextObject(this.props.index);
	            if (this.state.resourcesAreComplete) {
	                if (appHelper.isDefined(this.state.screenObject.progression) && this.state.screenObject.progression === objectConstants.OBJECT_PROGRESSION_CONTINUE && (this.state.status !== objectConstants.STATUS_COMPLETE || !hasNextObject)) {
	                    if (this.state.screenObject.feedback_type === objectConstants.FEEDBACK_TYPE_NO_FEEDBACK && this.props.callbacks.getScreenStatus() !== objectConstants.STATUS_COMPLETE) {
	                        //this.handleProgression();
	                        this.enableProgression();
	                    } else {
	                        if (!hasNextObject && !this.state.isResourceObject) {
	                            //console.log('progression 1')
	                            this.handleProgression();
	                        } else if (!hasNextObject && this.state.isResourceObject) {
	                            this.handleProgression();
	                        } else if (this.state.isResourceObject) {
	                            this.handleProgression();
	                        } else {
	                            //this.enableProgression();
	                            this.handleProgression();
	                        }
	                    }
	                } else {
	                    if (this.state.screenObject.feedback_type === objectConstants.FEEDBACK_TYPE_NO_FEEDBACK) {
	                        if (appHelper.isDefined(this.state.screenObject.progression) && this.state.screenObject.progression === objectConstants.OBJECT_PROGRESSION_CONTINUE && this.props.callbacks.getScreenStatus() !== objectConstants.STATUS_COMPLETE || !hasNextObject && this.props.callbacks.getScreenStatus() !== objectConstants.STATUS_COMPLETE) {
	                            //this.handleProgression();
	                            if (this.state.displayInline) {
	                                this.enableProgression();
	                            } else {
	                                this.handleProgression();
	                            }
	                        } else {
	                            this.handleNoFeedback();
	                        }
	                        //this.handleProgression();
	                    } else {
	                        this.handleProgression();
	                    }
	                }
	            }
	            this.scrollToTop();
	        }
	    }, {
	        key: 'enableProgression',
	        value: function enableProgression() {
	            if (!this.props.callbacks.isReviewMode()) {
	                // console.log('i am getting here',this.props.callbacks.getScreenStatus());
	                this.setState({ showProgressionButton: true });
	            }
	        }
	    }, {
	        key: 'handleNoFeedback',
	        value: function handleNoFeedback() {
	            this.setState({ status: objectConstants.STATUS_COMPLETE });
	            //this.handleProgression();
	            var handleProgression = this.handleProgression;
	            var navigateToNextScreen = this.props.callbacks.navigateToNextScreen;
	            setTimeout(function () {
	                handleProgression();
	                // navigateToNextScreen();
	            }, 500);
	        }
	    }, {
	        key: 'disableProgression',
	        value: function disableProgression() {
	            this.setState({ showProgressionButton: false });
	        }
	    }, {
	        key: 'handleProgression',
	        value: function handleProgression() {
	            var progressionRule = this.state.screenObject.progression;
	            var progressionType = appHelper.isDefined(this.state.screenObject.progression_type) ? this.state.screenObject.progression_type : undefined;
	            var progressionGoToId = appHelper.isDefined(this.state.screenObject.progression_goto_id) ? this.state.screenObject.progression_goto_id : undefined;
	            var completionData = {
	                progression: progressionRule,
	                progressionType: progressionType,
	                progressionGoToId: progressionGoToId,
	                asset_id: this.state.screenObject.asset_id,
	                status: objectConstants.STATUS_COMPLETE,
	                showProgressionButton: !this.props.callbacks.hasNextObject(this.props.index) && this.props.callbacks.getScreenStatus() === objectConstants.STATUS_COMPLETE && this.state.screenObject.progress !== objectConstants.OBJECT_PROGRESSION_CONTINUE,
	                asset_type_code: this.state.screenObject.asset_type_code,
	                navigateToNextScreen: this.props.callbacks.getScreenStatus() !== objectConstants.STATUS_COMPLETE && !this.state.navigate,
	                index: this.props.index
	            };
	
	            this.props.callbacks.onObjectComplete(completionData);
	
	            if (!this.props.callbacks.hasNextObject(this.props.index) && this.props.callbacks.getScreenStatus() !== objectConstants.STATUS_COMPLETE) {
	                //this.props.callbacks.navigateToNextScreen();
	                var navigateToNextScreen = this.props.callbacks.navigateToNextScreen;
	                setTimeout(function () {
	                    navigateToNextScreen();
	                }, 1000);
	            }
	            /*if(appHelper.isDefined(this.state.screenObject.progression) && this.state.screenObject.progression === objectConstants.OBJECT_PROGRESSION_AUTO){
	                 let navigateToNextScreen = this.props.callbacks.navigateToNextScreen;
	                      navigateToNextScreen();
	                },1000);
	            }*/
	        }
	    }, {
	        key: 'onProgressionBtnClicked',
	        value: function onProgressionBtnClicked(event) {
	            if (appHelper.isDefined(event)) {
	                event.stopPropagation();
	            }
	
	            this.setState({ showProgressionButton: false, navigate: true });
	            if (this.props.callbacks.hasNextObject(this.props.index) || this.state.isResourceObject) {
	                this.handleProgression();
	            } else {
	
	                this.handleProgression();
	                //this.props.callbacks.navigateToNextScreen();
	
	                var navigateToNextScreen = this.props.callbacks.navigateToNextScreen;
	                setTimeout(function () {
	                    navigateToNextScreen();
	                }, 500);
	            }
	        }
	    }, {
	        key: 'onResourcesComplete',
	        value: function onResourcesComplete() {
	            if (!this.state.resourcesAreComplete) {
	                this.setState({ resourcesAreComplete: true, checkComplete: true });
	            }
	        }
	    }, {
	        key: 'onSubmit',
	        value: function onSubmit(event) {
	            var _this3 = this;
	
	            if (appHelper.isDefined(event)) {
	                event.stopPropagation();
	            }
	            var userDataKpi = {};
	            if (appHelper.isDefined(this.state.score_kpi) && appHelper.isDefined(this.state.score_kpi.kpi_id)) {
	                var userBite = appHelper.getArrayObjectByKey(this.state.userData.bites, "bite_id", this.props.callbacks.getBiteId());
	                var userDataKpis = appHelper.getArrayObjectByKey(userBite.kpis, "kpi_id", this.state.score_kpi.kpi_id);
	                if (appHelper.isDefined(userDataKpis)) {
	                    userDataKpi = appHelper.getArrayObjectByKey(userDataKpis.history, "asset_id", this.state.screenObject.asset_id);
	                }
	            }
	
	            var params = {
	                userData: this.state.userData,
	                bite_id: this.props.callbacks.getBiteId(),
	                screen_id: this.props.callbacks.getScreenId(),
	                parent_screen_id: appHelper.isDefined(this.props.callbacks.getSubScreenParent()) ? this.props.callbacks.getSubScreenParent().screen_id : undefined,
	                asset_id: this.state.screenObject.asset_id,
	                kpis: appHelper.isDefined(userDataKpi) && this.state.saveRating ? [{
	                    kpi_id: appHelper.isDefined(this.state.score_kpi) && appHelper.isDefined(this.state.score_kpi.kpi_id) ? this.state.score_kpi.kpi_id : null,
	                    value: appHelper.isDefined(userDataKpi) && appHelper.isDefined(userDataKpi.statusIndicatorClass) && !isNaN(userDataKpi.statusIndicatorClass.value) ? userDataKpi.statusIndicatorClass.value : null
	                }] : []
	            };
	
	            if (localStorage.tracking_type !== appConstants.TRACKING_TYPE_XAPI && localStorage.tracking_type !== appConstants.TRACKING_TYPE_BLENDED_XAPI_SCORM_1_2) {
	                this.updateSumbission();
	
	                this.props.actions.storeUserResponse(params).then(function (userData) {
	
	                    _this3.props.actions.setSuspendData(userData).then(function (suspendData) {
	                        var params_2 = {
	                            userData: userData,
	                            answeredQuestions: _this3.state.renderedQuestions
	                        };
	
	                        _this3.props.actions.storeUserShortResponses(params_2).then(function (userData) {
	
	                            _this3.props.actions.setSuspendData(userData).then(function (suspendData) {
	                                //this.updateSumbission();
	
	
	                            }).catch(function (error) {});
	                        }).catch(function (error) {});
	                    }).catch(function (error) {});
	                }).catch(function (error) {});
	            } else {
	                var showFeedback = this.state.screenObject.feedback_type === objectConstants.FEEDBACK_TYPE_INCLUDE;
	
	                this.setState({
	                    submitted: true,
	                    showFeedback: showFeedback && !this.state.feedbackViewed,
	                    checkPostXAPIResponse: !showFeedback || this.state.status === objectConstants.STATUS_COMPLETE,
	                    checkComplete: !showFeedback && this.state.status !== objectConstants.STATUS_COMPLETE,
	                    status: !showFeedback || this.state.status === objectConstants.STATUS_COMPLETE ? objectConstants.STATUS_COMPLETE : objectConstants.STATUS_IN_PROGRESS
	                });
	            }
	        }
	    }, {
	        key: 'updateSumbission',
	        value: function updateSumbission() {
	            var showFeedback = this.state.screenObject.feedback_type === objectConstants.FEEDBACK_TYPE_INCLUDE;
	
	            this.setState({
	                submitted: true,
	                showFeedback: showFeedback && !this.state.feedbackViewed,
	                checkPostXAPIResponse: !showFeedback,
	                checkComplete: !showFeedback && this.state.status !== objectConstants.STATUS_COMPLETE,
	                status: !showFeedback || this.state.status === objectConstants.STATUS_COMPLETE ? objectConstants.STATUS_COMPLETE : objectConstants.STATUS_IN_PROGRESS
	            });
	        }
	    }, {
	        key: 'storeUserResponse',
	        value: function storeUserResponse() {
	            var _this4 = this;
	
	            var params = {
	                userData: this.state.userData,
	                bite_id: this.props.callbacks.getBiteId(),
	                screen_id: this.props.callbacks.getScreenId(),
	                parent_screen_id: appHelper.isDefined(this.props.callbacks.getSubScreenParent()) ? this.props.callbacks.getSubScreenParent().screen_id : undefined,
	                asset_id: this.state.screenObject.asset_id,
	                kpis: []
	            };
	
	            this.props.actions.storeUserResponse(params).then(function (userData) {
	                _this4.props.actions.setSuspendData(userData).then(function (suspendData) {
	                    _this4.storeUserShortResponses();
	                }).catch(function (error) {});
	            }).catch(function (error) {});
	        }
	    }, {
	        key: 'storeUserShortResponses',
	        value: function storeUserShortResponses() {
	            var _this5 = this;
	
	            var params = {
	                userData: this.state.userData,
	                answeredQuestions: this.state.renderedQuestions
	            };
	
	            this.props.actions.storeUserShortResponses(params).then(function (userData) {
	                _this5.props.actions.setSuspendData(userData).then(function (suspendData) {
	
	                    var showFeedback = _this5.state.screenObject.feedback_type === objectConstants.FEEDBACK_TYPE_INCLUDE;
	                    _this5.setState({
	                        submitted: true,
	                        showFeedback: showFeedback,
	                        checkComplete: !showFeedback,
	                        status: !showFeedback || _this5.state.status === objectConstants.STATUS_COMPLETE ? objectConstants.STATUS_COMPLETE : objectConstants.STATUS_IN_PROGRESS
	                    });
	                }).catch(function (error) {});
	            }).catch(function (error) {});
	        }
	    }, {
	        key: 'editResponses',
	        value: function editResponses(event) {
	            if (appHelper.isDefined(event)) {
	                event.stopPropagation();
	            }
	            this.setState({ submitted: false, currentAttempt: this.state.currentAttempt + 1 });
	        }
	    }, {
	        key: 'onContinue',
	        value: function onContinue(event) {
	            if (appHelper.isDefined(event)) {
	                event.stopPropagation();
	            }
	            this.setState({ status: objectConstants.STATUS_COMPLETE, showFeedback: false });
	            this.onProgressionBtnClicked(event);
	        }
	    }, {
	        key: 'scrollToFeedback',
	        value: function scrollToFeedback(feedbackPos) {
	            var question = this.refs[this.state.screenObject.asset_id + '_question'];
	            this.props.callbacks.scrollTo(question.offsetTop + feedbackPos);
	        }
	    }, {
	        key: 'setStatusClass',
	        value: function setStatusClass() {
	            return this.state.status === objectConstants.STATUS_COMPLETE ? "complete" : "";
	        }
	    }, {
	        key: 'onFeedbackComplete',
	        value: function onFeedbackComplete() {
	            this.setState({
	                status: objectConstants.STATUS_COMPLETE,
	                showFeedback: false,
	                feedbackViewed: true,
	                checkPostXAPIResponse: true,
	                checkComplete: true
	            });
	        }
	    }, {
	        key: 'onPanelClick',
	        value: function onPanelClick() {
	            if (this.state.status === objectConstants.STATUS_COMPLETE && this.state.submitted) {
	                this.onReviewObject();
	            }
	        }
	    }, {
	        key: 'onReviewObject',
	        value: function onReviewObject() {
	            var userDataKpi = {};
	            if (appHelper.isDefined(this.state.score_kpi) && appHelper.isDefined(this.state.score_kpi.kpi_id)) {
	                var userBite = appHelper.getArrayObjectByKey(this.state.userData.bites, "bite_id", this.props.callbacks.getBiteId());
	                var userDataKpis = appHelper.getArrayObjectByKey(userBite.kpis, "kpi_id", this.state.score_kpi.kpi_id);
	                if (appHelper.isDefined(userDataKpis)) {
	                    userDataKpi = appHelper.getArrayObjectByKey(userDataKpis.history, "asset_id", this.state.screenObject.asset_id);
	                }
	            }
	
	            var config = Object.assign({}, _dialogModels.SHORT_ANSWER_REVIEW_CONFIG, {
	                title: this.state.locale.label,
	                sourceId: 'object_' + this.state.screenObject.asset_id
	            });
	            //locale.title
	
	            for (var i = 0; i < config.childComponents.length; i++) {
	                var child = config.childComponents[i];
	                child.componentProps = Object.assign({}, {
	                    screenObject: this.state.screenObject,
	                    responseData: {
	                        bite_id: this.props.callbacks.getBiteId(),
	                        screen_id: this.props.callbacks.getScreenId(),
	                        object_id: this.state.screenObject.asset_id,
	                        asset_id: this.state.screenObject.asset_id,
	                        currentAttempt: 1,
	                        currentStatus: objectConstants.STATUS_COMPLETE,
	                        displayState: objectConstants.OBJECT_DISPLAY_STATE_REVIEW,
	                        kpis: [{
	                            kpi_id: appHelper.isDefined(this.state.score_kpi) && appHelper.isDefined(this.state.score_kpi.kpi_id) ? this.state.score_kpi.kpi_id : null,
	                            value: appHelper.isDefined(userDataKpi) && appHelper.isDefined(userDataKpi.statusIndicatorClass) && !isNaN(userDataKpi.statusIndicatorClass.value) ? userDataKpi.statusIndicatorClass.value : null
	                        }]
	                    },
	                    callbacks: this.props.callbacks
	                });
	            }
	            this.props.actions.setNewDialog(config);
	        }
	    }, {
	        key: 'onPanelClickByKeyboardAccessibility',
	        value: function onPanelClickByKeyboardAccessibility(event) {
	
	            if (event.which === keyboardConstants.ENTER_KEY || event.which === keyboardConstants.SPACEBAR_KEY) {
	                //event.preventDefault();
	                event.stopPropagation();
	                this.onPanelClick();
	            }
	        }
	    }, {
	        key: 'editResponsesOnKeyboardAccessibility',
	        value: function editResponsesOnKeyboardAccessibility(event) {
	
	            if (event.which === keyboardConstants.ENTER_KEY || event.which === keyboardConstants.SPACEBAR_KEY) {
	                //event.preventDefault();
	                event.stopPropagation();
	                this.setState({ submitted: false, currentAttempt: this.state.currentAttempt + 1 });
	                var focusEl = document.getElementById('object_' + this.state.screenObject.asset_id);
	                if (appHelper.isDefined(focusEl)) {
	                    focusEl.focus();
	                }
	            }
	        }
	    }, {
	        key: 'setKeyboardAcessibility',
	        value: function setKeyboardAcessibility(event) {
	
	            var idArray = event.target.id.split('short_response_');
	            var id = parseInt(idArray[1]);
	            if (appHelper.isDefined(event)) {
	                if (event.which === keyboardConstants.ARROW_UP_KEY) {
	                    event.preventDefault();
	                    this.getPreviousResponse(id);
	                }
	                if (event.which === keyboardConstants.ARROW_DOWN_KEY) {
	                    event.preventDefault();
	                    this.getNextResponse(id);
	                }
	                if (event.which === keyboardConstants.ARROW_LEFT_KEY) {
	                    event.preventDefault();
	                    this.getPreviousResponse(id);
	                }
	                if (event.which === keyboardConstants.ARROW_RIGHT_KEY) {
	                    event.preventDefault();
	                    this.getNextResponse(id);
	                }
	            }
	        }
	    }, {
	        key: 'getPreviousResponse',
	        value: function getPreviousResponse(targetId) {
	            var responseIndex = appHelper.getArrayObjectIndexByKey(this.state.renderedQuestions, "id", targetId);
	            var nextResponse = this.state.renderedQuestions[responseIndex - 1];
	            if (responseIndex <= 0) {
	                nextResponse = this.state.renderedQuestions[this.state.renderedQuestions.length - 1];
	            }
	
	            var focusEl = document.getElementById('short_response_' + nextResponse.id);
	            focusEl.focus();
	        }
	    }, {
	        key: 'getNextResponse',
	        value: function getNextResponse(targetId) {
	            var responseIndex = appHelper.getArrayObjectIndexByKey(this.state.renderedQuestions, "id", targetId);
	            var nextResponse = this.state.renderedQuestions[responseIndex + 1];
	            if (responseIndex === this.state.renderedQuestions.length - 1) {
	                nextResponse = this.state.renderedQuestions[0];
	            }
	            var focusEl = document.getElementById('short_response_' + nextResponse.id);
	            focusEl.focus();
	        }
	    }, {
	        key: 'getImagePath',
	        value: function getImagePath(image) {
	            if (appConstants.DEVELOPMENT_MODE) {
	                if (appHelper.isDefined(image) && image.length > 0) {
	                    return __webpack_require__(16)("./" + image);
	                }
	            } else {
	                return image;
	            }
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this6 = this;
	
	            return _react2.default.createElement(
	                'div',
	                { className: 'learner-action', ref: this.state.screenObject.asset_id + '_question' },
	                appHelper.isDefined(this.props.characterPose) && appHelper.isDefined(this.props.characterPose.src) && this.props.characterPose.src.length > 0 ? _react2.default.createElement(
	                    'div',
	                    { className: 'content-character-expression' },
	                    _react2.default.createElement('img', { src: this.getImagePath(this.props.characterPose.src), alt: '' })
	                ) : null,
	                _react2.default.createElement(
	                    'div',
	                    { className: 'question-wrapper short-response   ' + this.setStatusClass(),
	                        onClick: this.onPanelClick, onKeyDown: this.onPanelClickByKeyboardAccessibility, tabIndex: 0,
	                        role: 'link' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'object-container' },
	                        this.state.screenObject.show_title ? _react2.default.createElement('h4', { dangerouslySetInnerHTML: { __html: this.state.locale.label } }) : null,
	                        appHelper.isDefined(this.state.locale.description) && this.state.locale.description !== null && this.state.locale.description.length > 0 && this.state.locale.description !== "<p><br></p>" ? _react2.default.createElement('div', { dangerouslySetInnerHTML: { __html: this.state.locale.description } }) : null,
	                        this.state.hasResources ? _react2.default.createElement(
	                            'div',
	                            null,
	                            _react2.default.createElement('br', null),
	                            _react2.default.createElement(_ResourceLinks2.default, { resources: this.state.resourceLinks,
	                                onResourcesComplete: this.onResourcesComplete })
	                        ) : null,
	                        _react2.default.createElement('br', null),
	                        this.state.renderQuestions ? this.state.renderedQuestions.map(function (question) {
	                            return _react2.default.createElement(
	                                'div',
	                                { key: question.id, id: 'short_response_' + question.id, role: 'link',
	                                    tabIndex: '0', onKeyDown: _this6.setKeyboardAcessibility },
	                                _this6.state.displayInline ? _react2.default.createElement(_ShortResponseTextArea2.default, { parentObject: _this6.state.screenObject,
	                                    screenObject: question,
	                                    callbacks: _this6.state.callbacks,
	                                    submitted: _this6.state.submitted
	                                }) : _react2.default.createElement(_ShortResponseQuestion2.default, { parentObject: _this6.state.screenObject,
	                                    screenObject: question,
	                                    callbacks: _this6.state.callbacks })
	                            );
	                        }) : _react2.default.createElement(
	                            'div',
	                            { className: 'pl-circle content' },
	                            _react2.default.createElement('div', { className: 'pl-circle1 pl-child' }),
	                            _react2.default.createElement('div', { className: 'pl-circle2 pl-child' }),
	                            _react2.default.createElement('div', { className: 'pl-circle3 pl-child' }),
	                            _react2.default.createElement('div', { className: 'pl-circle4 pl-child' }),
	                            _react2.default.createElement('div', { className: 'pl-circle5 pl-child' }),
	                            _react2.default.createElement('div', { className: 'pl-circle6 pl-child' }),
	                            _react2.default.createElement('div', { className: 'pl-circle7 pl-child' }),
	                            _react2.default.createElement('div', { className: 'pl-circle8 pl-child' }),
	                            _react2.default.createElement('div', { className: 'pl-circle9 pl-child' }),
	                            _react2.default.createElement('div', { className: 'pl-circle10 pl-child' }),
	                            _react2.default.createElement('div', { className: 'pl-circle11 pl-child' }),
	                            _react2.default.createElement('div', { className: 'pl-circle12 pl-child' })
	                        ),
	                        !this.state.submitted && this.state.displayInline ? _react2.default.createElement(_Button2.default, { label: this.state.submit_label,
	                            id: this.state.screenObject.asset_id + '_button',
	                            onClick: this.onSubmit }) : null,
	                        this.state.showProgressionButton && this.state.displayInline ? _react2.default.createElement(_Button2.default, { label: this.state.continue_label,
	                            id: this.state.screenObject + '_button',
	                            onClick: this.onProgressionBtnClicked }) : null,
	                        this.state.status === objectConstants.STATUS_COMPLETE && this.state.displayInline && this.state.submitted ? _react2.default.createElement(
	                            'div',
	                            { className: 'guroo-active-link text-center', onClick: this.editResponses,
	                                onKeyDown: this.editResponsesOnKeyboardAccessibility, tabIndex: 0, role: 'link' },
	                            'Edit Responses'
	                        ) : null,
	                        !this.state.displayInline ? _react2.default.createElement(
	                            'div',
	                            { className: 'content-panel text-center' },
	                            _react2.default.createElement('div', {
	                                dangerouslySetInnerHTML: { __html: this.state.locale.response_elsewhere_instructions } }),
	                            this.state.status !== objectConstants.STATUS_COMPLETE ? _react2.default.createElement(_Button2.default, { label: this.state.complete_activity_label,
	                                id: this.state.screenObject + '_button',
	                                onClick: this.onContinue }) : null
	                        ) : null
	                    ),
	                    this.state.showFeedback && !this.state.feedbackViewed ? _react2.default.createElement(_ShortResponseFeedback2.default, { screenObject: this.state.screenObject, callbacks: this.state.callbacks,
	                        scrollToFeedback: this.scrollToFeedback, onComplete: this.onFeedbackComplete,
	                        selfRate: this.state.selfRate, saveRating: this.state.saveRating }) : null
	                )
	            );
	        }
	    }]);
	
	    return ShortResponse;
	}(_react2.default.Component);
	
	ShortResponse.propTypes = {
	    screenObject: _propTypes2.default.object.isRequired,
	    index: _propTypes2.default.number,
	    callbacks: _propTypes2.default.object,
	    shortResponseQuestions: _propTypes2.default.array.isRequired,
	    characterPose: _propTypes2.default.object,
	    contentData: _propTypes2.default.object.isRequired,
	    trackingData: _propTypes2.default.object.isRequired,
	    userData: _propTypes2.default.object.isRequired,
	    lang: _propTypes2.default.string.isRequired,
	    actions: _propTypes2.default.object.isRequired
	};
	
	ShortResponse.contextTypes = {
	    router: _propTypes2.default.object
	};
	
	function mapStateToProps(state, ownProps) {
	    var lang = state.userData.lang;
	    return {
	        lang: lang,
	        shortResponseQuestions: state.userData.short_response_questions,
	        contentData: state.contentData,
	        trackingData: state.trackingData,
	        userData: state.userData
	    };
	}
	
	function mapDispatchToProps(dispatch) {
	    return {
	        actions: (0, _redux.bindActionCreators)(Object.assign({}, appDataActions, trackingDataActions, userDataActions, dialogPopupActions), dispatch)
	    };
	}
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(ShortResponse);

/***/ },
/* 517 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(5);
	
	var _redux = __webpack_require__(4);
	
	var _appDataActions = __webpack_require__(12);
	
	var appDataActions = _interopRequireWildcard(_appDataActions);
	
	var _Button = __webpack_require__(18);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _ResourceLinks = __webpack_require__(48);
	
	var _ResourceLinks2 = _interopRequireDefault(_ResourceLinks);
	
	var _KpiSelfRatingPanel = __webpack_require__(488);
	
	var _KpiSelfRatingPanel2 = _interopRequireDefault(_KpiSelfRatingPanel);
	
	var _BadgeCollect = __webpack_require__(47);
	
	var _BadgeCollect2 = _interopRequireDefault(_BadgeCollect);
	
	var _trackingDataActions = __webpack_require__(7);
	
	var trackingDataActions = _interopRequireWildcard(_trackingDataActions);
	
	var _userDataActions = __webpack_require__(20);
	
	var userDataActions = _interopRequireWildcard(_userDataActions);
	
	var _appHelper = __webpack_require__(3);
	
	var appHelper = _interopRequireWildcard(_appHelper);
	
	var _objectConstants = __webpack_require__(9);
	
	var objectConstants = _interopRequireWildcard(_objectConstants);
	
	var _kpiConstants = __webpack_require__(37);
	
	var kpiConstants = _interopRequireWildcard(_kpiConstants);
	
	var _gsap = __webpack_require__(8);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	//eslint-disable-line import/no-named-as-default
	
	
	var ShortResponseFeedback = function (_React$Component) {
	    _inherits(ShortResponseFeedback, _React$Component);
	
	    function ShortResponseFeedback(props, context) {
	        _classCallCheck(this, ShortResponseFeedback);
	
	        var _this = _possibleConstructorReturn(this, (ShortResponseFeedback.__proto__ || Object.getPrototypeOf(ShortResponseFeedback)).call(this, props, context));
	
	        _this.state = {
	            lang: _this.props.lang,
	            userData: _this.props.userData,
	            screenObject: _this.props.screenObject,
	            locale: appHelper.getLocalData(_this.props.screenObject),
	            showProgression: false,
	            enableProgression: _this.props.screenObject.kpis === null,
	            optionFeedback: [],
	            kpiDashboardParams: {
	                showTitle: false,
	                showImmediateImpact: true,
	                allowUpdates: false
	            },
	            hasBadges: appHelper.isDefined(_this.props.screenObject.badges) && _this.props.screenObject.badges.length > 0,
	            badgesCollected: false,
	            resourceLinks: [],
	            hasResources: false,
	            resourcesAreComplete: true,
	            optionAsset: {
	                src: ""
	            },
	            assetData: {},
	            score_kpi: appHelper.isDefined(appHelper.getBite(_this.props.callbacks.getBiteId()).score_kpi) ? appHelper.getBite(_this.props.callbacks.getBiteId()).score_kpi : {},
	            kpi_user_rating: {
	                kpi_id: appHelper.isDefined(appHelper.getBite(_this.props.callbacks.getBiteId()).score_kpi) ? appHelper.getBite(_this.props.callbacks.getBiteId()).score_kpi.kpi_id : null,
	                value: null
	            },
	            ratingComplete: !_this.props.selfRate,
	            continue_label: appHelper.getLocaleString("continue_label")
	
	        };
	        _this.show = _this.show.bind(_this);
	        _this.onFeedbackRevealed = _this.onFeedbackRevealed.bind(_this);
	        _this.onFeedbackHidden = _this.onFeedbackHidden.bind(_this);
	        _this.onProgressionClicked = _this.onProgressionClicked.bind(_this);
	        _this.scrollToTop = _this.scrollToTop.bind(_this);
	        _this.storeUserResponse = _this.storeUserResponse.bind(_this);
	        _this.enableProgression = _this.enableProgression.bind(_this);
	        _this.onBadgeCollected = _this.onBadgeCollected.bind(_this);
	        _this.onResourcesComplete = _this.onResourcesComplete.bind(_this);
	        _this.setResources = _this.setResources.bind(_this);
	        _this.getDisabledState = _this.getDisabledState.bind(_this);
	        _this.onRatingSelected = _this.onRatingSelected.bind(_this);
	        return _this;
	    }
	
	    _createClass(ShortResponseFeedback, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            //this.handleOptionFeedback();
	
	            this.setResources();
	            this.show();
	            if (appHelper.isDefined(this.props.callbacks.updateCharacterExpression) && appHelper.isDefined(this.state.screenObject.character_pose)) {
	                this.props.callbacks.updateCharacterExpression(this.state.screenObject.character_pose);
	            }
	        }
	    }, {
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(nextProps) {
	            if (this.state.userData !== nextProps.userData) {
	                this.setState({ userData: Object.assign({}, nextProps.userData) });
	            }
	            if (this.state.lang !== nextProps.lang) {
	                this.setState({
	                    lang: nextProps.lang,
	                    locale: appHelper.getLocalData(this.state.screenObject),
	                    continue_label: appHelper.getLocaleString("continue_label")
	                });
	            }
	        }
	    }, {
	        key: 'storeUserResponse',
	        value: function storeUserResponse() {
	            var selectedOptions = [this.state.screenObject.asset_id];
	            var responseObj = {
	                asset_id: this.state.screenObject.asset_id,
	                selectedOptions: selectedOptions,
	                kpis: this.state.screenObject.kpis !== null ? this.state.screenObject.kpis : []
	            };
	            this.props.callbacks.storeUserResponse(responseObj);
	        }
	    }, {
	        key: 'scrollToTop',
	        value: function scrollToTop() {
	            var question = this.refs[this.state.screenObject.asset_id + '_feedbackPanel'];
	            if (appHelper.isDefined(question)) {
	                this.props.scrollToFeedback(question.offsetTop);
	            }
	        }
	    }, {
	        key: 'enableProgression',
	        value: function enableProgression() {
	            this.setState({ enableProgression: true });
	        }
	    }, {
	        key: 'onFeedbackRevealed',
	        value: function onFeedbackRevealed() {
	            //this.storeUserResponse();
	            this.scrollToTop();
	        }
	    }, {
	        key: 'onFeedbackHidden',
	        value: function onFeedbackHidden() {
	            if (typeof this.props.onComplete !== 'undefined') {
	                this.props.onComplete();
	            }
	        }
	    }, {
	        key: 'onProgressionClicked',
	        value: function onProgressionClicked(event) {
	            var _this2 = this;
	
	            if (appHelper.isDefined(event)) {
	                event.stopPropagation();
	            }
	            //if(this.props.selfRate){
	            var params = {
	                userData: this.state.userData,
	                bite_id: this.props.callbacks.getBiteId(),
	                screen_id: this.props.callbacks.getScreenId(),
	                parent_screen_id: appHelper.isDefined(this.props.callbacks.getSubScreenParent()) ? this.props.callbacks.getSubScreenParent().screen_id : undefined,
	                asset_id: this.state.screenObject.asset_id,
	                kpis: this.props.saveRating ? [this.state.kpi_user_rating] : []
	            };
	
	            this.props.actions.storeUserResponse(params).then(function (userData) {
	                _this2.props.actions.setSuspendData(userData).then(function (suspendData) {
	
	                    _this2.hide();
	                }).catch(function (error) {});
	            }).catch(function (error) {});
	            /*}else {
	                this.hide();
	            }*/
	        }
	    }, {
	        key: 'show',
	        value: function show() {
	            var feedbackPanel = this.refs[this.state.screenObject.asset_id + '_feedbackPanel'];
	            _gsap.TweenLite.set(feedbackPanel, { height: "auto", opacity: 1 });
	            _gsap.TweenLite.from(feedbackPanel, objectConstants.FEEDBACK_DURATION, {
	                height: 0,
	                opacity: 0,
	                ease: _gsap.Expo.easeInOut
	            }).eventCallback("onComplete", this.onFeedbackRevealed);
	            /**/
	        }
	    }, {
	        key: 'hide',
	        value: function hide() {
	            var feedbackPanel = this.refs[this.state.screenObject.asset_id + '_feedbackPanel'];
	            _gsap.TweenLite.to(feedbackPanel, objectConstants.FEEDBACK_DURATION, {
	                height: 0,
	                opacity: 0,
	                ease: _gsap.Expo.easeInOut
	            }).eventCallback("onComplete", this.onFeedbackHidden);
	        }
	    }, {
	        key: 'onToolboxComplete',
	        value: function onToolboxComplete(progression, asset_id, latestResponse) {
	            this.setState({ toolboxIsComplete: true });
	        }
	    }, {
	        key: 'setToolboxCallbacks',
	        value: function setToolboxCallbacks() {
	            this.setState({
	                toolboxCallbacks: Object.assign({}, this.state.toolboxCallbacks, {
	                    onObjectComplete: this.onToolboxComplete,
	                    isReviewMode: function isReviewMode() {
	                        return false;
	                    }
	                })
	            });
	        }
	    }, {
	        key: 'onBadgeCollected',
	        value: function onBadgeCollected() {
	            this.setState({ badgesCollected: true });
	            //this.hide();
	        }
	    }, {
	        key: 'setResources',
	        value: function setResources() {
	            var resourceLinks = appHelper.setResourceLinks(this.state.screenObject);
	
	            this.setState({
	                resourceLinks: Object.assign([], resourceLinks),
	                hasResources: resourceLinks.length > 0,
	                resourcesAreComplete: resourceLinks.length === 0
	            });
	        }
	    }, {
	        key: 'onResourcesComplete',
	        value: function onResourcesComplete() {
	            if (!this.state.resourcesAreComplete) {
	                this.setState({ resourcesAreComplete: true, checkComplete: true });
	            }
	        }
	    }, {
	        key: 'getDisabledState',
	        value: function getDisabledState() {
	            return !this.state.ratingComplete && appHelper.isDefined(this.state.score_kpi.kpi_id);
	        }
	    }, {
	        key: 'onRatingSelected',
	        value: function onRatingSelected(kpi) {
	            var kpiRating = Object.assign({}, this.state.kpi_user_rating, {
	                value: kpi.value
	            });
	            this.setState({
	                ratingComplete: true,
	                kpi_user_rating: Object.assign({}, kpiRating)
	            });
	
	            this.props.callbacks.updateUserRating(kpiRating);
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this3 = this;
	
	            return _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(
	                    'div',
	                    { className: 'feedback-panel reflective', ref: this.state.screenObject.asset_id + '_feedbackPanel' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'feedback-content-col' },
	                        appHelper.isDefined(this.state.locale.feedback) && this.state.locale.feedback.length > 0 ? _react2.default.createElement('div', { dangerouslySetInnerHTML: { __html: this.state.locale.feedback } }) : null,
	                        this.state.hasResources ? _react2.default.createElement(_ResourceLinks2.default, { resources: this.state.resourceLinks,
	                            onResourcesComplete: this.onResourcesComplete }) : null,
	                        this.props.selfRate && appHelper.isDefined(this.state.score_kpi.kpi_id) ? _react2.default.createElement(_KpiSelfRatingPanel2.default, { bite_id: this.props.callbacks.getBiteId(), kpi: this.state.score_kpi,
	                            onComplete: this.onRatingSelected }) : null,
	                        this.state.hasBadges ? _react2.default.createElement(
	                            'div',
	                            null,
	                            this.state.screenObject.badges.map(function (badge) {
	                                return _react2.default.createElement(_BadgeCollect2.default, { key: badge.badge_id, badge_id: badge.badge_id,
	                                    bite_id: _this3.props.callbacks.getBiteId(),
	                                    asset_id: _this3.state.screenObject.asset_id,
	                                    onCollected: _this3.onBadgeCollected });
	                            })
	                        ) : null
	                    )
	                ),
	                (this.state.hasBadges && this.state.badgesCollected || !this.state.hasBadges) && this.state.resourcesAreComplete ? _react2.default.createElement(_Button2.default, { label: this.state.continue_label,
	                    id: this.state.screenObject.asset_id + '_button',
	
	                    isDisabled: this.getDisabledState(),
	                    onClick: this.onProgressionClicked }) : null
	            );
	        }
	    }]);
	
	    return ShortResponseFeedback;
	}(_react2.default.Component);
	
	ShortResponseFeedback.propTypes = {
	    screenObject: _propTypes2.default.object.isRequired,
	    callbacks: _propTypes2.default.object.isRequired,
	    onComplete: _propTypes2.default.func,
	    scrollToFeedback: _propTypes2.default.func,
	    selfRate: _propTypes2.default.bool,
	    saveRating: _propTypes2.default.bool,
	    actions: _propTypes2.default.object,
	    contentData: _propTypes2.default.object.isRequired,
	    userData: _propTypes2.default.object.isRequired,
	    lang: _propTypes2.default.string.isRequired,
	    showImages: _propTypes2.default.bool
	
	};
	
	ShortResponseFeedback.contextTypes = {
	    router: _propTypes2.default.object
	};
	
	function mapStateToProps(state, ownProps) {
	    var lang = state.userData.lang;
	    return {
	        lang: lang,
	        contentData: state.contentData,
	        userData: state.userData
	    };
	}
	
	function mapDispatchToProps(dispatch) {
	    return {
	        actions: (0, _redux.bindActionCreators)(Object.assign({}, appDataActions, trackingDataActions, userDataActions), dispatch)
	    };
	}
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(ShortResponseFeedback);

/***/ },
/* 518 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(5);
	
	var _redux = __webpack_require__(4);
	
	var _appDataActions = __webpack_require__(12);
	
	var appDataActions = _interopRequireWildcard(_appDataActions);
	
	var _ResourceLinks = __webpack_require__(48);
	
	var _ResourceLinks2 = _interopRequireDefault(_ResourceLinks);
	
	var _KpiResultReview = __webpack_require__(151);
	
	var _KpiResultReview2 = _interopRequireDefault(_KpiResultReview);
	
	var _BadgeCollect = __webpack_require__(47);
	
	var _BadgeCollect2 = _interopRequireDefault(_BadgeCollect);
	
	var _trackingDataActions = __webpack_require__(7);
	
	var trackingDataActions = _interopRequireWildcard(_trackingDataActions);
	
	var _userDataActions = __webpack_require__(20);
	
	var userDataActions = _interopRequireWildcard(_userDataActions);
	
	var _appHelper = __webpack_require__(3);
	
	var appHelper = _interopRequireWildcard(_appHelper);
	
	var _objectConstants = __webpack_require__(9);
	
	var objectConstants = _interopRequireWildcard(_objectConstants);
	
	var _kpiConstants = __webpack_require__(37);
	
	var kpiConstants = _interopRequireWildcard(_kpiConstants);
	
	var _gsap = __webpack_require__(8);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	//eslint-disable-line import/no-named-as-default
	
	
	var ShortResponseFeedbackReview = function (_React$Component) {
	    _inherits(ShortResponseFeedbackReview, _React$Component);
	
	    function ShortResponseFeedbackReview(props, context) {
	        _classCallCheck(this, ShortResponseFeedbackReview);
	
	        var _this = _possibleConstructorReturn(this, (ShortResponseFeedbackReview.__proto__ || Object.getPrototypeOf(ShortResponseFeedbackReview)).call(this, props, context));
	
	        _this.state = {
	            lang: _this.props.lang,
	            userData: _this.props.userData,
	            screenObject: _this.props.screenObject,
	            responseData: _this.props.responseData,
	            locale: appHelper.getLocalData(_this.props.screenObject),
	            showProgression: false,
	            enableProgression: _this.props.screenObject.kpis === null,
	            optionFeedback: [],
	            kpiDashboardParams: {
	                showTitle: false,
	                showImmediateImpact: true,
	                allowUpdates: false
	            },
	            hasBadges: appHelper.isDefined(_this.props.screenObject.badges) && _this.props.screenObject.badges.length > 0,
	            badgesCollected: false,
	            resourceLinks: [],
	            hasResources: false,
	            resourcesAreComplete: true,
	            optionAsset: {
	                src: ""
	            },
	            assetData: {},
	            score_kpi: appHelper.isDefined(appHelper.getBite(_this.props.responseData.bite_id).score_kpi) ? appHelper.getBite(_this.props.responseData.bite_id).score_kpi : {},
	            kpi_user_rating: {
	                kpi_id: appHelper.isDefined(appHelper.getBite(_this.props.responseData.bite_id).score_kpi) ? appHelper.getBite(_this.props.responseData.bite_id).score_kpi.kpi_id : null,
	                value: null
	            },
	            ratingComplete: !_this.props.selfRate
	
	        };
	        _this.show = _this.show.bind(_this);
	        _this.onFeedbackRevealed = _this.onFeedbackRevealed.bind(_this);
	        _this.onFeedbackHidden = _this.onFeedbackHidden.bind(_this);
	        _this.onProgressionClicked = _this.onProgressionClicked.bind(_this);
	        _this.storeUserResponse = _this.storeUserResponse.bind(_this);
	        _this.enableProgression = _this.enableProgression.bind(_this);
	        _this.onBadgeCollected = _this.onBadgeCollected.bind(_this);
	        _this.onResourcesComplete = _this.onResourcesComplete.bind(_this);
	        _this.setResources = _this.setResources.bind(_this);
	        _this.getDisabledState = _this.getDisabledState.bind(_this);
	        _this.onRatingSelected = _this.onRatingSelected.bind(_this);
	        return _this;
	    }
	
	    _createClass(ShortResponseFeedbackReview, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            //this.handleOptionFeedback();
	
	            this.setResources();
	            this.show();
	            if (appHelper.isDefined(this.props.callbacks.updateCharacterExpression) && appHelper.isDefined(this.state.screenObject.character_pose)) {
	                this.props.callbacks.updateCharacterExpression(this.state.screenObject.character_pose);
	            }
	        }
	    }, {
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(nextProps) {
	            if (this.state.userData !== nextProps.userData) {
	                this.setState({ userData: Object.assign({}, nextProps.userData) });
	            }
	            if (this.state.lang !== nextProps.lang) {
	                this.setState({
	                    lang: nextProps.lang,
	                    locale: appHelper.getLocalData(this.state.screenObject)
	                });
	            }
	        }
	    }, {
	        key: 'storeUserResponse',
	        value: function storeUserResponse() {
	            var selectedOptions = [this.state.screenObject.asset_id];
	            var responseObj = {
	                asset_id: this.state.screenObject.asset_id,
	                selectedOptions: selectedOptions,
	                kpis: this.state.screenObject.kpis !== null ? this.state.screenObject.kpis : []
	            };
	            this.props.callbacks.storeUserResponse(responseObj);
	        }
	    }, {
	        key: 'enableProgression',
	        value: function enableProgression() {
	            this.setState({ enableProgression: true });
	        }
	    }, {
	        key: 'onFeedbackRevealed',
	        value: function onFeedbackRevealed() {
	            //this.storeUserResponse();
	
	        }
	    }, {
	        key: 'onFeedbackHidden',
	        value: function onFeedbackHidden() {
	            if (typeof this.props.onComplete !== 'undefined') {
	                this.props.onComplete();
	            }
	        }
	    }, {
	        key: 'onProgressionClicked',
	        value: function onProgressionClicked() {
	            var _this2 = this;
	
	            //if(this.props.selfRate){
	            var params = {
	                userData: this.state.userData,
	                bite_id: this.state.responseData.bite_id,
	                screen_id: this.state.responseData.screen_id,
	                parent_screen_id: appHelper.isDefined(this.props.callbacks.getSubScreenParent()) ? this.props.callbacks.getSubScreenParent().screen_id : undefined,
	                asset_id: this.state.screenObject.asset_id,
	                kpis: this.props.saveRating ? [this.state.kpi_user_rating] : []
	            };
	
	            this.props.actions.storeUserResponse(params).then(function (userData) {
	                _this2.props.actions.setSuspendData(userData).then(function (suspendData) {
	
	                    _this2.hide();
	                }).catch(function (error) {});
	            }).catch(function (error) {});
	            /*}else {
	                this.hide();
	            }*/
	        }
	    }, {
	        key: 'show',
	        value: function show() {
	            var feedbackPanel = this.refs[this.state.screenObject.asset_id + '_feedbackPanel'];
	            _gsap.TweenLite.set(feedbackPanel, { height: "auto", opacity: 1 });
	            _gsap.TweenLite.from(feedbackPanel, objectConstants.FEEDBACK_DURATION, {
	                height: 0,
	                opacity: 0,
	                ease: _gsap.Expo.easeInOut
	            }).eventCallback("onComplete", this.onFeedbackRevealed);
	            /**/
	        }
	    }, {
	        key: 'hide',
	        value: function hide() {
	            var feedbackPanel = this.refs[this.state.screenObject.asset_id + '_feedbackPanel'];
	            _gsap.TweenLite.to(feedbackPanel, 1, {
	                height: 0,
	                opacity: 0,
	                ease: _gsap.Expo.easeInOut
	            }).eventCallback("onComplete", this.onFeedbackHidden);
	        }
	    }, {
	        key: 'onToolboxComplete',
	        value: function onToolboxComplete(progression, asset_id, latestResponse) {
	            this.setState({ toolboxIsComplete: true });
	        }
	    }, {
	        key: 'setToolboxCallbacks',
	        value: function setToolboxCallbacks() {
	            this.setState({
	                toolboxCallbacks: Object.assign({}, this.state.toolboxCallbacks, {
	                    onObjectComplete: this.onToolboxComplete,
	                    isReviewMode: function isReviewMode() {
	                        return false;
	                    }
	                })
	            });
	        }
	    }, {
	        key: 'onBadgeCollected',
	        value: function onBadgeCollected() {
	            this.setState({ badgesCollected: true });
	            //this.hide();
	        }
	    }, {
	        key: 'setResources',
	        value: function setResources() {
	            var resourceLinks = appHelper.setResourceLinks(this.state.screenObject);
	
	            this.setState({
	                resourceLinks: Object.assign([], resourceLinks),
	                hasResources: resourceLinks.length > 0,
	                resourcesAreComplete: resourceLinks.length === 0
	            });
	        }
	    }, {
	        key: 'onResourcesComplete',
	        value: function onResourcesComplete() {
	            if (!this.state.resourcesAreComplete) {
	                this.setState({ resourcesAreComplete: true, checkComplete: true });
	            }
	        }
	    }, {
	        key: 'getDisabledState',
	        value: function getDisabledState() {
	            return !this.state.ratingComplete;
	        }
	    }, {
	        key: 'onRatingSelected',
	        value: function onRatingSelected(kpi) {
	
	            this.setState({
	                ratingComplete: true,
	                kpi_user_rating: Object.assign({}, this.state.kpi_user_rating, {
	                    value: kpi.value
	                })
	            });
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this3 = this;
	
	            return _react2.default.createElement(
	                'div',
	                { className: 'feedback-panel reflective', ref: this.state.screenObject.asset_id + '_feedbackPanel' },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'feedback-content-col' },
	                    appHelper.isDefined(this.state.locale.feedback) && this.state.locale.feedback.length > 0 ? _react2.default.createElement('div', { dangerouslySetInnerHTML: { __html: this.state.locale.feedback } }) : null,
	                    this.state.hasResources ? _react2.default.createElement(_ResourceLinks2.default, { resources: this.state.resourceLinks,
	                        onResourcesComplete: this.onResourcesComplete }) : null,
	                    this.state.responseData.kpis[0].value !== null ? _react2.default.createElement(_KpiResultReview2.default, { kpiDefaults: this.state.score_kpi,
	                        kpi: { value: this.state.responseData.kpis[0].value } }) : null,
	                    this.state.hasBadges ? _react2.default.createElement(
	                        'div',
	                        null,
	                        this.state.screenObject.badges.map(function (badge) {
	                            return _react2.default.createElement(_BadgeCollect2.default, { key: badge.badge_id, badge_id: badge.badge_id,
	                                bite_id: _this3.state.responseData.bite_id,
	                                asset_id: _this3.state.screenObject.asset_id,
	                                onCollected: _this3.onBadgeCollected });
	                        })
	                    ) : null
	                )
	            );
	        }
	    }]);
	
	    return ShortResponseFeedbackReview;
	}(_react2.default.Component);
	
	/*
	*
	*/
	
	
	ShortResponseFeedbackReview.propTypes = {
	    screenObject: _propTypes2.default.object.isRequired,
	    responseData: _propTypes2.default.object.isRequired,
	    callbacks: _propTypes2.default.object.isRequired,
	    onComplete: _propTypes2.default.func,
	    scrollToFeedback: _propTypes2.default.func,
	    selfRate: _propTypes2.default.bool,
	    saveRating: _propTypes2.default.bool,
	    actions: _propTypes2.default.object,
	    contentData: _propTypes2.default.object.isRequired,
	    userData: _propTypes2.default.object.isRequired,
	    lang: _propTypes2.default.string.isRequired,
	    showImages: _propTypes2.default.bool
	
	};
	
	ShortResponseFeedbackReview.contextTypes = {
	    router: _propTypes2.default.object
	};
	
	function mapStateToProps(state, ownProps) {
	    var lang = state.userData.lang;
	    return {
	        lang: lang,
	        contentData: state.contentData,
	        userData: state.userData
	    };
	}
	
	function mapDispatchToProps(dispatch) {
	    return {
	        actions: (0, _redux.bindActionCreators)(Object.assign({}, appDataActions, trackingDataActions, userDataActions), dispatch)
	    };
	}
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(ShortResponseFeedbackReview);

/***/ },
/* 519 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(5);
	
	var _redux = __webpack_require__(4);
	
	var _Button = __webpack_require__(18);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _ResourceLinks = __webpack_require__(48);
	
	var _ResourceLinks2 = _interopRequireDefault(_ResourceLinks);
	
	var _ShortResponseTextArea = __webpack_require__(284);
	
	var _ShortResponseTextArea2 = _interopRequireDefault(_ShortResponseTextArea);
	
	var _ShortResponseQuestion = __webpack_require__(283);
	
	var _ShortResponseQuestion2 = _interopRequireDefault(_ShortResponseQuestion);
	
	var _ShortResponseFeedbackReview = __webpack_require__(518);
	
	var _ShortResponseFeedbackReview2 = _interopRequireDefault(_ShortResponseFeedbackReview);
	
	var _appDataActions = __webpack_require__(12);
	
	var appDataActions = _interopRequireWildcard(_appDataActions);
	
	var _trackingDataActions = __webpack_require__(7);
	
	var trackingDataActions = _interopRequireWildcard(_trackingDataActions);
	
	var _userDataActions = __webpack_require__(20);
	
	var userDataActions = _interopRequireWildcard(_userDataActions);
	
	var _appConstants = __webpack_require__(13);
	
	var appConstants = _interopRequireWildcard(_appConstants);
	
	var _appHelper = __webpack_require__(3);
	
	var appHelper = _interopRequireWildcard(_appHelper);
	
	var _userDataHelper = __webpack_require__(15);
	
	var userDataHelper = _interopRequireWildcard(_userDataHelper);
	
	var _dataHelper = __webpack_require__(11);
	
	var dataHelper = _interopRequireWildcard(_dataHelper);
	
	var _xAPIHelper = __webpack_require__(86);
	
	var xAPIHelper = _interopRequireWildcard(_xAPIHelper);
	
	var _objectConstants = __webpack_require__(9);
	
	var objectConstants = _interopRequireWildcard(_objectConstants);
	
	var _assetConstants = __webpack_require__(33);
	
	var assetConstants = _interopRequireWildcard(_assetConstants);
	
	var _localStorage = __webpack_require__(17);
	
	var localStorage = _interopRequireWildcard(_localStorage);
	
	var _gsap = __webpack_require__(8);
	
	var _gsapReactPlugin = __webpack_require__(10);
	
	var _gsapReactPlugin2 = _interopRequireDefault(_gsapReactPlugin);
	
	var _lodash = __webpack_require__(28);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } //eslint-disable-line import/no-named-as-default
	
	
	var ShortResponseReview = function (_React$Component) {
	    _inherits(ShortResponseReview, _React$Component);
	
	    function ShortResponseReview(props, context) {
	        _classCallCheck(this, ShortResponseReview);
	
	        var _this = _possibleConstructorReturn(this, (ShortResponseReview.__proto__ || Object.getPrototypeOf(ShortResponseReview)).call(this, props, context));
	
	        _this.state = {
	            lang: _this.props.lang,
	            screenObject: _this.props.screenObject,
	            userData: _this.props.userData,
	            responseData: _this.props.responseData,
	            shortResponseQuestions: _this.props.shortResponseQuestions,
	            questionsRespondedTo: [],
	            kpis: [],
	            status: objectConstants.STATUS_NOT_STARTED,
	            locale: appHelper.getLocalData(_this.props.screenObject),
	            renderQuestions: false,
	            renderedQuestions: [],
	            displayInline: _this.props.screenObject.respond_type === objectConstants.RESPOND_TYPE_INLINE || _this.props.screenObject.respond_type === objectConstants.RESPOND_TYPE_ELSEWHERE_IF_SCORM && _this.props.contentData.experience.tracking_type !== appConstants.TRACKING_TYPE_SCORM,
	            submitted: true,
	            showFeedback: true,
	            selfRate: _this.props.screenObject.assess_type !== objectConstants.ASSESSED_TYPE_NONE,
	            saveRating: _this.props.screenObject.assess_type === objectConstants.ASSESSED_TYPE_SCORED && appHelper.isDefined(appHelper.getBite(_this.props.responseData.bite_id).score_kpi),
	            callbacks: {},
	            showProgressionButton: false,
	            assetData: {},
	            screenStatus: "",
	            checkComplete: false,
	            resourceLinks: [],
	            hasResources: false,
	            resourcesAreComplete: false,
	            allowScroll: appHelper.allowScroll(_this.props.responseData.bite_id, _this.props.responseData.screen_id, _this.props.screenObject.asset_id),
	            submit_label: appHelper.getLocaleString("submit_label")
	        };
	        _this.show = _this.show.bind(_this);
	        _this.onShowComplete = _this.onShowComplete.bind(_this);
	        _this.onResourcesComplete = _this.onResourcesComplete.bind(_this);
	        _this.setResources = _this.setResources.bind(_this);
	        _this.onRendered = _this.onRendered.bind(_this);
	        _this.setRenderedQuestions = _this.setRenderedQuestions.bind(_this);
	        _this.getXAPIResponse = _this.getXAPIResponse.bind(_this);
	        _this.setCallbacks = _this.setCallbacks.bind(_this);
	        return _this;
	    }
	
	    _createClass(ShortResponseReview, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            this.setRenderedQuestions();
	            this.setResources();
	
	            this.show();
	        }
	    }, {
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(nextProps) {
	            if (this.state.userData !== nextProps.userData) {
	                this.setState({ userData: Object.assign({}, nextProps.userData) });
	            }
	            if (this.state.shortResponseQuestions !== nextProps.shortResponseQuestions) {
	                this.setState({ shortResponseQuestions: Object.assign([], nextProps.shortResponseQuestions) });
	            }
	            if (this.state.lang !== nextProps.lang) {
	                this.setState({
	                    lang: nextProps.lang,
	                    locale: appHelper.getLocalData(this.state.screenObject),
	                    submit_label: appHelper.getLocaleString("submit_label")
	                });
	            }
	        }
	    }, {
	        key: 'componentDidUpdate',
	        value: function componentDidUpdate() {
	            if (this.state.checkGetXAPIResponse) {
	                this.getXAPIResponse();
	            }
	        }
	    }, {
	        key: 'setCallbacks',
	        value: function setCallbacks() {}
	    }, {
	        key: 'setRenderedQuestions',
	        value: function setRenderedQuestions() {
	            var renderedQuestions = [];
	            var allQuestions = Object.assign([], this.state.shortResponseQuestions);
	            _lodash2.default.forEach(this.state.screenObject.questions, function (question) {
	                var questionData = appHelper.getArrayObjectByKey(allQuestions, "id", question.id);
	
	                if (appHelper.isDefined(questionData.id)) {
	                    renderedQuestions = dataHelper.immutablePush(renderedQuestions, questionData);
	                }
	            });
	
	            this.setState({
	                renderQuestions: localStorage.tracking_type !== appConstants.TRACKING_TYPE_XAPI && localStorage.tracking_type !== appConstants.TRACKING_TYPE_BLENDED_XAPI_SCORM_1_2,
	                renderedQuestions: Object.assign([], renderedQuestions),
	                checkGetXAPIResponse: true
	
	            });
	        }
	    }, {
	        key: 'getXAPIResponse',
	        value: function getXAPIResponse() {
	            var _this2 = this;
	
	            this.setState({ checkGetXAPIResponse: false });
	            if (localStorage.tracking_type === appConstants.TRACKING_TYPE_XAPI || localStorage.tracking_type === appConstants.TRACKING_TYPE_BLENDED_XAPI_SCORM_1_2) {
	                (function () {
	                    var renderedQuestions = Object.assign([], _this2.state.renderedQuestions);
	                    var returnedResponses = 0;
	                    var parentScreen = _this2.props.callbacks.getSubScreenParent();
	                    var params = {
	                        renderedQuestions: _this2.state.renderedQuestions,
	                        bite_id: _this2.props.callbacks.getBiteId(),
	                        screen_id: _this2.props.callbacks.getScreenId(),
	                        parent_screen_id: appHelper.isDefined(parentScreen) ? parentScreen.screen_id : undefined,
	                        asset_id: _this2.state.screenObject.asset_id
	                    };
	
	                    var interactionDataArray = xAPIHelper.getShortResponseIds(_this2.state.screenObject, params);
	
	                    for (var i = 0; i < interactionDataArray.length; i++) {
	                        var interactionData = interactionDataArray[i];
	                        _this2.props.actions.getActvityStatement(interactionData).then(function (responseObj) {
	                            if (appHelper.isDefined(responseObj.statement)) {
	                                var response = responseObj.statement.result.response;
	                                var responseQuestion = appHelper.getArrayObjectByKey(renderedQuestions, "id", responseObj.id);
	                                var responseQuestionIndex = appHelper.getArrayObjectIndexByKey(renderedQuestions, "id", responseObj.id);
	                                responseQuestion = Object.assign({}, responseQuestion, {
	                                    response: response
	                                });
	
	                                renderedQuestions = dataHelper.immutableSplice(renderedQuestions, responseQuestionIndex, 1, responseQuestion);
	                                returnedResponses++;
	                                if (returnedResponses === renderedQuestions.length) {
	                                    _this2.setState({
	                                        renderedQuestions: Object.assign([], renderedQuestions),
	                                        renderQuestions: true
	                                    });
	                                }
	                            } else {
	                                _this2.setState({ renderQuestions: true });
	                            }
	                        }).catch(function (error) {});
	                    }
	                })();
	            }
	        }
	    }, {
	        key: 'setResources',
	        value: function setResources() {
	            var resourceLinks = appHelper.setResourceLinks(this.state.screenObject);
	            var hasRequiredResources = appHelper.hasRequiredResources(resourceLinks);
	
	            this.setState({
	                resourceLinks: Object.assign([], resourceLinks),
	                hasResources: resourceLinks.length > 0,
	                resourcesAreComplete: resourceLinks.length === 0 || !hasRequiredResources
	            });
	        }
	    }, {
	        key: 'show',
	        value: function show() {
	            var optionRef = this.refs[this.state.screenObject.asset_id + '_question'];
	            _gsap.TweenLite.set(optionRef, { height: "auto" });
	            _gsap.TweenLite.from(optionRef, objectConstants.SHOW_PANEL_DURATION, {
	                height: 0,
	                ease: _gsap.Expo.easeInOut
	            }).eventCallback("onComplete", this.onRendered);
	        }
	    }, {
	        key: 'onRendered',
	        value: function onRendered() {}
	    }, {
	        key: 'onShowComplete',
	        value: function onShowComplete() {
	            this.setState({ isVisible: true, checkComplete: false });
	        }
	    }, {
	        key: 'onResourcesComplete',
	        value: function onResourcesComplete() {}
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this3 = this;
	
	            return _react2.default.createElement(
	                'div',
	                { className: 'learner-action', ref: this.state.screenObject.asset_id + '_question' },
	                appHelper.isDefined(this.props.characterPose) && appHelper.isDefined(this.props.characterPose.src) && this.props.characterPose.src.length > 0 ? _react2.default.createElement(
	                    'div',
	                    { className: 'content-character-expression' },
	                    _react2.default.createElement('img', { src: this.getImagePath(this.props.characterPose.src), alt: '' })
	                ) : null,
	                _react2.default.createElement(
	                    'div',
	                    { className: 'question-wrapper' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'object-container' },
	                        this.state.screenObject.show_title ? _react2.default.createElement('h4', { dangerouslySetInnerHTML: { __html: this.state.locale.label } }) : null,
	                        appHelper.isDefined(this.state.locale.description) && this.state.locale.description !== null && this.state.locale.description.length > 0 && this.state.locale.description !== "<p><br></p>" ? _react2.default.createElement('div', { dangerouslySetInnerHTML: { __html: this.state.locale.description } }) : null,
	                        this.state.hasResources ? _react2.default.createElement(
	                            'div',
	                            null,
	                            _react2.default.createElement('br', null),
	                            _react2.default.createElement(_ResourceLinks2.default, { resources: this.state.resourceLinks,
	                                onResourcesComplete: this.onResourcesComplete })
	                        ) : null,
	                        this.state.showFeedback && this.state.screenObject.feedback_type === objectConstants.FEEDBACK_TYPE_INCLUDE ? _react2.default.createElement(
	                            'div',
	                            null,
	                            _react2.default.createElement('br', null),
	                            _react2.default.createElement(_ShortResponseFeedbackReview2.default, { screenObject: this.state.screenObject,
	                                responseData: this.state.responseData, callbacks: this.state.callbacks,
	                                scrollToFeedback: this.scrollToFeedback,
	                                onComplete: this.onFeedbackComplete, selfRate: this.state.selfRate,
	                                saveRating: this.state.saveRating })
	                        ) : null,
	                        _react2.default.createElement('br', null),
	                        this.state.renderQuestions ? this.state.renderedQuestions.map(function (question) {
	                            return _react2.default.createElement(
	                                'div',
	                                { key: question.id },
	                                _this3.state.displayInline ? _react2.default.createElement(_ShortResponseTextArea2.default, { parentObject: _this3.state.screenObject,
	                                    screenObject: question,
	                                    callbacks: _this3.state.callbacks,
	                                    submitted: _this3.state.submitted
	                                }) : _react2.default.createElement(_ShortResponseQuestion2.default, { parentObject: _this3.state.screenObject,
	                                    screenObject: question,
	                                    callbacks: _this3.state.callbacks })
	                            );
	                        }) : _react2.default.createElement(
	                            'div',
	                            { className: 'pl-circle content' },
	                            _react2.default.createElement('div', { className: 'pl-circle1 pl-child' }),
	                            _react2.default.createElement('div', { className: 'pl-circle2 pl-child' }),
	                            _react2.default.createElement('div', { className: 'pl-circle3 pl-child' }),
	                            _react2.default.createElement('div', { className: 'pl-circle4 pl-child' }),
	                            _react2.default.createElement('div', { className: 'pl-circle5 pl-child' }),
	                            _react2.default.createElement('div', { className: 'pl-circle6 pl-child' }),
	                            _react2.default.createElement('div', { className: 'pl-circle7 pl-child' }),
	                            _react2.default.createElement('div', { className: 'pl-circle8 pl-child' }),
	                            _react2.default.createElement('div', { className: 'pl-circle9 pl-child' }),
	                            _react2.default.createElement('div', { className: 'pl-circle10 pl-child' }),
	                            _react2.default.createElement('div', { className: 'pl-circle11 pl-child' }),
	                            _react2.default.createElement('div', { className: 'pl-circle12 pl-child' })
	                        ),
	                        !this.state.submitted && this.state.displayInline ? _react2.default.createElement(_Button2.default, { label: this.state.submit_label,
	                            id: this.state.screenObject + '_button',
	                            onClick: this.onSubmit }) : null
	                    )
	                )
	            );
	        }
	    }]);
	
	    return ShortResponseReview;
	}(_react2.default.Component);
	
	ShortResponseReview.propTypes = {
	    screenObject: _propTypes2.default.object.isRequired,
	    responseData: _propTypes2.default.object.isRequired,
	    callbacks: _propTypes2.default.object,
	    shortResponseQuestions: _propTypes2.default.array.isRequired,
	    characterPose: _propTypes2.default.object,
	    contentData: _propTypes2.default.object.isRequired,
	    trackingData: _propTypes2.default.object.isRequired,
	    userData: _propTypes2.default.object.isRequired,
	    lang: _propTypes2.default.string.isRequired,
	    actions: _propTypes2.default.object.isRequired
	};
	
	ShortResponseReview.contextTypes = {
	    router: _propTypes2.default.object
	};
	
	function mapStateToProps(state, ownProps) {
	    var lang = state.userData.lang;
	    return {
	        lang: lang,
	        shortResponseQuestions: state.userData.short_response_questions,
	        contentData: state.contentData,
	        trackingData: state.trackingData,
	        userData: state.userData
	    };
	}
	
	function mapDispatchToProps(dispatch) {
	    return {
	        actions: (0, _redux.bindActionCreators)(Object.assign({}, appDataActions, trackingDataActions, userDataActions), dispatch)
	    };
	}
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(ShortResponseReview);

/***/ },
/* 520 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(5);
	
	var _redux = __webpack_require__(4);
	
	var _Button = __webpack_require__(18);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _SwipeHorizontalOption = __webpack_require__(522);
	
	var _SwipeHorizontalOption2 = _interopRequireDefault(_SwipeHorizontalOption);
	
	var _SwipeHorizontalFeedback = __webpack_require__(521);
	
	var _SwipeHorizontalFeedback2 = _interopRequireDefault(_SwipeHorizontalFeedback);
	
	var _Prompt = __webpack_require__(83);
	
	var _Prompt2 = _interopRequireDefault(_Prompt);
	
	var _ChildConversationDialog = __webpack_require__(65);
	
	var _ChildConversationDialog2 = _interopRequireDefault(_ChildConversationDialog);
	
	var _BadgeCollect = __webpack_require__(47);
	
	var _BadgeCollect2 = _interopRequireDefault(_BadgeCollect);
	
	var _appDataActions = __webpack_require__(12);
	
	var appDataActions = _interopRequireWildcard(_appDataActions);
	
	var _trackingDataActions = __webpack_require__(7);
	
	var trackingDataActions = _interopRequireWildcard(_trackingDataActions);
	
	var _dialogPopupActions = __webpack_require__(19);
	
	var dialogPopupActions = _interopRequireWildcard(_dialogPopupActions);
	
	var _appHelper = __webpack_require__(3);
	
	var appHelper = _interopRequireWildcard(_appHelper);
	
	var _dataHelper = __webpack_require__(11);
	
	var dataHelper = _interopRequireWildcard(_dataHelper);
	
	var _userDataHelper = __webpack_require__(15);
	
	var userDataHelper = _interopRequireWildcard(_userDataHelper);
	
	var _objectConstants = __webpack_require__(9);
	
	var objectConstants = _interopRequireWildcard(_objectConstants);
	
	var _appConstants = __webpack_require__(13);
	
	var appConstants = _interopRequireWildcard(_appConstants);
	
	var _xAPIHelper = __webpack_require__(86);
	
	var xAPIHelper = _interopRequireWildcard(_xAPIHelper);
	
	var _localStorage = __webpack_require__(17);
	
	var localStorage = _interopRequireWildcard(_localStorage);
	
	var _keyboardConstants = __webpack_require__(14);
	
	var keyboardConstants = _interopRequireWildcard(_keyboardConstants);
	
	var _componentConstants = __webpack_require__(49);
	
	var componentConstants = _interopRequireWildcard(_componentConstants);
	
	var _dialogModels = __webpack_require__(32);
	
	var _gsap = __webpack_require__(8);
	
	var _Draggable = __webpack_require__(836);
	
	var _Draggable2 = _interopRequireDefault(_Draggable);
	
	var _gsapReactPlugin = __webpack_require__(10);
	
	var _gsapReactPlugin2 = _interopRequireDefault(_gsapReactPlugin);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } //eslint-disable-line import/no-named-as-default
	
	
	var SwipeHorizontal = function (_React$Component) {
	    _inherits(SwipeHorizontal, _React$Component);
	
	    function SwipeHorizontal(props, context) {
	        _classCallCheck(this, SwipeHorizontal);
	
	        var _this = _possibleConstructorReturn(this, (SwipeHorizontal.__proto__ || Object.getPrototypeOf(SwipeHorizontal)).call(this, props, context));
	
	        _this.state = {
	            lang: _this.props.lang,
	            initialised: false,
	            screenObject: _this.props.screenObject,
	            userData: _this.props.userData,
	            options: _this.props.screenObject.options,
	            showOptions: false,
	            hideOptions: false,
	            setDrags: false,
	            leftOption: {},
	            rightOption: {},
	            activeOption: {},
	            locale: appHelper.getLocalData(_this.props.screenObject),
	            callbacks: {},
	            responseData: {
	                bite_id: _this.props.callbacks.getBiteId(),
	                screen_id: _this.props.callbacks.getScreenId(),
	                asset_id: _this.props.screenObject.asset_id,
	                currentAttempt: 1,
	                currentStatus: objectConstants.STATUS_NOT_STARTED,
	                displayState: objectConstants.OBJECT_DISPLAY_STATE_INITIAL,
	                responses: [],
	                latestResponse: {},
	                scoring_type: _this.props.screenObject.scoring_type
	            },
	            showFeedback: false,
	            showResponse: false,
	            questionChecked: false,
	            currentlyChecked: false,
	            checkAnswers: false,
	            allowScroll: appHelper.allowScroll(_this.props.callbacks.getBiteId(), _this.props.callbacks.getScreenId(), _this.props.screenObject.asset_id),
	            checkPostXAPIResponse: false,
	            character_name: appHelper.isDefined(_this.props.callbacks) ? _this.props.callbacks.getCharacterName() : appHelper.getScreenCharacterNameByAssetId(_this.props.screenObject.asset_id),
	            focusedOption: _this.props.screenObject.options[0],
	            focusOnFeedback: false,
	            optionCallbacks: {},
	            updateFocus: false,
	            showProgression: false,
	            hideFeedback: false,
	            progression_label: "",
	            hasBadges: false,
	            badgesCollected: false,
	            animateBadge: true,
	            canScrollToContinue: false,
	            canScrolltoProgression: false,
	            multiple_choice_single_answer_question_label: appHelper.getLocaleString("multiple_choice_single_answer_question_label"),
	            continue_label: appHelper.getLocaleString("continue_label"),
	            try_again_label: appHelper.getLocaleString("try_again_label"),
	            progressionHandled: false,
	            xApiResponseObj: {}
	        };
	
	        _this.randomiseOptions = _this.randomiseOptions.bind(_this);
	        _this.getObjectStatus = _this.getObjectStatus.bind(_this);
	        _this.scrollToTop = _this.scrollToTop.bind(_this);
	        _this.scrollToFeedback = _this.scrollToFeedback.bind(_this);
	        _this.scrollToSubmitBtn = _this.scrollToSubmitBtn.bind(_this);
	        _this.setCallbacks = _this.setCallbacks.bind(_this);
	        _this.scrollOptionsToTop = _this.scrollOptionsToTop.bind(_this);
	        _this.setActiveOption = _this.setActiveOption.bind(_this);
	        _this.getClass = _this.getClass.bind(_this);
	        _this.checkAnswers = _this.checkAnswers.bind(_this);
	        _this.hideOptions = _this.hideOptions.bind(_this);
	        _this.getSwipeClass = _this.getSwipeClass.bind(_this);
	        _this.handleResponse = _this.handleResponse.bind(_this);
	        _this.handleProgression = _this.handleProgression.bind(_this);
	        _this.reattempt = _this.reattempt.bind(_this);
	        _this.onReviewObject = _this.onReviewObject.bind(_this);
	        _this.handleSkipFeedback = _this.handleSkipFeedback.bind(_this);
	        _this.setReviewMode = _this.setReviewMode.bind(_this);
	        _this.onOptionClick = _this.onOptionClick.bind(_this);
	        _this.getOptionListClass = _this.getOptionListClass.bind(_this);
	        _this.onPromptRevealed = _this.onPromptRevealed.bind(_this);
	        _this.postXAPIResponse = _this.postXAPIResponse.bind(_this);
	        _this.getBgClass = _this.getBgClass.bind(_this);
	        _this.getSwipeContainerClass = _this.getSwipeContainerClass.bind(_this);
	        _this.getAssets = _this.getAssets.bind(_this);
	        _this.getStatusClass = _this.getStatusClass.bind(_this);
	        _this.onPanelClick = _this.onPanelClick.bind(_this);
	        _this.getImagePath = _this.getImagePath.bind(_this);
	        _this.hasFeedbackToShow = _this.hasFeedbackToShow.bind(_this);
	        _this.setFocusedOption = _this.setFocusedOption.bind(_this);
	        _this.clearFocusedOption = _this.clearFocusedOption.bind(_this);
	        _this.getPrevOption = _this.getPrevOption.bind(_this);
	        _this.getNextOption = _this.getNextOption.bind(_this);
	        _this.setKeyboardAccessibility = _this.setKeyboardAccessibility.bind(_this);
	        _this.allowKeyAccessibility = _this.allowKeyAccessibility.bind(_this);
	        _this.getTabIndex = _this.getTabIndex.bind(_this);
	        _this.onKeyboardPanelClick = _this.onKeyboardPanelClick.bind(_this);
	        _this.onFocusOnFeedback = _this.onFocusOnFeedback.bind(_this);
	        _this.setOptionCallbacks = _this.setOptionCallbacks.bind(_this);
	        _this.setOptionFocus = _this.setOptionFocus.bind(_this);
	        _this.enableProgression = _this.enableProgression.bind(_this);
	        _this.onProgressionClicked = _this.onProgressionClicked.bind(_this);
	        _this.handleResponseComplete = _this.handleResponseComplete.bind(_this);
	        _this.onBadgeCollected = _this.onBadgeCollected.bind(_this);
	        _this.scrollToContinue = _this.scrollToContinue.bind(_this);
	        _this.scrollToProgression = _this.scrollToProgression.bind(_this);
	        _this.checkResponses = _this.checkResponses.bind(_this);
	        return _this;
	    }
	
	    _createClass(SwipeHorizontal, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	
	            if (localStorage.tracking_type === appConstants.TRACKING_TYPE_XAPI || localStorage.tracking_type === appConstants.TRACKING_TYPE_BLENDED_XAPI_SCORM_1_2) {
	                this.checkResponses();
	            } else {
	                this.getObjectStatus();
	            }
	            this.setCallbacks();
	            this.setOptionCallbacks();
	            this.randomiseOptions();
	            if (appHelper.isDefined(this.props.callbacks.updateCharacterExpression) && appHelper.isDefined(this.state.screenObject.character_pose)) {
	                this.props.callbacks.updateCharacterExpression(this.state.screenObject.character_pose);
	            }
	            this.getAssets();
	            this.show();
	        }
	    }, {
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(nextProps) {
	            if (this.state.userData !== nextProps.userData) {
	                this.setState({
	                    userData: Object.assign({}, nextProps.userData),
	                    checkObjectStatus: true
	                });
	            }
	            if (this.state.lang !== nextProps.lang) {
	                var progression_label = "";
	                if (this.state.progression_label === this.state.try_again_label) {
	                    progression_label = appHelper.getLocaleString("try_again_label");
	                } else if (this.state.progression_label === this.state.continue_label) {
	                    progression_label = appHelper.getLocaleString("continue_label");
	                }
	                this.setState({
	                    lang: nextProps.lang,
	                    locale: appHelper.getLocalData(this.state.screenObject),
	                    multiple_choice_single_answer_question_label: appHelper.getLocaleString("multiple_choice_single_answer_question_label"),
	                    progression_label: progression_label,
	                    continue_label: appHelper.getLocaleString("continue_label"),
	                    try_again_label: appHelper.getLocaleString("try_again_label")
	                });
	            }
	        }
	    }, {
	        key: 'componentDidUpdate',
	        value: function componentDidUpdate() {
	
	            if (this.state.canScrolltoProgression) {
	                this.scrollToProgression();
	            }
	            if (this.state.setDrags) {
	                this.enableDrag();
	            }
	            if (this.state.hideOptions) {
	                this.hideOptions();
	            }
	            if (this.state.propsUpdated && this.state.responseData.displayState === objectConstants.OBJECT_DISPLAY_STATE_REVIEW) {
	                this.setReviewMode();
	            }
	
	            if (this.state.skipFeedback) {
	                this.handleSkipFeedback();
	            }
	
	            if (this.state.checkObjectStatus) {
	                this.getObjectStatus();
	            }
	
	            if (this.state.handleCompletion) {
	                this.handleProgression();
	            }
	
	            if (this.state.checkAnswers) {
	                this.checkAnswers();
	            }
	            if (this.state.checkPostXAPIResponse) {
	                this.postXAPIResponse();
	            }
	
	            if (this.state.focusOnFeedback) {
	                this.onFocusOnFeedback();
	            }
	
	            if (this.state.updateFocus) {
	                this.setOptionFocus();
	            }
	
	            if (this.state.canScrollToContinue) {
	                this.scrollToContinue();
	            }
	        }
	    }, {
	        key: 'getAssets',
	        value: function getAssets() {
	            var objectUserData = {};
	            if (this.state.status !== objectConstants.STATUS_COMPLETE) {
	                var subScreenParent = this.props.callbacks.getSubScreenParent();
	                var screen_id = this.props.callbacks.getScreenId();
	                if (appHelper.isDefined(subScreenParent)) {
	                    objectUserData = userDataHelper.getSubScreenObjectStatus(this.state.userData, subScreenParent.screen_id, screen_id, this.state.screenObject.asset_id);
	                } else if (this.state.isResourceObject) {
	                    objectUserData = userDataHelper.getResourceScreenObjectUserData(this.state.userData, screen_id, this.state.screenObject.asset_id);
	                } else {
	                    objectUserData = userDataHelper.getObjectStatus(this.state.userData, screen_id, this.state.screenObject.asset_id);
	                }
	            }
	
	            if (appHelper.isDefined(this.state.screenObject.audio)) {
	                var audio = appHelper.getAudioAsset(this.state.screenObject.audio);
	                var audioObj = {
	                    audioRef: 'audio_' + audio.id + '_' + audio.type
	                };
	
	                if (objectUserData.status !== objectConstants.STATUS_COMPLETE) {
	                    this.props.actions.setAudio(audioObj);
	                }
	            }
	        }
	    }, {
	        key: 'postXAPIResponse',
	        value: function postXAPIResponse() {
	            this.setState({ checkPostXAPIResponse: false });
	            var interactionData = xAPIHelper.setSingleAnwserChoiceInteractionData(this.state.screenObject, this.state.responseData);
	            if (localStorage.tracking_type === appConstants.TRACKING_TYPE_XAPI || localStorage.tracking_type === appConstants.TRACKING_TYPE_BLENDED_XAPI_SCORM_1_2) {
	                var screen = appHelper.getScreenByAssetId(this.state.screenObject.asset_id);
	                var category = {
	                    constant: componentConstants.SWIPE_HORIZONTAL,
	                    label: componentConstants.SWIPE_HORIZONTAL_LABEL
	                };
	
	                this.props.actions.postActvityStatement(screen, interactionData, category);
	            }
	        }
	    }, {
	        key: 'handleSkipFeedback',
	        value: function handleSkipFeedback() {
	            var latestResponse = appHelper.getLastItemOfArray(this.state.responseData.responses);
	            var selectedOptions = [latestResponse.selectedOption.option_id];
	            if (appHelper.isDefined(latestResponse.audio)) {
	                var audio = appHelper.getAudioAsset(latestResponse.audio);
	                var audioObj = {
	                    audioRef: 'audio_' + audio.id + '_' + audio.type
	                };
	
	                this.props.actions.setAudio(audioObj);
	            }
	            var responseObj = {
	                asset_id: this.state.screenObject.asset_id,
	                selectedOptions: selectedOptions,
	                kpis: latestResponse.selectedOption.kpis !== null ? latestResponse.selectedOption.kpis : []
	            };
	            this.props.callbacks.storeUserResponse(responseObj);
	
	            this.setState({ skipFeedback: false });
	            if (!this.state.hasBadges) {
	                var handleResponse = this.handleResponse;
	
	                setTimeout(function () {
	                    handleResponse();
	                }, 1000);
	            }
	        }
	    }, {
	        key: 'checkResponses',
	        value: function checkResponses() {
	            var _this2 = this;
	
	            if (localStorage.tracking_type === appConstants.TRACKING_TYPE_XAPI || localStorage.tracking_type === appConstants.TRACKING_TYPE_BLENDED_XAPI_SCORM_1_2) {
	                var parentScreen = this.props.callbacks.getSubScreenParent();
	                var params = {
	
	                    bite_id: this.props.callbacks.getBiteId(),
	                    screen_id: this.props.callbacks.getScreenId(),
	                    parent_screen_id: appHelper.isDefined(parentScreen) ? parentScreen.screen_id : undefined,
	                    asset_id: this.state.screenObject.asset_id
	                };
	
	                var interactionData = xAPIHelper.getMultipleChoiceIds(params);
	
	                this.props.actions.getActvityStatement(interactionData).then(function (responseObj) {
	                    if (appHelper.isDefined(responseObj.statement.result.completion)) {
	                        _this2.setState({
	                            xApiResponseObj: Object.assign({}, responseObj),
	                            reviewMode: true,
	                            propsUpdated: true,
	                            responseData: Object.assign({}, _this2.state.responseData, {
	                                currentStatus: objectConstants.STATUS_COMPLETE,
	                                displayState: objectConstants.OBJECT_DISPLAY_STATE_REVIEW
	                            })
	                        });
	                    }
	                });
	            }
	        }
	    }, {
	        key: 'getObjectStatus',
	        value: function getObjectStatus() {
	            this.setState({ checkObjectStatus: false });
	            if (this.state.responseData.currentStatus !== objectConstants.STATUS_COMPLETE) {
	                var screenStatus = userDataHelper.getObjectStatus(this.state.userData, this.props.screenObject.asset_id);
	                if (screenStatus === objectConstants.STATUS_COMPLETE && this.state.screenObject.attempt_type === objectConstants.ATTEMPT_TYPE_FIRST) {
	                    this.setState({
	                        reviewMode: true,
	                        propsUpdated: true,
	                        responseData: Object.assign({}, this.state.responseData, {
	                            currentStatus: objectConstants.STATUS_COMPLETE,
	                            displayState: objectConstants.OBJECT_DISPLAY_STATE_REVIEW
	                        })
	                    });
	                } else {
	                    var objectUserData = {};
	                    if (this.state.status !== objectConstants.STATUS_COMPLETE) {
	                        var subScreenParent = this.props.callbacks.getSubScreenParent();
	                        var screen_id = this.props.callbacks.getScreenId();
	                        if (appHelper.isDefined(subScreenParent)) {
	                            objectUserData = userDataHelper.getSubScreenObjectStatus(this.state.userData, subScreenParent.screen_id, screen_id, this.state.screenObject.asset_id);
	                        } else {
	                            objectUserData = userDataHelper.getObjectStatus(this.state.userData, screen_id, this.state.screenObject.asset_id);
	                        }
	                    }
	
	                    if (objectUserData.status === objectConstants.STATUS_COMPLETE && this.state.screenObject.attempt_type === objectConstants.ATTEMPT_TYPE_FIRST) {
	                        this.setState({
	                            reviewMode: true,
	                            propsUpdated: true,
	                            responseData: Object.assign({}, this.state.responseData, {
	                                currentStatus: objectConstants.STATUS_COMPLETE,
	                                displayState: objectConstants.OBJECT_DISPLAY_STATE_REVIEW
	                            })
	                        });
	                    }
	                }
	            }
	        }
	    }, {
	        key: 'setReviewMode',
	        value: function setReviewMode() {
	            var optionIds = appHelper.getObjectOptionIds(this.state.screenObject);
	            var kpiUserData = userDataHelper.getUserResponseByOptionIds(this.state.userData, this.props.callbacks.getBiteId(), optionIds);
	            if (appHelper.isDefined(kpiUserData)) {
	                var optionDetails = appHelper.getOptionParentDetails(kpiUserData.option_id[0]);
	                var showResponse = false;
	
	                if (appHelper.isDefined(optionDetails)) {
	                    var responses = [];
	                    var response = {
	                        selectedOption: optionDetails.option
	                    };
	
	                    if (appHelper.isDefined(optionDetails.option.dialogs) && optionDetails.option.dialogs.length > 0) {
	                        showResponse = true;
	                    }
	
	                    var hasBadges = appHelper.isDefined(optionDetails.option.badges) && optionDetails.option.badges.length > 0;
	
	                    this.setState({
	                        showProgression: !this.props.callbacks.hasNextObject(this.props.index) && optionDetails.option.enable_feedback,
	                        hasBadges: hasBadges,
	                        badgesCollected: hasBadges,
	                        showFeedback: false,
	                        handleCompletion: true,
	                        propsUpdated: false,
	                        showOptions: true,
	                        questionChecked: true,
	                        currentlyChecked: true,
	                        showCheckBtn: false,
	                        options: dataHelper.immutableSplice(this.state.options, 0, this.state.options.length, optionDetails.option),
	                        showResponse: showResponse,
	                        progression_label: response.selectedOption.progression === objectConstants.OBJECT_PROGRESSION_TRY_AGAIN ? appHelper.getLocaleString("try_again_label") : appHelper.getLocaleString("continue_label"),
	                        responseData: Object.assign({}, this.state.responseData, {
	                            responses: dataHelper.immutablePush(responses, response),
	                            latestResponse: optionDetails.option
	                        })
	                    });
	                }
	            } else if (localStorage.tracking_type === appConstants.TRACKING_TYPE_XAPI || localStorage.tracking_type === appConstants.TRACKING_TYPE_BLENDED_XAPI_SCORM_1_2) {
	                var responseObj = Object.assign({}, this.state.xApiResponseObj);
	
	                if (appHelper.isDefined(responseObj.statement)) {
	                    var responseString = responseObj.statement.result.response;
	                    var choices = responseObj.statement.object.definition.choices;
	                    var optionResponse = xAPIHelper.getChoiceByDescription(choices, responseString);
	                    //let optionDetails = appHelper.getOptionByLabelName(responseString, this.state.screenObject.options);
	                    var _optionDetails = appHelper.getOptionParentDetails(parseInt(optionResponse.id));
	                    if (appHelper.isDefined(_optionDetails)) {
	                        var _showResponse = false;
	                        var _responses = [];
	                        var _response = {
	                            selectedOption: _optionDetails.option
	                        };
	
	                        if (appHelper.isDefined(_optionDetails.option.dialogs) && _optionDetails.option.dialogs.length > 0) {
	                            _showResponse = true;
	                        }
	
	                        var _hasBadges = appHelper.isDefined(_optionDetails.option.badges) && _optionDetails.option.badges.length > 0;
	                        this.setState({
	                            showProgression: !this.props.callbacks.hasNextObject(this.props.index) && _optionDetails.option.enable_feedback,
	                            hasBadges: _hasBadges,
	                            badgesCollected: _hasBadges,
	                            showFeedback: false,
	                            handleCompletion: true,
	                            propsUpdated: false,
	                            showOptions: true,
	                            questionChecked: true,
	                            currentlyChecked: true,
	                            showCheckBtn: false,
	                            options: dataHelper.immutableSplice(this.state.options, 0, this.state.options.length, _optionDetails.option),
	                            showResponse: _showResponse,
	                            progression_label: _response.selectedOption.progression === objectConstants.OBJECT_PROGRESSION_TRY_AGAIN ? appHelper.getLocaleString("try_again_label") : appHelper.getLocaleString("continue_label"),
	                            responseData: Object.assign({}, this.state.responseData, {
	                                responses: dataHelper.immutablePush(_responses, _response),
	                                latestResponse: _optionDetails.option
	                            })
	                        });
	                    } else {
	                        this.setState({
	                            reviewMode: false,
	                            propsUpdated: true,
	                            responseData: Object.assign({}, this.state.responseData, {
	                                currentStatus: objectConstants.STATUS_NOT_STARTED,
	                                displayState: objectConstants.OBJECT_DISPLAY_STATE_INITIAL
	                            })
	                        });
	                    }
	                } else {
	                    this.setState({ renderQuestions: true });
	                }
	            } else {
	                this.setState({
	                    reviewMode: false,
	                    propsUpdated: true,
	                    responseData: Object.assign({}, this.state.responseData, {
	                        currentStatus: objectConstants.STATUS_NOT_STARTED,
	                        displayState: objectConstants.OBJECT_DISPLAY_STATE_INITIAL
	                    })
	                });
	            }
	        }
	    }, {
	        key: 'randomiseOptions',
	        value: function randomiseOptions() {
	            var options = Object.assign([], this.state.options);
	            if (this.state.screenObject.randomise_options) {
	                options = dataHelper.randomiseArray(options);
	            }
	            this.setState({
	                options: options,
	                leftOption: options[0],
	                rightOption: options[1],
	                showOptions: true,
	                setDrags: this.state.responseData.displayState !== objectConstants.OBJECT_DISPLAY_STATE_REVIEW, //
	                focusedOption: options[0]
	            });
	            this.scrollToTop();
	        }
	    }, {
	        key: 'setCallbacks',
	        value: function setCallbacks() {
	            this.setState({
	                callbacks: Object.assign({}, this.props.callbacks, {
	                    scrollToTop: this.scrollToTop,
	                    scrollToFeedback: this.scrollToFeedback,
	                    scrollToSubmitBtn: this.scrollToSubmitBtn,
	                    scrollOptionsToTop: this.scrollOptionsToTop
	                })
	            });
	        }
	    }, {
	        key: 'scrollToTop',
	        value: function scrollToTop() {
	            var subScreenParent = this.props.callbacks.getSubScreenParent();
	            var objectUserData = {};
	            var screen_id = this.props.callbacks.getScreenId();
	            if (appHelper.isDefined(subScreenParent)) {
	                objectUserData = userDataHelper.getSubScreenObjectStatus(this.state.userData, subScreenParent.screen_id, screen_id, this.state.screenObject.asset_id);
	            } else {
	                objectUserData = userDataHelper.getObjectStatus(this.state.userData, screen_id, this.state.screenObject.asset_id);
	            }
	            if (this.state.allowScroll && objectUserData.status !== objectConstants.STATUS_COMPLETE) {
	                var question = this.refs[this.state.screenObject.asset_id + '_question'];
	                var scrollTo = this.props.callbacks.scrollTo;
	                setTimeout(function () {
	                    scrollTo(question.offsetTop);
	                }, objectConstants.SCROLL_TO);
	            }
	        }
	    }, {
	        key: 'scrollToFeedback',
	        value: function scrollToFeedback(feedbackPos) {
	            var question = this.refs[this.state.screenObject.asset_id + '_question'];
	            var scrollTo = this.props.callbacks.scrollTo;
	            setTimeout(function () {
	                scrollTo(question.offsetTop + feedbackPos, true);
	            }, objectConstants.SCROLL_TO, true);
	        }
	    }, {
	        key: 'scrollToSubmitBtn',
	        value: function scrollToSubmitBtn(submitBtnOffset) {
	            var question = this.refs[this.state.screenObject.asset_id + '_question'];
	            var scrollTo = this.props.callbacks.scrollTo;
	            setTimeout(function () {
	                scrollTo(question.offsetTop + submitBtnOffset);
	            }, objectConstants.SCROLL_TO);
	        }
	    }, {
	        key: 'scrollOptionsToTop',
	        value: function scrollOptionsToTop(questionOptionsOffset) {
	
	            var question = this.refs[this.state.screenObject.asset_id + '_question'];
	            var scrollTo = this.props.callbacks.scrollTo;
	            setTimeout(function () {
	                scrollTo(question.offsetTop + questionOptionsOffset);
	            }, objectConstants.SCROLL_TO);
	        }
	    }, {
	        key: 'scrollToProgression',
	        value: function scrollToProgression() {
	            this.setState({ canScrolltoProgression: false });
	            var question = this.refs[this.state.screenObject.asset_id + '_question'];
	            var progressionBtn = this.refs[this.state.screenObject.asset_id + '_progression_btn'];
	            var scrollTo = this.props.callbacks.scrollTo;
	            setTimeout(function () {
	                scrollTo(question.offsetTop + progressionBtn.offsetTop);
	            }, objectConstants.SCROLL_TO);
	        }
	    }, {
	        key: 'onOptionClick',
	        value: function onOptionClick(event) {
	            // console.log(this.state.responseData.latestResponse)
	            var response = {
	                selectedOption: appHelper.getObjectOption(this.state.screenObject.options, event.target.value)
	            };
	            // console.log(response.selectedOption);
	            this.setState({
	                checkAnswers: true,
	                responseData: Object.assign({}, this.state.responseData, {
	                    //responses: dataHelper.immutablePush(this.state.responseData.responses, response),
	                    latestResponse: Object.assign({}, response.selectedOption),
	                    displayState: objectConstants.OBJECT_DISPLAY_STATE_ANSWERED
	                }),
	                enableCheckBtn: true,
	                showOptions: true
	            });
	            this.scrollToSubmitBtn();
	        }
	    }, {
	        key: 'setActiveOption',
	        value: function setActiveOption(option) {
	            var response = {
	                selectedOption: option
	            };
	
	            if (this.state.responseData.latestResponse !== option) {
	                this.setState({
	                    responseData: Object.assign({}, this.state.responseData, {
	                        latestResponse: option
	                    })
	                });
	            }
	        }
	    }, {
	        key: 'getClass',
	        value: function getClass(option) {
	            return appHelper.isDefined(this.state.responseData.latestResponse.option_id) && option.option_id === this.state.responseData.latestResponse.option_id ? "active" : "";
	        }
	    }, {
	        key: 'enableDrag',
	        value: function enableDrag() {
	            this.setState({ setDrags: false });
	            var setActiveOption = this.setActiveOption;
	            var checkAnswers = this.checkAnswers;
	            var question = this.refs[this.state.screenObject.asset_id + '_question'];
	            var swipeCard = this.refs[this.state.screenObject.asset_id + '_swipe_card'];
	            var swipeCardContent = this.refs[this.state.screenObject.asset_id + '_swipe_card_content'];
	            var leftOption = Object.assign({}, this.state.leftOption);
	            var rightOption = Object.assign({}, this.state.rightOption);
	            var moveTo = 0;
	            var questionHalfWidth = appHelper.isDefined(question) ? question.offsetWidth / 2 : '100%';
	            var swipeCardHalfWidth = appHelper.isDefined(swipeCard) ? swipeCard.offsetWidth / 2 : '100%';
	
	            _gsap.TweenLite.set(swipeCard, { clearProps: "all" });
	            _Draggable2.default.create(swipeCard, {
	                bounds: question,
	                throwProps: false,
	                lockAxis: true,
	                type: "x",
	                onDrag: function onDrag() {
	                    var dragPosX = this.x;
	                    this.y = 0;
	                    if (dragPosX < -30) {
	                        setActiveOption(leftOption);
	                    } else if (dragPosX > 30) {
	                        setActiveOption(rightOption);
	                    } else {
	                        setActiveOption({});
	                    }
	
	                    //console.log(dragPosX);
	                },
	                onDragEnd: function onDragEnd() {
	
	                    var dragPosX = this.x;
	                    if (dragPosX < -30) {
	                        this.disable();
	                        //moveTo = 0 - (questionHalfWidth - swipeCardHalfWidth);
	                        _gsap.TweenLite.to(swipeCard, 0.3, {
	                            x: moveTo,
	                            y: 0,
	                            onComplete: checkAnswers
	                            //onCompleteParams:[leftOption]
	                        });
	                    } else if (dragPosX > 30) {
	                        this.disable();
	                        //moveTo = questionHalfWidth - swipeCardHalfWidth;
	                        _gsap.TweenLite.to(swipeCard, 0.3, {
	                            x: moveTo,
	                            y: 0,
	                            onComplete: checkAnswers
	                            //onCompleteParams:[rightOption]
	                        });
	                    } else {
	                        _gsap.TweenLite.to(swipeCard, 0.3, {
	                            x: moveTo,
	                            y: 0
	                            //onComplete: checkAnswers,
	                            //onCompleteParams:[{}]
	                        });
	                    }
	                }
	            });
	        }
	    }, {
	        key: 'checkAnswers',
	        value: function checkAnswers() {
	            this.setState({ checkAnswers: false });
	            var response = {
	                selectedOption: this.state.responseData.latestResponse
	            };
	            var showResponse = false;
	            var enable_feedback = this.state.responseData.latestResponse.enable_feedback;
	            if (appHelper.isDefined(this.state.responseData.latestResponse.dialogs) && this.state.responseData.latestResponse.dialogs.length > 0) {
	                showResponse = true;
	            }
	
	            var hasBadges = appHelper.isDefined(this.state.responseData.latestResponse.badges) && this.state.responseData.latestResponse.badges.length > 0 && !enable_feedback && !showResponse;
	            var progressionType = appHelper.isDefined(this.state.responseData.latestResponse.progression_type) ? this.state.responseData.latestResponse.progression_type : undefined;
	
	            this.setState({
	                responseData: Object.assign({}, this.state.responseData, {
	                    responses: dataHelper.immutablePush(this.state.responseData.responses, response),
	                    displayState: objectConstants.OBJECT_DISPLAY_STATE_ANSWERED
	                    //latestResponse: Object.assign({}, this.state.responseData.latestResponse)
	                }),
	                showResponse: showResponse,
	                showFeedback: enable_feedback && !showResponse,
	                focusOnFeedback: enable_feedback && !showResponse,
	                skipFeedback: !enable_feedback && this.state.responseData.latestResponse.progression !== objectConstants.OBJECT_PROGRESSION_TRY_AGAIN && !showResponse,
	                showProgression: !enable_feedback && this.state.responseData.latestResponse.progression === objectConstants.OBJECT_PROGRESSION_TRY_AGAIN || !enable_feedback && this.state.responseData.latestResponse.progression !== objectConstants.OBJECT_PROGRESSION_TRY_AGAIN && !this.props.callbacks.hasNextObject(this.props.index) && progressionType !== objectConstants.GO_TO_TYPE_SCREEN && !showResponse,
	                progression_label: this.state.responseData.latestResponse.progression === objectConstants.OBJECT_PROGRESSION_TRY_AGAIN ? appHelper.getLocaleString("try_again_label") : appHelper.getLocaleString("continue_label"),
	                hasBadges: hasBadges,
	                questionChecked: true,
	                currentlyChecked: true,
	                showOptions: true,
	                checkPostXAPIResponse: true
	            });
	        }
	    }, {
	        key: 'handleResponseComplete',
	        value: function handleResponseComplete() {
	            var enable_feedback = this.state.responseData.latestResponse.enable_feedback;
	            var progressionType = appHelper.isDefined(this.state.responseData.latestResponse.progression_type) ? this.state.responseData.latestResponse.progression_type : undefined;
	
	            if (this.state.status !== objectConstants.STATUS_COMPLETE) {
	                this.setState({
	                    showFeedback: enable_feedback && this.state.responseData.displayState !== objectConstants.OBJECT_DISPLAY_STATE_REVIEW,
	                    focusOnFeedback: enable_feedback && this.state.responseData.displayState !== objectConstants.OBJECT_DISPLAY_STATE_REVIEW,
	                    hasBadges: appHelper.isDefined(this.state.responseData.latestResponse.badges) && this.state.responseData.latestResponse.badges.length > 0 && !enable_feedback,
	                    skipFeedback: !enable_feedback && this.state.responseData.latestResponse.progression !== objectConstants.OBJECT_PROGRESSION_TRY_AGAIN,
	                    showProgression: !enable_feedback && this.state.responseData.latestResponse.progression === objectConstants.OBJECT_PROGRESSION_TRY_AGAIN || !enable_feedback && this.state.responseData.latestResponse.progression !== objectConstants.OBJECT_PROGRESSION_TRY_AGAIN && !this.props.callbacks.hasNextObject(this.props.index) && progressionType !== objectConstants.GO_TO_TYPE_SCREEN
	
	                });
	            }
	        }
	    }, {
	        key: 'hideOptions',
	        value: function hideOptions() {
	            this.setState({ hideOptions: false });
	            var optionsListRef = this.refs[this.state.screenObject.asset_id + '_optionList'];
	            _gsap.TweenLite.to(optionsListRef, 1, {
	                height: 0,
	                ease: _gsap.Expo.easeInOut
	            }); //.eventCallback("onComplete", this.onHideComplete);
	        }
	    }, {
	        key: 'getSwipeClass',
	        value: function getSwipeClass() {
	            return this.state.showFeedback ? 'feedback-panel ' + this.state.responseData.latestResponse.result : "swipe-card draggable";
	        }
	    }, {
	        key: 'handleResponse',
	        value: function handleResponse() {
	            this.setState({ hideFeedback: false });
	            var latestResponseFeedbackLocale = appHelper.getLocalData(this.state.responseData.latestResponse);
	            var progressionRule = this.state.responseData.latestResponse.progression;
	            if (progressionRule === objectConstants.OBJECT_PROGRESSION_TRY_AGAIN) {
	                this.reattempt();
	            } else {
	                this.setState({
	                    showFeedback: !this.props.callbacks.hasNextObject(this.props.index) && this.hasFeedbackToShow() && this.state.responseData.displayState !== objectConstants.OBJECT_DISPLAY_STATE_REVIEW,
	                    focusOnFeedback: !this.props.callbacks.hasNextObject(this.props.index) && this.hasFeedbackToShow(),
	                    showOptions: true,
	
	                    options: dataHelper.immutableSplice(this.state.options, 0, this.state.options.length, this.state.responseData.latestResponse),
	                    responseData: Object.assign({}, this.state.responseData, {
	                        currentStatus: objectConstants.STATUS_COMPLETE,
	                        displayState: objectConstants.OBJECT_DISPLAY_STATE_REVIEW
	                    })
	                });
	            }
	            this.handleProgression();
	            //}
	        }
	    }, {
	        key: 'hasFeedbackToShow',
	        value: function hasFeedbackToShow() {
	            var enable_feedback = this.state.responseData.latestResponse.enable_feedback;
	
	            return enable_feedback;
	        }
	    }, {
	        key: 'handleProgression',
	        value: function handleProgression() {
	            /*lorn
	            let navigateToNextScreen = true;
	            this.props.callbacks.onObjectComplete(progressionRule, this.state.screenObject.asset_id, this.state.responseData.latestResponse, navigateToNextScreen);*/
	            this.setState({ handleCompletion: false });
	            if (!this.state.progressionHandled) {
	                this.setState({ progressionHandled: true });
	                var enable_feedback = this.state.responseData.latestResponse.enable_feedback;
	                var hasBadges = appHelper.isDefined(this.state.responseData.latestResponse.badges) && this.state.responseData.latestResponse.badges.length > 0;
	
	                var progressionRule = this.state.responseData.latestResponse.progression;
	                var progressionType = appHelper.isDefined(this.state.responseData.latestResponse.progression_type) ? this.state.responseData.latestResponse.progression_type : undefined;
	                var progressionGoToId = appHelper.isDefined(this.state.responseData.latestResponse.progression_goto_id) ? this.state.responseData.latestResponse.progression_goto_id : undefined;
	                var completionData = {
	                    progression: progressionRule,
	                    asset_id: this.state.screenObject.asset_id,
	                    status: objectConstants.STATUS_COMPLETE,
	                    asset_type_code: this.state.screenObject.asset_type_code,
	                    navigateToNextScreen: progressionType !== objectConstants.GO_TO_TYPE_SCREEN,
	                    progressionType: progressionType,
	                    progressionGoToId: progressionGoToId,
	                    index: this.props.index
	
	                };
	
	                this.props.callbacks.onObjectComplete(completionData);
	            }
	        }
	    }, {
	        key: 'reattempt',
	        value: function reattempt() {
	            this.setState({
	                showFeedback: false,
	                enableCheckBtn: false,
	                showCheckBtn: false,
	                ///revealedOptions: dataHelper.immutableSplice(this.state.revealedOptions, 0, this.state.revealedOptions.length),
	                showOptions: true,
	                setDrags: true,
	                currentlyChecked: false,
	                focusedOption: this.state.options[0],
	                updateFocus: true,
	                responseData: Object.assign({}, this.state.responseData, {
	                    currentAttempt: this.state.responseData.currentAttempt + 1,
	                    currentStatus: objectConstants.STATUS_ATTEMPTED,
	                    displayState: objectConstants.OBJECT_DISPLAY_STATE_RETRY,
	                    latestResponse: Object.assign({}, {})
	
	                })
	            });
	        }
	
	        //REVEW POPUP
	
	    }, {
	        key: 'onReviewObject',
	        value: function onReviewObject(sourceId) {
	            if (this.hasFeedbackToShow()) {
	                var config = Object.assign({}, _dialogModels.MULTIPLE_CHOICE_REVIEW_CONFIG, {
	                    title: this.state.locale.label,
	                    sourceId: sourceId
	                });
	                //locale.title
	
	                for (var i = 0; i < config.childComponents.length; i++) {
	                    var child = config.childComponents[i];
	                    child.componentProps = Object.assign({}, {
	                        screenObject: this.state.screenObject,
	                        responseData: Object.assign({}, this.state.responseData, {
	                            displayState: objectConstants.OBJECT_DISPLAY_STATE_REVIEW
	                        }),
	                        callbacks: this.props.callbacks
	                    });
	                }
	                this.props.actions.setNewDialog(config);
	            }
	        }
	    }, {
	        key: 'getOptionListClass',
	        value: function getOptionListClass() {
	            return this.state.responseData.displayState === objectConstants.OBJECT_DISPLAY_STATE_REVIEW || this.state.responseData.displayState === objectConstants.OBJECT_DISPLAY_STATE_ANSWERED ? "multiple-choice-option-list" : "swipe-options-list";
	        }
	    }, {
	        key: 'onPromptRevealed',
	        value: function onPromptRevealed() {}
	    }, {
	        key: 'getBgClass',
	        value: function getBgClass() {
	            return this.state.showFeedback || this.state.responseData.displayState === objectConstants.OBJECT_DISPLAY_STATE_REVIEW || this.state.responseData.displayState === objectConstants.OBJECT_DISPLAY_STATE_ANSWERED ? "no-padding" : "";
	        }
	    }, {
	        key: 'getSwipeContainerClass',
	        value: function getSwipeContainerClass() {
	            return this.state.responseData.displayState !== objectConstants.OBJECT_DISPLAY_STATE_REVIEW && this.state.responseData.displayState !== objectConstants.OBJECT_DISPLAY_STATE_ANSWERED ? "swipe" : "";
	        }
	    }, {
	        key: 'getStatusClass',
	        value: function getStatusClass() {
	            return this.state.responseData.displayState === objectConstants.OBJECT_DISPLAY_STATE_REVIEW && this.props.contentData.experience.include_explore_feedback && this.hasFeedbackToShow() ? "complete" : "";
	        }
	    }, {
	        key: 'getTabIndex',
	        value: function getTabIndex() {
	            return this.state.responseData.displayState === objectConstants.OBJECT_DISPLAY_STATE_REVIEW && this.props.contentData.experience.include_explore_feedback ? 0 : -1;
	        }
	    }, {
	        key: 'onPanelClick',
	        value: function onPanelClick() {
	            if (this.state.responseData.displayState === objectConstants.OBJECT_DISPLAY_STATE_REVIEW && this.props.contentData.experience.include_explore_feedback && this.hasFeedbackToShow()) {
	                this.onReviewObject('question_wrapper_' + this.state.screenObject.asset_id);
	            }
	        }
	    }, {
	        key: 'onKeyboardPanelClick',
	        value: function onKeyboardPanelClick(event) {
	            if (event.which === keyboardConstants.ENTER_KEY || event.which === keyboardConstants.SPACEBAR_KEY) {
	                event.preventDefault();
	                if (this.state.responseData.displayState === objectConstants.OBJECT_DISPLAY_STATE_REVIEW && this.props.contentData.experience.include_explore_feedback) {
	                    this.onReviewObject('question_wrapper_' + this.state.screenObject.asset_id);
	                }
	            }
	        }
	    }, {
	        key: 'getImagePath',
	        value: function getImagePath(image) {
	            if (appConstants.DEVELOPMENT_MODE) {
	                if (appHelper.isDefined(image) && image.length > 0) {
	                    return __webpack_require__(16)("./" + image);
	                }
	            } else {
	                return image;
	            }
	        }
	    }, {
	        key: 'setFocusedOption',
	        value: function setFocusedOption() {
	            this.setState({ focusedOption: Object.assign({}, this.state.options[0]) });
	        }
	    }, {
	        key: 'clearFocusedOption',
	        value: function clearFocusedOption() {
	            this.setState({ focusedOption: Object.assign({}, {}) });
	        }
	    }, {
	        key: 'getPrevOption',
	        value: function getPrevOption() {
	            var optionIndex = appHelper.getArrayObjectIndexByKey(this.state.options, "option_id", this.state.focusedOption.option_id);
	            var nextOption = this.state.options[optionIndex - 1];
	            if (optionIndex <= 0) {
	                nextOption = this.state.options[this.state.options.length - 1];
	            }
	
	            this.setState({ focusedOption: Object.assign({}, nextOption), updateFocus: true });
	        }
	    }, {
	        key: 'getNextOption',
	        value: function getNextOption() {
	            var optionIndex = appHelper.getArrayObjectIndexByKey(this.state.options, "option_id", this.state.focusedOption.option_id);
	            var nextOption = this.state.options[optionIndex + 1];
	            if (optionIndex === this.state.options.length - 1) {
	                nextOption = this.state.options[0];
	            }
	            this.setState({ focusedOption: Object.assign({}, nextOption), updateFocus: true });
	        }
	    }, {
	        key: 'allowKeyAccessibility',
	        value: function allowKeyAccessibility() {
	            var responseData = this.state.responseData;
	            //if (responseData.displayState === objectConstants.OBJECT_DISPLAY_STATE_INITIAL) {
	            if (responseData.currentAttempt === responseData.responses.length) {
	                return false;
	            } else {
	                for (var i = 0; i < this.state.responseData.responses.length; i++) {
	                    var response = this.state.responseData.responses[i];
	                    if (response.selectedOption.option_id === this.state.focusedOption.option_id) {
	                        return false;
	                    }
	                }
	                return true;
	            }
	        }
	    }, {
	        key: 'setKeyboardAccessibility',
	        value: function setKeyboardAccessibility(event) {
	            if (event.which === keyboardConstants.ENTER_KEY || event.which === keyboardConstants.SPACEBAR_KEY) {
	                event.preventDefault();
	                if (this.allowKeyAccessibility()) {
	                    this.onOptionClick({ target: { value: this.state.focusedOption.option_id } });
	                } else {
	                    var responseData = this.state.responseData;
	                    if (responseData.displayState === objectConstants.OBJECT_DISPLAY_STATE_ANSWERED || responseData.displayState === objectConstants.OBJECT_DISPLAY_STATE_REVIEW && this.props.contentData.experience.include_explore_feedback) {
	                        this.onReviewObject('option_' + this.state.focusedOption.option_id);
	                    }
	                }
	            }
	
	            if (event.which === keyboardConstants.ARROW_LEFT_KEY) {
	                event.preventDefault();
	                this.getPrevOption();
	            }
	
	            if (event.which === keyboardConstants.ARROW_RIGHT_KEY) {
	                event.preventDefault();
	                this.getNextOption();
	            }
	
	            if (event.which === keyboardConstants.ARROW_UP_KEY) {
	                event.preventDefault();
	                this.getPrevOption();
	            }
	
	            if (event.which === keyboardConstants.ARROW_DOWN_KEY) {
	                event.preventDefault();
	                this.getNextOption();
	            }
	        }
	    }, {
	        key: 'onFocusOnFeedback',
	        value: function onFocusOnFeedback() {
	            var focusEl = document.getElementById('feedback_wrapper_' + this.state.screenObject.asset_id);
	            if (appHelper.isDefined(focusEl) && focusEl !== null) {
	                focusEl.focus();
	            }
	            this.setState({ focusOnFeedback: false });
	        }
	    }, {
	        key: 'setOptionCallbacks',
	        value: function setOptionCallbacks() {
	            this.setState({
	                optionCallbacks: Object.assign({}, this.state.optionCallbacks, {
	                    setKeyboardAccessibility: this.setKeyboardAccessibility
	                })
	            });
	        }
	    }, {
	        key: 'setOptionFocus',
	        value: function setOptionFocus() {
	
	            var focusEl = document.getElementById('option_' + this.state.focusedOption.option_id);
	            focusEl.focus();
	            this.setState({ updateFocus: false });
	        }
	    }, {
	        key: 'enableProgression',
	        value: function enableProgression(progression_label) {
	            var hasBadges = appHelper.isDefined(this.state.responseData.latestResponse.badges) && this.state.responseData.latestResponse.badges.length > 0;
	            var progressionType = appHelper.isDefined(this.state.responseData.latestResponse.progression_type) ? this.state.responseData.latestResponse.progression_type : undefined;
	            var showProgression = !hasBadges;
	            if (!this.props.callbacks.hasNextObject(this.props.index)) {
	                showProgression = !hasBadges && progressionType !== objectConstants.GO_TO_TYPE_SCREEN;
	            }
	            this.setState({
	                showProgression: showProgression,
	                hasBadges: hasBadges,
	                progression_label: this.state.responseData.latestResponse.progression === objectConstants.OBJECT_PROGRESSION_TRY_AGAIN ? appHelper.getLocaleString("try_again_label") : appHelper.getLocaleString("continue_label"),
	                canScrollToContinue: true,
	                canScrolltoProgression: true
	            });
	        }
	    }, {
	        key: 'onProgressionClicked',
	        value: function onProgressionClicked() {
	            var enable_feedback = this.state.responseData.latestResponse.enable_feedback;
	
	            this.setState({
	                showProgression: false,
	                hideFeedback: this.props.callbacks.hasNextObject(this.props.index) && this.state.responseData.latestResponse.progression !== objectConstants.OBJECT_PROGRESSION_TRY_AGAIN
	            });
	
	            if (!this.props.callbacks.hasNextObject(this.props.index) && this.state.responseData.latestResponse.progression !== objectConstants.OBJECT_PROGRESSION_TRY_AGAIN) {
	                this.props.callbacks.navigateToNextScreen();
	            } else if (this.state.responseData.latestResponse.progression === objectConstants.OBJECT_PROGRESSION_TRY_AGAIN) {
	                this.reattempt();
	            }
	        }
	    }, {
	        key: 'onBadgeCollected',
	        value: function onBadgeCollected() {
	
	            this.setState({ badgesCollected: true });
	            if (!this.props.callbacks.hasNextObject(this.props.index)) {
	                this.setState({
	                    showProgression: true,
	                    canScrollToContinue: true,
	                    canScrolltoProgression: true,
	                    progression_label: this.state.responseData.latestResponse.progression === objectConstants.OBJECT_PROGRESSION_TRY_AGAIN ? appHelper.getLocaleString("try_again_label") : appHelper.getLocaleString("continue_label")
	                });
	            }
	            this.handleResponse();
	
	            //this.hide();
	        }
	    }, {
	        key: 'show',
	        value: function show() {
	            var questionRef = this.refs['swipeContainer_' + this.state.screenObject.asset_id];
	            if (appHelper.isDefined(questionRef)) {
	                _gsap.TweenLite.set(questionRef, { height: "auto" });
	                _gsap.TweenLite.from(questionRef, objectConstants.SHOW_PANEL_DURATION, {
	                    height: 0,
	                    ease: _gsap.Expo.easeInOut
	                }).eventCallback("onComplete", this.scrollToTop);
	            }
	        }
	    }, {
	        key: 'scrollToContinue',
	        value: function scrollToContinue() {
	            this.setState({ canScrollToContinue: false });
	            var question = this.refs[this.state.screenObject.asset_id + '_question'];
	            var scrollTo = this.props.callbacks.scrollTo;
	            setTimeout(function () {
	                scrollTo(question.offsetTop, true);
	            }, objectConstants.SCROLL_TO);
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this3 = this;
	
	            return _react2.default.createElement(
	                'div',
	                { className: 'learner-action', ref: this.state.screenObject.asset_id + '_question' },
	                _react2.default.createElement(
	                    'p',
	                    { className: 'hidden-el' },
	                    this.state.multiple_choice_single_answer_question_label
	                ),
	                appHelper.isDefined(this.props.characterPose) && appHelper.isDefined(this.props.characterPose.src) && this.props.characterPose.src.length > 0 ? _react2.default.createElement(
	                    'div',
	                    { className: 'content-character-expression' },
	                    _react2.default.createElement('img', { src: this.getImagePath(this.props.characterPose.src), alt: '' })
	                ) : null,
	                _react2.default.createElement(
	                    'div',
	                    { className: 'question-wrapper ' + this.getStatusClass(), tabIndex: this.getTabIndex(),
	                        id: 'question_wrapper_' + this.state.screenObject.asset_id,
	                        role: 'presentation', onClick: this.onPanelClick, onKeyDown: this.onKeyboardPanelClick },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'swipe-container', ref: 'swipeContainer_' + this.state.screenObject.asset_id },
	                        this.state.screenObject.show_title && this.state.responseData.displayState !== objectConstants.OBJECT_DISPLAY_STATE_REVIEW && this.state.responseData.displayState !== objectConstants.OBJECT_DISPLAY_STATE_ANSWERED ? _react2.default.createElement(
	                            'div',
	                            { className: 'object-container no-btm-margin' },
	                            _react2.default.createElement('h4', {
	                                dangerouslySetInnerHTML: { __html: this.state.locale.label } })
	                        ) : null,
	                        this.state.responseData.displayState === objectConstants.OBJECT_DISPLAY_STATE_REVIEW || this.state.responseData.displayState === objectConstants.OBJECT_DISPLAY_STATE_ANSWERED ? _react2.default.createElement(
	                            'div',
	                            { className: 'object-container', ref: 'prompt_' + this.state.screenObject.asset_id },
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'question-prompt' },
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: 'content-column' },
	                                    this.state.screenObject.show_title && appHelper.isDefined(this.state.locale.label) && this.state.locale.label.length > 0 ? _react2.default.createElement('h4', { className: 'bold',
	                                        dangerouslySetInnerHTML: { __html: this.state.locale.label } }) : null,
	                                    appHelper.isDefined(this.state.locale.description) && this.state.locale.description !== null && this.state.locale.description.length > 0 ? _react2.default.createElement('div', { dangerouslySetInnerHTML: { __html: this.state.locale.description } }) : null
	                                )
	                            )
	                        ) : null,
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'swipe-bg ' + this.getBgClass() },
	                            _react2.default.createElement(
	                                'div',
	                                { className: this.getSwipeContainerClass() },
	                                this.state.showOptions ? _react2.default.createElement(
	                                    'div',
	                                    { className: '' + this.getOptionListClass(),
	                                        id: this.state.screenObject.asset_id + '_questionOptions',
	                                        ref: this.state.screenObject.asset_id + '_questionOptions',
	                                        role: 'radiogroup' },
	                                    this.state.options.map(function (option) {
	                                        return _react2.default.createElement(_SwipeHorizontalOption2.default, { key: option.option_id,
	                                            option: option,
	                                            asset_id: _this3.state.screenObject.asset_id,
	                                            questionChecked: _this3.state.questionChecked,
	                                            currentlyChecked: _this3.state.currentlyChecked,
	                                            onOptionClick: _this3.onOptionClick,
	                                            responseData: _this3.state.responseData,
	                                            className: _this3.getClass(option)
	                                            //onAttemptComplete={this.showFeedback}
	                                            //onOptionRevealed={this.onOptionRevealed}
	                                            , focusedOption: _this3.state.focusedOption,
	                                            onReviewObject: _this3.onReviewObject,
	                                            index: appHelper.getObjectOptionIndex(_this3.state.screenObject.options, option.option_id),
	                                            showFeedback: appHelper.isDefined(_this3.state.responseData.latestResponse.enable_feedback) && _this3.state.responseData.latestResponse.enable_feedback,
	                                            optionCallbacks: _this3.state.optionCallbacks
	                                        });
	                                    })
	                                ) : null,
	                                this.state.responseData.displayState !== objectConstants.OBJECT_DISPLAY_STATE_REVIEW && this.state.responseData.displayState !== objectConstants.OBJECT_DISPLAY_STATE_ANSWERED ? _react2.default.createElement(
	                                    'div',
	                                    { className: '' + this.getSwipeClass(),
	                                        ref: this.state.screenObject.asset_id + '_swipe_card' },
	                                    _react2.default.createElement('div', { className: 'swipe-card-content',
	                                        ref: this.state.screenObject.asset_id + '_swipe_card_content',
	                                        dangerouslySetInnerHTML: { __html: this.state.locale.description } })
	                                ) : null
	                            )
	                        )
	                    ),
	                    this.state.showResponse ? _react2.default.createElement(_ChildConversationDialog2.default, { asset_id: this.state.screenObject.asset_id, option_id: this.state.responseData.latestResponse.option_id,
	                        dialogs: this.state.responseData.latestResponse.dialogs, callbacks: this.props.callbacks, onComplete: this.handleResponseComplete }) : null,
	                    this.state.showFeedback ? _react2.default.createElement(
	                        'div',
	                        { ref: 'feedback_wrapper_' + this.state.screenObject.asset_id,
	                            id: 'feedback_wrapper_' + this.state.screenObject.asset_id,
	                            role: 'article',
	                            tabIndex: 0,
	                            className: '' + this.getSwipeClass() },
	                        _react2.default.createElement(_SwipeHorizontalFeedback2.default, { screenObject: this.state.screenObject,
	                            option: this.state.responseData.latestResponse,
	                            options: this.state.screenObject.options,
	                            asset_id: this.state.screenObject.asset_id,
	                            responseData: this.state.responseData,
	                            onComplete: this.handleResponse,
	                            onShowReview: this.onReviewObject,
	                            onEnableProgression: this.enableProgression,
	                            hideFeedback: this.state.hideFeedback,
	                            index: this.props.index,
	                            callbacks: this.state.callbacks })
	                    ) : null,
	                    (this.state.showResponse || this.state.showFeedback) && this.state.hasBadges ? _react2.default.createElement('br', null) : null,
	                    this.state.hasBadges ? _react2.default.createElement(
	                        'div',
	                        { className: 'badge-wrapper' },
	                        this.state.responseData.latestResponse.badges.map(function (badge) {
	                            return _react2.default.createElement(_BadgeCollect2.default, { key: badge.badge_id, badge_id: badge.badge_id,
	                                bite_id: _this3.props.callbacks.getBiteId(),
	                                asset_id: _this3.state.screenObject.asset_id,
	                                onCollected: _this3.onBadgeCollected,
	                                animate: _this3.state.animateBadge
	                            });
	                        })
	                    ) : null
	                ),
	                this.state.showProgression ? _react2.default.createElement(
	                    'div',
	                    { ref: this.state.screenObject.asset_id + '_progression_btn' },
	                    _react2.default.createElement(_Button2.default, { label: this.state.progression_label, id: this.state.screenObject.asset_id + '_button',
	                        onClick: this.onProgressionClicked })
	                ) : null
	            );
	        }
	    }]);
	
	    return SwipeHorizontal;
	}(_react2.default.Component);
	
	SwipeHorizontal.propTypes = {
	    screenObject: _propTypes2.default.object.isRequired,
	    callbacks: _propTypes2.default.object.isRequired,
	    index: _propTypes2.default.number,
	    characterPose: _propTypes2.default.object,
	    contentData: _propTypes2.default.object.isRequired,
	    trackingData: _propTypes2.default.object.isRequired,
	    userData: _propTypes2.default.object.isRequired,
	    lang: _propTypes2.default.string.isRequired,
	    actions: _propTypes2.default.object.isRequired
	};
	
	SwipeHorizontal.contextTypes = {
	    router: _propTypes2.default.object
	};
	
	function mapStateToProps(state) {
	    var lang = state.userData.lang;
	    return {
	        lang: lang,
	        contentData: state.contentData,
	        trackingData: state.trackingData,
	        userData: state.userData
	
	    };
	}
	
	function mapDispatchToProps(dispatch) {
	    return {
	        actions: (0, _redux.bindActionCreators)(Object.assign({}, appDataActions, trackingDataActions, dialogPopupActions), dispatch)
	    };
	}
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(SwipeHorizontal);

/***/ },
/* 521 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(5);
	
	var _redux = __webpack_require__(4);
	
	var _Button = __webpack_require__(18);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _ResourceLinks = __webpack_require__(48);
	
	var _ResourceLinks2 = _interopRequireDefault(_ResourceLinks);
	
	var _appDataActions = __webpack_require__(12);
	
	var appDataActions = _interopRequireWildcard(_appDataActions);
	
	var _KpiDashboard = __webpack_require__(93);
	
	var _KpiDashboard2 = _interopRequireDefault(_KpiDashboard);
	
	var _OptionFeedback = __webpack_require__(199);
	
	var _OptionFeedback2 = _interopRequireDefault(_OptionFeedback);
	
	var _ScoreKpi = __webpack_require__(198);
	
	var _ScoreKpi2 = _interopRequireDefault(_ScoreKpi);
	
	var _ChildConversationDialog = __webpack_require__(65);
	
	var _ChildConversationDialog2 = _interopRequireDefault(_ChildConversationDialog);
	
	var _BadgeCollect = __webpack_require__(47);
	
	var _BadgeCollect2 = _interopRequireDefault(_BadgeCollect);
	
	var _trackingDataActions = __webpack_require__(7);
	
	var trackingDataActions = _interopRequireWildcard(_trackingDataActions);
	
	var _userDataActions = __webpack_require__(20);
	
	var userDataActions = _interopRequireWildcard(_userDataActions);
	
	var _appHelper = __webpack_require__(3);
	
	var appHelper = _interopRequireWildcard(_appHelper);
	
	var _dataHelper = __webpack_require__(11);
	
	var dataHelper = _interopRequireWildcard(_dataHelper);
	
	var _appConstants = __webpack_require__(13);
	
	var appConstants = _interopRequireWildcard(_appConstants);
	
	var _objectConstants = __webpack_require__(9);
	
	var objectConstants = _interopRequireWildcard(_objectConstants);
	
	var _kpiConstants = __webpack_require__(37);
	
	var kpiConstants = _interopRequireWildcard(_kpiConstants);
	
	var _localStorage = __webpack_require__(17);
	
	var localStorage = _interopRequireWildcard(_localStorage);
	
	var _keyboardConstants = __webpack_require__(14);
	
	var keyboardConstants = _interopRequireWildcard(_keyboardConstants);
	
	var _gsap = __webpack_require__(8);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } //eslint-disable-line import/no-named-as-default
	
	
	//eslint-disable-line import/no-named-as-default
	//eslint-disable-line import/no-named-as-default
	//eslint-disable-line import/no-named-as-default
	
	
	var SingleAnswerFeedback = function (_React$Component) {
	    _inherits(SingleAnswerFeedback, _React$Component);
	
	    function SingleAnswerFeedback(props, context) {
	        _classCallCheck(this, SingleAnswerFeedback);
	
	        var _this = _possibleConstructorReturn(this, (SingleAnswerFeedback.__proto__ || Object.getPrototypeOf(SingleAnswerFeedback)).call(this, props, context));
	
	        _this.state = {
	            lang: _this.props.lang,
	            option: _this.props.option,
	            options: _this.props.options,
	            locale: appHelper.getLocalData(_this.props.option),
	            hideFeedback: _this.props.hideFeedback,
	            showKpis: appHelper.isDefined(_this.props.option.kpis) && _this.props.option.kpis !== null,
	            showProgression: false,
	            enableProgression: _this.props.option.kpis === null,
	            optionFeedback: [],
	            kpiDashboardParams: {
	                showTitle: false,
	                showImmediateImpact: true,
	                allowUpdates: false
	            },
	            hasDialogs: appHelper.isDefined(_this.props.option.dialogs) && _this.props.option.dialogs.length > 0,
	            dialogComplete: !appHelper.isDefined(_this.props.option.dialogs) || _this.props.option.dialogs.length === 0,
	            hasBadges: appHelper.isDefined(_this.props.option.badges) && _this.props.option.badges.length > 0,
	            badgesCollected: false,
	            resourceLinks: [],
	            hasResources: false,
	            resourcesAreComplete: true,
	            completionCalled: false,
	            feedbackInterval: {},
	            review_other_options_label: appHelper.getLocaleString("review_other_options_label")
	        };
	        _this.show = _this.show.bind(_this);
	        _this.onFeedbackRevealed = _this.onFeedbackRevealed.bind(_this);
	        _this.onFeedbackHidden = _this.onFeedbackHidden.bind(_this);
	        _this.onProgressionClicked = _this.onProgressionClicked.bind(_this);
	        _this.scrollToTop = _this.scrollToTop.bind(_this);
	        _this.handleOptionFeedback = _this.handleOptionFeedback.bind(_this);
	        _this.storeUserResponse = _this.storeUserResponse.bind(_this);
	        _this.enableProgression = _this.enableProgression.bind(_this);
	        _this.getLinkClass = _this.getLinkClass.bind(_this);
	        _this.getDisabledState = _this.getDisabledState.bind(_this);
	        _this.dialogsOnComplete = _this.dialogsOnComplete.bind(_this);
	        _this.onBadgeCollected = _this.onBadgeCollected.bind(_this);
	        _this.onResourcesComplete = _this.onResourcesComplete.bind(_this);
	        _this.setResources = _this.setResources.bind(_this);
	        _this.getAssets = _this.getAssets.bind(_this);
	        _this.getInheritedFeedback = _this.getInheritedFeedback.bind(_this);
	        _this.checkIsReadyToComplete = _this.checkIsReadyToComplete.bind(_this);
	        _this.setComplete = _this.setComplete.bind(_this);
	        _this.showProgressButton = _this.showProgressButton.bind(_this);
	        _this.setKeyboardAccessibility = _this.setKeyboardAccessibility.bind(_this);
	        _this.onReview = _this.onReview.bind(_this);
	        _this.setFeedbackInterval = _this.setFeedbackInterval.bind(_this);
	        _this.checkShowProgressButton = _this.checkShowProgressButton.bind(_this);
	        return _this;
	    }
	
	    _createClass(SingleAnswerFeedback, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            // this.handleOptionFeedback();
	            this.setResources();
	            this.show();
	            this.setFeedbackInterval();
	            if (appHelper.isDefined(this.props.callbacks.updateCharacterExpression) && appHelper.isDefined(this.state.option.character_pose)) {
	                this.props.callbacks.updateCharacterExpression(this.state.option.character_pose);
	            }
	            this.getAssets();
	        }
	    }, {
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(nextProps) {
	            if (this.state.hideFeedback !== nextProps.hideFeedback) {
	                this.setState({ hideFeedback: nextProps.hideFeedback });
	            }
	            if (this.state.lang !== nextProps.lang) {
	                this.setState({
	                    lang: nextProps.lang,
	                    locale: appHelper.getLocalData(this.state.option),
	                    review_other_options_label: appHelper.getLocaleString("review_other_options_label")
	                });
	            }
	        }
	    }, {
	        key: 'componentDidUpdate',
	        value: function componentDidUpdate() {
	            if (this.checkIsReadyToComplete()) {
	                this.setComplete();
	            }
	
	            if (this.state.hideFeedback) {
	                this.hide();
	            }
	        }
	    }, {
	        key: 'componentWillUnmount',
	        value: function componentWillUnmount() {
	            clearInterval(this.state.feedbackInterval);
	        }
	    }, {
	        key: 'setFeedbackInterval',
	        value: function setFeedbackInterval() {
	            var interval = setInterval(this.checkShowProgressButton, 500);
	            this.setState({ feedbackInterval: interval });
	        }
	    }, {
	        key: 'checkShowProgressButton',
	        value: function checkShowProgressButton() {
	            if (this.showProgressButton()) {
	                this.props.onEnableProgression(this.state.locale.progression_label);
	                clearInterval(this.state.feedbackInterval);
	            }
	        }
	    }, {
	        key: 'getAssets',
	        value: function getAssets() {
	            if (appHelper.isDefined(this.state.option.audio)) {
	                var audio = appHelper.getAudioAsset(this.state.option.audio);
	                var audioObj = {
	                    audioRef: 'audio_' + audio.id + '_' + audio.type
	                };
	
	                this.props.actions.setAudio(audioObj);
	            }
	        }
	    }, {
	        key: 'storeUserResponse',
	        value: function storeUserResponse() {
	            var selectedOptions = [this.state.option.option_id];
	            var responseObj = {
	                asset_id: this.props.asset_id,
	                selectedOptions: selectedOptions,
	                kpis: this.state.option.kpis !== null ? this.state.option.kpis : []
	            };
	            this.props.callbacks.storeUserResponse(responseObj);
	        }
	    }, {
	        key: 'scrollToTop',
	        value: function scrollToTop() {
	            var feedback = document.getElementById('feedback_wrapper_' + this.props.asset_id);
	            this.props.callbacks.scrollToFeedback(feedback.offsetTop);
	        }
	    }, {
	        key: 'enableProgression',
	        value: function enableProgression() {
	            this.setState({ enableProgression: true });
	        }
	    }, {
	        key: 'getLinkClass',
	        value: function getLinkClass() {
	            return this.state.enableProgression ? "" : "disabled-link";
	        }
	    }, {
	        key: 'getDisabledState',
	        value: function getDisabledState() {
	            return !this.state.enableProgression;
	        }
	    }, {
	        key: 'handleOptionFeedback',
	        value: function handleOptionFeedback() {
	            var feedbackOptions = [];
	            var noMsgObj = {
	                id: "none",
	                feedback: "",
	                options: []
	            };
	
	            var optionsForFeedback = [];
	            for (var i = 0; i < this.props.options.length; i++) {
	                var option = this.props.options[i];
	                var locale = appHelper.getLocalData(option);
	
	                var isChecked = this.state.option.option_id === option.option_id;
	                var optionObject = {
	                    result: option.result,
	                    className: isChecked ? 'checked' : 'unchecked',
	                    option_text: locale.option,
	                    option_id: option.option_id,
	                    kpis: appHelper.isDefined(option.kpis) && option.kpis !== null ? option.kpis : []
	                };
	
	                if (isChecked) {
	                    optionsForFeedback = dataHelper.immutablePush(optionsForFeedback, optionObject);
	                }
	            }
	
	            if (optionsForFeedback.length > 1) {
	
	                optionsForFeedback.sort(function (a, b) {
	                    if (a.className < b.className) return -1;
	                    if (a.className > b.className) return 1;
	                    return 0;
	                });
	            }
	
	            if (optionsForFeedback.length > 0) {
	                noMsgObj = Object.assign({}, noMsgObj, {
	                    options: Object.assign([], optionsForFeedback)
	                });
	            }
	
	            if (noMsgObj.options.length > 0) {
	                feedbackOptions = dataHelper.immutablePush(feedbackOptions, noMsgObj);
	            }
	
	            this.setState({ optionFeedback: Object.assign([], feedbackOptions) });
	        }
	    }, {
	        key: 'onFeedbackRevealed',
	        value: function onFeedbackRevealed() {
	            this.storeUserResponse();
	            this.scrollToTop();
	        }
	    }, {
	        key: 'onFeedbackHidden',
	        value: function onFeedbackHidden() {
	            //this.props.callbacks.resizeWatcher();
	            if (typeof this.props.onComplete !== 'undefined') {
	                this.props.onComplete();
	            }
	        }
	    }, {
	        key: 'showFeedbackContent',
	        value: function showFeedbackContent() {
	            this.setState({ showFeedbackContent: true });
	        }
	    }, {
	        key: 'onProgressionClicked',
	        value: function onProgressionClicked() {
	            this.hide();
	        }
	    }, {
	        key: 'show',
	        value: function show() {
	            var feedbackPanel = this.refs[this.state.option.option_id + '_feedbackPanel'];
	            _gsap.TweenLite.set(feedbackPanel, { height: "auto", opacity: 1 });
	            _gsap.TweenLite.from(feedbackPanel, objectConstants.FEEDBACK_DURATION, {
	                height: 0,
	                opacity: 0,
	                ease: _gsap.Expo.easeIn
	            }).eventCallback("onComplete", this.onFeedbackRevealed);
	            /**/
	        }
	    }, {
	        key: 'hide',
	        value: function hide() {
	            this.setState({ hideFeedback: false });
	            var feedbackPanel = this.refs[this.state.option.option_id + '_feedbackPanel'];
	            _gsap.TweenLite.to(feedbackPanel, objectConstants.FEEDBACK_DURATION, {
	                height: 0,
	                opacity: 0,
	                ease: _gsap.Expo.easeIn
	            }).eventCallback("onComplete", this.onFeedbackHidden);
	        }
	    }, {
	        key: 'onToolboxComplete',
	        value: function onToolboxComplete(progression, asset_id, latestResponse) {
	            this.setState({ toolboxIsComplete: true });
	        }
	    }, {
	        key: 'setToolboxCallbacks',
	        value: function setToolboxCallbacks() {
	            this.setState({
	                toolboxCallbacks: Object.assign({}, this.state.toolboxCallbacks, {
	                    onObjectComplete: this.onToolboxComplete,
	                    isReviewMode: function isReviewMode() {
	                        return false;
	                    }
	                })
	            });
	        }
	    }, {
	        key: 'onBadgeCollected',
	        value: function onBadgeCollected() {
	            this.setState({ badgesCollected: true });
	            //this.hide();
	        }
	    }, {
	        key: 'dialogsOnComplete',
	        value: function dialogsOnComplete() {
	            this.setState({ dialogComplete: true });
	        }
	    }, {
	        key: 'setResources',
	        value: function setResources() {
	            var resourceLinks = appHelper.setResourceLinks(this.state.option);
	            var hasRequiredResources = appHelper.hasRequiredResources(resourceLinks);
	            this.setState({
	                resourceLinks: Object.assign([], resourceLinks),
	                hasResources: resourceLinks.length > 0,
	                resourcesAreComplete: resourceLinks.length === 0 || !hasRequiredResources
	            });
	        }
	    }, {
	        key: 'onResourcesComplete',
	        value: function onResourcesComplete() {
	            if (!this.state.resourcesAreComplete) {
	                this.setState({ resourcesAreComplete: true, checkComplete: true });
	            }
	        }
	    }, {
	        key: 'getInheritedFeedback',
	        value: function getInheritedFeedback(feedback_id) {
	            var option = appHelper.getArrayObjectByKey(this.state.options, "option_id", feedback_id);
	            var optionLocale = appHelper.getLocalData(option);
	            return optionLocale.feedback;
	        }
	    }, {
	        key: 'checkIsReadyToComplete',
	        value: function checkIsReadyToComplete() {
	            return !this.props.callbacks.hasNextObject(this.props.index) && this.state.option.progression !== objectConstants.OBJECT_PROGRESSION_TRY_AGAIN && this.state.enableProgression && !this.state.completionCalled
	            //&& ((this.state.hasBadges && this.state.badgesCollected) || !this.state.hasBadges )
	            && this.state.resourcesAreComplete;
	        }
	    }, {
	        key: 'setComplete',
	        value: function setComplete() {
	            this.setState({ completionCalled: true });
	            this.props.onComplete();
	        }
	    }, {
	        key: 'showProgressButton',
	        value: function showProgressButton() {
	            return this.state.enableProgression && appHelper.isDefined(this.state.locale.progression_label) && this.state.resourcesAreComplete;
	        }
	    }, {
	        key: 'setKeyboardAccessibility',
	        value: function setKeyboardAccessibility(event) {
	
	            if (event.which === keyboardConstants.ENTER_KEY || event.which === keyboardConstants.SPACEBAR_KEY) {
	                event.preventDefault();
	                if (this.state.enableProgression) {
	                    this.onReview();
	                }
	            }
	        }
	    }, {
	        key: 'onReview',
	        value: function onReview() {
	            if (this.state.enableProgression) {
	                this.props.onShowReview('review_link_' + this.state.option.option_id);
	            }
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            return _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(
	                    'div',
	                    { ref: this.state.option.option_id + '_feedbackPanel' },
	                    _react2.default.createElement('img', { src: __webpack_require__(133)("./" + this.state.option.result + '.svg'), style: kpiConstants.WATERMARK_STYLES, alt: '' }),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'feedback-content-col' },
	                        this.state.showKpis ? _react2.default.createElement(_ScoreKpi2.default, { bite_id: this.props.responseData.bite_id,
	                            displayState: kpiConstants.KPI_DISPLAY_STATE_CURRENT_VALUE_NO_LABEL,
	                            showImmediateImpact: this.state.kpiDashboardParams.showImmediateImpact,
	                            showTitle: this.state.kpiDashboardParams.showTitle,
	                            onUpdateComplete: this.enableProgression }) : null,
	                        this.state.optionFeedback.length > 0 && this.props.option.enable_feedback ? _react2.default.createElement(_OptionFeedback2.default, { feedback_options: this.state.optionFeedback,
	                            asset_id: this.props.asset_id,
	                            responseData: this.props.responseData
	                        }) : null,
	                        appHelper.isDefined(this.state.locale.feedback) && this.state.locale.feedback.length > 0 && this.state.locale.feedback !== "<p><br></p>" && this.props.option.enable_feedback ? _react2.default.createElement('div', { dangerouslySetInnerHTML: { __html: this.state.locale.feedback } }) : appHelper.isDefined(this.state.option.feedback_id) ? _react2.default.createElement('div', {
	                            dangerouslySetInnerHTML: { __html: this.getInheritedFeedback(this.state.option.feedback_id) } }) : null,
	                        this.state.hasResources ? _react2.default.createElement(_ResourceLinks2.default, { resources: this.state.resourceLinks,
	                            onResourcesComplete: this.onResourcesComplete }) : null,
	                        this.props.option.progression === objectConstants.OBJECT_PROGRESSION_CONTINUE && this.state.resourcesAreComplete && this.props.contentData.experience.include_explore_feedback ? _react2.default.createElement(
	                            'div',
	                            { className: 'guroo-active-link text-center ' + this.getLinkClass(), role: 'link',
	                                tabIndex: '0',
	                                id: 'review_link_' + this.state.option.option_id,
	                                onKeyDown: this.setKeyboardAccessibility,
	                                onClick: this.onReview },
	                            this.state.review_other_options_label
	                        ) : null
	                    )
	                )
	            );
	        }
	    }]);
	
	    return SingleAnswerFeedback;
	}(_react2.default.Component);
	
	SingleAnswerFeedback.propTypes = {
	    screenObject: _propTypes2.default.object,
	    option: _propTypes2.default.object.isRequired,
	    options: _propTypes2.default.array.isRequired,
	    responseData: _propTypes2.default.object.isRequired,
	    callbacks: _propTypes2.default.object.isRequired,
	    asset_id: _propTypes2.default.number.isRequired,
	    onComplete: _propTypes2.default.func,
	    onShowReview: _propTypes2.default.func,
	    scrollToFeedback: _propTypes2.default.func,
	    actions: _propTypes2.default.object,
	    contentData: _propTypes2.default.object.isRequired,
	    onEnableProgression: _propTypes2.default.func,
	    index: _propTypes2.default.number,
	    lang: _propTypes2.default.string.isRequired,
	    hideFeedback: _propTypes2.default.bool
	};
	
	SingleAnswerFeedback.contextTypes = {
	    router: _propTypes2.default.object
	};
	
	function mapStateToProps(state, ownProps) {
	    var lang = state.userData.lang;
	    return {
	        lang: lang,
	        contentData: state.contentData
	    };
	}
	
	function mapDispatchToProps(dispatch) {
	    return {
	        actions: (0, _redux.bindActionCreators)(Object.assign({}, appDataActions, trackingDataActions, userDataActions), dispatch)
	    };
	}
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(SingleAnswerFeedback);

/***/ },
/* 522 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(5);
	
	var _redux = __webpack_require__(4);
	
	var _appDataActions = __webpack_require__(12);
	
	var appDataActions = _interopRequireWildcard(_appDataActions);
	
	var _trackingDataActions = __webpack_require__(7);
	
	var trackingDataActions = _interopRequireWildcard(_trackingDataActions);
	
	var _dialogPopupActions = __webpack_require__(19);
	
	var dialogPopupActions = _interopRequireWildcard(_dialogPopupActions);
	
	var _appHelper = __webpack_require__(3);
	
	var appHelper = _interopRequireWildcard(_appHelper);
	
	var _objectConstants = __webpack_require__(9);
	
	var objectConstants = _interopRequireWildcard(_objectConstants);
	
	var _gsap = __webpack_require__(8);
	
	var _gsapReactPlugin = __webpack_require__(10);
	
	var _gsapReactPlugin2 = _interopRequireDefault(_gsapReactPlugin);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var SwipeHorizontalOption = function (_React$Component) {
	    _inherits(SwipeHorizontalOption, _React$Component);
	
	    function SwipeHorizontalOption(props, context) {
	        _classCallCheck(this, SwipeHorizontalOption);
	
	        var _this = _possibleConstructorReturn(this, (SwipeHorizontalOption.__proto__ || Object.getPrototypeOf(SwipeHorizontalOption)).call(this, props, context));
	
	        _this.state = {
	            lang: _this.props.lang,
	            option: _this.props.option,
	            locale: appHelper.getLocalData(_this.props.option),
	            responseData: _this.props.responseData,
	            focusedOption: _this.props.focusedOption,
	            focusedClass: "not-focused"
	
	        };
	
	        _this.hideOption = _this.hideOption.bind(_this);
	        _this.showOption = _this.showOption.bind(_this);
	        _this.removeOption = _this.removeOption.bind(_this);
	        _this.onOptionHidden = _this.onOptionHidden.bind(_this);
	        _this.getDisabledState = _this.getDisabledState.bind(_this);
	        _this.getOptionClass = _this.getOptionClass.bind(_this);
	        _this.getClickFunction = _this.getClickFunction.bind(_this);
	        _this.handleOptionVisibility = _this.handleOptionVisibility.bind(_this);
	        _this.onOptionRevealed = _this.onOptionRevealed.bind(_this);
	        _this.renderOption = _this.renderOption.bind(_this);
	        _this.checkOptionIsFocused = _this.checkOptionIsFocused.bind(_this);
	        _this.getCheckedState = _this.getCheckedState.bind(_this);
	        _this.getIsChecked = _this.getIsChecked.bind(_this);
	        _this.getIsDisabled = _this.getIsDisabled.bind(_this);
	        _this.setFocus = _this.setFocus.bind(_this);
	        _this.setBlur = _this.setBlur.bind(_this);
	        _this.getScreenReaderOptionClass = _this.getScreenReaderOptionClass.bind(_this);
	        return _this;
	    }
	
	    _createClass(SwipeHorizontalOption, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            this.showOption(1, 0);
	        }
	    }, {
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(nextProps) {
	            if (this.state.responseData !== nextProps.responseData) {
	                this.setState({ responseData: nextProps.responseData, update: true });
	            }
	
	            if (this.state.focusedOption !== nextProps.focusedOption) {
	                this.setState({ focusedOption: Object.assign({}, nextProps.focusedOption) });
	            }
	
	            if (this.state.lang !== nextProps.lang) {
	                this.setState({
	                    lang: nextProps.lang,
	                    locale: appHelper.getLocalData(this.state.option)
	                });
	            }
	        }
	    }, {
	        key: 'componentDidUpdate',
	        value: function componentDidUpdate() {}
	    }, {
	        key: 'getOptionClass',
	        value: function getOptionClass() {
	            var responseData = this.state.responseData;
	            var latestResponse = appHelper.getLastItemOfArray(responseData.responses);
	            if (this.props.questionChecked) {
	                if (responseData.displayState !== objectConstants.OBJECT_DISPLAY_STATE_REVIEW) {
	                    if (responseData.currentAttempt === responseData.responses.length && latestResponse.selectedOption.option_id === this.state.option.option_id) {
	
	                        if (responseData.displayState !== objectConstants.OBJECT_DISPLAY_STATE_ANSWERED) {
	                            return 'active ' + this.state.option.result;
	                        } else if (responseData.displayState === objectConstants.OBJECT_DISPLAY_STATE_ANSWERED && this.props.showFeedback) {
	                            return 'selected  ' + this.state.option.result;
	                        } else if (responseData.displayState === objectConstants.OBJECT_DISPLAY_STATE_ANSWERED && !this.props.showFeedback) {
	                            return 'selected ' + this.state.option.result;
	                        }
	                    } else {
	                        for (var i = 0; i < this.state.responseData.responses.length; i++) {
	                            var response = this.state.responseData.responses[i];
	                            if (response.selectedOption.option_id === this.state.option.option_id) {
	                                return 'show-answer ' + this.state.option.result;
	                            }
	                        }
	                    }
	                } else if (responseData.displayState === objectConstants.OBJECT_DISPLAY_STATE_REVIEW) {
	                    if (responseData.currentAttempt === responseData.responses.length && latestResponse.selectedOption.option_id === this.state.option.option_id && this.props.showFeedback) {
	                        return 'selected answered ' + this.state.option.result;
	                    } else if (responseData.currentAttempt === responseData.responses.length && latestResponse.selectedOption.option_id === this.state.option.option_id && !this.props.showFeedback) {
	                        return 'selected inactive-answered ' + this.state.option.result;
	                    } else {
	                        return 'review ' + this.state.option.result;
	                    }
	                }
	            }
	            return "";
	        }
	    }, {
	        key: 'getScreenReaderOptionClass',
	        value: function getScreenReaderOptionClass() {
	            var responseData = this.state.responseData;
	            var latestResponse = appHelper.getLastItemOfArray(responseData.responses);
	            if (this.props.questionChecked) {
	                if (responseData.displayState !== objectConstants.OBJECT_DISPLAY_STATE_REVIEW) {
	                    if (responseData.currentAttempt === responseData.responses.length && latestResponse.selectedOption.option_id == this.state.option.option_id) {
	
	                        if (responseData.displayState !== objectConstants.OBJECT_DISPLAY_STATE_ANSWERED) {
	                            return "";
	                        } else if (responseData.displayState === objectConstants.OBJECT_DISPLAY_STATE_ANSWERED && this.props.showFeedback) {
	                            return appHelper.getOptionResultString(this.state.option.result, false);
	                        } else if (responseData.displayState === objectConstants.OBJECT_DISPLAY_STATE_ANSWERED && !this.props.showFeedback) {
	                            return appHelper.getOptionResultString(this.state.option.result, false);
	                        }
	                    } else {
	                        for (var i = 0; i < this.state.responseData.responses.length; i++) {
	                            var response = this.state.responseData.responses[i];
	                            if (response.selectedOption.option_id === this.state.option.option_id) {
	                                return appHelper.getOptionResultString(this.state.option.result, true);
	                            }
	                        }
	                    }
	                } else if (responseData.displayState === objectConstants.OBJECT_DISPLAY_STATE_REVIEW) {
	                    if (responseData.currentAttempt === responseData.responses.length && latestResponse.selectedOption.option_id === this.state.option.option_id && this.props.showFeedback) {
	                        return appHelper.getOptionResultString(this.state.option.result, false);
	                    } else if (responseData.currentAttempt === responseData.responses.length && latestResponse.selectedOption.option_id === this.state.option.option_id && !this.props.showFeedback) {
	                        return appHelper.getOptionResultString(this.state.option.result, false);
	                    } else {
	                        return appHelper.getOptionResultString(this.state.option.result, false);
	                    }
	                }
	            }
	            return "";
	        }
	    }, {
	        key: 'renderOption',
	        value: function renderOption() {
	            var responseData = this.state.responseData;
	            var latestResponse = appHelper.getLastItemOfArray(responseData.responses);
	            if (this.props.questionChecked && this.props.currentlyChecked) {
	                if (latestResponse.selectedOption.option_id === this.state.option.option_id) {
	                    return true;
	                } else {
	                    return false;
	                }
	            } else {
	                return true;
	            }
	        }
	    }, {
	        key: 'getClickFunction',
	        value: function getClickFunction() {
	            var responseData = this.state.responseData;
	            var latestResponse = appHelper.getLastItemOfArray(responseData.responses);
	            if (responseData.currentAttempt === responseData.responses.length && latestResponse.selectedOption.option_id === this.state.option.option_id && this.props.showFeedback) {
	                if (responseData.displayState === objectConstants.OBJECT_DISPLAY_STATE_REVIEW) {
	                    this.props.onReviewObject();
	                }
	            }
	        }
	    }, {
	        key: 'getDisabledState',
	        value: function getDisabledState() {
	            var responseData = this.state.responseData;
	            //if (responseData.displayState === objectConstants.OBJECT_DISPLAY_STATE_INITIAL) {
	            if (responseData.currentAttempt === responseData.responses.length && this.props.questionChecked) {
	                return 'disabled';
	            } else {
	                for (var i = 0; i < this.state.responseData.responses.length; i++) {
	                    var response = this.state.responseData.responses[i];
	                    if (response.selectedOption.option_id === this.state.option.option_id && this.props.questionChecked) {
	                        return 'disabled';
	                    }
	                }
	                return null;
	            }
	        }
	    }, {
	        key: 'handleOptionVisibility',
	        value: function handleOptionVisibility() {
	            var responseData = this.state.responseData;
	            var latestResponse = appHelper.getLastItemOfArray(responseData.responses);
	            //if user responsed have been logged
	            if (typeof latestResponse !== 'undefined' && responseData.displayState !== objectConstants.OBJECT_DISPLAY_STATE_REVIEW) {
	
	                // if currentAttempt has been answered and the current option id does not equal the selected option if then hide it
	                if (responseData.currentAttempt === responseData.responses.length && latestResponse.selectedOption.option_id !== this.state.option.option_id && this.props.questionChecked) {
	                    this.hideOption();
	                    // if currentAttempt has been answered and the current option id does equal the selected option if then show it but and the corners
	                } else if (responseData.currentAttempt === responseData.responses.length && latestResponse.selectedOption.option_id === this.state.option.option_id && this.props.questionChecked) {
	                    this.roundCorners();
	                    // if currentAttempt has not been answered then render all options with no animation
	                } else if (responseData.currentAttempt > responseData.responses.length && latestResponse.selectedOption.option_id !== this.state.option.option_id && !appHelper.isDefined(responseData.latestResponse.option_id)) {
	                    this.showOption(1, 0);
	                }
	                //if in review then reveal all options
	            } else if (responseData.displayState === objectConstants.OBJECT_DISPLAY_STATE_REVIEW) {
	                this.showOption(0, 0);
	            } else if (!appHelper.isDefined(responseData.latestResponse.option_id)) {
	                //if no user response has been logged yet then animate the
	                this.showOption(1, this.props.index / 2);
	            }
	        }
	    }, {
	        key: 'hideOption',
	        value: function hideOption() {
	            var optionRef = this.refs[this.state.option.option_id];
	            _gsap.TweenLite.to(optionRef, objectConstants.MC_OPTION_DURATION, {
	                opacity: 0,
	                delay: 0.5,
	                ease: _gsap.Expo.easeOut
	            }); //.eventCallback("onComplete", this.scaleOptionHeight);
	        }
	    }, {
	        key: 'showOption',
	        value: function showOption(duration, delay) {
	            var optionRef = this.refs[this.state.option.option_id];
	            _gsap.TweenLite.set(optionRef, { height: "auto", opacity: 1 });
	            _gsap.TweenLite.from(optionRef, 0.2, {
	                height: 0,
	                opacity: 0,
	
	                ease: _gsap.Expo.easeIn
	            }); //.eventCallback("onComplete", this.onOptionRevealed);
	        }
	    }, {
	        key: 'onOptionRevealed',
	        value: function onOptionRevealed() {
	            this.props.onOptionRevealed(this.props.option);
	        }
	    }, {
	        key: 'onOptionHidden',
	        value: function onOptionHidden() {
	            var responseData = this.state.responseData;
	            var latestResponse = appHelper.getLastItemOfArray(responseData.responses);
	
	            //if selected option is first in the list
	            if (latestResponse.index === 0) {
	                this.removeOption();
	            } else {
	                this.scaleOptionHeight();
	            }
	        }
	    }, {
	        key: 'removeOption',
	        value: function removeOption() {
	            //this.setState({render: false});
	        }
	    }, {
	        key: 'getCheckedState',
	        value: function getCheckedState() {
	            var responseData = this.state.responseData;
	            var latestResponse = responseData.latestResponse;
	            if (appHelper.isDefined(latestResponse.option_id) && latestResponse.option_id === this.state.option.option_id) {
	                //console.log(`getCheckedState`, latestResponse);
	                return 'checked';
	            }
	        }
	    }, {
	        key: 'checkOptionIsFocused',
	        value: function checkOptionIsFocused() {
	            return this.state.focusedOption.option_id === this.state.option.option_id ? "focus" : "not-focused";
	        }
	    }, {
	        key: 'getIsChecked',
	        value: function getIsChecked() {
	            var responseData = this.state.responseData;
	            var latestResponse = responseData.latestResponse;
	            if (appHelper.isDefined(latestResponse.option_id) && latestResponse.option_id === this.state.option.option_id) {
	                //console.log(`getCheckedState`, latestResponse);
	                return true;
	            }
	
	            return false;
	        }
	    }, {
	        key: 'getIsDisabled',
	        value: function getIsDisabled() {
	            var responseData = this.state.responseData;
	            //if (responseData.displayState === objectConstants.OBJECT_DISPLAY_STATE_INITIAL) {
	            if (responseData.currentAttempt === responseData.responses.length && this.props.questionChecked) {
	                return true;
	            } else {
	                for (var i = 0; i < this.state.responseData.responses.length; i++) {
	                    var response = this.state.responseData.responses[i];
	                    if (response.selectedOption.option_id === this.state.option.option_id && this.props.questionChecked) {
	                        return true;
	                    }
	                }
	                return false;
	            }
	        }
	    }, {
	        key: 'setFocus',
	        value: function setFocus() {
	            this.setState({ focusedClass: "focused" });
	        }
	    }, {
	        key: 'setBlur',
	        value: function setBlur() {
	            this.setState({ focusedClass: "not-focused" });
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	
	            return this.renderOption() ? _react2.default.createElement(
	                'div',
	                { className: 'multiple-choice-option ' + this.getOptionClass() + ' ' + this.props.className,
	                    ref: this.state.option.option_id,
	                    id: 'option_' + this.state.option.option_id,
	                    onKeyDown: this.props.optionCallbacks.setKeyboardAccessibility,
	                    onFocus: this.setFocus,
	                    onBlur: this.setBlur,
	                    role: 'radio',
	                    tabIndex: this.state.focusedOption.option_id === this.state.option.option_id ? 0 : -1,
	                    'aria-checked': this.getIsChecked(),
	                    'aria-disabled': this.getIsDisabled()
	                },
	                _react2.default.createElement('input', { id: this.props.asset_id + '_' + this.state.option.option_id, type: 'radio',
	                    name: this.props.asset_id,
	                    disabled: this.getDisabledState(),
	                    checked: this.getCheckedState(),
	                    value: this.state.option.option_id, onChange: this.props.onOptionClick }),
	                _react2.default.createElement(
	                    'label',
	                    { htmlFor: this.props.asset_id + '_' + this.state.option.option_id },
	                    _react2.default.createElement('span', { dangerouslySetInnerHTML: { __html: this.state.locale.option } }),
	                    _react2.default.createElement(
	                        'span',
	                        { className: 'hidden-el' },
	                        this.getScreenReaderOptionClass()
	                    )
	                )
	            ) : null;
	        }
	    }]);
	
	    return SwipeHorizontalOption;
	}(_react2.default.Component);
	
	SwipeHorizontalOption.propTypes = {
	    option: _propTypes2.default.object.isRequired,
	    asset_id: _propTypes2.default.number.isRequired,
	    questionChecked: _propTypes2.default.bool.isRequired,
	    currentlyChecked: _propTypes2.default.bool.isRequired,
	    responseData: _propTypes2.default.object.isRequired,
	    index: _propTypes2.default.number.isRequired,
	    onOptionClick: _propTypes2.default.func,
	    onAttemptComplete: _propTypes2.default.func,
	    onReviewObject: _propTypes2.default.func,
	    onOptionRevealed: _propTypes2.default.func,
	    focusedOption: _propTypes2.default.object,
	    optionCallbacks: _propTypes2.default.object,
	    showFeedback: _propTypes2.default.bool,
	    className: _propTypes2.default.string,
	    contentData: _propTypes2.default.object,
	    trackingData: _propTypes2.default.object,
	    lang: _propTypes2.default.string.isRequired,
	    actions: _propTypes2.default.object
	};
	
	SwipeHorizontalOption.contextTypes = {
	    router: _propTypes2.default.object
	};
	
	function mapStateToProps(state) {
	    var lang = state.userData.lang;
	    return {
	        lang: lang,
	        contentData: state.contentData,
	        trackingData: state.trackingData
	    };
	}
	
	function mapDispatchToProps(dispatch) {
	    return {
	        actions: (0, _redux.bindActionCreators)(Object.assign({}, appDataActions, trackingDataActions, dialogPopupActions), dispatch)
	    };
	}
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(SwipeHorizontalOption);

/***/ },
/* 523 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(5);
	
	var _redux = __webpack_require__(4);
	
	var _initActions = __webpack_require__(64);
	
	var initActions = _interopRequireWildcard(_initActions);
	
	var _trackingDataActions = __webpack_require__(7);
	
	var trackingDataActions = _interopRequireWildcard(_trackingDataActions);
	
	var _appHelper = __webpack_require__(3);
	
	var appHelper = _interopRequireWildcard(_appHelper);
	
	var _objectConstants = __webpack_require__(9);
	
	var objectConstants = _interopRequireWildcard(_objectConstants);
	
	var _gsap = __webpack_require__(8);
	
	var _gsapReactPlugin = __webpack_require__(10);
	
	var _gsapReactPlugin2 = _interopRequireDefault(_gsapReactPlugin);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Label = function (_React$Component) {
	    _inherits(Label, _React$Component);
	
	    function Label(props, context) {
	        _classCallCheck(this, Label);
	
	        var _this = _possibleConstructorReturn(this, (Label.__proto__ || Object.getPrototypeOf(Label)).call(this, props, context));
	
	        _this.state = {
	            isVisible: false
	        };
	        _this.show = _this.show.bind(_this);
	        _this.hide = _this.hide.bind(_this);
	        _this.onHideComplete = _this.onHideComplete.bind(_this);
	        _this.setContainerClass = _this.setContainerClass.bind(_this);
	        _this.setClass = _this.setClass.bind(_this);
	
	        return _this;
	    }
	
	    _createClass(Label, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            this.show();
	        }
	    }, {
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(nextProps) {
	            if (nextProps.doHide && this.state.isVisible) {
	                this.hide();
	            }
	        }
	    }, {
	        key: 'show',
	        value: function show() {
	            var optionRef = this.refs[this.props.id];
	            _gsap.TweenLite.set(optionRef, { height: "auto" });
	            _gsap.TweenLite.from(optionRef, objectConstants.SHOW_PANEL_DURATION, {
	                height: 0,
	                ease: _gsap.Expo.easeInOut
	            }).eventCallback("onComplete", this.onComplete);
	        }
	    }, {
	        key: 'hide',
	        value: function hide() {
	            var optionRef = this.refs[this.props.id];
	
	            _gsap.TweenLite.to(optionRef, objectConstants.SHOW_PANEL_DURATION, {
	                height: 0,
	                ease: _gsap.Expo.easeInOut
	            }).eventCallback("onComplete", this.onHideComplete);
	        }
	    }, {
	        key: 'onHideComplete',
	        value: function onHideComplete() {
	            this.setState({ isVisible: false });
	        }
	    }, {
	        key: 'setContainerClass',
	        value: function setContainerClass() {
	            if (appHelper.isDefined(this.props.container_class_name)) {
	                return this.props.container_class_name;
	            } else {
	                return 'object-container';
	            }
	        }
	    }, {
	        key: 'setClass',
	        value: function setClass() {
	            if (appHelper.isDefined(this.props.class_name)) {
	                return this.props.class_name;
	            } else {
	                return "";
	            }
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	
	            return _react2.default.createElement(
	                'div',
	                { className: '' + this.setContainerClass(), ref: this.props.id },
	                _react2.default.createElement(
	                    'div',
	                    { className: '' + this.setClass() },
	                    _react2.default.createElement(
	                        'div',
	                        null,
	                        this.props.text
	                    )
	                )
	            );
	        }
	    }]);
	
	    return Label;
	}(_react2.default.Component);
	
	Label.propTypes = {
	    screenObject: _propTypes2.default.object.isRequired,
	    id: _propTypes2.default.string.isRequired,
	    text: _propTypes2.default.string.isRequired,
	    class_name: _propTypes2.default.string,
	    doHide: _propTypes2.default.bool,
	    container_class_name: _propTypes2.default.string
	};
	
	Label.contextTypes = {
	    router: _propTypes2.default.object
	};
	
	function mapStateToProps(state, ownProps) {
	    return {};
	}
	
	function mapDispatchToProps(dispatch) {
	    return {
	        actions: (0, _redux.bindActionCreators)(Object.assign({}, initActions, trackingDataActions), dispatch)
	    };
	}
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(Label);

/***/ },
/* 524 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(5);
	
	var _redux = __webpack_require__(4);
	
	var _Button = __webpack_require__(18);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _ResourceLinks = __webpack_require__(48);
	
	var _ResourceLinks2 = _interopRequireDefault(_ResourceLinks);
	
	var _SecondaryImage = __webpack_require__(66);
	
	var _SecondaryImage2 = _interopRequireDefault(_SecondaryImage);
	
	var _SecondaryLibraryImage = __webpack_require__(67);
	
	var _SecondaryLibraryImage2 = _interopRequireDefault(_SecondaryLibraryImage);
	
	var _appDataActions = __webpack_require__(12);
	
	var appDataActions = _interopRequireWildcard(_appDataActions);
	
	var _trackingDataActions = __webpack_require__(7);
	
	var trackingDataActions = _interopRequireWildcard(_trackingDataActions);
	
	var _userDataActions = __webpack_require__(20);
	
	var userDataActions = _interopRequireWildcard(_userDataActions);
	
	var _dialogPopupActions = __webpack_require__(19);
	
	var dialogPopupActions = _interopRequireWildcard(_dialogPopupActions);
	
	var _appConstants = __webpack_require__(13);
	
	var appConstants = _interopRequireWildcard(_appConstants);
	
	var _appHelper = __webpack_require__(3);
	
	var appHelper = _interopRequireWildcard(_appHelper);
	
	var _userDataHelper = __webpack_require__(15);
	
	var userDataHelper = _interopRequireWildcard(_userDataHelper);
	
	var _objectConstants = __webpack_require__(9);
	
	var objectConstants = _interopRequireWildcard(_objectConstants);
	
	var _assetConstants = __webpack_require__(33);
	
	var assetConstants = _interopRequireWildcard(_assetConstants);
	
	var _imageHelper = __webpack_require__(203);
	
	var imageHelper = _interopRequireWildcard(_imageHelper);
	
	var _dialogModels = __webpack_require__(32);
	
	var _gsap = __webpack_require__(8);
	
	var _gsapReactPlugin = __webpack_require__(10);
	
	var _gsapReactPlugin2 = _interopRequireDefault(_gsapReactPlugin);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } //eslint-disable-line import/no-named-as-default
	
	
	var Text = function (_React$Component) {
	    _inherits(Text, _React$Component);
	
	    function Text(props, context) {
	        _classCallCheck(this, Text);
	
	        var _this = _possibleConstructorReturn(this, (Text.__proto__ || Object.getPrototypeOf(Text)).call(this, props, context));
	
	        _this.state = {
	            lang: _this.props.lang,
	            screenObject: _this.props.screenObject,
	            userData: _this.props.userData,
	            status: objectConstants.STATUS_NOT_STARTED,
	            locale: appHelper.getLocalData(_this.props.screenObject),
	            showProgressionButton: false,
	            icon: {
	                src: ""
	            },
	            screenAsset: {
	                src: ""
	            },
	            hasLeftAsset: appHelper.isDefined(_this.props.screenObject.left),
	            hasRightAsset: appHelper.isDefined(_this.props.screenObject.right),
	            hasTopAsset: appHelper.isDefined(_this.props.screenObject.top),
	            hasBottomAsset: appHelper.isDefined(_this.props.screenObject.bottom),
	            assetData: {},
	
	            screenStatus: "",
	            checkComplete: false,
	            resourceLinks: [],
	            isResourceObject: appHelper.isDefined(_this.props.callbacks.checkIsResourceScreen) && _this.props.callbacks.checkIsResourceScreen(),
	            hasResources: false,
	            resourcesAreComplete: false,
	            allowScroll: appHelper.allowScroll(_this.props.callbacks.getBiteId(), _this.props.callbacks.getScreenId(), _this.props.screenObject.asset_id),
	            progressionHandled: false,
	            imageStyles: {},
	            imageClass: "",
	            updateImageStyles: false,
	            imageStylesSet: false,
	            refValue: _this.props.screenObject.asset_id + '_contentWrapper',
	            reviewBtn: {
	                show: false,
	                label: '' + appHelper.getLocaleString("review_label")
	            },
	            clearBtn: {
	                show: false,
	                label: '' + appHelper.getLocaleString("clear_and_start_again_label")
	            },
	
	            menuBtn: {
	                show: false,
	                label: '' + appHelper.getLocaleString("return_to_menu_label")
	            },
	            exitBtn: {
	                show: false,
	                label: '' + appHelper.getLocaleString("exit_label")
	            },
	            progressionLabel: '' + appHelper.getLocaleString("continue_label"),
	            creditLabel: '' + appHelper.getLocaleString("credit_label")
	        };
	        _this.handleProgression = _this.handleProgression.bind(_this);
	        _this.scrollToTop = _this.scrollToTop.bind(_this);
	        _this.onComplete = _this.onComplete.bind(_this);
	        _this.enableProgression = _this.enableProgression.bind(_this);
	        _this.disableProgression = _this.disableProgression.bind(_this);
	        _this.getAssets = _this.getAssets.bind(_this);
	        _this.getAssetType = _this.getAssetType.bind(_this);
	        _this.getImagePath = _this.getImagePath.bind(_this);
	        _this.show = _this.show.bind(_this);
	        _this.onShowComplete = _this.onShowComplete.bind(_this);
	        _this.hide = _this.hide.bind(_this);
	        _this.onHideComplete = _this.onHideComplete.bind(_this);
	        _this.setClass = _this.setClass.bind(_this);
	        _this.setIconClass = _this.setIconClass.bind(_this);
	        _this.onProgressionBtnClicked = _this.onProgressionBtnClicked.bind(_this);
	        _this.getScreenStatus = _this.getScreenStatus.bind(_this);
	        _this.getObjectStatus = _this.getObjectStatus.bind(_this);
	        _this.onResourcesComplete = _this.onResourcesComplete.bind(_this);
	        _this.setResources = _this.setResources.bind(_this);
	        _this.onRendered = _this.onRendered.bind(_this);
	        _this.getImageStyles = _this.getImageStyles.bind(_this);
	
	        _this.clearResults = _this.clearResults.bind(_this);
	        _this.onReview = _this.onReview.bind(_this);
	        _this.setDisplay = _this.setDisplay.bind(_this);
	        _this.goToMenu = _this.goToMenu.bind(_this);
	        _this.exit = _this.exit.bind(_this);
	        _this.handleEndProgression = _this.handleEndProgression.bind(_this);
	        return _this;
	    }
	
	    _createClass(Text, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            this.setResources();
	            this.getAssets();
	            this.getImageStyles();
	            this.getScreenStatus();
	            this.show();
	            this.setDisplay();
	
	            if (appHelper.isDefined(this.props.callbacks.updateCharacterExpression) && appHelper.isDefined(this.state.screenObject.character_pose)) {
	                this.props.callbacks.updateCharacterExpression(this.state.screenObject.character_pose);
	            }
	        }
	    }, {
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(nextProps) {
	            if (this.state.userData !== nextProps.userData) {
	                this.setState({ userData: Object.assign({}, nextProps.userData) });
	            }
	            if (this.state.lang !== nextProps.lang) {
	                this.setState({
	                    lang: nextProps.lang,
	                    locale: appHelper.getLocalData(this.state.screenObject),
	                    reviewBtn: {
	                        label: '' + appHelper.getLocaleString("review_label")
	                    },
	                    clearBtn: {
	                        label: '' + appHelper.getLocaleString("clear_and_start_again_label")
	                    },
	
	                    menuBtn: {
	                        label: '' + appHelper.getLocaleString("return_to_menu_label")
	                    },
	                    exitBtn: {
	                        label: '' + appHelper.getLocaleString("exit_label")
	                    },
	                    progressionLabel: '' + appHelper.getLocaleString("continue_label"),
	                    creditLabel: '' + appHelper.getLocaleString("credit_label")
	
	                });
	            }
	        }
	    }, {
	        key: 'componentDidUpdate',
	        value: function componentDidUpdate() {
	
	            if (this.state.checkComplete) {
	
	                this.onComplete();
	            }
	
	            if (!this.state.imageStylesSet) {
	                this.getImageStyles();
	            }
	        }
	    }, {
	        key: 'setResources',
	        value: function setResources() {
	            var resourceLinks = appHelper.setResourceLinks(this.state.screenObject);
	            var hasRequiredResources = appHelper.hasRequiredResources(resourceLinks);
	
	            this.setState({
	                resourceLinks: Object.assign([], resourceLinks),
	                hasResources: resourceLinks.length > 0,
	                resourcesAreComplete: resourceLinks.length === 0 || !hasRequiredResources
	            });
	        }
	    }, {
	        key: 'getScreenStatus',
	        value: function getScreenStatus() {
	            var screenStatus = this.props.callbacks.getScreenStatus();
	            this.setState({
	                screenStatus: screenStatus,
	                status: screenStatus === objectConstants.STATUS_COMPLETE ? objectConstants.STATUS_COMPLETE : this.state.status
	            });
	        }
	    }, {
	        key: 'getObjectStatus',
	        value: function getObjectStatus() {
	            if (this.state.screenStatus === objectConstants.STATUS_COMPLETE) {
	
	                this.onComplete();
	            } else {
	                var objectUserData = {};
	                if (this.state.status !== objectConstants.STATUS_COMPLETE) {
	                    var subScreenParent = this.props.callbacks.getSubScreenParent();
	                    var screen_id = this.props.callbacks.getScreenId();
	                    if (appHelper.isDefined(subScreenParent)) {
	                        objectUserData = userDataHelper.getSubScreenObjectStatus(this.state.userData, subScreenParent.screen_id, screen_id, this.state.screenObject.asset_id);
	                    } else if (this.state.isResourceObject) {
	                        objectUserData = userDataHelper.getResourceScreenObjectUserData(this.state.userData, screen_id, this.state.screenObject.asset_id);
	                    } else {
	                        objectUserData = userDataHelper.getObjectStatus(this.state.userData, screen_id, this.state.screenObject.asset_id);
	                    }
	                }
	                if (objectUserData.status === objectConstants.STATUS_COMPLETE) {
	                    this.setState({ status: objectConstants.STATUS_COMPLETE, checkComplete: true });
	                } else {
	                    this.setState({ checkComplete: true });
	                }
	            }
	        }
	    }, {
	        key: 'getImagePath',
	        value: function getImagePath(image) {
	            if (appConstants.DEVELOPMENT_MODE) {
	                if (appHelper.isDefined(image) && image.length > 0) {
	                    return __webpack_require__(16)("./" + image);
	                }
	            } else {
	                return image;
	            }
	        }
	    }, {
	        key: 'getAssets',
	        value: function getAssets() {
	            var screenAsset = {};
	            var assetData = {};
	
	            if (this.state.hasLeftAsset) {
	                screenAsset = this.getAssetType(this.state.screenObject.left);
	                assetData = Object.assign({}, this.state.screenObject.left);
	            } else if (this.state.hasRightAsset) {
	                screenAsset = this.getAssetType(this.state.screenObject.right);
	                assetData = Object.assign({}, this.state.screenObject.right);
	            } else if (this.state.hasTopAsset) {
	                screenAsset = this.getAssetType(this.state.screenObject.top);
	                assetData = Object.assign({}, this.state.screenObject.top);
	            } else if (this.state.hasBottomAsset) {
	                screenAsset = this.getAssetType(this.state.screenObject.bottom);
	                assetData = Object.assign({}, this.state.screenObject.bottom);
	            }
	
	            if (appHelper.isDefined(this.state.screenObject.audio)) {
	
	                var objectUserData = {};
	                if (this.state.status !== objectConstants.STATUS_COMPLETE) {
	                    var subScreenParent = this.props.callbacks.getSubScreenParent();
	                    var screen_id = this.props.callbacks.getScreenId();
	                    if (appHelper.isDefined(subScreenParent)) {
	                        objectUserData = userDataHelper.getSubScreenObjectStatus(this.state.userData, subScreenParent.screen_id, screen_id, this.state.screenObject.asset_id);
	                    } else if (this.state.isResourceObject) {
	                        objectUserData = userDataHelper.getResourceScreenObjectUserData(this.state.userData, screen_id, this.state.screenObject.asset_id);
	                    } else {
	                        objectUserData = userDataHelper.getObjectStatus(this.state.userData, screen_id, this.state.screenObject.asset_id);
	                    }
	                }
	
	                var audio = appHelper.getAudioAsset(this.state.screenObject.audio);
	                var audioObj = {
	                    audioRef: 'audio_' + audio.id + '_' + audio.type
	                };
	
	                if (objectUserData.status !== objectConstants.STATUS_COMPLETE) {
	                    this.props.actions.setAudio(audioObj);
	                }
	            }
	
	            this.setState({
	                screenAsset: Object.assign({}, screenAsset),
	                assetData: Object.assign({}, assetData)
	            });
	        }
	    }, {
	        key: 'getAssetType',
	        value: function getAssetType(asset) {
	
	            var returnAsset = {};
	            if (asset.constant === assetConstants.ASSET_TYPE_ICON) {
	                returnAsset = appHelper.getIconAsset(asset);
	            } else if (asset.constant === assetConstants.ASSET_TYPE_IMAGE) {
	                returnAsset = appHelper.getImageAsset(asset);
	            } else if (asset.constant === assetConstants.ASSET_TYPE_LIBRARY_IMAGE) {
	                returnAsset = appHelper.getLibraryImageAsset(asset);
	            }
	            returnAsset = appHelper.isDefined(returnAsset.locale) ? appHelper.getLocalData(returnAsset) : returnAsset;
	
	            if (appHelper.isDefined(asset.constant) && !appHelper.isDefined(returnAsset.type)) {
	                returnAsset = Object.assign({}, returnAsset, {
	                    type: asset.constant
	                });
	            }
	
	            return returnAsset;
	        }
	    }, {
	        key: 'show',
	        value: function show() {
	            this.scrollToTop();
	            var optionRef = this.refs[this.state.screenObject.asset_id + '_text'];
	            _gsap.TweenLite.set(optionRef, { height: "auto" });
	            _gsap.TweenLite.from(optionRef, objectConstants.SHOW_PANEL_DURATION, {
	                height: 0,
	                ease: _gsap.Expo.easeInOut
	            }).eventCallback("onComplete", this.onRendered);
	        }
	    }, {
	        key: 'onRendered',
	        value: function onRendered() {
	            if (this.state.isResourceObject) {
	                this.props.callbacks.onObjectRendered();
	            }
	            this.getObjectStatus();
	        }
	    }, {
	        key: 'onShowComplete',
	        value: function onShowComplete() {
	            this.setState({ isVisible: true, checkComplete: false });
	        }
	    }, {
	        key: 'hide',
	        value: function hide() {
	            var optionRef = this.refs[this.state.screenObject.asset_id + '_text'];
	
	            _gsap.TweenLite.to(optionRef, objectConstants.SHOW_PANEL_DURATION, {
	                height: 0,
	                ease: _gsap.Expo.easeInOut
	            }).eventCallback("onComplete", this.onHideComplete);
	        }
	    }, {
	        key: 'onHideComplete',
	        value: function onHideComplete() {
	            this.setState({ isVisible: false });
	        }
	    }, {
	        key: 'scrollToTop',
	        value: function scrollToTop() {
	            if (this.state.allowScroll && this.state.status !== objectConstants.STATUS_COMPLETE) {
	                var question = this.refs[this.state.screenObject.asset_id + '_text'];
	                var scrollTo = this.props.callbacks.scrollTo;
	
	                setTimeout(function () {
	                    if (appHelper.isDefined(scrollTo)) {
	                        scrollTo(question.offsetTop);
	                    }
	                }, objectConstants.SCROLL_TO);
	            }
	        }
	    }, {
	        key: 'onComplete',
	        value: function onComplete() {
	            this.setState({ checkComplete: false });
	            if (this.state.screenObject.progression === objectConstants.OBJECT_PROGRESSION_END) {
	                if (this.state.resourcesAreComplete) {
	                    this.handleEndProgression();
	                }
	            } else {
	                var hasNextObject = this.props.callbacks.hasNextObject(this.props.index);
	                if (this.state.resourcesAreComplete) {
	                    if (appHelper.isDefined(this.state.screenObject.progression) && this.state.screenObject.progression === objectConstants.OBJECT_PROGRESSION_CONTINUE && (this.state.status !== objectConstants.STATUS_COMPLETE || !hasNextObject)) {
	                        if (!hasNextObject && !this.state.isResourceObject) {
	                            //console.log('progression 1')
	                            this.handleProgression();
	                            this.enableProgression();
	                        } else if (!hasNextObject && this.state.isResourceObject) {
	                            this.handleProgression();
	                        } else if (this.state.isResourceObject) {
	                            this.handleProgression();
	                        } else {
	                            this.enableProgression();
	                        }
	                    } else {
	
	                        this.handleProgression();
	                    }
	                }
	            }
	            this.scrollToTop();
	        }
	    }, {
	        key: 'enableProgression',
	        value: function enableProgression() {
	            if (!this.props.callbacks.isReviewMode()) {
	                this.setState({ showProgressionButton: true });
	            }
	        }
	    }, {
	        key: 'disableProgression',
	        value: function disableProgression() {
	            this.setState({ showProgressionButton: false });
	        }
	    }, {
	        key: 'handleProgression',
	        value: function handleProgression() {
	            if (!this.state.progressionHandled) {
	                var hasNextObject = this.props.callbacks.hasNextObject(this.props.index);
	                this.setState({ progressionHandled: true });
	                var progressionRule = this.state.screenObject.progression;
	                var progressionType = appHelper.isDefined(this.state.screenObject.progression_type) ? this.state.screenObject.progression_type : undefined;
	                var progressionGoToId = appHelper.isDefined(this.state.screenObject.progression_goto_id) ? this.state.screenObject.progression_goto_id : undefined;
	                var completionData = {
	                    progression: progressionRule,
	                    progressionType: progressionType,
	                    progressionGoToId: progressionGoToId,
	                    asset_id: this.state.screenObject.asset_id,
	                    status: objectConstants.STATUS_COMPLETE,
	                    showProgressionButton: !hasNextObject,
	                    asset_type_code: this.state.screenObject.asset_type_code,
	                    navigateToNextScreen: !this.state.isResourceObject && appHelper.isDefined(this.state.screenObject.progression) && this.state.screenObject.progression === objectConstants.OBJECT_PROGRESSION_CONTINUE,
	                    index: this.props.index
	                };
	
	                this.props.callbacks.onObjectComplete(completionData);
	            }
	            //t
	        }
	    }, {
	        key: 'handleEndProgression',
	        value: function handleEndProgression() {
	            var completionData = {
	                progression: objectConstants.OBJECT_PROGRESSION_CONTINUE,
	                asset_id: this.state.screenObject.asset_id,
	                status: objectConstants.STATUS_COMPLETE,
	                showProgressionButton: false,
	                asset_type_code: this.state.screenObject.asset_type_code,
	                navigateToNextScreen: appHelper.isDefined(this.state.screenObject.progression) && this.state.screenObject.progression === objectConstants.OBJECT_PROGRESSION_CONTINUE,
	                index: this.props.index
	            };
	
	            this.props.callbacks.onObjectComplete(completionData);
	        }
	    }, {
	        key: 'onProgressionBtnClicked',
	        value: function onProgressionBtnClicked() {
	            this.setState({ showProgressionButton: false });
	            if (this.props.callbacks.hasNextObject(this.props.index) || this.state.isResourceObject) {
	                this.handleProgression();
	            } else {
	                this.props.callbacks.navigateToNextScreen();
	            }
	        }
	    }, {
	        key: 'setClass',
	        value: function setClass() {
	
	            var className = "";
	            if (appHelper.isDefined(this.state.screenObject.class_name) && this.state.screenObject.class_name.length > 0) {
	                className += ' ' + this.state.screenObject.class_name;
	            } else {
	                className += "standard-block";
	            }
	
	            if (appHelper.isDefined(this.state.screenObject.bullet_list_style) && this.state.screenObject.bullet_list_style !== null) {
	                className += ' ' + this.state.screenObject.bullet_list_style;
	            }
	            return className;
	        }
	    }, {
	        key: 'setIconClass',
	        value: function setIconClass() {
	            var iconClass = '';
	
	            if (this.state.hasLeftAsset) {
	
	                iconClass += 'left-asset ';
	            } else if (this.state.hasRightAsset) {
	                iconClass += 'right-asset ';
	            } else if (this.state.hasTopAsset) {
	                iconClass += 'top-asset ';
	            } else if (this.state.hasBottomAsset) {
	                iconClass += 'bottom-asset ';
	            }
	
	            /*if (this.state.screenAsset.type === assetConstants.ASSET_TYPE_ICON) {
	                iconClass += 'icon ';
	            } else {
	                iconClass += 'image ';
	            }*/
	
	            if (this.state.assetData.constant === assetConstants.ASSET_TYPE_IMAGE) {
	                iconClass += 'image ';
	            }
	            return iconClass;
	        }
	    }, {
	        key: 'onResourcesComplete',
	        value: function onResourcesComplete() {
	            if (!this.state.resourcesAreComplete) {
	                this.setState({ resourcesAreComplete: true, checkComplete: true });
	            }
	        }
	    }, {
	        key: 'getImageStyles',
	        value: function getImageStyles() {
	            var refValue = this.refs[this.state.refValue];
	            if (appHelper.isDefined(refValue) && refValue !== null && appHelper.isDefined(this.state.screenAsset.src) && this.state.screenAsset.src.length > 0) {
	                var assetStyles = imageHelper.checkAssetImageWidth(this.state.screenObject, this.state.screenAsset, refValue.offsetWidth).styles;
	                this.setState({
	                    updateImageStyles: false,
	                    imageStylesSet: true,
	                    imageStyles: Object.assign({}, assetStyles),
	                    imageClass: imageHelper.getAssetImageClass(this.state.screenObject)
	                });
	            }
	        }
	    }, {
	        key: 'clearResults',
	        value: function clearResults() {
	            var _this2 = this;
	
	            var bite = appHelper.getBiteById(this.props.callbacks.getBiteId());
	            this.props.actions.clearBiteUserData(bite).then(function (userData) {
	                _this2.props.actions.setSuspendData(userData).then(function (userData) {
	                    _this2.onReview();
	                }).catch(function (error) {});
	            }).catch(function (error) {});
	        }
	    }, {
	        key: 'goToMenu',
	        value: function goToMenu() {
	            this.context.router.push('menu');
	        }
	    }, {
	        key: 'onReview',
	        value: function onReview() {
	            var bite = appHelper.getBiteById(this.props.callbacks.getBiteId());
	            var go_to_screen_id = bite.screens[0].screen_id;
	            if (this.props.contentData.experience.bites.length > 1) {
	                go_to_screen_id = this.props.contentData.experience.bites[0].screens[0].screen_id;
	            }
	            this.props.callbacks.goToScreen(go_to_screen_id);
	        }
	    }, {
	        key: 'setDisplay',
	        value: function setDisplay() {
	            if (this.state.screenObject.progression === objectConstants.OBJECT_PROGRESSION_END) {
	                if (this.state.screenObject.end_action === objectConstants.END_ACTION_REVIEW) {
	                    this.setState({
	                        reviewBtn: Object.assign({}, this.state.reviewBtn, {
	                            show: true
	                        })
	                    });
	                } else if (this.state.screenObject.end_action === objectConstants.END_ACTION_REVIEW_OR_CLEAR) {
	                    this.setState({
	                        reviewBtn: Object.assign({}, this.state.reviewBtn, {
	                            show: true
	                        }),
	                        clearBtn: Object.assign({}, this.state.clearBtn, {
	                            show: true
	                        })
	                    });
	                } else if (this.state.screenObject.end_action === objectConstants.END_ACTION_CLEAR) {
	                    this.setState({
	                        clearBtn: Object.assign({}, this.state.clearBtn, {
	                            show: true
	                        })
	                    });
	                } else if (this.state.screenObject.end_action === objectConstants.END_ACTION_RETURN_TO_MENU) {
	                    this.setState({
	                        menuBtn: Object.assign({}, this.state.menuBtn, {
	                            show: true
	                        })
	                    });
	                } else if (this.state.screenObject.end_action === objectConstants.END_ACTION_EXIT) {
	                    this.setState({
	                        exitBtn: Object.assign({}, this.state.exitBtn, {
	                            show: true
	                        })
	                    });
	                }
	            }
	        }
	    }, {
	        key: 'exit',
	        value: function exit() {
	            this.props.actions.setNewDialog(_dialogModels.EXIT_CONFIG);
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            return _react2.default.createElement(
	                'div',
	                { className: 'object-container', ref: this.state.screenObject.asset_id + '_text' },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'object-wrapper' },
	                    appHelper.isDefined(this.props.characterPose) && appHelper.isDefined(this.props.characterPose.src) && this.props.characterPose.src.length > 0 ? _react2.default.createElement(
	                        'div',
	                        { className: 'content-character-expression' },
	                        _react2.default.createElement('img', { src: this.getImagePath(this.props.characterPose.src), alt: '' })
	                    ) : null,
	                    _react2.default.createElement(
	                        'div',
	                        { className: '' + this.setClass() },
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'paragraph-content-wrapper ' + this.setIconClass(), ref: this.state.refValue },
	                            this.state.hasLeftAsset || this.state.hasTopAsset ? _react2.default.createElement(
	                                'div',
	                                { className: 'asset-column' },
	                                this.state.assetData.constant === assetConstants.ASSET_TYPE_IMAGE && _react2.default.createElement(_SecondaryImage2.default, { screenObject: this.state.assetData }),
	                                this.state.assetData.constant !== assetConstants.ASSET_TYPE_IMAGE && this.state.imageStylesSet && _react2.default.createElement(
	                                    'div',
	                                    { className: 'asset-image-wrapper ' + this.state.imageClass,
	                                        style: this.state.imageStyles },
	                                    _react2.default.createElement('img', { src: this.getImagePath(this.state.screenAsset.src), alt: '' })
	                                ),
	                                appHelper.isDefined(this.state.screenAsset.credit) && this.state.screenAsset.credit.length > 0 && _react2.default.createElement(
	                                    'div',
	                                    { className: 'image-credit', style: this.state.imageStyles },
	                                    this.state.creditLabel,
	                                    ': ',
	                                    this.state.screenAsset.credit
	                                )
	                            ) : null,
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'content-column' },
	                                this.state.screenObject.show_title && appHelper.isDefined(this.state.locale.label) && this.state.locale.label !== null && this.state.locale.label.length > 0 ? _react2.default.createElement('h4', { dangerouslySetInnerHTML: { __html: this.state.locale.label } }) : null,
	                                appHelper.isDefined(this.state.locale.description) && this.state.locale.description !== null && this.state.locale.description.length > 0 ? _react2.default.createElement('div', { dangerouslySetInnerHTML: { __html: this.state.locale.description } }) : null,
	                                this.state.hasResources ? _react2.default.createElement(_ResourceLinks2.default, { resources: this.state.resourceLinks,
	                                    onResourcesComplete: this.onResourcesComplete }) : null,
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: 'inline-list text-center' },
	                                    this.state.reviewBtn.show ? _react2.default.createElement(
	                                        'div',
	                                        { className: 'inline-item' },
	                                        _react2.default.createElement('input', { className: 'btn btn-lg guroo-btn action-btn', type: 'button',
	                                            value: this.state.reviewBtn.label, onClick: this.onReview })
	                                    ) : null,
	                                    this.state.clearBtn.show ? _react2.default.createElement(
	                                        'div',
	                                        { className: 'inline-item' },
	                                        _react2.default.createElement('input', { className: 'btn btn-lg guroo-btn action-btn', type: 'button',
	                                            value: this.state.clearBtn.label,
	                                            onClick: this.clearResults })
	                                    ) : null,
	                                    this.state.menuBtn.show ? _react2.default.createElement(
	                                        'div',
	                                        { className: 'inline-item' },
	                                        _react2.default.createElement('input', { className: 'btn btn-lg guroo-btn action-btn', type: 'button',
	                                            value: this.state.menuBtn.label,
	                                            onClick: this.onProgressionBtnClicked })
	                                    ) : null,
	                                    this.state.exitBtn.show ? _react2.default.createElement(
	                                        'div',
	                                        { className: 'inline-item' },
	                                        _react2.default.createElement('input', { className: 'btn btn-lg guroo-btn action-btn', type: 'button',
	                                            value: this.state.exitBtn.label,
	                                            onClick: this.exit })
	                                    ) : null
	                                )
	                            ),
	                            this.state.hasRightAsset || this.state.hasBottomAsset ? _react2.default.createElement(
	                                'div',
	                                { className: 'asset-column' },
	                                this.state.assetData.constant === assetConstants.ASSET_TYPE_IMAGE && _react2.default.createElement(_SecondaryImage2.default, { screenObject: this.state.assetData }),
	                                this.state.assetData.constant !== assetConstants.ASSET_TYPE_IMAGE && this.state.imageStylesSet && _react2.default.createElement(
	                                    'div',
	                                    { className: 'asset-image-wrapper ' + this.state.imageClass,
	                                        style: this.state.imageStyles },
	                                    _react2.default.createElement('img', { src: this.getImagePath(this.state.screenAsset.src), alt: '' })
	                                ),
	                                appHelper.isDefined(this.state.screenAsset.credit) && this.state.screenAsset.credit.length > 0 && _react2.default.createElement(
	                                    'div',
	                                    { className: 'image-credit', style: this.state.imageStyles },
	                                    this.state.creditLabel,
	                                    ': ',
	                                    this.state.screenAsset.credit
	                                )
	                            ) : null
	                        )
	                    )
	                ),
	                this.state.showProgressionButton ? _react2.default.createElement(_Button2.default, { label: this.state.progressionLabel,
	                    id: this.state.screenObject + '_button',
	                    onClick: this.onProgressionBtnClicked }) : null
	            );
	        }
	    }]);
	
	    return Text;
	}(_react2.default.Component);
	
	Text.propTypes = {
	    screenObject: _propTypes2.default.object.isRequired,
	    callbacks: _propTypes2.default.object.isRequired,
	    index: _propTypes2.default.number,
	    characterPose: _propTypes2.default.object,
	    contentData: _propTypes2.default.object.isRequired,
	    trackingData: _propTypes2.default.object.isRequired,
	    userData: _propTypes2.default.object.isRequired,
	    lang: _propTypes2.default.string.isRequired,
	    actions: _propTypes2.default.object.isRequired
	};
	
	Text.contextTypes = {
	    router: _propTypes2.default.object
	};
	
	function mapStateToProps(state, ownProps) {
	    var lang = state.userData.lang;
	    return {
	        lang: lang,
	        contentData: state.contentData,
	        trackingData: state.trackingData,
	        userData: state.userData
	    };
	}
	
	function mapDispatchToProps(dispatch) {
	    return {
	        actions: (0, _redux.bindActionCreators)(Object.assign({}, appDataActions, trackingDataActions, userDataActions, dialogPopupActions), dispatch)
	    };
	}
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(Text);

/***/ },
/* 525 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(5);
	
	var _redux = __webpack_require__(4);
	
	var _Button = __webpack_require__(18);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _appDataActions = __webpack_require__(12);
	
	var appDataActions = _interopRequireWildcard(_appDataActions);
	
	var _trackingDataActions = __webpack_require__(7);
	
	var trackingDataActions = _interopRequireWildcard(_trackingDataActions);
	
	var _userDataActions = __webpack_require__(20);
	
	var userDataActions = _interopRequireWildcard(_userDataActions);
	
	var _dialogPopupActions = __webpack_require__(19);
	
	var dialogPopupActions = _interopRequireWildcard(_dialogPopupActions);
	
	var _appConstants = __webpack_require__(13);
	
	var appConstants = _interopRequireWildcard(_appConstants);
	
	var _appHelper = __webpack_require__(3);
	
	var appHelper = _interopRequireWildcard(_appHelper);
	
	var _userDataHelper = __webpack_require__(15);
	
	var userDataHelper = _interopRequireWildcard(_userDataHelper);
	
	var _objectConstants = __webpack_require__(9);
	
	var objectConstants = _interopRequireWildcard(_objectConstants);
	
	var _dialogModels = __webpack_require__(32);
	
	var _gsap = __webpack_require__(8);
	
	var _gsapReactPlugin = __webpack_require__(10);
	
	var _gsapReactPlugin2 = _interopRequireDefault(_gsapReactPlugin);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } //eslint-disable-line import/no-named-as-default
	
	
	var TheEnd = function (_React$Component) {
	    _inherits(TheEnd, _React$Component);
	
	    function TheEnd(props, context) {
	        _classCallCheck(this, TheEnd);
	
	        var _this = _possibleConstructorReturn(this, (TheEnd.__proto__ || Object.getPrototypeOf(TheEnd)).call(this, props, context));
	
	        _this.state = {
	            lang: _this.props.lang,
	            screenObject: _this.props.screenObject,
	            userData: _this.props.userData,
	            status: objectConstants.STATUS_NOT_STARTED,
	            locale: appHelper.getLocalData(_this.props.screenObject),
	            showProgressionButton: false,
	            icon: {
	                src: ""
	            },
	            screenStatus: "",
	            checkComplete: false,
	            reviewBtn: {
	                show: false,
	                label: '' + appHelper.getLocaleString("review_label")
	            },
	            clearBtn: {
	                show: false,
	                label: '' + appHelper.getLocaleString("clear_and_start_again_label")
	            },
	
	            menuBtn: {
	                show: false,
	                label: '' + appHelper.getLocaleString("return_to_menu_label")
	            },
	            exitBtn: {
	                show: false,
	                label: '' + appHelper.getLocaleString("exit_label")
	            },
	            allowScroll: appHelper.allowScroll(_this.props.callbacks.getBiteId(), _this.props.callbacks.getScreenId(), _this.props.screenObject.asset_id),
	            progressionLabel: '' + appHelper.getLocaleString("continue_label")
	        };
	
	        _this.handleProgression = _this.handleProgression.bind(_this);
	        _this.scrollToTop = _this.scrollToTop.bind(_this);
	        _this.onComplete = _this.onComplete.bind(_this);
	        _this.enableProgression = _this.enableProgression.bind(_this);
	        _this.disableProgression = _this.disableProgression.bind(_this);
	        _this.getAssets = _this.getAssets.bind(_this);
	        _this.getImagePath = _this.getImagePath.bind(_this);
	        _this.show = _this.show.bind(_this);
	        _this.onShowComplete = _this.onShowComplete.bind(_this);
	        _this.onProgressionBtnClicked = _this.onProgressionBtnClicked.bind(_this);
	        _this.getScreenStatus = _this.getScreenStatus.bind(_this);
	        _this.getObjectStatus = _this.getObjectStatus.bind(_this);
	        _this.clearResults = _this.clearResults.bind(_this);
	        _this.onReview = _this.onReview.bind(_this);
	        _this.setDisplay = _this.setDisplay.bind(_this);
	        _this.goToMenu = _this.goToMenu.bind(_this);
	        _this.setClass = _this.setClass.bind(_this);
	        _this.setIconClass = _this.setIconClass.bind(_this);
	        _this.exit = _this.exit.bind(_this);
	        return _this;
	    }
	
	    _createClass(TheEnd, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            this.getAssets();
	            this.setDisplay();
	            this.getScreenStatus();
	            this.show();
	            if (appHelper.isDefined(this.props.callbacks.updateCharacterExpression) && appHelper.isDefined(this.state.screenObject.character_pose)) {
	                this.props.callbacks.updateCharacterExpression(this.state.screenObject.character_pose);
	            }
	        }
	    }, {
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(nextProps) {
	            if (this.state.userData !== nextProps.userData) {
	                this.setState({ userData: Object.assign({}, nextProps.userData) });
	            }
	            if (this.state.lang !== nextProps.lang) {
	                this.setState({
	                    lang: nextProps.lang,
	                    locale: appHelper.getLocalData(this.state.screenObject),
	                    reviewBtn: {
	                        label: '' + appHelper.getLocaleString("review_label")
	                    },
	                    clearBtn: {
	                        label: '' + appHelper.getLocaleString("clear_and_start_again_label")
	                    },
	
	                    menuBtn: {
	                        label: '' + appHelper.getLocaleString("return_to_menu_label")
	                    },
	                    exitBtn: {
	                        label: '' + appHelper.getLocaleString("exit_label")
	                    },
	                    progressionLabel: '' + appHelper.getLocaleString("continue_label")
	                });
	            }
	        }
	    }, {
	        key: 'componentDidUpdate',
	        value: function componentDidUpdate() {
	
	            if (this.state.checkComplete) {
	                this.onComplete();
	            }
	        }
	    }, {
	        key: 'getScreenStatus',
	        value: function getScreenStatus() {
	            var screenStatus = this.props.callbacks.getScreenStatus();
	            this.setState({
	                screenStatus: screenStatus,
	                status: screenStatus === objectConstants.STATUS_COMPLETE ? objectConstants.STATUS_COMPLETE : this.state.status
	            });
	        }
	    }, {
	        key: 'getObjectStatus',
	        value: function getObjectStatus() {
	            if (this.state.screenStatus === objectConstants.STATUS_COMPLETE) {
	                this.onComplete();
	            } else {
	                var objectUserData = {};
	                if (this.state.status !== objectConstants.STATUS_COMPLETE) {
	                    var subScreenParent = this.props.callbacks.getSubScreenParent();
	                    var screen_id = this.props.callbacks.getScreenId();
	                    if (appHelper.isDefined(subScreenParent)) {
	                        objectUserData = userDataHelper.getSubScreenObjectStatus(this.state.userData, subScreenParent.screen_id, screen_id, this.state.screenObject.asset_id);
	                    } else {
	                        objectUserData = userDataHelper.getObjectStatus(this.state.userData, screen_id, this.state.screenObject.asset_id);
	                    }
	                }
	                if (objectUserData.status === objectConstants.STATUS_COMPLETE) {
	                    this.setState({ status: objectConstants.STATUS_COMPLETE, checkComplete: true });
	                } else {
	                    this.setState({ checkComplete: true });
	                }
	            }
	        }
	    }, {
	        key: 'getImagePath',
	        value: function getImagePath(image) {
	            if (appConstants.DEVELOPMENT_MODE) {
	                if (appHelper.isDefined(image) && image.length > 0) {
	                    return __webpack_require__(16)("./" + image);
	                }
	            } else {
	                return image;
	            }
	        }
	    }, {
	        key: 'getAssets',
	        value: function getAssets() {
	            if (appHelper.isDefined(this.state.screenObject.icon)) {
	                var icon = appHelper.getIconAsset(this.state.screenObject.icon);
	                if (appHelper.isDefined(icon) && icon.src.length > 0) {
	                    this.setState({ icon: icon });
	                }
	            }
	        }
	    }, {
	        key: 'show',
	        value: function show() {
	            var optionRef = this.refs[this.state.screenObject.asset_id + '_asset'];
	            _gsap.TweenLite.set(optionRef, { height: "auto" });
	            _gsap.TweenLite.from(optionRef, objectConstants.SHOW_PANEL_DURATION, {
	                height: 0,
	                ease: _gsap.Expo.easeInOut
	            }).eventCallback("onComplete", this.getObjectStatus);
	        }
	    }, {
	        key: 'onShowComplete',
	        value: function onShowComplete() {
	            this.setState({ isVisible: true, checkComplete: false });
	        }
	    }, {
	        key: 'scrollToTop',
	        value: function scrollToTop() {
	            if (this.state.allowScroll && this.state.status !== objectConstants.STATUS_COMPLETE) {
	                var question = this.refs[this.state.screenObject.asset_id + '_asset'];
	                var scrollTo = this.props.callbacks.scrollTo;
	                setTimeout(function () {
	                    if (appHelper.isDefined(scrollTo)) {
	                        scrollTo(question.offsetTop);
	                    }
	                }, objectConstants.SCROLL_TO);
	            }
	        }
	    }, {
	        key: 'onComplete',
	        value: function onComplete() {
	            this.setState({ checkComplete: false });
	            this.scrollToTop();
	            /*let hasNextObject = this.props.callbacks.hasNextObject(this.state.screenObject);
	            if(appHelper.isDefined(this.state.screenObject.progression) && this.state.screenObject.progression === objectConstants.OBJECT_PROGRESSION_CONTINUE && (this.state.status !== objectConstants.STATUS_COMPLETE || !hasNextObject)){
	                if(!hasNextObject) {
	                    this.handleProgression();
	                    this.enableProgression();
	                }else{
	                    this.enableProgression();
	                }
	             }else{
	                this.handleProgression();
	            }*/
	            //this.enableProgression();
	            this.handleProgression();
	        }
	    }, {
	        key: 'enableProgression',
	        value: function enableProgression() {
	            if (!this.props.callbacks.isReviewMode()) {
	                this.setState({ showProgressionButton: true });
	            }
	        }
	    }, {
	        key: 'disableProgression',
	        value: function disableProgression() {
	            this.setState({ showProgressionButton: false });
	        }
	    }, {
	        key: 'handleProgression',
	        value: function handleProgression() {
	            var completionData = {
	                progression: objectConstants.OBJECT_PROGRESSION_CONTINUE,
	                asset_id: this.state.screenObject.asset_id,
	                status: objectConstants.STATUS_COMPLETE,
	                showProgressionButton: false,
	                asset_type_code: this.state.screenObject.asset_type_code,
	                navigateToNextScreen: appHelper.isDefined(this.state.screenObject.progression) && this.state.screenObject.progression === objectConstants.OBJECT_PROGRESSION_CONTINUE,
	                index: this.props.index
	            };
	
	            this.props.callbacks.onObjectComplete(completionData);
	            //t
	        }
	    }, {
	        key: 'onProgressionBtnClicked',
	        value: function onProgressionBtnClicked() {
	            this.setState({ showProgressionButton: false });
	            if (this.props.callbacks.hasNextObject(this.props.index)) {
	                this.handleProgression();
	            } else {
	                this.props.callbacks.navigateToNextScreen();
	            }
	        }
	    }, {
	        key: 'clearResults',
	        value: function clearResults() {
	            var _this2 = this;
	
	            var bite = appHelper.getBiteById(this.props.callbacks.getBiteId());
	            this.props.actions.clearBiteUserData(bite).then(function (userData) {
	                _this2.props.actions.setSuspendData(userData).then(function (userData) {
	                    _this2.onReview();
	                }).catch(function (error) {});
	            }).catch(function (error) {});
	        }
	    }, {
	        key: 'goToMenu',
	        value: function goToMenu() {
	            this.context.router.push('menu');
	        }
	    }, {
	        key: 'onReview',
	        value: function onReview() {
	            var bite = appHelper.getBiteById(this.props.callbacks.getBiteId());
	            var go_to_screen_id = bite.screens[0].screen_id;
	            if (this.props.contentData.experience.bites.length > 1) {
	                go_to_screen_id = this.props.contentData.experience.bites[0].screens[0].screen_id;
	            }
	            this.props.callbacks.goToScreen(go_to_screen_id);
	        }
	    }, {
	        key: 'setDisplay',
	        value: function setDisplay() {
	            if (this.state.screenObject.action === objectConstants.END_ACTION_REVIEW) {
	                this.setState({
	                    reviewBtn: Object.assign({}, this.state.reviewBtn, {
	                        show: true
	                    })
	                });
	            } else if (this.state.screenObject.action === objectConstants.END_ACTION_REVIEW_OR_CLEAR) {
	                this.setState({
	                    reviewBtn: Object.assign({}, this.state.reviewBtn, {
	                        show: true
	                    }),
	                    clearBtn: Object.assign({}, this.state.clearBtn, {
	                        show: true
	                    })
	                });
	            } else if (this.state.screenObject.action === objectConstants.END_ACTION_CLEAR) {
	                this.setState({
	                    clearBtn: Object.assign({}, this.state.clearBtn, {
	                        show: true
	                    })
	                });
	            } else if (this.state.screenObject.action === objectConstants.END_ACTION_RETURN_TO_MENU) {
	                this.setState({
	                    menuBtn: Object.assign({}, this.state.menuBtn, {
	                        show: true
	                    })
	                });
	            } else if (this.state.screenObject.action === objectConstants.END_ACTION_EXIT) {
	                this.setState({
	                    exitBtn: Object.assign({}, this.state.exitBtn, {
	                        show: true
	                    })
	                });
	            }
	        }
	    }, {
	        key: 'setClass',
	        value: function setClass() {
	            if (appHelper.isDefined(this.state.screenObject.class_name) && this.state.screenObject.class_name.length > 0) {
	                return this.state.screenObject.class_name;
	            } else {
	                return "standard-block";
	            }
	        }
	    }, {
	        key: 'setIconClass',
	        value: function setIconClass() {
	            return this.state.icon.src.length > 0 ? 'has-icon' : '';
	        }
	    }, {
	        key: 'exit',
	        value: function exit() {
	            this.props.actions.setNewDialog(_dialogModels.EXIT_CONFIG);
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            return _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(
	                    'div',
	                    { className: 'object-container', ref: this.state.screenObject.asset_id + '_asset' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: '' + this.setClass() },
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'paragraph-content-wrapper ' + this.setIconClass() },
	                            this.state.icon.src.length > 0 ? _react2.default.createElement(
	                                'div',
	                                { className: 'icon-column' },
	                                _react2.default.createElement('img', { src: this.getImagePath(this.state.icon.src), alt: '' })
	                            ) : null,
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'content-column' },
	                                this.state.screenObject.show_title && appHelper.isDefined(this.state.locale.label) && this.state.locale.label !== null && this.state.locale.label.length > 0 ? _react2.default.createElement('h4', { dangerouslySetInnerHTML: { __html: this.state.locale.label } }) : null,
	                                appHelper.isDefined(this.state.locale.description) && this.state.locale.description !== null && this.state.locale.description.length > 0 ? _react2.default.createElement('div', { dangerouslySetInnerHTML: { __html: this.state.locale.description } }) : null
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'inline-list text-center' },
	                            this.state.reviewBtn.show ? _react2.default.createElement(
	                                'div',
	                                { className: 'inline-item' },
	                                _react2.default.createElement('input', { className: 'btn btn-lg guroo-btn action-btn', type: 'button', value: this.state.reviewBtn.label, onClick: this.onReview })
	                            ) : null,
	                            this.state.clearBtn.show ? _react2.default.createElement(
	                                'div',
	                                { className: 'inline-item' },
	                                _react2.default.createElement('input', { className: 'btn btn-lg guroo-btn action-btn', type: 'button', value: this.state.clearBtn.label,
	                                    onClick: this.clearResults })
	                            ) : null,
	                            this.state.menuBtn.show ? _react2.default.createElement(
	                                'div',
	                                { className: 'inline-item' },
	                                _react2.default.createElement('input', { className: 'btn btn-lg guroo-btn action-btn', type: 'button', value: this.state.menuBtn.label,
	                                    onClick: this.onProgressionBtnClicked })
	                            ) : null,
	                            this.state.exitBtn.show ? _react2.default.createElement(
	                                'div',
	                                { className: 'inline-item' },
	                                _react2.default.createElement('input', { className: 'btn btn-lg guroo-btn action-btn', type: 'button', value: this.state.exitBtn.label,
	                                    onClick: this.exit })
	                            ) : null
	                        )
	                    )
	                )
	            );
	        }
	    }]);
	
	    return TheEnd;
	}(_react2.default.Component);
	
	TheEnd.propTypes = {
	    screenObject: _propTypes2.default.object.isRequired,
	    callbacks: _propTypes2.default.object.isRequired,
	    index: _propTypes2.default.number,
	    contentData: _propTypes2.default.object.isRequired,
	    trackingData: _propTypes2.default.object.isRequired,
	    userData: _propTypes2.default.object.isRequired,
	    actions: _propTypes2.default.object.isRequired,
	    lang: _propTypes2.default.string.isRequired
	};
	
	TheEnd.contextTypes = {
	    router: _propTypes2.default.object
	};
	
	function mapStateToProps(state, ownProps) {
	    var lang = state.userData.lang;
	    return {
	        lang: lang,
	        contentData: state.contentData,
	        trackingData: state.trackingData,
	        userData: state.userData
	    };
	}
	
	function mapDispatchToProps(dispatch) {
	    return {
	        actions: (0, _redux.bindActionCreators)(Object.assign({}, appDataActions, trackingDataActions, userDataActions, dialogPopupActions), dispatch)
	    };
	}
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(TheEnd);

/***/ },
/* 526 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _keyboardConstants = __webpack_require__(14);
	
	var keyboardConstants = _interopRequireWildcard(_keyboardConstants);
	
	var _gsap = __webpack_require__(8);
	
	var _gsapReactPlugin = __webpack_require__(10);
	
	var _gsapReactPlugin2 = _interopRequireDefault(_gsapReactPlugin);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ToolTip = function (_React$Component) {
	    _inherits(ToolTip, _React$Component);
	
	    function ToolTip(props, context) {
	        _classCallCheck(this, ToolTip);
	
	        var _this = _possibleConstructorReturn(this, (ToolTip.__proto__ || Object.getPrototypeOf(ToolTip)).call(this, props, context));
	
	        _this.state = {
	            show: _this.props.show
	        };
	        _this.setKeyboardAccessibility = _this.setKeyboardAccessibility.bind(_this);
	
	        return _this;
	    }
	
	    _createClass(ToolTip, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {}
	    }, {
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(nextProps) {}
	    }, {
	        key: 'setKeyboardAccessibility',
	        value: function setKeyboardAccessibility(event) {
	
	            if (event.which === keyboardConstants.ENTER_KEY || event.which === keyboardConstants.SPACEBAR_KEY) {
	                event.preventDefault();
	                event.stopPropagation();
	                this.props.onHide();
	            }
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            return _react2.default.createElement(
	                'div',
	                { className: 'tool-tip ' + this.props.class, ref: this.props.id, onClick: this.props.onHide, onKeyDown: this.setKeyboardAccessibility, tabIndex: 0, role: 'link' },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'tool-tip-content-wrapper' },
	                    this.props.childComponentProps !== null || typeof this.props.childComponentProps !== 'undefined' ? _react2.default.createElement(this.props.childComponent, this.props.childComponentProps) : _react2.default.createElement(this.props.childComponent, null)
	                )
	            );
	        }
	    }]);
	
	    return ToolTip;
	}(_react2.default.Component);
	
	ToolTip.propTypes = {
	    childComponent: _propTypes2.default.func.isRequired,
	    show: _propTypes2.default.bool.isRequired,
	    onHide: _propTypes2.default.func.isRequired,
	    id: _propTypes2.default.string.isRequired,
	    childComponentProps: _propTypes2.default.object,
	    class: _propTypes2.default.string
	};
	
	ToolTip.contextTypes = {
	    router: _propTypes2.default.object
	};
	
	exports.default = ToolTip;

/***/ },
/* 527 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(5);
	
	var _redux = __webpack_require__(4);
	
	var _appDataActions = __webpack_require__(12);
	
	var appDataActions = _interopRequireWildcard(_appDataActions);
	
	var _trackingDataActions = __webpack_require__(7);
	
	var trackingDataActions = _interopRequireWildcard(_trackingDataActions);
	
	var _appHelper = __webpack_require__(3);
	
	var appHelper = _interopRequireWildcard(_appHelper);
	
	var _dataHelper = __webpack_require__(11);
	
	var dataHelper = _interopRequireWildcard(_dataHelper);
	
	var _appConstants = __webpack_require__(13);
	
	var appConstants = _interopRequireWildcard(_appConstants);
	
	var _objectConstants = __webpack_require__(9);
	
	var objectConstants = _interopRequireWildcard(_objectConstants);
	
	var _userDataHelper = __webpack_require__(15);
	
	var userDataHelper = _interopRequireWildcard(_userDataHelper);
	
	var _keyboardConstants = __webpack_require__(14);
	
	var keyboardConstants = _interopRequireWildcard(_keyboardConstants);
	
	var _gsap = __webpack_require__(8);
	
	var _gsapReactPlugin = __webpack_require__(10);
	
	var _gsapReactPlugin2 = _interopRequireDefault(_gsapReactPlugin);
	
	var _reactPlayer = __webpack_require__(189);
	
	var _reactPlayer2 = _interopRequireDefault(_reactPlayer);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	//https://www.npmjs.com/package/react-player
	var SHOW_CONTROLS = true;
	
	var ReactVideoPlayer = function (_React$Component) {
	    _inherits(ReactVideoPlayer, _React$Component);
	
	    function ReactVideoPlayer(props, context) {
	        _classCallCheck(this, ReactVideoPlayer);
	
	        var _this = _possibleConstructorReturn(this, (ReactVideoPlayer.__proto__ || Object.getPrototypeOf(ReactVideoPlayer)).call(this, props, context));
	
	        _this.state = {
	            lang: _propTypes2.default.string.isRequired,
	            userData: _this.props.userData,
	            screenObject: _this.props.screenObject,
	            video: _this.props.video,
	            locale: appHelper.getLocalData(_this.props.screenObject),
	            responseData: {
	                latestResponse: {}
	            },
	            isPlaying: true,
	            status: objectConstants.STATUS_NOT_STARTED,
	            isResourceObject: appHelper.isDefined(_this.props.callbacks.checkIsResourceScreen) && _this.props.callbacks.checkIsResourceScreen(),
	            trackable: true,
	            autoPlay: true,
	            video_instruction: appHelper.getLocaleString("video_instruction"),
	            done_label: appHelper.getLocaleString("done_label"),
	            cancel_label: appHelper.getLocaleString("cancel_label")
	
	        };
	
	        _this.handleProgression = _this.handleProgression.bind(_this);
	        _this.show = _this.show.bind(_this);
	        _this.onStartFunc = _this.onStartFunc.bind(_this);
	        _this.onEndedFunc = _this.onEndedFunc.bind(_this);
	        _this.onPauseFunc = _this.onPauseFunc.bind(_this);
	        _this.onPlayFunc = _this.onPlayFunc.bind(_this);
	        _this.setClass = _this.setClass.bind(_this);
	        _this.getObjectStatusClass = _this.getObjectStatusClass.bind(_this);
	        _this.getVideoPath = _this.getVideoPath.bind(_this);
	        _this.getImagePath = _this.getImagePath.bind(_this);
	        _this.getControlClass = _this.getControlClass.bind(_this);
	        _this.setKeyboardAccessibility = _this.setKeyboardAccessibility.bind(_this);
	
	        return _this;
	    }
	
	    _createClass(ReactVideoPlayer, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            this.show();
	        }
	    }, {
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(nextProps) {
	            if (this.state.userData !== nextProps.userData) {
	                this.setState({ userData: Object.assign({}, nextProps.userData) });
	            }
	            if (this.state.lang !== nextProps.lang) {
	                this.setState({
	                    lang: nextProps.lang,
	                    locale: appHelper.getLocalData(this.state.screenObject),
	                    video_instruction: appHelper.getLocaleString("video_instruction"),
	                    done_label: appHelper.getLocaleString("done_label"),
	                    cancel_label: appHelper.getLocaleString("cancel_label")
	                });
	            }
	        }
	    }, {
	        key: 'getObjectStatusClass',
	        value: function getObjectStatusClass() {
	            var objectUserData = {};
	            var subScreenParent = {};
	            var screen_id = undefined;
	            if (appHelper.isDefined(this.props.callbacks.getSubScreenParent)) {
	                subScreenParent = this.props.callbacks.getSubScreenParent();
	            }
	            if (appHelper.isDefined(this.props.callbacks.getScreenId)) {
	                screen_id = this.props.callbacks.getScreenId();
	            }
	
	            if (appHelper.isDefined(screen_id)) {
	                if (appHelper.isDefined(subScreenParent)) {
	                    objectUserData = userDataHelper.getSubScreenObjectStatus(this.state.userData, subScreenParent.screen_id, screen_id, this.state.screenObject.asset_id);
	                } else if (this.state.isResourceObject) {
	                    objectUserData = userDataHelper.getResourceScreenObjectUserData(this.state.userData, screen_id, this.state.screenObject.asset_id);
	                } else {
	                    objectUserData = userDataHelper.getObjectStatus(this.state.userData, screen_id, this.state.screenObject.asset_id);
	                }
	            } else {
	                objectUserData = userDataHelper.getAttachmentObjectUserData(this.state.userData, this.state.screenObject.asset_id);
	            }
	
	            if (appHelper.isDefined(objectUserData.status)) {
	
	                if (objectUserData.status === objectConstants.STATUS_COMPLETE) {
	                    return 'complete';
	                } else if (objectUserData.status === objectConstants.STATUS_IN_PROGRESS) {
	                    return 'in-progress';
	                } else if (objectUserData.status === objectConstants.STATUS_NOT_REQUIRED) {
	                    return 'not-required';
	                } else {
	                    if (this.state.status === objectConstants.STATUS_COMPLETE) {
	                        return 'complete';
	                    } else if (this.state.status === objectConstants.STATUS_IN_PROGRESS) {
	                        return 'in-progress';
	                    } else {
	                        return 'not-started';
	                    }
	                }
	            }
	            return 'not-started';
	        }
	    }, {
	        key: 'getVideoPath',
	        value: function getVideoPath(video) {
	            if (video.sub_type == objectConstants.VIDEO_SUB_TYPE_MP4 && appConstants.DEVELOPMENT_MODE) {
	                if (appHelper.isDefined(video.src) && video.src.length > 0) {
	                    return __webpack_require__(16)("./" + video.src);
	                }
	            } else {
	                return video.src;
	            }
	        }
	    }, {
	        key: 'handleProgression',
	        value: function handleProgression() {
	            this.props.callbacks.onObjectComplete(objectConstants.OBJECT_PROGRESSION_CONTINUE, this.state.screenObject.asset_id, this.state.responseData.latestResponse);
	        }
	
	        //<iframe src={`https://player.vimeo.com/video/${this.state.locale.vimeo_id}`} width="100%" height="auto"  allowFullScreen />
	
	    }, {
	        key: 'onStartFunc',
	        value: function onStartFunc(event) {
	            //console.log(`onStart`);
	            this.setState({ isPlaying: true });
	            this.setState({ status: objectConstants.STATUS_IN_PROGRESS });
	        }
	    }, {
	        key: 'onEndedFunc',
	        value: function onEndedFunc(event) {
	            this.props.onAssetViewed();
	            this.setState({ isPlaying: false });
	            this.setState({ status: objectConstants.STATUS_COMPLETE });
	        }
	    }, {
	        key: 'onPauseFunc',
	        value: function onPauseFunc(event) {
	            this.setState({ isPlaying: false });
	        }
	    }, {
	        key: 'onPlayFunc',
	        value: function onPlayFunc(event) {
	            this.setState({ isPlaying: true });
	            if (this.state.status !== objectConstants.STATUS_COMPLETE) {
	                this.setState({ status: objectConstants.STATUS_IN_PROGRESS });
	            }
	        }
	    }, {
	        key: 'setClass',
	        value: function setClass() {
	            if (this.state.isPlaying) {
	                return "playing";
	            } else {
	                return "";
	            }
	        }
	    }, {
	        key: 'setStatusClass',
	        value: function setStatusClass() {
	
	            if (this.state.status === objectConstants.STATUS_COMPLETE) {
	                return "viewed";
	            } else {
	                return "not-viewed";
	            }
	        }
	    }, {
	        key: 'show',
	        value: function show() {
	            var videoRef = this.refs['video_container_' + this.state.screenObject.asset_id];
	            if (appHelper.isDefined(videoRef)) {
	                _gsap.TweenLite.set(videoRef, { opacity: 1 });
	                _gsap.TweenLite.from(videoRef, objectConstants.SHOW_PANEL_DURATION, {
	                    opacity: 0,
	                    ease: _gsap.Expo.easeInOut
	                });
	            }
	        }
	    }, {
	        key: 'getControlClass',
	        value: function getControlClass() {
	            return this.state.status === objectConstants.STATUS_COMPLETE ? 'replay' : 'play';
	        }
	    }, {
	        key: 'getImagePath',
	        value: function getImagePath(image) {
	            if (appConstants.DEVELOPMENT_MODE) {
	                if (appHelper.isDefined(image) && image.length > 0) {
	                    return __webpack_require__(16)("./" + image);
	                }
	            } else {
	                return image;
	            }
	        }
	    }, {
	        key: 'setKeyboardAccessibility',
	        value: function setKeyboardAccessibility(event) {
	            if (appHelper.isDefined(event)) {
	                if (event.which === keyboardConstants.ENTER_KEY || event.which === keyboardConstants.SPACEBAR_KEY) {
	                    event.preventDefault();
	                    this.onPlayFunc();
	                }
	            }
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            return _react2.default.createElement(
	                'div',
	                { className: 'object-container', ref: 'video_container_' + this.state.screenObject.asset_id },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'asset-dialog-image' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'asset-image-header' },
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'title-col truncate-text-container' },
	                            this.state.status !== objectConstants.STATUS_COMPLETE && this.state.screenObject.required_for_completion ? _react2.default.createElement('div', { className: 'title ' + this.getObjectStatusClass(),
	                                dangerouslySetInnerHTML: { __html: this.state.locale.label + '  - <em>' + this.state.video_instruction + '</em>' } }) : _react2.default.createElement('div', { className: 'title ' + this.getObjectStatusClass(),
	                                dangerouslySetInnerHTML: { __html: this.state.locale.label } })
	                        ),
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'nav-col' },
	                            _react2.default.createElement(
	                                'button',
	                                { className: 'btn guroo-btn', onClick: this.props.closeDialog },
	                                this.state.status === objectConstants.STATUS_COMPLETE || !this.state.screenObject.required_for_completion ? _react2.default.createElement(
	                                    'span',
	                                    null,
	                                    this.state.done_label
	                                ) : _react2.default.createElement(
	                                    'span',
	                                    null,
	                                    this.state.cancel_label
	                                )
	                            )
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'asset-img-container video' },
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'video-wrapper' },
	                            _react2.default.createElement(_reactPlayer2.default, { id: 'video_' + this.state.screenObject.asset_id,
	                                url: '' + this.getVideoPath(this.state.video),
	                                onStart: this.onStartFunc,
	                                onPause: this.onPauseFunc,
	                                onPlay: this.onPlayFunc,
	                                onEnded: this.onEndedFunc,
	                                width: '100%',
	                                height: 'auto',
	                                playing: this.state.isPlaying,
	                                controls: SHOW_CONTROLS
	
	                            })
	                        ),
	                        !this.state.isPlaying ? _react2.default.createElement(
	                            'div',
	                            { className: 'video-thumbnail-wrapper ' + this.getControlClass(),
	                                onClick: this.onPlayFunc, onKeyDown: this.setKeyboardAccessibility(), tabIndex: '0',
	                                role: 'link' },
	                            _react2.default.createElement('img', { src: this.getImagePath(this.state.video.thumbnail), alt: '' })
	                        ) : null,
	                        appHelper.isDefined(this.state.locale.description) && this.state.locale.description !== null && this.state.locale.description.length > 0 ? _react2.default.createElement(
	                            'div',
	                            { className: 'asset-desc' },
	                            _react2.default.createElement('div', { dangerouslySetInnerHTML: { __html: this.state.locale.description } })
	                        ) : null
	                    )
	                )
	            );
	        }
	    }]);
	
	    return ReactVideoPlayer;
	}(_react2.default.Component);
	
	/*config={{ file: {
	                                             tracks: [
	                                                 {kind: 'subtitles', src:  require(`../../../../moveToDist/${this.state.video.captions}`), srcLang: 'en', default: true}
	                                             ]
	                                         }}}*/
	
	
	ReactVideoPlayer.propTypes = {
	    screenObject: _propTypes2.default.object.isRequired,
	    video: _propTypes2.default.object.isRequired,
	    callbacks: _propTypes2.default.object.isRequired,
	    contentData: _propTypes2.default.object.isRequired,
	    trackingData: _propTypes2.default.object.isRequired,
	    actions: _propTypes2.default.object.isRequired,
	    onAssetViewed: _propTypes2.default.func.isRequired,
	    closeDialog: _propTypes2.default.func.isRequired,
	    lang: _propTypes2.default.string.isRequired,
	    userData: _propTypes2.default.object.isRequired
	};
	
	ReactVideoPlayer.contextTypes = {
	    router: _propTypes2.default.object
	};
	
	function mapStateToProps(state, ownProps) {
	    var lang = state.userData.lang;
	    return {
	        lang: lang,
	        contentData: state.contentData,
	        trackingData: state.trackingData,
	        userData: state.userData
	    };
	}
	
	function mapDispatchToProps(dispatch) {
	    return {
	        actions: (0, _redux.bindActionCreators)(Object.assign({}, appDataActions, trackingDataActions), dispatch)
	    };
	}
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(ReactVideoPlayer);

/***/ },
/* 528 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(5);
	
	var _redux = __webpack_require__(4);
	
	var _Button = __webpack_require__(18);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _dialogPopupActions = __webpack_require__(19);
	
	var dialogPopupActions = _interopRequireWildcard(_dialogPopupActions);
	
	var _appDataActions = __webpack_require__(12);
	
	var appDataActions = _interopRequireWildcard(_appDataActions);
	
	var _trackingDataActions = __webpack_require__(7);
	
	var trackingDataActions = _interopRequireWildcard(_trackingDataActions);
	
	var _appConstants = __webpack_require__(13);
	
	var appConstants = _interopRequireWildcard(_appConstants);
	
	var _appHelper = __webpack_require__(3);
	
	var appHelper = _interopRequireWildcard(_appHelper);
	
	var _dataHelper = __webpack_require__(11);
	
	var dataHelper = _interopRequireWildcard(_dataHelper);
	
	var _userDataHelper = __webpack_require__(15);
	
	var userDataHelper = _interopRequireWildcard(_userDataHelper);
	
	var _objectConstants = __webpack_require__(9);
	
	var objectConstants = _interopRequireWildcard(_objectConstants);
	
	var _keyboardConstants = __webpack_require__(14);
	
	var keyboardConstants = _interopRequireWildcard(_keyboardConstants);
	
	var _dialogModels = __webpack_require__(32);
	
	var _componentHelper = __webpack_require__(31);
	
	var _gsap = __webpack_require__(8);
	
	var _gsapReactPlugin = __webpack_require__(10);
	
	var _gsapReactPlugin2 = _interopRequireDefault(_gsapReactPlugin);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } //eslint-disable-line import/no-named-as-default
	
	
	var Video = function (_React$Component) {
	    _inherits(Video, _React$Component);
	
	    function Video(props, context) {
	        _classCallCheck(this, Video);
	
	        var _this = _possibleConstructorReturn(this, (Video.__proto__ || Object.getPrototypeOf(Video)).call(this, props, context));
	
	        _this.state = {
	            lang: _this.props.lang,
	            screenObject: _this.props.screenObject,
	            userData: _this.props.userData,
	            status: objectConstants.STATUS_NOT_STARTED,
	            locale: appHelper.getLocalData(_this.props.screenObject),
	            showProgressionButton: false,
	            videoType: {},
	            video: {
	                src: ""
	            },
	            screenStatus: "",
	            isResourceObject: appHelper.isDefined(_this.props.callbacks.checkIsResourceScreen) && _this.props.callbacks.checkIsResourceScreen(),
	            allowScroll: appHelper.allowScroll(_this.props.callbacks.getBiteId(), _this.props.callbacks.getScreenId(), _this.props.screenObject.asset_id),
	            download_transcript_label: appHelper.getLocaleString("download_transcript_label"),
	            replay_label: appHelper.getLocaleString("replay_label"),
	            play_label: appHelper.getLocaleString("play_label"),
	            video_instruction: appHelper.getLocaleString("video_instruction"),
	            continue_label: appHelper.getLocaleString("continue_label")
	        };
	
	        _this.handleProgression = _this.handleProgression.bind(_this);
	        _this.scrollToTop = _this.scrollToTop.bind(_this);
	        _this.onComplete = _this.onComplete.bind(_this);
	        _this.enableProgression = _this.enableProgression.bind(_this);
	        _this.disableProgression = _this.disableProgression.bind(_this);
	        _this.getAssets = _this.getAssets.bind(_this);
	        _this.getImagePath = _this.getImagePath.bind(_this);
	        _this.show = _this.show.bind(_this);
	        _this.onShowComplete = _this.onShowComplete.bind(_this);
	        _this.setClass = _this.setClass.bind(_this);
	        _this.onProgressionBtnClicked = _this.onProgressionBtnClicked.bind(_this);
	        _this.getControlClass = _this.getControlClass.bind(_this);
	        _this.launchVideo = _this.launchVideo.bind(_this);
	
	        _this.onCloseVideoDialog = _this.onCloseVideoDialog.bind(_this);
	        _this.setStatusClass = _this.setStatusClass.bind(_this);
	        _this.getScreenStatus = _this.getScreenStatus.bind(_this);
	        _this.getObjectStatus = _this.getObjectStatus.bind(_this);
	        _this.onRendered = _this.onRendered.bind(_this);
	        _this.setKeyboardAccessibility = _this.setKeyboardAccessibility.bind(_this);
	        _this.getCaptionPath = _this.getCaptionPath.bind(_this);
	        _this.onLinkClick = _this.onLinkClick.bind(_this);
	
	        return _this;
	    }
	
	    _createClass(Video, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            this.getAssets();
	            this.getScreenStatus();
	            this.show();
	
	            if (appHelper.isDefined(this.props.callbacks.updateCharacterExpression) && appHelper.isDefined(this.state.screenObject.character_pose)) {
	                this.props.callbacks.updateCharacterExpression(this.state.screenObject.character_pose);
	            }
	        }
	    }, {
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(nextProps) {
	            if (this.state.lang !== nextProps.lang) {
	                var video = appHelper.getVideoAsset(this.state.screenObject);
	                video = appHelper.getLocalData(video);
	                var videoType = Object.assign({}, (0, _componentHelper.getChildObjectComponentByType)('' + video.sub_type));
	                this.setState({
	                    lang: nextProps.lang,
	                    locale: appHelper.getLocalData(this.state.screenObject),
	                    video: appHelper.isDefined(video) && video.src.length > 0 ? video : this.state.video,
	                    videoType: appHelper.isDefined(video) && video.src.length > 0 ? videoType : this.state.videoType,
	                    download_transcript_label: appHelper.getLocaleString("download_transcript_label"),
	                    replay_label: appHelper.getLocaleString("replay_label"),
	                    play_label: appHelper.getLocaleString("play_label"),
	                    video_instruction: appHelper.getLocaleString("video_instruction"),
	                    continue_label: appHelper.getLocaleString("continue_label")
	                });
	            }
	        }
	    }, {
	        key: 'getCaptionPath',
	        value: function getCaptionPath(captions) {
	            if (appConstants.DEVELOPMENT_MODE) {
	                if (appHelper.isDefined(captions) && captions.length > 0) {
	                    return __webpack_require__(16)("./" + captions);
	                }
	            } else {
	                return captions;
	            }
	        }
	    }, {
	        key: 'onLinkClick',
	        value: function onLinkClick(event) {
	            event.stopPropagation();
	        }
	    }, {
	        key: 'getScreenStatus',
	        value: function getScreenStatus() {
	            var screenStatus = this.props.callbacks.getScreenStatus();
	            this.setState({
	                screenStatus: screenStatus,
	                status: screenStatus === objectConstants.STATUS_COMPLETE ? objectConstants.STATUS_COMPLETE : this.state.status
	            });
	        }
	    }, {
	        key: 'getImagePath',
	        value: function getImagePath(image) {
	            if (appConstants.DEVELOPMENT_MODE) {
	                if (appHelper.isDefined(image) && image.length > 0) {
	                    return __webpack_require__(16)("./" + image);
	                }
	            } else {
	                return image;
	            }
	        }
	    }, {
	        key: 'getAssets',
	        value: function getAssets() {
	            var video = appHelper.getVideoAsset(this.state.screenObject);
	            video = appHelper.getLocalData(video);
	            var videoType = Object.assign({}, (0, _componentHelper.getChildObjectComponentByType)('' + video.sub_type));
	            if (appHelper.isDefined(video) && video.src.length > 0) {
	                this.setState({
	                    video: video,
	                    videoType: videoType
	                });
	            }
	        }
	    }, {
	        key: 'show',
	        value: function show() {
	            var optionRef = this.refs[this.state.screenObject.asset_id + '_asset'];
	            _gsap.TweenLite.set(optionRef, { height: "auto" });
	            _gsap.TweenLite.from(optionRef, objectConstants.SHOW_PANEL_DURATION, {
	                height: 0,
	                ease: _gsap.Expo.easeInOut
	            }).eventCallback("onComplete", this.onRendered);
	        }
	    }, {
	        key: 'onRendered',
	        value: function onRendered() {
	            if (this.state.isResourceObject) {
	                this.props.callbacks.onObjectRendered();
	            }
	            this.getObjectStatus();
	        }
	    }, {
	        key: 'getObjectStatus',
	        value: function getObjectStatus() {
	
	            if (this.state.screenStatus === objectConstants.STATUS_COMPLETE) {
	                this.onComplete();
	            } else {
	                var objectUserData = {};
	                if (this.state.status !== objectConstants.STATUS_COMPLETE) {
	                    var subScreenParent = this.props.callbacks.getSubScreenParent();
	                    var screen_id = this.props.callbacks.getScreenId();
	                    if (appHelper.isDefined(subScreenParent)) {
	                        objectUserData = userDataHelper.getSubScreenObjectStatus(this.state.userData, subScreenParent.screen_id, screen_id, this.state.screenObject.asset_id);
	                    } else if (this.state.isResourceObject) {
	                        objectUserData = userDataHelper.getResourceScreenObjectUserData(this.state.userData, screen_id, this.state.screenObject.asset_id);
	                    } else {
	                        objectUserData = userDataHelper.getObjectStatus(this.state.userData, screen_id, this.state.screenObject.asset_id);
	                    }
	                }
	
	                if (!this.state.screenObject.required_for_completion || objectUserData.status === objectConstants.STATUS_COMPLETE) {
	                    this.setState({ status: objectConstants.STATUS_COMPLETE });
	                    this.onComplete();
	                }
	            }
	        }
	    }, {
	        key: 'onShowComplete',
	        value: function onShowComplete() {
	            this.setState({ isVisible: true, checkComplete: false });
	            if (!this.state.screenObject.required_for_completion || this.state.screenStatus === objectConstants.STATUS_COMPLETE) {
	                this.onComplete();
	            }
	        }
	    }, {
	        key: 'scrollToTop',
	        value: function scrollToTop() {
	            if (this.state.allowScroll && this.state.status !== objectConstants.STATUS_COMPLETE) {
	                var question = this.refs[this.state.screenObject.asset_id + '_asset'];
	                var scrollTo = this.props.callbacks.scrollTo;
	                setTimeout(function () {
	                    if (appHelper.isDefined(scrollTo)) {
	                        scrollTo(question.offsetTop);
	                    }
	                }, objectConstants.SCROLL_TO);
	            }
	        }
	    }, {
	        key: 'onComplete',
	        value: function onComplete() {
	            this.setState({ checkComplete: false });
	            var hasNextObject = this.props.callbacks.hasNextObject(this.props.index);
	            if (appHelper.isDefined(this.state.screenObject.progression) && this.state.screenObject.progression === objectConstants.OBJECT_PROGRESSION_CONTINUE && (this.state.status !== objectConstants.STATUS_COMPLETE || !hasNextObject)) {
	                if (!hasNextObject && !this.state.isResourceObject) {
	                    this.handleProgression();
	                    this.enableProgression();
	                } else if (!hasNextObject && this.state.isResourceObject) {
	                    this.handleProgression();
	                } else if (this.state.isResourceObject) {
	                    this.handleProgression();
	                } else {
	                    this.enableProgression();
	                }
	            } else {
	                this.handleProgression();
	            }
	            this.scrollToTop();
	        }
	    }, {
	        key: 'enableProgression',
	        value: function enableProgression() {
	            if (!this.props.callbacks.isReviewMode()) {
	                this.setState({ showProgressionButton: true });
	            }
	        }
	    }, {
	        key: 'disableProgression',
	        value: function disableProgression() {
	            this.setState({ showProgressionButton: false });
	        }
	    }, {
	        key: 'handleProgression',
	        value: function handleProgression() {
	            var progressionRule = appHelper.isDefined(this.state.screenObject.progression) ? this.state.screenObject.progression : objectConstants.OBJECT_PROGRESSION_CONTINUE;
	            var progressionType = appHelper.isDefined(this.state.screenObject.progression_type) ? this.state.screenObject.progression_type : undefined;
	            var progressionGoToId = appHelper.isDefined(this.state.screenObject.progression_goto_id) ? this.state.screenObject.progression_goto_id : undefined;
	            var completionData = {
	                progression: progressionRule,
	                progressionType: progressionType,
	                progressionGoToId: progressionGoToId,
	                asset_id: this.state.screenObject.asset_id,
	                status: objectConstants.STATUS_COMPLETE,
	                showProgressionButton: false,
	                asset_type_code: this.state.screenObject.asset_type_code,
	                navigateToNextScreen: !this.state.isResourceObject && appHelper.isDefined(this.state.screenObject.progression) && this.state.screenObject.progression === objectConstants.OBJECT_PROGRESSION_CONTINUE,
	                index: this.props.index
	            };
	
	            this.props.callbacks.onObjectComplete(completionData);
	            //t
	        }
	    }, {
	        key: 'onProgressionBtnClicked',
	        value: function onProgressionBtnClicked() {
	            this.setState({ showProgressionButton: false });
	            if (this.props.callbacks.hasNextObject(this.props.index) || this.state.isResourceObject) {
	                this.handleProgression();
	            } else {
	                this.props.callbacks.navigateToNextScreen();
	            }
	        }
	    }, {
	        key: 'setClass',
	        value: function setClass() {}
	    }, {
	        key: 'getControlClass',
	        value: function getControlClass() {
	            return this.state.status === objectConstants.STATUS_COMPLETE ? 'replay' : 'play';
	        }
	    }, {
	        key: 'onCloseVideoDialog',
	        value: function onCloseVideoDialog(viewed) {
	            if (this.state.status !== objectConstants.STATUS_COMPLETE && viewed) {
	                this.setState({
	                    status: objectConstants.STATUS_COMPLETE
	                });
	                this.onComplete();
	            }
	        }
	    }, {
	        key: 'launchVideo',
	        value: function launchVideo() {
	            var childComponenents = [];
	            var config = Object.assign({}, _dialogModels.ASSET_CONFIG, {
	                title: this.state.locale.label,
	                sourceId: 'video_player_' + this.state.screenObject.asset_id,
	                onClose: this.onCloseVideoDialog,
	                showCloseBtn: false,
	                theme: "dialog-asset-image"
	            });
	
	            for (var i = 0; i < config.childComponents.length; i++) {
	                var child = config.childComponents[i];
	                child = Object.assign({}, child, {
	                    childComponent: this.state.videoType.component,
	                    componentProps: Object.assign({}, {
	                        screenObject: this.state.screenObject,
	                        callbacks: this.props.callbacks,
	                        video: this.state.video
	                    })
	                });
	
	                childComponenents = dataHelper.immutablePush(childComponenents, child);
	            }
	            config = Object.assign({}, config, {
	                childComponents: childComponenents
	            });
	
	            this.props.actions.setNewAssetDialog(config);
	        }
	    }, {
	        key: 'setStatusClass',
	        value: function setStatusClass() {
	            if (this.state.status === objectConstants.STATUS_COMPLETE) {
	                return "viewed";
	            } else {
	                return "not-viewed";
	            }
	        }
	    }, {
	        key: 'setKeyboardAccessibility',
	        value: function setKeyboardAccessibility(event) {
	            if (event.which === keyboardConstants.ENTER_KEY || event.which === keyboardConstants.SPACEBAR_KEY) {
	                event.preventDefault();
	                this.launchVideo();
	            }
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            return _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(
	                    'div',
	                    { className: 'object-container', ref: this.state.screenObject.asset_id + '_asset' },
	                    _react2.default.createElement(
	                        'div',
	                        null,
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'video-container', onClick: this.launchVideo, onKeyDown: this.setKeyboardAccessibility, tabIndex: '0', role: 'link', id: 'video_player_' + this.state.screenObject.asset_id },
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'video-thumbnail-wrapper' },
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: 'video-controls ' + this.getControlClass() },
	                                    _react2.default.createElement('img', { src: this.getImagePath(this.state.video.thumbnail), alt: '' })
	                                )
	                            ),
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'video-details' },
	                                this.state.screenObject.show_title && appHelper.isDefined(this.state.locale.label) && this.state.locale.label !== null && this.state.locale.label.length > 0 ? _react2.default.createElement('h4', { className: this.setStatusClass(), dangerouslySetInnerHTML: { __html: this.state.locale.label } }) : null,
	                                appHelper.isDefined(this.state.locale.description) && this.state.locale.description !== null && this.state.locale.description.length > 0 ? _react2.default.createElement('div', { dangerouslySetInnerHTML: { __html: this.state.locale.description } }) : null,
	                                appHelper.isDefined(this.state.video.txt) && this.state.video.txt.length > 0 ? _react2.default.createElement(
	                                    'p',
	                                    { className: 'video-transcript' },
	                                    _react2.default.createElement(
	                                        'a',
	                                        { href: this.getCaptionPath(this.state.video.txt), download: true, target: '_blank', tabIndex: 0, onClick: this.onLinkClick, className: 'document' },
	                                        this.state.download_transcript_label
	                                    )
	                                ) : null,
	                                this.state.status === objectConstants.STATUS_COMPLETE ? _react2.default.createElement(
	                                    'div',
	                                    { className: 'icon-first video-icon icon icons8-publish' },
	                                    this.state.replay_label
	                                ) : _react2.default.createElement(
	                                    'div',
	                                    { className: 'icon-first video-icon icon icons8-play' },
	                                    this.state.play_label,
	                                    this.state.screenObject.required_for_completion && !this.state.isResourceObject ? _react2.default.createElement(
	                                        'span',
	                                        null,
	                                        ' - ',
	                                        _react2.default.createElement(
	                                            'em',
	                                            null,
	                                            this.state.video_instruction
	                                        )
	                                    ) : null
	                                )
	                            )
	                        )
	                    ),
	                    this.state.showProgressionButton ? _react2.default.createElement(_Button2.default, { label: this.state.continue_label,
	                        id: this.state.screenObject + '_button',
	                        onClick: this.onProgressionBtnClicked }) : null
	                )
	            );
	        }
	    }]);
	
	    return Video;
	}(_react2.default.Component);
	
	Video.propTypes = {
	    screenObject: _propTypes2.default.object.isRequired,
	    callbacks: _propTypes2.default.object.isRequired,
	    index: _propTypes2.default.number,
	    contentData: _propTypes2.default.object.isRequired,
	    trackingData: _propTypes2.default.object.isRequired,
	    userData: _propTypes2.default.object.isRequired,
	    lang: _propTypes2.default.string.isRequired,
	    actions: _propTypes2.default.object.isRequired
	};
	
	Video.contextTypes = {
	    router: _propTypes2.default.object
	};
	
	function mapStateToProps(state, ownProps) {
	    var lang = state.userData.lang;
	    return {
	        lang: lang,
	        contentData: state.contentData,
	        trackingData: state.trackingData,
	        userData: state.userData
	    };
	}
	
	function mapDispatchToProps(dispatch) {
	    return {
	        actions: (0, _redux.bindActionCreators)(Object.assign({}, appDataActions, trackingDataActions, dialogPopupActions), dispatch)
	    };
	}
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(Video);

/***/ },
/* 529 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(5);
	
	var _redux = __webpack_require__(4);
	
	var _appDataActions = __webpack_require__(12);
	
	var appDataActions = _interopRequireWildcard(_appDataActions);
	
	var _trackingDataActions = __webpack_require__(7);
	
	var trackingDataActions = _interopRequireWildcard(_trackingDataActions);
	
	var _appHelper = __webpack_require__(3);
	
	var appHelper = _interopRequireWildcard(_appHelper);
	
	var _dataHelper = __webpack_require__(11);
	
	var dataHelper = _interopRequireWildcard(_dataHelper);
	
	var _appConstants = __webpack_require__(13);
	
	var appConstants = _interopRequireWildcard(_appConstants);
	
	var _objectConstants = __webpack_require__(9);
	
	var objectConstants = _interopRequireWildcard(_objectConstants);
	
	var _userDataHelper = __webpack_require__(15);
	
	var userDataHelper = _interopRequireWildcard(_userDataHelper);
	
	var _keyboardConstants = __webpack_require__(14);
	
	var keyboardConstants = _interopRequireWildcard(_keyboardConstants);
	
	var _localStorage = __webpack_require__(17);
	
	var localStorage = _interopRequireWildcard(_localStorage);
	
	var _gsap = __webpack_require__(8);
	
	var _gsapReactPlugin = __webpack_require__(10);
	
	var _gsapReactPlugin2 = _interopRequireDefault(_gsapReactPlugin);
	
	var _video = __webpack_require__(437);
	
	var _video2 = _interopRequireDefault(_video);
	
	var _reactPlayer = __webpack_require__(189);
	
	var _reactPlayer2 = _interopRequireDefault(_reactPlayer);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	//https://www.npmjs.com/package/react-player
	var SHOW_CONTROLS = true;
	
	var VideoJsInlinePlayer = function (_React$Component) {
	    _inherits(VideoJsInlinePlayer, _React$Component);
	
	    function VideoJsInlinePlayer(props, context) {
	        _classCallCheck(this, VideoJsInlinePlayer);
	
	        var _this = _possibleConstructorReturn(this, (VideoJsInlinePlayer.__proto__ || Object.getPrototypeOf(VideoJsInlinePlayer)).call(this, props, context));
	
	        _this.state = {
	            lang: _this.props.lang,
	            userData: _this.props.userData,
	            screenObject: _this.props.screenObject,
	            video: _this.props.video,
	            locale: appHelper.getLocalData(_this.props.screenObject),
	            responseData: {
	                latestResponse: {}
	            },
	            isPlaying: _this.props.autoPlay,
	            status: objectConstants.STATUS_NOT_STARTED,
	            trackable: true,
	            autoPlay: _this.props.autoPlay,
	            isResourceObject: appHelper.isDefined(_this.props.callbacks.checkIsResourceScreen) && _this.props.callbacks.checkIsResourceScreen(),
	            download_transcript_label: appHelper.getLocaleString("download_transcript_label"),
	            language_name: appHelper.getArrayObjectByKey(localStorage.languages, "language_code", _this.props.lang).language_name
	        };
	
	        _this.handleProgression = _this.handleProgression.bind(_this);
	        _this.show = _this.show.bind(_this);
	        _this.onStartFunc = _this.onStartFunc.bind(_this);
	        _this.onEndedFunc = _this.onEndedFunc.bind(_this);
	        _this.onPauseFunc = _this.onPauseFunc.bind(_this);
	        _this.onPlayFunc = _this.onPlayFunc.bind(_this);
	        _this.setClass = _this.setClass.bind(_this);
	        _this.getObjectStatus = _this.getObjectStatus.bind(_this);
	        _this.getVideoPath = _this.getVideoPath.bind(_this);
	        _this.getImagePath = _this.getImagePath.bind(_this);
	        _this.getControlClass = _this.getControlClass.bind(_this);
	        _this.reInit = _this.reInit.bind(_this);
	        _this.setKeyboardAccessibility = _this.setKeyboardAccessibility.bind(_this);
	        _this.readyVideo = _this.readyVideo.bind(_this);
	        _this.getCaptionPath = _this.getCaptionPath.bind(_this);
	        _this.onReady = _this.onReady.bind(_this);
	        _this.onLinkClick = _this.onLinkClick.bind(_this);
	        return _this;
	    }
	
	    _createClass(VideoJsInlinePlayer, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            this.readyVideo();
	            this.getObjectStatus();
	            this.show();
	        }
	    }, {
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(nextProps) {
	
	            if (this.state.userData !== nextProps.userData) {
	                this.setState({
	                    userData: Object.assign({}, nextProps.userData)
	                });
	            }
	
	            if (this.state.lang !== nextProps.lang) {
	                this.setState({
	                    lang: nextProps.lang,
	                    locale: appHelper.getLocalData(this.state.screenObject),
	                    download_transcript_label: appHelper.getLocaleString("download_transcript_label"),
	                    language_name: appHelper.getArrayObjectByKey(localStorage.languages, "language_code", nextProps.lang).language_name
	                });
	            }
	        }
	    }, {
	        key: 'componentDidUpdate',
	        value: function componentDidUpdate() {}
	    }, {
	        key: 'componentWillUnmount',
	        value: function componentWillUnmount() {
	            if (this.player) {
	                this.player.dispose();
	            }
	        }
	    }, {
	        key: 'readyVideo',
	        value: function readyVideo() {
	            var isLocal = dataHelper.getFileExtention(this.state.video.src) === "mp4";
	            var props = {
	                autoplay: false,
	                controls: true,
	                sources: [{
	                    src: isLocal ? this.getVideoPath(this.state.video) : this.state.video.src,
	                    type: 'video/mp4'
	                }]
	            };
	
	            var ref = this.refs['video_' + this.state.screenObject.asset_id];
	            this.player = (0, _video2.default)(ref, props, this.onReady); /**/
	        }
	    }, {
	        key: 'getCaptionPath',
	        value: function getCaptionPath(captions) {
	            if (appConstants.DEVELOPMENT_MODE) {
	                if (appHelper.isDefined(captions) && captions.length > 0) {
	                    return __webpack_require__(16)("./" + captions);
	                }
	            } else {
	                return captions;
	            }
	        }
	    }, {
	        key: 'onReady',
	        value: function onReady() {
	            this.player.on("play", this.onPlayFunc);
	            this.player.on("ended", this.onEndedFunc);
	        }
	    }, {
	        key: 'reInit',
	        value: function reInit() {
	
	            this.getObjectStatus();
	            this.onPlayFunc();
	            // this.show();
	        }
	    }, {
	        key: 'getObjectStatus',
	        value: function getObjectStatus() {
	            var objectUserData = {};
	            if (this.state.status !== objectConstants.STATUS_COMPLETE) {
	                var subScreenParent = this.props.callbacks.getSubScreenParent();
	                var screen_id = this.props.callbacks.getScreenId();
	                if (appHelper.isDefined(subScreenParent)) {
	                    objectUserData = userDataHelper.getSubScreenObjectStatus(this.state.userData, subScreenParent.screen_id, screen_id, this.state.screenObject.asset_id);
	                } else if (this.state.isResourceObject) {
	                    objectUserData = userDataHelper.getResourceScreenObjectUserData(this.state.userData, screen_id, this.state.screenObject.asset_id);
	                } else {
	                    objectUserData = userDataHelper.getObjectStatus(this.state.userData, screen_id, this.state.screenObject.asset_id);
	                }
	            }
	
	            if (!this.state.screenObject.required_for_completion || objectUserData.status === objectConstants.STATUS_COMPLETE) {
	                this.setState({ status: objectConstants.STATUS_COMPLETE });
	                this.handleProgression();
	            }
	        }
	    }, {
	        key: 'getVideoPath',
	        value: function getVideoPath(video) {
	            if (video.sub_type == objectConstants.VIDEO_SUB_TYPE_MP4 && appConstants.DEVELOPMENT_MODE) {
	                if (appHelper.isDefined(video.src) && video.src.length > 0) {
	                    return __webpack_require__(16)("./" + video.src);
	                }
	            } else {
	                return video.src;
	            }
	        }
	    }, {
	        key: 'handleProgression',
	        value: function handleProgression() {
	            var progressionRule = appHelper.isDefined(this.state.screenObject.progression) ? this.state.screenObject.progression : objectConstants.OBJECT_PROGRESSION_CONTINUE;
	            var progressionType = appHelper.isDefined(this.state.screenObject.progression_type) ? this.state.screenObject.progression_type : undefined;
	            var progressionGoToId = appHelper.isDefined(this.state.screenObject.progression_goto_id) ? this.state.screenObject.progression_goto_id : undefined;
	            var completionData = {
	                progression: progressionRule,
	                progressionType: progressionType,
	                progressionGoToId: progressionGoToId,
	                asset_id: this.state.screenObject.asset_id,
	                status: objectConstants.STATUS_COMPLETE,
	                showProgressionButton: false,
	                asset_type_code: this.state.screenObject.asset_type_code,
	                navigateToNextScreen: false
	            };
	
	            this.props.callbacks.onObjectComplete(completionData);
	            //t
	        }
	
	        //<iframe src={`https://player.vimeo.com/video/${this.state.locale.vimeo_id}`} width="100%" height="auto"  allowFullScreen />
	
	    }, {
	        key: 'onStartFunc',
	        value: function onStartFunc(event) {
	            this.setState({ isPlaying: true });
	            this.setState({ status: objectConstants.STATUS_IN_PROGRESS });
	            this.props.callbacks.scrollToVideo();
	        }
	    }, {
	        key: 'onEndedFunc',
	        value: function onEndedFunc(event) {
	
	            this.handleProgression();
	            // this.setState({isPlaying: false});
	            this.setState({ status: objectConstants.STATUS_COMPLETE });
	        }
	    }, {
	        key: 'onPauseFunc',
	        value: function onPauseFunc(event) {
	            //this.setState({isPlaying: false});
	        }
	    }, {
	        key: 'onPlayFunc',
	        value: function onPlayFunc(event) {
	
	            if (this.player) {
	                this.player.play();
	            }
	            this.setState({ isPlaying: true });
	            this.props.callbacks.scrollToVideo();
	            if (this.state.status !== objectConstants.STATUS_COMPLETE) {
	                this.setState({ status: objectConstants.STATUS_IN_PROGRESS });
	            }
	        }
	    }, {
	        key: 'setClass',
	        value: function setClass() {
	            if (this.state.isPlaying) {
	                return "playing";
	            } else {
	                return "";
	            }
	        }
	    }, {
	        key: 'setStatusClass',
	        value: function setStatusClass() {
	
	            if (this.state.status === objectConstants.STATUS_COMPLETE) {
	                return "viewed";
	            } else {
	                return "not-viewed";
	            }
	        }
	    }, {
	        key: 'show',
	        value: function show() {
	            var videoRef = this.refs['video_container_' + this.state.screenObject.asset_id];
	            if (appHelper.isDefined(videoRef)) {
	                _gsap.TweenLite.set(videoRef, { opacity: 1 });
	                _gsap.TweenLite.from(videoRef, objectConstants.SHOW_PANEL_DURATION, {
	                    opacity: 0,
	                    ease: _gsap.Expo.easeInOut
	                });
	            }
	        }
	    }, {
	        key: 'getControlClass',
	        value: function getControlClass() {
	            return this.state.status === objectConstants.STATUS_COMPLETE ? 'replay' : 'play';
	        }
	    }, {
	        key: 'getImagePath',
	        value: function getImagePath(image) {
	            if (appConstants.DEVELOPMENT_MODE) {
	                if (appHelper.isDefined(image) && image.length > 0) {
	                    return __webpack_require__(16)("./" + image);
	                }
	            } else {
	                return image;
	            }
	        }
	    }, {
	        key: 'setKeyboardAccessibility',
	        value: function setKeyboardAccessibility(event) {
	            if (appHelper.isDefined(event)) {
	                if (event.which === keyboardConstants.ENTER_KEY || event.which === keyboardConstants.SPACEBAR_KEY) {
	                    event.preventDefault();
	                    this.onPlayFunc();
	                }
	            }
	        }
	    }, {
	        key: 'onLinkClick',
	        value: function onLinkClick(event) {
	            event.stopPropagation();
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            return _react2.default.createElement(
	                'div',
	                { className: 'object-container', ref: 'video_container_' + this.state.screenObject.asset_id },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'video-object' },
	                    !this.state.isPlaying ? _react2.default.createElement(
	                        'div',
	                        { className: 'video-thumbnail-wrapper ' + this.getControlClass(), onClick: this.onPlayFunc, onKeyDown: this.setKeyboardAccessibility, role: 'link', tabIndex: '0', id: 'video_player=' + this.state.screenObject.asset_id },
	                        _react2.default.createElement('img', { src: this.getImagePath(this.state.video.thumbnail), alt: '' }),
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'video-details' },
	                            this.state.screenObject.show_title && appHelper.isDefined(this.state.locale.label) && this.state.locale.label !== null && this.state.locale.label.length > 0 ? _react2.default.createElement('h4', { dangerouslySetInnerHTML: { __html: this.state.locale.label } }) : null,
	                            appHelper.isDefined(this.state.locale.description) && this.state.locale.description !== null && this.state.locale.description.length > 0 ? _react2.default.createElement('div', { dangerouslySetInnerHTML: { __html: this.state.locale.description } }) : null,
	                            appHelper.isDefined(this.state.video.txt) && this.state.video.txt.length > 0 ? _react2.default.createElement(
	                                'p',
	                                { className: 'video-transcript' },
	                                _react2.default.createElement(
	                                    'a',
	                                    { href: this.getCaptionPath(this.state.video.txt), download: true, target: '_blank', tabIndex: 0, onClick: this.onLinkClick, className: 'document' },
	                                    this.state.download_transcript_label
	                                )
	                            ) : null
	                        )
	                    ) : null,
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'video-js-container' },
	                        _react2.default.createElement(
	                            'div',
	                            { 'data-vjs-player': true },
	                            appHelper.isDefined(this.state.video.vtt) && this.state.video.vtt.length > 0 ? _react2.default.createElement(
	                                'video',
	                                { ref: 'video_' + this.state.screenObject.asset_id, className: 'video-js' },
	                                _react2.default.createElement('track', { src: this.getCaptionPath(this.state.video.vtt), kind: 'captions', srcLang: this.state.lang, label: dataHelper.toTitleCase(this.state.language_name), 'default': true })
	                            ) : _react2.default.createElement('video', { ref: 'video_' + this.state.screenObject.asset_id, className: 'video-js' })
	                        )
	                    )
	                )
	            );
	        }
	    }]);
	
	    return VideoJsInlinePlayer;
	}(_react2.default.Component);
	/* config={{ file: {
	                                         tracks: [
	                                             {kind: 'subtitles', src:  require(`../../../../moveToDist/${this.state.video.captions}`), srcLang: 'en', default: true}
	                                         ]
	                                     }}}*/
	
	
	VideoJsInlinePlayer.propTypes = {
	    screenObject: _propTypes2.default.object.isRequired,
	    video: _propTypes2.default.object.isRequired,
	    callbacks: _propTypes2.default.object.isRequired,
	    contentData: _propTypes2.default.object.isRequired,
	    trackingData: _propTypes2.default.object.isRequired,
	    userData: _propTypes2.default.object.isRequired,
	    autoPlay: _propTypes2.default.bool.isRequired,
	    lang: _propTypes2.default.string.isRequired,
	    actions: _propTypes2.default.object.isRequired
	};
	
	VideoJsInlinePlayer.contextTypes = {
	    router: _propTypes2.default.object
	};
	
	function mapStateToProps(state, ownProps) {
	    var lang = state.userData.lang;
	    return {
	        lang: lang,
	        contentData: state.contentData,
	        trackingData: state.trackingData,
	        userData: state.userData
	    };
	}
	
	function mapDispatchToProps(dispatch) {
	    return {
	        actions: (0, _redux.bindActionCreators)(Object.assign({}, appDataActions, trackingDataActions), dispatch)
	    };
	}
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(VideoJsInlinePlayer);

/***/ },
/* 530 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(5);
	
	var _redux = __webpack_require__(4);
	
	var _appDataActions = __webpack_require__(12);
	
	var appDataActions = _interopRequireWildcard(_appDataActions);
	
	var _trackingDataActions = __webpack_require__(7);
	
	var trackingDataActions = _interopRequireWildcard(_trackingDataActions);
	
	var _appHelper = __webpack_require__(3);
	
	var appHelper = _interopRequireWildcard(_appHelper);
	
	var _dataHelper = __webpack_require__(11);
	
	var dataHelper = _interopRequireWildcard(_dataHelper);
	
	var _video = __webpack_require__(437);
	
	var _video2 = _interopRequireDefault(_video);
	
	var _appConstants = __webpack_require__(13);
	
	var appConstants = _interopRequireWildcard(_appConstants);
	
	var _objectConstants = __webpack_require__(9);
	
	var objectConstants = _interopRequireWildcard(_objectConstants);
	
	var _userDataHelper = __webpack_require__(15);
	
	var userDataHelper = _interopRequireWildcard(_userDataHelper);
	
	var _keyboardConstants = __webpack_require__(14);
	
	var keyboardConstants = _interopRequireWildcard(_keyboardConstants);
	
	var _localStorage = __webpack_require__(17);
	
	var localStorage = _interopRequireWildcard(_localStorage);
	
	var _gsap = __webpack_require__(8);
	
	var _gsapReactPlugin = __webpack_require__(10);
	
	var _gsapReactPlugin2 = _interopRequireDefault(_gsapReactPlugin);
	
	var _reactPlayer = __webpack_require__(189);
	
	var _reactPlayer2 = _interopRequireDefault(_reactPlayer);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	//https://www.npmjs.com/package/react-player
	var SHOW_CONTROLS = true;
	
	var VideoJsPlayer = function (_React$Component) {
	    _inherits(VideoJsPlayer, _React$Component);
	
	    function VideoJsPlayer(props, context) {
	        _classCallCheck(this, VideoJsPlayer);
	
	        var _this = _possibleConstructorReturn(this, (VideoJsPlayer.__proto__ || Object.getPrototypeOf(VideoJsPlayer)).call(this, props, context));
	
	        _this.state = {
	            lang: _this.props.lang,
	            userData: _this.props.userData,
	            screenObject: _this.props.screenObject,
	            video: _this.props.video,
	            locale: appHelper.getLocalData(_this.props.screenObject),
	            responseData: {
	                latestResponse: {}
	            },
	            isPlaying: true,
	            status: objectConstants.STATUS_NOT_STARTED,
	            isResourceObject: appHelper.isDefined(_this.props.callbacks.checkIsResourceScreen) && _this.props.callbacks.checkIsResourceScreen(),
	            trackable: true,
	            autoPlay: true,
	            video_instruction: appHelper.getLocaleString("video_instruction"),
	            done_label: appHelper.getLocaleString("done_label"),
	            cancel_label: appHelper.getLocaleString("cancel_label"),
	            download_transcript_label: appHelper.getLocaleString("download_transcript_label"),
	            language_name: appHelper.getArrayObjectByKey(localStorage.languages, "language_code", _this.props.lang).language_name
	        };
	
	        _this.handleProgression = _this.handleProgression.bind(_this);
	        _this.show = _this.show.bind(_this);
	        _this.onStartFunc = _this.onStartFunc.bind(_this);
	        _this.onEndedFunc = _this.onEndedFunc.bind(_this);
	        _this.onPauseFunc = _this.onPauseFunc.bind(_this);
	        _this.onPlayFunc = _this.onPlayFunc.bind(_this);
	        _this.setClass = _this.setClass.bind(_this);
	        _this.getObjectStatusClass = _this.getObjectStatusClass.bind(_this);
	        _this.getVideoPath = _this.getVideoPath.bind(_this);
	        _this.getImagePath = _this.getImagePath.bind(_this);
	        _this.getControlClass = _this.getControlClass.bind(_this);
	        _this.setKeyboardAccessibility = _this.setKeyboardAccessibility.bind(_this);
	        _this.readyVideo = _this.readyVideo.bind(_this);
	        _this.getCaptionPath = _this.getCaptionPath.bind(_this);
	        _this.onReady = _this.onReady.bind(_this);
	        _this.onLinkClick = _this.onLinkClick.bind(_this);
	
	        return _this;
	    }
	
	    _createClass(VideoJsPlayer, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            this.readyVideo();
	            this.show();
	        }
	    }, {
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(nextProps) {
	            if (this.state.userData !== nextProps.userData) {
	                this.setState({ userData: Object.assign({}, nextProps.userData) });
	            }
	
	            if (this.state.lang !== nextProps.lang) {
	                this.setState({
	                    lang: nextProps.lang,
	                    locale: appHelper.getLocalData(this.state.screenObject),
	                    video_instruction: appHelper.getLocaleString("video_instruction"),
	                    done_label: appHelper.getLocaleString("done_label"),
	                    cancel_label: appHelper.getLocaleString("cancel_label"),
	                    download_transcript_label: appHelper.getLocaleString("download_transcript_label"),
	                    language_name: appHelper.getArrayObjectByKey(localStorage.languages, "language_code", nextProps.lang).language_name
	                });
	            }
	        }
	    }, {
	        key: 'componentWillUnmount',
	        value: function componentWillUnmount() {
	            if (this.player) {
	                this.player.dispose();
	            }
	        }
	    }, {
	        key: 'readyVideo',
	        value: function readyVideo() {
	            var isLocal = dataHelper.getFileExtention(this.state.video.src) === "mp4";
	            var props = {
	                autoplay: true,
	                controls: true,
	                sources: [{
	                    src: isLocal ? this.getVideoPath(this.state.video) : this.state.video.src,
	                    type: 'video/mp4'
	                }]
	            };
	
	            var ref = this.refs['video_' + this.state.screenObject.asset_id];
	            this.player = (0, _video2.default)(ref, props, this.onReady); /**/
	        }
	    }, {
	        key: 'getCaptionPath',
	        value: function getCaptionPath(captions) {
	            if (appConstants.DEVELOPMENT_MODE) {
	                if (appHelper.isDefined(captions) && captions.length > 0) {
	                    return __webpack_require__(16)("./" + captions);
	                }
	            } else {
	                return captions;
	            }
	        }
	    }, {
	        key: 'onReady',
	        value: function onReady() {
	            this.player.on("play", this.onPlayFunc);
	            this.player.on("ended", this.onEndedFunc);
	        }
	    }, {
	        key: 'getObjectStatusClass',
	        value: function getObjectStatusClass() {
	            var objectUserData = {};
	            var subScreenParent = {};
	            var screen_id = undefined;
	            if (appHelper.isDefined(this.props.callbacks.getSubScreenParent)) {
	                subScreenParent = this.props.callbacks.getSubScreenParent();
	            }
	            if (appHelper.isDefined(this.props.callbacks.getScreenId)) {
	                screen_id = this.props.callbacks.getScreenId();
	            }
	
	            if (appHelper.isDefined(screen_id)) {
	                if (appHelper.isDefined(subScreenParent)) {
	                    objectUserData = userDataHelper.getSubScreenObjectStatus(this.state.userData, subScreenParent.screen_id, screen_id, this.state.screenObject.asset_id);
	                } else if (this.state.isResourceObject) {
	                    objectUserData = userDataHelper.getResourceScreenObjectUserData(this.state.userData, screen_id, this.state.screenObject.asset_id);
	                } else {
	                    objectUserData = userDataHelper.getObjectStatus(this.state.userData, screen_id, this.state.screenObject.asset_id);
	                }
	            } else {
	                objectUserData = userDataHelper.getAttachmentObjectUserData(this.state.userData, this.state.screenObject.asset_id);
	            }
	
	            if (appHelper.isDefined(objectUserData.status)) {
	
	                if (objectUserData.status === objectConstants.STATUS_COMPLETE) {
	                    return 'complete';
	                } else if (objectUserData.status === objectConstants.STATUS_IN_PROGRESS) {
	                    return 'in-progress';
	                } else if (objectUserData.status === objectConstants.STATUS_NOT_REQUIRED) {
	                    return 'not-required';
	                } else {
	                    if (this.state.status === objectConstants.STATUS_COMPLETE) {
	                        return 'complete';
	                    } else if (this.state.status === objectConstants.STATUS_IN_PROGRESS) {
	                        return 'in-progress';
	                    } else {
	                        return 'not-started';
	                    }
	                }
	            }
	            return 'not-started';
	        }
	    }, {
	        key: 'getVideoPath',
	        value: function getVideoPath(video) {
	            if (video.sub_type == objectConstants.VIDEO_SUB_TYPE_MP4 && appConstants.DEVELOPMENT_MODE) {
	                if (appHelper.isDefined(video.src) && video.src.length > 0) {
	                    return __webpack_require__(16)("./" + video.src);
	                }
	            } else {
	                return video.src;
	            }
	        }
	    }, {
	        key: 'handleProgression',
	        value: function handleProgression() {
	            this.props.callbacks.onObjectComplete(objectConstants.OBJECT_PROGRESSION_CONTINUE, this.state.screenObject.asset_id, this.state.responseData.latestResponse);
	        }
	
	        //<iframe src={`https://player.vimeo.com/video/${this.state.locale.vimeo_id}`} width="100%" height="auto"  allowFullScreen />
	
	    }, {
	        key: 'onStartFunc',
	        value: function onStartFunc(event) {
	            //console.log(`onStart`);
	            this.setState({ isPlaying: true });
	            this.setState({ status: objectConstants.STATUS_IN_PROGRESS });
	        }
	    }, {
	        key: 'onEndedFunc',
	        value: function onEndedFunc(event) {
	            this.props.onAssetViewed();
	            this.setState({ isPlaying: false });
	            this.setState({ status: objectConstants.STATUS_COMPLETE });
	        }
	    }, {
	        key: 'onPauseFunc',
	        value: function onPauseFunc(event) {
	            this.setState({ isPlaying: false });
	        }
	    }, {
	        key: 'onPlayFunc',
	        value: function onPlayFunc(event) {
	            this.setState({ isPlaying: true });
	            if (this.state.status !== objectConstants.STATUS_COMPLETE) {
	                this.setState({ status: objectConstants.STATUS_IN_PROGRESS });
	            }
	        }
	    }, {
	        key: 'setClass',
	        value: function setClass() {
	            if (this.state.isPlaying) {
	                return "playing";
	            } else {
	                return "";
	            }
	        }
	    }, {
	        key: 'setStatusClass',
	        value: function setStatusClass() {
	
	            if (this.state.status === objectConstants.STATUS_COMPLETE) {
	                return "viewed";
	            } else {
	                return "not-viewed";
	            }
	        }
	    }, {
	        key: 'show',
	        value: function show() {
	            var videoRef = this.refs['video_container_' + this.state.screenObject.asset_id];
	            if (appHelper.isDefined(videoRef)) {
	                _gsap.TweenLite.set(videoRef, { opacity: 1 });
	                _gsap.TweenLite.from(videoRef, objectConstants.SHOW_PANEL_DURATION, {
	                    opacity: 0,
	                    ease: _gsap.Expo.easeInOut
	                });
	            }
	        }
	    }, {
	        key: 'getControlClass',
	        value: function getControlClass() {
	            return this.state.status === objectConstants.STATUS_COMPLETE ? 'replay' : 'play';
	        }
	    }, {
	        key: 'getImagePath',
	        value: function getImagePath(image) {
	            if (appConstants.DEVELOPMENT_MODE) {
	                if (appHelper.isDefined(image) && image.length > 0) {
	                    return __webpack_require__(16)("./" + image);
	                }
	            } else {
	                return image;
	            }
	        }
	    }, {
	        key: 'setKeyboardAccessibility',
	        value: function setKeyboardAccessibility(event) {
	            if (appHelper.isDefined(event)) {
	                if (event.which === keyboardConstants.ENTER_KEY || event.which === keyboardConstants.SPACEBAR_KEY) {
	                    event.preventDefault();
	                    this.onPlayFunc();
	                }
	            }
	        }
	    }, {
	        key: 'onLinkClick',
	        value: function onLinkClick(event) {
	            event.stopPropagation();
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            return _react2.default.createElement(
	                'div',
	                { className: 'object-container', ref: 'video_container_' + this.state.screenObject.asset_id },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'asset-dialog-image' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'asset-image-header' },
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'title-col truncate-text-container' },
	                            this.state.status !== objectConstants.STATUS_COMPLETE && this.state.screenObject.required_for_completion ? _react2.default.createElement('div', { className: 'title ' + this.getObjectStatusClass(),
	                                dangerouslySetInnerHTML: { __html: this.state.locale.label + '  - <em>' + this.state.video_instruction + '</em>' } }) : _react2.default.createElement('div', { className: 'title ' + this.getObjectStatusClass(),
	                                dangerouslySetInnerHTML: { __html: this.state.locale.label } })
	                        ),
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'nav-col' },
	                            _react2.default.createElement(
	                                'button',
	                                { className: 'btn guroo-btn', onClick: this.props.closeDialog },
	                                this.state.status === objectConstants.STATUS_COMPLETE || !this.state.screenObject.required_for_completion ? _react2.default.createElement(
	                                    'span',
	                                    null,
	                                    this.state.done_label
	                                ) : _react2.default.createElement(
	                                    'span',
	                                    null,
	                                    this.state.cancel_label
	                                )
	                            )
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'asset-img-container video' },
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'video-js-container' },
	                            _react2.default.createElement(
	                                'div',
	                                { 'data-vjs-player': true },
	                                appHelper.isDefined(this.state.video.vtt) && this.state.video.vtt.length > 0 ? _react2.default.createElement(
	                                    'video',
	                                    { ref: 'video_' + this.state.screenObject.asset_id, className: 'video-js' },
	                                    _react2.default.createElement('track', { src: this.getCaptionPath(this.state.video.vtt), kind: 'captions',
	                                        srcLang: this.state.lang, label: dataHelper.toTitleCase(this.state.language_name), 'default': true })
	                                ) : _react2.default.createElement('video', { ref: 'video_' + this.state.screenObject.asset_id, className: 'video-js' })
	                            )
	                        ),
	                        !this.state.isPlaying ? _react2.default.createElement(
	                            'div',
	                            { className: 'video-thumbnail-wrapper ' + this.getControlClass(),
	                                onClick: this.onPlayFunc, onKeyDown: this.setKeyboardAccessibility(), tabIndex: '0',
	                                role: 'link' },
	                            _react2.default.createElement('img', { src: this.getImagePath(this.state.video.thumbnail), alt: '' })
	                        ) : null,
	                        appHelper.isDefined(this.state.locale.description) && this.state.locale.description !== null && this.state.locale.description.length > 0 ? _react2.default.createElement(
	                            'div',
	                            { className: 'asset-desc' },
	                            _react2.default.createElement('div', { dangerouslySetInnerHTML: { __html: this.state.locale.description } })
	                        ) : null,
	                        appHelper.isDefined(this.state.video.txt) && this.state.video.txt.length > 0 ? _react2.default.createElement(
	                            'div',
	                            { className: 'asset-desc' },
	                            _react2.default.createElement(
	                                'a',
	                                { href: this.getCaptionPath(this.state.video.txt), download: true, target: '_blank', tabIndex: 0, onClick: this.onLinkClick, className: 'document' },
	                                this.state.download_transcript_label
	                            )
	                        ) : null
	                    )
	                )
	            );
	        }
	    }]);
	
	    return VideoJsPlayer;
	}(_react2.default.Component);
	
	/*config={{ file: {
	                                             tracks: [
	                                                 {kind: 'subtitles', src:  require(`../../../../moveToDist/${this.state.video.captions}`), srcLang: 'en', default: true}
	                                             ]
	                                         }}}*/
	
	
	VideoJsPlayer.propTypes = {
	    screenObject: _propTypes2.default.object.isRequired,
	    video: _propTypes2.default.object.isRequired,
	    callbacks: _propTypes2.default.object.isRequired,
	    contentData: _propTypes2.default.object.isRequired,
	    trackingData: _propTypes2.default.object.isRequired,
	    actions: _propTypes2.default.object.isRequired,
	    onAssetViewed: _propTypes2.default.func.isRequired,
	    closeDialog: _propTypes2.default.func.isRequired,
	    lang: _propTypes2.default.string.isRequired,
	    userData: _propTypes2.default.object.isRequired
	};
	
	VideoJsPlayer.contextTypes = {
	    router: _propTypes2.default.object
	};
	
	function mapStateToProps(state, ownProps) {
	    var lang = state.userData.lang;
	    return {
	        lang: lang,
	        contentData: state.contentData,
	        trackingData: state.trackingData,
	        userData: state.userData
	    };
	}
	
	function mapDispatchToProps(dispatch) {
	    return {
	        actions: (0, _redux.bindActionCreators)(Object.assign({}, appDataActions, trackingDataActions), dispatch)
	    };
	}
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(VideoJsPlayer);

/***/ },
/* 531 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(5);
	
	var _redux = __webpack_require__(4);
	
	var _appDataActions = __webpack_require__(12);
	
	var appDataActions = _interopRequireWildcard(_appDataActions);
	
	var _trackingDataActions = __webpack_require__(7);
	
	var trackingDataActions = _interopRequireWildcard(_trackingDataActions);
	
	var _appHelper = __webpack_require__(3);
	
	var appHelper = _interopRequireWildcard(_appHelper);
	
	var _dataHelper = __webpack_require__(11);
	
	var dataHelper = _interopRequireWildcard(_dataHelper);
	
	var _appConstants = __webpack_require__(13);
	
	var appConstants = _interopRequireWildcard(_appConstants);
	
	var _objectConstants = __webpack_require__(9);
	
	var objectConstants = _interopRequireWildcard(_objectConstants);
	
	var _userDataHelper = __webpack_require__(15);
	
	var userDataHelper = _interopRequireWildcard(_userDataHelper);
	
	var _keyboardConstants = __webpack_require__(14);
	
	var keyboardConstants = _interopRequireWildcard(_keyboardConstants);
	
	var _gsap = __webpack_require__(8);
	
	var _gsapReactPlugin = __webpack_require__(10);
	
	var _gsapReactPlugin2 = _interopRequireDefault(_gsapReactPlugin);
	
	var _reactPlayer = __webpack_require__(189);
	
	var _reactPlayer2 = _interopRequireDefault(_reactPlayer);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	//https://www.npmjs.com/package/react-player
	var SHOW_CONTROLS = true;
	
	var ReactVideoInline = function (_React$Component) {
	    _inherits(ReactVideoInline, _React$Component);
	
	    function ReactVideoInline(props, context) {
	        _classCallCheck(this, ReactVideoInline);
	
	        var _this = _possibleConstructorReturn(this, (ReactVideoInline.__proto__ || Object.getPrototypeOf(ReactVideoInline)).call(this, props, context));
	
	        _this.state = {
	            lang: _this.props.lang,
	            userData: _this.props.userData,
	            screenObject: _this.props.screenObject,
	            video: _this.props.video,
	            locale: appHelper.getLocalData(_this.props.screenObject),
	            responseData: {
	                latestResponse: {}
	            },
	            isPlaying: _this.props.autoPlay,
	            status: objectConstants.STATUS_NOT_STARTED,
	            trackable: true,
	            autoPlay: _this.props.autoPlay,
	            isResourceObject: appHelper.isDefined(_this.props.callbacks.checkIsResourceScreen) && _this.props.callbacks.checkIsResourceScreen()
	
	        };
	
	        _this.handleProgression = _this.handleProgression.bind(_this);
	        _this.show = _this.show.bind(_this);
	        _this.onStartFunc = _this.onStartFunc.bind(_this);
	        _this.onEndedFunc = _this.onEndedFunc.bind(_this);
	        _this.onPauseFunc = _this.onPauseFunc.bind(_this);
	        _this.onPlayFunc = _this.onPlayFunc.bind(_this);
	        _this.setClass = _this.setClass.bind(_this);
	        _this.getObjectStatus = _this.getObjectStatus.bind(_this);
	        _this.getVideoPath = _this.getVideoPath.bind(_this);
	        _this.getImagePath = _this.getImagePath.bind(_this);
	        _this.getControlClass = _this.getControlClass.bind(_this);
	        _this.reInit = _this.reInit.bind(_this);
	        _this.setKeyboardAccessibility = _this.setKeyboardAccessibility.bind(_this);
	        return _this;
	    }
	
	    _createClass(ReactVideoInline, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	
	            this.getObjectStatus();
	            this.show();
	        }
	    }, {
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(nextProps) {
	
	            if (this.state.userData !== nextProps.userData) {
	                this.setState({
	                    userData: Object.assign({}, nextProps.userData)
	                });
	            }
	
	            if (this.state.lang !== nextProps.lang) {
	                this.setState({
	                    lang: nextProps.lang,
	                    locale: appHelper.getLocalData(this.state.screenObject)
	                });
	            }
	        }
	    }, {
	        key: 'componentDidUpdate',
	        value: function componentDidUpdate() {}
	    }, {
	        key: 'reInit',
	        value: function reInit() {
	
	            this.getObjectStatus();
	            this.onPlayFunc();
	            // this.show();
	        }
	    }, {
	        key: 'getObjectStatus',
	        value: function getObjectStatus() {
	            var objectUserData = {};
	            if (this.state.status !== objectConstants.STATUS_COMPLETE) {
	                var subScreenParent = this.props.callbacks.getSubScreenParent();
	                var screen_id = this.props.callbacks.getScreenId();
	                if (appHelper.isDefined(subScreenParent)) {
	                    objectUserData = userDataHelper.getSubScreenObjectStatus(this.state.userData, subScreenParent.screen_id, screen_id, this.state.screenObject.asset_id);
	                } else if (this.state.isResourceObject) {
	                    objectUserData = userDataHelper.getResourceScreenObjectUserData(this.state.userData, screen_id, this.state.screenObject.asset_id);
	                } else {
	                    objectUserData = userDataHelper.getObjectStatus(this.state.userData, screen_id, this.state.screenObject.asset_id);
	                }
	            }
	
	            if (!this.state.screenObject.required_for_completion || objectUserData.status === objectConstants.STATUS_COMPLETE) {
	                this.setState({ status: objectConstants.STATUS_COMPLETE });
	                this.handleProgression();
	            }
	        }
	    }, {
	        key: 'getVideoPath',
	        value: function getVideoPath(video) {
	            if (video.sub_type == objectConstants.VIDEO_SUB_TYPE_MP4 && appConstants.DEVELOPMENT_MODE) {
	                if (appHelper.isDefined(video.src) && video.src.length > 0) {
	                    return __webpack_require__(16)("./" + video.src);
	                }
	            } else {
	                return video.src;
	            }
	        }
	    }, {
	        key: 'handleProgression',
	        value: function handleProgression() {
	            var progressionRule = appHelper.isDefined(this.state.screenObject.progression) ? this.state.screenObject.progression : objectConstants.OBJECT_PROGRESSION_CONTINUE;
	            var progressionType = appHelper.isDefined(this.state.screenObject.progression_type) ? this.state.screenObject.progression_type : undefined;
	            var progressionGoToId = appHelper.isDefined(this.state.screenObject.progression_goto_id) ? this.state.screenObject.progression_goto_id : undefined;
	            var completionData = {
	                progression: progressionRule,
	                progressionType: progressionType,
	                progressionGoToId: progressionGoToId,
	                asset_id: this.state.screenObject.asset_id,
	                status: objectConstants.STATUS_COMPLETE,
	                showProgressionButton: false,
	                asset_type_code: this.state.screenObject.asset_type_code,
	                navigateToNextScreen: false
	            };
	
	            this.props.callbacks.onObjectComplete(completionData);
	            //t
	        }
	
	        //<iframe src={`https://player.vimeo.com/video/${this.state.locale.vimeo_id}`} width="100%" height="auto"  allowFullScreen />
	
	    }, {
	        key: 'onStartFunc',
	        value: function onStartFunc(event) {
	            this.setState({ isPlaying: true });
	            this.setState({ status: objectConstants.STATUS_IN_PROGRESS });
	            this.props.callbacks.scrollToVideo();
	        }
	    }, {
	        key: 'onEndedFunc',
	        value: function onEndedFunc(event) {
	
	            this.handleProgression();
	            // this.setState({isPlaying: false});
	            this.setState({ status: objectConstants.STATUS_COMPLETE });
	        }
	    }, {
	        key: 'onPauseFunc',
	        value: function onPauseFunc(event) {
	            //this.setState({isPlaying: false});
	        }
	    }, {
	        key: 'onPlayFunc',
	        value: function onPlayFunc(event) {
	            this.setState({ isPlaying: true });
	            this.props.callbacks.scrollToVideo();
	            if (this.state.status !== objectConstants.STATUS_COMPLETE) {
	                this.setState({ status: objectConstants.STATUS_IN_PROGRESS });
	            }
	        }
	    }, {
	        key: 'setClass',
	        value: function setClass() {
	            if (this.state.isPlaying) {
	                return "playing";
	            } else {
	                return "";
	            }
	        }
	    }, {
	        key: 'setStatusClass',
	        value: function setStatusClass() {
	
	            if (this.state.status === objectConstants.STATUS_COMPLETE) {
	                return "viewed";
	            } else {
	                return "not-viewed";
	            }
	        }
	    }, {
	        key: 'show',
	        value: function show() {
	            var videoRef = this.refs['video_container_' + this.state.screenObject.asset_id];
	            if (appHelper.isDefined(videoRef)) {
	                _gsap.TweenLite.set(videoRef, { opacity: 1 });
	                _gsap.TweenLite.from(videoRef, objectConstants.SHOW_PANEL_DURATION, {
	                    opacity: 0,
	                    ease: _gsap.Expo.easeInOut
	                });
	            }
	        }
	    }, {
	        key: 'getControlClass',
	        value: function getControlClass() {
	            return this.state.status === objectConstants.STATUS_COMPLETE ? 'replay' : 'play';
	        }
	    }, {
	        key: 'getImagePath',
	        value: function getImagePath(image) {
	            if (appConstants.DEVELOPMENT_MODE) {
	                if (appHelper.isDefined(image) && image.length > 0) {
	                    return __webpack_require__(16)("./" + image);
	                }
	            } else {
	                return image;
	            }
	        }
	    }, {
	        key: 'setKeyboardAccessibility',
	        value: function setKeyboardAccessibility(event) {
	            if (appHelper.isDefined(event)) {
	                if (event.which === keyboardConstants.ENTER_KEY || event.which === keyboardConstants.SPACEBAR_KEY) {
	                    event.preventDefault();
	                    this.onPlayFunc();
	                }
	            }
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            return _react2.default.createElement(
	                'div',
	                { className: 'object-container', ref: 'video_container_' + this.state.screenObject.asset_id },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'video-object' },
	                    !this.state.isPlaying ? _react2.default.createElement(
	                        'div',
	                        { className: 'video-thumbnail-wrapper ' + this.getControlClass(), onClick: this.onPlayFunc, onKeyDown: this.setKeyboardAccessibility, role: 'link', tabIndex: '0', id: 'video_player=' + this.state.screenObject.asset_id },
	                        _react2.default.createElement('img', { src: this.getImagePath(this.state.video.thumbnail), alt: '' }),
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'video-details' },
	                            this.state.screenObject.show_title && appHelper.isDefined(this.state.locale.label) && this.state.locale.label !== null && this.state.locale.label.length > 0 ? _react2.default.createElement('h4', { dangerouslySetInnerHTML: { __html: this.state.locale.label } }) : null,
	                            appHelper.isDefined(this.state.locale.description) && this.state.locale.description !== null && this.state.locale.description.length > 0 ? _react2.default.createElement('div', { dangerouslySetInnerHTML: { __html: this.state.locale.description } }) : null
	                        )
	                    ) : null,
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'video-wrapper' },
	                        _react2.default.createElement(_reactPlayer2.default, { id: 'video_' + this.state.screenObject.asset_id,
	                            url: '' + this.getVideoPath(this.state.video),
	                            onStart: this.onStartFunc,
	                            onPause: this.onPauseFunc,
	                            onPlay: this.onPlayFunc,
	                            onEnded: this.onEndedFunc,
	                            width: '100%',
	                            height: 'auto',
	                            playing: this.state.isPlaying,
	                            controls: SHOW_CONTROLS
	
	                        })
	                    )
	                )
	            );
	        }
	    }]);
	
	    return ReactVideoInline;
	}(_react2.default.Component);
	/* config={{ file: {
	                                         tracks: [
	                                             {kind: 'subtitles', src:  require(`../../../../moveToDist/${this.state.video.captions}`), srcLang: 'en', default: true}
	                                         ]
	                                     }}}*/
	
	
	ReactVideoInline.propTypes = {
	    screenObject: _propTypes2.default.object.isRequired,
	    video: _propTypes2.default.object.isRequired,
	    callbacks: _propTypes2.default.object.isRequired,
	    contentData: _propTypes2.default.object.isRequired,
	    trackingData: _propTypes2.default.object.isRequired,
	    userData: _propTypes2.default.object.isRequired,
	    autoPlay: _propTypes2.default.bool.isRequired,
	    lang: _propTypes2.default.string.isRequired,
	    actions: _propTypes2.default.object.isRequired
	};
	
	ReactVideoInline.contextTypes = {
	    router: _propTypes2.default.object
	};
	
	function mapStateToProps(state, ownProps) {
	    var lang = state.userData.lang;
	    return {
	        lang: lang,
	        contentData: state.contentData,
	        trackingData: state.trackingData,
	        userData: state.userData
	    };
	}
	
	function mapDispatchToProps(dispatch) {
	    return {
	        actions: (0, _redux.bindActionCreators)(Object.assign({}, appDataActions, trackingDataActions), dispatch)
	    };
	}
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(ReactVideoInline);

/***/ },
/* 532 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(5);
	
	var _redux = __webpack_require__(4);
	
	var _appDataActions = __webpack_require__(12);
	
	var appDataActions = _interopRequireWildcard(_appDataActions);
	
	var _trackingDataActions = __webpack_require__(7);
	
	var trackingDataActions = _interopRequireWildcard(_trackingDataActions);
	
	var _appHelper = __webpack_require__(3);
	
	var appHelper = _interopRequireWildcard(_appHelper);
	
	var _objectConstants = __webpack_require__(9);
	
	var objectConstants = _interopRequireWildcard(_objectConstants);
	
	var _gsap = __webpack_require__(8);
	
	var _gsapReactPlugin = __webpack_require__(10);
	
	var _gsapReactPlugin2 = _interopRequireDefault(_gsapReactPlugin);
	
	var _appConstants = __webpack_require__(13);
	
	var appConstants = _interopRequireWildcard(_appConstants);
	
	var _keyboardConstants = __webpack_require__(14);
	
	var keyboardConstants = _interopRequireWildcard(_keyboardConstants);
	
	var _player = __webpack_require__(272);
	
	var _player2 = _interopRequireDefault(_player);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var MATCH_MESSAGE_ORIGIN = /^https?:\/\/player.vimeo.com/;
	
	var VimeoVideoInline = function (_React$Component) {
	    _inherits(VimeoVideoInline, _React$Component);
	
	    function VimeoVideoInline(props, context) {
	        _classCallCheck(this, VimeoVideoInline);
	
	        var _this = _possibleConstructorReturn(this, (VimeoVideoInline.__proto__ || Object.getPrototypeOf(VimeoVideoInline)).call(this, props, context));
	
	        _this.state = {
	            lang: _this.props.lang,
	            userData: _this.props.userData,
	            screenObject: _this.props.screenObject,
	            video: _this.props.video,
	            locale: appHelper.getLocalData(_this.props.screenObject),
	            responseData: {
	                latestResponse: {}
	            },
	            player: {},
	            isPlaying: _this.props.autoPlay,
	            initialised: false,
	            status: objectConstants.STATUS_NOT_STARTED,
	            trackable: true,
	            autoplay: _this.props.autoPlay,
	            isResourceObject: appHelper.isDefined(_this.props.callbacks.checkIsResourceScreen) && _this.props.callbacks.checkIsResourceScreen(),
	            initialise: false
	
	        };
	
	        _this.initVideoPlayer = _this.initVideoPlayer.bind(_this);
	        _this.show = _this.show.bind(_this);
	        _this.handleProgression = _this.handleProgression.bind(_this);
	        _this.onEndedFunc = _this.onEndedFunc.bind(_this);
	        _this.onPauseFunc = _this.onPauseFunc.bind(_this);
	        _this.onPlayFunc = _this.onPlayFunc.bind(_this);
	        _this.onVideoMessage = _this.onVideoMessage.bind(_this);
	        _this.setClass = _this.setClass.bind(_this);
	        _this.getObjectStatus = _this.getObjectStatus.bind(_this);
	        _this.getVimeoId = _this.getVimeoId.bind(_this);
	        _this.getImagePath = _this.getImagePath.bind(_this);
	        _this.customPlay = _this.customPlay.bind(_this);
	        _this.getControlClass = _this.getControlClass.bind(_this);
	        _this.setStatusClass = _this.setStatusClass.bind(_this);
	        _this.reInit = _this.reInit.bind(_this);
	        _this.setKeyboardAccessibility = _this.setKeyboardAccessibility.bind(_this);
	        return _this;
	    }
	
	    _createClass(VimeoVideoInline, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            this.getObjectStatus();
	            this.show();
	            this.initVideoPlayer();
	            window.addEventListener('message', this.onVideoMessage, false);
	        }
	    }, {
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(nextProps) {
	            if (this.state.screenObject.asset_id !== nextProps.screenObject.asset_id) {
	                this.setState({
	                    screenObject: Object.assign({}, nextProps.screenObject),
	                    video: Object.assign({}, nextProps.video),
	                    initialise: true
	                });
	            }
	            if (this.state.userData !== nextProps.userData) {
	                this.setState({
	                    userData: Object.assign({}, nextProps.userData)
	                });
	            }
	
	            if (this.state.lang !== nextProps.lang) {
	                this.setState({
	                    lang: nextProps.lang,
	                    locale: appHelper.getLocalData(this.state.screenObject)
	                });
	            }
	        }
	    }, {
	        key: 'componentDidUpdate',
	        value: function componentDidUpdate() {
	            if (appHelper.isDefined(this.state.locale.description) && this.state.locale.description !== null && !this.state.initialised && this.state.video.src.length > 0) {
	                this.initVideoPlayer();
	            }
	            if (this.state.initialise) {
	
	                this.reInit();
	            }
	        }
	    }, {
	        key: 'componentWillUnmount',
	        value: function componentWillUnmount() {
	            window.removeEventListener('message', this.onVideoMessage, false);
	        }
	    }, {
	        key: 'reInit',
	        value: function reInit() {
	            this.setState({
	                initialise: false,
	                locale: appHelper.getLocalData(this.state.screenObject),
	                isPlaying: true
	            });
	
	            this.getObjectStatus();
	            // this.show();
	        }
	    }, {
	        key: 'getLocale',
	        value: function getLocale() {
	            var locale = appHelper.getLocalData(this.state.screenObject);
	            this.setState({ locale: Object.assign({}, locale) });
	            if (this.state.screenObject.show_title_in_header) {
	                this.props.actions.setScreenTitle(locale.title);
	            }
	        }
	    }, {
	        key: 'getObjectStatus',
	        value: function getObjectStatus() {}
	    }, {
	        key: 'initVideoPlayer',
	        value: function initVideoPlayer() {
	            var videoId = this.getVimeoId(this.state.video.src);
	
	            var player = new _player2.default('video_' + this.state.screenObject.asset_id, {
	                id: parseFloat(videoId),
	                width: '100%',
	                height: 'auto'
	            });
	
	            player.on('play', function () {});
	
	            player.on('pause', function () {});
	
	            player.on('ended', function () {});
	            this.setState({
	                initialised: true,
	                player: player
	            });
	        }
	    }, {
	        key: 'onVideoMessage',
	        value: function onVideoMessage(e) {
	            if (!MATCH_MESSAGE_ORIGIN.test(e.origin)) return;
	            var data = e.data;
	            if (data.event === 'play') this.onPlayFunc();
	            if (data.event === 'pause') this.onPauseFunc();
	            if (data.event === 'ended') this.onEndedFunc();
	        }
	    }, {
	        key: 'handleProgression',
	        value: function handleProgression() {
	            var progressionRule = appHelper.isDefined(this.state.screenObject.progression) ? this.state.screenObject.progression : objectConstants.OBJECT_PROGRESSION_CONTINUE;
	            var progressionType = appHelper.isDefined(this.state.screenObject.progression_type) ? this.state.screenObject.progression_type : undefined;
	            var progressionGoToId = appHelper.isDefined(this.state.screenObject.progression_goto_id) ? this.state.screenObject.progression_goto_id : undefined;
	            var completionData = {
	                progression: progressionRule,
	                progressionType: progressionType,
	                progressionGoToId: progressionGoToId,
	                asset_id: this.state.screenObject.asset_id,
	                status: objectConstants.STATUS_COMPLETE,
	                showProgressionButton: false,
	                asset_type_code: this.state.screenObject.asset_type_code,
	                navigateToNextScreen: false
	            };
	
	            this.props.callbacks.onObjectComplete(completionData);
	        }
	    }, {
	        key: 'onEndedFunc',
	        value: function onEndedFunc(event) {
	            //if (this.state.status !== objectConstants.STATUS_COMPLETE) {
	            this.handleProgression();
	            //}
	            //this.setState({isPlaying: false});
	            this.setState({ status: objectConstants.STATUS_COMPLETE });
	        }
	    }, {
	        key: 'onPauseFunc',
	        value: function onPauseFunc(event) {
	            //this.setState({isPlaying: false});
	        }
	    }, {
	        key: 'onPlayFunc',
	        value: function onPlayFunc(event) {
	            this.props.callbacks.scrollToVideo();
	            this.setState({ isPlaying: true });
	            if (this.state.status !== objectConstants.STATUS_COMPLETE) {
	                this.setState({ status: objectConstants.STATUS_IN_PROGRESS });
	            }
	        }
	    }, {
	        key: 'setClass',
	        value: function setClass() {
	            if (this.state.isPlaying) {
	                return "playing";
	            } else {
	                return "";
	            }
	        }
	    }, {
	        key: 'setStatusClass',
	        value: function setStatusClass() {
	            if (this.state.status === objectConstants.STATUS_COMPLETE) {
	                return "viewed";
	            } else {
	                return "not-viewed";
	            }
	        }
	    }, {
	        key: 'show',
	        value: function show() {
	            var videoRef = this.refs['video_container_' + this.state.screenObject.asset_id];
	            if (appHelper.isDefined(videoRef)) {
	                _gsap.TweenLite.set(videoRef, { opacity: 1 });
	                _gsap.TweenLite.from(videoRef, objectConstants.SHOW_PANEL_DURATION, {
	                    opacity: 0,
	                    ease: _gsap.Expo.easeInOut
	                });
	            }
	        }
	    }, {
	        key: 'getVimeoId',
	        value: function getVimeoId(src) {
	
	            return src.split('.com/').pop().toLowerCase();
	        }
	    }, {
	        key: 'getImagePath',
	        value: function getImagePath(image) {
	            if (appConstants.DEVELOPMENT_MODE) {
	                if (appHelper.isDefined(image) && image.length > 0) {
	                    return __webpack_require__(16)("./" + image);
	                }
	            } else {
	                return image;
	            }
	        }
	    }, {
	        key: 'customPlay',
	        value: function customPlay() {
	            this.state.player.play();
	            this.props.callbacks.scrollToVideo();
	        }
	    }, {
	        key: 'getControlClass',
	        value: function getControlClass() {
	            return this.state.status === objectConstants.STATUS_COMPLETE ? 'replay' : 'play';
	        }
	    }, {
	        key: 'setKeyboardAccessibility',
	        value: function setKeyboardAccessibility(event) {
	            if (appHelper.isDefined(event)) {
	                if (event.which === keyboardConstants.ENTER_KEY || event.which === keyboardConstants.SPACEBAR_KEY) {
	                    event.preventDefault();
	                    this.customPlay();
	                }
	            }
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	
	            return _react2.default.createElement(
	                'div',
	                { className: 'object-container', ref: 'video_container_' + this.state.screenObject.asset_id },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'video-object' },
	                    !this.state.isPlaying ? _react2.default.createElement(
	                        'div',
	                        { className: 'video-thumbnail-wrapper ' + this.getControlClass(), onClick: this.customPlay, onKeyDown: this.setKeyboardAccessibility, role: 'link', tabIndex: '0', id: 'video_player=' + this.state.screenObject.asset_id },
	                        _react2.default.createElement('img', { src: this.getImagePath(this.state.video.thumbnail), alt: '' }),
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'video-details' },
	                            this.state.screenObject.show_title && appHelper.isDefined(this.state.locale.label) && this.state.locale.label !== null && this.state.locale.label.length > 0 ? _react2.default.createElement('h4', { dangerouslySetInnerHTML: { __html: this.state.locale.label } }) : null,
	                            appHelper.isDefined(this.state.locale.description) && this.state.locale.description.length > 0 ? _react2.default.createElement('div', { dangerouslySetInnerHTML: { __html: this.state.locale.description } }) : null
	                        )
	                    ) : null,
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'video-wrapper' },
	                        _react2.default.createElement('div', {
	                            'data-vimeo-url': 'https://player.vimeo.com/video/' + this.getVimeoId(this.state.video.src),
	                            'data-vimeo-autoplay': this.state.autoplay,
	                            id: 'video_' + this.state.screenObject.asset_id })
	                    )
	                )
	            );
	        }
	    }]);
	
	    return VimeoVideoInline;
	}(_react2.default.Component);
	
	VimeoVideoInline.propTypes = {
	    screenObject: _propTypes2.default.object.isRequired,
	    video: _propTypes2.default.object.isRequired,
	    callbacks: _propTypes2.default.object.isRequired,
	    contentData: _propTypes2.default.object.isRequired,
	    trackingData: _propTypes2.default.object.isRequired,
	    userData: _propTypes2.default.object.isRequired,
	    autoPlay: _propTypes2.default.bool.isRequired,
	    lang: _propTypes2.default.string.isRequired,
	    actions: _propTypes2.default.object.isRequired
	};
	
	VimeoVideoInline.contextTypes = {
	    router: _propTypes2.default.object
	};
	
	function mapStateToProps(state, ownProps) {
	    var lang = state.userData.lang;
	    return {
	        lang: lang,
	        contentData: state.contentData,
	        trackingData: state.trackingData,
	        userData: state.userData
	    };
	}
	
	function mapDispatchToProps(dispatch) {
	    return {
	        actions: (0, _redux.bindActionCreators)(Object.assign({}, appDataActions, trackingDataActions), dispatch)
	    };
	}
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(VimeoVideoInline);

/***/ },
/* 533 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(5);
	
	var _redux = __webpack_require__(4);
	
	var _appDataActions = __webpack_require__(12);
	
	var appDataActions = _interopRequireWildcard(_appDataActions);
	
	var _trackingDataActions = __webpack_require__(7);
	
	var trackingDataActions = _interopRequireWildcard(_trackingDataActions);
	
	var _appHelper = __webpack_require__(3);
	
	var appHelper = _interopRequireWildcard(_appHelper);
	
	var _userDataHelper = __webpack_require__(15);
	
	var userDataHelper = _interopRequireWildcard(_userDataHelper);
	
	var _objectConstants = __webpack_require__(9);
	
	var objectConstants = _interopRequireWildcard(_objectConstants);
	
	var _keyboardConstants = __webpack_require__(14);
	
	var keyboardConstants = _interopRequireWildcard(_keyboardConstants);
	
	var _gsap = __webpack_require__(8);
	
	var _gsapReactPlugin = __webpack_require__(10);
	
	var _gsapReactPlugin2 = _interopRequireDefault(_gsapReactPlugin);
	
	var _appConstants = __webpack_require__(13);
	
	var appConstants = _interopRequireWildcard(_appConstants);
	
	var _player = __webpack_require__(272);
	
	var _player2 = _interopRequireDefault(_player);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var MATCH_MESSAGE_ORIGIN = /^https?:\/\/player.vimeo.com/;
	
	var VimeoVideo = function (_React$Component) {
	    _inherits(VimeoVideo, _React$Component);
	
	    function VimeoVideo(props, context) {
	        _classCallCheck(this, VimeoVideo);
	
	        var _this = _possibleConstructorReturn(this, (VimeoVideo.__proto__ || Object.getPrototypeOf(VimeoVideo)).call(this, props, context));
	
	        _this.state = {
	            lang: _this.props.lang,
	            userData: _this.props.userData,
	            screenObject: _this.props.screenObject,
	            video: _this.props.video,
	            locale: appHelper.getLocalData(_this.props.screenObject),
	            responseData: {
	                latestResponse: {}
	            },
	            player: {},
	            isPlaying: true,
	            initialised: false,
	            status: objectConstants.STATUS_NOT_STARTED,
	            isResourceObject: appHelper.isDefined(_this.props.callbacks.checkIsResourceScreen) && _this.props.callbacks.checkIsResourceScreen(),
	            trackable: true,
	            autoplay: true,
	            video_instruction: appHelper.getLocaleString("video_instruction")
	
	        };
	
	        _this.initVideoPlayer = _this.initVideoPlayer.bind(_this);
	        _this.show = _this.show.bind(_this);
	        _this.handleProgression = _this.handleProgression.bind(_this);
	        _this.onEndedFunc = _this.onEndedFunc.bind(_this);
	        _this.onPauseFunc = _this.onPauseFunc.bind(_this);
	        _this.onPlayFunc = _this.onPlayFunc.bind(_this);
	        _this.onVideoMessage = _this.onVideoMessage.bind(_this);
	        _this.setClass = _this.setClass.bind(_this);
	        _this.getObjectStatusClass = _this.getObjectStatusClass.bind(_this);
	        _this.getVimeoId = _this.getVimeoId.bind(_this);
	        _this.getImagePath = _this.getImagePath.bind(_this);
	        _this.customPlay = _this.customPlay.bind(_this);
	        _this.getControlClass = _this.getControlClass.bind(_this);
	        _this.setStatusClass = _this.setStatusClass.bind(_this);
	        _this.setKeyboardAccessibility = _this.setKeyboardAccessibility.bind(_this);
	        return _this;
	    }
	
	    _createClass(VimeoVideo, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	
	            //this.getObjectStatus();
	            this.show();
	            this.initVideoPlayer();
	            window.addEventListener('message', this.onVideoMessage, false);
	        }
	    }, {
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(nextProps) {
	            if (this.state.userData !== nextProps.userData) {
	                this.setState({ userData: Object.assign({}, nextProps.userData) });
	            }
	            if (this.state.lang !== nextProps.lang) {
	                this.setState({
	                    lang: nextProps.lang,
	                    locale: appHelper.getLocalData(this.state.screenObject),
	                    video_instruction: appHelper.getLocaleString("video_instruction")
	                });
	            }
	        }
	    }, {
	        key: 'componentDidUpdate',
	        value: function componentDidUpdate() {
	            if (appHelper.isDefined(this.state.locale.description) && !this.state.initialised) {
	                this.initVideoPlayer();
	            }
	        }
	    }, {
	        key: 'componentWillUnmount',
	        value: function componentWillUnmount() {
	            window.removeEventListener('message', this.onVideoMessage, false);
	        }
	    }, {
	        key: 'getLocale',
	        value: function getLocale() {
	            var locale = appHelper.getLocalData(this.state.screenObject);
	            this.setState({ locale: Object.assign({}, locale) });
	            if (this.state.screenObject.show_title_in_header) {
	                this.props.actions.setScreenTitle(locale.title);
	            }
	        }
	    }, {
	        key: 'getObjectStatusClass',
	        value: function getObjectStatusClass() {
	            var objectUserData = {};
	            var subScreenParent = {};
	            var screen_id = undefined;
	            if (appHelper.isDefined(this.props.callbacks.getSubScreenParent)) {
	                subScreenParent = this.props.callbacks.getSubScreenParent();
	            }
	            if (appHelper.isDefined(this.props.callbacks.getScreenId)) {
	                screen_id = this.props.callbacks.getScreenId();
	            }
	
	            if (appHelper.isDefined(screen_id)) {
	                if (appHelper.isDefined(subScreenParent)) {
	                    objectUserData = userDataHelper.getSubScreenObjectStatus(this.state.userData, subScreenParent.screen_id, screen_id, this.state.screenObject.asset_id);
	                } else if (this.state.isResourceObject) {
	                    objectUserData = userDataHelper.getResourceScreenObjectUserData(this.state.userData, screen_id, this.state.screenObject.asset_id);
	                } else {
	                    objectUserData = userDataHelper.getObjectStatus(this.state.userData, screen_id, this.state.screenObject.asset_id);
	                }
	            } else {
	                objectUserData = userDataHelper.getAttachmentObjectUserData(this.state.userData, this.state.screenObject.asset_id);
	            }
	
	            if (appHelper.isDefined(objectUserData.status)) {
	
	                if (objectUserData.status === objectConstants.STATUS_COMPLETE) {
	                    return 'complete';
	                } else if (objectUserData.status === objectConstants.STATUS_IN_PROGRESS) {
	                    return 'in-progress';
	                } else if (objectUserData.status === objectConstants.STATUS_NOT_REQUIRED) {
	                    return 'not-required';
	                } else {
	                    if (this.state.status === objectConstants.STATUS_COMPLETE) {
	                        return 'complete';
	                    } else if (this.state.status === objectConstants.STATUS_IN_PROGRESS) {
	                        return 'in-progress';
	                    } else {
	                        return 'not-started';
	                    }
	                }
	            }
	            return 'not-started';
	        }
	    }, {
	        key: 'initVideoPlayer',
	        value: function initVideoPlayer() {
	            var player = new _player2.default('video_' + this.state.screenObject.asset_id, {
	                id: this.state.locale.vimeo_id,
	                width: '100%',
	                height: 'auto'
	            });
	
	            player.on('play', function () {});
	
	            player.on('pause', function () {});
	
	            player.on('ended', function () {});
	            this.setState({
	                initialised: true,
	                player: player
	            });
	        }
	    }, {
	        key: 'onVideoMessage',
	        value: function onVideoMessage(e) {
	            if (!MATCH_MESSAGE_ORIGIN.test(e.origin)) return;
	            var data = e.data;
	            if (data.event === 'play') this.onPlayFunc();
	            if (data.event === 'pause') this.onPauseFunc();
	            if (data.event === 'ended') this.onEndedFunc();
	        }
	    }, {
	        key: 'handleProgression',
	        value: function handleProgression() {
	            this.props.callbacks.onObjectComplete(objectConstants.OBJECT_PROGRESSION_CONTINUE, this.state.screenObject.asset_id, this.state.responseData.latestResponse);
	        }
	    }, {
	        key: 'onEndedFunc',
	        value: function onEndedFunc(event) {
	            //if (this.state.status !== objectConstants.STATUS_COMPLETE) {
	            this.props.onAssetViewed();
	            //}
	            this.setState({ isPlaying: false });
	            this.setState({ status: objectConstants.STATUS_COMPLETE });
	        }
	    }, {
	        key: 'onPauseFunc',
	        value: function onPauseFunc(event) {
	            this.setState({ isPlaying: false });
	        }
	    }, {
	        key: 'onPlayFunc',
	        value: function onPlayFunc(event) {
	
	            if (this.state.status !== objectConstants.STATUS_COMPLETE) {
	                this.setState({ status: objectConstants.STATUS_IN_PROGRESS });
	            }
	        }
	    }, {
	        key: 'setClass',
	        value: function setClass() {
	            if (this.state.isPlaying) {
	                return "playing";
	            } else {
	                return "";
	            }
	        }
	    }, {
	        key: 'setStatusClass',
	        value: function setStatusClass() {
	            if (this.state.status === objectConstants.STATUS_COMPLETE) {
	                return "viewed";
	            } else {
	                return "not-viewed";
	            }
	        }
	    }, {
	        key: 'show',
	        value: function show() {
	            var videoRef = this.refs['video_container_' + this.state.screenObject.asset_id];
	            if (appHelper.isDefined(videoRef)) {
	                _gsap.TweenLite.set(videoRef, { opacity: 1 });
	                _gsap.TweenLite.from(videoRef, objectConstants.SHOW_PANEL_DURATION, {
	                    opacity: 0,
	                    ease: _gsap.Expo.easeInOut
	                });
	            }
	        }
	    }, {
	        key: 'getVimeoId',
	        value: function getVimeoId(src) {
	
	            return src.split('.com/').pop().toLowerCase();
	        }
	    }, {
	        key: 'getImagePath',
	        value: function getImagePath(image) {
	            if (appConstants.DEVELOPMENT_MODE) {
	                if (appHelper.isDefined(image) && image.length > 0) {
	                    return __webpack_require__(16)("./" + image);
	                }
	            } else {
	                return image;
	            }
	        }
	    }, {
	        key: 'customPlay',
	        value: function customPlay() {
	            if (this.state.status !== objectConstants.STATUS_COMPLETE) {
	                this.setState({ status: objectConstants.STATUS_IN_PROGRESS });
	            }
	            this.state.player.play();
	        }
	    }, {
	        key: 'getControlClass',
	        value: function getControlClass() {
	            return this.state.status === objectConstants.STATUS_COMPLETE ? 'replay' : 'play';
	        }
	    }, {
	        key: 'setKeyboardAccessibility',
	        value: function setKeyboardAccessibility(event) {
	            if (appHelper.isDefined(event)) {
	                if (event.which === keyboardConstants.ENTER_KEY || event.which === keyboardConstants.SPACEBAR_KEY) {
	                    event.preventDefault();
	                    this.customPlay();
	                }
	            }
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            return _react2.default.createElement(
	                'div',
	                { className: 'object-container', ref: 'video_container_' + this.state.screenObject.asset_id },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'asset-dialog-image' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'asset-image-header' },
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'title-col truncate-text-container' },
	                            this.state.status !== objectConstants.STATUS_COMPLETE && this.state.screenObject.required_for_completion ? _react2.default.createElement('div', { className: 'title ' + this.getObjectStatusClass(),
	                                dangerouslySetInnerHTML: { __html: this.state.locale.label + '  - <em>' + this.state.video_instruction + '</em>' } }) : _react2.default.createElement('div', { className: 'title ' + this.getObjectStatusClass(),
	                                dangerouslySetInnerHTML: { __html: this.state.locale.label } })
	                        ),
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'nav-col' },
	                            _react2.default.createElement(
	                                'button',
	                                { className: 'btn guroo-btn', onClick: this.props.closeDialog },
	                                this.state.status === objectConstants.STATUS_COMPLETE || !this.state.screenObject.required_for_completion ? _react2.default.createElement(
	                                    'span',
	                                    null,
	                                    'Done'
	                                ) : _react2.default.createElement(
	                                    'span',
	                                    null,
	                                    'Cancel'
	                                )
	                            )
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'asset-img-container video' },
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'video-wrapper' },
	                            _react2.default.createElement('div', { 'data-vimeo-url': 'https://player.vimeo.com/video/' + this.getVimeoId(this.state.video.src),
	                                'data-vimeo-autoplay': this.state.autoplay,
	                                id: 'video_' + this.state.screenObject.asset_id })
	                        ),
	                        !this.state.isPlaying ? _react2.default.createElement(
	                            'div',
	                            { className: 'video-thumbnail-wrapper ' + this.getControlClass(), onClick: this.customPlay, onKeyDown: this.setKeyboardAccessibility, tabIndex: '0', role: 'link' },
	                            _react2.default.createElement('img', { src: this.getImagePath(this.state.video.thumbnail), alt: '' })
	                        ) : null,
	                        appHelper.isDefined(this.state.locale.description) && this.state.locale.description.length > 0 ? _react2.default.createElement(
	                            'div',
	                            { className: 'asset-desc' },
	                            _react2.default.createElement('div', { dangerouslySetInnerHTML: { __html: this.state.locale.description } })
	                        ) : null
	                    )
	                )
	            );
	        }
	    }]);
	
	    return VimeoVideo;
	}(_react2.default.Component);
	
	VimeoVideo.propTypes = {
	    screenObject: _propTypes2.default.object.isRequired,
	    video: _propTypes2.default.object.isRequired,
	    callbacks: _propTypes2.default.object.isRequired,
	    contentData: _propTypes2.default.object.isRequired,
	    trackingData: _propTypes2.default.object.isRequired,
	    actions: _propTypes2.default.object.isRequired,
	    onAssetViewed: _propTypes2.default.func.isRequired,
	    closeDialog: _propTypes2.default.func.isRequired,
	    lang: _propTypes2.default.string.isRequired,
	    userData: _propTypes2.default.object.isRequired
	};
	
	VimeoVideo.contextTypes = {
	    router: _propTypes2.default.object
	};
	
	function mapStateToProps(state, ownProps) {
	    var lang = state.userData.lang;
	    return {
	        lang: lang,
	        contentData: state.contentData,
	        trackingData: state.trackingData,
	        userData: state.userData
	    };
	}
	
	function mapDispatchToProps(dispatch) {
	    return {
	        actions: (0, _redux.bindActionCreators)(Object.assign({}, appDataActions, trackingDataActions), dispatch)
	    };
	}
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(VimeoVideo);

/***/ },
/* 534 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(5);
	
	var _redux = __webpack_require__(4);
	
	var _trackingDataActions = __webpack_require__(7);
	
	var trackingDataActions = _interopRequireWildcard(_trackingDataActions);
	
	var _appHelper = __webpack_require__(3);
	
	var appHelper = _interopRequireWildcard(_appHelper);
	
	var _objectConstants = __webpack_require__(9);
	
	var objectConstants = _interopRequireWildcard(_objectConstants);
	
	var _appConstants = __webpack_require__(13);
	
	var appConstants = _interopRequireWildcard(_appConstants);
	
	var _keyboardConstants = __webpack_require__(14);
	
	var keyboardConstants = _interopRequireWildcard(_keyboardConstants);
	
	var _gsap = __webpack_require__(8);
	
	var _gsapReactPlugin = __webpack_require__(10);
	
	var _gsapReactPlugin2 = _interopRequireDefault(_gsapReactPlugin);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var AccordionBtn = function (_React$Component) {
	    _inherits(AccordionBtn, _React$Component);
	
	    function AccordionBtn(props, context) {
	        _classCallCheck(this, AccordionBtn);
	
	        var _this = _possibleConstructorReturn(this, (AccordionBtn.__proto__ || Object.getPrototypeOf(AccordionBtn)).call(this, props, context));
	
	        _this.state = {
	            lang: _this.props.lang,
	            parentScreen: _this.props.parentScreen,
	            screen: _this.props.screen,
	            className: "",
	            locale: appHelper.getLocalData(_this.props.screen),
	            update: false,
	            icon: {}
	        };
	        _this.setClass = _this.setClass.bind(_this);
	        _this.onClicked = _this.onClicked.bind(_this);
	        _this.screenIsEnabled = _this.screenIsEnabled.bind(_this);
	        _this.screenIsComplete = _this.screenIsComplete.bind(_this);
	        _this.setKeyboardAccessibility = _this.setKeyboardAccessibility.bind(_this);
	        _this.getAssets = _this.getAssets.bind(_this);
	        _this.getImagePath = _this.getImagePath.bind(_this);
	        return _this;
	    }
	
	    _createClass(AccordionBtn, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            this.setClass();
	            if (this.state.parentScreen.include_icon) {
	                this.getAssets();
	            }
	        }
	    }, {
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(nextProps) {
	            if (this.state.lang !== nextProps.lang) {
	                this.setState({
	                    lang: nextProps.lang,
	                    locale: appHelper.getLocalData(this.state.screen)
	                });
	            }
	        }
	    }, {
	        key: 'screenIsEnabled',
	        value: function screenIsEnabled() {
	            return appHelper.getArrayObjectIndexByKey(this.props.enabledScreens, "screen_id", this.props.screen.screen_id);
	        }
	    }, {
	        key: 'screenIsComplete',
	        value: function screenIsComplete() {
	            return appHelper.getArrayObjectIndexByKey(this.props.completeScreens, "screen_id", this.props.screen.screen_id);
	        }
	    }, {
	        key: 'setClass',
	        value: function setClass() {
	            var className = "";
	
	            if (this.screenIsEnabled() === -1) {
	                className += "disabled ";
	            }
	
	            if (this.screenIsComplete() > -1) {
	                className += "complete ";
	            } else {
	                className += "incomplete ";
	            }
	
	            return className;
	        }
	    }, {
	        key: 'onClicked',
	        value: function onClicked() {
	            if (this.screenIsEnabled() > -1 && !this.props.isAnimating) {
	                this.props.biteCallbacks.toggleAccordion(this.props.screen);
	            }
	        }
	    }, {
	        key: 'setKeyboardAccessibility',
	        value: function setKeyboardAccessibility(event) {
	
	            if (event.which === keyboardConstants.ENTER_KEY || event.which === keyboardConstants.SPACEBAR_KEY) {
	                event.preventDefault();
	                event.stopPropagation();
	                this.onClicked();
	            }
	        }
	    }, {
	        key: 'getAssets',
	        value: function getAssets() {
	            var icon = {};
	
	            if (appHelper.isDefined(this.state.screen.assets.icon)) {
	                icon = appHelper.getIconAsset(this.state.screen.assets.icon);
	            }
	
	            this.setState({
	                icon: Object.assign({}, icon)
	            });
	        }
	    }, {
	        key: 'getImagePath',
	        value: function getImagePath(image) {
	            if (appConstants.DEVELOPMENT_MODE) {
	                if (appHelper.isDefined(image) && image.length > 0) {
	                    return __webpack_require__(16)("./" + image);
	                }
	            } else {
	                return image;
	            }
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            return _react2.default.createElement(
	                'div',
	                { className: 'accordion-btn ' + this.setClass(), onClick: this.onClicked, onKeyDown: this.setKeyboardAccessibility, tabIndex: 0, role: 'link', id: 'accordion_btn_' + this.state.screen.screen_id },
	                this.state.parentScreen.include_icon && appHelper.isDefined(this.state.icon.src) ? _react2.default.createElement(
	                    'div',
	                    { className: 'accordion-icon' },
	                    _react2.default.createElement('img', { src: this.getImagePath(this.state.icon.src), alt: '' })
	                ) : null,
	                _react2.default.createElement('div', { className: 'accordion-label', dangerouslySetInnerHTML: { __html: this.state.locale.title } })
	            );
	        }
	    }]);
	
	    return AccordionBtn;
	}(_react2.default.Component);
	
	AccordionBtn.propTypes = {
	    parentScreen: _propTypes2.default.object.isRequired,
	    screen: _propTypes2.default.object.isRequired,
	    activeScreenId: _propTypes2.default.number.isRequired,
	    enabledScreens: _propTypes2.default.array.isRequired,
	    completeScreens: _propTypes2.default.array.isRequired,
	    biteCallbacks: _propTypes2.default.object.isRequired,
	    isAnimating: _propTypes2.default.bool.isRequired,
	    contentData: _propTypes2.default.object,
	    trackingData: _propTypes2.default.object,
	    lang: _propTypes2.default.string.isRequired,
	    actions: _propTypes2.default.object
	};
	
	AccordionBtn.contextTypes = {
	    router: _propTypes2.default.object
	};
	
	function mapStateToProps(state, ownProps) {
	    var lang = state.userData.lang;
	    return {
	        lang: lang,
	        contentData: state.contentData,
	        trackingData: state.trackingData
	    };
	}
	
	function mapDispatchToProps(dispatch) {
	    return {
	        actions: (0, _redux.bindActionCreators)(Object.assign({}, trackingDataActions), dispatch)
	    };
	}
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(AccordionBtn);

/***/ },
/* 535 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(5);
	
	var _redux = __webpack_require__(4);
	
	var _trackingDataActions = __webpack_require__(7);
	
	var trackingDataActions = _interopRequireWildcard(_trackingDataActions);
	
	var _appHelper = __webpack_require__(3);
	
	var appHelper = _interopRequireWildcard(_appHelper);
	
	var _objectConstants = __webpack_require__(9);
	
	var objectConstants = _interopRequireWildcard(_objectConstants);
	
	var _componentHelper = __webpack_require__(31);
	
	var _gsap = __webpack_require__(8);
	
	var _gsapReactPlugin = __webpack_require__(10);
	
	var _gsapReactPlugin2 = _interopRequireDefault(_gsapReactPlugin);
	
	var _environmentHelper = __webpack_require__(56);
	
	var enviromentHelper = _interopRequireWildcard(_environmentHelper);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var AccordionContent = function (_React$Component) {
	    _inherits(AccordionContent, _React$Component);
	
	    function AccordionContent(props, context) {
	        _classCallCheck(this, AccordionContent);
	
	        var _this = _possibleConstructorReturn(this, (AccordionContent.__proto__ || Object.getPrototypeOf(AccordionContent)).call(this, props, context));
	
	        _this.state = {
	            className: "",
	            locale: {},
	            renderedScreen: {},
	            animating: false,
	            hasBeenViewed: false,
	            render: false
	        };
	        _this.setRenderedScreen = _this.setRenderedScreen.bind(_this);
	        _this.setClass = _this.setClass.bind(_this);
	        _this.objectIsEnabled = _this.objectIsEnabled.bind(_this);
	        _this.objectIsComplete = _this.objectIsComplete.bind(_this);
	        _this.openCloseItem = _this.openCloseItem.bind(_this);
	        _this.onAnimationComplete = _this.onAnimationComplete.bind(_this);
	        _this.onAnimationOpenComplete = _this.onAnimationOpenComplete.bind(_this);
	        _this.setItemViewed = _this.setItemViewed.bind(_this);
	        _this.allowRender = _this.allowRender.bind(_this);
	        return _this;
	    }
	
	    _createClass(AccordionContent, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            this.setRenderedScreen();
	            window.addEventListener("resize", this.openCloseItem);
	        }
	    }, {
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(nextProps) {}
	    }, {
	        key: 'componentDidUpdate',
	        value: function componentDidUpdate() {
	            if (this.props.toggleAllItems) {
	                this.openCloseItem();
	            }
	            var item = this.refs['accordion_content_' + this.props.screen.screen_id];
	            if (item.classList.contains('active') && !this.state.hasBeenViewed) {
	                this.setItemViewed();
	            }
	            if (this.props.screen.screen_id === this.props.activeScreenId || this.props.activeScreenId === "0") {
	                this.props.biteCallbacks.setIsAnimating(this.state.animating);
	            }
	        }
	    }, {
	        key: 'componentWillUnmount',
	        value: function componentWillUnmount() {
	            window.removeEventListener("resize", this.openCloseItem);
	        }
	    }, {
	        key: 'openCloseItem',
	        value: function openCloseItem() {
	            var env = enviromentHelper.getEnvironment();
	            var item = this.refs['accordion_content_' + this.props.screen.screen_id];
	            var btn = document.getElementById('accordion_btn_' + this.props.screen.screen_id);
	            if (appHelper.isDefined(item)) {
	                //console.log(`${this.props.screen.screen_id} !== ${this.props.activeScreenId} && ${!this.state.animating}`);
	                if (this.props.screen.screen_id !== this.props.activeScreenId && !this.state.animating) {
	                    this.setState({ animating: true });
	                    _gsap.TweenLite.to(item, 0.5, {
	                        height: 0,
	                        ease: _gsap.Linear.easeIn
	                    }).eventCallback("onComplete", this.onAnimationComplete);
	                } else if (this.props.screen.screen_id === this.props.activeScreenId && !this.state.animating) {
	                    var value = btn.offsetHeight * 3 + 80;
	                    if (env.window.size === "xs") {
	                        value = btn.offsetHeight * 2 + 108;
	                    }
	                    /*if(this.props.parentScreen.include_icon){
	                        value = 180;
	                    }*/
	                    var height = document.getElementById('main-wrapper').clientHeight - value;
	                    this.setState({ animating: true });
	
	                    _gsap.TweenLite.to(item, 0.5, {
	                        height: height,
	                        ease: _gsap.Linear.easeIn
	                    }).eventCallback("onComplete", this.onAnimationOpenComplete);
	                }
	            }
	            /*if (this.props.screen.screen_id !== this.props.activeScreenId && !this.state.animating) {
	                this.setState({animating: true});
	                TweenLite.to(item, 0.5, {
	                    height: 0,
	                    ease: Linear.easeIn
	                }).eventCallback("onComplete", this.onAnimationComplete);
	            } else if (this.props.screen.screen_id === this.props.activeScreenId && !this.state.animating) {
	                this.setState({animating: true});
	                TweenLite.set(item, {height: "auto"});
	                TweenLite.from(item, 0.5, {
	                    height: 0,
	                    ease: Linear.easeIn
	                }).eventCallback("onComplete", this.onAnimationComplete);
	            }*/
	        }
	    }, {
	        key: 'onAnimationOpenComplete',
	        value: function onAnimationOpenComplete() {
	            this.props.biteCallbacks.onItemsClosed();
	            this.props.setScrollPosition();
	            this.setState({ animating: false });
	        }
	    }, {
	        key: 'onAnimationComplete',
	        value: function onAnimationComplete() {
	            this.props.biteCallbacks.onItemsClosed();
	            this.props.setScrollPosition();
	            this.setState({ animating: false });
	        }
	    }, {
	        key: 'allowRender',
	        value: function allowRender() {
	            this.setState({ render: true });
	        }
	    }, {
	        key: 'setRenderedScreen',
	        value: function setRenderedScreen() {
	            var screenType = Object.assign({}, (0, _componentHelper.getScreenComponentByType)(this.props.screen.screen_type), {
	                data: this.props.screen
	            });
	
	            this.setState({ renderedScreen: Object.assign({}, screenType) });
	        }
	    }, {
	        key: 'objectIsEnabled',
	        value: function objectIsEnabled() {
	            return appHelper.getArrayObjectIndexByKey(this.props.enabledScreens, "screen_id", this.props.screen.screen_id);
	        }
	    }, {
	        key: 'objectIsComplete',
	        value: function objectIsComplete() {
	            return appHelper.getArrayObjectIndexByKey(this.props.completeScreens, "screen_id", this.props.screen.screen_id);
	        }
	    }, {
	        key: 'setClass',
	        value: function setClass() {
	            var className = "";
	            if (this.props.screen.screen_id === this.props.activeScreenId) {
	                className += "active ";
	            }
	
	            if (this.objectIsEnabled() === -1) {
	                className += "disabled ";
	            }
	
	            if (this.objectIsComplete() > -1) {
	                className += "complete ";
	            } else {
	                className += "incomplete ";
	            }
	
	            return className;
	        }
	    }, {
	        key: 'setItemViewed',
	        value: function setItemViewed() {
	            this.setState({ hasBeenViewed: true });
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var renderedScreen = this.state.renderedScreen;
	            return _react2.default.createElement(
	                'div',
	                { className: 'accordion-content ' + this.setClass(), ref: 'accordion_content_' + this.props.screen.screen_id },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'content-padding' },
	                    typeof renderedScreen.data !== "undefined" && this.state.hasBeenViewed ? _react2.default.createElement(renderedScreen.component, { screen: renderedScreen.data,
	                        parentScreen: this.props.parentScreen,
	                        biteCallbacks: this.props.biteCallbacks }) : null
	                )
	            );
	        }
	    }]);
	
	    return AccordionContent;
	}(_react2.default.Component);
	
	AccordionContent.propTypes = {
	    parentScreen: _propTypes2.default.object.isRequired,
	    screen: _propTypes2.default.object.isRequired,
	    activeScreenId: _propTypes2.default.number.isRequired,
	    enabledScreens: _propTypes2.default.array.isRequired,
	    completeScreens: _propTypes2.default.array.isRequired,
	    biteCallbacks: _propTypes2.default.object.isRequired,
	    toggleAllItems: _propTypes2.default.bool.isRequired,
	    setScrollPosition: _propTypes2.default.func.isRequired,
	    contentData: _propTypes2.default.object,
	    trackingData: _propTypes2.default.object,
	    actions: _propTypes2.default.object
	};
	
	AccordionContent.contextTypes = {
	    router: _propTypes2.default.object
	};
	
	function mapStateToProps(state, ownProps) {
	    return {
	        contentData: state.contentData,
	        trackingData: state.trackingData
	    };
	}
	
	function mapDispatchToProps(dispatch) {
	    return {
	        actions: (0, _redux.bindActionCreators)(Object.assign({}, trackingDataActions), dispatch)
	    };
	}
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(AccordionContent);

/***/ },
/* 536 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(5);
	
	var _redux = __webpack_require__(4);
	
	var _AccordionBtn = __webpack_require__(534);
	
	var _AccordionBtn2 = _interopRequireDefault(_AccordionBtn);
	
	var _AccordionContent = __webpack_require__(535);
	
	var _AccordionContent2 = _interopRequireDefault(_AccordionContent);
	
	var _trackingDataActions = __webpack_require__(7);
	
	var trackingDataActions = _interopRequireWildcard(_trackingDataActions);
	
	var _appHelper = __webpack_require__(3);
	
	var appHelper = _interopRequireWildcard(_appHelper);
	
	var _objectConstants = __webpack_require__(9);
	
	var objectConstants = _interopRequireWildcard(_objectConstants);
	
	var _environmentHelper = __webpack_require__(56);
	
	var enviromentHelper = _interopRequireWildcard(_environmentHelper);
	
	var _gsap = __webpack_require__(8);
	
	var _gsapReactPlugin = __webpack_require__(10);
	
	var _gsapReactPlugin2 = _interopRequireDefault(_gsapReactPlugin);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var AccordionItem = function (_React$Component) {
	    _inherits(AccordionItem, _React$Component);
	
	    function AccordionItem(props, context) {
	        _classCallCheck(this, AccordionItem);
	
	        var _this = _possibleConstructorReturn(this, (AccordionItem.__proto__ || Object.getPrototypeOf(AccordionItem)).call(this, props, context));
	
	        _this.state = {
	            topPos: 35,
	            mobileTopPos: 15
	        };
	        _this.setClass = _this.setClass.bind(_this);
	        _this.setScrollPosition = _this.setScrollPosition.bind(_this);
	        return _this;
	    }
	
	    _createClass(AccordionItem, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            this.setClass();
	        }
	    }, {
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(nextProps) {}
	    }, {
	        key: 'setClass',
	        value: function setClass() {
	            var className = "";
	
	            if (this.props.screen.screen_id === this.props.activeScreenId) {
	                className += "open ";
	            } else {
	                className += "closed ";
	            }
	
	            return className;
	        }
	    }, {
	        key: 'setScrollPosition',
	        value: function setScrollPosition() {
	            var env = enviromentHelper.getEnvironment();
	            var item = this.refs['accordion_item_' + this.props.screen.screen_id];
	            if (this.props.screen.screen_id === this.props.activeScreenId) {
	
	                if (env.window.size === "xs") {
	                    this.props.biteCallbacks.scrollTo(item.offsetTop - this.state.mobileTopPos);
	                } else {
	                    this.props.biteCallbacks.scrollTo(item.offsetTop - this.state.topPos);
	                }
	            } else if (this.props.activeScreenId === "0") {
	                if (env.window.size === "xs") {
	                    this.props.biteCallbacks.scrollTo(this.state.mobileTopPos);
	                } else {
	                    this.props.biteCallbacks.scrollTo(this.state.topPos);
	                }
	            }
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            return _react2.default.createElement(
	                'div',
	                { className: 'accordion-item ' + this.setClass(), ref: 'accordion_item_' + this.props.screen.screen_id },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'accordion-item-list' },
	                    _react2.default.createElement(_AccordionBtn2.default, { parentScreen: this.props.parentScreen, screen: this.props.screen, activeScreenId: this.props.activeScreenId, enabledScreens: this.props.enabledScreens, completeScreens: this.props.completeScreens, biteCallbacks: this.props.biteCallbacks, isAnimating: this.props.isAnimating }),
	                    _react2.default.createElement(_AccordionContent2.default, { parentScreen: this.props.parentScreen, screen: this.props.screen, activeScreenId: this.props.activeScreenId, enabledScreens: this.props.enabledScreens, completeScreens: this.props.completeScreens, biteCallbacks: this.props.biteCallbacks, toggleAllItems: this.props.toggleAllItems, setScrollPosition: this.setScrollPosition })
	                )
	            );
	        }
	    }]);
	
	    return AccordionItem;
	}(_react2.default.Component);
	
	AccordionItem.propTypes = {
	    parentScreen: _propTypes2.default.object.isRequired,
	    screen: _propTypes2.default.object.isRequired,
	    activeScreenId: _propTypes2.default.number.isRequired,
	    enabledScreens: _propTypes2.default.array.isRequired,
	    completeScreens: _propTypes2.default.array.isRequired,
	    biteCallbacks: _propTypes2.default.object.isRequired,
	    toggleAllItems: _propTypes2.default.bool.isRequired,
	    isAnimating: _propTypes2.default.bool.isRequired,
	    contentData: _propTypes2.default.object,
	    trackingData: _propTypes2.default.object,
	    actions: _propTypes2.default.object
	};
	
	AccordionItem.contextTypes = {
	    router: _propTypes2.default.object
	};
	
	function mapStateToProps(state, ownProps) {
	    return {
	        contentData: state.contentData,
	        trackingData: state.trackingData
	    };
	}
	
	function mapDispatchToProps(dispatch) {
	    return {
	        actions: (0, _redux.bindActionCreators)(Object.assign({}, trackingDataActions), dispatch)
	    };
	}
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(AccordionItem);

/***/ },
/* 537 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(5);
	
	var _redux = __webpack_require__(4);
	
	var _AccordionItem = __webpack_require__(536);
	
	var _AccordionItem2 = _interopRequireDefault(_AccordionItem);
	
	var _ProducerNotes = __webpack_require__(85);
	
	var _ProducerNotes2 = _interopRequireDefault(_ProducerNotes);
	
	var _NotReadyYet = __webpack_require__(84);
	
	var _NotReadyYet2 = _interopRequireDefault(_NotReadyYet);
	
	var _Button = __webpack_require__(18);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _trackingDataActions = __webpack_require__(7);
	
	var trackingDataActions = _interopRequireWildcard(_trackingDataActions);
	
	var _appDataActions = __webpack_require__(12);
	
	var appDataActions = _interopRequireWildcard(_appDataActions);
	
	var _userDataActions = __webpack_require__(20);
	
	var userDataActions = _interopRequireWildcard(_userDataActions);
	
	var _appHelper = __webpack_require__(3);
	
	var appHelper = _interopRequireWildcard(_appHelper);
	
	var _dataHelper = __webpack_require__(11);
	
	var dataHelper = _interopRequireWildcard(_dataHelper);
	
	var _appConstants = __webpack_require__(13);
	
	var appConstants = _interopRequireWildcard(_appConstants);
	
	var _objectConstants = __webpack_require__(9);
	
	var objectConstants = _interopRequireWildcard(_objectConstants);
	
	var _assetConstants = __webpack_require__(33);
	
	var assetConstants = _interopRequireWildcard(_assetConstants);
	
	var _localStorage = __webpack_require__(17);
	
	var localStorage = _interopRequireWildcard(_localStorage);
	
	var _userDataHelper = __webpack_require__(15);
	
	var userDataHelper = _interopRequireWildcard(_userDataHelper);
	
	var _componentHelper = __webpack_require__(31);
	
	var _gsap = __webpack_require__(8);
	
	var _gsapReactPlugin = __webpack_require__(10);
	
	var _gsapReactPlugin2 = _interopRequireDefault(_gsapReactPlugin);
	
	var _lodash = __webpack_require__(28);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } //eslint-disable-line import/no-named-as-default
	
	
	var AccordionScreen = function (_React$Component) {
	    _inherits(AccordionScreen, _React$Component);
	
	    function AccordionScreen(props, context) {
	        _classCallCheck(this, AccordionScreen);
	
	        var _this = _possibleConstructorReturn(this, (AccordionScreen.__proto__ || Object.getPrototypeOf(AccordionScreen)).call(this, props, context));
	
	        _this.state = {
	            lang: _this.props.lang,
	            screen: _this.props.screen,
	            userData: _this.props.userData,
	            locale: appHelper.getLocalData(_this.props.screen),
	            status: userDataHelper.getScreenUserData(_this.props.userData, _this.props.screen.screen_id).status, // objectConstants.STATUS_IN_PROGRESS,
	            callbacks: {},
	            assets: {
	                background: {
	                    src: ""
	
	                },
	                hotspotBackground: {
	                    src: ""
	                }
	            },
	            activeScreen: {
	                screen_id: 0
	            },
	            renderedScreen: {},
	            enabledScreens: [],
	            completeScreens: [],
	            toggleAllItems: false,
	            isAnimating: false,
	            producerNotes: appHelper.getScreenNotes(undefined, _this.props.screen),
	            screenIsReady: _this.props.screen.sub_screens.length > 0 && appHelper.canSeeContent(_this.props.screen),
	            allowClippedBlurEffect: appHelper.allowClippedBlurEffect(),
	            isOpenNavigation: appHelper.getBiteById(_this.props.biteCallbacks.getBiteId()).navigation_type === objectConstants.PROGRESSION_TYPE_OPEN,
	            continue_label: appHelper.getLocaleString("continue_label")
	        };
	        _this.getScreenId = _this.getScreenId.bind(_this);
	        _this.getBiteId = _this.getBiteId.bind(_this);
	        _this.getAssets = _this.getAssets.bind(_this);
	        _this.getImagePath = _this.getImagePath.bind(_this);
	        _this.checkScreenStatus = _this.checkScreenStatus.bind(_this);
	        _this.setCallbacks = _this.setCallbacks.bind(_this);
	        _this.setEnabledTabs = _this.setEnabledTabs.bind(_this);
	        _this.setTabActive = _this.setTabActive.bind(_this);
	        _this.setRenderedScreen = _this.setRenderedScreen.bind(_this);
	        _this.onSubScreenComplete = _this.onSubScreenComplete.bind(_this);
	        _this.goToNextSubScreen = _this.goToNextSubScreen.bind(_this);
	        _this.hasNextSubScreen = _this.hasNextSubScreen.bind(_this);
	        _this.checkScreenComplete = _this.checkScreenComplete.bind(_this);
	        _this.updateScreenResults = _lodash2.default.debounce(_this.updateScreenResults.bind(_this), 300);
	        _this.setScreenAccessed = _lodash2.default.debounce(_this.setScreenAccessed.bind(_this), 300);
	        _this.navigateToNextScreen = _this.navigateToNextScreen.bind(_this);
	        _this.toggleAccordion = _this.toggleAccordion.bind(_this);
	        _this.onItemsClosed = _this.onItemsClosed.bind(_this);
	        _this.setIsAnimating = _this.setIsAnimating.bind(_this);
	        _this.scrollTo = _this.scrollTo.bind(_this);
	        _this.completeScreen = _this.completeScreen.bind(_this);
	        _this.setScreenNotReadyYet = _this.setScreenNotReadyYet.bind(_this);
	        _this.getCanScrollScreenClass = _this.getCanScrollScreenClass.bind(_this);
	        _this.getPanelStyle = _this.getPanelStyle.bind(_this);
	        _this.getFeedClass = _this.getFeedClass.bind(_this);
	        return _this;
	    }
	
	    _createClass(AccordionScreen, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            this.setScreenAccessed();
	            this.props.biteCallbacks.showHeader(true);
	            this.props.actions.setScreenTitle(this.state.locale.title);
	            this.getAssets();
	            this.setCallbacks();
	
	            if (this.state.screenIsReady) {
	                this.setEnabledTabs();
	                this.checkScreenStatus();
	            } else {
	                this.setScreenNotReadyYet();
	            }
	        }
	    }, {
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(nextProps) {
	            var screenUserData = userDataHelper.getScreenUserData(nextProps.userData, this.state.screen.screen_id);
	            if (screenUserData.status === objectConstants.STATUS_COMPLETE) {
	                this.setState({
	                    status: screenUserData.status,
	                    enabledScreens: screenUserData.status === objectConstants.STATUS_COMPLETE ? this.state.screen.sub_screens : this.state.enabledScreens,
	                    completeScreens: screenUserData.status === objectConstants.STATUS_COMPLETE ? this.state.screen.sub_screens : this.state.completedScreens
	                });
	            } else if (this.state.isOpenNavigation) {
	                this.setState({
	                    enabledScreens: Object.assign([], this.state.screen.sub_screens)
	                });
	            }
	            this.setState({ userData: Object.assign({}, nextProps.userData) });
	
	            if (this.state.lang !== nextProps.lang) {
	                this.setState({
	                    lang: nextProps.lang,
	                    locale: appHelper.getLocalData(this.state.screen),
	                    continue_label: appHelper.getLocaleString("continue_label")
	                });
	                this.props.actions.setScreenTitle(appHelper.getLocalData(this.state.screen).title);
	            }
	        }
	    }, {
	        key: 'componentDidUpdate',
	        value: function componentDidUpdate() {
	            if (typeof this.state.renderedScreen.data === "undefined" && typeof this.state.activeScreen.screen_id !== "undefined") {
	                this.setRenderedScreen();
	            }
	        }
	    }, {
	        key: 'setScreenAccessed',
	        value: function setScreenAccessed() {
	            this.props.actions.setScreenAccessed(this.state.screen);
	        }
	    }, {
	        key: 'setScreenNotReadyYet',
	        value: function setScreenNotReadyYet() {
	            this.setState({ status: objectConstants.STATUS_COMPLETE });
	            this.updateScreenResults(objectConstants.STATUS_COMPLETE);
	        }
	    }, {
	        key: 'checkScreenStatus',
	        value: function checkScreenStatus() {
	            var screenUserData = userDataHelper.getScreenUserData(this.state.userData, this.state.screen.screen_id);
	            if (screenUserData.status === objectConstants.STATUS_COMPLETE) {
	                this.setState({
	                    status: screenUserData.status,
	                    enabledScreens: screenUserData.status === objectConstants.STATUS_COMPLETE ? this.state.screen.sub_screens : this.state.enabledScreens,
	                    completeScreens: screenUserData.status === objectConstants.STATUS_COMPLETE ? this.state.screen.sub_screens : this.state.completedScreens
	                });
	            } else if (this.state.isOpenNavigation) {
	                this.setState({
	                    enabledScreens: Object.assign([], this.state.screen.sub_screens)
	                });
	            }
	        }
	    }, {
	        key: 'getAssets',
	        value: function getAssets() {
	            var background = {};
	            var hotspotBackground = {};
	
	            if (appHelper.isDefined(this.state.screen.assets.background)) {
	                background = appHelper.getBackgroundAsset(this.state.screen.assets.background);
	            }
	            if (appHelper.isDefined(this.state.screen.assets.hotspot)) {
	                hotspotBackground = appHelper.getHotspotBackgroundAsset(this.state.screen.assets.hotspot);
	            }
	            this.setState({
	                assets: Object.assign({}, this.state.assets, {
	                    background: appHelper.isDefined(background.src) ? background : this.state.assets.background,
	                    hotspotBackground: appHelper.isDefined(hotspotBackground.src) ? hotspotBackground : this.state.assets.hotspotBackground
	
	                })
	            });
	            if (this.state.screen.sub_screens.length > 0) {
	                if (!appHelper.isDefined(hotspotBackground.src) || appHelper.isDefined(hotspotBackground.src) && hotspotBackground.src.length === 0) {
	                    this.setTabActive(this.state.screen.sub_screens[0]);
	                    this.toggleAccordion(this.state.screen.sub_screens[0]);
	                }
	            }
	        }
	    }, {
	        key: 'getImagePath',
	        value: function getImagePath(image) {
	            if (appConstants.DEVELOPMENT_MODE) {
	                if (appHelper.isDefined(image) && image.length > 0) {
	                    return __webpack_require__(16)("./" + image);
	                }
	            } else {
	                return image;
	            }
	        }
	    }, {
	        key: 'setCallbacks',
	        value: function setCallbacks() {
	            this.setState({
	                callbacks: Object.assign({}, this.props.biteCallbacks, {
	                    //onObjectComplete: this.onObjectComplete,
	                    getScreenId: this.getScreenId,
	                    getBiteId: this.getBiteId,
	                    onSubScreenComplete: this.onSubScreenComplete,
	                    goToNextSubScreen: this.goToNextSubScreen,
	                    hasNextSubScreen: this.hasNextSubScreen,
	                    toggleAccordion: this.toggleAccordion,
	                    onItemsClosed: this.onItemsClosed,
	                    setIsAnimating: this.setIsAnimating,
	                    scrollTo: this.scrollTo,
	                    completeScreen: this.completeScreen
	                    //objectIsEnabled: this.objectIsEnabled,
	                    //objectIsComplete: this.objectIsComplete,
	                    //storeUserResponse: this.storeUserResponse,
	                    //scrollTo: this.scrollTo,
	                    //isReviewMode: this.isReviewMode
	                })
	            });
	        }
	    }, {
	        key: 'scrollTo',
	        value: function scrollTo(pos) {
	            var feed = this.refs[this.state.screen.screen_id + '_feed'];
	            _gsap.TweenLite.to(feed, objectConstants.SHOW_PANEL_DURATION, {
	                scrollTop: pos,
	                ease: _gsap.Expo.easeInOut
	            }).eventCallback("onComplete", this.onScrollComplete);
	        }
	    }, {
	        key: 'getScreenId',
	        value: function getScreenId() {
	            return this.state.screen.screen_id;
	        }
	    }, {
	        key: 'getBiteId',
	        value: function getBiteId() {
	            //console.log(`getBiteId`);
	            return this.props.biteCallbacks.getBiteId();
	        }
	    }, {
	        key: 'setEnabledTabs',
	        value: function setEnabledTabs() {
	            if (this.state.status !== objectConstants.STATUS_COMPLETE) {
	                //if (this.state.screen.progression === objectConstants.OBJECT_PROGRESSION_LINEAR) {
	                if (this.state.isOpenNavigation) {
	                    this.setState({
	                        enabledScreens: Object.assign([], this.state.screen.sub_screens)
	                    });
	                } else {
	                    this.setState({ enabledScreens: dataHelper.immutablePush(this.state.enabledScreens, this.state.screen.sub_screens[0]) });
	                }
	                //} else {
	                //    this.setState({enabledObjects: Object.assign([], this.state.screen.objects)});
	                // }
	            } else {
	                //  console.log("hello");
	                this.setState({
	                    enabledObjects: Object.assign([], this.state.screen.objects),
	                    completeObjects: Object.assign([], this.state.screen.objects),
	                    checkContinueBtnState: true,
	                    propsUpdated: false
	                });
	            }
	        }
	    }, {
	        key: 'setTabActive',
	        value: function setTabActive(screen) {
	            //set renderedObject to empty so that when component updates we make sure we can set it again and we get exactly what we want rendered
	            this.setState({ activeScreen: screen, renderedScreen: {} });
	            //this.setBackButtonDisplayState(object);
	            //this.setContinueButtonDisplayState(object);
	        }
	    }, {
	        key: 'setRenderedScreen',
	        value: function setRenderedScreen() {
	            var screenType = Object.assign({}, (0, _componentHelper.getScreenComponentByType)(this.state.activeScreen.screen_type), {
	                data: this.state.activeScreen
	            });
	
	            this.setState({ renderedScreen: Object.assign({}, screenType) });
	        }
	    }, {
	        key: 'toggleAccordion',
	        value: function toggleAccordion(screen) {
	            if (appHelper.isDefined(this.state.activeScreen.screen_id)) {
	                if (screen.screen_id !== this.state.activeScreen.screen_id) {
	                    this.setState({ activeScreen: Object.assign({}, screen), toggleAllItems: true });
	                } else {
	                    this.setState({ activeScreen: Object.assign({}, {
	                            screen_id: 0
	                        }), toggleAllItems: true });
	                }
	            } else {
	                this.setState({ activeScreen: Object.assign({}, screen), toggleAllItems: true });
	            }
	        }
	    }, {
	        key: 'setIsAnimating',
	        value: function setIsAnimating(isAnimating) {
	            this.setState({ isAnimating: isAnimating });
	        }
	    }, {
	        key: 'onItemsClosed',
	        value: function onItemsClosed() {
	            this.setState({ toggleAllItems: false });
	        }
	    }, {
	        key: 'onSubScreenComplete',
	        value: function onSubScreenComplete(screen) {
	            //console.log(screen);
	            var completionIndex = appHelper.getArrayObjectIndexByKey(this.state.completeScreens, "screen_id", screen.screen_id);
	            var subScreenIndex = appHelper.getArrayObjectIndexByKey(this.state.screen.sub_screens, "screen_id", screen.screen_id);
	            var nextScreen = {};
	
	            if (subScreenIndex < this.state.screen.sub_screens.length - 1) {
	                nextScreen = Object.assign({}, this.state.screen.sub_screens[subScreenIndex + 1]);
	            }
	
	            if (completionIndex === -1) {
	                this.setState({
	                    completeScreens: dataHelper.immutablePush(this.state.completeScreens, screen),
	                    enabledScreens: typeof nextScreen.screen_id !== "undefined" ? dataHelper.immutablePush(this.state.enabledScreens, nextScreen) : Object.assign([], this.state.enabledScreens),
	                    checkContinueBtnState: true
	                });
	                // this.updateScreenResults(this.state.status !== objectConstants.STATUS_COMPLETE ? objectConstants.STATUS_IN_PROGRESS: objectConstants.STATUS_COMPLETE, object.object_id);
	            }
	
	            this.checkScreenComplete();
	        }
	    }, {
	        key: 'hasNextSubScreen',
	        value: function hasNextSubScreen(screen) {
	            var subScreenIndex = appHelper.getArrayObjectIndexByKey(this.state.screen.sub_screens, "screen_id", screen.screen_id);
	            return subScreenIndex < this.state.screen.sub_screens.length - 1;
	        }
	    }, {
	        key: 'goToNextSubScreen',
	        value: function goToNextSubScreen(screen) {
	            var subScreenIndex = appHelper.getArrayObjectIndexByKey(this.state.screen.sub_screens, "screen_id", screen.screen_id);
	            if (this.hasNextSubScreen(screen)) {
	                var nextScreen = Object.assign({}, this.state.screen.sub_screens[subScreenIndex + 1]);
	                this.setTabActive(nextScreen);
	                this.toggleAccordion(nextScreen);
	            } else {
	                this.navigateToNextScreen();
	            }
	        }
	    }, {
	        key: 'navigateToNextScreen',
	        value: function navigateToNextScreen() {
	            if (appHelper.isDefined(this.state.screen.next_screen_id) && !isNaN(this.state.screen.next_screen_id)) {
	                this.goToScreen(this.state.screen.next_screen_id);
	            } else {
	                var nextScreenId = appHelper.getNextScreenId(this.getScreenId());
	                if (localStorage.bites.length > 1 && nextScreenId.length === 0) {
	                    this.context.router.push('menu');
	                } else {
	                    this.props.actions.setNextLessonLocation(this.getScreenId());
	                }
	            }
	        }
	    }, {
	        key: 'checkScreenComplete',
	        value: function checkScreenComplete() {
	            if (this.state.completeScreens.length >= this.state.screen.sub_screens.length) {
	                this.setState({
	                    status: objectConstants.STATUS_COMPLETE
	                });
	                this.updateScreenResults(objectConstants.STATUS_COMPLETE);
	            }
	        }
	
	        //used when child screen terminates
	
	    }, {
	        key: 'completeScreen',
	        value: function completeScreen() {
	            this.setState({
	                status: objectConstants.STATUS_COMPLETE
	            });
	            this.updateScreenResults(objectConstants.STATUS_COMPLETE);
	        }
	    }, {
	        key: 'updateScreenResults',
	        value: function updateScreenResults(screen_status) {
	            var _this2 = this;
	
	            var params = {
	                bite_id: this.getBiteId(),
	                screen_id: this.getScreenId(),
	                screen_status: screen_status,
	                object_status: objectConstants.STATUS_COMPLETE
	            };
	
	            this.props.actions.updateScreenResults(params).then(function (userData) {
	                _this2.props.actions.setSuspendData(userData).then(function (trackingData) {
	                    if (screen_status === objectConstants.STATUS_COMPLETE) {
	                        _this2.props.actions.setScreenComplete(_this2.state.screen);
	                    }
	                }).catch(function (error) {});
	            }).catch(function (error) {});
	        }
	    }, {
	        key: 'getCanScrollScreenClass',
	        value: function getCanScrollScreenClass() {
	            return parseFloat(this.state.activeScreen.screen_id) === 0 ? "allow-scroll" : "";
	            //return "allow-scroll";
	        }
	    }, {
	        key: 'getPanelStyle',
	        value: function getPanelStyle() {
	            return appHelper.isDefined(this.state.screen.panel_style) ? this.state.screen.panel_style : "frosted_white";
	        }
	    }, {
	        key: 'getFeedClass',
	        value: function getFeedClass() {
	            return this.state.allowClippedBlurEffect ? 'blurred-feed' : 'standard-feed';
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this3 = this;
	
	            var renderedScreen = this.state.renderedScreen;
	            return _react2.default.createElement(
	                'div',
	                { className: 'customer-scenario' },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'background-container' },
	                    _react2.default.createElement('img', { src: this.getImagePath(this.state.assets.background.src), alt: '' })
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'screen-container' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'accordion-screen ' + this.getPanelStyle() },
	                        this.state.allowClippedBlurEffect ? _react2.default.createElement(
	                            'div',
	                            { className: 'content-wrapper-background ' },
	                            _react2.default.createElement('img', { className: 'blur', src: this.getImagePath(this.state.assets.background.src), alt: '' })
	                        ) : null,
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'accordion-content-wrapper ' + this.getFeedClass() + '  ' + this.getCanScrollScreenClass(), ref: this.state.screen.screen_id + '_feed' },
	                            appHelper.isDefined(this.state.assets.hotspotBackground.src) && this.state.assets.hotspotBackground.src.length > 0 && this.state.screen.sub_screens.length > 0 ? _react2.default.createElement(
	                                'div',
	                                { className: 'background-image' },
	                                _react2.default.createElement('img', { className: 'hot-spot-background',
	                                    src: this.getImagePath(this.state.assets.hotspotBackground.src), alt: '' })
	                            ) : null,
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'accordion' },
	                                this.state.screen.sub_screens.map(function (sub_screen) {
	                                    return typeof _this3.state.activeScreen.screen_id !== "undefined" && _this3.state.screenIsReady ? _react2.default.createElement(_AccordionItem2.default, { key: sub_screen.screen_id + '_tab',
	                                        parentScreen: _this3.state.screen,
	                                        screen: sub_screen,
	                                        activeScreenId: parseInt(_this3.state.activeScreen.screen_id),
	                                        enabledScreens: _this3.state.enabledScreens,
	                                        completeScreens: _this3.state.completeScreens,
	                                        toggleAllItems: _this3.state.toggleAllItems,
	                                        isAnimating: _this3.state.isAnimating,
	                                        biteCallbacks: _this3.state.callbacks }) : null;
	                                }),
	                                !this.state.screenIsReady ? _react2.default.createElement(
	                                    'div',
	                                    null,
	                                    this.state.producerNotes.length > 0 ? _react2.default.createElement(_ProducerNotes2.default, { notes: this.state.producerNotes,
	                                        screen_id: this.state.screen.screen_id }) : null,
	                                    _react2.default.createElement(_NotReadyYet2.default, { screen_id: this.state.screen.screen_id }),
	                                    _react2.default.createElement(_Button2.default, { ref: this.state.screen.screen_id + '_button',
	                                        label: this.state.continue_label,
	                                        id: this.state.screen.screen_id + '_button',
	                                        onClick: this.navigateToNextScreen,
	                                        onRevealed: this.onContinueBtnReveled })
	                                ) : null
	                            )
	                        )
	                    )
	                )
	            );
	        }
	    }]);
	
	    return AccordionScreen;
	}(_react2.default.Component);
	
	/*
	* <div className="tabbed-body-content" ref={`${this.state.screen.screen_id}_feed`}>
	                            {typeof renderedScreen.data !== "undefined"
	                                ?
	                                <renderedScreen.component screen={renderedScreen.data} parentScreen={this.state.screen}
	                                                          biteCallbacks={this.state.callbacks}/>
	                                : null
	                            }
	                        </div>
	* */
	
	AccordionScreen.propTypes = {
	    screen: _propTypes2.default.object.isRequired,
	    biteCallbacks: _propTypes2.default.object.isRequired,
	    titles: _propTypes2.default.object.isRequired,
	    lang: _propTypes2.default.string.isRequired,
	    actions: _propTypes2.default.object.isRequired,
	    userData: _propTypes2.default.object.isRequired
	};
	
	AccordionScreen.contextTypes = {
	    router: _propTypes2.default.object
	
	};
	
	function mapStateToProps(state, ownProps) {
	    var lang = state.userData.lang;
	    return {
	        lang: lang,
	        titles: state.titles,
	        userData: state.userData
	    };
	}
	
	function mapDispatchToProps(dispatch) {
	    return {
	        actions: (0, _redux.bindActionCreators)(Object.assign({}, appDataActions, trackingDataActions, userDataActions), dispatch)
	    };
	}
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(AccordionScreen);

/***/ },
/* 538 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(5);
	
	var _redux = __webpack_require__(4);
	
	var _trackingDataActions = __webpack_require__(7);
	
	var trackingDataActions = _interopRequireWildcard(_trackingDataActions);
	
	var _appHelper = __webpack_require__(3);
	
	var appHelper = _interopRequireWildcard(_appHelper);
	
	var _userDataHelper = __webpack_require__(15);
	
	var userDataHelper = _interopRequireWildcard(_userDataHelper);
	
	var _objectConstants = __webpack_require__(9);
	
	var objectConstants = _interopRequireWildcard(_objectConstants);
	
	var _keyboardConstants = __webpack_require__(14);
	
	var keyboardConstants = _interopRequireWildcard(_keyboardConstants);
	
	var _appConstants = __webpack_require__(13);
	
	var appConstants = _interopRequireWildcard(_appConstants);
	
	var _gsap = __webpack_require__(8);
	
	var _gsapReactPlugin = __webpack_require__(10);
	
	var _gsapReactPlugin2 = _interopRequireDefault(_gsapReactPlugin);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var HotSpotBtn = function (_React$Component) {
	    _inherits(HotSpotBtn, _React$Component);
	
	    function HotSpotBtn(props, context) {
	        _classCallCheck(this, HotSpotBtn);
	
	        var _this = _possibleConstructorReturn(this, (HotSpotBtn.__proto__ || Object.getPrototypeOf(HotSpotBtn)).call(this, props, context));
	
	        _this.state = {
	            parentScreen: _this.props.parentScreen,
	            lang: _this.props.lang,
	            screen: _this.props.screen,
	            userData: _this.props.userData,
	            activeScreenId: _this.props.activeScreenId,
	            enabledScreens: _this.props.enabledScreens,
	            completeScreens: _this.props.completeScreens,
	            className: "",
	            locale: appHelper.getLocalData(_this.props.screen),
	            update: false,
	            open_label: appHelper.getLocaleString("open_label"),
	            hotspotVisibility: _this.props.parentScreen.progression === objectConstants.PROGRESSION_TYPE_OPEN || _this.props.parentScreen.progression === objectConstants.PROGRESSION_TYPE_EXPLORE_INTERESTS ? "hidden" : "open",
	            icon: {}
	        };
	        _this.getClass = _this.getClass.bind(_this);
	        _this.setLocation = _this.setLocation.bind(_this);
	        _this.onClicked = _this.onClicked.bind(_this);
	        _this.screenIsEnabled = _this.screenIsEnabled.bind(_this);
	        _this.screenIsComplete = _this.screenIsComplete.bind(_this);
	        _this.getStatus = _this.getStatus.bind(_this);
	        _this.isDisabled = _this.isDisabled.bind(_this);
	        _this.setKeyboardAccessibility = _this.setKeyboardAccessibility.bind(_this);
	        _this.hasToolTip = _this.hasToolTip.bind(_this);
	        _this.onCloseToolTip = _this.onCloseToolTip.bind(_this);
	        _this.onCloseToolTipKeyboardAccessibility = _this.onCloseToolTipKeyboardAccessibility.bind(_this);
	        _this.onMouseIn = _this.onMouseIn.bind(_this);
	        _this.onMouseOut = _this.onMouseOut.bind(_this);
	        _this.getHotSpotButtonType = _this.getHotSpotButtonType.bind(_this);
	        _this.getAssets = _this.getAssets.bind(_this);
	        _this.getImagePath = _this.getImagePath.bind(_this);
	        _this.setButtonColour = _this.setButtonColour.bind(_this);
	        return _this;
	    }
	
	    _createClass(HotSpotBtn, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            this.getAssets();
	            this.setLocation();
	        }
	    }, {
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(nextProps) {
	            if (this.state.enabledScreens !== nextProps.enabledScreens || this.state.completeScreens !== nextProps.completeScreens || this.state.activeScreenId !== nextProps.activeScreenId) {
	                this.setState({
	                    update: true
	                });
	            }
	
	            if (this.state.userData !== nextProps.userData) {
	                this.setState({
	                    userData: Object.assign({}, nextProps.userData)
	                });
	            }
	
	            if (this.state.lang !== nextProps.lang) {
	                this.setState({
	                    lang: nextProps.lang,
	                    locale: appHelper.getLocalData(this.state.screen),
	                    open_label: appHelper.getLocaleString("open_label")
	                });
	            }
	        }
	    }, {
	        key: 'componentDidUpdate',
	        value: function componentDidUpdate() {}
	    }, {
	        key: 'screenIsEnabled',
	        value: function screenIsEnabled() {
	            return appHelper.getArrayObjectIndexByKey(this.props.enabledScreens, "screen_id", this.state.screen.screen_id);
	        }
	    }, {
	        key: 'screenIsComplete',
	        value: function screenIsComplete() {
	            return appHelper.getArrayObjectIndexByKey(this.props.completeScreens, "screen_id", this.state.screen.screen_id);
	        }
	    }, {
	        key: 'getStatus',
	        value: function getStatus() {
	
	            var screenUserData = userDataHelper.getSubScreenUserData(this.state.userData, this.props.parentScreen.screen_id, this.state.screen.screen_id);
	            if (screenUserData.status === objectConstants.STATUS_NOT_STARTED || screenUserData.status === objectConstants.STATUS_NOT_REQUIRED) {
	                return "not-started";
	            } else if (screenUserData.status === objectConstants.STATUS_IN_PROGRESS) {
	                return "in-progress";
	            } else if (screenUserData.status === objectConstants.STATUS_COMPLETE) {
	                return "complete";
	            }
	        }
	    }, {
	        key: 'getClass',
	        value: function getClass() {
	            var screenUserData = userDataHelper.getSubScreenUserData(this.state.userData, this.props.parentScreen.screen_id, this.state.screen.screen_id);
	            var className = "";
	
	            if (this.state.screen.screen_id === this.props.activeScreenId) {
	                className += "active ";
	            }
	            if (this.screenIsEnabled() === -1 && screenUserData.status !== objectConstants.STATUS_COMPLETE) {
	                className += "disabled ";
	            }
	
	            return className;
	        }
	    }, {
	        key: 'onClicked',
	        value: function onClicked(event) {
	            if (appHelper.isDefined(event)) {
	                event.stopPropagation();
	            }
	
	            var screenUserData = userDataHelper.getSubScreenUserData(this.state.userData, this.props.parentScreen.screen_id, this.state.screen.screen_id);
	            if (this.screenIsEnabled() > -1 || screenUserData.status === objectConstants.STATUS_COMPLETE) {
	                this.props.onClickFunc(this.state.screen);
	            }
	        }
	    }, {
	        key: 'setLocation',
	        value: function setLocation() {
	            var hotSpotRef = this.refs['hotSpot_' + this.state.screen_id];
	            _gsap.TweenLite.set(hotSpotRef, {
	                left: this.state.screen.hotspot_x_coordinate,
	                top: this.state.screen.hotspot_y_coordinate
	            });
	        }
	    }, {
	        key: 'setKeyboardAccessibility',
	        value: function setKeyboardAccessibility(event) {
	            if (event.which === keyboardConstants.ENTER_KEY || event.which === keyboardConstants.SPACEBAR_KEY) {
	                event.preventDefault();
	                this.onClicked();
	            }
	        }
	    }, {
	        key: 'isDisabled',
	        value: function isDisabled() {
	            var screenUserData = userDataHelper.getSubScreenUserData(this.state.userData, this.props.parentScreen.screen_id, this.state.screen.screen_id);
	            return this.screenIsEnabled() > -1 || screenUserData.status !== objectConstants.STATUS_COMPLETE;
	        }
	    }, {
	        key: 'hasToolTip',
	        value: function hasToolTip() {
	            if (this.screenIsEnabled() > -1 && (this.props.parentScreen.hotspot_button_type === objectConstants.HOT_SPOT_BUTTON_TYPE_CHECK_ROLLOVER || this.props.parentScreen.hotspot_button_type === objectConstants.HOT_SPOT_BUTTON_TYPE_SMALL_ICON)) {
	                return true;
	            }
	        }
	    }, {
	        key: 'onCloseToolTip',
	        value: function onCloseToolTip(event) {
	            event.stopPropagation();
	            this.setState({ hotspotVisibility: "hidden" });
	        }
	    }, {
	        key: 'onCloseToolTipKeyboardAccessibility',
	        value: function onCloseToolTipKeyboardAccessibility() {
	            if (event.which === keyboardConstants.ENTER_KEY || event.which === keyboardConstants.SPACEBAR_KEY) {
	                event.stopPropagation();
	                this.setState({ hotspotVisibility: "hidden" });
	            }
	        }
	    }, {
	        key: 'getHotSpotButtonType',
	        value: function getHotSpotButtonType() {
	            var screen = this.props.parentScreen;
	            var returnVal = "";
	            switch (screen.hotspot_button_type) {
	                case objectConstants.HOT_SPOT_BUTTON_TYPE_CHECK_ROLLOVER:
	                    returnVal = "hot-spot-hide";
	                    break;
	                case objectConstants.HOT_SPOT_BUTTON_TYPE_CHECK_LABEL:
	                    returnVal = "hot-spot";
	                    break;
	                case objectConstants.HOT_SPOT_BUTTON_TYPE_SMALL_ICON:
	                    returnVal = "hot-spot-sml-icon-only";
	                    break;
	                case objectConstants.HOT_SPOT_BUTTON_TYPE_SMALL_ICON_LABEL:
	                    returnVal = "hot-spot-sml-icon";
	                    break;
	                case objectConstants.HOT_SPOT_BUTTON_TYPE_LARGE_ICON:
	                    returnVal = "hot-spot-lg-icon-only";
	                    break;
	                case objectConstants.HOT_SPOT_BUTTON_TYPE_LARGE_ICON_LABEL:
	                    returnVal = "hot-spot-lg-icon";
	                    break;
	            }
	            return returnVal;
	        }
	    }, {
	        key: 'getAssets',
	        value: function getAssets() {
	            var icon = {};
	
	            if (appHelper.isDefined(this.state.screen.assets.icon)) {
	                icon = appHelper.getIconAsset(this.state.screen.assets.icon);
	            }
	
	            this.setState({
	                icon: Object.assign({}, icon)
	            });
	        }
	    }, {
	        key: 'getImagePath',
	        value: function getImagePath(image) {
	            if (appConstants.DEVELOPMENT_MODE) {
	                if (appHelper.isDefined(image) && image.length > 0) {
	                    return __webpack_require__(16)("./" + image);
	                }
	            } else {
	                return image;
	            }
	        }
	    }, {
	        key: 'setButtonColour',
	        value: function setButtonColour() {
	            if (this.props.parentScreen.hotspot_colour !== objectConstants.INHERIT && this.props.parentScreen.hotspot_label_colour !== objectConstants.INHERIT) {
	                return {
	                    background: this.props.parentScreen.hotspot_colour,
	                    color: this.props.parentScreen.hotspot_label_colour
	                };
	            } else if (this.props.parentScreen.hotspot_colour !== objectConstants.INHERIT && this.props.parentScreen.hotspot_label_colour === objectConstants.INHERIT) {
	                return {
	                    background: this.props.parentScreen.hotspot_colour
	
	                };
	            } else if (this.props.parentScreen.hotspot_colour === objectConstants.INHERIT && this.props.parentScreen.hotspot_label_colour !== objectConstants.INHERIT) {
	                return {
	                    color: this.props.parentScreen.hotspot_label_colour
	                };
	            } else {
	                return {};
	            }
	        }
	    }, {
	        key: 'onMouseIn',
	        value: function onMouseIn() {
	            if (this.state.parentScreen.progression === objectConstants.PROGRESSION_TYPE_OPEN || this.props.parentScreen.progression === objectConstants.PROGRESSION_TYPE_EXPLORE_INTERESTS) {
	                this.setState({ hotspotVisibility: "open" });
	            }
	        }
	    }, {
	        key: 'onMouseOut',
	        value: function onMouseOut() {
	            if (this.state.parentScreen.progression === objectConstants.PROGRESSION_TYPE_OPEN || this.props.parentScreen.progression === objectConstants.PROGRESSION_TYPE_EXPLORE_INTERESTS) {
	                this.setState({ hotspotVisibility: "hidden" });
	            }
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            return _react2.default.createElement(
	                'div',
	                { className: this.getHotSpotButtonType() + ' ' + this.state.className + ' hot-spot-' + this.state.screen.hotspot_label_type + ' ' + this.getStatus() + ' ' + this.getClass(),
	                    onClick: this.onClicked,
	                    onKeyDown: this.setKeyboardAccessibility,
	                    onMouseEnter: this.onMouseIn,
	                    onMouseLeave: this.onMouseOut,
	                    ref: 'hotSpot_' + this.state.screen_id,
	                    id: 'hotSpot_' + this.state.screen.screen_id,
	                    role: 'link',
	                    tabIndex: '0',
	                    'aria-current': this.state.screen.screen_id === this.props.activeScreenId,
	                    'aria-disabled': this.isDisabled(),
	                    style: this.setButtonColour()
	                },
	                appHelper.isDefined(this.state.icon.src) ? _react2.default.createElement(
	                    'div',
	                    { className: 'hot-spot-icon' },
	                    _react2.default.createElement('img', { src: this.getImagePath(this.state.icon.src), alt: '' })
	                ) : null,
	                _react2.default.createElement('div', { className: 'hot-spot-label', dangerouslySetInnerHTML: { __html: this.state.locale.title } }),
	                this.hasToolTip() ? _react2.default.createElement(
	                    'div',
	                    { className: 'hot-spot-tool-tip ' + this.state.hotspotVisibility, onClick: this.onCloseToolTip, onKeyDown: this.onCloseToolTipKeyboardAccessibility, role: 'link', tabIndex: '0' },
	                    _react2.default.createElement('div', { className: 'close-btn' }),
	                    _react2.default.createElement('h5', { dangerouslySetInnerHTML: { __html: this.state.locale.title } }),
	                    _react2.default.createElement(
	                        'button',
	                        { className: 'btn guroo-btn', onClick: this.onClicked, style: this.setButtonColour() },
	                        this.state.open_label
	                    )
	                ) : null,
	                this.hasToolTip() && this.state.hotspotVisibility === "open" ? _react2.default.createElement('div', { className: 'hot-spot-hover-area' }) : null
	            );
	        }
	    }]);
	
	    return HotSpotBtn;
	}(_react2.default.Component);
	
	HotSpotBtn.propTypes = {
	    parentScreen: _propTypes2.default.object.isRequired,
	    screen: _propTypes2.default.object.isRequired,
	    activeScreenId: _propTypes2.default.number,
	    enabledScreens: _propTypes2.default.array.isRequired,
	    completeScreens: _propTypes2.default.array.isRequired,
	    onClickFunc: _propTypes2.default.func,
	    userData: _propTypes2.default.object.isRequired,
	    lang: _propTypes2.default.string.isRequired,
	    actions: _propTypes2.default.object
	};
	
	HotSpotBtn.contextTypes = {
	    router: _propTypes2.default.object
	};
	
	function mapStateToProps(state, ownProps) {
	    var lang = state.userData.lang;
	    return {
	        lang: lang,
	        userData: state.userData
	    };
	}
	
	function mapDispatchToProps(dispatch) {
	    return {
	        actions: (0, _redux.bindActionCreators)(Object.assign({}, trackingDataActions), dispatch)
	    };
	}
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(HotSpotBtn);

/***/ },
/* 539 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(5);
	
	var _redux = __webpack_require__(4);
	
	var _HotSpotBtn = __webpack_require__(538);
	
	var _HotSpotBtn2 = _interopRequireDefault(_HotSpotBtn);
	
	var _ProducerNotes = __webpack_require__(85);
	
	var _ProducerNotes2 = _interopRequireDefault(_ProducerNotes);
	
	var _NotReadyYet = __webpack_require__(84);
	
	var _NotReadyYet2 = _interopRequireDefault(_NotReadyYet);
	
	var _Button = __webpack_require__(18);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _trackingDataActions = __webpack_require__(7);
	
	var trackingDataActions = _interopRequireWildcard(_trackingDataActions);
	
	var _appDataActions = __webpack_require__(12);
	
	var appDataActions = _interopRequireWildcard(_appDataActions);
	
	var _userDataActions = __webpack_require__(20);
	
	var userDataActions = _interopRequireWildcard(_userDataActions);
	
	var _dialogPopupActions = __webpack_require__(19);
	
	var dialogPopupActions = _interopRequireWildcard(_dialogPopupActions);
	
	var _appHelper = __webpack_require__(3);
	
	var appHelper = _interopRequireWildcard(_appHelper);
	
	var _dataHelper = __webpack_require__(11);
	
	var dataHelper = _interopRequireWildcard(_dataHelper);
	
	var _appConstants = __webpack_require__(13);
	
	var appConstants = _interopRequireWildcard(_appConstants);
	
	var _objectConstants = __webpack_require__(9);
	
	var objectConstants = _interopRequireWildcard(_objectConstants);
	
	var _assetConstants = __webpack_require__(33);
	
	var assetConstants = _interopRequireWildcard(_assetConstants);
	
	var _localStorage = __webpack_require__(17);
	
	var localStorage = _interopRequireWildcard(_localStorage);
	
	var _userDataHelper = __webpack_require__(15);
	
	var userDataHelper = _interopRequireWildcard(_userDataHelper);
	
	var _keyboardConstants = __webpack_require__(14);
	
	var keyboardConstants = _interopRequireWildcard(_keyboardConstants);
	
	var _dialogModels = __webpack_require__(32);
	
	var _componentHelper = __webpack_require__(31);
	
	var _gsap = __webpack_require__(8);
	
	var _gsapReactPlugin = __webpack_require__(10);
	
	var _gsapReactPlugin2 = _interopRequireDefault(_gsapReactPlugin);
	
	var _lodash = __webpack_require__(28);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } //eslint-disable-line import/no-named-as-default
	
	
	var HotspotScreen = function (_React$Component) {
	    _inherits(HotspotScreen, _React$Component);
	
	    function HotspotScreen(props, context) {
	        _classCallCheck(this, HotspotScreen);
	
	        var _this = _possibleConstructorReturn(this, (HotspotScreen.__proto__ || Object.getPrototypeOf(HotspotScreen)).call(this, props, context));
	
	        _this.state = {
	            lang: _this.props.lang,
	            screen: _this.props.screen,
	            userData: _this.props.userData,
	            locale: appHelper.getLocalData(_this.props.screen),
	            status: userDataHelper.getScreenUserData(_this.props.userData, _this.props.screen.screen_id).status, // objectConstants.STATUS_IN_PROGRESS,
	            callbacks: {},
	            assets: {
	                background: {
	                    src: ""
	                },
	                hotspotBackground: {
	                    src: ""
	                }
	            },
	            activeScreen: {},
	            viewedScreens: [],
	            hotspotScreens: [],
	            introductionScreen: {},
	            conclusionScreen: {},
	            enabledScreens: [],
	            completeScreens: [],
	            checkNextSlideBtnState: false,
	            hasIntroduction: _this.props.hasIntroduction,
	            introductionStatus: objectConstants.STATUS_NOT_STARTED,
	            launchIntroduction: false,
	            hasConclusion: _this.props.hasConclusion,
	            conclusionStatus: objectConstants.STATUS_NOT_STARTED,
	            launchConclusion: false,
	            scrollState: "",
	            checkScrollPos: false,
	            producerNotes: appHelper.getScreenNotes(undefined, _this.props.screen),
	            screenIsReady: _this.props.screen.sub_screens.length > 0 && appHelper.canSeeContent(_this.props.screen),
	            doSetRenderedScreens: false,
	            setEnabledHotSpots: false,
	            isOpenNavigation: appHelper.getBiteById(_this.props.biteCallbacks.getBiteId()).navigation_type === objectConstants.PROGRESSION_TYPE_OPEN,
	            introduction_label: appHelper.getLocaleString("introduction_label"),
	            continue_label: appHelper.getLocaleString("continue_label"),
	            conclusion_label: appHelper.getLocaleString("conclusion_label"),
	            scroll_label: appHelper.getLocaleString("scroll_label")
	
	        };
	
	        _this.getScreenId = _this.getScreenId.bind(_this);
	        _this.getBiteId = _this.getBiteId.bind(_this);
	        _this.getAssets = _this.getAssets.bind(_this);
	        _this.getImagePath = _this.getImagePath.bind(_this);
	        _this.checkScreenStatus = _this.checkScreenStatus.bind(_this);
	        _this.setCallbacks = _this.setCallbacks.bind(_this);
	        _this.readySetRenderedScreens = _this.readySetRenderedScreens.bind(_this);
	        _this.setEnabledHotSpots = _this.setEnabledHotSpots.bind(_this);
	        _this.setActiveHotspot = _this.setActiveHotspot.bind(_this);
	        _this.onSubScreenComplete = _this.onSubScreenComplete.bind(_this);
	        _this.goToNextSubScreen = _this.goToNextSubScreen.bind(_this);
	        _this.hasNextSubScreen = _this.hasNextSubScreen.bind(_this);
	        _this.checkScreenComplete = _this.checkScreenComplete.bind(_this);
	        _this.updateScreenResults = _lodash2.default.debounce(_this.updateScreenResults.bind(_this), 300);
	        _this.setScreenAccessed = _lodash2.default.debounce(_this.setScreenAccessed.bind(_this), 300);
	        _this.navigateToNextScreen = _this.navigateToNextScreen.bind(_this);
	        _this.checkScreenStatus = _this.checkScreenStatus.bind(_this);
	        _this.setRenderedScreens = _this.setRenderedScreens.bind(_this);
	        _this.setScreenHasBeenViewed = _this.setScreenHasBeenViewed.bind(_this);
	        _this.checkScreenIsEnabled = _this.checkScreenIsEnabled.bind(_this);
	        _this.completeScreen = _this.completeScreen.bind(_this);
	        _this.launchScreen = _this.launchScreen.bind(_this);
	        _this.checkHotSpotsAreComplete = _this.checkHotSpotsAreComplete.bind(_this);
	        _this.onCloseScreen = _this.onCloseScreen.bind(_this);
	        _this.showFooter = _this.showFooter.bind(_this);
	        _this.hasFooterClass = _this.hasFooterClass.bind(_this);
	        _this.showIntroduction = _this.showIntroduction.bind(_this);
	        _this.showConclusion = _this.showConclusion.bind(_this);
	        _this.checkScrolling = _this.checkScrolling.bind(_this);
	        _this.setScreenTitle = _this.setScreenTitle.bind(_this);
	        _this.readyIntroduction = _this.readyIntroduction.bind(_this);
	        _this.readyConclusion = _this.readyConclusion.bind(_this);
	        _this.scrollToBottom = _this.scrollToBottom.bind(_this);
	        _this.setScreenNotReadyYet = _this.setScreenNotReadyYet.bind(_this);
	        _this.getCompletedSubScreens = _this.getCompletedSubScreens.bind(_this);
	        _this.setKeyboardAccessibility = _this.setKeyboardAccessibility.bind(_this);
	        _this.allowScroll = _this.allowScroll.bind(_this);
	        _this.setButtonColour = _this.setButtonColour.bind(_this);
	        return _this;
	    }
	
	    _createClass(HotspotScreen, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            this.setScreenAccessed();
	            this.props.biteCallbacks.showHeader(true);
	            this.getAssets();
	            this.setCallbacks();
	            if (this.state.screenIsReady) {
	                //this.setEnabledHotSpots();
	                var readySetRenderedScreens = this.readySetRenderedScreens;
	                setTimeout(function () {
	                    readySetRenderedScreens();
	                }, 1000);
	                //this.readySetRenderedScreens();
	                //this.setRenderedScreens();
	            } else {
	                this.setScreenNotReadyYet();
	            }
	
	            this.setScreenTitle();
	            var feed = this.refs[this.state.screen.screen_id + '_feed'];
	            feed.addEventListener("scroll", this.checkScrolling);
	
	            //this.setActiveHotspot(this.state.screen.sub_screens[0]);
	        }
	    }, {
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(nextProps) {
	            var screenUserData = userDataHelper.getScreenUserData(nextProps.userData, this.state.screen.screen_id);
	            var introductionStatus = this.state.introductionStatus;
	            var conclusionStatus = this.state.conclusionStatus;
	
	            if (this.state.userData !== nextProps.userData) {
	                this.setState({
	                    userData: Object.assign({}, nextProps.userData),
	                    //introductionStatus: introductionStatus,
	                    setEnabledHotSpots: true
	                });
	            }
	
	            if (this.state.hasIntroduction && introductionStatus !== objectConstants.STATUS_COMPLETE && appHelper.isDefined(this.state.introductionScreen.data)) {
	                introductionStatus = userDataHelper.getSubScreenUserData(nextProps.userData, this.state.screen.screen_id, this.state.introductionScreen.data.screen_id).status;
	                this.setState({
	                    introductionStatus: introductionStatus
	                    //setEnabledHotSpots: true
	                });
	            }
	
	            if (this.state.hasConclusion && conclusionStatus !== objectConstants.STATUS_COMPLETE && appHelper.isDefined(this.state.conclusionScreen.data)) {
	                conclusionStatus = userDataHelper.getSubScreenUserData(nextProps.userData, this.state.screen.screen_id, this.state.conclusionScreen.data.screen_id).status;
	                this.setState({
	                    conclusionStatus: conclusionStatus
	                    //setEnabledHotSpots: true
	                });
	            }
	
	            if (screenUserData.status === objectConstants.STATUS_COMPLETE) {
	                this.setState({
	
	                    status: screenUserData.status,
	                    enabledScreens: screenUserData.status === objectConstants.STATUS_COMPLETE ? this.state.screen.sub_screens : this.state.enabledScreens,
	                    completeScreens: screenUserData.status === objectConstants.STATUS_COMPLETE ? this.state.screen.sub_screens : this.state.completeScreens
	                });
	            }
	
	            if (this.state.lang !== nextProps.lang) {
	                this.setState({
	                    lang: nextProps.lang,
	                    locale: appHelper.getLocalData(this.state.screen),
	                    introduction_label: appHelper.getLocaleString("introduction_label"),
	                    continue_label: appHelper.getLocaleString("continue_label"),
	                    conclusion_label: appHelper.getLocaleString("conclusion_label"),
	                    scroll_label: appHelper.getLocaleString("scroll_label")
	                });
	                this.props.actions.setScreenTitle(appHelper.getLocalData(this.state.screen).title);
	            }
	            //this.setState({setEnabledHotSpots: true });
	        }
	    }, {
	        key: 'componentDidUpdate',
	        value: function componentDidUpdate() {
	
	            if (this.state.launchIntroduction) {
	                this.readyIntroduction();
	            }
	
	            if (this.state.launchConclusion) {
	                this.readyConclusion();
	            }
	
	            if (this.state.checkScrollPos) {
	                this.checkScrolling();
	            }
	
	            if (this.state.doSetRenderedScreens) {
	                this.setRenderedScreens();
	            }
	
	            if (this.state.setEnabledHotSpots) {
	                this.setEnabledHotSpots();
	            }
	        }
	    }, {
	        key: 'componentWillUnmount',
	        value: function componentWillUnmount() {
	            var feed = this.refs[this.state.screen.screen_id + '_feed'];
	            feed.removeEventListener("scroll", this.checkScrolling);
	        }
	    }, {
	        key: 'readySetRenderedScreens',
	        value: function readySetRenderedScreens() {
	
	            this.setState({
	                setEnabledHotSpots: true
	            });
	        }
	    }, {
	        key: 'setScreenAccessed',
	        value: function setScreenAccessed() {
	            this.props.actions.setScreenAccessed(this.state.screen);
	        }
	    }, {
	        key: 'setScreenNotReadyYet',
	        value: function setScreenNotReadyYet() {
	            this.setState({ status: objectConstants.STATUS_COMPLETE });
	            this.updateScreenResults(objectConstants.STATUS_COMPLETE);
	        }
	    }, {
	        key: 'readyIntroduction',
	        value: function readyIntroduction() {
	            var launchScreen = this.launchScreen;
	            var introductionScreen = this.state.introductionScreen;
	            setTimeout(function () {
	                launchScreen(introductionScreen);
	            }, 1000);
	        }
	    }, {
	        key: 'readyConclusion',
	        value: function readyConclusion() {
	            var launchScreen = this.launchScreen;
	            var conclusionScreen = this.state.conclusionScreen;
	            setTimeout(function () {
	                launchScreen(conclusionScreen);
	            }, 1000);
	        }
	    }, {
	        key: 'setScreenTitle',
	        value: function setScreenTitle() {
	            this.props.actions.setScreenTitle(this.state.locale.title);
	        }
	    }, {
	        key: 'checkScreenStatus',
	        value: function checkScreenStatus() {
	            var screenUserData = userDataHelper.getScreenUserData(this.state.userData, this.state.screen.screen_id);
	            if (screenUserData.status === objectConstants.STATUS_COMPLETE) {
	                this.setState({
	                    status: screenUserData.status,
	                    enabledScreens: screenUserData.status === objectConstants.STATUS_COMPLETE ? this.state.screen.sub_screens : this.state.enabledScreens,
	                    completeScreens: screenUserData.status === objectConstants.STATUS_COMPLETE ? this.state.screen.sub_screens : this.state.completeScreens
	                });
	            }
	        }
	    }, {
	        key: 'getAssets',
	        value: function getAssets() {
	            var background = {};
	            var hotspotBackground = {};
	
	            if (appHelper.isDefined(this.state.screen.assets.background)) {
	                background = appHelper.getBackgroundAsset(this.state.screen.assets.background);
	            }
	
	            if (appHelper.isDefined(this.state.screen.assets.hotspot)) {
	                hotspotBackground = appHelper.getHotspotBackgroundAsset(this.state.screen.assets.hotspot);
	            }
	            this.setState({
	                assets: Object.assign({}, this.state.assets, {
	                    background: appHelper.isDefined(background.src) ? background : this.state.assets.background,
	                    hotspotBackground: appHelper.isDefined(hotspotBackground.src) ? hotspotBackground : this.state.assets.hotspotBackground
	                }),
	                checkScrollPos: true
	            });
	        }
	    }, {
	        key: 'getImagePath',
	        value: function getImagePath(image) {
	            if (appConstants.DEVELOPMENT_MODE) {
	                if (appHelper.isDefined(image) && image.length > 0) {
	                    return __webpack_require__(16)("./" + image);
	                }
	            } else {
	                return image;
	            }
	        }
	    }, {
	        key: 'setCallbacks',
	        value: function setCallbacks() {
	            this.setState({
	                callbacks: Object.assign({}, this.props.biteCallbacks, {
	                    //onObjectComplete: this.onObjectComplete,
	                    getScreenId: this.getScreenId,
	                    getBiteId: this.getBiteId,
	                    onSubScreenComplete: this.onSubScreenComplete,
	                    goToNextSubScreen: this.goToNextSubScreen,
	                    hasNextSubScreen: this.hasNextSubScreen,
	                    completeScreen: this.completeScreen
	                    //objectIsEnabled: this.objectIsEnabled,
	                    //objectIsComplete: this.objectIsComplete,
	                    //storeUserResponse: this.storeUserResponse,
	                    //scrollTo: this.scrollTo,
	                    //isReviewMode: this.isReviewMode
	                })
	            });
	        }
	    }, {
	        key: 'getScreenId',
	        value: function getScreenId() {
	            return this.state.screen.screen_id;
	        }
	    }, {
	        key: 'getBiteId',
	        value: function getBiteId() {
	            return this.props.biteCallbacks.getBiteId();
	        }
	    }, {
	        key: 'showFooter',
	        value: function showFooter() {
	
	            return this.state.status === objectConstants.STATUS_COMPLETE || this.state.introductionStatus === objectConstants.STATUS_COMPLETE || this.state.conclusionStatus === objectConstants.STATUS_COMPLETE || this.state.scrollState === 'scroll' || this.state.isOpenNavigation;
	        }
	    }, {
	        key: 'hasFooterClass',
	        value: function hasFooterClass() {
	            return this.showFooter() ? "include-footer" : "";
	        }
	    }, {
	        key: 'setEnabledHotSpots',
	        value: function setEnabledHotSpots() {
	            this.setState({ setEnabledHotSpots: false });
	            if (appHelper.isDefined(this.state.screen.progression) && this.state.screen.progression === objectConstants.LINEAR && this.state.status !== objectConstants.STATUS_COMPLETE) {
	                this.setState({ doSetRenderedScreens: true, enabledScreens: dataHelper.immutablePush(this.state.enabledScreens, this.state.screen.sub_screens[0]) });
	            } else {
	                this.setState({ doSetRenderedScreens: true, enabledScreens: Object.assign([], this.state.screen.sub_screens) });
	            }
	        }
	    }, {
	        key: 'checkScreenIsEnabled',
	        value: function checkScreenIsEnabled(screen) {
	            var enabledIndex = appHelper.getArrayObjectIndexByKey(this.state.enabledScreens, "screen_id", screen.screen_id);
	            return enabledIndex > -1;
	        }
	    }, {
	        key: 'setActiveHotspot',
	        value: function setActiveHotspot(screen) {
	            //set renderedObject to empty so that when component updates we make sure we can set it again and we get exactly what we want rendered
	
	            this.setState({
	                activeScreen: screen
	            });
	
	            if (screen.hotspot_display_type === objectConstants.DISPLAY_TYPE_HOTSPOT) {
	                var renderedScreen = {};
	                _lodash2.default.forEach(this.state.hotspotScreens, function (hs_screen) {
	                    if (hs_screen.data.screen_id === screen.screen_id) {
	                        renderedScreen = Object.assign({}, hs_screen);
	                    }
	                });
	                this.launchScreen(renderedScreen);
	            } else if (screen.hotspot_display_type === objectConstants.DISPLAY_TYPE_INTRODUCTION) {
	                this.launchScreen(this.state.introductionScreen);
	            } else if (screen.hotspot_display_type === objectConstants.DISPLAY_TYPE_CONCLUSION) {
	                this.launchScreen(this.state.conclusionScreen);
	            }
	        }
	    }, {
	        key: 'setScreenHasBeenViewed',
	        value: function setScreenHasBeenViewed(screen) {
	            var viewedIndex = appHelper.getArrayObjectIndexByKey(this.state.viewedScreens, "screen_id", screen.screen_id);
	            if (viewedIndex === -1) {
	                this.setState({ viewedObjects: dataHelper.immutablePush(this.state.viewedScreens, screen) });
	            }
	        }
	    }, {
	        key: 'setRenderedScreens',
	        value: function setRenderedScreens() {
	            //console.log(`setRenderedScreens`);
	            this.setState({ doSetRenderedScreens: false });
	            var hotspotScreens = [];
	            var introductionScreen = {};
	            var conclusionScreen = {};
	            var introductionStatus = objectConstants.STATUS_NOT_STARTED;
	            var conclusionStatus = objectConstants.STATUS_NOT_STARTED;
	            var userData = this.state.userData;
	            var screen = this.state.screen;
	
	            _lodash2.default.forEach(this.state.screen.sub_screens, function (sub_screen) {
	                var screenType = Object.assign({}, (0, _componentHelper.getScreenComponentByType)(sub_screen.screen_type), {
	                    data: sub_screen
	                });
	
	                if (screenType.data.hotspot_display_type === objectConstants.DISPLAY_TYPE_HOTSPOT) {
	                    hotspotScreens = dataHelper.immutablePush(hotspotScreens, screenType);
	                } else if (screenType.data.hotspot_display_type === objectConstants.DISPLAY_TYPE_INTRODUCTION) {
	                    introductionScreen = Object.assign({}, screenType);
	                    introductionStatus = userDataHelper.getSubScreenUserData(userData, screen.screen_id, introductionScreen.data.screen_id).status;
	                    //console.log(`introductionStatus`,introductionStatus);
	                } else if (screenType.data.hotspot_display_type === objectConstants.DISPLAY_TYPE_CONCLUSION) {
	                    conclusionScreen = Object.assign({}, screenType);
	                    conclusionStatus = userDataHelper.getSubScreenUserData(userData, screen.screen_id, conclusionScreen.data.screen_id).status;
	                }
	            });
	
	            var completeScreens = this.getCompletedSubScreens();
	            var enabledScreens = this.getCompletedSubScreens();
	
	            if (appHelper.isDefined(this.state.screen.progression) && this.state.screen.progression !== objectConstants.LINEAR) {
	                enabledScreens = Object.assign([], this.state.screen.sub_screens);
	            } else if (enabledScreens.length > 0 && enabledScreens.length < this.state.screen.sub_screens.length) {
	                var nextScreen = Object.assign({}, this.state.screen.sub_screens[enabledScreens.length]);
	                enabledScreens = dataHelper.immutablePush(enabledScreens, nextScreen);
	            } else {
	                var firstScreen = Object.assign({}, this.state.screen.sub_screens[0]);
	                enabledScreens = dataHelper.immutablePush(enabledScreens, firstScreen);
	
	                //enabledScreens =  dataHelper.immutablePush(this.state.screen.sub_screens[0]);
	            }
	
	            // console.log(`completeScreens`,completeScreens);
	
	            var introductionIndex = appHelper.getArrayObjectIndexByKey(completeScreens, "screen_id", introductionScreen.screen_id);
	            var conclusionIndex = appHelper.getArrayObjectIndexByKey(completeScreens, "screen_id", conclusionScreen.screen_id);
	
	            if (introductionIndex > -1) {
	                introductionStatus = objectConstants.STATUS_COMPLETE;
	            }
	
	            if (conclusionIndex > -1) {
	                conclusionStatus = objectConstants.STATUS_COMPLETE;
	            }
	            //console.log(`launchIntroduction`,this.state.hasIntroduction && introductionStatus !== objectConstants.STATUS_COMPLETE);
	            //console.log(`launchConclusion`,completeScreens.length === (this.state.screen.sub_screens.length - 1) && this.state.hasConclusion && conclusionStatus !== objectConstants.STATUS_COMPLETE);
	
	            this.setState({
	                hotspotScreens: Object.assign([], hotspotScreens),
	                introductionScreen: Object.assign({}, introductionScreen),
	                introductionStatus: introductionStatus,
	                conclusionScreen: Object.assign({}, conclusionScreen),
	                conclusionStatus: conclusionStatus,
	                launchIntroduction: this.state.hasIntroduction && introductionStatus !== objectConstants.STATUS_COMPLETE,
	                enabledScreens: Object.assign([], enabledScreens),
	                completeScreens: Object.assign([], completeScreens),
	                launchConclusion: completeScreens.length === this.state.screen.sub_screens.length - 1 && this.state.hasConclusion && conclusionStatus === objectConstants.STATUS_NOT_STARTED
	            });
	        }
	    }, {
	        key: 'getCompletedSubScreens',
	        value: function getCompletedSubScreens() {
	            var completedScreens = [];
	            var userData = this.state.userData;
	            var parentScreen = this.state.screen;
	            _lodash2.default.forEach(this.state.screen.sub_screens, function (sub_screen) {
	                var screenUserData = userDataHelper.getSubScreenUserData(userData, parentScreen.screen_id, sub_screen.screen_id);
	                if (screenUserData.status === objectConstants.STATUS_COMPLETE) {
	                    completedScreens = dataHelper.immutablePush(completedScreens, sub_screen);
	                }
	            });
	
	            return completedScreens;
	        }
	    }, {
	        key: 'onSubScreenComplete',
	        value: function onSubScreenComplete(screen) {
	            var completionIndex = appHelper.getArrayObjectIndexByKey(this.state.completeScreens, "screen_id", screen.screen_id);
	            var subScreenIndex = appHelper.getArrayObjectIndexByKey(this.state.screen.sub_screens, "screen_id", screen.screen_id);
	            var nextScreen = {};
	
	            if (subScreenIndex < this.state.screen.sub_screens.length - 1) {
	                nextScreen = Object.assign({}, this.state.screen.sub_screens[subScreenIndex + 1]);
	            }
	
	            if (completionIndex === -1) {
	                this.setState({
	                    completeScreens: dataHelper.immutablePush(this.state.completeScreens, screen),
	                    enabledScreens: typeof nextScreen.screen_id !== "undefined" ? dataHelper.immutablePush(this.state.enabledScreens, nextScreen) : Object.assign([], this.state.enabledScreens),
	                    checkContinueBtnState: true,
	                    checkNextSlideBtnState: true
	                });
	
	                // this.updateScreenResults(this.state.status !== objectConstants.STATUS_COMPLETE ? objectConstants.STATUS_IN_PROGRESS: objectConstants.STATUS_COMPLETE, screen.screen_id);
	            }
	
	            this.checkScreenComplete();
	        }
	    }, {
	        key: 'checkHotSpotsAreComplete',
	        value: function checkHotSpotsAreComplete() {
	            var completedHotSpots = 0;
	            var completeScreens = this.state.completeScreens;
	            _lodash2.default.forEach(this.state.hotspotScreens, function (screen) {
	                var screen_id = screen.data.screen_id;
	                var completionIndex = appHelper.getArrayObjectIndexByKey(completeScreens, "screen_id", screen_id);
	                if (completionIndex > -1) {
	                    completedHotSpots++;
	                }
	            });
	            return completedHotSpots === this.state.hotspotScreens.length;
	        }
	    }, {
	        key: 'hasNextSubScreen',
	        value: function hasNextSubScreen(screen) {
	            var subScreenIndex = appHelper.getArrayObjectIndexByKey(this.state.screen.sub_screens, "screen_id", screen.screen_id);
	            return subScreenIndex < this.state.screen.sub_screens.length - 1;
	        }
	    }, {
	        key: 'goToNextSubScreen',
	        value: function goToNextSubScreen(screen) {
	            var subScreenIndex = appHelper.getArrayObjectIndexByKey(this.state.screen.sub_screens, "screen_id", screen.screen_id);
	            if (this.hasNextSubScreen(screen)) {
	                var nextScreen = Object.assign({}, this.state.screen.sub_screens[subScreenIndex + 1]);
	                this.setActiveHotspot(nextScreen);
	            } else {
	                this.navigateToNextScreen();
	            }
	        }
	    }, {
	        key: 'navigateToNextScreen',
	        value: function navigateToNextScreen() {
	
	            if (this.state.isOpenNavigation || this.state.screen.progression === objectConstants.PROGRESSION_TYPE_EXPLORE_INTERESTS) {
	                this.updateScreenResults(objectConstants.STATUS_COMPLETE);
	            }
	
	            if (appHelper.isDefined(this.state.screen.next_screen_id) && !isNaN(this.state.screen.next_screen_id)) {
	                this.goToScreen(this.state.screen.next_screen_id);
	            } else {
	                var nextScreenId = appHelper.getNextScreenId(this.getScreenId());
	                if (localStorage.bites.length > 1 && nextScreenId.length === 0) {
	                    this.context.router.push('menu');
	                } else {
	                    this.props.actions.setNextLessonLocation(this.getScreenId());
	                }
	            }
	        }
	    }, {
	        key: 'checkScreenComplete',
	        value: function checkScreenComplete() {
	            if (this.state.completeScreens.length >= this.state.screen.sub_screens.length) {
	                this.setState({
	                    status: objectConstants.STATUS_COMPLETE
	                });
	                this.updateScreenResults(objectConstants.STATUS_COMPLETE);
	            }
	        }
	
	        //used when child screen terminates
	
	    }, {
	        key: 'completeScreen',
	        value: function completeScreen() {
	            this.setState({
	                status: objectConstants.STATUS_COMPLETE
	            });
	            this.updateScreenResults(objectConstants.STATUS_COMPLETE);
	        }
	    }, {
	        key: 'updateScreenResults',
	        value: function updateScreenResults(screen_status) {
	            var _this2 = this;
	
	            var params = {
	                bite_id: this.getBiteId(),
	                screen_id: this.getScreenId(),
	                screen_status: screen_status,
	                object_status: objectConstants.STATUS_COMPLETE
	            };
	            this.props.actions.updateScreenResults(params).then(function (userData) {
	                _this2.props.actions.setSuspendData(userData).then(function (trackingData) {
	                    if (screen_status === objectConstants.STATUS_COMPLETE) {
	                        _this2.props.actions.setScreenComplete(_this2.state.screen);
	                    }
	                }).catch(function (error) {});
	            }).catch(function (error) {});
	        }
	    }, {
	        key: 'launchScreen',
	        value: function launchScreen(renderedScreen) {
	
	            this.setState({
	                launchIntroduction: false,
	                launchConclusion: false
	            });
	
	            var config = Object.assign({}, _dialogModels.SCREEN_CONFIG, {
	                component: renderedScreen.component,
	                biteCallbacks: this.state.callbacks,
	                parentScreen: {
	                    screen_id: this.state.screen.screen_id
	                },
	                screen: {
	                    screen_id: renderedScreen.data.screen_id
	                },
	                onClose: this.onCloseScreen,
	                sourceId: 'hotSpot_' + renderedScreen.data.screen_id
	
	            });
	
	            this.props.actions.setNewScreenDialog(config);
	        }
	    }, {
	        key: 'onCloseScreen',
	        value: function onCloseScreen() {
	            var launchConclusion = this.checkHotSpotsAreComplete() && this.state.hasConclusion && this.state.conclusionStatus === objectConstants.STATUS_NOT_STARTED;
	            this.setState({ launchConclusion: launchConclusion });
	        }
	    }, {
	        key: 'showIntroduction',
	        value: function showIntroduction() {
	            this.launchScreen(this.state.introductionScreen);
	        }
	    }, {
	        key: 'showConclusion',
	        value: function showConclusion() {
	            this.launchScreen(this.state.conclusionScreen);
	        }
	    }, {
	        key: 'checkScrolling',
	        value: function checkScrolling() {
	            this.setState({ checkScrollPos: false });
	            var feed = this.refs[this.state.screen.screen_id + '_feed'];
	            var hotspot_background = this.refs[this.state.screen.screen_id + '_background'];
	            if (hotspot_background.offsetHeight > feed.offsetHeight && feed.scrollTop < hotspot_background.offsetHeight - feed.offsetHeight && appHelper.isDefined(this.state.screen.scrollable) && this.state.screen.scrollable) {
	                this.setState({
	                    scrollState: "scroll"
	                });
	            } else {
	                this.setState({
	                    scrollState: ""
	                });
	            }
	        }
	    }, {
	        key: 'scrollToBottom',
	        value: function scrollToBottom() {
	            var feed = this.refs[this.state.screen.screen_id + '_feed'];
	            _gsap.TweenLite.to(feed, 0.5, {
	                scrollTop: feed.offsetHeight,
	                ease: _gsap.Expo.easeInOut
	            });
	        }
	    }, {
	        key: 'setKeyboardAccessibility',
	        value: function setKeyboardAccessibility(event) {
	            if (event.which === keyboardConstants.ENTER_KEY || event.which === keyboardConstants.SPACEBAR_KEY) {
	                event.preventDefault();
	                this.scrollToBottom();
	            }
	        }
	    }, {
	        key: 'allowScroll',
	        value: function allowScroll() {
	            return appHelper.isDefined(this.state.screen.scrollable) && this.state.screen.scrollable;
	        }
	    }, {
	        key: 'setButtonColour',
	        value: function setButtonColour() {
	            if (this.state.screen.hotspot_type === objectConstants.HOT_SPOT_TYPE_NO_SCREEN || this.state.screen.hotspot_type === objectConstants.HOT_SPOT_TYPE_FULL_SCREEN) {
	                if (this.state.screen.hotspot_colour !== objectConstants.INHERIT && this.state.screen.hotspot_label_colour !== objectConstants.INHERIT) {
	                    return {
	                        background: this.state.screen.hotspot_colour,
	                        color: this.state.screen.hotspot_label_colour
	                    };
	                } else if (this.state.screen.hotspot_colour !== objectConstants.INHERIT && this.state.screen.hotspot_label_colour === objectConstants.INHERIT) {
	                    return {
	                        background: this.state.screen.hotspot_colour
	
	                    };
	                } else if (this.state.screen.hotspot_colour === objectConstants.INHERIT && this.state.screen.hotspot_label_colour !== objectConstants.INHERIT) {
	                    return {
	                        color: this.state.screen.hotspot_label_colour
	                    };
	                } else {
	                    return {};
	                }
	            } else {
	                return {};
	            }
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this3 = this;
	
	            return _react2.default.createElement(
	                'div',
	                { className: 'customer-scenario' },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'background-container' },
	                    _react2.default.createElement('img', { src: this.getImagePath(this.state.assets.background.src), alt: '' })
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'screen-container' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'hot-spot-screen ' + this.state.screen.hotspot_type },
	                        this.state.introductionStatus !== objectConstants.STATUS_NOT_STARTED ? _react2.default.createElement(
	                            'button',
	                            { className: 'btn guroo-btn introduction-btn', ref: 'hotSpot_' + this.state.introductionScreen.screen_id, id: 'hotSpot_' + this.state.introductionScreen.data.screen_id, tabIndex: '0', onClick: this.showIntroduction, style: this.setButtonColour() },
	                            this.state.introduction_label
	                        ) : null,
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'hot-spot-content ' + this.hasFooterClass() + ' ' + (!this.allowScroll() ? "no-scroll" : ""),
	                                ref: this.state.screen.screen_id + '_feed' },
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'hot-spot-background-container',
	                                    ref: this.state.screen.screen_id + '_background' },
	                                appHelper.isDefined(this.state.assets.hotspotBackground.src) ? _react2.default.createElement('img', {
	                                    className: this.state.screen.sub_screens.length === 0 ? "image-overlay" : "hot-spot-background",
	                                    src: this.getImagePath(this.state.assets.hotspotBackground.src), alt: '' }) : null,
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: 'hot-spot-area' },
	                                    this.state.screen.sub_screens.map(function (sub_screen) {
	                                        return sub_screen.hotspot_display_type === objectConstants.DISPLAY_TYPE_HOTSPOT && _this3.state.screenIsReady ? _react2.default.createElement(_HotSpotBtn2.default, { key: sub_screen.screen_id + '_hotspot',
	                                            parentScreen: _this3.state.screen,
	                                            screen: sub_screen,
	                                            activeScreenId: _this3.state.activeScreen.screen_id,
	                                            enabledScreens: _this3.state.enabledScreens,
	                                            completeScreens: _this3.state.completeScreens,
	                                            onClickFunc: _this3.setActiveHotspot }) : null;
	                                    }),
	                                    !this.state.screenIsReady ? _react2.default.createElement(
	                                        'div',
	                                        null,
	                                        this.state.producerNotes.length > 0 ? _react2.default.createElement(_ProducerNotes2.default, { notes: this.state.producerNotes,
	                                            screen_id: this.state.screen.screen_id }) : null,
	                                        _react2.default.createElement(_NotReadyYet2.default, { screen_id: this.state.screen.screen_id }),
	                                        _react2.default.createElement(_Button2.default, { ref: this.state.screen.screen_id + '_button',
	                                            label: this.state.continue_label,
	                                            id: this.state.screen.screen_id + '_button',
	                                            onClick: this.navigateToNextScreen,
	                                            onRevealed: this.onContinueBtnReveled })
	                                    ) : null
	                                )
	                            )
	                        ),
	                        this.state.conclusionStatus !== objectConstants.STATUS_NOT_STARTED || this.state.screen.progression === objectConstants.PROGRESSION_TYPE_EXPLORE_INTERESTS && (!this.state.hasIntroduction || this.state.hasIntroduction && this.state.introductionStatus === objectConstants.STATUS_COMPLETE) && appHelper.isDefined(this.state.conclusionScreen.data) ? _react2.default.createElement(
	                            'button',
	                            { className: 'btn guroo-btn conclusion-btn', ref: 'hotSpot_' + this.state.conclusionScreen.screen_id, id: 'hotSpot_' + this.state.conclusionScreen.data.screen_id, tabIndex: '0', onClick: this.showConclusion, style: this.setButtonColour() },
	                            this.state.conclusion_label
	                        ) : null,
	                        this.showFooter() ? _react2.default.createElement(
	                            'div',
	                            { className: 'hot-spot-footer ' + this.state.scrollState },
	                            _react2.default.createElement('div', { className: 'footer-btn', onClick: this.scrollToBottom, onKeyDown: this.setKeyboardAccessibility, role: 'presentation' }),
	                            _react2.default.createElement('div', { className: 'footer-col' }),
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'footer-col text-center' },
	                                this.state.scrollState === 'scroll' && this.state.screen.hotspot_type !== objectConstants.HOT_SPOT_TYPE_FULL_SCREEN ? _react2.default.createElement(
	                                    'div',
	                                    { className: 'scroll-instruction' },
	                                    this.state.scroll_label
	                                ) : null
	                            ),
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'footer-col text-right' },
	                                this.state.status === objectConstants.STATUS_COMPLETE || this.state.isOpenNavigation || this.state.screen.progression === objectConstants.PROGRESSION_TYPE_EXPLORE_INTERESTS ? _react2.default.createElement(
	                                    'button',
	                                    { className: 'btn guroo-btn', onClick: this.navigateToNextScreen, style: this.setButtonColour() },
	                                    this.state.continue_label
	                                ) : null
	                            )
	                        ) : null
	                    )
	                )
	            );
	        }
	    }]);
	
	    return HotspotScreen;
	}(_react2.default.Component);
	
	HotspotScreen.propTypes = {
	    screen: _propTypes2.default.object.isRequired,
	    hasIntroduction: _propTypes2.default.bool.isRequired,
	    hasConclusion: _propTypes2.default.bool.isRequired,
	    biteCallbacks: _propTypes2.default.object.isRequired,
	    titles: _propTypes2.default.object.isRequired,
	    actions: _propTypes2.default.object.isRequired,
	    lang: _propTypes2.default.string.isRequired,
	    userData: _propTypes2.default.object.isRequired
	};
	
	HotspotScreen.contextTypes = {
	    router: _propTypes2.default.object
	
	};
	
	function mapStateToProps(state, ownProps) {
	
	    var lastIndex = -1;
	    var hasIntroduction = false;
	    var hasConclusion = false;
	    if (ownProps.screen.sub_screens.length > 0) {
	        lastIndex = ownProps.screen.sub_screens.length - 1;
	        hasIntroduction = ownProps.screen.sub_screens[0].hotspot_display_type === objectConstants.DISPLAY_TYPE_INTRODUCTION;
	        hasConclusion = ownProps.screen.sub_screens[lastIndex].hotspot_display_type === objectConstants.DISPLAY_TYPE_CONCLUSION;
	    }
	    var lang = state.userData.lang;
	    return {
	        lang: lang,
	        hasIntroduction: hasIntroduction,
	        hasConclusion: hasConclusion,
	        titles: state.titles,
	        userData: state.userData
	    };
	}
	
	function mapDispatchToProps(dispatch) {
	    return {
	        actions: (0, _redux.bindActionCreators)(Object.assign({}, appDataActions, trackingDataActions, userDataActions, dialogPopupActions), dispatch)
	    };
	}
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(HotspotScreen);

/***/ },
/* 540 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(5);
	
	var _redux = __webpack_require__(4);
	
	var _Button = __webpack_require__(18);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _ProducerNotes = __webpack_require__(85);
	
	var _ProducerNotes2 = _interopRequireDefault(_ProducerNotes);
	
	var _NotReadyYet = __webpack_require__(84);
	
	var _NotReadyYet2 = _interopRequireDefault(_NotReadyYet);
	
	var _SecondaryImage = __webpack_require__(66);
	
	var _SecondaryImage2 = _interopRequireDefault(_SecondaryImage);
	
	var _SecondaryLibraryImage = __webpack_require__(67);
	
	var _SecondaryLibraryImage2 = _interopRequireDefault(_SecondaryLibraryImage);
	
	var _trackingDataActions = __webpack_require__(7);
	
	var trackingDataActions = _interopRequireWildcard(_trackingDataActions);
	
	var _appDataActions = __webpack_require__(12);
	
	var appDataActions = _interopRequireWildcard(_appDataActions);
	
	var _userDataActions = __webpack_require__(20);
	
	var userDataActions = _interopRequireWildcard(_userDataActions);
	
	var _appHelper = __webpack_require__(3);
	
	var appHelper = _interopRequireWildcard(_appHelper);
	
	var _dataHelper = __webpack_require__(11);
	
	var dataHelper = _interopRequireWildcard(_dataHelper);
	
	var _componentHelper = __webpack_require__(31);
	
	var _userDataHelper = __webpack_require__(15);
	
	var userDataHelper = _interopRequireWildcard(_userDataHelper);
	
	var _appConstants = __webpack_require__(13);
	
	var appConstants = _interopRequireWildcard(_appConstants);
	
	var _assetConstants = __webpack_require__(33);
	
	var assetConstants = _interopRequireWildcard(_assetConstants);
	
	var _objectConstants = __webpack_require__(9);
	
	var objectConstants = _interopRequireWildcard(_objectConstants);
	
	var _localStorage = __webpack_require__(17);
	
	var localStorage = _interopRequireWildcard(_localStorage);
	
	var _gsap = __webpack_require__(8);
	
	var _gsapReactPlugin = __webpack_require__(10);
	
	var _gsapReactPlugin2 = _interopRequireDefault(_gsapReactPlugin);
	
	var _lodash = __webpack_require__(28);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } //eslint-disable-line import/no-named-as-default
	
	
	var ResourcesScrollScreen = function (_React$Component) {
	    _inherits(ResourcesScrollScreen, _React$Component);
	
	    function ResourcesScrollScreen(props, context) {
	        _classCallCheck(this, ResourcesScrollScreen);
	
	        var _this = _possibleConstructorReturn(this, (ResourcesScrollScreen.__proto__ || Object.getPrototypeOf(ResourcesScrollScreen)).call(this, props, context));
	
	        _this.state = {
	            lang: _this.props.lang,
	            screen: _this.props.screen,
	            userData: _this.props.userData,
	            is_resource_screen: appHelper.isDefined(_this.props.screen.is_resource_screen) && _this.props.screen.is_resource_screen,
	            locale: {},
	            status: objectConstants.STATUS_NOT_STARTED,
	            multiPath: appHelper.isDefined(_this.props.screen.multi_path) ? _this.props.screen.multi_path : { enabled: false },
	            allowReviewMode: true,
	            reviewMode: false,
	            propsUpdated: false,
	            renderedObjects: [],
	            updateCharacter: false,
	            screenCharacter: {},
	            assets: {
	                background: {
	                    src: "",
	                    type: "",
	                    type_id: ""
	                },
	                screenAsset: {
	                    src: "",
	                    pose: "",
	                    position: ""
	                }
	            },
	            callbacks: {
	                updateCharacterExpression: null,
	                onObjectComplete: null
	            },
	            currentObjectIndex: 0,
	            showProgression: false,
	            imageIsTracking: false,
	            allowGoToScreen: false,
	            goToScreenId: 0,
	            terminateScreen: false,
	            terminateBite: false,
	            producerNotes: appHelper.getScreenNotes(_this.props.parentScreen, _this.props.screen),
	            screenIsReady: _this.props.screen.objects.length > 0 && (appHelper.canSeeContent(_this.props.screen) || appHelper.isDefined(_this.props.parentScreen)),
	            continue_label: appHelper.getLocaleString("continue_label")
	
	        };
	        _this.getLocale = _this.getLocale.bind(_this);
	        _this.getObject = _this.getObject.bind(_this);
	        _this.getScreenId = _this.getScreenId.bind(_this);
	        _this.getBiteId = _this.getBiteId.bind(_this);
	        _this.isReviewMode = _this.isReviewMode.bind(_this);
	        _this.getImagePath = _this.getImagePath.bind(_this);
	        _this.getAssets = _this.getAssets.bind(_this);
	        _this.getAssetType = _this.getAssetType.bind(_this);
	        _this.storeUserResponse = _this.storeUserResponse.bind(_this);
	        _this.setCallbacks = _this.setCallbacks.bind(_this);
	        _this.updateCharacterExpression = _this.updateCharacterExpression.bind(_this);
	        _this.onObjectComplete = _this.onObjectComplete.bind(_this);
	        _this.updateScreenResults = _lodash2.default.debounce(_this.updateScreenResults.bind(_this), 300);
	        _this.setScreenAccessed = _lodash2.default.debounce(_this.setScreenAccessed.bind(_this), 300);
	        _this.showProgressionButton = _this.showProgressionButton.bind(_this);
	        _this.navigateToNextScreen = _this.navigateToNextScreen.bind(_this);
	        _this.scrollTo = _this.scrollTo.bind(_this);
	        _this.onScrollComplete = _this.onScrollComplete.bind(_this);
	        _this.onContinueBtnReveled = _this.onContinueBtnReveled.bind(_this);
	        _this.scrollToTop = _this.scrollToTop.bind(_this);
	        _this.checkScreenStatus = _this.checkScreenStatus.bind(_this);
	        _this.setReviewMode = _this.setReviewMode.bind(_this);
	        _this.renderAllObjects = _this.renderAllObjects.bind(_this);
	        _this.transitionCharacterExpressions = _this.transitionCharacterExpressions.bind(_this);
	        _this.transitionCharacter = _this.transitionCharacter.bind(_this);
	        _this.transitionPrevCharacter = _this.transitionPrevCharacter.bind(_this);
	        _this.goToScreen = _this.goToScreen.bind(_this);
	        //new
	        _this.getCharacterName = _this.getCharacterName.bind(_this);
	        _this.handleObjectProgression = _this.handleObjectProgression.bind(_this);
	        _this.hasNextObject = _this.hasNextObject.bind(_this);
	        _this.getLayoutClass = _this.getLayoutClass.bind(_this);
	        _this.getScreenStatus = _this.getScreenStatus.bind(_this);
	        _this.getSubScreenParent = _this.getSubScreenParent.bind(_this);
	        _this.checkIsResourceScreen = _this.checkIsResourceScreen.bind(_this);
	        _this.updateResourceObjectResult = _this.updateResourceObjectResult.bind(_this);
	        _this.updateResourceScreenResult = _this.updateResourceScreenResult.bind(_this);
	        _this.setScreenNotReadyYet = _this.setScreenNotReadyYet.bind(_this);
	        _this.setScreenNotReadyYet = _this.setScreenNotReadyYet.bind(_this);
	        _this.onObjectRendered = _this.onObjectRendered.bind(_this);
	        return _this;
	    }
	
	    _createClass(ResourcesScrollScreen, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            if (this.props.audio.audioRef.length > 0) {
	                this.props.actions.clearAudio();
	            }
	            this.setScreenAccessed();
	            this.props.biteCallbacks.showHeader(true);
	            this.setCallbacks();
	            this.getLocale();
	            if (this.state.screenIsReady) {
	                this.getObject(this.state.currentObjectIndex);
	            } else {
	                this.setScreenNotReadyYet();
	            }
	            this.getAssets();
	            this.checkScreenStatus();
	        }
	    }, {
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(nextProps) {
	            var screenUserData = {};
	            if (this.state.is_resource_screen) {
	                screenUserData = userDataHelper.getResourceScreenUserData(nextProps.userData, this.state.screen.screen_id);
	            } else if (this.props.parentScreen) {
	                screenUserData = userDataHelper.getSubScreenUserData(nextProps.userData, this.props.parentScreen.screen_id, this.state.screen.screen_id);
	            } else {
	                screenUserData = userDataHelper.getScreenUserData(nextProps.userData, this.state.screen.screen_id);
	            }
	            this.setState({ userData: Object.assign({}, nextProps.userData) });
	
	            if (this.state.status !== screenUserData.status && screenUserData.status === objectConstants.STATUS_COMPLETE) {
	                this.setState({
	                    status: screenUserData.status
	                });
	            }
	
	            if (this.state.lang !== nextProps.lang) {
	                this.setState({
	                    lang: nextProps.lang,
	                    locale: appHelper.getLocalData(this.state.screen),
	                    continue_label: appHelper.getLocaleString("continue_label")
	                });
	            }
	        }
	    }, {
	        key: 'componentDidUpdate',
	        value: function componentDidUpdate() {
	            if (this.state.propsUpdated && this.state.reviewMode && this.state.allowReviewMode) {
	                this.setReviewMode();
	            }
	
	            if (this.state.updateCharacter) {
	
	                this.transitionCharacterExpressions();
	            }
	        }
	    }, {
	        key: 'componentWillUnmount',
	        value: function componentWillUnmount() {
	            this.props.actions.clearAudio();
	        }
	    }, {
	        key: 'setScreenAccessed',
	        value: function setScreenAccessed() {
	            //this.props.actions.setScreenAccessed(this.state.screen);
	        }
	    }, {
	        key: 'setScreenNotReadyYet',
	        value: function setScreenNotReadyYet() {
	            var completionData = {
	                screen_status: objectConstants.STATUS_COMPLETE,
	                sub_screen_complete: appHelper.isDefined(this.props.parentScreen) ? true : undefined
	            };
	
	            this.showProgressionButton();
	
	            this.updateScreenResults(completionData);
	        }
	    }, {
	        key: 'checkScreenStatus',
	        value: function checkScreenStatus() {
	            var screenUserData = {};
	            if (this.state.is_resource_screen) {
	                screenUserData = userDataHelper.getResourceScreenUserData(this.state.userData, this.state.screen.screen_id);
	            } else if (this.props.parentScreen) {
	                screenUserData = userDataHelper.getSubScreenUserData(this.state.userData, this.props.parentScreen.screen_id, this.state.screen.screen_id);
	            } else {
	                screenUserData = userDataHelper.getScreenUserData(this.state.userData, this.state.screen.screen_id);
	            }
	
	            if (this.state.status !== screenUserData.status && screenUserData.status === objectConstants.STATUS_COMPLETE) {
	                this.setState({
	                    status: screenUserData.status
	                });
	            }
	            /* let screenStatus = getScreenUserData(this.props.userData, this.props.screen.screen_id).status;
	             let reviewMode = screenStatus === objectConstants.STATUS_COMPLETE && localStorage.post_completion_mode === appConstants.POST_COMPLETION_MODE_REVIEW;
	            // console.log(`reviewMode: ${this.state.reviewMode} - line 120`);
	             this.setState({status: screenStatus, checkCompletionStatus: true, reviewMode: reviewMode, propsUpdated: true});
	             */
	        }
	    }, {
	        key: 'setCallbacks',
	        value: function setCallbacks() {
	            //console.log(`reviewMode: ${this.state.reviewMode} - line 125`);
	            this.setState({
	                callbacks: Object.assign({}, this.state.biteCallbacks, {
	                    updateCharacterExpression: this.updateCharacterExpression,
	                    onObjectComplete: this.onObjectComplete,
	                    getScreenId: this.getScreenId,
	                    getBiteId: this.getBiteId,
	                    storeUserResponse: this.storeUserResponse,
	                    scrollTo: this.scrollTo,
	                    isReviewMode: this.isReviewMode,
	                    getCharacterName: this.getCharacterName,
	                    hasNextObject: this.hasNextObject,
	                    navigateToNextScreen: this.navigateToNextScreen,
	                    getScreenStatus: this.getScreenStatus,
	                    getSubScreenParent: this.getSubScreenParent,
	                    checkIsResourceScreen: this.checkIsResourceScreen,
	                    goToScreen: this.goToScreen,
	                    onObjectRendered: this.onObjectRendered
	                })
	            });
	        }
	    }, {
	        key: 'getSubScreenParent',
	        value: function getSubScreenParent() {
	            return appHelper.isDefined(this.props.parentScreen) ? this.props.parentScreen : undefined;
	        }
	    }, {
	        key: 'getLocale',
	        value: function getLocale() {
	            var locale = appHelper.getLocalData(this.state.screen);
	            this.setState({ locale: Object.assign({}, locale) });
	            //if (!appHelper.isDefined(this.props.parentScreen) && !this.state.is_resource_screen) {
	            if (!appHelper.isDefined(this.props.parentScreen) && !this.state.is_resource_screen) {
	                this.props.actions.setScreenTitle(locale.title);
	            }
	        }
	    }, {
	        key: 'getScreenId',
	        value: function getScreenId() {
	            return this.state.screen.screen_id;
	        }
	    }, {
	        key: 'getBiteId',
	        value: function getBiteId() {
	
	            return this.props.biteCallbacks.getBiteId();
	        }
	    }, {
	        key: 'isReviewMode',
	        value: function isReviewMode() {
	            return this.state.reviewMode;
	        }
	    }, {
	        key: 'getCharacterName',
	        value: function getCharacterName() {
	            return this.state.locale.character_name;
	        }
	    }, {
	        key: 'getScreenStatus',
	        value: function getScreenStatus() {
	            return this.state.status;
	        }
	    }, {
	        key: 'checkIsResourceScreen',
	        value: function checkIsResourceScreen() {
	            return this.state.is_resource_screen;
	        }
	    }, {
	        key: 'setReviewMode',
	        value: function setReviewMode() {
	
	            var objectsToRender = appHelper.getRenderableObjects(this.props.userData, this.getBiteId(), this.state.screen.objects);
	            this.setState({
	                screen: Object.assign({}, this.state.screen, {
	                    objects: Object.assign([], objectsToRender)
	                }),
	                propsUpdated: false
	            });
	            this.renderAllObjects(objectsToRender);
	        }
	    }, {
	        key: 'renderAllObjects',
	        value: function renderAllObjects(objectsToRender) {
	            var renderableObjects = [];
	            for (var i = 0; i < objectsToRender.length; i++) {
	                var object = objectsToRender[i];
	                var objectType = Object.assign({}, (0, _componentHelper.getAssetComponentByType)(object.asset_type_code), {
	                    data: object
	                });
	                renderableObjects = dataHelper.immutablePush(renderableObjects, objectType);
	            }
	            this.setState({ renderedObjects: Object.assign([], renderableObjects), showProgression: true });
	        }
	    }, {
	        key: 'getObject',
	        value: function getObject(index) {
	            var object = this.state.screen.objects[index];
	            var objectType = Object.assign({}, (0, _componentHelper.getAssetComponentByType)(object.asset_type_code), {
	                data: object
	            });
	            //console.log(objectType);
	            //let objectLocale = appHelper.getLocalData(object.locale);
	            //this.props.actions.setScreenTitle(objectLocale.title);
	            this.setState({ renderedObjects: Object.assign([], dataHelper.immutablePush(this.state.renderedObjects, objectType)) });
	        }
	    }, {
	        key: 'getAssets',
	        value: function getAssets() {
	            var backgroundAsset = Object.assign(this.state.assets.background);
	            var hasLeftAsset = appHelper.isDefined(this.state.screen.assets.left);
	            var hasRightAsset = appHelper.isDefined(this.state.screen.assets.right);
	            var screenAsset = {};
	            if (hasLeftAsset) {
	                screenAsset = this.getAssetType(this.state.screen.assets.left);
	            } else if (hasRightAsset) {
	                screenAsset = this.getAssetType(this.state.screen.assets.right);
	            }
	
	            if (appHelper.isDefined(this.state.screen.assets.background)) {
	                backgroundAsset = appHelper.getBackgroundAsset(this.state.screen.assets.background);
	            }
	
	            this.setState({
	                assets: Object.assign({}, this.state.assets, {
	                    background: backgroundAsset,
	                    screenAsset: screenAsset
	                })
	            });
	        }
	    }, {
	        key: 'getAssetType',
	        value: function getAssetType(asset) {
	            var returnAsset = {};
	            if (asset.constant === assetConstants.ASSET_TYPE_ID_CHARACTER) {
	                var screenCharacter = appHelper.getCharacterAsset(asset);
	                returnAsset = appHelper.getCharacterPose(screenCharacter, asset);
	            } else if (asset.constant === assetConstants.ASSET_TYPE_ICON) {
	                returnAsset = appHelper.getIconAsset(asset);
	            } else if (asset.constant === assetConstants.ASSET_TYPE_IMAGE) {
	                returnAsset = appHelper.getImageAsset(asset);
	            } else if (asset.constant === assetConstants.ASSET_TYPE_LIBRARY_IMAGE) {
	                returnAsset = appHelper.getLibraryImageAsset(asset);
	            }
	            returnAsset = appHelper.isDefined(returnAsset.locale) ? appHelper.getLocalData(returnAsset) : returnAsset;
	
	            if (appHelper.isDefined(asset.constant) && !appHelper.isDefined(returnAsset.type)) {
	                returnAsset = Object.assign({}, returnAsset, {
	                    type: asset.constant
	                });
	            }
	
	            return returnAsset;
	        }
	    }, {
	        key: 'getImagePath',
	        value: function getImagePath(image) {
	            if (appConstants.DEVELOPMENT_MODE) {
	                if (appHelper.isDefined(image) && image.length > 0) {
	                    return __webpack_require__(16)("./" + image);
	                }
	            } else {
	                return image;
	            }
	        }
	    }, {
	        key: 'updateCharacterExpression',
	        value: function updateCharacterExpression(pose) {
	            if (appHelper.isDefined(pose) && pose.pose !== objectConstants.INHERIT) {
	                var characterAsset = appHelper.getCharacterPose(this.state.screenCharacter, pose);
	                if (appHelper.isDefined(characterAsset.src) && characterAsset.src.length > 0) {
	                    var characterRef = this.refs.character;
	                    characterRef.removeAttribute("style");
	                    _gsap.TweenLite.set(characterRef, { opacity: 0, '-webkit-filter': 'blur(5px)', 'filter': 'blur(5px)' });
	
	                    if (appHelper.isDefined(this.refs.prevCharacter)) {
	                        var prevCharacterRef = this.refs.prevCharacter;
	                        prevCharacterRef.removeAttribute("style");
	                        _gsap.TweenLite.set(prevCharacterRef, { opacity: 1, '-webkit-filter': 'blur(0px)', 'filter': 'blur(0px)' });
	                    }
	
	                    //if (characterAsset.src !== this.state.assets.character.src) {
	                    this.setState({
	                        assets: Object.assign({}, this.state.assets, {
	                            character: characterAsset,
	                            prevCharacter: this.state.assets.character
	
	                        }),
	                        updateCharacter: true
	                    });
	                }
	            }
	            //}
	        }
	    }, {
	        key: 'transitionCharacterExpressions',
	        value: function transitionCharacterExpressions() {
	            this.setState({ updateCharacter: false });
	            this.transitionPrevCharacter();
	            this.transitionCharacter();
	        }
	    }, {
	        key: 'transitionCharacter',
	        value: function transitionCharacter() {
	            var characterRef = this.refs.character;
	
	            _gsap.TweenLite.to(characterRef, 0.6, {
	                opacity: 1,
	                filter: 'blur(0px)',
	                ease: _gsap.Expo.easeOut
	            });
	        }
	    }, {
	        key: 'transitionPrevCharacter',
	        value: function transitionPrevCharacter() {
	            var characterRef = this.refs.prevCharacter;
	
	            _gsap.TweenLite.to(characterRef, 2, {
	                opacity: 0,
	
	                filter: 'blur(10px)',
	                ease: _gsap.Expo.easeOut
	            });
	        }
	    }, {
	        key: 'storeUserResponse',
	        value: function storeUserResponse(responseObj) {
	            var _this2 = this;
	
	            var params = Object.assign({}, responseObj, {
	                userData: this.props.userData,
	                bite_id: this.getBiteId(),
	                parent_screen_id: appHelper.isDefined(this.props.parentScreen) ? this.props.parentScreen.screen_id : undefined,
	                screen_id: this.getScreenId()
	
	            });
	
	            this.props.actions.storeUserResponse(params).then(function (userData) {
	                _this2.props.actions.setSuspendData(userData);
	            }).catch(function (error) {});
	        }
	    }, {
	        key: 'navigateToNextScreen',
	        value: function navigateToNextScreen() {
	            if (appHelper.isDefined(this.props.parentScreen)) {
	                if (appHelper.isDefined(this.props.closeDialog)) {
	                    this.props.closeDialog();
	                }
	                if (this.state.allowGoToScreen && !isNaN(parseInt(this.state.goToScreenId))) {
	                    this.goToScreen(this.state.goToScreenId);
	                } else if (this.state.terminateScreen) {
	                    var nextScreenId = appHelper.getNextScreenId(this.props.parentScreen.screen_id);
	                    if (localStorage.bites.length > 1 && nextScreenId.length === 0) {
	                        this.context.router.push('menu');
	                    } else {
	                        this.props.actions.setNextLessonLocation(nextScreenId);
	                    }
	                } else if (this.state.terminateBite) {
	                    if (localStorage.bites.length > 1) {
	                        this.context.router.push('menu');
	                    } else {
	                        var bite = appHelper.getBiteById(this.props.biteCallbacks.getBiteId());
	                        this.goToScreen(bite.screens[0].screen_id);
	                    }
	                } else {
	                    this.props.biteCallbacks.goToNextSubScreen(this.state.screen);
	                }
	            } else {
	                if (this.state.allowGoToScreen && !isNaN(parseInt(this.state.goToScreenId))) {
	                    this.goToScreen(this.state.goToScreenId);
	                } else if (this.state.terminateBite) {
	                    if (localStorage.bites.length > 1) {
	                        this.context.router.push('menu');
	                    } else {
	                        var _bite = appHelper.getBiteById(this.props.biteCallbacks.getBiteId());
	                        this.goToScreen(_bite.screens[0].screen_id);
	                    }
	                } else {
	                    var _nextScreenId = appHelper.getNextScreenId(this.getScreenId());
	                    if (localStorage.bites.length > 1 && _nextScreenId.length === 0) {
	                        this.context.router.push('menu');
	                    } else {
	                        this.props.actions.setNextLessonLocation(this.getScreenId());
	                    }
	                }
	            }
	        }
	    }, {
	        key: 'goToScreen',
	        value: function goToScreen(goTo) {
	            this.props.actions.setNewLessonLocation(goTo);
	        }
	    }, {
	        key: 'handleObjectProgression',
	        value: function handleObjectProgression() {}
	    }, {
	        key: 'onObjectRendered',
	        value: function onObjectRendered() {
	            if (this.state.currentObjectIndex < this.state.screen.objects.length - 1) {
	                var newIndex = this.state.currentObjectIndex + 1;
	                this.setState({ currentObjectIndex: newIndex });
	                this.getObject(newIndex);
	
	                //this.updateResourceObjectResult(completionData);
	            } else {
	                    // this.updateResourceObjectResult(completionData);
	                }
	        }
	    }, {
	        key: 'onObjectComplete',
	        value: function onObjectComplete(completionData) {
	
	            this.updateResourceObjectResult(completionData);
	        }
	    }, {
	        key: 'updateScreenResults',
	        value: function updateScreenResults(completionData) {
	            var _this3 = this;
	
	            var params = Object.assign({}, completionData, {
	                bite_id: this.getBiteId(),
	                parent_screen_id: appHelper.isDefined(this.props.parentScreen) ? this.props.parentScreen.screen_id : undefined,
	                screen_id: this.getScreenId(),
	                object_status: completionData.status,
	                object_result: {}
	            });
	
	            this.props.actions.updateScreenResults(params).then(function (userData) {
	                if (appHelper.isDefined(completionData.sub_screen_complete) && completionData.sub_screen_complete) {
	                    _this3.props.biteCallbacks.onSubScreenComplete(_this3.state.screen);
	                }
	                _this3.props.actions.setSuspendData(userData).then(function (trackingData) {
	
	                    if (completionData.screen_status === objectConstants.STATUS_COMPLETE) {
	                        _this3.props.actions.setScreenComplete(_this3.state.screen);
	                    }
	                }).catch(function (error) {});
	            }).catch(function (error) {});
	        }
	    }, {
	        key: 'updateResourceObjectResult',
	        value: function updateResourceObjectResult(completionData) {
	            var _this4 = this;
	
	            var params = Object.assign({}, completionData, {
	                screen_id: this.getScreenId(),
	                object_status: completionData.status
	
	            });
	            this.props.actions.updateResourceObjectResult(params).then(function (userData) {
	                _this4.props.actions.setSuspendData(userData).then(function (trackingData) {
	                    var resourceScreen = appHelper.getArrayObjectByKey(userData.resources, "screen_id", _this4.state.screen.screen_id);
	                    if (resourceScreen.status === objectConstants.STATUS_COMPLETE) {
	                        if (completionData.screen_status === objectConstants.STATUS_COMPLETE) {
	                            _this4.props.actions.setScreenComplete(_this4.state.screen);
	                        }
	                    }
	                }).catch(function (error) {});
	            }).catch(function (error) {});
	        }
	    }, {
	        key: 'updateResourceScreenResult',
	        value: function updateResourceScreenResult(completionData) {
	            var _this5 = this;
	
	            var params = Object.assign({}, completionData, {
	                screen_id: this.getScreenId(),
	                object_status: completionData.status,
	                screen_status: objectConstants.STATUS_COMPLETE
	            });
	            this.props.actions.updateResourceScreenResult(params).then(function (userData) {
	                _this5.props.actions.setSuspendData(userData).then(function (trackingData) {
	                    if (completionData.screen_status === objectConstants.STATUS_COMPLETE) {
	                        _this5.props.actions.setScreenComplete(_this5.state.screen);
	                    }
	                }).catch(function (error) {});
	            }).catch(function (error) {});
	        }
	    }, {
	        key: 'showProgressionButton',
	        value: function showProgressionButton() {
	            var nextScreenId = appHelper.getNextScreenId(this.state.screen.screen_id);
	            //if (nextScreenId.length > 0) {
	            this.setState({ showProgression: true });
	            //}
	        }
	    }, {
	        key: 'scrollTo',
	        value: function scrollTo(pos) {
	            if (this.state.status !== objectConstants.STATUS_COMPLETE) {
	                var feed = this.refs[this.state.screen.screen_id + '_feed'];
	                _gsap.TweenLite.to(feed, 0.5, {
	                    scrollTop: pos,
	                    ease: _gsap.Expo.easeInOut
	                }).eventCallback("onComplete", this.onScrollComplete);
	            }
	        }
	    }, {
	        key: 'onContinueBtnReveled',
	        value: function onContinueBtnReveled() {
	            this.scrollToTop();
	        }
	    }, {
	        key: 'scrollToTop',
	        value: function scrollToTop() {
	            if (this.state.status !== objectConstants.STATUS_COMPLETE) {
	                var anchor = this.refs[this.state.screen.screen_id + '_bottom_anchor'];
	                var scrollTo = this.scrollTo;
	                setTimeout(function () {
	                    scrollTo(anchor.offsetTop);
	                }, 1000);
	            }
	        }
	    }, {
	        key: 'onScrollComplete',
	        value: function onScrollComplete() {}
	    }, {
	        key: 'hasNextObject',
	        value: function hasNextObject(object) {
	            var objectIndex = appHelper.getArrayObjectIndexByKey(this.state.screen.objects, "asset_id", object.asset_id);
	            return objectIndex < this.state.screen.objects.length - 1;
	        }
	    }, {
	        key: 'getLayoutClass',
	        value: function getLayoutClass() {
	            if (appHelper.isDefined(this.state.screen.assets.left) && this.state.screenIsReady) {
	                return 'left-asset-screen';
	            } else if (appHelper.isDefined(this.state.screen.assets.right) && this.state.screenIsReady) {
	                return 'right-asset-screen';
	            } else {
	                return 'full-screen';
	            }
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this6 = this;
	
	            return _react2.default.createElement(
	                'div',
	                { className: 'content-screen' },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'background-container' },
	                    !appHelper.isDefined(this.props.parentScreen) && !this.state.is_resource_screen ? _react2.default.createElement('img', { src: this.getImagePath(this.state.assets.background.src), alt: '' }) : null
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'screen-container' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'content-wrapper', id: this.state.screen.screen_id + '_feed_id', ref: this.state.screen.screen_id + '_feed' },
	                        appHelper.isDefined(this.state.screen.assets.left) && appHelper.isDefined(this.state.assets.screenAsset) && this.state.assets.screenAsset.src.length > 0 && this.state.screenIsReady ? _react2.default.createElement(
	                            'div',
	                            { className: 'asset-col-left' },
	                            this.state.assets.screenAsset.type === assetConstants.ASSET_TYPE_IMAGE || this.state.assets.screenAsset.type === assetConstants.ASSET_TYPE_LIBRARY_IMAGE ? this.state.assets.screenAsset.type === assetConstants.ASSET_TYPE_IMAGE ? _react2.default.createElement(_SecondaryImage2.default, { screenObject: this.state.screen.assets.left }) : _react2.default.createElement(_SecondaryLibraryImage2.default, { screenObject: this.state.screen.assets.left }) : _react2.default.createElement('img', { src: this.getImagePath(this.state.assets.screenAsset.src), alt: '' })
	                        ) : null,
	                        _react2.default.createElement(
	                            'div',
	                            { className: this.getLayoutClass() + ' ', role: 'feed' },
	                            this.state.producerNotes.length > 0 ? _react2.default.createElement(_ProducerNotes2.default, { notes: this.state.producerNotes, screen_id: this.state.screen.screen_id }) : null,
	                            this.state.screenIsReady && this.state.renderedObjects.length > 0 ? this.state.renderedObjects.map(function (object, index) {
	                                return _react2.default.createElement(
	                                    'div',
	                                    { className: 'feed-object-container', key: index, role: 'article', tabIndex: '0', id: 'object_' + object.data.asset_id },
	                                    _react2.default.createElement(object.component, { screenObject: object.data, callbacks: _this6.state.callbacks, index: index })
	                                );
	                            }) : null,
	                            !this.state.screenIsReady ? _react2.default.createElement(_NotReadyYet2.default, { screen_id: this.state.screen.screen_id }) : null,
	                            this.state.showProgression ? _react2.default.createElement(_Button2.default, { ref: this.state.screen.screen_id + '_button',
	                                label: this.state.continue_label,
	                                id: this.state.screen.screen_id + '_button',
	                                onClick: this.navigateToNextScreen,
	                                onRevealed: this.onContinueBtnReveled
	                            }) : null,
	                            _react2.default.createElement('div', { ref: this.state.screen.screen_id + '_bottom_anchor' })
	                        ),
	                        appHelper.isDefined(this.state.screen.assets.right) && appHelper.isDefined(this.state.assets.screenAsset) && this.state.assets.screenAsset.src.length > 0 && this.state.screenIsReady ? _react2.default.createElement(
	                            'div',
	                            { className: 'asset-col-right' },
	                            this.state.assets.screenAsset.type === assetConstants.ASSET_TYPE_IMAGE || this.state.assets.screenAsset.type === assetConstants.ASSET_TYPE_LIBRARY_IMAGE ? this.state.assets.screenAsset.type === assetConstants.ASSET_TYPE_IMAGE ? _react2.default.createElement(_SecondaryImage2.default, { screenObject: this.state.screen.assets.right }) : _react2.default.createElement(_SecondaryLibraryImage2.default, { screenObject: this.state.screen.assets.right }) : _react2.default.createElement('img', { src: this.getImagePath(this.state.assets.screenAsset.src), alt: '' })
	                        ) : null
	                    )
	                )
	            );
	        }
	    }]);
	
	    return ResourcesScrollScreen;
	}(_react2.default.Component);
	
	ResourcesScrollScreen.propTypes = {
	    screen: _propTypes2.default.object.isRequired,
	    biteCallbacks: _propTypes2.default.object.isRequired,
	    parentScreen: _propTypes2.default.object,
	    contentData: _propTypes2.default.object.isRequired,
	    trackingData: _propTypes2.default.object.isRequired,
	    userData: _propTypes2.default.object.isRequired,
	    actions: _propTypes2.default.object.isRequired,
	    audio: _propTypes2.default.object.isRequired,
	    lang: _propTypes2.default.string.isRequired,
	    closeDialog: _propTypes2.default.func
	};
	
	ResourcesScrollScreen.contextTypes = {
	    router: _propTypes2.default.object
	};
	
	function mapStateToProps(state, ownProps) {
	    var lang = state.userData.lang;
	    return {
	        lang: lang,
	        contentData: state.contentData,
	        trackingData: state.trackingData,
	        userData: state.userData,
	        audio: state.audio
	    };
	}
	
	function mapDispatchToProps(dispatch) {
	    return {
	        actions: (0, _redux.bindActionCreators)(Object.assign({}, appDataActions, trackingDataActions, userDataActions), dispatch)
	    };
	}
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(ResourcesScrollScreen);

/***/ },
/* 541 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(5);
	
	var _redux = __webpack_require__(4);
	
	var _Button = __webpack_require__(18);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _ProducerNotes = __webpack_require__(85);
	
	var _ProducerNotes2 = _interopRequireDefault(_ProducerNotes);
	
	var _NotReadyYet = __webpack_require__(84);
	
	var _NotReadyYet2 = _interopRequireDefault(_NotReadyYet);
	
	var _trackingDataActions = __webpack_require__(7);
	
	var trackingDataActions = _interopRequireWildcard(_trackingDataActions);
	
	var _appDataActions = __webpack_require__(12);
	
	var appDataActions = _interopRequireWildcard(_appDataActions);
	
	var _userDataActions = __webpack_require__(20);
	
	var userDataActions = _interopRequireWildcard(_userDataActions);
	
	var _appHelper = __webpack_require__(3);
	
	var appHelper = _interopRequireWildcard(_appHelper);
	
	var _dataHelper = __webpack_require__(11);
	
	var dataHelper = _interopRequireWildcard(_dataHelper);
	
	var _componentHelper = __webpack_require__(31);
	
	var _userDataHelper = __webpack_require__(15);
	
	var userDataHelper = _interopRequireWildcard(_userDataHelper);
	
	var _environmentHelper = __webpack_require__(56);
	
	var enviromentHelper = _interopRequireWildcard(_environmentHelper);
	
	var _appConstants = __webpack_require__(13);
	
	var appConstants = _interopRequireWildcard(_appConstants);
	
	var _objectConstants = __webpack_require__(9);
	
	var objectConstants = _interopRequireWildcard(_objectConstants);
	
	var _componentConstants = __webpack_require__(49);
	
	var componentConstants = _interopRequireWildcard(_componentConstants);
	
	var _localStorage = __webpack_require__(17);
	
	var localStorage = _interopRequireWildcard(_localStorage);
	
	var _gsap = __webpack_require__(8);
	
	var _gsapReactPlugin = __webpack_require__(10);
	
	var _gsapReactPlugin2 = _interopRequireDefault(_gsapReactPlugin);
	
	var _lodash = __webpack_require__(28);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } //eslint-disable-line import/no-named-as-default
	
	
	var ScenarioScreen = function (_React$Component) {
	    _inherits(ScenarioScreen, _React$Component);
	
	    function ScenarioScreen(props, context) {
	        _classCallCheck(this, ScenarioScreen);
	
	        var _this = _possibleConstructorReturn(this, (ScenarioScreen.__proto__ || Object.getPrototypeOf(ScenarioScreen)).call(this, props, context));
	
	        _this.state = {
	            lang: _this.props.lang,
	            screen: _this.props.screen,
	            userData: _this.props.userData,
	            env: enviromentHelper.getEnvironment(),
	            locale: {},
	            status: objectConstants.STATUS_NOT_STARTED,
	            initialStatus: "",
	            multiPath: appHelper.isDefined(_this.props.screen.multi_path) ? _this.props.screen.multi_path : { enabled: false },
	            allowReviewMode: true,
	            reviewMode: false,
	            propsUpdated: false,
	            renderedObjects: [],
	            updateCharacter: false,
	            screenCharacter: {},
	            assets: {
	                background: {
	                    src: "",
	                    type: "",
	                    type_id: ""
	                },
	                character: {
	                    src: "",
	                    pose: "",
	                    position: ""
	                },
	                prevCharacter: {
	                    src: "",
	                    pose: "",
	                    position: ""
	                }
	            },
	
	            parentBackground: {
	                src: "",
	                type: "",
	                type_id: ""
	            },
	            callbacks: {
	                updateCharacterExpression: null,
	                onObjectComplete: null
	            },
	            currentObjectIndex: 0,
	            showProgression: false,
	            allowGoToScreen: false,
	            goToScreenId: 0,
	            terminateScreen: false,
	            terminateBite: false,
	            producerNotes: appHelper.getScreenNotes(_this.props.parentScreen, _this.props.screen),
	            screenIsReady: _this.props.screen.objects.length > 0 && (appHelper.canSeeContent(_this.props.screen) || appHelper.isDefined(_this.props.parentScreen)),
	            allowClippedBlurEffect: appHelper.allowClippedBlurEffect(),
	            allowBlur: dataHelper.cssPropertyValueSupported('filter', 'blur(3px)'),
	            allowScroll: false,
	            hasReceivedFocus: false,
	            focusOnNextObject: false,
	            scrollHeight: 0,
	            continue_label: appHelper.getLocaleString("continue_label")
	        };
	        _this.getLocale = _this.getLocale.bind(_this);
	        _this.getObject = _this.getObject.bind(_this);
	
	        _this.getScreenId = _this.getScreenId.bind(_this);
	        _this.getBiteId = _this.getBiteId.bind(_this);
	        _this.isReviewMode = _this.isReviewMode.bind(_this);
	        _this.getImagePath = _this.getImagePath.bind(_this);
	        _this.getAssets = _this.getAssets.bind(_this);
	        _this.storeUserResponse = _this.storeUserResponse.bind(_this);
	        _this.setCallbacks = _this.setCallbacks.bind(_this);
	        _this.updateCharacterExpression = _this.updateCharacterExpression.bind(_this);
	        _this.onObjectComplete = _this.onObjectComplete.bind(_this);
	        _this.updateScreenResults = _lodash2.default.debounce(_this.updateScreenResults.bind(_this), 300);
	        _this.setScreenAccessed = _lodash2.default.debounce(_this.setScreenAccessed.bind(_this), 300);
	        _this.showProgressionButton = _this.showProgressionButton.bind(_this);
	        _this.navigateToNextScreen = _this.navigateToNextScreen.bind(_this);
	        _this.scrollTo = _this.scrollTo.bind(_this);
	        _this.onScrollComplete = _this.onScrollComplete.bind(_this);
	        _this.onContinueBtnReveled = _this.onContinueBtnReveled.bind(_this);
	        _this.scrollToTop = _this.scrollToTop.bind(_this);
	        _this.checkScreenStatus = _this.checkScreenStatus.bind(_this);
	        _this.setReviewMode = _this.setReviewMode.bind(_this);
	        _this.renderAllObjects = _this.renderAllObjects.bind(_this);
	        _this.transitionCharacterExpressions = _this.transitionCharacterExpressions.bind(_this);
	        _this.transitionCharacter = _this.transitionCharacter.bind(_this);
	        _this.transitionPrevCharacter = _this.transitionPrevCharacter.bind(_this);
	        _this.goToScreen = _this.goToScreen.bind(_this);
	        //new
	        _this.getCharacterName = _this.getCharacterName.bind(_this);
	        _this.handleObjectProgression = _this.handleObjectProgression.bind(_this);
	        _this.hasNextObject = _this.hasNextObject.bind(_this);
	        _this.getScreenStatus = _this.getScreenStatus.bind(_this);
	        _this.getSubScreenParent = _this.getSubScreenParent.bind(_this);
	        _this.setScreenNotReadyYet = _this.setScreenNotReadyYet.bind(_this);
	        _this.getFeedClass = _this.getFeedClass.bind(_this);
	        _this.getPanelStyle = _this.getPanelStyle.bind(_this);
	        _this.scrollToOnComplete = _this.scrollToOnComplete.bind(_this);
	        _this.setFocusRecieved = _this.setFocusRecieved.bind(_this);
	        _this.focusOnNext = _this.focusOnNext.bind(_this);
	        _this.setScrollHeight = _this.setScrollHeight.bind(_this);
	        _this.resizeWatcher = _this.resizeWatcher.bind(_this);
	        _this.allowInheritParentPanelStyle = _this.allowInheritParentPanelStyle.bind(_this);
	        _this.goToMenu = _this.goToMenu.bind(_this);
	        _this.handleContinue = _this.handleContinue.bind(_this);
	
	        return _this;
	    }
	
	    _createClass(ScenarioScreen, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            window.addEventListener("resize", this.resizeWatcher);
	            this.setScreenAccessed();
	            if (this.props.audio.audioRef.length > 0) {
	                this.props.actions.clearAudio();
	            }
	
	            this.props.biteCallbacks.showHeader(true);
	            this.setCallbacks();
	            this.getLocale();
	            if (this.state.screenIsReady) {
	                var getObject = this.getObject;
	                var currentObjectIndex = this.state.currentObjectIndex;
	
	                setTimeout(function () {
	                    getObject(currentObjectIndex);
	                }, 100);
	                // this.getObject(this.state.currentObjectIndex);
	            } else {
	                this.setScreenNotReadyYet();
	            }
	            this.getAssets();
	            this.checkScreenStatus();
	        }
	    }, {
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(nextProps) {
	            var screenUserData = {};
	            if (!this.props.parentScreen) {
	                screenUserData = userDataHelper.getScreenUserData(nextProps.userData, this.state.screen.screen_id);
	            } else {
	                screenUserData = userDataHelper.getSubScreenUserData(nextProps.userData, this.props.parentScreen.screen_id, this.state.screen.screen_id);
	            }
	
	            this.setState({ userData: Object.assign({}, nextProps.userData) });
	
	            if (this.state.status !== screenUserData.status && screenUserData.status === objectConstants.STATUS_COMPLETE) {
	                this.setState({
	                    status: screenUserData.status
	                });
	            }
	            if (this.state.lang !== nextProps.lang) {
	                this.setState({
	                    lang: nextProps.lang,
	                    locale: appHelper.getLocalData(this.state.screen),
	                    continue_label: appHelper.getLocaleString("continue_label")
	                });
	                if (!appHelper.isDefined(this.props.parentScreen)) {
	                    this.props.actions.setScreenTitle(appHelper.getLocalData(this.state.screen).title);
	                }
	            }
	        }
	    }, {
	        key: 'componentDidUpdate',
	        value: function componentDidUpdate() {
	            var setScrollHeight = this.setScrollHeight;
	            setTimeout(function () {
	                setScrollHeight();
	            }, 500);
	
	            if (this.state.propsUpdated && this.state.reviewMode && this.state.allowReviewMode) {
	                this.setReviewMode();
	            }
	
	            if (this.state.updateCharacter) {
	
	                this.transitionCharacterExpressions();
	            }
	
	            if (this.state.focusOnNextObject) {
	                this.focusOnNext();
	            }
	        }
	    }, {
	        key: 'componentWillUnmount',
	        value: function componentWillUnmount() {
	            this.props.actions.clearAudio();
	            window.removeEventListener("resize", this.resizeWatcher);
	        }
	    }, {
	        key: 'setScreenAccessed',
	        value: function setScreenAccessed() {
	            this.props.actions.setScreenAccessed(this.state.screen, this.props.parentScreen);
	        }
	    }, {
	        key: 'resizeWatcher',
	        value: function resizeWatcher() {
	            var scrollContainer = this.refs[this.state.screen.screen_id + '_feedContainer'];
	            this.setState({ scrollHeight: 0 });
	        }
	    }, {
	        key: 'setScreenNotReadyYet',
	        value: function setScreenNotReadyYet() {
	            var completionData = {
	                screen_status: objectConstants.STATUS_COMPLETE,
	                sub_screen_complete: appHelper.isDefined(this.props.parentScreen) ? true : undefined
	            };
	
	            this.showProgressionButton();
	
	            this.updateScreenResults(completionData);
	        }
	    }, {
	        key: 'checkScreenStatus',
	        value: function checkScreenStatus() {
	            var screenUserData = {};
	            if (!this.props.parentScreen) {
	                screenUserData = userDataHelper.getScreenUserData(this.state.userData, this.state.screen.screen_id);
	            } else {
	                screenUserData = userDataHelper.getSubScreenUserData(this.state.userData, this.props.parentScreen.screen_id, this.state.screen.screen_id);
	            }
	            if (this.state.status !== screenUserData.status && screenUserData.status === objectConstants.STATUS_COMPLETE) {
	                this.setState({
	                    status: screenUserData.status
	                });
	            }
	
	            this.setState({
	                initialStatus: this.state.initialStatus.length === 0 ? screenUserData.status : this.state.initialStatus
	            });
	            /* let screenStatus = getScreenUserData(this.props.userData, this.props.screen.screen_id).status;
	             let reviewMode = screenStatus === objectConstants.STATUS_COMPLETE && localStorage.post_completion_mode === appConstants.POST_COMPLETION_MODE_REVIEW;
	            // console.log(`reviewMode: ${this.state.reviewMode} - line 120`);
	             this.setState({status: screenStatus, checkCompletionStatus: true, reviewMode: reviewMode, propsUpdated: true});
	             */
	        }
	    }, {
	        key: 'setCallbacks',
	        value: function setCallbacks() {
	            //console.log(`reviewMode: ${this.state.reviewMode} - line 125`);
	            this.setState({
	                callbacks: Object.assign({}, this.state.biteCallbacks, {
	                    updateCharacterExpression: this.updateCharacterExpression,
	                    onObjectComplete: this.onObjectComplete,
	                    getScreenId: this.getScreenId,
	                    getBiteId: this.getBiteId,
	                    storeUserResponse: this.storeUserResponse,
	                    scrollTo: this.scrollTo,
	                    isReviewMode: this.isReviewMode,
	                    getCharacterName: this.getCharacterName,
	                    hasNextObject: this.hasNextObject,
	                    navigateToNextScreen: this.navigateToNextScreen,
	                    getScreenStatus: this.getScreenStatus,
	                    getSubScreenParent: this.getSubScreenParent,
	                    goToScreen: this.goToScreen,
	                    resizeWatcher: this.resizeWatcher
	
	                })
	            });
	        }
	    }, {
	        key: 'getSubScreenParent',
	        value: function getSubScreenParent() {
	            return appHelper.isDefined(this.props.parentScreen) ? this.props.parentScreen : undefined;
	        }
	    }, {
	        key: 'getLocale',
	        value: function getLocale() {
	            var locale = appHelper.getLocalData(this.state.screen);
	            this.setState({ locale: Object.assign({}, locale) });
	            if (!appHelper.isDefined(this.props.parentScreen)) {
	                this.props.actions.setScreenTitle(locale.title);
	            }
	        }
	    }, {
	        key: 'getScreenId',
	        value: function getScreenId() {
	            return this.state.screen.screen_id;
	        }
	    }, {
	        key: 'getBiteId',
	        value: function getBiteId() {
	            return this.props.biteCallbacks.getBiteId();
	        }
	    }, {
	        key: 'isReviewMode',
	        value: function isReviewMode() {
	            return this.state.reviewMode;
	        }
	    }, {
	        key: 'getCharacterName',
	        value: function getCharacterName() {
	            return this.state.locale.character_name;
	        }
	    }, {
	        key: 'getScreenStatus',
	        value: function getScreenStatus() {
	            return this.state.status;
	        }
	    }, {
	        key: 'setReviewMode',
	        value: function setReviewMode() {
	
	            var objectsToRender = appHelper.getRenderableObjects(this.props.userData, this.getBiteId(), this.state.screen.objects);
	            this.setState({
	                screen: Object.assign({}, this.state.screen, {
	                    objects: Object.assign([], objectsToRender)
	                }),
	                propsUpdated: false
	            });
	            this.renderAllObjects(objectsToRender);
	        }
	    }, {
	        key: 'renderAllObjects',
	        value: function renderAllObjects(objectsToRender) {
	            var renderableObjects = [];
	            for (var i = 0; i < objectsToRender.length; i++) {
	                var object = objectsToRender[i];
	                var objectType = Object.assign({}, (0, _componentHelper.getAssetComponentByType)(object.asset_type_code), {
	                    data: object
	                });
	                renderableObjects = dataHelper.immutablePush(renderableObjects, objectType);
	            }
	            this.setState({ renderedObjects: Object.assign([], renderableObjects), showProgression: true });
	        }
	    }, {
	        key: 'getObject',
	        value: function getObject(index) {
	            var object = this.state.screen.objects[index];
	            var objectType = Object.assign({}, (0, _componentHelper.getAssetComponentByType)(object.asset_type_code), {
	                data: object
	            });
	            //console.log(objectType);
	            //let objectLocale = appHelper.getLocalData(object.locale);
	            //this.props.actions.setScreenTitle(objectLocale.title);
	            this.setState({
	                renderedObjects: Object.assign([], dataHelper.immutablePush(this.state.renderedObjects, objectType)),
	                focusOnNextObject: this.state.hasReceivedFocus
	            });
	        }
	    }, {
	        key: 'getAssets',
	        value: function getAssets() {
	            var backgroundAsset = Object.assign(this.state.assets.background);
	            var screenCharacter = {};
	            var characterAsset = Object.assign(this.state.assets.character);
	            var parentBackground = Object.assign(this.state.parentBackground);
	
	            if (appHelper.isDefined(this.state.screen.assets.background) && !appHelper.isDefined(this.props.parentScreen)) {
	                backgroundAsset = appHelper.getBackgroundAsset(this.state.screen.assets.background);
	            }
	
	            if (appHelper.isDefined(this.state.screen.assets.character)) {
	                screenCharacter = appHelper.getCharacterAsset(this.state.screen.assets.character);
	                characterAsset = appHelper.getCharacterPose(screenCharacter, this.state.screen.assets.character);
	            }
	            if (appHelper.isDefined(this.refs.character)) {
	                var characterRef = this.refs.character;
	                characterRef.removeAttribute("style");
	                if (this.state.allowBlur) {
	                    _gsap.TweenLite.set(characterRef, { opacity: 0, '-webkit-filter': 'blur(5px)', 'filter': 'blur(5px)' });
	                } else {
	                    _gsap.TweenLite.set(characterRef, { opacity: 0 });
	                }
	            }
	            if (appHelper.isDefined(this.refs.prevCharacter)) {
	                var prevCharacterRef = this.refs.prevCharacter;
	                prevCharacterRef.removeAttribute("style");
	                if (this.state.allowBlur) {
	                    _gsap.TweenLite.set(prevCharacterRef, { opacity: 1, '-webkit-filter': 'blur(0px)', 'filter': 'blur(0px)' });
	                } else {
	                    _gsap.TweenLite.set(prevCharacterRef, { opacity: 1 });
	                }
	            }
	
	            if (appHelper.isDefined(this.props.parentScreen) && appHelper.isDefined(this.props.parentScreen.assets.background)) {
	                parentBackground = appHelper.getBackgroundAsset(this.props.parentScreen.assets.background);
	            }
	
	            //console.log(characterAsset);
	
	            this.setState({
	                screenCharacter: Object.assign({}, screenCharacter),
	                assets: Object.assign({}, this.state.assets, {
	                    background: backgroundAsset,
	                    character: characterAsset,
	                    prevCharacter: characterAsset
	                }),
	                parentBackground: Object.assign({}, parentBackground)
	            });
	        }
	    }, {
	        key: 'getImagePath',
	        value: function getImagePath(image) {
	            if (appConstants.DEVELOPMENT_MODE) {
	                if (appHelper.isDefined(image) && image.length > 0) {
	                    return __webpack_require__(16)("./" + image);
	                }
	            } else {
	                return image;
	            }
	        }
	    }, {
	        key: 'updateCharacterExpression',
	        value: function updateCharacterExpression(pose) {
	            if (appHelper.isDefined(pose) && pose.pose !== objectConstants.INHERIT) {
	                var characterAsset = appHelper.getCharacterPose(this.state.screenCharacter, pose);
	                if (appHelper.isDefined(characterAsset.src) && characterAsset.src.length > 0) {
	                    var characterRef = this.refs.character;
	                    characterRef.removeAttribute("style");
	                    if (this.state.allowBlur) {
	                        _gsap.TweenLite.set(characterRef, { opacity: 0, '-webkit-filter': 'blur(5px)', 'filter': 'blur(5px)' });
	                    } else {
	                        _gsap.TweenLite.set(characterRef, { opacity: 0 });
	                    }
	                    if (appHelper.isDefined(this.refs.prevCharacter)) {
	                        var prevCharacterRef = this.refs.prevCharacter;
	                        prevCharacterRef.removeAttribute("style");
	                        if (this.state.allowBlur) {
	                            _gsap.TweenLite.set(prevCharacterRef, {
	                                opacity: 1,
	                                '-webkit-filter': 'blur(0px)',
	                                'filter': 'blur(0px)'
	                            });
	                        } else {
	                            _gsap.TweenLite.set(prevCharacterRef, { opacity: 1 });
	                        }
	                    }
	                    //if (characterAsset.src !== this.state.assets.character.src) {
	                    this.setState({
	                        assets: Object.assign({}, this.state.assets, {
	                            character: characterAsset,
	                            prevCharacter: this.state.assets.character
	
	                        }),
	                        updateCharacter: true
	                    });
	                }
	            }
	            //}
	        }
	    }, {
	        key: 'transitionCharacterExpressions',
	        value: function transitionCharacterExpressions() {
	            this.setState({ updateCharacter: false });
	            this.transitionPrevCharacter();
	            this.transitionCharacter();
	        }
	    }, {
	        key: 'transitionCharacter',
	        value: function transitionCharacter() {
	            var characterRef = this.refs.character;
	            if (this.state.allowBlur) {
	                _gsap.TweenLite.to(characterRef, 0.6, {
	                    opacity: 1,
	                    filter: 'blur(0px)',
	                    ease: _gsap.Expo.easeOut
	                });
	            } else {
	                _gsap.TweenLite.set(characterRef, { opacity: 1 });
	            }
	        }
	    }, {
	        key: 'transitionPrevCharacter',
	        value: function transitionPrevCharacter() {
	            var characterRef = this.refs.prevCharacter;
	            if (this.state.allowBlur) {
	                _gsap.TweenLite.to(characterRef, 2, {
	                    opacity: 0,
	
	                    filter: 'blur(10px)',
	                    ease: _gsap.Expo.easeOut
	                });
	            } else {
	                _gsap.TweenLite.set(characterRef, { opacity: 0 });
	            }
	        }
	
	        // storeUserResponse(asset_id, selectedOptions, kpis) {
	
	    }, {
	        key: 'storeUserResponse',
	        value: function storeUserResponse(responseObj) {
	            var _this2 = this;
	
	            //console.log('scroll screen - storeUserResponse');
	            var params = Object.assign({}, responseObj, {
	                userData: this.props.userData,
	                bite_id: this.getBiteId(),
	                parent_screen_id: appHelper.isDefined(this.props.parentScreen) ? this.props.parentScreen.screen_id : undefined,
	                screen_id: this.getScreenId()
	
	            });
	
	            //console.log(params);
	            this.props.actions.storeUserResponse(params).then(function (userData) {
	                _this2.props.actions.setSuspendData(userData);
	            }).catch(function (error) {});
	        }
	    }, {
	        key: 'navigateToNextScreen',
	        value: function navigateToNextScreen() {
	            var goToMenu = this.goToMenu;
	            if (appHelper.isDefined(this.props.parentScreen)) {
	                if (appHelper.isDefined(this.props.closeDialog)) {
	                    this.props.closeDialog();
	                }
	                if (this.state.allowGoToScreen && !isNaN(parseInt(this.state.goToScreenId)) && appHelper.screenExists(this.state.goToScreenId)) {
	                    this.goToScreen(this.state.goToScreenId);
	                } else if (this.state.terminateScreen) {
	                    var nextScreenId = appHelper.getNextScreenId(this.props.parentScreen.screen_id);
	                    if (localStorage.bites.length > 1 && nextScreenId.length === 0) {
	                        setTimeout(function () {
	                            goToMenu();
	                        }, 500);
	                    } else {
	                        this.props.actions.setNextLessonLocation(nextScreenId);
	                    }
	                } else if (this.state.terminateBite) {
	                    if (localStorage.bites.length > 1) {
	                        setTimeout(function () {
	                            goToMenu();
	                        }, 500);
	                    } else {
	                        var bite = appHelper.getBiteById(this.props.biteCallbacks.getBiteId());
	                        this.goToScreen(bite.screens[0].screen_id);
	                    }
	                } else {
	                    var hasNextSubScreen = this.props.biteCallbacks.hasNextSubScreen(this.state.screen);
	                    if (hasNextSubScreen) {
	                        this.props.biteCallbacks.goToNextSubScreen(this.state.screen);
	                    } else {
	                        var _nextScreenId = appHelper.getNextScreenId(this.props.parentScreen.screen_id);
	                        if (localStorage.bites.length > 1 && _nextScreenId.length === 0) {
	                            if (appHelper.isDefined(this.props.parentScreen.progression) && (this.props.parentScreen.progression === objectConstants.PROGRESSION_TYPE_OPEN || this.props.parentScreen.progression === objectConstants.PROGRESSION_TYPE_EXPLORE_INTERESTS) && appHelper.isDefined(this.props.closeDialog)) {
	                                return false;
	                            } else {
	                                setTimeout(function () {
	                                    goToMenu();
	                                }, 500);
	                            }
	                        } else {
	                            if (appHelper.isDefined(this.props.parentScreen.progression) && (this.props.parentScreen.progression === objectConstants.PROGRESSION_TYPE_OPEN || this.props.parentScreen.progression === objectConstants.PROGRESSION_TYPE_EXPLORE_INTERESTS) && appHelper.isDefined(this.props.closeDialog)) {
	                                return false;
	                            } else {
	                                var goToScreen = this.goToScreen;
	                                setTimeout(function () {
	                                    goToScreen(_nextScreenId);
	                                }, 500);
	                            }
	                        }
	                    }
	                }
	            } else {
	                if (this.state.allowGoToScreen && !isNaN(parseInt(this.state.goToScreenId)) && appHelper.screenExists(this.state.goToScreenId)) {
	                    this.goToScreen(this.state.goToScreenId);
	                } else if (this.state.terminateBite) {
	                    if (localStorage.bites.length > 1) {
	                        setTimeout(function () {
	                            goToMenu();
	                        }, 500);
	                    } else {
	                        var _bite = appHelper.getBiteById(this.props.biteCallbacks.getBiteId());
	                        this.goToScreen(_bite.screens[0].screen_id);
	                    }
	                } else {
	                    var _nextScreenId2 = appHelper.getNextScreenId(this.getScreenId());
	                    if (localStorage.bites.length > 1 && _nextScreenId2.length === 0) {
	                        setTimeout(function () {
	                            goToMenu();
	                        }, 500);
	                    } else {
	                        this.goToScreen(_nextScreenId2);
	                    }
	                }
	            }
	        }
	    }, {
	        key: 'goToMenu',
	        value: function goToMenu() {
	            this.context.router.push('menu');
	        }
	    }, {
	        key: 'goToScreen',
	        value: function goToScreen(goTo) {
	            this.props.actions.setNewLessonLocation(goTo);
	        }
	    }, {
	        key: 'handleObjectProgression',
	        value: function handleObjectProgression() {}
	    }, {
	        key: 'handleContinue',
	        value: function handleContinue(completionData) {
	            var currentIndex = appHelper.getArrayObjectIndexByKey(this.state.screen.objects, "asset_id", completionData.asset_id);
	            if (currentIndex < this.state.screen.objects.length - 1) {
	
	                var newIndex = currentIndex + 1;
	                this.setState({ currentObjectIndex: newIndex });
	                this.getObject(newIndex);
	                if (this.state.status !== objectConstants.STATUS_COMPLETE) {
	                    //this.updateScreenResults(objectConstants.STATUS_IN_PROGRESS, asset_id, response);
	                } else {
	                        // this.updateScreenResults(objectConstants.STATUS_COMPLETE, asset_id, response);
	                    }
	                completionData = Object.assign({}, completionData, {
	                    screen_status: this.state.status !== objectConstants.STATUS_COMPLETE ? objectConstants.STATUS_IN_PROGRESS : objectConstants.STATUS_COMPLETE
	                });
	
	                this.updateScreenResults(completionData);
	            } else {
	                this.setState({
	                    allowScroll: appHelper.AllowAutoProgressionIfLast(completionData.asset_type_code)
	                });
	                if (appHelper.isDefined(this.props.parentScreen)) {
	                    //////////////////////
	                    //COMPLETE SUB SCREEN
	                    /////////////////////
	                    if (!completionData.navigateToNextScreen && (!appHelper.isDefined(completionData.showProgressionButton) || appHelper.isDefined(completionData.showProgressionButton) && completionData.showProgressionButton)) {
	                        this.showProgressionButton();
	                    }
	                    completionData = Object.assign({}, completionData, {
	                        screen_status: objectConstants.STATUS_COMPLETE,
	                        sub_screen_complete: true
	                    });
	
	                    this.updateScreenResults(completionData);
	                } else {
	                    if (!completionData.navigateToNextScreen && (!appHelper.isDefined(completionData.showProgressionButton) || appHelper.isDefined(completionData.showProgressionButton) && completionData.showProgressionButton)) {
	                        this.showProgressionButton();
	                    }
	                    completionData = Object.assign({}, completionData, {
	                        screen_status: objectConstants.STATUS_COMPLETE
	
	                    });
	                    this.updateScreenResults(completionData);
	                    //////////////////////
	                    //COMPLETE SCREEN
	                    /////////////////////
	                    //console.log(`complete screen`);
	                }
	            }
	        }
	    }, {
	        key: 'onObjectComplete',
	        value: function onObjectComplete(completionData) {
	            var _this3 = this;
	
	            if (completionData.progression === objectConstants.OBJECT_PROGRESSION_CONTINUE || completionData.progression === objectConstants.OBJECT_PROGRESSION_AUTO) {
	                this.handleContinue(completionData);
	            } else if (completionData.progression === objectConstants.OBJECT_PROGRESSION_GO_TO) {
	                if (completionData.progressionType === objectConstants.GO_TO_TYPE_OBJECT) {
	                    var nextObjectIndex = appHelper.getArrayObjectIndexByKey(this.state.screen.objects, "asset_id", completionData.progressionGoToId);
	                    this.setState({ currentObjectIndex: nextObjectIndex });
	                    this.getObject(nextObjectIndex);
	                    this.updateScreenResults(completionData);
	                } else if (completionData.progressionType === objectConstants.GO_TO_TYPE_SCREEN && appHelper.screenExists(completionData.progressionGoToId)) {
	                    this.setState({
	                        allowGoToScreen: true,
	                        goToScreenId: completionData.progressionGoToId,
	                        allowScroll: appHelper.AllowAutoProgressionIfLast(completionData.asset_type_code)
	                    });
	
	                    if (appHelper.isDefined(this.props.parentScreen)) {
	                        //////////////////////
	                        //COMPLETE SUB SCREEN
	                        /////////////////////
	                        if (!completionData.navigateToNextScreen || completionData.navigateToNextScreen && this.state.initialStatus === objectConstants.STATUS_COMPLETE) {
	                            this.showProgressionButton();
	                        }
	                        completionData = Object.assign({}, completionData, {
	                            screen_status: objectConstants.STATUS_COMPLETE,
	                            sub_screen_complete: true
	                        });
	
	                        this.updateScreenResults(completionData);
	                    } else {
	                        if (!completionData.navigateToNextScreen || completionData.navigateToNextScreen && this.state.initialStatus === objectConstants.STATUS_COMPLETE) {
	                            this.showProgressionButton();
	                        }
	                        completionData = Object.assign({}, completionData, {
	                            screen_status: objectConstants.STATUS_COMPLETE
	                        });
	                        this.updateScreenResults(completionData);
	                        //////////////////////
	                        //COMPLETE SCREEN
	                        /////////////////////
	                        //console.log(`complete screen`);
	                    }
	                } else {
	                    this.handleContinue(completionData);
	                }
	            } else if (completionData.progression === objectConstants.OBJECT_PROGRESSION_TERMINAL) {
	                if (completionData.progressionType === objectConstants.TERMINAL_TYPE_SCREEN) {
	                    this.setState({
	                        terminateScreen: true,
	                        allowScroll: appHelper.AllowAutoProgressionIfLast(completionData.asset_type_code)
	                    });
	
	                    if (appHelper.isDefined(this.props.parentScreen)) {
	                        //////////////////////
	                        //COMPLETE SUB SCREEN
	                        /////////////////////
	                        this.props.biteCallbacks.completeScreen();
	
	                        if (!completionData.navigateToNextScreen) {
	                            this.showProgressionButton();
	                        }
	                        completionData = Object.assign({}, completionData, {
	                            screen_status: objectConstants.STATUS_COMPLETE,
	                            sub_screen_complete: true
	                        });
	
	                        this.updateScreenResults(completionData);
	                    } else {
	                        if (!completionData.navigateToNextScreen) {
	                            this.showProgressionButton();
	                        }
	                        completionData = Object.assign({}, completionData, {
	                            screen_status: objectConstants.STATUS_COMPLETE
	                        });
	                        this.updateScreenResults(completionData);
	                        //////////////////////
	                        //COMPLETE SCREEN
	                        /////////////////////
	                        //console.log(`complete screen`);
	                    }
	                } else if (completionData.progressionType === objectConstants.TERMINAL_TYPE_BITE) {
	                    this.setState({
	                        terminateBite: true,
	                        allowScroll: appHelper.AllowAutoProgressionIfLast(completionData.asset_type_code)
	                    });
	
	                    var bite = appHelper.getBiteById(this.props.biteCallbacks.getBiteId());
	                    this.props.actions.terminateBite(bite).then(function (userData) {
	
	                        if (!completionData.navigateToNextScreen) {
	                            _this3.showProgressionButton();
	                        }
	
	                        if (appHelper.isDefined(_this3.props.parentScreen)) {
	                            _this3.props.biteCallbacks.completeScreen();
	                        }
	
	                        completionData = Object.assign({}, completionData, {
	                            screen_status: objectConstants.STATUS_COMPLETE
	                        });
	
	                        _this3.updateScreenResults(completionData);
	                    }).catch(function (error) {});
	                }
	            }
	        }
	    }, {
	        key: 'updateScreenResults',
	        value: function updateScreenResults(completionData) {
	            var _this4 = this;
	
	            var params = Object.assign({}, completionData, {
	                bite_id: this.getBiteId(),
	                parent_screen_id: appHelper.isDefined(this.props.parentScreen) ? this.props.parentScreen.screen_id : undefined,
	                screen_id: this.getScreenId(),
	                object_status: completionData.status,
	                object_result: {}
	            });
	            this.props.actions.updateScreenResults(params).then(function (userData) {
	                if (appHelper.isDefined(completionData.sub_screen_complete) && completionData.sub_screen_complete) {
	                    _this4.props.biteCallbacks.onSubScreenComplete(_this4.state.screen);
	                }
	                _this4.props.actions.setSuspendData(userData).then(function (trackingData) {
	                    if (completionData.screen_status === objectConstants.STATUS_COMPLETE) {
	                        _this4.props.actions.setScreenComplete(_this4.state.screen, _this4.props.parentScreen);
	                    }
	
	                    if (completionData.navigateToNextScreen && _this4.state.initialStatus !== objectConstants.STATUS_COMPLETE && _this4.state.allowGoToScreen) {
	                        _this4.navigateToNextScreen();
	                    }
	                    /*let objectIndex = appHelper.getArrayObjectIndexByKey(this.state.screen.objects,"asset_id",completionData.asset_id);
	                    if (completionData.screen_status === objectConstants.STATUS_COMPLETE  && objectIndex === this.state.screen.objects.length - 1) {
	                         if (appHelper.AllowAutoProgressionIfLast(completionData.asset_type_code)) {
	                            if (this.state.initialStatus !== objectConstants.STATUS_COMPLETE  && !appHelper.isDefined(this.props.closeDialog)) {
	                                this.navigateToNextScreen();
	                            } else {
	                                 if (!completionData.navigateToNextScreen) {
	                                    this.showProgressionButton();
	                                }
	                            }
	                         }
	                    }*/
	                }).catch(function (error) {});
	            }).catch(function (error) {});
	        }
	    }, {
	        key: 'showProgressionButton',
	        value: function showProgressionButton() {
	            var nextScreenId = appHelper.getNextScreenId(this.state.screen.screen_id);
	            //if (nextScreenId.length > 0) {
	            this.setState({ showProgression: true });
	            this.scrollToTop();
	            //}
	        }
	    }, {
	        key: 'scrollTo',
	        value: function scrollTo(pos, allow) {
	            if (this.state.status !== objectConstants.STATUS_COMPLETE || appHelper.isDefined(allow) && allow) {
	                var feed = this.refs[this.state.screen.screen_id + '_feed'];
	
	                if (feed.scrollTop < pos) {
	                    _gsap.TweenLite.to(feed, objectConstants.SCROLL_SPEED, {
	                        scrollTop: pos,
	                        ease: _gsap.Expo.easeInOut
	                    }).eventCallback("onComplete", this.onScrollComplete);
	                }
	            }
	        }
	    }, {
	        key: 'scrollToOnComplete',
	        value: function scrollToOnComplete(pos) {
	            var feed = this.refs[this.state.screen.screen_id + '_feed'];
	
	            if (feed.scrollTop < pos) {
	                _gsap.TweenLite.to(feed, objectConstants.SCROLL_SPEED, {
	                    scrollTop: pos,
	                    ease: _gsap.Expo.easeInOut
	                }).eventCallback("onComplete", this.onScrollComplete);
	            }
	        }
	    }, {
	        key: 'onContinueBtnReveled',
	        value: function onContinueBtnReveled() {
	            this.scrollToTop();
	        }
	    }, {
	        key: 'scrollToTop',
	        value: function scrollToTop() {
	            if (this.state.initialStatus !== objectConstants.STATUS_COMPLETE && this.state.allowScroll) {
	
	                var anchor = this.refs[this.state.screen.screen_id + '_bottom_anchor'];
	                var scrollToOnComplete = this.scrollToOnComplete;
	                setTimeout(function () {
	                    scrollToOnComplete(anchor.offsetTop);
	                }, 1000);
	            }
	        }
	    }, {
	        key: 'onScrollComplete',
	        value: function onScrollComplete() {}
	    }, {
	        key: 'hasNextObject',
	        value: function hasNextObject(objectIndex) {
	            //let objectIndex = appHelper.getArrayObjectIndexByKey(this.state.screen.objects, "asset_id", object.asset_id);
	            return objectIndex < this.state.screen.objects.length - 1;
	        }
	    }, {
	        key: 'getFeedClass',
	        value: function getFeedClass() {
	            return this.state.allowClippedBlurEffect ? 'blurred-feed' : 'standard-feed';
	        }
	    }, {
	        key: 'getPanelStyle',
	        value: function getPanelStyle() {
	            if (!appHelper.isDefined(this.props.parentScreen)) {
	                return appHelper.isDefined(this.state.screen.panel_style) ? this.state.screen.panel_style : "frosted_white";
	            } else {
	                return this.props.parentScreen.screen_type === componentConstants.SCREEN_TYPE_TABBED && (this.props.parentScreen.tab_type === objectConstants.TAB_TYPE_HORIZONTAL_FRAMELESS || this.props.parentScreen.tab_type === objectConstants.TAB_TYPE_VERTICAL_FRAMELESS) && appHelper.isDefined(this.props.parentScreen.panel_style) ? this.props.parentScreen.panel_style : "";
	            }
	        }
	    }, {
	        key: 'setFocusRecieved',
	        value: function setFocusRecieved() {
	            this.setState({ hasReceivedFocus: true });
	        }
	    }, {
	        key: 'focusOnNext',
	        value: function focusOnNext() {
	            this.setState({ focusOnNextObject: false });
	            var object = this.state.renderedObjects[this.state.renderedObjects.length - 1];
	            var focusEl = document.getElementById('object_' + object.data.asset_id);
	            focusEl.focus();
	        }
	    }, {
	        key: 'setScrollHeight',
	        value: function setScrollHeight() {
	            var lastObjectData = this.state.renderedObjects[this.state.renderedObjects.length - 1];
	            var overwrite = false;
	            if (appHelper.isDefined(lastObjectData)) {
	                var lastObject = document.getElementById('object_' + lastObjectData.data.asset_id);
	                var feed = this.refs[this.state.screen.screen_id + '_feed'];
	                var scrollContainer = this.refs[this.state.screen.screen_id + '_feedContainer'];
	                if (appHelper.isDefined(scrollContainer)) {
	                    var scrollHeight = scrollContainer.scrollHeight;
	                    var objectEndPos = lastObject.offsetTop + lastObject.offsetHeight;
	                    //let difference = feed.offsetHeight - lastObject.offsetHeight;
	                    var endPosIntoFeed = Math.round(objectEndPos / feed.offsetHeight);
	                    var scrollHeightIntoFeed = Math.round(scrollHeight / feed.offsetHeight);
	                    //console.log(lastObject);
	                    //console.log('lastObject scrollPosition = ', lastObject.offsetTop);
	                    //console.log('lastObject height = ', lastObject.offsetHeight);
	                    //console.log('scrollHeight = ', scrollHeight);
	                    //console.log('feed height = ', feed.offsetHeight);
	                    //console.log(' object end pos = ',  objectEndPos);
	                    //console.log(' obect end pos into feedHeights', Math.round(objectEndPos / feed.offsetHeight));
	                    //console.log(' scroll height into feedHeight', Math.round(scrollHeight / feed.offsetHeight));
	                    if (scrollHeightIntoFeed > endPosIntoFeed) {
	                        //console.log(`scrollHeightIntoFeed`,scrollHeightIntoFeed);
	                        //console.log(`endPosIntoFeed`,endPosIntoFeed);
	                        overwrite = true;
	                        scrollHeight = feed.offsetHeight * endPosIntoFeed;
	
	                        //scrollHeight =  objectEndPos + difference - 40;
	
	                        //console.log(`remainder difference = `,difference);
	                        //console.log('new height options',feed.offsetHeight * endPosIntoFeed,' or ',objectEndPos + difference);
	                    }
	                    if (scrollHeight > this.state.scrollHeight || overwrite) {
	                        this.setState({ scrollHeight: scrollHeight });
	                    }
	                }
	            }
	        }
	    }, {
	        key: 'allowInheritParentPanelStyle',
	        value: function allowInheritParentPanelStyle() {
	            return appHelper.isDefined(this.props.parentScreen) && this.props.parentScreen.screen_type === componentConstants.SCREEN_TYPE_TABBED && (this.props.parentScreen.tab_type === objectConstants.TAB_TYPE_HORIZONTAL_FRAMELESS || this.props.parentScreen.tab_type === objectConstants.TAB_TYPE_VERTICAL_FRAMELESS) && appHelper.isDefined(this.props.parentScreen.panel_style);
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this5 = this;
	
	            return _react2.default.createElement(
	                'div',
	                { className: 'customer-scenario' },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'background-container blur' },
	                    !appHelper.isDefined(this.props.parentScreen) ? _react2.default.createElement('img', { className: 'blur', src: this.getImagePath(this.state.assets.background.src), alt: '' }) : null
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'screen-container ' + this.getPanelStyle() },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'character-stage' },
	                        appHelper.isDefined(this.state.screenCharacter.position) ? _react2.default.createElement(
	                            'div',
	                            { className: this.state.screenCharacter.position },
	                            _react2.default.createElement('img', { className: 'character-image', ref: 'character',
	                                src: this.getImagePath(this.state.assets.character.src), alt: '' }),
	                            this.state.assets.prevCharacter.src.length > 0 ? _react2.default.createElement('img', { className: 'prev-character-image', ref: 'prevCharacter',
	                                src: this.getImagePath(this.state.assets.prevCharacter.src), alt: '' }) : null
	                        ) : null
	                    ),
	                    !appHelper.isDefined(this.props.parentScreen) && this.state.allowClippedBlurEffect ? _react2.default.createElement(
	                        'div',
	                        { className: 'feed-background ' },
	                        _react2.default.createElement('img', { className: 'blur', src: this.getImagePath(this.state.assets.background.src), alt: '' })
	                    ) : null,
	                    this.allowInheritParentPanelStyle() && this.state.allowClippedBlurEffect ? _react2.default.createElement(
	                        'div',
	                        { className: 'feed-background ' },
	                        _react2.default.createElement('img', { className: 'blur', src: this.getImagePath(this.state.parentBackground.src), alt: '' })
	                    ) : null,
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'object-feed ' + this.getFeedClass(), id: this.state.screen.screen_id + '_feed_id',
	                            ref: this.state.screen.screen_id + '_feed', role: 'article' },
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'feed-container', ref: this.state.screen.screen_id + '_feedContainer',
	                                style: { minHeight: this.state.scrollHeight + 'px' } },
	                            this.state.producerNotes.length > 0 ? _react2.default.createElement(_ProducerNotes2.default, { notes: this.state.producerNotes,
	                                screen_id: this.state.screen.screen_id }) : null,
	                            this.state.screenIsReady && this.state.renderedObjects.length > 0 ? this.state.renderedObjects.map(function (object, index) {
	                                return _react2.default.createElement(
	                                    'div',
	                                    { className: 'feed-object-container', key: index, role: 'article',
	                                        tabIndex: '0', id: 'object_' + object.data.asset_id,
	                                        onFocus: _this5.setFocusRecieved },
	                                    _react2.default.createElement(object.component, { screenObject: object.data,
	                                        callbacks: _this5.state.callbacks,
	                                        index: appHelper.getArrayObjectIndexByKey(_this5.state.screen.objects, "asset_id", object.data.asset_id)
	                                    })
	                                );
	                            }) : null,
	                            !this.state.screenIsReady ? _react2.default.createElement(_NotReadyYet2.default, { screen_id: this.state.screen.screen_id }) : null,
	                            this.state.showProgression ? _react2.default.createElement(_Button2.default, { ref: this.state.screen.screen_id + '_button',
	                                label: this.state.continue_label,
	                                id: this.state.screen.screen_id + '_button',
	                                onClick: this.navigateToNextScreen,
	                                onRevealed: this.onContinueBtnReveled
	                            }) : null,
	                            _react2.default.createElement('div', { ref: this.state.screen.screen_id + '_bottom_anchor' })
	                        )
	                    )
	                )
	            );
	        }
	    }]);
	
	    return ScenarioScreen;
	}(_react2.default.Component);
	
	ScenarioScreen.propTypes = {
	    screen: _propTypes2.default.object.isRequired,
	    biteCallbacks: _propTypes2.default.object.isRequired,
	    parentScreen: _propTypes2.default.object,
	    contentData: _propTypes2.default.object.isRequired,
	    trackingData: _propTypes2.default.object.isRequired,
	    userData: _propTypes2.default.object.isRequired,
	    actions: _propTypes2.default.object.isRequired,
	    closeDialog: _propTypes2.default.func,
	    lang: _propTypes2.default.string.isRequired,
	    audio: _propTypes2.default.object.isRequired
	
	};
	
	ScenarioScreen.contextTypes = {
	    router: _propTypes2.default.object
	};
	
	function mapStateToProps(state, ownProps) {
	    var lang = state.userData.lang;
	    return {
	        lang: lang,
	        contentData: state.contentData,
	        trackingData: state.trackingData,
	        userData: state.userData,
	        audio: state.audio
	    };
	}
	
	function mapDispatchToProps(dispatch) {
	    return {
	        actions: (0, _redux.bindActionCreators)(Object.assign({}, appDataActions, trackingDataActions, userDataActions), dispatch)
	    };
	}
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(ScenarioScreen);

/***/ },
/* 542 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(5);
	
	var _redux = __webpack_require__(4);
	
	var _Button = __webpack_require__(18);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _ProducerNotes = __webpack_require__(85);
	
	var _ProducerNotes2 = _interopRequireDefault(_ProducerNotes);
	
	var _NotReadyYet = __webpack_require__(84);
	
	var _NotReadyYet2 = _interopRequireDefault(_NotReadyYet);
	
	var _SecondaryImage = __webpack_require__(66);
	
	var _SecondaryImage2 = _interopRequireDefault(_SecondaryImage);
	
	var _SecondaryLibraryImage = __webpack_require__(67);
	
	var _SecondaryLibraryImage2 = _interopRequireDefault(_SecondaryLibraryImage);
	
	var _trackingDataActions = __webpack_require__(7);
	
	var trackingDataActions = _interopRequireWildcard(_trackingDataActions);
	
	var _appDataActions = __webpack_require__(12);
	
	var appDataActions = _interopRequireWildcard(_appDataActions);
	
	var _userDataActions = __webpack_require__(20);
	
	var userDataActions = _interopRequireWildcard(_userDataActions);
	
	var _appHelper = __webpack_require__(3);
	
	var appHelper = _interopRequireWildcard(_appHelper);
	
	var _dataHelper = __webpack_require__(11);
	
	var dataHelper = _interopRequireWildcard(_dataHelper);
	
	var _componentHelper = __webpack_require__(31);
	
	var _userDataHelper = __webpack_require__(15);
	
	var userDataHelper = _interopRequireWildcard(_userDataHelper);
	
	var _environmentHelper = __webpack_require__(56);
	
	var enviromentHelper = _interopRequireWildcard(_environmentHelper);
	
	var _appConstants = __webpack_require__(13);
	
	var appConstants = _interopRequireWildcard(_appConstants);
	
	var _assetConstants = __webpack_require__(33);
	
	var assetConstants = _interopRequireWildcard(_assetConstants);
	
	var _objectConstants = __webpack_require__(9);
	
	var objectConstants = _interopRequireWildcard(_objectConstants);
	
	var _localStorage = __webpack_require__(17);
	
	var localStorage = _interopRequireWildcard(_localStorage);
	
	var _componentConstants = __webpack_require__(49);
	
	var componentConstants = _interopRequireWildcard(_componentConstants);
	
	var _imageHelper = __webpack_require__(203);
	
	var imageHelper = _interopRequireWildcard(_imageHelper);
	
	var _gsap = __webpack_require__(8);
	
	var _gsapReactPlugin = __webpack_require__(10);
	
	var _gsapReactPlugin2 = _interopRequireDefault(_gsapReactPlugin);
	
	var _lodash = __webpack_require__(28);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } //eslint-disable-line import/no-named-as-default
	
	
	var ScrollScreen = function (_React$Component) {
	    _inherits(ScrollScreen, _React$Component);
	
	    function ScrollScreen(props, context) {
	        _classCallCheck(this, ScrollScreen);
	
	        var _this = _possibleConstructorReturn(this, (ScrollScreen.__proto__ || Object.getPrototypeOf(ScrollScreen)).call(this, props, context));
	
	        _this.state = {
	            lang: _this.props.lang,
	            screen: _this.props.screen,
	            userData: _this.props.userData,
	            env: enviromentHelper.getEnvironment(),
	            is_resource_screen: appHelper.isDefined(_this.props.screen.is_resource_screen) && _this.props.screen.is_resource_screen,
	            locale: {},
	            status: objectConstants.STATUS_NOT_STARTED,
	            initialStatus: "",
	            multiPath: appHelper.isDefined(_this.props.screen.multi_path) ? _this.props.screen.multi_path : { enabled: false },
	            allowReviewMode: true,
	            reviewMode: false,
	            propsUpdated: false,
	            renderedObjects: [],
	            updateCharacter: false,
	            screenCharacter: {},
	            assets: {
	                background: {
	                    src: "",
	                    type: "",
	                    type_id: ""
	                },
	                screenAsset: {
	                    src: "",
	                    pose: "",
	                    position: ""
	                },
	                character: {
	                    src: "",
	                    pose: "",
	                    position: ""
	                }
	            },
	            parentBackground: {
	                src: "",
	                type: "",
	                type_id: ""
	            },
	            callbacks: {
	                updateCharacterExpression: null,
	                onObjectComplete: null
	            },
	            currentObjectIndex: 0,
	            showProgression: false,
	            imageIsTracking: false,
	            allowGoToScreen: false,
	            goToScreenId: 0,
	            terminateScreen: false,
	            terminateBite: false,
	            producerNotes: appHelper.getScreenNotes(_this.props.parentScreen, _this.props.screen),
	            screenIsReady: _this.props.screen.objects.length > 0 && (appHelper.canSeeContent(_this.props.screen) || appHelper.isDefined(_this.props.parentScreen)),
	            allowClippedBlurEffect: appHelper.allowClippedBlurEffect(),
	            allowScroll: true,
	            hasReceivedFocus: false,
	            focusOnNextObject: false,
	            scrollHeight: 0,
	            imageStyles: imageHelper.checkImageWidth(_this.props.screen).styles,
	            imageClass: imageHelper.getImageClass(_this.props.screen),
	            updateImageStyles: false,
	            continue_label: appHelper.getLocaleString("continue_label"),
	            credit_label: appHelper.getLocaleString("credit_label")
	        };
	        _this.getLocale = _this.getLocale.bind(_this);
	        _this.getObject = _this.getObject.bind(_this);
	        _this.getScreenId = _this.getScreenId.bind(_this);
	        _this.getBiteId = _this.getBiteId.bind(_this);
	        _this.isReviewMode = _this.isReviewMode.bind(_this);
	        _this.getImagePath = _this.getImagePath.bind(_this);
	        _this.getAssets = _this.getAssets.bind(_this);
	        _this.getAssetType = _this.getAssetType.bind(_this);
	        _this.storeUserResponse = _this.storeUserResponse.bind(_this);
	        _this.setCallbacks = _this.setCallbacks.bind(_this);
	        _this.updateCharacterExpression = _this.updateCharacterExpression.bind(_this);
	        _this.onObjectComplete = _this.onObjectComplete.bind(_this);
	        _this.updateScreenResults = _lodash2.default.debounce(_this.updateScreenResults.bind(_this), 300);
	        _this.setScreenAccessed = _lodash2.default.debounce(_this.setScreenAccessed.bind(_this), 300);
	        _this.showProgressionButton = _this.showProgressionButton.bind(_this);
	        _this.navigateToNextScreen = _this.navigateToNextScreen.bind(_this);
	        _this.scrollTo = _this.scrollTo.bind(_this);
	        _this.onScrollComplete = _this.onScrollComplete.bind(_this);
	        _this.onContinueBtnReveled = _this.onContinueBtnReveled.bind(_this);
	        _this.scrollToTop = _this.scrollToTop.bind(_this);
	        _this.checkScreenStatus = _this.checkScreenStatus.bind(_this);
	        _this.setReviewMode = _this.setReviewMode.bind(_this);
	        _this.renderAllObjects = _this.renderAllObjects.bind(_this);
	        _this.transitionCharacterExpressions = _this.transitionCharacterExpressions.bind(_this);
	        _this.transitionCharacter = _this.transitionCharacter.bind(_this);
	        _this.transitionPrevCharacter = _this.transitionPrevCharacter.bind(_this);
	        _this.goToScreen = _this.goToScreen.bind(_this);
	        //new
	        _this.getCharacterName = _this.getCharacterName.bind(_this);
	        _this.handleObjectProgression = _this.handleObjectProgression.bind(_this);
	        _this.hasNextObject = _this.hasNextObject.bind(_this);
	        _this.getLayoutClass = _this.getLayoutClass.bind(_this);
	        _this.getScreenStatus = _this.getScreenStatus.bind(_this);
	        _this.getSubScreenParent = _this.getSubScreenParent.bind(_this);
	        _this.checkIsResourceScreen = _this.checkIsResourceScreen.bind(_this);
	        _this.updateResourceObjectResult = _this.updateResourceObjectResult.bind(_this);
	        _this.updateResourceScreenResult = _this.updateResourceScreenResult.bind(_this);
	        _this.setScreenNotReadyYet = _this.setScreenNotReadyYet.bind(_this);
	        _this.setScreenNotReadyYet = _this.setScreenNotReadyYet.bind(_this);
	        _this.setCharacterPose = _this.setCharacterPose.bind(_this);
	        _this.getFeedClass = _this.getFeedClass.bind(_this);
	        _this.getPanelStyle = _this.getPanelStyle.bind(_this);
	        _this.getPanelLocation = _this.getPanelLocation.bind(_this);
	        _this.scrollToOnComplete = _this.scrollToOnComplete.bind(_this);
	        _this.setFocusRecieved = _this.setFocusRecieved.bind(_this);
	        _this.focusOnNext = _this.focusOnNext.bind(_this);
	        _this.setScrollHeight = _this.setScrollHeight.bind(_this);
	        _this.resizeWatcher = _this.resizeWatcher.bind(_this);
	        _this.allowInheritParentPanelStyle = _this.allowInheritParentPanelStyle.bind(_this);
	        _this.getImageStyles = _this.getImageStyles.bind(_this);
	        _this.updateClippedBlur = _this.updateClippedBlur.bind(_this);
	        _this.goToMenu = _this.goToMenu.bind(_this);
	        _this.handleContinue = _this.handleContinue.bind(_this);
	        return _this;
	    }
	
	    _createClass(ScrollScreen, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            window.addEventListener("resize", this.resizeWatcher);
	            if (this.props.audio.audioRef.length > 0) {
	                this.props.actions.clearAudio();
	            }
	            this.setScreenAccessed();
	            this.props.biteCallbacks.showHeader(true);
	            this.setCallbacks();
	            this.getLocale();
	            if (this.state.screenIsReady) {
	                this.getObject(this.state.currentObjectIndex);
	            } else {
	                this.setScreenNotReadyYet();
	            }
	            this.getAssets();
	            this.checkScreenStatus();
	            this.getImageStyles();
	        }
	    }, {
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(nextProps) {
	            var screenUserData = {};
	
	            if (this.state.is_resource_screen) {
	                screenUserData = userDataHelper.getResourceScreenUserData(nextProps.userData, this.state.screen.screen_id);
	            } else if (this.props.parentScreen) {
	                screenUserData = userDataHelper.getSubScreenUserData(nextProps.userData, this.props.parentScreen.screen_id, this.state.screen.screen_id);
	            } else {
	                screenUserData = userDataHelper.getScreenUserData(nextProps.userData, this.state.screen.screen_id);
	            }
	            this.setState({ userData: Object.assign({}, nextProps.userData) });
	
	            if (this.state.status !== screenUserData.status && screenUserData.status === objectConstants.STATUS_COMPLETE) {
	                this.setState({
	                    status: screenUserData.status
	                });
	                if (!appHelper.isDefined(this.props.parentScreen)) {
	                    this.props.actions.setScreenTitle(appHelper.getLocalData(this.state.screen).title);
	                }
	            }
	
	            if (this.state.lang !== nextProps.lang) {
	                this.setState({
	                    lang: nextProps.lang,
	                    locale: appHelper.getLocalData(this.state.screen),
	                    continue_label: appHelper.getLocaleString("continue_label"),
	                    credit_label: appHelper.getLocaleString("credit_label")
	                });
	                if (!appHelper.isDefined(this.props.parentScreen)) {
	                    this.props.actions.setScreenTitle(appHelper.getLocalData(this.state.screen).title);
	                }
	            }
	
	            this.setState({ updateImageStyles: true });
	        }
	    }, {
	        key: 'componentDidUpdate',
	        value: function componentDidUpdate() {
	            var setScrollHeight = this.setScrollHeight;
	            setTimeout(function () {
	                setScrollHeight();
	            }, 500);
	            if (this.state.propsUpdated && this.state.reviewMode && this.state.allowReviewMode) {
	                this.setReviewMode();
	            }
	
	            if (this.state.updateCharacter) {
	
	                this.transitionCharacterExpressions();
	            }
	
	            if (this.state.focusOnNextObject) {
	                this.focusOnNext();
	            }
	
	            if (this.state.updateImageStyles) {
	                this.getImageStyles();
	            }
	        }
	    }, {
	        key: 'componentWillUnmount',
	        value: function componentWillUnmount() {
	            this.props.actions.clearAudio();
	            window.removeEventListener("resize", this.resizeWatcher);
	        }
	    }, {
	        key: 'setScreenAccessed',
	        value: function setScreenAccessed() {
	            this.props.actions.setScreenAccessed(this.state.screen, this.props.parentScreen);
	        }
	    }, {
	        key: 'getImageStyles',
	        value: function getImageStyles() {
	            this.setState({
	                updateImageStyles: false,
	                imageStyles: Object.assign({}, imageHelper.checkImageWidth(this.state.screen)).styles,
	                imageClass: imageHelper.getImageClass(this.state.screen)
	            });
	        }
	    }, {
	        key: 'resizeWatcher',
	        value: function resizeWatcher() {
	            var scrollContainer = this.refs[this.state.screen.screen_id + '_feedContainer'];
	            if (appHelper.isDefined(scrollContainer)) {
	                var scrollHeight = scrollContainer.scrollHeight;
	                this.setState({ scrollHeight: scrollHeight });
	            }
	        }
	    }, {
	        key: 'setScreenNotReadyYet',
	        value: function setScreenNotReadyYet() {
	            var completionData = {
	                screen_status: objectConstants.STATUS_COMPLETE,
	                sub_screen_complete: appHelper.isDefined(this.props.parentScreen) ? true : undefined
	            };
	
	            this.showProgressionButton();
	
	            this.updateScreenResults(completionData);
	        }
	    }, {
	        key: 'checkScreenStatus',
	        value: function checkScreenStatus() {
	            var screenUserData = {};
	            if (this.state.is_resource_screen) {
	                screenUserData = userDataHelper.getResourceScreenUserData(this.state.userData, this.state.screen.screen_id);
	            } else if (this.props.parentScreen) {
	                screenUserData = userDataHelper.getSubScreenUserData(this.state.userData, this.props.parentScreen.screen_id, this.state.screen.screen_id);
	            } else {
	                screenUserData = userDataHelper.getScreenUserData(this.state.userData, this.state.screen.screen_id);
	            }
	
	            if (this.state.status !== screenUserData.status && screenUserData.status === objectConstants.STATUS_COMPLETE) {
	                this.setState({
	                    status: screenUserData.status
	                });
	            }
	
	            this.setState({
	                initialStatus: this.state.initialStatus.length === 0 ? screenUserData.status : this.state.initialStatus
	            });
	            /* let screenStatus = getScreenUserData(this.props.userData, this.props.screen.screen_id).status;
	             let reviewMode = screenStatus === objectConstants.STATUS_COMPLETE && localStorage.post_completion_mode === appConstants.POST_COMPLETION_MODE_REVIEW;
	            // console.log(`reviewMode: ${this.state.reviewMode} - line 120`);
	             this.setState({status: screenStatus, checkCompletionStatus: true, reviewMode: reviewMode, propsUpdated: true});
	             */
	        }
	    }, {
	        key: 'setCallbacks',
	        value: function setCallbacks() {
	            //console.log(`reviewMode: ${this.state.reviewMode} - line 125`);
	            this.setState({
	                callbacks: Object.assign({}, this.state.biteCallbacks, {
	                    updateCharacterExpression: this.updateCharacterExpression,
	                    onObjectComplete: this.onObjectComplete,
	                    getScreenId: this.getScreenId,
	                    getBiteId: this.getBiteId,
	                    storeUserResponse: this.storeUserResponse,
	                    scrollTo: this.scrollTo,
	                    isReviewMode: this.isReviewMode,
	                    getCharacterName: this.getCharacterName,
	                    hasNextObject: this.hasNextObject,
	                    navigateToNextScreen: this.navigateToNextScreen,
	                    getScreenStatus: this.getScreenStatus,
	                    getSubScreenParent: this.getSubScreenParent,
	                    checkIsResourceScreen: this.checkIsResourceScreen,
	                    goToScreen: this.goToScreen,
	                    resizeWatcher: this.resizeWatcher
	                })
	            });
	        }
	    }, {
	        key: 'getSubScreenParent',
	        value: function getSubScreenParent() {
	            return appHelper.isDefined(this.props.parentScreen) ? this.props.parentScreen : undefined;
	        }
	    }, {
	        key: 'getLocale',
	        value: function getLocale() {
	            var locale = appHelper.getLocalData(this.state.screen);
	            this.setState({ locale: Object.assign({}, locale) });
	            //if (!appHelper.isDefined(this.props.parentScreen) && !this.state.is_resource_screen) {
	            if (!appHelper.isDefined(this.props.parentScreen) && !this.state.is_resource_screen) {
	                this.props.actions.setScreenTitle(locale.title);
	            }
	        }
	    }, {
	        key: 'getScreenId',
	        value: function getScreenId() {
	            return this.state.screen.screen_id;
	        }
	    }, {
	        key: 'getBiteId',
	        value: function getBiteId() {
	
	            return this.props.biteCallbacks.getBiteId();
	        }
	    }, {
	        key: 'isReviewMode',
	        value: function isReviewMode() {
	            return this.state.reviewMode;
	        }
	    }, {
	        key: 'getCharacterName',
	        value: function getCharacterName() {
	            return this.state.locale.character_name;
	        }
	    }, {
	        key: 'getScreenStatus',
	        value: function getScreenStatus() {
	            return this.state.status;
	        }
	    }, {
	        key: 'checkIsResourceScreen',
	        value: function checkIsResourceScreen() {
	            return this.state.is_resource_screen;
	        }
	    }, {
	        key: 'setReviewMode',
	        value: function setReviewMode() {
	
	            var objectsToRender = appHelper.getRenderableObjects(this.props.userData, this.getBiteId(), this.state.screen.objects);
	            this.setState({
	                screen: Object.assign({}, this.state.screen, {
	                    objects: Object.assign([], objectsToRender)
	                }),
	                propsUpdated: false
	            });
	            this.renderAllObjects(objectsToRender);
	        }
	    }, {
	        key: 'renderAllObjects',
	        value: function renderAllObjects(objectsToRender) {
	            var renderableObjects = [];
	            for (var i = 0; i < objectsToRender.length; i++) {
	                var object = objectsToRender[i];
	                var objectType = Object.assign({}, (0, _componentHelper.getAssetComponentByType)(object.asset_type_code), {
	                    data: object
	                });
	                renderableObjects = dataHelper.immutablePush(renderableObjects, objectType);
	            }
	            this.setState({ renderedObjects: Object.assign([], renderableObjects), showProgression: true });
	        }
	    }, {
	        key: 'getObject',
	        value: function getObject(index) {
	            var object = this.state.screen.objects[index];
	            var objectType = Object.assign({}, (0, _componentHelper.getAssetComponentByType)(object.asset_type_code), {
	                data: object
	            });
	            //console.log(objectType);
	            //let objectLocale = appHelper.getLocalData(object.locale);
	            //this.props.actions.setScreenTitle(objectLocale.title);
	            this.setState({
	                renderedObjects: Object.assign([], dataHelper.immutablePush(this.state.renderedObjects, objectType)),
	                focusOnNextObject: this.state.hasReceivedFocus
	            });
	        }
	    }, {
	        key: 'getAssets',
	        value: function getAssets() {
	            var backgroundAsset = Object.assign(this.state.assets.background);
	            var hasLeftAsset = appHelper.isDefined(this.state.screen.assets.left);
	            var hasRightAsset = appHelper.isDefined(this.state.screen.assets.right);
	            var screenAsset = {};
	            var screenCharacter = {};
	            var characterAsset = Object.assign(this.state.assets.character);
	            var parentBackground = Object.assign(this.state.parentBackground);
	
	            if (hasLeftAsset) {
	                screenAsset = this.getAssetType(this.state.screen.assets.left);
	            } else if (hasRightAsset) {
	                screenAsset = this.getAssetType(this.state.screen.assets.right);
	            }
	            if (appHelper.isDefined(this.state.screen.assets.background)) {
	                backgroundAsset = appHelper.getBackgroundAsset(this.state.screen.assets.background);
	            }
	
	            if (appHelper.isDefined(this.state.screen.assets.character)) {
	                screenCharacter = appHelper.getCharacterAsset(this.state.screen.assets.character);
	                characterAsset = appHelper.getCharacterPose(screenCharacter, this.state.screen.assets.character);
	            }
	
	            if (appHelper.isDefined(this.props.parentScreen) && appHelper.isDefined(this.props.parentScreen.assets.background)) {
	                parentBackground = appHelper.getBackgroundAsset(this.props.parentScreen.assets.background);
	            }
	            this.setState({
	                screenCharacter: Object.assign({}, screenCharacter),
	                assets: Object.assign({}, this.state.assets, {
	                    background: backgroundAsset,
	                    screenAsset: screenAsset,
	                    character: characterAsset
	                }),
	                parentBackground: Object.assign({}, parentBackground)
	            });
	        }
	    }, {
	        key: 'getAssetType',
	        value: function getAssetType(asset) {
	
	            var returnAsset = {};
	            if (asset.constant === assetConstants.ASSET_TYPE_ID_CHARACTER) {
	                var screenCharacter = appHelper.getCharacterAsset(asset);
	                returnAsset = appHelper.getCharacterPose(screenCharacter, asset);
	            } else if (asset.constant === assetConstants.ASSET_TYPE_ICON) {
	                returnAsset = appHelper.getIconAsset(asset);
	            } else if (asset.constant === assetConstants.ASSET_TYPE_IMAGE) {
	                returnAsset = appHelper.getImageAsset(asset);
	            } else if (asset.constant === assetConstants.ASSET_TYPE_LIBRARY_IMAGE) {
	                returnAsset = appHelper.getLibraryImageAsset(asset);
	            }
	            returnAsset = appHelper.isDefined(returnAsset.locale) ? appHelper.getLocalData(returnAsset) : returnAsset;
	
	            if (appHelper.isDefined(asset.constant) && !appHelper.isDefined(returnAsset.type)) {
	                returnAsset = Object.assign({}, returnAsset, {
	                    type: asset.constant
	                });
	            }
	            return returnAsset;
	        }
	    }, {
	        key: 'getImagePath',
	        value: function getImagePath(image) {
	            if (appConstants.DEVELOPMENT_MODE) {
	                if (appHelper.isDefined(image) && image.length > 0) {
	                    return __webpack_require__(16)("./" + image);
	                }
	            } else {
	                return image;
	            }
	        }
	    }, {
	        key: 'updateCharacterExpression',
	        value: function updateCharacterExpression(pose) {
	            /*if (appHelper.isDefined(pose) && pose.pose !== objectConstants.INHERIT) {
	                let characterAsset = appHelper.getCharacterPose(this.state.screenCharacter, pose);
	                if (appHelper.isDefined(characterAsset.src) && characterAsset.src.length > 0) {
	                    let characterRef = this.refs.character;
	                    characterRef.removeAttribute("style");
	                    TweenLite.set(characterRef, {opacity: 0, '-webkit-filter': 'blur(5px)', 'filter': 'blur(5px)'});
	                     if (appHelper.isDefined(this.refs.prevCharacter)) {
	                        let prevCharacterRef = this.refs.prevCharacter;
	                        prevCharacterRef.removeAttribute("style");
	                        TweenLite.set(prevCharacterRef, {opacity: 1, '-webkit-filter': 'blur(0px)', 'filter': 'blur(0px)'});
	                    }
	                     //if (characterAsset.src !== this.state.assets.character.src) {
	                    this.setState({
	                        assets: Object.assign({}, this.state.assets, {
	                            character: characterAsset,
	                            prevCharacter: this.state.assets.character,
	                         }),
	                        updateCharacter: true
	                    });
	                }
	            }*/
	            //}
	        }
	    }, {
	        key: 'transitionCharacterExpressions',
	        value: function transitionCharacterExpressions() {
	            this.setState({ updateCharacter: false });
	            this.transitionPrevCharacter();
	            this.transitionCharacter();
	        }
	    }, {
	        key: 'transitionCharacter',
	        value: function transitionCharacter() {
	            var characterRef = this.refs.character;
	
	            _gsap.TweenLite.to(characterRef, 0.6, {
	                opacity: 1,
	                filter: 'blur(0px)',
	                ease: _gsap.Expo.easeOut
	            });
	        }
	    }, {
	        key: 'transitionPrevCharacter',
	        value: function transitionPrevCharacter() {
	            var characterRef = this.refs.prevCharacter;
	
	            _gsap.TweenLite.to(characterRef, 2, {
	                opacity: 0,
	
	                filter: 'blur(10px)',
	                ease: _gsap.Expo.easeOut
	            });
	        }
	    }, {
	        key: 'storeUserResponse',
	        value: function storeUserResponse(responseObj) {
	            var _this2 = this;
	
	            var params = Object.assign({}, responseObj, {
	                userData: this.props.userData,
	                bite_id: this.getBiteId(),
	                parent_screen_id: appHelper.isDefined(this.props.parentScreen) ? this.props.parentScreen.screen_id : undefined,
	                screen_id: this.getScreenId()
	
	            });
	
	            this.props.actions.storeUserResponse(params).then(function (userData) {
	                _this2.props.actions.setSuspendData(userData);
	            }).catch(function (error) {});
	        }
	    }, {
	        key: 'navigateToNextScreen',
	        value: function navigateToNextScreen() {
	            var goToMenu = this.goToMenu;
	            if (appHelper.isDefined(this.props.parentScreen)) {
	                if (appHelper.isDefined(this.props.closeDialog)) {
	                    this.props.closeDialog();
	                }
	                if (this.state.allowGoToScreen && !isNaN(parseInt(this.state.goToScreenId)) && appHelper.screenExists(this.state.goToScreenId)) {
	                    this.goToScreen(this.state.goToScreenId);
	                } else if (this.state.terminateScreen) {
	                    var nextScreenId = appHelper.getNextScreenId(this.props.parentScreen.screen_id);
	                    if (localStorage.bites.length > 1 && nextScreenId.length === 0) {
	                        setTimeout(function () {
	                            goToMenu();
	                        }, 500);
	                    } else {
	                        this.props.actions.setNextLessonLocation(nextScreenId);
	                    }
	                } else if (this.state.terminateBite) {
	                    if (localStorage.bites.length > 1) {
	                        setTimeout(function () {
	                            goToMenu();
	                        }, 500);
	                    } else {
	                        var bite = appHelper.getBiteById(this.props.biteCallbacks.getBiteId());
	                        this.goToScreen(bite.screens[0].screen_id);
	                    }
	                } else {
	                    var hasNextSubScreen = this.props.biteCallbacks.hasNextSubScreen(this.state.screen);
	                    if (hasNextSubScreen) {
	                        this.props.biteCallbacks.goToNextSubScreen(this.state.screen);
	                    } else {
	                        var _nextScreenId = appHelper.getNextScreenId(this.props.parentScreen.screen_id);
	                        if (localStorage.bites.length > 1 && _nextScreenId.length === 0) {
	                            if (appHelper.isDefined(this.props.parentScreen.progression) && (this.props.parentScreen.progression === objectConstants.PROGRESSION_TYPE_OPEN || this.props.parentScreen.progression === objectConstants.PROGRESSION_TYPE_EXPLORE_INTERESTS) && appHelper.isDefined(this.props.closeDialog)) {
	                                return false;
	                            } else {
	                                setTimeout(function () {
	                                    goToMenu();
	                                }, 500);
	                            }
	                        } else {
	                            if (appHelper.isDefined(this.props.parentScreen.progression) && (this.props.parentScreen.progression === objectConstants.PROGRESSION_TYPE_OPEN || this.props.parentScreen.progression === objectConstants.PROGRESSION_TYPE_EXPLORE_INTERESTS) && appHelper.isDefined(this.props.closeDialog)) {
	                                return false;
	                            } else {
	                                var goToScreen = this.goToScreen;
	                                setTimeout(function () {
	                                    goToScreen(_nextScreenId);
	                                }, 500);
	                            }
	                        }
	                    }
	                }
	            } else {
	                if (this.state.allowGoToScreen && !isNaN(parseInt(this.state.goToScreenId)) && appHelper.screenExists(this.state.goToScreenId)) {
	                    this.goToScreen(this.state.goToScreenId);
	                } else if (this.state.terminateBite) {
	                    if (localStorage.bites.length > 1) {
	                        setTimeout(function () {
	                            goToMenu();
	                        }, 500);
	                    } else {
	                        var _bite = appHelper.getBiteById(this.props.biteCallbacks.getBiteId());
	                        this.goToScreen(_bite.screens[0].screen_id);
	                    }
	                } else {
	                    var _nextScreenId2 = appHelper.getNextScreenId(this.getScreenId());
	                    if (localStorage.bites.length > 1 && _nextScreenId2.length === 0) {
	                        setTimeout(function () {
	                            goToMenu();
	                        }, 500);
	                    } else {
	                        this.goToScreen(_nextScreenId2);
	                    }
	                }
	            }
	        }
	    }, {
	        key: 'goToMenu',
	        value: function goToMenu() {
	            this.context.router.push('menu');
	        }
	    }, {
	        key: 'goToScreen',
	        value: function goToScreen(goTo) {
	            this.props.actions.setNewLessonLocation(goTo);
	        }
	    }, {
	        key: 'handleObjectProgression',
	        value: function handleObjectProgression() {}
	    }, {
	        key: 'handleContinue',
	        value: function handleContinue(completionData) {
	            var currentIndex = appHelper.getArrayObjectIndexByKey(this.state.screen.objects, "asset_id", completionData.asset_id);
	            if (currentIndex < this.state.screen.objects.length - 1) {
	
	                var newIndex = currentIndex + 1;
	
	                this.setState({ currentObjectIndex: newIndex });
	                this.getObject(newIndex);
	                if (this.state.status !== objectConstants.STATUS_COMPLETE) {
	                    //this.updateScreenResults(objectConstants.STATUS_IN_PROGRESS, asset_id, response);
	                } else {
	                        // this.updateScreenResults(objectConstants.STATUS_COMPLETE, asset_id, response);
	                    }
	                completionData = Object.assign({}, completionData, {
	                    screen_status: this.state.status !== objectConstants.STATUS_COMPLETE ? objectConstants.STATUS_IN_PROGRESS : objectConstants.STATUS_COMPLETE
	                });
	                if (this.state.is_resource_screen) {
	                    //save resource object tracking
	                    this.updateResourceObjectResult(completionData);
	                } else {
	
	                    this.updateScreenResults(completionData);
	                }
	            } else {
	                this.setState({
	                    allowScroll: appHelper.AllowAutoProgressionIfLast(completionData.asset_type_code)
	                });
	                if (this.state.is_resource_screen) {
	                    //Last object of resource screen we can add logic here when we need to
	                    this.updateResourceObjectResult(completionData);
	                } else if (appHelper.isDefined(this.props.parentScreen)) {
	                    //////////////////////
	                    //COMPLETE SUB SCREEN
	                    //////////////////////
	
	                    if (!completionData.navigateToNextScreen && (!appHelper.isDefined(completionData.showProgressionButton) || appHelper.isDefined(completionData.showProgressionButton) && completionData.showProgressionButton)) {
	                        this.showProgressionButton();
	                    }
	
	                    completionData = Object.assign({}, completionData, {
	                        screen_status: objectConstants.STATUS_COMPLETE,
	                        sub_screen_complete: true
	                    });
	
	                    this.updateScreenResults(completionData);
	
	                    //this.props.biteCallbacks.onSubScreenComplete(this.state.screen);
	                } else {
	
	                    if (!completionData.navigateToNextScreen && (!appHelper.isDefined(completionData.showProgressionButton) || appHelper.isDefined(completionData.showProgressionButton) && completionData.showProgressionButton)) {
	                        this.showProgressionButton();
	                    }
	
	                    completionData = Object.assign({}, completionData, {
	                        screen_status: objectConstants.STATUS_COMPLETE,
	                        allowScroll: appHelper.AllowAutoProgressionIfLast(completionData.asset_type_code)
	                    });
	
	                    this.updateScreenResults(completionData);
	                    //////////////////////
	                    //COMPLETE SCREEN
	                    /////////////////////
	                    //console.log(`complete screen`);
	                }
	            }
	        }
	    }, {
	        key: 'onObjectComplete',
	        value: function onObjectComplete(completionData) {
	            var _this3 = this;
	
	            if (completionData.progression === objectConstants.OBJECT_PROGRESSION_CONTINUE || completionData.progression === objectConstants.OBJECT_PROGRESSION_AUTO) {
	                this.handleContinue(completionData);
	            } else if (completionData.progression === objectConstants.OBJECT_PROGRESSION_GO_TO) {
	
	                if (completionData.progressionType === objectConstants.GO_TO_TYPE_OBJECT) {
	                    var nextObjectIndex = appHelper.getArrayObjectIndexByKey(this.state.screen.objects, "asset_id", completionData.progressionGoToId);
	                    this.setState({ currentObjectIndex: nextObjectIndex });
	                    this.getObject(nextObjectIndex);
	                    this.updateScreenResults(completionData);
	                } else if (completionData.progressionType === objectConstants.GO_TO_TYPE_SCREEN && appHelper.screenExists(completionData.progressionGoToId)) {
	
	                    this.setState({
	                        allowGoToScreen: true,
	                        goToScreenId: completionData.progressionGoToId,
	                        allowScroll: appHelper.AllowAutoProgressionIfLast(completionData.asset_type_code)
	                    });
	
	                    if (appHelper.isDefined(this.props.parentScreen)) {
	
	                        this.props.biteCallbacks.completeScreen();
	                        //////////////////////
	                        //COMPLETE SUB SCREEN
	                        /////////////////////
	                        if (!completionData.navigateToNextScreen || completionData.navigateToNextScreen && this.state.initialStatus === objectConstants.STATUS_COMPLETE) {
	                            this.showProgressionButton();
	                        }
	                        completionData = Object.assign({}, completionData, {
	                            screen_status: objectConstants.STATUS_COMPLETE,
	                            sub_screen_complete: true
	                        });
	
	                        this.updateScreenResults(completionData);
	                    } else {
	                        if (!completionData.navigateToNextScreen || completionData.navigateToNextScreen && this.state.initialStatus === objectConstants.STATUS_COMPLETE) {
	                            this.showProgressionButton();
	                        }
	                        completionData = Object.assign({}, completionData, {
	                            screen_status: objectConstants.STATUS_COMPLETE
	                        });
	                        this.updateScreenResults(completionData);
	                        //////////////////////
	                        //COMPLETE SCREEN
	                        /////////////////////
	                        //console.log(`complete screen`);
	                    }
	                } else {
	                    this.handleContinue(completionData);
	                }
	            } else if (completionData.progression === objectConstants.OBJECT_PROGRESSION_TERMINAL) {
	                if (completionData.progressionType === objectConstants.TERMINAL_TYPE_SCREEN) {
	                    this.setState({
	                        terminateScreen: true,
	                        allowScroll: appHelper.AllowAutoProgressionIfLast(completionData.asset_type_code)
	                    });
	
	                    if (appHelper.isDefined(this.props.parentScreen)) {
	                        //////////////////////
	                        //COMPLETE SUB SCREEN
	                        /////////////////////
	                        this.props.biteCallbacks.completeScreen();
	
	                        if (!completionData.navigateToNextScreen) {
	                            this.showProgressionButton();
	                        }
	                        completionData = Object.assign({}, completionData, {
	                            screen_status: objectConstants.STATUS_COMPLETE,
	                            sub_screen_complete: true
	                        });
	
	                        this.updateScreenResults(completionData);
	                    } else {
	                        if (!completionData.navigateToNextScreen) {
	                            this.showProgressionButton();
	                        }
	                        completionData = Object.assign({}, completionData, {
	                            screen_status: objectConstants.STATUS_COMPLETE
	                        });
	                        this.updateScreenResults(completionData);
	                        //////////////////////
	                        //COMPLETE SCREEN
	                        /////////////////////
	                        //console.log(`complete screen`);
	                    }
	                } else if (completionData.progressionType === objectConstants.TERMINAL_TYPE_BITE) {
	                    this.setState({
	                        terminateBite: true,
	                        allowScroll: appHelper.AllowAutoProgressionIfLast(completionData.asset_type_code)
	                    });
	
	                    var bite = appHelper.getBiteById(this.props.biteCallbacks.getBiteId());
	                    this.props.actions.terminateBite(bite).then(function (userData) {
	
	                        if (!completionData.navigateToNextScreen) {
	                            _this3.showProgressionButton();
	                        }
	
	                        if (appHelper.isDefined(_this3.props.parentScreen)) {
	                            _this3.props.biteCallbacks.completeScreen();
	                        }
	
	                        completionData = Object.assign({}, completionData, {
	                            screen_status: objectConstants.STATUS_COMPLETE
	                        });
	
	                        _this3.updateScreenResults(completionData);
	                    }).catch(function (error) {});
	                }
	            }
	        }
	    }, {
	        key: 'updateScreenResults',
	        value: function updateScreenResults(completionData) {
	            var _this4 = this;
	
	            var params = Object.assign({}, completionData, {
	                bite_id: this.getBiteId(),
	                parent_screen_id: appHelper.isDefined(this.props.parentScreen) ? this.props.parentScreen.screen_id : undefined,
	                screen_id: this.getScreenId(),
	                object_status: completionData.status,
	                object_result: {}
	            });
	            this.props.actions.updateScreenResults(params).then(function (userData) {
	                if (appHelper.isDefined(completionData.sub_screen_complete) && completionData.sub_screen_complete && appHelper.isDefined(_this4.props.biteCallbacks.onSubScreenComplete)) {
	                    try {
	                        _this4.props.biteCallbacks.onSubScreenComplete(_this4.state.screen);
	                    } catch (err) {
	                        //  console.log('error',err);
	                    }
	                }
	                _this4.props.actions.setSuspendData(userData).then(function (trackingData) {
	                    if (completionData.screen_status === objectConstants.STATUS_COMPLETE) {
	                        _this4.props.actions.setScreenComplete(_this4.state.screen, _this4.props.parentScreen);
	                    }
	
	                    if (completionData.navigateToNextScreen && _this4.state.initialStatus !== objectConstants.STATUS_COMPLETE && _this4.state.allowGoToScreen) {
	                        _this4.navigateToNextScreen();
	                    }
	                    /*let objectIndex = appHelper.getArrayObjectIndexByKey(this.state.screen.objects,"asset_id",completionData.asset_id);
	                    if (completionData.screen_status === objectConstants.STATUS_COMPLETE  && objectIndex === this.state.screen.objects.length - 1) {
	                        if (appHelper.AllowAutoProgressionIfLast(completionData.asset_type_code)) {
	                            if (this.state.initialStatus !== objectConstants.STATUS_COMPLETE && !appHelper.isDefined(this.props.closeDialog)){
	                                this.navigateToNextScreen();
	                            } else {
	                                if (!completionData.navigateToNextScreen){
	                                    this.showProgressionButton();
	                                }
	                            }
	                        }
	                    }*/
	                }).catch(function (error) {});
	            }).catch(function (error) {});
	        }
	    }, {
	        key: 'updateResourceObjectResult',
	        value: function updateResourceObjectResult(completionData) {
	            var _this5 = this;
	
	            var params = Object.assign({}, completionData, {
	                screen_id: this.getScreenId(),
	                object_status: completionData.status
	
	            });
	            this.props.actions.updateResourceObjectResult(params).then(function (userData) {
	                _this5.props.actions.setSuspendData(userData).then(function (trackingData) {
	                    var resourceScreen = appHelper.getArrayObjectByKey(userData.resources, "screen_id", _this5.state.screen.screen_id);
	                    if (resourceScreen.status === objectConstants.STATUS_COMPLETE) {
	                        if (completionData.screen_status === objectConstants.STATUS_COMPLETE) {
	                            _this5.props.actions.setScreenComplete(_this5.state.screen);
	                        }
	                    }
	                }).catch(function (error) {});
	            }).catch(function (error) {});
	        }
	    }, {
	        key: 'updateResourceScreenResult',
	        value: function updateResourceScreenResult(completionData) {
	            var _this6 = this;
	
	            var params = Object.assign({}, completionData, {
	                screen_id: this.getScreenId(),
	                object_status: completionData.status,
	                screen_status: objectConstants.STATUS_COMPLETE
	            });
	            this.props.actions.updateResourceScreenResult(params).then(function (userData) {
	                _this6.props.actions.setSuspendData(userData).then(function (trackingData) {
	                    if (completionData.screen_status === objectConstants.STATUS_COMPLETE) {
	                        _this6.props.actions.setScreenComplete(_this6.state.screen);
	                    }
	                }).catch(function (error) {});
	            }).catch(function (error) {});
	        }
	    }, {
	        key: 'showProgressionButton',
	        value: function showProgressionButton() {
	            var nextScreenId = appHelper.getNextScreenId(this.state.screen.screen_id);
	            //if (nextScreenId.length > 0) {
	            this.setState({ showProgression: true });
	
	            //}
	        }
	    }, {
	        key: 'scrollTo',
	        value: function scrollTo(pos, allow) {
	            if (this.state.status !== objectConstants.STATUS_COMPLETE || appHelper.isDefined(allow) && allow) {
	                var feed = this.refs[this.state.screen.screen_id + '_feed'];
	                if (feed.scrollTop < pos) {
	                    _gsap.TweenLite.to(feed, objectConstants.SCROLL_SPEED, {
	                        scrollTop: pos,
	                        ease: _gsap.Expo.easeInOut
	                    }).eventCallback("onComplete", this.onScrollComplete);
	                }
	            }
	        }
	    }, {
	        key: 'onContinueBtnReveled',
	        value: function onContinueBtnReveled() {
	            this.scrollToTop();
	        }
	    }, {
	        key: 'scrollToTop',
	        value: function scrollToTop() {
	            if (this.state.initialStatus !== objectConstants.STATUS_COMPLETE && this.state.allowScroll) {
	                var anchor = this.refs[this.state.screen.screen_id + '_bottom_anchor'];
	                var scrollToOnComplete = this.scrollToOnComplete;
	                setTimeout(function () {
	                    scrollToOnComplete(anchor.offsetTop);
	                }, 1000);
	            }
	        }
	    }, {
	        key: 'scrollToOnComplete',
	        value: function scrollToOnComplete(pos) {
	            var feed = this.refs[this.state.screen.screen_id + '_feed'];
	            if (feed.scrollTop < pos) {
	                _gsap.TweenLite.to(feed, objectConstants.SCROLL_SPEED, {
	                    scrollTop: pos,
	                    ease: _gsap.Expo.easeInOut
	                }).eventCallback("onComplete", this.onScrollComplete);
	            }
	        }
	    }, {
	        key: 'onScrollComplete',
	        value: function onScrollComplete() {}
	    }, {
	        key: 'hasNextObject',
	        value: function hasNextObject(objectIndex) {
	            //let objectIndex = appHelper.getArrayObjectIndexByKey(this.state.screen.objects, "asset_id", object.asset_id);
	            return objectIndex < this.state.screen.objects.length - 1;
	        }
	    }, {
	        key: 'getLayoutClass',
	        value: function getLayoutClass() {
	            if (appHelper.isDefined(this.state.screen.assets.left) && this.state.screenIsReady) {
	                return 'left-asset-screen';
	            } else if (appHelper.isDefined(this.state.screen.assets.right) && this.state.screenIsReady) {
	                return 'right-asset-screen';
	            } else {
	                return 'full-screen';
	            }
	        }
	    }, {
	        key: 'setCharacterPose',
	        value: function setCharacterPose(object) {
	
	            var characterAsset = {};
	            if (appHelper.isDefined(object.character_pose) && object.character_pose.pose !== objectConstants.INHERIT) {
	                characterAsset = appHelper.getCharacterPose(this.state.screenCharacter, object.character_pose);
	            }
	
	            return characterAsset;
	        }
	    }, {
	        key: 'getFeedClass',
	        value: function getFeedClass() {
	            return this.state.allowClippedBlurEffect ? 'blurred-feed' : 'standard-feed';
	        }
	    }, {
	        key: 'getPanelStyle',
	        value: function getPanelStyle() {
	            if (!appHelper.isDefined(this.props.parentScreen)) {
	                return appHelper.isDefined(this.state.screen.panel_style) ? this.state.screen.panel_style : "frosted_white";
	            } else {
	                return this.props.parentScreen.screen_type === componentConstants.SCREEN_TYPE_TABBED && (this.props.parentScreen.tab_type === objectConstants.TAB_TYPE_HORIZONTAL_FRAMELESS || this.props.parentScreen.tab_type === objectConstants.TAB_TYPE_VERTICAL_FRAMELESS) && appHelper.isDefined(this.props.parentScreen.panel_style) ? this.props.parentScreen.panel_style : "";
	            }
	        }
	    }, {
	        key: 'getPanelLocation',
	        value: function getPanelLocation() {
	            return appHelper.isDefined(this.state.screen.panel_location) ? this.state.screen.panel_location : objectConstants.PANEL_LOCATION_CENTERED;
	        }
	    }, {
	        key: 'setFocusRecieved',
	        value: function setFocusRecieved() {
	            this.setState({ hasReceivedFocus: true });
	        }
	    }, {
	        key: 'focusOnNext',
	        value: function focusOnNext() {
	            this.setState({ focusOnNextObject: false });
	            var object = this.state.renderedObjects[this.state.renderedObjects.length - 1];
	            var focusEl = document.getElementById('object_' + object.data.asset_id);
	            focusEl.focus();
	        }
	    }, {
	        key: 'setScrollHeight',
	        value: function setScrollHeight() {
	            var lastObjectData = this.state.renderedObjects[this.state.renderedObjects.length - 1];
	            var overwrite = false;
	            if (appHelper.isDefined(lastObjectData)) {
	                var lastObject = document.getElementById('object_' + lastObjectData.data.asset_id);
	                var feed = this.refs[this.state.screen.screen_id + '_feed'];
	                var scrollContainer = this.refs[this.state.screen.screen_id + '_feedContainer'];
	                if (appHelper.isDefined(scrollContainer)) {
	                    var scrollHeight = scrollContainer.scrollHeight;
	                    var objectEndPos = lastObject.offsetTop + lastObject.offsetHeight;
	                    //let difference = feed.offsetHeight - lastObject.offsetHeight;
	                    var endPosIntoFeed = Math.round(objectEndPos / feed.offsetHeight);
	                    var scrollHeightIntoFeed = Math.round(scrollHeight / feed.offsetHeight);
	
	                    if (scrollHeightIntoFeed > endPosIntoFeed) {
	                        overwrite = true;
	                        scrollHeight = feed.offsetHeight * endPosIntoFeed;
	                    }
	                    if (scrollHeight > this.state.scrollHeight || overwrite) {
	                        this.setState({ scrollHeight: scrollHeight });
	                    }
	                }
	            }
	        }
	    }, {
	        key: 'allowInheritParentPanelStyle',
	        value: function allowInheritParentPanelStyle() {
	            return appHelper.isDefined(this.props.parentScreen) && this.props.parentScreen.screen_type === componentConstants.SCREEN_TYPE_TABBED && (this.props.parentScreen.tab_type === objectConstants.TAB_TYPE_HORIZONTAL_FRAMELESS || this.props.parentScreen.tab_type === objectConstants.TAB_TYPE_VERTICAL_FRAMELESS) && appHelper.isDefined(this.props.parentScreen.panel_style);
	        }
	    }, {
	        key: 'updateClippedBlur',
	        value: function updateClippedBlur() {
	            var contentArea = document.getElementById('screenWrapper');
	            var width = this.state.imageStyles.width + 48;
	            var maxWidth = contentArea.offsetWidth / 100 * 40;
	
	            if (width > maxWidth) {
	                width = maxWidth;
	            }
	
	            if (imageHelper.showAssetLeftPanel(this.state.screen)) {
	                return { clipPath: 'inset( 0px  0px 0px ' + width + 'px)', mozClipPath: 'inset( 0px 0px 0px ' + width + 'px)' };
	            } else if (imageHelper.showAssetRightPanel(this.state.screen)) {
	                return { clipPath: 'inset( 0px  ' + width + 'px 0px 0px)', mozClipPath: 'inset( 0px ' + width + 'px 0px 0px)' };
	            } else {
	                return {};
	            }
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this7 = this;
	
	            return _react2.default.createElement(
	                'div',
	                { className: 'content-screen' },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'background-container' },
	                    !appHelper.isDefined(this.props.parentScreen) && !this.state.is_resource_screen ? _react2.default.createElement('img', { src: this.getImagePath(this.state.assets.background.src), alt: '' }) : null
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'screen-container' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'content-wrapper ' + this.getPanelStyle() + ' ' + this.getPanelLocation() + ' ' + imageHelper.getScreenAssetPanelWidth(this.state.screen) },
	                        !appHelper.isDefined(this.props.parentScreen) && this.state.allowClippedBlurEffect ? _react2.default.createElement(
	                            'div',
	                            { className: 'content-wrapper-background ', style: this.updateClippedBlur() },
	                            _react2.default.createElement('img', { className: 'blur', src: this.getImagePath(this.state.assets.background.src),
	                                alt: '' })
	                        ) : null,
	                        this.allowInheritParentPanelStyle() && this.state.allowClippedBlurEffect ? _react2.default.createElement(
	                            'div',
	                            { className: 'content-wrapper-background ' },
	                            _react2.default.createElement('img', { className: 'blur', src: this.getImagePath(this.state.parentBackground.src), alt: '' })
	                        ) : null,
	                        appHelper.isDefined(this.state.screen.panel_location) && this.state.screen.panel_location === objectConstants.PANEL_LOCATION_RIGHT && appHelper.isDefined(this.state.screen.assets.left) && appHelper.isDefined(this.state.assets.screenAsset) && this.state.assets.screenAsset.src.length > 0 && this.state.screenIsReady ? _react2.default.createElement(
	                            'div',
	                            { className: 'asset-left-panel' },
	                            this.state.assets.screenAsset.type === assetConstants.ASSET_TYPE_IMAGE ? _react2.default.createElement(_SecondaryImage2.default, { screenObject: this.state.screen.assets.left, id: imageHelper.getAssetLeftPanelId(this.state.screen.screen_id) }) : _react2.default.createElement(
	                                'div',
	                                { className: 'asset-image-wrapper ' + this.state.imageClass, style: this.state.imageStyles },
	                                _react2.default.createElement('img', { src: this.getImagePath(this.state.assets.screenAsset.src), id: imageHelper.getAssetLeftPanelId(this.state.screen.screen_id), alt: '' })
	                            ),
	                            appHelper.isDefined(this.state.assets.screenAsset.credit) && this.state.assets.screenAsset.credit.length > 0 && _react2.default.createElement(
	                                'div',
	                                { className: 'image-credit', style: this.state.imageStyles },
	                                this.state.credit_label,
	                                ': ',
	                                this.state.assets.screenAsset.credit
	                            )
	                        ) : null,
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'content-area ' + this.getFeedClass(), id: this.state.screen.screen_id + '_feed_id', ref: this.state.screen.screen_id + '_feed' },
	                            appHelper.isDefined(this.state.screen.assets.left) && appHelper.isDefined(this.state.assets.screenAsset) && this.state.assets.screenAsset.src.length > 0 && this.state.screenIsReady ? _react2.default.createElement(
	                                'div',
	                                { className: 'asset-col-left' },
	                                this.state.assets.screenAsset.type === assetConstants.ASSET_TYPE_IMAGE ? _react2.default.createElement(_SecondaryImage2.default, { screenObject: this.state.screen.assets.left, id: imageHelper.getAssetLeftId(this.state.screen.screen_id) }) : _react2.default.createElement(
	                                    'div',
	                                    { className: 'asset-image-wrapper ' + this.state.imageClass, style: this.state.imageStyles },
	                                    _react2.default.createElement('img', { src: this.getImagePath(this.state.assets.screenAsset.src), alt: '', id: imageHelper.getAssetLeftId(this.state.screen.screen_id) })
	                                ),
	                                appHelper.isDefined(this.state.assets.screenAsset.credit) && this.state.assets.screenAsset.credit.length > 0 && _react2.default.createElement(
	                                    'div',
	                                    { className: 'image-credit', style: this.state.imageStyles },
	                                    this.state.credit_label,
	                                    ': ',
	                                    this.state.assets.screenAsset.credit
	                                )
	                            ) : null,
	                            _react2.default.createElement(
	                                'div',
	                                { className: this.getLayoutClass() + ' ', role: 'feed' },
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: 'feed-container', ref: this.state.screen.screen_id + '_feedContainer',
	                                        style: { minHeight: this.state.scrollHeight + 'px' } },
	                                    this.state.producerNotes.length > 0 ? _react2.default.createElement(_ProducerNotes2.default, { notes: this.state.producerNotes,
	                                        screen_id: this.state.screen.screen_id }) : null,
	                                    this.state.screenIsReady && this.state.renderedObjects.length > 0 ? this.state.renderedObjects.map(function (object, index) {
	                                        return _react2.default.createElement(
	                                            'div',
	                                            { className: 'feed-object-container', key: index,
	                                                role: 'article', tabIndex: '0', id: 'object_' + object.data.asset_id,
	                                                onFocus: _this7.setFocusRecieved },
	                                            _react2.default.createElement(object.component, { screenObject: object.data,
	                                                callbacks: _this7.state.callbacks,
	                                                characterPose: _this7.setCharacterPose(object.data),
	                                                index: appHelper.getArrayObjectIndexByKey(_this7.state.screen.objects, "asset_id", object.data.asset_id)
	                                            })
	                                        );
	                                    }) : null,
	                                    !this.state.screenIsReady ? _react2.default.createElement(_NotReadyYet2.default, { screen_id: this.state.screen.screen_id }) : null,
	                                    this.state.showProgression ? _react2.default.createElement(_Button2.default, { ref: this.state.screen.screen_id + '_button',
	                                        label: this.state.continue_label,
	                                        id: this.state.screen.screen_id + '_button',
	                                        onClick: this.navigateToNextScreen,
	                                        onRevealed: this.onContinueBtnReveled
	                                    }) : null,
	                                    _react2.default.createElement('div', { ref: this.state.screen.screen_id + '_bottom_anchor' })
	                                )
	                            ),
	                            appHelper.isDefined(this.state.screen.assets.right) && appHelper.isDefined(this.state.assets.screenAsset) && this.state.assets.screenAsset.src.length > 0 && this.state.screenIsReady ? _react2.default.createElement(
	                                'div',
	                                { className: 'asset-col-right' },
	                                this.state.assets.screenAsset.type === assetConstants.ASSET_TYPE_IMAGE ? _react2.default.createElement(_SecondaryImage2.default, { screenObject: this.state.screen.assets.right, id: imageHelper.getAssetRightId(this.state.screen.screen_id) }) : _react2.default.createElement(
	                                    'div',
	                                    { className: 'asset-image-wrapper ' + this.state.imageClass, style: this.state.imageStyles },
	                                    _react2.default.createElement('img', { src: this.getImagePath(this.state.assets.screenAsset.src), id: imageHelper.getAssetRightId(this.state.screen.screen_id), alt: '' })
	                                ),
	                                appHelper.isDefined(this.state.assets.screenAsset.credit) && this.state.assets.screenAsset.credit.length > 0 && _react2.default.createElement(
	                                    'div',
	                                    { className: 'image-credit', style: this.state.imageStyles },
	                                    this.state.credit_label,
	                                    ': ',
	                                    this.state.assets.screenAsset.credit
	                                )
	                            ) : null
	                        ),
	                        appHelper.isDefined(this.state.screen.panel_location) && this.state.screen.panel_location === objectConstants.PANEL_LOCATION_LEFT && appHelper.isDefined(this.state.screen.assets.right) && appHelper.isDefined(this.state.assets.screenAsset) && this.state.assets.screenAsset.src.length > 0 && this.state.screenIsReady ? _react2.default.createElement(
	                            'div',
	                            { className: 'asset-right-panel' },
	                            this.state.assets.screenAsset.type === assetConstants.ASSET_TYPE_IMAGE ? _react2.default.createElement(_SecondaryImage2.default, { screenObject: this.state.screen.assets.right, id: imageHelper.getAssetRightPanelId(this.state.screen.screen_id) }) : _react2.default.createElement(
	                                'div',
	                                { className: 'asset-image-wrapper ' + this.state.imageClass, style: this.state.imageStyles },
	                                _react2.default.createElement('img', { src: this.getImagePath(this.state.assets.screenAsset.src), alt: '', id: imageHelper.getAssetRightPanelId(this.state.screen.screen_id) })
	                            ),
	                            appHelper.isDefined(this.state.assets.screenAsset.credit) && this.state.assets.screenAsset.credit.length > 0 && _react2.default.createElement(
	                                'div',
	                                { className: 'image-credit', style: this.state.imageStyles },
	                                this.state.credit_label,
	                                ': ',
	                                this.state.assets.screenAsset.credit
	                            )
	                        ) : null
	                    )
	                )
	            );
	        }
	    }]);
	
	    return ScrollScreen;
	}(_react2.default.Component);
	
	ScrollScreen.propTypes = {
	    screen: _propTypes2.default.object.isRequired,
	    biteCallbacks: _propTypes2.default.object.isRequired,
	    parentScreen: _propTypes2.default.object,
	    contentData: _propTypes2.default.object.isRequired,
	    trackingData: _propTypes2.default.object.isRequired,
	    userData: _propTypes2.default.object.isRequired,
	    actions: _propTypes2.default.object.isRequired,
	    audio: _propTypes2.default.object.isRequired,
	    lang: _propTypes2.default.string.isRequired,
	    closeDialog: _propTypes2.default.func
	};
	
	ScrollScreen.contextTypes = {
	    router: _propTypes2.default.object
	};
	
	function mapStateToProps(state, ownProps) {
	    var lang = state.userData.lang;
	    return {
	        lang: lang,
	        contentData: state.contentData,
	        trackingData: state.trackingData,
	        userData: state.userData,
	        audio: state.audio
	    };
	}
	
	function mapDispatchToProps(dispatch) {
	    return {
	        actions: (0, _redux.bindActionCreators)(Object.assign({}, appDataActions, trackingDataActions, userDataActions), dispatch)
	    };
	}
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(ScrollScreen);

/***/ },
/* 543 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(5);
	
	var _redux = __webpack_require__(4);
	
	var _SliderThumbnail = __webpack_require__(544);
	
	var _SliderThumbnail2 = _interopRequireDefault(_SliderThumbnail);
	
	var _TimelineThumbnail = __webpack_require__(545);
	
	var _TimelineThumbnail2 = _interopRequireDefault(_TimelineThumbnail);
	
	var _ProducerNotes = __webpack_require__(85);
	
	var _ProducerNotes2 = _interopRequireDefault(_ProducerNotes);
	
	var _NotReadyYet = __webpack_require__(84);
	
	var _NotReadyYet2 = _interopRequireDefault(_NotReadyYet);
	
	var _Button = __webpack_require__(18);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _trackingDataActions = __webpack_require__(7);
	
	var trackingDataActions = _interopRequireWildcard(_trackingDataActions);
	
	var _appDataActions = __webpack_require__(12);
	
	var appDataActions = _interopRequireWildcard(_appDataActions);
	
	var _userDataActions = __webpack_require__(20);
	
	var userDataActions = _interopRequireWildcard(_userDataActions);
	
	var _appHelper = __webpack_require__(3);
	
	var appHelper = _interopRequireWildcard(_appHelper);
	
	var _dataHelper = __webpack_require__(11);
	
	var dataHelper = _interopRequireWildcard(_dataHelper);
	
	var _appConstants = __webpack_require__(13);
	
	var appConstants = _interopRequireWildcard(_appConstants);
	
	var _objectConstants = __webpack_require__(9);
	
	var objectConstants = _interopRequireWildcard(_objectConstants);
	
	var _assetConstants = __webpack_require__(33);
	
	var assetConstants = _interopRequireWildcard(_assetConstants);
	
	var _keyboardConstants = __webpack_require__(14);
	
	var keyboardConstants = _interopRequireWildcard(_keyboardConstants);
	
	var _localStorage = __webpack_require__(17);
	
	var localStorage = _interopRequireWildcard(_localStorage);
	
	var _userDataHelper = __webpack_require__(15);
	
	var userDataHelper = _interopRequireWildcard(_userDataHelper);
	
	var _componentHelper = __webpack_require__(31);
	
	var _gsap = __webpack_require__(8);
	
	var _gsapReactPlugin = __webpack_require__(10);
	
	var _gsapReactPlugin2 = _interopRequireDefault(_gsapReactPlugin);
	
	var _lodash = __webpack_require__(28);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } //eslint-disable-line import/no-named-as-default
	
	
	var SliderScreen = function (_React$Component) {
	    _inherits(SliderScreen, _React$Component);
	
	    function SliderScreen(props, context) {
	        _classCallCheck(this, SliderScreen);
	
	        var _this = _possibleConstructorReturn(this, (SliderScreen.__proto__ || Object.getPrototypeOf(SliderScreen)).call(this, props, context));
	
	        _this.state = {
	            lang: _this.props.lang,
	            screen: _this.props.screen,
	            userData: _this.props.userData,
	            locale: appHelper.getLocalData(_this.props.screen),
	            status: userDataHelper.getScreenUserData(_this.props.userData, _this.props.screen.screen_id).status, // objectConstants.STATUS_IN_PROGRESS,
	            callbacks: {},
	            assets: {
	                background: {
	                    src: ""
	                }
	            },
	            activeScreen: {},
	            viewedScreens: [],
	            renderedScreens: [],
	            enabledScreens: [],
	            completeScreens: [],
	            checkNextSlideBtnState: false,
	            producerNotes: appHelper.getScreenNotes(undefined, _this.props.screen),
	            screenIsReady: _this.props.screen.sub_screens.length > 0 && appHelper.canSeeContent(_this.props.screen),
	            focusedTab: _this.props.screen.sub_screens[0],
	            tabCallbacks: {},
	            updateTabIndex: false,
	            isOpenNavigation: appHelper.getBiteById(_this.props.biteCallbacks.getBiteId()).navigation_type === objectConstants.PROGRESSION_TYPE_OPEN,
	            canThumbnailsAnimate: false,
	            setThumbnailInitialState: true,
	            continue_label: appHelper.getLocaleString("continue_label")
	        };
	        _this.getScreenId = _this.getScreenId.bind(_this);
	        _this.getBiteId = _this.getBiteId.bind(_this);
	        _this.getAssets = _this.getAssets.bind(_this);
	        _this.getImagePath = _this.getImagePath.bind(_this);
	        _this.checkScreenStatus = _this.checkScreenStatus.bind(_this);
	        _this.setCallbacks = _this.setCallbacks.bind(_this);
	        _this.setEnabledTabs = _this.setEnabledTabs.bind(_this);
	        _this.setTabActive = _this.setTabActive.bind(_this);
	        _this.onSubScreenComplete = _this.onSubScreenComplete.bind(_this);
	        _this.goToNextSubScreen = _this.goToNextSubScreen.bind(_this);
	        _this.hasNextSubScreen = _this.hasNextSubScreen.bind(_this);
	        _this.checkScreenComplete = _this.checkScreenComplete.bind(_this);
	        _this.updateScreenResults = _lodash2.default.debounce(_this.updateScreenResults.bind(_this), 300);
	        _this.setScreenAccessed = _lodash2.default.debounce(_this.setScreenAccessed.bind(_this), 300);
	        _this.navigateToNextScreen = _this.navigateToNextScreen.bind(_this);
	        _this.checkScreenStatus();
	        _this.setRenderedScreens = _this.setRenderedScreens.bind(_this);
	        _this.setPrevSlideBtnDisplayState = _this.setPrevSlideBtnDisplayState.bind(_this);
	        _this.onPrevSlideBtnClicked = _this.onPrevSlideBtnClicked.bind(_this);
	        _this.setPrevSlideBtnClass = _this.setPrevSlideBtnClass.bind(_this);
	        _this.setNextSlideBtnDisplayState = _this.setNextSlideBtnDisplayState.bind(_this);
	        _this.onNextSlideBtnClicked = _this.onNextSlideBtnClicked.bind(_this);
	        _this.setNextSlideBtnClass = _this.setNextSlideBtnClass.bind(_this);
	        _this.animateSlider = _this.animateSlider.bind(_this);
	        _this.onAnimateSliderComplete = _this.onAnimateSliderComplete.bind(_this);
	        _this.setScreenHasBeenViewed = _this.setScreenHasBeenViewed.bind(_this);
	        _this.checkScreenHasBeenViewed = _this.checkScreenHasBeenViewed.bind(_this);
	        _this.checkScreenIsEnabled = _this.checkScreenIsEnabled.bind(_this);
	        _this.completeScreen = _this.completeScreen.bind(_this);
	        _this.setScreenNotReadyYet = _this.setScreenNotReadyYet.bind(_this);
	        _this.onPrevSlideKeyboardAccessed = _this.onPrevSlideKeyboardAccessed.bind(_this);
	        _this.onNextSlideKeyboardAccessed = _this.onNextSlideKeyboardAccessed.bind(_this);
	        _this.getPrevTab = _this.getPrevTab.bind(_this);
	        _this.getNextTab = _this.getNextTab.bind(_this);
	        _this.setKeyboardAccessibility = _this.setKeyboardAccessibility.bind(_this);
	        _this.setTabCallbacks = _this.setTabCallbacks.bind(_this);
	        _this.updateSlideTabIndex = _this.updateSlideTabIndex.bind(_this);
	        _this.setLayout = _this.setLayout.bind(_this);
	        _this.setThumbnailComponent = _this.setThumbnailComponent.bind(_this);
	        _this.setCanThumbnailsAnimate = _this.setCanThumbnailsAnimate.bind(_this);
	        _this.setThumbnailPosition = _lodash2.default.debounce(_this.setThumbnailPosition.bind(_this), 300);
	        _this.goToScreen = _this.goToScreen.bind(_this);
	        return _this;
	    }
	
	    _createClass(SliderScreen, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            this.setScreenAccessed();
	            this.props.biteCallbacks.showHeader(true);
	            this.props.actions.setScreenTitle(this.state.locale.title);
	            this.getAssets();
	            this.setCallbacks();
	            this.setTabCallbacks();
	            this.setCanThumbnailsAnimate();
	            if (this.state.screenIsReady) {
	                this.setEnabledTabs();
	                this.setRenderedScreens();
	                this.setTabActive(this.state.screen.sub_screens[0]);
	            } else {
	                this.setScreenNotReadyYet();
	            }
	        }
	    }, {
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(nextProps) {
	            var screenUserData = userDataHelper.getScreenUserData(nextProps.userData, this.state.screen.screen_id);
	            if (screenUserData.status === objectConstants.STATUS_COMPLETE) {
	                this.setState({
	                    status: screenUserData.status,
	                    checkNextSlideBtnState: true,
	                    enabledScreens: screenUserData.status === objectConstants.STATUS_COMPLETE ? this.state.screen.sub_screens : this.state.enabledScreens,
	                    completeScreens: screenUserData.status === objectConstants.STATUS_COMPLETE ? this.state.screen.sub_screens : this.state.completeScreens
	                });
	            } else if (this.state.isOpenNavigation) {
	                this.setState({
	                    enabledScreens: Object.assign([], this.state.screen.sub_screens)
	                });
	            }
	
	            if (this.state.lang !== nextProps.lang) {
	                this.setState({
	                    lang: nextProps.lang,
	                    locale: appHelper.getLocalData(this.state.screen),
	                    continue_label: appHelper.getLocaleString("continue_label")
	                });
	                this.props.actions.setScreenTitle(appHelper.getLocalData(this.state.screen).title);
	            }
	
	            this.setState({ userData: Object.assign({}, nextProps.userData) });
	        }
	    }, {
	        key: 'componentDidUpdate',
	        value: function componentDidUpdate() {
	            if (this.state.checkNextSlideBtnState) {
	                this.setNextSlideBtnDisplayState(this.state.activeScreen);
	            }
	
	            if (this.state.updateTabIndex) {
	                this.updateSlideTabIndex();
	            }
	
	            if (this.state.setThumbnailInitialState) {
	                this.setThumbnailPosition(0, false);
	            }
	        }
	    }, {
	        key: 'setScreenAccessed',
	        value: function setScreenAccessed() {
	            this.props.actions.setScreenAccessed(this.state.screen);
	        }
	    }, {
	        key: 'setScreenNotReadyYet',
	        value: function setScreenNotReadyYet() {
	            this.updateScreenResults(objectConstants.STATUS_COMPLETE);
	        }
	    }, {
	        key: 'checkScreenStatus',
	        value: function checkScreenStatus() {
	            var screenUserData = userDataHelper.getScreenUserData(this.state.userData, this.state.screen.screen_id);
	            if (screenUserData.status === objectConstants.STATUS_COMPLETE) {
	                this.setState({
	                    status: screenUserData.status,
	                    enabledScreens: screenUserData.status === objectConstants.STATUS_COMPLETE ? this.state.screen.sub_screens : this.state.enabledScreens,
	                    completeScreens: screenUserData.status === objectConstants.STATUS_COMPLETE ? this.state.screen.sub_screens : this.state.completeScreens
	                });
	            } else if (this.state.isOpenNavigation) {
	                this.setState({
	                    enabledScreens: Object.assign([], this.state.screen.sub_screens)
	                });
	            }
	            /* let screenStatus = getScreenUserData(this.props.userData, this.props.screen.screen_id).status;
	             let reviewMode = screenStatus === objectConstants.STATUS_COMPLETE && localStorage.post_completion_mode === appConstants.POST_COMPLETION_MODE_REVIEW;
	            // console.log(`reviewMode: ${this.state.reviewMode} - line 120`);
	             this.setState({status: screenStatus, checkCompletionStatus: true, reviewMode: reviewMode, propsUpdated: true});
	             */
	        }
	    }, {
	        key: 'getAssets',
	        value: function getAssets() {
	            var background = {};
	
	            if (appHelper.isDefined(this.state.screen.assets.background)) {
	                background = appHelper.getBackgroundAsset(this.state.screen.assets.background);
	            }
	
	            this.setState({
	                assets: Object.assign({}, this.state.assets, {
	                    background: appHelper.isDefined(background.src) ? background : this.state.assets.background
	                })
	            });
	        }
	    }, {
	        key: 'getImagePath',
	        value: function getImagePath(image) {
	            if (appConstants.DEVELOPMENT_MODE) {
	                if (appHelper.isDefined(image) && image.length > 0) {
	                    return __webpack_require__(16)("./" + image);
	                }
	            } else {
	                return image;
	            }
	        }
	    }, {
	        key: 'setCallbacks',
	        value: function setCallbacks() {
	            this.setState({
	                callbacks: Object.assign({}, this.props.biteCallbacks, {
	                    //onObjectComplete: this.onObjectComplete,
	                    getScreenId: this.getScreenId,
	                    getBiteId: this.getBiteId,
	                    onSubScreenComplete: this.onSubScreenComplete,
	                    goToNextSubScreen: this.goToNextSubScreen,
	                    hasNextSubScreen: this.hasNextSubScreen,
	                    completeScreen: this.completeScreen
	                    //objectIsEnabled: this.objectIsEnabled,
	                    //objectIsComplete: this.objectIsComplete,
	                    //storeUserResponse: this.storeUserResponse,
	                    //scrollTo: this.scrollTo,
	                    //isReviewMode: this.isReviewMode
	                })
	            });
	        }
	    }, {
	        key: 'getScreenId',
	        value: function getScreenId() {
	            return this.state.screen.screen_id;
	        }
	    }, {
	        key: 'getBiteId',
	        value: function getBiteId() {
	            //console.log(`getBiteId`);
	            return this.props.biteCallbacks.getBiteId();
	        }
	    }, {
	        key: 'setEnabledTabs',
	        value: function setEnabledTabs() {
	            if (this.state.status !== objectConstants.STATUS_COMPLETE) {
	                if (this.state.isOpenNavigation) {
	                    this.setState({
	                        enabledScreens: Object.assign([], this.state.screen.sub_screens)
	                    });
	                } else {
	                    this.setState({ enabledScreens: dataHelper.immutablePush(this.state.enabledScreens, this.state.screen.sub_screens[0]) });
	                }
	            }
	        }
	    }, {
	        key: 'checkScreenIsEnabled',
	        value: function checkScreenIsEnabled(screen) {
	            var enabledIndex = appHelper.getArrayObjectIndexByKey(this.state.enabledScreens, "screen_id", screen.screen_id);
	            return enabledIndex > -1;
	        }
	    }, {
	        key: 'checkScreenHasBeenViewed',
	        value: function checkScreenHasBeenViewed(screen) {
	            var viewedIndex = appHelper.getArrayObjectIndexByKey(this.state.viewedScreens, "screen_id", screen.screen_id);
	            return viewedIndex > -1;
	        }
	    }, {
	        key: 'updateSlideTabIndex',
	        value: function updateSlideTabIndex() {
	            var _this2 = this;
	
	            this.setState({ updateTabIndex: false });
	            var activeScreenId = this.state.activeScreen.screen_id;
	
	            var _loop = function _loop(i) {
	                var screen = _this2.state.viewedScreens[i];
	
	                var el = document.getElementById('slide_' + screen.screen_id);
	                var tabbableElements = [];
	
	                if (appHelper.isDefined(el) && el !== null) {
	                    tabbableElements = dataHelper.getAllTabbableElements(el);
	                }
	
	                _lodash2.default.forEach(tabbableElements, function (tabEl) {
	                    if (screen.screen_id === activeScreenId) {
	                        tabEl.tabIndex = 0;
	                    } else {
	                        tabEl.tabIndex = -2;
	                    }
	                });
	            };
	
	            for (var i = 0; i < this.state.viewedScreens.length; i++) {
	                _loop(i);
	            }
	        }
	    }, {
	        key: 'setTabActive',
	        value: function setTabActive(screen) {
	            //set renderedObject to empty so that when component updates we make sure we can set it again and we get exactly what we want rendered
	
	            this.setState({
	                activeScreen: screen,
	                focusedTab: screen,
	                updateTabIndex: true
	            });
	
	            this.setPrevSlideBtnDisplayState(screen);
	            this.setNextSlideBtnDisplayState(screen);
	            if (this.state.canThumbnailsAnimate) {
	                var screenIndex = appHelper.getArrayObjectIndexByKey(this.state.screen.sub_screens, "screen_id", screen.screen_id);
	                this.setThumbnailPosition(screenIndex, true);
	            }
	            this.animateSlider(screen);
	            this.setScreenHasBeenViewed(screen);
	            //this.setBackButtonDisplayState(object);
	            //this.setContinueButtonDisplayState(object);
	        }
	    }, {
	        key: 'animateSlider',
	        value: function animateSlider(screen) {
	            var screenIndex = appHelper.getArrayObjectIndexByKey(this.state.screen.sub_screens, "screen_id", screen.screen_id);
	            var slider = this.refs[this.state.screen.screen_id + '_slide_container'];
	            var leftPos = 0 - screenIndex * 100;
	            if (appHelper.isDefined(slider)) {
	                _gsap.TweenLite.to(slider, 1, {
	                    left: leftPos + '%',
	                    ease: _gsap.Expo.easeInOut,
	                    onComplete: this.onAnimateSliderComplete,
	                    onCompleteParams: [screen]
	                });
	            }
	        }
	    }, {
	        key: 'onAnimateSliderComplete',
	        value: function onAnimateSliderComplete(screen) {
	            //viewedObjects
	            this.setScreenHasBeenViewed(screen);
	        }
	    }, {
	        key: 'setScreenHasBeenViewed',
	        value: function setScreenHasBeenViewed(screen) {
	            var viewedIndex = appHelper.getArrayObjectIndexByKey(this.state.viewedScreens, "screen_id", screen.screen_id);
	            if (viewedIndex === -1) {
	                this.setState({ viewedScreens: dataHelper.immutablePush(this.state.viewedScreens, screen) });
	            }
	        }
	    }, {
	        key: 'setRenderedScreens',
	        value: function setRenderedScreens() {
	            var renderedScreens = [];
	            _lodash2.default.forEach(this.state.screen.sub_screens, function (sub_screen) {
	                var screenType = Object.assign({}, (0, _componentHelper.getScreenComponentByType)(sub_screen.screen_type), {
	                    data: sub_screen
	                });
	                renderedScreens = dataHelper.immutablePush(renderedScreens, screenType);
	            });
	
	            this.setState({ renderedScreens: Object.assign([], renderedScreens) });
	        }
	    }, {
	        key: 'setPrevSlideBtnDisplayState',
	        value: function setPrevSlideBtnDisplayState(screen) {
	            var screenIndex = appHelper.getArrayObjectIndexByKey(this.state.screen.sub_screens, "screen_id", screen.screen_id);
	            this.setState({ enablePrevSlideBtn: screenIndex > 0 });
	        }
	    }, {
	        key: 'onPrevSlideBtnClicked',
	        value: function onPrevSlideBtnClicked() {
	            if (this.state.enablePrevSlideBtn) {
	                var screenIndex = appHelper.getArrayObjectIndexByKey(this.state.screen.sub_screens, "screen_id", this.state.activeScreen.screen_id);
	                if (screenIndex > 0) {
	                    this.setTabActive(this.state.screen.sub_screens[screenIndex - 1]);
	                }
	            }
	        }
	    }, {
	        key: 'setPrevSlideBtnClass',
	        value: function setPrevSlideBtnClass() {
	            return this.state.enablePrevSlideBtn ? "" : "disabled";
	        }
	    }, {
	        key: 'setNextSlideBtnDisplayState',
	        value: function setNextSlideBtnDisplayState(screen) {
	            if (appHelper.isDefined(screen)) {
	                var screenIndex = appHelper.getArrayObjectIndexByKey(this.state.screen.sub_screens, "screen_id", screen.screen_id);
	                if (screenIndex < this.state.screen.sub_screens.length - 1) {
	                    var nextScreen = this.state.screen.sub_screens[screenIndex + 1];
	                    var nextScreenEnabled = appHelper.getArrayObjectIndexByKey(this.state.enabledScreens, "screen_id", nextScreen.screen_id);
	                    this.setState({
	                        enableNextSlideBtn: this.state.status === objectConstants.STATUS_COMPLETE || this.state.isOpenNavigation ? true : nextScreenEnabled > -1,
	                        //enableNextSlideBtn: this.state.status === objectConstants.STATUS_COMPLETE,
	                        checkNextSlideBtnState: false
	                    });
	                } else {
	                    this.setState({
	                        enableNextSlideBtn: this.state.status === objectConstants.STATUS_COMPLETE || this.state.isOpenNavigation,
	                        checkNextSlideBtnState: false
	                    });
	                }
	            }
	        }
	    }, {
	        key: 'onNextSlideBtnClicked',
	        value: function onNextSlideBtnClicked() {
	            if (this.state.enableNextSlideBtn) {
	
	                var screenIndex = appHelper.getArrayObjectIndexByKey(this.state.screen.sub_screens, "screen_id", this.state.activeScreen.screen_id);
	                if ((this.state.status === objectConstants.STATUS_COMPLETE || this.state.isOpenNavigation) && screenIndex === this.state.screen.sub_screens.length - 1) {
	                    this.navigateToNextScreen();
	                } else {
	                    if (this.hasNextSubScreen(this.state.activeScreen)) {
	                        this.setTabActive(this.state.screen.sub_screens[screenIndex + 1]);
	                    }
	                }
	            }
	        }
	    }, {
	        key: 'setNextSlideBtnClass',
	        value: function setNextSlideBtnClass() {
	            return this.state.enableNextSlideBtn ? "" : "disabled";
	        }
	    }, {
	        key: 'onSubScreenComplete',
	        value: function onSubScreenComplete(screen) {
	            //console.log(screen);
	            var completionIndex = appHelper.getArrayObjectIndexByKey(this.state.completeScreens, "screen_id", screen.screen_id);
	            var subScreenIndex = appHelper.getArrayObjectIndexByKey(this.state.screen.sub_screens, "screen_id", screen.screen_id);
	            var nextScreen = {};
	
	            if (subScreenIndex < this.state.screen.sub_screens.length - 1) {
	                nextScreen = Object.assign({}, this.state.screen.sub_screens[subScreenIndex + 1]);
	            }
	
	            if (completionIndex === -1) {
	                this.setState({
	                    completeScreens: dataHelper.immutablePush(this.state.completeScreens, screen),
	                    enabledScreens: typeof nextScreen.screen_id !== "undefined" ? dataHelper.immutablePush(this.state.enabledScreens, nextScreen) : Object.assign([], this.state.enabledScreens),
	                    checkContinueBtnState: true,
	                    checkNextSlideBtnState: true
	                });
	
	                // this.updateScreenResults(this.state.status !== objectConstants.STATUS_COMPLETE ? objectConstants.STATUS_IN_PROGRESS: objectConstants.STATUS_COMPLETE, screen.screen_id);
	            }
	
	            this.checkScreenComplete();
	            this.setNextSlideBtnDisplayState(screen);
	        }
	    }, {
	        key: 'hasNextSubScreen',
	        value: function hasNextSubScreen(screen) {
	            var subScreenIndex = appHelper.getArrayObjectIndexByKey(this.state.screen.sub_screens, "screen_id", screen.screen_id);
	            return subScreenIndex < this.state.screen.sub_screens.length - 1;
	        }
	    }, {
	        key: 'goToNextSubScreen',
	        value: function goToNextSubScreen(screen) {
	            var subScreenIndex = appHelper.getArrayObjectIndexByKey(this.state.screen.sub_screens, "screen_id", screen.screen_id);
	            if (this.hasNextSubScreen(screen)) {
	                var nextScreen = Object.assign({}, this.state.screen.sub_screens[subScreenIndex + 1]);
	                this.setTabActive(nextScreen);
	            } else {
	                this.navigateToNextScreen();
	            }
	        }
	    }, {
	        key: 'goToScreen',
	        value: function goToScreen(goTo) {
	            this.props.actions.setNewLessonLocation(goTo);
	        }
	    }, {
	        key: 'navigateToNextScreen',
	        value: function navigateToNextScreen() {
	            if (appHelper.isDefined(this.state.screen.next_screen_id) && !isNaN(this.state.screen.next_screen_id)) {
	                this.goToScreen(this.state.screen.next_screen_id);
	            } else {
	                var nextScreenId = appHelper.getNextScreenId(this.getScreenId());
	                if (localStorage.bites.length > 1 && nextScreenId.length === 0) {
	                    this.context.router.push('menu');
	                } else {
	                    this.goToScreen(nextScreenId);
	                }
	            }
	        }
	    }, {
	        key: 'checkScreenComplete',
	        value: function checkScreenComplete() {
	            if (this.state.completeScreens.length >= this.state.screen.sub_screens.length) {
	                this.setState({
	                    status: objectConstants.STATUS_COMPLETE
	                });
	                this.updateScreenResults(objectConstants.STATUS_COMPLETE);
	            }
	        }
	
	        //used when child screen terminates
	
	    }, {
	        key: 'completeScreen',
	        value: function completeScreen() {
	            this.setState({
	                status: objectConstants.STATUS_COMPLETE
	            });
	            this.updateScreenResults(objectConstants.STATUS_COMPLETE);
	        }
	    }, {
	        key: 'updateScreenResults',
	        value: function updateScreenResults(screen_status) {
	            var _this3 = this;
	
	            var params = {
	                bite_id: this.getBiteId(),
	                screen_id: this.getScreenId(),
	                screen_status: screen_status,
	                object_status: objectConstants.STATUS_COMPLETE
	            };
	            this.props.actions.updateScreenResults(params).then(function (userData) {
	                _this3.props.actions.setSuspendData(userData).then(function (trackingData) {
	                    if (screen_status === objectConstants.STATUS_COMPLETE) {
	                        _this3.props.actions.setScreenComplete(_this3.state.screen);
	                    }
	                }).catch(function (error) {});
	            }).catch(function (error) {});
	        }
	    }, {
	        key: 'onPrevSlideKeyboardAccessed',
	        value: function onPrevSlideKeyboardAccessed(event) {
	            if (event.which === keyboardConstants.ENTER_KEY || event.which === keyboardConstants.SPACEBAR_KEY) {
	                event.preventDefault();
	                this.onPrevSlideBtnClicked();
	            }
	        }
	    }, {
	        key: 'onNextSlideKeyboardAccessed',
	        value: function onNextSlideKeyboardAccessed(event) {
	            if (event.which === keyboardConstants.ENTER_KEY || event.which === keyboardConstants.SPACEBAR_KEY) {
	                event.preventDefault();
	                if (this.checkScreenIsEnabled(this.state.focusedTab)) {
	                    this.onNextSlideBtnClicked();
	                }
	            }
	        }
	    }, {
	        key: 'getPrevTab',
	        value: function getPrevTab() {
	            var tabIndex = appHelper.getArrayObjectIndexByKey(this.state.screen.sub_screens, "screen_id", this.state.focusedTab.screen_id);
	            var nextTab = this.state.screen.sub_screens[tabIndex - 1];
	            if (tabIndex <= 0) {
	                nextTab = this.state.screen.sub_screens[this.state.screen.sub_screens.length - 1];
	            }
	            this.setState({ focusedTab: Object.assign({}, nextTab) });
	        }
	    }, {
	        key: 'getNextTab',
	        value: function getNextTab() {
	            var tabIndex = appHelper.getArrayObjectIndexByKey(this.state.screen.sub_screens, "screen_id", this.state.focusedTab.screen_id);
	            var nextTab = this.state.screen.sub_screens[tabIndex + 1];
	            if (tabIndex === this.state.screen.sub_screens.length - 1) {
	                nextTab = this.state.screen.sub_screens[0];
	            }
	            this.setState({ focusedTab: Object.assign({}, nextTab) });
	        }
	    }, {
	        key: 'setKeyboardAccessibility',
	        value: function setKeyboardAccessibility(event) {
	            if (event.which === keyboardConstants.ENTER_KEY || event.which === keyboardConstants.SPACEBAR_KEY) {
	                event.preventDefault();
	                if (appHelper.getArrayObjectIndexByKey(this.state.enabledScreens, "screen_id", this.state.focusedTab.screen_id) > -1) {
	                    this.setTabActive(this.state.focusedTab);
	                }
	            }
	
	            if (event.which === keyboardConstants.ARROW_LEFT_KEY) {
	                event.preventDefault();
	                this.getPrevTab();
	            }
	
	            if (event.which === keyboardConstants.ARROW_RIGHT_KEY) {
	                event.preventDefault();
	                this.getNextTab();
	            }
	
	            if (event.which === keyboardConstants.ARROW_UP_KEY) {
	                event.preventDefault();
	                this.getPrevTab();
	            }
	
	            if (event.which === keyboardConstants.ARROW_DOWN_KEY) {
	                event.preventDefault();
	                this.getNextTab();
	            }
	        }
	    }, {
	        key: 'setTabCallbacks',
	        value: function setTabCallbacks() {
	            this.setState({
	                tabCallbacks: Object.assign({}, this.state.tabCallbacks, {
	                    setKeyboardAccessibility: this.setKeyboardAccessibility
	                })
	            });
	        }
	    }, {
	        key: 'setLayout',
	        value: function setLayout() {
	            if (appHelper.isDefined(this.state.screen.slider_type) && this.state.screen.slider_type === objectConstants.SLIDER_TYPE_HORIZONTAL_TIMELINE) {
	                return "horz-slider-timeline";
	            } else {
	                return "horz-slider-screen";
	            }
	        }
	    }, {
	        key: 'setThumbnailComponent',
	        value: function setThumbnailComponent() {
	            if (appHelper.isDefined(this.state.screen.slider_type) && this.state.screen.slider_type === objectConstants.SLIDER_TYPE_HORIZONTAL_TIMELINE) {
	                return _TimelineThumbnail2.default;
	            } else {
	                return _SliderThumbnail2.default;
	            }
	        }
	    }, {
	        key: 'setCanThumbnailsAnimate',
	        value: function setCanThumbnailsAnimate() {
	            var canAnimate = false;
	            if (appHelper.isDefined(this.state.screen.slider_type) && this.state.screen.slider_type === objectConstants.SLIDER_TYPE_HORIZONTAL_TIMELINE) {
	                canAnimate = true;
	            }
	            this.setState({
	                canThumbnailsAnimate: canAnimate,
	                setThumbnailInitialState: canAnimate
	            });
	        }
	    }, {
	        key: 'setThumbnailPosition',
	        value: function setThumbnailPosition(screenIndex, animate) {
	            this.setState({
	                setThumbnailInitialState: false
	            });
	
	            var sliderContainer = this.refs[this.state.screen.screen_id + '_thumbnailContainer'];
	            var slider = this.refs[this.state.screen.screen_id + '_thumbnails'];
	            var thumbnail = document.getElementById('thumbnail_' + this.state.screen.sub_screens[screenIndex].screen_id);
	            var sliderContainer_width = sliderContainer.offsetWidth;
	            var thumbnail_width = thumbnail.offsetWidth;
	            //console.log(`thumbnail_width`,thumbnail_width);
	            var thumbnail_left = thumbnail.offsetWidth * screenIndex;
	            //console.log(`thumbnail_left`,thumbnail_left);
	
	
	            // let leftPos = (sliderContainer_width / 2) - (thumbnail_width / 2) - thumbnail_left + 12;
	            var leftPos = sliderContainer_width / 2 - thumbnail_width / 2 - thumbnail_left + 6;
	            //console.log(`leftPos`,leftPos);
	            if (appHelper.isDefined(slider)) {
	
	                if (animate) {
	                    _gsap.TweenLite.to(slider, 0.5, {
	                        left: leftPos
	                    });
	                } else {
	                    _gsap.TweenLite.set(slider, {
	                        left: leftPos,
	                        opacity: 1
	                    });
	                }
	            }
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this4 = this;
	
	            var ThumbnailComponent = this.setThumbnailComponent();
	            var layoutStyle = this.setLayout();
	            return _react2.default.createElement(
	                'div',
	                { className: 'customer-scenario' },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'background-container' },
	                    _react2.default.createElement('img', { src: this.getImagePath(this.state.assets.background.src), alt: '' })
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'screen-container' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: '' + layoutStyle },
	                        this.state.screen.sub_screens.length > 1 ? _react2.default.createElement('div', { className: 'slider-prev-slide-btn ' + this.setPrevSlideBtnClass(),
	                            onClick: this.onPrevSlideBtnClicked, onKeyDown: this.onPrevSlideKeyboardAccessed,
	                            role: 'link', tabIndex: '0' }) : null,
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'slider-container', ref: this.state.screen.screen_id + '_sliderContainer' },
	                            this.state.screen.sub_screens.length > 1 ? _react2.default.createElement(
	                                'div',
	                                { className: 'thumbnail-wrapper' },
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: 'thumbnail-container ' + (this.state.screen.include_icon ? "icon-list" : "") + ' ', ref: this.state.screen.screen_id + '_thumbnailContainer' },
	                                    _react2.default.createElement(
	                                        'div',
	                                        { className: 'thumbnail-list ',
	                                            role: 'tablist',
	                                            ref: this.state.screen.screen_id + '_thumbnails' },
	                                        this.state.screen.sub_screens.map(function (sub_screen, index) {
	                                            return typeof _this4.state.activeScreen.screen_id !== "undefined" && _this4.state.screenIsReady ? _react2.default.createElement(ThumbnailComponent, { key: sub_screen.screen_id + '_thumbnail',
	                                                index: index,
	                                                parentScreen: _this4.state.screen,
	                                                screen: sub_screen,
	                                                activeScreenId: _this4.state.activeScreen.screen_id,
	                                                enabledScreens: _this4.state.enabledScreens,
	                                                completeScreens: _this4.state.completeScreens,
	                                                onClickFunc: _this4.setTabActive,
	                                                focusedTab: _this4.state.focusedTab,
	                                                tabCallbacks: _this4.state.tabCallbacks
	                                            }) : null;
	                                        })
	                                    )
	                                )
	                            ) : null,
	                            _react2.default.createElement(
	                                'div',
	                                {
	                                    className: 'slider-body-content ' + (this.state.screen.sub_screens.length < 2 ? "single-slider" : "") + ' ' + (this.state.screen.include_icon ? "icon-body" : ""),
	                                    ref: this.state.screen.screen_id + '_feed' },
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: 'slide-container', ref: this.state.screen.screen_id + '_slide_container' },
	                                    this.state.renderedScreens.map(function (renderedScreen) {
	                                        return _react2.default.createElement(
	                                            'div',
	                                            { key: renderedScreen.data.screen_id, className: 'slide', role: 'tabpanel',
	                                                id: 'slide_' + renderedScreen.data.screen_id },
	                                            _this4.checkScreenIsEnabled(renderedScreen.data) && _this4.checkScreenHasBeenViewed(renderedScreen.data) && _this4.state.screenIsReady ? _react2.default.createElement(renderedScreen.component, { screen: renderedScreen.data,
	                                                parentScreen: _this4.state.screen,
	                                                biteCallbacks: _this4.state.callbacks }) : null
	                                        );
	                                    }),
	                                    !this.state.screenIsReady ? _react2.default.createElement(
	                                        'div',
	                                        null,
	                                        this.state.producerNotes.length > 0 ? _react2.default.createElement(_ProducerNotes2.default, { notes: this.state.producerNotes,
	                                            screen_id: this.state.screen.screen_id }) : null,
	                                        _react2.default.createElement(_NotReadyYet2.default, { screen_id: this.state.screen.screen_id }),
	                                        _react2.default.createElement(_Button2.default, { ref: this.state.screen.screen_id + '_button',
	                                            label: this.state.continue_label,
	                                            id: this.state.screen.screen_id + '_button',
	                                            onClick: this.navigateToNextScreen,
	                                            onRevealed: this.onContinueBtnReveled })
	                                    ) : null
	                                )
	                            )
	                        ),
	                        this.state.screen.sub_screens.length > 1 ? _react2.default.createElement('div', { className: 'slider-next-slide-btn ' + this.setNextSlideBtnClass(),
	                            onClick: this.onNextSlideBtnClicked, onKeyDown: this.onNextSlideKeyboardAccessed,
	                            role: 'link', tabIndex: '0' }) : null
	                    )
	                )
	            );
	        }
	    }]);
	
	    return SliderScreen;
	}(_react2.default.Component);
	
	/*
	* <div className="tabbed-body-footer">
	                            <div className="text-center">
	                                footer
	
	                            </div>
	                        </div>
	* */
	
	SliderScreen.propTypes = {
	    screen: _propTypes2.default.object.isRequired,
	    biteCallbacks: _propTypes2.default.object.isRequired,
	    titles: _propTypes2.default.object.isRequired,
	    actions: _propTypes2.default.object.isRequired,
	    userData: _propTypes2.default.object.isRequired,
	    lang: _propTypes2.default.string.isRequired
	};
	
	SliderScreen.contextTypes = {
	    router: _propTypes2.default.object
	
	};
	
	function mapStateToProps(state, ownProps) {
	    var lang = state.userData.lang;
	    return {
	        lang: lang,
	        titles: state.titles,
	        userData: state.userData
	    };
	}
	
	function mapDispatchToProps(dispatch) {
	    return {
	        actions: (0, _redux.bindActionCreators)(Object.assign({}, appDataActions, trackingDataActions, userDataActions), dispatch)
	    };
	}
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(SliderScreen);

/***/ },
/* 544 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(5);
	
	var _redux = __webpack_require__(4);
	
	var _trackingDataActions = __webpack_require__(7);
	
	var trackingDataActions = _interopRequireWildcard(_trackingDataActions);
	
	var _appHelper = __webpack_require__(3);
	
	var appHelper = _interopRequireWildcard(_appHelper);
	
	var _objectConstants = __webpack_require__(9);
	
	var objectConstants = _interopRequireWildcard(_objectConstants);
	
	var _appConstants = __webpack_require__(13);
	
	var appConstants = _interopRequireWildcard(_appConstants);
	
	var _keyboardConstants = __webpack_require__(14);
	
	var keyboardConstants = _interopRequireWildcard(_keyboardConstants);
	
	var _gsap = __webpack_require__(8);
	
	var _gsapReactPlugin = __webpack_require__(10);
	
	var _gsapReactPlugin2 = _interopRequireDefault(_gsapReactPlugin);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var SliderThumbnail = function (_React$Component) {
	    _inherits(SliderThumbnail, _React$Component);
	
	    function SliderThumbnail(props, context) {
	        _classCallCheck(this, SliderThumbnail);
	
	        var _this = _possibleConstructorReturn(this, (SliderThumbnail.__proto__ || Object.getPrototypeOf(SliderThumbnail)).call(this, props, context));
	
	        _this.state = {
	            lang: _this.props.lang,
	            parentScreen: _this.props.parentScreen,
	            screen: _this.props.screen,
	            activeScreenId: _this.props.activeScreenId,
	            enabledScreens: _this.props.enabledScreens,
	            completeScreens: _this.props.completeScreens,
	            focusedTab: _this.props.focusedTab,
	            className: "",
	            locale: appHelper.getLocalData(_this.props.screen),
	            update: false,
	            focusedClass: "not-focused",
	            icon: {}
	        };
	        _this.setClass = _this.setClass.bind(_this);
	        _this.onClicked = _this.onClicked.bind(_this);
	        _this.screenIsEnabled = _this.screenIsEnabled.bind(_this);
	        _this.screenIsComplete = _this.screenIsComplete.bind(_this);
	        _this.setFocus = _this.setFocus.bind(_this);
	        _this.setBlur = _this.setBlur.bind(_this);
	        _this.getAssets = _this.getAssets.bind(_this);
	        _this.getImagePath = _this.getImagePath.bind(_this);
	        return _this;
	    }
	
	    _createClass(SliderThumbnail, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            this.setClass();
	            if (this.state.parentScreen.include_icon) {
	                this.getAssets();
	            }
	        }
	    }, {
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(nextProps) {
	            if (this.state.enabledScreens !== nextProps.enabledScreens || this.state.completeScreens !== nextProps.completeScreens || this.state.activeScreenId !== nextProps.activeScreenId) {
	                this.setState({
	                    update: true
	                });
	            }
	
	            if (this.state.focusedTab.screen_id !== nextProps.focusedTab.screen_id) {
	                this.setState({ focusedTab: Object.assign({}, nextProps.focusedTab), update: true });
	            }
	
	            if (this.state.lang !== nextProps.lang) {
	                this.setState({
	                    lang: nextProps.lang,
	                    locale: appHelper.getLocalData(this.state.screen)
	                });
	            }
	        }
	    }, {
	        key: 'componentDidUpdate',
	        value: function componentDidUpdate() {
	            if (this.state.update) {
	                if (this.state.focusedTab.screen_id === this.state.screen.screen_id) {
	                    var focusEl = this.refs['tab_' + this.state.screen.screen_id];
	                    focusEl.focus();
	                }
	                this.setClass();
	            }
	        }
	    }, {
	        key: 'screenIsEnabled',
	        value: function screenIsEnabled() {
	            return appHelper.getArrayObjectIndexByKey(this.props.enabledScreens, "screen_id", this.state.screen.screen_id);
	        }
	    }, {
	        key: 'screenIsComplete',
	        value: function screenIsComplete() {
	            return appHelper.getArrayObjectIndexByKey(this.props.completeScreens, "screen_id", this.state.screen.screen_id);
	        }
	    }, {
	        key: 'setClass',
	        value: function setClass() {
	            var className = "";
	
	            if (this.state.screen.screen_id === this.props.activeScreenId) {
	                className += "active ";
	            }
	
	            if (this.screenIsEnabled() === -1) {
	                className += "disabled ";
	            }
	
	            if (this.screenIsComplete() > -1) {
	                className += "complete ";
	            } else {
	                className += "incomplete ";
	            }
	
	            this.setState({ className: className, update: false });
	        }
	    }, {
	        key: 'onClicked',
	        value: function onClicked() {
	            if (this.screenIsEnabled() > -1) {
	                this.props.onClickFunc(this.state.screen);
	            }
	        }
	    }, {
	        key: 'setFocus',
	        value: function setFocus() {
	            this.setState({ focusedClass: "focused" });
	        }
	    }, {
	        key: 'setBlur',
	        value: function setBlur() {
	            this.setState({ focusedClass: "not-focused" });
	        }
	    }, {
	        key: 'getAssets',
	        value: function getAssets() {
	            var icon = {};
	
	            if (appHelper.isDefined(this.state.screen.assets.icon)) {
	                icon = appHelper.getIconAsset(this.state.screen.assets.icon);
	            }
	
	            this.setState({
	                icon: Object.assign({}, icon)
	            });
	        }
	    }, {
	        key: 'getImagePath',
	        value: function getImagePath(image) {
	            if (appConstants.DEVELOPMENT_MODE) {
	                if (appHelper.isDefined(image) && image.length > 0) {
	                    return __webpack_require__(16)("./" + image);
	                }
	            } else {
	                return image;
	            }
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            return this.state.parentScreen.include_icon && appHelper.isDefined(this.state.icon.src) ? _react2.default.createElement(
	                'div',
	                { className: 'thumbnail-item ' + this.state.className + ' ' + this.state.focusedClass,
	                    onClick: this.onClicked,
	                    onKeyDown: this.props.tabCallbacks.setKeyboardAccessibility,
	                    onFocus: this.setFocus,
	                    onBlur: this.setBlur,
	                    role: 'tab',
	                    ref: 'tab_' + this.state.screen.screen_id,
	                    id: 'tab_' + this.state.screen.screen_id,
	                    tabIndex: this.state.focusedTab.screen_id === this.state.screen.screen_id ? 0 : -1,
	                    'aria-disabled': this.screenIsEnabled(),
	                    'aria-current': this.state.screen.screen_id === this.props.activeScreenId },
	                _react2.default.createElement('img', { src: this.getImagePath(this.state.icon.src), alt: '' })
	            ) : _react2.default.createElement('div', { className: 'thumbnail-item ' + this.state.className + ' ' + this.state.focusedClass,
	                onClick: this.onClicked,
	                onKeyDown: this.props.tabCallbacks.setKeyboardAccessibility,
	                onFocus: this.setFocus,
	                onBlur: this.setBlur,
	                role: 'tab',
	                ref: 'tab_' + this.state.screen.screen_id,
	                id: 'tab_' + this.state.screen.screen_id,
	                tabIndex: this.state.focusedTab.screen_id === this.state.screen.screen_id ? 0 : -1,
	                'aria-disabled': this.screenIsEnabled(),
	                'aria-current': this.state.screen.screen_id === this.props.activeScreenId });
	        }
	    }]);
	
	    return SliderThumbnail;
	}(_react2.default.Component);
	
	SliderThumbnail.propTypes = {
	    parentScreen: _propTypes2.default.object.isRequired,
	    screen: _propTypes2.default.object.isRequired,
	    activeScreenId: _propTypes2.default.number.isRequired,
	    enabledScreens: _propTypes2.default.array.isRequired,
	    completeScreens: _propTypes2.default.array.isRequired,
	    onClickFunc: _propTypes2.default.func,
	    focusedTab: _propTypes2.default.object,
	    tabCallbacks: _propTypes2.default.object,
	    lang: _propTypes2.default.string.isRequired,
	    index: _propTypes2.default.number,
	    actions: _propTypes2.default.object
	};
	
	SliderThumbnail.contextTypes = {
	    router: _propTypes2.default.object
	};
	
	function mapStateToProps(state, ownProps) {
	    var lang = state.userData.lang;
	    return {
	        lang: lang
	    };
	}
	
	function mapDispatchToProps(dispatch) {
	    return {
	        actions: (0, _redux.bindActionCreators)(Object.assign({}, trackingDataActions), dispatch)
	    };
	}
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(SliderThumbnail);

/***/ },
/* 545 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(5);
	
	var _redux = __webpack_require__(4);
	
	var _trackingDataActions = __webpack_require__(7);
	
	var trackingDataActions = _interopRequireWildcard(_trackingDataActions);
	
	var _appHelper = __webpack_require__(3);
	
	var appHelper = _interopRequireWildcard(_appHelper);
	
	var _objectConstants = __webpack_require__(9);
	
	var objectConstants = _interopRequireWildcard(_objectConstants);
	
	var _appConstants = __webpack_require__(13);
	
	var appConstants = _interopRequireWildcard(_appConstants);
	
	var _keyboardConstants = __webpack_require__(14);
	
	var keyboardConstants = _interopRequireWildcard(_keyboardConstants);
	
	var _gsap = __webpack_require__(8);
	
	var _gsapReactPlugin = __webpack_require__(10);
	
	var _gsapReactPlugin2 = _interopRequireDefault(_gsapReactPlugin);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var TimelineThumbnail = function (_React$Component) {
	    _inherits(TimelineThumbnail, _React$Component);
	
	    function TimelineThumbnail(props, context) {
	        _classCallCheck(this, TimelineThumbnail);
	
	        var _this = _possibleConstructorReturn(this, (TimelineThumbnail.__proto__ || Object.getPrototypeOf(TimelineThumbnail)).call(this, props, context));
	
	        _this.state = {
	            lang: _this.props.lang,
	            parentScreen: _this.props.parentScreen,
	            screen: _this.props.screen,
	            activeScreenId: _this.props.activeScreenId,
	            enabledScreens: _this.props.enabledScreens,
	            completeScreens: _this.props.completeScreens,
	            focusedTab: _this.props.focusedTab,
	            className: "",
	            locale: appHelper.getLocalData(_this.props.screen),
	            update: false,
	            focusedClass: "not-focused",
	            icon: {}
	        };
	        _this.setClass = _this.setClass.bind(_this);
	        _this.onClicked = _this.onClicked.bind(_this);
	        _this.screenIsEnabled = _this.screenIsEnabled.bind(_this);
	        _this.screenIsComplete = _this.screenIsComplete.bind(_this);
	        _this.setFocus = _this.setFocus.bind(_this);
	        _this.setBlur = _this.setBlur.bind(_this);
	        _this.getAssets = _this.getAssets.bind(_this);
	        _this.getImagePath = _this.getImagePath.bind(_this);
	        return _this;
	    }
	
	    _createClass(TimelineThumbnail, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            this.setClass();
	            if (this.state.parentScreen.include_icon) {
	                this.getAssets();
	            }
	        }
	    }, {
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(nextProps) {
	            if (this.state.enabledScreens !== nextProps.enabledScreens || this.state.completeScreens !== nextProps.completeScreens || this.state.activeScreenId !== nextProps.activeScreenId) {
	                this.setState({
	                    update: true
	                });
	            }
	
	            if (this.state.focusedTab.screen_id !== nextProps.focusedTab.screen_id) {
	                this.setState({ focusedTab: Object.assign({}, nextProps.focusedTab), update: true });
	            }
	
	            if (this.state.lang !== nextProps.lang) {
	                this.setState({
	                    lang: nextProps.lang,
	                    locale: appHelper.getLocalData(this.state.screen)
	                });
	            }
	        }
	    }, {
	        key: 'componentDidUpdate',
	        value: function componentDidUpdate() {
	            if (this.state.update) {
	                if (this.state.focusedTab.screen_id === this.state.screen.screen_id) {
	                    var focusEl = this.refs['tab_' + this.state.screen.screen_id];
	                    focusEl.focus();
	                }
	                this.setClass();
	            }
	        }
	    }, {
	        key: 'screenIsEnabled',
	        value: function screenIsEnabled() {
	            return appHelper.getArrayObjectIndexByKey(this.props.enabledScreens, "screen_id", this.state.screen.screen_id);
	        }
	    }, {
	        key: 'screenIsComplete',
	        value: function screenIsComplete() {
	            return appHelper.getArrayObjectIndexByKey(this.props.completeScreens, "screen_id", this.state.screen.screen_id);
	        }
	    }, {
	        key: 'setClass',
	        value: function setClass() {
	            var className = "";
	
	            if (this.state.screen.screen_id === this.props.activeScreenId) {
	                className += "active ";
	            }
	
	            if (this.screenIsEnabled() === -1) {
	                className += "disabled ";
	            }
	
	            if (this.screenIsComplete() > -1) {
	                className += "complete ";
	            } else {
	                className += "incomplete ";
	            }
	
	            this.setState({ className: className, update: false });
	        }
	    }, {
	        key: 'onClicked',
	        value: function onClicked() {
	            if (this.screenIsEnabled() > -1) {
	                this.props.onClickFunc(this.state.screen);
	            }
	        }
	    }, {
	        key: 'setFocus',
	        value: function setFocus() {
	            this.setState({ focusedClass: "focused" });
	        }
	    }, {
	        key: 'setBlur',
	        value: function setBlur() {
	            this.setState({ focusedClass: "not-focused" });
	        }
	    }, {
	        key: 'getAssets',
	        value: function getAssets() {
	            var icon = {};
	
	            if (appHelper.isDefined(this.state.screen.assets.icon)) {
	                icon = appHelper.getIconAsset(this.state.screen.assets.icon);
	            }
	
	            this.setState({
	                icon: Object.assign({}, icon)
	            });
	        }
	    }, {
	        key: 'getImagePath',
	        value: function getImagePath(image) {
	            if (appConstants.DEVELOPMENT_MODE) {
	                if (appHelper.isDefined(image) && image.length > 0) {
	                    return __webpack_require__(16)("./" + image);
	                }
	            } else {
	                return image;
	            }
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            return _react2.default.createElement(
	                'div',
	                { className: 'thumbnail-item ' + this.state.className + ' ' + this.state.focusedClass,
	                    onClick: this.onClicked,
	                    onKeyDown: this.props.tabCallbacks.setKeyboardAccessibility,
	                    onFocus: this.setFocus,
	                    onBlur: this.setBlur,
	                    role: 'tab',
	                    ref: 'tab_' + this.state.screen.screen_id,
	                    id: 'tab_' + this.state.screen.screen_id,
	                    tabIndex: this.state.focusedTab.screen_id === this.state.screen.screen_id ? 0 : -1,
	                    'aria-disabled': this.screenIsEnabled(),
	                    'aria-current': this.state.screen.screen_id === this.props.activeScreenId },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'thumbnail-details' },
	                    _react2.default.createElement('div', { className: 'pre-shape' }),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'thumbnail-indicator' },
	                        this.state.parentScreen.include_icon && appHelper.isDefined(this.state.icon.src) ? _react2.default.createElement('img', { src: this.getImagePath(this.state.icon.src), alt: '' }) : null
	                    ),
	                    _react2.default.createElement('div', { className: 'post-shape' })
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'thumbnail-label', id: 'thumbnail_' + this.state.screen.screen_id },
	                    _react2.default.createElement('div', { dangerouslySetInnerHTML: { __html: this.state.locale.title } })
	                )
	            );
	        }
	    }]);
	
	    return TimelineThumbnail;
	}(_react2.default.Component);
	
	TimelineThumbnail.propTypes = {
	    parentScreen: _propTypes2.default.object.isRequired,
	    screen: _propTypes2.default.object.isRequired,
	    activeScreenId: _propTypes2.default.number.isRequired,
	    enabledScreens: _propTypes2.default.array.isRequired,
	    completeScreens: _propTypes2.default.array.isRequired,
	    onClickFunc: _propTypes2.default.func,
	    focusedTab: _propTypes2.default.object,
	    tabCallbacks: _propTypes2.default.object,
	    index: _propTypes2.default.number,
	    lang: _propTypes2.default.string.isRequired,
	    actions: _propTypes2.default.object
	};
	
	TimelineThumbnail.contextTypes = {
	    router: _propTypes2.default.object
	};
	
	function mapStateToProps(state, ownProps) {
	    var lang = state.userData.lang;
	    return {
	        lang: lang
	    };
	}
	
	function mapDispatchToProps(dispatch) {
	    return {
	        actions: (0, _redux.bindActionCreators)(Object.assign({}, trackingDataActions), dispatch)
	    };
	}
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(TimelineThumbnail);

/***/ },
/* 546 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(5);
	
	var _redux = __webpack_require__(4);
	
	var _trackingDataActions = __webpack_require__(7);
	
	var trackingDataActions = _interopRequireWildcard(_trackingDataActions);
	
	var _appHelper = __webpack_require__(3);
	
	var appHelper = _interopRequireWildcard(_appHelper);
	
	var _objectConstants = __webpack_require__(9);
	
	var objectConstants = _interopRequireWildcard(_objectConstants);
	
	var _appConstants = __webpack_require__(13);
	
	var appConstants = _interopRequireWildcard(_appConstants);
	
	var _keyboardConstants = __webpack_require__(14);
	
	var keyboardConstants = _interopRequireWildcard(_keyboardConstants);
	
	var _gsap = __webpack_require__(8);
	
	var _gsapReactPlugin = __webpack_require__(10);
	
	var _gsapReactPlugin2 = _interopRequireDefault(_gsapReactPlugin);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ProcessBtn = function (_React$Component) {
	    _inherits(ProcessBtn, _React$Component);
	
	    function ProcessBtn(props, context) {
	        _classCallCheck(this, ProcessBtn);
	
	        var _this = _possibleConstructorReturn(this, (ProcessBtn.__proto__ || Object.getPrototypeOf(ProcessBtn)).call(this, props, context));
	
	        _this.state = {
	            lang: _this.props.lang,
	            parentScreen: _this.props.parentScreen,
	            screen: _this.props.screen,
	            activeScreenId: _this.props.activeScreenId,
	            enabledScreens: _this.props.enabledScreens,
	            completeScreens: _this.props.completeScreens,
	            focusedTab: _this.props.focusedTab,
	            className: "",
	            locale: appHelper.getLocalData(_this.props.screen),
	            update: true,
	            focusedClass: "not-focused",
	            icon: {}
	        };
	        _this.setClass = _this.setClass.bind(_this);
	        _this.onClicked = _this.onClicked.bind(_this);
	        _this.screenIsEnabled = _this.screenIsEnabled.bind(_this);
	        _this.screenIsComplete = _this.screenIsComplete.bind(_this);
	        _this.setIsFocused = _this.setIsFocused.bind(_this);
	        _this.setFocus = _this.setFocus.bind(_this);
	        _this.setBlur = _this.setBlur.bind(_this);
	        _this.getAssets = _this.getAssets.bind(_this);
	        _this.getImagePath = _this.getImagePath.bind(_this);
	        return _this;
	    }
	
	    _createClass(ProcessBtn, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	
	            this.setClass();
	            if (this.state.parentScreen.include_icon) {
	                this.getAssets();
	            }
	        }
	    }, {
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(nextProps) {
	            if (this.state.enabledScreens !== nextProps.enabledScreens || this.state.completeScreens !== nextProps.completeScreens || this.state.activeScreenId !== nextProps.activeScreenId) {
	                this.setState({
	                    update: true
	                });
	            }
	
	            if (this.state.focusedTab.screen_id !== nextProps.focusedTab.screen_id) {
	                this.setState({ focusedTab: Object.assign({}, nextProps.focusedTab), update: true });
	            }
	
	            if (this.state.lang !== nextProps.lang) {
	                this.setState({
	                    lang: nextProps.lang,
	                    locale: appHelper.getLocalData(this.state.screen)
	                });
	            }
	        }
	    }, {
	        key: 'componentDidUpdate',
	        value: function componentDidUpdate() {
	            if (this.state.update) {
	                if (this.state.focusedTab.screen_id === this.state.screen.screen_id) {
	                    var focusEl = this.refs['tab_' + this.state.screen.screen_id];
	                    focusEl.focus();
	                }
	                this.setClass();
	            }
	        }
	    }, {
	        key: 'getAssets',
	        value: function getAssets() {
	            var icon = {};
	
	            if (appHelper.isDefined(this.state.screen.assets.icon)) {
	                icon = appHelper.getIconAsset(this.state.screen.assets.icon);
	            }
	
	            this.setState({
	                icon: Object.assign({}, icon)
	            });
	        }
	    }, {
	        key: 'screenIsEnabled',
	        value: function screenIsEnabled() {
	            return appHelper.getArrayObjectIndexByKey(this.props.enabledScreens, "screen_id", this.state.screen.screen_id);
	        }
	    }, {
	        key: 'screenIsComplete',
	        value: function screenIsComplete() {
	            return appHelper.getArrayObjectIndexByKey(this.props.completeScreens, "screen_id", this.state.screen.screen_id);
	        }
	    }, {
	        key: 'setClass',
	        value: function setClass() {
	            var className = "";
	
	            if (this.state.screen.screen_id === this.props.activeScreenId) {
	                className += "active ";
	            }
	
	            if (this.screenIsEnabled() === -1) {
	                className += "disabled ";
	            }
	
	            if (this.screenIsComplete() > -1) {
	                className += "complete ";
	            } else {
	                className += "incomplete ";
	            }
	
	            this.setState({ className: className, update: false });
	        }
	    }, {
	        key: 'onClicked',
	        value: function onClicked() {
	            if (this.screenIsEnabled() > -1) {
	                this.props.onClickFunc(this.state.screen);
	            }
	        }
	    }, {
	        key: 'setIsFocused',
	        value: function setIsFocused() {
	            var activeEl = document.activeElement;
	            if (activeEl.id === 'tab_' + this.state.screen.screen_id) {
	                return "focused ";
	            } else {
	                return "not-focused ";
	            }
	        }
	    }, {
	        key: 'setFocus',
	        value: function setFocus() {
	            this.setState({ focusedClass: "focused" });
	        }
	    }, {
	        key: 'setBlur',
	        value: function setBlur() {
	            this.setState({ focusedClass: "not-focused" });
	        }
	    }, {
	        key: 'getImagePath',
	        value: function getImagePath(image) {
	            if (appConstants.DEVELOPMENT_MODE) {
	                if (appHelper.isDefined(image) && image.length > 0) {
	                    return __webpack_require__(16)("./" + image);
	                }
	            } else {
	                return image;
	            }
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            return _react2.default.createElement(
	                'div',
	                { className: 'tab-item  ' + this.state.className + ' ' + this.state.focusedClass,
	                    onClick: this.onClicked,
	                    onKeyDown: this.props.tabCallbacks.setKeyboardAccessibility,
	                    onFocus: this.setFocus,
	                    onBlur: this.setBlur,
	                    role: 'tab',
	                    'aria-controls': this.state.parentScreen.screen_id + '_feed',
	                    ref: 'tab_' + this.state.screen.screen_id,
	                    id: 'tab_' + this.state.screen.screen_id,
	                    tabIndex: this.state.focusedTab.screen_id === this.state.screen.screen_id ? 0 : -1,
	                    'aria-disabled': this.screenIsEnabled() },
	                _react2.default.createElement('div', { className: 'pre-shape' }),
	                this.state.parentScreen.include_icon && appHelper.isDefined(this.state.icon.src) ? _react2.default.createElement(
	                    'div',
	                    { className: 'tab-icon' },
	                    _react2.default.createElement('img', { src: this.getImagePath(this.state.icon.src), alt: '' })
	                ) : null,
	                _react2.default.createElement(
	                    'div',
	                    { className: 'tab-label' },
	                    _react2.default.createElement(
	                        'div',
	                        null,
	                        this.state.locale.title
	                    )
	                ),
	                _react2.default.createElement('div', { className: 'post-shape' })
	            );
	        }
	    }]);
	
	    return ProcessBtn;
	}(_react2.default.Component);
	
	ProcessBtn.propTypes = {
	    parentScreen: _propTypes2.default.object.isRequired,
	    screen: _propTypes2.default.object.isRequired,
	    activeScreenId: _propTypes2.default.number.isRequired,
	    enabledScreens: _propTypes2.default.array.isRequired,
	    completeScreens: _propTypes2.default.array.isRequired,
	    focusedTab: _propTypes2.default.object,
	    onClickFunc: _propTypes2.default.func,
	    onGetPrevTab: _propTypes2.default.func,
	    onGetNextTab: _propTypes2.default.func,
	    tabCallbacks: _propTypes2.default.object,
	    lang: _propTypes2.default.string.isRequired,
	    actions: _propTypes2.default.object
	};
	
	ProcessBtn.contextTypes = {
	    router: _propTypes2.default.object
	};
	
	function mapStateToProps(state, ownProps) {
	    var lang = state.userData.lang;
	    return {
	        lang: lang
	    };
	}
	
	function mapDispatchToProps(dispatch) {
	    return {
	        actions: (0, _redux.bindActionCreators)(Object.assign({}, trackingDataActions), dispatch)
	    };
	}
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(ProcessBtn);

/***/ },
/* 547 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(5);
	
	var _redux = __webpack_require__(4);
	
	var _trackingDataActions = __webpack_require__(7);
	
	var trackingDataActions = _interopRequireWildcard(_trackingDataActions);
	
	var _appHelper = __webpack_require__(3);
	
	var appHelper = _interopRequireWildcard(_appHelper);
	
	var _objectConstants = __webpack_require__(9);
	
	var objectConstants = _interopRequireWildcard(_objectConstants);
	
	var _appConstants = __webpack_require__(13);
	
	var appConstants = _interopRequireWildcard(_appConstants);
	
	var _keyboardConstants = __webpack_require__(14);
	
	var keyboardConstants = _interopRequireWildcard(_keyboardConstants);
	
	var _gsap = __webpack_require__(8);
	
	var _gsapReactPlugin = __webpack_require__(10);
	
	var _gsapReactPlugin2 = _interopRequireDefault(_gsapReactPlugin);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var TabBtn = function (_React$Component) {
	    _inherits(TabBtn, _React$Component);
	
	    function TabBtn(props, context) {
	        _classCallCheck(this, TabBtn);
	
	        var _this = _possibleConstructorReturn(this, (TabBtn.__proto__ || Object.getPrototypeOf(TabBtn)).call(this, props, context));
	
	        _this.state = {
	            lang: _this.props.lang,
	            parentScreen: _this.props.parentScreen,
	            screen: _this.props.screen,
	            activeScreenId: _this.props.activeScreenId,
	            enabledScreens: _this.props.enabledScreens,
	            completeScreens: _this.props.completeScreens,
	            focusedTab: _this.props.focusedTab,
	            className: "",
	            locale: appHelper.getLocalData(_this.props.screen),
	            update: true,
	            focusedClass: "not-focused",
	            icon: {}
	        };
	        _this.setClass = _this.setClass.bind(_this);
	        _this.onClicked = _this.onClicked.bind(_this);
	        _this.screenIsEnabled = _this.screenIsEnabled.bind(_this);
	        _this.screenIsComplete = _this.screenIsComplete.bind(_this);
	        _this.setIsFocused = _this.setIsFocused.bind(_this);
	        _this.setFocus = _this.setFocus.bind(_this);
	        _this.setBlur = _this.setBlur.bind(_this);
	        _this.getAssets = _this.getAssets.bind(_this);
	        _this.getImagePath = _this.getImagePath.bind(_this);
	        return _this;
	    }
	
	    _createClass(TabBtn, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	
	            this.setClass();
	            if (this.state.parentScreen.include_icon) {
	                this.getAssets();
	            }
	        }
	    }, {
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(nextProps) {
	            if (this.state.enabledScreens !== nextProps.enabledScreens || this.state.completeScreens !== nextProps.completeScreens || this.state.activeScreenId !== nextProps.activeScreenId) {
	                this.setState({
	                    update: true
	                });
	            }
	
	            if (this.state.focusedTab.screen_id !== nextProps.focusedTab.screen_id) {
	                this.setState({ focusedTab: Object.assign({}, nextProps.focusedTab), update: true });
	            }
	
	            if (this.state.lang !== nextProps.lang) {
	                this.setState({
	                    lang: nextProps.lang,
	                    locale: appHelper.getLocalData(this.state.screen)
	                });
	            }
	        }
	    }, {
	        key: 'componentDidUpdate',
	        value: function componentDidUpdate() {
	            if (this.state.update) {
	                if (this.state.focusedTab.screen_id === this.state.screen.screen_id) {
	                    var focusEl = this.refs['tab_' + this.state.screen.screen_id];
	                    focusEl.focus();
	                }
	                this.setClass();
	            }
	        }
	    }, {
	        key: 'getAssets',
	        value: function getAssets() {
	            var icon = {};
	
	            if (appHelper.isDefined(this.state.screen.assets.icon)) {
	                icon = appHelper.getIconAsset(this.state.screen.assets.icon);
	            }
	
	            this.setState({
	                icon: Object.assign({}, icon)
	            });
	        }
	    }, {
	        key: 'screenIsEnabled',
	        value: function screenIsEnabled() {
	            return appHelper.getArrayObjectIndexByKey(this.props.enabledScreens, "screen_id", this.state.screen.screen_id);
	        }
	    }, {
	        key: 'screenIsComplete',
	        value: function screenIsComplete() {
	            return appHelper.getArrayObjectIndexByKey(this.props.completeScreens, "screen_id", this.state.screen.screen_id);
	        }
	    }, {
	        key: 'setClass',
	        value: function setClass() {
	            var className = "";
	
	            if (this.state.screen.screen_id === this.props.activeScreenId) {
	                className += "active ";
	            }
	
	            if (this.screenIsEnabled() === -1) {
	                className += "disabled ";
	            }
	
	            if (this.screenIsComplete() > -1) {
	                className += "complete ";
	            } else {
	                className += "incomplete ";
	            }
	
	            this.setState({ className: className, update: false });
	        }
	    }, {
	        key: 'onClicked',
	        value: function onClicked() {
	            if (this.screenIsEnabled() > -1) {
	                this.props.onClickFunc(this.state.screen);
	            }
	        }
	    }, {
	        key: 'setIsFocused',
	        value: function setIsFocused() {
	            var activeEl = document.activeElement;
	            if (activeEl.id === 'tab_' + this.state.screen.screen_id) {
	                return "focused ";
	            } else {
	                return "not-focused ";
	            }
	        }
	    }, {
	        key: 'setFocus',
	        value: function setFocus() {
	            this.setState({ focusedClass: "focused" });
	        }
	    }, {
	        key: 'setBlur',
	        value: function setBlur() {
	            this.setState({ focusedClass: "not-focused" });
	        }
	    }, {
	        key: 'getImagePath',
	        value: function getImagePath(image) {
	            if (appConstants.DEVELOPMENT_MODE) {
	                if (appHelper.isDefined(image) && image.length > 0) {
	                    return __webpack_require__(16)("./" + image);
	                }
	            } else {
	                return image;
	            }
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            return _react2.default.createElement(
	                'div',
	                { className: 'tab-item  ' + this.state.className + ' ' + this.state.focusedClass,
	                    onClick: this.onClicked,
	                    onKeyDown: this.props.tabCallbacks.setKeyboardAccessibility,
	                    onFocus: this.setFocus,
	                    onBlur: this.setBlur,
	                    role: 'tab',
	                    'aria-controls': this.state.parentScreen.screen_id + '_feed',
	                    ref: 'tab_' + this.state.screen.screen_id,
	                    id: 'tab_' + this.state.screen.screen_id,
	                    tabIndex: this.state.focusedTab.screen_id === this.state.screen.screen_id ? 0 : -1,
	                    'aria-disabled': this.screenIsEnabled() },
	                this.state.parentScreen.include_icon && appHelper.isDefined(this.state.icon.src) ? _react2.default.createElement(
	                    'div',
	                    { className: 'tab-icon' },
	                    _react2.default.createElement('img', { src: this.getImagePath(this.state.icon.src), alt: '' })
	                ) : null,
	                _react2.default.createElement(
	                    'div',
	                    { className: 'tab-label' },
	                    _react2.default.createElement(
	                        'div',
	                        null,
	                        this.state.locale.title
	                    )
	                )
	            );
	        }
	    }]);
	
	    return TabBtn;
	}(_react2.default.Component);
	
	TabBtn.propTypes = {
	    parentScreen: _propTypes2.default.object.isRequired,
	    screen: _propTypes2.default.object.isRequired,
	    activeScreenId: _propTypes2.default.number.isRequired,
	    enabledScreens: _propTypes2.default.array.isRequired,
	    completeScreens: _propTypes2.default.array.isRequired,
	    focusedTab: _propTypes2.default.object,
	    onClickFunc: _propTypes2.default.func,
	    onGetPrevTab: _propTypes2.default.func,
	    onGetNextTab: _propTypes2.default.func,
	    tabCallbacks: _propTypes2.default.object,
	    lang: _propTypes2.default.string.isRequired,
	    actions: _propTypes2.default.object
	};
	
	TabBtn.contextTypes = {
	    router: _propTypes2.default.object
	};
	
	function mapStateToProps(state, ownProps) {
	    var lang = state.userData.lang;
	    return {
	        lang: lang
	    };
	}
	
	function mapDispatchToProps(dispatch) {
	    return {
	        actions: (0, _redux.bindActionCreators)(Object.assign({}, trackingDataActions), dispatch)
	    };
	}
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(TabBtn);

/***/ },
/* 548 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(5);
	
	var _redux = __webpack_require__(4);
	
	var _TabBtn = __webpack_require__(547);
	
	var _TabBtn2 = _interopRequireDefault(_TabBtn);
	
	var _ProcessBtn = __webpack_require__(546);
	
	var _ProcessBtn2 = _interopRequireDefault(_ProcessBtn);
	
	var _ProducerNotes = __webpack_require__(85);
	
	var _ProducerNotes2 = _interopRequireDefault(_ProducerNotes);
	
	var _NotReadyYet = __webpack_require__(84);
	
	var _NotReadyYet2 = _interopRequireDefault(_NotReadyYet);
	
	var _Button = __webpack_require__(18);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _trackingDataActions = __webpack_require__(7);
	
	var trackingDataActions = _interopRequireWildcard(_trackingDataActions);
	
	var _appDataActions = __webpack_require__(12);
	
	var appDataActions = _interopRequireWildcard(_appDataActions);
	
	var _userDataActions = __webpack_require__(20);
	
	var userDataActions = _interopRequireWildcard(_userDataActions);
	
	var _appHelper = __webpack_require__(3);
	
	var appHelper = _interopRequireWildcard(_appHelper);
	
	var _dataHelper = __webpack_require__(11);
	
	var dataHelper = _interopRequireWildcard(_dataHelper);
	
	var _appConstants = __webpack_require__(13);
	
	var appConstants = _interopRequireWildcard(_appConstants);
	
	var _objectConstants = __webpack_require__(9);
	
	var objectConstants = _interopRequireWildcard(_objectConstants);
	
	var _assetConstants = __webpack_require__(33);
	
	var assetConstants = _interopRequireWildcard(_assetConstants);
	
	var _localStorage = __webpack_require__(17);
	
	var localStorage = _interopRequireWildcard(_localStorage);
	
	var _userDataHelper = __webpack_require__(15);
	
	var userDataHelper = _interopRequireWildcard(_userDataHelper);
	
	var _componentHelper = __webpack_require__(31);
	
	var _gsap = __webpack_require__(8);
	
	var _gsapReactPlugin = __webpack_require__(10);
	
	var _gsapReactPlugin2 = _interopRequireDefault(_gsapReactPlugin);
	
	var _keyboardConstants = __webpack_require__(14);
	
	var keyboardConstants = _interopRequireWildcard(_keyboardConstants);
	
	var _lodash = __webpack_require__(28);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } //eslint-disable-line import/no-named-as-default
	//eslint-disable-line import/no-named-as-default
	
	
	var TabbedScreen = function (_React$Component) {
	    _inherits(TabbedScreen, _React$Component);
	
	    function TabbedScreen(props, context) {
	        _classCallCheck(this, TabbedScreen);
	
	        var _this = _possibleConstructorReturn(this, (TabbedScreen.__proto__ || Object.getPrototypeOf(TabbedScreen)).call(this, props, context));
	
	        _this.state = {
	            lang: _this.props.lang,
	            screen: _this.props.screen,
	            userData: _this.props.userData,
	            locale: appHelper.getLocalData(_this.props.screen),
	            status: userDataHelper.getScreenUserData(_this.props.userData, _this.props.screen.screen_id).status, // objectConstants.STATUS_IN_PROGRESS,
	            callbacks: {},
	            assets: {
	                background: {
	                    src: ""
	
	                }
	            },
	            activeScreen: {},
	            focusedTab: _this.props.screen.sub_screens[0],
	            renderedScreen: {},
	            enabledScreens: [],
	            completeScreens: [],
	            producerNotes: appHelper.getScreenNotes(undefined, _this.props.screen),
	            screenIsReady: _this.props.screen.sub_screens.length > 0 && appHelper.canSeeContent(_this.props.screen),
	            tabCallbacks: {},
	            isOpenNavigation: appHelper.getBiteById(_this.props.biteCallbacks.getBiteId()).navigation_type === objectConstants.PROGRESSION_TYPE_OPEN,
	            continue_label: appHelper.getLocaleString("continue_label")
	
	        };
	        _this.getScreenId = _this.getScreenId.bind(_this);
	        _this.getBiteId = _this.getBiteId.bind(_this);
	        _this.getAssets = _this.getAssets.bind(_this);
	        _this.getImagePath = _this.getImagePath.bind(_this);
	        _this.checkScreenStatus = _this.checkScreenStatus.bind(_this);
	        _this.setCallbacks = _this.setCallbacks.bind(_this);
	        _this.setEnabledTabs = _this.setEnabledTabs.bind(_this);
	        _this.setTabActive = _this.setTabActive.bind(_this);
	        _this.setRenderedScreen = _this.setRenderedScreen.bind(_this);
	        _this.onSubScreenComplete = _this.onSubScreenComplete.bind(_this);
	        _this.goToNextSubScreen = _this.goToNextSubScreen.bind(_this);
	        _this.hasNextSubScreen = _this.hasNextSubScreen.bind(_this);
	        _this.checkScreenComplete = _this.checkScreenComplete.bind(_this);
	        _this.updateScreenResults = _lodash2.default.debounce(_this.updateScreenResults.bind(_this), 300);
	        _this.setScreenAccessed = _lodash2.default.debounce(_this.setScreenAccessed.bind(_this), 300);
	        _this.navigateToNextScreen = _this.navigateToNextScreen.bind(_this);
	        _this.checkScreenStatus = _this.checkScreenStatus.bind(_this);
	        _this.completeScreen = _this.completeScreen.bind(_this);
	        _this.setScreenNotReadyYet = _this.setScreenNotReadyYet.bind(_this);
	        _this.setTabLayoutStyle = _this.setTabLayoutStyle.bind(_this);
	        _this.getPrevTab = _this.getPrevTab.bind(_this);
	        _this.getNextTab = _this.getNextTab.bind(_this);
	        _this.setKeyboardAccessibility = _this.setKeyboardAccessibility.bind(_this);
	        _this.setTabCallbacks = _this.setTabCallbacks.bind(_this);
	        _this.getTabComponent = _this.getTabComponent.bind(_this);
	        _this.includeIcons = _this.includeIcons.bind(_this);
	        return _this;
	    }
	
	    _createClass(TabbedScreen, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            this.setScreenAccessed();
	            this.props.biteCallbacks.showHeader(true);
	            this.props.actions.setScreenTitle(this.state.locale.title);
	            this.getAssets();
	            this.setCallbacks();
	            this.setTabCallbacks();
	            if (this.state.screenIsReady) {
	                this.setEnabledTabs();
	                this.setTabActive(this.state.screen.sub_screens[0]);
	            } else {
	                this.setScreenNotReadyYet();
	            }
	        }
	    }, {
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(nextProps) {
	            var screenUserData = userDataHelper.getScreenUserData(nextProps.userData, this.state.screen.screen_id);
	            if (screenUserData.status === objectConstants.STATUS_COMPLETE) {
	                this.setState({
	                    status: screenUserData.status,
	                    enabledScreens: screenUserData.status === objectConstants.STATUS_COMPLETE ? this.state.screen.sub_screens : this.state.enabledScreens,
	                    completeScreens: screenUserData.status === objectConstants.STATUS_COMPLETE ? this.state.screen.sub_screens : this.state.completedScreens
	                });
	            } else if (this.state.isOpenNavigation) {
	                this.setState({
	                    enabledScreens: Object.assign([], this.state.screen.sub_screens)
	                });
	            }
	
	            if (this.state.lang !== nextProps.lang) {
	                this.setState({
	                    lang: nextProps.lang,
	                    locale: appHelper.getLocalData(this.state.screen),
	                    continue_label: appHelper.getLocaleString("continue_label")
	                });
	
	                this.props.actions.setScreenTitle(appHelper.getLocalData(this.state.screen).title);
	            }
	
	            this.setState({ userData: Object.assign({}, nextProps.userData) });
	        }
	    }, {
	        key: 'componentDidUpdate',
	        value: function componentDidUpdate() {
	            if (typeof this.state.renderedScreen.data === "undefined" && typeof this.state.activeScreen.screen_id !== "undefined") {
	                this.setRenderedScreen();
	            }
	        }
	    }, {
	        key: 'setScreenAccessed',
	        value: function setScreenAccessed() {
	            this.props.actions.setScreenAccessed(this.state.screen);
	        }
	    }, {
	        key: 'setScreenNotReadyYet',
	        value: function setScreenNotReadyYet() {
	            this.setState({ status: objectConstants.STATUS_COMPLETE });
	            this.updateScreenResults(objectConstants.STATUS_COMPLETE);
	        }
	    }, {
	        key: 'checkScreenStatus',
	        value: function checkScreenStatus() {
	            var screenUserData = userDataHelper.getScreenUserData(this.state.userData, this.state.screen.screen_id);
	            if (screenUserData.status === objectConstants.STATUS_COMPLETE) {
	                this.setState({
	                    status: screenUserData.status,
	                    enabledScreens: screenUserData.status === objectConstants.STATUS_COMPLETE ? this.state.screen.sub_screens : this.state.enabledScreens,
	                    completeScreens: screenUserData.status === objectConstants.STATUS_COMPLETE ? this.state.screen.sub_screens : this.state.completedScreens
	                });
	            } else if (this.state.isOpenNavigation) {
	                this.setState({
	                    enabledScreens: Object.assign([], this.state.screen.sub_screens)
	                });
	            }
	            /* let screenStatus = getScreenUserData(this.props.userData, this.props.screen.screen_id).status;
	             let reviewMode = screenStatus === objectConstants.STATUS_COMPLETE && localStorage.post_completion_mode === appConstants.POST_COMPLETION_MODE_REVIEW;
	            // console.log(`reviewMode: ${this.state.reviewMode} - line 120`);
	             this.setState({status: screenStatus, checkCompletionStatus: true, reviewMode: reviewMode, propsUpdated: true});
	             */
	        }
	    }, {
	        key: 'getAssets',
	        value: function getAssets() {
	            var background = {};
	
	            if (appHelper.isDefined(this.state.screen.assets.background)) {
	                background = appHelper.getBackgroundAsset(this.state.screen.assets.background);
	            }
	
	            this.setState({
	                assets: Object.assign({}, this.state.assets, {
	                    background: appHelper.isDefined(background.src) ? background : this.state.assets.background
	                })
	            });
	        }
	    }, {
	        key: 'getImagePath',
	        value: function getImagePath(image) {
	            if (appConstants.DEVELOPMENT_MODE) {
	                if (appHelper.isDefined(image) && image.length > 0) {
	                    return __webpack_require__(16)("./" + image);
	                }
	            } else {
	                return image;
	            }
	        }
	    }, {
	        key: 'setCallbacks',
	        value: function setCallbacks() {
	            this.setState({
	                callbacks: Object.assign({}, this.props.biteCallbacks, {
	                    //onObjectComplete: this.onObjectComplete,
	                    getScreenId: this.getScreenId,
	                    getBiteId: this.getBiteId,
	                    onSubScreenComplete: this.onSubScreenComplete,
	                    goToNextSubScreen: this.goToNextSubScreen,
	                    hasNextSubScreen: this.hasNextSubScreen,
	                    completeScreen: this.completeScreen
	                    //objectIsEnabled: this.objectIsEnabled,
	                    //objectIsComplete: this.objectIsComplete,
	                    //storeUserResponse: this.storeUserResponse,
	                    //scrollTo: this.scrollTo,
	                    //isReviewMode: this.isReviewMode
	                })
	            });
	        }
	    }, {
	        key: 'getScreenId',
	        value: function getScreenId() {
	            return this.state.screen.screen_id;
	        }
	    }, {
	        key: 'getBiteId',
	        value: function getBiteId() {
	            //console.log(`getBiteId`);
	            return this.props.biteCallbacks.getBiteId();
	        }
	    }, {
	        key: 'setEnabledTabs',
	        value: function setEnabledTabs() {
	            if (this.state.status !== objectConstants.STATUS_COMPLETE) {
	                //if (this.state.screen.progression === objectConstants.OBJECT_PROGRESSION_LINEAR) {
	
	                //} else {
	                //    this.setState({enabledObjects: Object.assign([], this.state.screen.objects)});
	                // }
	                if (this.state.isOpenNavigation) {
	                    this.setState({
	                        enabledScreens: Object.assign([], this.state.screen.sub_screens)
	                    });
	                } else {
	                    this.setState({ enabledScreens: dataHelper.immutablePush(this.state.enabledScreens, this.state.screen.sub_screens[0]) });
	                }
	            } else {
	                //  console.log("hello");
	                this.setState({
	                    enabledObjects: Object.assign([], this.state.screen.objects),
	                    completeObjects: Object.assign([], this.state.screen.objects),
	                    checkContinueBtnState: true,
	                    propsUpdated: false
	                });
	            }
	        }
	    }, {
	        key: 'setTabActive',
	        value: function setTabActive(screen) {
	            //set renderedObject to empty so that when component updates we make sure we can set it again and we get exactly what we want rendered
	            if (this.state.activeScreen.screen_id !== screen.screen_id) {
	                this.setState({ activeScreen: screen, renderedScreen: {}, focusedTab: screen });
	            }
	            var focusEl = document.getElementById(this.state.screen.screen_id + '_feed');
	            //focusEl.focus();
	            //this.setBackButtonDisplayState(object);
	            //this.setContinueButtonDisplayState(object);
	        }
	    }, {
	        key: 'setRenderedScreen',
	        value: function setRenderedScreen() {
	            var screenType = Object.assign({}, (0, _componentHelper.getScreenComponentByType)(this.state.activeScreen.screen_type), {
	                data: this.state.activeScreen
	            });
	
	            this.setState({ renderedScreen: Object.assign({}, screenType) });
	        }
	    }, {
	        key: 'onSubScreenComplete',
	        value: function onSubScreenComplete(screen) {
	            //console.log(screen);
	            var completionIndex = appHelper.getArrayObjectIndexByKey(this.state.completeScreens, "screen_id", screen.screen_id);
	            var subScreenIndex = appHelper.getArrayObjectIndexByKey(this.state.screen.sub_screens, "screen_id", screen.screen_id);
	            var nextScreen = {};
	            var nextScreenIndex = -1;
	
	            if (subScreenIndex < this.state.screen.sub_screens.length - 1) {
	                nextScreen = Object.assign({}, this.state.screen.sub_screens[subScreenIndex + 1]);
	                nextScreenIndex = appHelper.getArrayObjectIndexByKey(this.state.enabledScreens, "screen_id", nextScreen.screen_id);
	            }
	
	            if (completionIndex === -1) {
	                this.setState({
	                    completeScreens: dataHelper.immutablePush(this.state.completeScreens, screen),
	                    enabledScreens: typeof nextScreen.screen_id !== "undefined" || nextScreenIndex === -1 ? dataHelper.immutablePush(this.state.enabledScreens, nextScreen) : Object.assign([], this.state.enabledScreens),
	                    checkContinueBtnState: true
	                });
	
	                // this.updateScreenResults(this.state.status !== objectConstants.STATUS_COMPLETE ? objectConstants.STATUS_IN_PROGRESS: objectConstants.STATUS_COMPLETE, object.object_id);
	            }
	
	            this.checkScreenComplete();
	        }
	    }, {
	        key: 'hasNextSubScreen',
	        value: function hasNextSubScreen(screen) {
	            var subScreenIndex = appHelper.getArrayObjectIndexByKey(this.state.screen.sub_screens, "screen_id", screen.screen_id);
	            return subScreenIndex < this.state.screen.sub_screens.length - 1;
	        }
	    }, {
	        key: 'goToNextSubScreen',
	        value: function goToNextSubScreen(screen) {
	            var subScreenIndex = appHelper.getArrayObjectIndexByKey(this.state.screen.sub_screens, "screen_id", screen.screen_id);
	            if (this.hasNextSubScreen(screen)) {
	                var nextScreen = Object.assign({}, this.state.screen.sub_screens[subScreenIndex + 1]);
	                this.setTabActive(nextScreen);
	            } else {
	                this.navigateToNextScreen();
	            }
	        }
	    }, {
	        key: 'navigateToNextScreen',
	        value: function navigateToNextScreen() {
	            var nextScreenId = appHelper.getNextScreenId(this.getScreenId());
	            if (localStorage.bites.length > 1 && nextScreenId.length === 0) {
	                this.context.router.push('menu');
	            } else {
	                this.props.actions.setNextLessonLocation(this.getScreenId());
	            }
	        }
	    }, {
	        key: 'checkScreenComplete',
	        value: function checkScreenComplete() {
	            if (this.state.completeScreens.length >= this.state.screen.sub_screens.length) {
	                this.setState({
	                    status: objectConstants.STATUS_COMPLETE
	                });
	                this.updateScreenResults(objectConstants.STATUS_COMPLETE);
	            }
	        }
	
	        //used when child screen terminates
	
	    }, {
	        key: 'completeScreen',
	        value: function completeScreen() {
	            this.setState({
	                status: objectConstants.STATUS_COMPLETE
	            });
	            this.updateScreenResults(objectConstants.STATUS_COMPLETE);
	        }
	    }, {
	        key: 'updateScreenResults',
	        value: function updateScreenResults(screen_status) {
	            var _this2 = this;
	
	            var params = {
	                bite_id: this.getBiteId(),
	                screen_id: this.getScreenId(),
	                screen_status: screen_status,
	                object_status: objectConstants.STATUS_COMPLETE
	            };
	            this.props.actions.updateScreenResults(params).then(function (userData) {
	                _this2.props.actions.setSuspendData(userData).then(function (trackingData) {
	                    if (screen_status === objectConstants.STATUS_COMPLETE) {
	                        _this2.props.actions.setScreenComplete(_this2.state.screen);
	                    }
	                }).catch(function (error) {});
	            }).catch(function (error) {});
	        }
	    }, {
	        key: 'setTabLayoutStyle',
	        value: function setTabLayoutStyle() {
	            if (appHelper.isDefined(this.state.screen.tab_type) && this.state.screen.tab_type === objectConstants.TAB_TYPE_VERTICAL) {
	                return "tabbed-content-vertical floating";
	            } else if (appHelper.isDefined(this.state.screen.tab_type) && this.state.screen.tab_type === objectConstants.TAB_TYPE_HORIZONTAL_FRAMELESS) {
	                return "tabbed-content";
	            } else if (appHelper.isDefined(this.state.screen.tab_type) && this.state.screen.tab_type === objectConstants.TAB_TYPE_VERTICAL_FRAMELESS) {
	                return "tabbed-content-vertical";
	            } else if (appHelper.isDefined(this.state.screen.tab_type) && this.state.screen.tab_type === objectConstants.TAB_TYPE_HORIZONTAL_PROCESS) {
	                return "tabbed-content-process-horizontal";
	            } else if (appHelper.isDefined(this.state.screen.tab_type) && this.state.screen.tab_type === objectConstants.TAB_TYPE_VERTICAL_PROCESS) {
	                return "tabbed-content-process-vertical";
	            } else if (appHelper.isDefined(this.state.screen.tab_type) && this.state.screen.tab_type === objectConstants.TAB_TYPE_HORIZONTAL_TILE) {
	                return "tabbed-content-tile-horizontal";
	            } else if (appHelper.isDefined(this.state.screen.tab_type) && this.state.screen.tab_type === objectConstants.TAB_TYPE_VERTICAL_TILE) {
	                return "tabbed-content-tile-vertical";
	            } else {
	                return "tabbed-content floating";
	            }
	        }
	    }, {
	        key: 'getTabComponent',
	        value: function getTabComponent() {
	            if (appHelper.isDefined(this.state.screen.tab_type) && (this.state.screen.tab_type === objectConstants.TAB_TYPE_HORIZONTAL_PROCESS || this.state.screen.tab_type === objectConstants.TAB_TYPE_VERTICAL_PROCESS)) {
	                return _ProcessBtn2.default;
	            } else {
	                return _TabBtn2.default;
	            }
	        }
	    }, {
	        key: 'getPrevTab',
	        value: function getPrevTab() {
	            var tabIndex = appHelper.getArrayObjectIndexByKey(this.state.screen.sub_screens, "screen_id", this.state.focusedTab.screen_id);
	            var nextTab = this.state.screen.sub_screens[tabIndex - 1];
	            if (tabIndex <= 0) {
	                nextTab = this.state.screen.sub_screens[this.state.screen.sub_screens.length - 1];
	            }
	            //console.log(`getPrevTab`,nextTab);
	            this.setState({ focusedTab: Object.assign({}, nextTab) });
	        }
	    }, {
	        key: 'getNextTab',
	        value: function getNextTab() {
	            var tabIndex = appHelper.getArrayObjectIndexByKey(this.state.screen.sub_screens, "screen_id", this.state.focusedTab.screen_id);
	            var nextTab = this.state.screen.sub_screens[tabIndex + 1];
	            if (tabIndex === this.state.screen.sub_screens.length - 1) {
	                nextTab = this.state.screen.sub_screens[0];
	            }
	            //console.log(`getNextTab`,nextTab);
	
	            this.setState({ focusedTab: Object.assign({}, nextTab) });
	        }
	    }, {
	        key: 'setKeyboardAccessibility',
	        value: function setKeyboardAccessibility(event) {
	            if (event.which === keyboardConstants.ENTER_KEY || event.which === keyboardConstants.SPACEBAR_KEY) {
	                if (appHelper.getArrayObjectIndexByKey(this.state.enabledScreens, "screen_id", this.state.focusedTab.screen_id) > -1) {
	                    event.preventDefault();
	                    this.setTabActive(this.state.focusedTab);
	                }
	            }
	
	            if (event.which === keyboardConstants.ARROW_LEFT_KEY) {
	                event.preventDefault();
	                this.getPrevTab();
	            }
	
	            if (event.which === keyboardConstants.ARROW_RIGHT_KEY) {
	                event.preventDefault();
	                this.getNextTab();
	            }
	
	            if (event.which === keyboardConstants.ARROW_UP_KEY) {
	                event.preventDefault();
	                this.getPrevTab();
	            }
	
	            if (event.which === keyboardConstants.ARROW_DOWN_KEY) {
	                event.preventDefault();
	                this.getNextTab();
	            }
	        }
	    }, {
	        key: 'setTabCallbacks',
	        value: function setTabCallbacks() {
	            this.setState({
	                tabCallbacks: Object.assign({}, this.state.tabCallbacks, {
	                    setKeyboardAccessibility: this.setKeyboardAccessibility
	                })
	            });
	        }
	    }, {
	        key: 'includeIcons',
	        value: function includeIcons() {
	            return appHelper.isDefined(this.state.screen.include_icon) && this.state.screen.include_icon;
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this3 = this;
	
	            var renderedScreen = this.state.renderedScreen;
	            var TabComponent = this.getTabComponent();
	            return _react2.default.createElement(
	                'div',
	                { className: 'customer-scenario' },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'background-container' },
	                    _react2.default.createElement('img', { src: this.getImagePath(this.state.assets.background.src), alt: '' })
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'screen-container' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: this.setTabLayoutStyle() },
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'tab-list even-widths ' + (this.includeIcons() ? "icon-list" : ""), role: 'tablist' },
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'tab-item-wrapper' },
	                                this.state.screen.sub_screens.map(function (sub_screen) {
	                                    return typeof _this3.state.activeScreen.screen_id !== "undefined" ? _react2.default.createElement(TabComponent, { key: sub_screen.screen_id + '_tab',
	                                        parentScreen: _this3.state.screen,
	                                        screen: sub_screen,
	                                        activeScreenId: _this3.state.activeScreen.screen_id,
	                                        enabledScreens: _this3.state.enabledScreens,
	                                        completeScreens: _this3.state.completeScreens,
	                                        onClickFunc: _this3.setTabActive,
	                                        ref: 'tab_btn_' + sub_screen.screen_id,
	                                        focusedTab: _this3.state.focusedTab,
	                                        tabCallbacks: _this3.state.tabCallbacks
	                                    }) : null;
	                                })
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'tabbed-body-content ' + (this.includeIcons() ? "icon-body" : ""), ref: this.state.screen.screen_id + '_feed',
	                                id: this.state.screen.screen_id + '_feed', role: 'tabpanel',
	                                'aria-labelledby': 'tab_' + this.state.activeScreen.screen_id },
	                            typeof renderedScreen.data !== "undefined" && this.state.screenIsReady ? _react2.default.createElement(renderedScreen.component, { screen: renderedScreen.data, parentScreen: this.state.screen,
	                                biteCallbacks: this.state.callbacks }) : null,
	                            !this.state.screenIsReady ? _react2.default.createElement(
	                                'div',
	                                null,
	                                this.state.producerNotes.length > 0 ? _react2.default.createElement(_ProducerNotes2.default, { notes: this.state.producerNotes,
	                                    screen_id: this.state.screen.screen_id }) : null,
	                                _react2.default.createElement(_NotReadyYet2.default, { screen_id: this.state.screen.screen_id }),
	                                _react2.default.createElement(_Button2.default, { ref: this.state.screen.screen_id + '_button',
	                                    label: this.state.continue_label,
	                                    id: this.state.screen.screen_id + '_button',
	                                    onClick: this.navigateToNextScreen,
	                                    onRevealed: this.onContinueBtnReveled })
	                            ) : null
	                        )
	                    )
	                )
	            );
	        }
	    }]);
	
	    return TabbedScreen;
	}(_react2.default.Component);
	
	/*
	* <div className="tabbed-body-footer">
	                            <div className="text-center">
	                                footer
	
	                            </div>
	                        </div>
	* */
	
	TabbedScreen.propTypes = {
	    screen: _propTypes2.default.object.isRequired,
	    biteCallbacks: _propTypes2.default.object.isRequired,
	    titles: _propTypes2.default.object.isRequired,
	    actions: _propTypes2.default.object.isRequired,
	    userData: _propTypes2.default.object.isRequired,
	    lang: _propTypes2.default.string.isRequired
	};
	
	TabbedScreen.contextTypes = {
	    router: _propTypes2.default.object
	
	};
	
	function mapStateToProps(state, ownProps) {
	    var lang = state.userData.lang;
	    return {
	        lang: lang,
	        titles: state.titles,
	        userData: state.userData
	    };
	}
	
	function mapDispatchToProps(dispatch) {
	    return {
	        actions: (0, _redux.bindActionCreators)(Object.assign({}, appDataActions, trackingDataActions, userDataActions), dispatch)
	    };
	}
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(TabbedScreen);

/***/ },
/* 549 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(5);
	
	var _redux = __webpack_require__(4);
	
	var _IconButton = __webpack_require__(275);
	
	var _IconButton2 = _interopRequireDefault(_IconButton);
	
	var _trackingDataActions = __webpack_require__(7);
	
	var trackingDataActions = _interopRequireWildcard(_trackingDataActions);
	
	var _appDataActions = __webpack_require__(12);
	
	var appDataActions = _interopRequireWildcard(_appDataActions);
	
	var _userDataActions = __webpack_require__(20);
	
	var userDataActions = _interopRequireWildcard(_userDataActions);
	
	var _appHelper = __webpack_require__(3);
	
	var appHelper = _interopRequireWildcard(_appHelper);
	
	var _appConstants = __webpack_require__(13);
	
	var appConstants = _interopRequireWildcard(_appConstants);
	
	var _objectConstants = __webpack_require__(9);
	
	var objectConstants = _interopRequireWildcard(_objectConstants);
	
	var _assetConstants = __webpack_require__(33);
	
	var assetConstants = _interopRequireWildcard(_assetConstants);
	
	var _localStorage = __webpack_require__(17);
	
	var localStorage = _interopRequireWildcard(_localStorage);
	
	var _gsap = __webpack_require__(8);
	
	var _gsapReactPlugin = __webpack_require__(10);
	
	var _gsapReactPlugin2 = _interopRequireDefault(_gsapReactPlugin);
	
	var _lodash = __webpack_require__(28);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } //eslint-disable-line import/no-named-as-default
	
	
	var TitleScreen = function (_React$Component) {
	    _inherits(TitleScreen, _React$Component);
	
	    function TitleScreen(props, context) {
	        _classCallCheck(this, TitleScreen);
	
	        var _this = _possibleConstructorReturn(this, (TitleScreen.__proto__ || Object.getPrototypeOf(TitleScreen)).call(this, props, context));
	
	        _this.state = {
	            lang: _this.props.lang,
	            screen: _this.props.screen,
	            show_project_title: appHelper.isDefined(_this.props.screen.show_project_title) ? _this.props.screen.show_project_title : true,
	            locale: {},
	            renderedObjects: [],
	            assets: {
	                background: {
	                    src: ""
	
	                },
	                icon: {
	                    src: ""
	                }
	            },
	            isDisabled: false,
	            start_label: appHelper.getLocaleString("start_label"),
	            continue_label: appHelper.getLocaleString("continue_label")
	        };
	        _this.getLocale = _this.getLocale.bind(_this);
	        _this.getScreenId = _this.getScreenId.bind(_this);
	        _this.getBiteId = _this.getBiteId.bind(_this);
	        _this.getAssets = _this.getAssets.bind(_this);
	        _this.getImagePath = _this.getImagePath.bind(_this);
	        _this.onProgressionClicked = _this.onProgressionClicked.bind(_this);
	        _this.navigateToNextScreen = _this.navigateToNextScreen.bind(_this);
	        _this.setClass = _this.setClass.bind(_this);
	        _this.getButtonLabel = _this.getButtonLabel.bind(_this);
	        _this.updateScreenResults = _lodash2.default.debounce(_this.updateScreenResults.bind(_this), 300);
	        _this.setScreenAccessed = _lodash2.default.debounce(_this.setScreenAccessed.bind(_this), 300);
	        return _this;
	    }
	
	    _createClass(TitleScreen, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            this.setScreenAccessed();
	            this.props.biteCallbacks.showHeader(false);
	            this.getLocale();
	            this.getAssets();
	            setTimeout(function () {
	                this.updateScreenResults(objectConstants.STATUS_COMPLETE);
	            }.bind(this), 1000);
	        }
	    }, {
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(nextProps) {
	            if (this.state.lang !== nextProps.lang) {
	                this.setState({
	                    lang: nextProps.lang,
	                    locale: appHelper.getLocalData(this.state.screen),
	                    start_label: appHelper.getLocaleString("start_label"),
	                    continue_label: appHelper.getLocaleString("continue_label")
	                });
	            }
	        }
	    }, {
	        key: 'setScreenAccessed',
	        value: function setScreenAccessed() {
	            this.props.actions.setScreenAccessed(this.state.screen);
	        }
	    }, {
	        key: 'getLocale',
	        value: function getLocale() {
	            var locale = appHelper.getLocalData(this.state.screen);
	            this.props.actions.setScreenTitle(locale.title);
	            this.setState({ locale: Object.assign({}, locale) });
	        }
	    }, {
	        key: 'getAssets',
	        value: function getAssets() {
	            var background = {};
	            var icon = {};
	            if (appHelper.isDefined(this.state.screen.assets.background)) {
	                background = appHelper.getBackgroundAsset(this.state.screen.assets.background);
	            }
	            if (appHelper.isDefined(this.state.screen.assets.icon)) {
	                if (this.state.screen.assets.icon.constant === assetConstants.ASSET_TYPE_ICON) {
	                    icon = appHelper.getIconAsset(this.state.screen.assets.icon);
	                } else if (this.state.screen.assets.icon.constant === assetConstants.ASSET_TYPE_LIBRARY_IMAGE) {
	                    icon = appHelper.getLibraryImageAsset(this.state.screen.assets.icon);
	                }
	            }
	
	            this.setState({
	                assets: Object.assign({}, this.state.assets, {
	                    background: appHelper.isDefined(background.src) ? background : this.state.assets.background,
	                    icon: appHelper.isDefined(icon.src) ? icon : this.state.assets.icon
	                })
	            });
	        }
	    }, {
	        key: 'getImagePath',
	        value: function getImagePath(image) {
	            if (appConstants.DEVELOPMENT_MODE) {
	                if (appHelper.isDefined(image) && image.length > 0) {
	                    return __webpack_require__(16)("./" + image);
	                }
	            } else {
	                return image;
	            }
	        }
	    }, {
	        key: 'getScreenId',
	        value: function getScreenId() {
	            return this.state.screen.screen_id;
	        }
	    }, {
	        key: 'getBiteId',
	        value: function getBiteId() {
	            return this.props.biteCallbacks.getBiteId();
	        }
	    }, {
	        key: 'updateScreenResults',
	        value: function updateScreenResults(screen_status) {
	            var _this2 = this;
	
	            var params = {
	                bite_id: this.getBiteId(),
	                screen_id: this.getScreenId(),
	                screen_status: screen_status
	            };
	
	            this.props.actions.updateScreenResults(params).then(function (userData) {
	                _this2.props.actions.setSuspendData(userData).then(function (trackingData) {
	                    if (screen_status === objectConstants.STATUS_COMPLETE) {
	                        _this2.props.actions.setScreenComplete(_this2.state.screen);
	                    }
	                }).catch(function (error) {});
	            }).catch(function (error) {});
	        }
	    }, {
	        key: 'onProgressionClicked',
	        value: function onProgressionClicked() {
	            this.setState({ isDisabled: true });
	
	            this.navigateToNextScreen();
	        }
	    }, {
	        key: 'navigateToNextScreen',
	        value: function navigateToNextScreen() {
	            var nextScreenId = appHelper.getNextScreenId(this.getScreenId());
	            if (localStorage.bites.length > 1 && nextScreenId.length === 0) {
	                this.context.router.push('menu');
	            } else {
	                this.props.actions.setNextLessonLocation(this.getScreenId());
	            }
	        }
	    }, {
	        key: 'setClass',
	        value: function setClass() {
	            return this.state.screen.include_logo ? "logo" : "";
	        }
	    }, {
	        key: 'getButtonLabel',
	        value: function getButtonLabel() {
	            var bite = appHelper.getBiteById(this.getBiteId());
	            if (bite.location_order === 1 & this.state.screen.display_order_id === 1) {
	                return this.state.start_label;
	            } else {
	                return this.state.continue_label;
	            }
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	
	            return appHelper.isDefined(this.state.assets.background.src) && this.state.assets.background.src.length > 0 ? _react2.default.createElement(
	                'div',
	                { className: 'customer-scenario' },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'background-container' },
	                    _react2.default.createElement('img', { src: this.getImagePath(this.state.assets.background.src), alt: '' })
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'screen-container' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'title-panel ' + this.setClass() },
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'title-content' },
	                            this.state.assets.icon.src.length > 0 ? _react2.default.createElement(
	                                'div',
	                                { className: 'title-icon-container' },
	                                _react2.default.createElement('img', { src: this.getImagePath(this.state.assets.icon.src), alt: '' })
	                            ) : null,
	                            appHelper.isDefined(this.state.locale.series_title) ? _react2.default.createElement('h1', { dangerouslySetInnerHTML: { __html: this.state.locale.series_title } }) : null,
	                            appHelper.isDefined(this.state.locale.title) && this.state.locale.title !== null && this.state.locale.title.length > 0 ? _react2.default.createElement('h2', { dangerouslySetInnerHTML: { __html: this.state.locale.title } }) : null,
	                            appHelper.isDefined(this.state.locale.description) && this.state.locale.description !== null && this.state.locale.description.length > 0 ? _react2.default.createElement('div', { dangerouslySetInnerHTML: { __html: this.state.locale.description } }) : null,
	                            _react2.default.createElement('br', null),
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'inline-list' },
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: 'inline-item' },
	                                    _react2.default.createElement(_IconButton2.default, { label: this.getButtonLabel(),
	                                        isDisabled: this.state.isDisabled,
	                                        id: this.state.screen.screen_id + '_button',
	                                        'class': 'continue-btn',
	                                        onClick: this.onProgressionClicked })
	                                )
	                            )
	                        )
	                    )
	                )
	            ) : null;
	        }
	    }]);
	
	    return TitleScreen;
	}(_react2.default.Component);
	
	TitleScreen.propTypes = {
	    screen: _propTypes2.default.object.isRequired,
	    biteCallbacks: _propTypes2.default.object.isRequired,
	    titles: _propTypes2.default.object.isRequired,
	    actions: _propTypes2.default.object.isRequired,
	    lang: _propTypes2.default.string.isRequired,
	    userData: _propTypes2.default.object.isRequired
	};
	
	TitleScreen.contextTypes = {
	    router: _propTypes2.default.object
	
	};
	
	function mapStateToProps(state, ownProps) {
	    var lang = state.userData.lang;
	    return {
	        lang: lang,
	        titles: state.titles,
	        userData: state.userData
	    };
	}
	
	function mapDispatchToProps(dispatch) {
	    return {
	        actions: (0, _redux.bindActionCreators)(Object.assign({}, appDataActions, trackingDataActions, userDataActions), dispatch)
	    };
	}
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(TitleScreen);

/***/ },
/* 550 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(5);
	
	var _redux = __webpack_require__(4);
	
	var _AbsoluteButton = __webpack_require__(447);
	
	var _AbsoluteButton2 = _interopRequireDefault(_AbsoluteButton);
	
	var _trackingDataActions = __webpack_require__(7);
	
	var trackingDataActions = _interopRequireWildcard(_trackingDataActions);
	
	var _appDataActions = __webpack_require__(12);
	
	var appDataActions = _interopRequireWildcard(_appDataActions);
	
	var _userDataActions = __webpack_require__(20);
	
	var userDataActions = _interopRequireWildcard(_userDataActions);
	
	var _appHelper = __webpack_require__(3);
	
	var appHelper = _interopRequireWildcard(_appHelper);
	
	var _appConstants = __webpack_require__(13);
	
	var appConstants = _interopRequireWildcard(_appConstants);
	
	var _objectConstants = __webpack_require__(9);
	
	var objectConstants = _interopRequireWildcard(_objectConstants);
	
	var _assetConstants = __webpack_require__(33);
	
	var assetConstants = _interopRequireWildcard(_assetConstants);
	
	var _localStorage = __webpack_require__(17);
	
	var localStorage = _interopRequireWildcard(_localStorage);
	
	var _environmentHelper = __webpack_require__(56);
	
	var enviromentHelper = _interopRequireWildcard(_environmentHelper);
	
	var _gsap = __webpack_require__(8);
	
	var _gsapReactPlugin = __webpack_require__(10);
	
	var _gsapReactPlugin2 = _interopRequireDefault(_gsapReactPlugin);
	
	var _lodash = __webpack_require__(28);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } //eslint-disable-line import/no-named-as-default
	
	
	var TitleScreenImageBased = function (_React$Component) {
	    _inherits(TitleScreenImageBased, _React$Component);
	
	    function TitleScreenImageBased(props, context) {
	        _classCallCheck(this, TitleScreenImageBased);
	
	        var _this = _possibleConstructorReturn(this, (TitleScreenImageBased.__proto__ || Object.getPrototypeOf(TitleScreenImageBased)).call(this, props, context));
	
	        _this.state = {
	            lang: _this.props.lang,
	            screen: _this.props.screen,
	            show_project_title: appHelper.isDefined(_this.props.screen.show_project_title) ? _this.props.screen.show_project_title : true,
	            locale: {},
	            renderedObjects: [],
	            assets: {
	                large_background: {
	                    src: ""
	
	                },
	                mobile_background: {
	                    src: ""
	                },
	                current_background: {
	                    src: ""
	                }
	            },
	            currentAssetParams: _this.props.screen.assets.large_background,
	            isDisabled: false,
	            env: enviromentHelper.getEnvironment(),
	            updateBackgroundAssets: false,
	            initialised: false,
	            updateButtonStyles: false,
	            button_styles: {},
	            adaptiveBackgroundSizes: {
	                lg: {
	                    landscape: objectConstants.LARGE_BACKGROUND,
	                    portrait: objectConstants.LARGE_BACKGROUND
	                },
	                md: {
	                    landscape: objectConstants.LARGE_BACKGROUND,
	                    portrait: objectConstants.LARGE_BACKGROUND
	                },
	                sm: {
	                    landscape: objectConstants.LARGE_BACKGROUND,
	                    portrait: objectConstants.MOBILE_BACKGROUND
	                },
	                xs: {
	                    landscape: objectConstants.LARGE_BACKGROUND,
	                    portrait: objectConstants.MOBILE_BACKGROUND
	                }
	            },
	            start_label: appHelper.getLocaleString("start_label"),
	            continue_label: appHelper.getLocaleString("continue_label")
	        };
	        _this.getLocale = _this.getLocale.bind(_this);
	        _this.getScreenId = _this.getScreenId.bind(_this);
	        _this.getBiteId = _this.getBiteId.bind(_this);
	        _this.getAssets = _this.getAssets.bind(_this);
	        _this.getImagePath = _this.getImagePath.bind(_this);
	        _this.onProgressionClicked = _this.onProgressionClicked.bind(_this);
	        _this.navigateToNextScreen = _this.navigateToNextScreen.bind(_this);
	        _this.setClass = _this.setClass.bind(_this);
	        _this.getButtonLabel = _this.getButtonLabel.bind(_this);
	        _this.componentWatcher = _this.componentWatcher.bind(_this);
	        _this.setBackgroundAsset = _this.setBackgroundAsset.bind(_this);
	        _this.setButtonStyles = _this.setButtonStyles.bind(_this);
	        _this.getCurrentBackgroundSize = _this.getCurrentBackgroundSize.bind(_this);
	        _this.setBackgroundClass = _this.setBackgroundClass.bind(_this);
	        _this.updateScreenResults = _lodash2.default.debounce(_this.updateScreenResults.bind(_this), 300);
	        _this.setScreenAccessed = _lodash2.default.debounce(_this.setScreenAccessed.bind(_this), 300);
	        return _this;
	    }
	
	    _createClass(TitleScreenImageBased, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            this.setButtonStyles();
	            this.setScreenAccessed();
	            this.props.biteCallbacks.showHeader(false);
	            window.addEventListener("resize", this.componentWatcher);
	            this.getLocale();
	            this.getAssets();
	            setTimeout(function () {
	                this.updateScreenResults(objectConstants.STATUS_COMPLETE);
	            }.bind(this), 1000);
	        }
	    }, {
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(nextProps) {
	            if (this.state.lang !== nextProps.lang) {
	                this.setState({
	                    lang: nextProps.lang,
	                    locale: appHelper.getLocalData(this.state.screen),
	                    start_label: appHelper.getLocaleString("start_label"),
	                    continue_label: appHelper.getLocaleString("continue_label")
	                });
	            }
	        }
	    }, {
	        key: 'componentDidUpdate',
	        value: function componentDidUpdate() {
	            //console.log(`updateBackgroundAssets`);
	            //console.log(this.state.button_styles);
	            if (this.state.updateBackgroundAssets) {
	                this.setBackgroundAsset();
	            }
	
	            if (this.state.updateButtonStyles) {
	                this.setButtonStyles();
	            }
	        }
	    }, {
	        key: 'componentWillUnmount',
	        value: function componentWillUnmount() {
	            window.removeEventListener("resize", this.componentWatcher);
	        }
	    }, {
	        key: 'componentWatcher',
	        value: function componentWatcher() {
	            var env = enviromentHelper.getEnvironment();
	            if (env.window.size !== this.state.env.window.size || env.window.orientation !== this.state.env.window.orientation) {
	                this.setState({ env: env, updateBackgroundAssets: true });
	            }
	        }
	    }, {
	        key: 'setScreenAccessed',
	        value: function setScreenAccessed() {
	            this.props.actions.setScreenAccessed(this.state.screen);
	        }
	    }, {
	        key: 'getCurrentBackgroundSize',
	        value: function getCurrentBackgroundSize() {
	            return this.state.adaptiveBackgroundSizes[this.state.env.window.size][this.state.env.window.orientation];
	        }
	    }, {
	        key: 'getLocale',
	        value: function getLocale() {
	            var locale = appHelper.getLocalData(this.state.screen);
	            this.props.actions.setScreenTitle(locale.title);
	            this.setState({ locale: Object.assign({}, locale) });
	        }
	    }, {
	        key: 'getAssets',
	        value: function getAssets() {
	            var large_background = {};
	            var mobile_background = {};
	            if (appHelper.isDefined(this.state.screen.assets.large_background)) {
	                large_background = appHelper.getLargeBackgroundAsset(this.state.screen.assets.large_background.upload);
	            }
	            if (appHelper.isDefined(this.state.screen.assets.mobile_background)) {
	                mobile_background = appHelper.getMobileBackgroundAsset(this.state.screen.assets.mobile_background.upload);
	            }
	            this.setState({
	                assets: Object.assign({}, this.state.assets, {
	                    large_background: appHelper.isDefined(large_background.src) ? large_background : this.state.assets.large_background,
	                    mobile_background: appHelper.isDefined(mobile_background.src) ? mobile_background : this.state.assets.mobile_background,
	                    current_background: appHelper.isDefined(large_background.src) ? large_background : this.state.assets.large_background
	                }),
	                currentAssetParams: this.state.screen.assets.large_background,
	                updateButtonStyles: true,
	                updateBackgroundAssets: true
	
	            });
	        }
	    }, {
	        key: 'setBackgroundAsset',
	        value: function setBackgroundAsset() {
	            this.setState({
	                assets: Object.assign({}, this.state.assets, {
	                    current_background: this.state.assets[this.getCurrentBackgroundSize()]
	                }),
	                currentAssetParams: this.state.screen.assets[this.getCurrentBackgroundSize()],
	                updateBackgroundAssets: false,
	                updateButtonStyles: true
	            });
	        }
	    }, {
	        key: 'getImagePath',
	        value: function getImagePath(image) {
	            if (appConstants.DEVELOPMENT_MODE) {
	                if (appHelper.isDefined(image) && image.length > 0) {
	                    return __webpack_require__(16)("./" + image);
	                }
	            } else {
	                return image;
	            }
	        }
	    }, {
	        key: 'getScreenId',
	        value: function getScreenId() {
	            return this.state.screen.screen_id;
	        }
	    }, {
	        key: 'getBiteId',
	        value: function getBiteId() {
	            return this.props.biteCallbacks.getBiteId();
	        }
	    }, {
	        key: 'updateScreenResults',
	        value: function updateScreenResults(screen_status) {
	            var _this2 = this;
	
	            var params = {
	                bite_id: this.getBiteId(),
	                screen_id: this.getScreenId(),
	                screen_status: screen_status
	            };
	
	            this.props.actions.updateScreenResults(params).then(function (userData) {
	                _this2.props.actions.setSuspendData(userData).then(function (trackingData) {
	                    if (screen_status === objectConstants.STATUS_COMPLETE) {
	                        _this2.props.actions.setScreenComplete(_this2.state.screen);
	                    }
	                }).catch(function (error) {});
	            }).catch(function (error) {});
	        }
	    }, {
	        key: 'onProgressionClicked',
	        value: function onProgressionClicked() {
	            this.setState({ isDisabled: true });
	
	            this.navigateToNextScreen();
	        }
	    }, {
	        key: 'navigateToNextScreen',
	        value: function navigateToNextScreen() {
	            var nextScreenId = appHelper.getNextScreenId(this.getScreenId());
	            if (localStorage.bites.length > 1 && nextScreenId.length === 0) {
	                this.context.router.push('menu');
	            } else {
	                this.props.actions.setNextLessonLocation(this.getScreenId());
	            }
	        }
	    }, {
	        key: 'setClass',
	        value: function setClass() {
	            return this.state.screen.include_logo ? "logo" : "";
	        }
	    }, {
	        key: 'getButtonLabel',
	        value: function getButtonLabel() {
	            var bite = appHelper.getBiteById(this.getBiteId());
	            if (bite.location_order === 1 & this.state.screen.display_order_id === 1) {
	                return this.state.start_label;
	            } else {
	                return this.state.continue_label;
	            }
	        }
	    }, {
	        key: 'setButtonStyles',
	        value: function setButtonStyles() {
	            var btn = this.refs.abs_btn;
	            var bg = this.refs.title_background;
	
	            if (appHelper.isDefined(btn) && appHelper.isDefined(bg)) {
	                var currentAssetParams = this.state.screen.assets[this.getCurrentBackgroundSize()];
	                var top = currentAssetParams.button_location.top;
	                var left = currentAssetParams.button_location.left;
	
	                var bgHeight = bg.offsetHeight;
	                var bgWidth = bg.offsetWidth;
	
	                //console.log(`bgWidth: ${bgWidth}`);
	                //console.log(`bgHeight: ${bgHeight}`);
	
	                var buttonHeight = btn.offsetHeight;
	                var buttonWidth = btn.offsetWidth;
	                //console.log(`buttonWidth: ${buttonWidth}`);
	                //console.log(`buttonHeight: ${buttonHeight}`);
	
	                var pHeight = bgHeight / 100 * top;
	                var pWidth = bgWidth / 100 * left;
	                //console.log(`pWidth: (${bgWidth} / 100) * ${left} = ${pWidth}`);
	                var moveTop = pHeight - buttonHeight / 2;
	
	                var btnBtm = moveTop + buttonHeight;
	
	                if (btnBtm > bgHeight) {
	                    moveTop = bgHeight - buttonHeight;
	                }
	
	                var moveLeft = pWidth - buttonWidth / 2;
	                var btnRight = moveLeft + buttonWidth;
	
	                if (btnRight > bgWidth) {
	                    moveLeft = bgWidth - buttonWidth;
	                }
	
	                //console.log(`moveLeft: ${pWidth} - (${buttonWidth} / 2) = ${moveLeft}`);
	
	                var moveTopPerc = moveTop / bgHeight * 100;
	                var moveLeftPerc = moveLeft / bgWidth * 100;
	
	                if (moveTopPerc < 0) {
	                    moveTopPerc = 0;
	                } else if (moveTop > bgHeight) {
	                    //console.log(`${moveTop} > ${bgHeight}`)
	                    moveTopPerc = 100;
	                }
	
	                if (moveLeftPerc < 0) {
	                    moveLeftPerc = 0;
	                } else if (moveLeftPerc > 100) {
	                    moveLeftPerc = 100;
	                }
	
	                //console.log(`moveLeftPerc: ${moveLeftPerc}`);
	
	                if (this.state.currentAssetParams.override_theme_button_styles) {
	
	                    this.setState({
	                        initialised: true,
	                        button_styles: Object.assign({}, {}, {
	                            top: moveTopPerc + '%',
	                            left: moveLeftPerc + '%',
	                            backgroundColor: currentAssetParams.button_background_color,
	                            color: currentAssetParams.button_text_color
	                        }),
	                        updateButtonStyles: false
	                    });
	                } else {
	                    this.setState({
	                        initialised: true,
	                        button_styles: Object.assign({}, {}, {
	                            top: moveTopPerc + '%',
	                            left: moveLeftPerc + '%'
	                        }),
	                        updateButtonStyles: false
	                    });
	                }
	            } else {
	                this.setState({ initialised: true, button_styles: Object.assign({}, {}), updateButtonStyles: false });
	            }
	        }
	    }, {
	        key: 'setBackgroundClass',
	        value: function setBackgroundClass() {
	            return this.getCurrentBackgroundSize() === objectConstants.LARGE_BACKGROUND ? "background-container title-screen" : "background-container";
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            return _react2.default.createElement(
	                'div',
	                { className: 'customer-scenario' },
	                _react2.default.createElement(
	                    'div',
	                    { className: this.setBackgroundClass() },
	                    _react2.default.createElement('img', { src: this.getImagePath(this.state.assets.current_background.src), className: 'title-screen', alt: '' })
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'screen-container', ref: 'title_background' },
	                    appHelper.isDefined(this.state.locale.title) ? _react2.default.createElement('h1', { className: 'hidden-el', dangerouslySetInnerHTML: { __html: this.state.locale.title } }) : null,
	                    _react2.default.createElement(
	                        'button',
	                        { className: 'btn btn-lg guroo-btn abs-btn continue-btn', ref: 'abs_btn',
	                            style: this.state.button_styles, disabled: this.state.isDisabled,
	                            onClick: this.onProgressionClicked },
	                        this.getButtonLabel()
	                    )
	                )
	            );
	        }
	    }]);
	
	    return TitleScreenImageBased;
	}(_react2.default.Component);
	
	TitleScreenImageBased.propTypes = {
	    screen: _propTypes2.default.object.isRequired,
	    biteCallbacks: _propTypes2.default.object.isRequired,
	    titles: _propTypes2.default.object.isRequired,
	    actions: _propTypes2.default.object.isRequired,
	    lang: _propTypes2.default.string.isRequired,
	    userData: _propTypes2.default.object.isRequired
	};
	
	TitleScreenImageBased.contextTypes = {
	    router: _propTypes2.default.object
	
	};
	
	function mapStateToProps(state, ownProps) {
	    var lang = state.userData.lang;
	    return {
	        lang: lang,
	        titles: state.titles,
	        userData: state.userData
	    };
	}
	
	function mapDispatchToProps(dispatch) {
	    return {
	        actions: (0, _redux.bindActionCreators)(Object.assign({}, appDataActions, trackingDataActions, userDataActions), dispatch)
	    };
	}
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(TitleScreenImageBased);

/***/ },
/* 551 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(5);
	
	var _redux = __webpack_require__(4);
	
	var _componentModels = __webpack_require__(204);
	
	var _IconButton = __webpack_require__(275);
	
	var _IconButton2 = _interopRequireDefault(_IconButton);
	
	var _trackingDataActions = __webpack_require__(7);
	
	var trackingDataActions = _interopRequireWildcard(_trackingDataActions);
	
	var _appDataActions = __webpack_require__(12);
	
	var appDataActions = _interopRequireWildcard(_appDataActions);
	
	var _userDataActions = __webpack_require__(20);
	
	var userDataActions = _interopRequireWildcard(_userDataActions);
	
	var _appHelper = __webpack_require__(3);
	
	var appHelper = _interopRequireWildcard(_appHelper);
	
	var _componentHelper = __webpack_require__(31);
	
	var componentHelper = _interopRequireWildcard(_componentHelper);
	
	var _appConstants = __webpack_require__(13);
	
	var appConstants = _interopRequireWildcard(_appConstants);
	
	var _objectConstants = __webpack_require__(9);
	
	var objectConstants = _interopRequireWildcard(_objectConstants);
	
	var _assetConstants = __webpack_require__(33);
	
	var assetConstants = _interopRequireWildcard(_assetConstants);
	
	var _localStorage = __webpack_require__(17);
	
	var localStorage = _interopRequireWildcard(_localStorage);
	
	var _gsap = __webpack_require__(8);
	
	var _gsapReactPlugin = __webpack_require__(10);
	
	var _gsapReactPlugin2 = _interopRequireDefault(_gsapReactPlugin);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } //eslint-disable-line import/no-named-as-default
	
	
	var TitleScreenManager = function (_React$Component) {
	    _inherits(TitleScreenManager, _React$Component);
	
	    function TitleScreenManager(props, context) {
	        _classCallCheck(this, TitleScreenManager);
	
	        var _this = _possibleConstructorReturn(this, (TitleScreenManager.__proto__ || Object.getPrototypeOf(TitleScreenManager)).call(this, props, context));
	
	        _this.state = {
	            screen: _this.props.screen,
	            sub_screen: {}
	        };
	        _this.getSubScreen = _this.getSubScreen.bind(_this);
	        return _this;
	    }
	
	    _createClass(TitleScreenManager, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            this.getSubScreen();
	        }
	    }, {
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(nextProps) {}
	    }, {
	        key: 'getSubScreen',
	        value: function getSubScreen() {
	            var sub_screen = componentHelper.getDefaultSubTitleScreenComponent();
	            if (appHelper.isDefined(this.state.screen.screen_sub_type_code)) {
	                sub_screen = componentHelper.getSubTitleScreenComponentByType(this.state.screen.screen_sub_type_code);
	            }
	
	            this.setState({ sub_screen: Object.assign({}, sub_screen) });
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var Component = appHelper.isDefined(this.state.sub_screen.component) ? this.state.sub_screen.component : undefined;
	            return appHelper.isDefined(Component) ? _react2.default.createElement(Component, { screen: this.state.screen, biteCallbacks: this.props.biteCallbacks }) : null;
	        }
	    }]);
	
	    return TitleScreenManager;
	}(_react2.default.Component);
	
	TitleScreenManager.propTypes = {
	    screen: _propTypes2.default.object.isRequired,
	    biteCallbacks: _propTypes2.default.object.isRequired,
	    titles: _propTypes2.default.object.isRequired,
	    actions: _propTypes2.default.object.isRequired,
	    userData: _propTypes2.default.object.isRequired
	};
	
	TitleScreenManager.contextTypes = {
	    router: _propTypes2.default.object
	
	};
	
	function mapStateToProps(state, ownProps) {
	    return {
	        titles: state.titles,
	        userData: state.userData
	    };
	}
	
	function mapDispatchToProps(dispatch) {
	    return {
	        actions: (0, _redux.bindActionCreators)(Object.assign({}, appDataActions, trackingDataActions, userDataActions), dispatch)
	    };
	}
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(TitleScreenManager);

/***/ },
/* 552 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(5);
	
	var _redux = __webpack_require__(4);
	
	var _trackingDataActions = __webpack_require__(7);
	
	var trackingDataActions = _interopRequireWildcard(_trackingDataActions);
	
	var _appHelper = __webpack_require__(3);
	
	var appHelper = _interopRequireWildcard(_appHelper);
	
	var _userDataHelper = __webpack_require__(15);
	
	var userDataHelper = _interopRequireWildcard(_userDataHelper);
	
	var _appConstants = __webpack_require__(13);
	
	var appConstants = _interopRequireWildcard(_appConstants);
	
	var _objectConstants = __webpack_require__(9);
	
	var objectConstants = _interopRequireWildcard(_objectConstants);
	
	var _keyboardConstants = __webpack_require__(14);
	
	var keyboardConstants = _interopRequireWildcard(_keyboardConstants);
	
	var _gsap = __webpack_require__(8);
	
	var _gsapReactPlugin = __webpack_require__(10);
	
	var _gsapReactPlugin2 = _interopRequireDefault(_gsapReactPlugin);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var VideoBtn = function (_React$Component) {
	    _inherits(VideoBtn, _React$Component);
	
	    function VideoBtn(props, context) {
	        _classCallCheck(this, VideoBtn);
	
	        var _this = _possibleConstructorReturn(this, (VideoBtn.__proto__ || Object.getPrototypeOf(VideoBtn)).call(this, props, context));
	
	        _this.state = {
	            lang: _this.props.lang,
	            userData: _this.props.userData,
	            object: _this.props.object,
	            activeObject: _this.props.activeObject,
	            enabledObjects: _this.props.enabledObjects,
	            completeObjects: _this.props.completeObjects,
	            focusedObject: _this.props.focusedObject,
	            className: "",
	            locale: appHelper.getLocalData(_this.props.object),
	            update: false,
	            video: {
	                src: "",
	                thumbnail: ""
	            }
	        };
	        _this.setClass = _this.setClass.bind(_this);
	        _this.getAssets = _this.getAssets.bind(_this);
	        _this.onClicked = _this.onClicked.bind(_this);
	        _this.objectIsEnabled = _this.objectIsEnabled.bind(_this);
	        _this.objectIsComplete = _this.objectIsComplete.bind(_this);
	        _this.getImagePath = _this.getImagePath.bind(_this);
	        _this.getObjectStatus = _this.getObjectStatus.bind(_this);
	        _this.setKeyboardAccessibility = _this.setKeyboardAccessibility.bind(_this);
	
	        return _this;
	    }
	
	    _createClass(VideoBtn, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            this.setClass();
	            this.getAssets();
	        }
	    }, {
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(nextProps) {
	
	            if (this.state.object !== nextProps.object) {
	                this.setState({ object: Object.assign({}, nextProps.object) });
	            }
	
	            if (this.state.userData !== nextProps.userData) {
	                this.setState({ userData: Object.assign({}, nextProps.userData) });
	            }
	
	            if (this.state.activeObject !== nextProps.activeObject) {
	                this.setState({ activeObject: Object.assign({}, nextProps.activeObject) });
	            }
	            if (this.state.enabledObjects !== nextProps.enabledObjects) {
	                this.setState({ enabledObjects: Object.assign([], nextProps.enabledObjects) });
	            }
	            if (this.state.completeObjects !== nextProps.completeObjects) {
	                this.setState({ completeObjects: Object.assign([], nextProps.completeObjects) });
	            }
	
	            if (this.state.focusedObject !== nextProps.focusedObject) {
	                this.setState({ focusedObject: Object.assign([], nextProps.focusedObject) });
	            }
	
	            if (this.state.lang !== nextProps.lang) {
	                var video = appHelper.getVideoAsset(this.props.object);
	                this.setState({
	                    lang: nextProps.lang,
	                    locale: appHelper.getLocalData(this.state.screen),
	                    video: appHelper.isDefined(video) && video.src.length > 0 ? video : this.state.video
	                });
	            }
	        }
	    }, {
	        key: 'componentDidUpdate',
	        value: function componentDidUpdate() {
	            if (this.state.update) {
	                this.setClass();
	            }
	        }
	    }, {
	        key: 'getAssets',
	        value: function getAssets() {
	            var video = appHelper.getVideoAsset(this.props.object);
	            video = appHelper.getLocalData(video);
	            if (appHelper.isDefined(video) && video.src.length > 0) {
	                this.setState({ video: video });
	            }
	        }
	    }, {
	        key: 'getImagePath',
	        value: function getImagePath(image) {
	            if (appConstants.DEVELOPMENT_MODE) {
	                if (appHelper.isDefined(image) && image.length > 0) {
	                    return __webpack_require__(16)("./" + image);
	                }
	            } else {
	                return image;
	            }
	        }
	    }, {
	        key: 'getObjectStatus',
	        value: function getObjectStatus() {
	            var objectUserData = {};
	            var subScreenParent = this.props.callbacks.getSubScreenParent();
	            var screen_id = this.props.callbacks.getScreenId();
	            if (appHelper.isDefined(subScreenParent)) {
	                objectUserData = userDataHelper.getSubScreenObjectStatus(this.state.userData, subScreenParent.screen_id, screen_id, this.state.object.asset_id);
	            } else if (this.state.isResourceObject) {
	                objectUserData = userDataHelper.getResourceScreenObjectUserData(this.state.userData, screen_id, this.state.object.asset_id);
	            } else {
	                objectUserData = userDataHelper.getObjectStatus(this.state.userData, screen_id, this.state.object.asset_id);
	            }
	
	            return objectUserData.status;
	        }
	    }, {
	        key: 'objectIsEnabled',
	        value: function objectIsEnabled() {
	            return appHelper.getArrayObjectIndexByKey(this.state.enabledObjects, "asset_id", this.state.object.asset_id);
	        }
	    }, {
	        key: 'objectIsComplete',
	        value: function objectIsComplete() {
	            return appHelper.getArrayObjectIndexByKey(this.state.completeObjects, "asset_id", this.state.object.asset_id);
	        }
	    }, {
	        key: 'setClass',
	        value: function setClass() {
	            var className = "";
	
	            if (appHelper.isDefined(this.state.activeObject.data) && this.state.activeObject.data.asset_id === this.state.object.asset_id) {
	                className += "active ";
	            }
	
	            if (this.objectIsEnabled() === -1) {
	                className += "disabled ";
	            }
	
	            if (this.objectIsComplete() > -1 || this.getObjectStatus() === objectConstants.STATUS_COMPLETE) {
	                className += "complete ";
	            } else {
	                className += "incomplete ";
	            }
	
	            if (this.state.focusedObject.asset_id === this.state.object.asset_id) {
	
	                className += "focused ";
	            } else {
	                className += "not-focused ";
	            }
	
	            return className;
	        }
	    }, {
	        key: 'onClicked',
	        value: function onClicked() {
	            if (this.objectIsEnabled() > -1 || this.getObjectStatus() === objectConstants.STATUS_COMPLETE) {
	                this.props.onClickFunc(this.state.object);
	            }
	        }
	    }, {
	        key: 'setKeyboardAccessibility',
	        value: function setKeyboardAccessibility(event) {
	            if (event.which === keyboardConstants.ENTER_KEY || event.which === keyboardConstants.SPACEBAR_KEY) {
	                event.preventDefault();
	                this.onClicked();
	            }
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            return _react2.default.createElement(
	                'div',
	                { className: 'video-btn ' + this.setClass(), onClick: this.onClicked, onKeyDown: this.setKeyboardAccessibility, role: 'presentation', 'aria-current': appHelper.isDefined(this.state.activeObject.data) && this.state.activeObject.data.asset_id === this.state.object.asset_id, 'aria-disabled': this.objectIsEnabled() === -1 },
	                _react2.default.createElement('img', { src: this.getImagePath(this.state.video.thumbnail), alt: '' })
	            );
	        }
	    }]);
	
	    return VideoBtn;
	}(_react2.default.Component);
	
	VideoBtn.propTypes = {
	    object: _propTypes2.default.object.isRequired,
	    activeObject: _propTypes2.default.object.isRequired,
	    enabledObjects: _propTypes2.default.array.isRequired,
	    completeObjects: _propTypes2.default.array.isRequired,
	    callbacks: _propTypes2.default.object.isRequired,
	    userData: _propTypes2.default.object.isRequired,
	    onClickFunc: _propTypes2.default.func,
	    focusedObject: _propTypes2.default.object,
	    lang: _propTypes2.default.string.isRequired,
	    actions: _propTypes2.default.object
	};
	
	VideoBtn.contextTypes = {
	    router: _propTypes2.default.object
	};
	
	function mapStateToProps(state, ownProps) {
	    var lang = state.userData.lang;
	    return {
	        lang: lang,
	        userData: state.userData
	    };
	}
	
	function mapDispatchToProps(dispatch) {
	    return {
	        actions: (0, _redux.bindActionCreators)(Object.assign({}, trackingDataActions), dispatch)
	    };
	}
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(VideoBtn);

/***/ },
/* 553 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(5);
	
	var _redux = __webpack_require__(4);
	
	var _VideoBtnMobile = __webpack_require__(285);
	
	var _VideoBtnMobile2 = _interopRequireDefault(_VideoBtnMobile);
	
	var _Button = __webpack_require__(18);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _ProducerNotes = __webpack_require__(85);
	
	var _ProducerNotes2 = _interopRequireDefault(_ProducerNotes);
	
	var _NotReadyYet = __webpack_require__(84);
	
	var _NotReadyYet2 = _interopRequireDefault(_NotReadyYet);
	
	var _SecondaryImage = __webpack_require__(66);
	
	var _SecondaryImage2 = _interopRequireDefault(_SecondaryImage);
	
	var _SecondaryLibraryImage = __webpack_require__(67);
	
	var _SecondaryLibraryImage2 = _interopRequireDefault(_SecondaryLibraryImage);
	
	var _trackingDataActions = __webpack_require__(7);
	
	var trackingDataActions = _interopRequireWildcard(_trackingDataActions);
	
	var _appDataActions = __webpack_require__(12);
	
	var appDataActions = _interopRequireWildcard(_appDataActions);
	
	var _userDataActions = __webpack_require__(20);
	
	var userDataActions = _interopRequireWildcard(_userDataActions);
	
	var _appHelper = __webpack_require__(3);
	
	var appHelper = _interopRequireWildcard(_appHelper);
	
	var _dataHelper = __webpack_require__(11);
	
	var dataHelper = _interopRequireWildcard(_dataHelper);
	
	var _componentHelper = __webpack_require__(31);
	
	var _userDataHelper = __webpack_require__(15);
	
	var userDataHelper = _interopRequireWildcard(_userDataHelper);
	
	var _appConstants = __webpack_require__(13);
	
	var appConstants = _interopRequireWildcard(_appConstants);
	
	var _assetConstants = __webpack_require__(33);
	
	var assetConstants = _interopRequireWildcard(_assetConstants);
	
	var _objectConstants = __webpack_require__(9);
	
	var objectConstants = _interopRequireWildcard(_objectConstants);
	
	var _localStorage = __webpack_require__(17);
	
	var localStorage = _interopRequireWildcard(_localStorage);
	
	var _gsap = __webpack_require__(8);
	
	var _gsapReactPlugin = __webpack_require__(10);
	
	var _gsapReactPlugin2 = _interopRequireDefault(_gsapReactPlugin);
	
	var _lodash = __webpack_require__(28);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } //eslint-disable-line import/no-named-as-default
	
	
	var VideoMobileScreen = function (_React$Component) {
	    _inherits(VideoMobileScreen, _React$Component);
	
	    function VideoMobileScreen(props, context) {
	        _classCallCheck(this, VideoMobileScreen);
	
	        var _this = _possibleConstructorReturn(this, (VideoMobileScreen.__proto__ || Object.getPrototypeOf(VideoMobileScreen)).call(this, props, context));
	
	        _this.state = {
	            lang: _this.props.lang,
	            screen: _this.props.screen,
	            userData: _this.props.userData,
	            is_resource_screen: appHelper.isDefined(_this.props.screen.is_resource_screen) && _this.props.screen.is_resource_screen,
	            locale: {},
	            status: objectConstants.STATUS_NOT_STARTED,
	            multiPath: appHelper.isDefined(_this.props.screen.multi_path) ? _this.props.screen.multi_path : { enabled: false },
	            allowReviewMode: true,
	            reviewMode: false,
	            propsUpdated: false,
	            renderedObject: {},
	            completeObjects: [],
	            enabledObjects: [],
	            updateCharacter: false,
	            screenCharacter: {},
	            assets: {
	                background: {
	                    src: "",
	                    type: "",
	                    type_id: ""
	                },
	                screenAsset: {
	                    src: "",
	                    pose: "",
	                    position: ""
	                }
	            },
	            callbacks: {
	                updateCharacterExpression: null,
	                onObjectComplete: null
	            },
	            callbacksSet: false,
	            currentObjectIndex: 0,
	            showProgression: false,
	            allowGoToScreen: false,
	            goToScreenId: 0,
	            terminateScreen: false,
	            terminateBite: false,
	            producerNotes: appHelper.getScreenNotes(_this.props.parentScreen, _this.props.screen),
	            screenIsReady: _this.props.screen.objects.length > 0 && (appHelper.canSeeContent(_this.props.screen) || appHelper.isDefined(_this.props.parentScreen)),
	            scrollToBtn: false,
	            continue_label: appHelper.getLocaleString("continue_label"),
	            nextObject: {}
	        };
	        _this.getLocale = _this.getLocale.bind(_this);
	        _this.setObjectEnabled = _this.setObjectEnabled.bind(_this);
	        _this.setObjectComplete = _this.setObjectComplete.bind(_this);
	        _this.getInitialObject = _this.getInitialObject.bind(_this);
	        _this.getObject = _this.getObject.bind(_this);
	        _this.setNextObject = _this.setNextObject.bind(_this);
	        _this.getScreenId = _this.getScreenId.bind(_this);
	        _this.getBiteId = _this.getBiteId.bind(_this);
	        _this.isReviewMode = _this.isReviewMode.bind(_this);
	        _this.getImagePath = _this.getImagePath.bind(_this);
	        _this.getAssets = _this.getAssets.bind(_this);
	        _this.setCallbacks = _this.setCallbacks.bind(_this);
	        _this.onObjectComplete = _this.onObjectComplete.bind(_this);
	        _this.updateScreenResults = _lodash2.default.debounce(_this.updateScreenResults.bind(_this), 300);
	        _this.setScreenAccessed = _lodash2.default.debounce(_this.setScreenAccessed.bind(_this), 300);
	        _this.showProgressionButton = _this.showProgressionButton.bind(_this);
	        _this.navigateToNextScreen = _this.navigateToNextScreen.bind(_this);
	        _this.scrollTo = _this.scrollTo.bind(_this);
	        _this.onScrollComplete = _this.onScrollComplete.bind(_this);
	        _this.onContinueBtnReveled = _this.onContinueBtnReveled.bind(_this);
	        _this.scrollToTop = _this.scrollToTop.bind(_this);
	        _this.checkScreenStatus = _this.checkScreenStatus.bind(_this);
	        _this.goToScreen = _this.goToScreen.bind(_this);
	        //new
	        _this.getCharacterName = _this.getCharacterName.bind(_this);
	        _this.handleObjectProgression = _this.handleObjectProgression.bind(_this);
	        _this.hasNextObject = _this.hasNextObject.bind(_this);
	        _this.getLayoutClass = _this.getLayoutClass.bind(_this);
	        _this.getScreenStatus = _this.getScreenStatus.bind(_this);
	        _this.getSubScreenParent = _this.getSubScreenParent.bind(_this);
	        _this.checkIsResourceScreen = _this.checkIsResourceScreen.bind(_this);
	        _this.updateResourceObjectResult = _this.updateResourceObjectResult.bind(_this);
	        _this.updateResourceScreenResult = _this.updateResourceScreenResult.bind(_this);
	        _this.setScreenNotReadyYet = _this.setScreenNotReadyYet.bind(_this);
	        _this.setScreenNotReadyYet = _this.setScreenNotReadyYet.bind(_this);
	        _this.scrollToVideo = _this.scrollToVideo.bind(_this);
	        return _this;
	    }
	
	    _createClass(VideoMobileScreen, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            this.setScreenAccessed();
	            this.props.biteCallbacks.showHeader(true);
	            this.checkScreenStatus();
	            this.setCallbacks();
	            this.getLocale();
	            if (this.state.screenIsReady) {
	                //this.setObjectEnabled(this.state.screen.objects[this.state.currentObjectIndex]);
	                this.getInitialObject();
	            } else {
	                this.setScreenNotReadyYet();
	            }
	            this.getAssets();
	        }
	    }, {
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(nextProps) {
	            var screenUserData = {};
	            if (this.state.is_resource_screen) {
	                screenUserData = userDataHelper.getResourceScreenUserData(nextProps.userData, this.state.screen.screen_id);
	            } else if (this.props.parentScreen) {
	                screenUserData = userDataHelper.getSubScreenUserData(nextProps.userData, this.props.parentScreen.screen_id, this.state.screen.screen_id);
	            } else {
	                screenUserData = userDataHelper.getScreenUserData(nextProps.userData, this.state.screen.screen_id);
	            }
	            this.setState({ userData: Object.assign({}, nextProps.userData) });
	
	            if (this.state.status !== screenUserData.status && screenUserData.status === objectConstants.STATUS_COMPLETE) {
	                this.setState({
	                    status: screenUserData.status
	                });
	            }
	
	            if (this.state.lang !== nextProps.lang) {
	                this.setState({
	                    lang: nextProps.lang,
	                    locale: appHelper.getLocalData(this.state.screen),
	                    continue_label: appHelper.getLocaleString("continue_label")
	                });
	
	                if (!appHelper.isDefined(this.props.parentScreen)) {
	                    this.props.actions.setScreenTitle(appHelper.getLocalData(this.state.screen).title);
	                }
	            }
	        }
	    }, {
	        key: 'componentDidUpdate',
	        value: function componentDidUpdate() {
	
	            if (this.state.updateCharacter) {
	
	                this.transitionCharacterExpressions();
	            }
	
	            if (appHelper.isDefined(this.state.nextObject.asset_id)) {
	                this.setNextObject();
	            }
	        }
	    }, {
	        key: 'setScreenAccessed',
	        value: function setScreenAccessed() {
	            this.props.actions.setScreenAccessed(this.state.screen, this.props.parentScreen);
	        }
	    }, {
	        key: 'setScreenNotReadyYet',
	        value: function setScreenNotReadyYet() {
	            var completionData = {
	                screen_status: objectConstants.STATUS_COMPLETE,
	                sub_screen_complete: appHelper.isDefined(this.props.parentScreen) ? true : undefined
	            };
	
	            this.showProgressionButton();
	
	            this.updateScreenResults(completionData);
	        }
	    }, {
	        key: 'checkScreenStatus',
	        value: function checkScreenStatus() {
	            var screenUserData = {};
	            if (this.state.is_resource_screen) {
	                screenUserData = userDataHelper.getResourceScreenUserData(this.state.userData, this.state.screen.screen_id);
	            } else if (this.props.parentScreen) {
	                screenUserData = userDataHelper.getSubScreenUserData(this.state.userData, this.props.parentScreen.screen_id, this.state.screen.screen_id);
	            } else {
	                screenUserData = userDataHelper.getScreenUserData(this.state.userData, this.state.screen.screen_id);
	            }
	
	            if (this.state.status !== screenUserData.status && screenUserData.status === objectConstants.STATUS_COMPLETE) {
	                this.setState({
	                    status: screenUserData.status
	                });
	            }
	        }
	    }, {
	        key: 'setCallbacks',
	        value: function setCallbacks() {
	            //console.log(`reviewMode: ${this.state.reviewMode} - line 125`);
	            this.setState({
	                callbacks: Object.assign({}, this.state.biteCallbacks, {
	                    updateCharacterExpression: this.updateCharacterExpression,
	                    onObjectComplete: this.onObjectComplete,
	                    getScreenId: this.getScreenId,
	                    getBiteId: this.getBiteId,
	                    storeUserResponse: this.storeUserResponse,
	                    scrollTo: this.scrollTo,
	                    scrollToVideo: this.scrollToVideo,
	                    isReviewMode: this.isReviewMode,
	                    getCharacterName: this.getCharacterName,
	                    hasNextObject: this.hasNextObject,
	                    navigateToNextScreen: this.navigateToNextScreen,
	                    getScreenStatus: this.getScreenStatus,
	                    getSubScreenParent: this.getSubScreenParent,
	                    checkIsResourceScreen: this.checkIsResourceScreen,
	                    goToScreen: this.goToScreen
	                }),
	                callbacksSet: true
	            });
	        }
	    }, {
	        key: 'getSubScreenParent',
	        value: function getSubScreenParent() {
	            return appHelper.isDefined(this.props.parentScreen) ? this.props.parentScreen : undefined;
	        }
	    }, {
	        key: 'getLocale',
	        value: function getLocale() {
	            var locale = appHelper.getLocalData(this.state.screen);
	            this.setState({ locale: Object.assign({}, locale) });
	            //if (!appHelper.isDefined(this.props.parentScreen) && !this.state.is_resource_screen) {
	            if (!appHelper.isDefined(this.props.parentScreen) && !this.state.is_resource_screen) {
	                this.props.actions.setScreenTitle(locale.title);
	            }
	        }
	    }, {
	        key: 'getScreenId',
	        value: function getScreenId() {
	            return this.state.screen.screen_id;
	        }
	    }, {
	        key: 'getBiteId',
	        value: function getBiteId() {
	
	            return this.props.biteCallbacks.getBiteId();
	        }
	    }, {
	        key: 'isReviewMode',
	        value: function isReviewMode() {
	            return this.state.reviewMode;
	        }
	    }, {
	        key: 'getCharacterName',
	        value: function getCharacterName() {
	            return this.state.locale.character_name;
	        }
	    }, {
	        key: 'getScreenStatus',
	        value: function getScreenStatus() {
	            return this.state.status;
	        }
	    }, {
	        key: 'checkIsResourceScreen',
	        value: function checkIsResourceScreen() {
	            return this.state.is_resource_screen;
	        }
	    }, {
	        key: 'setObjectEnabled',
	        value: function setObjectEnabled(object) {
	            var objectIndex = appHelper.getArrayObjectIndexByKey(this.state.enabledObjects, "asset_id", object.asset_id);
	            if (objectIndex === -1) {
	                this.setState({ enabledObjects: dataHelper.immutablePush(this.state.enabledObjects, object) });
	            }
	        }
	    }, {
	        key: 'setObjectComplete',
	        value: function setObjectComplete(object) {
	            var objectIndex = appHelper.getArrayObjectIndexByKey(this.state.completeObjects, "asset_id", object.asset_id);
	            if (objectIndex === -1) {
	                this.setState({ completeObjects: dataHelper.immutablePush(this.state.completeObjects, object) });
	            }
	        }
	    }, {
	        key: 'getInitialObject',
	        value: function getInitialObject() {
	            var enabledObjects = [];
	            var completeObjects = [];
	            for (var i = 0; i < this.state.screen.objects.length; i++) {
	                var object = this.state.screen.objects[i];
	                var objectUserData = {};
	                var subScreenParent = this.getSubScreenParent();
	                var screen_id = this.state.screen.screen_id;
	                if (appHelper.isDefined(subScreenParent)) {
	                    objectUserData = userDataHelper.getSubScreenObjectStatus(this.state.userData, subScreenParent.screen_id, screen_id, object.asset_id);
	                } else if (this.state.isResourceObject) {
	                    objectUserData = userDataHelper.getResourceScreenObjectUserData(this.state.userData, screen_id, object.asset_id);
	                } else {
	                    objectUserData = userDataHelper.getObjectStatus(this.state.userData, screen_id, object.asset_id);
	                }
	
	                if (i === 0) {
	                    enabledObjects = dataHelper.immutablePush(enabledObjects, object);
	                    if (objectUserData.status === objectConstants.STATUS_COMPLETE) {
	                        completeObjects = dataHelper.immutablePush(completeObjects, object);
	                    } else {
	                        this.getObject(object);
	                    }
	                } else {
	
	                    if (objectUserData.status === objectConstants.STATUS_COMPLETE) {
	                        enabledObjects = dataHelper.immutablePush(enabledObjects, object);
	                        completeObjects = dataHelper.immutablePush(completeObjects, object);
	                    } else {
	                        var previousObj = this.state.screen.objects[i - 1];
	                        var preObjectUserData = {};
	
	                        if (appHelper.isDefined(subScreenParent)) {
	                            preObjectUserData = userDataHelper.getSubScreenObjectStatus(this.state.userData, subScreenParent.screen_id, screen_id, previousObj.asset_id);
	                        } else if (this.state.isResourceObject) {
	                            preObjectUserData = userDataHelper.getResourceScreenObjectUserData(this.state.userData, screen_id, previousObj.asset_id);
	                        } else {
	                            preObjectUserData = userDataHelper.getObjectStatus(this.state.userData, screen_id, previousObj.asset_id);
	                        }
	
	                        if (preObjectUserData.status === objectConstants.STATUS_COMPLETE) {
	                            enabledObjects = dataHelper.immutablePush(enabledObjects, object);
	                            this.getObject(object);
	                        }
	                    }
	                }
	            }
	
	            if (completeObjects.length === this.state.screen.objects.length) {
	                this.getObject(this.state.screen.objects[0]);
	                this.showProgressionButton();
	            }
	
	            this.setState({
	                enabledObjects: Object.assign([], enabledObjects),
	                completeObjects: Object.assign([], completeObjects)
	            });
	        }
	    }, {
	        key: 'getObject',
	        value: function getObject(object) {
	            this.setState({
	                renderedObject: Object.assign({}, {}),
	                nextObject: object
	                //autoPlay: appHelper.getArrayObjectIndexByKey(this.state.screen.objects,"asset_id",object.asset_id) > 0
	            });
	        }
	    }, {
	        key: 'setNextObject',
	        value: function setNextObject() {
	            this.setState({ nextObject: Object.assign({}, {}) });
	            var objectLocale = appHelper.getLocalData(this.state.nextObject);
	            var objectType = Object.assign({}, (0, _componentHelper.getAssetComponentByType)(objectLocale.asset_sub_type_code), {
	                data: this.state.nextObject
	            });
	
	            this.setState({ renderedObject: Object.assign({}, objectType) });
	        }
	    }, {
	        key: 'getAssets',
	        value: function getAssets() {
	            var backgroundAsset = Object.assign(this.state.assets.background);
	
	            if (appHelper.isDefined(this.state.screen.assets.background)) {
	                backgroundAsset = appHelper.getBackgroundAsset(this.state.screen.assets.background);
	            }
	
	            this.setState({
	                assets: Object.assign({}, this.state.assets, {
	                    background: backgroundAsset
	
	                })
	            });
	        }
	    }, {
	        key: 'getImagePath',
	        value: function getImagePath(image) {
	            if (appConstants.DEVELOPMENT_MODE) {
	                if (appHelper.isDefined(image) && image.length > 0) {
	                    return __webpack_require__(16)("./" + image);
	                }
	            } else {
	                return image;
	            }
	        }
	    }, {
	        key: 'navigateToNextScreen',
	        value: function navigateToNextScreen() {
	            if (appHelper.isDefined(this.props.parentScreen)) {
	                if (appHelper.isDefined(this.props.closeDialog)) {
	                    this.props.closeDialog();
	                }
	                if (this.state.allowGoToScreen && !isNaN(parseInt(this.state.goToScreenId))) {
	                    this.goToScreen(this.state.goToScreenId);
	                } else if (this.state.terminateScreen) {
	                    var nextScreenId = appHelper.getNextScreenId(this.props.parentScreen.screen_id);
	                    if (localStorage.bites.length > 1 && nextScreenId.length === 0) {
	                        this.context.router.push('menu');
	                    } else {
	                        this.props.actions.setNextLessonLocation(nextScreenId);
	                    }
	                } else if (this.state.terminateBite) {
	                    if (localStorage.bites.length > 1) {
	                        this.context.router.push('menu');
	                    } else {
	                        var bite = appHelper.getBiteById(this.props.biteCallbacks.getBiteId());
	                        this.goToScreen(bite.screens[0].screen_id);
	                    }
	                } else {
	                    this.props.biteCallbacks.goToNextSubScreen(this.state.screen);
	                }
	            } else {
	                if (this.state.allowGoToScreen && !isNaN(parseInt(this.state.goToScreenId))) {
	                    this.goToScreen(this.state.goToScreenId);
	                } else if (this.state.terminateBite) {
	                    if (localStorage.bites.length > 1) {
	                        this.context.router.push('menu');
	                    } else {
	                        var _bite = appHelper.getBiteById(this.props.biteCallbacks.getBiteId());
	                        this.goToScreen(_bite.screens[0].screen_id);
	                    }
	                } else {
	                    var _nextScreenId = appHelper.getNextScreenId(this.getScreenId());
	                    if (localStorage.bites.length > 1 && _nextScreenId.length === 0) {
	                        this.context.router.push('menu');
	                    } else {
	                        this.props.actions.setNextLessonLocation(this.getScreenId());
	                    }
	                }
	            }
	        }
	    }, {
	        key: 'goToScreen',
	        value: function goToScreen(goTo) {
	            this.props.actions.setNewLessonLocation(goTo);
	        }
	    }, {
	        key: 'handleObjectProgression',
	        value: function handleObjectProgression() {}
	    }, {
	        key: 'onObjectComplete',
	        value: function onObjectComplete(completionData) {
	            var _this2 = this;
	
	            if (completionData.status === objectConstants.STATUS_COMPLETE) {
	                var screenUserData = {};
	                if (this.state.is_resource_screen) {
	                    screenUserData = userDataHelper.getResourceScreenUserData(this.state.userData, this.state.screen.screen_id);
	                } else if (this.props.parentScreen) {
	                    screenUserData = userDataHelper.getSubScreenUserData(this.state.userData, this.props.parentScreen.screen_id, this.state.screen.screen_id);
	                } else {
	                    screenUserData = userDataHelper.getScreenUserData(this.state.userData, this.state.screen.screen_id);
	                }
	                if (this.state.screen.status !== objectConstants.STATUS_COMPLETE && screenUserData.status !== objectConstants.STATUS_COMPLETE) {
	                    this.setState({ scrollToBtn: true });
	                }
	
	                var currentObject = appHelper.getArrayObjectByKey(this.state.screen.objects, "asset_id", completionData.asset_id);
	                this.setObjectComplete(currentObject);
	            }
	            if (completionData.progression === objectConstants.OBJECT_PROGRESSION_CONTINUE || completionData.progression === objectConstants.OBJECT_PROGRESSION_AUTO) {
	                var objectIndex = appHelper.getArrayObjectIndexByKey(this.state.screen.objects, "asset_id", completionData.asset_id);
	                if (objectIndex < this.state.screen.objects.length - 1) {
	                    var newIndex = objectIndex + 1;
	                    this.setState({ currentObjectIndex: newIndex });
	                    this.setObjectEnabled(this.state.screen.objects[newIndex]);
	
	                    if (this.state.status !== objectConstants.STATUS_COMPLETE) {
	                        //this.updateScreenResults(objectConstants.STATUS_IN_PROGRESS, asset_id, response);
	                    } else {
	                            // this.updateScreenResults(objectConstants.STATUS_COMPLETE, asset_id, response);
	                        }
	                    completionData = Object.assign({}, completionData, {
	                        screen_status: this.state.status !== objectConstants.STATUS_COMPLETE ? objectConstants.STATUS_IN_PROGRESS : objectConstants.STATUS_COMPLETE
	                    });
	                    if (this.state.is_resource_screen) {
	                        //save resource object tracking
	                        this.updateResourceObjectResult(completionData);
	                    } else {
	
	                        this.updateScreenResults(completionData);
	                    }
	                } else {
	
	                    if (this.state.is_resource_screen) {
	                        //Last object of resource screen we can add logic here when we need to
	                        this.updateResourceObjectResult(completionData);
	                    } else if (appHelper.isDefined(this.props.parentScreen)) {
	                        //////////////////////
	                        //COMPLETE SUB SCREEN
	                        /////////////////////
	
	
	                        if (!completionData.navigateToNextScreen) {
	                            this.showProgressionButton();
	                        }
	
	                        completionData = Object.assign({}, completionData, {
	                            screen_status: objectConstants.STATUS_COMPLETE,
	                            sub_screen_complete: true
	                        });
	
	                        this.updateScreenResults(completionData);
	
	                        //this.props.biteCallbacks.onSubScreenComplete(this.state.screen);
	                    } else {
	
	                        if (!completionData.navigateToNextScreen) {
	                            this.showProgressionButton();
	                        }
	
	                        completionData = Object.assign({}, completionData, {
	                            screen_status: objectConstants.STATUS_COMPLETE
	                        });
	
	                        this.updateScreenResults(completionData);
	                        //////////////////////
	                        //COMPLETE SCREEN
	                        /////////////////////
	                        //console.log(`complete screen`);
	                    }
	                }
	            } else if (completionData.progression === objectConstants.OBJECT_PROGRESSION_GO_TO) {
	                if (completionData.progressionType === objectConstants.GO_TO_TYPE_OBJECT) {
	                    var nextObjectIndex = appHelper.getArrayObjectIndexByKey(this.state.screen.objects, "asset_id", completionData.progressionGoToId);
	                    this.setState({ currentObjectIndex: nextObjectIndex });
	                    this.getObject(nextObjectIndex);
	                    this.updateScreenResults(completionData);
	                } else if (completionData.progressionType === objectConstants.GO_TO_TYPE_SCREEN) {
	
	                    this.setState({
	                        allowGoToScreen: true,
	                        goToScreenId: completionData.progressionGoToId
	                    });
	
	                    if (appHelper.isDefined(this.props.parentScreen)) {
	
	                        this.props.biteCallbacks.completeScreen();
	                        //////////////////////
	                        //COMPLETE SUB SCREEN
	                        /////////////////////
	                        if (!completionData.navigateToNextScreen) {
	                            this.showProgressionButton();
	                        }
	                        completionData = Object.assign({}, completionData, {
	                            screen_status: objectConstants.STATUS_COMPLETE,
	                            sub_screen_complete: true
	                        });
	
	                        this.updateScreenResults(completionData);
	                    } else {
	                        if (!completionData.navigateToNextScreen) {
	                            this.showProgressionButton();
	                        }
	                        completionData = Object.assign({}, completionData, {
	                            screen_status: objectConstants.STATUS_COMPLETE
	                        });
	                        this.updateScreenResults(completionData);
	                        //////////////////////
	                        //COMPLETE SCREEN
	                        /////////////////////
	                        //console.log(`complete screen`);
	                    }
	                }
	            } else if (completionData.progression === objectConstants.OBJECT_PROGRESSION_TERMINAL) {
	                if (completionData.progressionType === objectConstants.TERMINAL_TYPE_SCREEN) {
	                    this.setState({
	                        terminateScreen: true
	                    });
	
	                    if (appHelper.isDefined(this.props.parentScreen)) {
	                        //////////////////////
	                        //COMPLETE SUB SCREEN
	                        /////////////////////
	                        this.props.biteCallbacks.completeScreen();
	
	                        if (!completionData.navigateToNextScreen) {
	                            this.showProgressionButton();
	                        }
	                        completionData = Object.assign({}, completionData, {
	                            screen_status: objectConstants.STATUS_COMPLETE,
	                            sub_screen_complete: true
	                        });
	
	                        this.updateScreenResults(completionData);
	                    } else {
	                        if (!completionData.navigateToNextScreen) {
	                            this.showProgressionButton();
	                        }
	                        completionData = Object.assign({}, completionData, {
	                            screen_status: objectConstants.STATUS_COMPLETE
	                        });
	                        this.updateScreenResults(completionData);
	                        //////////////////////
	                        //COMPLETE SCREEN
	                        /////////////////////
	                        //console.log(`complete screen`);
	                    }
	                } else if (completionData.progressionType === objectConstants.TERMINAL_TYPE_BITE) {
	                    this.setState({
	                        terminateBite: true
	                    });
	
	                    var bite = appHelper.getBiteById(this.props.biteCallbacks.getBiteId());
	                    this.props.actions.terminateBite(bite).then(function (userData) {
	
	                        if (!completionData.navigateToNextScreen) {
	                            _this2.showProgressionButton();
	                        }
	
	                        if (appHelper.isDefined(_this2.props.parentScreen)) {
	                            _this2.props.biteCallbacks.completeScreen();
	                        }
	
	                        completionData = Object.assign({}, completionData, {
	                            screen_status: objectConstants.STATUS_COMPLETE
	                        });
	
	                        _this2.updateScreenResults(completionData);
	                    }).catch(function (error) {});
	                }
	            }
	        }
	    }, {
	        key: 'updateScreenResults',
	        value: function updateScreenResults(completionData) {
	            var _this3 = this;
	
	            var params = Object.assign({}, completionData, {
	                bite_id: this.getBiteId(),
	                parent_screen_id: appHelper.isDefined(this.props.parentScreen) ? this.props.parentScreen.screen_id : undefined,
	                screen_id: this.getScreenId(),
	                object_status: completionData.status,
	                object_result: {}
	            });
	
	            this.props.actions.updateScreenResults(params).then(function (userData) {
	                if (appHelper.isDefined(completionData.sub_screen_complete) && completionData.sub_screen_complete) {
	                    _this3.props.biteCallbacks.onSubScreenComplete(_this3.state.screen);
	                }
	                _this3.props.actions.setSuspendData(userData).then(function (trackingData) {
	
	                    if (completionData.screen_status === objectConstants.STATUS_COMPLETE) {
	                        _this3.props.actions.setScreenComplete(_this3.state.screen, _this3.props.parentScreen);
	                    }
	                }).catch(function (error) {});
	            }).catch(function (error) {});
	        }
	    }, {
	        key: 'updateResourceObjectResult',
	        value: function updateResourceObjectResult(completionData) {
	            var _this4 = this;
	
	            var params = Object.assign({}, completionData, {
	                screen_id: this.getScreenId(),
	                object_status: completionData.status
	
	            });
	            this.props.actions.updateResourceObjectResult(params).then(function (userData) {
	                _this4.props.actions.setSuspendData(userData).then(function (trackingData) {
	                    var resourceScreen = appHelper.getArrayObjectByKey(userData.resources, "screen_id", _this4.state.screen.screen_id);
	                    if (resourceScreen.status === objectConstants.STATUS_COMPLETE) {
	                        if (completionData.screen_status === objectConstants.STATUS_COMPLETE) {
	                            _this4.props.actions.setScreenComplete(_this4.state.screen);
	                        }
	                    }
	                }).catch(function (error) {});
	            }).catch(function (error) {});
	        }
	    }, {
	        key: 'updateResourceScreenResult',
	        value: function updateResourceScreenResult(completionData) {
	            var _this5 = this;
	
	            var params = Object.assign({}, completionData, {
	                screen_id: this.getScreenId(),
	                object_status: completionData.status,
	                screen_status: objectConstants.STATUS_COMPLETE
	            });
	            this.props.actions.updateResourceScreenResult(params).then(function (userData) {
	                _this5.props.actions.setSuspendData(userData).then(function (trackingData) {
	                    if (completionData.screen_status === objectConstants.STATUS_COMPLETE) {
	                        _this5.props.actions.setScreenComplete(_this5.state.screen);
	                    }
	                }).catch(function (error) {});
	            }).catch(function (error) {});
	        }
	    }, {
	        key: 'showProgressionButton',
	        value: function showProgressionButton() {
	            var nextScreenId = appHelper.getNextScreenId(this.state.screen.screen_id);
	            //if (nextScreenId.length > 0) {
	            this.setState({ showProgression: true });
	            //}
	        }
	    }, {
	        key: 'scrollTo',
	        value: function scrollTo(pos) {
	            if (this.state.status !== objectConstants.STATUS_COMPLETE || this.state.scrollToBtn) {
	                var feed = this.refs[this.state.screen.screen_id + '_feed'];
	                _gsap.TweenLite.to(feed, 0.5, {
	                    scrollTop: pos,
	                    ease: _gsap.Expo.easeInOut
	                }).eventCallback("onComplete", this.onScrollComplete);
	            }
	        }
	    }, {
	        key: 'onContinueBtnReveled',
	        value: function onContinueBtnReveled() {
	            this.scrollToTop();
	        }
	    }, {
	        key: 'scrollToVideo',
	        value: function scrollToVideo() {
	            var video = this.refs[this.state.screen.screen_id + '_video'];
	            var feed = this.refs[this.state.screen.screen_id + '_feed'];
	            _gsap.TweenLite.to(feed, 0.5, {
	                scrollTop: feed.offsetTop,
	                ease: _gsap.Expo.easeInOut
	            }).eventCallback("onComplete", this.onScrollComplete);
	        }
	    }, {
	        key: 'scrollToTop',
	        value: function scrollToTop() {
	            if (this.state.scrollToBtn) {
	                var anchor = this.refs[this.state.screen.screen_id + '_button'];
	                var scrollToValue = anchor.offsetTop + anchor.offsetHeight;
	                var scrollTo = this.scrollTo;
	                this.scrollTo(scrollToValue);
	            }
	        }
	    }, {
	        key: 'onScrollComplete',
	        value: function onScrollComplete() {}
	    }, {
	        key: 'hasNextObject',
	        value: function hasNextObject(object) {
	            var objectIndex = appHelper.getArrayObjectIndexByKey(this.state.screen.objects, "asset_id", object.asset_id);
	            return objectIndex < this.state.screen.objects.length - 1;
	        }
	    }, {
	        key: 'getLayoutClass',
	        value: function getLayoutClass() {
	            return this.state.screen.objects.length < 2 ? "single" : "";
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this6 = this;
	
	            return _react2.default.createElement(
	                'div',
	                { className: 'content-screen' },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'background-container' },
	                    !appHelper.isDefined(this.props.parentScreen) && !this.state.is_resource_screen ? _react2.default.createElement('img', { src: this.getImagePath(this.state.assets.background.src), alt: '' }) : null
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'screen-container' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'video-content-wrapper', id: this.state.screen.screen_id + '_feed_id', ref: this.state.screen.screen_id + '_feed' },
	                        this.state.producerNotes.length > 0 ? _react2.default.createElement(
	                            'div',
	                            { className: 'content-row' },
	                            _react2.default.createElement(_ProducerNotes2.default, { notes: this.state.producerNotes,
	                                screen_id: this.state.screen.screen_id })
	                        ) : null,
	                        !this.state.screenIsReady ? _react2.default.createElement(
	                            'div',
	                            { className: 'content-row' },
	                            _react2.default.createElement(_NotReadyYet2.default, { screen_id: this.state.screen.screen_id })
	                        ) : null,
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'content-row', ref: this.state.screen.screen_id + '_video' },
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'video-object-wrapper' },
	                                this.state.screenIsReady && this.state.callbacksSet ? _react2.default.createElement(
	                                    'div',
	                                    { className: 'thumbnail-col' },
	                                    this.state.screen.objects.map(function (object) {
	                                        return _react2.default.createElement(_VideoBtnMobile2.default, { key: object.asset_id + '_btn',
	                                            object: object,
	                                            activeObject: _this6.state.renderedObject,
	                                            enabledObjects: _this6.state.enabledObjects,
	                                            completeObjects: _this6.state.completeObjects,
	                                            callbacks: _this6.state.callbacks,
	                                            onClickFunc: _this6.getObject });
	                                    })
	                                ) : null
	                            )
	                        ),
	                        this.state.showProgression ? _react2.default.createElement(
	                            'div',
	                            { className: 'content-row', ref: this.state.screen.screen_id + '_button' },
	                            _react2.default.createElement(_Button2.default, {
	                                label: this.state.continue_label,
	                                id: this.state.screen.screen_id + '_button',
	                                onClick: this.navigateToNextScreen,
	                                onRevealed: this.onContinueBtnReveled
	                            })
	                        ) : null,
	                        _react2.default.createElement('div', { ref: this.state.screen.screen_id + '_bottom_anchor' })
	                    )
	                )
	            );
	        }
	    }]);
	
	    return VideoMobileScreen;
	}(_react2.default.Component);
	
	VideoMobileScreen.propTypes = {
	    screen: _propTypes2.default.object.isRequired,
	    biteCallbacks: _propTypes2.default.object.isRequired,
	    parentScreen: _propTypes2.default.object,
	    contentData: _propTypes2.default.object.isRequired,
	    trackingData: _propTypes2.default.object.isRequired,
	    userData: _propTypes2.default.object.isRequired,
	    actions: _propTypes2.default.object.isRequired,
	    lang: _propTypes2.default.string.isRequired,
	    closeDialog: _propTypes2.default.func
	};
	
	VideoMobileScreen.contextTypes = {
	    router: _propTypes2.default.object
	};
	
	function mapStateToProps(state, ownProps) {
	    var lang = state.userData.lang;
	    return {
	        lang: lang,
	        contentData: state.contentData,
	        trackingData: state.trackingData,
	        userData: state.userData
	
	    };
	}
	
	function mapDispatchToProps(dispatch) {
	    return {
	        actions: (0, _redux.bindActionCreators)(Object.assign({}, appDataActions, trackingDataActions, userDataActions), dispatch)
	    };
	}
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(VideoMobileScreen);

/***/ },
/* 554 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(5);
	
	var _redux = __webpack_require__(4);
	
	var _VideoBtn = __webpack_require__(552);
	
	var _VideoBtn2 = _interopRequireDefault(_VideoBtn);
	
	var _VideoBtnMobile = __webpack_require__(285);
	
	var _VideoBtnMobile2 = _interopRequireDefault(_VideoBtnMobile);
	
	var _Button = __webpack_require__(18);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _ProducerNotes = __webpack_require__(85);
	
	var _ProducerNotes2 = _interopRequireDefault(_ProducerNotes);
	
	var _NotReadyYet = __webpack_require__(84);
	
	var _NotReadyYet2 = _interopRequireDefault(_NotReadyYet);
	
	var _SecondaryImage = __webpack_require__(66);
	
	var _SecondaryImage2 = _interopRequireDefault(_SecondaryImage);
	
	var _SecondaryLibraryImage = __webpack_require__(67);
	
	var _SecondaryLibraryImage2 = _interopRequireDefault(_SecondaryLibraryImage);
	
	var _trackingDataActions = __webpack_require__(7);
	
	var trackingDataActions = _interopRequireWildcard(_trackingDataActions);
	
	var _appDataActions = __webpack_require__(12);
	
	var appDataActions = _interopRequireWildcard(_appDataActions);
	
	var _userDataActions = __webpack_require__(20);
	
	var userDataActions = _interopRequireWildcard(_userDataActions);
	
	var _appHelper = __webpack_require__(3);
	
	var appHelper = _interopRequireWildcard(_appHelper);
	
	var _dataHelper = __webpack_require__(11);
	
	var dataHelper = _interopRequireWildcard(_dataHelper);
	
	var _componentHelper = __webpack_require__(31);
	
	var _userDataHelper = __webpack_require__(15);
	
	var userDataHelper = _interopRequireWildcard(_userDataHelper);
	
	var _appConstants = __webpack_require__(13);
	
	var appConstants = _interopRequireWildcard(_appConstants);
	
	var _assetConstants = __webpack_require__(33);
	
	var assetConstants = _interopRequireWildcard(_assetConstants);
	
	var _objectConstants = __webpack_require__(9);
	
	var objectConstants = _interopRequireWildcard(_objectConstants);
	
	var _localStorage = __webpack_require__(17);
	
	var localStorage = _interopRequireWildcard(_localStorage);
	
	var _environmentHelper = __webpack_require__(56);
	
	var enviromentHelper = _interopRequireWildcard(_environmentHelper);
	
	var _keyboardConstants = __webpack_require__(14);
	
	var keyboardConstants = _interopRequireWildcard(_keyboardConstants);
	
	var _lodash = __webpack_require__(28);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _gsap = __webpack_require__(8);
	
	var _gsapReactPlugin = __webpack_require__(10);
	
	var _gsapReactPlugin2 = _interopRequireDefault(_gsapReactPlugin);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } //eslint-disable-line import/no-named-as-default
	
	
	var VideoScreen = function (_React$Component) {
	    _inherits(VideoScreen, _React$Component);
	
	    function VideoScreen(props, context) {
	        _classCallCheck(this, VideoScreen);
	
	        var _this = _possibleConstructorReturn(this, (VideoScreen.__proto__ || Object.getPrototypeOf(VideoScreen)).call(this, props, context));
	
	        _this.state = {
	            lang: _this.props.lang,
	            env: enviromentHelper.getEnvironment(),
	            screen: _this.props.screen,
	            userData: _this.props.userData,
	            is_resource_screen: appHelper.isDefined(_this.props.screen.is_resource_screen) && _this.props.screen.is_resource_screen,
	            locale: {},
	            status: objectConstants.STATUS_NOT_STARTED,
	            multiPath: appHelper.isDefined(_this.props.screen.multi_path) ? _this.props.screen.multi_path : { enabled: false },
	            allowReviewMode: true,
	            reviewMode: false,
	            propsUpdated: false,
	            renderedObject: {},
	            completeObjects: [],
	            enabledObjects: [],
	            updateCharacter: false,
	            screenCharacter: {},
	            assets: {
	                background: {
	                    src: "",
	                    type: "",
	                    type_id: ""
	                },
	                screenAsset: {
	                    src: "",
	                    pose: "",
	                    position: ""
	                }
	            },
	            callbacks: {
	                updateCharacterExpression: null,
	                onObjectComplete: null
	            },
	            callbacksSet: false,
	            currentObjectIndex: 0,
	            showProgression: false,
	            allowGoToScreen: false,
	            goToScreenId: 0,
	            terminateScreen: false,
	            terminateBite: false,
	            producerNotes: appHelper.getScreenNotes(_this.props.parentScreen, _this.props.screen),
	            screenIsReady: _this.props.screen.objects.length > 0 && (appHelper.canSeeContent(_this.props.screen) || appHelper.isDefined(_this.props.parentScreen)),
	            scrollToBtn: false,
	            autoPlay: false,
	            nextObject: {},
	            focusedObject: {},
	            continue_label: appHelper.getLocaleString("continue_label")
	        };
	        _this.getLocale = _this.getLocale.bind(_this);
	        _this.setObjectEnabled = _this.setObjectEnabled.bind(_this);
	        _this.setObjectComplete = _this.setObjectComplete.bind(_this);
	        _this.getInitialObject = _this.getInitialObject.bind(_this);
	        _this.getObject = _this.getObject.bind(_this);
	        _this.setNextObject = _this.setNextObject.bind(_this);
	        _this.getScreenId = _this.getScreenId.bind(_this);
	        _this.getBiteId = _this.getBiteId.bind(_this);
	        _this.isReviewMode = _this.isReviewMode.bind(_this);
	        _this.getImagePath = _this.getImagePath.bind(_this);
	        _this.getAssets = _this.getAssets.bind(_this);
	        _this.setCallbacks = _this.setCallbacks.bind(_this);
	        _this.onObjectComplete = _this.onObjectComplete.bind(_this);
	        _this.updateScreenResults = _lodash2.default.debounce(_this.updateScreenResults.bind(_this), 300);
	        _this.setScreenAccessed = _lodash2.default.debounce(_this.setScreenAccessed.bind(_this), 300);
	        _this.showProgressionButton = _this.showProgressionButton.bind(_this);
	        _this.navigateToNextScreen = _this.navigateToNextScreen.bind(_this);
	        _this.scrollTo = _this.scrollTo.bind(_this);
	        _this.onScrollComplete = _this.onScrollComplete.bind(_this);
	        _this.onContinueBtnReveled = _this.onContinueBtnReveled.bind(_this);
	        _this.scrollToTop = _this.scrollToTop.bind(_this);
	        _this.checkScreenStatus = _this.checkScreenStatus.bind(_this);
	        _this.goToScreen = _this.goToScreen.bind(_this);
	        //new
	        _this.getCharacterName = _this.getCharacterName.bind(_this);
	        _this.handleObjectProgression = _this.handleObjectProgression.bind(_this);
	        _this.hasNextObject = _this.hasNextObject.bind(_this);
	        _this.getLayoutClass = _this.getLayoutClass.bind(_this);
	        _this.getScreenStatus = _this.getScreenStatus.bind(_this);
	        _this.getSubScreenParent = _this.getSubScreenParent.bind(_this);
	        _this.checkIsResourceScreen = _this.checkIsResourceScreen.bind(_this);
	        _this.updateResourceObjectResult = _this.updateResourceObjectResult.bind(_this);
	        _this.updateResourceScreenResult = _this.updateResourceScreenResult.bind(_this);
	        _this.setScreenNotReadyYet = _this.setScreenNotReadyYet.bind(_this);
	        _this.setScreenNotReadyYet = _this.setScreenNotReadyYet.bind(_this);
	        _this.scrollToVideo = _this.scrollToVideo.bind(_this);
	
	        _this.setfocusedObject = _this.setfocusedObject.bind(_this);
	        _this.clearfocusedObject = _this.clearfocusedObject.bind(_this);
	        _this.getPrevObject = _this.getPrevObject.bind(_this);
	        _this.getNextObject = _this.getNextObject.bind(_this);
	        _this.setKeyboardAccessibility = _this.setKeyboardAccessibility.bind(_this);
	        _this.allowKeyAccessibility = _this.allowKeyAccessibility.bind(_this);
	        _this.objectIsEnabled = _this.objectIsEnabled.bind(_this);
	        _this.objectIsComplete = _this.objectIsComplete.bind(_this);
	        return _this;
	    }
	
	    _createClass(VideoScreen, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	
	            if (this.props.audio.audioRef.length > 0) {
	                this.props.actions.clearAudio();
	            }
	            this.setScreenAccessed();
	            this.props.biteCallbacks.showHeader(true);
	            this.checkScreenStatus();
	            this.setCallbacks();
	            this.getLocale();
	            if (this.state.screenIsReady) {
	                //this.setObjectEnabled(this.state.screen.objects[this.state.currentObjectIndex]);
	                this.getInitialObject();
	            } else {
	                this.setScreenNotReadyYet();
	            }
	            this.getAssets();
	        }
	    }, {
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(nextProps) {
	            var screenUserData = {};
	            if (this.state.is_resource_screen) {
	                screenUserData = userDataHelper.getResourceScreenUserData(nextProps.userData, this.state.screen.screen_id);
	            } else if (this.props.parentScreen) {
	                screenUserData = userDataHelper.getSubScreenUserData(nextProps.userData, this.props.parentScreen.screen_id, this.state.screen.screen_id);
	            } else {
	                screenUserData = userDataHelper.getScreenUserData(nextProps.userData, this.state.screen.screen_id);
	            }
	            this.setState({ userData: Object.assign({}, nextProps.userData) });
	
	            if (this.state.status !== screenUserData.status && screenUserData.status === objectConstants.STATUS_COMPLETE) {
	                this.setState({
	                    status: screenUserData.status
	                });
	            }
	
	            if (this.state.lang !== nextProps.lang) {
	                this.setState({
	                    lang: nextProps.lang,
	                    locale: appHelper.getLocalData(this.state.screen),
	                    continue_label: appHelper.getLocaleString("continue_label")
	                });
	                if (!appHelper.isDefined(this.props.parentScreen)) {
	                    this.props.actions.setScreenTitle(appHelper.getLocalData(this.state.screen).title);
	                }
	            }
	        }
	    }, {
	        key: 'componentDidUpdate',
	        value: function componentDidUpdate() {
	
	            if (this.state.updateCharacter) {
	
	                this.transitionCharacterExpressions();
	            }
	            if (appHelper.isDefined(this.state.nextObject.asset_id)) {
	                this.setNextObject();
	            }
	        }
	    }, {
	        key: 'componentWillUnmount',
	        value: function componentWillUnmount() {
	            this.props.actions.clearAudio();
	        }
	    }, {
	        key: 'setScreenAccessed',
	        value: function setScreenAccessed() {
	            this.props.actions.setScreenAccessed(this.state.screen, this.props.parentScreen);
	        }
	    }, {
	        key: 'setScreenNotReadyYet',
	        value: function setScreenNotReadyYet() {
	            var completionData = {
	                screen_status: objectConstants.STATUS_COMPLETE,
	                sub_screen_complete: appHelper.isDefined(this.props.parentScreen) ? true : undefined
	            };
	
	            this.showProgressionButton();
	
	            this.updateScreenResults(completionData);
	        }
	    }, {
	        key: 'checkScreenStatus',
	        value: function checkScreenStatus() {
	            var screenUserData = {};
	            if (this.state.is_resource_screen) {
	                screenUserData = userDataHelper.getResourceScreenUserData(this.state.userData, this.state.screen.screen_id);
	            } else if (this.props.parentScreen) {
	                screenUserData = userDataHelper.getSubScreenUserData(this.state.userData, this.props.parentScreen.screen_id, this.state.screen.screen_id);
	            } else {
	                screenUserData = userDataHelper.getScreenUserData(this.state.userData, this.state.screen.screen_id);
	            }
	
	            if (this.state.status !== screenUserData.status && screenUserData.status === objectConstants.STATUS_COMPLETE) {
	                this.setState({
	                    status: screenUserData.status
	                });
	            }
	        }
	    }, {
	        key: 'setCallbacks',
	        value: function setCallbacks() {
	            //console.log(`reviewMode: ${this.state.reviewMode} - line 125`);
	            this.setState({
	                callbacks: Object.assign({}, this.state.biteCallbacks, {
	                    updateCharacterExpression: this.updateCharacterExpression,
	                    onObjectComplete: this.onObjectComplete,
	                    getScreenId: this.getScreenId,
	                    getBiteId: this.getBiteId,
	                    storeUserResponse: this.storeUserResponse,
	                    scrollTo: this.scrollTo,
	                    scrollToVideo: this.scrollToVideo,
	                    isReviewMode: this.isReviewMode,
	                    getCharacterName: this.getCharacterName,
	                    hasNextObject: this.hasNextObject,
	                    navigateToNextScreen: this.navigateToNextScreen,
	                    getScreenStatus: this.getScreenStatus,
	                    getSubScreenParent: this.getSubScreenParent,
	                    checkIsResourceScreen: this.checkIsResourceScreen,
	                    goToScreen: this.goToScreen
	                }),
	                callbacksSet: true
	            });
	        }
	    }, {
	        key: 'getSubScreenParent',
	        value: function getSubScreenParent() {
	            return appHelper.isDefined(this.props.parentScreen) ? this.props.parentScreen : undefined;
	        }
	    }, {
	        key: 'getLocale',
	        value: function getLocale() {
	            var locale = appHelper.getLocalData(this.state.screen);
	            this.setState({ locale: Object.assign({}, locale) });
	            //if (!appHelper.isDefined(this.props.parentScreen) && !this.state.is_resource_screen) {
	            if (!appHelper.isDefined(this.props.parentScreen) && !this.state.is_resource_screen) {
	                this.props.actions.setScreenTitle(locale.title);
	            }
	        }
	    }, {
	        key: 'getScreenId',
	        value: function getScreenId() {
	            return this.state.screen.screen_id;
	        }
	    }, {
	        key: 'getBiteId',
	        value: function getBiteId() {
	
	            return this.props.biteCallbacks.getBiteId();
	        }
	    }, {
	        key: 'isReviewMode',
	        value: function isReviewMode() {
	            return this.state.reviewMode;
	        }
	    }, {
	        key: 'getCharacterName',
	        value: function getCharacterName() {
	            return this.state.locale.character_name;
	        }
	    }, {
	        key: 'getScreenStatus',
	        value: function getScreenStatus() {
	            return this.state.status;
	        }
	    }, {
	        key: 'checkIsResourceScreen',
	        value: function checkIsResourceScreen() {
	            return this.state.is_resource_screen;
	        }
	    }, {
	        key: 'setObjectEnabled',
	        value: function setObjectEnabled(object) {
	            var objectIndex = appHelper.getArrayObjectIndexByKey(this.state.enabledObjects, "asset_id", object.asset_id);
	            if (objectIndex === -1) {
	                this.setState({ enabledObjects: dataHelper.immutablePush(this.state.enabledObjects, object) });
	            }
	        }
	    }, {
	        key: 'setObjectComplete',
	        value: function setObjectComplete(object) {
	            var objectIndex = appHelper.getArrayObjectIndexByKey(this.state.completeObjects, "asset_id", object.asset_id);
	            if (objectIndex === -1) {
	                this.setState({ completeObjects: dataHelper.immutablePush(this.state.completeObjects, object) });
	            }
	        }
	    }, {
	        key: 'getInitialObject',
	        value: function getInitialObject() {
	            var enabledObjects = [];
	            var completeObjects = [];
	            for (var i = 0; i < this.state.screen.objects.length; i++) {
	                var object = this.state.screen.objects[i];
	                var objectUserData = {};
	                var subScreenParent = this.getSubScreenParent();
	                var screen_id = this.state.screen.screen_id;
	                if (appHelper.isDefined(subScreenParent)) {
	                    objectUserData = userDataHelper.getSubScreenObjectStatus(this.state.userData, subScreenParent.screen_id, screen_id, object.asset_id);
	                } else if (this.state.isResourceObject) {
	                    objectUserData = userDataHelper.getResourceScreenObjectUserData(this.state.userData, screen_id, object.asset_id);
	                } else {
	                    objectUserData = userDataHelper.getObjectStatus(this.state.userData, screen_id, object.asset_id);
	                }
	
	                if (i === 0) {
	                    enabledObjects = dataHelper.immutablePush(enabledObjects, object);
	                    if (objectUserData.status === objectConstants.STATUS_COMPLETE) {
	                        completeObjects = dataHelper.immutablePush(completeObjects, object);
	                    } else {
	                        this.getObject(object);
	                    }
	                } else {
	
	                    if (objectUserData.status === objectConstants.STATUS_COMPLETE) {
	                        enabledObjects = dataHelper.immutablePush(enabledObjects, object);
	                        completeObjects = dataHelper.immutablePush(completeObjects, object);
	                    } else {
	                        var previousObj = this.state.screen.objects[i - 1];
	                        var preObjectUserData = {};
	
	                        if (appHelper.isDefined(subScreenParent)) {
	                            preObjectUserData = userDataHelper.getSubScreenObjectStatus(this.state.userData, subScreenParent.screen_id, screen_id, previousObj.asset_id);
	                        } else if (this.state.isResourceObject) {
	                            preObjectUserData = userDataHelper.getResourceScreenObjectUserData(this.state.userData, screen_id, previousObj.asset_id);
	                        } else {
	                            preObjectUserData = userDataHelper.getObjectStatus(this.state.userData, screen_id, previousObj.asset_id);
	                        }
	
	                        if (preObjectUserData.status === objectConstants.STATUS_COMPLETE) {
	                            enabledObjects = dataHelper.immutablePush(enabledObjects, object);
	                            this.getObject(object);
	                        }
	                    }
	                }
	            }
	
	            if (completeObjects.length === this.state.screen.objects.length) {
	                this.getObject(this.state.screen.objects[0]);
	                this.showProgressionButton();
	            }
	
	            this.setState({
	                enabledObjects: Object.assign([], enabledObjects),
	                completeObjects: Object.assign([], completeObjects)
	            });
	        }
	    }, {
	        key: 'getObject',
	        value: function getObject(object) {
	            this.setState({
	                renderedObject: Object.assign({}, {}),
	                nextObject: object
	                //autoPlay: appHelper.getArrayObjectIndexByKey(this.state.screen.objects,"asset_id",object.asset_id) > 0
	            });
	        }
	    }, {
	        key: 'setNextObject',
	        value: function setNextObject() {
	            this.setState({ nextObject: Object.assign({}, {}) });
	            var objectLocale = appHelper.getLocalData(this.state.nextObject);
	            var objectType = Object.assign({}, (0, _componentHelper.getAssetComponentByType)(objectLocale.asset_sub_type_code), {
	                data: this.state.nextObject
	            });
	
	            this.setState({ renderedObject: Object.assign({}, objectType) });
	        }
	    }, {
	        key: 'getAssets',
	        value: function getAssets() {
	            var backgroundAsset = Object.assign(this.state.assets.background);
	
	            if (appHelper.isDefined(this.state.screen.assets.background)) {
	                backgroundAsset = appHelper.getBackgroundAsset(this.state.screen.assets.background);
	            }
	
	            this.setState({
	                assets: Object.assign({}, this.state.assets, {
	                    background: backgroundAsset
	
	                })
	            });
	        }
	    }, {
	        key: 'getImagePath',
	        value: function getImagePath(image) {
	            if (appConstants.DEVELOPMENT_MODE) {
	                if (appHelper.isDefined(image) && image.length > 0) {
	                    return __webpack_require__(16)("./" + image);
	                }
	            } else {
	                return image;
	            }
	        }
	    }, {
	        key: 'navigateToNextScreen',
	        value: function navigateToNextScreen() {
	            if (appHelper.isDefined(this.props.parentScreen)) {
	                if (appHelper.isDefined(this.props.closeDialog)) {
	                    this.props.closeDialog();
	                }
	                if (this.state.allowGoToScreen && !isNaN(parseInt(this.state.goToScreenId))) {
	                    this.goToScreen(this.state.goToScreenId);
	                } else if (this.state.terminateScreen) {
	                    var nextScreenId = appHelper.getNextScreenId(this.props.parentScreen.screen_id);
	                    if (localStorage.bites.length > 1 && nextScreenId.length === 0) {
	                        this.context.router.push('menu');
	                    } else {
	                        this.props.actions.setNextLessonLocation(nextScreenId);
	                    }
	                } else if (this.state.terminateBite) {
	                    if (localStorage.bites.length > 1) {
	                        this.context.router.push('menu');
	                    } else {
	                        var bite = appHelper.getBiteById(this.props.biteCallbacks.getBiteId());
	                        this.goToScreen(bite.screens[0].screen_id);
	                    }
	                } else {
	                    this.props.biteCallbacks.goToNextSubScreen(this.state.screen);
	                }
	            } else {
	                if (this.state.allowGoToScreen && !isNaN(parseInt(this.state.goToScreenId))) {
	                    this.goToScreen(this.state.goToScreenId);
	                } else if (this.state.terminateBite) {
	                    if (localStorage.bites.length > 1) {
	                        this.context.router.push('menu');
	                    } else {
	                        var _bite = appHelper.getBiteById(this.props.biteCallbacks.getBiteId());
	                        this.goToScreen(_bite.screens[0].screen_id);
	                    }
	                } else {
	                    var _nextScreenId = appHelper.getNextScreenId(this.getScreenId());
	                    if (localStorage.bites.length > 1 && _nextScreenId.length === 0) {
	                        this.context.router.push('menu');
	                    } else {
	                        this.props.actions.setNextLessonLocation(this.getScreenId());
	                    }
	                }
	            }
	        }
	    }, {
	        key: 'goToScreen',
	        value: function goToScreen(goTo) {
	            this.props.actions.setNewLessonLocation(goTo);
	        }
	    }, {
	        key: 'handleObjectProgression',
	        value: function handleObjectProgression() {}
	    }, {
	        key: 'onObjectComplete',
	        value: function onObjectComplete(completionData) {
	            var _this2 = this;
	
	            if (completionData.status === objectConstants.STATUS_COMPLETE) {
	                var screenUserData = {};
	                if (this.state.is_resource_screen) {
	                    screenUserData = userDataHelper.getResourceScreenUserData(this.state.userData, this.state.screen.screen_id);
	                } else if (this.props.parentScreen) {
	                    screenUserData = userDataHelper.getSubScreenUserData(this.state.userData, this.props.parentScreen.screen_id, this.state.screen.screen_id);
	                } else {
	                    screenUserData = userDataHelper.getScreenUserData(this.state.userData, this.state.screen.screen_id);
	                }
	                if (this.state.screen.status !== objectConstants.STATUS_COMPLETE && screenUserData.status !== objectConstants.STATUS_COMPLETE) {
	                    this.setState({ scrollToBtn: true });
	                }
	
	                var currentObject = appHelper.getArrayObjectByKey(this.state.screen.objects, "asset_id", completionData.asset_id);
	                this.setObjectComplete(currentObject);
	            }
	            if (completionData.progression === objectConstants.OBJECT_PROGRESSION_CONTINUE || completionData.progression === objectConstants.OBJECT_PROGRESSION_AUTO) {
	                var objectIndex = appHelper.getArrayObjectIndexByKey(this.state.screen.objects, "asset_id", completionData.asset_id);
	                if (objectIndex < this.state.screen.objects.length - 1) {
	                    var newIndex = objectIndex + 1;
	                    this.setState({ currentObjectIndex: newIndex });
	                    this.setObjectEnabled(this.state.screen.objects[newIndex]);
	
	                    if (this.state.status !== objectConstants.STATUS_COMPLETE) {
	                        //this.updateScreenResults(objectConstants.STATUS_IN_PROGRESS, asset_id, response);
	                    } else {
	                            // this.updateScreenResults(objectConstants.STATUS_COMPLETE, asset_id, response);
	                        }
	                    completionData = Object.assign({}, completionData, {
	                        screen_status: this.state.status !== objectConstants.STATUS_COMPLETE ? objectConstants.STATUS_IN_PROGRESS : objectConstants.STATUS_COMPLETE
	                    });
	                    if (this.state.is_resource_screen) {
	                        //save resource object tracking
	                        this.updateResourceObjectResult(completionData);
	                    } else {
	
	                        this.updateScreenResults(completionData);
	                    }
	                } else {
	
	                    if (this.state.is_resource_screen) {
	                        //Last object of resource screen we can add logic here when we need to
	                        this.updateResourceObjectResult(completionData);
	                    } else if (appHelper.isDefined(this.props.parentScreen)) {
	                        //////////////////////
	                        //COMPLETE SUB SCREEN
	                        /////////////////////
	
	
	                        if (!completionData.navigateToNextScreen) {
	                            this.showProgressionButton();
	                        }
	
	                        completionData = Object.assign({}, completionData, {
	                            screen_status: objectConstants.STATUS_COMPLETE,
	                            sub_screen_complete: true
	                        });
	
	                        this.updateScreenResults(completionData);
	
	                        //this.props.biteCallbacks.onSubScreenComplete(this.state.screen);
	                    } else {
	
	                        if (!completionData.navigateToNextScreen) {
	                            this.showProgressionButton();
	                        }
	
	                        completionData = Object.assign({}, completionData, {
	                            screen_status: objectConstants.STATUS_COMPLETE
	                        });
	
	                        this.updateScreenResults(completionData);
	                        //////////////////////
	                        //COMPLETE SCREEN
	                        /////////////////////
	                        //console.log(`complete screen`);
	                    }
	                }
	            } else if (completionData.progression === objectConstants.OBJECT_PROGRESSION_GO_TO) {
	                if (completionData.progressionType === objectConstants.GO_TO_TYPE_OBJECT) {
	                    var nextObjectIndex = appHelper.getArrayObjectIndexByKey(this.state.screen.objects, "asset_id", completionData.progressionGoToId);
	                    this.setState({ currentObjectIndex: nextObjectIndex });
	                    this.getObject(nextObjectIndex);
	                    this.updateScreenResults(completionData);
	                } else if (completionData.progressionType === objectConstants.GO_TO_TYPE_SCREEN) {
	
	                    this.setState({
	                        allowGoToScreen: true,
	                        goToScreenId: completionData.progressionGoToId
	                    });
	
	                    if (appHelper.isDefined(this.props.parentScreen)) {
	
	                        this.props.biteCallbacks.completeScreen();
	                        //////////////////////
	                        //COMPLETE SUB SCREEN
	                        /////////////////////
	                        if (!completionData.navigateToNextScreen) {
	                            this.showProgressionButton();
	                        }
	                        completionData = Object.assign({}, completionData, {
	                            screen_status: objectConstants.STATUS_COMPLETE,
	                            sub_screen_complete: true
	                        });
	
	                        this.updateScreenResults(completionData);
	                    } else {
	                        if (!completionData.navigateToNextScreen) {
	                            this.showProgressionButton();
	                        }
	                        completionData = Object.assign({}, completionData, {
	                            screen_status: objectConstants.STATUS_COMPLETE
	                        });
	                        this.updateScreenResults(completionData);
	                        //////////////////////
	                        //COMPLETE SCREEN
	                        /////////////////////
	                        //console.log(`complete screen`);
	                    }
	                }
	            } else if (completionData.progression === objectConstants.OBJECT_PROGRESSION_TERMINAL) {
	                if (completionData.progressionType === objectConstants.TERMINAL_TYPE_SCREEN) {
	                    this.setState({
	                        terminateScreen: true
	                    });
	
	                    if (appHelper.isDefined(this.props.parentScreen)) {
	                        //////////////////////
	                        //COMPLETE SUB SCREEN
	                        /////////////////////
	                        this.props.biteCallbacks.completeScreen();
	
	                        if (!completionData.navigateToNextScreen) {
	                            this.showProgressionButton();
	                        }
	                        completionData = Object.assign({}, completionData, {
	                            screen_status: objectConstants.STATUS_COMPLETE,
	                            sub_screen_complete: true
	                        });
	
	                        this.updateScreenResults(completionData);
	                    } else {
	                        if (!completionData.navigateToNextScreen) {
	                            this.showProgressionButton();
	                        }
	                        completionData = Object.assign({}, completionData, {
	                            screen_status: objectConstants.STATUS_COMPLETE
	                        });
	                        this.updateScreenResults(completionData);
	                        //////////////////////
	                        //COMPLETE SCREEN
	                        /////////////////////
	                        //console.log(`complete screen`);
	                    }
	                } else if (completionData.progressionType === objectConstants.TERMINAL_TYPE_BITE) {
	                    this.setState({
	                        terminateBite: true
	                    });
	
	                    var bite = appHelper.getBiteById(this.props.biteCallbacks.getBiteId());
	                    this.props.actions.terminateBite(bite).then(function (userData) {
	
	                        if (!completionData.navigateToNextScreen) {
	                            _this2.showProgressionButton();
	                        }
	
	                        if (appHelper.isDefined(_this2.props.parentScreen)) {
	                            _this2.props.biteCallbacks.completeScreen();
	                        }
	
	                        completionData = Object.assign({}, completionData, {
	                            screen_status: objectConstants.STATUS_COMPLETE
	                        });
	
	                        _this2.updateScreenResults(completionData);
	                    }).catch(function (error) {});
	                }
	            }
	        }
	    }, {
	        key: 'updateScreenResults',
	        value: function updateScreenResults(completionData) {
	            var _this3 = this;
	
	            var params = Object.assign({}, completionData, {
	                bite_id: this.getBiteId(),
	                parent_screen_id: appHelper.isDefined(this.props.parentScreen) ? this.props.parentScreen.screen_id : undefined,
	                screen_id: this.getScreenId(),
	                object_status: completionData.status,
	                object_result: {}
	            });
	
	            this.props.actions.updateScreenResults(params).then(function (userData) {
	                if (appHelper.isDefined(completionData.sub_screen_complete) && completionData.sub_screen_complete) {
	                    _this3.props.biteCallbacks.onSubScreenComplete(_this3.state.screen);
	                }
	                _this3.props.actions.setSuspendData(userData).then(function (trackingData) {
	
	                    if (completionData.screen_status === objectConstants.STATUS_COMPLETE) {
	                        _this3.props.actions.setScreenComplete(_this3.state.screen, _this3.props.parentScreen);
	                    }
	                }).catch(function (error) {});
	            }).catch(function (error) {});
	        }
	    }, {
	        key: 'updateResourceObjectResult',
	        value: function updateResourceObjectResult(completionData) {
	            var _this4 = this;
	
	            var params = Object.assign({}, completionData, {
	                screen_id: this.getScreenId(),
	                object_status: completionData.status
	
	            });
	            this.props.actions.updateResourceObjectResult(params).then(function (userData) {
	                _this4.props.actions.setSuspendData(userData).then(function (trackingData) {
	                    var resourceScreen = appHelper.getArrayObjectByKey(userData.resources, "screen_id", _this4.state.screen.screen_id);
	                    if (resourceScreen.status === objectConstants.STATUS_COMPLETE) {
	                        if (completionData.screen_status === objectConstants.STATUS_COMPLETE) {
	                            _this4.props.actions.setScreenComplete(_this4.state.screen);
	                        }
	                    }
	                }).catch(function (error) {});
	            }).catch(function (error) {});
	        }
	    }, {
	        key: 'updateResourceScreenResult',
	        value: function updateResourceScreenResult(completionData) {
	            var _this5 = this;
	
	            var params = Object.assign({}, completionData, {
	                screen_id: this.getScreenId(),
	                object_status: completionData.status,
	                screen_status: objectConstants.STATUS_COMPLETE
	            });
	            this.props.actions.updateResourceScreenResult(params).then(function (userData) {
	                _this5.props.actions.setSuspendData(userData).then(function (trackingData) {
	                    if (completionData.screen_status === objectConstants.STATUS_COMPLETE) {
	                        _this5.props.actions.setScreenComplete(_this5.state.screen);
	                    }
	                }).catch(function (error) {});
	            }).catch(function (error) {});
	        }
	    }, {
	        key: 'showProgressionButton',
	        value: function showProgressionButton() {
	            var nextScreenId = appHelper.getNextScreenId(this.state.screen.screen_id);
	            //if (nextScreenId.length > 0) {
	            this.setState({ showProgression: true });
	            //}
	        }
	    }, {
	        key: 'scrollTo',
	        value: function scrollTo(pos) {
	            if (this.state.status !== objectConstants.STATUS_COMPLETE || this.state.scrollToBtn) {
	                var feed = this.refs[this.state.screen.screen_id + '_feed'];
	                _gsap.TweenLite.to(feed, 0.5, {
	                    scrollTop: pos,
	                    ease: _gsap.Expo.easeInOut
	                }).eventCallback("onComplete", this.onScrollComplete);
	            }
	        }
	    }, {
	        key: 'onContinueBtnReveled',
	        value: function onContinueBtnReveled() {
	            this.scrollToTop();
	        }
	    }, {
	        key: 'scrollToVideo',
	        value: function scrollToVideo() {
	            var video = this.refs[this.state.screen.screen_id + '_video'];
	            var feed = this.refs[this.state.screen.screen_id + '_feed'];
	            _gsap.TweenLite.to(feed, 0.5, {
	                scrollTop: feed.offsetTop,
	                ease: _gsap.Expo.easeInOut
	            }).eventCallback("onComplete", this.onScrollComplete);
	        }
	    }, {
	        key: 'scrollToTop',
	        value: function scrollToTop() {
	            if (this.state.scrollToBtn) {
	                var anchor = this.refs[this.state.screen.screen_id + '_button'];
	                var scrollToValue = anchor.offsetTop + anchor.offsetHeight;
	                var scrollTo = this.scrollTo;
	                this.scrollTo(scrollToValue);
	            }
	        }
	    }, {
	        key: 'onScrollComplete',
	        value: function onScrollComplete() {}
	    }, {
	        key: 'hasNextObject',
	        value: function hasNextObject(object) {
	            var objectIndex = appHelper.getArrayObjectIndexByKey(this.state.screen.objects, "asset_id", object.asset_id);
	            return objectIndex < this.state.screen.objects.length - 1;
	        }
	    }, {
	        key: 'getLayoutClass',
	        value: function getLayoutClass() {
	            return this.state.screen.objects.length < 2 ? "single" : "";
	        }
	
	        //new
	
	    }, {
	        key: 'setfocusedObject',
	        value: function setfocusedObject() {
	            this.setState({ focusedObject: Object.assign({}, this.state.screen.objects[0]) });
	        }
	    }, {
	        key: 'clearfocusedObject',
	        value: function clearfocusedObject() {
	            this.setState({ focusedObject: Object.assign({}, {}) });
	        }
	    }, {
	        key: 'getPrevObject',
	        value: function getPrevObject() {
	            var objectIndex = appHelper.getArrayObjectIndexByKey(this.state.screen.objects, "asset_id", this.state.focusedObject.asset_id);
	            var nextObject = this.state.screen.objects[objectIndex - 1];
	            if (objectIndex <= 0) {
	                nextObject = this.state.screen.objects[this.state.screen.objects.length - 1];
	            }
	
	            this.setState({ focusedObject: Object.assign({}, nextObject) });
	        }
	    }, {
	        key: 'getNextObject',
	        value: function getNextObject() {
	            var objectIndex = appHelper.getArrayObjectIndexByKey(this.state.screen.objects, "asset_id", this.state.focusedObject.asset_id);
	            var nextObject = this.state.screen.objects[objectIndex + 1];
	            if (objectIndex === this.state.screen.objects.length - 1) {
	                nextObject = this.state.screen.objects[0];
	            }
	            this.setState({ focusedObject: Object.assign({}, nextObject) });
	        }
	    }, {
	        key: 'allowKeyAccessibility',
	        value: function allowKeyAccessibility() {
	            return this.objectIsEnabled() > -1 || this.objectIsComplete() > -1;
	        }
	    }, {
	        key: 'setKeyboardAccessibility',
	        value: function setKeyboardAccessibility(event) {
	            if (event.which === keyboardConstants.ENTER_KEY || event.which === keyboardConstants.SPACEBAR_KEY) {
	                event.preventDefault();
	                if (this.allowKeyAccessibility()) {
	                    this.getObject(this.state.focusedObject);
	                }
	            }
	
	            if (event.which === keyboardConstants.ARROW_LEFT_KEY) {
	                event.preventDefault();
	                this.getPrevObject();
	            }
	
	            if (event.which === keyboardConstants.ARROW_RIGHT_KEY) {
	                event.preventDefault();
	                this.getNextObject();
	            }
	
	            if (event.which === keyboardConstants.ARROW_UP_KEY) {
	                event.preventDefault();
	                this.getPrevObject();
	            }
	
	            if (event.which === keyboardConstants.ARROW_DOWN_KEY) {
	                event.preventDefault();
	                this.getNextObject();
	            }
	        }
	    }, {
	        key: 'objectIsEnabled',
	        value: function objectIsEnabled() {
	            return appHelper.getArrayObjectIndexByKey(this.state.enabledObjects, "asset_id", this.state.focusedObject.asset_id);
	        }
	    }, {
	        key: 'objectIsComplete',
	        value: function objectIsComplete() {
	            return appHelper.getArrayObjectIndexByKey(this.state.completeObjects, "asset_id", this.state.focusedObject.asset_id);
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this6 = this;
	
	            return _react2.default.createElement(
	                'div',
	                { className: 'content-screen' },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'background-container' },
	                    !appHelper.isDefined(this.props.parentScreen) && !this.state.is_resource_screen ? _react2.default.createElement('img', { src: this.getImagePath(this.state.assets.background.src), alt: '' }) : null
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'screen-container' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'video-content-wrapper', id: this.state.screen.screen_id + '_feed_id', ref: this.state.screen.screen_id + '_feed' },
	                        this.state.producerNotes.length > 0 ? _react2.default.createElement(
	                            'div',
	                            { className: 'content-row' },
	                            _react2.default.createElement(_ProducerNotes2.default, { notes: this.state.producerNotes,
	                                screen_id: this.state.screen.screen_id })
	                        ) : null,
	                        !this.state.screenIsReady ? _react2.default.createElement(
	                            'div',
	                            { className: 'content-row' },
	                            _react2.default.createElement(_NotReadyYet2.default, { screen_id: this.state.screen.screen_id })
	                        ) : null,
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'content-row', ref: this.state.screen.screen_id + '_video' },
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'video-object-wrapper' },
	                                this.state.screen.objects.length > 1 ? _react2.default.createElement(
	                                    'div',
	                                    { className: 'thumbnail-col',
	                                        id: this.state.screen.screen_id + '_tabs',
	                                        ref: this.state.screen.screen_id + '_tabs',
	                                        role: 'radiogroup',
	                                        tabIndex: 0,
	                                        onFocus: this.setfocusedObject,
	                                        onBlur: this.clearfocusedObject,
	                                        onKeyDown: this.setKeyboardAccessibility },
	                                    this.state.screenIsReady && this.state.screen.objects.length > 1 && this.state.callbacksSet && this.state.env.window.size !== "xs" ? this.state.screen.objects.map(function (object) {
	                                        return _react2.default.createElement(_VideoBtn2.default, { key: object.asset_id + '_btn',
	                                            object: object,
	                                            activeObject: _this6.state.renderedObject,
	                                            enabledObjects: _this6.state.enabledObjects,
	                                            completeObjects: _this6.state.completeObjects,
	                                            callbacks: _this6.state.callbacks,
	                                            onClickFunc: _this6.getObject,
	                                            focusedObject: _this6.state.focusedObject
	                                        });
	                                    }) : null,
	                                    this.state.screenIsReady && this.state.screen.objects.length > 0 && this.state.callbacksSet && this.state.env.window.size === "xs" ? this.state.screen.objects.map(function (object) {
	                                        return _react2.default.createElement(_VideoBtnMobile2.default, { key: object.asset_id + '_btn',
	                                            object: object,
	                                            activeObject: _this6.state.renderedObject,
	                                            enabledObjects: _this6.state.enabledObjects,
	                                            completeObjects: _this6.state.completeObjects,
	                                            callbacks: _this6.state.callbacks,
	                                            onClickFunc: _this6.getObject,
	                                            focusedObject: _this6.state.focusedObject
	                                        });
	                                    }) : null
	                                ) : null,
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: 'video-col ' + this.getLayoutClass() },
	                                    this.state.screenIsReady && appHelper.isDefined(this.state.renderedObject.data) ? _react2.default.createElement(this.state.renderedObject.component, {
	                                        screenObject: this.state.renderedObject.data,
	                                        video: appHelper.getLocalData(appHelper.getVideoAsset(this.state.renderedObject.data)),
	                                        autoPlay: this.state.autoPlay,
	                                        callbacks: this.state.callbacks }) : null
	                                )
	                            )
	                        ),
	                        this.state.showProgression ? _react2.default.createElement(
	                            'div',
	                            { className: 'content-row', ref: this.state.screen.screen_id + '_button' },
	                            _react2.default.createElement(_Button2.default, {
	                                label: this.state.continue_label,
	                                id: this.state.screen.screen_id + '_button',
	                                onClick: this.navigateToNextScreen,
	                                onRevealed: this.onContinueBtnReveled
	                            })
	                        ) : null,
	                        _react2.default.createElement('div', { ref: this.state.screen.screen_id + '_bottom_anchor' })
	                    )
	                )
	            );
	        }
	    }]);
	
	    return VideoScreen;
	}(_react2.default.Component);
	
	VideoScreen.propTypes = {
	    screen: _propTypes2.default.object.isRequired,
	    biteCallbacks: _propTypes2.default.object.isRequired,
	    parentScreen: _propTypes2.default.object,
	    contentData: _propTypes2.default.object.isRequired,
	    trackingData: _propTypes2.default.object.isRequired,
	    userData: _propTypes2.default.object.isRequired,
	    actions: _propTypes2.default.object.isRequired,
	    audio: _propTypes2.default.object.isRequired,
	    closeDialog: _propTypes2.default.func,
	    lang: _propTypes2.default.string.isRequired
	
	};
	
	VideoScreen.contextTypes = {
	    router: _propTypes2.default.object
	};
	
	function mapStateToProps(state, ownProps) {
	    var lang = state.userData.lang;
	    return {
	        lang: lang,
	        contentData: state.contentData,
	        trackingData: state.trackingData,
	        userData: state.userData,
	        audio: state.audio
	    };
	}
	
	function mapDispatchToProps(dispatch) {
	    return {
	        actions: (0, _redux.bindActionCreators)(Object.assign({}, appDataActions, trackingDataActions, userDataActions), dispatch)
	    };
	}
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(VideoScreen);

/***/ },
/* 555 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.DIALOG_LAYOUT_TYPES = exports.LAYOUT_TYPE_RIGHT_LARGE_FLYOUT = exports.LAYOUT_TYPE_RIGHT_SMALL_FLYOUT = exports.LAYOUT_TYPE_LEFT_LARGE_FLYOUT = exports.LAYOUT_TYPE_LEFT_SMALL_FLYOUT = exports.LAYOUT_TYPE_SMALL_DIALOG = exports.LAYOUT_TYPE_LARGE_DIALOG = exports.DIALOG_CLASS_STATE_CLOSED = exports.DIALOG_CLASS_STATE_OPEN = exports.SIDE_DIALOG_CLASSNAME = exports.SCREEN_DIALOG_CLASSNAME = exports.ASSET_DIALOG_CLASSNAME = exports.AUTH_DIALOG_CLASSNAME = exports.DIALOG_CLASSNAME = exports.DIALOG = exports.DIALOG_COMPONENTS = exports.SCREEN_DIALOG = exports.ASSET_DIALOG = exports.INIT_DIALOG = exports.CONTENT_DIALOG = exports.DIALOG_POPUP = undefined;
	
	var _DialogPopup = __webpack_require__(452);
	
	var _DialogPopup2 = _interopRequireDefault(_DialogPopup);
	
	var _ContentDialog = __webpack_require__(451);
	
	var _ContentDialog2 = _interopRequireDefault(_ContentDialog);
	
	var _InitDialog = __webpack_require__(453);
	
	var _InitDialog2 = _interopRequireDefault(_InitDialog);
	
	var _AssetDialog = __webpack_require__(450);
	
	var _AssetDialog2 = _interopRequireDefault(_AssetDialog);
	
	var _ScreenDialog = __webpack_require__(461);
	
	var _ScreenDialog2 = _interopRequireDefault(_ScreenDialog);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	//eslint-disable-line import/no-named-as-default
	
	//eslint-disable-line import/no-named-as-default
	//import ClickRevealDialog from '../components/dialog/ClickRevealDialog';//eslint-disable-line import/no-named-as-default
	//eslint-disable-line import/no-named-as-default
	var DIALOG_POPUP = exports.DIALOG_POPUP = _DialogPopup2.default; //eslint-disable-line import/no-named-as-default
	//eslint-disable-line import/no-named-as-default
	var CONTENT_DIALOG = exports.CONTENT_DIALOG = _ContentDialog2.default;
	var INIT_DIALOG = exports.INIT_DIALOG = _InitDialog2.default;
	var ASSET_DIALOG = exports.ASSET_DIALOG = _AssetDialog2.default;
	var SCREEN_DIALOG = exports.SCREEN_DIALOG = _ScreenDialog2.default;
	//export const CLICK_REVEAL_DIALOG_POPUP = ClickRevealDialog;
	
	var DIALOG_COMPONENTS = exports.DIALOG_COMPONENTS = {
	    DIALOG_POPUP: DIALOG_POPUP,
	    CONTENT_DIALOG: CONTENT_DIALOG,
	    INIT_DIALOG: INIT_DIALOG,
	    ASSET_DIALOG: ASSET_DIALOG,
	    SCREEN_DIALOG: SCREEN_DIALOG
	    //CLICK_REVEAL_DIALOG_POPUP: CLICK_REVEAL_DIALOG_POPUP
	};
	
	var DIALOG = exports.DIALOG = 'DIALOG';
	//export const CLICK_REVEAL_DIALOG = 'CLICK_REVEAL_DIALOG';
	var DIALOG_CLASSNAME = exports.DIALOG_CLASSNAME = 'content-dialog';
	var AUTH_DIALOG_CLASSNAME = exports.AUTH_DIALOG_CLASSNAME = 'auth-dialog';
	var ASSET_DIALOG_CLASSNAME = exports.ASSET_DIALOG_CLASSNAME = 'asset-content-dialog';
	var SCREEN_DIALOG_CLASSNAME = exports.SCREEN_DIALOG_CLASSNAME = 'screen-dialog';
	var SIDE_DIALOG_CLASSNAME = exports.SIDE_DIALOG_CLASSNAME = 'side-dialog';
	//export const CLICK_REVEAL_DIALOG_CLASSNAME = 'click-reveal-dialog';
	
	
	var DIALOG_CLASS_STATE_OPEN = exports.DIALOG_CLASS_STATE_OPEN = 'dialog-open';
	var DIALOG_CLASS_STATE_CLOSED = exports.DIALOG_CLASS_STATE_CLOSED = 'dialog-closed';
	
	var LAYOUT_TYPE_LARGE_DIALOG = exports.LAYOUT_TYPE_LARGE_DIALOG = "large_dialog";
	var LAYOUT_TYPE_SMALL_DIALOG = exports.LAYOUT_TYPE_SMALL_DIALOG = "small_dialog";
	var LAYOUT_TYPE_LEFT_SMALL_FLYOUT = exports.LAYOUT_TYPE_LEFT_SMALL_FLYOUT = "left_small_flyout";
	var LAYOUT_TYPE_LEFT_LARGE_FLYOUT = exports.LAYOUT_TYPE_LEFT_LARGE_FLYOUT = "left_large_flyout";
	var LAYOUT_TYPE_RIGHT_SMALL_FLYOUT = exports.LAYOUT_TYPE_RIGHT_SMALL_FLYOUT = "right_small_flyout";
	var LAYOUT_TYPE_RIGHT_LARGE_FLYOUT = exports.LAYOUT_TYPE_RIGHT_LARGE_FLYOUT = "right_large_flyout";
	
	var DIALOG_LAYOUT_TYPES = exports.DIALOG_LAYOUT_TYPES = [LAYOUT_TYPE_LARGE_DIALOG, LAYOUT_TYPE_SMALL_DIALOG, LAYOUT_TYPE_LEFT_SMALL_FLYOUT, LAYOUT_TYPE_LEFT_LARGE_FLYOUT, LAYOUT_TYPE_RIGHT_SMALL_FLYOUT, LAYOUT_TYPE_RIGHT_LARGE_FLYOUT];

/***/ },
/* 556 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.setSuspendData = setSuspendData;
	
	var _appHelper = __webpack_require__(3);
	
	var appHelper = _interopRequireWildcard(_appHelper);
	
	var _dataHelper = __webpack_require__(11);
	
	var dataHelpers = _interopRequireWildcard(_dataHelper);
	
	var _objectConstants = __webpack_require__(9);
	
	var objectConstants = _interopRequireWildcard(_objectConstants);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function setSuspendData(userData) {
	    return new Promise(function (resolve, reject) {
	        var _suspend_data;
	
	        var suspend_data = (_suspend_data = {
	            lang: userData.lang
	        }, _defineProperty(_suspend_data, appHelper.getShortHandKeyByRef("resources").key, setResourcesSuspendData(userData.resources)), _defineProperty(_suspend_data, appHelper.getShortHandKeyByRef("bites").key, setBiteSuspendData(userData.bites)), _defineProperty(_suspend_data, appHelper.getShortHandKeyByRef("attachments").key, setAttachmentSuspendData(userData.attachments)), _defineProperty(_suspend_data, appHelper.getShortHandKeyByRef("short_response_questions").key, setShortResponseSuspendData(userData.short_response_questions)), _suspend_data);
	        //console.log(JSON.stringify(suspend_data));
	        resolve(suspend_data);
	    });
	}
	
	function setAchievementSuspendData(achievements) {
	    var achievementsSuspendData = [];
	    for (var i = 0; i < achievements.length; i++) {
	        var _Object$assign;
	
	        var achievement = achievements[i];
	        var achievementSuspendDataObj = Object.assign({}, {}, (_Object$assign = {}, _defineProperty(_Object$assign, appHelper.getShortHandKeyByRef("code").key, achievement.code), _defineProperty(_Object$assign, appHelper.getShortHandKeyByRef("achieved").key, achievement.achieved), _defineProperty(_Object$assign, appHelper.getShortHandKeyByRef("achievedOn").key, Object.assign([], achievement.achievedOn)), _Object$assign));
	        achievementsSuspendData = dataHelpers.immutablePush(achievementsSuspendData, achievementSuspendDataObj);
	    }
	    return achievementsSuspendData;
	}
	
	function setShortResponseSuspendData(short_response_questions) {
	
	    var shortResponseQuestionArray = [];
	    for (var i = 0; i < short_response_questions.length; i++) {
	        var _suspendDataResponseQ;
	
	        var responseQuestion = Object.assign({}, short_response_questions[i]);
	        var suspendDataResponseQuestion = (_suspendDataResponseQ = {}, _defineProperty(_suspendDataResponseQ, appHelper.getShortHandKeyByRef("id").key, responseQuestion.id), _defineProperty(_suspendDataResponseQ, appHelper.getShortHandKeyByRef("response").key, responseQuestion.response), _suspendDataResponseQ);
	        if (responseQuestion.response.length > 0) {
	            shortResponseQuestionArray = dataHelpers.immutablePush(shortResponseQuestionArray, suspendDataResponseQuestion);
	        }
	    }
	
	    return shortResponseQuestionArray;
	}
	
	function setAttachmentSuspendData(attachments) {
	
	    var attachmentsArray = [];
	    for (var i = 0; i < attachments.length; i++) {
	        var _suspendDataAttachmen;
	
	        var attachment = Object.assign({}, attachments[i]);
	        var suspendDataAttachments = (_suspendDataAttachmen = {}, _defineProperty(_suspendDataAttachmen, appHelper.getShortHandKeyByRef("id").key, attachment.id), _defineProperty(_suspendDataAttachmen, appHelper.getShortHandKeyByRef("type").key, appHelper.getShortHandKeyByRef(attachment.type).key), _defineProperty(_suspendDataAttachmen, appHelper.getShortHandKeyByRef("sub_type").key, appHelper.isDefined(attachment.sub_type) ? appHelper.getShortHandKeyByRef(attachment.sub_type).key : ""), _defineProperty(_suspendDataAttachmen, appHelper.getShortHandKeyByRef("status").key, appHelper.getShortHandKeyByRef(attachment.status).key), _suspendDataAttachmen);
	        attachmentsArray = dataHelpers.immutablePush(attachmentsArray, suspendDataAttachments);
	    }
	
	    return attachmentsArray;
	}
	
	function setResourcesSuspendData(resources) {
	    var resourcesScreenArray = [];
	
	    for (var i = 0; i < resources.length; i++) {
	        var resourcesScreen = resources[i];
	        resourcesScreenArray = dataHelpers.immutablePush(resourcesScreenArray, setResourcesScreenResults(resourcesScreen));
	    }
	    return resourcesScreenArray;
	}
	
	function setResourcesScreenResults(resourcesScreen) {
	    var _ref;
	
	    return _ref = {}, _defineProperty(_ref, appHelper.getShortHandKeyByRef("screen_id").key, resourcesScreen.screen_id), _defineProperty(_ref, appHelper.getShortHandKeyByRef("status").key, appHelper.getShortHandKeyByRef(resourcesScreen.status).key), _defineProperty(_ref, appHelper.getShortHandKeyByRef("objects").key, setResourceObjects(resourcesScreen.objects)), _ref;
	}
	
	function setResourceObjects(resourceObjects) {
	    var resourceObjectArray = [];
	    for (var i = 0; i < resourceObjects.length; i++) {
	        var resourceObject = resourceObjects[i];
	        if (resourceObject.status === objectConstants.STATUS_COMPLETE) {
	            resourceObjectArray = dataHelpers.immutablePush(resourceObjectArray, setResourceObjectsResults(resourceObject));
	        }
	    }
	    return resourceObjectArray;
	}
	
	function setResourceObjectsResults(resourceObject) {
	    var _ref2;
	
	    return _ref2 = {}, _defineProperty(_ref2, appHelper.getShortHandKeyByRef("asset_id").key, resourceObject.asset_id), _defineProperty(_ref2, appHelper.getShortHandKeyByRef("status").key, appHelper.getShortHandKeyByRef(resourceObject.status).key), _ref2;
	}
	
	function setBiteSuspendData(bites) {
	    var biteArray = [];
	    for (var i = 0; i < bites.length; i++) {
	        var bite = bites[i];
	        biteArray = dataHelpers.immutablePush(biteArray, setBiteResult(bite));
	    }
	    return biteArray;
	}
	
	function setBiteResult(bite) {
	    var _ref3;
	
	    return _ref3 = {}, _defineProperty(_ref3, appHelper.getShortHandKeyByRef("bite_id").key, bite.bite_id), _defineProperty(_ref3, appHelper.getShortHandKeyByRef("screens").key, setBiteScreens(bite.screens)), _defineProperty(_ref3, appHelper.getShortHandKeyByRef("kpis").key, setBiteKpis(bite.kpis)), _defineProperty(_ref3, appHelper.getShortHandKeyByRef("badges").key, setBadgeSuspendData(bite.badges)), _defineProperty(_ref3, appHelper.getShortHandKeyByRef("status").key, appHelper.getShortHandKeyByRef(bite.status).key), _defineProperty(_ref3, appHelper.getShortHandKeyByRef("required").key, appHelper.getShortHandKeyByRef(bite.required).key), _defineProperty(_ref3, appHelper.getShortHandKeyByRef("complete_target_screens").key, setCompleteTargetScreens(bite.complete_target_screens)), _defineProperty(_ref3, appHelper.getShortHandKeyByRef("terminated").key, appHelper.getShortHandKeyByRef(bite.terminated).key), _ref3;
	}
	
	function setCompleteTargetScreens(complete_target_screens) {
	    var completeTargetScreensSuspendData = [];
	    for (var i = 0; i < complete_target_screens.length; i++) {
	
	        var target_screen = complete_target_screens[i];
	        var targetScreenSuspendData = _defineProperty({}, appHelper.getShortHandKeyByRef("screen_id").key, target_screen.screen_id);
	
	        completeTargetScreensSuspendData = dataHelpers.immutablePush(completeTargetScreensSuspendData, targetScreenSuspendData);
	    }
	
	    return completeTargetScreensSuspendData;
	}
	
	function setBadgeSuspendData(badges) {
	    var badgeSuspendData = [];
	    for (var i = 0; i < badges.length; i++) {
	        var _badgeSuspendDataObj;
	
	        var badge = badges[i];
	        var badgeSuspendDataObj = (_badgeSuspendDataObj = {}, _defineProperty(_badgeSuspendDataObj, appHelper.getShortHandKeyByRef("badge_id").key, badge.badge_id), _defineProperty(_badgeSuspendDataObj, appHelper.getShortHandKeyByRef("achieved").key, badge.achieved), _defineProperty(_badgeSuspendDataObj, appHelper.getShortHandKeyByRef("achievedOn").key, Object.assign([], badge.achievedOn)), _badgeSuspendDataObj);
	        badgeSuspendData = dataHelpers.immutablePush(badgeSuspendData, badgeSuspendDataObj);
	    }
	    return badgeSuspendData;
	}
	
	function setBiteKpis(kpis) {
	    var kpisArray = [];
	    for (var i = 0; i < kpis.length; i++) {
	        var kpi = kpis[i];
	        kpisArray = dataHelpers.immutablePush(kpisArray, setKpiResult(kpi));
	    }
	
	    return kpisArray;
	}
	
	function setKpiResult(kpi) {
	    var _ref4;
	
	    return _ref4 = {}, _defineProperty(_ref4, appHelper.getShortHandKeyByRef("kpi_id").key, kpi.kpi_id), _defineProperty(_ref4, appHelper.getShortHandKeyByRef("current").key, kpi.current), _defineProperty(_ref4, appHelper.getShortHandKeyByRef("history").key, setKpiHistory(kpi.history)), _ref4;
	}
	
	function setKpiHistory(history) {
	    var historyArray = [];
	    for (var i = 0; i < history.length; i++) {
	        var kpi = history[i];
	        historyArray = dataHelpers.immutablePush(historyArray, setHistoryResult(kpi));
	    }
	
	    return historyArray;
	}
	
	function setHistoryResult(kpi) {
	    var _ref5;
	
	    return _ref5 = {}, _defineProperty(_ref5, appHelper.getShortHandKeyByRef("hasValue").key, kpi.hasValue ? 1 : 0), _defineProperty(_ref5, appHelper.getShortHandKeyByRef("value").key, kpi.value), _defineProperty(_ref5, appHelper.getShortHandKeyByRef("asset_id").key, kpi.asset_id), _defineProperty(_ref5, appHelper.getShortHandKeyByRef("option_id").key, kpi.option_id), _defineProperty(_ref5, appHelper.getShortHandKeyByRef("current").key, kpi.current), _defineProperty(_ref5, appHelper.getShortHandKeyByRef("statusIndicatorClass").key, _defineProperty({}, appHelper.getShortHandKeyByRef("value").key, kpi.statusIndicatorClass.value)), _ref5;
	}
	
	function setBiteScreens(screens) {
	    var screensArray = [];
	    for (var i = 0; i < screens.length; i++) {
	        var screen = screens[i];
	        screensArray = dataHelpers.immutablePush(screensArray, setScreenResult(screen));
	    }
	
	    return screensArray;
	}
	
	function setScreenResult(screen) {
	    //ONLY SHOW COMPLETE OBJECTS IF THE SCREEN IN PROGRESS SCREEN
	    if (appHelper.isDefined(screen.objects) && screen.objects.length > 0) {
	        var objectData = setScreensObjects(screen.objects, appHelper.getShortHandKeyByRef(screen.status).ref);
	        //console.log(`screen`);
	        //console.log(screen);
	        //console.log(`objectData`);
	        //console.log(objectData);
	        if (objectData.length > 0) {
	            var _ref6;
	
	            return _ref6 = {}, _defineProperty(_ref6, appHelper.getShortHandKeyByRef("screen_id").key, screen.screen_id), _defineProperty(_ref6, appHelper.getShortHandKeyByRef("status").key, appHelper.getShortHandKeyByRef(screen.status).key), _defineProperty(_ref6, appHelper.getShortHandKeyByRef("objects").key, objectData), _defineProperty(_ref6, appHelper.getShortHandKeyByRef("required").key, appHelper.getShortHandKeyByRef(screen.required).key), _ref6;
	        } else {
	            var _ref7;
	
	            return _ref7 = {}, _defineProperty(_ref7, appHelper.getShortHandKeyByRef("screen_id").key, screen.screen_id), _defineProperty(_ref7, appHelper.getShortHandKeyByRef("status").key, appHelper.getShortHandKeyByRef(screen.status).key), _defineProperty(_ref7, appHelper.getShortHandKeyByRef("required").key, appHelper.getShortHandKeyByRef(screen.required).key), _ref7;
	        }
	    } else if (appHelper.isDefined(screen.sub_screens) && screen.sub_screens.length > 0) {
	        var _ref8;
	
	        return _ref8 = {}, _defineProperty(_ref8, appHelper.getShortHandKeyByRef("screen_id").key, screen.screen_id), _defineProperty(_ref8, appHelper.getShortHandKeyByRef("status").key, appHelper.getShortHandKeyByRef(screen.status).key), _defineProperty(_ref8, appHelper.getShortHandKeyByRef("required").key, appHelper.getShortHandKeyByRef(screen.required).key), _defineProperty(_ref8, appHelper.getShortHandKeyByRef("sub_screens").key, setBiteScreens(screen.sub_screens)), _ref8;
	    } else {
	        var _ref9;
	
	        return _ref9 = {}, _defineProperty(_ref9, appHelper.getShortHandKeyByRef("screen_id").key, screen.screen_id), _defineProperty(_ref9, appHelper.getShortHandKeyByRef("status").key, appHelper.getShortHandKeyByRef(screen.status).key), _defineProperty(_ref9, appHelper.getShortHandKeyByRef("required").key, appHelper.getShortHandKeyByRef(screen.required).key), _ref9;
	    }
	}
	
	function setScreensObjects(objects, screen_status) {
	
	    var objectArray = [];
	    for (var i = 0; i < objects.length; i++) {
	        var object = objects[i];
	
	        if (screen_status !== objectConstants.STATUS_COMPLETE && screen_status !== objectConstants.STATUS_NOT_STARTED || appHelper.isDefined(object.options)) {
	            if (appHelper.isDefined(object) && object.status === objectConstants.STATUS_COMPLETE) {
	                //objectArray = dataHelpers.immutablePush(objectArray, object.object_id);
	                objectArray = dataHelpers.immutablePush(objectArray, setObjectResult(object));
	            }
	        }
	    }
	    return objectArray;
	}
	
	function setObjectResult(object) {
	    //console.log(`typeof object.options === ${typeof object.options} && typeof object.result === ${typeof object.result}`);
	    if (appHelper.isDefined(object.options)) {
	        var _ref10;
	
	        return _ref10 = {}, _defineProperty(_ref10, appHelper.getShortHandKeyByRef("asset_id").key, object.asset_id), _defineProperty(_ref10, appHelper.getShortHandKeyByRef("status").key, appHelper.getShortHandKeyByRef(object.status).key), _defineProperty(_ref10, appHelper.getShortHandKeyByRef("options").key, object.options), _ref10;
	    } else {
	        var _ref11;
	
	        return _ref11 = {}, _defineProperty(_ref11, appHelper.getShortHandKeyByRef("asset_id").key, object.asset_id), _defineProperty(_ref11, appHelper.getShortHandKeyByRef("status").key, appHelper.getShortHandKeyByRef(object.status).key), _ref11;
	    }
	    //return null;
	}

/***/ },
/* 557 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	var environment = exports.environment = {
	    window: {
	        size: "",
	        width: 0,
	        height: 0,
	        orientation: ""
	    },
	    browser: {
	        name: "",
	        version: 0
	    },
	    os: {
	        name: "",
	        version: 0
	    },
	    userAgent: window.navigator.userAgent,
	    device: window.navigator.platform,
	    isDevice: false
	};
	
	var os = exports.os = [{ name: 'Windows Phone', value: 'Windows Phone', version: 'OS' }, { name: 'Windows', value: 'Win', version: 'NT' }, { name: 'iPhone', value: 'iPhone', version: 'OS' }, { name: 'iPad', value: 'iPad', version: 'OS' }, { name: 'Kindle', value: 'Silk', version: 'Silk' }, { name: 'Android', value: 'Android', version: 'Android' }, { name: 'PlayBook', value: 'PlayBook', version: 'OS' }, { name: 'BlackBerry', value: 'BlackBerry', version: '/' }, { name: 'Macintosh', value: 'Mac', version: 'OS X' }, { name: 'Linux', value: 'Linux', version: 'rv' }, { name: 'Palm', value: 'Palm', version: 'PalmOS' }];
	
	var browser = exports.browser = [{ name: 'Chrome', value: 'Chrome', version: 'Chrome' }, { name: 'Firefox', value: 'Firefox', version: 'Firefox' }, { name: 'Safari', value: 'Safari', version: 'Version' }, { name: 'Internet Explorer', value: 'MSIE', version: 'MSIE' }, { name: 'Internet Explorer', value: 'Trident/', version: 'Trident/' }, { name: 'Opera', value: 'Opera', version: 'Opera' }, { name: 'Mozilla', value: 'Mozilla', version: 'Mozilla' }, { name: 'BlackBerry', value: 'CLDC', version: 'CLDC' }];
	
	var header = exports.header = [window.navigator.platform, window.navigator.userAgent, window.navigator.appVersion, window.navigator.vendor, window.opera];

/***/ },
/* 558 */
/***/ function(module, exports) {

	"use strict";

/***/ },
/* 559 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.TOP_ASSET_IMAGE_SIZES = exports.ASSET_IMAGE_SIZES = exports.SPECIIFIC_IMAGE_SIZES = undefined;
	
	var _objectConstants = __webpack_require__(9);
	
	var objectConstants = _interopRequireWildcard(_objectConstants);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	var SPECIIFIC_IMAGE_SIZES = exports.SPECIIFIC_IMAGE_SIZES = [{
	    constant: objectConstants.IMAGE_WIDTH_5,
	    value: 5
	}, {
	    constant: objectConstants.IMAGE_WIDTH_10,
	    value: 10
	}, {
	    constant: objectConstants.IMAGE_WIDTH_15,
	    value: 15
	}, {
	    constant: objectConstants.IMAGE_WIDTH_20,
	    value: 20
	}, {
	    constant: objectConstants.IMAGE_WIDTH_25,
	    value: 25
	}, {
	    constant: objectConstants.IMAGE_WIDTH_30,
	    value: 30
	}, {
	    constant: objectConstants.IMAGE_WIDTH_35,
	    value: 35
	}, {
	    constant: objectConstants.IMAGE_WIDTH_40,
	    value: 40
	}];
	
	var ASSET_IMAGE_SIZES = exports.ASSET_IMAGE_SIZES = [{
	    constant: objectConstants.ASSET_IMAGE_WIDTH_10,
	    value: 10
	}, {
	    constant: objectConstants.ASSET_IMAGE_WIDTH_15,
	    value: 15
	}, {
	    constant: objectConstants.ASSET_IMAGE_WIDTH_20,
	    value: 20
	}, {
	    constant: objectConstants.ASSET_IMAGE_WIDTH_25,
	    value: 25
	}, {
	    constant: objectConstants.ASSET_IMAGE_WIDTH_30,
	    value: 30
	}, {
	    constant: objectConstants.ASSET_IMAGE_WIDTH_35,
	    value: 35
	}, {
	    constant: objectConstants.ASSET_IMAGE_WIDTH_40,
	    value: 40
	}];
	
	var TOP_ASSET_IMAGE_SIZES = exports.TOP_ASSET_IMAGE_SIZES = [{
	    constant: objectConstants.TOP_ASSET_IMAGE_WIDTH_10,
	    value: 10
	}, {
	    constant: objectConstants.TOP_ASSET_IMAGE_WIDTH_20,
	    value: 20
	}, {
	    constant: objectConstants.TOP_ASSET_IMAGE_WIDTH_30,
	    value: 30
	}, {
	    constant: objectConstants.TOP_ASSET_IMAGE_WIDTH_40,
	    value: 40
	}, {
	    constant: objectConstants.TOP_ASSET_IMAGE_WIDTH_50,
	    value: 50
	}, {
	    constant: objectConstants.TOP_ASSET_IMAGE_WIDTH_60,
	    value: 60
	}, {
	    constant: objectConstants.TOP_ASSET_IMAGE_WIDTH_70,
	    value: 70
	}, {
	    constant: objectConstants.TOP_ASSET_IMAGE_WIDTH_80,
	    value: 80
	}, {
	    constant: objectConstants.TOP_ASSET_IMAGE_WIDTH_90,
	    value: 90
	}, {
	    constant: objectConstants.TOP_ASSET_IMAGE_WIDTH_100,
	    value: 100
	}];

/***/ },
/* 560 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	var ACTOR = exports.ACTOR = {
	    mbox: "",
	    name: "",
	    objectType: "Agent"
	};
	
	//VERBS
	var ANSWERED = exports.ANSWERED = {
	    id: "http://adlnet.gov/expapi/verbs/answered",
	    display: {
	        "en-US": "answered"
	    }
	};
	
	var RESULT = exports.RESULT = {
	    score: {
	        scaled: 0,
	        min: 0,
	        max: 0,
	        raw: 0
	    },
	    success: true,
	    completion: true,
	    //duration: "",
	    response: ""
	};
	
	var BEST_SCORE = exports.BEST_SCORE = {
	    scaled: 1,
	    min: 0,
	    max: 100,
	    raw: 100
	};
	
	var OK_SCORE = exports.OK_SCORE = {
	    scaled: 0.5,
	    min: 0,
	    max: 100,
	    raw: 50
	};
	
	var POOR_SCORE = exports.POOR_SCORE = {
	    scaled: 0,
	    min: 0,
	    max: 100,
	    raw: 0
	};
	
	var DEFINITION = exports.DEFINITION = {
	
	    name: {
	        "en-US": ""
	    },
	    description: {
	        "en-US": ""
	    },
	    type: 'http://adlnet.gov/expapi/activities/cmi.interaction',
	    correctResponsesPattern: []
	
	};
	
	var ID_DESCRIPTION = exports.ID_DESCRIPTION = {
	    id: {
	        "en-US": ""
	    },
	    description: {
	        "en-US": ""
	    }
	};
	
	var CHOICE_OBJECT = exports.CHOICE_OBJECT = {
	    id: "",
	    objectType: "Activity",
	    definition: Object.assign({}, DEFINITION, {
	        interactionType: "choice",
	        choices: []
	    })
	};
	
	var FILL_IN_OBJECT = exports.FILL_IN_OBJECT = {
	    id: "",
	    objectType: "Activity",
	    definition: Object.assign({}, DEFINITION, {
	        interactionType: "fill-in"
	    })
	};
	
	//INTERACTION TYPE
	//https://experienceapi.com/scorm-to-experience-api-xapi-cookbook/
	
	
	var CHOICE = exports.CHOICE = {
	    actor: ACTOR,
	    verb: ANSWERED,
	    result: RESULT,
	    object: CHOICE_OBJECT
	};
	
	var FILL_IN = exports.FILL_IN = {
	    actor: ACTOR,
	    verb: ANSWERED,
	    result: RESULT,
	    object: FILL_IN_OBJECT
	};

/***/ },
/* 561 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = ajaxStatusReducer;
	
	var _actionTypes = __webpack_require__(22);
	
	var types = _interopRequireWildcard(_actionTypes);
	
	var _initialState = __webpack_require__(42);
	
	var _initialState2 = _interopRequireDefault(_initialState);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function actionTypeEndsInSuccess(type) {
	  return type.substring(type.length - 8) == '_SUCCESS';
	}
	
	function ajaxStatusReducer() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _initialState2.default.ajaxCallsInProgress;
	  var action = arguments[1];
	
	  if (action.type == types.BEGIN_AJAX_CALL) {
	    return state + 1;
	  } else if (action.type == types.AJAX_CALL_ERROR || actionTypeEndsInSuccess(action.type)) {
	    return state - 1;
	  }
	
	  return state;
	}

/***/ },
/* 562 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = assetDialogReducer;
	
	var _actionTypes = __webpack_require__(22);
	
	var types = _interopRequireWildcard(_actionTypes);
	
	var _initialState = __webpack_require__(42);
	
	var _initialState2 = _interopRequireDefault(_initialState);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function assetDialogReducer() {
	    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _initialState2.default.assetDialog;
	    var action = arguments[1];
	
	    switch (action.type) {
	        case types.SET_ASSET_DIALOG:
	            //debugger;
	            //use immutable state with es6's spread operator (...) on existing state and Object.assign to make a deep copy of existing object to create a brand new stateconsole.log('UPDATE_PROJECT_SUCCESS')
	            return Object.assign({}, action.assetDialog);
	
	        default:
	            return state;
	    }
	}

/***/ },
/* 563 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = audioReducer;
	
	var _actionTypes = __webpack_require__(22);
	
	var types = _interopRequireWildcard(_actionTypes);
	
	var _initialState = __webpack_require__(42);
	
	var _initialState2 = _interopRequireDefault(_initialState);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function audioReducer() {
	    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _initialState2.default.audio;
	    var action = arguments[1];
	
	    switch (action.type) {
	        case types.SET_AUDIO_REF:
	            //debugger;
	            //use immutable state with es6's spread operator (...) on existing state and Object.assign to make a deep copy of existing object to create a brand new stateconsole.log('UPDATE_PROJECT_SUCCESS')
	            return Object.assign({}, action.audio);
	
	        default:
	            return state;
	    }
	}

/***/ },
/* 564 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = clickRevealDialogReducer;
	
	var _actionTypes = __webpack_require__(22);
	
	var types = _interopRequireWildcard(_actionTypes);
	
	var _initialState = __webpack_require__(42);
	
	var _initialState2 = _interopRequireDefault(_initialState);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function clickRevealDialogReducer() {
	    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _initialState2.default.clickRevealDialog;
	    var action = arguments[1];
	
	    switch (action.type) {
	        case types.SET_CLICK_REVEAL_DIALOG:
	            //debugger;
	            //use immutable state with es6's spread operator (...) on existing state and Object.assign to make a deep copy of existing object to create a brand new stateconsole.log('UPDATE_PROJECT_SUCCESS')
	            return Object.assign({}, action.clickRevealDialog);
	
	        default:
	            return state;
	    }
	}

/***/ },
/* 565 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = contentDataReducer;
	
	var _actionTypes = __webpack_require__(22);
	
	var types = _interopRequireWildcard(_actionTypes);
	
	var _initialState = __webpack_require__(42);
	
	var _initialState2 = _interopRequireDefault(_initialState);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function contentDataReducer() {
	    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _initialState2.default.contentData;
	    var action = arguments[1];
	
	    switch (action.type) {
	        case types.SET_CONTENT_DATA:
	            //debugger;
	            //use immutable state with es6's spread operator (...) on existing state and Object.assign to make a deep copy of existing object to create a brand new stateconsole.log('UPDATE_PROJECT_SUCCESS')
	            return Object.assign({}, action.contentData);
	
	        default:
	            return state;
	    }
	}

/***/ },
/* 566 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = contentToolTipReducer;
	
	var _actionTypes = __webpack_require__(22);
	
	var types = _interopRequireWildcard(_actionTypes);
	
	var _initialState = __webpack_require__(42);
	
	var _initialState2 = _interopRequireDefault(_initialState);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function contentToolTipReducer() {
	    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _initialState2.default.contentToolTip;
	    var action = arguments[1];
	
	    switch (action.type) {
	        case types.SET_CONTENT_TOOLTIP:
	            //debugger;
	            //use immutable state with es6's spread operator (...) on existing state and Object.assign to make a deep copy of existing object to create a brand new stateconsole.log('UPDATE_PROJECT_SUCCESS')
	            return Object.assign({}, action.contentToolTip);
	
	        default:
	            return state;
	    }
	}

/***/ },
/* 567 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = dialogReducer;
	
	var _actionTypes = __webpack_require__(22);
	
	var types = _interopRequireWildcard(_actionTypes);
	
	var _initialState = __webpack_require__(42);
	
	var _initialState2 = _interopRequireDefault(_initialState);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function dialogReducer() {
	    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _initialState2.default.dialogPopup;
	    var action = arguments[1];
	
	    switch (action.type) {
	        case types.SET_DIALOG_POPUP:
	            //debugger;
	            //use immutable state with es6's spread operator (...) on existing state and Object.assign to make a deep copy of existing object to create a brand new stateconsole.log('UPDATE_PROJECT_SUCCESS')
	            return Object.assign({}, action.dialogPopup);
	
	        default:
	            return state;
	    }
	}

/***/ },
/* 568 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = fontSizeReducer;
	
	var _actionTypes = __webpack_require__(22);
	
	var types = _interopRequireWildcard(_actionTypes);
	
	var _initialState = __webpack_require__(42);
	
	var _initialState2 = _interopRequireDefault(_initialState);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function fontSizeReducer() {
	    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _initialState2.default.fontSize;
	    var action = arguments[1];
	
	    switch (action.type) {
	        case types.SET_FONT_SIZE:
	            //debugger;
	            //use immutable state with es6's spread operator (...) on existing state and Object.assign to make a deep copy of existing object to create a brand new stateconsole.log('UPDATE_PROJECT_SUCCESS')
	            return Object.assign({}, action.fontSize);
	
	        default:
	            return state;
	    }
	}

/***/ },
/* 569 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
				value: true
	});
	
	var _redux = __webpack_require__(4);
	
	var _initReducer = __webpack_require__(570);
	
	var _initReducer2 = _interopRequireDefault(_initReducer);
	
	var _contentDataReducer = __webpack_require__(565);
	
	var _contentDataReducer2 = _interopRequireDefault(_contentDataReducer);
	
	var _trackingDataReducer = __webpack_require__(578);
	
	var _trackingDataReducer2 = _interopRequireDefault(_trackingDataReducer);
	
	var _userDataReducer = __webpack_require__(579);
	
	var _userDataReducer2 = _interopRequireDefault(_userDataReducer);
	
	var _titleReducer = __webpack_require__(577);
	
	var _titleReducer2 = _interopRequireDefault(_titleReducer);
	
	var _navigationReducer = __webpack_require__(572);
	
	var _navigationReducer2 = _interopRequireDefault(_navigationReducer);
	
	var _dialogReducer = __webpack_require__(567);
	
	var _dialogReducer2 = _interopRequireDefault(_dialogReducer);
	
	var _mainMenuReducer = __webpack_require__(571);
	
	var _mainMenuReducer2 = _interopRequireDefault(_mainMenuReducer);
	
	var _resourcesReducer = __webpack_require__(575);
	
	var _resourcesReducer2 = _interopRequireDefault(_resourcesReducer);
	
	var _notesReducer = __webpack_require__(573);
	
	var _notesReducer2 = _interopRequireDefault(_notesReducer);
	
	var _resourcesPropsReducer = __webpack_require__(574);
	
	var _resourcesPropsReducer2 = _interopRequireDefault(_resourcesPropsReducer);
	
	var _contentToolTipReducer = __webpack_require__(566);
	
	var _contentToolTipReducer2 = _interopRequireDefault(_contentToolTipReducer);
	
	var _clickRevealDialogReducer = __webpack_require__(564);
	
	var _clickRevealDialogReducer2 = _interopRequireDefault(_clickRevealDialogReducer);
	
	var _assetDialogReducer = __webpack_require__(562);
	
	var _assetDialogReducer2 = _interopRequireDefault(_assetDialogReducer);
	
	var _audioReducer = __webpack_require__(563);
	
	var _audioReducer2 = _interopRequireDefault(_audioReducer);
	
	var _fontSizeReducer = __webpack_require__(568);
	
	var _fontSizeReducer2 = _interopRequireDefault(_fontSizeReducer);
	
	var _screenDialogReducer = __webpack_require__(576);
	
	var _screenDialogReducer2 = _interopRequireDefault(_screenDialogReducer);
	
	var _ajaxStatusReducer = __webpack_require__(561);
	
	var _ajaxStatusReducer2 = _interopRequireDefault(_ajaxStatusReducer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var rootReducer = (0, _redux.combineReducers)({
				//es6 short hand property name
				initData: _initReducer2.default,
				contentData: _contentDataReducer2.default,
				trackingData: _trackingDataReducer2.default,
				userData: _userDataReducer2.default,
				dialogPopup: _dialogReducer2.default,
				titles: _titleReducer2.default,
				navigation: _navigationReducer2.default,
				ajaxCallsInProgress: _ajaxStatusReducer2.default,
				displayMainMenu: _mainMenuReducer2.default,
				displayResources: _resourcesReducer2.default,
				displayNotes: _notesReducer2.default,
				resourceProps: _resourcesPropsReducer2.default,
				contentToolTip: _contentToolTipReducer2.default,
				clickRevealDialog: _clickRevealDialogReducer2.default,
				assetDialog: _assetDialogReducer2.default,
				screenDialog: _screenDialogReducer2.default,
				audio: _audioReducer2.default,
				fontSize: _fontSizeReducer2.default
	});
	
	exports.default = rootReducer;

/***/ },
/* 570 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = initReducer;
	
	var _actionTypes = __webpack_require__(22);
	
	var types = _interopRequireWildcard(_actionTypes);
	
	var _initialState = __webpack_require__(42);
	
	var _initialState2 = _interopRequireDefault(_initialState);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function initReducer() {
	    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _initialState2.default.initData;
	    var action = arguments[1];
	
	    switch (action.type) {
	        case types.INITIALISE:
	            //debugger;
	            //use immutable state with es6's spread operator (...) on existing state and Object.assign to make a deep copy of existing object to create a brand new stateconsole.log('UPDATE_PROJECT_SUCCESS')
	
	            return Object.assign({}, action.initData);
	
	        default:
	            return state;
	    }
	}

/***/ },
/* 571 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = mainMenuReducer;
	
	var _actionTypes = __webpack_require__(22);
	
	var types = _interopRequireWildcard(_actionTypes);
	
	var _initialState = __webpack_require__(42);
	
	var _initialState2 = _interopRequireDefault(_initialState);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function mainMenuReducer() {
	    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _initialState2.default.displayMainMenu;
	    var action = arguments[1];
	
	    switch (action.type) {
	
	        case types.SET_MAIN_MENU_DISPLAY:
	
	            //debugger;
	            //use immutable state with es6's spread operator (...) on existing state and Object.assign to make a deep copy of existing object to create a brand new state
	            return action.displayMainMenu;
	        default:
	            return state;
	    }
	}

/***/ },
/* 572 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = navigationReducer;
	
	var _actionTypes = __webpack_require__(22);
	
	var types = _interopRequireWildcard(_actionTypes);
	
	var _initialState = __webpack_require__(42);
	
	var _initialState2 = _interopRequireDefault(_initialState);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function navigationReducer() {
	    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _initialState2.default.navigation;
	    var action = arguments[1];
	
	    switch (action.type) {
	
	        case types.SET_NAVIGATION:
	            //debugger;
	            //use immutable state with es6's spread operator (...) on existing state and Object.assign to make a deep copy of existing object to create a brand new state
	            return Object.assign({}, action.navigation);
	        default:
	            return state;
	    }
	}

/***/ },
/* 573 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = notesReducer;
	
	var _actionTypes = __webpack_require__(22);
	
	var types = _interopRequireWildcard(_actionTypes);
	
	var _initialState = __webpack_require__(42);
	
	var _initialState2 = _interopRequireDefault(_initialState);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function notesReducer() {
	    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _initialState2.default.displayNotes;
	    var action = arguments[1];
	
	    switch (action.type) {
	
	        case types.SET_NOTES_DISPLAY:
	
	            //debugger;
	            //use immutable state with es6's spread operator (...) on existing state and Object.assign to make a deep copy of existing object to create a brand new state
	            return action.displayNotes;
	        default:
	            return state;
	    }
	}

/***/ },
/* 574 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = resourcePropsReducer;
	
	var _actionTypes = __webpack_require__(22);
	
	var types = _interopRequireWildcard(_actionTypes);
	
	var _initialState = __webpack_require__(42);
	
	var _initialState2 = _interopRequireDefault(_initialState);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function resourcePropsReducer() {
	    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _initialState2.default.resourceProps;
	    var action = arguments[1];
	
	    switch (action.type) {
	
	        case types.SET_RESOURCES_PROPS:
	
	            //debugger;
	            //use immutable state with es6's spread operator (...) on existing state and Object.assign to make a deep copy of existing object to create a brand new state
	            return Object.assign({}, action.resourceProps);
	        default:
	            return state;
	    }
	}

/***/ },
/* 575 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = resourcesReducer;
	
	var _actionTypes = __webpack_require__(22);
	
	var types = _interopRequireWildcard(_actionTypes);
	
	var _initialState = __webpack_require__(42);
	
	var _initialState2 = _interopRequireDefault(_initialState);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function resourcesReducer() {
	    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _initialState2.default.displayResources;
	    var action = arguments[1];
	
	    switch (action.type) {
	
	        case types.SET_RESOURCES_DISPLAY:
	
	            //debugger;
	            //use immutable state with es6's spread operator (...) on existing state and Object.assign to make a deep copy of existing object to create a brand new state
	            return action.displayResources;
	        default:
	            return state;
	    }
	}

/***/ },
/* 576 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = assetDialogReducer;
	
	var _actionTypes = __webpack_require__(22);
	
	var types = _interopRequireWildcard(_actionTypes);
	
	var _initialState = __webpack_require__(42);
	
	var _initialState2 = _interopRequireDefault(_initialState);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function assetDialogReducer() {
	    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _initialState2.default.screenDialog;
	    var action = arguments[1];
	
	    switch (action.type) {
	        case types.SET_SCREEN_DIALOG:
	            //debugger;
	            //use immutable state with es6's spread operator (...) on existing state and Object.assign to make a deep copy of existing object to create a brand new stateconsole.log('UPDATE_PROJECT_SUCCESS')
	            return Object.assign({}, action.screenDialog);
	
	        default:
	            return state;
	    }
	}

/***/ },
/* 577 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = titleReducer;
	
	var _actionTypes = __webpack_require__(22);
	
	var types = _interopRequireWildcard(_actionTypes);
	
	var _initialState = __webpack_require__(42);
	
	var _initialState2 = _interopRequireDefault(_initialState);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function titleReducer() {
	    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _initialState2.default.titles;
	    var action = arguments[1];
	
	    switch (action.type) {
	
	        case types.SET_PROJECT_TITLE:
	            return Object.assign({}, state, {
	                projectTitle: action.projectTitle
	            });
	        case types.SET_BITE_TITLE:
	            return Object.assign({}, state, {
	                biteTitle: action.biteTitle
	            });
	        case types.SET_SCREEN_TITLE:
	            return Object.assign({}, state, {
	                screenTitle: action.screenTitle
	            });
	        default:
	            return state;
	    }
	}

/***/ },
/* 578 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = trackingDataReducer;
	
	var _actionTypes = __webpack_require__(22);
	
	var types = _interopRequireWildcard(_actionTypes);
	
	var _initialState = __webpack_require__(42);
	
	var _initialState2 = _interopRequireDefault(_initialState);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function trackingDataReducer() {
	    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _initialState2.default.trackingData;
	    var action = arguments[1];
	
	    switch (action.type) {
	        case types.SET_TRACKING_DATA:
	            //debugger;
	            //use immutable state with es6's spread operator (...) on existing state and Object.assign to make a deep copy of existing object to create a brand new state
	            return Object.assign({}, action.trackingData);
	
	        default:
	            return state;
	    }
	}

/***/ },
/* 579 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = userDataReducer;
	
	var _actionTypes = __webpack_require__(22);
	
	var types = _interopRequireWildcard(_actionTypes);
	
	var _initialState = __webpack_require__(42);
	
	var _initialState2 = _interopRequireDefault(_initialState);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function userDataReducer() {
	    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _initialState2.default.userData;
	    var action = arguments[1];
	
	    switch (action.type) {
	        case types.SET_USER_DATA:
	            //debugger;
	            //use immutable state with es6's spread operator (...) on existing state and Object.assign to make a deep copy of existing object to create a brand new state
	            return Object.assign({}, action.userData);
	
	        default:
	            return state;
	    }
	}

/***/ },
/* 580 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(45);
	
	var _App = __webpack_require__(439);
	
	var _App2 = _interopRequireDefault(_App);
	
	var _Initialisation = __webpack_require__(465);
	
	var _Initialisation2 = _interopRequireDefault(_Initialisation);
	
	var _AppBite = __webpack_require__(440);
	
	var _AppBite2 = _interopRequireDefault(_AppBite);
	
	var _AppBiteMenu = __webpack_require__(441);
	
	var _AppBiteMenu2 = _interopRequireDefault(_AppBiteMenu);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	//Import Higher Level Components
	
	//import main Components
	exports.default = _react2.default.createElement(
	    _reactRouter.Router,
	    null,
	    _react2.default.createElement(
	        _reactRouter.Route,
	        { path: '/', component: _App2.default },
	        _react2.default.createElement(_reactRouter.IndexRoute, { component: _Initialisation2.default }),
	        _react2.default.createElement(_reactRouter.Route, { path: 'menu', component: _AppBiteMenu2.default }),
	        _react2.default.createElement(_reactRouter.Route, { path: ':bite_id', component: _AppBite2.default })
	    )
	);
	//import child Components

/***/ },
/* 581 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _jquery = __webpack_require__(356);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var DataService = function () {
	    function DataService() {
	        _classCallCheck(this, DataService);
	    }
	
	    _createClass(DataService, null, [{
	        key: 'loadData',
	        value: function loadData(dataPath) {
	            return new Promise(function (resolve, reject) {
	                _jquery2.default.ajax({
	                    type: 'GET',
	                    url: dataPath,
	                    contentType: 'application/json',
	                    dataType: 'json'
	                }).done(resolve).fail(reject);
	            });
	        }
	    }]);
	
	    return DataService;
	}();
	
	exports.default = DataService;

/***/ },
/* 582 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _appModels = __webpack_require__(68);
	
	var appData = _interopRequireWildcard(_appModels);
	
	var _appHelper = __webpack_require__(3);
	
	var appHelper = _interopRequireWildcard(_appHelper);
	
	var _dataHelper = __webpack_require__(11);
	
	var dataHelper = _interopRequireWildcard(_dataHelper);
	
	var _lodash = __webpack_require__(28);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _openlearningExternal = __webpack_require__(587);
	
	var OL = _interopRequireWildcard(_openlearningExternal);
	
	var _scormConstants = __webpack_require__(137);
	
	var scormConstants = _interopRequireWildcard(_scormConstants);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var openLearningService = function () {
	    function openLearningService() {
	        _classCallCheck(this, openLearningService);
	    }
	
	    _createClass(openLearningService, null, [{
	        key: 'initTracking',
	        value: function initTracking(contentData) {
	            return new Promise(function (resolve, reject) {
	                var trackingData = Object.assign({}, appData.TRACKING_DATA);
	
	                window.OL(function () {
	                    // Ready to go!
	                    window.OL.log("I'm ready!");
	                });
	
	                var userData = window.OL.user.data;
	                var tracking = {
	                    suspend_data: trackingData.suspend_data,
	                    lesson_location: contentData.experience.bites[0].screens[0].screen_id,
	                    lesson_status: scormConstants.LESSON_STATUS_INCOMPLETE
	                };
	
	                if (typeof userData.tracking === 'undefined') {
	
	                    window.OL.user.replace({ 'tracking': tracking }, function (result) {
	                        if (!result.success) {
	                            window.OL.log("It looks like we don't have the ability to save user data");
	                        } else {
	                            window.OL.log("saved!");
	                        }
	                    });
	
	                    trackingData = Object.assign({}, trackingData, {
	                        lesson_location: contentData.experience.bites[0].screens[0].screen_id,
	                        lesson_status: scormConstants.LESSON_STATUS_INCOMPLETE
	                    });
	                } else {
	                    var screen = appHelper.getScreenById(userData.tracking.lesson_location);
	                    if (!appHelper.isDefined(screen.screen_id) || userData.tracking.lesson_location === null || !appHelper.isDefined(userData.tracking.lesson_location)) {
	                        window.OL.user.replace({ 'tracking': tracking }, function (result) {
	                            if (!result.success) {
	                                window.OL.log("It looks like we don't have the ability to save user data");
	                            } else {
	                                window.OL.log("saved!");
	                            }
	                        });
	
	                        trackingData = Object.assign({}, trackingData, {
	                            lesson_location: contentData.experience.bites[0].screens[0].screen_id,
	                            lesson_status: scormConstants.LESSON_STATUS_INCOMPLETE
	                        });
	                    } else {
	                        if (_typeof(userData.tracking.suspend_data) !== undefined) {
	                            trackingData = Object.assign({}, trackingData, {
	                                suspend_data: userData.tracking.suspend_data
	                            });
	                        }
	
	                        if (_typeof(userData.tracking.lesson_location) !== undefined) {
	                            trackingData = Object.assign({}, trackingData, {
	                                lesson_location: userData.tracking.lesson_location
	                            });
	                        } else {
	                            trackingData = Object.assign({}, trackingData, {
	                                lesson_location: contentData.experience.bites[0].screens[0].screen_id
	                            });
	                        }
	
	                        if (_typeof(userData.tracking.lesson_status) !== undefined) {
	                            if (userData.tracking.lesson_status != scormConstants.LESSON_STATUS_COMPLETED) {
	                                trackingData = Object.assign({}, trackingData, {
	                                    lesson_status: userData.tracking.lesson_status
	                                });
	                            } else {
	                                trackingData = Object.assign({}, trackingData, {
	                                    lesson_status: scormConstants.LESSON_STATUS_INCOMPLETE
	                                });
	                            }
	                        }
	                    }
	                }
	
	                trackingData = Object.assign({}, trackingData, {
	                    initialised: true
	                });
	
	                resolve(trackingData);
	            });
	        }
	    }, {
	        key: 'setLessionLocation',
	        value: function setLessionLocation(lesson_location) {
	            return new Promise(function (resolve, reject) {
	                var userData = window.OL.user.data;
	                var tracking = Object.assign({}, userData.tracking);
	                tracking = Object.assign({}, tracking, {
	                    lesson_location: parseInt(lesson_location)
	                });
	
	                window.OL.user.replace({ 'tracking': tracking }, function (result) {
	                    if (!result.success) {
	                        window.OL.log("Error saving Lession Location");
	                    } else {
	                        resolve(true);
	                    }
	                });
	            });
	        }
	    }, {
	        key: 'setSuspendData',
	        value: function setSuspendData(suspend_data) {
	            return new Promise(function (resolve, reject) {
	                var userData = window.OL.user.data;
	                var tracking = Object.assign({}, userData.tracking);
	                tracking = Object.assign({}, tracking, {
	                    suspend_data: suspend_data
	                });
	
	                window.OL.user.replace({ 'tracking': tracking }, function (result) {
	                    if (!result.success) {
	                        window.OL.log("Error saving Suspend Data");
	                    } else {
	                        resolve(true);
	                    }
	                });
	            });
	        }
	    }, {
	        key: 'markComplete',
	        value: function markComplete(bites, contentData) {
	            return new Promise(function (resolve, reject) {
	                var userData = window.OL.user.data;
	                var tracking = Object.assign({}, userData.tracking);
	
	                if (tracking.lesson_status != scormConstants.LESSON_STATUS_COMPLETED) {
	
	                    tracking = Object.assign({}, tracking, {
	                        lesson_status: scormConstants.LESSON_STATUS_COMPLETED
	                    });
	
	                    window.OL.user.replace({ 'tracking': tracking });
	
	                    try {
	                        var scores = [];
	                        var totalScore = 0;
	                        var avgScore = 0;
	                        var scoreScaled = 0;
	                        var scoreMax = 100;
	
	                        _lodash2.default.forEach(bites, function (bite) {
	                            var primaryKpi = appHelper.getArrayObjectByKey(bite.kpis, "is_primary", true);
	                            var score = dataHelper.getRangePercentage(primaryKpi.min, primaryKpi.max, primaryKpi.current);
	                            if (isNaN(score)) {
	                                score = scormConstants.CMI_CORE_SCORE_MAX_DEFAULT;
	                            }
	                            scores.push(score);
	                            totalScore += score;
	                            avgScore = totalScore / scores.length;
	                            scoreScaled = new Number(avgScore / scoreMax);
	                        });
	
	                        if (avgScore >= 0) {
	                            window.OL.criteria.replace({ completed: true }, "equal", "open");
	                            window.OL.user.setProgress(scoreScaled / 1);
	                        }
	                    } catch (err) {
	                        window.OL.log("Error setting score");
	                    }
	
	                    window.OL.user.submit({ "completed": true }, function (result) {
	                        if (!result.success) {
	                            window.OL.log("Error setting completion");
	                            resolve(true);
	                        } else {
	                            window.OL.log("saved completion");
	                            resolve(true);
	                        }
	                        resolve(true);
	                    });
	                    resolve(true);
	                } else {
	                    window.OL.user.submit({ "completed": true }, function (result) {
	                        if (!result.success) {
	                            window.OL.log("Error setting completion");
	                            resolve(true);
	                        } else {
	                            window.OL.log("saved completion");
	                            resolve(true);
	                        }
	                    });
	                    resolve(true);
	                }
	            });
	        }
	    }]);
	
	    return openLearningService;
	}();
	
	exports.default = openLearningService;

/***/ },
/* 583 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _APIWrap = __webpack_require__(288);
	
	var scormAPIWrapper = _interopRequireWildcard(_APIWrap);
	
	var _scormConstants = __webpack_require__(137);
	
	var scormConstants = _interopRequireWildcard(_scormConstants);
	
	var _appModels = __webpack_require__(68);
	
	var appData = _interopRequireWildcard(_appModels);
	
	var _appHelper = __webpack_require__(3);
	
	var _localStorage = __webpack_require__(17);
	
	var localeStorage = _interopRequireWildcard(_localStorage);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var ScormService = function () {
	    function ScormService() {
	        _classCallCheck(this, ScormService);
	    }
	
	    _createClass(ScormService, null, [{
	        key: 'initTracking',
	        value: function initTracking() {
	            //console.log('initTracking');
	            return new Promise(function (resolve, reject) {
	                var trackingData = Object.assign({}, appData.TRACKING_DATA);
	                scormAPIWrapper.doLMSInitialize().then(function (result) {
	
	                    //GET SUSPEND_DATA
	                    scormAPIWrapper.doLMSGetValue(scormConstants.CMI_SUSPEND_DATA).then(function (result) {
	                        var suspend_data = result.data;
	                        if (suspend_data.length > 0) {
	                            suspend_data = JSON.parse(suspend_data);
	                        }
	                        //console.log('Get suspend_data ', result.data);
	                        trackingData = Object.assign({}, trackingData, {
	                            suspend_data: result.success ? suspend_data : trackingData.suspend_data
	                        });
	                    }).catch(function (error) {
	                        throw error;
	                    });
	
	                    //GET STUDENT_NAME
	                    scormAPIWrapper.doLMSGetValue(scormConstants.CMI_CORE_STUDENT_NAME).then(function (result) {
	                        if (result.success) {
	                            var studentNameObj = (0, _appHelper.setStudentName)(result.data);
	                            trackingData = Object.assign({}, trackingData, {
	                                student_name: studentNameObj.student_name,
	                                first_name: studentNameObj.first_name,
	                                last_name: studentNameObj.last_name
	                            });
	                        }
	                    }).catch(function (error) {
	                        throw error;
	                    });
	
	                    //GET LESSON_LOCATION (BOOKMARK)
	                    scormAPIWrapper.doLMSGetValue(scormConstants.CMI_CORE_LESSON_LOCATION).then(function (result) {
	                        trackingData = Object.assign({}, trackingData, {
	                            lesson_location: result.success && !isNaN(result.data) ? parseInt(result.data) : 0
	                        });
	                    }).catch(function (error) {
	                        throw error;
	                    });
	
	                    //GET LESSON_STATUS
	                    scormAPIWrapper.doLMSGetValue(scormConstants.CMI_CORE_LESSON_STATUS).then(function (result) {
	
	                        if (result.data != scormConstants.LESSON_STATUS_COMPLETED) {
	                            scormAPIWrapper.doLMSSetValue(scormConstants.CMI_CORE_LESSON_STATUS, scormConstants.LESSON_STATUS_INCOMPLETE);
	                            trackingData = Object.assign({}, trackingData, {
	                                lesson_status: scormConstants.LESSON_STATUS_INCOMPLETE
	                            });
	                        } else {
	                            trackingData = Object.assign({}, trackingData, {
	                                lesson_status: result.success ? result.data : trackingData.lesson_status
	                            });
	                        }
	                    }).catch(function (error) {
	                        throw error;
	                    });
	
	                    //GET SCORE_RAW
	                    scormAPIWrapper.doLMSGetValue(scormConstants.CMI_CORE_SCORE_RAW).then(function (result) {
	                        trackingData = Object.assign({}, trackingData, {
	                            score_raw: result.success && !isNaN(parseInt(result.data)) ? parseInt(result.data) : trackingData.score_raw
	                        });
	                    }).catch(function (error) {
	                        throw error;
	                    });
	
	                    //FINISH OFF BY MAKING SURE THE LMS IS INITIALISED
	                    scormAPIWrapper.LMSIsInitialized().then(function (result) {
	
	                        trackingData = Object.assign({}, trackingData, {
	                            initialised: result.success && result.data == "true" ? true : trackingData.initialised
	                        });
	                        resolve(trackingData);
	                    }).catch(function (error) {
	                        resolve(trackingData);
	                    });
	                }).catch(function (error) {
	                    if (appData.SETTINGS.DEVELOPMENT_MODE) {
	                        var student_name = "Lastname, Firstname";
	                        var studentNameObj = (0, _appHelper.setStudentName)(student_name);
	
	                        trackingData = Object.assign({}, trackingData, {
	                            initialised: true,
	                            student_name: studentNameObj.student_name,
	                            first_name: studentNameObj.first_name,
	                            last_name: studentNameObj.last_name
	                        });
	                        resolve(trackingData);
	                    } else {
	                        throw error;
	                    }
	                });
	            });
	        }
	    }, {
	        key: 'setLessionLocation',
	        value: function setLessionLocation(lesson_location) {
	            if (!isNaN(lesson_location)) {
	                return scormAPIWrapper.doLMSSetValue(scormConstants.CMI_CORE_LESSON_LOCATION, lesson_location.toString());
	            } else {
	                return scormAPIWrapper.doLMSSetValue(scormConstants.CMI_CORE_LESSON_LOCATION, localeStorage.contentData.experience.bites[0].screens[0].screen_id.toString());
	            }
	        }
	    }, {
	        key: 'setSuspendData',
	        value: function setSuspendData(suspend_data) {
	
	            //console.log('Set suspend_data ', JSON.stringify(suspend_data));
	            return scormAPIWrapper.doLMSSetValue(scormConstants.CMI_SUSPEND_DATA, JSON.stringify(suspend_data));
	        }
	    }, {
	        key: 'setLessionStatus',
	        value: function setLessionStatus(lesson_status) {
	            //console.log('setLessionStatus');
	            return scormAPIWrapper.doLMSSetValue(scormConstants.CMI_CORE_LESSON_STATUS, lesson_status);
	        }
	    }, {
	        key: 'setScoreRaw',
	        value: function setScoreRaw(scoreRaw) {
	            // console.log(`setScoreRaw ${scoreRaw}`);
	            return scormAPIWrapper.doLMSSetValue(scormConstants.CMI_CORE_SCORE_RAW, scoreRaw);
	        }
	    }, {
	        key: 'setScoreMin',
	        value: function setScoreMin(scoreMin) {
	            // console.log(`scoreMin ${scoreMin}`);
	            return scormAPIWrapper.doLMSSetValue(scormConstants.CMI_CORE_SCORE_MIN, scoreMin);
	        }
	    }, {
	        key: 'setScoreMax',
	        value: function setScoreMax(scoreMax) {
	            // console.log(`scoreMax ${scoreMax}`);
	            return scormAPIWrapper.doLMSSetValue(scormConstants.CMI_CORE_SCORE_MAX, scoreMax);
	        }
	    }, {
	        key: 'doLMSFinish',
	        value: function doLMSFinish() {
	            //console.log('doLMSFinish');
	            //return scormAPIWrapper.doLMSFinish();
	            return new Promise(function (resolve, reject) {
	                scormAPIWrapper.LMSIsInitialized().then(function (result) {
	                    if (result.success && result.data === "true") {
	                        resolve(scormAPIWrapper.doLMSFinish());
	                    }
	                }).catch(function (error) {
	                    //console.log(`doLMSFinish`, error);
	                    reject(error);
	                });
	            });
	        }
	    }, {
	        key: 'doLMSCommit',
	        value: function doLMSCommit() {
	            // console.log('doLMSCommit');
	            return new Promise(function (resolve, reject) {
	                scormAPIWrapper.LMSIsInitialized().then(function (result) {
	                    if (result.success && result.data === "true") {
	                        resolve(scormAPIWrapper.doLMSCommit());
	                    }
	                }).catch(function (error) {
	                    //console.log(`doLMSCommit`, error);
	                    reject(error);
	                });
	            });
	        }
	    }, {
	        key: 'doQuickLMSFinish',
	        value: function doQuickLMSFinish() {
	            //console.log('doLMSFinish');
	            return scormAPIWrapper.doLMSFinish();
	        }
	    }, {
	        key: 'doQuickLMSCommit',
	        value: function doQuickLMSCommit() {
	            //console.log('doLMSCommit');
	            return scormAPIWrapper.doLMSCommit();
	        }
	    }, {
	        key: 'lmsGetScore',
	        value: function lmsGetScore() {
	            scormAPIWrapper.doLMSGetValue(scormConstants.CMI_CORE_SCORE_RAW).then(function (result) {
	                // console.log(`lmsGetScore`, result);
	            }).catch(function (error) {
	                //console.log(`lmsGetScore error`, error);
	            });
	        }
	    }, {
	        key: 'lmsGetLessonStatus',
	        value: function lmsGetLessonStatus() {
	            scormAPIWrapper.doLMSGetValue(scormConstants.CMI_CORE_LESSON_STATUS).then(function (result) {
	                //console.log(`lmsGetLessonStatus`, result);
	            }).catch(function (error) {
	                //console.log(`lmsGetLessonStatus error`, error);
	            });
	        }
	    }, {
	        key: 'doLMSExit',
	        value: function doLMSExit() {
	            return scormAPIWrapper.doLMSSetValue(scormConstants.CMI_CORE_EXIT, scormConstants.EXIT_SUSPEND);
	        }
	
	        /*static doLMSSetValue(name,value){
	          return scormAPIWrapper.doLMSSetValue(name,value).then(result => {
	         //console.log(result);
	         }).catch(error => {
	         //console.log(error);
	         throw(error);
	         });
	         }*/
	
	    }]);
	
	    return ScormService;
	}();
	
	exports.default = ScormService;

/***/ },
/* 584 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _APIWrap = __webpack_require__(288);
	
	var scormAPIWrapper = _interopRequireWildcard(_APIWrap);
	
	var _scormConstants = __webpack_require__(137);
	
	var scormConstants = _interopRequireWildcard(_scormConstants);
	
	var _appModels = __webpack_require__(68);
	
	var appData = _interopRequireWildcard(_appModels);
	
	var _xAPIConstants = __webpack_require__(286);
	
	var xAPIConstants = _interopRequireWildcard(_xAPIConstants);
	
	var _xAPIWrap = __webpack_require__(289);
	
	var _xAPIWrap2 = _interopRequireDefault(_xAPIWrap);
	
	var _appHelper = __webpack_require__(3);
	
	var appHelper = _interopRequireWildcard(_appHelper);
	
	var _lodash = __webpack_require__(28);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _striptags = __webpack_require__(191);
	
	var _striptags2 = _interopRequireDefault(_striptags);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var xAPIScormService = function () {
	    function xAPIScormService() {
	        _classCallCheck(this, xAPIScormService);
	    }
	
	    _createClass(xAPIScormService, null, [{
	        key: 'initTracking',
	        value: function initTracking(contentData) {
	            return new Promise(function (resolve, reject) {
	                var trackingData = Object.assign({}, appData.TRACKING_DATA);
	                var suspend_data = trackingData.suspend_data;
	
	                var conf = {
	                    endpoint: contentData.experience.lrs.end_point,
	                    user: contentData.experience.lrs.key,
	                    password: contentData.experience.lrs.secret
	                };
	
	                var lrs = new _xAPIWrap2.default.Lrs(conf);
	                lrs.changeConfig(conf);
	                var settings = {};
	
	                scormAPIWrapper.doLMSInitialize().then(function (result) {
	
	                    //GET STUDENT_NAME
	                    scormAPIWrapper.doLMSGetValue(scormConstants.CMI_CORE_STUDENT_NAME).then(function (result) {
	                        if (result.success) {
	                            var studentNameObj = appHelper.setStudentName(result.data);
	                            trackingData = Object.assign({}, trackingData, {
	                                student_name: studentNameObj.student_name,
	                                first_name: studentNameObj.first_name,
	                                last_name: studentNameObj.last_name
	                            });
	                        }
	                    }).catch(function (error) {
	                        throw error;
	                    });
	
	                    //GET STUDENT_ID
	                    scormAPIWrapper.doLMSGetValue(scormConstants.CMI_CORE_STUDENT_ID).then(function (result) {
	                        if (result.success) {
	                            trackingData = Object.assign({}, trackingData, {
	                                student_id: result.data
	                            });
	                        }
	                    }).catch(function (error) {
	                        throw error;
	                    });
	
	                    //GET LESSON_LOCATION (BOOKMARK)
	                    scormAPIWrapper.doLMSGetValue(scormConstants.CMI_CORE_LESSON_LOCATION).then(function (result) {
	                        trackingData = Object.assign({}, trackingData, {
	                            lesson_location: result.success ? result.data : trackingData.lesson_location
	                        });
	                    }).catch(function (error) {
	                        throw error;
	                    });
	
	                    //GET LESSON_STATUS
	                    scormAPIWrapper.doLMSGetValue(scormConstants.CMI_CORE_LESSON_STATUS).then(function (result) {
	
	                        if (result.data != scormConstants.LESSON_STATUS_COMPLETED) {
	                            scormAPIWrapper.doLMSSetValue(scormConstants.CMI_CORE_LESSON_STATUS, scormConstants.LESSON_STATUS_INCOMPLETE);
	                            trackingData = Object.assign({}, trackingData, {
	                                lesson_status: scormConstants.LESSON_STATUS_INCOMPLETE
	                            });
	                        } else {
	                            trackingData = Object.assign({}, trackingData, {
	                                lesson_status: result.success ? result.data : trackingData.lesson_status
	                            });
	                        }
	                    }).catch(function (error) {
	                        throw error;
	                    });
	
	                    //GET SCORE_RAW
	                    scormAPIWrapper.doLMSGetValue(scormConstants.CMI_CORE_SCORE_RAW).then(function (result) {
	                        trackingData = Object.assign({}, trackingData, {
	                            score_raw: result.success && !isNaN(parseInt(result.data)) ? parseInt(result.data) : trackingData.score_raw
	                        });
	                    }).catch(function (error) {
	                        throw error;
	                    });
	
	                    //FINISH OFF BY MAKING SURE THE LMS IS INITIALISED
	                    scormAPIWrapper.LMSIsInitialized().then(function (result) {
	                        settings = {
	                            student: {
	                                id: trackingData.student_id,
	                                name: trackingData.first_name + ' ' + trackingData.last_name,
	                                homePage: lrs.getCurrentUrl()
	                            },
	                            project: {
	                                id: lrs.getCurrentUrl() + '/project_id:' + contentData.experience.project_id,
	                                name: contentData.experience.en.project_title
	                            },
	                            activity: {
	                                id: lrs.getCurrentUrl() + '/project_id:' + contentData.experience.project_id + '/experience_id:' + contentData.experience.experience_id,
	                                name: appHelper.getLocalData(contentData.experience).experience_title,
	                                description: appHelper.getLocalData(contentData.experience).experience_title
	                            },
	                            conf: {
	                                endpoint: xAPIConstants.LRS_END_POINT,
	                                user: xAPIConstants.LRS_KEY,
	                                password: xAPIConstants.LRS_SECRET
	                            }
	                        };
	                        lrs.updateSettings(settings);
	
	                        var user = {
	                            account: {
	                                name: lrs.settings.student.id,
	                                homePage: lrs.settings.student.homePage
	                            }
	                        };
	
	                        var actor = {
	                            objectType: "Agent",
	                            name: lrs.settings.student.name,
	                            account: user.account
	                        };
	
	                        lrs.lrs.actor = JSON.stringify(actor);
	
	                        function getSuspendData() {
	                            lrs.getState(lrs.settings.activity.id, new lrs.Agent(actor, actor.name), "suspend_data").then(function (response) {
	                                suspend_data = response.suspend_data;
	
	                                trackingData = Object.assign({}, trackingData, {
	                                    suspend_data: suspend_data
	                                });
	
	                                sendLaunchStatement();
	                            }).catch(function (error) {
	                                sendLaunchStatement();
	                            });
	                        }
	
	                        function sendLaunchStatement() {
	                            var stmt = new lrs.Statement(new lrs.Agent(actor, actor.name), lrs.Verbs.launched, new lrs.Activity(lrs.settings.activity.id, lrs.settings.activity.name, lrs.settings.activity.description, xAPIConstants.MODULE_ACTIVITY_TYPE));
	
	                            var group = {
	                                id: '' + lrs.settings.project.id,
	                                objectType: 'Activity',
	                                definition: {
	                                    name: {
	                                        en: lrs.settings.project.name
	                                    },
	                                    type: xAPIConstants.PROJECT_ACTIVITY_TYPE
	                                }
	                            };
	                            stmt = lrs.addGroupingActivity(stmt, group);
	
	                            var categoryObj = {
	                                id: xAPIConstants.ACTIVITY_URL_ID + '/' + xAPIConstants.EXPERIENCE_CODE,
	                                objectType: 'Activity',
	                                definition: {
	                                    name: {
	                                        en: xAPIConstants.EXPERIENC_LABEL
	                                    },
	                                    type: xAPIConstants.MODULE_ACTIVITY_TYPE
	                                }
	                            };
	                            stmt = lrs.addCategoryActivity(stmt, categoryObj);
	
	                            lrs.sendStatement(stmt).then(function (response) {
	                                trackingData = Object.assign({}, trackingData, {
	                                    lrs: lrs,
	                                    initialised: result.success && result.data == "true" ? true : trackingData.initialised
	                                });
	                                resolve(trackingData);
	                            }).catch(function (error) {
	                                resolve(trackingData);
	                            });
	                        }
	
	                        getSuspendData();
	                    }).catch(function (error) {
	                        resolve(trackingData);
	                    });
	                }).catch(function (error) {
	                    if (appData.SETTINGS.DEVELOPMENT_MODE) {
	                        var student_name = "Lastname, Firstname";
	                        var studentNameObj = appHelper.setStudentName(student_name);
	
	                        var _settings = {
	                            student: {
	                                id: '2099009',
	                                name: studentNameObj.student_name,
	                                homePage: lrs.getCurrentUrl()
	                            },
	                            activity: {
	                                id: lrs.getCurrentUrl() + '/' + contentData.experience.experience_id,
	                                name: appHelper.getLocalData(contentData.experience).experience_title,
	                                description: appHelper.getLocalData(contentData.experience).experience_title
	                            },
	                            conf: {
	                                endpoint: xAPIConstants.LRS_END_POINT,
	                                user: xAPIConstants.LRS_KEY,
	                                password: xAPIConstants.LRS_SECRET
	                            }
	                        };
	                        lrs.updateSettings(_settings);
	
	                        trackingData = Object.assign({}, trackingData, {
	                            initialised: true,
	                            student_name: studentNameObj.student_name,
	                            first_name: studentNameObj.first_name,
	                            last_name: studentNameObj.last_name,
	                            lrs: lrs
	                        });
	                        resolve(trackingData);
	                    } else {
	                        throw error;
	                    }
	                });
	            });
	        }
	    }]);
	
	    return xAPIScormService;
	}();
	
	exports.default = xAPIScormService;

/***/ },
/* 585 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _xAPIConstants = __webpack_require__(286);
	
	var xAPIConstants = _interopRequireWildcard(_xAPIConstants);
	
	var _appModels = __webpack_require__(68);
	
	var appData = _interopRequireWildcard(_appModels);
	
	var _scormConstants = __webpack_require__(137);
	
	var scormConstants = _interopRequireWildcard(_scormConstants);
	
	var _objectConstants = __webpack_require__(9);
	
	var objectConstants = _interopRequireWildcard(_objectConstants);
	
	var _appHelper = __webpack_require__(3);
	
	var appHelper = _interopRequireWildcard(_appHelper);
	
	var _dataHelper = __webpack_require__(11);
	
	var dataHelper = _interopRequireWildcard(_dataHelper);
	
	var _xAPIWrap = __webpack_require__(289);
	
	var _xAPIWrap2 = _interopRequireDefault(_xAPIWrap);
	
	var _lodash = __webpack_require__(28);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _striptags = __webpack_require__(191);
	
	var _striptags2 = _interopRequireDefault(_striptags);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var xAPIService = function () {
	    function xAPIService() {
	        _classCallCheck(this, xAPIService);
	    }
	
	    _createClass(xAPIService, null, [{
	        key: 'checkActorDefined',
	        value: function checkActorDefined(contentData) {
	            return new Promise(function (resolve, reject) {
	                var conf = {
	                    endpoint: contentData.experience.lrs.end_point,
	                    user: contentData.experience.lrs.key,
	                    password: contentData.experience.lrs.secret
	                };
	                var lrs = new _xAPIWrap2.default.Lrs(conf);
	                lrs.changeConfig(conf);
	                resolve(lrs);
	            });
	        }
	    }, {
	        key: 'initTracking',
	        value: function initTracking(contentData, trackingData) {
	            return new Promise(function (resolve, reject) {
	                var suspend_data = trackingData.suspend_data;
	                var lesson_location = trackingData.lesson_location;
	                var lesson_status = trackingData.lesson_status;
	
	                var conf = {
	                    endpoint: contentData.experience.lrs.end_point,
	                    user: contentData.experience.lrs.key,
	                    password: contentData.experience.lrs.secret
	                };
	
	                //let lrs = new xAPI.Lrs(conf);
	                var lrs = new _xAPIWrap2.default.Lrs();
	
	                if (typeof lrs.lrs === 'undefined' || typeof lrs.lrs.auth === 'undefined' || typeof lrs.lrs.endpoint === 'undefined') {
	                    lrs.changeConfig(conf);
	                }
	
	                if (!appHelper.isDefined(lrs.lrs.actor) && appHelper.isDefined(trackingData.actor)) {
	                    lrs.lrs.actor = JSON.stringify(trackingData.actor);
	                }
	
	                var actor = JSON.parse(lrs.lrs.actor);
	
	                var settings = {
	                    student: {
	                        id: '2099981',
	                        name: 'Daniel Steff',
	                        homePage: lrs.getCurrentUrl()
	                    },
	                    project: {
	                        id: lrs.getCurrentUrl() + '/project_id:' + contentData.experience.project_id,
	                        name: appHelper.getLocalData(contentData.experience).project_title
	                    },
	                    activity: {
	                        id: '' + (typeof lrs.lrs.activity_id !== 'undefined' ? lrs.lrs.activity_id : lrs.getCurrentUrl() + '/project_id:' + contentData.experience.project_id + '/experience_id:' + contentData.experience.experience_id),
	                        name: appHelper.getLocalData(contentData.experience).experience_title,
	                        description: ""
	                    },
	                    conf: {
	                        endpoint: xAPIConstants.LRS_END_POINT,
	                        user: xAPIConstants.LRS_KEY,
	                        password: xAPIConstants.LRS_SECRET
	                    }
	                };
	                lrs.updateSettings(settings);
	
	                var user = {
	                    account: {
	                        name: lrs.settings.student.id,
	                        homePage: lrs.settings.student.homePage
	                    }
	                };
	
	                trackingData = Object.assign({}, trackingData, {
	                    lrs: lrs
	                });
	
	                //GET SUSPEND_DATA
	                function getSuspendData() {
	                    lrs.getState(lrs.settings.activity.id, new lrs.Agent(actor, actor.name), "suspend_data").then(function (response) {
	                        suspend_data = response.suspend_data;
	
	                        trackingData = Object.assign({}, trackingData, {
	                            suspend_data: suspend_data
	                        });
	
	                        getLessonLocation();
	                    }).catch(function (error) {
	                        getLessonLocation();
	                    });
	                }
	
	                //GET LESSON_LOCATION (BOOKMARK)
	                function getLessonLocation() {
	                    lrs.getState(lrs.settings.activity.id, new lrs.Agent(actor, actor.name), "lesson_location").then(function (response) {
	                        var lesson_location = response.lesson_location;
	                        trackingData = Object.assign({}, trackingData, {
	                            lesson_location: lesson_location
	                        });
	                        checkCompleteRecord();
	                    }).catch(function (error) {
	                        trackingData = Object.assign({}, trackingData, {
	                            lesson_location: contentData.experience.bites[0].screens[0].screen_id
	                        });
	                        checkCompleteRecord();
	                    });
	                }
	
	                //CHECK FOR A COMPLETE RECORD
	                function checkCompleteRecord() {
	                    var search = lrs.searchParams();
	                    search['verb'] = lrs.Verbs.completed.id;
	                    search['activity'] = lrs.settings.activity.id;
	                    search['agent'] = new lrs.Agent(actor, actor.name);
	                    search['limit'] = 1;
	
	                    lrs.getStatements(search).then(function (response) {
	                        var raw_score = 0;
	                        if (response.statements.length > 0) {
	                            lesson_status = scormConstants.LESSON_STATUS_COMPLETED;
	                            if (typeof response.statements[0].result.score !== 'undefined') {
	                                raw_score = response.statements[0].result.score.raw;
	                            }
	                        }
	                        trackingData = Object.assign({}, trackingData, {
	                            lesson_status: lesson_status,
	                            raw_score: raw_score
	                        });
	                        sendLaunchStatement();
	                    }).catch(function (error) {
	                        sendLaunchStatement();
	                    });
	                }
	
	                function sendLaunchStatement() {
	
	                    var stmt = new lrs.Statement(new lrs.Agent(actor, actor.name), lrs.Verbs.launched, new lrs.Activity(lrs.settings.activity.id, lrs.settings.activity.name, lrs.settings.activity.description, xAPIConstants.MODULE_ACTIVITY_TYPE));
	
	                    var group = {
	                        id: '' + lrs.settings.project.id,
	                        objectType: 'Activity',
	                        definition: {
	                            name: {
	                                en: lrs.settings.project.name
	                            },
	                            type: xAPIConstants.PROJECT_ACTIVITY_TYPE
	                        }
	                    };
	                    stmt = lrs.addGroupingActivity(stmt, group);
	
	                    var categoryObj = {
	                        id: xAPIConstants.ACTIVITY_URL_ID + '/' + xAPIConstants.EXPERIENCE_CODE,
	                        objectType: 'Activity',
	                        definition: {
	                            name: {
	                                en: xAPIConstants.EXPERIENC_LABEL
	                            },
	                            type: xAPIConstants.MODULE_ACTIVITY_TYPE
	                        }
	                    };
	                    stmt = lrs.addCategoryActivity(stmt, categoryObj);
	
	                    lrs.sendStatement(stmt).then(function (response) {
	                        var studentNameObj = appHelper.setStudentName(actor.name);
	                        trackingData = Object.assign({}, trackingData, {
	                            initialised: true,
	                            student_name: studentNameObj.student_name,
	                            first_name: studentNameObj.first_name,
	                            last_name: studentNameObj.last_name
	                        });
	
	                        resolve(trackingData);
	                    }).catch(function (error) {
	
	                        if (appData.SETTINGS.DEVELOPMENT_MODE) {
	                            var student_name = "Lastname, Firstname";
	                            var studentNameObj = appHelper.setStudentName(student_name);
	
	                            trackingData = Object.assign({}, trackingData, {
	                                initialised: true,
	                                student_name: studentNameObj.student_name,
	                                first_name: studentNameObj.first_name,
	                                last_name: studentNameObj.last_name
	                            });
	
	                            resolve(trackingData);
	                        } else {
	                            throw error;
	                        }
	                    });
	                }
	
	                getSuspendData();
	            });
	        }
	    }, {
	        key: 'setLessionLocation',
	        value: function setLessionLocation(lesson_location, lrs) {
	            return new Promise(function (resolve, reject) {
	                var user = {
	                    account: {
	                        name: lrs.settings.student.id,
	                        homePage: lrs.settings.student.homePage
	                    }
	                };
	                var lessionLocation = { "lesson_location": lesson_location };
	
	                var actor = JSON.parse(lrs.lrs.actor);
	
	                lrs.sendState(lrs.settings.activity.id, new lrs.Agent(actor, actor.name), "lesson_location", null, lessionLocation).then(function (response) {
	                    resolve(true);
	                }).catch(function (error) {
	                    reject(error);
	                });
	            });
	        }
	    }, {
	        key: 'setSuspendData',
	        value: function setSuspendData(suspend_data, lrs) {
	            return new Promise(function (resolve, reject) {
	                var user = {
	                    account: {
	                        name: lrs.settings.student.id,
	                        homePage: lrs.settings.student.homePage
	                    }
	                };
	                var suspendData = { "suspend_data": suspend_data };
	
	                var actor = JSON.parse(lrs.lrs.actor);
	
	                lrs.sendState(lrs.settings.activity.id, new lrs.Agent(actor, actor.name), "suspend_data", null, suspendData).then(function (response) {
	                    resolve(true);
	                }).catch(function (error) {
	                    reject(error);
	                });
	
	                resolve(true);
	            });
	        }
	    }, {
	        key: 'markComplete',
	        value: function markComplete(lrs, bites, contentData) {
	            return new Promise(function (resolve, reject) {
	                var user = {
	                    account: {
	                        name: lrs.settings.student.id,
	                        homePage: lrs.settings.student.homePage
	                    }
	                };
	                var result = {};
	                var currentCompleteResult = {};
	                var actor = JSON.parse(lrs.lrs.actor);
	
	                //SET RESULT
	                function setResult() {
	                    var scores = [];
	                    var totalScore = 0;
	                    var avgScore = 100;
	                    var scoreScaled = 0;
	                    var scoreMax = 100;
	                    var scoreMin = 0;
	
	                    var totalweight = 0;
	                    _lodash2.default.forEach(bites, function (bite) {
	                        var primaryKpi = appHelper.getArrayObjectByKey(bite.kpis, "is_primary", true);
	                        if (appHelper.isDefined(primaryKpi)) {
	                            var score = dataHelper.getRangePercentage(primaryKpi.min, primaryKpi.max, primaryKpi.current);
	                            if (isNaN(score)) {
	                                score = scormConstants.CMI_CORE_SCORE_MAX_DEFAULT;
	                            }
	
	                            var weightedScore = score * bite.weight;
	
	                            scores.push(weightedScore);
	                            totalScore += weightedScore;
	                            totalweight += bite.weight;
	                        }
	                    });
	
	                    avgScore = totalScore / totalweight;
	                    scoreScaled = new Number(avgScore / scoreMax);
	
	                    if (isNaN(avgScore)) {
	                        avgScore = scormConstants.CMI_CORE_SCORE_MAX_DEFAULT;
	                    }
	
	                    if (avgScore >= 0 && scores.length > 0) {
	                        var scoreObj = {
	                            scaled: scoreScaled,
	                            raw: avgScore,
	                            min: scoreMin,
	                            max: scoreMax
	                        };
	
	                        result = {
	                            completion: true,
	                            success: true,
	                            score: scoreObj
	                            //response: 'Module Complete'
	                        };
	                    } else {
	                        result = {
	                            completion: true
	                            //success: true,
	                            //response: "Module Complete"
	                        };
	                    }
	                    checkCompleteRecord();
	                }
	
	                //CHECK FOR A COMPLETE RECORD
	                function checkCompleteRecord() {
	                    var search = lrs.searchParams();
	                    search['verb'] = lrs.Verbs.completed.id;
	                    search['activity'] = lrs.settings.activity.id;
	                    search['agent'] = new lrs.Agent(actor, actor.name);
	                    search['limit'] = 1;
	
	                    lrs.getStatements(search).then(function (response) {
	                        if (response.statements.length > 0) {
	                            currentCompleteResult = response.statements[0];
	                            if (typeof result.score !== 'undefined' && result.score.raw > currentCompleteResult.result.score.raw) {
	                                voidCompleteStatement();
	                            } else {
	                                //Don't send new record
	                            }
	                        } else {
	                            sendCompleteStatement();
	                        }
	                    }).catch(function (error) {
	                        sendCompleteStatement();
	                    });
	                }
	
	                //VOID COMPLETE STATEMENT
	                function voidCompleteStatement() {
	                    var stmt = new lrs.Statement(new lrs.Agent(actor, actor.name), lrs.Verbs.voided, new lrs.StatementRef(currentCompleteResult.id));
	
	                    lrs.sendStatement(stmt).then(function (response) {
	                        sendCompleteStatement();
	                    }).catch(function (error) {
	                        sendCompleteStatement();
	                    });
	                }
	
	                //SEND COMPLETE STATEMENT
	                function sendCompleteStatement() {
	                    var stmt = new lrs.Statement(new lrs.Agent(actor, actor.name), lrs.Verbs.completed, new lrs.Activity(lrs.settings.activity.id, lrs.settings.activity.name, lrs.settings.activity.description, xAPIConstants.MODULE_ACTIVITY_TYPE));
	                    stmt.generateId();
	                    stmt.result = result;
	
	                    var group = {
	                        id: '' + lrs.settings.project.id,
	                        objectType: 'Activity',
	                        definition: {
	                            name: {
	                                en: lrs.settings.project.name
	                            },
	                            type: xAPIConstants.PROJECT_ACTIVITY_TYPE
	                        }
	                    };
	                    stmt = lrs.addGroupingActivity(stmt, group);
	
	                    var categoryObj = {
	                        id: xAPIConstants.ACTIVITY_URL_ID + '/' + xAPIConstants.EXPERIENCE_CODE,
	                        objectType: 'Activity',
	                        definition: {
	                            name: {
	                                en: xAPIConstants.EXPERIENC_LABEL
	                            },
	                            type: xAPIConstants.MODULE_ACTIVITY_TYPE
	                        }
	                    };
	                    stmt = lrs.addCategoryActivity(stmt, categoryObj);
	
	                    lrs.sendStatement(stmt).then(function (response) {
	                        resolve(result);
	                    }).catch(function (error) {
	                        reject(error);
	                    });
	                }
	
	                //SEND KPI RESULTS
	                function sendKpiResults() {
	                    _lodash2.default.forEach(bites, function (bite) {
	                        if (appHelper.isDefined(bite.kpis) && bite.kpis.length > 0) {
	                            _lodash2.default.forEach(bite.kpis, function (kpi) {
	                                checkKpiCompleteRecord(bite, kpi);
	                            });
	                        }
	                    });
	                }
	
	                function checkKpiCompleteRecord(bite, kpi) {
	                    var biteData = appHelper.getArrayObjectByKey(contentData.experience.bites, "bite_id", bite.bite_id);
	                    var score_kpi = biteData.score_kpi;
	                    var performance_kpis = biteData.performance_kpis;
	                    var targetKpi = {};
	                    if (appHelper.isDefined(score_kpi.kpi_id) && kpi.kpi_id === score_kpi.kpi_id) {
	                        targetKpi = Object.assign({}, score_kpi);
	                    } else {
	                        _lodash2.default.forEach(performance_kpis, function (p_kpi) {
	                            if (kpi.kpi_id === p_kpi.kpi_id) {
	                                targetKpi = Object.assign({}, p_kpi);
	                            }
	                        });
	                    }
	
	                    if (appHelper.isDefined(targetKpi.kpi_id)) {
	                        var kpiLocale = appHelper.getLocalData(targetKpi);
	                        var id = lrs.settings.activity.id + '/bite_id:' + bite.bite_id + '/kpi_id:' + targetKpi.kpi_id;
	                        var search = lrs.searchParams();
	                        search['verb'] = lrs.Verbs.scored.id;
	                        search['activity'] = id;
	                        search['agent'] = new lrs.Agent(actor, actor.name);
	                        search['limit'] = 1;
	
	                        lrs.getStatements(search).then(function (response) {
	                            if (response.statements.length === 0) {
	                                sendKpiCompleteStatement(targetKpi, kpiLocale, id, kpi.current.toFixed(targetKpi.decimal_points), bite.bite_id);
	                            }
	                        }).catch(function (error) {
	                            sendKpiCompleteStatement();
	                        });
	                    }
	                }
	
	                function sendKpiCompleteStatement(targetKpi, kpiLocale, id, current, bite_id) {
	                    if (appHelper.isDefined(targetKpi)) {
	                        var bite = appHelper.getBiteById(bite_id);
	                        var rawScore = dataHelper.getRangePercentage(targetKpi.min, targetKpi.max, current);
	
	                        var scoreObj = {
	                            scaled: rawScore / 100,
	                            raw: parseFloat(current),
	                            min: targetKpi.min,
	                            max: targetKpi.max
	                        };
	
	                        var _result = {
	                            completion: true,
	                            success: true,
	                            score: scoreObj
	                            //response: "KPI Score"
	                        };
	
	                        var _actor = JSON.parse(lrs.lrs.actor);
	                        var stmt = new lrs.Statement(new lrs.Agent(_actor, _actor.name), lrs.Verbs.scored, new lrs.Activity(id, kpiLocale.long_title, kpiLocale.description, xAPIConstants.OBJECTIVE_ACTIVITY_TYPE));
	
	                        stmt.result = _result;
	
	                        //console.log(stmt);
	
	                        stmt.generateId();
	
	                        stmt = lrs.generateRegistration(stmt);
	
	                        var parent = {
	                            id: lrs.settings.activity.id + '/bite_id:' + bite.bite_id,
	                            objectType: 'Activity',
	                            definition: {
	                                name: {
	                                    en: appHelper.getLocalData(bite).title
	                                },
	                                type: xAPIConstants.SECTION_ACTIVITY_TYPE
	                            }
	                        };
	                        stmt = lrs.addParentActivity(stmt, parent);
	
	                        var moduleParent = {
	                            id: lrs.settings.activity.id,
	                            objectType: 'Activity',
	                            definition: {
	                                name: {
	                                    en: lrs.settings.activity.name
	                                },
	                                type: xAPIConstants.MODULE_ACTIVITY_TYPE
	                            }
	                        };
	                        stmt.context.contextActivities.parent.push(moduleParent);
	
	                        var categoryObj = {
	                            id: xAPIConstants.ACTIVITY_URL_ID + '/' + xAPIConstants.KPI_CODE,
	                            objectType: 'Activity',
	                            definition: {
	                                name: {
	                                    en: xAPIConstants.KPI_LABEL
	                                },
	                                type: xAPIConstants.OBJECTIVE_ACTIVITY_TYPE
	                            }
	                        };
	                        stmt = lrs.addCategoryActivity(stmt, categoryObj);
	
	                        lrs.sendStatement(stmt).then(function (response) {
	                            resolve(stmt);
	                        }).catch(function (error) {
	                            reject(error);
	                        });
	                    }
	                }
	
	                sendKpiResults();
	
	                setResult();
	                resolve(true);
	            });
	        }
	    }, {
	        key: 'postActvityStatement',
	        value: function postActvityStatement(screen, interactionData, category, voidCompleteRecords, lrs) {
	            return new Promise(function (resolve, reject) {
	
	                var user = {
	                    account: {
	                        name: lrs.settings.student.id,
	                        homePage: lrs.settings.student.homePage
	                    }
	                };
	
	                var actor = JSON.parse(lrs.lrs.actor);
	
	                var screen_id = screen.screen_id;
	                var screenLocale = appHelper.getLocalData(screen);
	                var screenTitle = screenLocale.title;
	                var parentScreen = appHelper.geScreenParentDetails(screen_id);
	                var bite_id = appHelper.getBiteByScreenId(screen_id);
	                var bite = appHelper.getBiteById(bite_id);
	
	                var id = lrs.settings.activity.id + '/bite_id:' + bite_id + '/screen_id:' + screen.screen_id;
	                if (typeof parentScreen !== 'undefined') {
	                    id = lrs.settings.activity.id + '/bite_id:' + bite_id + '/screen_id:' + parentScreen.screen_id + '/sub_screen_id:' + screen.screen_id;
	                }
	
	                var stmt = new lrs.Statement(new lrs.Agent(actor, actor.name), lrs.Verbs.answered, new lrs.Activity(id, lrs.settings.activity.name, lrs.settings.activity.description, xAPIConstants.QUESTION_ACTIVITY_TYPE));
	                stmt.result = interactionData.result;
	                stmt.object = Object.assign({}, interactionData.object, {
	                    id: stmt.object.id + '/' + interactionData.object.id
	                });
	
	                stmt.generateId();
	
	                /*let parent =  {
	                    id:id,
	                    objectType: 'Activity',
	                    definition: {
	                        name: {
	                            en: screenTitle
	                        },
	                        type: xAPIConstants.PAGE_ACTIVITY_TYPE
	                    }
	                };
	                stmt = lrs.addParentActivity(stmt, parent);
	                 if(typeof parentScreen !== 'undefined'){
	                    let parentScreenLocale = appHelper.getLocalData(parentScreen);
	                    let sub_screen_parent =  {
	                        id:`${lrs.settings.activity.id}/bite_id:${bite_id}/screen_id:${parentScreen.screen_id}`,
	                        objectType: `Activity`,
	                        definition: {
	                            name: {
	                                en: parentScreenLocale.title
	                            },
	                            type: xAPIConstants.PAGE_ACTIVITY_TYPE
	                         }
	                    };
	                    stmt.context.contextActivities.parent.push(sub_screen_parent);
	                }
	                 let biteParent =  {
	                    id:`${lrs.settings.activity.id}/bite_id:${bite_id}`,
	                    objectType: 'Activity',
	                    definition: {
	                        name: {
	                            en: bite.en.title
	                        },
	                        type: xAPIConstants.SECTION_ACTIVITY_TYPE
	                    }
	                };
	                stmt.context.contextActivities.parent.push(biteParent);
	                 let moduleParent =  {
	                    id: lrs.settings.activity.id,
	                    objectType: 'Activity',
	                    definition: {
	                        name: {
	                            en: lrs.settings.activity.name
	                        },
	                        type: xAPIConstants.MODULE_ACTIVITY_TYPE
	                    }
	                };
	                stmt.context.contextActivities.parent.push(moduleParent);*/
	
	                var moduleParent = {
	                    id: lrs.settings.activity.id,
	                    objectType: 'Activity',
	                    definition: {
	                        name: {
	                            en: lrs.settings.activity.name
	                        },
	                        type: xAPIConstants.MODULE_ACTIVITY_TYPE
	                    }
	                };
	                stmt = lrs.addParentActivity(stmt, moduleParent);
	
	                var categoryObj = {
	                    id: xAPIConstants.ACTIVITY_URL_ID + '/' + category.constant,
	                    objectType: 'Activity',
	                    definition: {
	                        name: {
	                            en: category.label
	                        },
	                        type: xAPIConstants.QUESTION_ACTIVITY_TYPE
	                    }
	                };
	
	                stmt = lrs.addCategoryActivity(stmt, categoryObj);
	                stmt = lrs.generateRegistration(stmt);
	
	                if (appHelper.isDefined(voidCompleteRecords) && voidCompleteRecords) {
	                    checkCompleteRecord();
	                } else {
	
	                    sendCompleteStatement();
	                }
	
	                function checkCompleteRecord() {
	
	                    var search = lrs.searchParams();
	                    search['verb'] = lrs.Verbs.answered.id;
	                    search['activity'] = stmt.object.id;
	                    search['agent'] = new lrs.Agent(actor, actor.name);
	                    search['limit'] = 1;
	
	                    lrs.getStatements(search).then(function (response) {
	                        if (response.statements.length > 0) {
	                            var currentCompleteResult = response.statements[0];
	                            voidCompleteStatement(currentCompleteResult);
	                        } else {
	                            sendCompleteStatement();
	                        }
	                    }).catch(function (error) {
	                        sendCompleteStatement();
	                    });
	                }
	
	                //VOID COMPLETE STATEMENT
	                function voidCompleteStatement(currentCompleteResult) {
	                    var new_stmt = new lrs.Statement(new lrs.Agent(actor, actor.name), lrs.Verbs.voided, new lrs.StatementRef(currentCompleteResult.id));
	
	                    lrs.sendStatement(new_stmt).then(function (response) {
	                        sendCompleteStatement();
	                    }).catch(function (error) {
	
	                        sendCompleteStatement();
	                    });
	                }
	
	                function sendCompleteStatement() {
	                    lrs.sendStatement(stmt).then(function (response) {
	                        resolve(stmt);
	                    }).catch(function (error) {
	                        reject(error);
	                    });
	
	                    resolve(stmt);
	                }
	            });
	        }
	    }, {
	        key: 'getActivityStatement',
	        value: function getActivityStatement(interactionData, lrs) {
	            return new Promise(function (resolve, reject) {
	                var user = {
	                    account: {
	                        name: lrs.settings.student.id,
	                        homePage: lrs.settings.student.homePage
	                    }
	                };
	
	                var actor = JSON.parse(lrs.lrs.actor);
	
	                var search = lrs.searchParams();
	                search['verb'] = lrs.Verbs.answered.id;
	                search['activity'] = lrs.settings.activity.id + '/' + interactionData.activityId;
	                search['agent'] = new lrs.Agent(actor, actor.name);
	                search['limit'] = 1;
	
	                lrs.getStatements(search).then(function (response) {
	                    resolve(Object.assign({}, interactionData, {
	                        statement: response.statements[0]
	                    }));
	                }).catch(function (error) {
	                    reject(error);
	                });
	            });
	        }
	    }, {
	        key: 'setScreenAccessed',
	        value: function setScreenAccessed(screen, parentScreen, bite, lrs) {
	            return new Promise(function (resolve, reject) {
	                var user = {
	                    account: {
	                        name: lrs.settings.student.id,
	                        homePage: lrs.settings.student.homePage
	                    }
	                };
	
	                var result = {
	                    completion: true
	                    //success: true,
	                    //response: "Screen Accessed"
	                };
	
	                var actor = JSON.parse(lrs.lrs.actor);
	                var screenLocale = appHelper.getLocalData(screen);
	
	                var id = lrs.settings.activity.id + '/bite_id:' + bite.bite_id + '/screen_id:' + screen.screen_id;
	                if (typeof parentScreen !== 'undefined') {
	                    id = lrs.settings.activity.id + '/bite_id:' + bite.bite_id + '/screen_id:' + parentScreen.screen_id + '/sub_screen_id:' + screen.screen_id;
	                }
	
	                var stmt = new lrs.Statement(new lrs.Agent(actor, actor.name), lrs.Verbs.progressed, new lrs.Activity(id, screenLocale.title, lrs.settings.activity.description, xAPIConstants.PAGE_ACTIVITY_TYPE));
	
	                stmt.result = result;
	                stmt.generateId();
	
	                var parent = {
	                    id: lrs.settings.activity.id + '/bite_id:' + bite.bite_id,
	                    objectType: 'Activity',
	                    definition: {
	                        name: {
	                            en: appHelper.getLocalData(bite).title
	                        },
	                        type: xAPIConstants.SECTION_ACTIVITY_TYPE
	                    }
	                };
	
	                var moduleParent = {
	                    id: lrs.settings.activity.id,
	                    objectType: 'Activity',
	                    definition: {
	                        name: {
	                            en: lrs.settings.activity.name
	                        },
	                        type: xAPIConstants.MODULE_ACTIVITY_TYPE
	                    }
	                };
	                stmt.context.contextActivities.parent.push(moduleParent);
	
	                var categoryObj = {
	                    id: xAPIConstants.ACTIVITY_URL_ID + '/' + xAPIConstants.SCREEN_CODE,
	                    objectType: 'Activity',
	                    definition: {
	                        name: {
	                            en: xAPIConstants.SCREEN_LABEL
	                        },
	                        type: xAPIConstants.PAGE_ACTIVITY_TYPE
	                    }
	                };
	
	                if (typeof parentScreen !== 'undefined') {
	                    var parentScreenLocale = appHelper.getLocalData(parentScreen);
	                    parent = {
	                        id: lrs.settings.activity.id + '/bite_id:' + bite.bite_id + '/screen_id:' + parentScreen.screen_id,
	                        objectType: 'Activity',
	                        definition: {
	                            name: {
	                                en: parentScreenLocale.title
	                            }
	                        }
	                    };
	
	                    categoryObj = {
	                        id: xAPIConstants.ACTIVITY_URL_ID + '/' + xAPIConstants.SUB_SCREEN_CODE,
	                        objectType: 'Activity',
	                        definition: {
	                            name: {
	                                en: xAPIConstants.SUB_SCREEN_LABEL
	                            },
	                            type: xAPIConstants.PAGE_ACTIVITY_TYPE
	                        }
	                    };
	                }
	                stmt = lrs.addParentActivity(stmt, parent);
	                stmt = lrs.addCategoryActivity(stmt, categoryObj);
	
	                lrs.sendStatement(stmt).then(function (response) {
	                    resolve(stmt);
	                }).catch(function (error) {
	                    reject(error);
	                });
	
	                resolve(stmt);
	            });
	        }
	    }, {
	        key: 'setScreenComplete',
	        value: function setScreenComplete(screen, parentScreen, bite, lrs) {
	            return new Promise(function (resolve, reject) {
	                var user = {
	                    account: {
	                        name: lrs.settings.student.id,
	                        homePage: lrs.settings.student.homePage
	                    }
	                };
	
	                var result = {
	                    completion: true
	                    //success: true,
	                    //response: "Screen Completed"
	                };
	
	                var actor = JSON.parse(lrs.lrs.actor);
	                var screenLocale = appHelper.getLocalData(screen);
	
	                var id = lrs.settings.activity.id + '/bite_id:' + bite.bite_id + '/screen_id:' + screen.screen_id;
	                if (typeof parentScreen !== 'undefined') {
	                    id = lrs.settings.activity.id + '/bite_id:' + bite.bite_id + '/screen_id:' + parentScreen.screen_id + '/sub_screen_id:' + screen.screen_id;
	                }
	
	                var stmt = new lrs.Statement(new lrs.Agent(actor, actor.name), lrs.Verbs.completed, new lrs.Activity(id, screenLocale.title, lrs.settings.activity.description, xAPIConstants.PAGE_ACTIVITY_TYPE));
	
	                checkCompleteRecord();
	
	                function checkCompleteRecord() {
	                    var search = lrs.searchParams();
	                    search['verb'] = lrs.Verbs.completed.id;
	                    search['activity'] = id;
	                    search['agent'] = new lrs.Agent(actor, actor.name);
	                    search['limit'] = 1;
	
	                    lrs.getStatements(search).then(function (response) {
	                        if (response.statements.length === 0) {
	                            sendCompleteStatement();
	                        } else {
	                            //console.log(`${id} has already been marked complete`);
	                        }
	                    }).catch(function (error) {
	                        sendCompleteStatement();
	                    });
	                }
	
	                function sendCompleteStatement() {
	
	                    stmt.result = result;
	
	                    var parent = {
	                        id: lrs.settings.activity.id + '/bite_id:' + bite.bite_id,
	                        objectType: 'Activity',
	                        definition: {
	                            name: {
	                                en: appHelper.getLocalData(bite).title
	                            },
	                            type: xAPIConstants.SECTION_ACTIVITY_TYPE
	                        }
	                    };
	
	                    var categoryObj = {
	                        id: xAPIConstants.ACTIVITY_URL_ID + '/' + xAPIConstants.SCREEN_CODE,
	                        objectType: 'Activity',
	                        definition: {
	                            name: {
	                                en: xAPIConstants.SCREEN_LABEL
	                            },
	                            type: xAPIConstants.PAGE_ACTIVITY_TYPE
	                        }
	                    };
	
	                    if (typeof parentScreen !== 'undefined') {
	                        var parentScreenLocale = appHelper.getLocalData(parentScreen);
	                        parent = {
	                            id: lrs.settings.activity.id + '/bite_id:' + bite.bite_id + '/screen_id:' + parentScreen.screen_id,
	                            objectType: 'Activity',
	                            definition: {
	                                name: {
	                                    en: parentScreenLocale.title
	                                },
	                                type: xAPIConstants.PAGE_ACTIVITY_TYPE
	                            }
	                        };
	                        categoryObj = {
	                            id: xAPIConstants.ACTIVITY_URL_ID + '/' + xAPIConstants.SUB_SCREEN_CODE,
	                            objectType: 'Activity',
	                            definition: {
	                                name: {
	                                    en: xAPIConstants.SUB_SCREEN_LABEL
	                                },
	                                type: xAPIConstants.PAGE_ACTIVITY_TYPE
	                            }
	                        };
	                    }
	
	                    stmt.generateId();
	                    stmt = lrs.addParentActivity(stmt, parent);
	                    stmt = lrs.addCategoryActivity(stmt, categoryObj);
	
	                    if (typeof parentScreen !== 'undefined') {
	                        var biteParent = {
	                            id: lrs.settings.activity.id + '/bite_id:' + bite.bite_id,
	                            objectType: 'Activity',
	                            definition: {
	                                name: {
	                                    en: appHelper.getLocalData(bite).title
	                                },
	                                type: xAPIConstants.SECTION_ACTIVITY_TYPE
	                            }
	                        };
	                        stmt.context.contextActivities.parent.push(biteParent);
	                    }
	
	                    var moduleParent = {
	                        id: lrs.settings.activity.id,
	                        objectType: 'Activity',
	                        definition: {
	                            name: {
	                                en: lrs.settings.activity.name
	                            },
	                            type: xAPIConstants.MODULE_ACTIVITY_TYPE
	                        }
	                    };
	                    stmt.context.contextActivities.parent.push(moduleParent);
	
	                    lrs.sendStatement(stmt).then(function (response) {
	                        resolve(stmt);
	                    }).catch(function (error) {
	                        reject(error);
	                    });
	                }
	
	                resolve(stmt);
	            });
	        }
	    }, {
	        key: 'setBadgeStatement',
	        value: function setBadgeStatement(badge, bite_id, lrs) {
	            return new Promise(function (resolve, reject) {
	                var user = {
	                    account: {
	                        name: lrs.settings.student.id,
	                        homePage: lrs.settings.student.homePage
	                    }
	                };
	
	                var result = {
	                    completion: true
	                    //success: true,
	                    //response: "Badge Collected"
	                };
	
	                var actor = JSON.parse(lrs.lrs.actor);
	                var id = lrs.settings.activity.id + '/bite_id:' + bite_id + '/badge_id:' + badge.badge_id;
	                var badgeLocale = appHelper.getLocalData(badge);
	                var bite = appHelper.getBiteById(bite_id);
	                var currentCompleteResult = {};
	
	                //CHECK FOR A COMPLETE RECORD
	                function checkCompleteRecord() {
	                    //console.log('checkCompleteRecord');
	                    var search = lrs.searchParams();
	                    search['verb'] = lrs.Verbs.earned.id;
	                    search['activity'] = id;
	                    search['agent'] = new lrs.Agent(actor, actor.name);
	                    search['limit'] = 1;
	
	                    lrs.getStatements(search).then(function (response) {
	                        if (response.statements.length === 0) {
	                            sendCompleteStatement();
	                        }
	                    }).catch(function (error) {
	                        sendCompleteStatement();
	                    });
	                }
	
	                //SEND COMPLETE STATEMENT
	                function sendCompleteStatement() {
	                    var stmt = new lrs.Statement(new lrs.Agent(actor, actor.name), lrs.Verbs.earned, new lrs.Activity(id, badgeLocale.long_title, badgeLocale.description, xAPIConstants.BADGE_ACTIVITY_TYPE));
	
	                    stmt.result = result;
	
	                    stmt.generateId();
	
	                    var parent = {
	                        id: lrs.settings.activity.id + '/bite_id:' + bite_id,
	                        objectType: 'Activity',
	                        definition: {
	                            name: {
	                                en: appHelper.getLocalData(bite).title
	                            },
	                            type: xAPIConstants.SECTION_ACTIVITY_TYPE
	                        }
	                    };
	                    stmt = lrs.addParentActivity(stmt, parent);
	
	                    var moduleParent = {
	                        id: lrs.settings.activity.id,
	                        objectType: 'Activity',
	                        definition: {
	                            name: {
	                                en: lrs.settings.activity.name
	                            },
	                            type: xAPIConstants.MODULE_ACTIVITY_TYPE
	                        }
	                    };
	                    stmt.context.contextActivities.parent.push(moduleParent);
	
	                    var categoryObj = {
	                        id: xAPIConstants.ACTIVITY_URL_ID + '/' + xAPIConstants.BADGE_CODE,
	                        objectType: 'Activity',
	                        definition: {
	                            name: {
	                                en: xAPIConstants.BADGE_LABEL
	                            },
	                            type: xAPIConstants.BADGE_ACTIVITY_TYPE
	                        }
	                    };
	                    stmt = lrs.addCategoryActivity(stmt, categoryObj);
	
	                    lrs.sendStatement(stmt).then(function (response) {
	                        resolve(stmt);
	                    }).catch(function (error) {
	                        reject(error);
	                    });
	                }
	
	                checkCompleteRecord();
	
	                resolve(true);
	            });
	        }
	    }, {
	        key: 'setBiteProgressStatus',
	        value: function setBiteProgressStatus(bite, biteStatus, userDataBite, parentScreen, lrs) {
	            return new Promise(function (resolve, reject) {
	                var user = {
	                    account: {
	                        name: lrs.settings.student.id,
	                        homePage: lrs.settings.student.homePage
	                    }
	                };
	
	                var actor = JSON.parse(lrs.lrs.actor);
	                var id = lrs.settings.activity.id + '/bite_id:' + bite.bite_id;
	                var biteLocale = appHelper.getLocalData(bite).title;
	
	                var result = {
	                    completion: true
	                    //success: true,
	                    //response: "Bite Accessed"
	                };
	
	                function checkProgessRecord() {
	                    //console.log('checkProgessRecord');
	                    var search = lrs.searchParams();
	                    search['verb'] = lrs.Verbs.progressed.id;
	                    search['activity'] = id;
	                    search['agent'] = new lrs.Agent(actor, actor.name);
	                    search['limit'] = 1;
	
	                    lrs.getStatements(search).then(function (response) {
	                        if (response.statements.length === 0) {
	                            sendProgressRecord();
	                        } else {
	                            //console.log(`${id} has already been marked complete`);
	                        }
	                    }).catch(function (error) {
	                        sendProgressRecord();
	                    });
	                }
	
	                function sendProgressRecord() {
	                    //console.log('sendProgressRecord');
	                    var stmt = new lrs.Statement(new lrs.Agent(actor, actor.name), lrs.Verbs.progressed, new lrs.Activity(id, biteLocale, lrs.settings.activity.description, xAPIConstants.SECTION_ACTIVITY_TYPE));
	
	                    stmt.result = result;
	
	                    stmt.generateId();
	                    var parent = {
	                        id: lrs.settings.activity.id,
	                        objectType: 'Activity',
	                        definition: {
	                            name: {
	                                en: lrs.settings.activity.name
	                            },
	                            type: xAPIConstants.MODULE_ACTIVITY_TYPE
	                        }
	                    };
	                    stmt = lrs.addParentActivity(stmt, parent);
	
	                    var categoryObj = {
	                        id: xAPIConstants.ACTIVITY_URL_ID + '/' + xAPIConstants.BITE_CODE,
	                        objectType: 'Activity',
	                        definition: {
	                            name: {
	                                en: xAPIConstants.BITE_LABEL
	                            },
	                            type: xAPIConstants.SECTION_ACTIVITY_TYPE
	                        }
	                    };
	                    stmt = lrs.addCategoryActivity(stmt, categoryObj);
	
	                    lrs.sendStatement(stmt).then(function (response) {
	                        resolve(stmt);
	                    }).catch(function (error) {
	                        reject(error);
	                    });
	                }
	                if (!appHelper.isDefined(parentScreen)) {
	                    if (biteStatus == objectConstants.STATUS_IN_PROGRESS) {
	                        checkProgessRecord();
	                    }
	                }
	
	                resolve(true);
	            });
	        }
	    }, {
	        key: 'setBiteCompleteStatus',
	        value: function setBiteCompleteStatus(bite, biteStatus, userDataBite, parentScreen, lrs) {
	            return new Promise(function (resolve, reject) {
	                var user = {
	                    account: {
	                        name: lrs.settings.student.id,
	                        homePage: lrs.settings.student.homePage
	                    }
	                };
	
	                var actor = JSON.parse(lrs.lrs.actor);
	                var id = lrs.settings.activity.id + '/bite_id:' + bite.bite_id;
	                var biteLocale = appHelper.getLocalData(bite).title;
	                var result = {};
	                var currentCompleteResult = {};
	
	                //SET RESULT
	                function setResult() {
	
	                    //console.log('setResult');
	                    var scores = [];
	                    var totalScore = 0;
	                    var avgScore = 0;
	                    var scoreScaled = 0;
	                    var scoreMax = 100;
	                    var scoreMin = 0;
	
	                    var totalweight = 0;
	
	                    var primaryKpi = appHelper.getArrayObjectByKey(userDataBite.kpis, "is_primary", true);
	                    if (appHelper.isDefined(primaryKpi)) {
	                        var score = dataHelper.getRangePercentage(primaryKpi.min, primaryKpi.max, primaryKpi.current);
	                        if (isNaN(score)) {
	                            score = scormConstants.CMI_CORE_SCORE_MAX_DEFAULT;
	                        }
	
	                        var weightedScore = score * userDataBite.weight;
	
	                        scores.push(weightedScore);
	                        totalScore += weightedScore;
	                        totalweight += userDataBite.weight;
	                    }
	
	                    avgScore = totalScore / totalweight;
	                    scoreScaled = new Number(avgScore / scoreMax);
	                    if (avgScore >= 0) {
	                        var scoreObj = {
	                            scaled: scoreScaled,
	                            raw: avgScore,
	                            min: scoreMin,
	                            max: scoreMax
	                        };
	
	                        result = {
	                            completion: true,
	                            success: true,
	                            score: scoreObj
	                            //response: 'Bite Complete'
	                        };
	                    } else {
	                        result = {
	                            completion: true
	                            //success: true,
	                            //response: "Bite Complete"
	                        };
	                    }
	                    checkCompleteRecord();
	                }
	
	                //CHECK FOR A COMPLETE RECORD
	                function checkCompleteRecord() {
	                    //console.log('checkCompleteRecord');
	                    var search = lrs.searchParams();
	                    search['verb'] = lrs.Verbs.completed.id;
	                    search['activity'] = id;
	                    search['agent'] = new lrs.Agent(actor, actor.name);
	                    search['limit'] = 1;
	
	                    lrs.getStatements(search).then(function (response) {
	                        if (response.statements.length > 0) {
	                            currentCompleteResult = response.statements[0];
	                            if (typeof result.score !== 'undefined' && result.score.raw > currentCompleteResult.result.score.raw) {
	                                voidCompleteStatement();
	                            } else {
	                                //Don't send new record
	                            }
	                        } else {
	                            sendCompleteStatement();
	                        }
	                    }).catch(function (error) {
	                        sendCompleteStatement();
	                    });
	                }
	
	                //VOID COMPLETE STATEMENT
	                function voidCompleteStatement() {
	                    //console.log('voidCompleteStatement');
	                    var stmt = new lrs.Statement(new lrs.Agent(actor, actor.name), lrs.Verbs.voided, new lrs.StatementRef(currentCompleteResult.id));
	
	                    lrs.sendStatement(stmt).then(function (response) {
	                        sendCompleteStatement();
	                    }).catch(function (error) {
	                        sendCompleteStatement();
	                    });
	                }
	
	                //SEND COMPLETE STATEMENT
	                function sendCompleteStatement() {
	                    //console.log('sendCompleteStatement');
	                    var stmt = new lrs.Statement(new lrs.Agent(actor, actor.name), lrs.Verbs.completed, new lrs.Activity(id, biteLocale, lrs.settings.activity.description, xAPIConstants.SECTION_ACTIVITY_TYPE));
	                    stmt.generateId();
	                    stmt.result = result;
	                    var parent = {
	                        id: lrs.settings.activity.id,
	                        objectType: 'Activity',
	                        definition: {
	                            name: {
	                                en: lrs.settings.activity.name
	                            },
	                            type: xAPIConstants.MODULE_ACTIVITY_TYPE
	                        }
	                    };
	                    stmt = lrs.addParentActivity(stmt, parent);
	
	                    var categoryObj = {
	                        id: xAPIConstants.ACTIVITY_URL_ID + '/' + xAPIConstants.BITE_CODE,
	                        objectType: 'Activity',
	                        definition: {
	                            name: {
	                                en: xAPIConstants.BITE_LABEL
	                            },
	                            type: xAPIConstants.SECTION_ACTIVITY_TYPE
	                        }
	                    };
	                    stmt = lrs.addCategoryActivity(stmt, categoryObj);
	
	                    lrs.sendStatement(stmt).then(function (response) {
	                        resolve(result);
	                    }).catch(function (error) {
	                        reject(error);
	                    });
	                }
	
	                if (!appHelper.isDefined(parentScreen)) {
	                    if (biteStatus == objectConstants.STATUS_COMPLETE) {
	                        setResult();
	                    }
	                }
	                resolve(true);
	            });
	        }
	    }]);
	
	    return xAPIService;
	}();
	
	exports.default = xAPIService;

/***/ },
/* 586 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = configureStore;
	
	var _redux = __webpack_require__(4);
	
	var _reducers = __webpack_require__(569);
	
	var _reducers2 = _interopRequireDefault(_reducers);
	
	var _reduxImmutableStateInvariant = __webpack_require__(1074);
	
	var _reduxImmutableStateInvariant2 = _interopRequireDefault(_reduxImmutableStateInvariant);
	
	var _reduxThunk = __webpack_require__(1077);
	
	var _reduxThunk2 = _interopRequireDefault(_reduxThunk);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function configureStore(initialState) {
	  return (0, _redux.createStore)(_reducers2.default, initialState, (0, _redux.applyMiddleware)(_reduxThunk2.default, (0, _reduxImmutableStateInvariant2.default)()));
	}

/***/ },
/* 587 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _appHelper = __webpack_require__(3);
	
	var appHelper = _interopRequireWildcard(_appHelper);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	window.OpenLearning = function () {
	    var _ol = void 0,
	        api = void 0,
	        events = void 0,
	        callbacks = void 0,
	        defaultOrigin = void 0,
	        triggerEvent = void 0,
	        messageQueue = void 0,
	        parent = void 0,
	        isReady = void 0,
	        readyData = void 0,
	        send = void 0,
	        sendMessage = void 0,
	        recv = void 0,
	        getHeight = void 0,
	        getParameter = void 0,
	        dataAPI = void 0,
	        resourceReadUpdate = void 0,
	        resourceLookupExec = void 0,
	        genId = void 0,
	        isArray = void 0,
	        init = void 0,
	        initRequestFunc = void 0,
	        isInitSent = void 0,
	        resizeInterval = void 0,
	        observer = void 0,
	        isObserving = void 0,
	        fromISOString = void 0;
	
	    // default origin to use if no origin parameter is passed to this app
	    defaultOrigin = '*';
	
	    parent = window.parent;
	    isReady = false;
	    events = {};
	    callbacks = {};
	    isInitSent = false;
	    isObserving = false;
	
	    messageQueue = [];
	
	    // called with response data from the parent frame
	    // when responding to an initialization message
	
	    init = function init(data) {
	        if (typeof data !== 'undefined') {
	            _ol.mode = data.mode || 'display';
	            _ol.theme = data.theme || {};
	            _ol.page = data.page || {};
	            _ol.user.data = data.userData || {};
	            _ol.setup.data = data.setupData || {};
	
	            // these need cleaning up
	            _ol.exhibitUser = data.exhibitUser || {}; // Profile data of the user we're looking at (focus pages) - horribly inconsistent between obj/str
	            _ol.exhibit = {};
	            _ol.exhibit.data = data.exhibit || {}; // this is only used for mazerunner at the moment
	            _ol.latestPosts = data.exhibitData.posts || {}; // latest post from person, split by collectionType
	
	            _ol.user.profile = data.profile || {};
	            _ol.user.group = data.group || null;
	            _ol.user.activeClass = data.activeClass || null;
	            _ol.user.timeLoaded = data.timeUserDataLoaded || null;
	            _ol.setup.timeLoaded = data.timeSetupDataLoaded || null;
	            _ol.course = data.course || {};
	            _ol.isSizeLocked = false;
	            // Unique instance identifier for this widget
	            _ol.deploymentId = data.deploymentId;
	
	            readyData = {
	                'theme': _ol.theme,
	                'user': _ol.user,
	                'setup': _ol.setup
	            };
	
	            // Trigger the setup for widgets
	            if (_ol.widgets) {
	                _ol.widgets.init();
	            }
	
	            // enable the window-resizing DOM watcher
	            _ol.enableWatcher();
	            // request a resize (set the window to the correct size)
	            _ol.resize();
	            // fire any read listeners
	            triggerEvent('ready', readyData);
	
	            // send any pending api calls
	            if (messageQueue) {
	                messageQueue.forEach(function (messageData) {
	                    sendMessage(messageData.message, messageData.callback);
	                });
	            }
	            messageQueue = null;
	        }
	    };
	
	    getHeight = function getHeight() {
	        // calculate the height of the app window
	        return Math.max(document.documentElement.scrollHeight || 0, document.body.scrollHeight || 0);
	    };
	
	    genId = function genId() {
	        // generate a unique ID based on the current time and a random number
	        var id = void 0,
	            gen = void 0;
	
	        gen = function gen() {
	            return new Date().getTime() + '' + Math.floor(Math.random() * 1000000);
	        };
	
	        do {
	            id = gen();
	        } while (callbacks[id]);
	
	        return id;
	    };
	
	    isArray = function isArray(value) {
	        return Object.prototype.toString.call(value) === '[object Array]';
	    };
	
	    getParameter = function getParameter(name, defaultValue) {
	        // get a query parameter by name (and an optional default value)
	        name = name.replace(/[\\[]/, "\\[").replace(/[\]]/, "\\]");
	        var results = new RegExp("[\\?&]" + name + "=([^&#]*)").exec(location.search);
	        return results == null ? defaultValue || '' : decodeURIComponent(results[1].replace(/\+/g, " "));
	    };
	
	    if ('toISOString' in new Date()) {
	        fromISOString = function fromISOString(isoString) {
	            return new Date(isoString);
	        };
	    } else {
	        fromISOString = function fromISOString(isoString) {
	            var d = void 0;
	            var matches = isoString && isoString.match(/^(\d{4})-(\d{2})-(\d{2})T(\d{2}):(\d{2}):(\d{2})(\.(\d{3}))?Z$/);
	            if (matches) {
	                d = new Date();
	                d.setUTCFullYear(matches[1], matches[2] - 1, matches[3]);
	                d.setUTCHours(matches[4], matches[5], matches[6], matches[8] || 0);
	            } else {
	                d = new Date(isoString);
	            }
	            return d;
	        };
	    }
	
	    // Called to trigger event listeners for a given eventName
	    triggerEvent = function triggerEvent(eventName, data, callback) {
	        var i = void 0,
	            handlers = void 0,
	            handler = void 0,
	            combinedCallback = void 0,
	            callbacksCountdown = void 0,
	            callbacksData = void 0;
	
	        handlers = events[eventName] || [];
	        callbacksCountdown = handlers.length;
	        callbacksData = [];
	
	        // Nothing registered to this callback, don't bother.
	        if (callbacksCountdown === 0) {
	            if (callback) callback(callbacksData);
	            return _ol;
	        }
	
	        combinedCallback = function combinedCallback(cbIndex) {
	            return function (cbData) {
	                callbacksData[cbIndex] = cbData;
	                callbacksCountdown--;
	                if (callbacksCountdown === 0) {
	                    if (callback) {
	                        callback(callbacksData);
	                    }
	                }
	            };
	        };
	
	        for (i = 0; i !== handlers.length; ++i) {
	            handler = handlers[i];
	
	            // Save handler doesn't handle callback... warn and call callback immediately
	            if (eventName === 'save' && handler.length !== 2) {
	                if (window.console) {
	                    console.warn("OL.on('save') handler does not specify callback argument. Please refer to docs on how to implement this.");
	                }
	
	                handler(data);
	                // Call the callback on it's behalf, for now.
	                combinedCallback(i);
	            } else {
	                handler(data, combinedCallback(i));
	            }
	        }
	
	        return _ol;
	    };
	
	    sendMessage = function sendMessage(message, callback) {
	        if (parent) {
	            parent.postMessage(JSON.stringify(message), _ol.targetDomain);
	        } else {
	            _ol.log('Unable to send ' + message.method + ' message. No parent document.');
	        }
	
	        if (callback) {
	            callbacks[message.id] = callback;
	        }
	    };
	
	    send = function send(method, data, callback) {
	        // send RPC message to the host frame
	        var message = {
	            'method': method,
	            'data': data || {},
	            'key': _ol.apiKey,
	            'sender': 'widget',
	            'id': genId()
	        };
	
	        if (method !== 'init' && !isReady) {
	            // API is not ready, queue this message until it's ready
	            messageQueue.push({
	                message: message,
	                callback: callback
	            });
	        } else {
	            sendMessage(message, callback);
	        }
	    };
	
	    recv = function recv(evt) {
	        // receive RPC message from host frame
	        var i = void 0,
	            message = void 0,
	            id = void 0,
	            result = void 0,
	            callback = void 0;
	
	        if (_ol.targetDomain && _ol.targetDomain !== "*" && evt.origin !== _ol.targetDomain) {
	            return;
	        }
	
	        try {
	            message = JSON.parse(evt.data);
	        } catch (err) {
	            _ol.log('Unrecognised message received: ' + evt.data + ' (' + err + ')');
	            return;
	        }
	
	        if (message.method === 'init') {
	            isReady = true;
	            init(message.data);
	        } else if (message.method === 'response') {
	            id = message.id;
	            result = message.result;
	            callback = callbacks[id];
	            if (callback) callback(result);
	            delete callbacks[id];
	        } else {
	            // Update 'latestPosts'
	            if (message.method === 'post-shared') {
	                _ol.latestPosts.share = message.data;
	            }
	
	            triggerEvent(message.method, message.data, function (cb_data) {
	                send('event-callback', {
	                    'event': message.method,
	                    'id': message.id,
	                    'data': cb_data
	                });
	            });
	        }
	    };
	
	    // The OpenLearning function accepts a function to call on ready
	    // otherwise it acts as a getter or setter
	    _ol = function ol() {
	        if (typeof arguments[0] === 'function') {
	            if (!isReady) {
	                _ol.on('ready', arguments[0]);
	            } else {
	                arguments[0](readyData);
	            }
	        } else if (typeof arguments[0] === 'string') {
	            if ({}.toString.call(_ol[arguments[0]]) === '[object Function]') {
	                // call the method given by string, e.g.
	                // OL('resize', height);
	                return _ol[arguments[0]].apply(_ol, Array.prototype.slice.call(arguments, 1));
	            } else if (typeof arguments[1] === 'undefined') {
	                // act as a getter
	                return _ol[arguments[0]];
	            } else {
	                throw new Error("Unknown way of invoking OL API.");
	            }
	        }
	        return _ol;
	    };
	
	    // cross-platform indexOf function
	    if (Array.prototype.indexOf) {
	        _ol.indexOf = function (arr, what, i) {
	            return arr.indexOf(what, i);
	        };
	    } else {
	        _ol.indexOf = function (arr, what, i) {
	            var len = arr.length;
	            i = i || 0;
	            while (i < len) {
	                if (arr[i] === what) return i;
	                ++i;
	            }
	            return -1;
	        };
	    }
	
	    // cross-platform String startsWith function
	    if (String.prototype.startsWith) {
	        _ol.startsWith = function (str, searchString, position) {
	            return str.startsWith(searchString, position);
	        };
	    } else {
	        _ol.startsWith = function (str, searchString, position) {
	            position = position || 0;
	            return str.indexOf(searchString, position) === position;
	        };
	    }
	
	    // Retrieve the API key from the query parameter or the subdomain
	    _ol.apiKey = getParameter('key', window.location.host.split('.')[0]);
	
	    // Retrieve the targetDomain origin from the query parameter, or use
	    // the default origin
	    _ol.targetDomain = getParameter('origin', defaultOrigin);
	
	    // Register an event listener for a given eventName
	    _ol.on = function (eventName, handler) {
	        if (!events[eventName]) {
	            send('registerEvent', {
	                'eventName': eventName
	            });
	        }
	
	        events[eventName] = events[eventName] || [];
	        events[eventName].push(handler);
	        return _ol;
	    };
	
	    // Deregister an event listener
	    _ol.off = function (eventName, handler) {
	        var handlers = void 0,
	            idx = void 0;
	
	        handlers = events[eventName] || [];
	
	        if (handler) {
	            while ((idx = _ol.indexOf(handlers, handler)) !== -1) {
	                handlers.splice(idx, 1);
	            }
	        } else {
	            handlers = [];
	        }
	
	        events[eventName] = handlers;
	        return _ol;
	    };
	
	    // Trigger a page event
	    _ol.trigger = function (eventName, data) {
	        send('trigger', {
	            'eventName': eventName,
	            'data': data
	        });
	        return _ol;
	    };
	
	    // Called to tell the parent frame to resize
	    // the app to a certain height (or calculate the height if not given)
	    // also accepts an optional lock parameter. If true, auto-resizing will
	    // be disabled until lock is set to false.
	    _ol.resize = function (height, lock) {
	        var wasObserving = isObserving;
	
	        if (typeof lock === 'boolean') {
	            _ol.isSizeLocked = lock;
	        }
	
	        if (isObserving) {
	            _ol.disableWatcher();
	        }
	
	        // Set a short delay before determining height
	        setTimeout(function () {
	            height = height || getHeight();
	
	            send('resize', {
	                'height': height
	            }, function () {
	                if (wasObserving) {
	                    _ol.enableWatcher();
	                }
	            });
	        }, 100);
	
	        return _ol;
	    };
	
	    // Called to reload an item on the parent-side
	    // called with 'self' to reload the app itself.
	    _ol.refresh = function (what) {
	        send('refresh', {
	            'what': what || 'self'
	        });
	        return _ol;
	    };
	
	    // Attach a file to the current page which situates the app
	    _ol.attachFile = function (filename, dataURI, overwrite, callback) {
	        var isUpload = false;
	        if (!dataURI) {
	            callback = overwrite;
	            overwrite = dataURI;
	            isUpload = true;
	        }
	
	        if (typeof overwrite === 'function') {
	            callback = overwrite;
	            overwrite = false;
	        }
	
	        if (isUpload) {
	            _ol.attachments.create(filename, './', overwrite, callback);
	        } else {
	            send('attachFile', {
	                'filename': filename,
	                'dataURI': dataURI,
	                'overwrite': overwrite
	            }, callback);
	        }
	
	        return _ol;
	    };
	
	    _ol.files = {};
	
	    _ol.files.create = function (files, callback) {
	        var i = void 0;
	        var filenames = [];
	        var isSingle = false;
	
	        if (files.constructor !== Array && files.constructor !== FileList) {
	            files = [files];
	            isSingle = true;
	        }
	
	        for (i = 0; i < files.length; i++) {
	            if (typeof files[i] === 'string') {
	                filenames.push(files[i]);
	            } else if (files[i].name) {
	                filenames.push(files[i].name);
	            }
	        }
	
	        send('createFiles', {
	            'filenames': filenames
	        }, function (result) {
	            if (isSingle) {
	                callback(result[0]);
	            } else {
	                callback(result);
	            }
	        });
	
	        return _ol;
	    };
	
	    _ol.files.finalizeUpload = function (fileData, callback) {
	        send('finalizeUpload', {
	            'storageKey': fileData.storageKey,
	            'options': fileData.options
	        }, function (result) {
	            callback(result);
	        });
	
	        return _ol;
	    };
	
	    _ol.files.getURLs = function (storageKeys, callback) {
	        send('getFileURLs', {
	            'storageKeys': storageKeys
	        }, function (result) {
	            callback(result);
	        });
	
	        return _ol;
	    };
	
	    _ol.pages = {};
	
	    _ol.pages.subPath = function (title) {
	        return _ol.page.path + '/' + (title || genId()).toLowerCase();
	    };
	
	    _ol.pages.siblingPath = function (title) {
	        var pathParts = _ol.page.path.split('/');
	        pathParts.pop();
	        return pathParts.join('/') + '/' + (title || genId()).toLowerCase();
	    };
	
	    _ol.pages.create = function (creationData, callback) {
	        if (typeof creationData === 'function') {
	            callback = creationData;
	            creationData = {};
	        }
	
	        send('createPage', creationData || {}, callback);
	
	        return _ol;
	    };
	
	    _ol.pages.view = function (pageID, callback) {
	        send('viewPage', {
	            'pageID': pageID
	        }, callback);
	
	        return _ol;
	    };
	
	    _ol.pages.edit = function (pageID, callback) {
	        send('editPage', {
	            'pageID': pageID
	        }, callback);
	
	        return _ol;
	    };
	
	    _ol.attachments = {};
	
	    // Create files and retrieve the upload URLs & paths
	    _ol.attachments.create = function (files, basePath, overwrite, callback) {
	        var i = void 0;
	        var filenames = [];
	        var isSingle = false;
	
	        if (files.constructor !== Array && files.constructor !== FileList) {
	            files = [files];
	            isSingle = true;
	        }
	
	        if (typeof overwrite === 'function') {
	            callback = overwrite;
	            overwrite = false;
	        }
	
	        if (typeof basePath === 'function' || !basePath) {
	            if (!callback) {
	                callback = basePath;
	            }
	            basePath = './';
	        }
	
	        for (i = 0; i < files.length; i++) {
	            if (typeof files[i] === 'string') {
	                filenames.push(files[i]);
	            } else if (files[i].name) {
	                filenames.push(files[i].name);
	            }
	        }
	
	        send('createAttachments', {
	            'filenames': filenames,
	            'basePath': basePath,
	            'overwrite': overwrite
	        }, function (result) {
	            if (isSingle) {
	                callback(result[0]);
	            } else {
	                callback(result);
	            }
	        });
	
	        return _ol;
	    };
	
	    // Create segmented uploads at an already created file path
	    _ol.attachments.createSegments = function (path, numSegments, callback) {
	        send('createAttachmentSegments', {
	            'path': path,
	            'numSegments': numSegments
	        }, callback);
	
	        return _ol;
	    };
	
	    // Finalize that segments have been uploaded and file can now be downloaded
	    _ol.attachments.finalizeSegments = function (path, callback) {
	        send('finalizeAttachmentSegments', {
	            'path': path
	        }, callback);
	
	        return _ol;
	    };
	
	    _ol.attachments.list = function (pattern, basePath, callback) {
	        if (typeof pattern === 'function') {
	            callback = pattern;
	            pattern = null;
	            basePath = './';
	        } else if (typeof basePath === 'function') {
	            callback = basePath;
	            basePath = './';
	        }
	
	        send('listAttachments', {
	            'basePath': basePath,
	            'pattern': pattern
	        }, callback);
	
	        return _ol;
	    };
	
	    // Ask the parent frame to pop up a notification bubble
	    _ol.notify = function (title, message, status) {
	        send('notify', {
	            'title': title,
	            'message': message,
	            'status': status || 'default'
	        });
	        return _ol;
	    };
	
	    // Get the roles of the current user in this context
	    _ol.getRoles = function (callback) {
	        send('getRoles', {}, callback);
	        return _ol;
	    };
	
	    // Extend the target object with properties from the arguments to the extend call
	    // e.g. to extend default options with more specific options
	    _ol.extend = function (target) {
	        for (var i = 1; i < arguments.length; i++) {
	            for (var prop in arguments[i]) {
	                if (arguments[i].hasOwnProperty(prop)) {
	                    target[prop] = arguments[i][prop];
	                }
	            }
	        }
	        return _ol;
	    };
	
	    resourceReadUpdate = function resourceReadUpdate(operation) {
	        return function (resource, id, method, args, callback) {
	            var data = {
	                'operation': operation,
	                'resource': resource,
	                'id': id
	            };
	
	            if (isArray(method)) {
	                data.methods = method;
	                callback = args;
	            } else {
	                data.method = method;
	                data.args = args;
	            }
	
	            send('resource', data, callback);
	            return _ol;
	        };
	    };
	
	    resourceLookupExec = function resourceLookupExec(operation) {
	        return function (resource, method, args, callback) {
	            var data = {
	                'operation': operation,
	                'resource': resource,
	                'method': method,
	                'args': args
	            };
	
	            send('resource', data, callback);
	            return _ol;
	        };
	    };
	
	    // Resource API
	    _ol.resource = {
	        'read': resourceReadUpdate('read'),
	        'update': resourceReadUpdate('update'),
	        'lookup': resourceLookupExec('lookup'),
	        'execute': resourceLookupExec('execute'),
	        'create': function create(resource, data, methods, callback) {
	            if (!isArray(methods)) {
	                callback = methods;
	            }
	
	            send('resource', {
	                'operation': 'create',
	                'resource': resource,
	                'data': data,
	                'methods': methods
	            }, callback);
	
	            return _ol;
	        },
	        'delete': function _delete(resource, id, callback) {
	            send('resource', {
	                'operation': 'delete',
	                'resource': resource,
	                'id': id
	            }, callback);
	
	            return _ol;
	        }
	    };
	
	    // Set the dirty flag (true if the state is a work-in-progress and
	    // hasn't been saved) for the app
	    _ol.setDirtyFlag = function (flag) {
	        send('setDirtyFlag', {
	            'dirtyFlag': flag
	        });
	        return _ol;
	    };
	
	    // Enable DOM watching to automatically call resize requests
	    _ol.enableWatcher = function () {
	        var MutationObserver = void 0;
	        MutationObserver = window.MutationObserver || window.WebKitMutationObserver;
	
	        if (isObserving || observer || resizeInterval) {
	            return;
	        }
	
	        isObserving = true;
	
	        if (MutationObserver) {
	            observer = new MutationObserver(function (mutations) {
	                var addLoadListener = void 0;
	
	                if (_ol.isSizeLocked) {
	                    return;
	                }
	
	                addLoadListener = function addLoadListener(element) {
	                    if (element.height === undefined || element.width === undefined || 0 === element.height || 0 === element.width) {
	                        window.addEventListener(element, 'load', function imageLoaded() {
	                            if (!_ol.isSizeLocked) {
	                                _ol.resize();
	                            }
	                        });
	                    }
	                };
	
	                mutations.forEach(function (mutation) {
	                    if (mutation.type === 'attributes' && mutation.attributeName === 'src') {
	                        addLoadListener(mutation.target);
	                    } else if (mutation.type === 'childList') {
	                        var images = mutation.target.querySelectorAll('img');
	                        Array.prototype.forEach.call(images, function (image) {
	                            addLoadListener(image);
	                        });
	                    }
	                });
	
	                _ol.resize();
	            });
	
	            observer.observe(document.querySelector('body'), {
	                attributes: true,
	                attributeOldValue: false,
	                characterData: true,
	                characterDataOldValue: false,
	                childList: true,
	                subtree: true
	            });
	        } else {
	            resizeInterval = setInterval(function () {
	                if (!_ol.isSizeLocked) {
	                    _ol.resize();
	                }
	            }, 200);
	        }
	    };
	
	    // Disable DOM watching
	    _ol.disableWatcher = function () {
	        if (observer) {
	            observer.disconnect();
	            observer = null;
	        }
	        if (resizeInterval) {
	            clearInterval(resizeInterval);
	            resizeInterval = null;
	        }
	
	        isObserving = false;
	    };
	
	    // Build a data API for different data sources
	    dataAPI = function dataAPI(dataSrc, name) {
	        var callbackWrapper = void 0;
	
	        callbackWrapper = function callbackWrapper(callback) {
	            return function (result) {
	                if (result.success && result.timeLoaded && result.timeLoaded > _ol[name].timeLoaded) {
	                    _ol[name].timeLoaded = result.timeLoaded;
	
	                    if (result.data) {
	                        _ol[name].data = result.data;
	                    }
	                }
	                if (callback) callback(result);
	            };
	        };
	
	        return {
	            // Merge the given updates with the current state
	            // (performs a 3-way merge with the revision at load time,
	            //  the latest data, and the new updates)
	            merge: function merge(updates, callback, showModal) {
	                send('merge' + dataSrc, {
	                    updates: updates,
	                    timeLoaded: _ol[name].timeLoaded,
	                    showModal: showModal
	                }, callbackWrapper(callback));
	                return _ol;
	            },
	
	            // Replace old data with the new data, regardless of what
	            // changes have been made since load
	            replace: function replace(newData, callback) {
	                send('replace' + dataSrc, {
	                    newData: newData
	                }, callbackWrapper(callback));
	                return _ol;
	            },
	
	            // Perform an update operation
	            // Operations such as: 'inc', 'push', 'addtoset', 'set'
	            //    e.g. to increment 'myField' by 1:
	            //    OL.update({'myField': 1}, 'inc', function(result) { ... });
	            update: function update(updates, operation, callback) {
	                if (typeof operation === 'function') {
	                    callback = operation;
	                    operation = 'set';
	                }
	
	                send('update' + dataSrc, {
	                    updates: updates,
	                    operation: operation
	                }, callbackWrapper(callback));
	                return _ol;
	            }
	        };
	    };
	
	    // create data API for setup data
	    _ol.setup = dataAPI('SetupData', 'setup');
	
	    // create data API for user data
	    _ol.user = dataAPI('UserData', 'user');
	
	    // Called to log an interaction (or multiple interactions)
	    // with an app
	    _ol.user.logInteraction = function (n) {
	        n = n || 1;
	        send('logInteraction', {
	            'inc': n
	        });
	        return _ol;
	    };
	
	    // Called to check assessment data against the activity's hidden criteria and set progress
	    _ol.user.submit = function (submissionData, callback) {
	        send('submitUserData', {
	            'data': submissionData
	        }, callback);
	        return _ol;
	    };
	
	    // Called to override progress, if the block allows it.
	    // 'progress' is a value in the interval [0.0, 1.0]
	    _ol.user.setProgress = function (progress, callback) {
	        send('setProgress', {
	            'progress': progress
	        }, callback);
	        return _ol;
	    };
	
	    _ol.criteria = {};
	
	    _ol.criteria.replace = function (criteria, comparison, progress, callback) {
	        if (typeof progress === 'function') {
	            callback = progress;
	            progress = 'keys';
	        }
	
	        if (typeof comparison === 'function') {
	            callback = comparison;
	            comparison = 'equal';
	            progress = 'keys';
	        }
	
	        send('replaceCriteria', {
	            'criteria': criteria,
	            'comparison': comparison,
	            'progress': progress
	        }, callback);
	        return _ol;
	    };
	
	    _ol.criteria.retrieve = function (callback) {
	        send('getCriteria', {}, callback);
	    };
	
	    _ol.share = function (shareType, shareData, callback) {
	        var shareValue = void 0;
	
	        if (typeof shareType !== 'string') {
	            shareType = 'block';
	            shareData = shareType;
	            callback = shareData;
	        }
	
	        if (typeof shareData === 'function' && !callback) {
	            callback = shareData;
	            shareData = _ol.user.data;
	        } else if (typeof shareData === 'function') {
	            shareData = shareData();
	        }
	
	        if (typeof shareData === 'string') {
	            shareValue = shareData;
	            shareData = {};
	            shareData[shareType] = shareValue;
	        }
	
	        if (shareType === 'widget') {
	            shareType = 'block';
	        }
	
	        send('share', {
	            'type': shareType,
	            'data': shareData
	        }, callback);
	
	        return _ol;
	    };
	
	    _ol.user.share = _ol.share;
	
	    _ol.tools = {};
	
	    // Launches an equation editor
	    _ol.tools.editEquation = function (latex, callback) {
	        send('editEquation', {
	            'latex': latex
	        }, function (returnData) {
	            callback(returnData.latex);
	        });
	    };
	
	    _ol.posts = {};
	    /**
	     * Get the latest post from this widget of a particular collection type ('share', 'submit', etc)
	     *
	     * result may be null or object containing:
	      result = {
	        id: string,
	        title: string,
	        notes: string,
	        thumbnail: string,
	        tags: array,
	        posted_by: {
	          id: string,
	          profile_name: string,
	          full_name: string,
	          profile_url: string,
	          profile_image: string
	        },
	        posted_at: string,
	        exhibit: {
	          display_type: string,
	          display_data: object,
	        },
	      }
	     */
	    _ol.posts.getLatestPost = function (type) {
	        return _ol.latestPosts[type] || null;
	    };
	
	    /*
	     * Pops up the full-screen modal for the post ID specified.
	     * There is no callback.
	     */
	    _ol.posts.show = function (postId) {
	        send('showPost', { 'id': postId }, function (result) {});
	        return _ol;
	    };
	
	    // A cross-platform protected debug log function
	    _ol.log = function () {
	        if (window.console && console.log) {
	            console.log.apply(console, arguments);
	        }
	    };
	
	    // Pad a string to a certain length by prepending characters (default zeros)
	    _ol.padString = function (inStr, length, paddingChar) {
	        var str = '' + inStr;
	
	        if (!paddingChar) {
	            paddingChar = '0';
	        }
	
	        while (str.length < length) {
	            str = paddingChar + str;
	        }
	
	        return str;
	    };
	
	    // A ISO-8601 date formatter
	    _ol.formatDateTime = function (isoTimestamp, format) {
	        var monthNames = void 0,
	            dayNames = void 0;
	        var meridiem = void 0,
	            hours = void 0,
	            hours24 = void 0,
	            day = void 0,
	            date = void 0,
	            month = void 0,
	            min = void 0,
	            sec = void 0,
	            year = void 0;
	        var timestamp = void 0;
	
	        if (!format) {
	            format = '%a, %d %b %Y %I:%M%p';
	        }
	
	        timestamp = typeof isoTimestamp === 'string' ? fromISOString(isoTimestamp) : isoTimestamp;
	
	        dayNames = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
	        monthNames = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
	
	        meridiem = "am";
	        hours = timestamp.getHours();
	        hours24 = timestamp.getHours();
	        day = timestamp.getDay();
	        month = timestamp.getMonth();
	        min = timestamp.getMinutes();
	        year = timestamp.getFullYear();
	        date = timestamp.getDate();
	
	        if (hours > 11) {
	            hours -= 12;
	            meridiem = "pm";
	        }
	
	        if (hours === 0) {
	            hours = 12;
	        }
	
	        return format.replace(/%a/g, dayNames[day].substring(0, 3)).replace(/%A/g, dayNames[day]).replace(/%d/g, _ol.padString(date, 2)).replace(/%D/g, date).replace(/%b/g, monthNames[month].substring(0, 3)).replace(/%B/g, monthNames[month]).replace(/%Y/g, year).replace(/%I/g, _ol.padString(hours, 2)).replace(/%H/g, _ol.padString(hours24, 2)).replace(/%M/g, _ol.padString(min, 2)).replace(/%S/g, _ol.padString(sec, 2)).replace(/%p/g, meridiem).replace(/%P/g, meridiem.toUpperCase());
	    };
	
	    // create a universally unique id (version 4)
	    _ol.uuid = function (placeholder) {
	        var nonce = void 0;
	        if (placeholder) {
	            nonce = placeholder ^ Math.random() * 16 >> placeholder / 4;
	            return nonce.toString(16);
	        } else {
	            return [1e7, // 10000000
	            1e3, // 1000
	            4e3, // 4000 (starts with 4 to signify version)
	            8e3, // 80000000 (starts with 8, 9, A, or B)
	            1e11 // 100000000000
	            ].join('-').replace(/[018]/g, // zeroes, ones, and eights with
	            _ol.uuid // random hex digits (based on the input digit)
	            );
	        }
	    };
	
	    _ol.localStorage = {
	        setItem: function setItem(key, value, callback) {
	            var values = key;
	
	            // Allow multiple keys
	            if (typeof values === "string") {
	                values = { key: value };
	            }
	            // Shift arguments
	            else {
	                    callback = value;
	                    value = null;
	                }
	
	            send('setLocalStorage', values, callback);
	
	            return _ol.localStorage;
	        },
	
	        getItem: function getItem(key, callback) {
	            var keys = key;
	
	            if (typeof keys === "string") {
	                keys = [key];
	            }
	
	            send('getLocalStorage', keys, callback);
	
	            return _ol.localStorage;
	        },
	
	        removeItem: function removeItem(key, callback) {
	            send('removeLocalStorage', {
	                'key': key
	            }, callback);
	
	            return _ol.localStorage;
	        }
	    };
	
	    // Cross-platform event listener registration
	    _ol.addEvent = function (base, evt, delegate) {
	        if (base.addEventListener) {
	            base.addEventListener(evt, delegate, false);
	        } else {
	            if (evt === 'DOMContentLoaded') {
	                evt = 'readystatechange';
	            }
	            base.attachEvent('on' + evt, delegate);
	        }
	    };
	
	    // Start listening for postMessage events
	    _ol.addEvent(window, 'message', recv);
	
	    // A function called to init the API only once
	    initRequestFunc = function initRequestFunc() {
	        // Only call this function once
	        if (!isInitSent) {
	            send('init');
	            isInitSent = true;
	        }
	    };
	
	    // If the document's already loaded, call the init method
	    if (document.readyState === "complete") {
	        initRequestFunc();
	    }
	    // Listen for document or window loaded and call the init method
	    _ol.addEvent(document, 'DOMContentLoaded', initRequestFunc);
	    _ol.addEvent(window, 'load', initRequestFunc);
	
	    return _ol;
	}();
	
	window.OL = window.OpenLearning;

/***/ },
/* 588 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {"use strict";
	
	__webpack_require__(789);
	
	__webpack_require__(1081);
	
	__webpack_require__(590);
	
	if (global._babelPolyfill) {
	  throw new Error("only one instance of babel-polyfill is allowed");
	}
	global._babelPolyfill = true;
	
	var DEFINE_PROPERTY = "defineProperty";
	function define(O, key, value) {
	  O[key] || Object[DEFINE_PROPERTY](O, key, {
	    writable: true,
	    configurable: true,
	    value: value
	  });
	}
	
	define(String.prototype, "padLeft", "".padStart);
	define(String.prototype, "padRight", "".padEnd);
	
	"pop,reverse,shift,keys,values,entries,indexOf,every,some,forEach,map,filter,find,findIndex,includes,join,slice,concat,push,splice,unshift,sort,lastIndexOf,reduce,reduceRight,copyWithin,fill".split(",").forEach(function (key) {
	  [][key] && define(Array, key, Function.call.bind([][key]));
	});
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 589 */
/***/ function(module, exports) {

	'use strict'
	
	exports.byteLength = byteLength
	exports.toByteArray = toByteArray
	exports.fromByteArray = fromByteArray
	
	var lookup = []
	var revLookup = []
	var Arr = typeof Uint8Array !== 'undefined' ? Uint8Array : Array
	
	var code = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/'
	for (var i = 0, len = code.length; i < len; ++i) {
	  lookup[i] = code[i]
	  revLookup[code.charCodeAt(i)] = i
	}
	
	// Support decoding URL-safe base64 strings, as Node.js does.
	// See: https://en.wikipedia.org/wiki/Base64#URL_applications
	revLookup['-'.charCodeAt(0)] = 62
	revLookup['_'.charCodeAt(0)] = 63
	
	function getLens (b64) {
	  var len = b64.length
	
	  if (len % 4 > 0) {
	    throw new Error('Invalid string. Length must be a multiple of 4')
	  }
	
	  // Trim off extra bytes after placeholder bytes are found
	  // See: https://github.com/beatgammit/base64-js/issues/42
	  var validLen = b64.indexOf('=')
	  if (validLen === -1) validLen = len
	
	  var placeHoldersLen = validLen === len
	    ? 0
	    : 4 - (validLen % 4)
	
	  return [validLen, placeHoldersLen]
	}
	
	// base64 is 4/3 + up to two characters of the original data
	function byteLength (b64) {
	  var lens = getLens(b64)
	  var validLen = lens[0]
	  var placeHoldersLen = lens[1]
	  return ((validLen + placeHoldersLen) * 3 / 4) - placeHoldersLen
	}
	
	function _byteLength (b64, validLen, placeHoldersLen) {
	  return ((validLen + placeHoldersLen) * 3 / 4) - placeHoldersLen
	}
	
	function toByteArray (b64) {
	  var tmp
	  var lens = getLens(b64)
	  var validLen = lens[0]
	  var placeHoldersLen = lens[1]
	
	  var arr = new Arr(_byteLength(b64, validLen, placeHoldersLen))
	
	  var curByte = 0
	
	  // if there are placeholders, only get up to the last complete 4 chars
	  var len = placeHoldersLen > 0
	    ? validLen - 4
	    : validLen
	
	  for (var i = 0; i < len; i += 4) {
	    tmp =
	      (revLookup[b64.charCodeAt(i)] << 18) |
	      (revLookup[b64.charCodeAt(i + 1)] << 12) |
	      (revLookup[b64.charCodeAt(i + 2)] << 6) |
	      revLookup[b64.charCodeAt(i + 3)]
	    arr[curByte++] = (tmp >> 16) & 0xFF
	    arr[curByte++] = (tmp >> 8) & 0xFF
	    arr[curByte++] = tmp & 0xFF
	  }
	
	  if (placeHoldersLen === 2) {
	    tmp =
	      (revLookup[b64.charCodeAt(i)] << 2) |
	      (revLookup[b64.charCodeAt(i + 1)] >> 4)
	    arr[curByte++] = tmp & 0xFF
	  }
	
	  if (placeHoldersLen === 1) {
	    tmp =
	      (revLookup[b64.charCodeAt(i)] << 10) |
	      (revLookup[b64.charCodeAt(i + 1)] << 4) |
	      (revLookup[b64.charCodeAt(i + 2)] >> 2)
	    arr[curByte++] = (tmp >> 8) & 0xFF
	    arr[curByte++] = tmp & 0xFF
	  }
	
	  return arr
	}
	
	function tripletToBase64 (num) {
	  return lookup[num >> 18 & 0x3F] +
	    lookup[num >> 12 & 0x3F] +
	    lookup[num >> 6 & 0x3F] +
	    lookup[num & 0x3F]
	}
	
	function encodeChunk (uint8, start, end) {
	  var tmp
	  var output = []
	  for (var i = start; i < end; i += 3) {
	    tmp =
	      ((uint8[i] << 16) & 0xFF0000) +
	      ((uint8[i + 1] << 8) & 0xFF00) +
	      (uint8[i + 2] & 0xFF)
	    output.push(tripletToBase64(tmp))
	  }
	  return output.join('')
	}
	
	function fromByteArray (uint8) {
	  var tmp
	  var len = uint8.length
	  var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
	  var parts = []
	  var maxChunkLength = 16383 // must be multiple of 3
	
	  // go through the array every three bytes, we'll deal with trailing stuff later
	  for (var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength) {
	    parts.push(encodeChunk(
	      uint8, i, (i + maxChunkLength) > len2 ? len2 : (i + maxChunkLength)
	    ))
	  }
	
	  // pad the end with zeros, but make sure to not forget the extra bytes
	  if (extraBytes === 1) {
	    tmp = uint8[len - 1]
	    parts.push(
	      lookup[tmp >> 2] +
	      lookup[(tmp << 4) & 0x3F] +
	      '=='
	    )
	  } else if (extraBytes === 2) {
	    tmp = (uint8[len - 2] << 8) + uint8[len - 1]
	    parts.push(
	      lookup[tmp >> 10] +
	      lookup[(tmp >> 4) & 0x3F] +
	      lookup[(tmp << 2) & 0x3F] +
	      '='
	    )
	  }
	
	  return parts.join('')
	}


/***/ },
/* 590 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(597);
	module.exports = __webpack_require__(70).RegExp.escape;


/***/ },
/* 591 */
/***/ function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(27);
	var isArray = __webpack_require__(158);
	var SPECIES = __webpack_require__(34)('species');
	
	module.exports = function (original) {
	  var C;
	  if (isArray(original)) {
	    C = original.constructor;
	    // cross-realm fallback
	    if (typeof C == 'function' && (C === Array || isArray(C.prototype))) C = undefined;
	    if (isObject(C)) {
	      C = C[SPECIES];
	      if (C === null) C = undefined;
	    }
	  } return C === undefined ? Array : C;
	};


/***/ },
/* 592 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// 20.3.4.36 / 15.9.5.43 Date.prototype.toISOString()
	var fails = __webpack_require__(26);
	var getTime = Date.prototype.getTime;
	var $toISOString = Date.prototype.toISOString;
	
	var lz = function (num) {
	  return num > 9 ? num : '0' + num;
	};
	
	// PhantomJS / old WebKit has a broken implementations
	module.exports = (fails(function () {
	  return $toISOString.call(new Date(-5e13 - 1)) != '0385-07-25T07:06:39.999Z';
	}) || !fails(function () {
	  $toISOString.call(new Date(NaN));
	})) ? function toISOString() {
	  if (!isFinite(getTime.call(this))) throw RangeError('Invalid time value');
	  var d = this;
	  var y = d.getUTCFullYear();
	  var m = d.getUTCMilliseconds();
	  var s = y < 0 ? '-' : y > 9999 ? '+' : '';
	  return s + ('00000' + Math.abs(y)).slice(s ? -6 : -4) +
	    '-' + lz(d.getUTCMonth() + 1) + '-' + lz(d.getUTCDate()) +
	    'T' + lz(d.getUTCHours()) + ':' + lz(d.getUTCMinutes()) +
	    ':' + lz(d.getUTCSeconds()) + '.' + (m > 99 ? m : '0' + lz(m)) + 'Z';
	} : $toISOString;


/***/ },
/* 593 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var anObject = __webpack_require__(23);
	var toPrimitive = __webpack_require__(79);
	var NUMBER = 'number';
	
	module.exports = function (hint) {
	  if (hint !== 'string' && hint !== NUMBER && hint !== 'default') throw TypeError('Incorrect hint');
	  return toPrimitive(anObject(this), hint != NUMBER);
	};


/***/ },
/* 594 */
/***/ function(module, exports, __webpack_require__) {

	// all enumerable object keys, includes symbols
	var getKeys = __webpack_require__(106);
	var gOPS = __webpack_require__(162);
	var pIE = __webpack_require__(140);
	module.exports = function (it) {
	  var result = getKeys(it);
	  var getSymbols = gOPS.f;
	  if (getSymbols) {
	    var symbols = getSymbols(it);
	    var isEnum = pIE.f;
	    var i = 0;
	    var key;
	    while (symbols.length > i) if (isEnum.call(it, key = symbols[i++])) result.push(key);
	  } return result;
	};


/***/ },
/* 595 */
/***/ function(module, exports) {

	module.exports = function (regExp, replace) {
	  var replacer = replace === Object(replace) ? function (part) {
	    return replace[part];
	  } : replace;
	  return function (it) {
	    return String(it).replace(regExp, replacer);
	  };
	};


/***/ },
/* 596 */
/***/ function(module, exports) {

	// 7.2.9 SameValue(x, y)
	module.exports = Object.is || function is(x, y) {
	  // eslint-disable-next-line no-self-compare
	  return x === y ? x !== 0 || 1 / x === 1 / y : x != x && y != y;
	};


/***/ },
/* 597 */
/***/ function(module, exports, __webpack_require__) {

	// https://github.com/benjamingr/RexExp.escape
	var $export = __webpack_require__(6);
	var $re = __webpack_require__(595)(/[\\^$*+?.()|[\]{}]/g, '\\$&');
	
	$export($export.S, 'RegExp', { escape: function escape(it) { return $re(it); } });


/***/ },
/* 598 */
/***/ function(module, exports, __webpack_require__) {

	// 22.1.3.3 Array.prototype.copyWithin(target, start, end = this.length)
	var $export = __webpack_require__(6);
	
	$export($export.P, 'Array', { copyWithin: __webpack_require__(292) });
	
	__webpack_require__(95)('copyWithin');


/***/ },
/* 599 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(6);
	var $every = __webpack_require__(75)(4);
	
	$export($export.P + $export.F * !__webpack_require__(72)([].every, true), 'Array', {
	  // 22.1.3.5 / 15.4.4.16 Array.prototype.every(callbackfn [, thisArg])
	  every: function every(callbackfn /* , thisArg */) {
	    return $every(this, callbackfn, arguments[1]);
	  }
	});


/***/ },
/* 600 */
/***/ function(module, exports, __webpack_require__) {

	// 22.1.3.6 Array.prototype.fill(value, start = 0, end = this.length)
	var $export = __webpack_require__(6);
	
	$export($export.P, 'Array', { fill: __webpack_require__(205) });
	
	__webpack_require__(95)('fill');


/***/ },
/* 601 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(6);
	var $filter = __webpack_require__(75)(2);
	
	$export($export.P + $export.F * !__webpack_require__(72)([].filter, true), 'Array', {
	  // 22.1.3.7 / 15.4.4.20 Array.prototype.filter(callbackfn [, thisArg])
	  filter: function filter(callbackfn /* , thisArg */) {
	    return $filter(this, callbackfn, arguments[1]);
	  }
	});


/***/ },
/* 602 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// 22.1.3.9 Array.prototype.findIndex(predicate, thisArg = undefined)
	var $export = __webpack_require__(6);
	var $find = __webpack_require__(75)(6);
	var KEY = 'findIndex';
	var forced = true;
	// Shouldn't skip holes
	if (KEY in []) Array(1)[KEY](function () { forced = false; });
	$export($export.P + $export.F * forced, 'Array', {
	  findIndex: function findIndex(callbackfn /* , that = undefined */) {
	    return $find(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
	  }
	});
	__webpack_require__(95)(KEY);


/***/ },
/* 603 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// 22.1.3.8 Array.prototype.find(predicate, thisArg = undefined)
	var $export = __webpack_require__(6);
	var $find = __webpack_require__(75)(5);
	var KEY = 'find';
	var forced = true;
	// Shouldn't skip holes
	if (KEY in []) Array(1)[KEY](function () { forced = false; });
	$export($export.P + $export.F * forced, 'Array', {
	  find: function find(callbackfn /* , that = undefined */) {
	    return $find(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
	  }
	});
	__webpack_require__(95)(KEY);


/***/ },
/* 604 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(6);
	var $forEach = __webpack_require__(75)(0);
	var STRICT = __webpack_require__(72)([].forEach, true);
	
	$export($export.P + $export.F * !STRICT, 'Array', {
	  // 22.1.3.10 / 15.4.4.18 Array.prototype.forEach(callbackfn [, thisArg])
	  forEach: function forEach(callbackfn /* , thisArg */) {
	    return $forEach(this, callbackfn, arguments[1]);
	  }
	});


/***/ },
/* 605 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var ctx = __webpack_require__(71);
	var $export = __webpack_require__(6);
	var toObject = __webpack_require__(43);
	var call = __webpack_require__(303);
	var isArrayIter = __webpack_require__(213);
	var toLength = __webpack_require__(40);
	var createProperty = __webpack_require__(207);
	var getIterFn = __webpack_require__(229);
	
	$export($export.S + $export.F * !__webpack_require__(160)(function (iter) { Array.from(iter); }), 'Array', {
	  // 22.1.2.1 Array.from(arrayLike, mapfn = undefined, thisArg = undefined)
	  from: function from(arrayLike /* , mapfn = undefined, thisArg = undefined */) {
	    var O = toObject(arrayLike);
	    var C = typeof this == 'function' ? this : Array;
	    var aLen = arguments.length;
	    var mapfn = aLen > 1 ? arguments[1] : undefined;
	    var mapping = mapfn !== undefined;
	    var index = 0;
	    var iterFn = getIterFn(O);
	    var length, result, step, iterator;
	    if (mapping) mapfn = ctx(mapfn, aLen > 2 ? arguments[2] : undefined, 2);
	    // if object isn't iterable or it's array with default iterator - use simple case
	    if (iterFn != undefined && !(C == Array && isArrayIter(iterFn))) {
	      for (iterator = iterFn.call(O), result = new C(); !(step = iterator.next()).done; index++) {
	        createProperty(result, index, mapping ? call(iterator, mapfn, [step.value, index], true) : step.value);
	      }
	    } else {
	      length = toLength(O.length);
	      for (result = new C(length); length > index; index++) {
	        createProperty(result, index, mapping ? mapfn(O[index], index) : O[index]);
	      }
	    }
	    result.length = index;
	    return result;
	  }
	});


/***/ },
/* 606 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(6);
	var $indexOf = __webpack_require__(154)(false);
	var $native = [].indexOf;
	var NEGATIVE_ZERO = !!$native && 1 / [1].indexOf(1, -0) < 0;
	
	$export($export.P + $export.F * (NEGATIVE_ZERO || !__webpack_require__(72)($native)), 'Array', {
	  // 22.1.3.11 / 15.4.4.14 Array.prototype.indexOf(searchElement [, fromIndex])
	  indexOf: function indexOf(searchElement /* , fromIndex = 0 */) {
	    return NEGATIVE_ZERO
	      // convert -0 to +0
	      ? $native.apply(this, arguments) || 0
	      : $indexOf(this, searchElement, arguments[1]);
	  }
	});


/***/ },
/* 607 */
/***/ function(module, exports, __webpack_require__) {

	// 22.1.2.2 / 15.4.3.2 Array.isArray(arg)
	var $export = __webpack_require__(6);
	
	$export($export.S, 'Array', { isArray: __webpack_require__(158) });


/***/ },
/* 608 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// 22.1.3.13 Array.prototype.join(separator)
	var $export = __webpack_require__(6);
	var toIObject = __webpack_require__(61);
	var arrayJoin = [].join;
	
	// fallback for not array-like strings
	$export($export.P + $export.F * (__webpack_require__(139) != Object || !__webpack_require__(72)(arrayJoin)), 'Array', {
	  join: function join(separator) {
	    return arrayJoin.call(toIObject(this), separator === undefined ? ',' : separator);
	  }
	});


/***/ },
/* 609 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(6);
	var toIObject = __webpack_require__(61);
	var toInteger = __webpack_require__(78);
	var toLength = __webpack_require__(40);
	var $native = [].lastIndexOf;
	var NEGATIVE_ZERO = !!$native && 1 / [1].lastIndexOf(1, -0) < 0;
	
	$export($export.P + $export.F * (NEGATIVE_ZERO || !__webpack_require__(72)($native)), 'Array', {
	  // 22.1.3.14 / 15.4.4.15 Array.prototype.lastIndexOf(searchElement [, fromIndex])
	  lastIndexOf: function lastIndexOf(searchElement /* , fromIndex = @[*-1] */) {
	    // convert -0 to +0
	    if (NEGATIVE_ZERO) return $native.apply(this, arguments) || 0;
	    var O = toIObject(this);
	    var length = toLength(O.length);
	    var index = length - 1;
	    if (arguments.length > 1) index = Math.min(index, toInteger(arguments[1]));
	    if (index < 0) index = length + index;
	    for (;index >= 0; index--) if (index in O) if (O[index] === searchElement) return index || 0;
	    return -1;
	  }
	});


/***/ },
/* 610 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(6);
	var $map = __webpack_require__(75)(1);
	
	$export($export.P + $export.F * !__webpack_require__(72)([].map, true), 'Array', {
	  // 22.1.3.15 / 15.4.4.19 Array.prototype.map(callbackfn [, thisArg])
	  map: function map(callbackfn /* , thisArg */) {
	    return $map(this, callbackfn, arguments[1]);
	  }
	});


/***/ },
/* 611 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(6);
	var createProperty = __webpack_require__(207);
	
	// WebKit Array.of isn't generic
	$export($export.S + $export.F * __webpack_require__(26)(function () {
	  function F() { /* empty */ }
	  return !(Array.of.call(F) instanceof F);
	}), 'Array', {
	  // 22.1.2.3 Array.of( ...items)
	  of: function of(/* ...args */) {
	    var index = 0;
	    var aLen = arguments.length;
	    var result = new (typeof this == 'function' ? this : Array)(aLen);
	    while (aLen > index) createProperty(result, index, arguments[index++]);
	    result.length = aLen;
	    return result;
	  }
	});


/***/ },
/* 612 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(6);
	var $reduce = __webpack_require__(294);
	
	$export($export.P + $export.F * !__webpack_require__(72)([].reduceRight, true), 'Array', {
	  // 22.1.3.19 / 15.4.4.22 Array.prototype.reduceRight(callbackfn [, initialValue])
	  reduceRight: function reduceRight(callbackfn /* , initialValue */) {
	    return $reduce(this, callbackfn, arguments.length, arguments[1], true);
	  }
	});


/***/ },
/* 613 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(6);
	var $reduce = __webpack_require__(294);
	
	$export($export.P + $export.F * !__webpack_require__(72)([].reduce, true), 'Array', {
	  // 22.1.3.18 / 15.4.4.21 Array.prototype.reduce(callbackfn [, initialValue])
	  reduce: function reduce(callbackfn /* , initialValue */) {
	    return $reduce(this, callbackfn, arguments.length, arguments[1], false);
	  }
	});


/***/ },
/* 614 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(6);
	var html = __webpack_require__(211);
	var cof = __webpack_require__(69);
	var toAbsoluteIndex = __webpack_require__(110);
	var toLength = __webpack_require__(40);
	var arraySlice = [].slice;
	
	// fallback for not array-like ES3 strings and DOM objects
	$export($export.P + $export.F * __webpack_require__(26)(function () {
	  if (html) arraySlice.call(html);
	}), 'Array', {
	  slice: function slice(begin, end) {
	    var len = toLength(this.length);
	    var klass = cof(this);
	    end = end === undefined ? len : end;
	    if (klass == 'Array') return arraySlice.call(this, begin, end);
	    var start = toAbsoluteIndex(begin, len);
	    var upTo = toAbsoluteIndex(end, len);
	    var size = toLength(upTo - start);
	    var cloned = new Array(size);
	    var i = 0;
	    for (; i < size; i++) cloned[i] = klass == 'String'
	      ? this.charAt(start + i)
	      : this[start + i];
	    return cloned;
	  }
	});


/***/ },
/* 615 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(6);
	var $some = __webpack_require__(75)(3);
	
	$export($export.P + $export.F * !__webpack_require__(72)([].some, true), 'Array', {
	  // 22.1.3.23 / 15.4.4.17 Array.prototype.some(callbackfn [, thisArg])
	  some: function some(callbackfn /* , thisArg */) {
	    return $some(this, callbackfn, arguments[1]);
	  }
	});


/***/ },
/* 616 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(6);
	var aFunction = __webpack_require__(50);
	var toObject = __webpack_require__(43);
	var fails = __webpack_require__(26);
	var $sort = [].sort;
	var test = [1, 2, 3];
	
	$export($export.P + $export.F * (fails(function () {
	  // IE8-
	  test.sort(undefined);
	}) || !fails(function () {
	  // V8 bug
	  test.sort(null);
	  // Old WebKit
	}) || !__webpack_require__(72)($sort)), 'Array', {
	  // 22.1.3.25 Array.prototype.sort(comparefn)
	  sort: function sort(comparefn) {
	    return comparefn === undefined
	      ? $sort.call(toObject(this))
	      : $sort.call(toObject(this), aFunction(comparefn));
	  }
	});


/***/ },
/* 617 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(109)('Array');


/***/ },
/* 618 */
/***/ function(module, exports, __webpack_require__) {

	// 20.3.3.1 / 15.9.4.4 Date.now()
	var $export = __webpack_require__(6);
	
	$export($export.S, 'Date', { now: function () { return new Date().getTime(); } });


/***/ },
/* 619 */
/***/ function(module, exports, __webpack_require__) {

	// 20.3.4.36 / 15.9.5.43 Date.prototype.toISOString()
	var $export = __webpack_require__(6);
	var toISOString = __webpack_require__(592);
	
	// PhantomJS / old WebKit has a broken implementations
	$export($export.P + $export.F * (Date.prototype.toISOString !== toISOString), 'Date', {
	  toISOString: toISOString
	});


/***/ },
/* 620 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(6);
	var toObject = __webpack_require__(43);
	var toPrimitive = __webpack_require__(79);
	
	$export($export.P + $export.F * __webpack_require__(26)(function () {
	  return new Date(NaN).toJSON() !== null
	    || Date.prototype.toJSON.call({ toISOString: function () { return 1; } }) !== 1;
	}), 'Date', {
	  // eslint-disable-next-line no-unused-vars
	  toJSON: function toJSON(key) {
	    var O = toObject(this);
	    var pv = toPrimitive(O);
	    return typeof pv == 'number' && !isFinite(pv) ? null : O.toISOString();
	  }
	});


/***/ },
/* 621 */
/***/ function(module, exports, __webpack_require__) {

	var TO_PRIMITIVE = __webpack_require__(34)('toPrimitive');
	var proto = Date.prototype;
	
	if (!(TO_PRIMITIVE in proto)) __webpack_require__(52)(proto, TO_PRIMITIVE, __webpack_require__(593));


/***/ },
/* 622 */
/***/ function(module, exports, __webpack_require__) {

	var DateProto = Date.prototype;
	var INVALID_DATE = 'Invalid Date';
	var TO_STRING = 'toString';
	var $toString = DateProto[TO_STRING];
	var getTime = DateProto.getTime;
	if (new Date(NaN) + '' != INVALID_DATE) {
	  __webpack_require__(53)(DateProto, TO_STRING, function toString() {
	    var value = getTime.call(this);
	    // eslint-disable-next-line no-self-compare
	    return value === value ? $toString.call(this) : INVALID_DATE;
	  });
	}


/***/ },
/* 623 */
/***/ function(module, exports, __webpack_require__) {

	// 19.2.3.2 / 15.3.4.5 Function.prototype.bind(thisArg, args...)
	var $export = __webpack_require__(6);
	
	$export($export.P, 'Function', { bind: __webpack_require__(295) });


/***/ },
/* 624 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var isObject = __webpack_require__(27);
	var getPrototypeOf = __webpack_require__(60);
	var HAS_INSTANCE = __webpack_require__(34)('hasInstance');
	var FunctionProto = Function.prototype;
	// 19.2.3.6 Function.prototype[@@hasInstance](V)
	if (!(HAS_INSTANCE in FunctionProto)) __webpack_require__(39).f(FunctionProto, HAS_INSTANCE, { value: function (O) {
	  if (typeof this != 'function' || !isObject(O)) return false;
	  if (!isObject(this.prototype)) return O instanceof this;
	  // for environment w/o native `@@hasInstance` logic enough `instanceof`, but add this:
	  while (O = getPrototypeOf(O)) if (this.prototype === O) return true;
	  return false;
	} });


/***/ },
/* 625 */
/***/ function(module, exports, __webpack_require__) {

	var dP = __webpack_require__(39).f;
	var FProto = Function.prototype;
	var nameRE = /^\s*function ([^ (]*)/;
	var NAME = 'name';
	
	// 19.2.4.2 name
	NAME in FProto || __webpack_require__(38) && dP(FProto, NAME, {
	  configurable: true,
	  get: function () {
	    try {
	      return ('' + this).match(nameRE)[1];
	    } catch (e) {
	      return '';
	    }
	  }
	});


/***/ },
/* 626 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.3 Math.acosh(x)
	var $export = __webpack_require__(6);
	var log1p = __webpack_require__(306);
	var sqrt = Math.sqrt;
	var $acosh = Math.acosh;
	
	$export($export.S + $export.F * !($acosh
	  // V8 bug: https://code.google.com/p/v8/issues/detail?id=3509
	  && Math.floor($acosh(Number.MAX_VALUE)) == 710
	  // Tor Browser bug: Math.acosh(Infinity) -> NaN
	  && $acosh(Infinity) == Infinity
	), 'Math', {
	  acosh: function acosh(x) {
	    return (x = +x) < 1 ? NaN : x > 94906265.62425156
	      ? Math.log(x) + Math.LN2
	      : log1p(x - 1 + sqrt(x - 1) * sqrt(x + 1));
	  }
	});


/***/ },
/* 627 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.5 Math.asinh(x)
	var $export = __webpack_require__(6);
	var $asinh = Math.asinh;
	
	function asinh(x) {
	  return !isFinite(x = +x) || x == 0 ? x : x < 0 ? -asinh(-x) : Math.log(x + Math.sqrt(x * x + 1));
	}
	
	// Tor Browser bug: Math.asinh(0) -> -0
	$export($export.S + $export.F * !($asinh && 1 / $asinh(0) > 0), 'Math', { asinh: asinh });


/***/ },
/* 628 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.7 Math.atanh(x)
	var $export = __webpack_require__(6);
	var $atanh = Math.atanh;
	
	// Tor Browser bug: Math.atanh(-0) -> 0
	$export($export.S + $export.F * !($atanh && 1 / $atanh(-0) < 0), 'Math', {
	  atanh: function atanh(x) {
	    return (x = +x) == 0 ? x : Math.log((1 + x) / (1 - x)) / 2;
	  }
	});


/***/ },
/* 629 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.9 Math.cbrt(x)
	var $export = __webpack_require__(6);
	var sign = __webpack_require__(217);
	
	$export($export.S, 'Math', {
	  cbrt: function cbrt(x) {
	    return sign(x = +x) * Math.pow(Math.abs(x), 1 / 3);
	  }
	});


/***/ },
/* 630 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.11 Math.clz32(x)
	var $export = __webpack_require__(6);
	
	$export($export.S, 'Math', {
	  clz32: function clz32(x) {
	    return (x >>>= 0) ? 31 - Math.floor(Math.log(x + 0.5) * Math.LOG2E) : 32;
	  }
	});


/***/ },
/* 631 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.12 Math.cosh(x)
	var $export = __webpack_require__(6);
	var exp = Math.exp;
	
	$export($export.S, 'Math', {
	  cosh: function cosh(x) {
	    return (exp(x = +x) + exp(-x)) / 2;
	  }
	});


/***/ },
/* 632 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.14 Math.expm1(x)
	var $export = __webpack_require__(6);
	var $expm1 = __webpack_require__(216);
	
	$export($export.S + $export.F * ($expm1 != Math.expm1), 'Math', { expm1: $expm1 });


/***/ },
/* 633 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.16 Math.fround(x)
	var $export = __webpack_require__(6);
	
	$export($export.S, 'Math', { fround: __webpack_require__(305) });


/***/ },
/* 634 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.17 Math.hypot([value1[, value2[, … ]]])
	var $export = __webpack_require__(6);
	var abs = Math.abs;
	
	$export($export.S, 'Math', {
	  hypot: function hypot(value1, value2) { // eslint-disable-line no-unused-vars
	    var sum = 0;
	    var i = 0;
	    var aLen = arguments.length;
	    var larg = 0;
	    var arg, div;
	    while (i < aLen) {
	      arg = abs(arguments[i++]);
	      if (larg < arg) {
	        div = larg / arg;
	        sum = sum * div * div + 1;
	        larg = arg;
	      } else if (arg > 0) {
	        div = arg / larg;
	        sum += div * div;
	      } else sum += arg;
	    }
	    return larg === Infinity ? Infinity : larg * Math.sqrt(sum);
	  }
	});


/***/ },
/* 635 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.18 Math.imul(x, y)
	var $export = __webpack_require__(6);
	var $imul = Math.imul;
	
	// some WebKit versions fails with big numbers, some has wrong arity
	$export($export.S + $export.F * __webpack_require__(26)(function () {
	  return $imul(0xffffffff, 5) != -5 || $imul.length != 2;
	}), 'Math', {
	  imul: function imul(x, y) {
	    var UINT16 = 0xffff;
	    var xn = +x;
	    var yn = +y;
	    var xl = UINT16 & xn;
	    var yl = UINT16 & yn;
	    return 0 | xl * yl + ((UINT16 & xn >>> 16) * yl + xl * (UINT16 & yn >>> 16) << 16 >>> 0);
	  }
	});


/***/ },
/* 636 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.21 Math.log10(x)
	var $export = __webpack_require__(6);
	
	$export($export.S, 'Math', {
	  log10: function log10(x) {
	    return Math.log(x) * Math.LOG10E;
	  }
	});


/***/ },
/* 637 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.20 Math.log1p(x)
	var $export = __webpack_require__(6);
	
	$export($export.S, 'Math', { log1p: __webpack_require__(306) });


/***/ },
/* 638 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.22 Math.log2(x)
	var $export = __webpack_require__(6);
	
	$export($export.S, 'Math', {
	  log2: function log2(x) {
	    return Math.log(x) / Math.LN2;
	  }
	});


/***/ },
/* 639 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.28 Math.sign(x)
	var $export = __webpack_require__(6);
	
	$export($export.S, 'Math', { sign: __webpack_require__(217) });


/***/ },
/* 640 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.30 Math.sinh(x)
	var $export = __webpack_require__(6);
	var expm1 = __webpack_require__(216);
	var exp = Math.exp;
	
	// V8 near Chromium 38 has a problem with very small numbers
	$export($export.S + $export.F * __webpack_require__(26)(function () {
	  return !Math.sinh(-2e-17) != -2e-17;
	}), 'Math', {
	  sinh: function sinh(x) {
	    return Math.abs(x = +x) < 1
	      ? (expm1(x) - expm1(-x)) / 2
	      : (exp(x - 1) - exp(-x - 1)) * (Math.E / 2);
	  }
	});


/***/ },
/* 641 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.33 Math.tanh(x)
	var $export = __webpack_require__(6);
	var expm1 = __webpack_require__(216);
	var exp = Math.exp;
	
	$export($export.S, 'Math', {
	  tanh: function tanh(x) {
	    var a = expm1(x = +x);
	    var b = expm1(-x);
	    return a == Infinity ? 1 : b == Infinity ? -1 : (a - b) / (exp(x) + exp(-x));
	  }
	});


/***/ },
/* 642 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.34 Math.trunc(x)
	var $export = __webpack_require__(6);
	
	$export($export.S, 'Math', {
	  trunc: function trunc(it) {
	    return (it > 0 ? Math.floor : Math.ceil)(it);
	  }
	});


/***/ },
/* 643 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var global = __webpack_require__(24);
	var has = __webpack_require__(58);
	var cof = __webpack_require__(69);
	var inheritIfRequired = __webpack_require__(212);
	var toPrimitive = __webpack_require__(79);
	var fails = __webpack_require__(26);
	var gOPN = __webpack_require__(105).f;
	var gOPD = __webpack_require__(59).f;
	var dP = __webpack_require__(39).f;
	var $trim = __webpack_require__(118).trim;
	var NUMBER = 'Number';
	var $Number = global[NUMBER];
	var Base = $Number;
	var proto = $Number.prototype;
	// Opera ~12 has broken Object#toString
	var BROKEN_COF = cof(__webpack_require__(104)(proto)) == NUMBER;
	var TRIM = 'trim' in String.prototype;
	
	// 7.1.3 ToNumber(argument)
	var toNumber = function (argument) {
	  var it = toPrimitive(argument, false);
	  if (typeof it == 'string' && it.length > 2) {
	    it = TRIM ? it.trim() : $trim(it, 3);
	    var first = it.charCodeAt(0);
	    var third, radix, maxCode;
	    if (first === 43 || first === 45) {
	      third = it.charCodeAt(2);
	      if (third === 88 || third === 120) return NaN; // Number('+0x1') should be NaN, old V8 fix
	    } else if (first === 48) {
	      switch (it.charCodeAt(1)) {
	        case 66: case 98: radix = 2; maxCode = 49; break; // fast equal /^0b[01]+$/i
	        case 79: case 111: radix = 8; maxCode = 55; break; // fast equal /^0o[0-7]+$/i
	        default: return +it;
	      }
	      for (var digits = it.slice(2), i = 0, l = digits.length, code; i < l; i++) {
	        code = digits.charCodeAt(i);
	        // parseInt parses a string to a first unavailable symbol
	        // but ToNumber should return NaN if a string contains unavailable symbols
	        if (code < 48 || code > maxCode) return NaN;
	      } return parseInt(digits, radix);
	    }
	  } return +it;
	};
	
	if (!$Number(' 0o1') || !$Number('0b1') || $Number('+0x1')) {
	  $Number = function Number(value) {
	    var it = arguments.length < 1 ? 0 : value;
	    var that = this;
	    return that instanceof $Number
	      // check on 1..constructor(foo) case
	      && (BROKEN_COF ? fails(function () { proto.valueOf.call(that); }) : cof(that) != NUMBER)
	        ? inheritIfRequired(new Base(toNumber(it)), that, $Number) : toNumber(it);
	  };
	  for (var keys = __webpack_require__(38) ? gOPN(Base) : (
	    // ES3:
	    'MAX_VALUE,MIN_VALUE,NaN,NEGATIVE_INFINITY,POSITIVE_INFINITY,' +
	    // ES6 (in case, if modules with ES6 Number statics required before):
	    'EPSILON,isFinite,isInteger,isNaN,isSafeInteger,MAX_SAFE_INTEGER,' +
	    'MIN_SAFE_INTEGER,parseFloat,parseInt,isInteger'
	  ).split(','), j = 0, key; keys.length > j; j++) {
	    if (has(Base, key = keys[j]) && !has($Number, key)) {
	      dP($Number, key, gOPD(Base, key));
	    }
	  }
	  $Number.prototype = proto;
	  proto.constructor = $Number;
	  __webpack_require__(53)(global, NUMBER, $Number);
	}


/***/ },
/* 644 */
/***/ function(module, exports, __webpack_require__) {

	// 20.1.2.1 Number.EPSILON
	var $export = __webpack_require__(6);
	
	$export($export.S, 'Number', { EPSILON: Math.pow(2, -52) });


/***/ },
/* 645 */
/***/ function(module, exports, __webpack_require__) {

	// 20.1.2.2 Number.isFinite(number)
	var $export = __webpack_require__(6);
	var _isFinite = __webpack_require__(24).isFinite;
	
	$export($export.S, 'Number', {
	  isFinite: function isFinite(it) {
	    return typeof it == 'number' && _isFinite(it);
	  }
	});


/***/ },
/* 646 */
/***/ function(module, exports, __webpack_require__) {

	// 20.1.2.3 Number.isInteger(number)
	var $export = __webpack_require__(6);
	
	$export($export.S, 'Number', { isInteger: __webpack_require__(302) });


/***/ },
/* 647 */
/***/ function(module, exports, __webpack_require__) {

	// 20.1.2.4 Number.isNaN(number)
	var $export = __webpack_require__(6);
	
	$export($export.S, 'Number', {
	  isNaN: function isNaN(number) {
	    // eslint-disable-next-line no-self-compare
	    return number != number;
	  }
	});


/***/ },
/* 648 */
/***/ function(module, exports, __webpack_require__) {

	// 20.1.2.5 Number.isSafeInteger(number)
	var $export = __webpack_require__(6);
	var isInteger = __webpack_require__(302);
	var abs = Math.abs;
	
	$export($export.S, 'Number', {
	  isSafeInteger: function isSafeInteger(number) {
	    return isInteger(number) && abs(number) <= 0x1fffffffffffff;
	  }
	});


/***/ },
/* 649 */
/***/ function(module, exports, __webpack_require__) {

	// 20.1.2.6 Number.MAX_SAFE_INTEGER
	var $export = __webpack_require__(6);
	
	$export($export.S, 'Number', { MAX_SAFE_INTEGER: 0x1fffffffffffff });


/***/ },
/* 650 */
/***/ function(module, exports, __webpack_require__) {

	// 20.1.2.10 Number.MIN_SAFE_INTEGER
	var $export = __webpack_require__(6);
	
	$export($export.S, 'Number', { MIN_SAFE_INTEGER: -0x1fffffffffffff });


/***/ },
/* 651 */
/***/ function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(6);
	var $parseFloat = __webpack_require__(314);
	// 20.1.2.12 Number.parseFloat(string)
	$export($export.S + $export.F * (Number.parseFloat != $parseFloat), 'Number', { parseFloat: $parseFloat });


/***/ },
/* 652 */
/***/ function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(6);
	var $parseInt = __webpack_require__(315);
	// 20.1.2.13 Number.parseInt(string, radix)
	$export($export.S + $export.F * (Number.parseInt != $parseInt), 'Number', { parseInt: $parseInt });


/***/ },
/* 653 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(6);
	var toInteger = __webpack_require__(78);
	var aNumberValue = __webpack_require__(291);
	var repeat = __webpack_require__(224);
	var $toFixed = 1.0.toFixed;
	var floor = Math.floor;
	var data = [0, 0, 0, 0, 0, 0];
	var ERROR = 'Number.toFixed: incorrect invocation!';
	var ZERO = '0';
	
	var multiply = function (n, c) {
	  var i = -1;
	  var c2 = c;
	  while (++i < 6) {
	    c2 += n * data[i];
	    data[i] = c2 % 1e7;
	    c2 = floor(c2 / 1e7);
	  }
	};
	var divide = function (n) {
	  var i = 6;
	  var c = 0;
	  while (--i >= 0) {
	    c += data[i];
	    data[i] = floor(c / n);
	    c = (c % n) * 1e7;
	  }
	};
	var numToString = function () {
	  var i = 6;
	  var s = '';
	  while (--i >= 0) {
	    if (s !== '' || i === 0 || data[i] !== 0) {
	      var t = String(data[i]);
	      s = s === '' ? t : s + repeat.call(ZERO, 7 - t.length) + t;
	    }
	  } return s;
	};
	var pow = function (x, n, acc) {
	  return n === 0 ? acc : n % 2 === 1 ? pow(x, n - 1, acc * x) : pow(x * x, n / 2, acc);
	};
	var log = function (x) {
	  var n = 0;
	  var x2 = x;
	  while (x2 >= 4096) {
	    n += 12;
	    x2 /= 4096;
	  }
	  while (x2 >= 2) {
	    n += 1;
	    x2 /= 2;
	  } return n;
	};
	
	$export($export.P + $export.F * (!!$toFixed && (
	  0.00008.toFixed(3) !== '0.000' ||
	  0.9.toFixed(0) !== '1' ||
	  1.255.toFixed(2) !== '1.25' ||
	  1000000000000000128.0.toFixed(0) !== '1000000000000000128'
	) || !__webpack_require__(26)(function () {
	  // V8 ~ Android 4.3-
	  $toFixed.call({});
	})), 'Number', {
	  toFixed: function toFixed(fractionDigits) {
	    var x = aNumberValue(this, ERROR);
	    var f = toInteger(fractionDigits);
	    var s = '';
	    var m = ZERO;
	    var e, z, j, k;
	    if (f < 0 || f > 20) throw RangeError(ERROR);
	    // eslint-disable-next-line no-self-compare
	    if (x != x) return 'NaN';
	    if (x <= -1e21 || x >= 1e21) return String(x);
	    if (x < 0) {
	      s = '-';
	      x = -x;
	    }
	    if (x > 1e-21) {
	      e = log(x * pow(2, 69, 1)) - 69;
	      z = e < 0 ? x * pow(2, -e, 1) : x / pow(2, e, 1);
	      z *= 0x10000000000000;
	      e = 52 - e;
	      if (e > 0) {
	        multiply(0, z);
	        j = f;
	        while (j >= 7) {
	          multiply(1e7, 0);
	          j -= 7;
	        }
	        multiply(pow(10, j, 1), 0);
	        j = e - 1;
	        while (j >= 23) {
	          divide(1 << 23);
	          j -= 23;
	        }
	        divide(1 << j);
	        multiply(1, 1);
	        divide(2);
	        m = numToString();
	      } else {
	        multiply(0, z);
	        multiply(1 << -e, 0);
	        m = numToString() + repeat.call(ZERO, f);
	      }
	    }
	    if (f > 0) {
	      k = m.length;
	      m = s + (k <= f ? '0.' + repeat.call(ZERO, f - k) + m : m.slice(0, k - f) + '.' + m.slice(k - f));
	    } else {
	      m = s + m;
	    } return m;
	  }
	});


/***/ },
/* 654 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(6);
	var $fails = __webpack_require__(26);
	var aNumberValue = __webpack_require__(291);
	var $toPrecision = 1.0.toPrecision;
	
	$export($export.P + $export.F * ($fails(function () {
	  // IE7-
	  return $toPrecision.call(1, undefined) !== '1';
	}) || !$fails(function () {
	  // V8 ~ Android 4.3-
	  $toPrecision.call({});
	})), 'Number', {
	  toPrecision: function toPrecision(precision) {
	    var that = aNumberValue(this, 'Number#toPrecision: incorrect invocation!');
	    return precision === undefined ? $toPrecision.call(that) : $toPrecision.call(that, precision);
	  }
	});


/***/ },
/* 655 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.3.1 Object.assign(target, source)
	var $export = __webpack_require__(6);
	
	$export($export.S + $export.F, 'Object', { assign: __webpack_require__(308) });


/***/ },
/* 656 */
/***/ function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(6);
	// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
	$export($export.S, 'Object', { create: __webpack_require__(104) });


/***/ },
/* 657 */
/***/ function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(6);
	// 19.1.2.3 / 15.2.3.7 Object.defineProperties(O, Properties)
	$export($export.S + $export.F * !__webpack_require__(38), 'Object', { defineProperties: __webpack_require__(309) });


/***/ },
/* 658 */
/***/ function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(6);
	// 19.1.2.4 / 15.2.3.6 Object.defineProperty(O, P, Attributes)
	$export($export.S + $export.F * !__webpack_require__(38), 'Object', { defineProperty: __webpack_require__(39).f });


/***/ },
/* 659 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.2.5 Object.freeze(O)
	var isObject = __webpack_require__(27);
	var meta = __webpack_require__(97).onFreeze;
	
	__webpack_require__(77)('freeze', function ($freeze) {
	  return function freeze(it) {
	    return $freeze && isObject(it) ? $freeze(meta(it)) : it;
	  };
	});


/***/ },
/* 660 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
	var toIObject = __webpack_require__(61);
	var $getOwnPropertyDescriptor = __webpack_require__(59).f;
	
	__webpack_require__(77)('getOwnPropertyDescriptor', function () {
	  return function getOwnPropertyDescriptor(it, key) {
	    return $getOwnPropertyDescriptor(toIObject(it), key);
	  };
	});


/***/ },
/* 661 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.2.7 Object.getOwnPropertyNames(O)
	__webpack_require__(77)('getOwnPropertyNames', function () {
	  return __webpack_require__(310).f;
	});


/***/ },
/* 662 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.2.9 Object.getPrototypeOf(O)
	var toObject = __webpack_require__(43);
	var $getPrototypeOf = __webpack_require__(60);
	
	__webpack_require__(77)('getPrototypeOf', function () {
	  return function getPrototypeOf(it) {
	    return $getPrototypeOf(toObject(it));
	  };
	});


/***/ },
/* 663 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.2.11 Object.isExtensible(O)
	var isObject = __webpack_require__(27);
	
	__webpack_require__(77)('isExtensible', function ($isExtensible) {
	  return function isExtensible(it) {
	    return isObject(it) ? $isExtensible ? $isExtensible(it) : true : false;
	  };
	});


/***/ },
/* 664 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.2.12 Object.isFrozen(O)
	var isObject = __webpack_require__(27);
	
	__webpack_require__(77)('isFrozen', function ($isFrozen) {
	  return function isFrozen(it) {
	    return isObject(it) ? $isFrozen ? $isFrozen(it) : false : true;
	  };
	});


/***/ },
/* 665 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.2.13 Object.isSealed(O)
	var isObject = __webpack_require__(27);
	
	__webpack_require__(77)('isSealed', function ($isSealed) {
	  return function isSealed(it) {
	    return isObject(it) ? $isSealed ? $isSealed(it) : false : true;
	  };
	});


/***/ },
/* 666 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.3.10 Object.is(value1, value2)
	var $export = __webpack_require__(6);
	$export($export.S, 'Object', { is: __webpack_require__(596) });


/***/ },
/* 667 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.2.14 Object.keys(O)
	var toObject = __webpack_require__(43);
	var $keys = __webpack_require__(106);
	
	__webpack_require__(77)('keys', function () {
	  return function keys(it) {
	    return $keys(toObject(it));
	  };
	});


/***/ },
/* 668 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.2.15 Object.preventExtensions(O)
	var isObject = __webpack_require__(27);
	var meta = __webpack_require__(97).onFreeze;
	
	__webpack_require__(77)('preventExtensions', function ($preventExtensions) {
	  return function preventExtensions(it) {
	    return $preventExtensions && isObject(it) ? $preventExtensions(meta(it)) : it;
	  };
	});


/***/ },
/* 669 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.2.17 Object.seal(O)
	var isObject = __webpack_require__(27);
	var meta = __webpack_require__(97).onFreeze;
	
	__webpack_require__(77)('seal', function ($seal) {
	  return function seal(it) {
	    return $seal && isObject(it) ? $seal(meta(it)) : it;
	  };
	});


/***/ },
/* 670 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.3.19 Object.setPrototypeOf(O, proto)
	var $export = __webpack_require__(6);
	$export($export.S, 'Object', { setPrototypeOf: __webpack_require__(220).set });


/***/ },
/* 671 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// 19.1.3.6 Object.prototype.toString()
	var classof = __webpack_require__(138);
	var test = {};
	test[__webpack_require__(34)('toStringTag')] = 'z';
	if (test + '' != '[object z]') {
	  __webpack_require__(53)(Object.prototype, 'toString', function toString() {
	    return '[object ' + classof(this) + ']';
	  }, true);
	}


/***/ },
/* 672 */
/***/ function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(6);
	var $parseFloat = __webpack_require__(314);
	// 18.2.4 parseFloat(string)
	$export($export.G + $export.F * (parseFloat != $parseFloat), { parseFloat: $parseFloat });


/***/ },
/* 673 */
/***/ function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(6);
	var $parseInt = __webpack_require__(315);
	// 18.2.5 parseInt(string, radix)
	$export($export.G + $export.F * (parseInt != $parseInt), { parseInt: $parseInt });


/***/ },
/* 674 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var LIBRARY = __webpack_require__(96);
	var global = __webpack_require__(24);
	var ctx = __webpack_require__(71);
	var classof = __webpack_require__(138);
	var $export = __webpack_require__(6);
	var isObject = __webpack_require__(27);
	var aFunction = __webpack_require__(50);
	var anInstance = __webpack_require__(102);
	var forOf = __webpack_require__(103);
	var speciesConstructor = __webpack_require__(166);
	var task = __webpack_require__(226).set;
	var microtask = __webpack_require__(218)();
	var newPromiseCapabilityModule = __webpack_require__(219);
	var perform = __webpack_require__(316);
	var userAgent = __webpack_require__(168);
	var promiseResolve = __webpack_require__(317);
	var PROMISE = 'Promise';
	var TypeError = global.TypeError;
	var process = global.process;
	var versions = process && process.versions;
	var v8 = versions && versions.v8 || '';
	var $Promise = global[PROMISE];
	var isNode = classof(process) == 'process';
	var empty = function () { /* empty */ };
	var Internal, newGenericPromiseCapability, OwnPromiseCapability, Wrapper;
	var newPromiseCapability = newGenericPromiseCapability = newPromiseCapabilityModule.f;
	
	var USE_NATIVE = !!function () {
	  try {
	    // correct subclassing with @@species support
	    var promise = $Promise.resolve(1);
	    var FakePromise = (promise.constructor = {})[__webpack_require__(34)('species')] = function (exec) {
	      exec(empty, empty);
	    };
	    // unhandled rejections tracking support, NodeJS Promise without it fails @@species test
	    return (isNode || typeof PromiseRejectionEvent == 'function')
	      && promise.then(empty) instanceof FakePromise
	      // v8 6.6 (Node 10 and Chrome 66) have a bug with resolving custom thenables
	      // https://bugs.chromium.org/p/chromium/issues/detail?id=830565
	      // we can't detect it synchronously, so just check versions
	      && v8.indexOf('6.6') !== 0
	      && userAgent.indexOf('Chrome/66') === -1;
	  } catch (e) { /* empty */ }
	}();
	
	// helpers
	var isThenable = function (it) {
	  var then;
	  return isObject(it) && typeof (then = it.then) == 'function' ? then : false;
	};
	var notify = function (promise, isReject) {
	  if (promise._n) return;
	  promise._n = true;
	  var chain = promise._c;
	  microtask(function () {
	    var value = promise._v;
	    var ok = promise._s == 1;
	    var i = 0;
	    var run = function (reaction) {
	      var handler = ok ? reaction.ok : reaction.fail;
	      var resolve = reaction.resolve;
	      var reject = reaction.reject;
	      var domain = reaction.domain;
	      var result, then, exited;
	      try {
	        if (handler) {
	          if (!ok) {
	            if (promise._h == 2) onHandleUnhandled(promise);
	            promise._h = 1;
	          }
	          if (handler === true) result = value;
	          else {
	            if (domain) domain.enter();
	            result = handler(value); // may throw
	            if (domain) {
	              domain.exit();
	              exited = true;
	            }
	          }
	          if (result === reaction.promise) {
	            reject(TypeError('Promise-chain cycle'));
	          } else if (then = isThenable(result)) {
	            then.call(result, resolve, reject);
	          } else resolve(result);
	        } else reject(value);
	      } catch (e) {
	        if (domain && !exited) domain.exit();
	        reject(e);
	      }
	    };
	    while (chain.length > i) run(chain[i++]); // variable length - can't use forEach
	    promise._c = [];
	    promise._n = false;
	    if (isReject && !promise._h) onUnhandled(promise);
	  });
	};
	var onUnhandled = function (promise) {
	  task.call(global, function () {
	    var value = promise._v;
	    var unhandled = isUnhandled(promise);
	    var result, handler, console;
	    if (unhandled) {
	      result = perform(function () {
	        if (isNode) {
	          process.emit('unhandledRejection', value, promise);
	        } else if (handler = global.onunhandledrejection) {
	          handler({ promise: promise, reason: value });
	        } else if ((console = global.console) && console.error) {
	          console.error('Unhandled promise rejection', value);
	        }
	      });
	      // Browsers should not trigger `rejectionHandled` event if it was handled here, NodeJS - should
	      promise._h = isNode || isUnhandled(promise) ? 2 : 1;
	    } promise._a = undefined;
	    if (unhandled && result.e) throw result.v;
	  });
	};
	var isUnhandled = function (promise) {
	  return promise._h !== 1 && (promise._a || promise._c).length === 0;
	};
	var onHandleUnhandled = function (promise) {
	  task.call(global, function () {
	    var handler;
	    if (isNode) {
	      process.emit('rejectionHandled', promise);
	    } else if (handler = global.onrejectionhandled) {
	      handler({ promise: promise, reason: promise._v });
	    }
	  });
	};
	var $reject = function (value) {
	  var promise = this;
	  if (promise._d) return;
	  promise._d = true;
	  promise = promise._w || promise; // unwrap
	  promise._v = value;
	  promise._s = 2;
	  if (!promise._a) promise._a = promise._c.slice();
	  notify(promise, true);
	};
	var $resolve = function (value) {
	  var promise = this;
	  var then;
	  if (promise._d) return;
	  promise._d = true;
	  promise = promise._w || promise; // unwrap
	  try {
	    if (promise === value) throw TypeError("Promise can't be resolved itself");
	    if (then = isThenable(value)) {
	      microtask(function () {
	        var wrapper = { _w: promise, _d: false }; // wrap
	        try {
	          then.call(value, ctx($resolve, wrapper, 1), ctx($reject, wrapper, 1));
	        } catch (e) {
	          $reject.call(wrapper, e);
	        }
	      });
	    } else {
	      promise._v = value;
	      promise._s = 1;
	      notify(promise, false);
	    }
	  } catch (e) {
	    $reject.call({ _w: promise, _d: false }, e); // wrap
	  }
	};
	
	// constructor polyfill
	if (!USE_NATIVE) {
	  // 25.4.3.1 Promise(executor)
	  $Promise = function Promise(executor) {
	    anInstance(this, $Promise, PROMISE, '_h');
	    aFunction(executor);
	    Internal.call(this);
	    try {
	      executor(ctx($resolve, this, 1), ctx($reject, this, 1));
	    } catch (err) {
	      $reject.call(this, err);
	    }
	  };
	  // eslint-disable-next-line no-unused-vars
	  Internal = function Promise(executor) {
	    this._c = [];             // <- awaiting reactions
	    this._a = undefined;      // <- checked in isUnhandled reactions
	    this._s = 0;              // <- state
	    this._d = false;          // <- done
	    this._v = undefined;      // <- value
	    this._h = 0;              // <- rejection state, 0 - default, 1 - handled, 2 - unhandled
	    this._n = false;          // <- notify
	  };
	  Internal.prototype = __webpack_require__(108)($Promise.prototype, {
	    // 25.4.5.3 Promise.prototype.then(onFulfilled, onRejected)
	    then: function then(onFulfilled, onRejected) {
	      var reaction = newPromiseCapability(speciesConstructor(this, $Promise));
	      reaction.ok = typeof onFulfilled == 'function' ? onFulfilled : true;
	      reaction.fail = typeof onRejected == 'function' && onRejected;
	      reaction.domain = isNode ? process.domain : undefined;
	      this._c.push(reaction);
	      if (this._a) this._a.push(reaction);
	      if (this._s) notify(this, false);
	      return reaction.promise;
	    },
	    // 25.4.5.1 Promise.prototype.catch(onRejected)
	    'catch': function (onRejected) {
	      return this.then(undefined, onRejected);
	    }
	  });
	  OwnPromiseCapability = function () {
	    var promise = new Internal();
	    this.promise = promise;
	    this.resolve = ctx($resolve, promise, 1);
	    this.reject = ctx($reject, promise, 1);
	  };
	  newPromiseCapabilityModule.f = newPromiseCapability = function (C) {
	    return C === $Promise || C === Wrapper
	      ? new OwnPromiseCapability(C)
	      : newGenericPromiseCapability(C);
	  };
	}
	
	$export($export.G + $export.W + $export.F * !USE_NATIVE, { Promise: $Promise });
	__webpack_require__(117)($Promise, PROMISE);
	__webpack_require__(109)(PROMISE);
	Wrapper = __webpack_require__(70)[PROMISE];
	
	// statics
	$export($export.S + $export.F * !USE_NATIVE, PROMISE, {
	  // 25.4.4.5 Promise.reject(r)
	  reject: function reject(r) {
	    var capability = newPromiseCapability(this);
	    var $$reject = capability.reject;
	    $$reject(r);
	    return capability.promise;
	  }
	});
	$export($export.S + $export.F * (LIBRARY || !USE_NATIVE), PROMISE, {
	  // 25.4.4.6 Promise.resolve(x)
	  resolve: function resolve(x) {
	    return promiseResolve(LIBRARY && this === Wrapper ? $Promise : this, x);
	  }
	});
	$export($export.S + $export.F * !(USE_NATIVE && __webpack_require__(160)(function (iter) {
	  $Promise.all(iter)['catch'](empty);
	})), PROMISE, {
	  // 25.4.4.1 Promise.all(iterable)
	  all: function all(iterable) {
	    var C = this;
	    var capability = newPromiseCapability(C);
	    var resolve = capability.resolve;
	    var reject = capability.reject;
	    var result = perform(function () {
	      var values = [];
	      var index = 0;
	      var remaining = 1;
	      forOf(iterable, false, function (promise) {
	        var $index = index++;
	        var alreadyCalled = false;
	        values.push(undefined);
	        remaining++;
	        C.resolve(promise).then(function (value) {
	          if (alreadyCalled) return;
	          alreadyCalled = true;
	          values[$index] = value;
	          --remaining || resolve(values);
	        }, reject);
	      });
	      --remaining || resolve(values);
	    });
	    if (result.e) reject(result.v);
	    return capability.promise;
	  },
	  // 25.4.4.4 Promise.race(iterable)
	  race: function race(iterable) {
	    var C = this;
	    var capability = newPromiseCapability(C);
	    var reject = capability.reject;
	    var result = perform(function () {
	      forOf(iterable, false, function (promise) {
	        C.resolve(promise).then(capability.resolve, reject);
	      });
	    });
	    if (result.e) reject(result.v);
	    return capability.promise;
	  }
	});


/***/ },
/* 675 */
/***/ function(module, exports, __webpack_require__) {

	// 26.1.1 Reflect.apply(target, thisArgument, argumentsList)
	var $export = __webpack_require__(6);
	var aFunction = __webpack_require__(50);
	var anObject = __webpack_require__(23);
	var rApply = (__webpack_require__(24).Reflect || {}).apply;
	var fApply = Function.apply;
	// MS Edge argumentsList argument is optional
	$export($export.S + $export.F * !__webpack_require__(26)(function () {
	  rApply(function () { /* empty */ });
	}), 'Reflect', {
	  apply: function apply(target, thisArgument, argumentsList) {
	    var T = aFunction(target);
	    var L = anObject(argumentsList);
	    return rApply ? rApply(T, thisArgument, L) : fApply.call(T, thisArgument, L);
	  }
	});


/***/ },
/* 676 */
/***/ function(module, exports, __webpack_require__) {

	// 26.1.2 Reflect.construct(target, argumentsList [, newTarget])
	var $export = __webpack_require__(6);
	var create = __webpack_require__(104);
	var aFunction = __webpack_require__(50);
	var anObject = __webpack_require__(23);
	var isObject = __webpack_require__(27);
	var fails = __webpack_require__(26);
	var bind = __webpack_require__(295);
	var rConstruct = (__webpack_require__(24).Reflect || {}).construct;
	
	// MS Edge supports only 2 arguments and argumentsList argument is optional
	// FF Nightly sets third argument as `new.target`, but does not create `this` from it
	var NEW_TARGET_BUG = fails(function () {
	  function F() { /* empty */ }
	  return !(rConstruct(function () { /* empty */ }, [], F) instanceof F);
	});
	var ARGS_BUG = !fails(function () {
	  rConstruct(function () { /* empty */ });
	});
	
	$export($export.S + $export.F * (NEW_TARGET_BUG || ARGS_BUG), 'Reflect', {
	  construct: function construct(Target, args /* , newTarget */) {
	    aFunction(Target);
	    anObject(args);
	    var newTarget = arguments.length < 3 ? Target : aFunction(arguments[2]);
	    if (ARGS_BUG && !NEW_TARGET_BUG) return rConstruct(Target, args, newTarget);
	    if (Target == newTarget) {
	      // w/o altered newTarget, optimization for 0-4 arguments
	      switch (args.length) {
	        case 0: return new Target();
	        case 1: return new Target(args[0]);
	        case 2: return new Target(args[0], args[1]);
	        case 3: return new Target(args[0], args[1], args[2]);
	        case 4: return new Target(args[0], args[1], args[2], args[3]);
	      }
	      // w/o altered newTarget, lot of arguments case
	      var $args = [null];
	      $args.push.apply($args, args);
	      return new (bind.apply(Target, $args))();
	    }
	    // with altered newTarget, not support built-in constructors
	    var proto = newTarget.prototype;
	    var instance = create(isObject(proto) ? proto : Object.prototype);
	    var result = Function.apply.call(Target, instance, args);
	    return isObject(result) ? result : instance;
	  }
	});


/***/ },
/* 677 */
/***/ function(module, exports, __webpack_require__) {

	// 26.1.3 Reflect.defineProperty(target, propertyKey, attributes)
	var dP = __webpack_require__(39);
	var $export = __webpack_require__(6);
	var anObject = __webpack_require__(23);
	var toPrimitive = __webpack_require__(79);
	
	// MS Edge has broken Reflect.defineProperty - throwing instead of returning false
	$export($export.S + $export.F * __webpack_require__(26)(function () {
	  // eslint-disable-next-line no-undef
	  Reflect.defineProperty(dP.f({}, 1, { value: 1 }), 1, { value: 2 });
	}), 'Reflect', {
	  defineProperty: function defineProperty(target, propertyKey, attributes) {
	    anObject(target);
	    propertyKey = toPrimitive(propertyKey, true);
	    anObject(attributes);
	    try {
	      dP.f(target, propertyKey, attributes);
	      return true;
	    } catch (e) {
	      return false;
	    }
	  }
	});


/***/ },
/* 678 */
/***/ function(module, exports, __webpack_require__) {

	// 26.1.4 Reflect.deleteProperty(target, propertyKey)
	var $export = __webpack_require__(6);
	var gOPD = __webpack_require__(59).f;
	var anObject = __webpack_require__(23);
	
	$export($export.S, 'Reflect', {
	  deleteProperty: function deleteProperty(target, propertyKey) {
	    var desc = gOPD(anObject(target), propertyKey);
	    return desc && !desc.configurable ? false : delete target[propertyKey];
	  }
	});


/***/ },
/* 679 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// 26.1.5 Reflect.enumerate(target)
	var $export = __webpack_require__(6);
	var anObject = __webpack_require__(23);
	var Enumerate = function (iterated) {
	  this._t = anObject(iterated); // target
	  this._i = 0;                  // next index
	  var keys = this._k = [];      // keys
	  var key;
	  for (key in iterated) keys.push(key);
	};
	__webpack_require__(214)(Enumerate, 'Object', function () {
	  var that = this;
	  var keys = that._k;
	  var key;
	  do {
	    if (that._i >= keys.length) return { value: undefined, done: true };
	  } while (!((key = keys[that._i++]) in that._t));
	  return { value: key, done: false };
	});
	
	$export($export.S, 'Reflect', {
	  enumerate: function enumerate(target) {
	    return new Enumerate(target);
	  }
	});


/***/ },
/* 680 */
/***/ function(module, exports, __webpack_require__) {

	// 26.1.7 Reflect.getOwnPropertyDescriptor(target, propertyKey)
	var gOPD = __webpack_require__(59);
	var $export = __webpack_require__(6);
	var anObject = __webpack_require__(23);
	
	$export($export.S, 'Reflect', {
	  getOwnPropertyDescriptor: function getOwnPropertyDescriptor(target, propertyKey) {
	    return gOPD.f(anObject(target), propertyKey);
	  }
	});


/***/ },
/* 681 */
/***/ function(module, exports, __webpack_require__) {

	// 26.1.8 Reflect.getPrototypeOf(target)
	var $export = __webpack_require__(6);
	var getProto = __webpack_require__(60);
	var anObject = __webpack_require__(23);
	
	$export($export.S, 'Reflect', {
	  getPrototypeOf: function getPrototypeOf(target) {
	    return getProto(anObject(target));
	  }
	});


/***/ },
/* 682 */
/***/ function(module, exports, __webpack_require__) {

	// 26.1.6 Reflect.get(target, propertyKey [, receiver])
	var gOPD = __webpack_require__(59);
	var getPrototypeOf = __webpack_require__(60);
	var has = __webpack_require__(58);
	var $export = __webpack_require__(6);
	var isObject = __webpack_require__(27);
	var anObject = __webpack_require__(23);
	
	function get(target, propertyKey /* , receiver */) {
	  var receiver = arguments.length < 3 ? target : arguments[2];
	  var desc, proto;
	  if (anObject(target) === receiver) return target[propertyKey];
	  if (desc = gOPD.f(target, propertyKey)) return has(desc, 'value')
	    ? desc.value
	    : desc.get !== undefined
	      ? desc.get.call(receiver)
	      : undefined;
	  if (isObject(proto = getPrototypeOf(target))) return get(proto, propertyKey, receiver);
	}
	
	$export($export.S, 'Reflect', { get: get });


/***/ },
/* 683 */
/***/ function(module, exports, __webpack_require__) {

	// 26.1.9 Reflect.has(target, propertyKey)
	var $export = __webpack_require__(6);
	
	$export($export.S, 'Reflect', {
	  has: function has(target, propertyKey) {
	    return propertyKey in target;
	  }
	});


/***/ },
/* 684 */
/***/ function(module, exports, __webpack_require__) {

	// 26.1.10 Reflect.isExtensible(target)
	var $export = __webpack_require__(6);
	var anObject = __webpack_require__(23);
	var $isExtensible = Object.isExtensible;
	
	$export($export.S, 'Reflect', {
	  isExtensible: function isExtensible(target) {
	    anObject(target);
	    return $isExtensible ? $isExtensible(target) : true;
	  }
	});


/***/ },
/* 685 */
/***/ function(module, exports, __webpack_require__) {

	// 26.1.11 Reflect.ownKeys(target)
	var $export = __webpack_require__(6);
	
	$export($export.S, 'Reflect', { ownKeys: __webpack_require__(313) });


/***/ },
/* 686 */
/***/ function(module, exports, __webpack_require__) {

	// 26.1.12 Reflect.preventExtensions(target)
	var $export = __webpack_require__(6);
	var anObject = __webpack_require__(23);
	var $preventExtensions = Object.preventExtensions;
	
	$export($export.S, 'Reflect', {
	  preventExtensions: function preventExtensions(target) {
	    anObject(target);
	    try {
	      if ($preventExtensions) $preventExtensions(target);
	      return true;
	    } catch (e) {
	      return false;
	    }
	  }
	});


/***/ },
/* 687 */
/***/ function(module, exports, __webpack_require__) {

	// 26.1.14 Reflect.setPrototypeOf(target, proto)
	var $export = __webpack_require__(6);
	var setProto = __webpack_require__(220);
	
	if (setProto) $export($export.S, 'Reflect', {
	  setPrototypeOf: function setPrototypeOf(target, proto) {
	    setProto.check(target, proto);
	    try {
	      setProto.set(target, proto);
	      return true;
	    } catch (e) {
	      return false;
	    }
	  }
	});


/***/ },
/* 688 */
/***/ function(module, exports, __webpack_require__) {

	// 26.1.13 Reflect.set(target, propertyKey, V [, receiver])
	var dP = __webpack_require__(39);
	var gOPD = __webpack_require__(59);
	var getPrototypeOf = __webpack_require__(60);
	var has = __webpack_require__(58);
	var $export = __webpack_require__(6);
	var createDesc = __webpack_require__(107);
	var anObject = __webpack_require__(23);
	var isObject = __webpack_require__(27);
	
	function set(target, propertyKey, V /* , receiver */) {
	  var receiver = arguments.length < 4 ? target : arguments[3];
	  var ownDesc = gOPD.f(anObject(target), propertyKey);
	  var existingDescriptor, proto;
	  if (!ownDesc) {
	    if (isObject(proto = getPrototypeOf(target))) {
	      return set(proto, propertyKey, V, receiver);
	    }
	    ownDesc = createDesc(0);
	  }
	  if (has(ownDesc, 'value')) {
	    if (ownDesc.writable === false || !isObject(receiver)) return false;
	    if (existingDescriptor = gOPD.f(receiver, propertyKey)) {
	      if (existingDescriptor.get || existingDescriptor.set || existingDescriptor.writable === false) return false;
	      existingDescriptor.value = V;
	      dP.f(receiver, propertyKey, existingDescriptor);
	    } else dP.f(receiver, propertyKey, createDesc(0, V));
	    return true;
	  }
	  return ownDesc.set === undefined ? false : (ownDesc.set.call(receiver, V), true);
	}
	
	$export($export.S, 'Reflect', { set: set });


/***/ },
/* 689 */
/***/ function(module, exports, __webpack_require__) {

	var global = __webpack_require__(24);
	var inheritIfRequired = __webpack_require__(212);
	var dP = __webpack_require__(39).f;
	var gOPN = __webpack_require__(105).f;
	var isRegExp = __webpack_require__(159);
	var $flags = __webpack_require__(157);
	var $RegExp = global.RegExp;
	var Base = $RegExp;
	var proto = $RegExp.prototype;
	var re1 = /a/g;
	var re2 = /a/g;
	// "new" creates a new object, old webkit buggy here
	var CORRECT_NEW = new $RegExp(re1) !== re1;
	
	if (__webpack_require__(38) && (!CORRECT_NEW || __webpack_require__(26)(function () {
	  re2[__webpack_require__(34)('match')] = false;
	  // RegExp constructor can alter flags and IsRegExp works correct with @@match
	  return $RegExp(re1) != re1 || $RegExp(re2) == re2 || $RegExp(re1, 'i') != '/a/i';
	}))) {
	  $RegExp = function RegExp(p, f) {
	    var tiRE = this instanceof $RegExp;
	    var piRE = isRegExp(p);
	    var fiU = f === undefined;
	    return !tiRE && piRE && p.constructor === $RegExp && fiU ? p
	      : inheritIfRequired(CORRECT_NEW
	        ? new Base(piRE && !fiU ? p.source : p, f)
	        : Base((piRE = p instanceof $RegExp) ? p.source : p, piRE && fiU ? $flags.call(p) : f)
	      , tiRE ? this : proto, $RegExp);
	  };
	  var proxy = function (key) {
	    key in $RegExp || dP($RegExp, key, {
	      configurable: true,
	      get: function () { return Base[key]; },
	      set: function (it) { Base[key] = it; }
	    });
	  };
	  for (var keys = gOPN(Base), i = 0; keys.length > i;) proxy(keys[i++]);
	  proto.constructor = $RegExp;
	  $RegExp.prototype = proto;
	  __webpack_require__(53)(global, 'RegExp', $RegExp);
	}
	
	__webpack_require__(109)('RegExp');


/***/ },
/* 690 */
/***/ function(module, exports, __webpack_require__) {

	// @@match logic
	__webpack_require__(156)('match', 1, function (defined, MATCH, $match) {
	  // 21.1.3.11 String.prototype.match(regexp)
	  return [function match(regexp) {
	    'use strict';
	    var O = defined(this);
	    var fn = regexp == undefined ? undefined : regexp[MATCH];
	    return fn !== undefined ? fn.call(regexp, O) : new RegExp(regexp)[MATCH](String(O));
	  }, $match];
	});


/***/ },
/* 691 */
/***/ function(module, exports, __webpack_require__) {

	// @@replace logic
	__webpack_require__(156)('replace', 2, function (defined, REPLACE, $replace) {
	  // 21.1.3.14 String.prototype.replace(searchValue, replaceValue)
	  return [function replace(searchValue, replaceValue) {
	    'use strict';
	    var O = defined(this);
	    var fn = searchValue == undefined ? undefined : searchValue[REPLACE];
	    return fn !== undefined
	      ? fn.call(searchValue, O, replaceValue)
	      : $replace.call(String(O), searchValue, replaceValue);
	  }, $replace];
	});


/***/ },
/* 692 */
/***/ function(module, exports, __webpack_require__) {

	// @@search logic
	__webpack_require__(156)('search', 1, function (defined, SEARCH, $search) {
	  // 21.1.3.15 String.prototype.search(regexp)
	  return [function search(regexp) {
	    'use strict';
	    var O = defined(this);
	    var fn = regexp == undefined ? undefined : regexp[SEARCH];
	    return fn !== undefined ? fn.call(regexp, O) : new RegExp(regexp)[SEARCH](String(O));
	  }, $search];
	});


/***/ },
/* 693 */
/***/ function(module, exports, __webpack_require__) {

	// @@split logic
	__webpack_require__(156)('split', 2, function (defined, SPLIT, $split) {
	  'use strict';
	  var isRegExp = __webpack_require__(159);
	  var _split = $split;
	  var $push = [].push;
	  var $SPLIT = 'split';
	  var LENGTH = 'length';
	  var LAST_INDEX = 'lastIndex';
	  if (
	    'abbc'[$SPLIT](/(b)*/)[1] == 'c' ||
	    'test'[$SPLIT](/(?:)/, -1)[LENGTH] != 4 ||
	    'ab'[$SPLIT](/(?:ab)*/)[LENGTH] != 2 ||
	    '.'[$SPLIT](/(.?)(.?)/)[LENGTH] != 4 ||
	    '.'[$SPLIT](/()()/)[LENGTH] > 1 ||
	    ''[$SPLIT](/.?/)[LENGTH]
	  ) {
	    var NPCG = /()??/.exec('')[1] === undefined; // nonparticipating capturing group
	    // based on es5-shim implementation, need to rework it
	    $split = function (separator, limit) {
	      var string = String(this);
	      if (separator === undefined && limit === 0) return [];
	      // If `separator` is not a regex, use native split
	      if (!isRegExp(separator)) return _split.call(string, separator, limit);
	      var output = [];
	      var flags = (separator.ignoreCase ? 'i' : '') +
	                  (separator.multiline ? 'm' : '') +
	                  (separator.unicode ? 'u' : '') +
	                  (separator.sticky ? 'y' : '');
	      var lastLastIndex = 0;
	      var splitLimit = limit === undefined ? 4294967295 : limit >>> 0;
	      // Make `global` and avoid `lastIndex` issues by working with a copy
	      var separatorCopy = new RegExp(separator.source, flags + 'g');
	      var separator2, match, lastIndex, lastLength, i;
	      // Doesn't need flags gy, but they don't hurt
	      if (!NPCG) separator2 = new RegExp('^' + separatorCopy.source + '$(?!\\s)', flags);
	      while (match = separatorCopy.exec(string)) {
	        // `separatorCopy.lastIndex` is not reliable cross-browser
	        lastIndex = match.index + match[0][LENGTH];
	        if (lastIndex > lastLastIndex) {
	          output.push(string.slice(lastLastIndex, match.index));
	          // Fix browsers whose `exec` methods don't consistently return `undefined` for NPCG
	          // eslint-disable-next-line no-loop-func
	          if (!NPCG && match[LENGTH] > 1) match[0].replace(separator2, function () {
	            for (i = 1; i < arguments[LENGTH] - 2; i++) if (arguments[i] === undefined) match[i] = undefined;
	          });
	          if (match[LENGTH] > 1 && match.index < string[LENGTH]) $push.apply(output, match.slice(1));
	          lastLength = match[0][LENGTH];
	          lastLastIndex = lastIndex;
	          if (output[LENGTH] >= splitLimit) break;
	        }
	        if (separatorCopy[LAST_INDEX] === match.index) separatorCopy[LAST_INDEX]++; // Avoid an infinite loop
	      }
	      if (lastLastIndex === string[LENGTH]) {
	        if (lastLength || !separatorCopy.test('')) output.push('');
	      } else output.push(string.slice(lastLastIndex));
	      return output[LENGTH] > splitLimit ? output.slice(0, splitLimit) : output;
	    };
	  // Chakra, V8
	  } else if ('0'[$SPLIT](undefined, 0)[LENGTH]) {
	    $split = function (separator, limit) {
	      return separator === undefined && limit === 0 ? [] : _split.call(this, separator, limit);
	    };
	  }
	  // 21.1.3.17 String.prototype.split(separator, limit)
	  return [function split(separator, limit) {
	    var O = defined(this);
	    var fn = separator == undefined ? undefined : separator[SPLIT];
	    return fn !== undefined ? fn.call(separator, O, limit) : $split.call(String(O), separator, limit);
	  }, $split];
	});


/***/ },
/* 694 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	__webpack_require__(322);
	var anObject = __webpack_require__(23);
	var $flags = __webpack_require__(157);
	var DESCRIPTORS = __webpack_require__(38);
	var TO_STRING = 'toString';
	var $toString = /./[TO_STRING];
	
	var define = function (fn) {
	  __webpack_require__(53)(RegExp.prototype, TO_STRING, fn, true);
	};
	
	// 21.2.5.14 RegExp.prototype.toString()
	if (__webpack_require__(26)(function () { return $toString.call({ source: 'a', flags: 'b' }) != '/a/b'; })) {
	  define(function toString() {
	    var R = anObject(this);
	    return '/'.concat(R.source, '/',
	      'flags' in R ? R.flags : !DESCRIPTORS && R instanceof RegExp ? $flags.call(R) : undefined);
	  });
	// FF44- RegExp#toString has a wrong name
	} else if ($toString.name != TO_STRING) {
	  define(function toString() {
	    return $toString.call(this);
	  });
	}


/***/ },
/* 695 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.2 String.prototype.anchor(name)
	__webpack_require__(54)('anchor', function (createHTML) {
	  return function anchor(name) {
	    return createHTML(this, 'a', 'name', name);
	  };
	});


/***/ },
/* 696 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.3 String.prototype.big()
	__webpack_require__(54)('big', function (createHTML) {
	  return function big() {
	    return createHTML(this, 'big', '', '');
	  };
	});


/***/ },
/* 697 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.4 String.prototype.blink()
	__webpack_require__(54)('blink', function (createHTML) {
	  return function blink() {
	    return createHTML(this, 'blink', '', '');
	  };
	});


/***/ },
/* 698 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.5 String.prototype.bold()
	__webpack_require__(54)('bold', function (createHTML) {
	  return function bold() {
	    return createHTML(this, 'b', '', '');
	  };
	});


/***/ },
/* 699 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(6);
	var $at = __webpack_require__(222)(false);
	$export($export.P, 'String', {
	  // 21.1.3.3 String.prototype.codePointAt(pos)
	  codePointAt: function codePointAt(pos) {
	    return $at(this, pos);
	  }
	});


/***/ },
/* 700 */
/***/ function(module, exports, __webpack_require__) {

	// 21.1.3.6 String.prototype.endsWith(searchString [, endPosition])
	'use strict';
	var $export = __webpack_require__(6);
	var toLength = __webpack_require__(40);
	var context = __webpack_require__(223);
	var ENDS_WITH = 'endsWith';
	var $endsWith = ''[ENDS_WITH];
	
	$export($export.P + $export.F * __webpack_require__(210)(ENDS_WITH), 'String', {
	  endsWith: function endsWith(searchString /* , endPosition = @length */) {
	    var that = context(this, searchString, ENDS_WITH);
	    var endPosition = arguments.length > 1 ? arguments[1] : undefined;
	    var len = toLength(that.length);
	    var end = endPosition === undefined ? len : Math.min(toLength(endPosition), len);
	    var search = String(searchString);
	    return $endsWith
	      ? $endsWith.call(that, search, end)
	      : that.slice(end - search.length, end) === search;
	  }
	});


/***/ },
/* 701 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.6 String.prototype.fixed()
	__webpack_require__(54)('fixed', function (createHTML) {
	  return function fixed() {
	    return createHTML(this, 'tt', '', '');
	  };
	});


/***/ },
/* 702 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.7 String.prototype.fontcolor(color)
	__webpack_require__(54)('fontcolor', function (createHTML) {
	  return function fontcolor(color) {
	    return createHTML(this, 'font', 'color', color);
	  };
	});


/***/ },
/* 703 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.8 String.prototype.fontsize(size)
	__webpack_require__(54)('fontsize', function (createHTML) {
	  return function fontsize(size) {
	    return createHTML(this, 'font', 'size', size);
	  };
	});


/***/ },
/* 704 */
/***/ function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(6);
	var toAbsoluteIndex = __webpack_require__(110);
	var fromCharCode = String.fromCharCode;
	var $fromCodePoint = String.fromCodePoint;
	
	// length should be 1, old FF problem
	$export($export.S + $export.F * (!!$fromCodePoint && $fromCodePoint.length != 1), 'String', {
	  // 21.1.2.2 String.fromCodePoint(...codePoints)
	  fromCodePoint: function fromCodePoint(x) { // eslint-disable-line no-unused-vars
	    var res = [];
	    var aLen = arguments.length;
	    var i = 0;
	    var code;
	    while (aLen > i) {
	      code = +arguments[i++];
	      if (toAbsoluteIndex(code, 0x10ffff) !== code) throw RangeError(code + ' is not a valid code point');
	      res.push(code < 0x10000
	        ? fromCharCode(code)
	        : fromCharCode(((code -= 0x10000) >> 10) + 0xd800, code % 0x400 + 0xdc00)
	      );
	    } return res.join('');
	  }
	});


/***/ },
/* 705 */
/***/ function(module, exports, __webpack_require__) {

	// 21.1.3.7 String.prototype.includes(searchString, position = 0)
	'use strict';
	var $export = __webpack_require__(6);
	var context = __webpack_require__(223);
	var INCLUDES = 'includes';
	
	$export($export.P + $export.F * __webpack_require__(210)(INCLUDES), 'String', {
	  includes: function includes(searchString /* , position = 0 */) {
	    return !!~context(this, searchString, INCLUDES)
	      .indexOf(searchString, arguments.length > 1 ? arguments[1] : undefined);
	  }
	});


/***/ },
/* 706 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.9 String.prototype.italics()
	__webpack_require__(54)('italics', function (createHTML) {
	  return function italics() {
	    return createHTML(this, 'i', '', '');
	  };
	});


/***/ },
/* 707 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $at = __webpack_require__(222)(true);
	
	// 21.1.3.27 String.prototype[@@iterator]()
	__webpack_require__(215)(String, 'String', function (iterated) {
	  this._t = String(iterated); // target
	  this._i = 0;                // next index
	// 21.1.5.2.1 %StringIteratorPrototype%.next()
	}, function () {
	  var O = this._t;
	  var index = this._i;
	  var point;
	  if (index >= O.length) return { value: undefined, done: true };
	  point = $at(O, index);
	  this._i += point.length;
	  return { value: point, done: false };
	});


/***/ },
/* 708 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.10 String.prototype.link(url)
	__webpack_require__(54)('link', function (createHTML) {
	  return function link(url) {
	    return createHTML(this, 'a', 'href', url);
	  };
	});


/***/ },
/* 709 */
/***/ function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(6);
	var toIObject = __webpack_require__(61);
	var toLength = __webpack_require__(40);
	
	$export($export.S, 'String', {
	  // 21.1.2.4 String.raw(callSite, ...substitutions)
	  raw: function raw(callSite) {
	    var tpl = toIObject(callSite.raw);
	    var len = toLength(tpl.length);
	    var aLen = arguments.length;
	    var res = [];
	    var i = 0;
	    while (len > i) {
	      res.push(String(tpl[i++]));
	      if (i < aLen) res.push(String(arguments[i]));
	    } return res.join('');
	  }
	});


/***/ },
/* 710 */
/***/ function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(6);
	
	$export($export.P, 'String', {
	  // 21.1.3.13 String.prototype.repeat(count)
	  repeat: __webpack_require__(224)
	});


/***/ },
/* 711 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.11 String.prototype.small()
	__webpack_require__(54)('small', function (createHTML) {
	  return function small() {
	    return createHTML(this, 'small', '', '');
	  };
	});


/***/ },
/* 712 */
/***/ function(module, exports, __webpack_require__) {

	// 21.1.3.18 String.prototype.startsWith(searchString [, position ])
	'use strict';
	var $export = __webpack_require__(6);
	var toLength = __webpack_require__(40);
	var context = __webpack_require__(223);
	var STARTS_WITH = 'startsWith';
	var $startsWith = ''[STARTS_WITH];
	
	$export($export.P + $export.F * __webpack_require__(210)(STARTS_WITH), 'String', {
	  startsWith: function startsWith(searchString /* , position = 0 */) {
	    var that = context(this, searchString, STARTS_WITH);
	    var index = toLength(Math.min(arguments.length > 1 ? arguments[1] : undefined, that.length));
	    var search = String(searchString);
	    return $startsWith
	      ? $startsWith.call(that, search, index)
	      : that.slice(index, index + search.length) === search;
	  }
	});


/***/ },
/* 713 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.12 String.prototype.strike()
	__webpack_require__(54)('strike', function (createHTML) {
	  return function strike() {
	    return createHTML(this, 'strike', '', '');
	  };
	});


/***/ },
/* 714 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.13 String.prototype.sub()
	__webpack_require__(54)('sub', function (createHTML) {
	  return function sub() {
	    return createHTML(this, 'sub', '', '');
	  };
	});


/***/ },
/* 715 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.14 String.prototype.sup()
	__webpack_require__(54)('sup', function (createHTML) {
	  return function sup() {
	    return createHTML(this, 'sup', '', '');
	  };
	});


/***/ },
/* 716 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// 21.1.3.25 String.prototype.trim()
	__webpack_require__(118)('trim', function ($trim) {
	  return function trim() {
	    return $trim(this, 3);
	  };
	});


/***/ },
/* 717 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// ECMAScript 6 symbols shim
	var global = __webpack_require__(24);
	var has = __webpack_require__(58);
	var DESCRIPTORS = __webpack_require__(38);
	var $export = __webpack_require__(6);
	var redefine = __webpack_require__(53);
	var META = __webpack_require__(97).KEY;
	var $fails = __webpack_require__(26);
	var shared = __webpack_require__(165);
	var setToStringTag = __webpack_require__(117);
	var uid = __webpack_require__(111);
	var wks = __webpack_require__(34);
	var wksExt = __webpack_require__(320);
	var wksDefine = __webpack_require__(228);
	var enumKeys = __webpack_require__(594);
	var isArray = __webpack_require__(158);
	var anObject = __webpack_require__(23);
	var isObject = __webpack_require__(27);
	var toIObject = __webpack_require__(61);
	var toPrimitive = __webpack_require__(79);
	var createDesc = __webpack_require__(107);
	var _create = __webpack_require__(104);
	var gOPNExt = __webpack_require__(310);
	var $GOPD = __webpack_require__(59);
	var $DP = __webpack_require__(39);
	var $keys = __webpack_require__(106);
	var gOPD = $GOPD.f;
	var dP = $DP.f;
	var gOPN = gOPNExt.f;
	var $Symbol = global.Symbol;
	var $JSON = global.JSON;
	var _stringify = $JSON && $JSON.stringify;
	var PROTOTYPE = 'prototype';
	var HIDDEN = wks('_hidden');
	var TO_PRIMITIVE = wks('toPrimitive');
	var isEnum = {}.propertyIsEnumerable;
	var SymbolRegistry = shared('symbol-registry');
	var AllSymbols = shared('symbols');
	var OPSymbols = shared('op-symbols');
	var ObjectProto = Object[PROTOTYPE];
	var USE_NATIVE = typeof $Symbol == 'function';
	var QObject = global.QObject;
	// Don't use setters in Qt Script, https://github.com/zloirock/core-js/issues/173
	var setter = !QObject || !QObject[PROTOTYPE] || !QObject[PROTOTYPE].findChild;
	
	// fallback for old Android, https://code.google.com/p/v8/issues/detail?id=687
	var setSymbolDesc = DESCRIPTORS && $fails(function () {
	  return _create(dP({}, 'a', {
	    get: function () { return dP(this, 'a', { value: 7 }).a; }
	  })).a != 7;
	}) ? function (it, key, D) {
	  var protoDesc = gOPD(ObjectProto, key);
	  if (protoDesc) delete ObjectProto[key];
	  dP(it, key, D);
	  if (protoDesc && it !== ObjectProto) dP(ObjectProto, key, protoDesc);
	} : dP;
	
	var wrap = function (tag) {
	  var sym = AllSymbols[tag] = _create($Symbol[PROTOTYPE]);
	  sym._k = tag;
	  return sym;
	};
	
	var isSymbol = USE_NATIVE && typeof $Symbol.iterator == 'symbol' ? function (it) {
	  return typeof it == 'symbol';
	} : function (it) {
	  return it instanceof $Symbol;
	};
	
	var $defineProperty = function defineProperty(it, key, D) {
	  if (it === ObjectProto) $defineProperty(OPSymbols, key, D);
	  anObject(it);
	  key = toPrimitive(key, true);
	  anObject(D);
	  if (has(AllSymbols, key)) {
	    if (!D.enumerable) {
	      if (!has(it, HIDDEN)) dP(it, HIDDEN, createDesc(1, {}));
	      it[HIDDEN][key] = true;
	    } else {
	      if (has(it, HIDDEN) && it[HIDDEN][key]) it[HIDDEN][key] = false;
	      D = _create(D, { enumerable: createDesc(0, false) });
	    } return setSymbolDesc(it, key, D);
	  } return dP(it, key, D);
	};
	var $defineProperties = function defineProperties(it, P) {
	  anObject(it);
	  var keys = enumKeys(P = toIObject(P));
	  var i = 0;
	  var l = keys.length;
	  var key;
	  while (l > i) $defineProperty(it, key = keys[i++], P[key]);
	  return it;
	};
	var $create = function create(it, P) {
	  return P === undefined ? _create(it) : $defineProperties(_create(it), P);
	};
	var $propertyIsEnumerable = function propertyIsEnumerable(key) {
	  var E = isEnum.call(this, key = toPrimitive(key, true));
	  if (this === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return false;
	  return E || !has(this, key) || !has(AllSymbols, key) || has(this, HIDDEN) && this[HIDDEN][key] ? E : true;
	};
	var $getOwnPropertyDescriptor = function getOwnPropertyDescriptor(it, key) {
	  it = toIObject(it);
	  key = toPrimitive(key, true);
	  if (it === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return;
	  var D = gOPD(it, key);
	  if (D && has(AllSymbols, key) && !(has(it, HIDDEN) && it[HIDDEN][key])) D.enumerable = true;
	  return D;
	};
	var $getOwnPropertyNames = function getOwnPropertyNames(it) {
	  var names = gOPN(toIObject(it));
	  var result = [];
	  var i = 0;
	  var key;
	  while (names.length > i) {
	    if (!has(AllSymbols, key = names[i++]) && key != HIDDEN && key != META) result.push(key);
	  } return result;
	};
	var $getOwnPropertySymbols = function getOwnPropertySymbols(it) {
	  var IS_OP = it === ObjectProto;
	  var names = gOPN(IS_OP ? OPSymbols : toIObject(it));
	  var result = [];
	  var i = 0;
	  var key;
	  while (names.length > i) {
	    if (has(AllSymbols, key = names[i++]) && (IS_OP ? has(ObjectProto, key) : true)) result.push(AllSymbols[key]);
	  } return result;
	};
	
	// 19.4.1.1 Symbol([description])
	if (!USE_NATIVE) {
	  $Symbol = function Symbol() {
	    if (this instanceof $Symbol) throw TypeError('Symbol is not a constructor!');
	    var tag = uid(arguments.length > 0 ? arguments[0] : undefined);
	    var $set = function (value) {
	      if (this === ObjectProto) $set.call(OPSymbols, value);
	      if (has(this, HIDDEN) && has(this[HIDDEN], tag)) this[HIDDEN][tag] = false;
	      setSymbolDesc(this, tag, createDesc(1, value));
	    };
	    if (DESCRIPTORS && setter) setSymbolDesc(ObjectProto, tag, { configurable: true, set: $set });
	    return wrap(tag);
	  };
	  redefine($Symbol[PROTOTYPE], 'toString', function toString() {
	    return this._k;
	  });
	
	  $GOPD.f = $getOwnPropertyDescriptor;
	  $DP.f = $defineProperty;
	  __webpack_require__(105).f = gOPNExt.f = $getOwnPropertyNames;
	  __webpack_require__(140).f = $propertyIsEnumerable;
	  __webpack_require__(162).f = $getOwnPropertySymbols;
	
	  if (DESCRIPTORS && !__webpack_require__(96)) {
	    redefine(ObjectProto, 'propertyIsEnumerable', $propertyIsEnumerable, true);
	  }
	
	  wksExt.f = function (name) {
	    return wrap(wks(name));
	  };
	}
	
	$export($export.G + $export.W + $export.F * !USE_NATIVE, { Symbol: $Symbol });
	
	for (var es6Symbols = (
	  // 19.4.2.2, 19.4.2.3, 19.4.2.4, 19.4.2.6, 19.4.2.8, 19.4.2.9, 19.4.2.10, 19.4.2.11, 19.4.2.12, 19.4.2.13, 19.4.2.14
	  'hasInstance,isConcatSpreadable,iterator,match,replace,search,species,split,toPrimitive,toStringTag,unscopables'
	).split(','), j = 0; es6Symbols.length > j;)wks(es6Symbols[j++]);
	
	for (var wellKnownSymbols = $keys(wks.store), k = 0; wellKnownSymbols.length > k;) wksDefine(wellKnownSymbols[k++]);
	
	$export($export.S + $export.F * !USE_NATIVE, 'Symbol', {
	  // 19.4.2.1 Symbol.for(key)
	  'for': function (key) {
	    return has(SymbolRegistry, key += '')
	      ? SymbolRegistry[key]
	      : SymbolRegistry[key] = $Symbol(key);
	  },
	  // 19.4.2.5 Symbol.keyFor(sym)
	  keyFor: function keyFor(sym) {
	    if (!isSymbol(sym)) throw TypeError(sym + ' is not a symbol!');
	    for (var key in SymbolRegistry) if (SymbolRegistry[key] === sym) return key;
	  },
	  useSetter: function () { setter = true; },
	  useSimple: function () { setter = false; }
	});
	
	$export($export.S + $export.F * !USE_NATIVE, 'Object', {
	  // 19.1.2.2 Object.create(O [, Properties])
	  create: $create,
	  // 19.1.2.4 Object.defineProperty(O, P, Attributes)
	  defineProperty: $defineProperty,
	  // 19.1.2.3 Object.defineProperties(O, Properties)
	  defineProperties: $defineProperties,
	  // 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
	  getOwnPropertyDescriptor: $getOwnPropertyDescriptor,
	  // 19.1.2.7 Object.getOwnPropertyNames(O)
	  getOwnPropertyNames: $getOwnPropertyNames,
	  // 19.1.2.8 Object.getOwnPropertySymbols(O)
	  getOwnPropertySymbols: $getOwnPropertySymbols
	});
	
	// 24.3.2 JSON.stringify(value [, replacer [, space]])
	$JSON && $export($export.S + $export.F * (!USE_NATIVE || $fails(function () {
	  var S = $Symbol();
	  // MS Edge converts symbol values to JSON as {}
	  // WebKit converts symbol values to JSON as null
	  // V8 throws on boxed symbols
	  return _stringify([S]) != '[null]' || _stringify({ a: S }) != '{}' || _stringify(Object(S)) != '{}';
	})), 'JSON', {
	  stringify: function stringify(it) {
	    var args = [it];
	    var i = 1;
	    var replacer, $replacer;
	    while (arguments.length > i) args.push(arguments[i++]);
	    $replacer = replacer = args[1];
	    if (!isObject(replacer) && it === undefined || isSymbol(it)) return; // IE8 returns string on undefined
	    if (!isArray(replacer)) replacer = function (key, value) {
	      if (typeof $replacer == 'function') value = $replacer.call(this, key, value);
	      if (!isSymbol(value)) return value;
	    };
	    args[1] = replacer;
	    return _stringify.apply($JSON, args);
	  }
	});
	
	// 19.4.3.4 Symbol.prototype[@@toPrimitive](hint)
	$Symbol[PROTOTYPE][TO_PRIMITIVE] || __webpack_require__(52)($Symbol[PROTOTYPE], TO_PRIMITIVE, $Symbol[PROTOTYPE].valueOf);
	// 19.4.3.5 Symbol.prototype[@@toStringTag]
	setToStringTag($Symbol, 'Symbol');
	// 20.2.1.9 Math[@@toStringTag]
	setToStringTag(Math, 'Math', true);
	// 24.3.3 JSON[@@toStringTag]
	setToStringTag(global.JSON, 'JSON', true);


/***/ },
/* 718 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(6);
	var $typed = __webpack_require__(167);
	var buffer = __webpack_require__(227);
	var anObject = __webpack_require__(23);
	var toAbsoluteIndex = __webpack_require__(110);
	var toLength = __webpack_require__(40);
	var isObject = __webpack_require__(27);
	var ArrayBuffer = __webpack_require__(24).ArrayBuffer;
	var speciesConstructor = __webpack_require__(166);
	var $ArrayBuffer = buffer.ArrayBuffer;
	var $DataView = buffer.DataView;
	var $isView = $typed.ABV && ArrayBuffer.isView;
	var $slice = $ArrayBuffer.prototype.slice;
	var VIEW = $typed.VIEW;
	var ARRAY_BUFFER = 'ArrayBuffer';
	
	$export($export.G + $export.W + $export.F * (ArrayBuffer !== $ArrayBuffer), { ArrayBuffer: $ArrayBuffer });
	
	$export($export.S + $export.F * !$typed.CONSTR, ARRAY_BUFFER, {
	  // 24.1.3.1 ArrayBuffer.isView(arg)
	  isView: function isView(it) {
	    return $isView && $isView(it) || isObject(it) && VIEW in it;
	  }
	});
	
	$export($export.P + $export.U + $export.F * __webpack_require__(26)(function () {
	  return !new $ArrayBuffer(2).slice(1, undefined).byteLength;
	}), ARRAY_BUFFER, {
	  // 24.1.4.3 ArrayBuffer.prototype.slice(start, end)
	  slice: function slice(start, end) {
	    if ($slice !== undefined && end === undefined) return $slice.call(anObject(this), start); // FF fix
	    var len = anObject(this).byteLength;
	    var first = toAbsoluteIndex(start, len);
	    var fin = toAbsoluteIndex(end === undefined ? len : end, len);
	    var result = new (speciesConstructor(this, $ArrayBuffer))(toLength(fin - first));
	    var viewS = new $DataView(this);
	    var viewT = new $DataView(result);
	    var index = 0;
	    while (first < fin) {
	      viewT.setUint8(index++, viewS.getUint8(first++));
	    } return result;
	  }
	});
	
	__webpack_require__(109)(ARRAY_BUFFER);


/***/ },
/* 719 */
/***/ function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(6);
	$export($export.G + $export.W + $export.F * !__webpack_require__(167).ABV, {
	  DataView: __webpack_require__(227).DataView
	});


/***/ },
/* 720 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(88)('Float32', 4, function (init) {
	  return function Float32Array(data, byteOffset, length) {
	    return init(this, data, byteOffset, length);
	  };
	});


/***/ },
/* 721 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(88)('Float64', 8, function (init) {
	  return function Float64Array(data, byteOffset, length) {
	    return init(this, data, byteOffset, length);
	  };
	});


/***/ },
/* 722 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(88)('Int16', 2, function (init) {
	  return function Int16Array(data, byteOffset, length) {
	    return init(this, data, byteOffset, length);
	  };
	});


/***/ },
/* 723 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(88)('Int32', 4, function (init) {
	  return function Int32Array(data, byteOffset, length) {
	    return init(this, data, byteOffset, length);
	  };
	});


/***/ },
/* 724 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(88)('Int8', 1, function (init) {
	  return function Int8Array(data, byteOffset, length) {
	    return init(this, data, byteOffset, length);
	  };
	});


/***/ },
/* 725 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(88)('Uint16', 2, function (init) {
	  return function Uint16Array(data, byteOffset, length) {
	    return init(this, data, byteOffset, length);
	  };
	});


/***/ },
/* 726 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(88)('Uint32', 4, function (init) {
	  return function Uint32Array(data, byteOffset, length) {
	    return init(this, data, byteOffset, length);
	  };
	});


/***/ },
/* 727 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(88)('Uint8', 1, function (init) {
	  return function Uint8Array(data, byteOffset, length) {
	    return init(this, data, byteOffset, length);
	  };
	});


/***/ },
/* 728 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(88)('Uint8', 1, function (init) {
	  return function Uint8ClampedArray(data, byteOffset, length) {
	    return init(this, data, byteOffset, length);
	  };
	}, true);


/***/ },
/* 729 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var weak = __webpack_require__(298);
	var validate = __webpack_require__(119);
	var WEAK_SET = 'WeakSet';
	
	// 23.4 WeakSet Objects
	__webpack_require__(155)(WEAK_SET, function (get) {
	  return function WeakSet() { return get(this, arguments.length > 0 ? arguments[0] : undefined); };
	}, {
	  // 23.4.3.1 WeakSet.prototype.add(value)
	  add: function add(value) {
	    return weak.def(validate(this, WEAK_SET), value, true);
	  }
	}, weak, false, true);


/***/ },
/* 730 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// https://tc39.github.io/proposal-flatMap/#sec-Array.prototype.flatMap
	var $export = __webpack_require__(6);
	var flattenIntoArray = __webpack_require__(299);
	var toObject = __webpack_require__(43);
	var toLength = __webpack_require__(40);
	var aFunction = __webpack_require__(50);
	var arraySpeciesCreate = __webpack_require__(206);
	
	$export($export.P, 'Array', {
	  flatMap: function flatMap(callbackfn /* , thisArg */) {
	    var O = toObject(this);
	    var sourceLen, A;
	    aFunction(callbackfn);
	    sourceLen = toLength(O.length);
	    A = arraySpeciesCreate(O, 0);
	    flattenIntoArray(A, O, O, sourceLen, 0, 1, callbackfn, arguments[1]);
	    return A;
	  }
	});
	
	__webpack_require__(95)('flatMap');


/***/ },
/* 731 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// https://tc39.github.io/proposal-flatMap/#sec-Array.prototype.flatten
	var $export = __webpack_require__(6);
	var flattenIntoArray = __webpack_require__(299);
	var toObject = __webpack_require__(43);
	var toLength = __webpack_require__(40);
	var toInteger = __webpack_require__(78);
	var arraySpeciesCreate = __webpack_require__(206);
	
	$export($export.P, 'Array', {
	  flatten: function flatten(/* depthArg = 1 */) {
	    var depthArg = arguments[0];
	    var O = toObject(this);
	    var sourceLen = toLength(O.length);
	    var A = arraySpeciesCreate(O, 0);
	    flattenIntoArray(A, O, O, sourceLen, 0, depthArg === undefined ? 1 : toInteger(depthArg));
	    return A;
	  }
	});
	
	__webpack_require__(95)('flatten');


/***/ },
/* 732 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// https://github.com/tc39/Array.prototype.includes
	var $export = __webpack_require__(6);
	var $includes = __webpack_require__(154)(true);
	
	$export($export.P, 'Array', {
	  includes: function includes(el /* , fromIndex = 0 */) {
	    return $includes(this, el, arguments.length > 1 ? arguments[1] : undefined);
	  }
	});
	
	__webpack_require__(95)('includes');


/***/ },
/* 733 */
/***/ function(module, exports, __webpack_require__) {

	// https://github.com/rwaldron/tc39-notes/blob/master/es6/2014-09/sept-25.md#510-globalasap-for-enqueuing-a-microtask
	var $export = __webpack_require__(6);
	var microtask = __webpack_require__(218)();
	var process = __webpack_require__(24).process;
	var isNode = __webpack_require__(69)(process) == 'process';
	
	$export($export.G, {
	  asap: function asap(fn) {
	    var domain = isNode && process.domain;
	    microtask(domain ? domain.bind(fn) : fn);
	  }
	});


/***/ },
/* 734 */
/***/ function(module, exports, __webpack_require__) {

	// https://github.com/ljharb/proposal-is-error
	var $export = __webpack_require__(6);
	var cof = __webpack_require__(69);
	
	$export($export.S, 'Error', {
	  isError: function isError(it) {
	    return cof(it) === 'Error';
	  }
	});


/***/ },
/* 735 */
/***/ function(module, exports, __webpack_require__) {

	// https://github.com/tc39/proposal-global
	var $export = __webpack_require__(6);
	
	$export($export.G, { global: __webpack_require__(24) });


/***/ },
/* 736 */
/***/ function(module, exports, __webpack_require__) {

	// https://tc39.github.io/proposal-setmap-offrom/#sec-map.from
	__webpack_require__(163)('Map');


/***/ },
/* 737 */
/***/ function(module, exports, __webpack_require__) {

	// https://tc39.github.io/proposal-setmap-offrom/#sec-map.of
	__webpack_require__(164)('Map');


/***/ },
/* 738 */
/***/ function(module, exports, __webpack_require__) {

	// https://github.com/DavidBruant/Map-Set.prototype.toJSON
	var $export = __webpack_require__(6);
	
	$export($export.P + $export.R, 'Map', { toJSON: __webpack_require__(297)('Map') });


/***/ },
/* 739 */
/***/ function(module, exports, __webpack_require__) {

	// https://rwaldron.github.io/proposal-math-extensions/
	var $export = __webpack_require__(6);
	
	$export($export.S, 'Math', {
	  clamp: function clamp(x, lower, upper) {
	    return Math.min(upper, Math.max(lower, x));
	  }
	});


/***/ },
/* 740 */
/***/ function(module, exports, __webpack_require__) {

	// https://rwaldron.github.io/proposal-math-extensions/
	var $export = __webpack_require__(6);
	
	$export($export.S, 'Math', { DEG_PER_RAD: Math.PI / 180 });


/***/ },
/* 741 */
/***/ function(module, exports, __webpack_require__) {

	// https://rwaldron.github.io/proposal-math-extensions/
	var $export = __webpack_require__(6);
	var RAD_PER_DEG = 180 / Math.PI;
	
	$export($export.S, 'Math', {
	  degrees: function degrees(radians) {
	    return radians * RAD_PER_DEG;
	  }
	});


/***/ },
/* 742 */
/***/ function(module, exports, __webpack_require__) {

	// https://rwaldron.github.io/proposal-math-extensions/
	var $export = __webpack_require__(6);
	var scale = __webpack_require__(307);
	var fround = __webpack_require__(305);
	
	$export($export.S, 'Math', {
	  fscale: function fscale(x, inLow, inHigh, outLow, outHigh) {
	    return fround(scale(x, inLow, inHigh, outLow, outHigh));
	  }
	});


/***/ },
/* 743 */
/***/ function(module, exports, __webpack_require__) {

	// https://gist.github.com/BrendanEich/4294d5c212a6d2254703
	var $export = __webpack_require__(6);
	
	$export($export.S, 'Math', {
	  iaddh: function iaddh(x0, x1, y0, y1) {
	    var $x0 = x0 >>> 0;
	    var $x1 = x1 >>> 0;
	    var $y0 = y0 >>> 0;
	    return $x1 + (y1 >>> 0) + (($x0 & $y0 | ($x0 | $y0) & ~($x0 + $y0 >>> 0)) >>> 31) | 0;
	  }
	});


/***/ },
/* 744 */
/***/ function(module, exports, __webpack_require__) {

	// https://gist.github.com/BrendanEich/4294d5c212a6d2254703
	var $export = __webpack_require__(6);
	
	$export($export.S, 'Math', {
	  imulh: function imulh(u, v) {
	    var UINT16 = 0xffff;
	    var $u = +u;
	    var $v = +v;
	    var u0 = $u & UINT16;
	    var v0 = $v & UINT16;
	    var u1 = $u >> 16;
	    var v1 = $v >> 16;
	    var t = (u1 * v0 >>> 0) + (u0 * v0 >>> 16);
	    return u1 * v1 + (t >> 16) + ((u0 * v1 >>> 0) + (t & UINT16) >> 16);
	  }
	});


/***/ },
/* 745 */
/***/ function(module, exports, __webpack_require__) {

	// https://gist.github.com/BrendanEich/4294d5c212a6d2254703
	var $export = __webpack_require__(6);
	
	$export($export.S, 'Math', {
	  isubh: function isubh(x0, x1, y0, y1) {
	    var $x0 = x0 >>> 0;
	    var $x1 = x1 >>> 0;
	    var $y0 = y0 >>> 0;
	    return $x1 - (y1 >>> 0) - ((~$x0 & $y0 | ~($x0 ^ $y0) & $x0 - $y0 >>> 0) >>> 31) | 0;
	  }
	});


/***/ },
/* 746 */
/***/ function(module, exports, __webpack_require__) {

	// https://rwaldron.github.io/proposal-math-extensions/
	var $export = __webpack_require__(6);
	
	$export($export.S, 'Math', { RAD_PER_DEG: 180 / Math.PI });


/***/ },
/* 747 */
/***/ function(module, exports, __webpack_require__) {

	// https://rwaldron.github.io/proposal-math-extensions/
	var $export = __webpack_require__(6);
	var DEG_PER_RAD = Math.PI / 180;
	
	$export($export.S, 'Math', {
	  radians: function radians(degrees) {
	    return degrees * DEG_PER_RAD;
	  }
	});


/***/ },
/* 748 */
/***/ function(module, exports, __webpack_require__) {

	// https://rwaldron.github.io/proposal-math-extensions/
	var $export = __webpack_require__(6);
	
	$export($export.S, 'Math', { scale: __webpack_require__(307) });


/***/ },
/* 749 */
/***/ function(module, exports, __webpack_require__) {

	// http://jfbastien.github.io/papers/Math.signbit.html
	var $export = __webpack_require__(6);
	
	$export($export.S, 'Math', { signbit: function signbit(x) {
	  // eslint-disable-next-line no-self-compare
	  return (x = +x) != x ? x : x == 0 ? 1 / x == Infinity : x > 0;
	} });


/***/ },
/* 750 */
/***/ function(module, exports, __webpack_require__) {

	// https://gist.github.com/BrendanEich/4294d5c212a6d2254703
	var $export = __webpack_require__(6);
	
	$export($export.S, 'Math', {
	  umulh: function umulh(u, v) {
	    var UINT16 = 0xffff;
	    var $u = +u;
	    var $v = +v;
	    var u0 = $u & UINT16;
	    var v0 = $v & UINT16;
	    var u1 = $u >>> 16;
	    var v1 = $v >>> 16;
	    var t = (u1 * v0 >>> 0) + (u0 * v0 >>> 16);
	    return u1 * v1 + (t >>> 16) + ((u0 * v1 >>> 0) + (t & UINT16) >>> 16);
	  }
	});


/***/ },
/* 751 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(6);
	var toObject = __webpack_require__(43);
	var aFunction = __webpack_require__(50);
	var $defineProperty = __webpack_require__(39);
	
	// B.2.2.2 Object.prototype.__defineGetter__(P, getter)
	__webpack_require__(38) && $export($export.P + __webpack_require__(161), 'Object', {
	  __defineGetter__: function __defineGetter__(P, getter) {
	    $defineProperty.f(toObject(this), P, { get: aFunction(getter), enumerable: true, configurable: true });
	  }
	});


/***/ },
/* 752 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(6);
	var toObject = __webpack_require__(43);
	var aFunction = __webpack_require__(50);
	var $defineProperty = __webpack_require__(39);
	
	// B.2.2.3 Object.prototype.__defineSetter__(P, setter)
	__webpack_require__(38) && $export($export.P + __webpack_require__(161), 'Object', {
	  __defineSetter__: function __defineSetter__(P, setter) {
	    $defineProperty.f(toObject(this), P, { set: aFunction(setter), enumerable: true, configurable: true });
	  }
	});


/***/ },
/* 753 */
/***/ function(module, exports, __webpack_require__) {

	// https://github.com/tc39/proposal-object-values-entries
	var $export = __webpack_require__(6);
	var $entries = __webpack_require__(312)(true);
	
	$export($export.S, 'Object', {
	  entries: function entries(it) {
	    return $entries(it);
	  }
	});


/***/ },
/* 754 */
/***/ function(module, exports, __webpack_require__) {

	// https://github.com/tc39/proposal-object-getownpropertydescriptors
	var $export = __webpack_require__(6);
	var ownKeys = __webpack_require__(313);
	var toIObject = __webpack_require__(61);
	var gOPD = __webpack_require__(59);
	var createProperty = __webpack_require__(207);
	
	$export($export.S, 'Object', {
	  getOwnPropertyDescriptors: function getOwnPropertyDescriptors(object) {
	    var O = toIObject(object);
	    var getDesc = gOPD.f;
	    var keys = ownKeys(O);
	    var result = {};
	    var i = 0;
	    var key, desc;
	    while (keys.length > i) {
	      desc = getDesc(O, key = keys[i++]);
	      if (desc !== undefined) createProperty(result, key, desc);
	    }
	    return result;
	  }
	});


/***/ },
/* 755 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(6);
	var toObject = __webpack_require__(43);
	var toPrimitive = __webpack_require__(79);
	var getPrototypeOf = __webpack_require__(60);
	var getOwnPropertyDescriptor = __webpack_require__(59).f;
	
	// B.2.2.4 Object.prototype.__lookupGetter__(P)
	__webpack_require__(38) && $export($export.P + __webpack_require__(161), 'Object', {
	  __lookupGetter__: function __lookupGetter__(P) {
	    var O = toObject(this);
	    var K = toPrimitive(P, true);
	    var D;
	    do {
	      if (D = getOwnPropertyDescriptor(O, K)) return D.get;
	    } while (O = getPrototypeOf(O));
	  }
	});


/***/ },
/* 756 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(6);
	var toObject = __webpack_require__(43);
	var toPrimitive = __webpack_require__(79);
	var getPrototypeOf = __webpack_require__(60);
	var getOwnPropertyDescriptor = __webpack_require__(59).f;
	
	// B.2.2.5 Object.prototype.__lookupSetter__(P)
	__webpack_require__(38) && $export($export.P + __webpack_require__(161), 'Object', {
	  __lookupSetter__: function __lookupSetter__(P) {
	    var O = toObject(this);
	    var K = toPrimitive(P, true);
	    var D;
	    do {
	      if (D = getOwnPropertyDescriptor(O, K)) return D.set;
	    } while (O = getPrototypeOf(O));
	  }
	});


/***/ },
/* 757 */
/***/ function(module, exports, __webpack_require__) {

	// https://github.com/tc39/proposal-object-values-entries
	var $export = __webpack_require__(6);
	var $values = __webpack_require__(312)(false);
	
	$export($export.S, 'Object', {
	  values: function values(it) {
	    return $values(it);
	  }
	});


/***/ },
/* 758 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// https://github.com/zenparsing/es-observable
	var $export = __webpack_require__(6);
	var global = __webpack_require__(24);
	var core = __webpack_require__(70);
	var microtask = __webpack_require__(218)();
	var OBSERVABLE = __webpack_require__(34)('observable');
	var aFunction = __webpack_require__(50);
	var anObject = __webpack_require__(23);
	var anInstance = __webpack_require__(102);
	var redefineAll = __webpack_require__(108);
	var hide = __webpack_require__(52);
	var forOf = __webpack_require__(103);
	var RETURN = forOf.RETURN;
	
	var getMethod = function (fn) {
	  return fn == null ? undefined : aFunction(fn);
	};
	
	var cleanupSubscription = function (subscription) {
	  var cleanup = subscription._c;
	  if (cleanup) {
	    subscription._c = undefined;
	    cleanup();
	  }
	};
	
	var subscriptionClosed = function (subscription) {
	  return subscription._o === undefined;
	};
	
	var closeSubscription = function (subscription) {
	  if (!subscriptionClosed(subscription)) {
	    subscription._o = undefined;
	    cleanupSubscription(subscription);
	  }
	};
	
	var Subscription = function (observer, subscriber) {
	  anObject(observer);
	  this._c = undefined;
	  this._o = observer;
	  observer = new SubscriptionObserver(this);
	  try {
	    var cleanup = subscriber(observer);
	    var subscription = cleanup;
	    if (cleanup != null) {
	      if (typeof cleanup.unsubscribe === 'function') cleanup = function () { subscription.unsubscribe(); };
	      else aFunction(cleanup);
	      this._c = cleanup;
	    }
	  } catch (e) {
	    observer.error(e);
	    return;
	  } if (subscriptionClosed(this)) cleanupSubscription(this);
	};
	
	Subscription.prototype = redefineAll({}, {
	  unsubscribe: function unsubscribe() { closeSubscription(this); }
	});
	
	var SubscriptionObserver = function (subscription) {
	  this._s = subscription;
	};
	
	SubscriptionObserver.prototype = redefineAll({}, {
	  next: function next(value) {
	    var subscription = this._s;
	    if (!subscriptionClosed(subscription)) {
	      var observer = subscription._o;
	      try {
	        var m = getMethod(observer.next);
	        if (m) return m.call(observer, value);
	      } catch (e) {
	        try {
	          closeSubscription(subscription);
	        } finally {
	          throw e;
	        }
	      }
	    }
	  },
	  error: function error(value) {
	    var subscription = this._s;
	    if (subscriptionClosed(subscription)) throw value;
	    var observer = subscription._o;
	    subscription._o = undefined;
	    try {
	      var m = getMethod(observer.error);
	      if (!m) throw value;
	      value = m.call(observer, value);
	    } catch (e) {
	      try {
	        cleanupSubscription(subscription);
	      } finally {
	        throw e;
	      }
	    } cleanupSubscription(subscription);
	    return value;
	  },
	  complete: function complete(value) {
	    var subscription = this._s;
	    if (!subscriptionClosed(subscription)) {
	      var observer = subscription._o;
	      subscription._o = undefined;
	      try {
	        var m = getMethod(observer.complete);
	        value = m ? m.call(observer, value) : undefined;
	      } catch (e) {
	        try {
	          cleanupSubscription(subscription);
	        } finally {
	          throw e;
	        }
	      } cleanupSubscription(subscription);
	      return value;
	    }
	  }
	});
	
	var $Observable = function Observable(subscriber) {
	  anInstance(this, $Observable, 'Observable', '_f')._f = aFunction(subscriber);
	};
	
	redefineAll($Observable.prototype, {
	  subscribe: function subscribe(observer) {
	    return new Subscription(observer, this._f);
	  },
	  forEach: function forEach(fn) {
	    var that = this;
	    return new (core.Promise || global.Promise)(function (resolve, reject) {
	      aFunction(fn);
	      var subscription = that.subscribe({
	        next: function (value) {
	          try {
	            return fn(value);
	          } catch (e) {
	            reject(e);
	            subscription.unsubscribe();
	          }
	        },
	        error: reject,
	        complete: resolve
	      });
	    });
	  }
	});
	
	redefineAll($Observable, {
	  from: function from(x) {
	    var C = typeof this === 'function' ? this : $Observable;
	    var method = getMethod(anObject(x)[OBSERVABLE]);
	    if (method) {
	      var observable = anObject(method.call(x));
	      return observable.constructor === C ? observable : new C(function (observer) {
	        return observable.subscribe(observer);
	      });
	    }
	    return new C(function (observer) {
	      var done = false;
	      microtask(function () {
	        if (!done) {
	          try {
	            if (forOf(x, false, function (it) {
	              observer.next(it);
	              if (done) return RETURN;
	            }) === RETURN) return;
	          } catch (e) {
	            if (done) throw e;
	            observer.error(e);
	            return;
	          } observer.complete();
	        }
	      });
	      return function () { done = true; };
	    });
	  },
	  of: function of() {
	    for (var i = 0, l = arguments.length, items = new Array(l); i < l;) items[i] = arguments[i++];
	    return new (typeof this === 'function' ? this : $Observable)(function (observer) {
	      var done = false;
	      microtask(function () {
	        if (!done) {
	          for (var j = 0; j < items.length; ++j) {
	            observer.next(items[j]);
	            if (done) return;
	          } observer.complete();
	        }
	      });
	      return function () { done = true; };
	    });
	  }
	});
	
	hide($Observable.prototype, OBSERVABLE, function () { return this; });
	
	$export($export.G, { Observable: $Observable });
	
	__webpack_require__(109)('Observable');


/***/ },
/* 759 */
/***/ function(module, exports, __webpack_require__) {

	// https://github.com/tc39/proposal-promise-finally
	'use strict';
	var $export = __webpack_require__(6);
	var core = __webpack_require__(70);
	var global = __webpack_require__(24);
	var speciesConstructor = __webpack_require__(166);
	var promiseResolve = __webpack_require__(317);
	
	$export($export.P + $export.R, 'Promise', { 'finally': function (onFinally) {
	  var C = speciesConstructor(this, core.Promise || global.Promise);
	  var isFunction = typeof onFinally == 'function';
	  return this.then(
	    isFunction ? function (x) {
	      return promiseResolve(C, onFinally()).then(function () { return x; });
	    } : onFinally,
	    isFunction ? function (e) {
	      return promiseResolve(C, onFinally()).then(function () { throw e; });
	    } : onFinally
	  );
	} });


/***/ },
/* 760 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// https://github.com/tc39/proposal-promise-try
	var $export = __webpack_require__(6);
	var newPromiseCapability = __webpack_require__(219);
	var perform = __webpack_require__(316);
	
	$export($export.S, 'Promise', { 'try': function (callbackfn) {
	  var promiseCapability = newPromiseCapability.f(this);
	  var result = perform(callbackfn);
	  (result.e ? promiseCapability.reject : promiseCapability.resolve)(result.v);
	  return promiseCapability.promise;
	} });


/***/ },
/* 761 */
/***/ function(module, exports, __webpack_require__) {

	var metadata = __webpack_require__(87);
	var anObject = __webpack_require__(23);
	var toMetaKey = metadata.key;
	var ordinaryDefineOwnMetadata = metadata.set;
	
	metadata.exp({ defineMetadata: function defineMetadata(metadataKey, metadataValue, target, targetKey) {
	  ordinaryDefineOwnMetadata(metadataKey, metadataValue, anObject(target), toMetaKey(targetKey));
	} });


/***/ },
/* 762 */
/***/ function(module, exports, __webpack_require__) {

	var metadata = __webpack_require__(87);
	var anObject = __webpack_require__(23);
	var toMetaKey = metadata.key;
	var getOrCreateMetadataMap = metadata.map;
	var store = metadata.store;
	
	metadata.exp({ deleteMetadata: function deleteMetadata(metadataKey, target /* , targetKey */) {
	  var targetKey = arguments.length < 3 ? undefined : toMetaKey(arguments[2]);
	  var metadataMap = getOrCreateMetadataMap(anObject(target), targetKey, false);
	  if (metadataMap === undefined || !metadataMap['delete'](metadataKey)) return false;
	  if (metadataMap.size) return true;
	  var targetMetadata = store.get(target);
	  targetMetadata['delete'](targetKey);
	  return !!targetMetadata.size || store['delete'](target);
	} });


/***/ },
/* 763 */
/***/ function(module, exports, __webpack_require__) {

	var Set = __webpack_require__(323);
	var from = __webpack_require__(293);
	var metadata = __webpack_require__(87);
	var anObject = __webpack_require__(23);
	var getPrototypeOf = __webpack_require__(60);
	var ordinaryOwnMetadataKeys = metadata.keys;
	var toMetaKey = metadata.key;
	
	var ordinaryMetadataKeys = function (O, P) {
	  var oKeys = ordinaryOwnMetadataKeys(O, P);
	  var parent = getPrototypeOf(O);
	  if (parent === null) return oKeys;
	  var pKeys = ordinaryMetadataKeys(parent, P);
	  return pKeys.length ? oKeys.length ? from(new Set(oKeys.concat(pKeys))) : pKeys : oKeys;
	};
	
	metadata.exp({ getMetadataKeys: function getMetadataKeys(target /* , targetKey */) {
	  return ordinaryMetadataKeys(anObject(target), arguments.length < 2 ? undefined : toMetaKey(arguments[1]));
	} });


/***/ },
/* 764 */
/***/ function(module, exports, __webpack_require__) {

	var metadata = __webpack_require__(87);
	var anObject = __webpack_require__(23);
	var getPrototypeOf = __webpack_require__(60);
	var ordinaryHasOwnMetadata = metadata.has;
	var ordinaryGetOwnMetadata = metadata.get;
	var toMetaKey = metadata.key;
	
	var ordinaryGetMetadata = function (MetadataKey, O, P) {
	  var hasOwn = ordinaryHasOwnMetadata(MetadataKey, O, P);
	  if (hasOwn) return ordinaryGetOwnMetadata(MetadataKey, O, P);
	  var parent = getPrototypeOf(O);
	  return parent !== null ? ordinaryGetMetadata(MetadataKey, parent, P) : undefined;
	};
	
	metadata.exp({ getMetadata: function getMetadata(metadataKey, target /* , targetKey */) {
	  return ordinaryGetMetadata(metadataKey, anObject(target), arguments.length < 3 ? undefined : toMetaKey(arguments[2]));
	} });


/***/ },
/* 765 */
/***/ function(module, exports, __webpack_require__) {

	var metadata = __webpack_require__(87);
	var anObject = __webpack_require__(23);
	var ordinaryOwnMetadataKeys = metadata.keys;
	var toMetaKey = metadata.key;
	
	metadata.exp({ getOwnMetadataKeys: function getOwnMetadataKeys(target /* , targetKey */) {
	  return ordinaryOwnMetadataKeys(anObject(target), arguments.length < 2 ? undefined : toMetaKey(arguments[1]));
	} });


/***/ },
/* 766 */
/***/ function(module, exports, __webpack_require__) {

	var metadata = __webpack_require__(87);
	var anObject = __webpack_require__(23);
	var ordinaryGetOwnMetadata = metadata.get;
	var toMetaKey = metadata.key;
	
	metadata.exp({ getOwnMetadata: function getOwnMetadata(metadataKey, target /* , targetKey */) {
	  return ordinaryGetOwnMetadata(metadataKey, anObject(target)
	    , arguments.length < 3 ? undefined : toMetaKey(arguments[2]));
	} });


/***/ },
/* 767 */
/***/ function(module, exports, __webpack_require__) {

	var metadata = __webpack_require__(87);
	var anObject = __webpack_require__(23);
	var getPrototypeOf = __webpack_require__(60);
	var ordinaryHasOwnMetadata = metadata.has;
	var toMetaKey = metadata.key;
	
	var ordinaryHasMetadata = function (MetadataKey, O, P) {
	  var hasOwn = ordinaryHasOwnMetadata(MetadataKey, O, P);
	  if (hasOwn) return true;
	  var parent = getPrototypeOf(O);
	  return parent !== null ? ordinaryHasMetadata(MetadataKey, parent, P) : false;
	};
	
	metadata.exp({ hasMetadata: function hasMetadata(metadataKey, target /* , targetKey */) {
	  return ordinaryHasMetadata(metadataKey, anObject(target), arguments.length < 3 ? undefined : toMetaKey(arguments[2]));
	} });


/***/ },
/* 768 */
/***/ function(module, exports, __webpack_require__) {

	var metadata = __webpack_require__(87);
	var anObject = __webpack_require__(23);
	var ordinaryHasOwnMetadata = metadata.has;
	var toMetaKey = metadata.key;
	
	metadata.exp({ hasOwnMetadata: function hasOwnMetadata(metadataKey, target /* , targetKey */) {
	  return ordinaryHasOwnMetadata(metadataKey, anObject(target)
	    , arguments.length < 3 ? undefined : toMetaKey(arguments[2]));
	} });


/***/ },
/* 769 */
/***/ function(module, exports, __webpack_require__) {

	var $metadata = __webpack_require__(87);
	var anObject = __webpack_require__(23);
	var aFunction = __webpack_require__(50);
	var toMetaKey = $metadata.key;
	var ordinaryDefineOwnMetadata = $metadata.set;
	
	$metadata.exp({ metadata: function metadata(metadataKey, metadataValue) {
	  return function decorator(target, targetKey) {
	    ordinaryDefineOwnMetadata(
	      metadataKey, metadataValue,
	      (targetKey !== undefined ? anObject : aFunction)(target),
	      toMetaKey(targetKey)
	    );
	  };
	} });


/***/ },
/* 770 */
/***/ function(module, exports, __webpack_require__) {

	// https://tc39.github.io/proposal-setmap-offrom/#sec-set.from
	__webpack_require__(163)('Set');


/***/ },
/* 771 */
/***/ function(module, exports, __webpack_require__) {

	// https://tc39.github.io/proposal-setmap-offrom/#sec-set.of
	__webpack_require__(164)('Set');


/***/ },
/* 772 */
/***/ function(module, exports, __webpack_require__) {

	// https://github.com/DavidBruant/Map-Set.prototype.toJSON
	var $export = __webpack_require__(6);
	
	$export($export.P + $export.R, 'Set', { toJSON: __webpack_require__(297)('Set') });


/***/ },
/* 773 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// https://github.com/mathiasbynens/String.prototype.at
	var $export = __webpack_require__(6);
	var $at = __webpack_require__(222)(true);
	
	$export($export.P, 'String', {
	  at: function at(pos) {
	    return $at(this, pos);
	  }
	});


/***/ },
/* 774 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// https://tc39.github.io/String.prototype.matchAll/
	var $export = __webpack_require__(6);
	var defined = __webpack_require__(76);
	var toLength = __webpack_require__(40);
	var isRegExp = __webpack_require__(159);
	var getFlags = __webpack_require__(157);
	var RegExpProto = RegExp.prototype;
	
	var $RegExpStringIterator = function (regexp, string) {
	  this._r = regexp;
	  this._s = string;
	};
	
	__webpack_require__(214)($RegExpStringIterator, 'RegExp String', function next() {
	  var match = this._r.exec(this._s);
	  return { value: match, done: match === null };
	});
	
	$export($export.P, 'String', {
	  matchAll: function matchAll(regexp) {
	    defined(this);
	    if (!isRegExp(regexp)) throw TypeError(regexp + ' is not a regexp!');
	    var S = String(this);
	    var flags = 'flags' in RegExpProto ? String(regexp.flags) : getFlags.call(regexp);
	    var rx = new RegExp(regexp.source, ~flags.indexOf('g') ? flags : 'g' + flags);
	    rx.lastIndex = toLength(regexp.lastIndex);
	    return new $RegExpStringIterator(rx, S);
	  }
	});


/***/ },
/* 775 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// https://github.com/tc39/proposal-string-pad-start-end
	var $export = __webpack_require__(6);
	var $pad = __webpack_require__(318);
	var userAgent = __webpack_require__(168);
	
	// https://github.com/zloirock/core-js/issues/280
	$export($export.P + $export.F * /Version\/10\.\d+(\.\d+)? Safari\//.test(userAgent), 'String', {
	  padEnd: function padEnd(maxLength /* , fillString = ' ' */) {
	    return $pad(this, maxLength, arguments.length > 1 ? arguments[1] : undefined, false);
	  }
	});


/***/ },
/* 776 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// https://github.com/tc39/proposal-string-pad-start-end
	var $export = __webpack_require__(6);
	var $pad = __webpack_require__(318);
	var userAgent = __webpack_require__(168);
	
	// https://github.com/zloirock/core-js/issues/280
	$export($export.P + $export.F * /Version\/10\.\d+(\.\d+)? Safari\//.test(userAgent), 'String', {
	  padStart: function padStart(maxLength /* , fillString = ' ' */) {
	    return $pad(this, maxLength, arguments.length > 1 ? arguments[1] : undefined, true);
	  }
	});


/***/ },
/* 777 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// https://github.com/sebmarkbage/ecmascript-string-left-right-trim
	__webpack_require__(118)('trimLeft', function ($trim) {
	  return function trimLeft() {
	    return $trim(this, 1);
	  };
	}, 'trimStart');


/***/ },
/* 778 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// https://github.com/sebmarkbage/ecmascript-string-left-right-trim
	__webpack_require__(118)('trimRight', function ($trim) {
	  return function trimRight() {
	    return $trim(this, 2);
	  };
	}, 'trimEnd');


/***/ },
/* 779 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(228)('asyncIterator');


/***/ },
/* 780 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(228)('observable');


/***/ },
/* 781 */
/***/ function(module, exports, __webpack_require__) {

	// https://github.com/tc39/proposal-global
	var $export = __webpack_require__(6);
	
	$export($export.S, 'System', { global: __webpack_require__(24) });


/***/ },
/* 782 */
/***/ function(module, exports, __webpack_require__) {

	// https://tc39.github.io/proposal-setmap-offrom/#sec-weakmap.from
	__webpack_require__(163)('WeakMap');


/***/ },
/* 783 */
/***/ function(module, exports, __webpack_require__) {

	// https://tc39.github.io/proposal-setmap-offrom/#sec-weakmap.of
	__webpack_require__(164)('WeakMap');


/***/ },
/* 784 */
/***/ function(module, exports, __webpack_require__) {

	// https://tc39.github.io/proposal-setmap-offrom/#sec-weakset.from
	__webpack_require__(163)('WeakSet');


/***/ },
/* 785 */
/***/ function(module, exports, __webpack_require__) {

	// https://tc39.github.io/proposal-setmap-offrom/#sec-weakset.of
	__webpack_require__(164)('WeakSet');


/***/ },
/* 786 */
/***/ function(module, exports, __webpack_require__) {

	var $iterators = __webpack_require__(230);
	var getKeys = __webpack_require__(106);
	var redefine = __webpack_require__(53);
	var global = __webpack_require__(24);
	var hide = __webpack_require__(52);
	var Iterators = __webpack_require__(116);
	var wks = __webpack_require__(34);
	var ITERATOR = wks('iterator');
	var TO_STRING_TAG = wks('toStringTag');
	var ArrayValues = Iterators.Array;
	
	var DOMIterables = {
	  CSSRuleList: true, // TODO: Not spec compliant, should be false.
	  CSSStyleDeclaration: false,
	  CSSValueList: false,
	  ClientRectList: false,
	  DOMRectList: false,
	  DOMStringList: false,
	  DOMTokenList: true,
	  DataTransferItemList: false,
	  FileList: false,
	  HTMLAllCollection: false,
	  HTMLCollection: false,
	  HTMLFormElement: false,
	  HTMLSelectElement: false,
	  MediaList: true, // TODO: Not spec compliant, should be false.
	  MimeTypeArray: false,
	  NamedNodeMap: false,
	  NodeList: true,
	  PaintRequestList: false,
	  Plugin: false,
	  PluginArray: false,
	  SVGLengthList: false,
	  SVGNumberList: false,
	  SVGPathSegList: false,
	  SVGPointList: false,
	  SVGStringList: false,
	  SVGTransformList: false,
	  SourceBufferList: false,
	  StyleSheetList: true, // TODO: Not spec compliant, should be false.
	  TextTrackCueList: false,
	  TextTrackList: false,
	  TouchList: false
	};
	
	for (var collections = getKeys(DOMIterables), i = 0; i < collections.length; i++) {
	  var NAME = collections[i];
	  var explicit = DOMIterables[NAME];
	  var Collection = global[NAME];
	  var proto = Collection && Collection.prototype;
	  var key;
	  if (proto) {
	    if (!proto[ITERATOR]) hide(proto, ITERATOR, ArrayValues);
	    if (!proto[TO_STRING_TAG]) hide(proto, TO_STRING_TAG, NAME);
	    Iterators[NAME] = ArrayValues;
	    if (explicit) for (key in $iterators) if (!proto[key]) redefine(proto, key, $iterators[key], true);
	  }
	}


/***/ },
/* 787 */
/***/ function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(6);
	var $task = __webpack_require__(226);
	$export($export.G + $export.B, {
	  setImmediate: $task.set,
	  clearImmediate: $task.clear
	});


/***/ },
/* 788 */
/***/ function(module, exports, __webpack_require__) {

	// ie9- setTimeout & setInterval additional parameters fix
	var global = __webpack_require__(24);
	var $export = __webpack_require__(6);
	var userAgent = __webpack_require__(168);
	var slice = [].slice;
	var MSIE = /MSIE .\./.test(userAgent); // <- dirty ie9- check
	var wrap = function (set) {
	  return function (fn, time /* , ...args */) {
	    var boundArgs = arguments.length > 2;
	    var args = boundArgs ? slice.call(arguments, 2) : false;
	    return set(boundArgs ? function () {
	      // eslint-disable-next-line no-new-func
	      (typeof fn == 'function' ? fn : Function(fn)).apply(this, args);
	    } : fn, time);
	  };
	};
	$export($export.G + $export.B + $export.F * MSIE, {
	  setTimeout: wrap(global.setTimeout),
	  setInterval: wrap(global.setInterval)
	});


/***/ },
/* 789 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(717);
	__webpack_require__(656);
	__webpack_require__(658);
	__webpack_require__(657);
	__webpack_require__(660);
	__webpack_require__(662);
	__webpack_require__(667);
	__webpack_require__(661);
	__webpack_require__(659);
	__webpack_require__(669);
	__webpack_require__(668);
	__webpack_require__(664);
	__webpack_require__(665);
	__webpack_require__(663);
	__webpack_require__(655);
	__webpack_require__(666);
	__webpack_require__(670);
	__webpack_require__(671);
	__webpack_require__(623);
	__webpack_require__(625);
	__webpack_require__(624);
	__webpack_require__(673);
	__webpack_require__(672);
	__webpack_require__(643);
	__webpack_require__(653);
	__webpack_require__(654);
	__webpack_require__(644);
	__webpack_require__(645);
	__webpack_require__(646);
	__webpack_require__(647);
	__webpack_require__(648);
	__webpack_require__(649);
	__webpack_require__(650);
	__webpack_require__(651);
	__webpack_require__(652);
	__webpack_require__(626);
	__webpack_require__(627);
	__webpack_require__(628);
	__webpack_require__(629);
	__webpack_require__(630);
	__webpack_require__(631);
	__webpack_require__(632);
	__webpack_require__(633);
	__webpack_require__(634);
	__webpack_require__(635);
	__webpack_require__(636);
	__webpack_require__(637);
	__webpack_require__(638);
	__webpack_require__(639);
	__webpack_require__(640);
	__webpack_require__(641);
	__webpack_require__(642);
	__webpack_require__(704);
	__webpack_require__(709);
	__webpack_require__(716);
	__webpack_require__(707);
	__webpack_require__(699);
	__webpack_require__(700);
	__webpack_require__(705);
	__webpack_require__(710);
	__webpack_require__(712);
	__webpack_require__(695);
	__webpack_require__(696);
	__webpack_require__(697);
	__webpack_require__(698);
	__webpack_require__(701);
	__webpack_require__(702);
	__webpack_require__(703);
	__webpack_require__(706);
	__webpack_require__(708);
	__webpack_require__(711);
	__webpack_require__(713);
	__webpack_require__(714);
	__webpack_require__(715);
	__webpack_require__(618);
	__webpack_require__(620);
	__webpack_require__(619);
	__webpack_require__(622);
	__webpack_require__(621);
	__webpack_require__(607);
	__webpack_require__(605);
	__webpack_require__(611);
	__webpack_require__(608);
	__webpack_require__(614);
	__webpack_require__(616);
	__webpack_require__(604);
	__webpack_require__(610);
	__webpack_require__(601);
	__webpack_require__(615);
	__webpack_require__(599);
	__webpack_require__(613);
	__webpack_require__(612);
	__webpack_require__(606);
	__webpack_require__(609);
	__webpack_require__(598);
	__webpack_require__(600);
	__webpack_require__(603);
	__webpack_require__(602);
	__webpack_require__(617);
	__webpack_require__(230);
	__webpack_require__(689);
	__webpack_require__(694);
	__webpack_require__(322);
	__webpack_require__(690);
	__webpack_require__(691);
	__webpack_require__(692);
	__webpack_require__(693);
	__webpack_require__(674);
	__webpack_require__(321);
	__webpack_require__(323);
	__webpack_require__(324);
	__webpack_require__(729);
	__webpack_require__(718);
	__webpack_require__(719);
	__webpack_require__(724);
	__webpack_require__(727);
	__webpack_require__(728);
	__webpack_require__(722);
	__webpack_require__(725);
	__webpack_require__(723);
	__webpack_require__(726);
	__webpack_require__(720);
	__webpack_require__(721);
	__webpack_require__(675);
	__webpack_require__(676);
	__webpack_require__(677);
	__webpack_require__(678);
	__webpack_require__(679);
	__webpack_require__(682);
	__webpack_require__(680);
	__webpack_require__(681);
	__webpack_require__(683);
	__webpack_require__(684);
	__webpack_require__(685);
	__webpack_require__(686);
	__webpack_require__(688);
	__webpack_require__(687);
	__webpack_require__(732);
	__webpack_require__(730);
	__webpack_require__(731);
	__webpack_require__(773);
	__webpack_require__(776);
	__webpack_require__(775);
	__webpack_require__(777);
	__webpack_require__(778);
	__webpack_require__(774);
	__webpack_require__(779);
	__webpack_require__(780);
	__webpack_require__(754);
	__webpack_require__(757);
	__webpack_require__(753);
	__webpack_require__(751);
	__webpack_require__(752);
	__webpack_require__(755);
	__webpack_require__(756);
	__webpack_require__(738);
	__webpack_require__(772);
	__webpack_require__(737);
	__webpack_require__(771);
	__webpack_require__(783);
	__webpack_require__(785);
	__webpack_require__(736);
	__webpack_require__(770);
	__webpack_require__(782);
	__webpack_require__(784);
	__webpack_require__(735);
	__webpack_require__(781);
	__webpack_require__(734);
	__webpack_require__(739);
	__webpack_require__(740);
	__webpack_require__(741);
	__webpack_require__(742);
	__webpack_require__(743);
	__webpack_require__(745);
	__webpack_require__(744);
	__webpack_require__(746);
	__webpack_require__(747);
	__webpack_require__(748);
	__webpack_require__(750);
	__webpack_require__(749);
	__webpack_require__(759);
	__webpack_require__(760);
	__webpack_require__(761);
	__webpack_require__(762);
	__webpack_require__(764);
	__webpack_require__(763);
	__webpack_require__(766);
	__webpack_require__(765);
	__webpack_require__(767);
	__webpack_require__(768);
	__webpack_require__(769);
	__webpack_require__(733);
	__webpack_require__(758);
	__webpack_require__(788);
	__webpack_require__(787);
	__webpack_require__(786);
	module.exports = __webpack_require__(70);


/***/ },
/* 790 */
/***/ function(module, exports, __webpack_require__) {

	;(function (root, factory, undef) {
		if (true) {
			// CommonJS
			module.exports = exports = factory(__webpack_require__(25), __webpack_require__(120), __webpack_require__(121), __webpack_require__(112), __webpack_require__(44));
		}
		else if (typeof define === "function" && define.amd) {
			// AMD
			define(["./core", "./enc-base64", "./md5", "./evpkdf", "./cipher-core"], factory);
		}
		else {
			// Global (browser)
			factory(root.CryptoJS);
		}
	}(this, function (CryptoJS) {
	
		(function () {
		    // Shortcuts
		    var C = CryptoJS;
		    var C_lib = C.lib;
		    var BlockCipher = C_lib.BlockCipher;
		    var C_algo = C.algo;
	
		    // Lookup tables
		    var SBOX = [];
		    var INV_SBOX = [];
		    var SUB_MIX_0 = [];
		    var SUB_MIX_1 = [];
		    var SUB_MIX_2 = [];
		    var SUB_MIX_3 = [];
		    var INV_SUB_MIX_0 = [];
		    var INV_SUB_MIX_1 = [];
		    var INV_SUB_MIX_2 = [];
		    var INV_SUB_MIX_3 = [];
	
		    // Compute lookup tables
		    (function () {
		        // Compute double table
		        var d = [];
		        for (var i = 0; i < 256; i++) {
		            if (i < 128) {
		                d[i] = i << 1;
		            } else {
		                d[i] = (i << 1) ^ 0x11b;
		            }
		        }
	
		        // Walk GF(2^8)
		        var x = 0;
		        var xi = 0;
		        for (var i = 0; i < 256; i++) {
		            // Compute sbox
		            var sx = xi ^ (xi << 1) ^ (xi << 2) ^ (xi << 3) ^ (xi << 4);
		            sx = (sx >>> 8) ^ (sx & 0xff) ^ 0x63;
		            SBOX[x] = sx;
		            INV_SBOX[sx] = x;
	
		            // Compute multiplication
		            var x2 = d[x];
		            var x4 = d[x2];
		            var x8 = d[x4];
	
		            // Compute sub bytes, mix columns tables
		            var t = (d[sx] * 0x101) ^ (sx * 0x1010100);
		            SUB_MIX_0[x] = (t << 24) | (t >>> 8);
		            SUB_MIX_1[x] = (t << 16) | (t >>> 16);
		            SUB_MIX_2[x] = (t << 8)  | (t >>> 24);
		            SUB_MIX_3[x] = t;
	
		            // Compute inv sub bytes, inv mix columns tables
		            var t = (x8 * 0x1010101) ^ (x4 * 0x10001) ^ (x2 * 0x101) ^ (x * 0x1010100);
		            INV_SUB_MIX_0[sx] = (t << 24) | (t >>> 8);
		            INV_SUB_MIX_1[sx] = (t << 16) | (t >>> 16);
		            INV_SUB_MIX_2[sx] = (t << 8)  | (t >>> 24);
		            INV_SUB_MIX_3[sx] = t;
	
		            // Compute next counter
		            if (!x) {
		                x = xi = 1;
		            } else {
		                x = x2 ^ d[d[d[x8 ^ x2]]];
		                xi ^= d[d[xi]];
		            }
		        }
		    }());
	
		    // Precomputed Rcon lookup
		    var RCON = [0x00, 0x01, 0x02, 0x04, 0x08, 0x10, 0x20, 0x40, 0x80, 0x1b, 0x36];
	
		    /**
		     * AES block cipher algorithm.
		     */
		    var AES = C_algo.AES = BlockCipher.extend({
		        _doReset: function () {
		            // Skip reset of nRounds has been set before and key did not change
		            if (this._nRounds && this._keyPriorReset === this._key) {
		                return;
		            }
	
		            // Shortcuts
		            var key = this._keyPriorReset = this._key;
		            var keyWords = key.words;
		            var keySize = key.sigBytes / 4;
	
		            // Compute number of rounds
		            var nRounds = this._nRounds = keySize + 6;
	
		            // Compute number of key schedule rows
		            var ksRows = (nRounds + 1) * 4;
	
		            // Compute key schedule
		            var keySchedule = this._keySchedule = [];
		            for (var ksRow = 0; ksRow < ksRows; ksRow++) {
		                if (ksRow < keySize) {
		                    keySchedule[ksRow] = keyWords[ksRow];
		                } else {
		                    var t = keySchedule[ksRow - 1];
	
		                    if (!(ksRow % keySize)) {
		                        // Rot word
		                        t = (t << 8) | (t >>> 24);
	
		                        // Sub word
		                        t = (SBOX[t >>> 24] << 24) | (SBOX[(t >>> 16) & 0xff] << 16) | (SBOX[(t >>> 8) & 0xff] << 8) | SBOX[t & 0xff];
	
		                        // Mix Rcon
		                        t ^= RCON[(ksRow / keySize) | 0] << 24;
		                    } else if (keySize > 6 && ksRow % keySize == 4) {
		                        // Sub word
		                        t = (SBOX[t >>> 24] << 24) | (SBOX[(t >>> 16) & 0xff] << 16) | (SBOX[(t >>> 8) & 0xff] << 8) | SBOX[t & 0xff];
		                    }
	
		                    keySchedule[ksRow] = keySchedule[ksRow - keySize] ^ t;
		                }
		            }
	
		            // Compute inv key schedule
		            var invKeySchedule = this._invKeySchedule = [];
		            for (var invKsRow = 0; invKsRow < ksRows; invKsRow++) {
		                var ksRow = ksRows - invKsRow;
	
		                if (invKsRow % 4) {
		                    var t = keySchedule[ksRow];
		                } else {
		                    var t = keySchedule[ksRow - 4];
		                }
	
		                if (invKsRow < 4 || ksRow <= 4) {
		                    invKeySchedule[invKsRow] = t;
		                } else {
		                    invKeySchedule[invKsRow] = INV_SUB_MIX_0[SBOX[t >>> 24]] ^ INV_SUB_MIX_1[SBOX[(t >>> 16) & 0xff]] ^
		                                               INV_SUB_MIX_2[SBOX[(t >>> 8) & 0xff]] ^ INV_SUB_MIX_3[SBOX[t & 0xff]];
		                }
		            }
		        },
	
		        encryptBlock: function (M, offset) {
		            this._doCryptBlock(M, offset, this._keySchedule, SUB_MIX_0, SUB_MIX_1, SUB_MIX_2, SUB_MIX_3, SBOX);
		        },
	
		        decryptBlock: function (M, offset) {
		            // Swap 2nd and 4th rows
		            var t = M[offset + 1];
		            M[offset + 1] = M[offset + 3];
		            M[offset + 3] = t;
	
		            this._doCryptBlock(M, offset, this._invKeySchedule, INV_SUB_MIX_0, INV_SUB_MIX_1, INV_SUB_MIX_2, INV_SUB_MIX_3, INV_SBOX);
	
		            // Inv swap 2nd and 4th rows
		            var t = M[offset + 1];
		            M[offset + 1] = M[offset + 3];
		            M[offset + 3] = t;
		        },
	
		        _doCryptBlock: function (M, offset, keySchedule, SUB_MIX_0, SUB_MIX_1, SUB_MIX_2, SUB_MIX_3, SBOX) {
		            // Shortcut
		            var nRounds = this._nRounds;
	
		            // Get input, add round key
		            var s0 = M[offset]     ^ keySchedule[0];
		            var s1 = M[offset + 1] ^ keySchedule[1];
		            var s2 = M[offset + 2] ^ keySchedule[2];
		            var s3 = M[offset + 3] ^ keySchedule[3];
	
		            // Key schedule row counter
		            var ksRow = 4;
	
		            // Rounds
		            for (var round = 1; round < nRounds; round++) {
		                // Shift rows, sub bytes, mix columns, add round key
		                var t0 = SUB_MIX_0[s0 >>> 24] ^ SUB_MIX_1[(s1 >>> 16) & 0xff] ^ SUB_MIX_2[(s2 >>> 8) & 0xff] ^ SUB_MIX_3[s3 & 0xff] ^ keySchedule[ksRow++];
		                var t1 = SUB_MIX_0[s1 >>> 24] ^ SUB_MIX_1[(s2 >>> 16) & 0xff] ^ SUB_MIX_2[(s3 >>> 8) & 0xff] ^ SUB_MIX_3[s0 & 0xff] ^ keySchedule[ksRow++];
		                var t2 = SUB_MIX_0[s2 >>> 24] ^ SUB_MIX_1[(s3 >>> 16) & 0xff] ^ SUB_MIX_2[(s0 >>> 8) & 0xff] ^ SUB_MIX_3[s1 & 0xff] ^ keySchedule[ksRow++];
		                var t3 = SUB_MIX_0[s3 >>> 24] ^ SUB_MIX_1[(s0 >>> 16) & 0xff] ^ SUB_MIX_2[(s1 >>> 8) & 0xff] ^ SUB_MIX_3[s2 & 0xff] ^ keySchedule[ksRow++];
	
		                // Update state
		                s0 = t0;
		                s1 = t1;
		                s2 = t2;
		                s3 = t3;
		            }
	
		            // Shift rows, sub bytes, add round key
		            var t0 = ((SBOX[s0 >>> 24] << 24) | (SBOX[(s1 >>> 16) & 0xff] << 16) | (SBOX[(s2 >>> 8) & 0xff] << 8) | SBOX[s3 & 0xff]) ^ keySchedule[ksRow++];
		            var t1 = ((SBOX[s1 >>> 24] << 24) | (SBOX[(s2 >>> 16) & 0xff] << 16) | (SBOX[(s3 >>> 8) & 0xff] << 8) | SBOX[s0 & 0xff]) ^ keySchedule[ksRow++];
		            var t2 = ((SBOX[s2 >>> 24] << 24) | (SBOX[(s3 >>> 16) & 0xff] << 16) | (SBOX[(s0 >>> 8) & 0xff] << 8) | SBOX[s1 & 0xff]) ^ keySchedule[ksRow++];
		            var t3 = ((SBOX[s3 >>> 24] << 24) | (SBOX[(s0 >>> 16) & 0xff] << 16) | (SBOX[(s1 >>> 8) & 0xff] << 8) | SBOX[s2 & 0xff]) ^ keySchedule[ksRow++];
	
		            // Set output
		            M[offset]     = t0;
		            M[offset + 1] = t1;
		            M[offset + 2] = t2;
		            M[offset + 3] = t3;
		        },
	
		        keySize: 256/32
		    });
	
		    /**
		     * Shortcut functions to the cipher's object interface.
		     *
		     * @example
		     *
		     *     var ciphertext = CryptoJS.AES.encrypt(message, key, cfg);
		     *     var plaintext  = CryptoJS.AES.decrypt(ciphertext, key, cfg);
		     */
		    C.AES = BlockCipher._createHelper(AES);
		}());
	
	
		return CryptoJS.AES;
	
	}));

/***/ },
/* 791 */
/***/ function(module, exports, __webpack_require__) {

	;(function (root, factory) {
		if (true) {
			// CommonJS
			module.exports = exports = factory(__webpack_require__(25));
		}
		else if (typeof define === "function" && define.amd) {
			// AMD
			define(["./core"], factory);
		}
		else {
			// Global (browser)
			factory(root.CryptoJS);
		}
	}(this, function (CryptoJS) {
	
		(function () {
		    // Shortcuts
		    var C = CryptoJS;
		    var C_lib = C.lib;
		    var WordArray = C_lib.WordArray;
		    var C_enc = C.enc;
	
		    /**
		     * UTF-16 BE encoding strategy.
		     */
		    var Utf16BE = C_enc.Utf16 = C_enc.Utf16BE = {
		        /**
		         * Converts a word array to a UTF-16 BE string.
		         *
		         * @param {WordArray} wordArray The word array.
		         *
		         * @return {string} The UTF-16 BE string.
		         *
		         * @static
		         *
		         * @example
		         *
		         *     var utf16String = CryptoJS.enc.Utf16.stringify(wordArray);
		         */
		        stringify: function (wordArray) {
		            // Shortcuts
		            var words = wordArray.words;
		            var sigBytes = wordArray.sigBytes;
	
		            // Convert
		            var utf16Chars = [];
		            for (var i = 0; i < sigBytes; i += 2) {
		                var codePoint = (words[i >>> 2] >>> (16 - (i % 4) * 8)) & 0xffff;
		                utf16Chars.push(String.fromCharCode(codePoint));
		            }
	
		            return utf16Chars.join('');
		        },
	
		        /**
		         * Converts a UTF-16 BE string to a word array.
		         *
		         * @param {string} utf16Str The UTF-16 BE string.
		         *
		         * @return {WordArray} The word array.
		         *
		         * @static
		         *
		         * @example
		         *
		         *     var wordArray = CryptoJS.enc.Utf16.parse(utf16String);
		         */
		        parse: function (utf16Str) {
		            // Shortcut
		            var utf16StrLength = utf16Str.length;
	
		            // Convert
		            var words = [];
		            for (var i = 0; i < utf16StrLength; i++) {
		                words[i >>> 1] |= utf16Str.charCodeAt(i) << (16 - (i % 2) * 16);
		            }
	
		            return WordArray.create(words, utf16StrLength * 2);
		        }
		    };
	
		    /**
		     * UTF-16 LE encoding strategy.
		     */
		    C_enc.Utf16LE = {
		        /**
		         * Converts a word array to a UTF-16 LE string.
		         *
		         * @param {WordArray} wordArray The word array.
		         *
		         * @return {string} The UTF-16 LE string.
		         *
		         * @static
		         *
		         * @example
		         *
		         *     var utf16Str = CryptoJS.enc.Utf16LE.stringify(wordArray);
		         */
		        stringify: function (wordArray) {
		            // Shortcuts
		            var words = wordArray.words;
		            var sigBytes = wordArray.sigBytes;
	
		            // Convert
		            var utf16Chars = [];
		            for (var i = 0; i < sigBytes; i += 2) {
		                var codePoint = swapEndian((words[i >>> 2] >>> (16 - (i % 4) * 8)) & 0xffff);
		                utf16Chars.push(String.fromCharCode(codePoint));
		            }
	
		            return utf16Chars.join('');
		        },
	
		        /**
		         * Converts a UTF-16 LE string to a word array.
		         *
		         * @param {string} utf16Str The UTF-16 LE string.
		         *
		         * @return {WordArray} The word array.
		         *
		         * @static
		         *
		         * @example
		         *
		         *     var wordArray = CryptoJS.enc.Utf16LE.parse(utf16Str);
		         */
		        parse: function (utf16Str) {
		            // Shortcut
		            var utf16StrLength = utf16Str.length;
	
		            // Convert
		            var words = [];
		            for (var i = 0; i < utf16StrLength; i++) {
		                words[i >>> 1] |= swapEndian(utf16Str.charCodeAt(i) << (16 - (i % 2) * 16));
		            }
	
		            return WordArray.create(words, utf16StrLength * 2);
		        }
		    };
	
		    function swapEndian(word) {
		        return ((word << 8) & 0xff00ff00) | ((word >>> 8) & 0x00ff00ff);
		    }
		}());
	
	
		return CryptoJS.enc.Utf16;
	
	}));

/***/ },
/* 792 */
/***/ function(module, exports, __webpack_require__) {

	;(function (root, factory, undef) {
		if (true) {
			// CommonJS
			module.exports = exports = factory(__webpack_require__(25), __webpack_require__(44));
		}
		else if (typeof define === "function" && define.amd) {
			// AMD
			define(["./core", "./cipher-core"], factory);
		}
		else {
			// Global (browser)
			factory(root.CryptoJS);
		}
	}(this, function (CryptoJS) {
	
		(function (undefined) {
		    // Shortcuts
		    var C = CryptoJS;
		    var C_lib = C.lib;
		    var CipherParams = C_lib.CipherParams;
		    var C_enc = C.enc;
		    var Hex = C_enc.Hex;
		    var C_format = C.format;
	
		    var HexFormatter = C_format.Hex = {
		        /**
		         * Converts the ciphertext of a cipher params object to a hexadecimally encoded string.
		         *
		         * @param {CipherParams} cipherParams The cipher params object.
		         *
		         * @return {string} The hexadecimally encoded string.
		         *
		         * @static
		         *
		         * @example
		         *
		         *     var hexString = CryptoJS.format.Hex.stringify(cipherParams);
		         */
		        stringify: function (cipherParams) {
		            return cipherParams.ciphertext.toString(Hex);
		        },
	
		        /**
		         * Converts a hexadecimally encoded ciphertext string to a cipher params object.
		         *
		         * @param {string} input The hexadecimally encoded string.
		         *
		         * @return {CipherParams} The cipher params object.
		         *
		         * @static
		         *
		         * @example
		         *
		         *     var cipherParams = CryptoJS.format.Hex.parse(hexString);
		         */
		        parse: function (input) {
		            var ciphertext = Hex.parse(input);
		            return CipherParams.create({ ciphertext: ciphertext });
		        }
		    };
		}());
	
	
		return CryptoJS.format.Hex;
	
	}));

/***/ },
/* 793 */
/***/ function(module, exports, __webpack_require__) {

	;(function (root, factory, undef) {
		if (true) {
			// CommonJS
			module.exports = exports = factory(__webpack_require__(25), __webpack_require__(169), __webpack_require__(794), __webpack_require__(791), __webpack_require__(120), __webpack_require__(121), __webpack_require__(232), __webpack_require__(326), __webpack_require__(810), __webpack_require__(327), __webpack_require__(812), __webpack_require__(811), __webpack_require__(809), __webpack_require__(231), __webpack_require__(805), __webpack_require__(112), __webpack_require__(44), __webpack_require__(795), __webpack_require__(797), __webpack_require__(796), __webpack_require__(799), __webpack_require__(798), __webpack_require__(800), __webpack_require__(801), __webpack_require__(802), __webpack_require__(804), __webpack_require__(803), __webpack_require__(792), __webpack_require__(790), __webpack_require__(813), __webpack_require__(808), __webpack_require__(807), __webpack_require__(806));
		}
		else if (typeof define === "function" && define.amd) {
			// AMD
			define(["./core", "./x64-core", "./lib-typedarrays", "./enc-utf16", "./enc-base64", "./md5", "./sha1", "./sha256", "./sha224", "./sha512", "./sha384", "./sha3", "./ripemd160", "./hmac", "./pbkdf2", "./evpkdf", "./cipher-core", "./mode-cfb", "./mode-ctr", "./mode-ctr-gladman", "./mode-ofb", "./mode-ecb", "./pad-ansix923", "./pad-iso10126", "./pad-iso97971", "./pad-zeropadding", "./pad-nopadding", "./format-hex", "./aes", "./tripledes", "./rc4", "./rabbit", "./rabbit-legacy"], factory);
		}
		else {
			// Global (browser)
			root.CryptoJS = factory(root.CryptoJS);
		}
	}(this, function (CryptoJS) {
	
		return CryptoJS;
	
	}));

/***/ },
/* 794 */
/***/ function(module, exports, __webpack_require__) {

	;(function (root, factory) {
		if (true) {
			// CommonJS
			module.exports = exports = factory(__webpack_require__(25));
		}
		else if (typeof define === "function" && define.amd) {
			// AMD
			define(["./core"], factory);
		}
		else {
			// Global (browser)
			factory(root.CryptoJS);
		}
	}(this, function (CryptoJS) {
	
		(function () {
		    // Check if typed arrays are supported
		    if (typeof ArrayBuffer != 'function') {
		        return;
		    }
	
		    // Shortcuts
		    var C = CryptoJS;
		    var C_lib = C.lib;
		    var WordArray = C_lib.WordArray;
	
		    // Reference original init
		    var superInit = WordArray.init;
	
		    // Augment WordArray.init to handle typed arrays
		    var subInit = WordArray.init = function (typedArray) {
		        // Convert buffers to uint8
		        if (typedArray instanceof ArrayBuffer) {
		            typedArray = new Uint8Array(typedArray);
		        }
	
		        // Convert other array views to uint8
		        if (
		            typedArray instanceof Int8Array ||
		            (typeof Uint8ClampedArray !== "undefined" && typedArray instanceof Uint8ClampedArray) ||
		            typedArray instanceof Int16Array ||
		            typedArray instanceof Uint16Array ||
		            typedArray instanceof Int32Array ||
		            typedArray instanceof Uint32Array ||
		            typedArray instanceof Float32Array ||
		            typedArray instanceof Float64Array
		        ) {
		            typedArray = new Uint8Array(typedArray.buffer, typedArray.byteOffset, typedArray.byteLength);
		        }
	
		        // Handle Uint8Array
		        if (typedArray instanceof Uint8Array) {
		            // Shortcut
		            var typedArrayByteLength = typedArray.byteLength;
	
		            // Extract bytes
		            var words = [];
		            for (var i = 0; i < typedArrayByteLength; i++) {
		                words[i >>> 2] |= typedArray[i] << (24 - (i % 4) * 8);
		            }
	
		            // Initialize this word array
		            superInit.call(this, words, typedArrayByteLength);
		        } else {
		            // Else call normal init
		            superInit.apply(this, arguments);
		        }
		    };
	
		    subInit.prototype = WordArray;
		}());
	
	
		return CryptoJS.lib.WordArray;
	
	}));

/***/ },
/* 795 */
/***/ function(module, exports, __webpack_require__) {

	;(function (root, factory, undef) {
		if (true) {
			// CommonJS
			module.exports = exports = factory(__webpack_require__(25), __webpack_require__(44));
		}
		else if (typeof define === "function" && define.amd) {
			// AMD
			define(["./core", "./cipher-core"], factory);
		}
		else {
			// Global (browser)
			factory(root.CryptoJS);
		}
	}(this, function (CryptoJS) {
	
		/**
		 * Cipher Feedback block mode.
		 */
		CryptoJS.mode.CFB = (function () {
		    var CFB = CryptoJS.lib.BlockCipherMode.extend();
	
		    CFB.Encryptor = CFB.extend({
		        processBlock: function (words, offset) {
		            // Shortcuts
		            var cipher = this._cipher;
		            var blockSize = cipher.blockSize;
	
		            generateKeystreamAndEncrypt.call(this, words, offset, blockSize, cipher);
	
		            // Remember this block to use with next block
		            this._prevBlock = words.slice(offset, offset + blockSize);
		        }
		    });
	
		    CFB.Decryptor = CFB.extend({
		        processBlock: function (words, offset) {
		            // Shortcuts
		            var cipher = this._cipher;
		            var blockSize = cipher.blockSize;
	
		            // Remember this block to use with next block
		            var thisBlock = words.slice(offset, offset + blockSize);
	
		            generateKeystreamAndEncrypt.call(this, words, offset, blockSize, cipher);
	
		            // This block becomes the previous block
		            this._prevBlock = thisBlock;
		        }
		    });
	
		    function generateKeystreamAndEncrypt(words, offset, blockSize, cipher) {
		        // Shortcut
		        var iv = this._iv;
	
		        // Generate keystream
		        if (iv) {
		            var keystream = iv.slice(0);
	
		            // Remove IV for subsequent blocks
		            this._iv = undefined;
		        } else {
		            var keystream = this._prevBlock;
		        }
		        cipher.encryptBlock(keystream, 0);
	
		        // Encrypt
		        for (var i = 0; i < blockSize; i++) {
		            words[offset + i] ^= keystream[i];
		        }
		    }
	
		    return CFB;
		}());
	
	
		return CryptoJS.mode.CFB;
	
	}));

/***/ },
/* 796 */
/***/ function(module, exports, __webpack_require__) {

	;(function (root, factory, undef) {
		if (true) {
			// CommonJS
			module.exports = exports = factory(__webpack_require__(25), __webpack_require__(44));
		}
		else if (typeof define === "function" && define.amd) {
			// AMD
			define(["./core", "./cipher-core"], factory);
		}
		else {
			// Global (browser)
			factory(root.CryptoJS);
		}
	}(this, function (CryptoJS) {
	
		/** @preserve
		 * Counter block mode compatible with  Dr Brian Gladman fileenc.c
		 * derived from CryptoJS.mode.CTR
		 * Jan Hruby jhruby.web@gmail.com
		 */
		CryptoJS.mode.CTRGladman = (function () {
		    var CTRGladman = CryptoJS.lib.BlockCipherMode.extend();
	
			function incWord(word)
			{
				if (((word >> 24) & 0xff) === 0xff) { //overflow
				var b1 = (word >> 16)&0xff;
				var b2 = (word >> 8)&0xff;
				var b3 = word & 0xff;
	
				if (b1 === 0xff) // overflow b1
				{
				b1 = 0;
				if (b2 === 0xff)
				{
					b2 = 0;
					if (b3 === 0xff)
					{
						b3 = 0;
					}
					else
					{
						++b3;
					}
				}
				else
				{
					++b2;
				}
				}
				else
				{
				++b1;
				}
	
				word = 0;
				word += (b1 << 16);
				word += (b2 << 8);
				word += b3;
				}
				else
				{
				word += (0x01 << 24);
				}
				return word;
			}
	
			function incCounter(counter)
			{
				if ((counter[0] = incWord(counter[0])) === 0)
				{
					// encr_data in fileenc.c from  Dr Brian Gladman's counts only with DWORD j < 8
					counter[1] = incWord(counter[1]);
				}
				return counter;
			}
	
		    var Encryptor = CTRGladman.Encryptor = CTRGladman.extend({
		        processBlock: function (words, offset) {
		            // Shortcuts
		            var cipher = this._cipher
		            var blockSize = cipher.blockSize;
		            var iv = this._iv;
		            var counter = this._counter;
	
		            // Generate keystream
		            if (iv) {
		                counter = this._counter = iv.slice(0);
	
		                // Remove IV for subsequent blocks
		                this._iv = undefined;
		            }
	
					incCounter(counter);
	
					var keystream = counter.slice(0);
		            cipher.encryptBlock(keystream, 0);
	
		            // Encrypt
		            for (var i = 0; i < blockSize; i++) {
		                words[offset + i] ^= keystream[i];
		            }
		        }
		    });
	
		    CTRGladman.Decryptor = Encryptor;
	
		    return CTRGladman;
		}());
	
	
	
	
		return CryptoJS.mode.CTRGladman;
	
	}));

/***/ },
/* 797 */
/***/ function(module, exports, __webpack_require__) {

	;(function (root, factory, undef) {
		if (true) {
			// CommonJS
			module.exports = exports = factory(__webpack_require__(25), __webpack_require__(44));
		}
		else if (typeof define === "function" && define.amd) {
			// AMD
			define(["./core", "./cipher-core"], factory);
		}
		else {
			// Global (browser)
			factory(root.CryptoJS);
		}
	}(this, function (CryptoJS) {
	
		/**
		 * Counter block mode.
		 */
		CryptoJS.mode.CTR = (function () {
		    var CTR = CryptoJS.lib.BlockCipherMode.extend();
	
		    var Encryptor = CTR.Encryptor = CTR.extend({
		        processBlock: function (words, offset) {
		            // Shortcuts
		            var cipher = this._cipher
		            var blockSize = cipher.blockSize;
		            var iv = this._iv;
		            var counter = this._counter;
	
		            // Generate keystream
		            if (iv) {
		                counter = this._counter = iv.slice(0);
	
		                // Remove IV for subsequent blocks
		                this._iv = undefined;
		            }
		            var keystream = counter.slice(0);
		            cipher.encryptBlock(keystream, 0);
	
		            // Increment counter
		            counter[blockSize - 1] = (counter[blockSize - 1] + 1) | 0
	
		            // Encrypt
		            for (var i = 0; i < blockSize; i++) {
		                words[offset + i] ^= keystream[i];
		            }
		        }
		    });
	
		    CTR.Decryptor = Encryptor;
	
		    return CTR;
		}());
	
	
		return CryptoJS.mode.CTR;
	
	}));

/***/ },
/* 798 */
/***/ function(module, exports, __webpack_require__) {

	;(function (root, factory, undef) {
		if (true) {
			// CommonJS
			module.exports = exports = factory(__webpack_require__(25), __webpack_require__(44));
		}
		else if (typeof define === "function" && define.amd) {
			// AMD
			define(["./core", "./cipher-core"], factory);
		}
		else {
			// Global (browser)
			factory(root.CryptoJS);
		}
	}(this, function (CryptoJS) {
	
		/**
		 * Electronic Codebook block mode.
		 */
		CryptoJS.mode.ECB = (function () {
		    var ECB = CryptoJS.lib.BlockCipherMode.extend();
	
		    ECB.Encryptor = ECB.extend({
		        processBlock: function (words, offset) {
		            this._cipher.encryptBlock(words, offset);
		        }
		    });
	
		    ECB.Decryptor = ECB.extend({
		        processBlock: function (words, offset) {
		            this._cipher.decryptBlock(words, offset);
		        }
		    });
	
		    return ECB;
		}());
	
	
		return CryptoJS.mode.ECB;
	
	}));

/***/ },
/* 799 */
/***/ function(module, exports, __webpack_require__) {

	;(function (root, factory, undef) {
		if (true) {
			// CommonJS
			module.exports = exports = factory(__webpack_require__(25), __webpack_require__(44));
		}
		else if (typeof define === "function" && define.amd) {
			// AMD
			define(["./core", "./cipher-core"], factory);
		}
		else {
			// Global (browser)
			factory(root.CryptoJS);
		}
	}(this, function (CryptoJS) {
	
		/**
		 * Output Feedback block mode.
		 */
		CryptoJS.mode.OFB = (function () {
		    var OFB = CryptoJS.lib.BlockCipherMode.extend();
	
		    var Encryptor = OFB.Encryptor = OFB.extend({
		        processBlock: function (words, offset) {
		            // Shortcuts
		            var cipher = this._cipher
		            var blockSize = cipher.blockSize;
		            var iv = this._iv;
		            var keystream = this._keystream;
	
		            // Generate keystream
		            if (iv) {
		                keystream = this._keystream = iv.slice(0);
	
		                // Remove IV for subsequent blocks
		                this._iv = undefined;
		            }
		            cipher.encryptBlock(keystream, 0);
	
		            // Encrypt
		            for (var i = 0; i < blockSize; i++) {
		                words[offset + i] ^= keystream[i];
		            }
		        }
		    });
	
		    OFB.Decryptor = Encryptor;
	
		    return OFB;
		}());
	
	
		return CryptoJS.mode.OFB;
	
	}));

/***/ },
/* 800 */
/***/ function(module, exports, __webpack_require__) {

	;(function (root, factory, undef) {
		if (true) {
			// CommonJS
			module.exports = exports = factory(__webpack_require__(25), __webpack_require__(44));
		}
		else if (typeof define === "function" && define.amd) {
			// AMD
			define(["./core", "./cipher-core"], factory);
		}
		else {
			// Global (browser)
			factory(root.CryptoJS);
		}
	}(this, function (CryptoJS) {
	
		/**
		 * ANSI X.923 padding strategy.
		 */
		CryptoJS.pad.AnsiX923 = {
		    pad: function (data, blockSize) {
		        // Shortcuts
		        var dataSigBytes = data.sigBytes;
		        var blockSizeBytes = blockSize * 4;
	
		        // Count padding bytes
		        var nPaddingBytes = blockSizeBytes - dataSigBytes % blockSizeBytes;
	
		        // Compute last byte position
		        var lastBytePos = dataSigBytes + nPaddingBytes - 1;
	
		        // Pad
		        data.clamp();
		        data.words[lastBytePos >>> 2] |= nPaddingBytes << (24 - (lastBytePos % 4) * 8);
		        data.sigBytes += nPaddingBytes;
		    },
	
		    unpad: function (data) {
		        // Get number of padding bytes from last byte
		        var nPaddingBytes = data.words[(data.sigBytes - 1) >>> 2] & 0xff;
	
		        // Remove padding
		        data.sigBytes -= nPaddingBytes;
		    }
		};
	
	
		return CryptoJS.pad.Ansix923;
	
	}));

/***/ },
/* 801 */
/***/ function(module, exports, __webpack_require__) {

	;(function (root, factory, undef) {
		if (true) {
			// CommonJS
			module.exports = exports = factory(__webpack_require__(25), __webpack_require__(44));
		}
		else if (typeof define === "function" && define.amd) {
			// AMD
			define(["./core", "./cipher-core"], factory);
		}
		else {
			// Global (browser)
			factory(root.CryptoJS);
		}
	}(this, function (CryptoJS) {
	
		/**
		 * ISO 10126 padding strategy.
		 */
		CryptoJS.pad.Iso10126 = {
		    pad: function (data, blockSize) {
		        // Shortcut
		        var blockSizeBytes = blockSize * 4;
	
		        // Count padding bytes
		        var nPaddingBytes = blockSizeBytes - data.sigBytes % blockSizeBytes;
	
		        // Pad
		        data.concat(CryptoJS.lib.WordArray.random(nPaddingBytes - 1)).
		             concat(CryptoJS.lib.WordArray.create([nPaddingBytes << 24], 1));
		    },
	
		    unpad: function (data) {
		        // Get number of padding bytes from last byte
		        var nPaddingBytes = data.words[(data.sigBytes - 1) >>> 2] & 0xff;
	
		        // Remove padding
		        data.sigBytes -= nPaddingBytes;
		    }
		};
	
	
		return CryptoJS.pad.Iso10126;
	
	}));

/***/ },
/* 802 */
/***/ function(module, exports, __webpack_require__) {

	;(function (root, factory, undef) {
		if (true) {
			// CommonJS
			module.exports = exports = factory(__webpack_require__(25), __webpack_require__(44));
		}
		else if (typeof define === "function" && define.amd) {
			// AMD
			define(["./core", "./cipher-core"], factory);
		}
		else {
			// Global (browser)
			factory(root.CryptoJS);
		}
	}(this, function (CryptoJS) {
	
		/**
		 * ISO/IEC 9797-1 Padding Method 2.
		 */
		CryptoJS.pad.Iso97971 = {
		    pad: function (data, blockSize) {
		        // Add 0x80 byte
		        data.concat(CryptoJS.lib.WordArray.create([0x80000000], 1));
	
		        // Zero pad the rest
		        CryptoJS.pad.ZeroPadding.pad(data, blockSize);
		    },
	
		    unpad: function (data) {
		        // Remove zero padding
		        CryptoJS.pad.ZeroPadding.unpad(data);
	
		        // Remove one more byte -- the 0x80 byte
		        data.sigBytes--;
		    }
		};
	
	
		return CryptoJS.pad.Iso97971;
	
	}));

/***/ },
/* 803 */
/***/ function(module, exports, __webpack_require__) {

	;(function (root, factory, undef) {
		if (true) {
			// CommonJS
			module.exports = exports = factory(__webpack_require__(25), __webpack_require__(44));
		}
		else if (typeof define === "function" && define.amd) {
			// AMD
			define(["./core", "./cipher-core"], factory);
		}
		else {
			// Global (browser)
			factory(root.CryptoJS);
		}
	}(this, function (CryptoJS) {
	
		/**
		 * A noop padding strategy.
		 */
		CryptoJS.pad.NoPadding = {
		    pad: function () {
		    },
	
		    unpad: function () {
		    }
		};
	
	
		return CryptoJS.pad.NoPadding;
	
	}));

/***/ },
/* 804 */
/***/ function(module, exports, __webpack_require__) {

	;(function (root, factory, undef) {
		if (true) {
			// CommonJS
			module.exports = exports = factory(__webpack_require__(25), __webpack_require__(44));
		}
		else if (typeof define === "function" && define.amd) {
			// AMD
			define(["./core", "./cipher-core"], factory);
		}
		else {
			// Global (browser)
			factory(root.CryptoJS);
		}
	}(this, function (CryptoJS) {
	
		/**
		 * Zero padding strategy.
		 */
		CryptoJS.pad.ZeroPadding = {
		    pad: function (data, blockSize) {
		        // Shortcut
		        var blockSizeBytes = blockSize * 4;
	
		        // Pad
		        data.clamp();
		        data.sigBytes += blockSizeBytes - ((data.sigBytes % blockSizeBytes) || blockSizeBytes);
		    },
	
		    unpad: function (data) {
		        // Shortcut
		        var dataWords = data.words;
	
		        // Unpad
		        var i = data.sigBytes - 1;
		        while (!((dataWords[i >>> 2] >>> (24 - (i % 4) * 8)) & 0xff)) {
		            i--;
		        }
		        data.sigBytes = i + 1;
		    }
		};
	
	
		return CryptoJS.pad.ZeroPadding;
	
	}));

/***/ },
/* 805 */
/***/ function(module, exports, __webpack_require__) {

	;(function (root, factory, undef) {
		if (true) {
			// CommonJS
			module.exports = exports = factory(__webpack_require__(25), __webpack_require__(232), __webpack_require__(231));
		}
		else if (typeof define === "function" && define.amd) {
			// AMD
			define(["./core", "./sha1", "./hmac"], factory);
		}
		else {
			// Global (browser)
			factory(root.CryptoJS);
		}
	}(this, function (CryptoJS) {
	
		(function () {
		    // Shortcuts
		    var C = CryptoJS;
		    var C_lib = C.lib;
		    var Base = C_lib.Base;
		    var WordArray = C_lib.WordArray;
		    var C_algo = C.algo;
		    var SHA1 = C_algo.SHA1;
		    var HMAC = C_algo.HMAC;
	
		    /**
		     * Password-Based Key Derivation Function 2 algorithm.
		     */
		    var PBKDF2 = C_algo.PBKDF2 = Base.extend({
		        /**
		         * Configuration options.
		         *
		         * @property {number} keySize The key size in words to generate. Default: 4 (128 bits)
		         * @property {Hasher} hasher The hasher to use. Default: SHA1
		         * @property {number} iterations The number of iterations to perform. Default: 1
		         */
		        cfg: Base.extend({
		            keySize: 128/32,
		            hasher: SHA1,
		            iterations: 1
		        }),
	
		        /**
		         * Initializes a newly created key derivation function.
		         *
		         * @param {Object} cfg (Optional) The configuration options to use for the derivation.
		         *
		         * @example
		         *
		         *     var kdf = CryptoJS.algo.PBKDF2.create();
		         *     var kdf = CryptoJS.algo.PBKDF2.create({ keySize: 8 });
		         *     var kdf = CryptoJS.algo.PBKDF2.create({ keySize: 8, iterations: 1000 });
		         */
		        init: function (cfg) {
		            this.cfg = this.cfg.extend(cfg);
		        },
	
		        /**
		         * Computes the Password-Based Key Derivation Function 2.
		         *
		         * @param {WordArray|string} password The password.
		         * @param {WordArray|string} salt A salt.
		         *
		         * @return {WordArray} The derived key.
		         *
		         * @example
		         *
		         *     var key = kdf.compute(password, salt);
		         */
		        compute: function (password, salt) {
		            // Shortcut
		            var cfg = this.cfg;
	
		            // Init HMAC
		            var hmac = HMAC.create(cfg.hasher, password);
	
		            // Initial values
		            var derivedKey = WordArray.create();
		            var blockIndex = WordArray.create([0x00000001]);
	
		            // Shortcuts
		            var derivedKeyWords = derivedKey.words;
		            var blockIndexWords = blockIndex.words;
		            var keySize = cfg.keySize;
		            var iterations = cfg.iterations;
	
		            // Generate key
		            while (derivedKeyWords.length < keySize) {
		                var block = hmac.update(salt).finalize(blockIndex);
		                hmac.reset();
	
		                // Shortcuts
		                var blockWords = block.words;
		                var blockWordsLength = blockWords.length;
	
		                // Iterations
		                var intermediate = block;
		                for (var i = 1; i < iterations; i++) {
		                    intermediate = hmac.finalize(intermediate);
		                    hmac.reset();
	
		                    // Shortcut
		                    var intermediateWords = intermediate.words;
	
		                    // XOR intermediate with block
		                    for (var j = 0; j < blockWordsLength; j++) {
		                        blockWords[j] ^= intermediateWords[j];
		                    }
		                }
	
		                derivedKey.concat(block);
		                blockIndexWords[0]++;
		            }
		            derivedKey.sigBytes = keySize * 4;
	
		            return derivedKey;
		        }
		    });
	
		    /**
		     * Computes the Password-Based Key Derivation Function 2.
		     *
		     * @param {WordArray|string} password The password.
		     * @param {WordArray|string} salt A salt.
		     * @param {Object} cfg (Optional) The configuration options to use for this computation.
		     *
		     * @return {WordArray} The derived key.
		     *
		     * @static
		     *
		     * @example
		     *
		     *     var key = CryptoJS.PBKDF2(password, salt);
		     *     var key = CryptoJS.PBKDF2(password, salt, { keySize: 8 });
		     *     var key = CryptoJS.PBKDF2(password, salt, { keySize: 8, iterations: 1000 });
		     */
		    C.PBKDF2 = function (password, salt, cfg) {
		        return PBKDF2.create(cfg).compute(password, salt);
		    };
		}());
	
	
		return CryptoJS.PBKDF2;
	
	}));

/***/ },
/* 806 */
/***/ function(module, exports, __webpack_require__) {

	;(function (root, factory, undef) {
		if (true) {
			// CommonJS
			module.exports = exports = factory(__webpack_require__(25), __webpack_require__(120), __webpack_require__(121), __webpack_require__(112), __webpack_require__(44));
		}
		else if (typeof define === "function" && define.amd) {
			// AMD
			define(["./core", "./enc-base64", "./md5", "./evpkdf", "./cipher-core"], factory);
		}
		else {
			// Global (browser)
			factory(root.CryptoJS);
		}
	}(this, function (CryptoJS) {
	
		(function () {
		    // Shortcuts
		    var C = CryptoJS;
		    var C_lib = C.lib;
		    var StreamCipher = C_lib.StreamCipher;
		    var C_algo = C.algo;
	
		    // Reusable objects
		    var S  = [];
		    var C_ = [];
		    var G  = [];
	
		    /**
		     * Rabbit stream cipher algorithm.
		     *
		     * This is a legacy version that neglected to convert the key to little-endian.
		     * This error doesn't affect the cipher's security,
		     * but it does affect its compatibility with other implementations.
		     */
		    var RabbitLegacy = C_algo.RabbitLegacy = StreamCipher.extend({
		        _doReset: function () {
		            // Shortcuts
		            var K = this._key.words;
		            var iv = this.cfg.iv;
	
		            // Generate initial state values
		            var X = this._X = [
		                K[0], (K[3] << 16) | (K[2] >>> 16),
		                K[1], (K[0] << 16) | (K[3] >>> 16),
		                K[2], (K[1] << 16) | (K[0] >>> 16),
		                K[3], (K[2] << 16) | (K[1] >>> 16)
		            ];
	
		            // Generate initial counter values
		            var C = this._C = [
		                (K[2] << 16) | (K[2] >>> 16), (K[0] & 0xffff0000) | (K[1] & 0x0000ffff),
		                (K[3] << 16) | (K[3] >>> 16), (K[1] & 0xffff0000) | (K[2] & 0x0000ffff),
		                (K[0] << 16) | (K[0] >>> 16), (K[2] & 0xffff0000) | (K[3] & 0x0000ffff),
		                (K[1] << 16) | (K[1] >>> 16), (K[3] & 0xffff0000) | (K[0] & 0x0000ffff)
		            ];
	
		            // Carry bit
		            this._b = 0;
	
		            // Iterate the system four times
		            for (var i = 0; i < 4; i++) {
		                nextState.call(this);
		            }
	
		            // Modify the counters
		            for (var i = 0; i < 8; i++) {
		                C[i] ^= X[(i + 4) & 7];
		            }
	
		            // IV setup
		            if (iv) {
		                // Shortcuts
		                var IV = iv.words;
		                var IV_0 = IV[0];
		                var IV_1 = IV[1];
	
		                // Generate four subvectors
		                var i0 = (((IV_0 << 8) | (IV_0 >>> 24)) & 0x00ff00ff) | (((IV_0 << 24) | (IV_0 >>> 8)) & 0xff00ff00);
		                var i2 = (((IV_1 << 8) | (IV_1 >>> 24)) & 0x00ff00ff) | (((IV_1 << 24) | (IV_1 >>> 8)) & 0xff00ff00);
		                var i1 = (i0 >>> 16) | (i2 & 0xffff0000);
		                var i3 = (i2 << 16)  | (i0 & 0x0000ffff);
	
		                // Modify counter values
		                C[0] ^= i0;
		                C[1] ^= i1;
		                C[2] ^= i2;
		                C[3] ^= i3;
		                C[4] ^= i0;
		                C[5] ^= i1;
		                C[6] ^= i2;
		                C[7] ^= i3;
	
		                // Iterate the system four times
		                for (var i = 0; i < 4; i++) {
		                    nextState.call(this);
		                }
		            }
		        },
	
		        _doProcessBlock: function (M, offset) {
		            // Shortcut
		            var X = this._X;
	
		            // Iterate the system
		            nextState.call(this);
	
		            // Generate four keystream words
		            S[0] = X[0] ^ (X[5] >>> 16) ^ (X[3] << 16);
		            S[1] = X[2] ^ (X[7] >>> 16) ^ (X[5] << 16);
		            S[2] = X[4] ^ (X[1] >>> 16) ^ (X[7] << 16);
		            S[3] = X[6] ^ (X[3] >>> 16) ^ (X[1] << 16);
	
		            for (var i = 0; i < 4; i++) {
		                // Swap endian
		                S[i] = (((S[i] << 8)  | (S[i] >>> 24)) & 0x00ff00ff) |
		                       (((S[i] << 24) | (S[i] >>> 8))  & 0xff00ff00);
	
		                // Encrypt
		                M[offset + i] ^= S[i];
		            }
		        },
	
		        blockSize: 128/32,
	
		        ivSize: 64/32
		    });
	
		    function nextState() {
		        // Shortcuts
		        var X = this._X;
		        var C = this._C;
	
		        // Save old counter values
		        for (var i = 0; i < 8; i++) {
		            C_[i] = C[i];
		        }
	
		        // Calculate new counter values
		        C[0] = (C[0] + 0x4d34d34d + this._b) | 0;
		        C[1] = (C[1] + 0xd34d34d3 + ((C[0] >>> 0) < (C_[0] >>> 0) ? 1 : 0)) | 0;
		        C[2] = (C[2] + 0x34d34d34 + ((C[1] >>> 0) < (C_[1] >>> 0) ? 1 : 0)) | 0;
		        C[3] = (C[3] + 0x4d34d34d + ((C[2] >>> 0) < (C_[2] >>> 0) ? 1 : 0)) | 0;
		        C[4] = (C[4] + 0xd34d34d3 + ((C[3] >>> 0) < (C_[3] >>> 0) ? 1 : 0)) | 0;
		        C[5] = (C[5] + 0x34d34d34 + ((C[4] >>> 0) < (C_[4] >>> 0) ? 1 : 0)) | 0;
		        C[6] = (C[6] + 0x4d34d34d + ((C[5] >>> 0) < (C_[5] >>> 0) ? 1 : 0)) | 0;
		        C[7] = (C[7] + 0xd34d34d3 + ((C[6] >>> 0) < (C_[6] >>> 0) ? 1 : 0)) | 0;
		        this._b = (C[7] >>> 0) < (C_[7] >>> 0) ? 1 : 0;
	
		        // Calculate the g-values
		        for (var i = 0; i < 8; i++) {
		            var gx = X[i] + C[i];
	
		            // Construct high and low argument for squaring
		            var ga = gx & 0xffff;
		            var gb = gx >>> 16;
	
		            // Calculate high and low result of squaring
		            var gh = ((((ga * ga) >>> 17) + ga * gb) >>> 15) + gb * gb;
		            var gl = (((gx & 0xffff0000) * gx) | 0) + (((gx & 0x0000ffff) * gx) | 0);
	
		            // High XOR low
		            G[i] = gh ^ gl;
		        }
	
		        // Calculate new state values
		        X[0] = (G[0] + ((G[7] << 16) | (G[7] >>> 16)) + ((G[6] << 16) | (G[6] >>> 16))) | 0;
		        X[1] = (G[1] + ((G[0] << 8)  | (G[0] >>> 24)) + G[7]) | 0;
		        X[2] = (G[2] + ((G[1] << 16) | (G[1] >>> 16)) + ((G[0] << 16) | (G[0] >>> 16))) | 0;
		        X[3] = (G[3] + ((G[2] << 8)  | (G[2] >>> 24)) + G[1]) | 0;
		        X[4] = (G[4] + ((G[3] << 16) | (G[3] >>> 16)) + ((G[2] << 16) | (G[2] >>> 16))) | 0;
		        X[5] = (G[5] + ((G[4] << 8)  | (G[4] >>> 24)) + G[3]) | 0;
		        X[6] = (G[6] + ((G[5] << 16) | (G[5] >>> 16)) + ((G[4] << 16) | (G[4] >>> 16))) | 0;
		        X[7] = (G[7] + ((G[6] << 8)  | (G[6] >>> 24)) + G[5]) | 0;
		    }
	
		    /**
		     * Shortcut functions to the cipher's object interface.
		     *
		     * @example
		     *
		     *     var ciphertext = CryptoJS.RabbitLegacy.encrypt(message, key, cfg);
		     *     var plaintext  = CryptoJS.RabbitLegacy.decrypt(ciphertext, key, cfg);
		     */
		    C.RabbitLegacy = StreamCipher._createHelper(RabbitLegacy);
		}());
	
	
		return CryptoJS.RabbitLegacy;
	
	}));

/***/ },
/* 807 */
/***/ function(module, exports, __webpack_require__) {

	;(function (root, factory, undef) {
		if (true) {
			// CommonJS
			module.exports = exports = factory(__webpack_require__(25), __webpack_require__(120), __webpack_require__(121), __webpack_require__(112), __webpack_require__(44));
		}
		else if (typeof define === "function" && define.amd) {
			// AMD
			define(["./core", "./enc-base64", "./md5", "./evpkdf", "./cipher-core"], factory);
		}
		else {
			// Global (browser)
			factory(root.CryptoJS);
		}
	}(this, function (CryptoJS) {
	
		(function () {
		    // Shortcuts
		    var C = CryptoJS;
		    var C_lib = C.lib;
		    var StreamCipher = C_lib.StreamCipher;
		    var C_algo = C.algo;
	
		    // Reusable objects
		    var S  = [];
		    var C_ = [];
		    var G  = [];
	
		    /**
		     * Rabbit stream cipher algorithm
		     */
		    var Rabbit = C_algo.Rabbit = StreamCipher.extend({
		        _doReset: function () {
		            // Shortcuts
		            var K = this._key.words;
		            var iv = this.cfg.iv;
	
		            // Swap endian
		            for (var i = 0; i < 4; i++) {
		                K[i] = (((K[i] << 8)  | (K[i] >>> 24)) & 0x00ff00ff) |
		                       (((K[i] << 24) | (K[i] >>> 8))  & 0xff00ff00);
		            }
	
		            // Generate initial state values
		            var X = this._X = [
		                K[0], (K[3] << 16) | (K[2] >>> 16),
		                K[1], (K[0] << 16) | (K[3] >>> 16),
		                K[2], (K[1] << 16) | (K[0] >>> 16),
		                K[3], (K[2] << 16) | (K[1] >>> 16)
		            ];
	
		            // Generate initial counter values
		            var C = this._C = [
		                (K[2] << 16) | (K[2] >>> 16), (K[0] & 0xffff0000) | (K[1] & 0x0000ffff),
		                (K[3] << 16) | (K[3] >>> 16), (K[1] & 0xffff0000) | (K[2] & 0x0000ffff),
		                (K[0] << 16) | (K[0] >>> 16), (K[2] & 0xffff0000) | (K[3] & 0x0000ffff),
		                (K[1] << 16) | (K[1] >>> 16), (K[3] & 0xffff0000) | (K[0] & 0x0000ffff)
		            ];
	
		            // Carry bit
		            this._b = 0;
	
		            // Iterate the system four times
		            for (var i = 0; i < 4; i++) {
		                nextState.call(this);
		            }
	
		            // Modify the counters
		            for (var i = 0; i < 8; i++) {
		                C[i] ^= X[(i + 4) & 7];
		            }
	
		            // IV setup
		            if (iv) {
		                // Shortcuts
		                var IV = iv.words;
		                var IV_0 = IV[0];
		                var IV_1 = IV[1];
	
		                // Generate four subvectors
		                var i0 = (((IV_0 << 8) | (IV_0 >>> 24)) & 0x00ff00ff) | (((IV_0 << 24) | (IV_0 >>> 8)) & 0xff00ff00);
		                var i2 = (((IV_1 << 8) | (IV_1 >>> 24)) & 0x00ff00ff) | (((IV_1 << 24) | (IV_1 >>> 8)) & 0xff00ff00);
		                var i1 = (i0 >>> 16) | (i2 & 0xffff0000);
		                var i3 = (i2 << 16)  | (i0 & 0x0000ffff);
	
		                // Modify counter values
		                C[0] ^= i0;
		                C[1] ^= i1;
		                C[2] ^= i2;
		                C[3] ^= i3;
		                C[4] ^= i0;
		                C[5] ^= i1;
		                C[6] ^= i2;
		                C[7] ^= i3;
	
		                // Iterate the system four times
		                for (var i = 0; i < 4; i++) {
		                    nextState.call(this);
		                }
		            }
		        },
	
		        _doProcessBlock: function (M, offset) {
		            // Shortcut
		            var X = this._X;
	
		            // Iterate the system
		            nextState.call(this);
	
		            // Generate four keystream words
		            S[0] = X[0] ^ (X[5] >>> 16) ^ (X[3] << 16);
		            S[1] = X[2] ^ (X[7] >>> 16) ^ (X[5] << 16);
		            S[2] = X[4] ^ (X[1] >>> 16) ^ (X[7] << 16);
		            S[3] = X[6] ^ (X[3] >>> 16) ^ (X[1] << 16);
	
		            for (var i = 0; i < 4; i++) {
		                // Swap endian
		                S[i] = (((S[i] << 8)  | (S[i] >>> 24)) & 0x00ff00ff) |
		                       (((S[i] << 24) | (S[i] >>> 8))  & 0xff00ff00);
	
		                // Encrypt
		                M[offset + i] ^= S[i];
		            }
		        },
	
		        blockSize: 128/32,
	
		        ivSize: 64/32
		    });
	
		    function nextState() {
		        // Shortcuts
		        var X = this._X;
		        var C = this._C;
	
		        // Save old counter values
		        for (var i = 0; i < 8; i++) {
		            C_[i] = C[i];
		        }
	
		        // Calculate new counter values
		        C[0] = (C[0] + 0x4d34d34d + this._b) | 0;
		        C[1] = (C[1] + 0xd34d34d3 + ((C[0] >>> 0) < (C_[0] >>> 0) ? 1 : 0)) | 0;
		        C[2] = (C[2] + 0x34d34d34 + ((C[1] >>> 0) < (C_[1] >>> 0) ? 1 : 0)) | 0;
		        C[3] = (C[3] + 0x4d34d34d + ((C[2] >>> 0) < (C_[2] >>> 0) ? 1 : 0)) | 0;
		        C[4] = (C[4] + 0xd34d34d3 + ((C[3] >>> 0) < (C_[3] >>> 0) ? 1 : 0)) | 0;
		        C[5] = (C[5] + 0x34d34d34 + ((C[4] >>> 0) < (C_[4] >>> 0) ? 1 : 0)) | 0;
		        C[6] = (C[6] + 0x4d34d34d + ((C[5] >>> 0) < (C_[5] >>> 0) ? 1 : 0)) | 0;
		        C[7] = (C[7] + 0xd34d34d3 + ((C[6] >>> 0) < (C_[6] >>> 0) ? 1 : 0)) | 0;
		        this._b = (C[7] >>> 0) < (C_[7] >>> 0) ? 1 : 0;
	
		        // Calculate the g-values
		        for (var i = 0; i < 8; i++) {
		            var gx = X[i] + C[i];
	
		            // Construct high and low argument for squaring
		            var ga = gx & 0xffff;
		            var gb = gx >>> 16;
	
		            // Calculate high and low result of squaring
		            var gh = ((((ga * ga) >>> 17) + ga * gb) >>> 15) + gb * gb;
		            var gl = (((gx & 0xffff0000) * gx) | 0) + (((gx & 0x0000ffff) * gx) | 0);
	
		            // High XOR low
		            G[i] = gh ^ gl;
		        }
	
		        // Calculate new state values
		        X[0] = (G[0] + ((G[7] << 16) | (G[7] >>> 16)) + ((G[6] << 16) | (G[6] >>> 16))) | 0;
		        X[1] = (G[1] + ((G[0] << 8)  | (G[0] >>> 24)) + G[7]) | 0;
		        X[2] = (G[2] + ((G[1] << 16) | (G[1] >>> 16)) + ((G[0] << 16) | (G[0] >>> 16))) | 0;
		        X[3] = (G[3] + ((G[2] << 8)  | (G[2] >>> 24)) + G[1]) | 0;
		        X[4] = (G[4] + ((G[3] << 16) | (G[3] >>> 16)) + ((G[2] << 16) | (G[2] >>> 16))) | 0;
		        X[5] = (G[5] + ((G[4] << 8)  | (G[4] >>> 24)) + G[3]) | 0;
		        X[6] = (G[6] + ((G[5] << 16) | (G[5] >>> 16)) + ((G[4] << 16) | (G[4] >>> 16))) | 0;
		        X[7] = (G[7] + ((G[6] << 8)  | (G[6] >>> 24)) + G[5]) | 0;
		    }
	
		    /**
		     * Shortcut functions to the cipher's object interface.
		     *
		     * @example
		     *
		     *     var ciphertext = CryptoJS.Rabbit.encrypt(message, key, cfg);
		     *     var plaintext  = CryptoJS.Rabbit.decrypt(ciphertext, key, cfg);
		     */
		    C.Rabbit = StreamCipher._createHelper(Rabbit);
		}());
	
	
		return CryptoJS.Rabbit;
	
	}));

/***/ },
/* 808 */
/***/ function(module, exports, __webpack_require__) {

	;(function (root, factory, undef) {
		if (true) {
			// CommonJS
			module.exports = exports = factory(__webpack_require__(25), __webpack_require__(120), __webpack_require__(121), __webpack_require__(112), __webpack_require__(44));
		}
		else if (typeof define === "function" && define.amd) {
			// AMD
			define(["./core", "./enc-base64", "./md5", "./evpkdf", "./cipher-core"], factory);
		}
		else {
			// Global (browser)
			factory(root.CryptoJS);
		}
	}(this, function (CryptoJS) {
	
		(function () {
		    // Shortcuts
		    var C = CryptoJS;
		    var C_lib = C.lib;
		    var StreamCipher = C_lib.StreamCipher;
		    var C_algo = C.algo;
	
		    /**
		     * RC4 stream cipher algorithm.
		     */
		    var RC4 = C_algo.RC4 = StreamCipher.extend({
		        _doReset: function () {
		            // Shortcuts
		            var key = this._key;
		            var keyWords = key.words;
		            var keySigBytes = key.sigBytes;
	
		            // Init sbox
		            var S = this._S = [];
		            for (var i = 0; i < 256; i++) {
		                S[i] = i;
		            }
	
		            // Key setup
		            for (var i = 0, j = 0; i < 256; i++) {
		                var keyByteIndex = i % keySigBytes;
		                var keyByte = (keyWords[keyByteIndex >>> 2] >>> (24 - (keyByteIndex % 4) * 8)) & 0xff;
	
		                j = (j + S[i] + keyByte) % 256;
	
		                // Swap
		                var t = S[i];
		                S[i] = S[j];
		                S[j] = t;
		            }
	
		            // Counters
		            this._i = this._j = 0;
		        },
	
		        _doProcessBlock: function (M, offset) {
		            M[offset] ^= generateKeystreamWord.call(this);
		        },
	
		        keySize: 256/32,
	
		        ivSize: 0
		    });
	
		    function generateKeystreamWord() {
		        // Shortcuts
		        var S = this._S;
		        var i = this._i;
		        var j = this._j;
	
		        // Generate keystream word
		        var keystreamWord = 0;
		        for (var n = 0; n < 4; n++) {
		            i = (i + 1) % 256;
		            j = (j + S[i]) % 256;
	
		            // Swap
		            var t = S[i];
		            S[i] = S[j];
		            S[j] = t;
	
		            keystreamWord |= S[(S[i] + S[j]) % 256] << (24 - n * 8);
		        }
	
		        // Update counters
		        this._i = i;
		        this._j = j;
	
		        return keystreamWord;
		    }
	
		    /**
		     * Shortcut functions to the cipher's object interface.
		     *
		     * @example
		     *
		     *     var ciphertext = CryptoJS.RC4.encrypt(message, key, cfg);
		     *     var plaintext  = CryptoJS.RC4.decrypt(ciphertext, key, cfg);
		     */
		    C.RC4 = StreamCipher._createHelper(RC4);
	
		    /**
		     * Modified RC4 stream cipher algorithm.
		     */
		    var RC4Drop = C_algo.RC4Drop = RC4.extend({
		        /**
		         * Configuration options.
		         *
		         * @property {number} drop The number of keystream words to drop. Default 192
		         */
		        cfg: RC4.cfg.extend({
		            drop: 192
		        }),
	
		        _doReset: function () {
		            RC4._doReset.call(this);
	
		            // Drop
		            for (var i = this.cfg.drop; i > 0; i--) {
		                generateKeystreamWord.call(this);
		            }
		        }
		    });
	
		    /**
		     * Shortcut functions to the cipher's object interface.
		     *
		     * @example
		     *
		     *     var ciphertext = CryptoJS.RC4Drop.encrypt(message, key, cfg);
		     *     var plaintext  = CryptoJS.RC4Drop.decrypt(ciphertext, key, cfg);
		     */
		    C.RC4Drop = StreamCipher._createHelper(RC4Drop);
		}());
	
	
		return CryptoJS.RC4;
	
	}));

/***/ },
/* 809 */
/***/ function(module, exports, __webpack_require__) {

	;(function (root, factory) {
		if (true) {
			// CommonJS
			module.exports = exports = factory(__webpack_require__(25));
		}
		else if (typeof define === "function" && define.amd) {
			// AMD
			define(["./core"], factory);
		}
		else {
			// Global (browser)
			factory(root.CryptoJS);
		}
	}(this, function (CryptoJS) {
	
		/** @preserve
		(c) 2012 by Cédric Mesnil. All rights reserved.
	
		Redistribution and use in source and binary forms, with or without modification, are permitted provided that the following conditions are met:
	
		    - Redistributions of source code must retain the above copyright notice, this list of conditions and the following disclaimer.
		    - Redistributions in binary form must reproduce the above copyright notice, this list of conditions and the following disclaimer in the documentation and/or other materials provided with the distribution.
	
		THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS" AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
		*/
	
		(function (Math) {
		    // Shortcuts
		    var C = CryptoJS;
		    var C_lib = C.lib;
		    var WordArray = C_lib.WordArray;
		    var Hasher = C_lib.Hasher;
		    var C_algo = C.algo;
	
		    // Constants table
		    var _zl = WordArray.create([
		        0,  1,  2,  3,  4,  5,  6,  7,  8,  9, 10, 11, 12, 13, 14, 15,
		        7,  4, 13,  1, 10,  6, 15,  3, 12,  0,  9,  5,  2, 14, 11,  8,
		        3, 10, 14,  4,  9, 15,  8,  1,  2,  7,  0,  6, 13, 11,  5, 12,
		        1,  9, 11, 10,  0,  8, 12,  4, 13,  3,  7, 15, 14,  5,  6,  2,
		        4,  0,  5,  9,  7, 12,  2, 10, 14,  1,  3,  8, 11,  6, 15, 13]);
		    var _zr = WordArray.create([
		        5, 14,  7,  0,  9,  2, 11,  4, 13,  6, 15,  8,  1, 10,  3, 12,
		        6, 11,  3,  7,  0, 13,  5, 10, 14, 15,  8, 12,  4,  9,  1,  2,
		        15,  5,  1,  3,  7, 14,  6,  9, 11,  8, 12,  2, 10,  0,  4, 13,
		        8,  6,  4,  1,  3, 11, 15,  0,  5, 12,  2, 13,  9,  7, 10, 14,
		        12, 15, 10,  4,  1,  5,  8,  7,  6,  2, 13, 14,  0,  3,  9, 11]);
		    var _sl = WordArray.create([
		         11, 14, 15, 12,  5,  8,  7,  9, 11, 13, 14, 15,  6,  7,  9,  8,
		        7, 6,   8, 13, 11,  9,  7, 15,  7, 12, 15,  9, 11,  7, 13, 12,
		        11, 13,  6,  7, 14,  9, 13, 15, 14,  8, 13,  6,  5, 12,  7,  5,
		          11, 12, 14, 15, 14, 15,  9,  8,  9, 14,  5,  6,  8,  6,  5, 12,
		        9, 15,  5, 11,  6,  8, 13, 12,  5, 12, 13, 14, 11,  8,  5,  6 ]);
		    var _sr = WordArray.create([
		        8,  9,  9, 11, 13, 15, 15,  5,  7,  7,  8, 11, 14, 14, 12,  6,
		        9, 13, 15,  7, 12,  8,  9, 11,  7,  7, 12,  7,  6, 15, 13, 11,
		        9,  7, 15, 11,  8,  6,  6, 14, 12, 13,  5, 14, 13, 13,  7,  5,
		        15,  5,  8, 11, 14, 14,  6, 14,  6,  9, 12,  9, 12,  5, 15,  8,
		        8,  5, 12,  9, 12,  5, 14,  6,  8, 13,  6,  5, 15, 13, 11, 11 ]);
	
		    var _hl =  WordArray.create([ 0x00000000, 0x5A827999, 0x6ED9EBA1, 0x8F1BBCDC, 0xA953FD4E]);
		    var _hr =  WordArray.create([ 0x50A28BE6, 0x5C4DD124, 0x6D703EF3, 0x7A6D76E9, 0x00000000]);
	
		    /**
		     * RIPEMD160 hash algorithm.
		     */
		    var RIPEMD160 = C_algo.RIPEMD160 = Hasher.extend({
		        _doReset: function () {
		            this._hash  = WordArray.create([0x67452301, 0xEFCDAB89, 0x98BADCFE, 0x10325476, 0xC3D2E1F0]);
		        },
	
		        _doProcessBlock: function (M, offset) {
	
		            // Swap endian
		            for (var i = 0; i < 16; i++) {
		                // Shortcuts
		                var offset_i = offset + i;
		                var M_offset_i = M[offset_i];
	
		                // Swap
		                M[offset_i] = (
		                    (((M_offset_i << 8)  | (M_offset_i >>> 24)) & 0x00ff00ff) |
		                    (((M_offset_i << 24) | (M_offset_i >>> 8))  & 0xff00ff00)
		                );
		            }
		            // Shortcut
		            var H  = this._hash.words;
		            var hl = _hl.words;
		            var hr = _hr.words;
		            var zl = _zl.words;
		            var zr = _zr.words;
		            var sl = _sl.words;
		            var sr = _sr.words;
	
		            // Working variables
		            var al, bl, cl, dl, el;
		            var ar, br, cr, dr, er;
	
		            ar = al = H[0];
		            br = bl = H[1];
		            cr = cl = H[2];
		            dr = dl = H[3];
		            er = el = H[4];
		            // Computation
		            var t;
		            for (var i = 0; i < 80; i += 1) {
		                t = (al +  M[offset+zl[i]])|0;
		                if (i<16){
			            t +=  f1(bl,cl,dl) + hl[0];
		                } else if (i<32) {
			            t +=  f2(bl,cl,dl) + hl[1];
		                } else if (i<48) {
			            t +=  f3(bl,cl,dl) + hl[2];
		                } else if (i<64) {
			            t +=  f4(bl,cl,dl) + hl[3];
		                } else {// if (i<80) {
			            t +=  f5(bl,cl,dl) + hl[4];
		                }
		                t = t|0;
		                t =  rotl(t,sl[i]);
		                t = (t+el)|0;
		                al = el;
		                el = dl;
		                dl = rotl(cl, 10);
		                cl = bl;
		                bl = t;
	
		                t = (ar + M[offset+zr[i]])|0;
		                if (i<16){
			            t +=  f5(br,cr,dr) + hr[0];
		                } else if (i<32) {
			            t +=  f4(br,cr,dr) + hr[1];
		                } else if (i<48) {
			            t +=  f3(br,cr,dr) + hr[2];
		                } else if (i<64) {
			            t +=  f2(br,cr,dr) + hr[3];
		                } else {// if (i<80) {
			            t +=  f1(br,cr,dr) + hr[4];
		                }
		                t = t|0;
		                t =  rotl(t,sr[i]) ;
		                t = (t+er)|0;
		                ar = er;
		                er = dr;
		                dr = rotl(cr, 10);
		                cr = br;
		                br = t;
		            }
		            // Intermediate hash value
		            t    = (H[1] + cl + dr)|0;
		            H[1] = (H[2] + dl + er)|0;
		            H[2] = (H[3] + el + ar)|0;
		            H[3] = (H[4] + al + br)|0;
		            H[4] = (H[0] + bl + cr)|0;
		            H[0] =  t;
		        },
	
		        _doFinalize: function () {
		            // Shortcuts
		            var data = this._data;
		            var dataWords = data.words;
	
		            var nBitsTotal = this._nDataBytes * 8;
		            var nBitsLeft = data.sigBytes * 8;
	
		            // Add padding
		            dataWords[nBitsLeft >>> 5] |= 0x80 << (24 - nBitsLeft % 32);
		            dataWords[(((nBitsLeft + 64) >>> 9) << 4) + 14] = (
		                (((nBitsTotal << 8)  | (nBitsTotal >>> 24)) & 0x00ff00ff) |
		                (((nBitsTotal << 24) | (nBitsTotal >>> 8))  & 0xff00ff00)
		            );
		            data.sigBytes = (dataWords.length + 1) * 4;
	
		            // Hash final blocks
		            this._process();
	
		            // Shortcuts
		            var hash = this._hash;
		            var H = hash.words;
	
		            // Swap endian
		            for (var i = 0; i < 5; i++) {
		                // Shortcut
		                var H_i = H[i];
	
		                // Swap
		                H[i] = (((H_i << 8)  | (H_i >>> 24)) & 0x00ff00ff) |
		                       (((H_i << 24) | (H_i >>> 8))  & 0xff00ff00);
		            }
	
		            // Return final computed hash
		            return hash;
		        },
	
		        clone: function () {
		            var clone = Hasher.clone.call(this);
		            clone._hash = this._hash.clone();
	
		            return clone;
		        }
		    });
	
	
		    function f1(x, y, z) {
		        return ((x) ^ (y) ^ (z));
	
		    }
	
		    function f2(x, y, z) {
		        return (((x)&(y)) | ((~x)&(z)));
		    }
	
		    function f3(x, y, z) {
		        return (((x) | (~(y))) ^ (z));
		    }
	
		    function f4(x, y, z) {
		        return (((x) & (z)) | ((y)&(~(z))));
		    }
	
		    function f5(x, y, z) {
		        return ((x) ^ ((y) |(~(z))));
	
		    }
	
		    function rotl(x,n) {
		        return (x<<n) | (x>>>(32-n));
		    }
	
	
		    /**
		     * Shortcut function to the hasher's object interface.
		     *
		     * @param {WordArray|string} message The message to hash.
		     *
		     * @return {WordArray} The hash.
		     *
		     * @static
		     *
		     * @example
		     *
		     *     var hash = CryptoJS.RIPEMD160('message');
		     *     var hash = CryptoJS.RIPEMD160(wordArray);
		     */
		    C.RIPEMD160 = Hasher._createHelper(RIPEMD160);
	
		    /**
		     * Shortcut function to the HMAC's object interface.
		     *
		     * @param {WordArray|string} message The message to hash.
		     * @param {WordArray|string} key The secret key.
		     *
		     * @return {WordArray} The HMAC.
		     *
		     * @static
		     *
		     * @example
		     *
		     *     var hmac = CryptoJS.HmacRIPEMD160(message, key);
		     */
		    C.HmacRIPEMD160 = Hasher._createHmacHelper(RIPEMD160);
		}(Math));
	
	
		return CryptoJS.RIPEMD160;
	
	}));

/***/ },
/* 810 */
/***/ function(module, exports, __webpack_require__) {

	;(function (root, factory, undef) {
		if (true) {
			// CommonJS
			module.exports = exports = factory(__webpack_require__(25), __webpack_require__(326));
		}
		else if (typeof define === "function" && define.amd) {
			// AMD
			define(["./core", "./sha256"], factory);
		}
		else {
			// Global (browser)
			factory(root.CryptoJS);
		}
	}(this, function (CryptoJS) {
	
		(function () {
		    // Shortcuts
		    var C = CryptoJS;
		    var C_lib = C.lib;
		    var WordArray = C_lib.WordArray;
		    var C_algo = C.algo;
		    var SHA256 = C_algo.SHA256;
	
		    /**
		     * SHA-224 hash algorithm.
		     */
		    var SHA224 = C_algo.SHA224 = SHA256.extend({
		        _doReset: function () {
		            this._hash = new WordArray.init([
		                0xc1059ed8, 0x367cd507, 0x3070dd17, 0xf70e5939,
		                0xffc00b31, 0x68581511, 0x64f98fa7, 0xbefa4fa4
		            ]);
		        },
	
		        _doFinalize: function () {
		            var hash = SHA256._doFinalize.call(this);
	
		            hash.sigBytes -= 4;
	
		            return hash;
		        }
		    });
	
		    /**
		     * Shortcut function to the hasher's object interface.
		     *
		     * @param {WordArray|string} message The message to hash.
		     *
		     * @return {WordArray} The hash.
		     *
		     * @static
		     *
		     * @example
		     *
		     *     var hash = CryptoJS.SHA224('message');
		     *     var hash = CryptoJS.SHA224(wordArray);
		     */
		    C.SHA224 = SHA256._createHelper(SHA224);
	
		    /**
		     * Shortcut function to the HMAC's object interface.
		     *
		     * @param {WordArray|string} message The message to hash.
		     * @param {WordArray|string} key The secret key.
		     *
		     * @return {WordArray} The HMAC.
		     *
		     * @static
		     *
		     * @example
		     *
		     *     var hmac = CryptoJS.HmacSHA224(message, key);
		     */
		    C.HmacSHA224 = SHA256._createHmacHelper(SHA224);
		}());
	
	
		return CryptoJS.SHA224;
	
	}));

/***/ },
/* 811 */
/***/ function(module, exports, __webpack_require__) {

	;(function (root, factory, undef) {
		if (true) {
			// CommonJS
			module.exports = exports = factory(__webpack_require__(25), __webpack_require__(169));
		}
		else if (typeof define === "function" && define.amd) {
			// AMD
			define(["./core", "./x64-core"], factory);
		}
		else {
			// Global (browser)
			factory(root.CryptoJS);
		}
	}(this, function (CryptoJS) {
	
		(function (Math) {
		    // Shortcuts
		    var C = CryptoJS;
		    var C_lib = C.lib;
		    var WordArray = C_lib.WordArray;
		    var Hasher = C_lib.Hasher;
		    var C_x64 = C.x64;
		    var X64Word = C_x64.Word;
		    var C_algo = C.algo;
	
		    // Constants tables
		    var RHO_OFFSETS = [];
		    var PI_INDEXES  = [];
		    var ROUND_CONSTANTS = [];
	
		    // Compute Constants
		    (function () {
		        // Compute rho offset constants
		        var x = 1, y = 0;
		        for (var t = 0; t < 24; t++) {
		            RHO_OFFSETS[x + 5 * y] = ((t + 1) * (t + 2) / 2) % 64;
	
		            var newX = y % 5;
		            var newY = (2 * x + 3 * y) % 5;
		            x = newX;
		            y = newY;
		        }
	
		        // Compute pi index constants
		        for (var x = 0; x < 5; x++) {
		            for (var y = 0; y < 5; y++) {
		                PI_INDEXES[x + 5 * y] = y + ((2 * x + 3 * y) % 5) * 5;
		            }
		        }
	
		        // Compute round constants
		        var LFSR = 0x01;
		        for (var i = 0; i < 24; i++) {
		            var roundConstantMsw = 0;
		            var roundConstantLsw = 0;
	
		            for (var j = 0; j < 7; j++) {
		                if (LFSR & 0x01) {
		                    var bitPosition = (1 << j) - 1;
		                    if (bitPosition < 32) {
		                        roundConstantLsw ^= 1 << bitPosition;
		                    } else /* if (bitPosition >= 32) */ {
		                        roundConstantMsw ^= 1 << (bitPosition - 32);
		                    }
		                }
	
		                // Compute next LFSR
		                if (LFSR & 0x80) {
		                    // Primitive polynomial over GF(2): x^8 + x^6 + x^5 + x^4 + 1
		                    LFSR = (LFSR << 1) ^ 0x71;
		                } else {
		                    LFSR <<= 1;
		                }
		            }
	
		            ROUND_CONSTANTS[i] = X64Word.create(roundConstantMsw, roundConstantLsw);
		        }
		    }());
	
		    // Reusable objects for temporary values
		    var T = [];
		    (function () {
		        for (var i = 0; i < 25; i++) {
		            T[i] = X64Word.create();
		        }
		    }());
	
		    /**
		     * SHA-3 hash algorithm.
		     */
		    var SHA3 = C_algo.SHA3 = Hasher.extend({
		        /**
		         * Configuration options.
		         *
		         * @property {number} outputLength
		         *   The desired number of bits in the output hash.
		         *   Only values permitted are: 224, 256, 384, 512.
		         *   Default: 512
		         */
		        cfg: Hasher.cfg.extend({
		            outputLength: 512
		        }),
	
		        _doReset: function () {
		            var state = this._state = []
		            for (var i = 0; i < 25; i++) {
		                state[i] = new X64Word.init();
		            }
	
		            this.blockSize = (1600 - 2 * this.cfg.outputLength) / 32;
		        },
	
		        _doProcessBlock: function (M, offset) {
		            // Shortcuts
		            var state = this._state;
		            var nBlockSizeLanes = this.blockSize / 2;
	
		            // Absorb
		            for (var i = 0; i < nBlockSizeLanes; i++) {
		                // Shortcuts
		                var M2i  = M[offset + 2 * i];
		                var M2i1 = M[offset + 2 * i + 1];
	
		                // Swap endian
		                M2i = (
		                    (((M2i << 8)  | (M2i >>> 24)) & 0x00ff00ff) |
		                    (((M2i << 24) | (M2i >>> 8))  & 0xff00ff00)
		                );
		                M2i1 = (
		                    (((M2i1 << 8)  | (M2i1 >>> 24)) & 0x00ff00ff) |
		                    (((M2i1 << 24) | (M2i1 >>> 8))  & 0xff00ff00)
		                );
	
		                // Absorb message into state
		                var lane = state[i];
		                lane.high ^= M2i1;
		                lane.low  ^= M2i;
		            }
	
		            // Rounds
		            for (var round = 0; round < 24; round++) {
		                // Theta
		                for (var x = 0; x < 5; x++) {
		                    // Mix column lanes
		                    var tMsw = 0, tLsw = 0;
		                    for (var y = 0; y < 5; y++) {
		                        var lane = state[x + 5 * y];
		                        tMsw ^= lane.high;
		                        tLsw ^= lane.low;
		                    }
	
		                    // Temporary values
		                    var Tx = T[x];
		                    Tx.high = tMsw;
		                    Tx.low  = tLsw;
		                }
		                for (var x = 0; x < 5; x++) {
		                    // Shortcuts
		                    var Tx4 = T[(x + 4) % 5];
		                    var Tx1 = T[(x + 1) % 5];
		                    var Tx1Msw = Tx1.high;
		                    var Tx1Lsw = Tx1.low;
	
		                    // Mix surrounding columns
		                    var tMsw = Tx4.high ^ ((Tx1Msw << 1) | (Tx1Lsw >>> 31));
		                    var tLsw = Tx4.low  ^ ((Tx1Lsw << 1) | (Tx1Msw >>> 31));
		                    for (var y = 0; y < 5; y++) {
		                        var lane = state[x + 5 * y];
		                        lane.high ^= tMsw;
		                        lane.low  ^= tLsw;
		                    }
		                }
	
		                // Rho Pi
		                for (var laneIndex = 1; laneIndex < 25; laneIndex++) {
		                    // Shortcuts
		                    var lane = state[laneIndex];
		                    var laneMsw = lane.high;
		                    var laneLsw = lane.low;
		                    var rhoOffset = RHO_OFFSETS[laneIndex];
	
		                    // Rotate lanes
		                    if (rhoOffset < 32) {
		                        var tMsw = (laneMsw << rhoOffset) | (laneLsw >>> (32 - rhoOffset));
		                        var tLsw = (laneLsw << rhoOffset) | (laneMsw >>> (32 - rhoOffset));
		                    } else /* if (rhoOffset >= 32) */ {
		                        var tMsw = (laneLsw << (rhoOffset - 32)) | (laneMsw >>> (64 - rhoOffset));
		                        var tLsw = (laneMsw << (rhoOffset - 32)) | (laneLsw >>> (64 - rhoOffset));
		                    }
	
		                    // Transpose lanes
		                    var TPiLane = T[PI_INDEXES[laneIndex]];
		                    TPiLane.high = tMsw;
		                    TPiLane.low  = tLsw;
		                }
	
		                // Rho pi at x = y = 0
		                var T0 = T[0];
		                var state0 = state[0];
		                T0.high = state0.high;
		                T0.low  = state0.low;
	
		                // Chi
		                for (var x = 0; x < 5; x++) {
		                    for (var y = 0; y < 5; y++) {
		                        // Shortcuts
		                        var laneIndex = x + 5 * y;
		                        var lane = state[laneIndex];
		                        var TLane = T[laneIndex];
		                        var Tx1Lane = T[((x + 1) % 5) + 5 * y];
		                        var Tx2Lane = T[((x + 2) % 5) + 5 * y];
	
		                        // Mix rows
		                        lane.high = TLane.high ^ (~Tx1Lane.high & Tx2Lane.high);
		                        lane.low  = TLane.low  ^ (~Tx1Lane.low  & Tx2Lane.low);
		                    }
		                }
	
		                // Iota
		                var lane = state[0];
		                var roundConstant = ROUND_CONSTANTS[round];
		                lane.high ^= roundConstant.high;
		                lane.low  ^= roundConstant.low;;
		            }
		        },
	
		        _doFinalize: function () {
		            // Shortcuts
		            var data = this._data;
		            var dataWords = data.words;
		            var nBitsTotal = this._nDataBytes * 8;
		            var nBitsLeft = data.sigBytes * 8;
		            var blockSizeBits = this.blockSize * 32;
	
		            // Add padding
		            dataWords[nBitsLeft >>> 5] |= 0x1 << (24 - nBitsLeft % 32);
		            dataWords[((Math.ceil((nBitsLeft + 1) / blockSizeBits) * blockSizeBits) >>> 5) - 1] |= 0x80;
		            data.sigBytes = dataWords.length * 4;
	
		            // Hash final blocks
		            this._process();
	
		            // Shortcuts
		            var state = this._state;
		            var outputLengthBytes = this.cfg.outputLength / 8;
		            var outputLengthLanes = outputLengthBytes / 8;
	
		            // Squeeze
		            var hashWords = [];
		            for (var i = 0; i < outputLengthLanes; i++) {
		                // Shortcuts
		                var lane = state[i];
		                var laneMsw = lane.high;
		                var laneLsw = lane.low;
	
		                // Swap endian
		                laneMsw = (
		                    (((laneMsw << 8)  | (laneMsw >>> 24)) & 0x00ff00ff) |
		                    (((laneMsw << 24) | (laneMsw >>> 8))  & 0xff00ff00)
		                );
		                laneLsw = (
		                    (((laneLsw << 8)  | (laneLsw >>> 24)) & 0x00ff00ff) |
		                    (((laneLsw << 24) | (laneLsw >>> 8))  & 0xff00ff00)
		                );
	
		                // Squeeze state to retrieve hash
		                hashWords.push(laneLsw);
		                hashWords.push(laneMsw);
		            }
	
		            // Return final computed hash
		            return new WordArray.init(hashWords, outputLengthBytes);
		        },
	
		        clone: function () {
		            var clone = Hasher.clone.call(this);
	
		            var state = clone._state = this._state.slice(0);
		            for (var i = 0; i < 25; i++) {
		                state[i] = state[i].clone();
		            }
	
		            return clone;
		        }
		    });
	
		    /**
		     * Shortcut function to the hasher's object interface.
		     *
		     * @param {WordArray|string} message The message to hash.
		     *
		     * @return {WordArray} The hash.
		     *
		     * @static
		     *
		     * @example
		     *
		     *     var hash = CryptoJS.SHA3('message');
		     *     var hash = CryptoJS.SHA3(wordArray);
		     */
		    C.SHA3 = Hasher._createHelper(SHA3);
	
		    /**
		     * Shortcut function to the HMAC's object interface.
		     *
		     * @param {WordArray|string} message The message to hash.
		     * @param {WordArray|string} key The secret key.
		     *
		     * @return {WordArray} The HMAC.
		     *
		     * @static
		     *
		     * @example
		     *
		     *     var hmac = CryptoJS.HmacSHA3(message, key);
		     */
		    C.HmacSHA3 = Hasher._createHmacHelper(SHA3);
		}(Math));
	
	
		return CryptoJS.SHA3;
	
	}));

/***/ },
/* 812 */
/***/ function(module, exports, __webpack_require__) {

	;(function (root, factory, undef) {
		if (true) {
			// CommonJS
			module.exports = exports = factory(__webpack_require__(25), __webpack_require__(169), __webpack_require__(327));
		}
		else if (typeof define === "function" && define.amd) {
			// AMD
			define(["./core", "./x64-core", "./sha512"], factory);
		}
		else {
			// Global (browser)
			factory(root.CryptoJS);
		}
	}(this, function (CryptoJS) {
	
		(function () {
		    // Shortcuts
		    var C = CryptoJS;
		    var C_x64 = C.x64;
		    var X64Word = C_x64.Word;
		    var X64WordArray = C_x64.WordArray;
		    var C_algo = C.algo;
		    var SHA512 = C_algo.SHA512;
	
		    /**
		     * SHA-384 hash algorithm.
		     */
		    var SHA384 = C_algo.SHA384 = SHA512.extend({
		        _doReset: function () {
		            this._hash = new X64WordArray.init([
		                new X64Word.init(0xcbbb9d5d, 0xc1059ed8), new X64Word.init(0x629a292a, 0x367cd507),
		                new X64Word.init(0x9159015a, 0x3070dd17), new X64Word.init(0x152fecd8, 0xf70e5939),
		                new X64Word.init(0x67332667, 0xffc00b31), new X64Word.init(0x8eb44a87, 0x68581511),
		                new X64Word.init(0xdb0c2e0d, 0x64f98fa7), new X64Word.init(0x47b5481d, 0xbefa4fa4)
		            ]);
		        },
	
		        _doFinalize: function () {
		            var hash = SHA512._doFinalize.call(this);
	
		            hash.sigBytes -= 16;
	
		            return hash;
		        }
		    });
	
		    /**
		     * Shortcut function to the hasher's object interface.
		     *
		     * @param {WordArray|string} message The message to hash.
		     *
		     * @return {WordArray} The hash.
		     *
		     * @static
		     *
		     * @example
		     *
		     *     var hash = CryptoJS.SHA384('message');
		     *     var hash = CryptoJS.SHA384(wordArray);
		     */
		    C.SHA384 = SHA512._createHelper(SHA384);
	
		    /**
		     * Shortcut function to the HMAC's object interface.
		     *
		     * @param {WordArray|string} message The message to hash.
		     * @param {WordArray|string} key The secret key.
		     *
		     * @return {WordArray} The HMAC.
		     *
		     * @static
		     *
		     * @example
		     *
		     *     var hmac = CryptoJS.HmacSHA384(message, key);
		     */
		    C.HmacSHA384 = SHA512._createHmacHelper(SHA384);
		}());
	
	
		return CryptoJS.SHA384;
	
	}));

/***/ },
/* 813 */
/***/ function(module, exports, __webpack_require__) {

	;(function (root, factory, undef) {
		if (true) {
			// CommonJS
			module.exports = exports = factory(__webpack_require__(25), __webpack_require__(120), __webpack_require__(121), __webpack_require__(112), __webpack_require__(44));
		}
		else if (typeof define === "function" && define.amd) {
			// AMD
			define(["./core", "./enc-base64", "./md5", "./evpkdf", "./cipher-core"], factory);
		}
		else {
			// Global (browser)
			factory(root.CryptoJS);
		}
	}(this, function (CryptoJS) {
	
		(function () {
		    // Shortcuts
		    var C = CryptoJS;
		    var C_lib = C.lib;
		    var WordArray = C_lib.WordArray;
		    var BlockCipher = C_lib.BlockCipher;
		    var C_algo = C.algo;
	
		    // Permuted Choice 1 constants
		    var PC1 = [
		        57, 49, 41, 33, 25, 17, 9,  1,
		        58, 50, 42, 34, 26, 18, 10, 2,
		        59, 51, 43, 35, 27, 19, 11, 3,
		        60, 52, 44, 36, 63, 55, 47, 39,
		        31, 23, 15, 7,  62, 54, 46, 38,
		        30, 22, 14, 6,  61, 53, 45, 37,
		        29, 21, 13, 5,  28, 20, 12, 4
		    ];
	
		    // Permuted Choice 2 constants
		    var PC2 = [
		        14, 17, 11, 24, 1,  5,
		        3,  28, 15, 6,  21, 10,
		        23, 19, 12, 4,  26, 8,
		        16, 7,  27, 20, 13, 2,
		        41, 52, 31, 37, 47, 55,
		        30, 40, 51, 45, 33, 48,
		        44, 49, 39, 56, 34, 53,
		        46, 42, 50, 36, 29, 32
		    ];
	
		    // Cumulative bit shift constants
		    var BIT_SHIFTS = [1,  2,  4,  6,  8,  10, 12, 14, 15, 17, 19, 21, 23, 25, 27, 28];
	
		    // SBOXes and round permutation constants
		    var SBOX_P = [
		        {
		            0x0: 0x808200,
		            0x10000000: 0x8000,
		            0x20000000: 0x808002,
		            0x30000000: 0x2,
		            0x40000000: 0x200,
		            0x50000000: 0x808202,
		            0x60000000: 0x800202,
		            0x70000000: 0x800000,
		            0x80000000: 0x202,
		            0x90000000: 0x800200,
		            0xa0000000: 0x8200,
		            0xb0000000: 0x808000,
		            0xc0000000: 0x8002,
		            0xd0000000: 0x800002,
		            0xe0000000: 0x0,
		            0xf0000000: 0x8202,
		            0x8000000: 0x0,
		            0x18000000: 0x808202,
		            0x28000000: 0x8202,
		            0x38000000: 0x8000,
		            0x48000000: 0x808200,
		            0x58000000: 0x200,
		            0x68000000: 0x808002,
		            0x78000000: 0x2,
		            0x88000000: 0x800200,
		            0x98000000: 0x8200,
		            0xa8000000: 0x808000,
		            0xb8000000: 0x800202,
		            0xc8000000: 0x800002,
		            0xd8000000: 0x8002,
		            0xe8000000: 0x202,
		            0xf8000000: 0x800000,
		            0x1: 0x8000,
		            0x10000001: 0x2,
		            0x20000001: 0x808200,
		            0x30000001: 0x800000,
		            0x40000001: 0x808002,
		            0x50000001: 0x8200,
		            0x60000001: 0x200,
		            0x70000001: 0x800202,
		            0x80000001: 0x808202,
		            0x90000001: 0x808000,
		            0xa0000001: 0x800002,
		            0xb0000001: 0x8202,
		            0xc0000001: 0x202,
		            0xd0000001: 0x800200,
		            0xe0000001: 0x8002,
		            0xf0000001: 0x0,
		            0x8000001: 0x808202,
		            0x18000001: 0x808000,
		            0x28000001: 0x800000,
		            0x38000001: 0x200,
		            0x48000001: 0x8000,
		            0x58000001: 0x800002,
		            0x68000001: 0x2,
		            0x78000001: 0x8202,
		            0x88000001: 0x8002,
		            0x98000001: 0x800202,
		            0xa8000001: 0x202,
		            0xb8000001: 0x808200,
		            0xc8000001: 0x800200,
		            0xd8000001: 0x0,
		            0xe8000001: 0x8200,
		            0xf8000001: 0x808002
		        },
		        {
		            0x0: 0x40084010,
		            0x1000000: 0x4000,
		            0x2000000: 0x80000,
		            0x3000000: 0x40080010,
		            0x4000000: 0x40000010,
		            0x5000000: 0x40084000,
		            0x6000000: 0x40004000,
		            0x7000000: 0x10,
		            0x8000000: 0x84000,
		            0x9000000: 0x40004010,
		            0xa000000: 0x40000000,
		            0xb000000: 0x84010,
		            0xc000000: 0x80010,
		            0xd000000: 0x0,
		            0xe000000: 0x4010,
		            0xf000000: 0x40080000,
		            0x800000: 0x40004000,
		            0x1800000: 0x84010,
		            0x2800000: 0x10,
		            0x3800000: 0x40004010,
		            0x4800000: 0x40084010,
		            0x5800000: 0x40000000,
		            0x6800000: 0x80000,
		            0x7800000: 0x40080010,
		            0x8800000: 0x80010,
		            0x9800000: 0x0,
		            0xa800000: 0x4000,
		            0xb800000: 0x40080000,
		            0xc800000: 0x40000010,
		            0xd800000: 0x84000,
		            0xe800000: 0x40084000,
		            0xf800000: 0x4010,
		            0x10000000: 0x0,
		            0x11000000: 0x40080010,
		            0x12000000: 0x40004010,
		            0x13000000: 0x40084000,
		            0x14000000: 0x40080000,
		            0x15000000: 0x10,
		            0x16000000: 0x84010,
		            0x17000000: 0x4000,
		            0x18000000: 0x4010,
		            0x19000000: 0x80000,
		            0x1a000000: 0x80010,
		            0x1b000000: 0x40000010,
		            0x1c000000: 0x84000,
		            0x1d000000: 0x40004000,
		            0x1e000000: 0x40000000,
		            0x1f000000: 0x40084010,
		            0x10800000: 0x84010,
		            0x11800000: 0x80000,
		            0x12800000: 0x40080000,
		            0x13800000: 0x4000,
		            0x14800000: 0x40004000,
		            0x15800000: 0x40084010,
		            0x16800000: 0x10,
		            0x17800000: 0x40000000,
		            0x18800000: 0x40084000,
		            0x19800000: 0x40000010,
		            0x1a800000: 0x40004010,
		            0x1b800000: 0x80010,
		            0x1c800000: 0x0,
		            0x1d800000: 0x4010,
		            0x1e800000: 0x40080010,
		            0x1f800000: 0x84000
		        },
		        {
		            0x0: 0x104,
		            0x100000: 0x0,
		            0x200000: 0x4000100,
		            0x300000: 0x10104,
		            0x400000: 0x10004,
		            0x500000: 0x4000004,
		            0x600000: 0x4010104,
		            0x700000: 0x4010000,
		            0x800000: 0x4000000,
		            0x900000: 0x4010100,
		            0xa00000: 0x10100,
		            0xb00000: 0x4010004,
		            0xc00000: 0x4000104,
		            0xd00000: 0x10000,
		            0xe00000: 0x4,
		            0xf00000: 0x100,
		            0x80000: 0x4010100,
		            0x180000: 0x4010004,
		            0x280000: 0x0,
		            0x380000: 0x4000100,
		            0x480000: 0x4000004,
		            0x580000: 0x10000,
		            0x680000: 0x10004,
		            0x780000: 0x104,
		            0x880000: 0x4,
		            0x980000: 0x100,
		            0xa80000: 0x4010000,
		            0xb80000: 0x10104,
		            0xc80000: 0x10100,
		            0xd80000: 0x4000104,
		            0xe80000: 0x4010104,
		            0xf80000: 0x4000000,
		            0x1000000: 0x4010100,
		            0x1100000: 0x10004,
		            0x1200000: 0x10000,
		            0x1300000: 0x4000100,
		            0x1400000: 0x100,
		            0x1500000: 0x4010104,
		            0x1600000: 0x4000004,
		            0x1700000: 0x0,
		            0x1800000: 0x4000104,
		            0x1900000: 0x4000000,
		            0x1a00000: 0x4,
		            0x1b00000: 0x10100,
		            0x1c00000: 0x4010000,
		            0x1d00000: 0x104,
		            0x1e00000: 0x10104,
		            0x1f00000: 0x4010004,
		            0x1080000: 0x4000000,
		            0x1180000: 0x104,
		            0x1280000: 0x4010100,
		            0x1380000: 0x0,
		            0x1480000: 0x10004,
		            0x1580000: 0x4000100,
		            0x1680000: 0x100,
		            0x1780000: 0x4010004,
		            0x1880000: 0x10000,
		            0x1980000: 0x4010104,
		            0x1a80000: 0x10104,
		            0x1b80000: 0x4000004,
		            0x1c80000: 0x4000104,
		            0x1d80000: 0x4010000,
		            0x1e80000: 0x4,
		            0x1f80000: 0x10100
		        },
		        {
		            0x0: 0x80401000,
		            0x10000: 0x80001040,
		            0x20000: 0x401040,
		            0x30000: 0x80400000,
		            0x40000: 0x0,
		            0x50000: 0x401000,
		            0x60000: 0x80000040,
		            0x70000: 0x400040,
		            0x80000: 0x80000000,
		            0x90000: 0x400000,
		            0xa0000: 0x40,
		            0xb0000: 0x80001000,
		            0xc0000: 0x80400040,
		            0xd0000: 0x1040,
		            0xe0000: 0x1000,
		            0xf0000: 0x80401040,
		            0x8000: 0x80001040,
		            0x18000: 0x40,
		            0x28000: 0x80400040,
		            0x38000: 0x80001000,
		            0x48000: 0x401000,
		            0x58000: 0x80401040,
		            0x68000: 0x0,
		            0x78000: 0x80400000,
		            0x88000: 0x1000,
		            0x98000: 0x80401000,
		            0xa8000: 0x400000,
		            0xb8000: 0x1040,
		            0xc8000: 0x80000000,
		            0xd8000: 0x400040,
		            0xe8000: 0x401040,
		            0xf8000: 0x80000040,
		            0x100000: 0x400040,
		            0x110000: 0x401000,
		            0x120000: 0x80000040,
		            0x130000: 0x0,
		            0x140000: 0x1040,
		            0x150000: 0x80400040,
		            0x160000: 0x80401000,
		            0x170000: 0x80001040,
		            0x180000: 0x80401040,
		            0x190000: 0x80000000,
		            0x1a0000: 0x80400000,
		            0x1b0000: 0x401040,
		            0x1c0000: 0x80001000,
		            0x1d0000: 0x400000,
		            0x1e0000: 0x40,
		            0x1f0000: 0x1000,
		            0x108000: 0x80400000,
		            0x118000: 0x80401040,
		            0x128000: 0x0,
		            0x138000: 0x401000,
		            0x148000: 0x400040,
		            0x158000: 0x80000000,
		            0x168000: 0x80001040,
		            0x178000: 0x40,
		            0x188000: 0x80000040,
		            0x198000: 0x1000,
		            0x1a8000: 0x80001000,
		            0x1b8000: 0x80400040,
		            0x1c8000: 0x1040,
		            0x1d8000: 0x80401000,
		            0x1e8000: 0x400000,
		            0x1f8000: 0x401040
		        },
		        {
		            0x0: 0x80,
		            0x1000: 0x1040000,
		            0x2000: 0x40000,
		            0x3000: 0x20000000,
		            0x4000: 0x20040080,
		            0x5000: 0x1000080,
		            0x6000: 0x21000080,
		            0x7000: 0x40080,
		            0x8000: 0x1000000,
		            0x9000: 0x20040000,
		            0xa000: 0x20000080,
		            0xb000: 0x21040080,
		            0xc000: 0x21040000,
		            0xd000: 0x0,
		            0xe000: 0x1040080,
		            0xf000: 0x21000000,
		            0x800: 0x1040080,
		            0x1800: 0x21000080,
		            0x2800: 0x80,
		            0x3800: 0x1040000,
		            0x4800: 0x40000,
		            0x5800: 0x20040080,
		            0x6800: 0x21040000,
		            0x7800: 0x20000000,
		            0x8800: 0x20040000,
		            0x9800: 0x0,
		            0xa800: 0x21040080,
		            0xb800: 0x1000080,
		            0xc800: 0x20000080,
		            0xd800: 0x21000000,
		            0xe800: 0x1000000,
		            0xf800: 0x40080,
		            0x10000: 0x40000,
		            0x11000: 0x80,
		            0x12000: 0x20000000,
		            0x13000: 0x21000080,
		            0x14000: 0x1000080,
		            0x15000: 0x21040000,
		            0x16000: 0x20040080,
		            0x17000: 0x1000000,
		            0x18000: 0x21040080,
		            0x19000: 0x21000000,
		            0x1a000: 0x1040000,
		            0x1b000: 0x20040000,
		            0x1c000: 0x40080,
		            0x1d000: 0x20000080,
		            0x1e000: 0x0,
		            0x1f000: 0x1040080,
		            0x10800: 0x21000080,
		            0x11800: 0x1000000,
		            0x12800: 0x1040000,
		            0x13800: 0x20040080,
		            0x14800: 0x20000000,
		            0x15800: 0x1040080,
		            0x16800: 0x80,
		            0x17800: 0x21040000,
		            0x18800: 0x40080,
		            0x19800: 0x21040080,
		            0x1a800: 0x0,
		            0x1b800: 0x21000000,
		            0x1c800: 0x1000080,
		            0x1d800: 0x40000,
		            0x1e800: 0x20040000,
		            0x1f800: 0x20000080
		        },
		        {
		            0x0: 0x10000008,
		            0x100: 0x2000,
		            0x200: 0x10200000,
		            0x300: 0x10202008,
		            0x400: 0x10002000,
		            0x500: 0x200000,
		            0x600: 0x200008,
		            0x700: 0x10000000,
		            0x800: 0x0,
		            0x900: 0x10002008,
		            0xa00: 0x202000,
		            0xb00: 0x8,
		            0xc00: 0x10200008,
		            0xd00: 0x202008,
		            0xe00: 0x2008,
		            0xf00: 0x10202000,
		            0x80: 0x10200000,
		            0x180: 0x10202008,
		            0x280: 0x8,
		            0x380: 0x200000,
		            0x480: 0x202008,
		            0x580: 0x10000008,
		            0x680: 0x10002000,
		            0x780: 0x2008,
		            0x880: 0x200008,
		            0x980: 0x2000,
		            0xa80: 0x10002008,
		            0xb80: 0x10200008,
		            0xc80: 0x0,
		            0xd80: 0x10202000,
		            0xe80: 0x202000,
		            0xf80: 0x10000000,
		            0x1000: 0x10002000,
		            0x1100: 0x10200008,
		            0x1200: 0x10202008,
		            0x1300: 0x2008,
		            0x1400: 0x200000,
		            0x1500: 0x10000000,
		            0x1600: 0x10000008,
		            0x1700: 0x202000,
		            0x1800: 0x202008,
		            0x1900: 0x0,
		            0x1a00: 0x8,
		            0x1b00: 0x10200000,
		            0x1c00: 0x2000,
		            0x1d00: 0x10002008,
		            0x1e00: 0x10202000,
		            0x1f00: 0x200008,
		            0x1080: 0x8,
		            0x1180: 0x202000,
		            0x1280: 0x200000,
		            0x1380: 0x10000008,
		            0x1480: 0x10002000,
		            0x1580: 0x2008,
		            0x1680: 0x10202008,
		            0x1780: 0x10200000,
		            0x1880: 0x10202000,
		            0x1980: 0x10200008,
		            0x1a80: 0x2000,
		            0x1b80: 0x202008,
		            0x1c80: 0x200008,
		            0x1d80: 0x0,
		            0x1e80: 0x10000000,
		            0x1f80: 0x10002008
		        },
		        {
		            0x0: 0x100000,
		            0x10: 0x2000401,
		            0x20: 0x400,
		            0x30: 0x100401,
		            0x40: 0x2100401,
		            0x50: 0x0,
		            0x60: 0x1,
		            0x70: 0x2100001,
		            0x80: 0x2000400,
		            0x90: 0x100001,
		            0xa0: 0x2000001,
		            0xb0: 0x2100400,
		            0xc0: 0x2100000,
		            0xd0: 0x401,
		            0xe0: 0x100400,
		            0xf0: 0x2000000,
		            0x8: 0x2100001,
		            0x18: 0x0,
		            0x28: 0x2000401,
		            0x38: 0x2100400,
		            0x48: 0x100000,
		            0x58: 0x2000001,
		            0x68: 0x2000000,
		            0x78: 0x401,
		            0x88: 0x100401,
		            0x98: 0x2000400,
		            0xa8: 0x2100000,
		            0xb8: 0x100001,
		            0xc8: 0x400,
		            0xd8: 0x2100401,
		            0xe8: 0x1,
		            0xf8: 0x100400,
		            0x100: 0x2000000,
		            0x110: 0x100000,
		            0x120: 0x2000401,
		            0x130: 0x2100001,
		            0x140: 0x100001,
		            0x150: 0x2000400,
		            0x160: 0x2100400,
		            0x170: 0x100401,
		            0x180: 0x401,
		            0x190: 0x2100401,
		            0x1a0: 0x100400,
		            0x1b0: 0x1,
		            0x1c0: 0x0,
		            0x1d0: 0x2100000,
		            0x1e0: 0x2000001,
		            0x1f0: 0x400,
		            0x108: 0x100400,
		            0x118: 0x2000401,
		            0x128: 0x2100001,
		            0x138: 0x1,
		            0x148: 0x2000000,
		            0x158: 0x100000,
		            0x168: 0x401,
		            0x178: 0x2100400,
		            0x188: 0x2000001,
		            0x198: 0x2100000,
		            0x1a8: 0x0,
		            0x1b8: 0x2100401,
		            0x1c8: 0x100401,
		            0x1d8: 0x400,
		            0x1e8: 0x2000400,
		            0x1f8: 0x100001
		        },
		        {
		            0x0: 0x8000820,
		            0x1: 0x20000,
		            0x2: 0x8000000,
		            0x3: 0x20,
		            0x4: 0x20020,
		            0x5: 0x8020820,
		            0x6: 0x8020800,
		            0x7: 0x800,
		            0x8: 0x8020000,
		            0x9: 0x8000800,
		            0xa: 0x20800,
		            0xb: 0x8020020,
		            0xc: 0x820,
		            0xd: 0x0,
		            0xe: 0x8000020,
		            0xf: 0x20820,
		            0x80000000: 0x800,
		            0x80000001: 0x8020820,
		            0x80000002: 0x8000820,
		            0x80000003: 0x8000000,
		            0x80000004: 0x8020000,
		            0x80000005: 0x20800,
		            0x80000006: 0x20820,
		            0x80000007: 0x20,
		            0x80000008: 0x8000020,
		            0x80000009: 0x820,
		            0x8000000a: 0x20020,
		            0x8000000b: 0x8020800,
		            0x8000000c: 0x0,
		            0x8000000d: 0x8020020,
		            0x8000000e: 0x8000800,
		            0x8000000f: 0x20000,
		            0x10: 0x20820,
		            0x11: 0x8020800,
		            0x12: 0x20,
		            0x13: 0x800,
		            0x14: 0x8000800,
		            0x15: 0x8000020,
		            0x16: 0x8020020,
		            0x17: 0x20000,
		            0x18: 0x0,
		            0x19: 0x20020,
		            0x1a: 0x8020000,
		            0x1b: 0x8000820,
		            0x1c: 0x8020820,
		            0x1d: 0x20800,
		            0x1e: 0x820,
		            0x1f: 0x8000000,
		            0x80000010: 0x20000,
		            0x80000011: 0x800,
		            0x80000012: 0x8020020,
		            0x80000013: 0x20820,
		            0x80000014: 0x20,
		            0x80000015: 0x8020000,
		            0x80000016: 0x8000000,
		            0x80000017: 0x8000820,
		            0x80000018: 0x8020820,
		            0x80000019: 0x8000020,
		            0x8000001a: 0x8000800,
		            0x8000001b: 0x0,
		            0x8000001c: 0x20800,
		            0x8000001d: 0x820,
		            0x8000001e: 0x20020,
		            0x8000001f: 0x8020800
		        }
		    ];
	
		    // Masks that select the SBOX input
		    var SBOX_MASK = [
		        0xf8000001, 0x1f800000, 0x01f80000, 0x001f8000,
		        0x0001f800, 0x00001f80, 0x000001f8, 0x8000001f
		    ];
	
		    /**
		     * DES block cipher algorithm.
		     */
		    var DES = C_algo.DES = BlockCipher.extend({
		        _doReset: function () {
		            // Shortcuts
		            var key = this._key;
		            var keyWords = key.words;
	
		            // Select 56 bits according to PC1
		            var keyBits = [];
		            for (var i = 0; i < 56; i++) {
		                var keyBitPos = PC1[i] - 1;
		                keyBits[i] = (keyWords[keyBitPos >>> 5] >>> (31 - keyBitPos % 32)) & 1;
		            }
	
		            // Assemble 16 subkeys
		            var subKeys = this._subKeys = [];
		            for (var nSubKey = 0; nSubKey < 16; nSubKey++) {
		                // Create subkey
		                var subKey = subKeys[nSubKey] = [];
	
		                // Shortcut
		                var bitShift = BIT_SHIFTS[nSubKey];
	
		                // Select 48 bits according to PC2
		                for (var i = 0; i < 24; i++) {
		                    // Select from the left 28 key bits
		                    subKey[(i / 6) | 0] |= keyBits[((PC2[i] - 1) + bitShift) % 28] << (31 - i % 6);
	
		                    // Select from the right 28 key bits
		                    subKey[4 + ((i / 6) | 0)] |= keyBits[28 + (((PC2[i + 24] - 1) + bitShift) % 28)] << (31 - i % 6);
		                }
	
		                // Since each subkey is applied to an expanded 32-bit input,
		                // the subkey can be broken into 8 values scaled to 32-bits,
		                // which allows the key to be used without expansion
		                subKey[0] = (subKey[0] << 1) | (subKey[0] >>> 31);
		                for (var i = 1; i < 7; i++) {
		                    subKey[i] = subKey[i] >>> ((i - 1) * 4 + 3);
		                }
		                subKey[7] = (subKey[7] << 5) | (subKey[7] >>> 27);
		            }
	
		            // Compute inverse subkeys
		            var invSubKeys = this._invSubKeys = [];
		            for (var i = 0; i < 16; i++) {
		                invSubKeys[i] = subKeys[15 - i];
		            }
		        },
	
		        encryptBlock: function (M, offset) {
		            this._doCryptBlock(M, offset, this._subKeys);
		        },
	
		        decryptBlock: function (M, offset) {
		            this._doCryptBlock(M, offset, this._invSubKeys);
		        },
	
		        _doCryptBlock: function (M, offset, subKeys) {
		            // Get input
		            this._lBlock = M[offset];
		            this._rBlock = M[offset + 1];
	
		            // Initial permutation
		            exchangeLR.call(this, 4,  0x0f0f0f0f);
		            exchangeLR.call(this, 16, 0x0000ffff);
		            exchangeRL.call(this, 2,  0x33333333);
		            exchangeRL.call(this, 8,  0x00ff00ff);
		            exchangeLR.call(this, 1,  0x55555555);
	
		            // Rounds
		            for (var round = 0; round < 16; round++) {
		                // Shortcuts
		                var subKey = subKeys[round];
		                var lBlock = this._lBlock;
		                var rBlock = this._rBlock;
	
		                // Feistel function
		                var f = 0;
		                for (var i = 0; i < 8; i++) {
		                    f |= SBOX_P[i][((rBlock ^ subKey[i]) & SBOX_MASK[i]) >>> 0];
		                }
		                this._lBlock = rBlock;
		                this._rBlock = lBlock ^ f;
		            }
	
		            // Undo swap from last round
		            var t = this._lBlock;
		            this._lBlock = this._rBlock;
		            this._rBlock = t;
	
		            // Final permutation
		            exchangeLR.call(this, 1,  0x55555555);
		            exchangeRL.call(this, 8,  0x00ff00ff);
		            exchangeRL.call(this, 2,  0x33333333);
		            exchangeLR.call(this, 16, 0x0000ffff);
		            exchangeLR.call(this, 4,  0x0f0f0f0f);
	
		            // Set output
		            M[offset] = this._lBlock;
		            M[offset + 1] = this._rBlock;
		        },
	
		        keySize: 64/32,
	
		        ivSize: 64/32,
	
		        blockSize: 64/32
		    });
	
		    // Swap bits across the left and right words
		    function exchangeLR(offset, mask) {
		        var t = ((this._lBlock >>> offset) ^ this._rBlock) & mask;
		        this._rBlock ^= t;
		        this._lBlock ^= t << offset;
		    }
	
		    function exchangeRL(offset, mask) {
		        var t = ((this._rBlock >>> offset) ^ this._lBlock) & mask;
		        this._lBlock ^= t;
		        this._rBlock ^= t << offset;
		    }
	
		    /**
		     * Shortcut functions to the cipher's object interface.
		     *
		     * @example
		     *
		     *     var ciphertext = CryptoJS.DES.encrypt(message, key, cfg);
		     *     var plaintext  = CryptoJS.DES.decrypt(ciphertext, key, cfg);
		     */
		    C.DES = BlockCipher._createHelper(DES);
	
		    /**
		     * Triple-DES block cipher algorithm.
		     */
		    var TripleDES = C_algo.TripleDES = BlockCipher.extend({
		        _doReset: function () {
		            // Shortcuts
		            var key = this._key;
		            var keyWords = key.words;
	
		            // Create DES instances
		            this._des1 = DES.createEncryptor(WordArray.create(keyWords.slice(0, 2)));
		            this._des2 = DES.createEncryptor(WordArray.create(keyWords.slice(2, 4)));
		            this._des3 = DES.createEncryptor(WordArray.create(keyWords.slice(4, 6)));
		        },
	
		        encryptBlock: function (M, offset) {
		            this._des1.encryptBlock(M, offset);
		            this._des2.decryptBlock(M, offset);
		            this._des3.encryptBlock(M, offset);
		        },
	
		        decryptBlock: function (M, offset) {
		            this._des3.decryptBlock(M, offset);
		            this._des2.encryptBlock(M, offset);
		            this._des1.decryptBlock(M, offset);
		        },
	
		        keySize: 192/32,
	
		        ivSize: 64/32,
	
		        blockSize: 64/32
		    });
	
		    /**
		     * Shortcut functions to the cipher's object interface.
		     *
		     * @example
		     *
		     *     var ciphertext = CryptoJS.TripleDES.encrypt(message, key, cfg);
		     *     var plaintext  = CryptoJS.TripleDES.decrypt(ciphertext, key, cfg);
		     */
		    C.TripleDES = BlockCipher._createHelper(TripleDES);
		}());
	
	
		return CryptoJS.TripleDES;
	
	}));

/***/ },
/* 814 */
/***/ function(module, exports, __webpack_require__) {

	var escape = __webpack_require__(328);
	exports = module.exports = __webpack_require__(122)(false);
	// imports
	
	
	// module
	exports.push([module.id, "/*!\n * Bootstrap v3.3.7 (http://getbootstrap.com)\n * Copyright 2011-2016 Twitter, Inc.\n * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)\n *//*! normalize.css v3.0.3 | MIT License | github.com/necolas/normalize.css */html{font-family:sans-serif;-webkit-text-size-adjust:100%;-ms-text-size-adjust:100%}body{margin:0}article,aside,details,figcaption,figure,footer,header,hgroup,main,menu,nav,section,summary{display:block}audio,canvas,progress,video{display:inline-block;vertical-align:baseline}audio:not([controls]){display:none;height:0}[hidden],template{display:none}a{background-color:transparent}a:active,a:hover{outline:0}abbr[title]{border-bottom:1px dotted}b,strong{font-weight:700}dfn{font-style:italic}h1{margin:.67em 0;font-size:2em}mark{color:#000;background:#ff0}small{font-size:80%}sub,sup{position:relative;font-size:75%;line-height:0;vertical-align:baseline}sup{top:-.5em}sub{bottom:-.25em}img{border:0}svg:not(:root){overflow:hidden}figure{margin:1em 40px}hr{height:0;-webkit-box-sizing:content-box;-moz-box-sizing:content-box;box-sizing:content-box}pre{overflow:auto}code,kbd,pre,samp{font-family:monospace,monospace;font-size:1em}button,input,optgroup,select,textarea{margin:0;font:inherit;color:inherit}button{overflow:visible}button,select{text-transform:none}button,html input[type=button],input[type=reset],input[type=submit]{-webkit-appearance:button;cursor:pointer}button[disabled],html input[disabled]{cursor:default}button::-moz-focus-inner,input::-moz-focus-inner{padding:0;border:0}input{line-height:normal}input[type=checkbox],input[type=radio]{-webkit-box-sizing:border-box;-moz-box-sizing:border-box;box-sizing:border-box;padding:0}input[type=number]::-webkit-inner-spin-button,input[type=number]::-webkit-outer-spin-button{height:auto}input[type=search]{-webkit-box-sizing:content-box;-moz-box-sizing:content-box;box-sizing:content-box;-webkit-appearance:textfield}input[type=search]::-webkit-search-cancel-button,input[type=search]::-webkit-search-decoration{-webkit-appearance:none}fieldset{padding:.35em .625em .75em;margin:0 2px;border:1px solid silver}textarea{overflow:auto}optgroup{font-weight:700}table{border-spacing:0;border-collapse:collapse}td,th{padding:0}/*! Source: https://github.com/h5bp/html5-boilerplate/blob/master/src/css/main.css */@media print{*,:after,:before{color:#000!important;text-shadow:none!important;background:0 0!important;-webkit-box-shadow:none!important;box-shadow:none!important}a,a:visited{text-decoration:underline}a[href]:after{content:\" (\" attr(href) \")\"}abbr[title]:after{content:\" (\" attr(title) \")\"}a[href^=\"#\"]:after,a[href^=\"javascript:\"]:after{content:\"\"}blockquote,pre{border:1px solid #999;page-break-inside:avoid}thead{display:table-header-group}img,tr{page-break-inside:avoid}img{max-width:100%!important}h2,h3,p{orphans:3;widows:3}h2,h3{page-break-after:avoid}.navbar{display:none}.btn>.caret,.dropup>.btn>.caret{border-top-color:#000!important}.label{border:1px solid #000}.table{border-collapse:collapse!important}.table td,.table th{background-color:#fff!important}.table-bordered td,.table-bordered th{border:1px solid #ddd!important}}@font-face{font-family:Glyphicons Halflings;src:url(" + escape(__webpack_require__(332)) + ");src:url(" + escape(__webpack_require__(332)) + "?#iefix) format(\"embedded-opentype\"),url(" + escape(__webpack_require__(1107)) + ") format(\"woff2\"),url(" + escape(__webpack_require__(1106)) + ") format(\"woff\"),url(" + escape(__webpack_require__(1097)) + ") format(\"truetype\"),url(" + escape(__webpack_require__(1101)) + "#glyphicons_halflingsregular) format(\"svg\")}.glyphicon{position:relative;top:1px;display:inline-block;font-family:Glyphicons Halflings;font-style:normal;font-weight:400;line-height:1;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale}.glyphicon-asterisk:before{content:\"*\"}.glyphicon-plus:before{content:\"+\"}.glyphicon-eur:before,.glyphicon-euro:before{content:\"\\20AC\"}.glyphicon-minus:before{content:\"\\2212\"}.glyphicon-cloud:before{content:\"\\2601\"}.glyphicon-envelope:before{content:\"\\2709\"}.glyphicon-pencil:before{content:\"\\270F\"}.glyphicon-glass:before{content:\"\\E001\"}.glyphicon-music:before{content:\"\\E002\"}.glyphicon-search:before{content:\"\\E003\"}.glyphicon-heart:before{content:\"\\E005\"}.glyphicon-star:before{content:\"\\E006\"}.glyphicon-star-empty:before{content:\"\\E007\"}.glyphicon-user:before{content:\"\\E008\"}.glyphicon-film:before{content:\"\\E009\"}.glyphicon-th-large:before{content:\"\\E010\"}.glyphicon-th:before{content:\"\\E011\"}.glyphicon-th-list:before{content:\"\\E012\"}.glyphicon-ok:before{content:\"\\E013\"}.glyphicon-remove:before{content:\"\\E014\"}.glyphicon-zoom-in:before{content:\"\\E015\"}.glyphicon-zoom-out:before{content:\"\\E016\"}.glyphicon-off:before{content:\"\\E017\"}.glyphicon-signal:before{content:\"\\E018\"}.glyphicon-cog:before{content:\"\\E019\"}.glyphicon-trash:before{content:\"\\E020\"}.glyphicon-home:before{content:\"\\E021\"}.glyphicon-file:before{content:\"\\E022\"}.glyphicon-time:before{content:\"\\E023\"}.glyphicon-road:before{content:\"\\E024\"}.glyphicon-download-alt:before{content:\"\\E025\"}.glyphicon-download:before{content:\"\\E026\"}.glyphicon-upload:before{content:\"\\E027\"}.glyphicon-inbox:before{content:\"\\E028\"}.glyphicon-play-circle:before{content:\"\\E029\"}.glyphicon-repeat:before{content:\"\\E030\"}.glyphicon-refresh:before{content:\"\\E031\"}.glyphicon-list-alt:before{content:\"\\E032\"}.glyphicon-lock:before{content:\"\\E033\"}.glyphicon-flag:before{content:\"\\E034\"}.glyphicon-headphones:before{content:\"\\E035\"}.glyphicon-volume-off:before{content:\"\\E036\"}.glyphicon-volume-down:before{content:\"\\E037\"}.glyphicon-volume-up:before{content:\"\\E038\"}.glyphicon-qrcode:before{content:\"\\E039\"}.glyphicon-barcode:before{content:\"\\E040\"}.glyphicon-tag:before{content:\"\\E041\"}.glyphicon-tags:before{content:\"\\E042\"}.glyphicon-book:before{content:\"\\E043\"}.glyphicon-bookmark:before{content:\"\\E044\"}.glyphicon-print:before{content:\"\\E045\"}.glyphicon-camera:before{content:\"\\E046\"}.glyphicon-font:before{content:\"\\E047\"}.glyphicon-bold:before{content:\"\\E048\"}.glyphicon-italic:before{content:\"\\E049\"}.glyphicon-text-height:before{content:\"\\E050\"}.glyphicon-text-width:before{content:\"\\E051\"}.glyphicon-align-left:before{content:\"\\E052\"}.glyphicon-align-center:before{content:\"\\E053\"}.glyphicon-align-right:before{content:\"\\E054\"}.glyphicon-align-justify:before{content:\"\\E055\"}.glyphicon-list:before{content:\"\\E056\"}.glyphicon-indent-left:before{content:\"\\E057\"}.glyphicon-indent-right:before{content:\"\\E058\"}.glyphicon-facetime-video:before{content:\"\\E059\"}.glyphicon-picture:before{content:\"\\E060\"}.glyphicon-map-marker:before{content:\"\\E062\"}.glyphicon-adjust:before{content:\"\\E063\"}.glyphicon-tint:before{content:\"\\E064\"}.glyphicon-edit:before{content:\"\\E065\"}.glyphicon-share:before{content:\"\\E066\"}.glyphicon-check:before{content:\"\\E067\"}.glyphicon-move:before{content:\"\\E068\"}.glyphicon-step-backward:before{content:\"\\E069\"}.glyphicon-fast-backward:before{content:\"\\E070\"}.glyphicon-backward:before{content:\"\\E071\"}.glyphicon-play:before{content:\"\\E072\"}.glyphicon-pause:before{content:\"\\E073\"}.glyphicon-stop:before{content:\"\\E074\"}.glyphicon-forward:before{content:\"\\E075\"}.glyphicon-fast-forward:before{content:\"\\E076\"}.glyphicon-step-forward:before{content:\"\\E077\"}.glyphicon-eject:before{content:\"\\E078\"}.glyphicon-chevron-left:before{content:\"\\E079\"}.glyphicon-chevron-right:before{content:\"\\E080\"}.glyphicon-plus-sign:before{content:\"\\E081\"}.glyphicon-minus-sign:before{content:\"\\E082\"}.glyphicon-remove-sign:before{content:\"\\E083\"}.glyphicon-ok-sign:before{content:\"\\E084\"}.glyphicon-question-sign:before{content:\"\\E085\"}.glyphicon-info-sign:before{content:\"\\E086\"}.glyphicon-screenshot:before{content:\"\\E087\"}.glyphicon-remove-circle:before{content:\"\\E088\"}.glyphicon-ok-circle:before{content:\"\\E089\"}.glyphicon-ban-circle:before{content:\"\\E090\"}.glyphicon-arrow-left:before{content:\"\\E091\"}.glyphicon-arrow-right:before{content:\"\\E092\"}.glyphicon-arrow-up:before{content:\"\\E093\"}.glyphicon-arrow-down:before{content:\"\\E094\"}.glyphicon-share-alt:before{content:\"\\E095\"}.glyphicon-resize-full:before{content:\"\\E096\"}.glyphicon-resize-small:before{content:\"\\E097\"}.glyphicon-exclamation-sign:before{content:\"\\E101\"}.glyphicon-gift:before{content:\"\\E102\"}.glyphicon-leaf:before{content:\"\\E103\"}.glyphicon-fire:before{content:\"\\E104\"}.glyphicon-eye-open:before{content:\"\\E105\"}.glyphicon-eye-close:before{content:\"\\E106\"}.glyphicon-warning-sign:before{content:\"\\E107\"}.glyphicon-plane:before{content:\"\\E108\"}.glyphicon-calendar:before{content:\"\\E109\"}.glyphicon-random:before{content:\"\\E110\"}.glyphicon-comment:before{content:\"\\E111\"}.glyphicon-magnet:before{content:\"\\E112\"}.glyphicon-chevron-up:before{content:\"\\E113\"}.glyphicon-chevron-down:before{content:\"\\E114\"}.glyphicon-retweet:before{content:\"\\E115\"}.glyphicon-shopping-cart:before{content:\"\\E116\"}.glyphicon-folder-close:before{content:\"\\E117\"}.glyphicon-folder-open:before{content:\"\\E118\"}.glyphicon-resize-vertical:before{content:\"\\E119\"}.glyphicon-resize-horizontal:before{content:\"\\E120\"}.glyphicon-hdd:before{content:\"\\E121\"}.glyphicon-bullhorn:before{content:\"\\E122\"}.glyphicon-bell:before{content:\"\\E123\"}.glyphicon-certificate:before{content:\"\\E124\"}.glyphicon-thumbs-up:before{content:\"\\E125\"}.glyphicon-thumbs-down:before{content:\"\\E126\"}.glyphicon-hand-right:before{content:\"\\E127\"}.glyphicon-hand-left:before{content:\"\\E128\"}.glyphicon-hand-up:before{content:\"\\E129\"}.glyphicon-hand-down:before{content:\"\\E130\"}.glyphicon-circle-arrow-right:before{content:\"\\E131\"}.glyphicon-circle-arrow-left:before{content:\"\\E132\"}.glyphicon-circle-arrow-up:before{content:\"\\E133\"}.glyphicon-circle-arrow-down:before{content:\"\\E134\"}.glyphicon-globe:before{content:\"\\E135\"}.glyphicon-wrench:before{content:\"\\E136\"}.glyphicon-tasks:before{content:\"\\E137\"}.glyphicon-filter:before{content:\"\\E138\"}.glyphicon-briefcase:before{content:\"\\E139\"}.glyphicon-fullscreen:before{content:\"\\E140\"}.glyphicon-dashboard:before{content:\"\\E141\"}.glyphicon-paperclip:before{content:\"\\E142\"}.glyphicon-heart-empty:before{content:\"\\E143\"}.glyphicon-link:before{content:\"\\E144\"}.glyphicon-phone:before{content:\"\\E145\"}.glyphicon-pushpin:before{content:\"\\E146\"}.glyphicon-usd:before{content:\"\\E148\"}.glyphicon-gbp:before{content:\"\\E149\"}.glyphicon-sort:before{content:\"\\E150\"}.glyphicon-sort-by-alphabet:before{content:\"\\E151\"}.glyphicon-sort-by-alphabet-alt:before{content:\"\\E152\"}.glyphicon-sort-by-order:before{content:\"\\E153\"}.glyphicon-sort-by-order-alt:before{content:\"\\E154\"}.glyphicon-sort-by-attributes:before{content:\"\\E155\"}.glyphicon-sort-by-attributes-alt:before{content:\"\\E156\"}.glyphicon-unchecked:before{content:\"\\E157\"}.glyphicon-expand:before{content:\"\\E158\"}.glyphicon-collapse-down:before{content:\"\\E159\"}.glyphicon-collapse-up:before{content:\"\\E160\"}.glyphicon-log-in:before{content:\"\\E161\"}.glyphicon-flash:before{content:\"\\E162\"}.glyphicon-log-out:before{content:\"\\E163\"}.glyphicon-new-window:before{content:\"\\E164\"}.glyphicon-record:before{content:\"\\E165\"}.glyphicon-save:before{content:\"\\E166\"}.glyphicon-open:before{content:\"\\E167\"}.glyphicon-saved:before{content:\"\\E168\"}.glyphicon-import:before{content:\"\\E169\"}.glyphicon-export:before{content:\"\\E170\"}.glyphicon-send:before{content:\"\\E171\"}.glyphicon-floppy-disk:before{content:\"\\E172\"}.glyphicon-floppy-saved:before{content:\"\\E173\"}.glyphicon-floppy-remove:before{content:\"\\E174\"}.glyphicon-floppy-save:before{content:\"\\E175\"}.glyphicon-floppy-open:before{content:\"\\E176\"}.glyphicon-credit-card:before{content:\"\\E177\"}.glyphicon-transfer:before{content:\"\\E178\"}.glyphicon-cutlery:before{content:\"\\E179\"}.glyphicon-header:before{content:\"\\E180\"}.glyphicon-compressed:before{content:\"\\E181\"}.glyphicon-earphone:before{content:\"\\E182\"}.glyphicon-phone-alt:before{content:\"\\E183\"}.glyphicon-tower:before{content:\"\\E184\"}.glyphicon-stats:before{content:\"\\E185\"}.glyphicon-sd-video:before{content:\"\\E186\"}.glyphicon-hd-video:before{content:\"\\E187\"}.glyphicon-subtitles:before{content:\"\\E188\"}.glyphicon-sound-stereo:before{content:\"\\E189\"}.glyphicon-sound-dolby:before{content:\"\\E190\"}.glyphicon-sound-5-1:before{content:\"\\E191\"}.glyphicon-sound-6-1:before{content:\"\\E192\"}.glyphicon-sound-7-1:before{content:\"\\E193\"}.glyphicon-copyright-mark:before{content:\"\\E194\"}.glyphicon-registration-mark:before{content:\"\\E195\"}.glyphicon-cloud-download:before{content:\"\\E197\"}.glyphicon-cloud-upload:before{content:\"\\E198\"}.glyphicon-tree-conifer:before{content:\"\\E199\"}.glyphicon-tree-deciduous:before{content:\"\\E200\"}.glyphicon-cd:before{content:\"\\E201\"}.glyphicon-save-file:before{content:\"\\E202\"}.glyphicon-open-file:before{content:\"\\E203\"}.glyphicon-level-up:before{content:\"\\E204\"}.glyphicon-copy:before{content:\"\\E205\"}.glyphicon-paste:before{content:\"\\E206\"}.glyphicon-alert:before{content:\"\\E209\"}.glyphicon-equalizer:before{content:\"\\E210\"}.glyphicon-king:before{content:\"\\E211\"}.glyphicon-queen:before{content:\"\\E212\"}.glyphicon-pawn:before{content:\"\\E213\"}.glyphicon-bishop:before{content:\"\\E214\"}.glyphicon-knight:before{content:\"\\E215\"}.glyphicon-baby-formula:before{content:\"\\E216\"}.glyphicon-tent:before{content:\"\\26FA\"}.glyphicon-blackboard:before{content:\"\\E218\"}.glyphicon-bed:before{content:\"\\E219\"}.glyphicon-apple:before{content:\"\\F8FF\"}.glyphicon-erase:before{content:\"\\E221\"}.glyphicon-hourglass:before{content:\"\\231B\"}.glyphicon-lamp:before{content:\"\\E223\"}.glyphicon-duplicate:before{content:\"\\E224\"}.glyphicon-piggy-bank:before{content:\"\\E225\"}.glyphicon-scissors:before{content:\"\\E226\"}.glyphicon-bitcoin:before,.glyphicon-btc:before,.glyphicon-xbt:before{content:\"\\E227\"}.glyphicon-jpy:before,.glyphicon-yen:before{content:\"\\A5\"}.glyphicon-rub:before,.glyphicon-ruble:before{content:\"\\20BD\"}.glyphicon-scale:before{content:\"\\E230\"}.glyphicon-ice-lolly:before{content:\"\\E231\"}.glyphicon-ice-lolly-tasted:before{content:\"\\E232\"}.glyphicon-education:before{content:\"\\E233\"}.glyphicon-option-horizontal:before{content:\"\\E234\"}.glyphicon-option-vertical:before{content:\"\\E235\"}.glyphicon-menu-hamburger:before{content:\"\\E236\"}.glyphicon-modal-window:before{content:\"\\E237\"}.glyphicon-oil:before{content:\"\\E238\"}.glyphicon-grain:before{content:\"\\E239\"}.glyphicon-sunglasses:before{content:\"\\E240\"}.glyphicon-text-size:before{content:\"\\E241\"}.glyphicon-text-color:before{content:\"\\E242\"}.glyphicon-text-background:before{content:\"\\E243\"}.glyphicon-object-align-top:before{content:\"\\E244\"}.glyphicon-object-align-bottom:before{content:\"\\E245\"}.glyphicon-object-align-horizontal:before{content:\"\\E246\"}.glyphicon-object-align-left:before{content:\"\\E247\"}.glyphicon-object-align-vertical:before{content:\"\\E248\"}.glyphicon-object-align-right:before{content:\"\\E249\"}.glyphicon-triangle-right:before{content:\"\\E250\"}.glyphicon-triangle-left:before{content:\"\\E251\"}.glyphicon-triangle-bottom:before{content:\"\\E252\"}.glyphicon-triangle-top:before{content:\"\\E253\"}.glyphicon-console:before{content:\"\\E254\"}.glyphicon-superscript:before{content:\"\\E255\"}.glyphicon-subscript:before{content:\"\\E256\"}.glyphicon-menu-left:before{content:\"\\E257\"}.glyphicon-menu-right:before{content:\"\\E258\"}.glyphicon-menu-down:before{content:\"\\E259\"}.glyphicon-menu-up:before{content:\"\\E260\"}*,:after,:before{-webkit-box-sizing:border-box;-moz-box-sizing:border-box;box-sizing:border-box}html{font-size:10px;-webkit-tap-highlight-color:rgba(0,0,0,0)}body{font-family:Helvetica Neue,Helvetica,Arial,sans-serif;font-size:14px;line-height:1.42857143;color:#333;background-color:#fff}button,input,select,textarea{font-family:inherit;font-size:inherit;line-height:inherit}a{color:#337ab7;text-decoration:none}a:focus,a:hover{color:#23527c;text-decoration:underline}a:focus{outline:5px auto -webkit-focus-ring-color;outline-offset:-2px}figure{margin:0}img{vertical-align:middle}.carousel-inner>.item>a>img,.carousel-inner>.item>img,.img-responsive,.thumbnail>img,.thumbnail a>img{display:block;max-width:100%;height:auto}.img-rounded{border-radius:6px}.img-thumbnail{display:inline-block;max-width:100%;height:auto;padding:4px;line-height:1.42857143;background-color:#fff;border:1px solid #ddd;border-radius:4px;-webkit-transition:all .2s ease-in-out;-o-transition:all .2s ease-in-out;transition:all .2s ease-in-out}.img-circle{border-radius:50%}hr{margin-top:20px;margin-bottom:20px;border:0;border-top:1px solid #eee}.sr-only{position:absolute;width:1px;height:1px;padding:0;margin:-1px;overflow:hidden;clip:rect(0,0,0,0);border:0}.sr-only-focusable:active,.sr-only-focusable:focus{position:static;width:auto;height:auto;margin:0;overflow:visible;clip:auto}[role=button]{cursor:pointer}.h1,.h2,.h3,.h4,.h5,.h6,h1,h2,h3,h4,h5,h6{font-family:inherit;font-weight:500;line-height:1.1;color:inherit}.h1 .small,.h1 small,.h2 .small,.h2 small,.h3 .small,.h3 small,.h4 .small,.h4 small,.h5 .small,.h5 small,.h6 .small,.h6 small,h1 .small,h1 small,h2 .small,h2 small,h3 .small,h3 small,h4 .small,h4 small,h5 .small,h5 small,h6 .small,h6 small{font-weight:400;line-height:1;color:#777}.h1,.h2,.h3,h1,h2,h3{margin-top:20px;margin-bottom:10px}.h1 .small,.h1 small,.h2 .small,.h2 small,.h3 .small,.h3 small,h1 .small,h1 small,h2 .small,h2 small,h3 .small,h3 small{font-size:65%}.h4,.h5,.h6,h4,h5,h6{margin-top:10px;margin-bottom:10px}.h4 .small,.h4 small,.h5 .small,.h5 small,.h6 .small,.h6 small,h4 .small,h4 small,h5 .small,h5 small,h6 .small,h6 small{font-size:75%}.h1,h1{font-size:36px}.h2,h2{font-size:30px}.h3,h3{font-size:24px}.h4,h4{font-size:18px}.h5,h5{font-size:14px}.h6,h6{font-size:12px}p{margin:0 0 10px}.lead{margin-bottom:20px;font-size:16px;font-weight:300;line-height:1.4}@media (min-width:768px){.lead{font-size:21px}}.small,small{font-size:85%}.mark,mark{padding:.2em;background-color:#fcf8e3}.text-left{text-align:left}.text-right{text-align:right}.text-center{text-align:center}.text-justify{text-align:justify}.text-nowrap{white-space:nowrap}.text-lowercase{text-transform:lowercase}.text-uppercase{text-transform:uppercase}.text-capitalize{text-transform:capitalize}.text-muted{color:#777}.text-primary{color:#337ab7}a.text-primary:focus,a.text-primary:hover{color:#286090}.text-success{color:#3c763d}a.text-success:focus,a.text-success:hover{color:#2b542c}.text-info{color:#31708f}a.text-info:focus,a.text-info:hover{color:#245269}.text-warning{color:#8a6d3b}a.text-warning:focus,a.text-warning:hover{color:#66512c}.text-danger{color:#a94442}a.text-danger:focus,a.text-danger:hover{color:#843534}.bg-primary{color:#fff;background-color:#337ab7}a.bg-primary:focus,a.bg-primary:hover{background-color:#286090}.bg-success{background-color:#dff0d8}a.bg-success:focus,a.bg-success:hover{background-color:#c1e2b3}.bg-info{background-color:#d9edf7}a.bg-info:focus,a.bg-info:hover{background-color:#afd9ee}.bg-warning{background-color:#fcf8e3}a.bg-warning:focus,a.bg-warning:hover{background-color:#f7ecb5}.bg-danger{background-color:#f2dede}a.bg-danger:focus,a.bg-danger:hover{background-color:#e4b9b9}.page-header{padding-bottom:9px;margin:40px 0 20px;border-bottom:1px solid #eee}ol,ul{margin-top:0;margin-bottom:10px}ol ol,ol ul,ul ol,ul ul{margin-bottom:0}.list-inline,.list-unstyled{padding-left:0;list-style:none}.list-inline{margin-left:-5px}.list-inline>li{display:inline-block;padding-right:5px;padding-left:5px}dl{margin-top:0;margin-bottom:20px}dd,dt{line-height:1.42857143}dt{font-weight:700}dd{margin-left:0}@media (min-width:768px){.dl-horizontal dt{float:left;width:160px;overflow:hidden;clear:left;text-align:right;text-overflow:ellipsis;white-space:nowrap}.dl-horizontal dd{margin-left:180px}}abbr[data-original-title],abbr[title]{cursor:help;border-bottom:1px dotted #777}.initialism{font-size:90%;text-transform:uppercase}blockquote{padding:10px 20px;margin:0 0 20px;font-size:17.5px;border-left:5px solid #eee}blockquote ol:last-child,blockquote p:last-child,blockquote ul:last-child{margin-bottom:0}blockquote .small,blockquote footer,blockquote small{display:block;font-size:80%;line-height:1.42857143;color:#777}blockquote .small:before,blockquote footer:before,blockquote small:before{content:\"\\2014   \\A0\"}.blockquote-reverse,blockquote.pull-right{padding-right:15px;padding-left:0;text-align:right;border-right:5px solid #eee;border-left:0}.blockquote-reverse .small:before,.blockquote-reverse footer:before,.blockquote-reverse small:before,blockquote.pull-right .small:before,blockquote.pull-right footer:before,blockquote.pull-right small:before{content:\"\"}.blockquote-reverse .small:after,.blockquote-reverse footer:after,.blockquote-reverse small:after,blockquote.pull-right .small:after,blockquote.pull-right footer:after,blockquote.pull-right small:after{content:\"\\A0   \\2014\"}address{margin-bottom:20px;font-style:normal;line-height:1.42857143}code,kbd,pre,samp{font-family:Menlo,Monaco,Consolas,Courier New,monospace}code{color:#c7254e;background-color:#f9f2f4;border-radius:4px}code,kbd{padding:2px 4px;font-size:90%}kbd{color:#fff;background-color:#333;border-radius:3px;-webkit-box-shadow:inset 0 -1px 0 rgba(0,0,0,.25);box-shadow:inset 0 -1px 0 rgba(0,0,0,.25)}kbd kbd{padding:0;font-size:100%;font-weight:700;-webkit-box-shadow:none;box-shadow:none}pre{display:block;padding:9.5px;margin:0 0 10px;font-size:13px;line-height:1.42857143;color:#333;word-break:break-all;word-wrap:break-word;background-color:#f5f5f5;border:1px solid #ccc;border-radius:4px}pre code{padding:0;font-size:inherit;color:inherit;white-space:pre-wrap;background-color:transparent;border-radius:0}.pre-scrollable{max-height:340px;overflow-y:scroll}.container{padding-right:15px;padding-left:15px;margin-right:auto;margin-left:auto}@media (min-width:768px){.container{width:750px}}@media (min-width:992px){.container{width:970px}}@media (min-width:1200px){.container{width:1170px}}.container-fluid{padding-right:15px;padding-left:15px;margin-right:auto;margin-left:auto}.row{margin-right:-15px;margin-left:-15px}.col-lg-1,.col-lg-2,.col-lg-3,.col-lg-4,.col-lg-5,.col-lg-6,.col-lg-7,.col-lg-8,.col-lg-9,.col-lg-10,.col-lg-11,.col-lg-12,.col-md-1,.col-md-2,.col-md-3,.col-md-4,.col-md-5,.col-md-6,.col-md-7,.col-md-8,.col-md-9,.col-md-10,.col-md-11,.col-md-12,.col-sm-1,.col-sm-2,.col-sm-3,.col-sm-4,.col-sm-5,.col-sm-6,.col-sm-7,.col-sm-8,.col-sm-9,.col-sm-10,.col-sm-11,.col-sm-12,.col-xs-1,.col-xs-2,.col-xs-3,.col-xs-4,.col-xs-5,.col-xs-6,.col-xs-7,.col-xs-8,.col-xs-9,.col-xs-10,.col-xs-11,.col-xs-12{position:relative;min-height:1px;padding-right:15px;padding-left:15px}.col-xs-1,.col-xs-2,.col-xs-3,.col-xs-4,.col-xs-5,.col-xs-6,.col-xs-7,.col-xs-8,.col-xs-9,.col-xs-10,.col-xs-11,.col-xs-12{float:left}.col-xs-12{width:100%}.col-xs-11{width:91.66666667%}.col-xs-10{width:83.33333333%}.col-xs-9{width:75%}.col-xs-8{width:66.66666667%}.col-xs-7{width:58.33333333%}.col-xs-6{width:50%}.col-xs-5{width:41.66666667%}.col-xs-4{width:33.33333333%}.col-xs-3{width:25%}.col-xs-2{width:16.66666667%}.col-xs-1{width:8.33333333%}.col-xs-pull-12{right:100%}.col-xs-pull-11{right:91.66666667%}.col-xs-pull-10{right:83.33333333%}.col-xs-pull-9{right:75%}.col-xs-pull-8{right:66.66666667%}.col-xs-pull-7{right:58.33333333%}.col-xs-pull-6{right:50%}.col-xs-pull-5{right:41.66666667%}.col-xs-pull-4{right:33.33333333%}.col-xs-pull-3{right:25%}.col-xs-pull-2{right:16.66666667%}.col-xs-pull-1{right:8.33333333%}.col-xs-pull-0{right:auto}.col-xs-push-12{left:100%}.col-xs-push-11{left:91.66666667%}.col-xs-push-10{left:83.33333333%}.col-xs-push-9{left:75%}.col-xs-push-8{left:66.66666667%}.col-xs-push-7{left:58.33333333%}.col-xs-push-6{left:50%}.col-xs-push-5{left:41.66666667%}.col-xs-push-4{left:33.33333333%}.col-xs-push-3{left:25%}.col-xs-push-2{left:16.66666667%}.col-xs-push-1{left:8.33333333%}.col-xs-push-0{left:auto}.col-xs-offset-12{margin-left:100%}.col-xs-offset-11{margin-left:91.66666667%}.col-xs-offset-10{margin-left:83.33333333%}.col-xs-offset-9{margin-left:75%}.col-xs-offset-8{margin-left:66.66666667%}.col-xs-offset-7{margin-left:58.33333333%}.col-xs-offset-6{margin-left:50%}.col-xs-offset-5{margin-left:41.66666667%}.col-xs-offset-4{margin-left:33.33333333%}.col-xs-offset-3{margin-left:25%}.col-xs-offset-2{margin-left:16.66666667%}.col-xs-offset-1{margin-left:8.33333333%}.col-xs-offset-0{margin-left:0}@media (min-width:768px){.col-sm-1,.col-sm-2,.col-sm-3,.col-sm-4,.col-sm-5,.col-sm-6,.col-sm-7,.col-sm-8,.col-sm-9,.col-sm-10,.col-sm-11,.col-sm-12{float:left}.col-sm-12{width:100%}.col-sm-11{width:91.66666667%}.col-sm-10{width:83.33333333%}.col-sm-9{width:75%}.col-sm-8{width:66.66666667%}.col-sm-7{width:58.33333333%}.col-sm-6{width:50%}.col-sm-5{width:41.66666667%}.col-sm-4{width:33.33333333%}.col-sm-3{width:25%}.col-sm-2{width:16.66666667%}.col-sm-1{width:8.33333333%}.col-sm-pull-12{right:100%}.col-sm-pull-11{right:91.66666667%}.col-sm-pull-10{right:83.33333333%}.col-sm-pull-9{right:75%}.col-sm-pull-8{right:66.66666667%}.col-sm-pull-7{right:58.33333333%}.col-sm-pull-6{right:50%}.col-sm-pull-5{right:41.66666667%}.col-sm-pull-4{right:33.33333333%}.col-sm-pull-3{right:25%}.col-sm-pull-2{right:16.66666667%}.col-sm-pull-1{right:8.33333333%}.col-sm-pull-0{right:auto}.col-sm-push-12{left:100%}.col-sm-push-11{left:91.66666667%}.col-sm-push-10{left:83.33333333%}.col-sm-push-9{left:75%}.col-sm-push-8{left:66.66666667%}.col-sm-push-7{left:58.33333333%}.col-sm-push-6{left:50%}.col-sm-push-5{left:41.66666667%}.col-sm-push-4{left:33.33333333%}.col-sm-push-3{left:25%}.col-sm-push-2{left:16.66666667%}.col-sm-push-1{left:8.33333333%}.col-sm-push-0{left:auto}.col-sm-offset-12{margin-left:100%}.col-sm-offset-11{margin-left:91.66666667%}.col-sm-offset-10{margin-left:83.33333333%}.col-sm-offset-9{margin-left:75%}.col-sm-offset-8{margin-left:66.66666667%}.col-sm-offset-7{margin-left:58.33333333%}.col-sm-offset-6{margin-left:50%}.col-sm-offset-5{margin-left:41.66666667%}.col-sm-offset-4{margin-left:33.33333333%}.col-sm-offset-3{margin-left:25%}.col-sm-offset-2{margin-left:16.66666667%}.col-sm-offset-1{margin-left:8.33333333%}.col-sm-offset-0{margin-left:0}}@media (min-width:992px){.col-md-1,.col-md-2,.col-md-3,.col-md-4,.col-md-5,.col-md-6,.col-md-7,.col-md-8,.col-md-9,.col-md-10,.col-md-11,.col-md-12{float:left}.col-md-12{width:100%}.col-md-11{width:91.66666667%}.col-md-10{width:83.33333333%}.col-md-9{width:75%}.col-md-8{width:66.66666667%}.col-md-7{width:58.33333333%}.col-md-6{width:50%}.col-md-5{width:41.66666667%}.col-md-4{width:33.33333333%}.col-md-3{width:25%}.col-md-2{width:16.66666667%}.col-md-1{width:8.33333333%}.col-md-pull-12{right:100%}.col-md-pull-11{right:91.66666667%}.col-md-pull-10{right:83.33333333%}.col-md-pull-9{right:75%}.col-md-pull-8{right:66.66666667%}.col-md-pull-7{right:58.33333333%}.col-md-pull-6{right:50%}.col-md-pull-5{right:41.66666667%}.col-md-pull-4{right:33.33333333%}.col-md-pull-3{right:25%}.col-md-pull-2{right:16.66666667%}.col-md-pull-1{right:8.33333333%}.col-md-pull-0{right:auto}.col-md-push-12{left:100%}.col-md-push-11{left:91.66666667%}.col-md-push-10{left:83.33333333%}.col-md-push-9{left:75%}.col-md-push-8{left:66.66666667%}.col-md-push-7{left:58.33333333%}.col-md-push-6{left:50%}.col-md-push-5{left:41.66666667%}.col-md-push-4{left:33.33333333%}.col-md-push-3{left:25%}.col-md-push-2{left:16.66666667%}.col-md-push-1{left:8.33333333%}.col-md-push-0{left:auto}.col-md-offset-12{margin-left:100%}.col-md-offset-11{margin-left:91.66666667%}.col-md-offset-10{margin-left:83.33333333%}.col-md-offset-9{margin-left:75%}.col-md-offset-8{margin-left:66.66666667%}.col-md-offset-7{margin-left:58.33333333%}.col-md-offset-6{margin-left:50%}.col-md-offset-5{margin-left:41.66666667%}.col-md-offset-4{margin-left:33.33333333%}.col-md-offset-3{margin-left:25%}.col-md-offset-2{margin-left:16.66666667%}.col-md-offset-1{margin-left:8.33333333%}.col-md-offset-0{margin-left:0}}@media (min-width:1200px){.col-lg-1,.col-lg-2,.col-lg-3,.col-lg-4,.col-lg-5,.col-lg-6,.col-lg-7,.col-lg-8,.col-lg-9,.col-lg-10,.col-lg-11,.col-lg-12{float:left}.col-lg-12{width:100%}.col-lg-11{width:91.66666667%}.col-lg-10{width:83.33333333%}.col-lg-9{width:75%}.col-lg-8{width:66.66666667%}.col-lg-7{width:58.33333333%}.col-lg-6{width:50%}.col-lg-5{width:41.66666667%}.col-lg-4{width:33.33333333%}.col-lg-3{width:25%}.col-lg-2{width:16.66666667%}.col-lg-1{width:8.33333333%}.col-lg-pull-12{right:100%}.col-lg-pull-11{right:91.66666667%}.col-lg-pull-10{right:83.33333333%}.col-lg-pull-9{right:75%}.col-lg-pull-8{right:66.66666667%}.col-lg-pull-7{right:58.33333333%}.col-lg-pull-6{right:50%}.col-lg-pull-5{right:41.66666667%}.col-lg-pull-4{right:33.33333333%}.col-lg-pull-3{right:25%}.col-lg-pull-2{right:16.66666667%}.col-lg-pull-1{right:8.33333333%}.col-lg-pull-0{right:auto}.col-lg-push-12{left:100%}.col-lg-push-11{left:91.66666667%}.col-lg-push-10{left:83.33333333%}.col-lg-push-9{left:75%}.col-lg-push-8{left:66.66666667%}.col-lg-push-7{left:58.33333333%}.col-lg-push-6{left:50%}.col-lg-push-5{left:41.66666667%}.col-lg-push-4{left:33.33333333%}.col-lg-push-3{left:25%}.col-lg-push-2{left:16.66666667%}.col-lg-push-1{left:8.33333333%}.col-lg-push-0{left:auto}.col-lg-offset-12{margin-left:100%}.col-lg-offset-11{margin-left:91.66666667%}.col-lg-offset-10{margin-left:83.33333333%}.col-lg-offset-9{margin-left:75%}.col-lg-offset-8{margin-left:66.66666667%}.col-lg-offset-7{margin-left:58.33333333%}.col-lg-offset-6{margin-left:50%}.col-lg-offset-5{margin-left:41.66666667%}.col-lg-offset-4{margin-left:33.33333333%}.col-lg-offset-3{margin-left:25%}.col-lg-offset-2{margin-left:16.66666667%}.col-lg-offset-1{margin-left:8.33333333%}.col-lg-offset-0{margin-left:0}}table{background-color:transparent}caption{padding-top:8px;padding-bottom:8px;color:#777}caption,th{text-align:left}.table{width:100%;max-width:100%;margin-bottom:20px}.table>tbody>tr>td,.table>tbody>tr>th,.table>tfoot>tr>td,.table>tfoot>tr>th,.table>thead>tr>td,.table>thead>tr>th{padding:8px;line-height:1.42857143;vertical-align:top;border-top:1px solid #ddd}.table>thead>tr>th{vertical-align:bottom;border-bottom:2px solid #ddd}.table>caption+thead>tr:first-child>td,.table>caption+thead>tr:first-child>th,.table>colgroup+thead>tr:first-child>td,.table>colgroup+thead>tr:first-child>th,.table>thead:first-child>tr:first-child>td,.table>thead:first-child>tr:first-child>th{border-top:0}.table>tbody+tbody{border-top:2px solid #ddd}.table .table{background-color:#fff}.table-condensed>tbody>tr>td,.table-condensed>tbody>tr>th,.table-condensed>tfoot>tr>td,.table-condensed>tfoot>tr>th,.table-condensed>thead>tr>td,.table-condensed>thead>tr>th{padding:5px}.table-bordered,.table-bordered>tbody>tr>td,.table-bordered>tbody>tr>th,.table-bordered>tfoot>tr>td,.table-bordered>tfoot>tr>th,.table-bordered>thead>tr>td,.table-bordered>thead>tr>th{border:1px solid #ddd}.table-bordered>thead>tr>td,.table-bordered>thead>tr>th{border-bottom-width:2px}.table-striped>tbody>tr:nth-of-type(odd){background-color:#f9f9f9}.table-hover>tbody>tr:hover{background-color:#f5f5f5}table col[class*=col-]{position:static;display:table-column;float:none}table td[class*=col-],table th[class*=col-]{position:static;display:table-cell;float:none}.table>tbody>tr.active>td,.table>tbody>tr.active>th,.table>tbody>tr>td.active,.table>tbody>tr>th.active,.table>tfoot>tr.active>td,.table>tfoot>tr.active>th,.table>tfoot>tr>td.active,.table>tfoot>tr>th.active,.table>thead>tr.active>td,.table>thead>tr.active>th,.table>thead>tr>td.active,.table>thead>tr>th.active{background-color:#f5f5f5}.table-hover>tbody>tr.active:hover>td,.table-hover>tbody>tr.active:hover>th,.table-hover>tbody>tr:hover>.active,.table-hover>tbody>tr>td.active:hover,.table-hover>tbody>tr>th.active:hover{background-color:#e8e8e8}.table>tbody>tr.success>td,.table>tbody>tr.success>th,.table>tbody>tr>td.success,.table>tbody>tr>th.success,.table>tfoot>tr.success>td,.table>tfoot>tr.success>th,.table>tfoot>tr>td.success,.table>tfoot>tr>th.success,.table>thead>tr.success>td,.table>thead>tr.success>th,.table>thead>tr>td.success,.table>thead>tr>th.success{background-color:#dff0d8}.table-hover>tbody>tr.success:hover>td,.table-hover>tbody>tr.success:hover>th,.table-hover>tbody>tr:hover>.success,.table-hover>tbody>tr>td.success:hover,.table-hover>tbody>tr>th.success:hover{background-color:#d0e9c6}.table>tbody>tr.info>td,.table>tbody>tr.info>th,.table>tbody>tr>td.info,.table>tbody>tr>th.info,.table>tfoot>tr.info>td,.table>tfoot>tr.info>th,.table>tfoot>tr>td.info,.table>tfoot>tr>th.info,.table>thead>tr.info>td,.table>thead>tr.info>th,.table>thead>tr>td.info,.table>thead>tr>th.info{background-color:#d9edf7}.table-hover>tbody>tr.info:hover>td,.table-hover>tbody>tr.info:hover>th,.table-hover>tbody>tr:hover>.info,.table-hover>tbody>tr>td.info:hover,.table-hover>tbody>tr>th.info:hover{background-color:#c4e3f3}.table>tbody>tr.warning>td,.table>tbody>tr.warning>th,.table>tbody>tr>td.warning,.table>tbody>tr>th.warning,.table>tfoot>tr.warning>td,.table>tfoot>tr.warning>th,.table>tfoot>tr>td.warning,.table>tfoot>tr>th.warning,.table>thead>tr.warning>td,.table>thead>tr.warning>th,.table>thead>tr>td.warning,.table>thead>tr>th.warning{background-color:#fcf8e3}.table-hover>tbody>tr.warning:hover>td,.table-hover>tbody>tr.warning:hover>th,.table-hover>tbody>tr:hover>.warning,.table-hover>tbody>tr>td.warning:hover,.table-hover>tbody>tr>th.warning:hover{background-color:#faf2cc}.table>tbody>tr.danger>td,.table>tbody>tr.danger>th,.table>tbody>tr>td.danger,.table>tbody>tr>th.danger,.table>tfoot>tr.danger>td,.table>tfoot>tr.danger>th,.table>tfoot>tr>td.danger,.table>tfoot>tr>th.danger,.table>thead>tr.danger>td,.table>thead>tr.danger>th,.table>thead>tr>td.danger,.table>thead>tr>th.danger{background-color:#f2dede}.table-hover>tbody>tr.danger:hover>td,.table-hover>tbody>tr.danger:hover>th,.table-hover>tbody>tr:hover>.danger,.table-hover>tbody>tr>td.danger:hover,.table-hover>tbody>tr>th.danger:hover{background-color:#ebcccc}.table-responsive{min-height:.01%;overflow-x:auto}@media screen and (max-width:767px){.table-responsive{width:100%;margin-bottom:15px;overflow-y:hidden;-ms-overflow-style:-ms-autohiding-scrollbar;border:1px solid #ddd}.table-responsive>.table{margin-bottom:0}.table-responsive>.table>tbody>tr>td,.table-responsive>.table>tbody>tr>th,.table-responsive>.table>tfoot>tr>td,.table-responsive>.table>tfoot>tr>th,.table-responsive>.table>thead>tr>td,.table-responsive>.table>thead>tr>th{white-space:nowrap}.table-responsive>.table-bordered{border:0}.table-responsive>.table-bordered>tbody>tr>td:first-child,.table-responsive>.table-bordered>tbody>tr>th:first-child,.table-responsive>.table-bordered>tfoot>tr>td:first-child,.table-responsive>.table-bordered>tfoot>tr>th:first-child,.table-responsive>.table-bordered>thead>tr>td:first-child,.table-responsive>.table-bordered>thead>tr>th:first-child{border-left:0}.table-responsive>.table-bordered>tbody>tr>td:last-child,.table-responsive>.table-bordered>tbody>tr>th:last-child,.table-responsive>.table-bordered>tfoot>tr>td:last-child,.table-responsive>.table-bordered>tfoot>tr>th:last-child,.table-responsive>.table-bordered>thead>tr>td:last-child,.table-responsive>.table-bordered>thead>tr>th:last-child{border-right:0}.table-responsive>.table-bordered>tbody>tr:last-child>td,.table-responsive>.table-bordered>tbody>tr:last-child>th,.table-responsive>.table-bordered>tfoot>tr:last-child>td,.table-responsive>.table-bordered>tfoot>tr:last-child>th{border-bottom:0}}fieldset{min-width:0;margin:0}fieldset,legend{padding:0;border:0}legend{display:block;width:100%;margin-bottom:20px;font-size:21px;line-height:inherit;color:#333;border-bottom:1px solid #e5e5e5}label{display:inline-block;max-width:100%;margin-bottom:5px;font-weight:700}input[type=search]{-webkit-box-sizing:border-box;-moz-box-sizing:border-box;box-sizing:border-box}input[type=checkbox],input[type=radio]{margin:4px 0 0;margin-top:1px\\9;line-height:normal}input[type=file]{display:block}input[type=range]{display:block;width:100%}select[multiple],select[size]{height:auto}input[type=checkbox]:focus,input[type=file]:focus,input[type=radio]:focus{outline:5px auto -webkit-focus-ring-color;outline-offset:-2px}output{padding-top:7px}.form-control,output{display:block;font-size:14px;line-height:1.42857143;color:#555}.form-control{width:100%;height:34px;padding:6px 12px;background-color:#fff;background-image:none;border:1px solid #ccc;border-radius:4px;-webkit-box-shadow:inset 0 1px 1px rgba(0,0,0,.075);box-shadow:inset 0 1px 1px rgba(0,0,0,.075);-webkit-transition:border-color .15s ease-in-out,-webkit-box-shadow .15s ease-in-out;-o-transition:border-color ease-in-out .15s,box-shadow ease-in-out .15s;transition:border-color .15s ease-in-out,box-shadow .15s ease-in-out}.form-control:focus{border-color:#66afe9;outline:0;-webkit-box-shadow:inset 0 1px 1px rgba(0,0,0,.075),0 0 8px rgba(102,175,233,.6);box-shadow:inset 0 1px 1px rgba(0,0,0,.075),0 0 8px rgba(102,175,233,.6)}.form-control::-moz-placeholder{color:#999;opacity:1}.form-control:-ms-input-placeholder{color:#999}.form-control::-webkit-input-placeholder{color:#999}.form-control::-ms-expand{background-color:transparent;border:0}.form-control[disabled],.form-control[readonly],fieldset[disabled] .form-control{background-color:#eee;opacity:1}.form-control[disabled],fieldset[disabled] .form-control{cursor:not-allowed}textarea.form-control{height:auto}input[type=search]{-webkit-appearance:none}@media screen and (-webkit-min-device-pixel-ratio:0){input[type=date].form-control,input[type=datetime-local].form-control,input[type=month].form-control,input[type=time].form-control{line-height:34px}.input-group-sm input[type=date],.input-group-sm input[type=datetime-local],.input-group-sm input[type=month],.input-group-sm input[type=time],input[type=date].input-sm,input[type=datetime-local].input-sm,input[type=month].input-sm,input[type=time].input-sm{line-height:30px}.input-group-lg input[type=date],.input-group-lg input[type=datetime-local],.input-group-lg input[type=month],.input-group-lg input[type=time],input[type=date].input-lg,input[type=datetime-local].input-lg,input[type=month].input-lg,input[type=time].input-lg{line-height:46px}}.form-group{margin-bottom:15px}.checkbox,.radio{position:relative;display:block;margin-top:10px;margin-bottom:10px}.checkbox label,.radio label{min-height:20px;padding-left:20px;margin-bottom:0;font-weight:400;cursor:pointer}.checkbox-inline input[type=checkbox],.checkbox input[type=checkbox],.radio-inline input[type=radio],.radio input[type=radio]{position:absolute;margin-top:4px\\9;margin-left:-20px}.checkbox+.checkbox,.radio+.radio{margin-top:-5px}.checkbox-inline,.radio-inline{position:relative;display:inline-block;padding-left:20px;margin-bottom:0;font-weight:400;vertical-align:middle;cursor:pointer}.checkbox-inline+.checkbox-inline,.radio-inline+.radio-inline{margin-top:0;margin-left:10px}.checkbox-inline.disabled,.checkbox.disabled label,.radio-inline.disabled,.radio.disabled label,fieldset[disabled] .checkbox-inline,fieldset[disabled] .checkbox label,fieldset[disabled] .radio-inline,fieldset[disabled] .radio label,fieldset[disabled] input[type=checkbox],fieldset[disabled] input[type=radio],input[type=checkbox].disabled,input[type=checkbox][disabled],input[type=radio].disabled,input[type=radio][disabled]{cursor:not-allowed}.form-control-static{min-height:34px;padding-top:7px;padding-bottom:7px;margin-bottom:0}.form-control-static.input-lg,.form-control-static.input-sm{padding-right:0;padding-left:0}.input-sm{height:30px;padding:5px 10px;font-size:12px;line-height:1.5;border-radius:3px}select.input-sm{height:30px;line-height:30px}select[multiple].input-sm,textarea.input-sm{height:auto}.form-group-sm .form-control{height:30px;padding:5px 10px;font-size:12px;line-height:1.5;border-radius:3px}.form-group-sm select.form-control{height:30px;line-height:30px}.form-group-sm select[multiple].form-control,.form-group-sm textarea.form-control{height:auto}.form-group-sm .form-control-static{height:30px;min-height:32px;padding:6px 10px;font-size:12px;line-height:1.5}.input-lg{height:46px;padding:10px 16px;font-size:18px;line-height:1.3333333;border-radius:6px}select.input-lg{height:46px;line-height:46px}select[multiple].input-lg,textarea.input-lg{height:auto}.form-group-lg .form-control{height:46px;padding:10px 16px;font-size:18px;line-height:1.3333333;border-radius:6px}.form-group-lg select.form-control{height:46px;line-height:46px}.form-group-lg select[multiple].form-control,.form-group-lg textarea.form-control{height:auto}.form-group-lg .form-control-static{height:46px;min-height:38px;padding:11px 16px;font-size:18px;line-height:1.3333333}.has-feedback{position:relative}.has-feedback .form-control{padding-right:42.5px}.form-control-feedback{position:absolute;top:0;right:0;z-index:2;display:block;width:34px;height:34px;line-height:34px;text-align:center;pointer-events:none}.form-group-lg .form-control+.form-control-feedback,.input-group-lg+.form-control-feedback,.input-lg+.form-control-feedback{width:46px;height:46px;line-height:46px}.form-group-sm .form-control+.form-control-feedback,.input-group-sm+.form-control-feedback,.input-sm+.form-control-feedback{width:30px;height:30px;line-height:30px}.has-success .checkbox,.has-success .checkbox-inline,.has-success.checkbox-inline label,.has-success.checkbox label,.has-success .control-label,.has-success .help-block,.has-success .radio,.has-success .radio-inline,.has-success.radio-inline label,.has-success.radio label{color:#3c763d}.has-success .form-control{border-color:#3c763d;-webkit-box-shadow:inset 0 1px 1px rgba(0,0,0,.075);box-shadow:inset 0 1px 1px rgba(0,0,0,.075)}.has-success .form-control:focus{border-color:#2b542c;-webkit-box-shadow:inset 0 1px 1px rgba(0,0,0,.075),0 0 6px #67b168;box-shadow:inset 0 1px 1px rgba(0,0,0,.075),0 0 6px #67b168}.has-success .input-group-addon{color:#3c763d;background-color:#dff0d8;border-color:#3c763d}.has-success .form-control-feedback{color:#3c763d}.has-warning .checkbox,.has-warning .checkbox-inline,.has-warning.checkbox-inline label,.has-warning.checkbox label,.has-warning .control-label,.has-warning .help-block,.has-warning .radio,.has-warning .radio-inline,.has-warning.radio-inline label,.has-warning.radio label{color:#8a6d3b}.has-warning .form-control{border-color:#8a6d3b;-webkit-box-shadow:inset 0 1px 1px rgba(0,0,0,.075);box-shadow:inset 0 1px 1px rgba(0,0,0,.075)}.has-warning .form-control:focus{border-color:#66512c;-webkit-box-shadow:inset 0 1px 1px rgba(0,0,0,.075),0 0 6px #c0a16b;box-shadow:inset 0 1px 1px rgba(0,0,0,.075),0 0 6px #c0a16b}.has-warning .input-group-addon{color:#8a6d3b;background-color:#fcf8e3;border-color:#8a6d3b}.has-warning .form-control-feedback{color:#8a6d3b}.has-error .checkbox,.has-error .checkbox-inline,.has-error.checkbox-inline label,.has-error.checkbox label,.has-error .control-label,.has-error .help-block,.has-error .radio,.has-error .radio-inline,.has-error.radio-inline label,.has-error.radio label{color:#a94442}.has-error .form-control{border-color:#a94442;-webkit-box-shadow:inset 0 1px 1px rgba(0,0,0,.075);box-shadow:inset 0 1px 1px rgba(0,0,0,.075)}.has-error .form-control:focus{border-color:#843534;-webkit-box-shadow:inset 0 1px 1px rgba(0,0,0,.075),0 0 6px #ce8483;box-shadow:inset 0 1px 1px rgba(0,0,0,.075),0 0 6px #ce8483}.has-error .input-group-addon{color:#a94442;background-color:#f2dede;border-color:#a94442}.has-error .form-control-feedback{color:#a94442}.has-feedback label~.form-control-feedback{top:25px}.has-feedback label.sr-only~.form-control-feedback{top:0}.help-block{display:block;margin-top:5px;margin-bottom:10px;color:#737373}@media (min-width:768px){.form-inline .form-group{display:inline-block;margin-bottom:0;vertical-align:middle}.form-inline .form-control{display:inline-block;width:auto;vertical-align:middle}.form-inline .form-control-static{display:inline-block}.form-inline .input-group{display:inline-table;vertical-align:middle}.form-inline .input-group .form-control,.form-inline .input-group .input-group-addon,.form-inline .input-group .input-group-btn{width:auto}.form-inline .input-group>.form-control{width:100%}.form-inline .control-label{margin-bottom:0;vertical-align:middle}.form-inline .checkbox,.form-inline .radio{display:inline-block;margin-top:0;margin-bottom:0;vertical-align:middle}.form-inline .checkbox label,.form-inline .radio label{padding-left:0}.form-inline .checkbox input[type=checkbox],.form-inline .radio input[type=radio]{position:relative;margin-left:0}.form-inline .has-feedback .form-control-feedback{top:0}}.form-horizontal .checkbox,.form-horizontal .checkbox-inline,.form-horizontal .radio,.form-horizontal .radio-inline{padding-top:7px;margin-top:0;margin-bottom:0}.form-horizontal .checkbox,.form-horizontal .radio{min-height:27px}.form-horizontal .form-group{margin-right:-15px;margin-left:-15px}@media (min-width:768px){.form-horizontal .control-label{padding-top:7px;margin-bottom:0;text-align:right}}.form-horizontal .has-feedback .form-control-feedback{right:15px}@media (min-width:768px){.form-horizontal .form-group-lg .control-label{padding-top:11px;font-size:18px}}@media (min-width:768px){.form-horizontal .form-group-sm .control-label{padding-top:6px;font-size:12px}}.btn{display:inline-block;padding:6px 12px;margin-bottom:0;font-size:14px;font-weight:400;line-height:1.42857143;text-align:center;white-space:nowrap;vertical-align:middle;-ms-touch-action:manipulation;touch-action:manipulation;cursor:pointer;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;background-image:none;border:1px solid transparent;border-radius:4px}.btn.active.focus,.btn.active:focus,.btn.focus,.btn:active.focus,.btn:active:focus,.btn:focus{outline:5px auto -webkit-focus-ring-color;outline-offset:-2px}.btn.focus,.btn:focus,.btn:hover{color:#333;text-decoration:none}.btn.active,.btn:active{background-image:none;outline:0;-webkit-box-shadow:inset 0 3px 5px rgba(0,0,0,.125);box-shadow:inset 0 3px 5px rgba(0,0,0,.125)}.btn.disabled,.btn[disabled],fieldset[disabled] .btn{cursor:not-allowed;filter:alpha(opacity=65);-webkit-box-shadow:none;box-shadow:none;opacity:.65}a.btn.disabled,fieldset[disabled] a.btn{pointer-events:none}.btn-default{color:#333;background-color:#fff;border-color:#ccc}.btn-default.focus,.btn-default:focus{color:#333;background-color:#e6e6e6;border-color:#8c8c8c}.btn-default.active,.btn-default:active,.btn-default:hover,.open>.dropdown-toggle.btn-default{color:#333;background-color:#e6e6e6;border-color:#adadad}.btn-default.active.focus,.btn-default.active:focus,.btn-default.active:hover,.btn-default:active.focus,.btn-default:active:focus,.btn-default:active:hover,.open>.dropdown-toggle.btn-default.focus,.open>.dropdown-toggle.btn-default:focus,.open>.dropdown-toggle.btn-default:hover{color:#333;background-color:#d4d4d4;border-color:#8c8c8c}.btn-default.active,.btn-default:active,.open>.dropdown-toggle.btn-default{background-image:none}.btn-default.disabled.focus,.btn-default.disabled:focus,.btn-default.disabled:hover,.btn-default[disabled].focus,.btn-default[disabled]:focus,.btn-default[disabled]:hover,fieldset[disabled] .btn-default.focus,fieldset[disabled] .btn-default:focus,fieldset[disabled] .btn-default:hover{background-color:#fff;border-color:#ccc}.btn-default .badge{color:#fff;background-color:#333}.btn-primary{color:#fff;background-color:#337ab7;border-color:#2e6da4}.btn-primary.focus,.btn-primary:focus{color:#fff;background-color:#286090;border-color:#122b40}.btn-primary.active,.btn-primary:active,.btn-primary:hover,.open>.dropdown-toggle.btn-primary{color:#fff;background-color:#286090;border-color:#204d74}.btn-primary.active.focus,.btn-primary.active:focus,.btn-primary.active:hover,.btn-primary:active.focus,.btn-primary:active:focus,.btn-primary:active:hover,.open>.dropdown-toggle.btn-primary.focus,.open>.dropdown-toggle.btn-primary:focus,.open>.dropdown-toggle.btn-primary:hover{color:#fff;background-color:#204d74;border-color:#122b40}.btn-primary.active,.btn-primary:active,.open>.dropdown-toggle.btn-primary{background-image:none}.btn-primary.disabled.focus,.btn-primary.disabled:focus,.btn-primary.disabled:hover,.btn-primary[disabled].focus,.btn-primary[disabled]:focus,.btn-primary[disabled]:hover,fieldset[disabled] .btn-primary.focus,fieldset[disabled] .btn-primary:focus,fieldset[disabled] .btn-primary:hover{background-color:#337ab7;border-color:#2e6da4}.btn-primary .badge{color:#337ab7;background-color:#fff}.btn-success{color:#fff;background-color:#5cb85c;border-color:#4cae4c}.btn-success.focus,.btn-success:focus{color:#fff;background-color:#449d44;border-color:#255625}.btn-success.active,.btn-success:active,.btn-success:hover,.open>.dropdown-toggle.btn-success{color:#fff;background-color:#449d44;border-color:#398439}.btn-success.active.focus,.btn-success.active:focus,.btn-success.active:hover,.btn-success:active.focus,.btn-success:active:focus,.btn-success:active:hover,.open>.dropdown-toggle.btn-success.focus,.open>.dropdown-toggle.btn-success:focus,.open>.dropdown-toggle.btn-success:hover{color:#fff;background-color:#398439;border-color:#255625}.btn-success.active,.btn-success:active,.open>.dropdown-toggle.btn-success{background-image:none}.btn-success.disabled.focus,.btn-success.disabled:focus,.btn-success.disabled:hover,.btn-success[disabled].focus,.btn-success[disabled]:focus,.btn-success[disabled]:hover,fieldset[disabled] .btn-success.focus,fieldset[disabled] .btn-success:focus,fieldset[disabled] .btn-success:hover{background-color:#5cb85c;border-color:#4cae4c}.btn-success .badge{color:#5cb85c;background-color:#fff}.btn-info{color:#fff;background-color:#5bc0de;border-color:#46b8da}.btn-info.focus,.btn-info:focus{color:#fff;background-color:#31b0d5;border-color:#1b6d85}.btn-info.active,.btn-info:active,.btn-info:hover,.open>.dropdown-toggle.btn-info{color:#fff;background-color:#31b0d5;border-color:#269abc}.btn-info.active.focus,.btn-info.active:focus,.btn-info.active:hover,.btn-info:active.focus,.btn-info:active:focus,.btn-info:active:hover,.open>.dropdown-toggle.btn-info.focus,.open>.dropdown-toggle.btn-info:focus,.open>.dropdown-toggle.btn-info:hover{color:#fff;background-color:#269abc;border-color:#1b6d85}.btn-info.active,.btn-info:active,.open>.dropdown-toggle.btn-info{background-image:none}.btn-info.disabled.focus,.btn-info.disabled:focus,.btn-info.disabled:hover,.btn-info[disabled].focus,.btn-info[disabled]:focus,.btn-info[disabled]:hover,fieldset[disabled] .btn-info.focus,fieldset[disabled] .btn-info:focus,fieldset[disabled] .btn-info:hover{background-color:#5bc0de;border-color:#46b8da}.btn-info .badge{color:#5bc0de;background-color:#fff}.btn-warning{color:#fff;background-color:#f0ad4e;border-color:#eea236}.btn-warning.focus,.btn-warning:focus{color:#fff;background-color:#ec971f;border-color:#985f0d}.btn-warning.active,.btn-warning:active,.btn-warning:hover,.open>.dropdown-toggle.btn-warning{color:#fff;background-color:#ec971f;border-color:#d58512}.btn-warning.active.focus,.btn-warning.active:focus,.btn-warning.active:hover,.btn-warning:active.focus,.btn-warning:active:focus,.btn-warning:active:hover,.open>.dropdown-toggle.btn-warning.focus,.open>.dropdown-toggle.btn-warning:focus,.open>.dropdown-toggle.btn-warning:hover{color:#fff;background-color:#d58512;border-color:#985f0d}.btn-warning.active,.btn-warning:active,.open>.dropdown-toggle.btn-warning{background-image:none}.btn-warning.disabled.focus,.btn-warning.disabled:focus,.btn-warning.disabled:hover,.btn-warning[disabled].focus,.btn-warning[disabled]:focus,.btn-warning[disabled]:hover,fieldset[disabled] .btn-warning.focus,fieldset[disabled] .btn-warning:focus,fieldset[disabled] .btn-warning:hover{background-color:#f0ad4e;border-color:#eea236}.btn-warning .badge{color:#f0ad4e;background-color:#fff}.btn-danger{color:#fff;background-color:#d9534f;border-color:#d43f3a}.btn-danger.focus,.btn-danger:focus{color:#fff;background-color:#c9302c;border-color:#761c19}.btn-danger.active,.btn-danger:active,.btn-danger:hover,.open>.dropdown-toggle.btn-danger{color:#fff;background-color:#c9302c;border-color:#ac2925}.btn-danger.active.focus,.btn-danger.active:focus,.btn-danger.active:hover,.btn-danger:active.focus,.btn-danger:active:focus,.btn-danger:active:hover,.open>.dropdown-toggle.btn-danger.focus,.open>.dropdown-toggle.btn-danger:focus,.open>.dropdown-toggle.btn-danger:hover{color:#fff;background-color:#ac2925;border-color:#761c19}.btn-danger.active,.btn-danger:active,.open>.dropdown-toggle.btn-danger{background-image:none}.btn-danger.disabled.focus,.btn-danger.disabled:focus,.btn-danger.disabled:hover,.btn-danger[disabled].focus,.btn-danger[disabled]:focus,.btn-danger[disabled]:hover,fieldset[disabled] .btn-danger.focus,fieldset[disabled] .btn-danger:focus,fieldset[disabled] .btn-danger:hover{background-color:#d9534f;border-color:#d43f3a}.btn-danger .badge{color:#d9534f;background-color:#fff}.btn-link{font-weight:400;color:#337ab7;border-radius:0}.btn-link,.btn-link.active,.btn-link:active,.btn-link[disabled],fieldset[disabled] .btn-link{background-color:transparent;-webkit-box-shadow:none;box-shadow:none}.btn-link,.btn-link:active,.btn-link:focus,.btn-link:hover{border-color:transparent}.btn-link:focus,.btn-link:hover{color:#23527c;text-decoration:underline;background-color:transparent}.btn-link[disabled]:focus,.btn-link[disabled]:hover,fieldset[disabled] .btn-link:focus,fieldset[disabled] .btn-link:hover{color:#777;text-decoration:none}.btn-group-lg>.btn,.btn-lg{padding:10px 16px;font-size:18px;line-height:1.3333333;border-radius:6px}.btn-group-sm>.btn,.btn-sm{padding:5px 10px;font-size:12px;line-height:1.5;border-radius:3px}.btn-group-xs>.btn,.btn-xs{padding:1px 5px;font-size:12px;line-height:1.5;border-radius:3px}.btn-block{display:block;width:100%}.btn-block+.btn-block{margin-top:5px}input[type=button].btn-block,input[type=reset].btn-block,input[type=submit].btn-block{width:100%}.fade{opacity:0;-webkit-transition:opacity .15s linear;-o-transition:opacity .15s linear;transition:opacity .15s linear}.fade.in{opacity:1}.collapse{display:none}.collapse.in{display:block}tr.collapse.in{display:table-row}tbody.collapse.in{display:table-row-group}.collapsing{position:relative;height:0;overflow:hidden;-webkit-transition-timing-function:ease;-o-transition-timing-function:ease;transition-timing-function:ease;-webkit-transition-duration:.35s;-o-transition-duration:.35s;transition-duration:.35s;-webkit-transition-property:height,visibility;-o-transition-property:height,visibility;transition-property:height,visibility}.caret{display:inline-block;width:0;height:0;margin-left:2px;vertical-align:middle;border-top:4px dashed;border-top:4px solid\\9;border-right:4px solid transparent;border-left:4px solid transparent}.dropdown,.dropup{position:relative}.dropdown-toggle:focus{outline:0}.dropdown-menu{position:absolute;top:100%;left:0;z-index:1000;display:none;float:left;min-width:160px;padding:5px 0;margin:2px 0 0;font-size:14px;text-align:left;list-style:none;background-color:#fff;-webkit-background-clip:padding-box;background-clip:padding-box;border:1px solid #ccc;border:1px solid rgba(0,0,0,.15);border-radius:4px;-webkit-box-shadow:0 6px 12px rgba(0,0,0,.175);box-shadow:0 6px 12px rgba(0,0,0,.175)}.dropdown-menu.pull-right{right:0;left:auto}.dropdown-menu .divider{height:1px;margin:9px 0;overflow:hidden;background-color:#e5e5e5}.dropdown-menu>li>a{display:block;padding:3px 20px;clear:both;font-weight:400;line-height:1.42857143;color:#333;white-space:nowrap}.dropdown-menu>li>a:focus,.dropdown-menu>li>a:hover{color:#262626;text-decoration:none;background-color:#f5f5f5}.dropdown-menu>.active>a,.dropdown-menu>.active>a:focus,.dropdown-menu>.active>a:hover{color:#fff;text-decoration:none;background-color:#337ab7;outline:0}.dropdown-menu>.disabled>a,.dropdown-menu>.disabled>a:focus,.dropdown-menu>.disabled>a:hover{color:#777}.dropdown-menu>.disabled>a:focus,.dropdown-menu>.disabled>a:hover{text-decoration:none;cursor:not-allowed;background-color:transparent;background-image:none;filter:progid:DXImageTransform.Microsoft.gradient(enabled=false)}.open>.dropdown-menu{display:block}.open>a{outline:0}.dropdown-menu-right{right:0;left:auto}.dropdown-menu-left{right:auto;left:0}.dropdown-header{display:block;padding:3px 20px;font-size:12px;line-height:1.42857143;color:#777;white-space:nowrap}.dropdown-backdrop{position:fixed;top:0;right:0;bottom:0;left:0;z-index:990}.pull-right>.dropdown-menu{right:0;left:auto}.dropup .caret,.navbar-fixed-bottom .dropdown .caret{content:\"\";border-top:0;border-bottom:4px dashed;border-bottom:4px solid\\9}.dropup .dropdown-menu,.navbar-fixed-bottom .dropdown .dropdown-menu{top:auto;bottom:100%;margin-bottom:2px}@media (min-width:768px){.navbar-right .dropdown-menu{right:0;left:auto}.navbar-right .dropdown-menu-left{right:auto;left:0}}.btn-group,.btn-group-vertical{position:relative;display:inline-block;vertical-align:middle}.btn-group-vertical>.btn,.btn-group>.btn{position:relative;float:left}.btn-group-vertical>.btn.active,.btn-group-vertical>.btn:active,.btn-group-vertical>.btn:focus,.btn-group-vertical>.btn:hover,.btn-group>.btn.active,.btn-group>.btn:active,.btn-group>.btn:focus,.btn-group>.btn:hover{z-index:2}.btn-group .btn+.btn,.btn-group .btn+.btn-group,.btn-group .btn-group+.btn,.btn-group .btn-group+.btn-group{margin-left:-1px}.btn-toolbar{margin-left:-5px}.btn-toolbar .btn,.btn-toolbar .btn-group,.btn-toolbar .input-group{float:left}.btn-toolbar>.btn,.btn-toolbar>.btn-group,.btn-toolbar>.input-group{margin-left:5px}.btn-group>.btn:not(:first-child):not(:last-child):not(.dropdown-toggle){border-radius:0}.btn-group>.btn:first-child{margin-left:0}.btn-group>.btn:first-child:not(:last-child):not(.dropdown-toggle){border-top-right-radius:0;border-bottom-right-radius:0}.btn-group>.btn:last-child:not(:first-child),.btn-group>.dropdown-toggle:not(:first-child){border-top-left-radius:0;border-bottom-left-radius:0}.btn-group>.btn-group{float:left}.btn-group>.btn-group:not(:first-child):not(:last-child)>.btn{border-radius:0}.btn-group>.btn-group:first-child:not(:last-child)>.btn:last-child,.btn-group>.btn-group:first-child:not(:last-child)>.dropdown-toggle{border-top-right-radius:0;border-bottom-right-radius:0}.btn-group>.btn-group:last-child:not(:first-child)>.btn:first-child{border-top-left-radius:0;border-bottom-left-radius:0}.btn-group .dropdown-toggle:active,.btn-group.open .dropdown-toggle{outline:0}.btn-group>.btn+.dropdown-toggle{padding-right:8px;padding-left:8px}.btn-group>.btn-lg+.dropdown-toggle{padding-right:12px;padding-left:12px}.btn-group.open .dropdown-toggle{-webkit-box-shadow:inset 0 3px 5px rgba(0,0,0,.125);box-shadow:inset 0 3px 5px rgba(0,0,0,.125)}.btn-group.open .dropdown-toggle.btn-link{-webkit-box-shadow:none;box-shadow:none}.btn .caret{margin-left:0}.btn-lg .caret{border-width:5px 5px 0;border-bottom-width:0}.dropup .btn-lg .caret{border-width:0 5px 5px}.btn-group-vertical>.btn,.btn-group-vertical>.btn-group,.btn-group-vertical>.btn-group>.btn{display:block;float:none;width:100%;max-width:100%}.btn-group-vertical>.btn-group>.btn{float:none}.btn-group-vertical>.btn+.btn,.btn-group-vertical>.btn+.btn-group,.btn-group-vertical>.btn-group+.btn,.btn-group-vertical>.btn-group+.btn-group{margin-top:-1px;margin-left:0}.btn-group-vertical>.btn:not(:first-child):not(:last-child){border-radius:0}.btn-group-vertical>.btn:first-child:not(:last-child){border-top-left-radius:4px;border-top-right-radius:4px;border-bottom-right-radius:0;border-bottom-left-radius:0}.btn-group-vertical>.btn:last-child:not(:first-child){border-top-left-radius:0;border-top-right-radius:0;border-bottom-right-radius:4px;border-bottom-left-radius:4px}.btn-group-vertical>.btn-group:not(:first-child):not(:last-child)>.btn{border-radius:0}.btn-group-vertical>.btn-group:first-child:not(:last-child)>.btn:last-child,.btn-group-vertical>.btn-group:first-child:not(:last-child)>.dropdown-toggle{border-bottom-right-radius:0;border-bottom-left-radius:0}.btn-group-vertical>.btn-group:last-child:not(:first-child)>.btn:first-child{border-top-left-radius:0;border-top-right-radius:0}.btn-group-justified{display:table;width:100%;table-layout:fixed;border-collapse:separate}.btn-group-justified>.btn,.btn-group-justified>.btn-group{display:table-cell;float:none;width:1%}.btn-group-justified>.btn-group .btn{width:100%}.btn-group-justified>.btn-group .dropdown-menu{left:auto}[data-toggle=buttons]>.btn-group>.btn input[type=checkbox],[data-toggle=buttons]>.btn-group>.btn input[type=radio],[data-toggle=buttons]>.btn input[type=checkbox],[data-toggle=buttons]>.btn input[type=radio]{position:absolute;clip:rect(0,0,0,0);pointer-events:none}.input-group{position:relative;display:table;border-collapse:separate}.input-group[class*=col-]{float:none;padding-right:0;padding-left:0}.input-group .form-control{position:relative;z-index:2;float:left;width:100%;margin-bottom:0}.input-group .form-control:focus{z-index:3}.input-group-lg>.form-control,.input-group-lg>.input-group-addon,.input-group-lg>.input-group-btn>.btn{height:46px;padding:10px 16px;font-size:18px;line-height:1.3333333;border-radius:6px}select.input-group-lg>.form-control,select.input-group-lg>.input-group-addon,select.input-group-lg>.input-group-btn>.btn{height:46px;line-height:46px}select[multiple].input-group-lg>.form-control,select[multiple].input-group-lg>.input-group-addon,select[multiple].input-group-lg>.input-group-btn>.btn,textarea.input-group-lg>.form-control,textarea.input-group-lg>.input-group-addon,textarea.input-group-lg>.input-group-btn>.btn{height:auto}.input-group-sm>.form-control,.input-group-sm>.input-group-addon,.input-group-sm>.input-group-btn>.btn{height:30px;padding:5px 10px;font-size:12px;line-height:1.5;border-radius:3px}select.input-group-sm>.form-control,select.input-group-sm>.input-group-addon,select.input-group-sm>.input-group-btn>.btn{height:30px;line-height:30px}select[multiple].input-group-sm>.form-control,select[multiple].input-group-sm>.input-group-addon,select[multiple].input-group-sm>.input-group-btn>.btn,textarea.input-group-sm>.form-control,textarea.input-group-sm>.input-group-addon,textarea.input-group-sm>.input-group-btn>.btn{height:auto}.input-group-addon,.input-group-btn,.input-group .form-control{display:table-cell}.input-group-addon:not(:first-child):not(:last-child),.input-group-btn:not(:first-child):not(:last-child),.input-group .form-control:not(:first-child):not(:last-child){border-radius:0}.input-group-addon,.input-group-btn{width:1%;white-space:nowrap;vertical-align:middle}.input-group-addon{padding:6px 12px;font-size:14px;font-weight:400;line-height:1;color:#555;text-align:center;background-color:#eee;border:1px solid #ccc;border-radius:4px}.input-group-addon.input-sm{padding:5px 10px;font-size:12px;border-radius:3px}.input-group-addon.input-lg{padding:10px 16px;font-size:18px;border-radius:6px}.input-group-addon input[type=checkbox],.input-group-addon input[type=radio]{margin-top:0}.input-group-addon:first-child,.input-group-btn:first-child>.btn,.input-group-btn:first-child>.btn-group>.btn,.input-group-btn:first-child>.dropdown-toggle,.input-group-btn:last-child>.btn-group:not(:last-child)>.btn,.input-group-btn:last-child>.btn:not(:last-child):not(.dropdown-toggle),.input-group .form-control:first-child{border-top-right-radius:0;border-bottom-right-radius:0}.input-group-addon:first-child{border-right:0}.input-group-addon:last-child,.input-group-btn:first-child>.btn-group:not(:first-child)>.btn,.input-group-btn:first-child>.btn:not(:first-child),.input-group-btn:last-child>.btn,.input-group-btn:last-child>.btn-group>.btn,.input-group-btn:last-child>.dropdown-toggle,.input-group .form-control:last-child{border-top-left-radius:0;border-bottom-left-radius:0}.input-group-addon:last-child{border-left:0}.input-group-btn{font-size:0;white-space:nowrap}.input-group-btn,.input-group-btn>.btn{position:relative}.input-group-btn>.btn+.btn{margin-left:-1px}.input-group-btn>.btn:active,.input-group-btn>.btn:focus,.input-group-btn>.btn:hover{z-index:2}.input-group-btn:first-child>.btn,.input-group-btn:first-child>.btn-group{margin-right:-1px}.input-group-btn:last-child>.btn,.input-group-btn:last-child>.btn-group{z-index:2;margin-left:-1px}.nav{padding-left:0;margin-bottom:0;list-style:none}.nav>li,.nav>li>a{position:relative;display:block}.nav>li>a{padding:10px 15px}.nav>li>a:focus,.nav>li>a:hover{text-decoration:none;background-color:#eee}.nav>li.disabled>a{color:#777}.nav>li.disabled>a:focus,.nav>li.disabled>a:hover{color:#777;text-decoration:none;cursor:not-allowed;background-color:transparent}.nav .open>a,.nav .open>a:focus,.nav .open>a:hover{background-color:#eee;border-color:#337ab7}.nav .nav-divider{height:1px;margin:9px 0;overflow:hidden;background-color:#e5e5e5}.nav>li>a>img{max-width:none}.nav-tabs{border-bottom:1px solid #ddd}.nav-tabs>li{float:left;margin-bottom:-1px}.nav-tabs>li>a{margin-right:2px;line-height:1.42857143;border:1px solid transparent;border-radius:4px 4px 0 0}.nav-tabs>li>a:hover{border-color:#eee #eee #ddd}.nav-tabs>li.active>a,.nav-tabs>li.active>a:focus,.nav-tabs>li.active>a:hover{color:#555;cursor:default;background-color:#fff;border:1px solid #ddd;border-bottom-color:transparent}.nav-tabs.nav-justified{width:100%;border-bottom:0}.nav-tabs.nav-justified>li{float:none}.nav-tabs.nav-justified>li>a{margin-bottom:5px;text-align:center}.nav-tabs.nav-justified>.dropdown .dropdown-menu{top:auto;left:auto}@media (min-width:768px){.nav-tabs.nav-justified>li{display:table-cell;width:1%}.nav-tabs.nav-justified>li>a{margin-bottom:0}}.nav-tabs.nav-justified>li>a{margin-right:0;border-radius:4px}.nav-tabs.nav-justified>.active>a,.nav-tabs.nav-justified>.active>a:focus,.nav-tabs.nav-justified>.active>a:hover{border:1px solid #ddd}@media (min-width:768px){.nav-tabs.nav-justified>li>a{border-bottom:1px solid #ddd;border-radius:4px 4px 0 0}.nav-tabs.nav-justified>.active>a,.nav-tabs.nav-justified>.active>a:focus,.nav-tabs.nav-justified>.active>a:hover{border-bottom-color:#fff}}.nav-pills>li{float:left}.nav-pills>li>a{border-radius:4px}.nav-pills>li+li{margin-left:2px}.nav-pills>li.active>a,.nav-pills>li.active>a:focus,.nav-pills>li.active>a:hover{color:#fff;background-color:#337ab7}.nav-stacked>li{float:none}.nav-stacked>li+li{margin-top:2px;margin-left:0}.nav-justified{width:100%}.nav-justified>li{float:none}.nav-justified>li>a{margin-bottom:5px;text-align:center}.nav-justified>.dropdown .dropdown-menu{top:auto;left:auto}@media (min-width:768px){.nav-justified>li{display:table-cell;width:1%}.nav-justified>li>a{margin-bottom:0}}.nav-tabs-justified{border-bottom:0}.nav-tabs-justified>li>a{margin-right:0;border-radius:4px}.nav-tabs-justified>.active>a,.nav-tabs-justified>.active>a:focus,.nav-tabs-justified>.active>a:hover{border:1px solid #ddd}@media (min-width:768px){.nav-tabs-justified>li>a{border-bottom:1px solid #ddd;border-radius:4px 4px 0 0}.nav-tabs-justified>.active>a,.nav-tabs-justified>.active>a:focus,.nav-tabs-justified>.active>a:hover{border-bottom-color:#fff}}.tab-content>.tab-pane{display:none}.tab-content>.active{display:block}.nav-tabs .dropdown-menu{margin-top:-1px;border-top-left-radius:0;border-top-right-radius:0}.navbar{position:relative;min-height:50px;margin-bottom:20px;border:1px solid transparent}@media (min-width:768px){.navbar{border-radius:4px}}@media (min-width:768px){.navbar-header{float:left}}.navbar-collapse{padding-right:15px;padding-left:15px;overflow-x:visible;-webkit-overflow-scrolling:touch;border-top:1px solid transparent;-webkit-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.1);box-shadow:inset 0 1px 0 hsla(0,0%,100%,.1)}.navbar-collapse.in{overflow-y:auto}@media (min-width:768px){.navbar-collapse{width:auto;border-top:0;-webkit-box-shadow:none;box-shadow:none}.navbar-collapse.collapse{display:block!important;height:auto!important;padding-bottom:0;overflow:visible!important}.navbar-collapse.in{overflow-y:visible}.navbar-fixed-bottom .navbar-collapse,.navbar-fixed-top .navbar-collapse,.navbar-static-top .navbar-collapse{padding-right:0;padding-left:0}}.navbar-fixed-bottom .navbar-collapse,.navbar-fixed-top .navbar-collapse{max-height:340px}@media (max-device-width:480px) and (orientation:landscape){.navbar-fixed-bottom .navbar-collapse,.navbar-fixed-top .navbar-collapse{max-height:200px}}.container-fluid>.navbar-collapse,.container-fluid>.navbar-header,.container>.navbar-collapse,.container>.navbar-header{margin-right:-15px;margin-left:-15px}@media (min-width:768px){.container-fluid>.navbar-collapse,.container-fluid>.navbar-header,.container>.navbar-collapse,.container>.navbar-header{margin-right:0;margin-left:0}}.navbar-static-top{z-index:1000;border-width:0 0 1px}@media (min-width:768px){.navbar-static-top{border-radius:0}}.navbar-fixed-bottom,.navbar-fixed-top{position:fixed;right:0;left:0;z-index:1030}@media (min-width:768px){.navbar-fixed-bottom,.navbar-fixed-top{border-radius:0}}.navbar-fixed-top{top:0;border-width:0 0 1px}.navbar-fixed-bottom{bottom:0;margin-bottom:0;border-width:1px 0 0}.navbar-brand{float:left;height:50px;padding:15px;font-size:18px;line-height:20px}.navbar-brand:focus,.navbar-brand:hover{text-decoration:none}.navbar-brand>img{display:block}@media (min-width:768px){.navbar>.container-fluid .navbar-brand,.navbar>.container .navbar-brand{margin-left:-15px}}.navbar-toggle{position:relative;float:right;padding:9px 10px;margin-top:8px;margin-right:15px;margin-bottom:8px;background-color:transparent;background-image:none;border:1px solid transparent;border-radius:4px}.navbar-toggle:focus{outline:0}.navbar-toggle .icon-bar{display:block;width:22px;height:2px;border-radius:1px}.navbar-toggle .icon-bar+.icon-bar{margin-top:4px}@media (min-width:768px){.navbar-toggle{display:none}}.navbar-nav{margin:7.5px -15px}.navbar-nav>li>a{padding-top:10px;padding-bottom:10px;line-height:20px}@media (max-width:767px){.navbar-nav .open .dropdown-menu{position:static;float:none;width:auto;margin-top:0;background-color:transparent;border:0;-webkit-box-shadow:none;box-shadow:none}.navbar-nav .open .dropdown-menu .dropdown-header,.navbar-nav .open .dropdown-menu>li>a{padding:5px 15px 5px 25px}.navbar-nav .open .dropdown-menu>li>a{line-height:20px}.navbar-nav .open .dropdown-menu>li>a:focus,.navbar-nav .open .dropdown-menu>li>a:hover{background-image:none}}@media (min-width:768px){.navbar-nav{float:left;margin:0}.navbar-nav>li{float:left}.navbar-nav>li>a{padding-top:15px;padding-bottom:15px}}.navbar-form{padding:10px 15px;margin:8px -15px;border-top:1px solid transparent;border-bottom:1px solid transparent;-webkit-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.1),0 1px 0 hsla(0,0%,100%,.1);box-shadow:inset 0 1px 0 hsla(0,0%,100%,.1),0 1px 0 hsla(0,0%,100%,.1)}@media (min-width:768px){.navbar-form .form-group{display:inline-block;margin-bottom:0;vertical-align:middle}.navbar-form .form-control{display:inline-block;width:auto;vertical-align:middle}.navbar-form .form-control-static{display:inline-block}.navbar-form .input-group{display:inline-table;vertical-align:middle}.navbar-form .input-group .form-control,.navbar-form .input-group .input-group-addon,.navbar-form .input-group .input-group-btn{width:auto}.navbar-form .input-group>.form-control{width:100%}.navbar-form .control-label{margin-bottom:0;vertical-align:middle}.navbar-form .checkbox,.navbar-form .radio{display:inline-block;margin-top:0;margin-bottom:0;vertical-align:middle}.navbar-form .checkbox label,.navbar-form .radio label{padding-left:0}.navbar-form .checkbox input[type=checkbox],.navbar-form .radio input[type=radio]{position:relative;margin-left:0}.navbar-form .has-feedback .form-control-feedback{top:0}}@media (max-width:767px){.navbar-form .form-group{margin-bottom:5px}.navbar-form .form-group:last-child{margin-bottom:0}}@media (min-width:768px){.navbar-form{width:auto;padding-top:0;padding-bottom:0;margin-right:0;margin-left:0;border:0;-webkit-box-shadow:none;box-shadow:none}}.navbar-nav>li>.dropdown-menu{margin-top:0;border-top-left-radius:0;border-top-right-radius:0}.navbar-fixed-bottom .navbar-nav>li>.dropdown-menu{margin-bottom:0;border-top-left-radius:4px;border-top-right-radius:4px;border-bottom-right-radius:0;border-bottom-left-radius:0}.navbar-btn{margin-top:8px;margin-bottom:8px}.navbar-btn.btn-sm{margin-top:10px;margin-bottom:10px}.navbar-btn.btn-xs{margin-top:14px;margin-bottom:14px}.navbar-text{margin-top:15px;margin-bottom:15px}@media (min-width:768px){.navbar-text{float:left;margin-right:15px;margin-left:15px}}@media (min-width:768px){.navbar-left{float:left!important}.navbar-right{float:right!important;margin-right:-15px}.navbar-right~.navbar-right{margin-right:0}}.navbar-default{background-color:#f8f8f8;border-color:#e7e7e7}.navbar-default .navbar-brand{color:#777}.navbar-default .navbar-brand:focus,.navbar-default .navbar-brand:hover{color:#5e5e5e;background-color:transparent}.navbar-default .navbar-nav>li>a,.navbar-default .navbar-text{color:#777}.navbar-default .navbar-nav>li>a:focus,.navbar-default .navbar-nav>li>a:hover{color:#333;background-color:transparent}.navbar-default .navbar-nav>.active>a,.navbar-default .navbar-nav>.active>a:focus,.navbar-default .navbar-nav>.active>a:hover{color:#555;background-color:#e7e7e7}.navbar-default .navbar-nav>.disabled>a,.navbar-default .navbar-nav>.disabled>a:focus,.navbar-default .navbar-nav>.disabled>a:hover{color:#ccc;background-color:transparent}.navbar-default .navbar-toggle{border-color:#ddd}.navbar-default .navbar-toggle:focus,.navbar-default .navbar-toggle:hover{background-color:#ddd}.navbar-default .navbar-toggle .icon-bar{background-color:#888}.navbar-default .navbar-collapse,.navbar-default .navbar-form{border-color:#e7e7e7}.navbar-default .navbar-nav>.open>a,.navbar-default .navbar-nav>.open>a:focus,.navbar-default .navbar-nav>.open>a:hover{color:#555;background-color:#e7e7e7}@media (max-width:767px){.navbar-default .navbar-nav .open .dropdown-menu>li>a{color:#777}.navbar-default .navbar-nav .open .dropdown-menu>li>a:focus,.navbar-default .navbar-nav .open .dropdown-menu>li>a:hover{color:#333;background-color:transparent}.navbar-default .navbar-nav .open .dropdown-menu>.active>a,.navbar-default .navbar-nav .open .dropdown-menu>.active>a:focus,.navbar-default .navbar-nav .open .dropdown-menu>.active>a:hover{color:#555;background-color:#e7e7e7}.navbar-default .navbar-nav .open .dropdown-menu>.disabled>a,.navbar-default .navbar-nav .open .dropdown-menu>.disabled>a:focus,.navbar-default .navbar-nav .open .dropdown-menu>.disabled>a:hover{color:#ccc;background-color:transparent}}.navbar-default .navbar-link{color:#777}.navbar-default .navbar-link:hover{color:#333}.navbar-default .btn-link{color:#777}.navbar-default .btn-link:focus,.navbar-default .btn-link:hover{color:#333}.navbar-default .btn-link[disabled]:focus,.navbar-default .btn-link[disabled]:hover,fieldset[disabled] .navbar-default .btn-link:focus,fieldset[disabled] .navbar-default .btn-link:hover{color:#ccc}.navbar-inverse{background-color:#222;border-color:#080808}.navbar-inverse .navbar-brand{color:#9d9d9d}.navbar-inverse .navbar-brand:focus,.navbar-inverse .navbar-brand:hover{color:#fff;background-color:transparent}.navbar-inverse .navbar-nav>li>a,.navbar-inverse .navbar-text{color:#9d9d9d}.navbar-inverse .navbar-nav>li>a:focus,.navbar-inverse .navbar-nav>li>a:hover{color:#fff;background-color:transparent}.navbar-inverse .navbar-nav>.active>a,.navbar-inverse .navbar-nav>.active>a:focus,.navbar-inverse .navbar-nav>.active>a:hover{color:#fff;background-color:#080808}.navbar-inverse .navbar-nav>.disabled>a,.navbar-inverse .navbar-nav>.disabled>a:focus,.navbar-inverse .navbar-nav>.disabled>a:hover{color:#444;background-color:transparent}.navbar-inverse .navbar-toggle{border-color:#333}.navbar-inverse .navbar-toggle:focus,.navbar-inverse .navbar-toggle:hover{background-color:#333}.navbar-inverse .navbar-toggle .icon-bar{background-color:#fff}.navbar-inverse .navbar-collapse,.navbar-inverse .navbar-form{border-color:#101010}.navbar-inverse .navbar-nav>.open>a,.navbar-inverse .navbar-nav>.open>a:focus,.navbar-inverse .navbar-nav>.open>a:hover{color:#fff;background-color:#080808}@media (max-width:767px){.navbar-inverse .navbar-nav .open .dropdown-menu>.dropdown-header{border-color:#080808}.navbar-inverse .navbar-nav .open .dropdown-menu .divider{background-color:#080808}.navbar-inverse .navbar-nav .open .dropdown-menu>li>a{color:#9d9d9d}.navbar-inverse .navbar-nav .open .dropdown-menu>li>a:focus,.navbar-inverse .navbar-nav .open .dropdown-menu>li>a:hover{color:#fff;background-color:transparent}.navbar-inverse .navbar-nav .open .dropdown-menu>.active>a,.navbar-inverse .navbar-nav .open .dropdown-menu>.active>a:focus,.navbar-inverse .navbar-nav .open .dropdown-menu>.active>a:hover{color:#fff;background-color:#080808}.navbar-inverse .navbar-nav .open .dropdown-menu>.disabled>a,.navbar-inverse .navbar-nav .open .dropdown-menu>.disabled>a:focus,.navbar-inverse .navbar-nav .open .dropdown-menu>.disabled>a:hover{color:#444;background-color:transparent}}.navbar-inverse .navbar-link{color:#9d9d9d}.navbar-inverse .navbar-link:hover{color:#fff}.navbar-inverse .btn-link{color:#9d9d9d}.navbar-inverse .btn-link:focus,.navbar-inverse .btn-link:hover{color:#fff}.navbar-inverse .btn-link[disabled]:focus,.navbar-inverse .btn-link[disabled]:hover,fieldset[disabled] .navbar-inverse .btn-link:focus,fieldset[disabled] .navbar-inverse .btn-link:hover{color:#444}.breadcrumb{padding:8px 15px;margin-bottom:20px;list-style:none;background-color:#f5f5f5;border-radius:4px}.breadcrumb>li{display:inline-block}.breadcrumb>li+li:before{padding:0 5px;color:#ccc;content:\"/\\A0\"}.breadcrumb>.active{color:#777}.pagination{display:inline-block;padding-left:0;margin:20px 0;border-radius:4px}.pagination>li{display:inline}.pagination>li>a,.pagination>li>span{position:relative;float:left;padding:6px 12px;margin-left:-1px;line-height:1.42857143;color:#337ab7;text-decoration:none;background-color:#fff;border:1px solid #ddd}.pagination>li:first-child>a,.pagination>li:first-child>span{margin-left:0;border-top-left-radius:4px;border-bottom-left-radius:4px}.pagination>li:last-child>a,.pagination>li:last-child>span{border-top-right-radius:4px;border-bottom-right-radius:4px}.pagination>li>a:focus,.pagination>li>a:hover,.pagination>li>span:focus,.pagination>li>span:hover{z-index:2;color:#23527c;background-color:#eee;border-color:#ddd}.pagination>.active>a,.pagination>.active>a:focus,.pagination>.active>a:hover,.pagination>.active>span,.pagination>.active>span:focus,.pagination>.active>span:hover{z-index:3;color:#fff;cursor:default;background-color:#337ab7;border-color:#337ab7}.pagination>.disabled>a,.pagination>.disabled>a:focus,.pagination>.disabled>a:hover,.pagination>.disabled>span,.pagination>.disabled>span:focus,.pagination>.disabled>span:hover{color:#777;cursor:not-allowed;background-color:#fff;border-color:#ddd}.pagination-lg>li>a,.pagination-lg>li>span{padding:10px 16px;font-size:18px;line-height:1.3333333}.pagination-lg>li:first-child>a,.pagination-lg>li:first-child>span{border-top-left-radius:6px;border-bottom-left-radius:6px}.pagination-lg>li:last-child>a,.pagination-lg>li:last-child>span{border-top-right-radius:6px;border-bottom-right-radius:6px}.pagination-sm>li>a,.pagination-sm>li>span{padding:5px 10px;font-size:12px;line-height:1.5}.pagination-sm>li:first-child>a,.pagination-sm>li:first-child>span{border-top-left-radius:3px;border-bottom-left-radius:3px}.pagination-sm>li:last-child>a,.pagination-sm>li:last-child>span{border-top-right-radius:3px;border-bottom-right-radius:3px}.pager{padding-left:0;margin:20px 0;text-align:center;list-style:none}.pager li{display:inline}.pager li>a,.pager li>span{display:inline-block;padding:5px 14px;background-color:#fff;border:1px solid #ddd;border-radius:15px}.pager li>a:focus,.pager li>a:hover{text-decoration:none;background-color:#eee}.pager .next>a,.pager .next>span{float:right}.pager .previous>a,.pager .previous>span{float:left}.pager .disabled>a,.pager .disabled>a:focus,.pager .disabled>a:hover,.pager .disabled>span{color:#777;cursor:not-allowed;background-color:#fff}.label{display:inline;padding:.2em .6em .3em;font-size:75%;font-weight:700;line-height:1;color:#fff;text-align:center;white-space:nowrap;vertical-align:baseline;border-radius:.25em}a.label:focus,a.label:hover{color:#fff;text-decoration:none;cursor:pointer}.label:empty{display:none}.btn .label{position:relative;top:-1px}.label-default{background-color:#777}.label-default[href]:focus,.label-default[href]:hover{background-color:#5e5e5e}.label-primary{background-color:#337ab7}.label-primary[href]:focus,.label-primary[href]:hover{background-color:#286090}.label-success{background-color:#5cb85c}.label-success[href]:focus,.label-success[href]:hover{background-color:#449d44}.label-info{background-color:#5bc0de}.label-info[href]:focus,.label-info[href]:hover{background-color:#31b0d5}.label-warning{background-color:#f0ad4e}.label-warning[href]:focus,.label-warning[href]:hover{background-color:#ec971f}.label-danger{background-color:#d9534f}.label-danger[href]:focus,.label-danger[href]:hover{background-color:#c9302c}.badge{display:inline-block;min-width:10px;padding:3px 7px;font-size:12px;font-weight:700;line-height:1;color:#fff;text-align:center;white-space:nowrap;vertical-align:middle;background-color:#777;border-radius:10px}.badge:empty{display:none}.btn .badge{position:relative;top:-1px}.btn-group-xs>.btn .badge,.btn-xs .badge{top:0;padding:1px 5px}a.badge:focus,a.badge:hover{color:#fff;text-decoration:none;cursor:pointer}.list-group-item.active>.badge,.nav-pills>.active>a>.badge{color:#337ab7;background-color:#fff}.list-group-item>.badge{float:right}.list-group-item>.badge+.badge{margin-right:5px}.nav-pills>li>a>.badge{margin-left:3px}.jumbotron{padding-top:30px;padding-bottom:30px;margin-bottom:30px;background-color:#eee}.jumbotron,.jumbotron .h1,.jumbotron h1{color:inherit}.jumbotron p{margin-bottom:15px;font-size:21px;font-weight:200}.jumbotron>hr{border-top-color:#d5d5d5}.container-fluid .jumbotron,.container .jumbotron{padding-right:15px;padding-left:15px;border-radius:6px}.jumbotron .container{max-width:100%}@media screen and (min-width:768px){.jumbotron{padding-top:48px;padding-bottom:48px}.container-fluid .jumbotron,.container .jumbotron{padding-right:60px;padding-left:60px}.jumbotron .h1,.jumbotron h1{font-size:63px}}.thumbnail{display:block;padding:4px;margin-bottom:20px;line-height:1.42857143;background-color:#fff;border:1px solid #ddd;border-radius:4px;-webkit-transition:border .2s ease-in-out;-o-transition:border .2s ease-in-out;transition:border .2s ease-in-out}.thumbnail>img,.thumbnail a>img{margin-right:auto;margin-left:auto}a.thumbnail.active,a.thumbnail:focus,a.thumbnail:hover{border-color:#337ab7}.thumbnail .caption{padding:9px;color:#333}.alert{padding:15px;margin-bottom:20px;border:1px solid transparent;border-radius:4px}.alert h4{margin-top:0;color:inherit}.alert .alert-link{font-weight:700}.alert>p,.alert>ul{margin-bottom:0}.alert>p+p{margin-top:5px}.alert-dismissable,.alert-dismissible{padding-right:35px}.alert-dismissable .close,.alert-dismissible .close{position:relative;top:-2px;right:-21px;color:inherit}.alert-success{color:#3c763d;background-color:#dff0d8;border-color:#d6e9c6}.alert-success hr{border-top-color:#c9e2b3}.alert-success .alert-link{color:#2b542c}.alert-info{color:#31708f;background-color:#d9edf7;border-color:#bce8f1}.alert-info hr{border-top-color:#a6e1ec}.alert-info .alert-link{color:#245269}.alert-warning{color:#8a6d3b;background-color:#fcf8e3;border-color:#faebcc}.alert-warning hr{border-top-color:#f7e1b5}.alert-warning .alert-link{color:#66512c}.alert-danger{color:#a94442;background-color:#f2dede;border-color:#ebccd1}.alert-danger hr{border-top-color:#e4b9c0}.alert-danger .alert-link{color:#843534}@-webkit-keyframes progress-bar-stripes{0%{background-position:40px 0}to{background-position:0 0}}@-o-keyframes progress-bar-stripes{0%{background-position:40px 0}to{background-position:0 0}}@keyframes progress-bar-stripes{0%{background-position:40px 0}to{background-position:0 0}}.progress{height:20px;margin-bottom:20px;overflow:hidden;background-color:#f5f5f5;border-radius:4px;-webkit-box-shadow:inset 0 1px 2px rgba(0,0,0,.1);box-shadow:inset 0 1px 2px rgba(0,0,0,.1)}.progress-bar{float:left;width:0;height:100%;font-size:12px;line-height:20px;color:#fff;text-align:center;background-color:#337ab7;-webkit-box-shadow:inset 0 -1px 0 rgba(0,0,0,.15);box-shadow:inset 0 -1px 0 rgba(0,0,0,.15);-webkit-transition:width .6s ease;-o-transition:width .6s ease;transition:width .6s ease}.progress-bar-striped,.progress-striped .progress-bar{background-image:-webkit-linear-gradient(45deg,hsla(0,0%,100%,.15) 25%,transparent 0,transparent 50%,hsla(0,0%,100%,.15) 0,hsla(0,0%,100%,.15) 75%,transparent 0,transparent);background-image:-o-linear-gradient(45deg,hsla(0,0%,100%,.15) 25%,transparent 25%,transparent 50%,hsla(0,0%,100%,.15) 50%,hsla(0,0%,100%,.15) 75%,transparent 75%,transparent);background-image:linear-gradient(45deg,hsla(0,0%,100%,.15) 25%,transparent 0,transparent 50%,hsla(0,0%,100%,.15) 0,hsla(0,0%,100%,.15) 75%,transparent 0,transparent);-webkit-background-size:40px 40px;background-size:40px 40px}.progress-bar.active,.progress.active .progress-bar{-webkit-animation:progress-bar-stripes 2s linear infinite;-o-animation:progress-bar-stripes 2s linear infinite;animation:progress-bar-stripes 2s linear infinite}.progress-bar-success{background-color:#5cb85c}.progress-striped .progress-bar-success{background-image:-webkit-linear-gradient(45deg,hsla(0,0%,100%,.15) 25%,transparent 0,transparent 50%,hsla(0,0%,100%,.15) 0,hsla(0,0%,100%,.15) 75%,transparent 0,transparent);background-image:-o-linear-gradient(45deg,hsla(0,0%,100%,.15) 25%,transparent 25%,transparent 50%,hsla(0,0%,100%,.15) 50%,hsla(0,0%,100%,.15) 75%,transparent 75%,transparent);background-image:linear-gradient(45deg,hsla(0,0%,100%,.15) 25%,transparent 0,transparent 50%,hsla(0,0%,100%,.15) 0,hsla(0,0%,100%,.15) 75%,transparent 0,transparent)}.progress-bar-info{background-color:#5bc0de}.progress-striped .progress-bar-info{background-image:-webkit-linear-gradient(45deg,hsla(0,0%,100%,.15) 25%,transparent 0,transparent 50%,hsla(0,0%,100%,.15) 0,hsla(0,0%,100%,.15) 75%,transparent 0,transparent);background-image:-o-linear-gradient(45deg,hsla(0,0%,100%,.15) 25%,transparent 25%,transparent 50%,hsla(0,0%,100%,.15) 50%,hsla(0,0%,100%,.15) 75%,transparent 75%,transparent);background-image:linear-gradient(45deg,hsla(0,0%,100%,.15) 25%,transparent 0,transparent 50%,hsla(0,0%,100%,.15) 0,hsla(0,0%,100%,.15) 75%,transparent 0,transparent)}.progress-bar-warning{background-color:#f0ad4e}.progress-striped .progress-bar-warning{background-image:-webkit-linear-gradient(45deg,hsla(0,0%,100%,.15) 25%,transparent 0,transparent 50%,hsla(0,0%,100%,.15) 0,hsla(0,0%,100%,.15) 75%,transparent 0,transparent);background-image:-o-linear-gradient(45deg,hsla(0,0%,100%,.15) 25%,transparent 25%,transparent 50%,hsla(0,0%,100%,.15) 50%,hsla(0,0%,100%,.15) 75%,transparent 75%,transparent);background-image:linear-gradient(45deg,hsla(0,0%,100%,.15) 25%,transparent 0,transparent 50%,hsla(0,0%,100%,.15) 0,hsla(0,0%,100%,.15) 75%,transparent 0,transparent)}.progress-bar-danger{background-color:#d9534f}.progress-striped .progress-bar-danger{background-image:-webkit-linear-gradient(45deg,hsla(0,0%,100%,.15) 25%,transparent 0,transparent 50%,hsla(0,0%,100%,.15) 0,hsla(0,0%,100%,.15) 75%,transparent 0,transparent);background-image:-o-linear-gradient(45deg,hsla(0,0%,100%,.15) 25%,transparent 25%,transparent 50%,hsla(0,0%,100%,.15) 50%,hsla(0,0%,100%,.15) 75%,transparent 75%,transparent);background-image:linear-gradient(45deg,hsla(0,0%,100%,.15) 25%,transparent 0,transparent 50%,hsla(0,0%,100%,.15) 0,hsla(0,0%,100%,.15) 75%,transparent 0,transparent)}.media{margin-top:15px}.media:first-child{margin-top:0}.media,.media-body{overflow:hidden;zoom:1}.media-body{width:10000px}.media-object{display:block}.media-object.img-thumbnail{max-width:none}.media-right,.media>.pull-right{padding-left:10px}.media-left,.media>.pull-left{padding-right:10px}.media-body,.media-left,.media-right{display:table-cell;vertical-align:top}.media-middle{vertical-align:middle}.media-bottom{vertical-align:bottom}.media-heading{margin-top:0;margin-bottom:5px}.media-list{padding-left:0;list-style:none}.list-group{padding-left:0;margin-bottom:20px}.list-group-item{position:relative;display:block;padding:10px 15px;margin-bottom:-1px;background-color:#fff;border:1px solid #ddd}.list-group-item:first-child{border-top-left-radius:4px;border-top-right-radius:4px}.list-group-item:last-child{margin-bottom:0;border-bottom-right-radius:4px;border-bottom-left-radius:4px}a.list-group-item,button.list-group-item{color:#555}a.list-group-item .list-group-item-heading,button.list-group-item .list-group-item-heading{color:#333}a.list-group-item:focus,a.list-group-item:hover,button.list-group-item:focus,button.list-group-item:hover{color:#555;text-decoration:none;background-color:#f5f5f5}button.list-group-item{width:100%;text-align:left}.list-group-item.disabled,.list-group-item.disabled:focus,.list-group-item.disabled:hover{color:#777;cursor:not-allowed;background-color:#eee}.list-group-item.disabled .list-group-item-heading,.list-group-item.disabled:focus .list-group-item-heading,.list-group-item.disabled:hover .list-group-item-heading{color:inherit}.list-group-item.disabled .list-group-item-text,.list-group-item.disabled:focus .list-group-item-text,.list-group-item.disabled:hover .list-group-item-text{color:#777}.list-group-item.active,.list-group-item.active:focus,.list-group-item.active:hover{z-index:2;color:#fff;background-color:#337ab7;border-color:#337ab7}.list-group-item.active .list-group-item-heading,.list-group-item.active .list-group-item-heading>.small,.list-group-item.active .list-group-item-heading>small,.list-group-item.active:focus .list-group-item-heading,.list-group-item.active:focus .list-group-item-heading>.small,.list-group-item.active:focus .list-group-item-heading>small,.list-group-item.active:hover .list-group-item-heading,.list-group-item.active:hover .list-group-item-heading>.small,.list-group-item.active:hover .list-group-item-heading>small{color:inherit}.list-group-item.active .list-group-item-text,.list-group-item.active:focus .list-group-item-text,.list-group-item.active:hover .list-group-item-text{color:#c7ddef}.list-group-item-success{color:#3c763d;background-color:#dff0d8}a.list-group-item-success,button.list-group-item-success{color:#3c763d}a.list-group-item-success .list-group-item-heading,button.list-group-item-success .list-group-item-heading{color:inherit}a.list-group-item-success:focus,a.list-group-item-success:hover,button.list-group-item-success:focus,button.list-group-item-success:hover{color:#3c763d;background-color:#d0e9c6}a.list-group-item-success.active,a.list-group-item-success.active:focus,a.list-group-item-success.active:hover,button.list-group-item-success.active,button.list-group-item-success.active:focus,button.list-group-item-success.active:hover{color:#fff;background-color:#3c763d;border-color:#3c763d}.list-group-item-info{color:#31708f;background-color:#d9edf7}a.list-group-item-info,button.list-group-item-info{color:#31708f}a.list-group-item-info .list-group-item-heading,button.list-group-item-info .list-group-item-heading{color:inherit}a.list-group-item-info:focus,a.list-group-item-info:hover,button.list-group-item-info:focus,button.list-group-item-info:hover{color:#31708f;background-color:#c4e3f3}a.list-group-item-info.active,a.list-group-item-info.active:focus,a.list-group-item-info.active:hover,button.list-group-item-info.active,button.list-group-item-info.active:focus,button.list-group-item-info.active:hover{color:#fff;background-color:#31708f;border-color:#31708f}.list-group-item-warning{color:#8a6d3b;background-color:#fcf8e3}a.list-group-item-warning,button.list-group-item-warning{color:#8a6d3b}a.list-group-item-warning .list-group-item-heading,button.list-group-item-warning .list-group-item-heading{color:inherit}a.list-group-item-warning:focus,a.list-group-item-warning:hover,button.list-group-item-warning:focus,button.list-group-item-warning:hover{color:#8a6d3b;background-color:#faf2cc}a.list-group-item-warning.active,a.list-group-item-warning.active:focus,a.list-group-item-warning.active:hover,button.list-group-item-warning.active,button.list-group-item-warning.active:focus,button.list-group-item-warning.active:hover{color:#fff;background-color:#8a6d3b;border-color:#8a6d3b}.list-group-item-danger{color:#a94442;background-color:#f2dede}a.list-group-item-danger,button.list-group-item-danger{color:#a94442}a.list-group-item-danger .list-group-item-heading,button.list-group-item-danger .list-group-item-heading{color:inherit}a.list-group-item-danger:focus,a.list-group-item-danger:hover,button.list-group-item-danger:focus,button.list-group-item-danger:hover{color:#a94442;background-color:#ebcccc}a.list-group-item-danger.active,a.list-group-item-danger.active:focus,a.list-group-item-danger.active:hover,button.list-group-item-danger.active,button.list-group-item-danger.active:focus,button.list-group-item-danger.active:hover{color:#fff;background-color:#a94442;border-color:#a94442}.list-group-item-heading{margin-top:0;margin-bottom:5px}.list-group-item-text{margin-bottom:0;line-height:1.3}.panel{margin-bottom:20px;background-color:#fff;border:1px solid transparent;border-radius:4px;-webkit-box-shadow:0 1px 1px rgba(0,0,0,.05);box-shadow:0 1px 1px rgba(0,0,0,.05)}.panel-body{padding:15px}.panel-heading{padding:10px 15px;border-bottom:1px solid transparent;border-top-left-radius:3px;border-top-right-radius:3px}.panel-heading>.dropdown .dropdown-toggle,.panel-title{color:inherit}.panel-title{margin-top:0;margin-bottom:0;font-size:16px}.panel-title>.small,.panel-title>.small>a,.panel-title>a,.panel-title>small,.panel-title>small>a{color:inherit}.panel-footer{padding:10px 15px;background-color:#f5f5f5;border-top:1px solid #ddd;border-bottom-right-radius:3px;border-bottom-left-radius:3px}.panel>.list-group,.panel>.panel-collapse>.list-group{margin-bottom:0}.panel>.list-group .list-group-item,.panel>.panel-collapse>.list-group .list-group-item{border-width:1px 0;border-radius:0}.panel>.list-group:first-child .list-group-item:first-child,.panel>.panel-collapse>.list-group:first-child .list-group-item:first-child{border-top:0;border-top-left-radius:3px;border-top-right-radius:3px}.panel>.list-group:last-child .list-group-item:last-child,.panel>.panel-collapse>.list-group:last-child .list-group-item:last-child{border-bottom:0;border-bottom-right-radius:3px;border-bottom-left-radius:3px}.panel>.panel-heading+.panel-collapse>.list-group .list-group-item:first-child{border-top-left-radius:0;border-top-right-radius:0}.list-group+.panel-footer,.panel-heading+.list-group .list-group-item:first-child{border-top-width:0}.panel>.panel-collapse>.table,.panel>.table,.panel>.table-responsive>.table{margin-bottom:0}.panel>.panel-collapse>.table caption,.panel>.table-responsive>.table caption,.panel>.table caption{padding-right:15px;padding-left:15px}.panel>.table-responsive:first-child>.table:first-child,.panel>.table-responsive:first-child>.table:first-child>tbody:first-child>tr:first-child,.panel>.table-responsive:first-child>.table:first-child>thead:first-child>tr:first-child,.panel>.table:first-child,.panel>.table:first-child>tbody:first-child>tr:first-child,.panel>.table:first-child>thead:first-child>tr:first-child{border-top-left-radius:3px;border-top-right-radius:3px}.panel>.table-responsive:first-child>.table:first-child>tbody:first-child>tr:first-child td:first-child,.panel>.table-responsive:first-child>.table:first-child>tbody:first-child>tr:first-child th:first-child,.panel>.table-responsive:first-child>.table:first-child>thead:first-child>tr:first-child td:first-child,.panel>.table-responsive:first-child>.table:first-child>thead:first-child>tr:first-child th:first-child,.panel>.table:first-child>tbody:first-child>tr:first-child td:first-child,.panel>.table:first-child>tbody:first-child>tr:first-child th:first-child,.panel>.table:first-child>thead:first-child>tr:first-child td:first-child,.panel>.table:first-child>thead:first-child>tr:first-child th:first-child{border-top-left-radius:3px}.panel>.table-responsive:first-child>.table:first-child>tbody:first-child>tr:first-child td:last-child,.panel>.table-responsive:first-child>.table:first-child>tbody:first-child>tr:first-child th:last-child,.panel>.table-responsive:first-child>.table:first-child>thead:first-child>tr:first-child td:last-child,.panel>.table-responsive:first-child>.table:first-child>thead:first-child>tr:first-child th:last-child,.panel>.table:first-child>tbody:first-child>tr:first-child td:last-child,.panel>.table:first-child>tbody:first-child>tr:first-child th:last-child,.panel>.table:first-child>thead:first-child>tr:first-child td:last-child,.panel>.table:first-child>thead:first-child>tr:first-child th:last-child{border-top-right-radius:3px}.panel>.table-responsive:last-child>.table:last-child,.panel>.table-responsive:last-child>.table:last-child>tbody:last-child>tr:last-child,.panel>.table-responsive:last-child>.table:last-child>tfoot:last-child>tr:last-child,.panel>.table:last-child,.panel>.table:last-child>tbody:last-child>tr:last-child,.panel>.table:last-child>tfoot:last-child>tr:last-child{border-bottom-right-radius:3px;border-bottom-left-radius:3px}.panel>.table-responsive:last-child>.table:last-child>tbody:last-child>tr:last-child td:first-child,.panel>.table-responsive:last-child>.table:last-child>tbody:last-child>tr:last-child th:first-child,.panel>.table-responsive:last-child>.table:last-child>tfoot:last-child>tr:last-child td:first-child,.panel>.table-responsive:last-child>.table:last-child>tfoot:last-child>tr:last-child th:first-child,.panel>.table:last-child>tbody:last-child>tr:last-child td:first-child,.panel>.table:last-child>tbody:last-child>tr:last-child th:first-child,.panel>.table:last-child>tfoot:last-child>tr:last-child td:first-child,.panel>.table:last-child>tfoot:last-child>tr:last-child th:first-child{border-bottom-left-radius:3px}.panel>.table-responsive:last-child>.table:last-child>tbody:last-child>tr:last-child td:last-child,.panel>.table-responsive:last-child>.table:last-child>tbody:last-child>tr:last-child th:last-child,.panel>.table-responsive:last-child>.table:last-child>tfoot:last-child>tr:last-child td:last-child,.panel>.table-responsive:last-child>.table:last-child>tfoot:last-child>tr:last-child th:last-child,.panel>.table:last-child>tbody:last-child>tr:last-child td:last-child,.panel>.table:last-child>tbody:last-child>tr:last-child th:last-child,.panel>.table:last-child>tfoot:last-child>tr:last-child td:last-child,.panel>.table:last-child>tfoot:last-child>tr:last-child th:last-child{border-bottom-right-radius:3px}.panel>.panel-body+.table,.panel>.panel-body+.table-responsive,.panel>.table+.panel-body,.panel>.table-responsive+.panel-body{border-top:1px solid #ddd}.panel>.table>tbody:first-child>tr:first-child td,.panel>.table>tbody:first-child>tr:first-child th{border-top:0}.panel>.table-bordered,.panel>.table-responsive>.table-bordered{border:0}.panel>.table-bordered>tbody>tr>td:first-child,.panel>.table-bordered>tbody>tr>th:first-child,.panel>.table-bordered>tfoot>tr>td:first-child,.panel>.table-bordered>tfoot>tr>th:first-child,.panel>.table-bordered>thead>tr>td:first-child,.panel>.table-bordered>thead>tr>th:first-child,.panel>.table-responsive>.table-bordered>tbody>tr>td:first-child,.panel>.table-responsive>.table-bordered>tbody>tr>th:first-child,.panel>.table-responsive>.table-bordered>tfoot>tr>td:first-child,.panel>.table-responsive>.table-bordered>tfoot>tr>th:first-child,.panel>.table-responsive>.table-bordered>thead>tr>td:first-child,.panel>.table-responsive>.table-bordered>thead>tr>th:first-child{border-left:0}.panel>.table-bordered>tbody>tr>td:last-child,.panel>.table-bordered>tbody>tr>th:last-child,.panel>.table-bordered>tfoot>tr>td:last-child,.panel>.table-bordered>tfoot>tr>th:last-child,.panel>.table-bordered>thead>tr>td:last-child,.panel>.table-bordered>thead>tr>th:last-child,.panel>.table-responsive>.table-bordered>tbody>tr>td:last-child,.panel>.table-responsive>.table-bordered>tbody>tr>th:last-child,.panel>.table-responsive>.table-bordered>tfoot>tr>td:last-child,.panel>.table-responsive>.table-bordered>tfoot>tr>th:last-child,.panel>.table-responsive>.table-bordered>thead>tr>td:last-child,.panel>.table-responsive>.table-bordered>thead>tr>th:last-child{border-right:0}.panel>.table-bordered>tbody>tr:first-child>td,.panel>.table-bordered>tbody>tr:first-child>th,.panel>.table-bordered>tbody>tr:last-child>td,.panel>.table-bordered>tbody>tr:last-child>th,.panel>.table-bordered>tfoot>tr:last-child>td,.panel>.table-bordered>tfoot>tr:last-child>th,.panel>.table-bordered>thead>tr:first-child>td,.panel>.table-bordered>thead>tr:first-child>th,.panel>.table-responsive>.table-bordered>tbody>tr:first-child>td,.panel>.table-responsive>.table-bordered>tbody>tr:first-child>th,.panel>.table-responsive>.table-bordered>tbody>tr:last-child>td,.panel>.table-responsive>.table-bordered>tbody>tr:last-child>th,.panel>.table-responsive>.table-bordered>tfoot>tr:last-child>td,.panel>.table-responsive>.table-bordered>tfoot>tr:last-child>th,.panel>.table-responsive>.table-bordered>thead>tr:first-child>td,.panel>.table-responsive>.table-bordered>thead>tr:first-child>th{border-bottom:0}.panel>.table-responsive{margin-bottom:0;border:0}.panel-group{margin-bottom:20px}.panel-group .panel{margin-bottom:0;border-radius:4px}.panel-group .panel+.panel{margin-top:5px}.panel-group .panel-heading{border-bottom:0}.panel-group .panel-heading+.panel-collapse>.list-group,.panel-group .panel-heading+.panel-collapse>.panel-body{border-top:1px solid #ddd}.panel-group .panel-footer{border-top:0}.panel-group .panel-footer+.panel-collapse .panel-body{border-bottom:1px solid #ddd}.panel-default{border-color:#ddd}.panel-default>.panel-heading{color:#333;background-color:#f5f5f5;border-color:#ddd}.panel-default>.panel-heading+.panel-collapse>.panel-body{border-top-color:#ddd}.panel-default>.panel-heading .badge{color:#f5f5f5;background-color:#333}.panel-default>.panel-footer+.panel-collapse>.panel-body{border-bottom-color:#ddd}.panel-primary{border-color:#337ab7}.panel-primary>.panel-heading{color:#fff;background-color:#337ab7;border-color:#337ab7}.panel-primary>.panel-heading+.panel-collapse>.panel-body{border-top-color:#337ab7}.panel-primary>.panel-heading .badge{color:#337ab7;background-color:#fff}.panel-primary>.panel-footer+.panel-collapse>.panel-body{border-bottom-color:#337ab7}.panel-success{border-color:#d6e9c6}.panel-success>.panel-heading{color:#3c763d;background-color:#dff0d8;border-color:#d6e9c6}.panel-success>.panel-heading+.panel-collapse>.panel-body{border-top-color:#d6e9c6}.panel-success>.panel-heading .badge{color:#dff0d8;background-color:#3c763d}.panel-success>.panel-footer+.panel-collapse>.panel-body{border-bottom-color:#d6e9c6}.panel-info{border-color:#bce8f1}.panel-info>.panel-heading{color:#31708f;background-color:#d9edf7;border-color:#bce8f1}.panel-info>.panel-heading+.panel-collapse>.panel-body{border-top-color:#bce8f1}.panel-info>.panel-heading .badge{color:#d9edf7;background-color:#31708f}.panel-info>.panel-footer+.panel-collapse>.panel-body{border-bottom-color:#bce8f1}.panel-warning{border-color:#faebcc}.panel-warning>.panel-heading{color:#8a6d3b;background-color:#fcf8e3;border-color:#faebcc}.panel-warning>.panel-heading+.panel-collapse>.panel-body{border-top-color:#faebcc}.panel-warning>.panel-heading .badge{color:#fcf8e3;background-color:#8a6d3b}.panel-warning>.panel-footer+.panel-collapse>.panel-body{border-bottom-color:#faebcc}.panel-danger{border-color:#ebccd1}.panel-danger>.panel-heading{color:#a94442;background-color:#f2dede;border-color:#ebccd1}.panel-danger>.panel-heading+.panel-collapse>.panel-body{border-top-color:#ebccd1}.panel-danger>.panel-heading .badge{color:#f2dede;background-color:#a94442}.panel-danger>.panel-footer+.panel-collapse>.panel-body{border-bottom-color:#ebccd1}.embed-responsive{position:relative;display:block;height:0;padding:0;overflow:hidden}.embed-responsive .embed-responsive-item,.embed-responsive embed,.embed-responsive iframe,.embed-responsive object,.embed-responsive video{position:absolute;top:0;bottom:0;left:0;width:100%;height:100%;border:0}.embed-responsive-16by9{padding-bottom:56.25%}.embed-responsive-4by3{padding-bottom:75%}.well{min-height:20px;padding:19px;margin-bottom:20px;background-color:#f5f5f5;border:1px solid #e3e3e3;border-radius:4px;-webkit-box-shadow:inset 0 1px 1px rgba(0,0,0,.05);box-shadow:inset 0 1px 1px rgba(0,0,0,.05)}.well blockquote{border-color:#ddd;border-color:rgba(0,0,0,.15)}.well-lg{padding:24px;border-radius:6px}.well-sm{padding:9px;border-radius:3px}.close{float:right;font-size:21px;font-weight:700;line-height:1;color:#000;text-shadow:0 1px 0 #fff;filter:alpha(opacity=20);opacity:.2}.close:focus,.close:hover{color:#000;text-decoration:none;cursor:pointer;filter:alpha(opacity=50);opacity:.5}button.close{-webkit-appearance:none;padding:0;cursor:pointer;background:0 0;border:0}.modal,.modal-open{overflow:hidden}.modal{position:fixed;top:0;right:0;bottom:0;left:0;z-index:1050;display:none;-webkit-overflow-scrolling:touch;outline:0}.modal.fade .modal-dialog{-webkit-transition:-webkit-transform .3s ease-out;-o-transition:-o-transform .3s ease-out;transition:transform .3s ease-out;-webkit-transform:translateY(-25%);-ms-transform:translateY(-25%);-o-transform:translateY(-25%);transform:translateY(-25%)}.modal.in .modal-dialog{-webkit-transform:translate(0);-ms-transform:translate(0);-o-transform:translate(0);transform:translate(0)}.modal-open .modal{overflow-x:hidden;overflow-y:auto}.modal-dialog{position:relative;width:auto;margin:10px}.modal-content{position:relative;background-color:#fff;-webkit-background-clip:padding-box;background-clip:padding-box;border:1px solid #999;border:1px solid rgba(0,0,0,.2);border-radius:6px;outline:0;-webkit-box-shadow:0 3px 9px rgba(0,0,0,.5);box-shadow:0 3px 9px rgba(0,0,0,.5)}.modal-backdrop{position:fixed;top:0;right:0;bottom:0;left:0;z-index:1040;background-color:#000}.modal-backdrop.fade{filter:alpha(opacity=0);opacity:0}.modal-backdrop.in{filter:alpha(opacity=50);opacity:.5}.modal-header{padding:15px;border-bottom:1px solid #e5e5e5}.modal-header .close{margin-top:-2px}.modal-title{margin:0;line-height:1.42857143}.modal-body{position:relative;padding:15px}.modal-footer{padding:15px;text-align:right;border-top:1px solid #e5e5e5}.modal-footer .btn+.btn{margin-bottom:0;margin-left:5px}.modal-footer .btn-group .btn+.btn{margin-left:-1px}.modal-footer .btn-block+.btn-block{margin-left:0}.modal-scrollbar-measure{position:absolute;top:-9999px;width:50px;height:50px;overflow:scroll}@media (min-width:768px){.modal-dialog{width:600px;margin:30px auto}.modal-content{-webkit-box-shadow:0 5px 15px rgba(0,0,0,.5);box-shadow:0 5px 15px rgba(0,0,0,.5)}.modal-sm{width:300px}}@media (min-width:992px){.modal-lg{width:900px}}.tooltip{position:absolute;z-index:1070;display:block;font-family:Helvetica Neue,Helvetica,Arial,sans-serif;font-size:12px;font-style:normal;font-weight:400;line-height:1.42857143;text-align:left;text-align:start;text-decoration:none;text-shadow:none;text-transform:none;letter-spacing:normal;word-break:normal;word-spacing:normal;word-wrap:normal;white-space:normal;filter:alpha(opacity=0);opacity:0;line-break:auto}.tooltip.in{filter:alpha(opacity=90);opacity:.9}.tooltip.top{padding:5px 0;margin-top:-3px}.tooltip.right{padding:0 5px;margin-left:3px}.tooltip.bottom{padding:5px 0;margin-top:3px}.tooltip.left{padding:0 5px;margin-left:-3px}.tooltip-inner{max-width:200px;padding:3px 8px;color:#fff;text-align:center;background-color:#000;border-radius:4px}.tooltip-arrow{position:absolute;width:0;height:0;border-color:transparent;border-style:solid}.tooltip.top .tooltip-arrow{bottom:0;left:50%;margin-left:-5px;border-width:5px 5px 0;border-top-color:#000}.tooltip.top-left .tooltip-arrow{right:5px}.tooltip.top-left .tooltip-arrow,.tooltip.top-right .tooltip-arrow{bottom:0;margin-bottom:-5px;border-width:5px 5px 0;border-top-color:#000}.tooltip.top-right .tooltip-arrow{left:5px}.tooltip.right .tooltip-arrow{top:50%;left:0;margin-top:-5px;border-width:5px 5px 5px 0;border-right-color:#000}.tooltip.left .tooltip-arrow{top:50%;right:0;margin-top:-5px;border-width:5px 0 5px 5px;border-left-color:#000}.tooltip.bottom .tooltip-arrow{top:0;left:50%;margin-left:-5px;border-width:0 5px 5px;border-bottom-color:#000}.tooltip.bottom-left .tooltip-arrow{top:0;right:5px;margin-top:-5px;border-width:0 5px 5px;border-bottom-color:#000}.tooltip.bottom-right .tooltip-arrow{top:0;left:5px;margin-top:-5px;border-width:0 5px 5px;border-bottom-color:#000}.popover{position:absolute;top:0;left:0;z-index:1060;display:none;max-width:276px;padding:1px;font-family:Helvetica Neue,Helvetica,Arial,sans-serif;font-size:14px;font-style:normal;font-weight:400;line-height:1.42857143;text-align:left;text-align:start;text-decoration:none;text-shadow:none;text-transform:none;letter-spacing:normal;word-break:normal;word-spacing:normal;word-wrap:normal;white-space:normal;background-color:#fff;-webkit-background-clip:padding-box;background-clip:padding-box;border:1px solid #ccc;border:1px solid rgba(0,0,0,.2);border-radius:6px;-webkit-box-shadow:0 5px 10px rgba(0,0,0,.2);box-shadow:0 5px 10px rgba(0,0,0,.2);line-break:auto}.popover.top{margin-top:-10px}.popover.right{margin-left:10px}.popover.bottom{margin-top:10px}.popover.left{margin-left:-10px}.popover-title{padding:8px 14px;margin:0;font-size:14px;background-color:#f7f7f7;border-bottom:1px solid #ebebeb;border-radius:5px 5px 0 0}.popover-content{padding:9px 14px}.popover>.arrow,.popover>.arrow:after{position:absolute;display:block;width:0;height:0;border-color:transparent;border-style:solid}.popover>.arrow{border-width:11px}.popover>.arrow:after{content:\"\";border-width:10px}.popover.top>.arrow{bottom:-11px;left:50%;margin-left:-11px;border-top-color:#999;border-top-color:rgba(0,0,0,.25);border-bottom-width:0}.popover.top>.arrow:after{bottom:1px;margin-left:-10px;content:\" \";border-top-color:#fff;border-bottom-width:0}.popover.right>.arrow{top:50%;left:-11px;margin-top:-11px;border-right-color:#999;border-right-color:rgba(0,0,0,.25);border-left-width:0}.popover.right>.arrow:after{bottom:-10px;left:1px;content:\" \";border-right-color:#fff;border-left-width:0}.popover.bottom>.arrow{top:-11px;left:50%;margin-left:-11px;border-top-width:0;border-bottom-color:#999;border-bottom-color:rgba(0,0,0,.25)}.popover.bottom>.arrow:after{top:1px;margin-left:-10px;content:\" \";border-top-width:0;border-bottom-color:#fff}.popover.left>.arrow{top:50%;right:-11px;margin-top:-11px;border-right-width:0;border-left-color:#999;border-left-color:rgba(0,0,0,.25)}.popover.left>.arrow:after{right:1px;bottom:-10px;content:\" \";border-right-width:0;border-left-color:#fff}.carousel,.carousel-inner{position:relative}.carousel-inner{width:100%;overflow:hidden}.carousel-inner>.item{position:relative;display:none;-webkit-transition:left .6s ease-in-out;-o-transition:.6s ease-in-out left;transition:left .6s ease-in-out}.carousel-inner>.item>a>img,.carousel-inner>.item>img{line-height:1}@media (-webkit-transform-3d),(transform-3d){.carousel-inner>.item{-webkit-transition:-webkit-transform .6s ease-in-out;-o-transition:-o-transform .6s ease-in-out;transition:transform .6s ease-in-out;-webkit-backface-visibility:hidden;backface-visibility:hidden;-webkit-perspective:1000px;perspective:1000px}.carousel-inner>.item.active.right,.carousel-inner>.item.next{left:0;-webkit-transform:translate3d(100%,0,0);transform:translate3d(100%,0,0)}.carousel-inner>.item.active.left,.carousel-inner>.item.prev{left:0;-webkit-transform:translate3d(-100%,0,0);transform:translate3d(-100%,0,0)}.carousel-inner>.item.active,.carousel-inner>.item.next.left,.carousel-inner>.item.prev.right{left:0;-webkit-transform:translateZ(0);transform:translateZ(0)}}.carousel-inner>.active,.carousel-inner>.next,.carousel-inner>.prev{display:block}.carousel-inner>.active{left:0}.carousel-inner>.next,.carousel-inner>.prev{position:absolute;top:0;width:100%}.carousel-inner>.next{left:100%}.carousel-inner>.prev{left:-100%}.carousel-inner>.next.left,.carousel-inner>.prev.right{left:0}.carousel-inner>.active.left{left:-100%}.carousel-inner>.active.right{left:100%}.carousel-control{position:absolute;top:0;bottom:0;left:0;width:15%;font-size:20px;color:#fff;text-align:center;text-shadow:0 1px 2px rgba(0,0,0,.6);background-color:transparent;filter:alpha(opacity=50);opacity:.5}.carousel-control.left{background-image:-webkit-linear-gradient(left,rgba(0,0,0,.5),rgba(0,0,0,.0001));background-image:-o-linear-gradient(left,rgba(0,0,0,.5) 0,rgba(0,0,0,.0001) 100%);background-image:-webkit-gradient(linear,left top,right top,from(rgba(0,0,0,.5)),to(rgba(0,0,0,.0001)));background-image:linear-gradient(90deg,rgba(0,0,0,.5) 0,rgba(0,0,0,.0001));filter:progid:DXImageTransform.Microsoft.gradient(startColorstr=\"#80000000\",endColorstr=\"#00000000\",GradientType=1);background-repeat:repeat-x}.carousel-control.right{right:0;left:auto;background-image:-webkit-linear-gradient(left,rgba(0,0,0,.0001),rgba(0,0,0,.5));background-image:-o-linear-gradient(left,rgba(0,0,0,.0001) 0,rgba(0,0,0,.5) 100%);background-image:-webkit-gradient(linear,left top,right top,from(rgba(0,0,0,.0001)),to(rgba(0,0,0,.5)));background-image:linear-gradient(90deg,rgba(0,0,0,.0001) 0,rgba(0,0,0,.5));filter:progid:DXImageTransform.Microsoft.gradient(startColorstr=\"#00000000\",endColorstr=\"#80000000\",GradientType=1);background-repeat:repeat-x}.carousel-control:focus,.carousel-control:hover{color:#fff;text-decoration:none;filter:alpha(opacity=90);outline:0;opacity:.9}.carousel-control .glyphicon-chevron-left,.carousel-control .glyphicon-chevron-right,.carousel-control .icon-next,.carousel-control .icon-prev{position:absolute;top:50%;z-index:5;display:inline-block;margin-top:-10px}.carousel-control .glyphicon-chevron-left,.carousel-control .icon-prev{left:50%;margin-left:-10px}.carousel-control .glyphicon-chevron-right,.carousel-control .icon-next{right:50%;margin-right:-10px}.carousel-control .icon-next,.carousel-control .icon-prev{width:20px;height:20px;font-family:serif;line-height:1}.carousel-control .icon-prev:before{content:\"\\2039\"}.carousel-control .icon-next:before{content:\"\\203A\"}.carousel-indicators{position:absolute;bottom:10px;left:50%;z-index:15;width:60%;padding-left:0;margin-left:-30%;text-align:center;list-style:none}.carousel-indicators li{display:inline-block;width:10px;height:10px;margin:1px;text-indent:-999px;cursor:pointer;background-color:#000\\9;background-color:transparent;border:1px solid #fff;border-radius:10px}.carousel-indicators .active{width:12px;height:12px;margin:0;background-color:#fff}.carousel-caption{position:absolute;right:15%;bottom:20px;left:15%;z-index:10;padding-top:20px;padding-bottom:20px;color:#fff;text-align:center;text-shadow:0 1px 2px rgba(0,0,0,.6)}.carousel-caption .btn{text-shadow:none}@media screen and (min-width:768px){.carousel-control .glyphicon-chevron-left,.carousel-control .glyphicon-chevron-right,.carousel-control .icon-next,.carousel-control .icon-prev{width:30px;height:30px;margin-top:-10px;font-size:30px}.carousel-control .glyphicon-chevron-left,.carousel-control .icon-prev{margin-left:-10px}.carousel-control .glyphicon-chevron-right,.carousel-control .icon-next{margin-right:-10px}.carousel-caption{right:20%;left:20%;padding-bottom:30px}.carousel-indicators{bottom:20px}}.btn-group-vertical>.btn-group:after,.btn-group-vertical>.btn-group:before,.btn-toolbar:after,.btn-toolbar:before,.clearfix:after,.clearfix:before,.container-fluid:after,.container-fluid:before,.container:after,.container:before,.dl-horizontal dd:after,.dl-horizontal dd:before,.form-horizontal .form-group:after,.form-horizontal .form-group:before,.modal-footer:after,.modal-footer:before,.modal-header:after,.modal-header:before,.nav:after,.nav:before,.navbar-collapse:after,.navbar-collapse:before,.navbar-header:after,.navbar-header:before,.navbar:after,.navbar:before,.pager:after,.pager:before,.panel-body:after,.panel-body:before,.row:after,.row:before{display:table;content:\" \"}.btn-group-vertical>.btn-group:after,.btn-toolbar:after,.clearfix:after,.container-fluid:after,.container:after,.dl-horizontal dd:after,.form-horizontal .form-group:after,.modal-footer:after,.modal-header:after,.nav:after,.navbar-collapse:after,.navbar-header:after,.navbar:after,.pager:after,.panel-body:after,.row:after{clear:both}.center-block{display:block;margin-right:auto;margin-left:auto}.pull-right{float:right!important}.pull-left{float:left!important}.hide{display:none!important}.show{display:block!important}.invisible{visibility:hidden}.text-hide{font:0/0 a;color:transparent;text-shadow:none;background-color:transparent;border:0}.hidden{display:none!important}.affix{position:fixed}@-ms-viewport{width:device-width}.visible-lg,.visible-lg-block,.visible-lg-inline,.visible-lg-inline-block,.visible-md,.visible-md-block,.visible-md-inline,.visible-md-inline-block,.visible-sm,.visible-sm-block,.visible-sm-inline,.visible-sm-inline-block,.visible-xs,.visible-xs-block,.visible-xs-inline,.visible-xs-inline-block{display:none!important}@media (max-width:767px){.visible-xs{display:block!important}table.visible-xs{display:table!important}tr.visible-xs{display:table-row!important}td.visible-xs,th.visible-xs{display:table-cell!important}}@media (max-width:767px){.visible-xs-block{display:block!important}}@media (max-width:767px){.visible-xs-inline{display:inline!important}}@media (max-width:767px){.visible-xs-inline-block{display:inline-block!important}}@media (min-width:768px) and (max-width:991px){.visible-sm{display:block!important}table.visible-sm{display:table!important}tr.visible-sm{display:table-row!important}td.visible-sm,th.visible-sm{display:table-cell!important}}@media (min-width:768px) and (max-width:991px){.visible-sm-block{display:block!important}}@media (min-width:768px) and (max-width:991px){.visible-sm-inline{display:inline!important}}@media (min-width:768px) and (max-width:991px){.visible-sm-inline-block{display:inline-block!important}}@media (min-width:992px) and (max-width:1199px){.visible-md{display:block!important}table.visible-md{display:table!important}tr.visible-md{display:table-row!important}td.visible-md,th.visible-md{display:table-cell!important}}@media (min-width:992px) and (max-width:1199px){.visible-md-block{display:block!important}}@media (min-width:992px) and (max-width:1199px){.visible-md-inline{display:inline!important}}@media (min-width:992px) and (max-width:1199px){.visible-md-inline-block{display:inline-block!important}}@media (min-width:1200px){.visible-lg{display:block!important}table.visible-lg{display:table!important}tr.visible-lg{display:table-row!important}td.visible-lg,th.visible-lg{display:table-cell!important}}@media (min-width:1200px){.visible-lg-block{display:block!important}}@media (min-width:1200px){.visible-lg-inline{display:inline!important}}@media (min-width:1200px){.visible-lg-inline-block{display:inline-block!important}}@media (max-width:767px){.hidden-xs{display:none!important}}@media (min-width:768px) and (max-width:991px){.hidden-sm{display:none!important}}@media (min-width:992px) and (max-width:1199px){.hidden-md{display:none!important}}@media (min-width:1200px){.hidden-lg{display:none!important}}.visible-print{display:none!important}@media print{.visible-print{display:block!important}table.visible-print{display:table!important}tr.visible-print{display:table-row!important}td.visible-print,th.visible-print{display:table-cell!important}}.visible-print-block{display:none!important}@media print{.visible-print-block{display:block!important}}.visible-print-inline{display:none!important}@media print{.visible-print-inline{display:inline!important}}.visible-print-inline-block{display:none!important}@media print{.visible-print-inline-block{display:inline-block!important}}@media print{.hidden-print{display:none!important}}", ""]);
	
	// exports


/***/ },
/* 815 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(122)(false);
	// imports
	
	
	// module
	exports.push([module.id, "/*!\n * Quill Editor v1.3.0\n * https://quilljs.com/\n * Copyright (c) 2014, Jason Chen\n * Copyright (c) 2013, salesforce.com\n */.ql-container{box-sizing:border-box;font-family:Helvetica,Arial,sans-serif;font-size:13px;height:100%;margin:0;position:relative}.ql-container.ql-disabled .ql-tooltip{visibility:hidden}.ql-container.ql-disabled .ql-editor ul[data-checked]>li:before{pointer-events:none}.ql-clipboard{left:-100000px;height:1px;overflow-y:hidden;position:absolute;top:50%}.ql-clipboard p{margin:0;padding:0}.ql-editor{box-sizing:border-box;line-height:1.42;height:100%;outline:none;overflow-y:auto;padding:12px 15px;tab-size:4;-moz-tab-size:4;text-align:left;white-space:pre-wrap;word-wrap:break-word}.ql-editor>*{cursor:text}.ql-editor blockquote,.ql-editor h1,.ql-editor h2,.ql-editor h3,.ql-editor h4,.ql-editor h5,.ql-editor h6,.ql-editor ol,.ql-editor p,.ql-editor pre,.ql-editor ul{margin:0;padding:0;counter-reset:list-1 list-2 list-3 list-4 list-5 list-6 list-7 list-8 list-9}.ql-editor ol,.ql-editor ul{padding-left:1.5em}.ql-editor ol>li,.ql-editor ul>li{list-style-type:none}.ql-editor ul>li:before{content:\"\\2022\"}.ql-editor ul[data-checked=false],.ql-editor ul[data-checked=true]{pointer-events:none}.ql-editor ul[data-checked=false]>li *,.ql-editor ul[data-checked=true]>li *{pointer-events:all}.ql-editor ul[data-checked=false]>li:before,.ql-editor ul[data-checked=true]>li:before{color:#777;cursor:pointer;pointer-events:all}.ql-editor ul[data-checked=true]>li:before{content:\"\\2611\"}.ql-editor ul[data-checked=false]>li:before{content:\"\\2610\"}.ql-editor li:before{display:inline-block;white-space:nowrap;width:1.2em}.ql-editor li:not(.ql-direction-rtl):before{margin-left:-1.5em;margin-right:.3em;text-align:right}.ql-editor li.ql-direction-rtl:before{margin-left:.3em;margin-right:-1.5em}.ql-editor ol li:not(.ql-direction-rtl),.ql-editor ul li:not(.ql-direction-rtl){padding-left:1.5em}.ql-editor ol li.ql-direction-rtl,.ql-editor ul li.ql-direction-rtl{padding-right:1.5em}.ql-editor ol li{counter-reset:list-1 list-2 list-3 list-4 list-5 list-6 list-7 list-8 list-9;counter-increment:list-0}.ql-editor ol li:before{content:counter(list-0,decimal) \". \"}.ql-editor ol li.ql-indent-1{counter-increment:list-1}.ql-editor ol li.ql-indent-1:before{content:counter(list-1,lower-alpha) \". \"}.ql-editor ol li.ql-indent-1{counter-reset:list-2 list-3 list-4 list-5 list-6 list-7 list-8 list-9}.ql-editor ol li.ql-indent-2{counter-increment:list-2}.ql-editor ol li.ql-indent-2:before{content:counter(list-2,lower-roman) \". \"}.ql-editor ol li.ql-indent-2{counter-reset:list-3 list-4 list-5 list-6 list-7 list-8 list-9}.ql-editor ol li.ql-indent-3{counter-increment:list-3}.ql-editor ol li.ql-indent-3:before{content:counter(list-3,decimal) \". \"}.ql-editor ol li.ql-indent-3{counter-reset:list-4 list-5 list-6 list-7 list-8 list-9}.ql-editor ol li.ql-indent-4{counter-increment:list-4}.ql-editor ol li.ql-indent-4:before{content:counter(list-4,lower-alpha) \". \"}.ql-editor ol li.ql-indent-4{counter-reset:list-5 list-6 list-7 list-8 list-9}.ql-editor ol li.ql-indent-5{counter-increment:list-5}.ql-editor ol li.ql-indent-5:before{content:counter(list-5,lower-roman) \". \"}.ql-editor ol li.ql-indent-5{counter-reset:list-6 list-7 list-8 list-9}.ql-editor ol li.ql-indent-6{counter-increment:list-6}.ql-editor ol li.ql-indent-6:before{content:counter(list-6,decimal) \". \"}.ql-editor ol li.ql-indent-6{counter-reset:list-7 list-8 list-9}.ql-editor ol li.ql-indent-7{counter-increment:list-7}.ql-editor ol li.ql-indent-7:before{content:counter(list-7,lower-alpha) \". \"}.ql-editor ol li.ql-indent-7{counter-reset:list-8 list-9}.ql-editor ol li.ql-indent-8{counter-increment:list-8}.ql-editor ol li.ql-indent-8:before{content:counter(list-8,lower-roman) \". \"}.ql-editor ol li.ql-indent-8{counter-reset:list-9}.ql-editor ol li.ql-indent-9{counter-increment:list-9}.ql-editor ol li.ql-indent-9:before{content:counter(list-9,decimal) \". \"}.ql-editor .ql-indent-1:not(.ql-direction-rtl){padding-left:3em}.ql-editor li.ql-indent-1:not(.ql-direction-rtl){padding-left:4.5em}.ql-editor .ql-indent-1.ql-direction-rtl.ql-align-right{padding-right:3em}.ql-editor li.ql-indent-1.ql-direction-rtl.ql-align-right{padding-right:4.5em}.ql-editor .ql-indent-2:not(.ql-direction-rtl){padding-left:6em}.ql-editor li.ql-indent-2:not(.ql-direction-rtl){padding-left:7.5em}.ql-editor .ql-indent-2.ql-direction-rtl.ql-align-right{padding-right:6em}.ql-editor li.ql-indent-2.ql-direction-rtl.ql-align-right{padding-right:7.5em}.ql-editor .ql-indent-3:not(.ql-direction-rtl){padding-left:9em}.ql-editor li.ql-indent-3:not(.ql-direction-rtl){padding-left:10.5em}.ql-editor .ql-indent-3.ql-direction-rtl.ql-align-right{padding-right:9em}.ql-editor li.ql-indent-3.ql-direction-rtl.ql-align-right{padding-right:10.5em}.ql-editor .ql-indent-4:not(.ql-direction-rtl){padding-left:12em}.ql-editor li.ql-indent-4:not(.ql-direction-rtl){padding-left:13.5em}.ql-editor .ql-indent-4.ql-direction-rtl.ql-align-right{padding-right:12em}.ql-editor li.ql-indent-4.ql-direction-rtl.ql-align-right{padding-right:13.5em}.ql-editor .ql-indent-5:not(.ql-direction-rtl){padding-left:15em}.ql-editor li.ql-indent-5:not(.ql-direction-rtl){padding-left:16.5em}.ql-editor .ql-indent-5.ql-direction-rtl.ql-align-right{padding-right:15em}.ql-editor li.ql-indent-5.ql-direction-rtl.ql-align-right{padding-right:16.5em}.ql-editor .ql-indent-6:not(.ql-direction-rtl){padding-left:18em}.ql-editor li.ql-indent-6:not(.ql-direction-rtl){padding-left:19.5em}.ql-editor .ql-indent-6.ql-direction-rtl.ql-align-right{padding-right:18em}.ql-editor li.ql-indent-6.ql-direction-rtl.ql-align-right{padding-right:19.5em}.ql-editor .ql-indent-7:not(.ql-direction-rtl){padding-left:21em}.ql-editor li.ql-indent-7:not(.ql-direction-rtl){padding-left:22.5em}.ql-editor .ql-indent-7.ql-direction-rtl.ql-align-right{padding-right:21em}.ql-editor li.ql-indent-7.ql-direction-rtl.ql-align-right{padding-right:22.5em}.ql-editor .ql-indent-8:not(.ql-direction-rtl){padding-left:24em}.ql-editor li.ql-indent-8:not(.ql-direction-rtl){padding-left:25.5em}.ql-editor .ql-indent-8.ql-direction-rtl.ql-align-right{padding-right:24em}.ql-editor li.ql-indent-8.ql-direction-rtl.ql-align-right{padding-right:25.5em}.ql-editor .ql-indent-9:not(.ql-direction-rtl){padding-left:27em}.ql-editor li.ql-indent-9:not(.ql-direction-rtl){padding-left:28.5em}.ql-editor .ql-indent-9.ql-direction-rtl.ql-align-right{padding-right:27em}.ql-editor li.ql-indent-9.ql-direction-rtl.ql-align-right{padding-right:28.5em}.ql-editor .ql-video{display:block;max-width:100%}.ql-editor .ql-video.ql-align-center{margin:0 auto}.ql-editor .ql-video.ql-align-right{margin:0 0 0 auto}.ql-editor .ql-bg-black{background-color:#000}.ql-editor .ql-bg-red{background-color:#e60000}.ql-editor .ql-bg-orange{background-color:#f90}.ql-editor .ql-bg-yellow{background-color:#ff0}.ql-editor .ql-bg-green{background-color:#008a00}.ql-editor .ql-bg-blue{background-color:#06c}.ql-editor .ql-bg-purple{background-color:#93f}.ql-editor .ql-color-white{color:#fff}.ql-editor .ql-color-red{color:#e60000}.ql-editor .ql-color-orange{color:#f90}.ql-editor .ql-color-yellow{color:#ff0}.ql-editor .ql-color-green{color:#008a00}.ql-editor .ql-color-blue{color:#06c}.ql-editor .ql-color-purple{color:#93f}.ql-editor .ql-font-serif{font-family:Georgia,Times New Roman,serif}.ql-editor .ql-font-monospace{font-family:Monaco,Courier New,monospace}.ql-editor .ql-size-small{font-size:.75em}.ql-editor .ql-size-large{font-size:1.5em}.ql-editor .ql-size-huge{font-size:2.5em}.ql-editor .ql-direction-rtl{direction:rtl;text-align:inherit}.ql-editor .ql-align-center{text-align:center}.ql-editor .ql-align-justify{text-align:justify}.ql-editor .ql-align-right{text-align:right}.ql-editor .ql-embed-selected{border:1px solid #777;user-select:none}.ql-editor.ql-blank:before{color:rgba(0,0,0,.6);content:attr(data-placeholder);font-style:italic;pointer-events:none;position:absolute}.ql-bubble.ql-toolbar:after,.ql-bubble .ql-toolbar:after{clear:both;content:\"\";display:table}.ql-bubble.ql-toolbar button,.ql-bubble .ql-toolbar button{background:none;border:none;cursor:pointer;display:inline-block;float:left;height:24px;padding:3px 5px;width:28px}.ql-bubble.ql-toolbar button svg,.ql-bubble .ql-toolbar button svg{float:left;height:100%}.ql-bubble.ql-toolbar button:active:hover,.ql-bubble .ql-toolbar button:active:hover{outline:none}.ql-bubble.ql-toolbar input.ql-image[type=file],.ql-bubble .ql-toolbar input.ql-image[type=file]{display:none}.ql-bubble.ql-toolbar .ql-picker-item.ql-selected,.ql-bubble .ql-toolbar .ql-picker-item.ql-selected,.ql-bubble.ql-toolbar .ql-picker-item:hover,.ql-bubble .ql-toolbar .ql-picker-item:hover,.ql-bubble.ql-toolbar .ql-picker-label.ql-active,.ql-bubble .ql-toolbar .ql-picker-label.ql-active,.ql-bubble.ql-toolbar .ql-picker-label:hover,.ql-bubble .ql-toolbar .ql-picker-label:hover,.ql-bubble.ql-toolbar button.ql-active,.ql-bubble .ql-toolbar button.ql-active,.ql-bubble.ql-toolbar button:focus,.ql-bubble .ql-toolbar button:focus,.ql-bubble.ql-toolbar button:hover,.ql-bubble .ql-toolbar button:hover{color:#fff}.ql-bubble.ql-toolbar .ql-picker-item.ql-selected .ql-fill,.ql-bubble .ql-toolbar .ql-picker-item.ql-selected .ql-fill,.ql-bubble.ql-toolbar .ql-picker-item.ql-selected .ql-stroke.ql-fill,.ql-bubble .ql-toolbar .ql-picker-item.ql-selected .ql-stroke.ql-fill,.ql-bubble.ql-toolbar .ql-picker-item:hover .ql-fill,.ql-bubble .ql-toolbar .ql-picker-item:hover .ql-fill,.ql-bubble.ql-toolbar .ql-picker-item:hover .ql-stroke.ql-fill,.ql-bubble .ql-toolbar .ql-picker-item:hover .ql-stroke.ql-fill,.ql-bubble.ql-toolbar .ql-picker-label.ql-active .ql-fill,.ql-bubble .ql-toolbar .ql-picker-label.ql-active .ql-fill,.ql-bubble.ql-toolbar .ql-picker-label.ql-active .ql-stroke.ql-fill,.ql-bubble .ql-toolbar .ql-picker-label.ql-active .ql-stroke.ql-fill,.ql-bubble.ql-toolbar .ql-picker-label:hover .ql-fill,.ql-bubble .ql-toolbar .ql-picker-label:hover .ql-fill,.ql-bubble.ql-toolbar .ql-picker-label:hover .ql-stroke.ql-fill,.ql-bubble .ql-toolbar .ql-picker-label:hover .ql-stroke.ql-fill,.ql-bubble.ql-toolbar button.ql-active .ql-fill,.ql-bubble .ql-toolbar button.ql-active .ql-fill,.ql-bubble.ql-toolbar button.ql-active .ql-stroke.ql-fill,.ql-bubble .ql-toolbar button.ql-active .ql-stroke.ql-fill,.ql-bubble.ql-toolbar button:focus .ql-fill,.ql-bubble .ql-toolbar button:focus .ql-fill,.ql-bubble.ql-toolbar button:focus .ql-stroke.ql-fill,.ql-bubble .ql-toolbar button:focus .ql-stroke.ql-fill,.ql-bubble.ql-toolbar button:hover .ql-fill,.ql-bubble .ql-toolbar button:hover .ql-fill,.ql-bubble.ql-toolbar button:hover .ql-stroke.ql-fill,.ql-bubble .ql-toolbar button:hover .ql-stroke.ql-fill{fill:#fff}.ql-bubble.ql-toolbar .ql-picker-item.ql-selected .ql-stroke,.ql-bubble .ql-toolbar .ql-picker-item.ql-selected .ql-stroke,.ql-bubble.ql-toolbar .ql-picker-item.ql-selected .ql-stroke-miter,.ql-bubble .ql-toolbar .ql-picker-item.ql-selected .ql-stroke-miter,.ql-bubble.ql-toolbar .ql-picker-item:hover .ql-stroke,.ql-bubble .ql-toolbar .ql-picker-item:hover .ql-stroke,.ql-bubble.ql-toolbar .ql-picker-item:hover .ql-stroke-miter,.ql-bubble .ql-toolbar .ql-picker-item:hover .ql-stroke-miter,.ql-bubble.ql-toolbar .ql-picker-label.ql-active .ql-stroke,.ql-bubble .ql-toolbar .ql-picker-label.ql-active .ql-stroke,.ql-bubble.ql-toolbar .ql-picker-label.ql-active .ql-stroke-miter,.ql-bubble .ql-toolbar .ql-picker-label.ql-active .ql-stroke-miter,.ql-bubble.ql-toolbar .ql-picker-label:hover .ql-stroke,.ql-bubble .ql-toolbar .ql-picker-label:hover .ql-stroke,.ql-bubble.ql-toolbar .ql-picker-label:hover .ql-stroke-miter,.ql-bubble .ql-toolbar .ql-picker-label:hover .ql-stroke-miter,.ql-bubble.ql-toolbar button.ql-active .ql-stroke,.ql-bubble .ql-toolbar button.ql-active .ql-stroke,.ql-bubble.ql-toolbar button.ql-active .ql-stroke-miter,.ql-bubble .ql-toolbar button.ql-active .ql-stroke-miter,.ql-bubble.ql-toolbar button:focus .ql-stroke,.ql-bubble .ql-toolbar button:focus .ql-stroke,.ql-bubble.ql-toolbar button:focus .ql-stroke-miter,.ql-bubble .ql-toolbar button:focus .ql-stroke-miter,.ql-bubble.ql-toolbar button:hover .ql-stroke,.ql-bubble .ql-toolbar button:hover .ql-stroke,.ql-bubble.ql-toolbar button:hover .ql-stroke-miter,.ql-bubble .ql-toolbar button:hover .ql-stroke-miter{stroke:#fff}@media (pointer:coarse){.ql-bubble.ql-toolbar button:hover:not(.ql-active),.ql-bubble .ql-toolbar button:hover:not(.ql-active){color:#ccc}.ql-bubble.ql-toolbar button:hover:not(.ql-active) .ql-fill,.ql-bubble .ql-toolbar button:hover:not(.ql-active) .ql-fill,.ql-bubble.ql-toolbar button:hover:not(.ql-active) .ql-stroke.ql-fill,.ql-bubble .ql-toolbar button:hover:not(.ql-active) .ql-stroke.ql-fill{fill:#ccc}.ql-bubble.ql-toolbar button:hover:not(.ql-active) .ql-stroke,.ql-bubble .ql-toolbar button:hover:not(.ql-active) .ql-stroke,.ql-bubble.ql-toolbar button:hover:not(.ql-active) .ql-stroke-miter,.ql-bubble .ql-toolbar button:hover:not(.ql-active) .ql-stroke-miter{stroke:#ccc}}.ql-bubble,.ql-bubble *{box-sizing:border-box}.ql-bubble .ql-hidden{display:none}.ql-bubble .ql-out-bottom,.ql-bubble .ql-out-top{visibility:hidden}.ql-bubble .ql-tooltip{position:absolute;transform:translateY(10px)}.ql-bubble .ql-tooltip a{cursor:pointer;text-decoration:none}.ql-bubble .ql-tooltip.ql-flip{transform:translateY(-10px)}.ql-bubble .ql-formats{display:inline-block;vertical-align:middle}.ql-bubble .ql-formats:after{clear:both;content:\"\";display:table}.ql-bubble .ql-stroke{fill:none;stroke:#ccc;stroke-linecap:round;stroke-linejoin:round;stroke-width:2}.ql-bubble .ql-stroke-miter{fill:none;stroke:#ccc;stroke-miterlimit:10;stroke-width:2}.ql-bubble .ql-fill,.ql-bubble .ql-stroke.ql-fill{fill:#ccc}.ql-bubble .ql-empty{fill:none}.ql-bubble .ql-even{fill-rule:evenodd}.ql-bubble .ql-stroke.ql-thin,.ql-bubble .ql-thin{stroke-width:1}.ql-bubble .ql-transparent{opacity:.4}.ql-bubble .ql-direction svg:last-child{display:none}.ql-bubble .ql-direction.ql-active svg:last-child{display:inline}.ql-bubble .ql-direction.ql-active svg:first-child{display:none}.ql-bubble .ql-editor h1{font-size:2em}.ql-bubble .ql-editor h2{font-size:1.5em}.ql-bubble .ql-editor h3{font-size:1.17em}.ql-bubble .ql-editor h4{font-size:1em}.ql-bubble .ql-editor h5{font-size:.83em}.ql-bubble .ql-editor h6{font-size:.67em}.ql-bubble .ql-editor a{text-decoration:underline}.ql-bubble .ql-editor blockquote{border-left:4px solid #ccc;margin-bottom:5px;margin-top:5px;padding-left:16px}.ql-bubble .ql-editor code,.ql-bubble .ql-editor pre{background-color:#f0f0f0;border-radius:3px}.ql-bubble .ql-editor pre{white-space:pre-wrap;margin-bottom:5px;margin-top:5px;padding:5px 10px}.ql-bubble .ql-editor code{font-size:85%;padding-bottom:2px;padding-top:2px}.ql-bubble .ql-editor code:after,.ql-bubble .ql-editor code:before{content:\"\\A0\";letter-spacing:-2px}.ql-bubble .ql-editor pre.ql-syntax{background-color:#23241f;color:#f8f8f2;overflow:visible}.ql-bubble .ql-editor img{max-width:100%}.ql-bubble .ql-picker{color:#ccc;display:inline-block;float:left;font-size:14px;font-weight:500;height:24px;position:relative;vertical-align:middle}.ql-bubble .ql-picker-label{cursor:pointer;display:inline-block;height:100%;padding-left:8px;padding-right:2px;position:relative;width:100%}.ql-bubble .ql-picker-label:before{display:inline-block;line-height:22px}.ql-bubble .ql-picker-options{background-color:#444;display:none;min-width:100%;padding:4px 8px;position:absolute;white-space:nowrap}.ql-bubble .ql-picker-options .ql-picker-item{cursor:pointer;display:block;padding-bottom:5px;padding-top:5px}.ql-bubble .ql-picker.ql-expanded .ql-picker-label{color:#777;z-index:2}.ql-bubble .ql-picker.ql-expanded .ql-picker-label .ql-fill{fill:#777}.ql-bubble .ql-picker.ql-expanded .ql-picker-label .ql-stroke{stroke:#777}.ql-bubble .ql-picker.ql-expanded .ql-picker-options{display:block;margin-top:-1px;top:100%;z-index:1}.ql-bubble .ql-color-picker,.ql-bubble .ql-icon-picker{width:28px}.ql-bubble .ql-color-picker .ql-picker-label,.ql-bubble .ql-icon-picker .ql-picker-label{padding:2px 4px}.ql-bubble .ql-color-picker .ql-picker-label svg,.ql-bubble .ql-icon-picker .ql-picker-label svg{right:4px}.ql-bubble .ql-icon-picker .ql-picker-options{padding:4px 0}.ql-bubble .ql-icon-picker .ql-picker-item{height:24px;width:24px;padding:2px 4px}.ql-bubble .ql-color-picker .ql-picker-options{padding:3px 5px;width:152px}.ql-bubble .ql-color-picker .ql-picker-item{border:1px solid transparent;float:left;height:16px;margin:2px;padding:0;width:16px}.ql-bubble .ql-picker:not(.ql-color-picker):not(.ql-icon-picker) svg{position:absolute;margin-top:-9px;right:0;top:50%;width:18px}.ql-bubble .ql-picker.ql-font .ql-picker-item[data-label]:not([data-label=\"\"]):before,.ql-bubble .ql-picker.ql-font .ql-picker-label[data-label]:not([data-label=\"\"]):before,.ql-bubble .ql-picker.ql-header .ql-picker-item[data-label]:not([data-label=\"\"]):before,.ql-bubble .ql-picker.ql-header .ql-picker-label[data-label]:not([data-label=\"\"]):before,.ql-bubble .ql-picker.ql-size .ql-picker-item[data-label]:not([data-label=\"\"]):before,.ql-bubble .ql-picker.ql-size .ql-picker-label[data-label]:not([data-label=\"\"]):before{content:attr(data-label)}.ql-bubble .ql-picker.ql-header{width:98px}.ql-bubble .ql-picker.ql-header .ql-picker-item:before,.ql-bubble .ql-picker.ql-header .ql-picker-label:before{content:\"Normal\"}.ql-bubble .ql-picker.ql-header .ql-picker-item[data-value=\"1\"]:before,.ql-bubble .ql-picker.ql-header .ql-picker-label[data-value=\"1\"]:before{content:\"Heading 1\"}.ql-bubble .ql-picker.ql-header .ql-picker-item[data-value=\"2\"]:before,.ql-bubble .ql-picker.ql-header .ql-picker-label[data-value=\"2\"]:before{content:\"Heading 2\"}.ql-bubble .ql-picker.ql-header .ql-picker-item[data-value=\"3\"]:before,.ql-bubble .ql-picker.ql-header .ql-picker-label[data-value=\"3\"]:before{content:\"Heading 3\"}.ql-bubble .ql-picker.ql-header .ql-picker-item[data-value=\"4\"]:before,.ql-bubble .ql-picker.ql-header .ql-picker-label[data-value=\"4\"]:before{content:\"Heading 4\"}.ql-bubble .ql-picker.ql-header .ql-picker-item[data-value=\"5\"]:before,.ql-bubble .ql-picker.ql-header .ql-picker-label[data-value=\"5\"]:before{content:\"Heading 5\"}.ql-bubble .ql-picker.ql-header .ql-picker-item[data-value=\"6\"]:before,.ql-bubble .ql-picker.ql-header .ql-picker-label[data-value=\"6\"]:before{content:\"Heading 6\"}.ql-bubble .ql-picker.ql-header .ql-picker-item[data-value=\"1\"]:before{font-size:2em}.ql-bubble .ql-picker.ql-header .ql-picker-item[data-value=\"2\"]:before{font-size:1.5em}.ql-bubble .ql-picker.ql-header .ql-picker-item[data-value=\"3\"]:before{font-size:1.17em}.ql-bubble .ql-picker.ql-header .ql-picker-item[data-value=\"4\"]:before{font-size:1em}.ql-bubble .ql-picker.ql-header .ql-picker-item[data-value=\"5\"]:before{font-size:.83em}.ql-bubble .ql-picker.ql-header .ql-picker-item[data-value=\"6\"]:before{font-size:.67em}.ql-bubble .ql-picker.ql-font{width:108px}.ql-bubble .ql-picker.ql-font .ql-picker-item:before,.ql-bubble .ql-picker.ql-font .ql-picker-label:before{content:\"Sans Serif\"}.ql-bubble .ql-picker.ql-font .ql-picker-item[data-value=serif]:before,.ql-bubble .ql-picker.ql-font .ql-picker-label[data-value=serif]:before{content:\"Serif\"}.ql-bubble .ql-picker.ql-font .ql-picker-item[data-value=monospace]:before,.ql-bubble .ql-picker.ql-font .ql-picker-label[data-value=monospace]:before{content:\"Monospace\"}.ql-bubble .ql-picker.ql-font .ql-picker-item[data-value=serif]:before{font-family:Georgia,Times New Roman,serif}.ql-bubble .ql-picker.ql-font .ql-picker-item[data-value=monospace]:before{font-family:Monaco,Courier New,monospace}.ql-bubble .ql-picker.ql-size{width:98px}.ql-bubble .ql-picker.ql-size .ql-picker-item:before,.ql-bubble .ql-picker.ql-size .ql-picker-label:before{content:\"Normal\"}.ql-bubble .ql-picker.ql-size .ql-picker-item[data-value=small]:before,.ql-bubble .ql-picker.ql-size .ql-picker-label[data-value=small]:before{content:\"Small\"}.ql-bubble .ql-picker.ql-size .ql-picker-item[data-value=large]:before,.ql-bubble .ql-picker.ql-size .ql-picker-label[data-value=large]:before{content:\"Large\"}.ql-bubble .ql-picker.ql-size .ql-picker-item[data-value=huge]:before,.ql-bubble .ql-picker.ql-size .ql-picker-label[data-value=huge]:before{content:\"Huge\"}.ql-bubble .ql-picker.ql-size .ql-picker-item[data-value=small]:before{font-size:10px}.ql-bubble .ql-picker.ql-size .ql-picker-item[data-value=large]:before{font-size:18px}.ql-bubble .ql-picker.ql-size .ql-picker-item[data-value=huge]:before{font-size:32px}.ql-bubble .ql-color-picker.ql-background .ql-picker-item{background-color:#fff}.ql-bubble .ql-color-picker.ql-color .ql-picker-item{background-color:#000}.ql-bubble .ql-toolbar .ql-formats{margin:8px 12px 8px 0}.ql-bubble .ql-toolbar .ql-formats:first-child{margin-left:12px}.ql-bubble .ql-color-picker svg{margin:1px}.ql-bubble .ql-color-picker .ql-picker-item.ql-selected,.ql-bubble .ql-color-picker .ql-picker-item:hover{border-color:#fff}.ql-bubble .ql-tooltip{background-color:#444;border-radius:25px;color:#fff}.ql-bubble .ql-tooltip-arrow{border-left:6px solid transparent;border-right:6px solid transparent;content:\" \";display:block;left:50%;margin-left:-6px;position:absolute}.ql-bubble .ql-tooltip:not(.ql-flip) .ql-tooltip-arrow{border-bottom:6px solid #444;top:-6px}.ql-bubble .ql-tooltip.ql-flip .ql-tooltip-arrow{border-top:6px solid #444;bottom:-6px}.ql-bubble .ql-tooltip.ql-editing .ql-tooltip-editor{display:block}.ql-bubble .ql-tooltip.ql-editing .ql-formats{visibility:hidden}.ql-bubble .ql-tooltip-editor{display:none}.ql-bubble .ql-tooltip-editor input[type=text]{background:transparent;border:none;color:#fff;font-size:13px;height:100%;outline:none;padding:10px 20px;position:absolute;width:100%}.ql-bubble .ql-tooltip-editor a{top:10px;position:absolute;right:20px}.ql-bubble .ql-tooltip-editor a:before{color:#ccc;content:\"\\D7\";font-size:16px;font-weight:700}.ql-container.ql-bubble:not(.ql-disabled) a{position:relative;white-space:nowrap}.ql-container.ql-bubble:not(.ql-disabled) a:before{background-color:#444;border-radius:15px;top:-5px;font-size:12px;color:#fff;content:attr(href);font-weight:400;overflow:hidden;padding:5px 15px;text-decoration:none;z-index:1}.ql-container.ql-bubble:not(.ql-disabled) a:after{border-top:6px solid #444;border-left:6px solid transparent;border-right:6px solid transparent;top:0;content:\" \";height:0;width:0}.ql-container.ql-bubble:not(.ql-disabled) a:after,.ql-container.ql-bubble:not(.ql-disabled) a:before{left:0;margin-left:50%;position:absolute;transform:translate(-50%,-100%);transition:visibility 0s ease .2s;visibility:hidden}.ql-container.ql-bubble:not(.ql-disabled) a:hover:after,.ql-container.ql-bubble:not(.ql-disabled) a:hover:before{visibility:visible}", ""]);
	
	// exports


/***/ },
/* 816 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(122)(false);
	// imports
	
	
	// module
	exports.push([module.id, "/*!\n * Quill Editor v1.3.0\n * https://quilljs.com/\n * Copyright (c) 2014, Jason Chen\n * Copyright (c) 2013, salesforce.com\n */.ql-container{box-sizing:border-box;font-family:Helvetica,Arial,sans-serif;font-size:13px;height:100%;margin:0;position:relative}.ql-container.ql-disabled .ql-tooltip{visibility:hidden}.ql-container.ql-disabled .ql-editor ul[data-checked]>li:before{pointer-events:none}.ql-clipboard{left:-100000px;height:1px;overflow-y:hidden;position:absolute;top:50%}.ql-clipboard p{margin:0;padding:0}.ql-editor{box-sizing:border-box;line-height:1.42;height:100%;outline:none;overflow-y:auto;padding:12px 15px;tab-size:4;-moz-tab-size:4;text-align:left;white-space:pre-wrap;word-wrap:break-word}.ql-editor>*{cursor:text}.ql-editor blockquote,.ql-editor h1,.ql-editor h2,.ql-editor h3,.ql-editor h4,.ql-editor h5,.ql-editor h6,.ql-editor ol,.ql-editor p,.ql-editor pre,.ql-editor ul{margin:0;padding:0;counter-reset:list-1 list-2 list-3 list-4 list-5 list-6 list-7 list-8 list-9}.ql-editor ol,.ql-editor ul{padding-left:1.5em}.ql-editor ol>li,.ql-editor ul>li{list-style-type:none}.ql-editor ul>li:before{content:\"\\2022\"}.ql-editor ul[data-checked=false],.ql-editor ul[data-checked=true]{pointer-events:none}.ql-editor ul[data-checked=false]>li *,.ql-editor ul[data-checked=true]>li *{pointer-events:all}.ql-editor ul[data-checked=false]>li:before,.ql-editor ul[data-checked=true]>li:before{color:#777;cursor:pointer;pointer-events:all}.ql-editor ul[data-checked=true]>li:before{content:\"\\2611\"}.ql-editor ul[data-checked=false]>li:before{content:\"\\2610\"}.ql-editor li:before{display:inline-block;white-space:nowrap;width:1.2em}.ql-editor li:not(.ql-direction-rtl):before{margin-left:-1.5em;margin-right:.3em;text-align:right}.ql-editor li.ql-direction-rtl:before{margin-left:.3em;margin-right:-1.5em}.ql-editor ol li:not(.ql-direction-rtl),.ql-editor ul li:not(.ql-direction-rtl){padding-left:1.5em}.ql-editor ol li.ql-direction-rtl,.ql-editor ul li.ql-direction-rtl{padding-right:1.5em}.ql-editor ol li{counter-reset:list-1 list-2 list-3 list-4 list-5 list-6 list-7 list-8 list-9;counter-increment:list-0}.ql-editor ol li:before{content:counter(list-0,decimal) \". \"}.ql-editor ol li.ql-indent-1{counter-increment:list-1}.ql-editor ol li.ql-indent-1:before{content:counter(list-1,lower-alpha) \". \"}.ql-editor ol li.ql-indent-1{counter-reset:list-2 list-3 list-4 list-5 list-6 list-7 list-8 list-9}.ql-editor ol li.ql-indent-2{counter-increment:list-2}.ql-editor ol li.ql-indent-2:before{content:counter(list-2,lower-roman) \". \"}.ql-editor ol li.ql-indent-2{counter-reset:list-3 list-4 list-5 list-6 list-7 list-8 list-9}.ql-editor ol li.ql-indent-3{counter-increment:list-3}.ql-editor ol li.ql-indent-3:before{content:counter(list-3,decimal) \". \"}.ql-editor ol li.ql-indent-3{counter-reset:list-4 list-5 list-6 list-7 list-8 list-9}.ql-editor ol li.ql-indent-4{counter-increment:list-4}.ql-editor ol li.ql-indent-4:before{content:counter(list-4,lower-alpha) \". \"}.ql-editor ol li.ql-indent-4{counter-reset:list-5 list-6 list-7 list-8 list-9}.ql-editor ol li.ql-indent-5{counter-increment:list-5}.ql-editor ol li.ql-indent-5:before{content:counter(list-5,lower-roman) \". \"}.ql-editor ol li.ql-indent-5{counter-reset:list-6 list-7 list-8 list-9}.ql-editor ol li.ql-indent-6{counter-increment:list-6}.ql-editor ol li.ql-indent-6:before{content:counter(list-6,decimal) \". \"}.ql-editor ol li.ql-indent-6{counter-reset:list-7 list-8 list-9}.ql-editor ol li.ql-indent-7{counter-increment:list-7}.ql-editor ol li.ql-indent-7:before{content:counter(list-7,lower-alpha) \". \"}.ql-editor ol li.ql-indent-7{counter-reset:list-8 list-9}.ql-editor ol li.ql-indent-8{counter-increment:list-8}.ql-editor ol li.ql-indent-8:before{content:counter(list-8,lower-roman) \". \"}.ql-editor ol li.ql-indent-8{counter-reset:list-9}.ql-editor ol li.ql-indent-9{counter-increment:list-9}.ql-editor ol li.ql-indent-9:before{content:counter(list-9,decimal) \". \"}.ql-editor .ql-indent-1:not(.ql-direction-rtl){padding-left:3em}.ql-editor li.ql-indent-1:not(.ql-direction-rtl){padding-left:4.5em}.ql-editor .ql-indent-1.ql-direction-rtl.ql-align-right{padding-right:3em}.ql-editor li.ql-indent-1.ql-direction-rtl.ql-align-right{padding-right:4.5em}.ql-editor .ql-indent-2:not(.ql-direction-rtl){padding-left:6em}.ql-editor li.ql-indent-2:not(.ql-direction-rtl){padding-left:7.5em}.ql-editor .ql-indent-2.ql-direction-rtl.ql-align-right{padding-right:6em}.ql-editor li.ql-indent-2.ql-direction-rtl.ql-align-right{padding-right:7.5em}.ql-editor .ql-indent-3:not(.ql-direction-rtl){padding-left:9em}.ql-editor li.ql-indent-3:not(.ql-direction-rtl){padding-left:10.5em}.ql-editor .ql-indent-3.ql-direction-rtl.ql-align-right{padding-right:9em}.ql-editor li.ql-indent-3.ql-direction-rtl.ql-align-right{padding-right:10.5em}.ql-editor .ql-indent-4:not(.ql-direction-rtl){padding-left:12em}.ql-editor li.ql-indent-4:not(.ql-direction-rtl){padding-left:13.5em}.ql-editor .ql-indent-4.ql-direction-rtl.ql-align-right{padding-right:12em}.ql-editor li.ql-indent-4.ql-direction-rtl.ql-align-right{padding-right:13.5em}.ql-editor .ql-indent-5:not(.ql-direction-rtl){padding-left:15em}.ql-editor li.ql-indent-5:not(.ql-direction-rtl){padding-left:16.5em}.ql-editor .ql-indent-5.ql-direction-rtl.ql-align-right{padding-right:15em}.ql-editor li.ql-indent-5.ql-direction-rtl.ql-align-right{padding-right:16.5em}.ql-editor .ql-indent-6:not(.ql-direction-rtl){padding-left:18em}.ql-editor li.ql-indent-6:not(.ql-direction-rtl){padding-left:19.5em}.ql-editor .ql-indent-6.ql-direction-rtl.ql-align-right{padding-right:18em}.ql-editor li.ql-indent-6.ql-direction-rtl.ql-align-right{padding-right:19.5em}.ql-editor .ql-indent-7:not(.ql-direction-rtl){padding-left:21em}.ql-editor li.ql-indent-7:not(.ql-direction-rtl){padding-left:22.5em}.ql-editor .ql-indent-7.ql-direction-rtl.ql-align-right{padding-right:21em}.ql-editor li.ql-indent-7.ql-direction-rtl.ql-align-right{padding-right:22.5em}.ql-editor .ql-indent-8:not(.ql-direction-rtl){padding-left:24em}.ql-editor li.ql-indent-8:not(.ql-direction-rtl){padding-left:25.5em}.ql-editor .ql-indent-8.ql-direction-rtl.ql-align-right{padding-right:24em}.ql-editor li.ql-indent-8.ql-direction-rtl.ql-align-right{padding-right:25.5em}.ql-editor .ql-indent-9:not(.ql-direction-rtl){padding-left:27em}.ql-editor li.ql-indent-9:not(.ql-direction-rtl){padding-left:28.5em}.ql-editor .ql-indent-9.ql-direction-rtl.ql-align-right{padding-right:27em}.ql-editor li.ql-indent-9.ql-direction-rtl.ql-align-right{padding-right:28.5em}.ql-editor .ql-video{display:block;max-width:100%}.ql-editor .ql-video.ql-align-center{margin:0 auto}.ql-editor .ql-video.ql-align-right{margin:0 0 0 auto}.ql-editor .ql-bg-black{background-color:#000}.ql-editor .ql-bg-red{background-color:#e60000}.ql-editor .ql-bg-orange{background-color:#f90}.ql-editor .ql-bg-yellow{background-color:#ff0}.ql-editor .ql-bg-green{background-color:#008a00}.ql-editor .ql-bg-blue{background-color:#06c}.ql-editor .ql-bg-purple{background-color:#93f}.ql-editor .ql-color-white{color:#fff}.ql-editor .ql-color-red{color:#e60000}.ql-editor .ql-color-orange{color:#f90}.ql-editor .ql-color-yellow{color:#ff0}.ql-editor .ql-color-green{color:#008a00}.ql-editor .ql-color-blue{color:#06c}.ql-editor .ql-color-purple{color:#93f}.ql-editor .ql-font-serif{font-family:Georgia,Times New Roman,serif}.ql-editor .ql-font-monospace{font-family:Monaco,Courier New,monospace}.ql-editor .ql-size-small{font-size:.75em}.ql-editor .ql-size-large{font-size:1.5em}.ql-editor .ql-size-huge{font-size:2.5em}.ql-editor .ql-direction-rtl{direction:rtl;text-align:inherit}.ql-editor .ql-align-center{text-align:center}.ql-editor .ql-align-justify{text-align:justify}.ql-editor .ql-align-right{text-align:right}.ql-editor .ql-embed-selected{border:1px solid #777;user-select:none}.ql-editor.ql-blank:before{color:rgba(0,0,0,.6);content:attr(data-placeholder);font-style:italic;pointer-events:none;position:absolute}", ""]);
	
	// exports


/***/ },
/* 817 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(122)(false);
	// imports
	
	
	// module
	exports.push([module.id, "/*!\n * Quill Editor v1.3.0\n * https://quilljs.com/\n * Copyright (c) 2014, Jason Chen\n * Copyright (c) 2013, salesforce.com\n */.ql-container{box-sizing:border-box;font-family:Helvetica,Arial,sans-serif;font-size:13px;height:100%;margin:0;position:relative}.ql-container.ql-disabled .ql-tooltip{visibility:hidden}.ql-container.ql-disabled .ql-editor ul[data-checked]>li:before{pointer-events:none}.ql-clipboard{left:-100000px;height:1px;overflow-y:hidden;position:absolute;top:50%}.ql-clipboard p{margin:0;padding:0}.ql-editor{box-sizing:border-box;line-height:1.42;height:100%;outline:none;overflow-y:auto;padding:12px 15px;tab-size:4;-moz-tab-size:4;text-align:left;white-space:pre-wrap;word-wrap:break-word}.ql-editor>*{cursor:text}.ql-editor blockquote,.ql-editor h1,.ql-editor h2,.ql-editor h3,.ql-editor h4,.ql-editor h5,.ql-editor h6,.ql-editor ol,.ql-editor p,.ql-editor pre,.ql-editor ul{margin:0;padding:0;counter-reset:list-1 list-2 list-3 list-4 list-5 list-6 list-7 list-8 list-9}.ql-editor ol,.ql-editor ul{padding-left:1.5em}.ql-editor ol>li,.ql-editor ul>li{list-style-type:none}.ql-editor ul>li:before{content:\"\\2022\"}.ql-editor ul[data-checked=false],.ql-editor ul[data-checked=true]{pointer-events:none}.ql-editor ul[data-checked=false]>li *,.ql-editor ul[data-checked=true]>li *{pointer-events:all}.ql-editor ul[data-checked=false]>li:before,.ql-editor ul[data-checked=true]>li:before{color:#777;cursor:pointer;pointer-events:all}.ql-editor ul[data-checked=true]>li:before{content:\"\\2611\"}.ql-editor ul[data-checked=false]>li:before{content:\"\\2610\"}.ql-editor li:before{display:inline-block;white-space:nowrap;width:1.2em}.ql-editor li:not(.ql-direction-rtl):before{margin-left:-1.5em;margin-right:.3em;text-align:right}.ql-editor li.ql-direction-rtl:before{margin-left:.3em;margin-right:-1.5em}.ql-editor ol li:not(.ql-direction-rtl),.ql-editor ul li:not(.ql-direction-rtl){padding-left:1.5em}.ql-editor ol li.ql-direction-rtl,.ql-editor ul li.ql-direction-rtl{padding-right:1.5em}.ql-editor ol li{counter-reset:list-1 list-2 list-3 list-4 list-5 list-6 list-7 list-8 list-9;counter-increment:list-0}.ql-editor ol li:before{content:counter(list-0,decimal) \". \"}.ql-editor ol li.ql-indent-1{counter-increment:list-1}.ql-editor ol li.ql-indent-1:before{content:counter(list-1,lower-alpha) \". \"}.ql-editor ol li.ql-indent-1{counter-reset:list-2 list-3 list-4 list-5 list-6 list-7 list-8 list-9}.ql-editor ol li.ql-indent-2{counter-increment:list-2}.ql-editor ol li.ql-indent-2:before{content:counter(list-2,lower-roman) \". \"}.ql-editor ol li.ql-indent-2{counter-reset:list-3 list-4 list-5 list-6 list-7 list-8 list-9}.ql-editor ol li.ql-indent-3{counter-increment:list-3}.ql-editor ol li.ql-indent-3:before{content:counter(list-3,decimal) \". \"}.ql-editor ol li.ql-indent-3{counter-reset:list-4 list-5 list-6 list-7 list-8 list-9}.ql-editor ol li.ql-indent-4{counter-increment:list-4}.ql-editor ol li.ql-indent-4:before{content:counter(list-4,lower-alpha) \". \"}.ql-editor ol li.ql-indent-4{counter-reset:list-5 list-6 list-7 list-8 list-9}.ql-editor ol li.ql-indent-5{counter-increment:list-5}.ql-editor ol li.ql-indent-5:before{content:counter(list-5,lower-roman) \". \"}.ql-editor ol li.ql-indent-5{counter-reset:list-6 list-7 list-8 list-9}.ql-editor ol li.ql-indent-6{counter-increment:list-6}.ql-editor ol li.ql-indent-6:before{content:counter(list-6,decimal) \". \"}.ql-editor ol li.ql-indent-6{counter-reset:list-7 list-8 list-9}.ql-editor ol li.ql-indent-7{counter-increment:list-7}.ql-editor ol li.ql-indent-7:before{content:counter(list-7,lower-alpha) \". \"}.ql-editor ol li.ql-indent-7{counter-reset:list-8 list-9}.ql-editor ol li.ql-indent-8{counter-increment:list-8}.ql-editor ol li.ql-indent-8:before{content:counter(list-8,lower-roman) \". \"}.ql-editor ol li.ql-indent-8{counter-reset:list-9}.ql-editor ol li.ql-indent-9{counter-increment:list-9}.ql-editor ol li.ql-indent-9:before{content:counter(list-9,decimal) \". \"}.ql-editor .ql-indent-1:not(.ql-direction-rtl){padding-left:3em}.ql-editor li.ql-indent-1:not(.ql-direction-rtl){padding-left:4.5em}.ql-editor .ql-indent-1.ql-direction-rtl.ql-align-right{padding-right:3em}.ql-editor li.ql-indent-1.ql-direction-rtl.ql-align-right{padding-right:4.5em}.ql-editor .ql-indent-2:not(.ql-direction-rtl){padding-left:6em}.ql-editor li.ql-indent-2:not(.ql-direction-rtl){padding-left:7.5em}.ql-editor .ql-indent-2.ql-direction-rtl.ql-align-right{padding-right:6em}.ql-editor li.ql-indent-2.ql-direction-rtl.ql-align-right{padding-right:7.5em}.ql-editor .ql-indent-3:not(.ql-direction-rtl){padding-left:9em}.ql-editor li.ql-indent-3:not(.ql-direction-rtl){padding-left:10.5em}.ql-editor .ql-indent-3.ql-direction-rtl.ql-align-right{padding-right:9em}.ql-editor li.ql-indent-3.ql-direction-rtl.ql-align-right{padding-right:10.5em}.ql-editor .ql-indent-4:not(.ql-direction-rtl){padding-left:12em}.ql-editor li.ql-indent-4:not(.ql-direction-rtl){padding-left:13.5em}.ql-editor .ql-indent-4.ql-direction-rtl.ql-align-right{padding-right:12em}.ql-editor li.ql-indent-4.ql-direction-rtl.ql-align-right{padding-right:13.5em}.ql-editor .ql-indent-5:not(.ql-direction-rtl){padding-left:15em}.ql-editor li.ql-indent-5:not(.ql-direction-rtl){padding-left:16.5em}.ql-editor .ql-indent-5.ql-direction-rtl.ql-align-right{padding-right:15em}.ql-editor li.ql-indent-5.ql-direction-rtl.ql-align-right{padding-right:16.5em}.ql-editor .ql-indent-6:not(.ql-direction-rtl){padding-left:18em}.ql-editor li.ql-indent-6:not(.ql-direction-rtl){padding-left:19.5em}.ql-editor .ql-indent-6.ql-direction-rtl.ql-align-right{padding-right:18em}.ql-editor li.ql-indent-6.ql-direction-rtl.ql-align-right{padding-right:19.5em}.ql-editor .ql-indent-7:not(.ql-direction-rtl){padding-left:21em}.ql-editor li.ql-indent-7:not(.ql-direction-rtl){padding-left:22.5em}.ql-editor .ql-indent-7.ql-direction-rtl.ql-align-right{padding-right:21em}.ql-editor li.ql-indent-7.ql-direction-rtl.ql-align-right{padding-right:22.5em}.ql-editor .ql-indent-8:not(.ql-direction-rtl){padding-left:24em}.ql-editor li.ql-indent-8:not(.ql-direction-rtl){padding-left:25.5em}.ql-editor .ql-indent-8.ql-direction-rtl.ql-align-right{padding-right:24em}.ql-editor li.ql-indent-8.ql-direction-rtl.ql-align-right{padding-right:25.5em}.ql-editor .ql-indent-9:not(.ql-direction-rtl){padding-left:27em}.ql-editor li.ql-indent-9:not(.ql-direction-rtl){padding-left:28.5em}.ql-editor .ql-indent-9.ql-direction-rtl.ql-align-right{padding-right:27em}.ql-editor li.ql-indent-9.ql-direction-rtl.ql-align-right{padding-right:28.5em}.ql-editor .ql-video{display:block;max-width:100%}.ql-editor .ql-video.ql-align-center{margin:0 auto}.ql-editor .ql-video.ql-align-right{margin:0 0 0 auto}.ql-editor .ql-bg-black{background-color:#000}.ql-editor .ql-bg-red{background-color:#e60000}.ql-editor .ql-bg-orange{background-color:#f90}.ql-editor .ql-bg-yellow{background-color:#ff0}.ql-editor .ql-bg-green{background-color:#008a00}.ql-editor .ql-bg-blue{background-color:#06c}.ql-editor .ql-bg-purple{background-color:#93f}.ql-editor .ql-color-white{color:#fff}.ql-editor .ql-color-red{color:#e60000}.ql-editor .ql-color-orange{color:#f90}.ql-editor .ql-color-yellow{color:#ff0}.ql-editor .ql-color-green{color:#008a00}.ql-editor .ql-color-blue{color:#06c}.ql-editor .ql-color-purple{color:#93f}.ql-editor .ql-font-serif{font-family:Georgia,Times New Roman,serif}.ql-editor .ql-font-monospace{font-family:Monaco,Courier New,monospace}.ql-editor .ql-size-small{font-size:.75em}.ql-editor .ql-size-large{font-size:1.5em}.ql-editor .ql-size-huge{font-size:2.5em}.ql-editor .ql-direction-rtl{direction:rtl;text-align:inherit}.ql-editor .ql-align-center{text-align:center}.ql-editor .ql-align-justify{text-align:justify}.ql-editor .ql-align-right{text-align:right}.ql-editor .ql-embed-selected{border:1px solid #777;user-select:none}.ql-editor.ql-blank:before{color:rgba(0,0,0,.6);content:attr(data-placeholder);font-style:italic;pointer-events:none;position:absolute}.ql-snow.ql-toolbar:after,.ql-snow .ql-toolbar:after{clear:both;content:\"\";display:table}.ql-snow.ql-toolbar button,.ql-snow .ql-toolbar button{background:none;border:none;cursor:pointer;display:inline-block;float:left;height:24px;padding:3px 5px;width:28px}.ql-snow.ql-toolbar button svg,.ql-snow .ql-toolbar button svg{float:left;height:100%}.ql-snow.ql-toolbar button:active:hover,.ql-snow .ql-toolbar button:active:hover{outline:none}.ql-snow.ql-toolbar input.ql-image[type=file],.ql-snow .ql-toolbar input.ql-image[type=file]{display:none}.ql-snow.ql-toolbar .ql-picker-item.ql-selected,.ql-snow .ql-toolbar .ql-picker-item.ql-selected,.ql-snow.ql-toolbar .ql-picker-item:hover,.ql-snow .ql-toolbar .ql-picker-item:hover,.ql-snow.ql-toolbar .ql-picker-label.ql-active,.ql-snow .ql-toolbar .ql-picker-label.ql-active,.ql-snow.ql-toolbar .ql-picker-label:hover,.ql-snow .ql-toolbar .ql-picker-label:hover,.ql-snow.ql-toolbar button.ql-active,.ql-snow .ql-toolbar button.ql-active,.ql-snow.ql-toolbar button:focus,.ql-snow .ql-toolbar button:focus,.ql-snow.ql-toolbar button:hover,.ql-snow .ql-toolbar button:hover{color:#06c}.ql-snow.ql-toolbar .ql-picker-item.ql-selected .ql-fill,.ql-snow .ql-toolbar .ql-picker-item.ql-selected .ql-fill,.ql-snow.ql-toolbar .ql-picker-item.ql-selected .ql-stroke.ql-fill,.ql-snow .ql-toolbar .ql-picker-item.ql-selected .ql-stroke.ql-fill,.ql-snow.ql-toolbar .ql-picker-item:hover .ql-fill,.ql-snow .ql-toolbar .ql-picker-item:hover .ql-fill,.ql-snow.ql-toolbar .ql-picker-item:hover .ql-stroke.ql-fill,.ql-snow .ql-toolbar .ql-picker-item:hover .ql-stroke.ql-fill,.ql-snow.ql-toolbar .ql-picker-label.ql-active .ql-fill,.ql-snow .ql-toolbar .ql-picker-label.ql-active .ql-fill,.ql-snow.ql-toolbar .ql-picker-label.ql-active .ql-stroke.ql-fill,.ql-snow .ql-toolbar .ql-picker-label.ql-active .ql-stroke.ql-fill,.ql-snow.ql-toolbar .ql-picker-label:hover .ql-fill,.ql-snow .ql-toolbar .ql-picker-label:hover .ql-fill,.ql-snow.ql-toolbar .ql-picker-label:hover .ql-stroke.ql-fill,.ql-snow .ql-toolbar .ql-picker-label:hover .ql-stroke.ql-fill,.ql-snow.ql-toolbar button.ql-active .ql-fill,.ql-snow .ql-toolbar button.ql-active .ql-fill,.ql-snow.ql-toolbar button.ql-active .ql-stroke.ql-fill,.ql-snow .ql-toolbar button.ql-active .ql-stroke.ql-fill,.ql-snow.ql-toolbar button:focus .ql-fill,.ql-snow .ql-toolbar button:focus .ql-fill,.ql-snow.ql-toolbar button:focus .ql-stroke.ql-fill,.ql-snow .ql-toolbar button:focus .ql-stroke.ql-fill,.ql-snow.ql-toolbar button:hover .ql-fill,.ql-snow .ql-toolbar button:hover .ql-fill,.ql-snow.ql-toolbar button:hover .ql-stroke.ql-fill,.ql-snow .ql-toolbar button:hover .ql-stroke.ql-fill{fill:#06c}.ql-snow.ql-toolbar .ql-picker-item.ql-selected .ql-stroke,.ql-snow .ql-toolbar .ql-picker-item.ql-selected .ql-stroke,.ql-snow.ql-toolbar .ql-picker-item.ql-selected .ql-stroke-miter,.ql-snow .ql-toolbar .ql-picker-item.ql-selected .ql-stroke-miter,.ql-snow.ql-toolbar .ql-picker-item:hover .ql-stroke,.ql-snow .ql-toolbar .ql-picker-item:hover .ql-stroke,.ql-snow.ql-toolbar .ql-picker-item:hover .ql-stroke-miter,.ql-snow .ql-toolbar .ql-picker-item:hover .ql-stroke-miter,.ql-snow.ql-toolbar .ql-picker-label.ql-active .ql-stroke,.ql-snow .ql-toolbar .ql-picker-label.ql-active .ql-stroke,.ql-snow.ql-toolbar .ql-picker-label.ql-active .ql-stroke-miter,.ql-snow .ql-toolbar .ql-picker-label.ql-active .ql-stroke-miter,.ql-snow.ql-toolbar .ql-picker-label:hover .ql-stroke,.ql-snow .ql-toolbar .ql-picker-label:hover .ql-stroke,.ql-snow.ql-toolbar .ql-picker-label:hover .ql-stroke-miter,.ql-snow .ql-toolbar .ql-picker-label:hover .ql-stroke-miter,.ql-snow.ql-toolbar button.ql-active .ql-stroke,.ql-snow .ql-toolbar button.ql-active .ql-stroke,.ql-snow.ql-toolbar button.ql-active .ql-stroke-miter,.ql-snow .ql-toolbar button.ql-active .ql-stroke-miter,.ql-snow.ql-toolbar button:focus .ql-stroke,.ql-snow .ql-toolbar button:focus .ql-stroke,.ql-snow.ql-toolbar button:focus .ql-stroke-miter,.ql-snow .ql-toolbar button:focus .ql-stroke-miter,.ql-snow.ql-toolbar button:hover .ql-stroke,.ql-snow .ql-toolbar button:hover .ql-stroke,.ql-snow.ql-toolbar button:hover .ql-stroke-miter,.ql-snow .ql-toolbar button:hover .ql-stroke-miter{stroke:#06c}@media (pointer:coarse){.ql-snow.ql-toolbar button:hover:not(.ql-active),.ql-snow .ql-toolbar button:hover:not(.ql-active){color:#444}.ql-snow.ql-toolbar button:hover:not(.ql-active) .ql-fill,.ql-snow .ql-toolbar button:hover:not(.ql-active) .ql-fill,.ql-snow.ql-toolbar button:hover:not(.ql-active) .ql-stroke.ql-fill,.ql-snow .ql-toolbar button:hover:not(.ql-active) .ql-stroke.ql-fill{fill:#444}.ql-snow.ql-toolbar button:hover:not(.ql-active) .ql-stroke,.ql-snow .ql-toolbar button:hover:not(.ql-active) .ql-stroke,.ql-snow.ql-toolbar button:hover:not(.ql-active) .ql-stroke-miter,.ql-snow .ql-toolbar button:hover:not(.ql-active) .ql-stroke-miter{stroke:#444}}.ql-snow,.ql-snow *{box-sizing:border-box}.ql-snow .ql-hidden{display:none}.ql-snow .ql-out-bottom,.ql-snow .ql-out-top{visibility:hidden}.ql-snow .ql-tooltip{position:absolute;transform:translateY(10px)}.ql-snow .ql-tooltip a{cursor:pointer;text-decoration:none}.ql-snow .ql-tooltip.ql-flip{transform:translateY(-10px)}.ql-snow .ql-formats{display:inline-block;vertical-align:middle}.ql-snow .ql-formats:after{clear:both;content:\"\";display:table}.ql-snow .ql-stroke{fill:none;stroke:#444;stroke-linecap:round;stroke-linejoin:round;stroke-width:2}.ql-snow .ql-stroke-miter{fill:none;stroke:#444;stroke-miterlimit:10;stroke-width:2}.ql-snow .ql-fill,.ql-snow .ql-stroke.ql-fill{fill:#444}.ql-snow .ql-empty{fill:none}.ql-snow .ql-even{fill-rule:evenodd}.ql-snow .ql-stroke.ql-thin,.ql-snow .ql-thin{stroke-width:1}.ql-snow .ql-transparent{opacity:.4}.ql-snow .ql-direction svg:last-child{display:none}.ql-snow .ql-direction.ql-active svg:last-child{display:inline}.ql-snow .ql-direction.ql-active svg:first-child{display:none}.ql-snow .ql-editor h1{font-size:2em}.ql-snow .ql-editor h2{font-size:1.5em}.ql-snow .ql-editor h3{font-size:1.17em}.ql-snow .ql-editor h4{font-size:1em}.ql-snow .ql-editor h5{font-size:.83em}.ql-snow .ql-editor h6{font-size:.67em}.ql-snow .ql-editor a{text-decoration:underline}.ql-snow .ql-editor blockquote{border-left:4px solid #ccc;margin-bottom:5px;margin-top:5px;padding-left:16px}.ql-snow .ql-editor code,.ql-snow .ql-editor pre{background-color:#f0f0f0;border-radius:3px}.ql-snow .ql-editor pre{white-space:pre-wrap;margin-bottom:5px;margin-top:5px;padding:5px 10px}.ql-snow .ql-editor code{font-size:85%;padding-bottom:2px;padding-top:2px}.ql-snow .ql-editor code:after,.ql-snow .ql-editor code:before{content:\"\\A0\";letter-spacing:-2px}.ql-snow .ql-editor pre.ql-syntax{background-color:#23241f;color:#f8f8f2;overflow:visible}.ql-snow .ql-editor img{max-width:100%}.ql-snow .ql-picker{color:#444;display:inline-block;float:left;font-size:14px;font-weight:500;height:24px;position:relative;vertical-align:middle}.ql-snow .ql-picker-label{cursor:pointer;display:inline-block;height:100%;padding-left:8px;padding-right:2px;position:relative;width:100%}.ql-snow .ql-picker-label:before{display:inline-block;line-height:22px}.ql-snow .ql-picker-options{background-color:#fff;display:none;min-width:100%;padding:4px 8px;position:absolute;white-space:nowrap}.ql-snow .ql-picker-options .ql-picker-item{cursor:pointer;display:block;padding-bottom:5px;padding-top:5px}.ql-snow .ql-picker.ql-expanded .ql-picker-label{color:#ccc;z-index:2}.ql-snow .ql-picker.ql-expanded .ql-picker-label .ql-fill{fill:#ccc}.ql-snow .ql-picker.ql-expanded .ql-picker-label .ql-stroke{stroke:#ccc}.ql-snow .ql-picker.ql-expanded .ql-picker-options{display:block;margin-top:-1px;top:100%;z-index:1}.ql-snow .ql-color-picker,.ql-snow .ql-icon-picker{width:28px}.ql-snow .ql-color-picker .ql-picker-label,.ql-snow .ql-icon-picker .ql-picker-label{padding:2px 4px}.ql-snow .ql-color-picker .ql-picker-label svg,.ql-snow .ql-icon-picker .ql-picker-label svg{right:4px}.ql-snow .ql-icon-picker .ql-picker-options{padding:4px 0}.ql-snow .ql-icon-picker .ql-picker-item{height:24px;width:24px;padding:2px 4px}.ql-snow .ql-color-picker .ql-picker-options{padding:3px 5px;width:152px}.ql-snow .ql-color-picker .ql-picker-item{border:1px solid transparent;float:left;height:16px;margin:2px;padding:0;width:16px}.ql-snow .ql-picker:not(.ql-color-picker):not(.ql-icon-picker) svg{position:absolute;margin-top:-9px;right:0;top:50%;width:18px}.ql-snow .ql-picker.ql-font .ql-picker-item[data-label]:not([data-label=\"\"]):before,.ql-snow .ql-picker.ql-font .ql-picker-label[data-label]:not([data-label=\"\"]):before,.ql-snow .ql-picker.ql-header .ql-picker-item[data-label]:not([data-label=\"\"]):before,.ql-snow .ql-picker.ql-header .ql-picker-label[data-label]:not([data-label=\"\"]):before,.ql-snow .ql-picker.ql-size .ql-picker-item[data-label]:not([data-label=\"\"]):before,.ql-snow .ql-picker.ql-size .ql-picker-label[data-label]:not([data-label=\"\"]):before{content:attr(data-label)}.ql-snow .ql-picker.ql-header{width:98px}.ql-snow .ql-picker.ql-header .ql-picker-item:before,.ql-snow .ql-picker.ql-header .ql-picker-label:before{content:\"Normal\"}.ql-snow .ql-picker.ql-header .ql-picker-item[data-value=\"1\"]:before,.ql-snow .ql-picker.ql-header .ql-picker-label[data-value=\"1\"]:before{content:\"Heading 1\"}.ql-snow .ql-picker.ql-header .ql-picker-item[data-value=\"2\"]:before,.ql-snow .ql-picker.ql-header .ql-picker-label[data-value=\"2\"]:before{content:\"Heading 2\"}.ql-snow .ql-picker.ql-header .ql-picker-item[data-value=\"3\"]:before,.ql-snow .ql-picker.ql-header .ql-picker-label[data-value=\"3\"]:before{content:\"Heading 3\"}.ql-snow .ql-picker.ql-header .ql-picker-item[data-value=\"4\"]:before,.ql-snow .ql-picker.ql-header .ql-picker-label[data-value=\"4\"]:before{content:\"Heading 4\"}.ql-snow .ql-picker.ql-header .ql-picker-item[data-value=\"5\"]:before,.ql-snow .ql-picker.ql-header .ql-picker-label[data-value=\"5\"]:before{content:\"Heading 5\"}.ql-snow .ql-picker.ql-header .ql-picker-item[data-value=\"6\"]:before,.ql-snow .ql-picker.ql-header .ql-picker-label[data-value=\"6\"]:before{content:\"Heading 6\"}.ql-snow .ql-picker.ql-header .ql-picker-item[data-value=\"1\"]:before{font-size:2em}.ql-snow .ql-picker.ql-header .ql-picker-item[data-value=\"2\"]:before{font-size:1.5em}.ql-snow .ql-picker.ql-header .ql-picker-item[data-value=\"3\"]:before{font-size:1.17em}.ql-snow .ql-picker.ql-header .ql-picker-item[data-value=\"4\"]:before{font-size:1em}.ql-snow .ql-picker.ql-header .ql-picker-item[data-value=\"5\"]:before{font-size:.83em}.ql-snow .ql-picker.ql-header .ql-picker-item[data-value=\"6\"]:before{font-size:.67em}.ql-snow .ql-picker.ql-font{width:108px}.ql-snow .ql-picker.ql-font .ql-picker-item:before,.ql-snow .ql-picker.ql-font .ql-picker-label:before{content:\"Sans Serif\"}.ql-snow .ql-picker.ql-font .ql-picker-item[data-value=serif]:before,.ql-snow .ql-picker.ql-font .ql-picker-label[data-value=serif]:before{content:\"Serif\"}.ql-snow .ql-picker.ql-font .ql-picker-item[data-value=monospace]:before,.ql-snow .ql-picker.ql-font .ql-picker-label[data-value=monospace]:before{content:\"Monospace\"}.ql-snow .ql-picker.ql-font .ql-picker-item[data-value=serif]:before{font-family:Georgia,Times New Roman,serif}.ql-snow .ql-picker.ql-font .ql-picker-item[data-value=monospace]:before{font-family:Monaco,Courier New,monospace}.ql-snow .ql-picker.ql-size{width:98px}.ql-snow .ql-picker.ql-size .ql-picker-item:before,.ql-snow .ql-picker.ql-size .ql-picker-label:before{content:\"Normal\"}.ql-snow .ql-picker.ql-size .ql-picker-item[data-value=small]:before,.ql-snow .ql-picker.ql-size .ql-picker-label[data-value=small]:before{content:\"Small\"}.ql-snow .ql-picker.ql-size .ql-picker-item[data-value=large]:before,.ql-snow .ql-picker.ql-size .ql-picker-label[data-value=large]:before{content:\"Large\"}.ql-snow .ql-picker.ql-size .ql-picker-item[data-value=huge]:before,.ql-snow .ql-picker.ql-size .ql-picker-label[data-value=huge]:before{content:\"Huge\"}.ql-snow .ql-picker.ql-size .ql-picker-item[data-value=small]:before{font-size:10px}.ql-snow .ql-picker.ql-size .ql-picker-item[data-value=large]:before{font-size:18px}.ql-snow .ql-picker.ql-size .ql-picker-item[data-value=huge]:before{font-size:32px}.ql-snow .ql-color-picker.ql-background .ql-picker-item{background-color:#fff}.ql-snow .ql-color-picker.ql-color .ql-picker-item{background-color:#000}.ql-toolbar.ql-snow{border:1px solid #ccc;box-sizing:border-box;font-family:Helvetica Neue,Helvetica,Arial,sans-serif;padding:8px}.ql-toolbar.ql-snow .ql-formats{margin-right:15px}.ql-toolbar.ql-snow .ql-picker-label{border:1px solid transparent}.ql-toolbar.ql-snow .ql-picker-options{border:1px solid transparent;box-shadow:0 2px 8px rgba(0,0,0,.2)}.ql-toolbar.ql-snow .ql-picker.ql-expanded .ql-picker-label,.ql-toolbar.ql-snow .ql-picker.ql-expanded .ql-picker-options{border-color:#ccc}.ql-toolbar.ql-snow .ql-color-picker .ql-picker-item.ql-selected,.ql-toolbar.ql-snow .ql-color-picker .ql-picker-item:hover{border-color:#000}.ql-toolbar.ql-snow+.ql-container.ql-snow{border-top:0}.ql-snow .ql-tooltip{background-color:#fff;border:1px solid #ccc;box-shadow:0 0 5px #ddd;color:#444;padding:5px 12px;white-space:nowrap}.ql-snow .ql-tooltip:before{content:\"Visit URL:\";line-height:26px;margin-right:8px}.ql-snow .ql-tooltip input[type=text]{display:none;border:1px solid #ccc;font-size:13px;height:26px;margin:0;padding:3px 5px;width:170px}.ql-snow .ql-tooltip a.ql-preview{display:inline-block;max-width:200px;overflow-x:hidden;text-overflow:ellipsis;vertical-align:top}.ql-snow .ql-tooltip a.ql-action:after{border-right:1px solid #ccc;content:\"Edit\";margin-left:16px;padding-right:8px}.ql-snow .ql-tooltip a.ql-remove:before{content:\"Remove\";margin-left:8px}.ql-snow .ql-tooltip a{line-height:26px}.ql-snow .ql-tooltip.ql-editing a.ql-preview,.ql-snow .ql-tooltip.ql-editing a.ql-remove{display:none}.ql-snow .ql-tooltip.ql-editing input[type=text]{display:inline-block}.ql-snow .ql-tooltip.ql-editing a.ql-action:after{border-right:0;content:\"Save\";padding-right:0}.ql-snow .ql-tooltip[data-mode=link]:before{content:\"Enter link:\"}.ql-snow .ql-tooltip[data-mode=formula]:before{content:\"Enter formula:\"}.ql-snow .ql-tooltip[data-mode=video]:before{content:\"Enter video:\"}.ql-snow a{color:#06c}.ql-container.ql-snow{border:1px solid #ccc}", ""]);
	
	// exports


/***/ },
/* 818 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(122)(false);
	// imports
	
	
	// module
	exports.push([module.id, ".video-js .vjs-big-play-button .vjs-icon-placeholder:before,.video-js .vjs-modal-dialog,.vjs-button>.vjs-icon-placeholder:before,.vjs-modal-dialog .vjs-modal-dialog-content{position:absolute;top:0;left:0;width:100%;height:100%}.video-js .vjs-big-play-button .vjs-icon-placeholder:before,.vjs-button>.vjs-icon-placeholder:before{text-align:center}@font-face{font-family:VideoJS;src:url(data:application/font-woff;charset=utf-8;base64,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) format(\"woff\");font-weight:400;font-style:normal}.video-js .vjs-big-play-button .vjs-icon-placeholder:before,.video-js .vjs-play-control .vjs-icon-placeholder,.vjs-icon-play{font-family:VideoJS;font-weight:400;font-style:normal}.video-js .vjs-big-play-button .vjs-icon-placeholder:before,.video-js .vjs-play-control .vjs-icon-placeholder:before,.vjs-icon-play:before{content:\"\\F101\"}.vjs-icon-play-circle{font-family:VideoJS;font-weight:400;font-style:normal}.vjs-icon-play-circle:before{content:\"\\F102\"}.video-js .vjs-play-control.vjs-playing .vjs-icon-placeholder,.vjs-icon-pause{font-family:VideoJS;font-weight:400;font-style:normal}.video-js .vjs-play-control.vjs-playing .vjs-icon-placeholder:before,.vjs-icon-pause:before{content:\"\\F103\"}.video-js .vjs-mute-control.vjs-vol-0 .vjs-icon-placeholder,.vjs-icon-volume-mute{font-family:VideoJS;font-weight:400;font-style:normal}.video-js .vjs-mute-control.vjs-vol-0 .vjs-icon-placeholder:before,.vjs-icon-volume-mute:before{content:\"\\F104\"}.video-js .vjs-mute-control.vjs-vol-1 .vjs-icon-placeholder,.vjs-icon-volume-low{font-family:VideoJS;font-weight:400;font-style:normal}.video-js .vjs-mute-control.vjs-vol-1 .vjs-icon-placeholder:before,.vjs-icon-volume-low:before{content:\"\\F105\"}.video-js .vjs-mute-control.vjs-vol-2 .vjs-icon-placeholder,.vjs-icon-volume-mid{font-family:VideoJS;font-weight:400;font-style:normal}.video-js .vjs-mute-control.vjs-vol-2 .vjs-icon-placeholder:before,.vjs-icon-volume-mid:before{content:\"\\F106\"}.video-js .vjs-mute-control .vjs-icon-placeholder,.vjs-icon-volume-high{font-family:VideoJS;font-weight:400;font-style:normal}.video-js .vjs-mute-control .vjs-icon-placeholder:before,.vjs-icon-volume-high:before{content:\"\\F107\"}.video-js .vjs-fullscreen-control .vjs-icon-placeholder,.vjs-icon-fullscreen-enter{font-family:VideoJS;font-weight:400;font-style:normal}.video-js .vjs-fullscreen-control .vjs-icon-placeholder:before,.vjs-icon-fullscreen-enter:before{content:\"\\F108\"}.video-js.vjs-fullscreen .vjs-fullscreen-control .vjs-icon-placeholder,.vjs-icon-fullscreen-exit{font-family:VideoJS;font-weight:400;font-style:normal}.video-js.vjs-fullscreen .vjs-fullscreen-control .vjs-icon-placeholder:before,.vjs-icon-fullscreen-exit:before{content:\"\\F109\"}.vjs-icon-square{font-family:VideoJS;font-weight:400;font-style:normal}.vjs-icon-square:before{content:\"\\F10A\"}.vjs-icon-spinner{font-family:VideoJS;font-weight:400;font-style:normal}.vjs-icon-spinner:before{content:\"\\F10B\"}.video-js.video-js:lang(en-AU) .vjs-subs-caps-button .vjs-icon-placeholder,.video-js.video-js:lang(en-GB) .vjs-subs-caps-button .vjs-icon-placeholder,.video-js.video-js:lang(en-IE) .vjs-subs-caps-button .vjs-icon-placeholder,.video-js.video-js:lang(en-NZ) .vjs-subs-caps-button .vjs-icon-placeholder,.video-js .vjs-subs-caps-button .vjs-icon-placeholder,.video-js .vjs-subtitles-button .vjs-icon-placeholder,.vjs-icon-subtitles{font-family:VideoJS;font-weight:400;font-style:normal}.video-js.video-js:lang(en-AU) .vjs-subs-caps-button .vjs-icon-placeholder:before,.video-js.video-js:lang(en-GB) .vjs-subs-caps-button .vjs-icon-placeholder:before,.video-js.video-js:lang(en-IE) .vjs-subs-caps-button .vjs-icon-placeholder:before,.video-js.video-js:lang(en-NZ) .vjs-subs-caps-button .vjs-icon-placeholder:before,.video-js .vjs-subs-caps-button .vjs-icon-placeholder:before,.video-js .vjs-subtitles-button .vjs-icon-placeholder:before,.vjs-icon-subtitles:before{content:\"\\F10C\"}.video-js .vjs-captions-button .vjs-icon-placeholder,.video-js:lang(en) .vjs-subs-caps-button .vjs-icon-placeholder,.video-js:lang(fr-CA) .vjs-subs-caps-button .vjs-icon-placeholder,.vjs-icon-captions{font-family:VideoJS;font-weight:400;font-style:normal}.video-js .vjs-captions-button .vjs-icon-placeholder:before,.video-js:lang(en) .vjs-subs-caps-button .vjs-icon-placeholder:before,.video-js:lang(fr-CA) .vjs-subs-caps-button .vjs-icon-placeholder:before,.vjs-icon-captions:before{content:\"\\F10D\"}.video-js .vjs-chapters-button .vjs-icon-placeholder,.vjs-icon-chapters{font-family:VideoJS;font-weight:400;font-style:normal}.video-js .vjs-chapters-button .vjs-icon-placeholder:before,.vjs-icon-chapters:before{content:\"\\F10E\"}.vjs-icon-share{font-family:VideoJS;font-weight:400;font-style:normal}.vjs-icon-share:before{content:\"\\F10F\"}.vjs-icon-cog{font-family:VideoJS;font-weight:400;font-style:normal}.vjs-icon-cog:before{content:\"\\F110\"}.video-js .vjs-play-progress,.video-js .vjs-volume-level,.vjs-icon-circle{font-family:VideoJS;font-weight:400;font-style:normal}.video-js .vjs-play-progress:before,.video-js .vjs-volume-level:before,.vjs-icon-circle:before{content:\"\\F111\"}.vjs-icon-circle-outline{font-family:VideoJS;font-weight:400;font-style:normal}.vjs-icon-circle-outline:before{content:\"\\F112\"}.vjs-icon-circle-inner-circle{font-family:VideoJS;font-weight:400;font-style:normal}.vjs-icon-circle-inner-circle:before{content:\"\\F113\"}.vjs-icon-hd{font-family:VideoJS;font-weight:400;font-style:normal}.vjs-icon-hd:before{content:\"\\F114\"}.video-js .vjs-control.vjs-close-button .vjs-icon-placeholder,.vjs-icon-cancel{font-family:VideoJS;font-weight:400;font-style:normal}.video-js .vjs-control.vjs-close-button .vjs-icon-placeholder:before,.vjs-icon-cancel:before{content:\"\\F115\"}.video-js .vjs-play-control.vjs-ended .vjs-icon-placeholder,.vjs-icon-replay{font-family:VideoJS;font-weight:400;font-style:normal}.video-js .vjs-play-control.vjs-ended .vjs-icon-placeholder:before,.vjs-icon-replay:before{content:\"\\F116\"}.vjs-icon-facebook{font-family:VideoJS;font-weight:400;font-style:normal}.vjs-icon-facebook:before{content:\"\\F117\"}.vjs-icon-gplus{font-family:VideoJS;font-weight:400;font-style:normal}.vjs-icon-gplus:before{content:\"\\F118\"}.vjs-icon-linkedin{font-family:VideoJS;font-weight:400;font-style:normal}.vjs-icon-linkedin:before{content:\"\\F119\"}.vjs-icon-twitter{font-family:VideoJS;font-weight:400;font-style:normal}.vjs-icon-twitter:before{content:\"\\F11A\"}.vjs-icon-tumblr{font-family:VideoJS;font-weight:400;font-style:normal}.vjs-icon-tumblr:before{content:\"\\F11B\"}.vjs-icon-pinterest{font-family:VideoJS;font-weight:400;font-style:normal}.vjs-icon-pinterest:before{content:\"\\F11C\"}.video-js .vjs-descriptions-button .vjs-icon-placeholder,.vjs-icon-audio-description{font-family:VideoJS;font-weight:400;font-style:normal}.video-js .vjs-descriptions-button .vjs-icon-placeholder:before,.vjs-icon-audio-description:before{content:\"\\F11D\"}.video-js .vjs-audio-button .vjs-icon-placeholder,.vjs-icon-audio{font-family:VideoJS;font-weight:400;font-style:normal}.video-js .vjs-audio-button .vjs-icon-placeholder:before,.vjs-icon-audio:before{content:\"\\F11E\"}.vjs-icon-next-item{font-family:VideoJS;font-weight:400;font-style:normal}.vjs-icon-next-item:before{content:\"\\F11F\"}.vjs-icon-previous-item{font-family:VideoJS;font-weight:400;font-style:normal}.vjs-icon-previous-item:before{content:\"\\F120\"}.video-js{display:block;vertical-align:top;box-sizing:border-box;color:#fff;background-color:#000;position:relative;padding:0;font-size:10px;line-height:1;font-weight:400;font-style:normal;font-family:Arial,Helvetica,sans-serif;word-break:normal}.video-js:-moz-full-screen{position:absolute}.video-js:-webkit-full-screen{width:100%!important;height:100%!important}.video-js[tabindex=\"-1\"]{outline:none}.video-js *,.video-js :after,.video-js :before{box-sizing:inherit}.video-js ul{font-family:inherit;font-size:inherit;line-height:inherit;list-style-position:outside;margin:0}.video-js.vjs-4-3,.video-js.vjs-16-9,.video-js.vjs-fluid{width:100%;max-width:100%;height:0}.video-js.vjs-16-9{padding-top:56.25%}.video-js.vjs-4-3{padding-top:75%}.video-js.vjs-fill,.video-js .vjs-tech{width:100%;height:100%}.video-js .vjs-tech{position:absolute;top:0;left:0}body.vjs-full-window{padding:0;margin:0;height:100%}.vjs-full-window .video-js.vjs-fullscreen{position:fixed;overflow:hidden;z-index:1000;left:0;top:0;bottom:0;right:0}.video-js.vjs-fullscreen{width:100%!important;height:100%!important;padding-top:0!important}.video-js.vjs-fullscreen.vjs-user-inactive{cursor:none}.vjs-hidden{display:none!important}.vjs-disabled{opacity:.5;cursor:default}.video-js .vjs-offscreen{height:1px;left:-9999px;position:absolute;top:0;width:1px}.vjs-lock-showing{display:block!important;opacity:1;visibility:visible}.vjs-no-js{padding:20px;color:#fff;background-color:#000;font-size:18px;font-family:Arial,Helvetica,sans-serif;text-align:center;width:300px;height:150px;margin:0 auto}.vjs-no-js a,.vjs-no-js a:visited{color:#66a8cc}.video-js .vjs-big-play-button{font-size:3em;line-height:1.5em;height:1.5em;width:3em;display:block;position:absolute;top:10px;left:10px;padding:0;cursor:pointer;opacity:1;border:.06666em solid #fff;background-color:#2b333f;background-color:rgba(43,51,63,.7);border-radius:.3em;transition:all .4s}.vjs-big-play-centered .vjs-big-play-button{top:50%;left:50%;margin-top:-.75em;margin-left:-1.5em}.video-js .vjs-big-play-button:focus,.video-js:hover .vjs-big-play-button{border-color:#fff;background-color:#73859f;background-color:rgba(115,133,159,.5);transition:all 0s}.vjs-controls-disabled .vjs-big-play-button,.vjs-error .vjs-big-play-button,.vjs-has-started .vjs-big-play-button,.vjs-using-native-controls .vjs-big-play-button{display:none}.vjs-has-started.vjs-paused.vjs-show-big-play-button-on-pause .vjs-big-play-button{display:block}.video-js button{background:none;border:none;color:inherit;display:inline-block;font-size:inherit;line-height:inherit;text-transform:none;text-decoration:none;transition:none;-webkit-appearance:none;-moz-appearance:none;appearance:none}.vjs-control .vjs-button{width:100%;height:100%}.video-js .vjs-control.vjs-close-button{cursor:pointer;height:3em;position:absolute;right:0;top:.5em;z-index:2}.video-js .vjs-modal-dialog{background:rgba(0,0,0,.8);background:linear-gradient(180deg,rgba(0,0,0,.8),hsla(0,0%,100%,0));overflow:auto}.video-js .vjs-modal-dialog>*{box-sizing:border-box}.vjs-modal-dialog .vjs-modal-dialog-content{font-size:1.2em;line-height:1.5;padding:20px 24px;z-index:1}.vjs-menu-button{cursor:pointer}.vjs-menu-button.vjs-disabled{cursor:default}.vjs-workinghover .vjs-menu-button.vjs-disabled:hover .vjs-menu{display:none}.vjs-menu .vjs-menu-content{display:block;padding:0;margin:0;font-family:Arial,Helvetica,sans-serif;overflow:auto}.vjs-menu .vjs-menu-content>*{box-sizing:border-box}.vjs-scrubbing .vjs-control.vjs-menu-button:hover .vjs-menu{display:none}.vjs-menu li{list-style:none;margin:0;padding:.2em 0;line-height:1.4em;font-size:1.2em;text-align:center;text-transform:lowercase}.vjs-menu li.vjs-menu-item:focus,.vjs-menu li.vjs-menu-item:hover{background-color:#73859f;background-color:rgba(115,133,159,.5)}.vjs-menu li.vjs-selected,.vjs-menu li.vjs-selected:focus,.vjs-menu li.vjs-selected:hover{background-color:#fff;color:#2b333f}.vjs-menu li.vjs-menu-title{text-align:center;text-transform:uppercase;font-size:1em;line-height:2em;padding:0;margin:0 0 .3em;font-weight:700;cursor:default}.vjs-menu-button-popup .vjs-menu{display:none;position:absolute;bottom:0;width:10em;left:-3em;height:0;margin-bottom:1.5em;border-top-color:rgba(43,51,63,.7)}.vjs-menu-button-popup .vjs-menu .vjs-menu-content{background-color:#2b333f;background-color:rgba(43,51,63,.7);position:absolute;width:100%;bottom:1.5em;max-height:15em}.vjs-menu-button-popup .vjs-menu.vjs-lock-showing,.vjs-workinghover .vjs-menu-button-popup:hover .vjs-menu{display:block}.video-js .vjs-menu-button-inline{transition:all .4s;overflow:hidden}.video-js .vjs-menu-button-inline:before{width:2.222222222em}.video-js .vjs-menu-button-inline.vjs-slider-active,.video-js .vjs-menu-button-inline:focus,.video-js .vjs-menu-button-inline:hover,.video-js.vjs-no-flex .vjs-menu-button-inline{width:12em}.vjs-menu-button-inline .vjs-menu{opacity:0;height:100%;width:auto;position:absolute;left:4em;top:0;padding:0;margin:0;transition:all .4s}.vjs-menu-button-inline.vjs-slider-active .vjs-menu,.vjs-menu-button-inline:focus .vjs-menu,.vjs-menu-button-inline:hover .vjs-menu{display:block;opacity:1}.vjs-no-flex .vjs-menu-button-inline .vjs-menu{display:block;opacity:1;position:relative;width:auto}.vjs-no-flex .vjs-menu-button-inline.vjs-slider-active .vjs-menu,.vjs-no-flex .vjs-menu-button-inline:focus .vjs-menu,.vjs-no-flex .vjs-menu-button-inline:hover .vjs-menu{width:auto}.vjs-menu-button-inline .vjs-menu-content{width:auto;height:100%;margin:0;overflow:hidden}.video-js .vjs-control-bar{display:none;width:100%;position:absolute;bottom:0;left:0;right:0;height:3em;background-color:#2b333f;background-color:rgba(43,51,63,.7)}.vjs-has-started .vjs-control-bar{display:flex;visibility:visible;opacity:1;transition:visibility .1s,opacity .1s}.vjs-has-started.vjs-user-inactive.vjs-playing .vjs-control-bar{visibility:visible;opacity:0;transition:visibility 1s,opacity 1s}.vjs-controls-disabled .vjs-control-bar,.vjs-error .vjs-control-bar,.vjs-using-native-controls .vjs-control-bar{display:none!important}.vjs-audio.vjs-has-started.vjs-user-inactive.vjs-playing .vjs-control-bar{opacity:1;visibility:visible}.vjs-has-started.vjs-no-flex .vjs-control-bar{display:table}.video-js .vjs-control{position:relative;text-align:center;margin:0;padding:0;height:100%;width:4em;flex:none}.vjs-button>.vjs-icon-placeholder:before{font-size:1.8em;line-height:1.67}.video-js .vjs-control:focus,.video-js .vjs-control:focus:before,.video-js .vjs-control:hover:before{text-shadow:0 0 1em #fff}.video-js .vjs-control-text{border:0;clip:rect(0 0 0 0);height:1px;overflow:hidden;padding:0;position:absolute;width:1px}.vjs-no-flex .vjs-control{display:table-cell;vertical-align:middle}.video-js .vjs-custom-control-spacer{display:none}.video-js .vjs-progress-control{cursor:pointer;flex:auto;display:flex;align-items:center;min-width:4em;touch-action:none}.video-js .vjs-progress-control.disabled{cursor:default}.vjs-live .vjs-progress-control{display:none}.vjs-no-flex .vjs-progress-control{width:auto}.video-js .vjs-progress-holder{flex:auto;transition:all .2s;height:.3em}.video-js .vjs-progress-control .vjs-progress-holder{margin:0 10px}.video-js .vjs-progress-control:hover .vjs-progress-holder{font-size:1.6666666666666667em}.video-js .vjs-progress-control:hover .vjs-progress-holder.disabled{font-size:1em}.video-js .vjs-progress-holder .vjs-load-progress,.video-js .vjs-progress-holder .vjs-load-progress div,.video-js .vjs-progress-holder .vjs-play-progress{position:absolute;display:block;height:100%;margin:0;padding:0;width:0}.video-js .vjs-play-progress{background-color:#fff}.video-js .vjs-play-progress:before{font-size:.9em;position:absolute;right:-.5em;top:-.333333333333333em;z-index:1}.video-js .vjs-load-progress{background:rgba(115,133,159,.5)}.video-js .vjs-load-progress div{background:rgba(115,133,159,.75)}.video-js .vjs-time-tooltip{background-color:#fff;background-color:hsla(0,0%,100%,.8);border-radius:.3em;color:#000;float:right;font-family:Arial,Helvetica,sans-serif;font-size:1em;padding:6px 8px 8px;pointer-events:none;position:absolute;top:-3.4em;visibility:hidden;z-index:1}.video-js .vjs-progress-holder:focus .vjs-time-tooltip{display:none}.video-js .vjs-progress-control:hover .vjs-progress-holder:focus .vjs-time-tooltip,.video-js .vjs-progress-control:hover .vjs-time-tooltip{display:block;font-size:.6em;visibility:visible}.video-js .vjs-progress-control.disabled:hover .vjs-time-tooltip{font-size:1em}.video-js .vjs-progress-control .vjs-mouse-display{display:none;position:absolute;width:1px;height:100%;background-color:#000;z-index:1}.vjs-no-flex .vjs-progress-control .vjs-mouse-display{z-index:0}.video-js .vjs-progress-control:hover .vjs-mouse-display{display:block}.video-js.vjs-user-inactive .vjs-progress-control .vjs-mouse-display{visibility:hidden;opacity:0;transition:visibility 1s,opacity 1s}.video-js.vjs-user-inactive.vjs-no-flex .vjs-progress-control .vjs-mouse-display{display:none}.vjs-mouse-display .vjs-time-tooltip{color:#fff;background-color:#000;background-color:rgba(0,0,0,.8)}.video-js .vjs-slider{position:relative;cursor:pointer;padding:0;margin:0 .45em;-webkit-touch-callout:none;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;background-color:#73859f;background-color:rgba(115,133,159,.5)}.video-js .vjs-slider.disabled{cursor:default}.video-js .vjs-slider:focus{text-shadow:0 0 1em #fff;box-shadow:0 0 1em #fff}.video-js .vjs-mute-control{cursor:pointer;flex:none}.video-js .vjs-volume-control{cursor:pointer;margin-right:1em;display:flex}.video-js .vjs-volume-control.vjs-volume-horizontal{width:5em}.video-js .vjs-volume-panel .vjs-volume-control{visibility:visible;opacity:0;width:1px;height:1px;margin-left:-1px}.video-js .vjs-volume-panel{transition:width 1s}.video-js .vjs-volume-panel .vjs-mute-control:hover~.vjs-volume-control,.video-js .vjs-volume-panel .vjs-volume-control.vjs-slider-active,.video-js .vjs-volume-panel .vjs-volume-control:active,.video-js .vjs-volume-panel .vjs-volume-control:hover,.video-js .vjs-volume-panel:active .vjs-volume-control,.video-js .vjs-volume-panel:focus .vjs-volume-control,.video-js .vjs-volume-panel:hover .vjs-volume-control{visibility:visible;opacity:1;position:relative;transition:visibility .1s,opacity .1s,height .1s,width .1s,left 0s,top 0s}.video-js .vjs-volume-panel .vjs-mute-control:hover~.vjs-volume-control.vjs-volume-horizontal,.video-js .vjs-volume-panel .vjs-volume-control.vjs-slider-active.vjs-volume-horizontal,.video-js .vjs-volume-panel .vjs-volume-control:active.vjs-volume-horizontal,.video-js .vjs-volume-panel .vjs-volume-control:hover.vjs-volume-horizontal,.video-js .vjs-volume-panel:active .vjs-volume-control.vjs-volume-horizontal,.video-js .vjs-volume-panel:focus .vjs-volume-control.vjs-volume-horizontal,.video-js .vjs-volume-panel:hover .vjs-volume-control.vjs-volume-horizontal{width:5em;height:3em}.video-js .vjs-volume-panel.vjs-volume-panel-horizontal.vjs-slider-active,.video-js .vjs-volume-panel.vjs-volume-panel-horizontal:active,.video-js .vjs-volume-panel.vjs-volume-panel-horizontal:hover{width:9em;transition:width .1s}.video-js .vjs-volume-panel.vjs-volume-panel-horizontal.vjs-mute-toggle-only{width:4em}.video-js .vjs-volume-panel .vjs-volume-control.vjs-volume-vertical{height:8em;width:3em;left:-3.5em;transition:visibility 1s,opacity 1s,height 1s 1s,width 1s 1s,left 1s 1s,top 1s 1s}.video-js .vjs-volume-panel .vjs-volume-control.vjs-volume-horizontal{transition:visibility 1s,opacity 1s,height 1s 1s,width 1s,left 1s 1s,top 1s 1s}.video-js.vjs-no-flex .vjs-volume-panel .vjs-volume-control.vjs-volume-horizontal{width:5em;height:3em;visibility:visible;opacity:1;position:relative;transition:none}.video-js.vjs-no-flex .vjs-volume-control.vjs-volume-vertical,.video-js.vjs-no-flex .vjs-volume-panel .vjs-volume-control.vjs-volume-vertical{position:absolute;bottom:3em;left:.5em}.video-js .vjs-volume-panel{display:flex}.video-js .vjs-volume-bar{margin:1.35em .45em}.vjs-volume-bar.vjs-slider-horizontal{width:5em;height:.3em}.vjs-volume-bar.vjs-slider-vertical{width:.3em;height:5em;margin:1.35em auto}.video-js .vjs-volume-level{position:absolute;bottom:0;left:0;background-color:#fff}.video-js .vjs-volume-level:before{position:absolute;font-size:.9em}.vjs-slider-vertical .vjs-volume-level{width:.3em}.vjs-slider-vertical .vjs-volume-level:before{top:-.5em;left:-.3em}.vjs-slider-horizontal .vjs-volume-level{height:.3em}.vjs-slider-horizontal .vjs-volume-level:before{top:-.3em;right:-.5em}.video-js .vjs-volume-panel.vjs-volume-panel-vertical{width:4em}.vjs-volume-bar.vjs-slider-vertical .vjs-volume-level{height:100%}.vjs-volume-bar.vjs-slider-horizontal .vjs-volume-level{width:100%}.video-js .vjs-volume-vertical{width:3em;height:8em;bottom:8em;background-color:#2b333f;background-color:rgba(43,51,63,.7)}.video-js .vjs-volume-horizontal .vjs-menu{left:-2em}.vjs-poster{display:inline-block;vertical-align:middle;background-repeat:no-repeat;background-position:50% 50%;background-size:contain;background-color:#000;cursor:pointer;margin:0;padding:0;position:absolute;top:0;right:0;bottom:0;left:0;height:100%}.vjs-has-started .vjs-poster{display:none}.vjs-audio.vjs-has-started .vjs-poster{display:block}.vjs-using-native-controls .vjs-poster{display:none}.video-js .vjs-live-control{display:flex;align-items:flex-start;flex:auto;font-size:1em;line-height:3em}.vjs-no-flex .vjs-live-control{display:table-cell;width:auto;text-align:left}.video-js .vjs-time-control{flex:none;font-size:1em;line-height:3em;min-width:2em;width:auto;padding-left:1em;padding-right:1em}.video-js .vjs-current-time,.video-js .vjs-duration,.vjs-live .vjs-time-control,.vjs-no-flex .vjs-current-time,.vjs-no-flex .vjs-duration{display:none}.vjs-time-divider{display:none;line-height:3em}.vjs-live .vjs-time-divider{display:none}.video-js .vjs-play-control .vjs-icon-placeholder{cursor:pointer;flex:none}.vjs-text-track-display{position:absolute;bottom:3em;left:0;right:0;top:0;pointer-events:none}.video-js.vjs-user-inactive.vjs-playing .vjs-text-track-display{bottom:1em}.video-js .vjs-text-track{font-size:1.4em;text-align:center;margin-bottom:.1em}.vjs-subtitles{color:#fff}.vjs-captions{color:#fc6}.vjs-tt-cue{display:block}video::-webkit-media-text-track-display{-webkit-transform:translateY(-3em);transform:translateY(-3em)}.video-js.vjs-user-inactive.vjs-playing video::-webkit-media-text-track-display{-webkit-transform:translateY(-1.5em);transform:translateY(-1.5em)}.video-js .vjs-fullscreen-control{cursor:pointer;flex:none}.vjs-playback-rate .vjs-playback-rate-value,.vjs-playback-rate>.vjs-menu-button{position:absolute;top:0;left:0;width:100%;height:100%}.vjs-playback-rate .vjs-playback-rate-value{pointer-events:none;font-size:1.5em;line-height:2;text-align:center}.vjs-playback-rate .vjs-menu{width:4em;left:0}.vjs-error .vjs-error-display .vjs-modal-dialog-content{font-size:1.4em;text-align:center}.vjs-error .vjs-error-display:before{color:#fff;content:\"X\";font-family:Arial,Helvetica,sans-serif;font-size:4em;left:0;line-height:1;margin-top:-.5em;position:absolute;text-shadow:.05em .05em .1em #000;text-align:center;top:50%;vertical-align:middle;width:100%}.vjs-loading-spinner{display:none;position:absolute;top:50%;left:50%;margin:-25px 0 0 -25px;opacity:.85;text-align:left;border:6px solid rgba(43,51,63,.7);box-sizing:border-box;background-clip:padding-box;width:50px;height:50px;border-radius:25px;visibility:hidden}.vjs-seeking .vjs-loading-spinner,.vjs-waiting .vjs-loading-spinner{display:block;-webkit-animation:0s linear .3s forwards vjs-spinner-show;animation:0s linear .3s forwards vjs-spinner-show}.vjs-loading-spinner:after,.vjs-loading-spinner:before{content:\"\";position:absolute;margin:-6px;box-sizing:inherit;width:inherit;height:inherit;border-radius:inherit;opacity:1;border:inherit;border-color:transparent;border-top-color:#fff}.vjs-seeking .vjs-loading-spinner:after,.vjs-seeking .vjs-loading-spinner:before,.vjs-waiting .vjs-loading-spinner:after,.vjs-waiting .vjs-loading-spinner:before{-webkit-animation:vjs-spinner-spin 1.1s cubic-bezier(.6,.2,0,.8) infinite,vjs-spinner-fade 1.1s linear infinite;animation:vjs-spinner-spin 1.1s cubic-bezier(.6,.2,0,.8) infinite,vjs-spinner-fade 1.1s linear infinite}.vjs-seeking .vjs-loading-spinner:before,.vjs-waiting .vjs-loading-spinner:before{border-top-color:#fff}.vjs-seeking .vjs-loading-spinner:after,.vjs-waiting .vjs-loading-spinner:after{border-top-color:#fff;-webkit-animation-delay:.44s;animation-delay:.44s}@keyframes vjs-spinner-show{to{visibility:visible}}@-webkit-keyframes vjs-spinner-show{to{visibility:visible}}@keyframes vjs-spinner-spin{to{-webkit-transform:rotate(1turn);transform:rotate(1turn)}}@-webkit-keyframes vjs-spinner-spin{to{-webkit-transform:rotate(1turn)}}@keyframes vjs-spinner-fade{0%{border-top-color:#73859f}20%{border-top-color:#73859f}35%{border-top-color:#fff}60%{border-top-color:#73859f}to{border-top-color:#73859f}}@-webkit-keyframes vjs-spinner-fade{0%{border-top-color:#73859f}20%{border-top-color:#73859f}35%{border-top-color:#fff}60%{border-top-color:#73859f}to{border-top-color:#73859f}}.vjs-chapters-button .vjs-menu ul{width:24em}.video-js .vjs-subs-caps-button+.vjs-menu .vjs-captions-menu-item .vjs-menu-item-text .vjs-icon-placeholder{vertical-align:middle;display:inline-block;margin-bottom:-.1em}.video-js .vjs-subs-caps-button+.vjs-menu .vjs-captions-menu-item .vjs-menu-item-text .vjs-icon-placeholder:before{font-family:VideoJS;content:\"\\F10D\";font-size:1.5em;line-height:inherit}.video-js .vjs-audio-button+.vjs-menu .vjs-main-desc-menu-item .vjs-menu-item-text .vjs-icon-placeholder{vertical-align:middle;display:inline-block;margin-bottom:-.1em}.video-js .vjs-audio-button+.vjs-menu .vjs-main-desc-menu-item .vjs-menu-item-text .vjs-icon-placeholder:before{font-family:VideoJS;content:\" \\F11D\";font-size:1.5em;line-height:inherit}.video-js.vjs-layout-tiny:not(.vjs-fullscreen) .vjs-custom-control-spacer{flex:auto}.video-js.vjs-layout-tiny:not(.vjs-fullscreen).vjs-no-flex .vjs-custom-control-spacer{width:auto}.video-js.vjs-layout-small:not(.vjs-fullscreen) .vjs-captions-button,.video-js.vjs-layout-small:not(.vjs-fullscreen) .vjs-chapters-button,.video-js.vjs-layout-small:not(.vjs-fullscreen) .vjs-current-time,.video-js.vjs-layout-small:not(.vjs-fullscreen) .vjs-descriptions-button,.video-js.vjs-layout-small:not(.vjs-fullscreen) .vjs-duration,.video-js.vjs-layout-small:not(.vjs-fullscreen) .vjs-mute-control,.video-js.vjs-layout-small:not(.vjs-fullscreen) .vjs-playback-rate,.video-js.vjs-layout-small:not(.vjs-fullscreen) .vjs-remaining-time,.video-js.vjs-layout-small:not(.vjs-fullscreen) .vjs-subtitles-button .vjs-audio-button,.video-js.vjs-layout-small:not(.vjs-fullscreen) .vjs-time-divider,.video-js.vjs-layout-small:not(.vjs-fullscreen) .vjs-volume-control,.video-js.vjs-layout-tiny:not(.vjs-fullscreen) .vjs-audio-button,.video-js.vjs-layout-tiny:not(.vjs-fullscreen) .vjs-captions-button,.video-js.vjs-layout-tiny:not(.vjs-fullscreen) .vjs-chapters-button,.video-js.vjs-layout-tiny:not(.vjs-fullscreen) .vjs-current-time,.video-js.vjs-layout-tiny:not(.vjs-fullscreen) .vjs-descriptions-button,.video-js.vjs-layout-tiny:not(.vjs-fullscreen) .vjs-duration,.video-js.vjs-layout-tiny:not(.vjs-fullscreen) .vjs-mute-control,.video-js.vjs-layout-tiny:not(.vjs-fullscreen) .vjs-playback-rate,.video-js.vjs-layout-tiny:not(.vjs-fullscreen) .vjs-progress-control,.video-js.vjs-layout-tiny:not(.vjs-fullscreen) .vjs-remaining-time,.video-js.vjs-layout-tiny:not(.vjs-fullscreen) .vjs-subtitles-button,.video-js.vjs-layout-tiny:not(.vjs-fullscreen) .vjs-time-divider,.video-js.vjs-layout-tiny:not(.vjs-fullscreen) .vjs-volume-control,.video-js.vjs-layout-x-small:not(.vjs-fullscreen) .vjs-audio-button,.video-js.vjs-layout-x-small:not(.vjs-fullscreen) .vjs-captions-button,.video-js.vjs-layout-x-small:not(.vjs-fullscreen) .vjs-chapters-button,.video-js.vjs-layout-x-small:not(.vjs-fullscreen) .vjs-current-time,.video-js.vjs-layout-x-small:not(.vjs-fullscreen) .vjs-descriptions-button,.video-js.vjs-layout-x-small:not(.vjs-fullscreen) .vjs-duration,.video-js.vjs-layout-x-small:not(.vjs-fullscreen) .vjs-mute-control,.video-js.vjs-layout-x-small:not(.vjs-fullscreen) .vjs-playback-rate,.video-js.vjs-layout-x-small:not(.vjs-fullscreen) .vjs-remaining-time,.video-js.vjs-layout-x-small:not(.vjs-fullscreen) .vjs-subtitles-button,.video-js.vjs-layout-x-small:not(.vjs-fullscreen) .vjs-time-divider,.video-js.vjs-layout-x-small:not(.vjs-fullscreen) .vjs-volume-control{display:none}.vjs-modal-dialog.vjs-text-track-settings{background-color:#2b333f;background-color:rgba(43,51,63,.75);color:#fff;height:70%}.vjs-text-track-settings .vjs-modal-dialog-content{display:table}.vjs-text-track-settings .vjs-track-settings-colors,.vjs-text-track-settings .vjs-track-settings-controls,.vjs-text-track-settings .vjs-track-settings-font{display:table-cell}.vjs-text-track-settings .vjs-track-settings-controls{text-align:right;vertical-align:bottom}@supports (display:grid){.vjs-text-track-settings .vjs-modal-dialog-content{display:grid;grid-template-columns:1fr 1fr;grid-template-rows:1fr auto}.vjs-text-track-settings .vjs-track-settings-colors{display:block;grid-column:1;grid-row:1}.vjs-text-track-settings .vjs-track-settings-font{grid-column:2;grid-row:1}.vjs-text-track-settings .vjs-track-settings-controls{grid-column:2;grid-row:2}}.vjs-track-setting>select{margin-right:5px}.vjs-text-track-settings fieldset{margin:5px;padding:3px;border:none}.vjs-text-track-settings fieldset span{display:inline-block}.vjs-text-track-settings legend{color:#fff;margin:0 0 5px}.vjs-text-track-settings .vjs-label{position:absolute;clip:rect(1px 1px 1px 1px);clip:rect(1px,1px,1px,1px);display:block;margin:0 0 5px;padding:0;border:0;height:1px;width:1px;overflow:hidden}.vjs-track-settings-controls button:active,.vjs-track-settings-controls button:focus{outline-style:solid;outline-width:medium;background-image:linear-gradient(0deg,#fff 88%,#73859f)}.vjs-track-settings-controls button:hover{color:rgba(43,51,63,.75)}.vjs-track-settings-controls button{background-color:#fff;background-image:linear-gradient(-180deg,#fff 88%,#73859f);color:#2b333f;cursor:pointer;border-radius:2px}.vjs-track-settings-controls .vjs-default-button{margin-right:1em}@media print{.video-js>:not(.vjs-tech):not(.vjs-poster){visibility:hidden}}.vjs-resize-manager{position:absolute;top:0;left:0;width:100%;height:100%;border:none;visibility:hidden}", ""]);
	
	// exports


/***/ },
/* 819 */
/***/ function(module, exports, __webpack_require__) {

	var escape = __webpack_require__(328);
	exports = module.exports = __webpack_require__(122)(false);
	// imports
	
	
	// module
	exports.push([module.id, "/*!\n * Icon Font Guroo-Producer\n * Made with love by Icons8 [ https://icons8.com/ ] using FontCustom [ https://github.com/FontCustom/fontcustom ]\n *\n * Contacts:\n *    [ https://icons8.com/contact ]\n *\n * Follow Icon8 on\n *    Twitter [ https://twitter.com/icons_8 ]\n *    Facebook [ https://www.facebook.com/Icons8 ]\n *    Google+ [ https://plus.google.com/+Icons8 ]\n *    GitHub [ https://github.com/icons8 ]\n */@font-face{font-family:Guroo-Producer;src:url(" + escape(__webpack_require__(349)) + ");src:url(" + escape(__webpack_require__(349)) + "?#iefix) format(\"embedded-opentype\"),url(" + escape(__webpack_require__(1125)) + ") format(\"woff2\"),url(" + escape(__webpack_require__(1124)) + ") format(\"woff\"),url(" + escape(__webpack_require__(1098)) + ") format(\"truetype\"),url(" + escape(__webpack_require__(435)) + "#Guroo-Producer) format(\"svg\");font-weight:400;font-style:normal}@media screen and (-webkit-min-device-pixel-ratio:0){@font-face{font-family:Guroo-Producer;src:url(" + escape(__webpack_require__(435)) + "#Guroo-Producer) format(\"svg\")}}.icons8-achievement-filled:before,.icons8-achievement:before,.icons8-activity-grid-2-filled:before,.icons8-activity-grid-2:before,.icons8-angry:before,.icons8-applause-filled:before,.icons8-applause:before,.icons8-arrow-back:before,.icons8-arrow-collapse:before,.icons8-arrow-expand:before,.icons8-arrow-list:before,.icons8-arrow-right:before,.icons8-attach:before,.icons8-audio:before,.icons8-autograph:before,.icons8-calendar:before,.icons8-camera:before,.icons8-change:before,.icons8-character-speak:before,.icons8-chat-bubble:before,.icons8-chat-filled:before,.icons8-checkbox-correct:before,.icons8-checkbox-filled:before,.icons8-checkbox-ok:before,.icons8-checked-checkbox:before,.icons8-checked-incorrect:before,.icons8-circle-half:before,.icons8-circle:before,.icons8-circled-arrow--down:before,.icons8-circled-arrow-down-filled:before,.icons8-circled-arrow-left-filled:before,.icons8-circled-arrow-left:before,.icons8-circled-arrow-right-2:before,.icons8-circled-arrow-right-filled:before,.icons8-circled-arrow-right:before,.icons8-circled-arrow-up-filled:before,.icons8-circled-arrow-up:before,.icons8-circled-collapse-filled:before,.icons8-circled-collapse:before,.icons8-circled-correct-filled:before,.icons8-circled-down-right:before,.icons8-circled-down:before,.icons8-circled-expand-filled:before,.icons8-circled-left:before,.icons8-circled-right:before,.icons8-circled-up:before,.icons8-cirlced-close:before,.icons8-cirlced-expand:before,.icons8-cirlced-incorrect:before,.icons8-class:before,.icons8-close-window-filled:before,.icons8-close-window:before,.icons8-cloud-checked-filled:before,.icons8-confused:before,.icons8-contact-us:before,.icons8-conversation-choice:before,.icons8-cool:before,.icons8-copy:before,.icons8-cross-list:before,.icons8-crying:before,.icons8-decrease-font:before,.icons8-devices:before,.icons8-dialogue:before,.icons8-document:before,.icons8-double-down-filled:before,.icons8-down:before,.icons8-download-filled:before,.icons8-download:before,.icons8-drafting-compass-2:before,.icons8-edit:before,.icons8-exit-2:before,.icons8-exit-3:before,.icons8-exit-4:before,.icons8-exit:before,.icons8-export:before,.icons8-eye:before,.icons8-facebook:before,.icons8-file:before,.icons8-folder-filled:before,.icons8-gears:before,.icons8-geography-2:before,.icons8-geography:before,.icons8-goal:before,.icons8-google-plus:before,.icons8-goto:before,.icons8-graph:before,.icons8-grid-filled:before,.icons8-guroo-library:before,.icons8-hand-down:before,.icons8-happy:before,.icons8-heart-health:before,.icons8-height-filled:before,.icons8-high-importance-filled:before,.icons8-high-importance:before,.icons8-home:before,.icons8-horizontal-settings-mixer:before,.icons8-icorrect-checkbox:before,.icons8-image-2:before,.icons8-image:before,.icons8-incorrect:before,.icons8-increase-font:before,.icons8-info-2:before,.icons8-info-filled:before,.icons8-info:before,.icons8-information:before,.icons8-interactive-video:before,.icons8-invisible:before,.icons8-learner-speak-choice:before,.icons8-learner-speak:before,.icons8-learning-game:before,.icons8-left:before,.icons8-link-2:before,.icons8-link:before,.icons8-linkedin:before,.icons8-lock:before,.icons8-lol:before,.icons8-menu:before,.icons8-microsoft-powerpoint-filled:before,.icons8-minus:before,.icons8-monitor:before,.icons8-more:before,.icons8-multiple-choice-single-answer:before,.icons8-multiple-choice:before,.icons8-multiply:before,.icons8-neutral:before,.icons8-news:before,.icons8-note:before,.icons8-ok-2:before,.icons8-ok:before,.icons8-open-folder-filled:before,.icons8-outline:before,.icons8-padlock:before,.icons8-paragraph:before,.icons8-pdf:before,.icons8-pencil:before,.icons8-performance-overview:before,.icons8-performance-results:before,.icons8-phone-landscape:before,.icons8-phone-portrait:before,.icons8-phone:before,.icons8-play-button-circled:before,.icons8-play-property:before,.icons8-play:before,.icons8-plus-filled:before,.icons8-plus-list:before,.icons8-plus:before,.icons8-print-filled:before,.icons8-print:before,.icons8-profile:before,.icons8-publish:before,.icons8-question-2:before,.icons8-question:before,.icons8-radio-answered:before,.icons8-radio-checked:before,.icons8-radio:before,.icons8-record:before,.icons8-replay:before,.icons8-report-card:before,.icons8-reset-font:before,.icons8-resource-link:before,.icons8-right:before,.icons8-sad:before,.icons8-save:before,.icons8-scenario-bite:before,.icons8-search-filled:before,.icons8-settings-2:before,.icons8-settings:before,.icons8-single-choice:before,.icons8-sort-down-filled:before,.icons8-sort-down:before,.icons8-sort-right-filled:before,.icons8-sort-right:before,.icons8-speed-2:before,.icons8-speed:before,.icons8-standing-man:before,.icons8-standing-woman:before,.icons8-star-2:before,.icons8-star-filled:before,.icons8-star:before,.icons8-statistics:before,.icons8-stop:before,.icons8-stopwatch:before,.icons8-student-male:before,.icons8-surprised:before,.icons8-synchronize:before,.icons8-tablet-landscape:before,.icons8-tablet-portrait:before,.icons8-tablet:before,.icons8-text-paragraph:before,.icons8-thumb-up-filled-left:before,.icons8-thumb-up-filled-right:before,.icons8-thumbs-down-filled-left:before,.icons8-thumbs-down-filled-right:before,.icons8-tick-list:before,.icons8-tick:before,.icons8-todo-list:before,.icons8-toolbox-filled:before,.icons8-toolbox:before,.icons8-touch-reveal:before,.icons8-trash:before,.icons8-tree-structure:before,.icons8-twitter:before,.icons8-unchecked-checkbox:before,.icons8-undo-filled:before,.icons8-undo:before,.icons8-unicast-2:before,.icons8-unicast-filled-2:before,.icons8-unicast-filled:before,.icons8-unicast:before,.icons8-up:before,.icons8-upload-2:before,.icons8-upload-circled:before,.icons8-upload-filled:before,.icons8-upload:before,.icons8-user-groups:before,.icons8-video-2:before,.icons8-video-conference-filled:before,.icons8-video-conference:before,.icons8-video-play-button:before,.icons8-video-question:before,.icons8-video:before,.icons8-visible:before,.icons8-warning:before,.icons8-web-design:before,.icons8-width-filled:before,.icons8-word:before,.icons8-zoom-in:before,.icons8-zoom-out:before,.icons8-zoom-to-actual-size:before,[data-icons8]:before{display:inline-block;font-family:Guroo-Producer;font-style:normal;font-weight:400;font-variant:normal;line-height:1;text-decoration:inherit;text-rendering:optimizeLegibility;text-transform:none;-moz-osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased;font-smoothing:antialiased}[data-icons8]:before{content:attr(data-icons8)}.icons8-achievement:before{content:\"\\F237\"}.icons8-achievement-filled:before{content:\"\\F201\"}.icons8-activity-grid-2:before{content:\"\\F195\"}.icons8-activity-grid-2-filled:before{content:\"\\F19C\"}.icons8-angry:before{content:\"\\F18D\"}.icons8-applause:before{content:\"\\F1C0\"}.icons8-applause-filled:before{content:\"\\F17F\"}.icons8-arrow-back:before{content:\"\\F227\"}.icons8-arrow-collapse:before{content:\"\\F21F\"}.icons8-arrow-expand:before{content:\"\\F220\"}.icons8-arrow-list:before{content:\"\\F25F\"}.icons8-arrow-right:before{content:\"\\F221\"}.icons8-attach:before{content:\"\\F23D\"}.icons8-audio:before{content:\"\\F255\"}.icons8-autograph:before{content:\"\\F1B4\"}.icons8-calendar:before{content:\"\\F1BB\"}.icons8-camera:before{content:\"\\F1B3\"}.icons8-change:before{content:\"\\F1CE\"}.icons8-character-speak:before{content:\"\\F222\"}.icons8-chat-bubble:before{content:\"\\F23C\"}.icons8-chat-filled:before{content:\"\\F23F\"}.icons8-checkbox-correct:before{content:\"\\F275\"}.icons8-checkbox-filled:before{content:\"\\F271\"}.icons8-checkbox-ok:before{content:\"\\F276\"}.icons8-checked-checkbox:before{content:\"\\F176\"}.icons8-checked-incorrect:before{content:\"\\F277\"}.icons8-circle:before{content:\"\\F16A\"}.icons8-circle-half:before{content:\"\\F182\"}.icons8-circled-arrow--down:before{content:\"\\F223\"}.icons8-circled-arrow-down-filled:before{content:\"\\F23A\"}.icons8-circled-arrow-left:before{content:\"\\F108\"}.icons8-circled-arrow-left-filled:before{content:\"\\F107\"}.icons8-circled-arrow-right:before{content:\"\\F10A\"}.icons8-circled-arrow-right-2:before{content:\"\\F26D\"}.icons8-circled-arrow-right-filled:before{content:\"\\F109\"}.icons8-circled-arrow-up:before{content:\"\\F10C\"}.icons8-circled-arrow-up-filled:before{content:\"\\F10B\"}.icons8-circled-collapse:before{content:\"\\F10E\"}.icons8-circled-collapse-filled:before{content:\"\\F10D\"}.icons8-circled-correct-filled:before{content:\"\\F10F\"}.icons8-circled-down:before{content:\"\\F168\"}.icons8-circled-down-right:before{content:\"\\F110\"}.icons8-circled-expand-filled:before{content:\"\\F111\"}.icons8-circled-left:before{content:\"\\F112\"}.icons8-circled-right:before{content:\"\\F113\"}.icons8-circled-up:before{content:\"\\F114\"}.icons8-cirlced-close:before{content:\"\\F273\"}.icons8-cirlced-expand:before{content:\"\\F115\"}.icons8-cirlced-incorrect:before{content:\"\\F116\"}.icons8-class:before{content:\"\\F219\"}.icons8-close-window:before{content:\"\\F118\"}.icons8-close-window-filled:before{content:\"\\F117\"}.icons8-cloud-checked-filled:before{content:\"\\F119\"}.icons8-confused:before{content:\"\\F11A\"}.icons8-contact-us:before{content:\"\\F153\"}.icons8-conversation-choice:before{content:\"\\F1F3\"}.icons8-cool:before{content:\"\\F18C\"}.icons8-copy:before{content:\"\\F26B\"}.icons8-cross-list:before{content:\"\\F260\"}.icons8-crying:before{content:\"\\F189\"}.icons8-decrease-font:before{content:\"\\F282\"}.icons8-devices:before{content:\"\\F11B\"}.icons8-dialogue:before{content:\"\\F1F6\"}.icons8-document:before{content:\"\\F1F4\"}.icons8-double-down-filled:before{content:\"\\F1D1\"}.icons8-down:before{content:\"\\F11C\"}.icons8-download:before{content:\"\\F24B\"}.icons8-download-filled:before{content:\"\\F11D\"}.icons8-drafting-compass-2:before{content:\"\\F184\"}.icons8-edit:before{content:\"\\F11E\"}.icons8-exit:before{content:\"\\F1AC\"}.icons8-exit-2:before{content:\"\\F267\"}.icons8-exit-3:before{content:\"\\F268\"}.icons8-exit-4:before{content:\"\\F269\"}.icons8-export:before{content:\"\\F27B\"}.icons8-eye:before{content:\"\\F1D0\"}.icons8-facebook:before{content:\"\\F1D6\"}.icons8-file:before{content:\"\\F11F\"}.icons8-folder-filled:before{content:\"\\F120\"}.icons8-gears:before{content:\"\\F25D\"}.icons8-geography:before{content:\"\\F22E\"}.icons8-geography-2:before{content:\"\\F22D\"}.icons8-goal:before{content:\"\\F20F\"}.icons8-google-plus:before{content:\"\\F1D7\"}.icons8-goto:before{content:\"\\F1D4\"}.icons8-graph:before{content:\"\\F1F5\"}.icons8-grid-filled:before{content:\"\\F197\"}.icons8-guroo-library:before{content:\"\\F14C\"}.icons8-hand-down:before{content:\"\\F24D\"}.icons8-happy:before{content:\"\\F18A\"}.icons8-heart-health:before{content:\"\\F26F\"}.icons8-height-filled:before{content:\"\\F249\"}.icons8-high-importance:before{content:\"\\F122\"}.icons8-high-importance-filled:before{content:\"\\F121\"}.icons8-home:before{content:\"\\F123\"}.icons8-horizontal-settings-mixer:before{content:\"\\F1CD\"}.icons8-icorrect-checkbox:before{content:\"\\F17B\"}.icons8-image:before{content:\"\\F124\"}.icons8-image-2:before{content:\"\\F22F\"}.icons8-incorrect:before{content:\"\\F125\"}.icons8-increase-font:before{content:\"\\F281\"}.icons8-info:before{content:\"\\F127\"}.icons8-info-2:before{content:\"\\F190\"}.icons8-info-filled:before{content:\"\\F126\"}.icons8-information:before{content:\"\\F253\"}.icons8-interactive-video:before{content:\"\\F14D\"}.icons8-invisible:before{content:\"\\F128\"}.icons8-learner-speak:before{content:\"\\F12A\"}.icons8-learner-speak-choice:before{content:\"\\F234\"}.icons8-learning-game:before{content:\"\\F14E\"}.icons8-left:before{content:\"\\F12B\"}.icons8-link:before{content:\"\\F17D\"}.icons8-link-2:before{content:\"\\F1F8\"}.icons8-linkedin:before{content:\"\\F151\"}.icons8-lock:before{content:\"\\F241\"}.icons8-lol:before{content:\"\\F18B\"}.icons8-menu:before{content:\"\\F12D\"}.icons8-microsoft-powerpoint-filled:before{content:\"\\F21A\"}.icons8-minus:before{content:\"\\F12E\"}.icons8-monitor:before{content:\"\\F12F\"}.icons8-more:before{content:\"\\F130\"}.icons8-multiple-choice:before{content:\"\\F132\"}.icons8-multiple-choice-single-answer:before{content:\"\\F131\"}.icons8-multiply:before{content:\"\\F172\"}.icons8-neutral:before{content:\"\\F18F\"}.icons8-news:before{content:\"\\F1BA\"}.icons8-note:before{content:\"\\F1C3\"}.icons8-ok:before{content:\"\\F16F\"}.icons8-ok-2:before{content:\"\\F181\"}.icons8-open-folder-filled:before{content:\"\\F133\"}.icons8-outline:before{content:\"\\F1C7\"}.icons8-padlock:before{content:\"\\F242\"}.icons8-paragraph:before{content:\"\\F134\"}.icons8-pdf:before{content:\"\\F27D\"}.icons8-pencil:before{content:\"\\F191\"}.icons8-performance-overview:before{content:\"\\F1F9\"}.icons8-performance-results:before{content:\"\\F1FA\"}.icons8-phone:before{content:\"\\F135\"}.icons8-phone-landscape:before{content:\"\\F205\"}.icons8-phone-portrait:before{content:\"\\F207\"}.icons8-play:before{content:\"\\F136\"}.icons8-play-button-circled:before{content:\"\\F259\"}.icons8-play-property:before{content:\"\\F252\"}.icons8-plus:before{content:\"\\F137\"}.icons8-plus-filled:before{content:\"\\F1A5\"}.icons8-plus-list:before{content:\"\\F262\"}.icons8-print:before{content:\"\\F1C9\"}.icons8-print-filled:before{content:\"\\F1C8\"}.icons8-profile:before{content:\"\\F138\"}.icons8-publish:before{content:\"\\F1AA\"}.icons8-question:before{content:\"\\F188\"}.icons8-question-2:before{content:\"\\F238\"}.icons8-radio:before{content:\"\\F175\"}.icons8-radio-answered:before{content:\"\\F179\"}.icons8-radio-checked:before{content:\"\\F231\"}.icons8-record:before{content:\"\\F224\"}.icons8-replay:before{content:\"\\F25B\"}.icons8-report-card:before{content:\"\\F1CC\"}.icons8-reset-font:before{content:\"\\F280\"}.icons8-resource-link:before{content:\"\\F22A\"}.icons8-right:before{content:\"\\F13B\"}.icons8-sad:before{content:\"\\F187\"}.icons8-save:before{content:\"\\F1CA\"}.icons8-scenario-bite:before{content:\"\\F14F\"}.icons8-search-filled:before{content:\"\\F155\"}.icons8-settings:before{content:\"\\F13C\"}.icons8-settings-2:before{content:\"\\F1B1\"}.icons8-single-choice:before{content:\"\\F1FC\"}.icons8-sort-down:before{content:\"\\F214\"}.icons8-sort-down-filled:before{content:\"\\F217\"}.icons8-sort-right:before{content:\"\\F216\"}.icons8-sort-right-filled:before{content:\"\\F215\"}.icons8-speed:before{content:\"\\F24E\"}.icons8-speed-2:before{content:\"\\F279\"}.icons8-standing-man:before{content:\"\\F185\"}.icons8-standing-woman:before{content:\"\\F186\"}.icons8-star:before{content:\"\\F13E\"}.icons8-star-2:before{content:\"\\F1BD\"}.icons8-star-filled:before{content:\"\\F13D\"}.icons8-statistics:before{content:\"\\F1C1\"}.icons8-stop:before{content:\"\\F13F\"}.icons8-stopwatch:before{content:\"\\F1B8\"}.icons8-student-male:before{content:\"\\F251\"}.icons8-surprised:before{content:\"\\F18E\"}.icons8-synchronize:before{content:\"\\F140\"}.icons8-tablet:before{content:\"\\F141\"}.icons8-tablet-landscape:before{content:\"\\F20A\"}.icons8-tablet-portrait:before{content:\"\\F20B\"}.icons8-text-paragraph:before{content:\"\\F232\"}.icons8-thumb-up-filled-left:before{content:\"\\F16C\"}.icons8-thumb-up-filled-right:before{content:\"\\F16B\"}.icons8-thumbs-down-filled-left:before{content:\"\\F16D\"}.icons8-thumbs-down-filled-right:before{content:\"\\F16E\"}.icons8-tick:before{content:\"\\F142\"}.icons8-tick-list:before{content:\"\\F263\"}.icons8-todo-list:before{content:\"\\F250\"}.icons8-toolbox:before{content:\"\\F15B\"}.icons8-toolbox-filled:before{content:\"\\F170\"}.icons8-touch-reveal:before{content:\"\\F143\"}.icons8-trash:before{content:\"\\F144\"}.icons8-tree-structure:before{content:\"\\F1AD\"}.icons8-twitter:before{content:\"\\F152\"}.icons8-unchecked-checkbox:before{content:\"\\F177\"}.icons8-undo:before{content:\"\\F145\"}.icons8-undo-filled:before{content:\"\\F204\"}.icons8-unicast:before{content:\"\\F19B\"}.icons8-unicast-2:before{content:\"\\F19E\"}.icons8-unicast-filled:before{content:\"\\F19A\"}.icons8-unicast-filled-2:before{content:\"\\F19F\"}.icons8-up:before{content:\"\\F146\"}.icons8-upload:before{content:\"\\F1AF\"}.icons8-upload-2:before{content:\"\\F21C\"}.icons8-upload-circled:before{content:\"\\F1B6\"}.icons8-upload-filled:before{content:\"\\F147\"}.icons8-user-groups:before{content:\"\\F200\"}.icons8-video:before{content:\"\\F149\"}.icons8-video-2:before{content:\"\\F1FE\"}.icons8-video-conference:before{content:\"\\F211\"}.icons8-video-conference-filled:before{content:\"\\F212\"}.icons8-video-play-button:before{content:\"\\F257\"}.icons8-video-question:before{content:\"\\F148\"}.icons8-visible:before{content:\"\\F14A\"}.icons8-warning:before{content:\"\\F14B\"}.icons8-web-design:before{content:\"\\F1C5\"}.icons8-width-filled:before{content:\"\\F248\"}.icons8-word:before{content:\"\\F27E\"}.icons8-zoom-in:before{content:\"\\F244\"}.icons8-zoom-out:before{content:\"\\F245\"}.icons8-zoom-to-actual-size:before{content:\"\\F246\"}@font-face{font-family:FWDCircularWeb-Bold;src:url(" + escape(__webpack_require__(343)) + ");src:url(" + escape(__webpack_require__(343)) + "?#iefix) format(\"embedded-opentype\"),url(" + escape(__webpack_require__(1118)) + ") format(\"woff\");font-weight:400;font-style:normal}@font-face{font-family:FWDCircularWeb-Book;src:url(" + escape(__webpack_require__(345)) + ");src:url(" + escape(__webpack_require__(345)) + "?#iefix) format(\"embedded-opentype\"),url(" + escape(__webpack_require__(1120)) + ") format(\"woff\");font-weight:400;font-style:normal}@font-face{font-family:FWDCircularWeb-BookItalic;src:url(" + escape(__webpack_require__(346)) + ");src:url(" + escape(__webpack_require__(346)) + "?#iefix) format(\"embedded-opentype\"),url(" + escape(__webpack_require__(1121)) + ") format(\"woff\");font-weight:400;font-style:normal}@font-face{font-family:FWDCircularWeb-Medium;src:url(" + escape(__webpack_require__(347)) + ");src:url(" + escape(__webpack_require__(347)) + "?#iefix) format(\"embedded-opentype\"),url(" + escape(__webpack_require__(1122)) + ") format(\"woff\");font-weight:400;font-style:normal}@font-face{font-family:FWDCircularWeb-MediumItalic;src:url(" + escape(__webpack_require__(348)) + ");src:url(" + escape(__webpack_require__(348)) + "?#iefix) format(\"embedded-opentype\"),url(" + escape(__webpack_require__(1123)) + ") format(\"woff\");font-weight:400;font-style:normal}@font-face{font-family:FWDCircularWeb-BlackItalic;src:url(" + escape(__webpack_require__(342)) + ");src:url(" + escape(__webpack_require__(342)) + "?#iefix) format(\"embedded-opentype\"),url(" + escape(__webpack_require__(1117)) + ") format(\"woff\");font-weight:400;font-style:normal}@font-face{font-family:FWDCircularWeb-BoldItalic;src:url(" + escape(__webpack_require__(344)) + ");src:url(" + escape(__webpack_require__(344)) + "?#iefix) format(\"embedded-opentype\"),url(" + escape(__webpack_require__(1119)) + ") format(\"woff\");font-weight:400;font-style:normal}@font-face{font-family:FWDCircularWeb-Black;src:url(" + escape(__webpack_require__(341)) + ");src:url(" + escape(__webpack_require__(341)) + "?#iefix) format(\"embedded-opentype\"),url(" + escape(__webpack_require__(1116)) + ") format(\"woff\");font-weight:400;font-style:normal}@font-face{font-family:FWDCircularVietWeb-Bold;src:url(" + escape(__webpack_require__(335)) + ");src:url(" + escape(__webpack_require__(335)) + "?#iefix) format(\"embedded-opentype\"),url(" + escape(__webpack_require__(1110)) + ") format(\"woff\");font-weight:400;font-style:normal}@font-face{font-family:FWDCircularVietWeb-Medium;src:url(" + escape(__webpack_require__(339)) + ");src:url(" + escape(__webpack_require__(339)) + "?#iefix) format(\"embedded-opentype\"),url(" + escape(__webpack_require__(1114)) + ") format(\"woff\");font-weight:400;font-style:normal}@font-face{font-family:FWDCircularVietWeb-Book;src:url(" + escape(__webpack_require__(337)) + ");src:url(" + escape(__webpack_require__(337)) + "?#iefix) format(\"embedded-opentype\"),url(" + escape(__webpack_require__(1112)) + ") format(\"woff\");font-weight:400;font-style:normal}@font-face{font-family:FWDCircularVietWeb-MediumItalic;src:url(" + escape(__webpack_require__(340)) + ");src:url(" + escape(__webpack_require__(340)) + "?#iefix) format(\"embedded-opentype\"),url(" + escape(__webpack_require__(1115)) + ") format(\"woff\");font-weight:400;font-style:normal}@font-face{font-family:FWDCircularVietWeb-BlackItalic;src:url(" + escape(__webpack_require__(334)) + ");src:url(" + escape(__webpack_require__(334)) + "?#iefix) format(\"embedded-opentype\"),url(" + escape(__webpack_require__(1109)) + ") format(\"woff\");font-weight:400;font-style:normal}@font-face{font-family:FWDCircularVietWeb-BoldItalic;src:url(" + escape(__webpack_require__(336)) + ");src:url(" + escape(__webpack_require__(336)) + "?#iefix) format(\"embedded-opentype\"),url(" + escape(__webpack_require__(1111)) + ") format(\"woff\");font-weight:400;font-style:normal}@font-face{font-family:FWDCircularVietWeb-Black;src:url(" + escape(__webpack_require__(333)) + ");src:url(" + escape(__webpack_require__(333)) + "?#iefix) format(\"embedded-opentype\"),url(" + escape(__webpack_require__(1108)) + ") format(\"woff\");font-weight:400;font-style:normal}@font-face{font-family:FWDCircularVietWeb-BookItalic;src:url(" + escape(__webpack_require__(338)) + ");src:url(" + escape(__webpack_require__(338)) + "?#iefix) format(\"embedded-opentype\"),url(" + escape(__webpack_require__(1113)) + ") format(\"woff\");font-weight:400;font-style:normal}.flex-row-nowrap{flex-flow:row nowrap}.flex-row-nowrap,.flex-row-wrap{display:-webkit-flex;display:flex}.flex-row-wrap{flex-flow:row wrap}.flex-row-wrap-reverse{display:-webkit-flex;display:flex;flex-flow:row wrap-reverse}.flex-row-reverse-nowrap{display:-webkit-flex;display:flex;flex-flow:row-reverse nowrap}.flex-row-reverse-wrap{display:-webkit-flex;display:flex;flex-flow:row-reverse wrap}.flex-row-reverse-wrap-reverse{display:-webkit-flex;display:flex;flex-flow:row-reverse wrap-reverse}.flex-col-nowrap{flex-flow:column nowrap}.flex-col-nowrap,.flex-col-wrap{display:-webkit-flex;display:flex}.flex-col-wrap{flex-flow:column wrap}.flex-col-wrap-reverse{display:-webkit-flex;display:flex;flex-flow:column wrap-reverse}.flex-col-reverse-nowrap{display:-webkit-flex;display:flex;flex-flow:column-reverse nowrap}.flex-col-reverse-wrap{display:-webkit-flex;display:flex;flex-flow:column-reverse wrap}.flex-col-reverse-wrap-reverse{display:-webkit-flex;display:flex;flex-flow:column-reverse wrap-reverse}.flex-justify-content-start{justify-content:flex-start}.flex-justify-content-end{justify-content:flex-end}.flex-justify-content-center{justify-content:center}.flex-justify-content-space-between{justify-content:space-between}.flex-justify-content-space-around{justify-content:space-around}.flex-justify-content-space-evenly{justify-content:space-evenly}.flex-align-items-start{align-items:flex-start}.flex-align-items-end{align-items:flex-end}.flex-align-items-center{align-items:center}.flex-align-items-stretch{align-items:stretch}.flex-align-items-baseline{align-items:baseline}.flex-align-content-start{align-content:flex-start}.flex-align-content-end{align-content:flex-end}.flex-align-content-center{align-content:center}.flex-align-content-space-between{align-content:space-between}.flex-align-content-space-around{align-content:space-around}.flex-align-content-space-evenly{align-content:space-evenly}.flex-item{margin:0 5px;position:relative}.flex-item:first-child{margin-left:0}.flex-item:last-child{margin-right:0}@media only screen and (max-width:736px) and (orientation:portrait){.flex-item{position:unset}}.flex-none{flex:none}.flex-1{flex:1}.flex-2{flex:2}.flex-3{flex:3}.flex-4{flex:4}.flex-5{flex:5}.flex-6{flex:6}.seperator{display:block;min-height:30px;height:100%;background:#d5d5d5;width:1px;margin:0 10px}.flex-grid{display:flex;justify-content:space-between;flex-wrap:wrap}.flex-grid-cell{border-radius:5px;padding:16px 24px;overflow:hidden;margin:0 .5em 1em;width:calc(50% - 1em);height:100%}*{box-sizing:border-box}body,html{height:100%;-webkit-font-smoothing:antialiased;text-rendering:optimizeLegibility}body{position:relative;margin:0 auto;padding:0;font-size:2.1em}body:before{z-index:2;top:-30px;left:-30px;width:calc(100% + 60px);height:calc(100% + 60px);opacity:.5;filter:blur(15px);background-attachment:fixed;background-size:100% 100%!important;background-repeat:no-repeat}body:after,body:before{display:block;position:fixed;content:\"\"}body:after{top:0;left:0;width:100%;height:200%;z-index:1}.main-content-wrapper{overflow:hidden;overflow:visible!important;font-size:.8em;z-index:3}.main,.main-content-wrapper{display:block;position:relative;width:100%;height:100%}.main{overflow:hidden;max-height:770px;font-family:Helvetica Neue,Helvetica,Arial,san-serif;margin:0 auto;padding:0}@media only screen and (max-width:375px) and (max-height:736px) and (orientation:portrait){.main{height:100%!important;min-height:100vh!important}}@media only screen and (max-height:375px) and (max-width:736px) and (orientation:landscape){.main{height:100%!important;min-height:100vh!important}}@media only screen and (min-width:376px) and (max-width:414px) and (max-height:736px) and (orientation:portrait){.main{height:100%!important;min-height:100vh}}@media only screen and (min-height:376px) and (max-height:414px) and (max-width:736px) and (orientation:landscape){.main{height:100%!important;min-height:100vh!important}}@media only screen and (max-width:375px) and (min-height:737px) and (max-height:812px) and (orientation:portrait){.main{height:100%!important;min-height:100vh}}@media only screen and (min-width:737px) and (max-width:812px) and (max-height:375px) and (orientation:landscape){.main{height:100%!important;min-height:100vh!important}}@media only screen and (min-width:768px) and (max-width:1024px) and (orientation:landscape){.main{height:100%!important;min-height:664px}}@media only screen and (min-width:768px) and (max-width:1024px) and (orientation:portrait){.main{height:100%!important;min-height:924px}}@media only screen and (max-width:320px) and (max-height:568px) and (orientation:portrait){.main{height:100%!important;min-height:100vh!important}}.content-body{-webkit-box-shadow:0 1px 5px 3px rgba(0,0,0,.75);-moz-box-shadow:0 1px 5px 3px rgba(0,0,0,.75);box-shadow:0 1px 5px 3px rgba(0,0,0,.75)}a:active,a:focus,a:hover{text-decoration:none}h1,h2,h3,h4{font-family:Arial Rounded MT Bold,Helvetica Rounded,Arial,sans-serif;margin:0 0 10px;line-height:150%}h4{font-size:130%}.btn{transition:background .2s ease-in}.btn.tight{margin:0}.abs-btn{position:absolute!important;left:50%;top:50%}.centered-panel-sml{text-align:center;margin:0 auto;width:auto;min-width:50%;max-width:33.33333%;padding:30px 40px;margin-top:25%;border-radius:5px;background:hsla(0,0%,100%,.3)}.abs-centered-panel-sml{left:33.33%;position:absolute;text-align:center;width:33.33%;height:auto;padding-top:33.33%;top:15%;border-radius:50%;z-index:10000}.abs-centered-panel-sml span{position:absolute;display:block;width:70%;top:20%;left:0;right:0;margin:auto}.abs-centered-panel-sml-mobile{color:#fff;padding:32px 24px;text-align:center}.preloading-image-polaroid{width:100px;height:120px;position:absolute;background:#333;padding:2px;opacity:0;top:50%;left:50%;overflow:hidden}.preloading-image-polaroid:after{text-align:center;display:block;position:absolute;bottom:0;left:0;background:#333;width:100%;padding:4px 0 8px;font-size:80%;line-height:100%;color:#fff;content:\"snapshot\";font-style:italic;font-family:Comic Sans MS;font-weight:100}.preloading-image-polaroid img{position:absolute;top:2px;left:2px;background:#fff;width:calc(100% - 4px);min-height:80px;height:auto;border-top-left-radius:6px;border-top-right-radius:6px}.preloading-image{width:100px;height:100px;position:absolute;padding:0;margin:0;background:#fff;opacity:0;top:0;left:-100px;overflow:hidden;border-radius:50%;border-style:solid;border-width:2px}.preloading-image img{position:absolute;top:0;background:#fff;width:100%;min-width:102px;min-height:102px;height:auto;left:0;right:0;margin:auto}.inline-list{margin:0 0 10px;padding:0;display:block;position:relative;line-height:0}.inline-list.tight{margin:0}.inline-list .inline-item{display:inline-block;margin:0;line-height:0;padding:0 12px 0 0;vertical-align:middle!important}.inline-list .inline-item:last-child{padding-right:0}.inline-list .abs-right{position:absolute}.header-text{text-align:center}.header-items{margin:0;padding:0}.header-items .icon{font-size:32px}.truncate-text-container{position:relative;overflow:hidden}.truncate-text-container a,.truncate-text-container div,.truncate-text-container h1,.truncate-text-container h2,.truncate-text-container h3,.truncate-text-container h4,.truncate-text-container h5,.truncate-text-container li,.truncate-text-container p,.truncate-text-container span{height:100%;width:100%;overflow:hidden;display:block;white-space:nowrap;text-overflow:ellipsis}.tool-tip-wrapper{line-height:130%;text-align:left}.tool-tip-pointer{display:block;position:relative;z-index:999999!important;margin:0 auto;top:12px;left:8px}.tool-tip-pointer.achievement-tool-tip{top:14px}.tool-tip-pointer:before{position:absolute;width:0;height:0;left:-2px;top:0;border-left:12px solid transparent;border-right:12px solid transparent;border-bottom-width:12px;border-bottom-style:solid;content:\"\"}.tool-tip-pointer:after{position:absolute;top:3px;left:2px;width:0;height:0;border-left:8px solid transparent;border-right:8px solid transparent;border-bottom-width:9px;border-bottom-style:solid;content:\"\"}.tool-tip.header-tool-tip-left{margin:0 10px;display:block;width:100%;min-width:320px!important;position:absolute;z-index:99999!important;border-width:2px;border-style:solid;top:calc(100% + 18px);left:0;border-radius:5px;-webkit-box-shadow:0 5px 5px 0 rgba(0,0,0,.5);-moz-box-shadow:0 5px 5px 0 rgba(0,0,0,.5);box-shadow:0 5px 5px 0 rgba(0,0,0,.5)}@media only screen and (max-width:375px) and (max-height:736px) and (orientation:portrait){.tool-tip.header-tool-tip-left{left:5px;min-width:calc(100vw - 15px)!important}}.tool-tip.header-tool-tip-right{margin:0 10px;display:block;width:100%;min-width:305px!important;position:absolute;z-index:99999!important;border-width:2px;border-style:solid;top:calc(100% + 5px);right:-20px;border-radius:5px;-webkit-box-shadow:0 5px 5px 0 rgba(0,0,0,.5);-moz-box-shadow:0 5px 5px 0 rgba(0,0,0,.5);box-shadow:0 5px 5px 0 rgba(0,0,0,.5)}@media only screen and (max-width:375px) and (max-height:736px) and (orientation:portrait){.tool-tip.header-tool-tip-right{right:-5px;width:calc(100vw - 10px)!important}}@media only screen and (max-width:736px) and (orientation:landscape){.tool-tip.header-tool-tip-right{min-width:75vw!important;max-height:calc(100vh - 140px);overflow-y:scroll}}.tool-tip .tool-tip-content-wrapper{display:block;position:relative!important;padding:0;margin:0;clear:both;overflow:hidden}.tool-tip .tool-tip-content-wrapper:after{position:absolute;display:inline-block;font-family:Guroo-Producer;font-style:normal;font-weight:400;font-variant:normal;line-height:1;text-decoration:inherit;text-rendering:optimizeLegibility;text-transform:none;-moz-osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased;font-smoothing:antialiased;content:\"\\F172\";top:10px;right:15px}.title-panel{display:-webkit-flex;display:flex;flex-flow:row nowrap;justify-content:center;align-content:center;align-items:center;margin:0;padding:0;height:100%}.title-panel .title-content{flex:1;padding:30px 40px;text-align:center}.title-panel .title-content .title-icon-container{height:130px;margin:0 0 10px}.title-panel .title-content .title-icon-container img{height:100%;width:auto}@media only screen and (max-width:375px) and (max-height:736px) and (orientation:portrait){.title-panel .title-content{padding:30px 20px}.title-panel .title-content h2{font-size:30px!important}}@media only screen and (max-width:736px) and (orientation:landscape){.title-panel .title-content{padding:10px 40px}.title-panel .title-content .title-icon-container{height:80px!important}.title-panel .title-content h2{font-size:30px!important}}@media only screen and (min-width:376px) and (max-width:414px) and (max-height:736px) and (orientation:portrait){.title-panel .title-content{padding:30px 20px}.title-panel .title-content h2{font-size:30px!important}}@media only screen and (min-height:376px) and (max-height:414px) and (max-width:736px) and (orientation:landscape){.title-panel .title-content{padding:10px 40px}.title-panel .title-content .title-icon-container{height:80px!important}.title-panel .title-content h2{font-size:30px!important}}@media only screen and (max-width:375px) and (min-height:737px) and (max-height:812px) and (orientation:portrait){.title-panel .title-content{padding:30px 20px}.title-panel .title-content h2{font-size:30px!important}}@media only screen and (min-width:737px) and (max-width:812px) and (max-height:375px) and (orientation:landscape){.title-panel .title-content{padding:10px 40px}.title-panel .title-content .title-icon-container{height:80px!important}.title-panel .title-content h2{font-size:30px!important}}.footer-instruction-text{padding:12px 0;font-style:italic;color:#999}@media only screen and (max-width:375px) and (max-height:736px) and (orientation:portrait){.footer-instruction-text{padding:4px 0}}@media only screen and (max-height:375px) and (max-width:736px) and (orientation:landscape){.footer-instruction-text{padding:4px 0}}@media only screen and (min-width:376px) and (max-width:414px) and (max-height:736px) and (orientation:portrait){.footer-instruction-text{padding:4px 0}}@media only screen and (min-height:376px) and (max-height:414px) and (max-width:736px) and (orientation:landscape){.footer-instruction-text{padding:4px 0}}@media only screen and (max-width:375px) and (min-height:737px) and (max-height:812px) and (orientation:portrait){.footer-instruction-text{padding:4px 0}}@media only screen and (min-width:737px) and (max-width:812px) and (max-height:375px) and (orientation:landscape){.footer-instruction-text{padding:4px 0}}.footer-completion-text{padding:12px 0;font-style:italic}.footer-completion-text:before{font-size:130%;padding-right:5px;display:inline-block;font-family:Guroo-Producer;font-style:normal;font-weight:400;font-variant:normal;line-height:1;text-decoration:inherit;text-rendering:optimizeLegibility;text-transform:none;-moz-osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased;font-smoothing:antialiased;content:\"\\F17F\"}.instruction-text{font-style:italic}.feedback-instruction-text{color:#999;font-style:italic}.disabled-link{opacity:.2;transition:opacity .2s}.disabled-link:hover{opacity:.2;cursor:pointer}.content-rule{border-color:#333}.inline-form{display:inline-block}.inline-form.small{width:100px!important}.text-compare-complete{font-weight:700}@media only screen and (max-width:735px) and (orientation:portrait){.abs-centered-panel-sml{left:0;right:0;margin:auto;position:absolute;text-align:center;width:66.66%;height:auto;padding-top:66.66%}html{-ms-text-size-adjust:100%;-webkit-text-size-adjust:100%}.header-text{text-align:left;padding-top:5px;padding-left:24px!important}}@media only screen and (max-height:375px) and (max-width:736px) and (orientation:landscape){.header-text{text-align:left;padding-top:5px}}.width-100-center{width:100%;margin:0 auto}.width-100-center img{width:100%;height:auto}.width-90-center{width:90%;margin:0 auto}.width-90-center img{width:100%;height:auto}.width-80-center{width:80%;margin:0 auto}.width-80-center img{width:100%;height:auto}.width-70-center{width:70%;margin:0 auto}.width-70-center img{width:100%;height:auto}.width-60-center{width:60%;margin:0 auto}.width-60-center img{width:100%;height:auto}.width-50-center{width:50%;margin:0 auto}.width-50-center img{width:100%;height:auto}.width-40-center{width:40%;margin:0 auto}.width-40-center img{width:100%;height:auto}.width-30-center{width:30%;margin:0 auto}.width-30-center img{width:100%;height:auto}.width-20-center{width:20%;margin:0 auto}.width-20-center img{width:100%;height:auto}.width-10-center{width:10%;margin:0 auto}.width-10-center img{width:100%;height:auto}.float-right{float:right}.script{font-size:130%;font-family:Brush Script MT,cursive}.required-label{font-style:italic;color:#999}.tick-list ul{margin:0;padding:0}.tick-list ul li:not(.resource-link){position:relative;list-style-type:none;padding:0 0 10px 40px}.tick-list ul li:not(.resource-link):before{position:absolute;left:10px;top:4px;display:inline-block;font-family:Guroo-Producer;font-style:normal;font-weight:400;font-variant:normal;line-height:1;text-decoration:inherit;text-rendering:optimizeLegibility;text-transform:none;-moz-osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased;font-smoothing:antialiased;content:\"\\F263\";width:18px;height:18px;border-radius:50%;font-size:18px;color:#fff}.cross-list ul{margin:0;padding:0}.cross-list ul li:not(.resource-link){position:relative;list-style-type:none;padding:0 0 10px 40px}.cross-list ul li:not(.resource-link):before{position:absolute;left:10px;top:4px;display:inline-block;font-family:Guroo-Producer;font-style:normal;font-weight:400;font-variant:normal;line-height:1;text-decoration:inherit;text-rendering:optimizeLegibility;text-transform:none;-moz-osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased;font-smoothing:antialiased;content:\"\\F260\";width:18px;height:18px;border-radius:50%;font-size:18px;color:#fff}.plus-list ul{margin:0;padding:0}.plus-list ul li:not(.resource-link){position:relative;list-style-type:none;padding:0 0 10px 40px}.plus-list ul li:not(.resource-link):before{position:absolute;left:10px;top:4px;display:inline-block;font-family:Guroo-Producer;font-style:normal;font-weight:400;font-variant:normal;line-height:1;text-decoration:inherit;text-rendering:optimizeLegibility;text-transform:none;-moz-osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased;font-smoothing:antialiased;content:\"\\F262\";width:18px;height:18px;border-radius:50%;font-size:18px;color:#fff}.arrow-list ul{margin:0;padding:0}.arrow-list ul li:not(.resource-link){position:relative;list-style-type:none;padding:0 0 10px 40px}.arrow-list ul li:not(.resource-link):before{position:absolute;left:10px;top:4px;display:inline-block;font-family:Guroo-Producer;font-style:normal;font-weight:400;font-variant:normal;line-height:1;text-decoration:inherit;text-rendering:optimizeLegibility;text-transform:none;-moz-osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased;font-smoothing:antialiased;content:\"\\F25F\";width:18px;height:18px;border-radius:50%;font-size:18px;color:#fff}.dotted-list ul{margin:0;padding:0}.dotted-list ul li:not(.resource-link){position:relative;list-style-type:none;padding:0 0 10px 40px}.dotted-list ul li:not(.resource-link):before{position:absolute;left:10px;top:4px;display:inline-block;font-family:Guroo-Producer;font-style:normal;font-weight:400;font-variant:normal;line-height:1;text-decoration:inherit;text-rendering:optimizeLegibility;text-transform:none;-moz-osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased;font-smoothing:antialiased;content:\"\\F231\";width:18px;height:18px;border-radius:50%;font-size:18px}.bold{font-weight:700}blockquote{font-size:110%}.ql-align-center{text-align:center}.ql-align-right{text-align:right}.relative-block{overflow:hidden}.clear-both,.relative-block{display:block;position:relative}.clear-both{clear:both}.text-resize-list{margin:0 5px;padding:0 10px;background:#fff;border-radius:3px;font-size:24px;color:#6592cb;max-width:130px}.text-resize-list .text-resize-item{display:inline-block;padding:4px 6px}.text-resize-list .text-resize-item .resize-btn{background:transparent;border:0;padding:0;margin:0}.text-resize-list .text-resize-item .resize-btn:disabled{color:#d5d5d5}.text-resize-list .text-resize-item .resize-btn:active,.text-resize-list .text-resize-item .resize-btn:focus,.text-resize-list .text-resize-item .resize-btn:hover{opacity:.7}.text-resize-list .text-resize-item .increase-font-btn:before{content:\"\\F281\"}.text-resize-list .text-resize-item .decrease-font-btn:before,.text-resize-list .text-resize-item .increase-font-btn:before{display:inline-block;font-family:Guroo-Producer;font-style:normal;font-weight:400;font-variant:normal;line-height:1;text-decoration:inherit;text-rendering:optimizeLegibility;text-transform:none;-moz-osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased;font-smoothing:antialiased}.text-resize-list .text-resize-item .decrease-font-btn:before{content:\"\\F282\"}.text-resize-list .text-resize-item .reset-font-btn:before{display:inline-block;font-family:Guroo-Producer;font-style:normal;font-weight:400;font-variant:normal;line-height:1;text-decoration:inherit;text-rendering:optimizeLegibility;text-transform:none;-moz-osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased;font-smoothing:antialiased;content:\"\\F280\"}.btn-lg{font-size:110%}.btn{font-size:100%}.feedback-focus{position:relative;clear:both}.feedback-focus:focus{outline:none}a:active,a:focus,button:active,button:focus,div:focus,input:focus,span:focus{outline:none!important}.hidden-el{position:absolute;top:-200000px;left:-200000px}.title-case{text-transform:capitalize!important}* *{box-sizing:border-box}.badge-btn{position:relative;cursor:pointer}.badge-btn .badge-count{transition:color .3s ease;z-index:100;top:0;bottom:0;height:100%;text-align:center}.badge-btn .badge-count,.badge-btn .badge-count .status-indicator{left:0;right:0;margin:auto;width:100%;position:absolute;font-size:12px}.badge-btn .badge-count .status-indicator{top:10px;padding:1px 4px;font-weight:700;border-radius:12px;height:16px;line-height:100%;background:transparent}.badge-btn .btn-label{font-size:10px;padding:6px 0;text-align:center}.badge-btn.disabled{opacity:.5;cursor:default}.badge-btn.disabled:focus,.badge-btn.disabled:hover{opacity:.5}.badge-dashboard{padding:16px 24px;overflow:hidden}.badge-dashboard,.image-badge{display:block;position:relative}.image-badge{width:130px;height:130px;padding:0;margin:0 auto;margin-bottom:20px}.image-badge img{width:100%;height:auto}.badge{position:relative;display:block;width:120px;height:120px;padding:0;margin:0 auto;margin-bottom:20px;background:transparent!important}.badge.active{opacity:.7;cursor:pointer}.badge .badge-container{position:relative;width:100%;height:100%;margin:0;border-radius:5px}.badge .badge-container.not-achieved{-webkit-filter:grayscale(100%);filter:grayscale(100%)}.badge .badge-container.not-achieved :before{color:#d5d5d5}.badge .badge-container.not-achieved .badge-icon img{opacity:.5}.badge .badge-container:before{display:block;position:relative;margin:auto;font-size:120px;display:inline-block;font-family:Guroo-Producer;font-style:normal;font-weight:400;font-variant:normal;line-height:1;text-decoration:inherit;text-rendering:optimizeLegibility;text-transform:none;-moz-osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased;font-smoothing:antialiased;content:\"\\F201\"!important}.badge .badge-container .badge-icon{display:block;position:absolute;top:0;left:0;width:100%;height:100%}.badge .badge-container .badge-icon img{position:absolute;width:55%;height:auto;left:0;right:0;top:-16px;bottom:0;margin:auto}.badge .badge-label{position:absolute!important;bottom:-10px;padding:12px 8px;border-radius:24px;font-size:100%}.badge .achieved-count,.badge .badge-label{display:block;text-align:center;left:0;width:100%}.badge .achieved-count{position:absolute;top:0;padding:8px 4px;font-size:11px}.badge-grid{display:block;margin:0;padding:0}.badge-grid .badge-grid-item{margin:0;padding:0 5px;list-style-type:none;position:relative;display:block;float:left}.badge-grid .badge-grid-item:first-child:last-child{width:50%;margin-left:25%}.badge-grid .badge-grid-item:first-child:nth-last-child(2),.badge-grid .badge-grid-item:first-child:nth-last-child(2)~li{width:50%}.badge-grid .badge-grid-item:first-child:nth-last-child(3),.badge-grid .badge-grid-item:first-child:nth-last-child(3)~li{width:33.3333%}.badge-grid .badge-grid-item:first-child:nth-last-child(4),.badge-grid .badge-grid-item:first-child:nth-last-child(4)~li{width:50%}.badge-grid .badge-grid-item:first-child:nth-last-child(5){width:33.3333%}.badge-grid .badge-grid-item:first-child:nth-last-child(5)~li{width:33.3333%;clear:right}.badge-grid .badge-grid-item:first-child:nth-last-child(5)~li:nth-child(4){clear:right;margin-left:16.66665%}.badge-grid .badge-grid-item:first-child:nth-last-child(6),.badge-grid .badge-grid-item:first-child:nth-last-child(6)~li,.badge-grid .badge-grid-item:first-child:nth-last-child(7),.badge-grid .badge-grid-item:first-child:nth-last-child(7)~li{width:33.3333%}.badge-grid .badge-grid-item:first-child:nth-last-child(7)~li:nth-child(7){clear:right;margin-left:33.3333%}.badge-grid .badge-grid-item:first-child:nth-last-child(8),.badge-grid .badge-grid-item:first-child:nth-last-child(8)~li{width:33.3333%}.badge-grid .badge-grid-item:first-child:nth-last-child(8)~li:nth-child(7){clear:right;margin-left:16.66665%}.badge-grid .badge-grid-item:first-child:nth-last-child(9),.badge-grid .badge-grid-item:first-child:nth-last-child(9)~li,.badge-grid .badge-grid-item:first-child:nth-last-child(10),.badge-grid .badge-grid-item:first-child:nth-last-child(10)~li{width:33.3333%}.badge-grid .badge-grid-item:first-child:nth-last-child(10)~li:nth-child(10){clear:right;margin-left:33.3333%}.badge-grid .badge-grid-item:first-child:nth-last-child(11),.badge-grid .badge-grid-item:first-child:nth-last-child(11)~li{width:33.3333%}.badge-grid .badge-grid-item:first-child:nth-last-child(11)~li:nth-child(10){clear:right;margin-left:16.66665%}.badge-grid .badge-grid-item:first-child:nth-last-child(12),.badge-grid .badge-grid-item:first-child:nth-last-child(12)~li,.badge-grid .badge-grid-item:first-child:nth-last-child(13),.badge-grid .badge-grid-item:first-child:nth-last-child(13)~li{width:33.3333%}.badge-grid .badge-grid-item:first-child:nth-last-child(13)~li:nth-child(13){clear:right;margin-left:33.3333%}.badge-grid .badge-grid-item:first-child:nth-last-child(14),.badge-grid .badge-grid-item:first-child:nth-last-child(14)~li{width:33.3333%}.badge-grid .badge-grid-item:first-child:nth-last-child(14)~li:nth-child(13){clear:right;margin-left:16.66665%}.badge-grid .badge-grid-item:first-child:nth-last-child(15),.badge-grid .badge-grid-item:first-child:nth-last-child(15)~li{width:33.3333%}.badge-panel{display:table;width:100%}.badge-panel .badge-icon-col{display:table-cell;width:150px!important;vertical-align:top}.badge-panel .badge-content-col{display:table-cell;vertical-align:middle}@media only screen and (max-width:375px) and (max-height:736px) and (orientation:portrait){.badge-panel{display:block}.badge-panel .left-column{display:block;width:100%;padding:0 0 20px!important}.badge-panel .full-content{display:block;width:100%}.badge-panel .right-column{display:block;width:100%}}@media only screen and (max-height:375px) and (max-width:736px) and (orientation:landscape){.badge-panel{display:block}.badge-panel .left-column{display:block;width:100%;padding:0 0 20px!important}.badge-panel .full-content{display:block;width:100%}.badge-panel .right-column{display:block;width:100%}}@media only screen and (min-width:376px) and (max-width:414px) and (max-height:736px) and (orientation:portrait){.badge-panel{display:block}.badge-panel .left-column{display:block;width:100%;padding:0 0 20px!important}.badge-panel .full-content{display:block;width:100%}.badge-panel .right-column{display:block;width:100%}}@media only screen and (min-height:376px) and (max-height:414px) and (max-width:736px) and (orientation:landscape){.badge-panel{display:block}.badge-panel .left-column{display:block;width:100%;padding:0 0 20px!important}.badge-panel .full-content{display:block;width:100%}.badge-panel .right-column{display:block;width:100%}}@media only screen and (max-width:375px) and (min-height:737px) and (max-height:812px) and (orientation:portrait){.badge-panel{display:block}.badge-panel .left-column{display:block;width:100%;padding:0 0 20px!important}.badge-panel .full-content{display:block;width:100%}.badge-panel .right-column{display:block;width:100%}}@media only screen and (min-width:737px) and (max-width:812px) and (max-height:375px) and (orientation:landscape){.badge-panel{display:block}.badge-panel .left-column{display:block;width:100%;padding:0 0 20px!important}.badge-panel .full-content{display:block;width:100%}.badge-panel .right-column{display:block;width:100%}}@media only screen and (min-width:768px) and (max-width:1024px) and (orientation:portrait){.badge-panel{display:block}.badge-panel .left-column{display:block;width:100%;padding:0 0 20px!important}.badge-panel .full-content{display:block;width:100%}.badge-panel .right-column{display:block;width:100%}}.badge-collection-panel{display:block;width:100%;padding:15px 12px 10px!important;overflow:hidden}.badge-collection-panel .collect-left-col{display:block;float:left;width:120px;padding-bottom:10px;vertical-align:top}.badge-collection-panel .collect-right-col{margin-left:130px;vertical-align:top;padding:5px 15px;width:calc(100% - 130px)}.badge-collection-panel .collect-full-col{display:block;width:100%;clear:both;float:none;margin:0;overflow:hidden;padding:0}.badge-collection-panel .collect-full-col .object-container{margin:0!important;padding:0!important}.badge-collection-panel .collect-full-col .object-container .action-btn{margin:5px 0!important}.badge-details{display:block;clear:both;margin:10px 0;padding:8px 12px;background:#eff0f2;border-radius:5px}.badge-details .content{font-size:90%}.kpi-dashboard{display:block;position:relative;padding:16px 24px;padding-bottom:0;overflow:hidden}.kpi-dashboard .object-container{padding:0!important;margin:0!important}.kpi-dashboard .kpi-item{padding:0!important;vertical-align:bottom!important}.kpi-review-btn{position:relative;overflow:hidden;padding:6px 16px 10px!important;margin:0 6px!important;border-radius:5px;vertical-align:bottom!important;border:1px solid transparent;text-align:center}.kpi-review-btn.active{border:1px solid #f7f7f7;background:#fff;-webkit-box-shadow:inset 0 0 5px 0 rgba(0,0,0,.25);-moz-box-shadow:inset 0 0 5px 0 rgba(0,0,0,.25);box-shadow:inset 0 0 5px 0 rgba(0,0,0,.25)}.kpi-review-btn .kpi-review-btn-label{display:block;padding:8px 0 0;font-size:150%}.kpi-review-btn .kpi-review-btn-label.best{color:#39aa27}.kpi-review-btn .kpi-review-btn-label.ok{color:#f6ad17}.kpi-review-btn .kpi-review-btn-label.poor{color:#c5000f}.kpi-review-btn .kpi-review-btn-label.reflective{color:#6592cb}.kpi-review-btn .progress-indicator{position:absolute;left:16px;bottom:30px;z-index:6}.kpi-review-btn .progress-indicator.incomplete:before{color:#999;content:\"\\F16A\";width:15px;height:15px}.kpi-review-btn .progress-indicator.complete:before,.kpi-review-btn .progress-indicator.incomplete:before{position:absolute;font-size:16px;background:#fff;border-radius:50%;padding:0;line-height:100%;display:inline-block;font-family:Guroo-Producer;font-style:normal;font-weight:400;font-variant:normal;line-height:1;text-decoration:inherit;text-rendering:optimizeLegibility;text-transform:none;-moz-osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased;font-smoothing:antialiased}.kpi-review-btn .progress-indicator.complete:before{color:#39aa27;content:\"\\F16F\"}@media only screen and (max-width:375px) and (max-height:736px) and (orientation:portrait){.kpi-review-btn{padding:6px 6px 10px!important;margin:0!important}.kpi-review-btn .progress-indicator{left:5px}}@media only screen and (min-width:376px) and (max-width:414px) and (max-height:736px) and (orientation:portrait){.kpi-review-btn{padding:6px 6px 10px!important;margin:0!important}.kpi-review-btn .progress-indicator{left:5px}}@media only screen and (max-width:375px) and (min-height:737px) and (max-height:812px) and (orientation:portrait){.kpi-review-btn{padding:6px 6px 10px!important;margin:0!important}.kpi-review-btn .progress-indicator{left:5px}}.kpi-btn{position:relative}.kpi-btn.disabled{opacity:.5;cursor:default}.kpi-btn.disabled:focus,.kpi-btn.disabled:hover{opacity:.5}.kpi-btn .kpi-score-difference{display:none}.points-indicator{display:block;margin:0 auto;position:absolute;padding:0;font-weight:400;height:0;margin-top:-8px;overflow:hidden;transition:background .5s ease,width .5s ease,height .5s ease}.points-indicator.relative-indicator{margin-top:10px;position:relative}.points-indicator:after{opacity:0;transition-delay:1s;transition:opacity .5s ease}.points-indicator.small{height:24px;width:24px;left:calc(50% - 12px)}.points-indicator.small:after{height:24px;width:24px;font-size:24px}.points-indicator.small.relative-indicator{position:relative;left:unset}.points-indicator.small:after{opacity:1;transition-delay:1s;transition:opacity .5s ease}.points-indicator.large{height:36px;width:36px;left:calc(50% - 18px)}.points-indicator.large:after{height:36px;width:36px;font-size:36px}.points-indicator.large.relative-indicator{position:relative;left:unset}.points-indicator.large:after{opacity:1;transition:opacity .5s ease;transition-delay:2s}.points-indicator.positive-up{color:#39aa27}.points-indicator.positive-up:after{display:inline-block;font-family:Guroo-Producer;font-style:normal;font-weight:400;font-variant:normal;line-height:1;text-decoration:inherit;text-rendering:optimizeLegibility;text-transform:none;-moz-osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased;font-smoothing:antialiased;content:\"\\F114\"}.points-indicator.positive-down{color:#39aa27}.points-indicator.positive-down:after{display:inline-block;font-family:Guroo-Producer;font-style:normal;font-weight:400;font-variant:normal;line-height:1;text-decoration:inherit;text-rendering:optimizeLegibility;text-transform:none;-moz-osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased;font-smoothing:antialiased;content:\"\\F168\"}.points-indicator.negative-down{color:#c5000f}.points-indicator.negative-down:after{display:inline-block;font-family:Guroo-Producer;font-style:normal;font-weight:400;font-variant:normal;line-height:1;text-decoration:inherit;text-rendering:optimizeLegibility;text-transform:none;-moz-osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased;font-smoothing:antialiased;content:\"\\F168\"}.points-indicator.negative-up{color:#c5000f}.points-indicator.negative-up:after{display:inline-block;font-family:Guroo-Producer;font-style:normal;font-weight:400;font-variant:normal;line-height:1;text-decoration:inherit;text-rendering:optimizeLegibility;text-transform:none;-moz-osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased;font-smoothing:antialiased;content:\"\\F114\"}.points-indicator.neutral{color:#f6ad17}.points-indicator.neutral:after{display:inline-block;font-family:Guroo-Producer;font-style:normal;font-weight:400;font-variant:normal;line-height:1;text-decoration:inherit;text-rendering:optimizeLegibility;text-transform:none;-moz-osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased;font-smoothing:antialiased;content:\"\\F10D\"}.kpi-rotation-btn{position:relative;height:36px;cursor:pointer}.kpi-rotation-btn .kpi-svg{background:transparent;width:36px;height:36px}.kpi-rotation-btn .kpi-rotation-meter{margin:0 auto;display:block;position:relative;padding:0;width:36px;height:36px}.kpi-rotation-btn .kpi-points-awarded{text-align:center;margin:0 auto;display:table;min-width:36px;margin-top:-12px}.kpi-rotation-btn .rotator{position:absolute;width:6px;height:6px;background:transparent;top:calc(50% - 3px);left:calc(50% - 3px);border-width:1px;border-style:solid;border-radius:50%;transform:rotate(0deg)}.kpi-rotation-btn .rotator:before{display:none;position:absolute;left:0;top:-9px;width:0;height:0;border-left:2px solid transparent;border-right:2px solid transparent;content:\"\"}.kpi-rotation-btn .rotator:after{position:absolute;background:#333;height:8px;width:2px;content:\"\";left:1px;top:-8px}.kpi-rotation-btn .kpi-current-score{transition:color .3s ease;position:relative;display:table;width:100%;padding:0;margin:0;margin-top:-12px;text-align:center;font-size:60%;clear:both}.kpi-rotation-btn .kpi-current-score .current-score-label{display:block;padding:2px 4px;margin:0 auto;border-radius:12px;min-height:16px;min-width:16px;line-height:100%}.kpi-rotation-btn .kpi-current-score .current-score-label.best{background:#39aa27}.kpi-rotation-btn .kpi-current-score .current-score-label.ok{background:#f6ad17}.kpi-rotation-btn .kpi-current-score .current-score-label.poor{background:#c5000f}.kpi-rotation-btn .kpi-current-score .current-score-label.reflective{background:#6592cb}.kpi-rotation-tab{position:relative;height:36px;cursor:pointer}.kpi-rotation-tab .kpi-svg{background:transparent;width:36px;height:36px}.kpi-rotation-tab .kpi-rotation-meter{margin:0 auto;display:block;position:relative;padding:0;width:36px;height:36px}.kpi-rotation-tab .kpi-points-awarded{text-align:center;margin:0 auto;display:table;min-width:36px;margin-top:-12px}.kpi-rotation-tab .rotator{position:absolute;width:6px;height:6px;background:transparent;top:calc(50% - 3px);left:calc(50% - 3px);border-width:1px;border-style:solid;border-radius:50%;transform:rotate(0deg)}.kpi-rotation-tab .rotator:before{display:none;position:absolute;left:0;top:-9px;width:0;height:0;border-left:2px solid transparent;border-right:2px solid transparent;content:\"\"}.kpi-rotation-tab .rotator:after{position:absolute;background:#333;height:8px;width:2px;content:\"\";left:1px;top:-8px}.kpi-rotation-tab .kpi-current-score{transition:color .3s ease;position:relative;display:table;width:100%;padding:0;margin:0;margin-top:-12px;text-align:center;font-size:10px;clear:both}.kpi-rotation-tab .kpi-current-score .current-score-label{display:block;padding:2px 4px;margin:0 auto;border-radius:12px;min-height:16px;min-width:16px;line-height:100%}.kpi-rotation-tab .kpi-current-score .current-score-label.best{background:#39aa27}.kpi-rotation-tab .kpi-current-score .current-score-label.ok{background:#f6ad17}.kpi-rotation-tab .kpi-current-score .current-score-label.poor{background:#c5000f}.kpi-rotation-tab .kpi-current-score .current-score-label.reflective{background:#6592cb}.kpi-rotation{display:block;position:relative;text-align:center;cursor:pointer;padding:8px}.kpi-rotation .start-label{font-size:90%;text-align:center;padding:4px 0}.kpi-rotation .start-label.poor{color:#c5000f}.kpi-rotation .start-label.ok{color:#f6ad17}.kpi-rotation .start-label.best{color:#39aa27}.kpi-rotation .kpi-score-difference{position:absolute;display:block;top:10px;overflow:hidden;border-radius:12px;font-size:80%}.kpi-rotation .kpi-score-difference.positive{left:100%}.kpi-rotation .kpi-score-difference.positive .diff-label{padding:12px 8px!important;display:block;background:#39aa27;color:#fff}.kpi-rotation .kpi-score-difference.positive .diff-label:before{content:\"+\"}.kpi-rotation .kpi-score-difference.negative{right:100%}.kpi-rotation .kpi-score-difference.negative .diff-label{padding:12px 8px!important;display:block;background:#c5000f;color:#fff}.kpi-rotation .rotator{position:absolute;width:8px;height:8px;background:transparent;top:calc(50% - 4px);left:calc(50% - 4px);border-radius:50%;transform:rotate(0deg)}.kpi-rotation .rotator:after{position:absolute;height:16px;width:4px;content:\"\";left:2px;top:-10px;border-top-left-radius:2px;border-top-right-radius:2px}.kpi-rotation.default .kpi-svg{width:64px;height:64px}.kpi-rotation.default .kpi-rotation-meter{margin:0 auto;display:block;position:relative;padding:0;width:66px;height:62px}.kpi-rotation.default .kpi-rotation-meter .meter-wrapper{display:inline-block;position:relative;height:62px}.kpi-rotation.default .kpi-rotation-meter .meter-wrapper .min-label{position:absolute;left:-105px;bottom:10px;text-align:right;width:100px;font-size:90%}.kpi-rotation.default .kpi-rotation-meter .meter-wrapper .min-label.poor{color:#c5000f}.kpi-rotation.default .kpi-rotation-meter .meter-wrapper .min-label.ok{color:#f6ad17}.kpi-rotation.default .kpi-rotation-meter .meter-wrapper .min-label.best{color:#39aa27}.kpi-rotation.default .kpi-rotation-meter .meter-wrapper .max-label{position:absolute;right:-105px;bottom:10px;text-align:left;width:100px;font-size:90%}.kpi-rotation.default .kpi-rotation-meter .meter-wrapper .max-label.poor{color:#c5000f}.kpi-rotation.default .kpi-rotation-meter .meter-wrapper .max-label.ok{color:#f6ad17}.kpi-rotation.default .kpi-rotation-meter .meter-wrapper .max-label.best{color:#39aa27}.kpi-rotation.default .kpi-current-score{width:auto;min-width:66px;margin:auto;margin-top:-18px}.kpi-rotation.default .kpi-points-awarded{min-width:66px;margin-top:-18px}.kpi-rotation.primary .kpi-svg{width:84px;height:84px}.kpi-rotation.primary .kpi-rotation-meter{display:block;position:relative;padding:0;height:80px;margin:0 auto}.kpi-rotation.primary .kpi-rotation-meter .meter-wrapper{display:inline-block;position:relative;height:80px}.kpi-rotation.primary .kpi-rotation-meter .meter-wrapper .min-label{position:absolute;left:-105px;bottom:20px;text-align:right;width:100px;font-size:90%}.kpi-rotation.primary .kpi-rotation-meter .meter-wrapper .min-label.poor{color:#c5000f}.kpi-rotation.primary .kpi-rotation-meter .meter-wrapper .min-label.ok{color:#f6ad17}.kpi-rotation.primary .kpi-rotation-meter .meter-wrapper .min-label.best{color:#39aa27}.kpi-rotation.primary .kpi-rotation-meter .meter-wrapper .max-label{position:absolute;right:-105px;bottom:20px;text-align:left;width:100px;font-size:90%}.kpi-rotation.primary .kpi-rotation-meter .meter-wrapper .max-label.poor{color:#c5000f}.kpi-rotation.primary .kpi-rotation-meter .meter-wrapper .max-label.ok{color:#f6ad17}.kpi-rotation.primary .kpi-rotation-meter .meter-wrapper .max-label.best{color:#39aa27}.kpi-rotation.primary .rotator{width:12px;height:12px;top:calc(50% - 6px);left:calc(50% - 6px)}.kpi-rotation.primary .rotator:after{height:16px;top:-14px;left:3px;width:6px;border-top-left-radius:3px;border-top-right-radius:3px}.kpi-rotation.primary .kpi-current-score{width:auto;min-width:86px;margin:auto;margin-top:-24px;text-align:center}.kpi-rotation.primary .kpi-points-awarded{min-width:86px;margin-top:-24px}.kpi-rotation .kpi-current-score{position:relative;display:table;width:100%;padding:0;margin:0;text-align:center;font-size:75%;clear:both}.kpi-rotation .kpi-current-score .current-score-label{transition:background .5s ease,width .5s ease;display:block;padding:7px 10px;margin:0 auto;border-radius:12px;min-height:16px;min-width:16px;line-height:100%;color:#fff}.kpi-rotation .kpi-current-score .current-score-label.best{background:#39aa27}.kpi-rotation .kpi-current-score .current-score-label.ok{background:#f6ad17}.kpi-rotation .kpi-current-score .current-score-label.poor{background:#c5000f}.kpi-rotation .kpi-current-score .current-score-label.reflective{background:#6592cb}.kpi-rotation .kpi-label{position:relative;display:block;clear:both;line-height:130%;padding:5px 0 0;margin:0;font-size:80%;font-weight:700}@media only screen and (max-width:375px) and (max-height:736px) and (orientation:portrait){.kpi-rotation .kpi-label{font-size:70%}}@media only screen and (min-width:376px) and (max-width:414px) and (max-height:736px) and (orientation:portrait){.kpi-rotation .kpi-label{font-size:70%}}@media only screen and (max-width:375px) and (min-height:737px) and (max-height:812px) and (orientation:portrait){.kpi-rotation .kpi-label{font-size:70%}}.kpi-points-awarded{position:relative;display:table;width:auto;text-align:center;font-size:11px;clear:both;padding:8px 16px;margin:0 auto;border-radius:12px;min-height:16px;line-height:100%;color:#fff;min-width:56px}.kpi-points-awarded:after,.kpi-points-awarded:before{display:block;opacity:0;transition:opacity .5s ease}.kpi-points-awarded.positive-double:before,.kpi-points-awarded.positive-single:before{left:-16px;content:\"\\F16C\"}.kpi-points-awarded.positive-double:after,.kpi-points-awarded.positive-double:before,.kpi-points-awarded.positive-single:before{opacity:1;border:2px solid #fff;position:absolute;background:#39aa27;padding:6px;border-radius:50%;bottom:-2px;font-size:12px;display:inline-block;font-family:Guroo-Producer;font-style:normal;font-weight:400;font-variant:normal;line-height:1;text-decoration:inherit;text-rendering:optimizeLegibility;text-transform:none;-moz-osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased;font-smoothing:antialiased}.kpi-points-awarded.positive-double:after{right:-16px;content:\"\\F16B\"}.kpi-points-awarded.negative-single:before{background:#d4404b}.kpi-points-awarded.negative-double:before,.kpi-points-awarded.negative-single:before{opacity:1;border:2px solid #fff;position:absolute;padding:6px;border-radius:50%;bottom:-2px;font-size:12px;left:-16px;display:inline-block;font-family:Guroo-Producer;font-style:normal;font-weight:400;font-variant:normal;line-height:1;text-decoration:inherit;text-rendering:optimizeLegibility;text-transform:none;-moz-osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased;font-smoothing:antialiased;content:\"\\F16D\"}.kpi-points-awarded.negative-double:before{background:#c5000f}.kpi-points-awarded.negative-double:after{background:#c5000f;right:-16px;content:\"\\F16E\"}.kpi-points-awarded.negative-double:after,.kpi-points-awarded.no-value:before{opacity:1;border:2px solid #fff;position:absolute;padding:6px;border-radius:50%;bottom:-2px;font-size:12px;display:inline-block;font-family:Guroo-Producer;font-style:normal;font-weight:400;font-variant:normal;line-height:1;text-decoration:inherit;text-rendering:optimizeLegibility;text-transform:none;-moz-osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased;font-smoothing:antialiased}.kpi-points-awarded.no-value:before{background:#f6ad17;left:-16px;content:\"\\F12E\"}.kpi-points-review-awarded{position:relative;width:auto;text-align:left;font-size:11px;clear:both;display:inline-block;padding:6px 16px;margin:0 auto;border-radius:12px;min-height:16px;line-height:100%;color:#fff;min-width:56px;font-style:normal!important}.kpi-points-review-awarded.positive-single{padding-left:32px;background:#6bbf5d}.kpi-points-review-awarded.positive-single .kpi-result{position:absolute;width:28px;height:28px;background:#39aa27;border-radius:50%;font-size:12px;left:-2px;bottom:-2px}.kpi-points-review-awarded.positive-single .kpi-result:after{position:absolute;display:block;left:0;top:0;right:0;bottom:0;margin:auto;height:auto;padding:8px 0 0;display:inline-block;font-family:Guroo-Producer;font-style:normal;font-weight:400;font-variant:normal;line-height:1;text-decoration:inherit;text-rendering:optimizeLegibility;text-transform:none;-moz-osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased;font-smoothing:antialiased;text-align:center;content:\"\\F16C\"}.kpi-points-review-awarded.positive-double{padding-left:32px;background:#6bbf5d}.kpi-points-review-awarded.positive-double .kpi-result{position:absolute;width:28px;height:28px;background:#39aa27;border-radius:50%;font-size:12px;left:-2px;bottom:-2px}.kpi-points-review-awarded.positive-double .kpi-result:after{position:absolute;display:block;left:0;top:0;right:0;bottom:0;margin:auto;height:auto;padding:8px 0 0;display:inline-block;font-family:Guroo-Producer;font-style:normal;font-weight:400;font-variant:normal;line-height:1;text-decoration:inherit;text-rendering:optimizeLegibility;text-transform:none;-moz-osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased;font-smoothing:antialiased;text-align:center;content:\"\\F16C\\F16B\"}.kpi-points-review-awarded.negative-single{padding-left:36px;background:#d4404b}.kpi-points-review-awarded.negative-single .kpi-result{position:absolute;width:28px;height:28px;background:#c5000f;border-radius:50%;font-size:12px;left:-2px;bottom:-2px}.kpi-points-review-awarded.negative-single .kpi-result:after{position:absolute;display:block;left:0;top:0;right:0;bottom:0;margin:auto;height:auto;padding:8px 0 0;display:inline-block;font-family:Guroo-Producer;font-style:normal;font-weight:400;font-variant:normal;line-height:1;text-decoration:inherit;text-rendering:optimizeLegibility;text-transform:none;-moz-osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased;font-smoothing:antialiased;text-align:center;content:\"\\F16D\"}.kpi-points-review-awarded.negative-double{padding-left:36px;background:#d4404b}.kpi-points-review-awarded.negative-double .kpi-result{position:absolute;width:28px;height:28px;background:#c5000f;border-radius:50%;font-size:12px;left:-2px;bottom:-2px}.kpi-points-review-awarded.negative-double .kpi-result:after{position:absolute;display:block;left:0;top:0;right:0;bottom:0;margin:auto;height:auto;padding:8px 0 0;display:inline-block;font-family:Guroo-Producer;font-style:normal;font-weight:400;font-variant:normal;line-height:1;text-decoration:inherit;text-rendering:optimizeLegibility;text-transform:none;-moz-osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased;font-smoothing:antialiased;text-align:center;content:\"\\F16D\\F16E\"}.kpi-points-review-awarded.no-value{padding-left:36px;background:#f8c251}.kpi-points-review-awarded.no-value .kpi-result{position:absolute;width:28px;height:28px;background:#f6ad17;border-radius:50%;font-size:12px;left:-2px;bottom:-2px}.kpi-points-review-awarded.no-value .kpi-result:after{position:absolute;display:block;left:0;top:0;right:0;bottom:0;margin:auto;height:auto;padding:8px 0 0;display:inline-block;font-family:Guroo-Producer;font-style:normal;font-weight:400;font-variant:normal;line-height:1;text-decoration:inherit;text-rendering:optimizeLegibility;text-transform:none;-moz-osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased;font-smoothing:antialiased;text-align:center;content:\"\\F12E\"}.kpi-label{position:relative;display:block;clear:both;line-height:130%;padding:0 0 5px;margin:0;font-size:90%;font-weight:700}@media only screen and (max-width:375px) and (max-height:736px) and (orientation:portrait){.kpi-label{font-size:70%}}@media only screen and (min-width:376px) and (max-width:414px) and (max-height:736px) and (orientation:portrait){.kpi-label{font-size:70%}}@media only screen and (max-width:375px) and (min-height:737px) and (max-height:812px) and (orientation:portrait){.kpi-label{font-size:70%}}.feedback-panel .kpi-dashboard{margin:0;padding:0}.feedback-panel .kpi-item{vertical-align:middle;margin:0 15px}.feedback-panel .kpi-item-review-primary{display:block;padding:10px 15px 10px 0;vertical-align:bottom!important;margin:0 auto!important}.feedback-panel .kpi-item-review-primary:last-child{padding-right:0}.feedback-panel .kpi-item-review-primary.inline{display:inline-block;margin:0 auto;padding-left:30px}.feedback-panel .kpi-item-review-primary.inline:first-child{padding-left:10px}.feedback-panel .kpi-item-review-primary .kpi-points-review-awarded{-ms-transform:scale(2,3);-webkit-transform:scale(2,3);transform:scale(1.2)}.feedback-panel .kpi-item-review{padding:10px 15px 10px 2px;vertical-align:bottom!important;margin:0!important}.feedback-panel .kpi-item-review:last-child{padding-right:0}@media only screen and (max-width:375px) and (max-height:736px) and (orientation:portrait){.feedback-panel .kpi-item{margin:0 15px!important}}@media only screen and (min-width:376px) and (max-width:414px) and (max-height:736px) and (orientation:portrait){.feedback-panel kpi-item{margin:0 15px!important}}@media only screen and (max-width:375px) and (min-height:737px) and (max-height:812px) and (orientation:portrait){.feedback-panel kpi-item{margin:0 15px!important}}.kpi-description{display:table;width:100%}.kpi-description .score-column{display:table-cell;vertical-align:middle;font-size:60px;text-align:center}.kpi-description .score-column .best{color:#39aa27}.kpi-description .score-column .ok{color:#f6ad17}.kpi-description .score-column .poor{color:#c5000f}.kpi-description .score-column .reflective{color:#6592cb}.kpi-description .left-column{display:table-cell;width:100px;vertical-align:top}.kpi-description .right-column{display:table-cell;vertical-align:top;padding:5px 10px}.kpi-description .right-column .object-container{padding:0!important;margin:0!important}@media only screen and (max-width:375px) and (max-height:736px) and (orientation:portrait){.kpi-description{display:block}.kpi-description .left-column{display:block;width:100%;padding:0 0 20px!important}.kpi-description .full-content{display:block;width:100%}.kpi-description .right-column{display:block;width:100%}}@media only screen and (max-height:375px) and (max-width:736px) and (orientation:landscape){.kpi-description{display:block}.kpi-description .left-column{display:block;width:100%;padding:0 0 20px!important}.kpi-description .full-content{display:block;width:100%}.kpi-description .right-column{display:block;width:100%}}@media only screen and (min-width:376px) and (max-width:414px) and (max-height:736px) and (orientation:portrait){.kpi-description{display:block}.kpi-description .left-column{display:block;width:100%;padding:0 0 20px!important}.kpi-description .full-content{display:block;width:100%}.kpi-description .right-column{display:block;width:100%}}@media only screen and (min-height:376px) and (max-height:414px) and (max-width:736px) and (orientation:landscape){.kpi-description{display:block}.kpi-description .left-column{display:block;width:100%;padding:0 0 20px!important}.kpi-description .full-content{display:block;width:100%}.kpi-description .right-column{display:block;width:100%}}@media only screen and (max-width:375px) and (min-height:737px) and (max-height:812px) and (orientation:portrait){.kpi-description{display:block}.kpi-description .left-column{display:block;width:100%;padding:0 0 20px!important}.kpi-description .full-content{display:block;width:100%}.kpi-description .right-column{display:block;width:100%}}@media only screen and (min-width:737px) and (max-width:812px) and (max-height:375px) and (orientation:landscape){.kpi-description{display:block}.kpi-description .left-column{display:block;width:100%;padding:0 0 20px!important}.kpi-description .full-content{display:block;width:100%}.kpi-description .right-column{display:block;width:100%}}@media only screen and (min-width:768px) and (max-width:1024px) and (orientation:portrait){.kpi-description{display:block}.kpi-description .left-column{display:block;width:100%;padding:0 0 20px!important}.kpi-description .full-content{display:block;width:100%}.kpi-description .right-column{display:block;width:100%}}.kpi-results-dashboard{margin:0;padding:0}.kpi-results-description{display:table;width:calc(100% - 40px);border-width:2px;border-style:solid;margin:0 0 40px 40px}.kpi-results-description .content-column{display:table-cell;vertical-align:top;padding:16px 24px;width:90%}.kpi-results-description.best{border-color:#39aa27;background:#edffef}.kpi-results-description.ok{border-color:#f6ad17;background:#fef8e2}.kpi-results-description.poor{border-color:#c5000f;background:#ffecf8}.kpi-results-description.reflective{border-color:#6592cb;background:#d8e4f2}@media only screen and (max-width:375px) and (max-height:736px) and (orientation:portrait){.kpi-results-description{margin:0 0 40px;width:100%}.kpi-results-description .content-column{display:table-cell;vertical-align:top;padding:10px 12px}}@media only screen and (max-height:375px) and (max-width:736px) and (orientation:landscape){.kpi-results-description{margin:0 0 40px;width:100%}}@media only screen and (min-height:376px) and (max-height:414px) and (max-width:736px) and (orientation:landscape){.kpi-results-description{margin:0 0 40px;width:100%}}@media only screen and (min-width:737px) and (max-width:812px) and (max-height:375px) and (orientation:landscape){.kpi-results-description{margin:0 0 40px;width:100%}}.kpi-graph-container{display:block;position:relative;margin:20px 0 0;height:245px;width:calc(100% - 30px)}@media only screen and (max-width:375px) and (max-height:736px) and (orientation:portrait){.kpi-graph-container{height:180px;width:90%}}@media only screen and (max-height:375px) and (max-width:736px) and (orientation:landscape){.kpi-graph-container{height:180px;width:90%}}@media only screen and (min-width:376px) and (max-width:414px) and (max-height:736px) and (orientation:portrait){.kpi-graph-container{height:180px;width:90%}}@media only screen and (min-height:376px) and (max-height:414px) and (max-width:736px) and (orientation:landscape){.kpi-graph-container{height:180px;width:90%}}@media only screen and (max-width:375px) and (min-height:737px) and (max-height:812px) and (orientation:portrait){.kpi-graph-container{height:180px;width:90%}}@media only screen and (min-width:737px) and (max-width:812px) and (max-height:375px) and (orientation:landscape){.kpi-graph-container{height:180px;width:90%}}.kpi-graph-container .graph-y-title{font-weight:700;position:absolute;top:0;left:0;padding:0;width:260px;height:100%;text-align:center;-webkit-transform:rotate(-90deg);z-index:1;white-space:nowrap;overflow:hidden;-moz-transform:rotate(-90deg);-ms-transform:rotate(-90deg);-o-transform:rotate(-90deg)}@media only screen and (max-width:375px) and (max-height:736px) and (orientation:portrait){.kpi-graph-container .graph-y-title{width:170px;font-size:80%}}@media only screen and (max-height:375px) and (max-width:736px) and (orientation:landscape){.kpi-graph-container .graph-y-title{width:175px;font-size:80%}}@media only screen and (min-width:376px) and (max-width:414px) and (max-height:736px) and (orientation:portrait){.kpi-graph-container .graph-y-title{width:170px;font-size:80%}}@media only screen and (min-height:376px) and (max-height:414px) and (max-width:736px) and (orientation:landscape){.kpi-graph-container .graph-y-title{width:175px;font-size:80%}}@media only screen and (max-width:375px) and (min-height:737px) and (max-height:812px) and (orientation:portrait){.kpi-graph-container .graph-y-title{width:170px;font-size:80%}}@media only screen and (min-width:737px) and (max-width:812px) and (max-height:375px) and (orientation:landscape){.kpi-graph-container .graph-y-title{width:175px;font-size:80%}}@media only screen and (max-width:320px) and (max-height:568px) and (orientation:portrait){.kpi-graph-container .graph-y-title{width:170px;font-size:80%}}@media only screen and (max-width:320px) and (max-height:568px) and (orientation:landscape){.kpi-graph-container .graph-y-title{width:175px;font-size:80%}}.kpi-graph-container .kpi-graph{z-index:2;display:block;position:relative;height:100%;margin:0 0 0 40px;border-left-style:solid;border-left-width:2px;border-bottom-style:solid;border-bottom-width:2px}@media only screen and (max-width:375px) and (max-height:736px) and (orientation:portrait){.kpi-graph-container .kpi-graph{margin:0 0 0 20px}}@media only screen and (min-width:376px) and (max-width:414px) and (max-height:736px) and (orientation:portrait){.kpi-graph-container .kpi-graph{margin:0 0 0 20px}}@media only screen and (max-width:375px) and (min-height:737px) and (max-height:812px) and (orientation:portrait){.kpi-graph-container .kpi-graph{margin:0 0 0 20px}}.kpi-graph-container .kpi-graph .zone-marker{position:absolute;background:transparent;left:0;bottom:0;width:100%;height:0;z-index:2;text-align:left}.kpi-graph-container .kpi-graph .zone-marker .zone-marker-label{position:absolute;right:-25px;font-size:80%;top:-10px;color:#999}.kpi-graph-container .kpi-graph .green-zone-marker{border-top:2px dashed #39aa27;position:absolute;background:transparent;left:0;bottom:0;width:100%;height:0;z-index:2;text-align:left}.kpi-graph-container .kpi-graph .green-zone-marker .zone-marker-label{position:absolute;right:-25px;font-size:80%;top:-20px;color:#999}.kpi-graph-container .kpi-graph .yellow-zone-marker{border-top:2px dashed #f6ad17;position:absolute;background:transparent;left:0;bottom:0;width:100%;height:0;z-index:2;text-align:left}.kpi-graph-container .kpi-graph .yellow-zone-marker .zone-marker-label{position:absolute;right:-25px;font-size:80%;top:-20px;color:#999}.kpi-graph-container .kpi-graph .bar-graph-items{display:block;position:absolute;margin:0;padding:0;bottom:0;left:0;width:100%;height:100%;overflow:visible}.kpi-graph-container .kpi-graph .bar-graph-items .graph-item{display:block;position:absolute;bottom:0;min-height:24px;height:0;max-height:280px;text-align:center;z-index:4;cursor:pointer;max-width:24px}.kpi-graph-container .kpi-graph .bar-graph-items .graph-item:before{display:block;position:absolute;left:0;right:0;margin:auto;bottom:0;width:70%;height:100%;content:\"\";z-index:10}.kpi-graph-container .kpi-graph .bar-graph-items .graph-item:after{display:block;position:absolute;left:15%;bottom:0;width:100%;height:calc(100% + 50px);content:\"\";z-index:10}.kpi-graph-container .kpi-graph .bar-graph-items .graph-item .badge-earned{position:absolute;left:0;right:0;margin:auto;top:10px;width:100%;padding-top:100%;z-index:8}.kpi-graph-container .kpi-graph .bar-graph-items .graph-item .badge-earned:before{display:block;position:absolute;left:0;right:0;margin:auto;text-align:center;font-size:100%;display:inline-block;font-family:Guroo-Producer;font-style:normal;font-weight:400;font-variant:normal;line-height:1;text-decoration:inherit;text-rendering:optimizeLegibility;text-transform:none;-moz-osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased;font-smoothing:antialiased;content:\"\\F201\"}.kpi-graph-container .kpi-graph .bar-graph-items .graph-item .graph-item-marker{display:block;position:absolute;left:0;right:0;margin:auto;top:0;width:100%;padding-top:100%;content:\"\";z-index:10;border-radius:50%}.kpi-graph-container .kpi-graph .bar-graph-items .graph-item.positive:before{background:transparent}.kpi-graph-container .kpi-graph .bar-graph-items .graph-item.positive .graph-item-marker{background:#39aa27}.kpi-graph-container .kpi-graph .bar-graph-items .graph-item.positive .graph-item-tool-tip{border-color:#39aa27}.kpi-graph-container .kpi-graph .bar-graph-items .graph-item.positive .graph-item-tool-tip-arrow:before{border-top-color:#39aa27}.kpi-graph-container .kpi-graph .bar-graph-items .graph-item.neutral:before{background:transparent}.kpi-graph-container .kpi-graph .bar-graph-items .graph-item.neutral .graph-item-marker{background:#f6ad17}.kpi-graph-container .kpi-graph .bar-graph-items .graph-item.neutral .graph-item-tool-tip{border-color:#f6ad17}.kpi-graph-container .kpi-graph .bar-graph-items .graph-item.neutral .graph-item-tool-tip-arrow:before{border-top-color:#f6ad17}.kpi-graph-container .kpi-graph .bar-graph-items .graph-item.negative:before{background:transparent}.kpi-graph-container .kpi-graph .bar-graph-items .graph-item.negative .graph-item-marker{background:#c5000f}.kpi-graph-container .kpi-graph .bar-graph-items .graph-item.negative .graph-item-tool-tip{border-color:#c5000f}.kpi-graph-container .kpi-graph .bar-graph-items .graph-item.negative .graph-item-tool-tip-arrow:before{border-top-color:#c5000f}.kpi-graph-container .kpi-graph .bar-graph-items .graph-item.reflective:before{background:transparent}.kpi-graph-container .kpi-graph .bar-graph-items .graph-item.reflective .graph-item-marker{background:#6592cb}.kpi-graph-container .kpi-graph .bar-graph-items .graph-item.reflective .graph-item-tool-tip{border-color:#6592cb}.kpi-graph-container .kpi-graph .bar-graph-items .graph-item.reflective .graph-item-tool-tip-arrow:before{border-top-color:#6592cb}.kpi-graph-container .kpi-graph .bar-graph-items .graph-item.active{z-index:10}.kpi-graph-container .kpi-graph .bar-graph-items .graph-item .graph-item-tool-tip-arrow{display:block;position:absolute;width:24px;height:12px;top:-20px;left:calc(50% - 12px)}.kpi-graph-container .kpi-graph .bar-graph-items .graph-item .graph-item-tool-tip-arrow:before{position:absolute;width:0;height:0;top:0;left:0;border-left:12px solid transparent;border-right:12px solid transparent;border-top-style:solid;border-top-width:12px;content:\"\"}.kpi-graph-container .kpi-graph .bar-graph-items .graph-item .graph-item-tool-tip-arrow:after{position:absolute;width:0;height:0;top:0;left:2px;border-left:10px solid transparent;border-right:10px solid transparent;border-top-style:solid;border-top-width:10px;border-top-color:#fff;content:\"\"}.kpi-graph-container .kpi-graph .bar-graph-items .graph-item .graph-item-tool-tip{display:block;position:absolute;top:-138px;padding:8px 12px;height:120px;min-width:180px;border-radius:5px;-webkit-box-shadow:3px 3px 5px 0 rgba(0,0,0,.25);-moz-box-shadow:3px 3px 5px 0 rgba(0,0,0,.25);box-shadow:3px 3px 5px 0 rgba(0,0,0,.25);border-style:solid;border-width:2px;background:#fff;overflow:hidden;cursor:pointer;font-size:90%}.kpi-graph-container .kpi-graph .bar-graph-items .graph-item .graph-item-tool-tip.left{left:-10px!important}.kpi-graph-container .kpi-graph .bar-graph-items .graph-item .graph-item-tool-tip.right{right:-10px}.kpi-graph-container .kpi-graph .bar-graph-items .graph-item .graph-item-tool-tip .tool-tip-title{white-space:nowrap}.kpi-graph-container .kpi-graph .bar-graph-items .graph-item .graph-item-tool-tip .kpi-meter-wrapper{display:block;overflow:hidden;position:relative;margin:5px 0;padding:4px 6px}@media only screen and (max-width:375px) and (max-height:736px) and (orientation:portrait){.kpi-graph-container .kpi-graph .bar-graph-items .graph-item .graph-item-tool-tip{top:-208px!important;height:190px!important;max-width:210px}.kpi-graph-container .kpi-graph .bar-graph-items .graph-item .graph-item-tool-tip .tool-tip-title{position:relative;overflow:hidden;white-space:normal}.kpi-graph-container .kpi-graph .bar-graph-items .graph-item .graph-item-tool-tip .tool-tip-title a,.kpi-graph-container .kpi-graph .bar-graph-items .graph-item .graph-item-tool-tip .tool-tip-title div,.kpi-graph-container .kpi-graph .bar-graph-items .graph-item .graph-item-tool-tip .tool-tip-title h1,.kpi-graph-container .kpi-graph .bar-graph-items .graph-item .graph-item-tool-tip .tool-tip-title h2,.kpi-graph-container .kpi-graph .bar-graph-items .graph-item .graph-item-tool-tip .tool-tip-title h3,.kpi-graph-container .kpi-graph .bar-graph-items .graph-item .graph-item-tool-tip .tool-tip-title h4,.kpi-graph-container .kpi-graph .bar-graph-items .graph-item .graph-item-tool-tip .tool-tip-title h5,.kpi-graph-container .kpi-graph .bar-graph-items .graph-item .graph-item-tool-tip .tool-tip-title li,.kpi-graph-container .kpi-graph .bar-graph-items .graph-item .graph-item-tool-tip .tool-tip-title p,.kpi-graph-container .kpi-graph .bar-graph-items .graph-item .graph-item-tool-tip .tool-tip-title span{height:100%;width:100%;overflow:hidden;display:block;white-space:nowrap;text-overflow:ellipsis}.kpi-graph-container .kpi-graph .bar-graph-items .graph-item .graph-item-tool-tip.left{left:-10px}.kpi-graph-container .kpi-graph .bar-graph-items .graph-item .graph-item-tool-tip.right{right:-10px}.kpi-graph-container .kpi-graph .bar-graph-items .graph-item .graph-item-tool-tip.has-badges .badge{width:80px;height:80px}.kpi-graph-container .kpi-graph .bar-graph-items .graph-item .graph-item-tool-tip.has-badges .badge .badge-container:before{font-size:80px}.kpi-graph-container .kpi-graph .bar-graph-items .graph-item .graph-item-tool-tip.has-badges .badge-grid .badge-grid-item{margin:0!important}}@media only screen and (min-width:376px) and (max-width:414px) and (max-height:736px) and (orientation:portrait){.kpi-graph-container .kpi-graph .bar-graph-items .graph-item .graph-item-tool-tip{top:-208px!important;height:190px!important;max-width:210px}.kpi-graph-container .kpi-graph .bar-graph-items .graph-item .graph-item-tool-tip .tool-tip-title{position:relative;overflow:hidden;white-space:normal}.kpi-graph-container .kpi-graph .bar-graph-items .graph-item .graph-item-tool-tip .tool-tip-title a,.kpi-graph-container .kpi-graph .bar-graph-items .graph-item .graph-item-tool-tip .tool-tip-title div,.kpi-graph-container .kpi-graph .bar-graph-items .graph-item .graph-item-tool-tip .tool-tip-title h1,.kpi-graph-container .kpi-graph .bar-graph-items .graph-item .graph-item-tool-tip .tool-tip-title h2,.kpi-graph-container .kpi-graph .bar-graph-items .graph-item .graph-item-tool-tip .tool-tip-title h3,.kpi-graph-container .kpi-graph .bar-graph-items .graph-item .graph-item-tool-tip .tool-tip-title h4,.kpi-graph-container .kpi-graph .bar-graph-items .graph-item .graph-item-tool-tip .tool-tip-title h5,.kpi-graph-container .kpi-graph .bar-graph-items .graph-item .graph-item-tool-tip .tool-tip-title li,.kpi-graph-container .kpi-graph .bar-graph-items .graph-item .graph-item-tool-tip .tool-tip-title p,.kpi-graph-container .kpi-graph .bar-graph-items .graph-item .graph-item-tool-tip .tool-tip-title span{height:100%;width:100%;overflow:hidden;display:block;white-space:nowrap;text-overflow:ellipsis}.kpi-graph-container .kpi-graph .bar-graph-items .graph-item .graph-item-tool-tip.left{left:-10px}.kpi-graph-container .kpi-graph .bar-graph-items .graph-item .graph-item-tool-tip.right{right:-10px}.kpi-graph-container .kpi-graph .bar-graph-items .graph-item .graph-item-tool-tip.has-badges .badge{width:80px;height:80px}.kpi-graph-container .kpi-graph .bar-graph-items .graph-item .graph-item-tool-tip.has-badges .badge .badge-container:before{font-size:80px}.kpi-graph-container .kpi-graph .bar-graph-items .graph-item .graph-item-tool-tip.has-badges .badge-grid .badge-grid-item{margin:0!important}}@media only screen and (max-width:375px) and (min-height:737px) and (max-height:812px) and (orientation:portrait){.kpi-graph-container .kpi-graph .bar-graph-items .graph-item .graph-item-tool-tip{top:-208px!important;height:190px!important;max-width:210px}.kpi-graph-container .kpi-graph .bar-graph-items .graph-item .graph-item-tool-tip .tool-tip-title{position:relative;overflow:hidden;white-space:normal}.kpi-graph-container .kpi-graph .bar-graph-items .graph-item .graph-item-tool-tip .tool-tip-title a,.kpi-graph-container .kpi-graph .bar-graph-items .graph-item .graph-item-tool-tip .tool-tip-title div,.kpi-graph-container .kpi-graph .bar-graph-items .graph-item .graph-item-tool-tip .tool-tip-title h1,.kpi-graph-container .kpi-graph .bar-graph-items .graph-item .graph-item-tool-tip .tool-tip-title h2,.kpi-graph-container .kpi-graph .bar-graph-items .graph-item .graph-item-tool-tip .tool-tip-title h3,.kpi-graph-container .kpi-graph .bar-graph-items .graph-item .graph-item-tool-tip .tool-tip-title h4,.kpi-graph-container .kpi-graph .bar-graph-items .graph-item .graph-item-tool-tip .tool-tip-title h5,.kpi-graph-container .kpi-graph .bar-graph-items .graph-item .graph-item-tool-tip .tool-tip-title li,.kpi-graph-container .kpi-graph .bar-graph-items .graph-item .graph-item-tool-tip .tool-tip-title p,.kpi-graph-container .kpi-graph .bar-graph-items .graph-item .graph-item-tool-tip .tool-tip-title span{height:100%;width:100%;overflow:hidden;display:block;white-space:nowrap;text-overflow:ellipsis}.kpi-graph-container .kpi-graph .bar-graph-items .graph-item .graph-item-tool-tip.left{left:-10px}.kpi-graph-container .kpi-graph .bar-graph-items .graph-item .graph-item-tool-tip.right{right:-10px}.kpi-graph-container .kpi-graph .bar-graph-items .graph-item .graph-item-tool-tip.has-badges .badge{width:80px;height:80px}.kpi-graph-container .kpi-graph .bar-graph-items .graph-item .graph-item-tool-tip.has-badges .badge .badge-container:before{font-size:80px}.kpi-graph-container .kpi-graph .bar-graph-items .graph-item .graph-item-tool-tip.has-badges .badge-grid .badge-grid-item{margin:0!important}}.kpi-graph-container .kpi-graph .bar-graph-items .graph-item.has-badges .graph-item-tool-tip{top:-158px;height:140px}.kpi-graph-container .kpi-graph .bar-graph-items .graph-item.has-badges .badge{width:55px;height:55px}.kpi-graph-container .kpi-graph .bar-graph-items .graph-item.has-badges .badge .badge-container:before{font-size:55px}.kpi-graph-container .kpi-graph .bar-graph-items .graph-item.has-badges .badge .badge-label{padding:4px 8px}.kpi-graph-container .kpi-graph .bar-graph-items .graph-item.has-badges .image-badge{width:55px;height:55px;margin:5px auto}.kpi-graph-container .kpi-graph .bar-graph-items .graph-item.has-badges .badge-grid .badge-grid-item{margin:0!important}.kpi-graph-container .kpi-graph .bar-graph-items .graph-item .active .graph-item-tool-tip{z-index:15!important}.no-result{padding:40px;font-style:italic;text-align:center}.kpi-results-panel{border-width:2px;border-style:solid;border-radius:5px;margin-bottom:10px}.kpi-results-panel.best{border-color:#39aa27;background:#edffef}.kpi-results-panel.ok{border-color:#f6ad17;background:#fef8e2}.kpi-results-panel.poor{border-color:#c5000f;background:#ffecf8}.kpi-results-panel .results-row{display:-webkit-flex;display:flex;flex-flow:row nowrap;justify-content:center;padding:15px 24px}.kpi-results-panel .kpi-results-column{margin:0 5px}.kpi-results-panel .kpi-results-column:first-child{margin-left:0}.kpi-results-panel .kpi-results-column:last-child{margin-right:0}.kpi-results-panel .kpi-results-column.flex-1{flex:1}.kpi-results-panel .kpi-result-asset{width:130px}.kpi-results-panel .kpi-result-asset img{width:100%;height:auto}.kpi-results-panel .kpi-result-meter{float:right}@media only screen and (max-width:375px) and (max-height:736px) and (orientation:portrait){.kpi-results-panel .results-row{display:block;overflow:hidden;padding:12px 12px 0}.kpi-results-panel .kpi-result-asset,.kpi-results-panel .kpi-results-column{display:block;flex:unset;width:100%;padding-bottom:10px}.kpi-results-panel .kpi-result-asset{text-align:center;overflow:hidden}.kpi-results-panel .kpi-result-asset img{height:auto;max-height:120px;width:auto}.kpi-results-panel .kpi-result-meter{display:block;overflow:hidden;flex:unset;width:100%;text-align:center}}.kpi-overview-panel{display:block;width:100%;border:1px solid #d5d5d5;border-radius:5px;position:relative;overflow:hidden}.kpi-overview-panel .kpi-overview-row{display:-webkit-flex;display:flex;flex-flow:row wrap;border-bottom:1px solid #d5d5d5;width:100%}.kpi-overview-panel .kpi-overview-row .kpi-meter-col{position:relative;flex:1;vertical-align:baseline;background:#eff0f2;padding:16px 24px}.kpi-overview-panel .kpi-overview-row .kpi-meter-col:before{position:absolute;display:block;left:0;top:0;width:6px;height:100%;content:\"\"}.kpi-overview-panel .kpi-overview-row:first-child .kpi-meter-col{border-top-left-radius:5px}.kpi-overview-panel .kpi-overview-row:first-child .kpi-meter-col:before{content:\"\";border-top-left-radius:5px}.kpi-overview-panel .kpi-overview-row:last-child{border-bottom:none;border-bottom-left-radius:5px}.kpi-overview-panel .kpi-overview-row:last-child .kpi-meter-col:before{content:\"\";border-bottom-left-radius:5px}.kpi-overview-panel .kpi-overview-row .kpi-content-col{flex:3;background:#fff;vertical-align:middle;padding:16px 24px}.kpi-overview-panel .kpi-overview-row .kpi-content-col :last-child{margin-bottom:0}@media only screen and (max-width:375px) and (max-height:736px) and (orientation:portrait){.kpi-overview-panel .kpi-overview-row{display:-webkit-flex;display:flex;flex-flow:column wrap}.kpi-overview-panel .kpi-overview-row .kpi-meter-col:before{position:absolute;display:block;left:0;top:0;height:6px;width:100%;content:\"\"}.kpi-overview-panel .kpi-overview-row .kpi-content-col{flex:1}}@media only screen and (min-width:376px) and (max-width:414px) and (max-height:736px) and (orientation:portrait){.kpi-overview-panel .kpi-overview-row{display:-webkit-flex;display:flex;flex-flow:column wrap}.kpi-overview-panel .kpi-overview-row .kpi-meter-col:before{position:absolute;display:block;left:0;top:0;height:6px;width:100%;content:\"\"}.kpi-overview-panel .kpi-overview-row .kpi-content-col{flex:1}}@media only screen and (max-width:375px) and (min-height:737px) and (max-height:812px) and (orientation:portrait){.kpi-overview-panel .kpi-overview-row{display:-webkit-flex;display:flex;flex-flow:column wrap}.kpi-overview-panel .kpi-overview-row .kpi-meter-col:before{position:absolute;display:block;left:0;top:0;height:6px;width:100%;content:\"\"}.kpi-overview-panel .kpi-overview-row .kpi-content-col{flex:1}}@media only screen and (min-width:768px) and (max-width:1024px) and (orientation:portrait){.kpi-overview-panel .kpi-overview-row{display:block}.kpi-overview-panel .kpi-overview-row .left-column{display:block;width:100%;padding:0 0 20px!important}.kpi-overview-panel .kpi-overview-row .full-content{display:block;width:100%}.kpi-overview-panel .kpi-overview-row .right-column{display:block;width:100%}}.dollars:before{content:\"$\"}.percentage:after{content:\"%\"}.pounds:before{content:\"\\A3\"}.euros:before{content:\"\\20AC\"}.negative:before{content:\"-\"}.kpi-self-rating-list{margin:20px 0 0;padding:0;display:block}.kpi-self-rating-list div{list-style-type:none;display:inline-block;margin:0 5px;position:relative;width:48px;height:48px;border-radius:50%;font-size:24px;border-style:solid;border-width:2px;background:#fff;cursor:pointer}.kpi-self-rating-list div:first-child{margin-left:0}.kpi-self-rating-list div:last-child{margin-right:0}.kpi-self-rating-list div:after{position:absolute;display:block;left:0;top:0;right:0;font-size:24px;bottom:0;margin:auto;height:auto;padding:10px 0 0;text-align:center}.kpi-self-rating-list div.positive-single{border-color:#39aa27}.kpi-self-rating-list div.positive-single:after{color:#39aa27;display:inline-block;font-family:Guroo-Producer;font-style:normal;font-weight:400;font-variant:normal;line-height:1;text-decoration:inherit;text-rendering:optimizeLegibility;text-transform:none;-moz-osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased;font-smoothing:antialiased;content:\"\\F16C\"}.kpi-self-rating-list div.positive-single:hover{background:#6bbf5d}.kpi-self-rating-list div.positive-single:hover:after{color:#fff!important}.kpi-self-rating-list div.positive-single.active{background:#6bbf5d}.kpi-self-rating-list div.positive-single.active:after{color:#fff!important}.kpi-self-rating-list div.positive-double{border-color:#39aa27}.kpi-self-rating-list div.positive-double:after{color:#39aa27;letter-spacing:-6px;left:-6px;display:inline-block;font-family:Guroo-Producer;font-style:normal;font-weight:400;font-variant:normal;line-height:1;text-decoration:inherit;text-rendering:optimizeLegibility;text-transform:none;-moz-osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased;font-smoothing:antialiased;content:\"\\F16C\\F16B\"}.kpi-self-rating-list div.positive-double:hover{background:#6bbf5d}.kpi-self-rating-list div.positive-double:hover:after{color:#fff!important}.kpi-self-rating-list div.positive-double.active{background:#6bbf5d}.kpi-self-rating-list div.positive-double.active:after{color:#fff!important}.kpi-self-rating-list div.no-value{border-color:#f6ad17}.kpi-self-rating-list div.no-value:after{color:#f6ad17;display:inline-block;font-family:Guroo-Producer;font-style:normal;font-weight:400;font-variant:normal;line-height:1;text-decoration:inherit;text-rendering:optimizeLegibility;text-transform:none;-moz-osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased;font-smoothing:antialiased;content:\"\\F12E\"}.kpi-self-rating-list div.no-value:hover{background:#f8c251}.kpi-self-rating-list div.no-value:hover:after{color:#fff!important}.kpi-self-rating-list div.no-value.active{background:#f8c251}.kpi-self-rating-list div.no-value.active:after{color:#fff!important}.kpi-self-rating-list div.negative-single{border-color:#c5000f}.kpi-self-rating-list div.negative-single:after{color:#c5000f;display:inline-block;font-family:Guroo-Producer;font-style:normal;font-weight:400;font-variant:normal;line-height:1;text-decoration:inherit;text-rendering:optimizeLegibility;text-transform:none;-moz-osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased;font-smoothing:antialiased;content:\"\\F16D\"}.kpi-self-rating-list div.negative-single:hover{background:#d4404b}.kpi-self-rating-list div.negative-single:hover:after{color:#fff!important}.kpi-self-rating-list div.negative-single.active{background:#d4404b}.kpi-self-rating-list div.negative-single.active:after{color:#fff!important}.kpi-self-rating-list div.negative-double{border-color:#c5000f}.kpi-self-rating-list div.negative-double:after{color:#c5000f;letter-spacing:-6px;left:-6px;display:inline-block;font-family:Guroo-Producer;font-style:normal;font-weight:400;font-variant:normal;line-height:1;text-decoration:inherit;text-rendering:optimizeLegibility;text-transform:none;-moz-osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased;font-smoothing:antialiased;content:\"\\F16D\\F16E\"}.kpi-self-rating-list div.negative-double:hover{background:#d4404b}.kpi-self-rating-list div.negative-double:hover:after{color:#fff!important}.kpi-self-rating-list div.negative-double.active{background:#d4404b}.kpi-self-rating-list div.negative-double.active:after{color:#fff!important}.screen{margin:0 auto!important;max-width:1200px!important;min-width:320px!important;display:block;position:relative;overflow:hidden;min-height:664px;max-height:770px!important;height:calc(100vh - 0px)}@media only screen and (max-width:375px) and (max-height:736px) and (orientation:portrait){.screen{min-height:calc(100vh - 0px)!important;height:100%!important}}@media only screen and (max-height:375px) and (max-width:736px) and (orientation:landscape){.screen{height:100%!important;min-height:calc(100vh - 0px)!important}}@media only screen and (min-width:376px) and (max-width:414px) and (max-height:736px) and (orientation:portrait){.screen{height:100%!important;min-height:calc(100vh - 0px)!important}}@media only screen and (min-height:376px) and (max-height:414px) and (max-width:736px) and (orientation:landscape){.screen{height:100%!important;min-height:calc(100vh - 0px)!important}}@media only screen and (min-width:768px) and (max-width:1024px) and (orientation:landscape){.screen{height:100%!important;min-height:664px!important}}@media only screen and (min-width:768px) and (max-width:1024px) and (orientation:portrait){.screen{height:100%!important;min-height:924px!important}}@media only screen and (max-width:375px) and (min-height:737px) and (max-height:812px) and (orientation:portrait){.screen{height:100%!important;min-height:calc(100vh - 0px)!important}}@media only screen and (min-width:737px) and (max-width:812px) and (max-height:375px) and (orientation:landscape){.screen{height:100%!important;min-height:calc(100vh - 0px)!important}}@media only screen and (max-width:320px) and (max-height:568px) and (orientation:portrait){.screen{min-height:calc(100vh - 0px)!important;height:100%!important}}.app-bite{max-height:770px}.app-bite .scenario-bite{overflow:hidden!important;display:block;position:relative;overflow:hidden;max-height:770px}@media only screen and (max-width:375px) and (max-height:736px) and (orientation:portrait){.app-bite .scenario-bite{height:100%!important;min-height:100vh!important}}@media only screen and (max-height:375px) and (max-width:736px) and (orientation:landscape){.app-bite .scenario-bite{height:100%!important;min-height:100vh!important}}@media only screen and (min-width:376px) and (max-width:414px) and (max-height:736px) and (orientation:portrait){.app-bite .scenario-bite{height:100%!important;min-height:100vh}}@media only screen and (min-height:376px) and (max-height:414px) and (max-width:736px) and (orientation:landscape){.app-bite .scenario-bite{height:100%!important;min-height:100vh!important}}@media only screen and (max-width:375px) and (min-height:737px) and (max-height:812px) and (orientation:portrait){.app-bite .scenario-bite{height:100%!important;min-height:100vh}}@media only screen and (min-width:737px) and (max-width:812px) and (max-height:375px) and (orientation:landscape){.app-bite .scenario-bite{height:100%!important;min-height:100vh!important}}@media only screen and (min-width:768px) and (max-width:1024px) and (orientation:landscape){.app-bite .scenario-bite{height:100%!important;min-height:664px}}@media only screen and (min-width:768px) and (max-width:1024px) and (orientation:portrait){.app-bite .scenario-bite{height:100%!important;min-height:924px}}@media only screen and (max-width:320px) and (max-height:568px) and (orientation:portrait){.app-bite .scenario-bite{height:100%!important;min-height:100vh!important}}.app-bite .scenario-bite .header{padding:0;min-height:60px}.app-bite .scenario-bite .header h2,.app-bite .scenario-bite .header h3{margin:0!important}.app-bite .scenario-bite .header .screen-title{position:relative}.app-bite .scenario-bite .header .screen-title:before{margin-right:5px;font-size:80%}.app-bite .scenario-bite .header .screen-title.not-required:before{color:#999;content:\"\"}.app-bite .scenario-bite .header .screen-title.not-required:before,.app-bite .scenario-bite .header .screen-title.not-started:before{display:inline-block;font-family:Guroo-Producer;font-style:normal;font-weight:400;font-variant:normal;line-height:1;text-decoration:inherit;text-rendering:optimizeLegibility;text-transform:none;-moz-osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased;font-smoothing:antialiased}.app-bite .scenario-bite .header .screen-title.not-started:before{content:\"\\F16A\"}.app-bite .scenario-bite .header .screen-title.in-progress:before{content:\"\\F182\"}.app-bite .scenario-bite .header .screen-title.complete:before,.app-bite .scenario-bite .header .screen-title.in-progress:before{display:inline-block;font-family:Guroo-Producer;font-style:normal;font-weight:400;font-variant:normal;line-height:1;text-decoration:inherit;text-rendering:optimizeLegibility;text-transform:none;-moz-osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased;font-smoothing:antialiased}.app-bite .scenario-bite .header .screen-title.complete:before{content:\"\\F16F\"}.app-bite .scenario-bite .header .header-nav-container{display:-webkit-flex;display:flex;flex-flow:row nowrap;align-items:center;margin:0 auto!important;max-width:1200px!important;min-width:320px!important;height:100%;padding:8px 12px;position:relative}.app-bite .scenario-bite .header .header-nav-container .header-left-col{margin:0 5px;flex:1}.app-bite .scenario-bite .header .header-nav-container .header-left-col:first-child{margin-left:0}.app-bite .scenario-bite .header .header-nav-container .header-left-col:last-child{margin-right:0}.app-bite .scenario-bite .header .header-nav-container .header-left-col .col-row{display:-webkit-flex;display:flex;flex-flow:row nowrap;align-content:center;align-items:center}@media only screen and (max-width:375px) and (max-height:736px) and (orientation:portrait){.app-bite .scenario-bite .header .header-nav-container .header-left-col{flex:0;width:auto;margin:0;padding:0}}@media only screen and (min-width:376px) and (max-width:414px) and (max-height:736px) and (orientation:portrait){.app-bite .scenario-bite .header .header-nav-container .header-left-col{flex:0;width:auto;margin:0;padding:0}}@media only screen and (max-width:375px) and (min-height:737px) and (max-height:812px) and (orientation:portrait){.app-bite .scenario-bite .header .header-nav-container .header-left-col{flex:0;width:auto;margin:0;padding:0}}.app-bite .scenario-bite .header .header-nav-container .header-center-col{margin:0 5px;flex:4;max-width:55%}.app-bite .scenario-bite .header .header-nav-container .header-center-col:first-child{margin-left:0}.app-bite .scenario-bite .header .header-nav-container .header-center-col:last-child{margin-right:0}.app-bite .scenario-bite .header .header-nav-container .header-center-col .col-row{display:-webkit-flex;display:flex;flex-flow:row nowrap;justify-content:center;align-content:center;align-items:center}@media only screen and (max-height:736px) and (orientation:portrait){.app-bite .scenario-bite .header .header-nav-container .header-center-col .col-row{justify-content:flex-start}.app-bite .scenario-bite .header .header-nav-container .header-center-col .col-row h2{padding-top:10px}}@media only screen and (max-width:375px) and (max-height:736px) and (orientation:portrait){.app-bite .scenario-bite .header .header-nav-container .header-center-col .col-row{justify-content:flex-start}.app-bite .scenario-bite .header .header-nav-container .header-center-col .col-row h2{padding-top:10px}}@media only screen and (min-width:376px) and (max-width:414px) and (max-height:736px) and (orientation:portrait){.app-bite .scenario-bite .header .header-nav-container .header-center-col .col-row{justify-content:flex-start}.app-bite .scenario-bite .header .header-nav-container .header-center-col .col-row h2{padding-top:10px}}@media only screen and (max-width:375px) and (min-height:737px) and (max-height:812px) and (orientation:portrait){.app-bite .scenario-bite .header .header-nav-container .header-center-col .col-row{justify-content:flex-start}.app-bite .scenario-bite .header .header-nav-container .header-center-col .col-row h2{padding-top:10px}}.app-bite .scenario-bite .header .header-nav-container .header-right-col{margin:0 5px;flex:1}.app-bite .scenario-bite .header .header-nav-container .header-right-col:first-child{margin-left:0}.app-bite .scenario-bite .header .header-nav-container .header-right-col:last-child{margin-right:0}.app-bite .scenario-bite .header .header-nav-container .header-right-col .col-row{display:-webkit-flex;display:flex;flex-flow:row nowrap;justify-content:flex-end}.app-bite .scenario-bite .bite-progress-bar{position:relative;display:block;padding:0;margin:0;height:9px;overflow:visible!important;-webkit-box-shadow:0 3px 5px 0 rgba(0,0,0,.25);-moz-box-shadow:0 3px 5px 0 rgba(0,0,0,.25);box-shadow:0 3px 5px 0 rgba(0,0,0,.25);z-index:3}.app-bite .scenario-bite .bite-progress-bar .progress-meter{position:absolute;left:0;top:0;height:100%;width:0;background:#f6ad17}.app-bite .scenario-bite .bite-progress-bar .progress-meter.complete{background:#39aa27}.app-bite .scenario-bite .scenario-bite-content{display:block;position:relative;overflow:hidden;margin:0 auto!important;max-width:1200px!important;min-width:320px!important}.app-bite .scenario-bite .screen-wrapper{z-index:1;display:block;position:relative;overflow:hidden;min-height:596px;max-height:702px!important;height:calc(100vh - 68px)}@media only screen and (max-width:375px) and (max-height:736px) and (orientation:portrait){.app-bite .scenario-bite .screen-wrapper{min-height:calc(100vh - 68px)!important;height:100%!important}}@media only screen and (max-height:375px) and (max-width:736px) and (orientation:landscape){.app-bite .scenario-bite .screen-wrapper{height:100%!important;min-height:calc(100vh - 68px)!important}}@media only screen and (min-width:376px) and (max-width:414px) and (max-height:736px) and (orientation:portrait){.app-bite .scenario-bite .screen-wrapper{height:100%!important;min-height:calc(100vh - 68px)!important}}@media only screen and (min-height:376px) and (max-height:414px) and (max-width:736px) and (orientation:landscape){.app-bite .scenario-bite .screen-wrapper{height:100%!important;min-height:calc(100vh - 68px)!important}}@media only screen and (min-width:768px) and (max-width:1024px) and (orientation:landscape){.app-bite .scenario-bite .screen-wrapper{height:100%!important;min-height:596px!important}}@media only screen and (min-width:768px) and (max-width:1024px) and (orientation:portrait){.app-bite .scenario-bite .screen-wrapper{height:100%!important;min-height:856px!important}}@media only screen and (max-width:375px) and (min-height:737px) and (max-height:812px) and (orientation:portrait){.app-bite .scenario-bite .screen-wrapper{height:100%!important;min-height:calc(100vh - 68px)!important}}@media only screen and (min-width:737px) and (max-width:812px) and (max-height:375px) and (orientation:landscape){.app-bite .scenario-bite .screen-wrapper{height:100%!important;min-height:calc(100vh - 68px)!important}}@media only screen and (max-width:320px) and (max-height:568px) and (orientation:portrait){.app-bite .scenario-bite .screen-wrapper{min-height:calc(100vh - 68px)!important;height:100%!important}}.app-bite .scenario-bite .screen-wrapper.full-screen{min-height:664px;max-height:770px!important;height:calc(100vh - 0px)}@media only screen and (max-width:375px) and (max-height:736px) and (orientation:portrait){.app-bite .scenario-bite .screen-wrapper.full-screen{min-height:calc(100vh - 0px)!important;height:100%!important}}@media only screen and (max-height:375px) and (max-width:736px) and (orientation:landscape){.app-bite .scenario-bite .screen-wrapper.full-screen{height:100%!important;min-height:calc(100vh - 0px)!important}}@media only screen and (min-width:376px) and (max-width:414px) and (max-height:736px) and (orientation:portrait){.app-bite .scenario-bite .screen-wrapper.full-screen{height:100%!important;min-height:calc(100vh - 0px)!important}}@media only screen and (min-height:376px) and (max-height:414px) and (max-width:736px) and (orientation:landscape){.app-bite .scenario-bite .screen-wrapper.full-screen{height:100%!important;min-height:calc(100vh - 0px)!important}}@media only screen and (min-width:768px) and (max-width:1024px) and (orientation:landscape){.app-bite .scenario-bite .screen-wrapper.full-screen{height:100%!important;min-height:664px!important}}@media only screen and (min-width:768px) and (max-width:1024px) and (orientation:portrait){.app-bite .scenario-bite .screen-wrapper.full-screen{height:100%!important;min-height:924px!important}}@media only screen and (max-width:375px) and (min-height:737px) and (max-height:812px) and (orientation:portrait){.app-bite .scenario-bite .screen-wrapper.full-screen{height:100%!important;min-height:calc(100vh - 0px)!important}}@media only screen and (min-width:737px) and (max-width:812px) and (max-height:375px) and (orientation:landscape){.app-bite .scenario-bite .screen-wrapper.full-screen{height:100%!important;min-height:calc(100vh - 0px)!important}}@media only screen and (max-width:320px) and (max-height:568px) and (orientation:portrait){.app-bite .scenario-bite .screen-wrapper.full-screen{min-height:calc(100vh - 0px)!important;height:100%!important}}.app-bite .scenario-bite .screen-wrapper .background-container{position:absolute;top:0;left:0;right:0;width:100%;height:100%;margin:auto;z-index:3}.app-bite .scenario-bite .screen-wrapper .background-container img{position:absolute;bottom:0;left:0;right:0;margin:auto;width:100%;height:auto}@media only screen and (max-width:375px) and (max-height:736px) and (orientation:portrait){.app-bite .scenario-bite .screen-wrapper .background-container img{min-height:100vh;position:absolute;height:100%;left:0;right:0;margin:auto!important;width:auto;min-width:100%}}@media only screen and (max-height:375px) and (max-width:736px) and (orientation:landscape){.app-bite .scenario-bite .screen-wrapper .background-container img{min-height:100vh;height:auto;top:0;width:100%}.app-bite .scenario-bite .screen-wrapper .background-container img.title-screen{bottom:unset;top:0}}@media only screen and (min-width:376px) and (max-width:414px) and (max-height:736px) and (orientation:portrait){.app-bite .scenario-bite .screen-wrapper .background-container img{min-height:100vh;position:absolute;height:100%;left:0;right:0;margin:auto!important;width:auto;min-width:100%}}@media only screen and (min-height:376px) and (max-height:414px) and (max-width:736px) and (orientation:landscape){.app-bite .scenario-bite .screen-wrapper .background-container img{min-height:100vh;height:auto;bottom:0;width:100%}.app-bite .scenario-bite .screen-wrapper .background-container img.title-screen{bottom:unset;top:0}}@media only screen and (min-width:768px) and (max-width:1024px) and (orientation:landscape){.app-bite .scenario-bite .screen-wrapper .background-container img{min-height:664px;height:auto;width:100%}}@media only screen and (width:900px) and (height:768px){.app-bite .scenario-bite .screen-wrapper .background-container img{min-height:664px;height:auto;width:100%}}@media only screen and (min-width:768px) and (max-width:1024px) and (orientation:portrait){.app-bite .scenario-bite .screen-wrapper .background-container img{min-height:924px;position:absolute;height:100%;left:0;right:0;margin:auto!important;width:auto;min-width:100%}}@media only screen and (max-width:375px) and (min-height:737px) and (max-height:812px) and (orientation:portrait){.app-bite .scenario-bite .screen-wrapper .background-container img{min-height:100vh;position:absolute;height:100%;left:0;right:0;margin:auto!important;width:auto;min-width:100%}}@media only screen and (min-width:737px) and (max-width:812px) and (max-height:375px) and (orientation:landscape){.app-bite .scenario-bite .screen-wrapper .background-container img{min-height:100vh;height:auto;top:0;width:100%}.app-bite .scenario-bite .screen-wrapper .background-container img.title-screen{bottom:unset;top:0}}@media only screen and (max-width:320px) and (max-height:568px) and (orientation:portrait){.app-bite .scenario-bite .screen-wrapper .background-container img{min-height:100vh;position:absolute;height:100%;left:0;right:0;margin:auto!important;width:auto;min-width:100%}}.app-bite .scenario-bite .screen-wrapper .mobile-background-container{position:absolute;top:0;left:0;right:0;width:100%;height:100%;margin:auto;z-index:3}.app-bite .scenario-bite .screen-wrapper .mobile-background-container img{display:none}.app-bite .scenario-bite .screen-wrapper .screen-container{position:absolute;top:0;left:0;width:100%;height:100%;z-index:4;padding:0}.app-bite .scenario-bite .screen-wrapper .screen-container.full-screen-tight{padding:0}.app-bite .scenario-bite .screen-wrapper .screen-container .asset-col-left{width:auto;padding-right:15px;max-width:40%}.app-bite .scenario-bite .screen-wrapper .screen-container .asset-col-left .asset-image-wrapper{position:relative;width:100%;max-width:100%;overflow:hidden}.app-bite .scenario-bite .screen-wrapper .screen-container .asset-col-left .object-container{margin:0;padding:0}.app-bite .scenario-bite .screen-wrapper .screen-container .left-asset-screen{width:auto;min-width:60%}.app-bite .scenario-bite .screen-wrapper .screen-container .asset-col-right{width:auto;padding-left:15px;max-width:40%}.app-bite .scenario-bite .screen-wrapper .screen-container .asset-col-right .asset-image-wrapper{position:relative;width:100%;max-width:100%;overflow:hidden}.app-bite .scenario-bite .screen-wrapper .screen-container .asset-col-right .object-container{margin:0;padding:0}.app-bite .scenario-bite .screen-wrapper .screen-container .right-asset-screen{width:auto;min-width:60%}@media only screen and (max-width:375px) and (max-height:736px) and (orientation:portrait){.app-bite .scenario-bite .screen-wrapper .screen-container{padding:0!important}.app-bite .scenario-bite .screen-wrapper .screen-container .content-area{display:block}.app-bite .scenario-bite .screen-wrapper .screen-container .full-screen{margin:0;height:inherit;padding:10px 12px;overflow-y:scroll}.app-bite .scenario-bite .screen-wrapper .screen-container .asset-col-left{width:100%;float:none;overflow:hidden;padding:10px 12px;margin:0!important;max-width:100%}.app-bite .scenario-bite .screen-wrapper .screen-container .asset-col-left .asset-image-wrapper{margin:0 auto!important}.app-bite .scenario-bite .screen-wrapper .screen-container .left-asset-screen{width:100%;margin-left:0;padding:10px 12px}.app-bite .scenario-bite .screen-wrapper .screen-container .asset-col-right{width:100%;overflow:hidden;padding:10px 12px;margin:0!important;max-width:100%}.app-bite .scenario-bite .screen-wrapper .screen-container .asset-col-right .asset-image-wrapper{margin:0 auto!important}.app-bite .scenario-bite .screen-wrapper .screen-container .right-asset-screen{width:100%;float:none;padding:10px 12px}}@media only screen and (max-height:375px) and (max-width:736px) and (orientation:landscape){.app-bite .scenario-bite .screen-wrapper .screen-container{padding:0!important}.app-bite .scenario-bite .screen-wrapper .screen-container .content-area{display:block}.app-bite .scenario-bite .screen-wrapper .screen-container .full-screen{margin:0;height:inherit;padding:10px 12px;overflow-y:scroll}.app-bite .scenario-bite .screen-wrapper .screen-container .asset-col-left{width:100%;float:none;overflow:hidden;padding:10px 12px;margin:0!important;max-width:100%}.app-bite .scenario-bite .screen-wrapper .screen-container .asset-col-left .asset-image-wrapper{margin:0 auto!important}.app-bite .scenario-bite .screen-wrapper .screen-container .left-asset-screen{width:100%;margin-left:0;padding:10px 12px}.app-bite .scenario-bite .screen-wrapper .screen-container .asset-col-right{width:100%;overflow:hidden;padding:10px 12px;margin:0!important;max-width:100%}.app-bite .scenario-bite .screen-wrapper .screen-container .asset-col-right .asset-image-wrapper{margin:0 auto!important}.app-bite .scenario-bite .screen-wrapper .screen-container .right-asset-screen{width:100%;float:none;padding:10px 12px}}@media only screen and (min-width:376px) and (max-width:414px) and (max-height:736px) and (orientation:portrait){.app-bite .scenario-bite .screen-wrapper .screen-container{padding:0!important}.app-bite .scenario-bite .screen-wrapper .screen-container .content-area{display:block}.app-bite .scenario-bite .screen-wrapper .screen-container .full-screen{margin:0;height:inherit;padding:10px 12px;overflow-y:scroll}.app-bite .scenario-bite .screen-wrapper .screen-container .asset-col-left{width:100%;float:none;overflow:hidden;padding:10px 12px;margin:0!important;max-width:100%}.app-bite .scenario-bite .screen-wrapper .screen-container .asset-col-left .asset-image-wrapper{margin:0 auto!important}.app-bite .scenario-bite .screen-wrapper .screen-container .left-asset-screen{width:100%;margin-left:0;padding:10px 12px}.app-bite .scenario-bite .screen-wrapper .screen-container .asset-col-right{width:100%;overflow:hidden;padding:10px 12px;margin:0!important;max-width:100%}.app-bite .scenario-bite .screen-wrapper .screen-container .asset-col-right .asset-image-wrapper{margin:0 auto!important}.app-bite .scenario-bite .screen-wrapper .screen-container .right-asset-screen{width:100%;float:none;padding:10px 12px}}@media only screen and (min-height:376px) and (max-height:414px) and (max-width:736px) and (orientation:landscape){.app-bite .scenario-bite .screen-wrapper .screen-container{padding:0!important}.app-bite .scenario-bite .screen-wrapper .screen-container .content-area{display:block}.app-bite .scenario-bite .screen-wrapper .screen-container .full-screen{margin:0;height:inherit;padding:10px 12px;overflow-y:scroll}.app-bite .scenario-bite .screen-wrapper .screen-container .asset-col-left{width:100%;float:none;overflow:hidden;padding:10px 12px;margin:0!important;max-width:100%}.app-bite .scenario-bite .screen-wrapper .screen-container .asset-col-left .asset-image-wrapper{margin:0 auto!important}.app-bite .scenario-bite .screen-wrapper .screen-container .left-asset-screen{width:100%;margin-left:0;padding:10px 12px}.app-bite .scenario-bite .screen-wrapper .screen-container .asset-col-right{width:100%;overflow:hidden;padding:10px 12px;margin:0!important;max-width:100%}.app-bite .scenario-bite .screen-wrapper .screen-container .asset-col-right .asset-image-wrapper{margin:0 auto!important}.app-bite .scenario-bite .screen-wrapper .screen-container .right-asset-screen{width:100%;float:none;padding:10px 12px}}@media only screen and (max-width:375px) and (min-height:737px) and (max-height:812px) and (orientation:portrait){.app-bite .scenario-bite .screen-wrapper .screen-container{padding:0!important}.app-bite .scenario-bite .screen-wrapper .screen-container .content-area{display:block}.app-bite .scenario-bite .screen-wrapper .screen-container .full-screen{margin:0;height:inherit;padding:10px 12px;overflow-y:scroll}.app-bite .scenario-bite .screen-wrapper .screen-container .asset-col-left{width:100%;float:none;overflow:hidden;padding:10px 12px;margin:0!important;max-width:100%}.app-bite .scenario-bite .screen-wrapper .screen-container .asset-col-left .asset-image-wrapper{margin:0 auto!important}.app-bite .scenario-bite .screen-wrapper .screen-container .left-asset-screen{width:100%;margin-left:0;padding:10px 12px}.app-bite .scenario-bite .screen-wrapper .screen-container .asset-col-right{width:100%;overflow:hidden;padding:10px 12px;margin:0!important;max-width:100%}.app-bite .scenario-bite .screen-wrapper .screen-container .asset-col-right .asset-image-wrapper{margin:0 auto!important}.app-bite .scenario-bite .screen-wrapper .screen-container .right-asset-screen{width:100%;float:none;padding:10px 12px}}@media only screen and (min-height:737px) and (max-height:812px) and (max-width:375px) and (orientation:landscape){.app-bite .scenario-bite .screen-wrapper .screen-container{padding:0!important}.app-bite .scenario-bite .screen-wrapper .screen-container .content-area{display:block}.app-bite .scenario-bite .screen-wrapper .screen-container .full-screen{margin:0;height:inherit;padding:10px 12px;overflow-y:scroll}.app-bite .scenario-bite .screen-wrapper .screen-container .asset-col-left{width:100%;float:none;overflow:hidden;padding:10px 12px;margin:0!important;max-width:100%}.app-bite .scenario-bite .screen-wrapper .screen-container .asset-col-left .asset-image-wrapper{margin:0 auto!important}.app-bite .scenario-bite .screen-wrapper .screen-container .left-asset-screen{width:100%;margin-left:0;padding:10px 12px}.app-bite .scenario-bite .screen-wrapper .screen-container .asset-col-right{width:100%;overflow:hidden;padding:10px 12px;margin:0!important;max-width:100%}.app-bite .scenario-bite .screen-wrapper .screen-container .asset-col-right .asset-image-wrapper{margin:0 auto!important}.app-bite .scenario-bite .screen-wrapper .screen-container .right-asset-screen{width:100%;float:none;padding:10px 12px}}@media only screen and (max-width:320px) and (max-height:568px) and (orientation:landscape){.app-bite .scenario-bite .screen-wrapper .screen-container{padding:0!important}.app-bite .scenario-bite .screen-wrapper .screen-container .content-area{display:block}.app-bite .scenario-bite .screen-wrapper .screen-container .full-screen{margin:0;height:inherit;padding:10px 12px;overflow-y:scroll}.app-bite .scenario-bite .screen-wrapper .screen-container .asset-col-left{width:100%;float:none;overflow:hidden;padding:10px 12px;margin:0!important;max-width:100%}.app-bite .scenario-bite .screen-wrapper .screen-container .asset-col-left .asset-image-wrapper{margin:0 auto!important}.app-bite .scenario-bite .screen-wrapper .screen-container .left-asset-screen{width:100%;margin-left:0;padding:10px 12px}.app-bite .scenario-bite .screen-wrapper .screen-container .asset-col-right{width:100%;overflow:hidden;padding:10px 12px;margin:0!important;max-width:100%}.app-bite .scenario-bite .screen-wrapper .screen-container .asset-col-right .asset-image-wrapper{margin:0 auto!important}.app-bite .scenario-bite .screen-wrapper .screen-container .right-asset-screen{width:100%;float:none;padding:10px 12px}}.app-bite .scenario-bite .screen-wrapper .screen-container .character-stage{display:block;float:left;width:40%;height:inherit;padding:40px 0 0;z-index:2}@media only screen and (max-width:900px){.app-bite .scenario-bite .screen-wrapper .screen-container .character-stage{float:none;clear:both;margin:0;width:100%;height:inherit;z-index:2}}@media only screen and (max-width:375px) and (max-height:736px) and (orientation:portrait){.app-bite .scenario-bite .screen-wrapper .screen-container .character-stage{float:none;clear:both;margin:0;width:100%;height:inherit;z-index:2}}@media only screen and (max-height:375px) and (max-width:736px) and (orientation:landscape){.app-bite .scenario-bite .screen-wrapper .screen-container .character-stage{float:none;clear:both;margin:0;width:100%;height:inherit;z-index:2}}@media only screen and (min-width:376px) and (max-width:414px) and (max-height:736px) and (orientation:portrait){.app-bite .scenario-bite .screen-wrapper .screen-container .character-stage{float:none;clear:both;margin:0;width:100%;height:inherit;z-index:2}}@media only screen and (min-height:376px) and (max-height:414px) and (max-width:736px) and (orientation:landscape){.app-bite .scenario-bite .screen-wrapper .screen-container .character-stage{float:none;clear:both;margin:0;width:100%;height:inherit;z-index:2}}@media only screen and (max-width:375px) and (min-height:737px) and (max-height:812px) and (orientation:portrait){.app-bite .scenario-bite .screen-wrapper .screen-container .character-stage{float:none;clear:both;margin:0;width:100%;height:inherit;z-index:2}}@media only screen and (min-width:737px) and (max-width:812px) and (max-height:375px) and (orientation:landscape){.app-bite .scenario-bite .screen-wrapper .screen-container .character-stage{float:none;clear:both;margin:0;width:100%;height:inherit;z-index:2}}@media only screen and (min-width:768px) and (max-width:1024px) and (orientation:portrait){.app-bite .scenario-bite .screen-wrapper .screen-container .character-stage{float:none;clear:both;margin:0;width:100%;height:inherit;z-index:2}}@media only screen and (max-width:320px) and (max-height:568px) and (orientation:portrait){.app-bite .scenario-bite .screen-wrapper .screen-container .character-stage{float:none;clear:both;margin:0;width:100%;height:inherit;z-index:2}}.app-bite .scenario-bite .screen-wrapper .screen-container .character-stage .close_up{display:block;position:relative;text-align:center;height:100%;width:auto;margin:0 auto;bottom:0;z-index:2}.app-bite .scenario-bite .screen-wrapper .screen-container .character-stage .close_up img{position:absolute;left:-12%;right:0;bottom:0!important;width:125%;height:auto;z-index:0}@media only screen and (max-width:900px){.app-bite .scenario-bite .screen-wrapper .screen-container .character-stage .close_up img{height:100%;width:auto;left:0;right:0;margin:auto}}@media only screen and (max-width:375px) and (max-height:736px) and (orientation:portrait){.app-bite .scenario-bite .screen-wrapper .screen-container .character-stage .close_up img{width:100%;height:auto;left:0;right:0;margin:auto}}@media only screen and (max-height:375px) and (max-width:736px) and (orientation:landscape){.app-bite .scenario-bite .screen-wrapper .screen-container .character-stage .close_up img{height:120%;width:auto;left:0;right:0;margin:auto;bottom:unset}}@media only screen and (min-width:376px) and (max-width:414px) and (max-height:736px) and (orientation:portrait){.app-bite .scenario-bite .screen-wrapper .screen-container .character-stage .close_up img{width:100%;height:auto;left:0;right:0;margin:auto}}@media only screen and (min-height:376px) and (max-height:414px) and (max-width:736px) and (orientation:landscape){.app-bite .scenario-bite .screen-wrapper .screen-container .character-stage .close_up img{height:120%;width:auto;left:0;right:0;margin:auto;bottom:unset}}@media only screen and (max-width:375px) and (min-height:737px) and (max-height:812px) and (orientation:portrait){.app-bite .scenario-bite .screen-wrapper .screen-container .character-stage .close_up img{width:100%;height:auto;left:0;right:0;margin:auto}}@media only screen and (min-width:737px) and (max-width:812px) and (max-height:375px) and (orientation:landscape){.app-bite .scenario-bite .screen-wrapper .screen-container .character-stage .close_up img{height:120%;width:auto;left:0;right:0;margin:auto;bottom:unset}}@media only screen and (min-width:768px) and (max-width:1024px) and (orientation:portrait){.app-bite .scenario-bite .screen-wrapper .screen-container .character-stage .close_up img{height:auto;width:90%;left:0;right:0;margin:auto;min-width:0}}.app-bite .scenario-bite .screen-wrapper .screen-container .character-stage .standing{position:relative;text-align:center;height:100%;max-height:100%;width:auto;margin:0 auto;bottom:0}.app-bite .scenario-bite .screen-wrapper .screen-container .character-stage .standing img{position:absolute;left:0;right:0;margin:auto!important;bottom:0;width:auto;height:auto;max-height:100%;max-width:100%}@media only screen and (max-height:375px) and (max-width:736px) and (orientation:landscape){.app-bite .scenario-bite .screen-wrapper .screen-container .character-stage .standing img{height:120%}}@media only screen and (min-height:376px) and (max-height:414px) and (max-width:736px) and (orientation:landscape){.app-bite .scenario-bite .screen-wrapper .screen-container .character-stage .standing img{height:120%}}@media only screen and (min-width:768px) and (max-width:1024px) and (orientation:portrait){.app-bite .scenario-bite .screen-wrapper .screen-container .character-stage .standing img{height:90%;width:auto;min-width:0;left:0;right:0;margin:auto}}.app-bite .scenario-bite .screen-wrapper .screen-container .object-feed{position:absolute;left:40%;top:0;width:60%;height:inherit;z-index:4;overflow-y:scroll;transition:height 1s ease-out;right:0;padding-bottom:20px}.app-bite .scenario-bite .screen-wrapper .screen-container .object-feed .feed-object-container{padding:16px 24px;padding-top:0;padding-bottom:10px;margin:0;line-height:130%}.app-bite .scenario-bite .screen-wrapper .screen-container .object-feed .feed-object-container:first-child{margin-top:20px}.app-bite .scenario-bite .screen-wrapper .screen-container .object-feed .feed-object-container:last-child{margin-bottom:20px;position:sticky;bottom:0}.app-bite .scenario-bite .screen-wrapper .screen-container .object-feed .feed-object-container p{margin:0 0 8px}.app-bite .scenario-bite .screen-wrapper .screen-container .object-feed .feed-object-container p:last-child{margin:0}.app-bite .scenario-bite .screen-wrapper .screen-container .object-feed .feed-object-container .content-dialogs .object-container:last-child{margin-bottom:20px}@media only screen and (max-width:375px) and (max-height:736px) and (orientation:portrait){.app-bite .scenario-bite .screen-wrapper .screen-container .object-feed .feed-object-container{overflow:hidden;padding:4px 12px}.app-bite .scenario-bite .screen-wrapper .screen-container .object-feed .feed-object-container .feedback-panel{padding:10px 12px;margin:0 -12px}.app-bite .scenario-bite .screen-wrapper .screen-container .object-feed .feed-object-container .question-wrapper .question-prompt.object-container{background:transparent!important;border:none!important;padding:0 24px 0 0!important}}@media only screen and (max-height:375px) and (max-width:736px) and (orientation:landscape){.app-bite .scenario-bite .screen-wrapper .screen-container .object-feed .feed-object-container{overflow:hidden;padding:4px 12px}.app-bite .scenario-bite .screen-wrapper .screen-container .object-feed .feed-object-container .feedback-panel{padding:10px 12px;margin:0 -12px}.app-bite .scenario-bite .screen-wrapper .screen-container .object-feed .feed-object-container .question-wrapper .question-prompt.object-container{background:transparent!important;border:none!important;padding:0 24px 0 0!important}}@media only screen and (min-width:376px) and (max-width:414px) and (max-height:736px) and (orientation:portrait){.app-bite .scenario-bite .screen-wrapper .screen-container .object-feed .feed-object-container{overflow:hidden;padding:4px 12px}.app-bite .scenario-bite .screen-wrapper .screen-container .object-feed .feed-object-container .feedback-panel{padding:10px 12px;margin:0 -12px}.app-bite .scenario-bite .screen-wrapper .screen-container .object-feed .feed-object-container .question-wrapper .question-prompt.object-container{background:transparent!important;border:none!important;padding:0 24px 0 0!important}}@media only screen and (min-height:376px) and (max-height:414px) and (max-width:736px) and (orientation:landscape){.app-bite .scenario-bite .screen-wrapper .screen-container .object-feed .feed-object-container{overflow:hidden;padding:4px 12px}.app-bite .scenario-bite .screen-wrapper .screen-container .object-feed .feed-object-container .feedback-panel{padding:10px 12px;margin:0 -12px}.app-bite .scenario-bite .screen-wrapper .screen-container .object-feed .feed-object-container .question-wrapper .question-prompt.object-container{background:transparent!important;border:none!important;padding:0 24px 0 0!important}}@media only screen and (max-width:375px) and (min-height:737px) and (max-height:812px) and (orientation:portrait){.app-bite .scenario-bite .screen-wrapper .screen-container .object-feed .feed-object-container{overflow:hidden;padding:4px 12px}.app-bite .scenario-bite .screen-wrapper .screen-container .object-feed .feed-object-container .feedback-panel{padding:10px 12px;margin:0 -12px}.app-bite .scenario-bite .screen-wrapper .screen-container .object-feed .feed-object-container .question-wrapper .question-prompt.object-container{background:transparent!important;border:none!important;padding:0 24px 0 0!important}}@media only screen and (min-width:737px) and (max-width:812px) and (max-height:375px) and (orientation:landscape){.app-bite .scenario-bite .screen-wrapper .screen-container .object-feed .feed-object-container{overflow:hidden;padding:4px 12px}.app-bite .scenario-bite .screen-wrapper .screen-container .object-feed .feed-object-container .feedback-panel{padding:10px 12px;margin:0 -12px}.app-bite .scenario-bite .screen-wrapper .screen-container .object-feed .feed-object-container .question-wrapper .question-prompt.object-container{background:transparent!important;border:none!important;padding:0 24px 0 0!important}}.app-bite .scenario-bite .screen-wrapper .screen-container .object-feed .feed-object-container .object-container.toolbox_link{margin:0!important}.app-bite .scenario-bite .screen-wrapper .screen-container .object-feed .feed-object-container .learner-action-option.answered:before,.app-bite .scenario-bite .screen-wrapper .screen-container .object-feed .feed-object-container .learner-action-option.review-selected:before,.app-bite .scenario-bite .screen-wrapper .screen-container .object-feed .feed-object-container .learner-action-option.review:before,.app-bite .scenario-bite .screen-wrapper .screen-container .object-feed .feed-object-container .learner-action-option.selected:before,.app-bite .scenario-bite .screen-wrapper .screen-container .object-feed .feed-object-container .learner-action-option.show-answer:before{left:24px!important}.app-bite .scenario-bite .screen-wrapper .screen-container .object-feed .feed-object-container .learner-action-option.answered:after{right:18px!important}@media only screen and (min-width:200px) and (max-width:900px) and (orientation:landscape){.app-bite .scenario-bite .screen-wrapper .screen-container .object-feed{position:absolute;width:100%;margin-left:0;left:0;top:unset;bottom:0;height:auto;max-height:701px;overflow-y:auto;-webkit-box-shadow:none;-moz-box-shadow:none;box-shadow:none;padding-bottom:0}.app-bite .scenario-bite .screen-wrapper .screen-container .object-feed .feed-object-container:last-child{padding-bottom:0}}@media only screen and (min-width:200px) and (max-width:1023px) and (orientation:portrait){.app-bite .scenario-bite .screen-wrapper .screen-container .object-feed{position:absolute;width:100%;margin-left:0;left:0;top:unset;bottom:0;height:auto;max-height:701px;overflow-y:auto;-webkit-box-shadow:none;-moz-box-shadow:none;box-shadow:none;padding-bottom:0}.app-bite .scenario-bite .screen-wrapper .screen-container .object-feed .feed-object-container:last-child{padding-bottom:0}}@media only screen and (max-width:375px) and (max-height:736px) and (orientation:portrait){.app-bite .scenario-bite .screen-wrapper .screen-container .object-feed{position:absolute;width:100%;margin-left:0;left:0;top:unset;bottom:0;height:auto;max-height:calc(100vh - 60px - 9px);-webkit-box-shadow:none;-moz-box-shadow:none;box-shadow:none;padding-bottom:0}.app-bite .scenario-bite .screen-wrapper .screen-container .object-feed .feed-object-container:last-child{padding-bottom:0}}@media only screen and (max-height:375px) and (max-width:736px) and (orientation:landscape){.app-bite .scenario-bite .screen-wrapper .screen-container .object-feed{position:absolute;width:100%;margin-left:0;left:0;top:unset;bottom:0;height:auto;max-height:calc(100vh - 60px - 9px);-webkit-box-shadow:none;-moz-box-shadow:none;box-shadow:none;padding-bottom:0}.app-bite .scenario-bite .screen-wrapper .screen-container .object-feed .feed-object-container:last-child{padding-bottom:0}}@media only screen and (min-width:376px) and (max-width:414px) and (max-height:736px) and (orientation:portrait){.app-bite .scenario-bite .screen-wrapper .screen-container .object-feed{position:absolute;width:100%;margin-left:0;left:0;top:unset;bottom:0;height:auto;max-height:calc(100vh - 60px - 9px);-webkit-box-shadow:none;-moz-box-shadow:none;box-shadow:none;padding-bottom:0}.app-bite .scenario-bite .screen-wrapper .screen-container .object-feed .feed-object-container:last-child{padding-bottom:0}}@media only screen and (min-height:376px) and (max-height:414px) and (max-width:736px) and (orientation:landscape){.app-bite .scenario-bite .screen-wrapper .screen-container .object-feed{position:absolute;width:100%;margin-left:0;left:0;top:unset;bottom:0;height:auto;max-height:calc(100vh - 60px - 9px);-webkit-box-shadow:none;-moz-box-shadow:none;box-shadow:none;padding-bottom:0}.app-bite .scenario-bite .screen-wrapper .screen-container .object-feed .feed-object-container:last-child{padding-bottom:0}}@media only screen and (max-width:375px) and (min-height:737px) and (max-height:812px) and (orientation:portrait){.app-bite .scenario-bite .screen-wrapper .screen-container .object-feed{position:absolute;width:100%;margin-left:0;left:0;top:unset;bottom:0;height:auto;max-height:calc(100vh - 60px - 9px);-webkit-box-shadow:none;-moz-box-shadow:none;box-shadow:none;padding-bottom:0}.app-bite .scenario-bite .screen-wrapper .screen-container .object-feed .feed-object-container:last-child{padding-bottom:0}}@media only screen and (min-width:737px) and (max-width:812px) and (max-height:375px) and (orientation:landscape){.app-bite .scenario-bite .screen-wrapper .screen-container .object-feed{position:absolute;width:100%;margin-left:0;left:0;top:unset;bottom:0;height:auto;max-height:calc(100vh - 60px - 9px);-webkit-box-shadow:none;-moz-box-shadow:none;box-shadow:none;padding-bottom:0}.app-bite .scenario-bite .screen-wrapper .screen-container .object-feed .feed-object-container:last-child{padding-bottom:0}}@media only screen and (min-width:768px) and (max-width:1024px) and (orientation:portrait){.app-bite .scenario-bite .screen-wrapper .screen-container .object-feed{position:absolute;width:100%;margin-left:0;left:0;top:unset;bottom:0;height:auto;max-height:855px;overflow-y:auto;-webkit-box-shadow:none;-moz-box-shadow:none;box-shadow:none;padding-bottom:0}.app-bite .scenario-bite .screen-wrapper .screen-container .object-feed .feed-object-container:last-child{padding-bottom:0}}@media only screen and (max-width:320px) and (max-height:568px) and (orientation:portrait){.app-bite .scenario-bite .screen-wrapper .screen-container .object-feed{position:absolute;width:100%;margin-left:0;left:0;top:unset;bottom:0;height:auto;max-height:calc(100vh - 60px - 9px);-webkit-box-shadow:none;-moz-box-shadow:none;box-shadow:none;padding-bottom:0}.app-bite .scenario-bite .screen-wrapper .screen-container .object-feed .feed-object-container:last-child{padding-bottom:0}}@media only screen and (max-width:320px) and (max-height:568px) and (orientation:landscape){.app-bite .scenario-bite .screen-wrapper .screen-container .object-feed{position:absolute;width:100%;margin-left:0;left:0;top:unset;bottom:0;height:auto;max-height:calc(100vh - 60px - 9px);-webkit-box-shadow:none;-moz-box-shadow:none;box-shadow:none;padding-bottom:0}.app-bite .scenario-bite .screen-wrapper .screen-container .object-feed .feed-object-container:last-child{padding-bottom:0}}@media only screen and (max-width:375px) and (max-height:736px) and (orientation:portrait){.app-bite .scenario-bite .screen-wrapper .screen-container .blurred-feed:not(.accordion-content-wrapper){background:hsla(0,0%,100%,.8)}}@media only screen and (max-height:375px) and (max-width:736px) and (orientation:landscape){.app-bite .scenario-bite .screen-wrapper .screen-container .blurred-feed:not(.accordion-content-wrapper){background:hsla(0,0%,100%,.8)}}@media only screen and (min-width:376px) and (max-width:414px) and (max-height:736px) and (orientation:portrait){.app-bite .scenario-bite .screen-wrapper .screen-container .blurred-feed:not(.accordion-content-wrapper){background:hsla(0,0%,100%,.8)}}@media only screen and (min-height:376px) and (max-height:414px) and (max-width:736px) and (orientation:landscape){.app-bite .scenario-bite .screen-wrapper .screen-container .blurred-feed:not(.accordion-content-wrapper){background:hsla(0,0%,100%,.8)}}@media only screen and (min-width:768px) and (max-width:1024px) and (orientation:portrait){.app-bite .scenario-bite .screen-wrapper .screen-container .blurred-feed:not(.accordion-content-wrapper){background:hsla(0,0%,100%,.8)}}@media only screen and (max-width:375px) and (min-height:737px) and (max-height:812px) and (orientation:portrait){.app-bite .scenario-bite .screen-wrapper .screen-container .blurred-feed:not(.accordion-content-wrapper){background:hsla(0,0%,100%,.8)}}@media only screen and (min-width:737px) and (max-width:812px) and (max-height:375px) and (orientation:landscape){.app-bite .scenario-bite .screen-wrapper .screen-container .blurred-feed:not(.accordion-content-wrapper){background:hsla(0,0%,100%,.8)}}@media only screen and (max-width:320px) and (max-height:568px) and (orientation:portrait){.app-bite .scenario-bite .screen-wrapper .screen-container .blurred-feed:not(.accordion-content-wrapper){background:hsla(0,0%,100%,.8)}}@media only screen and (max-width:320px) and (max-height:568px) and (orientation:landscape){.app-bite .scenario-bite .screen-wrapper .screen-container .blurred-feed:not(.accordion-content-wrapper){background:hsla(0,0%,100%,.8)}}.app-bite .scenario-bite .screen-wrapper .screen-container.frosted_white .feed-background{position:absolute;top:0;left:0;right:0;width:100%;height:100%;margin:auto;-webkit-clip-path:inset(0 0 0 40%);clip-path:inset(0 0 0 40%);-webkit-filter:blur(15px);filter:blur(15px)}.app-bite .scenario-bite .screen-wrapper .screen-container.frosted_white .feed-background img{position:absolute;bottom:0;left:0;right:0;margin:auto;width:100%;height:auto}@media only screen and (max-width:375px) and (max-height:736px) and (orientation:portrait){.app-bite .scenario-bite .screen-wrapper .screen-container.frosted_white .feed-background img{min-height:100vh;position:absolute;height:100%;left:0;right:0;margin:auto!important;width:auto;min-width:100%}}@media only screen and (max-height:375px) and (max-width:736px) and (orientation:landscape){.app-bite .scenario-bite .screen-wrapper .screen-container.frosted_white .feed-background img{min-height:100vh;height:auto;top:0;width:100%}.app-bite .scenario-bite .screen-wrapper .screen-container.frosted_white .feed-background img.title-screen{bottom:unset;top:0}}@media only screen and (min-width:376px) and (max-width:414px) and (max-height:736px) and (orientation:portrait){.app-bite .scenario-bite .screen-wrapper .screen-container.frosted_white .feed-background img{min-height:100vh;position:absolute;height:100%;left:0;right:0;margin:auto!important;width:auto;min-width:100%}}@media only screen and (min-height:376px) and (max-height:414px) and (max-width:736px) and (orientation:landscape){.app-bite .scenario-bite .screen-wrapper .screen-container.frosted_white .feed-background img{min-height:100vh;height:auto;bottom:0;width:100%}.app-bite .scenario-bite .screen-wrapper .screen-container.frosted_white .feed-background img.title-screen{bottom:unset;top:0}}@media only screen and (min-width:768px) and (max-width:1024px) and (orientation:landscape){.app-bite .scenario-bite .screen-wrapper .screen-container.frosted_white .feed-background img{min-height:664px;height:auto;width:100%}}@media only screen and (width:900px) and (height:768px){.app-bite .scenario-bite .screen-wrapper .screen-container.frosted_white .feed-background img{min-height:664px;height:auto;width:100%}}@media only screen and (min-width:768px) and (max-width:1024px) and (orientation:portrait){.app-bite .scenario-bite .screen-wrapper .screen-container.frosted_white .feed-background img{min-height:924px;position:absolute;height:100%;left:0;right:0;margin:auto!important;width:auto;min-width:100%}}@media only screen and (max-width:375px) and (min-height:737px) and (max-height:812px) and (orientation:portrait){.app-bite .scenario-bite .screen-wrapper .screen-container.frosted_white .feed-background img{min-height:100vh;position:absolute;height:100%;left:0;right:0;margin:auto!important;width:auto;min-width:100%}}@media only screen and (min-width:737px) and (max-width:812px) and (max-height:375px) and (orientation:landscape){.app-bite .scenario-bite .screen-wrapper .screen-container.frosted_white .feed-background img{min-height:100vh;height:auto;top:0;width:100%}.app-bite .scenario-bite .screen-wrapper .screen-container.frosted_white .feed-background img.title-screen{bottom:unset;top:0}}@media only screen and (max-width:320px) and (max-height:568px) and (orientation:portrait){.app-bite .scenario-bite .screen-wrapper .screen-container.frosted_white .feed-background img{min-height:100vh;position:absolute;height:100%;left:0;right:0;margin:auto!important;width:auto;min-width:100%}}@media only screen and (min-width:200px) and (max-width:900px) and (orientation:landscape){.app-bite .scenario-bite .screen-wrapper .screen-container.frosted_white .feed-background{display:none}}@media only screen and (min-width:200px) and (max-width:1023px) and (orientation:portrait){.app-bite .scenario-bite .screen-wrapper .screen-container.frosted_white .feed-background{display:none}}@media only screen and (max-width:375px) and (max-height:736px) and (orientation:portrait){.app-bite .scenario-bite .screen-wrapper .screen-container.frosted_white .feed-background{display:none}}@media only screen and (max-height:375px) and (max-width:736px) and (orientation:landscape){.app-bite .scenario-bite .screen-wrapper .screen-container.frosted_white .feed-background{display:none}}@media only screen and (min-width:376px) and (max-width:414px) and (max-height:736px) and (orientation:portrait){.app-bite .scenario-bite .screen-wrapper .screen-container.frosted_white .feed-background{display:none}}@media only screen and (min-height:376px) and (max-height:414px) and (max-width:736px) and (orientation:landscape){.app-bite .scenario-bite .screen-wrapper .screen-container.frosted_white .feed-background{display:none}}@media only screen and (max-width:375px) and (min-height:737px) and (max-height:812px) and (orientation:portrait){.app-bite .scenario-bite .screen-wrapper .screen-container.frosted_white .feed-background{display:none}}@media only screen and (min-width:768px) and (max-width:1024px) and (orientation:portrait){.app-bite .scenario-bite .screen-wrapper .screen-container.frosted_white .feed-background{display:none}}.app-bite .scenario-bite .screen-wrapper .screen-container.frosted_white .blurred-feed{background:hsla(0,0%,100%,.7);-webkit-box-shadow:0 5px 5px 0 rgba(0,0,0,.25);-moz-box-shadow:0 5px 5px 0 rgba(0,0,0,.25);box-shadow:0 5px 5px 0 rgba(0,0,0,.25)}.app-bite .scenario-bite .screen-wrapper .screen-container.frosted_white .standard-feed{background:hsla(0,0%,100%,.9);-webkit-box-shadow:0 5px 5px 0 rgba(0,0,0,.25);-moz-box-shadow:0 5px 5px 0 rgba(0,0,0,.25);box-shadow:0 5px 5px 0 rgba(0,0,0,.25)}@media only screen and (max-width:375px) and (max-height:736px) and (orientation:portrait){.app-bite .scenario-bite .screen-wrapper .screen-container.frosted_white .blurred-feed:not(.accordion-content-wrapper){background:hsla(0,0%,100%,.8)}}@media only screen and (max-height:375px) and (max-width:736px) and (orientation:landscape){.app-bite .scenario-bite .screen-wrapper .screen-container.frosted_white .blurred-feed:not(.accordion-content-wrapper){background:hsla(0,0%,100%,.8)}}@media only screen and (min-width:376px) and (max-width:414px) and (max-height:736px) and (orientation:portrait){.app-bite .scenario-bite .screen-wrapper .screen-container.frosted_white .blurred-feed:not(.accordion-content-wrapper){background:hsla(0,0%,100%,.8)}}@media only screen and (min-height:376px) and (max-height:414px) and (max-width:736px) and (orientation:landscape){.app-bite .scenario-bite .screen-wrapper .screen-container.frosted_white .blurred-feed:not(.accordion-content-wrapper){background:hsla(0,0%,100%,.8)}}@media only screen and (min-width:768px) and (max-width:1024px) and (orientation:portrait){.app-bite .scenario-bite .screen-wrapper .screen-container.frosted_white .blurred-feed:not(.accordion-content-wrapper){background:hsla(0,0%,100%,.8)}}@media only screen and (max-width:375px) and (min-height:737px) and (max-height:812px) and (orientation:portrait){.app-bite .scenario-bite .screen-wrapper .screen-container.frosted_white .blurred-feed:not(.accordion-content-wrapper){background:hsla(0,0%,100%,.8)}}@media only screen and (min-width:737px) and (max-width:812px) and (max-height:375px) and (orientation:landscape){.app-bite .scenario-bite .screen-wrapper .screen-container.frosted_white .blurred-feed:not(.accordion-content-wrapper){background:hsla(0,0%,100%,.8)}}@media only screen and (max-width:320px) and (max-height:568px) and (orientation:portrait){.app-bite .scenario-bite .screen-wrapper .screen-container.frosted_white .blurred-feed:not(.accordion-content-wrapper){background:hsla(0,0%,100%,.8)}}@media only screen and (max-width:320px) and (max-height:568px) and (orientation:landscape){.app-bite .scenario-bite .screen-wrapper .screen-container.frosted_white .blurred-feed:not(.accordion-content-wrapper){background:hsla(0,0%,100%,.8)}}.app-bite .scenario-bite .screen-wrapper .screen-container.tinted_dark .feed-background{position:absolute;top:0;left:0;right:0;width:100%;height:100%;margin:auto;-webkit-clip-path:inset(0 0 0 40%);clip-path:inset(0 0 0 40%);-webkit-filter:blur(15px);filter:blur(15px)}.app-bite .scenario-bite .screen-wrapper .screen-container.tinted_dark .feed-background img{position:absolute;bottom:0;left:0;right:0;margin:auto;width:100%;height:auto}@media only screen and (max-width:375px) and (max-height:736px) and (orientation:portrait){.app-bite .scenario-bite .screen-wrapper .screen-container.tinted_dark .feed-background img{min-height:100vh;position:absolute;height:100%;left:0;right:0;margin:auto!important;width:auto;min-width:100%}}@media only screen and (max-height:375px) and (max-width:736px) and (orientation:landscape){.app-bite .scenario-bite .screen-wrapper .screen-container.tinted_dark .feed-background img{min-height:100vh;height:auto;top:0;width:100%}.app-bite .scenario-bite .screen-wrapper .screen-container.tinted_dark .feed-background img.title-screen{bottom:unset;top:0}}@media only screen and (min-width:376px) and (max-width:414px) and (max-height:736px) and (orientation:portrait){.app-bite .scenario-bite .screen-wrapper .screen-container.tinted_dark .feed-background img{min-height:100vh;position:absolute;height:100%;left:0;right:0;margin:auto!important;width:auto;min-width:100%}}@media only screen and (min-height:376px) and (max-height:414px) and (max-width:736px) and (orientation:landscape){.app-bite .scenario-bite .screen-wrapper .screen-container.tinted_dark .feed-background img{min-height:100vh;height:auto;bottom:0;width:100%}.app-bite .scenario-bite .screen-wrapper .screen-container.tinted_dark .feed-background img.title-screen{bottom:unset;top:0}}@media only screen and (min-width:768px) and (max-width:1024px) and (orientation:landscape){.app-bite .scenario-bite .screen-wrapper .screen-container.tinted_dark .feed-background img{min-height:664px;height:auto;width:100%}}@media only screen and (width:900px) and (height:768px){.app-bite .scenario-bite .screen-wrapper .screen-container.tinted_dark .feed-background img{min-height:664px;height:auto;width:100%}}@media only screen and (min-width:768px) and (max-width:1024px) and (orientation:portrait){.app-bite .scenario-bite .screen-wrapper .screen-container.tinted_dark .feed-background img{min-height:924px;position:absolute;height:100%;left:0;right:0;margin:auto!important;width:auto;min-width:100%}}@media only screen and (max-width:375px) and (min-height:737px) and (max-height:812px) and (orientation:portrait){.app-bite .scenario-bite .screen-wrapper .screen-container.tinted_dark .feed-background img{min-height:100vh;position:absolute;height:100%;left:0;right:0;margin:auto!important;width:auto;min-width:100%}}@media only screen and (min-width:737px) and (max-width:812px) and (max-height:375px) and (orientation:landscape){.app-bite .scenario-bite .screen-wrapper .screen-container.tinted_dark .feed-background img{min-height:100vh;height:auto;top:0;width:100%}.app-bite .scenario-bite .screen-wrapper .screen-container.tinted_dark .feed-background img.title-screen{bottom:unset;top:0}}@media only screen and (max-width:320px) and (max-height:568px) and (orientation:portrait){.app-bite .scenario-bite .screen-wrapper .screen-container.tinted_dark .feed-background img{min-height:100vh;position:absolute;height:100%;left:0;right:0;margin:auto!important;width:auto;min-width:100%}}@media only screen and (min-width:200px) and (max-width:900px) and (orientation:landscape){.app-bite .scenario-bite .screen-wrapper .screen-container.tinted_dark .feed-background{display:none}}@media only screen and (min-width:200px) and (max-width:1023px) and (orientation:portrait){.app-bite .scenario-bite .screen-wrapper .screen-container.tinted_dark .feed-background{display:none}}@media only screen and (max-width:375px) and (max-height:736px) and (orientation:portrait){.app-bite .scenario-bite .screen-wrapper .screen-container.tinted_dark .feed-background{display:none}}@media only screen and (max-height:375px) and (max-width:736px) and (orientation:landscape){.app-bite .scenario-bite .screen-wrapper .screen-container.tinted_dark .feed-background{display:none}}@media only screen and (min-width:376px) and (max-width:414px) and (max-height:736px) and (orientation:portrait){.app-bite .scenario-bite .screen-wrapper .screen-container.tinted_dark .feed-background{display:none}}@media only screen and (min-height:376px) and (max-height:414px) and (max-width:736px) and (orientation:landscape){.app-bite .scenario-bite .screen-wrapper .screen-container.tinted_dark .feed-background{display:none}}@media only screen and (max-width:375px) and (min-height:737px) and (max-height:812px) and (orientation:portrait){.app-bite .scenario-bite .screen-wrapper .screen-container.tinted_dark .feed-background{display:none}}@media only screen and (min-width:768px) and (max-width:1024px) and (orientation:portrait){.app-bite .scenario-bite .screen-wrapper .screen-container.tinted_dark .feed-background{display:none}}.app-bite .scenario-bite .screen-wrapper .screen-container.tinted_dark .blurred-feed{background:rgba(0,0,0,.5)}.app-bite .scenario-bite .screen-wrapper .screen-container.tinted_dark .standard-feed{background:rgba(0,0,0,.5);-webkit-box-shadow:0 5px 5px 0 rgba(0,0,0,.25);-moz-box-shadow:0 5px 5px 0 rgba(0,0,0,.25);box-shadow:0 5px 5px 0 rgba(0,0,0,.25)}.app-bite .scenario-bite .screen-wrapper .screen-container.thick_glass .feed-background{position:absolute;top:0;left:0;right:0;width:100%;height:100%;margin:auto;-webkit-clip-path:inset(0 0 0 40%);clip-path:inset(0 0 0 40%);-webkit-filter:blur(15px);filter:blur(15px)}.app-bite .scenario-bite .screen-wrapper .screen-container.thick_glass .feed-background img{position:absolute;bottom:0;left:0;right:0;margin:auto;width:100%;height:auto}@media only screen and (max-width:375px) and (max-height:736px) and (orientation:portrait){.app-bite .scenario-bite .screen-wrapper .screen-container.thick_glass .feed-background img{min-height:100vh;position:absolute;height:100%;left:0;right:0;margin:auto!important;width:auto;min-width:100%}}@media only screen and (max-height:375px) and (max-width:736px) and (orientation:landscape){.app-bite .scenario-bite .screen-wrapper .screen-container.thick_glass .feed-background img{min-height:100vh;height:auto;top:0;width:100%}.app-bite .scenario-bite .screen-wrapper .screen-container.thick_glass .feed-background img.title-screen{bottom:unset;top:0}}@media only screen and (min-width:376px) and (max-width:414px) and (max-height:736px) and (orientation:portrait){.app-bite .scenario-bite .screen-wrapper .screen-container.thick_glass .feed-background img{min-height:100vh;position:absolute;height:100%;left:0;right:0;margin:auto!important;width:auto;min-width:100%}}@media only screen and (min-height:376px) and (max-height:414px) and (max-width:736px) and (orientation:landscape){.app-bite .scenario-bite .screen-wrapper .screen-container.thick_glass .feed-background img{min-height:100vh;height:auto;bottom:0;width:100%}.app-bite .scenario-bite .screen-wrapper .screen-container.thick_glass .feed-background img.title-screen{bottom:unset;top:0}}@media only screen and (min-width:768px) and (max-width:1024px) and (orientation:landscape){.app-bite .scenario-bite .screen-wrapper .screen-container.thick_glass .feed-background img{min-height:664px;height:auto;width:100%}}@media only screen and (width:900px) and (height:768px){.app-bite .scenario-bite .screen-wrapper .screen-container.thick_glass .feed-background img{min-height:664px;height:auto;width:100%}}@media only screen and (min-width:768px) and (max-width:1024px) and (orientation:portrait){.app-bite .scenario-bite .screen-wrapper .screen-container.thick_glass .feed-background img{min-height:924px;position:absolute;height:100%;left:0;right:0;margin:auto!important;width:auto;min-width:100%}}@media only screen and (max-width:375px) and (min-height:737px) and (max-height:812px) and (orientation:portrait){.app-bite .scenario-bite .screen-wrapper .screen-container.thick_glass .feed-background img{min-height:100vh;position:absolute;height:100%;left:0;right:0;margin:auto!important;width:auto;min-width:100%}}@media only screen and (min-width:737px) and (max-width:812px) and (max-height:375px) and (orientation:landscape){.app-bite .scenario-bite .screen-wrapper .screen-container.thick_glass .feed-background img{min-height:100vh;height:auto;top:0;width:100%}.app-bite .scenario-bite .screen-wrapper .screen-container.thick_glass .feed-background img.title-screen{bottom:unset;top:0}}@media only screen and (max-width:320px) and (max-height:568px) and (orientation:portrait){.app-bite .scenario-bite .screen-wrapper .screen-container.thick_glass .feed-background img{min-height:100vh;position:absolute;height:100%;left:0;right:0;margin:auto!important;width:auto;min-width:100%}}@media only screen and (min-width:200px) and (max-width:900px) and (orientation:landscape){.app-bite .scenario-bite .screen-wrapper .screen-container.thick_glass .feed-background{display:none}}@media only screen and (min-width:200px) and (max-width:1023px) and (orientation:portrait){.app-bite .scenario-bite .screen-wrapper .screen-container.thick_glass .feed-background{display:none}}@media only screen and (max-width:375px) and (max-height:736px) and (orientation:portrait){.app-bite .scenario-bite .screen-wrapper .screen-container.thick_glass .feed-background{display:none}}@media only screen and (max-height:375px) and (max-width:736px) and (orientation:landscape){.app-bite .scenario-bite .screen-wrapper .screen-container.thick_glass .feed-background{display:none}}@media only screen and (min-width:376px) and (max-width:414px) and (max-height:736px) and (orientation:portrait){.app-bite .scenario-bite .screen-wrapper .screen-container.thick_glass .feed-background{display:none}}@media only screen and (min-height:376px) and (max-height:414px) and (max-width:736px) and (orientation:landscape){.app-bite .scenario-bite .screen-wrapper .screen-container.thick_glass .feed-background{display:none}}@media only screen and (max-width:375px) and (min-height:737px) and (max-height:812px) and (orientation:portrait){.app-bite .scenario-bite .screen-wrapper .screen-container.thick_glass .feed-background{display:none}}@media only screen and (min-width:768px) and (max-width:1024px) and (orientation:portrait){.app-bite .scenario-bite .screen-wrapper .screen-container.thick_glass .feed-background{display:none}}.app-bite .scenario-bite .screen-wrapper .screen-container.thick_glass .blurred-feed{background:hsla(0,0%,91%,.2);-webkit-box-shadow:0 5px 5px 0 rgba(0,0,0,.25);-moz-box-shadow:0 5px 5px 0 rgba(0,0,0,.25);box-shadow:0 5px 5px 0 rgba(0,0,0,.25)}.app-bite .scenario-bite .screen-wrapper .screen-container.thick_glass .standard-feed{background:hsla(0,0%,91%,.9);-webkit-box-shadow:0 5px 5px 0 rgba(0,0,0,.25);-moz-box-shadow:0 5px 5px 0 rgba(0,0,0,.25);box-shadow:0 5px 5px 0 rgba(0,0,0,.25)}@media only screen and (max-width:375px) and (max-height:736px) and (orientation:portrait){.app-bite .scenario-bite .screen-wrapper .screen-container.thick_glass .blurred-feed{background:hsla(0,0%,91%,.9)}}@media only screen and (max-height:375px) and (max-width:736px) and (orientation:landscape){.app-bite .scenario-bite .screen-wrapper .screen-container.thick_glass .blurred-feed{background:hsla(0,0%,91%,.9)}}@media only screen and (min-width:376px) and (max-width:414px) and (max-height:736px) and (orientation:portrait){.app-bite .scenario-bite .screen-wrapper .screen-container.thick_glass .blurred-feed{background:hsla(0,0%,91%,.9)}}@media only screen and (min-height:376px) and (max-height:414px) and (max-width:736px) and (orientation:landscape){.app-bite .scenario-bite .screen-wrapper .screen-container.thick_glass .blurred-feed{background:hsla(0,0%,91%,.9)}}@media only screen and (min-width:768px) and (max-width:1024px) and (orientation:portrait){.app-bite .scenario-bite .screen-wrapper .screen-container.thick_glass .blurred-feed{background:hsla(0,0%,91%,.9)}}@media only screen and (max-width:375px) and (min-height:737px) and (max-height:812px) and (orientation:portrait){.app-bite .scenario-bite .screen-wrapper .screen-container.thick_glass .blurred-feed{background:hsla(0,0%,91%,.9)}}@media only screen and (min-width:737px) and (max-width:812px) and (max-height:375px) and (orientation:landscape){.app-bite .scenario-bite .screen-wrapper .screen-container.thick_glass .blurred-feed{background:hsla(0,0%,91%,.9)}}@media only screen and (max-width:320px) and (max-height:568px) and (orientation:portrait){.app-bite .scenario-bite .screen-wrapper .screen-container.thick_glass .blurred-feed{background:hsla(0,0%,91%,.9)}}@media only screen and (max-width:320px) and (max-height:568px) and (orientation:landscape){.app-bite .scenario-bite .screen-wrapper .screen-container.thick_glass .blurred-feed{background:hsla(0,0%,91%,.9)}}.app-bite .scenario-bite .screen-wrapper .screen-container.transparent .feed-background{display:none}.app-bite .scenario-bite .screen-wrapper .customer-scenario .screen-container{padding:0}.header-btn{cursor:pointer}.header-btn.disabled{opacity:.5;cursor:default}.header-btn.disabled:focus,.header-btn.disabled:hover{opacity:.5}.header-btn .icon{text-align:center;font-size:32px;padding:0;margin:0;line-height:0}.header-btn.back .icon{padding-top:4px;font-size:26px}.header-btn.back .btn-label{padding:7px 0 6px}.header-btn .btn-label{font-size:60%;padding:6px 0;text-align:center;line-height:0}.header-btn:hover{opacity:.7}.header-btn:active,.header-btn:focus{opacity:.7!important}.action-option-label{display:block;overflow:hidden;position:relative;padding:0;margin:0}.user_name_label{text-align:right;padding:0 42px 0 0}.customer_name_label,.user_name_label{position:relative;margin:0;font-size:60%;text-transform:uppercase;color:#333}.customer_name_label{text-align:left;padding:0 0 0 42px}.narrator_name_label{position:relative;text-align:center;padding:0 16px;margin:0;font-size:60%;text-transform:uppercase;color:#333}.learner-action-option-list{display:block;overflow:visible;margin:0 -24px 20px;padding:0;clear:both;min-width:calc(100% + 48px)!important}.learner-action-option-list.user{float:right}.learner-action-option-list:focus{box-shadow:none!important;outline:none}.learner-action-option-list .learner-action-option{position:relative;display:block;width:100%;list-style-type:none;margin:0;padding:0 24px 0 0;height:0;overflow:hidden}.learner-action-option-list .learner-action-option input{display:none}.learner-action-option-list .learner-action-option label{width:80%;max-width:80%!important;display:block;float:right;overflow:hidden;margin:0 15px 0 0;font-weight:400;padding:14px 24px;line-height:130%;border-bottom:2px solid transparent;margin-bottom:2px;transition:opacity .3s ease,border-radius .6s ease,width 2s ease,border-color .6s ease,color .2s ease,background .4s ease}.learner-action-option-list .learner-action-option label p:last-child{margin-bottom:0}.learner-action-option-list .learner-action-option input:not([disabled])+label{cursor:pointer}.learner-action-option-list .learner-action-option input:not([disabled])+label:hover{opacity:.7}.learner-action-option-list .learner-action-option:first-child label{border-top-left-radius:20px;border-top-right-radius:20px}.learner-action-option-list .learner-action-option:last-child label{border-bottom-left-radius:20px;border-bottom-right-radius:20px;margin-bottom:2px}.learner-action-option-list .learner-action-option:last-child label:after{content:\"\"!important;bottom:7px!important;right:9px!important;position:absolute!important;border:0 solid!important;display:block!important;width:30px!important;height:18px!important;background-color:transparent!important;border-bottom-left-radius:50%!important;border-bottom-right-radius:50%!important;box-shadow:-15px 6px 0 0 #5b8bc7}.learner-action-option-list .learner-action-option.rounded label{border-radius:20px;margin-bottom:2px;max-width:80%!important}.learner-action-option-list .learner-action-option.rounded label:after{content:\"\";bottom:7px;right:9px;position:absolute;border:0 solid;display:block;width:30px;height:18px;background-color:transparent;border-bottom-left-radius:50%;border-bottom-right-radius:50%}.learner-action-option-list .learner-action-option.selected:before{display:block;position:absolute;width:16px;height:16px;padding:0;margin:0;border-radius:50%;top:calc(50% - 8px);left:48px;content:\"\"}.learner-action-option-list .learner-action-option.selected.best:before{background:#39aa27}.learner-action-option-list .learner-action-option.selected.ok:before{background:#f6ad17}.learner-action-option-list .learner-action-option.selected.poor:before{background:#c5000f}.learner-action-option-list .learner-action-option.selected.reflective:before{background:#6592cb}.learner-action-option-list .learner-action-option.review-selected:before{display:block;position:absolute;width:16px;height:16px;padding:0;margin:0;border-radius:50%;top:calc(50% - 8px);left:48px;content:\"\"}.learner-action-option-list .learner-action-option.review-selected.best:before{background:#39aa27}.learner-action-option-list .learner-action-option.review-selected.ok:before{background:#f6ad17}.learner-action-option-list .learner-action-option.review-selected.poor:before{background:#c5000f}.learner-action-option-list .learner-action-option.review-selected.reflective:before{background:#6592cb}.learner-action-option-list .learner-action-option.show-answer:before{display:block;position:absolute;width:16px;height:16px;padding:0;margin:0;border-radius:50%;top:calc(50% - 8px);left:48px;border:3px solid #000;content:\"\"}.learner-action-option-list .learner-action-option.show-answer.best:before{border-color:#39aa27}.learner-action-option-list .learner-action-option.show-answer.ok:before{border-color:#f6ad17}.learner-action-option-list .learner-action-option.show-answer.poor:before{border-color:#c5000f}.learner-action-option-list .learner-action-option.show-answer.reflective:before{background:#6592cb}.learner-action-option-list .learner-action-option.review:before{display:block;position:absolute;width:16px;height:16px;padding:0;margin:0;border-radius:50%;top:calc(50% - 8px);left:48px;border:3px solid #000;content:\"\"}.learner-action-option-list .learner-action-option.review.best:before{border-color:#39aa27}.learner-action-option-list .learner-action-option.review.ok:before{border-color:#f6ad17}.learner-action-option-list .learner-action-option.review.poor:before{border-color:#c5000f}.learner-action-option-list .learner-action-option.review.reflective:before{border-color:#6592cb}.learner-action-option-list .learner-action-option.answered{cursor:pointer}.learner-action-option-list .learner-action-option.answered:before{display:block;position:absolute;width:16px;height:16px;padding:0;margin:0;border-radius:50%;top:calc(50% - 8px);left:48px;content:\"\"}.learner-action-option-list .learner-action-option.answered.best:before{background:#39aa27}.learner-action-option-list .learner-action-option.answered.ok:before{background:#f6ad17}.learner-action-option-list .learner-action-option.answered.poor:before{background:#c5000f}.learner-action-option-list .learner-action-option.answered.reflective:before{background:#6592cb}.learner-action-option-list .learner-action-option.answered:after{display:block;position:absolute;font-size:24px;top:calc(50% - 8px);right:3px;display:inline-block;font-family:Guroo-Producer;font-style:normal;font-weight:400;font-variant:normal;line-height:1;text-decoration:inherit;text-rendering:optimizeLegibility;text-transform:none;-moz-osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased;font-smoothing:antialiased;content:\"\\F221\"}.learner-action-option-list .learner-action-option.answered label{cursor:pointer;display:inline-block!important;border-radius:20px}.learner-action-option-list .learner-action-option.speak.selected label,.learner-action-option-list .learner-action-option.speak:last-child label{border-bottom:none!important}.learner-action-option-list .learner-action-option.speak.review-selected input:disabled+label{cursor:pointer}.learner-action-option-list .learner-action-option.behaviour label{border-style:solid;border-width:2px;border-top-color:transparent}.learner-action-option-list .learner-action-option.behaviour input[disabled]+label{color:#999}.learner-action-option-list .learner-action-option.behaviour.review-selected input:disabled+label,.learner-action-option-list .learner-action-option.behaviour.review input:disabled+label{cursor:pointer}.learner-action-option-list.question-checked .learner-action-option.answered label,.learner-action-option-list.question-checked .learner-action-option.rounded label,.learner-action-option-list.question-checked .learner-action-option.selected label{width:auto!important}@media only screen and (max-height:736px) and (orientation:portrait){.learner-action-option-list .learner-action-option.answered:before,.learner-action-option-list .learner-action-option.review-selected:before,.learner-action-option-list .learner-action-option.review:before,.learner-action-option-list .learner-action-option.selected:before,.learner-action-option-list .learner-action-option.show-answer:before{left:24px!important}.learner-action-option-list .learner-action-option.answered:after{right:18px!important}}@media only screen and (max-width:375px) and (max-height:736px) and (orientation:portrait){.learner-action-option-list .learner-action-option.answered:before,.learner-action-option-list .learner-action-option.review-selected:before,.learner-action-option-list .learner-action-option.review:before,.learner-action-option-list .learner-action-option.selected:before,.learner-action-option-list .learner-action-option.show-answer:before{left:24px!important}.learner-action-option-list .learner-action-option.answered:after{right:18px!important}}@media only screen and (min-width:376px) and (max-width:414px) and (max-height:736px) and (orientation:portrait){.learner-action-option-list .learner-action-option.answered:before,.learner-action-option-list .learner-action-option.review-selected:before,.learner-action-option-list .learner-action-option.review:before,.learner-action-option-list .learner-action-option.selected:before,.learner-action-option-list .learner-action-option.show-answer:before{left:24px!important}.learner-action-option-list .learner-action-option.answered:after{right:18px!important}}@media only screen and (max-width:375px) and (min-height:737px) and (max-height:812px) and (orientation:portrait){.learner-action-option-list .learner-action-option.answered:before,.learner-action-option-list .learner-action-option.review-selected:before,.learner-action-option-list .learner-action-option.review:before,.learner-action-option-list .learner-action-option.selected:before,.learner-action-option-list .learner-action-option.show-answer:before{left:24px!important}.learner-action-option-list .learner-action-option.answered:after{right:18px!important}}.learner-action{display:block;padding:0 24px;margin-left:-24px;margin-right:-24px}.learner-action .question-wrapper{position:relative;padding:15px 24px;margin:10px 0;border-radius:5px;background:hsla(0,0%,100%,.9);border:1px solid #d5d5d5;overflow:hidden}.learner-action .question-wrapper.short-response{background:#cde1ec!important;border-color:#666!important}.learner-action .question-wrapper.complete{cursor:pointer}.learner-action .question-wrapper.complete:after{display:block;position:absolute;font-size:24px;top:15px;right:15px;display:inline-block;font-family:Guroo-Producer;font-style:normal;font-weight:400;font-variant:normal;line-height:1;text-decoration:inherit;text-rendering:optimizeLegibility;text-transform:none;-moz-osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased;font-smoothing:antialiased;content:\"\\F221\"}.learner-action .question-wrapper.conversation{padding:0;background:transparent;border:none}.learner-action .question-wrapper.conversation .content-dialogs{display:block;position:relative;width:100%;overflow:hidden}.learner-action .question-wrapper.conversation .content-dialogs .object-container{width:100%}.learner-action .question-wrapper.conversation>:last-child{margin-bottom:0!important}.learner-action .question-wrapper .question-separator{border-bottom:1px solid #d5d5d5;padding:15px 24px 30px!important}.learner-action .content-dialogs .object-container{padding-left:0!important;padding-right:0!important}.learner-action .feedback-panel .object-container{margin-left:0;margin-right:0}.learner-action .feedback-panel .feedback-options-container .object-container{margin-left:-24px;margin-right:-24px}@media only screen and (max-width:375px) and (max-height:736px) and (orientation:portrait){.learner-action .question-wrapper{padding:10px 12px!important;overflow:hidden}.learner-action .question-wrapper.complete:after{right:30px!important}.learner-action .question-wrapper .object-container{padding:0 12px!important}.learner-action .question-wrapper.conversation{padding:0 0 0 12px!important;overflow:visible}.learner-action .question-wrapper.conversation .object-container{padding:10px 12px!important}.learner-action .question-wrapper.conversation .feedback-panel{margin-left:-24px!important;padding-right:24px!important}.learner-action .question-wrapper.conversation .object-container-conversation{margin-left:0!important;margin-right:0!important}.learner-action .question-wrapper.conversation .object-container-conversation .character-expression{left:1px}.learner-action .question-wrapper.conversation .object-container-conversation .character-expression+{left:12px}.learner-action .question-wrapper.conversation .content-dialogs{margin-right:-12px!important;padding-right:0}.learner-action .question-wrapper .feedback-panel .feedback-options-container .object-container{margin-left:-12px;margin-right:-12px}.learner-action .question-wrapper .content-dialogs .object-container{padding-left:0!important;padding-right:0!important}.learner-action .content-area .question-wrapper.conversation .content-dialogs{padding-left:0!important}}@media only screen and (max-height:375px) and (max-width:736px) and (orientation:landscape){.learner-action .question-wrapper{padding:10px 12px!important;overflow:hidden}.learner-action .question-wrapper.complete:after{right:30px!important}.learner-action .question-wrapper .object-container{padding:0 12px!important}.learner-action .question-wrapper.conversation{padding:0 0 0 12px!important;overflow:visible}.learner-action .question-wrapper.conversation .object-container{padding:10px 12px!important}.learner-action .question-wrapper.conversation .feedback-panel{margin-left:-24px!important;padding-right:24px!important}.learner-action .question-wrapper.conversation .object-container-conversation{margin-left:0!important;margin-right:0!important}.learner-action .question-wrapper.conversation .object-container-conversation .character-expression{left:1px}.learner-action .question-wrapper.conversation .object-container-conversation .character-expression+{left:12px}.learner-action .question-wrapper.conversation .content-dialogs{margin-right:-12px!important;padding-right:0}.learner-action .question-wrapper .feedback-panel .feedback-options-container .object-container{margin-left:-12px;margin-right:-12px}.learner-action .question-wrapper .content-dialogs .object-container{padding-left:0!important;padding-right:0!important}.learner-action .content-area .question-wrapper.conversation .content-dialogs{padding-left:0!important}}@media only screen and (min-width:376px) and (max-width:414px) and (max-height:736px) and (orientation:portrait){.learner-action .question-wrapper{padding:10px 12px!important;overflow:hidden}.learner-action .question-wrapper.complete:after{right:30px!important}.learner-action .question-wrapper .object-container{padding:0 12px!important}.learner-action .question-wrapper.conversation{padding:0 0 0 12px!important;overflow:visible}.learner-action .question-wrapper.conversation .object-container{padding:10px 12px!important}.learner-action .question-wrapper.conversation .feedback-panel{margin-left:-24px!important;padding-right:24px!important}.learner-action .question-wrapper.conversation .object-container-conversation{margin-left:0!important;margin-right:0!important}.learner-action .question-wrapper.conversation .object-container-conversation .character-expression{left:1px}.learner-action .question-wrapper.conversation .object-container-conversation .character-expression+{left:12px}.learner-action .question-wrapper.conversation .content-dialogs{margin-right:-12px!important;padding-right:0}.learner-action .question-wrapper .feedback-panel .feedback-options-container .object-container{margin-left:-12px;margin-right:-12px}.learner-action .question-wrapper .content-dialogs .object-container{padding-left:0!important;padding-right:0!important}.learner-action .content-area .question-wrapper.conversation .content-dialogs{padding-left:0!important}}@media only screen and (min-height:376px) and (max-height:414px) and (max-width:736px) and (orientation:landscape){.learner-action .question-wrapper{padding:10px 12px!important;overflow:hidden}.learner-action .question-wrapper.complete:after{right:30px!important}.learner-action .question-wrapper .object-container{padding:0 12px!important}.learner-action .question-wrapper.conversation{padding:0 0 0 12px!important;overflow:visible}.learner-action .question-wrapper.conversation .object-container{padding:10px 12px!important}.learner-action .question-wrapper.conversation .feedback-panel{margin-left:-24px!important;padding-right:24px!important}.learner-action .question-wrapper.conversation .object-container-conversation{margin-left:0!important;margin-right:0!important}.learner-action .question-wrapper.conversation .object-container-conversation .character-expression{left:1px}.learner-action .question-wrapper.conversation .object-container-conversation .character-expression+{left:12px}.learner-action .question-wrapper.conversation .content-dialogs{margin-right:-12px!important;padding-right:0}.learner-action .question-wrapper .feedback-panel .feedback-options-container .object-container{margin-left:-12px;margin-right:-12px}.learner-action .question-wrapper .content-dialogs .object-container{padding-left:0!important;padding-right:0!important}.learner-action .content-area .question-wrapper.conversation .content-dialogs{padding-left:0!important}}@media only screen and (max-width:375px) and (min-height:737px) and (max-height:812px) and (orientation:portrait){.learner-action .question-wrapper{padding:10px 12px!important;overflow:hidden}.learner-action .question-wrapper.complete:after{right:30px!important}.learner-action .question-wrapper .object-container{padding:0 12px!important}.learner-action .question-wrapper.conversation{padding:0 0 0 12px!important;overflow:visible}.learner-action .question-wrapper.conversation .object-container{padding:10px 12px!important}.learner-action .question-wrapper.conversation .feedback-panel{margin-left:-24px!important;padding-right:24px!important}.learner-action .question-wrapper.conversation .object-container-conversation{margin-left:0!important;margin-right:0!important}.learner-action .question-wrapper.conversation .object-container-conversation .character-expression{left:1px}.learner-action .question-wrapper.conversation .object-container-conversation .character-expression+{left:12px}.learner-action .question-wrapper.conversation .content-dialogs{margin-right:-12px!important;padding-right:0}.learner-action .question-wrapper .feedback-panel .feedback-options-container .object-container{margin-left:-12px;margin-right:-12px}.learner-action .question-wrapper .content-dialogs .object-container{padding-left:0!important;padding-right:0!important}.learner-action .content-area .question-wrapper.conversation .content-dialogs{padding-left:0!important}}@media only screen and (min-height:737px) and (max-height:812px) and (max-width:375px) and (orientation:landscape){.learner-action .question-wrapper{padding:10px 12px!important;overflow:hidden}.learner-action .question-wrapper.complete:after{right:30px!important}.learner-action .question-wrapper .object-container{padding:0 12px!important}.learner-action .question-wrapper.conversation{padding:0 0 0 12px!important;overflow:visible}.learner-action .question-wrapper.conversation .object-container{padding:10px 12px!important}.learner-action .question-wrapper.conversation .feedback-panel{margin-left:-24px!important;padding-right:24px!important}.learner-action .question-wrapper.conversation .object-container-conversation{margin-left:0!important;margin-right:0!important}.learner-action .question-wrapper.conversation .object-container-conversation .character-expression{left:1px}.learner-action .question-wrapper.conversation .object-container-conversation .character-expression+{left:12px}.learner-action .question-wrapper.conversation .content-dialogs{margin-right:-12px!important;padding-right:0}.learner-action .question-wrapper .feedback-panel .feedback-options-container .object-container{margin-left:-12px;margin-right:-12px}.learner-action .question-wrapper .content-dialogs .object-container{padding-left:0!important;padding-right:0!important}.learner-action .content-area .question-wrapper.conversation .content-dialogs{padding-left:0!important}}.content-wrapper .learner-action{margin-left:0;margin-right:0}.content-wrapper .learner-action .question-wrapper{padding:15px 0;margin:10px 0;border-radius:5px;background:hsla(0,0%,100%,.9);border:1px solid #d5d5d5;overflow:hidden}.content-wrapper .learner-action .question-wrapper.complete{cursor:pointer}.content-wrapper .learner-action .question-wrapper.complete:after{display:block;position:absolute;font-size:24px;top:15px;right:15px;display:inline-block;font-family:Guroo-Producer;font-style:normal;font-weight:400;font-variant:normal;line-height:1;text-decoration:inherit;text-rendering:optimizeLegibility;text-transform:none;-moz-osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased;font-smoothing:antialiased;content:\"\\F221\"}.content-wrapper .learner-action .question-wrapper.short-response{background:#cde1ec!important;border-color:#666!important}.content-wrapper .learner-action .question-wrapper .grid-choice-option-list{margin:0 12px}.content-wrapper .learner-action .question-wrapper .feedback-panel{margin:0 24px}.content-wrapper .learner-action .question-wrapper .badge-wrapper{display:block;position:relative;overflow:hidden;margin:0 24px}.content-wrapper .learner-action .question-wrapper.conversation{padding:0 0 0 24px;background:transparent;border:none}.content-wrapper .learner-action .question-wrapper.conversation .object-container-conversation.customer-has-expression{margin-left:0!important}.content-wrapper .learner-action .question-wrapper.conversation .feedback-panel{margin:0 0 10px!important;border-left-style:solid;border-left-width:2px;border-right-style:solid;border-right-width:2px}.content-wrapper .learner-action .question-wrapper.conversation .object-container{padding:0}@media only screen and (max-width:375px) and (max-height:736px) and (orientation:portrait){.content-wrapper .learner-action .question-wrapper{padding-left:0!important;padding-right:0!important;overflow:hidden}.content-wrapper .learner-action .question-wrapper.complete:after{right:10px!important}.content-wrapper .learner-action .question-wrapper .object-container{padding:0 12px!important}.content-wrapper .learner-action .question-wrapper .question-prompt.object-container{padding:0 24px 0 12px!important}.content-wrapper .learner-action .question-wrapper.conversation .object-container{padding:10px 12px!important}.content-wrapper .learner-action .question-wrapper.conversation .feedback-panel{margin:0!important;padding:10px 12px}.content-wrapper .learner-action .question-wrapper .feedback-panel{margin:0;padding:10px 12px}.content-wrapper .learner-action .question-wrapper .feedback-panel .feedback-options-container .object-container{margin-left:-12px;margin-right:-12px}}@media only screen and (max-height:375px) and (max-width:736px) and (orientation:landscape){.content-wrapper .learner-action .question-wrapper{padding-left:0!important;padding-right:0!important;overflow:hidden}.content-wrapper .learner-action .question-wrapper.complete:after{right:10px!important}.content-wrapper .learner-action .question-wrapper .object-container{padding:0 12px!important}.content-wrapper .learner-action .question-wrapper .question-prompt.object-container{padding:0 24px 0 12px!important}.content-wrapper .learner-action .question-wrapper.conversation .object-container{padding:10px 12px!important}.content-wrapper .learner-action .question-wrapper.conversation .feedback-panel{margin:0!important;padding:10px 12px}.content-wrapper .learner-action .question-wrapper .feedback-panel{margin:0;padding:10px 12px}.content-wrapper .learner-action .question-wrapper .feedback-panel .feedback-options-container .object-container{margin-left:-12px;margin-right:-12px}}@media only screen and (min-width:376px) and (max-width:414px) and (max-height:736px) and (orientation:portrait){.content-wrapper .learner-action .question-wrapper{padding-left:0!important;padding-right:0!important;overflow:hidden}.content-wrapper .learner-action .question-wrapper.complete:after{right:10px!important}.content-wrapper .learner-action .question-wrapper .object-container{padding:0 12px!important}.content-wrapper .learner-action .question-wrapper .question-prompt.object-container{padding:0 24px 0 12px!important}.content-wrapper .learner-action .question-wrapper.conversation .object-container{padding:10px 12px!important}.content-wrapper .learner-action .question-wrapper.conversation .feedback-panel{margin:0!important;padding:10px 12px}.content-wrapper .learner-action .question-wrapper .feedback-panel{margin:0;padding:10px 12px}.content-wrapper .learner-action .question-wrapper .feedback-panel .feedback-options-container .object-container{margin-left:-12px;margin-right:-12px}}@media only screen and (min-height:376px) and (max-height:414px) and (max-width:736px) and (orientation:landscape){.content-wrapper .learner-action .question-wrapper{padding-left:0!important;padding-right:0!important;overflow:hidden}.content-wrapper .learner-action .question-wrapper.complete:after{right:10px!important}.content-wrapper .learner-action .question-wrapper .object-container{padding:0 12px!important}.content-wrapper .learner-action .question-wrapper .question-prompt.object-container{padding:0 24px 0 12px!important}.content-wrapper .learner-action .question-wrapper.conversation .object-container{padding:10px 12px!important}.content-wrapper .learner-action .question-wrapper.conversation .feedback-panel{margin:0!important;padding:10px 12px}.content-wrapper .learner-action .question-wrapper .feedback-panel{margin:0;padding:10px 12px}.content-wrapper .learner-action .question-wrapper .feedback-panel .feedback-options-container .object-container{margin-left:-12px;margin-right:-12px}}@media only screen and (max-width:375px) and (min-height:737px) and (max-height:812px) and (orientation:portrait){.content-wrapper .learner-action .question-wrapper{padding-left:0!important;padding-right:0!important;overflow:hidden}.content-wrapper .learner-action .question-wrapper.complete:after{right:10px!important}.content-wrapper .learner-action .question-wrapper .object-container{padding:0 12px!important}.content-wrapper .learner-action .question-wrapper .question-prompt.object-container{padding:0 24px 0 12px!important}.content-wrapper .learner-action .question-wrapper.conversation .object-container{padding:10px 12px!important}.content-wrapper .learner-action .question-wrapper.conversation .feedback-panel{margin:0!important;padding:10px 12px}.content-wrapper .learner-action .question-wrapper .feedback-panel{margin:0;padding:10px 12px}.content-wrapper .learner-action .question-wrapper .feedback-panel .feedback-options-container .object-container{margin-left:-12px;margin-right:-12px}}@media only screen and (min-height:737px) and (max-height:812px) and (max-width:375px) and (orientation:landscape){.content-wrapper .learner-action .question-wrapper{padding-left:0!important;padding-right:0!important;overflow:hidden}.content-wrapper .learner-action .question-wrapper.complete:after{right:10px!important}.content-wrapper .learner-action .question-wrapper .object-container{padding:0 12px!important}.content-wrapper .learner-action .question-wrapper .question-prompt.object-container{padding:0 24px 0 12px!important}.content-wrapper .learner-action .question-wrapper.conversation .object-container{padding:10px 12px!important}.content-wrapper .learner-action .question-wrapper.conversation .feedback-panel{margin:0!important;padding:10px 12px}.content-wrapper .learner-action .question-wrapper .feedback-panel{margin:0;padding:10px 12px}.content-wrapper .learner-action .question-wrapper .feedback-panel .feedback-options-container .object-container{margin-left:-12px;margin-right:-12px}}@media only screen and (max-width:320px) and (max-height:568px) and (orientation:portrait){.content-wrapper .learner-action .question-wrapper{padding-left:0!important;padding-right:0!important;overflow:hidden}.content-wrapper .learner-action .question-wrapper.complete:after{right:10px!important}.content-wrapper .learner-action .question-wrapper .object-container{padding:0 12px!important}.content-wrapper .learner-action .question-wrapper .question-prompt.object-container{padding:0 24px 0 12px!important}.content-wrapper .learner-action .question-wrapper.conversation .object-container{padding:10px 12px!important}.content-wrapper .learner-action .question-wrapper.conversation .feedback-panel{margin:0!important;padding:10px 12px}.content-wrapper .learner-action .question-wrapper .feedback-panel{margin:0;padding:10px 12px}.content-wrapper .learner-action .question-wrapper .feedback-panel .feedback-options-container .object-container{margin-left:-12px;margin-right:-12px}}.content-wrapper .content-dialogs{padding-left:24px;padding-right:24px}.content-wrapper .content-dialogs .object-container{padding-left:0;padding-right:0}.learner-action-response-list{display:block;margin:0 0 30px;padding:0;clear:both}.learner-action-response-list .learner-action-response{position:relative;display:block;list-style-type:none;margin:0;overflow:hidden;padding:0}.learner-action-response-list .learner-action-response .response-label{display:inline-block;overflow:hidden;margin:0;font-weight:400;padding:14px 24px;line-height:130%;transition:opacity .3s ease,border-radius .6s ease,color .2s ease;max-width:80%}.learner-action-response-list .learner-action-response .response-label.behaviour{border-top-left-radius:20px;border-top-right-radius:20px;border-bottom-right-radius:20px;border-style:solid;border-width:2px}.learner-action-response-list .learner-action-response .response-label.speak{border-top-left-radius:20px;border-top-right-radius:20px;border-bottom-right-radius:20px}.feedback-panel{display:block;clear:both;overflow:hidden;border:2px solid;padding:16px 24px;margin:0;border-radius:4px;position:relative!important}.feedback-panel p{line-height:130%;padding:0 0 10px}.feedback-panel.best{background:#edffef;border-color:#39aa27}.feedback-panel.best .feedback-options-panel{border-color:#39aa27}.feedback-panel.ok{background:#fef8e2}.feedback-panel.ok,.feedback-panel.ok .feedback-options-panel{border-color:#f6ad17}.feedback-panel.poor{background:#ffecf8;border-color:#c5000f}.feedback-panel.poor .feedback-options-panel{border-color:#c5000f}.feedback-panel.reflective{background:#d8e4f2;border-color:#6592cb}.feedback-panel.reflective .feedback-options-panel{border-color:#6592cb}.feedback-panel .feedback-character-col{display:none}.feedback-panel .feedback-character-content-col{margin-left:0;bottom:0;width:100%;transition:height 1s ease-out}.feedback-panel .feedback-character-content-col *{margin-bottom:10px}.feedback-panel .feedback-character-content-col * *,.feedback-panel .feedback-character-content-col :last-child{margin-bottom:0}.feedback-panel .feedback-content-col{margin-left:0;top:0;width:100%;clear:both;transition:height 1s ease-out}.feedback-panel .feedback-content-col *{margin-bottom:10px}.feedback-panel .feedback-content-col * *,.feedback-panel .feedback-content-col :last-child{margin-bottom:0}.feedback-panel.review{margin-bottom:20px}.feedback-panel.review .feedback-character-col{display:block;float:left;width:15%;height:inherit;z-index:2}.feedback-panel.review .feedback-character-col img{width:120%;margin-left:-25%;height:auto}.feedback-panel.review .feedback-character-content-col{margin-left:15%;padding-bottom:10px;top:0;width:85%;height:100%;z-index:3;overflow:hidden;transition:height 1s ease-out}.feedback-panel .object-container{margin-left:-24px;margin-right:-24px}.feedback-panel .feedback-image{text-align:center}.feedback-panel .feedback-image .image-container{display:inline-block;text-align:center;background:#fff;border-radius:5px;padding:16px 24px;min-width:calc(50% - 1em);margin:0 10px 10px auto!important}.feedback-panel .feedback-image .image-container img{max-width:100%;height:auto;max-height:200px!important;margin:0 auto}@media only screen and (max-width:375px) and (max-height:736px) and (orientation:portrait){.feedback-panel{margin:0 -12px;border-radius:0;border-left:none;border-right:none}.feedback-panel.review{margin-bottom:0}.feedback-panel .feedback-character-col{position:relative;display:block;float:left;width:15%;height:inherit;z-index:2}.feedback-panel .feedback-character-col img{bottom:0;left:0;width:120%;margin-left:-25%;height:auto}.feedback-panel .feedback-character-content-col{margin-left:15%;top:0;width:85%;height:inherit;z-index:3;overflow-y:scroll;transition:height 1s ease-out}.feedback-panel .feedback-content-col{clear:both;margin-left:0;top:0;padding-top:10px;width:100%;height:inherit;z-index:3;transition:height 1s ease-out}.feedback-panel .object-container{margin-left:-12px;margin-right:-12px}}@media only screen and (max-height:375px) and (max-width:736px) and (orientation:landscape){.feedback-panel{margin:0 -12px;border-radius:0;border-left:none;border-right:none}}@media only screen and (min-width:376px) and (max-width:414px) and (max-height:736px) and (orientation:portrait){.feedback-panel{margin:0 -12px;border-radius:0;border-left:none;border-right:none}.feedback-panel.review{margin-bottom:0}.feedback-panel .feedback-character-col{position:relative;display:block;float:left;width:15%;height:inherit;z-index:2}.feedback-panel .feedback-character-col img{bottom:0;left:0;width:120%;margin-left:-25%;height:auto}.feedback-panel .feedback-character-content-col{margin-left:15%;top:0;width:85%;height:inherit;z-index:3;overflow-y:scroll;transition:height 1s ease-out}.feedback-panel .feedback-content-col{clear:both;margin-left:0;top:0;padding-top:10px;width:100%;height:inherit;z-index:3;transition:height 1s ease-out}.feedback-panel .object-container{margin-left:-12px;margin-right:-12px}}@media only screen and (min-height:376px) and (max-height:414px) and (max-width:736px) and (orientation:landscape){.feedback-panel{margin:0 -12px;border-radius:0;border-left:none;border-right:none}}@media only screen and (max-width:375px) and (min-height:737px) and (max-height:812px) and (orientation:portrait){.feedback-panel{margin:0 -12px;border-radius:0;border-left:none;border-right:none}.feedback-panel.review{margin-bottom:0}.feedback-panel .feedback-character-col{position:relative;display:block;float:left;width:15%;height:inherit;z-index:2}.feedback-panel .feedback-character-col img{bottom:0;left:0;width:120%;margin-left:-25%;height:auto}.feedback-panel .feedback-character-content-col{margin-left:15%;top:0;width:85%;height:inherit;z-index:3;overflow-y:scroll;transition:height 1s ease-out}.feedback-panel .feedback-content-col{clear:both;margin-left:0;top:0;padding-top:10px;width:100%;height:inherit;z-index:3;transition:height 1s ease-out}.feedback-panel .object-container{margin-left:-12px;margin-right:-12px}}@media only screen and (min-width:737px) and (max-width:812px) and (max-height:375px) and (orientation:landscape){.feedback-panel{margin:0 -12px;border-radius:0;border-left:none;border-right:none}}.vertical-spacer{clear:both;margin:20px 0}.object-container-no-margin,.vertical-spacer{display:block;position:relative;overflow:hidden}.object-container-no-margin{margin:0}.object-container{display:block;position:relative;overflow:hidden;margin:0 0 20px}.object-container.no-btm-margin{margin-bottom:0}.action-btn{margin:20px 0}.action-btn.icon-button{position:relative;font-size:130%;padding-right:40px}.action-btn.icon-button .icon{top:5px;right:10px;position:absolute;font-size:180%;line-height:0}.action-btn:hover{opacity:.7}.continue-btn{margin-top:0;margin-bottom:0;transition:opacity .3s ease;position:relative;padding-right:50px}.continue-btn:after{position:absolute;display:inline-block;font-family:Guroo-Producer;font-style:normal;font-weight:400;font-variant:normal;line-height:1;text-decoration:inherit;text-rendering:optimizeLegibility;text-transform:none;-moz-osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased;font-smoothing:antialiased;top:0;bottom:0;margin:auto;right:10px;font-size:32px;height:32px;content:\"\\F113\"}.continue-btn:hover{opacity:.7}.back-btn{margin-top:0;margin-bottom:0;transition:opacity .3s ease;position:relative;padding:5px}.back-btn:before{position:relative;display:inline-block;font-family:Guroo-Producer;font-style:normal;font-weight:400;font-variant:normal;line-height:1;text-decoration:inherit;text-rendering:optimizeLegibility;text-transform:none;-moz-osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased;font-smoothing:antialiased;font-size:180%;content:\"\\F112\"}.back-btn:hover{opacity:.7}.save-btn{margin-top:0;margin-bottom:0;transition:opacity .3s ease;position:relative}.save-btn:before{position:relative;display:inline-block;font-family:Guroo-Producer;font-style:normal;font-weight:400;font-variant:normal;line-height:1;text-decoration:inherit;text-rendering:optimizeLegibility;text-transform:none;-moz-osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased;font-smoothing:antialiased;font-size:100%;content:\"\\F1CA\";padding:0 10px 0 0}.save-btn:hover{opacity:.7}.print-btn{margin-top:0;margin-bottom:0;transition:opacity .3s ease;position:relative}.print-btn:before{position:relative;display:inline-block;font-family:Guroo-Producer;font-style:normal;font-weight:400;font-variant:normal;line-height:1;text-decoration:inherit;text-rendering:optimizeLegibility;text-transform:none;-moz-osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased;font-smoothing:antialiased;padding:0 10px 0 0;font-size:100%;content:\"\\F1C9\"}.print-btn:hover{opacity:.7}.video-container{display:block;position:relative;overflow:hidden;margin:10px auto!important;margin-top:0!important;margin-bottom:0!important;border-radius:5px}.video-container:hover{cursor:pointer}.video-container:hover .video-controls:before{-webkit-box-shadow:0 0 10px 3px #ead146;-moz-box-shadow:0 0 10px 3px #ead146;box-shadow:0 0 10px 3px #ead146}.video-container:focus{cursor:pointer}.video-container:focus .video-controls:before{-webkit-box-shadow:0 0 10px 3px #ead146;-moz-box-shadow:0 0 10px 3px #ead146;box-shadow:0 0 10px 3px #ead146}.video-container .video-thumbnail-wrapper{display:block;float:left;margin:0 auto;position:relative;width:33.333%;background:#d5d5d5;cursor:pointer;border-top-left-radius:5px;border-bottom-left-radius:5px}.video-container .video-thumbnail-wrapper .video-controls{position:relative;margin:0;padding:0;cursor:pointer}.video-container .video-thumbnail-wrapper .video-controls:before{background:hsla(0,0%,100%,.5);position:absolute;top:0;left:0;right:0;bottom:0;margin:auto;font-size:40px;border-radius:50%;padding:0;line-height:0;width:60px;height:60px;content:\"\";border:3px solid #fff}.video-container .video-thumbnail-wrapper .video-controls:after{height:40px;width:40px;position:absolute;top:0;left:0;right:0;bottom:0;margin:auto;font-size:40px}.video-container .video-thumbnail-wrapper .video-controls.play{display:block}.video-container .video-thumbnail-wrapper .video-controls.play:after{display:inline-block;font-family:Guroo-Producer;font-style:normal;font-weight:400;font-variant:normal;line-height:1;text-decoration:inherit;text-rendering:optimizeLegibility;text-transform:none;-moz-osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased;font-smoothing:antialiased;content:\"\\F136\"}.video-container .video-thumbnail-wrapper .video-controls.replay{display:block}.video-container .video-thumbnail-wrapper .video-controls.replay:after{display:inline-block;font-family:Guroo-Producer;font-style:normal;font-weight:400;font-variant:normal;line-height:1;text-decoration:inherit;text-rendering:optimizeLegibility;text-transform:none;-moz-osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased;font-smoothing:antialiased;content:\"\\F1AA\"}.video-container .video-thumbnail-wrapper .video-controls img{width:100%;height:auto;border-right:3px solid #fff;border-top-left-radius:5px;border-bottom-left-radius:5px}@media (min-width:320px) and (max-width:480px){.video-container .video-thumbnail-wrapper{float:none;width:100%}}.video-container .video-wrapper{display:block;float:left;margin:0 auto;position:relative;width:33.333%;padding-bottom:19%;height:0}.video-container .video-wrapper iframe{position:absolute;top:0;left:0;width:100%;height:100%;border:none}.video-container .video-details{margin-left:34%;padding:12px 16px;font-size:90%}.video-container .video-details h4{font-size:110%;position:relative;color:#fff;cursor:pointer}.video-container .video-details h4.not-viewed{padding:0 0 0 20px}.video-container .video-details h4.not-viewed:before{position:absolute;left:-2px;top:0;bottom:0;margin:auto;font-size:16px;height:16px;color:#999;padding-right:10px;display:inline-block;font-family:Guroo-Producer;font-style:normal;font-weight:400;font-variant:normal;line-height:1;text-decoration:inherit;text-rendering:optimizeLegibility;text-transform:none;-moz-osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased;font-smoothing:antialiased;content:\"\\F16A\"}.video-container .video-details h4.viewed{padding:0 0 0 20px}.video-container .video-details h4.viewed:before{position:absolute;left:-2px;top:0;bottom:0;margin:auto;font-size:16px;height:16px;color:#39aa27;padding-right:10px;display:inline-block;font-family:Guroo-Producer;font-style:normal;font-weight:400;font-variant:normal;line-height:1;text-decoration:inherit;text-rendering:optimizeLegibility;text-transform:none;-moz-osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased;font-smoothing:antialiased;content:\"\\F16F\"}@media (min-width:320px) and (max-width:480px){.video-container .video-details{margin-left:0}}.video-container.playing{display:block}.video-container.playing .video-wrapper{display:block;position:relative;width:100%;padding-bottom:56.25%;padding-top:25px;height:0;float:none}.video-container.playing .video-details{display:none}.videoInfo{padding:8px 12px;font-size:90%}@media only screen and (max-width:375px) and (max-height:736px) and (orientation:portrait){.videoInfo{display:none}}@media only screen and (min-width:376px) and (max-width:414px) and (max-height:736px) and (orientation:portrait){.videoInfo{display:none}}@media only screen and (max-width:375px) and (min-height:737px) and (max-height:812px) and (orientation:portrait){.videoInfo{display:none}}.video-instructions{width:100%;padding:8px 12px;text-align:center;font-size:90%;color:#999;font-style:italic}.tabbed-content{display:block;position:relative;overflow:hidden;width:100%;height:100%}.tabbed-content .tab-list,.tabbed-content .tab-list .tab-item-wrapper{display:-webkit-flex;display:flex;flex-flow:row nowrap;align-items:center;width:100%;margin:0;padding:0}.tabbed-content .tab-list .tab-item{position:relative;text-align:left;display:-webkit-flex;display:flex;flex-flow:row nowrap;align-items:center;border-style:solid;border-width:0 0 1px 1px;padding:0 12px;height:60px;cursor:pointer;overflow:hidden;flex:1;transition:background .5s ease,color .5s ease}.tabbed-content .tab-list .tab-item.active:after,.tabbed-content .tab-list .tab-item:focus:after{display:block;position:absolute;height:6px;width:100%;top:0;left:0;content:\"\"}.tabbed-content .tab-list .tab-item.disabled:hover{cursor:not-allowed;background:transparent}.tabbed-content .tab-list .tab-item.incomplete:before{color:#999;content:\"\\F16A\"}.tabbed-content .tab-list .tab-item.complete:before,.tabbed-content .tab-list .tab-item.incomplete:before{position:relative;padding-right:5px;font-size:16px;display:inline-block;font-family:Guroo-Producer;font-style:normal;font-weight:400;font-variant:normal;line-height:1;text-decoration:inherit;text-rendering:optimizeLegibility;text-transform:none;-moz-osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased;font-smoothing:antialiased}.tabbed-content .tab-list .tab-item.complete:before{color:#39aa27;content:\"\\F16F\"}.tabbed-content .tab-list .tab-item .tab-label{position:relative;overflow:hidden}.tabbed-content .tab-list .tab-item .tab-label a,.tabbed-content .tab-list .tab-item .tab-label div,.tabbed-content .tab-list .tab-item .tab-label h1,.tabbed-content .tab-list .tab-item .tab-label h2,.tabbed-content .tab-list .tab-item .tab-label h3,.tabbed-content .tab-list .tab-item .tab-label h4,.tabbed-content .tab-list .tab-item .tab-label h5,.tabbed-content .tab-list .tab-item .tab-label li,.tabbed-content .tab-list .tab-item .tab-label p,.tabbed-content .tab-list .tab-item .tab-label span{height:100%;width:100%;overflow:hidden;display:block;white-space:nowrap;text-overflow:ellipsis}.tabbed-content .tab-list .tab-item .tab-icon img{height:38px}.tabbed-content .tab-list.icon-list .tab-item.incomplete:before{color:#999;content:\"\\F16A\"}.tabbed-content .tab-list.icon-list .tab-item.complete:before,.tabbed-content .tab-list.icon-list .tab-item.incomplete:before{position:absolute;left:6px;top:6px;height:16px;width:16px;background:#fff;border-radius:50%;font-size:16px;display:inline-block;font-family:Guroo-Producer;font-style:normal;font-weight:400;font-variant:normal;line-height:1;text-decoration:inherit;text-rendering:optimizeLegibility;text-transform:none;-moz-osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased;font-smoothing:antialiased}.tabbed-content .tab-list.icon-list .tab-item.complete:before{color:#39aa27;content:\"\\F16F\"}.tabbed-content .tab-list.icon-list .tab-item .tab-label{padding-left:12px;line-height:110%;font-size:100%}.tabbed-content .tabbed-body-content{display:block;position:relative;overflow:hidden;height:calc(100% - 60px);overflow:hidden!important}.tabbed-content .tabbed-body-content .content-wrapper,.tabbed-content .tabbed-body-content .content-wrapper .content-area{height:100%;width:100%;margin:0 auto;box-shadow:none}.tabbed-content .tabbed-body-content .content-wrapper-background{-webkit-clip-path:none!important;clip-path:none!important}.tabbed-content.floating{height:calc(100% - 60px);width:calc(100% - 60px);margin:30px auto;max-width:1100px;border-radius:5px;-webkit-box-shadow:0 5px 5px 0 rgba(0,0,0,.25);-moz-box-shadow:0 5px 5px 0 rgba(0,0,0,.25);box-shadow:0 5px 5px 0 rgba(0,0,0,.25)}.tabbed-content.floating .object-feed{box-shadow:none!important;-webkit-box-shadow:none!important;-moz-box-shadow:none!important}.tabbed-content.floating .tab-item:first-child{border-left:none;border-top-left-radius:5px}.tabbed-content.floating .tab-item:first-child.active:after{border-top-left-radius:5px;content:\"\"}.tabbed-content.floating .tab-item:last-child{border-right:none;border-top-right-radius:5px}.tabbed-content.floating .tab-item:last-child.active:after{border-top-right-radius:5px;content:\"\"}.tabbed-content-vertical{display:-webkit-flex;display:flex;flex-flow:row nowrap;width:100%;height:100%}.tabbed-content-vertical .tab-list{overflow:hidden;flex:1;margin:0;padding:0;border-top-left-radius:5px;border-bottom-left-radius:5px}.tabbed-content-vertical .tab-list .tab-item-wrapper{margin:0}.tabbed-content-vertical .tab-list .tab-item{display:-webkit-flex;display:flex;flex-flow:row nowrap;align-items:center;overflow:hidden;flex:1;text-align:left;position:relative;vertical-align:middle;border-style:solid;border-width:0 0 1px;padding:18px 16px 18px 18px;cursor:pointer;transition:background .5s ease,color .5s ease}.tabbed-content-vertical .tab-list .tab-item.active:after,.tabbed-content-vertical .tab-list .tab-item:focus:after{display:block;position:absolute;width:6px;height:100%;top:0;left:0;content:\"\"}.tabbed-content-vertical .tab-list .tab-item:last-child{border-top:none}.tabbed-content-vertical .tab-list .tab-item:last-child.active:after{content:\"\"}.tabbed-content-vertical .tab-list .tab-item.disabled:hover{cursor:not-allowed;background:transparent}.tabbed-content-vertical .tab-list .tab-item.incomplete:before{color:#999;content:\"\\F16A\"}.tabbed-content-vertical .tab-list .tab-item.complete:before,.tabbed-content-vertical .tab-list .tab-item.incomplete:before{position:relative;padding-right:5px;font-size:16px;display:inline-block;font-family:Guroo-Producer;font-style:normal;font-weight:400;font-variant:normal;line-height:1;text-decoration:inherit;text-rendering:optimizeLegibility;text-transform:none;-moz-osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased;font-smoothing:antialiased}.tabbed-content-vertical .tab-list .tab-item.complete:before{color:#39aa27;content:\"\\F16F\"}.tabbed-content-vertical .tab-list .tab-item .tab-icon img{height:38px}.tabbed-content-vertical .tab-list .tab-item .tab-label{position:relative;overflow:hidden}.tabbed-content-vertical .tab-list .tab-item .tab-label a,.tabbed-content-vertical .tab-list .tab-item .tab-label div,.tabbed-content-vertical .tab-list .tab-item .tab-label h1,.tabbed-content-vertical .tab-list .tab-item .tab-label h2,.tabbed-content-vertical .tab-list .tab-item .tab-label h3,.tabbed-content-vertical .tab-list .tab-item .tab-label h4,.tabbed-content-vertical .tab-list .tab-item .tab-label h5,.tabbed-content-vertical .tab-list .tab-item .tab-label li,.tabbed-content-vertical .tab-list .tab-item .tab-label p,.tabbed-content-vertical .tab-list .tab-item .tab-label span{height:100%;width:100%;overflow:hidden;display:block;white-space:nowrap;text-overflow:ellipsis}.tabbed-content-vertical .tab-list.icon-list .tab-item.incomplete:before{color:#999;content:\"\\F16A\"}.tabbed-content-vertical .tab-list.icon-list .tab-item.complete:before,.tabbed-content-vertical .tab-list.icon-list .tab-item.incomplete:before{position:absolute;left:12px;top:12px;height:16px;width:16px;background:#fff;border-radius:50%;font-size:16px;display:inline-block;font-family:Guroo-Producer;font-style:normal;font-weight:400;font-variant:normal;line-height:1;text-decoration:inherit;text-rendering:optimizeLegibility;text-transform:none;-moz-osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased;font-smoothing:antialiased}.tabbed-content-vertical .tab-list.icon-list .tab-item.complete:before{color:#39aa27;content:\"\\F16F\"}.tabbed-content-vertical .tab-list.icon-list .tab-item .tab-label{padding-left:12px;line-height:110%;font-size:100%}.tabbed-content-vertical .tabbed-body-content{flex:3;display:-webkit-flex;display:flex;flex-flow:column nowrap;border-top-right-radius:5px;border-bottom-right-radius:5px;height:100%;overflow:hidden!important}.tabbed-content-vertical .tabbed-body-content .content-screen,.tabbed-content-vertical .tabbed-body-content .customer-scenario{flex:1;position:relative;display:-webkit-flex;display:flex;flex-flow:column nowrap}.tabbed-content-vertical .tabbed-body-content .content-wrapper{height:100%;width:inherit;margin:0 auto;box-shadow:none;border-top-right-radius:5px;border-bottom-right-radius:5px}.tabbed-content-vertical .tabbed-body-content .content-wrapper .content-area{height:100%;width:100%;border-top-right-radius:5px;border-bottom-right-radius:5px;margin:0 auto;box-shadow:none}.tabbed-content-vertical .tabbed-body-content .content-wrapper-background{-webkit-clip-path:none!important;clip-path:none!important}.tabbed-content-vertical .tabbed-body-content .video-content-wrapper .content-row{align-items:flex-start!important}.tabbed-content-vertical .tabbed-body-content .video-content-wrapper .video-object-wrapper .video-col.single{padding:0 10px!important}.tabbed-content-vertical .tabbed-body-content .close_up img{width:150%!important;left:-25%!important}.tabbed-content-vertical.floating{height:calc(100% - 60px);width:calc(100% - 60px);margin:30px auto;max-width:1100px;border-radius:5px;-webkit-box-shadow:0 5px 5px 0 rgba(0,0,0,.25);-moz-box-shadow:0 5px 5px 0 rgba(0,0,0,.25);box-shadow:0 5px 5px 0 rgba(0,0,0,.25)}.tabbed-content-vertical.floating .object-feed{box-shadow:none!important;-webkit-box-shadow:none!important;-moz-box-shadow:none!important}.tabbed-content-vertical.floating:first-child{border-top:none;border-top-left-radius:5px}.tabbed-content-vertical.floating:first-child.active:after{content:\"\";border-top-left-radius:5px}.tabbed-content-process-horizontal{display:block;position:relative;overflow:hidden;height:calc(100% - 60px);width:calc(100% - 60px);margin:30px auto;max-width:1100px;border-radius:5px;-webkit-box-shadow:0 5px 5px 0 rgba(0,0,0,.25);-moz-box-shadow:0 5px 5px 0 rgba(0,0,0,.25);box-shadow:0 5px 5px 0 rgba(0,0,0,.25)}.tabbed-content-process-horizontal .object-feed{box-shadow:none!important;-webkit-box-shadow:none!important;-moz-box-shadow:none!important}.tabbed-content-process-horizontal .tab-list{width:100%;margin:auto;padding:0;height:70px}.tabbed-content-process-horizontal .tab-list .tab-item-wrapper{display:-webkit-flex;display:flex;flex-flow:row nowrap;align-items:center;justify-content:center;width:100%;overflow:hidden;margin:auto;padding:0;height:70px}.tabbed-content-process-horizontal .tab-list .tab-item{position:relative;display:-webkit-flex;display:flex;flex-flow:row nowrap;align-items:center;padding:10px 6px 10px 48px;margin:0 15px 0 10px;cursor:pointer;height:50px;transition:background .5s ease,color .5s ease}.tabbed-content-process-horizontal .tab-list .tab-item .pre-shape{display:block;position:absolute;width:25px;height:50px;border-top:25px solid transparent;border-bottom:25px solid transparent;border-left:25px solid #fff;left:0!important;top:0}.tabbed-content-process-horizontal .tab-list .tab-item .pre-shape:before{content:\"\";display:block;position:absolute;width:25px;height:50px;border-top:25px solid transparent;border-bottom:25px solid transparent;border-left-width:25px;border-left-style:solid;z-index:1;left:-24px;top:-27px}.tabbed-content-process-horizontal .tab-list .tab-item .pre-shape:after{content:\"\";display:block;position:absolute;width:22px;height:44px;border-top:22px solid transparent;border-bottom:22px solid transparent;border-left-width:22px;border-left-style:solid;border-left-color:#fff;z-index:2;left:-24px;top:-24px}.tabbed-content-process-horizontal .tab-list .tab-item .post-shape{right:-25px!important;top:0;z-index:100;transition:border-left-color .5s ease,color .5s ease}.tabbed-content-process-horizontal .tab-list .tab-item .post-shape,.tabbed-content-process-horizontal .tab-list .tab-item .post-shape:before{display:block;position:absolute;width:25px;height:50px;border-top:25px solid transparent;border-bottom:25px solid transparent;border-left-width:25px;border-left-style:solid}.tabbed-content-process-horizontal .tab-list .tab-item .post-shape:before{content:\"\";border-left-color:#6592cb;z-index:1;right:0;top:-27px}.tabbed-content-process-horizontal .tab-list .tab-item .post-shape:after{content:\"\";display:block;position:absolute;width:22px;height:44px;border-top:22px solid transparent;border-bottom:22px solid transparent;border-left-width:22px;border-left-style:solid;border-left-color:#eff0f2;z-index:1;right:3px;top:-24px}.tabbed-content-process-horizontal .tab-list .tab-item.incomplete:before{content:\"\\F16A\"}.tabbed-content-process-horizontal .tab-list .tab-item.complete:before,.tabbed-content-process-horizontal .tab-list .tab-item.incomplete:before{z-index:2;position:absolute;left:36px;top:0;bottom:0;height:16px;margin:auto;font-size:16px;display:inline-block;font-family:Guroo-Producer;font-style:normal;font-weight:400;font-variant:normal;line-height:1;text-decoration:inherit;text-rendering:optimizeLegibility;text-transform:none;-moz-osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased;font-smoothing:antialiased}.tabbed-content-process-horizontal .tab-list .tab-item.complete:before{content:\"\\F16F\"}.tabbed-content-process-horizontal .tab-list .tab-item:first-child{margin-left:0;padding:10px 6px 10px 24px;border-bottom-left-radius:5px;border-top-left-radius:5px}.tabbed-content-process-horizontal .tab-list .tab-item:first-child .pre-shape{display:none!important}.tabbed-content-process-horizontal .tab-list .tab-item:first-child.complete:before,.tabbed-content-process-horizontal .tab-list .tab-item:first-child.incomplete:before{left:12px}.tabbed-content-process-horizontal .tab-list .tab-item.disabled:hover{cursor:not-allowed}.tabbed-content-process-horizontal .tab-list .tab-item .tab-label{padding-left:12px;line-height:110%;font-size:90%;position:relative;overflow:hidden}.tabbed-content-process-horizontal .tab-list .tab-item .tab-label a,.tabbed-content-process-horizontal .tab-list .tab-item .tab-label div,.tabbed-content-process-horizontal .tab-list .tab-item .tab-label h1,.tabbed-content-process-horizontal .tab-list .tab-item .tab-label h2,.tabbed-content-process-horizontal .tab-list .tab-item .tab-label h3,.tabbed-content-process-horizontal .tab-list .tab-item .tab-label h4,.tabbed-content-process-horizontal .tab-list .tab-item .tab-label h5,.tabbed-content-process-horizontal .tab-list .tab-item .tab-label li,.tabbed-content-process-horizontal .tab-list .tab-item .tab-label p,.tabbed-content-process-horizontal .tab-list .tab-item .tab-label span{height:100%;width:100%;overflow:hidden;display:block;white-space:nowrap;text-overflow:ellipsis}.tabbed-content-process-horizontal .tab-list.icon-list .tab-item{padding:10px 6px 10px 36px}.tabbed-content-process-horizontal .tab-list.icon-list .tab-item.incomplete:before{display:inline-block;content:\"\\F16A\";color:#999}.tabbed-content-process-horizontal .tab-list.icon-list .tab-item.complete:before,.tabbed-content-process-horizontal .tab-list.icon-list .tab-item.incomplete:before{position:absolute;left:30px;top:6px!important;bottom:unset!important;height:16px;width:16px;margin:unset!important;font-size:16px;font-family:Guroo-Producer;font-style:normal;font-weight:400;font-variant:normal;line-height:1;text-decoration:inherit;text-rendering:optimizeLegibility;text-transform:none;-moz-osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased;font-smoothing:antialiased;background:#fff;border-radius:50%;-webkit-box-shadow:0 0 3px 0 rgba(0,0,0,.25);-moz-box-shadow:0 0 3px 0 rgba(0,0,0,.25);box-shadow:0 0 3px 0 rgba(0,0,0,.25)}.tabbed-content-process-horizontal .tab-list.icon-list .tab-item.complete:before{display:block;display:inline-block;content:\"\\F16F\";color:#39aa27}.tabbed-content-process-horizontal .tab-list.icon-list .tab-item:first-child{margin-left:0;padding:10px 6px 10px 12px}.tabbed-content-process-horizontal .tab-list.icon-list .tab-item:first-child.complete:before,.tabbed-content-process-horizontal .tab-list.icon-list .tab-item:first-child.incomplete:before{left:6px}.tabbed-content-process-horizontal .tab-list.icon-list .tab-item .tab-icon{position:relative;height:40px;width:40px;text-align:center}.tabbed-content-process-horizontal .tab-list.icon-list .tab-item .tab-icon img{display:block;position:absolute;z-index:1;left:0;right:0;top:0;bottom:0;margin:auto;height:38px}.tabbed-content-process-horizontal .tabbed-body-content{border-top:1px solid #d5d5d5;display:block;position:relative;overflow:hidden;height:calc(100% - 60px);overflow:hidden!important}.tabbed-content-process-horizontal .tabbed-body-content .content-wrapper,.tabbed-content-process-horizontal .tabbed-body-content .content-wrapper .content-area{height:100%;width:100%;margin:0 auto;box-shadow:none}.tabbed-content-process-horizontal .tabbed-body-content .content-wrapper-background{-webkit-clip-path:none!important;clip-path:none!important}.tabbed-content-process-vertical{display:-webkit-flex;display:flex;flex-flow:row nowrap;width:100%;height:100%}.tabbed-content-process-vertical .tab-list{flex:1;margin:0;padding:30px 15px;border-top-left-radius:5px;border-bottom-left-radius:5px;overflow-y:auto;direction:rtl}.tabbed-content-process-vertical .tab-list .tab-item-wrapper{margin:0;direction:ltr}.tabbed-content-process-vertical .tab-list .tab-item{display:-webkit-flex;display:flex;flex-flow:row nowrap;align-items:center;flex:1;text-align:left;position:relative;vertical-align:middle;padding:12px 16px;cursor:pointer;transition:background .5s ease,color .5s ease;border-radius:5px;margin:0 0 40px;min-height:72px;border-style:solid;border-width:1px}.tabbed-content-process-vertical .tab-list .tab-item:hover{background:hsla(0,0%,100%,.8)}.tabbed-content-process-vertical .tab-list .tab-item .post-shape{border:none}.tabbed-content-process-vertical .tab-list .tab-item .post-shape:after{content:\"\";color:#333;position:absolute;left:calc(50% - 10px);bottom:-30px;display:inline-block;font-family:Guroo-Producer;font-style:normal;font-weight:400;font-variant:normal;line-height:1;text-decoration:inherit;text-rendering:optimizeLegibility;text-transform:none;-moz-osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased;font-smoothing:antialiased;content:\"\\F220\";z-index:1;font-size:20px}.tabbed-content-process-vertical .tab-list .tab-item:first-child.active:after{content:\"\";border-top-left-radius:5px}.tabbed-content-process-vertical .tab-list .tab-item:last-child{margin-bottom:0}.tabbed-content-process-vertical .tab-list .tab-item:last-child .post-shape,.tabbed-content-process-vertical .tab-list .tab-item:last-child .pre-shape{display:none}.tabbed-content-process-vertical .tab-list .tab-item:last-child.active:after{content:\"\"}.tabbed-content-process-vertical .tab-list .tab-item.disabled:hover{cursor:not-allowed}.tabbed-content-process-vertical .tab-list .tab-item.incomplete:before{content:\"\\F16A\";color:#999}.tabbed-content-process-vertical .tab-list .tab-item.complete:before,.tabbed-content-process-vertical .tab-list .tab-item.incomplete:before{position:absolute;right:-6px;top:-6px;font-size:16px;display:inline-block;font-family:Guroo-Producer;font-style:normal;font-weight:400;font-variant:normal;line-height:1;text-decoration:inherit;text-rendering:optimizeLegibility;text-transform:none;-moz-osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased;font-smoothing:antialiased;background:#fff;border-radius:50%}.tabbed-content-process-vertical .tab-list .tab-item.complete:before{content:\"\\F16F\";color:#39aa27}.tabbed-content-process-vertical .tab-list .tab-item .tab-label{line-height:110%}.tabbed-content-process-vertical .tab-list.icon-list .tab-item{padding:12px 16px 12px 12px;margin:0 0 40px;min-height:72px}.tabbed-content-process-vertical .tab-list.icon-list .tab-item .tab-icon{padding:3px;min-width:50px!important;width:50px!important;height:50px;border:none;position:relative}.tabbed-content-process-vertical .tab-list.icon-list .tab-item .tab-icon img{position:absolute;height:38px;width:auto;top:0;left:0;right:0;bottom:0;margin:auto}.tabbed-content-process-vertical .tab-list.icon-list .tab-item .tab-label{padding-left:12px}.tabbed-content-process-vertical .tabbed-body-content{flex:3;display:-webkit-flex;display:flex;flex-flow:column nowrap;border-top-right-radius:5px;border-bottom-right-radius:5px;height:100%;overflow:hidden!important}.tabbed-content-process-vertical .tabbed-body-content .content-screen,.tabbed-content-process-vertical .tabbed-body-content .customer-scenario{flex:1;position:relative;display:-webkit-flex;display:flex;flex-flow:column nowrap}.tabbed-content-process-vertical .tabbed-body-content .content-wrapper{height:100%;width:inherit;margin:0 auto;box-shadow:none;border-top-right-radius:5px;border-bottom-right-radius:5px}.tabbed-content-process-vertical .tabbed-body-content .content-wrapper .content-area{height:100%;width:100%;border-top-right-radius:5px;border-bottom-right-radius:5px;margin:0 auto;box-shadow:none}.tabbed-content-process-vertical .tabbed-body-content .content-wrapper-background{-webkit-clip-path:none!important;clip-path:none!important}.tabbed-content-process-vertical .tabbed-body-content .video-content-wrapper .content-row{align-items:flex-start!important}.tabbed-content-process-vertical .tabbed-body-content .video-content-wrapper .video-object-wrapper .video-col.single{padding:0 10px!important}.tabbed-content-process-vertical .tabbed-body-content .close_up img{width:150%!important;left:-25%!important}.tabbed-content-tile-horizontal{display:block;position:relative;overflow:hidden;height:calc(100% - 60px);width:calc(100% - 60px);margin:30px auto;max-width:1100px;border-radius:5px;-webkit-box-shadow:0 5px 5px 0 rgba(0,0,0,.25);-moz-box-shadow:0 5px 5px 0 rgba(0,0,0,.25);box-shadow:0 5px 5px 0 rgba(0,0,0,.25)}.tabbed-content-tile-horizontal .object-feed{box-shadow:none!important;-webkit-box-shadow:none!important;-moz-box-shadow:none!important}.tabbed-content-tile-horizontal .tab-list .tab-item-wrapper{display:-webkit-flex;display:flex;flex-flow:row nowrap;align-items:center;justify-content:center;width:95%;margin:auto;padding:0;height:160px}.tabbed-content-tile-horizontal .tab-list .tab-item{display:-webkit-flex;display:flex;flex-flow:row nowrap;align-items:center;position:relative;padding:44px 6px;margin:0 15px 0 0;cursor:pointer;height:140px;width:120px;border-radius:5px;border-style:solid;border-width:1px;-webkit-box-shadow:0 0 3px 0 rgba(0,0,0,.25);-moz-box-shadow:0 0 3px 0 rgba(0,0,0,.25);box-shadow:0 0 3px 0 rgba(0,0,0,.25);transition:background .5s ease,color .5s ease}.tabbed-content-tile-horizontal .tab-list .tab-item.incomplete:before{content:\"\\F16A\";color:#999}.tabbed-content-tile-horizontal .tab-list .tab-item.complete:before,.tabbed-content-tile-horizontal .tab-list .tab-item.incomplete:before{position:absolute;right:-6px;top:-6px;font-size:16px;width:16px;height:16px;margin:unset;left:unset;display:inline-block;font-family:Guroo-Producer;font-style:normal;font-weight:400;font-variant:normal;line-height:1;text-decoration:inherit;text-rendering:optimizeLegibility;text-transform:none;-moz-osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased;font-smoothing:antialiased;background:#fff;border-radius:50%}.tabbed-content-tile-horizontal .tab-list .tab-item.complete:before{content:\"\\F16F\";color:#39aa27}.tabbed-content-tile-horizontal .tab-list .tab-item:first-child{margin-left:0}.tabbed-content-tile-horizontal .tab-list .tab-item:last-child{margin-right:0}.tabbed-content-tile-horizontal .tab-list .tab-item.disabled:hover{cursor:not-allowed}.tabbed-content-tile-horizontal .tab-list .tab-item .tab-label{flex:1;text-align:center;line-height:110%;font-size:85%}.tabbed-content-tile-horizontal .tab-list.icon-list .tab-item{display:block;flex-flow:unset;padding:6px}.tabbed-content-tile-horizontal .tab-list.icon-list .tab-item .tab-icon{display:block;padding:8px;height:105px;overflow:hidden;position:relative;text-align:center}.tabbed-content-tile-horizontal .tab-list.icon-list .tab-item .tab-icon img{height:100%;width:auto}.tabbed-content-tile-horizontal .tab-list.icon-list .tab-item .tab-label{flex:none;padding:5px 5px 0;line-height:125%;font-size:85%;position:relative;overflow:hidden}.tabbed-content-tile-horizontal .tab-list.icon-list .tab-item .tab-label a,.tabbed-content-tile-horizontal .tab-list.icon-list .tab-item .tab-label div,.tabbed-content-tile-horizontal .tab-list.icon-list .tab-item .tab-label h1,.tabbed-content-tile-horizontal .tab-list.icon-list .tab-item .tab-label h2,.tabbed-content-tile-horizontal .tab-list.icon-list .tab-item .tab-label h3,.tabbed-content-tile-horizontal .tab-list.icon-list .tab-item .tab-label h4,.tabbed-content-tile-horizontal .tab-list.icon-list .tab-item .tab-label h5,.tabbed-content-tile-horizontal .tab-list.icon-list .tab-item .tab-label li,.tabbed-content-tile-horizontal .tab-list.icon-list .tab-item .tab-label p,.tabbed-content-tile-horizontal .tab-list.icon-list .tab-item .tab-label span{height:100%;width:100%;overflow:hidden;display:block;white-space:nowrap;text-overflow:ellipsis}.tabbed-content-tile-horizontal .tabbed-body-content{border-top:1px solid #d5d5d5;display:block;position:relative;overflow:hidden;height:calc(100% - 160px);overflow:hidden!important}.tabbed-content-tile-horizontal .tabbed-body-content .content-wrapper,.tabbed-content-tile-horizontal .tabbed-body-content .content-wrapper .content-area{height:100%;width:100%;margin:0 auto;box-shadow:none}.tabbed-content-tile-horizontal .tabbed-body-content .content-wrapper-background{-webkit-clip-path:none!important;clip-path:none!important}.tabbed-content-tile-horizontal .tabbed-body-content .character-stage{background:transparent!important}.tabbed-content-tile-horizontal .tabbed-body-content .character-stage .close_up img{width:100%!important;left:0!important}.tabbed-content-tile-horizontal .tabbed-body-content .video-content-wrapper .video-object-wrapper .video-col.single{padding:0 280px!important}.tabbed-content-tile-vertical{display:-webkit-flex;display:flex;flex-flow:row nowrap;height:calc(100% - 60px);width:calc(100% - 60px);margin:30px auto;max-width:1100px;border-radius:5px;-webkit-box-shadow:0 5px 5px 0 rgba(0,0,0,.25);-moz-box-shadow:0 5px 5px 0 rgba(0,0,0,.25);box-shadow:0 5px 5px 0 rgba(0,0,0,.25)}.tabbed-content-tile-vertical .tab-list{overflow-y:auto;width:320px;margin:0;padding:0 15px;direction:rtl;display:flex;flex-flow:row wrap;align-content:flex-start;justify-content:flex-start}.tabbed-content-tile-vertical .tab-list .tab-item-wrapper{margin:30px 0 0;direction:ltr;display:flex;flex-flow:row wrap;align-content:flex-start;justify-content:center}.tabbed-content-tile-vertical .tab-list .tab-item{display:-webkit-flex;display:flex;flex-flow:row nowrap;align-items:center;position:relative;padding:44px 6px;margin:0 15px 0 0;cursor:pointer;height:140px;width:120px;border-radius:5px;border-style:solid;border-width:1px;-webkit-box-shadow:0 0 3px 0 rgba(0,0,0,.25);-moz-box-shadow:0 0 3px 0 rgba(0,0,0,.25);box-shadow:0 0 3px 0 rgba(0,0,0,.25);transition:background .5s ease,color .5s ease}.tabbed-content-tile-vertical .tab-list .tab-item.incomplete:before{content:\"\\F16A\";color:#999}.tabbed-content-tile-vertical .tab-list .tab-item.complete:before,.tabbed-content-tile-vertical .tab-list .tab-item.incomplete:before{position:absolute;right:-6px;top:-6px;font-size:16px;width:16px;height:16px;margin:unset;left:unset;display:inline-block;font-family:Guroo-Producer;font-style:normal;font-weight:400;font-variant:normal;line-height:1;text-decoration:inherit;text-rendering:optimizeLegibility;text-transform:none;-moz-osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased;font-smoothing:antialiased;background:#fff;border-radius:50%}.tabbed-content-tile-vertical .tab-list .tab-item.complete:before{content:\"\\F16F\";color:#39aa27}.tabbed-content-tile-vertical .tab-list .tab-item:first-child{margin-left:0}.tabbed-content-tile-vertical .tab-list .tab-item:last-child{margin-right:0}.tabbed-content-tile-vertical .tab-list .tab-item.disabled:hover{cursor:not-allowed}.tabbed-content-tile-vertical .tab-list .tab-item .tab-label{flex:1;text-align:center;line-height:110%;font-size:85%}.tabbed-content-tile-vertical .tab-list.icon-list .tab-item{display:block;flex-flow:unset;padding:6px}.tabbed-content-tile-vertical .tab-list.icon-list .tab-item .tab-icon{display:block;padding:8px;height:105px;overflow:hidden;position:relative;text-align:center}.tabbed-content-tile-vertical .tab-list.icon-list .tab-item .tab-icon img{height:100%;width:auto}.tabbed-content-tile-vertical .tab-list.icon-list .tab-item .tab-label{flex:none;padding:5px 5px 0;line-height:125%;font-size:85%;position:relative;overflow:hidden}.tabbed-content-tile-vertical .tab-list.icon-list .tab-item .tab-label a,.tabbed-content-tile-vertical .tab-list.icon-list .tab-item .tab-label div,.tabbed-content-tile-vertical .tab-list.icon-list .tab-item .tab-label h1,.tabbed-content-tile-vertical .tab-list.icon-list .tab-item .tab-label h2,.tabbed-content-tile-vertical .tab-list.icon-list .tab-item .tab-label h3,.tabbed-content-tile-vertical .tab-list.icon-list .tab-item .tab-label h4,.tabbed-content-tile-vertical .tab-list.icon-list .tab-item .tab-label h5,.tabbed-content-tile-vertical .tab-list.icon-list .tab-item .tab-label li,.tabbed-content-tile-vertical .tab-list.icon-list .tab-item .tab-label p,.tabbed-content-tile-vertical .tab-list.icon-list .tab-item .tab-label span{height:100%;width:100%;overflow:hidden;display:block;white-space:nowrap;text-overflow:ellipsis}.tabbed-content-tile-vertical .tab-list .tab-item{margin-bottom:30px}.tabbed-content-tile-vertical .tab-list .tab-item:nth-child(2n){margin-right:0}.tabbed-content-tile-vertical .tabbed-body-content{width:calc(100% - 320px);display:-webkit-flex;display:flex;flex-flow:column nowrap;border-top-right-radius:5px;border-bottom-right-radius:5px;height:100%;overflow:hidden!important}.tabbed-content-tile-vertical .tabbed-body-content .content-screen,.tabbed-content-tile-vertical .tabbed-body-content .customer-scenario{flex:1;position:relative;display:-webkit-flex;display:flex;flex-flow:column nowrap}.tabbed-content-tile-vertical .tabbed-body-content .content-wrapper{height:100%;width:inherit;margin:0 auto;box-shadow:none;border-top-right-radius:5px;border-bottom-right-radius:5px}.tabbed-content-tile-vertical .tabbed-body-content .content-wrapper .content-area{height:100%;width:100%;border-top-right-radius:5px;border-bottom-right-radius:5px;margin:0 auto;box-shadow:none}.tabbed-content-tile-vertical .tabbed-body-content .content-wrapper-background{-webkit-clip-path:none!important;clip-path:none!important}.tabbed-content-tile-vertical .tabbed-body-content .video-content-wrapper .content-row{align-items:flex-start!important}.tabbed-content-tile-vertical .tabbed-body-content .video-content-wrapper .video-object-wrapper .video-col.single{padding:0 10px!important}.tabbed-content-tile-vertical .tabbed-body-content .close_up img{width:150%!important;left:-25%!important}.inline-content{display:table;width:100%}.inline-content .content-item{overflow:hidden;display:table-cell;vertical-align:top}.inline-content .content-item:first-child:last-child{width:100%}.inline-content .content-item:first-child:nth-last-child(2),.inline-content .content-item:first-child:nth-last-child(2)~li{min-width:50%;width:50%}.inline-content .content-item:first-child:nth-last-child(3),.inline-content .content-item:first-child:nth-last-child(3)~li{min-width:33.3333%;width:33.3333%}.inline-content .content-item:first-child:nth-last-child(4),.inline-content .content-item:first-child:nth-last-child(4)~li{min-width:25%}.inline-content .content-item:first-child:nth-last-child(5),.inline-content .content-item:first-child:nth-last-child(5)~li{width:20%}.inline-content .content-item:first-child:nth-last-child(6),.inline-content .content-item:first-child:nth-last-child(6)~li{width:16.6666%}.inline-content .content-item:first-child:nth-last-child(7),.inline-content .content-item:first-child:nth-last-child(7)~li{width:14.2857%}.inline-content .content-item:first-child:nth-last-child(8),.inline-content .content-item:first-child:nth-last-child(8)~li{width:12.5%}.inline-content .content-item-spacer{overflow:hidden;display:table-cell;vertical-align:top;min-width:20px}.inline-content .content-item-spacer:before{content:\" - \"}.inline-content .content-item-review{overflow:hidden;display:table-cell;vertical-align:top}@media only screen and (max-width:375px) and (max-height:736px) and (orientation:portrait){.inline-content.mobile-block,.inline-content.mobile-block .content-item{display:block;width:100%!important}.inline-content.mobile-block .content-item:first-child:last-child{width:100%}.inline-content.mobile-block .content-item:first-child:nth-last-child(2),.inline-content.mobile-block .content-item:first-child:nth-last-child(2)~li{min-width:50%;width:50%}.inline-content.mobile-block .content-item:first-child:nth-last-child(3),.inline-content.mobile-block .content-item:first-child:nth-last-child(3)~li{min-width:33.3333%;width:33.3333%}.inline-content.mobile-block .content-item:first-child:nth-last-child(4),.inline-content.mobile-block .content-item:first-child:nth-last-child(4)~li{min-width:25%}.inline-content.mobile-block .content-item:first-child:nth-last-child(5),.inline-content.mobile-block .content-item:first-child:nth-last-child(5)~li{width:20%}.inline-content.mobile-block .content-item:first-child:nth-last-child(6),.inline-content.mobile-block .content-item:first-child:nth-last-child(6)~li{width:16.6666%}.inline-content.mobile-block .content-item:first-child:nth-last-child(7),.inline-content.mobile-block .content-item:first-child:nth-last-child(7)~li{width:14.2857%}.inline-content.mobile-block .content-item:first-child:nth-last-child(8),.inline-content.mobile-block .content-item:first-child:nth-last-child(8)~li{width:12.5%}.inline-content.mobile-block .content-item-review,.inline-content.mobile-block .content-item-spacer{display:block;width:100%!important}.inline-content.mobile-block .content-item-review .text-right{text-align:center}}@media only screen and (min-width:376px) and (max-width:414px) and (max-height:736px) and (orientation:portrait){.inline-content.mobile-block,.inline-content.mobile-block .content-item{display:block;width:100%!important}.inline-content.mobile-block .content-item:first-child:last-child{width:100%}.inline-content.mobile-block .content-item:first-child:nth-last-child(2),.inline-content.mobile-block .content-item:first-child:nth-last-child(2)~li{min-width:50%;width:50%}.inline-content.mobile-block .content-item:first-child:nth-last-child(3),.inline-content.mobile-block .content-item:first-child:nth-last-child(3)~li{min-width:33.3333%;width:33.3333%}.inline-content.mobile-block .content-item:first-child:nth-last-child(4),.inline-content.mobile-block .content-item:first-child:nth-last-child(4)~li{min-width:25%}.inline-content.mobile-block .content-item:first-child:nth-last-child(5),.inline-content.mobile-block .content-item:first-child:nth-last-child(5)~li{width:20%}.inline-content.mobile-block .content-item:first-child:nth-last-child(6),.inline-content.mobile-block .content-item:first-child:nth-last-child(6)~li{width:16.6666%}.inline-content.mobile-block .content-item:first-child:nth-last-child(7),.inline-content.mobile-block .content-item:first-child:nth-last-child(7)~li{width:14.2857%}.inline-content.mobile-block .content-item:first-child:nth-last-child(8),.inline-content.mobile-block .content-item:first-child:nth-last-child(8)~li{width:12.5%}.inline-content.mobile-block .content-item-review,.inline-content.mobile-block .content-item-spacer{display:block;width:100%!important}.inline-content.mobile-block .content-item-review .text-right{text-align:center}}@media only screen and (max-width:375px) and (min-height:737px) and (max-height:812px) and (orientation:portrait){.inline-content.mobile-block,.inline-content.mobile-block .content-item{display:block;width:100%!important}.inline-content.mobile-block .content-item:first-child:last-child{width:100%}.inline-content.mobile-block .content-item:first-child:nth-last-child(2),.inline-content.mobile-block .content-item:first-child:nth-last-child(2)~li{min-width:50%;width:50%}.inline-content.mobile-block .content-item:first-child:nth-last-child(3),.inline-content.mobile-block .content-item:first-child:nth-last-child(3)~li{min-width:33.3333%;width:33.3333%}.inline-content.mobile-block .content-item:first-child:nth-last-child(4),.inline-content.mobile-block .content-item:first-child:nth-last-child(4)~li{min-width:25%}.inline-content.mobile-block .content-item:first-child:nth-last-child(5),.inline-content.mobile-block .content-item:first-child:nth-last-child(5)~li{width:20%}.inline-content.mobile-block .content-item:first-child:nth-last-child(6),.inline-content.mobile-block .content-item:first-child:nth-last-child(6)~li{width:16.6666%}.inline-content.mobile-block .content-item:first-child:nth-last-child(7),.inline-content.mobile-block .content-item:first-child:nth-last-child(7)~li{width:14.2857%}.inline-content.mobile-block .content-item:first-child:nth-last-child(8),.inline-content.mobile-block .content-item:first-child:nth-last-child(8)~li{width:12.5%}.inline-content.mobile-block .content-item-review,.inline-content.mobile-block .content-item-spacer{display:block;width:100%!important}.inline-content.mobile-block .content-item-review .text-right{text-align:center}}.object-feed .multiple-choice-option-list{margin:0 -24px}.content-tool-tip{z-index:99999999999;display:block;position:fixed;top:50%;left:50%;width:1px;height:1px;opacity:0;cursor:pointer;transition:all .2s ease-in-out}.content-tool-tip.open{width:100%;height:100%;opacity:1;top:0;left:0}.content-tool-tip.open .tool-tip{position:absolute;display:block;top:25%;margin:auto;margin-bottom:5px;overflow:hidden;left:0;right:0;background:#fff;width:300px;padding:0;border-radius:5px;-webkit-box-shadow:3px 11px 5px -9px rgba(0,0,0,.5);-moz-box-shadow:3px 11px 5px -9px rgba(0,0,0,.5);box-shadow:3px 11px 5px -9px rgba(0,0,0,.5);font-style:italic}.content-tool-tip.open .tool-tip .tool-tip-header{padding:6px 10px;color:#fff}.content-tool-tip.open .tool-tip .tool-tip-header:before{content:\"\\F190\"}.content-tool-tip.open .tool-tip .tool-tip-header:after,.content-tool-tip.open .tool-tip .tool-tip-header:before{font-size:100%;display:inline-block;font-family:Guroo-Producer;font-style:normal;font-weight:400;font-variant:normal;line-height:1;text-decoration:inherit;text-rendering:optimizeLegibility;text-transform:none;-moz-osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased;font-smoothing:antialiased}.content-tool-tip.open .tool-tip .tool-tip-header:after{position:absolute;top:8px;right:6px;content:\"\\F125\"}.content-tool-tip.open .tool-tip .tool-tip-content{padding:12px 15px 15px}.tool-tip-btn{cursor:pointer}.tool-tip-btn:before{position:relative;font-size:100%;display:inline-block;font-family:Guroo-Producer;font-style:normal;font-weight:400;font-variant:normal;line-height:1;text-decoration:inherit;text-rendering:optimizeLegibility;text-transform:none;-moz-osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased;font-smoothing:antialiased;content:\"\\F190\"}.multiple-choice-option :last-child{margin-bottom:0}.multiple-choice-option-list{display:block;overflow:hidden;margin:0 0 20px;padding:0;clear:both}@media only screen and (max-width:375px) and (max-height:736px) and (orientation:portrait){.multiple-choice-option-list{margin:0 -12px;margin-bottom:20px}}@media only screen and (max-height:375px) and (max-width:736px) and (orientation:landscape){.multiple-choice-option-list{margin:0 -12px;margin-bottom:20px}}@media only screen and (min-width:376px) and (max-width:414px) and (max-height:736px) and (orientation:portrait){.multiple-choice-option-list{margin:0 -12px;margin-bottom:20px}}@media only screen and (min-height:376px) and (max-height:414px) and (max-width:736px) and (orientation:landscape){.multiple-choice-option-list{margin:0 -12px;margin-bottom:20px}}@media only screen and (max-width:375px) and (min-height:737px) and (max-height:812px) and (orientation:portrait){.multiple-choice-option-list{margin:0 -12px;margin-bottom:20px}}@media only screen and (min-height:737px) and (max-height:812px) and (max-width:375px) and (orientation:landscape){.multiple-choice-option-list{margin:0 -12px;margin-bottom:20px}}.multiple-choice-option-list .multiple-choice-option{position:relative!important;display:block;list-style-type:none;margin:0 0 3px;padding:0;width:100%;overflow:hidden}.multiple-choice-option-list .multiple-choice-option .tool-tip-btn{position:absolute;right:10px;top:12px;z-index:5}.multiple-choice-option-list .multiple-choice-option input{display:none}.multiple-choice-option-list .multiple-choice-option label{position:relative;width:100%;display:block;float:right;overflow:hidden;margin:0;font-weight:400;padding:12px 30px 10px 60px;line-height:130%;border-bottom:2px solid transparent;transition:opacity .3s ease,border-radius .6s ease,border-color .6s ease,color .2s ease,background .4s ease}.multiple-choice-option-list .multiple-choice-option label .image-container{text-align:center;margin-top:15px}.multiple-choice-option-list .multiple-choice-option label .image-container img{max-width:100%;height:auto;max-height:200px!important;margin:0 auto}@media only screen and (max-width:375px) and (max-height:736px) and (orientation:portrait){.multiple-choice-option-list .multiple-choice-option label{padding:12px 30px 10px 60px}}@media only screen and (max-height:375px) and (max-width:736px) and (orientation:landscape){.multiple-choice-option-list .multiple-choice-option label{padding:12px 30px 10px 60px}}@media only screen and (min-width:376px) and (max-width:414px) and (max-height:736px) and (orientation:portrait){.multiple-choice-option-list .multiple-choice-option label{padding:12px 30px 10px 60px}}@media only screen and (min-height:376px) and (max-height:414px) and (max-width:736px) and (orientation:landscape){.multiple-choice-option-list .multiple-choice-option label{padding:12px 30px 10px 60px}}@media only screen and (max-width:375px) and (min-height:737px) and (max-height:812px) and (orientation:portrait){.multiple-choice-option-list .multiple-choice-option label{padding:12px 30px 10px 60px}}@media only screen and (min-height:737px) and (max-height:812px) and (max-width:375px) and (orientation:landscape){.multiple-choice-option-list .multiple-choice-option label{padding:12px 30px 10px 60px}}.multiple-choice-option-list .multiple-choice-option input:not([disabled])+label{cursor:pointer;z-index:1}.multiple-choice-option-list .multiple-choice-option input:not([disabled])+label:hover{background:hsla(0,0%,100%,.8)}.multiple-choice-option-list .multiple-choice-option input[type=radio]+label:before{position:absolute;left:24px;top:10px;font-size:24px;content:\"\\F175\"}.multiple-choice-option-list .multiple-choice-option input[type=radio]+label:before,.multiple-choice-option-list .multiple-choice-option input[type=radio]:checked+label:before{display:inline-block;font-family:Guroo-Producer;font-style:normal;font-weight:400;font-variant:normal;line-height:1;text-decoration:inherit;text-rendering:optimizeLegibility;text-transform:none;-moz-osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased;font-smoothing:antialiased}.multiple-choice-option-list .multiple-choice-option input[type=radio]:checked+label:before{padding-right:10px;content:\"\\F231\"}.multiple-choice-option-list .multiple-choice-option input[type=checkbox]+label:before{position:absolute;left:24px;top:10px;font-size:24px;display:inline-block;font-family:Guroo-Producer;font-style:normal;font-weight:400;font-variant:normal;line-height:1;text-decoration:inherit;text-rendering:optimizeLegibility;text-transform:none;-moz-osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased;font-smoothing:antialiased;content:\"\\F177\"}.multiple-choice-option-list .multiple-choice-option input[type=checkbox]:checked+label:before{content:\"\\F176\"}.multiple-choice-option-list .multiple-choice-option.poor input[type=checkbox]:checked+label:before,.multiple-choice-option-list .multiple-choice-option input[type=checkbox]:checked+label:before{padding-right:10px;display:inline-block;font-family:Guroo-Producer;font-style:normal;font-weight:400;font-variant:normal;line-height:1;text-decoration:inherit;text-rendering:optimizeLegibility;text-transform:none;-moz-osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased;font-smoothing:antialiased}.multiple-choice-option-list .multiple-choice-option.poor input[type=checkbox]:checked+label:before{color:#c5000f;content:\"\\F277\"}.multiple-choice-option-list .multiple-choice-option.ok input[type=checkbox]:checked+label:before{color:#f6ad17;content:\"\\F276\"}.multiple-choice-option-list .multiple-choice-option.best input[type=checkbox]:checked+label:before,.multiple-choice-option-list .multiple-choice-option.ok input[type=checkbox]:checked+label:before{padding-right:10px;display:inline-block;font-family:Guroo-Producer;font-style:normal;font-weight:400;font-variant:normal;line-height:1;text-decoration:inherit;text-rendering:optimizeLegibility;text-transform:none;-moz-osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased;font-smoothing:antialiased}.multiple-choice-option-list .multiple-choice-option.best input[type=checkbox]:checked+label:before{color:#39aa27;content:\"\\F275\"}.multiple-choice-option-list .multiple-choice-option.missed:hover{background:transparent!important}.multiple-choice-option-list .multiple-choice-option.best:before,.multiple-choice-option-list .multiple-choice-option.best input+label:before,.multiple-choice-option-list .multiple-choice-option.missed:before,.multiple-choice-option-list .multiple-choice-option.missed input+label:before{color:#39aa27}.multiple-choice-option-list .multiple-choice-option.ok:before,.multiple-choice-option-list .multiple-choice-option.ok input+label:before{color:#f6ad17}.multiple-choice-option-list .multiple-choice-option.poor:before,.multiple-choice-option-list .multiple-choice-option.poor input+label:before{color:#c5000f}.multiple-choice-option-list .multiple-choice-option.reflective:before,.multiple-choice-option-list .multiple-choice-option.reflective input+label:before{color:#6592cb!important}.multiple-choice-option-list .multiple-choice-option.positive-single{padding-left:15px}.multiple-choice-option-list .multiple-choice-option.positive-single input+label:before{color:#39aa27}.multiple-choice-option-list .multiple-choice-option.positive-single:before{position:absolute;width:30px;height:30px;background:#39aa27;border-radius:50%;font-size:12px;left:-24px;top:-5px;content:\"\"}.multiple-choice-option-list .multiple-choice-option.positive-single:after{position:absolute;width:30px;display:block;left:-24px;font-size:15px;top:3px;padding:0;color:#fff;display:inline-block;font-family:Guroo-Producer;font-style:normal;font-weight:400;font-variant:normal;line-height:1;text-decoration:inherit;text-rendering:optimizeLegibility;text-transform:none;-moz-osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased;font-smoothing:antialiased;text-align:center;content:\"\\F16C\"}.multiple-choice-option-list .multiple-choice-option.positive-double{padding-left:15px}.multiple-choice-option-list .multiple-choice-option.positive-double input+label:before{color:#39aa27}.multiple-choice-option-list .multiple-choice-option.positive-double:before{position:absolute;width:30px;height:30px;background:#39aa27;border-radius:50%;font-size:12px;left:-24px;top:-5px;content:\"\"}.multiple-choice-option-list .multiple-choice-option.positive-double:after{position:absolute;width:30px;display:block;left:-24px;font-size:15px;top:3px;padding:0;color:#fff;display:inline-block;font-family:Guroo-Producer;font-style:normal;font-weight:400;font-variant:normal;line-height:1;text-decoration:inherit;text-rendering:optimizeLegibility;text-transform:none;-moz-osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased;font-smoothing:antialiased;text-align:center;content:\"\\F16C\\F16B\"}.multiple-choice-option-list .multiple-choice-option.unchecked.positive-single{padding-left:15px}.multiple-choice-option-list .multiple-choice-option.unchecked.positive-single input+label:before{color:#39aa27}.multiple-choice-option-list .multiple-choice-option.unchecked.positive-single:before{position:absolute;width:30px;height:30px;border:2px solid #39aa27;background:transparent;border-radius:50%;font-size:12px;left:-24px;top:-5px;content:\"\"}.multiple-choice-option-list .multiple-choice-option.unchecked.positive-single:after{position:absolute;width:30px;display:block;left:-24px;top:3px;font-size:15px;padding:0;display:inline-block;font-family:Guroo-Producer;font-style:normal;font-weight:400;font-variant:normal;line-height:1;text-decoration:inherit;text-rendering:optimizeLegibility;text-transform:none;-moz-osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased;font-smoothing:antialiased;text-align:center;content:\"\\F16C\";color:#999}.multiple-choice-option-list .multiple-choice-option.unchecked.positive-double{padding-left:15px}.multiple-choice-option-list .multiple-choice-option.unchecked.positive-double input+label:before{color:#39aa27}.multiple-choice-option-list .multiple-choice-option.unchecked.positive-double:before{position:absolute;width:30px;height:30px;border:2px solid #39aa27;background:transparent;border-radius:50%;font-size:12px;left:-24px;top:-5px;content:\"\"}.multiple-choice-option-list .multiple-choice-option.unchecked.positive-double:after{position:absolute;width:30px;display:block;left:-24px;top:3px;font-size:15px;padding:0;color:#999;display:inline-block;font-family:Guroo-Producer;font-style:normal;font-weight:400;font-variant:normal;line-height:1;text-decoration:inherit;text-rendering:optimizeLegibility;text-transform:none;-moz-osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased;font-smoothing:antialiased;text-align:center;content:\"\\F16C\\F16B\"}.multiple-choice-option-list .multiple-choice-option.negative-single{padding-left:15px}.multiple-choice-option-list .multiple-choice-option.negative-single input+label:before{color:#c5000f}.multiple-choice-option-list .multiple-choice-option.negative-single:before{position:absolute;width:30px;height:30px;background:#c5000f;border-radius:50%;font-size:12px;left:-24px;top:-5px;content:\"\"}.multiple-choice-option-list .multiple-choice-option.negative-single:after{position:absolute;width:30px;display:block;left:-24px;top:3px;font-size:15px;padding:0;color:#fff;display:inline-block;font-family:Guroo-Producer;font-style:normal;font-weight:400;font-variant:normal;line-height:1;text-decoration:inherit;text-rendering:optimizeLegibility;text-transform:none;-moz-osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased;font-smoothing:antialiased;text-align:center;content:\"\\F16D\"}.multiple-choice-option-list .multiple-choice-option.negative-double{padding-left:15px}.multiple-choice-option-list .multiple-choice-option.negative-double input+label:before{color:#c5000f}.multiple-choice-option-list .multiple-choice-option.negative-double:before{position:absolute;width:30px;height:30px;background:#c5000f;border-radius:50%;font-size:12px;left:-24px;top:-5px;content:\"\"}.multiple-choice-option-list .multiple-choice-option.negative-double:after{position:absolute;width:30px;display:block;left:-24px;top:3px;font-size:15px;padding:0;color:#fff;display:inline-block;font-family:Guroo-Producer;font-style:normal;font-weight:400;font-variant:normal;line-height:1;text-decoration:inherit;text-rendering:optimizeLegibility;text-transform:none;-moz-osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased;font-smoothing:antialiased;text-align:center;content:\"\\F16D\\F16E\"}.multiple-choice-option-list .multiple-choice-option.no-value{padding-left:15px}.multiple-choice-option-list .multiple-choice-option.no-value input+label:before{color:#f6ad17}.multiple-choice-option-list .multiple-choice-option.no-value:before{position:absolute;width:30px;height:30px;background:#f6ad17;border-radius:50%;font-size:12px;left:-24px;top:-5px;content:\"\"}.multiple-choice-option-list .multiple-choice-option.no-value:after{position:absolute;width:30px;display:block;left:-24px;top:3px;padding:0;font-size:15px;color:#fff;display:inline-block;font-family:Guroo-Producer;font-style:normal;font-weight:400;font-variant:normal;line-height:1;text-decoration:inherit;text-rendering:optimizeLegibility;text-transform:none;-moz-osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased;font-smoothing:antialiased;text-align:center;content:\"\\F12E\"}.multiple-choice-option-list .multiple-choice-option.selected{cursor:pointer}.multiple-choice-option-list .multiple-choice-option.review input[type=radio]+label:before,.multiple-choice-option-list .multiple-choice-option.selected input[type=radio]+label:before,.multiple-choice-option-list .multiple-choice-option.show-answer input[type=radio]+label:before{position:absolute;display:inline-block;font-family:Guroo-Producer;font-style:normal;font-weight:400;font-variant:normal;line-height:1;text-decoration:inherit;text-rendering:optimizeLegibility;text-transform:none;-moz-osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased;font-smoothing:antialiased;content:\"\\F179\"}.multiple-choice-option-list .multiple-choice-option.review input:disabled+label{cursor:default}.multiple-choice-option-list .multiple-choice-option.review-selected input[type=radio]+label:before{content:\"\\F179\"!important}.multiple-choice-option-list .multiple-choice-option.review-selected input[type=checkbox]+label:before,.multiple-choice-option-list .multiple-choice-option.review-selected input[type=radio]+label:before{position:absolute;display:inline-block;font-family:Guroo-Producer;font-style:normal;font-weight:400;font-variant:normal;line-height:1;text-decoration:inherit;text-rendering:optimizeLegibility;text-transform:none;-moz-osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased;font-smoothing:antialiased}.multiple-choice-option-list .multiple-choice-option.review-selected input[type=checkbox]+label:before{content:\"\\F176\"!important}.multiple-choice-option-list .multiple-choice-option.review-selected input:disabled+label{cursor:default}.multiple-choice-option-list .multiple-choice-option.answered input[type=radio]+label:before{position:absolute;display:inline-block;font-family:Guroo-Producer;font-style:normal;font-weight:400;font-variant:normal;line-height:1;text-decoration:inherit;text-rendering:optimizeLegibility;text-transform:none;-moz-osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased;font-smoothing:antialiased;content:\"\\F179\"!important}.multiple-choice-option-list .multiple-choice-option.answered input:disabled+label{cursor:pointer}.multiple-choice-option-list .multiple-choice-option.inactive-answered input[type=radio]+label:before{position:absolute;display:inline-block;font-family:Guroo-Producer;font-style:normal;font-weight:400;font-variant:normal;line-height:1;text-decoration:inherit;text-rendering:optimizeLegibility;text-transform:none;-moz-osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased;font-smoothing:antialiased;content:\"\\F179\"!important}.multiple-choice-option-list .multiple-choice-option.inactive-answered input:disabled+label{cursor:default}.grid-choice-option-list{display:flex;justify-content:space-between;flex-wrap:wrap;justify-content:center;margin:0;padding:0;overflow:hidden}.grid-choice-option-list .multiple-choice-option{border-radius:5px;padding:16px 24px;margin:0 .5em 1em;width:calc(50% - 1em);height:100%;overflow:hidden;padding:0;list-style-type:none;background:#fff;-webkit-box-shadow:0 3px 5px 0 rgba(0,0,0,.25);-moz-box-shadow:0 3px 5px 0 rgba(0,0,0,.25);box-shadow:0 3px 5px 0 rgba(0,0,0,.25)}.grid-choice-option-list .multiple-choice-option input{display:none}.grid-choice-option-list .multiple-choice-option.focus{background:#eff0f2!important}.grid-choice-option-list .multiple-choice-option label{position:relative;width:100%;display:block;float:right;overflow:hidden;margin:0;font-weight:400;padding:16px 24px;line-height:110%;transition:opacity .3s ease,border-radius .6s ease,border-color .6s ease,color .2s ease,background .4s ease}.grid-choice-option-list .multiple-choice-option label .object-container{padding:0!important;margin:0!important}.grid-choice-option-list .multiple-choice-option label .image-container{text-align:center;margin-top:15px;display:block;width:100%;height:100%;vertical-align:middle}.grid-choice-option-list .multiple-choice-option label .image-container img{display:block;max-width:100%;height:auto;max-height:200px!important;margin:0 auto}.grid-choice-option-list .multiple-choice-option input:not([disabled])+label{cursor:pointer;z-index:1}.grid-choice-option-list .multiple-choice-option input[type=radio]+label .label-text{padding-left:24px;min-height:20px}.grid-choice-option-list .multiple-choice-option input[type=radio]+label .label-text:before{position:absolute;left:12px;top:12px;font-size:24px;display:inline-block;font-family:Guroo-Producer;font-style:normal;font-weight:400;font-variant:normal;line-height:1;text-decoration:inherit;text-rendering:optimizeLegibility;text-transform:none;-moz-osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased;font-smoothing:antialiased;content:\"\\F175\"}.grid-choice-option-list .multiple-choice-option input[type=radio]:checked+label .label-text:before{content:\"\\F231\"}.grid-choice-option-list .multiple-choice-option.poor input[type=checkbox]:checked+label:before,.grid-choice-option-list .multiple-choice-option input[type=radio]:checked+label .label-text:before{padding-right:10px;display:inline-block;font-family:Guroo-Producer;font-style:normal;font-weight:400;font-variant:normal;line-height:1;text-decoration:inherit;text-rendering:optimizeLegibility;text-transform:none;-moz-osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased;font-smoothing:antialiased}.grid-choice-option-list .multiple-choice-option.poor input[type=checkbox]:checked+label:before{color:#c5000f;content:\"\\F277\"}.grid-choice-option-list .multiple-choice-option.ok input[type=checkbox]:checked+label:before{color:#f6ad17;content:\"\\F276\"}.grid-choice-option-list .multiple-choice-option.best input[type=checkbox]:checked+label:before,.grid-choice-option-list .multiple-choice-option.ok input[type=checkbox]:checked+label:before{padding-right:10px;display:inline-block;font-family:Guroo-Producer;font-style:normal;font-weight:400;font-variant:normal;line-height:1;text-decoration:inherit;text-rendering:optimizeLegibility;text-transform:none;-moz-osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased;font-smoothing:antialiased}.grid-choice-option-list .multiple-choice-option.best input[type=checkbox]:checked+label:before{color:#39aa27;content:\"\\F275\"}.grid-choice-option-list .multiple-choice-option.missed:hover{background:transparent!important}.grid-choice-option-list .multiple-choice-option.best:before,.grid-choice-option-list .multiple-choice-option.best input+label:before,.grid-choice-option-list .multiple-choice-option.missed:before,.grid-choice-option-list .multiple-choice-option.missed input+label:before{color:#39aa27}.grid-choice-option-list .multiple-choice-option.ok:before,.grid-choice-option-list .multiple-choice-option.ok input+label:before{color:#f6ad17}.grid-choice-option-list .multiple-choice-option.poor:before,.grid-choice-option-list .multiple-choice-option.poor input+label:before{color:#c5000f}.grid-choice-option-list .multiple-choice-option.reflective input+label:before{color:#6592cb!important}.grid-choice-option-list .multiple-choice-option.positive-single{padding-left:15px}.grid-choice-option-list .multiple-choice-option.positive-single input+label:before{color:#39aa27}.grid-choice-option-list .multiple-choice-option.positive-single:before{position:absolute;width:30px;height:30px;background:#39aa27;border-radius:50%;font-size:12px;left:-24px;top:-5px;content:\"\"}.grid-choice-option-list .multiple-choice-option.positive-single:after{position:absolute;width:30px;display:block;left:-24px;font-size:15px;top:3px;padding:0;color:#fff;display:inline-block;font-family:Guroo-Producer;font-style:normal;font-weight:400;font-variant:normal;line-height:1;text-decoration:inherit;text-rendering:optimizeLegibility;text-transform:none;-moz-osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased;font-smoothing:antialiased;text-align:center;content:\"\\F16C\"}.grid-choice-option-list .multiple-choice-option.positive-double{padding-left:15px}.grid-choice-option-list .multiple-choice-option.positive-double input+label:before{color:#39aa27}.grid-choice-option-list .multiple-choice-option.positive-double:before{position:absolute;width:30px;height:30px;background:#39aa27;border-radius:50%;font-size:12px;left:-24px;top:-5px;content:\"\"}.grid-choice-option-list .multiple-choice-option.positive-double:after{position:absolute;width:30px;display:block;left:-24px;font-size:15px;top:3px;padding:0;color:#fff;display:inline-block;font-family:Guroo-Producer;font-style:normal;font-weight:400;font-variant:normal;line-height:1;text-decoration:inherit;text-rendering:optimizeLegibility;text-transform:none;-moz-osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased;font-smoothing:antialiased;text-align:center;content:\"\\F16C\\F16B\"}.grid-choice-option-list .multiple-choice-option.unchecked.positive-single{padding-left:15px}.grid-choice-option-list .multiple-choice-option.unchecked.positive-single input+label:before{color:#39aa27}.grid-choice-option-list .multiple-choice-option.unchecked.positive-single:before{position:absolute;width:30px;height:30px;border:2px solid #39aa27;background:transparent;border-radius:50%;font-size:12px;left:-24px;top:-5px;content:\"\"}.grid-choice-option-list .multiple-choice-option.unchecked.positive-single:after{position:absolute;width:30px;display:block;left:-24px;top:3px;font-size:15px;padding:0;display:inline-block;font-family:Guroo-Producer;font-style:normal;font-weight:400;font-variant:normal;line-height:1;text-decoration:inherit;text-rendering:optimizeLegibility;text-transform:none;-moz-osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased;font-smoothing:antialiased;text-align:center;content:\"\\F16C\";color:#999}.grid-choice-option-list .multiple-choice-option.unchecked.positive-double{padding-left:15px}.grid-choice-option-list .multiple-choice-option.unchecked.positive-double input+label:before{color:#39aa27}.grid-choice-option-list .multiple-choice-option.unchecked.positive-double:before{position:absolute;width:30px;height:30px;border:2px solid #39aa27;background:transparent;border-radius:50%;font-size:12px;left:-24px;top:-5px;content:\"\"}.grid-choice-option-list .multiple-choice-option.unchecked.positive-double:after{position:absolute;width:30px;display:block;left:-24px;top:3px;font-size:15px;padding:0;color:#999;display:inline-block;font-family:Guroo-Producer;font-style:normal;font-weight:400;font-variant:normal;line-height:1;text-decoration:inherit;text-rendering:optimizeLegibility;text-transform:none;-moz-osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased;font-smoothing:antialiased;text-align:center;content:\"\\F16C\\F16B\"}.grid-choice-option-list .multiple-choice-option.negative-single{padding-left:15px}.grid-choice-option-list .multiple-choice-option.negative-single input+label:before{color:#c5000f}.grid-choice-option-list .multiple-choice-option.negative-single:before{position:absolute;width:30px;height:30px;background:#c5000f;border-radius:50%;font-size:12px;left:-24px;top:-5px;content:\"\"}.grid-choice-option-list .multiple-choice-option.negative-single:after{position:absolute;width:30px;display:block;left:-24px;top:3px;font-size:15px;padding:0;color:#fff;display:inline-block;font-family:Guroo-Producer;font-style:normal;font-weight:400;font-variant:normal;line-height:1;text-decoration:inherit;text-rendering:optimizeLegibility;text-transform:none;-moz-osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased;font-smoothing:antialiased;text-align:center;content:\"\\F16D\"}.grid-choice-option-list .multiple-choice-option.negative-double{padding-left:15px}.grid-choice-option-list .multiple-choice-option.negative-double input+label:before{color:#c5000f}.grid-choice-option-list .multiple-choice-option.negative-double:before{position:absolute;width:30px;height:30px;background:#c5000f;border-radius:50%;font-size:12px;left:-24px;top:-5px;content:\"\"}.grid-choice-option-list .multiple-choice-option.negative-double:after{position:absolute;width:30px;display:block;left:-24px;top:3px;font-size:15px;padding:0;color:#fff;display:inline-block;font-family:Guroo-Producer;font-style:normal;font-weight:400;font-variant:normal;line-height:1;text-decoration:inherit;text-rendering:optimizeLegibility;text-transform:none;-moz-osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased;font-smoothing:antialiased;text-align:center;content:\"\\F16D\\F16E\"}.grid-choice-option-list .multiple-choice-option.no-value{padding-left:15px}.grid-choice-option-list .multiple-choice-option.no-value input+label:before{color:#f6ad17}.grid-choice-option-list .multiple-choice-option.no-value:before{position:absolute;width:30px;height:30px;background:#f6ad17;border-radius:50%;font-size:12px;left:-24px;top:-5px;content:\"\"}.grid-choice-option-list .multiple-choice-option.no-value:after{position:absolute;width:30px;display:block;left:-24px;top:3px;padding:0;font-size:15px;color:#fff;display:inline-block;font-family:Guroo-Producer;font-style:normal;font-weight:400;font-variant:normal;line-height:1;text-decoration:inherit;text-rendering:optimizeLegibility;text-transform:none;-moz-osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased;font-smoothing:antialiased;text-align:center;content:\"\\F12E\"}.grid-choice-option-list .multiple-choice-option.selected{cursor:pointer}.grid-choice-option-list .multiple-choice-option.selected input[type=radio]+label .label-text:before{position:absolute;content:\"\\F179\"}.grid-choice-option-list .multiple-choice-option.selected.poor input[type=checkbox]:checked+label .label-text:before,.grid-choice-option-list .multiple-choice-option.selected input[type=radio]+label .label-text:before{display:inline-block;font-family:Guroo-Producer;font-style:normal;font-weight:400;font-variant:normal;line-height:1;text-decoration:inherit;text-rendering:optimizeLegibility;text-transform:none;-moz-osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased;font-smoothing:antialiased}.grid-choice-option-list .multiple-choice-option.selected.poor input[type=checkbox]:checked+label .label-text:before{padding-right:10px;content:\"\\F17B\"}.grid-choice-option-list .multiple-choice-option.best{border-color:#39aa27!important}.grid-choice-option-list .multiple-choice-option.best label{color:#333!important}.grid-choice-option-list .multiple-choice-option.poor{border-color:#c5000f!important;background:#ffecf8}.grid-choice-option-list .multiple-choice-option.poor label{color:#333!important}.grid-choice-option-list .multiple-choice-option.ok{border-color:#f6ad17!important}.grid-choice-option-list .multiple-choice-option.ok label{color:#333!important}.grid-choice-option-list .multiple-choice-option.reflective{border-color:#6592cb!important}.grid-choice-option-list .multiple-choice-option.reflective label{color:#333!important}.grid-choice-option-list .multiple-choice-option.best input+label .label-text:before{color:#39aa27!important}.grid-choice-option-list .multiple-choice-option.ok input+label .label-text:before{color:#f6ad17!important}.grid-choice-option-list .multiple-choice-option.poor input+label .label-text:before{color:#c5000f!important}.grid-choice-option-list .multiple-choice-option.reflective:before,.grid-choice-option-list .multiple-choice-option.reflective input+label .label-text:before{color:#6592cb!important}.grid-choice-option-list .multiple-choice-option.show-answer input[type=radio]+label .label-text{padding-left:24px}.grid-choice-option-list .multiple-choice-option.show-answer input[type=radio]+label .label-text:before{position:absolute;left:12px;top:12px;font-size:24px;display:inline-block;font-family:Guroo-Producer;font-style:normal;font-weight:400;font-variant:normal;line-height:1;text-decoration:inherit;text-rendering:optimizeLegibility;text-transform:none;-moz-osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased;font-smoothing:antialiased;content:\"\\F179\"}.grid-choice-option-list .multiple-choice-option.show-answer.best input+label .label-text:before{color:#39aa27!important}.grid-choice-option-list .multiple-choice-option.show-answer.ok input+label .label-text:before{color:#f6ad17!important}.grid-choice-option-list .multiple-choice-option.show-answer.poor input+label .label-text:before{color:#c5000f!important}.grid-choice-option-list .multiple-choice-option.show-answer.reflective:before,.grid-choice-option-list .multiple-choice-option.show-answer.reflective input+label .label-text:before{color:#6592cb!important}.grid-choice-option-list .multiple-choice-option.inactive-answered input:disabled+label,.grid-choice-option-list .multiple-choice-option.review-selected input:disabled+label,.grid-choice-option-list .multiple-choice-option.review input:disabled+label{cursor:default}@media only screen and (max-width:375px) and (max-height:736px) and (orientation:portrait){.grid-choice-option-list{display:block!important}.grid-choice-option-list .multiple-choice-option{width:calc(100% - 6px);margin:0 3px 5px}}@media only screen and (max-height:375px) and (max-width:736px) and (orientation:landscape){.grid-choice-option-list{display:block!important}.grid-choice-option-list .multiple-choice-option{width:calc(100% - 6px);margin:0 3px 5px}}@media only screen and (min-width:376px) and (max-width:414px) and (max-height:736px) and (orientation:portrait){.grid-choice-option-list{display:block!important}.grid-choice-option-list .multiple-choice-option{width:calc(100% - 6px);margin:0 3px 5px}}@media only screen and (min-height:376px) and (max-height:414px) and (max-width:736px) and (orientation:landscape){.grid-choice-option-list{display:block!important}.grid-choice-option-list .multiple-choice-option{width:calc(100% - 6px);margin:0 3px 5px}}@media only screen and (max-width:375px) and (min-height:737px) and (max-height:812px) and (orientation:portrait){.grid-choice-option-list{display:block!important}.grid-choice-option-list .multiple-choice-option{width:calc(100% - 6px);margin:0 3px 5px}}@media only screen and (min-width:737px) and (max-width:812px) and (max-height:375px) and (orientation:landscape){.grid-choice-option-list{display:block!important}.grid-choice-option-list .multiple-choice-option{width:calc(100% - 6px);margin:0 3px 5px}}@media only screen and (max-width:320px) and (max-height:568px) and (orientation:portrait){.grid-choice-option-list{display:block!important}.grid-choice-option-list .multiple-choice-option{width:calc(100% - 6px);margin:0 3px 5px}}@media only screen and (max-width:320px) and (max-height:568px) and (orientation:landscape){.grid-choice-option-list{display:block!important}.grid-choice-option-list .multiple-choice-option{width:calc(100% - 6px);margin:0 3px 5px}}.object-container-conversation{display:block;position:relative;overflow:hidden;clear:both;margin:0 0 5px;padding-bottom:5px}.object-container-conversation .object-container:last-child{margin-bottom:0}.object-container-conversation+.feedback-panel{margin-top:20px}.character-expression{display:none}.character{display:inline-block;overflow:visible;margin:0;font-weight:400;padding:14px 24px;line-height:130%;transition:opacity .3s ease,border-radius .6s ease,color .2s ease;max-width:90%;width:auto;position:relative;margin-left:15px;margin-bottom:2px!important;z-index:2}.character.speak{border-radius:20px}.character.behaviour{border-top-left-radius:20px;border-top-right-radius:20px;border-bottom-left-radius:20px;border-style:solid;border-width:2px}.character:after{content:\"\";bottom:5px;left:-30px;position:absolute;border:0 solid;display:block;width:30px;height:18px;border-bottom-left-radius:50%;border-bottom-right-radius:50%}.character p:last-child{margin-bottom:0}.character-conversation-image{display:inline-block;overflow:visible;margin:0;font-weight:400;line-height:130%;transition:opacity .3s ease,border-radius .6s ease,color .2s ease;max-width:90%;border-radius:20px;border:none;margin-left:15px;margin-bottom:2px;padding:14px 24px}.character-conversation-image img{display:block;overflow:hidden;max-width:100%;width:auto;height:auto}.character-conversation-image:after{content:\"\";bottom:11px;left:-15px;position:absolute;border:0 solid;display:block;width:30px;height:18px;border-bottom-left-radius:50%;border-bottom-right-radius:50%}@media only screen and (max-width:375px) and (max-height:736px) and (orientation:portrait){.object-feed .customer-has-expression .customer_name_label{padding:0 0 0 100px}.object-feed .customer-has-expression .character-expression{display:block;position:absolute;left:1px;bottom:1px!important;overflow:hidden;height:60px!important;width:60px;background:#fff;border:4px solid #fff;border-radius:50%;-webkit-box-shadow:0 0 0 1px #d5d5d5;-moz-box-shadow:0 0 0 1px #d5d5d5;box-shadow:0 0 0 1px #d5d5d5}.object-feed .customer-has-expression .character-expression img{position:absolute;top:0;margin:auto;width:100%;height:auto}.object-feed .customer-has-expression .character-expression.close_up img{height:90%;width:auto;top:unset;bottom:0!important}.object-feed .customer-has-expression .character-expression.best{-webkit-box-shadow:0 0 0 1px #39aa27;-moz-box-shadow:0 0 0 1px #39aa27;box-shadow:0 0 0 1px #39aa27}.object-feed .customer-has-expression .character-expression.ok{-webkit-box-shadow:0 0 0 1px #f6ad17;-moz-box-shadow:0 0 0 1px #f6ad17;box-shadow:0 0 0 1px #f6ad17}.object-feed .customer-has-expression .character-expression.poor{-webkit-box-shadow:0 0 0 1px #c5000f;-moz-box-shadow:0 0 0 1px #c5000f;box-shadow:0 0 0 1px #c5000f}.object-feed .customer-has-expression .character-expression.reflective{-webkit-box-shadow:0 0 0 1px #6592cb;-moz-box-shadow:0 0 0 1px #6592cb;box-shadow:0 0 0 1px #6592cb}.object-feed .customer-has-expression .character,.object-feed .customer-has-expression .character-conversation-image{margin:0 0 0 75px}.object-feed .customer-has-expression .character-conversation-image:after{left:35px}}@media only screen and (max-height:375px) and (max-width:736px) and (orientation:landscape){.object-feed .customer-has-expression .customer_name_label{padding:0 0 0 100px}.object-feed .customer-has-expression .character-expression{display:block;position:absolute;left:1px;bottom:1px!important;overflow:hidden;height:60px!important;width:60px;background:#fff;border:4px solid #fff;border-radius:50%;-webkit-box-shadow:0 0 0 1px #d5d5d5;-moz-box-shadow:0 0 0 1px #d5d5d5;box-shadow:0 0 0 1px #d5d5d5}.object-feed .customer-has-expression .character-expression img{position:absolute;top:0;margin:auto;width:100%;height:auto}.object-feed .customer-has-expression .character-expression.close_up img{height:90%;width:auto;top:unset;bottom:0!important}.object-feed .customer-has-expression .character-expression.best{-webkit-box-shadow:0 0 0 1px #39aa27;-moz-box-shadow:0 0 0 1px #39aa27;box-shadow:0 0 0 1px #39aa27}.object-feed .customer-has-expression .character-expression.ok{-webkit-box-shadow:0 0 0 1px #f6ad17;-moz-box-shadow:0 0 0 1px #f6ad17;box-shadow:0 0 0 1px #f6ad17}.object-feed .customer-has-expression .character-expression.poor{-webkit-box-shadow:0 0 0 1px #c5000f;-moz-box-shadow:0 0 0 1px #c5000f;box-shadow:0 0 0 1px #c5000f}.object-feed .customer-has-expression .character-expression.reflective{-webkit-box-shadow:0 0 0 1px #6592cb;-moz-box-shadow:0 0 0 1px #6592cb;box-shadow:0 0 0 1px #6592cb}.object-feed .customer-has-expression .character,.object-feed .customer-has-expression .character-conversation-image{margin:0 0 0 75px}.object-feed .customer-has-expression .character-conversation-image:after{left:35px}}@media only screen and (min-width:376px) and (max-width:414px) and (max-height:736px) and (orientation:portrait){.object-feed .customer-has-expression .customer_name_label{padding:0 0 0 100px}.object-feed .customer-has-expression .character-expression{display:block;position:absolute;left:1px;bottom:1px!important;overflow:hidden;height:60px!important;width:60px;background:#fff;border:4px solid #fff;border-radius:50%;-webkit-box-shadow:0 0 0 1px #d5d5d5;-moz-box-shadow:0 0 0 1px #d5d5d5;box-shadow:0 0 0 1px #d5d5d5}.object-feed .customer-has-expression .character-expression img{position:absolute;top:0;margin:auto;width:100%;height:auto}.object-feed .customer-has-expression .character-expression.close_up img{height:90%;width:auto;top:unset;bottom:0!important}.object-feed .customer-has-expression .character-expression.best{-webkit-box-shadow:0 0 0 1px #39aa27;-moz-box-shadow:0 0 0 1px #39aa27;box-shadow:0 0 0 1px #39aa27}.object-feed .customer-has-expression .character-expression.ok{-webkit-box-shadow:0 0 0 1px #f6ad17;-moz-box-shadow:0 0 0 1px #f6ad17;box-shadow:0 0 0 1px #f6ad17}.object-feed .customer-has-expression .character-expression.poor{-webkit-box-shadow:0 0 0 1px #c5000f;-moz-box-shadow:0 0 0 1px #c5000f;box-shadow:0 0 0 1px #c5000f}.object-feed .customer-has-expression .character-expression.reflective{-webkit-box-shadow:0 0 0 1px #6592cb;-moz-box-shadow:0 0 0 1px #6592cb;box-shadow:0 0 0 1px #6592cb}.object-feed .customer-has-expression .character,.object-feed .customer-has-expression .character-conversation-image{margin:0 0 0 75px}.object-feed .customer-has-expression .character-conversation-image:after{left:35px}}@media only screen and (min-height:376px) and (max-height:414px) and (max-width:736px) and (orientation:landscape){.object-feed .customer-has-expression .customer_name_label{padding:0 0 0 100px}.object-feed .customer-has-expression .character-expression{display:block;position:absolute;left:1px;bottom:1px!important;overflow:hidden;height:60px!important;width:60px;background:#fff;border:4px solid #fff;border-radius:50%;-webkit-box-shadow:0 0 0 1px #d5d5d5;-moz-box-shadow:0 0 0 1px #d5d5d5;box-shadow:0 0 0 1px #d5d5d5}.object-feed .customer-has-expression .character-expression img{position:absolute;top:0;margin:auto;width:100%;height:auto}.object-feed .customer-has-expression .character-expression.close_up img{height:90%;width:auto;top:unset;bottom:0!important}.object-feed .customer-has-expression .character-expression.best{-webkit-box-shadow:0 0 0 1px #39aa27;-moz-box-shadow:0 0 0 1px #39aa27;box-shadow:0 0 0 1px #39aa27}.object-feed .customer-has-expression .character-expression.ok{-webkit-box-shadow:0 0 0 1px #f6ad17;-moz-box-shadow:0 0 0 1px #f6ad17;box-shadow:0 0 0 1px #f6ad17}.object-feed .customer-has-expression .character-expression.poor{-webkit-box-shadow:0 0 0 1px #c5000f;-moz-box-shadow:0 0 0 1px #c5000f;box-shadow:0 0 0 1px #c5000f}.object-feed .customer-has-expression .character-expression.reflective{-webkit-box-shadow:0 0 0 1px #6592cb;-moz-box-shadow:0 0 0 1px #6592cb;box-shadow:0 0 0 1px #6592cb}.object-feed .customer-has-expression .character,.object-feed .customer-has-expression .character-conversation-image{margin:0 0 0 75px}.object-feed .customer-has-expression .character-conversation-image:after{left:35px}}@media only screen and (max-width:375px) and (min-height:737px) and (max-height:812px) and (orientation:portrait){.object-feed .customer-has-expression .customer_name_label{padding:0 0 0 100px}.object-feed .customer-has-expression .character-expression{display:block;position:absolute;left:1px;bottom:1px!important;overflow:hidden;height:60px!important;width:60px;background:#fff;border:4px solid #fff;border-radius:50%;-webkit-box-shadow:0 0 0 1px #d5d5d5;-moz-box-shadow:0 0 0 1px #d5d5d5;box-shadow:0 0 0 1px #d5d5d5}.object-feed .customer-has-expression .character-expression img{position:absolute;top:0;margin:auto;width:100%;height:auto}.object-feed .customer-has-expression .character-expression.close_up img{height:90%;width:auto;top:unset;bottom:0!important}.object-feed .customer-has-expression .character-expression.best{-webkit-box-shadow:0 0 0 1px #39aa27;-moz-box-shadow:0 0 0 1px #39aa27;box-shadow:0 0 0 1px #39aa27}.object-feed .customer-has-expression .character-expression.ok{-webkit-box-shadow:0 0 0 1px #f6ad17;-moz-box-shadow:0 0 0 1px #f6ad17;box-shadow:0 0 0 1px #f6ad17}.object-feed .customer-has-expression .character-expression.poor{-webkit-box-shadow:0 0 0 1px #c5000f;-moz-box-shadow:0 0 0 1px #c5000f;box-shadow:0 0 0 1px #c5000f}.object-feed .customer-has-expression .character-expression.reflective{-webkit-box-shadow:0 0 0 1px #6592cb;-moz-box-shadow:0 0 0 1px #6592cb;box-shadow:0 0 0 1px #6592cb}.object-feed .customer-has-expression .character,.object-feed .customer-has-expression .character-conversation-image{margin:0 0 0 75px}.object-feed .customer-has-expression .character-conversation-image:after{left:35px}}@media only screen and (min-height:737px) and (max-height:812px) and (max-width:375px) and (orientation:landscape){.object-feed .customer-has-expression .customer_name_label{padding:0 0 0 100px}.object-feed .customer-has-expression .character-expression{display:block;position:absolute;left:1px;bottom:1px!important;overflow:hidden;height:60px!important;width:60px;background:#fff;border:4px solid #fff;border-radius:50%;-webkit-box-shadow:0 0 0 1px #d5d5d5;-moz-box-shadow:0 0 0 1px #d5d5d5;box-shadow:0 0 0 1px #d5d5d5}.object-feed .customer-has-expression .character-expression img{position:absolute;top:0;margin:auto;width:100%;height:auto}.object-feed .customer-has-expression .character-expression.close_up img{height:90%;width:auto;top:unset;bottom:0!important}.object-feed .customer-has-expression .character-expression.best{-webkit-box-shadow:0 0 0 1px #39aa27;-moz-box-shadow:0 0 0 1px #39aa27;box-shadow:0 0 0 1px #39aa27}.object-feed .customer-has-expression .character-expression.ok{-webkit-box-shadow:0 0 0 1px #f6ad17;-moz-box-shadow:0 0 0 1px #f6ad17;box-shadow:0 0 0 1px #f6ad17}.object-feed .customer-has-expression .character-expression.poor{-webkit-box-shadow:0 0 0 1px #c5000f;-moz-box-shadow:0 0 0 1px #c5000f;box-shadow:0 0 0 1px #c5000f}.object-feed .customer-has-expression .character-expression.reflective{-webkit-box-shadow:0 0 0 1px #6592cb;-moz-box-shadow:0 0 0 1px #6592cb;box-shadow:0 0 0 1px #6592cb}.object-feed .customer-has-expression .character,.object-feed .customer-has-expression .character-conversation-image{margin:0 0 0 75px}.object-feed .customer-has-expression .character-conversation-image:after{left:35px}}@media only screen and (min-width:768px) and (max-width:1024px) and (orientation:portrait){.object-feed .customer-has-expression .customer_name_label{padding:0 0 0 100px}.object-feed .customer-has-expression .character-expression{display:block;position:absolute;left:1px;bottom:1px!important;overflow:hidden;height:60px!important;width:60px;background:#fff;border:4px solid #fff;border-radius:50%;-webkit-box-shadow:0 0 0 1px #d5d5d5;-moz-box-shadow:0 0 0 1px #d5d5d5;box-shadow:0 0 0 1px #d5d5d5}.object-feed .customer-has-expression .character-expression img{position:absolute;top:0;margin:auto;width:100%;height:auto}.object-feed .customer-has-expression .character-expression.close_up img{height:90%;width:auto;top:unset;bottom:0!important}.object-feed .customer-has-expression .character-expression.best{-webkit-box-shadow:0 0 0 1px #39aa27;-moz-box-shadow:0 0 0 1px #39aa27;box-shadow:0 0 0 1px #39aa27}.object-feed .customer-has-expression .character-expression.ok{-webkit-box-shadow:0 0 0 1px #f6ad17;-moz-box-shadow:0 0 0 1px #f6ad17;box-shadow:0 0 0 1px #f6ad17}.object-feed .customer-has-expression .character-expression.poor{-webkit-box-shadow:0 0 0 1px #c5000f;-moz-box-shadow:0 0 0 1px #c5000f;box-shadow:0 0 0 1px #c5000f}.object-feed .customer-has-expression .character-expression.reflective{-webkit-box-shadow:0 0 0 1px #6592cb;-moz-box-shadow:0 0 0 1px #6592cb;box-shadow:0 0 0 1px #6592cb}.object-feed .customer-has-expression .character,.object-feed .customer-has-expression .character-conversation-image{margin:0 0 0 75px}.object-feed .customer-has-expression .character-conversation-image:after{left:35px}}@media only screen and (min-width:768px) and (max-width:979px){.object-feed .customer-has-expression .customer_name_label{padding:0 0 0 100px}.object-feed .customer-has-expression .character-expression{display:block;position:absolute;left:1px;bottom:1px!important;overflow:hidden;height:60px!important;width:60px;background:#fff;border:4px solid #fff;border-radius:50%;-webkit-box-shadow:0 0 0 1px #d5d5d5;-moz-box-shadow:0 0 0 1px #d5d5d5;box-shadow:0 0 0 1px #d5d5d5}.object-feed .customer-has-expression .character-expression img{position:absolute;top:0;margin:auto;width:100%;height:auto}.object-feed .customer-has-expression .character-expression.close_up img{height:90%;width:auto;top:unset;bottom:0!important}.object-feed .customer-has-expression .character-expression.best{-webkit-box-shadow:0 0 0 1px #39aa27;-moz-box-shadow:0 0 0 1px #39aa27;box-shadow:0 0 0 1px #39aa27}.object-feed .customer-has-expression .character-expression.ok{-webkit-box-shadow:0 0 0 1px #f6ad17;-moz-box-shadow:0 0 0 1px #f6ad17;box-shadow:0 0 0 1px #f6ad17}.object-feed .customer-has-expression .character-expression.poor{-webkit-box-shadow:0 0 0 1px #c5000f;-moz-box-shadow:0 0 0 1px #c5000f;box-shadow:0 0 0 1px #c5000f}.object-feed .customer-has-expression .character-expression.reflective{-webkit-box-shadow:0 0 0 1px #6592cb;-moz-box-shadow:0 0 0 1px #6592cb;box-shadow:0 0 0 1px #6592cb}.object-feed .customer-has-expression .character,.object-feed .customer-has-expression .character-conversation-image{margin:0 0 0 75px}.object-feed .customer-has-expression .character-conversation-image:after{left:35px}}.learner{display:block;overflow:visible;margin:0 15px 2px 0;font-weight:400;float:right;padding:14px 24px;line-height:130%;transition:opacity .3s ease,border-radius .6s ease,color .2s ease;max-width:calc(80% + 20px);border:none}@media only screen and (max-width:375px) and (max-height:736px) and (orientation:portrait){.learner{margin-right:12px}}@media only screen and (min-width:376px) and (max-width:414px) and (max-height:736px) and (orientation:portrait){.learner{margin-right:12px}}@media only screen and (max-width:375px) and (min-height:737px) and (max-height:812px) and (orientation:portrait){.learner{margin-right:12px}}.learner.speak{border-radius:20px}.learner.behaviour{border-top-left-radius:20px;border-top-right-radius:20px;border-bottom-left-radius:20px}.learner:after{content:\"\";bottom:7px;right:-15px;position:absolute;border:0 solid;display:block;width:30px;height:18px;background-color:transparent;border-bottom-left-radius:50%;border-bottom-right-radius:50%}.learner p:last-child{margin-bottom:0}.learner-conversation-image{display:block;overflow:visible;margin:0 15px 2px 0;font-weight:400;float:right;padding:14px 24px;line-height:130%;transition:opacity .3s ease,border-radius .6s ease,color .2s ease;max-width:calc(80% + 20px);border:none;border-radius:20px}.learner-conversation-image img{display:block;overflow:hidden;width:100%;height:auto}.learner-conversation-image:after{content:\"\";bottom:7px;right:-15px;position:absolute;border:0 solid;display:block;width:30px;height:18px;background-color:transparent;border-bottom-left-radius:50%;border-bottom-right-radius:50%}.narrator{font-weight:400;padding:14px 24px;line-height:130%;transition:opacity .3s ease,border-radius .6s ease,color .2s ease;border-style:solid;border-width:2px;border-radius:20px}.feedback-options-container,.narrator{display:block;overflow:hidden;margin:0}.feedback-options-container{position:relative;clear:both}.feedback-options-container .feedback-options-panel{clear:both;margin:10px 0;padding:5px 24px 10px;border-bottom-width:1px;border-bottom-style:dashed}.feedback-options-container .feedback-options-panel:last-child{border-bottom:none}.feedback-options-container .feedback-options-panel .missed-options-label{font-style:italic;margin:0 -24px!important}.feedback-options-container .feedback-options-panel .feedback-options{margin:0;padding:0}.feedback-options-container .feedback-options-panel .feedback-options .feedback-option{display:block;position:relative;list-style-type:none;padding:6px 0;font-size:90%;font-style:italic}.feedback-options-container .feedback-options-panel .feedback-options .feedback-option:before{position:absolute;left:-24px;font-size:20px;padding:0 10px 0 0;display:inline-block;font-family:Guroo-Producer;font-style:normal;font-weight:400;font-variant:normal;line-height:1;text-decoration:inherit;text-rendering:optimizeLegibility;text-transform:none;-moz-osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased;font-smoothing:antialiased;content:\"\\F175\"}.feedback-options-container .feedback-options-panel .feedback-options .feedback-option.unchecked{color:#999}.feedback-options-container .feedback-options-panel .feedback-options .feedback-option.unchecked:before{content:\"\\F175\"}.feedback-options-container .feedback-options-panel .feedback-options .feedback-option.checked:before{content:\"\\F179\"}.feedback-options-container .feedback-options-panel .feedback-options .feedback-option.poor input[type=checkbox]:checked+label:before{color:#c5000f;content:\"\\F277\"}.feedback-options-container .feedback-options-panel .feedback-options .feedback-option.ok input[type=checkbox]:checked+label:before,.feedback-options-container .feedback-options-panel .feedback-options .feedback-option.poor input[type=checkbox]:checked+label:before{padding-right:10px;display:inline-block;font-family:Guroo-Producer;font-style:normal;font-weight:400;font-variant:normal;line-height:1;text-decoration:inherit;text-rendering:optimizeLegibility;text-transform:none;-moz-osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased;font-smoothing:antialiased}.feedback-options-container .feedback-options-panel .feedback-options .feedback-option.ok input[type=checkbox]:checked+label:before{color:#f6ad17;content:\"\\F276\"}.feedback-options-container .feedback-options-panel .feedback-options .feedback-option.best input[type=checkbox]:checked+label:before{padding-right:10px;color:#39aa27;display:inline-block;font-family:Guroo-Producer;font-style:normal;font-weight:400;font-variant:normal;line-height:1;text-decoration:inherit;text-rendering:optimizeLegibility;text-transform:none;-moz-osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased;font-smoothing:antialiased;content:\"\\F275\"}.feedback-options-container .feedback-options-panel .feedback-options .feedback-option.missed:hover{background:transparent!important}.feedback-options-container .feedback-options-panel .feedback-options .feedback-option.best:before,.feedback-options-container .feedback-options-panel .feedback-options .feedback-option.best input+label:before,.feedback-options-container .feedback-options-panel .feedback-options .feedback-option.missed:before,.feedback-options-container .feedback-options-panel .feedback-options .feedback-option.missed input+label:before{color:#39aa27}.feedback-options-container .feedback-options-panel .feedback-options .feedback-option.ok:before,.feedback-options-container .feedback-options-panel .feedback-options .feedback-option.ok input+label:before{color:#f6ad17}.feedback-options-container .feedback-options-panel .feedback-options .feedback-option.poor:before,.feedback-options-container .feedback-options-panel .feedback-options .feedback-option.poor input+label:before{color:#c5000f}.feedback-options-container .feedback-options-panel .feedback-options .feedback-option.reflective:before,.feedback-options-container .feedback-options-panel .feedback-options .feedback-option.reflective input+label:before{color:#6592cb!important}.feedback-options-container .feedback-options-panel .feedback-options .feedback-option.positive-single{padding-left:15px}.feedback-options-container .feedback-options-panel .feedback-options .feedback-option.positive-single input+label:before{color:#39aa27}.feedback-options-container .feedback-options-panel .feedback-options .feedback-option.positive-single:before{position:absolute;width:30px;height:30px;background:#39aa27;border-radius:50%;font-size:12px;left:-24px;top:-5px;content:\"\"}.feedback-options-container .feedback-options-panel .feedback-options .feedback-option.positive-single:after{position:absolute;width:30px;display:block;left:-24px;font-size:15px;top:3px;padding:0;color:#fff;display:inline-block;font-family:Guroo-Producer;font-style:normal;font-weight:400;font-variant:normal;line-height:1;text-decoration:inherit;text-rendering:optimizeLegibility;text-transform:none;-moz-osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased;font-smoothing:antialiased;text-align:center;content:\"\\F16C\"}.feedback-options-container .feedback-options-panel .feedback-options .feedback-option.positive-double{padding-left:15px}.feedback-options-container .feedback-options-panel .feedback-options .feedback-option.positive-double input+label:before{color:#39aa27}.feedback-options-container .feedback-options-panel .feedback-options .feedback-option.positive-double:before{position:absolute;width:30px;height:30px;background:#39aa27;border-radius:50%;font-size:12px;left:-24px;top:-5px;content:\"\"}.feedback-options-container .feedback-options-panel .feedback-options .feedback-option.positive-double:after{position:absolute;width:30px;display:block;left:-24px;font-size:15px;top:3px;padding:0;color:#fff;display:inline-block;font-family:Guroo-Producer;font-style:normal;font-weight:400;font-variant:normal;line-height:1;text-decoration:inherit;text-rendering:optimizeLegibility;text-transform:none;-moz-osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased;font-smoothing:antialiased;text-align:center;content:\"\\F16C\\F16B\"}.feedback-options-container .feedback-options-panel .feedback-options .feedback-option.unchecked.positive-single{padding-left:15px}.feedback-options-container .feedback-options-panel .feedback-options .feedback-option.unchecked.positive-single input+label:before{color:#39aa27}.feedback-options-container .feedback-options-panel .feedback-options .feedback-option.unchecked.positive-single:before{position:absolute;width:30px;height:30px;border:2px solid #39aa27;background:transparent;border-radius:50%;font-size:12px;left:-24px;top:-5px;content:\"\"}.feedback-options-container .feedback-options-panel .feedback-options .feedback-option.unchecked.positive-single:after{position:absolute;width:30px;display:block;left:-24px;top:3px;font-size:15px;padding:0;display:inline-block;font-family:Guroo-Producer;font-style:normal;font-weight:400;font-variant:normal;line-height:1;text-decoration:inherit;text-rendering:optimizeLegibility;text-transform:none;-moz-osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased;font-smoothing:antialiased;text-align:center;content:\"\\F16C\";color:#999}.feedback-options-container .feedback-options-panel .feedback-options .feedback-option.unchecked.positive-double{padding-left:15px}.feedback-options-container .feedback-options-panel .feedback-options .feedback-option.unchecked.positive-double input+label:before{color:#39aa27}.feedback-options-container .feedback-options-panel .feedback-options .feedback-option.unchecked.positive-double:before{position:absolute;width:30px;height:30px;border:2px solid #39aa27;background:transparent;border-radius:50%;font-size:12px;left:-24px;top:-5px;content:\"\"}.feedback-options-container .feedback-options-panel .feedback-options .feedback-option.unchecked.positive-double:after{position:absolute;width:30px;display:block;left:-24px;top:3px;font-size:15px;padding:0;color:#999;display:inline-block;font-family:Guroo-Producer;font-style:normal;font-weight:400;font-variant:normal;line-height:1;text-decoration:inherit;text-rendering:optimizeLegibility;text-transform:none;-moz-osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased;font-smoothing:antialiased;text-align:center;content:\"\\F16C\\F16B\"}.feedback-options-container .feedback-options-panel .feedback-options .feedback-option.negative-single{padding-left:15px}.feedback-options-container .feedback-options-panel .feedback-options .feedback-option.negative-single input+label:before{color:#c5000f}.feedback-options-container .feedback-options-panel .feedback-options .feedback-option.negative-single:before{position:absolute;width:30px;height:30px;background:#c5000f;border-radius:50%;font-size:12px;left:-24px;top:-5px;content:\"\"}.feedback-options-container .feedback-options-panel .feedback-options .feedback-option.negative-single:after{position:absolute;width:30px;display:block;left:-24px;top:3px;font-size:15px;padding:0;color:#fff;display:inline-block;font-family:Guroo-Producer;font-style:normal;font-weight:400;font-variant:normal;line-height:1;text-decoration:inherit;text-rendering:optimizeLegibility;text-transform:none;-moz-osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased;font-smoothing:antialiased;text-align:center;content:\"\\F16D\"}.feedback-options-container .feedback-options-panel .feedback-options .feedback-option.negative-double{padding-left:15px}.feedback-options-container .feedback-options-panel .feedback-options .feedback-option.negative-double input+label:before{color:#c5000f}.feedback-options-container .feedback-options-panel .feedback-options .feedback-option.negative-double:before{position:absolute;width:30px;height:30px;background:#c5000f;border-radius:50%;font-size:12px;left:-24px;top:-5px;content:\"\"}.feedback-options-container .feedback-options-panel .feedback-options .feedback-option.negative-double:after{position:absolute;width:30px;display:block;left:-24px;top:3px;font-size:15px;padding:0;color:#fff;display:inline-block;font-family:Guroo-Producer;font-style:normal;font-weight:400;font-variant:normal;line-height:1;text-decoration:inherit;text-rendering:optimizeLegibility;text-transform:none;-moz-osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased;font-smoothing:antialiased;text-align:center;content:\"\\F16D\\F16E\"}.feedback-options-container .feedback-options-panel .feedback-options .feedback-option.no-value{padding-left:15px}.feedback-options-container .feedback-options-panel .feedback-options .feedback-option.no-value input+label:before{color:#f6ad17}.feedback-options-container .feedback-options-panel .feedback-options .feedback-option.no-value:before{position:absolute;width:30px;height:30px;background:#f6ad17;border-radius:50%;font-size:12px;left:-24px;top:-5px;content:\"\"}.feedback-options-container .feedback-options-panel .feedback-options .feedback-option.no-value:after{position:absolute;width:30px;display:block;left:-24px;top:3px;padding:0;font-size:15px;color:#fff;display:inline-block;font-family:Guroo-Producer;font-style:normal;font-weight:400;font-variant:normal;line-height:1;text-decoration:inherit;text-rendering:optimizeLegibility;text-transform:none;-moz-osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased;font-smoothing:antialiased;text-align:center;content:\"\\F12E\"}.feedback-options-container .feedback-options-panel .feedback-options .feedback-option:first-child{padding-top:0}.feedback-options-container .feedback-options-panel .feedback-options .feedback-option:last-child{padding-bottom:0}.feedback-options-container .feedback-options-panel .feedback-option-feedback{padding:12px 0}.missed-options{display:block;overflow:hidden}.missed-options .missed-options-label{font-style:italic;padding:15px 0!important}.missed-options .multiple-choice-option-list{overflow:hidden;padding:0;margin-left:0;margin-right:0}.missed-options .multiple-choice-option-list label{color:#999;padding-left:35px!important}.missed-options .multiple-choice-option-list label:before{left:0!important;color:#39aa27!important}.document-panel{display:-webkit-flex;display:flex;flex-flow:row nowrap;padding:0;margin:0;position:relative}.document-panel .thumbnail-container{width:100px;background:#fff;border:1px solid #eff0f2;padding:2px;margin-right:5px;margin-bottom:12px}.document-panel .thumbnail-container img{width:100%}.document-panel .link-title{padding:0 0 0 20px;font-weight:700}.document-panel .link-title.not-started:before{height:16px;color:#999;content:\"\\F16A\"}.document-panel .link-title.complete:before,.document-panel .link-title.not-started:before{position:absolute;left:0;top:0;bottom:0;margin:auto;padding-right:10px;font-size:16px;display:inline-block;font-family:Guroo-Producer;font-style:normal;font-weight:400;font-variant:normal;line-height:1;text-decoration:inherit;text-rendering:optimizeLegibility;text-transform:none;-moz-osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased;font-smoothing:antialiased}.document-panel .link-title.complete:before{color:#39aa27;content:\"\\F16F\"}.document-panel .link-title.file a:before{content:\"\\F11F\"}.document-panel .link-title.file a:before,.document-panel .link-title.link a:before{padding-right:5px;display:inline-block;font-family:Guroo-Producer;font-style:normal;font-weight:400;font-variant:normal;line-height:1;text-decoration:inherit;text-rendering:optimizeLegibility;text-transform:none;-moz-osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased;font-smoothing:antialiased}.document-panel .link-title.link a:before{content:\"\\F17D\"}.document-panel .link-sub-title{padding:0 0 0 44px;font-size:80%}.document-panel .document-description{padding:0 0 0 44px;display:block;font-size:90%}.document-panel .document-header{display:block;position:relative;width:100%!important;margin:0 0 4px;padding:0}.document-panel .object-container{padding:0!important}.no-wrap{white-space:nowrap}.character-image{z-index:2}.prev-character-image{z-index:1}.footer{padding:8px 12px;margin:0 auto;margin:0 auto!important;max-width:1200px!important;min-width:320px!important}.footer img{height:50px;width:auto}@media only screen and (max-width:375px) and (max-height:736px) and (orientation:portrait){.footer img{height:25px}}@media only screen and (max-height:375px) and (max-width:736px) and (orientation:landscape){.footer img{height:25px}}@media only screen and (min-width:376px) and (max-width:414px) and (max-height:736px) and (orientation:portrait){.footer img{height:25px}}@media only screen and (min-height:376px) and (max-height:414px) and (max-width:736px) and (orientation:landscape){.footer img{height:25px}}@media only screen and (max-width:375px) and (min-height:737px) and (max-height:812px) and (orientation:portrait){.footer img{height:25px}}@media only screen and (min-height:737px) and (max-height:812px) and (max-width:375px) and (orientation:landscape){.footer img{height:25px}}.footer .footer-text{padding:12px 0;font-size:90%}.footer .footer-text a{text-decoration:underline}@media only screen and (max-width:375px) and (max-height:736px) and (orientation:portrait){.footer{display:none}}@media only screen and (max-height:375px) and (max-width:736px) and (orientation:landscape){.footer{display:none}}@media only screen and (min-width:376px) and (max-width:414px) and (max-height:736px) and (orientation:portrait){.footer{display:none}}@media only screen and (min-height:376px) and (max-height:414px) and (max-width:736px) and (orientation:landscape){.footer{display:none}}@media only screen and (max-width:375px) and (min-height:737px) and (max-height:812px) and (orientation:portrait){.footer{display:none}}@media only screen and (min-height:737px) and (max-height:812px) and (max-width:375px) and (orientation:landscape){.footer{display:none}}.feed-anti-margin{margin-left:-24px;margin-right:-24px}.standard-block{padding:0 0 0 24px}.call-out-style-1,.call-out-style-2,.call-out-style-3,.call-out-style-4{display:block;position:relative;overflow:hidden;border-width:2px;border-radius:5px;padding:16px 24px}@media only screen and (max-width:375px) and (max-height:736px) and (orientation:portrait){.call-out-style-1,.call-out-style-2,.call-out-style-3,.call-out-style-4{padding:10px 12px}}@media only screen and (max-height:375px) and (max-width:736px) and (orientation:landscape){.call-out-style-1,.call-out-style-2,.call-out-style-3,.call-out-style-4{padding:10px 12px}}@media only screen and (min-width:376px) and (max-width:414px) and (max-height:736px) and (orientation:portrait){.call-out-style-1,.call-out-style-2,.call-out-style-3,.call-out-style-4{padding:10px 12px}}@media only screen and (min-height:376px) and (max-height:414px) and (max-width:736px) and (orientation:landscape){.call-out-style-1,.call-out-style-2,.call-out-style-3,.call-out-style-4{padding:10px 12px}}@media only screen and (max-width:375px) and (min-height:737px) and (max-height:812px) and (orientation:portrait){.call-out-style-1,.call-out-style-2,.call-out-style-3,.call-out-style-4{padding:10px 12px}}@media only screen and (min-height:737px) and (max-height:812px) and (max-width:375px) and (orientation:landscape){.call-out-style-1,.call-out-style-2,.call-out-style-3,.call-out-style-4{padding:10px 12px}}.call-out-outline{display:block;position:relative;overflow:hidden;border-style:dashed;border-width:2px;padding:16px 24px}@media only screen and (max-width:375px) and (max-height:736px) and (orientation:portrait){.call-out-outline{padding:10px 12px}}@media only screen and (max-height:375px) and (max-width:736px) and (orientation:landscape){.call-out-outline{padding:10px 12px}}@media only screen and (min-width:376px) and (max-width:414px) and (max-height:736px) and (orientation:portrait){.call-out-outline{padding:10px 12px}}@media only screen and (min-height:376px) and (max-height:414px) and (max-width:736px) and (orientation:landscape){.call-out-outline{padding:10px 12px}}@media only screen and (max-width:375px) and (min-height:737px) and (max-height:812px) and (orientation:portrait){.call-out-outline{padding:10px 12px}}@media only screen and (min-height:737px) and (max-height:812px) and (max-width:375px) and (orientation:landscape){.call-out-outline{padding:10px 12px}}.content-wrapper{height:100%!important}.content-wrapper,.content-wrapper .content-area{width:calc(100% - 160px);padding:30px 24px;margin:0 80px auto}.content-wrapper .content-area{position:absolute;top:0;left:0;right:0;height:100%;overflow-y:scroll;display:-webkit-flex;display:flex;flex-flow:row nowrap;z-index:2!important;-webkit-box-shadow:0 5px 5px 0 rgba(0,0,0,.25);-moz-box-shadow:0 5px 5px 0 rgba(0,0,0,.25);box-shadow:0 5px 5px 0 rgba(0,0,0,.25)}.content-wrapper .full-screen{width:100%}.content-wrapper .left-asset-screen{width:auto;min-width:60%}.content-wrapper .right-asset-screen{min-width:60%}.content-wrapper .content-wrapper-background{display:none}@media only screen and (max-width:375px) and (max-height:736px) and (orientation:portrait){.content-wrapper .blurred-feed:not(.accordion-content-wrapper){background:hsla(0,0%,100%,.8)}}@media only screen and (max-height:375px) and (max-width:736px) and (orientation:landscape){.content-wrapper .blurred-feed:not(.accordion-content-wrapper){background:hsla(0,0%,100%,.8)}}@media only screen and (min-width:376px) and (max-width:414px) and (max-height:736px) and (orientation:portrait){.content-wrapper .blurred-feed:not(.accordion-content-wrapper){background:hsla(0,0%,100%,.8)}}@media only screen and (min-height:376px) and (max-height:414px) and (max-width:736px) and (orientation:landscape){.content-wrapper .blurred-feed:not(.accordion-content-wrapper){background:hsla(0,0%,100%,.8)}}@media only screen and (min-width:768px) and (max-width:1024px) and (orientation:portrait){.content-wrapper .blurred-feed:not(.accordion-content-wrapper){background:hsla(0,0%,100%,.8)}}@media only screen and (max-width:375px) and (min-height:737px) and (max-height:812px) and (orientation:portrait){.content-wrapper .blurred-feed:not(.accordion-content-wrapper){background:hsla(0,0%,100%,.8)}}@media only screen and (min-width:737px) and (max-width:812px) and (max-height:375px) and (orientation:landscape){.content-wrapper .blurred-feed:not(.accordion-content-wrapper){background:hsla(0,0%,100%,.8)}}@media only screen and (max-width:320px) and (max-height:568px) and (orientation:portrait){.content-wrapper .blurred-feed:not(.accordion-content-wrapper){background:hsla(0,0%,100%,.8)}}@media only screen and (max-width:320px) and (max-height:568px) and (orientation:landscape){.content-wrapper .blurred-feed:not(.accordion-content-wrapper){background:hsla(0,0%,100%,.8)}}.content-wrapper.frosted_white .content-wrapper-background{z-index:1;display:block;position:absolute;top:0;left:0;right:0;width:100%;height:100%;margin:auto;-webkit-clip-path:inset(0 80px 0 80px);clip-path:inset(0 80px 0 80px);-webkit-filter:blur(15px);filter:blur(15px)}.content-wrapper.frosted_white .content-wrapper-background img{position:absolute;bottom:0;left:0;right:0;margin:auto;width:100%;height:auto}@media only screen and (max-width:375px) and (max-height:736px) and (orientation:portrait){.content-wrapper.frosted_white .content-wrapper-background img{min-height:100vh;position:absolute;height:100%;left:0;right:0;margin:auto!important;width:auto;min-width:100%}}@media only screen and (max-height:375px) and (max-width:736px) and (orientation:landscape){.content-wrapper.frosted_white .content-wrapper-background img{min-height:100vh;height:auto;top:0;width:100%}.content-wrapper.frosted_white .content-wrapper-background img.title-screen{bottom:unset;top:0}}@media only screen and (min-width:376px) and (max-width:414px) and (max-height:736px) and (orientation:portrait){.content-wrapper.frosted_white .content-wrapper-background img{min-height:100vh;position:absolute;height:100%;left:0;right:0;margin:auto!important;width:auto;min-width:100%}}@media only screen and (min-height:376px) and (max-height:414px) and (max-width:736px) and (orientation:landscape){.content-wrapper.frosted_white .content-wrapper-background img{min-height:100vh;height:auto;bottom:0;width:100%}.content-wrapper.frosted_white .content-wrapper-background img.title-screen{bottom:unset;top:0}}@media only screen and (min-width:768px) and (max-width:1024px) and (orientation:landscape){.content-wrapper.frosted_white .content-wrapper-background img{min-height:664px;height:auto;width:100%}}@media only screen and (width:900px) and (height:768px){.content-wrapper.frosted_white .content-wrapper-background img{min-height:664px;height:auto;width:100%}}@media only screen and (min-width:768px) and (max-width:1024px) and (orientation:portrait){.content-wrapper.frosted_white .content-wrapper-background img{min-height:924px;position:absolute;height:100%;left:0;right:0;margin:auto!important;width:auto;min-width:100%}}@media only screen and (max-width:375px) and (min-height:737px) and (max-height:812px) and (orientation:portrait){.content-wrapper.frosted_white .content-wrapper-background img{min-height:100vh;position:absolute;height:100%;left:0;right:0;margin:auto!important;width:auto;min-width:100%}}@media only screen and (min-width:737px) and (max-width:812px) and (max-height:375px) and (orientation:landscape){.content-wrapper.frosted_white .content-wrapper-background img{min-height:100vh;height:auto;top:0;width:100%}.content-wrapper.frosted_white .content-wrapper-background img.title-screen{bottom:unset;top:0}}@media only screen and (max-width:320px) and (max-height:568px) and (orientation:portrait){.content-wrapper.frosted_white .content-wrapper-background img{min-height:100vh;position:absolute;height:100%;left:0;right:0;margin:auto!important;width:auto;min-width:100%}}@media only screen and (min-width:200px) and (max-width:900px) and (orientation:landscape){.content-wrapper.frosted_white .content-wrapper-background{display:none}}@media only screen and (max-width:375px) and (max-height:736px) and (orientation:portrait){.content-wrapper.frosted_white .content-wrapper-background{display:none}}@media only screen and (max-height:375px) and (max-width:736px) and (orientation:landscape){.content-wrapper.frosted_white .content-wrapper-background{display:none}}@media only screen and (min-width:376px) and (max-width:414px) and (max-height:736px) and (orientation:portrait){.content-wrapper.frosted_white .content-wrapper-background{display:none}}@media only screen and (min-height:376px) and (max-height:414px) and (max-width:736px) and (orientation:landscape){.content-wrapper.frosted_white .content-wrapper-background{display:none}}@media only screen and (max-width:375px) and (min-height:737px) and (max-height:812px) and (orientation:portrait){.content-wrapper.frosted_white .content-wrapper-background{display:none}}@media only screen and (min-width:768px) and (max-width:1024px) and (orientation:landscape){.content-wrapper.frosted_white .content-wrapper-background{position:absolute;top:0;left:0;right:0;width:100%;height:100%;margin:auto;-webkit-clip-path:inset(0 32px 0 32px);clip-path:inset(0 32px 0 32x);-webkit-filter:blur(15px);filter:blur(15px)}}@media only screen and (min-width:768px) and (max-width:1024px) and (orientation:portrait){.content-wrapper.frosted_white .content-wrapper-background{position:absolute;top:0;left:0;right:0;width:100%;height:100%;margin:auto;-webkit-clip-path:inset(0 24px 0 24px);clip-path:inset(0 24px 0 24px);-webkit-filter:blur(15px);filter:blur(15px)}}.content-wrapper.frosted_white .content-wrapper-background:after{content:\"\";position:absolute;width:100%;height:100%;margin:0 30px}.content-wrapper.frosted_white .blurred-feed{background:hsla(0,0%,100%,.7)}.content-wrapper.frosted_white .standard-feed{background:hsla(0,0%,100%,.9)}@media only screen and (max-width:375px) and (max-height:736px) and (orientation:portrait){.content-wrapper.frosted_white .blurred-feed:not(.accordion-content-wrapper){background:hsla(0,0%,100%,.8)}}@media only screen and (max-height:375px) and (max-width:736px) and (orientation:landscape){.content-wrapper.frosted_white .blurred-feed:not(.accordion-content-wrapper){background:hsla(0,0%,100%,.8)}}@media only screen and (min-width:376px) and (max-width:414px) and (max-height:736px) and (orientation:portrait){.content-wrapper.frosted_white .blurred-feed:not(.accordion-content-wrapper){background:hsla(0,0%,100%,.8)}}@media only screen and (min-height:376px) and (max-height:414px) and (max-width:736px) and (orientation:landscape){.content-wrapper.frosted_white .blurred-feed:not(.accordion-content-wrapper){background:hsla(0,0%,100%,.8)}}@media only screen and (min-width:768px) and (max-width:1024px) and (orientation:portrait){.content-wrapper.frosted_white .blurred-feed:not(.accordion-content-wrapper){background:hsla(0,0%,100%,.8)}}@media only screen and (max-width:375px) and (min-height:737px) and (max-height:812px) and (orientation:portrait){.content-wrapper.frosted_white .blurred-feed:not(.accordion-content-wrapper){background:hsla(0,0%,100%,.8)}}@media only screen and (min-width:737px) and (max-width:812px) and (max-height:375px) and (orientation:landscape){.content-wrapper.frosted_white .blurred-feed:not(.accordion-content-wrapper){background:hsla(0,0%,100%,.8)}}@media only screen and (max-width:320px) and (max-height:568px) and (orientation:portrait){.content-wrapper.frosted_white .blurred-feed:not(.accordion-content-wrapper){background:hsla(0,0%,100%,.8)}}@media only screen and (max-width:320px) and (max-height:568px) and (orientation:landscape){.content-wrapper.frosted_white .blurred-feed:not(.accordion-content-wrapper){background:hsla(0,0%,100%,.8)}}.content-wrapper.tinted_dark .content-wrapper-background{z-index:1;display:block;position:absolute;top:0;left:0;right:0;width:100%;height:100%;margin:auto;-webkit-clip-path:inset(0 80px 0 80px);clip-path:inset(0 80px 0 80px);-webkit-filter:blur(15px);filter:blur(15px)}.content-wrapper.tinted_dark .content-wrapper-background img{position:absolute;bottom:0;left:0;right:0;margin:auto;width:100%;height:auto}@media only screen and (max-width:375px) and (max-height:736px) and (orientation:portrait){.content-wrapper.tinted_dark .content-wrapper-background img{min-height:100vh;position:absolute;height:100%;left:0;right:0;margin:auto!important;width:auto;min-width:100%}}@media only screen and (max-height:375px) and (max-width:736px) and (orientation:landscape){.content-wrapper.tinted_dark .content-wrapper-background img{min-height:100vh;height:auto;top:0;width:100%}.content-wrapper.tinted_dark .content-wrapper-background img.title-screen{bottom:unset;top:0}}@media only screen and (min-width:376px) and (max-width:414px) and (max-height:736px) and (orientation:portrait){.content-wrapper.tinted_dark .content-wrapper-background img{min-height:100vh;position:absolute;height:100%;left:0;right:0;margin:auto!important;width:auto;min-width:100%}}@media only screen and (min-height:376px) and (max-height:414px) and (max-width:736px) and (orientation:landscape){.content-wrapper.tinted_dark .content-wrapper-background img{min-height:100vh;height:auto;bottom:0;width:100%}.content-wrapper.tinted_dark .content-wrapper-background img.title-screen{bottom:unset;top:0}}@media only screen and (min-width:768px) and (max-width:1024px) and (orientation:landscape){.content-wrapper.tinted_dark .content-wrapper-background img{min-height:664px;height:auto;width:100%}}@media only screen and (width:900px) and (height:768px){.content-wrapper.tinted_dark .content-wrapper-background img{min-height:664px;height:auto;width:100%}}@media only screen and (min-width:768px) and (max-width:1024px) and (orientation:portrait){.content-wrapper.tinted_dark .content-wrapper-background img{min-height:924px;position:absolute;height:100%;left:0;right:0;margin:auto!important;width:auto;min-width:100%}}@media only screen and (max-width:375px) and (min-height:737px) and (max-height:812px) and (orientation:portrait){.content-wrapper.tinted_dark .content-wrapper-background img{min-height:100vh;position:absolute;height:100%;left:0;right:0;margin:auto!important;width:auto;min-width:100%}}@media only screen and (min-width:737px) and (max-width:812px) and (max-height:375px) and (orientation:landscape){.content-wrapper.tinted_dark .content-wrapper-background img{min-height:100vh;height:auto;top:0;width:100%}.content-wrapper.tinted_dark .content-wrapper-background img.title-screen{bottom:unset;top:0}}@media only screen and (max-width:320px) and (max-height:568px) and (orientation:portrait){.content-wrapper.tinted_dark .content-wrapper-background img{min-height:100vh;position:absolute;height:100%;left:0;right:0;margin:auto!important;width:auto;min-width:100%}}@media only screen and (min-width:200px) and (max-width:900px) and (orientation:landscape){.content-wrapper.tinted_dark .content-wrapper-background{display:none}}@media only screen and (max-width:375px) and (max-height:736px) and (orientation:portrait){.content-wrapper.tinted_dark .content-wrapper-background{display:none}}@media only screen and (max-height:375px) and (max-width:736px) and (orientation:landscape){.content-wrapper.tinted_dark .content-wrapper-background{display:none}}@media only screen and (min-width:376px) and (max-width:414px) and (max-height:736px) and (orientation:portrait){.content-wrapper.tinted_dark .content-wrapper-background{display:none}}@media only screen and (min-height:376px) and (max-height:414px) and (max-width:736px) and (orientation:landscape){.content-wrapper.tinted_dark .content-wrapper-background{display:none}}@media only screen and (max-width:375px) and (min-height:737px) and (max-height:812px) and (orientation:portrait){.content-wrapper.tinted_dark .content-wrapper-background{display:none}}@media only screen and (min-width:768px) and (max-width:1024px) and (orientation:landscape){.content-wrapper.tinted_dark .content-wrapper-background{position:absolute;top:0;left:0;right:0;width:100%;height:100%;margin:auto;-webkit-clip-path:inset(0 32px 0 32px);clip-path:inset(0 32px 0 32x);-webkit-filter:blur(15px);filter:blur(15px)}}@media only screen and (min-width:768px) and (max-width:1024px) and (orientation:portrait){.content-wrapper.tinted_dark .content-wrapper-background{position:absolute;top:0;left:0;right:0;width:100%;height:100%;margin:auto;-webkit-clip-path:inset(0 24px 0 24px);clip-path:inset(0 24px 0 24px);-webkit-filter:blur(15px);filter:blur(15px)}}.content-wrapper.tinted_dark .content-area{background:rgba(0,0,0,.5)}.content-wrapper.thick_glass .content-wrapper-background{z-index:1;display:block;position:absolute;top:0;left:0;right:0;width:100%;height:100%;margin:auto;-webkit-clip-path:inset(0 80px 0 80px);clip-path:inset(0 80px 0 80px);-webkit-filter:blur(15px);filter:blur(15px)}.content-wrapper.thick_glass .content-wrapper-background img{position:absolute;bottom:0;left:0;right:0;margin:auto;width:100%;height:auto}@media only screen and (max-width:375px) and (max-height:736px) and (orientation:portrait){.content-wrapper.thick_glass .content-wrapper-background img{min-height:100vh;position:absolute;height:100%;left:0;right:0;margin:auto!important;width:auto;min-width:100%}}@media only screen and (max-height:375px) and (max-width:736px) and (orientation:landscape){.content-wrapper.thick_glass .content-wrapper-background img{min-height:100vh;height:auto;top:0;width:100%}.content-wrapper.thick_glass .content-wrapper-background img.title-screen{bottom:unset;top:0}}@media only screen and (min-width:376px) and (max-width:414px) and (max-height:736px) and (orientation:portrait){.content-wrapper.thick_glass .content-wrapper-background img{min-height:100vh;position:absolute;height:100%;left:0;right:0;margin:auto!important;width:auto;min-width:100%}}@media only screen and (min-height:376px) and (max-height:414px) and (max-width:736px) and (orientation:landscape){.content-wrapper.thick_glass .content-wrapper-background img{min-height:100vh;height:auto;bottom:0;width:100%}.content-wrapper.thick_glass .content-wrapper-background img.title-screen{bottom:unset;top:0}}@media only screen and (min-width:768px) and (max-width:1024px) and (orientation:landscape){.content-wrapper.thick_glass .content-wrapper-background img{min-height:664px;height:auto;width:100%}}@media only screen and (width:900px) and (height:768px){.content-wrapper.thick_glass .content-wrapper-background img{min-height:664px;height:auto;width:100%}}@media only screen and (min-width:768px) and (max-width:1024px) and (orientation:portrait){.content-wrapper.thick_glass .content-wrapper-background img{min-height:924px;position:absolute;height:100%;left:0;right:0;margin:auto!important;width:auto;min-width:100%}}@media only screen and (max-width:375px) and (min-height:737px) and (max-height:812px) and (orientation:portrait){.content-wrapper.thick_glass .content-wrapper-background img{min-height:100vh;position:absolute;height:100%;left:0;right:0;margin:auto!important;width:auto;min-width:100%}}@media only screen and (min-width:737px) and (max-width:812px) and (max-height:375px) and (orientation:landscape){.content-wrapper.thick_glass .content-wrapper-background img{min-height:100vh;height:auto;top:0;width:100%}.content-wrapper.thick_glass .content-wrapper-background img.title-screen{bottom:unset;top:0}}@media only screen and (max-width:320px) and (max-height:568px) and (orientation:portrait){.content-wrapper.thick_glass .content-wrapper-background img{min-height:100vh;position:absolute;height:100%;left:0;right:0;margin:auto!important;width:auto;min-width:100%}}@media only screen and (min-width:200px) and (max-width:900px) and (orientation:landscape){.content-wrapper.thick_glass .content-wrapper-background{display:none}}@media only screen and (max-width:375px) and (max-height:736px) and (orientation:portrait){.content-wrapper.thick_glass .content-wrapper-background{display:none}}@media only screen and (max-height:375px) and (max-width:736px) and (orientation:landscape){.content-wrapper.thick_glass .content-wrapper-background{display:none}}@media only screen and (min-width:376px) and (max-width:414px) and (max-height:736px) and (orientation:portrait){.content-wrapper.thick_glass .content-wrapper-background{display:none}}@media only screen and (min-height:376px) and (max-height:414px) and (max-width:736px) and (orientation:landscape){.content-wrapper.thick_glass .content-wrapper-background{display:none}}@media only screen and (max-width:375px) and (min-height:737px) and (max-height:812px) and (orientation:portrait){.content-wrapper.thick_glass .content-wrapper-background{display:none}}@media only screen and (min-width:768px) and (max-width:1024px) and (orientation:landscape){.content-wrapper.thick_glass .content-wrapper-background{position:absolute;top:0;left:0;right:0;width:100%;height:100%;margin:auto;-webkit-clip-path:inset(0 32px 0 32px);clip-path:inset(0 32px 0 32x);-webkit-filter:blur(15px);filter:blur(15px)}}@media only screen and (min-width:768px) and (max-width:1024px) and (orientation:portrait){.content-wrapper.thick_glass .content-wrapper-background{position:absolute;top:0;left:0;right:0;width:100%;height:100%;margin:auto;-webkit-clip-path:inset(0 24px 0 24px);clip-path:inset(0 24px 0 24px);-webkit-filter:blur(15px);filter:blur(15px)}}.content-wrapper.thick_glass .blurred-feed{background:hsla(0,0%,91%,.2)}.content-wrapper.thick_glass .standard-feed{background:hsla(0,0%,91%,.9)}@media only screen and (max-width:375px) and (max-height:736px) and (orientation:portrait){.content-wrapper.thick_glass .blurred-feed{background:hsla(0,0%,91%,.9)}}@media only screen and (max-height:375px) and (max-width:736px) and (orientation:landscape){.content-wrapper.thick_glass .blurred-feed{background:hsla(0,0%,91%,.9)}}@media only screen and (min-width:376px) and (max-width:414px) and (max-height:736px) and (orientation:portrait){.content-wrapper.thick_glass .blurred-feed{background:hsla(0,0%,91%,.9)}}@media only screen and (min-height:376px) and (max-height:414px) and (max-width:736px) and (orientation:landscape){.content-wrapper.thick_glass .blurred-feed{background:hsla(0,0%,91%,.9)}}@media only screen and (min-width:768px) and (max-width:1024px) and (orientation:portrait){.content-wrapper.thick_glass .blurred-feed{background:hsla(0,0%,91%,.9)}}@media only screen and (max-width:375px) and (min-height:737px) and (max-height:812px) and (orientation:portrait){.content-wrapper.thick_glass .blurred-feed{background:hsla(0,0%,91%,.9)}}@media only screen and (min-width:737px) and (max-width:812px) and (max-height:375px) and (orientation:landscape){.content-wrapper.thick_glass .blurred-feed{background:hsla(0,0%,91%,.9)}}@media only screen and (max-width:320px) and (max-height:568px) and (orientation:portrait){.content-wrapper.thick_glass .blurred-feed{background:hsla(0,0%,91%,.9)}}@media only screen and (max-width:320px) and (max-height:568px) and (orientation:landscape){.content-wrapper.thick_glass .blurred-feed{background:hsla(0,0%,91%,.9)}}.content-wrapper.transparent .content-area{-webkit-box-shadow:none;-moz-box-shadow:none;box-shadow:none}@media only screen and (max-width:375px) and (max-height:736px) and (orientation:portrait){.content-wrapper .content-area{width:100%!important;margin:0!important;padding:0!important}.content-wrapper .content-area .feed-object-container,.content-wrapper .content-area .feed-object-container .content-dialogs,.content-wrapper .content-area .feed-object-container>.object-container{padding:0!important}.content-wrapper .content-area .learner-action{padding:0}}@media only screen and (max-height:375px) and (max-width:736px) and (orientation:landscape){.content-wrapper .content-area{width:100%!important;margin:0!important;padding:0!important}.content-wrapper .content-area .feed-object-container,.content-wrapper .content-area .feed-object-container .content-dialogs,.content-wrapper .content-area .feed-object-container>.object-container{padding:0!important}.content-wrapper .content-area .learner-action{padding:0}}@media only screen and (min-width:376px) and (max-width:414px) and (max-height:736px) and (orientation:portrait){.content-wrapper .content-area{width:100%!important;margin:0!important;padding:0!important}.content-wrapper .content-area .feed-object-container,.content-wrapper .content-area .feed-object-container .content-dialogs,.content-wrapper .content-area .feed-object-container>.object-container{padding:0!important}.content-wrapper .content-area .learner-action{padding:0}}@media only screen and (min-height:376px) and (max-height:414px) and (max-width:736px) and (orientation:landscape){.content-wrapper .content-area{width:100%!important;margin:0!important;padding:0!important}.content-wrapper .content-area .feed-object-container,.content-wrapper .content-area .feed-object-container .content-dialogs,.content-wrapper .content-area .feed-object-container>.object-container{padding:0!important}.content-wrapper .content-area .learner-action{padding:0}}@media only screen and (max-width:375px) and (min-height:737px) and (max-height:812px) and (orientation:portrait){.content-wrapper .content-area{width:100%!important;margin:0!important;padding:0!important}.content-wrapper .content-area .feed-object-container,.content-wrapper .content-area .feed-object-container .content-dialogs,.content-wrapper .content-area .feed-object-container>.object-container{padding:0!important}.content-wrapper .content-area .learner-action{padding:0}}@media only screen and (min-height:737px) and (max-height:812px) and (max-width:375px) and (orientation:landscape){.content-wrapper .content-area{width:100%!important;margin:0!important;padding:0!important}.content-wrapper .content-area .feed-object-container,.content-wrapper .content-area .feed-object-container .content-dialogs,.content-wrapper .content-area .feed-object-container>.object-container{padding:0!important}.content-wrapper .content-area .learner-action{padding:0}}@media only screen and (min-width:768px) and (max-width:1024px) and (orientation:landscape){.content-wrapper .content-area{width:calc(100% - 64px)!important;margin:0 32px auto!important}}@media only screen and (min-width:768px) and (max-width:1024px) and (orientation:portrait){.content-wrapper .content-area{width:calc(100% - 48px)!important;margin:0 24px auto!important}}.content-wrapper .object-container{padding-left:24px;padding-right:24px}.content-wrapper .object-container .standard-block{padding:0}.content-wrapper .object-container .call-out,.content-wrapper .object-container .feedback-panel,.content-wrapper .object-container .video-container{margin-left:-24px;margin-right:-24px}@media only screen and (max-width:375px) and (max-height:736px) and (orientation:portrait){.content-wrapper .object-container{padding-left:12px;padding-right:12px;width:100%!important;margin:0 0 10px!important}.content-wrapper .object-container .call-out{margin-left:-12px;margin-right:-12px}.content-wrapper .object-container .feedback-panel{margin:0;padding:10px 12px}.content-wrapper .object-container.feed-anti-margin{overflow:visible}}@media only screen and (max-height:375px) and (max-width:736px) and (orientation:landscape){.content-wrapper .object-container{padding-left:12px;padding-right:12px;width:100%!important;margin:0 0 10px!important}.content-wrapper .object-container .call-out{margin-left:-12px;margin-right:-12px}.content-wrapper .object-container .feedback-panel{margin:0;padding:10px 12px}.content-wrapper .object-container.feed-anti-margin{overflow:visible}}@media only screen and (min-width:376px) and (max-width:414px) and (max-height:736px) and (orientation:portrait){.content-wrapper .object-container{padding-left:12px;padding-right:12px;width:100%!important;margin:0 0 10px!important}.content-wrapper .object-container .call-out{margin-left:-12px;margin-right:-12px}.content-wrapper .object-container .feedback-panel{margin:0;padding:10px 12px}.content-wrapper .object-container.feed-anti-margin{overflow:visible}}@media only screen and (min-height:376px) and (max-height:414px) and (max-width:736px) and (orientation:landscape){.content-wrapper .object-container{padding-left:12px;padding-right:12px;width:100%!important;margin:0 0 10px!important}.content-wrapper .object-container .call-out{margin-left:-12px;margin-right:-12px}.content-wrapper .object-container .feedback-panel{margin:0;padding:10px 12px}.content-wrapper .object-container.feed-anti-margin{overflow:visible}}@media only screen and (max-width:375px) and (min-height:737px) and (max-height:812px) and (orientation:portrait){.content-wrapper .object-container{padding-left:12px;padding-right:12px;width:100%!important;margin:0 0 10px!important}.content-wrapper .object-container .call-out{margin-left:-12px;margin-right:-12px}.content-wrapper .object-container .feedback-panel{margin:0;padding:10px 12px}.content-wrapper .object-container.feed-anti-margin{overflow:visible}}@media only screen and (min-height:737px) and (max-height:812px) and (max-width:375px) and (orientation:landscape){.content-wrapper .object-container{padding-left:12px;padding-right:12px;width:100%!important;margin:0 0 10px!important}.content-wrapper .object-container .call-out{margin-left:-12px;margin-right:-12px}.content-wrapper .object-container .feedback-panel{margin:0;padding:10px 12px}.content-wrapper .object-container.feed-anti-margin{overflow:visible}}.content-wrapper .multiple-choice-option-list label{border-radius:3px}.content-wrapper.right{height:100%!important;width:100%;padding:0;margin:0 auto;display:-webkit-flex;display:flex;flex-flow:row nowrap}.content-wrapper.right .content-area{position:relative;top:0;left:unset;right:0!important;height:100%;overflow-y:scroll;width:60%;padding:30px 0;margin:0 0 0 40%;z-index:2!important;-webkit-box-shadow:0 5px 5px 0 rgba(0,0,0,.25);-moz-box-shadow:0 5px 5px 0 rgba(0,0,0,.25);box-shadow:0 5px 5px 0 rgba(0,0,0,.25)}@media only screen and (min-width:768px) and (max-width:1024px) and (orientation:landscape){.content-wrapper.right .content-area{width:60%!important;margin:0!important}}@media only screen and (min-width:768px) and (max-width:1024px) and (orientation:portrait){.content-wrapper.right .content-area{width:calc(100% - 48px)!important;margin:0 24px auto!important}.content-wrapper.right .content-area .asset-left-panel{display:none!important}}.content-wrapper.right .full-screen{width:100%}.content-wrapper.right .left-asset-screen,.content-wrapper.right .right-asset-screen{width:100%!important;margin:0!important}.content-wrapper.right .asset-col-left,.content-wrapper.right .asset-col-right{display:none}.content-wrapper.right .asset-left-panel{position:relative;height:100%;padding:30px 24px;z-index:2!important;width:40%}.content-wrapper.right .asset-left-panel .asset-image-wrapper{position:relative;width:100%;max-width:calc(100% - 0px);overflow:hidden}.content-wrapper.right.flexi .content-area{width:auto;min-width:60%;margin:0!important}.content-wrapper.right.flexi .asset-left-panel{width:auto;max-width:40%}.content-wrapper.right.flexi .asset-left-panel .asset-image-wrapper{position:relative;width:100%;max-width:calc(100% - 0px);overflow:hidden}.content-wrapper.right.flexi .asset-left-panel .image-credit{margin-top:10px;background:hsla(0,0%,100%,.9)}.content-wrapper.right .content-wrapper-background{display:none}@media only screen and (max-width:375px) and (max-height:736px) and (orientation:portrait){.content-wrapper.right .blurred-feed:not(.accordion-content-wrapper){background:hsla(0,0%,100%,.8)}}@media only screen and (max-height:375px) and (max-width:736px) and (orientation:landscape){.content-wrapper.right .blurred-feed:not(.accordion-content-wrapper){background:hsla(0,0%,100%,.8)}}@media only screen and (min-width:376px) and (max-width:414px) and (max-height:736px) and (orientation:portrait){.content-wrapper.right .blurred-feed:not(.accordion-content-wrapper){background:hsla(0,0%,100%,.8)}}@media only screen and (min-height:376px) and (max-height:414px) and (max-width:736px) and (orientation:landscape){.content-wrapper.right .blurred-feed:not(.accordion-content-wrapper){background:hsla(0,0%,100%,.8)}}@media only screen and (min-width:768px) and (max-width:1024px) and (orientation:portrait){.content-wrapper.right .blurred-feed:not(.accordion-content-wrapper){background:hsla(0,0%,100%,.8)}}@media only screen and (max-width:375px) and (min-height:737px) and (max-height:812px) and (orientation:portrait){.content-wrapper.right .blurred-feed:not(.accordion-content-wrapper){background:hsla(0,0%,100%,.8)}}@media only screen and (min-width:737px) and (max-width:812px) and (max-height:375px) and (orientation:landscape){.content-wrapper.right .blurred-feed:not(.accordion-content-wrapper){background:hsla(0,0%,100%,.8)}}@media only screen and (max-width:320px) and (max-height:568px) and (orientation:portrait){.content-wrapper.right .blurred-feed:not(.accordion-content-wrapper){background:hsla(0,0%,100%,.8)}}@media only screen and (max-width:320px) and (max-height:568px) and (orientation:landscape){.content-wrapper.right .blurred-feed:not(.accordion-content-wrapper){background:hsla(0,0%,100%,.8)}}.content-wrapper.right.frosted_white .content-wrapper-background{z-index:1;display:block;position:absolute;top:0;left:0;right:0;width:100%;height:100%;margin:auto;-webkit-clip-path:inset(0 0 0 40%);clip-path:inset(0 0 0 40%);-webkit-filter:blur(15px);filter:blur(15px)}.content-wrapper.right.frosted_white .content-wrapper-background img{position:absolute;bottom:0;left:0;right:0;margin:auto;width:100%;height:auto}@media only screen and (max-width:375px) and (max-height:736px) and (orientation:portrait){.content-wrapper.right.frosted_white .content-wrapper-background img{min-height:100vh;position:absolute;height:100%;left:0;right:0;margin:auto!important;width:auto;min-width:100%}}@media only screen and (max-height:375px) and (max-width:736px) and (orientation:landscape){.content-wrapper.right.frosted_white .content-wrapper-background img{min-height:100vh;height:auto;top:0;width:100%}.content-wrapper.right.frosted_white .content-wrapper-background img.title-screen{bottom:unset;top:0}}@media only screen and (min-width:376px) and (max-width:414px) and (max-height:736px) and (orientation:portrait){.content-wrapper.right.frosted_white .content-wrapper-background img{min-height:100vh;position:absolute;height:100%;left:0;right:0;margin:auto!important;width:auto;min-width:100%}}@media only screen and (min-height:376px) and (max-height:414px) and (max-width:736px) and (orientation:landscape){.content-wrapper.right.frosted_white .content-wrapper-background img{min-height:100vh;height:auto;bottom:0;width:100%}.content-wrapper.right.frosted_white .content-wrapper-background img.title-screen{bottom:unset;top:0}}@media only screen and (min-width:768px) and (max-width:1024px) and (orientation:landscape){.content-wrapper.right.frosted_white .content-wrapper-background img{min-height:664px;height:auto;width:100%}}@media only screen and (width:900px) and (height:768px){.content-wrapper.right.frosted_white .content-wrapper-background img{min-height:664px;height:auto;width:100%}}@media only screen and (min-width:768px) and (max-width:1024px) and (orientation:portrait){.content-wrapper.right.frosted_white .content-wrapper-background img{min-height:924px;position:absolute;height:100%;left:0;right:0;margin:auto!important;width:auto;min-width:100%}}@media only screen and (max-width:375px) and (min-height:737px) and (max-height:812px) and (orientation:portrait){.content-wrapper.right.frosted_white .content-wrapper-background img{min-height:100vh;position:absolute;height:100%;left:0;right:0;margin:auto!important;width:auto;min-width:100%}}@media only screen and (min-width:737px) and (max-width:812px) and (max-height:375px) and (orientation:landscape){.content-wrapper.right.frosted_white .content-wrapper-background img{min-height:100vh;height:auto;top:0;width:100%}.content-wrapper.right.frosted_white .content-wrapper-background img.title-screen{bottom:unset;top:0}}@media only screen and (max-width:320px) and (max-height:568px) and (orientation:portrait){.content-wrapper.right.frosted_white .content-wrapper-background img{min-height:100vh;position:absolute;height:100%;left:0;right:0;margin:auto!important;width:auto;min-width:100%}}@media only screen and (min-width:200px) and (max-width:900px) and (orientation:landscape){.content-wrapper.right.frosted_white .content-wrapper-background{display:none}}@media only screen and (max-width:375px) and (max-height:736px) and (orientation:portrait){.content-wrapper.right.frosted_white .content-wrapper-background{display:none}}@media only screen and (max-height:375px) and (max-width:736px) and (orientation:landscape){.content-wrapper.right.frosted_white .content-wrapper-background{display:none}}@media only screen and (min-width:376px) and (max-width:414px) and (max-height:736px) and (orientation:portrait){.content-wrapper.right.frosted_white .content-wrapper-background{display:none}}@media only screen and (min-height:376px) and (max-height:414px) and (max-width:736px) and (orientation:landscape){.content-wrapper.right.frosted_white .content-wrapper-background{display:none}}@media only screen and (max-width:375px) and (min-height:737px) and (max-height:812px) and (orientation:portrait){.content-wrapper.right.frosted_white .content-wrapper-background{display:none}}@media only screen and (min-width:768px) and (max-width:1024px) and (orientation:landscape){.content-wrapper.right.frosted_white .content-wrapper-background{position:absolute;top:0;left:0;right:0;width:100%;height:100%;margin:auto;-webkit-clip-path:inset(0 0 0 40%);clip-path:inset(0 0 0 40%);-webkit-filter:blur(15px);filter:blur(15px)}}@media only screen and (min-width:768px) and (max-width:1024px) and (orientation:portrait){.content-wrapper.right.frosted_white .content-wrapper-background{position:absolute;top:0;left:0;right:0;width:100%;height:100%;margin:auto;-webkit-clip-path:inset(0 24px 0 24px);clip-path:inset(0 24px 0 24px);-webkit-filter:blur(15px);filter:blur(15px)}}.content-wrapper.right.frosted_white .content-wrapper-background:after{content:\"\";position:absolute;width:100%;height:100%;margin:0 30px}.content-wrapper.right.frosted_white .blurred-feed{background:hsla(0,0%,100%,.7)}.content-wrapper.right.frosted_white .standard-feed{background:hsla(0,0%,100%,.9)}@media only screen and (max-width:375px) and (max-height:736px) and (orientation:portrait){.content-wrapper.right.frosted_white .blurred-feed:not(.accordion-content-wrapper){background:hsla(0,0%,100%,.8)}}@media only screen and (max-height:375px) and (max-width:736px) and (orientation:landscape){.content-wrapper.right.frosted_white .blurred-feed:not(.accordion-content-wrapper){background:hsla(0,0%,100%,.8)}}@media only screen and (min-width:376px) and (max-width:414px) and (max-height:736px) and (orientation:portrait){.content-wrapper.right.frosted_white .blurred-feed:not(.accordion-content-wrapper){background:hsla(0,0%,100%,.8)}}@media only screen and (min-height:376px) and (max-height:414px) and (max-width:736px) and (orientation:landscape){.content-wrapper.right.frosted_white .blurred-feed:not(.accordion-content-wrapper){background:hsla(0,0%,100%,.8)}}@media only screen and (min-width:768px) and (max-width:1024px) and (orientation:portrait){.content-wrapper.right.frosted_white .blurred-feed:not(.accordion-content-wrapper){background:hsla(0,0%,100%,.8)}}@media only screen and (max-width:375px) and (min-height:737px) and (max-height:812px) and (orientation:portrait){.content-wrapper.right.frosted_white .blurred-feed:not(.accordion-content-wrapper){background:hsla(0,0%,100%,.8)}}@media only screen and (min-width:737px) and (max-width:812px) and (max-height:375px) and (orientation:landscape){.content-wrapper.right.frosted_white .blurred-feed:not(.accordion-content-wrapper){background:hsla(0,0%,100%,.8)}}@media only screen and (max-width:320px) and (max-height:568px) and (orientation:portrait){.content-wrapper.right.frosted_white .blurred-feed:not(.accordion-content-wrapper){background:hsla(0,0%,100%,.8)}}@media only screen and (max-width:320px) and (max-height:568px) and (orientation:landscape){.content-wrapper.right.frosted_white .blurred-feed:not(.accordion-content-wrapper){background:hsla(0,0%,100%,.8)}}.content-wrapper.right.tinted_dark .content-wrapper-background{z-index:1;display:block;position:absolute;top:0;left:0;right:0;width:100%;height:100%;margin:auto;-webkit-clip-path:inset(0 0 0 40%);clip-path:inset(0 0 0 40%);-webkit-filter:blur(15px);filter:blur(15px)}.content-wrapper.right.tinted_dark .content-wrapper-background img{position:absolute;bottom:0;left:0;right:0;margin:auto;width:100%;height:auto}@media only screen and (max-width:375px) and (max-height:736px) and (orientation:portrait){.content-wrapper.right.tinted_dark .content-wrapper-background img{min-height:100vh;position:absolute;height:100%;left:0;right:0;margin:auto!important;width:auto;min-width:100%}}@media only screen and (max-height:375px) and (max-width:736px) and (orientation:landscape){.content-wrapper.right.tinted_dark .content-wrapper-background img{min-height:100vh;height:auto;top:0;width:100%}.content-wrapper.right.tinted_dark .content-wrapper-background img.title-screen{bottom:unset;top:0}}@media only screen and (min-width:376px) and (max-width:414px) and (max-height:736px) and (orientation:portrait){.content-wrapper.right.tinted_dark .content-wrapper-background img{min-height:100vh;position:absolute;height:100%;left:0;right:0;margin:auto!important;width:auto;min-width:100%}}@media only screen and (min-height:376px) and (max-height:414px) and (max-width:736px) and (orientation:landscape){.content-wrapper.right.tinted_dark .content-wrapper-background img{min-height:100vh;height:auto;bottom:0;width:100%}.content-wrapper.right.tinted_dark .content-wrapper-background img.title-screen{bottom:unset;top:0}}@media only screen and (min-width:768px) and (max-width:1024px) and (orientation:landscape){.content-wrapper.right.tinted_dark .content-wrapper-background img{min-height:664px;height:auto;width:100%}}@media only screen and (width:900px) and (height:768px){.content-wrapper.right.tinted_dark .content-wrapper-background img{min-height:664px;height:auto;width:100%}}@media only screen and (min-width:768px) and (max-width:1024px) and (orientation:portrait){.content-wrapper.right.tinted_dark .content-wrapper-background img{min-height:924px;position:absolute;height:100%;left:0;right:0;margin:auto!important;width:auto;min-width:100%}}@media only screen and (max-width:375px) and (min-height:737px) and (max-height:812px) and (orientation:portrait){.content-wrapper.right.tinted_dark .content-wrapper-background img{min-height:100vh;position:absolute;height:100%;left:0;right:0;margin:auto!important;width:auto;min-width:100%}}@media only screen and (min-width:737px) and (max-width:812px) and (max-height:375px) and (orientation:landscape){.content-wrapper.right.tinted_dark .content-wrapper-background img{min-height:100vh;height:auto;top:0;width:100%}.content-wrapper.right.tinted_dark .content-wrapper-background img.title-screen{bottom:unset;top:0}}@media only screen and (max-width:320px) and (max-height:568px) and (orientation:portrait){.content-wrapper.right.tinted_dark .content-wrapper-background img{min-height:100vh;position:absolute;height:100%;left:0;right:0;margin:auto!important;width:auto;min-width:100%}}@media only screen and (min-width:200px) and (max-width:900px) and (orientation:landscape){.content-wrapper.right.tinted_dark .content-wrapper-background{display:none}}@media only screen and (max-width:375px) and (max-height:736px) and (orientation:portrait){.content-wrapper.right.tinted_dark .content-wrapper-background{display:none}}@media only screen and (max-height:375px) and (max-width:736px) and (orientation:landscape){.content-wrapper.right.tinted_dark .content-wrapper-background{display:none}}@media only screen and (min-width:376px) and (max-width:414px) and (max-height:736px) and (orientation:portrait){.content-wrapper.right.tinted_dark .content-wrapper-background{display:none}}@media only screen and (min-height:376px) and (max-height:414px) and (max-width:736px) and (orientation:landscape){.content-wrapper.right.tinted_dark .content-wrapper-background{display:none}}@media only screen and (max-width:375px) and (min-height:737px) and (max-height:812px) and (orientation:portrait){.content-wrapper.right.tinted_dark .content-wrapper-background{display:none}}@media only screen and (min-width:768px) and (max-width:1024px) and (orientation:landscape){.content-wrapper.right.tinted_dark .content-wrapper-background{position:absolute;top:0;left:0;right:0;width:100%;height:100%;margin:auto;-webkit-clip-path:inset(0 0 0 40%);clip-path:inset(0 0 0 40%);-webkit-filter:blur(15px);filter:blur(15px)}}@media only screen and (min-width:768px) and (max-width:1024px) and (orientation:portrait){.content-wrapper.right.tinted_dark .content-wrapper-background{position:absolute;top:0;left:0;right:0;width:100%;height:100%;margin:auto;-webkit-clip-path:inset(0 24px 0 24px);clip-path:inset(0 24px 0 24px);-webkit-filter:blur(15px);filter:blur(15px)}}.content-wrapper.right.tinted_dark .content-area{background:rgba(0,0,0,.5)}.content-wrapper.right.thick_glass .content-wrapper-background{z-index:1;display:block;position:absolute;top:0;left:0;right:0;width:100%;height:100%;margin:auto;-webkit-clip-path:inset(0 0 0 40%);clip-path:inset(0 0 0 40%);-webkit-filter:blur(15px);filter:blur(15px)}.content-wrapper.right.thick_glass .content-wrapper-background img{position:absolute;bottom:0;left:0;right:0;margin:auto;width:100%;height:auto}@media only screen and (max-width:375px) and (max-height:736px) and (orientation:portrait){.content-wrapper.right.thick_glass .content-wrapper-background img{min-height:100vh;position:absolute;height:100%;left:0;right:0;margin:auto!important;width:auto;min-width:100%}}@media only screen and (max-height:375px) and (max-width:736px) and (orientation:landscape){.content-wrapper.right.thick_glass .content-wrapper-background img{min-height:100vh;height:auto;top:0;width:100%}.content-wrapper.right.thick_glass .content-wrapper-background img.title-screen{bottom:unset;top:0}}@media only screen and (min-width:376px) and (max-width:414px) and (max-height:736px) and (orientation:portrait){.content-wrapper.right.thick_glass .content-wrapper-background img{min-height:100vh;position:absolute;height:100%;left:0;right:0;margin:auto!important;width:auto;min-width:100%}}@media only screen and (min-height:376px) and (max-height:414px) and (max-width:736px) and (orientation:landscape){.content-wrapper.right.thick_glass .content-wrapper-background img{min-height:100vh;height:auto;bottom:0;width:100%}.content-wrapper.right.thick_glass .content-wrapper-background img.title-screen{bottom:unset;top:0}}@media only screen and (min-width:768px) and (max-width:1024px) and (orientation:landscape){.content-wrapper.right.thick_glass .content-wrapper-background img{min-height:664px;height:auto;width:100%}}@media only screen and (width:900px) and (height:768px){.content-wrapper.right.thick_glass .content-wrapper-background img{min-height:664px;height:auto;width:100%}}@media only screen and (min-width:768px) and (max-width:1024px) and (orientation:portrait){.content-wrapper.right.thick_glass .content-wrapper-background img{min-height:924px;position:absolute;height:100%;left:0;right:0;margin:auto!important;width:auto;min-width:100%}}@media only screen and (max-width:375px) and (min-height:737px) and (max-height:812px) and (orientation:portrait){.content-wrapper.right.thick_glass .content-wrapper-background img{min-height:100vh;position:absolute;height:100%;left:0;right:0;margin:auto!important;width:auto;min-width:100%}}@media only screen and (min-width:737px) and (max-width:812px) and (max-height:375px) and (orientation:landscape){.content-wrapper.right.thick_glass .content-wrapper-background img{min-height:100vh;height:auto;top:0;width:100%}.content-wrapper.right.thick_glass .content-wrapper-background img.title-screen{bottom:unset;top:0}}@media only screen and (max-width:320px) and (max-height:568px) and (orientation:portrait){.content-wrapper.right.thick_glass .content-wrapper-background img{min-height:100vh;position:absolute;height:100%;left:0;right:0;margin:auto!important;width:auto;min-width:100%}}@media only screen and (min-width:200px) and (max-width:900px) and (orientation:landscape){.content-wrapper.right.thick_glass .content-wrapper-background{display:none}}@media only screen and (max-width:375px) and (max-height:736px) and (orientation:portrait){.content-wrapper.right.thick_glass .content-wrapper-background{display:none}}@media only screen and (max-height:375px) and (max-width:736px) and (orientation:landscape){.content-wrapper.right.thick_glass .content-wrapper-background{display:none}}@media only screen and (min-width:376px) and (max-width:414px) and (max-height:736px) and (orientation:portrait){.content-wrapper.right.thick_glass .content-wrapper-background{display:none}}@media only screen and (min-height:376px) and (max-height:414px) and (max-width:736px) and (orientation:landscape){.content-wrapper.right.thick_glass .content-wrapper-background{display:none}}@media only screen and (max-width:375px) and (min-height:737px) and (max-height:812px) and (orientation:portrait){.content-wrapper.right.thick_glass .content-wrapper-background{display:none}}@media only screen and (min-width:768px) and (max-width:1024px) and (orientation:landscape){.content-wrapper.right.thick_glass .content-wrapper-background{position:absolute;top:0;left:0;right:0;width:100%;height:100%;margin:auto;-webkit-clip-path:inset(0 0 0 40%);clip-path:inset(0 0 0 40%);-webkit-filter:blur(15px);filter:blur(15px)}}@media only screen and (min-width:768px) and (max-width:1024px) and (orientation:portrait){.content-wrapper.right.thick_glass .content-wrapper-background{position:absolute;top:0;left:0;right:0;width:100%;height:100%;margin:auto;-webkit-clip-path:inset(0 24px 0 24px);clip-path:inset(0 24px 0 24px);-webkit-filter:blur(15px);filter:blur(15px)}}.content-wrapper.right.thick_glass .blurred-feed{background:hsla(0,0%,91%,.2)}.content-wrapper.right.thick_glass .standard-feed{background:hsla(0,0%,91%,.9)}@media only screen and (max-width:375px) and (max-height:736px) and (orientation:portrait){.content-wrapper.right.thick_glass .blurred-feed{background:hsla(0,0%,91%,.9)}}@media only screen and (max-height:375px) and (max-width:736px) and (orientation:landscape){.content-wrapper.right.thick_glass .blurred-feed{background:hsla(0,0%,91%,.9)}}@media only screen and (min-width:376px) and (max-width:414px) and (max-height:736px) and (orientation:portrait){.content-wrapper.right.thick_glass .blurred-feed{background:hsla(0,0%,91%,.9)}}@media only screen and (min-height:376px) and (max-height:414px) and (max-width:736px) and (orientation:landscape){.content-wrapper.right.thick_glass .blurred-feed{background:hsla(0,0%,91%,.9)}}@media only screen and (min-width:768px) and (max-width:1024px) and (orientation:portrait){.content-wrapper.right.thick_glass .blurred-feed{background:hsla(0,0%,91%,.9)}}@media only screen and (max-width:375px) and (min-height:737px) and (max-height:812px) and (orientation:portrait){.content-wrapper.right.thick_glass .blurred-feed{background:hsla(0,0%,91%,.9)}}@media only screen and (min-width:737px) and (max-width:812px) and (max-height:375px) and (orientation:landscape){.content-wrapper.right.thick_glass .blurred-feed{background:hsla(0,0%,91%,.9)}}@media only screen and (max-width:320px) and (max-height:568px) and (orientation:portrait){.content-wrapper.right.thick_glass .blurred-feed{background:hsla(0,0%,91%,.9)}}@media only screen and (max-width:320px) and (max-height:568px) and (orientation:landscape){.content-wrapper.right.thick_glass .blurred-feed{background:hsla(0,0%,91%,.9)}}.content-wrapper.right.transparent .content-area{-webkit-box-shadow:none;-moz-box-shadow:none;box-shadow:none}.content-wrapper.left{height:100%!important;width:100%;padding:0;margin:0 auto;display:-webkit-flex;display:flex;flex-flow:row nowrap}.content-wrapper.left .content-area{position:relative;height:100%;overflow-x:hidden!important;overflow-y:scroll;direction:rtl;width:60%;padding:30px 0;margin:0;z-index:2!important;-webkit-box-shadow:0 5px 5px 0 rgba(0,0,0,.25);-moz-box-shadow:0 5px 5px 0 rgba(0,0,0,.25);box-shadow:0 5px 5px 0 rgba(0,0,0,.25)}.content-wrapper.left .content-area div{direction:ltr}@media only screen and (min-width:768px) and (max-width:1024px) and (orientation:landscape){.content-wrapper.left .content-area{width:60%!important;margin:0!important}}@media only screen and (min-width:768px) and (max-width:1024px) and (orientation:portrait){.content-wrapper.left .content-area{width:calc(100% - 48px)!important;margin:0 24px auto!important}.content-wrapper.left .content-area .asset-right-panel{display:none!important}}.content-wrapper.left .full-screen{width:100%}.content-wrapper.left .left-asset-screen{width:100%!important;margin:0!important}.content-wrapper.left .right-asset-screen{width:100%!important;float:none!important;margin:0!important}.content-wrapper.left .asset-col-left,.content-wrapper.left .asset-col-right{display:none}.content-wrapper.left .asset-right-panel{position:relative;height:100%;padding:30px 24px;z-index:2!important;width:auto;max-width:40%}.content-wrapper.left .asset-right-panel .asset-image-wrapper{position:relative;width:100%;max-width:calc(100% - 0px);overflow:hidden}.content-wrapper.left .asset-right-panel .image-credit{margin-top:10px;background:hsla(0,0%,100%,.9)}.content-wrapper.left.flexi .content-area{width:auto;min-width:60%}.content-wrapper.left.flexi .asset-right-panel{width:auto;max-width:40%}.content-wrapper.left.flexi .asset-right-panel .asset-image-wrapper{position:relative;width:100%;max-width:calc(100% - 0px);overflow:hidden}.content-wrapper.left .content-wrapper-background{display:none}@media only screen and (max-width:375px) and (max-height:736px) and (orientation:portrait){.content-wrapper.left .blurred-feed:not(.accordion-content-wrapper){background:hsla(0,0%,100%,.8)}}@media only screen and (max-height:375px) and (max-width:736px) and (orientation:landscape){.content-wrapper.left .blurred-feed:not(.accordion-content-wrapper){background:hsla(0,0%,100%,.8)}}@media only screen and (min-width:376px) and (max-width:414px) and (max-height:736px) and (orientation:portrait){.content-wrapper.left .blurred-feed:not(.accordion-content-wrapper){background:hsla(0,0%,100%,.8)}}@media only screen and (min-height:376px) and (max-height:414px) and (max-width:736px) and (orientation:landscape){.content-wrapper.left .blurred-feed:not(.accordion-content-wrapper){background:hsla(0,0%,100%,.8)}}@media only screen and (min-width:768px) and (max-width:1024px) and (orientation:portrait){.content-wrapper.left .blurred-feed:not(.accordion-content-wrapper){background:hsla(0,0%,100%,.8)}}@media only screen and (max-width:375px) and (min-height:737px) and (max-height:812px) and (orientation:portrait){.content-wrapper.left .blurred-feed:not(.accordion-content-wrapper){background:hsla(0,0%,100%,.8)}}@media only screen and (min-width:737px) and (max-width:812px) and (max-height:375px) and (orientation:landscape){.content-wrapper.left .blurred-feed:not(.accordion-content-wrapper){background:hsla(0,0%,100%,.8)}}@media only screen and (max-width:320px) and (max-height:568px) and (orientation:portrait){.content-wrapper.left .blurred-feed:not(.accordion-content-wrapper){background:hsla(0,0%,100%,.8)}}@media only screen and (max-width:320px) and (max-height:568px) and (orientation:landscape){.content-wrapper.left .blurred-feed:not(.accordion-content-wrapper){background:hsla(0,0%,100%,.8)}}.content-wrapper.left.frosted_white .content-wrapper-background{z-index:1;display:block;position:absolute;top:0;left:0;right:0;width:100%;height:100%;margin:auto;-webkit-clip-path:inset(0 40% 0 0);clip-path:inset(0 40% 0 0);-webkit-filter:blur(15px);filter:blur(15px)}.content-wrapper.left.frosted_white .content-wrapper-background img{position:absolute;bottom:0;left:0;right:0;margin:auto;width:100%;height:auto}@media only screen and (max-width:375px) and (max-height:736px) and (orientation:portrait){.content-wrapper.left.frosted_white .content-wrapper-background img{min-height:100vh;position:absolute;height:100%;left:0;right:0;margin:auto!important;width:auto;min-width:100%}}@media only screen and (max-height:375px) and (max-width:736px) and (orientation:landscape){.content-wrapper.left.frosted_white .content-wrapper-background img{min-height:100vh;height:auto;top:0;width:100%}.content-wrapper.left.frosted_white .content-wrapper-background img.title-screen{bottom:unset;top:0}}@media only screen and (min-width:376px) and (max-width:414px) and (max-height:736px) and (orientation:portrait){.content-wrapper.left.frosted_white .content-wrapper-background img{min-height:100vh;position:absolute;height:100%;left:0;right:0;margin:auto!important;width:auto;min-width:100%}}@media only screen and (min-height:376px) and (max-height:414px) and (max-width:736px) and (orientation:landscape){.content-wrapper.left.frosted_white .content-wrapper-background img{min-height:100vh;height:auto;bottom:0;width:100%}.content-wrapper.left.frosted_white .content-wrapper-background img.title-screen{bottom:unset;top:0}}@media only screen and (min-width:768px) and (max-width:1024px) and (orientation:landscape){.content-wrapper.left.frosted_white .content-wrapper-background img{min-height:664px;height:auto;width:100%}}@media only screen and (width:900px) and (height:768px){.content-wrapper.left.frosted_white .content-wrapper-background img{min-height:664px;height:auto;width:100%}}@media only screen and (min-width:768px) and (max-width:1024px) and (orientation:portrait){.content-wrapper.left.frosted_white .content-wrapper-background img{min-height:924px;position:absolute;height:100%;left:0;right:0;margin:auto!important;width:auto;min-width:100%}}@media only screen and (max-width:375px) and (min-height:737px) and (max-height:812px) and (orientation:portrait){.content-wrapper.left.frosted_white .content-wrapper-background img{min-height:100vh;position:absolute;height:100%;left:0;right:0;margin:auto!important;width:auto;min-width:100%}}@media only screen and (min-width:737px) and (max-width:812px) and (max-height:375px) and (orientation:landscape){.content-wrapper.left.frosted_white .content-wrapper-background img{min-height:100vh;height:auto;top:0;width:100%}.content-wrapper.left.frosted_white .content-wrapper-background img.title-screen{bottom:unset;top:0}}@media only screen and (max-width:320px) and (max-height:568px) and (orientation:portrait){.content-wrapper.left.frosted_white .content-wrapper-background img{min-height:100vh;position:absolute;height:100%;left:0;right:0;margin:auto!important;width:auto;min-width:100%}}@media only screen and (min-width:200px) and (max-width:900px) and (orientation:landscape){.content-wrapper.left.frosted_white .content-wrapper-background{display:none}}@media only screen and (max-width:375px) and (max-height:736px) and (orientation:portrait){.content-wrapper.left.frosted_white .content-wrapper-background{display:none}}@media only screen and (max-height:375px) and (max-width:736px) and (orientation:landscape){.content-wrapper.left.frosted_white .content-wrapper-background{display:none}}@media only screen and (min-width:376px) and (max-width:414px) and (max-height:736px) and (orientation:portrait){.content-wrapper.left.frosted_white .content-wrapper-background{display:none}}@media only screen and (min-height:376px) and (max-height:414px) and (max-width:736px) and (orientation:landscape){.content-wrapper.left.frosted_white .content-wrapper-background{display:none}}@media only screen and (max-width:375px) and (min-height:737px) and (max-height:812px) and (orientation:portrait){.content-wrapper.left.frosted_white .content-wrapper-background{display:none}}@media only screen and (min-width:768px) and (max-width:1024px) and (orientation:landscape){.content-wrapper.left.frosted_white .content-wrapper-background{position:absolute;top:0;left:0;right:0;width:100%;height:100%;margin:auto;-webkit-clip-path:inset(0 40% 0 0);clip-path:inset(0 40% 0 0);-webkit-filter:blur(15px);filter:blur(15px)}}@media only screen and (min-width:768px) and (max-width:1024px) and (orientation:portrait){.content-wrapper.left.frosted_white .content-wrapper-background{position:absolute;top:0;left:0;right:0;width:100%;height:100%;margin:auto;-webkit-clip-path:inset(0 24px 0 24px);clip-path:inset(0 24px 0 24px);-webkit-filter:blur(15px);filter:blur(15px)}}.content-wrapper.left.frosted_white .content-wrapper-background:after{content:\"\";position:absolute;width:100%;height:100%;margin:0 30px}.content-wrapper.left.frosted_white .blurred-feed{background:hsla(0,0%,100%,.7)}.content-wrapper.left.frosted_white .standard-feed{background:hsla(0,0%,100%,.9)}@media only screen and (max-width:375px) and (max-height:736px) and (orientation:portrait){.content-wrapper.left.frosted_white .blurred-feed:not(.accordion-content-wrapper){background:hsla(0,0%,100%,.8)}}@media only screen and (max-height:375px) and (max-width:736px) and (orientation:landscape){.content-wrapper.left.frosted_white .blurred-feed:not(.accordion-content-wrapper){background:hsla(0,0%,100%,.8)}}@media only screen and (min-width:376px) and (max-width:414px) and (max-height:736px) and (orientation:portrait){.content-wrapper.left.frosted_white .blurred-feed:not(.accordion-content-wrapper){background:hsla(0,0%,100%,.8)}}@media only screen and (min-height:376px) and (max-height:414px) and (max-width:736px) and (orientation:landscape){.content-wrapper.left.frosted_white .blurred-feed:not(.accordion-content-wrapper){background:hsla(0,0%,100%,.8)}}@media only screen and (min-width:768px) and (max-width:1024px) and (orientation:portrait){.content-wrapper.left.frosted_white .blurred-feed:not(.accordion-content-wrapper){background:hsla(0,0%,100%,.8)}}@media only screen and (max-width:375px) and (min-height:737px) and (max-height:812px) and (orientation:portrait){.content-wrapper.left.frosted_white .blurred-feed:not(.accordion-content-wrapper){background:hsla(0,0%,100%,.8)}}@media only screen and (min-width:737px) and (max-width:812px) and (max-height:375px) and (orientation:landscape){.content-wrapper.left.frosted_white .blurred-feed:not(.accordion-content-wrapper){background:hsla(0,0%,100%,.8)}}@media only screen and (max-width:320px) and (max-height:568px) and (orientation:portrait){.content-wrapper.left.frosted_white .blurred-feed:not(.accordion-content-wrapper){background:hsla(0,0%,100%,.8)}}@media only screen and (max-width:320px) and (max-height:568px) and (orientation:landscape){.content-wrapper.left.frosted_white .blurred-feed:not(.accordion-content-wrapper){background:hsla(0,0%,100%,.8)}}.content-wrapper.left.tinted_dark .content-wrapper-background{z-index:1;display:block;position:absolute;top:0;left:0;right:0;width:100%;height:100%;margin:auto;-webkit-clip-path:inset(0 40% 0 0);clip-path:inset(0 40% 0 0);-webkit-filter:blur(15px);filter:blur(15px)}.content-wrapper.left.tinted_dark .content-wrapper-background img{position:absolute;bottom:0;left:0;right:0;margin:auto;width:100%;height:auto}@media only screen and (max-width:375px) and (max-height:736px) and (orientation:portrait){.content-wrapper.left.tinted_dark .content-wrapper-background img{min-height:100vh;position:absolute;height:100%;left:0;right:0;margin:auto!important;width:auto;min-width:100%}}@media only screen and (max-height:375px) and (max-width:736px) and (orientation:landscape){.content-wrapper.left.tinted_dark .content-wrapper-background img{min-height:100vh;height:auto;top:0;width:100%}.content-wrapper.left.tinted_dark .content-wrapper-background img.title-screen{bottom:unset;top:0}}@media only screen and (min-width:376px) and (max-width:414px) and (max-height:736px) and (orientation:portrait){.content-wrapper.left.tinted_dark .content-wrapper-background img{min-height:100vh;position:absolute;height:100%;left:0;right:0;margin:auto!important;width:auto;min-width:100%}}@media only screen and (min-height:376px) and (max-height:414px) and (max-width:736px) and (orientation:landscape){.content-wrapper.left.tinted_dark .content-wrapper-background img{min-height:100vh;height:auto;bottom:0;width:100%}.content-wrapper.left.tinted_dark .content-wrapper-background img.title-screen{bottom:unset;top:0}}@media only screen and (min-width:768px) and (max-width:1024px) and (orientation:landscape){.content-wrapper.left.tinted_dark .content-wrapper-background img{min-height:664px;height:auto;width:100%}}@media only screen and (width:900px) and (height:768px){.content-wrapper.left.tinted_dark .content-wrapper-background img{min-height:664px;height:auto;width:100%}}@media only screen and (min-width:768px) and (max-width:1024px) and (orientation:portrait){.content-wrapper.left.tinted_dark .content-wrapper-background img{min-height:924px;position:absolute;height:100%;left:0;right:0;margin:auto!important;width:auto;min-width:100%}}@media only screen and (max-width:375px) and (min-height:737px) and (max-height:812px) and (orientation:portrait){.content-wrapper.left.tinted_dark .content-wrapper-background img{min-height:100vh;position:absolute;height:100%;left:0;right:0;margin:auto!important;width:auto;min-width:100%}}@media only screen and (min-width:737px) and (max-width:812px) and (max-height:375px) and (orientation:landscape){.content-wrapper.left.tinted_dark .content-wrapper-background img{min-height:100vh;height:auto;top:0;width:100%}.content-wrapper.left.tinted_dark .content-wrapper-background img.title-screen{bottom:unset;top:0}}@media only screen and (max-width:320px) and (max-height:568px) and (orientation:portrait){.content-wrapper.left.tinted_dark .content-wrapper-background img{min-height:100vh;position:absolute;height:100%;left:0;right:0;margin:auto!important;width:auto;min-width:100%}}@media only screen and (min-width:200px) and (max-width:900px) and (orientation:landscape){.content-wrapper.left.tinted_dark .content-wrapper-background{display:none}}@media only screen and (max-width:375px) and (max-height:736px) and (orientation:portrait){.content-wrapper.left.tinted_dark .content-wrapper-background{display:none}}@media only screen and (max-height:375px) and (max-width:736px) and (orientation:landscape){.content-wrapper.left.tinted_dark .content-wrapper-background{display:none}}@media only screen and (min-width:376px) and (max-width:414px) and (max-height:736px) and (orientation:portrait){.content-wrapper.left.tinted_dark .content-wrapper-background{display:none}}@media only screen and (min-height:376px) and (max-height:414px) and (max-width:736px) and (orientation:landscape){.content-wrapper.left.tinted_dark .content-wrapper-background{display:none}}@media only screen and (max-width:375px) and (min-height:737px) and (max-height:812px) and (orientation:portrait){.content-wrapper.left.tinted_dark .content-wrapper-background{display:none}}@media only screen and (min-width:768px) and (max-width:1024px) and (orientation:landscape){.content-wrapper.left.tinted_dark .content-wrapper-background{position:absolute;top:0;left:0;right:0;width:100%;height:100%;margin:auto;-webkit-clip-path:inset(0 40% 0 0);clip-path:inset(0 40% 0 0);-webkit-filter:blur(15px);filter:blur(15px)}}@media only screen and (min-width:768px) and (max-width:1024px) and (orientation:portrait){.content-wrapper.left.tinted_dark .content-wrapper-background{position:absolute;top:0;left:0;right:0;width:100%;height:100%;margin:auto;-webkit-clip-path:inset(0 24px 0 24px);clip-path:inset(0 24px 0 24px);-webkit-filter:blur(15px);filter:blur(15px)}}.content-wrapper.left.tinted_dark .content-area{background:rgba(0,0,0,.5)}.content-wrapper.left.thick_glass .content-wrapper-background{z-index:1;display:block;position:absolute;top:0;left:0;right:0;width:100%;height:100%;margin:auto;-webkit-clip-path:inset(0 40% 0 0);clip-path:inset(0 40% 0 0);-webkit-filter:blur(15px);filter:blur(15px)}.content-wrapper.left.thick_glass .content-wrapper-background img{position:absolute;bottom:0;left:0;right:0;margin:auto;width:100%;height:auto}@media only screen and (max-width:375px) and (max-height:736px) and (orientation:portrait){.content-wrapper.left.thick_glass .content-wrapper-background img{min-height:100vh;position:absolute;height:100%;left:0;right:0;margin:auto!important;width:auto;min-width:100%}}@media only screen and (max-height:375px) and (max-width:736px) and (orientation:landscape){.content-wrapper.left.thick_glass .content-wrapper-background img{min-height:100vh;height:auto;top:0;width:100%}.content-wrapper.left.thick_glass .content-wrapper-background img.title-screen{bottom:unset;top:0}}@media only screen and (min-width:376px) and (max-width:414px) and (max-height:736px) and (orientation:portrait){.content-wrapper.left.thick_glass .content-wrapper-background img{min-height:100vh;position:absolute;height:100%;left:0;right:0;margin:auto!important;width:auto;min-width:100%}}@media only screen and (min-height:376px) and (max-height:414px) and (max-width:736px) and (orientation:landscape){.content-wrapper.left.thick_glass .content-wrapper-background img{min-height:100vh;height:auto;bottom:0;width:100%}.content-wrapper.left.thick_glass .content-wrapper-background img.title-screen{bottom:unset;top:0}}@media only screen and (min-width:768px) and (max-width:1024px) and (orientation:landscape){.content-wrapper.left.thick_glass .content-wrapper-background img{min-height:664px;height:auto;width:100%}}@media only screen and (width:900px) and (height:768px){.content-wrapper.left.thick_glass .content-wrapper-background img{min-height:664px;height:auto;width:100%}}@media only screen and (min-width:768px) and (max-width:1024px) and (orientation:portrait){.content-wrapper.left.thick_glass .content-wrapper-background img{min-height:924px;position:absolute;height:100%;left:0;right:0;margin:auto!important;width:auto;min-width:100%}}@media only screen and (max-width:375px) and (min-height:737px) and (max-height:812px) and (orientation:portrait){.content-wrapper.left.thick_glass .content-wrapper-background img{min-height:100vh;position:absolute;height:100%;left:0;right:0;margin:auto!important;width:auto;min-width:100%}}@media only screen and (min-width:737px) and (max-width:812px) and (max-height:375px) and (orientation:landscape){.content-wrapper.left.thick_glass .content-wrapper-background img{min-height:100vh;height:auto;top:0;width:100%}.content-wrapper.left.thick_glass .content-wrapper-background img.title-screen{bottom:unset;top:0}}@media only screen and (max-width:320px) and (max-height:568px) and (orientation:portrait){.content-wrapper.left.thick_glass .content-wrapper-background img{min-height:100vh;position:absolute;height:100%;left:0;right:0;margin:auto!important;width:auto;min-width:100%}}@media only screen and (min-width:200px) and (max-width:900px) and (orientation:landscape){.content-wrapper.left.thick_glass .content-wrapper-background{display:none}}@media only screen and (max-width:375px) and (max-height:736px) and (orientation:portrait){.content-wrapper.left.thick_glass .content-wrapper-background{display:none}}@media only screen and (max-height:375px) and (max-width:736px) and (orientation:landscape){.content-wrapper.left.thick_glass .content-wrapper-background{display:none}}@media only screen and (min-width:376px) and (max-width:414px) and (max-height:736px) and (orientation:portrait){.content-wrapper.left.thick_glass .content-wrapper-background{display:none}}@media only screen and (min-height:376px) and (max-height:414px) and (max-width:736px) and (orientation:landscape){.content-wrapper.left.thick_glass .content-wrapper-background{display:none}}@media only screen and (max-width:375px) and (min-height:737px) and (max-height:812px) and (orientation:portrait){.content-wrapper.left.thick_glass .content-wrapper-background{display:none}}@media only screen and (min-width:768px) and (max-width:1024px) and (orientation:landscape){.content-wrapper.left.thick_glass .content-wrapper-background{position:absolute;top:0;left:0;right:0;width:100%;height:100%;margin:auto;-webkit-clip-path:inset(0 40% 0 0);clip-path:inset(0 40% 0 0);-webkit-filter:blur(15px);filter:blur(15px)}}@media only screen and (min-width:768px) and (max-width:1024px) and (orientation:portrait){.content-wrapper.left.thick_glass .content-wrapper-background{position:absolute;top:0;left:0;right:0;width:100%;height:100%;margin:auto;-webkit-clip-path:inset(0 24px 0 24px);clip-path:inset(0 24px 0 24px);-webkit-filter:blur(15px);filter:blur(15px)}}.content-wrapper.left.thick_glass .blurred-feed{background:hsla(0,0%,91%,.2)}.content-wrapper.left.thick_glass .standard-feed{background:hsla(0,0%,91%,.9)}@media only screen and (max-width:375px) and (max-height:736px) and (orientation:portrait){.content-wrapper.left.thick_glass .blurred-feed{background:hsla(0,0%,91%,.9)}}@media only screen and (max-height:375px) and (max-width:736px) and (orientation:landscape){.content-wrapper.left.thick_glass .blurred-feed{background:hsla(0,0%,91%,.9)}}@media only screen and (min-width:376px) and (max-width:414px) and (max-height:736px) and (orientation:portrait){.content-wrapper.left.thick_glass .blurred-feed{background:hsla(0,0%,91%,.9)}}@media only screen and (min-height:376px) and (max-height:414px) and (max-width:736px) and (orientation:landscape){.content-wrapper.left.thick_glass .blurred-feed{background:hsla(0,0%,91%,.9)}}@media only screen and (min-width:768px) and (max-width:1024px) and (orientation:portrait){.content-wrapper.left.thick_glass .blurred-feed{background:hsla(0,0%,91%,.9)}}@media only screen and (max-width:375px) and (min-height:737px) and (max-height:812px) and (orientation:portrait){.content-wrapper.left.thick_glass .blurred-feed{background:hsla(0,0%,91%,.9)}}@media only screen and (min-width:737px) and (max-width:812px) and (max-height:375px) and (orientation:landscape){.content-wrapper.left.thick_glass .blurred-feed{background:hsla(0,0%,91%,.9)}}@media only screen and (max-width:320px) and (max-height:568px) and (orientation:portrait){.content-wrapper.left.thick_glass .blurred-feed{background:hsla(0,0%,91%,.9)}}@media only screen and (max-width:320px) and (max-height:568px) and (orientation:landscape){.content-wrapper.left.thick_glass .blurred-feed{background:hsla(0,0%,91%,.9)}}.content-wrapper.left.transparent .content-area{-webkit-box-shadow:none;-moz-box-shadow:none;box-shadow:none}.content-wrapper .asset-image-wrapper{position:relative;-webkit-animation:1.2s ease-in 0s normal forwards 1 fadein;animation:1.2s ease-in 0s normal forwards 1 fadein}.content-wrapper .asset-image-wrapper img{height:auto;max-height:unset;width:auto;max-width:100%}.content-wrapper .asset-image-wrapper.border{background:#fff;border:2px solid #d5d5d5}.content-wrapper .asset-image-wrapper.padded_border{background:#fff;border:2px solid #d5d5d5;padding:4px}.content-wrapper .asset-image-wrapper.padded_shadow,.content-wrapper .asset-image-wrapper.shadow{background:#fff;-webkit-box-shadow:0 2px 5px 0 rgba(0,0,0,.5);-moz-box-shadow:0 2px 5px 0 rgba(0,0,0,.5);box-shadow:0 2px 5px 0 rgba(0,0,0,.5)}.content-wrapper .asset-image-wrapper.padded_shadow{padding:4px}.content-wrapper .asset-image-wrapper.square{display:block;overflow:hidden!important;position:relative}.content-wrapper .asset-image-wrapper.square:before{display:block;content:\"\";width:100%!important;padding-top:100%}.content-wrapper .asset-image-wrapper.square img{position:absolute;top:0;left:0;max-width:100%}.content-wrapper .asset-image-wrapper.square.landscape img{width:auto!important;max-width:unset!important;height:auto!important;max-height:100%!important}.content-wrapper .asset-image-wrapper.square.portrait img{height:auto!important;max-height:unset!important;width:auto!important;max-width:100%!important}.content-wrapper .asset-image-wrapper.square.left img,.content-wrapper .asset-image-wrapper.square.top img{top:0;left:0}.content-wrapper .asset-image-wrapper.square.center img{top:0;left:50%;-webkit-transform:translateX(-50%);transform:translateX(-50%)}.content-wrapper .asset-image-wrapper.square.right img{top:0;left:100%;-webkit-transform:translateX(-100%);transform:translateX(-100%)}.content-wrapper .asset-image-wrapper.square.middle img{left:0;top:50%;-webkit-transform:translateY(-50%);transform:translateY(-50%)}.content-wrapper .asset-image-wrapper.square.bottom img{top:100%;-webkit-transform:translateY(-100%);transform:translateY(-100%);left:0}.content-wrapper .asset-image-wrapper.square.padded_border:after,.content-wrapper .asset-image-wrapper.square.padded_shadow:after{position:absolute;left:0;top:0;width:100%;height:100%;border:4px solid #fff;content:\"\"}.content-wrapper .asset-image-wrapper.circle{display:block;position:relative;overflow:hidden!important;border-radius:50%;background:#fff}.content-wrapper .asset-image-wrapper.circle:before{display:block;content:\"\";width:100%!important;padding-top:100%}.content-wrapper .asset-image-wrapper.circle img{position:absolute}.content-wrapper .asset-image-wrapper.circle.padded_border:after,.content-wrapper .asset-image-wrapper.circle.padded_shadow:after{border-radius:50%}.content-wrapper .asset-image-wrapper.circle.landscape img{width:auto!important;max-width:unset!important;height:auto!important;max-height:100%!important}.content-wrapper .asset-image-wrapper.circle.portrait img{height:auto!important;max-height:unset!important;width:auto!important;max-width:100%!important}.content-wrapper .asset-image-wrapper.circle.left img,.content-wrapper .asset-image-wrapper.circle.top img{top:0;left:0}.content-wrapper .asset-image-wrapper.circle.center img{top:0;left:50%;-webkit-transform:translateX(-50%);transform:translateX(-50%)}.content-wrapper .asset-image-wrapper.circle.right img{top:0;left:100%;-webkit-transform:translateX(-100%);transform:translateX(-100%)}.content-wrapper .asset-image-wrapper.circle.middle img{left:0;top:50%;-webkit-transform:translateY(-50%);transform:translateY(-50%)}.content-wrapper .asset-image-wrapper.circle.bottom img{top:100%;-webkit-transform:translateY(-100%);transform:translateY(-100%);left:0}.content-wrapper .asset-image-wrapper.circle.padded_border:after,.content-wrapper .asset-image-wrapper.circle.padded_shadow:after{position:absolute;left:0;top:0;width:100%;height:100%;border:4px solid #fff;content:\"\"}.content-wrapper .asset-image-wrapper.rectangle{display:block;overflow:hidden!important}.content-wrapper .asset-image-wrapper.rectangle img{position:absolute;top:0;left:0}.content-wrapper .asset-image-wrapper.rectangle.landscape{position:relative}.content-wrapper .asset-image-wrapper.rectangle.landscape:before{display:block;content:\"\";width:100%!important;padding-top:133.33333%}.content-wrapper .asset-image-wrapper.rectangle.landscape img{width:auto;max-width:unset;height:auto;max-height:100%}.content-wrapper .asset-image-wrapper.rectangle.portrait{position:relative}.content-wrapper .asset-image-wrapper.rectangle.portrait:before{display:block;content:\"\";width:100%!important;padding-top:75%}.content-wrapper .asset-image-wrapper.rectangle.portrait img{height:auto;max-height:unset;width:auto;max-width:100%}.content-wrapper .asset-image-wrapper.rectangle.left img,.content-wrapper .asset-image-wrapper.rectangle.top img{top:0;left:0}.content-wrapper .asset-image-wrapper.rectangle.center img{top:0;left:50%;-webkit-transform:translateX(-50%);transform:translateX(-50%)}.content-wrapper .asset-image-wrapper.rectangle.right img{top:0;left:100%;-webkit-transform:translateX(-100%);transform:translateX(-100%)}.content-wrapper .asset-image-wrapper.rectangle.middle img{left:0;top:50%;-webkit-transform:translateY(-50%);transform:translateY(-50%)}.content-wrapper .asset-image-wrapper.rectangle.bottom img{top:100%;-webkit-transform:translateY(-100%);transform:translateY(-100%);left:0}.content-wrapper .asset-image-wrapper.rectangle.padded_border:after,.content-wrapper .asset-image-wrapper.rectangle.padded_shadow:after{position:absolute;left:0;top:0;width:100%;height:100%;border:4px solid #fff;content:\"\"}@media only screen and (max-width:375px) and (max-height:736px) and (orientation:portrait){.content-wrapper .asset-left-panel,.content-wrapper .asset-right-panel{display:none}.content-wrapper.left .asset-col-left,.content-wrapper.left .asset-col-right,.content-wrapper.right .asset-col-left,.content-wrapper.right .asset-col-right{display:block!important}}@media only screen and (max-height:375px) and (max-width:736px) and (orientation:landscape){.content-wrapper .asset-left-panel,.content-wrapper .asset-right-panel{display:none}}@media only screen and (min-width:376px) and (max-width:414px) and (max-height:736px) and (orientation:portrait){.content-wrapper .asset-left-panel,.content-wrapper .asset-right-panel{display:none}}@media only screen and (min-height:376px) and (max-height:414px) and (max-width:736px) and (orientation:landscape){.content-wrapper .asset-left-panel,.content-wrapper .asset-right-panel{display:none}}@media only screen and (max-width:375px) and (min-height:737px) and (max-height:812px) and (orientation:portrait){.content-wrapper .asset-left-panel,.content-wrapper .asset-right-panel{display:none}}@media only screen and (min-height:737px) and (max-height:812px) and (max-width:375px) and (orientation:landscape){.content-wrapper .asset-left-panel,.content-wrapper .asset-right-panel{display:none}}.menu-header{padding:8px 12px;height:80px;text-align:center}.menu-header h2,.menu-header h3{margin:0!important}.menu-body{display:block;min-height:584px;max-height:690px;height:calc(100vh - 80px);padding:30px 48px;overflow-y:scroll}@media only screen and (max-width:375px) and (max-height:736px) and (orientation:portrait){.menu-body{height:100%!important;max-height:calc(100vh - 80px)!important}}@media only screen and (max-height:375px) and (max-width:736px) and (orientation:landscape){.menu-body{max-height:calc(100vh - 80px)!important}}@media only screen and (min-width:376px) and (max-width:414px) and (max-height:736px) and (orientation:portrait){.menu-body{max-height:calc(100vh - 80px)!important}}@media only screen and (min-height:376px) and (max-height:414px) and (max-width:736px) and (orientation:landscape){.menu-body{max-height:calc(100vh - 80px)!important}}@media only screen and (min-width:768px) and (max-width:1024px) and (orientation:landscape){.menu-body{max-height:584px!important}}@media only screen and (min-width:768px) and (max-width:1024px) and (orientation:portrait){.menu-body{max-height:844px!important}}@media only screen and (max-width:375px) and (min-height:737px) and (max-height:812px) and (orientation:portrait){.menu-body{max-height:calc(100vh - 80px)!important}}@media only screen and (min-width:737px) and (max-width:812px) and (max-height:375px) and (orientation:landscape){.menu-body{max-height:calc(100vh - 80px)!important}}@media only screen and (max-width:320px) and (max-height:568px) and (orientation:portrait){.menu-body{min-height:calc(100vh - 80px)!important;height:100%!important}}.personalised-menu-header{text-align:center;position:relative;-webkit-box-shadow:0 3px 5px 0 rgba(0,0,0,.25);-moz-box-shadow:0 3px 5px 0 rgba(0,0,0,.25);box-shadow:0 3px 5px 0 rgba(0,0,0,.25)}.personalised-menu-header .label-panel{position:relative;padding:8px 150px 0;min-height:70px;overflow:hidden;display:-webkit-flex;display:flex;flex-flow:row nowrap;align-items:center}.personalised-menu-header .label-panel.include-nav{padding-left:90px!important;padding-right:60px!important}.personalised-menu-header .label-panel.include-nav h3,.personalised-menu-header .label-panel h3{margin:0!important}.personalised-menu-header .label-panel .nav-item{float:right}.personalised-menu-header .filter-panel{position:relative;width:100%;overflow:hidden;text-align:right;margin:0;padding:8px 60px;min-height:52px}.personalised-menu-header .filter-panel .instruction-text{padding-left:150px;padding-right:150px;text-align:center}.personalised-menu-header .filter-panel h3{font-size:130%!important}.personalised-menu-header h2{margin:0!important}.personalised-menu-header h3{margin:10px 0 0!important}.personalised-menu-header .character-image{height:125px;position:absolute;bottom:0;left:45px}.personalised-menu-header .character-image img{height:100%;width:auto}.personalised-menu-header .accessibility-panel{width:140px;top:14px;right:8px;position:absolute}.personalised-menu-header .instruction-text{margin-top:10px}@media only screen and (max-width:375px) and (max-height:736px) and (orientation:portrait){.personalised-menu-header .label-panel{padding:5px 12px 0 50px;min-height:70px;overflow:hidden;text-align:center}.personalised-menu-header .label-panel.include-nav{padding-left:70px!important;padding-right:12px!important}.personalised-menu-header .character-image{height:48px;width:48px;overflow:hidden;border-radius:50%;background:#fff;position:absolute;bottom:unset;top:12px;left:12px}.personalised-menu-header .character-image img{height:100%;width:auto}.personalised-menu-header .filter-panel{padding:6px 12px!important}.personalised-menu-header .filter-panel h3{padding-top:5px;font-size:120%}.personalised-menu-header .filter-panel .instruction-text{padding-left:0!important;padding-right:0!important}}@media only screen and (max-height:375px) and (max-width:736px) and (orientation:landscape){.personalised-menu-header .character-image{left:10px}.personalised-menu-header .label-panel{padding:5px 12px 0 50px;min-height:70px;overflow:hidden;text-align:center}.personalised-menu-header .label-panel.include-nav{padding-left:70px!important;padding-right:12px!important}.personalised-menu-header .character-image{height:48px;width:48px;overflow:hidden;border-radius:50%;background:#fff;position:absolute;bottom:unset;top:12px;left:12px}.personalised-menu-header .character-image img{height:100%;width:auto}.personalised-menu-header .filter-panel{padding:6px 12px!important}.personalised-menu-header .filter-panel h3{padding-top:5px;font-size:120%}.personalised-menu-header .filter-panel .instruction-text{padding-left:0!important;padding-right:0!important}}@media only screen and (min-width:376px) and (max-width:414px) and (max-height:736px) and (orientation:portrait){.personalised-menu-header .label-panel{padding:5px 12px 0 50px;min-height:70px;overflow:hidden;text-align:center}.personalised-menu-header .label-panel.include-nav{padding-left:70px!important;padding-right:12px!important}.personalised-menu-header .character-image{height:48px;width:48px;overflow:hidden;border-radius:50%;background:#fff;position:absolute;bottom:unset;top:12px;left:12px}.personalised-menu-header .character-image img{height:100%;width:auto}.personalised-menu-header .filter-panel{padding:6px 12px!important}.personalised-menu-header .filter-panel h3{padding-top:5px;font-size:120%}.personalised-menu-header .filter-panel .instruction-text{padding-left:0!important;padding-right:0!important}}@media only screen and (min-height:376px) and (max-height:414px) and (max-width:736px) and (orientation:landscape){.personalised-menu-header .character-image{left:10px}.personalised-menu-header .label-panel{padding:5px 12px 0 50px;min-height:70px;overflow:hidden;text-align:center}.personalised-menu-header .label-panel.include-nav{padding-left:70px!important;padding-right:12px!important}.personalised-menu-header .character-image{height:48px;width:48px;overflow:hidden;border-radius:50%;background:#fff;position:absolute;bottom:unset;top:12px;left:12px}.personalised-menu-header .character-image img{height:100%;width:auto}.personalised-menu-header .filter-panel{padding:6px 12px!important}.personalised-menu-header .filter-panel h3{padding-top:5px;font-size:120%}.personalised-menu-header .filter-panel .instruction-text{padding-left:0!important;padding-right:0!important}}@media only screen and (max-width:375px) and (min-height:737px) and (max-height:812px) and (orientation:portrait){.personalised-menu-header .label-panel{padding:5px 12px 0 50px;min-height:70px;overflow:hidden;text-align:center}.personalised-menu-header .label-panel.include-nav{padding-left:70px!important;padding-right:12px!important}.personalised-menu-header .character-image{height:48px;width:48px;overflow:hidden;border-radius:50%;background:#fff;position:absolute;bottom:unset;top:12px;left:12px}.personalised-menu-header .character-image img{height:100%;width:auto}.personalised-menu-header .filter-panel{padding:6px 12px!important}.personalised-menu-header .filter-panel h3{padding-top:5px;font-size:120%}.personalised-menu-header .filter-panel .instruction-text{padding-left:0!important;padding-right:0!important}}@media only screen and (min-height:737px) and (max-height:812px) and (max-width:375px) and (orientation:landscape){.personalised-menu-header .character-image{left:10px}.personalised-menu-header .label-panel{padding:5px 12px 0 50px;min-height:70px;overflow:hidden;text-align:center}.personalised-menu-header .label-panel.include-nav{padding-left:70px!important;padding-right:12px!important}.personalised-menu-header .character-image{height:48px;width:48px;overflow:hidden;border-radius:50%;background:#fff;position:absolute;bottom:unset;top:12px;left:12px}.personalised-menu-header .character-image img{height:100%;width:auto}.personalised-menu-header .filter-panel{padding:6px 12px!important}.personalised-menu-header .filter-panel h3{padding-top:5px;font-size:120%}.personalised-menu-header .filter-panel .instruction-text{padding-left:0!important;padding-right:0!important}}@media only screen and (min-width:768px) and (max-width:1024px) and (orientation:landscape){.personalised-menu-header .label-panel{padding:5px 12px 0 50px;min-height:70px;overflow:hidden;text-align:center}.personalised-menu-header .label-panel.include-nav{padding-left:70px!important;padding-right:12px!important}.personalised-menu-header .character-image{height:48px;width:48px;overflow:hidden;border-radius:50%;background:#fff;position:absolute;bottom:unset;top:12px;left:12px}.personalised-menu-header .character-image img{height:100%;width:auto}.personalised-menu-header .filter-panel{padding:6px 12px!important}.personalised-menu-header .filter-panel h3{padding-top:5px;font-size:120%}.personalised-menu-header .filter-panel .instruction-text{padding-left:0!important;padding-right:0!important}}.personalised-menu-body{display:block;margin-top:5px;padding:30px 48px;overflow-y:scroll}@media only screen and (max-width:375px) and (max-height:736px) and (orientation:portrait){.personalised-menu-body{padding:12px}}@media only screen and (min-width:376px) and (max-width:414px) and (max-height:736px) and (orientation:portrait){.personalised-menu-body{padding:12px}}@media only screen and (max-width:375px) and (min-height:737px) and (max-height:812px) and (orientation:portrait){.personalised-menu-body{padding:12px}}.menu-grid{display:block;overflow:hidden;margin:0;padding:0;min-height:524px;max-height:630px!important;height:calc(100vh - 140px)}@media only screen and (max-width:375px) and (max-height:736px) and (orientation:portrait){.menu-grid{min-height:calc(100vh - 140px)!important;height:100%!important}}@media only screen and (max-height:375px) and (max-width:736px) and (orientation:landscape){.menu-grid{height:100%!important;min-height:calc(100vh - 140px)!important}}@media only screen and (min-width:376px) and (max-width:414px) and (max-height:736px) and (orientation:portrait){.menu-grid{height:100%!important;min-height:calc(100vh - 140px)!important}}@media only screen and (min-height:376px) and (max-height:414px) and (max-width:736px) and (orientation:landscape){.menu-grid{height:100%!important;min-height:calc(100vh - 140px)!important}}@media only screen and (min-width:768px) and (max-width:1024px) and (orientation:landscape){.menu-grid{height:100%!important;min-height:524px!important}}@media only screen and (min-width:768px) and (max-width:1024px) and (orientation:portrait){.menu-grid{height:100%!important;min-height:784px!important}}@media only screen and (max-width:375px) and (min-height:737px) and (max-height:812px) and (orientation:portrait){.menu-grid{height:100%!important;min-height:calc(100vh - 140px)!important}}@media only screen and (min-width:737px) and (max-width:812px) and (max-height:375px) and (orientation:landscape){.menu-grid{height:100%!important;min-height:calc(100vh - 140px)!important}}@media only screen and (max-width:320px) and (max-height:568px) and (orientation:portrait){.menu-grid{min-height:calc(100vh - 140px)!important;height:100%!important}}.menu-grid .grid-item{position:relative;padding:16px;display:block;float:left;text-align:center}.menu-grid .grid-item .thumbnail{display:block;position:absolute;background:#ccc;overflow:hidden;left:0;right:0;margin:auto;top:8px;width:calc(100% - 16px);height:calc(100% - 16px)}.menu-grid .grid-item:first-child:last-child{width:50%;min-height:570.66667px;max-height:676.66667px;min-height:617.33333px;max-height:723.33333px;margin-left:25%}@media only screen and (max-width:375px) and (max-height:736px) and (orientation:portrait){.menu-grid .grid-item:first-child:last-child{height:100%;min-height:calc((100vh - 140px) / 1.5)}}@media only screen and (max-height:375px) and (max-width:736px) and (orientation:landscape){.menu-grid .grid-item:first-child:last-child{min-height:calc((100vh - 140px) / 1.5)}}@media only screen and (min-width:376px) and (max-width:414px) and (max-height:736px) and (orientation:portrait){.menu-grid .grid-item:first-child:last-child{height:100%;min-height:calc((100vh - 140px) / 1.5)}}@media only screen and (min-height:376px) and (max-height:414px) and (max-width:736px) and (orientation:landscape){.menu-grid .grid-item:first-child:last-child{min-height:calc((100vh - 140px) / 1.5)}}@media only screen and (max-width:375px) and (min-height:737px) and (max-height:812px) and (orientation:portrait){.menu-grid .grid-item:first-child:last-child{height:100%;min-height:calc((100vh - 140px) / 1.5)}}@media only screen and (min-width:737px) and (max-width:812px) and (max-height:375px) and (orientation:landscape){.menu-grid .grid-item:first-child:last-child{min-height:calc((100vh - 140px) / 1.5)}}@media only screen and (min-width:768px) and (max-width:1024px) and (orientation:landscape){.menu-grid .grid-item:first-child:last-child{min-height:349.33333px}}@media only screen and (min-width:768px) and (max-width:1024px) and (orientation:portrait){.menu-grid .grid-item:first-child:last-child{min-height:522.66667px}}@media only screen and (max-width:375px) and (max-height:736px) and (orientation:portrait){.menu-grid .grid-item:first-child:last-child{height:100%;min-height:calc((100vh - 140px) / 3)}}@media only screen and (max-height:375px) and (max-width:736px) and (orientation:landscape){.menu-grid .grid-item:first-child:last-child{min-height:calc((100vh - 140px) / 3)}}@media only screen and (min-width:376px) and (max-width:414px) and (max-height:736px) and (orientation:portrait){.menu-grid .grid-item:first-child:last-child{height:100%;min-height:calc((100vh - 140px) / 3)}}@media only screen and (min-height:376px) and (max-height:414px) and (max-width:736px) and (orientation:landscape){.menu-grid .grid-item:first-child:last-child{min-height:calc((100vh - 140px) / 3)}}@media only screen and (max-width:375px) and (min-height:737px) and (max-height:812px) and (orientation:portrait){.menu-grid .grid-item:first-child:last-child{height:100%;min-height:calc((100vh - 140px) / 3)}}@media only screen and (min-width:737px) and (max-width:812px) and (max-height:375px) and (orientation:landscape){.menu-grid .grid-item:first-child:last-child{min-height:calc((100vh - 140px) / 3)}}@media only screen and (min-width:768px) and (max-width:1024px) and (orientation:landscape){.menu-grid .grid-item:first-child:last-child{min-height:174.66667px}}@media only screen and (min-width:768px) and (max-width:1024px) and (orientation:portrait){.menu-grid .grid-item:first-child:last-child{min-height:261.33333px}}.menu-grid .grid-item:first-child:nth-last-child(2){width:50%;min-height:570.66667px;max-height:676.66667px;min-height:617.33333px;max-height:723.33333px}@media only screen and (max-width:375px) and (max-height:736px) and (orientation:portrait){.menu-grid .grid-item:first-child:nth-last-child(2){height:100%;min-height:calc((100vh - 140px) / 1.5)}}@media only screen and (max-height:375px) and (max-width:736px) and (orientation:landscape){.menu-grid .grid-item:first-child:nth-last-child(2){min-height:calc((100vh - 140px) / 1.5)}}@media only screen and (min-width:376px) and (max-width:414px) and (max-height:736px) and (orientation:portrait){.menu-grid .grid-item:first-child:nth-last-child(2){height:100%;min-height:calc((100vh - 140px) / 1.5)}}@media only screen and (min-height:376px) and (max-height:414px) and (max-width:736px) and (orientation:landscape){.menu-grid .grid-item:first-child:nth-last-child(2){min-height:calc((100vh - 140px) / 1.5)}}@media only screen and (max-width:375px) and (min-height:737px) and (max-height:812px) and (orientation:portrait){.menu-grid .grid-item:first-child:nth-last-child(2){height:100%;min-height:calc((100vh - 140px) / 1.5)}}@media only screen and (min-width:737px) and (max-width:812px) and (max-height:375px) and (orientation:landscape){.menu-grid .grid-item:first-child:nth-last-child(2){min-height:calc((100vh - 140px) / 1.5)}}@media only screen and (min-width:768px) and (max-width:1024px) and (orientation:landscape){.menu-grid .grid-item:first-child:nth-last-child(2){min-height:349.33333px}}@media only screen and (min-width:768px) and (max-width:1024px) and (orientation:portrait){.menu-grid .grid-item:first-child:nth-last-child(2){min-height:522.66667px}}@media only screen and (max-width:375px) and (max-height:736px) and (orientation:portrait){.menu-grid .grid-item:first-child:nth-last-child(2){height:100%;min-height:calc((100vh - 140px) / 3)}}@media only screen and (max-height:375px) and (max-width:736px) and (orientation:landscape){.menu-grid .grid-item:first-child:nth-last-child(2){min-height:calc((100vh - 140px) / 3)}}@media only screen and (min-width:376px) and (max-width:414px) and (max-height:736px) and (orientation:portrait){.menu-grid .grid-item:first-child:nth-last-child(2){height:100%;min-height:calc((100vh - 140px) / 3)}}@media only screen and (min-height:376px) and (max-height:414px) and (max-width:736px) and (orientation:landscape){.menu-grid .grid-item:first-child:nth-last-child(2){min-height:calc((100vh - 140px) / 3)}}@media only screen and (max-width:375px) and (min-height:737px) and (max-height:812px) and (orientation:portrait){.menu-grid .grid-item:first-child:nth-last-child(2){height:100%;min-height:calc((100vh - 140px) / 3)}}@media only screen and (min-width:737px) and (max-width:812px) and (max-height:375px) and (orientation:landscape){.menu-grid .grid-item:first-child:nth-last-child(2){min-height:calc((100vh - 140px) / 3)}}@media only screen and (min-width:768px) and (max-width:1024px) and (orientation:landscape){.menu-grid .grid-item:first-child:nth-last-child(2){min-height:174.66667px}}@media only screen and (min-width:768px) and (max-width:1024px) and (orientation:portrait){.menu-grid .grid-item:first-child:nth-last-child(2){min-height:261.33333px}}.menu-grid .grid-item:first-child:nth-last-child(2)~li{width:50%;min-height:570.66667px;max-height:676.66667px;min-height:617.33333px;max-height:723.33333px}@media only screen and (max-width:375px) and (max-height:736px) and (orientation:portrait){.menu-grid .grid-item:first-child:nth-last-child(2)~li{height:100%;min-height:calc((100vh - 140px) / 1.5)}}@media only screen and (max-height:375px) and (max-width:736px) and (orientation:landscape){.menu-grid .grid-item:first-child:nth-last-child(2)~li{min-height:calc((100vh - 140px) / 1.5)}}@media only screen and (min-width:376px) and (max-width:414px) and (max-height:736px) and (orientation:portrait){.menu-grid .grid-item:first-child:nth-last-child(2)~li{height:100%;min-height:calc((100vh - 140px) / 1.5)}}@media only screen and (min-height:376px) and (max-height:414px) and (max-width:736px) and (orientation:landscape){.menu-grid .grid-item:first-child:nth-last-child(2)~li{min-height:calc((100vh - 140px) / 1.5)}}@media only screen and (max-width:375px) and (min-height:737px) and (max-height:812px) and (orientation:portrait){.menu-grid .grid-item:first-child:nth-last-child(2)~li{height:100%;min-height:calc((100vh - 140px) / 1.5)}}@media only screen and (min-width:737px) and (max-width:812px) and (max-height:375px) and (orientation:landscape){.menu-grid .grid-item:first-child:nth-last-child(2)~li{min-height:calc((100vh - 140px) / 1.5)}}@media only screen and (min-width:768px) and (max-width:1024px) and (orientation:landscape){.menu-grid .grid-item:first-child:nth-last-child(2)~li{min-height:349.33333px}}@media only screen and (min-width:768px) and (max-width:1024px) and (orientation:portrait){.menu-grid .grid-item:first-child:nth-last-child(2)~li{min-height:522.66667px}}@media only screen and (max-width:375px) and (max-height:736px) and (orientation:portrait){.menu-grid .grid-item:first-child:nth-last-child(2)~li{height:100%;min-height:calc((100vh - 140px) / 3)}}@media only screen and (max-height:375px) and (max-width:736px) and (orientation:landscape){.menu-grid .grid-item:first-child:nth-last-child(2)~li{min-height:calc((100vh - 140px) / 3)}}@media only screen and (min-width:376px) and (max-width:414px) and (max-height:736px) and (orientation:portrait){.menu-grid .grid-item:first-child:nth-last-child(2)~li{height:100%;min-height:calc((100vh - 140px) / 3)}}@media only screen and (min-height:376px) and (max-height:414px) and (max-width:736px) and (orientation:landscape){.menu-grid .grid-item:first-child:nth-last-child(2)~li{min-height:calc((100vh - 140px) / 3)}}@media only screen and (max-width:375px) and (min-height:737px) and (max-height:812px) and (orientation:portrait){.menu-grid .grid-item:first-child:nth-last-child(2)~li{height:100%;min-height:calc((100vh - 140px) / 3)}}@media only screen and (min-width:737px) and (max-width:812px) and (max-height:375px) and (orientation:landscape){.menu-grid .grid-item:first-child:nth-last-child(2)~li{min-height:calc((100vh - 140px) / 3)}}@media only screen and (min-width:768px) and (max-width:1024px) and (orientation:landscape){.menu-grid .grid-item:first-child:nth-last-child(2)~li{min-height:174.66667px}}@media only screen and (min-width:768px) and (max-width:1024px) and (orientation:portrait){.menu-grid .grid-item:first-child:nth-last-child(2)~li{min-height:261.33333px}}.menu-grid .grid-item:first-child:nth-last-child(3){width:33.3333%;min-height:594px;max-height:700px}@media only screen and (max-width:375px) and (max-height:736px) and (orientation:portrait){.menu-grid .grid-item:first-child:nth-last-child(3){height:100%;min-height:calc((100vh - 140px) / 2)}}@media only screen and (max-height:375px) and (max-width:736px) and (orientation:landscape){.menu-grid .grid-item:first-child:nth-last-child(3){min-height:calc((100vh - 140px) / 2)}}@media only screen and (min-width:376px) and (max-width:414px) and (max-height:736px) and (orientation:portrait){.menu-grid .grid-item:first-child:nth-last-child(3){height:100%;min-height:calc((100vh - 140px) / 2)}}@media only screen and (min-height:376px) and (max-height:414px) and (max-width:736px) and (orientation:landscape){.menu-grid .grid-item:first-child:nth-last-child(3){min-height:calc((100vh - 140px) / 2)}}@media only screen and (max-width:375px) and (min-height:737px) and (max-height:812px) and (orientation:portrait){.menu-grid .grid-item:first-child:nth-last-child(3){height:100%;min-height:calc((100vh - 140px) / 2)}}@media only screen and (min-width:737px) and (max-width:812px) and (max-height:375px) and (orientation:landscape){.menu-grid .grid-item:first-child:nth-last-child(3){min-height:calc((100vh - 140px) / 2)}}@media only screen and (min-width:768px) and (max-width:1024px) and (orientation:landscape){.menu-grid .grid-item:first-child:nth-last-child(3){min-height:262px}}@media only screen and (min-width:768px) and (max-width:1024px) and (orientation:portrait){.menu-grid .grid-item:first-child:nth-last-child(3){min-height:392px}}.menu-grid .grid-item:first-child:nth-last-child(3)~li{width:33.3333%;min-height:594px;max-height:700px}@media only screen and (max-width:375px) and (max-height:736px) and (orientation:portrait){.menu-grid .grid-item:first-child:nth-last-child(3)~li{height:100%;min-height:calc((100vh - 140px) / 2)}}@media only screen and (max-height:375px) and (max-width:736px) and (orientation:landscape){.menu-grid .grid-item:first-child:nth-last-child(3)~li{min-height:calc((100vh - 140px) / 2)}}@media only screen and (min-width:376px) and (max-width:414px) and (max-height:736px) and (orientation:portrait){.menu-grid .grid-item:first-child:nth-last-child(3)~li{height:100%;min-height:calc((100vh - 140px) / 2)}}@media only screen and (min-height:376px) and (max-height:414px) and (max-width:736px) and (orientation:landscape){.menu-grid .grid-item:first-child:nth-last-child(3)~li{min-height:calc((100vh - 140px) / 2)}}@media only screen and (max-width:375px) and (min-height:737px) and (max-height:812px) and (orientation:portrait){.menu-grid .grid-item:first-child:nth-last-child(3)~li{height:100%;min-height:calc((100vh - 140px) / 2)}}@media only screen and (min-width:737px) and (max-width:812px) and (max-height:375px) and (orientation:landscape){.menu-grid .grid-item:first-child:nth-last-child(3)~li{min-height:calc((100vh - 140px) / 2)}}@media only screen and (min-width:768px) and (max-width:1024px) and (orientation:landscape){.menu-grid .grid-item:first-child:nth-last-child(3)~li{min-height:262px}}@media only screen and (min-width:768px) and (max-width:1024px) and (orientation:portrait){.menu-grid .grid-item:first-child:nth-last-child(3)~li{min-height:392px}}.menu-grid .grid-item:first-child:nth-last-child(4){width:50%;min-height:594px;max-height:700px}@media only screen and (max-width:375px) and (max-height:736px) and (orientation:portrait){.menu-grid .grid-item:first-child:nth-last-child(4){height:100%;min-height:calc((100vh - 140px) / 2)}}@media only screen and (max-height:375px) and (max-width:736px) and (orientation:landscape){.menu-grid .grid-item:first-child:nth-last-child(4){min-height:calc((100vh - 140px) / 2)}}@media only screen and (min-width:376px) and (max-width:414px) and (max-height:736px) and (orientation:portrait){.menu-grid .grid-item:first-child:nth-last-child(4){height:100%;min-height:calc((100vh - 140px) / 2)}}@media only screen and (min-height:376px) and (max-height:414px) and (max-width:736px) and (orientation:landscape){.menu-grid .grid-item:first-child:nth-last-child(4){min-height:calc((100vh - 140px) / 2)}}@media only screen and (max-width:375px) and (min-height:737px) and (max-height:812px) and (orientation:portrait){.menu-grid .grid-item:first-child:nth-last-child(4){height:100%;min-height:calc((100vh - 140px) / 2)}}@media only screen and (min-width:737px) and (max-width:812px) and (max-height:375px) and (orientation:landscape){.menu-grid .grid-item:first-child:nth-last-child(4){min-height:calc((100vh - 140px) / 2)}}@media only screen and (min-width:768px) and (max-width:1024px) and (orientation:landscape){.menu-grid .grid-item:first-child:nth-last-child(4){min-height:262px}}@media only screen and (min-width:768px) and (max-width:1024px) and (orientation:portrait){.menu-grid .grid-item:first-child:nth-last-child(4){min-height:392px}}.menu-grid .grid-item:first-child:nth-last-child(4)~li{width:50%;min-height:594px;max-height:700px}@media only screen and (max-width:375px) and (max-height:736px) and (orientation:portrait){.menu-grid .grid-item:first-child:nth-last-child(4)~li{height:100%;min-height:calc((100vh - 140px) / 2)}}@media only screen and (max-height:375px) and (max-width:736px) and (orientation:landscape){.menu-grid .grid-item:first-child:nth-last-child(4)~li{min-height:calc((100vh - 140px) / 2)}}@media only screen and (min-width:376px) and (max-width:414px) and (max-height:736px) and (orientation:portrait){.menu-grid .grid-item:first-child:nth-last-child(4)~li{height:100%;min-height:calc((100vh - 140px) / 2)}}@media only screen and (min-height:376px) and (max-height:414px) and (max-width:736px) and (orientation:landscape){.menu-grid .grid-item:first-child:nth-last-child(4)~li{min-height:calc((100vh - 140px) / 2)}}@media only screen and (max-width:375px) and (min-height:737px) and (max-height:812px) and (orientation:portrait){.menu-grid .grid-item:first-child:nth-last-child(4)~li{height:100%;min-height:calc((100vh - 140px) / 2)}}@media only screen and (min-width:737px) and (max-width:812px) and (max-height:375px) and (orientation:landscape){.menu-grid .grid-item:first-child:nth-last-child(4)~li{min-height:calc((100vh - 140px) / 2)}}@media only screen and (min-width:768px) and (max-width:1024px) and (orientation:landscape){.menu-grid .grid-item:first-child:nth-last-child(4)~li{min-height:262px}}@media only screen and (min-width:768px) and (max-width:1024px) and (orientation:portrait){.menu-grid .grid-item:first-child:nth-last-child(4)~li{min-height:392px}}.menu-grid .grid-item:first-child:nth-last-child(5){width:33.3333%;min-height:594px;max-height:700px}@media only screen and (max-width:375px) and (max-height:736px) and (orientation:portrait){.menu-grid .grid-item:first-child:nth-last-child(5){height:100%;min-height:calc((100vh - 140px) / 2)}}@media only screen and (max-height:375px) and (max-width:736px) and (orientation:landscape){.menu-grid .grid-item:first-child:nth-last-child(5){min-height:calc((100vh - 140px) / 2)}}@media only screen and (min-width:376px) and (max-width:414px) and (max-height:736px) and (orientation:portrait){.menu-grid .grid-item:first-child:nth-last-child(5){height:100%;min-height:calc((100vh - 140px) / 2)}}@media only screen and (min-height:376px) and (max-height:414px) and (max-width:736px) and (orientation:landscape){.menu-grid .grid-item:first-child:nth-last-child(5){min-height:calc((100vh - 140px) / 2)}}@media only screen and (max-width:375px) and (min-height:737px) and (max-height:812px) and (orientation:portrait){.menu-grid .grid-item:first-child:nth-last-child(5){height:100%;min-height:calc((100vh - 140px) / 2)}}@media only screen and (min-width:737px) and (max-width:812px) and (max-height:375px) and (orientation:landscape){.menu-grid .grid-item:first-child:nth-last-child(5){min-height:calc((100vh - 140px) / 2)}}@media only screen and (min-width:768px) and (max-width:1024px) and (orientation:landscape){.menu-grid .grid-item:first-child:nth-last-child(5){min-height:262px}}@media only screen and (min-width:768px) and (max-width:1024px) and (orientation:portrait){.menu-grid .grid-item:first-child:nth-last-child(5){min-height:392px}}.menu-grid .grid-item:first-child:nth-last-child(5)~li{width:33.3333%;clear:right;min-height:594px;max-height:700px}@media only screen and (max-width:375px) and (max-height:736px) and (orientation:portrait){.menu-grid .grid-item:first-child:nth-last-child(5)~li{height:100%;min-height:calc((100vh - 140px) / 2)}}@media only screen and (max-height:375px) and (max-width:736px) and (orientation:landscape){.menu-grid .grid-item:first-child:nth-last-child(5)~li{min-height:calc((100vh - 140px) / 2)}}@media only screen and (min-width:376px) and (max-width:414px) and (max-height:736px) and (orientation:portrait){.menu-grid .grid-item:first-child:nth-last-child(5)~li{height:100%;min-height:calc((100vh - 140px) / 2)}}@media only screen and (min-height:376px) and (max-height:414px) and (max-width:736px) and (orientation:landscape){.menu-grid .grid-item:first-child:nth-last-child(5)~li{min-height:calc((100vh - 140px) / 2)}}@media only screen and (max-width:375px) and (min-height:737px) and (max-height:812px) and (orientation:portrait){.menu-grid .grid-item:first-child:nth-last-child(5)~li{height:100%;min-height:calc((100vh - 140px) / 2)}}@media only screen and (min-width:737px) and (max-width:812px) and (max-height:375px) and (orientation:landscape){.menu-grid .grid-item:first-child:nth-last-child(5)~li{min-height:calc((100vh - 140px) / 2)}}@media only screen and (min-width:768px) and (max-width:1024px) and (orientation:landscape){.menu-grid .grid-item:first-child:nth-last-child(5)~li{min-height:262px}}@media only screen and (min-width:768px) and (max-width:1024px) and (orientation:portrait){.menu-grid .grid-item:first-child:nth-last-child(5)~li{min-height:392px}}.menu-grid .grid-item:first-child:nth-last-child(5)~li:nth-child(4){clear:right;margin-left:16.66665%}.menu-grid .grid-item:first-child:nth-last-child(6){width:33.3333%;min-height:594px;max-height:700px}@media only screen and (max-width:375px) and (max-height:736px) and (orientation:portrait){.menu-grid .grid-item:first-child:nth-last-child(6){height:100%;min-height:calc((100vh - 140px) / 2)}}@media only screen and (max-height:375px) and (max-width:736px) and (orientation:landscape){.menu-grid .grid-item:first-child:nth-last-child(6){min-height:calc((100vh - 140px) / 2)}}@media only screen and (min-width:376px) and (max-width:414px) and (max-height:736px) and (orientation:portrait){.menu-grid .grid-item:first-child:nth-last-child(6){height:100%;min-height:calc((100vh - 140px) / 2)}}@media only screen and (min-height:376px) and (max-height:414px) and (max-width:736px) and (orientation:landscape){.menu-grid .grid-item:first-child:nth-last-child(6){min-height:calc((100vh - 140px) / 2)}}@media only screen and (max-width:375px) and (min-height:737px) and (max-height:812px) and (orientation:portrait){.menu-grid .grid-item:first-child:nth-last-child(6){height:100%;min-height:calc((100vh - 140px) / 2)}}@media only screen and (min-width:737px) and (max-width:812px) and (max-height:375px) and (orientation:landscape){.menu-grid .grid-item:first-child:nth-last-child(6){min-height:calc((100vh - 140px) / 2)}}@media only screen and (min-width:768px) and (max-width:1024px) and (orientation:landscape){.menu-grid .grid-item:first-child:nth-last-child(6){min-height:262px}}@media only screen and (min-width:768px) and (max-width:1024px) and (orientation:portrait){.menu-grid .grid-item:first-child:nth-last-child(6){min-height:392px}}.menu-grid .grid-item:first-child:nth-last-child(6)~li{width:33.3333%;min-height:594px;max-height:700px}@media only screen and (max-width:375px) and (max-height:736px) and (orientation:portrait){.menu-grid .grid-item:first-child:nth-last-child(6)~li{height:100%;min-height:calc((100vh - 140px) / 2)}}@media only screen and (max-height:375px) and (max-width:736px) and (orientation:landscape){.menu-grid .grid-item:first-child:nth-last-child(6)~li{min-height:calc((100vh - 140px) / 2)}}@media only screen and (min-width:376px) and (max-width:414px) and (max-height:736px) and (orientation:portrait){.menu-grid .grid-item:first-child:nth-last-child(6)~li{height:100%;min-height:calc((100vh - 140px) / 2)}}@media only screen and (min-height:376px) and (max-height:414px) and (max-width:736px) and (orientation:landscape){.menu-grid .grid-item:first-child:nth-last-child(6)~li{min-height:calc((100vh - 140px) / 2)}}@media only screen and (max-width:375px) and (min-height:737px) and (max-height:812px) and (orientation:portrait){.menu-grid .grid-item:first-child:nth-last-child(6)~li{height:100%;min-height:calc((100vh - 140px) / 2)}}@media only screen and (min-width:737px) and (max-width:812px) and (max-height:375px) and (orientation:landscape){.menu-grid .grid-item:first-child:nth-last-child(6)~li{min-height:calc((100vh - 140px) / 2)}}@media only screen and (min-width:768px) and (max-width:1024px) and (orientation:landscape){.menu-grid .grid-item:first-child:nth-last-child(6)~li{min-height:262px}}@media only screen and (min-width:768px) and (max-width:1024px) and (orientation:portrait){.menu-grid .grid-item:first-child:nth-last-child(6)~li{min-height:392px}}.menu-grid .grid-item:first-child:nth-last-child(7){width:25%}.menu-grid .grid-item:first-child:nth-last-child(7)~li{width:25%;min-height:617.33333px;max-height:723.33333px}@media only screen and (max-width:375px) and (max-height:736px) and (orientation:portrait){.menu-grid .grid-item:first-child:nth-last-child(7)~li{height:100%;min-height:calc((100vh - 140px) / 3)}}@media only screen and (max-height:375px) and (max-width:736px) and (orientation:landscape){.menu-grid .grid-item:first-child:nth-last-child(7)~li{min-height:calc((100vh - 140px) / 3)}}@media only screen and (min-width:376px) and (max-width:414px) and (max-height:736px) and (orientation:portrait){.menu-grid .grid-item:first-child:nth-last-child(7)~li{height:100%;min-height:calc((100vh - 140px) / 3)}}@media only screen and (min-height:376px) and (max-height:414px) and (max-width:736px) and (orientation:landscape){.menu-grid .grid-item:first-child:nth-last-child(7)~li{min-height:calc((100vh - 140px) / 3)}}@media only screen and (max-width:375px) and (min-height:737px) and (max-height:812px) and (orientation:portrait){.menu-grid .grid-item:first-child:nth-last-child(7)~li{height:100%;min-height:calc((100vh - 140px) / 3)}}@media only screen and (min-width:737px) and (max-width:812px) and (max-height:375px) and (orientation:landscape){.menu-grid .grid-item:first-child:nth-last-child(7)~li{min-height:calc((100vh - 140px) / 3)}}@media only screen and (min-width:768px) and (max-width:1024px) and (orientation:landscape){.menu-grid .grid-item:first-child:nth-last-child(7)~li{min-height:174.66667px}}@media only screen and (min-width:768px) and (max-width:1024px) and (orientation:portrait){.menu-grid .grid-item:first-child:nth-last-child(7)~li{min-height:261.33333px}}.menu-grid .grid-item:first-child:nth-last-child(7)~li:nth-child(5){clear:right;margin-left:12.5%}.menu-grid .grid-item:first-child:nth-last-child(7){min-height:617.33333px;max-height:723.33333px}@media only screen and (max-width:375px) and (max-height:736px) and (orientation:portrait){.menu-grid .grid-item:first-child:nth-last-child(7){height:100%;min-height:calc((100vh - 140px) / 3)}}@media only screen and (max-height:375px) and (max-width:736px) and (orientation:landscape){.menu-grid .grid-item:first-child:nth-last-child(7){min-height:calc((100vh - 140px) / 3)}}@media only screen and (min-width:376px) and (max-width:414px) and (max-height:736px) and (orientation:portrait){.menu-grid .grid-item:first-child:nth-last-child(7){height:100%;min-height:calc((100vh - 140px) / 3)}}@media only screen and (min-height:376px) and (max-height:414px) and (max-width:736px) and (orientation:landscape){.menu-grid .grid-item:first-child:nth-last-child(7){min-height:calc((100vh - 140px) / 3)}}@media only screen and (max-width:375px) and (min-height:737px) and (max-height:812px) and (orientation:portrait){.menu-grid .grid-item:first-child:nth-last-child(7){height:100%;min-height:calc((100vh - 140px) / 3)}}@media only screen and (min-width:737px) and (max-width:812px) and (max-height:375px) and (orientation:landscape){.menu-grid .grid-item:first-child:nth-last-child(7){min-height:calc((100vh - 140px) / 3)}}@media only screen and (min-width:768px) and (max-width:1024px) and (orientation:landscape){.menu-grid .grid-item:first-child:nth-last-child(7){min-height:174.66667px}}@media only screen and (min-width:768px) and (max-width:1024px) and (orientation:portrait){.menu-grid .grid-item:first-child:nth-last-child(7){min-height:261.33333px}}.menu-grid .grid-item:first-child:nth-last-child(7)~li:nth-child(2){min-height:617.33333px;max-height:723.33333px}@media only screen and (max-width:375px) and (max-height:736px) and (orientation:portrait){.menu-grid .grid-item:first-child:nth-last-child(7)~li:nth-child(2){height:100%;min-height:calc((100vh - 140px) / 3)}}@media only screen and (max-height:375px) and (max-width:736px) and (orientation:landscape){.menu-grid .grid-item:first-child:nth-last-child(7)~li:nth-child(2){min-height:calc((100vh - 140px) / 3)}}@media only screen and (min-width:376px) and (max-width:414px) and (max-height:736px) and (orientation:portrait){.menu-grid .grid-item:first-child:nth-last-child(7)~li:nth-child(2){height:100%;min-height:calc((100vh - 140px) / 3)}}@media only screen and (min-height:376px) and (max-height:414px) and (max-width:736px) and (orientation:landscape){.menu-grid .grid-item:first-child:nth-last-child(7)~li:nth-child(2){min-height:calc((100vh - 140px) / 3)}}@media only screen and (max-width:375px) and (min-height:737px) and (max-height:812px) and (orientation:portrait){.menu-grid .grid-item:first-child:nth-last-child(7)~li:nth-child(2){height:100%;min-height:calc((100vh - 140px) / 3)}}@media only screen and (min-width:737px) and (max-width:812px) and (max-height:375px) and (orientation:landscape){.menu-grid .grid-item:first-child:nth-last-child(7)~li:nth-child(2){min-height:calc((100vh - 140px) / 3)}}@media only screen and (min-width:768px) and (max-width:1024px) and (orientation:landscape){.menu-grid .grid-item:first-child:nth-last-child(7)~li:nth-child(2){min-height:174.66667px}}@media only screen and (min-width:768px) and (max-width:1024px) and (orientation:portrait){.menu-grid .grid-item:first-child:nth-last-child(7)~li:nth-child(2){min-height:261.33333px}}.menu-grid .grid-item:first-child:nth-last-child(7)~li:nth-child(3){min-height:617.33333px;max-height:723.33333px}@media only screen and (max-width:375px) and (max-height:736px) and (orientation:portrait){.menu-grid .grid-item:first-child:nth-last-child(7)~li:nth-child(3){height:100%;min-height:calc((100vh - 140px) / 3)}}@media only screen and (max-height:375px) and (max-width:736px) and (orientation:landscape){.menu-grid .grid-item:first-child:nth-last-child(7)~li:nth-child(3){min-height:calc((100vh - 140px) / 3)}}@media only screen and (min-width:376px) and (max-width:414px) and (max-height:736px) and (orientation:portrait){.menu-grid .grid-item:first-child:nth-last-child(7)~li:nth-child(3){height:100%;min-height:calc((100vh - 140px) / 3)}}@media only screen and (min-height:376px) and (max-height:414px) and (max-width:736px) and (orientation:landscape){.menu-grid .grid-item:first-child:nth-last-child(7)~li:nth-child(3){min-height:calc((100vh - 140px) / 3)}}@media only screen and (max-width:375px) and (min-height:737px) and (max-height:812px) and (orientation:portrait){.menu-grid .grid-item:first-child:nth-last-child(7)~li:nth-child(3){height:100%;min-height:calc((100vh - 140px) / 3)}}@media only screen and (min-width:737px) and (max-width:812px) and (max-height:375px) and (orientation:landscape){.menu-grid .grid-item:first-child:nth-last-child(7)~li:nth-child(3){min-height:calc((100vh - 140px) / 3)}}@media only screen and (min-width:768px) and (max-width:1024px) and (orientation:landscape){.menu-grid .grid-item:first-child:nth-last-child(7)~li:nth-child(3){min-height:174.66667px}}@media only screen and (min-width:768px) and (max-width:1024px) and (orientation:portrait){.menu-grid .grid-item:first-child:nth-last-child(7)~li:nth-child(3){min-height:261.33333px}}.menu-grid .grid-item:first-child:nth-last-child(7)~li:nth-child(4){min-height:617.33333px;max-height:723.33333px}@media only screen and (max-width:375px) and (max-height:736px) and (orientation:portrait){.menu-grid .grid-item:first-child:nth-last-child(7)~li:nth-child(4){height:100%;min-height:calc((100vh - 140px) / 3)}}@media only screen and (max-height:375px) and (max-width:736px) and (orientation:landscape){.menu-grid .grid-item:first-child:nth-last-child(7)~li:nth-child(4){min-height:calc((100vh - 140px) / 3)}}@media only screen and (min-width:376px) and (max-width:414px) and (max-height:736px) and (orientation:portrait){.menu-grid .grid-item:first-child:nth-last-child(7)~li:nth-child(4){height:100%;min-height:calc((100vh - 140px) / 3)}}@media only screen and (min-height:376px) and (max-height:414px) and (max-width:736px) and (orientation:landscape){.menu-grid .grid-item:first-child:nth-last-child(7)~li:nth-child(4){min-height:calc((100vh - 140px) / 3)}}@media only screen and (max-width:375px) and (min-height:737px) and (max-height:812px) and (orientation:portrait){.menu-grid .grid-item:first-child:nth-last-child(7)~li:nth-child(4){height:100%;min-height:calc((100vh - 140px) / 3)}}@media only screen and (min-width:737px) and (max-width:812px) and (max-height:375px) and (orientation:landscape){.menu-grid .grid-item:first-child:nth-last-child(7)~li:nth-child(4){min-height:calc((100vh - 140px) / 3)}}@media only screen and (min-width:768px) and (max-width:1024px) and (orientation:landscape){.menu-grid .grid-item:first-child:nth-last-child(7)~li:nth-child(4){min-height:174.66667px}}@media only screen and (min-width:768px) and (max-width:1024px) and (orientation:portrait){.menu-grid .grid-item:first-child:nth-last-child(7)~li:nth-child(4){min-height:261.33333px}}.menu-grid .grid-item:first-child:nth-last-child(8){width:25%}.menu-grid .grid-item:first-child:nth-last-child(8)~li{width:25%;min-height:617.33333px;max-height:723.33333px}@media only screen and (max-width:375px) and (max-height:736px) and (orientation:portrait){.menu-grid .grid-item:first-child:nth-last-child(8)~li{height:100%;min-height:calc((100vh - 140px) / 3)}}@media only screen and (max-height:375px) and (max-width:736px) and (orientation:landscape){.menu-grid .grid-item:first-child:nth-last-child(8)~li{min-height:calc((100vh - 140px) / 3)}}@media only screen and (min-width:376px) and (max-width:414px) and (max-height:736px) and (orientation:portrait){.menu-grid .grid-item:first-child:nth-last-child(8)~li{height:100%;min-height:calc((100vh - 140px) / 3)}}@media only screen and (min-height:376px) and (max-height:414px) and (max-width:736px) and (orientation:landscape){.menu-grid .grid-item:first-child:nth-last-child(8)~li{min-height:calc((100vh - 140px) / 3)}}@media only screen and (max-width:375px) and (min-height:737px) and (max-height:812px) and (orientation:portrait){.menu-grid .grid-item:first-child:nth-last-child(8)~li{height:100%;min-height:calc((100vh - 140px) / 3)}}@media only screen and (min-width:737px) and (max-width:812px) and (max-height:375px) and (orientation:landscape){.menu-grid .grid-item:first-child:nth-last-child(8)~li{min-height:calc((100vh - 140px) / 3)}}@media only screen and (min-width:768px) and (max-width:1024px) and (orientation:landscape){.menu-grid .grid-item:first-child:nth-last-child(8)~li{min-height:174.66667px}}@media only screen and (min-width:768px) and (max-width:1024px) and (orientation:portrait){.menu-grid .grid-item:first-child:nth-last-child(8)~li{min-height:261.33333px}}.menu-grid .grid-item:first-child:nth-last-child(8){min-height:617.33333px;max-height:723.33333px}@media only screen and (max-width:375px) and (max-height:736px) and (orientation:portrait){.menu-grid .grid-item:first-child:nth-last-child(8){height:100%;min-height:calc((100vh - 140px) / 3)}}@media only screen and (max-height:375px) and (max-width:736px) and (orientation:landscape){.menu-grid .grid-item:first-child:nth-last-child(8){min-height:calc((100vh - 140px) / 3)}}@media only screen and (min-width:376px) and (max-width:414px) and (max-height:736px) and (orientation:portrait){.menu-grid .grid-item:first-child:nth-last-child(8){height:100%;min-height:calc((100vh - 140px) / 3)}}@media only screen and (min-height:376px) and (max-height:414px) and (max-width:736px) and (orientation:landscape){.menu-grid .grid-item:first-child:nth-last-child(8){min-height:calc((100vh - 140px) / 3)}}@media only screen and (max-width:375px) and (min-height:737px) and (max-height:812px) and (orientation:portrait){.menu-grid .grid-item:first-child:nth-last-child(8){height:100%;min-height:calc((100vh - 140px) / 3)}}@media only screen and (min-width:737px) and (max-width:812px) and (max-height:375px) and (orientation:landscape){.menu-grid .grid-item:first-child:nth-last-child(8){min-height:calc((100vh - 140px) / 3)}}@media only screen and (min-width:768px) and (max-width:1024px) and (orientation:landscape){.menu-grid .grid-item:first-child:nth-last-child(8){min-height:174.66667px}}@media only screen and (min-width:768px) and (max-width:1024px) and (orientation:portrait){.menu-grid .grid-item:first-child:nth-last-child(8){min-height:261.33333px}}.menu-grid .grid-item:first-child:nth-last-child(8)~li:nth-child(2){min-height:617.33333px;max-height:723.33333px}@media only screen and (max-width:375px) and (max-height:736px) and (orientation:portrait){.menu-grid .grid-item:first-child:nth-last-child(8)~li:nth-child(2){height:100%;min-height:calc((100vh - 140px) / 3)}}@media only screen and (max-height:375px) and (max-width:736px) and (orientation:landscape){.menu-grid .grid-item:first-child:nth-last-child(8)~li:nth-child(2){min-height:calc((100vh - 140px) / 3)}}@media only screen and (min-width:376px) and (max-width:414px) and (max-height:736px) and (orientation:portrait){.menu-grid .grid-item:first-child:nth-last-child(8)~li:nth-child(2){height:100%;min-height:calc((100vh - 140px) / 3)}}@media only screen and (min-height:376px) and (max-height:414px) and (max-width:736px) and (orientation:landscape){.menu-grid .grid-item:first-child:nth-last-child(8)~li:nth-child(2){min-height:calc((100vh - 140px) / 3)}}@media only screen and (max-width:375px) and (min-height:737px) and (max-height:812px) and (orientation:portrait){.menu-grid .grid-item:first-child:nth-last-child(8)~li:nth-child(2){height:100%;min-height:calc((100vh - 140px) / 3)}}@media only screen and (min-width:737px) and (max-width:812px) and (max-height:375px) and (orientation:landscape){.menu-grid .grid-item:first-child:nth-last-child(8)~li:nth-child(2){min-height:calc((100vh - 140px) / 3)}}@media only screen and (min-width:768px) and (max-width:1024px) and (orientation:landscape){.menu-grid .grid-item:first-child:nth-last-child(8)~li:nth-child(2){min-height:174.66667px}}@media only screen and (min-width:768px) and (max-width:1024px) and (orientation:portrait){.menu-grid .grid-item:first-child:nth-last-child(8)~li:nth-child(2){min-height:261.33333px}}.menu-grid .grid-item:first-child:nth-last-child(8)~li:nth-child(3){min-height:617.33333px;max-height:723.33333px}@media only screen and (max-width:375px) and (max-height:736px) and (orientation:portrait){.menu-grid .grid-item:first-child:nth-last-child(8)~li:nth-child(3){height:100%;min-height:calc((100vh - 140px) / 3)}}@media only screen and (max-height:375px) and (max-width:736px) and (orientation:landscape){.menu-grid .grid-item:first-child:nth-last-child(8)~li:nth-child(3){min-height:calc((100vh - 140px) / 3)}}@media only screen and (min-width:376px) and (max-width:414px) and (max-height:736px) and (orientation:portrait){.menu-grid .grid-item:first-child:nth-last-child(8)~li:nth-child(3){height:100%;min-height:calc((100vh - 140px) / 3)}}@media only screen and (min-height:376px) and (max-height:414px) and (max-width:736px) and (orientation:landscape){.menu-grid .grid-item:first-child:nth-last-child(8)~li:nth-child(3){min-height:calc((100vh - 140px) / 3)}}@media only screen and (max-width:375px) and (min-height:737px) and (max-height:812px) and (orientation:portrait){.menu-grid .grid-item:first-child:nth-last-child(8)~li:nth-child(3){height:100%;min-height:calc((100vh - 140px) / 3)}}@media only screen and (min-width:737px) and (max-width:812px) and (max-height:375px) and (orientation:landscape){.menu-grid .grid-item:first-child:nth-last-child(8)~li:nth-child(3){min-height:calc((100vh - 140px) / 3)}}@media only screen and (min-width:768px) and (max-width:1024px) and (orientation:landscape){.menu-grid .grid-item:first-child:nth-last-child(8)~li:nth-child(3){min-height:174.66667px}}@media only screen and (min-width:768px) and (max-width:1024px) and (orientation:portrait){.menu-grid .grid-item:first-child:nth-last-child(8)~li:nth-child(3){min-height:261.33333px}}.menu-grid .grid-item:first-child:nth-last-child(8)~li:nth-child(4){min-height:617.33333px;max-height:723.33333px}@media only screen and (max-width:375px) and (max-height:736px) and (orientation:portrait){.menu-grid .grid-item:first-child:nth-last-child(8)~li:nth-child(4){height:100%;min-height:calc((100vh - 140px) / 3)}}@media only screen and (max-height:375px) and (max-width:736px) and (orientation:landscape){.menu-grid .grid-item:first-child:nth-last-child(8)~li:nth-child(4){min-height:calc((100vh - 140px) / 3)}}@media only screen and (min-width:376px) and (max-width:414px) and (max-height:736px) and (orientation:portrait){.menu-grid .grid-item:first-child:nth-last-child(8)~li:nth-child(4){height:100%;min-height:calc((100vh - 140px) / 3)}}@media only screen and (min-height:376px) and (max-height:414px) and (max-width:736px) and (orientation:landscape){.menu-grid .grid-item:first-child:nth-last-child(8)~li:nth-child(4){min-height:calc((100vh - 140px) / 3)}}@media only screen and (max-width:375px) and (min-height:737px) and (max-height:812px) and (orientation:portrait){.menu-grid .grid-item:first-child:nth-last-child(8)~li:nth-child(4){height:100%;min-height:calc((100vh - 140px) / 3)}}@media only screen and (min-width:737px) and (max-width:812px) and (max-height:375px) and (orientation:landscape){.menu-grid .grid-item:first-child:nth-last-child(8)~li:nth-child(4){min-height:calc((100vh - 140px) / 3)}}@media only screen and (min-width:768px) and (max-width:1024px) and (orientation:landscape){.menu-grid .grid-item:first-child:nth-last-child(8)~li:nth-child(4){min-height:174.66667px}}@media only screen and (min-width:768px) and (max-width:1024px) and (orientation:portrait){.menu-grid .grid-item:first-child:nth-last-child(8)~li:nth-child(4){min-height:261.33333px}}.menu-grid .grid-item:first-child:nth-last-child(9){width:33.3333%;min-height:617.33333px;max-height:723.33333px}@media only screen and (max-width:375px) and (max-height:736px) and (orientation:portrait){.menu-grid .grid-item:first-child:nth-last-child(9){height:100%;min-height:calc((100vh - 140px) / 3)}}@media only screen and (max-height:375px) and (max-width:736px) and (orientation:landscape){.menu-grid .grid-item:first-child:nth-last-child(9){min-height:calc((100vh - 140px) / 3)}}@media only screen and (min-width:376px) and (max-width:414px) and (max-height:736px) and (orientation:portrait){.menu-grid .grid-item:first-child:nth-last-child(9){height:100%;min-height:calc((100vh - 140px) / 3)}}@media only screen and (min-height:376px) and (max-height:414px) and (max-width:736px) and (orientation:landscape){.menu-grid .grid-item:first-child:nth-last-child(9){min-height:calc((100vh - 140px) / 3)}}@media only screen and (max-width:375px) and (min-height:737px) and (max-height:812px) and (orientation:portrait){.menu-grid .grid-item:first-child:nth-last-child(9){height:100%;min-height:calc((100vh - 140px) / 3)}}@media only screen and (min-width:737px) and (max-width:812px) and (max-height:375px) and (orientation:landscape){.menu-grid .grid-item:first-child:nth-last-child(9){min-height:calc((100vh - 140px) / 3)}}@media only screen and (min-width:768px) and (max-width:1024px) and (orientation:landscape){.menu-grid .grid-item:first-child:nth-last-child(9){min-height:174.66667px}}@media only screen and (min-width:768px) and (max-width:1024px) and (orientation:portrait){.menu-grid .grid-item:first-child:nth-last-child(9){min-height:261.33333px}}.menu-grid .grid-item:first-child:nth-last-child(9)~li{width:33.3333%;min-height:617.33333px;max-height:723.33333px}@media only screen and (max-width:375px) and (max-height:736px) and (orientation:portrait){.menu-grid .grid-item:first-child:nth-last-child(9)~li{height:100%;min-height:calc((100vh - 140px) / 3)}}@media only screen and (max-height:375px) and (max-width:736px) and (orientation:landscape){.menu-grid .grid-item:first-child:nth-last-child(9)~li{min-height:calc((100vh - 140px) / 3)}}@media only screen and (min-width:376px) and (max-width:414px) and (max-height:736px) and (orientation:portrait){.menu-grid .grid-item:first-child:nth-last-child(9)~li{height:100%;min-height:calc((100vh - 140px) / 3)}}@media only screen and (min-height:376px) and (max-height:414px) and (max-width:736px) and (orientation:landscape){.menu-grid .grid-item:first-child:nth-last-child(9)~li{min-height:calc((100vh - 140px) / 3)}}@media only screen and (max-width:375px) and (min-height:737px) and (max-height:812px) and (orientation:portrait){.menu-grid .grid-item:first-child:nth-last-child(9)~li{height:100%;min-height:calc((100vh - 140px) / 3)}}@media only screen and (min-width:737px) and (max-width:812px) and (max-height:375px) and (orientation:landscape){.menu-grid .grid-item:first-child:nth-last-child(9)~li{min-height:calc((100vh - 140px) / 3)}}@media only screen and (min-width:768px) and (max-width:1024px) and (orientation:landscape){.menu-grid .grid-item:first-child:nth-last-child(9)~li{min-height:174.66667px}}@media only screen and (min-width:768px) and (max-width:1024px) and (orientation:portrait){.menu-grid .grid-item:first-child:nth-last-child(9)~li{min-height:261.33333px}}.menu-grid .grid-item:first-child:nth-last-child(10){width:25%;min-height:617.33333px;max-height:723.33333px}@media only screen and (max-width:375px) and (max-height:736px) and (orientation:portrait){.menu-grid .grid-item:first-child:nth-last-child(10){height:100%;min-height:calc((100vh - 140px) / 3)}}@media only screen and (max-height:375px) and (max-width:736px) and (orientation:landscape){.menu-grid .grid-item:first-child:nth-last-child(10){min-height:calc((100vh - 140px) / 3)}}@media only screen and (min-width:376px) and (max-width:414px) and (max-height:736px) and (orientation:portrait){.menu-grid .grid-item:first-child:nth-last-child(10){height:100%;min-height:calc((100vh - 140px) / 3)}}@media only screen and (min-height:376px) and (max-height:414px) and (max-width:736px) and (orientation:landscape){.menu-grid .grid-item:first-child:nth-last-child(10){min-height:calc((100vh - 140px) / 3)}}@media only screen and (max-width:375px) and (min-height:737px) and (max-height:812px) and (orientation:portrait){.menu-grid .grid-item:first-child:nth-last-child(10){height:100%;min-height:calc((100vh - 140px) / 3)}}@media only screen and (min-width:737px) and (max-width:812px) and (max-height:375px) and (orientation:landscape){.menu-grid .grid-item:first-child:nth-last-child(10){min-height:calc((100vh - 140px) / 3)}}@media only screen and (min-width:768px) and (max-width:1024px) and (orientation:landscape){.menu-grid .grid-item:first-child:nth-last-child(10){min-height:174.66667px}}@media only screen and (min-width:768px) and (max-width:1024px) and (orientation:portrait){.menu-grid .grid-item:first-child:nth-last-child(10){min-height:261.33333px}}.menu-grid .grid-item:first-child:nth-last-child(10)~li{width:25%;min-height:617.33333px;max-height:723.33333px}@media only screen and (max-width:375px) and (max-height:736px) and (orientation:portrait){.menu-grid .grid-item:first-child:nth-last-child(10)~li{height:100%;min-height:calc((100vh - 140px) / 3)}}@media only screen and (max-height:375px) and (max-width:736px) and (orientation:landscape){.menu-grid .grid-item:first-child:nth-last-child(10)~li{min-height:calc((100vh - 140px) / 3)}}@media only screen and (min-width:376px) and (max-width:414px) and (max-height:736px) and (orientation:portrait){.menu-grid .grid-item:first-child:nth-last-child(10)~li{height:100%;min-height:calc((100vh - 140px) / 3)}}@media only screen and (min-height:376px) and (max-height:414px) and (max-width:736px) and (orientation:landscape){.menu-grid .grid-item:first-child:nth-last-child(10)~li{min-height:calc((100vh - 140px) / 3)}}@media only screen and (max-width:375px) and (min-height:737px) and (max-height:812px) and (orientation:portrait){.menu-grid .grid-item:first-child:nth-last-child(10)~li{height:100%;min-height:calc((100vh - 140px) / 3)}}@media only screen and (min-width:737px) and (max-width:812px) and (max-height:375px) and (orientation:landscape){.menu-grid .grid-item:first-child:nth-last-child(10)~li{min-height:calc((100vh - 140px) / 3)}}@media only screen and (min-width:768px) and (max-width:1024px) and (orientation:landscape){.menu-grid .grid-item:first-child:nth-last-child(10)~li{min-height:174.66667px}}@media only screen and (min-width:768px) and (max-width:1024px) and (orientation:portrait){.menu-grid .grid-item:first-child:nth-last-child(10)~li{min-height:261.33333px}}.menu-grid .grid-item:first-child:nth-last-child(10)~li:nth-child(9){clear:right;margin-left:25%}.menu-grid .grid-item:first-child:nth-last-child(11){width:25%;min-height:617.33333px;max-height:723.33333px}@media only screen and (max-width:375px) and (max-height:736px) and (orientation:portrait){.menu-grid .grid-item:first-child:nth-last-child(11){height:100%;min-height:calc((100vh - 140px) / 3)}}@media only screen and (max-height:375px) and (max-width:736px) and (orientation:landscape){.menu-grid .grid-item:first-child:nth-last-child(11){min-height:calc((100vh - 140px) / 3)}}@media only screen and (min-width:376px) and (max-width:414px) and (max-height:736px) and (orientation:portrait){.menu-grid .grid-item:first-child:nth-last-child(11){height:100%;min-height:calc((100vh - 140px) / 3)}}@media only screen and (min-height:376px) and (max-height:414px) and (max-width:736px) and (orientation:landscape){.menu-grid .grid-item:first-child:nth-last-child(11){min-height:calc((100vh - 140px) / 3)}}@media only screen and (max-width:375px) and (min-height:737px) and (max-height:812px) and (orientation:portrait){.menu-grid .grid-item:first-child:nth-last-child(11){height:100%;min-height:calc((100vh - 140px) / 3)}}@media only screen and (min-width:737px) and (max-width:812px) and (max-height:375px) and (orientation:landscape){.menu-grid .grid-item:first-child:nth-last-child(11){min-height:calc((100vh - 140px) / 3)}}@media only screen and (min-width:768px) and (max-width:1024px) and (orientation:landscape){.menu-grid .grid-item:first-child:nth-last-child(11){min-height:174.66667px}}@media only screen and (min-width:768px) and (max-width:1024px) and (orientation:portrait){.menu-grid .grid-item:first-child:nth-last-child(11){min-height:261.33333px}}.menu-grid .grid-item:first-child:nth-last-child(11)~li{width:25%;min-height:617.33333px;max-height:723.33333px}@media only screen and (max-width:375px) and (max-height:736px) and (orientation:portrait){.menu-grid .grid-item:first-child:nth-last-child(11)~li{height:100%;min-height:calc((100vh - 140px) / 3)}}@media only screen and (max-height:375px) and (max-width:736px) and (orientation:landscape){.menu-grid .grid-item:first-child:nth-last-child(11)~li{min-height:calc((100vh - 140px) / 3)}}@media only screen and (min-width:376px) and (max-width:414px) and (max-height:736px) and (orientation:portrait){.menu-grid .grid-item:first-child:nth-last-child(11)~li{height:100%;min-height:calc((100vh - 140px) / 3)}}@media only screen and (min-height:376px) and (max-height:414px) and (max-width:736px) and (orientation:landscape){.menu-grid .grid-item:first-child:nth-last-child(11)~li{min-height:calc((100vh - 140px) / 3)}}@media only screen and (max-width:375px) and (min-height:737px) and (max-height:812px) and (orientation:portrait){.menu-grid .grid-item:first-child:nth-last-child(11)~li{height:100%;min-height:calc((100vh - 140px) / 3)}}@media only screen and (min-width:737px) and (max-width:812px) and (max-height:375px) and (orientation:landscape){.menu-grid .grid-item:first-child:nth-last-child(11)~li{min-height:calc((100vh - 140px) / 3)}}@media only screen and (min-width:768px) and (max-width:1024px) and (orientation:landscape){.menu-grid .grid-item:first-child:nth-last-child(11)~li{min-height:174.66667px}}@media only screen and (min-width:768px) and (max-width:1024px) and (orientation:portrait){.menu-grid .grid-item:first-child:nth-last-child(11)~li{min-height:261.33333px}}.menu-grid .grid-item:first-child:nth-last-child(11)~li:nth-child(9){clear:right;margin-left:12.5%}.menu-grid .grid-item:first-child:nth-last-child(12){width:25%;min-height:617.33333px;max-height:723.33333px}@media only screen and (max-width:375px) and (max-height:736px) and (orientation:portrait){.menu-grid .grid-item:first-child:nth-last-child(12){height:100%;min-height:calc((100vh - 140px) / 3)}}@media only screen and (max-height:375px) and (max-width:736px) and (orientation:landscape){.menu-grid .grid-item:first-child:nth-last-child(12){min-height:calc((100vh - 140px) / 3)}}@media only screen and (min-width:376px) and (max-width:414px) and (max-height:736px) and (orientation:portrait){.menu-grid .grid-item:first-child:nth-last-child(12){height:100%;min-height:calc((100vh - 140px) / 3)}}@media only screen and (min-height:376px) and (max-height:414px) and (max-width:736px) and (orientation:landscape){.menu-grid .grid-item:first-child:nth-last-child(12){min-height:calc((100vh - 140px) / 3)}}@media only screen and (max-width:375px) and (min-height:737px) and (max-height:812px) and (orientation:portrait){.menu-grid .grid-item:first-child:nth-last-child(12){height:100%;min-height:calc((100vh - 140px) / 3)}}@media only screen and (min-width:737px) and (max-width:812px) and (max-height:375px) and (orientation:landscape){.menu-grid .grid-item:first-child:nth-last-child(12){min-height:calc((100vh - 140px) / 3)}}@media only screen and (min-width:768px) and (max-width:1024px) and (orientation:landscape){.menu-grid .grid-item:first-child:nth-last-child(12){min-height:174.66667px}}@media only screen and (min-width:768px) and (max-width:1024px) and (orientation:portrait){.menu-grid .grid-item:first-child:nth-last-child(12){min-height:261.33333px}}.menu-grid .grid-item:first-child:nth-last-child(12)~li{width:25%;min-height:617.33333px;max-height:723.33333px}@media only screen and (max-width:375px) and (max-height:736px) and (orientation:portrait){.menu-grid .grid-item:first-child:nth-last-child(12)~li{height:100%;min-height:calc((100vh - 140px) / 3)}}@media only screen and (max-height:375px) and (max-width:736px) and (orientation:landscape){.menu-grid .grid-item:first-child:nth-last-child(12)~li{min-height:calc((100vh - 140px) / 3)}}@media only screen and (min-width:376px) and (max-width:414px) and (max-height:736px) and (orientation:portrait){.menu-grid .grid-item:first-child:nth-last-child(12)~li{height:100%;min-height:calc((100vh - 140px) / 3)}}@media only screen and (min-height:376px) and (max-height:414px) and (max-width:736px) and (orientation:landscape){.menu-grid .grid-item:first-child:nth-last-child(12)~li{min-height:calc((100vh - 140px) / 3)}}@media only screen and (max-width:375px) and (min-height:737px) and (max-height:812px) and (orientation:portrait){.menu-grid .grid-item:first-child:nth-last-child(12)~li{height:100%;min-height:calc((100vh - 140px) / 3)}}@media only screen and (min-width:737px) and (max-width:812px) and (max-height:375px) and (orientation:landscape){.menu-grid .grid-item:first-child:nth-last-child(12)~li{min-height:calc((100vh - 140px) / 3)}}@media only screen and (min-width:768px) and (max-width:1024px) and (orientation:landscape){.menu-grid .grid-item:first-child:nth-last-child(12)~li{min-height:174.66667px}}@media only screen and (min-width:768px) and (max-width:1024px) and (orientation:portrait){.menu-grid .grid-item:first-child:nth-last-child(12)~li{min-height:261.33333px}}.menu-grid .grid-item .thumbnail{margin:0 auto!important;max-width:366px;border-radius:8px}.menu-grid .grid-item .thumbnail:hover{cursor:pointer}.menu-grid .grid-item .thumbnail:hover:after{position:absolute;display:block;background:hsla(0,0%,100%,.1);top:0;left:0;width:100%;height:100%;content:\"\";z-index:4}.menu-grid .grid-item .thumbnail .background-image-container{position:absolute;display:block;top:0;left:0;right:0;margin:auto;overflow:hidden;z-index:2}.menu-grid .grid-item .thumbnail .background-image-container img{top:0;display:block;width:100%;height:auto;position:relative;left:0;right:0;margin:auto;overflow:hidden}.menu-grid .grid-item .thumbnail .content-container{position:absolute;width:100%;height:100%;z-index:3;left:0;top:0;overflow:hidden}.menu-grid .grid-item .thumbnail .content-container .thumbnail-title{position:absolute;color:#fff;left:0;bottom:0;padding:6px 60px 6px 24px;width:100%;line-height:130%;text-align:left;font-size:86%;min-height:48px}.menu-grid .grid-item .thumbnail .content-container .thumbnail-title:before{top:8px;left:6px}.menu-grid .grid-item .thumbnail .content-container .thumbnail-title.not-required:before{color:#999;content:\"\"}.menu-grid .grid-item .thumbnail .content-container .thumbnail-title.not-required:before,.menu-grid .grid-item .thumbnail .content-container .thumbnail-title.not-started:before{padding-right:8px;display:inline-block;font-family:Guroo-Producer;font-style:normal;font-weight:400;font-variant:normal;line-height:1;text-decoration:inherit;text-rendering:optimizeLegibility;text-transform:none;-moz-osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased;font-smoothing:antialiased}.menu-grid .grid-item .thumbnail .content-container .thumbnail-title.not-started:before{content:\"\\F16A\"}.menu-grid .grid-item .thumbnail .content-container .thumbnail-title.in-progress:before{content:\"\\F182\"}.menu-grid .grid-item .thumbnail .content-container .thumbnail-title.complete:before,.menu-grid .grid-item .thumbnail .content-container .thumbnail-title.in-progress:before{display:inline-block;font-family:Guroo-Producer;font-style:normal;font-weight:400;font-variant:normal;line-height:1;text-decoration:inherit;text-rendering:optimizeLegibility;text-transform:none;-moz-osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased;font-smoothing:antialiased}.menu-grid .grid-item .thumbnail .content-container .thumbnail-title.complete:before{content:\"\\F16F\"}.menu-grid .grid-item .thumbnail .content-container .thumbnail-title .thumbnail-icon{position:absolute;right:10px;top:6px;text-align:right}.menu-grid .grid-item .thumbnail .content-container .thumbnail-title .thumbnail-icon img{height:36px}.menu-grid .grid-item .thumbnail .content-container .kpi-meter{position:absolute;top:10px;right:10px;padding:6px;background:hsla(0,0%,100%,.5);border-radius:5px}.menu-grid .grid-item .thumbnail .content-container .thumbnail-achievement-container{padding:8px 12px;position:absolute;width:auto;right:10px;background:hsla(0,0%,100%,.5);border-radius:5px;bottom:40px}.menu-grid .grid-item .thumbnail .content-container .thumbnail-achievement-container .achievement-grid-item:first-child:last-child{margin-left:0}.menu-grid .grid-item .thumbnail .content-container .thumbnail-achievement-container .achievement{width:60px;height:60px}.menu-grid .grid-item .thumbnail .content-container .thumbnail-achievement-container .achievement .achievement-container :before{font-size:60px}.menu-grid .grid-item .thumbnail.disabled{-webkit-filter:grayscale(90%);filter:grayscale(100%)}.menu-grid .grid-item .thumbnail.disabled:hover{cursor:default}.menu-grid .grid-item .thumbnail.disabled:hover:after{display:none}.accordion-screen .content-wrapper-background{position:absolute}.accordion-screen.frosted_white .content-wrapper-background{z-index:1;display:block;position:absolute;top:0;left:0;right:0;width:100%;height:100%;margin:auto;-webkit-clip-path:inset(0 80px 0 80px);clip-path:inset(0 80px 0 80px);-webkit-filter:blur(15px);filter:blur(15px);-webkit-clip-path:inset(0 60px 0 60px);clip-path:inset(0 60px 0 60px)}.accordion-screen.frosted_white .content-wrapper-background img{position:absolute;bottom:0;left:0;right:0;margin:auto;width:100%;height:auto}@media only screen and (max-width:375px) and (max-height:736px) and (orientation:portrait){.accordion-screen.frosted_white .content-wrapper-background img{min-height:100vh;position:absolute;height:100%;left:0;right:0;margin:auto!important;width:auto;min-width:100%}}@media only screen and (max-height:375px) and (max-width:736px) and (orientation:landscape){.accordion-screen.frosted_white .content-wrapper-background img{min-height:100vh;height:auto;top:0;width:100%}.accordion-screen.frosted_white .content-wrapper-background img.title-screen{bottom:unset;top:0}}@media only screen and (min-width:376px) and (max-width:414px) and (max-height:736px) and (orientation:portrait){.accordion-screen.frosted_white .content-wrapper-background img{min-height:100vh;position:absolute;height:100%;left:0;right:0;margin:auto!important;width:auto;min-width:100%}}@media only screen and (min-height:376px) and (max-height:414px) and (max-width:736px) and (orientation:landscape){.accordion-screen.frosted_white .content-wrapper-background img{min-height:100vh;height:auto;bottom:0;width:100%}.accordion-screen.frosted_white .content-wrapper-background img.title-screen{bottom:unset;top:0}}@media only screen and (min-width:768px) and (max-width:1024px) and (orientation:landscape){.accordion-screen.frosted_white .content-wrapper-background img{min-height:664px;height:auto;width:100%}}@media only screen and (width:900px) and (height:768px){.accordion-screen.frosted_white .content-wrapper-background img{min-height:664px;height:auto;width:100%}}@media only screen and (min-width:768px) and (max-width:1024px) and (orientation:portrait){.accordion-screen.frosted_white .content-wrapper-background img{min-height:924px;position:absolute;height:100%;left:0;right:0;margin:auto!important;width:auto;min-width:100%}}@media only screen and (max-width:375px) and (min-height:737px) and (max-height:812px) and (orientation:portrait){.accordion-screen.frosted_white .content-wrapper-background img{min-height:100vh;position:absolute;height:100%;left:0;right:0;margin:auto!important;width:auto;min-width:100%}}@media only screen and (min-width:737px) and (max-width:812px) and (max-height:375px) and (orientation:landscape){.accordion-screen.frosted_white .content-wrapper-background img{min-height:100vh;height:auto;top:0;width:100%}.accordion-screen.frosted_white .content-wrapper-background img.title-screen{bottom:unset;top:0}}@media only screen and (max-width:320px) and (max-height:568px) and (orientation:portrait){.accordion-screen.frosted_white .content-wrapper-background img{min-height:100vh;position:absolute;height:100%;left:0;right:0;margin:auto!important;width:auto;min-width:100%}}@media only screen and (min-width:200px) and (max-width:900px) and (orientation:landscape){.accordion-screen.frosted_white .content-wrapper-background{display:none}}@media only screen and (max-width:375px) and (max-height:736px) and (orientation:portrait){.accordion-screen.frosted_white .content-wrapper-background{display:none}}@media only screen and (max-height:375px) and (max-width:736px) and (orientation:landscape){.accordion-screen.frosted_white .content-wrapper-background{display:none}}@media only screen and (min-width:376px) and (max-width:414px) and (max-height:736px) and (orientation:portrait){.accordion-screen.frosted_white .content-wrapper-background{display:none}}@media only screen and (min-height:376px) and (max-height:414px) and (max-width:736px) and (orientation:landscape){.accordion-screen.frosted_white .content-wrapper-background{display:none}}@media only screen and (max-width:375px) and (min-height:737px) and (max-height:812px) and (orientation:portrait){.accordion-screen.frosted_white .content-wrapper-background{display:none}}@media only screen and (min-width:768px) and (max-width:1024px) and (orientation:landscape){.accordion-screen.frosted_white .content-wrapper-background{position:absolute;top:0;left:0;right:0;width:100%;height:100%;margin:auto;-webkit-clip-path:inset(0 32px 0 32px);clip-path:inset(0 32px 0 32x);-webkit-filter:blur(15px);filter:blur(15px)}}@media only screen and (min-width:768px) and (max-width:1024px) and (orientation:portrait){.accordion-screen.frosted_white .content-wrapper-background{position:absolute;top:0;left:0;right:0;width:100%;height:100%;margin:auto;-webkit-clip-path:inset(0 24px 0 24px);clip-path:inset(0 24px 0 24px);-webkit-filter:blur(15px);filter:blur(15px)}}.accordion-screen.frosted_white .content-wrapper-background:after{content:\"\";position:absolute;width:100%;height:100%;margin:0 30px}.accordion-screen.frosted_white .blurred-feed{background:hsla(0,0%,100%,.7)}.accordion-screen.frosted_white .standard-feed{background:hsla(0,0%,100%,.9)}@media only screen and (max-width:375px) and (max-height:736px) and (orientation:portrait){.accordion-screen.frosted_white .blurred-feed:not(.accordion-content-wrapper){background:hsla(0,0%,100%,.8)}}@media only screen and (max-height:375px) and (max-width:736px) and (orientation:landscape){.accordion-screen.frosted_white .blurred-feed:not(.accordion-content-wrapper){background:hsla(0,0%,100%,.8)}}@media only screen and (min-width:376px) and (max-width:414px) and (max-height:736px) and (orientation:portrait){.accordion-screen.frosted_white .blurred-feed:not(.accordion-content-wrapper){background:hsla(0,0%,100%,.8)}}@media only screen and (min-height:376px) and (max-height:414px) and (max-width:736px) and (orientation:landscape){.accordion-screen.frosted_white .blurred-feed:not(.accordion-content-wrapper){background:hsla(0,0%,100%,.8)}}@media only screen and (min-width:768px) and (max-width:1024px) and (orientation:portrait){.accordion-screen.frosted_white .blurred-feed:not(.accordion-content-wrapper){background:hsla(0,0%,100%,.8)}}@media only screen and (max-width:375px) and (min-height:737px) and (max-height:812px) and (orientation:portrait){.accordion-screen.frosted_white .blurred-feed:not(.accordion-content-wrapper){background:hsla(0,0%,100%,.8)}}@media only screen and (min-width:737px) and (max-width:812px) and (max-height:375px) and (orientation:landscape){.accordion-screen.frosted_white .blurred-feed:not(.accordion-content-wrapper){background:hsla(0,0%,100%,.8)}}@media only screen and (max-width:320px) and (max-height:568px) and (orientation:portrait){.accordion-screen.frosted_white .blurred-feed:not(.accordion-content-wrapper){background:hsla(0,0%,100%,.8)}}@media only screen and (max-width:320px) and (max-height:568px) and (orientation:landscape){.accordion-screen.frosted_white .blurred-feed:not(.accordion-content-wrapper){background:hsla(0,0%,100%,.8)}}.accordion-screen.tinted_dark .content-wrapper-background{z-index:1;display:block;position:absolute;top:0;left:0;right:0;width:100%;height:100%;margin:auto;-webkit-clip-path:inset(0 80px 0 80px);clip-path:inset(0 80px 0 80px);-webkit-filter:blur(15px);filter:blur(15px);-webkit-clip-path:inset(0 60px 0 60px);clip-path:inset(0 60px 0 60px)}.accordion-screen.tinted_dark .content-wrapper-background img{position:absolute;bottom:0;left:0;right:0;margin:auto;width:100%;height:auto}@media only screen and (max-width:375px) and (max-height:736px) and (orientation:portrait){.accordion-screen.tinted_dark .content-wrapper-background img{min-height:100vh;position:absolute;height:100%;left:0;right:0;margin:auto!important;width:auto;min-width:100%}}@media only screen and (max-height:375px) and (max-width:736px) and (orientation:landscape){.accordion-screen.tinted_dark .content-wrapper-background img{min-height:100vh;height:auto;top:0;width:100%}.accordion-screen.tinted_dark .content-wrapper-background img.title-screen{bottom:unset;top:0}}@media only screen and (min-width:376px) and (max-width:414px) and (max-height:736px) and (orientation:portrait){.accordion-screen.tinted_dark .content-wrapper-background img{min-height:100vh;position:absolute;height:100%;left:0;right:0;margin:auto!important;width:auto;min-width:100%}}@media only screen and (min-height:376px) and (max-height:414px) and (max-width:736px) and (orientation:landscape){.accordion-screen.tinted_dark .content-wrapper-background img{min-height:100vh;height:auto;bottom:0;width:100%}.accordion-screen.tinted_dark .content-wrapper-background img.title-screen{bottom:unset;top:0}}@media only screen and (min-width:768px) and (max-width:1024px) and (orientation:landscape){.accordion-screen.tinted_dark .content-wrapper-background img{min-height:664px;height:auto;width:100%}}@media only screen and (width:900px) and (height:768px){.accordion-screen.tinted_dark .content-wrapper-background img{min-height:664px;height:auto;width:100%}}@media only screen and (min-width:768px) and (max-width:1024px) and (orientation:portrait){.accordion-screen.tinted_dark .content-wrapper-background img{min-height:924px;position:absolute;height:100%;left:0;right:0;margin:auto!important;width:auto;min-width:100%}}@media only screen and (max-width:375px) and (min-height:737px) and (max-height:812px) and (orientation:portrait){.accordion-screen.tinted_dark .content-wrapper-background img{min-height:100vh;position:absolute;height:100%;left:0;right:0;margin:auto!important;width:auto;min-width:100%}}@media only screen and (min-width:737px) and (max-width:812px) and (max-height:375px) and (orientation:landscape){.accordion-screen.tinted_dark .content-wrapper-background img{min-height:100vh;height:auto;top:0;width:100%}.accordion-screen.tinted_dark .content-wrapper-background img.title-screen{bottom:unset;top:0}}@media only screen and (max-width:320px) and (max-height:568px) and (orientation:portrait){.accordion-screen.tinted_dark .content-wrapper-background img{min-height:100vh;position:absolute;height:100%;left:0;right:0;margin:auto!important;width:auto;min-width:100%}}@media only screen and (min-width:200px) and (max-width:900px) and (orientation:landscape){.accordion-screen.tinted_dark .content-wrapper-background{display:none}}@media only screen and (max-width:375px) and (max-height:736px) and (orientation:portrait){.accordion-screen.tinted_dark .content-wrapper-background{display:none}}@media only screen and (max-height:375px) and (max-width:736px) and (orientation:landscape){.accordion-screen.tinted_dark .content-wrapper-background{display:none}}@media only screen and (min-width:376px) and (max-width:414px) and (max-height:736px) and (orientation:portrait){.accordion-screen.tinted_dark .content-wrapper-background{display:none}}@media only screen and (min-height:376px) and (max-height:414px) and (max-width:736px) and (orientation:landscape){.accordion-screen.tinted_dark .content-wrapper-background{display:none}}@media only screen and (max-width:375px) and (min-height:737px) and (max-height:812px) and (orientation:portrait){.accordion-screen.tinted_dark .content-wrapper-background{display:none}}@media only screen and (min-width:768px) and (max-width:1024px) and (orientation:landscape){.accordion-screen.tinted_dark .content-wrapper-background{position:absolute;top:0;left:0;right:0;width:100%;height:100%;margin:auto;-webkit-clip-path:inset(0 32px 0 32px);clip-path:inset(0 32px 0 32x);-webkit-filter:blur(15px);filter:blur(15px)}}@media only screen and (min-width:768px) and (max-width:1024px) and (orientation:portrait){.accordion-screen.tinted_dark .content-wrapper-background{position:absolute;top:0;left:0;right:0;width:100%;height:100%;margin:auto;-webkit-clip-path:inset(0 24px 0 24px);clip-path:inset(0 24px 0 24px);-webkit-filter:blur(15px);filter:blur(15px)}}.accordion-screen.tinted_dark .accordion-content-wrapper{background:rgba(0,0,0,.5)}.accordion-screen.thick_glass .content-wrapper-background{z-index:1;display:block;position:absolute;top:0;left:0;right:0;width:100%;height:100%;margin:auto;-webkit-clip-path:inset(0 80px 0 80px);clip-path:inset(0 80px 0 80px);-webkit-filter:blur(15px);filter:blur(15px);-webkit-clip-path:inset(0 60px 0 60px);clip-path:inset(0 60px 0 60px)}.accordion-screen.thick_glass .content-wrapper-background img{position:absolute;bottom:0;left:0;right:0;margin:auto;width:100%;height:auto}@media only screen and (max-width:375px) and (max-height:736px) and (orientation:portrait){.accordion-screen.thick_glass .content-wrapper-background img{min-height:100vh;position:absolute;height:100%;left:0;right:0;margin:auto!important;width:auto;min-width:100%}}@media only screen and (max-height:375px) and (max-width:736px) and (orientation:landscape){.accordion-screen.thick_glass .content-wrapper-background img{min-height:100vh;height:auto;top:0;width:100%}.accordion-screen.thick_glass .content-wrapper-background img.title-screen{bottom:unset;top:0}}@media only screen and (min-width:376px) and (max-width:414px) and (max-height:736px) and (orientation:portrait){.accordion-screen.thick_glass .content-wrapper-background img{min-height:100vh;position:absolute;height:100%;left:0;right:0;margin:auto!important;width:auto;min-width:100%}}@media only screen and (min-height:376px) and (max-height:414px) and (max-width:736px) and (orientation:landscape){.accordion-screen.thick_glass .content-wrapper-background img{min-height:100vh;height:auto;bottom:0;width:100%}.accordion-screen.thick_glass .content-wrapper-background img.title-screen{bottom:unset;top:0}}@media only screen and (min-width:768px) and (max-width:1024px) and (orientation:landscape){.accordion-screen.thick_glass .content-wrapper-background img{min-height:664px;height:auto;width:100%}}@media only screen and (width:900px) and (height:768px){.accordion-screen.thick_glass .content-wrapper-background img{min-height:664px;height:auto;width:100%}}@media only screen and (min-width:768px) and (max-width:1024px) and (orientation:portrait){.accordion-screen.thick_glass .content-wrapper-background img{min-height:924px;position:absolute;height:100%;left:0;right:0;margin:auto!important;width:auto;min-width:100%}}@media only screen and (max-width:375px) and (min-height:737px) and (max-height:812px) and (orientation:portrait){.accordion-screen.thick_glass .content-wrapper-background img{min-height:100vh;position:absolute;height:100%;left:0;right:0;margin:auto!important;width:auto;min-width:100%}}@media only screen and (min-width:737px) and (max-width:812px) and (max-height:375px) and (orientation:landscape){.accordion-screen.thick_glass .content-wrapper-background img{min-height:100vh;height:auto;top:0;width:100%}.accordion-screen.thick_glass .content-wrapper-background img.title-screen{bottom:unset;top:0}}@media only screen and (max-width:320px) and (max-height:568px) and (orientation:portrait){.accordion-screen.thick_glass .content-wrapper-background img{min-height:100vh;position:absolute;height:100%;left:0;right:0;margin:auto!important;width:auto;min-width:100%}}@media only screen and (min-width:200px) and (max-width:900px) and (orientation:landscape){.accordion-screen.thick_glass .content-wrapper-background{display:none}}@media only screen and (max-width:375px) and (max-height:736px) and (orientation:portrait){.accordion-screen.thick_glass .content-wrapper-background{display:none}}@media only screen and (max-height:375px) and (max-width:736px) and (orientation:landscape){.accordion-screen.thick_glass .content-wrapper-background{display:none}}@media only screen and (min-width:376px) and (max-width:414px) and (max-height:736px) and (orientation:portrait){.accordion-screen.thick_glass .content-wrapper-background{display:none}}@media only screen and (min-height:376px) and (max-height:414px) and (max-width:736px) and (orientation:landscape){.accordion-screen.thick_glass .content-wrapper-background{display:none}}@media only screen and (max-width:375px) and (min-height:737px) and (max-height:812px) and (orientation:portrait){.accordion-screen.thick_glass .content-wrapper-background{display:none}}@media only screen and (min-width:768px) and (max-width:1024px) and (orientation:landscape){.accordion-screen.thick_glass .content-wrapper-background{position:absolute;top:0;left:0;right:0;width:100%;height:100%;margin:auto;-webkit-clip-path:inset(0 32px 0 32px);clip-path:inset(0 32px 0 32x);-webkit-filter:blur(15px);filter:blur(15px)}}@media only screen and (min-width:768px) and (max-width:1024px) and (orientation:portrait){.accordion-screen.thick_glass .content-wrapper-background{position:absolute;top:0;left:0;right:0;width:100%;height:100%;margin:auto;-webkit-clip-path:inset(0 24px 0 24px);clip-path:inset(0 24px 0 24px);-webkit-filter:blur(15px);filter:blur(15px)}}.accordion-screen.thick_glass .blurred-feed{background:hsla(0,0%,91%,.2)}.accordion-screen.thick_glass .standard-feed{background:hsla(0,0%,91%,.9)}@media only screen and (max-width:375px) and (max-height:736px) and (orientation:portrait){.accordion-screen.thick_glass .blurred-feed{background:hsla(0,0%,91%,.9)}}@media only screen and (max-height:375px) and (max-width:736px) and (orientation:landscape){.accordion-screen.thick_glass .blurred-feed{background:hsla(0,0%,91%,.9)}}@media only screen and (min-width:376px) and (max-width:414px) and (max-height:736px) and (orientation:portrait){.accordion-screen.thick_glass .blurred-feed{background:hsla(0,0%,91%,.9)}}@media only screen and (min-height:376px) and (max-height:414px) and (max-width:736px) and (orientation:landscape){.accordion-screen.thick_glass .blurred-feed{background:hsla(0,0%,91%,.9)}}@media only screen and (min-width:768px) and (max-width:1024px) and (orientation:portrait){.accordion-screen.thick_glass .blurred-feed{background:hsla(0,0%,91%,.9)}}@media only screen and (max-width:375px) and (min-height:737px) and (max-height:812px) and (orientation:portrait){.accordion-screen.thick_glass .blurred-feed{background:hsla(0,0%,91%,.9)}}@media only screen and (min-width:737px) and (max-width:812px) and (max-height:375px) and (orientation:landscape){.accordion-screen.thick_glass .blurred-feed{background:hsla(0,0%,91%,.9)}}@media only screen and (max-width:320px) and (max-height:568px) and (orientation:portrait){.accordion-screen.thick_glass .blurred-feed{background:hsla(0,0%,91%,.9)}}@media only screen and (max-width:320px) and (max-height:568px) and (orientation:landscape){.accordion-screen.thick_glass .blurred-feed{background:hsla(0,0%,91%,.9)}}.accordion-screen.transparent .accordion-content-wrapper{-webkit-box-shadow:none;-moz-box-shadow:none;box-shadow:none}.accordion-screen .accordion-content-wrapper{position:absolute;z-index:2!important;height:100%;width:calc(100% - 120px);padding:0;left:0;right:0;margin:auto;overflow-y:hidden;-webkit-box-shadow:0 5px 5px 0 rgba(0,0,0,.25);-moz-box-shadow:0 5px 5px 0 rgba(0,0,0,.25);box-shadow:0 5px 5px 0 rgba(0,0,0,.25)}.accordion-screen .accordion-content-wrapper.allow-scroll{overflow-y:auto}.accordion-screen .accordion-content-wrapper .background-image{text-align:center}.accordion-screen .accordion-content-wrapper .background-image .hot-spot-background{width:100%;height:auto;max-height:50%}.accordion-screen .accordion{display:block;overflow:hidden;margin:30px;padding:0}.accordion-screen .accordion .accordion-item{list-style-type:none;display:block;overflow:hidden;margin:15px 5px;padding:0;border-radius:5px;-webkit-box-shadow:0 0 5px 2px rgba(0,0,0,.05);-moz-box-shadow:0 0 5px 2px rgba(0,0,0,.05);box-shadow:0 0 5px 2px rgba(0,0,0,.05)}.accordion-screen .accordion .accordion-item:first-child{margin-top:5px}.accordion-screen .accordion .accordion-item:last-child{margin-bottom:5px}.accordion-screen .accordion .accordion-item .accordion-item-list{display:block;overflow:hidden;margin:0;padding:0}.accordion-screen .accordion .accordion-item .accordion-item-list .accordion-btn{position:relative;padding:20px 48px;cursor:pointer;overflow:hidden;display:-webkit-flex;display:flex;flex-flow:row nowrap;align-items:center}.accordion-screen .accordion .accordion-item .accordion-item-list .accordion-btn.disabled{cursor:default}.accordion-screen .accordion .accordion-item .accordion-item-list .accordion-btn:before{position:absolute;left:24px;top:0;bottom:0;margin:auto;height:16px}.accordion-screen .accordion .accordion-item .accordion-item-list .accordion-btn:after{position:absolute;right:24px;top:0;bottom:0;height:16px;margin:auto}.accordion-screen .accordion .accordion-item .accordion-item-list .accordion-btn.incomplete:before{content:\"\\F16A\"}.accordion-screen .accordion .accordion-item .accordion-item-list .accordion-btn.complete:before,.accordion-screen .accordion .accordion-item .accordion-item-list .accordion-btn.incomplete:before{display:inline-block;font-family:Guroo-Producer;font-style:normal;font-weight:400;font-variant:normal;line-height:1;text-decoration:inherit;text-rendering:optimizeLegibility;text-transform:none;-moz-osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased;font-smoothing:antialiased}.accordion-screen .accordion .accordion-item .accordion-item-list .accordion-btn.complete:before{content:\"\\F16F\"}.accordion-screen .accordion .accordion-item .accordion-item-list .accordion-btn .kpi-meter-container{position:absolute;padding:0 0 0 50px}.accordion-screen .accordion .accordion-item .accordion-item-list .accordion-btn .kpi-meter-container .kpi-meter{left:5px;top:-5px;position:absolute}.accordion-screen .accordion .accordion-item .accordion-item-list .accordion-btn .accordion-icon{padding-right:10px}.accordion-screen .accordion .accordion-item .accordion-item-list .accordion-btn .accordion-icon img{height:40px;width:auto}.accordion-screen .accordion .accordion-item .accordion-item-list .accordion-content{display:block;position:relative;overflow:hidden;padding:0;height:0;background:#fff;margin-top:0}.accordion-screen .accordion .accordion-item .accordion-item-list .accordion-content .content-padding{padding:12px 24px}@media only screen and (max-width:736px){.accordion-screen .accordion .accordion-item .accordion-item-list .accordion-content .content-padding{padding-left:12px;padding-right:12px}}@media only screen and (max-height:375px) and (max-width:736px) and (orientation:landscape){.accordion-screen .accordion .accordion-item .accordion-item-list .accordion-content .content-padding{padding-left:12px;padding-right:12px}}@media only screen and (min-width:768px) and (max-width:1024px) and (orientation:portrait){.accordion-screen .accordion .accordion-item .accordion-item-list .accordion-content .content-padding{padding:0}}.accordion-screen .accordion .accordion-item .accordion-item-list .accordion-content .content-padding .content-wrapper{height:100%;width:100%;padding:30px 24px;margin:0 auto;box-shadow:none}@media only screen and (max-width:736px){.accordion-screen .accordion .accordion-item .accordion-item-list .accordion-content .content-padding .content-wrapper{margin:0 -12px;padding-left:12px;padding-right:12px}.accordion-screen .accordion .accordion-item .accordion-item-list .accordion-content .content-padding .content-wrapper .object-container{padding-left:24px;padding-right:24px}}@media only screen and (min-width:768px) and (max-width:1024px) and (orientation:portrait){.accordion-screen .accordion .accordion-item .accordion-item-list .accordion-content .content-padding .content-wrapper{padding:0;margin:0!important;width:100%!important}}.accordion-screen .accordion .accordion-item .accordion-item-list .accordion-content .content-padding .content-wrapper .content-area{height:100%;width:100%;padding:30px 24px;margin:0 auto;box-shadow:none}@media only screen and (max-width:736px){.accordion-screen .accordion .accordion-item .accordion-item-list .accordion-content .content-padding .content-wrapper .content-area{margin:0 -12px;padding-left:12px;padding-right:12px}.accordion-screen .accordion .accordion-item .accordion-item-list .accordion-content .content-padding .content-wrapper .content-area .object-container{padding-left:24px;padding-right:24px}}@media only screen and (min-width:768px) and (max-width:1024px) and (orientation:portrait){.accordion-screen .accordion .accordion-item .accordion-item-list .accordion-content .content-padding .content-wrapper .content-area{padding:0;margin:0!important;width:100%!important}.accordion-screen .accordion .accordion-item .accordion-item-list .accordion-content .content-padding .content-wrapper .content-area .asset-col-left{padding:24px 15px 0}}.accordion-screen .accordion .accordion-item .accordion-item-list .accordion-content .content-padding .screen-container{height:100%}.accordion-screen .accordion .accordion-item .accordion-item-list .accordion-content .content-padding .object-feed{position:absolute;bottom:0;max-height:100%;height:auto;padding:10px 0 0!important}.accordion-screen .accordion .accordion-item .accordion-item-list .accordion-content .content-padding .video-object-wrapper .video-col.single{padding:0 210px}.accordion-screen .accordion .accordion-item.open .accordion-btn{border-bottom:1px solid #d5d5d5}.accordion-screen .accordion .accordion-item.open .accordion-btn:after{content:\"\\F21F\"}.accordion-screen .accordion .accordion-item.closed .accordion-btn:after,.accordion-screen .accordion .accordion-item.open .accordion-btn:after{display:inline-block;font-family:Guroo-Producer;font-style:normal;font-weight:400;font-variant:normal;line-height:1;text-decoration:inherit;text-rendering:optimizeLegibility;text-transform:none;-moz-osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased;font-smoothing:antialiased}.accordion-screen .accordion .accordion-item.closed .accordion-btn:after{content:\"\\F220\"}@media only screen and (max-width:375px) and (max-height:736px) and (orientation:portrait){.accordion-screen .accordion-content-wrapper{width:100%}.accordion-screen .accordion-content-wrapper .accordion{margin:10px}.accordion-screen .accordion-content-wrapper .accordion .accordion-item{margin:5px}.accordion-screen .accordion-content-wrapper .accordion .accordion-item .accordion-btn{padding:10px 48px}}@media only screen and (max-height:375px) and (max-width:736px) and (orientation:landscape){.accordion-screen .accordion-content-wrapper{width:100%}.accordion-screen .accordion-content-wrapper .accordion{margin:10px}.accordion-screen .accordion-content-wrapper .accordion .accordion-item{margin:5px}.accordion-screen .accordion-content-wrapper .accordion .accordion-item .accordion-btn{padding:10px 48px}}@media only screen and (min-width:376px) and (max-width:414px) and (max-height:736px) and (orientation:portrait){.accordion-screen .accordion-content-wrapper{width:100%}.accordion-screen .accordion-content-wrapper .accordion{margin:10px}.accordion-screen .accordion-content-wrapper .accordion .accordion-item{margin:5px}.accordion-screen .accordion-content-wrapper .accordion .accordion-item .accordion-btn{padding:10px 48px}}@media only screen and (min-height:376px) and (max-height:414px) and (max-width:736px) and (orientation:landscape){.accordion-screen .accordion-content-wrapper{width:100%}.accordion-screen .accordion-content-wrapper .accordion{margin:10px}.accordion-screen .accordion-content-wrapper .accordion .accordion-item{margin:5px}.accordion-screen .accordion-content-wrapper .accordion .accordion-item .accordion-btn{padding:10px 48px}}@media only screen and (min-width:768px) and (max-width:1024px) and (orientation:portrait){.accordion-screen .accordion-content-wrapper{width:calc(100% - 50px)}}@media only screen and (max-width:375px) and (min-height:737px) and (max-height:812px) and (orientation:portrait){.accordion-screen .accordion-content-wrapper{width:100%}.accordion-screen .accordion-content-wrapper .accordion{margin:10px}.accordion-screen .accordion-content-wrapper .accordion .accordion-item{margin:5px}.accordion-screen .accordion-content-wrapper .accordion .accordion-item .accordion-btn{padding:10px 48px}}@media only screen and (min-width:737px) and (max-width:812px) and (max-height:375px) and (orientation:landscape){.accordion-screen .accordion-content-wrapper{width:100%}.accordion-screen .accordion-content-wrapper .accordion{margin:10px}.accordion-screen .accordion-content-wrapper .accordion .accordion-item{margin:5px}.accordion-screen .accordion-content-wrapper .accordion .accordion-item .accordion-btn{padding:10px 48px}}@media only screen and (max-width:320px) and (max-height:568px) and (orientation:portrait){.accordion-screen .accordion-content-wrapper{width:100%}.accordion-screen .accordion-content-wrapper .accordion{margin:10px}.accordion-screen .accordion-content-wrapper .accordion .accordion-item{margin:5px}.accordion-screen .accordion-content-wrapper .accordion .accordion-item .accordion-btn{padding:10px 48px}}@media only screen and (max-width:320px) and (max-height:568px) and (orientation:landscape){.accordion-screen .accordion-content-wrapper{width:100%}.accordion-screen .accordion-content-wrapper .accordion{margin:10px}.accordion-screen .accordion-content-wrapper .accordion .accordion-item{margin:5px}.accordion-screen .accordion-content-wrapper .accordion .accordion-item .accordion-btn{padding:10px 48px}}.top-level{position:absolute;background:red;z-index:9999999999}.horz-slider-screen{display:block;position:relative;overflow:hidden;height:100%}.horz-slider-screen .slider-prev-slide-btn{cursor:pointer;position:absolute;top:50%;left:25px;transition:opacity .5s ease,color .5s ease;z-index:500}.horz-slider-screen .slider-prev-slide-btn:after{font-size:32px;display:inline-block;font-family:Guroo-Producer;font-style:normal;font-weight:400;font-variant:normal;line-height:1;text-decoration:inherit;text-rendering:optimizeLegibility;text-transform:none;-moz-osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased;font-smoothing:antialiased;content:\"\\F107\"}.horz-slider-screen .slider-prev-slide-btn:hover{opacity:.8}.horz-slider-screen .slider-prev-slide-btn.disabled{cursor:not-allowed}.horz-slider-screen .slider-prev-slide-btn.disabled:hover{opacity:1}.horz-slider-screen .slider-prev-slide-btn.disabled:after{color:#999}.horz-slider-screen .slider-next-slide-btn{cursor:pointer;position:absolute;top:50%;right:25px;transition:opacity .5s ease,color .5s ease;z-index:500}.horz-slider-screen .slider-next-slide-btn:after{font-size:32px;display:inline-block;font-family:Guroo-Producer;font-style:normal;font-weight:400;font-variant:normal;line-height:1;text-decoration:inherit;text-rendering:optimizeLegibility;text-transform:none;-moz-osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased;font-smoothing:antialiased;content:\"\\F109\"}.horz-slider-screen .slider-next-slide-btn:hover{opacity:.8}.horz-slider-screen .slider-next-slide-btn.disabled{cursor:not-allowed}.horz-slider-screen .slider-next-slide-btn.disabled:hover{opacity:1}.horz-slider-screen .slider-next-slide-btn.disabled:after{color:#999}.horz-slider-screen .slider-container{height:calc(100% - 60px);width:calc(100% - 120px);max-width:1024px;margin:30px auto;border-radius:5px;-webkit-box-shadow:0 5px 5px 0 rgba(0,0,0,.25);-moz-box-shadow:0 5px 5px 0 rgba(0,0,0,.25);box-shadow:0 5px 5px 0 rgba(0,0,0,.25);background:#fff;border:1px solid #d5d5d5;overflow:hidden;z-index:400}.horz-slider-screen .slider-container .thumbnail-wrapper,.horz-slider-screen .slider-container .thumbnail-wrapper .thumbnail-container,.horz-slider-screen .slider-container .thumbnail-wrapper .thumbnail-container .thumbnail-list{display:block;text-align:center;width:100%;margin:0;padding:0}.horz-slider-screen .slider-container .thumbnail-wrapper .thumbnail-container .thumbnail-list .thumbnail-item{position:relative;display:inline-block;text-align:center;vertical-align:middle;padding:0 12px;height:40px;cursor:pointer;transition:opacity .5s ease,color .5s ease}.horz-slider-screen .slider-container .thumbnail-wrapper .thumbnail-container .thumbnail-list .thumbnail-item:hover{opacity:.8}.horz-slider-screen .slider-container .thumbnail-wrapper .thumbnail-container .thumbnail-list .thumbnail-item:before{position:absolute;font-size:16px;height:16px;width:24px;text-align:center;top:0;bottom:0;left:0;right:0;margin:auto}.horz-slider-screen .slider-container .thumbnail-wrapper .thumbnail-container .thumbnail-list .thumbnail-item.disabled:hover{cursor:not-allowed;opacity:1}.horz-slider-screen .slider-container .thumbnail-wrapper .thumbnail-container .thumbnail-list .thumbnail-item.incomplete:before{color:#999;display:inline-block;font-family:Guroo-Producer;font-style:normal;font-weight:400;font-variant:normal;line-height:1;text-decoration:inherit;text-rendering:optimizeLegibility;text-transform:none;-moz-osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased;font-smoothing:antialiased;content:\"\\F16A\"}.horz-slider-screen .slider-container .thumbnail-wrapper .thumbnail-container .thumbnail-list .thumbnail-item.complete:before{color:#39aa27;display:inline-block;font-family:Guroo-Producer;font-style:normal;font-weight:400;font-variant:normal;line-height:1;text-decoration:inherit;text-rendering:optimizeLegibility;text-transform:none;-moz-osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased;font-smoothing:antialiased;content:\"\\F16F\"}.horz-slider-screen .slider-container .thumbnail-wrapper .thumbnail-container.icon-list{display:block;text-align:center;width:100%;margin:0;padding:0;background:#eff0f2}.horz-slider-screen .slider-container .thumbnail-wrapper .thumbnail-container.icon-list .thumbnail-item{position:relative;display:inline-block;text-align:center;vertical-align:middle;background:#fff;margin:10px 5px;height:48px;width:48px;padding:4px 2px;border-radius:50%;border:2px solid #d5d5d5;cursor:pointer;transition:opacity .5s ease,color .5s ease;overflow:hidden}.horz-slider-screen .slider-container .thumbnail-wrapper .thumbnail-container.icon-list .thumbnail-item:hover{opacity:.8}.horz-slider-screen .slider-container .thumbnail-wrapper .thumbnail-container.icon-list .thumbnail-item:before{display:none}.horz-slider-screen .slider-container .thumbnail-wrapper .thumbnail-container.icon-list .thumbnail-item.disabled:hover{cursor:not-allowed;opacity:1}.horz-slider-screen .slider-container .thumbnail-wrapper .thumbnail-container.icon-list .thumbnail-item.incomplete{border-color:#999}.horz-slider-screen .slider-container .thumbnail-wrapper .thumbnail-container.icon-list .thumbnail-item.incomplete:before{display:none}.horz-slider-screen .slider-container .thumbnail-wrapper .thumbnail-container.icon-list .thumbnail-item.complete{border-color:#39aa27}.horz-slider-screen .slider-container .thumbnail-wrapper .thumbnail-container.icon-list .thumbnail-item.complete:before{display:none}.horz-slider-screen .slider-container .thumbnail-wrapper .thumbnail-container.icon-list .thumbnail-item.complete.active:before{color:inherit!important}.horz-slider-screen .slider-container .thumbnail-wrapper .thumbnail-container.icon-list .thumbnail-item img{position:absolute;top:0;bottom:0;left:0;right:0;margin:auto;height:24px;width:auto}.horz-slider-screen .slider-container .slider-body-content{display:block;position:relative;overflow:hidden;padding:0;height:calc(100% - 40px);overflow-y:auto}.horz-slider-screen .slider-container .slider-body-content.icon-body{height:calc(100% - 60px)}.horz-slider-screen .slider-container .slider-body-content.single-slider{height:100%}.horz-slider-screen .slider-container .slider-body-content .slide-container{display:block;position:absolute;top:0;left:0;width:100%;height:100%}.horz-slider-screen .slider-container .slider-body-content .slide-container .slide{position:absolute;top:0;width:100%;height:100%;z-index:100;padding:16px 24px}.horz-slider-screen .slider-container .slider-body-content .slide-container .slide:first-child{left:0%}.horz-slider-screen .slider-container .slider-body-content .slide-container .slide:nth-child(2){left:100%}.horz-slider-screen .slider-container .slider-body-content .slide-container .slide:nth-child(3){left:200%}.horz-slider-screen .slider-container .slider-body-content .slide-container .slide:nth-child(4){left:300%}.horz-slider-screen .slider-container .slider-body-content .slide-container .slide:nth-child(5){left:400%}.horz-slider-screen .slider-container .slider-body-content .slide-container .slide:nth-child(6){left:500%}.horz-slider-screen .slider-container .slider-body-content .slide-container .slide:nth-child(7){left:600%}.horz-slider-screen .slider-container .slider-body-content .slide-container .slide:nth-child(8){left:700%}.horz-slider-screen .slider-container .slider-body-content .slide-container .slide:nth-child(9){left:800%}.horz-slider-screen .slider-container .slider-body-content .slide-container .slide:nth-child(10){left:900%}.horz-slider-screen .slider-container .slider-body-content .slide-container .slide:nth-child(11){left:1000%}.horz-slider-screen .slider-container .slider-body-content .slide-container .slide:nth-child(12){left:1100%}.horz-slider-screen .slider-container .slider-body-content .slide-container .slide:nth-child(13){left:1200%}.horz-slider-screen .slider-container .slider-body-content .slide-container .slide:nth-child(14){left:1300%}.horz-slider-screen .slider-container .slider-body-content .slide-container .slide:nth-child(15){left:1400%}.horz-slider-screen .slider-container .slider-body-content .slide-container .slide:nth-child(16){left:1500%}.horz-slider-screen .slider-container .slider-body-content .slide-container .slide:nth-child(17){left:1600%}.horz-slider-screen .slider-container .slider-body-content .slide-container .slide:nth-child(18){left:1700%}.horz-slider-screen .slider-container .slider-body-content .slide-container .slide:nth-child(19){left:1800%}.horz-slider-screen .slider-container .slider-body-content .slide-container .slide:nth-child(20){left:1900%}.horz-slider-screen .slider-container .slider-body-content .slide-container .slide:nth-child(21){left:2000%}.horz-slider-screen .slider-container .slider-body-content .slide-container .slide:nth-child(22){left:2100%}.horz-slider-screen .slider-container .slider-body-content .slide-container .slide:nth-child(23){left:2200%}.horz-slider-screen .slider-container .slider-body-content .slide-container .slide:nth-child(24){left:2300%}.horz-slider-screen .slider-container .slider-body-content .slide-container .slide:nth-child(25){left:2400%}.horz-slider-screen .slider-container .slider-body-content .slide-container .slide:nth-child(26){left:2500%}.horz-slider-screen .slider-container .slider-body-content .slide-container .slide:nth-child(27){left:2600%}.horz-slider-screen .slider-container .slider-body-content .slide-container .slide:nth-child(28){left:2700%}.horz-slider-screen .slider-container .slider-body-content .slide-container .slide:nth-child(29){left:2800%}.horz-slider-screen .slider-container .slider-body-content .slide-container .slide:nth-child(30){left:2900%}.horz-slider-screen .slider-container .slider-body-content .slide-container .slide:nth-child(31){left:3000%}.horz-slider-screen .slider-container .slider-body-content .slide-container .slide:nth-child(32){left:3100%}.horz-slider-screen .slider-container .slider-body-content .slide-container .slide:nth-child(33){left:3200%}.horz-slider-screen .slider-container .slider-body-content .slide-container .slide:nth-child(34){left:3300%}.horz-slider-screen .slider-container .slider-body-content .slide-container .slide:nth-child(35){left:3400%}.horz-slider-screen .slider-container .slider-body-content .slide-container .slide:nth-child(36){left:3500%}.horz-slider-screen .slider-container .slider-body-content .slide-container .slide:nth-child(37){left:3600%}.horz-slider-screen .slider-container .slider-body-content .slide-container .slide:nth-child(38){left:3700%}.horz-slider-screen .slider-container .slider-body-content .slide-container .slide:nth-child(39){left:3800%}.horz-slider-screen .slider-container .slider-body-content .slide-container .slide:nth-child(40){left:3900%}.horz-slider-screen .slider-container .slider-body-content .slide-container .slide:nth-child(41){left:4000%}.horz-slider-screen .slider-container .slider-body-content .slide-container .slide:nth-child(42){left:4100%}.horz-slider-screen .slider-container .slider-body-content .slide-container .slide:nth-child(43){left:4200%}.horz-slider-screen .slider-container .slider-body-content .slide-container .slide:nth-child(44){left:4300%}.horz-slider-screen .slider-container .slider-body-content .slide-container .slide:nth-child(45){left:4400%}.horz-slider-screen .slider-container .slider-body-content .slide-container .slide:nth-child(46){left:4500%}.horz-slider-screen .slider-container .slider-body-content .slide-container .slide:nth-child(47){left:4600%}.horz-slider-screen .slider-container .slider-body-content .slide-container .slide:nth-child(48){left:4700%}.horz-slider-screen .slider-container .slider-body-content .slide-container .slide:nth-child(49){left:4800%}.horz-slider-screen .slider-container .slider-body-content .slide-container .slide:nth-child(50){left:4900%}.horz-slider-screen .slider-container .slider-body-content .slide-container .slide .content-wrapper{height:100%;width:100%;margin:0 auto;padding:0;box-shadow:none}.horz-slider-screen .slider-container .slider-body-content .slide-container .slide .content-wrapper .content-area{height:100%;width:100%;margin:0 auto;box-shadow:none}@media only screen and (min-width:768px) and (max-width:1024px) and (orientation:landscape){.horz-slider-screen .slider-container .slider-body-content .slide-container .slide .content-wrapper .content-area{width:100%!important;margin:0!important}}@media only screen and (min-width:768px) and (max-width:1024px) and (orientation:portrait){.horz-slider-screen .slider-container .slider-body-content .slide-container .slide .content-wrapper .content-area{width:100%!important;margin:0!important}}.horz-slider-screen .slider-container .slider-body-content .slide-container .slide .object-feed{box-shadow:none!important;-webkit-box-shadow:none!important;-moz-box-shadow:none!important;position:absolute;bottom:0;max-height:100%;height:auto;padding:10px 0 0!important}@media only screen and (max-width:375px) and (max-height:736px) and (orientation:portrait){.horz-slider-screen .thumbnail-list .thumbnail-item{padding:6px!important;height:40px}.horz-slider-screen .slider-prev-slide-btn{top:16px;left:24px}.horz-slider-screen .slider-next-slide-btn{top:16px;right:24px}.horz-slider-screen .slider-container{height:calc(100% - 24px);width:calc(100% - 24px);margin:12px auto}.horz-slider-screen .slider-container .slider-body-content{display:block;position:relative;overflow:hidden;overflow-y:scroll}.horz-slider-screen .slider-container .slider-body-content .slide{top:0;width:100%;height:50%;overflow-y:scroll;z-index:100}.horz-slider-screen .icon-list{height:45px}.horz-slider-screen .icon-list .thumbnail-list{margin:40px 0 0!important}.horz-slider-screen .icon-list .thumbnail-item{height:24px!important;width:24px!important}.horz-slider-screen .icon-list .thumbnail-item img{height:12px!important}}@media only screen and (max-height:375px) and (max-width:736px) and (orientation:landscape){.horz-slider-screen thumbnail-list .thumbnail-item{padding:6px!important;height:40px}.horz-slider-screen .slider-prev-slide-btn{top:16px;left:24px}.horz-slider-screen .slider-next-slide-btn{top:16px;right:24px}.horz-slider-screen .slider-container{height:calc(100% - 24px);width:calc(100% - 24px);margin:12px auto}.horz-slider-screen .slider-container .slider-body-content{display:block;position:relative;overflow:hidden;overflow-y:scroll}.horz-slider-screen .slider-container .slider-body-content .slide{top:0;width:100%;height:50%;overflow-y:scroll;z-index:100}.horz-slider-screen .icon-list .thumbnail-item{height:36px!important;width:36px!important}.horz-slider-screen .icon-list .thumbnail-item img{height:20px!important}}@media only screen and (min-width:376px) and (max-width:414px) and (max-height:736px) and (orientation:portrait){.horz-slider-screen .thumbnail-list .thumbnail-item{padding:6px!important;height:40px}.horz-slider-screen .slider-prev-slide-btn{top:16px;left:24px}.horz-slider-screen .slider-next-slide-btn{top:16px;right:24px}.horz-slider-screen .slider-container{height:calc(100% - 24px);width:calc(100% - 24px);margin:12px auto}.horz-slider-screen .slider-container .slider-body-content{display:block;position:relative;overflow:hidden;overflow-y:scroll}.horz-slider-screen .slider-container .slider-body-content .slide{top:0;width:100%;height:50%;overflow-y:scroll;z-index:100}.horz-slider-screen .icon-list{height:45px}.horz-slider-screen .icon-list .thumbnail-list{margin:40px 0 0!important}.horz-slider-screen .icon-list .thumbnail-item{height:24px!important;width:24px!important}.horz-slider-screen .icon-list .thumbnail-item img{height:12px!important}}@media only screen and (min-height:376px) and (max-height:414px) and (max-width:736px) and (orientation:landscape){.horz-slider-screen thumbnail-list .thumbnail-item{padding:6px!important;height:40px}.horz-slider-screen .slider-prev-slide-btn{top:16px;left:24px}.horz-slider-screen .slider-next-slide-btn{top:16px;right:24px}.horz-slider-screen .slider-container{height:calc(100% - 24px);width:calc(100% - 24px);margin:12px auto}.horz-slider-screen .slider-container .slider-body-content{display:block;position:relative;overflow:hidden;overflow-y:scroll}.horz-slider-screen .slider-container .slider-body-content .slide{top:0;width:100%;height:50%;overflow-y:scroll;z-index:100}.horz-slider-screen .icon-list .thumbnail-item{height:36px!important;width:36px!important}.horz-slider-screen .icon-list .thumbnail-item img{height:20px!important}}@media only screen and (max-width:375px) and (min-height:737px) and (max-height:812px) and (orientation:portrait){.horz-slider-screen .thumbnail-list .thumbnail-item{padding:6px!important;height:40px}.horz-slider-screen .slider-prev-slide-btn{top:16px;left:24px}.horz-slider-screen .slider-next-slide-btn{top:16px;right:24px}.horz-slider-screen .slider-container{height:calc(100% - 24px);width:calc(100% - 24px);margin:12px auto}.horz-slider-screen .slider-container .slider-body-content{display:block;position:relative;overflow:hidden;overflow-y:scroll}.horz-slider-screen .slider-container .slider-body-content .slide{top:0;width:100%;height:50%;overflow-y:scroll;z-index:100}.horz-slider-screen .icon-list{height:45px}.horz-slider-screen .icon-list .thumbnail-list{margin:40px 0 0!important}.horz-slider-screen .icon-list .thumbnail-item{height:24px!important;width:24px!important}.horz-slider-screen .icon-list .thumbnail-item img{height:12px!important}}@media only screen and (min-height:737px) and (max-height:812px) and (max-width:375px) and (orientation:landscape){.horz-slider-screen thumbnail-list .thumbnail-item{padding:6px!important;height:40px}.horz-slider-screen .slider-prev-slide-btn{top:16px;left:24px}.horz-slider-screen .slider-next-slide-btn{top:16px;right:24px}.horz-slider-screen .slider-container{height:calc(100% - 24px);width:calc(100% - 24px);margin:12px auto}.horz-slider-screen .slider-container .slider-body-content{display:block;position:relative;overflow:hidden;overflow-y:scroll}.horz-slider-screen .slider-container .slider-body-content .slide{top:0;width:100%;height:50%;overflow-y:scroll;z-index:100}.horz-slider-screen .icon-list .thumbnail-item{height:36px!important;width:36px!important}.horz-slider-screen .icon-list .thumbnail-item img{height:20px!important}}@media only screen and (min-width:768px) and (max-width:1024px) and (orientation:landscape){.horz-slider-screen .slider-next-slide-btn{right:15px}.horz-slider-screen .slider-prev-slide-btn{left:15px}}.horz-slider-timeline{display:block;position:relative;overflow:hidden;height:100%}.horz-slider-timeline .slider-prev-slide-btn{cursor:pointer;position:absolute;top:55px;left:100px;transition:opacity .5s ease,color .5s ease;z-index:500}.horz-slider-timeline .slider-prev-slide-btn:after{font-size:24px;display:inline-block;font-family:Guroo-Producer;font-style:normal;font-weight:400;font-variant:normal;line-height:1;text-decoration:inherit;text-rendering:optimizeLegibility;text-transform:none;-moz-osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased;font-smoothing:antialiased;content:\"\\F107\"}.horz-slider-timeline .slider-prev-slide-btn:hover{opacity:.8}.horz-slider-timeline .slider-prev-slide-btn.disabled{cursor:not-allowed}.horz-slider-timeline .slider-prev-slide-btn.disabled:hover{opacity:1}.horz-slider-timeline .slider-prev-slide-btn.disabled:after{color:#999}.horz-slider-timeline .slider-next-slide-btn{cursor:pointer;position:absolute;top:55px;right:100px;transition:opacity .5s ease,color .5s ease;z-index:500}.horz-slider-timeline .slider-next-slide-btn:after{font-size:24px;display:inline-block;font-family:Guroo-Producer;font-style:normal;font-weight:400;font-variant:normal;line-height:1;text-decoration:inherit;text-rendering:optimizeLegibility;text-transform:none;-moz-osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased;font-smoothing:antialiased;content:\"\\F109\"}.horz-slider-timeline .slider-next-slide-btn:hover{opacity:.8}.horz-slider-timeline .slider-next-slide-btn.disabled{cursor:not-allowed}.horz-slider-timeline .slider-next-slide-btn.disabled:hover{opacity:1}.horz-slider-timeline .slider-next-slide-btn.disabled:after{color:#999}.horz-slider-timeline .slider-container{height:calc(100% - 50px);width:calc(100% - 100px);max-width:1100px;margin:30px auto;border-radius:5px;-webkit-box-shadow:0 5px 5px 0 rgba(0,0,0,.25);-moz-box-shadow:0 5px 5px 0 rgba(0,0,0,.25);box-shadow:0 5px 5px 0 rgba(0,0,0,.25);background:#fff;border:1px solid #d5d5d5;overflow:hidden;z-index:400}.horz-slider-timeline .slider-container .thumbnail-wrapper{position:relative;display:block;text-align:center;width:100%;margin:0;padding:0;border-bottom:1px solid #d5d5d5}.horz-slider-timeline .slider-container .thumbnail-wrapper:after{content:\"\";position:absolute;left:calc(50% - 10px);width:0;height:0;border-left:10px solid transparent;border-right:10px solid transparent;border-bottom:10px solid #d5d5d5;bottom:0}.horz-slider-timeline .slider-container .thumbnail-wrapper .thumbnail-container{position:relative;margin:0 auto!important;max-width:900px;width:100%;overflow:hidden;display:block;text-align:center;padding:0;height:75px;display:-webkit-flex;display:flex;flex-flow:row nowrap}.horz-slider-timeline .slider-container .thumbnail-wrapper .thumbnail-container:before{content:\"\";position:absolute;top:0;left:0;height:100%;width:100px;z-index:100;background:-moz-linear-gradient(left,#fff 0,hsla(0,0%,100%,0) 100%);background:-webkit-linear-gradient(left,#fff,hsla(0,0%,100%,0));background:linear-gradient(90deg,#fff 0,hsla(0,0%,100%,0));filter:progid:DXImageTransform.Microsoft.gradient(startColorstr=\"#ffffff\",endColorstr=\"#00ffffff\",GradientType=1)}.horz-slider-timeline .slider-container .thumbnail-wrapper .thumbnail-container:after{content:\"\";position:absolute;top:0;right:0;height:100%;width:100px;z-index:100;background:-moz-linear-gradient(left,hsla(0,0%,100%,0) 0,#fff 100%);background:-webkit-linear-gradient(left,hsla(0,0%,100%,0),#fff);background:linear-gradient(90deg,hsla(0,0%,100%,0) 0,#fff);filter:progid:DXImageTransform.Microsoft.gradient(startColorstr=\"#00ffffff\",endColorstr=\"#ffffff\",GradientType=1)}.horz-slider-timeline .slider-container .thumbnail-wrapper .thumbnail-container .thumbnail-list{position:absolute;z-index:10;width:100%;overflow:visible;display:block;text-align:center;padding:0;margin:0;opacity:0;display:-webkit-flex;display:flex;flex-flow:row nowrap}.horz-slider-timeline .slider-container .thumbnail-wrapper .thumbnail-container .thumbnail-list .thumbnail-item{display:-webkit-flex;display:flex;flex-flow:column nowrap;align-items:center;padding:0;margin:10px 0;opacity:.4;-webkit-backface-visibility:hidden;-webkit-transform:translateZ(0) scale(1);transform:translateZ(0);-webkit-transition:all .3s ease-out;-moz-transition:all .3s ease-out;-o-transition:all .3s ease-out;transition:all .3s ease-out}.horz-slider-timeline .slider-container .thumbnail-wrapper .thumbnail-container .thumbnail-list .thumbnail-item.active{opacity:1}.horz-slider-timeline .slider-container .thumbnail-wrapper .thumbnail-container .thumbnail-list .thumbnail-item:hover{opacity:.9}.horz-slider-timeline .slider-container .thumbnail-wrapper .thumbnail-container .thumbnail-list .thumbnail-item:before{display:none}.horz-slider-timeline .slider-container .thumbnail-wrapper .thumbnail-container .thumbnail-list .thumbnail-item.disabled:hover{cursor:not-allowed;opacity:1}.horz-slider-timeline .slider-container .thumbnail-wrapper .thumbnail-container .thumbnail-list .thumbnail-item.incomplete{border-color:#999}.horz-slider-timeline .slider-container .thumbnail-wrapper .thumbnail-container .thumbnail-list .thumbnail-item.complete{border-color:#39aa27}.horz-slider-timeline .slider-container .thumbnail-wrapper .thumbnail-container .thumbnail-list .thumbnail-item.complete.active:before{color:inherit!important}.horz-slider-timeline .slider-container .thumbnail-wrapper .thumbnail-container .thumbnail-list .thumbnail-item .thumbnail-details{display:-webkit-flex;display:flex;flex-flow:row nowrap;align-items:center;position:relative;padding-right:14px}.horz-slider-timeline .slider-container .thumbnail-wrapper .thumbnail-container .thumbnail-list .thumbnail-item .thumbnail-details:before{left:-16px}.horz-slider-timeline .slider-container .thumbnail-wrapper .thumbnail-container .thumbnail-list .thumbnail-item .thumbnail-details:after,.horz-slider-timeline .slider-container .thumbnail-wrapper .thumbnail-container .thumbnail-list .thumbnail-item .thumbnail-details:before{height:100%;position:absolute;top:calc(50% - 4px);font-size:14px;color:#333;display:inline-block;font-family:Guroo-Producer;font-style:normal;font-weight:400;font-variant:normal;line-height:1;text-decoration:inherit;text-rendering:optimizeLegibility;text-transform:none;-moz-osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased;font-smoothing:antialiased;content:\"\\F179\"}.horz-slider-timeline .slider-container .thumbnail-wrapper .thumbnail-container .thumbnail-list .thumbnail-item .thumbnail-details:after{right:0}.horz-slider-timeline .slider-container .thumbnail-wrapper .thumbnail-container .thumbnail-list .thumbnail-item .thumbnail-details .pre-shape{color:#333}.horz-slider-timeline .slider-container .thumbnail-wrapper .thumbnail-container .thumbnail-list .thumbnail-item .thumbnail-details .pre-shape:before{height:100%;font-size:8px;display:inline-block;font-family:Guroo-Producer;font-style:normal;font-weight:400;font-variant:normal;line-height:1;text-decoration:inherit;text-rendering:optimizeLegibility;text-transform:none;-moz-osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased;font-smoothing:antialiased;content:\"\\F224\" \"\\F224\" \"\\F224\" \"\\F224\" \"\\F224\"}.horz-slider-timeline .slider-container .thumbnail-wrapper .thumbnail-container .thumbnail-list .thumbnail-item .thumbnail-details .post-shape{color:#333}.horz-slider-timeline .slider-container .thumbnail-wrapper .thumbnail-container .thumbnail-list .thumbnail-item .thumbnail-details .post-shape:before{height:100%;font-size:8px;display:inline-block;font-family:Guroo-Producer;font-style:normal;font-weight:400;font-variant:normal;line-height:1;text-decoration:inherit;text-rendering:optimizeLegibility;text-transform:none;-moz-osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased;font-smoothing:antialiased;content:\"\\F224\" \"\\F224\" \"\\F224\" \"\\F224\" \"\\F224\"}.horz-slider-timeline .slider-container .thumbnail-wrapper .thumbnail-container .thumbnail-list .thumbnail-item .thumbnail-details .thumbnail-indicator{position:relative;text-align:center;background:#fff;margin:5px 5px 0;height:30px;width:30px;padding:2px 0;border-radius:50%;border:2px solid #d5d5d5;cursor:pointer;transition:opacity .5s ease,color .5s ease;overflow:hidden}.horz-slider-timeline .slider-container .thumbnail-wrapper .thumbnail-container .thumbnail-list .thumbnail-item .thumbnail-details .thumbnail-indicator img{position:absolute;top:0;bottom:0;left:0;right:0;margin:auto;height:24px;width:auto}.horz-slider-timeline .slider-container .thumbnail-wrapper .thumbnail-container .thumbnail-list .thumbnail-item .thumbnail-label{display:block;width:136px!important;padding-right:14px;text-align:center;font-size:80%;position:relative;overflow:hidden}.horz-slider-timeline .slider-container .thumbnail-wrapper .thumbnail-container .thumbnail-list .thumbnail-item .thumbnail-label a,.horz-slider-timeline .slider-container .thumbnail-wrapper .thumbnail-container .thumbnail-list .thumbnail-item .thumbnail-label div,.horz-slider-timeline .slider-container .thumbnail-wrapper .thumbnail-container .thumbnail-list .thumbnail-item .thumbnail-label h1,.horz-slider-timeline .slider-container .thumbnail-wrapper .thumbnail-container .thumbnail-list .thumbnail-item .thumbnail-label h2,.horz-slider-timeline .slider-container .thumbnail-wrapper .thumbnail-container .thumbnail-list .thumbnail-item .thumbnail-label h3,.horz-slider-timeline .slider-container .thumbnail-wrapper .thumbnail-container .thumbnail-list .thumbnail-item .thumbnail-label h4,.horz-slider-timeline .slider-container .thumbnail-wrapper .thumbnail-container .thumbnail-list .thumbnail-item .thumbnail-label h5,.horz-slider-timeline .slider-container .thumbnail-wrapper .thumbnail-container .thumbnail-list .thumbnail-item .thumbnail-label li,.horz-slider-timeline .slider-container .thumbnail-wrapper .thumbnail-container .thumbnail-list .thumbnail-item .thumbnail-label p,.horz-slider-timeline .slider-container .thumbnail-wrapper .thumbnail-container .thumbnail-list .thumbnail-item .thumbnail-label span{height:100%;width:100%;overflow:hidden;display:block;white-space:nowrap;text-overflow:ellipsis}.horz-slider-timeline .slider-container .thumbnail-wrapper .thumbnail-container .thumbnail-list .thumbnail-item:first-child .pre-shape{color:transparent!important}.horz-slider-timeline .slider-container .thumbnail-wrapper .thumbnail-container .thumbnail-list .thumbnail-item:first-child .thumbnail-details:before{display:none}.horz-slider-timeline .slider-container .thumbnail-wrapper .thumbnail-container .thumbnail-list .thumbnail-item:last-child .post-shape{color:#fff}.horz-slider-timeline .slider-container .thumbnail-wrapper .thumbnail-container .thumbnail-list .thumbnail-item:last-child .thumbnail-details:after{display:none}.horz-slider-timeline .slider-container .thumbnail-wrapper .thumbnail-container .thumbnail-list .thumbnail-item.incomplete .thumbnail-indicator:before{text-align:center;color:#999;content:\"\\F16A\"}.horz-slider-timeline .slider-container .thumbnail-wrapper .thumbnail-container .thumbnail-list .thumbnail-item.complete .thumbnail-indicator:before,.horz-slider-timeline .slider-container .thumbnail-wrapper .thumbnail-container .thumbnail-list .thumbnail-item.incomplete .thumbnail-indicator:before{font-size:18px;display:inline-block;font-family:Guroo-Producer;font-style:normal;font-weight:400;font-variant:normal;line-height:1;text-decoration:inherit;text-rendering:optimizeLegibility;text-transform:none;-moz-osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased;font-smoothing:antialiased}.horz-slider-timeline .slider-container .thumbnail-wrapper .thumbnail-container .thumbnail-list .thumbnail-item.complete .thumbnail-indicator:before{color:#39aa27;content:\"\\F16F\"}.horz-slider-timeline .slider-container .thumbnail-wrapper .thumbnail-container.icon-list{height:95px}.horz-slider-timeline .slider-container .thumbnail-wrapper .thumbnail-container.icon-list .thumbnail-item.incomplete .thumbnail-indicator:before{display:none}.horz-slider-timeline .slider-container .thumbnail-wrapper .thumbnail-container.icon-list .thumbnail-item.complete .thumbnail-indicator{border-color:#39aa27}.horz-slider-timeline .slider-container .thumbnail-wrapper .thumbnail-container.icon-list .thumbnail-item.complete .thumbnail-indicator:before{display:none}.horz-slider-timeline .slider-container .thumbnail-wrapper .thumbnail-container.icon-list .thumbnail-item .thumbnail-indicator{position:relative;text-align:center;background:#fff;margin:0 5px;height:48px!important;width:48px!important;padding:4px 2px;border-radius:50%;border:2px solid #d5d5d5;cursor:pointer;transition:opacity .5s ease,color .5s ease;overflow:hidden}.horz-slider-timeline .slider-container .thumbnail-wrapper .thumbnail-container.icon-list .thumbnail-item .thumbnail-indicator img{position:absolute;top:0;bottom:0;left:0;right:0;margin:auto;height:24px;width:auto}.horz-slider-timeline .slider-container .thumbnail-wrapper .thumbnail-container.icon-list .thumbnail-item .thumbnail-label{min-width:154px!important}.horz-slider-timeline .slider-container .slider-body-content{display:block;position:relative;overflow:hidden;padding:0;height:calc(100% - 40px);overflow-y:auto}.horz-slider-timeline .slider-container .slider-body-content.icon-body{height:calc(100% - 95px)}.horz-slider-timeline .slider-container .slider-body-content.single-slider{height:100%}.horz-slider-timeline .slider-container .slider-body-content .slide-container{display:block;position:absolute;top:0;left:0;width:100%;height:100%}.horz-slider-timeline .slider-container .slider-body-content .slide-container .slide{position:absolute;top:0;width:100%;height:100%;z-index:100;padding:16px 24px}.horz-slider-timeline .slider-container .slider-body-content .slide-container .slide:first-child{left:0%}.horz-slider-timeline .slider-container .slider-body-content .slide-container .slide:nth-child(2){left:100%}.horz-slider-timeline .slider-container .slider-body-content .slide-container .slide:nth-child(3){left:200%}.horz-slider-timeline .slider-container .slider-body-content .slide-container .slide:nth-child(4){left:300%}.horz-slider-timeline .slider-container .slider-body-content .slide-container .slide:nth-child(5){left:400%}.horz-slider-timeline .slider-container .slider-body-content .slide-container .slide:nth-child(6){left:500%}.horz-slider-timeline .slider-container .slider-body-content .slide-container .slide:nth-child(7){left:600%}.horz-slider-timeline .slider-container .slider-body-content .slide-container .slide:nth-child(8){left:700%}.horz-slider-timeline .slider-container .slider-body-content .slide-container .slide:nth-child(9){left:800%}.horz-slider-timeline .slider-container .slider-body-content .slide-container .slide:nth-child(10){left:900%}.horz-slider-timeline .slider-container .slider-body-content .slide-container .slide:nth-child(11){left:1000%}.horz-slider-timeline .slider-container .slider-body-content .slide-container .slide:nth-child(12){left:1100%}.horz-slider-timeline .slider-container .slider-body-content .slide-container .slide:nth-child(13){left:1200%}.horz-slider-timeline .slider-container .slider-body-content .slide-container .slide:nth-child(14){left:1300%}.horz-slider-timeline .slider-container .slider-body-content .slide-container .slide:nth-child(15){left:1400%}.horz-slider-timeline .slider-container .slider-body-content .slide-container .slide:nth-child(16){left:1500%}.horz-slider-timeline .slider-container .slider-body-content .slide-container .slide:nth-child(17){left:1600%}.horz-slider-timeline .slider-container .slider-body-content .slide-container .slide:nth-child(18){left:1700%}.horz-slider-timeline .slider-container .slider-body-content .slide-container .slide:nth-child(19){left:1800%}.horz-slider-timeline .slider-container .slider-body-content .slide-container .slide:nth-child(20){left:1900%}.horz-slider-timeline .slider-container .slider-body-content .slide-container .slide:nth-child(21){left:2000%}.horz-slider-timeline .slider-container .slider-body-content .slide-container .slide:nth-child(22){left:2100%}.horz-slider-timeline .slider-container .slider-body-content .slide-container .slide:nth-child(23){left:2200%}.horz-slider-timeline .slider-container .slider-body-content .slide-container .slide:nth-child(24){left:2300%}.horz-slider-timeline .slider-container .slider-body-content .slide-container .slide:nth-child(25){left:2400%}.horz-slider-timeline .slider-container .slider-body-content .slide-container .slide:nth-child(26){left:2500%}.horz-slider-timeline .slider-container .slider-body-content .slide-container .slide:nth-child(27){left:2600%}.horz-slider-timeline .slider-container .slider-body-content .slide-container .slide:nth-child(28){left:2700%}.horz-slider-timeline .slider-container .slider-body-content .slide-container .slide:nth-child(29){left:2800%}.horz-slider-timeline .slider-container .slider-body-content .slide-container .slide:nth-child(30){left:2900%}.horz-slider-timeline .slider-container .slider-body-content .slide-container .slide:nth-child(31){left:3000%}.horz-slider-timeline .slider-container .slider-body-content .slide-container .slide:nth-child(32){left:3100%}.horz-slider-timeline .slider-container .slider-body-content .slide-container .slide:nth-child(33){left:3200%}.horz-slider-timeline .slider-container .slider-body-content .slide-container .slide:nth-child(34){left:3300%}.horz-slider-timeline .slider-container .slider-body-content .slide-container .slide:nth-child(35){left:3400%}.horz-slider-timeline .slider-container .slider-body-content .slide-container .slide:nth-child(36){left:3500%}.horz-slider-timeline .slider-container .slider-body-content .slide-container .slide:nth-child(37){left:3600%}.horz-slider-timeline .slider-container .slider-body-content .slide-container .slide:nth-child(38){left:3700%}.horz-slider-timeline .slider-container .slider-body-content .slide-container .slide:nth-child(39){left:3800%}.horz-slider-timeline .slider-container .slider-body-content .slide-container .slide:nth-child(40){left:3900%}.horz-slider-timeline .slider-container .slider-body-content .slide-container .slide:nth-child(41){left:4000%}.horz-slider-timeline .slider-container .slider-body-content .slide-container .slide:nth-child(42){left:4100%}.horz-slider-timeline .slider-container .slider-body-content .slide-container .slide:nth-child(43){left:4200%}.horz-slider-timeline .slider-container .slider-body-content .slide-container .slide:nth-child(44){left:4300%}.horz-slider-timeline .slider-container .slider-body-content .slide-container .slide:nth-child(45){left:4400%}.horz-slider-timeline .slider-container .slider-body-content .slide-container .slide:nth-child(46){left:4500%}.horz-slider-timeline .slider-container .slider-body-content .slide-container .slide:nth-child(47){left:4600%}.horz-slider-timeline .slider-container .slider-body-content .slide-container .slide:nth-child(48){left:4700%}.horz-slider-timeline .slider-container .slider-body-content .slide-container .slide:nth-child(49){left:4800%}.horz-slider-timeline .slider-container .slider-body-content .slide-container .slide:nth-child(50){left:4900%}.horz-slider-timeline .slider-container .slider-body-content .slide-container .slide .content-wrapper{height:100%;width:100%;margin:0 auto;padding:0;box-shadow:none}.horz-slider-timeline .slider-container .slider-body-content .slide-container .slide .content-wrapper .content-area{height:100%;width:100%;margin:0 auto;box-shadow:none}@media only screen and (min-width:768px) and (max-width:1024px) and (orientation:landscape){.horz-slider-timeline .slider-container .slider-body-content .slide-container .slide .content-wrapper .content-area{width:100%!important;margin:0!important}}@media only screen and (min-width:768px) and (max-width:1024px) and (orientation:portrait){.horz-slider-timeline .slider-container .slider-body-content .slide-container .slide .content-wrapper .content-area{width:100%!important;margin:0!important}}.horz-slider-timeline .slider-container .slider-body-content .slide-container .slide .object-feed{box-shadow:none!important;-webkit-box-shadow:none!important;-moz-box-shadow:none!important;position:absolute;bottom:0;max-height:100%;height:auto;padding:10px 0 0!important}@media only screen and (max-width:375px) and (max-height:736px) and (orientation:portrait){.horz-slider-timeline .slider-container{margin:10px auto;height:calc(100% - 20px);width:calc(100% - 20px);overflow:hidden}.horz-slider-timeline .slider-prev-slide-btn{top:40px;left:24px}.horz-slider-timeline .slider-next-slide-btn{top:40px;right:24px}.horz-slider-timeline .thumbnail-container,.horz-slider-timeline .thumbnail-wrapper{border-top-left-radius:5px;border-top-right-radius:5px}}@media only screen and (max-height:375px) and (max-width:736px) and (orientation:landscape){.horz-slider-timeline .slider-container{margin:10px auto;height:calc(100% - 20px);width:calc(100% - 20px);overflow:hidden}.horz-slider-timeline .slider-prev-slide-btn{top:40px;left:24px}.horz-slider-timeline .slider-next-slide-btn{top:40px;right:24px}.horz-slider-timeline .thumbnail-container,.horz-slider-timeline .thumbnail-wrapper{border-top-left-radius:5px;border-top-right-radius:5px}}@media only screen and (min-width:376px) and (max-width:414px) and (max-height:736px) and (orientation:portrait){.horz-slider-timeline .slider-container{margin:10px auto;height:calc(100% - 20px);width:calc(100% - 20px);overflow:hidden}.horz-slider-timeline .slider-prev-slide-btn{top:40px;left:24px}.horz-slider-timeline .slider-next-slide-btn{top:40px;right:24px}.horz-slider-timeline .thumbnail-container,.horz-slider-timeline .thumbnail-wrapper{border-top-left-radius:5px;border-top-right-radius:5px}}@media only screen and (min-height:376px) and (max-height:414px) and (max-width:736px) and (orientation:landscape){.horz-slider-timeline .slider-container{margin:10px auto;height:calc(100% - 20px);width:calc(100% - 20px);overflow:hidden}.horz-slider-timeline .slider-prev-slide-btn{top:40px;left:24px}.horz-slider-timeline .slider-next-slide-btn{top:40px;right:24px}.horz-slider-timeline .thumbnail-container,.horz-slider-timeline .thumbnail-wrapper{border-top-left-radius:5px;border-top-right-radius:5px}}@media only screen and (max-width:375px) and (min-height:737px) and (max-height:812px) and (orientation:portrait){.horz-slider-timeline .slider-container{margin:10px auto;height:calc(100% - 20px);width:calc(100% - 20px);overflow:hidden}.horz-slider-timeline .slider-prev-slide-btn{top:40px;left:24px}.horz-slider-timeline .slider-next-slide-btn{top:40px;right:24px}.horz-slider-timeline .thumbnail-container,.horz-slider-timeline .thumbnail-wrapper{border-top-left-radius:5px;border-top-right-radius:5px}}@media only screen and (min-height:737px) and (max-height:812px) and (max-width:375px) and (orientation:landscape){.horz-slider-timeline .slider-container{margin:10px auto;height:calc(100% - 20px);width:calc(100% - 20px);overflow:hidden}.horz-slider-timeline .slider-prev-slide-btn{top:40px;left:24px}.horz-slider-timeline .slider-next-slide-btn{top:40px;right:24px}.horz-slider-timeline .thumbnail-container,.horz-slider-timeline .thumbnail-wrapper{border-top-left-radius:5px;border-top-right-radius:5px}}@media only screen and (min-width:768px) and (max-width:1024px) and (orientation:landscape){.horz-slider-timeline .slider-next-slide-btn{right:15px}.horz-slider-timeline .slider-prev-slide-btn{left:15px}}.flex-row{display:flex;flex-direction:row;flex-wrap:nowrap;justify-content:center;align-items:center;align-content:center}.flex-row .flex-item{flex:1;padding:4px;margin:auto;text-align:center}.flex-row .flex-item .flex-item{padding:0}.click-reveal-hot-spot .hot-spot-container{display:block;position:relative;margin-bottom:20px}.click-reveal-hot-spot .hot-spot-container .hot-spot-btn{position:absolute;top:0;left:0;cursor:pointer}.click-reveal-hot-spot .hot-spot-container .hot-spot-btn .btn-label{position:relative;text-align:center;line-height:110%}.click-reveal-hot-spot .hot-spot-container .hot-spot-btn:before{font-size:100%;content:\"\\F175\"}.click-reveal-hot-spot .hot-spot-container .hot-spot-btn.complete:before,.click-reveal-hot-spot .hot-spot-container .hot-spot-btn:before{position:absolute;top:5px;left:-18px;display:inline-block;font-family:Guroo-Producer;font-style:normal;font-weight:400;font-variant:normal;line-height:1;text-decoration:inherit;text-rendering:optimizeLegibility;text-transform:none;-moz-osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased;font-smoothing:antialiased}.click-reveal-hot-spot .hot-spot-container .hot-spot-btn.complete:before{content:\"\\F16F\"}.save-message{display:block;position:relative;padding:15px 24px 15px 60px;margin:0 0 20px}.save-message:before{position:absolute;top:10px;left:15px;display:inline-block;font-family:Guroo-Producer;font-style:normal;font-weight:400;font-variant:normal;line-height:1;text-decoration:inherit;text-rendering:optimizeLegibility;text-transform:none;-moz-osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased;font-smoothing:antialiased;font-size:32px;content:\"\\F1CA\"}.user-response-panel{margin-bottom:20px;display:block;position:relative;overflow:hidden}.user-response-panel .question-label{display:block;color:#333;font-weight:700;font-style:italic}.user-response-panel .response{padding:0 0 0 20px}.paragraph-content-wrapper{display:-webkit-flex;display:flex;flex-flow:row nowrap}.paragraph-content-wrapper h4{font-weight:700!important}.paragraph-content-wrapper .content-column{text-align:left;flex:1}.paragraph-content-wrapper.left-asset .asset-column{padding:5px}.paragraph-content-wrapper.left-asset .asset-column .asset-image-wrapper{position:relative;margin:5px 30px 0 0}.paragraph-content-wrapper.left-asset .asset-column .asset-image-wrapper img{height:auto;max-height:unset;width:auto;max-width:100%}.paragraph-content-wrapper.left-asset .asset-column .asset-image-wrapper.border{background:#fff;border:2px solid #d5d5d5}.paragraph-content-wrapper.left-asset .asset-column .asset-image-wrapper.padded_border{background:#fff;border:2px solid #d5d5d5;padding:4px}.paragraph-content-wrapper.left-asset .asset-column .asset-image-wrapper.padded_shadow,.paragraph-content-wrapper.left-asset .asset-column .asset-image-wrapper.shadow{background:#fff;-webkit-box-shadow:0 2px 5px 0 rgba(0,0,0,.5);-moz-box-shadow:0 2px 5px 0 rgba(0,0,0,.5);box-shadow:0 2px 5px 0 rgba(0,0,0,.5)}.paragraph-content-wrapper.left-asset .asset-column .asset-image-wrapper.padded_shadow{padding:4px}.paragraph-content-wrapper.left-asset .asset-column .asset-image-wrapper.square{display:block;overflow:hidden!important;position:relative}.paragraph-content-wrapper.left-asset .asset-column .asset-image-wrapper.square:before{display:block;content:\"\";width:100%!important;padding-top:100%}.paragraph-content-wrapper.left-asset .asset-column .asset-image-wrapper.square img{position:absolute;top:0;left:0}.paragraph-content-wrapper.left-asset .asset-column .asset-image-wrapper.square.landscape img{width:auto!important;max-width:unset!important;height:auto!important;max-height:100%!important}.paragraph-content-wrapper.left-asset .asset-column .asset-image-wrapper.square.portrait img{height:auto!important;max-height:unset!important;width:auto!important;max-width:100%!important}.paragraph-content-wrapper.left-asset .asset-column .asset-image-wrapper.square.left img,.paragraph-content-wrapper.left-asset .asset-column .asset-image-wrapper.square.top img{top:0;left:0}.paragraph-content-wrapper.left-asset .asset-column .asset-image-wrapper.square.center img{top:0;left:50%;-webkit-transform:translateX(-50%);transform:translateX(-50%)}.paragraph-content-wrapper.left-asset .asset-column .asset-image-wrapper.square.right img{top:0;left:100%;-webkit-transform:translateX(-100%);transform:translateX(-100%)}.paragraph-content-wrapper.left-asset .asset-column .asset-image-wrapper.square.middle img{left:0;top:50%;-webkit-transform:translateY(-50%);transform:translateY(-50%)}.paragraph-content-wrapper.left-asset .asset-column .asset-image-wrapper.square.bottom img{top:100%;-webkit-transform:translateY(-100%);transform:translateY(-100%);left:0}.paragraph-content-wrapper.left-asset .asset-column .asset-image-wrapper.square.padded_border:after,.paragraph-content-wrapper.left-asset .asset-column .asset-image-wrapper.square.padded_shadow:after{position:absolute;left:0;top:0;width:100%;height:100%;border:4px solid #fff;content:\"\"}.paragraph-content-wrapper.left-asset .asset-column .asset-image-wrapper.rectangle{display:block;overflow:hidden!important}.paragraph-content-wrapper.left-asset .asset-column .asset-image-wrapper.rectangle img{position:absolute;top:0;left:0}.paragraph-content-wrapper.left-asset .asset-column .asset-image-wrapper.rectangle.landscape{position:relative}.paragraph-content-wrapper.left-asset .asset-column .asset-image-wrapper.rectangle.landscape:before{display:block;content:\"\";width:100%!important;padding-top:133.33333%}.paragraph-content-wrapper.left-asset .asset-column .asset-image-wrapper.rectangle.landscape img{width:auto;max-width:unset;height:auto;max-height:100%}.paragraph-content-wrapper.left-asset .asset-column .asset-image-wrapper.rectangle.portrait{position:relative}.paragraph-content-wrapper.left-asset .asset-column .asset-image-wrapper.rectangle.portrait:before{display:block;content:\"\";width:100%!important;padding-top:75%}.paragraph-content-wrapper.left-asset .asset-column .asset-image-wrapper.rectangle.portrait img{height:auto;max-height:unset;width:auto;max-width:100%}.paragraph-content-wrapper.left-asset .asset-column .asset-image-wrapper.rectangle.left img,.paragraph-content-wrapper.left-asset .asset-column .asset-image-wrapper.rectangle.top img{top:0;left:0}.paragraph-content-wrapper.left-asset .asset-column .asset-image-wrapper.rectangle.center img{top:0;left:50%;-webkit-transform:translateX(-50%);transform:translateX(-50%)}.paragraph-content-wrapper.left-asset .asset-column .asset-image-wrapper.rectangle.right img{top:0;left:100%;-webkit-transform:translateX(-100%);transform:translateX(-100%)}.paragraph-content-wrapper.left-asset .asset-column .asset-image-wrapper.rectangle.middle img{left:0;top:50%;-webkit-transform:translateY(-50%);transform:translateY(-50%)}.paragraph-content-wrapper.left-asset .asset-column .asset-image-wrapper.rectangle.bottom img{top:100%;-webkit-transform:translateY(-100%);transform:translateY(-100%);left:0}.paragraph-content-wrapper.left-asset .asset-column .asset-image-wrapper.rectangle.padded_border:after,.paragraph-content-wrapper.left-asset .asset-column .asset-image-wrapper.rectangle.padded_shadow:after{position:absolute;left:0;top:0;width:100%;height:100%;border:4px solid #fff;content:\"\"}.paragraph-content-wrapper.left-asset .asset-column .asset-image-wrapper.circle{display:block;overflow:hidden!important;position:relative;border-radius:50%;background:#fff}.paragraph-content-wrapper.left-asset .asset-column .asset-image-wrapper.circle:before{display:block;content:\"\";width:100%!important;padding-top:100%}.paragraph-content-wrapper.left-asset .asset-column .asset-image-wrapper.circle img{position:absolute}.paragraph-content-wrapper.left-asset .asset-column .asset-image-wrapper.circle.padded_border:after,.paragraph-content-wrapper.left-asset .asset-column .asset-image-wrapper.circle.padded_shadow:after{border-radius:50%}.paragraph-content-wrapper.left-asset .asset-column .asset-image-wrapper.circle.landscape img{width:auto!important;max-width:unset!important;height:auto!important;max-height:100%!important}.paragraph-content-wrapper.left-asset .asset-column .asset-image-wrapper.circle.portrait img{height:auto!important;max-height:unset!important;width:auto!important;max-width:100%!important}.paragraph-content-wrapper.left-asset .asset-column .asset-image-wrapper.circle.left img,.paragraph-content-wrapper.left-asset .asset-column .asset-image-wrapper.circle.top img{top:0;left:0}.paragraph-content-wrapper.left-asset .asset-column .asset-image-wrapper.circle.center img{top:0;left:50%;-webkit-transform:translateX(-50%);transform:translateX(-50%)}.paragraph-content-wrapper.left-asset .asset-column .asset-image-wrapper.circle.right img{top:0;left:100%;-webkit-transform:translateX(-100%);transform:translateX(-100%)}.paragraph-content-wrapper.left-asset .asset-column .asset-image-wrapper.circle.middle img{left:0;top:50%;-webkit-transform:translateY(-50%);transform:translateY(-50%)}.paragraph-content-wrapper.left-asset .asset-column .asset-image-wrapper.circle.bottom img{top:100%;-webkit-transform:translateY(-100%);transform:translateY(-100%);left:0}.paragraph-content-wrapper.left-asset .asset-column .asset-image-wrapper.circle.padded_border:after,.paragraph-content-wrapper.left-asset .asset-column .asset-image-wrapper.circle.padded_shadow:after{position:absolute;left:0;top:0;width:100%;height:100%;border:4px solid #fff;content:\"\"}.paragraph-content-wrapper.left-asset .asset-column .image-credit{margin:0 30px 0 0}.paragraph-content-wrapper.left-asset.icon .asset-column{width:90px;overflow:hidden;display:block;margin:0 30px 0 0}.paragraph-content-wrapper.left-asset.icon .asset-column img{width:100%;display:block;min-height:90px;height:auto}.paragraph-content-wrapper.left-asset.icon .content-column{display:block;width:calc(100% - 120px)}.paragraph-content-wrapper.left-asset.image .asset-column{overflow:hidden;display:block;max-width:40%;margin:5px 30px 0 0}.paragraph-content-wrapper.left-asset.image .asset-column .object-container{padding:0;margin:0}.paragraph-content-wrapper.left-asset.image .asset-column img{width:100%;max-width:100%;display:block;height:auto}.paragraph-content-wrapper.left-asset.image .content-column{display:block}@media only screen and (max-width:736px) and (orientation:portrait){.paragraph-content-wrapper.left-asset{display:-webkit-flex!important;display:flex!important;flex-flow:column wrap!important}.paragraph-content-wrapper.left-asset.icon{display:block!important}.paragraph-content-wrapper.left-asset.icon .asset-column{width:100%!important;max-width:100%;text-align:center;margin:0 0 20px;float:none}.paragraph-content-wrapper.left-asset.icon .asset-column img{max-width:80px;display:inline-block;min-height:80px;height:auto}.paragraph-content-wrapper.left-asset.icon .content-column{display:block!important;clear:both!important;width:100%!important}.paragraph-content-wrapper.left-asset.image{display:block!important}.paragraph-content-wrapper.left-asset.image .asset-column{width:100%!important;max-width:100%;text-align:center;margin:0 0 10px;float:none}.paragraph-content-wrapper.left-asset.image .asset-column .object-container{padding:0;margin:0}.paragraph-content-wrapper.left-asset.image .asset-column img{max-width:100%;max-height:250px;width:auto;height:auto}.paragraph-content-wrapper.left-asset.image .content-column{display:block!important;clear:both!important;width:100%!important}.paragraph-content-wrapper.left-asset .asset-image-wrapper{margin:0 auto!important}}@media only screen and (max-width:375px) and (max-height:736px) and (orientation:portrait){.paragraph-content-wrapper.left-asset{display:-webkit-flex!important;display:flex!important;flex-flow:column wrap!important}.paragraph-content-wrapper.left-asset.icon{display:block!important}.paragraph-content-wrapper.left-asset.icon .asset-column{width:100%!important;max-width:100%;text-align:center;margin:0 0 20px;float:none}.paragraph-content-wrapper.left-asset.icon .asset-column img{max-width:80px;display:inline-block;min-height:80px;height:auto}.paragraph-content-wrapper.left-asset.icon .content-column{display:block!important;clear:both!important;width:100%!important}.paragraph-content-wrapper.left-asset.image{display:block!important}.paragraph-content-wrapper.left-asset.image .asset-column{width:100%!important;max-width:100%;text-align:center;margin:0 0 10px;float:none}.paragraph-content-wrapper.left-asset.image .asset-column .object-container{padding:0;margin:0}.paragraph-content-wrapper.left-asset.image .asset-column img{max-width:100%;max-height:250px;width:auto;height:auto}.paragraph-content-wrapper.left-asset.image .content-column{display:block!important;clear:both!important;width:100%!important}.paragraph-content-wrapper.left-asset .asset-image-wrapper{margin:0 auto!important}}@media only screen and (min-width:376px) and (max-width:414px) and (max-height:736px) and (orientation:portrait){.paragraph-content-wrapper.left-asset{display:-webkit-flex!important;display:flex!important;flex-flow:column wrap!important}.paragraph-content-wrapper.left-asset.icon{display:block!important}.paragraph-content-wrapper.left-asset.icon .asset-column{width:100%!important;max-width:100%;text-align:center;margin:0 0 20px;float:none}.paragraph-content-wrapper.left-asset.icon .asset-column img{max-width:80px;display:inline-block;min-height:80px;height:auto}.paragraph-content-wrapper.left-asset.icon .content-column{display:block!important;clear:both!important;width:100%!important}.paragraph-content-wrapper.left-asset.image{display:block!important}.paragraph-content-wrapper.left-asset.image .asset-column{width:100%!important;max-width:100%;text-align:center;margin:0 0 10px;float:none}.paragraph-content-wrapper.left-asset.image .asset-column .object-container{padding:0;margin:0}.paragraph-content-wrapper.left-asset.image .asset-column img{max-width:100%;max-height:250px;width:auto;height:auto}.paragraph-content-wrapper.left-asset.image .content-column{display:block!important;clear:both!important;width:100%!important}.paragraph-content-wrapper.left-asset .asset-image-wrapper{margin:0 auto!important}}@media only screen and (max-width:375px) and (min-height:737px) and (max-height:812px) and (orientation:portrait){.paragraph-content-wrapper.left-asset{display:-webkit-flex!important;display:flex!important;flex-flow:column wrap!important}.paragraph-content-wrapper.left-asset.icon{display:block!important}.paragraph-content-wrapper.left-asset.icon .asset-column{width:100%!important;max-width:100%;text-align:center;margin:0 0 20px;float:none}.paragraph-content-wrapper.left-asset.icon .asset-column img{max-width:80px;display:inline-block;min-height:80px;height:auto}.paragraph-content-wrapper.left-asset.icon .content-column{display:block!important;clear:both!important;width:100%!important}.paragraph-content-wrapper.left-asset.image{display:block!important}.paragraph-content-wrapper.left-asset.image .asset-column{width:100%!important;max-width:100%;text-align:center;margin:0 0 10px;float:none}.paragraph-content-wrapper.left-asset.image .asset-column .object-container{padding:0;margin:0}.paragraph-content-wrapper.left-asset.image .asset-column img{max-width:100%;max-height:250px;width:auto;height:auto}.paragraph-content-wrapper.left-asset.image .content-column{display:block!important;clear:both!important;width:100%!important}.paragraph-content-wrapper.left-asset .asset-image-wrapper{margin:0 auto!important}}.paragraph-content-wrapper.right-asset .asset-column{padding:5px}.paragraph-content-wrapper.right-asset .asset-column .asset-image-wrapper{position:relative;margin:5px 0 0 30px}.paragraph-content-wrapper.right-asset .asset-column .asset-image-wrapper img{height:auto;max-height:unset;width:auto;max-width:100%}.paragraph-content-wrapper.right-asset .asset-column .asset-image-wrapper.border{background:#fff;border:2px solid #d5d5d5}.paragraph-content-wrapper.right-asset .asset-column .asset-image-wrapper.padded_border{background:#fff;border:2px solid #d5d5d5;padding:4px}.paragraph-content-wrapper.right-asset .asset-column .asset-image-wrapper.padded_shadow,.paragraph-content-wrapper.right-asset .asset-column .asset-image-wrapper.shadow{background:#fff;-webkit-box-shadow:0 2px 5px 0 rgba(0,0,0,.5);-moz-box-shadow:0 2px 5px 0 rgba(0,0,0,.5);box-shadow:0 2px 5px 0 rgba(0,0,0,.5)}.paragraph-content-wrapper.right-asset .asset-column .asset-image-wrapper.padded_shadow{padding:4px}.paragraph-content-wrapper.right-asset .asset-column .asset-image-wrapper.square{display:block;overflow:hidden!important;position:relative}.paragraph-content-wrapper.right-asset .asset-column .asset-image-wrapper.square:before{display:block;content:\"\";width:100%!important;padding-top:100%}.paragraph-content-wrapper.right-asset .asset-column .asset-image-wrapper.square img{position:absolute;top:0;left:0}.paragraph-content-wrapper.right-asset .asset-column .asset-image-wrapper.square.landscape img{width:auto!important;max-width:unset!important;height:auto!important;max-height:100%!important}.paragraph-content-wrapper.right-asset .asset-column .asset-image-wrapper.square.portrait img{height:auto!important;max-height:unset!important;width:auto!important;max-width:100%!important}.paragraph-content-wrapper.right-asset .asset-column .asset-image-wrapper.square.left img,.paragraph-content-wrapper.right-asset .asset-column .asset-image-wrapper.square.top img{top:0;left:0}.paragraph-content-wrapper.right-asset .asset-column .asset-image-wrapper.square.center img{top:0;left:50%;-webkit-transform:translateX(-50%);transform:translateX(-50%)}.paragraph-content-wrapper.right-asset .asset-column .asset-image-wrapper.square.right img{top:0;left:100%;-webkit-transform:translateX(-100%);transform:translateX(-100%)}.paragraph-content-wrapper.right-asset .asset-column .asset-image-wrapper.square.middle img{left:0;top:50%;-webkit-transform:translateY(-50%);transform:translateY(-50%)}.paragraph-content-wrapper.right-asset .asset-column .asset-image-wrapper.square.bottom img{top:100%;-webkit-transform:translateY(-100%);transform:translateY(-100%);left:0}.paragraph-content-wrapper.right-asset .asset-column .asset-image-wrapper.square.padded_border:after,.paragraph-content-wrapper.right-asset .asset-column .asset-image-wrapper.square.padded_shadow:after{position:absolute;left:0;top:0;width:100%;height:100%;border:4px solid #fff;content:\"\"}.paragraph-content-wrapper.right-asset .asset-column .asset-image-wrapper.rectangle{display:block;overflow:hidden!important}.paragraph-content-wrapper.right-asset .asset-column .asset-image-wrapper.rectangle img{position:absolute;top:0;left:0}.paragraph-content-wrapper.right-asset .asset-column .asset-image-wrapper.rectangle.landscape{position:relative}.paragraph-content-wrapper.right-asset .asset-column .asset-image-wrapper.rectangle.landscape:before{display:block;content:\"\";width:100%!important;padding-top:133.33333%}.paragraph-content-wrapper.right-asset .asset-column .asset-image-wrapper.rectangle.landscape img{width:auto;max-width:unset;height:auto;max-height:100%}.paragraph-content-wrapper.right-asset .asset-column .asset-image-wrapper.rectangle.portrait{position:relative}.paragraph-content-wrapper.right-asset .asset-column .asset-image-wrapper.rectangle.portrait:before{display:block;content:\"\";width:100%!important;padding-top:75%}.paragraph-content-wrapper.right-asset .asset-column .asset-image-wrapper.rectangle.portrait img{height:auto;max-height:unset;width:auto;max-width:100%}.paragraph-content-wrapper.right-asset .asset-column .asset-image-wrapper.rectangle.left img,.paragraph-content-wrapper.right-asset .asset-column .asset-image-wrapper.rectangle.top img{top:0;left:0}.paragraph-content-wrapper.right-asset .asset-column .asset-image-wrapper.rectangle.center img{top:0;left:50%;-webkit-transform:translateX(-50%);transform:translateX(-50%)}.paragraph-content-wrapper.right-asset .asset-column .asset-image-wrapper.rectangle.right img{top:0;left:100%;-webkit-transform:translateX(-100%);transform:translateX(-100%)}.paragraph-content-wrapper.right-asset .asset-column .asset-image-wrapper.rectangle.middle img{left:0;top:50%;-webkit-transform:translateY(-50%);transform:translateY(-50%)}.paragraph-content-wrapper.right-asset .asset-column .asset-image-wrapper.rectangle.bottom img{top:100%;-webkit-transform:translateY(-100%);transform:translateY(-100%);left:0}.paragraph-content-wrapper.right-asset .asset-column .asset-image-wrapper.rectangle.padded_border:after,.paragraph-content-wrapper.right-asset .asset-column .asset-image-wrapper.rectangle.padded_shadow:after{position:absolute;left:0;top:0;width:100%;height:100%;border:4px solid #fff;content:\"\"}.paragraph-content-wrapper.right-asset .asset-column .asset-image-wrapper.circle{display:block;overflow:hidden!important;position:relative;border-radius:50%;background:#fff}.paragraph-content-wrapper.right-asset .asset-column .asset-image-wrapper.circle:before{display:block;content:\"\";width:100%!important;padding-top:100%}.paragraph-content-wrapper.right-asset .asset-column .asset-image-wrapper.circle img{position:absolute}.paragraph-content-wrapper.right-asset .asset-column .asset-image-wrapper.circle.padded_border:after,.paragraph-content-wrapper.right-asset .asset-column .asset-image-wrapper.circle.padded_shadow:after{border-radius:50%}.paragraph-content-wrapper.right-asset .asset-column .asset-image-wrapper.circle.landscape img{width:auto!important;max-width:unset!important;height:auto!important;max-height:100%!important}.paragraph-content-wrapper.right-asset .asset-column .asset-image-wrapper.circle.portrait img{height:auto!important;max-height:unset!important;width:auto!important;max-width:100%!important}.paragraph-content-wrapper.right-asset .asset-column .asset-image-wrapper.circle.left img,.paragraph-content-wrapper.right-asset .asset-column .asset-image-wrapper.circle.top img{top:0;left:0}.paragraph-content-wrapper.right-asset .asset-column .asset-image-wrapper.circle.center img{top:0;left:50%;-webkit-transform:translateX(-50%);transform:translateX(-50%)}.paragraph-content-wrapper.right-asset .asset-column .asset-image-wrapper.circle.right img{top:0;left:100%;-webkit-transform:translateX(-100%);transform:translateX(-100%)}.paragraph-content-wrapper.right-asset .asset-column .asset-image-wrapper.circle.middle img{left:0;top:50%;-webkit-transform:translateY(-50%);transform:translateY(-50%)}.paragraph-content-wrapper.right-asset .asset-column .asset-image-wrapper.circle.bottom img{top:100%;-webkit-transform:translateY(-100%);transform:translateY(-100%);left:0}.paragraph-content-wrapper.right-asset .asset-column .asset-image-wrapper.circle.padded_border:after,.paragraph-content-wrapper.right-asset .asset-column .asset-image-wrapper.circle.padded_shadow:after{position:absolute;left:0;top:0;width:100%;height:100%;border:4px solid #fff;content:\"\"}.paragraph-content-wrapper.right-asset .asset-column .image-credit{margin:5px 0 0 30px}.paragraph-content-wrapper.right-asset.icon .asset-column{width:120px;overflow:hidden;display:block;margin:0 0 0 30px}.paragraph-content-wrapper.right-asset.icon .asset-column img{width:90px;display:block;min-height:90px;height:auto}.paragraph-content-wrapper.right-asset.icon .content-column{display:block;width:calc(100% - 120px)}.paragraph-content-wrapper.right-asset.image .asset-column{overflow:hidden;display:block;max-width:40%;margin:0 0 0 30px}.paragraph-content-wrapper.right-asset.image .asset-column .object-container{padding:0;margin:0}.paragraph-content-wrapper.right-asset.image .asset-column img{width:100%;max-width:100%;display:block;height:auto}.paragraph-content-wrapper.right-asset.image .content-column{display:block}@media only screen and (max-width:736px) and (orientation:portrait){.paragraph-content-wrapper.right-asset{display:-webkit-flex!important;display:flex!important;flex-flow:column wrap!important}.paragraph-content-wrapper.right-asset.icon{display:block!important}.paragraph-content-wrapper.right-asset.icon .asset-column{width:100%!important;text-align:center;margin:20px 0 0!important}.paragraph-content-wrapper.right-asset.icon .asset-column img{max-width:80px;display:inline-block;min-height:80px;height:auto}.paragraph-content-wrapper.right-asset.icon .content-column{display:block!important;clear:both!important;width:100%!important}.paragraph-content-wrapper.right-asset.image{display:block!important}.paragraph-content-wrapper.right-asset.image .asset-column{width:100%!important;max-width:100%;text-align:center;margin:10px 0;float:none}.paragraph-content-wrapper.right-asset.image .asset-column .object-container{padding:0;margin:0}.paragraph-content-wrapper.right-asset.image .asset-column img{max-width:100%;max-height:250px;width:100%;height:auto}.paragraph-content-wrapper.right-asset.image .content-column{display:block!important;clear:both!important;width:100%!important}.paragraph-content-wrapper.right-asset .asset-image-wrapper{margin:0 auto!important}}@media only screen and (max-width:375px) and (max-height:736px) and (orientation:portrait){.paragraph-content-wrapper.right-asset{display:-webkit-flex!important;display:flex!important;flex-flow:column wrap!important}.paragraph-content-wrapper.right-asset.icon{display:block!important}.paragraph-content-wrapper.right-asset.icon .asset-column{width:100%!important;text-align:center;margin:20px 0 0!important}.paragraph-content-wrapper.right-asset.icon .asset-column img{max-width:80px;display:inline-block;min-height:80px;height:auto}.paragraph-content-wrapper.right-asset.icon .content-column{display:block!important;clear:both!important;width:100%!important}.paragraph-content-wrapper.right-asset.image{display:block!important}.paragraph-content-wrapper.right-asset.image .asset-column{width:100%!important;max-width:100%;text-align:center;margin:10px 0;float:none}.paragraph-content-wrapper.right-asset.image .asset-column .object-container{padding:0;margin:0}.paragraph-content-wrapper.right-asset.image .asset-column img{max-width:100%;max-height:250px;width:100%;height:auto}.paragraph-content-wrapper.right-asset.image .content-column{display:block!important;clear:both!important;width:100%!important}.paragraph-content-wrapper.right-asset .asset-image-wrapper{margin:0 auto!important}}@media only screen and (min-width:376px) and (max-width:414px) and (max-height:736px) and (orientation:portrait){.paragraph-content-wrapper.right-asset{display:-webkit-flex!important;display:flex!important;flex-flow:column wrap!important}.paragraph-content-wrapper.right-asset.icon{display:block!important}.paragraph-content-wrapper.right-asset.icon .asset-column{width:100%!important;text-align:center;margin:20px 0 0!important}.paragraph-content-wrapper.right-asset.icon .asset-column img{max-width:80px;display:inline-block;min-height:80px;height:auto}.paragraph-content-wrapper.right-asset.icon .content-column{display:block!important;clear:both!important;width:100%!important}.paragraph-content-wrapper.right-asset.image{display:block!important}.paragraph-content-wrapper.right-asset.image .asset-column{width:100%!important;max-width:100%;text-align:center;margin:10px 0;float:none}.paragraph-content-wrapper.right-asset.image .asset-column .object-container{padding:0;margin:0}.paragraph-content-wrapper.right-asset.image .asset-column img{max-width:100%;max-height:250px;width:100%;height:auto}.paragraph-content-wrapper.right-asset.image .content-column{display:block!important;clear:both!important;width:100%!important}.paragraph-content-wrapper.right-asset .asset-image-wrapper{margin:0 auto!important}}@media only screen and (max-width:375px) and (min-height:737px) and (max-height:812px) and (orientation:portrait){.paragraph-content-wrapper.right-asset{display:-webkit-flex!important;display:flex!important;flex-flow:column wrap!important}.paragraph-content-wrapper.right-asset.icon{display:block!important}.paragraph-content-wrapper.right-asset.icon .asset-column{width:100%!important;text-align:center;margin:20px 0 0!important}.paragraph-content-wrapper.right-asset.icon .asset-column img{max-width:80px;display:inline-block;min-height:80px;height:auto}.paragraph-content-wrapper.right-asset.icon .content-column{display:block!important;clear:both!important;width:100%!important}.paragraph-content-wrapper.right-asset.image{display:block!important}.paragraph-content-wrapper.right-asset.image .asset-column{width:100%!important;max-width:100%;text-align:center;margin:10px 0;float:none}.paragraph-content-wrapper.right-asset.image .asset-column .object-container{padding:0;margin:0}.paragraph-content-wrapper.right-asset.image .asset-column img{max-width:100%;max-height:250px;width:100%;height:auto}.paragraph-content-wrapper.right-asset.image .content-column{display:block!important;clear:both!important;width:100%!important}.paragraph-content-wrapper.right-asset .asset-image-wrapper{margin:0 auto!important}}.paragraph-content-wrapper.top-asset{display:block}.paragraph-content-wrapper.top-asset .content-column{display:block!important;width:100%!important;clear:both!important}.paragraph-content-wrapper.top-asset .asset-column{width:100%;text-align:center;margin:0 0 20px!important;padding:5px}.paragraph-content-wrapper.top-asset .asset-column .asset-image-wrapper{margin:0 auto;position:relative}.paragraph-content-wrapper.top-asset .asset-column .asset-image-wrapper img{height:auto;max-height:unset;width:auto;max-width:100%}.paragraph-content-wrapper.top-asset .asset-column .asset-image-wrapper.border{background:#fff;border:2px solid #d5d5d5}.paragraph-content-wrapper.top-asset .asset-column .asset-image-wrapper.padded_border{background:#fff;border:2px solid #d5d5d5;padding:4px}.paragraph-content-wrapper.top-asset .asset-column .asset-image-wrapper.padded_shadow,.paragraph-content-wrapper.top-asset .asset-column .asset-image-wrapper.shadow{background:#fff;-webkit-box-shadow:0 2px 5px 0 rgba(0,0,0,.5);-moz-box-shadow:0 2px 5px 0 rgba(0,0,0,.5);box-shadow:0 2px 5px 0 rgba(0,0,0,.5)}.paragraph-content-wrapper.top-asset .asset-column .asset-image-wrapper.padded_shadow{padding:4px}.paragraph-content-wrapper.top-asset .asset-column .asset-image-wrapper.square{display:block;overflow:hidden!important;position:relative}.paragraph-content-wrapper.top-asset .asset-column .asset-image-wrapper.square:before{display:block;content:\"\";width:100%!important;padding-top:100%}.paragraph-content-wrapper.top-asset .asset-column .asset-image-wrapper.square img{position:absolute;top:0;left:0}.paragraph-content-wrapper.top-asset .asset-column .asset-image-wrapper.square.landscape img{width:auto!important;max-width:unset!important;height:auto!important;max-height:100%!important}.paragraph-content-wrapper.top-asset .asset-column .asset-image-wrapper.square.portrait img{height:auto!important;max-height:unset!important;width:auto!important;max-width:100%!important}.paragraph-content-wrapper.top-asset .asset-column .asset-image-wrapper.square.left img,.paragraph-content-wrapper.top-asset .asset-column .asset-image-wrapper.square.top img{top:0;left:0}.paragraph-content-wrapper.top-asset .asset-column .asset-image-wrapper.square.center img{top:0;left:50%;-webkit-transform:translateX(-50%);transform:translateX(-50%)}.paragraph-content-wrapper.top-asset .asset-column .asset-image-wrapper.square.right img{top:0;left:100%;-webkit-transform:translateX(-100%);transform:translateX(-100%)}.paragraph-content-wrapper.top-asset .asset-column .asset-image-wrapper.square.middle img{left:0;top:50%;-webkit-transform:translateY(-50%);transform:translateY(-50%)}.paragraph-content-wrapper.top-asset .asset-column .asset-image-wrapper.square.bottom img{top:100%;-webkit-transform:translateY(-100%);transform:translateY(-100%);left:0}.paragraph-content-wrapper.top-asset .asset-column .asset-image-wrapper.square.padded_border:after,.paragraph-content-wrapper.top-asset .asset-column .asset-image-wrapper.square.padded_shadow:after{position:absolute;left:0;top:0;width:100%;height:100%;border:4px solid #fff;content:\"\"}.paragraph-content-wrapper.top-asset .asset-column .asset-image-wrapper.rectangle{display:block;overflow:hidden!important}.paragraph-content-wrapper.top-asset .asset-column .asset-image-wrapper.rectangle img{position:absolute;top:0;left:0}.paragraph-content-wrapper.top-asset .asset-column .asset-image-wrapper.rectangle.landscape{position:relative}.paragraph-content-wrapper.top-asset .asset-column .asset-image-wrapper.rectangle.landscape:before{display:block;content:\"\";width:100%!important;padding-top:133.33333%}.paragraph-content-wrapper.top-asset .asset-column .asset-image-wrapper.rectangle.landscape img{width:auto;max-width:unset;height:auto;max-height:100%}.paragraph-content-wrapper.top-asset .asset-column .asset-image-wrapper.rectangle.portrait{position:relative}.paragraph-content-wrapper.top-asset .asset-column .asset-image-wrapper.rectangle.portrait:before{display:block;content:\"\";width:100%!important;padding-top:75%}.paragraph-content-wrapper.top-asset .asset-column .asset-image-wrapper.rectangle.portrait img{height:auto;max-height:unset;width:auto;max-width:100%}.paragraph-content-wrapper.top-asset .asset-column .asset-image-wrapper.rectangle.left img,.paragraph-content-wrapper.top-asset .asset-column .asset-image-wrapper.rectangle.top img{top:0;left:0}.paragraph-content-wrapper.top-asset .asset-column .asset-image-wrapper.rectangle.center img{top:0;left:50%;-webkit-transform:translateX(-50%);transform:translateX(-50%)}.paragraph-content-wrapper.top-asset .asset-column .asset-image-wrapper.rectangle.right img{top:0;left:100%;-webkit-transform:translateX(-100%);transform:translateX(-100%)}.paragraph-content-wrapper.top-asset .asset-column .asset-image-wrapper.rectangle.middle img{left:0;top:50%;-webkit-transform:translateY(-50%);transform:translateY(-50%)}.paragraph-content-wrapper.top-asset .asset-column .asset-image-wrapper.rectangle.bottom img{top:100%;-webkit-transform:translateY(-100%);transform:translateY(-100%);left:0}.paragraph-content-wrapper.top-asset .asset-column .asset-image-wrapper.rectangle.padded_border:after,.paragraph-content-wrapper.top-asset .asset-column .asset-image-wrapper.rectangle.padded_shadow:after{position:absolute;left:0;top:0;width:100%;height:100%;border:4px solid #fff;content:\"\"}.paragraph-content-wrapper.top-asset .asset-column .asset-image-wrapper.circle{display:block;overflow:hidden!important;position:relative;border-radius:50%;background:#fff}.paragraph-content-wrapper.top-asset .asset-column .asset-image-wrapper.circle:before{display:block;content:\"\";width:100%!important;padding-top:100%}.paragraph-content-wrapper.top-asset .asset-column .asset-image-wrapper.circle img{position:absolute}.paragraph-content-wrapper.top-asset .asset-column .asset-image-wrapper.circle.padded_border:after,.paragraph-content-wrapper.top-asset .asset-column .asset-image-wrapper.circle.padded_shadow:after{border-radius:50%}.paragraph-content-wrapper.top-asset .asset-column .asset-image-wrapper.circle.landscape img{width:auto!important;max-width:unset!important;height:auto!important;max-height:100%!important}.paragraph-content-wrapper.top-asset .asset-column .asset-image-wrapper.circle.portrait img{height:auto!important;max-height:unset!important;width:auto!important;max-width:100%!important}.paragraph-content-wrapper.top-asset .asset-column .asset-image-wrapper.circle.left img,.paragraph-content-wrapper.top-asset .asset-column .asset-image-wrapper.circle.top img{top:0;left:0}.paragraph-content-wrapper.top-asset .asset-column .asset-image-wrapper.circle.center img{top:0;left:50%;-webkit-transform:translateX(-50%);transform:translateX(-50%)}.paragraph-content-wrapper.top-asset .asset-column .asset-image-wrapper.circle.right img{top:0;left:100%;-webkit-transform:translateX(-100%);transform:translateX(-100%)}.paragraph-content-wrapper.top-asset .asset-column .asset-image-wrapper.circle.middle img{left:0;top:50%;-webkit-transform:translateY(-50%);transform:translateY(-50%)}.paragraph-content-wrapper.top-asset .asset-column .asset-image-wrapper.circle.bottom img{top:100%;-webkit-transform:translateY(-100%);transform:translateY(-100%);left:0}.paragraph-content-wrapper.top-asset .asset-column .asset-image-wrapper.circle.padded_border:after,.paragraph-content-wrapper.top-asset .asset-column .asset-image-wrapper.circle.padded_shadow:after{position:absolute;left:0;top:0;width:100%;height:100%;border:4px solid #fff;content:\"\"}.paragraph-content-wrapper.top-asset .asset-column .image-credit{margin:0 auto}.paragraph-content-wrapper.top-asset.icon .asset-column{display:block!important;width:100%!important;clear:both!important;height:120px;text-align:center;margin:0 0 20px}.paragraph-content-wrapper.top-asset.icon .asset-column img{width:120px;display:inline-block;height:120px}.paragraph-content-wrapper.top-asset.icon .kpi-column{width:100%;text-align:center;margin:15px 0 0 5px}.paragraph-content-wrapper.top-asset.image{width:100%;text-align:center}.paragraph-content-wrapper.top-asset.image .object-container{padding:0;margin:0}.paragraph-content-wrapper.top-asset.image .asset-column{width:100%;text-align:center;margin:0}.paragraph-content-wrapper.top-asset.image .asset-column img{max-height:300px;width:auto;height:auto}.paragraph-content-wrapper.bottom-asset{display:block}.paragraph-content-wrapper.bottom-asset .content-column{display:block!important;width:100%!important;clear:both!important}.paragraph-content-wrapper.bottom-asset .asset-column{width:100%;text-align:center;margin:20px 0 0;padding:5px}.paragraph-content-wrapper.bottom-asset .asset-column .asset-image-wrapper{margin:0 auto;position:relative}.paragraph-content-wrapper.bottom-asset .asset-column .asset-image-wrapper img{height:auto;max-height:unset;width:auto;max-width:100%}.paragraph-content-wrapper.bottom-asset .asset-column .asset-image-wrapper.border{background:#fff;border:2px solid #d5d5d5}.paragraph-content-wrapper.bottom-asset .asset-column .asset-image-wrapper.padded_border{background:#fff;border:2px solid #d5d5d5;padding:4px}.paragraph-content-wrapper.bottom-asset .asset-column .asset-image-wrapper.padded_shadow,.paragraph-content-wrapper.bottom-asset .asset-column .asset-image-wrapper.shadow{background:#fff;-webkit-box-shadow:0 2px 5px 0 rgba(0,0,0,.5);-moz-box-shadow:0 2px 5px 0 rgba(0,0,0,.5);box-shadow:0 2px 5px 0 rgba(0,0,0,.5)}.paragraph-content-wrapper.bottom-asset .asset-column .asset-image-wrapper.padded_shadow{padding:4px}.paragraph-content-wrapper.bottom-asset .asset-column .asset-image-wrapper.square{display:block;overflow:hidden!important;position:relative}.paragraph-content-wrapper.bottom-asset .asset-column .asset-image-wrapper.square:before{display:block;content:\"\";width:100%!important;padding-top:100%}.paragraph-content-wrapper.bottom-asset .asset-column .asset-image-wrapper.square img{position:absolute;top:0;left:0}.paragraph-content-wrapper.bottom-asset .asset-column .asset-image-wrapper.square.landscape img{width:auto!important;max-width:unset!important;height:auto!important;max-height:100%!important}.paragraph-content-wrapper.bottom-asset .asset-column .asset-image-wrapper.square.portrait img{height:auto!important;max-height:unset!important;width:auto!important;max-width:100%!important}.paragraph-content-wrapper.bottom-asset .asset-column .asset-image-wrapper.square.left img,.paragraph-content-wrapper.bottom-asset .asset-column .asset-image-wrapper.square.top img{top:0;left:0}.paragraph-content-wrapper.bottom-asset .asset-column .asset-image-wrapper.square.center img{top:0;left:50%;-webkit-transform:translateX(-50%);transform:translateX(-50%)}.paragraph-content-wrapper.bottom-asset .asset-column .asset-image-wrapper.square.right img{top:0;left:100%;-webkit-transform:translateX(-100%);transform:translateX(-100%)}.paragraph-content-wrapper.bottom-asset .asset-column .asset-image-wrapper.square.middle img{left:0;top:50%;-webkit-transform:translateY(-50%);transform:translateY(-50%)}.paragraph-content-wrapper.bottom-asset .asset-column .asset-image-wrapper.square.bottom img{top:100%;-webkit-transform:translateY(-100%);transform:translateY(-100%);left:0}.paragraph-content-wrapper.bottom-asset .asset-column .asset-image-wrapper.square.padded_border:after,.paragraph-content-wrapper.bottom-asset .asset-column .asset-image-wrapper.square.padded_shadow:after{position:absolute;left:0;top:0;width:100%;height:100%;border:4px solid #fff;content:\"\"}.paragraph-content-wrapper.bottom-asset .asset-column .asset-image-wrapper.rectangle{display:block;overflow:hidden!important}.paragraph-content-wrapper.bottom-asset .asset-column .asset-image-wrapper.rectangle img{position:absolute;top:0;left:0}.paragraph-content-wrapper.bottom-asset .asset-column .asset-image-wrapper.rectangle.landscape{position:relative}.paragraph-content-wrapper.bottom-asset .asset-column .asset-image-wrapper.rectangle.landscape:before{display:block;content:\"\";width:100%!important;padding-top:133.33333%}.paragraph-content-wrapper.bottom-asset .asset-column .asset-image-wrapper.rectangle.landscape img{width:auto;max-width:unset;height:auto;max-height:100%}.paragraph-content-wrapper.bottom-asset .asset-column .asset-image-wrapper.rectangle.portrait{position:relative}.paragraph-content-wrapper.bottom-asset .asset-column .asset-image-wrapper.rectangle.portrait:before{display:block;content:\"\";width:100%!important;padding-top:75%}.paragraph-content-wrapper.bottom-asset .asset-column .asset-image-wrapper.rectangle.portrait img{height:auto;max-height:unset;width:auto;max-width:100%}.paragraph-content-wrapper.bottom-asset .asset-column .asset-image-wrapper.rectangle.left img,.paragraph-content-wrapper.bottom-asset .asset-column .asset-image-wrapper.rectangle.top img{top:0;left:0}.paragraph-content-wrapper.bottom-asset .asset-column .asset-image-wrapper.rectangle.center img{top:0;left:50%;-webkit-transform:translateX(-50%);transform:translateX(-50%)}.paragraph-content-wrapper.bottom-asset .asset-column .asset-image-wrapper.rectangle.right img{top:0;left:100%;-webkit-transform:translateX(-100%);transform:translateX(-100%)}.paragraph-content-wrapper.bottom-asset .asset-column .asset-image-wrapper.rectangle.middle img{left:0;top:50%;-webkit-transform:translateY(-50%);transform:translateY(-50%)}.paragraph-content-wrapper.bottom-asset .asset-column .asset-image-wrapper.rectangle.bottom img{top:100%;-webkit-transform:translateY(-100%);transform:translateY(-100%);left:0}.paragraph-content-wrapper.bottom-asset .asset-column .asset-image-wrapper.rectangle.padded_border:after,.paragraph-content-wrapper.bottom-asset .asset-column .asset-image-wrapper.rectangle.padded_shadow:after{position:absolute;left:0;top:0;width:100%;height:100%;border:4px solid #fff;content:\"\"}.paragraph-content-wrapper.bottom-asset .asset-column .asset-image-wrapper.circle{display:block;overflow:hidden!important;position:relative;border-radius:50%;background:#fff}.paragraph-content-wrapper.bottom-asset .asset-column .asset-image-wrapper.circle:before{display:block;content:\"\";width:100%!important;padding-top:100%}.paragraph-content-wrapper.bottom-asset .asset-column .asset-image-wrapper.circle img{position:absolute}.paragraph-content-wrapper.bottom-asset .asset-column .asset-image-wrapper.circle.padded_border:after,.paragraph-content-wrapper.bottom-asset .asset-column .asset-image-wrapper.circle.padded_shadow:after{border-radius:50%}.paragraph-content-wrapper.bottom-asset .asset-column .asset-image-wrapper.circle.landscape img{width:auto!important;max-width:unset!important;height:auto!important;max-height:100%!important}.paragraph-content-wrapper.bottom-asset .asset-column .asset-image-wrapper.circle.portrait img{height:auto!important;max-height:unset!important;width:auto!important;max-width:100%!important}.paragraph-content-wrapper.bottom-asset .asset-column .asset-image-wrapper.circle.left img,.paragraph-content-wrapper.bottom-asset .asset-column .asset-image-wrapper.circle.top img{top:0;left:0}.paragraph-content-wrapper.bottom-asset .asset-column .asset-image-wrapper.circle.center img{top:0;left:50%;-webkit-transform:translateX(-50%);transform:translateX(-50%)}.paragraph-content-wrapper.bottom-asset .asset-column .asset-image-wrapper.circle.right img{top:0;left:100%;-webkit-transform:translateX(-100%);transform:translateX(-100%)}.paragraph-content-wrapper.bottom-asset .asset-column .asset-image-wrapper.circle.middle img{left:0;top:50%;-webkit-transform:translateY(-50%);transform:translateY(-50%)}.paragraph-content-wrapper.bottom-asset .asset-column .asset-image-wrapper.circle.bottom img{top:100%;-webkit-transform:translateY(-100%);transform:translateY(-100%);left:0}.paragraph-content-wrapper.bottom-asset .asset-column .asset-image-wrapper.circle.padded_border:after,.paragraph-content-wrapper.bottom-asset .asset-column .asset-image-wrapper.circle.padded_shadow:after{position:absolute;left:0;top:0;width:100%;height:100%;border:4px solid #fff;content:\"\"}.paragraph-content-wrapper.bottom-asset .asset-column .image-credit{margin:0 auto}.paragraph-content-wrapper.bottom-asset.icon .asset-column{display:block!important;width:100%!important;clear:both!important;height:120px;text-align:center;margin:20px 0 0}.paragraph-content-wrapper.bottom-asset.icon .asset-column img{width:120px;display:inline-block;height:120px}.paragraph-content-wrapper.bottom-asset.image .asset-column{width:100%;text-align:center;margin:20px 0 0}.paragraph-content-wrapper.bottom-asset.image .asset-column .object-container{padding:0;margin:0}.paragraph-content-wrapper.bottom-asset.image .asset-column img{max-height:300px;width:auto;height:auto}.paragraph-content-wrapper_{display:table;position:relative;overflow:hidden;margin:0;padding:0}.paragraph-content-wrapper_.has-icon .icon-column{display:table-cell;width:120px;vertical-align:top}.paragraph-content-wrapper_.has-icon .icon-column img{width:90px;display:block;min-height:90px;height:auto}.paragraph-content-wrapper_.has-icon .content-column{display:table-cell;vertical-align:top}.menu-panel-list{display:block;margin:0;padding:0}.menu-panel-list .panel-item{display:block;list-style-type:none;margin:0 0 10px;padding:0}.menu-panel{display:table;width:100%;overflow:hidden;position:relative;border-radius:5px;margin-bottom:5px;background:#fff;-webkit-box-shadow:0 2px 5px 0 rgba(0,0,0,.25);-moz-box-shadow:0 2px 5px 0 rgba(0,0,0,.25);box-shadow:0 2px 5px 0 rgba(0,0,0,.25);border:none}.menu-panel:focus,.menu-panel:hover{opacity:.95}.menu-panel.disabled{-webkit-filter:grayscale(90%);filter:grayscale(90%)}.menu-panel.disabled:hover{opacity:1;cursor:not-allowed!important}.menu-panel.disabled .content-container{background:#eff0f2}.menu-panel.disabled .content-container:hover{cursor:not-allowed!important}.menu-panel .icon-container{display:table-cell;box-sizing:border-box;width:80px!important;max-width:80px;padding:10px;border-top-left-radius:2px;border-bottom-left-radius:2px}.menu-panel .icon-container img{max-height:60px;height:100%;width:auto;margin:0 auto}.menu-panel .icon-container.not-started{background:#999}.menu-panel .icon-container.in-progress{background:#f6ad17}.menu-panel .icon-container.complete{background:#39aa27}.menu-panel .icon-container.not-required{background:#6592cb}.menu-panel .content-container{display:table-cell;padding:8px 12px;vertical-align:middle;box-sizing:border-box;background:#fff;cursor:pointer;width:calc(100% - 80px);border-top-right-radius:3px;border-bottom-right-radius:3px}.menu-panel .content-container .bite-title{position:relative;overflow:hidden}.menu-panel .content-container .bite-title .sur-title{padding:0 0 0 24px;text-transform:uppercase;color:#999;font-size:90%}.menu-panel .content-container .bite-title .title{display:block;position:relative;overflow:hidden;font-weight:700;padding:0 0 0 24px;line-height:110%}.menu-panel .content-container .bite-title .title:before{position:absolute;top:2px;left:0;height:16px;font-size:16px}.menu-panel .content-container .bite-title .title.not-required:before{color:#999;content:\"\"}.menu-panel .content-container .bite-title .title.not-required:before,.menu-panel .content-container .bite-title .title.not-started:before{padding-right:8px;display:inline-block;font-family:Guroo-Producer;font-style:normal;font-weight:400;font-variant:normal;line-height:1;text-decoration:inherit;text-rendering:optimizeLegibility;text-transform:none;-moz-osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased;font-smoothing:antialiased}.menu-panel .content-container .bite-title .title.not-started:before{content:\"\\F16A\"}.menu-panel .content-container .bite-title .title.in-progress:before{content:\"\\F182\"}.menu-panel .content-container .bite-title .title.complete:before,.menu-panel .content-container .bite-title .title.in-progress:before{display:inline-block;font-family:Guroo-Producer;font-style:normal;font-weight:400;font-variant:normal;line-height:1;text-decoration:inherit;text-rendering:optimizeLegibility;text-transform:none;-moz-osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased;font-smoothing:antialiased}.menu-panel .content-container .bite-title .title.complete:before{content:\"\\F16F\"}.menu-panel .content-container .required{margin:0 10px;color:#fff;font-size:11px;text-transform:uppercase;font-weight:700;padding:4px 8px;border-radius:3px}.menu-panel .content-container .description{font-size:80%;padding:5px 0 0 24px;color:#999}.menu-panel .kpi-meter-container,.menu-panel .thumbnail-badge-container{position:relative;display:block;float:right}.menu-panel .thumbnail-badge-container{padding:5px 0 10px 10px}.menu-panel .thumbnail-badge-container .achievement-badge-item:first-child:last-child,.menu-panel .thumbnail-badge-container .badge-grid-item:only-child{margin-left:0!important}.menu-panel .thumbnail-badge-container .badge{width:70px;height:70px;margin-bottom:0}.menu-panel .thumbnail-badge-container .badge .badge-container:before{font-size:70px}.menu-panel .thumbnail-badge-container .badge .badge-label{padding:6px 2px}.menu-panel .thumbnail-badge-container .image-badge{width:74px;height:74px;margin-bottom:0}.badge-details{color:#333}.inline-block{display:inline-block}.note-panel{margin:0 0 10px;overflow:hidden}.note-panel .note-title{position:relative;padding:6px 15px 6px 44px;font-weight:700}.note-panel .note-title:before{top:7px;left:15px;font-size:20px;content:\"\\F1C3\"}.note-panel .note-title:after,.note-panel .note-title:before{position:absolute;display:inline-block;font-family:Guroo-Producer;font-style:normal;font-weight:400;font-variant:normal;line-height:1;text-decoration:inherit;text-rendering:optimizeLegibility;text-transform:none;-moz-osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased;font-smoothing:antialiased}.note-panel .note-title:after{top:6px;right:10px;font-size:18px;content:\"\\F11E\"}.note-panel .note-content{padding:10px 20px}.note-panel:hover{cursor:pointer}.content-table{width:100%}.content-table td{padding:8px 0}.content-table td.horz-padding{padding-left:15px}.icon-link{padding:4px 0 0 30px}.icon-link img{position:absolute;width:24px;height:auto;top:-10px;left:0}.swipe-container{display:block;clear:both;position:relative;outline:0!important}.swipe-container .swipe-bg{display:block;background:#eff0f2;padding:16px 24px}.swipe-container .swipe-bg .swipe{position:relative!important;margin-bottom:10px;display:-webkit-flex;display:flex;flex-flow:column nowrap;justify-content:center;align-items:center;min-height:200px}.swipe-container .swipe-bg .swipe .feedback-panel{width:100%!important}.swipe-container .swipe-bg .swipe .swipe-card{transition:color .3s ease-in,background .3s ease-in,width .3s ease-in,height .3s ease-in,border .3s ease-in;position:relative;vertical-align:middle}.swipe-container .swipe-bg .swipe .swipe-card.draggable{flex:1;text-align:center;width:33%;left:0;right:0;margin:auto;background:#fff;border:2px solid #999;padding:16px 24px;height:inherit;border-radius:5px;-webkit-box-shadow:5px 5px 5px 0 rgba(0,0,0,.5);-moz-box-shadow:5px 5px 5px 0 rgba(0,0,0,.5);box-shadow:5px 5px 5px 0 rgba(0,0,0,.5);cursor:hand;display:-webkit-flex;display:flex;flex-flow:row nowrap;justify-content:center;align-items:center}.swipe-container .swipe-bg .swipe .swipe-card .swipe-card-content{flex:1}.swipe-container .swipe-bg .swipe .swipe-options-list{margin:0;padding:0;position:absolute;height:100%;width:100%;display:flex;justify-content:space-between;flex-wrap:wrap;overflow:hidden;border:2px dashed #999;border-radius:5px}.swipe-container .swipe-bg .swipe .swipe-options-list input{display:none}.swipe-container .swipe-bg .swipe .swipe-options-list .multiple-choice-option{width:34%;list-style-type:none;padding:8px 12px;overflow:hidden;position:relative;margin-bottom:0;text-align:center}.swipe-container .swipe-bg .swipe .swipe-options-list .multiple-choice-option label{overflow:hidden;display:block;position:absolute;top:0;width:100%;height:100%;padding-top:20%}.swipe-container .swipe-bg .swipe .swipe-options-list .multiple-choice-option:first-child{margin-left:0}.swipe-container .swipe-bg .swipe .swipe-options-list .multiple-choice-option:first-child label{left:0}.swipe-container .swipe-bg .swipe .swipe-options-list .multiple-choice-option:first-child label:before{padding-top:5px;overflow:hidden;position:relative;display:inline-block;font-family:Guroo-Producer;font-style:normal;font-weight:400;font-variant:normal;line-height:1;text-decoration:inherit;text-rendering:optimizeLegibility;text-transform:none;-moz-osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased;font-smoothing:antialiased;font-size:60px;content:\"\\F12B\"}.swipe-container .swipe-bg .swipe .swipe-options-list .multiple-choice-option:last-child label{right:0}.swipe-container .swipe-bg .swipe .swipe-options-list .multiple-choice-option:last-child label:before{position:relative;overflow:hidden;padding-top:5px;display:inline-block;font-family:Guroo-Producer;font-style:normal;font-weight:400;font-variant:normal;line-height:1;text-decoration:inherit;text-rendering:optimizeLegibility;text-transform:none;-moz-osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased;font-smoothing:antialiased;font-size:60px;content:\"\\F13B\"}.swipe-container .swipe-bg .swipe .swipe-options-list .multiple-choice-option.active label{color:#fff!important}.swipe-container .swipe-bg .swipe .swipe-options-list .multiple-choice-option:hover{cursor:pointer}.swipe-container .swipe-bg .swipe .swipe-options-list .multiple-choice-option:hover label{color:#fff!important}.swipe-container .swipe-bg .swipe .multiple-choice-option-list{width:100%}.swipe-container .swipe-bg.no-padding{background:transparent;padding:0}.swipe-container .swipe-bg.no-padding .swipe{min-height:0}@media only screen and (max-width:375px) and (max-height:736px) and (orientation:portrait){.swipe-container .swipe-bg{padding:10px 12px}.swipe-container .swipe-bg .swipe-card{transition:color .3s ease-in,background .3s ease-in,width .3s ease-in,height .3s ease-in,border .3s ease-in;position:relative}.swipe-container .swipe-bg .swipe-card.draggable{width:40%!important}}@media only screen and (min-width:376px) and (max-width:414px) and (max-height:736px) and (orientation:portrait){.swipe-container .swipe-bg{padding:10px 12px}.swipe-container .swipe-bg .swipe-card{transition:color .3s ease-in,background .3s ease-in,width .3s ease-in,height .3s ease-in,border .3s ease-in;position:relative}.swipe-container .swipe-bg .swipe-card.draggable{width:40%!important}}@media only screen and (max-width:375px) and (min-height:737px) and (max-height:812px) and (orientation:portrait){.swipe-container .swipe-bg{padding:10px 12px}.swipe-container .swipe-bg .swipe-card{transition:color .3s ease-in,background .3s ease-in,width .3s ease-in,height .3s ease-in,border .3s ease-in;position:relative}.swipe-container .swipe-bg .swipe-card.draggable{width:40%!important}}.home-btn{margin-top:0;margin-bottom:0;transition:opacity .3s ease;position:relative;padding:4px 8px 4px 32px!important}.home-btn:before{position:absolute;left:8px;top:0;bottom:0;margin:auto;display:inline-block;font-family:Guroo-Producer;font-style:normal;font-weight:400;font-variant:normal;line-height:1;text-decoration:inherit;text-rendering:optimizeLegibility;text-transform:none;-moz-osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased;font-smoothing:antialiased;padding:0 5px 0 0;font-size:20px;height:20px;content:\"\\F123\"}.home-btn:hover{opacity:.7}@keyframes fadein{0%{opacity:0}to{opacity:1}}@-moz-keyframes fadein{0%{opacity:0}to{opacity:1}}@-webkit-keyframes fadein{0%{opacity:0}to{opacity:1}}@-ms-keyframes fadein{0%{opacity:0}to{opacity:1}}@-o-keyframes fadein{0%{opacity:0}to{opacity:1}}.hot-spot-screen,.hot-spot-screen .hot-spot-content{display:block;position:relative;overflow:hidden}.hot-spot-screen .hot-spot-content{overflow-y:auto;padding:0}.hot-spot-screen .hot-spot-content.include-footer{height:calc(100% - 60px)}.hot-spot-screen .hot-spot-content.no-scroll{overflow-y:hidden!important}.hot-spot-screen .hot-spot-content .hot-spot-background-container{display:block;position:relative}.hot-spot-screen .hot-spot-content .hot-spot-background-container img.hot-spot-background{width:100%;height:auto;position:relative}.hot-spot-screen .hot-spot-content .hot-spot-background-container img.image-overlay{display:none}.hot-spot-screen .hot-spot-content .hot-spot-background-container .hot-spot-area{display:block;position:absolute;width:100%;height:100%;top:0;left:0;margin:0;padding:0}.hot-spot-screen .hot-spot-content .hot-spot-background-container .hot-spot-area .-hot-spot{position:absolute;left:0;top:0;padding:2px;min-height:32px;width:32px;font-size:80%;cursor:pointer}.hot-spot-screen .hot-spot-content .hot-spot-background-container .hot-spot-area .-hot-spot:before{position:relative;font-size:28px}.hot-spot-screen .hot-spot-content .hot-spot-background-container .hot-spot-area .-hot-spot.not-required:before{margin-right:0;content:\"\"}.hot-spot-screen .hot-spot-content .hot-spot-background-container .hot-spot-area .-hot-spot.not-started:before{content:\"\\F16A\"}.hot-spot-screen .hot-spot-content .hot-spot-background-container .hot-spot-area .-hot-spot.in-progress:before,.hot-spot-screen .hot-spot-content .hot-spot-background-container .hot-spot-area .-hot-spot.not-started:before{display:inline-block;font-family:Guroo-Producer;font-style:normal;font-weight:400;font-variant:normal;line-height:1;text-decoration:inherit;text-rendering:optimizeLegibility;text-transform:none;-moz-osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased;font-smoothing:antialiased}.hot-spot-screen .hot-spot-content .hot-spot-background-container .hot-spot-area .-hot-spot.in-progress:before{content:\"\\F182\"}.hot-spot-screen .hot-spot-content .hot-spot-background-container .hot-spot-area .-hot-spot.complete:before{display:inline-block;font-family:Guroo-Producer;font-style:normal;font-weight:400;font-variant:normal;line-height:1;text-decoration:inherit;text-rendering:optimizeLegibility;text-transform:none;-moz-osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased;font-smoothing:antialiased;content:\"\\F16F\"}.hot-spot-screen .hot-spot-content .hot-spot-background-container .hot-spot-area .-hot-spot .hot-spot-label{overflow:hidden;position:absolute;background:inherit;white-space:nowrap;top:0;bottom:0;margin:auto;height:100%;padding:10px;line-height:100%}.hot-spot-screen .hot-spot-content .hot-spot-background-container .hot-spot-area .-hot-spot.hot-spot-left{border-top-right-radius:16px;border-bottom-right-radius:16px}.hot-spot-screen .hot-spot-content .hot-spot-background-container .hot-spot-area .-hot-spot.hot-spot-left .hot-spot-label{right:31px;padding-right:0!important;border-top-left-radius:16px;border-bottom-left-radius:16px}.hot-spot-screen .hot-spot-content .hot-spot-background-container .hot-spot-area .-hot-spot.hot-spot-right{border-top-left-radius:16px;border-bottom-left-radius:16px}.hot-spot-screen .hot-spot-content .hot-spot-background-container .hot-spot-area .-hot-spot.hot-spot-right .hot-spot-label{left:31px;padding-left:2px!important;border-top-right-radius:16px;border-bottom-right-radius:16px}.hot-spot-screen .hot-spot-content .hot-spot-background-container .hot-spot-area .-hot-spot.hot-spot-hide{width:40px;height:40px;border-radius:50%}.hot-spot-screen .hot-spot-content .hot-spot-background-container .hot-spot-area .-hot-spot.hot-spot-hide:before{position:relative;font-size:36px}.hot-spot-screen .hot-spot-content .hot-spot-background-container .hot-spot-area .-hot-spot.hot-spot-hide .hot-spot-label{display:none}.hot-spot-screen .hot-spot-content .hot-spot-background-container .hot-spot-area .-hot-spot.hot-spot-hide .hot-spot-hover-area{display:block;position:absolute;width:40px;height:40px;background:transparent;top:-20px;left:0}.hot-spot-screen .hot-spot-content .hot-spot-background-container .hot-spot-area .-hot-spot.hot-spot-hide .hot-spot-tool-tip{display:block;position:absolute;top:-130px;padding:12px 8px;height:115px;min-width:170px;left:-65px;border-radius:5px;-webkit-box-shadow:3px 3px 5px 0 rgba(0,0,0,.25);-moz-box-shadow:3px 3px 5px 0 rgba(0,0,0,.25);box-shadow:3px 3px 5px 0 rgba(0,0,0,.25);background:hsla(0,0%,100%,.9);color:#333;text-align:center;border:2px solid #999;z-index:100;-webkit-animation:fadein .7s;-moz-animation:fadein .7s;-ms-animation:fadein .7s;-o-animation:fadein .7s;animation:fadein .7s}.hot-spot-screen .hot-spot-content .hot-spot-background-container .hot-spot-area .-hot-spot.hot-spot-hide .hot-spot-tool-tip .close-btn{position:absolute;top:5px;right:5px}.hot-spot-screen .hot-spot-content .hot-spot-background-container .hot-spot-area .-hot-spot.hot-spot-hide .hot-spot-tool-tip .close-btn:before{display:inline-block;font-family:Guroo-Producer;font-style:normal;font-weight:400;font-variant:normal;line-height:1;text-decoration:inherit;text-rendering:optimizeLegibility;text-transform:none;-moz-osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased;font-smoothing:antialiased;color:#999;font-size:130%;font-weight:700;content:\"\\F125\"}.hot-spot-screen .hot-spot-content .hot-spot-background-container .hot-spot-area .-hot-spot.hot-spot-hide .hot-spot-tool-tip:before{position:absolute;width:0;height:0;bottom:-12px;left:calc(50% - 12px);border-left:12px solid transparent;border-right:12px solid transparent;border-top-style:solid;border-top-width:12px;border-top-color:#999;content:\"\"}.hot-spot-screen .hot-spot-content .hot-spot-background-container .hot-spot-area .-hot-spot.hot-spot-hide .hot-spot-tool-tip:after{position:absolute;width:0;height:0;bottom:-10px;left:calc(50% - 10px);border-left:10px solid transparent;border-right:10px solid transparent;border-top-style:solid;border-top-width:10px;border-top-color:#fff;content:\"\"}.hot-spot-screen .hot-spot-content .hot-spot-background-container .hot-spot-area .-hot-spot.hot-spot-hide.complete .hot-spot-tool-tip,.hot-spot-screen .hot-spot-content .hot-spot-background-container .hot-spot-area .-hot-spot.hot-spot-hide .hot-spot-tool-tip.hidden{display:none}.hot-spot-screen .hot-spot-content .hot-spot-background-container .hot-spot-area .-hot-spot.hot-spot-hide.complete:hover .hot-spot-tool-tip{display:block}.hot-spot-screen .hot-spot-content .hot-spot-background-container .hot-spot-area .-hot-spot.disabled,.hot-spot-screen .hot-spot-content .hot-spot-background-container .hot-spot-area .-hot-spot.disabled:active,.hot-spot-screen .hot-spot-content .hot-spot-background-container .hot-spot-area .-hot-spot.disabled:focus,.hot-spot-screen .hot-spot-content .hot-spot-background-container .hot-spot-area .-hot-spot.disabled:hover{background:#d2d2d2!important;color:#555!important;cursor:default}.hot-spot-screen .hot-spot-content .hot-spot-background-container .hot-spot-area .hot-spot{position:absolute;left:0;top:0;padding:2px;cursor:pointer;display:-webkit-flex;display:flex;flex-flow:row nowrap;align-items:center;-webkit-box-shadow:0 0 5px 3px rgba(0,0,0,.1);-moz-box-shadow:0 0 5px 3px rgba(0,0,0,.1);box-shadow:0 0 5px 3px rgba(0,0,0,.1);border-radius:16px;font-size:80%}.hot-spot-screen .hot-spot-content .hot-spot-background-container .hot-spot-area .hot-spot:before{position:relative;font-size:28px}.hot-spot-screen .hot-spot-content .hot-spot-background-container .hot-spot-area .hot-spot.not-required:before{margin-right:0;content:\"\"}.hot-spot-screen .hot-spot-content .hot-spot-background-container .hot-spot-area .hot-spot.not-started:before{content:\"\\F16A\"}.hot-spot-screen .hot-spot-content .hot-spot-background-container .hot-spot-area .hot-spot.in-progress:before,.hot-spot-screen .hot-spot-content .hot-spot-background-container .hot-spot-area .hot-spot.not-started:before{display:inline-block;font-family:Guroo-Producer;font-style:normal;font-weight:400;font-variant:normal;line-height:1;text-decoration:inherit;text-rendering:optimizeLegibility;text-transform:none;-moz-osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased;font-smoothing:antialiased}.hot-spot-screen .hot-spot-content .hot-spot-background-container .hot-spot-area .hot-spot.in-progress:before{content:\"\\F182\"}.hot-spot-screen .hot-spot-content .hot-spot-background-container .hot-spot-area .hot-spot.complete:before{display:inline-block;font-family:Guroo-Producer;font-style:normal;font-weight:400;font-variant:normal;line-height:1;text-decoration:inherit;text-rendering:optimizeLegibility;text-transform:none;-moz-osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased;font-smoothing:antialiased;content:\"\\F16F\"}.hot-spot-screen .hot-spot-content .hot-spot-background-container .hot-spot-area .hot-spot .hot-spot-icon{display:none}.hot-spot-screen .hot-spot-content .hot-spot-background-container .hot-spot-area .hot-spot .hot-spot-label{position:relative;padding:0 12px 0 6px;line-height:100%}.hot-spot-screen .hot-spot-content .hot-spot-background-container .hot-spot-area .hot-spot.hot-spot-left{display:-webkit-flex;display:flex;flex-flow:row-reverse nowrap}.hot-spot-screen .hot-spot-content .hot-spot-background-container .hot-spot-area .hot-spot.hot-spot-left .hot-spot-label{padding:0 6px 0 12px}.hot-spot-screen .hot-spot-content .hot-spot-background-container .hot-spot-area .hot-spot.disabled,.hot-spot-screen .hot-spot-content .hot-spot-background-container .hot-spot-area .hot-spot.disabled:active,.hot-spot-screen .hot-spot-content .hot-spot-background-container .hot-spot-area .hot-spot.disabled:focus,.hot-spot-screen .hot-spot-content .hot-spot-background-container .hot-spot-area .hot-spot.disabled:hover{background:#d2d2d2!important;color:#555!important;cursor:default}.hot-spot-screen .hot-spot-content .hot-spot-background-container .hot-spot-area .hot-spot-hide{position:absolute;left:0;top:0;padding:2px;width:40px;height:40px;border-radius:50%;cursor:pointer;-webkit-box-shadow:0 0 5px 3px rgba(0,0,0,.1);-moz-box-shadow:0 0 5px 3px rgba(0,0,0,.1);box-shadow:0 0 5px 3px rgba(0,0,0,.1)}.hot-spot-screen .hot-spot-content .hot-spot-background-container .hot-spot-area .hot-spot-hide:before{position:relative;font-size:37px}.hot-spot-screen .hot-spot-content .hot-spot-background-container .hot-spot-area .hot-spot-hide.not-required:before{margin-right:0;content:\"\"}.hot-spot-screen .hot-spot-content .hot-spot-background-container .hot-spot-area .hot-spot-hide.not-started:before{content:\"\\F16A\"}.hot-spot-screen .hot-spot-content .hot-spot-background-container .hot-spot-area .hot-spot-hide.in-progress:before,.hot-spot-screen .hot-spot-content .hot-spot-background-container .hot-spot-area .hot-spot-hide.not-started:before{display:inline-block;font-family:Guroo-Producer;font-style:normal;font-weight:400;font-variant:normal;line-height:1;text-decoration:inherit;text-rendering:optimizeLegibility;text-transform:none;-moz-osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased;font-smoothing:antialiased}.hot-spot-screen .hot-spot-content .hot-spot-background-container .hot-spot-area .hot-spot-hide.in-progress:before{content:\"\\F182\"}.hot-spot-screen .hot-spot-content .hot-spot-background-container .hot-spot-area .hot-spot-hide.complete:before{display:inline-block;font-family:Guroo-Producer;font-style:normal;font-weight:400;font-variant:normal;line-height:1;text-decoration:inherit;text-rendering:optimizeLegibility;text-transform:none;-moz-osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased;font-smoothing:antialiased;content:\"\\F16F\"}.hot-spot-screen .hot-spot-content .hot-spot-background-container .hot-spot-area .hot-spot-hide .hot-spot-icon{display:none!important}.hot-spot-screen .hot-spot-content .hot-spot-background-container .hot-spot-area .hot-spot-hide .hot-spot-label{display:none}.hot-spot-screen .hot-spot-content .hot-spot-background-container .hot-spot-area .hot-spot-hide .hot-spot-hover-area{display:block;position:absolute;width:40px;height:40px;background:transparent;top:-20px;left:0}.hot-spot-screen .hot-spot-content .hot-spot-background-container .hot-spot-area .hot-spot-hide .hot-spot-tool-tip{display:block;position:absolute;top:-130px;padding:12px 8px;height:115px;min-width:170px;left:-65px;border-radius:5px;-webkit-box-shadow:3px 3px 5px 0 rgba(0,0,0,.25);-moz-box-shadow:3px 3px 5px 0 rgba(0,0,0,.25);box-shadow:3px 3px 5px 0 rgba(0,0,0,.25);background:hsla(0,0%,100%,.9);color:#333;text-align:center;border:2px solid #999;z-index:100;-webkit-animation:fadein .7s;-moz-animation:fadein .7s;-ms-animation:fadein .7s;-o-animation:fadein .7s;animation:fadein .7s}.hot-spot-screen .hot-spot-content .hot-spot-background-container .hot-spot-area .hot-spot-hide .hot-spot-tool-tip .close-btn{position:absolute;top:0;right:5px}.hot-spot-screen .hot-spot-content .hot-spot-background-container .hot-spot-area .hot-spot-hide .hot-spot-tool-tip .close-btn:before{display:inline-block;font-family:Guroo-Producer;font-style:normal;font-weight:400;font-variant:normal;line-height:1;text-decoration:inherit;text-rendering:optimizeLegibility;text-transform:none;-moz-osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased;font-smoothing:antialiased;color:#999;font-size:12px;font-weight:700;content:\"\\F125\"}.hot-spot-screen .hot-spot-content .hot-spot-background-container .hot-spot-area .hot-spot-hide .hot-spot-tool-tip:before{position:absolute;width:0;height:0;bottom:-12px;left:calc(50% - 12px);border-left:12px solid transparent;border-right:12px solid transparent;border-top-style:solid;border-top-width:12px;border-top-color:#999;content:\"\"}.hot-spot-screen .hot-spot-content .hot-spot-background-container .hot-spot-area .hot-spot-hide .hot-spot-tool-tip:after{position:absolute;width:0;height:0;bottom:-10px;left:calc(50% - 10px);border-left:10px solid transparent;border-right:10px solid transparent;border-top-style:solid;border-top-width:10px;border-top-color:#fff;content:\"\"}.hot-spot-screen .hot-spot-content .hot-spot-background-container .hot-spot-area .hot-spot-hide.complete .hot-spot-tool-tip,.hot-spot-screen .hot-spot-content .hot-spot-background-container .hot-spot-area .hot-spot-hide .hot-spot-tool-tip.hidden{display:none}.hot-spot-screen .hot-spot-content .hot-spot-background-container .hot-spot-area .hot-spot-hide.complete:hover .hot-spot-tool-tip{display:block}.hot-spot-screen .hot-spot-content .hot-spot-background-container .hot-spot-area .hot-spot-hide.disabled,.hot-spot-screen .hot-spot-content .hot-spot-background-container .hot-spot-area .hot-spot-hide.disabled:active,.hot-spot-screen .hot-spot-content .hot-spot-background-container .hot-spot-area .hot-spot-hide.disabled:focus,.hot-spot-screen .hot-spot-content .hot-spot-background-container .hot-spot-area .hot-spot-hide.disabled:hover{background:#d2d2d2!important;color:#555!important;cursor:default}.hot-spot-screen .hot-spot-content .hot-spot-background-container .hot-spot-area .hot-spot-sml-icon{position:absolute;left:0;top:0;padding:6px 12px;cursor:pointer;display:-webkit-flex;display:flex;flex-flow:row nowrap;align-items:center;-webkit-box-shadow:0 0 5px 3px rgba(0,0,0,.1);-moz-box-shadow:0 0 5px 3px rgba(0,0,0,.1);box-shadow:0 0 5px 3px rgba(0,0,0,.1);border-radius:16px}.hot-spot-screen .hot-spot-content .hot-spot-background-container .hot-spot-area .hot-spot-sml-icon .hot-spot-icon{position:relative;padding:0 2px}.hot-spot-screen .hot-spot-content .hot-spot-background-container .hot-spot-area .hot-spot-sml-icon .hot-spot-icon img{height:32px;width:auto}.hot-spot-screen .hot-spot-content .hot-spot-background-container .hot-spot-area .hot-spot-sml-icon .hot-spot-label{position:relative;padding:0 6px}.hot-spot-screen .hot-spot-content .hot-spot-background-container .hot-spot-area .hot-spot-sml-icon.hot-spot-left{display:-webkit-flex;display:flex;flex-flow:row-reverse nowrap}.hot-spot-screen .hot-spot-content .hot-spot-background-container .hot-spot-area .hot-spot-sml-icon:before{display:block;position:absolute;top:-3px;right:-3px;width:16px;height:16px;font-size:16px;background:#fff;border-radius:50%}.hot-spot-screen .hot-spot-content .hot-spot-background-container .hot-spot-area .hot-spot-sml-icon.not-required:before{margin-right:0;content:\"\"}.hot-spot-screen .hot-spot-content .hot-spot-background-container .hot-spot-area .hot-spot-sml-icon.not-started:before{color:#999;content:\"\\F16A\"}.hot-spot-screen .hot-spot-content .hot-spot-background-container .hot-spot-area .hot-spot-sml-icon.in-progress:before,.hot-spot-screen .hot-spot-content .hot-spot-background-container .hot-spot-area .hot-spot-sml-icon.not-started:before{display:inline-block;font-family:Guroo-Producer;font-style:normal;font-weight:400;font-variant:normal;line-height:1;text-decoration:inherit;text-rendering:optimizeLegibility;text-transform:none;-moz-osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased;font-smoothing:antialiased}.hot-spot-screen .hot-spot-content .hot-spot-background-container .hot-spot-area .hot-spot-sml-icon.in-progress:before{color:#f6ad17;content:\"\\F182\"}.hot-spot-screen .hot-spot-content .hot-spot-background-container .hot-spot-area .hot-spot-sml-icon.complete:before{color:#39aa27;display:inline-block;font-family:Guroo-Producer;font-style:normal;font-weight:400;font-variant:normal;line-height:1;text-decoration:inherit;text-rendering:optimizeLegibility;text-transform:none;-moz-osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased;font-smoothing:antialiased;content:\"\\F16F\"}.hot-spot-screen .hot-spot-content .hot-spot-background-container .hot-spot-area .hot-spot-sml-icon .hot-spot-tool-tip{display:none}.hot-spot-screen .hot-spot-content .hot-spot-background-container .hot-spot-area .hot-spot-sml-icon.disabled,.hot-spot-screen .hot-spot-content .hot-spot-background-container .hot-spot-area .hot-spot-sml-icon.disabled:active,.hot-spot-screen .hot-spot-content .hot-spot-background-container .hot-spot-area .hot-spot-sml-icon.disabled:focus,.hot-spot-screen .hot-spot-content .hot-spot-background-container .hot-spot-area .hot-spot-sml-icon.disabled:hover{background:#d2d2d2!important;color:#555!important;cursor:default}.hot-spot-screen .hot-spot-content .hot-spot-background-container .hot-spot-area .hot-spot-sml-icon-only{position:absolute;left:0;top:0;padding:2px;width:50px;height:50px;border-radius:50%;cursor:pointer;border:3px solid #999;-webkit-box-shadow:0 0 5px 3px rgba(0,0,0,.1);-moz-box-shadow:0 0 5px 3px rgba(0,0,0,.1);box-shadow:0 0 5px 3px rgba(0,0,0,.1)}.hot-spot-screen .hot-spot-content .hot-spot-background-container .hot-spot-area .hot-spot-sml-icon-only:before{position:relative;font-size:37px}.hot-spot-screen .hot-spot-content .hot-spot-background-container .hot-spot-area .hot-spot-sml-icon-only.in-progress{border-color:#f6ad17}.hot-spot-screen .hot-spot-content .hot-spot-background-container .hot-spot-area .hot-spot-sml-icon-only.complete{border-color:#39aa27}.hot-spot-screen .hot-spot-content .hot-spot-background-container .hot-spot-area .hot-spot-sml-icon-only .hot-spot-icon{display:block;position:absolute;width:44px;height:44px;top:0;bottom:0;left:0;right:0;margin:auto!important;overflow:hidden;border:2px solid #fff;border-radius:50%}.hot-spot-screen .hot-spot-content .hot-spot-background-container .hot-spot-area .hot-spot-sml-icon-only .hot-spot-icon img{position:absolute;height:26px!important;width:auto;top:0;bottom:0;left:0;right:0;margin:auto}.hot-spot-screen .hot-spot-content .hot-spot-background-container .hot-spot-area .hot-spot-sml-icon-only .hot-spot-label{display:none}.hot-spot-screen .hot-spot-content .hot-spot-background-container .hot-spot-area .hot-spot-sml-icon-only .hot-spot-hover-area{display:block;position:absolute;width:40px;height:40px;background:transparent;top:-20px;left:0}.hot-spot-screen .hot-spot-content .hot-spot-background-container .hot-spot-area .hot-spot-sml-icon-only .hot-spot-tool-tip{display:block;position:absolute;top:-130px;padding:12px 8px;height:115px;min-width:170px;left:-65px;border-radius:5px;-webkit-box-shadow:3px 3px 5px 0 rgba(0,0,0,.25);-moz-box-shadow:3px 3px 5px 0 rgba(0,0,0,.25);box-shadow:3px 3px 5px 0 rgba(0,0,0,.25);background:hsla(0,0%,100%,.9);color:#333;text-align:center;border:2px solid #999;z-index:100;-webkit-animation:fadein .7s;-moz-animation:fadein .7s;-ms-animation:fadein .7s;-o-animation:fadein .7s;animation:fadein .7s}.hot-spot-screen .hot-spot-content .hot-spot-background-container .hot-spot-area .hot-spot-sml-icon-only .hot-spot-tool-tip .close-btn{position:absolute;top:0;right:5px}.hot-spot-screen .hot-spot-content .hot-spot-background-container .hot-spot-area .hot-spot-sml-icon-only .hot-spot-tool-tip .close-btn:before{display:inline-block;font-family:Guroo-Producer;font-style:normal;font-weight:400;font-variant:normal;line-height:1;text-decoration:inherit;text-rendering:optimizeLegibility;text-transform:none;-moz-osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased;font-smoothing:antialiased;color:#999;font-size:12px;font-weight:700;content:\"\\F125\"}.hot-spot-screen .hot-spot-content .hot-spot-background-container .hot-spot-area .hot-spot-sml-icon-only .hot-spot-tool-tip:before{position:absolute;width:0;height:0;bottom:-12px;left:calc(50% - 12px);border-left:12px solid transparent;border-right:12px solid transparent;border-top-style:solid;border-top-width:12px;border-top-color:#999;content:\"\"}.hot-spot-screen .hot-spot-content .hot-spot-background-container .hot-spot-area .hot-spot-sml-icon-only .hot-spot-tool-tip:after{position:absolute;width:0;height:0;bottom:-10px;left:calc(50% - 10px);border-left:10px solid transparent;border-right:10px solid transparent;border-top-style:solid;border-top-width:10px;border-top-color:#fff;content:\"\"}.hot-spot-screen .hot-spot-content .hot-spot-background-container .hot-spot-area .hot-spot-sml-icon-only.complete .hot-spot-tool-tip,.hot-spot-screen .hot-spot-content .hot-spot-background-container .hot-spot-area .hot-spot-sml-icon-only .hot-spot-tool-tip.hidden{display:none}.hot-spot-screen .hot-spot-content .hot-spot-background-container .hot-spot-area .hot-spot-sml-icon-only.complete:hover .hot-spot-tool-tip{display:block}.hot-spot-screen .hot-spot-content .hot-spot-background-container .hot-spot-area .hot-spot-sml-icon-only.disabled,.hot-spot-screen .hot-spot-content .hot-spot-background-container .hot-spot-area .hot-spot-sml-icon-only.disabled:active,.hot-spot-screen .hot-spot-content .hot-spot-background-container .hot-spot-area .hot-spot-sml-icon-only.disabled:focus,.hot-spot-screen .hot-spot-content .hot-spot-background-container .hot-spot-area .hot-spot-sml-icon-only.disabled:hover{background:#d2d2d2!important;color:#555!important;cursor:default}.hot-spot-screen .hot-spot-content .hot-spot-background-container .hot-spot-area .hot-spot-lg-icon{position:absolute;left:0;top:0;padding:0;min-height:32px;width:160px;cursor:pointer;border-radius:5px;-webkit-box-shadow:0 0 5px 3px rgba(0,0,0,.1);-moz-box-shadow:0 0 5px 3px rgba(0,0,0,.1);box-shadow:0 0 5px 3px rgba(0,0,0,.1);font-size:80%}.hot-spot-screen .hot-spot-content .hot-spot-background-container .hot-spot-area .hot-spot-lg-icon .hot-spot-icon{width:160px;height:160px;position:relative;overflow:hidden}.hot-spot-screen .hot-spot-content .hot-spot-background-container .hot-spot-area .hot-spot-lg-icon .hot-spot-icon img{height:140px;width:auto;position:absolute;left:0;right:0;top:0;bottom:0;margin:auto}.hot-spot-screen .hot-spot-content .hot-spot-background-container .hot-spot-area .hot-spot-lg-icon:before{display:block;position:absolute;top:-3px;right:-3px;width:16px;height:16px;font-size:16px;background:#fff;border-radius:50%}.hot-spot-screen .hot-spot-content .hot-spot-background-container .hot-spot-area .hot-spot-lg-icon.not-required:before{margin-right:0;content:\"\"}.hot-spot-screen .hot-spot-content .hot-spot-background-container .hot-spot-area .hot-spot-lg-icon.not-started:before{color:#999;content:\"\\F16A\"}.hot-spot-screen .hot-spot-content .hot-spot-background-container .hot-spot-area .hot-spot-lg-icon.in-progress:before,.hot-spot-screen .hot-spot-content .hot-spot-background-container .hot-spot-area .hot-spot-lg-icon.not-started:before{display:inline-block;font-family:Guroo-Producer;font-style:normal;font-weight:400;font-variant:normal;line-height:1;text-decoration:inherit;text-rendering:optimizeLegibility;text-transform:none;-moz-osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased;font-smoothing:antialiased}.hot-spot-screen .hot-spot-content .hot-spot-background-container .hot-spot-area .hot-spot-lg-icon.in-progress:before{color:#f6ad17;content:\"\\F182\"}.hot-spot-screen .hot-spot-content .hot-spot-background-container .hot-spot-area .hot-spot-lg-icon.complete:before{color:#39aa27;display:inline-block;font-family:Guroo-Producer;font-style:normal;font-weight:400;font-variant:normal;line-height:1;text-decoration:inherit;text-rendering:optimizeLegibility;text-transform:none;-moz-osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased;font-smoothing:antialiased;content:\"\\F16F\"}.hot-spot-screen .hot-spot-content .hot-spot-background-container .hot-spot-area .hot-spot-lg-icon .hot-spot-tool-tip{display:none}.hot-spot-screen .hot-spot-content .hot-spot-background-container .hot-spot-area .hot-spot-lg-icon .hot-spot-label{padding:8px 12px;border-top:1px solid #fff;text-align:center}.hot-spot-screen .hot-spot-content .hot-spot-background-container .hot-spot-area .hot-spot-lg-icon.disabled,.hot-spot-screen .hot-spot-content .hot-spot-background-container .hot-spot-area .hot-spot-lg-icon.disabled:active,.hot-spot-screen .hot-spot-content .hot-spot-background-container .hot-spot-area .hot-spot-lg-icon.disabled:focus,.hot-spot-screen .hot-spot-content .hot-spot-background-container .hot-spot-area .hot-spot-lg-icon.disabled:hover{background:#d2d2d2!important;color:#555!important;cursor:default}.hot-spot-screen .hot-spot-content .hot-spot-background-container .hot-spot-area .hot-spot-lg-icon-only{position:absolute;left:0;top:0;padding:0;min-height:32px;width:160px;cursor:pointer;border-radius:5px;-webkit-box-shadow:0 0 5px 3px rgba(0,0,0,.1);-moz-box-shadow:0 0 5px 3px rgba(0,0,0,.1);box-shadow:0 0 5px 3px rgba(0,0,0,.1);font-size:80%}.hot-spot-screen .hot-spot-content .hot-spot-background-container .hot-spot-area .hot-spot-lg-icon-only .hot-spot-icon{width:160px;height:160px;position:relative;overflow:hidden}.hot-spot-screen .hot-spot-content .hot-spot-background-container .hot-spot-area .hot-spot-lg-icon-only .hot-spot-icon img{height:140px;width:auto;position:absolute;left:0;right:0;top:0;bottom:0;margin:auto}.hot-spot-screen .hot-spot-content .hot-spot-background-container .hot-spot-area .hot-spot-lg-icon-only:before{display:block;position:absolute;top:-3px;right:-3px;width:16px;height:16px;font-size:16px;background:#fff;border-radius:50%}.hot-spot-screen .hot-spot-content .hot-spot-background-container .hot-spot-area .hot-spot-lg-icon-only.not-required:before{margin-right:0;content:\"\"}.hot-spot-screen .hot-spot-content .hot-spot-background-container .hot-spot-area .hot-spot-lg-icon-only.not-started:before{color:#999;content:\"\\F16A\"}.hot-spot-screen .hot-spot-content .hot-spot-background-container .hot-spot-area .hot-spot-lg-icon-only.in-progress:before,.hot-spot-screen .hot-spot-content .hot-spot-background-container .hot-spot-area .hot-spot-lg-icon-only.not-started:before{display:inline-block;font-family:Guroo-Producer;font-style:normal;font-weight:400;font-variant:normal;line-height:1;text-decoration:inherit;text-rendering:optimizeLegibility;text-transform:none;-moz-osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased;font-smoothing:antialiased}.hot-spot-screen .hot-spot-content .hot-spot-background-container .hot-spot-area .hot-spot-lg-icon-only.in-progress:before{color:#f6ad17;content:\"\\F182\"}.hot-spot-screen .hot-spot-content .hot-spot-background-container .hot-spot-area .hot-spot-lg-icon-only.complete:before{color:#39aa27;display:inline-block;font-family:Guroo-Producer;font-style:normal;font-weight:400;font-variant:normal;line-height:1;text-decoration:inherit;text-rendering:optimizeLegibility;text-transform:none;-moz-osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased;font-smoothing:antialiased;content:\"\\F16F\"}.hot-spot-screen .hot-spot-content .hot-spot-background-container .hot-spot-area .hot-spot-lg-icon-only .hot-spot-label,.hot-spot-screen .hot-spot-content .hot-spot-background-container .hot-spot-area .hot-spot-lg-icon-only .hot-spot-tool-tip{display:none}.hot-spot-screen .hot-spot-content .hot-spot-background-container .hot-spot-area .hot-spot-lg-icon-only.disabled,.hot-spot-screen .hot-spot-content .hot-spot-background-container .hot-spot-area .hot-spot-lg-icon-only.disabled:active,.hot-spot-screen .hot-spot-content .hot-spot-background-container .hot-spot-area .hot-spot-lg-icon-only.disabled:focus,.hot-spot-screen .hot-spot-content .hot-spot-background-container .hot-spot-area .hot-spot-lg-icon-only.disabled:hover{background:#d2d2d2!important;color:#555!important;cursor:default}.hot-spot-screen .hot-spot-footer{position:relative;display:-webkit-flex;display:flex;flex-flow:row nowrap;align-items:center;height:42px;width:calc(100% - 14px);margin:auto;padding:0;color:#fff}.hot-spot-screen .hot-spot-footer .footer-col{padding:0 12px;margin:0 5px;flex:1}.hot-spot-screen .hot-spot-footer .footer-col:first-child{margin-left:0}.hot-spot-screen .hot-spot-footer .footer-col:last-child{margin-right:0}.hot-spot-screen .hot-spot-footer .footer-btn{display:none}.hot-spot-screen .hot-spot-footer.scroll:after{position:absolute;top:-25px;bottom:0;width:100%;height:20px;-webkit-box-shadow:inset 0 -7px 6px 0 rgba(0,0,0,.45);-moz-box-shadow:inset 0 -7px 6px 0 rgba(0,0,0,.45);box-shadow:inset 0 -7px 6px 0 rgba(0,0,0,.45);content:\"\"}.hot-spot-screen .hot-spot-footer.scroll .footer-btn{display:block;position:absolute;left:0;top:0;right:0;margin:auto;cursor:pointer}.hot-spot-screen .hot-spot-footer.scroll .footer-btn:before{position:absolute;left:0;right:0;top:-60px;margin:auto;display:inline-block;font-family:Guroo-Producer;font-style:normal;font-weight:400;font-variant:normal;line-height:1;text-decoration:inherit;text-rendering:optimizeLegibility;text-transform:none;-moz-osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased;font-smoothing:antialiased;width:40px;height:40px;padding:8px;border-radius:50%;background:rgba(0,0,0,.7);content:\"\\F24D\";font-size:24px}.hot-spot-screen .hot-spot-footer .guroo-btn{background:#fff;color:#333;margin:0 6px}.hot-spot-screen.large_screen{background:#333;border:1px solid #000;height:calc(100% - 10px);width:calc(100% - 10px);max-width:994px;margin:5px auto;border-radius:12px;-webkit-box-shadow:0 5px 5px 0 rgba(0,0,0,.25);-moz-box-shadow:0 5px 5px 0 rgba(0,0,0,.25);box-shadow:0 5px 5px 0 rgba(0,0,0,.25)}.hot-spot-screen.large_screen .hot-spot-content{margin:6px auto;height:calc(100% - 12px);width:calc(100% - 12px);background:#fff}.hot-spot-screen.large_screen .hot-spot-content.include-footer{height:calc(100% - 60px)}.hot-spot-screen.large_screen .introduction-btn{position:absolute;z-index:1000;bottom:9px!important;left:25px!important}.hot-spot-screen.large_screen .introduction-btn.guroo-btn{background:#fff;color:#333;margin:0 6px}.hot-spot-screen.large_screen .conclusion-btn{position:absolute;z-index:1000;bottom:9px!important;left:155px!important}.hot-spot-screen.large_screen .conclusion-btn.guroo-btn{background:#fff;color:#333;margin:0 6px}.hot-spot-screen.no_screen{max-width:994px;height:100%;background:transparent;margin:0 auto;-webkit-box-shadow:0 5px 5px 0 rgba(0,0,0,.25);-moz-box-shadow:0 5px 5px 0 rgba(0,0,0,.25);box-shadow:0 5px 5px 0 rgba(0,0,0,.25)}.hot-spot-screen.no_screen .hot-spot-content.include-footer{height:100%!important}.hot-spot-screen.no_screen .hot-spot-footer{position:absolute;bottom:0;width:100%;padding:16px 24px;height:64px;color:#333}.hot-spot-screen.no_screen .hot-spot-footer.scroll:after{display:none!important}.hot-spot-screen.no_screen .introduction-btn{position:absolute;z-index:1000;bottom:12px!important;left:50px!important}.hot-spot-screen.no_screen .conclusion-btn{position:absolute;z-index:1000;bottom:12px!important;left:185px!important}.hot-spot-screen.full_screen{width:100%;height:100%;background:transparent;margin:0 auto;-webkit-box-shadow:0 5px 5px 0 rgba(0,0,0,.25);-moz-box-shadow:0 5px 5px 0 rgba(0,0,0,.25);box-shadow:0 5px 5px 0 rgba(0,0,0,.25)}.hot-spot-screen.full_screen .hot-spot-content{overflow:hidden!important;height:100%!important}.hot-spot-screen.full_screen .hot-spot-content.include-footer{height:100%!important}.hot-spot-screen.full_screen .hot-spot-footer{position:absolute;bottom:0;width:100%;padding:16px 24px;height:64px;color:#333}.hot-spot-screen.full_screen .hot-spot-footer .footer-btn,.hot-spot-screen.full_screen .hot-spot-footer.scroll:after,.hot-spot-screen.full_screen .hot-spot-footer.scroll:before{display:none!important}.hot-spot-screen.full_screen .introduction-btn{position:absolute;z-index:1000;bottom:12px!important;left:50px!important}.hot-spot-screen.full_screen .conclusion-btn{position:absolute;z-index:1000;bottom:12px!important;left:185px!important}.hot-spot-screen.mobile_screen{background:#333;border:1px solid #000;height:calc(100% - 10px);width:calc(100% - 10px);max-width:420px;margin:5px auto;border-radius:12px;-webkit-box-shadow:0 5px 5px 0 rgba(0,0,0,.25);-moz-box-shadow:0 5px 5px 0 rgba(0,0,0,.25);box-shadow:0 5px 5px 0 rgba(0,0,0,.25)}.hot-spot-screen.mobile_screen .hot-spot-content{margin:6px auto;height:calc(100% - 12px);width:calc(100% - 12px);background:#fff}.hot-spot-screen.mobile_screen .hot-spot-content.include-footer{height:calc(100% - 60px)}.hot-spot-screen.mobile_screen .introduction-btn{position:absolute;z-index:1000;bottom:8px!important;left:15px!important}.hot-spot-screen.mobile_screen .introduction-btn.guroo-btn{background:#fff;color:#333;margin:0 6px}.hot-spot-screen.mobile_screen .conclusion-btn{position:absolute;z-index:1000;bottom:8px!important;left:155px!important;margin:auto}.hot-spot-screen.mobile_screen .conclusion-btn.guroo-btn{background:#fff;color:#333;margin:0 6px}.hot-spot-screen.mobile_screen .scroll-instruction{display:none}.producer-notes{display:block;position:relative;padding:20px 15px 40px 70px;margin:16px 24px;margin-bottom:0;border:2px dotted #3a93d2;background:#f1f7fc}.producer-notes .guroo-producer-logo{position:absolute;width:32px!important;height:auto!important;top:18px;left:24px}.producer-notes .producer-notes-title{font-weight:700;color:#3a93d2!important}.producer-notes .producer-notes-description{font-size:90%;padding:20px 0;border-bottom:2px dotted #3a93d2}.producer-notes .producer-notes-description:last-child{border-bottom:none;padding-bottom:0}.screen-not-ready{margin:16px 24px;text-align:center;font-size:200%;color:#999}.video-object{position:relative;margin:10px}.video-object .video-js-container{display:block;position:relative;background:#000;color:#fff;overflow:hidden;margin:10px auto!important;-webkit-box-shadow:5px 5px 5px 0 rgba(0,0,0,.25);-moz-box-shadow:5px 5px 5px 0 rgba(0,0,0,.25);box-shadow:5px 5px 5px 0 rgba(0,0,0,.25)}.video-object .video-js-container .video-js{display:block;position:relative;width:100%;padding-bottom:56.25%;padding-top:25px;height:0;float:none}.video-object .video-js-container .video-js .vjs-big-play-button{top:0;bottom:0;left:0;right:0;margin:auto;width:2em}.video-object .video-wrapper{display:block;position:relative;width:100%;padding-bottom:56.25%;padding-top:25px;height:0;background:#000;float:none}.video-object .video-wrapper iframe,.video-object .video-wrapper video{position:absolute;top:0;left:0;right:0;width:100%;height:100%;margin:auto;z-index:1!important}.video-object .video-wrapper iframe{bottom:0}.video-object .asset-desc{position:relative;padding:12px 15px 0;text-align:left}.video-object .video-thumbnail-wrapper{position:absolute;top:0;left:0;width:100%;height:100%;overflow:hidden;background:#d5d5d5;-webkit-box-shadow:5px 5px 5px 2px rgba(0,0,0,.25);-moz-box-shadow:5px 5px 5px 2px rgba(0,0,0,.25);box-shadow:5px 5px 5px 2px rgba(0,0,0,.25);z-index:10!important}.video-object .video-thumbnail-wrapper:hover{cursor:pointer}.video-object .video-thumbnail-wrapper:hover:before{-webkit-box-shadow:0 0 10px 3px #ead146;-moz-box-shadow:0 0 10px 3px #ead146;box-shadow:0 0 10px 3px #ead146}.video-object .video-thumbnail-wrapper:focus{cursor:pointer}.video-object .video-thumbnail-wrapper:focus:before{-webkit-box-shadow:0 0 10px 3px #ead146!important;-moz-box-shadow:0 0 10px 3px #ead146!important;box-shadow:0 0 10px 3px #ead146!important}.video-object .video-thumbnail-wrapper:before{background:hsla(0,0%,100%,.5);position:absolute;top:0;left:0;right:0;bottom:0;margin:auto;font-size:40px;border-radius:50%;padding:0;line-height:0;width:60px;height:60px;content:\"\";border:3px solid #fff}.video-object .video-thumbnail-wrapper:after{height:40px;width:40px;position:absolute;top:0;left:0;right:0;bottom:0;margin:auto;font-size:40px}.video-object .video-thumbnail-wrapper.play{display:block}.video-object .video-thumbnail-wrapper.play:after{color:#fff;display:inline-block;font-family:Guroo-Producer;font-style:normal;font-weight:400;font-variant:normal;line-height:1;text-decoration:inherit;text-rendering:optimizeLegibility;text-transform:none;-moz-osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased;font-smoothing:antialiased;content:\"\\F136\"}.video-object .video-thumbnail-wrapper.replay{display:block}.video-object .video-thumbnail-wrapper.replay:after{color:#fff;display:inline-block;font-family:Guroo-Producer;font-style:normal;font-weight:400;font-variant:normal;line-height:1;text-decoration:inherit;text-rendering:optimizeLegibility;text-transform:none;-moz-osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased;font-smoothing:antialiased;content:\"\\F1AA\"}.video-object .video-thumbnail-wrapper img{width:100%;overflow:hidden}.video-object .video-thumbnail-wrapper .video-details{display:block;width:100%;position:absolute;bottom:0;padding:16px 24px;color:#333;background:hsla(0,0%,100%,.6);font-size:85%;overflow:hidden}.video-object .video-thumbnail-wrapper .video-details h4{font-size:110%;position:relative}.video-object .video-thumbnail-wrapper .video-details h4.not-viewed{padding:0 0 0 16px}.video-object .video-thumbnail-wrapper .video-details h4.not-viewed:before{position:absolute;left:-8px;top:4px;color:#999;padding-right:10px;display:inline-block;font-family:Guroo-Producer;font-style:normal;font-weight:400;font-variant:normal;line-height:1;text-decoration:inherit;text-rendering:optimizeLegibility;text-transform:none;-moz-osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased;font-smoothing:antialiased;content:\"\\F16A\"}.video-object .video-thumbnail-wrapper .video-details h4.viewed{padding:0 0 0 16px}.video-object .video-thumbnail-wrapper .video-details h4.viewed:before{position:absolute;left:-8px;top:4px;color:#39aa27;padding-right:10px;display:inline-block;font-family:Guroo-Producer;font-style:normal;font-weight:400;font-variant:normal;line-height:1;text-decoration:inherit;text-rendering:optimizeLegibility;text-transform:none;-moz-osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased;font-smoothing:antialiased;content:\"\\F16F\"}.video-object .video-thumbnail-wrapper .video-details a{color:inherit!important;text-decoration:underline}.video-object .video-thumbnail-wrapper .video-details a:before{text-decoration:none}@media (min-width:320px) and (max-width:480px){.video-object .video-thumbnail-wrapper .video-details{padding:10px 12px;background:hsla(0,0%,100%,.8)}}@media only screen and (max-width:375px) and (max-height:736px) and (orientation:portrait){.video-object{margin:0}.video-object .video-thumbnail-wrapper{border:1px solid #d5d5d5}.video-object .video-thumbnail-wrapper:before{background:hsla(0,0%,100%,.5);position:absolute;top:0;left:0;right:0;bottom:0;margin:auto;font-size:30px;border-radius:50%;padding:0;line-height:0;width:50px;height:50px;content:\"\";border:3px solid #fff}.video-object .video-thumbnail-wrapper:after{height:30px;width:30px;position:absolute;top:0;left:0;right:0;bottom:0;margin:auto;font-size:30px}.video-object .video-thumbnail-wrapper:hover{cursor:pointer}.video-object .video-thumbnail-wrapper:hover:before{-webkit-box-shadow:0 0 10px 3px #ead146;-moz-box-shadow:0 0 10px 3px #ead146;box-shadow:0 0 10px 3px #ead146}.video-object .video-thumbnail-wrapper.play{display:block;color:#fff}.video-object .video-thumbnail-wrapper.play:after{display:inline-block;font-family:Guroo-Producer;font-style:normal;font-weight:400;font-variant:normal;line-height:1;text-decoration:inherit;text-rendering:optimizeLegibility;text-transform:none;-moz-osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased;font-smoothing:antialiased;content:\"\\F136\"}.video-object .video-thumbnail-wrapper.replay{display:block}.video-object .video-thumbnail-wrapper.replay:after{color:#fff;display:inline-block;font-family:Guroo-Producer;font-style:normal;font-weight:400;font-variant:normal;line-height:1;text-decoration:inherit;text-rendering:optimizeLegibility;text-transform:none;-moz-osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased;font-smoothing:antialiased;content:\"\\F1AA\"}}@media only screen and (max-height:375px) and (max-width:736px) and (orientation:landscape){.video-object{margin:0}.video-object .video-thumbnail-wrapper{border:1px solid #d5d5d5}.video-object .video-thumbnail-wrapper:before{background:hsla(0,0%,100%,.5);position:absolute;top:0;left:0;right:0;bottom:0;margin:auto;font-size:30px;border-radius:50%;padding:0;line-height:0;width:50px;height:50px;content:\"\";border:3px solid #fff}.video-object .video-thumbnail-wrapper:after{height:30px;width:30px;position:absolute;top:0;left:0;right:0;bottom:0;margin:auto;font-size:30px}.video-object .video-thumbnail-wrapper:hover{cursor:pointer}.video-object .video-thumbnail-wrapper:hover:before{-webkit-box-shadow:0 0 10px 3px #ead146;-moz-box-shadow:0 0 10px 3px #ead146;box-shadow:0 0 10px 3px #ead146}.video-object .video-thumbnail-wrapper.play{display:block;color:#fff}.video-object .video-thumbnail-wrapper.play:after{display:inline-block;font-family:Guroo-Producer;font-style:normal;font-weight:400;font-variant:normal;line-height:1;text-decoration:inherit;text-rendering:optimizeLegibility;text-transform:none;-moz-osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased;font-smoothing:antialiased;content:\"\\F136\"}.video-object .video-thumbnail-wrapper.replay{display:block}.video-object .video-thumbnail-wrapper.replay:after{color:#fff;display:inline-block;font-family:Guroo-Producer;font-style:normal;font-weight:400;font-variant:normal;line-height:1;text-decoration:inherit;text-rendering:optimizeLegibility;text-transform:none;-moz-osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased;font-smoothing:antialiased;content:\"\\F1AA\"}}@media only screen and (min-width:376px) and (max-width:414px) and (max-height:736px) and (orientation:portrait){.video-object{margin:0}.video-object .video-thumbnail-wrapper{border:1px solid #d5d5d5}.video-object .video-thumbnail-wrapper:before{background:hsla(0,0%,100%,.5);position:absolute;top:0;left:0;right:0;bottom:0;margin:auto;font-size:30px;border-radius:50%;padding:0;line-height:0;width:50px;height:50px;content:\"\";border:3px solid #fff}.video-object .video-thumbnail-wrapper:after{height:30px;width:30px;position:absolute;top:0;left:0;right:0;bottom:0;margin:auto;font-size:30px}.video-object .video-thumbnail-wrapper:hover{cursor:pointer}.video-object .video-thumbnail-wrapper:hover:before{-webkit-box-shadow:0 0 10px 3px #ead146;-moz-box-shadow:0 0 10px 3px #ead146;box-shadow:0 0 10px 3px #ead146}.video-object .video-thumbnail-wrapper.play{display:block;color:#fff}.video-object .video-thumbnail-wrapper.play:after{display:inline-block;font-family:Guroo-Producer;font-style:normal;font-weight:400;font-variant:normal;line-height:1;text-decoration:inherit;text-rendering:optimizeLegibility;text-transform:none;-moz-osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased;font-smoothing:antialiased;content:\"\\F136\"}.video-object .video-thumbnail-wrapper.replay{display:block}.video-object .video-thumbnail-wrapper.replay:after{color:#fff;display:inline-block;font-family:Guroo-Producer;font-style:normal;font-weight:400;font-variant:normal;line-height:1;text-decoration:inherit;text-rendering:optimizeLegibility;text-transform:none;-moz-osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased;font-smoothing:antialiased;content:\"\\F1AA\"}}@media only screen and (min-height:376px) and (max-height:414px) and (max-width:736px) and (orientation:landscape){.video-object{margin:0}.video-object .video-thumbnail-wrapper{border:1px solid #d5d5d5}.video-object .video-thumbnail-wrapper:before{background:hsla(0,0%,100%,.5);position:absolute;top:0;left:0;right:0;bottom:0;margin:auto;font-size:30px;border-radius:50%;padding:0;line-height:0;width:50px;height:50px;content:\"\";border:3px solid #fff}.video-object .video-thumbnail-wrapper:after{height:30px;width:30px;position:absolute;top:0;left:0;right:0;bottom:0;margin:auto;font-size:30px}.video-object .video-thumbnail-wrapper:hover{cursor:pointer}.video-object .video-thumbnail-wrapper:hover:before{-webkit-box-shadow:0 0 10px 3px #ead146;-moz-box-shadow:0 0 10px 3px #ead146;box-shadow:0 0 10px 3px #ead146}.video-object .video-thumbnail-wrapper.play{display:block;color:#fff}.video-object .video-thumbnail-wrapper.play:after{display:inline-block;font-family:Guroo-Producer;font-style:normal;font-weight:400;font-variant:normal;line-height:1;text-decoration:inherit;text-rendering:optimizeLegibility;text-transform:none;-moz-osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased;font-smoothing:antialiased;content:\"\\F136\"}.video-object .video-thumbnail-wrapper.replay{display:block}.video-object .video-thumbnail-wrapper.replay:after{color:#fff;display:inline-block;font-family:Guroo-Producer;font-style:normal;font-weight:400;font-variant:normal;line-height:1;text-decoration:inherit;text-rendering:optimizeLegibility;text-transform:none;-moz-osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased;font-smoothing:antialiased;content:\"\\F1AA\"}}@media only screen and (max-width:375px) and (min-height:737px) and (max-height:812px) and (orientation:portrait){.video-object{margin:0}.video-object .video-thumbnail-wrapper{border:1px solid #d5d5d5}.video-object .video-thumbnail-wrapper:before{background:hsla(0,0%,100%,.5);position:absolute;top:0;left:0;right:0;bottom:0;margin:auto;font-size:30px;border-radius:50%;padding:0;line-height:0;width:50px;height:50px;content:\"\";border:3px solid #fff}.video-object .video-thumbnail-wrapper:after{height:30px;width:30px;position:absolute;top:0;left:0;right:0;bottom:0;margin:auto;font-size:30px}.video-object .video-thumbnail-wrapper:hover{cursor:pointer}.video-object .video-thumbnail-wrapper:hover:before{-webkit-box-shadow:0 0 10px 3px #ead146;-moz-box-shadow:0 0 10px 3px #ead146;box-shadow:0 0 10px 3px #ead146}.video-object .video-thumbnail-wrapper.play{display:block;color:#fff}.video-object .video-thumbnail-wrapper.play:after{display:inline-block;font-family:Guroo-Producer;font-style:normal;font-weight:400;font-variant:normal;line-height:1;text-decoration:inherit;text-rendering:optimizeLegibility;text-transform:none;-moz-osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased;font-smoothing:antialiased;content:\"\\F136\"}.video-object .video-thumbnail-wrapper.replay{display:block}.video-object .video-thumbnail-wrapper.replay:after{color:#fff;display:inline-block;font-family:Guroo-Producer;font-style:normal;font-weight:400;font-variant:normal;line-height:1;text-decoration:inherit;text-rendering:optimizeLegibility;text-transform:none;-moz-osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased;font-smoothing:antialiased;content:\"\\F1AA\"}}@media only screen and (min-width:737px) and (max-width:812px) and (max-height:375px) and (orientation:landscape){.video-object{margin:0}.video-object .video-thumbnail-wrapper{border:1px solid #d5d5d5}.video-object .video-thumbnail-wrapper:before{background:hsla(0,0%,100%,.5);position:absolute;top:0;left:0;right:0;bottom:0;margin:auto;font-size:30px;border-radius:50%;padding:0;line-height:0;width:50px;height:50px;content:\"\";border:3px solid #fff}.video-object .video-thumbnail-wrapper:after{height:30px;width:30px;position:absolute;top:0;left:0;right:0;bottom:0;margin:auto;font-size:30px}.video-object .video-thumbnail-wrapper:hover{cursor:pointer}.video-object .video-thumbnail-wrapper:hover:before{-webkit-box-shadow:0 0 10px 3px #ead146;-moz-box-shadow:0 0 10px 3px #ead146;box-shadow:0 0 10px 3px #ead146}.video-object .video-thumbnail-wrapper.play{display:block;color:#fff}.video-object .video-thumbnail-wrapper.play:after{display:inline-block;font-family:Guroo-Producer;font-style:normal;font-weight:400;font-variant:normal;line-height:1;text-decoration:inherit;text-rendering:optimizeLegibility;text-transform:none;-moz-osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased;font-smoothing:antialiased;content:\"\\F136\"}.video-object .video-thumbnail-wrapper.replay{display:block}.video-object .video-thumbnail-wrapper.replay:after{color:#fff;display:inline-block;font-family:Guroo-Producer;font-style:normal;font-weight:400;font-variant:normal;line-height:1;text-decoration:inherit;text-rendering:optimizeLegibility;text-transform:none;-moz-osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased;font-smoothing:antialiased;content:\"\\F1AA\"}}.video-content-wrapper{height:100%!important;overflow-y:auto;margin:0;padding:16px 24px;flex-flow:row wrap;justify-content:flex-start}.video-content-wrapper,.video-content-wrapper .content-row{width:100%;display:-webkit-flex;display:flex;align-items:center}.video-content-wrapper .content-row{flex-flow:row nowrap;justify-content:center}.video-content-wrapper .video-object-wrapper{width:100%;flex:1;display:-webkit-flex;display:flex;flex-flow:row nowrap;justify-content:flex-start}.video-content-wrapper .video-object-wrapper .thumbnail-col{flex:1;padding:0 24px}.video-content-wrapper .video-object-wrapper .thumbnail-col img{width:100%;height:auto}.video-content-wrapper .video-object-wrapper .thumbnail-col:focus{outline:none!important}.video-content-wrapper .video-object-wrapper .video-col{flex:6;padding:0 24px;padding-left:0}.video-content-wrapper .video-object-wrapper .video-col.single{padding:0 140px}@media only screen and (max-width:375px) and (max-height:736px) and (orientation:portrait){.video-content-wrapper{padding:10px 0 0;align-items:flex-start}.video-content-wrapper .video-col{width:100%;padding:0 24px!important}}@media only screen and (max-height:375px) and (max-width:736px) and (orientation:landscape){.video-content-wrapper{padding:10px 0 0}.video-content-wrapper .video-object-wrapper{padding:0;text-align:center}.video-content-wrapper .video-col{width:100%;padding:0 24px!important}}@media only screen and (min-width:376px) and (max-width:414px) and (max-height:736px) and (orientation:portrait){.video-content-wrapper{padding:10px 0 0;align-items:flex-start}.video-content-wrapper .video-col{width:100%;padding:0 24px!important}}@media only screen and (min-height:376px) and (max-height:414px) and (max-width:736px) and (orientation:landscape){.video-content-wrapper{padding:10px 0 0}.video-content-wrapper .video-object-wrapper{padding:0;text-align:center}.video-content-wrapper .video-col{width:100%;padding:0 24px!important}}@media only screen and (min-width:768px) and (max-width:1024px) and (orientation:portrait){.video-content-wrapper{align-items:flex-start}}@media only screen and (max-width:375px) and (min-height:737px) and (max-height:812px) and (orientation:portrait){.video-content-wrapper{padding:10px 0 0;align-items:flex-start}.video-content-wrapper .video-col{width:100%;padding:0 24px!important}}@media only screen and (min-width:737px) and (max-width:812px) and (max-height:375px) and (orientation:landscape){.video-content-wrapper{padding:10px 0 0}.video-content-wrapper .video-object-wrapper{padding:0;text-align:center}.video-content-wrapper .video-col{width:100%;padding:0 24px!important}}.video-btn{position:relative;margin:10px 0 20px!important;-webkit-box-shadow:3px 3px 3px 2px rgba(0,0,0,.25);-moz-box-shadow:3px 3px 3px 2px rgba(0,0,0,.25);box-shadow:3px 3px 3px 2px rgba(0,0,0,.25)}.video-btn.active{border-style:solid;border-width:3px}.video-btn.focused{outline:2px solid #6592cb}.video-btn.disabled:after{content:\"\";position:absolute;display:block;left:0;top:0;width:100%;height:100%;background:hsla(0,0%,100%,.5)}.video-btn.complete:before{background:#fff;width:24px;height:24px;border-radius:50%;position:absolute;color:#39aa27;font-size:24px;top:-10px;left:-10px;display:inline-block;font-family:Guroo-Producer;font-style:normal;font-weight:400;font-variant:normal;line-height:1;text-decoration:inherit;text-rendering:optimizeLegibility;text-transform:none;-moz-osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased;font-smoothing:antialiased;content:\"\\F16F\";z-index:10000}@media only screen and (max-width:375px) and (max-height:736px) and (orientation:portrait){.video-btn{margin:0}.video-btn .object-container{margin:0!important;padding:0}}@media only screen and (max-height:375px) and (max-width:736px) and (orientation:landscape){.video-btn{margin:0;display:inline-block;width:23%;margin-right:2%!important}.video-btn:last-child{margin-right:0!important}.video-btn .object-container{margin:0!important;padding:0}.video-btn .video-details{display:none!important}}@media only screen and (min-width:376px) and (max-width:414px) and (max-height:736px) and (orientation:portrait){.video-btn{margin:0}.video-btn .object-container{margin:0!important;padding:0}}@media only screen and (min-height:376px) and (max-height:414px) and (max-width:736px) and (orientation:landscape){.video-btn{margin:0;display:inline-block;width:23%;margin-right:2%!important}.video-btn:last-child{margin-right:0!important}.video-btn .object-container{margin:0!important;padding:0}.video-btn .video-details{display:none!important}}@media only screen and (max-width:375px) and (min-height:737px) and (max-height:812px) and (orientation:portrait){.video-btn{margin:0}.video-btn .object-container{margin:0!important;padding:0}}@media only screen and (min-width:737px) and (max-width:812px) and (max-height:375px) and (orientation:landscape){.video-btn{margin:0;display:inline-block;width:23%;margin-right:2%!important}.video-btn:last-child{margin-right:0!important}.video-btn .object-container{margin:0!important;padding:0}.video-btn .video-details{display:none!important}}.content-character-expression{position:relative;float:left;overflow:hidden;left:0;top:0;margin-top:1px;margin-left:1px;height:80px!important;width:80px;background:#fff;border:4px solid #fff;border-radius:50%;-webkit-box-shadow:0 0 0 1px #d5d5d5;-moz-box-shadow:0 0 0 1px #d5d5d5;box-shadow:0 0 0 1px #d5d5d5}.content-character-expression img{width:100%;height:auto}@media only screen and (max-width:375px) and (max-height:736px) and (orientation:portrait){.content-character-expression{height:60px!important;width:60px}}@media only screen and (min-width:376px) and (max-width:414px) and (max-height:736px) and (orientation:portrait){.content-character-expression{height:60px!important;width:60px}}@media only screen and (max-width:375px) and (min-height:737px) and (max-height:812px) and (orientation:portrait){.content-character-expression{height:60px!important;width:60px}}@media only screen and (max-width:320px) and (max-height:568px) and (orientation:portrait){.content-character-expression{height:60px!important;width:60px}}@media only screen and (min-width:768px) and (max-width:1024px) and (orientation:portrait){.content-character-expression{height:60px!important;width:60px}}@media only screen and (min-width:768px) and (max-width:1024px) and (orientation:landscape){.content-character-expression{height:60px!important;width:60px}}.content-character-expression+div{overflow:hidden;padding-left:0!important;padding-right:0!important;margin-left:100px!important;width:calc(100% - 100px);clear:none}.content-character-expression+div.call-out-style-1,.content-character-expression+div.call-out-style-2,.content-character-expression+div.call-out-style-3,.content-character-expression+div.call-out-style-4{padding-left:24px!important;padding-right:24px!important}.content-character-expression+div.conversation-dialog{margin-left:85px!important;width:calc(100% - 85px)}.content-character-expression+div.conversation{margin-left:85px!important;width:calc(100% - 85px)!important}@media only screen and (max-width:375px) and (max-height:736px) and (orientation:portrait){.content-character-expression+div{margin-left:80px!important;width:calc(100% - 80px)}.content-character-expression+div.call-out-style-1,.content-character-expression+div.call-out-style-2,.content-character-expression+div.call-out-style-3,.content-character-expression+div.call-out-style-4{padding-left:12px!important;padding-right:12px!important}.content-character-expression+div.conversation-dialog{margin-left:65px!important;width:calc(100% - 65px)}}@media only screen and (max-height:375px) and (max-width:736px) and (orientation:landscape){.content-character-expression+div{margin-left:80px!important;width:calc(100% - 80px)}.content-character-expression+div.call-out-style-1,.content-character-expression+div.call-out-style-2,.content-character-expression+div.call-out-style-3,.content-character-expression+div.call-out-style-4{padding-left:12px!important;padding-right:12px!important}.content-character-expression+div.conversation-dialog{margin-left:65px!important;width:calc(100% - 65px)}}@media only screen and (min-width:376px) and (max-width:414px) and (max-height:736px) and (orientation:portrait){.content-character-expression+div{margin-left:80px!important;width:calc(100% - 80px)}.content-character-expression+div.call-out-style-1,.content-character-expression+div.call-out-style-2,.content-character-expression+div.call-out-style-3,.content-character-expression+div.call-out-style-4{padding-left:12px!important;padding-right:12px!important}.content-character-expression+div.conversation-dialog{margin-left:65px!important;width:calc(100% - 65px)}}@media only screen and (min-height:376px) and (max-height:414px) and (max-width:736px) and (orientation:landscape){.content-character-expression+div{margin-left:80px!important;width:calc(100% - 80px)}.content-character-expression+div.call-out-style-1,.content-character-expression+div.call-out-style-2,.content-character-expression+div.call-out-style-3,.content-character-expression+div.call-out-style-4{padding-left:12px!important;padding-right:12px!important}.content-character-expression+div.conversation-dialog{margin-left:65px!important;width:calc(100% - 65px)}}@media only screen and (max-width:375px) and (min-height:737px) and (max-height:812px) and (orientation:portrait){.content-character-expression+div{margin-left:80px!important;width:calc(100% - 80px)}.content-character-expression+div.call-out-style-1,.content-character-expression+div.call-out-style-2,.content-character-expression+div.call-out-style-3,.content-character-expression+div.call-out-style-4{padding-left:12px!important;padding-right:12px!important}.content-character-expression+div.conversation-dialog{margin-left:65px!important;width:calc(100% - 65px)}}@media only screen and (min-width:737px) and (max-width:812px) and (max-height:375px) and (orientation:landscape){.content-character-expression+div{margin-left:80px!important;width:calc(100% - 80px)}.content-character-expression+div.call-out-style-1,.content-character-expression+div.call-out-style-2,.content-character-expression+div.call-out-style-3,.content-character-expression+div.call-out-style-4{padding-left:12px!important;padding-right:12px!important}.content-character-expression+div.conversation-dialog{margin-left:65px!important;width:calc(100% - 65px)}}@media only screen and (max-width:320px) and (max-height:568px) and (orientation:portrait){.content-character-expression+div{margin-left:80px!important;width:calc(100% - 80px)}.content-character-expression+div.call-out-style-1,.content-character-expression+div.call-out-style-2,.content-character-expression+div.call-out-style-3,.content-character-expression+div.call-out-style-4{padding-left:12px!important;padding-right:12px!important}.content-character-expression+div.conversation-dialog{margin-left:65px!important;width:calc(100% - 65px)}}@media only screen and (min-width:768px) and (max-width:1024px) and (orientation:portrait){.content-character-expression+div{margin-left:80px!important;width:calc(100% - 80px)}.content-character-expression+div.call-out-style-1,.content-character-expression+div.call-out-style-2,.content-character-expression+div.call-out-style-3,.content-character-expression+div.call-out-style-4{padding-left:12px!important;padding-right:12px!important}.content-character-expression+div.conversation-dialog{margin-left:65px!important;width:calc(100% - 65px)}}@media only screen and (min-width:768px) and (max-width:1024px) and (orientation:landscape){.content-character-expression+div{margin-left:80px!important;width:calc(100% - 80px)}.content-character-expression+div.call-out-style-1,.content-character-expression+div.call-out-style-2,.content-character-expression+div.call-out-style-3,.content-character-expression+div.call-out-style-4{padding-left:12px!important;padding-right:12px!important}.content-character-expression+div.conversation-dialog{margin-left:65px!important;width:calc(100% - 65px)}}.content-panel{background:#eff0f2;padding:16px 24px;border-radius:5px}.content-panel :last-child{margin-bottom:0}.horz-padding{padding:0 24px}@media only screen and (max-width:375px) and (max-height:736px) and (orientation:portrait){.horz-padding{padding:0}}@media only screen and (max-height:375px) and (max-width:736px) and (orientation:landscape){.horz-padding{padding:0}}@media only screen and (min-width:376px) and (max-width:414px) and (max-height:736px) and (orientation:portrait){.horz-padding{padding:0}}@media only screen and (min-height:376px) and (max-height:414px) and (max-width:736px) and (orientation:landscape){.horz-padding{padding:0}}@media only screen and (max-width:375px) and (min-height:737px) and (max-height:812px) and (orientation:portrait){.horz-padding{padding:0}}@media only screen and (min-height:737px) and (max-height:812px) and (max-width:375px) and (orientation:landscape){.horz-padding{padding:0}}@media only screen and (max-width:320px) and (max-height:568px) and (orientation:portrait){.horz-padding{padding:0}}.library-image-object{overflow:hidden;padding:5px;margin:0}.library-image-object .asset-image-wrapper{margin:0 auto;position:relative}.library-image-object .asset-image-wrapper img{height:auto;max-height:unset;width:auto;max-width:100%}.library-image-object .asset-image-wrapper.border{background:#fff;border:2px solid #d5d5d5}.library-image-object .asset-image-wrapper.padded_border{background:#fff;border:2px solid #d5d5d5;padding:4px}.library-image-object .asset-image-wrapper.padded_shadow,.library-image-object .asset-image-wrapper.shadow{background:#fff;-webkit-box-shadow:0 2px 5px 0 rgba(0,0,0,.5);-moz-box-shadow:0 2px 5px 0 rgba(0,0,0,.5);box-shadow:0 2px 5px 0 rgba(0,0,0,.5)}.library-image-object .asset-image-wrapper.padded_shadow{padding:4px}.library-image-object .asset-image-wrapper.square{display:block;overflow:hidden!important;position:relative}.library-image-object .asset-image-wrapper.square:before{display:block;content:\"\";width:100%!important;padding-top:100%}.library-image-object .asset-image-wrapper.square img{position:absolute;top:0;left:0}.library-image-object .asset-image-wrapper.square.landscape img{width:auto!important;max-width:unset!important;height:auto!important;max-height:100%!important}.library-image-object .asset-image-wrapper.square.portrait img{height:auto!important;max-height:unset!important;width:auto!important;max-width:100%!important}.library-image-object .asset-image-wrapper.square.left img,.library-image-object .asset-image-wrapper.square.top img{top:0;left:0}.library-image-object .asset-image-wrapper.square.center img{top:0;left:50%;-webkit-transform:translateX(-50%);transform:translateX(-50%)}.library-image-object .asset-image-wrapper.square.right img{top:0;left:100%;-webkit-transform:translateX(-100%);transform:translateX(-100%)}.library-image-object .asset-image-wrapper.square.middle img{left:0;top:50%;-webkit-transform:translateY(-50%);transform:translateY(-50%)}.library-image-object .asset-image-wrapper.square.bottom img{top:100%;-webkit-transform:translateY(-100%);transform:translateY(-100%);left:0}.library-image-object .asset-image-wrapper.square.padded_border:after,.library-image-object .asset-image-wrapper.square.padded_shadow:after{position:absolute;left:0;top:0;width:100%;height:100%;border:4px solid #fff;content:\"\"}.library-image-object .asset-image-wrapper.rectangle{display:block;overflow:hidden!important}.library-image-object .asset-image-wrapper.rectangle img{position:absolute;top:0;left:0}.library-image-object .asset-image-wrapper.rectangle.landscape{position:relative}.library-image-object .asset-image-wrapper.rectangle.landscape:before{display:block;content:\"\";width:100%!important;padding-top:133.33333%}.library-image-object .asset-image-wrapper.rectangle.landscape img{width:auto;max-width:unset;height:auto;max-height:100%}.library-image-object .asset-image-wrapper.rectangle.portrait{position:relative}.library-image-object .asset-image-wrapper.rectangle.portrait:before{display:block;content:\"\";width:100%!important;padding-top:75%}.library-image-object .asset-image-wrapper.rectangle.portrait img{height:auto;max-height:unset;width:auto;max-width:100%}.library-image-object .asset-image-wrapper.rectangle.left img,.library-image-object .asset-image-wrapper.rectangle.top img{top:0;left:0}.library-image-object .asset-image-wrapper.rectangle.center img{top:0;left:50%;-webkit-transform:translateX(-50%);transform:translateX(-50%)}.library-image-object .asset-image-wrapper.rectangle.right img{top:0;left:100%;-webkit-transform:translateX(-100%);transform:translateX(-100%)}.library-image-object .asset-image-wrapper.rectangle.middle img{left:0;top:50%;-webkit-transform:translateY(-50%);transform:translateY(-50%)}.library-image-object .asset-image-wrapper.rectangle.bottom img{top:100%;-webkit-transform:translateY(-100%);transform:translateY(-100%);left:0}.library-image-object .asset-image-wrapper.rectangle.padded_border:after,.library-image-object .asset-image-wrapper.rectangle.padded_shadow:after{position:absolute;left:0;top:0;width:100%;height:100%;border:4px solid #fff;content:\"\"}.library-image-object .asset-image-wrapper.circle{display:block;overflow:hidden!important;position:relative;border-radius:50%;background:#fff}.library-image-object .asset-image-wrapper.circle:before{display:block;content:\"\";width:100%!important;padding-top:100%}.library-image-object .asset-image-wrapper.circle img{position:absolute}.library-image-object .asset-image-wrapper.circle.padded_border:after,.library-image-object .asset-image-wrapper.circle.padded_shadow:after{border-radius:50%}.library-image-object .asset-image-wrapper.circle.landscape img{width:auto!important;max-width:unset!important;height:auto!important;max-height:100%!important}.library-image-object .asset-image-wrapper.circle.portrait img{height:auto!important;max-height:unset!important;width:auto!important;max-width:100%!important}.library-image-object .asset-image-wrapper.circle.left img,.library-image-object .asset-image-wrapper.circle.top img{top:0;left:0}.library-image-object .asset-image-wrapper.circle.center img{top:0;left:50%;-webkit-transform:translateX(-50%);transform:translateX(-50%)}.library-image-object .asset-image-wrapper.circle.right img{top:0;left:100%;-webkit-transform:translateX(-100%);transform:translateX(-100%)}.library-image-object .asset-image-wrapper.circle.middle img{left:0;top:50%;-webkit-transform:translateY(-50%);transform:translateY(-50%)}.library-image-object .asset-image-wrapper.circle.bottom img{top:100%;-webkit-transform:translateY(-100%);transform:translateY(-100%);left:0}.library-image-object .asset-image-wrapper.circle.padded_border:after,.library-image-object .asset-image-wrapper.circle.padded_shadow:after{position:absolute;left:0;top:0;width:100%;height:100%;border:4px solid #fff;content:\"\"}.video-transcript,.video-transcript a{color:inherit!important}.video-transcript a{display:block;position:relative;padding:10px 0 0;overflow:hidden;text-decoration:underline}.video-transcript a:before{text-decoration:none}.kpi-nav-list{margin:0;padding:0;display:-webkit-flex;display:flex;flex-flow:row nowrap;align-items:center}.kpi-nav-list .back-nav{position:relative;list-style-type:none;width:50%;text-align:center}.kpi-nav-list .back-nav:hover{cursor:pointer;opacity:.5}.kpi-nav-list .back-nav:before{text-align:center;font-size:18px;display:inline-block;font-family:Guroo-Producer;font-style:normal;font-weight:400;font-variant:normal;line-height:1;text-decoration:inherit;text-rendering:optimizeLegibility;text-transform:none;-moz-osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased;font-smoothing:antialiased;content:\"\\F12B\"}.kpi-nav-list .next-nav{position:relative;list-style-type:none;width:50%;text-align:center}.kpi-nav-list .next-nav:hover{cursor:pointer;opacity:.5}.kpi-nav-list .next-nav:before{text-align:center;font-size:18px;display:inline-block;font-family:Guroo-Producer;font-style:normal;font-weight:400;font-variant:normal;line-height:1;text-decoration:inherit;text-rendering:optimizeLegibility;text-transform:none;-moz-osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased;font-smoothing:antialiased;content:\"\\F13B\"}.kpi-nav-list .kpi-indicator{cursor:pointer;transition:opacity .5s ease,color .5s ease}.kpi-nav-list .kpi-indicator:hover{opacity:.8}.kpi-nav-list .kpi-indicator:before{font-size:16px;height:16px;width:24px;text-align:center;margin:auto}.kpi-nav-list .kpi-indicator.incomplete:before,.kpi-nav-list .kpi-indicator:before{display:inline-block;font-family:Guroo-Producer;font-style:normal;font-weight:400;font-variant:normal;line-height:1;text-decoration:inherit;text-rendering:optimizeLegibility;text-transform:none;-moz-osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased;font-smoothing:antialiased;content:\"\\F16A\"}.kpi-nav-list .kpi-indicator.incomplete:before{color:#999}.kpi-nav-list .kpi-indicator.complete:before{color:#39aa27;display:inline-block;font-family:Guroo-Producer;font-style:normal;font-weight:400;font-variant:normal;line-height:1;text-decoration:inherit;text-rendering:optimizeLegibility;text-transform:none;-moz-osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased;font-smoothing:antialiased;content:\"\\F16F\"}.icon-first{position:relative;padding:0}.icon-first:before{font-family:Guroo-Producer;text-align:center;padding:0;margin:0 4px 0 0;line-height:100%;font-size:130%;vertical-align:center}h1.icon-first:before{margin:0 10px 0 0}.icon-red.icon-first:before{margin:0 10px 0 0;color:#c00}li.icon-first{list-style-type:none;margin:4px 0}li.icon-first:before{margin:0 8px 0 0}.video-icon.icon-first{position:relative;padding-left:28px}.video-icon.icon-first:before{top:1px;left:0;font-size:24px;position:absolute}.navIcon.icon-first{position:relative;padding-left:32px}.navIcon.icon-first:before{left:10px;top:6px;position:absolute;font-size:150%}.dialog-title.icon-first{padding:0}.dialog-title.icon-first:before{margin:0 8px 0 0}.large-text-icon.icon-first{padding:0;font-size:130%;padding-right:35px}.large-text-icon.icon-first:before{font-size:150%;position:absolute;right:0;top:-3px}.close-btn.icon-first{padding:0;padding-right:26px}.close-btn.icon-first:before{position:absolute;right:0;top:1px;font-weight:700}.dialog-container{display:block;position:absolute;left:0;right:0;margin:auto;overflow:hidden;max-height:770px;margin:0 auto!important;max-width:1200px!important;min-width:320px!important}@media only screen and (max-width:375px) and (max-height:736px) and (orientation:portrait){.dialog-container{height:100%!important;min-height:100vh!important}}@media only screen and (max-height:375px) and (max-width:736px) and (orientation:landscape){.dialog-container{height:100%!important;min-height:100vh!important}}@media only screen and (min-width:376px) and (max-width:414px) and (max-height:736px) and (orientation:portrait){.dialog-container{height:100%!important;min-height:100vh}}@media only screen and (min-height:376px) and (max-height:414px) and (max-width:736px) and (orientation:landscape){.dialog-container{height:100%!important;min-height:100vh!important}}@media only screen and (max-width:375px) and (min-height:737px) and (max-height:812px) and (orientation:portrait){.dialog-container{height:100%!important;min-height:100vh}}@media only screen and (min-width:737px) and (max-width:812px) and (max-height:375px) and (orientation:landscape){.dialog-container{height:100%!important;min-height:100vh!important}}@media only screen and (min-width:768px) and (max-width:1024px) and (orientation:landscape){.dialog-container{height:100%!important;min-height:664px}}@media only screen and (min-width:768px) and (max-width:1024px) and (orientation:portrait){.dialog-container{height:100%!important;min-height:924px}}@media only screen and (max-width:320px) and (max-height:568px) and (orientation:portrait){.dialog-container{height:100%!important;min-height:100vh!important}}.full-page-overflow{display:block;position:fixed;top:0;left:0;width:100%;height:100%;background:hsla(0,0%,100%,.7);z-index:1000}.dialog-page{z-index:99999999!important;opacity:0;padding:50px 100px;box-sizing:border-box}.dialog-page,.dialog-page:before{display:block;position:absolute;top:0;left:0;width:100%;height:100%}.dialog-page:before{background:rgba(0,0,0,.5);content:\"\"}.dialog-page .click-reveal-dialog{position:absolute;left:0;right:0;margin:auto;width:75%;height:calc(100% - 140px);border-radius:5px;overflow:visible;transition:all .2s ease-in-out}.dialog-page .click-reveal-dialog .dialog-header{padding:8px 12px;border-top-left-radius:5px;border-top-right-radius:5px;cursor:pointer}.dialog-page .click-reveal-dialog .dialog-header:after{position:absolute;top:8px;right:6px;font-size:100%;display:inline-block;font-family:Guroo-Producer;font-style:normal;font-weight:400;font-variant:normal;line-height:1;text-decoration:inherit;text-rendering:optimizeLegibility;text-transform:none;-moz-osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased;font-smoothing:antialiased;content:\"\\F125\"}.dialog-page .click-reveal-dialog .dialog-body{position:relative;display:block;background:#fff;height:auto;max-height:100%;width:100%;padding:8px 12px;overflow:hidden;overflow-y:scroll;-webkit-box-shadow:3px 11px 5px -9px rgba(0,0,0,.5);-moz-box-shadow:3px 11px 5px -9px rgba(0,0,0,.5);box-shadow:3px 11px 5px -9px rgba(0,0,0,.5);border-bottom-left-radius:5px;border-bottom-right-radius:5px}.dialog-page .content-dialog{position:absolute;top:0;right:0;width:60%;height:100%;transition:right .6s linear}@media only screen and (max-width:736px) and (orientation:portrait){.dialog-page .content-dialog{width:100%;transition:right .3s linear}}@media only screen and (max-height:375px) and (max-width:736px) and (orientation:landscape){.dialog-page .content-dialog{width:60%}}@media only screen and (min-width:768px) and (max-width:1024px) and (orientation:portrait){.dialog-page .content-dialog{width:60%}}.dialog-page .content-dialog .dialog-header{padding:8px 12px;cursor:pointer}.dialog-page .content-dialog .dialog-header .dialog-title{font-size:130%}.dialog-page .content-dialog .dialog-body{position:absolute;display:block;height:auto;max-height:calc(100% - 45px);width:100%;padding:16px 24px;overflow:hidden;overflow-y:scroll}.dialog-page .content-dialog .dialog-body p{margin-bottom:10px}.dialog-page .content-dialog .dialog-body p:last-child{margin-bottom:0}@media only screen and (max-width:375px) and (max-height:736px) and (orientation:portrait){.dialog-page .content-dialog .dialog-body{padding:10px 12px}.dialog-page .content-dialog .dialog-body .learner-action{padding:16px 24px;padding-bottom:0}.dialog-page .content-dialog .dialog-body .learner-action .feedback-panel{margin-left:-24px;margin-right:-24px}.dialog-page .content-dialog .dialog-body .learner-action .multiple-choice-option-list{margin:0 -24px;padding:0}.dialog-page .content-dialog .dialog-body .learner-action .multiple-choice-option-list .feedback-panel{margin:0}.dialog-page .content-dialog .dialog-body .learner-action .multiple-choice-option-list .feedback-panel .object-container{padding-left:24px;padding-right:24px}.dialog-page .content-dialog .dialog-body .learner-action .multiple-choice-option-list .multiple-choice-option .feedback-panel{padding:16px 24px!important}}@media only screen and (max-height:375px) and (max-width:736px) and (orientation:landscape){.dialog-page .content-dialog .dialog-body{padding:10px 12px}.dialog-page .content-dialog .dialog-body .learner-action{padding:16px 24px;padding-bottom:0}.dialog-page .content-dialog .dialog-body .learner-action .feedback-panel{margin-left:-24px;margin-right:-24px}.dialog-page .content-dialog .dialog-body .learner-action .multiple-choice-option-list{margin:0 -24px;padding:0}.dialog-page .content-dialog .dialog-body .learner-action .multiple-choice-option-list .feedback-panel{margin:0}.dialog-page .content-dialog .dialog-body .learner-action .multiple-choice-option-list .feedback-panel .object-container{padding-left:24px;padding-right:24px}.dialog-page .content-dialog .dialog-body .learner-action .multiple-choice-option-list .multiple-choice-option .feedback-panel{padding:16px 24px!important}}@media only screen and (min-width:376px) and (max-width:414px) and (max-height:736px) and (orientation:portrait){.dialog-page .content-dialog .dialog-body{padding:10px 12px}.dialog-page .content-dialog .dialog-body .learner-action{padding:16px 24px;padding-bottom:0}.dialog-page .content-dialog .dialog-body .learner-action .feedback-panel{margin-left:-24px;margin-right:-24px}.dialog-page .content-dialog .dialog-body .learner-action .multiple-choice-option-list{margin:0 -24px;padding:0}.dialog-page .content-dialog .dialog-body .learner-action .multiple-choice-option-list .feedback-panel{margin:0}.dialog-page .content-dialog .dialog-body .learner-action .multiple-choice-option-list .feedback-panel .object-container{padding-left:24px;padding-right:24px}.dialog-page .content-dialog .dialog-body .learner-action .multiple-choice-option-list .multiple-choice-option .feedback-panel{padding:16px 24px!important}}@media only screen and (min-height:376px) and (max-height:414px) and (max-width:736px) and (orientation:landscape){.dialog-page .content-dialog .dialog-body{padding:10px 12px}.dialog-page .content-dialog .dialog-body .learner-action{padding:16px 24px;padding-bottom:0}.dialog-page .content-dialog .dialog-body .learner-action .feedback-panel{margin-left:-24px;margin-right:-24px}.dialog-page .content-dialog .dialog-body .learner-action .multiple-choice-option-list{margin:0 -24px;padding:0}.dialog-page .content-dialog .dialog-body .learner-action .multiple-choice-option-list .feedback-panel{margin:0}.dialog-page .content-dialog .dialog-body .learner-action .multiple-choice-option-list .feedback-panel .object-container{padding-left:24px;padding-right:24px}.dialog-page .content-dialog .dialog-body .learner-action .multiple-choice-option-list .multiple-choice-option .feedback-panel{padding:16px 24px!important}}@media only screen and (max-width:375px) and (min-height:737px) and (max-height:812px) and (orientation:portrait){.dialog-page .content-dialog .dialog-body{padding:10px 12px}.dialog-page .content-dialog .dialog-body .learner-action{padding:16px 24px;padding-bottom:0}.dialog-page .content-dialog .dialog-body .learner-action .feedback-panel{margin-left:-24px;margin-right:-24px}.dialog-page .content-dialog .dialog-body .learner-action .multiple-choice-option-list{margin:0 -24px;padding:0}.dialog-page .content-dialog .dialog-body .learner-action .multiple-choice-option-list .feedback-panel{margin:0}.dialog-page .content-dialog .dialog-body .learner-action .multiple-choice-option-list .feedback-panel .object-container{padding-left:24px;padding-right:24px}.dialog-page .content-dialog .dialog-body .learner-action .multiple-choice-option-list .multiple-choice-option .feedback-panel{padding:16px 24px!important}}@media only screen and (min-width:737px) and (max-width:812px) and (max-height:375px) and (orientation:landscape){.dialog-page .content-dialog .dialog-body{padding:10px 12px}.dialog-page .content-dialog .dialog-body .learner-action{padding:16px 24px;padding-bottom:0}.dialog-page .content-dialog .dialog-body .learner-action .feedback-panel{margin-left:-24px;margin-right:-24px}.dialog-page .content-dialog .dialog-body .learner-action .multiple-choice-option-list{margin:0 -24px;padding:0}.dialog-page .content-dialog .dialog-body .learner-action .multiple-choice-option-list .feedback-panel{margin:0}.dialog-page .content-dialog .dialog-body .learner-action .multiple-choice-option-list .feedback-panel .object-container{padding-left:24px;padding-right:24px}.dialog-page .content-dialog .dialog-body .learner-action .multiple-choice-option-list .multiple-choice-option .feedback-panel{padding:16px 24px!important}}.dialog-page .content-dialog.main-menu{top:0;height:100%;right:unset;left:-100%;width:60%;transition:left .6s linear}.dialog-page .content-dialog.main-menu .dialog-body{height:100%;padding:0;width:100%;max-height:calc(100% - 45px)}@media only screen and (max-width:375px) and (max-height:736px) and (orientation:portrait){.dialog-page .content-dialog.main-menu{width:100%}}@media only screen and (max-height:375px) and (max-width:736px) and (orientation:landscape){.dialog-page .content-dialog.main-menu{width:60%}}@media only screen and (min-width:376px) and (max-width:414px) and (max-height:736px) and (orientation:portrait){.dialog-page .content-dialog.main-menu{width:100%}}@media only screen and (min-height:376px) and (max-height:414px) and (max-width:736px) and (orientation:landscape){.dialog-page .content-dialog.main-menu{width:60%}}@media only screen and (max-width:375px) and (min-height:737px) and (max-height:812px) and (orientation:portrait){.dialog-page .content-dialog.main-menu{width:100%}}@media only screen and (min-width:737px) and (max-width:812px) and (max-height:375px) and (orientation:landscape){.dialog-page .content-dialog.main-menu{width:60%}}@media only screen and (min-width:768px) and (max-width:1024px) and (orientation:landscape){.dialog-page .content-dialog.main-menu{width:60%}}@media only screen and (min-width:768px) and (max-width:1024px) and (orientation:portrait){.dialog-page .content-dialog.main-menu{width:75%}}.dialog-page .content-dialog.resources{top:0;height:100%;left:unset;right:0;width:75%;transition:right .6s linear;overflow:hidden}.dialog-page .content-dialog.resources .dialog-body{width:100%;height:calc(100% - 55px);overflow-y:scroll}@media only screen and (max-width:375px) and (max-height:736px) and (orientation:portrait){.dialog-page .content-dialog.resources{width:100%}.dialog-page .content-dialog.resources .dialog-body{padding:10px 12px!important;margin-top:0!important}.dialog-page .content-dialog.resources .dialog-body .feed-anti-margin{margin-left:-12px;margin-right:-12px}}@media only screen and (max-height:375px) and (max-width:736px) and (orientation:landscape){.dialog-page .content-dialog.resources{width:100%}.dialog-page .content-dialog.resources .dialog-body{padding:10px 12px!important;margin-top:0!important}.dialog-page .content-dialog.resources .dialog-body .feed-anti-margin{margin-left:-12px;margin-right:-12px}}@media only screen and (min-height:376px) and (max-height:414px) and (max-width:736px) and (orientation:landscape){.dialog-page .content-dialog.resources{width:100%}.dialog-page .content-dialog.resources .dialog-body{padding:10px 12px!important;margin-top:0!important}.dialog-page .content-dialog.resources .dialog-body .feed-anti-margin{margin-left:-12px;margin-right:-12px}}@media only screen and (max-width:375px) and (min-height:737px) and (max-height:812px) and (orientation:portrait){.dialog-page .content-dialog.resources{width:100%}.dialog-page .content-dialog.resources .dialog-body{padding:10px 12px!important;margin-top:0!important}.dialog-page .content-dialog.resources .dialog-body .feed-anti-margin{margin-left:-12px;margin-right:-12px}}@media only screen and (min-width:737px) and (max-width:812px) and (max-height:375px) and (orientation:landscape){.dialog-page .content-dialog.resources{width:100%}.dialog-page .content-dialog.resources .dialog-body{padding:10px 12px!important;margin-top:0!important}.dialog-page .content-dialog.resources .dialog-body .feed-anti-margin{margin-left:-12px;margin-right:-12px}}@media only screen and (min-width:768px) and (max-width:1024px) and (orientation:landscape){.dialog-page .content-dialog.resources{width:100%}.dialog-page .content-dialog.resources .dialog-body{padding:10px 12px!important;margin-top:0!important}.dialog-page .content-dialog.resources .dialog-body .feed-anti-margin{margin-left:-12px;margin-right:-12px}}@media only screen and (min-width:768px) and (max-width:1024px) and (orientation:portrait){.dialog-page .content-dialog.resources{width:80%}}.dialog-page .content-dialog.performance{width:45%}@media only screen and (max-width:375px) and (max-height:736px) and (orientation:portrait){.dialog-page .content-dialog.performance{width:100%}}@media only screen and (max-height:375px) and (max-width:736px) and (orientation:landscape){.dialog-page .content-dialog.performance{width:60%}}@media only screen and (min-width:376px) and (max-width:414px) and (max-height:736px) and (orientation:portrait){.dialog-page .content-dialog.performance{width:100%}}@media only screen and (min-height:376px) and (max-height:414px) and (max-width:736px) and (orientation:landscape){.dialog-page .content-dialog.performance{width:60%}}@media only screen and (max-width:375px) and (min-height:737px) and (max-height:812px) and (orientation:portrait){.dialog-page .content-dialog.performance{width:100%}}@media only screen and (min-width:737px) and (max-width:812px) and (max-height:375px) and (orientation:landscape){.dialog-page .content-dialog.performance{width:60%}}@media only screen and (min-width:768px) and (max-width:1024px) and (orientation:portrait){.dialog-page .content-dialog.performance{width:50%}}@media only screen and (min-width:768px) and (max-width:1024px){.dialog-page .content-dialog.performance{width:50%}}.dialog-page .content-dialog.init-prompt{height:400px;width:40%;left:0;right:0;bottom:0;top:0;margin:auto;border:1px solid #fff;border-radius:5px;transition:all .2s ease-out!important;-webkit-box-shadow:0 2px 5px 0 rgba(0,0,0,.75);-moz-box-shadow:0 2px 5px 0 rgba(0,0,0,.75);box-shadow:0 2px 5px 0 rgba(0,0,0,.75)}.dialog-page .content-dialog.init-prompt .dialog-header{padding:10px 24px;cursor:default;border-top-left-radius:5px;border-top-right-radius:5px}.dialog-page .content-dialog.init-prompt .dialog-header .dialog-title{cursor:default}.dialog-page .content-dialog.init-prompt .preloader-image-container{width:150px;height:auto;margin:0 auto}.dialog-page .content-dialog.init-prompt .preloader-image-container img{max-width:100%}.dialog-page .content-dialog.init-prompt .init-prompt-content{padding-top:20px}.dialog-page .content-dialog.init-prompt .locale-prompt-content{padding-top:20px;min-height:340px}.dialog-page .content-dialog.init-prompt .locale-prompt-content .selection-menu.locale-picker{position:relative;text-align:left;width:auto!important;max-width:200px;margin:0 auto;margin-top:5px;display:block;cursor:pointer;z-index:100}@media only screen and (max-width:320px) and (max-height:736px) and (orientation:portrait){.dialog-page .content-dialog.init-prompt .locale-prompt-content .selection-menu.locale-picker{max-width:250px!important}}.dialog-page .content-dialog.init-prompt .locale-prompt-content .selection-menu.locale-picker .selection-menu-btn:focus{background:hsla(0,0%,100%,.3)}.dialog-page .content-dialog.init-prompt .locale-prompt-content .selection-menu.locale-picker:after{position:absolute;left:8px;top:8px;color:#333;font-size:20px;display:inline-block;font-family:Guroo-Producer;font-style:normal;font-weight:400;font-variant:normal;line-height:1;text-decoration:inherit;text-rendering:optimizeLegibility;text-transform:none;-moz-osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased;font-smoothing:antialiased;content:\"\\F22E\"}.dialog-page .content-dialog.init-prompt .locale-prompt-content .selection-menu.locale-picker .selected-title{position:relative;overflow:hidden;border-radius:5px;background:transparent;display:block;padding:5px 36px 4px;text-align:left;cursor:pointer;white-space:nowrap;text-overflow:ellipsis;border:1px solid #333}.dialog-page .content-dialog.init-prompt .locale-prompt-content .selection-menu.locale-picker .selected-title:before{position:absolute;left:8px;top:0;bottom:0;margin:auto;color:#333;font-size:16px;height:16px}.dialog-page .content-dialog.init-prompt .locale-prompt-content .selection-menu.locale-picker .selected-title.not-required:before{content:\"\"}.dialog-page .content-dialog.init-prompt .locale-prompt-content .selection-menu.locale-picker .selected-title.not-required:before,.dialog-page .content-dialog.init-prompt .locale-prompt-content .selection-menu.locale-picker .selected-title.not-started:before{display:inline-block;font-family:Guroo-Producer;font-style:normal;font-weight:400;font-variant:normal;line-height:1;text-decoration:inherit;text-rendering:optimizeLegibility;text-transform:none;-moz-osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased;font-smoothing:antialiased}.dialog-page .content-dialog.init-prompt .locale-prompt-content .selection-menu.locale-picker .selected-title.not-started:before{content:\"\\F16A\"}.dialog-page .content-dialog.init-prompt .locale-prompt-content .selection-menu.locale-picker .selected-title.in-progress:before{content:\"\\F182\"}.dialog-page .content-dialog.init-prompt .locale-prompt-content .selection-menu.locale-picker .selected-title.complete:before,.dialog-page .content-dialog.init-prompt .locale-prompt-content .selection-menu.locale-picker .selected-title.in-progress:before{display:inline-block;font-family:Guroo-Producer;font-style:normal;font-weight:400;font-variant:normal;line-height:1;text-decoration:inherit;text-rendering:optimizeLegibility;text-transform:none;-moz-osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased;font-smoothing:antialiased}.dialog-page .content-dialog.init-prompt .locale-prompt-content .selection-menu.locale-picker .selected-title.complete:before{content:\"\\F16F\"}.dialog-page .content-dialog.init-prompt .locale-prompt-content .selection-menu.locale-picker .menu-icon{position:absolute;top:6px;margin:auto;right:8px;display:block;width:20px;height:20px;padding:0;font-size:18px;color:#333;text-align:right}.dialog-page .content-dialog.init-prompt .locale-prompt-content .selection-menu.locale-picker .menu-icon .rotating-icon{position:absolute;left:0}.dialog-page .content-dialog.init-prompt .locale-prompt-content .selection-menu.locale-picker .menu-option-container{text-align:left;display:block;position:absolute;background:#fff;border-radius:5px;margin:5px 0 0;padding:0;height:0;left:0;overflow:hidden;width:auto;max-height:500px;overflow-y:scroll;-webkit-box-shadow:0 0 5px 0 rgba(0,0,0,.25);-moz-box-shadow:0 0 5px 0 rgba(0,0,0,.25);box-shadow:0 0 5px 0 rgba(0,0,0,.25)}@media only screen and (max-height:375px) and (max-width:736px) and (orientation:landscape){.dialog-page .content-dialog.init-prompt .locale-prompt-content .selection-menu.locale-picker .menu-option-container{max-height:180px}}@media only screen and (max-width:320px) and (max-height:736px) and (orientation:portrait){.dialog-page .content-dialog.init-prompt .locale-prompt-content .selection-menu.locale-picker .menu-option-container{max-width:250px!important}}.dialog-page .content-dialog.init-prompt .locale-prompt-content .selection-menu.locale-picker .menu-option-container .menu-option-list{display:block;margin:0;padding:0;overflow:hidden!important;border-radius:5px}.dialog-page .content-dialog.init-prompt .locale-prompt-content .selection-menu.locale-picker .menu-option-container .menu-option-list .option-item{display:block;padding:0;margin:0;list-style-type:none;overflow:hidden!important}.dialog-page .content-dialog.init-prompt .locale-prompt-content .selection-menu.locale-picker .menu-option-container .menu-option-list .option-item .option-label{display:block;position:relative;width:100%;margin:0;padding:6px 12px;text-decoration:none;cursor:pointer;overflow:hidden;white-space:nowrap;text-overflow:ellipsis}.dialog-page .content-dialog.init-prompt .locale-prompt-content .selection-menu.locale-picker .menu-option-container .menu-option-list .option-item .option-label.active,.dialog-page .content-dialog.init-prompt .locale-prompt-content .selection-menu.locale-picker .menu-option-container .menu-option-list .option-item .option-label:hover{background-color:#eff0f2}.dialog-page .content-dialog.init-prompt .locale-prompt-content .selection-menu.locale-picker .menu-option-container .menu-option-list .option-item .option-label:before{position:absolute;left:8px;top:0;bottom:0;margin:auto;font-size:16px;height:16px}.dialog-page .content-dialog.init-prompt .locale-prompt-content .selection-menu.locale-picker .menu-option-container .menu-option-list .option-item .option-label.not-required:before{display:inline-block;font-family:Guroo-Producer;font-style:normal;font-weight:400;font-variant:normal;line-height:1;text-decoration:inherit;text-rendering:optimizeLegibility;text-transform:none;-moz-osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased;font-smoothing:antialiased;content:\"\"}.dialog-page .content-dialog.init-prompt .locale-prompt-content .selection-menu.locale-picker .menu-option-container .menu-option-list .option-item .option-label.not-started:before{display:inline-block;font-family:Guroo-Producer;font-style:normal;font-weight:400;font-variant:normal;line-height:1;text-decoration:inherit;text-rendering:optimizeLegibility;text-transform:none;-moz-osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased;font-smoothing:antialiased;content:\"\\F16A\"}.dialog-page .content-dialog.init-prompt .locale-prompt-content .selection-menu.locale-picker .menu-option-container .menu-option-list .option-item .option-label.in-progress:before{display:inline-block;font-family:Guroo-Producer;font-style:normal;font-weight:400;font-variant:normal;line-height:1;text-decoration:inherit;text-rendering:optimizeLegibility;text-transform:none;-moz-osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased;font-smoothing:antialiased;content:\"\\F182\"}.dialog-page .content-dialog.init-prompt .locale-prompt-content .selection-menu.locale-picker .menu-option-container .menu-option-list .option-item .option-label.complete:before{display:inline-block;font-family:Guroo-Producer;font-style:normal;font-weight:400;font-variant:normal;line-height:1;text-decoration:inherit;text-rendering:optimizeLegibility;text-transform:none;-moz-osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased;font-smoothing:antialiased;content:\"\\F16F\"}.dialog-page .content-dialog.init-prompt .locale-prompt-content .selection-menu.locale-picker .menu-option-container .menu-option-list .option-item.child .option-label{padding-left:56px!important}.dialog-page .content-dialog.init-prompt .locale-prompt-content .selection-menu.locale-picker .menu-option-container .menu-option-list .option-item.child .option-label:before{left:30px}.dialog-page .content-dialog.init-prompt .locale-prompt-content .selection-menu.locale-picker .menu-option-container .menu-option-list .option-item:first-child .option-label{border-top-left-radius:5px!important;border-top-right-radius:5px!important;padding-top:8px}.dialog-page .content-dialog.init-prompt .locale-prompt-content .selection-menu.locale-picker .menu-option-container .menu-option-list .option-item:last-child .option-label{padding-bottom:8px;border-bottom-left-radius:5px!important;border-bottom-right-radius:5px!important}.dialog-page .content-dialog.init-prompt .locale-prompt-content .selection-menu.locale-picker .menu-option-container .menu-option-list .option-item .menu-option-list .option-label{display:block;padding:6px 12px 6px 24px}.dialog-page .content-dialog.init-prompt .locale-prompt-content .selection-menu.locale-picker .menu-option-container .menu-option-list .option-item .menu-option-list:first-child .option-label{padding-top:6px}.dialog-page .content-dialog.init-prompt .locale-prompt-content .selection-menu.locale-picker .menu-option-container .menu-option-list .option-item .menu-option-list:last-child .option-label{padding-bottom:6px}.dialog-page .content-dialog.init-prompt .locale-prompt-content .selection-menu.locale-picker .menu-option-container .option-label{padding-left:32px!important}@media only screen and (max-width:375px) and (max-height:736px) and (orientation:portrait){.dialog-page .content-dialog.init-prompt{width:90%;height:90%}.dialog-page .content-dialog.init-prompt .dialog-header{font-size:90%;padding:10px 12px}.dialog-page .content-dialog.init-prompt .preloader-image-container{width:120px;height:auto;margin:0 auto}.dialog-page .content-dialog.init-prompt .preloader-image-container img{max-width:100%}}@media only screen and (max-height:375px) and (max-width:736px) and (orientation:landscape){.dialog-page .content-dialog.init-prompt{width:90%;height:90%}.dialog-page .content-dialog.init-prompt .dialog-header{font-size:90%;padding:10px 12px}.dialog-page .content-dialog.init-prompt .preloader-image-container{width:120px;height:auto;margin:0 auto}.dialog-page .content-dialog.init-prompt .preloader-image-container img{max-width:100%}}@media only screen and (min-width:376px) and (max-width:414px) and (max-height:736px) and (orientation:portrait){.dialog-page .content-dialog.init-prompt{width:90%;height:90%}.dialog-page .content-dialog.init-prompt .dialog-header{font-size:90%;padding:10px 12px}.dialog-page .content-dialog.init-prompt .preloader-image-container{width:120px;height:auto;margin:0 auto}.dialog-page .content-dialog.init-prompt .preloader-image-container img{max-width:100%}}@media only screen and (min-height:376px) and (max-height:414px) and (max-width:736px) and (orientation:landscape){.dialog-page .content-dialog.init-prompt{width:90%;height:90%}.dialog-page .content-dialog.init-prompt .dialog-header{font-size:90%;padding:10px 12px}.dialog-page .content-dialog.init-prompt .preloader-image-container{width:120px;height:auto;margin:0 auto}.dialog-page .content-dialog.init-prompt .preloader-image-container img{max-width:100%}}@media only screen and (max-width:375px) and (min-height:737px) and (max-height:812px) and (orientation:portrait){.dialog-page .content-dialog.init-prompt{width:90%;height:90%}.dialog-page .content-dialog.init-prompt .dialog-header{font-size:90%;padding:10px 12px}.dialog-page .content-dialog.init-prompt .preloader-image-container{width:120px;height:auto;margin:0 auto}.dialog-page .content-dialog.init-prompt .preloader-image-container img{max-width:100%}}@media only screen and (min-width:737px) and (max-width:812px) and (max-height:375px) and (orientation:landscape){.dialog-page .content-dialog.init-prompt{width:90%;height:90%}.dialog-page .content-dialog.init-prompt .dialog-header{font-size:90%;padding:10px 12px}.dialog-page .content-dialog.init-prompt .preloader-image-container{width:120px;height:auto;margin:0 auto}.dialog-page .content-dialog.init-prompt .preloader-image-container img{max-width:100%}}.dialog-page .asset-content-dialog{position:absolute;left:0;right:0;top:0;bottom:0;margin:auto;height:90%;width:70%;overflow:visible}.dialog-page .asset-content-dialog .dialog-header{text-align:right;color:#fff;padding:8px 12px}.dialog-page .asset-content-dialog .dialog-header .close-btn{color:#fff;cursor:pointer;transition:opacity .3s ease-in}.dialog-page .asset-content-dialog .dialog-header .close-btn:hover{opacity:.7}.dialog-page .asset-content-dialog .dialog-body{height:100%;overflow-y:auto}.dialog-page .asset-content-dialog .dialog-body .asset-dialog-image{overflow:hidden;transition:width .3s ease-in-out;margin:0 auto;width:0}.dialog-page .asset-content-dialog .dialog-body .asset-dialog-image.portrait{width:auto;height:50%}.dialog-page .asset-content-dialog .dialog-body .asset-dialog-image.landscape{width:100%}.dialog-page .asset-content-dialog .dialog-body .asset-dialog-image .close-btn{color:#fff;text-align:right;cursor:pointer;transition:opacity .3s ease-in}.dialog-page .asset-content-dialog .dialog-body .asset-dialog-image .close-btn:hover{opacity:.7}.dialog-page .asset-content-dialog .dialog-body .asset-dialog-image .asset-img-container{border:1px solid #d5d5d5;padding:6px;background:#fff}.dialog-page .asset-content-dialog .dialog-body .asset-dialog-image .asset-img-container .img-container img{width:100%;height:auto}.dialog-page .asset-content-dialog .dialog-body .asset-dialog-image .asset-img-container .asset-desc{padding:12px 5px 0;text-align:left}.dialog-page .asset-content-dialog .dialog-body .asset-dialog-image .asset-img-container .asset-desc .title{font-weight:700;padding:0 0 5px}.dialog-page .asset-content-dialog.dialog-asset-image{position:absolute;left:0;right:0;top:unset;transition:.3s ease-in-out;margin:auto;height:96%;width:94%;overflow:visible}.dialog-page .asset-content-dialog.dialog-asset-image .dialog-body{height:100%;width:100%;overflow:hidden}.dialog-page .asset-content-dialog.dialog-asset-image .dialog-body .component-seperator,.dialog-page .asset-content-dialog.dialog-asset-image .dialog-body .object-container{position:absolute;height:100%;width:100%;left:0;top:0}.dialog-page .asset-content-dialog.dialog-asset-image .dialog-body .asset-dialog-image{position:absolute;height:100%;width:100%;left:0;top:0;overflow:hidden;margin:0 auto;border-top-left-radius:5px;border-top-right-radius:5px}.dialog-page .asset-content-dialog.dialog-asset-image .dialog-body .asset-dialog-image .asset-image-header{position:relative;height:50px;display:-webkit-flex;display:flex;flex-flow:row nowrap;align-items:center}.dialog-page .asset-content-dialog.dialog-asset-image .dialog-body .asset-dialog-image .asset-image-header .title-col{padding:0 15px;flex:3}.dialog-page .asset-content-dialog.dialog-asset-image .dialog-body .asset-dialog-image .asset-image-header .title-col .title{position:relative;padding:6px 0}.dialog-page .asset-content-dialog.dialog-asset-image .dialog-body .asset-dialog-image .asset-image-header .title-col .title:before{position:absolute;left:0;top:2px;font-size:32px}.dialog-page .asset-content-dialog.dialog-asset-image .dialog-body .asset-dialog-image .asset-image-header .title-col .title.not-required:before{display:inline-block;font-family:Guroo-Producer;font-style:normal;font-weight:400;font-variant:normal;line-height:1;text-decoration:inherit;text-rendering:optimizeLegibility;text-transform:none;-moz-osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased;font-smoothing:antialiased;content:\"\"}.dialog-page .asset-content-dialog.dialog-asset-image .dialog-body .asset-dialog-image .asset-image-header .title-col .title.not-started{padding:6px 0 6px 40px}.dialog-page .asset-content-dialog.dialog-asset-image .dialog-body .asset-dialog-image .asset-image-header .title-col .title.not-started:before{display:inline-block;font-family:Guroo-Producer;font-style:normal;font-weight:400;font-variant:normal;line-height:1;text-decoration:inherit;text-rendering:optimizeLegibility;text-transform:none;-moz-osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased;font-smoothing:antialiased;content:\"\\F16A\"}.dialog-page .asset-content-dialog.dialog-asset-image .dialog-body .asset-dialog-image .asset-image-header .title-col .title.in-progress{padding:6px 0 6px 40px}.dialog-page .asset-content-dialog.dialog-asset-image .dialog-body .asset-dialog-image .asset-image-header .title-col .title.in-progress:before{display:inline-block;font-family:Guroo-Producer;font-style:normal;font-weight:400;font-variant:normal;line-height:1;text-decoration:inherit;text-rendering:optimizeLegibility;text-transform:none;-moz-osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased;font-smoothing:antialiased;content:\"\\F182\"}.dialog-page .asset-content-dialog.dialog-asset-image .dialog-body .asset-dialog-image .asset-image-header .title-col .title.complete{padding:6px 0 6px 40px}.dialog-page .asset-content-dialog.dialog-asset-image .dialog-body .asset-dialog-image .asset-image-header .title-col .title.complete:before{display:inline-block;font-family:Guroo-Producer;font-style:normal;font-weight:400;font-variant:normal;line-height:1;text-decoration:inherit;text-rendering:optimizeLegibility;text-transform:none;-moz-osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased;font-smoothing:antialiased;content:\"\\F16F\"}@media only screen and (max-width:375px) and (max-height:736px) and (orientation:portrait){.dialog-page .asset-content-dialog.dialog-asset-image .dialog-body .asset-dialog-image .asset-image-header .title-col{flex:2}}@media only screen and (min-width:376px) and (max-width:414px) and (max-height:736px) and (orientation:portrait){.dialog-page .asset-content-dialog.dialog-asset-image .dialog-body .asset-dialog-image .asset-image-header .title-col{flex:2}}@media only screen and (max-width:375px) and (min-height:737px) and (max-height:812px) and (orientation:portrait){.dialog-page .asset-content-dialog.dialog-asset-image .dialog-body .asset-dialog-image .asset-image-header .title-col{flex:2}}.dialog-page .asset-content-dialog.dialog-asset-image .dialog-body .asset-dialog-image .asset-image-header .nav-col{flex:3;text-align:right;padding:0 5px}.dialog-page .asset-content-dialog.dialog-asset-image .dialog-body .asset-dialog-image .asset-image-header .icon-btn-group{margin-right:40px}@media only screen and (max-width:375px) and (max-height:736px) and (orientation:portrait){.dialog-page .asset-content-dialog.dialog-asset-image .dialog-body .asset-dialog-image .asset-image-header .icon-btn-group{margin-right:10px}}@media only screen and (min-width:376px) and (max-width:414px) and (max-height:736px) and (orientation:portrait){.dialog-page .asset-content-dialog.dialog-asset-image .dialog-body .asset-dialog-image .asset-image-header .icon-btn-group{margin-right:10px}}@media only screen and (max-width:375px) and (min-height:737px) and (max-height:812px) and (orientation:portrait){.dialog-page .asset-content-dialog.dialog-asset-image .dialog-body .asset-dialog-image .asset-image-header .icon-btn-group{margin-right:10px}}.dialog-page .asset-content-dialog.dialog-asset-image .dialog-body .asset-dialog-image .asset-image-header .icon-btn-group button{font-size:24px!important;line-height:0;padding:4px 6px}.dialog-page .asset-content-dialog.dialog-asset-image .dialog-body .asset-dialog-image .asset-image-header .icon-btn-group button:active,.dialog-page .asset-content-dialog.dialog-asset-image .dialog-body .asset-dialog-image .asset-image-header .icon-btn-group button:focus{box-shadow:none!important;outline:0 none!important}.dialog-page .asset-content-dialog.dialog-asset-image .dialog-body .asset-dialog-image .asset-img-container{position:absolute;height:calc(100% - 50px);width:100%;left:0;top:50px;padding:20px 30px;overflow:auto}.dialog-page .asset-content-dialog.dialog-asset-image .dialog-body .asset-dialog-image .asset-img-container .img-container{transition:height .3s ease-in-out}.dialog-page .asset-content-dialog.dialog-asset-image .dialog-body .asset-dialog-image .asset-img-container.portrait .img-container{height:95%;text-align:center;overflow:auto!important}.dialog-page .asset-content-dialog.dialog-asset-image .dialog-body .asset-dialog-image .asset-img-container.portrait .img-container img{width:auto!important;height:100%}.dialog-page .asset-content-dialog.dialog-asset-image .dialog-body .asset-dialog-image .asset-img-container.landscape .img-container{max-width:100%;overflow:auto;text-align:center}.dialog-page .asset-content-dialog.dialog-asset-image .dialog-body .asset-dialog-image .asset-img-container.landscape .img-container img{width:unset!important;max-width:100%}.dialog-page .asset-content-dialog.dialog-asset-image .dialog-body .asset-dialog-image .asset-img-container .video-wrapper{position:relative;height:95%;overflow:hidden}.dialog-page .asset-content-dialog.dialog-asset-image .dialog-body .asset-dialog-image .asset-img-container .video-wrapper video{position:absolute;height:100%!important;width:auto!important;left:0;right:0;margin:auto}.dialog-page .asset-content-dialog.dialog-asset-image .dialog-body .asset-dialog-image .asset-img-container .video-wrapper iframe{position:absolute;height:100%!important;width:100%!important;left:0;right:0;margin:auto}.dialog-page .asset-content-dialog.dialog-asset-image .dialog-body .asset-dialog-image .asset-img-container .video-js-container{position:relative;height:95%;overflow:hidden}.dialog-page .asset-content-dialog.dialog-asset-image .dialog-body .asset-dialog-image .asset-img-container .video-js-container .video-js{position:absolute;height:100%!important;width:auto!important;left:0;right:0;margin:auto}.dialog-page .asset-content-dialog.dialog-asset-image .dialog-body .asset-dialog-image .asset-img-container .video-js-container .video-js .vjs-big-play-button{top:0;bottom:0;left:0;right:0;margin:auto;width:2em}.dialog-page .asset-content-dialog.dialog-asset-image .dialog-body .asset-dialog-image .asset-img-container .asset-desc{position:relative;padding:12px 15px 0;text-align:left}.dialog-page .asset-content-dialog.dialog-asset-image .dialog-body .asset-dialog-image .asset-img-container .video-thumbnail-wrapper{display:none!important;position:absolute;top:0;left:0;width:100%;height:100%;overflow:hidden;background:#d5d5d5}.dialog-page .asset-content-dialog.dialog-asset-image .dialog-body .asset-dialog-image .asset-img-container .video-thumbnail-wrapper:before{background:hsla(0,0%,100%,.5);position:absolute;top:0;left:0;right:0;bottom:0;margin:auto;font-size:40px;border-radius:50%;padding:0;line-height:0;width:60px;height:60px;content:\"\";border:3px solid #fff}.dialog-page .asset-content-dialog.dialog-asset-image .dialog-body .asset-dialog-image .asset-img-container .video-thumbnail-wrapper:after{height:40px;width:40px;position:absolute;top:0;left:0;right:0;bottom:0;margin:auto;font-size:40px}.dialog-page .asset-content-dialog.dialog-asset-image .dialog-body .asset-dialog-image .asset-img-container .video-thumbnail-wrapper:hover{cursor:pointer}.dialog-page .asset-content-dialog.dialog-asset-image .dialog-body .asset-dialog-image .asset-img-container .video-thumbnail-wrapper:hover:before{-webkit-box-shadow:0 0 10px 3px #ead146;-moz-box-shadow:0 0 10px 3px #ead146;box-shadow:0 0 10px 3px #ead146}.dialog-page .asset-content-dialog.dialog-asset-image .dialog-body .asset-dialog-image .asset-img-container .video-thumbnail-wrapper.play{display:block}.dialog-page .asset-content-dialog.dialog-asset-image .dialog-body .asset-dialog-image .asset-img-container .video-thumbnail-wrapper.play:after{display:inline-block;font-family:Guroo-Producer;font-style:normal;font-weight:400;font-variant:normal;line-height:1;text-decoration:inherit;text-rendering:optimizeLegibility;text-transform:none;-moz-osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased;font-smoothing:antialiased;content:\"\\F136\"}.dialog-page .asset-content-dialog.dialog-asset-image .dialog-body .asset-dialog-image .asset-img-container .video-thumbnail-wrapper.replay{display:block}.dialog-page .asset-content-dialog.dialog-asset-image .dialog-body .asset-dialog-image .asset-img-container .video-thumbnail-wrapper.replay:after{display:inline-block;font-family:Guroo-Producer;font-style:normal;font-weight:400;font-variant:normal;line-height:1;text-decoration:inherit;text-rendering:optimizeLegibility;text-transform:none;-moz-osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased;font-smoothing:antialiased;content:\"\\F1AA\"}.dialog-page .asset-content-dialog.dialog-asset-image .dialog-body .asset-dialog-image .asset-img-container .video-thumbnail-wrapper img{width:100%;overflow:hidden}.dialog-page .asset-content-dialog.dialog-asset-image .dialog-body .asset-dialog-image .asset-img-container .video-thumbnail-wrapper .video-details{display:block;width:100%;position:absolute;bottom:0;padding:16px 24px;background:rgba(0,0,0,.6);font-size:85%;overflow:hidden}.dialog-page .asset-content-dialog.dialog-asset-image .dialog-body .asset-dialog-image .asset-img-container .video-thumbnail-wrapper .video-details h4{font-size:110%;position:relative}.dialog-page .asset-content-dialog.dialog-asset-image .dialog-body .asset-dialog-image .asset-img-container .video-thumbnail-wrapper .video-details h4.not-viewed{padding:0 0 0 16px}.dialog-page .asset-content-dialog.dialog-asset-image .dialog-body .asset-dialog-image .asset-img-container .video-thumbnail-wrapper .video-details h4.not-viewed:before{position:absolute;left:-8px;top:4px;color:#999;padding-right:10px;display:inline-block;font-family:Guroo-Producer;font-style:normal;font-weight:400;font-variant:normal;line-height:1;text-decoration:inherit;text-rendering:optimizeLegibility;text-transform:none;-moz-osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased;font-smoothing:antialiased;content:\"\\F16A\"}.dialog-page .asset-content-dialog.dialog-asset-image .dialog-body .asset-dialog-image .asset-img-container .video-thumbnail-wrapper .video-details h4.viewed{padding:0 0 0 16px}.dialog-page .asset-content-dialog.dialog-asset-image .dialog-body .asset-dialog-image .asset-img-container .video-thumbnail-wrapper .video-details h4.viewed:before{position:absolute;left:-8px;top:4px;color:#39aa27;padding-right:10px;display:inline-block;font-family:Guroo-Producer;font-style:normal;font-weight:400;font-variant:normal;line-height:1;text-decoration:inherit;text-rendering:optimizeLegibility;text-transform:none;-moz-osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased;font-smoothing:antialiased;content:\"\\F16F\"}@media only screen and (max-width:375px) and (max-height:736px) and (orientation:portrait){.dialog-page .asset-content-dialog.dialog-asset-image .dialog-body .asset-dialog-image .asset-img-container .video-thumbnail-wrapper .video-details{display:none}}@media only screen and (min-width:376px) and (max-width:414px) and (max-height:736px) and (orientation:portrait){.dialog-page .asset-content-dialog.dialog-asset-image .dialog-body .asset-dialog-image .asset-img-container .video-thumbnail-wrapper .video-details{display:none}}@media only screen and (max-width:375px) and (min-height:737px) and (max-height:812px) and (orientation:portrait){.dialog-page .asset-content-dialog.dialog-asset-image .dialog-body .asset-dialog-image .asset-img-container .video-thumbnail-wrapper .video-details{display:none}}@media (min-width:320px) and (max-width:480px){.dialog-page .asset-content-dialog.dialog-asset-image .dialog-body .asset-dialog-image .asset-img-container{padding-left:12px;padding-right:12px}}.dialog-page .screen-dialog{position:absolute;height:90%;width:70%;overflow:hidden}.dialog-page .screen-dialog.large_dialog{border-top-right-radius:5px;border-top-left-radius:5px;top:unset;transition:bottom .3s ease-in-out;margin:auto;height:96%;width:94%;left:0;right:0;bottom:0}.dialog-page .screen-dialog.small_dialog{border-radius:5px;transition:.3s ease-in-out;margin:auto;height:70%;width:60%;left:0;right:0;bottom:0;top:0}.dialog-page .screen-dialog.left_small_flyout{right:unset;width:50%}.dialog-page .screen-dialog.left_large_flyout,.dialog-page .screen-dialog.left_small_flyout{height:100%;bottom:0;top:0;transition:left .3s ease-in-out}.dialog-page .screen-dialog.right_small_flyout{width:50%}.dialog-page .screen-dialog.right_large_flyout,.dialog-page .screen-dialog.right_small_flyout{height:100%;bottom:0;top:0;transition:right .3s ease-in-out}.dialog-page .screen-dialog .dialog-header{position:relative;height:50px;display:-webkit-flex;display:flex;flex-flow:row nowrap;align-items:center}.dialog-page .screen-dialog .dialog-header .title-col{padding:0 15px;flex:3}.dialog-page .screen-dialog .dialog-header .title-col .title{position:relative;padding:6px 0}.dialog-page .screen-dialog .dialog-header .title-col .title:before{position:absolute;left:0;top:2px;font-size:32px}.dialog-page .screen-dialog .dialog-header .title-col .title.not-required:before{margin-right:0;content:\"\"}.dialog-page .screen-dialog .dialog-header .title-col .title.not-started{padding:6px 0 6px 40px}.dialog-page .screen-dialog .dialog-header .title-col .title.not-started:before{display:inline-block;font-family:Guroo-Producer;font-style:normal;font-weight:400;font-variant:normal;line-height:1;text-decoration:inherit;text-rendering:optimizeLegibility;text-transform:none;-moz-osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased;font-smoothing:antialiased;content:\"\\F16A\"}.dialog-page .screen-dialog .dialog-header .title-col .title.in-progress{padding:6px 0 6px 40px}.dialog-page .screen-dialog .dialog-header .title-col .title.in-progress:before{display:inline-block;font-family:Guroo-Producer;font-style:normal;font-weight:400;font-variant:normal;line-height:1;text-decoration:inherit;text-rendering:optimizeLegibility;text-transform:none;-moz-osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased;font-smoothing:antialiased;content:\"\\F182\"}.dialog-page .screen-dialog .dialog-header .title-col .title.complete{padding:6px 0 6px 40px}.dialog-page .screen-dialog .dialog-header .title-col .title.complete:before{display:inline-block;font-family:Guroo-Producer;font-style:normal;font-weight:400;font-variant:normal;line-height:1;text-decoration:inherit;text-rendering:optimizeLegibility;text-transform:none;-moz-osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased;font-smoothing:antialiased;content:\"\\F16F\"}.dialog-page .screen-dialog .dialog-header .nav-col{flex:2;text-align:right;padding:0 15px}.dialog-page .screen-dialog .dialog-header .icon-btn-group{margin-right:40px}.dialog-page .screen-dialog .dialog-header .icon-btn-group button{font-size:24px!important;line-height:0;padding:4px 6px}.dialog-page .screen-dialog .dialog-header .icon-btn-group button:active,.dialog-page .screen-dialog .dialog-header .icon-btn-group button:focus{box-shadow:none!important;outline:0 none!important}.dialog-page .screen-dialog .dialog-body{height:calc(100% - 50px);overflow-y:hidden!important;position:relative;background:#fff}.dialog-page .screen-dialog .dialog-body.scenario{overflow-y:hidden!important;padding-top:0}.dialog-page .screen-dialog .dialog-body .content-wrapper{position:absolute;height:100%;overflow-y:auto!important;width:100%;margin:0 auto;box-shadow:none}.dialog-page .screen-dialog .dialog-body .content-wrapper .content-area{height:100%;width:100%;margin:0 auto;box-shadow:none}@media only screen and (min-width:768px) and (max-width:1024px) and (orientation:landscape){.dialog-page .screen-dialog .dialog-body .content-wrapper .content-area{width:100%!important;margin:0!important}}@media only screen and (min-width:768px) and (max-width:1024px) and (orientation:portrait){.dialog-page .screen-dialog .dialog-body .content-wrapper .content-area{width:100%!important;margin:0!important}}.dialog-page .screen-dialog .dialog-body .character-stage{display:block;float:left;width:40%;height:inherit;padding:40px 0 0;z-index:2;height:100%;position:absolute}@media only screen and (max-width:900px){.dialog-page .screen-dialog .dialog-body .character-stage{float:none;clear:both;margin:0;width:100%;height:inherit;z-index:2}}@media only screen and (max-width:375px) and (max-height:736px) and (orientation:portrait){.dialog-page .screen-dialog .dialog-body .character-stage{float:none;clear:both;margin:0;width:100%;height:inherit;z-index:2}}@media only screen and (max-height:375px) and (max-width:736px) and (orientation:landscape){.dialog-page .screen-dialog .dialog-body .character-stage{float:none;clear:both;margin:0;width:100%;height:inherit;z-index:2}}@media only screen and (min-width:376px) and (max-width:414px) and (max-height:736px) and (orientation:portrait){.dialog-page .screen-dialog .dialog-body .character-stage{float:none;clear:both;margin:0;width:100%;height:inherit;z-index:2}}@media only screen and (min-height:376px) and (max-height:414px) and (max-width:736px) and (orientation:landscape){.dialog-page .screen-dialog .dialog-body .character-stage{float:none;clear:both;margin:0;width:100%;height:inherit;z-index:2}}@media only screen and (max-width:375px) and (min-height:737px) and (max-height:812px) and (orientation:portrait){.dialog-page .screen-dialog .dialog-body .character-stage{float:none;clear:both;margin:0;width:100%;height:inherit;z-index:2}}@media only screen and (min-width:737px) and (max-width:812px) and (max-height:375px) and (orientation:landscape){.dialog-page .screen-dialog .dialog-body .character-stage{float:none;clear:both;margin:0;width:100%;height:inherit;z-index:2}}@media only screen and (min-width:768px) and (max-width:1024px) and (orientation:portrait){.dialog-page .screen-dialog .dialog-body .character-stage{float:none;clear:both;margin:0;width:100%;height:inherit;z-index:2}}@media only screen and (max-width:320px) and (max-height:568px) and (orientation:portrait){.dialog-page .screen-dialog .dialog-body .character-stage{float:none;clear:both;margin:0;width:100%;height:inherit;z-index:2}}.dialog-page .screen-dialog .dialog-body .character-stage .close_up{display:block;position:relative;text-align:center;height:100%;width:auto;margin:0 auto;bottom:0;z-index:2}.dialog-page .screen-dialog .dialog-body .character-stage .close_up img{position:absolute;left:-12%;right:0;bottom:0!important;width:125%;height:auto;z-index:0}@media only screen and (max-width:900px){.dialog-page .screen-dialog .dialog-body .character-stage .close_up img{height:100%;width:auto;left:0;right:0;margin:auto}}@media only screen and (max-width:375px) and (max-height:736px) and (orientation:portrait){.dialog-page .screen-dialog .dialog-body .character-stage .close_up img{width:100%;height:auto;left:0;right:0;margin:auto}}@media only screen and (max-height:375px) and (max-width:736px) and (orientation:landscape){.dialog-page .screen-dialog .dialog-body .character-stage .close_up img{height:120%;width:auto;left:0;right:0;margin:auto;bottom:unset}}@media only screen and (min-width:376px) and (max-width:414px) and (max-height:736px) and (orientation:portrait){.dialog-page .screen-dialog .dialog-body .character-stage .close_up img{width:100%;height:auto;left:0;right:0;margin:auto}}@media only screen and (min-height:376px) and (max-height:414px) and (max-width:736px) and (orientation:landscape){.dialog-page .screen-dialog .dialog-body .character-stage .close_up img{height:120%;width:auto;left:0;right:0;margin:auto;bottom:unset}}@media only screen and (max-width:375px) and (min-height:737px) and (max-height:812px) and (orientation:portrait){.dialog-page .screen-dialog .dialog-body .character-stage .close_up img{width:100%;height:auto;left:0;right:0;margin:auto}}@media only screen and (min-width:737px) and (max-width:812px) and (max-height:375px) and (orientation:landscape){.dialog-page .screen-dialog .dialog-body .character-stage .close_up img{height:120%;width:auto;left:0;right:0;margin:auto;bottom:unset}}@media only screen and (min-width:768px) and (max-width:1024px) and (orientation:portrait){.dialog-page .screen-dialog .dialog-body .character-stage .close_up img{height:auto;width:90%;left:0;right:0;margin:auto;min-width:0}}.dialog-page .screen-dialog .dialog-body .character-stage .standing{position:relative;text-align:center;height:100%;max-height:100%;width:auto;margin:0 auto;bottom:0}.dialog-page .screen-dialog .dialog-body .character-stage .standing img{position:absolute;left:0;right:0;margin:auto!important;bottom:0;width:auto;height:auto;max-height:100%;max-width:100%}@media only screen and (max-height:375px) and (max-width:736px) and (orientation:landscape){.dialog-page .screen-dialog .dialog-body .character-stage .standing img{height:120%}}@media only screen and (min-height:376px) and (max-height:414px) and (max-width:736px) and (orientation:landscape){.dialog-page .screen-dialog .dialog-body .character-stage .standing img{height:120%}}@media only screen and (min-width:768px) and (max-width:1024px) and (orientation:portrait){.dialog-page .screen-dialog .dialog-body .character-stage .standing img{height:90%;width:auto;min-width:0;left:0;right:0;margin:auto}}.dialog-page .screen-dialog .dialog-body .object-feed{position:absolute;left:40%;top:0;width:60%;height:inherit;z-index:4;overflow-y:scroll;transition:height 1s ease-out;right:0;padding-bottom:20px;height:100%}.dialog-page .screen-dialog .dialog-body .object-feed .feed-object-container{padding:16px 24px;padding-top:0;padding-bottom:10px;margin:0;line-height:130%}.dialog-page .screen-dialog .dialog-body .object-feed .feed-object-container:first-child{margin-top:20px}.dialog-page .screen-dialog .dialog-body .object-feed .feed-object-container:last-child{margin-bottom:20px;position:sticky;bottom:0}.dialog-page .screen-dialog .dialog-body .object-feed .feed-object-container p{margin:0 0 8px}.dialog-page .screen-dialog .dialog-body .object-feed .feed-object-container p:last-child{margin:0}.dialog-page .screen-dialog .dialog-body .object-feed .feed-object-container .content-dialogs .object-container:last-child{margin-bottom:20px}@media only screen and (max-width:375px) and (max-height:736px) and (orientation:portrait){.dialog-page .screen-dialog .dialog-body .object-feed .feed-object-container{overflow:hidden;padding:4px 12px}.dialog-page .screen-dialog .dialog-body .object-feed .feed-object-container .feedback-panel{padding:10px 12px;margin:0 -12px}.dialog-page .screen-dialog .dialog-body .object-feed .feed-object-container .question-wrapper .question-prompt.object-container{background:transparent!important;border:none!important;padding:0 24px 0 0!important}}@media only screen and (max-height:375px) and (max-width:736px) and (orientation:landscape){.dialog-page .screen-dialog .dialog-body .object-feed .feed-object-container{overflow:hidden;padding:4px 12px}.dialog-page .screen-dialog .dialog-body .object-feed .feed-object-container .feedback-panel{padding:10px 12px;margin:0 -12px}.dialog-page .screen-dialog .dialog-body .object-feed .feed-object-container .question-wrapper .question-prompt.object-container{background:transparent!important;border:none!important;padding:0 24px 0 0!important}}@media only screen and (min-width:376px) and (max-width:414px) and (max-height:736px) and (orientation:portrait){.dialog-page .screen-dialog .dialog-body .object-feed .feed-object-container{overflow:hidden;padding:4px 12px}.dialog-page .screen-dialog .dialog-body .object-feed .feed-object-container .feedback-panel{padding:10px 12px;margin:0 -12px}.dialog-page .screen-dialog .dialog-body .object-feed .feed-object-container .question-wrapper .question-prompt.object-container{background:transparent!important;border:none!important;padding:0 24px 0 0!important}}@media only screen and (min-height:376px) and (max-height:414px) and (max-width:736px) and (orientation:landscape){.dialog-page .screen-dialog .dialog-body .object-feed .feed-object-container{overflow:hidden;padding:4px 12px}.dialog-page .screen-dialog .dialog-body .object-feed .feed-object-container .feedback-panel{padding:10px 12px;margin:0 -12px}.dialog-page .screen-dialog .dialog-body .object-feed .feed-object-container .question-wrapper .question-prompt.object-container{background:transparent!important;border:none!important;padding:0 24px 0 0!important}}@media only screen and (max-width:375px) and (min-height:737px) and (max-height:812px) and (orientation:portrait){.dialog-page .screen-dialog .dialog-body .object-feed .feed-object-container{overflow:hidden;padding:4px 12px}.dialog-page .screen-dialog .dialog-body .object-feed .feed-object-container .feedback-panel{padding:10px 12px;margin:0 -12px}.dialog-page .screen-dialog .dialog-body .object-feed .feed-object-container .question-wrapper .question-prompt.object-container{background:transparent!important;border:none!important;padding:0 24px 0 0!important}}@media only screen and (min-width:737px) and (max-width:812px) and (max-height:375px) and (orientation:landscape){.dialog-page .screen-dialog .dialog-body .object-feed .feed-object-container{overflow:hidden;padding:4px 12px}.dialog-page .screen-dialog .dialog-body .object-feed .feed-object-container .feedback-panel{padding:10px 12px;margin:0 -12px}.dialog-page .screen-dialog .dialog-body .object-feed .feed-object-container .question-wrapper .question-prompt.object-container{background:transparent!important;border:none!important;padding:0 24px 0 0!important}}.dialog-page .screen-dialog .dialog-body .object-feed .feed-object-container .object-container.toolbox_link{margin:0!important}.dialog-page .screen-dialog .dialog-body .object-feed .feed-object-container .learner-action-option.answered:before,.dialog-page .screen-dialog .dialog-body .object-feed .feed-object-container .learner-action-option.review-selected:before,.dialog-page .screen-dialog .dialog-body .object-feed .feed-object-container .learner-action-option.review:before,.dialog-page .screen-dialog .dialog-body .object-feed .feed-object-container .learner-action-option.selected:before,.dialog-page .screen-dialog .dialog-body .object-feed .feed-object-container .learner-action-option.show-answer:before{left:24px!important}.dialog-page .screen-dialog .dialog-body .object-feed .feed-object-container .learner-action-option.answered:after{right:18px!important}@media only screen and (min-width:200px) and (max-width:900px) and (orientation:landscape){.dialog-page .screen-dialog .dialog-body .object-feed{position:absolute;width:100%;margin-left:0;left:0;top:unset;bottom:0;height:auto;max-height:701px;overflow-y:auto;-webkit-box-shadow:none;-moz-box-shadow:none;box-shadow:none;padding-bottom:0}.dialog-page .screen-dialog .dialog-body .object-feed .feed-object-container:last-child{padding-bottom:0}}@media only screen and (min-width:200px) and (max-width:1023px) and (orientation:portrait){.dialog-page .screen-dialog .dialog-body .object-feed{position:absolute;width:100%;margin-left:0;left:0;top:unset;bottom:0;height:auto;max-height:701px;overflow-y:auto;-webkit-box-shadow:none;-moz-box-shadow:none;box-shadow:none;padding-bottom:0}.dialog-page .screen-dialog .dialog-body .object-feed .feed-object-container:last-child{padding-bottom:0}}@media only screen and (max-width:375px) and (max-height:736px) and (orientation:portrait){.dialog-page .screen-dialog .dialog-body .object-feed{position:absolute;width:100%;margin-left:0;left:0;top:unset;bottom:0;height:auto;max-height:calc(100vh - 60px - 9px);-webkit-box-shadow:none;-moz-box-shadow:none;box-shadow:none;padding-bottom:0}.dialog-page .screen-dialog .dialog-body .object-feed .feed-object-container:last-child{padding-bottom:0}}@media only screen and (max-height:375px) and (max-width:736px) and (orientation:landscape){.dialog-page .screen-dialog .dialog-body .object-feed{position:absolute;width:100%;margin-left:0;left:0;top:unset;bottom:0;height:auto;max-height:calc(100vh - 60px - 9px);-webkit-box-shadow:none;-moz-box-shadow:none;box-shadow:none;padding-bottom:0}.dialog-page .screen-dialog .dialog-body .object-feed .feed-object-container:last-child{padding-bottom:0}}@media only screen and (min-width:376px) and (max-width:414px) and (max-height:736px) and (orientation:portrait){.dialog-page .screen-dialog .dialog-body .object-feed{position:absolute;width:100%;margin-left:0;left:0;top:unset;bottom:0;height:auto;max-height:calc(100vh - 60px - 9px);-webkit-box-shadow:none;-moz-box-shadow:none;box-shadow:none;padding-bottom:0}.dialog-page .screen-dialog .dialog-body .object-feed .feed-object-container:last-child{padding-bottom:0}}@media only screen and (min-height:376px) and (max-height:414px) and (max-width:736px) and (orientation:landscape){.dialog-page .screen-dialog .dialog-body .object-feed{position:absolute;width:100%;margin-left:0;left:0;top:unset;bottom:0;height:auto;max-height:calc(100vh - 60px - 9px);-webkit-box-shadow:none;-moz-box-shadow:none;box-shadow:none;padding-bottom:0}.dialog-page .screen-dialog .dialog-body .object-feed .feed-object-container:last-child{padding-bottom:0}}@media only screen and (max-width:375px) and (min-height:737px) and (max-height:812px) and (orientation:portrait){.dialog-page .screen-dialog .dialog-body .object-feed{position:absolute;width:100%;margin-left:0;left:0;top:unset;bottom:0;height:auto;max-height:calc(100vh - 60px - 9px);-webkit-box-shadow:none;-moz-box-shadow:none;box-shadow:none;padding-bottom:0}.dialog-page .screen-dialog .dialog-body .object-feed .feed-object-container:last-child{padding-bottom:0}}@media only screen and (min-width:737px) and (max-width:812px) and (max-height:375px) and (orientation:landscape){.dialog-page .screen-dialog .dialog-body .object-feed{position:absolute;width:100%;margin-left:0;left:0;top:unset;bottom:0;height:auto;max-height:calc(100vh - 60px - 9px);-webkit-box-shadow:none;-moz-box-shadow:none;box-shadow:none;padding-bottom:0}.dialog-page .screen-dialog .dialog-body .object-feed .feed-object-container:last-child{padding-bottom:0}}@media only screen and (min-width:768px) and (max-width:1024px) and (orientation:portrait){.dialog-page .screen-dialog .dialog-body .object-feed{position:absolute;width:100%;margin-left:0;left:0;top:unset;bottom:0;height:auto;max-height:855px;overflow-y:auto;-webkit-box-shadow:none;-moz-box-shadow:none;box-shadow:none;padding-bottom:0}.dialog-page .screen-dialog .dialog-body .object-feed .feed-object-container:last-child{padding-bottom:0}}@media only screen and (max-width:320px) and (max-height:568px) and (orientation:portrait){.dialog-page .screen-dialog .dialog-body .object-feed{position:absolute;width:100%;margin-left:0;left:0;top:unset;bottom:0;height:auto;max-height:calc(100vh - 60px - 9px);-webkit-box-shadow:none;-moz-box-shadow:none;box-shadow:none;padding-bottom:0}.dialog-page .screen-dialog .dialog-body .object-feed .feed-object-container:last-child{padding-bottom:0}}@media only screen and (max-width:320px) and (max-height:568px) and (orientation:landscape){.dialog-page .screen-dialog .dialog-body .object-feed{position:absolute;width:100%;margin-left:0;left:0;top:unset;bottom:0;height:auto;max-height:calc(100vh - 60px - 9px);-webkit-box-shadow:none;-moz-box-shadow:none;box-shadow:none;padding-bottom:0}.dialog-page .screen-dialog .dialog-body .object-feed .feed-object-container:last-child{padding-bottom:0}}.dialog-page .screen-dialog .dialog-body .customer-scenario .screen-container{padding:0}.dialog-page.dialog-open .content-dialog{right:0}.dialog-page.dialog-open .content-dialog.main-menu{right:unset;left:0}.dialog-page.dialog-open .content-dialog.init-prompt{right:0;top:0;opacity:1}.dialog-page.dialog-open .click-reveal-dialog{opacity:1;top:40px}.dialog-page.dialog-open .dialog-asset,.dialog-page.dialog-open .dialog-asset-image,.dialog-page.dialog-open .large_dialog{bottom:0}.dialog-page.dialog-open .small_dialog{top:-100px;opacity:1}.dialog-page.dialog-open .left_large_flyout,.dialog-page.dialog-open .left_small_flyout{left:0}.dialog-page.dialog-open .right_large_flyout,.dialog-page.dialog-open .right_small_flyout{right:0}.dialog-page.dialog-closed .content-dialog{right:-100%}.dialog-page.dialog-closed .content-dialog.main-menu{right:unset;left:-100%}.dialog-page.dialog-closed .content-dialog.init-prompt{top:50px;opacity:0;right:0}.dialog-page.dialog-closed .click-reveal-dialog{opacity:0;top:50px}.dialog-page.dialog-closed .dialog-asset,.dialog-page.dialog-closed .dialog-asset-image,.dialog-page.dialog-closed .large_dialog{bottom:-100%}.dialog-page.dialog-closed .small_dialog{top:40px;opacity:0}.dialog-page.dialog-closed .left_large_flyout,.dialog-page.dialog-closed .left_small_flyout{left:-100%}.dialog-page.dialog-closed .right_large_flyout,.dialog-page.dialog-closed .right_small_flyout{right:-100%}.main-menu-nav{display:block;margin:0;padding:0;overflow:hidden}.main-menu-nav .menu-nav-item{display:block;position:relative;overflow:hidden;list-style-type:none;margin:0;padding:5px 16px 5px 32px;border-left:6px solid transparent;cursor:pointer}.main-menu-nav .menu-nav-item:first-child{border-top:1px solid #ccc}.main-menu-nav .menu-nav-item:before{position:absolute;left:8px;top:0;bottom:0;height:15px;margin:auto}.main-menu-nav .menu-nav-item.not-required:before{content:\"\"}.main-menu-nav .menu-nav-item.not-required:before,.main-menu-nav .menu-nav-item.not-started:before{color:#999;padding-right:10px;display:inline-block;font-family:Guroo-Producer;font-style:normal;font-weight:400;font-variant:normal;line-height:1;text-decoration:inherit;text-rendering:optimizeLegibility;text-transform:none;-moz-osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased;font-smoothing:antialiased}.main-menu-nav .menu-nav-item.not-started:before{font-size:16px;content:\"\\F16A\"}.main-menu-nav .menu-nav-item.in-progress:before{color:#f6ad17;content:\"\\F182\"}.main-menu-nav .menu-nav-item.complete:before,.main-menu-nav .menu-nav-item.in-progress:before{padding-right:10px;font-size:16px;display:inline-block;font-family:Guroo-Producer;font-style:normal;font-weight:400;font-variant:normal;line-height:1;text-decoration:inherit;text-rendering:optimizeLegibility;text-transform:none;-moz-osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased;font-smoothing:antialiased}.main-menu-nav .menu-nav-item.complete:before{color:#39aa27;content:\"\\F16F\"}.main-menu-nav .menu-nav-item.disabled{color:#d5d5d5}.main-menu-nav .menu-nav-item.disabled:hover{cursor:not-allowed;color:#d5d5d5}.main-menu-nav .menu-nav-item.disabled:before{color:#d5d5d5!important}.main-menu-nav .menu-nav-accordion{display:block;list-style-type:none;margin:0;position:relative;background:#eff0f2;border-bottom:1px solid #d5d5d5;overflow:hidden}.main-menu-nav .menu-nav-accordion:first-child{border-top:1px solid #ccc}.main-menu-nav .menu-nav-accordion .menu-nav-accordion-btn{cursor:pointer;display:block;position:relative;background:#eff0f2;overflow:hidden}.main-menu-nav .menu-nav-accordion .menu-nav-accordion-btn:before{position:absolute;left:12px;top:0;bottom:0;margin:auto;height:16px}.main-menu-nav .menu-nav-accordion .menu-nav-accordion-btn:after{position:absolute;right:12px;top:0;bottom:0;margin:auto;height:24px}.main-menu-nav .menu-nav-accordion .menu-nav-accordion-btn.not-required:before{content:\"\"}.main-menu-nav .menu-nav-accordion .menu-nav-accordion-btn.not-required:before,.main-menu-nav .menu-nav-accordion .menu-nav-accordion-btn.not-started:before{color:#999;padding-right:10px;display:inline-block;font-family:Guroo-Producer;font-style:normal;font-weight:400;font-variant:normal;line-height:1;text-decoration:inherit;text-rendering:optimizeLegibility;text-transform:none;-moz-osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased;font-smoothing:antialiased}.main-menu-nav .menu-nav-accordion .menu-nav-accordion-btn.not-started:before{font-size:16px;content:\"\\F16A\"}.main-menu-nav .menu-nav-accordion .menu-nav-accordion-btn.in-progress:before{color:#f6ad17;content:\"\\F182\"}.main-menu-nav .menu-nav-accordion .menu-nav-accordion-btn.complete:before,.main-menu-nav .menu-nav-accordion .menu-nav-accordion-btn.in-progress:before{padding-right:10px;font-size:16px;display:inline-block;font-family:Guroo-Producer;font-style:normal;font-weight:400;font-variant:normal;line-height:1;text-decoration:inherit;text-rendering:optimizeLegibility;text-transform:none;-moz-osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased;font-smoothing:antialiased}.main-menu-nav .menu-nav-accordion .menu-nav-accordion-btn.complete:before{color:#39aa27;content:\"\\F16F\"}.main-menu-nav .menu-nav-accordion .menu-nav-accordion-btn.open:after{content:\"\\F10D\"}.main-menu-nav .menu-nav-accordion .menu-nav-accordion-btn.closed:after,.main-menu-nav .menu-nav-accordion .menu-nav-accordion-btn.open:after{display:inline-block;font-family:Guroo-Producer;font-style:normal;font-weight:400;font-variant:normal;line-height:1;text-decoration:inherit;text-rendering:optimizeLegibility;text-transform:none;-moz-osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased;font-smoothing:antialiased;font-size:24px}.main-menu-nav .menu-nav-accordion .menu-nav-accordion-btn.closed:after{content:\"\\F111\"}.main-menu-nav .menu-nav-accordion .menu-nav-accordion-btn.closed .accordion-list{height:0;overflow:hidden!important}.main-menu-nav .menu-nav-accordion .menu-nav-accordion-btn .label-padding{padding:5px 16px 5px 32px;border-left:6px solid transparent}.main-menu-nav .menu-nav-accordion .accordion-list{margin:0;padding:0;position:relative;height:0;background:#fff}.main-menu-nav .menu-nav-accordion.disabled{color:#d5d5d5}.main-menu-nav .menu-nav-accordion.disabled:hover{cursor:not-allowed;color:#d5d5d5}.main-menu-nav .menu-nav-accordion.disabled:after,.main-menu-nav .menu-nav-accordion.disabled:before{color:#d5d5d5!important}.blur.on{-webkit-filter:blur(2px);filter:blur(2px)}.blur.off{-webkit-filter:blur(0);filter:blur(0)}.form-group{padding:0;margin:0 0 8px}.label{display:block;color:#999;font-weight:400;text-transform:uppercase;font-size:12px;padding:1px 0 1px 12px;margin-bottom:3px;text-align:left;clear:both;white-space:normal;line-height:130%}.label .sub-label,.label a{text-transform:none}.title-label{display:block;color:#333;font-weight:400;text-transform:uppercase;font-size:14px;padding:1px 0 10px 12px;margin-bottom:3px;text-align:left;clear:both}.title-label .sub-label,.title-label a{text-transform:none}.focus-label{position:relative;z-index:1000}.focus-label label{position:absolute;opacity:0;transition:opacity .3s ease-in-out;padding:4px 8px;border:1px solid #d5d5d5;top:-20px;background:#fff;-webkit-box-shadow:0 3px 5px 0 rgba(0,0,0,.25);-moz-box-shadow:0 3px 5px 0 rgba(0,0,0,.25);box-shadow:0 3px 5px 0 rgba(0,0,0,.25)}.focus-label.active label,.focus-label:hover label{opacity:1}.focus-label a,.focus-label a:focus{-webkit-box-shadow:none!important;box-shadow:none!important;border:none;outline:0}.form-control,input.form-control{margin:0 0 5px;background:transparent!important;-webkit-box-shadow:none;-moz-box-shadow:none;box-shadow:none}.form-control.color-picker-input,input.form-control.color-picker-input{margin:0}.form-control.inlineField,input.form-control.inlineField{display:inline-block}.form-control.disabled,.form-control:disabled,input.form-control.disabled,input.form-control:disabled{background:#fff;border-color:#edeef0;box-shadow:none;margin:0;color:#6592cb!important}.form-control.disabled.inlineField,.form-control:disabled.inlineField,input.form-control.disabled.inlineField,input.form-control:disabled.inlineField{padding-bottom:10px;border-bottom-right-radius:0!important;border-top-right-radius:0!important;border-right:none;display:inline-block;width:75%}.form-control.disabled.editable,.form-control:disabled.editable,input.form-control.disabled.editable,input.form-control:disabled.editable{cursor:pointer}.form-control.disabled.editable:hover,.form-control:disabled.editable:hover,input.form-control.disabled.editable:hover,input.form-control:disabled.editable:hover{background:#eff0f2}.form-control.disabled.editable.focus-out,.form-control:disabled.editable.focus-out,input.form-control.disabled.editable.focus-out,input.form-control:disabled.editable.focus-out{border-color:transparent;-webkit-animation:focus-highlight .5s ease-in-out;-moz-animation:focus-highlight .5s ease-in-out;-ms-animation:focus-highlight .5s ease-in-out;-o-animation:focus-highlight .5s ease-in-out;animation:focus-highlight .5s ease-in-out;box-shadow:none;outline:0 none}.form-control.disabled-look,input.form-control.disabled-look{background:#fff;border-color:#edeef0;box-shadow:none;margin:0;color:#6592cb!important;cursor:pointer}.form-control.disabled-look:focus,.form-control.disabled-look:hover,input.form-control.disabled-look:focus,input.form-control.disabled-look:hover{background:#eff0f2!important}.form-control.disabled-look.focus-out,input.form-control.disabled-look.focus-out{border-color:transparent;-webkit-animation:focus-highlight .5s ease-in-out;-moz-animation:focus-highlight .5s ease-in-out;-ms-animation:focus-highlight .5s ease-in-out;-o-animation:focus-highlight .5s ease-in-out;animation:focus-highlight .5s ease-in-out;box-shadow:none;outline:0 none}.form-control.title-look-editable,input.form-control.title-look-editable{background:#fff;border:none;display:inline-block;font-size:2.5em;font-family:Arial Rounded MT Bold,Helvetica Rounded,Arial,sans-serif;color:#333;height:auto;cursor:pointer;margin-left:-14px;width:calc(100% - 40px)!important}.form-control.title-look-editable:focus,.form-control.title-look-editable:hover,input.form-control.title-look-editable:focus,input.form-control.title-look-editable:hover{background:#eff0f2!important}.form-control.title-look-editable.focus-out,input.form-control.title-look-editable.focus-out{border-color:transparent;-webkit-animation:focus-highlight .5s ease-in-out;-moz-animation:focus-highlight .5s ease-in-out;-ms-animation:focus-highlight .5s ease-in-out;-o-animation:focus-highlight .5s ease-in-out;animation:focus-highlight .5s ease-in-out;box-shadow:none;outline:0 none}.form-control.screen-title-look-editable,input.form-control.screen-title-look-editable{background:#fff;border:none;display:inline-block;font-size:16px;color:#333;height:auto;cursor:pointer;margin-left:-14px}.form-control.screen-title-look-editable:focus,.form-control.screen-title-look-editable:hover,input.form-control.screen-title-look-editable:focus,input.form-control.screen-title-look-editable:hover{background:#eff0f2!important}.form-control.screen-title-look-editable.focus-out,input.form-control.screen-title-look-editable.focus-out{border-color:transparent;-webkit-animation:focus-highlight .5s ease-in-out;-moz-animation:focus-highlight .5s ease-in-out;-ms-animation:focus-highlight .5s ease-in-out;-o-animation:focus-highlight .5s ease-in-out;animation:focus-highlight .5s ease-in-out;box-shadow:none;outline:0 none}.form-control.text-look-editable,input.form-control.text-look-editable{background:#fff;border:none;display:inline-block;color:#333;height:auto;cursor:pointer;margin-left:-14px}.form-control.text-look-editable:focus,.form-control.text-look-editable:hover,input.form-control.text-look-editable:focus,input.form-control.text-look-editable:hover{background:#eff0f2!important}.form-control.text-look-editable.active,input.form-control.text-look-editable.active{background:#eff0f2!important;border-color:#66afe9;outline:0;-webkit-box-shadow:inset 0 1px 1px rgba(0,0,0,.075),0 0 8px rgba(102,175,233,.6);box-shadow:inset 0 1px 1px rgba(0,0,0,.075),0 0 8px rgba(102,175,233,.6)}.form-control.text-look-editable.focus-out,input.form-control.text-look-editable.focus-out{border-color:transparent;-webkit-animation:focus-highlight .5s ease-in-out;-moz-animation:focus-highlight .5s ease-in-out;-ms-animation:focus-highlight .5s ease-in-out;-o-animation:focus-highlight .5s ease-in-out;animation:focus-highlight .5s ease-in-out;box-shadow:none;outline:0 none}.form-control.text-look-editable-no-margin,input.form-control.text-look-editable-no-margin{background:#fff;border:none;display:inline-block;color:#333;height:auto;cursor:pointer}.form-control.text-look-editable-no-margin:focus,.form-control.text-look-editable-no-margin:hover,input.form-control.text-look-editable-no-margin:focus,input.form-control.text-look-editable-no-margin:hover{background:#eff0f2!important}.form-control.text-look-editable-no-margin.active,input.form-control.text-look-editable-no-margin.active{background:#eff0f2!important;border-color:#66afe9;outline:0;-webkit-box-shadow:inset 0 1px 1px rgba(0,0,0,.075),0 0 8px rgba(102,175,233,.6);box-shadow:inset 0 1px 1px rgba(0,0,0,.075),0 0 8px rgba(102,175,233,.6)}.form-control.text-look-editable-no-margin.focus-out,input.form-control.text-look-editable-no-margin.focus-out{border-color:transparent;-webkit-animation:focus-highlight .5s ease-in-out;-moz-animation:focus-highlight .5s ease-in-out;-ms-animation:focus-highlight .5s ease-in-out;-o-animation:focus-highlight .5s ease-in-out;animation:focus-highlight .5s ease-in-out;box-shadow:none;outline:0 none}.form-control.title-look-editable-no-margin,input.form-control.title-look-editable-no-margin{background:#fff;border:none;display:inline-block;font-size:16px;font-family:Arial Rounded MT Bold,Helvetica Rounded,Arial,sans-serif;color:#333;height:auto;cursor:pointer}.form-control.title-look-editable-no-margin:focus,.form-control.title-look-editable-no-margin:hover,input.form-control.title-look-editable-no-margin:focus,input.form-control.title-look-editable-no-margin:hover{background:#eff0f2!important}.form-control.title-look-editable-no-margin.active,input.form-control.title-look-editable-no-margin.active{background:#eff0f2!important;border-color:#66afe9;outline:0;-webkit-box-shadow:inset 0 1px 1px rgba(0,0,0,.075),0 0 8px rgba(102,175,233,.6);box-shadow:inset 0 1px 1px rgba(0,0,0,.075),0 0 8px rgba(102,175,233,.6)}.form-control.title-look-editable-no-margin.focus-out,input.form-control.title-look-editable-no-margin.focus-out{border-color:transparent;-webkit-animation:focus-highlight .5s ease-in-out;-moz-animation:focus-highlight .5s ease-in-out;-ms-animation:focus-highlight .5s ease-in-out;-o-animation:focus-highlight .5s ease-in-out;animation:focus-highlight .5s ease-in-out;box-shadow:none;outline:0 none}.form-control.standard-no-margin,input.form-control.standard-no-margin{background:#fff!important;border:none;display:inline-block;padding:0;color:#333;height:auto;cursor:pointer}.form-control.standard-no-margin:focus,.form-control.standard-no-margin:hover,input.form-control.standard-no-margin:focus,input.form-control.standard-no-margin:hover{background:#fff!important}.form-control.standard-no-margin.active,input.form-control.standard-no-margin.active{background:#fff!important;border-color:#66afe9;outline:0;-webkit-box-shadow:inset 0 1px 1px rgba(0,0,0,.075),0 0 8px rgba(102,175,233,.6);box-shadow:inset 0 1px 1px rgba(0,0,0,.075),0 0 8px rgba(102,175,233,.6)}.form-control.standard-no-margin.focus-out,input.form-control.standard-no-margin.focus-out{border-color:transparent;-webkit-animation:focus-highlight .5s ease-in-out;-moz-animation:focus-highlight .5s ease-in-out;-ms-animation:focus-highlight .5s ease-in-out;-o-animation:focus-highlight .5s ease-in-out;animation:focus-highlight .5s ease-in-out;box-shadow:none;outline:0 none}.relative-input-wrapper{position:relative;padding:0;margin:0}.relative-input-wrapper label{font-weight:400;font-family:inherit}.search-input{position:relative;padding:0;margin:0}.search-input input{padding-right:30px;padding-left:35px}.search-input .search-icon{position:absolute;left:6px;top:1px;width:32px;height:32px;color:#999;border-radius:3px;text-align:center;font-size:20px;box-sizing:border-box;padding:4px 0;cursor:pointer}.search-input .search-icon:hover{opacity:.7}.search-input .clear-search-btn{position:absolute;right:6px;top:6px;width:18px;height:22px;color:#999;border-radius:3px;text-align:center;font-size:12px;box-sizing:border-box;padding:4px 0;cursor:pointer}.search-input .clear-search-btn:hover{opacity:.7}.password-input{position:relative;padding:0;margin:0}.password-input input{padding-right:40px}.password-input .password-icon{position:absolute;right:6px;top:1px;width:32px;height:32px;border-radius:3px;text-align:center;font-size:20px;box-sizing:border-box;padding:4px 0;cursor:pointer}.password-input .password-icon:hover{opacity:.7}form .row{margin-left:-5px;margin-right:-5px}form .col-lg-1,form .col-lg-2,form .col-lg-3,form .col-lg-4,form .col-lg-5,form .col-lg-6,form .col-lg-7,form .col-lg-8,form .col-lg-9,form .col-lg-10,form .col-lg-11,form .col-lg-12,form .col-md-1,form .col-md-2,form .col-md-3,form .col-md-4,form .col-md-5,form .col-md-6,form .col-md-7,form .col-md-8,form .col-md-9,form .col-md-10,form .col-md-11,form .col-md-12,form .col-sm-1,form .col-sm-2,form .col-sm-3,form .col-sm-4,form .col-sm-5,form .col-sm-6,form .col-sm-7,form .col-sm-8,form .col-sm-9,form .col-sm-10,form .col-sm-11,form .col-sm-12,form .col-xs-1,form .col-xs-2,form .col-xs-3,form .col-xs-4,form .col-xs-5,form .col-xs-6,form .col-xs-7,form .col-xs-8,form .col-xs-9,form .col-xs-10,form .col-xs-11,form .col-xs-12{padding-left:5px;padding-right:5px}.btn-default.inlineField{margin:0;margin-top:-2px;border-color:#edeef0;box-shadow:none;border-bottom-left-radius:0!important;border-top-left-radius:0!important;width:25%}.upload-validation .alert-danger{margin:0 auto;margin-top:8px;text-align:left}.alert-danger{margin:0 auto;margin-top:5px}@keyframes focus-highlight{0%{box-shadow:inset 0 1px 1px rgba(0,0,0,.075),0 0 8px rgba(133,217,133,.75);border-color:#85d985}to{box-shadow:inset 0 1px 1px rgba(0,0,0,.075),0 0 8px rgba(133,217,133,0);border-color:transparent}}@-webkit-keyframes focus-highlight{0%{box-shadow:inset 0 1px 1px rgba(0,0,0,.075),0 0 8px rgba(133,217,133,.75);border-color:#85d985}to{box-shadow:inset 0 1px 1px rgba(0,0,0,.075),0 0 8px rgba(133,217,133,0);border-color:transparent}}.btn-group.guroo-blue-icon-only button{border-color:#6592cb!important;border-width:2px;background:#fff!important;color:#6592cb;padding:0;box-shadow:none}.btn-group.guroo-blue-icon-only button:active,.btn-group.guroo-blue-icon-only button:focus{color:#6592cb;box-shadow:none!important;outline:0 none!important}.btn-group.guroo-blue-icon-only button .icon{padding:10px 8px!important}.btn-group.guroo-blue-icon-only button .icon:after,.btn-group.guroo-blue-icon-only button .icon:before{font-size:28px!important}.btn-group.guroo-blue-icon-only button.active{background:#6592cb!important;color:#fff!important}.checkbox{display:inline-block;margin:0 20px;padding:6px 0;vertical-align:top}.checkbox input{display:none}.checkbox label{position:relative;text-transform:none;font-size:100%;color:#333;padding:10px 0 0 28px;line-height:0}.checkbox input[type=checkbox]+label:before{position:absolute;left:0;top:-1px;font-size:24px;content:\"\\F175\";color:#6592cb}.checkbox input[type=checkbox]+label:before,.checkbox input[type=checkbox]:checked+label:before{display:inline-block;font-family:Guroo-Producer;font-style:normal;font-weight:400;font-variant:normal;line-height:1;text-decoration:inherit;text-rendering:optimizeLegibility;text-transform:none;-moz-osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased;font-smoothing:antialiased}.checkbox input[type=checkbox]:checked+label:before{padding-right:10px;content:\"\\F16F\"}.checkbox.no-margin{margin:0!important}.category-picker{display:inline-block}.selected-items-list{display:inline-block;margin:0;padding:0}.selected-items-list .selected-item{display:inline-block;list-style-type:none;margin:0 0 5px 5px;padding:8px 12px;background:#6592cb;color:#fff;border-radius:5px}.selected-items-list .selected-item.removable{cursor:pointer}.selected-items-list .selected-item.removable:after{padding-left:5px;display:inline-block;font-family:Guroo-Producer;font-style:normal;font-weight:400;font-variant:normal;line-height:1;text-decoration:inherit;text-rendering:optimizeLegibility;text-transform:none;-moz-osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased;font-smoothing:antialiased;content:\"\\F125\"}.selected-items-list .selected-item.removable:hover{background:#6592cb}textarea{min-height:300px;resize:none}.editor-label{display:block;padding:0 0 5px}.editor-label .sub-label{font-weight:400;font-style:normal;font-size:12px}.embedded-activity-indent{padding-left:16px;padding-right:16px}.embedded-response{background:#fff;padding:16px 24px;background:#eff0f2;border-radius:5px;margin:10px 0}.embedded-response :last-child{margin-bottom:0}.quill{background:transparent!important;border-radius:5px!important}.ql-editor{padding:16px 24px!important;border:1px solid #d5d5d5;background:#eff0f2;min-height:120px;border-radius:5px;font-size:120%;font-family:inherit}.ql-editor:before{color:#999!important;font-style:normal!important}.quill .ql-bubble .ql-tooltip{left:0!important;right:0!important;margin:auto!important;width:90%!important;border-radius:5px!important;overflow:hidden}.quill .ql-bubble .ql-tooltip .ql-tooltip-arrow{display:none}.quill .ql-bubble .ql-formats{display:block!important;clear:both;text-align:center!important}.selection-menu{position:relative;text-align:left;width:auto;display:inline-block;cursor:pointer;margin-left:-5px;float:none!important}.selection-menu.open{z-index:99999}.selection-menu.closed{z-index:1}.selection-menu:focus{opacity:.7}.selection-menu .selected-title{position:relative;overflow:hidden;display:inline-block;width:auto;padding:5px;text-align:left;cursor:pointer;white-space:nowrap;text-overflow:ellipsis;font-weight:700}.selection-menu .selected-title:before{position:absolute;left:8px;color:#fff;top:0;bottom:0;margin:auto;font-size:16px;height:16px}.selection-menu .selected-title.not-required:before{content:\"\"}.selection-menu .selected-title.not-required:before,.selection-menu .selected-title.not-started:before{display:inline-block;font-family:Guroo-Producer;font-style:normal;font-weight:400;font-variant:normal;line-height:1;text-decoration:inherit;text-rendering:optimizeLegibility;text-transform:none;-moz-osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased;font-smoothing:antialiased}.selection-menu .selected-title.not-started:before{content:\"\\F16A\"}.selection-menu .selected-title.in-progress:before{content:\"\\F182\"}.selection-menu .selected-title.complete:before,.selection-menu .selected-title.in-progress:before{display:inline-block;font-family:Guroo-Producer;font-style:normal;font-weight:400;font-variant:normal;line-height:1;text-decoration:inherit;text-rendering:optimizeLegibility;text-transform:none;-moz-osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased;font-smoothing:antialiased}.selection-menu .selected-title.complete:before{content:\"\\F16F\"}.selection-menu .menu-icon{position:absolute;top:4px;right:-24px;display:block;width:20px;height:20px;padding:0;margin:0;font-size:18px;color:#6592cb;text-align:right}.selection-menu .menu-icon .rotating-icon{position:absolute;left:0}.selection-menu .menu-option-container{text-align:left;display:block;position:absolute;background:#fff;border-radius:5px;margin:5px 0 0;padding:0;height:0;left:0;overflow:hidden;width:auto;max-height:500px;overflow-y:scroll;-webkit-box-shadow:0 0 5px 0 rgba(0,0,0,.25);-moz-box-shadow:0 0 5px 0 rgba(0,0,0,.25);box-shadow:0 0 5px 0 rgba(0,0,0,.25)}@media only screen and (max-height:375px) and (max-width:736px) and (orientation:landscape){.selection-menu .menu-option-container{max-height:180px}}@media only screen and (max-width:320px) and (max-height:736px) and (orientation:portrait){.selection-menu .menu-option-container{max-width:250px!important}}.selection-menu .menu-option-container .menu-option-list{display:block;margin:0;padding:0;overflow:hidden!important;border-radius:5px}.selection-menu .menu-option-container .menu-option-list .option-item{display:block;padding:0;margin:0;list-style-type:none;overflow:hidden!important}.selection-menu .menu-option-container .menu-option-list .option-item .option-label{display:block;position:relative;width:100%;margin:0;padding:6px 12px;text-decoration:none;cursor:pointer;overflow:hidden;white-space:nowrap;text-overflow:ellipsis}.selection-menu .menu-option-container .menu-option-list .option-item .option-label.active,.selection-menu .menu-option-container .menu-option-list .option-item .option-label:hover{background-color:#eff0f2}.selection-menu .menu-option-container .menu-option-list .option-item .option-label:before{position:absolute;left:8px;top:0;bottom:0;margin:auto;font-size:16px;height:16px}.selection-menu .menu-option-container .menu-option-list .option-item .option-label.not-required:before{content:\"\"}.selection-menu .menu-option-container .menu-option-list .option-item .option-label.not-required:before,.selection-menu .menu-option-container .menu-option-list .option-item .option-label.not-started:before{display:inline-block;font-family:Guroo-Producer;font-style:normal;font-weight:400;font-variant:normal;line-height:1;text-decoration:inherit;text-rendering:optimizeLegibility;text-transform:none;-moz-osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased;font-smoothing:antialiased}.selection-menu .menu-option-container .menu-option-list .option-item .option-label.not-started:before{content:\"\\F16A\"}.selection-menu .menu-option-container .menu-option-list .option-item .option-label.in-progress:before{content:\"\\F182\"}.selection-menu .menu-option-container .menu-option-list .option-item .option-label.complete:before,.selection-menu .menu-option-container .menu-option-list .option-item .option-label.in-progress:before{display:inline-block;font-family:Guroo-Producer;font-style:normal;font-weight:400;font-variant:normal;line-height:1;text-decoration:inherit;text-rendering:optimizeLegibility;text-transform:none;-moz-osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased;font-smoothing:antialiased}.selection-menu .menu-option-container .menu-option-list .option-item .option-label.complete:before{content:\"\\F16F\"}.selection-menu .menu-option-container .menu-option-list .option-item.child .option-label{padding-left:56px!important}.selection-menu .menu-option-container .menu-option-list .option-item.child .option-label:before{left:30px}.selection-menu .menu-option-container .menu-option-list .option-item:first-child .option-label{border-top-left-radius:5px!important;border-top-right-radius:5px!important;padding-top:8px}.selection-menu .menu-option-container .menu-option-list .option-item:last-child .option-label{padding-bottom:8px;border-bottom-left-radius:5px!important;border-bottom-right-radius:5px!important}.selection-menu .menu-option-container .menu-option-list .option-item .menu-option-list .option-label{display:block;padding:6px 12px 6px 24px}.selection-menu .menu-option-container .menu-option-list .option-item .menu-option-list:first-child .option-label{padding-top:6px}.selection-menu .menu-option-container .menu-option-list .option-item .menu-option-list:last-child .option-label{padding-bottom:6px}.ql-toolbar.ql-snow{background:transparent!important;border:none!important}.ql-toolbar.ql-snow .ql-formats{display:block!important;width:100%}.ql-done{text-align:right!important}.ql-done:before{content:\"Done\"}.ql-done:after{position:absolute;visibility:hidden;top:-2000px;left:-2000px;content:\", This button will move focus to next item outside of the rich text editor\"}.content-image{text-align:center;margin:20px 0 0}.content-image img{padding:0;margin:0;width:100%;height:auto}.content-image:first-child{margin-top:0;padding:0}.light-frame{background:#fff;border:1px solid #d5d5d5}.light-frame img{padding:4px}.border img{border:1px solid #d5d5d5}.img-100-left{text-align:left}.img-100-left img{padding:0;margin:0;width:90%;height:auto}.img-90-left{text-align:left}.img-90-left img{padding:0;margin:0;width:90%;height:auto}.img-80-left{text-align:left}.img-80-left img{padding:0;margin:0;width:80%;height:auto}.img-70-left{text-align:left}.img-70-left img{padding:0;margin:0;width:70%;height:auto}.img-60-left{text-align:left}.img-60-left img{padding:0;margin:0;width:60%;height:auto}.img-50-left{text-align:left}.img-50-left img{padding:0;margin:0;width:50%;height:auto}.img-40-left{text-align:left}.img-40-left img{padding:0;margin:0;width:40%;height:auto}.img-30-left{text-align:left}.img-30-left img{padding:0;margin:0;width:30%;height:auto}.img-20-left{text-align:left}.img-20-left img{padding:0;margin:0;width:20%;height:auto}.img-10-left{text-align:left}.img-10-left img{padding:0;margin:0;width:10%;height:auto}.img-100-center{text-align:center}.img-100-center img{padding:0;margin:0;width:100%;height:auto}.img-90-center{text-align:center}.img-90-center img{padding:0;margin:0;width:90%;height:auto}.img-80-center{text-align:center}.img-80-center img{padding:0;margin:0;width:80%;height:auto}.img-70-center{text-align:center}.img-70-center img{padding:0;margin:0;width:70%;height:auto}.img-60-center{text-align:center}.img-60-center img{padding:0;margin:0;width:60%;height:auto}.img-50-center{text-align:center}.img-50-center img{padding:0;margin:0;width:50%;height:auto}.img-40-center{text-align:center}.img-40-center img{padding:0;margin:0;width:40%;height:auto}.img-30-center{text-align:center}.img-30-center img{padding:0;margin:0;width:30%;height:auto}.img-20-center{text-align:center}.img-20-center img{padding:0;margin:0;width:20%;height:auto}.img-10-center{text-align:center}.img-10-center img{padding:0;margin:0;width:10%;height:auto}.img-100-right{text-align:right}.img-100-right img{padding:0;margin:0;width:90%;height:auto}.img-90-right{text-align:right}.img-90-right img{padding:0;margin:0;width:90%;height:auto}.img-80-right{text-align:right}.img-80-right img{padding:0;margin:0;width:80%;height:auto}.img-70-right{text-align:right}.img-70-right img{padding:0;margin:0;width:70%;height:auto}.img-60-right{text-align:right}.img-60-right img{padding:0;margin:0;width:60%;height:auto}.img-50-right{text-align:right}.img-50-right img{padding:0;margin:0;width:50%;height:auto}.img-40-right{text-align:right}.img-40-right img{padding:0;margin:0;width:40%;height:auto}.img-30-right{text-align:right}.img-30-right img{padding:0;margin:0;width:30%;height:auto}.img-20-right{text-align:right}.img-20-right img{padding:0;margin:0;width:20%;height:auto}.img-10-right{text-align:right}.img-10-right img{padding:0;margin:0;width:10%;height:auto}.img-90-float-right{float:right;margin:0 0 20px 20px;width:90%}.img-90-float-right img{padding:0;margin:0;width:100%;height:auto}.img-80-float-right{float:right;margin:0 0 20px 20px;width:80%}.img-80-float-right img{padding:0;margin:0;width:100%;height:auto}.img-70-float-right{float:right;margin:0 0 20px 20px;width:70%}.img-70-float-right img{padding:0;margin:0;width:100%;height:auto}.img-60-float-right{float:right;margin:0 0 20px 20px;width:60%}.img-60-float-right img{padding:0;margin:0;width:100%;height:auto}.img-50-float-right{float:right;margin:0 0 20px 20px;width:50%}.img-50-float-right img{padding:0;margin:0;width:100%;height:auto}.img-40-float-right{float:right;margin:0 0 20px 20px;width:40%}.img-40-float-right img{padding:0;margin:0;width:100%;height:auto}.img-30-float-right{float:right;margin:0 0 20px 20px;width:30%}.img-30-float-right img{padding:0;margin:0;width:100%;height:auto}.img-20-float-right{float:right;margin:0 0 20px 20px;width:20%}.img-20-float-right img{padding:0;margin:0;width:100%;height:auto}.img-10-float-right{float:right;margin:0 0 20px 20px;width:10%}.img-10-float-right img{padding:0;margin:0;width:100%;height:auto}.img-90-float-left{float:left;margin:0 20px 20px 0;width:90%}.img-90-float-left img{padding:0;margin:0;width:100%;height:auto}.img-80-float-left{float:left;margin:0 0 20px 20px;width:80%}.img-80-float-left img{padding:0;margin:0;width:100%;height:auto}.img-70-float-left{float:left;margin:0 0 20px 20px;width:70%}.img-70-float-left img{padding:0;margin:0;width:100%;height:auto}.img-60-float-left{float:left;margin:0 0 20px 20px;width:60%}.img-60-float-left img{padding:0;margin:0;width:100%;height:auto}.img-50-float-left{float:left;margin:0 0 20px 20px;width:50%}.img-50-float-left img{padding:0;margin:0;width:100%;height:auto}.img-40-float-left{float:left;margin:0 0 20px 20px;width:40%}.img-40-float-left img{padding:0;margin:0;width:100%;height:auto}.img-30-float-left{float:left;margin:0 0 20px 20px;width:30%}.img-30-float-left img{padding:0;margin:0;width:100%;height:auto}.img-20-float-left{float:left;margin:0 0 20px 20px;width:20%}.img-20-float-left img{padding:0;margin:0;width:100%;height:auto}.img-10-float-left{float:left;margin:0 0 20px 20px;width:10%}.img-10-float-left img{padding:0;margin:0;width:100%;height:auto}.content-img-desc-50{background:#fff;width:50%;margin:0 auto}.content-img-desc-50 img{padding:8px 12px}.content-img-desc-50 .image-caption{text-align:left;font-size:90%;padding:8px 12px;background:#c1cfde}.asset-image{border:1px solid #d5d5d5;overflow:hidden;padding:6px;background:hsla(0,0%,100%,.9);max-width:100%;margin:0 auto}.asset-image:hover{cursor:pointer;opacity:.7}.asset-image .img-container{text-align:center}.asset-image .img-container .object-container{padding-left:0!important;padding-right:0!important}.asset-image .img-container img{max-width:100%!important;height:auto}.asset-image .asset-desc{padding:12px 15px 0;text-align:left;position:relative}.asset-image .asset-desc .title{font-weight:700;padding:0 0 5px 24px}.asset-image .asset-desc .title:before{position:absolute;top:15px;left:8px;font-size:130%;padding-right:5px;display:inline-block;font-family:Guroo-Producer;font-style:normal;font-weight:400;font-variant:normal;line-height:1;text-decoration:inherit;text-rendering:optimizeLegibility;text-transform:none;-moz-osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased;font-smoothing:antialiased;content:\"\\F244\"}.asset-image .asset-desc .desc-text{padding:0 0 10px 24px}.library-image{overflow:hidden;margin:0 auto;display:inline-block;margin-bottom:20px;max-width:100%}.library-image .img-container{text-align:center;overflow:hidden;display:block}.library-image .img-container .object-container{padding-left:0!important;padding-right:0!important}.library-image .img-container img{width:auto;max-width:100%;height:auto}.image-container{margin:10px 0!important}.image-container .object-container{padding-left:0!important;padding-right:0!important}.image-credit{font-size:80%;font-style:italic;text-align:left;padding:8px 10px}.image-credit.center{margin:0 auto}.resources-header-layout{display:-webkit-flex;display:flex;flex-flow:row nowrap;align-items:center;width:100%}.resources-header-layout .close-col{display:table-cell;width:20%}.resources-header-layout .close-col .icon{font-size:32px}.resources-header-layout .close-col .icon:before{font-size:32px;line-height:100%}.resources-header-layout .title-col{display:table-cell;width:60%;text-align:center}.resources-header-layout .icon-col{display:table-cell;width:20%;text-align:right}.resources-header-layout .resources-nav{display:-webkit-flex;display:flex;flex-flow:row nowrap;align-items:center;justify-content:flex-end;margin:0;padding:0}.resources-header-layout .resources-nav .resources-nav-item{list-style-type:none;padding:6px 8px;transition:opacity .3s ease-in}.resources-header-layout .resources-nav .resources-nav-item .resources-back-btn{position:relative;color:inherit;padding:4px 8px 4px 38px;border-radius:5px}.resources-header-layout .resources-nav .resources-nav-item .resources-back-btn:before{font-size:24px;position:absolute;left:8px;top:0;bottom:0;margin:auto;height:24px;display:inline-block;font-family:Guroo-Producer;font-style:normal;font-weight:400;font-variant:normal;line-height:1;text-decoration:inherit;text-rendering:optimizeLegibility;text-transform:none;-moz-osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased;font-smoothing:antialiased;content:\"\\F112\"}.resources-header-layout .resources-nav .resources-nav-item .resources-back-btn:active,.resources-header-layout .resources-nav .resources-nav-item .resources-back-btn:focus{background:hsla(0,0%,100%,.3)}.resources-header-layout .resources-nav .resources-nav-item .resources-next-btn{position:relative;color:inherit;padding:4px 38px 4px 8px;border-radius:5px}.resources-header-layout .resources-nav .resources-nav-item .resources-next-btn:after{font-size:24px;position:absolute;right:8px;top:0;bottom:0;margin:auto;height:24px;display:inline-block;font-family:Guroo-Producer;font-style:normal;font-weight:400;font-variant:normal;line-height:1;text-decoration:inherit;text-rendering:optimizeLegibility;text-transform:none;-moz-osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased;font-smoothing:antialiased;content:\"\\F113\"}.resources-header-layout .resources-nav .resources-nav-item .resources-next-btn:active,.resources-header-layout .resources-nav .resources-nav-item .resources-next-btn:focus{background:hsla(0,0%,100%,.3)}.resources-header-layout .resources-nav .resources-nav-item:hover{cursor:pointer;opacity:.7}.resources-header-layout .resources-nav .resources-nav-item.disabled{opacity:.3}.resources-header-layout .resources-nav .resources-nav-item.disabled .resources-back-btn:hover,.resources-header-layout .resources-nav .resources-nav-item.disabled .resources-next-btn:hover,.resources-header-layout .resources-nav .resources-nav-item.disabled:hover{cursor:not-allowed!important}@media only screen and (max-width:375px) and (max-height:736px) and (orientation:portrait){.resources-header-layout .resources-nav{display:none}}@media only screen and (max-height:375px) and (max-width:736px) and (orientation:landscape){.resources-header-layout .resources-nav{display:none}}.resources-container{min-height:544px;max-height:650px;height:-20vh;width:100%}@media only screen and (max-width:375px) and (max-height:736px) and (orientation:portrait){.resources-container{height:100%!important;max-height:-20vh!important}}@media only screen and (max-height:375px) and (max-width:736px) and (orientation:landscape){.resources-container{max-height:-20vh!important}}@media only screen and (min-width:376px) and (max-width:414px) and (max-height:736px) and (orientation:portrait){.resources-container{max-height:-20vh!important}}@media only screen and (min-height:376px) and (max-height:414px) and (max-width:736px) and (orientation:landscape){.resources-container{max-height:-20vh!important}}@media only screen and (min-width:768px) and (max-width:1024px) and (orientation:landscape){.resources-container{max-height:544px!important}}@media only screen and (min-width:768px) and (max-width:1024px) and (orientation:portrait){.resources-container{max-height:804px!important}}@media only screen and (max-width:375px) and (min-height:737px) and (max-height:812px) and (orientation:portrait){.resources-container{max-height:-20vh!important}}@media only screen and (min-width:737px) and (max-width:812px) and (max-height:375px) and (orientation:landscape){.resources-container{max-height:-20vh!important}}@media only screen and (max-width:320px) and (max-height:568px) and (orientation:portrait){.resources-container{min-height:-20vh!important;height:100%!important}}.resources-container .screen-container{position:absolute;top:0;left:0;width:100%;height:100%}.resources-container .screen-container .left-nav-content{height:100%;width:100%;background:#fff;display:table;padding:0!important;margin:0!important;vertical-align:top!important}.resources-container .screen-container .left-nav-content .nav-panel{display:table-cell;width:30%;border-right:1px solid #ccc;vertical-align:top}.resources-container .screen-container .left-nav-content .nav-panel .main-menu-nav{max-height:530px;overflow-y:scroll}.resources-container .screen-container .left-nav-content .content-panel{width:70%;display:table-cell;position:relative;height:100%}.resources-container .screen-container .left-nav-content .content-panel .body-content{display:block;position:absolute;height:100%;width:100%;min-height:544px;max-height:650px!important;height:calc(100vh - 120px);overflow-y:scroll;margin:0;padding:0 30px 30px}@media only screen and (max-width:375px) and (max-height:736px) and (orientation:portrait){.resources-container .screen-container .left-nav-content .content-panel .body-content{min-height:calc(100vh - 120px)!important;height:100%!important}}@media only screen and (max-height:375px) and (max-width:736px) and (orientation:landscape){.resources-container .screen-container .left-nav-content .content-panel .body-content{height:100%!important;min-height:calc(100vh - 120px)!important}}@media only screen and (min-width:376px) and (max-width:414px) and (max-height:736px) and (orientation:portrait){.resources-container .screen-container .left-nav-content .content-panel .body-content{height:100%!important;min-height:calc(100vh - 120px)!important}}@media only screen and (min-height:376px) and (max-height:414px) and (max-width:736px) and (orientation:landscape){.resources-container .screen-container .left-nav-content .content-panel .body-content{height:100%!important;min-height:calc(100vh - 120px)!important}}@media only screen and (min-width:768px) and (max-width:1024px) and (orientation:landscape){.resources-container .screen-container .left-nav-content .content-panel .body-content{height:100%!important;min-height:544px!important}}@media only screen and (min-width:768px) and (max-width:1024px) and (orientation:portrait){.resources-container .screen-container .left-nav-content .content-panel .body-content{height:100%!important;min-height:804px!important}}@media only screen and (max-width:375px) and (min-height:737px) and (max-height:812px) and (orientation:portrait){.resources-container .screen-container .left-nav-content .content-panel .body-content{height:100%!important;min-height:calc(100vh - 120px)!important}}@media only screen and (min-width:737px) and (max-width:812px) and (max-height:375px) and (orientation:landscape){.resources-container .screen-container .left-nav-content .content-panel .body-content{height:100%!important;min-height:calc(100vh - 120px)!important}}@media only screen and (max-width:320px) and (max-height:568px) and (orientation:portrait){.resources-container .screen-container .left-nav-content .content-panel .body-content{min-height:calc(100vh - 120px)!important;height:100%!important}}.resources-container .screen-container .left-nav-content .content-panel .body-content:before{display:block;padding:15px 0 0;content:\"\"}.resources-container .screen-container .left-nav-content .body-footer{padding:15px 30px}.resource-links{margin:0;padding:0}.resource-links .resource-link{display:block;list-style-type:none;padding:4px 4px 4px 32px;position:relative}.resource-links .resource-link:before{position:absolute;left:0;top:0;bottom:0;margin:auto;background:transparent!important;font-size:16px;height:16px}.resource-links .resource-link.not-viewed:before{color:#999;content:\"\\F16A\"}.resource-links .resource-link.not-viewed:before,.resource-links .resource-link.viewed:before{display:inline-block;font-family:Guroo-Producer;font-style:normal;font-weight:400;font-variant:normal;line-height:1;text-decoration:inherit;text-rendering:optimizeLegibility;text-transform:none;-moz-osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased;font-smoothing:antialiased}.resource-links .resource-link.viewed:before{color:#39aa27;content:\"\\F16F\"}.resource-links .resource-link.not-started:before{color:#999;content:\"\\F16A\"}.resource-links .resource-link.in-progress:before,.resource-links .resource-link.not-started:before{display:inline-block;font-family:Guroo-Producer;font-style:normal;font-weight:400;font-variant:normal;line-height:1;text-decoration:inherit;text-rendering:optimizeLegibility;text-transform:none;-moz-osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased;font-smoothing:antialiased}.resource-links .resource-link.in-progress:before{color:#f6ad17;content:\"\\F182\"}.resource-links .resource-link.complete:before{color:#39aa27;display:inline-block;font-family:Guroo-Producer;font-style:normal;font-weight:400;font-variant:normal;line-height:1;text-decoration:inherit;text-rendering:optimizeLegibility;text-transform:none;-moz-osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased;font-smoothing:antialiased;content:\"\\F16F\"}.resource-links .resource-link .document:before{content:\"\\F11F\"}.resource-links .resource-link .document:before,.resource-links .resource-link .link:before{padding-right:5px;display:inline-block;font-family:Guroo-Producer;font-style:normal;font-weight:400;font-variant:normal;line-height:1;text-decoration:inherit;text-rendering:optimizeLegibility;text-transform:none;-moz-osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased;font-smoothing:antialiased}.resource-links .resource-link .link:before{content:\"\\F17D\"}.resource-links .resource-link .video:before{content:\"\\F1FE\"}.resource-links .resource-link .image:before,.resource-links .resource-link .video:before{padding-right:5px;display:inline-block;font-family:Guroo-Producer;font-style:normal;font-weight:400;font-variant:normal;line-height:1;text-decoration:inherit;text-rendering:optimizeLegibility;text-transform:none;-moz-osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased;font-smoothing:antialiased}.resource-links .resource-link .image:before{content:\"\\F124\"}.resource-links .resource-link .resources:before{padding-right:5px;display:inline-block;font-family:Guroo-Producer;font-style:normal;font-weight:400;font-variant:normal;line-height:1;text-decoration:inherit;text-rendering:optimizeLegibility;text-transform:none;-moz-osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased;font-smoothing:antialiased;content:\"\\F15B\"}.selection-menu.locale-picker{position:relative;text-align:left;width:auto;max-width:540px;display:block;cursor:pointer;z-index:100}@media only screen and (max-width:320px) and (max-height:736px) and (orientation:portrait){.selection-menu.locale-picker{max-width:250px!important}}.selection-menu.locale-picker .selection-menu-btn:focus{background:hsla(0,0%,100%,.3)}.selection-menu.locale-picker:after{position:absolute;left:8px;top:8px;color:#fff;font-size:20px;display:inline-block;font-family:Guroo-Producer;font-style:normal;font-weight:400;font-variant:normal;line-height:1;text-decoration:inherit;text-rendering:optimizeLegibility;text-transform:none;-moz-osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased;font-smoothing:antialiased;content:\"\\F22E\"}.selection-menu.locale-picker .selected-title{position:relative;overflow:hidden;border-radius:5px;background:transparent;display:block;padding:5px 5px 4px 36px;text-align:left;cursor:pointer;white-space:nowrap;text-overflow:ellipsis}.selection-menu.locale-picker .selected-title:before{position:absolute;left:8px;top:0;bottom:0;margin:auto;color:#fff;font-size:16px;height:16px}.selection-menu.locale-picker .selected-title.not-required:before{content:\"\"}.selection-menu.locale-picker .selected-title.not-required:before,.selection-menu.locale-picker .selected-title.not-started:before{display:inline-block;font-family:Guroo-Producer;font-style:normal;font-weight:400;font-variant:normal;line-height:1;text-decoration:inherit;text-rendering:optimizeLegibility;text-transform:none;-moz-osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased;font-smoothing:antialiased}.selection-menu.locale-picker .selected-title.not-started:before{content:\"\\F16A\"}.selection-menu.locale-picker .selected-title.in-progress:before{content:\"\\F182\"}.selection-menu.locale-picker .selected-title.complete:before,.selection-menu.locale-picker .selected-title.in-progress:before{display:inline-block;font-family:Guroo-Producer;font-style:normal;font-weight:400;font-variant:normal;line-height:1;text-decoration:inherit;text-rendering:optimizeLegibility;text-transform:none;-moz-osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased;font-smoothing:antialiased}.selection-menu.locale-picker .selected-title.complete:before{content:\"\\F16F\"}.selection-menu.locale-picker .menu-icon{display:none;position:absolute;top:6px;margin:auto;right:8px;width:20px;height:20px;padding:0;font-size:18px;color:#fff;text-align:right}.selection-menu.locale-picker .menu-icon .rotating-icon{position:absolute;left:0}.selection-menu.locale-picker .menu-option-container{text-align:left;display:block;position:absolute;background:#fff;border-radius:5px;margin:5px 0 0;padding:0;height:0;left:0;overflow:hidden;width:auto;max-height:500px;overflow-y:scroll;-webkit-box-shadow:0 0 5px 0 rgba(0,0,0,.25);-moz-box-shadow:0 0 5px 0 rgba(0,0,0,.25);box-shadow:0 0 5px 0 rgba(0,0,0,.25)}@media only screen and (max-height:375px) and (max-width:736px) and (orientation:landscape){.selection-menu.locale-picker .menu-option-container{max-height:180px}}@media only screen and (max-width:320px) and (max-height:736px) and (orientation:portrait){.selection-menu.locale-picker .menu-option-container{max-width:250px!important}}.selection-menu.locale-picker .menu-option-container .menu-option-list{display:block;margin:0;padding:0;overflow:hidden!important;border-radius:5px}.selection-menu.locale-picker .menu-option-container .menu-option-list .option-item{display:block;padding:0;margin:0;list-style-type:none;overflow:hidden!important}.selection-menu.locale-picker .menu-option-container .menu-option-list .option-item .option-label{display:block;position:relative;width:100%;margin:0;padding:6px 12px;text-decoration:none;cursor:pointer;overflow:hidden;white-space:nowrap;text-overflow:ellipsis}.selection-menu.locale-picker .menu-option-container .menu-option-list .option-item .option-label.active,.selection-menu.locale-picker .menu-option-container .menu-option-list .option-item .option-label:hover{background-color:#eff0f2}.selection-menu.locale-picker .menu-option-container .menu-option-list .option-item .option-label:before{position:absolute;left:8px;top:0;bottom:0;margin:auto;font-size:16px;height:16px}.selection-menu.locale-picker .menu-option-container .menu-option-list .option-item .option-label.not-required:before{content:\"\"}.selection-menu.locale-picker .menu-option-container .menu-option-list .option-item .option-label.not-required:before,.selection-menu.locale-picker .menu-option-container .menu-option-list .option-item .option-label.not-started:before{display:inline-block;font-family:Guroo-Producer;font-style:normal;font-weight:400;font-variant:normal;line-height:1;text-decoration:inherit;text-rendering:optimizeLegibility;text-transform:none;-moz-osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased;font-smoothing:antialiased}.selection-menu.locale-picker .menu-option-container .menu-option-list .option-item .option-label.not-started:before{content:\"\\F16A\"}.selection-menu.locale-picker .menu-option-container .menu-option-list .option-item .option-label.in-progress:before{content:\"\\F182\"}.selection-menu.locale-picker .menu-option-container .menu-option-list .option-item .option-label.complete:before,.selection-menu.locale-picker .menu-option-container .menu-option-list .option-item .option-label.in-progress:before{display:inline-block;font-family:Guroo-Producer;font-style:normal;font-weight:400;font-variant:normal;line-height:1;text-decoration:inherit;text-rendering:optimizeLegibility;text-transform:none;-moz-osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased;font-smoothing:antialiased}.selection-menu.locale-picker .menu-option-container .menu-option-list .option-item .option-label.complete:before{content:\"\\F16F\"}.selection-menu.locale-picker .menu-option-container .menu-option-list .option-item.child .option-label{padding-left:56px!important}.selection-menu.locale-picker .menu-option-container .menu-option-list .option-item.child .option-label:before{left:30px}.selection-menu.locale-picker .menu-option-container .menu-option-list .option-item:first-child .option-label{border-top-left-radius:5px!important;border-top-right-radius:5px!important;padding-top:8px}.selection-menu.locale-picker .menu-option-container .menu-option-list .option-item:last-child .option-label{padding-bottom:8px;border-bottom-left-radius:5px!important;border-bottom-right-radius:5px!important}.selection-menu.locale-picker .menu-option-container .menu-option-list .option-item .menu-option-list .option-label{display:block;padding:6px 12px 6px 24px}.selection-menu.locale-picker .menu-option-container .menu-option-list .option-item .menu-option-list:first-child .option-label{padding-top:6px}.selection-menu.locale-picker .menu-option-container .menu-option-list .option-item .menu-option-list:last-child .option-label{padding-bottom:6px}.selection-menu.locale-picker .menu-option-container .option-label{padding-left:32px!important}.selection-menu.resources{position:relative;text-align:left;width:auto;max-width:540px;margin-top:5px;margin-left:50px;display:block;cursor:pointer;z-index:100}@media only screen and (max-width:320px) and (max-height:736px) and (orientation:portrait){.selection-menu.resources{max-width:250px!important}}.selection-menu.resources:after{position:absolute;left:-45px;top:0;color:#fff;font-size:32px;display:inline-block;font-family:Guroo-Producer;font-style:normal;font-weight:400;font-variant:normal;line-height:1;text-decoration:inherit;text-rendering:optimizeLegibility;text-transform:none;-moz-osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased;font-smoothing:antialiased;content:\"\\F15B\"}.selection-menu.resources .selection-menu-btn:focus{background:hsla(0,0%,100%,.3)}.selection-menu.resources .selected-title{position:relative;overflow:hidden;border-radius:5px;background:transparent;display:block;padding:5px 36px 4px 32px;text-align:left;cursor:pointer;white-space:nowrap;text-overflow:ellipsis;border:1px solid #fff}.selection-menu.resources .selected-title:before{position:absolute;left:8px;top:0;bottom:0;margin:auto;color:#fff;font-size:16px;height:16px}.selection-menu.resources .selected-title.not-required:before{content:\"\"}.selection-menu.resources .selected-title.not-required:before,.selection-menu.resources .selected-title.not-started:before{display:inline-block;font-family:Guroo-Producer;font-style:normal;font-weight:400;font-variant:normal;line-height:1;text-decoration:inherit;text-rendering:optimizeLegibility;text-transform:none;-moz-osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased;font-smoothing:antialiased}.selection-menu.resources .selected-title.not-started:before{content:\"\\F16A\"}.selection-menu.resources .selected-title.in-progress:before{content:\"\\F182\"}.selection-menu.resources .selected-title.complete:before,.selection-menu.resources .selected-title.in-progress:before{display:inline-block;font-family:Guroo-Producer;font-style:normal;font-weight:400;font-variant:normal;line-height:1;text-decoration:inherit;text-rendering:optimizeLegibility;text-transform:none;-moz-osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased;font-smoothing:antialiased}.selection-menu.resources .selected-title.complete:before{content:\"\\F16F\"}.selection-menu.resources .menu-icon{position:absolute;top:6px;margin:auto;right:8px;display:block;width:20px;height:20px;padding:0;font-size:18px;color:#fff;text-align:right}.selection-menu.resources .menu-icon .rotating-icon{position:absolute;left:0}.selection-menu.resources .menu-option-container{text-align:left;display:block;position:absolute;background:#fff;border-radius:5px;margin:5px 0 0;padding:0;height:0;left:0;overflow:hidden;width:auto;max-height:500px;overflow-y:scroll;-webkit-box-shadow:0 0 5px 0 rgba(0,0,0,.25);-moz-box-shadow:0 0 5px 0 rgba(0,0,0,.25);box-shadow:0 0 5px 0 rgba(0,0,0,.25)}@media only screen and (max-height:375px) and (max-width:736px) and (orientation:landscape){.selection-menu.resources .menu-option-container{max-height:180px}}@media only screen and (max-width:320px) and (max-height:736px) and (orientation:portrait){.selection-menu.resources .menu-option-container{max-width:250px!important}}.selection-menu.resources .menu-option-container .menu-option-list{display:block;margin:0;padding:0;overflow:hidden!important;border-radius:5px}.selection-menu.resources .menu-option-container .menu-option-list .option-item{display:block;padding:0;margin:0;list-style-type:none;overflow:hidden!important}.selection-menu.resources .menu-option-container .menu-option-list .option-item .option-label{display:block;position:relative;width:100%;margin:0;padding:6px 12px;text-decoration:none;cursor:pointer;overflow:hidden;white-space:nowrap;text-overflow:ellipsis}.selection-menu.resources .menu-option-container .menu-option-list .option-item .option-label.active,.selection-menu.resources .menu-option-container .menu-option-list .option-item .option-label:hover{background-color:#eff0f2}.selection-menu.resources .menu-option-container .menu-option-list .option-item .option-label:before{position:absolute;left:8px;top:0;bottom:0;margin:auto;font-size:16px;height:16px}.selection-menu.resources .menu-option-container .menu-option-list .option-item .option-label.not-required:before{content:\"\"}.selection-menu.resources .menu-option-container .menu-option-list .option-item .option-label.not-required:before,.selection-menu.resources .menu-option-container .menu-option-list .option-item .option-label.not-started:before{display:inline-block;font-family:Guroo-Producer;font-style:normal;font-weight:400;font-variant:normal;line-height:1;text-decoration:inherit;text-rendering:optimizeLegibility;text-transform:none;-moz-osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased;font-smoothing:antialiased}.selection-menu.resources .menu-option-container .menu-option-list .option-item .option-label.not-started:before{content:\"\\F16A\"}.selection-menu.resources .menu-option-container .menu-option-list .option-item .option-label.in-progress:before{content:\"\\F182\"}.selection-menu.resources .menu-option-container .menu-option-list .option-item .option-label.complete:before,.selection-menu.resources .menu-option-container .menu-option-list .option-item .option-label.in-progress:before{display:inline-block;font-family:Guroo-Producer;font-style:normal;font-weight:400;font-variant:normal;line-height:1;text-decoration:inherit;text-rendering:optimizeLegibility;text-transform:none;-moz-osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased;font-smoothing:antialiased}.selection-menu.resources .menu-option-container .menu-option-list .option-item .option-label.complete:before{content:\"\\F16F\"}.selection-menu.resources .menu-option-container .menu-option-list .option-item.child .option-label{padding-left:56px!important}.selection-menu.resources .menu-option-container .menu-option-list .option-item.child .option-label:before{left:30px}.selection-menu.resources .menu-option-container .menu-option-list .option-item:first-child .option-label{border-top-left-radius:5px!important;border-top-right-radius:5px!important;padding-top:8px}.selection-menu.resources .menu-option-container .menu-option-list .option-item:last-child .option-label{padding-bottom:8px;border-bottom-left-radius:5px!important;border-bottom-right-radius:5px!important}.selection-menu.resources .menu-option-container .menu-option-list .option-item .menu-option-list .option-label{display:block;padding:6px 12px 6px 24px}.selection-menu.resources .menu-option-container .menu-option-list .option-item .menu-option-list:first-child .option-label{padding-top:6px}.selection-menu.resources .menu-option-container .menu-option-list .option-item .menu-option-list:last-child .option-label{padding-bottom:6px}.selection-menu.resources .menu-option-container .option-label{padding-left:32px!important}@media only screen and (max-width:375px) and (max-height:736px) and (orientation:portrait){.selection-menu.resources,.selection-menu.resources .menu-option-container{max-width:300px}}@media only screen and (max-height:375px) and (max-width:736px) and (orientation:landscape){.selection-menu.resources,.selection-menu.resources .menu-option-container{max-width:600px}}.resources-content{display:block;position:relative;padding:0;margin:0}.resources-content .content-screen{padding:0!important;margin:0!important}.resources-content .content-screen .content-wrapper{width:100%;padding:0;margin:0;overflow-y:auto!important;-webkit-box-shadow:none;-moz-box-shadow:none;box-shadow:none}.resources-content .content-screen .content-wrapper .asset-col-left{width:30%;float:left;overflow:hidden;padding-right:15px}.resources-content .content-screen .content-wrapper .asset-col-left img{width:100%}.resources-content .content-screen .content-wrapper .left-asset-screen{width:70%;margin-left:30%;overflow:hidden}.resources-content .content-screen .content-wrapper .asset-col-right{width:30%;margin-left:70%;overflow:hidden;padding:16px 24px;padding-left:15px}.resources-content .content-screen .content-wrapper .asset-col-right img{width:100%}.resources-content .content-screen .content-wrapper .right-asset-screen{width:70%;float:left;overflow:hidden}.feedback-content-col .resources_link.object-container{padding:0!important}.document:before{padding-right:5px;display:inline-block;font-family:Guroo-Producer;font-style:normal;font-weight:400;font-variant:normal;line-height:1;text-decoration:inherit;text-rendering:optimizeLegibility;text-transform:none;-moz-osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased;font-smoothing:antialiased;content:\"\\F11F\"}.pl-circle{width:80px;height:80px;position:absolute;top:0;left:0;right:0;bottom:0;margin:auto}.pl-circle .pl-child{width:100%;height:100%;position:absolute;left:0;top:0}.pl-circle .pl-child:before{content:\"\";display:block;margin:0 auto;width:15%;height:15%;background-color:#fff;border-radius:100%;-webkit-animation:pl-circleBounceDelay 1.2s infinite ease-in-out both;animation:pl-circleBounceDelay 1.2s infinite ease-in-out both}.pl-circle.content{position:relative;margin:30px auto}.pl-circle.content .pl-child:before{background-color:#999}.pl-circle .pl-circle2{-webkit-transform:rotate(30deg);-ms-transform:rotate(30deg);transform:rotate(30deg)}.pl-circle .pl-circle2:before{-webkit-animation-delay:-1.1s;animation-delay:-1.1s}.pl-circle .pl-circle3{-webkit-transform:rotate(60deg);-ms-transform:rotate(60deg);transform:rotate(60deg)}.pl-circle .pl-circle3:before{-webkit-animation-delay:-1s;animation-delay:-1s}.pl-circle .pl-circle4{-webkit-transform:rotate(90deg);-ms-transform:rotate(90deg);transform:rotate(90deg)}.pl-circle .pl-circle4:before{-webkit-animation-delay:-.9s;animation-delay:-.9s}.pl-circle .pl-circle5{-webkit-transform:rotate(120deg);-ms-transform:rotate(120deg);transform:rotate(120deg)}.pl-circle .pl-circle5:before{-webkit-animation-delay:-.8s;animation-delay:-.8s}.pl-circle .pl-circle6{-webkit-transform:rotate(150deg);-ms-transform:rotate(150deg);transform:rotate(150deg)}.pl-circle .pl-circle6:before{-webkit-animation-delay:-.7s;animation-delay:-.7s}.pl-circle .pl-circle7{-webkit-transform:rotate(180deg);-ms-transform:rotate(180deg);transform:rotate(180deg)}.pl-circle .pl-circle7:before{-webkit-animation-delay:-.6s;animation-delay:-.6s}.pl-circle .pl-circle8{-webkit-transform:rotate(210deg);-ms-transform:rotate(210deg);transform:rotate(210deg)}.pl-circle .pl-circle8:before{-webkit-animation-delay:-.5s;animation-delay:-.5s}.pl-circle .pl-circle9{-webkit-transform:rotate(240deg);-ms-transform:rotate(240deg);transform:rotate(240deg)}.pl-circle .pl-circle9:before{-webkit-animation-delay:-.4s;animation-delay:-.4s}.pl-circle .pl-circle10{-webkit-transform:rotate(270deg);-ms-transform:rotate(270deg);transform:rotate(270deg)}.pl-circle .pl-circle10:before{-webkit-animation-delay:-.3s;animation-delay:-.3s}.pl-circle .pl-circle11{-webkit-transform:rotate(300deg);-ms-transform:rotate(300deg);transform:rotate(300deg)}.pl-circle .pl-circle11:before{-webkit-animation-delay:-.2;animation-delay:-.2s}.pl-circle .pl-circle12{-webkit-transform:rotate(330deg);-ms-transform:rotate(330deg);transform:rotate(330deg)}.pl-circle .pl-circle12:before{-webkit-animation-delay:-.1s;animation-delay:-.1s}@-webkit-keyframes pl-circleBounceDelay{0%,80%,to{-webkit-transform:scale(0);transform:scale(0)}40%{-webkit-transform:scale(1);transform:scale(1)}}@keyframes pl-circleBounceDelay{0%,80%,to{-webkit-transform:scale(0);transform:scale(0)}40%{-webkit-transform:scale(1);transform:scale(1)}}.guroo{background:#6592cb}.guroo .abs-centered-panel-sml{color:#fff}.preloading-image{border-color:#6592cb}.guroo-active-link{color:#6592cb;cursor:pointer}.guroo-active-link:active,.guroo-active-link:focus,.guroo-active-link:hover,body{color:#333}body:before{background:#333}body:after{background:rgba(0,0,0,.8)}a:focus,a:hover{color:#333}a:active{color:#6592cb}.screen-wrapper{background:#fff}.guroo-header{background:#6894cc;color:#fff}.bite-progress-bar{background:#becddd}.guroo-dialog-header{background:#345177;color:#fff}.content-dialog{background:#fff}.guroo-btn,.guroo-btn:active,.guroo-btn:focus,.guroo-btn:hover{background:#6689c6;color:#fff}.guroo-btn:disabled{background:#ccc;color:#999}a{color:#6592cb}a:active,a:focus,a:hover{color:#c1cfde}.tool-tip{background:#fff;border-color:#d5d5d5;color:#333}.kpi-rotation-btn .rotator{border-color:#fff}.kpi-rotation-btn .rotator:after{background:#fff}.kpi-rotation .rotator,.kpi-rotation .rotator:after{background:#333}.guroo-kpi-label{background:#6689c6;color:#fff}.learner-action-option-list .learner-action-option.rounded label:after,.learner-action-option-list .learner-action-option.speak:last-child:hover label:after,.learner-action-option-list .learner-action-option.speak:last-child input:not([disabled])+label:after:hover,.learner-action-option-list .learner-action-option.speak:last-child input:not([disabled])+label:hover:after,.learner-action-option-list .learner-action-option.speak:last-child label:after{box-shadow:-15px 6px 0 0 #5b8bc7}.learner-action-option-list .learner-action-option.review-current:last-child label:after{box-shadow:-15px 6px 0 0 #d6e2f1}.learner-action-option-list .learner-action-option.answered:after{color:#5b8bc7}.learner-action-option-list .learner-action-option.rounded.behaviour label{border-top-color:#5b8bc7}.learner-action-option-list .learner-action-option.answered :after{color:#5b8bc7\n  /*!important*/}.learner-action-option-list .learner-action-option.speak label{color:#fff;background:#5b8bc7}.learner-action-option-list .learner-action-option.speak input[disabled]+label{color:hsla(0,0%,100%,.5)}.learner-action-option-list .learner-action-option.speak.active input:disabled+label,.learner-action-option-list .learner-action-option.speak.answered input:disabled+label,.learner-action-option-list .learner-action-option.speak.review-selected input:disabled+label,.learner-action-option-list .learner-action-option.speak.review input:disabled+label,.learner-action-option-list .learner-action-option.speak.selected input:disabled+label{color:#fff}.learner-action-option-list .learner-action-option.speak.review-current:focus label,.learner-action-option-list .learner-action-option.speak.review-current label{color:#333;background:#d6e2f1}.learner-action-option-list .learner-action-option:focus{outline:none!important}.learner-action-option-list .learner-action-option:focus label{opacity:.7}.learner-action-response-list .learner-action-response .response-label.behaviour{background:#fff;border-color:#bababa}.learner-action-response-list .learner-action-response .response-label.speak{background:#bababa;color:#fff}.tabbed-content .tab-list{background:hsla(0,0%,100%,.9)}.tabbed-content .tab-list .tab-item{border-left-color:#999;border-bottom-color:#999;font-weight:400}.tabbed-content .tab-list .tab-item:hover{background:hsla(0,0%,100%,.8)}.tabbed-content .tab-list .tab-item.active{background:#fff;border-bottom:1px solid #999;color:#5b8bc7}.tabbed-content .tab-list .tab-item.active:after{background:#6592cb;top:unset;bottom:0}.tabbed-content .tab-list .tab-item.active:focus{outline:none!important}.tabbed-content .tab-list .tab-item.disabled{color:#666}.tabbed-content .tab-list .tab-item:focus{outline:none!important;background:#eff0f2}.tabbed-content .tab-list .tab-item:focus:after{background:#d5d5d5}.tabbed-content.floating .tab-item.active{border-bottom:#fff}.tabbed-content.floating .tab-item.active:after{background:#6592cb;top:0;bottom:unset}.tabbed-content.floating .tabbed-body-content{background:#fff}.tabbed-content-vertical .tab-list{background:#eff0f2;border-right:1px solid #999}.tabbed-content-vertical .tab-list .tab-item{border-left-color:#999;border-bottom-color:#999}.tabbed-content-vertical .tab-list .tab-item:hover{background:hsla(0,0%,100%,.8)}.tabbed-content-vertical .tab-list .tab-item.active{background:#fff;color:#5b8bc7}.tabbed-content-vertical .tab-list .tab-item.active:after{background:#6592cb}.tabbed-content-vertical .tab-list .tab-item.active:focus{outline:none!important}.tabbed-content-vertical .tab-list .tab-item.disabled{color:#666}.tabbed-content-vertical .tab-list .tab-item:focus{outline:none!important;background:#eff0f2}.tabbed-content-vertical .tab-list .tab-item:focus:after{background:#d5d5d5}.tabbed-content-vertical.floating .tabbed-body-content{background:#fff}.tabbed-content-vertical.floating .tab-list{border-right:none}.tabbed-content-process-horizontal{background:#fff}.tabbed-content-process-horizontal .tab-list .tab-item{background:#eff0f2;color:#333;border-top:2px solid #fff;border-bottom:2px solid #fff}.tabbed-content-process-horizontal .tab-list .tab-item:first-child{border-left:2px solid #fff}.tabbed-content-process-horizontal .tab-list .tab-item .post-shape,.tabbed-content-process-horizontal .tab-list .tab-item .post-shape:before,.tabbed-content-process-horizontal .tab-list .tab-item .pre-shape,.tabbed-content-process-horizontal .tab-list .tab-item .pre-shape:before{border-left-color:#fff}.tabbed-content-process-horizontal .tab-list .tab-item:hover{box-sizing:border-box;-moz-box-sizing:border-box;-webkit-box-sizing:border-box;border-top:2px solid #e2e2e2;border-bottom:2px solid #e2e2e2}.tabbed-content-process-horizontal .tab-list .tab-item:hover:first-child{border-left:2px solid #e2e2e2}.tabbed-content-process-horizontal .tab-list .tab-item:hover .post-shape:before,.tabbed-content-process-horizontal .tab-list .tab-item:hover .pre-shape:before{display:block;border-left-color:#e2e2e2}.tabbed-content-process-horizontal .tab-list .tab-item.disabled{background:#eff0f2;color:#999!important;border-top:2px solid #eff0f2;border-bottom:2px solid #eff0f2}.tabbed-content-process-horizontal .tab-list .tab-item.disabled:first-child{border-left:2px solid #eff0f2}.tabbed-content-process-horizontal .tab-list .tab-item.disabled .post-shape,.tabbed-content-process-horizontal .tab-list .tab-item.disabled .post-shape:before,.tabbed-content-process-horizontal .tab-list .tab-item.disabled .pre-shape:before{border-left-color:#eff0f2}.tabbed-content-process-horizontal .tab-list .tab-item.disabled:hover{box-sizing:border-box;-moz-box-sizing:border-box;-webkit-box-sizing:border-box;border-top:2px solid #eff0f2;border-bottom:2px solid #eff0f2;background:#eff0f2}.tabbed-content-process-horizontal .tab-list .tab-item.disabled:hover:first-child{border-left:2px solid #eff0f2}.tabbed-content-process-horizontal .tab-list .tab-item.disabled:hover .post-shape:before,.tabbed-content-process-horizontal .tab-list .tab-item.disabled:hover .pre-shape:before{display:block;border-left-color:#eff0f2}.tabbed-content-process-horizontal .tab-list .tab-item.active{box-sizing:border-box;-moz-box-sizing:border-box;-webkit-box-sizing:border-box;border-top:2px solid #6592cb;border-bottom:2px solid #6592cb}.tabbed-content-process-horizontal .tab-list .tab-item.active:first-child{border-left:2px solid #6592cb}.tabbed-content-process-horizontal .tab-list .tab-item.active .post-shape:before,.tabbed-content-process-horizontal .tab-list .tab-item.active .pre-shape:before{display:block;border-left-color:#6592cb}.tabbed-content-process-horizontal .tabbed-body-content{background:#fff}.tabbed-content-process-vertical{background:hsla(0,0%,100%,.9)}.tabbed-content-process-vertical .tab-list{border-right:1px solid #d5d5d5}.tabbed-content-process-vertical .tab-list .tab-item{background:#eff0f2;color:#333;border-color:#d5d5d5}.tabbed-content-process-vertical .tab-list .tab-item .post-shape{border-top-color:#333}.tabbed-content-process-vertical .tab-list .tab-item:hover{background:#eff0f2;-webkit-box-shadow:0 0 1px 2px #e2e2e2;-moz-box-shadow:0 0 1px 2px #e2e2e2;box-shadow:0 0 1px 2px #e2e2e2}.tabbed-content-process-vertical .tab-list .tab-item.disabled{background:#eff0f2;color:#999!important;border-color:#d5d5d5}.tabbed-content-process-vertical .tab-list .tab-item.disabled .post-shape{border-top-color:#333}.tabbed-content-process-vertical .tab-list .tab-item.disabled .tab-icon{border-color:#d5d5d5}.tabbed-content-process-vertical .tab-list .tab-item.disabled:hover{background:#eff0f2;-webkit-box-shadow:none;-moz-box-shadow:#eff0f2;box-shadow:#eff0f2}.tabbed-content-process-vertical .tab-list .tab-item.active{background:#eff0f2;-webkit-box-shadow:0 0 1px 2px #6592cb;-moz-box-shadow:0 0 1px 2px #6592cb;box-shadow:0 0 1px 2px #6592cb}.tabbed-content-process-vertical .tabbed-body-content{background:#fff}.tabbed-content-tile-horizontal{background:hsla(0,0%,100%,.9)}.tabbed-content-tile-horizontal .tab-list .tab-item{background:#eff0f2;border-color:#d5d5d5}.tabbed-content-tile-horizontal .tab-list .tab-item:hover{-webkit-box-shadow:0 0 1px 2px #e2e2e2;-moz-box-shadow:0 0 1px 2px #e2e2e2;box-shadow:0 0 1px 2px #e2e2e2}.tabbed-content-tile-horizontal .tab-list .tab-item.active{-webkit-box-shadow:0 0 1px 2px #6592cb;-moz-box-shadow:0 0 1px 2px #6592cb;box-shadow:0 0 1px 2px #6592cb}.tabbed-content-tile-horizontal .tab-list .tab-item.disabled{background:#eff0f2;border-color:#d5d5d5;color:#999!important;-webkit-box-shadow:none;-moz-box-shadow:none;box-shadow:none}.tabbed-content-tile-horizontal .tab-list .tab-item.disabled .post-shape{border-top-color:#6592cb}.tabbed-content-tile-horizontal .tab-list .tab-item.disabled:hover{background:#eff0f2;-webkit-box-shadow:none;-moz-box-shadow:none;box-shadow:none}.tabbed-content-tile-horizontal .tabbed-body-content{background:#fff}.tabbed-content-tile-vertical{background:hsla(0,0%,100%,.9)}.tabbed-content-tile-vertical .tab-list{border-right:1px solid #d5d5d5}.tabbed-content-tile-vertical .tab-list .tab-item{background:#eff0f2;border-color:#d5d5d5}.tabbed-content-tile-vertical .tab-list .tab-item:hover{-webkit-box-shadow:0 0 1px 2px #e2e2e2;-moz-box-shadow:0 0 1px 2px #e2e2e2;box-shadow:0 0 1px 2px #e2e2e2}.tabbed-content-tile-vertical .tab-list .tab-item.active{-webkit-box-shadow:0 0 1px 2px #6592cb;-moz-box-shadow:0 0 1px 2px #6592cb;box-shadow:0 0 1px 2px #6592cb}.tabbed-content-tile-vertical .tab-list .tab-item.disabled{background:#eff0f2;border-color:#d5d5d5;color:#999!important}.tabbed-content-tile-vertical .tab-list .tab-item.disabled .post-shape{border-top-color:#6592cb}.tabbed-content-tile-vertical .tab-list .tab-item.disabled:hover{background:#eff0f2;-webkit-box-shadow:none;-moz-box-shadow:none;box-shadow:none}.tabbed-content-tile-vertical .tabbed-body-content{background:#fff}.kpi-graph{border-color:#6592cb}.kpi-graph .bar-graph-items .graph-item .badge-earned:before,.menu-nav-item:focus,.menu-nav-item:hover{color:#6592cb}.menu-nav-item.active{border-left-color:#6592cb;background:#eff4fa}.menu-nav-accordion-btn:after,.multiple-choice-option label{color:#6592cb}.multiple-choice-option.show-answer input:disabled+label{color:#c1cfde}.multiple-choice-option.review-current input+label{color:#333;font-weight:700}.multiple-choice-option.review-selected input:disabled+label,.multiple-choice-option.review input:disabled+label{color:#333}.multiple-choice-option:active,.multiple-choice-option:focus,.multiple-choice-option:hover{background:#eff0f2!important}.character.speak{color:#fff;background:#bababa}.character.speak:after{box-shadow:15px 6px 0 0 #bababa}.character-conversation-image{background:#e5e5e5}.character-conversation-image:after{box-shadow:15px 6px 0 0 #e5e5e5}.learner.speak{color:#fff;background:#5b8bc7}.learner.speak:after{box-shadow:-15px 6px 0 0 #5b8bc7}.learner-conversation-image{background:#d6e2f1}.learner-conversation-image:after{box-shadow:-15px 6px 0 0 #d6e2f1}.narrator{background:#fff;border-color:#5b8bc7}.arrow-list ul li:before,.cross-list ul li:before,.plus-list ul li:before,.tick-list ul li:before{background:#6592cb;color:#fff}.dotted-list ul li:before{color:#6592cb}.call-out-style-1{background:#c1cfde;border-color:#5b8bc7;border-style:dashed;color:#333}.call-out-style-1 .arrow-list ul li:before,.call-out-style-1 .cross-list ul li:before,.call-out-style-1 .plus-list ul li:before,.call-out-style-1 .tick-list ul li:before{background:#5b8bc7;color:#fff}.call-out-style-1 .dotted-list ul li:before{color:#5b8bc7}.call-out-style-2{background:#d5d5d5;border-color:#333;border-style:dotted;color:#333}.call-out-style-2 .arrow-list ul li:before,.call-out-style-2 .cross-list ul li:before,.call-out-style-2 .plus-list ul li:before,.call-out-style-2 .tick-list ul li:before{background:#333;color:#fff}.call-out-style-2 .dotted-list ul li:before{color:#333}.call-out-style-3{background:#333;border-color:#5b8bc7;border-style:solid;color:#eff0f2}.call-out-style-3 .arrow-list ul li:before,.call-out-style-3 .cross-list ul li:before,.call-out-style-3 .plus-list ul li:before,.call-out-style-3 .tick-list ul li:before{background:#5b8bc7;color:#fff}.call-out-style-3 .dotted-list ul li:before{color:#5b8bc7}.call-out-style-4{background:#eff0f2;border-color:#d5d5d5;border-style:solid;color:#666}.call-out-style-4 .arrow-list ul li:before,.call-out-style-4 .cross-list ul li:before,.call-out-style-4 .plus-list ul li:before,.call-out-style-4 .tick-list ul li:before{background:#d5d5d5;color:#fff}.call-out-style-4 .dotted-list ul li:before{color:#d5d5d5}.menu-header{background:hsla(0,0%,100%,.3)}.menu-header h2{font-weight:200;line-height:140%}.menu-header h2,.menu-header h3{font-family:Arial,Helvetica Neue,Helvetica,sans-serif}.personalised-menu-header{background:#6592cb;color:#fff}.personalised-menu-header .filter-panel{background:#becddd;color:#6592cb;border-top:2px solid #fff}.personalised-menu-header .filter-panel h3{color:#345177}.personalised-menu-header .filter-panel button{border:1px solid #6592cb;background:#6592cb;color:#fff}.personalised-menu-header .filter-panel button.active{background:#fff;color:#6592cb;box-shadow:inset 0 3px 5px rgba(0,0,0,.3)!important}.personalised-menu-header h2{font-weight:200;line-height:140%}.personalised-menu-header h2,.personalised-menu-header h3{font-family:Arial,Helvetica Neue,Helvetica,sans-serif}.title-panel .title-content{background:hsla(0,0%,100%,.7)}.title-panel .title-content h1{font-size:25px;font-family:Times New Roman,Georgia,Serif;font-weight:300}.title-panel .title-content h2{font-size:50px;font-family:Times New Roman,Georgia,Serif;font-weight:200;line-height:140%}.scenario-bite .header h2{font-size:90%;font-weight:400;line-height:120%}.scenario-bite .header h2,.scenario-bite .header h3{font-family:Helvetica Neue,Helvetica,Arial,san-serif}.scenario-bite .header h3{font-size:150%;font-weight:lighter}@media only screen and (max-width:736px) and (orientation:portrait){.scenario-bite .header h3{font-size:120%}}@media only screen and (max-width:736px) and (orientation:landscape){.scenario-bite .header h3{font-size:120%}}.document-panel:before{color:#6592cb}.footer-text,.footer-text a{color:#fff}.accordion-screen-footer{color:#333}.accordion .accordion-item{border-color:#999}.accordion .accordion-item .accordion-item-list .accordion-btn{background:#fff!important}.accordion .accordion-item .accordion-item-list .accordion-btn:hover{background:#fff}.accordion .accordion-item .accordion-item-list .accordion-btn.incomplete:before{color:#333}.accordion .accordion-item .accordion-item-list .accordion-btn.complete:before{color:#39aa27}.accordion .accordion-item .accordion-item-list .accordion-btn.disabled{color:#ccc!important;cursor:not-allowed}.accordion .accordion-item .accordion-item-list .accordion-btn.disabled:hover{background:hsla(0,0%,100%,.9)}.accordion .accordion-item .accordion-item-list .accordion-btn.disabled:after{color:#ccc!important}.accordion .accordion-item .accordion-item-list .accordion-content{background:hsla(0,0%,100%,.9)}.accordion .accordion-item.open .accordion-btn{background:#fff;color:#6592cb;-webkit-box-shadow:0 2px 5px 0 rgba(0,0,0,.25);-moz-box-shadow:0 2px 5px 0 rgba(0,0,0,.25);box-shadow:0 2px 5px 0 rgba(0,0,0,.25)}.accordion .accordion-item.open .accordion-btn:after{color:#000}.accordion .accordion-item.open .accordion-btn:hover{background:#fff}.accordion .accordion-item.closed .accordion-btn{background:hsla(0,0%,100%,.9);color:#6592cb}.accordion .accordion-item.closed .accordion-btn:after{color:#000}.content-tool-tip{background:transparent}.content-tool-tip .tool-tip{display:none}.content-tool-tip.open{background:rgba(0,0,0,.3)}.content-tool-tip.open .tool-tip .tool-tip-header{background:#6592cb}.content-tool-tip.open .tool-tip .tool-tip-header:after,.content-tool-tip.open .tool-tip .tool-tip-header:before{color:#fff}.horz-slider-screen .slider-container .thumbnail-list .thumbnail-item.complete.active:before,.horz-slider-screen .slider-container .thumbnail-list .thumbnail-item.incomplete.active:before,.horz-slider-screen .slider-next-slide-btn:after,.horz-slider-screen .slider-prev-slide-btn:after,.horz-slider-timeline .slider-container .thumbnail-list .thumbnail-item.complete.active:before,.horz-slider-timeline .slider-container .thumbnail-list .thumbnail-item.incomplete.active:before,.horz-slider-timeline .slider-next-slide-btn:after,.horz-slider-timeline .slider-prev-slide-btn:after,.tool-tip-btn:before{color:#6592cb}.save-message{background:#6592cb;color:#fff}.badge-btn .badge-count{background-color:transparent!important}.badge-btn .badge-count .status-indicator{background-color:transparent!important;color:#6592cb}.badge .badge-container:before{color:#6592cb}.badge .badge-label{background:#666;color:#fff}.badge .achieved-count{color:#fff}.badge-collection-panel{border:3px solid #6592cb;background:#c1cfde}.menu-grid .grid-item .thumbnail .content-container .thumbnail-title{padding-top:10px;padding-left:36px;font-size:18px}.menu-grid .grid-item .thumbnail .content-container .thumbnail-title:before{position:absolute;top:12px;left:12px}.filter-panel{color:#6592cb}.filter-panel .label{color:#fff}.filter-panel h3{color:#345177}.filter-panel button{border:1px solid #6592cb;background:#6592cb;color:#fff}.filter-panel button:active,.filter-panel button:focus,.filter-panel button:hover{color:#fff}.filter-panel button.active{background:#fff;color:#6592cb}.filter-panel button.active:active,.filter-panel button.active:focus{color:#6592cb}.note-panel{border:1px solid #6592cb}.note-panel .note-title{background:#6592cb;color:#fff}.main-menu-nav .menu-nav-item{background:#fff}.grid-choice-option-list .multiple-choice-option{border:1px solid #666}.grid-choice-option-list .multiple-choice-option.checked,.grid-choice-option-list .multiple-choice-option.selected{border-color:#6592cb}.grid-choice-option-list .multiple-choice-option:focus{outline:none}.swipe-container .swipe-options-list .multiple-choice-option label{color:#333}.swipe-container .swipe-options-list .multiple-choice-option label:before{color:#6592cb}.swipe-container .swipe-options-list .multiple-choice-option.active{color:#333;background:#6592cb}.swipe-container .swipe-options-list .multiple-choice-option.active label:before{color:#fff!important}.swipe-container .swipe-options-list .multiple-choice-option:focus{color:#333;background:#6592cb!important}.swipe-container .swipe-options-list .multiple-choice-option:focus label:before{color:#fff!important}.swipe-container .swipe-options-list .multiple-choice-option:hover{color:#333;background:#6592cb}.swipe-container .swipe-options-list .multiple-choice-option:hover label:before{color:#fff!important}.menu-panel{border-color:#6592cb}.menu-panel .icon-container path{fill:#fff}.menu-panel .content-container .bite-title .required{background:#999}.asset-image .asset-desc{color:#333}.dialog-asset-image .dialog-body .asset-dialog-image .asset-image-header{background:#6592cb}.dialog-asset-image .dialog-body .asset-dialog-image .asset-image-header .title-col{color:#fff}.dialog-asset-image .dialog-body .asset-dialog-image .asset-image-header button{background:#6592cb;border-color:#fff;color:#fff}.dialog-asset-image .dialog-body .asset-dialog-image .asset-image-header .icon-btn-group button.active{background:#fff;border-color:#fff;color:#6592cb}.hot-spot-screen .hot-spot-content .hot-spot-background-container .hot-spot-area .hot-spot{color:#fff;background:#6592cb}.hot-spot-screen .hot-spot-content .hot-spot-background-container .hot-spot-area .hot-spot:active{background:#6592cb}.hot-spot-screen .hot-spot-content .hot-spot-background-container .hot-spot-area .hot-spot:focus,.hot-spot-screen .hot-spot-content .hot-spot-background-container .hot-spot-area .hot-spot:hover{background:#345177}.hot-spot-screen .hot-spot-content .hot-spot-background-container .hot-spot-area .hot-spot-hide,.hot-spot-screen .hot-spot-content .hot-spot-background-container .hot-spot-area .hot-spot-lg-icon,.hot-spot-screen .hot-spot-content .hot-spot-background-container .hot-spot-area .hot-spot-lg-icon-only,.hot-spot-screen .hot-spot-content .hot-spot-background-container .hot-spot-area .hot-spot-sml-icon,.hot-spot-screen .hot-spot-content .hot-spot-background-container .hot-spot-area .hot-spot-sml-icon-only{color:#fff;background:#6592cb}.hot-spot-screen .hot-spot-footer.scroll .footer-btn:before{color:#fff;background:#4c2f4c}.hot-spot-screen .hot-spot-footer.scroll .footer-btn:hover:before{background:#997099}.hot-spot-screen.large_screen .guroo-btn.introduction-btn,.hot-spot-screen.large_screen .hot-spot-footer .guroo-btn{background:#fff!important;color:#333!important}.hot-spot-screen.full_screen .hot-spot-footer .guroo-btn,.hot-spot-screen.no_screen .hot-spot-footer .guroo-btn{color:#fff!important;background:#6592cb}.dialog-page .screen-dialog .dialog-header{background:#6592cb;color:#fff}.dialog-page .screen-dialog .dialog-header button{background:#6592cb;border-color:#fff;color:#fff}.dialog-page .screen-dialog .dialog-header .icon-btn-group button.active{background:#fff;border-color:#fff;color:#6592cb}.kpi-overview-panel .kpi-overview-row .kpi-meter-col:before{background:#6592cb}.video-container{background:#000;color:#fff}.video-container .video-thumbnail-wrapper .video-controls:after,.video-container h4{color:#fff!important}.video-btn.active{border-color:#6592cb}.video-object .video-thumbnail-wrapper .video-details:before{color:#6592cb}blockquote{border-color:#6592cb}.tinted_dark:not(.accordion-screen) div:not(.call-out-style-1,call-out-style-2,call-out-style-3,call-out-style-4) h4{color:#fff}.tinted_dark:not(.accordion-screen) .standard-block{color:inherit!important;background:hsla(0,0%,100%,.9);padding:16px 24px!important;border-radius:5px;border:1px solid #d5d5d5}.tinted_dark:not(.accordion-screen) .standard-block h4{color:inherit!important}.tinted_dark:not(.accordion-screen) .question-prompt{color:inherit!important;border-radius:5px;border:1px solid #d5d5d5}.tinted_dark:not(.accordion-screen) .question-prompt h4,.tinted_dark:not(.accordion-screen) .question-wrapper,.tinted_dark:not(.accordion-screen) .question-wrapper h4{color:inherit!important}.tinted_dark:not(.accordion-screen) .question-wrapper .question-prompt{border:none;background:transparent;padding-top:0!important;padding-bottom:0!important}.tinted_dark:not(.accordion-screen) .question-wrapper.conversation .question-prompt{border:1px solid #d5d5d5;padding:16px 24px!important;background:#fff}.tinted_dark:not(.accordion-screen) .asset-image{border-radius:5px;border:1px solid #d5d5d5}.tinted_dark:not(.accordion-screen) .document-panel{position:relative;color:inherit!important;background:hsla(0,0%,100%,.9);padding:16px 24px!important;border-radius:5px;border:1px solid #d5d5d5}.tinted_dark:not(.accordion-screen) .document-panel h4{color:inherit!important}.tinted_dark:not(.accordion-screen) .library-image{background:hsla(0,0%,100%,.9);border-radius:5px;border:1px solid #d5d5d5}.tinted_dark:not(.accordion-screen) .paragraph-content-wrapper .library-image{background:transparent;border-radius:0;border:none}.tinted_dark:not(.accordion-screen) .customer_name_label,.tinted_dark:not(.accordion-screen) .user_name_label{color:#fff}.tinted_dark:not(.accordion-screen) .object-feed .learner-action-option.selected:before{left:48px!important}.tinted_dark:not(.accordion-screen) .object-feed .learner-action-option.review-selected:before{left:pxpx!important}.tinted_dark:not(.accordion-screen) .object-feed .learner-action-option.answered:before,.tinted_dark:not(.accordion-screen) .object-feed .learner-action-option.review:before,.tinted_dark:not(.accordion-screen) .object-feed .learner-action-option.show-answer:before{left:48px!important}@media only screen and (max-width:375px) and (max-height:736px) and (orientation:portrait){.tinted_dark:not(.accordion-screen) .question-wrapper .question-prompt.object-container{padding:0!important}.tinted_dark:not(.accordion-screen) .question-wrapper.conversation{overflow:visible;padding:0!important}.tinted_dark:not(.accordion-screen) .question-wrapper.conversation .question-prompt{padding:10px 12px!important}.tinted_dark:not(.accordion-screen) .question-wrapper.conversation.object-container{padding:0!important}.tinted_dark:not(.accordion-screen) .question-wrapper.conversation .feedback-panel{padding-left:24px!important;padding-right:24px!important}.tinted_dark:not(.accordion-screen) .content-character-expression+div.question-wrapper .question-prompt,.tinted_dark:not(.accordion-screen) .content-character-expression+div.standard-block{padding:10px 12px!important}.tinted_dark:not(.accordion-screen) .content-character-expression+div.question-wrapper.conversation{overflow:hidden}.tinted_dark:not(.accordion-screen) .content-character-expression+div.question-wrapper.conversation .question-prompt,.tinted_dark:not(.accordion-screen) .document-panel,.tinted_dark:not(.accordion-screen) .standard-block{padding:10px 12px!important}}@media only screen and (max-height:375px) and (max-width:736px) and (orientation:landscape){.tinted_dark:not(.accordion-screen) .question-wrapper .question-prompt.object-container{padding:0!important}.tinted_dark:not(.accordion-screen) .question-wrapper.conversation{overflow:visible;padding:0!important}.tinted_dark:not(.accordion-screen) .question-wrapper.conversation .question-prompt{padding:10px 12px!important}.tinted_dark:not(.accordion-screen) .question-wrapper.conversation.object-container{padding:0!important}.tinted_dark:not(.accordion-screen) .question-wrapper.conversation .feedback-panel{padding-left:24px!important;padding-right:24px!important}.tinted_dark:not(.accordion-screen) .content-character-expression+div.question-wrapper .question-prompt,.tinted_dark:not(.accordion-screen) .content-character-expression+div.standard-block{padding:10px 12px!important}.tinted_dark:not(.accordion-screen) .content-character-expression+div.question-wrapper.conversation{overflow:hidden}.tinted_dark:not(.accordion-screen) .content-character-expression+div.question-wrapper.conversation .question-prompt,.tinted_dark:not(.accordion-screen) .document-panel,.tinted_dark:not(.accordion-screen) .standard-block{padding:10px 12px!important}}@media only screen and (min-width:376px) and (max-width:414px) and (max-height:736px) and (orientation:portrait){.tinted_dark:not(.accordion-screen) .question-wrapper .question-prompt.object-container{padding:0!important}.tinted_dark:not(.accordion-screen) .question-wrapper.conversation{overflow:visible;padding:0!important}.tinted_dark:not(.accordion-screen) .question-wrapper.conversation .question-prompt{padding:10px 12px!important}.tinted_dark:not(.accordion-screen) .question-wrapper.conversation.object-container{padding:0!important}.tinted_dark:not(.accordion-screen) .question-wrapper.conversation .feedback-panel{padding-left:24px!important;padding-right:24px!important}.tinted_dark:not(.accordion-screen) .content-character-expression+div.question-wrapper .question-prompt,.tinted_dark:not(.accordion-screen) .content-character-expression+div.standard-block{padding:10px 12px!important}.tinted_dark:not(.accordion-screen) .content-character-expression+div.question-wrapper.conversation{overflow:hidden}.tinted_dark:not(.accordion-screen) .content-character-expression+div.question-wrapper.conversation .question-prompt,.tinted_dark:not(.accordion-screen) .document-panel,.tinted_dark:not(.accordion-screen) .standard-block{padding:10px 12px!important}}@media only screen and (min-height:376px) and (max-height:414px) and (max-width:736px) and (orientation:landscape){.tinted_dark:not(.accordion-screen) .question-wrapper .question-prompt.object-container{padding:0!important}.tinted_dark:not(.accordion-screen) .question-wrapper.conversation{overflow:visible;padding:0!important}.tinted_dark:not(.accordion-screen) .question-wrapper.conversation .question-prompt{padding:10px 12px!important}.tinted_dark:not(.accordion-screen) .question-wrapper.conversation.object-container{padding:0!important}.tinted_dark:not(.accordion-screen) .question-wrapper.conversation .feedback-panel{padding-left:24px!important;padding-right:24px!important}.tinted_dark:not(.accordion-screen) .content-character-expression+div.question-wrapper .question-prompt,.tinted_dark:not(.accordion-screen) .content-character-expression+div.standard-block{padding:10px 12px!important}.tinted_dark:not(.accordion-screen) .content-character-expression+div.question-wrapper.conversation{overflow:hidden}.tinted_dark:not(.accordion-screen) .content-character-expression+div.question-wrapper.conversation .question-prompt,.tinted_dark:not(.accordion-screen) .document-panel,.tinted_dark:not(.accordion-screen) .standard-block{padding:10px 12px!important}}@media only screen and (max-width:375px) and (min-height:737px) and (max-height:812px) and (orientation:portrait){.tinted_dark:not(.accordion-screen) .question-wrapper .question-prompt.object-container{padding:0!important}.tinted_dark:not(.accordion-screen) .question-wrapper.conversation{overflow:visible;padding:0!important}.tinted_dark:not(.accordion-screen) .question-wrapper.conversation .question-prompt{padding:10px 12px!important}.tinted_dark:not(.accordion-screen) .question-wrapper.conversation.object-container{padding:0!important}.tinted_dark:not(.accordion-screen) .question-wrapper.conversation .feedback-panel{padding-left:24px!important;padding-right:24px!important}.tinted_dark:not(.accordion-screen) .content-character-expression+div.question-wrapper .question-prompt,.tinted_dark:not(.accordion-screen) .content-character-expression+div.standard-block{padding:10px 12px!important}.tinted_dark:not(.accordion-screen) .content-character-expression+div.question-wrapper.conversation{overflow:hidden}.tinted_dark:not(.accordion-screen) .content-character-expression+div.question-wrapper.conversation .question-prompt,.tinted_dark:not(.accordion-screen) .document-panel,.tinted_dark:not(.accordion-screen) .standard-block{padding:10px 12px!important}}@media only screen and (min-width:737px) and (max-width:812px) and (max-height:375px) and (orientation:landscape){.tinted_dark:not(.accordion-screen) .question-wrapper .question-prompt.object-container{padding:0!important}.tinted_dark:not(.accordion-screen) .question-wrapper.conversation{overflow:visible;padding:0!important}.tinted_dark:not(.accordion-screen) .question-wrapper.conversation .question-prompt{padding:10px 12px!important}.tinted_dark:not(.accordion-screen) .question-wrapper.conversation.object-container{padding:0!important}.tinted_dark:not(.accordion-screen) .question-wrapper.conversation .feedback-panel{padding-left:24px!important;padding-right:24px!important}.tinted_dark:not(.accordion-screen) .content-character-expression+div.question-wrapper .question-prompt,.tinted_dark:not(.accordion-screen) .content-character-expression+div.standard-block{padding:10px 12px!important}.tinted_dark:not(.accordion-screen) .content-character-expression+div.question-wrapper.conversation{overflow:hidden}.tinted_dark:not(.accordion-screen) .content-character-expression+div.question-wrapper.conversation .question-prompt,.tinted_dark:not(.accordion-screen) .document-panel,.tinted_dark:not(.accordion-screen) .standard-block{padding:10px 12px!important}}@media only screen and (max-width:320px) and (max-height:568px) and (orientation:portrait){.tinted_dark:not(.accordion-screen) .question-wrapper .question-prompt.object-container{padding:0!important}.tinted_dark:not(.accordion-screen) .question-wrapper.conversation{overflow:visible;padding:0!important}.tinted_dark:not(.accordion-screen) .question-wrapper.conversation .question-prompt{padding:10px 12px!important}.tinted_dark:not(.accordion-screen) .question-wrapper.conversation.object-container{padding:0!important}.tinted_dark:not(.accordion-screen) .question-wrapper.conversation .feedback-panel{padding-left:24px!important;padding-right:24px!important}.tinted_dark:not(.accordion-screen) .content-character-expression+div.question-wrapper .question-prompt,.tinted_dark:not(.accordion-screen) .content-character-expression+div.standard-block{padding:10px 12px!important}.tinted_dark:not(.accordion-screen) .content-character-expression+div.question-wrapper.conversation{overflow:hidden}.tinted_dark:not(.accordion-screen) .content-character-expression+div.question-wrapper.conversation .question-prompt,.tinted_dark:not(.accordion-screen) .document-panel,.tinted_dark:not(.accordion-screen) .standard-block{padding:10px 12px!important}}.tinted_dark:not(.accordion-screen) .asset-col-left .image-credit,.tinted_dark:not(.accordion-screen) .asset-col-right .image-credit{color:#fff}.transparent:not(.accordion-screen) .asset-col-left .image-credit,.transparent:not(.accordion-screen) .asset-col-right .image-credit{margin-top:10px;background:hsla(0,0%,100%,.9)}.thick_glass:not(.accordion-screen) .standard-block,.transparent:not(.accordion-screen) .standard-block{color:inherit!important;background:hsla(0,0%,100%,.9);padding:16px 24px!important;border-radius:5px;border:1px solid #d5d5d5}.thick_glass:not(.accordion-screen) .standard-block h4,.transparent:not(.accordion-screen) .standard-block h4{color:inherit!important}.thick_glass:not(.accordion-screen) .question-prompt,.transparent:not(.accordion-screen) .question-prompt{color:inherit!important;background:hsla(0,0%,100%,.9);border-radius:5px}.thick_glass:not(.accordion-screen) .question-prompt h4,.thick_glass:not(.accordion-screen) .question-wrapper,.thick_glass:not(.accordion-screen) .question-wrapper h4,.transparent:not(.accordion-screen) .question-prompt h4,.transparent:not(.accordion-screen) .question-wrapper,.transparent:not(.accordion-screen) .question-wrapper h4{color:inherit!important}.thick_glass:not(.accordion-screen) .question-wrapper .question-prompt,.transparent:not(.accordion-screen) .question-wrapper .question-prompt{background:transparent}.thick_glass:not(.accordion-screen) .question-wrapper.conversation .question-prompt,.transparent:not(.accordion-screen) .question-wrapper.conversation .question-prompt{border:1px solid #d5d5d5;padding:16px 24px!important;background:#fff}.thick_glass:not(.accordion-screen) .asset-image,.transparent:not(.accordion-screen) .asset-image{border-radius:5px;border:1px solid #d5d5d5}.thick_glass:not(.accordion-screen) .document-panel,.transparent:not(.accordion-screen) .document-panel{color:inherit!important;background:hsla(0,0%,100%,.9);padding:16px 24px!important;border-radius:5px;border:1px solid #d5d5d5}.thick_glass:not(.accordion-screen) .document-panel h4,.transparent:not(.accordion-screen) .document-panel h4{color:inherit!important}.thick_glass:not(.accordion-screen) .library-image,.transparent:not(.accordion-screen) .library-image{background:hsla(0,0%,100%,.9);border-radius:5px;border:1px solid #d5d5d5}.thick_glass:not(.accordion-screen) .paragraph-content-wrapper .library-image,.transparent:not(.accordion-screen) .paragraph-content-wrapper .library-image{background:transparent;border-radius:0;border:none}.thick_glass:not(.accordion-screen) .object-feed .learner-action-option.answered:before,.thick_glass:not(.accordion-screen) .object-feed .learner-action-option.review-selected:before,.thick_glass:not(.accordion-screen) .object-feed .learner-action-option.review:before,.thick_glass:not(.accordion-screen) .object-feed .learner-action-option.selected:before,.thick_glass:not(.accordion-screen) .object-feed .learner-action-option.show-answer:before,.transparent:not(.accordion-screen) .object-feed .learner-action-option.answered:before,.transparent:not(.accordion-screen) .object-feed .learner-action-option.review-selected:before,.transparent:not(.accordion-screen) .object-feed .learner-action-option.review:before,.transparent:not(.accordion-screen) .object-feed .learner-action-option.selected:before,.transparent:not(.accordion-screen) .object-feed .learner-action-option.show-answer:before{left:48px!important}@media only screen and (max-width:375px) and (max-height:736px) and (orientation:portrait){.thick_glass:not(.accordion-screen) .question-wrapper .question-prompt.object-container,.transparent:not(.accordion-screen) .question-wrapper .question-prompt.object-container{padding:0!important}.thick_glass:not(.accordion-screen) .question-wrapper.conversation,.transparent:not(.accordion-screen) .question-wrapper.conversation{overflow:visible;padding:0!important}.thick_glass:not(.accordion-screen) .question-wrapper.conversation .question-prompt,.transparent:not(.accordion-screen) .question-wrapper.conversation .question-prompt{padding:10px 12px!important}.thick_glass:not(.accordion-screen) .question-wrapper.conversation.object-container,.transparent:not(.accordion-screen) .question-wrapper.conversation.object-container{padding:0!important}.thick_glass:not(.accordion-screen) .question-wrapper.conversation .feedback-panel,.transparent:not(.accordion-screen) .question-wrapper.conversation .feedback-panel{padding-left:24px!important;padding-right:24px!important}.thick_glass:not(.accordion-screen) .content-character-expression+div.question-wrapper .question-prompt,.thick_glass:not(.accordion-screen) .content-character-expression+div.standard-block,.transparent:not(.accordion-screen) .content-character-expression+div.question-wrapper .question-prompt,.transparent:not(.accordion-screen) .content-character-expression+div.standard-block{padding:10px 12px!important}.thick_glass:not(.accordion-screen) .content-character-expression+div.question-wrapper.conversation,.transparent:not(.accordion-screen) .content-character-expression+div.question-wrapper.conversation{overflow:hidden}.thick_glass:not(.accordion-screen) .content-character-expression+div.question-wrapper.conversation .question-prompt,.thick_glass:not(.accordion-screen) .document-panel,.thick_glass:not(.accordion-screen) .standard-block,.transparent:not(.accordion-screen) .content-character-expression+div.question-wrapper.conversation .question-prompt,.transparent:not(.accordion-screen) .document-panel,.transparent:not(.accordion-screen) .standard-block{padding:10px 12px!important}}@media only screen and (max-height:375px) and (max-width:736px) and (orientation:landscape){.thick_glass:not(.accordion-screen) .question-wrapper .question-prompt.object-container,.transparent:not(.accordion-screen) .question-wrapper .question-prompt.object-container{padding:0!important}.thick_glass:not(.accordion-screen) .question-wrapper.conversation,.transparent:not(.accordion-screen) .question-wrapper.conversation{overflow:visible;padding:0!important}.thick_glass:not(.accordion-screen) .question-wrapper.conversation .question-prompt,.transparent:not(.accordion-screen) .question-wrapper.conversation .question-prompt{padding:10px 12px!important}.thick_glass:not(.accordion-screen) .question-wrapper.conversation.object-container,.transparent:not(.accordion-screen) .question-wrapper.conversation.object-container{padding:0!important}.thick_glass:not(.accordion-screen) .question-wrapper.conversation .feedback-panel,.transparent:not(.accordion-screen) .question-wrapper.conversation .feedback-panel{padding-left:24px!important;padding-right:24px!important}.thick_glass:not(.accordion-screen) .content-character-expression+div.question-wrapper .question-prompt,.thick_glass:not(.accordion-screen) .content-character-expression+div.standard-block,.transparent:not(.accordion-screen) .content-character-expression+div.question-wrapper .question-prompt,.transparent:not(.accordion-screen) .content-character-expression+div.standard-block{padding:10px 12px!important}.thick_glass:not(.accordion-screen) .content-character-expression+div.question-wrapper.conversation,.transparent:not(.accordion-screen) .content-character-expression+div.question-wrapper.conversation{overflow:hidden}.thick_glass:not(.accordion-screen) .content-character-expression+div.question-wrapper.conversation .question-prompt,.thick_glass:not(.accordion-screen) .document-panel,.thick_glass:not(.accordion-screen) .standard-block,.transparent:not(.accordion-screen) .content-character-expression+div.question-wrapper.conversation .question-prompt,.transparent:not(.accordion-screen) .document-panel,.transparent:not(.accordion-screen) .standard-block{padding:10px 12px!important}}@media only screen and (min-width:376px) and (max-width:414px) and (max-height:736px) and (orientation:portrait){.thick_glass:not(.accordion-screen) .question-wrapper .question-prompt.object-container,.transparent:not(.accordion-screen) .question-wrapper .question-prompt.object-container{padding:0!important}.thick_glass:not(.accordion-screen) .question-wrapper.conversation,.transparent:not(.accordion-screen) .question-wrapper.conversation{overflow:visible;padding:0!important}.thick_glass:not(.accordion-screen) .question-wrapper.conversation .question-prompt,.transparent:not(.accordion-screen) .question-wrapper.conversation .question-prompt{padding:10px 12px!important}.thick_glass:not(.accordion-screen) .question-wrapper.conversation.object-container,.transparent:not(.accordion-screen) .question-wrapper.conversation.object-container{padding:0!important}.thick_glass:not(.accordion-screen) .question-wrapper.conversation .feedback-panel,.transparent:not(.accordion-screen) .question-wrapper.conversation .feedback-panel{padding-left:24px!important;padding-right:24px!important}.thick_glass:not(.accordion-screen) .content-character-expression+div.question-wrapper .question-prompt,.thick_glass:not(.accordion-screen) .content-character-expression+div.standard-block,.transparent:not(.accordion-screen) .content-character-expression+div.question-wrapper .question-prompt,.transparent:not(.accordion-screen) .content-character-expression+div.standard-block{padding:10px 12px!important}.thick_glass:not(.accordion-screen) .content-character-expression+div.question-wrapper.conversation,.transparent:not(.accordion-screen) .content-character-expression+div.question-wrapper.conversation{overflow:hidden}.thick_glass:not(.accordion-screen) .content-character-expression+div.question-wrapper.conversation .question-prompt,.thick_glass:not(.accordion-screen) .document-panel,.thick_glass:not(.accordion-screen) .standard-block,.transparent:not(.accordion-screen) .content-character-expression+div.question-wrapper.conversation .question-prompt,.transparent:not(.accordion-screen) .document-panel,.transparent:not(.accordion-screen) .standard-block{padding:10px 12px!important}}@media only screen and (min-height:376px) and (max-height:414px) and (max-width:736px) and (orientation:landscape){.thick_glass:not(.accordion-screen) .question-wrapper .question-prompt.object-container,.transparent:not(.accordion-screen) .question-wrapper .question-prompt.object-container{padding:0!important}.thick_glass:not(.accordion-screen) .question-wrapper.conversation,.transparent:not(.accordion-screen) .question-wrapper.conversation{overflow:visible;padding:0!important}.thick_glass:not(.accordion-screen) .question-wrapper.conversation .question-prompt,.transparent:not(.accordion-screen) .question-wrapper.conversation .question-prompt{padding:10px 12px!important}.thick_glass:not(.accordion-screen) .question-wrapper.conversation.object-container,.transparent:not(.accordion-screen) .question-wrapper.conversation.object-container{padding:0!important}.thick_glass:not(.accordion-screen) .question-wrapper.conversation .feedback-panel,.transparent:not(.accordion-screen) .question-wrapper.conversation .feedback-panel{padding-left:24px!important;padding-right:24px!important}.thick_glass:not(.accordion-screen) .content-character-expression+div.question-wrapper .question-prompt,.thick_glass:not(.accordion-screen) .content-character-expression+div.standard-block,.transparent:not(.accordion-screen) .content-character-expression+div.question-wrapper .question-prompt,.transparent:not(.accordion-screen) .content-character-expression+div.standard-block{padding:10px 12px!important}.thick_glass:not(.accordion-screen) .content-character-expression+div.question-wrapper.conversation,.transparent:not(.accordion-screen) .content-character-expression+div.question-wrapper.conversation{overflow:hidden}.thick_glass:not(.accordion-screen) .content-character-expression+div.question-wrapper.conversation .question-prompt,.thick_glass:not(.accordion-screen) .document-panel,.thick_glass:not(.accordion-screen) .standard-block,.transparent:not(.accordion-screen) .content-character-expression+div.question-wrapper.conversation .question-prompt,.transparent:not(.accordion-screen) .document-panel,.transparent:not(.accordion-screen) .standard-block{padding:10px 12px!important}}@media only screen and (max-width:375px) and (min-height:737px) and (max-height:812px) and (orientation:portrait){.thick_glass:not(.accordion-screen) .question-wrapper .question-prompt.object-container,.transparent:not(.accordion-screen) .question-wrapper .question-prompt.object-container{padding:0!important}.thick_glass:not(.accordion-screen) .question-wrapper.conversation,.transparent:not(.accordion-screen) .question-wrapper.conversation{overflow:visible;padding:0!important}.thick_glass:not(.accordion-screen) .question-wrapper.conversation .question-prompt,.transparent:not(.accordion-screen) .question-wrapper.conversation .question-prompt{padding:10px 12px!important}.thick_glass:not(.accordion-screen) .question-wrapper.conversation.object-container,.transparent:not(.accordion-screen) .question-wrapper.conversation.object-container{padding:0!important}.thick_glass:not(.accordion-screen) .question-wrapper.conversation .feedback-panel,.transparent:not(.accordion-screen) .question-wrapper.conversation .feedback-panel{padding-left:24px!important;padding-right:24px!important}.thick_glass:not(.accordion-screen) .content-character-expression+div.question-wrapper .question-prompt,.thick_glass:not(.accordion-screen) .content-character-expression+div.standard-block,.transparent:not(.accordion-screen) .content-character-expression+div.question-wrapper .question-prompt,.transparent:not(.accordion-screen) .content-character-expression+div.standard-block{padding:10px 12px!important}.thick_glass:not(.accordion-screen) .content-character-expression+div.question-wrapper.conversation,.transparent:not(.accordion-screen) .content-character-expression+div.question-wrapper.conversation{overflow:hidden}.thick_glass:not(.accordion-screen) .content-character-expression+div.question-wrapper.conversation .question-prompt,.thick_glass:not(.accordion-screen) .document-panel,.thick_glass:not(.accordion-screen) .standard-block,.transparent:not(.accordion-screen) .content-character-expression+div.question-wrapper.conversation .question-prompt,.transparent:not(.accordion-screen) .document-panel,.transparent:not(.accordion-screen) .standard-block{padding:10px 12px!important}}@media only screen and (min-width:737px) and (max-width:812px) and (max-height:375px) and (orientation:landscape){.thick_glass:not(.accordion-screen) .question-wrapper .question-prompt.object-container,.transparent:not(.accordion-screen) .question-wrapper .question-prompt.object-container{padding:0!important}.thick_glass:not(.accordion-screen) .question-wrapper.conversation,.transparent:not(.accordion-screen) .question-wrapper.conversation{overflow:visible;padding:0!important}.thick_glass:not(.accordion-screen) .question-wrapper.conversation .question-prompt,.transparent:not(.accordion-screen) .question-wrapper.conversation .question-prompt{padding:10px 12px!important}.thick_glass:not(.accordion-screen) .question-wrapper.conversation.object-container,.transparent:not(.accordion-screen) .question-wrapper.conversation.object-container{padding:0!important}.thick_glass:not(.accordion-screen) .question-wrapper.conversation .feedback-panel,.transparent:not(.accordion-screen) .question-wrapper.conversation .feedback-panel{padding-left:24px!important;padding-right:24px!important}.thick_glass:not(.accordion-screen) .content-character-expression+div.question-wrapper .question-prompt,.thick_glass:not(.accordion-screen) .content-character-expression+div.standard-block,.transparent:not(.accordion-screen) .content-character-expression+div.question-wrapper .question-prompt,.transparent:not(.accordion-screen) .content-character-expression+div.standard-block{padding:10px 12px!important}.thick_glass:not(.accordion-screen) .content-character-expression+div.question-wrapper.conversation,.transparent:not(.accordion-screen) .content-character-expression+div.question-wrapper.conversation{overflow:hidden}.thick_glass:not(.accordion-screen) .content-character-expression+div.question-wrapper.conversation .question-prompt,.thick_glass:not(.accordion-screen) .document-panel,.thick_glass:not(.accordion-screen) .standard-block,.transparent:not(.accordion-screen) .content-character-expression+div.question-wrapper.conversation .question-prompt,.transparent:not(.accordion-screen) .document-panel,.transparent:not(.accordion-screen) .standard-block{padding:10px 12px!important}}@media only screen and (max-width:320px) and (max-height:568px) and (orientation:portrait){.thick_glass:not(.accordion-screen) .question-wrapper .question-prompt.object-container,.transparent:not(.accordion-screen) .question-wrapper .question-prompt.object-container{padding:0!important}.thick_glass:not(.accordion-screen) .question-wrapper.conversation,.transparent:not(.accordion-screen) .question-wrapper.conversation{overflow:visible;padding:0!important}.thick_glass:not(.accordion-screen) .question-wrapper.conversation .question-prompt,.transparent:not(.accordion-screen) .question-wrapper.conversation .question-prompt{padding:10px 12px!important}.thick_glass:not(.accordion-screen) .question-wrapper.conversation.object-container,.transparent:not(.accordion-screen) .question-wrapper.conversation.object-container{padding:0!important}.thick_glass:not(.accordion-screen) .question-wrapper.conversation .feedback-panel,.transparent:not(.accordion-screen) .question-wrapper.conversation .feedback-panel{padding-left:24px!important;padding-right:24px!important}.thick_glass:not(.accordion-screen) .content-character-expression+div.question-wrapper .question-prompt,.thick_glass:not(.accordion-screen) .content-character-expression+div.standard-block,.transparent:not(.accordion-screen) .content-character-expression+div.question-wrapper .question-prompt,.transparent:not(.accordion-screen) .content-character-expression+div.standard-block{padding:10px 12px!important}.thick_glass:not(.accordion-screen) .content-character-expression+div.question-wrapper.conversation,.transparent:not(.accordion-screen) .content-character-expression+div.question-wrapper.conversation{overflow:hidden}.thick_glass:not(.accordion-screen) .content-character-expression+div.question-wrapper.conversation .question-prompt,.thick_glass:not(.accordion-screen) .document-panel,.thick_glass:not(.accordion-screen) .standard-block,.transparent:not(.accordion-screen) .content-character-expression+div.question-wrapper.conversation .question-prompt,.transparent:not(.accordion-screen) .document-panel,.transparent:not(.accordion-screen) .standard-block{padding:10px 12px!important}}.frosted_white .content-character-expression+div.standard-block{color:inherit!important;background:#fff;padding:16px 24px!important;border-radius:5px}.frosted_white .content-character-expression+div.standard-block h4{color:inherit!important}.frosted_white .content-character-expression+div .question-prompt{color:inherit!important;background:#fff;border-radius:5px}.frosted_white .content-character-expression+div .question-prompt h4{color:inherit!important}.frosted_white .content-character-expression+div.question-wrapper{background:#fff;color:inherit!important}.frosted_white .content-character-expression+div.question-wrapper h4{color:inherit!important}.frosted_white .content-character-expression+div.question-wrapper .question-prompt{background:transparent}.frosted_white .content-character-expression+div.question-wrapper.conversation .question-prompt{border:1px solid #d5d5d5;padding:16px 24px!important;background:#fff}.frosted_white question-wrapper{background:#fff}@media only screen and (max-width:375px) and (max-height:736px) and (orientation:portrait){.frosted_white .question-wrapper.conversation{overflow:visible;padding:0!important}.frosted_white .question-wrapper.conversation .question-prompt{padding:10px 12px!important}.frosted_white .question-wrapper.conversation.object-container{padding:0!important}.frosted_white .question-wrapper.conversation .feedback-panel{padding-left:24px!important;padding-right:24px!important}.frosted_white .question-wrapper.conversation .learner-action-option.answered:before,.frosted_white .question-wrapper.conversation .learner-action-option.review-selected:before,.frosted_white .question-wrapper.conversation .learner-action-option.review:before,.frosted_white .question-wrapper.conversation .learner-action-option.selected:before,.frosted_white .question-wrapper.conversation .learner-action-option.show-answer:before{left:24px!important}.frosted_white .question-wrapper.conversation .learner-action-option.answered:after{right:18px!important}.frosted_white .content-character-expression+div.question-wrapper .question-prompt,.frosted_white .content-character-expression+div.standard-block{padding:10px 12px!important}.frosted_white .content-character-expression+div.question-wrapper.conversation{overflow:hidden}.frosted_white .content-character-expression+div.question-wrapper.conversation .question-prompt{padding:10px 12px!important}.frosted_white .content-character-expression+div.question-wrapper.conversation .feedback-panel{margin:0!important}.frosted_white .standard-block{padding:10px 12px!important}}@media only screen and (max-height:375px) and (max-width:736px) and (orientation:landscape){.frosted_white .question-wrapper.conversation{overflow:visible;padding:0!important}.frosted_white .question-wrapper.conversation .question-prompt{padding:10px 12px!important}.frosted_white .question-wrapper.conversation.object-container{padding:0!important}.frosted_white .question-wrapper.conversation .feedback-panel{padding-left:24px!important;padding-right:24px!important}.frosted_white .question-wrapper.conversation .learner-action-option.answered:before,.frosted_white .question-wrapper.conversation .learner-action-option.review-selected:before,.frosted_white .question-wrapper.conversation .learner-action-option.review:before,.frosted_white .question-wrapper.conversation .learner-action-option.selected:before,.frosted_white .question-wrapper.conversation .learner-action-option.show-answer:before{left:24px!important}.frosted_white .question-wrapper.conversation .learner-action-option.answered:after{right:18px!important}.frosted_white .content-character-expression+div.question-wrapper .question-prompt,.frosted_white .content-character-expression+div.standard-block{padding:10px 12px!important}.frosted_white .content-character-expression+div.question-wrapper.conversation{overflow:hidden}.frosted_white .content-character-expression+div.question-wrapper.conversation .question-prompt{padding:10px 12px!important}.frosted_white .content-character-expression+div.question-wrapper.conversation .feedback-panel{margin:0!important}.frosted_white .standard-block{padding:10px 12px!important}}@media only screen and (min-width:376px) and (max-width:414px) and (max-height:736px) and (orientation:portrait){.frosted_white .question-wrapper.conversation{overflow:visible;padding:0!important}.frosted_white .question-wrapper.conversation .question-prompt{padding:10px 12px!important}.frosted_white .question-wrapper.conversation.object-container{padding:0!important}.frosted_white .question-wrapper.conversation .feedback-panel{padding-left:24px!important;padding-right:24px!important}.frosted_white .question-wrapper.conversation .learner-action-option.answered:before,.frosted_white .question-wrapper.conversation .learner-action-option.review-selected:before,.frosted_white .question-wrapper.conversation .learner-action-option.review:before,.frosted_white .question-wrapper.conversation .learner-action-option.selected:before,.frosted_white .question-wrapper.conversation .learner-action-option.show-answer:before{left:24px!important}.frosted_white .question-wrapper.conversation .learner-action-option.answered:after{right:18px!important}.frosted_white .content-character-expression+div.question-wrapper .question-prompt,.frosted_white .content-character-expression+div.standard-block{padding:10px 12px!important}.frosted_white .content-character-expression+div.question-wrapper.conversation{overflow:hidden}.frosted_white .content-character-expression+div.question-wrapper.conversation .question-prompt{padding:10px 12px!important}.frosted_white .content-character-expression+div.question-wrapper.conversation .feedback-panel{margin:0!important}.frosted_white .standard-block{padding:10px 12px!important}}@media only screen and (min-height:376px) and (max-height:414px) and (max-width:736px) and (orientation:landscape){.frosted_white .question-wrapper.conversation{overflow:visible;padding:0!important}.frosted_white .question-wrapper.conversation .question-prompt{padding:10px 12px!important}.frosted_white .question-wrapper.conversation.object-container{padding:0!important}.frosted_white .question-wrapper.conversation .feedback-panel{padding-left:24px!important;padding-right:24px!important}.frosted_white .question-wrapper.conversation .learner-action-option.answered:before,.frosted_white .question-wrapper.conversation .learner-action-option.review-selected:before,.frosted_white .question-wrapper.conversation .learner-action-option.review:before,.frosted_white .question-wrapper.conversation .learner-action-option.selected:before,.frosted_white .question-wrapper.conversation .learner-action-option.show-answer:before{left:24px!important}.frosted_white .question-wrapper.conversation .learner-action-option.answered:after{right:18px!important}.frosted_white .content-character-expression+div.question-wrapper .question-prompt,.frosted_white .content-character-expression+div.standard-block{padding:10px 12px!important}.frosted_white .content-character-expression+div.question-wrapper.conversation{overflow:hidden}.frosted_white .content-character-expression+div.question-wrapper.conversation .question-prompt{padding:10px 12px!important}.frosted_white .content-character-expression+div.question-wrapper.conversation .feedback-panel{margin:0!important}.frosted_white .standard-block{padding:10px 12px!important}}@media only screen and (max-width:375px) and (min-height:737px) and (max-height:812px) and (orientation:portrait){.frosted_white .question-wrapper.conversation{overflow:visible;padding:0!important}.frosted_white .question-wrapper.conversation .question-prompt{padding:10px 12px!important}.frosted_white .question-wrapper.conversation.object-container{padding:0!important}.frosted_white .question-wrapper.conversation .feedback-panel{padding-left:24px!important;padding-right:24px!important}.frosted_white .question-wrapper.conversation .learner-action-option.answered:before,.frosted_white .question-wrapper.conversation .learner-action-option.review-selected:before,.frosted_white .question-wrapper.conversation .learner-action-option.review:before,.frosted_white .question-wrapper.conversation .learner-action-option.selected:before,.frosted_white .question-wrapper.conversation .learner-action-option.show-answer:before{left:24px!important}.frosted_white .question-wrapper.conversation .learner-action-option.answered:after{right:18px!important}.frosted_white .content-character-expression+div.question-wrapper .question-prompt,.frosted_white .content-character-expression+div.standard-block{padding:10px 12px!important}.frosted_white .content-character-expression+div.question-wrapper.conversation{overflow:hidden}.frosted_white .content-character-expression+div.question-wrapper.conversation .question-prompt{padding:10px 12px!important}.frosted_white .content-character-expression+div.question-wrapper.conversation .feedback-panel{margin:0!important}.frosted_white .standard-block{padding:10px 12px!important}}@media only screen and (min-width:737px) and (max-width:812px) and (max-height:375px) and (orientation:landscape){.frosted_white .question-wrapper.conversation{overflow:visible;padding:0!important}.frosted_white .question-wrapper.conversation .question-prompt{padding:10px 12px!important}.frosted_white .question-wrapper.conversation.object-container{padding:0!important}.frosted_white .question-wrapper.conversation .feedback-panel{padding-left:24px!important;padding-right:24px!important}.frosted_white .question-wrapper.conversation .learner-action-option.answered:before,.frosted_white .question-wrapper.conversation .learner-action-option.review-selected:before,.frosted_white .question-wrapper.conversation .learner-action-option.review:before,.frosted_white .question-wrapper.conversation .learner-action-option.selected:before,.frosted_white .question-wrapper.conversation .learner-action-option.show-answer:before{left:24px!important}.frosted_white .question-wrapper.conversation .learner-action-option.answered:after{right:18px!important}.frosted_white .content-character-expression+div.question-wrapper .question-prompt,.frosted_white .content-character-expression+div.standard-block{padding:10px 12px!important}.frosted_white .content-character-expression+div.question-wrapper.conversation{overflow:hidden}.frosted_white .content-character-expression+div.question-wrapper.conversation .question-prompt{padding:10px 12px!important}.frosted_white .content-character-expression+div.question-wrapper.conversation .feedback-panel{margin:0!important}.frosted_white .standard-block{padding:10px 12px!important}}@media only screen and (max-width:320px) and (max-height:568px) and (orientation:portrait){.frosted_white .question-wrapper.conversation{overflow:visible;padding:0!important}.frosted_white .question-wrapper.conversation .question-prompt{padding:10px 12px!important}.frosted_white .question-wrapper.conversation.object-container{padding:0!important}.frosted_white .question-wrapper.conversation .feedback-panel{padding-left:24px!important;padding-right:24px!important}.frosted_white .question-wrapper.conversation .learner-action-option.answered:before,.frosted_white .question-wrapper.conversation .learner-action-option.review-selected:before,.frosted_white .question-wrapper.conversation .learner-action-option.review:before,.frosted_white .question-wrapper.conversation .learner-action-option.selected:before,.frosted_white .question-wrapper.conversation .learner-action-option.show-answer:before{left:24px!important}.frosted_white .question-wrapper.conversation .learner-action-option.answered:after{right:18px!important}.frosted_white .content-character-expression+div.question-wrapper .question-prompt,.frosted_white .content-character-expression+div.standard-block{padding:10px 12px!important}.frosted_white .content-character-expression+div.question-wrapper.conversation{overflow:hidden}.frosted_white .content-character-expression+div.question-wrapper.conversation .question-prompt{padding:10px 12px!important}.frosted_white .content-character-expression+div.question-wrapper.conversation .feedback-panel{margin:0!important}.frosted_white .standard-block{padding:10px 12px!important}}.selection-menu .menu-option-container .menu-option-list .option-item .option-label{color:#6592cb}.resource-link{color:#6592cb;cursor:pointer}.resource-link:active,.resource-link:focus,.resource-link:hover,.resource-link span:focus{color:#c1cfde}.ql-done{display:inline-block;overflow:hidden;background:#6592cb;width:auto!important;height:auto!important;color:#fff;border-radius:5px;padding:4px 12px!important;float:right!important;margin-right:10px!important;font-size:80%!important}.ql-done:active,.ql-done:focus,.ql-done:hover{background:#6689c6;color:#fff}.ql-done:disabled{background:#ccc;color:#999}.text-resize-list{color:#333}.feed-object-container{padding-top:4px;padding-bottom:4px}.feed-object-container:focus{border-radius:5px;background:#f7f7f8}.frosted_white:not(.accordion-screen) .feed-object-container:focus,.thick_glass:not(.accordion-screen) .feed-object-container:focus,.transparent:not(.accordion-screen) .feed-object-container:focus{background:hsla(240,7%,97%,.3)!important}.tinted_dark:not(.accordion-screen) .feed-object-container:focus{background:rgba(0,0,0,.5)!important}.dialog-body .feed-object-container:focus,.slider-body-content .feed-object-container:focus{background:#f7f7f8!important}.multiple-choice-option:focus{outline:none!important}.content-wrappe-{height:100%!important}.content-wrappe-,.content-wrappe- .content-area{width:calc(100% - 160px);padding:30px 24px;margin:0 80px auto}.content-wrappe- .content-area{position:absolute;top:0;left:0;right:0;height:100%;overflow-y:scroll!important;z-index:2!important}.content-wrappe- .content-area .learner-action-option-list{margin-left:24px;margin-right:24px}.content-wrappe- .content-wrapper-background{display:none}.content-wrappe-.frosted_white .content-wrapper-background{z-index:1;display:block;position:absolute;top:0;left:0;right:0;width:100%;height:100%;margin:auto;-webkit-clip-path:inset(0 80px 0 80px);clip-path:inset(0 80px 0 80px);-webkit-filter:blur(15px);filter:blur(15px)}.content-wrappe-.frosted_white .content-wrapper-background img{position:absolute;bottom:0;left:0;right:0;margin:auto;width:100%;height:auto}@media only screen and (max-width:375px) and (max-height:736px) and (orientation:portrait){.content-wrappe-.frosted_white .content-wrapper-background img{min-height:100vh;position:absolute;height:100%;left:0;right:0;margin:auto!important;width:auto;min-width:100%}}@media only screen and (max-height:375px) and (max-width:736px) and (orientation:landscape){.content-wrappe-.frosted_white .content-wrapper-background img{min-height:100vh;height:auto;top:0;width:100%}.content-wrappe-.frosted_white .content-wrapper-background img.title-screen{bottom:unset;top:0}}@media only screen and (min-width:376px) and (max-width:414px) and (max-height:736px) and (orientation:portrait){.content-wrappe-.frosted_white .content-wrapper-background img{min-height:100vh;position:absolute;height:100%;left:0;right:0;margin:auto!important;width:auto;min-width:100%}}@media only screen and (min-height:376px) and (max-height:414px) and (max-width:736px) and (orientation:landscape){.content-wrappe-.frosted_white .content-wrapper-background img{min-height:100vh;height:auto;bottom:0;width:100%}.content-wrappe-.frosted_white .content-wrapper-background img.title-screen{bottom:unset;top:0}}@media only screen and (min-width:768px) and (max-width:1024px) and (orientation:landscape){.content-wrappe-.frosted_white .content-wrapper-background img{min-height:664px;height:auto;width:100%}}@media only screen and (width:900px) and (height:768px){.content-wrappe-.frosted_white .content-wrapper-background img{min-height:664px;height:auto;width:100%}}@media only screen and (min-width:768px) and (max-width:1024px) and (orientation:portrait){.content-wrappe-.frosted_white .content-wrapper-background img{min-height:924px;position:absolute;height:100%;left:0;right:0;margin:auto!important;width:auto;min-width:100%}}@media only screen and (max-width:375px) and (min-height:737px) and (max-height:812px) and (orientation:portrait){.content-wrappe-.frosted_white .content-wrapper-background img{min-height:100vh;position:absolute;height:100%;left:0;right:0;margin:auto!important;width:auto;min-width:100%}}@media only screen and (min-width:737px) and (max-width:812px) and (max-height:375px) and (orientation:landscape){.content-wrappe-.frosted_white .content-wrapper-background img{min-height:100vh;height:auto;top:0;width:100%}.content-wrappe-.frosted_white .content-wrapper-background img.title-screen{bottom:unset;top:0}}@media only screen and (max-width:320px) and (max-height:568px) and (orientation:portrait){.content-wrappe-.frosted_white .content-wrapper-background img{min-height:100vh;position:absolute;height:100%;left:0;right:0;margin:auto!important;width:auto;min-width:100%}}@media only screen and (min-width:200px) and (max-width:900px) and (orientation:landscape){.content-wrappe-.frosted_white .content-wrapper-background{display:none}}@media only screen and (max-width:375px) and (max-height:736px) and (orientation:portrait){.content-wrappe-.frosted_white .content-wrapper-background{display:none}}@media only screen and (max-height:375px) and (max-width:736px) and (orientation:landscape){.content-wrappe-.frosted_white .content-wrapper-background{display:none}}@media only screen and (min-width:376px) and (max-width:414px) and (max-height:736px) and (orientation:portrait){.content-wrappe-.frosted_white .content-wrapper-background{display:none}}@media only screen and (min-height:376px) and (max-height:414px) and (max-width:736px) and (orientation:landscape){.content-wrappe-.frosted_white .content-wrapper-background{display:none}}@media only screen and (max-width:375px) and (min-height:737px) and (max-height:812px) and (orientation:portrait){.content-wrappe-.frosted_white .content-wrapper-background{display:none}}@media only screen and (min-width:768px) and (max-width:1024px) and (orientation:landscape){.content-wrappe-.frosted_white .content-wrapper-background{position:absolute;top:0;left:0;right:0;width:100%;height:100%;margin:auto;-webkit-clip-path:inset(0 32px 0 32px);clip-path:inset(0 32px 0 32x);-webkit-filter:blur(15px);filter:blur(15px)}}@media only screen and (min-width:768px) and (max-width:1024px) and (orientation:portrait){.content-wrappe-.frosted_white .content-wrapper-background{position:absolute;top:0;left:0;right:0;width:100%;height:100%;margin:auto;-webkit-clip-path:inset(0 24px 0 24px);clip-path:inset(0 24px 0 24px);-webkit-filter:blur(15px);filter:blur(15px)}}.content-wrappe-.frosted_white .content-wrapper-background:after{content:\"\";position:absolute;width:100%;height:100%}.content-wrappe-.frosted_white .content-wrapper-background.blurred-feed:after{background:hsla(0,0%,100%,.7)}.content-wrappe-.frosted_white .content-wrapper-background.standard-feed:after{background:hsla(0,0%,100%,.9)}.content-wrappe-.tinted_dark{background:rgba(0,0,0,.3)}.content-wrappe-.thick_glass .content-wrapper-background{z-index:1;display:block;position:absolute;top:0;left:0;right:0;width:100%;height:100%;margin:auto;-webkit-clip-path:inset(0 80px 0 80px);clip-path:inset(0 80px 0 80px);-webkit-filter:blur(15px);filter:blur(15px)}.content-wrappe-.thick_glass .content-wrapper-background img{position:absolute;bottom:0;left:0;right:0;margin:auto;width:100%;height:auto}@media only screen and (max-width:375px) and (max-height:736px) and (orientation:portrait){.content-wrappe-.thick_glass .content-wrapper-background img{min-height:100vh;position:absolute;height:100%;left:0;right:0;margin:auto!important;width:auto;min-width:100%}}@media only screen and (max-height:375px) and (max-width:736px) and (orientation:landscape){.content-wrappe-.thick_glass .content-wrapper-background img{min-height:100vh;height:auto;top:0;width:100%}.content-wrappe-.thick_glass .content-wrapper-background img.title-screen{bottom:unset;top:0}}@media only screen and (min-width:376px) and (max-width:414px) and (max-height:736px) and (orientation:portrait){.content-wrappe-.thick_glass .content-wrapper-background img{min-height:100vh;position:absolute;height:100%;left:0;right:0;margin:auto!important;width:auto;min-width:100%}}@media only screen and (min-height:376px) and (max-height:414px) and (max-width:736px) and (orientation:landscape){.content-wrappe-.thick_glass .content-wrapper-background img{min-height:100vh;height:auto;bottom:0;width:100%}.content-wrappe-.thick_glass .content-wrapper-background img.title-screen{bottom:unset;top:0}}@media only screen and (min-width:768px) and (max-width:1024px) and (orientation:landscape){.content-wrappe-.thick_glass .content-wrapper-background img{min-height:664px;height:auto;width:100%}}@media only screen and (width:900px) and (height:768px){.content-wrappe-.thick_glass .content-wrapper-background img{min-height:664px;height:auto;width:100%}}@media only screen and (min-width:768px) and (max-width:1024px) and (orientation:portrait){.content-wrappe-.thick_glass .content-wrapper-background img{min-height:924px;position:absolute;height:100%;left:0;right:0;margin:auto!important;width:auto;min-width:100%}}@media only screen and (max-width:375px) and (min-height:737px) and (max-height:812px) and (orientation:portrait){.content-wrappe-.thick_glass .content-wrapper-background img{min-height:100vh;position:absolute;height:100%;left:0;right:0;margin:auto!important;width:auto;min-width:100%}}@media only screen and (min-width:737px) and (max-width:812px) and (max-height:375px) and (orientation:landscape){.content-wrappe-.thick_glass .content-wrapper-background img{min-height:100vh;height:auto;top:0;width:100%}.content-wrappe-.thick_glass .content-wrapper-background img.title-screen{bottom:unset;top:0}}@media only screen and (max-width:320px) and (max-height:568px) and (orientation:portrait){.content-wrappe-.thick_glass .content-wrapper-background img{min-height:100vh;position:absolute;height:100%;left:0;right:0;margin:auto!important;width:auto;min-width:100%}}@media only screen and (min-width:200px) and (max-width:900px) and (orientation:landscape){.content-wrappe-.thick_glass .content-wrapper-background{display:none}}@media only screen and (max-width:375px) and (max-height:736px) and (orientation:portrait){.content-wrappe-.thick_glass .content-wrapper-background{display:none}}@media only screen and (max-height:375px) and (max-width:736px) and (orientation:landscape){.content-wrappe-.thick_glass .content-wrapper-background{display:none}}@media only screen and (min-width:376px) and (max-width:414px) and (max-height:736px) and (orientation:portrait){.content-wrappe-.thick_glass .content-wrapper-background{display:none}}@media only screen and (min-height:376px) and (max-height:414px) and (max-width:736px) and (orientation:landscape){.content-wrappe-.thick_glass .content-wrapper-background{display:none}}@media only screen and (max-width:375px) and (min-height:737px) and (max-height:812px) and (orientation:portrait){.content-wrappe-.thick_glass .content-wrapper-background{display:none}}@media only screen and (min-width:768px) and (max-width:1024px) and (orientation:landscape){.content-wrappe-.thick_glass .content-wrapper-background{position:absolute;top:0;left:0;right:0;width:100%;height:100%;margin:auto;-webkit-clip-path:inset(0 32px 0 32px);clip-path:inset(0 32px 0 32x);-webkit-filter:blur(15px);filter:blur(15px)}}@media only screen and (min-width:768px) and (max-width:1024px) and (orientation:portrait){.content-wrappe-.thick_glass .content-wrapper-background{position:absolute;top:0;left:0;right:0;width:100%;height:100%;margin:auto;-webkit-clip-path:inset(0 24px 0 24px);clip-path:inset(0 24px 0 24px);-webkit-filter:blur(15px);filter:blur(15px)}}.content-wrappe-.transparent{-webkit-box-shadow:none;-moz-box-shadow:none;box-shadow:none}", ""]);
	
	// exports


/***/ },
/* 820 */
/***/ function(module, exports, __webpack_require__) {

	(function (global, factory) {
		 true ? module.exports = factory() :
		typeof define === 'function' && define.amd ? define(factory) :
		(global.deepmerge = factory());
	}(this, (function () { 'use strict';
	
	var isMergeableObject = function isMergeableObject(value) {
		return isNonNullObject(value)
			&& !isSpecial(value)
	};
	
	function isNonNullObject(value) {
		return !!value && typeof value === 'object'
	}
	
	function isSpecial(value) {
		var stringValue = Object.prototype.toString.call(value);
	
		return stringValue === '[object RegExp]'
			|| stringValue === '[object Date]'
			|| isReactElement(value)
	}
	
	// see https://github.com/facebook/react/blob/b5ac963fb791d1298e7f396236383bc955f916c1/src/isomorphic/classic/element/ReactElement.js#L21-L25
	var canUseSymbol = typeof Symbol === 'function' && Symbol.for;
	var REACT_ELEMENT_TYPE = canUseSymbol ? Symbol.for('react.element') : 0xeac7;
	
	function isReactElement(value) {
		return value.$$typeof === REACT_ELEMENT_TYPE
	}
	
	function emptyTarget(val) {
		return Array.isArray(val) ? [] : {}
	}
	
	function cloneUnlessOtherwiseSpecified(value, options) {
		return (options.clone !== false && options.isMergeableObject(value))
			? deepmerge(emptyTarget(value), value, options)
			: value
	}
	
	function defaultArrayMerge(target, source, options) {
		return target.concat(source).map(function(element) {
			return cloneUnlessOtherwiseSpecified(element, options)
		})
	}
	
	function mergeObject(target, source, options) {
		var destination = {};
		if (options.isMergeableObject(target)) {
			Object.keys(target).forEach(function(key) {
				destination[key] = cloneUnlessOtherwiseSpecified(target[key], options);
			});
		}
		Object.keys(source).forEach(function(key) {
			if (!options.isMergeableObject(source[key]) || !target[key]) {
				destination[key] = cloneUnlessOtherwiseSpecified(source[key], options);
			} else {
				destination[key] = deepmerge(target[key], source[key], options);
			}
		});
		return destination
	}
	
	function deepmerge(target, source, options) {
		options = options || {};
		options.arrayMerge = options.arrayMerge || defaultArrayMerge;
		options.isMergeableObject = options.isMergeableObject || isMergeableObject;
	
		var sourceIsArray = Array.isArray(source);
		var targetIsArray = Array.isArray(target);
		var sourceAndTargetTypesMatch = sourceIsArray === targetIsArray;
	
		if (!sourceAndTargetTypesMatch) {
			return cloneUnlessOtherwiseSpecified(source, options)
		} else if (sourceIsArray) {
			return options.arrayMerge(target, source, options)
		} else {
			return mergeObject(target, source, options)
		}
	}
	
	deepmerge.all = function deepmergeAll(array, options) {
		if (!Array.isArray(array)) {
			throw new Error('first argument should be an array')
		}
	
		return array.reduce(function(prev, next) {
			return deepmerge(prev, next, options)
		}, {})
	};
	
	var deepmerge_1 = deepmerge;
	
	return deepmerge_1;
	
	})));


/***/ },
/* 821 */
/***/ function(module, exports) {

	"use strict";
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 */
	
	var _hyphenPattern = /-(.)/g;
	
	/**
	 * Camelcases a hyphenated string, for example:
	 *
	 *   > camelize('background-color')
	 *   < "backgroundColor"
	 *
	 * @param {string} string
	 * @return {string}
	 */
	function camelize(string) {
	  return string.replace(_hyphenPattern, function (_, character) {
	    return character.toUpperCase();
	  });
	}
	
	module.exports = camelize;

/***/ },
/* 822 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 */
	
	'use strict';
	
	var camelize = __webpack_require__(821);
	
	var msPattern = /^-ms-/;
	
	/**
	 * Camelcases a hyphenated CSS property name, for example:
	 *
	 *   > camelizeStyleName('background-color')
	 *   < "backgroundColor"
	 *   > camelizeStyleName('-moz-transition')
	 *   < "MozTransition"
	 *   > camelizeStyleName('-ms-transition')
	 *   < "msTransition"
	 *
	 * As Andi Smith suggests
	 * (http://www.andismith.com/blog/2012/02/modernizr-prefixed/), an `-ms` prefix
	 * is converted to lowercase `ms`.
	 *
	 * @param {string} string
	 * @return {string}
	 */
	function camelizeStyleName(string) {
	  return camelize(string.replace(msPattern, 'ms-'));
	}
	
	module.exports = camelizeStyleName;

/***/ },
/* 823 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	var isTextNode = __webpack_require__(831);
	
	/*eslint-disable no-bitwise */
	
	/**
	 * Checks if a given DOM node contains or is another DOM node.
	 */
	function containsNode(outerNode, innerNode) {
	  if (!outerNode || !innerNode) {
	    return false;
	  } else if (outerNode === innerNode) {
	    return true;
	  } else if (isTextNode(outerNode)) {
	    return false;
	  } else if (isTextNode(innerNode)) {
	    return containsNode(outerNode, innerNode.parentNode);
	  } else if ('contains' in outerNode) {
	    return outerNode.contains(innerNode);
	  } else if (outerNode.compareDocumentPosition) {
	    return !!(outerNode.compareDocumentPosition(innerNode) & 16);
	  } else {
	    return false;
	  }
	}
	
	module.exports = containsNode;

/***/ },
/* 824 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 */
	
	var invariant = __webpack_require__(21);
	
	/**
	 * Convert array-like objects to arrays.
	 *
	 * This API assumes the caller knows the contents of the data type. For less
	 * well defined inputs use createArrayFromMixed.
	 *
	 * @param {object|function|filelist} obj
	 * @return {array}
	 */
	function toArray(obj) {
	  var length = obj.length;
	
	  // Some browsers builtin objects can report typeof 'function' (e.g. NodeList
	  // in old versions of Safari).
	  !(!Array.isArray(obj) && (typeof obj === 'object' || typeof obj === 'function')) ?  false ? invariant(false, 'toArray: Array-like object expected') : invariant(false) : void 0;
	
	  !(typeof length === 'number') ?  false ? invariant(false, 'toArray: Object needs a length property') : invariant(false) : void 0;
	
	  !(length === 0 || length - 1 in obj) ?  false ? invariant(false, 'toArray: Object should have keys for indices') : invariant(false) : void 0;
	
	  !(typeof obj.callee !== 'function') ?  false ? invariant(false, 'toArray: Object can\'t be `arguments`. Use rest params ' + '(function(...args) {}) or Array.from() instead.') : invariant(false) : void 0;
	
	  // Old IE doesn't give collections access to hasOwnProperty. Assume inputs
	  // without method will throw during the slice call and skip straight to the
	  // fallback.
	  if (obj.hasOwnProperty) {
	    try {
	      return Array.prototype.slice.call(obj);
	    } catch (e) {
	      // IE < 9 does not support Array#slice on collections objects
	    }
	  }
	
	  // Fall back to copying key by key. This assumes all keys have a value,
	  // so will not preserve sparsely populated inputs.
	  var ret = Array(length);
	  for (var ii = 0; ii < length; ii++) {
	    ret[ii] = obj[ii];
	  }
	  return ret;
	}
	
	/**
	 * Perform a heuristic test to determine if an object is "array-like".
	 *
	 *   A monk asked Joshu, a Zen master, "Has a dog Buddha nature?"
	 *   Joshu replied: "Mu."
	 *
	 * This function determines if its argument has "array nature": it returns
	 * true if the argument is an actual array, an `arguments' object, or an
	 * HTMLCollection (e.g. node.childNodes or node.getElementsByTagName()).
	 *
	 * It will return false for other array-like objects like Filelist.
	 *
	 * @param {*} obj
	 * @return {boolean}
	 */
	function hasArrayNature(obj) {
	  return (
	    // not null/false
	    !!obj && (
	    // arrays are objects, NodeLists are functions in Safari
	    typeof obj == 'object' || typeof obj == 'function') &&
	    // quacks like an array
	    'length' in obj &&
	    // not window
	    !('setInterval' in obj) &&
	    // no DOM node should be considered an array-like
	    // a 'select' element has 'length' and 'item' properties on IE8
	    typeof obj.nodeType != 'number' && (
	    // a real array
	    Array.isArray(obj) ||
	    // arguments
	    'callee' in obj ||
	    // HTMLCollection/NodeList
	    'item' in obj)
	  );
	}
	
	/**
	 * Ensure that the argument is an array by wrapping it in an array if it is not.
	 * Creates a copy of the argument if it is already an array.
	 *
	 * This is mostly useful idiomatically:
	 *
	 *   var createArrayFromMixed = require('createArrayFromMixed');
	 *
	 *   function takesOneOrMoreThings(things) {
	 *     things = createArrayFromMixed(things);
	 *     ...
	 *   }
	 *
	 * This allows you to treat `things' as an array, but accept scalars in the API.
	 *
	 * If you need to convert an array-like object, like `arguments`, into an array
	 * use toArray instead.
	 *
	 * @param {*} obj
	 * @return {array}
	 */
	function createArrayFromMixed(obj) {
	  if (!hasArrayNature(obj)) {
	    return [obj];
	  } else if (Array.isArray(obj)) {
	    return obj.slice();
	  } else {
	    return toArray(obj);
	  }
	}
	
	module.exports = createArrayFromMixed;

/***/ },
/* 825 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 */
	
	/*eslint-disable fb-www/unsafe-html*/
	
	var ExecutionEnvironment = __webpack_require__(51);
	
	var createArrayFromMixed = __webpack_require__(824);
	var getMarkupWrap = __webpack_require__(826);
	var invariant = __webpack_require__(21);
	
	/**
	 * Dummy container used to render all markup.
	 */
	var dummyNode = ExecutionEnvironment.canUseDOM ? document.createElement('div') : null;
	
	/**
	 * Pattern used by `getNodeName`.
	 */
	var nodeNamePattern = /^\s*<(\w+)/;
	
	/**
	 * Extracts the `nodeName` of the first element in a string of markup.
	 *
	 * @param {string} markup String of markup.
	 * @return {?string} Node name of the supplied markup.
	 */
	function getNodeName(markup) {
	  var nodeNameMatch = markup.match(nodeNamePattern);
	  return nodeNameMatch && nodeNameMatch[1].toLowerCase();
	}
	
	/**
	 * Creates an array containing the nodes rendered from the supplied markup. The
	 * optionally supplied `handleScript` function will be invoked once for each
	 * <script> element that is rendered. If no `handleScript` function is supplied,
	 * an exception is thrown if any <script> elements are rendered.
	 *
	 * @param {string} markup A string of valid HTML markup.
	 * @param {?function} handleScript Invoked once for each rendered <script>.
	 * @return {array<DOMElement|DOMTextNode>} An array of rendered nodes.
	 */
	function createNodesFromMarkup(markup, handleScript) {
	  var node = dummyNode;
	  !!!dummyNode ?  false ? invariant(false, 'createNodesFromMarkup dummy not initialized') : invariant(false) : void 0;
	  var nodeName = getNodeName(markup);
	
	  var wrap = nodeName && getMarkupWrap(nodeName);
	  if (wrap) {
	    node.innerHTML = wrap[1] + markup + wrap[2];
	
	    var wrapDepth = wrap[0];
	    while (wrapDepth--) {
	      node = node.lastChild;
	    }
	  } else {
	    node.innerHTML = markup;
	  }
	
	  var scripts = node.getElementsByTagName('script');
	  if (scripts.length) {
	    !handleScript ?  false ? invariant(false, 'createNodesFromMarkup(...): Unexpected <script> element rendered.') : invariant(false) : void 0;
	    createArrayFromMixed(scripts).forEach(handleScript);
	  }
	
	  var nodes = Array.from(node.childNodes);
	  while (node.lastChild) {
	    node.removeChild(node.lastChild);
	  }
	  return nodes;
	}
	
	module.exports = createNodesFromMarkup;

/***/ },
/* 826 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	/*eslint-disable fb-www/unsafe-html */
	
	var ExecutionEnvironment = __webpack_require__(51);
	
	var invariant = __webpack_require__(21);
	
	/**
	 * Dummy container used to detect which wraps are necessary.
	 */
	var dummyNode = ExecutionEnvironment.canUseDOM ? document.createElement('div') : null;
	
	/**
	 * Some browsers cannot use `innerHTML` to render certain elements standalone,
	 * so we wrap them, render the wrapped nodes, then extract the desired node.
	 *
	 * In IE8, certain elements cannot render alone, so wrap all elements ('*').
	 */
	
	var shouldWrap = {};
	
	var selectWrap = [1, '<select multiple="true">', '</select>'];
	var tableWrap = [1, '<table>', '</table>'];
	var trWrap = [3, '<table><tbody><tr>', '</tr></tbody></table>'];
	
	var svgWrap = [1, '<svg xmlns="http://www.w3.org/2000/svg">', '</svg>'];
	
	var markupWrap = {
	  '*': [1, '?<div>', '</div>'],
	
	  'area': [1, '<map>', '</map>'],
	  'col': [2, '<table><tbody></tbody><colgroup>', '</colgroup></table>'],
	  'legend': [1, '<fieldset>', '</fieldset>'],
	  'param': [1, '<object>', '</object>'],
	  'tr': [2, '<table><tbody>', '</tbody></table>'],
	
	  'optgroup': selectWrap,
	  'option': selectWrap,
	
	  'caption': tableWrap,
	  'colgroup': tableWrap,
	  'tbody': tableWrap,
	  'tfoot': tableWrap,
	  'thead': tableWrap,
	
	  'td': trWrap,
	  'th': trWrap
	};
	
	// Initialize the SVG elements since we know they'll always need to be wrapped
	// consistently. If they are created inside a <div> they will be initialized in
	// the wrong namespace (and will not display).
	var svgElements = ['circle', 'clipPath', 'defs', 'ellipse', 'g', 'image', 'line', 'linearGradient', 'mask', 'path', 'pattern', 'polygon', 'polyline', 'radialGradient', 'rect', 'stop', 'text', 'tspan'];
	svgElements.forEach(function (nodeName) {
	  markupWrap[nodeName] = svgWrap;
	  shouldWrap[nodeName] = true;
	});
	
	/**
	 * Gets the markup wrap configuration for the supplied `nodeName`.
	 *
	 * NOTE: This lazily detects which wraps are necessary for the current browser.
	 *
	 * @param {string} nodeName Lowercase `nodeName`.
	 * @return {?array} Markup wrap configuration, if applicable.
	 */
	function getMarkupWrap(nodeName) {
	  !!!dummyNode ?  false ? invariant(false, 'Markup wrapping node not initialized') : invariant(false) : void 0;
	  if (!markupWrap.hasOwnProperty(nodeName)) {
	    nodeName = '*';
	  }
	  if (!shouldWrap.hasOwnProperty(nodeName)) {
	    if (nodeName === '*') {
	      dummyNode.innerHTML = '<link />';
	    } else {
	      dummyNode.innerHTML = '<' + nodeName + '></' + nodeName + '>';
	    }
	    shouldWrap[nodeName] = !dummyNode.firstChild;
	  }
	  return shouldWrap[nodeName] ? markupWrap[nodeName] : null;
	}
	
	module.exports = getMarkupWrap;

/***/ },
/* 827 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 */
	
	'use strict';
	
	/**
	 * Gets the scroll position of the supplied element or window.
	 *
	 * The return values are unbounded, unlike `getScrollPosition`. This means they
	 * may be negative or exceed the element boundaries (which is possible using
	 * inertial scrolling).
	 *
	 * @param {DOMWindow|DOMElement} scrollable
	 * @return {object} Map with `x` and `y` keys.
	 */
	
	function getUnboundedScrollPosition(scrollable) {
	  if (scrollable.Window && scrollable instanceof scrollable.Window) {
	    return {
	      x: scrollable.pageXOffset || scrollable.document.documentElement.scrollLeft,
	      y: scrollable.pageYOffset || scrollable.document.documentElement.scrollTop
	    };
	  }
	  return {
	    x: scrollable.scrollLeft,
	    y: scrollable.scrollTop
	  };
	}
	
	module.exports = getUnboundedScrollPosition;

/***/ },
/* 828 */
/***/ function(module, exports) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 */
	
	var _uppercasePattern = /([A-Z])/g;
	
	/**
	 * Hyphenates a camelcased string, for example:
	 *
	 *   > hyphenate('backgroundColor')
	 *   < "background-color"
	 *
	 * For CSS style names, use `hyphenateStyleName` instead which works properly
	 * with all vendor prefixes, including `ms`.
	 *
	 * @param {string} string
	 * @return {string}
	 */
	function hyphenate(string) {
	  return string.replace(_uppercasePattern, '-$1').toLowerCase();
	}
	
	module.exports = hyphenate;

/***/ },
/* 829 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 */
	
	'use strict';
	
	var hyphenate = __webpack_require__(828);
	
	var msPattern = /^ms-/;
	
	/**
	 * Hyphenates a camelcased CSS property name, for example:
	 *
	 *   > hyphenateStyleName('backgroundColor')
	 *   < "background-color"
	 *   > hyphenateStyleName('MozTransition')
	 *   < "-moz-transition"
	 *   > hyphenateStyleName('msTransition')
	 *   < "-ms-transition"
	 *
	 * As Modernizr suggests (http://modernizr.com/docs/#prefixed), an `ms` prefix
	 * is converted to `-ms-`.
	 *
	 * @param {string} string
	 * @return {string}
	 */
	function hyphenateStyleName(string) {
	  return hyphenate(string).replace(msPattern, '-ms-');
	}
	
	module.exports = hyphenateStyleName;

/***/ },
/* 830 */
/***/ function(module, exports) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 */
	
	/**
	 * @param {*} object The object to check.
	 * @return {boolean} Whether or not the object is a DOM node.
	 */
	function isNode(object) {
	  var doc = object ? object.ownerDocument || object : document;
	  var defaultView = doc.defaultView || window;
	  return !!(object && (typeof defaultView.Node === 'function' ? object instanceof defaultView.Node : typeof object === 'object' && typeof object.nodeType === 'number' && typeof object.nodeName === 'string'));
	}
	
	module.exports = isNode;

/***/ },
/* 831 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 */
	
	var isNode = __webpack_require__(830);
	
	/**
	 * @param {*} object The object to check.
	 * @return {boolean} Whether or not the object is a DOM text node.
	 */
	function isTextNode(object) {
	  return isNode(object) && object.nodeType == 3;
	}
	
	module.exports = isTextNode;

/***/ },
/* 832 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 * @typechecks static-only
	 */
	
	'use strict';
	
	/**
	 * Memoizes the return value of a function that accepts one string argument.
	 */
	
	function memoizeStringOnly(callback) {
	  var cache = {};
	  return function (string) {
	    if (!cache.hasOwnProperty(string)) {
	      cache[string] = callback.call(this, string);
	    }
	    return cache[string];
	  };
	}
	
	module.exports = memoizeStringOnly;

/***/ },
/* 833 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "json/data.json";

/***/ },
/* 834 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var isCallable = __webpack_require__(844);
	
	var toStr = Object.prototype.toString;
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	
	var forEachArray = function forEachArray(array, iterator, receiver) {
	    for (var i = 0, len = array.length; i < len; i++) {
	        if (hasOwnProperty.call(array, i)) {
	            if (receiver == null) {
	                iterator(array[i], i, array);
	            } else {
	                iterator.call(receiver, array[i], i, array);
	            }
	        }
	    }
	};
	
	var forEachString = function forEachString(string, iterator, receiver) {
	    for (var i = 0, len = string.length; i < len; i++) {
	        // no such thing as a sparse string.
	        if (receiver == null) {
	            iterator(string.charAt(i), i, string);
	        } else {
	            iterator.call(receiver, string.charAt(i), i, string);
	        }
	    }
	};
	
	var forEachObject = function forEachObject(object, iterator, receiver) {
	    for (var k in object) {
	        if (hasOwnProperty.call(object, k)) {
	            if (receiver == null) {
	                iterator(object[k], k, object);
	            } else {
	                iterator.call(receiver, object[k], k, object);
	            }
	        }
	    }
	};
	
	var forEach = function forEach(list, iterator, thisArg) {
	    if (!isCallable(iterator)) {
	        throw new TypeError('iterator must be a function');
	    }
	
	    var receiver;
	    if (arguments.length >= 3) {
	        receiver = thisArg;
	    }
	
	    if (toStr.call(list) === '[object Array]') {
	        forEachArray(list, iterator, receiver);
	    } else if (typeof list === 'string') {
	        forEachString(list, iterator, receiver);
	    } else {
	        forEachObject(list, iterator, receiver);
	    }
	};
	
	module.exports = forEach;


/***/ },
/* 835 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {var topLevel = typeof global !== 'undefined' ? global :
	    typeof window !== 'undefined' ? window : {}
	var minDoc = __webpack_require__(1132);
	
	var doccy;
	
	if (typeof document !== 'undefined') {
	    doccy = document;
	} else {
	    doccy = topLevel['__GLOBAL_DOCUMENT_CACHE@4'];
	
	    if (!doccy) {
	        doccy = topLevel['__GLOBAL_DOCUMENT_CACHE@4'] = minDoc;
	    }
	}
	
	module.exports = doccy;
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 836 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(global) {/*!
	 * VERSION: 0.16.3
	 * DATE: 2018-05-04
	 * UPDATES AND DOCS AT: http://greensock.com
	 *
	 * Requires TweenLite and CSSPlugin version 1.17.0 or later (TweenMax contains both TweenLite and CSSPlugin). ThrowPropsPlugin is required for momentum-based continuation of movement after the mouse/touch is released (ThrowPropsPlugin is a membership benefit of Club GreenSock - http://greensock.com/club/).
	 *
	 * @license Copyright (c) 2008-2018, GreenSock. All rights reserved.
	 * This work is subject to the terms at http://greensock.com/standard-license or for
	 * Club GreenSock members, the software agreement that was issued with your membership.
	 *
	 * @author: Jack Doyle, jack@greensock.com
	 */
	var _gsScope = (typeof(module) !== "undefined" && module.exports && typeof(global) !== "undefined") ? global : this || window; //helps ensure compatibility with AMD/RequireJS and CommonJS/Node
	(_gsScope._gsQueue || (_gsScope._gsQueue = [])).push( function() {
	
		"use strict";
	
		_gsScope._gsDefine("utils.Draggable", ["events.EventDispatcher","TweenLite","plugins.CSSPlugin"], function(EventDispatcher, TweenLite, CSSPlugin) {
	
			var _tempVarsXY = {css:{}, data:"_draggable"}, //speed optimization - we reuse the same vars object for x/y TweenLite.set() calls to minimize garbage collection tasks and improve performance.
				_tempVarsX = {css:{}, data:"_draggable"},
				_tempVarsY = {css:{}, data:"_draggable"},
				_tempVarsRotation = {css:{}},
				_globals = _gsScope._gsDefine.globals,
				_tempEvent = {}, //for populating with pageX/pageY in old versions of IE
				_dummyElement = {style:{}},
				_doc = _gsScope.document || {createElement: function() {return _dummyElement;}},
				_docElement = _doc.documentElement || {},
				_createElement = function(type) {
					return _doc.createElementNS ? _doc.createElementNS("http://www.w3.org/1999/xhtml", type) : _doc.createElement(type);
				},
				_tempDiv = _createElement("div"),
				_emptyArray = [],
				_emptyFunc = function() { return false; },
				_RAD2DEG = 180 / Math.PI,
				_max = 999999999999999,
				_getTime = Date.now || function() {return new Date().getTime();},
				_isOldIE = !!(!_doc.addEventListener && _doc.all),
				_placeholderDiv = _doc.createElement("div"),
				_renderQueue = [],
				_lookup = {}, //when a Draggable is created, the target gets a unique _gsDragID property that allows gets associated with the Draggable instance for quick lookups in Draggable.get(). This avoids circular references that could cause gc problems.
				_lookupCount = 0,
				_clickableTagExp = /^(?:a|input|textarea|button|select)$/i,
				_dragCount = 0, //total number of elements currently being dragged
				_prefix,
				_isMultiTouching,
				_isAndroid = (_gsScope.navigator && _gsScope.navigator.userAgent.toLowerCase().indexOf("android") !== -1), //Android handles touch events in an odd way and it's virtually impossible to "feature test" so we resort to UA sniffing
				_lastDragTime = 0,
				_temp1 = {}, // a simple object we reuse and populate (usually x/y properties) to conserve memory and improve performance.
				_windowProxy = {}, //memory/performance optimization - we reuse this object during autoScroll to store window-related bounds/offsets.
				_slice = function(a) { //don't use Array.prototype.slice.call(target, 0) because that doesn't work in IE8 with a NodeList that's returned by querySelectorAll()
					if (typeof(a) === "string") {
						a = TweenLite.selector(a);
					}
					if (!a || a.nodeType) { //if it's not an array, wrap it in one.
						return [a];
					}
					var b = [],
						l = a.length,
						i;
					for (i = 0; i !== l; b.push(a[i++]));
					return b;
				},
				_copy = function(obj, factor) {
					var copy = {}, p;
					if (factor) {
						for (p in obj) {
							copy[p] = obj[p] * factor;
						}
					} else {
						for (p in obj) {
							copy[p] = obj[p];
						}
					}
					return copy;
				},
				ThrowPropsPlugin,
	
				_renderQueueTick = function() {
					var i = _renderQueue.length;
					while (--i > -1) {
						_renderQueue[i]();
					}
				},
				_addToRenderQueue = function(func) {
					_renderQueue.push(func);
					if (_renderQueue.length === 1) {
						TweenLite.ticker.addEventListener("tick", _renderQueueTick, this, false, 1);
					}
				},
				_removeFromRenderQueue = function(func) {
					var i = _renderQueue.length;
					while (--i > -1) {
						if (_renderQueue[i] === func) {
							_renderQueue.splice(i, 1);
						}
					}
					TweenLite.to(_renderQueueTimeout, 0, {overwrite:"all", delay:15, onComplete:_renderQueueTimeout, data:"_draggable"}); //remove the "tick" listener only after the render queue is empty for 15 seconds (to improve performance). Adding/removing it constantly for every click/touch wouldn't deliver optimal speed, and we also don't want the ticker to keep calling the render method when things are idle for long periods of time (we want to improve battery life on mobile devices).
				},
				_renderQueueTimeout = function() {
					if (!_renderQueue.length) {
						TweenLite.ticker.removeEventListener("tick", _renderQueueTick);
					}
				},
	
				_extend = function(obj, defaults) {
					var p;
					for (p in defaults) {
						if (obj[p] === undefined) {
							obj[p] = defaults[p];
						}
					}
					return obj;
				},
				_getDocScrollTop = function() {
					return (window.pageYOffset != null) ? window.pageYOffset : (_doc.scrollTop != null) ? _doc.scrollTop : _docElement.scrollTop || _doc.body.scrollTop || 0;
				},
				_getDocScrollLeft = function() {
					return (window.pageXOffset != null) ? window.pageXOffset : (_doc.scrollLeft != null) ? _doc.scrollLeft : _docElement.scrollLeft || _doc.body.scrollLeft || 0;
				},
				_addScrollListener = function(e, callback) {
					_addListener(e, "scroll", callback);
					if (!_isRoot(e.parentNode)) {
						_addScrollListener(e.parentNode, callback);
					}
				},
				_removeScrollListener = function(e, callback) {
					_removeListener(e, "scroll", callback);
					if (!_isRoot(e.parentNode)) {
						_removeScrollListener(e.parentNode, callback);
					}
				},
				_isRoot = function (e) {
					return !!(!e || e === _docElement || e === _doc || e === _doc.body || e === window || !e.nodeType || !e.parentNode);
				},
				_getMaxScroll = function(element, axis) {
					var dim = (axis === "x") ? "Width" : "Height",
						scroll = "scroll" + dim,
						client = "client" + dim,
						body = _doc.body;
					return Math.max(0, _isRoot(element) ? Math.max(_docElement[scroll], body[scroll]) - (window["inner" + dim] || _docElement[client] || body[client]) : element[scroll] - element[client]);
				},
				_recordMaxScrolls = function(e) { //records _gsMaxScrollX and _gsMaxScrollY properties for the element and all ancestors up the chain so that we can cap it, otherwise dragging beyond the edges with autoScroll on can endlessly scroll.
					var isRoot = _isRoot(e),
						x = _getMaxScroll(e, "x"),
						y = _getMaxScroll(e, "y");
					if (isRoot) {
						e = _windowProxy;
					} else {
						_recordMaxScrolls(e.parentNode);
					}
					e._gsMaxScrollX = x;
					e._gsMaxScrollY = y;
					e._gsScrollX = e.scrollLeft || 0;
					e._gsScrollY = e.scrollTop || 0;
				},
	
				//just used for IE8 and earlier to normalize events and populate pageX/pageY
				_populateIEEvent = function(e, preventDefault) {
					e = e || window.event;
					_tempEvent.pageX = e.clientX + _doc.body.scrollLeft + _docElement.scrollLeft;
					_tempEvent.pageY = e.clientY + _doc.body.scrollTop + _docElement.scrollTop;
					if (preventDefault) {
						e.returnValue = false;
					}
					return _tempEvent;
				},
	
				//grabs the first element it finds (and we include the window as an element), so if it's selector text, it'll feed that value to TweenLite.selector, if it's a jQuery object or some other selector engine's result, it'll grab the first one, and same for an array. If the value doesn't contain a DOM element, it'll just return null.
				_unwrapElement = function(value) {
					if (!value) {
						return value;
					}
					if (typeof(value) === "string") {
						value = TweenLite.selector(value);
					}
					if (value.length && value !== window && value[0] && value[0].style && !value.nodeType) {
						value = value[0];
					}
					return (value === window || (value.nodeType && value.style)) ? value : null;
				},
	
				_checkPrefix = function(e, p) {
					var s = e.style,
						capped, i, a;
					if (s[p] === undefined) {
						a = ["O","Moz","ms","Ms","Webkit"];
						i = 5;
						capped = p.charAt(0).toUpperCase() + p.substr(1);
						while (--i > -1 && s[a[i]+capped] === undefined) { }
						if (i < 0) {
							return "";
						}
						_prefix = (i === 3) ? "ms" : a[i];
						p = _prefix + capped;
					}
					return p;
				},
	
				_setStyle = function(e, p, value) {
					var s = e.style;
					if (!s) {
						return;
					}
					if (s[p] === undefined) {
						p = _checkPrefix(e, p);
					}
					if (value == null) {
						if (s.removeProperty) {
							s.removeProperty(p.replace(/([A-Z])/g, "-$1").toLowerCase());
						} else { //note: old versions of IE use "removeAttribute()" instead of "removeProperty()"
							s.removeAttribute(p);
						}
					} else if (s[p] !== undefined) {
						s[p] = value;
					}
				},
	
				_getComputedStyle = _doc.defaultView ? _doc.defaultView.getComputedStyle : _emptyFunc,
				_horizExp = /(?:Left|Right|Width)/i,
				_suffixExp = /(?:\d|\-|\+|=|#|\.)*/g,
				_convertToPixels = function(t, p, v, sfx, recurse) {
					if (sfx === "px" || !sfx) { return v; }
					if (sfx === "auto" || !v) { return 0; }
					var horiz = _horizExp.test(p),
						node = t,
						style = _tempDiv.style,
						neg = (v < 0),
						pix;
					if (neg) {
						v = -v;
					}
					if (sfx === "%" && p.indexOf("border") !== -1) {
						pix = (v / 100) * (horiz ? t.clientWidth : t.clientHeight);
					} else {
						style.cssText = "border:0 solid red;position:" + _getStyle(t, "position", true) + ";line-height:0;";
						if (sfx === "%" || !node.appendChild) {
							node = t.parentNode || _doc.body;
							style[(horiz ? "width" : "height")] = v + sfx;
						} else {
							style[(horiz ? "borderLeftWidth" : "borderTopWidth")] = v + sfx;
						}
						node.appendChild(_tempDiv);
						pix = parseFloat(_tempDiv[(horiz ? "offsetWidth" : "offsetHeight")]);
						node.removeChild(_tempDiv);
						if (pix === 0 && !recurse) {
							pix = _convertToPixels(t, p, v, sfx, true);
						}
					}
					return neg ? -pix : pix;
				},
				_calculateOffset = function(t, p) { //for figuring out "top" or "left" in px when it's "auto". We need to factor in margin with the offsetLeft/offsetTop
					if (_getStyle(t, "position", true) !== "absolute") { return 0; }
					var dim = ((p === "left") ? "Left" : "Top"),
						v = _getStyle(t, "margin" + dim, true);
					return t["offset" + dim] - (_convertToPixels(t, p, parseFloat(v), (v + "").replace(_suffixExp, "")) || 0);
				},
	
				_getStyle = function(element, prop, keepUnits) {
					var rv = (element._gsTransform || {})[prop],
						cs;
					if (rv || rv === 0) {
						return rv;
					} else if (element.style[prop]) {
						rv = element.style[prop];
					} else if ((cs = _getComputedStyle(element))) {
						rv = cs.getPropertyValue(prop.replace(/([A-Z])/g, "-$1").toLowerCase());
						rv = (rv || cs.length) ? rv : cs[prop]; //Opera behaves VERY strangely - length is usually 0 and cs[prop] is the only way to get accurate results EXCEPT when checking for -o-transform which only works with cs.getPropertyValue()!
					} else if (element.currentStyle) {
						rv = element.currentStyle[prop];
					}
					if (rv === "auto" && (prop === "top" || prop === "left")) {
						rv = _calculateOffset(element, prop);
					}
					return keepUnits ? rv : parseFloat(rv) || 0;
				},
	
				_dispatchEvent = function(instance, type, callbackName) {
					var vars = instance.vars,
						callback = vars[callbackName],
						listeners = instance._listeners[type];
					if (typeof(callback) === "function") {
						callback.apply(vars[callbackName + "Scope"] || vars.callbackScope || instance, vars[callbackName + "Params"] || [instance.pointerEvent]);
					}
					if (listeners) {
						instance.dispatchEvent(type);
					}
				},
				_getBounds = function(obj, context) { //accepts any of the following: a DOM element, jQuery object, selector text, or an object defining bounds as {top, left, width, height} or {minX, maxX, minY, maxY}. Returns an object with left, top, width, and height properties.
					var e = _unwrapElement(obj),
						top, left, offset;
					if (!e) {
						if (obj.left !== undefined) {
							offset = _getOffsetTransformOrigin(context); //the bounds should be relative to the origin
							return {left: obj.left - offset.x, top: obj.top - offset.y, width: obj.width, height: obj.height};
						}
						left = obj.min || obj.minX || obj.minRotation || 0;
						top = obj.min || obj.minY || 0;
						return {left:left, top:top, width:(obj.max || obj.maxX || obj.maxRotation || 0) - left, height:(obj.max || obj.maxY || 0) - top};
					}
					return _getElementBounds(e, context);
				},
	
				_svgBorderFactor,
				_svgBorderScales,
				_svgScrollOffset,
				_hasBorderBug,
				_hasReparentBug,//some browsers, like Chrome 49, alter the offsetTop/offsetLeft/offsetParent of elements when a non-identity transform is applied.
				_setEnvironmentVariables = function() { //some browsers factor the border into the SVG coordinate space, some don't (like Firefox). Some apply transforms to them, some don't. We feature-detect here so we know how to handle the border(s). We can't do this immediately - we must wait for the document.body to exist.
					if (!_doc.createElementNS) {
						_svgBorderFactor = 0;
						_svgBorderScales = false;
						return;
					}
					var div = _createElement("div"),
						svg = _doc.createElementNS("http://www.w3.org/2000/svg", "svg"),
						wrapper = _createElement("div"),
						style = div.style,
						parent = _doc.body || _docElement,
						isFlex = (_getStyle(parent, "display", true) === "flex"), //Firefox bug causes getScreenCTM() to return null when parent is display:flex and the element isn't rendered inside the window (like if it's below the scroll position)
						matrix, e1, point, oldValue;
					if (_doc.body && _transformProp) {
						style.position = "absolute";
						parent.appendChild(wrapper);
						wrapper.appendChild(div);
						oldValue = div.offsetParent;
						wrapper.style[_transformProp] = "rotate(1deg)";
						_hasReparentBug = (div.offsetParent === oldValue);
						wrapper.style.position = "absolute";
						style.height = "10px";
						oldValue = div.offsetTop;
						wrapper.style.border = "5px solid red";
						_hasBorderBug = (oldValue !== div.offsetTop); //some browsers, like Firefox 38, cause the offsetTop/Left to be affected by a parent's border.
						parent.removeChild(wrapper);
					}
					style = svg.style;
					svg.setAttributeNS(null, "width", "400px");
					svg.setAttributeNS(null, "height", "400px");
					svg.setAttributeNS(null, "viewBox", "0 0 400 400");
					style.display = "block";
					style.boxSizing = "border-box";
					style.border = "0px solid red";
					style.transform = "none";
					// in some browsers (like certain flavors of Android), the getScreenCTM() matrix is contaminated by the scroll position. We can run some logic here to detect that condition, but we ended up not needing this because we found another workaround using getBoundingClientRect().
					div.style.cssText = "width:100px;height:100px;overflow:scroll;-ms-overflow-style:none;";
					parent.appendChild(div);
					div.appendChild(svg);
					point = svg.createSVGPoint().matrixTransform(svg.getScreenCTM());
					e1 = point.y;
					div.scrollTop = 100;
					point.x = point.y = 0;
					point = point.matrixTransform(svg.getScreenCTM());
					_svgScrollOffset = (e1 - point.y < 100.1) ? 0 : e1 - point.y - 150;
					div.removeChild(svg);
					parent.removeChild(div);
					// -- end _svgScrollOffset calculation.
					parent.appendChild(svg);
					if (isFlex) {
						parent.style.display = "block"; //Firefox bug causes getScreenCTM() to return null when parent is display:flex and the element isn't rendered inside the window (like if it's below the scroll position)
					}
					matrix = svg.getScreenCTM();
					e1 = matrix.e;
					style.border = "50px solid red";
					matrix = svg.getScreenCTM();
					if (e1 === 0 && matrix.e === 0 && matrix.f === 0 && matrix.a === 1) { //Opera has a bunch of bugs - it doesn't adjust the x/y of the matrix, nor does it scale when box-sizing is border-box but it does so elsewhere; to get the correct behavior we set _svgBorderScales to true.
						_svgBorderFactor = 1;
						_svgBorderScales = true;
					} else {
						_svgBorderFactor = (e1 !== matrix.e) ? 1 : 0;
						_svgBorderScales = (matrix.a !== 1);
					}
					if (isFlex) {
						parent.style.display = "flex";
					}
					parent.removeChild(svg);
				},
	
				_supports3D = (_checkPrefix(_tempDiv, "perspective") !== ""),
	
				// start matrix and point conversion methods...
				_transformOriginProp = _checkPrefix(_tempDiv, "transformOrigin").replace(/^ms/g, "Ms").replace(/([A-Z])/g, "-$1").toLowerCase(),
				_transformProp = _checkPrefix(_tempDiv, "transform"),
				_transformPropCSS = _transformProp.replace(/^ms/g, "Ms").replace(/([A-Z])/g, "-$1").toLowerCase(),
				_point1 = {}, //we reuse _point1 and _point2 objects inside matrix and point conversion methods to conserve memory and minimize garbage collection tasks.
				_point2 = {},
				_SVGElement = _gsScope.SVGElement,
				_isSVG = function(e) {
					return !!(_SVGElement && typeof(e.getBBox) === "function" && e.getCTM && (!e.parentNode || (e.parentNode.getBBox && e.parentNode.getCTM)));
				},
				_isIE10orBelow = (((/MSIE ([0-9]{1,}[\.0-9]{0,})/).exec(navigator.userAgent) || (/Trident\/.*rv:([0-9]{1,}[\.0-9]{0,})/).exec(navigator.userAgent)) && parseFloat( RegExp.$1 ) < 11), //Ideally we'd avoid user agent sniffing, but there doesn't seem to be a way to feature-detect and sense a border-related bug that only affects IE10 and IE9.
				_tempTransforms = [],
				_tempElements = [],
				_getSVGOffsets = function(e) { //SVG elements don't always report offsetTop/offsetLeft/offsetParent at all (I'm looking at you, Firefox 29 and Android), so we have to do some work to manufacture those values. You can pass any SVG element and it'll spit back an object with offsetTop, offsetLeft, offsetParent, scaleX, and scaleY properties. We need the scaleX and scaleY to handle the way SVG can resize itself based on the container.
					if (!e.getBoundingClientRect || !e.parentNode || !_transformProp) {
						return {offsetTop:0, offsetLeft:0, scaleX:1, scaleY:1, offsetParent:_docElement};
					}
					if (Draggable.cacheSVGData !== false && e._dCache && e._dCache.lastUpdate === TweenLite.ticker.frame) { //performance optimization. Assume that if the offsets are requested again on the same tick, we can just feed back the values we already calculated (no need to keep recalculating until another tick elapses).
						return e._dCache;
					}
					var curElement = e,
						cache = _cache(e),
						eRect, parentRect, offsetParent, cs, m, i, point1, point2, borderWidth, borderHeight, width, height;
					cache.lastUpdate = TweenLite.ticker.frame;
					if (e.getBBox && !cache.isSVGRoot) { //if it's a nested/child SVG element, we must find the parent SVG canvas and measure the offset from there.
						curElement = e.parentNode;
						eRect = e.getBBox();
						while (curElement && (curElement.nodeName + "").toLowerCase() !== "svg") {
							curElement = curElement.parentNode;
						}
						cs = _getSVGOffsets(curElement);
						cache.offsetTop = eRect.y * cs.scaleY;
						cache.offsetLeft = eRect.x * cs.scaleX;
						cache.scaleX = cs.scaleX;
						cache.scaleY = cs.scaleY;
						cache.offsetParent = curElement || _docElement;
						return cache;
					}
					//only root SVG elements continue here...
					offsetParent = cache.offsetParent;
					if (offsetParent === _doc.body) {
						offsetParent = _docElement; //avoids problems with margins/padding on the body
					}
					//walk up the ancestors and record any non-identity transforms (and reset them to "none") until we reach the offsetParent. We must do this so that the getBoundingClientRect() is accurate for measuring the offsetTop/offsetLeft. We'll revert the values later...
					_tempElements.length = _tempTransforms.length = 0;
					while (curElement) {
						m = _getStyle(curElement, _transformProp, true);
						if (m !== "matrix(1, 0, 0, 1, 0, 0)" && m !== "none" && m !== "translate3d(0px, 0px, 0px)") {
							_tempElements.push(curElement);
							_tempTransforms.push(curElement.style[_transformProp]);
							curElement.style[_transformProp] = "none";
						}
						if (curElement === offsetParent) {
							break;
						}
						curElement = curElement.parentNode;
					}
					parentRect = offsetParent.getBoundingClientRect();
					m = e.getScreenCTM();
	
					point2 = e.createSVGPoint();
					point1 = point2.matrixTransform(m);
					cache.scaleX = Math.sqrt(m.a * m.a + m.b * m.b);
					cache.scaleY = Math.sqrt(m.d * m.d + m.c * m.c);
					if (_svgBorderFactor === undefined) {
						_setEnvironmentVariables();
					}
					if (cache.borderBox && !_svgBorderScales && e.getAttribute("width")) { //some browsers (like Safari) don't properly scale the matrix to accommodate the border when box-sizing is border-box, so we must calculate it here...
						cs = _getComputedStyle(e) || {};
						borderWidth = (parseFloat(cs.borderLeftWidth) + parseFloat(cs.borderRightWidth)) || 0;
						borderHeight = (parseFloat(cs.borderTopWidth) + parseFloat(cs.borderBottomWidth)) || 0;
						width = parseFloat(cs.width) || 0;
						height = parseFloat(cs.height) || 0;
						cache.scaleX *= (width - borderWidth) / width;
						cache.scaleY *= (height - borderHeight) / height;
					}
					if (_svgScrollOffset) { //some browsers (like Chrome for Android) have bugs in the way getScreenCTM() is reported (it doesn't factor in scroll position), so we must revert to a more expensive technique for calculating offsetTop/Left.
						eRect = e.getBoundingClientRect();
						cache.offsetLeft = eRect.left - parentRect.left;
						cache.offsetTop = eRect.top - parentRect.top;
					} else {
						cache.offsetLeft = point1.x - parentRect.left;
						cache.offsetTop = point1.y - parentRect.top;
					}
					cache.offsetParent = offsetParent;
					i = _tempElements.length;
					while (--i > -1) {
						_tempElements[i].style[_transformProp] = _tempTransforms[i];
					}
					return cache;
				},
				_getOffsetTransformOrigin = function(e, decoratee) { //returns the x/y position of the transformOrigin of the element, in its own local coordinate system (pixels), offset from the top left corner.
					decoratee = decoratee || {};
					if (!e || e === _docElement || !e.parentNode || e === window) {
						return {x:0, y:0};
					}
					var cs = _getComputedStyle(e),
						v = (_transformOriginProp && cs) ? cs.getPropertyValue(_transformOriginProp) : "50% 50%",
						a = v.split(" "),
						x = (v.indexOf("left") !== -1) ? "0%" : (v.indexOf("right") !== -1) ? "100%" : a[0],
						y = (v.indexOf("top") !== -1) ? "0%" : (v.indexOf("bottom") !== -1) ? "100%" : a[1];
					if (y === "center" || y == null) {
						y = "50%";
					}
					if (x === "center" || isNaN(parseFloat(x))) { //remember, the user could flip-flop the values and say "bottom center" or "center bottom", etc. "center" is ambiguous because it could be used to describe horizontal or vertical, hence the isNaN(). If there's an "=" sign in the value, it's relative.
						x = "50%";
					}
					if (e.getBBox && _isSVG(e)) { //SVG elements must be handled in a special way because their origins are calculated from the top left.
						if (!e._gsTransform) {
							TweenLite.set(e, {x:"+=0", overwrite:false}); //forces creation of the _gsTransform where we store all the transform components including xOrigin and yOrigin for SVG elements, as of GSAP 1.15.0 which also takes care of calculating the origin from the upper left corner of the SVG canvas.
							if (e._gsTransform.xOrigin === undefined) {
								console.log("Draggable requires at least GSAP 1.17.0");
							}
						}
						v = e.getBBox();
						decoratee.x = (e._gsTransform.xOrigin - v.x);
						decoratee.y = (e._gsTransform.yOrigin - v.y);
					} else {
						if (e.getBBox && (x + y).indexOf("%") !== -1) { //Firefox doesn't report offsetWidth/height on <svg> elements.
							e = e.getBBox();
							e = {offsetWidth: e.width, offsetHeight: e.height};
						}
						decoratee.x = ((x.indexOf("%") !== -1) ? e.offsetWidth * parseFloat(x) / 100 : parseFloat(x));
						decoratee.y = ((y.indexOf("%") !== -1) ? e.offsetHeight * parseFloat(y) / 100 : parseFloat(y));
					}
					return decoratee;
				},
				_cache = function(e) { //computes some important values and stores them in a _dCache object attached to the element itself so that we can optimize performance
					if (Draggable.cacheSVGData !== false && e._dCache && e._dCache.lastUpdate === TweenLite.ticker.frame) { //performance optimization. Assume that if the offsets are requested again on the same tick, we can just feed back the values we already calculated (no need to keep recalculating until another tick elapses).
						return e._dCache;
					}
					var cache = e._dCache = e._dCache || {},
						cs = _getComputedStyle(e),
						isSVG = (e.getBBox && _isSVG(e)),
						isSVGRoot = ((e.nodeName + "").toLowerCase() === "svg"),
						curSVG;
					cache.isSVG = isSVG;
					cache.isSVGRoot = isSVGRoot;
					cache.borderBox = (cs.boxSizing === "border-box");
					cache.computedStyle = cs;
					if (isSVGRoot) { //some browsers don't report parentNode on SVG elements.
						curSVG = e.parentNode || _docElement;
						curSVG.insertBefore(_tempDiv, e);
						cache.offsetParent = _tempDiv.offsetParent || _docElement; //in some cases, Firefox still reports offsetParent as null.
						curSVG.removeChild(_tempDiv);
					} else if (isSVG) {
						curSVG = e.parentNode;
						while (curSVG && (curSVG.nodeName + "").toLowerCase() !== "svg") { //offsetParent is always the SVG canvas for SVG elements.
							curSVG = curSVG.parentNode;
						}
						cache.offsetParent = curSVG;
					} else {
						cache.offsetParent = e.offsetParent;
					}
					return cache;
				},
				_getOffset2DMatrix = function(e, offsetOrigin, parentOffsetOrigin, zeroOrigin, isBase) {  //"isBase" helps us discern context - it should only be true when the element is the base one (the one at which we're starting to walk up the chain). It only matters in cases when it's an <svg> element itself because that's a case when we don't apply scaling.
					if (e === window || !e || !e.style || !e.parentNode) {
						return [1,0,0,1,0,0];
					}
					var cache = e._dCache || _cache(e),
						parent = e.parentNode,
						parentCache = parent._dCache || _cache(parent),
						cs = cache.computedStyle,
						parentOffsetParent = cache.isSVG ? parentCache.offsetParent : parent.offsetParent,
						m, isRoot, offsets, rect, t, sx, sy, offsetX, offsetY, parentRect, borderTop, borderLeft, borderTranslateX, borderTranslateY;
					m = (cache.isSVG && (e.style[_transformProp] + "").indexOf("matrix") !== -1) ? e.style[_transformProp] : cs ? cs.getPropertyValue(_transformPropCSS) : e.currentStyle ? e.currentStyle[_transformProp] : "1,0,0,1,0,0"; //some browsers (like Chrome 40) don't correctly report transforms that are applied inline on an SVG element (they don't get included in the computed style), so we double-check here and accept matrix values
					if (e.getBBox && (e.getAttribute("transform") + "").indexOf("matrix") !== -1) { //SVG can store transform data in its "transform" attribute instead of the CSS, so look for that here (only accept matrix()).
						m = e.getAttribute("transform");
					}
					m = (m + "").match(/(?:\-|\.|\b)(\d|\.|e\-)+/g) || [1,0,0,1,0,0];
					if (m.length > 6) {
						m = [m[0], m[1], m[4], m[5], m[12], m[13]];
					}
					if (zeroOrigin) {
						m[4] = m[5] = 0;
					} else if (cache.isSVG && (t = e._gsTransform) && (t.xOrigin || t.yOrigin)) {
						//SVGs handle origin very differently. Factor in GSAP's handling of origin values here:
						m[0] = parseFloat(m[0]);
						m[1] = parseFloat(m[1]);
						m[2] = parseFloat(m[2]);
						m[3] = parseFloat(m[3]);
						m[4] = parseFloat(m[4]) - (t.xOrigin - (t.xOrigin * m[0] + t.yOrigin * m[2]));
						m[5] = parseFloat(m[5]) - (t.yOrigin - (t.xOrigin * m[1] + t.yOrigin * m[3]));
					}
					if (offsetOrigin) {
						if (_svgBorderFactor === undefined) {
							_setEnvironmentVariables();
						}
						offsets = (cache.isSVG || cache.isSVGRoot) ? _getSVGOffsets(e) : e;
						if (cache.isSVG) { //don't just rely on "instanceof _SVGElement" because if the SVG is embedded via an object tag, it won't work (SVGElement is mapped to a different object))
							rect = e.getBBox();
							parentRect = (parentCache.isSVGRoot) ? {x:0, y:0} : parent.getBBox();
							offsets = {offsetLeft:rect.x - parentRect.x, offsetTop:rect.y - parentRect.y, offsetParent:cache.offsetParent};
						} else if (cache.isSVGRoot) {
							borderTop = parseInt(cs.borderTopWidth, 10) || 0;
							borderLeft = parseInt(cs.borderLeftWidth, 10) || 0;
							borderTranslateX = ((m[0] - _svgBorderFactor) * borderLeft + m[2] * borderTop);
							borderTranslateY = (m[1] * borderLeft + (m[3] - _svgBorderFactor) * borderTop);
	
							sx = offsetOrigin.x;
							sy = offsetOrigin.y;
							offsetX = (sx - (sx * m[0] + sy * m[2])); //accommodate the SVG root's transforms when the origin isn't in the top left.
							offsetY = (sy - (sx * m[1] + sy * m[3]));
	
							m[4] = parseFloat(m[4]) + offsetX;
							m[5] = parseFloat(m[5]) + offsetY;
							offsetOrigin.x -= offsetX;
							offsetOrigin.y -= offsetY;
							sx = offsets.scaleX;
							sy = offsets.scaleY;
							if (!isBase) { //when getting the matrix for a root <svg> element itself (NOT in the context of an SVG element that's nested inside of it like a <path>), we do NOT apply the scaling!
								offsetOrigin.x *= sx;
								offsetOrigin.y *= sy;
							}
							m[0] *= sx;
							m[1] *= sy;
							m[2] *= sx;
							m[3] *= sy;
							if (!_isIE10orBelow) {
								offsetOrigin.x += borderTranslateX;
								offsetOrigin.y += borderTranslateY;
							}
							if (parentOffsetParent === _doc.body && offsets.offsetParent === _docElement) { //to avoid issues with margin/padding on the <body>, we always set the offsetParent to _docElement in the _getSVGOffsets() function but there's a condition we check later in this function for (parentOffsetParent === offsets.offsetParent) which would fail if we don't run this logic. In other words, parentOffsetParent may be <body> and the <svg>'s offsetParent is also <body> but artificially set to _docElement to avoid margin/padding issues.
								parentOffsetParent = _docElement;
							}
						} else if (!_hasBorderBug && e.offsetParent) {
							offsetOrigin.x += parseInt(_getStyle(e.offsetParent, "borderLeftWidth"), 10) || 0;
							offsetOrigin.y += parseInt(_getStyle(e.offsetParent, "borderTopWidth"), 10) || 0;
						}
						isRoot = (parent === _docElement || parent === _doc.body);
						m[4] = Number(m[4]) + offsetOrigin.x + (offsets.offsetLeft || 0) - parentOffsetOrigin.x - (isRoot ? 0 : parent.scrollLeft || 0);
						m[5] = Number(m[5]) + offsetOrigin.y + (offsets.offsetTop || 0) - parentOffsetOrigin.y - (isRoot ? 0 : parent.scrollTop || 0);
						if (parent && _getStyle(e, "position", cs) === "fixed") { //fixed position elements should factor in the scroll position of the document.
							m[4] += _getDocScrollLeft();
							m[5] += _getDocScrollTop();
						}
						if (parent && parent !== _docElement && parentOffsetParent === offsets.offsetParent && !parentCache.isSVG && (!_hasReparentBug || _getOffset2DMatrix(parent).join("") === "100100")) {
							offsets = (parentCache.isSVGRoot) ? _getSVGOffsets(parent) : parent;
							m[4] -= offsets.offsetLeft || 0;
							m[5] -= offsets.offsetTop || 0;
							if (!_hasBorderBug && parentCache.offsetParent && !cache.isSVG && !cache.isSVGRoot) {
								m[4] -= parseInt(_getStyle(parentCache.offsetParent, "borderLeftWidth"), 10) || 0;
								m[5] -= parseInt(_getStyle(parentCache.offsetParent, "borderTopWidth"), 10) || 0;
							}
						}
					}
					return m;
				},
				_getConcatenatedMatrix = function(e, invert) {
					if (!e || e === window || !e.parentNode) {
						return [1,0,0,1,0,0];
					}
					//note: we keep reusing _point1 and _point2 in order to minimize memory usage and garbage collection chores.
					var originOffset = _getOffsetTransformOrigin(e, _point1),
						parentOriginOffset = _getOffsetTransformOrigin(e.parentNode, _point2),
						m = _getOffset2DMatrix(e, originOffset, parentOriginOffset, false, !invert),
						a, b, c, d, tx, ty, m2, determinant;
					while ((e = e.parentNode) && e.parentNode && e !== _docElement) {
						originOffset = parentOriginOffset;
						parentOriginOffset = _getOffsetTransformOrigin(e.parentNode, (originOffset === _point1) ? _point2 : _point1);
						m2 = _getOffset2DMatrix(e, originOffset, parentOriginOffset);
						a = m[0];
						b = m[1];
						c = m[2];
						d = m[3];
						tx = m[4];
						ty = m[5];
						m[0] = a * m2[0] + b * m2[2];
						m[1] = a * m2[1] + b * m2[3];
						m[2] = c * m2[0] + d * m2[2];
						m[3] = c * m2[1] + d * m2[3];
						m[4] = tx * m2[0] + ty * m2[2] + m2[4];
						m[5] = tx * m2[1] + ty * m2[3] + m2[5];
					}
					if (invert) {
						a = m[0];
						b = m[1];
						c = m[2];
						d = m[3];
						tx = m[4];
						ty = m[5];
						determinant = (a * d - b * c);
						m[0] = d / determinant;
						m[1] = -b / determinant;
						m[2] = -c / determinant;
						m[3] = a / determinant;
						m[4] = (c * ty - d * tx) / determinant;
						m[5] = -(a * ty - b * tx) / determinant;
					}
					return m;
				},
				_localToGlobal = function(e, p, fromTopLeft, decoratee, zeroOrigin) {
					e = _unwrapElement(e);
					var m = _getConcatenatedMatrix(e, false, zeroOrigin),
						x = p.x,
						y = p.y;
					if (fromTopLeft) {
						_getOffsetTransformOrigin(e, p);
						x -= p.x;
						y -= p.y;
					}
					decoratee = (decoratee === true) ? p : decoratee || {};
					decoratee.x = x * m[0] + y * m[2] + m[4];
					decoratee.y = x * m[1] + y * m[3] + m[5];
					return decoratee;
				},
				_localizePoint = function(p, localToGlobal, globalToLocal) {
					var x = p.x * localToGlobal[0] + p.y * localToGlobal[2] + localToGlobal[4],
						y = p.x * localToGlobal[1] + p.y * localToGlobal[3] + localToGlobal[5];
					p.x = x * globalToLocal[0] + y * globalToLocal[2] + globalToLocal[4];
					p.y = x * globalToLocal[1] + y * globalToLocal[3] + globalToLocal[5];
					return p;
				},
	
				_getElementBounds = function(e, context, fromTopLeft) {
					if (!(e = _unwrapElement(e))) {
						return null;
					}
					context = _unwrapElement(context);
					var isSVG = (e.getBBox && _isSVG(e)),
						origin, left, right, top, bottom, mLocalToGlobal, mGlobalToLocal, p1, p2, p3, p4, bbox, width, height, cache, borderLeft, borderTop, viewBox, viewBoxX, viewBoxY, computedDimensions, cs;
					if (e === window) {
						top = _getDocScrollTop();
						left = _getDocScrollLeft();
						right = left + (_docElement.clientWidth || e.innerWidth || _doc.body.clientWidth || 0);
						bottom = top + (((e.innerHeight || 0) - 20 < _docElement.clientHeight) ? _docElement.clientHeight : e.innerHeight || _doc.body.clientHeight || 0); //some browsers (like Firefox) ignore absolutely positioned elements, and collapse the height of the documentElement, so it could be 8px, for example, if you have just an absolutely positioned div. In that case, we use the innerHeight to resolve this.
					} else if (context === undefined || context === window) {
						return e.getBoundingClientRect();
					} else {
						origin = _getOffsetTransformOrigin(e);
						left = -origin.x;
						top = -origin.y;
						if (isSVG) {
							bbox = e.getBBox();
							width = bbox.width;
							height = bbox.height;
						} else if ((e.nodeName + "").toLowerCase() !== "svg" && e.offsetWidth) { //Chrome dropped support for "offsetWidth" on SVG elements
							width = e.offsetWidth;
							height = e.offsetHeight;
						} else {
							computedDimensions = _getComputedStyle(e);
							width = parseFloat(computedDimensions.width);
							height = parseFloat(computedDimensions.height);
						}
						right = left + width;
						bottom = top + height;
						if (e.nodeName.toLowerCase() === "svg" && !_isOldIE) { //root SVG elements are a special beast because they have 2 types of scaling - transforms on themselves as well as the stretching of the SVG canvas itself based on the outer size and the viewBox. If, for example, the SVG's viewbox is "0 0 100 100" but the CSS is set to width:200px; height:200px, that'd make it appear at 2x scale even though the element itself has no CSS transforms but the offsetWidth/offsetHeight are based on that css, not the viewBox so we need to adjust them accordingly.
							cache = _getSVGOffsets(e);
							cs = cache.computedStyle || {};
							viewBox = (e.getAttribute("viewBox") || "0 0").split(" ");
							viewBoxX = parseFloat(viewBox[0]);
							viewBoxY = parseFloat(viewBox[1]);
							borderLeft = parseFloat(cs.borderLeftWidth) || 0;
							borderTop = parseFloat(cs.borderTopWidth) || 0;
							right -= width - ((width - borderLeft) / cache.scaleX) - viewBoxX;
							bottom -= height - ((height - borderTop) / cache.scaleY) - viewBoxY;
							left -= borderLeft / cache.scaleX - viewBoxX;
							top -= borderTop / cache.scaleY - viewBoxY;
							if (computedDimensions) { //when we had to use computed styles, factor in the border now.
								right += (parseFloat(cs.borderRightWidth) + borderLeft) / cache.scaleX;
								bottom += (borderTop + parseFloat(cs.borderBottomWidth)) / cache.scaleY;
							}
						}
					}
					if (e === context) {
						return {left:left, top:top, width: right - left, height: bottom - top};
					}
					mLocalToGlobal = _getConcatenatedMatrix(e);
					mGlobalToLocal = _getConcatenatedMatrix(context, true);
					p1 = _localizePoint({x:left, y:top}, mLocalToGlobal, mGlobalToLocal);
					p2 = _localizePoint({x:right, y:top}, mLocalToGlobal, mGlobalToLocal);
					p3 = _localizePoint({x:right, y:bottom}, mLocalToGlobal, mGlobalToLocal);
					p4 = _localizePoint({x:left, y:bottom}, mLocalToGlobal, mGlobalToLocal);
					left = Math.min(p1.x, p2.x, p3.x, p4.x);
					top = Math.min(p1.y, p2.y, p3.y, p4.y);
					_temp1.x = _temp1.y = 0;
					if (fromTopLeft) {
						_getOffsetTransformOrigin(context, _temp1);
					}
					return {left:left + _temp1.x, top:top + _temp1.y, width:Math.max(p1.x, p2.x, p3.x, p4.x) - left, height:Math.max(p1.y, p2.y, p3.y, p4.y) - top};
				},
				// end matrix and point conversion methods
	
	
	
				_isArrayLike = function(e) {
					return (e && e.length && e[0] && ((e[0].nodeType && e[0].style && !e.nodeType) || (e[0].length && e[0][0]))) ? true : false; //could be an array of jQuery objects too, so accommodate that.
				},
	
				_flattenArray = function(a) {
					var result = [],
						l = a.length,
						i, e, j;
					for (i = 0; i < l; i++) {
						e = a[i];
						if (_isArrayLike(e)) {
							j = e.length;
							for (j = 0; j < e.length; j++) {
								result.push(e[j]);
							}
						} else if (e && e.length !== 0) {
							result.push(e);
						}
					}
					return result;
				},
	
				_isTouchDevice = (("ontouchstart" in _docElement) && ("orientation" in window)),
				_touchEventLookup = (function(types) { //we create an object that makes it easy to translate touch event types into their "pointer" counterparts if we're in a browser that uses those instead. Like IE10 uses "MSPointerDown" instead of "touchstart", for example.
					var standard = types.split(","),
						converted = ((_tempDiv.onpointerdown !== undefined) ? "pointerdown,pointermove,pointerup,pointercancel" : (_tempDiv.onmspointerdown !== undefined) ? "MSPointerDown,MSPointerMove,MSPointerUp,MSPointerCancel" : types).split(","),
						obj = {},
						i = 4;
					while (--i > -1) {
						obj[standard[i]] = converted[i];
						obj[converted[i]] = standard[i];
					}
					return obj;
				}("touchstart,touchmove,touchend,touchcancel")),
	
				_addListener = function(element, type, func, capture) {
					if (element.addEventListener) {
						var touchType = _touchEventLookup[type];
						capture = capture || {passive:false};
						element.addEventListener(touchType || type, func, capture);
						if (touchType && type !== touchType) { //some browsers actually support both, so must we.
							element.addEventListener(type, func, capture);
						}
					} else if (element.attachEvent) {
						element.attachEvent("on" + type, func);
					}
				},
	
				_removeListener = function(element, type, func) {
					if (element.removeEventListener) {
						var touchType = _touchEventLookup[type];
						element.removeEventListener(touchType || type, func);
						if (touchType && type !== touchType) {
							element.removeEventListener(type, func);
						}
					} else if (element.detachEvent) {
						element.detachEvent("on" + type, func);
					}
				},
	
				_hasTouchID = function(list, ID) {
					var i = list.length;
					while (--i > -1) {
						if (list[i].identifier === ID) {
							return true;
						}
					}
					return false;
				},
	
				_onMultiTouchDocumentEnd = function(e) {
					_isMultiTouching = (e.touches && _dragCount < e.touches.length);
					_removeListener(e.target, "touchend", _onMultiTouchDocumentEnd);
				},
	
				_onMultiTouchDocument = function(e) {
					_isMultiTouching = (e.touches && _dragCount < e.touches.length);
					_addListener(e.target, "touchend", _onMultiTouchDocumentEnd);
				},
	
				_parseThrowProps = function(draggable, snap, max, min, factor, forceZeroVelocity) {
					var vars = {},
						a, i, l;
					if (snap) {
						if (factor !== 1 && snap instanceof Array) { //some data must be altered to make sense, like if the user passes in an array of rotational values in degrees, we must convert it to radians. Or for scrollLeft and scrollTop, we invert the values.
							vars.end = a = [];
							l = snap.length;
							if (typeof(snap[0]) === "object") { //if the array is populated with objects, like points ({x:100, y:200}), make copies before multiplying by the factor, otherwise we'll mess up the originals and the user may reuse it elsewhere.
								for (i = 0; i < l; i++) {
									a[i] = _copy(snap[i], factor);
								}
							} else {
								for (i = 0; i < l; i++) {
									a[i] = snap[i] * factor;
								}
							}
							max += 1.1; //allow 1.1 pixels of wiggle room when snapping in order to work around some browser inconsistencies in the way bounds are reported which can make them roughly a pixel off. For example, if "snap:[-$('#menu').width(), 0]" was defined and #menu had a wrapper that was used as the bounds, some browsers would be one pixel off, making the minimum -752 for example when snap was [-753,0], thus instead of snapping to -753, it would snap to 0 since -753 was below the minimum.
							min -= 1.1;
						} else if (typeof(snap) === "function") {
							vars.end = function(value) {
								var result = snap.call(draggable, value),
									copy, p;
								if (factor !== 1) {
									if (typeof(result) === "object") {
										copy = {};
										for (p in result) {
											copy[p] = result[p] * factor;
										}
										result = copy;
									} else {
										result *= factor;
									}
								}
								return result; //we need to ensure that we can scope the function call to the Draggable instance itself so that users can access important values like maxX, minX, maxY, minY, x, and y from within that function.
							};
						} else {
							vars.end = snap;
						}
					}
					if (max || max === 0) {
						vars.max = max;
					}
					if (min || min === 0) {
						vars.min = min;
					}
					if (forceZeroVelocity) {
						vars.velocity = 0;
					}
					return vars;
				},
	
				_isClickable = function(e) { //sometimes it's convenient to mark an element as clickable by adding a data-clickable="true" attribute (in which case we won't preventDefault() the mouse/touch event). This method checks if the element is an <a>, <input>, or <button> or has an onclick or has the data-clickable or contentEditable attribute set to true (or any of its parent elements).
					var data;
					return (!e || !e.getAttribute || e.nodeName === "BODY") ? false : ((data = e.getAttribute("data-clickable")) === "true" || (data !== "false" && (e.onclick || _clickableTagExp.test(e.nodeName + "") || e.getAttribute("contentEditable") === "true"))) ? true : _isClickable(e.parentNode);
				},
	
				_setSelectable = function(elements, selectable) {
					var i = elements.length,
						e;
					while (--i > -1) {
						e = elements[i];
						e.ondragstart = e.onselectstart = selectable ? null : _emptyFunc;
						_setStyle(e, "userSelect", (selectable ? "text" : "none"));
					}
				},
	
				_addPaddingBR = (function() { //this function is in charge of analyzing browser behavior related to padding. It sets the _addPaddingBR to true if the browser doesn't normally factor in the bottom or right padding on the element inside the scrolling area, and it sets _addPaddingLeft to true if it's a browser that requires the extra offset (offsetLeft) to be added to the paddingRight (like Opera).
					var div = _doc.createElement("div"),
						child = _doc.createElement("div"),
						childStyle = child.style,
						parent = _doc.body || _tempDiv,
						val;
					childStyle.display = "inline-block";
					childStyle.position = "relative";
					div.style.cssText = child.innerHTML = "width:90px; height:40px; padding:10px; overflow:auto; visibility: hidden";
					div.appendChild(child);
					parent.appendChild(div);
					val = (child.offsetHeight + 18 > div.scrollHeight); //div.scrollHeight should be child.offsetHeight + 20 because of the 10px of padding on each side, but some browsers ignore one side. We allow a 2px margin of error.
					parent.removeChild(div);
					return val;
				}()),
	
	
	
	
				//The ScrollProxy class wraps an element's contents into another div (we call it "content") that we either add padding when necessary or apply a translate3d() transform in order to overscroll (scroll past the boundaries). This allows us to simply set the scrollTop/scrollLeft (or top/left for easier reverse-axis orientation, which is what we do in Draggable) and it'll do all the work for us. For example, if we tried setting scrollTop to -100 on a normal DOM element, it wouldn't work - it'd look the same as setting it to 0, but if we set scrollTop of a ScrollProxy to -100, it'll give the correct appearance by either setting paddingTop of the wrapper to 100 or applying a 100-pixel translateY.
				ScrollProxy = function(element, vars) {
					element = _unwrapElement(element);
					vars = vars || {};
					var content = _doc.createElement("div"),
						style = content.style,
						node = element.firstChild,
						offsetTop = 0,
						offsetLeft = 0,
						prevTop = element.scrollTop,
						prevLeft = element.scrollLeft,
						scrollWidth = element.scrollWidth,
						scrollHeight = element.scrollHeight,
						extraPadRight = 0,
						maxLeft = 0,
						maxTop = 0,
						elementWidth, elementHeight, contentHeight, nextNode, transformStart, transformEnd;
	
					if (_supports3D && vars.force3D !== false) {
						transformStart = "translate3d(";
						transformEnd = "px,0px)";
					} else if (_transformProp) {
						transformStart = "translate(";
						transformEnd = "px)";
					}
	
					this.scrollTop = function(value, force) {
						if (!arguments.length) {
							return -this.top();
						}
						this.top(-value, force);
					};
	
					this.scrollLeft = function(value, force) {
						if (!arguments.length) {
							return -this.left();
						}
						this.left(-value, force);
					};
	
					this.left = function(value, force) {
						if (!arguments.length) {
							return -(element.scrollLeft + offsetLeft);
						}
						var dif = element.scrollLeft - prevLeft,
							oldOffset = offsetLeft;
						if ((dif > 2 || dif < -2) && !force) { //if the user interacts with the scrollbar (or something else scrolls it, like the mouse wheel), we should kill any tweens of the ScrollProxy.
							prevLeft = element.scrollLeft;
							TweenLite.killTweensOf(this, true, {left:1, scrollLeft:1});
							this.left(-prevLeft);
							if (vars.onKill) {
								vars.onKill();
							}
							return;
						}
						value = -value; //invert because scrolling works in the opposite direction
						if (value < 0) {
							offsetLeft = (value - 0.5) | 0;
							value = 0;
						} else if (value > maxLeft) {
							offsetLeft = (value - maxLeft) | 0;
							value = maxLeft;
						} else {
							offsetLeft = 0;
						}
						if (offsetLeft || oldOffset) {
							if (transformStart) {
								if (!this._suspendTransforms) {
									style[_transformProp] = transformStart + -offsetLeft + "px," + -offsetTop + transformEnd;
								}
							} else {
								style.left = -offsetLeft + "px";
							}
							if (offsetLeft + extraPadRight >= 0) {
								style.paddingRight = offsetLeft + extraPadRight + "px";
							}
						}
						element.scrollLeft = value | 0;
						prevLeft = element.scrollLeft; //don't merge this with the line above because some browsers adjsut the scrollLeft after it's set, so in order to be 100% accurate in tracking it, we need to ask the browser to report it.
					};
	
					this.top = function(value, force) {
						if (!arguments.length) {
							return -(element.scrollTop + offsetTop);
						}
						var dif = element.scrollTop - prevTop,
							oldOffset = offsetTop;
						if ((dif > 2 || dif < -2) && !force) { //if the user interacts with the scrollbar (or something else scrolls it, like the mouse wheel), we should kill any tweens of the ScrollProxy.
							prevTop = element.scrollTop;
							TweenLite.killTweensOf(this, true, {top:1, scrollTop:1});
							this.top(-prevTop);
							if (vars.onKill) {
								vars.onKill();
							}
							return;
						}
						value = -value; //invert because scrolling works in the opposite direction
						if (value < 0) {
							offsetTop = (value - 0.5) | 0;
							value = 0;
						} else if (value > maxTop) {
							offsetTop = (value - maxTop) | 0;
							value = maxTop;
						} else {
							offsetTop = 0;
						}
						if (offsetTop || oldOffset) {
							if (transformStart) {
								if (!this._suspendTransforms) {
									style[_transformProp] = transformStart + -offsetLeft + "px," + -offsetTop + transformEnd;
								}
							} else {
								style.top = -offsetTop + "px";
							}
						}
						element.scrollTop = value | 0;
						prevTop = element.scrollTop;
					};
	
					this.maxScrollTop = function() {
						return maxTop;
					};
	
					this.maxScrollLeft = function() {
						return maxLeft;
					};
	
					this.disable = function() {
						node = content.firstChild;
						while (node) {
							nextNode = node.nextSibling;
							element.appendChild(node);
							node = nextNode;
						}
						if (element === content.parentNode) { //in case disable() is called when it's already disabled.
							element.removeChild(content);
						}
					};
	
					this.enable = function() {
						node = element.firstChild;
						if (node === content) {
							return;
						}
						while (node) {
							nextNode = node.nextSibling;
							content.appendChild(node);
							node = nextNode;
						}
						element.appendChild(content);
						this.calibrate();
					};
	
					this.calibrate = function(force) {
						var widthMatches = (element.clientWidth === elementWidth),
							x, y;
						prevTop = element.scrollTop;
						prevLeft = element.scrollLeft;
						if (widthMatches && element.clientHeight === elementHeight && content.offsetHeight === contentHeight && scrollWidth === element.scrollWidth && scrollHeight === element.scrollHeight && !force) {
							return; //no need to recalculate things if the width and height haven't changed.
						}
						if (offsetTop || offsetLeft) {
							x = this.left();
							y = this.top();
							this.left(-element.scrollLeft);
							this.top(-element.scrollTop);
						}
						//first, we need to remove any width constraints to see how the content naturally flows so that we can see if it's wider than the containing element. If so, we've got to record the amount of overage so that we can apply that as padding in order for browsers to correctly handle things. Then we switch back to a width of 100% (without that, some browsers don't flow the content correctly)
						if (!widthMatches || force) {
							style.display = "block";
							style.width = "auto";
							style.paddingRight = "0px";
							extraPadRight = Math.max(0, element.scrollWidth - element.clientWidth);
							//if the content is wider than the container, we need to add the paddingLeft and paddingRight in order for things to behave correctly.
							if (extraPadRight) {
								extraPadRight += _getStyle(element, "paddingLeft") + (_addPaddingBR ? _getStyle(element, "paddingRight") : 0);
							}
						}
						style.display = "inline-block";
						style.position = "relative";
						style.overflow = "visible";
						style.verticalAlign = "top";
						style.width = "100%";
						style.paddingRight = extraPadRight + "px";
						//some browsers neglect to factor in the bottom padding when calculating the scrollHeight, so we need to add that padding to the content when that happens. Allow a 2px margin for error
						if (_addPaddingBR) {
							style.paddingBottom = _getStyle(element, "paddingBottom", true);
						}
						if (_isOldIE) {
							style.zoom = "1";
						}
						elementWidth = element.clientWidth;
						elementHeight = element.clientHeight;
						scrollWidth = element.scrollWidth;
						scrollHeight = element.scrollHeight;
						maxLeft = element.scrollWidth - elementWidth;
						maxTop = element.scrollHeight - elementHeight;
						contentHeight = content.offsetHeight;
						style.display = "block";
						if (x || y) {
							this.left(x);
							this.top(y);
						}
					};
	
					this.content = content;
					this.element = element;
					this._suspendTransforms = false;
					this.enable();
				},
	
	
	
	
	
				Draggable = function(target, vars) {
					EventDispatcher.call(this, target);
					target = _unwrapElement(target); //in case the target is a selector object or selector text
					if (!ThrowPropsPlugin) {
						ThrowPropsPlugin = _globals.com.greensock.plugins.ThrowPropsPlugin;
					}
					this.vars = vars = _copy(vars || {});
					this.target = target;
					this.x = this.y = this.rotation = 0;
					this.dragResistance = parseFloat(vars.dragResistance) || 0;
					this.edgeResistance = isNaN(vars.edgeResistance) ? 1 : parseFloat(vars.edgeResistance) || 0;
					this.lockAxis = vars.lockAxis;
					this.autoScroll = vars.autoScroll || 0;
					this.lockedAxis = null;
					this.allowEventDefault = !!vars.allowEventDefault;
					var type = (vars.type || (_isOldIE ? "top,left" : "x,y")).toLowerCase(),
						xyMode = (type.indexOf("x") !== -1 || type.indexOf("y") !== -1),
						rotationMode = (type.indexOf("rotation") !== -1),
						xProp = rotationMode ? "rotation" : xyMode ? "x" : "left",
						yProp = xyMode ? "y" : "top",
						allowX = (type.indexOf("x") !== -1 || type.indexOf("left") !== -1 || type === "scroll"),
						allowY = (type.indexOf("y") !== -1 || type.indexOf("top") !== -1 || type === "scroll"),
						minimumMovement = vars.minimumMovement || 2,
						self = this,
						triggers = _slice(vars.trigger || vars.handle || target),
						killProps = {},
						dragEndTime = 0,
						checkAutoScrollBounds = false,
						autoScrollMarginTop = vars.autoScrollMarginTop || 40,
						autoScrollMarginRight = vars.autoScrollMarginRight || 40,
						autoScrollMarginBottom = vars.autoScrollMarginBottom || 40,
						autoScrollMarginLeft = vars.autoScrollMarginLeft || 40,
						isClickable = vars.clickableTest || _isClickable,
						clickTime = 0,
						enabled, scrollProxy, startPointerX, startPointerY, startElementX, startElementY, hasBounds, hasDragCallback, maxX, minX, maxY, minY, tempVars, cssVars, touch, touchID, rotationOrigin, dirty, old, snapX, snapY, snapXY, isClicking, touchEventTarget, matrix, interrupted, startScrollTop, startScrollLeft, applyObj, allowNativeTouchScrolling, touchDragAxis, isDispatching, clickDispatch, trustedClickDispatch,
	
						onContextMenu = function(e) { //used to prevent long-touch from triggering a context menu.
							if (self.isPressed && e.which < 2) {
								self.endDrag();
							} else {
								e.preventDefault();
								e.stopPropagation();
								return false;
							}
						},
	
						//this method gets called on every tick of TweenLite.ticker which allows us to synchronize the renders to the core engine (which is typically synchronized with the display refresh via requestAnimationFrame). This is an optimization - it's better than applying the values inside the "mousemove" or "touchmove" event handler which may get called many times inbetween refreshes.
						render = function(suppressEvents) {
							if (self.autoScroll && self.isDragging && (checkAutoScrollBounds || dirty)) {
								var e = target,
									autoScrollFactor = self.autoScroll * 15, //multiplying by 15 just gives us a better "feel" speed-wise.
									parent, isRoot, rect, pointerX, pointerY, changeX, changeY, gap;
								checkAutoScrollBounds = false;
								_windowProxy.scrollTop = ((window.pageYOffset != null) ? window.pageYOffset : (_docElement.scrollTop != null) ? _docElement.scrollTop : _doc.body.scrollTop);
								_windowProxy.scrollLeft = ((window.pageXOffset != null) ? window.pageXOffset : (_docElement.scrollLeft != null) ? _docElement.scrollLeft : _doc.body.scrollLeft);
								pointerX = self.pointerX - _windowProxy.scrollLeft;
								pointerY = self.pointerY - _windowProxy.scrollTop;
								while (e && !isRoot) { //walk up the chain and sense wherever the pointer is within 40px of an edge that's scrollable.
									isRoot = _isRoot(e.parentNode);
									parent = isRoot ? _windowProxy : e.parentNode;
									rect = isRoot ? {bottom:Math.max(_docElement.clientHeight, window.innerHeight || 0), right: Math.max(_docElement.clientWidth, window.innerWidth || 0), left:0, top:0} : parent.getBoundingClientRect();
									changeX = changeY = 0;
									if (allowY) {
										gap = parent._gsMaxScrollY - parent.scrollTop;
										if (gap < 0) {
											changeY = gap;
										} else if (pointerY > rect.bottom - autoScrollMarginBottom && gap) {
											checkAutoScrollBounds = true;
											changeY = Math.min(gap, (autoScrollFactor * (1 - Math.max(0, (rect.bottom - pointerY)) / autoScrollMarginBottom)) | 0);
										} else if (pointerY < rect.top + autoScrollMarginTop && parent.scrollTop) {
											checkAutoScrollBounds = true;
											changeY = -Math.min(parent.scrollTop, (autoScrollFactor * (1 - Math.max(0, (pointerY - rect.top)) / autoScrollMarginTop)) | 0);
										}
										if (changeY) {
											parent.scrollTop += changeY;
										}
									}
									if (allowX) {
										gap = parent._gsMaxScrollX - parent.scrollLeft;
										if (gap < 0) {
											changeX = gap;
										} else if (pointerX > rect.right - autoScrollMarginRight && gap) {
											checkAutoScrollBounds = true;
											changeX = Math.min(gap, (autoScrollFactor * (1 - Math.max(0, (rect.right - pointerX)) / autoScrollMarginRight)) | 0);
										} else if (pointerX < rect.left + autoScrollMarginLeft && parent.scrollLeft) {
											checkAutoScrollBounds = true;
											changeX = -Math.min(parent.scrollLeft, (autoScrollFactor * (1 - Math.max(0, (pointerX - rect.left)) / autoScrollMarginLeft)) | 0);
										}
										if (changeX) {
											parent.scrollLeft += changeX;
										}
									}
	
									if (isRoot && (changeX || changeY)) {
										window.scrollTo(parent.scrollLeft, parent.scrollTop);
										setPointerPosition(self.pointerX + changeX, self.pointerY + changeY);
									}
									e = parent;
								}
							}
							if (dirty) {
								var x = self.x,
									y = self.y,
									min = 0.000001;
								if (x < min && x > -min) { //browsers don't handle super small decimals well.
									x = 0;
								}
								if (y < min && y > -min) {
									y = 0;
								}
								if (rotationMode) {
									self.deltaX = x - applyObj.data.rotation;
									applyObj.data.rotation = self.rotation = x;
									applyObj.setRatio(1); //note: instead of doing TweenLite.set(), as a performance optimization we skip right to the method that renders the transforms inside CSSPlugin. For old versions of IE, though, we do a normal TweenLite.set() to leverage its ability to re-reroute to an IE-specific 2D renderer.
								} else {
									if (scrollProxy) {
										if (allowY) {
											self.deltaY = y - scrollProxy.top();
											scrollProxy.top(y);
										}
										if (allowX) {
											self.deltaX = x - scrollProxy.left();
											scrollProxy.left(x);
										}
									} else if (xyMode) {
										if (allowY) {
											self.deltaY = y - applyObj.data.y;
											applyObj.data.y = y;
										}
										if (allowX) {
											self.deltaX = x - applyObj.data.x;
											applyObj.data.x = x;
										}
										applyObj.setRatio(1); //note: instead of doing TweenLite.set(), as a performance optimization we skip right to the method that renders the transforms inside CSSPlugin. For old versions of IE, though, we do a normal TweenLite.set() to leverage its ability to re-reroute to an IE-specific 2D renderer.
									} else {
										if (allowY) {
											self.deltaY = y - parseFloat(target.style.top || 0);
											target.style.top = y + "px";
										}
										if (allowX) {
											self.deltaY = x - parseFloat(target.style.left || 0);
											target.style.left = x + "px";
										}
									}
								}
								if (hasDragCallback && !suppressEvents && !isDispatching) {
									isDispatching = true; //in case onDrag has an update() call (avoid endless loop)
									_dispatchEvent(self, "drag", "onDrag");
									isDispatching = false;
								}
							}
							dirty = false;
						},
	
						//copies the x/y from the element (whether that be transforms, top/left, or ScrollProxy's top/left) to the Draggable's x and y (and rotation if necessary) properties so that they reflect reality and it also (optionally) applies any snapping necessary. This is used by the ThrowPropsPlugin tween in an onUpdate to ensure things are synced and snapped.
						syncXY = function(skipOnUpdate, skipSnap) {
							var x = self.x,
								y = self.y,
								snappedValue;
							if (!target._gsTransform && (xyMode || rotationMode)) { //just in case the _gsTransform got wiped, like if the user called clearProps on the transform or something (very rare), doing an x tween forces a re-parsing of the transforms and population of the _gsTransform.
								TweenLite.set(target, {x:"+=0", overwrite:false, data:"_draggable"});
							}
							if (xyMode) {
								self.y = target._gsTransform.y;
								self.x = target._gsTransform.x;
							} else if (rotationMode) {
								self.x = self.rotation = target._gsTransform.rotation;
							} else if (scrollProxy) {
								self.y = scrollProxy.top();
								self.x = scrollProxy.left();
							} else {
								self.y = parseInt(target.style.top, 10) || 0;
								self.x = parseInt(target.style.left, 10) || 0;
							}
							if ((snapX || snapY || snapXY) && !skipSnap && (self.isDragging || self.isThrowing)) {
								if (snapXY) {
									_temp1.x = self.x;
									_temp1.y = self.y;
									snappedValue = snapXY(_temp1);
									if (snappedValue.x !== self.x) {
										self.x = snappedValue.x;
										dirty = true;
									}
									if (snappedValue.y !== self.y) {
										self.y = snappedValue.y;
										dirty = true;
									}
								}
								if (snapX) {
									snappedValue = snapX(self.x);
									if (snappedValue !== self.x) {
										self.x = snappedValue;
										if (rotationMode) {
											self.rotation = snappedValue;
										}
										dirty = true;
									}
								}
								if (snapY) {
									snappedValue = snapY(self.y);
									if (snappedValue !== self.y) {
										self.y = snappedValue;
									}
									dirty = true;
								}
							}
							if (dirty) {
								render(true);
							}
							if (!skipOnUpdate) {
								self.deltaX = self.x - x;
								self.deltaY = self.y - y;
								_dispatchEvent(self, "throwupdate", "onThrowUpdate");
							}
						},
	
						calculateBounds = function() {
							var bounds, targetBounds, snap, snapIsRaw;
							hasBounds = false;
							if (scrollProxy) {
								scrollProxy.calibrate();
								self.minX = minX = -scrollProxy.maxScrollLeft();
								self.minY = minY = -scrollProxy.maxScrollTop();
								self.maxX = maxX = self.maxY = maxY = 0;
								hasBounds = true;
							} else if (!!vars.bounds) {
								bounds = _getBounds(vars.bounds, target.parentNode); //could be a selector/jQuery object or a DOM element or a generic object like {top:0, left:100, width:1000, height:800} or {minX:100, maxX:1100, minY:0, maxY:800}
								if (rotationMode) {
									self.minX = minX = bounds.left;
									self.maxX = maxX = bounds.left + bounds.width;
									self.minY = minY = self.maxY = maxY = 0;
								} else if (vars.bounds.maxX !== undefined || vars.bounds.maxY !== undefined) {
									bounds = vars.bounds;
									self.minX = minX = bounds.minX;
									self.minY = minY = bounds.minY;
									self.maxX = maxX = bounds.maxX;
									self.maxY = maxY = bounds.maxY;
								} else {
									targetBounds = _getBounds(target, target.parentNode);
									self.minX = minX = _getStyle(target, xProp) + bounds.left - targetBounds.left;
									self.minY = minY = _getStyle(target, yProp) + bounds.top - targetBounds.top;
									self.maxX = maxX = minX + (bounds.width - targetBounds.width);
									self.maxY = maxY = minY + (bounds.height - targetBounds.height);
								}
								if (minX > maxX) {
									self.minX = maxX;
									self.maxX = maxX = minX;
									minX = self.minX;
								}
								if (minY > maxY) {
									self.minY = maxY;
									self.maxY = maxY = minY;
									minY = self.minY;
								}
								if (rotationMode) {
									self.minRotation = minX;
									self.maxRotation = maxX;
								}
								hasBounds = true;
							}
							if (vars.liveSnap) {
								snap = (vars.liveSnap === true) ? (vars.snap || {}) : vars.liveSnap;
								snapIsRaw = (snap instanceof Array || typeof(snap) === "function");
								if (rotationMode) {
									snapX = buildSnapFunc((snapIsRaw ? snap : snap.rotation), minX, maxX, 1);
									snapY = null;
								} else {
									if (snap.points) {
										snapXY = buildPointSnapFunc((snapIsRaw ? snap : snap.points), minX, maxX, minY, maxY, snap.radius, scrollProxy ? -1 : 1);
									} else {
										if (allowX) {
											snapX = buildSnapFunc((snapIsRaw ? snap : snap.x || snap.left || snap.scrollLeft), minX, maxX, scrollProxy ? -1 : 1);
										}
										if (allowY) {
											snapY = buildSnapFunc((snapIsRaw ? snap : snap.y || snap.top || snap.scrollTop), minY, maxY, scrollProxy ? -1 : 1);
										}
									}
								}
							}
	
						},
	
						onThrowComplete = function() {
							self.isThrowing = false;
							_dispatchEvent(self, "throwcomplete", "onThrowComplete");
						},
						onThrowOverwrite = function() {
							self.isThrowing = false;
						},
	
						animate = function(throwProps, forceZeroVelocity) {
							var snap, snapIsRaw, tween, overshootTolerance;
							if (throwProps && ThrowPropsPlugin) {
								if (throwProps === true) {
									snap = vars.snap || vars.liveSnap || {};
									snapIsRaw = (snap instanceof Array || typeof(snap) === "function");
									throwProps = {resistance:(vars.throwResistance || vars.resistance || 1000) / (rotationMode ? 10 : 1)};
									if (rotationMode) {
										throwProps.rotation = _parseThrowProps(self, snapIsRaw ? snap : snap.rotation, maxX, minX, 1, forceZeroVelocity);
									} else {
										if (allowX) {
											throwProps[xProp] = _parseThrowProps(self, snapIsRaw ? snap : snap.points || snap.x || snap.left || snap.scrollLeft, maxX, minX, scrollProxy ? -1 : 1, forceZeroVelocity || (self.lockedAxis === "x"));
										}
										if (allowY) {
											throwProps[yProp] = _parseThrowProps(self, snapIsRaw ? snap : snap.points || snap.y || snap.top || snap.scrollTop, maxY, minY, scrollProxy ? -1 : 1, forceZeroVelocity || (self.lockedAxis === "y"));
										}
										if (snap.points || (snap instanceof Array && typeof(snap[0]) === "object")) {
											throwProps.linkedProps = xProp + "," + yProp;
											throwProps.radius = snap.radius; //note: we also disable liveSnapping while throwing if there's a "radius" defined, otherwise it looks weird to have the item thrown past a snapping point but live-snapping mid-tween. We do this by altering the onUpdateParams so that "skipSnap" parameter is true for syncXY.
										}
									}
								}
								self.isThrowing = true;
								overshootTolerance = (!isNaN(vars.overshootTolerance)) ? vars.overshootTolerance : (vars.edgeResistance === 1) ? 0 : (1 - self.edgeResistance) + 0.2;
								self.tween = tween = ThrowPropsPlugin.to(scrollProxy || target, {throwProps:throwProps, data:"_draggable", ease:(vars.ease || _globals.Power3.easeOut), onComplete:onThrowComplete, onOverwrite:onThrowOverwrite, onUpdate:(vars.fastMode ? _dispatchEvent : syncXY), onUpdateParams:(vars.fastMode ? [self, "onthrowupdate", "onThrowUpdate"] : (snap && snap.radius) ? [false, true] : _emptyArray)}, (isNaN(vars.maxDuration) ? 2 : vars.maxDuration), (!isNaN(vars.minDuration) ? vars.minDuration : (overshootTolerance === 0 || (typeof(throwProps) === "object" && throwProps.resistance > 1000)) ? 0 : 0.5), overshootTolerance);
								if (!vars.fastMode) {
									//to populate the end values, we just scrub the tween to the end, record the values, and then jump back to the beginning.
									if (scrollProxy) {
										scrollProxy._suspendTransforms = true; //Microsoft browsers have a bug that causes them to briefly render the position incorrectly (it flashes to the end state when we seek() the tween even though we jump right back to the current position, and this only seems to happen when we're affecting both top and left), so we set a _suspendTransforms flag to prevent it from actually applying the values in the ScrollProxy.
									}
									tween.render(tween.duration(), true, true);
									syncXY(true, true);
									self.endX = self.x;
									self.endY = self.y;
									if (rotationMode) {
										self.endRotation = self.x;
									}
									tween.play(0);
									syncXY(true, true);
									if (scrollProxy) {
										scrollProxy._suspendTransforms = false;
									}
								}
							} else if (hasBounds) {
								self.applyBounds();
							}
						},
	
						updateMatrix = function(shiftStart) {
							var start = matrix || [1,0,0,1,0,0],
								a, b, c, d, tx, ty, determinant, pointerX, pointerY;
							matrix = _getConcatenatedMatrix(target.parentNode, true);
							if (shiftStart && self.isPressed && start.join(",") !== matrix.join(",")) { //if the matrix changes WHILE the element is pressed, we must adjust the startPointerX and startPointerY accordingly, so we invert the original matrix and figure out where the pointerX and pointerY were in the global space, then apply the new matrix to get the updated coordinates.
								a = start[0];
								b = start[1];
								c = start[2];
								d = start[3];
								tx = start[4];
								ty = start[5];
								determinant = (a * d - b * c);
								pointerX = startPointerX * (d / determinant) + startPointerY * (-c / determinant) + ((c * ty - d * tx) / determinant);
								pointerY = startPointerX * (-b / determinant) + startPointerY * (a / determinant) + (-(a * ty - b * tx) / determinant);
								startPointerY = pointerX * matrix[1] + pointerY * matrix[3] + matrix[5];
								startPointerX = pointerX * matrix[0] + pointerY * matrix[2] + matrix[4];
							}
							if (!matrix[1] && !matrix[2] && matrix[0] == 1 && matrix[3] == 1 && matrix[4] == 0 && matrix[5] == 0) { //if there are no transforms, we can optimize performance by not factoring in the matrix
								matrix = null;
							}
	
						},
	
						recordStartPositions = function() {
							var edgeTolerance = 1 - self.edgeResistance;
							updateMatrix(false);
							if (matrix) {
								startPointerX = self.pointerX * matrix[0] + self.pointerY * matrix[2] + matrix[4]; //translate to local coordinate system
								startPointerY = self.pointerX * matrix[1] + self.pointerY * matrix[3] + matrix[5];
							}
							if (dirty) {
								setPointerPosition(self.pointerX, self.pointerY);
								render(true);
							}
							if (scrollProxy) {
								calculateBounds();
								startElementY = scrollProxy.top();
								startElementX = scrollProxy.left();
							} else {
								//if the element is in the process of tweening, don't force snapping to occur because it could make it jump. Imagine the user throwing, then before it's done, clicking on the element in its inbetween state.
								if (isTweening()) {
									syncXY(true, true);
									calculateBounds();
								} else {
									self.applyBounds();
								}
								if (rotationMode) {
									rotationOrigin = self.rotationOrigin = _localToGlobal(target, {x:0, y:0});
									syncXY(true, true);
									startElementX = self.x; //starting rotation (x always refers to rotation in type:"rotation", measured in degrees)
									startElementY = self.y = Math.atan2(rotationOrigin.y - self.pointerY, self.pointerX - rotationOrigin.x) * _RAD2DEG;
								} else {
									startScrollTop = target.parentNode ? target.parentNode.scrollTop || 0 : 0;
									startScrollLeft = target.parentNode ? target.parentNode.scrollLeft || 0 : 0;
									startElementY = _getStyle(target, yProp); //record the starting top and left values so that we can just add the mouse's movement to them later.
									startElementX = _getStyle(target, xProp);
								}
							}
							if (hasBounds && edgeTolerance) {
								if (startElementX > maxX) {
									startElementX = maxX + (startElementX - maxX) / edgeTolerance;
								} else if (startElementX < minX) {
									startElementX = minX - (minX - startElementX) / edgeTolerance;
								}
								if (!rotationMode) {
									if (startElementY > maxY) {
										startElementY = maxY + (startElementY - maxY) / edgeTolerance;
									} else if (startElementY < minY) {
										startElementY = minY - (minY - startElementY) / edgeTolerance;
									}
								}
							}
							self.startX = startElementX;
							self.startY = startElementY;
						},
	
						isTweening = function() {
							return (self.tween && self.tween.isActive());
						},
	
						removePlaceholder = function() {
							if (_placeholderDiv.parentNode && !isTweening() && !self.isDragging) { //_placeholderDiv just props open auto-scrolling containers so they don't collapse as the user drags left/up. We remove it after dragging (and throwing, if necessary) finishes.
								_placeholderDiv.parentNode.removeChild(_placeholderDiv);
							}
						},
	
						buildSnapFunc = function(snap, min, max, factor) {
							if (typeof(snap) === "function") {
								return function(n) {
									var edgeTolerance = !self.isPressed ? 1 : 1 - self.edgeResistance; //if we're tweening, disable the edgeTolerance because it's already factored into the tweening values (we don't want to apply it multiple times)
									return snap.call(self, (n > max ? max + (n - max) * edgeTolerance : (n < min) ? min + (n - min) * edgeTolerance : n)) * factor;
								};
							}
							if (snap instanceof Array) {
								return function(n) {
									var i = snap.length,
										closest = 0,
										absDif = _max,
										val, dif;
									while (--i > -1) {
										val = snap[i];
										dif = val - n;
										if (dif < 0) {
											dif = -dif;
										}
										if (dif < absDif && val >= min && val <= max) {
											closest = i;
											absDif = dif;
										}
									}
									return snap[closest];
								};
							}
							return isNaN(snap) ? function(n) { return n; } : function() { return snap * factor; };
						},
	
						buildPointSnapFunc = function(snap, minX, maxX, minY, maxY, radius, factor) {
							radius = (radius && radius < _max) ? radius * radius : _max; //so we don't have to Math.sqrt() in the functions. Performance optimization.
							if (typeof(snap) === "function") {
								return function(point) {
									var edgeTolerance = !self.isPressed ? 1 : 1 - self.edgeResistance,
										x = point.x,
										y = point.y,
										result, dx, dy; //if we're tweening, disable the edgeTolerance because it's already factored into the tweening values (we don't want to apply it multiple times)
									point.x = x = (x > maxX ? maxX + (x - maxX) * edgeTolerance : (x < minX) ? minX + (x - minX) * edgeTolerance : x);
									point.y = y = (y > maxY ? maxY + (y - maxY) * edgeTolerance : (y < minY) ? minY + (y - minY) * edgeTolerance : y);
									result = snap.call(self, point);
									if (result !== point) {
										point.x = result.x;
										point.y = result.y;
									}
									if (factor !== 1) {
										point.x *= factor;
										point.y *= factor;
									}
									if (radius < _max) {
										dx = point.x - x;
										dy = point.y - y;
										if (dx * dx + dy * dy > radius) {
											point.x = x;
											point.y = y;
										}
									}
									return point;
								};
							}
							if (snap instanceof Array) {
								return function(p) {
									var i = snap.length,
										closest = 0,
										minDist = _max,
										x, y, point, dist;
									while (--i > -1) {
										point = snap[i];
										x = point.x - p.x;
										y = point.y - p.y;
										dist = x * x + y * y;
										if (dist < minDist) {
											closest = i;
											minDist = dist;
										}
									}
									return (minDist <= radius) ? snap[closest] : p;
								};
							}
							return function(n) { return n; };
						},
	
						//called when the mouse is pressed (or touch starts)
						onPress = function(e, force) {
							var i;
							if (!enabled || self.isPressed || !e || ((e.type === "mousedown" || e.type === "pointerdown") && !force && _getTime() - clickTime < 30 && _touchEventLookup[self.pointerEvent.type])) { //when we DON'T preventDefault() in order to accommodate touch-scrolling and the user just taps, many browsers also fire a mousedown/mouseup sequence AFTER the touchstart/touchend sequence, thus it'd result in two quick "click" events being dispatched. This line senses that condition and halts it on the subsequent mousedown.
								return;
							}
							interrupted = isTweening();
							self.pointerEvent = e;
							if (_touchEventLookup[e.type]) { //note: on iOS, BOTH touchmove and mousemove are dispatched, but the mousemove has pageY and pageX of 0 which would mess up the calculations and needlessly hurt performance.
								touchEventTarget = (e.type.indexOf("touch") !== -1) ? (e.currentTarget || e.target) : _doc; //pointer-based touches (for Microsoft browsers) don't remain locked to the original target like other browsers, so we must use the document instead. The event type would be "MSPointerDown" or "pointerdown".
								_addListener(touchEventTarget, "touchend", onRelease);
								_addListener(touchEventTarget, "touchmove", onMove);
								_addListener(touchEventTarget, "touchcancel", onRelease);
								_addListener(_doc, "touchstart", _onMultiTouchDocument);
							} else {
								touchEventTarget = null;
								_addListener(_doc, "mousemove", onMove); //attach these to the document instead of the box itself so that if the user's mouse moves too quickly (and off of the box), things still work.
							}
							touchDragAxis = null;
							_addListener(_doc, "mouseup", onRelease);
							if (e && e.target) {
								_addListener(e.target, "mouseup", onRelease); //we also have to listen directly on the element because some browsers don't bubble up the event to the _doc on elements with contentEditable="true"
							}
							isClicking = (isClickable.call(self, e.target) && !vars.dragClickables && !force);
							if (isClicking) {
								_addListener(e.target, "change", onRelease); //in some browsers, when you mousedown on a <select> element, no mouseup gets dispatched! So we listen for a "change" event instead.
								_dispatchEvent(self, "press", "onPress");
								_setSelectable(triggers, true); //accommodates things like inputs and elements with contentEditable="true" (otherwise user couldn't drag to select text)
								return;
							}
							allowNativeTouchScrolling = (!touchEventTarget || allowX === allowY || self.vars.allowNativeTouchScrolling === false || (self.vars.allowContextMenu && e && (e.ctrlKey || e.which > 2))) ? false : allowX ? "y" : "x"; //note: in Chrome, right-clicking (for a context menu) fires onPress and it doesn't have the event.which set properly, so we must look for event.ctrlKey. If the user wants to allow context menus we should of course sense it here and not allow native touch scrolling.
							if (_isOldIE) {
								e = _populateIEEvent(e, true);
							} else if (!allowNativeTouchScrolling && !self.allowEventDefault) {
								e.preventDefault();
								if (e.preventManipulation) {
									e.preventManipulation();  //for some Microsoft browsers
								}
							}
							if (e.changedTouches) { //touch events store the data slightly differently
								e = touch = e.changedTouches[0];
								touchID = e.identifier;
							} else if (e.pointerId) {
								touchID = e.pointerId; //for some Microsoft browsers
							} else {
								touch = touchID = null;
							}
							_dragCount++;
							_addToRenderQueue(render); //causes the Draggable to render on each "tick" of TweenLite.ticker (performance optimization - updating values in a mousemove can cause them to happen too frequently, like multiple times between frame redraws which is wasteful, and it also prevents values from updating properly in IE8)
							startPointerY = self.pointerY = e.pageY; //record the starting x and y so that we can calculate the movement from the original in _onMouseMove
							startPointerX = self.pointerX = e.pageX;
							if (allowNativeTouchScrolling || self.autoScroll) {
								_recordMaxScrolls(target.parentNode);
							}
							if (target.parentNode && self.autoScroll && !scrollProxy && !rotationMode && target.parentNode._gsMaxScrollX && !_placeholderDiv.parentNode && !target.getBBox) { //add a placeholder div to prevent the parent container from collapsing when the user drags the element left.
								_placeholderDiv.style.width = target.parentNode.scrollWidth + "px";
								target.parentNode.appendChild(_placeholderDiv);
							}
							recordStartPositions();
							if (self.tween) {
								self.tween.kill();
							}
							self.isThrowing = false;
							TweenLite.killTweensOf(scrollProxy || target, true, killProps); //in case the user tries to drag it before the last tween is done.
							if (scrollProxy) {
								TweenLite.killTweensOf(target, true, {scrollTo:1}); //just in case the original target's scroll position is being tweened somewhere else.
							}
							self.tween = self.lockedAxis = null;
							if (vars.zIndexBoost || (!rotationMode && !scrollProxy && vars.zIndexBoost !== false)) {
								target.style.zIndex = Draggable.zIndex++;
							}
							self.isPressed = true;
							hasDragCallback = !!(vars.onDrag || self._listeners.drag);
							if (!rotationMode) {
								i = triggers.length;
								while (--i > -1) {
									_setStyle(triggers[i], "cursor", vars.cursor || "move");
								}
							}
							_dispatchEvent(self, "press", "onPress");
						},
	
						//called every time the mouse/touch moves
						onMove = function(e) {
							var originalEvent = e,
								touches, pointerX, pointerY, i, dx, dy;
							if (!enabled || _isMultiTouching || !self.isPressed || !e) {
								return;
							}
							self.pointerEvent = e;
							touches = e.changedTouches;
							if (touches) { //touch events store the data slightly differently
								e = touches[0];
								if (e !== touch && e.identifier !== touchID) { //Usually changedTouches[0] will be what we're looking for, but in case it's not, look through the rest of the array...(and Android browsers don't reuse the event like iOS)
									i = touches.length;
									while (--i > -1 && (e = touches[i]).identifier !== touchID) {}
									if (i < 0) {
										return;
									}
								}
							} else if (e.pointerId && touchID && e.pointerId !== touchID) { //for some Microsoft browsers, we must attach the listener to the doc rather than the trigger so that when the finger moves outside the bounds of the trigger, things still work. So if the event we're receiving has a pointerId that doesn't match the touchID, ignore it (for multi-touch)
								return;
							}
							if (_isOldIE) {
								e = _populateIEEvent(e, true);
							} else {
								if (touchEventTarget && allowNativeTouchScrolling && !touchDragAxis) { //Android browsers force us to decide on the first "touchmove" event if we should allow the default (scrolling) behavior or preventDefault(). Otherwise, a "touchcancel" will be fired and then no "touchmove" or "touchend" will fire during the scrolling (no good).
									pointerX = e.pageX;
									pointerY = e.pageY;
									if (matrix) {
										i = pointerX * matrix[0] + pointerY * matrix[2] + matrix[4];
										pointerY = pointerX * matrix[1] + pointerY * matrix[3] + matrix[5];
										pointerX = i;
									}
									dx = Math.abs(pointerX - startPointerX);
									dy = Math.abs(pointerY - startPointerY);
									if ((dx !== dy && (dx > minimumMovement || dy > minimumMovement)) || (_isAndroid && allowNativeTouchScrolling === touchDragAxis)) {
										touchDragAxis = (dx > dy && allowX) ? "x" : "y";
										if (self.vars.lockAxisOnTouchScroll !== false) {
											self.lockedAxis = (touchDragAxis === "x") ? "y" : "x";
											if (typeof(self.vars.onLockAxis) === "function") {
												self.vars.onLockAxis.call(self, originalEvent);
											}
										}
										if (_isAndroid && allowNativeTouchScrolling === touchDragAxis) {
											onRelease(originalEvent);
											return;
										}
									}
								}
								if (!self.allowEventDefault && (!allowNativeTouchScrolling || (touchDragAxis && allowNativeTouchScrolling !== touchDragAxis)) && originalEvent.cancelable !== false) {
									originalEvent.preventDefault();
									if (originalEvent.preventManipulation) { //for some Microsoft browsers
										originalEvent.preventManipulation();
									}
								}
							}
							if (self.autoScroll) {
								checkAutoScrollBounds = true;
							}
							setPointerPosition(e.pageX, e.pageY);
						},
	
						setPointerPosition = function(pointerX, pointerY) {
							var dragTolerance = 1 - self.dragResistance,
								edgeTolerance = 1 - self.edgeResistance,
								xChange, yChange, x, y, dif, temp;
	
							self.pointerX = pointerX;
							self.pointerY = pointerY;
							if (rotationMode) {
								y = Math.atan2(rotationOrigin.y - pointerY, pointerX - rotationOrigin.x) * _RAD2DEG;
								dif = self.y - y;
								if (dif > 180) {
									startElementY -= 360;
									self.y = y;
								} else if (dif < -180) {
									startElementY += 360;
									self.y = y;
								}
								if (self.x !== startElementX || Math.abs(startElementY - y) > minimumMovement) {
									self.y = y;
									x = startElementX + (startElementY - y) * dragTolerance;
								} else {
									x = startElementX;
								}
	
							} else {
								if (matrix) {
									temp = pointerX * matrix[0] + pointerY * matrix[2] + matrix[4];
									pointerY = pointerX * matrix[1] + pointerY * matrix[3] + matrix[5];
									pointerX = temp;
								}
								yChange = (pointerY - startPointerY);
								xChange = (pointerX - startPointerX);
								if (yChange < minimumMovement && yChange > -minimumMovement) {
									yChange = 0;
								}
								if (xChange < minimumMovement && xChange > -minimumMovement) {
									xChange = 0;
								}
								if ((self.lockAxis || self.lockedAxis) && (xChange || yChange)) {
									temp = self.lockedAxis;
									if (!temp) {
										self.lockedAxis = temp = (allowX && Math.abs(xChange) > Math.abs(yChange)) ? "y" : allowY ? "x" : null;
										if (temp && typeof(self.vars.onLockAxis) === "function") {
											self.vars.onLockAxis.call(self, self.pointerEvent);
										}
									}
									if (temp === "y") {
										yChange = 0;
									} else if (temp === "x") {
										xChange = 0;
									}
								}
								x = startElementX + xChange * dragTolerance;
								y = startElementY + yChange * dragTolerance;
							}
	
							if ((snapX || snapY || snapXY) && (self.x !== x || (self.y !== y && !rotationMode))) {
								if (snapXY) {
									_temp1.x = x;
									_temp1.y = y;
									temp = snapXY(_temp1);
									x = temp.x;
									y = temp.y;
								}
								if (snapX) {
									x = snapX(x);
								}
								if (snapY) {
									y = snapY(y);
								}
							} else if (hasBounds) {
								if (x > maxX) {
									x = maxX + (x - maxX) * edgeTolerance;
								} else if (x < minX) {
									x = minX + (x - minX) * edgeTolerance;
								}
								if (!rotationMode) {
									if (y > maxY) {
										y = maxY + (y - maxY) * edgeTolerance;
									} else if (y < minY) {
										y = minY + (y - minY) * edgeTolerance;
									}
								}
							}
							if (!rotationMode && !matrix) {
								x = Math.round(x); //helps work around an issue with some Win Touch devices
								y = Math.round(y);
							}
							if (self.x !== x || (self.y !== y && !rotationMode)) {
								if (rotationMode) {
									self.endRotation = self.x = self.endX = x;
									dirty = true;
								} else {
									if (allowY) {
										self.y = self.endY = y;
										dirty = true; //a flag that indicates we need to render the target next time the TweenLite.ticker dispatches a "tick" event (typically on a requestAnimationFrame) - this is a performance optimization (we shouldn't render on every move because sometimes many move events can get dispatched between screen refreshes, and that'd be wasteful to render every time)
									}
									if (allowX) {
										self.x = self.endX = x;
										dirty = true;
									}
								}
								if (!self.isDragging && self.isPressed) {
									self.isDragging = true;
									_dispatchEvent(self, "dragstart", "onDragStart");
								}
							}
						},
	
						//called when the mouse/touch is released
						onRelease = function(e, force) {
							if (!enabled || !self.isPressed || (e && touchID != null && !force && ((e.pointerId && e.pointerId !== touchID) || (e.changedTouches && !_hasTouchID(e.changedTouches, touchID))))) {  //for some Microsoft browsers, we must attach the listener to the doc rather than the trigger so that when the finger moves outside the bounds of the trigger, things still work. So if the event we're receiving has a pointerId that doesn't match the touchID, ignore it (for multi-touch)
								return;
							}
							self.isPressed = false;
							var originalEvent = e,
								wasDragging = self.isDragging,
								isContextMenuRelease = (self.vars.allowContextMenu && e && (e.ctrlKey || e.which > 2)),
								placeholderDelayedCall = TweenLite.delayedCall(0.001, removePlaceholder),
								touches, i, syntheticEvent, eventTarget, syntheticClick;
							if (touchEventTarget) {
								_removeListener(touchEventTarget, "touchend", onRelease);
								_removeListener(touchEventTarget, "touchmove", onMove);
								_removeListener(touchEventTarget, "touchcancel", onRelease);
								_removeListener(_doc, "touchstart", _onMultiTouchDocument);
							} else {
								_removeListener(_doc, "mousemove", onMove);
							}
							_removeListener(_doc, "mouseup", onRelease);
							if (e && e.target) {
								_removeListener(e.target, "mouseup", onRelease);
							}
							dirty = false;
							if (isClicking && !isContextMenuRelease) {
								if (e) {
									_removeListener(e.target, "change", onRelease);
									self.pointerEvent = originalEvent;
								}
								_setSelectable(triggers, false);
								_dispatchEvent(self, "release", "onRelease");
								_dispatchEvent(self, "click", "onClick");
								isClicking = false;
								return;
							}
							_removeFromRenderQueue(render);
							if (!rotationMode) {
								i = triggers.length;
								while (--i > -1) {
									_setStyle(triggers[i], "cursor", vars.cursor || "move");
								}
							}
							if (wasDragging) {
								dragEndTime = _lastDragTime = _getTime();
								self.isDragging = false;
							}
							_dragCount--;
							if (e) {
								if (_isOldIE) {
									e = _populateIEEvent(e, false);
								}
								touches = e.changedTouches;
								if (touches) { //touch events store the data slightly differently
									e = touches[0];
									if (e !== touch && e.identifier !== touchID) { //Usually changedTouches[0] will be what we're looking for, but in case it's not, look through the rest of the array...(and Android browsers don't reuse the event like iOS)
										i = touches.length;
										while (--i > -1 && (e = touches[i]).identifier !== touchID) {}
										if (i < 0) {
											return;
										}
									}
								}
								self.pointerEvent = originalEvent;
								self.pointerX = e.pageX;
								self.pointerY = e.pageY;
							}
							if (isContextMenuRelease && originalEvent) {
								originalEvent.preventDefault();
								if (originalEvent.preventManipulation) {
									originalEvent.preventManipulation();  //for some Microsoft browsers
								}
								_dispatchEvent(self, "release", "onRelease");
							} else if (originalEvent && !wasDragging) {
								if (interrupted && (vars.snap || vars.bounds)) { //otherwise, if the user clicks on the object while it's animating to a snapped position, and then releases without moving 3 pixels, it will just stay there (it should animate/snap)
									animate(vars.throwProps);
								}
								_dispatchEvent(self, "release", "onRelease");
								if ((!_isAndroid || originalEvent.type !== "touchmove") && originalEvent.type.indexOf("cancel") === -1) { //to accommodate native scrolling on Android devices, we have to immediately call onRelease() on the first touchmove event, but that shouldn't trigger a "click".
									_dispatchEvent(self, "click", "onClick");
									if (_getTime() - clickTime < 300) {
										_dispatchEvent(self, "doubleclick", "onDoubleClick");
									}
									eventTarget = originalEvent.target || originalEvent.srcElement || target; //old IE uses srcElement
									clickTime = _getTime();
									syntheticClick = function () { // some browsers (like Firefox) won't trust script-generated clicks, so if the user tries to click on a video to play it, for example, it simply won't work. Since a regular "click" event will most likely be generated anyway (one that has its isTrusted flag set to true), we must slightly delay our script-generated click so that the "real"/trusted one is prioritized. Remember, when there are duplicate events in quick succession, we suppress all but the first one. Some browsers don't even trigger the "real" one at all, so our synthetic one is a safety valve that ensures that no matter what, a click event does get dispatched.
										if (clickTime !== clickDispatch && self.enabled() && !self.isPressed) {
											if (eventTarget.click) { //some browsers (like mobile Safari) don't properly trigger the click event
												eventTarget.click();
											} else if (_doc.createEvent) {
												syntheticEvent = _doc.createEvent("MouseEvents");
												syntheticEvent.initMouseEvent("click", true, true, window, 1, self.pointerEvent.screenX, self.pointerEvent.screenY, self.pointerX, self.pointerY, false, false, false, false, 0, null);
												eventTarget.dispatchEvent(syntheticEvent);
											}
										}
									};
									if (!_isAndroid && !originalEvent.defaultPrevented) { //iOS Safari requires the synthetic click to happen immediately or else it simply won't work, but Android doesn't play nice.
										TweenLite.delayedCall(0.00001, syntheticClick); //in addition to the iOS bug workaround, there's a Firefox issue with clicking on things like a video to play, so we must fake a click event in a slightly delayed fashion. Previously, we listened for the "click" event with "capture" false which solved the video-click-to-play issue, but it would allow the "click" event to be dispatched twice like if you were using a jQuery.click() because that was handled in the capture phase, thus we had to switch to the capture phase to avoid the double-dispatching, but do the delayed synthetic click.
									}
								}
							} else {
								animate(vars.throwProps); //will skip if throwProps isn't defined or ThrowPropsPlugin isn't loaded.
								if (!_isOldIE && !self.allowEventDefault && originalEvent && (vars.dragClickables || !isClickable.call(self, originalEvent.target)) && wasDragging && (!allowNativeTouchScrolling || (touchDragAxis && allowNativeTouchScrolling === touchDragAxis)) && originalEvent.cancelable !== false) {
									originalEvent.preventDefault();
									if (originalEvent.preventManipulation) {
										originalEvent.preventManipulation();  //for some Microsoft browsers
									}
								}
								_dispatchEvent(self, "release", "onRelease");
							}
							if (isTweening()) {
								placeholderDelayedCall.duration( self.tween.duration() ); //sync the timing so that the placeholder DIV gets
							}
							if (wasDragging) {
								_dispatchEvent(self, "dragend", "onDragEnd");
							}
							return true;
						},
	
						updateScroll = function(e) {
							if (e && self.isDragging && !scrollProxy) {
								var parent = e.target || e.srcElement || target.parentNode,
									deltaX = parent.scrollLeft - parent._gsScrollX,
									deltaY = parent.scrollTop - parent._gsScrollY;
								if (deltaX || deltaY) {
									if (matrix) {
										startPointerX -= deltaX * matrix[0] + deltaY * matrix[2];
										startPointerY -= deltaY * matrix[3] + deltaX * matrix[1];
									} else {
										startPointerX -= deltaX;
										startPointerY -= deltaY;
									}
									parent._gsScrollX += deltaX;
									parent._gsScrollY += deltaY;
									setPointerPosition(self.pointerX, self.pointerY);
								}
							}
						},
	
						onClick = function(e) { //this was a huge pain in the neck to align all the various browsers and their behaviors. Chrome, Firefox, Safari, Opera, Android, and Microsoft Edge all handle events differently! Some will only trigger native behavior (like checkbox toggling) from trusted events. Others don't even support isTrusted, but require 2 events to flow through before triggering native behavior. Edge treats everything as trusted but also mandates that 2 flow through to trigger the correct native behavior.
							var time = _getTime(),
								recentlyClicked = (time - clickTime < 40),
								recentlyDragged = (time - dragEndTime < 40),
								alreadyDispatched = (recentlyClicked && clickDispatch === clickTime),
								isModern = !!e.preventDefault,
								defaultPrevented = (self.pointerEvent && self.pointerEvent.defaultPrevented),
								alreadyDispatchedTrusted = (recentlyClicked && trustedClickDispatch === clickTime),
								trusted = e.isTrusted || (e.isTrusted == null && recentlyClicked && alreadyDispatched); //note: Safari doesn't support isTrusted, and it won't properly execute native behavior (like toggling checkboxes) on the first synthetic "click" event - we must wait for the 2nd and treat it as trusted (but stop propagation at that point). Confusing, I know. Don't you love cross-browser compatibility challenges?
							if (isModern && (alreadyDispatched || (recentlyDragged && self.vars.suppressClickOnDrag !== false) )) {
								e.stopImmediatePropagation();
							}
							if (recentlyClicked && !(self.pointerEvent && self.pointerEvent.defaultPrevented) && (!alreadyDispatched || (trusted !== alreadyDispatchedTrusted))) { //let the first click pass through unhindered. Let the next one only if it's trusted, then no more (stop quick-succession ones)
								if (trusted && alreadyDispatched) {
									trustedClickDispatch = clickTime;
								}
								clickDispatch = clickTime;
								return;
							}
							if (self.isPressed || recentlyDragged || recentlyClicked) {
								if (!isModern) {
									e.returnValue = false;
								} else if (!trusted || !e.detail || !recentlyClicked || defaultPrevented) {
									e.preventDefault();
									if (e.preventManipulation) {
										e.preventManipulation();  //for some Microsoft browsers
									}
								}
							}
						},
	
						localizePoint = function(p) {
							return matrix ? {x:p.x * matrix[0] + p.y * matrix[2] + matrix[4], y:p.x * matrix[1] + p.y * matrix[3] + matrix[5]} : {x:p.x, y:p.y};
						};
	
					old = Draggable.get(this.target);
					if (old) {
						old.kill(); // avoids duplicates (an element can only be controlled by one Draggable)
					}
	
					//give the user access to start/stop dragging...
					this.startDrag = function(e, align) {
						var r1, r2, p1, p2;
						onPress(e || self.pointerEvent, true);
						//if the pointer isn't on top of the element, adjust things accordingly
						if (align && !self.hitTest(e || self.pointerEvent)) {
							r1 = _parseRect(e || self.pointerEvent);
							r2 = _parseRect(target);
							p1 = localizePoint({x:r1.left + r1.width / 2, y:r1.top + r1.height / 2});
							p2 = localizePoint({x:r2.left + r2.width / 2, y:r2.top + r2.height / 2});
							startPointerX -= p1.x - p2.x;
							startPointerY -= p1.y - p2.y;
						}
						if (!self.isDragging) {
							self.isDragging = true;
							_dispatchEvent(self, "dragstart", "onDragStart");
						}
					};
					this.drag = onMove;
					this.endDrag = function(e) {
						onRelease(e || self.pointerEvent, true);
					};
					this.timeSinceDrag = function() {
						return self.isDragging ? 0 : (_getTime() - dragEndTime) / 1000;
					};
					this.timeSinceClick = function() {
						return (_getTime() - clickTime) / 1000;
					};
					this.hitTest = function(target, threshold) {
						return Draggable.hitTest(self.target, target, threshold);
					};
	
					this.getDirection = function(from, diagonalThreshold) { //from can be "start" (default), "velocity", or an element
						var mode = (from === "velocity" && ThrowPropsPlugin) ? from : (typeof(from) === "object" && !rotationMode) ? "element" : "start",
							xChange, yChange, ratio, direction, r1, r2;
						if (mode === "element") {
							r1 = _parseRect(self.target);
							r2 = _parseRect(from);
						}
						xChange = (mode === "start") ? self.x - startElementX : (mode === "velocity") ? ThrowPropsPlugin.getVelocity(this.target, xProp) : (r1.left + r1.width / 2) - (r2.left + r2.width / 2);
						if (rotationMode) {
							return xChange < 0 ? "counter-clockwise" : "clockwise";
						} else {
							diagonalThreshold = diagonalThreshold || 2;
							yChange = (mode === "start") ? self.y - startElementY : (mode === "velocity") ? ThrowPropsPlugin.getVelocity(this.target, yProp) : (r1.top + r1.height / 2) - (r2.top + r2.height / 2);
							ratio = Math.abs(xChange / yChange);
							direction = (ratio < 1 / diagonalThreshold) ? "" : (xChange < 0) ? "left" : "right";
							if (ratio < diagonalThreshold) {
								if (direction !== "") {
									direction += "-";
								}
								direction += (yChange < 0) ? "up" : "down";
							}
						}
						return direction;
					};
	
	
					this.applyBounds = function(newBounds) {
						var x, y, forceZeroVelocity, e, parent, isRoot;
						if (newBounds && vars.bounds !== newBounds) {
							vars.bounds = newBounds;
							return self.update(true);
						}
						syncXY(true);
						calculateBounds();
						if (hasBounds) {
							x = self.x;
							y = self.y;
							if (x > maxX) {
								x = maxX;
							} else if (x < minX) {
								x = minX;
							}
							if (y > maxY) {
								y = maxY;
							} else if (y < minY) {
								y = minY;
							}
							if (self.x !== x || self.y !== y) {
								forceZeroVelocity = true;
								self.x = self.endX = x;
								if (rotationMode) {
									self.endRotation = x;
								} else {
									self.y = self.endY = y;
								}
								dirty = true;
								render(true);
								if (self.autoScroll && !self.isDragging) {
									_recordMaxScrolls(target.parentNode);
									e = target;
									_windowProxy.scrollTop = ((window.pageYOffset != null) ? window.pageYOffset : (_docElement.scrollTop != null) ? _docElement.scrollTop : _doc.body.scrollTop);
									_windowProxy.scrollLeft = ((window.pageXOffset != null) ? window.pageXOffset : (_docElement.scrollLeft != null) ? _docElement.scrollLeft : _doc.body.scrollLeft);
									while (e && !isRoot) { //walk up the chain and sense wherever the scrollTop/scrollLeft exceeds the maximum.
										isRoot = _isRoot(e.parentNode);
										parent = isRoot ? _windowProxy : e.parentNode;
										if (allowY && parent.scrollTop > parent._gsMaxScrollY) {
											parent.scrollTop = parent._gsMaxScrollY;
										}
										if (allowX && parent.scrollLeft > parent._gsMaxScrollX) {
											parent.scrollLeft = parent._gsMaxScrollX;
										}
										e = parent;
									}
								}
							}
							if (self.isThrowing && (forceZeroVelocity || self.endX > maxX || self.endX < minX || self.endY > maxY || self.endY < minY)) {
								animate(vars.throwProps, forceZeroVelocity);
							}
						}
						return self;
					};
	
					this.update = function(applyBounds, sticky, ignoreExternalChanges) {
						var x = self.x,
							y = self.y;
						updateMatrix(!sticky);
						if (applyBounds) {
							self.applyBounds();
						} else {
							if (dirty && ignoreExternalChanges) {
								render(true);
							}
							syncXY(true);
						}
						if (sticky) {
							setPointerPosition(self.pointerX, self.pointerY);
							if (dirty) {
								render(true);
							}
						}
						if (self.isPressed && !sticky && ((allowX && Math.abs(x - self.x) > 0.01) || (allowY && (Math.abs(y - self.y) > 0.01 && !rotationMode)))) {
							recordStartPositions();
						}
						if (self.autoScroll) {
							_recordMaxScrolls(target.parentNode);
							checkAutoScrollBounds = self.isDragging;
							render(true);
						}
						if (self.autoScroll) { //in case reparenting occurred.
							_removeScrollListener(target, updateScroll);
							_addScrollListener(target, updateScroll);
						}
						return self;
					};
	
					this.enable = function(type) {
						var id, i, trigger;
						if (type !== "soft") {
							i = triggers.length;
							while (--i > -1) {
								trigger = triggers[i];
								_addListener(trigger, "mousedown", onPress);
								_addListener(trigger, "touchstart", onPress);
								_addListener(trigger, "click", onClick, true); //note: used to pass true for capture but it prevented click-to-play-video functionality in Firefox.
								if (!rotationMode) {
									_setStyle(trigger, "cursor", vars.cursor || "move");
								}
								_setStyle(trigger, "touchCallout", "none");
								_setStyle(trigger, "touchAction", (allowX === allowY) ? "none" : allowX ? "pan-y" : "pan-x");
								if (_isSVG(trigger)) { // a bug in chrome doesn't respect touch-action on SVG elements - it only works if we set it on the parent SVG.
									_setStyle(trigger.ownerSVGElement || trigger, "touchAction", (allowX === allowY) ? "none" : allowX ? "pan-y" : "pan-x");
								}
								if (!this.vars.allowContextMenu) {
									_addListener(trigger, "contextmenu", onContextMenu);
								}
							}
							_setSelectable(triggers, false);
						}
						_addScrollListener(target, updateScroll);
						enabled = true;
						if (ThrowPropsPlugin && type !== "soft") {
							ThrowPropsPlugin.track(scrollProxy || target, (xyMode ? "x,y" : rotationMode ? "rotation" : "top,left"));
						}
						if (scrollProxy) {
							scrollProxy.enable();
						}
						target._gsDragID = id = "d" + (_lookupCount++);
						_lookup[id] = this;
						if (scrollProxy) {
							scrollProxy.element._gsDragID = id;
						}
						TweenLite.set(target, {x:"+=0", overwrite:false, data:"_draggable"}); //simply ensures that there's a _gsTransform on the element.
						applyObj = {
							t:target,
							data:_isOldIE ? cssVars : target._gsTransform,
							tween:{},
							setRatio:(_isOldIE ? function() { TweenLite.set(target, tempVars); } : CSSPlugin._internals.setTransformRatio || CSSPlugin._internals.set3DTransformRatio)
						};
						recordStartPositions();
						self.update(true);
						return self;
					};
	
					this.disable = function(type) {
						var dragging = self.isDragging,
							i, trigger;
						if (!rotationMode) {
							i = triggers.length;
							while (--i > -1) {
								_setStyle(triggers[i], "cursor", null);
							}
						}
						if (type !== "soft") {
							i = triggers.length;
							while (--i > -1) {
								trigger = triggers[i];
								_setStyle(trigger, "touchCallout", null);
								_setStyle(trigger, "touchAction", null);
								_removeListener(trigger, "mousedown", onPress);
								_removeListener(trigger, "touchstart", onPress);
								_removeListener(trigger, "click", onClick);
								_removeListener(trigger, "contextmenu", onContextMenu);
							}
							_setSelectable(triggers, true);
							if (touchEventTarget) {
								_removeListener(touchEventTarget, "touchcancel", onRelease);
								_removeListener(touchEventTarget, "touchend", onRelease);
								_removeListener(touchEventTarget, "touchmove", onMove);
							}
							_removeListener(_doc, "mouseup", onRelease);
							_removeListener(_doc, "mousemove", onMove);
						}
						_removeScrollListener(target, updateScroll);
						enabled = false;
						if (ThrowPropsPlugin && type !== "soft") {
							ThrowPropsPlugin.untrack(scrollProxy || target, (xyMode ? "x,y" : rotationMode ? "rotation" : "top,left"));
						}
						if (scrollProxy) {
							scrollProxy.disable();
						}
						_removeFromRenderQueue(render);
						self.isDragging = self.isPressed = isClicking = false;
						if (dragging) {
							_dispatchEvent(self, "dragend", "onDragEnd");
						}
						return self;
					};
	
					this.enabled = function(value, type) {
						return arguments.length ? (value ? self.enable(type) : self.disable(type)) : enabled;
					};
	
					this.kill = function() {
						self.isThrowing = false;
						TweenLite.killTweensOf(scrollProxy || target, true, killProps);
						self.disable();
						delete _lookup[target._gsDragID];
						return self;
					};
	
					if (type.indexOf("scroll") !== -1) {
						scrollProxy = this.scrollProxy = new ScrollProxy(target, _extend({onKill:function() { //ScrollProxy's onKill() gets called if/when the ScrollProxy senses that the user interacted with the scroll position manually (like using the scrollbar). IE9 doesn't fire the "mouseup" properly when users drag the scrollbar of an element, so this works around that issue.
							if (self.isPressed) {
								onRelease(null);
							}}}, vars));
						//a bug in many Android devices' stock browser causes scrollTop to get forced back to 0 after it is altered via JS, so we set overflow to "hidden" on mobile/touch devices (they hide the scroll bar anyway). That works around the bug. (This bug is discussed at https://code.google.com/p/android/issues/detail?id=19625)
						target.style.overflowY = (allowY && !_isTouchDevice) ? "auto" : "hidden";
						target.style.overflowX = (allowX && !_isTouchDevice) ? "auto" : "hidden";
						target = scrollProxy.content;
					}
	
					if (vars.force3D !== false) {
						TweenLite.set(target, {force3D:true}); //improve performance by forcing a GPU layer when possible
					}
					if (rotationMode) {
						killProps.rotation = 1;
					} else {
						if (allowX) {
							killProps[xProp] = 1;
						}
						if (allowY) {
							killProps[yProp] = 1;
						}
					}
					if (rotationMode) {
						tempVars = _tempVarsRotation;
						cssVars = tempVars.css;
						tempVars.overwrite = false;
					} else if (xyMode) {
						tempVars = (allowX && allowY) ? _tempVarsXY : allowX ? _tempVarsX : _tempVarsY;
						cssVars = tempVars.css;
						tempVars.overwrite = false;
					}
	
					this.enable();
				},
				p = Draggable.prototype = new EventDispatcher();
	
			p.constructor = Draggable;
			p.pointerX = p.pointerY = p.startX = p.startY = p.deltaX = p.deltaY = 0;
			p.isDragging = p.isPressed = false;
			Draggable.version = "0.16.3";
			Draggable.zIndex = 1000;
	
			_addListener(_doc, "touchcancel", function() {
				//some older Android devices intermittently stop dispatching "touchmove" events if we don't listen for "touchcancel" on the document. Very strange indeed.
			});
			_addListener(_doc, "contextmenu", function(e) {
				var p;
				for (p in _lookup) {
					if (_lookup[p].isPressed) {
						_lookup[p].endDrag();
					}
				}
			});
	
			Draggable.create = function(targets, vars) {
				if (typeof(targets) === "string") {
					targets = TweenLite.selector(targets);
				}
				var a = (!targets || targets.length === 0) ? [] : _isArrayLike(targets) ? _flattenArray(targets) : [targets],
					i = a.length;
				while (--i > -1) {
					a[i] = new Draggable(a[i], vars);
				}
				return a;
			};
	
			Draggable.get = function(target) {
				return _lookup[(_unwrapElement(target) || {})._gsDragID];
			};
	
			Draggable.timeSinceDrag = function() {
				return (_getTime() - _lastDragTime) / 1000;
			};
	
			var _tempRect = {}, //reuse to reduce garbage collection tasks
				_oldIERect = function(e) { //IE8 doesn't support getBoundingClientRect(), so we use this as a backup.
					var top = 0,
						left = 0,
						width, height;
					e = _unwrapElement(e);
					width = e.offsetWidth;
					height = e.offsetHeight;
					while(e) {
						top += e.offsetTop;
						left += e.offsetLeft;
						e = e.offsetParent;
					}
					return {top: top, left: left, width: width, height: height};
				},
				_parseRect = function(e, undefined) { //accepts a DOM element, a mouse event, or a rectangle object and returns the corresponding rectangle with left, right, width, height, top, and bottom properties
					if (e === window) {
						_tempRect.left = _tempRect.top = 0;
						_tempRect.width = _tempRect.right = _docElement.clientWidth || e.innerWidth || _doc.body.clientWidth || 0;
						_tempRect.height = _tempRect.bottom = ((e.innerHeight || 0) - 20 < _docElement.clientHeight) ? _docElement.clientHeight : e.innerHeight || _doc.body.clientHeight || 0;
						return _tempRect;
					}
					var r = (e.pageX !== undefined) ? {left:e.pageX - _getDocScrollLeft(), top:e.pageY - _getDocScrollTop(), right:e.pageX - _getDocScrollLeft() + 1, bottom:e.pageY - _getDocScrollTop() + 1} : (!e.nodeType && e.left !== undefined && e.top !== undefined) ? e : _isOldIE ? _oldIERect(e) : _unwrapElement(e).getBoundingClientRect();
					if (r.right === undefined && r.width !== undefined) {
						r.right = r.left + r.width;
						r.bottom = r.top + r.height;
					} else if (r.width === undefined) { //some browsers don't include width and height properties. We can't just set them directly on r because some browsers throw errors, so create a new generic object.
						r = {width: r.right - r.left, height: r.bottom - r.top, right: r.right, left: r.left, bottom: r.bottom, top: r.top};
					}
					return r;
				};
	
			Draggable.hitTest = function(obj1, obj2, threshold) {
				if (obj1 === obj2) {
					return false;
				}
				var r1 = _parseRect(obj1),
					r2 = _parseRect(obj2),
					isOutside = (r2.left > r1.right || r2.right < r1.left || r2.top > r1.bottom || r2.bottom < r1.top),
					overlap, area, isRatio;
				if (isOutside || !threshold) {
					return !isOutside;
				}
				isRatio = ((threshold + "").indexOf("%") !== -1);
				threshold = parseFloat(threshold) || 0;
				overlap = {left:Math.max(r1.left, r2.left), top:Math.max(r1.top, r2.top)};
				overlap.width = Math.min(r1.right, r2.right) - overlap.left;
				overlap.height = Math.min(r1.bottom, r2.bottom) - overlap.top;
				if (overlap.width < 0 || overlap.height < 0) {
					return false;
				}
				if (isRatio) {
					threshold *= 0.01;
					area = overlap.width * overlap.height;
					return (area >= r1.width * r1.height * threshold || area >= r2.width * r2.height * threshold);
				}
				return (overlap.width > threshold && overlap.height > threshold);
			};
	
			_placeholderDiv.style.cssText = "visibility:hidden;height:1px;top:-1px;pointer-events:none;position:relative;clear:both;";
	
			return Draggable;
	
		}, true);
	
	}); if (_gsScope._gsDefine) { _gsScope._gsQueue.pop()(); }
	
	//export to AMD/RequireJS and CommonJS/Node (precursor to full modular build system coming at a later date)
	(function(name) {
		"use strict";
		var getGlobal = function() {
			return (_gsScope.GreenSockGlobals || _gsScope)[name];
		};
		if (typeof(module) !== "undefined" && module.exports) { //node
			__webpack_require__(171);
			__webpack_require__(351);
			module.exports = getGlobal();
		} else if (true) { //AMD
			!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(171), __webpack_require__(351)], __WEBPACK_AMD_DEFINE_FACTORY__ = (getGlobal), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		}
	}("Draggable"));
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 837 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	var loopAsync = exports.loopAsync = function loopAsync(turns, work, callback) {
	  var currentTurn = 0,
	      isDone = false;
	  var isSync = false,
	      hasNext = false,
	      doneArgs = void 0;
	
	  var done = function done() {
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    isDone = true;
	
	    if (isSync) {
	      // Iterate instead of recursing if possible.
	      doneArgs = args;
	      return;
	    }
	
	    callback.apply(undefined, args);
	  };
	
	  var next = function next() {
	    if (isDone) return;
	
	    hasNext = true;
	
	    if (isSync) return; // Iterate instead of recursing if possible.
	
	    isSync = true;
	
	    while (!isDone && currentTurn < turns && hasNext) {
	      hasNext = false;
	      work(currentTurn++, next, done);
	    }
	
	    isSync = false;
	
	    if (isDone) {
	      // This means the loop finished synchronously.
	      callback.apply(undefined, doneArgs);
	      return;
	    }
	
	    if (currentTurn >= turns && hasNext) {
	      isDone = true;
	      callback();
	    }
	  };
	
	  next();
	};

/***/ },
/* 838 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.replaceLocation = exports.pushLocation = exports.startListener = exports.getCurrentLocation = exports.go = exports.getUserConfirmation = undefined;
	
	var _BrowserProtocol = __webpack_require__(234);
	
	Object.defineProperty(exports, 'getUserConfirmation', {
	  enumerable: true,
	  get: function get() {
	    return _BrowserProtocol.getUserConfirmation;
	  }
	});
	Object.defineProperty(exports, 'go', {
	  enumerable: true,
	  get: function get() {
	    return _BrowserProtocol.go;
	  }
	});
	
	var _warning = __webpack_require__(101);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _LocationUtils = __webpack_require__(123);
	
	var _DOMUtils = __webpack_require__(173);
	
	var _DOMStateStorage = __webpack_require__(352);
	
	var _PathUtils = __webpack_require__(98);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var HashChangeEvent = 'hashchange';
	
	var getHashPath = function getHashPath() {
	  // We can't use window.location.hash here because it's not
	  // consistent across browsers - Firefox will pre-decode it!
	  var href = window.location.href;
	  var hashIndex = href.indexOf('#');
	  return hashIndex === -1 ? '' : href.substring(hashIndex + 1);
	};
	
	var pushHashPath = function pushHashPath(path) {
	  return window.location.hash = path;
	};
	
	var replaceHashPath = function replaceHashPath(path) {
	  var hashIndex = window.location.href.indexOf('#');
	
	  window.location.replace(window.location.href.slice(0, hashIndex >= 0 ? hashIndex : 0) + '#' + path);
	};
	
	var getCurrentLocation = exports.getCurrentLocation = function getCurrentLocation(pathCoder, queryKey) {
	  var path = pathCoder.decodePath(getHashPath());
	  var key = (0, _PathUtils.getQueryStringValueFromPath)(path, queryKey);
	
	  var state = void 0;
	  if (key) {
	    path = (0, _PathUtils.stripQueryStringValueFromPath)(path, queryKey);
	    state = (0, _DOMStateStorage.readState)(key);
	  }
	
	  var init = (0, _PathUtils.parsePath)(path);
	  init.state = state;
	
	  return (0, _LocationUtils.createLocation)(init, undefined, key);
	};
	
	var prevLocation = void 0;
	
	var startListener = exports.startListener = function startListener(listener, pathCoder, queryKey) {
	  var handleHashChange = function handleHashChange() {
	    var path = getHashPath();
	    var encodedPath = pathCoder.encodePath(path);
	
	    if (path !== encodedPath) {
	      // Always be sure we have a properly-encoded hash.
	      replaceHashPath(encodedPath);
	    } else {
	      var currentLocation = getCurrentLocation(pathCoder, queryKey);
	
	      if (prevLocation && currentLocation.key && prevLocation.key === currentLocation.key) return; // Ignore extraneous hashchange events
	
	      prevLocation = currentLocation;
	
	      listener(currentLocation);
	    }
	  };
	
	  // Ensure the hash is encoded properly.
	  var path = getHashPath();
	  var encodedPath = pathCoder.encodePath(path);
	
	  if (path !== encodedPath) replaceHashPath(encodedPath);
	
	  (0, _DOMUtils.addEventListener)(window, HashChangeEvent, handleHashChange);
	
	  return function () {
	    return (0, _DOMUtils.removeEventListener)(window, HashChangeEvent, handleHashChange);
	  };
	};
	
	var updateLocation = function updateLocation(location, pathCoder, queryKey, updateHash) {
	  var state = location.state,
	      key = location.key;
	
	
	  var path = pathCoder.encodePath((0, _PathUtils.createPath)(location));
	
	  if (state !== undefined) {
	    path = (0, _PathUtils.addQueryStringValueToPath)(path, queryKey, key);
	    (0, _DOMStateStorage.saveState)(key, state);
	  }
	
	  prevLocation = location;
	
	  updateHash(path);
	};
	
	var pushLocation = exports.pushLocation = function pushLocation(location, pathCoder, queryKey) {
	  return updateLocation(location, pathCoder, queryKey, function (path) {
	    if (getHashPath() !== path) {
	      pushHashPath(path);
	    } else {
	       false ? (0, _warning2.default)(false, 'You cannot PUSH the same path using hash history') : void 0;
	    }
	  });
	};
	
	var replaceLocation = exports.replaceLocation = function replaceLocation(location, pathCoder, queryKey) {
	  return updateLocation(location, pathCoder, queryKey, function (path) {
	    if (getHashPath() !== path) replaceHashPath(path);
	  });
	};

/***/ },
/* 839 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.replaceLocation = exports.pushLocation = exports.getCurrentLocation = exports.go = exports.getUserConfirmation = undefined;
	
	var _BrowserProtocol = __webpack_require__(234);
	
	Object.defineProperty(exports, 'getUserConfirmation', {
	  enumerable: true,
	  get: function get() {
	    return _BrowserProtocol.getUserConfirmation;
	  }
	});
	Object.defineProperty(exports, 'go', {
	  enumerable: true,
	  get: function get() {
	    return _BrowserProtocol.go;
	  }
	});
	
	var _LocationUtils = __webpack_require__(123);
	
	var _PathUtils = __webpack_require__(98);
	
	var getCurrentLocation = exports.getCurrentLocation = function getCurrentLocation() {
	  return (0, _LocationUtils.createLocation)(window.location);
	};
	
	var pushLocation = exports.pushLocation = function pushLocation(location) {
	  window.location.href = (0, _PathUtils.createPath)(location);
	  return false; // Don't update location
	};
	
	var replaceLocation = exports.replaceLocation = function replaceLocation(location) {
	  window.location.replace((0, _PathUtils.createPath)(location));
	  return false; // Don't update location
	};

/***/ },
/* 840 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _invariant = __webpack_require__(46);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _ExecutionEnvironment = __webpack_require__(235);
	
	var _BrowserProtocol = __webpack_require__(234);
	
	var BrowserProtocol = _interopRequireWildcard(_BrowserProtocol);
	
	var _RefreshProtocol = __webpack_require__(839);
	
	var RefreshProtocol = _interopRequireWildcard(_RefreshProtocol);
	
	var _DOMUtils = __webpack_require__(173);
	
	var _createHistory = __webpack_require__(236);
	
	var _createHistory2 = _interopRequireDefault(_createHistory);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Creates and returns a history object that uses HTML5's history API
	 * (pushState, replaceState, and the popstate event) to manage history.
	 * This is the recommended method of managing history in browsers because
	 * it provides the cleanest URLs.
	 *
	 * Note: In browsers that do not support the HTML5 history API full
	 * page reloads will be used to preserve clean URLs. You can force this
	 * behavior using { forceRefresh: true } in options.
	 */
	var createBrowserHistory = function createBrowserHistory() {
	  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	  !_ExecutionEnvironment.canUseDOM ?  false ? (0, _invariant2.default)(false, 'Browser history needs a DOM') : (0, _invariant2.default)(false) : void 0;
	
	  var useRefresh = options.forceRefresh || !(0, _DOMUtils.supportsHistory)();
	  var Protocol = useRefresh ? RefreshProtocol : BrowserProtocol;
	
	  var getUserConfirmation = Protocol.getUserConfirmation,
	      getCurrentLocation = Protocol.getCurrentLocation,
	      pushLocation = Protocol.pushLocation,
	      replaceLocation = Protocol.replaceLocation,
	      go = Protocol.go;
	
	
	  var history = (0, _createHistory2.default)(_extends({
	    getUserConfirmation: getUserConfirmation }, options, {
	    getCurrentLocation: getCurrentLocation,
	    pushLocation: pushLocation,
	    replaceLocation: replaceLocation,
	    go: go
	  }));
	
	  var listenerCount = 0,
	      stopListener = void 0;
	
	  var startListener = function startListener(listener, before) {
	    if (++listenerCount === 1) stopListener = BrowserProtocol.startListener(history.transitionTo);
	
	    var unlisten = before ? history.listenBefore(listener) : history.listen(listener);
	
	    return function () {
	      unlisten();
	
	      if (--listenerCount === 0) stopListener();
	    };
	  };
	
	  var listenBefore = function listenBefore(listener) {
	    return startListener(listener, true);
	  };
	
	  var listen = function listen(listener) {
	    return startListener(listener, false);
	  };
	
	  return _extends({}, history, {
	    listenBefore: listenBefore,
	    listen: listen
	  });
	};
	
	exports.default = createBrowserHistory;

/***/ },
/* 841 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _warning = __webpack_require__(101);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _invariant = __webpack_require__(46);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _ExecutionEnvironment = __webpack_require__(235);
	
	var _DOMUtils = __webpack_require__(173);
	
	var _HashProtocol = __webpack_require__(838);
	
	var HashProtocol = _interopRequireWildcard(_HashProtocol);
	
	var _createHistory = __webpack_require__(236);
	
	var _createHistory2 = _interopRequireDefault(_createHistory);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DefaultQueryKey = '_k';
	
	var addLeadingSlash = function addLeadingSlash(path) {
	  return path.charAt(0) === '/' ? path : '/' + path;
	};
	
	var HashPathCoders = {
	  hashbang: {
	    encodePath: function encodePath(path) {
	      return path.charAt(0) === '!' ? path : '!' + path;
	    },
	    decodePath: function decodePath(path) {
	      return path.charAt(0) === '!' ? path.substring(1) : path;
	    }
	  },
	  noslash: {
	    encodePath: function encodePath(path) {
	      return path.charAt(0) === '/' ? path.substring(1) : path;
	    },
	    decodePath: addLeadingSlash
	  },
	  slash: {
	    encodePath: addLeadingSlash,
	    decodePath: addLeadingSlash
	  }
	};
	
	var createHashHistory = function createHashHistory() {
	  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	  !_ExecutionEnvironment.canUseDOM ?  false ? (0, _invariant2.default)(false, 'Hash history needs a DOM') : (0, _invariant2.default)(false) : void 0;
	
	  var queryKey = options.queryKey,
	      hashType = options.hashType;
	
	
	   false ? (0, _warning2.default)(queryKey !== false, 'Using { queryKey: false } no longer works. Instead, just don\'t ' + 'use location state if you don\'t want a key in your URL query string') : void 0;
	
	  if (typeof queryKey !== 'string') queryKey = DefaultQueryKey;
	
	  if (hashType == null) hashType = 'slash';
	
	  if (!(hashType in HashPathCoders)) {
	     false ? (0, _warning2.default)(false, 'Invalid hash type: %s', hashType) : void 0;
	
	    hashType = 'slash';
	  }
	
	  var pathCoder = HashPathCoders[hashType];
	
	  var getUserConfirmation = HashProtocol.getUserConfirmation;
	
	
	  var getCurrentLocation = function getCurrentLocation() {
	    return HashProtocol.getCurrentLocation(pathCoder, queryKey);
	  };
	
	  var pushLocation = function pushLocation(location) {
	    return HashProtocol.pushLocation(location, pathCoder, queryKey);
	  };
	
	  var replaceLocation = function replaceLocation(location) {
	    return HashProtocol.replaceLocation(location, pathCoder, queryKey);
	  };
	
	  var history = (0, _createHistory2.default)(_extends({
	    getUserConfirmation: getUserConfirmation }, options, {
	    getCurrentLocation: getCurrentLocation,
	    pushLocation: pushLocation,
	    replaceLocation: replaceLocation,
	    go: HashProtocol.go
	  }));
	
	  var listenerCount = 0,
	      stopListener = void 0;
	
	  var startListener = function startListener(listener, before) {
	    if (++listenerCount === 1) stopListener = HashProtocol.startListener(history.transitionTo, pathCoder, queryKey);
	
	    var unlisten = before ? history.listenBefore(listener) : history.listen(listener);
	
	    return function () {
	      unlisten();
	
	      if (--listenerCount === 0) stopListener();
	    };
	  };
	
	  var listenBefore = function listenBefore(listener) {
	    return startListener(listener, true);
	  };
	
	  var listen = function listen(listener) {
	    return startListener(listener, false);
	  };
	
	  var goIsSupportedWithoutReload = (0, _DOMUtils.supportsGoWithoutReloadUsingHash)();
	
	  var go = function go(n) {
	     false ? (0, _warning2.default)(goIsSupportedWithoutReload, 'Hash history go(n) causes a full page reload in this browser') : void 0;
	
	    history.go(n);
	  };
	
	  var createHref = function createHref(path) {
	    return '#' + pathCoder.encodePath(history.createHref(path));
	  };
	
	  return _extends({}, history, {
	    listenBefore: listenBefore,
	    listen: listen,
	    go: go,
	    createHref: createHref
	  });
	};
	
	exports.default = createHashHistory;

/***/ },
/* 842 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _warning = __webpack_require__(101);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _invariant = __webpack_require__(46);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _LocationUtils = __webpack_require__(123);
	
	var _PathUtils = __webpack_require__(98);
	
	var _createHistory = __webpack_require__(236);
	
	var _createHistory2 = _interopRequireDefault(_createHistory);
	
	var _Actions = __webpack_require__(172);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var createStateStorage = function createStateStorage(entries) {
	  return entries.filter(function (entry) {
	    return entry.state;
	  }).reduce(function (memo, entry) {
	    memo[entry.key] = entry.state;
	    return memo;
	  }, {});
	};
	
	var createMemoryHistory = function createMemoryHistory() {
	  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	  if (Array.isArray(options)) {
	    options = { entries: options };
	  } else if (typeof options === 'string') {
	    options = { entries: [options] };
	  }
	
	  var getCurrentLocation = function getCurrentLocation() {
	    var entry = entries[current];
	    var path = (0, _PathUtils.createPath)(entry);
	
	    var key = void 0,
	        state = void 0;
	    if (entry.key) {
	      key = entry.key;
	      state = readState(key);
	    }
	
	    var init = (0, _PathUtils.parsePath)(path);
	
	    return (0, _LocationUtils.createLocation)(_extends({}, init, { state: state }), undefined, key);
	  };
	
	  var canGo = function canGo(n) {
	    var index = current + n;
	    return index >= 0 && index < entries.length;
	  };
	
	  var go = function go(n) {
	    if (!n) return;
	
	    if (!canGo(n)) {
	       false ? (0, _warning2.default)(false, 'Cannot go(%s) there is not enough history', n) : void 0;
	
	      return;
	    }
	
	    current += n;
	    var currentLocation = getCurrentLocation();
	
	    // Change action to POP
	    history.transitionTo(_extends({}, currentLocation, { action: _Actions.POP }));
	  };
	
	  var pushLocation = function pushLocation(location) {
	    current += 1;
	
	    if (current < entries.length) entries.splice(current);
	
	    entries.push(location);
	
	    saveState(location.key, location.state);
	  };
	
	  var replaceLocation = function replaceLocation(location) {
	    entries[current] = location;
	    saveState(location.key, location.state);
	  };
	
	  var history = (0, _createHistory2.default)(_extends({}, options, {
	    getCurrentLocation: getCurrentLocation,
	    pushLocation: pushLocation,
	    replaceLocation: replaceLocation,
	    go: go
	  }));
	
	  var _options = options,
	      entries = _options.entries,
	      current = _options.current;
	
	
	  if (typeof entries === 'string') {
	    entries = [entries];
	  } else if (!Array.isArray(entries)) {
	    entries = ['/'];
	  }
	
	  entries = entries.map(function (entry) {
	    return (0, _LocationUtils.createLocation)(entry);
	  });
	
	  if (current == null) {
	    current = entries.length - 1;
	  } else {
	    !(current >= 0 && current < entries.length) ?  false ? (0, _invariant2.default)(false, 'Current index must be >= 0 and < %s, was %s', entries.length, current) : (0, _invariant2.default)(false) : void 0;
	  }
	
	  var storage = createStateStorage(entries);
	
	  var saveState = function saveState(key, state) {
	    return storage[key] = state;
	  };
	
	  var readState = function readState(key) {
	    return storage[key];
	  };
	
	  return _extends({}, history, {
	    canGo: canGo
	  });
	};
	
	exports.default = createMemoryHistory;

/***/ },
/* 843 */
/***/ function(module, exports) {

	exports.read = function (buffer, offset, isLE, mLen, nBytes) {
	  var e, m
	  var eLen = (nBytes * 8) - mLen - 1
	  var eMax = (1 << eLen) - 1
	  var eBias = eMax >> 1
	  var nBits = -7
	  var i = isLE ? (nBytes - 1) : 0
	  var d = isLE ? -1 : 1
	  var s = buffer[offset + i]
	
	  i += d
	
	  e = s & ((1 << (-nBits)) - 1)
	  s >>= (-nBits)
	  nBits += eLen
	  for (; nBits > 0; e = (e * 256) + buffer[offset + i], i += d, nBits -= 8) {}
	
	  m = e & ((1 << (-nBits)) - 1)
	  e >>= (-nBits)
	  nBits += mLen
	  for (; nBits > 0; m = (m * 256) + buffer[offset + i], i += d, nBits -= 8) {}
	
	  if (e === 0) {
	    e = 1 - eBias
	  } else if (e === eMax) {
	    return m ? NaN : ((s ? -1 : 1) * Infinity)
	  } else {
	    m = m + Math.pow(2, mLen)
	    e = e - eBias
	  }
	  return (s ? -1 : 1) * m * Math.pow(2, e - mLen)
	}
	
	exports.write = function (buffer, value, offset, isLE, mLen, nBytes) {
	  var e, m, c
	  var eLen = (nBytes * 8) - mLen - 1
	  var eMax = (1 << eLen) - 1
	  var eBias = eMax >> 1
	  var rt = (mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0)
	  var i = isLE ? 0 : (nBytes - 1)
	  var d = isLE ? 1 : -1
	  var s = value < 0 || (value === 0 && 1 / value < 0) ? 1 : 0
	
	  value = Math.abs(value)
	
	  if (isNaN(value) || value === Infinity) {
	    m = isNaN(value) ? 1 : 0
	    e = eMax
	  } else {
	    e = Math.floor(Math.log(value) / Math.LN2)
	    if (value * (c = Math.pow(2, -e)) < 1) {
	      e--
	      c *= 2
	    }
	    if (e + eBias >= 1) {
	      value += rt / c
	    } else {
	      value += rt * Math.pow(2, 1 - eBias)
	    }
	    if (value * c >= 2) {
	      e++
	      c /= 2
	    }
	
	    if (e + eBias >= eMax) {
	      m = 0
	      e = eMax
	    } else if (e + eBias >= 1) {
	      m = ((value * c) - 1) * Math.pow(2, mLen)
	      e = e + eBias
	    } else {
	      m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen)
	      e = 0
	    }
	  }
	
	  for (; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8) {}
	
	  e = (e << mLen) | m
	  eLen += mLen
	  for (; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8) {}
	
	  buffer[offset + i - d] |= s * 128
	}


/***/ },
/* 844 */
/***/ function(module, exports) {

	'use strict';
	
	var fnToStr = Function.prototype.toString;
	
	var constructorRegex = /^\s*class\b/;
	var isES6ClassFn = function isES6ClassFunction(value) {
		try {
			var fnStr = fnToStr.call(value);
			return constructorRegex.test(fnStr);
		} catch (e) {
			return false; // not a function
		}
	};
	
	var tryFunctionObject = function tryFunctionToStr(value) {
		try {
			if (isES6ClassFn(value)) { return false; }
			fnToStr.call(value);
			return true;
		} catch (e) {
			return false;
		}
	};
	var toStr = Object.prototype.toString;
	var fnClass = '[object Function]';
	var genClass = '[object GeneratorFunction]';
	var hasToStringTag = typeof Symbol === 'function' && typeof Symbol.toStringTag === 'symbol';
	
	module.exports = function isCallable(value) {
		if (!value) { return false; }
		if (typeof value !== 'function' && typeof value !== 'object') { return false; }
		if (typeof value === 'function' && !value.prototype) { return true; }
		if (hasToStringTag) { return tryFunctionObject(value); }
		if (isES6ClassFn(value)) { return false; }
		var strClass = toStr.call(value);
		return strClass === fnClass || strClass === genClass;
	};


/***/ },
/* 845 */
/***/ function(module, exports) {

	module.exports = isFunction
	
	var toString = Object.prototype.toString
	
	function isFunction (fn) {
	  var string = toString.call(fn)
	  return string === '[object Function]' ||
	    (typeof fn === 'function' && string !== '[object RegExp]') ||
	    (typeof window !== 'undefined' &&
	     // IE8 and below
	     (fn === window.setTimeout ||
	      fn === window.alert ||
	      fn === window.confirm ||
	      fn === window.prompt))
	};


/***/ },
/* 846 */
/***/ function(module, exports) {

	var toString = {}.toString;
	
	module.exports = Array.isArray || function (arr) {
	  return toString.call(arr) == '[object Array]';
	};


/***/ },
/* 847 */
/***/ function(module, exports) {

	exports = module.exports = stringify
	exports.getSerialize = serializer
	
	function stringify(obj, replacer, spaces, cycleReplacer) {
	  return JSON.stringify(obj, serializer(replacer, cycleReplacer), spaces)
	}
	
	function serializer(replacer, cycleReplacer) {
	  var stack = [], keys = []
	
	  if (cycleReplacer == null) cycleReplacer = function(key, value) {
	    if (stack[0] === value) return "[Circular ~]"
	    return "[Circular ~." + keys.slice(0, stack.indexOf(value)).join(".") + "]"
	  }
	
	  return function(key, value) {
	    if (stack.length > 0) {
	      var thisPos = stack.indexOf(this)
	      ~thisPos ? stack.splice(thisPos + 1) : stack.push(this)
	      ~thisPos ? keys.splice(thisPos, Infinity, key) : keys.push(key)
	      if (~stack.indexOf(value)) value = cycleReplacer.call(this, key, value)
	    }
	    else stack.push(value)
	
	    return replacer == null ? value : replacer.call(this, key, value)
	  }
	}


/***/ },
/* 848 */
/***/ function(module, exports) {

	
	module.exports = function load (src, opts, cb) {
	  var head = document.head || document.getElementsByTagName('head')[0]
	  var script = document.createElement('script')
	
	  if (typeof opts === 'function') {
	    cb = opts
	    opts = {}
	  }
	
	  opts = opts || {}
	  cb = cb || function() {}
	
	  script.type = opts.type || 'text/javascript'
	  script.charset = opts.charset || 'utf8';
	  script.async = 'async' in opts ? !!opts.async : true
	  script.src = src
	
	  if (opts.attrs) {
	    setAttributes(script, opts.attrs)
	  }
	
	  if (opts.text) {
	    script.text = '' + opts.text
	  }
	
	  var onend = 'onload' in script ? stdOnEnd : ieOnEnd
	  onend(script, cb)
	
	  // some good legacy browsers (firefox) fail the 'in' detection above
	  // so as a fallback we always set onload
	  // old IE will ignore this and new IE will set onload
	  if (!script.onload) {
	    stdOnEnd(script, cb);
	  }
	
	  head.appendChild(script)
	}
	
	function setAttributes(script, attrs) {
	  for (var attr in attrs) {
	    script.setAttribute(attr, attrs[attr]);
	  }
	}
	
	function stdOnEnd (script, cb) {
	  script.onload = function () {
	    this.onerror = this.onload = null
	    cb(null, script)
	  }
	  script.onerror = function () {
	    // this.onload = null here is necessary
	    // because even IE9 works not like others
	    this.onerror = this.onload = null
	    cb(new Error('Failed to load ' + this.src), script)
	  }
	}
	
	function ieOnEnd (script, cb) {
	  script.onreadystatechange = function () {
	    if (this.readyState != 'complete' && this.readyState != 'loaded') return
	    this.onreadystatechange = null
	    cb(null, script) // there is no way to catch loading errors in IE8
	  }
	}


/***/ },
/* 849 */
/***/ function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__(125),
	    root = __webpack_require__(89);
	
	/* Built-in method references that are verified to be native. */
	var DataView = getNative(root, 'DataView');
	
	module.exports = DataView;


/***/ },
/* 850 */
/***/ function(module, exports, __webpack_require__) {

	var hashClear = __webpack_require__(895),
	    hashDelete = __webpack_require__(896),
	    hashGet = __webpack_require__(897),
	    hashHas = __webpack_require__(898),
	    hashSet = __webpack_require__(899);
	
	/**
	 * Creates a hash object.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function Hash(entries) {
	  var index = -1,
	      length = entries == null ? 0 : entries.length;
	
	  this.clear();
	  while (++index < length) {
	    var entry = entries[index];
	    this.set(entry[0], entry[1]);
	  }
	}
	
	// Add methods to `Hash`.
	Hash.prototype.clear = hashClear;
	Hash.prototype['delete'] = hashDelete;
	Hash.prototype.get = hashGet;
	Hash.prototype.has = hashHas;
	Hash.prototype.set = hashSet;
	
	module.exports = Hash;


/***/ },
/* 851 */
/***/ function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__(125),
	    root = __webpack_require__(89);
	
	/* Built-in method references that are verified to be native. */
	var Promise = getNative(root, 'Promise');
	
	module.exports = Promise;


/***/ },
/* 852 */
/***/ function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__(125),
	    root = __webpack_require__(89);
	
	/* Built-in method references that are verified to be native. */
	var Set = getNative(root, 'Set');
	
	module.exports = Set;


/***/ },
/* 853 */
/***/ function(module, exports, __webpack_require__) {

	var MapCache = __webpack_require__(239),
	    setCacheAdd = __webpack_require__(919),
	    setCacheHas = __webpack_require__(920);
	
	/**
	 *
	 * Creates an array cache object to store unique values.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [values] The values to cache.
	 */
	function SetCache(values) {
	  var index = -1,
	      length = values == null ? 0 : values.length;
	
	  this.__data__ = new MapCache;
	  while (++index < length) {
	    this.add(values[index]);
	  }
	}
	
	// Add methods to `SetCache`.
	SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
	SetCache.prototype.has = setCacheHas;
	
	module.exports = SetCache;


/***/ },
/* 854 */
/***/ function(module, exports, __webpack_require__) {

	var root = __webpack_require__(89);
	
	/** Built-in value references. */
	var Uint8Array = root.Uint8Array;
	
	module.exports = Uint8Array;


/***/ },
/* 855 */
/***/ function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__(125),
	    root = __webpack_require__(89);
	
	/* Built-in method references that are verified to be native. */
	var WeakMap = getNative(root, 'WeakMap');
	
	module.exports = WeakMap;


/***/ },
/* 856 */
/***/ function(module, exports) {

	/**
	 * A specialized version of `_.filter` for arrays without support for
	 * iteratee shorthands.
	 *
	 * @private
	 * @param {Array} [array] The array to iterate over.
	 * @param {Function} predicate The function invoked per iteration.
	 * @returns {Array} Returns the new filtered array.
	 */
	function arrayFilter(array, predicate) {
	  var index = -1,
	      length = array == null ? 0 : array.length,
	      resIndex = 0,
	      result = [];
	
	  while (++index < length) {
	    var value = array[index];
	    if (predicate(value, index, array)) {
	      result[resIndex++] = value;
	    }
	  }
	  return result;
	}
	
	module.exports = arrayFilter;


/***/ },
/* 857 */
/***/ function(module, exports, __webpack_require__) {

	var baseTimes = __webpack_require__(877),
	    isArguments = __webpack_require__(368),
	    isArray = __webpack_require__(90),
	    isBuffer = __webpack_require__(369),
	    isIndex = __webpack_require__(242),
	    isTypedArray = __webpack_require__(372);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Creates an array of the enumerable property names of the array-like `value`.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @param {boolean} inherited Specify returning inherited property names.
	 * @returns {Array} Returns the array of property names.
	 */
	function arrayLikeKeys(value, inherited) {
	  var isArr = isArray(value),
	      isArg = !isArr && isArguments(value),
	      isBuff = !isArr && !isArg && isBuffer(value),
	      isType = !isArr && !isArg && !isBuff && isTypedArray(value),
	      skipIndexes = isArr || isArg || isBuff || isType,
	      result = skipIndexes ? baseTimes(value.length, String) : [],
	      length = result.length;
	
	  for (var key in value) {
	    if ((inherited || hasOwnProperty.call(value, key)) &&
	        !(skipIndexes && (
	           // Safari 9 has enumerable `arguments.length` in strict mode.
	           key == 'length' ||
	           // Node.js 0.10 has enumerable non-index properties on buffers.
	           (isBuff && (key == 'offset' || key == 'parent')) ||
	           // PhantomJS 2 has enumerable non-index properties on typed arrays.
	           (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
	           // Skip index properties.
	           isIndex(key, length)
	        ))) {
	      result.push(key);
	    }
	  }
	  return result;
	}
	
	module.exports = arrayLikeKeys;


/***/ },
/* 858 */
/***/ function(module, exports) {

	/**
	 * A specialized version of `_.map` for arrays without support for iteratee
	 * shorthands.
	 *
	 * @private
	 * @param {Array} [array] The array to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Array} Returns the new mapped array.
	 */
	function arrayMap(array, iteratee) {
	  var index = -1,
	      length = array == null ? 0 : array.length,
	      result = Array(length);
	
	  while (++index < length) {
	    result[index] = iteratee(array[index], index, array);
	  }
	  return result;
	}
	
	module.exports = arrayMap;


/***/ },
/* 859 */
/***/ function(module, exports) {

	/**
	 * Appends the elements of `values` to `array`.
	 *
	 * @private
	 * @param {Array} array The array to modify.
	 * @param {Array} values The values to append.
	 * @returns {Array} Returns `array`.
	 */
	function arrayPush(array, values) {
	  var index = -1,
	      length = values.length,
	      offset = array.length;
	
	  while (++index < length) {
	    array[offset + index] = values[index];
	  }
	  return array;
	}
	
	module.exports = arrayPush;


/***/ },
/* 860 */
/***/ function(module, exports, __webpack_require__) {

	var baseForOwn = __webpack_require__(863),
	    createBaseEach = __webpack_require__(882);
	
	/**
	 * The base implementation of `_.forEach` without support for iteratee shorthands.
	 *
	 * @private
	 * @param {Array|Object} collection The collection to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Array|Object} Returns `collection`.
	 */
	var baseEach = createBaseEach(baseForOwn);
	
	module.exports = baseEach;


/***/ },
/* 861 */
/***/ function(module, exports) {

	/**
	 * The base implementation of `_.findIndex` and `_.findLastIndex` without
	 * support for iteratee shorthands.
	 *
	 * @private
	 * @param {Array} array The array to inspect.
	 * @param {Function} predicate The function invoked per iteration.
	 * @param {number} fromIndex The index to search from.
	 * @param {boolean} [fromRight] Specify iterating from right to left.
	 * @returns {number} Returns the index of the matched value, else `-1`.
	 */
	function baseFindIndex(array, predicate, fromIndex, fromRight) {
	  var length = array.length,
	      index = fromIndex + (fromRight ? 1 : -1);
	
	  while ((fromRight ? index-- : ++index < length)) {
	    if (predicate(array[index], index, array)) {
	      return index;
	    }
	  }
	  return -1;
	}
	
	module.exports = baseFindIndex;


/***/ },
/* 862 */
/***/ function(module, exports, __webpack_require__) {

	var createBaseFor = __webpack_require__(883);
	
	/**
	 * The base implementation of `baseForOwn` which iterates over `object`
	 * properties returned by `keysFunc` and invokes `iteratee` for each property.
	 * Iteratee functions may exit iteration early by explicitly returning `false`.
	 *
	 * @private
	 * @param {Object} object The object to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @param {Function} keysFunc The function to get the keys of `object`.
	 * @returns {Object} Returns `object`.
	 */
	var baseFor = createBaseFor();
	
	module.exports = baseFor;


/***/ },
/* 863 */
/***/ function(module, exports, __webpack_require__) {

	var baseFor = __webpack_require__(862),
	    keys = __webpack_require__(182);
	
	/**
	 * The base implementation of `_.forOwn` without support for iteratee shorthands.
	 *
	 * @private
	 * @param {Object} object The object to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Object} Returns `object`.
	 */
	function baseForOwn(object, iteratee) {
	  return object && baseFor(object, iteratee, keys);
	}
	
	module.exports = baseForOwn;


/***/ },
/* 864 */
/***/ function(module, exports, __webpack_require__) {

	var arrayPush = __webpack_require__(859),
	    isArray = __webpack_require__(90);
	
	/**
	 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
	 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
	 * symbols of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {Function} keysFunc The function to get the keys of `object`.
	 * @param {Function} symbolsFunc The function to get the symbols of `object`.
	 * @returns {Array} Returns the array of property names and symbols.
	 */
	function baseGetAllKeys(object, keysFunc, symbolsFunc) {
	  var result = keysFunc(object);
	  return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
	}
	
	module.exports = baseGetAllKeys;


/***/ },
/* 865 */
/***/ function(module, exports) {

	/**
	 * The base implementation of `_.hasIn` without support for deep paths.
	 *
	 * @private
	 * @param {Object} [object] The object to query.
	 * @param {Array|string} key The key to check.
	 * @returns {boolean} Returns `true` if `key` exists, else `false`.
	 */
	function baseHasIn(object, key) {
	  return object != null && key in Object(object);
	}
	
	module.exports = baseHasIn;


/***/ },
/* 866 */
/***/ function(module, exports, __webpack_require__) {

	var baseGetTag = __webpack_require__(124),
	    isObjectLike = __webpack_require__(126);
	
	/** `Object#toString` result references. */
	var argsTag = '[object Arguments]';
	
	/**
	 * The base implementation of `_.isArguments`.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
	 */
	function baseIsArguments(value) {
	  return isObjectLike(value) && baseGetTag(value) == argsTag;
	}
	
	module.exports = baseIsArguments;


/***/ },
/* 867 */
/***/ function(module, exports, __webpack_require__) {

	var Stack = __webpack_require__(357),
	    equalArrays = __webpack_require__(361),
	    equalByTag = __webpack_require__(885),
	    equalObjects = __webpack_require__(886),
	    getTag = __webpack_require__(892),
	    isArray = __webpack_require__(90),
	    isBuffer = __webpack_require__(369),
	    isTypedArray = __webpack_require__(372);
	
	/** Used to compose bitmasks for value comparisons. */
	var COMPARE_PARTIAL_FLAG = 1;
	
	/** `Object#toString` result references. */
	var argsTag = '[object Arguments]',
	    arrayTag = '[object Array]',
	    objectTag = '[object Object]';
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * A specialized version of `baseIsEqual` for arrays and objects which performs
	 * deep comparisons and tracks traversed objects enabling objects with circular
	 * references to be compared.
	 *
	 * @private
	 * @param {Object} object The object to compare.
	 * @param {Object} other The other object to compare.
	 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	 * @param {Function} customizer The function to customize comparisons.
	 * @param {Function} equalFunc The function to determine equivalents of values.
	 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
	 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	 */
	function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
	  var objIsArr = isArray(object),
	      othIsArr = isArray(other),
	      objTag = objIsArr ? arrayTag : getTag(object),
	      othTag = othIsArr ? arrayTag : getTag(other);
	
	  objTag = objTag == argsTag ? objectTag : objTag;
	  othTag = othTag == argsTag ? objectTag : othTag;
	
	  var objIsObj = objTag == objectTag,
	      othIsObj = othTag == objectTag,
	      isSameTag = objTag == othTag;
	
	  if (isSameTag && isBuffer(object)) {
	    if (!isBuffer(other)) {
	      return false;
	    }
	    objIsArr = true;
	    objIsObj = false;
	  }
	  if (isSameTag && !objIsObj) {
	    stack || (stack = new Stack);
	    return (objIsArr || isTypedArray(object))
	      ? equalArrays(object, other, bitmask, customizer, equalFunc, stack)
	      : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
	  }
	  if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
	    var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
	        othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');
	
	    if (objIsWrapped || othIsWrapped) {
	      var objUnwrapped = objIsWrapped ? object.value() : object,
	          othUnwrapped = othIsWrapped ? other.value() : other;
	
	      stack || (stack = new Stack);
	      return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
	    }
	  }
	  if (!isSameTag) {
	    return false;
	  }
	  stack || (stack = new Stack);
	  return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
	}
	
	module.exports = baseIsEqualDeep;


/***/ },
/* 868 */
/***/ function(module, exports, __webpack_require__) {

	var Stack = __webpack_require__(357),
	    baseIsEqual = __webpack_require__(240);
	
	/** Used to compose bitmasks for value comparisons. */
	var COMPARE_PARTIAL_FLAG = 1,
	    COMPARE_UNORDERED_FLAG = 2;
	
	/**
	 * The base implementation of `_.isMatch` without support for iteratee shorthands.
	 *
	 * @private
	 * @param {Object} object The object to inspect.
	 * @param {Object} source The object of property values to match.
	 * @param {Array} matchData The property names, values, and compare flags to match.
	 * @param {Function} [customizer] The function to customize comparisons.
	 * @returns {boolean} Returns `true` if `object` is a match, else `false`.
	 */
	function baseIsMatch(object, source, matchData, customizer) {
	  var index = matchData.length,
	      length = index,
	      noCustomizer = !customizer;
	
	  if (object == null) {
	    return !length;
	  }
	  object = Object(object);
	  while (index--) {
	    var data = matchData[index];
	    if ((noCustomizer && data[2])
	          ? data[1] !== object[data[0]]
	          : !(data[0] in object)
	        ) {
	      return false;
	    }
	  }
	  while (++index < length) {
	    data = matchData[index];
	    var key = data[0],
	        objValue = object[key],
	        srcValue = data[1];
	
	    if (noCustomizer && data[2]) {
	      if (objValue === undefined && !(key in object)) {
	        return false;
	      }
	    } else {
	      var stack = new Stack;
	      if (customizer) {
	        var result = customizer(objValue, srcValue, key, object, source, stack);
	      }
	      if (!(result === undefined
	            ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack)
	            : result
	          )) {
	        return false;
	      }
	    }
	  }
	  return true;
	}
	
	module.exports = baseIsMatch;


/***/ },
/* 869 */
/***/ function(module, exports, __webpack_require__) {

	var isFunction = __webpack_require__(371),
	    isMasked = __webpack_require__(902),
	    isObject = __webpack_require__(142),
	    toSource = __webpack_require__(366);
	
	/**
	 * Used to match `RegExp`
	 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
	 */
	var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
	
	/** Used to detect host constructors (Safari). */
	var reIsHostCtor = /^\[object .+?Constructor\]$/;
	
	/** Used for built-in method references. */
	var funcProto = Function.prototype,
	    objectProto = Object.prototype;
	
	/** Used to resolve the decompiled source of functions. */
	var funcToString = funcProto.toString;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/** Used to detect if a method is native. */
	var reIsNative = RegExp('^' +
	  funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
	  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
	);
	
	/**
	 * The base implementation of `_.isNative` without bad shim checks.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a native function,
	 *  else `false`.
	 */
	function baseIsNative(value) {
	  if (!isObject(value) || isMasked(value)) {
	    return false;
	  }
	  var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
	  return pattern.test(toSource(value));
	}
	
	module.exports = baseIsNative;


/***/ },
/* 870 */
/***/ function(module, exports, __webpack_require__) {

	var baseGetTag = __webpack_require__(124),
	    isLength = __webpack_require__(245),
	    isObjectLike = __webpack_require__(126);
	
	/** `Object#toString` result references. */
	var argsTag = '[object Arguments]',
	    arrayTag = '[object Array]',
	    boolTag = '[object Boolean]',
	    dateTag = '[object Date]',
	    errorTag = '[object Error]',
	    funcTag = '[object Function]',
	    mapTag = '[object Map]',
	    numberTag = '[object Number]',
	    objectTag = '[object Object]',
	    regexpTag = '[object RegExp]',
	    setTag = '[object Set]',
	    stringTag = '[object String]',
	    weakMapTag = '[object WeakMap]';
	
	var arrayBufferTag = '[object ArrayBuffer]',
	    dataViewTag = '[object DataView]',
	    float32Tag = '[object Float32Array]',
	    float64Tag = '[object Float64Array]',
	    int8Tag = '[object Int8Array]',
	    int16Tag = '[object Int16Array]',
	    int32Tag = '[object Int32Array]',
	    uint8Tag = '[object Uint8Array]',
	    uint8ClampedTag = '[object Uint8ClampedArray]',
	    uint16Tag = '[object Uint16Array]',
	    uint32Tag = '[object Uint32Array]';
	
	/** Used to identify `toStringTag` values of typed arrays. */
	var typedArrayTags = {};
	typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
	typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
	typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
	typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
	typedArrayTags[uint32Tag] = true;
	typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
	typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
	typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
	typedArrayTags[errorTag] = typedArrayTags[funcTag] =
	typedArrayTags[mapTag] = typedArrayTags[numberTag] =
	typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
	typedArrayTags[setTag] = typedArrayTags[stringTag] =
	typedArrayTags[weakMapTag] = false;
	
	/**
	 * The base implementation of `_.isTypedArray` without Node.js optimizations.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
	 */
	function baseIsTypedArray(value) {
	  return isObjectLike(value) &&
	    isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
	}
	
	module.exports = baseIsTypedArray;


/***/ },
/* 871 */
/***/ function(module, exports, __webpack_require__) {

	var isPrototype = __webpack_require__(903),
	    nativeKeys = __webpack_require__(916);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 */
	function baseKeys(object) {
	  if (!isPrototype(object)) {
	    return nativeKeys(object);
	  }
	  var result = [];
	  for (var key in Object(object)) {
	    if (hasOwnProperty.call(object, key) && key != 'constructor') {
	      result.push(key);
	    }
	  }
	  return result;
	}
	
	module.exports = baseKeys;


/***/ },
/* 872 */
/***/ function(module, exports, __webpack_require__) {

	var baseIsMatch = __webpack_require__(868),
	    getMatchData = __webpack_require__(888),
	    matchesStrictComparable = __webpack_require__(364);
	
	/**
	 * The base implementation of `_.matches` which doesn't clone `source`.
	 *
	 * @private
	 * @param {Object} source The object of property values to match.
	 * @returns {Function} Returns the new spec function.
	 */
	function baseMatches(source) {
	  var matchData = getMatchData(source);
	  if (matchData.length == 1 && matchData[0][2]) {
	    return matchesStrictComparable(matchData[0][0], matchData[0][1]);
	  }
	  return function(object) {
	    return object === source || baseIsMatch(object, source, matchData);
	  };
	}
	
	module.exports = baseMatches;


/***/ },
/* 873 */
/***/ function(module, exports, __webpack_require__) {

	var baseIsEqual = __webpack_require__(240),
	    get = __webpack_require__(929),
	    hasIn = __webpack_require__(930),
	    isKey = __webpack_require__(243),
	    isStrictComparable = __webpack_require__(363),
	    matchesStrictComparable = __webpack_require__(364),
	    toKey = __webpack_require__(179);
	
	/** Used to compose bitmasks for value comparisons. */
	var COMPARE_PARTIAL_FLAG = 1,
	    COMPARE_UNORDERED_FLAG = 2;
	
	/**
	 * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
	 *
	 * @private
	 * @param {string} path The path of the property to get.
	 * @param {*} srcValue The value to match.
	 * @returns {Function} Returns the new spec function.
	 */
	function baseMatchesProperty(path, srcValue) {
	  if (isKey(path) && isStrictComparable(srcValue)) {
	    return matchesStrictComparable(toKey(path), srcValue);
	  }
	  return function(object) {
	    var objValue = get(object, path);
	    return (objValue === undefined && objValue === srcValue)
	      ? hasIn(object, path)
	      : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
	  };
	}
	
	module.exports = baseMatchesProperty;


/***/ },
/* 874 */
/***/ function(module, exports) {

	/**
	 * The base implementation of `_.property` without support for deep paths.
	 *
	 * @private
	 * @param {string} key The key of the property to get.
	 * @returns {Function} Returns the new accessor function.
	 */
	function baseProperty(key) {
	  return function(object) {
	    return object == null ? undefined : object[key];
	  };
	}
	
	module.exports = baseProperty;


/***/ },
/* 875 */
/***/ function(module, exports, __webpack_require__) {

	var baseGet = __webpack_require__(359);
	
	/**
	 * A specialized version of `baseProperty` which supports deep paths.
	 *
	 * @private
	 * @param {Array|string} path The path of the property to get.
	 * @returns {Function} Returns the new accessor function.
	 */
	function basePropertyDeep(path) {
	  return function(object) {
	    return baseGet(object, path);
	  };
	}
	
	module.exports = basePropertyDeep;


/***/ },
/* 876 */
/***/ function(module, exports, __webpack_require__) {

	var baseEach = __webpack_require__(860);
	
	/**
	 * The base implementation of `_.some` without support for iteratee shorthands.
	 *
	 * @private
	 * @param {Array|Object} collection The collection to iterate over.
	 * @param {Function} predicate The function invoked per iteration.
	 * @returns {boolean} Returns `true` if any element passes the predicate check,
	 *  else `false`.
	 */
	function baseSome(collection, predicate) {
	  var result;
	
	  baseEach(collection, function(value, index, collection) {
	    result = predicate(value, index, collection);
	    return !result;
	  });
	  return !!result;
	}
	
	module.exports = baseSome;


/***/ },
/* 877 */
/***/ function(module, exports) {

	/**
	 * The base implementation of `_.times` without support for iteratee shorthands
	 * or max array length checks.
	 *
	 * @private
	 * @param {number} n The number of times to invoke `iteratee`.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Array} Returns the array of results.
	 */
	function baseTimes(n, iteratee) {
	  var index = -1,
	      result = Array(n);
	
	  while (++index < n) {
	    result[index] = iteratee(index);
	  }
	  return result;
	}
	
	module.exports = baseTimes;


/***/ },
/* 878 */
/***/ function(module, exports, __webpack_require__) {

	var Symbol = __webpack_require__(175),
	    arrayMap = __webpack_require__(858),
	    isArray = __webpack_require__(90),
	    isSymbol = __webpack_require__(181);
	
	/** Used as references for various `Number` constants. */
	var INFINITY = 1 / 0;
	
	/** Used to convert symbols to primitives and strings. */
	var symbolProto = Symbol ? Symbol.prototype : undefined,
	    symbolToString = symbolProto ? symbolProto.toString : undefined;
	
	/**
	 * The base implementation of `_.toString` which doesn't convert nullish
	 * values to empty strings.
	 *
	 * @private
	 * @param {*} value The value to process.
	 * @returns {string} Returns the string.
	 */
	function baseToString(value) {
	  // Exit early for strings to avoid a performance hit in some environments.
	  if (typeof value == 'string') {
	    return value;
	  }
	  if (isArray(value)) {
	    // Recursively convert values (susceptible to call stack limits).
	    return arrayMap(value, baseToString) + '';
	  }
	  if (isSymbol(value)) {
	    return symbolToString ? symbolToString.call(value) : '';
	  }
	  var result = (value + '');
	  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
	}
	
	module.exports = baseToString;


/***/ },
/* 879 */
/***/ function(module, exports) {

	/**
	 * The base implementation of `_.unary` without support for storing metadata.
	 *
	 * @private
	 * @param {Function} func The function to cap arguments for.
	 * @returns {Function} Returns the new capped function.
	 */
	function baseUnary(func) {
	  return function(value) {
	    return func(value);
	  };
	}
	
	module.exports = baseUnary;


/***/ },
/* 880 */
/***/ function(module, exports) {

	/**
	 * Checks if a `cache` value for `key` exists.
	 *
	 * @private
	 * @param {Object} cache The cache to query.
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function cacheHas(cache, key) {
	  return cache.has(key);
	}
	
	module.exports = cacheHas;


/***/ },
/* 881 */
/***/ function(module, exports, __webpack_require__) {

	var root = __webpack_require__(89);
	
	/** Used to detect overreaching core-js shims. */
	var coreJsData = root['__core-js_shared__'];
	
	module.exports = coreJsData;


/***/ },
/* 882 */
/***/ function(module, exports, __webpack_require__) {

	var isArrayLike = __webpack_require__(180);
	
	/**
	 * Creates a `baseEach` or `baseEachRight` function.
	 *
	 * @private
	 * @param {Function} eachFunc The function to iterate over a collection.
	 * @param {boolean} [fromRight] Specify iterating from right to left.
	 * @returns {Function} Returns the new base function.
	 */
	function createBaseEach(eachFunc, fromRight) {
	  return function(collection, iteratee) {
	    if (collection == null) {
	      return collection;
	    }
	    if (!isArrayLike(collection)) {
	      return eachFunc(collection, iteratee);
	    }
	    var length = collection.length,
	        index = fromRight ? length : -1,
	        iterable = Object(collection);
	
	    while ((fromRight ? index-- : ++index < length)) {
	      if (iteratee(iterable[index], index, iterable) === false) {
	        break;
	      }
	    }
	    return collection;
	  };
	}
	
	module.exports = createBaseEach;


/***/ },
/* 883 */
/***/ function(module, exports) {

	/**
	 * Creates a base function for methods like `_.forIn` and `_.forOwn`.
	 *
	 * @private
	 * @param {boolean} [fromRight] Specify iterating from right to left.
	 * @returns {Function} Returns the new base function.
	 */
	function createBaseFor(fromRight) {
	  return function(object, iteratee, keysFunc) {
	    var index = -1,
	        iterable = Object(object),
	        props = keysFunc(object),
	        length = props.length;
	
	    while (length--) {
	      var key = props[fromRight ? length : ++index];
	      if (iteratee(iterable[key], key, iterable) === false) {
	        break;
	      }
	    }
	    return object;
	  };
	}
	
	module.exports = createBaseFor;


/***/ },
/* 884 */
/***/ function(module, exports, __webpack_require__) {

	var baseIteratee = __webpack_require__(241),
	    isArrayLike = __webpack_require__(180),
	    keys = __webpack_require__(182);
	
	/**
	 * Creates a `_.find` or `_.findLast` function.
	 *
	 * @private
	 * @param {Function} findIndexFunc The function to find the collection index.
	 * @returns {Function} Returns the new find function.
	 */
	function createFind(findIndexFunc) {
	  return function(collection, predicate, fromIndex) {
	    var iterable = Object(collection);
	    if (!isArrayLike(collection)) {
	      var iteratee = baseIteratee(predicate, 3);
	      collection = keys(collection);
	      predicate = function(key) { return iteratee(iterable[key], key, iterable); };
	    }
	    var index = findIndexFunc(collection, predicate, fromIndex);
	    return index > -1 ? iterable[iteratee ? collection[index] : index] : undefined;
	  };
	}
	
	module.exports = createFind;


/***/ },
/* 885 */
/***/ function(module, exports, __webpack_require__) {

	var Symbol = __webpack_require__(175),
	    Uint8Array = __webpack_require__(854),
	    eq = __webpack_require__(244),
	    equalArrays = __webpack_require__(361),
	    mapToArray = __webpack_require__(914),
	    setToArray = __webpack_require__(921);
	
	/** Used to compose bitmasks for value comparisons. */
	var COMPARE_PARTIAL_FLAG = 1,
	    COMPARE_UNORDERED_FLAG = 2;
	
	/** `Object#toString` result references. */
	var boolTag = '[object Boolean]',
	    dateTag = '[object Date]',
	    errorTag = '[object Error]',
	    mapTag = '[object Map]',
	    numberTag = '[object Number]',
	    regexpTag = '[object RegExp]',
	    setTag = '[object Set]',
	    stringTag = '[object String]',
	    symbolTag = '[object Symbol]';
	
	var arrayBufferTag = '[object ArrayBuffer]',
	    dataViewTag = '[object DataView]';
	
	/** Used to convert symbols to primitives and strings. */
	var symbolProto = Symbol ? Symbol.prototype : undefined,
	    symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;
	
	/**
	 * A specialized version of `baseIsEqualDeep` for comparing objects of
	 * the same `toStringTag`.
	 *
	 * **Note:** This function only supports comparing values with tags of
	 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
	 *
	 * @private
	 * @param {Object} object The object to compare.
	 * @param {Object} other The other object to compare.
	 * @param {string} tag The `toStringTag` of the objects to compare.
	 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	 * @param {Function} customizer The function to customize comparisons.
	 * @param {Function} equalFunc The function to determine equivalents of values.
	 * @param {Object} stack Tracks traversed `object` and `other` objects.
	 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	 */
	function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
	  switch (tag) {
	    case dataViewTag:
	      if ((object.byteLength != other.byteLength) ||
	          (object.byteOffset != other.byteOffset)) {
	        return false;
	      }
	      object = object.buffer;
	      other = other.buffer;
	
	    case arrayBufferTag:
	      if ((object.byteLength != other.byteLength) ||
	          !equalFunc(new Uint8Array(object), new Uint8Array(other))) {
	        return false;
	      }
	      return true;
	
	    case boolTag:
	    case dateTag:
	    case numberTag:
	      // Coerce booleans to `1` or `0` and dates to milliseconds.
	      // Invalid dates are coerced to `NaN`.
	      return eq(+object, +other);
	
	    case errorTag:
	      return object.name == other.name && object.message == other.message;
	
	    case regexpTag:
	    case stringTag:
	      // Coerce regexes to strings and treat strings, primitives and objects,
	      // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
	      // for more details.
	      return object == (other + '');
	
	    case mapTag:
	      var convert = mapToArray;
	
	    case setTag:
	      var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
	      convert || (convert = setToArray);
	
	      if (object.size != other.size && !isPartial) {
	        return false;
	      }
	      // Assume cyclic values are equal.
	      var stacked = stack.get(object);
	      if (stacked) {
	        return stacked == other;
	      }
	      bitmask |= COMPARE_UNORDERED_FLAG;
	
	      // Recursively compare objects (susceptible to call stack limits).
	      stack.set(object, other);
	      var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
	      stack['delete'](object);
	      return result;
	
	    case symbolTag:
	      if (symbolValueOf) {
	        return symbolValueOf.call(object) == symbolValueOf.call(other);
	      }
	  }
	  return false;
	}
	
	module.exports = equalByTag;


/***/ },
/* 886 */
/***/ function(module, exports, __webpack_require__) {

	var getAllKeys = __webpack_require__(887);
	
	/** Used to compose bitmasks for value comparisons. */
	var COMPARE_PARTIAL_FLAG = 1;
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * A specialized version of `baseIsEqualDeep` for objects with support for
	 * partial deep comparisons.
	 *
	 * @private
	 * @param {Object} object The object to compare.
	 * @param {Object} other The other object to compare.
	 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	 * @param {Function} customizer The function to customize comparisons.
	 * @param {Function} equalFunc The function to determine equivalents of values.
	 * @param {Object} stack Tracks traversed `object` and `other` objects.
	 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	 */
	function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
	  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
	      objProps = getAllKeys(object),
	      objLength = objProps.length,
	      othProps = getAllKeys(other),
	      othLength = othProps.length;
	
	  if (objLength != othLength && !isPartial) {
	    return false;
	  }
	  var index = objLength;
	  while (index--) {
	    var key = objProps[index];
	    if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) {
	      return false;
	    }
	  }
	  // Assume cyclic values are equal.
	  var stacked = stack.get(object);
	  if (stacked && stack.get(other)) {
	    return stacked == other;
	  }
	  var result = true;
	  stack.set(object, other);
	  stack.set(other, object);
	
	  var skipCtor = isPartial;
	  while (++index < objLength) {
	    key = objProps[index];
	    var objValue = object[key],
	        othValue = other[key];
	
	    if (customizer) {
	      var compared = isPartial
	        ? customizer(othValue, objValue, key, other, object, stack)
	        : customizer(objValue, othValue, key, object, other, stack);
	    }
	    // Recursively compare objects (susceptible to call stack limits).
	    if (!(compared === undefined
	          ? (objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack))
	          : compared
	        )) {
	      result = false;
	      break;
	    }
	    skipCtor || (skipCtor = key == 'constructor');
	  }
	  if (result && !skipCtor) {
	    var objCtor = object.constructor,
	        othCtor = other.constructor;
	
	    // Non `Object` object instances with different constructors are not equal.
	    if (objCtor != othCtor &&
	        ('constructor' in object && 'constructor' in other) &&
	        !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
	          typeof othCtor == 'function' && othCtor instanceof othCtor)) {
	      result = false;
	    }
	  }
	  stack['delete'](object);
	  stack['delete'](other);
	  return result;
	}
	
	module.exports = equalObjects;


/***/ },
/* 887 */
/***/ function(module, exports, __webpack_require__) {

	var baseGetAllKeys = __webpack_require__(864),
	    getSymbols = __webpack_require__(891),
	    keys = __webpack_require__(182);
	
	/**
	 * Creates an array of own enumerable property names and symbols of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names and symbols.
	 */
	function getAllKeys(object) {
	  return baseGetAllKeys(object, keys, getSymbols);
	}
	
	module.exports = getAllKeys;


/***/ },
/* 888 */
/***/ function(module, exports, __webpack_require__) {

	var isStrictComparable = __webpack_require__(363),
	    keys = __webpack_require__(182);
	
	/**
	 * Gets the property names, values, and compare flags of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the match data of `object`.
	 */
	function getMatchData(object) {
	  var result = keys(object),
	      length = result.length;
	
	  while (length--) {
	    var key = result[length],
	        value = object[key];
	
	    result[length] = [key, value, isStrictComparable(value)];
	  }
	  return result;
	}
	
	module.exports = getMatchData;


/***/ },
/* 889 */
/***/ function(module, exports, __webpack_require__) {

	var overArg = __webpack_require__(365);
	
	/** Built-in value references. */
	var getPrototype = overArg(Object.getPrototypeOf, Object);
	
	module.exports = getPrototype;


/***/ },
/* 890 */
/***/ function(module, exports, __webpack_require__) {

	var Symbol = __webpack_require__(175);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var nativeObjectToString = objectProto.toString;
	
	/** Built-in value references. */
	var symToStringTag = Symbol ? Symbol.toStringTag : undefined;
	
	/**
	 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @returns {string} Returns the raw `toStringTag`.
	 */
	function getRawTag(value) {
	  var isOwn = hasOwnProperty.call(value, symToStringTag),
	      tag = value[symToStringTag];
	
	  try {
	    value[symToStringTag] = undefined;
	    var unmasked = true;
	  } catch (e) {}
	
	  var result = nativeObjectToString.call(value);
	  if (unmasked) {
	    if (isOwn) {
	      value[symToStringTag] = tag;
	    } else {
	      delete value[symToStringTag];
	    }
	  }
	  return result;
	}
	
	module.exports = getRawTag;


/***/ },
/* 891 */
/***/ function(module, exports, __webpack_require__) {

	var arrayFilter = __webpack_require__(856),
	    stubArray = __webpack_require__(935);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Built-in value references. */
	var propertyIsEnumerable = objectProto.propertyIsEnumerable;
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeGetSymbols = Object.getOwnPropertySymbols;
	
	/**
	 * Creates an array of the own enumerable symbols of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of symbols.
	 */
	var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
	  if (object == null) {
	    return [];
	  }
	  object = Object(object);
	  return arrayFilter(nativeGetSymbols(object), function(symbol) {
	    return propertyIsEnumerable.call(object, symbol);
	  });
	};
	
	module.exports = getSymbols;


/***/ },
/* 892 */
/***/ function(module, exports, __webpack_require__) {

	var DataView = __webpack_require__(849),
	    Map = __webpack_require__(238),
	    Promise = __webpack_require__(851),
	    Set = __webpack_require__(852),
	    WeakMap = __webpack_require__(855),
	    baseGetTag = __webpack_require__(124),
	    toSource = __webpack_require__(366);
	
	/** `Object#toString` result references. */
	var mapTag = '[object Map]',
	    objectTag = '[object Object]',
	    promiseTag = '[object Promise]',
	    setTag = '[object Set]',
	    weakMapTag = '[object WeakMap]';
	
	var dataViewTag = '[object DataView]';
	
	/** Used to detect maps, sets, and weakmaps. */
	var dataViewCtorString = toSource(DataView),
	    mapCtorString = toSource(Map),
	    promiseCtorString = toSource(Promise),
	    setCtorString = toSource(Set),
	    weakMapCtorString = toSource(WeakMap);
	
	/**
	 * Gets the `toStringTag` of `value`.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @returns {string} Returns the `toStringTag`.
	 */
	var getTag = baseGetTag;
	
	// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
	if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
	    (Map && getTag(new Map) != mapTag) ||
	    (Promise && getTag(Promise.resolve()) != promiseTag) ||
	    (Set && getTag(new Set) != setTag) ||
	    (WeakMap && getTag(new WeakMap) != weakMapTag)) {
	  getTag = function(value) {
	    var result = baseGetTag(value),
	        Ctor = result == objectTag ? value.constructor : undefined,
	        ctorString = Ctor ? toSource(Ctor) : '';
	
	    if (ctorString) {
	      switch (ctorString) {
	        case dataViewCtorString: return dataViewTag;
	        case mapCtorString: return mapTag;
	        case promiseCtorString: return promiseTag;
	        case setCtorString: return setTag;
	        case weakMapCtorString: return weakMapTag;
	      }
	    }
	    return result;
	  };
	}
	
	module.exports = getTag;


/***/ },
/* 893 */
/***/ function(module, exports) {

	/**
	 * Gets the value at `key` of `object`.
	 *
	 * @private
	 * @param {Object} [object] The object to query.
	 * @param {string} key The key of the property to get.
	 * @returns {*} Returns the property value.
	 */
	function getValue(object, key) {
	  return object == null ? undefined : object[key];
	}
	
	module.exports = getValue;


/***/ },
/* 894 */
/***/ function(module, exports, __webpack_require__) {

	var castPath = __webpack_require__(360),
	    isArguments = __webpack_require__(368),
	    isArray = __webpack_require__(90),
	    isIndex = __webpack_require__(242),
	    isLength = __webpack_require__(245),
	    toKey = __webpack_require__(179);
	
	/**
	 * Checks if `path` exists on `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {Array|string} path The path to check.
	 * @param {Function} hasFunc The function to check properties.
	 * @returns {boolean} Returns `true` if `path` exists, else `false`.
	 */
	function hasPath(object, path, hasFunc) {
	  path = castPath(path, object);
	
	  var index = -1,
	      length = path.length,
	      result = false;
	
	  while (++index < length) {
	    var key = toKey(path[index]);
	    if (!(result = object != null && hasFunc(object, key))) {
	      break;
	    }
	    object = object[key];
	  }
	  if (result || ++index != length) {
	    return result;
	  }
	  length = object == null ? 0 : object.length;
	  return !!length && isLength(length) && isIndex(key, length) &&
	    (isArray(object) || isArguments(object));
	}
	
	module.exports = hasPath;


/***/ },
/* 895 */
/***/ function(module, exports, __webpack_require__) {

	var nativeCreate = __webpack_require__(178);
	
	/**
	 * Removes all key-value entries from the hash.
	 *
	 * @private
	 * @name clear
	 * @memberOf Hash
	 */
	function hashClear() {
	  this.__data__ = nativeCreate ? nativeCreate(null) : {};
	  this.size = 0;
	}
	
	module.exports = hashClear;


/***/ },
/* 896 */
/***/ function(module, exports) {

	/**
	 * Removes `key` and its value from the hash.
	 *
	 * @private
	 * @name delete
	 * @memberOf Hash
	 * @param {Object} hash The hash to modify.
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function hashDelete(key) {
	  var result = this.has(key) && delete this.__data__[key];
	  this.size -= result ? 1 : 0;
	  return result;
	}
	
	module.exports = hashDelete;


/***/ },
/* 897 */
/***/ function(module, exports, __webpack_require__) {

	var nativeCreate = __webpack_require__(178);
	
	/** Used to stand-in for `undefined` hash values. */
	var HASH_UNDEFINED = '__lodash_hash_undefined__';
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Gets the hash value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf Hash
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function hashGet(key) {
	  var data = this.__data__;
	  if (nativeCreate) {
	    var result = data[key];
	    return result === HASH_UNDEFINED ? undefined : result;
	  }
	  return hasOwnProperty.call(data, key) ? data[key] : undefined;
	}
	
	module.exports = hashGet;


/***/ },
/* 898 */
/***/ function(module, exports, __webpack_require__) {

	var nativeCreate = __webpack_require__(178);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Checks if a hash value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf Hash
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function hashHas(key) {
	  var data = this.__data__;
	  return nativeCreate ? (data[key] !== undefined) : hasOwnProperty.call(data, key);
	}
	
	module.exports = hashHas;


/***/ },
/* 899 */
/***/ function(module, exports, __webpack_require__) {

	var nativeCreate = __webpack_require__(178);
	
	/** Used to stand-in for `undefined` hash values. */
	var HASH_UNDEFINED = '__lodash_hash_undefined__';
	
	/**
	 * Sets the hash `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf Hash
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the hash instance.
	 */
	function hashSet(key, value) {
	  var data = this.__data__;
	  this.size += this.has(key) ? 0 : 1;
	  data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
	  return this;
	}
	
	module.exports = hashSet;


/***/ },
/* 900 */
/***/ function(module, exports, __webpack_require__) {

	var eq = __webpack_require__(244),
	    isArrayLike = __webpack_require__(180),
	    isIndex = __webpack_require__(242),
	    isObject = __webpack_require__(142);
	
	/**
	 * Checks if the given arguments are from an iteratee call.
	 *
	 * @private
	 * @param {*} value The potential iteratee value argument.
	 * @param {*} index The potential iteratee index or key argument.
	 * @param {*} object The potential iteratee object argument.
	 * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
	 *  else `false`.
	 */
	function isIterateeCall(value, index, object) {
	  if (!isObject(object)) {
	    return false;
	  }
	  var type = typeof index;
	  if (type == 'number'
	        ? (isArrayLike(object) && isIndex(index, object.length))
	        : (type == 'string' && index in object)
	      ) {
	    return eq(object[index], value);
	  }
	  return false;
	}
	
	module.exports = isIterateeCall;


/***/ },
/* 901 */
/***/ function(module, exports) {

	/**
	 * Checks if `value` is suitable for use as unique object key.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
	 */
	function isKeyable(value) {
	  var type = typeof value;
	  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
	    ? (value !== '__proto__')
	    : (value === null);
	}
	
	module.exports = isKeyable;


/***/ },
/* 902 */
/***/ function(module, exports, __webpack_require__) {

	var coreJsData = __webpack_require__(881);
	
	/** Used to detect methods masquerading as native. */
	var maskSrcKey = (function() {
	  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
	  return uid ? ('Symbol(src)_1.' + uid) : '';
	}());
	
	/**
	 * Checks if `func` has its source masked.
	 *
	 * @private
	 * @param {Function} func The function to check.
	 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
	 */
	function isMasked(func) {
	  return !!maskSrcKey && (maskSrcKey in func);
	}
	
	module.exports = isMasked;


/***/ },
/* 903 */
/***/ function(module, exports) {

	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/**
	 * Checks if `value` is likely a prototype object.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
	 */
	function isPrototype(value) {
	  var Ctor = value && value.constructor,
	      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;
	
	  return value === proto;
	}
	
	module.exports = isPrototype;


/***/ },
/* 904 */
/***/ function(module, exports) {

	/**
	 * Removes all key-value entries from the list cache.
	 *
	 * @private
	 * @name clear
	 * @memberOf ListCache
	 */
	function listCacheClear() {
	  this.__data__ = [];
	  this.size = 0;
	}
	
	module.exports = listCacheClear;


/***/ },
/* 905 */
/***/ function(module, exports, __webpack_require__) {

	var assocIndexOf = __webpack_require__(176);
	
	/** Used for built-in method references. */
	var arrayProto = Array.prototype;
	
	/** Built-in value references. */
	var splice = arrayProto.splice;
	
	/**
	 * Removes `key` and its value from the list cache.
	 *
	 * @private
	 * @name delete
	 * @memberOf ListCache
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function listCacheDelete(key) {
	  var data = this.__data__,
	      index = assocIndexOf(data, key);
	
	  if (index < 0) {
	    return false;
	  }
	  var lastIndex = data.length - 1;
	  if (index == lastIndex) {
	    data.pop();
	  } else {
	    splice.call(data, index, 1);
	  }
	  --this.size;
	  return true;
	}
	
	module.exports = listCacheDelete;


/***/ },
/* 906 */
/***/ function(module, exports, __webpack_require__) {

	var assocIndexOf = __webpack_require__(176);
	
	/**
	 * Gets the list cache value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf ListCache
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function listCacheGet(key) {
	  var data = this.__data__,
	      index = assocIndexOf(data, key);
	
	  return index < 0 ? undefined : data[index][1];
	}
	
	module.exports = listCacheGet;


/***/ },
/* 907 */
/***/ function(module, exports, __webpack_require__) {

	var assocIndexOf = __webpack_require__(176);
	
	/**
	 * Checks if a list cache value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf ListCache
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function listCacheHas(key) {
	  return assocIndexOf(this.__data__, key) > -1;
	}
	
	module.exports = listCacheHas;


/***/ },
/* 908 */
/***/ function(module, exports, __webpack_require__) {

	var assocIndexOf = __webpack_require__(176);
	
	/**
	 * Sets the list cache `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf ListCache
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the list cache instance.
	 */
	function listCacheSet(key, value) {
	  var data = this.__data__,
	      index = assocIndexOf(data, key);
	
	  if (index < 0) {
	    ++this.size;
	    data.push([key, value]);
	  } else {
	    data[index][1] = value;
	  }
	  return this;
	}
	
	module.exports = listCacheSet;


/***/ },
/* 909 */
/***/ function(module, exports, __webpack_require__) {

	var Hash = __webpack_require__(850),
	    ListCache = __webpack_require__(174),
	    Map = __webpack_require__(238);
	
	/**
	 * Removes all key-value entries from the map.
	 *
	 * @private
	 * @name clear
	 * @memberOf MapCache
	 */
	function mapCacheClear() {
	  this.size = 0;
	  this.__data__ = {
	    'hash': new Hash,
	    'map': new (Map || ListCache),
	    'string': new Hash
	  };
	}
	
	module.exports = mapCacheClear;


/***/ },
/* 910 */
/***/ function(module, exports, __webpack_require__) {

	var getMapData = __webpack_require__(177);
	
	/**
	 * Removes `key` and its value from the map.
	 *
	 * @private
	 * @name delete
	 * @memberOf MapCache
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function mapCacheDelete(key) {
	  var result = getMapData(this, key)['delete'](key);
	  this.size -= result ? 1 : 0;
	  return result;
	}
	
	module.exports = mapCacheDelete;


/***/ },
/* 911 */
/***/ function(module, exports, __webpack_require__) {

	var getMapData = __webpack_require__(177);
	
	/**
	 * Gets the map value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf MapCache
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function mapCacheGet(key) {
	  return getMapData(this, key).get(key);
	}
	
	module.exports = mapCacheGet;


/***/ },
/* 912 */
/***/ function(module, exports, __webpack_require__) {

	var getMapData = __webpack_require__(177);
	
	/**
	 * Checks if a map value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf MapCache
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function mapCacheHas(key) {
	  return getMapData(this, key).has(key);
	}
	
	module.exports = mapCacheHas;


/***/ },
/* 913 */
/***/ function(module, exports, __webpack_require__) {

	var getMapData = __webpack_require__(177);
	
	/**
	 * Sets the map `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf MapCache
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the map cache instance.
	 */
	function mapCacheSet(key, value) {
	  var data = getMapData(this, key),
	      size = data.size;
	
	  data.set(key, value);
	  this.size += data.size == size ? 0 : 1;
	  return this;
	}
	
	module.exports = mapCacheSet;


/***/ },
/* 914 */
/***/ function(module, exports) {

	/**
	 * Converts `map` to its key-value pairs.
	 *
	 * @private
	 * @param {Object} map The map to convert.
	 * @returns {Array} Returns the key-value pairs.
	 */
	function mapToArray(map) {
	  var index = -1,
	      result = Array(map.size);
	
	  map.forEach(function(value, key) {
	    result[++index] = [key, value];
	  });
	  return result;
	}
	
	module.exports = mapToArray;


/***/ },
/* 915 */
/***/ function(module, exports, __webpack_require__) {

	var memoize = __webpack_require__(932);
	
	/** Used as the maximum memoize cache size. */
	var MAX_MEMOIZE_SIZE = 500;
	
	/**
	 * A specialized version of `_.memoize` which clears the memoized function's
	 * cache when it exceeds `MAX_MEMOIZE_SIZE`.
	 *
	 * @private
	 * @param {Function} func The function to have its output memoized.
	 * @returns {Function} Returns the new memoized function.
	 */
	function memoizeCapped(func) {
	  var result = memoize(func, function(key) {
	    if (cache.size === MAX_MEMOIZE_SIZE) {
	      cache.clear();
	    }
	    return key;
	  });
	
	  var cache = result.cache;
	  return result;
	}
	
	module.exports = memoizeCapped;


/***/ },
/* 916 */
/***/ function(module, exports, __webpack_require__) {

	var overArg = __webpack_require__(365);
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeKeys = overArg(Object.keys, Object);
	
	module.exports = nativeKeys;


/***/ },
/* 917 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var freeGlobal = __webpack_require__(362);
	
	/** Detect free variable `exports`. */
	var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;
	
	/** Detect free variable `module`. */
	var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;
	
	/** Detect the popular CommonJS extension `module.exports`. */
	var moduleExports = freeModule && freeModule.exports === freeExports;
	
	/** Detect free variable `process` from Node.js. */
	var freeProcess = moduleExports && freeGlobal.process;
	
	/** Used to access faster Node.js helpers. */
	var nodeUtil = (function() {
	  try {
	    // Use `util.types` for Node.js 10+.
	    var types = freeModule && freeModule.require && freeModule.require('util').types;
	
	    if (types) {
	      return types;
	    }
	
	    // Legacy `process.binding('util')` for Node.js < 10.
	    return freeProcess && freeProcess.binding && freeProcess.binding('util');
	  } catch (e) {}
	}());
	
	module.exports = nodeUtil;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(192)(module)))

/***/ },
/* 918 */
/***/ function(module, exports) {

	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var nativeObjectToString = objectProto.toString;
	
	/**
	 * Converts `value` to a string using `Object.prototype.toString`.
	 *
	 * @private
	 * @param {*} value The value to convert.
	 * @returns {string} Returns the converted string.
	 */
	function objectToString(value) {
	  return nativeObjectToString.call(value);
	}
	
	module.exports = objectToString;


/***/ },
/* 919 */
/***/ function(module, exports) {

	/** Used to stand-in for `undefined` hash values. */
	var HASH_UNDEFINED = '__lodash_hash_undefined__';
	
	/**
	 * Adds `value` to the array cache.
	 *
	 * @private
	 * @name add
	 * @memberOf SetCache
	 * @alias push
	 * @param {*} value The value to cache.
	 * @returns {Object} Returns the cache instance.
	 */
	function setCacheAdd(value) {
	  this.__data__.set(value, HASH_UNDEFINED);
	  return this;
	}
	
	module.exports = setCacheAdd;


/***/ },
/* 920 */
/***/ function(module, exports) {

	/**
	 * Checks if `value` is in the array cache.
	 *
	 * @private
	 * @name has
	 * @memberOf SetCache
	 * @param {*} value The value to search for.
	 * @returns {number} Returns `true` if `value` is found, else `false`.
	 */
	function setCacheHas(value) {
	  return this.__data__.has(value);
	}
	
	module.exports = setCacheHas;


/***/ },
/* 921 */
/***/ function(module, exports) {

	/**
	 * Converts `set` to an array of its values.
	 *
	 * @private
	 * @param {Object} set The set to convert.
	 * @returns {Array} Returns the values.
	 */
	function setToArray(set) {
	  var index = -1,
	      result = Array(set.size);
	
	  set.forEach(function(value) {
	    result[++index] = value;
	  });
	  return result;
	}
	
	module.exports = setToArray;


/***/ },
/* 922 */
/***/ function(module, exports, __webpack_require__) {

	var ListCache = __webpack_require__(174);
	
	/**
	 * Removes all key-value entries from the stack.
	 *
	 * @private
	 * @name clear
	 * @memberOf Stack
	 */
	function stackClear() {
	  this.__data__ = new ListCache;
	  this.size = 0;
	}
	
	module.exports = stackClear;


/***/ },
/* 923 */
/***/ function(module, exports) {

	/**
	 * Removes `key` and its value from the stack.
	 *
	 * @private
	 * @name delete
	 * @memberOf Stack
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function stackDelete(key) {
	  var data = this.__data__,
	      result = data['delete'](key);
	
	  this.size = data.size;
	  return result;
	}
	
	module.exports = stackDelete;


/***/ },
/* 924 */
/***/ function(module, exports) {

	/**
	 * Gets the stack value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf Stack
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function stackGet(key) {
	  return this.__data__.get(key);
	}
	
	module.exports = stackGet;


/***/ },
/* 925 */
/***/ function(module, exports) {

	/**
	 * Checks if a stack value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf Stack
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function stackHas(key) {
	  return this.__data__.has(key);
	}
	
	module.exports = stackHas;


/***/ },
/* 926 */
/***/ function(module, exports, __webpack_require__) {

	var ListCache = __webpack_require__(174),
	    Map = __webpack_require__(238),
	    MapCache = __webpack_require__(239);
	
	/** Used as the size to enable large array optimizations. */
	var LARGE_ARRAY_SIZE = 200;
	
	/**
	 * Sets the stack `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf Stack
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the stack cache instance.
	 */
	function stackSet(key, value) {
	  var data = this.__data__;
	  if (data instanceof ListCache) {
	    var pairs = data.__data__;
	    if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
	      pairs.push([key, value]);
	      this.size = ++data.size;
	      return this;
	    }
	    data = this.__data__ = new MapCache(pairs);
	  }
	  data.set(key, value);
	  this.size = data.size;
	  return this;
	}
	
	module.exports = stackSet;


/***/ },
/* 927 */
/***/ function(module, exports, __webpack_require__) {

	var memoizeCapped = __webpack_require__(915);
	
	/** Used to match property names within property paths. */
	var rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
	
	/** Used to match backslashes in property paths. */
	var reEscapeChar = /\\(\\)?/g;
	
	/**
	 * Converts `string` to a property path array.
	 *
	 * @private
	 * @param {string} string The string to convert.
	 * @returns {Array} Returns the property path array.
	 */
	var stringToPath = memoizeCapped(function(string) {
	  var result = [];
	  if (string.charCodeAt(0) === 46 /* . */) {
	    result.push('');
	  }
	  string.replace(rePropName, function(match, number, quote, subString) {
	    result.push(quote ? subString.replace(reEscapeChar, '$1') : (number || match));
	  });
	  return result;
	});
	
	module.exports = stringToPath;


/***/ },
/* 928 */
/***/ function(module, exports, __webpack_require__) {

	var baseFindIndex = __webpack_require__(861),
	    baseIteratee = __webpack_require__(241),
	    toInteger = __webpack_require__(938);
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeMax = Math.max;
	
	/**
	 * This method is like `_.find` except that it returns the index of the first
	 * element `predicate` returns truthy for instead of the element itself.
	 *
	 * @static
	 * @memberOf _
	 * @since 1.1.0
	 * @category Array
	 * @param {Array} array The array to inspect.
	 * @param {Function} [predicate=_.identity] The function invoked per iteration.
	 * @param {number} [fromIndex=0] The index to search from.
	 * @returns {number} Returns the index of the found element, else `-1`.
	 * @example
	 *
	 * var users = [
	 *   { 'user': 'barney',  'active': false },
	 *   { 'user': 'fred',    'active': false },
	 *   { 'user': 'pebbles', 'active': true }
	 * ];
	 *
	 * _.findIndex(users, function(o) { return o.user == 'barney'; });
	 * // => 0
	 *
	 * // The `_.matches` iteratee shorthand.
	 * _.findIndex(users, { 'user': 'fred', 'active': false });
	 * // => 1
	 *
	 * // The `_.matchesProperty` iteratee shorthand.
	 * _.findIndex(users, ['active', false]);
	 * // => 0
	 *
	 * // The `_.property` iteratee shorthand.
	 * _.findIndex(users, 'active');
	 * // => 2
	 */
	function findIndex(array, predicate, fromIndex) {
	  var length = array == null ? 0 : array.length;
	  if (!length) {
	    return -1;
	  }
	  var index = fromIndex == null ? 0 : toInteger(fromIndex);
	  if (index < 0) {
	    index = nativeMax(length + index, 0);
	  }
	  return baseFindIndex(array, baseIteratee(predicate, 3), index);
	}
	
	module.exports = findIndex;


/***/ },
/* 929 */
/***/ function(module, exports, __webpack_require__) {

	var baseGet = __webpack_require__(359);
	
	/**
	 * Gets the value at `path` of `object`. If the resolved value is
	 * `undefined`, the `defaultValue` is returned in its place.
	 *
	 * @static
	 * @memberOf _
	 * @since 3.7.0
	 * @category Object
	 * @param {Object} object The object to query.
	 * @param {Array|string} path The path of the property to get.
	 * @param {*} [defaultValue] The value returned for `undefined` resolved values.
	 * @returns {*} Returns the resolved value.
	 * @example
	 *
	 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
	 *
	 * _.get(object, 'a[0].b.c');
	 * // => 3
	 *
	 * _.get(object, ['a', '0', 'b', 'c']);
	 * // => 3
	 *
	 * _.get(object, 'a.b.c', 'default');
	 * // => 'default'
	 */
	function get(object, path, defaultValue) {
	  var result = object == null ? undefined : baseGet(object, path);
	  return result === undefined ? defaultValue : result;
	}
	
	module.exports = get;


/***/ },
/* 930 */
/***/ function(module, exports, __webpack_require__) {

	var baseHasIn = __webpack_require__(865),
	    hasPath = __webpack_require__(894);
	
	/**
	 * Checks if `path` is a direct or inherited property of `object`.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Object
	 * @param {Object} object The object to query.
	 * @param {Array|string} path The path to check.
	 * @returns {boolean} Returns `true` if `path` exists, else `false`.
	 * @example
	 *
	 * var object = _.create({ 'a': _.create({ 'b': 2 }) });
	 *
	 * _.hasIn(object, 'a');
	 * // => true
	 *
	 * _.hasIn(object, 'a.b');
	 * // => true
	 *
	 * _.hasIn(object, ['a', 'b']);
	 * // => true
	 *
	 * _.hasIn(object, 'b');
	 * // => false
	 */
	function hasIn(object, path) {
	  return object != null && hasPath(object, path, baseHasIn);
	}
	
	module.exports = hasIn;


/***/ },
/* 931 */
/***/ function(module, exports) {

	/**
	 * This method returns the first argument it receives.
	 *
	 * @static
	 * @since 0.1.0
	 * @memberOf _
	 * @category Util
	 * @param {*} value Any value.
	 * @returns {*} Returns `value`.
	 * @example
	 *
	 * var object = { 'a': 1 };
	 *
	 * console.log(_.identity(object) === object);
	 * // => true
	 */
	function identity(value) {
	  return value;
	}
	
	module.exports = identity;


/***/ },
/* 932 */
/***/ function(module, exports, __webpack_require__) {

	var MapCache = __webpack_require__(239);
	
	/** Error message constants. */
	var FUNC_ERROR_TEXT = 'Expected a function';
	
	/**
	 * Creates a function that memoizes the result of `func`. If `resolver` is
	 * provided, it determines the cache key for storing the result based on the
	 * arguments provided to the memoized function. By default, the first argument
	 * provided to the memoized function is used as the map cache key. The `func`
	 * is invoked with the `this` binding of the memoized function.
	 *
	 * **Note:** The cache is exposed as the `cache` property on the memoized
	 * function. Its creation may be customized by replacing the `_.memoize.Cache`
	 * constructor with one whose instances implement the
	 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
	 * method interface of `clear`, `delete`, `get`, `has`, and `set`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Function
	 * @param {Function} func The function to have its output memoized.
	 * @param {Function} [resolver] The function to resolve the cache key.
	 * @returns {Function} Returns the new memoized function.
	 * @example
	 *
	 * var object = { 'a': 1, 'b': 2 };
	 * var other = { 'c': 3, 'd': 4 };
	 *
	 * var values = _.memoize(_.values);
	 * values(object);
	 * // => [1, 2]
	 *
	 * values(other);
	 * // => [3, 4]
	 *
	 * object.a = 2;
	 * values(object);
	 * // => [1, 2]
	 *
	 * // Modify the result cache.
	 * values.cache.set(object, ['a', 'b']);
	 * values(object);
	 * // => ['a', 'b']
	 *
	 * // Replace `_.memoize.Cache`.
	 * _.memoize.Cache = WeakMap;
	 */
	function memoize(func, resolver) {
	  if (typeof func != 'function' || (resolver != null && typeof resolver != 'function')) {
	    throw new TypeError(FUNC_ERROR_TEXT);
	  }
	  var memoized = function() {
	    var args = arguments,
	        key = resolver ? resolver.apply(this, args) : args[0],
	        cache = memoized.cache;
	
	    if (cache.has(key)) {
	      return cache.get(key);
	    }
	    var result = func.apply(this, args);
	    memoized.cache = cache.set(key, result) || cache;
	    return result;
	  };
	  memoized.cache = new (memoize.Cache || MapCache);
	  return memoized;
	}
	
	// Expose `MapCache`.
	memoize.Cache = MapCache;
	
	module.exports = memoize;


/***/ },
/* 933 */
/***/ function(module, exports, __webpack_require__) {

	var baseProperty = __webpack_require__(874),
	    basePropertyDeep = __webpack_require__(875),
	    isKey = __webpack_require__(243),
	    toKey = __webpack_require__(179);
	
	/**
	 * Creates a function that returns the value at `path` of a given object.
	 *
	 * @static
	 * @memberOf _
	 * @since 2.4.0
	 * @category Util
	 * @param {Array|string} path The path of the property to get.
	 * @returns {Function} Returns the new accessor function.
	 * @example
	 *
	 * var objects = [
	 *   { 'a': { 'b': 2 } },
	 *   { 'a': { 'b': 1 } }
	 * ];
	 *
	 * _.map(objects, _.property('a.b'));
	 * // => [2, 1]
	 *
	 * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
	 * // => [1, 2]
	 */
	function property(path) {
	  return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
	}
	
	module.exports = property;


/***/ },
/* 934 */
/***/ function(module, exports, __webpack_require__) {

	var arraySome = __webpack_require__(358),
	    baseIteratee = __webpack_require__(241),
	    baseSome = __webpack_require__(876),
	    isArray = __webpack_require__(90),
	    isIterateeCall = __webpack_require__(900);
	
	/**
	 * Checks if `predicate` returns truthy for **any** element of `collection`.
	 * Iteration is stopped once `predicate` returns truthy. The predicate is
	 * invoked with three arguments: (value, index|key, collection).
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Collection
	 * @param {Array|Object} collection The collection to iterate over.
	 * @param {Function} [predicate=_.identity] The function invoked per iteration.
	 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	 * @returns {boolean} Returns `true` if any element passes the predicate check,
	 *  else `false`.
	 * @example
	 *
	 * _.some([null, 0, 'yes', false], Boolean);
	 * // => true
	 *
	 * var users = [
	 *   { 'user': 'barney', 'active': true },
	 *   { 'user': 'fred',   'active': false }
	 * ];
	 *
	 * // The `_.matches` iteratee shorthand.
	 * _.some(users, { 'user': 'barney', 'active': false });
	 * // => false
	 *
	 * // The `_.matchesProperty` iteratee shorthand.
	 * _.some(users, ['active', false]);
	 * // => true
	 *
	 * // The `_.property` iteratee shorthand.
	 * _.some(users, 'active');
	 * // => true
	 */
	function some(collection, predicate, guard) {
	  var func = isArray(collection) ? arraySome : baseSome;
	  if (guard && isIterateeCall(collection, predicate, guard)) {
	    predicate = undefined;
	  }
	  return func(collection, baseIteratee(predicate, 3));
	}
	
	module.exports = some;


/***/ },
/* 935 */
/***/ function(module, exports) {

	/**
	 * This method returns a new empty array.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.13.0
	 * @category Util
	 * @returns {Array} Returns the new empty array.
	 * @example
	 *
	 * var arrays = _.times(2, _.stubArray);
	 *
	 * console.log(arrays);
	 * // => [[], []]
	 *
	 * console.log(arrays[0] === arrays[1]);
	 * // => false
	 */
	function stubArray() {
	  return [];
	}
	
	module.exports = stubArray;


/***/ },
/* 936 */
/***/ function(module, exports) {

	/**
	 * This method returns `false`.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.13.0
	 * @category Util
	 * @returns {boolean} Returns `false`.
	 * @example
	 *
	 * _.times(2, _.stubFalse);
	 * // => [false, false]
	 */
	function stubFalse() {
	  return false;
	}
	
	module.exports = stubFalse;


/***/ },
/* 937 */
/***/ function(module, exports, __webpack_require__) {

	var toNumber = __webpack_require__(939);
	
	/** Used as references for various `Number` constants. */
	var INFINITY = 1 / 0,
	    MAX_INTEGER = 1.7976931348623157e+308;
	
	/**
	 * Converts `value` to a finite number.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.12.0
	 * @category Lang
	 * @param {*} value The value to convert.
	 * @returns {number} Returns the converted number.
	 * @example
	 *
	 * _.toFinite(3.2);
	 * // => 3.2
	 *
	 * _.toFinite(Number.MIN_VALUE);
	 * // => 5e-324
	 *
	 * _.toFinite(Infinity);
	 * // => 1.7976931348623157e+308
	 *
	 * _.toFinite('3.2');
	 * // => 3.2
	 */
	function toFinite(value) {
	  if (!value) {
	    return value === 0 ? value : 0;
	  }
	  value = toNumber(value);
	  if (value === INFINITY || value === -INFINITY) {
	    var sign = (value < 0 ? -1 : 1);
	    return sign * MAX_INTEGER;
	  }
	  return value === value ? value : 0;
	}
	
	module.exports = toFinite;


/***/ },
/* 938 */
/***/ function(module, exports, __webpack_require__) {

	var toFinite = __webpack_require__(937);
	
	/**
	 * Converts `value` to an integer.
	 *
	 * **Note:** This method is loosely based on
	 * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to convert.
	 * @returns {number} Returns the converted integer.
	 * @example
	 *
	 * _.toInteger(3.2);
	 * // => 3
	 *
	 * _.toInteger(Number.MIN_VALUE);
	 * // => 0
	 *
	 * _.toInteger(Infinity);
	 * // => 1.7976931348623157e+308
	 *
	 * _.toInteger('3.2');
	 * // => 3
	 */
	function toInteger(value) {
	  var result = toFinite(value),
	      remainder = result % 1;
	
	  return result === result ? (remainder ? result - remainder : result) : 0;
	}
	
	module.exports = toInteger;


/***/ },
/* 939 */
/***/ function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(142),
	    isSymbol = __webpack_require__(181);
	
	/** Used as references for various `Number` constants. */
	var NAN = 0 / 0;
	
	/** Used to match leading and trailing whitespace. */
	var reTrim = /^\s+|\s+$/g;
	
	/** Used to detect bad signed hexadecimal string values. */
	var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
	
	/** Used to detect binary string values. */
	var reIsBinary = /^0b[01]+$/i;
	
	/** Used to detect octal string values. */
	var reIsOctal = /^0o[0-7]+$/i;
	
	/** Built-in method references without a dependency on `root`. */
	var freeParseInt = parseInt;
	
	/**
	 * Converts `value` to a number.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to process.
	 * @returns {number} Returns the number.
	 * @example
	 *
	 * _.toNumber(3.2);
	 * // => 3.2
	 *
	 * _.toNumber(Number.MIN_VALUE);
	 * // => 5e-324
	 *
	 * _.toNumber(Infinity);
	 * // => Infinity
	 *
	 * _.toNumber('3.2');
	 * // => 3.2
	 */
	function toNumber(value) {
	  if (typeof value == 'number') {
	    return value;
	  }
	  if (isSymbol(value)) {
	    return NAN;
	  }
	  if (isObject(value)) {
	    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
	    value = isObject(other) ? (other + '') : other;
	  }
	  if (typeof value != 'string') {
	    return value === 0 ? value : +value;
	  }
	  value = value.replace(reTrim, '');
	  var isBinary = reIsBinary.test(value);
	  return (isBinary || reIsOctal.test(value))
	    ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
	    : (reIsBadHex.test(value) ? NAN : +value);
	}
	
	module.exports = toNumber;


/***/ },
/* 940 */
/***/ function(module, exports, __webpack_require__) {

	var baseToString = __webpack_require__(878);
	
	/**
	 * Converts `value` to a string. An empty string is returned for `null`
	 * and `undefined` values. The sign of `-0` is preserved.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to convert.
	 * @returns {string} Returns the converted string.
	 * @example
	 *
	 * _.toString(null);
	 * // => ''
	 *
	 * _.toString(-0);
	 * // => '-0'
	 *
	 * _.toString([1, 2, 3]);
	 * // => '1,2,3'
	 */
	function toString(value) {
	  return value == null ? '' : baseToString(value);
	}
	
	module.exports = toString;


/***/ },
/* 941 */
/***/ function(module, exports) {

	'use strict';
	
	var classCallCheck = function (instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	};
	
	
	
	
	
	
	
	
	
	var _extends = Object.assign || function (target) {
	  for (var i = 1; i < arguments.length; i++) {
	    var source = arguments[i];
	
	    for (var key in source) {
	      if (Object.prototype.hasOwnProperty.call(source, key)) {
	        target[key] = source[key];
	      }
	    }
	  }
	
	  return target;
	};
	
	
	
	var inherits = function (subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
	  }
	
	  subClass.prototype = Object.create(superClass && superClass.prototype, {
	    constructor: {
	      value: subClass,
	      enumerable: false,
	      writable: true,
	      configurable: true
	    }
	  });
	  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
	};
	
	
	
	
	
	
	
	
	
	
	
	var possibleConstructorReturn = function (self, call) {
	  if (!self) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }
	
	  return call && (typeof call === "object" || typeof call === "function") ? call : self;
	};
	
	/**
	 * @file stream.js
	 */
	/**
	 * A lightweight readable stream implemention that handles event dispatching.
	 *
	 * @class Stream
	 */
	var Stream = function () {
	  function Stream() {
	    classCallCheck(this, Stream);
	
	    this.listeners = {};
	  }
	
	  /**
	   * Add a listener for a specified event type.
	   *
	   * @param {String} type the event name
	   * @param {Function} listener the callback to be invoked when an event of
	   * the specified type occurs
	   */
	
	
	  Stream.prototype.on = function on(type, listener) {
	    if (!this.listeners[type]) {
	      this.listeners[type] = [];
	    }
	    this.listeners[type].push(listener);
	  };
	
	  /**
	   * Remove a listener for a specified event type.
	   *
	   * @param {String} type the event name
	   * @param {Function} listener  a function previously registered for this
	   * type of event through `on`
	   * @return {Boolean} if we could turn it off or not
	   */
	
	
	  Stream.prototype.off = function off(type, listener) {
	    if (!this.listeners[type]) {
	      return false;
	    }
	
	    var index = this.listeners[type].indexOf(listener);
	
	    this.listeners[type].splice(index, 1);
	    return index > -1;
	  };
	
	  /**
	   * Trigger an event of the specified type on this stream. Any additional
	   * arguments to this function are passed as parameters to event listeners.
	   *
	   * @param {String} type the event name
	   */
	
	
	  Stream.prototype.trigger = function trigger(type) {
	    var callbacks = this.listeners[type];
	    var i = void 0;
	    var length = void 0;
	    var args = void 0;
	
	    if (!callbacks) {
	      return;
	    }
	    // Slicing the arguments on every invocation of this method
	    // can add a significant amount of overhead. Avoid the
	    // intermediate object creation for the common case of a
	    // single callback argument
	    if (arguments.length === 2) {
	      length = callbacks.length;
	      for (i = 0; i < length; ++i) {
	        callbacks[i].call(this, arguments[1]);
	      }
	    } else {
	      args = Array.prototype.slice.call(arguments, 1);
	      length = callbacks.length;
	      for (i = 0; i < length; ++i) {
	        callbacks[i].apply(this, args);
	      }
	    }
	  };
	
	  /**
	   * Destroys the stream and cleans up.
	   */
	
	
	  Stream.prototype.dispose = function dispose() {
	    this.listeners = {};
	  };
	  /**
	   * Forwards all `data` events on this stream to the destination stream. The
	   * destination stream should provide a method `push` to receive the data
	   * events as they arrive.
	   *
	   * @param {Stream} destination the stream that will receive all `data` events
	   * @see http://nodejs.org/api/stream.html#stream_readable_pipe_destination_options
	   */
	
	
	  Stream.prototype.pipe = function pipe(destination) {
	    this.on('data', function (data) {
	      destination.push(data);
	    });
	  };
	
	  return Stream;
	}();
	
	/**
	 * @file m3u8/line-stream.js
	 */
	/**
	 * A stream that buffers string input and generates a `data` event for each
	 * line.
	 *
	 * @class LineStream
	 * @extends Stream
	 */
	
	var LineStream = function (_Stream) {
	  inherits(LineStream, _Stream);
	
	  function LineStream() {
	    classCallCheck(this, LineStream);
	
	    var _this = possibleConstructorReturn(this, _Stream.call(this));
	
	    _this.buffer = '';
	    return _this;
	  }
	
	  /**
	   * Add new data to be parsed.
	   *
	   * @param {String} data the text to process
	   */
	
	
	  LineStream.prototype.push = function push(data) {
	    var nextNewline = void 0;
	
	    this.buffer += data;
	    nextNewline = this.buffer.indexOf('\n');
	
	    for (; nextNewline > -1; nextNewline = this.buffer.indexOf('\n')) {
	      this.trigger('data', this.buffer.substring(0, nextNewline));
	      this.buffer = this.buffer.substring(nextNewline + 1);
	    }
	  };
	
	  return LineStream;
	}(Stream);
	
	/**
	 * @file m3u8/parse-stream.js
	 */
	/**
	 * "forgiving" attribute list psuedo-grammar:
	 * attributes -> keyvalue (',' keyvalue)*
	 * keyvalue   -> key '=' value
	 * key        -> [^=]*
	 * value      -> '"' [^"]* '"' | [^,]*
	 */
	var attributeSeparator = function attributeSeparator() {
	  var key = '[^=]*';
	  var value = '"[^"]*"|[^,]*';
	  var keyvalue = '(?:' + key + ')=(?:' + value + ')';
	
	  return new RegExp('(?:^|,)(' + keyvalue + ')');
	};
	
	/**
	 * Parse attributes from a line given the seperator
	 *
	 * @param {String} attributes the attibute line to parse
	 */
	var parseAttributes = function parseAttributes(attributes) {
	  // split the string using attributes as the separator
	  var attrs = attributes.split(attributeSeparator());
	  var result = {};
	  var i = attrs.length;
	  var attr = void 0;
	
	  while (i--) {
	    // filter out unmatched portions of the string
	    if (attrs[i] === '') {
	      continue;
	    }
	
	    // split the key and value
	    attr = /([^=]*)=(.*)/.exec(attrs[i]).slice(1);
	    // trim whitespace and remove optional quotes around the value
	    attr[0] = attr[0].replace(/^\s+|\s+$/g, '');
	    attr[1] = attr[1].replace(/^\s+|\s+$/g, '');
	    attr[1] = attr[1].replace(/^['"](.*)['"]$/g, '$1');
	    result[attr[0]] = attr[1];
	  }
	  return result;
	};
	
	/**
	 * A line-level M3U8 parser event stream. It expects to receive input one
	 * line at a time and performs a context-free parse of its contents. A stream
	 * interpretation of a manifest can be useful if the manifest is expected to
	 * be too large to fit comfortably into memory or the entirety of the input
	 * is not immediately available. Otherwise, it's probably much easier to work
	 * with a regular `Parser` object.
	 *
	 * Produces `data` events with an object that captures the parser's
	 * interpretation of the input. That object has a property `tag` that is one
	 * of `uri`, `comment`, or `tag`. URIs only have a single additional
	 * property, `line`, which captures the entirety of the input without
	 * interpretation. Comments similarly have a single additional property
	 * `text` which is the input without the leading `#`.
	 *
	 * Tags always have a property `tagType` which is the lower-cased version of
	 * the M3U8 directive without the `#EXT` or `#EXT-X-` prefix. For instance,
	 * `#EXT-X-MEDIA-SEQUENCE` becomes `media-sequence` when parsed. Unrecognized
	 * tags are given the tag type `unknown` and a single additional property
	 * `data` with the remainder of the input.
	 *
	 * @class ParseStream
	 * @extends Stream
	 */
	
	var ParseStream = function (_Stream) {
	  inherits(ParseStream, _Stream);
	
	  function ParseStream() {
	    classCallCheck(this, ParseStream);
	
	    var _this = possibleConstructorReturn(this, _Stream.call(this));
	
	    _this.customParsers = [];
	    return _this;
	  }
	
	  /**
	   * Parses an additional line of input.
	   *
	   * @param {String} line a single line of an M3U8 file to parse
	   */
	
	
	  ParseStream.prototype.push = function push(line) {
	    var match = void 0;
	    var event = void 0;
	
	    // strip whitespace
	    line = line.replace(/^[\u0000\s]+|[\u0000\s]+$/g, '');
	    if (line.length === 0) {
	      // ignore empty lines
	      return;
	    }
	
	    // URIs
	    if (line[0] !== '#') {
	      this.trigger('data', {
	        type: 'uri',
	        uri: line
	      });
	      return;
	    }
	
	    for (var i = 0; i < this.customParsers.length; i++) {
	      if (this.customParsers[i].call(this, line)) {
	        return;
	      }
	    }
	
	    // Comments
	    if (line.indexOf('#EXT') !== 0) {
	      this.trigger('data', {
	        type: 'comment',
	        text: line.slice(1)
	      });
	      return;
	    }
	
	    // strip off any carriage returns here so the regex matching
	    // doesn't have to account for them.
	    line = line.replace('\r', '');
	
	    // Tags
	    match = /^#EXTM3U/.exec(line);
	    if (match) {
	      this.trigger('data', {
	        type: 'tag',
	        tagType: 'm3u'
	      });
	      return;
	    }
	    match = /^#EXTINF:?([0-9\.]*)?,?(.*)?$/.exec(line);
	    if (match) {
	      event = {
	        type: 'tag',
	        tagType: 'inf'
	      };
	      if (match[1]) {
	        event.duration = parseFloat(match[1]);
	      }
	      if (match[2]) {
	        event.title = match[2];
	      }
	      this.trigger('data', event);
	      return;
	    }
	    match = /^#EXT-X-TARGETDURATION:?([0-9.]*)?/.exec(line);
	    if (match) {
	      event = {
	        type: 'tag',
	        tagType: 'targetduration'
	      };
	      if (match[1]) {
	        event.duration = parseInt(match[1], 10);
	      }
	      this.trigger('data', event);
	      return;
	    }
	    match = /^#ZEN-TOTAL-DURATION:?([0-9.]*)?/.exec(line);
	    if (match) {
	      event = {
	        type: 'tag',
	        tagType: 'totalduration'
	      };
	      if (match[1]) {
	        event.duration = parseInt(match[1], 10);
	      }
	      this.trigger('data', event);
	      return;
	    }
	    match = /^#EXT-X-VERSION:?([0-9.]*)?/.exec(line);
	    if (match) {
	      event = {
	        type: 'tag',
	        tagType: 'version'
	      };
	      if (match[1]) {
	        event.version = parseInt(match[1], 10);
	      }
	      this.trigger('data', event);
	      return;
	    }
	    match = /^#EXT-X-MEDIA-SEQUENCE:?(\-?[0-9.]*)?/.exec(line);
	    if (match) {
	      event = {
	        type: 'tag',
	        tagType: 'media-sequence'
	      };
	      if (match[1]) {
	        event.number = parseInt(match[1], 10);
	      }
	      this.trigger('data', event);
	      return;
	    }
	    match = /^#EXT-X-DISCONTINUITY-SEQUENCE:?(\-?[0-9.]*)?/.exec(line);
	    if (match) {
	      event = {
	        type: 'tag',
	        tagType: 'discontinuity-sequence'
	      };
	      if (match[1]) {
	        event.number = parseInt(match[1], 10);
	      }
	      this.trigger('data', event);
	      return;
	    }
	    match = /^#EXT-X-PLAYLIST-TYPE:?(.*)?$/.exec(line);
	    if (match) {
	      event = {
	        type: 'tag',
	        tagType: 'playlist-type'
	      };
	      if (match[1]) {
	        event.playlistType = match[1];
	      }
	      this.trigger('data', event);
	      return;
	    }
	    match = /^#EXT-X-BYTERANGE:?([0-9.]*)?@?([0-9.]*)?/.exec(line);
	    if (match) {
	      event = {
	        type: 'tag',
	        tagType: 'byterange'
	      };
	      if (match[1]) {
	        event.length = parseInt(match[1], 10);
	      }
	      if (match[2]) {
	        event.offset = parseInt(match[2], 10);
	      }
	      this.trigger('data', event);
	      return;
	    }
	    match = /^#EXT-X-ALLOW-CACHE:?(YES|NO)?/.exec(line);
	    if (match) {
	      event = {
	        type: 'tag',
	        tagType: 'allow-cache'
	      };
	      if (match[1]) {
	        event.allowed = !/NO/.test(match[1]);
	      }
	      this.trigger('data', event);
	      return;
	    }
	    match = /^#EXT-X-MAP:?(.*)$/.exec(line);
	    if (match) {
	      event = {
	        type: 'tag',
	        tagType: 'map'
	      };
	
	      if (match[1]) {
	        var attributes = parseAttributes(match[1]);
	
	        if (attributes.URI) {
	          event.uri = attributes.URI;
	        }
	        if (attributes.BYTERANGE) {
	          var _attributes$BYTERANGE = attributes.BYTERANGE.split('@'),
	              length = _attributes$BYTERANGE[0],
	              offset = _attributes$BYTERANGE[1];
	
	          event.byterange = {};
	          if (length) {
	            event.byterange.length = parseInt(length, 10);
	          }
	          if (offset) {
	            event.byterange.offset = parseInt(offset, 10);
	          }
	        }
	      }
	
	      this.trigger('data', event);
	      return;
	    }
	    match = /^#EXT-X-STREAM-INF:?(.*)$/.exec(line);
	    if (match) {
	      event = {
	        type: 'tag',
	        tagType: 'stream-inf'
	      };
	      if (match[1]) {
	        event.attributes = parseAttributes(match[1]);
	
	        if (event.attributes.RESOLUTION) {
	          var split = event.attributes.RESOLUTION.split('x');
	          var resolution = {};
	
	          if (split[0]) {
	            resolution.width = parseInt(split[0], 10);
	          }
	          if (split[1]) {
	            resolution.height = parseInt(split[1], 10);
	          }
	          event.attributes.RESOLUTION = resolution;
	        }
	        if (event.attributes.BANDWIDTH) {
	          event.attributes.BANDWIDTH = parseInt(event.attributes.BANDWIDTH, 10);
	        }
	        if (event.attributes['PROGRAM-ID']) {
	          event.attributes['PROGRAM-ID'] = parseInt(event.attributes['PROGRAM-ID'], 10);
	        }
	      }
	      this.trigger('data', event);
	      return;
	    }
	    match = /^#EXT-X-MEDIA:?(.*)$/.exec(line);
	    if (match) {
	      event = {
	        type: 'tag',
	        tagType: 'media'
	      };
	      if (match[1]) {
	        event.attributes = parseAttributes(match[1]);
	      }
	      this.trigger('data', event);
	      return;
	    }
	    match = /^#EXT-X-ENDLIST/.exec(line);
	    if (match) {
	      this.trigger('data', {
	        type: 'tag',
	        tagType: 'endlist'
	      });
	      return;
	    }
	    match = /^#EXT-X-DISCONTINUITY/.exec(line);
	    if (match) {
	      this.trigger('data', {
	        type: 'tag',
	        tagType: 'discontinuity'
	      });
	      return;
	    }
	    match = /^#EXT-X-PROGRAM-DATE-TIME:?(.*)$/.exec(line);
	    if (match) {
	      event = {
	        type: 'tag',
	        tagType: 'program-date-time'
	      };
	      if (match[1]) {
	        event.dateTimeString = match[1];
	        event.dateTimeObject = new Date(match[1]);
	      }
	      this.trigger('data', event);
	      return;
	    }
	    match = /^#EXT-X-KEY:?(.*)$/.exec(line);
	    if (match) {
	      event = {
	        type: 'tag',
	        tagType: 'key'
	      };
	      if (match[1]) {
	        event.attributes = parseAttributes(match[1]);
	        // parse the IV string into a Uint32Array
	        if (event.attributes.IV) {
	          if (event.attributes.IV.substring(0, 2).toLowerCase() === '0x') {
	            event.attributes.IV = event.attributes.IV.substring(2);
	          }
	
	          event.attributes.IV = event.attributes.IV.match(/.{8}/g);
	          event.attributes.IV[0] = parseInt(event.attributes.IV[0], 16);
	          event.attributes.IV[1] = parseInt(event.attributes.IV[1], 16);
	          event.attributes.IV[2] = parseInt(event.attributes.IV[2], 16);
	          event.attributes.IV[3] = parseInt(event.attributes.IV[3], 16);
	          event.attributes.IV = new Uint32Array(event.attributes.IV);
	        }
	      }
	      this.trigger('data', event);
	      return;
	    }
	    match = /^#EXT-X-START:?(.*)$/.exec(line);
	    if (match) {
	      event = {
	        type: 'tag',
	        tagType: 'start'
	      };
	      if (match[1]) {
	        event.attributes = parseAttributes(match[1]);
	
	        event.attributes['TIME-OFFSET'] = parseFloat(event.attributes['TIME-OFFSET']);
	        event.attributes.PRECISE = /YES/.test(event.attributes.PRECISE);
	      }
	      this.trigger('data', event);
	      return;
	    }
	    match = /^#EXT-X-CUE-OUT-CONT:?(.*)?$/.exec(line);
	    if (match) {
	      event = {
	        type: 'tag',
	        tagType: 'cue-out-cont'
	      };
	      if (match[1]) {
	        event.data = match[1];
	      } else {
	        event.data = '';
	      }
	      this.trigger('data', event);
	      return;
	    }
	    match = /^#EXT-X-CUE-OUT:?(.*)?$/.exec(line);
	    if (match) {
	      event = {
	        type: 'tag',
	        tagType: 'cue-out'
	      };
	      if (match[1]) {
	        event.data = match[1];
	      } else {
	        event.data = '';
	      }
	      this.trigger('data', event);
	      return;
	    }
	    match = /^#EXT-X-CUE-IN:?(.*)?$/.exec(line);
	    if (match) {
	      event = {
	        type: 'tag',
	        tagType: 'cue-in'
	      };
	      if (match[1]) {
	        event.data = match[1];
	      } else {
	        event.data = '';
	      }
	      this.trigger('data', event);
	      return;
	    }
	
	    // unknown tag type
	    this.trigger('data', {
	      type: 'tag',
	      data: line.slice(4)
	    });
	  };
	
	  /**
	   * Add a parser for custom headers
	   *
	   * @param {Object}   options              a map of options for the added parser
	   * @param {RegExp}   options.expression   a regular expression to match the custom header
	   * @param {string}   options.customType   the custom type to register to the output
	   * @param {Function} [options.dataParser] function to parse the line into an object
	   * @param {boolean}  [options.segment]    should tag data be attached to the segment object
	   */
	
	
	  ParseStream.prototype.addParser = function addParser(_ref) {
	    var _this2 = this;
	
	    var expression = _ref.expression,
	        customType = _ref.customType,
	        dataParser = _ref.dataParser,
	        segment = _ref.segment;
	
	    if (typeof dataParser !== 'function') {
	      dataParser = function dataParser(line) {
	        return line;
	      };
	    }
	    this.customParsers.push(function (line) {
	      var match = expression.exec(line);
	
	      if (match) {
	        _this2.trigger('data', {
	          type: 'custom',
	          data: dataParser(line),
	          customType: customType,
	          segment: segment
	        });
	        return true;
	      }
	    });
	  };
	
	  return ParseStream;
	}(Stream);
	
	/**
	 * @file m3u8/parser.js
	 */
	/**
	 * A parser for M3U8 files. The current interpretation of the input is
	 * exposed as a property `manifest` on parser objects. It's just two lines to
	 * create and parse a manifest once you have the contents available as a string:
	 *
	 * ```js
	 * var parser = new m3u8.Parser();
	 * parser.push(xhr.responseText);
	 * ```
	 *
	 * New input can later be applied to update the manifest object by calling
	 * `push` again.
	 *
	 * The parser attempts to create a usable manifest object even if the
	 * underlying input is somewhat nonsensical. It emits `info` and `warning`
	 * events during the parse if it encounters input that seems invalid or
	 * requires some property of the manifest object to be defaulted.
	 *
	 * @class Parser
	 * @extends Stream
	 */
	
	var Parser = function (_Stream) {
	  inherits(Parser, _Stream);
	
	  function Parser() {
	    classCallCheck(this, Parser);
	
	    var _this = possibleConstructorReturn(this, _Stream.call(this));
	
	    _this.lineStream = new LineStream();
	    _this.parseStream = new ParseStream();
	    _this.lineStream.pipe(_this.parseStream);
	
	    /* eslint-disable consistent-this */
	    var self = _this;
	    /* eslint-enable consistent-this */
	    var uris = [];
	    var currentUri = {};
	    // if specified, the active EXT-X-MAP definition
	    var currentMap = void 0;
	    // if specified, the active decryption key
	    var _key = void 0;
	    var noop = function noop() {};
	    var defaultMediaGroups = {
	      'AUDIO': {},
	      'VIDEO': {},
	      'CLOSED-CAPTIONS': {},
	      'SUBTITLES': {}
	    };
	    // group segments into numbered timelines delineated by discontinuities
	    var currentTimeline = 0;
	
	    // the manifest is empty until the parse stream begins delivering data
	    _this.manifest = {
	      allowCache: true,
	      discontinuityStarts: [],
	      segments: []
	    };
	
	    // update the manifest with the m3u8 entry from the parse stream
	    _this.parseStream.on('data', function (entry) {
	      var mediaGroup = void 0;
	      var rendition = void 0;
	
	      ({
	        tag: function tag() {
	          // switch based on the tag type
	          (({
	            'allow-cache': function allowCache() {
	              this.manifest.allowCache = entry.allowed;
	              if (!('allowed' in entry)) {
	                this.trigger('info', {
	                  message: 'defaulting allowCache to YES'
	                });
	                this.manifest.allowCache = true;
	              }
	            },
	            byterange: function byterange() {
	              var byterange = {};
	
	              if ('length' in entry) {
	                currentUri.byterange = byterange;
	                byterange.length = entry.length;
	
	                if (!('offset' in entry)) {
	                  this.trigger('info', {
	                    message: 'defaulting offset to zero'
	                  });
	                  entry.offset = 0;
	                }
	              }
	              if ('offset' in entry) {
	                currentUri.byterange = byterange;
	                byterange.offset = entry.offset;
	              }
	            },
	            endlist: function endlist() {
	              this.manifest.endList = true;
	            },
	            inf: function inf() {
	              if (!('mediaSequence' in this.manifest)) {
	                this.manifest.mediaSequence = 0;
	                this.trigger('info', {
	                  message: 'defaulting media sequence to zero'
	                });
	              }
	              if (!('discontinuitySequence' in this.manifest)) {
	                this.manifest.discontinuitySequence = 0;
	                this.trigger('info', {
	                  message: 'defaulting discontinuity sequence to zero'
	                });
	              }
	              if (entry.duration > 0) {
	                currentUri.duration = entry.duration;
	              }
	
	              if (entry.duration === 0) {
	                currentUri.duration = 0.01;
	                this.trigger('info', {
	                  message: 'updating zero segment duration to a small value'
	                });
	              }
	
	              this.manifest.segments = uris;
	            },
	            key: function key() {
	              if (!entry.attributes) {
	                this.trigger('warn', {
	                  message: 'ignoring key declaration without attribute list'
	                });
	                return;
	              }
	              // clear the active encryption key
	              if (entry.attributes.METHOD === 'NONE') {
	                _key = null;
	                return;
	              }
	              if (!entry.attributes.URI) {
	                this.trigger('warn', {
	                  message: 'ignoring key declaration without URI'
	                });
	                return;
	              }
	              if (!entry.attributes.METHOD) {
	                this.trigger('warn', {
	                  message: 'defaulting key method to AES-128'
	                });
	              }
	
	              // setup an encryption key for upcoming segments
	              _key = {
	                method: entry.attributes.METHOD || 'AES-128',
	                uri: entry.attributes.URI
	              };
	
	              if (typeof entry.attributes.IV !== 'undefined') {
	                _key.iv = entry.attributes.IV;
	              }
	            },
	            'media-sequence': function mediaSequence() {
	              if (!isFinite(entry.number)) {
	                this.trigger('warn', {
	                  message: 'ignoring invalid media sequence: ' + entry.number
	                });
	                return;
	              }
	              this.manifest.mediaSequence = entry.number;
	            },
	            'discontinuity-sequence': function discontinuitySequence() {
	              if (!isFinite(entry.number)) {
	                this.trigger('warn', {
	                  message: 'ignoring invalid discontinuity sequence: ' + entry.number
	                });
	                return;
	              }
	              this.manifest.discontinuitySequence = entry.number;
	              currentTimeline = entry.number;
	            },
	            'playlist-type': function playlistType() {
	              if (!/VOD|EVENT/.test(entry.playlistType)) {
	                this.trigger('warn', {
	                  message: 'ignoring unknown playlist type: ' + entry.playlist
	                });
	                return;
	              }
	              this.manifest.playlistType = entry.playlistType;
	            },
	            map: function map() {
	              currentMap = {};
	              if (entry.uri) {
	                currentMap.uri = entry.uri;
	              }
	              if (entry.byterange) {
	                currentMap.byterange = entry.byterange;
	              }
	            },
	            'stream-inf': function streamInf() {
	              this.manifest.playlists = uris;
	              this.manifest.mediaGroups = this.manifest.mediaGroups || defaultMediaGroups;
	
	              if (!entry.attributes) {
	                this.trigger('warn', {
	                  message: 'ignoring empty stream-inf attributes'
	                });
	                return;
	              }
	
	              if (!currentUri.attributes) {
	                currentUri.attributes = {};
	              }
	              _extends(currentUri.attributes, entry.attributes);
	            },
	            media: function media() {
	              this.manifest.mediaGroups = this.manifest.mediaGroups || defaultMediaGroups;
	
	              if (!(entry.attributes && entry.attributes.TYPE && entry.attributes['GROUP-ID'] && entry.attributes.NAME)) {
	                this.trigger('warn', {
	                  message: 'ignoring incomplete or missing media group'
	                });
	                return;
	              }
	
	              // find the media group, creating defaults as necessary
	              var mediaGroupType = this.manifest.mediaGroups[entry.attributes.TYPE];
	
	              mediaGroupType[entry.attributes['GROUP-ID']] = mediaGroupType[entry.attributes['GROUP-ID']] || {};
	              mediaGroup = mediaGroupType[entry.attributes['GROUP-ID']];
	
	              // collect the rendition metadata
	              rendition = {
	                'default': /yes/i.test(entry.attributes.DEFAULT)
	              };
	              if (rendition['default']) {
	                rendition.autoselect = true;
	              } else {
	                rendition.autoselect = /yes/i.test(entry.attributes.AUTOSELECT);
	              }
	              if (entry.attributes.LANGUAGE) {
	                rendition.language = entry.attributes.LANGUAGE;
	              }
	              if (entry.attributes.URI) {
	                rendition.uri = entry.attributes.URI;
	              }
	              if (entry.attributes['INSTREAM-ID']) {
	                rendition.instreamId = entry.attributes['INSTREAM-ID'];
	              }
	              if (entry.attributes.CHARACTERISTICS) {
	                rendition.characteristics = entry.attributes.CHARACTERISTICS;
	              }
	              if (entry.attributes.FORCED) {
	                rendition.forced = /yes/i.test(entry.attributes.FORCED);
	              }
	
	              // insert the new rendition
	              mediaGroup[entry.attributes.NAME] = rendition;
	            },
	            discontinuity: function discontinuity() {
	              currentTimeline += 1;
	              currentUri.discontinuity = true;
	              this.manifest.discontinuityStarts.push(uris.length);
	            },
	            'program-date-time': function programDateTime() {
	              if (typeof this.manifest.dateTimeString === 'undefined') {
	                // PROGRAM-DATE-TIME is a media-segment tag, but for backwards
	                // compatibility, we add the first occurence of the PROGRAM-DATE-TIME tag
	                // to the manifest object
	                // TODO: Consider removing this in future major version
	                this.manifest.dateTimeString = entry.dateTimeString;
	                this.manifest.dateTimeObject = entry.dateTimeObject;
	              }
	
	              currentUri.dateTimeString = entry.dateTimeString;
	              currentUri.dateTimeObject = entry.dateTimeObject;
	            },
	            targetduration: function targetduration() {
	              if (!isFinite(entry.duration) || entry.duration < 0) {
	                this.trigger('warn', {
	                  message: 'ignoring invalid target duration: ' + entry.duration
	                });
	                return;
	              }
	              this.manifest.targetDuration = entry.duration;
	            },
	            totalduration: function totalduration() {
	              if (!isFinite(entry.duration) || entry.duration < 0) {
	                this.trigger('warn', {
	                  message: 'ignoring invalid total duration: ' + entry.duration
	                });
	                return;
	              }
	              this.manifest.totalDuration = entry.duration;
	            },
	            start: function start() {
	              if (!entry.attributes || isNaN(entry.attributes['TIME-OFFSET'])) {
	                this.trigger('warn', {
	                  message: 'ignoring start declaration without appropriate attribute list'
	                });
	                return;
	              }
	              this.manifest.start = {
	                timeOffset: entry.attributes['TIME-OFFSET'],
	                precise: entry.attributes.PRECISE
	              };
	            },
	            'cue-out': function cueOut() {
	              currentUri.cueOut = entry.data;
	            },
	            'cue-out-cont': function cueOutCont() {
	              currentUri.cueOutCont = entry.data;
	            },
	            'cue-in': function cueIn() {
	              currentUri.cueIn = entry.data;
	            }
	          })[entry.tagType] || noop).call(self);
	        },
	        uri: function uri() {
	          currentUri.uri = entry.uri;
	          uris.push(currentUri);
	
	          // if no explicit duration was declared, use the target duration
	          if (this.manifest.targetDuration && !('duration' in currentUri)) {
	            this.trigger('warn', {
	              message: 'defaulting segment duration to the target duration'
	            });
	            currentUri.duration = this.manifest.targetDuration;
	          }
	          // annotate with encryption information, if necessary
	          if (_key) {
	            currentUri.key = _key;
	          }
	          currentUri.timeline = currentTimeline;
	          // annotate with initialization segment information, if necessary
	          if (currentMap) {
	            currentUri.map = currentMap;
	          }
	
	          // prepare for the next URI
	          currentUri = {};
	        },
	        comment: function comment() {
	          // comments are not important for playback
	        },
	        custom: function custom() {
	          // if this is segment-level data attach the output to the segment
	          if (entry.segment) {
	            currentUri.custom = currentUri.custom || {};
	            currentUri.custom[entry.customType] = entry.data;
	            // if this is manifest-level data attach to the top level manifest object
	          } else {
	            this.manifest.custom = this.manifest.custom || {};
	            this.manifest.custom[entry.customType] = entry.data;
	          }
	        }
	      })[entry.type].call(self);
	    });
	    return _this;
	  }
	
	  /**
	   * Parse the input string and update the manifest object.
	   *
	   * @param {String} chunk a potentially incomplete portion of the manifest
	   */
	
	
	  Parser.prototype.push = function push(chunk) {
	    this.lineStream.push(chunk);
	  };
	
	  /**
	   * Flush any remaining input. This can be handy if the last line of an M3U8
	   * manifest did not contain a trailing newline but the file has been
	   * completely received.
	   */
	
	
	  Parser.prototype.end = function end() {
	    // flush any buffered input
	    this.lineStream.push('\n');
	  };
	  /**
	   * Add an additional parser for non-standard tags
	   *
	   * @param {Object}   options              a map of options for the added parser
	   * @param {RegExp}   options.expression   a regular expression to match the custom header
	   * @param {string}   options.type         the type to register to the output
	   * @param {Function} [options.dataParser] function to parse the line into an object
	   * @param {boolean}  [options.segment]    should tag data be attached to the segment object
	   */
	
	
	  Parser.prototype.addParser = function addParser(options) {
	    this.parseStream.addParser(options);
	  };
	
	  return Parser;
	}(Stream);
	
	/**
	 * @file m3u8/index.js
	 *
	 * Utilities for parsing M3U8 files. If the entire manifest is available,
	 * `Parser` will create an object representation with enough detail for managing
	 * playback. `ParseStream` and `LineStream` are lower-level parsing primitives
	 * that do not assume the entirety of the manifest is ready and expose a
	 * ReadableStream-like interface.
	 */
	
	exports.LineStream = LineStream;
	exports.ParseStream = ParseStream;
	exports.Parser = Parser;


/***/ },
/* 942 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * mpd-parser
	 * @version 0.6.1
	 * @copyright 2018 Brightcove, Inc
	 * @license Apache-2.0
	 */
	'use strict';
	
	function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }
	
	var URLToolkit = _interopDefault(__webpack_require__(436));
	var window = _interopDefault(__webpack_require__(170));
	
	var version = "0.6.1";
	
	var formatAudioPlaylist = function formatAudioPlaylist(_ref) {
	  var _attributes;
	
	  var attributes = _ref.attributes,
	      segments = _ref.segments;
	
	  var playlist = {
	    attributes: (_attributes = {
	      NAME: attributes.id,
	      BANDWIDTH: attributes.bandwidth,
	      CODECS: attributes.codecs
	    }, _attributes['PROGRAM-ID'] = 1, _attributes),
	    uri: '',
	    endList: (attributes.type || 'static') === 'static',
	    timeline: attributes.periodIndex,
	    resolvedUri: '',
	    targetDuration: attributes.duration,
	    segments: segments,
	    mediaSequence: segments.length ? segments[0].number : 1
	  };
	
	  if (attributes.contentProtection) {
	    playlist.contentProtection = attributes.contentProtection;
	  }
	
	  return playlist;
	};
	
	var formatVttPlaylist = function formatVttPlaylist(_ref2) {
	  var _attributes2;
	
	  var attributes = _ref2.attributes,
	      segments = _ref2.segments;
	
	  if (typeof segments === 'undefined') {
	    // vtt tracks may use single file in BaseURL
	    segments = [{
	      uri: attributes.baseUrl,
	      timeline: attributes.periodIndex,
	      resolvedUri: attributes.baseUrl || '',
	      duration: attributes.sourceDuration,
	      number: 0
	    }];
	    // targetDuration should be the same duration as the only segment
	    attributes.duration = attributes.sourceDuration;
	  }
	  return {
	    attributes: (_attributes2 = {
	      NAME: attributes.id,
	      BANDWIDTH: attributes.bandwidth
	    }, _attributes2['PROGRAM-ID'] = 1, _attributes2),
	    uri: '',
	    endList: (attributes.type || 'static') === 'static',
	    timeline: attributes.periodIndex,
	    resolvedUri: attributes.baseUrl || '',
	    targetDuration: attributes.duration,
	    segments: segments,
	    mediaSequence: segments.length ? segments[0].number : 1
	  };
	};
	
	var organizeAudioPlaylists = function organizeAudioPlaylists(playlists) {
	  return playlists.reduce(function (a, playlist) {
	    var role = playlist.attributes.role && playlist.attributes.role.value || 'main';
	    var language = playlist.attributes.lang || '';
	
	    var label = 'main';
	
	    if (language) {
	      label = playlist.attributes.lang + ' (' + role + ')';
	    }
	
	    // skip if we already have the highest quality audio for a language
	    if (a[label] && a[label].playlists[0].attributes.BANDWIDTH > playlist.attributes.bandwidth) {
	      return a;
	    }
	
	    a[label] = {
	      language: language,
	      autoselect: true,
	      'default': role === 'main',
	      playlists: [formatAudioPlaylist(playlist)],
	      uri: ''
	    };
	
	    return a;
	  }, {});
	};
	
	var organizeVttPlaylists = function organizeVttPlaylists(playlists) {
	  return playlists.reduce(function (a, playlist) {
	    var label = playlist.attributes.lang || 'text';
	
	    // skip if we already have subtitles
	    if (a[label]) {
	      return a;
	    }
	
	    a[label] = {
	      language: label,
	      'default': false,
	      autoselect: false,
	      playlists: [formatVttPlaylist(playlist)],
	      uri: ''
	    };
	
	    return a;
	  }, {});
	};
	
	var formatVideoPlaylist = function formatVideoPlaylist(_ref3) {
	  var _attributes3;
	
	  var attributes = _ref3.attributes,
	      segments = _ref3.segments;
	
	  var playlist = {
	    attributes: (_attributes3 = {
	      NAME: attributes.id,
	      AUDIO: 'audio',
	      SUBTITLES: 'subs',
	      RESOLUTION: {
	        width: attributes.width,
	        height: attributes.height
	      },
	      CODECS: attributes.codecs,
	      BANDWIDTH: attributes.bandwidth
	    }, _attributes3['PROGRAM-ID'] = 1, _attributes3),
	    uri: '',
	    endList: (attributes.type || 'static') === 'static',
	    timeline: attributes.periodIndex,
	    resolvedUri: '',
	    targetDuration: attributes.duration,
	    segments: segments,
	    mediaSequence: segments.length ? segments[0].number : 1
	  };
	
	  if (attributes.contentProtection) {
	    playlist.contentProtection = attributes.contentProtection;
	  }
	
	  return playlist;
	};
	
	var toM3u8 = function toM3u8(dashPlaylists) {
	  var _mediaGroups;
	
	  if (!dashPlaylists.length) {
	    return {};
	  }
	
	  // grab all master attributes
	  var _dashPlaylists$0$attr = dashPlaylists[0].attributes,
	      duration = _dashPlaylists$0$attr.sourceDuration,
	      _dashPlaylists$0$attr2 = _dashPlaylists$0$attr.minimumUpdatePeriod,
	      minimumUpdatePeriod = _dashPlaylists$0$attr2 === undefined ? 0 : _dashPlaylists$0$attr2;
	
	
	  var videoOnly = function videoOnly(_ref4) {
	    var attributes = _ref4.attributes;
	    return attributes.mimeType === 'video/mp4' || attributes.contentType === 'video';
	  };
	  var audioOnly = function audioOnly(_ref5) {
	    var attributes = _ref5.attributes;
	    return attributes.mimeType === 'audio/mp4' || attributes.contentType === 'audio';
	  };
	  var vttOnly = function vttOnly(_ref6) {
	    var attributes = _ref6.attributes;
	    return attributes.mimeType === 'text/vtt' || attributes.contentType === 'text';
	  };
	
	  var videoPlaylists = dashPlaylists.filter(videoOnly).map(formatVideoPlaylist);
	  var audioPlaylists = dashPlaylists.filter(audioOnly);
	  var vttPlaylists = dashPlaylists.filter(vttOnly);
	
	  var master = {
	    allowCache: true,
	    discontinuityStarts: [],
	    segments: [],
	    endList: true,
	    mediaGroups: (_mediaGroups = {
	      AUDIO: {},
	      VIDEO: {}
	    }, _mediaGroups['CLOSED-CAPTIONS'] = {}, _mediaGroups.SUBTITLES = {}, _mediaGroups),
	    uri: '',
	    duration: duration,
	    playlists: videoPlaylists,
	    minimumUpdatePeriod: minimumUpdatePeriod * 1000
	  };
	
	  if (audioPlaylists.length) {
	    master.mediaGroups.AUDIO.audio = organizeAudioPlaylists(audioPlaylists);
	  }
	
	  if (vttPlaylists.length) {
	    master.mediaGroups.SUBTITLES.subs = organizeVttPlaylists(vttPlaylists);
	  }
	
	  return master;
	};
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {
	  return typeof obj;
	} : function (obj) {
	  return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
	};
	
	var isObject = function isObject(obj) {
	  return !!obj && (typeof obj === 'undefined' ? 'undefined' : _typeof(obj)) === 'object';
	};
	
	var merge = function merge() {
	  for (var _len = arguments.length, objects = Array(_len), _key = 0; _key < _len; _key++) {
	    objects[_key] = arguments[_key];
	  }
	
	  return objects.reduce(function (result, source) {
	
	    Object.keys(source).forEach(function (key) {
	
	      if (Array.isArray(result[key]) && Array.isArray(source[key])) {
	        result[key] = result[key].concat(source[key]);
	      } else if (isObject(result[key]) && isObject(source[key])) {
	        result[key] = merge(result[key], source[key]);
	      } else {
	        result[key] = source[key];
	      }
	    });
	    return result;
	  }, {});
	};
	
	var resolveUrl = function resolveUrl(baseUrl, relativeUrl) {
	  // return early if we don't need to resolve
	  if (/^[a-z]+:/i.test(relativeUrl)) {
	    return relativeUrl;
	  }
	
	  // if the base URL is relative then combine with the current location
	  if (!/\/\//i.test(baseUrl)) {
	    baseUrl = URLToolkit.buildAbsoluteURL(window.location.href, baseUrl);
	  }
	
	  return URLToolkit.buildAbsoluteURL(baseUrl, relativeUrl);
	};
	
	/**
	 * @typedef {Object} SingleUri
	 * @property {string} uri - relative location of segment
	 * @property {string} resolvedUri - resolved location of segment
	 * @property {Object} byterange - Object containing information on how to make byte range
	 *   requests following byte-range-spec per RFC2616.
	 * @property {String} byterange.length - length of range request
	 * @property {String} byterange.offset - byte offset of range request
	 *
	 * @see https://www.w3.org/Protocols/rfc2616/rfc2616-sec14.html#sec14.35.1
	 */
	
	/**
	 * Converts a URLType node (5.3.9.2.3 Table 13) to a segment object
	 * that conforms to how m3u8-parser is structured
	 *
	 * @see https://github.com/videojs/m3u8-parser
	 *
	 * @param {string} baseUrl - baseUrl provided by <BaseUrl> nodes
	 * @param {string} source - source url for segment
	 * @param {string} range - optional range used for range calls, follows
	 * @return {SingleUri} full segment information transformed into a format similar
	 *   to m3u8-parser
	 */
	var urlTypeToSegment = function urlTypeToSegment(_ref) {
	  var _ref$baseUrl = _ref.baseUrl,
	      baseUrl = _ref$baseUrl === undefined ? '' : _ref$baseUrl,
	      _ref$source = _ref.source,
	      source = _ref$source === undefined ? '' : _ref$source,
	      _ref$range = _ref.range,
	      range = _ref$range === undefined ? '' : _ref$range;
	
	  var init = {
	    uri: source,
	    resolvedUri: resolveUrl(baseUrl || '', source)
	  };
	
	  if (range) {
	    var ranges = range.split('-');
	    var startRange = parseInt(ranges[0], 10);
	    var endRange = parseInt(ranges[1], 10);
	
	    init.byterange = {
	      length: endRange - startRange,
	      offset: startRange
	    };
	  }
	
	  return init;
	};
	
	/**
	 * Calculates the R (repetition) value for a live stream (for the final segment
	 * in a manifest where the r value is negative 1)
	 *
	 * @param {Object} attributes
	 *        Object containing all inherited attributes from parent elements with attribute
	 *        names as keys
	 * @param {number} time
	 *        current time (typically the total time up until the final segment)
	 * @param {number} duration
	 *        duration property for the given <S />
	 *
	 * @return {number}
	 *        R value to reach the end of the given period
	 */
	var getLiveRValue = function getLiveRValue(attributes, time, duration) {
	  var NOW = attributes.NOW,
	      clientOffset = attributes.clientOffset,
	      availabilityStartTime = attributes.availabilityStartTime,
	      _attributes$timescale = attributes.timescale,
	      timescale = _attributes$timescale === undefined ? 1 : _attributes$timescale,
	      _attributes$start = attributes.start,
	      start = _attributes$start === undefined ? 0 : _attributes$start,
	      _attributes$minimumUp = attributes.minimumUpdatePeriod,
	      minimumUpdatePeriod = _attributes$minimumUp === undefined ? 0 : _attributes$minimumUp;
	
	  var now = (NOW + clientOffset) / 1000;
	  var periodStartWC = availabilityStartTime + start;
	  var periodEndWC = now + minimumUpdatePeriod;
	  var periodDuration = periodEndWC - periodStartWC;
	
	  return Math.ceil((periodDuration * timescale - time) / duration);
	};
	
	/**
	 * Uses information provided by SegmentTemplate.SegmentTimeline to determine segment
	 * timing and duration
	 *
	 * @param {Object} attributes
	 *        Object containing all inherited attributes from parent elements with attribute
	 *        names as keys
	 * @param {Object[]} segmentTimeline
	 *        List of objects representing the attributes of each S element contained within
	 *
	 * @return {{number: number, duration: number, time: number, timeline: number}[]}
	 *         List of Objects with segment timing and duration info
	 */
	var parseByTimeline = function parseByTimeline(attributes, segmentTimeline) {
	  var _attributes$type = attributes.type,
	      type = _attributes$type === undefined ? 'static' : _attributes$type,
	      _attributes$minimumUp2 = attributes.minimumUpdatePeriod,
	      minimumUpdatePeriod = _attributes$minimumUp2 === undefined ? 0 : _attributes$minimumUp2,
	      _attributes$media = attributes.media,
	      media = _attributes$media === undefined ? '' : _attributes$media,
	      sourceDuration = attributes.sourceDuration,
	      _attributes$timescale2 = attributes.timescale,
	      timescale = _attributes$timescale2 === undefined ? 1 : _attributes$timescale2,
	      _attributes$startNumb = attributes.startNumber,
	      startNumber = _attributes$startNumb === undefined ? 1 : _attributes$startNumb,
	      timeline = attributes.periodIndex;
	
	  var segments = [];
	  var time = -1;
	
	  for (var sIndex = 0; sIndex < segmentTimeline.length; sIndex++) {
	    var S = segmentTimeline[sIndex];
	    var duration = S.d;
	    var repeat = S.r || 0;
	    var segmentTime = S.t || 0;
	
	    if (time < 0) {
	      // first segment
	      time = segmentTime;
	    }
	
	    if (segmentTime && segmentTime > time) {
	      // discontinuity
	
	      // TODO: How to handle this type of discontinuity
	      // timeline++ here would treat it like HLS discontuity and content would
	      // get appended without gap
	      // E.G.
	      //  <S t="0" d="1" />
	      //  <S d="1" />
	      //  <S d="1" />
	      //  <S t="5" d="1" />
	      // would have $Time$ values of [0, 1, 2, 5]
	      // should this be appened at time positions [0, 1, 2, 3],(#EXT-X-DISCONTINUITY)
	      // or [0, 1, 2, gap, gap, 5]? (#EXT-X-GAP)
	      // does the value of sourceDuration consider this when calculating arbitrary
	      // negative @r repeat value?
	      // E.G. Same elements as above with this added at the end
	      //  <S d="1" r="-1" />
	      //  with a sourceDuration of 10
	      // Would the 2 gaps be included in the time duration calculations resulting in
	      // 8 segments with $Time$ values of [0, 1, 2, 5, 6, 7, 8, 9] or 10 segments
	      // with $Time$ values of [0, 1, 2, 5, 6, 7, 8, 9, 10, 11] ?
	
	      time = segmentTime;
	    }
	
	    var count = void 0;
	
	    if (repeat < 0) {
	      var nextS = sIndex + 1;
	
	      if (nextS === segmentTimeline.length) {
	        // last segment
	        if (type === 'dynamic' && minimumUpdatePeriod > 0 && media.indexOf('$Number$') > 0) {
	          count = getLiveRValue(attributes, time, duration);
	        } else {
	          // TODO: This may be incorrect depending on conclusion of TODO above
	          count = (sourceDuration * timescale - time) / duration;
	        }
	      } else {
	        count = (segmentTimeline[nextS].t - time) / duration;
	      }
	    } else {
	      count = repeat + 1;
	    }
	
	    var end = startNumber + segments.length + count;
	    var number = startNumber + segments.length;
	
	    while (number < end) {
	      segments.push({ number: number, duration: duration / timescale, time: time, timeline: timeline });
	      time += duration;
	      number++;
	    }
	  }
	
	  return segments;
	};
	
	var range = function range(start, end) {
	  var result = [];
	
	  for (var i = start; i < end; i++) {
	    result.push(i);
	  }
	
	  return result;
	};
	
	var flatten = function flatten(lists) {
	  return lists.reduce(function (x, y) {
	    return x.concat(y);
	  }, []);
	};
	
	var from = function from(list) {
	  if (!list.length) {
	    return [];
	  }
	
	  var result = [];
	
	  for (var i = 0; i < list.length; i++) {
	    result.push(list[i]);
	  }
	
	  return result;
	};
	
	/**
	 * Functions for calculating the range of available segments in static and dynamic
	 * manifests.
	 */
	var segmentRange = {
	  /**
	   * Returns the entire range of available segments for a static MPD
	   *
	   * @param {Object} attributes
	   *        Inheritied MPD attributes
	   * @return {{ start: number, end: number }}
	   *         The start and end numbers for available segments
	   */
	  'static': function _static(attributes) {
	    var duration = attributes.duration,
	        _attributes$timescale = attributes.timescale,
	        timescale = _attributes$timescale === undefined ? 1 : _attributes$timescale,
	        sourceDuration = attributes.sourceDuration;
	
	
	    return {
	      start: 0,
	      end: Math.ceil(sourceDuration / (duration / timescale))
	    };
	  },
	
	
	  /**
	   * Returns the current live window range of available segments for a dynamic MPD
	   *
	   * @param {Object} attributes
	   *        Inheritied MPD attributes
	   * @return {{ start: number, end: number }}
	   *         The start and end numbers for available segments
	   */
	  dynamic: function dynamic(attributes) {
	    var NOW = attributes.NOW,
	        clientOffset = attributes.clientOffset,
	        availabilityStartTime = attributes.availabilityStartTime,
	        _attributes$timescale2 = attributes.timescale,
	        timescale = _attributes$timescale2 === undefined ? 1 : _attributes$timescale2,
	        duration = attributes.duration,
	        _attributes$start = attributes.start,
	        start = _attributes$start === undefined ? 0 : _attributes$start,
	        _attributes$minimumUp = attributes.minimumUpdatePeriod,
	        minimumUpdatePeriod = _attributes$minimumUp === undefined ? 0 : _attributes$minimumUp,
	        _attributes$timeShift = attributes.timeShiftBufferDepth,
	        timeShiftBufferDepth = _attributes$timeShift === undefined ? Infinity : _attributes$timeShift;
	
	    var now = (NOW + clientOffset) / 1000;
	    var periodStartWC = availabilityStartTime + start;
	    var periodEndWC = now + minimumUpdatePeriod;
	    var periodDuration = periodEndWC - periodStartWC;
	    var segmentCount = Math.ceil(periodDuration * timescale / duration);
	    var availableStart = Math.floor((now - periodStartWC - timeShiftBufferDepth) * timescale / duration);
	    var availableEnd = Math.floor((now - periodStartWC) * timescale / duration);
	
	    return {
	      start: Math.max(0, availableStart),
	      end: Math.min(segmentCount, availableEnd)
	    };
	  }
	};
	
	/**
	 * Maps a range of numbers to objects with information needed to build the corresponding
	 * segment list
	 *
	 * @name toSegmentsCallback
	 * @function
	 * @param {number} number
	 *        Number of the segment
	 * @param {number} index
	 *        Index of the number in the range list
	 * @return {{ number: Number, duration: Number, timeline: Number, time: Number }}
	 *         Object with segment timing and duration info
	 */
	
	/**
	 * Returns a callback for Array.prototype.map for mapping a range of numbers to
	 * information needed to build the segment list.
	 *
	 * @param {Object} attributes
	 *        Inherited MPD attributes
	 * @return {toSegmentsCallback}
	 *         Callback map function
	 */
	var toSegments = function toSegments(attributes) {
	  return function (number, index) {
	    var duration = attributes.duration,
	        _attributes$timescale3 = attributes.timescale,
	        timescale = _attributes$timescale3 === undefined ? 1 : _attributes$timescale3,
	        periodIndex = attributes.periodIndex,
	        _attributes$startNumb = attributes.startNumber,
	        startNumber = _attributes$startNumb === undefined ? 1 : _attributes$startNumb;
	
	
	    return {
	      number: startNumber + number,
	      duration: duration / timescale,
	      timeline: periodIndex,
	      time: index * duration
	    };
	  };
	};
	
	/**
	 * Returns a list of objects containing segment timing and duration info used for
	 * building the list of segments. This uses the @duration attribute specified
	 * in the MPD manifest to derive the range of segments.
	 *
	 * @param {Object} attributes
	 *        Inherited MPD attributes
	 * @return {{number: number, duration: number, time: number, timeline: number}[]}
	 *         List of Objects with segment timing and duration info
	 */
	var parseByDuration = function parseByDuration(attributes) {
	  var _attributes$type = attributes.type,
	      type = _attributes$type === undefined ? 'static' : _attributes$type,
	      duration = attributes.duration,
	      _attributes$timescale4 = attributes.timescale,
	      timescale = _attributes$timescale4 === undefined ? 1 : _attributes$timescale4,
	      sourceDuration = attributes.sourceDuration;
	
	  var _segmentRange$type = segmentRange[type](attributes),
	      start = _segmentRange$type.start,
	      end = _segmentRange$type.end;
	
	  var segments = range(start, end).map(toSegments(attributes));
	
	  if (type === 'static') {
	    var index = segments.length - 1;
	
	    // final segment may be less than full segment duration
	    segments[index].duration = sourceDuration - duration / timescale * index;
	  }
	
	  return segments;
	};
	
	var identifierPattern = /\$([A-z]*)(?:(%0)([0-9]+)d)?\$/g;
	
	/**
	 * Replaces template identifiers with corresponding values. To be used as the callback
	 * for String.prototype.replace
	 *
	 * @name replaceCallback
	 * @function
	 * @param {string} match
	 *        Entire match of identifier
	 * @param {string} identifier
	 *        Name of matched identifier
	 * @param {string} format
	 *        Format tag string. Its presence indicates that padding is expected
	 * @param {string} width
	 *        Desired length of the replaced value. Values less than this width shall be left
	 *        zero padded
	 * @return {string}
	 *         Replacement for the matched identifier
	 */
	
	/**
	 * Returns a function to be used as a callback for String.prototype.replace to replace
	 * template identifiers
	 *
	 * @param {Obect} values
	 *        Object containing values that shall be used to replace known identifiers
	 * @param {number} values.RepresentationID
	 *        Value of the Representation@id attribute
	 * @param {number} values.Number
	 *        Number of the corresponding segment
	 * @param {number} values.Bandwidth
	 *        Value of the Representation@bandwidth attribute.
	 * @param {number} values.Time
	 *        Timestamp value of the corresponding segment
	 * @return {replaceCallback}
	 *         Callback to be used with String.prototype.replace to replace identifiers
	 */
	var identifierReplacement = function identifierReplacement(values) {
	  return function (match, identifier, format, width) {
	    if (match === '$$') {
	      // escape sequence
	      return '$';
	    }
	
	    if (typeof values[identifier] === 'undefined') {
	      return match;
	    }
	
	    var value = '' + values[identifier];
	
	    if (identifier === 'RepresentationID') {
	      // Format tag shall not be present with RepresentationID
	      return value;
	    }
	
	    if (!format) {
	      width = 1;
	    } else {
	      width = parseInt(width, 10);
	    }
	
	    if (value.length >= width) {
	      return value;
	    }
	
	    return '' + new Array(width - value.length + 1).join('0') + value;
	  };
	};
	
	/**
	 * Constructs a segment url from a template string
	 *
	 * @param {string} url
	 *        Template string to construct url from
	 * @param {Obect} values
	 *        Object containing values that shall be used to replace known identifiers
	 * @param {number} values.RepresentationID
	 *        Value of the Representation@id attribute
	 * @param {number} values.Number
	 *        Number of the corresponding segment
	 * @param {number} values.Bandwidth
	 *        Value of the Representation@bandwidth attribute.
	 * @param {number} values.Time
	 *        Timestamp value of the corresponding segment
	 * @return {string}
	 *         Segment url with identifiers replaced
	 */
	var constructTemplateUrl = function constructTemplateUrl(url, values) {
	  return url.replace(identifierPattern, identifierReplacement(values));
	};
	
	/**
	 * Generates a list of objects containing timing and duration information about each
	 * segment needed to generate segment uris and the complete segment object
	 *
	 * @param {Object} attributes
	 *        Object containing all inherited attributes from parent elements with attribute
	 *        names as keys
	 * @param {Object[]|undefined} segmentTimeline
	 *        List of objects representing the attributes of each S element contained within
	 *        the SegmentTimeline element
	 * @return {{number: number, duration: number, time: number, timeline: number}[]}
	 *         List of Objects with segment timing and duration info
	 */
	var parseTemplateInfo = function parseTemplateInfo(attributes, segmentTimeline) {
	  if (!attributes.duration && !segmentTimeline) {
	    // if neither @duration or SegmentTimeline are present, then there shall be exactly
	    // one media segment
	    return [{
	      number: attributes.startNumber || 1,
	      duration: attributes.sourceDuration,
	      time: 0,
	      timeline: attributes.periodIndex
	    }];
	  }
	
	  if (attributes.duration) {
	    return parseByDuration(attributes);
	  }
	
	  return parseByTimeline(attributes, segmentTimeline);
	};
	
	/**
	 * Generates a list of segments using information provided by the SegmentTemplate element
	 *
	 * @param {Object} attributes
	 *        Object containing all inherited attributes from parent elements with attribute
	 *        names as keys
	 * @param {Object[]|undefined} segmentTimeline
	 *        List of objects representing the attributes of each S element contained within
	 *        the SegmentTimeline element
	 * @return {Object[]}
	 *         List of segment objects
	 */
	var segmentsFromTemplate = function segmentsFromTemplate(attributes, segmentTimeline) {
	  var templateValues = {
	    RepresentationID: attributes.id,
	    Bandwidth: attributes.bandwidth || 0
	  };
	
	  var _attributes$initializ = attributes.initialization,
	      initialization = _attributes$initializ === undefined ? { sourceURL: '', range: '' } : _attributes$initializ;
	
	
	  var mapSegment = urlTypeToSegment({
	    baseUrl: attributes.baseUrl,
	    source: constructTemplateUrl(initialization.sourceURL, templateValues),
	    range: initialization.range
	  });
	
	  var segments = parseTemplateInfo(attributes, segmentTimeline);
	
	  return segments.map(function (segment) {
	    templateValues.Number = segment.number;
	    templateValues.Time = segment.time;
	
	    var uri = constructTemplateUrl(attributes.media || '', templateValues);
	
	    return {
	      uri: uri,
	      timeline: segment.timeline,
	      duration: segment.duration,
	      resolvedUri: resolveUrl(attributes.baseUrl || '', uri),
	      map: mapSegment,
	      number: segment.number
	    };
	  });
	};
	
	var errors = {
	  INVALID_NUMBER_OF_PERIOD: 'INVALID_NUMBER_OF_PERIOD',
	  DASH_EMPTY_MANIFEST: 'DASH_EMPTY_MANIFEST',
	  DASH_INVALID_XML: 'DASH_INVALID_XML',
	  NO_BASE_URL: 'NO_BASE_URL',
	  MISSING_SEGMENT_INFORMATION: 'MISSING_SEGMENT_INFORMATION',
	  SEGMENT_TIME_UNSPECIFIED: 'SEGMENT_TIME_UNSPECIFIED',
	  UNSUPPORTED_UTC_TIMING_SCHEME: 'UNSUPPORTED_UTC_TIMING_SCHEME'
	};
	
	/**
	 * Converts a <SegmentUrl> (of type URLType from the DASH spec 5.3.9.2 Table 14)
	 * to an object that matches the output of a segment in videojs/mpd-parser
	 *
	 * @param {Object} attributes
	 *   Object containing all inherited attributes from parent elements with attribute
	 *   names as keys
	 * @param {Object} segmentUrl
	 *   <SegmentURL> node to translate into a segment object
	 * @return {Object} translated segment object
	 */
	var SegmentURLToSegmentObject = function SegmentURLToSegmentObject(attributes, segmentUrl) {
	  var baseUrl = attributes.baseUrl,
	      _attributes$initializ = attributes.initialization,
	      initialization = _attributes$initializ === undefined ? {} : _attributes$initializ;
	
	
	  var initSegment = urlTypeToSegment({
	    baseUrl: baseUrl,
	    source: initialization.sourceURL,
	    range: initialization.range
	  });
	
	  var segment = urlTypeToSegment({
	    baseUrl: baseUrl,
	    source: segmentUrl.media,
	    range: segmentUrl.mediaRange
	  });
	
	  segment.map = initSegment;
	
	  return segment;
	};
	
	/**
	 * Generates a list of segments using information provided by the SegmentList element
	 * SegmentList (DASH SPEC Section 5.3.9.3.2) contains a set of <SegmentURL> nodes.  Each
	 * node should be translated into segment.
	 *
	 * @param {Object} attributes
	 *   Object containing all inherited attributes from parent elements with attribute
	 *   names as keys
	 * @param {Object[]|undefined} segmentTimeline
	 *        List of objects representing the attributes of each S element contained within
	 *        the SegmentTimeline element
	 * @return {Object.<Array>} list of segments
	 */
	var segmentsFromList = function segmentsFromList(attributes, segmentTimeline) {
	  var duration = attributes.duration,
	      _attributes$segmentUr = attributes.segmentUrls,
	      segmentUrls = _attributes$segmentUr === undefined ? [] : _attributes$segmentUr;
	
	  // Per spec (5.3.9.2.1) no way to determine segment duration OR
	  // if both SegmentTimeline and @duration are defined, it is outside of spec.
	
	  if (!duration && !segmentTimeline || duration && segmentTimeline) {
	    throw new Error(errors.SEGMENT_TIME_UNSPECIFIED);
	  }
	
	  var segmentUrlMap = segmentUrls.map(function (segmentUrlObject) {
	    return SegmentURLToSegmentObject(attributes, segmentUrlObject);
	  });
	  var segmentTimeInfo = void 0;
	
	  if (duration) {
	    segmentTimeInfo = parseByDuration(attributes);
	  }
	
	  if (segmentTimeline) {
	    segmentTimeInfo = parseByTimeline(attributes, segmentTimeline);
	  }
	
	  var segments = segmentTimeInfo.map(function (segmentTime, index) {
	    if (segmentUrlMap[index]) {
	      var segment = segmentUrlMap[index];
	
	      segment.timeline = segmentTime.timeline;
	      segment.duration = segmentTime.duration;
	      segment.number = segmentTime.number;
	      return segment;
	    }
	    // Since we're mapping we should get rid of any blank segments (in case
	    // the given SegmentTimeline is handling for more elements than we have
	    // SegmentURLs for).
	  }).filter(function (segment) {
	    return segment;
	  });
	
	  return segments;
	};
	
	/**
	 * Translates SegmentBase into a set of segments.
	 * (DASH SPEC Section 5.3.9.3.2) contains a set of <SegmentURL> nodes.  Each
	 * node should be translated into segment.
	 *
	 * @param {Object} attributes
	 *   Object containing all inherited attributes from parent elements with attribute
	 *   names as keys
	 * @return {Object.<Array>} list of segments
	 */
	var segmentsFromBase = function segmentsFromBase(attributes) {
	  var baseUrl = attributes.baseUrl,
	      _attributes$initializ = attributes.initialization,
	      initialization = _attributes$initializ === undefined ? {} : _attributes$initializ,
	      sourceDuration = attributes.sourceDuration,
	      _attributes$timescale = attributes.timescale,
	      timescale = _attributes$timescale === undefined ? 1 : _attributes$timescale,
	      _attributes$indexRang = attributes.indexRange,
	      indexRange = _attributes$indexRang === undefined ? '' : _attributes$indexRang,
	      duration = attributes.duration;
	
	  // base url is required for SegmentBase to work, per spec (Section 5.3.9.2.1)
	
	  if (!baseUrl) {
	    throw new Error(errors.NO_BASE_URL);
	  }
	
	  var initSegment = urlTypeToSegment({
	    baseUrl: baseUrl,
	    source: initialization.sourceURL,
	    range: initialization.range
	  });
	  var segment = urlTypeToSegment({ baseUrl: baseUrl, source: baseUrl, range: indexRange });
	
	  segment.map = initSegment;
	
	  // If there is a duration, use it, otherwise use the given duration of the source
	  // (since SegmentBase is only for one total segment)
	  if (duration) {
	    var segmentTimeInfo = parseByDuration(attributes);
	
	    if (segmentTimeInfo.length) {
	      segment.duration = segmentTimeInfo[0].duration;
	      segment.timeline = segmentTimeInfo[0].timeline;
	    }
	  } else if (sourceDuration) {
	    segment.duration = sourceDuration / timescale;
	    segment.timeline = 0;
	  }
	
	  // This is used for mediaSequence
	  segment.number = 0;
	
	  return [segment];
	};
	
	var generateSegments = function generateSegments(_ref) {
	  var attributes = _ref.attributes,
	      segmentInfo = _ref.segmentInfo;
	
	  var segmentAttributes = void 0;
	  var segmentsFn = void 0;
	
	  if (segmentInfo.template) {
	    segmentsFn = segmentsFromTemplate;
	    segmentAttributes = merge(attributes, segmentInfo.template);
	  } else if (segmentInfo.base) {
	    segmentsFn = segmentsFromBase;
	    segmentAttributes = merge(attributes, segmentInfo.base);
	  } else if (segmentInfo.list) {
	    segmentsFn = segmentsFromList;
	    segmentAttributes = merge(attributes, segmentInfo.list);
	  }
	
	  if (!segmentsFn) {
	    return { attributes: attributes };
	  }
	
	  var segments = segmentsFn(segmentAttributes, segmentInfo.timeline);
	
	  // The @duration attribute will be used to determin the playlist's targetDuration which
	  // must be in seconds. Since we've generated the segment list, we no longer need
	  // @duration to be in @timescale units, so we can convert it here.
	  if (segmentAttributes.duration) {
	    var _segmentAttributes = segmentAttributes,
	        duration = _segmentAttributes.duration,
	        _segmentAttributes$ti = _segmentAttributes.timescale,
	        timescale = _segmentAttributes$ti === undefined ? 1 : _segmentAttributes$ti;
	
	
	    segmentAttributes.duration = duration / timescale;
	  } else if (segments.length) {
	    // if there is no @duration attribute, use the largest segment duration as
	    // as target duration
	    segmentAttributes.duration = segments.reduce(function (max, segment) {
	      return Math.max(max, Math.ceil(segment.duration));
	    }, 0);
	  } else {
	    segmentAttributes.duration = 0;
	  }
	
	  return {
	    attributes: segmentAttributes,
	    segments: segments
	  };
	};
	
	var toPlaylists = function toPlaylists(representations) {
	  return representations.map(generateSegments);
	};
	
	var findChildren = function findChildren(element, name) {
	  return from(element.childNodes).filter(function (_ref) {
	    var tagName = _ref.tagName;
	    return tagName === name;
	  });
	};
	
	var getContent = function getContent(element) {
	  return element.textContent.trim();
	};
	
	var parseDuration = function parseDuration(str) {
	  var SECONDS_IN_YEAR = 365 * 24 * 60 * 60;
	  var SECONDS_IN_MONTH = 30 * 24 * 60 * 60;
	  var SECONDS_IN_DAY = 24 * 60 * 60;
	  var SECONDS_IN_HOUR = 60 * 60;
	  var SECONDS_IN_MIN = 60;
	
	  // P10Y10M10DT10H10M10.1S
	  var durationRegex = /P(?:(\d*)Y)?(?:(\d*)M)?(?:(\d*)D)?(?:T(?:(\d*)H)?(?:(\d*)M)?(?:([\d.]*)S)?)?/;
	  var match = durationRegex.exec(str);
	
	  if (!match) {
	    return 0;
	  }
	
	  var _match$slice = match.slice(1),
	      year = _match$slice[0],
	      month = _match$slice[1],
	      day = _match$slice[2],
	      hour = _match$slice[3],
	      minute = _match$slice[4],
	      second = _match$slice[5];
	
	  return parseFloat(year || 0) * SECONDS_IN_YEAR + parseFloat(month || 0) * SECONDS_IN_MONTH + parseFloat(day || 0) * SECONDS_IN_DAY + parseFloat(hour || 0) * SECONDS_IN_HOUR + parseFloat(minute || 0) * SECONDS_IN_MIN + parseFloat(second || 0);
	};
	
	var parseDate = function parseDate(str) {
	  // Date format without timezone according to ISO 8601
	  // YYY-MM-DDThh:mm:ss.ssssss
	  var dateRegex = /^\d+-\d+-\d+T\d+:\d+:\d+(\.\d+)?$/;
	
	  // If the date string does not specifiy a timezone, we must specifiy UTC. This is
	  // expressed by ending with 'Z'
	  if (dateRegex.test(str)) {
	    str += 'Z';
	  }
	
	  return Date.parse(str);
	};
	
	// TODO: maybe order these in some way that makes it easy to find specific attributes
	var parsers = {
	  /**
	   * Specifies the duration of the entire Media Presentation. Format is a duration string
	   * as specified in ISO 8601
	   *
	   * @param {string} value
	   *        value of attribute as a string
	   * @return {number}
	   *         The duration in seconds
	   */
	  mediaPresentationDuration: function mediaPresentationDuration(value) {
	    return parseDuration(value);
	  },
	
	
	  /**
	   * Specifies the Segment availability start time for all Segments referred to in this
	   * MPD. For a dynamic manifest, it specifies the anchor for the earliest availability
	   * time. Format is a date string as specified in ISO 8601
	   *
	   * @param {string} value
	   *        value of attribute as a string
	   * @return {number}
	   *         The date as seconds from unix epoch
	   */
	  availabilityStartTime: function availabilityStartTime(value) {
	    return parseDate(value) / 1000;
	  },
	
	
	  /**
	   * Specifies the smallest period between potential changes to the MPD. Format is a
	   * duration string as specified in ISO 8601
	   *
	   * @param {string} value
	   *        value of attribute as a string
	   * @return {number}
	   *         The duration in seconds
	   */
	  minimumUpdatePeriod: function minimumUpdatePeriod(value) {
	    return parseDuration(value);
	  },
	
	
	  /**
	   * Specifies the duration of the smallest time shifting buffer for any Representation
	   * in the MPD. Format is a duration string as specified in ISO 8601
	   *
	   * @param {string} value
	   *        value of attribute as a string
	   * @return {number}
	   *         The duration in seconds
	   */
	  timeShiftBufferDepth: function timeShiftBufferDepth(value) {
	    return parseDuration(value);
	  },
	
	
	  /**
	   * Specifies the PeriodStart time of the Period relative to the availabilityStarttime.
	   * Format is a duration string as specified in ISO 8601
	   *
	   * @param {string} value
	   *        value of attribute as a string
	   * @return {number}
	   *         The duration in seconds
	   */
	  start: function start(value) {
	    return parseDuration(value);
	  },
	
	
	  /**
	   * Specifies the width of the visual presentation
	   *
	   * @param {string} value
	   *        value of attribute as a string
	   * @return {number}
	   *         The parsed width
	   */
	  width: function width(value) {
	    return parseInt(value, 10);
	  },
	
	
	  /**
	   * Specifies the height of the visual presentation
	   *
	   * @param {string} value
	   *        value of attribute as a string
	   * @return {number}
	   *         The parsed height
	   */
	  height: function height(value) {
	    return parseInt(value, 10);
	  },
	
	
	  /**
	   * Specifies the bitrate of the representation
	   *
	   * @param {string} value
	   *        value of attribute as a string
	   * @return {number}
	   *         The parsed bandwidth
	   */
	  bandwidth: function bandwidth(value) {
	    return parseInt(value, 10);
	  },
	
	
	  /**
	   * Specifies the number of the first Media Segment in this Representation in the Period
	   *
	   * @param {string} value
	   *        value of attribute as a string
	   * @return {number}
	   *         The parsed number
	   */
	  startNumber: function startNumber(value) {
	    return parseInt(value, 10);
	  },
	
	
	  /**
	   * Specifies the timescale in units per seconds
	   *
	   * @param {string} value
	   *        value of attribute as a string
	   * @return {number}
	   *         The aprsed timescale
	   */
	  timescale: function timescale(value) {
	    return parseInt(value, 10);
	  },
	
	
	  /**
	   * Specifies the constant approximate Segment duration
	   * NOTE: The <Period> element also contains an @duration attribute. This duration
	   *       specifies the duration of the Period. This attribute is currently not
	   *       supported by the rest of the parser, however we still check for it to prevent
	   *       errors.
	   *
	   * @param {string} value
	   *        value of attribute as a string
	   * @return {number}
	   *         The parsed duration
	   */
	  duration: function duration(value) {
	    var parsedValue = parseInt(value, 10);
	
	    if (isNaN(parsedValue)) {
	      return parseDuration(value);
	    }
	
	    return parsedValue;
	  },
	
	
	  /**
	   * Specifies the Segment duration, in units of the value of the @timescale.
	   *
	   * @param {string} value
	   *        value of attribute as a string
	   * @return {number}
	   *         The parsed duration
	   */
	  d: function d(value) {
	    return parseInt(value, 10);
	  },
	
	
	  /**
	   * Specifies the MPD start time, in @timescale units, the first Segment in the series
	   * starts relative to the beginning of the Period
	   *
	   * @param {string} value
	   *        value of attribute as a string
	   * @return {number}
	   *         The parsed time
	   */
	  t: function t(value) {
	    return parseInt(value, 10);
	  },
	
	
	  /**
	   * Specifies the repeat count of the number of following contiguous Segments with the
	   * same duration expressed by the value of @d
	   *
	   * @param {string} value
	   *        value of attribute as a string
	   * @return {number}
	   *         The parsed number
	   */
	  r: function r(value) {
	    return parseInt(value, 10);
	  },
	
	
	  /**
	   * Default parser for all other attributes. Acts as a no-op and just returns the value
	   * as a string
	   *
	   * @param {string} value
	   *        value of attribute as a string
	   * @return {string}
	   *         Unparsed value
	   */
	  DEFAULT: function DEFAULT(value) {
	    return value;
	  }
	};
	
	/**
	 * Gets all the attributes and values of the provided node, parses attributes with known
	 * types, and returns an object with attribute names mapped to values.
	 *
	 * @param {Node} el
	 *        The node to parse attributes from
	 * @return {Object}
	 *         Object with all attributes of el parsed
	 */
	var parseAttributes = function parseAttributes(el) {
	  if (!(el && el.attributes)) {
	    return {};
	  }
	
	  return from(el.attributes).reduce(function (a, e) {
	    var parseFn = parsers[e.name] || parsers.DEFAULT;
	
	    a[e.name] = parseFn(e.value);
	
	    return a;
	  }, {});
	};
	
	function decodeB64ToUint8Array(b64Text) {
	  var decodedString = window.atob(b64Text);
	  var array = new Uint8Array(decodedString.length);
	
	  for (var i = 0; i < decodedString.length; i++) {
	    array[i] = decodedString.charCodeAt(i);
	  }
	  return array;
	}
	
	var keySystemsMap = {
	  'urn:uuid:1077efec-c0b2-4d02-ace3-3c1e52e2fb4b': 'org.w3.clearkey',
	  'urn:uuid:edef8ba9-79d6-4ace-a3c8-27dcd51d21ed': 'com.widevine.alpha',
	  'urn:uuid:9a04f079-9840-4286-ab92-e65be0885f95': 'com.microsoft.playready',
	  'urn:uuid:f239e769-efa3-4850-9c16-a903c6932efb': 'com.adobe.primetime'
	};
	
	/**
	 * Builds a list of urls that is the product of the reference urls and BaseURL values
	 *
	 * @param {string[]} referenceUrls
	 *        List of reference urls to resolve to
	 * @param {Node[]} baseUrlElements
	 *        List of BaseURL nodes from the mpd
	 * @return {string[]}
	 *         List of resolved urls
	 */
	var buildBaseUrls = function buildBaseUrls(referenceUrls, baseUrlElements) {
	  if (!baseUrlElements.length) {
	    return referenceUrls;
	  }
	
	  return flatten(referenceUrls.map(function (reference) {
	    return baseUrlElements.map(function (baseUrlElement) {
	      return resolveUrl(reference, getContent(baseUrlElement));
	    });
	  }));
	};
	
	/**
	 * Contains all Segment information for its containing AdaptationSet
	 *
	 * @typedef {Object} SegmentInformation
	 * @property {Object|undefined} template
	 *           Contains the attributes for the SegmentTemplate node
	 * @property {Object[]|undefined} timeline
	 *           Contains a list of atrributes for each S node within the SegmentTimeline node
	 * @property {Object|undefined} list
	 *           Contains the attributes for the SegmentList node
	 * @property {Object|undefined} base
	 *           Contains the attributes for the SegmentBase node
	 */
	
	/**
	 * Returns all available Segment information contained within the AdaptationSet node
	 *
	 * @param {Node} adaptationSet
	 *        The AdaptationSet node to get Segment information from
	 * @return {SegmentInformation}
	 *         The Segment information contained within the provided AdaptationSet
	 */
	var getSegmentInformation = function getSegmentInformation(adaptationSet) {
	  var segmentTemplate = findChildren(adaptationSet, 'SegmentTemplate')[0];
	  var segmentList = findChildren(adaptationSet, 'SegmentList')[0];
	  var segmentUrls = segmentList && findChildren(segmentList, 'SegmentURL').map(function (s) {
	    return merge({ tag: 'SegmentURL' }, parseAttributes(s));
	  });
	  var segmentBase = findChildren(adaptationSet, 'SegmentBase')[0];
	  var segmentTimelineParentNode = segmentList || segmentTemplate;
	  var segmentTimeline = segmentTimelineParentNode && findChildren(segmentTimelineParentNode, 'SegmentTimeline')[0];
	  var segmentInitializationParentNode = segmentList || segmentBase || segmentTemplate;
	  var segmentInitialization = segmentInitializationParentNode && findChildren(segmentInitializationParentNode, 'Initialization')[0];
	
	  // SegmentTemplate is handled slightly differently, since it can have both
	  // @initialization and an <Initialization> node.  @initialization can be templated,
	  // while the node can have a url and range specified.  If the <SegmentTemplate> has
	  // both @initialization and an <Initialization> subelement we opt to override with
	  // the node, as this interaction is not defined in the spec.
	  var template = segmentTemplate && parseAttributes(segmentTemplate);
	
	  if (template && segmentInitialization) {
	    template.initialization = segmentInitialization && parseAttributes(segmentInitialization);
	  } else if (template && template.initialization) {
	    // If it is @initialization we convert it to an object since this is the format that
	    // later functions will rely on for the initialization segment.  This is only valid
	    // for <SegmentTemplate>
	    template.initialization = { sourceURL: template.initialization };
	  }
	
	  var segmentInfo = {
	    template: template,
	    timeline: segmentTimeline && findChildren(segmentTimeline, 'S').map(function (s) {
	      return parseAttributes(s);
	    }),
	    list: segmentList && merge(parseAttributes(segmentList), {
	      segmentUrls: segmentUrls,
	      initialization: parseAttributes(segmentInitialization)
	    }),
	    base: segmentBase && merge(parseAttributes(segmentBase), {
	      initialization: parseAttributes(segmentInitialization)
	    })
	  };
	
	  Object.keys(segmentInfo).forEach(function (key) {
	    if (!segmentInfo[key]) {
	      delete segmentInfo[key];
	    }
	  });
	
	  return segmentInfo;
	};
	
	/**
	 * Contains Segment information and attributes needed to construct a Playlist object
	 * from a Representation
	 *
	 * @typedef {Object} RepresentationInformation
	 * @property {SegmentInformation} segmentInfo
	 *           Segment information for this Representation
	 * @property {Object} attributes
	 *           Inherited attributes for this Representation
	 */
	
	/**
	 * Maps a Representation node to an object containing Segment information and attributes
	 *
	 * @name inheritBaseUrlsCallback
	 * @function
	 * @param {Node} representation
	 *        Representation node from the mpd
	 * @return {RepresentationInformation}
	 *         Representation information needed to construct a Playlist object
	 */
	
	/**
	 * Returns a callback for Array.prototype.map for mapping Representation nodes to
	 * Segment information and attributes using inherited BaseURL nodes.
	 *
	 * @param {Object} adaptationSetAttributes
	 *        Contains attributes inherited by the AdaptationSet
	 * @param {string[]} adaptationSetBaseUrls
	 *        Contains list of resolved base urls inherited by the AdaptationSet
	 * @param {SegmentInformation} adaptationSetSegmentInfo
	 *        Contains Segment information for the AdaptationSet
	 * @return {inheritBaseUrlsCallback}
	 *         Callback map function
	 */
	var inheritBaseUrls = function inheritBaseUrls(adaptationSetAttributes, adaptationSetBaseUrls, adaptationSetSegmentInfo) {
	  return function (representation) {
	    var repBaseUrlElements = findChildren(representation, 'BaseURL');
	    var repBaseUrls = buildBaseUrls(adaptationSetBaseUrls, repBaseUrlElements);
	    var attributes = merge(adaptationSetAttributes, parseAttributes(representation));
	    var representationSegmentInfo = getSegmentInformation(representation);
	
	    return repBaseUrls.map(function (baseUrl) {
	      return {
	        segmentInfo: merge(adaptationSetSegmentInfo, representationSegmentInfo),
	        attributes: merge(attributes, { baseUrl: baseUrl })
	      };
	    });
	  };
	};
	
	/**
	 * Tranforms a series of content protection nodes to
	 * an object containing pssh data by key system
	 *
	 * @param {Node[]} contentProtectionNodes
	 *        Content protection nodes
	 * @return {Object}
	 *        Object containing pssh data by key system
	 */
	var generateKeySystemInformation = function generateKeySystemInformation(contentProtectionNodes) {
	  return contentProtectionNodes.reduce(function (acc, node) {
	    var attributes = parseAttributes(node);
	    var keySystem = keySystemsMap[attributes.schemeIdUri];
	
	    if (keySystem) {
	      acc[keySystem] = { attributes: attributes };
	
	      var psshNode = findChildren(node, 'cenc:pssh')[0];
	
	      if (psshNode) {
	        var pssh = getContent(psshNode);
	        var psshBuffer = pssh && decodeB64ToUint8Array(pssh);
	
	        acc[keySystem].pssh = psshBuffer;
	      }
	    }
	
	    return acc;
	  }, {});
	};
	
	/**
	 * Maps an AdaptationSet node to a list of Representation information objects
	 *
	 * @name toRepresentationsCallback
	 * @function
	 * @param {Node} adaptationSet
	 *        AdaptationSet node from the mpd
	 * @return {RepresentationInformation[]}
	 *         List of objects containing Representaion information
	 */
	
	/**
	 * Returns a callback for Array.prototype.map for mapping AdaptationSet nodes to a list of
	 * Representation information objects
	 *
	 * @param {Object} periodAttributes
	 *        Contains attributes inherited by the Period
	 * @param {string[]} periodBaseUrls
	 *        Contains list of resolved base urls inherited by the Period
	 * @param {string[]} periodSegmentInfo
	 *        Contains Segment Information at the period level
	 * @return {toRepresentationsCallback}
	 *         Callback map function
	 */
	var toRepresentations = function toRepresentations(periodAttributes, periodBaseUrls, periodSegmentInfo) {
	  return function (adaptationSet) {
	    var adaptationSetAttributes = parseAttributes(adaptationSet);
	    var adaptationSetBaseUrls = buildBaseUrls(periodBaseUrls, findChildren(adaptationSet, 'BaseURL'));
	    var role = findChildren(adaptationSet, 'Role')[0];
	    var roleAttributes = { role: parseAttributes(role) };
	
	    var attrs = merge(periodAttributes, adaptationSetAttributes, roleAttributes);
	
	    var contentProtection = generateKeySystemInformation(findChildren(adaptationSet, 'ContentProtection'));
	
	    if (Object.keys(contentProtection).length) {
	      attrs = merge(attrs, { contentProtection: contentProtection });
	    }
	
	    var segmentInfo = getSegmentInformation(adaptationSet);
	    var representations = findChildren(adaptationSet, 'Representation');
	    var adaptationSetSegmentInfo = merge(periodSegmentInfo, segmentInfo);
	
	    return flatten(representations.map(inheritBaseUrls(attrs, adaptationSetBaseUrls, adaptationSetSegmentInfo)));
	  };
	};
	
	/**
	 * Maps an Period node to a list of Representation inforamtion objects for all
	 * AdaptationSet nodes contained within the Period
	 *
	 * @name toAdaptationSetsCallback
	 * @function
	 * @param {Node} period
	 *        Period node from the mpd
	 * @param {number} periodIndex
	 *        Index of the Period within the mpd
	 * @return {RepresentationInformation[]}
	 *         List of objects containing Representaion information
	 */
	
	/**
	 * Returns a callback for Array.prototype.map for mapping Period nodes to a list of
	 * Representation information objects
	 *
	 * @param {Object} mpdAttributes
	 *        Contains attributes inherited by the mpd
	 * @param {string[]} mpdBaseUrls
	 *        Contains list of resolved base urls inherited by the mpd
	 * @return {toAdaptationSetsCallback}
	 *         Callback map function
	 */
	var toAdaptationSets = function toAdaptationSets(mpdAttributes, mpdBaseUrls) {
	  return function (period, periodIndex) {
	    var periodBaseUrls = buildBaseUrls(mpdBaseUrls, findChildren(period, 'BaseURL'));
	    var periodAtt = parseAttributes(period);
	    var periodAttributes = merge(mpdAttributes, periodAtt, { periodIndex: periodIndex });
	    var adaptationSets = findChildren(period, 'AdaptationSet');
	    var periodSegmentInfo = getSegmentInformation(period);
	
	    return flatten(adaptationSets.map(toRepresentations(periodAttributes, periodBaseUrls, periodSegmentInfo)));
	  };
	};
	
	/**
	 * Traverses the mpd xml tree to generate a list of Representation information objects
	 * that have inherited attributes from parent nodes
	 *
	 * @param {Node} mpd
	 *        The root node of the mpd
	 * @param {Object} options
	 *        Available options for inheritAttributes
	 * @param {string} options.manifestUri
	 *        The uri source of the mpd
	 * @param {number} options.NOW
	 *        Current time per DASH IOP.  Default is current time in ms since epoch
	 * @param {number} options.clientOffset
	 *        Client time difference from NOW (in milliseconds)
	 * @return {RepresentationInformation[]}
	 *         List of objects containing Representation information
	 */
	var inheritAttributes = function inheritAttributes(mpd) {
	  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	  var _options$manifestUri = options.manifestUri,
	      manifestUri = _options$manifestUri === undefined ? '' : _options$manifestUri,
	      _options$NOW = options.NOW,
	      NOW = _options$NOW === undefined ? Date.now() : _options$NOW,
	      _options$clientOffset = options.clientOffset,
	      clientOffset = _options$clientOffset === undefined ? 0 : _options$clientOffset;
	
	  var periods = findChildren(mpd, 'Period');
	
	  if (periods.length !== 1) {
	    // TODO add support for multiperiod
	    throw new Error(errors.INVALID_NUMBER_OF_PERIOD);
	  }
	
	  var mpdAttributes = parseAttributes(mpd);
	  var mpdBaseUrls = buildBaseUrls([manifestUri], findChildren(mpd, 'BaseURL'));
	
	  mpdAttributes.sourceDuration = mpdAttributes.mediaPresentationDuration || 0;
	  mpdAttributes.NOW = NOW;
	  mpdAttributes.clientOffset = clientOffset;
	
	  return flatten(periods.map(toAdaptationSets(mpdAttributes, mpdBaseUrls)));
	};
	
	var stringToMpdXml = function stringToMpdXml(manifestString) {
	  if (manifestString === '') {
	    throw new Error(errors.DASH_EMPTY_MANIFEST);
	  }
	
	  var parser = new window.DOMParser();
	  var xml = parser.parseFromString(manifestString, 'application/xml');
	  var mpd = xml && xml.documentElement.tagName === 'MPD' ? xml.documentElement : null;
	
	  if (!mpd || mpd && mpd.getElementsByTagName('parsererror').length > 0) {
	    throw new Error(errors.DASH_INVALID_XML);
	  }
	
	  return mpd;
	};
	
	/**
	 * Parses the manifest for a UTCTiming node, returning the nodes attributes if found
	 *
	 * @param {string} mpd
	 *        XML string of the MPD manifest
	 * @return {Object|null}
	 *         Attributes of UTCTiming node specified in the manifest. Null if none found
	 */
	var parseUTCTimingScheme = function parseUTCTimingScheme(mpd) {
	  var UTCTimingNode = findChildren(mpd, 'UTCTiming')[0];
	
	  if (!UTCTimingNode) {
	    return null;
	  }
	
	  var attributes = parseAttributes(UTCTimingNode);
	
	  switch (attributes.schemeIdUri) {
	    case 'urn:mpeg:dash:utc:http-head:2014':
	    case 'urn:mpeg:dash:utc:http-head:2012':
	      attributes.method = 'HEAD';
	      break;
	    case 'urn:mpeg:dash:utc:http-xsdate:2014':
	    case 'urn:mpeg:dash:utc:http-iso:2014':
	    case 'urn:mpeg:dash:utc:http-xsdate:2012':
	    case 'urn:mpeg:dash:utc:http-iso:2012':
	      attributes.method = 'GET';
	      break;
	    case 'urn:mpeg:dash:utc:direct:2014':
	    case 'urn:mpeg:dash:utc:direct:2012':
	      attributes.method = 'DIRECT';
	      attributes.value = Date.parse(attributes.value);
	      break;
	    case 'urn:mpeg:dash:utc:http-ntp:2014':
	    case 'urn:mpeg:dash:utc:ntp:2014':
	    case 'urn:mpeg:dash:utc:sntp:2014':
	    default:
	      throw new Error(errors.UNSUPPORTED_UTC_TIMING_SCHEME);
	  }
	
	  return attributes;
	};
	
	var VERSION = version;
	
	var parse = function parse(manifestString, options) {
	  return toM3u8(toPlaylists(inheritAttributes(stringToMpdXml(manifestString), options)));
	};
	
	/**
	 * Parses the manifest for a UTCTiming node, returning the nodes attributes if found
	 *
	 * @param {string} manifestString
	 *        XML string of the MPD manifest
	 * @return {Object|null}
	 *         Attributes of UTCTiming node specified in the manifest. Null if none found
	 */
	var parseUTCTiming = function parseUTCTiming(manifestString) {
	  return parseUTCTimingScheme(stringToMpdXml(manifestString));
	};
	
	exports.VERSION = VERSION;
	exports.parse = parse;
	exports.parseUTCTiming = parseUTCTiming;


/***/ },
/* 943 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * mux.js
	 *
	 * Copyright (c) 2016 Brightcove
	 * All rights reserved.
	 *
	 * A stream-based aac to mp4 converter. This utility can be used to
	 * deliver mp4s to a SourceBuffer on platforms that support native
	 * Media Source Extensions.
	 */
	'use strict';
	var Stream = __webpack_require__(99);
	
	// Constants
	var AacStream;
	
	/**
	 * Splits an incoming stream of binary data into ADTS and ID3 Frames.
	 */
	
	AacStream = function() {
	  var
	    everything = new Uint8Array(),
	    timeStamp = 0;
	
	  AacStream.prototype.init.call(this);
	
	  this.setTimestamp = function(timestamp) {
	    timeStamp = timestamp;
	  };
	
	  this.parseId3TagSize = function(header, byteIndex) {
	    var
	      returnSize = (header[byteIndex + 6] << 21) |
	                   (header[byteIndex + 7] << 14) |
	                   (header[byteIndex + 8] << 7) |
	                   (header[byteIndex + 9]),
	      flags = header[byteIndex + 5],
	      footerPresent = (flags & 16) >> 4;
	
	    if (footerPresent) {
	      return returnSize + 20;
	    }
	    return returnSize + 10;
	  };
	
	  this.parseAdtsSize = function(header, byteIndex) {
	    var
	      lowThree = (header[byteIndex + 5] & 0xE0) >> 5,
	      middle = header[byteIndex + 4] << 3,
	      highTwo = header[byteIndex + 3] & 0x3 << 11;
	
	    return (highTwo | middle) | lowThree;
	  };
	
	  this.push = function(bytes) {
	    var
	      frameSize = 0,
	      byteIndex = 0,
	      bytesLeft,
	      chunk,
	      packet,
	      tempLength;
	
	    // If there are bytes remaining from the last segment, prepend them to the
	    // bytes that were pushed in
	    if (everything.length) {
	      tempLength = everything.length;
	      everything = new Uint8Array(bytes.byteLength + tempLength);
	      everything.set(everything.subarray(0, tempLength));
	      everything.set(bytes, tempLength);
	    } else {
	      everything = bytes;
	    }
	
	    while (everything.length - byteIndex >= 3) {
	      if ((everything[byteIndex] === 'I'.charCodeAt(0)) &&
	          (everything[byteIndex + 1] === 'D'.charCodeAt(0)) &&
	          (everything[byteIndex + 2] === '3'.charCodeAt(0))) {
	
	        // Exit early because we don't have enough to parse
	        // the ID3 tag header
	        if (everything.length - byteIndex < 10) {
	          break;
	        }
	
	        // check framesize
	        frameSize = this.parseId3TagSize(everything, byteIndex);
	
	        // Exit early if we don't have enough in the buffer
	        // to emit a full packet
	        if (frameSize > everything.length) {
	          break;
	        }
	        chunk = {
	          type: 'timed-metadata',
	          data: everything.subarray(byteIndex, byteIndex + frameSize)
	        };
	        this.trigger('data', chunk);
	        byteIndex += frameSize;
	        continue;
	      } else if ((everything[byteIndex] & 0xff === 0xff) &&
	                 ((everything[byteIndex + 1] & 0xf0) === 0xf0)) {
	
	        // Exit early because we don't have enough to parse
	        // the ADTS frame header
	        if (everything.length - byteIndex < 7) {
	          break;
	        }
	
	        frameSize = this.parseAdtsSize(everything, byteIndex);
	
	        // Exit early if we don't have enough in the buffer
	        // to emit a full packet
	        if (frameSize > everything.length) {
	          break;
	        }
	
	        packet = {
	          type: 'audio',
	          data: everything.subarray(byteIndex, byteIndex + frameSize),
	          pts: timeStamp,
	          dts: timeStamp
	        };
	        this.trigger('data', packet);
	        byteIndex += frameSize;
	        continue;
	      }
	      byteIndex++;
	    }
	    bytesLeft = everything.length - byteIndex;
	
	    if (bytesLeft > 0) {
	      everything = everything.subarray(byteIndex);
	    } else {
	      everything = new Uint8Array();
	    }
	  };
	};
	
	AacStream.prototype = new Stream();
	
	module.exports = AacStream;


/***/ },
/* 944 */
/***/ function(module, exports) {

	/**
	 * mux.js
	 *
	 * Copyright (c) 2016 Brightcove
	 * All rights reserved.
	 *
	 * Utilities to detect basic properties and metadata about Aac data.
	 */
	'use strict';
	
	var ADTS_SAMPLING_FREQUENCIES = [
	  96000,
	  88200,
	  64000,
	  48000,
	  44100,
	  32000,
	  24000,
	  22050,
	  16000,
	  12000,
	  11025,
	  8000,
	  7350
	];
	
	var parseSyncSafeInteger = function(data) {
	  return (data[0] << 21) |
	          (data[1] << 14) |
	          (data[2] << 7) |
	          (data[3]);
	};
	
	// return a percent-encoded representation of the specified byte range
	// @see http://en.wikipedia.org/wiki/Percent-encoding
	var percentEncode = function(bytes, start, end) {
	  var i, result = '';
	  for (i = start; i < end; i++) {
	    result += '%' + ('00' + bytes[i].toString(16)).slice(-2);
	  }
	  return result;
	};
	
	// return the string representation of the specified byte range,
	// interpreted as ISO-8859-1.
	var parseIso88591 = function(bytes, start, end) {
	  return unescape(percentEncode(bytes, start, end)); // jshint ignore:line
	};
	
	var parseId3TagSize = function(header, byteIndex) {
	  var
	    returnSize = (header[byteIndex + 6] << 21) |
	                 (header[byteIndex + 7] << 14) |
	                 (header[byteIndex + 8] << 7) |
	                 (header[byteIndex + 9]),
	    flags = header[byteIndex + 5],
	    footerPresent = (flags & 16) >> 4;
	
	  if (footerPresent) {
	    return returnSize + 20;
	  }
	  return returnSize + 10;
	};
	
	var parseAdtsSize = function(header, byteIndex) {
	  var
	    lowThree = (header[byteIndex + 5] & 0xE0) >> 5,
	    middle = header[byteIndex + 4] << 3,
	    highTwo = header[byteIndex + 3] & 0x3 << 11;
	
	  return (highTwo | middle) | lowThree;
	};
	
	var parseType = function(header, byteIndex) {
	  if ((header[byteIndex] === 'I'.charCodeAt(0)) &&
	      (header[byteIndex + 1] === 'D'.charCodeAt(0)) &&
	      (header[byteIndex + 2] === '3'.charCodeAt(0))) {
	    return 'timed-metadata';
	  } else if ((header[byteIndex] & 0xff === 0xff) &&
	             ((header[byteIndex + 1] & 0xf0) === 0xf0)) {
	    return 'audio';
	  }
	  return null;
	};
	
	var parseSampleRate = function(packet) {
	  var i = 0;
	
	  while (i + 5 < packet.length) {
	    if (packet[i] !== 0xFF || (packet[i + 1] & 0xF6) !== 0xF0) {
	      // If a valid header was not found,  jump one forward and attempt to
	      // find a valid ADTS header starting at the next byte
	      i++;
	      continue;
	    }
	    return ADTS_SAMPLING_FREQUENCIES[(packet[i + 2] & 0x3c) >>> 2];
	  }
	
	  return null;
	};
	
	var parseAacTimestamp = function(packet) {
	  var frameStart, frameSize, frame, frameHeader;
	
	  // find the start of the first frame and the end of the tag
	  frameStart = 10;
	  if (packet[5] & 0x40) {
	    // advance the frame start past the extended header
	    frameStart += 4; // header size field
	    frameStart += parseSyncSafeInteger(packet.subarray(10, 14));
	  }
	
	  // parse one or more ID3 frames
	  // http://id3.org/id3v2.3.0#ID3v2_frame_overview
	  do {
	    // determine the number of bytes in this frame
	    frameSize = parseSyncSafeInteger(packet.subarray(frameStart + 4, frameStart + 8));
	    if (frameSize < 1) {
	      return null;
	    }
	    frameHeader = String.fromCharCode(packet[frameStart],
	                                      packet[frameStart + 1],
	                                      packet[frameStart + 2],
	                                      packet[frameStart + 3]);
	
	    if (frameHeader === 'PRIV') {
	      frame = packet.subarray(frameStart + 10, frameStart + frameSize + 10);
	
	      for (var i = 0; i < frame.byteLength; i++) {
	        if (frame[i] === 0) {
	          var owner = parseIso88591(frame, 0, i);
	          if (owner === 'com.apple.streaming.transportStreamTimestamp') {
	            var d = frame.subarray(i + 1);
	            var size = ((d[3] & 0x01)  << 30) |
	                       (d[4]  << 22) |
	                       (d[5] << 14) |
	                       (d[6] << 6) |
	                       (d[7] >>> 2);
	            size *= 4;
	            size += d[7] & 0x03;
	
	            return size;
	          }
	          break;
	        }
	      }
	    }
	
	    frameStart += 10; // advance past the frame header
	    frameStart += frameSize; // advance past the frame body
	  } while (frameStart < packet.byteLength);
	  return null;
	};
	
	module.exports = {
	  parseId3TagSize: parseId3TagSize,
	  parseAdtsSize: parseAdtsSize,
	  parseType: parseType,
	  parseSampleRate: parseSampleRate,
	  parseAacTimestamp: parseAacTimestamp
	};


/***/ },
/* 945 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var Stream = __webpack_require__(99);
	
	var AdtsStream;
	
	var
	  ADTS_SAMPLING_FREQUENCIES = [
	    96000,
	    88200,
	    64000,
	    48000,
	    44100,
	    32000,
	    24000,
	    22050,
	    16000,
	    12000,
	    11025,
	    8000,
	    7350
	  ];
	
	/*
	 * Accepts a ElementaryStream and emits data events with parsed
	 * AAC Audio Frames of the individual packets. Input audio in ADTS
	 * format is unpacked and re-emitted as AAC frames.
	 *
	 * @see http://wiki.multimedia.cx/index.php?title=ADTS
	 * @see http://wiki.multimedia.cx/?title=Understanding_AAC
	 */
	AdtsStream = function() {
	  var buffer;
	
	  AdtsStream.prototype.init.call(this);
	
	  this.push = function(packet) {
	    var
	      i = 0,
	      frameNum = 0,
	      frameLength,
	      protectionSkipBytes,
	      frameEnd,
	      oldBuffer,
	      sampleCount,
	      adtsFrameDuration;
	
	    if (packet.type !== 'audio') {
	      // ignore non-audio data
	      return;
	    }
	
	    // Prepend any data in the buffer to the input data so that we can parse
	    // aac frames the cross a PES packet boundary
	    if (buffer) {
	      oldBuffer = buffer;
	      buffer = new Uint8Array(oldBuffer.byteLength + packet.data.byteLength);
	      buffer.set(oldBuffer);
	      buffer.set(packet.data, oldBuffer.byteLength);
	    } else {
	      buffer = packet.data;
	    }
	
	    // unpack any ADTS frames which have been fully received
	    // for details on the ADTS header, see http://wiki.multimedia.cx/index.php?title=ADTS
	    while (i + 5 < buffer.length) {
	
	      // Loook for the start of an ADTS header..
	      if (buffer[i] !== 0xFF || (buffer[i + 1] & 0xF6) !== 0xF0) {
	        // If a valid header was not found,  jump one forward and attempt to
	        // find a valid ADTS header starting at the next byte
	        i++;
	        continue;
	      }
	
	      // The protection skip bit tells us if we have 2 bytes of CRC data at the
	      // end of the ADTS header
	      protectionSkipBytes = (~buffer[i + 1] & 0x01) * 2;
	
	      // Frame length is a 13 bit integer starting 16 bits from the
	      // end of the sync sequence
	      frameLength = ((buffer[i + 3] & 0x03) << 11) |
	        (buffer[i + 4] << 3) |
	        ((buffer[i + 5] & 0xe0) >> 5);
	
	      sampleCount = ((buffer[i + 6] & 0x03) + 1) * 1024;
	      adtsFrameDuration = (sampleCount * 90000) /
	        ADTS_SAMPLING_FREQUENCIES[(buffer[i + 2] & 0x3c) >>> 2];
	
	      frameEnd = i + frameLength;
	
	      // If we don't have enough data to actually finish this ADTS frame, return
	      // and wait for more data
	      if (buffer.byteLength < frameEnd) {
	        return;
	      }
	
	      // Otherwise, deliver the complete AAC frame
	      this.trigger('data', {
	        pts: packet.pts + (frameNum * adtsFrameDuration),
	        dts: packet.dts + (frameNum * adtsFrameDuration),
	        sampleCount: sampleCount,
	        audioobjecttype: ((buffer[i + 2] >>> 6) & 0x03) + 1,
	        channelcount: ((buffer[i + 2] & 1) << 2) |
	          ((buffer[i + 3] & 0xc0) >>> 6),
	        samplerate: ADTS_SAMPLING_FREQUENCIES[(buffer[i + 2] & 0x3c) >>> 2],
	        samplingfrequencyindex: (buffer[i + 2] & 0x3c) >>> 2,
	        // assume ISO/IEC 14496-12 AudioSampleEntry default of 16
	        samplesize: 16,
	        data: buffer.subarray(i + 7 + protectionSkipBytes, frameEnd)
	      });
	
	      // If the buffer is empty, clear it and return
	      if (buffer.byteLength === frameEnd) {
	        buffer = undefined;
	        return;
	      }
	
	      frameNum++;
	
	      // Remove the finished frame from the buffer and start the process again
	      buffer = buffer.subarray(frameEnd);
	    }
	  };
	  this.flush = function() {
	    this.trigger('done');
	  };
	};
	
	AdtsStream.prototype = new Stream();
	
	module.exports = AdtsStream;


/***/ },
/* 946 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var Stream = __webpack_require__(99);
	var ExpGolomb = __webpack_require__(959);
	
	var H264Stream, NalByteStream;
	var PROFILES_WITH_OPTIONAL_SPS_DATA;
	
	/**
	 * Accepts a NAL unit byte stream and unpacks the embedded NAL units.
	 */
	NalByteStream = function() {
	  var
	    syncPoint = 0,
	    i,
	    buffer;
	  NalByteStream.prototype.init.call(this);
	
	  /*
	   * Scans a byte stream and triggers a data event with the NAL units found.
	   * @param {Object} data Event received from H264Stream
	   * @param {Uint8Array} data.data The h264 byte stream to be scanned
	   *
	   * @see H264Stream.push
	   */
	  this.push = function(data) {
	    var swapBuffer;
	
	    if (!buffer) {
	      buffer = data.data;
	    } else {
	      swapBuffer = new Uint8Array(buffer.byteLength + data.data.byteLength);
	      swapBuffer.set(buffer);
	      swapBuffer.set(data.data, buffer.byteLength);
	      buffer = swapBuffer;
	    }
	
	    // Rec. ITU-T H.264, Annex B
	    // scan for NAL unit boundaries
	
	    // a match looks like this:
	    // 0 0 1 .. NAL .. 0 0 1
	    // ^ sync point        ^ i
	    // or this:
	    // 0 0 1 .. NAL .. 0 0 0
	    // ^ sync point        ^ i
	
	    // advance the sync point to a NAL start, if necessary
	    for (; syncPoint < buffer.byteLength - 3; syncPoint++) {
	      if (buffer[syncPoint + 2] === 1) {
	        // the sync point is properly aligned
	        i = syncPoint + 5;
	        break;
	      }
	    }
	
	    while (i < buffer.byteLength) {
	      // look at the current byte to determine if we've hit the end of
	      // a NAL unit boundary
	      switch (buffer[i]) {
	      case 0:
	        // skip past non-sync sequences
	        if (buffer[i - 1] !== 0) {
	          i += 2;
	          break;
	        } else if (buffer[i - 2] !== 0) {
	          i++;
	          break;
	        }
	
	        // deliver the NAL unit if it isn't empty
	        if (syncPoint + 3 !== i - 2) {
	          this.trigger('data', buffer.subarray(syncPoint + 3, i - 2));
	        }
	
	        // drop trailing zeroes
	        do {
	          i++;
	        } while (buffer[i] !== 1 && i < buffer.length);
	        syncPoint = i - 2;
	        i += 3;
	        break;
	      case 1:
	        // skip past non-sync sequences
	        if (buffer[i - 1] !== 0 ||
	            buffer[i - 2] !== 0) {
	          i += 3;
	          break;
	        }
	
	        // deliver the NAL unit
	        this.trigger('data', buffer.subarray(syncPoint + 3, i - 2));
	        syncPoint = i - 2;
	        i += 3;
	        break;
	      default:
	        // the current byte isn't a one or zero, so it cannot be part
	        // of a sync sequence
	        i += 3;
	        break;
	      }
	    }
	    // filter out the NAL units that were delivered
	    buffer = buffer.subarray(syncPoint);
	    i -= syncPoint;
	    syncPoint = 0;
	  };
	
	  this.flush = function() {
	    // deliver the last buffered NAL unit
	    if (buffer && buffer.byteLength > 3) {
	      this.trigger('data', buffer.subarray(syncPoint + 3));
	    }
	    // reset the stream state
	    buffer = null;
	    syncPoint = 0;
	    this.trigger('done');
	  };
	};
	NalByteStream.prototype = new Stream();
	
	// values of profile_idc that indicate additional fields are included in the SPS
	// see Recommendation ITU-T H.264 (4/2013),
	// 7.3.2.1.1 Sequence parameter set data syntax
	PROFILES_WITH_OPTIONAL_SPS_DATA = {
	  100: true,
	  110: true,
	  122: true,
	  244: true,
	  44: true,
	  83: true,
	  86: true,
	  118: true,
	  128: true,
	  138: true,
	  139: true,
	  134: true
	};
	
	/**
	 * Accepts input from a ElementaryStream and produces H.264 NAL unit data
	 * events.
	 */
	H264Stream = function() {
	  var
	    nalByteStream = new NalByteStream(),
	    self,
	    trackId,
	    currentPts,
	    currentDts,
	
	    discardEmulationPreventionBytes,
	    readSequenceParameterSet,
	    skipScalingList;
	
	  H264Stream.prototype.init.call(this);
	  self = this;
	
	  /*
	   * Pushes a packet from a stream onto the NalByteStream
	   *
	   * @param {Object} packet - A packet received from a stream
	   * @param {Uint8Array} packet.data - The raw bytes of the packet
	   * @param {Number} packet.dts - Decode timestamp of the packet
	   * @param {Number} packet.pts - Presentation timestamp of the packet
	   * @param {Number} packet.trackId - The id of the h264 track this packet came from
	   * @param {('video'|'audio')} packet.type - The type of packet
	   *
	   */
	  this.push = function(packet) {
	    if (packet.type !== 'video') {
	      return;
	    }
	    trackId = packet.trackId;
	    currentPts = packet.pts;
	    currentDts = packet.dts;
	
	    nalByteStream.push(packet);
	  };
	
	  /*
	   * Identify NAL unit types and pass on the NALU, trackId, presentation and decode timestamps
	   * for the NALUs to the next stream component.
	   * Also, preprocess caption and sequence parameter NALUs.
	   *
	   * @param {Uint8Array} data - A NAL unit identified by `NalByteStream.push`
	   * @see NalByteStream.push
	   */
	  nalByteStream.on('data', function(data) {
	    var
	      event = {
	        trackId: trackId,
	        pts: currentPts,
	        dts: currentDts,
	        data: data
	      };
	
	    switch (data[0] & 0x1f) {
	    case 0x05:
	      event.nalUnitType = 'slice_layer_without_partitioning_rbsp_idr';
	      break;
	    case 0x06:
	      event.nalUnitType = 'sei_rbsp';
	      event.escapedRBSP = discardEmulationPreventionBytes(data.subarray(1));
	      break;
	    case 0x07:
	      event.nalUnitType = 'seq_parameter_set_rbsp';
	      event.escapedRBSP = discardEmulationPreventionBytes(data.subarray(1));
	      event.config = readSequenceParameterSet(event.escapedRBSP);
	      break;
	    case 0x08:
	      event.nalUnitType = 'pic_parameter_set_rbsp';
	      break;
	    case 0x09:
	      event.nalUnitType = 'access_unit_delimiter_rbsp';
	      break;
	
	    default:
	      break;
	    }
	    // This triggers data on the H264Stream
	    self.trigger('data', event);
	  });
	  nalByteStream.on('done', function() {
	    self.trigger('done');
	  });
	
	  this.flush = function() {
	    nalByteStream.flush();
	  };
	
	  /**
	   * Advance the ExpGolomb decoder past a scaling list. The scaling
	   * list is optionally transmitted as part of a sequence parameter
	   * set and is not relevant to transmuxing.
	   * @param count {number} the number of entries in this scaling list
	   * @param expGolombDecoder {object} an ExpGolomb pointed to the
	   * start of a scaling list
	   * @see Recommendation ITU-T H.264, Section 7.3.2.1.1.1
	   */
	  skipScalingList = function(count, expGolombDecoder) {
	    var
	      lastScale = 8,
	      nextScale = 8,
	      j,
	      deltaScale;
	
	    for (j = 0; j < count; j++) {
	      if (nextScale !== 0) {
	        deltaScale = expGolombDecoder.readExpGolomb();
	        nextScale = (lastScale + deltaScale + 256) % 256;
	      }
	
	      lastScale = (nextScale === 0) ? lastScale : nextScale;
	    }
	  };
	
	  /**
	   * Expunge any "Emulation Prevention" bytes from a "Raw Byte
	   * Sequence Payload"
	   * @param data {Uint8Array} the bytes of a RBSP from a NAL
	   * unit
	   * @return {Uint8Array} the RBSP without any Emulation
	   * Prevention Bytes
	   */
	  discardEmulationPreventionBytes = function(data) {
	    var
	      length = data.byteLength,
	      emulationPreventionBytesPositions = [],
	      i = 1,
	      newLength, newData;
	
	    // Find all `Emulation Prevention Bytes`
	    while (i < length - 2) {
	      if (data[i] === 0 && data[i + 1] === 0 && data[i + 2] === 0x03) {
	        emulationPreventionBytesPositions.push(i + 2);
	        i += 2;
	      } else {
	        i++;
	      }
	    }
	
	    // If no Emulation Prevention Bytes were found just return the original
	    // array
	    if (emulationPreventionBytesPositions.length === 0) {
	      return data;
	    }
	
	    // Create a new array to hold the NAL unit data
	    newLength = length - emulationPreventionBytesPositions.length;
	    newData = new Uint8Array(newLength);
	    var sourceIndex = 0;
	
	    for (i = 0; i < newLength; sourceIndex++, i++) {
	      if (sourceIndex === emulationPreventionBytesPositions[0]) {
	        // Skip this byte
	        sourceIndex++;
	        // Remove this position index
	        emulationPreventionBytesPositions.shift();
	      }
	      newData[i] = data[sourceIndex];
	    }
	
	    return newData;
	  };
	
	  /**
	   * Read a sequence parameter set and return some interesting video
	   * properties. A sequence parameter set is the H264 metadata that
	   * describes the properties of upcoming video frames.
	   * @param data {Uint8Array} the bytes of a sequence parameter set
	   * @return {object} an object with configuration parsed from the
	   * sequence parameter set, including the dimensions of the
	   * associated video frames.
	   */
	  readSequenceParameterSet = function(data) {
	    var
	      frameCropLeftOffset = 0,
	      frameCropRightOffset = 0,
	      frameCropTopOffset = 0,
	      frameCropBottomOffset = 0,
	      sarScale = 1,
	      expGolombDecoder, profileIdc, levelIdc, profileCompatibility,
	      chromaFormatIdc, picOrderCntType,
	      numRefFramesInPicOrderCntCycle, picWidthInMbsMinus1,
	      picHeightInMapUnitsMinus1,
	      frameMbsOnlyFlag,
	      scalingListCount,
	      sarRatio,
	      aspectRatioIdc,
	      i;
	
	    expGolombDecoder = new ExpGolomb(data);
	    profileIdc = expGolombDecoder.readUnsignedByte(); // profile_idc
	    profileCompatibility = expGolombDecoder.readUnsignedByte(); // constraint_set[0-5]_flag
	    levelIdc = expGolombDecoder.readUnsignedByte(); // level_idc u(8)
	    expGolombDecoder.skipUnsignedExpGolomb(); // seq_parameter_set_id
	
	    // some profiles have more optional data we don't need
	    if (PROFILES_WITH_OPTIONAL_SPS_DATA[profileIdc]) {
	      chromaFormatIdc = expGolombDecoder.readUnsignedExpGolomb();
	      if (chromaFormatIdc === 3) {
	        expGolombDecoder.skipBits(1); // separate_colour_plane_flag
	      }
	      expGolombDecoder.skipUnsignedExpGolomb(); // bit_depth_luma_minus8
	      expGolombDecoder.skipUnsignedExpGolomb(); // bit_depth_chroma_minus8
	      expGolombDecoder.skipBits(1); // qpprime_y_zero_transform_bypass_flag
	      if (expGolombDecoder.readBoolean()) { // seq_scaling_matrix_present_flag
	        scalingListCount = (chromaFormatIdc !== 3) ? 8 : 12;
	        for (i = 0; i < scalingListCount; i++) {
	          if (expGolombDecoder.readBoolean()) { // seq_scaling_list_present_flag[ i ]
	            if (i < 6) {
	              skipScalingList(16, expGolombDecoder);
	            } else {
	              skipScalingList(64, expGolombDecoder);
	            }
	          }
	        }
	      }
	    }
	
	    expGolombDecoder.skipUnsignedExpGolomb(); // log2_max_frame_num_minus4
	    picOrderCntType = expGolombDecoder.readUnsignedExpGolomb();
	
	    if (picOrderCntType === 0) {
	      expGolombDecoder.readUnsignedExpGolomb(); // log2_max_pic_order_cnt_lsb_minus4
	    } else if (picOrderCntType === 1) {
	      expGolombDecoder.skipBits(1); // delta_pic_order_always_zero_flag
	      expGolombDecoder.skipExpGolomb(); // offset_for_non_ref_pic
	      expGolombDecoder.skipExpGolomb(); // offset_for_top_to_bottom_field
	      numRefFramesInPicOrderCntCycle = expGolombDecoder.readUnsignedExpGolomb();
	      for (i = 0; i < numRefFramesInPicOrderCntCycle; i++) {
	        expGolombDecoder.skipExpGolomb(); // offset_for_ref_frame[ i ]
	      }
	    }
	
	    expGolombDecoder.skipUnsignedExpGolomb(); // max_num_ref_frames
	    expGolombDecoder.skipBits(1); // gaps_in_frame_num_value_allowed_flag
	
	    picWidthInMbsMinus1 = expGolombDecoder.readUnsignedExpGolomb();
	    picHeightInMapUnitsMinus1 = expGolombDecoder.readUnsignedExpGolomb();
	
	    frameMbsOnlyFlag = expGolombDecoder.readBits(1);
	    if (frameMbsOnlyFlag === 0) {
	      expGolombDecoder.skipBits(1); // mb_adaptive_frame_field_flag
	    }
	
	    expGolombDecoder.skipBits(1); // direct_8x8_inference_flag
	    if (expGolombDecoder.readBoolean()) { // frame_cropping_flag
	      frameCropLeftOffset = expGolombDecoder.readUnsignedExpGolomb();
	      frameCropRightOffset = expGolombDecoder.readUnsignedExpGolomb();
	      frameCropTopOffset = expGolombDecoder.readUnsignedExpGolomb();
	      frameCropBottomOffset = expGolombDecoder.readUnsignedExpGolomb();
	    }
	    if (expGolombDecoder.readBoolean()) {
	      // vui_parameters_present_flag
	      if (expGolombDecoder.readBoolean()) {
	        // aspect_ratio_info_present_flag
	        aspectRatioIdc = expGolombDecoder.readUnsignedByte();
	        switch (aspectRatioIdc) {
	          case 1: sarRatio = [1, 1]; break;
	          case 2: sarRatio = [12, 11]; break;
	          case 3: sarRatio = [10, 11]; break;
	          case 4: sarRatio = [16, 11]; break;
	          case 5: sarRatio = [40, 33]; break;
	          case 6: sarRatio = [24, 11]; break;
	          case 7: sarRatio = [20, 11]; break;
	          case 8: sarRatio = [32, 11]; break;
	          case 9: sarRatio = [80, 33]; break;
	          case 10: sarRatio = [18, 11]; break;
	          case 11: sarRatio = [15, 11]; break;
	          case 12: sarRatio = [64, 33]; break;
	          case 13: sarRatio = [160, 99]; break;
	          case 14: sarRatio = [4, 3]; break;
	          case 15: sarRatio = [3, 2]; break;
	          case 16: sarRatio = [2, 1]; break;
	          case 255: {
	            sarRatio = [expGolombDecoder.readUnsignedByte() << 8 |
	                        expGolombDecoder.readUnsignedByte(),
	                        expGolombDecoder.readUnsignedByte() << 8 |
	                        expGolombDecoder.readUnsignedByte() ];
	            break;
	          }
	        }
	        if (sarRatio) {
	          sarScale = sarRatio[0] / sarRatio[1];
	        }
	      }
	    }
	    return {
	      profileIdc: profileIdc,
	      levelIdc: levelIdc,
	      profileCompatibility: profileCompatibility,
	      width: Math.ceil((((picWidthInMbsMinus1 + 1) * 16) - frameCropLeftOffset * 2 - frameCropRightOffset * 2) * sarScale),
	      height: ((2 - frameMbsOnlyFlag) * (picHeightInMapUnitsMinus1 + 1) * 16) - (frameCropTopOffset * 2) - (frameCropBottomOffset * 2)
	    };
	  };
	
	};
	H264Stream.prototype = new Stream();
	
	module.exports = {
	  H264Stream: H264Stream,
	  NalByteStream: NalByteStream
	};


/***/ },
/* 947 */
/***/ function(module, exports) {

	var highPrefix = [33, 16, 5, 32, 164, 27];
	var lowPrefix = [33, 65, 108, 84, 1, 2, 4, 8, 168, 2, 4, 8, 17, 191, 252];
	var zeroFill = function(count) {
	  var a = [];
	  while (count--) {
	    a.push(0);
	  }
	  return a;
	};
	
	var makeTable = function(metaTable) {
	  return Object.keys(metaTable).reduce(function(obj, key) {
	    obj[key] = new Uint8Array(metaTable[key].reduce(function(arr, part) {
	      return arr.concat(part);
	    }, []));
	    return obj;
	  }, {});
	};
	
	// Frames-of-silence to use for filling in missing AAC frames
	var coneOfSilence = {
	  96000: [highPrefix, [227, 64], zeroFill(154), [56]],
	  88200: [highPrefix, [231], zeroFill(170), [56]],
	  64000: [highPrefix, [248, 192], zeroFill(240), [56]],
	  48000: [highPrefix, [255, 192], zeroFill(268), [55, 148, 128], zeroFill(54), [112]],
	  44100: [highPrefix, [255, 192], zeroFill(268), [55, 163, 128], zeroFill(84), [112]],
	  32000: [highPrefix, [255, 192], zeroFill(268), [55, 234], zeroFill(226), [112]],
	  24000: [highPrefix, [255, 192], zeroFill(268), [55, 255, 128], zeroFill(268), [111, 112], zeroFill(126), [224]],
	  16000: [highPrefix, [255, 192], zeroFill(268), [55, 255, 128], zeroFill(268), [111, 255], zeroFill(269), [223, 108], zeroFill(195), [1, 192]],
	  12000: [lowPrefix, zeroFill(268), [3, 127, 248], zeroFill(268), [6, 255, 240], zeroFill(268), [13, 255, 224], zeroFill(268), [27, 253, 128], zeroFill(259), [56]],
	  11025: [lowPrefix, zeroFill(268), [3, 127, 248], zeroFill(268), [6, 255, 240], zeroFill(268), [13, 255, 224], zeroFill(268), [27, 255, 192], zeroFill(268), [55, 175, 128], zeroFill(108), [112]],
	  8000: [lowPrefix, zeroFill(268), [3, 121, 16], zeroFill(47), [7]]
	};
	
	module.exports = makeTable(coneOfSilence);


/***/ },
/* 948 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * mux.js
	 *
	 * Copyright (c) 2015 Brightcove
	 * All rights reserved.
	 *
	 * A stream-based mp2t to mp4 converter. This utility can be used to
	 * deliver mp4s to a SourceBuffer on platforms that support native
	 * Media Source Extensions.
	 */
	'use strict';
	var Stream = __webpack_require__(99),
	  CaptionStream = __webpack_require__(373),
	  StreamTypes = __webpack_require__(143),
	  TimestampRolloverStream = __webpack_require__(374).TimestampRolloverStream;
	
	var m2tsStreamTypes = __webpack_require__(143);
	
	// object types
	var TransportPacketStream, TransportParseStream, ElementaryStream;
	
	// constants
	var
	  MP2T_PACKET_LENGTH = 188, // bytes
	  SYNC_BYTE = 0x47;
	
	/**
	 * Splits an incoming stream of binary data into MPEG-2 Transport
	 * Stream packets.
	 */
	TransportPacketStream = function() {
	  var
	    buffer = new Uint8Array(MP2T_PACKET_LENGTH),
	    bytesInBuffer = 0;
	
	  TransportPacketStream.prototype.init.call(this);
	
	   // Deliver new bytes to the stream.
	
	  /**
	   * Split a stream of data into M2TS packets
	  **/
	  this.push = function(bytes) {
	    var
	      startIndex = 0,
	      endIndex = MP2T_PACKET_LENGTH,
	      everything;
	
	    // If there are bytes remaining from the last segment, prepend them to the
	    // bytes that were pushed in
	    if (bytesInBuffer) {
	      everything = new Uint8Array(bytes.byteLength + bytesInBuffer);
	      everything.set(buffer.subarray(0, bytesInBuffer));
	      everything.set(bytes, bytesInBuffer);
	      bytesInBuffer = 0;
	    } else {
	      everything = bytes;
	    }
	
	    // While we have enough data for a packet
	    while (endIndex < everything.byteLength) {
	      // Look for a pair of start and end sync bytes in the data..
	      if (everything[startIndex] === SYNC_BYTE && everything[endIndex] === SYNC_BYTE) {
	        // We found a packet so emit it and jump one whole packet forward in
	        // the stream
	        this.trigger('data', everything.subarray(startIndex, endIndex));
	        startIndex += MP2T_PACKET_LENGTH;
	        endIndex += MP2T_PACKET_LENGTH;
	        continue;
	      }
	      // If we get here, we have somehow become de-synchronized and we need to step
	      // forward one byte at a time until we find a pair of sync bytes that denote
	      // a packet
	      startIndex++;
	      endIndex++;
	    }
	
	    // If there was some data left over at the end of the segment that couldn't
	    // possibly be a whole packet, keep it because it might be the start of a packet
	    // that continues in the next segment
	    if (startIndex < everything.byteLength) {
	      buffer.set(everything.subarray(startIndex), 0);
	      bytesInBuffer = everything.byteLength - startIndex;
	    }
	  };
	
	  /**
	   * Passes identified M2TS packets to the TransportParseStream to be parsed
	  **/
	  this.flush = function() {
	    // If the buffer contains a whole packet when we are being flushed, emit it
	    // and empty the buffer. Otherwise hold onto the data because it may be
	    // important for decoding the next segment
	    if (bytesInBuffer === MP2T_PACKET_LENGTH && buffer[0] === SYNC_BYTE) {
	      this.trigger('data', buffer);
	      bytesInBuffer = 0;
	    }
	    this.trigger('done');
	  };
	};
	TransportPacketStream.prototype = new Stream();
	
	/**
	 * Accepts an MP2T TransportPacketStream and emits data events with parsed
	 * forms of the individual transport stream packets.
	 */
	TransportParseStream = function() {
	  var parsePsi, parsePat, parsePmt, self;
	  TransportParseStream.prototype.init.call(this);
	  self = this;
	
	  this.packetsWaitingForPmt = [];
	  this.programMapTable = undefined;
	
	  parsePsi = function(payload, psi) {
	    var offset = 0;
	
	    // PSI packets may be split into multiple sections and those
	    // sections may be split into multiple packets. If a PSI
	    // section starts in this packet, the payload_unit_start_indicator
	    // will be true and the first byte of the payload will indicate
	    // the offset from the current position to the start of the
	    // section.
	    if (psi.payloadUnitStartIndicator) {
	      offset += payload[offset] + 1;
	    }
	
	    if (psi.type === 'pat') {
	      parsePat(payload.subarray(offset), psi);
	    } else {
	      parsePmt(payload.subarray(offset), psi);
	    }
	  };
	
	  parsePat = function(payload, pat) {
	    pat.section_number = payload[7]; // eslint-disable-line camelcase
	    pat.last_section_number = payload[8]; // eslint-disable-line camelcase
	
	    // skip the PSI header and parse the first PMT entry
	    self.pmtPid = (payload[10] & 0x1F) << 8 | payload[11];
	    pat.pmtPid = self.pmtPid;
	  };
	
	  /**
	   * Parse out the relevant fields of a Program Map Table (PMT).
	   * @param payload {Uint8Array} the PMT-specific portion of an MP2T
	   * packet. The first byte in this array should be the table_id
	   * field.
	   * @param pmt {object} the object that should be decorated with
	   * fields parsed from the PMT.
	   */
	  parsePmt = function(payload, pmt) {
	    var sectionLength, tableEnd, programInfoLength, offset;
	
	    // PMTs can be sent ahead of the time when they should actually
	    // take effect. We don't believe this should ever be the case
	    // for HLS but we'll ignore "forward" PMT declarations if we see
	    // them. Future PMT declarations have the current_next_indicator
	    // set to zero.
	    if (!(payload[5] & 0x01)) {
	      return;
	    }
	
	    // overwrite any existing program map table
	    self.programMapTable = {
	      video: null,
	      audio: null,
	      'timed-metadata': {}
	    };
	
	    // the mapping table ends at the end of the current section
	    sectionLength = (payload[1] & 0x0f) << 8 | payload[2];
	    tableEnd = 3 + sectionLength - 4;
	
	    // to determine where the table is, we have to figure out how
	    // long the program info descriptors are
	    programInfoLength = (payload[10] & 0x0f) << 8 | payload[11];
	
	    // advance the offset to the first entry in the mapping table
	    offset = 12 + programInfoLength;
	    while (offset < tableEnd) {
	      var streamType = payload[offset];
	      var pid = (payload[offset + 1] & 0x1F) << 8 | payload[offset + 2];
	
	      // only map a single elementary_pid for audio and video stream types
	      // TODO: should this be done for metadata too? for now maintain behavior of
	      //       multiple metadata streams
	      if (streamType === StreamTypes.H264_STREAM_TYPE &&
	          self.programMapTable.video === null) {
	        self.programMapTable.video = pid;
	      } else if (streamType === StreamTypes.ADTS_STREAM_TYPE &&
	                 self.programMapTable.audio === null) {
	        self.programMapTable.audio = pid;
	      } else if (streamType === StreamTypes.METADATA_STREAM_TYPE) {
	        // map pid to stream type for metadata streams
	        self.programMapTable['timed-metadata'][pid] = streamType;
	      }
	
	      // move to the next table entry
	      // skip past the elementary stream descriptors, if present
	      offset += ((payload[offset + 3] & 0x0F) << 8 | payload[offset + 4]) + 5;
	    }
	
	    // record the map on the packet as well
	    pmt.programMapTable = self.programMapTable;
	  };
	
	  /**
	   * Deliver a new MP2T packet to the next stream in the pipeline.
	   */
	  this.push = function(packet) {
	    var
	      result = {},
	      offset = 4;
	
	    result.payloadUnitStartIndicator = !!(packet[1] & 0x40);
	
	    // pid is a 13-bit field starting at the last bit of packet[1]
	    result.pid = packet[1] & 0x1f;
	    result.pid <<= 8;
	    result.pid |= packet[2];
	
	    // if an adaption field is present, its length is specified by the
	    // fifth byte of the TS packet header. The adaptation field is
	    // used to add stuffing to PES packets that don't fill a complete
	    // TS packet, and to specify some forms of timing and control data
	    // that we do not currently use.
	    if (((packet[3] & 0x30) >>> 4) > 0x01) {
	      offset += packet[offset] + 1;
	    }
	
	    // parse the rest of the packet based on the type
	    if (result.pid === 0) {
	      result.type = 'pat';
	      parsePsi(packet.subarray(offset), result);
	      this.trigger('data', result);
	    } else if (result.pid === this.pmtPid) {
	      result.type = 'pmt';
	      parsePsi(packet.subarray(offset), result);
	      this.trigger('data', result);
	
	      // if there are any packets waiting for a PMT to be found, process them now
	      while (this.packetsWaitingForPmt.length) {
	        this.processPes_.apply(this, this.packetsWaitingForPmt.shift());
	      }
	    } else if (this.programMapTable === undefined) {
	      // When we have not seen a PMT yet, defer further processing of
	      // PES packets until one has been parsed
	      this.packetsWaitingForPmt.push([packet, offset, result]);
	    } else {
	      this.processPes_(packet, offset, result);
	    }
	  };
	
	  this.processPes_ = function(packet, offset, result) {
	    // set the appropriate stream type
	    if (result.pid === this.programMapTable.video) {
	      result.streamType = StreamTypes.H264_STREAM_TYPE;
	    } else if (result.pid === this.programMapTable.audio) {
	      result.streamType = StreamTypes.ADTS_STREAM_TYPE;
	    } else {
	      // if not video or audio, it is timed-metadata or unknown
	      // if unknown, streamType will be undefined
	      result.streamType = this.programMapTable['timed-metadata'][result.pid];
	    }
	
	    result.type = 'pes';
	    result.data = packet.subarray(offset);
	
	    this.trigger('data', result);
	  };
	
	};
	TransportParseStream.prototype = new Stream();
	TransportParseStream.STREAM_TYPES  = {
	  h264: 0x1b,
	  adts: 0x0f
	};
	
	/**
	 * Reconsistutes program elementary stream (PES) packets from parsed
	 * transport stream packets. That is, if you pipe an
	 * mp2t.TransportParseStream into a mp2t.ElementaryStream, the output
	 * events will be events which capture the bytes for individual PES
	 * packets plus relevant metadata that has been extracted from the
	 * container.
	 */
	ElementaryStream = function() {
	  var
	    self = this,
	    // PES packet fragments
	    video = {
	      data: [],
	      size: 0
	    },
	    audio = {
	      data: [],
	      size: 0
	    },
	    timedMetadata = {
	      data: [],
	      size: 0
	    },
	    parsePes = function(payload, pes) {
	      var ptsDtsFlags;
	
	      // get the packet length, this will be 0 for video
	      pes.packetLength = 6 + ((payload[4] << 8) | payload[5]);
	
	      // find out if this packets starts a new keyframe
	      pes.dataAlignmentIndicator = (payload[6] & 0x04) !== 0;
	      // PES packets may be annotated with a PTS value, or a PTS value
	      // and a DTS value. Determine what combination of values is
	      // available to work with.
	      ptsDtsFlags = payload[7];
	
	      // PTS and DTS are normally stored as a 33-bit number.  Javascript
	      // performs all bitwise operations on 32-bit integers but javascript
	      // supports a much greater range (52-bits) of integer using standard
	      // mathematical operations.
	      // We construct a 31-bit value using bitwise operators over the 31
	      // most significant bits and then multiply by 4 (equal to a left-shift
	      // of 2) before we add the final 2 least significant bits of the
	      // timestamp (equal to an OR.)
	      if (ptsDtsFlags & 0xC0) {
	        // the PTS and DTS are not written out directly. For information
	        // on how they are encoded, see
	        // http://dvd.sourceforge.net/dvdinfo/pes-hdr.html
	        pes.pts = (payload[9] & 0x0E) << 27 |
	          (payload[10] & 0xFF) << 20 |
	          (payload[11] & 0xFE) << 12 |
	          (payload[12] & 0xFF) <<  5 |
	          (payload[13] & 0xFE) >>>  3;
	        pes.pts *= 4; // Left shift by 2
	        pes.pts += (payload[13] & 0x06) >>> 1; // OR by the two LSBs
	        pes.dts = pes.pts;
	        if (ptsDtsFlags & 0x40) {
	          pes.dts = (payload[14] & 0x0E) << 27 |
	            (payload[15] & 0xFF) << 20 |
	            (payload[16] & 0xFE) << 12 |
	            (payload[17] & 0xFF) << 5 |
	            (payload[18] & 0xFE) >>> 3;
	          pes.dts *= 4; // Left shift by 2
	          pes.dts += (payload[18] & 0x06) >>> 1; // OR by the two LSBs
	        }
	      }
	      // the data section starts immediately after the PES header.
	      // pes_header_data_length specifies the number of header bytes
	      // that follow the last byte of the field.
	      pes.data = payload.subarray(9 + payload[8]);
	    },
	    /**
	      * Pass completely parsed PES packets to the next stream in the pipeline
	     **/
	    flushStream = function(stream, type, forceFlush) {
	      var
	        packetData = new Uint8Array(stream.size),
	        event = {
	          type: type
	        },
	        i = 0,
	        offset = 0,
	        packetFlushable = false,
	        fragment;
	
	      // do nothing if there is not enough buffered data for a complete
	      // PES header
	      if (!stream.data.length || stream.size < 9) {
	        return;
	      }
	      event.trackId = stream.data[0].pid;
	
	      // reassemble the packet
	      for (i = 0; i < stream.data.length; i++) {
	        fragment = stream.data[i];
	
	        packetData.set(fragment.data, offset);
	        offset += fragment.data.byteLength;
	      }
	
	      // parse assembled packet's PES header
	      parsePes(packetData, event);
	
	      // non-video PES packets MUST have a non-zero PES_packet_length
	      // check that there is enough stream data to fill the packet
	      packetFlushable = type === 'video' || event.packetLength <= stream.size;
	
	      // flush pending packets if the conditions are right
	      if (forceFlush || packetFlushable) {
	        stream.size = 0;
	        stream.data.length = 0;
	      }
	
	      // only emit packets that are complete. this is to avoid assembling
	      // incomplete PES packets due to poor segmentation
	      if (packetFlushable) {
	        self.trigger('data', event);
	      }
	    };
	
	  ElementaryStream.prototype.init.call(this);
	
	  /**
	   * Identifies M2TS packet types and parses PES packets using metadata
	   * parsed from the PMT
	   **/
	  this.push = function(data) {
	    ({
	      pat: function() {
	        // we have to wait for the PMT to arrive as well before we
	        // have any meaningful metadata
	      },
	      pes: function() {
	        var stream, streamType;
	
	        switch (data.streamType) {
	        case StreamTypes.H264_STREAM_TYPE:
	        case m2tsStreamTypes.H264_STREAM_TYPE:
	          stream = video;
	          streamType = 'video';
	          break;
	        case StreamTypes.ADTS_STREAM_TYPE:
	          stream = audio;
	          streamType = 'audio';
	          break;
	        case StreamTypes.METADATA_STREAM_TYPE:
	          stream = timedMetadata;
	          streamType = 'timed-metadata';
	          break;
	        default:
	          // ignore unknown stream types
	          return;
	        }
	
	        // if a new packet is starting, we can flush the completed
	        // packet
	        if (data.payloadUnitStartIndicator) {
	          flushStream(stream, streamType, true);
	        }
	
	        // buffer this fragment until we are sure we've received the
	        // complete payload
	        stream.data.push(data);
	        stream.size += data.data.byteLength;
	      },
	      pmt: function() {
	        var
	          event = {
	            type: 'metadata',
	            tracks: []
	          },
	          programMapTable = data.programMapTable;
	
	        // translate audio and video streams to tracks
	        if (programMapTable.video !== null) {
	          event.tracks.push({
	            timelineStartInfo: {
	              baseMediaDecodeTime: 0
	            },
	            id: +programMapTable.video,
	            codec: 'avc',
	            type: 'video'
	          });
	        }
	        if (programMapTable.audio !== null) {
	          event.tracks.push({
	            timelineStartInfo: {
	              baseMediaDecodeTime: 0
	            },
	            id: +programMapTable.audio,
	            codec: 'adts',
	            type: 'audio'
	          });
	        }
	
	        self.trigger('data', event);
	      }
	    })[data.type]();
	  };
	
	  /**
	   * Flush any remaining input. Video PES packets may be of variable
	   * length. Normally, the start of a new video packet can trigger the
	   * finalization of the previous packet. That is not possible if no
	   * more video is forthcoming, however. In that case, some other
	   * mechanism (like the end of the file) has to be employed. When it is
	   * clear that no additional data is forthcoming, calling this method
	   * will flush the buffered packets.
	   */
	  this.flush = function() {
	    // !!THIS ORDER IS IMPORTANT!!
	    // video first then audio
	    flushStream(video, 'video');
	    flushStream(audio, 'audio');
	    flushStream(timedMetadata, 'timed-metadata');
	    this.trigger('done');
	  };
	};
	ElementaryStream.prototype = new Stream();
	
	var m2ts = {
	  PAT_PID: 0x0000,
	  MP2T_PACKET_LENGTH: MP2T_PACKET_LENGTH,
	  TransportPacketStream: TransportPacketStream,
	  TransportParseStream: TransportParseStream,
	  ElementaryStream: ElementaryStream,
	  TimestampRolloverStream: TimestampRolloverStream,
	  CaptionStream: CaptionStream.CaptionStream,
	  Cea608Stream: CaptionStream.Cea608Stream,
	  MetadataStream: __webpack_require__(949)
	};
	
	for (var type in StreamTypes) {
	  if (StreamTypes.hasOwnProperty(type)) {
	    m2ts[type] = StreamTypes[type];
	  }
	}
	
	module.exports = m2ts;


/***/ },
/* 949 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Accepts program elementary stream (PES) data events and parses out
	 * ID3 metadata from them, if present.
	 * @see http://id3.org/id3v2.3.0
	 */
	'use strict';
	var
	  Stream = __webpack_require__(99),
	  StreamTypes = __webpack_require__(143),
	  // return a percent-encoded representation of the specified byte range
	  // @see http://en.wikipedia.org/wiki/Percent-encoding
	  percentEncode = function(bytes, start, end) {
	    var i, result = '';
	    for (i = start; i < end; i++) {
	      result += '%' + ('00' + bytes[i].toString(16)).slice(-2);
	    }
	    return result;
	  },
	  // return the string representation of the specified byte range,
	  // interpreted as UTf-8.
	  parseUtf8 = function(bytes, start, end) {
	    return decodeURIComponent(percentEncode(bytes, start, end));
	  },
	  // return the string representation of the specified byte range,
	  // interpreted as ISO-8859-1.
	  parseIso88591 = function(bytes, start, end) {
	    return unescape(percentEncode(bytes, start, end)); // jshint ignore:line
	  },
	  parseSyncSafeInteger = function(data) {
	    return (data[0] << 21) |
	            (data[1] << 14) |
	            (data[2] << 7) |
	            (data[3]);
	  },
	  tagParsers = {
	    TXXX: function(tag) {
	      var i;
	      if (tag.data[0] !== 3) {
	        // ignore frames with unrecognized character encodings
	        return;
	      }
	
	      for (i = 1; i < tag.data.length; i++) {
	        if (tag.data[i] === 0) {
	          // parse the text fields
	          tag.description = parseUtf8(tag.data, 1, i);
	          // do not include the null terminator in the tag value
	          tag.value = parseUtf8(tag.data, i + 1, tag.data.length).replace(/\0*$/, '');
	          break;
	        }
	      }
	      tag.data = tag.value;
	    },
	    WXXX: function(tag) {
	      var i;
	      if (tag.data[0] !== 3) {
	        // ignore frames with unrecognized character encodings
	        return;
	      }
	
	      for (i = 1; i < tag.data.length; i++) {
	        if (tag.data[i] === 0) {
	          // parse the description and URL fields
	          tag.description = parseUtf8(tag.data, 1, i);
	          tag.url = parseUtf8(tag.data, i + 1, tag.data.length);
	          break;
	        }
	      }
	    },
	    PRIV: function(tag) {
	      var i;
	
	      for (i = 0; i < tag.data.length; i++) {
	        if (tag.data[i] === 0) {
	          // parse the description and URL fields
	          tag.owner = parseIso88591(tag.data, 0, i);
	          break;
	        }
	      }
	      tag.privateData = tag.data.subarray(i + 1);
	      tag.data = tag.privateData;
	    }
	  },
	  MetadataStream;
	
	MetadataStream = function(options) {
	  var
	    settings = {
	      debug: !!(options && options.debug),
	
	      // the bytes of the program-level descriptor field in MP2T
	      // see ISO/IEC 13818-1:2013 (E), section 2.6 "Program and
	      // program element descriptors"
	      descriptor: options && options.descriptor
	    },
	    // the total size in bytes of the ID3 tag being parsed
	    tagSize = 0,
	    // tag data that is not complete enough to be parsed
	    buffer = [],
	    // the total number of bytes currently in the buffer
	    bufferSize = 0,
	    i;
	
	  MetadataStream.prototype.init.call(this);
	
	  // calculate the text track in-band metadata track dispatch type
	  // https://html.spec.whatwg.org/multipage/embedded-content.html#steps-to-expose-a-media-resource-specific-text-track
	  this.dispatchType = StreamTypes.METADATA_STREAM_TYPE.toString(16);
	  if (settings.descriptor) {
	    for (i = 0; i < settings.descriptor.length; i++) {
	      this.dispatchType += ('00' + settings.descriptor[i].toString(16)).slice(-2);
	    }
	  }
	
	  this.push = function(chunk) {
	    var tag, frameStart, frameSize, frame, i, frameHeader;
	    if (chunk.type !== 'timed-metadata') {
	      return;
	    }
	
	    // if data_alignment_indicator is set in the PES header,
	    // we must have the start of a new ID3 tag. Assume anything
	    // remaining in the buffer was malformed and throw it out
	    if (chunk.dataAlignmentIndicator) {
	      bufferSize = 0;
	      buffer.length = 0;
	    }
	
	    // ignore events that don't look like ID3 data
	    if (buffer.length === 0 &&
	        (chunk.data.length < 10 ||
	          chunk.data[0] !== 'I'.charCodeAt(0) ||
	          chunk.data[1] !== 'D'.charCodeAt(0) ||
	          chunk.data[2] !== '3'.charCodeAt(0))) {
	      if (settings.debug) {
	        // eslint-disable-next-line no-console
	        console.log('Skipping unrecognized metadata packet');
	      }
	      return;
	    }
	
	    // add this chunk to the data we've collected so far
	
	    buffer.push(chunk);
	    bufferSize += chunk.data.byteLength;
	
	    // grab the size of the entire frame from the ID3 header
	    if (buffer.length === 1) {
	      // the frame size is transmitted as a 28-bit integer in the
	      // last four bytes of the ID3 header.
	      // The most significant bit of each byte is dropped and the
	      // results concatenated to recover the actual value.
	      tagSize = parseSyncSafeInteger(chunk.data.subarray(6, 10));
	
	      // ID3 reports the tag size excluding the header but it's more
	      // convenient for our comparisons to include it
	      tagSize += 10;
	    }
	
	    // if the entire frame has not arrived, wait for more data
	    if (bufferSize < tagSize) {
	      return;
	    }
	
	    // collect the entire frame so it can be parsed
	    tag = {
	      data: new Uint8Array(tagSize),
	      frames: [],
	      pts: buffer[0].pts,
	      dts: buffer[0].dts
	    };
	    for (i = 0; i < tagSize;) {
	      tag.data.set(buffer[0].data.subarray(0, tagSize - i), i);
	      i += buffer[0].data.byteLength;
	      bufferSize -= buffer[0].data.byteLength;
	      buffer.shift();
	    }
	
	    // find the start of the first frame and the end of the tag
	    frameStart = 10;
	    if (tag.data[5] & 0x40) {
	      // advance the frame start past the extended header
	      frameStart += 4; // header size field
	      frameStart += parseSyncSafeInteger(tag.data.subarray(10, 14));
	
	      // clip any padding off the end
	      tagSize -= parseSyncSafeInteger(tag.data.subarray(16, 20));
	    }
	
	    // parse one or more ID3 frames
	    // http://id3.org/id3v2.3.0#ID3v2_frame_overview
	    do {
	      // determine the number of bytes in this frame
	      frameSize = parseSyncSafeInteger(tag.data.subarray(frameStart + 4, frameStart + 8));
	      if (frameSize < 1) {
	         // eslint-disable-next-line no-console
	        return console.log('Malformed ID3 frame encountered. Skipping metadata parsing.');
	      }
	      frameHeader = String.fromCharCode(tag.data[frameStart],
	                                        tag.data[frameStart + 1],
	                                        tag.data[frameStart + 2],
	                                        tag.data[frameStart + 3]);
	
	
	      frame = {
	        id: frameHeader,
	        data: tag.data.subarray(frameStart + 10, frameStart + frameSize + 10)
	      };
	      frame.key = frame.id;
	      if (tagParsers[frame.id]) {
	        tagParsers[frame.id](frame);
	
	        // handle the special PRIV frame used to indicate the start
	        // time for raw AAC data
	        if (frame.owner === 'com.apple.streaming.transportStreamTimestamp') {
	          var
	            d = frame.data,
	            size = ((d[3] & 0x01)  << 30) |
	                   (d[4]  << 22) |
	                   (d[5] << 14) |
	                   (d[6] << 6) |
	                   (d[7] >>> 2);
	
	          size *= 4;
	          size += d[7] & 0x03;
	          frame.timeStamp = size;
	          // in raw AAC, all subsequent data will be timestamped based
	          // on the value of this frame
	          // we couldn't have known the appropriate pts and dts before
	          // parsing this ID3 tag so set those values now
	          if (tag.pts === undefined && tag.dts === undefined) {
	            tag.pts = frame.timeStamp;
	            tag.dts = frame.timeStamp;
	          }
	          this.trigger('timestamp', frame);
	        }
	      }
	      tag.frames.push(frame);
	
	      frameStart += 10; // advance past the frame header
	      frameStart += frameSize; // advance past the frame body
	    } while (frameStart < tagSize);
	    this.trigger('data', tag);
	  };
	};
	MetadataStream.prototype = new Stream();
	
	module.exports = MetadataStream;


/***/ },
/* 950 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * mux.js
	 *
	 * Copyright (c) 2016 Brightcove
	 * All rights reserved.
	 *
	 * Utilities to detect basic properties and metadata about TS Segments.
	 */
	'use strict';
	
	var StreamTypes = __webpack_require__(143);
	
	var parsePid = function(packet) {
	  var pid = packet[1] & 0x1f;
	  pid <<= 8;
	  pid |= packet[2];
	  return pid;
	};
	
	var parsePayloadUnitStartIndicator = function(packet) {
	  return !!(packet[1] & 0x40);
	};
	
	var parseAdaptionField = function(packet) {
	  var offset = 0;
	  // if an adaption field is present, its length is specified by the
	  // fifth byte of the TS packet header. The adaptation field is
	  // used to add stuffing to PES packets that don't fill a complete
	  // TS packet, and to specify some forms of timing and control data
	  // that we do not currently use.
	  if (((packet[3] & 0x30) >>> 4) > 0x01) {
	    offset += packet[4] + 1;
	  }
	  return offset;
	};
	
	var parseType = function(packet, pmtPid) {
	  var pid = parsePid(packet);
	  if (pid === 0) {
	    return 'pat';
	  } else if (pid === pmtPid) {
	    return 'pmt';
	  } else if (pmtPid) {
	    return 'pes';
	  }
	  return null;
	};
	
	var parsePat = function(packet) {
	  var pusi = parsePayloadUnitStartIndicator(packet);
	  var offset = 4 + parseAdaptionField(packet);
	
	  if (pusi) {
	    offset += packet[offset] + 1;
	  }
	
	  return (packet[offset + 10] & 0x1f) << 8 | packet[offset + 11];
	};
	
	var parsePmt = function(packet) {
	  var programMapTable = {};
	  var pusi = parsePayloadUnitStartIndicator(packet);
	  var payloadOffset = 4 + parseAdaptionField(packet);
	
	  if (pusi) {
	    payloadOffset += packet[payloadOffset] + 1;
	  }
	
	  // PMTs can be sent ahead of the time when they should actually
	  // take effect. We don't believe this should ever be the case
	  // for HLS but we'll ignore "forward" PMT declarations if we see
	  // them. Future PMT declarations have the current_next_indicator
	  // set to zero.
	  if (!(packet[payloadOffset + 5] & 0x01)) {
	    return;
	  }
	
	  var sectionLength, tableEnd, programInfoLength;
	  // the mapping table ends at the end of the current section
	  sectionLength = (packet[payloadOffset + 1] & 0x0f) << 8 | packet[payloadOffset + 2];
	  tableEnd = 3 + sectionLength - 4;
	
	  // to determine where the table is, we have to figure out how
	  // long the program info descriptors are
	  programInfoLength = (packet[payloadOffset + 10] & 0x0f) << 8 | packet[payloadOffset + 11];
	
	  // advance the offset to the first entry in the mapping table
	  var offset = 12 + programInfoLength;
	  while (offset < tableEnd) {
	    var i = payloadOffset + offset;
	    // add an entry that maps the elementary_pid to the stream_type
	    programMapTable[(packet[i + 1] & 0x1F) << 8 | packet[i + 2]] = packet[i];
	
	    // move to the next table entry
	    // skip past the elementary stream descriptors, if present
	    offset += ((packet[i + 3] & 0x0F) << 8 | packet[i + 4]) + 5;
	  }
	  return programMapTable;
	};
	
	var parsePesType = function(packet, programMapTable) {
	  var pid = parsePid(packet);
	  var type = programMapTable[pid];
	  switch (type) {
	    case StreamTypes.H264_STREAM_TYPE:
	      return 'video';
	    case StreamTypes.ADTS_STREAM_TYPE:
	      return 'audio';
	    case StreamTypes.METADATA_STREAM_TYPE:
	      return 'timed-metadata';
	    default:
	      return null;
	  }
	};
	
	var parsePesTime = function(packet) {
	  var pusi = parsePayloadUnitStartIndicator(packet);
	  if (!pusi) {
	    return null;
	  }
	
	  var offset = 4 + parseAdaptionField(packet);
	
	  if (offset >= packet.byteLength) {
	    // From the H 222.0 MPEG-TS spec
	    // "For transport stream packets carrying PES packets, stuffing is needed when there
	    //  is insufficient PES packet data to completely fill the transport stream packet
	    //  payload bytes. Stuffing is accomplished by defining an adaptation field longer than
	    //  the sum of the lengths of the data elements in it, so that the payload bytes
	    //  remaining after the adaptation field exactly accommodates the available PES packet
	    //  data."
	    //
	    // If the offset is >= the length of the packet, then the packet contains no data
	    // and instead is just adaption field stuffing bytes
	    return null;
	  }
	
	  var pes = null;
	  var ptsDtsFlags;
	
	  // PES packets may be annotated with a PTS value, or a PTS value
	  // and a DTS value. Determine what combination of values is
	  // available to work with.
	  ptsDtsFlags = packet[offset + 7];
	
	  // PTS and DTS are normally stored as a 33-bit number.  Javascript
	  // performs all bitwise operations on 32-bit integers but javascript
	  // supports a much greater range (52-bits) of integer using standard
	  // mathematical operations.
	  // We construct a 31-bit value using bitwise operators over the 31
	  // most significant bits and then multiply by 4 (equal to a left-shift
	  // of 2) before we add the final 2 least significant bits of the
	  // timestamp (equal to an OR.)
	  if (ptsDtsFlags & 0xC0) {
	    pes = {};
	    // the PTS and DTS are not written out directly. For information
	    // on how they are encoded, see
	    // http://dvd.sourceforge.net/dvdinfo/pes-hdr.html
	    pes.pts = (packet[offset + 9] & 0x0E) << 27 |
	      (packet[offset + 10] & 0xFF) << 20 |
	      (packet[offset + 11] & 0xFE) << 12 |
	      (packet[offset + 12] & 0xFF) <<  5 |
	      (packet[offset + 13] & 0xFE) >>>  3;
	    pes.pts *= 4; // Left shift by 2
	    pes.pts += (packet[offset + 13] & 0x06) >>> 1; // OR by the two LSBs
	    pes.dts = pes.pts;
	    if (ptsDtsFlags & 0x40) {
	      pes.dts = (packet[offset + 14] & 0x0E) << 27 |
	        (packet[offset + 15] & 0xFF) << 20 |
	        (packet[offset + 16] & 0xFE) << 12 |
	        (packet[offset + 17] & 0xFF) << 5 |
	        (packet[offset + 18] & 0xFE) >>> 3;
	      pes.dts *= 4; // Left shift by 2
	      pes.dts += (packet[offset + 18] & 0x06) >>> 1; // OR by the two LSBs
	    }
	  }
	  return pes;
	};
	
	var parseNalUnitType = function(type) {
	  switch (type) {
	    case 0x05:
	      return 'slice_layer_without_partitioning_rbsp_idr';
	    case 0x06:
	      return 'sei_rbsp';
	    case 0x07:
	      return 'seq_parameter_set_rbsp';
	    case 0x08:
	      return 'pic_parameter_set_rbsp';
	    case 0x09:
	      return 'access_unit_delimiter_rbsp';
	    default:
	      return null;
	  }
	};
	
	var videoPacketContainsKeyFrame = function(packet) {
	  var offset = 4 + parseAdaptionField(packet);
	  var frameBuffer = packet.subarray(offset);
	  var frameI = 0;
	  var frameSyncPoint = 0;
	  var foundKeyFrame = false;
	  var nalType;
	
	  // advance the sync point to a NAL start, if necessary
	  for (; frameSyncPoint < frameBuffer.byteLength - 3; frameSyncPoint++) {
	    if (frameBuffer[frameSyncPoint + 2] === 1) {
	      // the sync point is properly aligned
	      frameI = frameSyncPoint + 5;
	      break;
	    }
	  }
	
	  while (frameI < frameBuffer.byteLength) {
	    // look at the current byte to determine if we've hit the end of
	    // a NAL unit boundary
	    switch (frameBuffer[frameI]) {
	    case 0:
	      // skip past non-sync sequences
	      if (frameBuffer[frameI - 1] !== 0) {
	        frameI += 2;
	        break;
	      } else if (frameBuffer[frameI - 2] !== 0) {
	        frameI++;
	        break;
	      }
	
	      if (frameSyncPoint + 3 !== frameI - 2) {
	        nalType = parseNalUnitType(frameBuffer[frameSyncPoint + 3] & 0x1f);
	        if (nalType === 'slice_layer_without_partitioning_rbsp_idr') {
	          foundKeyFrame = true;
	        }
	      }
	
	      // drop trailing zeroes
	      do {
	        frameI++;
	      } while (frameBuffer[frameI] !== 1 && frameI < frameBuffer.length);
	      frameSyncPoint = frameI - 2;
	      frameI += 3;
	      break;
	    case 1:
	      // skip past non-sync sequences
	      if (frameBuffer[frameI - 1] !== 0 ||
	          frameBuffer[frameI - 2] !== 0) {
	        frameI += 3;
	        break;
	      }
	
	      nalType = parseNalUnitType(frameBuffer[frameSyncPoint + 3] & 0x1f);
	      if (nalType === 'slice_layer_without_partitioning_rbsp_idr') {
	        foundKeyFrame = true;
	      }
	      frameSyncPoint = frameI - 2;
	      frameI += 3;
	      break;
	    default:
	      // the current byte isn't a one or zero, so it cannot be part
	      // of a sync sequence
	      frameI += 3;
	      break;
	    }
	  }
	  frameBuffer = frameBuffer.subarray(frameSyncPoint);
	  frameI -= frameSyncPoint;
	  frameSyncPoint = 0;
	  // parse the final nal
	  if (frameBuffer && frameBuffer.byteLength > 3) {
	    nalType = parseNalUnitType(frameBuffer[frameSyncPoint + 3] & 0x1f);
	    if (nalType === 'slice_layer_without_partitioning_rbsp_idr') {
	      foundKeyFrame = true;
	    }
	  }
	
	  return foundKeyFrame;
	};
	
	
	module.exports = {
	  parseType: parseType,
	  parsePat: parsePat,
	  parsePmt: parsePmt,
	  parsePayloadUnitStartIndicator: parsePayloadUnitStartIndicator,
	  parsePesType: parsePesType,
	  parsePesTime: parsePesTime,
	  videoPacketContainsKeyFrame: videoPacketContainsKeyFrame
	};


/***/ },
/* 951 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * mux.js
	 *
	 * Copyright (c) 2015 Brightcove
	 * All rights reserved.
	 *
	 * Reads in-band CEA-708 captions out of FMP4 segments.
	 * @see https://en.wikipedia.org/wiki/CEA-708
	 */
	'use strict';
	
	var discardEmulationPreventionBytes = __webpack_require__(376).discardEmulationPreventionBytes;
	var CaptionStream = __webpack_require__(373).CaptionStream;
	var probe = __webpack_require__(183);
	var inspect = __webpack_require__(955);
	
	/**
	  * Maps an offset in the mdat to a sample based on the the size of the samples.
	  * Assumes that `parseSamples` has been called first.
	  *
	  * @param {Number} offset - The offset into the mdat
	  * @param {Object[]} samples - An array of samples, parsed using `parseSamples`
	  * @return {?Object} The matching sample, or null if no match was found.
	  *
	  * @see ISO-BMFF-12/2015, Section 8.8.8
	 **/
	var mapToSample = function(offset, samples) {
	  var approximateOffset = offset;
	
	  for (var i = 0; i < samples.length; i++) {
	    var sample = samples[i];
	
	    if (approximateOffset < sample.size) {
	      return sample;
	    }
	
	    approximateOffset -= sample.size;
	  }
	
	  return null;
	};
	
	/**
	  * Finds SEI nal units contained in a Media Data Box.
	  * Assumes that `parseSamples` has been called first.
	  *
	  * @param {Uint8Array} avcStream - The bytes of the mdat
	  * @param {Object[]} samples - The samples parsed out by `parseSamples`
	  * @param {Number} trackId - The trackId of this video track
	  * @return {Object[]} seiNals - the parsed SEI NALUs found.
	  *   The contents of the seiNal should match what is expected by
	  *   CaptionStream.push (nalUnitType, size, data, escapedRBSP, pts, dts)
	  *
	  * @see ISO-BMFF-12/2015, Section 8.1.1
	  * @see Rec. ITU-T H.264, 7.3.2.3.1
	 **/
	var findSeiNals = function(avcStream, samples, trackId) {
	  var
	    avcView = new DataView(avcStream.buffer, avcStream.byteOffset, avcStream.byteLength),
	    result = [],
	    seiNal,
	    i,
	    length,
	    lastMatchedSample;
	
	  for (i = 0; i + 4 < avcStream.length; i += length) {
	    length = avcView.getUint32(i);
	    i += 4;
	
	    // Bail if this doesn't appear to be an H264 stream
	    if (length <= 0) {
	      continue;
	    }
	
	    switch (avcStream[i] & 0x1F) {
	    case 0x06:
	      var data = avcStream.subarray(i + 1, i + 1 + length);
	      var matchingSample = mapToSample(i, samples);
	
	      seiNal = {
	        nalUnitType: 'sei_rbsp',
	        size: length,
	        data: data,
	        escapedRBSP: discardEmulationPreventionBytes(data),
	        trackId: trackId
	      };
	
	      if (matchingSample) {
	        seiNal.pts = matchingSample.pts;
	        seiNal.dts = matchingSample.dts;
	        lastMatchedSample = matchingSample;
	      } else {
	        // If a matching sample cannot be found, use the last
	        // sample's values as they should be as close as possible
	        seiNal.pts = lastMatchedSample.pts;
	        seiNal.dts = lastMatchedSample.dts;
	      }
	
	      result.push(seiNal);
	      break;
	    default:
	      break;
	    }
	  }
	
	  return result;
	};
	
	/**
	  * Parses sample information out of Track Run Boxes and calculates
	  * the absolute presentation and decode timestamps of each sample.
	  *
	  * @param {Array<Uint8Array>} truns - The Trun Run boxes to be parsed
	  * @param {Number} baseMediaDecodeTime - base media decode time from tfdt
	      @see ISO-BMFF-12/2015, Section 8.8.12
	  * @param {Object} tfhd - The parsed Track Fragment Header
	  *   @see inspect.parseTfhd
	  * @return {Object[]} the parsed samples
	  *
	  * @see ISO-BMFF-12/2015, Section 8.8.8
	 **/
	var parseSamples = function(truns, baseMediaDecodeTime, tfhd) {
	  var currentDts = baseMediaDecodeTime;
	  var defaultSampleDuration = tfhd.defaultSampleDuration || 0;
	  var defaultSampleSize = tfhd.defaultSampleSize || 0;
	  var trackId = tfhd.trackId;
	  var allSamples = [];
	
	  truns.forEach(function(trun) {
	    // Note: We currently do not parse the sample table as well
	    // as the trun. It's possible some sources will require this.
	    // moov > trak > mdia > minf > stbl
	    var trackRun = inspect.parseTrun(trun);
	    var samples = trackRun.samples;
	
	    samples.forEach(function(sample) {
	      if (sample.duration === undefined) {
	        sample.duration = defaultSampleDuration;
	      }
	      if (sample.size === undefined) {
	        sample.size = defaultSampleSize;
	      }
	      sample.trackId = trackId;
	      sample.dts = currentDts;
	      if (sample.compositionTimeOffset === undefined) {
	        sample.compositionTimeOffset = 0;
	      }
	      sample.pts = currentDts + sample.compositionTimeOffset;
	
	      currentDts += sample.duration;
	    });
	
	    allSamples = allSamples.concat(samples);
	  });
	
	  return allSamples;
	};
	
	/**
	  * Parses out caption nals from an FMP4 segment's video tracks.
	  *
	  * @param {Uint8Array} segment - The bytes of a single segment
	  * @param {Number} videoTrackId - The trackId of a video track in the segment
	  * @return {Object.<Number, Object[]>} A mapping of video trackId to
	  *   a list of seiNals found in that track
	 **/
	var parseCaptionNals = function(segment, videoTrackId) {
	  // To get the samples
	  var trafs = probe.findBox(segment, ['moof', 'traf']);
	  // To get SEI NAL units
	  var mdats = probe.findBox(segment, ['mdat']);
	  var captionNals = {};
	  var mdatTrafPairs = [];
	
	  // Pair up each traf with a mdat as moofs and mdats are in pairs
	  mdats.forEach(function(mdat, index) {
	    var matchingTraf = trafs[index];
	    mdatTrafPairs.push({
	      mdat: mdat,
	      traf: matchingTraf
	    });
	  });
	
	  mdatTrafPairs.forEach(function(pair) {
	    var mdat = pair.mdat;
	    var traf = pair.traf;
	    var tfhd = probe.findBox(traf, ['tfhd']);
	    // Exactly 1 tfhd per traf
	    var headerInfo = inspect.parseTfhd(tfhd[0]);
	    var trackId = headerInfo.trackId;
	    var tfdt = probe.findBox(traf, ['tfdt']);
	    // Either 0 or 1 tfdt per traf
	    var baseMediaDecodeTime = (tfdt.length > 0) ? inspect.parseTfdt(tfdt[0]).baseMediaDecodeTime : 0;
	    var truns = probe.findBox(traf, ['trun']);
	    var samples;
	    var seiNals;
	
	    // Only parse video data for the chosen video track
	    if (videoTrackId === trackId && truns.length > 0) {
	      samples = parseSamples(truns, baseMediaDecodeTime, headerInfo);
	
	      seiNals = findSeiNals(mdat, samples, trackId);
	
	      if (!captionNals[trackId]) {
	        captionNals[trackId] = [];
	      }
	
	      captionNals[trackId] = captionNals[trackId].concat(seiNals);
	    }
	  });
	
	  return captionNals;
	};
	
	/**
	  * Parses out inband captions from an MP4 container and returns
	  * caption objects that can be used by WebVTT and the TextTrack API.
	  * @see https://developer.mozilla.org/en-US/docs/Web/API/VTTCue
	  * @see https://developer.mozilla.org/en-US/docs/Web/API/TextTrack
	  * Assumes that `probe.getVideoTrackIds` and `probe.timescale` have been called first
	  *
	  * @param {Uint8Array} segment - The fmp4 segment containing embedded captions
	  * @param {Number} trackId - The id of the video track to parse
	  * @param {Number} timescale - The timescale for the video track from the init segment
	  *
	  * @return {?Object[]} parsedCaptions - A list of captions or null if no video tracks
	  * @return {Number} parsedCaptions[].startTime - The time to show the caption in seconds
	  * @return {Number} parsedCaptions[].endTime - The time to stop showing the caption in seconds
	  * @return {String} parsedCaptions[].text - The visible content of the caption
	 **/
	var parseEmbeddedCaptions = function(segment, trackId, timescale) {
	  var seiNals;
	
	  if (!trackId) {
	    return null;
	  }
	
	  seiNals = parseCaptionNals(segment, trackId);
	
	  return {
	    seiNals: seiNals[trackId],
	    timescale: timescale
	  };
	};
	
	/**
	  * Converts SEI NALUs into captions that can be used by video.js
	 **/
	var CaptionParser = function() {
	  var isInitialized = false;
	  var captionStream;
	
	  // Stores segments seen before trackId and timescale are set
	  var segmentCache;
	  // Stores video track ID of the track being parsed
	  var trackId;
	  // Stores the timescale of the track being parsed
	  var timescale;
	  // Stores captions parsed so far
	  var parsedCaptions;
	
	  /**
	    * A method to indicate whether a CaptionParser has been initalized
	    * @returns {Boolean}
	   **/
	  this.isInitialized = function() {
	    return isInitialized;
	  };
	
	  /**
	    * Initializes the underlying CaptionStream, SEI NAL parsing
	    * and management, and caption collection
	   **/
	  this.init = function() {
	    captionStream = new CaptionStream();
	    isInitialized = true;
	
	    // Collect dispatched captions
	    captionStream.on('data', function(event) {
	      // Convert to seconds in the source's timescale
	      event.startTime = event.startPts / timescale;
	      event.endTime = event.endPts / timescale;
	
	      parsedCaptions.captions.push(event);
	      parsedCaptions.captionStreams[event.stream] = true;
	    });
	  };
	
	  /**
	    * Determines if a new video track will be selected
	    * or if the timescale changed
	    * @return {Boolean}
	   **/
	  this.isNewInit = function(videoTrackIds, timescales) {
	    if ((videoTrackIds && videoTrackIds.length === 0) ||
	        (timescales && typeof timescales === 'object' &&
	          Object.keys(timescales).length === 0)) {
	      return false;
	    }
	
	    return trackId !== videoTrackIds[0] ||
	      timescale !== timescales[trackId];
	  };
	
	  /**
	    * Parses out SEI captions and interacts with underlying
	    * CaptionStream to return dispatched captions
	    *
	    * @param {Uint8Array} segment - The fmp4 segment containing embedded captions
	    * @param {Number[]} videoTrackIds - A list of video tracks found in the init segment
	    * @param {Object.<Number, Number>} timescales - The timescales found in the init segment
	    * @see parseEmbeddedCaptions
	    * @see m2ts/caption-stream.js
	   **/
	  this.parse = function(segment, videoTrackIds, timescales) {
	    var parsedData;
	
	    if (!this.isInitialized()) {
	      return null;
	
	    // This is not likely to be a video segment
	    } else if (!videoTrackIds || !timescales) {
	      return null;
	
	    } else if (this.isNewInit(videoTrackIds, timescales)) {
	      // Use the first video track only as there is no
	      // mechanism to switch to other video tracks
	      trackId = videoTrackIds[0];
	      timescale = timescales[trackId];
	
	    // If an init segment has not been seen yet, hold onto segment
	    // data until we have one
	    } else if (!trackId || !timescale) {
	      segmentCache.push(segment);
	      return null;
	    }
	
	    // Now that a timescale and trackId is set, parse cached segments
	    while (segmentCache.length > 0) {
	      var cachedSegment = segmentCache.shift();
	
	      this.parse(cachedSegment, videoTrackIds, timescales);
	    }
	
	    parsedData = parseEmbeddedCaptions(segment, trackId, timescale);
	
	    if (parsedData === null || !parsedData.seiNals) {
	      return null;
	    }
	
	    this.pushNals(parsedData.seiNals);
	    // Force the parsed captions to be dispatched
	    this.flushStream();
	
	    return parsedCaptions;
	  };
	
	  /**
	    * Pushes SEI NALUs onto CaptionStream
	    * @param {Object[]} nals - A list of SEI nals parsed using `parseCaptionNals`
	    * Assumes that `parseCaptionNals` has been called first
	    * @see m2ts/caption-stream.js
	    **/
	  this.pushNals = function(nals) {
	    if (!this.isInitialized() || !nals || nals.length === 0) {
	      return null;
	    }
	
	    nals.forEach(function(nal) {
	      captionStream.push(nal);
	    });
	  };
	
	  /**
	    * Flushes underlying CaptionStream to dispatch processed, displayable captions
	    * @see m2ts/caption-stream.js
	   **/
	  this.flushStream = function() {
	    if (!this.isInitialized()) {
	      return null;
	    }
	
	    captionStream.flush();
	  };
	
	  /**
	    * Reset caption buckets for new data
	   **/
	  this.clearParsedCaptions = function() {
	    parsedCaptions.captions = [];
	    parsedCaptions.captionStreams = {};
	  };
	
	  /**
	    * Resets underlying CaptionStream
	    * @see m2ts/caption-stream.js
	   **/
	  this.resetCaptionStream = function() {
	    if (!this.isInitialized()) {
	      return null;
	    }
	
	    captionStream.reset();
	  };
	
	  /**
	    * Convenience method to clear all captions flushed from the
	    * CaptionStream and still being parsed
	    * @see m2ts/caption-stream.js
	   **/
	  this.clearAllCaptions = function() {
	    this.clearParsedCaptions();
	    this.resetCaptionStream();
	  };
	
	  /**
	    * Reset caption parser
	   **/
	  this.reset = function() {
	    segmentCache = [];
	    trackId = null;
	    timescale = null;
	
	    if (!parsedCaptions) {
	      parsedCaptions = {
	        captions: [],
	        // CC1, CC2, CC3, CC4
	        captionStreams: {}
	      };
	    } else {
	      this.clearParsedCaptions();
	    }
	
	    this.resetCaptionStream();
	  };
	
	  this.reset();
	};
	
	module.exports = CaptionParser;


/***/ },
/* 952 */
/***/ function(module, exports) {

	// Convert an array of nal units into an array of frames with each frame being
	// composed of the nal units that make up that frame
	// Also keep track of cummulative data about the frame from the nal units such
	// as the frame duration, starting pts, etc.
	var groupNalsIntoFrames = function(nalUnits) {
	  var
	    i,
	    currentNal,
	    currentFrame = [],
	    frames = [];
	
	  currentFrame.byteLength = 0;
	
	  for (i = 0; i < nalUnits.length; i++) {
	    currentNal = nalUnits[i];
	
	    // Split on 'aud'-type nal units
	    if (currentNal.nalUnitType === 'access_unit_delimiter_rbsp') {
	      // Since the very first nal unit is expected to be an AUD
	      // only push to the frames array when currentFrame is not empty
	      if (currentFrame.length) {
	        currentFrame.duration = currentNal.dts - currentFrame.dts;
	        frames.push(currentFrame);
	      }
	      currentFrame = [currentNal];
	      currentFrame.byteLength = currentNal.data.byteLength;
	      currentFrame.pts = currentNal.pts;
	      currentFrame.dts = currentNal.dts;
	    } else {
	      // Specifically flag key frames for ease of use later
	      if (currentNal.nalUnitType === 'slice_layer_without_partitioning_rbsp_idr') {
	        currentFrame.keyFrame = true;
	      }
	      currentFrame.duration = currentNal.dts - currentFrame.dts;
	      currentFrame.byteLength += currentNal.data.byteLength;
	      currentFrame.push(currentNal);
	    }
	  }
	
	  // For the last frame, use the duration of the previous frame if we
	  // have nothing better to go on
	  if (frames.length &&
	      (!currentFrame.duration ||
	       currentFrame.duration <= 0)) {
	    currentFrame.duration = frames[frames.length - 1].duration;
	  }
	
	  // Push the final frame
	  frames.push(currentFrame);
	  return frames;
	};
	
	// Convert an array of frames into an array of Gop with each Gop being composed
	// of the frames that make up that Gop
	// Also keep track of cummulative data about the Gop from the frames such as the
	// Gop duration, starting pts, etc.
	var groupFramesIntoGops = function(frames) {
	  var
	    i,
	    currentFrame,
	    currentGop = [],
	    gops = [];
	
	  // We must pre-set some of the values on the Gop since we
	  // keep running totals of these values
	  currentGop.byteLength = 0;
	  currentGop.nalCount = 0;
	  currentGop.duration = 0;
	  currentGop.pts = frames[0].pts;
	  currentGop.dts = frames[0].dts;
	
	  // store some metadata about all the Gops
	  gops.byteLength = 0;
	  gops.nalCount = 0;
	  gops.duration = 0;
	  gops.pts = frames[0].pts;
	  gops.dts = frames[0].dts;
	
	  for (i = 0; i < frames.length; i++) {
	    currentFrame = frames[i];
	
	    if (currentFrame.keyFrame) {
	      // Since the very first frame is expected to be an keyframe
	      // only push to the gops array when currentGop is not empty
	      if (currentGop.length) {
	        gops.push(currentGop);
	        gops.byteLength += currentGop.byteLength;
	        gops.nalCount += currentGop.nalCount;
	        gops.duration += currentGop.duration;
	      }
	
	      currentGop = [currentFrame];
	      currentGop.nalCount = currentFrame.length;
	      currentGop.byteLength = currentFrame.byteLength;
	      currentGop.pts = currentFrame.pts;
	      currentGop.dts = currentFrame.dts;
	      currentGop.duration = currentFrame.duration;
	    } else {
	      currentGop.duration += currentFrame.duration;
	      currentGop.nalCount += currentFrame.length;
	      currentGop.byteLength += currentFrame.byteLength;
	      currentGop.push(currentFrame);
	    }
	  }
	
	  if (gops.length && currentGop.duration <= 0) {
	    currentGop.duration = gops[gops.length - 1].duration;
	  }
	  gops.byteLength += currentGop.byteLength;
	  gops.nalCount += currentGop.nalCount;
	  gops.duration += currentGop.duration;
	
	  // push the final Gop
	  gops.push(currentGop);
	  return gops;
	};
	
	/*
	 * Search for the first keyframe in the GOPs and throw away all frames
	 * until that keyframe. Then extend the duration of the pulled keyframe
	 * and pull the PTS and DTS of the keyframe so that it covers the time
	 * range of the frames that were disposed.
	 *
	 * @param {Array} gops video GOPs
	 * @returns {Array} modified video GOPs
	 */
	var extendFirstKeyFrame = function(gops) {
	  var currentGop;
	
	  if (!gops[0][0].keyFrame && gops.length > 1) {
	    // Remove the first GOP
	    currentGop = gops.shift();
	
	    gops.byteLength -= currentGop.byteLength;
	    gops.nalCount -= currentGop.nalCount;
	
	    // Extend the first frame of what is now the
	    // first gop to cover the time period of the
	    // frames we just removed
	    gops[0][0].dts = currentGop.dts;
	    gops[0][0].pts = currentGop.pts;
	    gops[0][0].duration += currentGop.duration;
	  }
	
	  return gops;
	};
	
	/**
	 * Default sample object
	 * see ISO/IEC 14496-12:2012, section 8.6.4.3
	 */
	var createDefaultSample = function() {
	  return {
	    size: 0,
	    flags: {
	      isLeading: 0,
	      dependsOn: 1,
	      isDependedOn: 0,
	      hasRedundancy: 0,
	      degradationPriority: 0,
	      isNonSyncSample: 1
	    }
	  };
	};
	
	/*
	 * Collates information from a video frame into an object for eventual
	 * entry into an MP4 sample table.
	 *
	 * @param {Object} frame the video frame
	 * @param {Number} dataOffset the byte offset to position the sample
	 * @return {Object} object containing sample table info for a frame
	 */
	var sampleForFrame = function(frame, dataOffset) {
	  var sample = createDefaultSample();
	
	  sample.dataOffset = dataOffset;
	  sample.compositionTimeOffset = frame.pts - frame.dts;
	  sample.duration = frame.duration;
	  sample.size = 4 * frame.length; // Space for nal unit size
	  sample.size += frame.byteLength;
	
	  if (frame.keyFrame) {
	    sample.flags.dependsOn = 2;
	    sample.flags.isNonSyncSample = 0;
	  }
	
	  return sample;
	};
	
	// generate the track's sample table from an array of gops
	var generateSampleTable = function(gops, baseDataOffset) {
	  var
	    h, i,
	    sample,
	    currentGop,
	    currentFrame,
	    dataOffset = baseDataOffset || 0,
	    samples = [];
	
	  for (h = 0; h < gops.length; h++) {
	    currentGop = gops[h];
	
	    for (i = 0; i < currentGop.length; i++) {
	      currentFrame = currentGop[i];
	
	      sample = sampleForFrame(currentFrame, dataOffset);
	
	      dataOffset += sample.size;
	
	      samples.push(sample);
	    }
	  }
	  return samples;
	};
	
	// generate the track's raw mdat data from an array of gops
	var concatenateNalData = function(gops) {
	  var
	    h, i, j,
	    currentGop,
	    currentFrame,
	    currentNal,
	    dataOffset = 0,
	    nalsByteLength = gops.byteLength,
	    numberOfNals = gops.nalCount,
	    totalByteLength = nalsByteLength + 4 * numberOfNals,
	    data = new Uint8Array(totalByteLength),
	    view = new DataView(data.buffer);
	
	  // For each Gop..
	  for (h = 0; h < gops.length; h++) {
	    currentGop = gops[h];
	
	    // For each Frame..
	    for (i = 0; i < currentGop.length; i++) {
	      currentFrame = currentGop[i];
	
	      // For each NAL..
	      for (j = 0; j < currentFrame.length; j++) {
	        currentNal = currentFrame[j];
	
	        view.setUint32(dataOffset, currentNal.data.byteLength);
	        dataOffset += 4;
	        data.set(currentNal.data, dataOffset);
	        dataOffset += currentNal.data.byteLength;
	      }
	    }
	  }
	  return data;
	};
	
	module.exports = {
	  groupNalsIntoFrames: groupNalsIntoFrames,
	  groupFramesIntoGops: groupFramesIntoGops,
	  extendFirstKeyFrame: extendFirstKeyFrame,
	  generateSampleTable: generateSampleTable,
	  concatenateNalData: concatenateNalData
	};


/***/ },
/* 953 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = {
	  generator: __webpack_require__(375),
	  probe: __webpack_require__(183),
	  Transmuxer: __webpack_require__(247).Transmuxer,
	  AudioSegmentStream: __webpack_require__(247).AudioSegmentStream,
	  VideoSegmentStream: __webpack_require__(247).VideoSegmentStream,
	  CaptionParser: __webpack_require__(951)
	};


/***/ },
/* 954 */
/***/ function(module, exports) {

	var ONE_SECOND_IN_TS = 90000; // 90kHz clock
	
	/**
	 * Store information about the start and end of the track and the
	 * duration for each frame/sample we process in order to calculate
	 * the baseMediaDecodeTime
	 */
	var collectDtsInfo = function(track, data) {
	  if (typeof data.pts === 'number') {
	    if (track.timelineStartInfo.pts === undefined) {
	      track.timelineStartInfo.pts = data.pts;
	    }
	
	    if (track.minSegmentPts === undefined) {
	      track.minSegmentPts = data.pts;
	    } else {
	      track.minSegmentPts = Math.min(track.minSegmentPts, data.pts);
	    }
	
	    if (track.maxSegmentPts === undefined) {
	      track.maxSegmentPts = data.pts;
	    } else {
	      track.maxSegmentPts = Math.max(track.maxSegmentPts, data.pts);
	    }
	  }
	
	  if (typeof data.dts === 'number') {
	    if (track.timelineStartInfo.dts === undefined) {
	      track.timelineStartInfo.dts = data.dts;
	    }
	
	    if (track.minSegmentDts === undefined) {
	      track.minSegmentDts = data.dts;
	    } else {
	      track.minSegmentDts = Math.min(track.minSegmentDts, data.dts);
	    }
	
	    if (track.maxSegmentDts === undefined) {
	      track.maxSegmentDts = data.dts;
	    } else {
	      track.maxSegmentDts = Math.max(track.maxSegmentDts, data.dts);
	    }
	  }
	};
	
	/**
	 * Clear values used to calculate the baseMediaDecodeTime between
	 * tracks
	 */
	var clearDtsInfo = function(track) {
	  delete track.minSegmentDts;
	  delete track.maxSegmentDts;
	  delete track.minSegmentPts;
	  delete track.maxSegmentPts;
	};
	
	/**
	 * Calculate the track's baseMediaDecodeTime based on the earliest
	 * DTS the transmuxer has ever seen and the minimum DTS for the
	 * current track
	 * @param track {object} track metadata configuration
	 * @param keepOriginalTimestamps {boolean} If true, keep the timestamps
	 *        in the source; false to adjust the first segment to start at 0.
	 */
	var calculateTrackBaseMediaDecodeTime = function(track, keepOriginalTimestamps) {
	  var
	    baseMediaDecodeTime,
	    scale,
	    minSegmentDts = track.minSegmentDts;
	
	  // Optionally adjust the time so the first segment starts at zero.
	  if (!keepOriginalTimestamps) {
	    minSegmentDts -= track.timelineStartInfo.dts;
	  }
	
	  // track.timelineStartInfo.baseMediaDecodeTime is the location, in time, where
	  // we want the start of the first segment to be placed
	  baseMediaDecodeTime = track.timelineStartInfo.baseMediaDecodeTime;
	
	  // Add to that the distance this segment is from the very first
	  baseMediaDecodeTime += minSegmentDts;
	
	  // baseMediaDecodeTime must not become negative
	  baseMediaDecodeTime = Math.max(0, baseMediaDecodeTime);
	
	  if (track.type === 'audio') {
	    // Audio has a different clock equal to the sampling_rate so we need to
	    // scale the PTS values into the clock rate of the track
	    scale = track.samplerate / ONE_SECOND_IN_TS;
	    baseMediaDecodeTime *= scale;
	    baseMediaDecodeTime = Math.floor(baseMediaDecodeTime);
	  }
	
	  return baseMediaDecodeTime;
	};
	
	module.exports = {
	  clearDtsInfo: clearDtsInfo,
	  calculateTrackBaseMediaDecodeTime: calculateTrackBaseMediaDecodeTime,
	  collectDtsInfo: collectDtsInfo
	};


/***/ },
/* 955 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * mux.js
	 *
	 * Copyright (c) 2015 Brightcove
	 * All rights reserved.
	 *
	 * Parse the internal MP4 structure into an equivalent javascript
	 * object.
	 */
	'use strict';
	
	var
	  inspectMp4,
	  textifyMp4,
	
	  parseType = __webpack_require__(183).parseType,
	  parseMp4Date = function(seconds) {
	    return new Date(seconds * 1000 - 2082844800000);
	  },
	  parseSampleFlags = function(flags) {
	    return {
	      isLeading: (flags[0] & 0x0c) >>> 2,
	      dependsOn: flags[0] & 0x03,
	      isDependedOn: (flags[1] & 0xc0) >>> 6,
	      hasRedundancy: (flags[1] & 0x30) >>> 4,
	      paddingValue: (flags[1] & 0x0e) >>> 1,
	      isNonSyncSample: flags[1] & 0x01,
	      degradationPriority: (flags[2] << 8) | flags[3]
	    };
	  },
	  nalParse = function(avcStream) {
	    var
	      avcView = new DataView(avcStream.buffer, avcStream.byteOffset, avcStream.byteLength),
	      result = [],
	      i,
	      length;
	    for (i = 0; i + 4 < avcStream.length; i += length) {
	      length = avcView.getUint32(i);
	      i += 4;
	
	      // bail if this doesn't appear to be an H264 stream
	      if (length <= 0) {
	        result.push('<span style=\'color:red;\'>MALFORMED DATA</span>');
	        continue;
	      }
	
	      switch (avcStream[i] & 0x1F) {
	      case 0x01:
	        result.push('slice_layer_without_partitioning_rbsp');
	        break;
	      case 0x05:
	        result.push('slice_layer_without_partitioning_rbsp_idr');
	        break;
	      case 0x06:
	        result.push('sei_rbsp');
	        break;
	      case 0x07:
	        result.push('seq_parameter_set_rbsp');
	        break;
	      case 0x08:
	        result.push('pic_parameter_set_rbsp');
	        break;
	      case 0x09:
	        result.push('access_unit_delimiter_rbsp');
	        break;
	      default:
	        result.push('UNKNOWN NAL - ' + avcStream[i] & 0x1F);
	        break;
	      }
	    }
	    return result;
	  },
	
	  // registry of handlers for individual mp4 box types
	  parse = {
	    // codingname, not a first-class box type. stsd entries share the
	    // same format as real boxes so the parsing infrastructure can be
	    // shared
	    avc1: function(data) {
	      var view = new DataView(data.buffer, data.byteOffset, data.byteLength);
	      return {
	        dataReferenceIndex: view.getUint16(6),
	        width: view.getUint16(24),
	        height: view.getUint16(26),
	        horizresolution: view.getUint16(28) + (view.getUint16(30) / 16),
	        vertresolution: view.getUint16(32) + (view.getUint16(34) / 16),
	        frameCount: view.getUint16(40),
	        depth: view.getUint16(74),
	        config: inspectMp4(data.subarray(78, data.byteLength))
	      };
	    },
	    avcC: function(data) {
	      var
	        view = new DataView(data.buffer, data.byteOffset, data.byteLength),
	        result = {
	          configurationVersion: data[0],
	          avcProfileIndication: data[1],
	          profileCompatibility: data[2],
	          avcLevelIndication: data[3],
	          lengthSizeMinusOne: data[4] & 0x03,
	          sps: [],
	          pps: []
	        },
	        numOfSequenceParameterSets = data[5] & 0x1f,
	        numOfPictureParameterSets,
	        nalSize,
	        offset,
	        i;
	
	      // iterate past any SPSs
	      offset = 6;
	      for (i = 0; i < numOfSequenceParameterSets; i++) {
	        nalSize = view.getUint16(offset);
	        offset += 2;
	        result.sps.push(new Uint8Array(data.subarray(offset, offset + nalSize)));
	        offset += nalSize;
	      }
	      // iterate past any PPSs
	      numOfPictureParameterSets = data[offset];
	      offset++;
	      for (i = 0; i < numOfPictureParameterSets; i++) {
	        nalSize = view.getUint16(offset);
	        offset += 2;
	        result.pps.push(new Uint8Array(data.subarray(offset, offset + nalSize)));
	        offset += nalSize;
	      }
	      return result;
	    },
	    btrt: function(data) {
	      var view = new DataView(data.buffer, data.byteOffset, data.byteLength);
	      return {
	        bufferSizeDB: view.getUint32(0),
	        maxBitrate: view.getUint32(4),
	        avgBitrate: view.getUint32(8)
	      };
	    },
	    esds: function(data) {
	      return {
	        version: data[0],
	        flags: new Uint8Array(data.subarray(1, 4)),
	        esId: (data[6] << 8) | data[7],
	        streamPriority: data[8] & 0x1f,
	        decoderConfig: {
	          objectProfileIndication: data[11],
	          streamType: (data[12] >>> 2) & 0x3f,
	          bufferSize: (data[13] << 16) | (data[14] << 8) | data[15],
	          maxBitrate: (data[16] << 24) |
	            (data[17] << 16) |
	            (data[18] <<  8) |
	            data[19],
	          avgBitrate: (data[20] << 24) |
	            (data[21] << 16) |
	            (data[22] <<  8) |
	            data[23],
	          decoderConfigDescriptor: {
	            tag: data[24],
	            length: data[25],
	            audioObjectType: (data[26] >>> 3) & 0x1f,
	            samplingFrequencyIndex: ((data[26] & 0x07) << 1) |
	              ((data[27] >>> 7) & 0x01),
	            channelConfiguration: (data[27] >>> 3) & 0x0f
	          }
	        }
	      };
	    },
	    ftyp: function(data) {
	      var
	        view = new DataView(data.buffer, data.byteOffset, data.byteLength),
	        result = {
	          majorBrand: parseType(data.subarray(0, 4)),
	          minorVersion: view.getUint32(4),
	          compatibleBrands: []
	        },
	        i = 8;
	      while (i < data.byteLength) {
	        result.compatibleBrands.push(parseType(data.subarray(i, i + 4)));
	        i += 4;
	      }
	      return result;
	    },
	    dinf: function(data) {
	      return {
	        boxes: inspectMp4(data)
	      };
	    },
	    dref: function(data) {
	      return {
	        version: data[0],
	        flags: new Uint8Array(data.subarray(1, 4)),
	        dataReferences: inspectMp4(data.subarray(8))
	      };
	    },
	    hdlr: function(data) {
	      var
	        view = new DataView(data.buffer, data.byteOffset, data.byteLength),
	        result = {
	          version: view.getUint8(0),
	          flags: new Uint8Array(data.subarray(1, 4)),
	          handlerType: parseType(data.subarray(8, 12)),
	          name: ''
	        },
	        i = 8;
	
	      // parse out the name field
	      for (i = 24; i < data.byteLength; i++) {
	        if (data[i] === 0x00) {
	          // the name field is null-terminated
	          i++;
	          break;
	        }
	        result.name += String.fromCharCode(data[i]);
	      }
	      // decode UTF-8 to javascript's internal representation
	      // see http://ecmanaut.blogspot.com/2006/07/encoding-decoding-utf8-in-javascript.html
	      result.name = decodeURIComponent(escape(result.name));
	
	      return result;
	    },
	    mdat: function(data) {
	      return {
	        byteLength: data.byteLength,
	        nals: nalParse(data)
	      };
	    },
	    mdhd: function(data) {
	      var
	        view = new DataView(data.buffer, data.byteOffset, data.byteLength),
	        i = 4,
	        language,
	        result = {
	          version: view.getUint8(0),
	          flags: new Uint8Array(data.subarray(1, 4)),
	          language: ''
	        };
	      if (result.version === 1) {
	        i += 4;
	        result.creationTime = parseMp4Date(view.getUint32(i)); // truncating top 4 bytes
	        i += 8;
	        result.modificationTime = parseMp4Date(view.getUint32(i)); // truncating top 4 bytes
	        i += 4;
	        result.timescale = view.getUint32(i);
	        i += 8;
	        result.duration = view.getUint32(i); // truncating top 4 bytes
	      } else {
	        result.creationTime = parseMp4Date(view.getUint32(i));
	        i += 4;
	        result.modificationTime = parseMp4Date(view.getUint32(i));
	        i += 4;
	        result.timescale = view.getUint32(i);
	        i += 4;
	        result.duration = view.getUint32(i);
	      }
	      i += 4;
	      // language is stored as an ISO-639-2/T code in an array of three 5-bit fields
	      // each field is the packed difference between its ASCII value and 0x60
	      language = view.getUint16(i);
	      result.language += String.fromCharCode((language >> 10) + 0x60);
	      result.language += String.fromCharCode(((language & 0x03e0) >> 5) + 0x60);
	      result.language += String.fromCharCode((language & 0x1f) + 0x60);
	
	      return result;
	    },
	    mdia: function(data) {
	      return {
	        boxes: inspectMp4(data)
	      };
	    },
	    mfhd: function(data) {
	      return {
	        version: data[0],
	        flags: new Uint8Array(data.subarray(1, 4)),
	        sequenceNumber: (data[4] << 24) |
	          (data[5] << 16) |
	          (data[6] << 8) |
	          (data[7])
	      };
	    },
	    minf: function(data) {
	      return {
	        boxes: inspectMp4(data)
	      };
	    },
	    // codingname, not a first-class box type. stsd entries share the
	    // same format as real boxes so the parsing infrastructure can be
	    // shared
	    mp4a: function(data) {
	      var
	        view = new DataView(data.buffer, data.byteOffset, data.byteLength),
	        result = {
	          // 6 bytes reserved
	          dataReferenceIndex: view.getUint16(6),
	          // 4 + 4 bytes reserved
	          channelcount: view.getUint16(16),
	          samplesize: view.getUint16(18),
	          // 2 bytes pre_defined
	          // 2 bytes reserved
	          samplerate: view.getUint16(24) + (view.getUint16(26) / 65536)
	        };
	
	      // if there are more bytes to process, assume this is an ISO/IEC
	      // 14496-14 MP4AudioSampleEntry and parse the ESDBox
	      if (data.byteLength > 28) {
	        result.streamDescriptor = inspectMp4(data.subarray(28))[0];
	      }
	      return result;
	    },
	    moof: function(data) {
	      return {
	        boxes: inspectMp4(data)
	      };
	    },
	    moov: function(data) {
	      return {
	        boxes: inspectMp4(data)
	      };
	    },
	    mvex: function(data) {
	      return {
	        boxes: inspectMp4(data)
	      };
	    },
	    mvhd: function(data) {
	      var
	        view = new DataView(data.buffer, data.byteOffset, data.byteLength),
	        i = 4,
	        result = {
	          version: view.getUint8(0),
	          flags: new Uint8Array(data.subarray(1, 4))
	        };
	
	      if (result.version === 1) {
	        i += 4;
	        result.creationTime = parseMp4Date(view.getUint32(i)); // truncating top 4 bytes
	        i += 8;
	        result.modificationTime = parseMp4Date(view.getUint32(i)); // truncating top 4 bytes
	        i += 4;
	        result.timescale = view.getUint32(i);
	        i += 8;
	        result.duration = view.getUint32(i); // truncating top 4 bytes
	      } else {
	        result.creationTime = parseMp4Date(view.getUint32(i));
	        i += 4;
	        result.modificationTime = parseMp4Date(view.getUint32(i));
	        i += 4;
	        result.timescale = view.getUint32(i);
	        i += 4;
	        result.duration = view.getUint32(i);
	      }
	      i += 4;
	
	      // convert fixed-point, base 16 back to a number
	      result.rate = view.getUint16(i) + (view.getUint16(i + 2) / 16);
	      i += 4;
	      result.volume = view.getUint8(i) + (view.getUint8(i + 1) / 8);
	      i += 2;
	      i += 2;
	      i += 2 * 4;
	      result.matrix = new Uint32Array(data.subarray(i, i + (9 * 4)));
	      i += 9 * 4;
	      i += 6 * 4;
	      result.nextTrackId = view.getUint32(i);
	      return result;
	    },
	    pdin: function(data) {
	      var view = new DataView(data.buffer, data.byteOffset, data.byteLength);
	      return {
	        version: view.getUint8(0),
	        flags: new Uint8Array(data.subarray(1, 4)),
	        rate: view.getUint32(4),
	        initialDelay: view.getUint32(8)
	      };
	    },
	    sdtp: function(data) {
	      var
	        result = {
	          version: data[0],
	          flags: new Uint8Array(data.subarray(1, 4)),
	          samples: []
	        }, i;
	
	      for (i = 4; i < data.byteLength; i++) {
	        result.samples.push({
	          dependsOn: (data[i] & 0x30) >> 4,
	          isDependedOn: (data[i] & 0x0c) >> 2,
	          hasRedundancy: data[i] & 0x03
	        });
	      }
	      return result;
	    },
	    sidx: function(data) {
	      var view = new DataView(data.buffer, data.byteOffset, data.byteLength),
	          result = {
	            version: data[0],
	            flags: new Uint8Array(data.subarray(1, 4)),
	            references: [],
	            referenceId: view.getUint32(4),
	            timescale: view.getUint32(8),
	            earliestPresentationTime: view.getUint32(12),
	            firstOffset: view.getUint32(16)
	          },
	          referenceCount = view.getUint16(22),
	          i;
	
	      for (i = 24; referenceCount; i += 12, referenceCount--) {
	        result.references.push({
	          referenceType: (data[i] & 0x80) >>> 7,
	          referencedSize: view.getUint32(i) & 0x7FFFFFFF,
	          subsegmentDuration: view.getUint32(i + 4),
	          startsWithSap: !!(data[i + 8] & 0x80),
	          sapType: (data[i + 8] & 0x70) >>> 4,
	          sapDeltaTime: view.getUint32(i + 8) & 0x0FFFFFFF
	        });
	      }
	
	      return result;
	    },
	    smhd: function(data) {
	      return {
	        version: data[0],
	        flags: new Uint8Array(data.subarray(1, 4)),
	        balance: data[4] + (data[5] / 256)
	      };
	    },
	    stbl: function(data) {
	      return {
	        boxes: inspectMp4(data)
	      };
	    },
	    stco: function(data) {
	      var
	        view = new DataView(data.buffer, data.byteOffset, data.byteLength),
	        result = {
	          version: data[0],
	          flags: new Uint8Array(data.subarray(1, 4)),
	          chunkOffsets: []
	        },
	        entryCount = view.getUint32(4),
	        i;
	      for (i = 8; entryCount; i += 4, entryCount--) {
	        result.chunkOffsets.push(view.getUint32(i));
	      }
	      return result;
	    },
	    stsc: function(data) {
	      var
	        view = new DataView(data.buffer, data.byteOffset, data.byteLength),
	        entryCount = view.getUint32(4),
	        result = {
	          version: data[0],
	          flags: new Uint8Array(data.subarray(1, 4)),
	          sampleToChunks: []
	        },
	        i;
	      for (i = 8; entryCount; i += 12, entryCount--) {
	        result.sampleToChunks.push({
	          firstChunk: view.getUint32(i),
	          samplesPerChunk: view.getUint32(i + 4),
	          sampleDescriptionIndex: view.getUint32(i + 8)
	        });
	      }
	      return result;
	    },
	    stsd: function(data) {
	      return {
	        version: data[0],
	        flags: new Uint8Array(data.subarray(1, 4)),
	        sampleDescriptions: inspectMp4(data.subarray(8))
	      };
	    },
	    stsz: function(data) {
	      var
	        view = new DataView(data.buffer, data.byteOffset, data.byteLength),
	        result = {
	          version: data[0],
	          flags: new Uint8Array(data.subarray(1, 4)),
	          sampleSize: view.getUint32(4),
	          entries: []
	        },
	        i;
	      for (i = 12; i < data.byteLength; i += 4) {
	        result.entries.push(view.getUint32(i));
	      }
	      return result;
	    },
	    stts: function(data) {
	      var
	        view = new DataView(data.buffer, data.byteOffset, data.byteLength),
	        result = {
	          version: data[0],
	          flags: new Uint8Array(data.subarray(1, 4)),
	          timeToSamples: []
	        },
	        entryCount = view.getUint32(4),
	        i;
	
	      for (i = 8; entryCount; i += 8, entryCount--) {
	        result.timeToSamples.push({
	          sampleCount: view.getUint32(i),
	          sampleDelta: view.getUint32(i + 4)
	        });
	      }
	      return result;
	    },
	    styp: function(data) {
	      return parse.ftyp(data);
	    },
	    tfdt: function(data) {
	      var result = {
	        version: data[0],
	        flags: new Uint8Array(data.subarray(1, 4)),
	        baseMediaDecodeTime: data[4] << 24 | data[5] << 16 | data[6] << 8 | data[7]
	      };
	      if (result.version === 1) {
	        result.baseMediaDecodeTime *= Math.pow(2, 32);
	        result.baseMediaDecodeTime += data[8] << 24 | data[9] << 16 | data[10] << 8 | data[11];
	      }
	      return result;
	    },
	    tfhd: function(data) {
	      var
	        view = new DataView(data.buffer, data.byteOffset, data.byteLength),
	        result = {
	          version: data[0],
	          flags: new Uint8Array(data.subarray(1, 4)),
	          trackId: view.getUint32(4)
	        },
	        baseDataOffsetPresent = result.flags[2] & 0x01,
	        sampleDescriptionIndexPresent = result.flags[2] & 0x02,
	        defaultSampleDurationPresent = result.flags[2] & 0x08,
	        defaultSampleSizePresent = result.flags[2] & 0x10,
	        defaultSampleFlagsPresent = result.flags[2] & 0x20,
	        durationIsEmpty = result.flags[0] & 0x010000,
	        defaultBaseIsMoof =  result.flags[0] & 0x020000,
	        i;
	
	      i = 8;
	      if (baseDataOffsetPresent) {
	        i += 4; // truncate top 4 bytes
	        // FIXME: should we read the full 64 bits?
	        result.baseDataOffset = view.getUint32(12);
	        i += 4;
	      }
	      if (sampleDescriptionIndexPresent) {
	        result.sampleDescriptionIndex = view.getUint32(i);
	        i += 4;
	      }
	      if (defaultSampleDurationPresent) {
	        result.defaultSampleDuration = view.getUint32(i);
	        i += 4;
	      }
	      if (defaultSampleSizePresent) {
	        result.defaultSampleSize = view.getUint32(i);
	        i += 4;
	      }
	      if (defaultSampleFlagsPresent) {
	        result.defaultSampleFlags = view.getUint32(i);
	      }
	      if (durationIsEmpty) {
	        result.durationIsEmpty = true;
	      }
	      if (!baseDataOffsetPresent && defaultBaseIsMoof) {
	        result.baseDataOffsetIsMoof = true;
	      }
	      return result;
	    },
	    tkhd: function(data) {
	      var
	        view = new DataView(data.buffer, data.byteOffset, data.byteLength),
	        i = 4,
	        result = {
	          version: view.getUint8(0),
	          flags: new Uint8Array(data.subarray(1, 4))
	        };
	      if (result.version === 1) {
	        i += 4;
	        result.creationTime = parseMp4Date(view.getUint32(i)); // truncating top 4 bytes
	        i += 8;
	        result.modificationTime = parseMp4Date(view.getUint32(i)); // truncating top 4 bytes
	        i += 4;
	        result.trackId = view.getUint32(i);
	        i += 4;
	        i += 8;
	        result.duration = view.getUint32(i); // truncating top 4 bytes
	      } else {
	        result.creationTime = parseMp4Date(view.getUint32(i));
	        i += 4;
	        result.modificationTime = parseMp4Date(view.getUint32(i));
	        i += 4;
	        result.trackId = view.getUint32(i);
	        i += 4;
	        i += 4;
	        result.duration = view.getUint32(i);
	      }
	      i += 4;
	      i += 2 * 4;
	      result.layer = view.getUint16(i);
	      i += 2;
	      result.alternateGroup = view.getUint16(i);
	      i += 2;
	      // convert fixed-point, base 16 back to a number
	      result.volume = view.getUint8(i) + (view.getUint8(i + 1) / 8);
	      i += 2;
	      i += 2;
	      result.matrix = new Uint32Array(data.subarray(i, i + (9 * 4)));
	      i += 9 * 4;
	      result.width = view.getUint16(i) + (view.getUint16(i + 2) / 16);
	      i += 4;
	      result.height = view.getUint16(i) + (view.getUint16(i + 2) / 16);
	      return result;
	    },
	    traf: function(data) {
	      return {
	        boxes: inspectMp4(data)
	      };
	    },
	    trak: function(data) {
	      return {
	        boxes: inspectMp4(data)
	      };
	    },
	    trex: function(data) {
	      var view = new DataView(data.buffer, data.byteOffset, data.byteLength);
	      return {
	        version: data[0],
	        flags: new Uint8Array(data.subarray(1, 4)),
	        trackId: view.getUint32(4),
	        defaultSampleDescriptionIndex: view.getUint32(8),
	        defaultSampleDuration: view.getUint32(12),
	        defaultSampleSize: view.getUint32(16),
	        sampleDependsOn: data[20] & 0x03,
	        sampleIsDependedOn: (data[21] & 0xc0) >> 6,
	        sampleHasRedundancy: (data[21] & 0x30) >> 4,
	        samplePaddingValue: (data[21] & 0x0e) >> 1,
	        sampleIsDifferenceSample: !!(data[21] & 0x01),
	        sampleDegradationPriority: view.getUint16(22)
	      };
	    },
	    trun: function(data) {
	      var
	        result = {
	          version: data[0],
	          flags: new Uint8Array(data.subarray(1, 4)),
	          samples: []
	        },
	        view = new DataView(data.buffer, data.byteOffset, data.byteLength),
	        // Flag interpretation
	        dataOffsetPresent = result.flags[2] & 0x01, // compare with 2nd byte of 0x1
	        firstSampleFlagsPresent = result.flags[2] & 0x04, // compare with 2nd byte of 0x4
	        sampleDurationPresent = result.flags[1] & 0x01, // compare with 2nd byte of 0x100
	        sampleSizePresent = result.flags[1] & 0x02, // compare with 2nd byte of 0x200
	        sampleFlagsPresent = result.flags[1] & 0x04, // compare with 2nd byte of 0x400
	        sampleCompositionTimeOffsetPresent = result.flags[1] & 0x08, // compare with 2nd byte of 0x800
	        sampleCount = view.getUint32(4),
	        offset = 8,
	        sample;
	
	      if (dataOffsetPresent) {
	        // 32 bit signed integer
	        result.dataOffset = view.getInt32(offset);
	        offset += 4;
	      }
	
	      // Overrides the flags for the first sample only. The order of
	      // optional values will be: duration, size, compositionTimeOffset
	      if (firstSampleFlagsPresent && sampleCount) {
	        sample = {
	          flags: parseSampleFlags(data.subarray(offset, offset + 4))
	        };
	        offset += 4;
	        if (sampleDurationPresent) {
	          sample.duration = view.getUint32(offset);
	          offset += 4;
	        }
	        if (sampleSizePresent) {
	          sample.size = view.getUint32(offset);
	          offset += 4;
	        }
	        if (sampleCompositionTimeOffsetPresent) {
	          // Note: this should be a signed int if version is 1
	          sample.compositionTimeOffset = view.getUint32(offset);
	          offset += 4;
	        }
	        result.samples.push(sample);
	        sampleCount--;
	      }
	
	      while (sampleCount--) {
	        sample = {};
	        if (sampleDurationPresent) {
	          sample.duration = view.getUint32(offset);
	          offset += 4;
	        }
	        if (sampleSizePresent) {
	          sample.size = view.getUint32(offset);
	          offset += 4;
	        }
	        if (sampleFlagsPresent) {
	          sample.flags = parseSampleFlags(data.subarray(offset, offset + 4));
	          offset += 4;
	        }
	        if (sampleCompositionTimeOffsetPresent) {
	          // Note: this should be a signed int if version is 1
	          sample.compositionTimeOffset = view.getUint32(offset);
	          offset += 4;
	        }
	        result.samples.push(sample);
	      }
	      return result;
	    },
	    'url ': function(data) {
	      return {
	        version: data[0],
	        flags: new Uint8Array(data.subarray(1, 4))
	      };
	    },
	    vmhd: function(data) {
	      var view = new DataView(data.buffer, data.byteOffset, data.byteLength);
	      return {
	        version: data[0],
	        flags: new Uint8Array(data.subarray(1, 4)),
	        graphicsmode: view.getUint16(4),
	        opcolor: new Uint16Array([view.getUint16(6),
	                                  view.getUint16(8),
	                                  view.getUint16(10)])
	      };
	    }
	  };
	
	
	/**
	 * Return a javascript array of box objects parsed from an ISO base
	 * media file.
	 * @param data {Uint8Array} the binary data of the media to be inspected
	 * @return {array} a javascript array of potentially nested box objects
	 */
	inspectMp4 = function(data) {
	  var
	    i = 0,
	    result = [],
	    view,
	    size,
	    type,
	    end,
	    box;
	
	  // Convert data from Uint8Array to ArrayBuffer, to follow Dataview API
	  var ab = new ArrayBuffer(data.length);
	  var v = new Uint8Array(ab);
	  for (var z = 0; z < data.length; ++z) {
	      v[z] = data[z];
	  }
	  view = new DataView(ab);
	
	  while (i < data.byteLength) {
	    // parse box data
	    size = view.getUint32(i);
	    type =  parseType(data.subarray(i + 4, i + 8));
	    end = size > 1 ? i + size : data.byteLength;
	
	    // parse type-specific data
	    box = (parse[type] || function(data) {
	      return {
	        data: data
	      };
	    })(data.subarray(i + 8, end));
	    box.size = size;
	    box.type = type;
	
	    // store this box and move to the next
	    result.push(box);
	    i = end;
	  }
	  return result;
	};
	
	/**
	 * Returns a textual representation of the javascript represtentation
	 * of an MP4 file. You can use it as an alternative to
	 * JSON.stringify() to compare inspected MP4s.
	 * @param inspectedMp4 {array} the parsed array of boxes in an MP4
	 * file
	 * @param depth {number} (optional) the number of ancestor boxes of
	 * the elements of inspectedMp4. Assumed to be zero if unspecified.
	 * @return {string} a text representation of the parsed MP4
	 */
	textifyMp4 = function(inspectedMp4, depth) {
	  var indent;
	  depth = depth || 0;
	  indent = new Array(depth * 2 + 1).join(' ');
	
	  // iterate over all the boxes
	  return inspectedMp4.map(function(box, index) {
	
	    // list the box type first at the current indentation level
	    return indent + box.type + '\n' +
	
	      // the type is already included and handle child boxes separately
	      Object.keys(box).filter(function(key) {
	        return key !== 'type' && key !== 'boxes';
	
	      // output all the box properties
	      }).map(function(key) {
	        var prefix = indent + '  ' + key + ': ',
	            value = box[key];
	
	        // print out raw bytes as hexademical
	        if (value instanceof Uint8Array || value instanceof Uint32Array) {
	          var bytes = Array.prototype.slice.call(new Uint8Array(value.buffer, value.byteOffset, value.byteLength))
	              .map(function(byte) {
	                return ' ' + ('00' + byte.toString(16)).slice(-2);
	              }).join('').match(/.{1,24}/g);
	          if (!bytes) {
	            return prefix + '<>';
	          }
	          if (bytes.length === 1) {
	            return prefix + '<' + bytes.join('').slice(1) + '>';
	          }
	          return prefix + '<\n' + bytes.map(function(line) {
	            return indent + '  ' + line;
	          }).join('\n') + '\n' + indent + '  >';
	        }
	
	        // stringify generic objects
	        return prefix +
	            JSON.stringify(value, null, 2)
	              .split('\n').map(function(line, index) {
	                if (index === 0) {
	                  return line;
	                }
	                return indent + '  ' + line;
	              }).join('\n');
	      }).join('\n') +
	
	    // recursively textify the child boxes
	    (box.boxes ? '\n' + textifyMp4(box.boxes, depth + 1) : '');
	  }).join('\n');
	};
	
	module.exports = {
	  inspect: inspectMp4,
	  textify: textifyMp4,
	  parseTfdt: parse.tfdt,
	  parseHdlr: parse.hdlr,
	  parseTfhd: parse.tfhd,
	  parseTrun: parse.trun
	};


/***/ },
/* 956 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * mux.js
	 *
	 * Copyright (c) 2016 Brightcove
	 * All rights reserved.
	 *
	 * Parse mpeg2 transport stream packets to extract basic timing information
	 */
	'use strict';
	
	var StreamTypes = __webpack_require__(143);
	var handleRollover = __webpack_require__(374).handleRollover;
	var probe = {};
	probe.ts = __webpack_require__(950);
	probe.aac = __webpack_require__(944);
	
	
	var
	  PES_TIMESCALE = 90000,
	  MP2T_PACKET_LENGTH = 188, // bytes
	  SYNC_BYTE = 0x47;
	
	var isLikelyAacData = function(data) {
	  if ((data[0] === 'I'.charCodeAt(0)) &&
	      (data[1] === 'D'.charCodeAt(0)) &&
	      (data[2] === '3'.charCodeAt(0))) {
	    return true;
	  }
	  return false;
	};
	
	/**
	 * walks through segment data looking for pat and pmt packets to parse out
	 * program map table information
	 */
	var parsePsi_ = function(bytes, pmt) {
	  var
	    startIndex = 0,
	    endIndex = MP2T_PACKET_LENGTH,
	    packet, type;
	
	  while (endIndex < bytes.byteLength) {
	    // Look for a pair of start and end sync bytes in the data..
	    if (bytes[startIndex] === SYNC_BYTE && bytes[endIndex] === SYNC_BYTE) {
	      // We found a packet
	      packet = bytes.subarray(startIndex, endIndex);
	      type = probe.ts.parseType(packet, pmt.pid);
	
	      switch (type) {
	        case 'pat':
	          if (!pmt.pid) {
	            pmt.pid = probe.ts.parsePat(packet);
	          }
	          break;
	        case 'pmt':
	          if (!pmt.table) {
	            pmt.table = probe.ts.parsePmt(packet);
	          }
	          break;
	        default:
	          break;
	      }
	
	      // Found the pat and pmt, we can stop walking the segment
	      if (pmt.pid && pmt.table) {
	        return;
	      }
	
	      startIndex += MP2T_PACKET_LENGTH;
	      endIndex += MP2T_PACKET_LENGTH;
	      continue;
	    }
	
	    // If we get here, we have somehow become de-synchronized and we need to step
	    // forward one byte at a time until we find a pair of sync bytes that denote
	    // a packet
	    startIndex++;
	    endIndex++;
	  }
	};
	
	/**
	 * walks through the segment data from the start and end to get timing information
	 * for the first and last audio pes packets
	 */
	var parseAudioPes_ = function(bytes, pmt, result) {
	  var
	    startIndex = 0,
	    endIndex = MP2T_PACKET_LENGTH,
	    packet, type, pesType, pusi, parsed;
	
	  var endLoop = false;
	
	  // Start walking from start of segment to get first audio packet
	  while (endIndex < bytes.byteLength) {
	    // Look for a pair of start and end sync bytes in the data..
	    if (bytes[startIndex] === SYNC_BYTE && bytes[endIndex] === SYNC_BYTE) {
	      // We found a packet
	      packet = bytes.subarray(startIndex, endIndex);
	      type = probe.ts.parseType(packet, pmt.pid);
	
	      switch (type) {
	        case 'pes':
	          pesType = probe.ts.parsePesType(packet, pmt.table);
	          pusi = probe.ts.parsePayloadUnitStartIndicator(packet);
	          if (pesType === 'audio' && pusi) {
	            parsed = probe.ts.parsePesTime(packet);
	            if (parsed) {
	              parsed.type = 'audio';
	              result.audio.push(parsed);
	              endLoop = true;
	            }
	          }
	          break;
	        default:
	          break;
	      }
	
	      if (endLoop) {
	        break;
	      }
	
	      startIndex += MP2T_PACKET_LENGTH;
	      endIndex += MP2T_PACKET_LENGTH;
	      continue;
	    }
	
	    // If we get here, we have somehow become de-synchronized and we need to step
	    // forward one byte at a time until we find a pair of sync bytes that denote
	    // a packet
	    startIndex++;
	    endIndex++;
	  }
	
	  // Start walking from end of segment to get last audio packet
	  endIndex = bytes.byteLength;
	  startIndex = endIndex - MP2T_PACKET_LENGTH;
	  endLoop = false;
	  while (startIndex >= 0) {
	    // Look for a pair of start and end sync bytes in the data..
	    if (bytes[startIndex] === SYNC_BYTE && bytes[endIndex] === SYNC_BYTE) {
	      // We found a packet
	      packet = bytes.subarray(startIndex, endIndex);
	      type = probe.ts.parseType(packet, pmt.pid);
	
	      switch (type) {
	        case 'pes':
	          pesType = probe.ts.parsePesType(packet, pmt.table);
	          pusi = probe.ts.parsePayloadUnitStartIndicator(packet);
	          if (pesType === 'audio' && pusi) {
	            parsed = probe.ts.parsePesTime(packet);
	            if (parsed) {
	              parsed.type = 'audio';
	              result.audio.push(parsed);
	              endLoop = true;
	            }
	          }
	          break;
	        default:
	          break;
	      }
	
	      if (endLoop) {
	        break;
	      }
	
	      startIndex -= MP2T_PACKET_LENGTH;
	      endIndex -= MP2T_PACKET_LENGTH;
	      continue;
	    }
	
	    // If we get here, we have somehow become de-synchronized and we need to step
	    // forward one byte at a time until we find a pair of sync bytes that denote
	    // a packet
	    startIndex--;
	    endIndex--;
	  }
	};
	
	/**
	 * walks through the segment data from the start and end to get timing information
	 * for the first and last video pes packets as well as timing information for the first
	 * key frame.
	 */
	var parseVideoPes_ = function(bytes, pmt, result) {
	  var
	    startIndex = 0,
	    endIndex = MP2T_PACKET_LENGTH,
	    packet, type, pesType, pusi, parsed, frame, i, pes;
	
	  var endLoop = false;
	
	  var currentFrame = {
	    data: [],
	    size: 0
	  };
	
	  // Start walking from start of segment to get first video packet
	  while (endIndex < bytes.byteLength) {
	    // Look for a pair of start and end sync bytes in the data..
	    if (bytes[startIndex] === SYNC_BYTE && bytes[endIndex] === SYNC_BYTE) {
	      // We found a packet
	      packet = bytes.subarray(startIndex, endIndex);
	      type = probe.ts.parseType(packet, pmt.pid);
	
	      switch (type) {
	        case 'pes':
	          pesType = probe.ts.parsePesType(packet, pmt.table);
	          pusi = probe.ts.parsePayloadUnitStartIndicator(packet);
	          if (pesType === 'video') {
	            if (pusi && !endLoop) {
	              parsed = probe.ts.parsePesTime(packet);
	              if (parsed) {
	                parsed.type = 'video';
	                result.video.push(parsed);
	                endLoop = true;
	              }
	            }
	            if (!result.firstKeyFrame) {
	              if (pusi) {
	                if (currentFrame.size !== 0) {
	                  frame = new Uint8Array(currentFrame.size);
	                  i = 0;
	                  while (currentFrame.data.length) {
	                    pes = currentFrame.data.shift();
	                    frame.set(pes, i);
	                    i += pes.byteLength;
	                  }
	                  if (probe.ts.videoPacketContainsKeyFrame(frame)) {
	                    result.firstKeyFrame = probe.ts.parsePesTime(frame);
	                    result.firstKeyFrame.type = 'video';
	                  }
	                  currentFrame.size = 0;
	                }
	              }
	              currentFrame.data.push(packet);
	              currentFrame.size += packet.byteLength;
	            }
	          }
	          break;
	        default:
	          break;
	      }
	
	      if (endLoop && result.firstKeyFrame) {
	        break;
	      }
	
	      startIndex += MP2T_PACKET_LENGTH;
	      endIndex += MP2T_PACKET_LENGTH;
	      continue;
	    }
	
	    // If we get here, we have somehow become de-synchronized and we need to step
	    // forward one byte at a time until we find a pair of sync bytes that denote
	    // a packet
	    startIndex++;
	    endIndex++;
	  }
	
	  // Start walking from end of segment to get last video packet
	  endIndex = bytes.byteLength;
	  startIndex = endIndex - MP2T_PACKET_LENGTH;
	  endLoop = false;
	  while (startIndex >= 0) {
	    // Look for a pair of start and end sync bytes in the data..
	    if (bytes[startIndex] === SYNC_BYTE && bytes[endIndex] === SYNC_BYTE) {
	      // We found a packet
	      packet = bytes.subarray(startIndex, endIndex);
	      type = probe.ts.parseType(packet, pmt.pid);
	
	      switch (type) {
	        case 'pes':
	          pesType = probe.ts.parsePesType(packet, pmt.table);
	          pusi = probe.ts.parsePayloadUnitStartIndicator(packet);
	          if (pesType === 'video' && pusi) {
	              parsed = probe.ts.parsePesTime(packet);
	              if (parsed) {
	                parsed.type = 'video';
	                result.video.push(parsed);
	                endLoop = true;
	              }
	          }
	          break;
	        default:
	          break;
	      }
	
	      if (endLoop) {
	        break;
	      }
	
	      startIndex -= MP2T_PACKET_LENGTH;
	      endIndex -= MP2T_PACKET_LENGTH;
	      continue;
	    }
	
	    // If we get here, we have somehow become de-synchronized and we need to step
	    // forward one byte at a time until we find a pair of sync bytes that denote
	    // a packet
	    startIndex--;
	    endIndex--;
	  }
	};
	
	/**
	 * Adjusts the timestamp information for the segment to account for
	 * rollover and convert to seconds based on pes packet timescale (90khz clock)
	 */
	var adjustTimestamp_ = function(segmentInfo, baseTimestamp) {
	  if (segmentInfo.audio && segmentInfo.audio.length) {
	    var audioBaseTimestamp = baseTimestamp;
	    if (typeof audioBaseTimestamp === 'undefined') {
	      audioBaseTimestamp = segmentInfo.audio[0].dts;
	    }
	    segmentInfo.audio.forEach(function(info) {
	      info.dts = handleRollover(info.dts, audioBaseTimestamp);
	      info.pts = handleRollover(info.pts, audioBaseTimestamp);
	      // time in seconds
	      info.dtsTime = info.dts / PES_TIMESCALE;
	      info.ptsTime = info.pts / PES_TIMESCALE;
	    });
	  }
	
	  if (segmentInfo.video && segmentInfo.video.length) {
	    var videoBaseTimestamp = baseTimestamp;
	    if (typeof videoBaseTimestamp === 'undefined') {
	      videoBaseTimestamp = segmentInfo.video[0].dts;
	    }
	    segmentInfo.video.forEach(function(info) {
	      info.dts = handleRollover(info.dts, videoBaseTimestamp);
	      info.pts = handleRollover(info.pts, videoBaseTimestamp);
	      // time in seconds
	      info.dtsTime = info.dts / PES_TIMESCALE;
	      info.ptsTime = info.pts / PES_TIMESCALE;
	    });
	    if (segmentInfo.firstKeyFrame) {
	      var frame = segmentInfo.firstKeyFrame;
	      frame.dts = handleRollover(frame.dts, videoBaseTimestamp);
	      frame.pts = handleRollover(frame.pts, videoBaseTimestamp);
	      // time in seconds
	      frame.dtsTime = frame.dts / PES_TIMESCALE;
	      frame.ptsTime = frame.dts / PES_TIMESCALE;
	    }
	  }
	};
	
	/**
	 * inspects the aac data stream for start and end time information
	 */
	var inspectAac_ = function(bytes) {
	  var
	    endLoop = false,
	    audioCount = 0,
	    sampleRate = null,
	    timestamp = null,
	    frameSize = 0,
	    byteIndex = 0,
	    packet;
	
	  while (bytes.length - byteIndex >= 3) {
	    var type = probe.aac.parseType(bytes, byteIndex);
	    switch (type) {
	      case 'timed-metadata':
	        // Exit early because we don't have enough to parse
	        // the ID3 tag header
	        if (bytes.length - byteIndex < 10) {
	          endLoop = true;
	          break;
	        }
	
	        frameSize = probe.aac.parseId3TagSize(bytes, byteIndex);
	
	        // Exit early if we don't have enough in the buffer
	        // to emit a full packet
	        if (frameSize > bytes.length) {
	          endLoop = true;
	          break;
	        }
	        if (timestamp === null) {
	          packet = bytes.subarray(byteIndex, byteIndex + frameSize);
	          timestamp = probe.aac.parseAacTimestamp(packet);
	        }
	        byteIndex += frameSize;
	        break;
	      case 'audio':
	        // Exit early because we don't have enough to parse
	        // the ADTS frame header
	        if (bytes.length - byteIndex < 7) {
	          endLoop = true;
	          break;
	        }
	
	        frameSize = probe.aac.parseAdtsSize(bytes, byteIndex);
	
	        // Exit early if we don't have enough in the buffer
	        // to emit a full packet
	        if (frameSize > bytes.length) {
	          endLoop = true;
	          break;
	        }
	        if (sampleRate === null) {
	          packet = bytes.subarray(byteIndex, byteIndex + frameSize);
	          sampleRate = probe.aac.parseSampleRate(packet);
	        }
	        audioCount++;
	        byteIndex += frameSize;
	        break;
	      default:
	        byteIndex++;
	        break;
	    }
	    if (endLoop) {
	      return null;
	    }
	  }
	  if (sampleRate === null || timestamp === null) {
	    return null;
	  }
	
	  var audioTimescale = PES_TIMESCALE / sampleRate;
	
	  var result = {
	    audio: [
	      {
	        type: 'audio',
	        dts: timestamp,
	        pts: timestamp
	      },
	      {
	        type: 'audio',
	        dts: timestamp + (audioCount * 1024 * audioTimescale),
	        pts: timestamp + (audioCount * 1024 * audioTimescale)
	      }
	    ]
	  };
	
	  return result;
	};
	
	/**
	 * inspects the transport stream segment data for start and end time information
	 * of the audio and video tracks (when present) as well as the first key frame's
	 * start time.
	 */
	var inspectTs_ = function(bytes) {
	  var pmt = {
	    pid: null,
	    table: null
	  };
	
	  var result = {};
	
	  parsePsi_(bytes, pmt);
	
	  for (var pid in pmt.table) {
	    if (pmt.table.hasOwnProperty(pid)) {
	      var type = pmt.table[pid];
	      switch (type) {
	        case StreamTypes.H264_STREAM_TYPE:
	          result.video = [];
	          parseVideoPes_(bytes, pmt, result);
	          if (result.video.length === 0) {
	            delete result.video;
	          }
	          break;
	        case StreamTypes.ADTS_STREAM_TYPE:
	          result.audio = [];
	          parseAudioPes_(bytes, pmt, result);
	          if (result.audio.length === 0) {
	            delete result.audio;
	          }
	          break;
	        default:
	          break;
	      }
	    }
	  }
	  return result;
	};
	
	/**
	 * Inspects segment byte data and returns an object with start and end timing information
	 *
	 * @param {Uint8Array} bytes The segment byte data
	 * @param {Number} baseTimestamp Relative reference timestamp used when adjusting frame
	 *  timestamps for rollover. This value must be in 90khz clock.
	 * @return {Object} Object containing start and end frame timing info of segment.
	 */
	var inspect = function(bytes, baseTimestamp) {
	  var isAacData = isLikelyAacData(bytes);
	
	  var result;
	
	  if (isAacData) {
	    result = inspectAac_(bytes);
	  } else {
	    result = inspectTs_(bytes);
	  }
	
	  if (!result || (!result.audio && !result.video)) {
	    return null;
	  }
	
	  adjustTimestamp_(result, baseTimestamp);
	
	  return result;
	};
	
	module.exports = {
	  inspect: inspect
	};


/***/ },
/* 957 */
/***/ function(module, exports) {

	var toUnsigned = function(value) {
	  return value >>> 0;
	};
	
	module.exports = {
	  toUnsigned: toUnsigned
	};


/***/ },
/* 958 */
/***/ function(module, exports) {

	var
	  ONE_SECOND_IN_TS = 90000, // 90kHz clock
	  secondsToVideoTs,
	  secondsToAudioTs,
	  videoTsToSeconds,
	  audioTsToSeconds,
	  audioTsToVideoTs,
	  videoTsToAudioTs;
	
	secondsToVideoTs = function(seconds) {
	  return seconds * ONE_SECOND_IN_TS;
	};
	
	secondsToAudioTs = function(seconds, sampleRate) {
	  return seconds * sampleRate;
	};
	
	videoTsToSeconds = function(timestamp) {
	  return timestamp / ONE_SECOND_IN_TS;
	};
	
	audioTsToSeconds = function(timestamp, sampleRate) {
	  return timestamp / sampleRate;
	};
	
	audioTsToVideoTs = function(timestamp, sampleRate) {
	  return secondsToVideoTs(audioTsToSeconds(timestamp, sampleRate));
	};
	
	videoTsToAudioTs = function(timestamp, sampleRate) {
	  return secondsToAudioTs(videoTsToSeconds(timestamp), sampleRate);
	};
	
	module.exports = {
	  secondsToVideoTs: secondsToVideoTs,
	  secondsToAudioTs: secondsToAudioTs,
	  videoTsToSeconds: videoTsToSeconds,
	  audioTsToSeconds: audioTsToSeconds,
	  audioTsToVideoTs: audioTsToVideoTs,
	  videoTsToAudioTs: videoTsToAudioTs
	};


/***/ },
/* 959 */
/***/ function(module, exports) {

	'use strict';
	
	var ExpGolomb;
	
	/**
	 * Parser for exponential Golomb codes, a variable-bitwidth number encoding
	 * scheme used by h264.
	 */
	ExpGolomb = function(workingData) {
	  var
	    // the number of bytes left to examine in workingData
	    workingBytesAvailable = workingData.byteLength,
	
	    // the current word being examined
	    workingWord = 0, // :uint
	
	    // the number of bits left to examine in the current word
	    workingBitsAvailable = 0; // :uint;
	
	  // ():uint
	  this.length = function() {
	    return (8 * workingBytesAvailable);
	  };
	
	  // ():uint
	  this.bitsAvailable = function() {
	    return (8 * workingBytesAvailable) + workingBitsAvailable;
	  };
	
	  // ():void
	  this.loadWord = function() {
	    var
	      position = workingData.byteLength - workingBytesAvailable,
	      workingBytes = new Uint8Array(4),
	      availableBytes = Math.min(4, workingBytesAvailable);
	
	    if (availableBytes === 0) {
	      throw new Error('no bytes available');
	    }
	
	    workingBytes.set(workingData.subarray(position,
	                                          position + availableBytes));
	    workingWord = new DataView(workingBytes.buffer).getUint32(0);
	
	    // track the amount of workingData that has been processed
	    workingBitsAvailable = availableBytes * 8;
	    workingBytesAvailable -= availableBytes;
	  };
	
	  // (count:int):void
	  this.skipBits = function(count) {
	    var skipBytes; // :int
	    if (workingBitsAvailable > count) {
	      workingWord          <<= count;
	      workingBitsAvailable -= count;
	    } else {
	      count -= workingBitsAvailable;
	      skipBytes = Math.floor(count / 8);
	
	      count -= (skipBytes * 8);
	      workingBytesAvailable -= skipBytes;
	
	      this.loadWord();
	
	      workingWord <<= count;
	      workingBitsAvailable -= count;
	    }
	  };
	
	  // (size:int):uint
	  this.readBits = function(size) {
	    var
	      bits = Math.min(workingBitsAvailable, size), // :uint
	      valu = workingWord >>> (32 - bits); // :uint
	    // if size > 31, handle error
	    workingBitsAvailable -= bits;
	    if (workingBitsAvailable > 0) {
	      workingWord <<= bits;
	    } else if (workingBytesAvailable > 0) {
	      this.loadWord();
	    }
	
	    bits = size - bits;
	    if (bits > 0) {
	      return valu << bits | this.readBits(bits);
	    }
	    return valu;
	  };
	
	  // ():uint
	  this.skipLeadingZeros = function() {
	    var leadingZeroCount; // :uint
	    for (leadingZeroCount = 0; leadingZeroCount < workingBitsAvailable; ++leadingZeroCount) {
	      if ((workingWord & (0x80000000 >>> leadingZeroCount)) !== 0) {
	        // the first bit of working word is 1
	        workingWord <<= leadingZeroCount;
	        workingBitsAvailable -= leadingZeroCount;
	        return leadingZeroCount;
	      }
	    }
	
	    // we exhausted workingWord and still have not found a 1
	    this.loadWord();
	    return leadingZeroCount + this.skipLeadingZeros();
	  };
	
	  // ():void
	  this.skipUnsignedExpGolomb = function() {
	    this.skipBits(1 + this.skipLeadingZeros());
	  };
	
	  // ():void
	  this.skipExpGolomb = function() {
	    this.skipBits(1 + this.skipLeadingZeros());
	  };
	
	  // ():uint
	  this.readUnsignedExpGolomb = function() {
	    var clz = this.skipLeadingZeros(); // :uint
	    return this.readBits(clz + 1) - 1;
	  };
	
	  // ():int
	  this.readExpGolomb = function() {
	    var valu = this.readUnsignedExpGolomb(); // :int
	    if (0x01 & valu) {
	      // the number is odd if the low order bit is set
	      return (1 + valu) >>> 1; // add 1 to make it even, and divide by 2
	    }
	    return -1 * (valu >>> 1); // divide by two then make it negative
	  };
	
	  // Some convenience functions
	  // :Boolean
	  this.readBoolean = function() {
	    return this.readBits(1) === 1;
	  };
	
	  // ():int
	  this.readUnsignedByte = function() {
	    return this.readBits(8);
	  };
	
	  this.loadWord();
	};
	
	module.exports = ExpGolomb;


/***/ },
/* 960 */
/***/ function(module, exports, __webpack_require__) {

	var trim = __webpack_require__(1095)
	  , forEach = __webpack_require__(834)
	  , isArray = function(arg) {
	      return Object.prototype.toString.call(arg) === '[object Array]';
	    }
	
	module.exports = function (headers) {
	  if (!headers)
	    return {}
	
	  var result = {}
	
	  forEach(
	      trim(headers).split('\n')
	    , function (row) {
	        var index = row.indexOf(':')
	          , key = trim(row.slice(0, index)).toLowerCase()
	          , value = trim(row.slice(index + 1))
	
	        if (typeof(result[key]) === 'undefined') {
	          result[key] = value
	        } else if (isArray(result[key])) {
	          result[key].push(value)
	        } else {
	          result[key] = [ result[key], value ]
	        }
	      }
	  )
	
	  return result
	}

/***/ },
/* 961 */
/***/ function(module, exports) {

	'use strict';
	
	/*
	 * pkcs7.pad
	 * https://github.com/brightcove/pkcs7
	 *
	 * Copyright (c) 2014 Brightcove
	 * Licensed under the apache2 license.
	 */
	
	var PADDING = void 0;
	
	/**
	 * Returns a new Uint8Array that is padded with PKCS#7 padding.
	 * @param plaintext {Uint8Array} the input bytes before encryption
	 * @return {Uint8Array} the padded bytes
	 * @see http://tools.ietf.org/html/rfc5652
	 */
	function pad(plaintext) {
	  var padding = PADDING[plaintext.byteLength % 16 || 0];
	  var result = new Uint8Array(plaintext.byteLength + padding.length);
	
	  result.set(plaintext);
	  result.set(padding, plaintext.byteLength);
	
	  return result;
	}
	
	// pre-define the padding values
	PADDING = [[16, 16, 16, 16, 16, 16, 16, 16, 16, 16, 16, 16, 16, 16, 16, 16], [15, 15, 15, 15, 15, 15, 15, 15, 15, 15, 15, 15, 15, 15, 15], [14, 14, 14, 14, 14, 14, 14, 14, 14, 14, 14, 14, 14, 14], [13, 13, 13, 13, 13, 13, 13, 13, 13, 13, 13, 13, 13], [12, 12, 12, 12, 12, 12, 12, 12, 12, 12, 12, 12], [11, 11, 11, 11, 11, 11, 11, 11, 11, 11, 11], [10, 10, 10, 10, 10, 10, 10, 10, 10, 10], [9, 9, 9, 9, 9, 9, 9, 9, 9], [8, 8, 8, 8, 8, 8, 8, 8], [7, 7, 7, 7, 7, 7, 7], [6, 6, 6, 6, 6, 6], [5, 5, 5, 5, 5], [4, 4, 4, 4], [3, 3, 3], [2, 2], [1]];
	
	/**
	 * Returns the subarray of a Uint8Array without PKCS#7 padding.
	 * @param padded {Uint8Array} unencrypted bytes that have been padded
	 * @return {Uint8Array} the unpadded bytes
	 * @see http://tools.ietf.org/html/rfc5652
	 */
	function unpad(padded) {
	  return padded.subarray(0, padded.byteLength - padded[padded.byteLength - 1]);
	}
	
	var version = "1.0.2";
	
	exports.pad = pad;
	exports.unpad = unpad;
	exports.VERSION = version;


/***/ },
/* 962 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';
	
	var printWarning = function() {};
	
	if (false) {
	  var ReactPropTypesSecret = require('./lib/ReactPropTypesSecret');
	  var loggedTypeFailures = {};
	
	  printWarning = function(text) {
	    var message = 'Warning: ' + text;
	    if (typeof console !== 'undefined') {
	      console.error(message);
	    }
	    try {
	      // --- Welcome to debugging React ---
	      // This error was thrown as a convenience so that you can use this stack
	      // to find the callsite that caused this warning to fire.
	      throw new Error(message);
	    } catch (x) {}
	  };
	}
	
	/**
	 * Assert that the values match with the type specs.
	 * Error messages are memorized and will only be shown once.
	 *
	 * @param {object} typeSpecs Map of name to a ReactPropType
	 * @param {object} values Runtime values that need to be type-checked
	 * @param {string} location e.g. "prop", "context", "child context"
	 * @param {string} componentName Name of the component for error messages.
	 * @param {?Function} getStack Returns the component stack.
	 * @private
	 */
	function checkPropTypes(typeSpecs, values, location, componentName, getStack) {
	  if (false) {
	    for (var typeSpecName in typeSpecs) {
	      if (typeSpecs.hasOwnProperty(typeSpecName)) {
	        var error;
	        // Prop type validation may throw. In case they do, we don't want to
	        // fail the render phase where it didn't fail before. So we log it.
	        // After these have been cleaned up, we'll let them throw.
	        try {
	          // This is intentionally an invariant that gets caught. It's the same
	          // behavior as without this statement except with a better message.
	          if (typeof typeSpecs[typeSpecName] !== 'function') {
	            var err = Error(
	              (componentName || 'React class') + ': ' + location + ' type `' + typeSpecName + '` is invalid; ' +
	              'it must be a function, usually from the `prop-types` package, but received `' + typeof typeSpecs[typeSpecName] + '`.'
	            );
	            err.name = 'Invariant Violation';
	            throw err;
	          }
	          error = typeSpecs[typeSpecName](values, typeSpecName, componentName, location, null, ReactPropTypesSecret);
	        } catch (ex) {
	          error = ex;
	        }
	        if (error && !(error instanceof Error)) {
	          printWarning(
	            (componentName || 'React class') + ': type specification of ' +
	            location + ' `' + typeSpecName + '` is invalid; the type checker ' +
	            'function must return `null` or an `Error` but returned a ' + typeof error + '. ' +
	            'You may have forgotten to pass an argument to the type checker ' +
	            'creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and ' +
	            'shape all require an argument).'
	          )
	
	        }
	        if (error instanceof Error && !(error.message in loggedTypeFailures)) {
	          // Only monitor this failure once because there tends to be a lot of the
	          // same error.
	          loggedTypeFailures[error.message] = true;
	
	          var stack = getStack ? getStack() : '';
	
	          printWarning(
	            'Failed ' + location + ' type: ' + error.message + (stack != null ? stack : '')
	          );
	        }
	      }
	    }
	  }
	}
	
	module.exports = checkPropTypes;


/***/ },
/* 963 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';
	
	var ReactPropTypesSecret = __webpack_require__(379);
	
	function emptyFunction() {}
	
	module.exports = function() {
	  function shim(props, propName, componentName, location, propFullName, secret) {
	    if (secret === ReactPropTypesSecret) {
	      // It is still safe when called from React.
	      return;
	    }
	    var err = new Error(
	      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
	      'Use PropTypes.checkPropTypes() to call them. ' +
	      'Read more at http://fb.me/use-check-prop-types'
	    );
	    err.name = 'Invariant Violation';
	    throw err;
	  };
	  shim.isRequired = shim;
	  function getShim() {
	    return shim;
	  };
	  // Important!
	  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
	  var ReactPropTypes = {
	    array: shim,
	    bool: shim,
	    func: shim,
	    number: shim,
	    object: shim,
	    string: shim,
	    symbol: shim,
	
	    any: shim,
	    arrayOf: getShim,
	    element: shim,
	    instanceOf: getShim,
	    node: shim,
	    objectOf: getShim,
	    oneOf: getShim,
	    oneOfType: getShim,
	    shape: getShim,
	    exact: getShim
	  };
	
	  ReactPropTypes.checkPropTypes = emptyFunction;
	  ReactPropTypes.PropTypes = ReactPropTypes;
	
	  return ReactPropTypes;
	};


/***/ },
/* 964 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';
	
	var assign = __webpack_require__(36);
	
	var ReactPropTypesSecret = __webpack_require__(379);
	var checkPropTypes = __webpack_require__(962);
	
	var printWarning = function() {};
	
	if (false) {
	  printWarning = function(text) {
	    var message = 'Warning: ' + text;
	    if (typeof console !== 'undefined') {
	      console.error(message);
	    }
	    try {
	      // --- Welcome to debugging React ---
	      // This error was thrown as a convenience so that you can use this stack
	      // to find the callsite that caused this warning to fire.
	      throw new Error(message);
	    } catch (x) {}
	  };
	}
	
	function emptyFunctionThatReturnsNull() {
	  return null;
	}
	
	module.exports = function(isValidElement, throwOnDirectAccess) {
	  /* global Symbol */
	  var ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
	  var FAUX_ITERATOR_SYMBOL = '@@iterator'; // Before Symbol spec.
	
	  /**
	   * Returns the iterator method function contained on the iterable object.
	   *
	   * Be sure to invoke the function with the iterable as context:
	   *
	   *     var iteratorFn = getIteratorFn(myIterable);
	   *     if (iteratorFn) {
	   *       var iterator = iteratorFn.call(myIterable);
	   *       ...
	   *     }
	   *
	   * @param {?object} maybeIterable
	   * @return {?function}
	   */
	  function getIteratorFn(maybeIterable) {
	    var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
	    if (typeof iteratorFn === 'function') {
	      return iteratorFn;
	    }
	  }
	
	  /**
	   * Collection of methods that allow declaration and validation of props that are
	   * supplied to React components. Example usage:
	   *
	   *   var Props = require('ReactPropTypes');
	   *   var MyArticle = React.createClass({
	   *     propTypes: {
	   *       // An optional string prop named "description".
	   *       description: Props.string,
	   *
	   *       // A required enum prop named "category".
	   *       category: Props.oneOf(['News','Photos']).isRequired,
	   *
	   *       // A prop named "dialog" that requires an instance of Dialog.
	   *       dialog: Props.instanceOf(Dialog).isRequired
	   *     },
	   *     render: function() { ... }
	   *   });
	   *
	   * A more formal specification of how these methods are used:
	   *
	   *   type := array|bool|func|object|number|string|oneOf([...])|instanceOf(...)
	   *   decl := ReactPropTypes.{type}(.isRequired)?
	   *
	   * Each and every declaration produces a function with the same signature. This
	   * allows the creation of custom validation functions. For example:
	   *
	   *  var MyLink = React.createClass({
	   *    propTypes: {
	   *      // An optional string or URI prop named "href".
	   *      href: function(props, propName, componentName) {
	   *        var propValue = props[propName];
	   *        if (propValue != null && typeof propValue !== 'string' &&
	   *            !(propValue instanceof URI)) {
	   *          return new Error(
	   *            'Expected a string or an URI for ' + propName + ' in ' +
	   *            componentName
	   *          );
	   *        }
	   *      }
	   *    },
	   *    render: function() {...}
	   *  });
	   *
	   * @internal
	   */
	
	  var ANONYMOUS = '<<anonymous>>';
	
	  // Important!
	  // Keep this list in sync with production version in `./factoryWithThrowingShims.js`.
	  var ReactPropTypes = {
	    array: createPrimitiveTypeChecker('array'),
	    bool: createPrimitiveTypeChecker('boolean'),
	    func: createPrimitiveTypeChecker('function'),
	    number: createPrimitiveTypeChecker('number'),
	    object: createPrimitiveTypeChecker('object'),
	    string: createPrimitiveTypeChecker('string'),
	    symbol: createPrimitiveTypeChecker('symbol'),
	
	    any: createAnyTypeChecker(),
	    arrayOf: createArrayOfTypeChecker,
	    element: createElementTypeChecker(),
	    instanceOf: createInstanceTypeChecker,
	    node: createNodeChecker(),
	    objectOf: createObjectOfTypeChecker,
	    oneOf: createEnumTypeChecker,
	    oneOfType: createUnionTypeChecker,
	    shape: createShapeTypeChecker,
	    exact: createStrictShapeTypeChecker,
	  };
	
	  /**
	   * inlined Object.is polyfill to avoid requiring consumers ship their own
	   * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
	   */
	  /*eslint-disable no-self-compare*/
	  function is(x, y) {
	    // SameValue algorithm
	    if (x === y) {
	      // Steps 1-5, 7-10
	      // Steps 6.b-6.e: +0 != -0
	      return x !== 0 || 1 / x === 1 / y;
	    } else {
	      // Step 6.a: NaN == NaN
	      return x !== x && y !== y;
	    }
	  }
	  /*eslint-enable no-self-compare*/
	
	  /**
	   * We use an Error-like object for backward compatibility as people may call
	   * PropTypes directly and inspect their output. However, we don't use real
	   * Errors anymore. We don't inspect their stack anyway, and creating them
	   * is prohibitively expensive if they are created too often, such as what
	   * happens in oneOfType() for any type before the one that matched.
	   */
	  function PropTypeError(message) {
	    this.message = message;
	    this.stack = '';
	  }
	  // Make `instanceof Error` still work for returned errors.
	  PropTypeError.prototype = Error.prototype;
	
	  function createChainableTypeChecker(validate) {
	    if (false) {
	      var manualPropTypeCallCache = {};
	      var manualPropTypeWarningCount = 0;
	    }
	    function checkType(isRequired, props, propName, componentName, location, propFullName, secret) {
	      componentName = componentName || ANONYMOUS;
	      propFullName = propFullName || propName;
	
	      if (secret !== ReactPropTypesSecret) {
	        if (throwOnDirectAccess) {
	          // New behavior only for users of `prop-types` package
	          var err = new Error(
	            'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
	            'Use `PropTypes.checkPropTypes()` to call them. ' +
	            'Read more at http://fb.me/use-check-prop-types'
	          );
	          err.name = 'Invariant Violation';
	          throw err;
	        } else if (false) {
	          // Old behavior for people using React.PropTypes
	          var cacheKey = componentName + ':' + propName;
	          if (
	            !manualPropTypeCallCache[cacheKey] &&
	            // Avoid spamming the console because they are often not actionable except for lib authors
	            manualPropTypeWarningCount < 3
	          ) {
	            printWarning(
	              'You are manually calling a React.PropTypes validation ' +
	              'function for the `' + propFullName + '` prop on `' + componentName  + '`. This is deprecated ' +
	              'and will throw in the standalone `prop-types` package. ' +
	              'You may be seeing this warning due to a third-party PropTypes ' +
	              'library. See https://fb.me/react-warning-dont-call-proptypes ' + 'for details.'
	            );
	            manualPropTypeCallCache[cacheKey] = true;
	            manualPropTypeWarningCount++;
	          }
	        }
	      }
	      if (props[propName] == null) {
	        if (isRequired) {
	          if (props[propName] === null) {
	            return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required ' + ('in `' + componentName + '`, but its value is `null`.'));
	          }
	          return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required in ' + ('`' + componentName + '`, but its value is `undefined`.'));
	        }
	        return null;
	      } else {
	        return validate(props, propName, componentName, location, propFullName);
	      }
	    }
	
	    var chainedCheckType = checkType.bind(null, false);
	    chainedCheckType.isRequired = checkType.bind(null, true);
	
	    return chainedCheckType;
	  }
	
	  function createPrimitiveTypeChecker(expectedType) {
	    function validate(props, propName, componentName, location, propFullName, secret) {
	      var propValue = props[propName];
	      var propType = getPropType(propValue);
	      if (propType !== expectedType) {
	        // `propValue` being instance of, say, date/regexp, pass the 'object'
	        // check, but we can offer a more precise error message here rather than
	        // 'of type `object`'.
	        var preciseType = getPreciseType(propValue);
	
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + preciseType + '` supplied to `' + componentName + '`, expected ') + ('`' + expectedType + '`.'));
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createAnyTypeChecker() {
	    return createChainableTypeChecker(emptyFunctionThatReturnsNull);
	  }
	
	  function createArrayOfTypeChecker(typeChecker) {
	    function validate(props, propName, componentName, location, propFullName) {
	      if (typeof typeChecker !== 'function') {
	        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside arrayOf.');
	      }
	      var propValue = props[propName];
	      if (!Array.isArray(propValue)) {
	        var propType = getPropType(propValue);
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an array.'));
	      }
	      for (var i = 0; i < propValue.length; i++) {
	        var error = typeChecker(propValue, i, componentName, location, propFullName + '[' + i + ']', ReactPropTypesSecret);
	        if (error instanceof Error) {
	          return error;
	        }
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createElementTypeChecker() {
	    function validate(props, propName, componentName, location, propFullName) {
	      var propValue = props[propName];
	      if (!isValidElement(propValue)) {
	        var propType = getPropType(propValue);
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement.'));
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createInstanceTypeChecker(expectedClass) {
	    function validate(props, propName, componentName, location, propFullName) {
	      if (!(props[propName] instanceof expectedClass)) {
	        var expectedClassName = expectedClass.name || ANONYMOUS;
	        var actualClassName = getClassName(props[propName]);
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + actualClassName + '` supplied to `' + componentName + '`, expected ') + ('instance of `' + expectedClassName + '`.'));
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createEnumTypeChecker(expectedValues) {
	    if (!Array.isArray(expectedValues)) {
	       false ? printWarning('Invalid argument supplied to oneOf, expected an instance of array.') : void 0;
	      return emptyFunctionThatReturnsNull;
	    }
	
	    function validate(props, propName, componentName, location, propFullName) {
	      var propValue = props[propName];
	      for (var i = 0; i < expectedValues.length; i++) {
	        if (is(propValue, expectedValues[i])) {
	          return null;
	        }
	      }
	
	      var valuesString = JSON.stringify(expectedValues);
	      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of value `' + propValue + '` ' + ('supplied to `' + componentName + '`, expected one of ' + valuesString + '.'));
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createObjectOfTypeChecker(typeChecker) {
	    function validate(props, propName, componentName, location, propFullName) {
	      if (typeof typeChecker !== 'function') {
	        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside objectOf.');
	      }
	      var propValue = props[propName];
	      var propType = getPropType(propValue);
	      if (propType !== 'object') {
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an object.'));
	      }
	      for (var key in propValue) {
	        if (propValue.hasOwnProperty(key)) {
	          var error = typeChecker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
	          if (error instanceof Error) {
	            return error;
	          }
	        }
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createUnionTypeChecker(arrayOfTypeCheckers) {
	    if (!Array.isArray(arrayOfTypeCheckers)) {
	       false ? printWarning('Invalid argument supplied to oneOfType, expected an instance of array.') : void 0;
	      return emptyFunctionThatReturnsNull;
	    }
	
	    for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
	      var checker = arrayOfTypeCheckers[i];
	      if (typeof checker !== 'function') {
	        printWarning(
	          'Invalid argument supplied to oneOfType. Expected an array of check functions, but ' +
	          'received ' + getPostfixForTypeWarning(checker) + ' at index ' + i + '.'
	        );
	        return emptyFunctionThatReturnsNull;
	      }
	    }
	
	    function validate(props, propName, componentName, location, propFullName) {
	      for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
	        var checker = arrayOfTypeCheckers[i];
	        if (checker(props, propName, componentName, location, propFullName, ReactPropTypesSecret) == null) {
	          return null;
	        }
	      }
	
	      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`.'));
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createNodeChecker() {
	    function validate(props, propName, componentName, location, propFullName) {
	      if (!isNode(props[propName])) {
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`, expected a ReactNode.'));
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createShapeTypeChecker(shapeTypes) {
	    function validate(props, propName, componentName, location, propFullName) {
	      var propValue = props[propName];
	      var propType = getPropType(propValue);
	      if (propType !== 'object') {
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
	      }
	      for (var key in shapeTypes) {
	        var checker = shapeTypes[key];
	        if (!checker) {
	          continue;
	        }
	        var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
	        if (error) {
	          return error;
	        }
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createStrictShapeTypeChecker(shapeTypes) {
	    function validate(props, propName, componentName, location, propFullName) {
	      var propValue = props[propName];
	      var propType = getPropType(propValue);
	      if (propType !== 'object') {
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
	      }
	      // We need to check all keys in case some are required but missing from
	      // props.
	      var allKeys = assign({}, props[propName], shapeTypes);
	      for (var key in allKeys) {
	        var checker = shapeTypes[key];
	        if (!checker) {
	          return new PropTypeError(
	            'Invalid ' + location + ' `' + propFullName + '` key `' + key + '` supplied to `' + componentName + '`.' +
	            '\nBad object: ' + JSON.stringify(props[propName], null, '  ') +
	            '\nValid keys: ' +  JSON.stringify(Object.keys(shapeTypes), null, '  ')
	          );
	        }
	        var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
	        if (error) {
	          return error;
	        }
	      }
	      return null;
	    }
	
	    return createChainableTypeChecker(validate);
	  }
	
	  function isNode(propValue) {
	    switch (typeof propValue) {
	      case 'number':
	      case 'string':
	      case 'undefined':
	        return true;
	      case 'boolean':
	        return !propValue;
	      case 'object':
	        if (Array.isArray(propValue)) {
	          return propValue.every(isNode);
	        }
	        if (propValue === null || isValidElement(propValue)) {
	          return true;
	        }
	
	        var iteratorFn = getIteratorFn(propValue);
	        if (iteratorFn) {
	          var iterator = iteratorFn.call(propValue);
	          var step;
	          if (iteratorFn !== propValue.entries) {
	            while (!(step = iterator.next()).done) {
	              if (!isNode(step.value)) {
	                return false;
	              }
	            }
	          } else {
	            // Iterator will provide entry [k,v] tuples rather than values.
	            while (!(step = iterator.next()).done) {
	              var entry = step.value;
	              if (entry) {
	                if (!isNode(entry[1])) {
	                  return false;
	                }
	              }
	            }
	          }
	        } else {
	          return false;
	        }
	
	        return true;
	      default:
	        return false;
	    }
	  }
	
	  function isSymbol(propType, propValue) {
	    // Native Symbol.
	    if (propType === 'symbol') {
	      return true;
	    }
	
	    // 19.4.3.5 Symbol.prototype[@@toStringTag] === 'Symbol'
	    if (propValue['@@toStringTag'] === 'Symbol') {
	      return true;
	    }
	
	    // Fallback for non-spec compliant Symbols which are polyfilled.
	    if (typeof Symbol === 'function' && propValue instanceof Symbol) {
	      return true;
	    }
	
	    return false;
	  }
	
	  // Equivalent of `typeof` but with special handling for array and regexp.
	  function getPropType(propValue) {
	    var propType = typeof propValue;
	    if (Array.isArray(propValue)) {
	      return 'array';
	    }
	    if (propValue instanceof RegExp) {
	      // Old webkits (at least until Android 4.0) return 'function' rather than
	      // 'object' for typeof a RegExp. We'll normalize this here so that /bla/
	      // passes PropTypes.object.
	      return 'object';
	    }
	    if (isSymbol(propType, propValue)) {
	      return 'symbol';
	    }
	    return propType;
	  }
	
	  // This handles more types than `getPropType`. Only used for error messages.
	  // See `createPrimitiveTypeChecker`.
	  function getPreciseType(propValue) {
	    if (typeof propValue === 'undefined' || propValue === null) {
	      return '' + propValue;
	    }
	    var propType = getPropType(propValue);
	    if (propType === 'object') {
	      if (propValue instanceof Date) {
	        return 'date';
	      } else if (propValue instanceof RegExp) {
	        return 'regexp';
	      }
	    }
	    return propType;
	  }
	
	  // Returns a string that is postfixed to a warning about an invalid type.
	  // For example, "undefined" or "of type array"
	  function getPostfixForTypeWarning(value) {
	    var type = getPreciseType(value);
	    switch (type) {
	      case 'array':
	      case 'object':
	        return 'an ' + type;
	      case 'boolean':
	      case 'date':
	      case 'regexp':
	        return 'a ' + type;
	      default:
	        return type;
	    }
	  }
	
	  // Returns class name of the object, if any.
	  function getClassName(propValue) {
	    if (!propValue.constructor || !propValue.constructor.name) {
	      return ANONYMOUS;
	    }
	    return propValue.constructor.name;
	  }
	
	  ReactPropTypes.checkPropTypes = checkPropTypes;
	  ReactPropTypes.PropTypes = ReactPropTypes;
	
	  return ReactPropTypes;
	};


/***/ },
/* 965 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var strictUriEncode = __webpack_require__(1083);
	var objectAssign = __webpack_require__(36);
	
	function encoderForArrayFormat(opts) {
		switch (opts.arrayFormat) {
			case 'index':
				return function (key, value, index) {
					return value === null ? [
						encode(key, opts),
						'[',
						index,
						']'
					].join('') : [
						encode(key, opts),
						'[',
						encode(index, opts),
						']=',
						encode(value, opts)
					].join('');
				};
	
			case 'bracket':
				return function (key, value) {
					return value === null ? encode(key, opts) : [
						encode(key, opts),
						'[]=',
						encode(value, opts)
					].join('');
				};
	
			default:
				return function (key, value) {
					return value === null ? encode(key, opts) : [
						encode(key, opts),
						'=',
						encode(value, opts)
					].join('');
				};
		}
	}
	
	function parserForArrayFormat(opts) {
		var result;
	
		switch (opts.arrayFormat) {
			case 'index':
				return function (key, value, accumulator) {
					result = /\[(\d*)\]$/.exec(key);
	
					key = key.replace(/\[\d*\]$/, '');
	
					if (!result) {
						accumulator[key] = value;
						return;
					}
	
					if (accumulator[key] === undefined) {
						accumulator[key] = {};
					}
	
					accumulator[key][result[1]] = value;
				};
	
			case 'bracket':
				return function (key, value, accumulator) {
					result = /(\[\])$/.exec(key);
					key = key.replace(/\[\]$/, '');
	
					if (!result) {
						accumulator[key] = value;
						return;
					} else if (accumulator[key] === undefined) {
						accumulator[key] = [value];
						return;
					}
	
					accumulator[key] = [].concat(accumulator[key], value);
				};
	
			default:
				return function (key, value, accumulator) {
					if (accumulator[key] === undefined) {
						accumulator[key] = value;
						return;
					}
	
					accumulator[key] = [].concat(accumulator[key], value);
				};
		}
	}
	
	function encode(value, opts) {
		if (opts.encode) {
			return opts.strict ? strictUriEncode(value) : encodeURIComponent(value);
		}
	
		return value;
	}
	
	function keysSorter(input) {
		if (Array.isArray(input)) {
			return input.sort();
		} else if (typeof input === 'object') {
			return keysSorter(Object.keys(input)).sort(function (a, b) {
				return Number(a) - Number(b);
			}).map(function (key) {
				return input[key];
			});
		}
	
		return input;
	}
	
	exports.extract = function (str) {
		return str.split('?')[1] || '';
	};
	
	exports.parse = function (str, opts) {
		opts = objectAssign({arrayFormat: 'none'}, opts);
	
		var formatter = parserForArrayFormat(opts);
	
		// Create an object with no prototype
		// https://github.com/sindresorhus/query-string/issues/47
		var ret = Object.create(null);
	
		if (typeof str !== 'string') {
			return ret;
		}
	
		str = str.trim().replace(/^(\?|#|&)/, '');
	
		if (!str) {
			return ret;
		}
	
		str.split('&').forEach(function (param) {
			var parts = param.replace(/\+/g, ' ').split('=');
			// Firefox (pre 40) decodes `%3D` to `=`
			// https://github.com/sindresorhus/query-string/pull/37
			var key = parts.shift();
			var val = parts.length > 0 ? parts.join('=') : undefined;
	
			// missing `=` should be `null`:
			// http://w3.org/TR/2012/WD-url-20120524/#collect-url-parameters
			val = val === undefined ? null : decodeURIComponent(val);
	
			formatter(decodeURIComponent(key), val, ret);
		});
	
		return Object.keys(ret).sort().reduce(function (result, key) {
			var val = ret[key];
			if (Boolean(val) && typeof val === 'object' && !Array.isArray(val)) {
				// Sort object keys, not values
				result[key] = keysSorter(val);
			} else {
				result[key] = val;
			}
	
			return result;
		}, Object.create(null));
	};
	
	exports.stringify = function (obj, opts) {
		var defaults = {
			encode: true,
			strict: true,
			arrayFormat: 'none'
		};
	
		opts = objectAssign(defaults, opts);
	
		var formatter = encoderForArrayFormat(opts);
	
		return obj ? Object.keys(obj).sort().map(function (key) {
			var val = obj[key];
	
			if (val === undefined) {
				return '';
			}
	
			if (val === null) {
				return encode(key, opts);
			}
	
			if (Array.isArray(val)) {
				var result = [];
	
				val.slice().forEach(function (val2) {
					if (val2 === undefined) {
						return;
					}
	
					result.push(formatter(key, val2, result.length));
				});
	
				return result.join('&');
			}
	
			return encode(key, opts) + '=' + encode(val, opts);
		}).filter(function (x) {
			return x.length > 0;
		}).join('&') : '';
	};


/***/ },
/* 966 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ARIADOMPropertyConfig = {
	  Properties: {
	    // Global States and Properties
	    'aria-current': 0, // state
	    'aria-details': 0,
	    'aria-disabled': 0, // state
	    'aria-hidden': 0, // state
	    'aria-invalid': 0, // state
	    'aria-keyshortcuts': 0,
	    'aria-label': 0,
	    'aria-roledescription': 0,
	    // Widget Attributes
	    'aria-autocomplete': 0,
	    'aria-checked': 0,
	    'aria-expanded': 0,
	    'aria-haspopup': 0,
	    'aria-level': 0,
	    'aria-modal': 0,
	    'aria-multiline': 0,
	    'aria-multiselectable': 0,
	    'aria-orientation': 0,
	    'aria-placeholder': 0,
	    'aria-pressed': 0,
	    'aria-readonly': 0,
	    'aria-required': 0,
	    'aria-selected': 0,
	    'aria-sort': 0,
	    'aria-valuemax': 0,
	    'aria-valuemin': 0,
	    'aria-valuenow': 0,
	    'aria-valuetext': 0,
	    // Live Region Attributes
	    'aria-atomic': 0,
	    'aria-busy': 0,
	    'aria-live': 0,
	    'aria-relevant': 0,
	    // Drag-and-Drop Attributes
	    'aria-dropeffect': 0,
	    'aria-grabbed': 0,
	    // Relationship Attributes
	    'aria-activedescendant': 0,
	    'aria-colcount': 0,
	    'aria-colindex': 0,
	    'aria-colspan': 0,
	    'aria-controls': 0,
	    'aria-describedby': 0,
	    'aria-errormessage': 0,
	    'aria-flowto': 0,
	    'aria-labelledby': 0,
	    'aria-owns': 0,
	    'aria-posinset': 0,
	    'aria-rowcount': 0,
	    'aria-rowindex': 0,
	    'aria-rowspan': 0,
	    'aria-setsize': 0
	  },
	  DOMAttributeNames: {},
	  DOMPropertyNames: {}
	};
	
	module.exports = ARIADOMPropertyConfig;

/***/ },
/* 967 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ReactDOMComponentTree = __webpack_require__(41);
	
	var focusNode = __webpack_require__(330);
	
	var AutoFocusUtils = {
	  focusDOMComponent: function () {
	    focusNode(ReactDOMComponentTree.getNodeFromInstance(this));
	  }
	};
	
	module.exports = AutoFocusUtils;

/***/ },
/* 968 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var EventPropagators = __webpack_require__(145);
	var ExecutionEnvironment = __webpack_require__(51);
	var FallbackCompositionState = __webpack_require__(974);
	var SyntheticCompositionEvent = __webpack_require__(1008);
	var SyntheticInputEvent = __webpack_require__(1011);
	
	var END_KEYCODES = [9, 13, 27, 32]; // Tab, Return, Esc, Space
	var START_KEYCODE = 229;
	
	var canUseCompositionEvent = ExecutionEnvironment.canUseDOM && 'CompositionEvent' in window;
	
	var documentMode = null;
	if (ExecutionEnvironment.canUseDOM && 'documentMode' in document) {
	  documentMode = document.documentMode;
	}
	
	// Webkit offers a very useful `textInput` event that can be used to
	// directly represent `beforeInput`. The IE `textinput` event is not as
	// useful, so we don't use it.
	var canUseTextInputEvent = ExecutionEnvironment.canUseDOM && 'TextEvent' in window && !documentMode && !isPresto();
	
	// In IE9+, we have access to composition events, but the data supplied
	// by the native compositionend event may be incorrect. Japanese ideographic
	// spaces, for instance (\u3000) are not recorded correctly.
	var useFallbackCompositionData = ExecutionEnvironment.canUseDOM && (!canUseCompositionEvent || documentMode && documentMode > 8 && documentMode <= 11);
	
	/**
	 * Opera <= 12 includes TextEvent in window, but does not fire
	 * text input events. Rely on keypress instead.
	 */
	function isPresto() {
	  var opera = window.opera;
	  return typeof opera === 'object' && typeof opera.version === 'function' && parseInt(opera.version(), 10) <= 12;
	}
	
	var SPACEBAR_CODE = 32;
	var SPACEBAR_CHAR = String.fromCharCode(SPACEBAR_CODE);
	
	// Events and their corresponding property names.
	var eventTypes = {
	  beforeInput: {
	    phasedRegistrationNames: {
	      bubbled: 'onBeforeInput',
	      captured: 'onBeforeInputCapture'
	    },
	    dependencies: ['topCompositionEnd', 'topKeyPress', 'topTextInput', 'topPaste']
	  },
	  compositionEnd: {
	    phasedRegistrationNames: {
	      bubbled: 'onCompositionEnd',
	      captured: 'onCompositionEndCapture'
	    },
	    dependencies: ['topBlur', 'topCompositionEnd', 'topKeyDown', 'topKeyPress', 'topKeyUp', 'topMouseDown']
	  },
	  compositionStart: {
	    phasedRegistrationNames: {
	      bubbled: 'onCompositionStart',
	      captured: 'onCompositionStartCapture'
	    },
	    dependencies: ['topBlur', 'topCompositionStart', 'topKeyDown', 'topKeyPress', 'topKeyUp', 'topMouseDown']
	  },
	  compositionUpdate: {
	    phasedRegistrationNames: {
	      bubbled: 'onCompositionUpdate',
	      captured: 'onCompositionUpdateCapture'
	    },
	    dependencies: ['topBlur', 'topCompositionUpdate', 'topKeyDown', 'topKeyPress', 'topKeyUp', 'topMouseDown']
	  }
	};
	
	// Track whether we've ever handled a keypress on the space key.
	var hasSpaceKeypress = false;
	
	/**
	 * Return whether a native keypress event is assumed to be a command.
	 * This is required because Firefox fires `keypress` events for key commands
	 * (cut, copy, select-all, etc.) even though no character is inserted.
	 */
	function isKeypressCommand(nativeEvent) {
	  return (nativeEvent.ctrlKey || nativeEvent.altKey || nativeEvent.metaKey) &&
	  // ctrlKey && altKey is equivalent to AltGr, and is not a command.
	  !(nativeEvent.ctrlKey && nativeEvent.altKey);
	}
	
	/**
	 * Translate native top level events into event types.
	 *
	 * @param {string} topLevelType
	 * @return {object}
	 */
	function getCompositionEventType(topLevelType) {
	  switch (topLevelType) {
	    case 'topCompositionStart':
	      return eventTypes.compositionStart;
	    case 'topCompositionEnd':
	      return eventTypes.compositionEnd;
	    case 'topCompositionUpdate':
	      return eventTypes.compositionUpdate;
	  }
	}
	
	/**
	 * Does our fallback best-guess model think this event signifies that
	 * composition has begun?
	 *
	 * @param {string} topLevelType
	 * @param {object} nativeEvent
	 * @return {boolean}
	 */
	function isFallbackCompositionStart(topLevelType, nativeEvent) {
	  return topLevelType === 'topKeyDown' && nativeEvent.keyCode === START_KEYCODE;
	}
	
	/**
	 * Does our fallback mode think that this event is the end of composition?
	 *
	 * @param {string} topLevelType
	 * @param {object} nativeEvent
	 * @return {boolean}
	 */
	function isFallbackCompositionEnd(topLevelType, nativeEvent) {
	  switch (topLevelType) {
	    case 'topKeyUp':
	      // Command keys insert or clear IME input.
	      return END_KEYCODES.indexOf(nativeEvent.keyCode) !== -1;
	    case 'topKeyDown':
	      // Expect IME keyCode on each keydown. If we get any other
	      // code we must have exited earlier.
	      return nativeEvent.keyCode !== START_KEYCODE;
	    case 'topKeyPress':
	    case 'topMouseDown':
	    case 'topBlur':
	      // Events are not possible without cancelling IME.
	      return true;
	    default:
	      return false;
	  }
	}
	
	/**
	 * Google Input Tools provides composition data via a CustomEvent,
	 * with the `data` property populated in the `detail` object. If this
	 * is available on the event object, use it. If not, this is a plain
	 * composition event and we have nothing special to extract.
	 *
	 * @param {object} nativeEvent
	 * @return {?string}
	 */
	function getDataFromCustomEvent(nativeEvent) {
	  var detail = nativeEvent.detail;
	  if (typeof detail === 'object' && 'data' in detail) {
	    return detail.data;
	  }
	  return null;
	}
	
	// Track the current IME composition fallback object, if any.
	var currentComposition = null;
	
	/**
	 * @return {?object} A SyntheticCompositionEvent.
	 */
	function extractCompositionEvent(topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	  var eventType;
	  var fallbackData;
	
	  if (canUseCompositionEvent) {
	    eventType = getCompositionEventType(topLevelType);
	  } else if (!currentComposition) {
	    if (isFallbackCompositionStart(topLevelType, nativeEvent)) {
	      eventType = eventTypes.compositionStart;
	    }
	  } else if (isFallbackCompositionEnd(topLevelType, nativeEvent)) {
	    eventType = eventTypes.compositionEnd;
	  }
	
	  if (!eventType) {
	    return null;
	  }
	
	  if (useFallbackCompositionData) {
	    // The current composition is stored statically and must not be
	    // overwritten while composition continues.
	    if (!currentComposition && eventType === eventTypes.compositionStart) {
	      currentComposition = FallbackCompositionState.getPooled(nativeEventTarget);
	    } else if (eventType === eventTypes.compositionEnd) {
	      if (currentComposition) {
	        fallbackData = currentComposition.getData();
	      }
	    }
	  }
	
	  var event = SyntheticCompositionEvent.getPooled(eventType, targetInst, nativeEvent, nativeEventTarget);
	
	  if (fallbackData) {
	    // Inject data generated from fallback path into the synthetic event.
	    // This matches the property of native CompositionEventInterface.
	    event.data = fallbackData;
	  } else {
	    var customData = getDataFromCustomEvent(nativeEvent);
	    if (customData !== null) {
	      event.data = customData;
	    }
	  }
	
	  EventPropagators.accumulateTwoPhaseDispatches(event);
	  return event;
	}
	
	/**
	 * @param {string} topLevelType Record from `EventConstants`.
	 * @param {object} nativeEvent Native browser event.
	 * @return {?string} The string corresponding to this `beforeInput` event.
	 */
	function getNativeBeforeInputChars(topLevelType, nativeEvent) {
	  switch (topLevelType) {
	    case 'topCompositionEnd':
	      return getDataFromCustomEvent(nativeEvent);
	    case 'topKeyPress':
	      /**
	       * If native `textInput` events are available, our goal is to make
	       * use of them. However, there is a special case: the spacebar key.
	       * In Webkit, preventing default on a spacebar `textInput` event
	       * cancels character insertion, but it *also* causes the browser
	       * to fall back to its default spacebar behavior of scrolling the
	       * page.
	       *
	       * Tracking at:
	       * https://code.google.com/p/chromium/issues/detail?id=355103
	       *
	       * To avoid this issue, use the keypress event as if no `textInput`
	       * event is available.
	       */
	      var which = nativeEvent.which;
	      if (which !== SPACEBAR_CODE) {
	        return null;
	      }
	
	      hasSpaceKeypress = true;
	      return SPACEBAR_CHAR;
	
	    case 'topTextInput':
	      // Record the characters to be added to the DOM.
	      var chars = nativeEvent.data;
	
	      // If it's a spacebar character, assume that we have already handled
	      // it at the keypress level and bail immediately. Android Chrome
	      // doesn't give us keycodes, so we need to blacklist it.
	      if (chars === SPACEBAR_CHAR && hasSpaceKeypress) {
	        return null;
	      }
	
	      return chars;
	
	    default:
	      // For other native event types, do nothing.
	      return null;
	  }
	}
	
	/**
	 * For browsers that do not provide the `textInput` event, extract the
	 * appropriate string to use for SyntheticInputEvent.
	 *
	 * @param {string} topLevelType Record from `EventConstants`.
	 * @param {object} nativeEvent Native browser event.
	 * @return {?string} The fallback string for this `beforeInput` event.
	 */
	function getFallbackBeforeInputChars(topLevelType, nativeEvent) {
	  // If we are currently composing (IME) and using a fallback to do so,
	  // try to extract the composed characters from the fallback object.
	  // If composition event is available, we extract a string only at
	  // compositionevent, otherwise extract it at fallback events.
	  if (currentComposition) {
	    if (topLevelType === 'topCompositionEnd' || !canUseCompositionEvent && isFallbackCompositionEnd(topLevelType, nativeEvent)) {
	      var chars = currentComposition.getData();
	      FallbackCompositionState.release(currentComposition);
	      currentComposition = null;
	      return chars;
	    }
	    return null;
	  }
	
	  switch (topLevelType) {
	    case 'topPaste':
	      // If a paste event occurs after a keypress, throw out the input
	      // chars. Paste events should not lead to BeforeInput events.
	      return null;
	    case 'topKeyPress':
	      /**
	       * As of v27, Firefox may fire keypress events even when no character
	       * will be inserted. A few possibilities:
	       *
	       * - `which` is `0`. Arrow keys, Esc key, etc.
	       *
	       * - `which` is the pressed key code, but no char is available.
	       *   Ex: 'AltGr + d` in Polish. There is no modified character for
	       *   this key combination and no character is inserted into the
	       *   document, but FF fires the keypress for char code `100` anyway.
	       *   No `input` event will occur.
	       *
	       * - `which` is the pressed key code, but a command combination is
	       *   being used. Ex: `Cmd+C`. No character is inserted, and no
	       *   `input` event will occur.
	       */
	      if (nativeEvent.which && !isKeypressCommand(nativeEvent)) {
	        return String.fromCharCode(nativeEvent.which);
	      }
	      return null;
	    case 'topCompositionEnd':
	      return useFallbackCompositionData ? null : nativeEvent.data;
	    default:
	      return null;
	  }
	}
	
	/**
	 * Extract a SyntheticInputEvent for `beforeInput`, based on either native
	 * `textInput` or fallback behavior.
	 *
	 * @return {?object} A SyntheticInputEvent.
	 */
	function extractBeforeInputEvent(topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	  var chars;
	
	  if (canUseTextInputEvent) {
	    chars = getNativeBeforeInputChars(topLevelType, nativeEvent);
	  } else {
	    chars = getFallbackBeforeInputChars(topLevelType, nativeEvent);
	  }
	
	  // If no characters are being inserted, no BeforeInput event should
	  // be fired.
	  if (!chars) {
	    return null;
	  }
	
	  var event = SyntheticInputEvent.getPooled(eventTypes.beforeInput, targetInst, nativeEvent, nativeEventTarget);
	
	  event.data = chars;
	  EventPropagators.accumulateTwoPhaseDispatches(event);
	  return event;
	}
	
	/**
	 * Create an `onBeforeInput` event to match
	 * http://www.w3.org/TR/2013/WD-DOM-Level-3-Events-20131105/#events-inputevents.
	 *
	 * This event plugin is based on the native `textInput` event
	 * available in Chrome, Safari, Opera, and IE. This event fires after
	 * `onKeyPress` and `onCompositionEnd`, but before `onInput`.
	 *
	 * `beforeInput` is spec'd but not implemented in any browsers, and
	 * the `input` event does not provide any useful information about what has
	 * actually been added, contrary to the spec. Thus, `textInput` is the best
	 * available event to identify the characters that have actually been inserted
	 * into the target node.
	 *
	 * This plugin is also responsible for emitting `composition` events, thus
	 * allowing us to share composition fallback code for both `beforeInput` and
	 * `composition` event types.
	 */
	var BeforeInputEventPlugin = {
	  eventTypes: eventTypes,
	
	  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	    return [extractCompositionEvent(topLevelType, targetInst, nativeEvent, nativeEventTarget), extractBeforeInputEvent(topLevelType, targetInst, nativeEvent, nativeEventTarget)];
	  }
	};
	
	module.exports = BeforeInputEventPlugin;

/***/ },
/* 969 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var CSSProperty = __webpack_require__(382);
	var ExecutionEnvironment = __webpack_require__(51);
	var ReactInstrumentation = __webpack_require__(62);
	
	var camelizeStyleName = __webpack_require__(822);
	var dangerousStyleValue = __webpack_require__(1017);
	var hyphenateStyleName = __webpack_require__(829);
	var memoizeStringOnly = __webpack_require__(832);
	var warning = __webpack_require__(30);
	
	var processStyleName = memoizeStringOnly(function (styleName) {
	  return hyphenateStyleName(styleName);
	});
	
	var hasShorthandPropertyBug = false;
	var styleFloatAccessor = 'cssFloat';
	if (ExecutionEnvironment.canUseDOM) {
	  var tempStyle = document.createElement('div').style;
	  try {
	    // IE8 throws "Invalid argument." if resetting shorthand style properties.
	    tempStyle.font = '';
	  } catch (e) {
	    hasShorthandPropertyBug = true;
	  }
	  // IE8 only supports accessing cssFloat (standard) as styleFloat
	  if (document.documentElement.style.cssFloat === undefined) {
	    styleFloatAccessor = 'styleFloat';
	  }
	}
	
	if (false) {
	  // 'msTransform' is correct, but the other prefixes should be capitalized
	  var badVendoredStyleNamePattern = /^(?:webkit|moz|o)[A-Z]/;
	
	  // style values shouldn't contain a semicolon
	  var badStyleValueWithSemicolonPattern = /;\s*$/;
	
	  var warnedStyleNames = {};
	  var warnedStyleValues = {};
	  var warnedForNaNValue = false;
	
	  var warnHyphenatedStyleName = function (name, owner) {
	    if (warnedStyleNames.hasOwnProperty(name) && warnedStyleNames[name]) {
	      return;
	    }
	
	    warnedStyleNames[name] = true;
	    process.env.NODE_ENV !== 'production' ? warning(false, 'Unsupported style property %s. Did you mean %s?%s', name, camelizeStyleName(name), checkRenderMessage(owner)) : void 0;
	  };
	
	  var warnBadVendoredStyleName = function (name, owner) {
	    if (warnedStyleNames.hasOwnProperty(name) && warnedStyleNames[name]) {
	      return;
	    }
	
	    warnedStyleNames[name] = true;
	    process.env.NODE_ENV !== 'production' ? warning(false, 'Unsupported vendor-prefixed style property %s. Did you mean %s?%s', name, name.charAt(0).toUpperCase() + name.slice(1), checkRenderMessage(owner)) : void 0;
	  };
	
	  var warnStyleValueWithSemicolon = function (name, value, owner) {
	    if (warnedStyleValues.hasOwnProperty(value) && warnedStyleValues[value]) {
	      return;
	    }
	
	    warnedStyleValues[value] = true;
	    process.env.NODE_ENV !== 'production' ? warning(false, "Style property values shouldn't contain a semicolon.%s " + 'Try "%s: %s" instead.', checkRenderMessage(owner), name, value.replace(badStyleValueWithSemicolonPattern, '')) : void 0;
	  };
	
	  var warnStyleValueIsNaN = function (name, value, owner) {
	    if (warnedForNaNValue) {
	      return;
	    }
	
	    warnedForNaNValue = true;
	    process.env.NODE_ENV !== 'production' ? warning(false, '`NaN` is an invalid value for the `%s` css style property.%s', name, checkRenderMessage(owner)) : void 0;
	  };
	
	  var checkRenderMessage = function (owner) {
	    if (owner) {
	      var name = owner.getName();
	      if (name) {
	        return ' Check the render method of `' + name + '`.';
	      }
	    }
	    return '';
	  };
	
	  /**
	   * @param {string} name
	   * @param {*} value
	   * @param {ReactDOMComponent} component
	   */
	  var warnValidStyle = function (name, value, component) {
	    var owner;
	    if (component) {
	      owner = component._currentElement._owner;
	    }
	    if (name.indexOf('-') > -1) {
	      warnHyphenatedStyleName(name, owner);
	    } else if (badVendoredStyleNamePattern.test(name)) {
	      warnBadVendoredStyleName(name, owner);
	    } else if (badStyleValueWithSemicolonPattern.test(value)) {
	      warnStyleValueWithSemicolon(name, value, owner);
	    }
	
	    if (typeof value === 'number' && isNaN(value)) {
	      warnStyleValueIsNaN(name, value, owner);
	    }
	  };
	}
	
	/**
	 * Operations for dealing with CSS properties.
	 */
	var CSSPropertyOperations = {
	  /**
	   * Serializes a mapping of style properties for use as inline styles:
	   *
	   *   > createMarkupForStyles({width: '200px', height: 0})
	   *   "width:200px;height:0;"
	   *
	   * Undefined values are ignored so that declarative programming is easier.
	   * The result should be HTML-escaped before insertion into the DOM.
	   *
	   * @param {object} styles
	   * @param {ReactDOMComponent} component
	   * @return {?string}
	   */
	  createMarkupForStyles: function (styles, component) {
	    var serialized = '';
	    for (var styleName in styles) {
	      if (!styles.hasOwnProperty(styleName)) {
	        continue;
	      }
	      var isCustomProperty = styleName.indexOf('--') === 0;
	      var styleValue = styles[styleName];
	      if (false) {
	        if (!isCustomProperty) {
	          warnValidStyle(styleName, styleValue, component);
	        }
	      }
	      if (styleValue != null) {
	        serialized += processStyleName(styleName) + ':';
	        serialized += dangerousStyleValue(styleName, styleValue, component, isCustomProperty) + ';';
	      }
	    }
	    return serialized || null;
	  },
	
	  /**
	   * Sets the value for multiple styles on a node.  If a value is specified as
	   * '' (empty string), the corresponding style property will be unset.
	   *
	   * @param {DOMElement} node
	   * @param {object} styles
	   * @param {ReactDOMComponent} component
	   */
	  setValueForStyles: function (node, styles, component) {
	    if (false) {
	      ReactInstrumentation.debugTool.onHostOperation({
	        instanceID: component._debugID,
	        type: 'update styles',
	        payload: styles
	      });
	    }
	
	    var style = node.style;
	    for (var styleName in styles) {
	      if (!styles.hasOwnProperty(styleName)) {
	        continue;
	      }
	      var isCustomProperty = styleName.indexOf('--') === 0;
	      if (false) {
	        if (!isCustomProperty) {
	          warnValidStyle(styleName, styles[styleName], component);
	        }
	      }
	      var styleValue = dangerousStyleValue(styleName, styles[styleName], component, isCustomProperty);
	      if (styleName === 'float' || styleName === 'cssFloat') {
	        styleName = styleFloatAccessor;
	      }
	      if (isCustomProperty) {
	        style.setProperty(styleName, styleValue);
	      } else if (styleValue) {
	        style[styleName] = styleValue;
	      } else {
	        var expansion = hasShorthandPropertyBug && CSSProperty.shorthandPropertyExpansions[styleName];
	        if (expansion) {
	          // Shorthand property that IE8 won't like unsetting, so unset each
	          // component to placate it
	          for (var individualStyleName in expansion) {
	            style[individualStyleName] = '';
	          }
	        } else {
	          style[styleName] = '';
	        }
	      }
	    }
	  }
	};
	
	module.exports = CSSPropertyOperations;

/***/ },
/* 970 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var EventPluginHub = __webpack_require__(144);
	var EventPropagators = __webpack_require__(145);
	var ExecutionEnvironment = __webpack_require__(51);
	var ReactDOMComponentTree = __webpack_require__(41);
	var ReactUpdates = __webpack_require__(74);
	var SyntheticEvent = __webpack_require__(91);
	
	var inputValueTracking = __webpack_require__(404);
	var getEventTarget = __webpack_require__(260);
	var isEventSupported = __webpack_require__(262);
	var isTextInputElement = __webpack_require__(405);
	
	var eventTypes = {
	  change: {
	    phasedRegistrationNames: {
	      bubbled: 'onChange',
	      captured: 'onChangeCapture'
	    },
	    dependencies: ['topBlur', 'topChange', 'topClick', 'topFocus', 'topInput', 'topKeyDown', 'topKeyUp', 'topSelectionChange']
	  }
	};
	
	function createAndAccumulateChangeEvent(inst, nativeEvent, target) {
	  var event = SyntheticEvent.getPooled(eventTypes.change, inst, nativeEvent, target);
	  event.type = 'change';
	  EventPropagators.accumulateTwoPhaseDispatches(event);
	  return event;
	}
	/**
	 * For IE shims
	 */
	var activeElement = null;
	var activeElementInst = null;
	
	/**
	 * SECTION: handle `change` event
	 */
	function shouldUseChangeEvent(elem) {
	  var nodeName = elem.nodeName && elem.nodeName.toLowerCase();
	  return nodeName === 'select' || nodeName === 'input' && elem.type === 'file';
	}
	
	var doesChangeEventBubble = false;
	if (ExecutionEnvironment.canUseDOM) {
	  // See `handleChange` comment below
	  doesChangeEventBubble = isEventSupported('change') && (!document.documentMode || document.documentMode > 8);
	}
	
	function manualDispatchChangeEvent(nativeEvent) {
	  var event = createAndAccumulateChangeEvent(activeElementInst, nativeEvent, getEventTarget(nativeEvent));
	
	  // If change and propertychange bubbled, we'd just bind to it like all the
	  // other events and have it go through ReactBrowserEventEmitter. Since it
	  // doesn't, we manually listen for the events and so we have to enqueue and
	  // process the abstract event manually.
	  //
	  // Batching is necessary here in order to ensure that all event handlers run
	  // before the next rerender (including event handlers attached to ancestor
	  // elements instead of directly on the input). Without this, controlled
	  // components don't work properly in conjunction with event bubbling because
	  // the component is rerendered and the value reverted before all the event
	  // handlers can run. See https://github.com/facebook/react/issues/708.
	  ReactUpdates.batchedUpdates(runEventInBatch, event);
	}
	
	function runEventInBatch(event) {
	  EventPluginHub.enqueueEvents(event);
	  EventPluginHub.processEventQueue(false);
	}
	
	function startWatchingForChangeEventIE8(target, targetInst) {
	  activeElement = target;
	  activeElementInst = targetInst;
	  activeElement.attachEvent('onchange', manualDispatchChangeEvent);
	}
	
	function stopWatchingForChangeEventIE8() {
	  if (!activeElement) {
	    return;
	  }
	  activeElement.detachEvent('onchange', manualDispatchChangeEvent);
	  activeElement = null;
	  activeElementInst = null;
	}
	
	function getInstIfValueChanged(targetInst, nativeEvent) {
	  var updated = inputValueTracking.updateValueIfChanged(targetInst);
	  var simulated = nativeEvent.simulated === true && ChangeEventPlugin._allowSimulatedPassThrough;
	
	  if (updated || simulated) {
	    return targetInst;
	  }
	}
	
	function getTargetInstForChangeEvent(topLevelType, targetInst) {
	  if (topLevelType === 'topChange') {
	    return targetInst;
	  }
	}
	
	function handleEventsForChangeEventIE8(topLevelType, target, targetInst) {
	  if (topLevelType === 'topFocus') {
	    // stopWatching() should be a noop here but we call it just in case we
	    // missed a blur event somehow.
	    stopWatchingForChangeEventIE8();
	    startWatchingForChangeEventIE8(target, targetInst);
	  } else if (topLevelType === 'topBlur') {
	    stopWatchingForChangeEventIE8();
	  }
	}
	
	/**
	 * SECTION: handle `input` event
	 */
	var isInputEventSupported = false;
	if (ExecutionEnvironment.canUseDOM) {
	  // IE9 claims to support the input event but fails to trigger it when
	  // deleting text, so we ignore its input events.
	
	  isInputEventSupported = isEventSupported('input') && (!document.documentMode || document.documentMode > 9);
	}
	
	/**
	 * (For IE <=9) Starts tracking propertychange events on the passed-in element
	 * and override the value property so that we can distinguish user events from
	 * value changes in JS.
	 */
	function startWatchingForValueChange(target, targetInst) {
	  activeElement = target;
	  activeElementInst = targetInst;
	  activeElement.attachEvent('onpropertychange', handlePropertyChange);
	}
	
	/**
	 * (For IE <=9) Removes the event listeners from the currently-tracked element,
	 * if any exists.
	 */
	function stopWatchingForValueChange() {
	  if (!activeElement) {
	    return;
	  }
	  activeElement.detachEvent('onpropertychange', handlePropertyChange);
	
	  activeElement = null;
	  activeElementInst = null;
	}
	
	/**
	 * (For IE <=9) Handles a propertychange event, sending a `change` event if
	 * the value of the active element has changed.
	 */
	function handlePropertyChange(nativeEvent) {
	  if (nativeEvent.propertyName !== 'value') {
	    return;
	  }
	  if (getInstIfValueChanged(activeElementInst, nativeEvent)) {
	    manualDispatchChangeEvent(nativeEvent);
	  }
	}
	
	function handleEventsForInputEventPolyfill(topLevelType, target, targetInst) {
	  if (topLevelType === 'topFocus') {
	    // In IE8, we can capture almost all .value changes by adding a
	    // propertychange handler and looking for events with propertyName
	    // equal to 'value'
	    // In IE9, propertychange fires for most input events but is buggy and
	    // doesn't fire when text is deleted, but conveniently, selectionchange
	    // appears to fire in all of the remaining cases so we catch those and
	    // forward the event if the value has changed
	    // In either case, we don't want to call the event handler if the value
	    // is changed from JS so we redefine a setter for `.value` that updates
	    // our activeElementValue variable, allowing us to ignore those changes
	    //
	    // stopWatching() should be a noop here but we call it just in case we
	    // missed a blur event somehow.
	    stopWatchingForValueChange();
	    startWatchingForValueChange(target, targetInst);
	  } else if (topLevelType === 'topBlur') {
	    stopWatchingForValueChange();
	  }
	}
	
	// For IE8 and IE9.
	function getTargetInstForInputEventPolyfill(topLevelType, targetInst, nativeEvent) {
	  if (topLevelType === 'topSelectionChange' || topLevelType === 'topKeyUp' || topLevelType === 'topKeyDown') {
	    // On the selectionchange event, the target is just document which isn't
	    // helpful for us so just check activeElement instead.
	    //
	    // 99% of the time, keydown and keyup aren't necessary. IE8 fails to fire
	    // propertychange on the first input event after setting `value` from a
	    // script and fires only keydown, keypress, keyup. Catching keyup usually
	    // gets it and catching keydown lets us fire an event for the first
	    // keystroke if user does a key repeat (it'll be a little delayed: right
	    // before the second keystroke). Other input methods (e.g., paste) seem to
	    // fire selectionchange normally.
	    return getInstIfValueChanged(activeElementInst, nativeEvent);
	  }
	}
	
	/**
	 * SECTION: handle `click` event
	 */
	function shouldUseClickEvent(elem) {
	  // Use the `click` event to detect changes to checkbox and radio inputs.
	  // This approach works across all browsers, whereas `change` does not fire
	  // until `blur` in IE8.
	  var nodeName = elem.nodeName;
	  return nodeName && nodeName.toLowerCase() === 'input' && (elem.type === 'checkbox' || elem.type === 'radio');
	}
	
	function getTargetInstForClickEvent(topLevelType, targetInst, nativeEvent) {
	  if (topLevelType === 'topClick') {
	    return getInstIfValueChanged(targetInst, nativeEvent);
	  }
	}
	
	function getTargetInstForInputOrChangeEvent(topLevelType, targetInst, nativeEvent) {
	  if (topLevelType === 'topInput' || topLevelType === 'topChange') {
	    return getInstIfValueChanged(targetInst, nativeEvent);
	  }
	}
	
	function handleControlledInputBlur(inst, node) {
	  // TODO: In IE, inst is occasionally null. Why?
	  if (inst == null) {
	    return;
	  }
	
	  // Fiber and ReactDOM keep wrapper state in separate places
	  var state = inst._wrapperState || node._wrapperState;
	
	  if (!state || !state.controlled || node.type !== 'number') {
	    return;
	  }
	
	  // If controlled, assign the value attribute to the current value on blur
	  var value = '' + node.value;
	  if (node.getAttribute('value') !== value) {
	    node.setAttribute('value', value);
	  }
	}
	
	/**
	 * This plugin creates an `onChange` event that normalizes change events
	 * across form elements. This event fires at a time when it's possible to
	 * change the element's value without seeing a flicker.
	 *
	 * Supported elements are:
	 * - input (see `isTextInputElement`)
	 * - textarea
	 * - select
	 */
	var ChangeEventPlugin = {
	  eventTypes: eventTypes,
	
	  _allowSimulatedPassThrough: true,
	  _isInputEventSupported: isInputEventSupported,
	
	  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	    var targetNode = targetInst ? ReactDOMComponentTree.getNodeFromInstance(targetInst) : window;
	
	    var getTargetInstFunc, handleEventFunc;
	    if (shouldUseChangeEvent(targetNode)) {
	      if (doesChangeEventBubble) {
	        getTargetInstFunc = getTargetInstForChangeEvent;
	      } else {
	        handleEventFunc = handleEventsForChangeEventIE8;
	      }
	    } else if (isTextInputElement(targetNode)) {
	      if (isInputEventSupported) {
	        getTargetInstFunc = getTargetInstForInputOrChangeEvent;
	      } else {
	        getTargetInstFunc = getTargetInstForInputEventPolyfill;
	        handleEventFunc = handleEventsForInputEventPolyfill;
	      }
	    } else if (shouldUseClickEvent(targetNode)) {
	      getTargetInstFunc = getTargetInstForClickEvent;
	    }
	
	    if (getTargetInstFunc) {
	      var inst = getTargetInstFunc(topLevelType, targetInst, nativeEvent);
	      if (inst) {
	        var event = createAndAccumulateChangeEvent(inst, nativeEvent, nativeEventTarget);
	        return event;
	      }
	    }
	
	    if (handleEventFunc) {
	      handleEventFunc(topLevelType, targetNode, targetInst);
	    }
	
	    // When blurring, set the value attribute for number inputs
	    if (topLevelType === 'topBlur') {
	      handleControlledInputBlur(targetInst, targetNode);
	    }
	  }
	};
	
	module.exports = ChangeEventPlugin;

/***/ },
/* 971 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(29);
	
	var DOMLazyTree = __webpack_require__(127);
	var ExecutionEnvironment = __webpack_require__(51);
	
	var createNodesFromMarkup = __webpack_require__(825);
	var emptyFunction = __webpack_require__(80);
	var invariant = __webpack_require__(21);
	
	var Danger = {
	  /**
	   * Replaces a node with a string of markup at its current position within its
	   * parent. The markup must render into a single root node.
	   *
	   * @param {DOMElement} oldChild Child node to replace.
	   * @param {string} markup Markup to render in place of the child node.
	   * @internal
	   */
	  dangerouslyReplaceNodeWithMarkup: function (oldChild, markup) {
	    !ExecutionEnvironment.canUseDOM ?  false ? invariant(false, 'dangerouslyReplaceNodeWithMarkup(...): Cannot render markup in a worker thread. Make sure `window` and `document` are available globally before requiring React when unit testing or use ReactDOMServer.renderToString() for server rendering.') : _prodInvariant('56') : void 0;
	    !markup ?  false ? invariant(false, 'dangerouslyReplaceNodeWithMarkup(...): Missing markup.') : _prodInvariant('57') : void 0;
	    !(oldChild.nodeName !== 'HTML') ?  false ? invariant(false, 'dangerouslyReplaceNodeWithMarkup(...): Cannot replace markup of the <html> node. This is because browser quirks make this unreliable and/or slow. If you want to render to the root you must use server rendering. See ReactDOMServer.renderToString().') : _prodInvariant('58') : void 0;
	
	    if (typeof markup === 'string') {
	      var newChild = createNodesFromMarkup(markup, emptyFunction)[0];
	      oldChild.parentNode.replaceChild(newChild, oldChild);
	    } else {
	      DOMLazyTree.replaceChildWithTree(oldChild, markup);
	    }
	  }
	};
	
	module.exports = Danger;

/***/ },
/* 972 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	/**
	 * Module that is injectable into `EventPluginHub`, that specifies a
	 * deterministic ordering of `EventPlugin`s. A convenient way to reason about
	 * plugins, without having to package every one of them. This is better than
	 * having plugins be ordered in the same order that they are injected because
	 * that ordering would be influenced by the packaging order.
	 * `ResponderEventPlugin` must occur before `SimpleEventPlugin` so that
	 * preventing default on events is convenient in `SimpleEventPlugin` handlers.
	 */
	
	var DefaultEventPluginOrder = ['ResponderEventPlugin', 'SimpleEventPlugin', 'TapEventPlugin', 'EnterLeaveEventPlugin', 'ChangeEventPlugin', 'SelectEventPlugin', 'BeforeInputEventPlugin'];
	
	module.exports = DefaultEventPluginOrder;

/***/ },
/* 973 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var EventPropagators = __webpack_require__(145);
	var ReactDOMComponentTree = __webpack_require__(41);
	var SyntheticMouseEvent = __webpack_require__(185);
	
	var eventTypes = {
	  mouseEnter: {
	    registrationName: 'onMouseEnter',
	    dependencies: ['topMouseOut', 'topMouseOver']
	  },
	  mouseLeave: {
	    registrationName: 'onMouseLeave',
	    dependencies: ['topMouseOut', 'topMouseOver']
	  }
	};
	
	var EnterLeaveEventPlugin = {
	  eventTypes: eventTypes,
	
	  /**
	   * For almost every interaction we care about, there will be both a top-level
	   * `mouseover` and `mouseout` event that occurs. Only use `mouseout` so that
	   * we do not extract duplicate events. However, moving the mouse into the
	   * browser from outside will not fire a `mouseout` event. In this case, we use
	   * the `mouseover` top-level event.
	   */
	  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	    if (topLevelType === 'topMouseOver' && (nativeEvent.relatedTarget || nativeEvent.fromElement)) {
	      return null;
	    }
	    if (topLevelType !== 'topMouseOut' && topLevelType !== 'topMouseOver') {
	      // Must not be a mouse in or mouse out - ignoring.
	      return null;
	    }
	
	    var win;
	    if (nativeEventTarget.window === nativeEventTarget) {
	      // `nativeEventTarget` is probably a window object.
	      win = nativeEventTarget;
	    } else {
	      // TODO: Figure out why `ownerDocument` is sometimes undefined in IE8.
	      var doc = nativeEventTarget.ownerDocument;
	      if (doc) {
	        win = doc.defaultView || doc.parentWindow;
	      } else {
	        win = window;
	      }
	    }
	
	    var from;
	    var to;
	    if (topLevelType === 'topMouseOut') {
	      from = targetInst;
	      var related = nativeEvent.relatedTarget || nativeEvent.toElement;
	      to = related ? ReactDOMComponentTree.getClosestInstanceFromNode(related) : null;
	    } else {
	      // Moving to a node from outside the window.
	      from = null;
	      to = targetInst;
	    }
	
	    if (from === to) {
	      // Nothing pertains to our managed components.
	      return null;
	    }
	
	    var fromNode = from == null ? win : ReactDOMComponentTree.getNodeFromInstance(from);
	    var toNode = to == null ? win : ReactDOMComponentTree.getNodeFromInstance(to);
	
	    var leave = SyntheticMouseEvent.getPooled(eventTypes.mouseLeave, from, nativeEvent, nativeEventTarget);
	    leave.type = 'mouseleave';
	    leave.target = fromNode;
	    leave.relatedTarget = toNode;
	
	    var enter = SyntheticMouseEvent.getPooled(eventTypes.mouseEnter, to, nativeEvent, nativeEventTarget);
	    enter.type = 'mouseenter';
	    enter.target = toNode;
	    enter.relatedTarget = fromNode;
	
	    EventPropagators.accumulateEnterLeaveDispatches(leave, enter, from, to);
	
	    return [leave, enter];
	  }
	};
	
	module.exports = EnterLeaveEventPlugin;

/***/ },
/* 974 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(36);
	
	var PooledClass = __webpack_require__(113);
	
	var getTextContentAccessor = __webpack_require__(403);
	
	/**
	 * This helper class stores information about text content of a target node,
	 * allowing comparison of content before and after a given event.
	 *
	 * Identify the node where selection currently begins, then observe
	 * both its text content and its current position in the DOM. Since the
	 * browser may natively replace the target node during composition, we can
	 * use its position to find its replacement.
	 *
	 * @param {DOMEventTarget} root
	 */
	function FallbackCompositionState(root) {
	  this._root = root;
	  this._startText = this.getText();
	  this._fallbackText = null;
	}
	
	_assign(FallbackCompositionState.prototype, {
	  destructor: function () {
	    this._root = null;
	    this._startText = null;
	    this._fallbackText = null;
	  },
	
	  /**
	   * Get current text of input.
	   *
	   * @return {string}
	   */
	  getText: function () {
	    if ('value' in this._root) {
	      return this._root.value;
	    }
	    return this._root[getTextContentAccessor()];
	  },
	
	  /**
	   * Determine the differing substring between the initially stored
	   * text content and the current content.
	   *
	   * @return {string}
	   */
	  getData: function () {
	    if (this._fallbackText) {
	      return this._fallbackText;
	    }
	
	    var start;
	    var startValue = this._startText;
	    var startLength = startValue.length;
	    var end;
	    var endValue = this.getText();
	    var endLength = endValue.length;
	
	    for (start = 0; start < startLength; start++) {
	      if (startValue[start] !== endValue[start]) {
	        break;
	      }
	    }
	
	    var minEnd = startLength - start;
	    for (end = 1; end <= minEnd; end++) {
	      if (startValue[startLength - end] !== endValue[endLength - end]) {
	        break;
	      }
	    }
	
	    var sliceTail = end > 1 ? 1 - end : undefined;
	    this._fallbackText = endValue.slice(start, sliceTail);
	    return this._fallbackText;
	  }
	});
	
	PooledClass.addPoolingTo(FallbackCompositionState);
	
	module.exports = FallbackCompositionState;

/***/ },
/* 975 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var DOMProperty = __webpack_require__(128);
	
	var MUST_USE_PROPERTY = DOMProperty.injection.MUST_USE_PROPERTY;
	var HAS_BOOLEAN_VALUE = DOMProperty.injection.HAS_BOOLEAN_VALUE;
	var HAS_NUMERIC_VALUE = DOMProperty.injection.HAS_NUMERIC_VALUE;
	var HAS_POSITIVE_NUMERIC_VALUE = DOMProperty.injection.HAS_POSITIVE_NUMERIC_VALUE;
	var HAS_OVERLOADED_BOOLEAN_VALUE = DOMProperty.injection.HAS_OVERLOADED_BOOLEAN_VALUE;
	
	var HTMLDOMPropertyConfig = {
	  isCustomAttribute: RegExp.prototype.test.bind(new RegExp('^(data|aria)-[' + DOMProperty.ATTRIBUTE_NAME_CHAR + ']*$')),
	  Properties: {
	    /**
	     * Standard Properties
	     */
	    accept: 0,
	    acceptCharset: 0,
	    accessKey: 0,
	    action: 0,
	    allowFullScreen: HAS_BOOLEAN_VALUE,
	    allowTransparency: 0,
	    alt: 0,
	    // specifies target context for links with `preload` type
	    as: 0,
	    async: HAS_BOOLEAN_VALUE,
	    autoComplete: 0,
	    // autoFocus is polyfilled/normalized by AutoFocusUtils
	    // autoFocus: HAS_BOOLEAN_VALUE,
	    autoPlay: HAS_BOOLEAN_VALUE,
	    capture: HAS_BOOLEAN_VALUE,
	    cellPadding: 0,
	    cellSpacing: 0,
	    charSet: 0,
	    challenge: 0,
	    checked: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
	    cite: 0,
	    classID: 0,
	    className: 0,
	    cols: HAS_POSITIVE_NUMERIC_VALUE,
	    colSpan: 0,
	    content: 0,
	    contentEditable: 0,
	    contextMenu: 0,
	    controls: HAS_BOOLEAN_VALUE,
	    controlsList: 0,
	    coords: 0,
	    crossOrigin: 0,
	    data: 0, // For `<object />` acts as `src`.
	    dateTime: 0,
	    'default': HAS_BOOLEAN_VALUE,
	    defer: HAS_BOOLEAN_VALUE,
	    dir: 0,
	    disabled: HAS_BOOLEAN_VALUE,
	    download: HAS_OVERLOADED_BOOLEAN_VALUE,
	    draggable: 0,
	    encType: 0,
	    form: 0,
	    formAction: 0,
	    formEncType: 0,
	    formMethod: 0,
	    formNoValidate: HAS_BOOLEAN_VALUE,
	    formTarget: 0,
	    frameBorder: 0,
	    headers: 0,
	    height: 0,
	    hidden: HAS_BOOLEAN_VALUE,
	    high: 0,
	    href: 0,
	    hrefLang: 0,
	    htmlFor: 0,
	    httpEquiv: 0,
	    icon: 0,
	    id: 0,
	    inputMode: 0,
	    integrity: 0,
	    is: 0,
	    keyParams: 0,
	    keyType: 0,
	    kind: 0,
	    label: 0,
	    lang: 0,
	    list: 0,
	    loop: HAS_BOOLEAN_VALUE,
	    low: 0,
	    manifest: 0,
	    marginHeight: 0,
	    marginWidth: 0,
	    max: 0,
	    maxLength: 0,
	    media: 0,
	    mediaGroup: 0,
	    method: 0,
	    min: 0,
	    minLength: 0,
	    // Caution; `option.selected` is not updated if `select.multiple` is
	    // disabled with `removeAttribute`.
	    multiple: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
	    muted: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
	    name: 0,
	    nonce: 0,
	    noValidate: HAS_BOOLEAN_VALUE,
	    open: HAS_BOOLEAN_VALUE,
	    optimum: 0,
	    pattern: 0,
	    placeholder: 0,
	    playsInline: HAS_BOOLEAN_VALUE,
	    poster: 0,
	    preload: 0,
	    profile: 0,
	    radioGroup: 0,
	    readOnly: HAS_BOOLEAN_VALUE,
	    referrerPolicy: 0,
	    rel: 0,
	    required: HAS_BOOLEAN_VALUE,
	    reversed: HAS_BOOLEAN_VALUE,
	    role: 0,
	    rows: HAS_POSITIVE_NUMERIC_VALUE,
	    rowSpan: HAS_NUMERIC_VALUE,
	    sandbox: 0,
	    scope: 0,
	    scoped: HAS_BOOLEAN_VALUE,
	    scrolling: 0,
	    seamless: HAS_BOOLEAN_VALUE,
	    selected: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
	    shape: 0,
	    size: HAS_POSITIVE_NUMERIC_VALUE,
	    sizes: 0,
	    span: HAS_POSITIVE_NUMERIC_VALUE,
	    spellCheck: 0,
	    src: 0,
	    srcDoc: 0,
	    srcLang: 0,
	    srcSet: 0,
	    start: HAS_NUMERIC_VALUE,
	    step: 0,
	    style: 0,
	    summary: 0,
	    tabIndex: 0,
	    target: 0,
	    title: 0,
	    // Setting .type throws on non-<input> tags
	    type: 0,
	    useMap: 0,
	    value: 0,
	    width: 0,
	    wmode: 0,
	    wrap: 0,
	
	    /**
	     * RDFa Properties
	     */
	    about: 0,
	    datatype: 0,
	    inlist: 0,
	    prefix: 0,
	    // property is also supported for OpenGraph in meta tags.
	    property: 0,
	    resource: 0,
	    'typeof': 0,
	    vocab: 0,
	
	    /**
	     * Non-standard Properties
	     */
	    // autoCapitalize and autoCorrect are supported in Mobile Safari for
	    // keyboard hints.
	    autoCapitalize: 0,
	    autoCorrect: 0,
	    // autoSave allows WebKit/Blink to persist values of input fields on page reloads
	    autoSave: 0,
	    // color is for Safari mask-icon link
	    color: 0,
	    // itemProp, itemScope, itemType are for
	    // Microdata support. See http://schema.org/docs/gs.html
	    itemProp: 0,
	    itemScope: HAS_BOOLEAN_VALUE,
	    itemType: 0,
	    // itemID and itemRef are for Microdata support as well but
	    // only specified in the WHATWG spec document. See
	    // https://html.spec.whatwg.org/multipage/microdata.html#microdata-dom-api
	    itemID: 0,
	    itemRef: 0,
	    // results show looking glass icon and recent searches on input
	    // search fields in WebKit/Blink
	    results: 0,
	    // IE-only attribute that specifies security restrictions on an iframe
	    // as an alternative to the sandbox attribute on IE<10
	    security: 0,
	    // IE-only attribute that controls focus behavior
	    unselectable: 0
	  },
	  DOMAttributeNames: {
	    acceptCharset: 'accept-charset',
	    className: 'class',
	    htmlFor: 'for',
	    httpEquiv: 'http-equiv'
	  },
	  DOMPropertyNames: {},
	  DOMMutationMethods: {
	    value: function (node, value) {
	      if (value == null) {
	        return node.removeAttribute('value');
	      }
	
	      // Number inputs get special treatment due to some edge cases in
	      // Chrome. Let everything else assign the value attribute as normal.
	      // https://github.com/facebook/react/issues/7253#issuecomment-236074326
	      if (node.type !== 'number' || node.hasAttribute('value') === false) {
	        node.setAttribute('value', '' + value);
	      } else if (node.validity && !node.validity.badInput && node.ownerDocument.activeElement !== node) {
	        // Don't assign an attribute if validation reports bad
	        // input. Chrome will clear the value. Additionally, don't
	        // operate on inputs that have focus, otherwise Chrome might
	        // strip off trailing decimal places and cause the user's
	        // cursor position to jump to the beginning of the input.
	        //
	        // In ReactDOMInput, we have an onBlur event that will trigger
	        // this function again when focus is lost.
	        node.setAttribute('value', '' + value);
	      }
	    }
	  }
	};
	
	module.exports = HTMLDOMPropertyConfig;

/***/ },
/* 976 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {/**
	 * Copyright (c) 2014-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ReactReconciler = __webpack_require__(114);
	
	var instantiateReactComponent = __webpack_require__(261);
	var KeyEscapeUtils = __webpack_require__(252);
	var shouldUpdateReactComponent = __webpack_require__(263);
	var traverseAllChildren = __webpack_require__(407);
	var warning = __webpack_require__(30);
	
	var ReactComponentTreeHook;
	
	if (typeof process !== 'undefined' && process.env && ("production") === 'test') {
	  // Temporary hack.
	  // Inline requires don't work well with Jest:
	  // https://github.com/facebook/react/issues/7240
	  // Remove the inline requires when we don't need them anymore:
	  // https://github.com/facebook/react/pull/7178
	  ReactComponentTreeHook = __webpack_require__(427);
	}
	
	function instantiateChild(childInstances, child, name, selfDebugID) {
	  // We found a component instance.
	  var keyUnique = childInstances[name] === undefined;
	  if (false) {
	    if (!ReactComponentTreeHook) {
	      ReactComponentTreeHook = require('react/lib/ReactComponentTreeHook');
	    }
	    if (!keyUnique) {
	      process.env.NODE_ENV !== 'production' ? warning(false, 'flattenChildren(...): Encountered two children with the same key, ' + '`%s`. Child keys must be unique; when two children share a key, only ' + 'the first child will be used.%s', KeyEscapeUtils.unescape(name), ReactComponentTreeHook.getStackAddendumByID(selfDebugID)) : void 0;
	    }
	  }
	  if (child != null && keyUnique) {
	    childInstances[name] = instantiateReactComponent(child, true);
	  }
	}
	
	/**
	 * ReactChildReconciler provides helpers for initializing or updating a set of
	 * children. Its output is suitable for passing it onto ReactMultiChild which
	 * does diffed reordering and insertion.
	 */
	var ReactChildReconciler = {
	  /**
	   * Generates a "mount image" for each of the supplied children. In the case
	   * of `ReactDOMComponent`, a mount image is a string of markup.
	   *
	   * @param {?object} nestedChildNodes Nested child maps.
	   * @return {?object} A set of child instances.
	   * @internal
	   */
	  instantiateChildren: function (nestedChildNodes, transaction, context, selfDebugID) // 0 in production and for roots
	  {
	    if (nestedChildNodes == null) {
	      return null;
	    }
	    var childInstances = {};
	
	    if (false) {
	      traverseAllChildren(nestedChildNodes, function (childInsts, child, name) {
	        return instantiateChild(childInsts, child, name, selfDebugID);
	      }, childInstances);
	    } else {
	      traverseAllChildren(nestedChildNodes, instantiateChild, childInstances);
	    }
	    return childInstances;
	  },
	
	  /**
	   * Updates the rendered children and returns a new set of children.
	   *
	   * @param {?object} prevChildren Previously initialized set of children.
	   * @param {?object} nextChildren Flat child element maps.
	   * @param {ReactReconcileTransaction} transaction
	   * @param {object} context
	   * @return {?object} A new set of child instances.
	   * @internal
	   */
	  updateChildren: function (prevChildren, nextChildren, mountImages, removedNodes, transaction, hostParent, hostContainerInfo, context, selfDebugID) // 0 in production and for roots
	  {
	    // We currently don't have a way to track moves here but if we use iterators
	    // instead of for..in we can zip the iterators and check if an item has
	    // moved.
	    // TODO: If nothing has changed, return the prevChildren object so that we
	    // can quickly bailout if nothing has changed.
	    if (!nextChildren && !prevChildren) {
	      return;
	    }
	    var name;
	    var prevChild;
	    for (name in nextChildren) {
	      if (!nextChildren.hasOwnProperty(name)) {
	        continue;
	      }
	      prevChild = prevChildren && prevChildren[name];
	      var prevElement = prevChild && prevChild._currentElement;
	      var nextElement = nextChildren[name];
	      if (prevChild != null && shouldUpdateReactComponent(prevElement, nextElement)) {
	        ReactReconciler.receiveComponent(prevChild, nextElement, transaction, context);
	        nextChildren[name] = prevChild;
	      } else {
	        if (prevChild) {
	          removedNodes[name] = ReactReconciler.getHostNode(prevChild);
	          ReactReconciler.unmountComponent(prevChild, false);
	        }
	        // The child must be instantiated before it's mounted.
	        var nextChildInstance = instantiateReactComponent(nextElement, true);
	        nextChildren[name] = nextChildInstance;
	        // Creating mount image now ensures refs are resolved in right order
	        // (see https://github.com/facebook/react/pull/7101 for explanation).
	        var nextChildMountImage = ReactReconciler.mountComponent(nextChildInstance, transaction, hostParent, hostContainerInfo, context, selfDebugID);
	        mountImages.push(nextChildMountImage);
	      }
	    }
	    // Unmount children that are no longer present.
	    for (name in prevChildren) {
	      if (prevChildren.hasOwnProperty(name) && !(nextChildren && nextChildren.hasOwnProperty(name))) {
	        prevChild = prevChildren[name];
	        removedNodes[name] = ReactReconciler.getHostNode(prevChild);
	        ReactReconciler.unmountComponent(prevChild, false);
	      }
	    }
	  },
	
	  /**
	   * Unmounts all rendered children. This should be used to clean up children
	   * when this component is unmounted.
	   *
	   * @param {?object} renderedChildren Previously initialized set of children.
	   * @internal
	   */
	  unmountChildren: function (renderedChildren, safely) {
	    for (var name in renderedChildren) {
	      if (renderedChildren.hasOwnProperty(name)) {
	        var renderedChild = renderedChildren[name];
	        ReactReconciler.unmountComponent(renderedChild, safely);
	      }
	    }
	  }
	};
	
	module.exports = ReactChildReconciler;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(377)))

/***/ },
/* 977 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var DOMChildrenOperations = __webpack_require__(248);
	var ReactDOMIDOperations = __webpack_require__(983);
	
	/**
	 * Abstracts away all functionality of the reconciler that requires knowledge of
	 * the browser context. TODO: These callers should be refactored to avoid the
	 * need for this injection.
	 */
	var ReactComponentBrowserEnvironment = {
	  processChildrenUpdates: ReactDOMIDOperations.dangerouslyProcessChildrenUpdates,
	
	  replaceNodeWithMarkup: DOMChildrenOperations.dangerouslyReplaceNodeWithMarkup
	};
	
	module.exports = ReactComponentBrowserEnvironment;

/***/ },
/* 978 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(29),
	    _assign = __webpack_require__(36);
	
	var React = __webpack_require__(115);
	var ReactComponentEnvironment = __webpack_require__(254);
	var ReactCurrentOwner = __webpack_require__(92);
	var ReactErrorUtils = __webpack_require__(255);
	var ReactInstanceMap = __webpack_require__(146);
	var ReactInstrumentation = __webpack_require__(62);
	var ReactNodeTypes = __webpack_require__(396);
	var ReactReconciler = __webpack_require__(114);
	
	if (false) {
	  var checkReactTypeSpec = require('./checkReactTypeSpec');
	}
	
	var emptyObject = __webpack_require__(141);
	var invariant = __webpack_require__(21);
	var shallowEqual = __webpack_require__(233);
	var shouldUpdateReactComponent = __webpack_require__(263);
	var warning = __webpack_require__(30);
	
	var CompositeTypes = {
	  ImpureClass: 0,
	  PureClass: 1,
	  StatelessFunctional: 2
	};
	
	function StatelessComponent(Component) {}
	StatelessComponent.prototype.render = function () {
	  var Component = ReactInstanceMap.get(this)._currentElement.type;
	  var element = Component(this.props, this.context, this.updater);
	  warnIfInvalidElement(Component, element);
	  return element;
	};
	
	function warnIfInvalidElement(Component, element) {
	  if (false) {
	    process.env.NODE_ENV !== 'production' ? warning(element === null || element === false || React.isValidElement(element), '%s(...): A valid React element (or null) must be returned. You may have ' + 'returned undefined, an array or some other invalid object.', Component.displayName || Component.name || 'Component') : void 0;
	    process.env.NODE_ENV !== 'production' ? warning(!Component.childContextTypes, '%s(...): childContextTypes cannot be defined on a functional component.', Component.displayName || Component.name || 'Component') : void 0;
	  }
	}
	
	function shouldConstruct(Component) {
	  return !!(Component.prototype && Component.prototype.isReactComponent);
	}
	
	function isPureComponent(Component) {
	  return !!(Component.prototype && Component.prototype.isPureReactComponent);
	}
	
	// Separated into a function to contain deoptimizations caused by try/finally.
	function measureLifeCyclePerf(fn, debugID, timerType) {
	  if (debugID === 0) {
	    // Top-level wrappers (see ReactMount) and empty components (see
	    // ReactDOMEmptyComponent) are invisible to hooks and devtools.
	    // Both are implementation details that should go away in the future.
	    return fn();
	  }
	
	  ReactInstrumentation.debugTool.onBeginLifeCycleTimer(debugID, timerType);
	  try {
	    return fn();
	  } finally {
	    ReactInstrumentation.debugTool.onEndLifeCycleTimer(debugID, timerType);
	  }
	}
	
	/**
	 * ------------------ The Life-Cycle of a Composite Component ------------------
	 *
	 * - constructor: Initialization of state. The instance is now retained.
	 *   - componentWillMount
	 *   - render
	 *   - [children's constructors]
	 *     - [children's componentWillMount and render]
	 *     - [children's componentDidMount]
	 *     - componentDidMount
	 *
	 *       Update Phases:
	 *       - componentWillReceiveProps (only called if parent updated)
	 *       - shouldComponentUpdate
	 *         - componentWillUpdate
	 *           - render
	 *           - [children's constructors or receive props phases]
	 *         - componentDidUpdate
	 *
	 *     - componentWillUnmount
	 *     - [children's componentWillUnmount]
	 *   - [children destroyed]
	 * - (destroyed): The instance is now blank, released by React and ready for GC.
	 *
	 * -----------------------------------------------------------------------------
	 */
	
	/**
	 * An incrementing ID assigned to each component when it is mounted. This is
	 * used to enforce the order in which `ReactUpdates` updates dirty components.
	 *
	 * @private
	 */
	var nextMountID = 1;
	
	/**
	 * @lends {ReactCompositeComponent.prototype}
	 */
	var ReactCompositeComponent = {
	  /**
	   * Base constructor for all composite component.
	   *
	   * @param {ReactElement} element
	   * @final
	   * @internal
	   */
	  construct: function (element) {
	    this._currentElement = element;
	    this._rootNodeID = 0;
	    this._compositeType = null;
	    this._instance = null;
	    this._hostParent = null;
	    this._hostContainerInfo = null;
	
	    // See ReactUpdateQueue
	    this._updateBatchNumber = null;
	    this._pendingElement = null;
	    this._pendingStateQueue = null;
	    this._pendingReplaceState = false;
	    this._pendingForceUpdate = false;
	
	    this._renderedNodeType = null;
	    this._renderedComponent = null;
	    this._context = null;
	    this._mountOrder = 0;
	    this._topLevelWrapper = null;
	
	    // See ReactUpdates and ReactUpdateQueue.
	    this._pendingCallbacks = null;
	
	    // ComponentWillUnmount shall only be called once
	    this._calledComponentWillUnmount = false;
	
	    if (false) {
	      this._warnedAboutRefsInRender = false;
	    }
	  },
	
	  /**
	   * Initializes the component, renders markup, and registers event listeners.
	   *
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @param {?object} hostParent
	   * @param {?object} hostContainerInfo
	   * @param {?object} context
	   * @return {?string} Rendered markup to be inserted into the DOM.
	   * @final
	   * @internal
	   */
	  mountComponent: function (transaction, hostParent, hostContainerInfo, context) {
	    var _this = this;
	
	    this._context = context;
	    this._mountOrder = nextMountID++;
	    this._hostParent = hostParent;
	    this._hostContainerInfo = hostContainerInfo;
	
	    var publicProps = this._currentElement.props;
	    var publicContext = this._processContext(context);
	
	    var Component = this._currentElement.type;
	
	    var updateQueue = transaction.getUpdateQueue();
	
	    // Initialize the public class
	    var doConstruct = shouldConstruct(Component);
	    var inst = this._constructComponent(doConstruct, publicProps, publicContext, updateQueue);
	    var renderedElement;
	
	    // Support functional components
	    if (!doConstruct && (inst == null || inst.render == null)) {
	      renderedElement = inst;
	      warnIfInvalidElement(Component, renderedElement);
	      !(inst === null || inst === false || React.isValidElement(inst)) ?  false ? invariant(false, '%s(...): A valid React element (or null) must be returned. You may have returned undefined, an array or some other invalid object.', Component.displayName || Component.name || 'Component') : _prodInvariant('105', Component.displayName || Component.name || 'Component') : void 0;
	      inst = new StatelessComponent(Component);
	      this._compositeType = CompositeTypes.StatelessFunctional;
	    } else {
	      if (isPureComponent(Component)) {
	        this._compositeType = CompositeTypes.PureClass;
	      } else {
	        this._compositeType = CompositeTypes.ImpureClass;
	      }
	    }
	
	    if (false) {
	      // This will throw later in _renderValidatedComponent, but add an early
	      // warning now to help debugging
	      if (inst.render == null) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '%s(...): No `render` method found on the returned component ' + 'instance: you may have forgotten to define `render`.', Component.displayName || Component.name || 'Component') : void 0;
	      }
	
	      var propsMutated = inst.props !== publicProps;
	      var componentName = Component.displayName || Component.name || 'Component';
	
	      process.env.NODE_ENV !== 'production' ? warning(inst.props === undefined || !propsMutated, '%s(...): When calling super() in `%s`, make sure to pass ' + "up the same props that your component's constructor was passed.", componentName, componentName) : void 0;
	    }
	
	    // These should be set up in the constructor, but as a convenience for
	    // simpler class abstractions, we set them up after the fact.
	    inst.props = publicProps;
	    inst.context = publicContext;
	    inst.refs = emptyObject;
	    inst.updater = updateQueue;
	
	    this._instance = inst;
	
	    // Store a reference from the instance back to the internal representation
	    ReactInstanceMap.set(inst, this);
	
	    if (false) {
	      // Since plain JS classes are defined without any special initialization
	      // logic, we can not catch common errors early. Therefore, we have to
	      // catch them here, at initialization time, instead.
	      process.env.NODE_ENV !== 'production' ? warning(!inst.getInitialState || inst.getInitialState.isReactClassApproved || inst.state, 'getInitialState was defined on %s, a plain JavaScript class. ' + 'This is only supported for classes created using React.createClass. ' + 'Did you mean to define a state property instead?', this.getName() || 'a component') : void 0;
	      process.env.NODE_ENV !== 'production' ? warning(!inst.getDefaultProps || inst.getDefaultProps.isReactClassApproved, 'getDefaultProps was defined on %s, a plain JavaScript class. ' + 'This is only supported for classes created using React.createClass. ' + 'Use a static property to define defaultProps instead.', this.getName() || 'a component') : void 0;
	      process.env.NODE_ENV !== 'production' ? warning(!inst.propTypes, 'propTypes was defined as an instance property on %s. Use a static ' + 'property to define propTypes instead.', this.getName() || 'a component') : void 0;
	      process.env.NODE_ENV !== 'production' ? warning(!inst.contextTypes, 'contextTypes was defined as an instance property on %s. Use a ' + 'static property to define contextTypes instead.', this.getName() || 'a component') : void 0;
	      process.env.NODE_ENV !== 'production' ? warning(typeof inst.componentShouldUpdate !== 'function', '%s has a method called ' + 'componentShouldUpdate(). Did you mean shouldComponentUpdate()? ' + 'The name is phrased as a question because the function is ' + 'expected to return a value.', this.getName() || 'A component') : void 0;
	      process.env.NODE_ENV !== 'production' ? warning(typeof inst.componentDidUnmount !== 'function', '%s has a method called ' + 'componentDidUnmount(). But there is no such lifecycle method. ' + 'Did you mean componentWillUnmount()?', this.getName() || 'A component') : void 0;
	      process.env.NODE_ENV !== 'production' ? warning(typeof inst.componentWillRecieveProps !== 'function', '%s has a method called ' + 'componentWillRecieveProps(). Did you mean componentWillReceiveProps()?', this.getName() || 'A component') : void 0;
	    }
	
	    var initialState = inst.state;
	    if (initialState === undefined) {
	      inst.state = initialState = null;
	    }
	    !(typeof initialState === 'object' && !Array.isArray(initialState)) ?  false ? invariant(false, '%s.state: must be set to an object or null', this.getName() || 'ReactCompositeComponent') : _prodInvariant('106', this.getName() || 'ReactCompositeComponent') : void 0;
	
	    this._pendingStateQueue = null;
	    this._pendingReplaceState = false;
	    this._pendingForceUpdate = false;
	
	    var markup;
	    if (inst.unstable_handleError) {
	      markup = this.performInitialMountWithErrorHandling(renderedElement, hostParent, hostContainerInfo, transaction, context);
	    } else {
	      markup = this.performInitialMount(renderedElement, hostParent, hostContainerInfo, transaction, context);
	    }
	
	    if (inst.componentDidMount) {
	      if (false) {
	        transaction.getReactMountReady().enqueue(function () {
	          measureLifeCyclePerf(function () {
	            return inst.componentDidMount();
	          }, _this._debugID, 'componentDidMount');
	        });
	      } else {
	        transaction.getReactMountReady().enqueue(inst.componentDidMount, inst);
	      }
	    }
	
	    return markup;
	  },
	
	  _constructComponent: function (doConstruct, publicProps, publicContext, updateQueue) {
	    if (false) {
	      ReactCurrentOwner.current = this;
	      try {
	        return this._constructComponentWithoutOwner(doConstruct, publicProps, publicContext, updateQueue);
	      } finally {
	        ReactCurrentOwner.current = null;
	      }
	    } else {
	      return this._constructComponentWithoutOwner(doConstruct, publicProps, publicContext, updateQueue);
	    }
	  },
	
	  _constructComponentWithoutOwner: function (doConstruct, publicProps, publicContext, updateQueue) {
	    var Component = this._currentElement.type;
	
	    if (doConstruct) {
	      if (false) {
	        return measureLifeCyclePerf(function () {
	          return new Component(publicProps, publicContext, updateQueue);
	        }, this._debugID, 'ctor');
	      } else {
	        return new Component(publicProps, publicContext, updateQueue);
	      }
	    }
	
	    // This can still be an instance in case of factory components
	    // but we'll count this as time spent rendering as the more common case.
	    if (false) {
	      return measureLifeCyclePerf(function () {
	        return Component(publicProps, publicContext, updateQueue);
	      }, this._debugID, 'render');
	    } else {
	      return Component(publicProps, publicContext, updateQueue);
	    }
	  },
	
	  performInitialMountWithErrorHandling: function (renderedElement, hostParent, hostContainerInfo, transaction, context) {
	    var markup;
	    var checkpoint = transaction.checkpoint();
	    try {
	      markup = this.performInitialMount(renderedElement, hostParent, hostContainerInfo, transaction, context);
	    } catch (e) {
	      // Roll back to checkpoint, handle error (which may add items to the transaction), and take a new checkpoint
	      transaction.rollback(checkpoint);
	      this._instance.unstable_handleError(e);
	      if (this._pendingStateQueue) {
	        this._instance.state = this._processPendingState(this._instance.props, this._instance.context);
	      }
	      checkpoint = transaction.checkpoint();
	
	      this._renderedComponent.unmountComponent(true);
	      transaction.rollback(checkpoint);
	
	      // Try again - we've informed the component about the error, so they can render an error message this time.
	      // If this throws again, the error will bubble up (and can be caught by a higher error boundary).
	      markup = this.performInitialMount(renderedElement, hostParent, hostContainerInfo, transaction, context);
	    }
	    return markup;
	  },
	
	  performInitialMount: function (renderedElement, hostParent, hostContainerInfo, transaction, context) {
	    var inst = this._instance;
	
	    var debugID = 0;
	    if (false) {
	      debugID = this._debugID;
	    }
	
	    if (inst.componentWillMount) {
	      if (false) {
	        measureLifeCyclePerf(function () {
	          return inst.componentWillMount();
	        }, debugID, 'componentWillMount');
	      } else {
	        inst.componentWillMount();
	      }
	      // When mounting, calls to `setState` by `componentWillMount` will set
	      // `this._pendingStateQueue` without triggering a re-render.
	      if (this._pendingStateQueue) {
	        inst.state = this._processPendingState(inst.props, inst.context);
	      }
	    }
	
	    // If not a stateless component, we now render
	    if (renderedElement === undefined) {
	      renderedElement = this._renderValidatedComponent();
	    }
	
	    var nodeType = ReactNodeTypes.getType(renderedElement);
	    this._renderedNodeType = nodeType;
	    var child = this._instantiateReactComponent(renderedElement, nodeType !== ReactNodeTypes.EMPTY /* shouldHaveDebugID */
	    );
	    this._renderedComponent = child;
	
	    var markup = ReactReconciler.mountComponent(child, transaction, hostParent, hostContainerInfo, this._processChildContext(context), debugID);
	
	    if (false) {
	      if (debugID !== 0) {
	        var childDebugIDs = child._debugID !== 0 ? [child._debugID] : [];
	        ReactInstrumentation.debugTool.onSetChildren(debugID, childDebugIDs);
	      }
	    }
	
	    return markup;
	  },
	
	  getHostNode: function () {
	    return ReactReconciler.getHostNode(this._renderedComponent);
	  },
	
	  /**
	   * Releases any resources allocated by `mountComponent`.
	   *
	   * @final
	   * @internal
	   */
	  unmountComponent: function (safely) {
	    if (!this._renderedComponent) {
	      return;
	    }
	
	    var inst = this._instance;
	
	    if (inst.componentWillUnmount && !inst._calledComponentWillUnmount) {
	      inst._calledComponentWillUnmount = true;
	
	      if (safely) {
	        var name = this.getName() + '.componentWillUnmount()';
	        ReactErrorUtils.invokeGuardedCallback(name, inst.componentWillUnmount.bind(inst));
	      } else {
	        if (false) {
	          measureLifeCyclePerf(function () {
	            return inst.componentWillUnmount();
	          }, this._debugID, 'componentWillUnmount');
	        } else {
	          inst.componentWillUnmount();
	        }
	      }
	    }
	
	    if (this._renderedComponent) {
	      ReactReconciler.unmountComponent(this._renderedComponent, safely);
	      this._renderedNodeType = null;
	      this._renderedComponent = null;
	      this._instance = null;
	    }
	
	    // Reset pending fields
	    // Even if this component is scheduled for another update in ReactUpdates,
	    // it would still be ignored because these fields are reset.
	    this._pendingStateQueue = null;
	    this._pendingReplaceState = false;
	    this._pendingForceUpdate = false;
	    this._pendingCallbacks = null;
	    this._pendingElement = null;
	
	    // These fields do not really need to be reset since this object is no
	    // longer accessible.
	    this._context = null;
	    this._rootNodeID = 0;
	    this._topLevelWrapper = null;
	
	    // Delete the reference from the instance to this internal representation
	    // which allow the internals to be properly cleaned up even if the user
	    // leaks a reference to the public instance.
	    ReactInstanceMap.remove(inst);
	
	    // Some existing components rely on inst.props even after they've been
	    // destroyed (in event handlers).
	    // TODO: inst.props = null;
	    // TODO: inst.state = null;
	    // TODO: inst.context = null;
	  },
	
	  /**
	   * Filters the context object to only contain keys specified in
	   * `contextTypes`
	   *
	   * @param {object} context
	   * @return {?object}
	   * @private
	   */
	  _maskContext: function (context) {
	    var Component = this._currentElement.type;
	    var contextTypes = Component.contextTypes;
	    if (!contextTypes) {
	      return emptyObject;
	    }
	    var maskedContext = {};
	    for (var contextName in contextTypes) {
	      maskedContext[contextName] = context[contextName];
	    }
	    return maskedContext;
	  },
	
	  /**
	   * Filters the context object to only contain keys specified in
	   * `contextTypes`, and asserts that they are valid.
	   *
	   * @param {object} context
	   * @return {?object}
	   * @private
	   */
	  _processContext: function (context) {
	    var maskedContext = this._maskContext(context);
	    if (false) {
	      var Component = this._currentElement.type;
	      if (Component.contextTypes) {
	        this._checkContextTypes(Component.contextTypes, maskedContext, 'context');
	      }
	    }
	    return maskedContext;
	  },
	
	  /**
	   * @param {object} currentContext
	   * @return {object}
	   * @private
	   */
	  _processChildContext: function (currentContext) {
	    var Component = this._currentElement.type;
	    var inst = this._instance;
	    var childContext;
	
	    if (inst.getChildContext) {
	      if (false) {
	        ReactInstrumentation.debugTool.onBeginProcessingChildContext();
	        try {
	          childContext = inst.getChildContext();
	        } finally {
	          ReactInstrumentation.debugTool.onEndProcessingChildContext();
	        }
	      } else {
	        childContext = inst.getChildContext();
	      }
	    }
	
	    if (childContext) {
	      !(typeof Component.childContextTypes === 'object') ?  false ? invariant(false, '%s.getChildContext(): childContextTypes must be defined in order to use getChildContext().', this.getName() || 'ReactCompositeComponent') : _prodInvariant('107', this.getName() || 'ReactCompositeComponent') : void 0;
	      if (false) {
	        this._checkContextTypes(Component.childContextTypes, childContext, 'child context');
	      }
	      for (var name in childContext) {
	        !(name in Component.childContextTypes) ?  false ? invariant(false, '%s.getChildContext(): key "%s" is not defined in childContextTypes.', this.getName() || 'ReactCompositeComponent', name) : _prodInvariant('108', this.getName() || 'ReactCompositeComponent', name) : void 0;
	      }
	      return _assign({}, currentContext, childContext);
	    }
	    return currentContext;
	  },
	
	  /**
	   * Assert that the context types are valid
	   *
	   * @param {object} typeSpecs Map of context field to a ReactPropType
	   * @param {object} values Runtime values that need to be type-checked
	   * @param {string} location e.g. "prop", "context", "child context"
	   * @private
	   */
	  _checkContextTypes: function (typeSpecs, values, location) {
	    if (false) {
	      checkReactTypeSpec(typeSpecs, values, location, this.getName(), null, this._debugID);
	    }
	  },
	
	  receiveComponent: function (nextElement, transaction, nextContext) {
	    var prevElement = this._currentElement;
	    var prevContext = this._context;
	
	    this._pendingElement = null;
	
	    this.updateComponent(transaction, prevElement, nextElement, prevContext, nextContext);
	  },
	
	  /**
	   * If any of `_pendingElement`, `_pendingStateQueue`, or `_pendingForceUpdate`
	   * is set, update the component.
	   *
	   * @param {ReactReconcileTransaction} transaction
	   * @internal
	   */
	  performUpdateIfNecessary: function (transaction) {
	    if (this._pendingElement != null) {
	      ReactReconciler.receiveComponent(this, this._pendingElement, transaction, this._context);
	    } else if (this._pendingStateQueue !== null || this._pendingForceUpdate) {
	      this.updateComponent(transaction, this._currentElement, this._currentElement, this._context, this._context);
	    } else {
	      this._updateBatchNumber = null;
	    }
	  },
	
	  /**
	   * Perform an update to a mounted component. The componentWillReceiveProps and
	   * shouldComponentUpdate methods are called, then (assuming the update isn't
	   * skipped) the remaining update lifecycle methods are called and the DOM
	   * representation is updated.
	   *
	   * By default, this implements React's rendering and reconciliation algorithm.
	   * Sophisticated clients may wish to override this.
	   *
	   * @param {ReactReconcileTransaction} transaction
	   * @param {ReactElement} prevParentElement
	   * @param {ReactElement} nextParentElement
	   * @internal
	   * @overridable
	   */
	  updateComponent: function (transaction, prevParentElement, nextParentElement, prevUnmaskedContext, nextUnmaskedContext) {
	    var inst = this._instance;
	    !(inst != null) ?  false ? invariant(false, 'Attempted to update component `%s` that has already been unmounted (or failed to mount).', this.getName() || 'ReactCompositeComponent') : _prodInvariant('136', this.getName() || 'ReactCompositeComponent') : void 0;
	
	    var willReceive = false;
	    var nextContext;
	
	    // Determine if the context has changed or not
	    if (this._context === nextUnmaskedContext) {
	      nextContext = inst.context;
	    } else {
	      nextContext = this._processContext(nextUnmaskedContext);
	      willReceive = true;
	    }
	
	    var prevProps = prevParentElement.props;
	    var nextProps = nextParentElement.props;
	
	    // Not a simple state update but a props update
	    if (prevParentElement !== nextParentElement) {
	      willReceive = true;
	    }
	
	    // An update here will schedule an update but immediately set
	    // _pendingStateQueue which will ensure that any state updates gets
	    // immediately reconciled instead of waiting for the next batch.
	    if (willReceive && inst.componentWillReceiveProps) {
	      if (false) {
	        measureLifeCyclePerf(function () {
	          return inst.componentWillReceiveProps(nextProps, nextContext);
	        }, this._debugID, 'componentWillReceiveProps');
	      } else {
	        inst.componentWillReceiveProps(nextProps, nextContext);
	      }
	    }
	
	    var nextState = this._processPendingState(nextProps, nextContext);
	    var shouldUpdate = true;
	
	    if (!this._pendingForceUpdate) {
	      if (inst.shouldComponentUpdate) {
	        if (false) {
	          shouldUpdate = measureLifeCyclePerf(function () {
	            return inst.shouldComponentUpdate(nextProps, nextState, nextContext);
	          }, this._debugID, 'shouldComponentUpdate');
	        } else {
	          shouldUpdate = inst.shouldComponentUpdate(nextProps, nextState, nextContext);
	        }
	      } else {
	        if (this._compositeType === CompositeTypes.PureClass) {
	          shouldUpdate = !shallowEqual(prevProps, nextProps) || !shallowEqual(inst.state, nextState);
	        }
	      }
	    }
	
	    if (false) {
	      process.env.NODE_ENV !== 'production' ? warning(shouldUpdate !== undefined, '%s.shouldComponentUpdate(): Returned undefined instead of a ' + 'boolean value. Make sure to return true or false.', this.getName() || 'ReactCompositeComponent') : void 0;
	    }
	
	    this._updateBatchNumber = null;
	    if (shouldUpdate) {
	      this._pendingForceUpdate = false;
	      // Will set `this.props`, `this.state` and `this.context`.
	      this._performComponentUpdate(nextParentElement, nextProps, nextState, nextContext, transaction, nextUnmaskedContext);
	    } else {
	      // If it's determined that a component should not update, we still want
	      // to set props and state but we shortcut the rest of the update.
	      this._currentElement = nextParentElement;
	      this._context = nextUnmaskedContext;
	      inst.props = nextProps;
	      inst.state = nextState;
	      inst.context = nextContext;
	    }
	  },
	
	  _processPendingState: function (props, context) {
	    var inst = this._instance;
	    var queue = this._pendingStateQueue;
	    var replace = this._pendingReplaceState;
	    this._pendingReplaceState = false;
	    this._pendingStateQueue = null;
	
	    if (!queue) {
	      return inst.state;
	    }
	
	    if (replace && queue.length === 1) {
	      return queue[0];
	    }
	
	    var nextState = _assign({}, replace ? queue[0] : inst.state);
	    for (var i = replace ? 1 : 0; i < queue.length; i++) {
	      var partial = queue[i];
	      _assign(nextState, typeof partial === 'function' ? partial.call(inst, nextState, props, context) : partial);
	    }
	
	    return nextState;
	  },
	
	  /**
	   * Merges new props and state, notifies delegate methods of update and
	   * performs update.
	   *
	   * @param {ReactElement} nextElement Next element
	   * @param {object} nextProps Next public object to set as properties.
	   * @param {?object} nextState Next object to set as state.
	   * @param {?object} nextContext Next public object to set as context.
	   * @param {ReactReconcileTransaction} transaction
	   * @param {?object} unmaskedContext
	   * @private
	   */
	  _performComponentUpdate: function (nextElement, nextProps, nextState, nextContext, transaction, unmaskedContext) {
	    var _this2 = this;
	
	    var inst = this._instance;
	
	    var hasComponentDidUpdate = Boolean(inst.componentDidUpdate);
	    var prevProps;
	    var prevState;
	    var prevContext;
	    if (hasComponentDidUpdate) {
	      prevProps = inst.props;
	      prevState = inst.state;
	      prevContext = inst.context;
	    }
	
	    if (inst.componentWillUpdate) {
	      if (false) {
	        measureLifeCyclePerf(function () {
	          return inst.componentWillUpdate(nextProps, nextState, nextContext);
	        }, this._debugID, 'componentWillUpdate');
	      } else {
	        inst.componentWillUpdate(nextProps, nextState, nextContext);
	      }
	    }
	
	    this._currentElement = nextElement;
	    this._context = unmaskedContext;
	    inst.props = nextProps;
	    inst.state = nextState;
	    inst.context = nextContext;
	
	    this._updateRenderedComponent(transaction, unmaskedContext);
	
	    if (hasComponentDidUpdate) {
	      if (false) {
	        transaction.getReactMountReady().enqueue(function () {
	          measureLifeCyclePerf(inst.componentDidUpdate.bind(inst, prevProps, prevState, prevContext), _this2._debugID, 'componentDidUpdate');
	        });
	      } else {
	        transaction.getReactMountReady().enqueue(inst.componentDidUpdate.bind(inst, prevProps, prevState, prevContext), inst);
	      }
	    }
	  },
	
	  /**
	   * Call the component's `render` method and update the DOM accordingly.
	   *
	   * @param {ReactReconcileTransaction} transaction
	   * @internal
	   */
	  _updateRenderedComponent: function (transaction, context) {
	    var prevComponentInstance = this._renderedComponent;
	    var prevRenderedElement = prevComponentInstance._currentElement;
	    var nextRenderedElement = this._renderValidatedComponent();
	
	    var debugID = 0;
	    if (false) {
	      debugID = this._debugID;
	    }
	
	    if (shouldUpdateReactComponent(prevRenderedElement, nextRenderedElement)) {
	      ReactReconciler.receiveComponent(prevComponentInstance, nextRenderedElement, transaction, this._processChildContext(context));
	    } else {
	      var oldHostNode = ReactReconciler.getHostNode(prevComponentInstance);
	      ReactReconciler.unmountComponent(prevComponentInstance, false);
	
	      var nodeType = ReactNodeTypes.getType(nextRenderedElement);
	      this._renderedNodeType = nodeType;
	      var child = this._instantiateReactComponent(nextRenderedElement, nodeType !== ReactNodeTypes.EMPTY /* shouldHaveDebugID */
	      );
	      this._renderedComponent = child;
	
	      var nextMarkup = ReactReconciler.mountComponent(child, transaction, this._hostParent, this._hostContainerInfo, this._processChildContext(context), debugID);
	
	      if (false) {
	        if (debugID !== 0) {
	          var childDebugIDs = child._debugID !== 0 ? [child._debugID] : [];
	          ReactInstrumentation.debugTool.onSetChildren(debugID, childDebugIDs);
	        }
	      }
	
	      this._replaceNodeWithMarkup(oldHostNode, nextMarkup, prevComponentInstance);
	    }
	  },
	
	  /**
	   * Overridden in shallow rendering.
	   *
	   * @protected
	   */
	  _replaceNodeWithMarkup: function (oldHostNode, nextMarkup, prevInstance) {
	    ReactComponentEnvironment.replaceNodeWithMarkup(oldHostNode, nextMarkup, prevInstance);
	  },
	
	  /**
	   * @protected
	   */
	  _renderValidatedComponentWithoutOwnerOrContext: function () {
	    var inst = this._instance;
	    var renderedElement;
	
	    if (false) {
	      renderedElement = measureLifeCyclePerf(function () {
	        return inst.render();
	      }, this._debugID, 'render');
	    } else {
	      renderedElement = inst.render();
	    }
	
	    if (false) {
	      // We allow auto-mocks to proceed as if they're returning null.
	      if (renderedElement === undefined && inst.render._isMockFunction) {
	        // This is probably bad practice. Consider warning here and
	        // deprecating this convenience.
	        renderedElement = null;
	      }
	    }
	
	    return renderedElement;
	  },
	
	  /**
	   * @private
	   */
	  _renderValidatedComponent: function () {
	    var renderedElement;
	    if (("production") !== 'production' || this._compositeType !== CompositeTypes.StatelessFunctional) {
	      ReactCurrentOwner.current = this;
	      try {
	        renderedElement = this._renderValidatedComponentWithoutOwnerOrContext();
	      } finally {
	        ReactCurrentOwner.current = null;
	      }
	    } else {
	      renderedElement = this._renderValidatedComponentWithoutOwnerOrContext();
	    }
	    !(
	    // TODO: An `isValidNode` function would probably be more appropriate
	    renderedElement === null || renderedElement === false || React.isValidElement(renderedElement)) ?  false ? invariant(false, '%s.render(): A valid React element (or null) must be returned. You may have returned undefined, an array or some other invalid object.', this.getName() || 'ReactCompositeComponent') : _prodInvariant('109', this.getName() || 'ReactCompositeComponent') : void 0;
	
	    return renderedElement;
	  },
	
	  /**
	   * Lazily allocates the refs object and stores `component` as `ref`.
	   *
	   * @param {string} ref Reference name.
	   * @param {component} component Component to store as `ref`.
	   * @final
	   * @private
	   */
	  attachRef: function (ref, component) {
	    var inst = this.getPublicInstance();
	    !(inst != null) ?  false ? invariant(false, 'Stateless function components cannot have refs.') : _prodInvariant('110') : void 0;
	    var publicComponentInstance = component.getPublicInstance();
	    if (false) {
	      var componentName = component && component.getName ? component.getName() : 'a component';
	      process.env.NODE_ENV !== 'production' ? warning(publicComponentInstance != null || component._compositeType !== CompositeTypes.StatelessFunctional, 'Stateless function components cannot be given refs ' + '(See ref "%s" in %s created by %s). ' + 'Attempts to access this ref will fail.', ref, componentName, this.getName()) : void 0;
	    }
	    var refs = inst.refs === emptyObject ? inst.refs = {} : inst.refs;
	    refs[ref] = publicComponentInstance;
	  },
	
	  /**
	   * Detaches a reference name.
	   *
	   * @param {string} ref Name to dereference.
	   * @final
	   * @private
	   */
	  detachRef: function (ref) {
	    var refs = this.getPublicInstance().refs;
	    delete refs[ref];
	  },
	
	  /**
	   * Get a text description of the component that can be used to identify it
	   * in error messages.
	   * @return {string} The name or null.
	   * @internal
	   */
	  getName: function () {
	    var type = this._currentElement.type;
	    var constructor = this._instance && this._instance.constructor;
	    return type.displayName || constructor && constructor.displayName || type.name || constructor && constructor.name || null;
	  },
	
	  /**
	   * Get the publicly accessible representation of this component - i.e. what
	   * is exposed by refs and returned by render. Can be null for stateless
	   * components.
	   *
	   * @return {ReactComponent} the public component instance.
	   * @internal
	   */
	  getPublicInstance: function () {
	    var inst = this._instance;
	    if (this._compositeType === CompositeTypes.StatelessFunctional) {
	      return null;
	    }
	    return inst;
	  },
	
	  // Stub
	  _instantiateReactComponent: null
	};
	
	module.exports = ReactCompositeComponent;

/***/ },
/* 979 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	/* globals __REACT_DEVTOOLS_GLOBAL_HOOK__*/
	
	'use strict';
	
	var ReactDOMComponentTree = __webpack_require__(41);
	var ReactDefaultInjection = __webpack_require__(389);
	var ReactMount = __webpack_require__(395);
	var ReactReconciler = __webpack_require__(114);
	var ReactUpdates = __webpack_require__(74);
	var ReactVersion = __webpack_require__(398);
	
	var findDOMNode = __webpack_require__(1018);
	var getHostComponentFromComposite = __webpack_require__(402);
	var renderSubtreeIntoContainer = __webpack_require__(1025);
	var warning = __webpack_require__(30);
	
	ReactDefaultInjection.inject();
	
	var ReactDOM = {
	  findDOMNode: findDOMNode,
	  render: ReactMount.render,
	  unmountComponentAtNode: ReactMount.unmountComponentAtNode,
	  version: ReactVersion,
	
	  /* eslint-disable camelcase */
	  unstable_batchedUpdates: ReactUpdates.batchedUpdates,
	  unstable_renderSubtreeIntoContainer: renderSubtreeIntoContainer
	  /* eslint-enable camelcase */
	};
	
	// Inject the runtime into a devtools global hook regardless of browser.
	// Allows for debugging when the hook is injected on the page.
	if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ !== 'undefined' && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.inject === 'function') {
	  __REACT_DEVTOOLS_GLOBAL_HOOK__.inject({
	    ComponentTree: {
	      getClosestInstanceFromNode: ReactDOMComponentTree.getClosestInstanceFromNode,
	      getNodeFromInstance: function (inst) {
	        // inst is an internal instance (but could be a composite)
	        if (inst._renderedComponent) {
	          inst = getHostComponentFromComposite(inst);
	        }
	        if (inst) {
	          return ReactDOMComponentTree.getNodeFromInstance(inst);
	        } else {
	          return null;
	        }
	      }
	    },
	    Mount: ReactMount,
	    Reconciler: ReactReconciler
	  });
	}
	
	if (false) {
	  var ExecutionEnvironment = require('fbjs/lib/ExecutionEnvironment');
	  if (ExecutionEnvironment.canUseDOM && window.top === window.self) {
	    // First check if devtools is not installed
	    if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined') {
	      // If we're in Chrome or Firefox, provide a download link if not installed.
	      if (navigator.userAgent.indexOf('Chrome') > -1 && navigator.userAgent.indexOf('Edge') === -1 || navigator.userAgent.indexOf('Firefox') > -1) {
	        // Firefox does not have the issue with devtools loaded over file://
	        var showFileUrlMessage = window.location.protocol.indexOf('http') === -1 && navigator.userAgent.indexOf('Firefox') === -1;
	        console.debug('Download the React DevTools ' + (showFileUrlMessage ? 'and use an HTTP server (instead of a file: URL) ' : '') + 'for a better development experience: ' + 'https://fb.me/react-devtools');
	      }
	    }
	
	    var testFunc = function testFn() {};
	    process.env.NODE_ENV !== 'production' ? warning((testFunc.name || testFunc.toString()).indexOf('testFn') !== -1, "It looks like you're using a minified copy of the development build " + 'of React. When deploying React apps to production, make sure to use ' + 'the production build which skips development warnings and is faster. ' + 'See https://fb.me/react-minification for more details.') : void 0;
	
	    // If we're in IE8, check to see if we are in compatibility mode and provide
	    // information on preventing compatibility mode
	    var ieCompatibilityMode = document.documentMode && document.documentMode < 8;
	
	    process.env.NODE_ENV !== 'production' ? warning(!ieCompatibilityMode, 'Internet Explorer is running in compatibility mode; please add the ' + 'following tag to your HTML to prevent this from happening: ' + '<meta http-equiv="X-UA-Compatible" content="IE=edge" />') : void 0;
	
	    var expectedFeatures = [
	    // shims
	    Array.isArray, Array.prototype.every, Array.prototype.forEach, Array.prototype.indexOf, Array.prototype.map, Date.now, Function.prototype.bind, Object.keys, String.prototype.trim];
	
	    for (var i = 0; i < expectedFeatures.length; i++) {
	      if (!expectedFeatures[i]) {
	        process.env.NODE_ENV !== 'production' ? warning(false, 'One or more ES5 shims expected by React are not available: ' + 'https://fb.me/react-warning-polyfills') : void 0;
	        break;
	      }
	    }
	  }
	}
	
	if (false) {
	  var ReactInstrumentation = require('./ReactInstrumentation');
	  var ReactDOMUnknownPropertyHook = require('./ReactDOMUnknownPropertyHook');
	  var ReactDOMNullInputValuePropHook = require('./ReactDOMNullInputValuePropHook');
	  var ReactDOMInvalidARIAHook = require('./ReactDOMInvalidARIAHook');
	
	  ReactInstrumentation.debugTool.addHook(ReactDOMUnknownPropertyHook);
	  ReactInstrumentation.debugTool.addHook(ReactDOMNullInputValuePropHook);
	  ReactInstrumentation.debugTool.addHook(ReactDOMInvalidARIAHook);
	}
	
	module.exports = ReactDOM;

/***/ },
/* 980 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	/* global hasOwnProperty:true */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(29),
	    _assign = __webpack_require__(36);
	
	var AutoFocusUtils = __webpack_require__(967);
	var CSSPropertyOperations = __webpack_require__(969);
	var DOMLazyTree = __webpack_require__(127);
	var DOMNamespaces = __webpack_require__(249);
	var DOMProperty = __webpack_require__(128);
	var DOMPropertyOperations = __webpack_require__(384);
	var EventPluginHub = __webpack_require__(144);
	var EventPluginRegistry = __webpack_require__(250);
	var ReactBrowserEventEmitter = __webpack_require__(184);
	var ReactDOMComponentFlags = __webpack_require__(385);
	var ReactDOMComponentTree = __webpack_require__(41);
	var ReactDOMInput = __webpack_require__(984);
	var ReactDOMOption = __webpack_require__(985);
	var ReactDOMSelect = __webpack_require__(387);
	var ReactDOMTextarea = __webpack_require__(989);
	var ReactInstrumentation = __webpack_require__(62);
	var ReactMultiChild = __webpack_require__(995);
	var ReactServerRenderingTransaction = __webpack_require__(397);
	
	var emptyFunction = __webpack_require__(80);
	var escapeTextContentForBrowser = __webpack_require__(187);
	var invariant = __webpack_require__(21);
	var isEventSupported = __webpack_require__(262);
	var shallowEqual = __webpack_require__(233);
	var inputValueTracking = __webpack_require__(404);
	var validateDOMNesting = __webpack_require__(264);
	var warning = __webpack_require__(30);
	
	var Flags = ReactDOMComponentFlags;
	var deleteListener = EventPluginHub.deleteListener;
	var getNode = ReactDOMComponentTree.getNodeFromInstance;
	var listenTo = ReactBrowserEventEmitter.listenTo;
	var registrationNameModules = EventPluginRegistry.registrationNameModules;
	
	// For quickly matching children type, to test if can be treated as content.
	var CONTENT_TYPES = { string: true, number: true };
	
	var STYLE = 'style';
	var HTML = '__html';
	var RESERVED_PROPS = {
	  children: null,
	  dangerouslySetInnerHTML: null,
	  suppressContentEditableWarning: null
	};
	
	// Node type for document fragments (Node.DOCUMENT_FRAGMENT_NODE).
	var DOC_FRAGMENT_TYPE = 11;
	
	function getDeclarationErrorAddendum(internalInstance) {
	  if (internalInstance) {
	    var owner = internalInstance._currentElement._owner || null;
	    if (owner) {
	      var name = owner.getName();
	      if (name) {
	        return ' This DOM node was rendered by `' + name + '`.';
	      }
	    }
	  }
	  return '';
	}
	
	function friendlyStringify(obj) {
	  if (typeof obj === 'object') {
	    if (Array.isArray(obj)) {
	      return '[' + obj.map(friendlyStringify).join(', ') + ']';
	    } else {
	      var pairs = [];
	      for (var key in obj) {
	        if (Object.prototype.hasOwnProperty.call(obj, key)) {
	          var keyEscaped = /^[a-z$_][\w$_]*$/i.test(key) ? key : JSON.stringify(key);
	          pairs.push(keyEscaped + ': ' + friendlyStringify(obj[key]));
	        }
	      }
	      return '{' + pairs.join(', ') + '}';
	    }
	  } else if (typeof obj === 'string') {
	    return JSON.stringify(obj);
	  } else if (typeof obj === 'function') {
	    return '[function object]';
	  }
	  // Differs from JSON.stringify in that undefined because undefined and that
	  // inf and nan don't become null
	  return String(obj);
	}
	
	var styleMutationWarning = {};
	
	function checkAndWarnForMutatedStyle(style1, style2, component) {
	  if (style1 == null || style2 == null) {
	    return;
	  }
	  if (shallowEqual(style1, style2)) {
	    return;
	  }
	
	  var componentName = component._tag;
	  var owner = component._currentElement._owner;
	  var ownerName;
	  if (owner) {
	    ownerName = owner.getName();
	  }
	
	  var hash = ownerName + '|' + componentName;
	
	  if (styleMutationWarning.hasOwnProperty(hash)) {
	    return;
	  }
	
	  styleMutationWarning[hash] = true;
	
	   false ? warning(false, '`%s` was passed a style object that has previously been mutated. ' + 'Mutating `style` is deprecated. Consider cloning it beforehand. Check ' + 'the `render` %s. Previous style: %s. Mutated style: %s.', componentName, owner ? 'of `' + ownerName + '`' : 'using <' + componentName + '>', friendlyStringify(style1), friendlyStringify(style2)) : void 0;
	}
	
	/**
	 * @param {object} component
	 * @param {?object} props
	 */
	function assertValidProps(component, props) {
	  if (!props) {
	    return;
	  }
	  // Note the use of `==` which checks for null or undefined.
	  if (voidElementTags[component._tag]) {
	    !(props.children == null && props.dangerouslySetInnerHTML == null) ?  false ? invariant(false, '%s is a void element tag and must neither have `children` nor use `dangerouslySetInnerHTML`.%s', component._tag, component._currentElement._owner ? ' Check the render method of ' + component._currentElement._owner.getName() + '.' : '') : _prodInvariant('137', component._tag, component._currentElement._owner ? ' Check the render method of ' + component._currentElement._owner.getName() + '.' : '') : void 0;
	  }
	  if (props.dangerouslySetInnerHTML != null) {
	    !(props.children == null) ?  false ? invariant(false, 'Can only set one of `children` or `props.dangerouslySetInnerHTML`.') : _prodInvariant('60') : void 0;
	    !(typeof props.dangerouslySetInnerHTML === 'object' && HTML in props.dangerouslySetInnerHTML) ?  false ? invariant(false, '`props.dangerouslySetInnerHTML` must be in the form `{__html: ...}`. Please visit https://fb.me/react-invariant-dangerously-set-inner-html for more information.') : _prodInvariant('61') : void 0;
	  }
	  if (false) {
	    process.env.NODE_ENV !== 'production' ? warning(props.innerHTML == null, 'Directly setting property `innerHTML` is not permitted. ' + 'For more information, lookup documentation on `dangerouslySetInnerHTML`.') : void 0;
	    process.env.NODE_ENV !== 'production' ? warning(props.suppressContentEditableWarning || !props.contentEditable || props.children == null, 'A component is `contentEditable` and contains `children` managed by ' + 'React. It is now your responsibility to guarantee that none of ' + 'those nodes are unexpectedly modified or duplicated. This is ' + 'probably not intentional.') : void 0;
	    process.env.NODE_ENV !== 'production' ? warning(props.onFocusIn == null && props.onFocusOut == null, 'React uses onFocus and onBlur instead of onFocusIn and onFocusOut. ' + 'All React events are normalized to bubble, so onFocusIn and onFocusOut ' + 'are not needed/supported by React.') : void 0;
	  }
	  !(props.style == null || typeof props.style === 'object') ?  false ? invariant(false, 'The `style` prop expects a mapping from style properties to values, not a string. For example, style={{marginRight: spacing + \'em\'}} when using JSX.%s', getDeclarationErrorAddendum(component)) : _prodInvariant('62', getDeclarationErrorAddendum(component)) : void 0;
	}
	
	function enqueuePutListener(inst, registrationName, listener, transaction) {
	  if (transaction instanceof ReactServerRenderingTransaction) {
	    return;
	  }
	  if (false) {
	    // IE8 has no API for event capturing and the `onScroll` event doesn't
	    // bubble.
	    process.env.NODE_ENV !== 'production' ? warning(registrationName !== 'onScroll' || isEventSupported('scroll', true), "This browser doesn't support the `onScroll` event") : void 0;
	  }
	  var containerInfo = inst._hostContainerInfo;
	  var isDocumentFragment = containerInfo._node && containerInfo._node.nodeType === DOC_FRAGMENT_TYPE;
	  var doc = isDocumentFragment ? containerInfo._node : containerInfo._ownerDocument;
	  listenTo(registrationName, doc);
	  transaction.getReactMountReady().enqueue(putListener, {
	    inst: inst,
	    registrationName: registrationName,
	    listener: listener
	  });
	}
	
	function putListener() {
	  var listenerToPut = this;
	  EventPluginHub.putListener(listenerToPut.inst, listenerToPut.registrationName, listenerToPut.listener);
	}
	
	function inputPostMount() {
	  var inst = this;
	  ReactDOMInput.postMountWrapper(inst);
	}
	
	function textareaPostMount() {
	  var inst = this;
	  ReactDOMTextarea.postMountWrapper(inst);
	}
	
	function optionPostMount() {
	  var inst = this;
	  ReactDOMOption.postMountWrapper(inst);
	}
	
	var setAndValidateContentChildDev = emptyFunction;
	if (false) {
	  setAndValidateContentChildDev = function (content) {
	    var hasExistingContent = this._contentDebugID != null;
	    var debugID = this._debugID;
	    // This ID represents the inlined child that has no backing instance:
	    var contentDebugID = -debugID;
	
	    if (content == null) {
	      if (hasExistingContent) {
	        ReactInstrumentation.debugTool.onUnmountComponent(this._contentDebugID);
	      }
	      this._contentDebugID = null;
	      return;
	    }
	
	    validateDOMNesting(null, String(content), this, this._ancestorInfo);
	    this._contentDebugID = contentDebugID;
	    if (hasExistingContent) {
	      ReactInstrumentation.debugTool.onBeforeUpdateComponent(contentDebugID, content);
	      ReactInstrumentation.debugTool.onUpdateComponent(contentDebugID);
	    } else {
	      ReactInstrumentation.debugTool.onBeforeMountComponent(contentDebugID, content, debugID);
	      ReactInstrumentation.debugTool.onMountComponent(contentDebugID);
	      ReactInstrumentation.debugTool.onSetChildren(debugID, [contentDebugID]);
	    }
	  };
	}
	
	// There are so many media events, it makes sense to just
	// maintain a list rather than create a `trapBubbledEvent` for each
	var mediaEvents = {
	  topAbort: 'abort',
	  topCanPlay: 'canplay',
	  topCanPlayThrough: 'canplaythrough',
	  topDurationChange: 'durationchange',
	  topEmptied: 'emptied',
	  topEncrypted: 'encrypted',
	  topEnded: 'ended',
	  topError: 'error',
	  topLoadedData: 'loadeddata',
	  topLoadedMetadata: 'loadedmetadata',
	  topLoadStart: 'loadstart',
	  topPause: 'pause',
	  topPlay: 'play',
	  topPlaying: 'playing',
	  topProgress: 'progress',
	  topRateChange: 'ratechange',
	  topSeeked: 'seeked',
	  topSeeking: 'seeking',
	  topStalled: 'stalled',
	  topSuspend: 'suspend',
	  topTimeUpdate: 'timeupdate',
	  topVolumeChange: 'volumechange',
	  topWaiting: 'waiting'
	};
	
	function trackInputValue() {
	  inputValueTracking.track(this);
	}
	
	function trapBubbledEventsLocal() {
	  var inst = this;
	  // If a component renders to null or if another component fatals and causes
	  // the state of the tree to be corrupted, `node` here can be null.
	  !inst._rootNodeID ?  false ? invariant(false, 'Must be mounted to trap events') : _prodInvariant('63') : void 0;
	  var node = getNode(inst);
	  !node ?  false ? invariant(false, 'trapBubbledEvent(...): Requires node to be rendered.') : _prodInvariant('64') : void 0;
	
	  switch (inst._tag) {
	    case 'iframe':
	    case 'object':
	      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent('topLoad', 'load', node)];
	      break;
	    case 'video':
	    case 'audio':
	      inst._wrapperState.listeners = [];
	      // Create listener for each media event
	      for (var event in mediaEvents) {
	        if (mediaEvents.hasOwnProperty(event)) {
	          inst._wrapperState.listeners.push(ReactBrowserEventEmitter.trapBubbledEvent(event, mediaEvents[event], node));
	        }
	      }
	      break;
	    case 'source':
	      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent('topError', 'error', node)];
	      break;
	    case 'img':
	      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent('topError', 'error', node), ReactBrowserEventEmitter.trapBubbledEvent('topLoad', 'load', node)];
	      break;
	    case 'form':
	      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent('topReset', 'reset', node), ReactBrowserEventEmitter.trapBubbledEvent('topSubmit', 'submit', node)];
	      break;
	    case 'input':
	    case 'select':
	    case 'textarea':
	      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent('topInvalid', 'invalid', node)];
	      break;
	  }
	}
	
	function postUpdateSelectWrapper() {
	  ReactDOMSelect.postUpdateWrapper(this);
	}
	
	// For HTML, certain tags should omit their close tag. We keep a whitelist for
	// those special-case tags.
	
	var omittedCloseTags = {
	  area: true,
	  base: true,
	  br: true,
	  col: true,
	  embed: true,
	  hr: true,
	  img: true,
	  input: true,
	  keygen: true,
	  link: true,
	  meta: true,
	  param: true,
	  source: true,
	  track: true,
	  wbr: true
	  // NOTE: menuitem's close tag should be omitted, but that causes problems.
	};
	
	var newlineEatingTags = {
	  listing: true,
	  pre: true,
	  textarea: true
	};
	
	// For HTML, certain tags cannot have children. This has the same purpose as
	// `omittedCloseTags` except that `menuitem` should still have its closing tag.
	
	var voidElementTags = _assign({
	  menuitem: true
	}, omittedCloseTags);
	
	// We accept any tag to be rendered but since this gets injected into arbitrary
	// HTML, we want to make sure that it's a safe tag.
	// http://www.w3.org/TR/REC-xml/#NT-Name
	
	var VALID_TAG_REGEX = /^[a-zA-Z][a-zA-Z:_\.\-\d]*$/; // Simplified subset
	var validatedTagCache = {};
	var hasOwnProperty = {}.hasOwnProperty;
	
	function validateDangerousTag(tag) {
	  if (!hasOwnProperty.call(validatedTagCache, tag)) {
	    !VALID_TAG_REGEX.test(tag) ?  false ? invariant(false, 'Invalid tag: %s', tag) : _prodInvariant('65', tag) : void 0;
	    validatedTagCache[tag] = true;
	  }
	}
	
	function isCustomComponent(tagName, props) {
	  return tagName.indexOf('-') >= 0 || props.is != null;
	}
	
	var globalIdCounter = 1;
	
	/**
	 * Creates a new React class that is idempotent and capable of containing other
	 * React components. It accepts event listeners and DOM properties that are
	 * valid according to `DOMProperty`.
	 *
	 *  - Event listeners: `onClick`, `onMouseDown`, etc.
	 *  - DOM properties: `className`, `name`, `title`, etc.
	 *
	 * The `style` property functions differently from the DOM API. It accepts an
	 * object mapping of style properties to values.
	 *
	 * @constructor ReactDOMComponent
	 * @extends ReactMultiChild
	 */
	function ReactDOMComponent(element) {
	  var tag = element.type;
	  validateDangerousTag(tag);
	  this._currentElement = element;
	  this._tag = tag.toLowerCase();
	  this._namespaceURI = null;
	  this._renderedChildren = null;
	  this._previousStyle = null;
	  this._previousStyleCopy = null;
	  this._hostNode = null;
	  this._hostParent = null;
	  this._rootNodeID = 0;
	  this._domID = 0;
	  this._hostContainerInfo = null;
	  this._wrapperState = null;
	  this._topLevelWrapper = null;
	  this._flags = 0;
	  if (false) {
	    this._ancestorInfo = null;
	    setAndValidateContentChildDev.call(this, null);
	  }
	}
	
	ReactDOMComponent.displayName = 'ReactDOMComponent';
	
	ReactDOMComponent.Mixin = {
	  /**
	   * Generates root tag markup then recurses. This method has side effects and
	   * is not idempotent.
	   *
	   * @internal
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @param {?ReactDOMComponent} the parent component instance
	   * @param {?object} info about the host container
	   * @param {object} context
	   * @return {string} The computed markup.
	   */
	  mountComponent: function (transaction, hostParent, hostContainerInfo, context) {
	    this._rootNodeID = globalIdCounter++;
	    this._domID = hostContainerInfo._idCounter++;
	    this._hostParent = hostParent;
	    this._hostContainerInfo = hostContainerInfo;
	
	    var props = this._currentElement.props;
	
	    switch (this._tag) {
	      case 'audio':
	      case 'form':
	      case 'iframe':
	      case 'img':
	      case 'link':
	      case 'object':
	      case 'source':
	      case 'video':
	        this._wrapperState = {
	          listeners: null
	        };
	        transaction.getReactMountReady().enqueue(trapBubbledEventsLocal, this);
	        break;
	      case 'input':
	        ReactDOMInput.mountWrapper(this, props, hostParent);
	        props = ReactDOMInput.getHostProps(this, props);
	        transaction.getReactMountReady().enqueue(trackInputValue, this);
	        transaction.getReactMountReady().enqueue(trapBubbledEventsLocal, this);
	        break;
	      case 'option':
	        ReactDOMOption.mountWrapper(this, props, hostParent);
	        props = ReactDOMOption.getHostProps(this, props);
	        break;
	      case 'select':
	        ReactDOMSelect.mountWrapper(this, props, hostParent);
	        props = ReactDOMSelect.getHostProps(this, props);
	        transaction.getReactMountReady().enqueue(trapBubbledEventsLocal, this);
	        break;
	      case 'textarea':
	        ReactDOMTextarea.mountWrapper(this, props, hostParent);
	        props = ReactDOMTextarea.getHostProps(this, props);
	        transaction.getReactMountReady().enqueue(trackInputValue, this);
	        transaction.getReactMountReady().enqueue(trapBubbledEventsLocal, this);
	        break;
	    }
	
	    assertValidProps(this, props);
	
	    // We create tags in the namespace of their parent container, except HTML
	    // tags get no namespace.
	    var namespaceURI;
	    var parentTag;
	    if (hostParent != null) {
	      namespaceURI = hostParent._namespaceURI;
	      parentTag = hostParent._tag;
	    } else if (hostContainerInfo._tag) {
	      namespaceURI = hostContainerInfo._namespaceURI;
	      parentTag = hostContainerInfo._tag;
	    }
	    if (namespaceURI == null || namespaceURI === DOMNamespaces.svg && parentTag === 'foreignobject') {
	      namespaceURI = DOMNamespaces.html;
	    }
	    if (namespaceURI === DOMNamespaces.html) {
	      if (this._tag === 'svg') {
	        namespaceURI = DOMNamespaces.svg;
	      } else if (this._tag === 'math') {
	        namespaceURI = DOMNamespaces.mathml;
	      }
	    }
	    this._namespaceURI = namespaceURI;
	
	    if (false) {
	      var parentInfo;
	      if (hostParent != null) {
	        parentInfo = hostParent._ancestorInfo;
	      } else if (hostContainerInfo._tag) {
	        parentInfo = hostContainerInfo._ancestorInfo;
	      }
	      if (parentInfo) {
	        // parentInfo should always be present except for the top-level
	        // component when server rendering
	        validateDOMNesting(this._tag, null, this, parentInfo);
	      }
	      this._ancestorInfo = validateDOMNesting.updatedAncestorInfo(parentInfo, this._tag, this);
	    }
	
	    var mountImage;
	    if (transaction.useCreateElement) {
	      var ownerDocument = hostContainerInfo._ownerDocument;
	      var el;
	      if (namespaceURI === DOMNamespaces.html) {
	        if (this._tag === 'script') {
	          // Create the script via .innerHTML so its "parser-inserted" flag is
	          // set to true and it does not execute
	          var div = ownerDocument.createElement('div');
	          var type = this._currentElement.type;
	          div.innerHTML = '<' + type + '></' + type + '>';
	          el = div.removeChild(div.firstChild);
	        } else if (props.is) {
	          el = ownerDocument.createElement(this._currentElement.type, props.is);
	        } else {
	          // Separate else branch instead of using `props.is || undefined` above becuase of a Firefox bug.
	          // See discussion in https://github.com/facebook/react/pull/6896
	          // and discussion in https://bugzilla.mozilla.org/show_bug.cgi?id=1276240
	          el = ownerDocument.createElement(this._currentElement.type);
	        }
	      } else {
	        el = ownerDocument.createElementNS(namespaceURI, this._currentElement.type);
	      }
	      ReactDOMComponentTree.precacheNode(this, el);
	      this._flags |= Flags.hasCachedChildNodes;
	      if (!this._hostParent) {
	        DOMPropertyOperations.setAttributeForRoot(el);
	      }
	      this._updateDOMProperties(null, props, transaction);
	      var lazyTree = DOMLazyTree(el);
	      this._createInitialChildren(transaction, props, context, lazyTree);
	      mountImage = lazyTree;
	    } else {
	      var tagOpen = this._createOpenTagMarkupAndPutListeners(transaction, props);
	      var tagContent = this._createContentMarkup(transaction, props, context);
	      if (!tagContent && omittedCloseTags[this._tag]) {
	        mountImage = tagOpen + '/>';
	      } else {
	        mountImage = tagOpen + '>' + tagContent + '</' + this._currentElement.type + '>';
	      }
	    }
	
	    switch (this._tag) {
	      case 'input':
	        transaction.getReactMountReady().enqueue(inputPostMount, this);
	        if (props.autoFocus) {
	          transaction.getReactMountReady().enqueue(AutoFocusUtils.focusDOMComponent, this);
	        }
	        break;
	      case 'textarea':
	        transaction.getReactMountReady().enqueue(textareaPostMount, this);
	        if (props.autoFocus) {
	          transaction.getReactMountReady().enqueue(AutoFocusUtils.focusDOMComponent, this);
	        }
	        break;
	      case 'select':
	        if (props.autoFocus) {
	          transaction.getReactMountReady().enqueue(AutoFocusUtils.focusDOMComponent, this);
	        }
	        break;
	      case 'button':
	        if (props.autoFocus) {
	          transaction.getReactMountReady().enqueue(AutoFocusUtils.focusDOMComponent, this);
	        }
	        break;
	      case 'option':
	        transaction.getReactMountReady().enqueue(optionPostMount, this);
	        break;
	    }
	
	    return mountImage;
	  },
	
	  /**
	   * Creates markup for the open tag and all attributes.
	   *
	   * This method has side effects because events get registered.
	   *
	   * Iterating over object properties is faster than iterating over arrays.
	   * @see http://jsperf.com/obj-vs-arr-iteration
	   *
	   * @private
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @param {object} props
	   * @return {string} Markup of opening tag.
	   */
	  _createOpenTagMarkupAndPutListeners: function (transaction, props) {
	    var ret = '<' + this._currentElement.type;
	
	    for (var propKey in props) {
	      if (!props.hasOwnProperty(propKey)) {
	        continue;
	      }
	      var propValue = props[propKey];
	      if (propValue == null) {
	        continue;
	      }
	      if (registrationNameModules.hasOwnProperty(propKey)) {
	        if (propValue) {
	          enqueuePutListener(this, propKey, propValue, transaction);
	        }
	      } else {
	        if (propKey === STYLE) {
	          if (propValue) {
	            if (false) {
	              // See `_updateDOMProperties`. style block
	              this._previousStyle = propValue;
	            }
	            propValue = this._previousStyleCopy = _assign({}, props.style);
	          }
	          propValue = CSSPropertyOperations.createMarkupForStyles(propValue, this);
	        }
	        var markup = null;
	        if (this._tag != null && isCustomComponent(this._tag, props)) {
	          if (!RESERVED_PROPS.hasOwnProperty(propKey)) {
	            markup = DOMPropertyOperations.createMarkupForCustomAttribute(propKey, propValue);
	          }
	        } else {
	          markup = DOMPropertyOperations.createMarkupForProperty(propKey, propValue);
	        }
	        if (markup) {
	          ret += ' ' + markup;
	        }
	      }
	    }
	
	    // For static pages, no need to put React ID and checksum. Saves lots of
	    // bytes.
	    if (transaction.renderToStaticMarkup) {
	      return ret;
	    }
	
	    if (!this._hostParent) {
	      ret += ' ' + DOMPropertyOperations.createMarkupForRoot();
	    }
	    ret += ' ' + DOMPropertyOperations.createMarkupForID(this._domID);
	    return ret;
	  },
	
	  /**
	   * Creates markup for the content between the tags.
	   *
	   * @private
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @param {object} props
	   * @param {object} context
	   * @return {string} Content markup.
	   */
	  _createContentMarkup: function (transaction, props, context) {
	    var ret = '';
	
	    // Intentional use of != to avoid catching zero/false.
	    var innerHTML = props.dangerouslySetInnerHTML;
	    if (innerHTML != null) {
	      if (innerHTML.__html != null) {
	        ret = innerHTML.__html;
	      }
	    } else {
	      var contentToUse = CONTENT_TYPES[typeof props.children] ? props.children : null;
	      var childrenToUse = contentToUse != null ? null : props.children;
	      if (contentToUse != null) {
	        // TODO: Validate that text is allowed as a child of this node
	        ret = escapeTextContentForBrowser(contentToUse);
	        if (false) {
	          setAndValidateContentChildDev.call(this, contentToUse);
	        }
	      } else if (childrenToUse != null) {
	        var mountImages = this.mountChildren(childrenToUse, transaction, context);
	        ret = mountImages.join('');
	      }
	    }
	    if (newlineEatingTags[this._tag] && ret.charAt(0) === '\n') {
	      // text/html ignores the first character in these tags if it's a newline
	      // Prefer to break application/xml over text/html (for now) by adding
	      // a newline specifically to get eaten by the parser. (Alternately for
	      // textareas, replacing "^\n" with "\r\n" doesn't get eaten, and the first
	      // \r is normalized out by HTMLTextAreaElement#value.)
	      // See: <http://www.w3.org/TR/html-polyglot/#newlines-in-textarea-and-pre>
	      // See: <http://www.w3.org/TR/html5/syntax.html#element-restrictions>
	      // See: <http://www.w3.org/TR/html5/syntax.html#newlines>
	      // See: Parsing of "textarea" "listing" and "pre" elements
	      //  from <http://www.w3.org/TR/html5/syntax.html#parsing-main-inbody>
	      return '\n' + ret;
	    } else {
	      return ret;
	    }
	  },
	
	  _createInitialChildren: function (transaction, props, context, lazyTree) {
	    // Intentional use of != to avoid catching zero/false.
	    var innerHTML = props.dangerouslySetInnerHTML;
	    if (innerHTML != null) {
	      if (innerHTML.__html != null) {
	        DOMLazyTree.queueHTML(lazyTree, innerHTML.__html);
	      }
	    } else {
	      var contentToUse = CONTENT_TYPES[typeof props.children] ? props.children : null;
	      var childrenToUse = contentToUse != null ? null : props.children;
	      // TODO: Validate that text is allowed as a child of this node
	      if (contentToUse != null) {
	        // Avoid setting textContent when the text is empty. In IE11 setting
	        // textContent on a text area will cause the placeholder to not
	        // show within the textarea until it has been focused and blurred again.
	        // https://github.com/facebook/react/issues/6731#issuecomment-254874553
	        if (contentToUse !== '') {
	          if (false) {
	            setAndValidateContentChildDev.call(this, contentToUse);
	          }
	          DOMLazyTree.queueText(lazyTree, contentToUse);
	        }
	      } else if (childrenToUse != null) {
	        var mountImages = this.mountChildren(childrenToUse, transaction, context);
	        for (var i = 0; i < mountImages.length; i++) {
	          DOMLazyTree.queueChild(lazyTree, mountImages[i]);
	        }
	      }
	    }
	  },
	
	  /**
	   * Receives a next element and updates the component.
	   *
	   * @internal
	   * @param {ReactElement} nextElement
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @param {object} context
	   */
	  receiveComponent: function (nextElement, transaction, context) {
	    var prevElement = this._currentElement;
	    this._currentElement = nextElement;
	    this.updateComponent(transaction, prevElement, nextElement, context);
	  },
	
	  /**
	   * Updates a DOM component after it has already been allocated and
	   * attached to the DOM. Reconciles the root DOM node, then recurses.
	   *
	   * @param {ReactReconcileTransaction} transaction
	   * @param {ReactElement} prevElement
	   * @param {ReactElement} nextElement
	   * @internal
	   * @overridable
	   */
	  updateComponent: function (transaction, prevElement, nextElement, context) {
	    var lastProps = prevElement.props;
	    var nextProps = this._currentElement.props;
	
	    switch (this._tag) {
	      case 'input':
	        lastProps = ReactDOMInput.getHostProps(this, lastProps);
	        nextProps = ReactDOMInput.getHostProps(this, nextProps);
	        break;
	      case 'option':
	        lastProps = ReactDOMOption.getHostProps(this, lastProps);
	        nextProps = ReactDOMOption.getHostProps(this, nextProps);
	        break;
	      case 'select':
	        lastProps = ReactDOMSelect.getHostProps(this, lastProps);
	        nextProps = ReactDOMSelect.getHostProps(this, nextProps);
	        break;
	      case 'textarea':
	        lastProps = ReactDOMTextarea.getHostProps(this, lastProps);
	        nextProps = ReactDOMTextarea.getHostProps(this, nextProps);
	        break;
	    }
	
	    assertValidProps(this, nextProps);
	    this._updateDOMProperties(lastProps, nextProps, transaction);
	    this._updateDOMChildren(lastProps, nextProps, transaction, context);
	
	    switch (this._tag) {
	      case 'input':
	        // Update the wrapper around inputs *after* updating props. This has to
	        // happen after `_updateDOMProperties`. Otherwise HTML5 input validations
	        // raise warnings and prevent the new value from being assigned.
	        ReactDOMInput.updateWrapper(this);
	
	        // We also check that we haven't missed a value update, such as a
	        // Radio group shifting the checked value to another named radio input.
	        inputValueTracking.updateValueIfChanged(this);
	        break;
	      case 'textarea':
	        ReactDOMTextarea.updateWrapper(this);
	        break;
	      case 'select':
	        // <select> value update needs to occur after <option> children
	        // reconciliation
	        transaction.getReactMountReady().enqueue(postUpdateSelectWrapper, this);
	        break;
	    }
	  },
	
	  /**
	   * Reconciles the properties by detecting differences in property values and
	   * updating the DOM as necessary. This function is probably the single most
	   * critical path for performance optimization.
	   *
	   * TODO: Benchmark whether checking for changed values in memory actually
	   *       improves performance (especially statically positioned elements).
	   * TODO: Benchmark the effects of putting this at the top since 99% of props
	   *       do not change for a given reconciliation.
	   * TODO: Benchmark areas that can be improved with caching.
	   *
	   * @private
	   * @param {object} lastProps
	   * @param {object} nextProps
	   * @param {?DOMElement} node
	   */
	  _updateDOMProperties: function (lastProps, nextProps, transaction) {
	    var propKey;
	    var styleName;
	    var styleUpdates;
	    for (propKey in lastProps) {
	      if (nextProps.hasOwnProperty(propKey) || !lastProps.hasOwnProperty(propKey) || lastProps[propKey] == null) {
	        continue;
	      }
	      if (propKey === STYLE) {
	        var lastStyle = this._previousStyleCopy;
	        for (styleName in lastStyle) {
	          if (lastStyle.hasOwnProperty(styleName)) {
	            styleUpdates = styleUpdates || {};
	            styleUpdates[styleName] = '';
	          }
	        }
	        this._previousStyleCopy = null;
	      } else if (registrationNameModules.hasOwnProperty(propKey)) {
	        if (lastProps[propKey]) {
	          // Only call deleteListener if there was a listener previously or
	          // else willDeleteListener gets called when there wasn't actually a
	          // listener (e.g., onClick={null})
	          deleteListener(this, propKey);
	        }
	      } else if (isCustomComponent(this._tag, lastProps)) {
	        if (!RESERVED_PROPS.hasOwnProperty(propKey)) {
	          DOMPropertyOperations.deleteValueForAttribute(getNode(this), propKey);
	        }
	      } else if (DOMProperty.properties[propKey] || DOMProperty.isCustomAttribute(propKey)) {
	        DOMPropertyOperations.deleteValueForProperty(getNode(this), propKey);
	      }
	    }
	    for (propKey in nextProps) {
	      var nextProp = nextProps[propKey];
	      var lastProp = propKey === STYLE ? this._previousStyleCopy : lastProps != null ? lastProps[propKey] : undefined;
	      if (!nextProps.hasOwnProperty(propKey) || nextProp === lastProp || nextProp == null && lastProp == null) {
	        continue;
	      }
	      if (propKey === STYLE) {
	        if (nextProp) {
	          if (false) {
	            checkAndWarnForMutatedStyle(this._previousStyleCopy, this._previousStyle, this);
	            this._previousStyle = nextProp;
	          }
	          nextProp = this._previousStyleCopy = _assign({}, nextProp);
	        } else {
	          this._previousStyleCopy = null;
	        }
	        if (lastProp) {
	          // Unset styles on `lastProp` but not on `nextProp`.
	          for (styleName in lastProp) {
	            if (lastProp.hasOwnProperty(styleName) && (!nextProp || !nextProp.hasOwnProperty(styleName))) {
	              styleUpdates = styleUpdates || {};
	              styleUpdates[styleName] = '';
	            }
	          }
	          // Update styles that changed since `lastProp`.
	          for (styleName in nextProp) {
	            if (nextProp.hasOwnProperty(styleName) && lastProp[styleName] !== nextProp[styleName]) {
	              styleUpdates = styleUpdates || {};
	              styleUpdates[styleName] = nextProp[styleName];
	            }
	          }
	        } else {
	          // Relies on `updateStylesByID` not mutating `styleUpdates`.
	          styleUpdates = nextProp;
	        }
	      } else if (registrationNameModules.hasOwnProperty(propKey)) {
	        if (nextProp) {
	          enqueuePutListener(this, propKey, nextProp, transaction);
	        } else if (lastProp) {
	          deleteListener(this, propKey);
	        }
	      } else if (isCustomComponent(this._tag, nextProps)) {
	        if (!RESERVED_PROPS.hasOwnProperty(propKey)) {
	          DOMPropertyOperations.setValueForAttribute(getNode(this), propKey, nextProp);
	        }
	      } else if (DOMProperty.properties[propKey] || DOMProperty.isCustomAttribute(propKey)) {
	        var node = getNode(this);
	        // If we're updating to null or undefined, we should remove the property
	        // from the DOM node instead of inadvertently setting to a string. This
	        // brings us in line with the same behavior we have on initial render.
	        if (nextProp != null) {
	          DOMPropertyOperations.setValueForProperty(node, propKey, nextProp);
	        } else {
	          DOMPropertyOperations.deleteValueForProperty(node, propKey);
	        }
	      }
	    }
	    if (styleUpdates) {
	      CSSPropertyOperations.setValueForStyles(getNode(this), styleUpdates, this);
	    }
	  },
	
	  /**
	   * Reconciles the children with the various properties that affect the
	   * children content.
	   *
	   * @param {object} lastProps
	   * @param {object} nextProps
	   * @param {ReactReconcileTransaction} transaction
	   * @param {object} context
	   */
	  _updateDOMChildren: function (lastProps, nextProps, transaction, context) {
	    var lastContent = CONTENT_TYPES[typeof lastProps.children] ? lastProps.children : null;
	    var nextContent = CONTENT_TYPES[typeof nextProps.children] ? nextProps.children : null;
	
	    var lastHtml = lastProps.dangerouslySetInnerHTML && lastProps.dangerouslySetInnerHTML.__html;
	    var nextHtml = nextProps.dangerouslySetInnerHTML && nextProps.dangerouslySetInnerHTML.__html;
	
	    // Note the use of `!=` which checks for null or undefined.
	    var lastChildren = lastContent != null ? null : lastProps.children;
	    var nextChildren = nextContent != null ? null : nextProps.children;
	
	    // If we're switching from children to content/html or vice versa, remove
	    // the old content
	    var lastHasContentOrHtml = lastContent != null || lastHtml != null;
	    var nextHasContentOrHtml = nextContent != null || nextHtml != null;
	    if (lastChildren != null && nextChildren == null) {
	      this.updateChildren(null, transaction, context);
	    } else if (lastHasContentOrHtml && !nextHasContentOrHtml) {
	      this.updateTextContent('');
	      if (false) {
	        ReactInstrumentation.debugTool.onSetChildren(this._debugID, []);
	      }
	    }
	
	    if (nextContent != null) {
	      if (lastContent !== nextContent) {
	        this.updateTextContent('' + nextContent);
	        if (false) {
	          setAndValidateContentChildDev.call(this, nextContent);
	        }
	      }
	    } else if (nextHtml != null) {
	      if (lastHtml !== nextHtml) {
	        this.updateMarkup('' + nextHtml);
	      }
	      if (false) {
	        ReactInstrumentation.debugTool.onSetChildren(this._debugID, []);
	      }
	    } else if (nextChildren != null) {
	      if (false) {
	        setAndValidateContentChildDev.call(this, null);
	      }
	
	      this.updateChildren(nextChildren, transaction, context);
	    }
	  },
	
	  getHostNode: function () {
	    return getNode(this);
	  },
	
	  /**
	   * Destroys all event registrations for this instance. Does not remove from
	   * the DOM. That must be done by the parent.
	   *
	   * @internal
	   */
	  unmountComponent: function (safely) {
	    switch (this._tag) {
	      case 'audio':
	      case 'form':
	      case 'iframe':
	      case 'img':
	      case 'link':
	      case 'object':
	      case 'source':
	      case 'video':
	        var listeners = this._wrapperState.listeners;
	        if (listeners) {
	          for (var i = 0; i < listeners.length; i++) {
	            listeners[i].remove();
	          }
	        }
	        break;
	      case 'input':
	      case 'textarea':
	        inputValueTracking.stopTracking(this);
	        break;
	      case 'html':
	      case 'head':
	      case 'body':
	        /**
	         * Components like <html> <head> and <body> can't be removed or added
	         * easily in a cross-browser way, however it's valuable to be able to
	         * take advantage of React's reconciliation for styling and <title>
	         * management. So we just document it and throw in dangerous cases.
	         */
	         true ?  false ? invariant(false, '<%s> tried to unmount. Because of cross-browser quirks it is impossible to unmount some top-level components (eg <html>, <head>, and <body>) reliably and efficiently. To fix this, have a single top-level component that never unmounts render these elements.', this._tag) : _prodInvariant('66', this._tag) : void 0;
	        break;
	    }
	
	    this.unmountChildren(safely);
	    ReactDOMComponentTree.uncacheNode(this);
	    EventPluginHub.deleteAllListeners(this);
	    this._rootNodeID = 0;
	    this._domID = 0;
	    this._wrapperState = null;
	
	    if (false) {
	      setAndValidateContentChildDev.call(this, null);
	    }
	  },
	
	  getPublicInstance: function () {
	    return getNode(this);
	  }
	};
	
	_assign(ReactDOMComponent.prototype, ReactDOMComponent.Mixin, ReactMultiChild.Mixin);
	
	module.exports = ReactDOMComponent;

/***/ },
/* 981 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2014-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(36);
	
	var DOMLazyTree = __webpack_require__(127);
	var ReactDOMComponentTree = __webpack_require__(41);
	
	var ReactDOMEmptyComponent = function (instantiate) {
	  // ReactCompositeComponent uses this:
	  this._currentElement = null;
	  // ReactDOMComponentTree uses these:
	  this._hostNode = null;
	  this._hostParent = null;
	  this._hostContainerInfo = null;
	  this._domID = 0;
	};
	_assign(ReactDOMEmptyComponent.prototype, {
	  mountComponent: function (transaction, hostParent, hostContainerInfo, context) {
	    var domID = hostContainerInfo._idCounter++;
	    this._domID = domID;
	    this._hostParent = hostParent;
	    this._hostContainerInfo = hostContainerInfo;
	
	    var nodeValue = ' react-empty: ' + this._domID + ' ';
	    if (transaction.useCreateElement) {
	      var ownerDocument = hostContainerInfo._ownerDocument;
	      var node = ownerDocument.createComment(nodeValue);
	      ReactDOMComponentTree.precacheNode(this, node);
	      return DOMLazyTree(node);
	    } else {
	      if (transaction.renderToStaticMarkup) {
	        // Normally we'd insert a comment node, but since this is a situation
	        // where React won't take over (static pages), we can simply return
	        // nothing.
	        return '';
	      }
	      return '<!--' + nodeValue + '-->';
	    }
	  },
	  receiveComponent: function () {},
	  getHostNode: function () {
	    return ReactDOMComponentTree.getNodeFromInstance(this);
	  },
	  unmountComponent: function () {
	    ReactDOMComponentTree.uncacheNode(this);
	  }
	});
	
	module.exports = ReactDOMEmptyComponent;

/***/ },
/* 982 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ReactDOMFeatureFlags = {
	  useCreateElement: true,
	  useFiber: false
	};
	
	module.exports = ReactDOMFeatureFlags;

/***/ },
/* 983 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var DOMChildrenOperations = __webpack_require__(248);
	var ReactDOMComponentTree = __webpack_require__(41);
	
	/**
	 * Operations used to process updates to DOM nodes.
	 */
	var ReactDOMIDOperations = {
	  /**
	   * Updates a component's children by processing a series of updates.
	   *
	   * @param {array<object>} updates List of update configurations.
	   * @internal
	   */
	  dangerouslyProcessChildrenUpdates: function (parentInst, updates) {
	    var node = ReactDOMComponentTree.getNodeFromInstance(parentInst);
	    DOMChildrenOperations.processUpdates(node, updates);
	  }
	};
	
	module.exports = ReactDOMIDOperations;

/***/ },
/* 984 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(29),
	    _assign = __webpack_require__(36);
	
	var DOMPropertyOperations = __webpack_require__(384);
	var LinkedValueUtils = __webpack_require__(253);
	var ReactDOMComponentTree = __webpack_require__(41);
	var ReactUpdates = __webpack_require__(74);
	
	var invariant = __webpack_require__(21);
	var warning = __webpack_require__(30);
	
	var didWarnValueLink = false;
	var didWarnCheckedLink = false;
	var didWarnValueDefaultValue = false;
	var didWarnCheckedDefaultChecked = false;
	var didWarnControlledToUncontrolled = false;
	var didWarnUncontrolledToControlled = false;
	
	function forceUpdateIfMounted() {
	  if (this._rootNodeID) {
	    // DOM component is still mounted; update
	    ReactDOMInput.updateWrapper(this);
	  }
	}
	
	function isControlled(props) {
	  var usesChecked = props.type === 'checkbox' || props.type === 'radio';
	  return usesChecked ? props.checked != null : props.value != null;
	}
	
	/**
	 * Implements an <input> host component that allows setting these optional
	 * props: `checked`, `value`, `defaultChecked`, and `defaultValue`.
	 *
	 * If `checked` or `value` are not supplied (or null/undefined), user actions
	 * that affect the checked state or value will trigger updates to the element.
	 *
	 * If they are supplied (and not null/undefined), the rendered element will not
	 * trigger updates to the element. Instead, the props must change in order for
	 * the rendered element to be updated.
	 *
	 * The rendered element will be initialized as unchecked (or `defaultChecked`)
	 * with an empty value (or `defaultValue`).
	 *
	 * @see http://www.w3.org/TR/2012/WD-html5-20121025/the-input-element.html
	 */
	var ReactDOMInput = {
	  getHostProps: function (inst, props) {
	    var value = LinkedValueUtils.getValue(props);
	    var checked = LinkedValueUtils.getChecked(props);
	
	    var hostProps = _assign({
	      // Make sure we set .type before any other properties (setting .value
	      // before .type means .value is lost in IE11 and below)
	      type: undefined,
	      // Make sure we set .step before .value (setting .value before .step
	      // means .value is rounded on mount, based upon step precision)
	      step: undefined,
	      // Make sure we set .min & .max before .value (to ensure proper order
	      // in corner cases such as min or max deriving from value, e.g. Issue #7170)
	      min: undefined,
	      max: undefined
	    }, props, {
	      defaultChecked: undefined,
	      defaultValue: undefined,
	      value: value != null ? value : inst._wrapperState.initialValue,
	      checked: checked != null ? checked : inst._wrapperState.initialChecked,
	      onChange: inst._wrapperState.onChange
	    });
	
	    return hostProps;
	  },
	
	  mountWrapper: function (inst, props) {
	    if (false) {
	      LinkedValueUtils.checkPropTypes('input', props, inst._currentElement._owner);
	
	      var owner = inst._currentElement._owner;
	
	      if (props.valueLink !== undefined && !didWarnValueLink) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '`valueLink` prop on `input` is deprecated; set `value` and `onChange` instead.') : void 0;
	        didWarnValueLink = true;
	      }
	      if (props.checkedLink !== undefined && !didWarnCheckedLink) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '`checkedLink` prop on `input` is deprecated; set `value` and `onChange` instead.') : void 0;
	        didWarnCheckedLink = true;
	      }
	      if (props.checked !== undefined && props.defaultChecked !== undefined && !didWarnCheckedDefaultChecked) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '%s contains an input of type %s with both checked and defaultChecked props. ' + 'Input elements must be either controlled or uncontrolled ' + '(specify either the checked prop, or the defaultChecked prop, but not ' + 'both). Decide between using a controlled or uncontrolled input ' + 'element and remove one of these props. More info: ' + 'https://fb.me/react-controlled-components', owner && owner.getName() || 'A component', props.type) : void 0;
	        didWarnCheckedDefaultChecked = true;
	      }
	      if (props.value !== undefined && props.defaultValue !== undefined && !didWarnValueDefaultValue) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '%s contains an input of type %s with both value and defaultValue props. ' + 'Input elements must be either controlled or uncontrolled ' + '(specify either the value prop, or the defaultValue prop, but not ' + 'both). Decide between using a controlled or uncontrolled input ' + 'element and remove one of these props. More info: ' + 'https://fb.me/react-controlled-components', owner && owner.getName() || 'A component', props.type) : void 0;
	        didWarnValueDefaultValue = true;
	      }
	    }
	
	    var defaultValue = props.defaultValue;
	    inst._wrapperState = {
	      initialChecked: props.checked != null ? props.checked : props.defaultChecked,
	      initialValue: props.value != null ? props.value : defaultValue,
	      listeners: null,
	      onChange: _handleChange.bind(inst),
	      controlled: isControlled(props)
	    };
	  },
	
	  updateWrapper: function (inst) {
	    var props = inst._currentElement.props;
	
	    if (false) {
	      var controlled = isControlled(props);
	      var owner = inst._currentElement._owner;
	
	      if (!inst._wrapperState.controlled && controlled && !didWarnUncontrolledToControlled) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '%s is changing an uncontrolled input of type %s to be controlled. ' + 'Input elements should not switch from uncontrolled to controlled (or vice versa). ' + 'Decide between using a controlled or uncontrolled input ' + 'element for the lifetime of the component. More info: https://fb.me/react-controlled-components', owner && owner.getName() || 'A component', props.type) : void 0;
	        didWarnUncontrolledToControlled = true;
	      }
	      if (inst._wrapperState.controlled && !controlled && !didWarnControlledToUncontrolled) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '%s is changing a controlled input of type %s to be uncontrolled. ' + 'Input elements should not switch from controlled to uncontrolled (or vice versa). ' + 'Decide between using a controlled or uncontrolled input ' + 'element for the lifetime of the component. More info: https://fb.me/react-controlled-components', owner && owner.getName() || 'A component', props.type) : void 0;
	        didWarnControlledToUncontrolled = true;
	      }
	    }
	
	    // TODO: Shouldn't this be getChecked(props)?
	    var checked = props.checked;
	    if (checked != null) {
	      DOMPropertyOperations.setValueForProperty(ReactDOMComponentTree.getNodeFromInstance(inst), 'checked', checked || false);
	    }
	
	    var node = ReactDOMComponentTree.getNodeFromInstance(inst);
	    var value = LinkedValueUtils.getValue(props);
	    if (value != null) {
	      if (value === 0 && node.value === '') {
	        node.value = '0';
	        // Note: IE9 reports a number inputs as 'text', so check props instead.
	      } else if (props.type === 'number') {
	        // Simulate `input.valueAsNumber`. IE9 does not support it
	        var valueAsNumber = parseFloat(node.value, 10) || 0;
	
	        if (
	        // eslint-disable-next-line
	        value != valueAsNumber ||
	        // eslint-disable-next-line
	        value == valueAsNumber && node.value != value) {
	          // Cast `value` to a string to ensure the value is set correctly. While
	          // browsers typically do this as necessary, jsdom doesn't.
	          node.value = '' + value;
	        }
	      } else if (node.value !== '' + value) {
	        // Cast `value` to a string to ensure the value is set correctly. While
	        // browsers typically do this as necessary, jsdom doesn't.
	        node.value = '' + value;
	      }
	    } else {
	      if (props.value == null && props.defaultValue != null) {
	        // In Chrome, assigning defaultValue to certain input types triggers input validation.
	        // For number inputs, the display value loses trailing decimal points. For email inputs,
	        // Chrome raises "The specified value <x> is not a valid email address".
	        //
	        // Here we check to see if the defaultValue has actually changed, avoiding these problems
	        // when the user is inputting text
	        //
	        // https://github.com/facebook/react/issues/7253
	        if (node.defaultValue !== '' + props.defaultValue) {
	          node.defaultValue = '' + props.defaultValue;
	        }
	      }
	      if (props.checked == null && props.defaultChecked != null) {
	        node.defaultChecked = !!props.defaultChecked;
	      }
	    }
	  },
	
	  postMountWrapper: function (inst) {
	    var props = inst._currentElement.props;
	
	    // This is in postMount because we need access to the DOM node, which is not
	    // available until after the component has mounted.
	    var node = ReactDOMComponentTree.getNodeFromInstance(inst);
	
	    // Detach value from defaultValue. We won't do anything if we're working on
	    // submit or reset inputs as those values & defaultValues are linked. They
	    // are not resetable nodes so this operation doesn't matter and actually
	    // removes browser-default values (eg "Submit Query") when no value is
	    // provided.
	
	    switch (props.type) {
	      case 'submit':
	      case 'reset':
	        break;
	      case 'color':
	      case 'date':
	      case 'datetime':
	      case 'datetime-local':
	      case 'month':
	      case 'time':
	      case 'week':
	        // This fixes the no-show issue on iOS Safari and Android Chrome:
	        // https://github.com/facebook/react/issues/7233
	        node.value = '';
	        node.value = node.defaultValue;
	        break;
	      default:
	        node.value = node.value;
	        break;
	    }
	
	    // Normally, we'd just do `node.checked = node.checked` upon initial mount, less this bug
	    // this is needed to work around a chrome bug where setting defaultChecked
	    // will sometimes influence the value of checked (even after detachment).
	    // Reference: https://bugs.chromium.org/p/chromium/issues/detail?id=608416
	    // We need to temporarily unset name to avoid disrupting radio button groups.
	    var name = node.name;
	    if (name !== '') {
	      node.name = '';
	    }
	    node.defaultChecked = !node.defaultChecked;
	    node.defaultChecked = !node.defaultChecked;
	    if (name !== '') {
	      node.name = name;
	    }
	  }
	};
	
	function _handleChange(event) {
	  var props = this._currentElement.props;
	
	  var returnValue = LinkedValueUtils.executeOnChange(props, event);
	
	  // Here we use asap to wait until all updates have propagated, which
	  // is important when using controlled components within layers:
	  // https://github.com/facebook/react/issues/1698
	  ReactUpdates.asap(forceUpdateIfMounted, this);
	
	  var name = props.name;
	  if (props.type === 'radio' && name != null) {
	    var rootNode = ReactDOMComponentTree.getNodeFromInstance(this);
	    var queryRoot = rootNode;
	
	    while (queryRoot.parentNode) {
	      queryRoot = queryRoot.parentNode;
	    }
	
	    // If `rootNode.form` was non-null, then we could try `form.elements`,
	    // but that sometimes behaves strangely in IE8. We could also try using
	    // `form.getElementsByName`, but that will only return direct children
	    // and won't include inputs that use the HTML5 `form=` attribute. Since
	    // the input might not even be in a form, let's just use the global
	    // `querySelectorAll` to ensure we don't miss anything.
	    var group = queryRoot.querySelectorAll('input[name=' + JSON.stringify('' + name) + '][type="radio"]');
	
	    for (var i = 0; i < group.length; i++) {
	      var otherNode = group[i];
	      if (otherNode === rootNode || otherNode.form !== rootNode.form) {
	        continue;
	      }
	      // This will throw if radio buttons rendered by different copies of React
	      // and the same name are rendered into the same form (same as #1939).
	      // That's probably okay; we don't support it just as we don't support
	      // mixing React radio buttons with non-React ones.
	      var otherInstance = ReactDOMComponentTree.getInstanceFromNode(otherNode);
	      !otherInstance ?  false ? invariant(false, 'ReactDOMInput: Mixing React and non-React radio inputs with the same `name` is not supported.') : _prodInvariant('90') : void 0;
	      // If this is a controlled radio button group, forcing the input that
	      // was previously checked to update will cause it to be come re-checked
	      // as appropriate.
	      ReactUpdates.asap(forceUpdateIfMounted, otherInstance);
	    }
	  }
	
	  return returnValue;
	}
	
	module.exports = ReactDOMInput;

/***/ },
/* 985 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(36);
	
	var React = __webpack_require__(115);
	var ReactDOMComponentTree = __webpack_require__(41);
	var ReactDOMSelect = __webpack_require__(387);
	
	var warning = __webpack_require__(30);
	var didWarnInvalidOptionChildren = false;
	
	function flattenChildren(children) {
	  var content = '';
	
	  // Flatten children and warn if they aren't strings or numbers;
	  // invalid types are ignored.
	  React.Children.forEach(children, function (child) {
	    if (child == null) {
	      return;
	    }
	    if (typeof child === 'string' || typeof child === 'number') {
	      content += child;
	    } else if (!didWarnInvalidOptionChildren) {
	      didWarnInvalidOptionChildren = true;
	       false ? warning(false, 'Only strings and numbers are supported as <option> children.') : void 0;
	    }
	  });
	
	  return content;
	}
	
	/**
	 * Implements an <option> host component that warns when `selected` is set.
	 */
	var ReactDOMOption = {
	  mountWrapper: function (inst, props, hostParent) {
	    // TODO (yungsters): Remove support for `selected` in <option>.
	    if (false) {
	      process.env.NODE_ENV !== 'production' ? warning(props.selected == null, 'Use the `defaultValue` or `value` props on <select> instead of ' + 'setting `selected` on <option>.') : void 0;
	    }
	
	    // Look up whether this option is 'selected'
	    var selectValue = null;
	    if (hostParent != null) {
	      var selectParent = hostParent;
	
	      if (selectParent._tag === 'optgroup') {
	        selectParent = selectParent._hostParent;
	      }
	
	      if (selectParent != null && selectParent._tag === 'select') {
	        selectValue = ReactDOMSelect.getSelectValueContext(selectParent);
	      }
	    }
	
	    // If the value is null (e.g., no specified value or after initial mount)
	    // or missing (e.g., for <datalist>), we don't change props.selected
	    var selected = null;
	    if (selectValue != null) {
	      var value;
	      if (props.value != null) {
	        value = props.value + '';
	      } else {
	        value = flattenChildren(props.children);
	      }
	      selected = false;
	      if (Array.isArray(selectValue)) {
	        // multiple
	        for (var i = 0; i < selectValue.length; i++) {
	          if ('' + selectValue[i] === value) {
	            selected = true;
	            break;
	          }
	        }
	      } else {
	        selected = '' + selectValue === value;
	      }
	    }
	
	    inst._wrapperState = { selected: selected };
	  },
	
	  postMountWrapper: function (inst) {
	    // value="" should make a value attribute (#6219)
	    var props = inst._currentElement.props;
	    if (props.value != null) {
	      var node = ReactDOMComponentTree.getNodeFromInstance(inst);
	      node.setAttribute('value', props.value);
	    }
	  },
	
	  getHostProps: function (inst, props) {
	    var hostProps = _assign({ selected: undefined, children: undefined }, props);
	
	    // Read state only from initial mount because <select> updates value
	    // manually; we need the initial state only for server rendering
	    if (inst._wrapperState.selected != null) {
	      hostProps.selected = inst._wrapperState.selected;
	    }
	
	    var content = flattenChildren(props.children);
	
	    if (content) {
	      hostProps.children = content;
	    }
	
	    return hostProps;
	  }
	};
	
	module.exports = ReactDOMOption;

/***/ },
/* 986 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ExecutionEnvironment = __webpack_require__(51);
	
	var getNodeForCharacterOffset = __webpack_require__(1022);
	var getTextContentAccessor = __webpack_require__(403);
	
	/**
	 * While `isCollapsed` is available on the Selection object and `collapsed`
	 * is available on the Range object, IE11 sometimes gets them wrong.
	 * If the anchor/focus nodes and offsets are the same, the range is collapsed.
	 */
	function isCollapsed(anchorNode, anchorOffset, focusNode, focusOffset) {
	  return anchorNode === focusNode && anchorOffset === focusOffset;
	}
	
	/**
	 * Get the appropriate anchor and focus node/offset pairs for IE.
	 *
	 * The catch here is that IE's selection API doesn't provide information
	 * about whether the selection is forward or backward, so we have to
	 * behave as though it's always forward.
	 *
	 * IE text differs from modern selection in that it behaves as though
	 * block elements end with a new line. This means character offsets will
	 * differ between the two APIs.
	 *
	 * @param {DOMElement} node
	 * @return {object}
	 */
	function getIEOffsets(node) {
	  var selection = document.selection;
	  var selectedRange = selection.createRange();
	  var selectedLength = selectedRange.text.length;
	
	  // Duplicate selection so we can move range without breaking user selection.
	  var fromStart = selectedRange.duplicate();
	  fromStart.moveToElementText(node);
	  fromStart.setEndPoint('EndToStart', selectedRange);
	
	  var startOffset = fromStart.text.length;
	  var endOffset = startOffset + selectedLength;
	
	  return {
	    start: startOffset,
	    end: endOffset
	  };
	}
	
	/**
	 * @param {DOMElement} node
	 * @return {?object}
	 */
	function getModernOffsets(node) {
	  var selection = window.getSelection && window.getSelection();
	
	  if (!selection || selection.rangeCount === 0) {
	    return null;
	  }
	
	  var anchorNode = selection.anchorNode;
	  var anchorOffset = selection.anchorOffset;
	  var focusNode = selection.focusNode;
	  var focusOffset = selection.focusOffset;
	
	  var currentRange = selection.getRangeAt(0);
	
	  // In Firefox, range.startContainer and range.endContainer can be "anonymous
	  // divs", e.g. the up/down buttons on an <input type="number">. Anonymous
	  // divs do not seem to expose properties, triggering a "Permission denied
	  // error" if any of its properties are accessed. The only seemingly possible
	  // way to avoid erroring is to access a property that typically works for
	  // non-anonymous divs and catch any error that may otherwise arise. See
	  // https://bugzilla.mozilla.org/show_bug.cgi?id=208427
	  try {
	    /* eslint-disable no-unused-expressions */
	    currentRange.startContainer.nodeType;
	    currentRange.endContainer.nodeType;
	    /* eslint-enable no-unused-expressions */
	  } catch (e) {
	    return null;
	  }
	
	  // If the node and offset values are the same, the selection is collapsed.
	  // `Selection.isCollapsed` is available natively, but IE sometimes gets
	  // this value wrong.
	  var isSelectionCollapsed = isCollapsed(selection.anchorNode, selection.anchorOffset, selection.focusNode, selection.focusOffset);
	
	  var rangeLength = isSelectionCollapsed ? 0 : currentRange.toString().length;
	
	  var tempRange = currentRange.cloneRange();
	  tempRange.selectNodeContents(node);
	  tempRange.setEnd(currentRange.startContainer, currentRange.startOffset);
	
	  var isTempRangeCollapsed = isCollapsed(tempRange.startContainer, tempRange.startOffset, tempRange.endContainer, tempRange.endOffset);
	
	  var start = isTempRangeCollapsed ? 0 : tempRange.toString().length;
	  var end = start + rangeLength;
	
	  // Detect whether the selection is backward.
	  var detectionRange = document.createRange();
	  detectionRange.setStart(anchorNode, anchorOffset);
	  detectionRange.setEnd(focusNode, focusOffset);
	  var isBackward = detectionRange.collapsed;
	
	  return {
	    start: isBackward ? end : start,
	    end: isBackward ? start : end
	  };
	}
	
	/**
	 * @param {DOMElement|DOMTextNode} node
	 * @param {object} offsets
	 */
	function setIEOffsets(node, offsets) {
	  var range = document.selection.createRange().duplicate();
	  var start, end;
	
	  if (offsets.end === undefined) {
	    start = offsets.start;
	    end = start;
	  } else if (offsets.start > offsets.end) {
	    start = offsets.end;
	    end = offsets.start;
	  } else {
	    start = offsets.start;
	    end = offsets.end;
	  }
	
	  range.moveToElementText(node);
	  range.moveStart('character', start);
	  range.setEndPoint('EndToStart', range);
	  range.moveEnd('character', end - start);
	  range.select();
	}
	
	/**
	 * In modern non-IE browsers, we can support both forward and backward
	 * selections.
	 *
	 * Note: IE10+ supports the Selection object, but it does not support
	 * the `extend` method, which means that even in modern IE, it's not possible
	 * to programmatically create a backward selection. Thus, for all IE
	 * versions, we use the old IE API to create our selections.
	 *
	 * @param {DOMElement|DOMTextNode} node
	 * @param {object} offsets
	 */
	function setModernOffsets(node, offsets) {
	  if (!window.getSelection) {
	    return;
	  }
	
	  var selection = window.getSelection();
	  var length = node[getTextContentAccessor()].length;
	  var start = Math.min(offsets.start, length);
	  var end = offsets.end === undefined ? start : Math.min(offsets.end, length);
	
	  // IE 11 uses modern selection, but doesn't support the extend method.
	  // Flip backward selections, so we can set with a single range.
	  if (!selection.extend && start > end) {
	    var temp = end;
	    end = start;
	    start = temp;
	  }
	
	  var startMarker = getNodeForCharacterOffset(node, start);
	  var endMarker = getNodeForCharacterOffset(node, end);
	
	  if (startMarker && endMarker) {
	    var range = document.createRange();
	    range.setStart(startMarker.node, startMarker.offset);
	    selection.removeAllRanges();
	
	    if (start > end) {
	      selection.addRange(range);
	      selection.extend(endMarker.node, endMarker.offset);
	    } else {
	      range.setEnd(endMarker.node, endMarker.offset);
	      selection.addRange(range);
	    }
	  }
	}
	
	var useIEOffsets = ExecutionEnvironment.canUseDOM && 'selection' in document && !('getSelection' in window);
	
	var ReactDOMSelection = {
	  /**
	   * @param {DOMElement} node
	   */
	  getOffsets: useIEOffsets ? getIEOffsets : getModernOffsets,
	
	  /**
	   * @param {DOMElement|DOMTextNode} node
	   * @param {object} offsets
	   */
	  setOffsets: useIEOffsets ? setIEOffsets : setModernOffsets
	};
	
	module.exports = ReactDOMSelection;

/***/ },
/* 987 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ReactDefaultInjection = __webpack_require__(389);
	var ReactServerRendering = __webpack_require__(1001);
	var ReactVersion = __webpack_require__(398);
	
	ReactDefaultInjection.inject();
	
	var ReactDOMServer = {
	  renderToString: ReactServerRendering.renderToString,
	  renderToStaticMarkup: ReactServerRendering.renderToStaticMarkup,
	  version: ReactVersion
	};
	
	module.exports = ReactDOMServer;

/***/ },
/* 988 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(29),
	    _assign = __webpack_require__(36);
	
	var DOMChildrenOperations = __webpack_require__(248);
	var DOMLazyTree = __webpack_require__(127);
	var ReactDOMComponentTree = __webpack_require__(41);
	
	var escapeTextContentForBrowser = __webpack_require__(187);
	var invariant = __webpack_require__(21);
	var validateDOMNesting = __webpack_require__(264);
	
	/**
	 * Text nodes violate a couple assumptions that React makes about components:
	 *
	 *  - When mounting text into the DOM, adjacent text nodes are merged.
	 *  - Text nodes cannot be assigned a React root ID.
	 *
	 * This component is used to wrap strings between comment nodes so that they
	 * can undergo the same reconciliation that is applied to elements.
	 *
	 * TODO: Investigate representing React components in the DOM with text nodes.
	 *
	 * @class ReactDOMTextComponent
	 * @extends ReactComponent
	 * @internal
	 */
	var ReactDOMTextComponent = function (text) {
	  // TODO: This is really a ReactText (ReactNode), not a ReactElement
	  this._currentElement = text;
	  this._stringText = '' + text;
	  // ReactDOMComponentTree uses these:
	  this._hostNode = null;
	  this._hostParent = null;
	
	  // Properties
	  this._domID = 0;
	  this._mountIndex = 0;
	  this._closingComment = null;
	  this._commentNodes = null;
	};
	
	_assign(ReactDOMTextComponent.prototype, {
	  /**
	   * Creates the markup for this text node. This node is not intended to have
	   * any features besides containing text content.
	   *
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @return {string} Markup for this text node.
	   * @internal
	   */
	  mountComponent: function (transaction, hostParent, hostContainerInfo, context) {
	    if (false) {
	      var parentInfo;
	      if (hostParent != null) {
	        parentInfo = hostParent._ancestorInfo;
	      } else if (hostContainerInfo != null) {
	        parentInfo = hostContainerInfo._ancestorInfo;
	      }
	      if (parentInfo) {
	        // parentInfo should always be present except for the top-level
	        // component when server rendering
	        validateDOMNesting(null, this._stringText, this, parentInfo);
	      }
	    }
	
	    var domID = hostContainerInfo._idCounter++;
	    var openingValue = ' react-text: ' + domID + ' ';
	    var closingValue = ' /react-text ';
	    this._domID = domID;
	    this._hostParent = hostParent;
	    if (transaction.useCreateElement) {
	      var ownerDocument = hostContainerInfo._ownerDocument;
	      var openingComment = ownerDocument.createComment(openingValue);
	      var closingComment = ownerDocument.createComment(closingValue);
	      var lazyTree = DOMLazyTree(ownerDocument.createDocumentFragment());
	      DOMLazyTree.queueChild(lazyTree, DOMLazyTree(openingComment));
	      if (this._stringText) {
	        DOMLazyTree.queueChild(lazyTree, DOMLazyTree(ownerDocument.createTextNode(this._stringText)));
	      }
	      DOMLazyTree.queueChild(lazyTree, DOMLazyTree(closingComment));
	      ReactDOMComponentTree.precacheNode(this, openingComment);
	      this._closingComment = closingComment;
	      return lazyTree;
	    } else {
	      var escapedText = escapeTextContentForBrowser(this._stringText);
	
	      if (transaction.renderToStaticMarkup) {
	        // Normally we'd wrap this between comment nodes for the reasons stated
	        // above, but since this is a situation where React won't take over
	        // (static pages), we can simply return the text as it is.
	        return escapedText;
	      }
	
	      return '<!--' + openingValue + '-->' + escapedText + '<!--' + closingValue + '-->';
	    }
	  },
	
	  /**
	   * Updates this component by updating the text content.
	   *
	   * @param {ReactText} nextText The next text content
	   * @param {ReactReconcileTransaction} transaction
	   * @internal
	   */
	  receiveComponent: function (nextText, transaction) {
	    if (nextText !== this._currentElement) {
	      this._currentElement = nextText;
	      var nextStringText = '' + nextText;
	      if (nextStringText !== this._stringText) {
	        // TODO: Save this as pending props and use performUpdateIfNecessary
	        // and/or updateComponent to do the actual update for consistency with
	        // other component types?
	        this._stringText = nextStringText;
	        var commentNodes = this.getHostNode();
	        DOMChildrenOperations.replaceDelimitedText(commentNodes[0], commentNodes[1], nextStringText);
	      }
	    }
	  },
	
	  getHostNode: function () {
	    var hostNode = this._commentNodes;
	    if (hostNode) {
	      return hostNode;
	    }
	    if (!this._closingComment) {
	      var openingComment = ReactDOMComponentTree.getNodeFromInstance(this);
	      var node = openingComment.nextSibling;
	      while (true) {
	        !(node != null) ?  false ? invariant(false, 'Missing closing comment for text component %s', this._domID) : _prodInvariant('67', this._domID) : void 0;
	        if (node.nodeType === 8 && node.nodeValue === ' /react-text ') {
	          this._closingComment = node;
	          break;
	        }
	        node = node.nextSibling;
	      }
	    }
	    hostNode = [this._hostNode, this._closingComment];
	    this._commentNodes = hostNode;
	    return hostNode;
	  },
	
	  unmountComponent: function () {
	    this._closingComment = null;
	    this._commentNodes = null;
	    ReactDOMComponentTree.uncacheNode(this);
	  }
	});
	
	module.exports = ReactDOMTextComponent;

/***/ },
/* 989 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(29),
	    _assign = __webpack_require__(36);
	
	var LinkedValueUtils = __webpack_require__(253);
	var ReactDOMComponentTree = __webpack_require__(41);
	var ReactUpdates = __webpack_require__(74);
	
	var invariant = __webpack_require__(21);
	var warning = __webpack_require__(30);
	
	var didWarnValueLink = false;
	var didWarnValDefaultVal = false;
	
	function forceUpdateIfMounted() {
	  if (this._rootNodeID) {
	    // DOM component is still mounted; update
	    ReactDOMTextarea.updateWrapper(this);
	  }
	}
	
	/**
	 * Implements a <textarea> host component that allows setting `value`, and
	 * `defaultValue`. This differs from the traditional DOM API because value is
	 * usually set as PCDATA children.
	 *
	 * If `value` is not supplied (or null/undefined), user actions that affect the
	 * value will trigger updates to the element.
	 *
	 * If `value` is supplied (and not null/undefined), the rendered element will
	 * not trigger updates to the element. Instead, the `value` prop must change in
	 * order for the rendered element to be updated.
	 *
	 * The rendered element will be initialized with an empty value, the prop
	 * `defaultValue` if specified, or the children content (deprecated).
	 */
	var ReactDOMTextarea = {
	  getHostProps: function (inst, props) {
	    !(props.dangerouslySetInnerHTML == null) ?  false ? invariant(false, '`dangerouslySetInnerHTML` does not make sense on <textarea>.') : _prodInvariant('91') : void 0;
	
	    // Always set children to the same thing. In IE9, the selection range will
	    // get reset if `textContent` is mutated.  We could add a check in setTextContent
	    // to only set the value if/when the value differs from the node value (which would
	    // completely solve this IE9 bug), but Sebastian+Ben seemed to like this solution.
	    // The value can be a boolean or object so that's why it's forced to be a string.
	    var hostProps = _assign({}, props, {
	      value: undefined,
	      defaultValue: undefined,
	      children: '' + inst._wrapperState.initialValue,
	      onChange: inst._wrapperState.onChange
	    });
	
	    return hostProps;
	  },
	
	  mountWrapper: function (inst, props) {
	    if (false) {
	      LinkedValueUtils.checkPropTypes('textarea', props, inst._currentElement._owner);
	      if (props.valueLink !== undefined && !didWarnValueLink) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '`valueLink` prop on `textarea` is deprecated; set `value` and `onChange` instead.') : void 0;
	        didWarnValueLink = true;
	      }
	      if (props.value !== undefined && props.defaultValue !== undefined && !didWarnValDefaultVal) {
	        process.env.NODE_ENV !== 'production' ? warning(false, 'Textarea elements must be either controlled or uncontrolled ' + '(specify either the value prop, or the defaultValue prop, but not ' + 'both). Decide between using a controlled or uncontrolled textarea ' + 'and remove one of these props. More info: ' + 'https://fb.me/react-controlled-components') : void 0;
	        didWarnValDefaultVal = true;
	      }
	    }
	
	    var value = LinkedValueUtils.getValue(props);
	    var initialValue = value;
	
	    // Only bother fetching default value if we're going to use it
	    if (value == null) {
	      var defaultValue = props.defaultValue;
	      // TODO (yungsters): Remove support for children content in <textarea>.
	      var children = props.children;
	      if (children != null) {
	        if (false) {
	          process.env.NODE_ENV !== 'production' ? warning(false, 'Use the `defaultValue` or `value` props instead of setting ' + 'children on <textarea>.') : void 0;
	        }
	        !(defaultValue == null) ?  false ? invariant(false, 'If you supply `defaultValue` on a <textarea>, do not pass children.') : _prodInvariant('92') : void 0;
	        if (Array.isArray(children)) {
	          !(children.length <= 1) ?  false ? invariant(false, '<textarea> can only have at most one child.') : _prodInvariant('93') : void 0;
	          children = children[0];
	        }
	
	        defaultValue = '' + children;
	      }
	      if (defaultValue == null) {
	        defaultValue = '';
	      }
	      initialValue = defaultValue;
	    }
	
	    inst._wrapperState = {
	      initialValue: '' + initialValue,
	      listeners: null,
	      onChange: _handleChange.bind(inst)
	    };
	  },
	
	  updateWrapper: function (inst) {
	    var props = inst._currentElement.props;
	
	    var node = ReactDOMComponentTree.getNodeFromInstance(inst);
	    var value = LinkedValueUtils.getValue(props);
	    if (value != null) {
	      // Cast `value` to a string to ensure the value is set correctly. While
	      // browsers typically do this as necessary, jsdom doesn't.
	      var newValue = '' + value;
	
	      // To avoid side effects (such as losing text selection), only set value if changed
	      if (newValue !== node.value) {
	        node.value = newValue;
	      }
	      if (props.defaultValue == null) {
	        node.defaultValue = newValue;
	      }
	    }
	    if (props.defaultValue != null) {
	      node.defaultValue = props.defaultValue;
	    }
	  },
	
	  postMountWrapper: function (inst) {
	    // This is in postMount because we need access to the DOM node, which is not
	    // available until after the component has mounted.
	    var node = ReactDOMComponentTree.getNodeFromInstance(inst);
	    var textContent = node.textContent;
	
	    // Only set node.value if textContent is equal to the expected
	    // initial value. In IE10/IE11 there is a bug where the placeholder attribute
	    // will populate textContent as well.
	    // https://developer.microsoft.com/microsoft-edge/platform/issues/101525/
	    if (textContent === inst._wrapperState.initialValue) {
	      node.value = textContent;
	    }
	  }
	};
	
	function _handleChange(event) {
	  var props = this._currentElement.props;
	  var returnValue = LinkedValueUtils.executeOnChange(props, event);
	  ReactUpdates.asap(forceUpdateIfMounted, this);
	  return returnValue;
	}
	
	module.exports = ReactDOMTextarea;

/***/ },
/* 990 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2015-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(29);
	
	var invariant = __webpack_require__(21);
	
	/**
	 * Return the lowest common ancestor of A and B, or null if they are in
	 * different trees.
	 */
	function getLowestCommonAncestor(instA, instB) {
	  !('_hostNode' in instA) ?  false ? invariant(false, 'getNodeFromInstance: Invalid argument.') : _prodInvariant('33') : void 0;
	  !('_hostNode' in instB) ?  false ? invariant(false, 'getNodeFromInstance: Invalid argument.') : _prodInvariant('33') : void 0;
	
	  var depthA = 0;
	  for (var tempA = instA; tempA; tempA = tempA._hostParent) {
	    depthA++;
	  }
	  var depthB = 0;
	  for (var tempB = instB; tempB; tempB = tempB._hostParent) {
	    depthB++;
	  }
	
	  // If A is deeper, crawl up.
	  while (depthA - depthB > 0) {
	    instA = instA._hostParent;
	    depthA--;
	  }
	
	  // If B is deeper, crawl up.
	  while (depthB - depthA > 0) {
	    instB = instB._hostParent;
	    depthB--;
	  }
	
	  // Walk in lockstep until we find a match.
	  var depth = depthA;
	  while (depth--) {
	    if (instA === instB) {
	      return instA;
	    }
	    instA = instA._hostParent;
	    instB = instB._hostParent;
	  }
	  return null;
	}
	
	/**
	 * Return if A is an ancestor of B.
	 */
	function isAncestor(instA, instB) {
	  !('_hostNode' in instA) ?  false ? invariant(false, 'isAncestor: Invalid argument.') : _prodInvariant('35') : void 0;
	  !('_hostNode' in instB) ?  false ? invariant(false, 'isAncestor: Invalid argument.') : _prodInvariant('35') : void 0;
	
	  while (instB) {
	    if (instB === instA) {
	      return true;
	    }
	    instB = instB._hostParent;
	  }
	  return false;
	}
	
	/**
	 * Return the parent instance of the passed-in instance.
	 */
	function getParentInstance(inst) {
	  !('_hostNode' in inst) ?  false ? invariant(false, 'getParentInstance: Invalid argument.') : _prodInvariant('36') : void 0;
	
	  return inst._hostParent;
	}
	
	/**
	 * Simulates the traversal of a two-phase, capture/bubble event dispatch.
	 */
	function traverseTwoPhase(inst, fn, arg) {
	  var path = [];
	  while (inst) {
	    path.push(inst);
	    inst = inst._hostParent;
	  }
	  var i;
	  for (i = path.length; i-- > 0;) {
	    fn(path[i], 'captured', arg);
	  }
	  for (i = 0; i < path.length; i++) {
	    fn(path[i], 'bubbled', arg);
	  }
	}
	
	/**
	 * Traverses the ID hierarchy and invokes the supplied `cb` on any IDs that
	 * should would receive a `mouseEnter` or `mouseLeave` event.
	 *
	 * Does not invoke the callback on the nearest common ancestor because nothing
	 * "entered" or "left" that element.
	 */
	function traverseEnterLeave(from, to, fn, argFrom, argTo) {
	  var common = from && to ? getLowestCommonAncestor(from, to) : null;
	  var pathFrom = [];
	  while (from && from !== common) {
	    pathFrom.push(from);
	    from = from._hostParent;
	  }
	  var pathTo = [];
	  while (to && to !== common) {
	    pathTo.push(to);
	    to = to._hostParent;
	  }
	  var i;
	  for (i = 0; i < pathFrom.length; i++) {
	    fn(pathFrom[i], 'bubbled', argFrom);
	  }
	  for (i = pathTo.length; i-- > 0;) {
	    fn(pathTo[i], 'captured', argTo);
	  }
	}
	
	module.exports = {
	  isAncestor: isAncestor,
	  getLowestCommonAncestor: getLowestCommonAncestor,
	  getParentInstance: getParentInstance,
	  traverseTwoPhase: traverseTwoPhase,
	  traverseEnterLeave: traverseEnterLeave
	};

/***/ },
/* 991 */
428,
/* 992 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var EventPluginHub = __webpack_require__(144);
	
	function runEventQueueInBatch(events) {
	  EventPluginHub.enqueueEvents(events);
	  EventPluginHub.processEventQueue(false);
	}
	
	var ReactEventEmitterMixin = {
	  /**
	   * Streams a fired top-level event to `EventPluginHub` where plugins have the
	   * opportunity to create `ReactEvent`s to be dispatched.
	   */
	  handleTopLevel: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	    var events = EventPluginHub.extractEvents(topLevelType, targetInst, nativeEvent, nativeEventTarget);
	    runEventQueueInBatch(events);
	  }
	};
	
	module.exports = ReactEventEmitterMixin;

/***/ },
/* 993 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(36);
	
	var EventListener = __webpack_require__(329);
	var ExecutionEnvironment = __webpack_require__(51);
	var PooledClass = __webpack_require__(113);
	var ReactDOMComponentTree = __webpack_require__(41);
	var ReactUpdates = __webpack_require__(74);
	
	var getEventTarget = __webpack_require__(260);
	var getUnboundedScrollPosition = __webpack_require__(827);
	
	/**
	 * Find the deepest React component completely containing the root of the
	 * passed-in instance (for use when entire React trees are nested within each
	 * other). If React trees are not nested, returns null.
	 */
	function findParent(inst) {
	  // TODO: It may be a good idea to cache this to prevent unnecessary DOM
	  // traversal, but caching is difficult to do correctly without using a
	  // mutation observer to listen for all DOM changes.
	  while (inst._hostParent) {
	    inst = inst._hostParent;
	  }
	  var rootNode = ReactDOMComponentTree.getNodeFromInstance(inst);
	  var container = rootNode.parentNode;
	  return ReactDOMComponentTree.getClosestInstanceFromNode(container);
	}
	
	// Used to store ancestor hierarchy in top level callback
	function TopLevelCallbackBookKeeping(topLevelType, nativeEvent) {
	  this.topLevelType = topLevelType;
	  this.nativeEvent = nativeEvent;
	  this.ancestors = [];
	}
	_assign(TopLevelCallbackBookKeeping.prototype, {
	  destructor: function () {
	    this.topLevelType = null;
	    this.nativeEvent = null;
	    this.ancestors.length = 0;
	  }
	});
	PooledClass.addPoolingTo(TopLevelCallbackBookKeeping, PooledClass.twoArgumentPooler);
	
	function handleTopLevelImpl(bookKeeping) {
	  var nativeEventTarget = getEventTarget(bookKeeping.nativeEvent);
	  var targetInst = ReactDOMComponentTree.getClosestInstanceFromNode(nativeEventTarget);
	
	  // Loop through the hierarchy, in case there's any nested components.
	  // It's important that we build the array of ancestors before calling any
	  // event handlers, because event handlers can modify the DOM, leading to
	  // inconsistencies with ReactMount's node cache. See #1105.
	  var ancestor = targetInst;
	  do {
	    bookKeeping.ancestors.push(ancestor);
	    ancestor = ancestor && findParent(ancestor);
	  } while (ancestor);
	
	  for (var i = 0; i < bookKeeping.ancestors.length; i++) {
	    targetInst = bookKeeping.ancestors[i];
	    ReactEventListener._handleTopLevel(bookKeeping.topLevelType, targetInst, bookKeeping.nativeEvent, getEventTarget(bookKeeping.nativeEvent));
	  }
	}
	
	function scrollValueMonitor(cb) {
	  var scrollPosition = getUnboundedScrollPosition(window);
	  cb(scrollPosition);
	}
	
	var ReactEventListener = {
	  _enabled: true,
	  _handleTopLevel: null,
	
	  WINDOW_HANDLE: ExecutionEnvironment.canUseDOM ? window : null,
	
	  setHandleTopLevel: function (handleTopLevel) {
	    ReactEventListener._handleTopLevel = handleTopLevel;
	  },
	
	  setEnabled: function (enabled) {
	    ReactEventListener._enabled = !!enabled;
	  },
	
	  isEnabled: function () {
	    return ReactEventListener._enabled;
	  },
	
	  /**
	   * Traps top-level events by using event bubbling.
	   *
	   * @param {string} topLevelType Record from `EventConstants`.
	   * @param {string} handlerBaseName Event name (e.g. "click").
	   * @param {object} element Element on which to attach listener.
	   * @return {?object} An object with a remove function which will forcefully
	   *                  remove the listener.
	   * @internal
	   */
	  trapBubbledEvent: function (topLevelType, handlerBaseName, element) {
	    if (!element) {
	      return null;
	    }
	    return EventListener.listen(element, handlerBaseName, ReactEventListener.dispatchEvent.bind(null, topLevelType));
	  },
	
	  /**
	   * Traps a top-level event by using event capturing.
	   *
	   * @param {string} topLevelType Record from `EventConstants`.
	   * @param {string} handlerBaseName Event name (e.g. "click").
	   * @param {object} element Element on which to attach listener.
	   * @return {?object} An object with a remove function which will forcefully
	   *                  remove the listener.
	   * @internal
	   */
	  trapCapturedEvent: function (topLevelType, handlerBaseName, element) {
	    if (!element) {
	      return null;
	    }
	    return EventListener.capture(element, handlerBaseName, ReactEventListener.dispatchEvent.bind(null, topLevelType));
	  },
	
	  monitorScrollValue: function (refresh) {
	    var callback = scrollValueMonitor.bind(null, refresh);
	    EventListener.listen(window, 'scroll', callback);
	  },
	
	  dispatchEvent: function (topLevelType, nativeEvent) {
	    if (!ReactEventListener._enabled) {
	      return;
	    }
	
	    var bookKeeping = TopLevelCallbackBookKeeping.getPooled(topLevelType, nativeEvent);
	    try {
	      // Event queue being processed in the same cycle allows
	      // `preventDefault`.
	      ReactUpdates.batchedUpdates(handleTopLevelImpl, bookKeeping);
	    } finally {
	      TopLevelCallbackBookKeeping.release(bookKeeping);
	    }
	  }
	};
	
	module.exports = ReactEventListener;

/***/ },
/* 994 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var DOMProperty = __webpack_require__(128);
	var EventPluginHub = __webpack_require__(144);
	var EventPluginUtils = __webpack_require__(251);
	var ReactComponentEnvironment = __webpack_require__(254);
	var ReactEmptyComponent = __webpack_require__(390);
	var ReactBrowserEventEmitter = __webpack_require__(184);
	var ReactHostComponent = __webpack_require__(392);
	var ReactUpdates = __webpack_require__(74);
	
	var ReactInjection = {
	  Component: ReactComponentEnvironment.injection,
	  DOMProperty: DOMProperty.injection,
	  EmptyComponent: ReactEmptyComponent.injection,
	  EventPluginHub: EventPluginHub.injection,
	  EventPluginUtils: EventPluginUtils.injection,
	  EventEmitter: ReactBrowserEventEmitter.injection,
	  HostComponent: ReactHostComponent.injection,
	  Updates: ReactUpdates.injection
	};
	
	module.exports = ReactInjection;

/***/ },
/* 995 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(29);
	
	var ReactComponentEnvironment = __webpack_require__(254);
	var ReactInstanceMap = __webpack_require__(146);
	var ReactInstrumentation = __webpack_require__(62);
	
	var ReactCurrentOwner = __webpack_require__(92);
	var ReactReconciler = __webpack_require__(114);
	var ReactChildReconciler = __webpack_require__(976);
	
	var emptyFunction = __webpack_require__(80);
	var flattenChildren = __webpack_require__(1019);
	var invariant = __webpack_require__(21);
	
	/**
	 * Make an update for markup to be rendered and inserted at a supplied index.
	 *
	 * @param {string} markup Markup that renders into an element.
	 * @param {number} toIndex Destination index.
	 * @private
	 */
	function makeInsertMarkup(markup, afterNode, toIndex) {
	  // NOTE: Null values reduce hidden classes.
	  return {
	    type: 'INSERT_MARKUP',
	    content: markup,
	    fromIndex: null,
	    fromNode: null,
	    toIndex: toIndex,
	    afterNode: afterNode
	  };
	}
	
	/**
	 * Make an update for moving an existing element to another index.
	 *
	 * @param {number} fromIndex Source index of the existing element.
	 * @param {number} toIndex Destination index of the element.
	 * @private
	 */
	function makeMove(child, afterNode, toIndex) {
	  // NOTE: Null values reduce hidden classes.
	  return {
	    type: 'MOVE_EXISTING',
	    content: null,
	    fromIndex: child._mountIndex,
	    fromNode: ReactReconciler.getHostNode(child),
	    toIndex: toIndex,
	    afterNode: afterNode
	  };
	}
	
	/**
	 * Make an update for removing an element at an index.
	 *
	 * @param {number} fromIndex Index of the element to remove.
	 * @private
	 */
	function makeRemove(child, node) {
	  // NOTE: Null values reduce hidden classes.
	  return {
	    type: 'REMOVE_NODE',
	    content: null,
	    fromIndex: child._mountIndex,
	    fromNode: node,
	    toIndex: null,
	    afterNode: null
	  };
	}
	
	/**
	 * Make an update for setting the markup of a node.
	 *
	 * @param {string} markup Markup that renders into an element.
	 * @private
	 */
	function makeSetMarkup(markup) {
	  // NOTE: Null values reduce hidden classes.
	  return {
	    type: 'SET_MARKUP',
	    content: markup,
	    fromIndex: null,
	    fromNode: null,
	    toIndex: null,
	    afterNode: null
	  };
	}
	
	/**
	 * Make an update for setting the text content.
	 *
	 * @param {string} textContent Text content to set.
	 * @private
	 */
	function makeTextContent(textContent) {
	  // NOTE: Null values reduce hidden classes.
	  return {
	    type: 'TEXT_CONTENT',
	    content: textContent,
	    fromIndex: null,
	    fromNode: null,
	    toIndex: null,
	    afterNode: null
	  };
	}
	
	/**
	 * Push an update, if any, onto the queue. Creates a new queue if none is
	 * passed and always returns the queue. Mutative.
	 */
	function enqueue(queue, update) {
	  if (update) {
	    queue = queue || [];
	    queue.push(update);
	  }
	  return queue;
	}
	
	/**
	 * Processes any enqueued updates.
	 *
	 * @private
	 */
	function processQueue(inst, updateQueue) {
	  ReactComponentEnvironment.processChildrenUpdates(inst, updateQueue);
	}
	
	var setChildrenForInstrumentation = emptyFunction;
	if (false) {
	  var getDebugID = function (inst) {
	    if (!inst._debugID) {
	      // Check for ART-like instances. TODO: This is silly/gross.
	      var internal;
	      if (internal = ReactInstanceMap.get(inst)) {
	        inst = internal;
	      }
	    }
	    return inst._debugID;
	  };
	  setChildrenForInstrumentation = function (children) {
	    var debugID = getDebugID(this);
	    // TODO: React Native empty components are also multichild.
	    // This means they still get into this method but don't have _debugID.
	    if (debugID !== 0) {
	      ReactInstrumentation.debugTool.onSetChildren(debugID, children ? Object.keys(children).map(function (key) {
	        return children[key]._debugID;
	      }) : []);
	    }
	  };
	}
	
	/**
	 * ReactMultiChild are capable of reconciling multiple children.
	 *
	 * @class ReactMultiChild
	 * @internal
	 */
	var ReactMultiChild = {
	  /**
	   * Provides common functionality for components that must reconcile multiple
	   * children. This is used by `ReactDOMComponent` to mount, update, and
	   * unmount child components.
	   *
	   * @lends {ReactMultiChild.prototype}
	   */
	  Mixin: {
	    _reconcilerInstantiateChildren: function (nestedChildren, transaction, context) {
	      if (false) {
	        var selfDebugID = getDebugID(this);
	        if (this._currentElement) {
	          try {
	            ReactCurrentOwner.current = this._currentElement._owner;
	            return ReactChildReconciler.instantiateChildren(nestedChildren, transaction, context, selfDebugID);
	          } finally {
	            ReactCurrentOwner.current = null;
	          }
	        }
	      }
	      return ReactChildReconciler.instantiateChildren(nestedChildren, transaction, context);
	    },
	
	    _reconcilerUpdateChildren: function (prevChildren, nextNestedChildrenElements, mountImages, removedNodes, transaction, context) {
	      var nextChildren;
	      var selfDebugID = 0;
	      if (false) {
	        selfDebugID = getDebugID(this);
	        if (this._currentElement) {
	          try {
	            ReactCurrentOwner.current = this._currentElement._owner;
	            nextChildren = flattenChildren(nextNestedChildrenElements, selfDebugID);
	          } finally {
	            ReactCurrentOwner.current = null;
	          }
	          ReactChildReconciler.updateChildren(prevChildren, nextChildren, mountImages, removedNodes, transaction, this, this._hostContainerInfo, context, selfDebugID);
	          return nextChildren;
	        }
	      }
	      nextChildren = flattenChildren(nextNestedChildrenElements, selfDebugID);
	      ReactChildReconciler.updateChildren(prevChildren, nextChildren, mountImages, removedNodes, transaction, this, this._hostContainerInfo, context, selfDebugID);
	      return nextChildren;
	    },
	
	    /**
	     * Generates a "mount image" for each of the supplied children. In the case
	     * of `ReactDOMComponent`, a mount image is a string of markup.
	     *
	     * @param {?object} nestedChildren Nested child maps.
	     * @return {array} An array of mounted representations.
	     * @internal
	     */
	    mountChildren: function (nestedChildren, transaction, context) {
	      var children = this._reconcilerInstantiateChildren(nestedChildren, transaction, context);
	      this._renderedChildren = children;
	
	      var mountImages = [];
	      var index = 0;
	      for (var name in children) {
	        if (children.hasOwnProperty(name)) {
	          var child = children[name];
	          var selfDebugID = 0;
	          if (false) {
	            selfDebugID = getDebugID(this);
	          }
	          var mountImage = ReactReconciler.mountComponent(child, transaction, this, this._hostContainerInfo, context, selfDebugID);
	          child._mountIndex = index++;
	          mountImages.push(mountImage);
	        }
	      }
	
	      if (false) {
	        setChildrenForInstrumentation.call(this, children);
	      }
	
	      return mountImages;
	    },
	
	    /**
	     * Replaces any rendered children with a text content string.
	     *
	     * @param {string} nextContent String of content.
	     * @internal
	     */
	    updateTextContent: function (nextContent) {
	      var prevChildren = this._renderedChildren;
	      // Remove any rendered children.
	      ReactChildReconciler.unmountChildren(prevChildren, false);
	      for (var name in prevChildren) {
	        if (prevChildren.hasOwnProperty(name)) {
	           true ?  false ? invariant(false, 'updateTextContent called on non-empty component.') : _prodInvariant('118') : void 0;
	        }
	      }
	      // Set new text content.
	      var updates = [makeTextContent(nextContent)];
	      processQueue(this, updates);
	    },
	
	    /**
	     * Replaces any rendered children with a markup string.
	     *
	     * @param {string} nextMarkup String of markup.
	     * @internal
	     */
	    updateMarkup: function (nextMarkup) {
	      var prevChildren = this._renderedChildren;
	      // Remove any rendered children.
	      ReactChildReconciler.unmountChildren(prevChildren, false);
	      for (var name in prevChildren) {
	        if (prevChildren.hasOwnProperty(name)) {
	           true ?  false ? invariant(false, 'updateTextContent called on non-empty component.') : _prodInvariant('118') : void 0;
	        }
	      }
	      var updates = [makeSetMarkup(nextMarkup)];
	      processQueue(this, updates);
	    },
	
	    /**
	     * Updates the rendered children with new children.
	     *
	     * @param {?object} nextNestedChildrenElements Nested child element maps.
	     * @param {ReactReconcileTransaction} transaction
	     * @internal
	     */
	    updateChildren: function (nextNestedChildrenElements, transaction, context) {
	      // Hook used by React ART
	      this._updateChildren(nextNestedChildrenElements, transaction, context);
	    },
	
	    /**
	     * @param {?object} nextNestedChildrenElements Nested child element maps.
	     * @param {ReactReconcileTransaction} transaction
	     * @final
	     * @protected
	     */
	    _updateChildren: function (nextNestedChildrenElements, transaction, context) {
	      var prevChildren = this._renderedChildren;
	      var removedNodes = {};
	      var mountImages = [];
	      var nextChildren = this._reconcilerUpdateChildren(prevChildren, nextNestedChildrenElements, mountImages, removedNodes, transaction, context);
	      if (!nextChildren && !prevChildren) {
	        return;
	      }
	      var updates = null;
	      var name;
	      // `nextIndex` will increment for each child in `nextChildren`, but
	      // `lastIndex` will be the last index visited in `prevChildren`.
	      var nextIndex = 0;
	      var lastIndex = 0;
	      // `nextMountIndex` will increment for each newly mounted child.
	      var nextMountIndex = 0;
	      var lastPlacedNode = null;
	      for (name in nextChildren) {
	        if (!nextChildren.hasOwnProperty(name)) {
	          continue;
	        }
	        var prevChild = prevChildren && prevChildren[name];
	        var nextChild = nextChildren[name];
	        if (prevChild === nextChild) {
	          updates = enqueue(updates, this.moveChild(prevChild, lastPlacedNode, nextIndex, lastIndex));
	          lastIndex = Math.max(prevChild._mountIndex, lastIndex);
	          prevChild._mountIndex = nextIndex;
	        } else {
	          if (prevChild) {
	            // Update `lastIndex` before `_mountIndex` gets unset by unmounting.
	            lastIndex = Math.max(prevChild._mountIndex, lastIndex);
	            // The `removedNodes` loop below will actually remove the child.
	          }
	          // The child must be instantiated before it's mounted.
	          updates = enqueue(updates, this._mountChildAtIndex(nextChild, mountImages[nextMountIndex], lastPlacedNode, nextIndex, transaction, context));
	          nextMountIndex++;
	        }
	        nextIndex++;
	        lastPlacedNode = ReactReconciler.getHostNode(nextChild);
	      }
	      // Remove children that are no longer present.
	      for (name in removedNodes) {
	        if (removedNodes.hasOwnProperty(name)) {
	          updates = enqueue(updates, this._unmountChild(prevChildren[name], removedNodes[name]));
	        }
	      }
	      if (updates) {
	        processQueue(this, updates);
	      }
	      this._renderedChildren = nextChildren;
	
	      if (false) {
	        setChildrenForInstrumentation.call(this, nextChildren);
	      }
	    },
	
	    /**
	     * Unmounts all rendered children. This should be used to clean up children
	     * when this component is unmounted. It does not actually perform any
	     * backend operations.
	     *
	     * @internal
	     */
	    unmountChildren: function (safely) {
	      var renderedChildren = this._renderedChildren;
	      ReactChildReconciler.unmountChildren(renderedChildren, safely);
	      this._renderedChildren = null;
	    },
	
	    /**
	     * Moves a child component to the supplied index.
	     *
	     * @param {ReactComponent} child Component to move.
	     * @param {number} toIndex Destination index of the element.
	     * @param {number} lastIndex Last index visited of the siblings of `child`.
	     * @protected
	     */
	    moveChild: function (child, afterNode, toIndex, lastIndex) {
	      // If the index of `child` is less than `lastIndex`, then it needs to
	      // be moved. Otherwise, we do not need to move it because a child will be
	      // inserted or moved before `child`.
	      if (child._mountIndex < lastIndex) {
	        return makeMove(child, afterNode, toIndex);
	      }
	    },
	
	    /**
	     * Creates a child component.
	     *
	     * @param {ReactComponent} child Component to create.
	     * @param {string} mountImage Markup to insert.
	     * @protected
	     */
	    createChild: function (child, afterNode, mountImage) {
	      return makeInsertMarkup(mountImage, afterNode, child._mountIndex);
	    },
	
	    /**
	     * Removes a child component.
	     *
	     * @param {ReactComponent} child Child to remove.
	     * @protected
	     */
	    removeChild: function (child, node) {
	      return makeRemove(child, node);
	    },
	
	    /**
	     * Mounts a child with the supplied name.
	     *
	     * NOTE: This is part of `updateChildren` and is here for readability.
	     *
	     * @param {ReactComponent} child Component to mount.
	     * @param {string} name Name of the child.
	     * @param {number} index Index at which to insert the child.
	     * @param {ReactReconcileTransaction} transaction
	     * @private
	     */
	    _mountChildAtIndex: function (child, mountImage, afterNode, index, transaction, context) {
	      child._mountIndex = index;
	      return this.createChild(child, afterNode, mountImage);
	    },
	
	    /**
	     * Unmounts a rendered child.
	     *
	     * NOTE: This is part of `updateChildren` and is here for readability.
	     *
	     * @param {ReactComponent} child Component to unmount.
	     * @private
	     */
	    _unmountChild: function (child, node) {
	      var update = this.removeChild(child, node);
	      child._mountIndex = null;
	      return update;
	    }
	  }
	};
	
	module.exports = ReactMultiChild;

/***/ },
/* 996 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(29);
	
	var invariant = __webpack_require__(21);
	
	/**
	 * @param {?object} object
	 * @return {boolean} True if `object` is a valid owner.
	 * @final
	 */
	function isValidOwner(object) {
	  return !!(object && typeof object.attachRef === 'function' && typeof object.detachRef === 'function');
	}
	
	/**
	 * ReactOwners are capable of storing references to owned components.
	 *
	 * All components are capable of //being// referenced by owner components, but
	 * only ReactOwner components are capable of //referencing// owned components.
	 * The named reference is known as a "ref".
	 *
	 * Refs are available when mounted and updated during reconciliation.
	 *
	 *   var MyComponent = React.createClass({
	 *     render: function() {
	 *       return (
	 *         <div onClick={this.handleClick}>
	 *           <CustomComponent ref="custom" />
	 *         </div>
	 *       );
	 *     },
	 *     handleClick: function() {
	 *       this.refs.custom.handleClick();
	 *     },
	 *     componentDidMount: function() {
	 *       this.refs.custom.initialize();
	 *     }
	 *   });
	 *
	 * Refs should rarely be used. When refs are used, they should only be done to
	 * control data that is not handled by React's data flow.
	 *
	 * @class ReactOwner
	 */
	var ReactOwner = {
	  /**
	   * Adds a component by ref to an owner component.
	   *
	   * @param {ReactComponent} component Component to reference.
	   * @param {string} ref Name by which to refer to the component.
	   * @param {ReactOwner} owner Component on which to record the ref.
	   * @final
	   * @internal
	   */
	  addComponentAsRefTo: function (component, ref, owner) {
	    !isValidOwner(owner) ?  false ? invariant(false, 'addComponentAsRefTo(...): Only a ReactOwner can have refs. You might be adding a ref to a component that was not created inside a component\'s `render` method, or you have multiple copies of React loaded (details: https://fb.me/react-refs-must-have-owner).') : _prodInvariant('119') : void 0;
	    owner.attachRef(ref, component);
	  },
	
	  /**
	   * Removes a component by ref from an owner component.
	   *
	   * @param {ReactComponent} component Component to dereference.
	   * @param {string} ref Name of the ref to remove.
	   * @param {ReactOwner} owner Component on which the ref is recorded.
	   * @final
	   * @internal
	   */
	  removeComponentAsRefFrom: function (component, ref, owner) {
	    !isValidOwner(owner) ?  false ? invariant(false, 'removeComponentAsRefFrom(...): Only a ReactOwner can have refs. You might be removing a ref to a component that was not created inside a component\'s `render` method, or you have multiple copies of React loaded (details: https://fb.me/react-refs-must-have-owner).') : _prodInvariant('120') : void 0;
	    var ownerPublicInstance = owner.getPublicInstance();
	    // Check that `component`'s owner is still alive and that `component` is still the current ref
	    // because we do not want to detach the ref if another component stole it.
	    if (ownerPublicInstance && ownerPublicInstance.refs[ref] === component.getPublicInstance()) {
	      owner.detachRef(ref);
	    }
	  }
	};
	
	module.exports = ReactOwner;

/***/ },
/* 997 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';
	
	module.exports = ReactPropTypesSecret;

/***/ },
/* 998 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(36);
	
	var CallbackQueue = __webpack_require__(383);
	var PooledClass = __webpack_require__(113);
	var ReactBrowserEventEmitter = __webpack_require__(184);
	var ReactInputSelection = __webpack_require__(393);
	var ReactInstrumentation = __webpack_require__(62);
	var Transaction = __webpack_require__(186);
	var ReactUpdateQueue = __webpack_require__(256);
	
	/**
	 * Ensures that, when possible, the selection range (currently selected text
	 * input) is not disturbed by performing the transaction.
	 */
	var SELECTION_RESTORATION = {
	  /**
	   * @return {Selection} Selection information.
	   */
	  initialize: ReactInputSelection.getSelectionInformation,
	  /**
	   * @param {Selection} sel Selection information returned from `initialize`.
	   */
	  close: ReactInputSelection.restoreSelection
	};
	
	/**
	 * Suppresses events (blur/focus) that could be inadvertently dispatched due to
	 * high level DOM manipulations (like temporarily removing a text input from the
	 * DOM).
	 */
	var EVENT_SUPPRESSION = {
	  /**
	   * @return {boolean} The enabled status of `ReactBrowserEventEmitter` before
	   * the reconciliation.
	   */
	  initialize: function () {
	    var currentlyEnabled = ReactBrowserEventEmitter.isEnabled();
	    ReactBrowserEventEmitter.setEnabled(false);
	    return currentlyEnabled;
	  },
	
	  /**
	   * @param {boolean} previouslyEnabled Enabled status of
	   *   `ReactBrowserEventEmitter` before the reconciliation occurred. `close`
	   *   restores the previous value.
	   */
	  close: function (previouslyEnabled) {
	    ReactBrowserEventEmitter.setEnabled(previouslyEnabled);
	  }
	};
	
	/**
	 * Provides a queue for collecting `componentDidMount` and
	 * `componentDidUpdate` callbacks during the transaction.
	 */
	var ON_DOM_READY_QUEUEING = {
	  /**
	   * Initializes the internal `onDOMReady` queue.
	   */
	  initialize: function () {
	    this.reactMountReady.reset();
	  },
	
	  /**
	   * After DOM is flushed, invoke all registered `onDOMReady` callbacks.
	   */
	  close: function () {
	    this.reactMountReady.notifyAll();
	  }
	};
	
	/**
	 * Executed within the scope of the `Transaction` instance. Consider these as
	 * being member methods, but with an implied ordering while being isolated from
	 * each other.
	 */
	var TRANSACTION_WRAPPERS = [SELECTION_RESTORATION, EVENT_SUPPRESSION, ON_DOM_READY_QUEUEING];
	
	if (false) {
	  TRANSACTION_WRAPPERS.push({
	    initialize: ReactInstrumentation.debugTool.onBeginFlush,
	    close: ReactInstrumentation.debugTool.onEndFlush
	  });
	}
	
	/**
	 * Currently:
	 * - The order that these are listed in the transaction is critical:
	 * - Suppresses events.
	 * - Restores selection range.
	 *
	 * Future:
	 * - Restore document/overflow scroll positions that were unintentionally
	 *   modified via DOM insertions above the top viewport boundary.
	 * - Implement/integrate with customized constraint based layout system and keep
	 *   track of which dimensions must be remeasured.
	 *
	 * @class ReactReconcileTransaction
	 */
	function ReactReconcileTransaction(useCreateElement) {
	  this.reinitializeTransaction();
	  // Only server-side rendering really needs this option (see
	  // `ReactServerRendering`), but server-side uses
	  // `ReactServerRenderingTransaction` instead. This option is here so that it's
	  // accessible and defaults to false when `ReactDOMComponent` and
	  // `ReactDOMTextComponent` checks it in `mountComponent`.`
	  this.renderToStaticMarkup = false;
	  this.reactMountReady = CallbackQueue.getPooled(null);
	  this.useCreateElement = useCreateElement;
	}
	
	var Mixin = {
	  /**
	   * @see Transaction
	   * @abstract
	   * @final
	   * @return {array<object>} List of operation wrap procedures.
	   *   TODO: convert to array<TransactionWrapper>
	   */
	  getTransactionWrappers: function () {
	    return TRANSACTION_WRAPPERS;
	  },
	
	  /**
	   * @return {object} The queue to collect `onDOMReady` callbacks with.
	   */
	  getReactMountReady: function () {
	    return this.reactMountReady;
	  },
	
	  /**
	   * @return {object} The queue to collect React async events.
	   */
	  getUpdateQueue: function () {
	    return ReactUpdateQueue;
	  },
	
	  /**
	   * Save current transaction state -- if the return value from this method is
	   * passed to `rollback`, the transaction will be reset to that state.
	   */
	  checkpoint: function () {
	    // reactMountReady is the our only stateful wrapper
	    return this.reactMountReady.checkpoint();
	  },
	
	  rollback: function (checkpoint) {
	    this.reactMountReady.rollback(checkpoint);
	  },
	
	  /**
	   * `PooledClass` looks for this, and will invoke this before allowing this
	   * instance to be reused.
	   */
	  destructor: function () {
	    CallbackQueue.release(this.reactMountReady);
	    this.reactMountReady = null;
	  }
	};
	
	_assign(ReactReconcileTransaction.prototype, Transaction, Mixin);
	
	PooledClass.addPoolingTo(ReactReconcileTransaction);
	
	module.exports = ReactReconcileTransaction;

/***/ },
/* 999 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var ReactOwner = __webpack_require__(996);
	
	var ReactRef = {};
	
	function attachRef(ref, component, owner) {
	  if (typeof ref === 'function') {
	    ref(component.getPublicInstance());
	  } else {
	    // Legacy ref
	    ReactOwner.addComponentAsRefTo(component, ref, owner);
	  }
	}
	
	function detachRef(ref, component, owner) {
	  if (typeof ref === 'function') {
	    ref(null);
	  } else {
	    // Legacy ref
	    ReactOwner.removeComponentAsRefFrom(component, ref, owner);
	  }
	}
	
	ReactRef.attachRefs = function (instance, element) {
	  if (element === null || typeof element !== 'object') {
	    return;
	  }
	  var ref = element.ref;
	  if (ref != null) {
	    attachRef(ref, instance, element._owner);
	  }
	};
	
	ReactRef.shouldUpdateRefs = function (prevElement, nextElement) {
	  // If either the owner or a `ref` has changed, make sure the newest owner
	  // has stored a reference to `this`, and the previous owner (if different)
	  // has forgotten the reference to `this`. We use the element instead
	  // of the public this.props because the post processing cannot determine
	  // a ref. The ref conceptually lives on the element.
	
	  // TODO: Should this even be possible? The owner cannot change because
	  // it's forbidden by shouldUpdateReactComponent. The ref can change
	  // if you swap the keys of but not the refs. Reconsider where this check
	  // is made. It probably belongs where the key checking and
	  // instantiateReactComponent is done.
	
	  var prevRef = null;
	  var prevOwner = null;
	  if (prevElement !== null && typeof prevElement === 'object') {
	    prevRef = prevElement.ref;
	    prevOwner = prevElement._owner;
	  }
	
	  var nextRef = null;
	  var nextOwner = null;
	  if (nextElement !== null && typeof nextElement === 'object') {
	    nextRef = nextElement.ref;
	    nextOwner = nextElement._owner;
	  }
	
	  return prevRef !== nextRef ||
	  // If owner changes but we have an unchanged function ref, don't update refs
	  typeof nextRef === 'string' && nextOwner !== prevOwner;
	};
	
	ReactRef.detachRefs = function (instance, element) {
	  if (element === null || typeof element !== 'object') {
	    return;
	  }
	  var ref = element.ref;
	  if (ref != null) {
	    detachRef(ref, instance, element._owner);
	  }
	};
	
	module.exports = ReactRef;

/***/ },
/* 1000 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2014-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ReactServerBatchingStrategy = {
	  isBatchingUpdates: false,
	  batchedUpdates: function (callback) {
	    // Don't do anything here. During the server rendering we don't want to
	    // schedule any updates. We will simply ignore them.
	  }
	};
	
	module.exports = ReactServerBatchingStrategy;

/***/ },
/* 1001 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	'use strict';
	
	var _prodInvariant = __webpack_require__(29);
	
	var React = __webpack_require__(115);
	var ReactDOMContainerInfo = __webpack_require__(386);
	var ReactDefaultBatchingStrategy = __webpack_require__(388);
	var ReactInstrumentation = __webpack_require__(62);
	var ReactMarkupChecksum = __webpack_require__(394);
	var ReactReconciler = __webpack_require__(114);
	var ReactServerBatchingStrategy = __webpack_require__(1000);
	var ReactServerRenderingTransaction = __webpack_require__(397);
	var ReactUpdates = __webpack_require__(74);
	
	var emptyObject = __webpack_require__(141);
	var instantiateReactComponent = __webpack_require__(261);
	var invariant = __webpack_require__(21);
	
	var pendingTransactions = 0;
	
	/**
	 * @param {ReactElement} element
	 * @return {string} the HTML markup
	 */
	function renderToStringImpl(element, makeStaticMarkup) {
	  var transaction;
	  try {
	    ReactUpdates.injection.injectBatchingStrategy(ReactServerBatchingStrategy);
	
	    transaction = ReactServerRenderingTransaction.getPooled(makeStaticMarkup);
	
	    pendingTransactions++;
	
	    return transaction.perform(function () {
	      var componentInstance = instantiateReactComponent(element, true);
	      var markup = ReactReconciler.mountComponent(componentInstance, transaction, null, ReactDOMContainerInfo(), emptyObject, 0 /* parentDebugID */
	      );
	      if (false) {
	        ReactInstrumentation.debugTool.onUnmountComponent(componentInstance._debugID);
	      }
	      if (!makeStaticMarkup) {
	        markup = ReactMarkupChecksum.addChecksumToMarkup(markup);
	      }
	      return markup;
	    }, null);
	  } finally {
	    pendingTransactions--;
	    ReactServerRenderingTransaction.release(transaction);
	    // Revert to the DOM batching strategy since these two renderers
	    // currently share these stateful modules.
	    if (!pendingTransactions) {
	      ReactUpdates.injection.injectBatchingStrategy(ReactDefaultBatchingStrategy);
	    }
	  }
	}
	
	/**
	 * Render a ReactElement to its initial HTML. This should only be used on the
	 * server.
	 * See https://facebook.github.io/react/docs/top-level-api.html#reactdomserver.rendertostring
	 */
	function renderToString(element) {
	  !React.isValidElement(element) ?  false ? invariant(false, 'renderToString(): You must pass a valid ReactElement.') : _prodInvariant('46') : void 0;
	  return renderToStringImpl(element, false);
	}
	
	/**
	 * Similar to renderToString, except this doesn't create extra DOM attributes
	 * such as data-react-id that React uses internally.
	 * See https://facebook.github.io/react/docs/top-level-api.html#reactdomserver.rendertostaticmarkup
	 */
	function renderToStaticMarkup(element) {
	  !React.isValidElement(element) ?  false ? invariant(false, 'renderToStaticMarkup(): You must pass a valid ReactElement.') : _prodInvariant('47') : void 0;
	  return renderToStringImpl(element, true);
	}
	
	module.exports = {
	  renderToString: renderToString,
	  renderToStaticMarkup: renderToStaticMarkup
	};

/***/ },
/* 1002 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2015-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var ReactUpdateQueue = __webpack_require__(256);
	
	var warning = __webpack_require__(30);
	
	function warnNoop(publicInstance, callerName) {
	  if (false) {
	    var constructor = publicInstance.constructor;
	    process.env.NODE_ENV !== 'production' ? warning(false, '%s(...): Can only update a mounting component. ' + 'This usually means you called %s() outside componentWillMount() on the server. ' + 'This is a no-op. Please check the code for the %s component.', callerName, callerName, constructor && (constructor.displayName || constructor.name) || 'ReactClass') : void 0;
	  }
	}
	
	/**
	 * This is the update queue used for server rendering.
	 * It delegates to ReactUpdateQueue while server rendering is in progress and
	 * switches to ReactNoopUpdateQueue after the transaction has completed.
	 * @class ReactServerUpdateQueue
	 * @param {Transaction} transaction
	 */
	
	var ReactServerUpdateQueue = function () {
	  function ReactServerUpdateQueue(transaction) {
	    _classCallCheck(this, ReactServerUpdateQueue);
	
	    this.transaction = transaction;
	  }
	
	  /**
	   * Checks whether or not this composite component is mounted.
	   * @param {ReactClass} publicInstance The instance we want to test.
	   * @return {boolean} True if mounted, false otherwise.
	   * @protected
	   * @final
	   */
	
	
	  ReactServerUpdateQueue.prototype.isMounted = function isMounted(publicInstance) {
	    return false;
	  };
	
	  /**
	   * Enqueue a callback that will be executed after all the pending updates
	   * have processed.
	   *
	   * @param {ReactClass} publicInstance The instance to use as `this` context.
	   * @param {?function} callback Called after state is updated.
	   * @internal
	   */
	
	
	  ReactServerUpdateQueue.prototype.enqueueCallback = function enqueueCallback(publicInstance, callback, callerName) {
	    if (this.transaction.isInTransaction()) {
	      ReactUpdateQueue.enqueueCallback(publicInstance, callback, callerName);
	    }
	  };
	
	  /**
	   * Forces an update. This should only be invoked when it is known with
	   * certainty that we are **not** in a DOM transaction.
	   *
	   * You may want to call this when you know that some deeper aspect of the
	   * component's state has changed but `setState` was not called.
	   *
	   * This will not invoke `shouldComponentUpdate`, but it will invoke
	   * `componentWillUpdate` and `componentDidUpdate`.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @internal
	   */
	
	
	  ReactServerUpdateQueue.prototype.enqueueForceUpdate = function enqueueForceUpdate(publicInstance) {
	    if (this.transaction.isInTransaction()) {
	      ReactUpdateQueue.enqueueForceUpdate(publicInstance);
	    } else {
	      warnNoop(publicInstance, 'forceUpdate');
	    }
	  };
	
	  /**
	   * Replaces all of the state. Always use this or `setState` to mutate state.
	   * You should treat `this.state` as immutable.
	   *
	   * There is no guarantee that `this.state` will be immediately updated, so
	   * accessing `this.state` after calling this method may return the old value.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @param {object|function} completeState Next state.
	   * @internal
	   */
	
	
	  ReactServerUpdateQueue.prototype.enqueueReplaceState = function enqueueReplaceState(publicInstance, completeState) {
	    if (this.transaction.isInTransaction()) {
	      ReactUpdateQueue.enqueueReplaceState(publicInstance, completeState);
	    } else {
	      warnNoop(publicInstance, 'replaceState');
	    }
	  };
	
	  /**
	   * Sets a subset of the state. This only exists because _pendingState is
	   * internal. This provides a merging strategy that is not available to deep
	   * properties which is confusing. TODO: Expose pendingState or don't use it
	   * during the merge.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @param {object|function} partialState Next partial state to be merged with state.
	   * @internal
	   */
	
	
	  ReactServerUpdateQueue.prototype.enqueueSetState = function enqueueSetState(publicInstance, partialState) {
	    if (this.transaction.isInTransaction()) {
	      ReactUpdateQueue.enqueueSetState(publicInstance, partialState);
	    } else {
	      warnNoop(publicInstance, 'setState');
	    }
	  };
	
	  return ReactServerUpdateQueue;
	}();
	
	module.exports = ReactServerUpdateQueue;

/***/ },
/* 1003 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var NS = {
	  xlink: 'http://www.w3.org/1999/xlink',
	  xml: 'http://www.w3.org/XML/1998/namespace'
	};
	
	// We use attributes for everything SVG so let's avoid some duplication and run
	// code instead.
	// The following are all specified in the HTML config already so we exclude here.
	// - class (as className)
	// - color
	// - height
	// - id
	// - lang
	// - max
	// - media
	// - method
	// - min
	// - name
	// - style
	// - target
	// - type
	// - width
	var ATTRS = {
	  accentHeight: 'accent-height',
	  accumulate: 0,
	  additive: 0,
	  alignmentBaseline: 'alignment-baseline',
	  allowReorder: 'allowReorder',
	  alphabetic: 0,
	  amplitude: 0,
	  arabicForm: 'arabic-form',
	  ascent: 0,
	  attributeName: 'attributeName',
	  attributeType: 'attributeType',
	  autoReverse: 'autoReverse',
	  azimuth: 0,
	  baseFrequency: 'baseFrequency',
	  baseProfile: 'baseProfile',
	  baselineShift: 'baseline-shift',
	  bbox: 0,
	  begin: 0,
	  bias: 0,
	  by: 0,
	  calcMode: 'calcMode',
	  capHeight: 'cap-height',
	  clip: 0,
	  clipPath: 'clip-path',
	  clipRule: 'clip-rule',
	  clipPathUnits: 'clipPathUnits',
	  colorInterpolation: 'color-interpolation',
	  colorInterpolationFilters: 'color-interpolation-filters',
	  colorProfile: 'color-profile',
	  colorRendering: 'color-rendering',
	  contentScriptType: 'contentScriptType',
	  contentStyleType: 'contentStyleType',
	  cursor: 0,
	  cx: 0,
	  cy: 0,
	  d: 0,
	  decelerate: 0,
	  descent: 0,
	  diffuseConstant: 'diffuseConstant',
	  direction: 0,
	  display: 0,
	  divisor: 0,
	  dominantBaseline: 'dominant-baseline',
	  dur: 0,
	  dx: 0,
	  dy: 0,
	  edgeMode: 'edgeMode',
	  elevation: 0,
	  enableBackground: 'enable-background',
	  end: 0,
	  exponent: 0,
	  externalResourcesRequired: 'externalResourcesRequired',
	  fill: 0,
	  fillOpacity: 'fill-opacity',
	  fillRule: 'fill-rule',
	  filter: 0,
	  filterRes: 'filterRes',
	  filterUnits: 'filterUnits',
	  floodColor: 'flood-color',
	  floodOpacity: 'flood-opacity',
	  focusable: 0,
	  fontFamily: 'font-family',
	  fontSize: 'font-size',
	  fontSizeAdjust: 'font-size-adjust',
	  fontStretch: 'font-stretch',
	  fontStyle: 'font-style',
	  fontVariant: 'font-variant',
	  fontWeight: 'font-weight',
	  format: 0,
	  from: 0,
	  fx: 0,
	  fy: 0,
	  g1: 0,
	  g2: 0,
	  glyphName: 'glyph-name',
	  glyphOrientationHorizontal: 'glyph-orientation-horizontal',
	  glyphOrientationVertical: 'glyph-orientation-vertical',
	  glyphRef: 'glyphRef',
	  gradientTransform: 'gradientTransform',
	  gradientUnits: 'gradientUnits',
	  hanging: 0,
	  horizAdvX: 'horiz-adv-x',
	  horizOriginX: 'horiz-origin-x',
	  ideographic: 0,
	  imageRendering: 'image-rendering',
	  'in': 0,
	  in2: 0,
	  intercept: 0,
	  k: 0,
	  k1: 0,
	  k2: 0,
	  k3: 0,
	  k4: 0,
	  kernelMatrix: 'kernelMatrix',
	  kernelUnitLength: 'kernelUnitLength',
	  kerning: 0,
	  keyPoints: 'keyPoints',
	  keySplines: 'keySplines',
	  keyTimes: 'keyTimes',
	  lengthAdjust: 'lengthAdjust',
	  letterSpacing: 'letter-spacing',
	  lightingColor: 'lighting-color',
	  limitingConeAngle: 'limitingConeAngle',
	  local: 0,
	  markerEnd: 'marker-end',
	  markerMid: 'marker-mid',
	  markerStart: 'marker-start',
	  markerHeight: 'markerHeight',
	  markerUnits: 'markerUnits',
	  markerWidth: 'markerWidth',
	  mask: 0,
	  maskContentUnits: 'maskContentUnits',
	  maskUnits: 'maskUnits',
	  mathematical: 0,
	  mode: 0,
	  numOctaves: 'numOctaves',
	  offset: 0,
	  opacity: 0,
	  operator: 0,
	  order: 0,
	  orient: 0,
	  orientation: 0,
	  origin: 0,
	  overflow: 0,
	  overlinePosition: 'overline-position',
	  overlineThickness: 'overline-thickness',
	  paintOrder: 'paint-order',
	  panose1: 'panose-1',
	  pathLength: 'pathLength',
	  patternContentUnits: 'patternContentUnits',
	  patternTransform: 'patternTransform',
	  patternUnits: 'patternUnits',
	  pointerEvents: 'pointer-events',
	  points: 0,
	  pointsAtX: 'pointsAtX',
	  pointsAtY: 'pointsAtY',
	  pointsAtZ: 'pointsAtZ',
	  preserveAlpha: 'preserveAlpha',
	  preserveAspectRatio: 'preserveAspectRatio',
	  primitiveUnits: 'primitiveUnits',
	  r: 0,
	  radius: 0,
	  refX: 'refX',
	  refY: 'refY',
	  renderingIntent: 'rendering-intent',
	  repeatCount: 'repeatCount',
	  repeatDur: 'repeatDur',
	  requiredExtensions: 'requiredExtensions',
	  requiredFeatures: 'requiredFeatures',
	  restart: 0,
	  result: 0,
	  rotate: 0,
	  rx: 0,
	  ry: 0,
	  scale: 0,
	  seed: 0,
	  shapeRendering: 'shape-rendering',
	  slope: 0,
	  spacing: 0,
	  specularConstant: 'specularConstant',
	  specularExponent: 'specularExponent',
	  speed: 0,
	  spreadMethod: 'spreadMethod',
	  startOffset: 'startOffset',
	  stdDeviation: 'stdDeviation',
	  stemh: 0,
	  stemv: 0,
	  stitchTiles: 'stitchTiles',
	  stopColor: 'stop-color',
	  stopOpacity: 'stop-opacity',
	  strikethroughPosition: 'strikethrough-position',
	  strikethroughThickness: 'strikethrough-thickness',
	  string: 0,
	  stroke: 0,
	  strokeDasharray: 'stroke-dasharray',
	  strokeDashoffset: 'stroke-dashoffset',
	  strokeLinecap: 'stroke-linecap',
	  strokeLinejoin: 'stroke-linejoin',
	  strokeMiterlimit: 'stroke-miterlimit',
	  strokeOpacity: 'stroke-opacity',
	  strokeWidth: 'stroke-width',
	  surfaceScale: 'surfaceScale',
	  systemLanguage: 'systemLanguage',
	  tableValues: 'tableValues',
	  targetX: 'targetX',
	  targetY: 'targetY',
	  textAnchor: 'text-anchor',
	  textDecoration: 'text-decoration',
	  textRendering: 'text-rendering',
	  textLength: 'textLength',
	  to: 0,
	  transform: 0,
	  u1: 0,
	  u2: 0,
	  underlinePosition: 'underline-position',
	  underlineThickness: 'underline-thickness',
	  unicode: 0,
	  unicodeBidi: 'unicode-bidi',
	  unicodeRange: 'unicode-range',
	  unitsPerEm: 'units-per-em',
	  vAlphabetic: 'v-alphabetic',
	  vHanging: 'v-hanging',
	  vIdeographic: 'v-ideographic',
	  vMathematical: 'v-mathematical',
	  values: 0,
	  vectorEffect: 'vector-effect',
	  version: 0,
	  vertAdvY: 'vert-adv-y',
	  vertOriginX: 'vert-origin-x',
	  vertOriginY: 'vert-origin-y',
	  viewBox: 'viewBox',
	  viewTarget: 'viewTarget',
	  visibility: 0,
	  widths: 0,
	  wordSpacing: 'word-spacing',
	  writingMode: 'writing-mode',
	  x: 0,
	  xHeight: 'x-height',
	  x1: 0,
	  x2: 0,
	  xChannelSelector: 'xChannelSelector',
	  xlinkActuate: 'xlink:actuate',
	  xlinkArcrole: 'xlink:arcrole',
	  xlinkHref: 'xlink:href',
	  xlinkRole: 'xlink:role',
	  xlinkShow: 'xlink:show',
	  xlinkTitle: 'xlink:title',
	  xlinkType: 'xlink:type',
	  xmlBase: 'xml:base',
	  xmlns: 0,
	  xmlnsXlink: 'xmlns:xlink',
	  xmlLang: 'xml:lang',
	  xmlSpace: 'xml:space',
	  y: 0,
	  y1: 0,
	  y2: 0,
	  yChannelSelector: 'yChannelSelector',
	  z: 0,
	  zoomAndPan: 'zoomAndPan'
	};
	
	var SVGDOMPropertyConfig = {
	  Properties: {},
	  DOMAttributeNamespaces: {
	    xlinkActuate: NS.xlink,
	    xlinkArcrole: NS.xlink,
	    xlinkHref: NS.xlink,
	    xlinkRole: NS.xlink,
	    xlinkShow: NS.xlink,
	    xlinkTitle: NS.xlink,
	    xlinkType: NS.xlink,
	    xmlBase: NS.xml,
	    xmlLang: NS.xml,
	    xmlSpace: NS.xml
	  },
	  DOMAttributeNames: {}
	};
	
	Object.keys(ATTRS).forEach(function (key) {
	  SVGDOMPropertyConfig.Properties[key] = 0;
	  if (ATTRS[key]) {
	    SVGDOMPropertyConfig.DOMAttributeNames[key] = ATTRS[key];
	  }
	});
	
	module.exports = SVGDOMPropertyConfig;

/***/ },
/* 1004 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var EventPropagators = __webpack_require__(145);
	var ExecutionEnvironment = __webpack_require__(51);
	var ReactDOMComponentTree = __webpack_require__(41);
	var ReactInputSelection = __webpack_require__(393);
	var SyntheticEvent = __webpack_require__(91);
	
	var getActiveElement = __webpack_require__(331);
	var isTextInputElement = __webpack_require__(405);
	var shallowEqual = __webpack_require__(233);
	
	var skipSelectionChangeEvent = ExecutionEnvironment.canUseDOM && 'documentMode' in document && document.documentMode <= 11;
	
	var eventTypes = {
	  select: {
	    phasedRegistrationNames: {
	      bubbled: 'onSelect',
	      captured: 'onSelectCapture'
	    },
	    dependencies: ['topBlur', 'topContextMenu', 'topFocus', 'topKeyDown', 'topKeyUp', 'topMouseDown', 'topMouseUp', 'topSelectionChange']
	  }
	};
	
	var activeElement = null;
	var activeElementInst = null;
	var lastSelection = null;
	var mouseDown = false;
	
	// Track whether a listener exists for this plugin. If none exist, we do
	// not extract events. See #3639.
	var hasListener = false;
	
	/**
	 * Get an object which is a unique representation of the current selection.
	 *
	 * The return value will not be consistent across nodes or browsers, but
	 * two identical selections on the same node will return identical objects.
	 *
	 * @param {DOMElement} node
	 * @return {object}
	 */
	function getSelection(node) {
	  if ('selectionStart' in node && ReactInputSelection.hasSelectionCapabilities(node)) {
	    return {
	      start: node.selectionStart,
	      end: node.selectionEnd
	    };
	  } else if (window.getSelection) {
	    var selection = window.getSelection();
	    return {
	      anchorNode: selection.anchorNode,
	      anchorOffset: selection.anchorOffset,
	      focusNode: selection.focusNode,
	      focusOffset: selection.focusOffset
	    };
	  } else if (document.selection) {
	    var range = document.selection.createRange();
	    return {
	      parentElement: range.parentElement(),
	      text: range.text,
	      top: range.boundingTop,
	      left: range.boundingLeft
	    };
	  }
	}
	
	/**
	 * Poll selection to see whether it's changed.
	 *
	 * @param {object} nativeEvent
	 * @return {?SyntheticEvent}
	 */
	function constructSelectEvent(nativeEvent, nativeEventTarget) {
	  // Ensure we have the right element, and that the user is not dragging a
	  // selection (this matches native `select` event behavior). In HTML5, select
	  // fires only on input and textarea thus if there's no focused element we
	  // won't dispatch.
	  if (mouseDown || activeElement == null || activeElement !== getActiveElement()) {
	    return null;
	  }
	
	  // Only fire when selection has actually changed.
	  var currentSelection = getSelection(activeElement);
	  if (!lastSelection || !shallowEqual(lastSelection, currentSelection)) {
	    lastSelection = currentSelection;
	
	    var syntheticEvent = SyntheticEvent.getPooled(eventTypes.select, activeElementInst, nativeEvent, nativeEventTarget);
	
	    syntheticEvent.type = 'select';
	    syntheticEvent.target = activeElement;
	
	    EventPropagators.accumulateTwoPhaseDispatches(syntheticEvent);
	
	    return syntheticEvent;
	  }
	
	  return null;
	}
	
	/**
	 * This plugin creates an `onSelect` event that normalizes select events
	 * across form elements.
	 *
	 * Supported elements are:
	 * - input (see `isTextInputElement`)
	 * - textarea
	 * - contentEditable
	 *
	 * This differs from native browser implementations in the following ways:
	 * - Fires on contentEditable fields as well as inputs.
	 * - Fires for collapsed selection.
	 * - Fires after user input.
	 */
	var SelectEventPlugin = {
	  eventTypes: eventTypes,
	
	  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	    if (!hasListener) {
	      return null;
	    }
	
	    var targetNode = targetInst ? ReactDOMComponentTree.getNodeFromInstance(targetInst) : window;
	
	    switch (topLevelType) {
	      // Track the input node that has focus.
	      case 'topFocus':
	        if (isTextInputElement(targetNode) || targetNode.contentEditable === 'true') {
	          activeElement = targetNode;
	          activeElementInst = targetInst;
	          lastSelection = null;
	        }
	        break;
	      case 'topBlur':
	        activeElement = null;
	        activeElementInst = null;
	        lastSelection = null;
	        break;
	      // Don't fire the event while the user is dragging. This matches the
	      // semantics of the native select event.
	      case 'topMouseDown':
	        mouseDown = true;
	        break;
	      case 'topContextMenu':
	      case 'topMouseUp':
	        mouseDown = false;
	        return constructSelectEvent(nativeEvent, nativeEventTarget);
	      // Chrome and IE fire non-standard event when selection is changed (and
	      // sometimes when it hasn't). IE's event fires out of order with respect
	      // to key and input events on deletion, so we discard it.
	      //
	      // Firefox doesn't support selectionchange, so check selection status
	      // after each key entry. The selection changes after keydown and before
	      // keyup, but we check on keydown as well in the case of holding down a
	      // key, when multiple keydown events are fired but only one keyup is.
	      // This is also our approach for IE handling, for the reason above.
	      case 'topSelectionChange':
	        if (skipSelectionChangeEvent) {
	          break;
	        }
	      // falls through
	      case 'topKeyDown':
	      case 'topKeyUp':
	        return constructSelectEvent(nativeEvent, nativeEventTarget);
	    }
	
	    return null;
	  },
	
	  didPutListener: function (inst, registrationName, listener) {
	    if (registrationName === 'onSelect') {
	      hasListener = true;
	    }
	  }
	};
	
	module.exports = SelectEventPlugin;

/***/ },
/* 1005 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(29);
	
	var EventListener = __webpack_require__(329);
	var EventPropagators = __webpack_require__(145);
	var ReactDOMComponentTree = __webpack_require__(41);
	var SyntheticAnimationEvent = __webpack_require__(1006);
	var SyntheticClipboardEvent = __webpack_require__(1007);
	var SyntheticEvent = __webpack_require__(91);
	var SyntheticFocusEvent = __webpack_require__(1010);
	var SyntheticKeyboardEvent = __webpack_require__(1012);
	var SyntheticMouseEvent = __webpack_require__(185);
	var SyntheticDragEvent = __webpack_require__(1009);
	var SyntheticTouchEvent = __webpack_require__(1013);
	var SyntheticTransitionEvent = __webpack_require__(1014);
	var SyntheticUIEvent = __webpack_require__(147);
	var SyntheticWheelEvent = __webpack_require__(1015);
	
	var emptyFunction = __webpack_require__(80);
	var getEventCharCode = __webpack_require__(258);
	var invariant = __webpack_require__(21);
	
	/**
	 * Turns
	 * ['abort', ...]
	 * into
	 * eventTypes = {
	 *   'abort': {
	 *     phasedRegistrationNames: {
	 *       bubbled: 'onAbort',
	 *       captured: 'onAbortCapture',
	 *     },
	 *     dependencies: ['topAbort'],
	 *   },
	 *   ...
	 * };
	 * topLevelEventsToDispatchConfig = {
	 *   'topAbort': { sameConfig }
	 * };
	 */
	var eventTypes = {};
	var topLevelEventsToDispatchConfig = {};
	['abort', 'animationEnd', 'animationIteration', 'animationStart', 'blur', 'canPlay', 'canPlayThrough', 'click', 'contextMenu', 'copy', 'cut', 'doubleClick', 'drag', 'dragEnd', 'dragEnter', 'dragExit', 'dragLeave', 'dragOver', 'dragStart', 'drop', 'durationChange', 'emptied', 'encrypted', 'ended', 'error', 'focus', 'input', 'invalid', 'keyDown', 'keyPress', 'keyUp', 'load', 'loadedData', 'loadedMetadata', 'loadStart', 'mouseDown', 'mouseMove', 'mouseOut', 'mouseOver', 'mouseUp', 'paste', 'pause', 'play', 'playing', 'progress', 'rateChange', 'reset', 'scroll', 'seeked', 'seeking', 'stalled', 'submit', 'suspend', 'timeUpdate', 'touchCancel', 'touchEnd', 'touchMove', 'touchStart', 'transitionEnd', 'volumeChange', 'waiting', 'wheel'].forEach(function (event) {
	  var capitalizedEvent = event[0].toUpperCase() + event.slice(1);
	  var onEvent = 'on' + capitalizedEvent;
	  var topEvent = 'top' + capitalizedEvent;
	
	  var type = {
	    phasedRegistrationNames: {
	      bubbled: onEvent,
	      captured: onEvent + 'Capture'
	    },
	    dependencies: [topEvent]
	  };
	  eventTypes[event] = type;
	  topLevelEventsToDispatchConfig[topEvent] = type;
	});
	
	var onClickListeners = {};
	
	function getDictionaryKey(inst) {
	  // Prevents V8 performance issue:
	  // https://github.com/facebook/react/pull/7232
	  return '.' + inst._rootNodeID;
	}
	
	function isInteractive(tag) {
	  return tag === 'button' || tag === 'input' || tag === 'select' || tag === 'textarea';
	}
	
	var SimpleEventPlugin = {
	  eventTypes: eventTypes,
	
	  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	    var dispatchConfig = topLevelEventsToDispatchConfig[topLevelType];
	    if (!dispatchConfig) {
	      return null;
	    }
	    var EventConstructor;
	    switch (topLevelType) {
	      case 'topAbort':
	      case 'topCanPlay':
	      case 'topCanPlayThrough':
	      case 'topDurationChange':
	      case 'topEmptied':
	      case 'topEncrypted':
	      case 'topEnded':
	      case 'topError':
	      case 'topInput':
	      case 'topInvalid':
	      case 'topLoad':
	      case 'topLoadedData':
	      case 'topLoadedMetadata':
	      case 'topLoadStart':
	      case 'topPause':
	      case 'topPlay':
	      case 'topPlaying':
	      case 'topProgress':
	      case 'topRateChange':
	      case 'topReset':
	      case 'topSeeked':
	      case 'topSeeking':
	      case 'topStalled':
	      case 'topSubmit':
	      case 'topSuspend':
	      case 'topTimeUpdate':
	      case 'topVolumeChange':
	      case 'topWaiting':
	        // HTML Events
	        // @see http://www.w3.org/TR/html5/index.html#events-0
	        EventConstructor = SyntheticEvent;
	        break;
	      case 'topKeyPress':
	        // Firefox creates a keypress event for function keys too. This removes
	        // the unwanted keypress events. Enter is however both printable and
	        // non-printable. One would expect Tab to be as well (but it isn't).
	        if (getEventCharCode(nativeEvent) === 0) {
	          return null;
	        }
	      /* falls through */
	      case 'topKeyDown':
	      case 'topKeyUp':
	        EventConstructor = SyntheticKeyboardEvent;
	        break;
	      case 'topBlur':
	      case 'topFocus':
	        EventConstructor = SyntheticFocusEvent;
	        break;
	      case 'topClick':
	        // Firefox creates a click event on right mouse clicks. This removes the
	        // unwanted click events.
	        if (nativeEvent.button === 2) {
	          return null;
	        }
	      /* falls through */
	      case 'topDoubleClick':
	      case 'topMouseDown':
	      case 'topMouseMove':
	      case 'topMouseUp':
	      // TODO: Disabled elements should not respond to mouse events
	      /* falls through */
	      case 'topMouseOut':
	      case 'topMouseOver':
	      case 'topContextMenu':
	        EventConstructor = SyntheticMouseEvent;
	        break;
	      case 'topDrag':
	      case 'topDragEnd':
	      case 'topDragEnter':
	      case 'topDragExit':
	      case 'topDragLeave':
	      case 'topDragOver':
	      case 'topDragStart':
	      case 'topDrop':
	        EventConstructor = SyntheticDragEvent;
	        break;
	      case 'topTouchCancel':
	      case 'topTouchEnd':
	      case 'topTouchMove':
	      case 'topTouchStart':
	        EventConstructor = SyntheticTouchEvent;
	        break;
	      case 'topAnimationEnd':
	      case 'topAnimationIteration':
	      case 'topAnimationStart':
	        EventConstructor = SyntheticAnimationEvent;
	        break;
	      case 'topTransitionEnd':
	        EventConstructor = SyntheticTransitionEvent;
	        break;
	      case 'topScroll':
	        EventConstructor = SyntheticUIEvent;
	        break;
	      case 'topWheel':
	        EventConstructor = SyntheticWheelEvent;
	        break;
	      case 'topCopy':
	      case 'topCut':
	      case 'topPaste':
	        EventConstructor = SyntheticClipboardEvent;
	        break;
	    }
	    !EventConstructor ?  false ? invariant(false, 'SimpleEventPlugin: Unhandled event type, `%s`.', topLevelType) : _prodInvariant('86', topLevelType) : void 0;
	    var event = EventConstructor.getPooled(dispatchConfig, targetInst, nativeEvent, nativeEventTarget);
	    EventPropagators.accumulateTwoPhaseDispatches(event);
	    return event;
	  },
	
	  didPutListener: function (inst, registrationName, listener) {
	    // Mobile Safari does not fire properly bubble click events on
	    // non-interactive elements, which means delegated click listeners do not
	    // fire. The workaround for this bug involves attaching an empty click
	    // listener on the target node.
	    // http://www.quirksmode.org/blog/archives/2010/09/click_event_del.html
	    if (registrationName === 'onClick' && !isInteractive(inst._tag)) {
	      var key = getDictionaryKey(inst);
	      var node = ReactDOMComponentTree.getNodeFromInstance(inst);
	      if (!onClickListeners[key]) {
	        onClickListeners[key] = EventListener.listen(node, 'click', emptyFunction);
	      }
	    }
	  },
	
	  willDeleteListener: function (inst, registrationName) {
	    if (registrationName === 'onClick' && !isInteractive(inst._tag)) {
	      var key = getDictionaryKey(inst);
	      onClickListeners[key].remove();
	      delete onClickListeners[key];
	    }
	  }
	};
	
	module.exports = SimpleEventPlugin;

/***/ },
/* 1006 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var SyntheticEvent = __webpack_require__(91);
	
	/**
	 * @interface Event
	 * @see http://www.w3.org/TR/css3-animations/#AnimationEvent-interface
	 * @see https://developer.mozilla.org/en-US/docs/Web/API/AnimationEvent
	 */
	var AnimationEventInterface = {
	  animationName: null,
	  elapsedTime: null,
	  pseudoElement: null
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticEvent}
	 */
	function SyntheticAnimationEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticEvent.augmentClass(SyntheticAnimationEvent, AnimationEventInterface);
	
	module.exports = SyntheticAnimationEvent;

/***/ },
/* 1007 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var SyntheticEvent = __webpack_require__(91);
	
	/**
	 * @interface Event
	 * @see http://www.w3.org/TR/clipboard-apis/
	 */
	var ClipboardEventInterface = {
	  clipboardData: function (event) {
	    return 'clipboardData' in event ? event.clipboardData : window.clipboardData;
	  }
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticClipboardEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticEvent.augmentClass(SyntheticClipboardEvent, ClipboardEventInterface);
	
	module.exports = SyntheticClipboardEvent;

/***/ },
/* 1008 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var SyntheticEvent = __webpack_require__(91);
	
	/**
	 * @interface Event
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/#events-compositionevents
	 */
	var CompositionEventInterface = {
	  data: null
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticCompositionEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticEvent.augmentClass(SyntheticCompositionEvent, CompositionEventInterface);
	
	module.exports = SyntheticCompositionEvent;

/***/ },
/* 1009 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var SyntheticMouseEvent = __webpack_require__(185);
	
	/**
	 * @interface DragEvent
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var DragEventInterface = {
	  dataTransfer: null
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticDragEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticMouseEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticMouseEvent.augmentClass(SyntheticDragEvent, DragEventInterface);
	
	module.exports = SyntheticDragEvent;

/***/ },
/* 1010 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var SyntheticUIEvent = __webpack_require__(147);
	
	/**
	 * @interface FocusEvent
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var FocusEventInterface = {
	  relatedTarget: null
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticFocusEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticUIEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticUIEvent.augmentClass(SyntheticFocusEvent, FocusEventInterface);
	
	module.exports = SyntheticFocusEvent;

/***/ },
/* 1011 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var SyntheticEvent = __webpack_require__(91);
	
	/**
	 * @interface Event
	 * @see http://www.w3.org/TR/2013/WD-DOM-Level-3-Events-20131105
	 *      /#events-inputevents
	 */
	var InputEventInterface = {
	  data: null
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticInputEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticEvent.augmentClass(SyntheticInputEvent, InputEventInterface);
	
	module.exports = SyntheticInputEvent;

/***/ },
/* 1012 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var SyntheticUIEvent = __webpack_require__(147);
	
	var getEventCharCode = __webpack_require__(258);
	var getEventKey = __webpack_require__(1020);
	var getEventModifierState = __webpack_require__(259);
	
	/**
	 * @interface KeyboardEvent
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var KeyboardEventInterface = {
	  key: getEventKey,
	  location: null,
	  ctrlKey: null,
	  shiftKey: null,
	  altKey: null,
	  metaKey: null,
	  repeat: null,
	  locale: null,
	  getModifierState: getEventModifierState,
	  // Legacy Interface
	  charCode: function (event) {
	    // `charCode` is the result of a KeyPress event and represents the value of
	    // the actual printable character.
	
	    // KeyPress is deprecated, but its replacement is not yet final and not
	    // implemented in any major browser. Only KeyPress has charCode.
	    if (event.type === 'keypress') {
	      return getEventCharCode(event);
	    }
	    return 0;
	  },
	  keyCode: function (event) {
	    // `keyCode` is the result of a KeyDown/Up event and represents the value of
	    // physical keyboard key.
	
	    // The actual meaning of the value depends on the users' keyboard layout
	    // which cannot be detected. Assuming that it is a US keyboard layout
	    // provides a surprisingly accurate mapping for US and European users.
	    // Due to this, it is left to the user to implement at this time.
	    if (event.type === 'keydown' || event.type === 'keyup') {
	      return event.keyCode;
	    }
	    return 0;
	  },
	  which: function (event) {
	    // `which` is an alias for either `keyCode` or `charCode` depending on the
	    // type of the event.
	    if (event.type === 'keypress') {
	      return getEventCharCode(event);
	    }
	    if (event.type === 'keydown' || event.type === 'keyup') {
	      return event.keyCode;
	    }
	    return 0;
	  }
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticKeyboardEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticUIEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticUIEvent.augmentClass(SyntheticKeyboardEvent, KeyboardEventInterface);
	
	module.exports = SyntheticKeyboardEvent;

/***/ },
/* 1013 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var SyntheticUIEvent = __webpack_require__(147);
	
	var getEventModifierState = __webpack_require__(259);
	
	/**
	 * @interface TouchEvent
	 * @see http://www.w3.org/TR/touch-events/
	 */
	var TouchEventInterface = {
	  touches: null,
	  targetTouches: null,
	  changedTouches: null,
	  altKey: null,
	  metaKey: null,
	  ctrlKey: null,
	  shiftKey: null,
	  getModifierState: getEventModifierState
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticTouchEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticUIEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticUIEvent.augmentClass(SyntheticTouchEvent, TouchEventInterface);
	
	module.exports = SyntheticTouchEvent;

/***/ },
/* 1014 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var SyntheticEvent = __webpack_require__(91);
	
	/**
	 * @interface Event
	 * @see http://www.w3.org/TR/2009/WD-css3-transitions-20090320/#transition-events-
	 * @see https://developer.mozilla.org/en-US/docs/Web/API/TransitionEvent
	 */
	var TransitionEventInterface = {
	  propertyName: null,
	  elapsedTime: null,
	  pseudoElement: null
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticEvent}
	 */
	function SyntheticTransitionEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticEvent.augmentClass(SyntheticTransitionEvent, TransitionEventInterface);
	
	module.exports = SyntheticTransitionEvent;

/***/ },
/* 1015 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var SyntheticMouseEvent = __webpack_require__(185);
	
	/**
	 * @interface WheelEvent
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var WheelEventInterface = {
	  deltaX: function (event) {
	    return 'deltaX' in event ? event.deltaX : // Fallback to `wheelDeltaX` for Webkit and normalize (right is positive).
	    'wheelDeltaX' in event ? -event.wheelDeltaX : 0;
	  },
	  deltaY: function (event) {
	    return 'deltaY' in event ? event.deltaY : // Fallback to `wheelDeltaY` for Webkit and normalize (down is positive).
	    'wheelDeltaY' in event ? -event.wheelDeltaY : // Fallback to `wheelDelta` for IE<9 and normalize (down is positive).
	    'wheelDelta' in event ? -event.wheelDelta : 0;
	  },
	  deltaZ: null,
	
	  // Browsers without "deltaMode" is reporting in raw wheel delta where one
	  // notch on the scroll is always +/- 120, roughly equivalent to pixels.
	  // A good approximation of DOM_DELTA_LINE (1) is 5% of viewport size or
	  // ~40 pixels, for DOM_DELTA_SCREEN (2) it is 87.5% of viewport size.
	  deltaMode: null
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticMouseEvent}
	 */
	function SyntheticWheelEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticMouseEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticMouseEvent.augmentClass(SyntheticWheelEvent, WheelEventInterface);
	
	module.exports = SyntheticWheelEvent;

/***/ },
/* 1016 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var MOD = 65521;
	
	// adler32 is not cryptographically strong, and is only used to sanity check that
	// markup generated on the server matches the markup generated on the client.
	// This implementation (a modified version of the SheetJS version) has been optimized
	// for our use case, at the expense of conforming to the adler32 specification
	// for non-ascii inputs.
	function adler32(data) {
	  var a = 1;
	  var b = 0;
	  var i = 0;
	  var l = data.length;
	  var m = l & ~0x3;
	  while (i < m) {
	    var n = Math.min(i + 4096, m);
	    for (; i < n; i += 4) {
	      b += (a += data.charCodeAt(i)) + (a += data.charCodeAt(i + 1)) + (a += data.charCodeAt(i + 2)) + (a += data.charCodeAt(i + 3));
	    }
	    a %= MOD;
	    b %= MOD;
	  }
	  for (; i < l; i++) {
	    b += a += data.charCodeAt(i);
	  }
	  a %= MOD;
	  b %= MOD;
	  return a | b << 16;
	}
	
	module.exports = adler32;

/***/ },
/* 1017 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var CSSProperty = __webpack_require__(382);
	var warning = __webpack_require__(30);
	
	var isUnitlessNumber = CSSProperty.isUnitlessNumber;
	var styleWarnings = {};
	
	/**
	 * Convert a value into the proper css writable value. The style name `name`
	 * should be logical (no hyphens), as specified
	 * in `CSSProperty.isUnitlessNumber`.
	 *
	 * @param {string} name CSS property name such as `topMargin`.
	 * @param {*} value CSS property value such as `10px`.
	 * @param {ReactDOMComponent} component
	 * @return {string} Normalized style value with dimensions applied.
	 */
	function dangerousStyleValue(name, value, component, isCustomProperty) {
	  // Note that we've removed escapeTextForBrowser() calls here since the
	  // whole string will be escaped when the attribute is injected into
	  // the markup. If you provide unsafe user data here they can inject
	  // arbitrary CSS which may be problematic (I couldn't repro this):
	  // https://www.owasp.org/index.php/XSS_Filter_Evasion_Cheat_Sheet
	  // http://www.thespanner.co.uk/2007/11/26/ultimate-xss-css-injection/
	  // This is not an XSS hole but instead a potential CSS injection issue
	  // which has lead to a greater discussion about how we're going to
	  // trust URLs moving forward. See #2115901
	
	  var isEmpty = value == null || typeof value === 'boolean' || value === '';
	  if (isEmpty) {
	    return '';
	  }
	
	  var isNonNumeric = isNaN(value);
	  if (isCustomProperty || isNonNumeric || value === 0 || isUnitlessNumber.hasOwnProperty(name) && isUnitlessNumber[name]) {
	    return '' + value; // cast to string
	  }
	
	  if (typeof value === 'string') {
	    if (false) {
	      // Allow '0' to pass through without warning. 0 is already special and
	      // doesn't require units, so we don't need to warn about it.
	      if (component && value !== '0') {
	        var owner = component._currentElement._owner;
	        var ownerName = owner ? owner.getName() : null;
	        if (ownerName && !styleWarnings[ownerName]) {
	          styleWarnings[ownerName] = {};
	        }
	        var warned = false;
	        if (ownerName) {
	          var warnings = styleWarnings[ownerName];
	          warned = warnings[name];
	          if (!warned) {
	            warnings[name] = true;
	          }
	        }
	        if (!warned) {
	          process.env.NODE_ENV !== 'production' ? warning(false, 'a `%s` tag (owner: `%s`) was passed a numeric string value ' + 'for CSS property `%s` (value: `%s`) which will be treated ' + 'as a unitless number in a future version of React.', component._currentElement.type, ownerName || 'unknown', name, value) : void 0;
	        }
	      }
	    }
	    value = value.trim();
	  }
	  return value + 'px';
	}
	
	module.exports = dangerousStyleValue;

/***/ },
/* 1018 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(29);
	
	var ReactCurrentOwner = __webpack_require__(92);
	var ReactDOMComponentTree = __webpack_require__(41);
	var ReactInstanceMap = __webpack_require__(146);
	
	var getHostComponentFromComposite = __webpack_require__(402);
	var invariant = __webpack_require__(21);
	var warning = __webpack_require__(30);
	
	/**
	 * Returns the DOM node rendered by this element.
	 *
	 * See https://facebook.github.io/react/docs/top-level-api.html#reactdom.finddomnode
	 *
	 * @param {ReactComponent|DOMElement} componentOrElement
	 * @return {?DOMElement} The root node of this element.
	 */
	function findDOMNode(componentOrElement) {
	  if (false) {
	    var owner = ReactCurrentOwner.current;
	    if (owner !== null) {
	      process.env.NODE_ENV !== 'production' ? warning(owner._warnedAboutRefsInRender, '%s is accessing findDOMNode inside its render(). ' + 'render() should be a pure function of props and state. It should ' + 'never access something that requires stale data from the previous ' + 'render, such as refs. Move this logic to componentDidMount and ' + 'componentDidUpdate instead.', owner.getName() || 'A component') : void 0;
	      owner._warnedAboutRefsInRender = true;
	    }
	  }
	  if (componentOrElement == null) {
	    return null;
	  }
	  if (componentOrElement.nodeType === 1) {
	    return componentOrElement;
	  }
	
	  var inst = ReactInstanceMap.get(componentOrElement);
	  if (inst) {
	    inst = getHostComponentFromComposite(inst);
	    return inst ? ReactDOMComponentTree.getNodeFromInstance(inst) : null;
	  }
	
	  if (typeof componentOrElement.render === 'function') {
	     true ?  false ? invariant(false, 'findDOMNode was called on an unmounted component.') : _prodInvariant('44') : void 0;
	  } else {
	     true ?  false ? invariant(false, 'Element appears to be neither ReactComponent nor DOMNode (keys: %s)', Object.keys(componentOrElement)) : _prodInvariant('45', Object.keys(componentOrElement)) : void 0;
	  }
	}
	
	module.exports = findDOMNode;

/***/ },
/* 1019 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var KeyEscapeUtils = __webpack_require__(252);
	var traverseAllChildren = __webpack_require__(407);
	var warning = __webpack_require__(30);
	
	var ReactComponentTreeHook;
	
	if (typeof process !== 'undefined' && process.env && ("production") === 'test') {
	  // Temporary hack.
	  // Inline requires don't work well with Jest:
	  // https://github.com/facebook/react/issues/7240
	  // Remove the inline requires when we don't need them anymore:
	  // https://github.com/facebook/react/pull/7178
	  ReactComponentTreeHook = __webpack_require__(427);
	}
	
	/**
	 * @param {function} traverseContext Context passed through traversal.
	 * @param {?ReactComponent} child React child component.
	 * @param {!string} name String name of key path to child.
	 * @param {number=} selfDebugID Optional debugID of the current internal instance.
	 */
	function flattenSingleChildIntoContext(traverseContext, child, name, selfDebugID) {
	  // We found a component instance.
	  if (traverseContext && typeof traverseContext === 'object') {
	    var result = traverseContext;
	    var keyUnique = result[name] === undefined;
	    if (false) {
	      if (!ReactComponentTreeHook) {
	        ReactComponentTreeHook = require('react/lib/ReactComponentTreeHook');
	      }
	      if (!keyUnique) {
	        process.env.NODE_ENV !== 'production' ? warning(false, 'flattenChildren(...): Encountered two children with the same key, ' + '`%s`. Child keys must be unique; when two children share a key, only ' + 'the first child will be used.%s', KeyEscapeUtils.unescape(name), ReactComponentTreeHook.getStackAddendumByID(selfDebugID)) : void 0;
	      }
	    }
	    if (keyUnique && child != null) {
	      result[name] = child;
	    }
	  }
	}
	
	/**
	 * Flattens children that are typically specified as `props.children`. Any null
	 * children will not be included in the resulting object.
	 * @return {!object} flattened children keyed by name.
	 */
	function flattenChildren(children, selfDebugID) {
	  if (children == null) {
	    return children;
	  }
	  var result = {};
	
	  if (false) {
	    traverseAllChildren(children, function (traverseContext, child, name) {
	      return flattenSingleChildIntoContext(traverseContext, child, name, selfDebugID);
	    }, result);
	  } else {
	    traverseAllChildren(children, flattenSingleChildIntoContext, result);
	  }
	  return result;
	}
	
	module.exports = flattenChildren;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(377)))

/***/ },
/* 1020 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var getEventCharCode = __webpack_require__(258);
	
	/**
	 * Normalization of deprecated HTML5 `key` values
	 * @see https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent#Key_names
	 */
	var normalizeKey = {
	  Esc: 'Escape',
	  Spacebar: ' ',
	  Left: 'ArrowLeft',
	  Up: 'ArrowUp',
	  Right: 'ArrowRight',
	  Down: 'ArrowDown',
	  Del: 'Delete',
	  Win: 'OS',
	  Menu: 'ContextMenu',
	  Apps: 'ContextMenu',
	  Scroll: 'ScrollLock',
	  MozPrintableKey: 'Unidentified'
	};
	
	/**
	 * Translation from legacy `keyCode` to HTML5 `key`
	 * Only special keys supported, all others depend on keyboard layout or browser
	 * @see https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent#Key_names
	 */
	var translateToKey = {
	  8: 'Backspace',
	  9: 'Tab',
	  12: 'Clear',
	  13: 'Enter',
	  16: 'Shift',
	  17: 'Control',
	  18: 'Alt',
	  19: 'Pause',
	  20: 'CapsLock',
	  27: 'Escape',
	  32: ' ',
	  33: 'PageUp',
	  34: 'PageDown',
	  35: 'End',
	  36: 'Home',
	  37: 'ArrowLeft',
	  38: 'ArrowUp',
	  39: 'ArrowRight',
	  40: 'ArrowDown',
	  45: 'Insert',
	  46: 'Delete',
	  112: 'F1',
	  113: 'F2',
	  114: 'F3',
	  115: 'F4',
	  116: 'F5',
	  117: 'F6',
	  118: 'F7',
	  119: 'F8',
	  120: 'F9',
	  121: 'F10',
	  122: 'F11',
	  123: 'F12',
	  144: 'NumLock',
	  145: 'ScrollLock',
	  224: 'Meta'
	};
	
	/**
	 * @param {object} nativeEvent Native browser event.
	 * @return {string} Normalized `key` property.
	 */
	function getEventKey(nativeEvent) {
	  if (nativeEvent.key) {
	    // Normalize inconsistent values reported by browsers due to
	    // implementations of a working draft specification.
	
	    // FireFox implements `key` but returns `MozPrintableKey` for all
	    // printable characters (normalized to `Unidentified`), ignore it.
	    var key = normalizeKey[nativeEvent.key] || nativeEvent.key;
	    if (key !== 'Unidentified') {
	      return key;
	    }
	  }
	
	  // Browser does not implement `key`, polyfill as much of it as we can.
	  if (nativeEvent.type === 'keypress') {
	    var charCode = getEventCharCode(nativeEvent);
	
	    // The enter-key is technically both printable and non-printable and can
	    // thus be captured by `keypress`, no other non-printable key should.
	    return charCode === 13 ? 'Enter' : String.fromCharCode(charCode);
	  }
	  if (nativeEvent.type === 'keydown' || nativeEvent.type === 'keyup') {
	    // While user keyboard layout determines the actual meaning of each
	    // `keyCode` value, almost all function keys have a universal value.
	    return translateToKey[nativeEvent.keyCode] || 'Unidentified';
	  }
	  return '';
	}
	
	module.exports = getEventKey;

/***/ },
/* 1021 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	/* global Symbol */
	
	var ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
	var FAUX_ITERATOR_SYMBOL = '@@iterator'; // Before Symbol spec.
	
	/**
	 * Returns the iterator method function contained on the iterable object.
	 *
	 * Be sure to invoke the function with the iterable as context:
	 *
	 *     var iteratorFn = getIteratorFn(myIterable);
	 *     if (iteratorFn) {
	 *       var iterator = iteratorFn.call(myIterable);
	 *       ...
	 *     }
	 *
	 * @param {?object} maybeIterable
	 * @return {?function}
	 */
	function getIteratorFn(maybeIterable) {
	  var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
	  if (typeof iteratorFn === 'function') {
	    return iteratorFn;
	  }
	}
	
	module.exports = getIteratorFn;

/***/ },
/* 1022 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	/**
	 * Given any node return the first leaf node without children.
	 *
	 * @param {DOMElement|DOMTextNode} node
	 * @return {DOMElement|DOMTextNode}
	 */
	
	function getLeafNode(node) {
	  while (node && node.firstChild) {
	    node = node.firstChild;
	  }
	  return node;
	}
	
	/**
	 * Get the next sibling within a container. This will walk up the
	 * DOM if a node's siblings have been exhausted.
	 *
	 * @param {DOMElement|DOMTextNode} node
	 * @return {?DOMElement|DOMTextNode}
	 */
	function getSiblingNode(node) {
	  while (node) {
	    if (node.nextSibling) {
	      return node.nextSibling;
	    }
	    node = node.parentNode;
	  }
	}
	
	/**
	 * Get object describing the nodes which contain characters at offset.
	 *
	 * @param {DOMElement|DOMTextNode} root
	 * @param {number} offset
	 * @return {?object}
	 */
	function getNodeForCharacterOffset(root, offset) {
	  var node = getLeafNode(root);
	  var nodeStart = 0;
	  var nodeEnd = 0;
	
	  while (node) {
	    if (node.nodeType === 3) {
	      nodeEnd = nodeStart + node.textContent.length;
	
	      if (nodeStart <= offset && nodeEnd >= offset) {
	        return {
	          node: node,
	          offset: offset - nodeStart
	        };
	      }
	
	      nodeStart = nodeEnd;
	    }
	
	    node = getLeafNode(getSiblingNode(node));
	  }
	}
	
	module.exports = getNodeForCharacterOffset;

/***/ },
/* 1023 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ExecutionEnvironment = __webpack_require__(51);
	
	/**
	 * Generate a mapping of standard vendor prefixes using the defined style property and event name.
	 *
	 * @param {string} styleProp
	 * @param {string} eventName
	 * @returns {object}
	 */
	function makePrefixMap(styleProp, eventName) {
	  var prefixes = {};
	
	  prefixes[styleProp.toLowerCase()] = eventName.toLowerCase();
	  prefixes['Webkit' + styleProp] = 'webkit' + eventName;
	  prefixes['Moz' + styleProp] = 'moz' + eventName;
	  prefixes['ms' + styleProp] = 'MS' + eventName;
	  prefixes['O' + styleProp] = 'o' + eventName.toLowerCase();
	
	  return prefixes;
	}
	
	/**
	 * A list of event names to a configurable list of vendor prefixes.
	 */
	var vendorPrefixes = {
	  animationend: makePrefixMap('Animation', 'AnimationEnd'),
	  animationiteration: makePrefixMap('Animation', 'AnimationIteration'),
	  animationstart: makePrefixMap('Animation', 'AnimationStart'),
	  transitionend: makePrefixMap('Transition', 'TransitionEnd')
	};
	
	/**
	 * Event names that have already been detected and prefixed (if applicable).
	 */
	var prefixedEventNames = {};
	
	/**
	 * Element to check for prefixes on.
	 */
	var style = {};
	
	/**
	 * Bootstrap if a DOM exists.
	 */
	if (ExecutionEnvironment.canUseDOM) {
	  style = document.createElement('div').style;
	
	  // On some platforms, in particular some releases of Android 4.x,
	  // the un-prefixed "animation" and "transition" properties are defined on the
	  // style object but the events that fire will still be prefixed, so we need
	  // to check if the un-prefixed events are usable, and if not remove them from the map.
	  if (!('AnimationEvent' in window)) {
	    delete vendorPrefixes.animationend.animation;
	    delete vendorPrefixes.animationiteration.animation;
	    delete vendorPrefixes.animationstart.animation;
	  }
	
	  // Same as above
	  if (!('TransitionEvent' in window)) {
	    delete vendorPrefixes.transitionend.transition;
	  }
	}
	
	/**
	 * Attempts to determine the correct vendor prefixed event name.
	 *
	 * @param {string} eventName
	 * @returns {string}
	 */
	function getVendorPrefixedEventName(eventName) {
	  if (prefixedEventNames[eventName]) {
	    return prefixedEventNames[eventName];
	  } else if (!vendorPrefixes[eventName]) {
	    return eventName;
	  }
	
	  var prefixMap = vendorPrefixes[eventName];
	
	  for (var styleProp in prefixMap) {
	    if (prefixMap.hasOwnProperty(styleProp) && styleProp in style) {
	      return prefixedEventNames[eventName] = prefixMap[styleProp];
	    }
	  }
	
	  return '';
	}
	
	module.exports = getVendorPrefixedEventName;

/***/ },
/* 1024 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var escapeTextContentForBrowser = __webpack_require__(187);
	
	/**
	 * Escapes attribute value to prevent scripting attacks.
	 *
	 * @param {*} value Value to escape.
	 * @return {string} An escaped string.
	 */
	function quoteAttributeValueForBrowser(value) {
	  return '"' + escapeTextContentForBrowser(value) + '"';
	}
	
	module.exports = quoteAttributeValueForBrowser;

/***/ },
/* 1025 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ReactMount = __webpack_require__(395);
	
	module.exports = ReactMount.renderSubtreeIntoContainer;

/***/ },
/* 1026 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	module.exports = __webpack_require__(987);


/***/ },
/* 1027 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Facebook = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _utils = __webpack_require__(63);
	
	var _singlePlayer = __webpack_require__(81);
	
	var _singlePlayer2 = _interopRequireDefault(_singlePlayer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var SDK_URL = '//connect.facebook.net/en_US/sdk.js';
	var SDK_GLOBAL = 'FB';
	var SDK_GLOBAL_READY = 'fbAsyncInit';
	var MATCH_URL = /facebook\.com\/([^/?].+\/)?video(s|\.php)[/?].*$/;
	var PLAYER_ID_PREFIX = 'facebook-player-';
	
	var Facebook = exports.Facebook = function (_Component) {
	  _inherits(Facebook, _Component);
	
	  function Facebook() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, Facebook);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Facebook.__proto__ || Object.getPrototypeOf(Facebook)).call.apply(_ref, [this].concat(args))), _this), _this.callPlayer = _utils.callPlayer, _this.playerID = PLAYER_ID_PREFIX + (0, _utils.randomString)(), _this.mute = function () {
	      _this.callPlayer('mute');
	    }, _this.unmute = function () {
	      _this.callPlayer('unmute');
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(Facebook, [{
	    key: 'load',
	    value: function load(url, isReady) {
	      var _this2 = this;
	
	      if (isReady) {
	        (0, _utils.getSDK)(SDK_URL, SDK_GLOBAL, SDK_GLOBAL_READY).then(function (FB) {
	          return FB.XFBML.parse();
	        });
	        return;
	      }
	      (0, _utils.getSDK)(SDK_URL, SDK_GLOBAL, SDK_GLOBAL_READY).then(function (FB) {
	        FB.init({
	          appId: _this2.props.config.facebook.appId,
	          xfbml: true,
	          version: 'v2.5'
	        });
	        FB.Event.subscribe('xfbml.ready', function (msg) {
	          if (msg.type === 'video' && msg.id === _this2.playerID) {
	            _this2.player = msg.instance;
	            _this2.player.subscribe('startedPlaying', _this2.props.onPlay);
	            _this2.player.subscribe('paused', _this2.props.onPause);
	            _this2.player.subscribe('finishedPlaying', _this2.props.onEnded);
	            _this2.player.subscribe('startedBuffering', _this2.props.onBuffer);
	            _this2.player.subscribe('error', _this2.props.onError);
	            if (!_this2.props.muted) {
	              // Player is muted by default
	              _this2.callPlayer('unmute');
	            }
	            _this2.props.onReady();
	          }
	        });
	      });
	    }
	  }, {
	    key: 'play',
	    value: function play() {
	      this.callPlayer('play');
	    }
	  }, {
	    key: 'pause',
	    value: function pause() {
	      this.callPlayer('pause');
	    }
	  }, {
	    key: 'stop',
	    value: function stop() {
	      // Nothing to do
	    }
	  }, {
	    key: 'seekTo',
	    value: function seekTo(seconds) {
	      this.callPlayer('seek', seconds);
	    }
	  }, {
	    key: 'setVolume',
	    value: function setVolume(fraction) {
	      this.callPlayer('setVolume', fraction);
	    }
	  }, {
	    key: 'getDuration',
	    value: function getDuration() {
	      return this.callPlayer('getDuration');
	    }
	  }, {
	    key: 'getCurrentTime',
	    value: function getCurrentTime() {
	      return this.callPlayer('getCurrentPosition');
	    }
	  }, {
	    key: 'getSecondsLoaded',
	    value: function getSecondsLoaded() {
	      return null;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var style = {
	        width: '100%',
	        height: '100%',
	        backgroundColor: 'black'
	      };
	      return _react2['default'].createElement('div', {
	        style: style,
	        id: this.playerID,
	        className: 'fb-video',
	        'data-href': this.props.url,
	        'data-autoplay': this.props.playing ? 'true' : 'false',
	        'data-allowfullscreen': 'true',
	        'data-controls': this.props.controls ? 'true' : 'false'
	      });
	    }
	  }]);
	
	  return Facebook;
	}(_react.Component);
	
	Facebook.displayName = 'Facebook';
	
	Facebook.canPlay = function (url) {
	  return MATCH_URL.test(url);
	};
	
	Facebook.loopOnEnded = true;
	exports['default'] = (0, _singlePlayer2['default'])(Facebook);

/***/ },
/* 1028 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Mixcloud = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _utils = __webpack_require__(63);
	
	var _singlePlayer = __webpack_require__(81);
	
	var _singlePlayer2 = _interopRequireDefault(_singlePlayer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var SDK_URL = '//widget.mixcloud.com/media/js/widgetApi.js';
	var SDK_GLOBAL = 'Mixcloud';
	var MATCH_URL = /mixcloud\.com\/([^/]+\/[^/]+)/;
	
	var Mixcloud = exports.Mixcloud = function (_Component) {
	  _inherits(Mixcloud, _Component);
	
	  function Mixcloud() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, Mixcloud);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Mixcloud.__proto__ || Object.getPrototypeOf(Mixcloud)).call.apply(_ref, [this].concat(args))), _this), _this.callPlayer = _utils.callPlayer, _this.duration = null, _this.currentTime = null, _this.secondsLoaded = null, _this.mute = function () {
	      // No volume support
	    }, _this.unmute = function () {
	      // No volume support
	    }, _this.ref = function (iframe) {
	      _this.iframe = iframe;
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(Mixcloud, [{
	    key: 'load',
	    value: function load(url) {
	      var _this2 = this;
	
	      (0, _utils.getSDK)(SDK_URL, SDK_GLOBAL).then(function (Mixcloud) {
	        _this2.player = Mixcloud.PlayerWidget(_this2.iframe);
	        _this2.player.ready.then(function () {
	          _this2.player.events.play.on(_this2.props.onPlay);
	          _this2.player.events.pause.on(_this2.props.onPause);
	          _this2.player.events.ended.on(_this2.props.onEnded);
	          _this2.player.events.error.on(_this2.props.error);
	          _this2.player.events.progress.on(function (seconds, duration) {
	            _this2.currentTime = seconds;
	            _this2.duration = duration;
	          });
	          _this2.props.onReady();
	        });
	      }, this.props.onError);
	    }
	  }, {
	    key: 'play',
	    value: function play() {
	      this.callPlayer('play');
	    }
	  }, {
	    key: 'pause',
	    value: function pause() {
	      this.callPlayer('pause');
	    }
	  }, {
	    key: 'stop',
	    value: function stop() {
	      // Nothing to do
	    }
	  }, {
	    key: 'seekTo',
	    value: function seekTo(seconds) {
	      this.callPlayer('seek', seconds);
	    }
	  }, {
	    key: 'setVolume',
	    value: function setVolume(fraction) {
	      // No volume support
	    }
	  }, {
	    key: 'getDuration',
	    value: function getDuration() {
	      return this.duration;
	    }
	  }, {
	    key: 'getCurrentTime',
	    value: function getCurrentTime() {
	      return this.currentTime;
	    }
	  }, {
	    key: 'getSecondsLoaded',
	    value: function getSecondsLoaded() {
	      return null;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          url = _props.url,
	          config = _props.config;
	
	      var id = url.match(MATCH_URL)[1];
	      var style = {
	        width: '100%',
	        height: '100%'
	      };
	      var query = (0, _utils.queryString)(_extends({}, config.mixcloud.options, {
	        feed: '/' + id + '/'
	      }));
	      // We have to give the iframe a key here to prevent a
	      // weird dialog appearing when loading a new track
	      return _react2['default'].createElement('iframe', {
	        key: id,
	        ref: this.ref,
	        style: style,
	        src: 'https://www.mixcloud.com/widget/iframe/?' + query,
	        frameBorder: '0'
	      });
	    }
	  }]);
	
	  return Mixcloud;
	}(_react.Component);
	
	Mixcloud.displayName = 'Mixcloud';
	
	Mixcloud.canPlay = function (url) {
	  return MATCH_URL.test(url);
	};
	
	exports['default'] = (0, _singlePlayer2['default'])(Mixcloud);

/***/ },
/* 1029 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Streamable = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _utils = __webpack_require__(63);
	
	var _singlePlayer = __webpack_require__(81);
	
	var _singlePlayer2 = _interopRequireDefault(_singlePlayer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var SDK_URL = '//cdn.embed.ly/player-0.1.0.min.js';
	var SDK_GLOBAL = 'playerjs';
	var MATCH_URL = /streamable\.com\/([a-z0-9]+)$/;
	
	var Streamable = exports.Streamable = function (_Component) {
	  _inherits(Streamable, _Component);
	
	  function Streamable() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, Streamable);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Streamable.__proto__ || Object.getPrototypeOf(Streamable)).call.apply(_ref, [this].concat(args))), _this), _this.callPlayer = _utils.callPlayer, _this.duration = null, _this.currentTime = null, _this.secondsLoaded = null, _this.mute = function () {
	      _this.callPlayer('mute');
	    }, _this.unmute = function () {
	      _this.callPlayer('unmute');
	    }, _this.ref = function (iframe) {
	      _this.iframe = iframe;
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(Streamable, [{
	    key: 'load',
	    value: function load(url) {
	      var _this2 = this;
	
	      (0, _utils.getSDK)(SDK_URL, SDK_GLOBAL).then(function (playerjs) {
	        if (!_this2.iframe) return;
	        _this2.player = new playerjs.Player(_this2.iframe);
	        _this2.player.setLoop(_this2.props.loop);
	        _this2.player.on('ready', _this2.props.onReady);
	        _this2.player.on('play', _this2.props.onPlay);
	        _this2.player.on('pause', _this2.props.onPause);
	        _this2.player.on('seeked', _this2.props.onSeek);
	        _this2.player.on('ended', _this2.props.onEnded);
	        _this2.player.on('error', _this2.props.onError);
	        _this2.player.on('timeupdate', function (_ref2) {
	          var duration = _ref2.duration,
	              seconds = _ref2.seconds;
	
	          _this2.duration = duration;
	          _this2.currentTime = seconds;
	        });
	        _this2.player.on('buffered', function (_ref3) {
	          var percent = _ref3.percent;
	
	          if (_this2.duration) {
	            _this2.secondsLoaded = _this2.duration * percent;
	          }
	        });
	        if (_this2.props.muted) {
	          _this2.player.mute();
	        }
	      }, this.props.onError);
	    }
	  }, {
	    key: 'play',
	    value: function play() {
	      this.callPlayer('play');
	    }
	  }, {
	    key: 'pause',
	    value: function pause() {
	      this.callPlayer('pause');
	    }
	  }, {
	    key: 'stop',
	    value: function stop() {
	      // Nothing to do
	    }
	  }, {
	    key: 'seekTo',
	    value: function seekTo(seconds) {
	      this.callPlayer('setCurrentTime', seconds);
	    }
	  }, {
	    key: 'setVolume',
	    value: function setVolume(fraction) {
	      this.callPlayer('setVolume', fraction * 100);
	    }
	  }, {
	    key: 'getDuration',
	    value: function getDuration() {
	      return this.duration;
	    }
	  }, {
	    key: 'getCurrentTime',
	    value: function getCurrentTime() {
	      return this.currentTime;
	    }
	  }, {
	    key: 'getSecondsLoaded',
	    value: function getSecondsLoaded() {
	      return this.secondsLoaded;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var id = this.props.url.match(MATCH_URL)[1];
	      var style = {
	        width: '100%',
	        height: '100%'
	      };
	      return _react2['default'].createElement('iframe', {
	        ref: this.ref,
	        src: 'https://streamable.com/o/' + id,
	        frameBorder: '0',
	        scrolling: 'no',
	        style: style,
	        allowFullScreen: true
	      });
	    }
	  }]);
	
	  return Streamable;
	}(_react.Component);
	
	Streamable.displayName = 'Streamable';
	
	Streamable.canPlay = function (url) {
	  return MATCH_URL.test(url);
	};
	
	exports['default'] = (0, _singlePlayer2['default'])(Streamable);

/***/ },
/* 1030 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Twitch = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _utils = __webpack_require__(63);
	
	var _singlePlayer = __webpack_require__(81);
	
	var _singlePlayer2 = _interopRequireDefault(_singlePlayer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var SDK_URL = 'https://player.twitch.tv/js/embed/v1.js';
	var SDK_GLOBAL = 'Twitch';
	var MATCH_VIDEO_URL = /(?:www\.|go\.)?twitch\.tv\/videos\/(\d+)($|\?)/;
	var MATCH_CHANNEL_URL = /(?:www\.|go\.)?twitch\.tv\/([a-z0-9_]+)($|\?)/;
	var PLAYER_ID_PREFIX = 'twitch-player-';
	
	var Twitch = exports.Twitch = function (_Component) {
	  _inherits(Twitch, _Component);
	
	  function Twitch() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, Twitch);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Twitch.__proto__ || Object.getPrototypeOf(Twitch)).call.apply(_ref, [this].concat(args))), _this), _this.callPlayer = _utils.callPlayer, _this.playerID = PLAYER_ID_PREFIX + (0, _utils.randomString)(), _this.mute = function () {
	      _this.callPlayer('setMuted', true);
	    }, _this.unmute = function () {
	      _this.callPlayer('setMuted', false);
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(Twitch, [{
	    key: 'load',
	    value: function load(url, isReady) {
	      var _this2 = this;
	
	      var _props = this.props,
	          playsinline = _props.playsinline,
	          onError = _props.onError,
	          config = _props.config;
	
	      var isChannel = MATCH_CHANNEL_URL.test(url);
	      var id = isChannel ? url.match(MATCH_CHANNEL_URL)[1] : url.match(MATCH_VIDEO_URL)[1];
	      if (isReady) {
	        if (isChannel) {
	          this.player.setChannel(id);
	        } else {
	          this.player.setVideo('v' + id);
	        }
	        return;
	      }
	      (0, _utils.getSDK)(SDK_URL, SDK_GLOBAL).then(function (Twitch) {
	        _this2.player = new Twitch.Player(_this2.playerID, _extends({
	          video: isChannel ? '' : id,
	          channel: isChannel ? id : '',
	          height: '100%',
	          width: '100%',
	          playsinline: playsinline,
	          autoplay: _this2.props.playing,
	          muted: _this2.props.muted
	        }, config.twitch.options));
	        var _Twitch$Player = Twitch.Player,
	            READY = _Twitch$Player.READY,
	            PLAY = _Twitch$Player.PLAY,
	            PAUSE = _Twitch$Player.PAUSE,
	            ENDED = _Twitch$Player.ENDED;
	
	        _this2.player.addEventListener(READY, _this2.props.onReady);
	        _this2.player.addEventListener(PLAY, _this2.props.onPlay);
	        _this2.player.addEventListener(PAUSE, _this2.props.onPause);
	        _this2.player.addEventListener(ENDED, _this2.props.onEnded);
	      }, onError);
	    }
	  }, {
	    key: 'play',
	    value: function play() {
	      this.callPlayer('play');
	    }
	  }, {
	    key: 'pause',
	    value: function pause() {
	      this.callPlayer('pause');
	    }
	  }, {
	    key: 'stop',
	    value: function stop() {
	      this.callPlayer('pause');
	    }
	  }, {
	    key: 'seekTo',
	    value: function seekTo(seconds) {
	      this.callPlayer('seek', seconds);
	    }
	  }, {
	    key: 'setVolume',
	    value: function setVolume(fraction) {
	      this.callPlayer('setVolume', fraction);
	    }
	  }, {
	    key: 'getDuration',
	    value: function getDuration() {
	      return this.callPlayer('getDuration');
	    }
	  }, {
	    key: 'getCurrentTime',
	    value: function getCurrentTime() {
	      return this.callPlayer('getCurrentTime');
	    }
	  }, {
	    key: 'getSecondsLoaded',
	    value: function getSecondsLoaded() {
	      return null;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var style = {
	        width: '100%',
	        height: '100%'
	      };
	      return _react2['default'].createElement('div', { style: style, id: this.playerID });
	    }
	  }]);
	
	  return Twitch;
	}(_react.Component);
	
	Twitch.displayName = 'Twitch';
	
	Twitch.canPlay = function (url) {
	  return MATCH_VIDEO_URL.test(url) || MATCH_CHANNEL_URL.test(url);
	};
	
	Twitch.loopOnEnded = true;
	exports['default'] = (0, _singlePlayer2['default'])(Twitch);

/***/ },
/* 1031 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Wistia = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _utils = __webpack_require__(63);
	
	var _singlePlayer = __webpack_require__(81);
	
	var _singlePlayer2 = _interopRequireDefault(_singlePlayer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var SDK_URL = '//fast.wistia.com/assets/external/E-v1.js';
	var SDK_GLOBAL = 'Wistia';
	var MATCH_URL = /(?:wistia\.com|wi\.st)\/(?:medias|embed)\/(.*)$/;
	
	var Wistia = exports.Wistia = function (_Component) {
	  _inherits(Wistia, _Component);
	
	  function Wistia() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, Wistia);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Wistia.__proto__ || Object.getPrototypeOf(Wistia)).call.apply(_ref, [this].concat(args))), _this), _this.callPlayer = _utils.callPlayer, _this.mute = function () {
	      _this.callPlayer('mute');
	    }, _this.unmute = function () {
	      _this.callPlayer('unmute');
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(Wistia, [{
	    key: 'getID',
	    value: function getID(url) {
	      return url && url.match(MATCH_URL)[1];
	    }
	  }, {
	    key: 'load',
	    value: function load(url) {
	      var _this2 = this;
	
	      var _props = this.props,
	          playing = _props.playing,
	          muted = _props.muted,
	          controls = _props.controls,
	          _onReady = _props.onReady,
	          onPlay = _props.onPlay,
	          onPause = _props.onPause,
	          onSeek = _props.onSeek,
	          onEnded = _props.onEnded,
	          config = _props.config;
	
	      (0, _utils.getSDK)(SDK_URL, SDK_GLOBAL).then(function () {
	        window._wq = window._wq || [];
	        window._wq.push({
	          id: _this2.getID(url),
	          options: _extends({
	            autoPlay: playing,
	            silentAutoPlay: 'allow',
	            muted: muted,
	            controlsVisibleOnLoad: controls
	          }, config.wistia.options),
	          onReady: function onReady(player) {
	            _this2.player = player;
	            _this2.player.bind('play', onPlay);
	            _this2.player.bind('pause', onPause);
	            _this2.player.bind('seek', onSeek);
	            _this2.player.bind('end', onEnded);
	            _onReady();
	          }
	        });
	      });
	    }
	  }, {
	    key: 'play',
	    value: function play() {
	      this.callPlayer('play');
	    }
	  }, {
	    key: 'pause',
	    value: function pause() {
	      this.callPlayer('pause');
	    }
	  }, {
	    key: 'stop',
	    value: function stop() {
	      this.callPlayer('remove');
	    }
	  }, {
	    key: 'seekTo',
	    value: function seekTo(seconds) {
	      this.callPlayer('time', seconds);
	    }
	  }, {
	    key: 'setVolume',
	    value: function setVolume(fraction) {
	      this.callPlayer('volume', fraction);
	    }
	  }, {
	    key: 'setPlaybackRate',
	    value: function setPlaybackRate(rate) {
	      this.callPlayer('playbackRate', rate);
	    }
	  }, {
	    key: 'getDuration',
	    value: function getDuration() {
	      return this.callPlayer('duration');
	    }
	  }, {
	    key: 'getCurrentTime',
	    value: function getCurrentTime() {
	      return this.callPlayer('time');
	    }
	  }, {
	    key: 'getSecondsLoaded',
	    value: function getSecondsLoaded() {
	      return null;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var id = this.getID(this.props.url);
	      var className = 'wistia_embed wistia_async_' + id;
	      var style = {
	        width: '100%',
	        height: '100%'
	      };
	      return _react2['default'].createElement('div', { key: id, className: className, style: style });
	    }
	  }]);
	
	  return Wistia;
	}(_react.Component);
	
	Wistia.displayName = 'Wistia';
	
	Wistia.canPlay = function (url) {
	  return MATCH_URL.test(url);
	};
	
	Wistia.loopOnEnded = true;
	exports['default'] = (0, _singlePlayer2['default'])(Wistia);

/***/ },
/* 1032 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _YouTube = __webpack_require__(412);
	
	var _SoundCloud = __webpack_require__(410);
	
	var _Vimeo = __webpack_require__(411);
	
	var _Facebook = __webpack_require__(1027);
	
	var _Streamable = __webpack_require__(1029);
	
	var _Wistia = __webpack_require__(1031);
	
	var _Twitch = __webpack_require__(1030);
	
	var _DailyMotion = __webpack_require__(408);
	
	var _Mixcloud = __webpack_require__(1028);
	
	var _FilePlayer = __webpack_require__(409);
	
	exports['default'] = [_YouTube.YouTube, _SoundCloud.SoundCloud, _Vimeo.Vimeo, _Facebook.Facebook, _Streamable.Streamable, _Wistia.Wistia, _Twitch.Twitch, _DailyMotion.DailyMotion, _Mixcloud.Mixcloud, _FilePlayer.FilePlayer];

/***/ },
/* 1033 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports['default'] = renderPreloadPlayers;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Player = __webpack_require__(265);
	
	var _Player2 = _interopRequireDefault(_Player);
	
	var _YouTube = __webpack_require__(412);
	
	var _SoundCloud = __webpack_require__(410);
	
	var _Vimeo = __webpack_require__(411);
	
	var _DailyMotion = __webpack_require__(408);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var PRELOAD_PLAYERS = [{
	  Player: _YouTube.YouTube,
	  configKey: 'youtube',
	  url: 'https://www.youtube.com/watch?v=GlCmAC4MHek'
	}, {
	  Player: _SoundCloud.SoundCloud,
	  configKey: 'soundcloud',
	  url: 'https://soundcloud.com/seucheu/john-cage-433-8-bit-version'
	}, {
	  Player: _Vimeo.Vimeo,
	  configKey: 'vimeo',
	  url: 'https://vimeo.com/127250231'
	}, {
	  Player: _DailyMotion.DailyMotion,
	  configKey: 'dailymotion',
	  url: 'http://www.dailymotion.com/video/xqdpyk'
	}];
	
	function renderPreloadPlayers(url, config) {
	  var players = [];
	
	  var _iteratorNormalCompletion = true;
	  var _didIteratorError = false;
	  var _iteratorError = undefined;
	
	  try {
	    for (var _iterator = PRELOAD_PLAYERS[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	      var player = _step.value;
	
	      if (!player.Player.canPlay(url) && config[player.configKey].preload) {
	        players.push(_react2['default'].createElement(_Player2['default'], {
	          key: player.Player.displayName,
	          activePlayer: player.Player,
	          url: player.url,
	          playing: true,
	          muted: true,
	          style: { display: 'none' }
	        }));
	      }
	    }
	  } catch (err) {
	    _didIteratorError = true;
	    _iteratorError = err;
	  } finally {
	    try {
	      if (!_iteratorNormalCompletion && _iterator['return']) {
	        _iterator['return']();
	      }
	    } finally {
	      if (_didIteratorError) {
	        throw _iteratorError;
	      }
	    }
	  }
	
	  return players;
	}

/***/ },
/* 1034 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var React = __webpack_require__(1);
	var ReactDOM = __webpack_require__(55);
	var createClass = __webpack_require__(73);
	var QuillMixin = __webpack_require__(413);
	var find = __webpack_require__(367);
	var some = __webpack_require__(934);
	var isEqual = __webpack_require__(370);
	var T = __webpack_require__(2);
	var DOM = __webpack_require__(381);
	
	var QuillComponent = createClass({
	
		displayName: 'Quill',
	
		mixins: [ QuillMixin ],
	
		propTypes: {
			id: T.string,
			className: T.string,
			theme: T.string,
			style: T.object,
			readOnly: T.bool,
			value: T.oneOfType([T.string, T.shape({ops: T.array})]),
			defaultValue: T.oneOfType([T.string, T.shape({ops: T.array})]),
			placeholder: T.string,
			tabIndex: T.number,
			bounds: T.oneOfType([T.string, T.element]),
			onChange: T.func,
			onChangeSelection: T.func,
			onFocus: T.func,
			onBlur: T.func,
			onKeyPress: T.func,
			onKeyDown: T.func,
			onKeyUp: T.func,
	
			modules: function(props) {
				var isNotObject = T.object.apply(this, arguments);
				if (isNotObject) return isNotObject;
	
				if (
					props.modules && 
					props.modules.toolbar &&
					props.modules.toolbar[0] &&
					props.modules.toolbar[0].type
				) return new Error(
					'Since v1.0.0, React Quill will not create a custom toolbar for you ' +
					'anymore. Create a toolbar explictly, or let Quill create one. ' +
					'See: https://github.com/zenoamaro/react-quill#upgrading-to-react-quill-v100'
				);
			},
	
			toolbar: function(props) {
				if ('toolbar' in props) return new Error(
					'The `toolbar` prop has been deprecated. Use `modules.toolbar` instead. ' +
					'See: https://github.com/zenoamaro/react-quill#upgrading-to-react-quill-v100'
				);
			},
	
			formats: function(props) {
				var isNotArrayOfString = T.arrayOf(T.string).apply(this, arguments);
	
				if (isNotArrayOfString) return new Error(
					'You cannot specify custom `formats` anymore. Use Parchment instead.  ' +
					'See: https://github.com/zenoamaro/react-quill#upgrading-to-react-quill-v100.'
				);
			},
	
			styles: function(props) {
				if ('styles' in props) return new Error(
					'The `styles` prop has been deprecated. Use custom stylesheets instead. ' +
					'See: https://github.com/zenoamaro/react-quill#upgrading-to-react-quill-v100.'
				);
			},
	
			pollInterval: function(props) {
				if ('pollInterval' in props) return new Error(
					'The `pollInterval` property does not have any effect anymore. ' +
					'You can safely remove it from your props.' +
					'See: https://github.com/zenoamaro/react-quill#upgrading-to-react-quill-v100.'
				);
			},
	
			children: function(props) {
				// Validate that the editor has only one child element and it is not a <textarea>
				var isNotASingleElement = T.element.apply(this, arguments);
				if (isNotASingleElement) return new Error(
					'The Quill editing area can only be composed of a single React element.'
				);
	
				if (React.Children.count(props.children)) {
					var child = React.Children.only(props.children);
					if (child.type === 'textarea') return new Error(
						'Quill does not support editing on a <textarea>. Use a <div> instead.'
					);
				}
			}
		},
			
		/*
		Changing one of these props should cause a full re-render.
		*/
		dirtyProps: [
			'modules',
			'formats',
			'bounds',
			'theme',
			'children',
		],
	
		/*
		Changing one of these props should cause a regular update.
		*/
		cleanProps: [
			'id',
			'className',
			'style',
			'placeholder',
			'tabIndex',
			'onChange',
			'onChangeSelection',
			'onFocus',
			'onBlur',
			'onKeyPress',
			'onKeyDown',
			'onKeyUp',
		],
	
		getDefaultProps: function() {
			return {
				theme: 'snow',
				modules: {},
			};
		},
	
		/*
		We consider the component to be controlled if `value` is being sent in props.
		*/
		isControlled: function() {
			return 'value' in this.props;
		},
	
		getInitialState: function() {
			return {
				generation: 0,
				value: this.isControlled()
					? this.props.value
					: this.props.defaultValue
			};
		},
	
		componentWillReceiveProps: function(nextProps, nextState) {
			var editor = this.editor;
	
			// If the component is unmounted and mounted too quickly
			// an error is thrown in setEditorContents since editor is
			// still undefined. Must check if editor is undefined
			// before performing this call.
			if (!editor) return;
			
			// Update only if we've been passed a new `value`.
			// This leaves components using `defaultValue` alone.
			if ('value' in nextProps) {
				var currentContents = this.getEditorContents();
				var nextContents = nextProps.value;
	
				if (nextContents === this.lastDeltaChangeSet) throw new Error(
					'You are passing the `delta` object from the `onChange` event back ' +
					'as `value`. You most probably want `editor.getContents()` instead. ' +
					'See: https://github.com/zenoamaro/react-quill#using-deltas'
				);
	
				// NOTE: Seeing that Quill is missing a way to prevent
				//       edits, we have to settle for a hybrid between
				//       controlled and uncontrolled mode. We can't prevent
				//       the change, but we'll still override content
				//       whenever `value` differs from current state.
				// NOTE: Comparing an HTML string and a Quill Delta will always trigger 
				//       a change, regardless of whether they represent the same document.
				if (!this.isEqualValue(nextContents, currentContents)) {
					this.setEditorContents(editor, nextContents);
				}
			}
			
			// We can update readOnly state in-place.
			if ('readOnly' in nextProps) {
				if (nextProps.readOnly !== this.props.readOnly) {
					this.setEditorReadOnly(editor, nextProps.readOnly);
				}
			}
	
			// If we need to regenerate the component, we can avoid a detailed
			// in-place update step, and just let everything rerender.
			if (this.shouldComponentRegenerate(nextProps, nextState)) {
				return this.regenerate();
			}
		},
	
		componentDidMount: function() {
			this.editor = this.createEditor(
				this.getEditingArea(),
				this.getEditorConfig()
			);
			// Restore editor from Quill's native formats in regeneration scenario
			if (this.quillDelta) {
				this.editor.setContents(this.quillDelta);
				this.editor.setSelection(this.quillSelection);		
				this.editor.focus();
				this.quillDelta = this.quillSelection = null;
				return;
			}
			if (this.state.value) {
				this.setEditorContents(this.editor, this.state.value);
				return;
			}
		},
	
		componentWillUnmount: function() {
			var editor; if ((editor = this.getEditor())) {
				this.unhookEditor(editor);
				this.editor = null;
			}
		},
	
		shouldComponentUpdate: function(nextProps, nextState) {
			var self = this;
	
			// If the component has been regenerated, we already know we should update.
			if (this.state.generation !== nextState.generation) {
				return true;
			}
			
			// Compare props that require React updating the DOM.
			return some(this.cleanProps, function(prop) {
				// Note that `isEqual` compares deeply, making it safe to perform
				// non-immutable updates, at the cost of performance.
				return !isEqual(nextProps[prop], self.props[prop]);
			});
		},
	
		shouldComponentRegenerate: function(nextProps, nextState) {
			var self = this;
			// Whenever a `dirtyProp` changes, the editor needs reinstantiation.
			return some(this.dirtyProps, function(prop) {
				// Note that `isEqual` compares deeply, making it safe to perform
				// non-immutable updates, at the cost of performance.
				return !isEqual(nextProps[prop], self.props[prop]);
			});
		},
	
		/*
		If we could not update settings from the new props in-place, we have to tear
		down everything and re-render from scratch.
		*/
		componentWillUpdate: function(nextProps, nextState) {
			if (this.state.generation !== nextState.generation) {
				this.componentWillUnmount();
			}
		},
	
		componentDidUpdate: function(prevProps, prevState) {
			if (this.state.generation !== prevState.generation) {
				this.componentDidMount();
			}
		},
	
		getEditorConfig: function() {
			return {
				bounds:       this.props.bounds,
				formats:      this.props.formats,
				modules:      this.props.modules,
				placeholder:  this.props.placeholder,
				readOnly:     this.props.readOnly,
	      			scrollingContainer: this.props.scrollingContainer,
				tabIndex:     this.props.tabIndex,
				theme:        this.props.theme,
			};
		},
	
		getEditor: function() {
			return this.editor;
		},
	
		getEditingArea: function () {
			return ReactDOM.findDOMNode(this.editingArea);
		},
	
		getEditorContents: function() {
			return this.state.value;
		},
	
		getEditorSelection: function() {
			return this.state.selection;
		},
	
		/*
		True if the value is a Delta instance or a Delta look-alike.
		*/
		isDelta: function(value) {
			return value && value.ops;
		},
	
		/*
		Special comparison function that knows how to compare Deltas.
		*/
		isEqualValue: function(value, nextValue) {
			if (this.isDelta(value) && this.isDelta(nextValue)) {
				return isEqual(value.ops, nextValue.ops);
			} else {
				return isEqual(value, nextValue);
			}
		},
	
		/*
		Regenerating the editor will cause the whole tree, including the container,
		to be cleaned up and re-rendered from scratch.
		*/
		regenerate: function() {
			// Cache selection and contents in Quill's native format to be restored later
			this.quillDelta = this.editor.getContents();
			this.quillSelection = this.editor.getSelection();
			this.setState({
				generation: this.state.generation + 1,
			});
		},
	
		/*
		Renders an editor area, unless it has been provided one to clone.
		*/
		renderEditingArea: function() {
			var self = this;
			var children = this.props.children;
	
			var properties = {
				key: this.state.generation,
				tabIndex: this.props.tabIndex,
				ref: function(element) { self.editingArea = element },
			};
	
			var customElement = React.Children.count(children)
				? React.Children.only(children)
				: null;
	
			var editingArea = customElement
				? React.cloneElement(customElement, properties)
				: DOM.div(properties);
	
			return editingArea;
		},
	
		render: function() {
			return DOM.div({
				id: this.props.id,
				style: this.props.style,
				key: this.state.generation,
				className: ['quill'].concat(this.props.className).join(' '),
				onKeyPress: this.props.onKeyPress,
				onKeyDown: this.props.onKeyDown,
				onKeyUp: this.props.onKeyUp },
				this.renderEditingArea()
			);
		},
	
		onEditorChangeText: function(value, delta, source, editor) {
			var currentContents = this.getEditorContents();
	
			// We keep storing the same type of value as what the user gives us,
			// so that value comparisons will be more stable and predictable.
			var nextContents = this.isDelta(currentContents)
				? editor.getContents()
				: editor.getHTML();
			
			if (!this.isEqualValue(nextContents, currentContents)) {
				// Taint this `delta` object, so we can recognize whether the user
				// is trying to send it back as `value`, preventing a likely loop.
				this.lastDeltaChangeSet = delta;
	
				this.setState({ value: nextContents });
	
				if (this.props.onChange) {
					this.props.onChange(value, delta, source, editor);
				}
			}
		},
	
		onEditorChangeSelection: function(nextSelection, source, editor) {
			var currentSelection = this.getEditorSelection();
			var hasGainedFocus = !currentSelection && nextSelection;
			var hasLostFocus = currentSelection && !nextSelection;
	
			if (isEqual(nextSelection, currentSelection)) {
				return;
			}
			
			this.setState({ selection: nextSelection });
			
			if (this.props.onChangeSelection) {
				this.props.onChangeSelection(nextSelection, source, editor);
			}
	
			if (hasGainedFocus && this.props.onFocus) {
				this.props.onFocus(nextSelection, source, editor);
			} else if (hasLostFocus && this.props.onBlur) {
				this.props.onBlur(currentSelection, source, editor);
			}
		},
	
		focus: function() {
			this.editor.focus();
		},
	
		blur: function() {
			this.setEditorSelection(this.editor, null);
		}
	
	});
	
	module.exports = QuillComponent;


/***/ },
/* 1035 */
/***/ function(module, exports, __webpack_require__) {

	/*
	React-Quill v1.0.0
	https://github.com/zenoamaro/react-quill
	*/
	var Quill = __webpack_require__(380);
	var Component = __webpack_require__(1034);
	
	module.exports = Component;
	module.exports.default = Component;
	module.exports.Quill = Quill;
	module.exports.Mixin = __webpack_require__(413);
	module.exports.Toolbar = __webpack_require__(1036);


/***/ },
/* 1036 */
/***/ function(module, exports, __webpack_require__) {

	/*
	QuillToolbar is deprecated. Consider switching to the official Quill
	toolbar format, or providing your own toolbar instead. 
	See https://quilljs.com/docs/modules/toolbar
	*/
	
	'use strict';
	
	var React = __webpack_require__(1);
	var ReactDOMServer = __webpack_require__(1026);
	var createClass = __webpack_require__(73);
	var find = __webpack_require__(367);
	var isEqual = __webpack_require__(370);
	var T = __webpack_require__(2);
	var DOM = __webpack_require__(381);
	
	var defaultColors = [
		'rgb(  0,   0,   0)', 'rgb(230,   0,   0)', 'rgb(255, 153,   0)',
		'rgb(255, 255,   0)', 'rgb(  0, 138,   0)', 'rgb(  0, 102, 204)',
		'rgb(153,  51, 255)', 'rgb(255, 255, 255)', 'rgb(250, 204, 204)',
		'rgb(255, 235, 204)', 'rgb(255, 255, 204)', 'rgb(204, 232, 204)',
		'rgb(204, 224, 245)', 'rgb(235, 214, 255)', 'rgb(187, 187, 187)',
		'rgb(240, 102, 102)', 'rgb(255, 194, 102)', 'rgb(255, 255, 102)',
		'rgb(102, 185, 102)', 'rgb(102, 163, 224)', 'rgb(194, 133, 255)',
		'rgb(136, 136, 136)', 'rgb(161,   0,   0)', 'rgb(178, 107,   0)',
		'rgb(178, 178,   0)', 'rgb(  0,  97,   0)', 'rgb(  0,  71, 178)',
		'rgb(107,  36, 178)', 'rgb( 68,  68,  68)', 'rgb( 92,   0,   0)',
		'rgb(102,  61,   0)', 'rgb(102, 102,   0)', 'rgb(  0,  55,   0)',
		'rgb(  0,  41, 102)', 'rgb( 61,  20,  10)',
	].map(function(color){ return { value: color } });
	
	var defaultItems = [
	
		{ label:'Formats', type:'group', items: [
			{ label:'Font', type:'font', items: [
				{ label:'Sans Serif',  value:'sans-serif', selected:true },
				{ label:'Serif',       value:'serif' },
				{ label:'Monospace',   value:'monospace' }
			]},
			{ label:'Size', type:'size', items: [
				{ label:'Small',  value:'10px' },
				{ label:'Normal', value:'13px', selected:true },
				{ label:'Large',  value:'18px' },
				{ label:'Huge',   value:'32px' }
			]},
			{ label:'Alignment', type:'align', items: [
				{ label:'', value:'', selected:true },
				{ label:'', value:'center' },
				{ label:'', value:'right' },
				{ label:'', value:'justify' }
			]}
		]},
	
		{ label:'Text', type:'group', items: [
			{ type:'bold', label:'Bold' },
			{ type:'italic', label:'Italic' },
			{ type:'strike', label:'Strike' },
			{ type:'underline', label:'Underline' },
			{ type:'color', label:'Color', items:defaultColors },
			{ type:'background', label:'Background color', items:defaultColors },
			{ type:'link', label:'Link' }
		]},
	
		{ label:'Blocks', type:'group', items: [
			{ type:'list', value:'bullet' },
			{ type:'list', value:'ordered' }
		]},
	
		{ label:'Blocks', type:'group', items: [
			{ type:'image', label:'Image' }
		]}
	
	];
	
	var QuillToolbar = createClass({
	
		displayName: 'Quill Toolbar',
	
		propTypes: {
			id:        T.string,
			className: T.string,
			style:     T.object,
			items:     T.array
		},
	
		getDefaultProps: function() {
			return {
				items: defaultItems
			};
		},
	
		componentDidMount: function() {
			console.warn(
				'QuillToolbar is deprecated. Consider switching to the official Quill ' +
				'toolbar format, or providing your own toolbar instead. ' +
				'See: https://github.com/zenoamaro/react-quill#upgrading-to-react-quill-v1-0-0'
			);
		},
	
		shouldComponentUpdate: function(nextProps, nextState) {
			return !isEqual(nextProps, this.props);
		},
	
		renderGroup: function(item, key) {
			return DOM.span({
				key: item.label || key,
				className:'ql-formats' },
				item.items.map(this.renderItem)
			);
		},
	
		renderChoiceItem: function(item, key) {
			return DOM.option({
				key: item.label || item.value || key,
				value: item.value },
				item.label
			);
		},
	
		renderChoices: function(item, key) {
			var choiceItems = item.items.map(this.renderChoiceItem);
			var selectedItem = find(item.items, function(item){ return item.selected });
			var attrs = {
				key: item.label || key,
				title: item.label,
				className: 'ql-'+item.type,
				value: selectedItem.value,
			};
			return DOM.select(attrs, choiceItems);
		},
	
		renderButton: function(item, key) {
			return DOM.button({
				type: 'button',
				key: item.label || item.value || key,
				value: item.value,
				className: 'ql-'+item.type,
				title: item.label },
				item.children
			);
		},
	
		renderAction: function(item, key) {
			return DOM.button({
				key: item.label || item.value || key,
				className: 'ql-'+item.type,
				title: item.label },
				item.children
			);
		},
	
		/* jshint maxcomplexity: false */
		renderItem: function(item, key) {
			switch (item.type) {
				case 'group':
					return this.renderGroup(item, key);
				case 'font':
				case 'header':
				case 'align':
				case 'size':
				case 'color':
				case 'background':
					return this.renderChoices(item, key);
				case 'bold':
				case 'italic':
				case 'underline':
				case 'strike':
				case 'link':
				case 'list':
				case 'bullet':
				case 'ordered':
				case 'indent':
				case 'image':
				case 'video':
					return this.renderButton(item, key);
				default:
					return this.renderAction(item, key);
			}
		},
	
		getClassName: function() {
			return 'quill-toolbar ' + (this.props.className||'');
		},
	
		render: function() {
			var children = this.props.items.map(this.renderItem);
			var html = children.map(ReactDOMServer.renderToStaticMarkup).join('');
			return DOM.div({
				id: this.props.id,
				className: this.getClassName(),
				style: this.props.style,
				dangerouslySetInnerHTML: { __html:html }
			});
		},
	
	});
	
	module.exports = QuillToolbar;
	QuillToolbar.defaultItems = defaultItems;
	QuillToolbar.defaultColors = defaultColors;


/***/ },
/* 1037 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.createProvider = createProvider;
	
	var _react = __webpack_require__(1);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _PropTypes = __webpack_require__(416);
	
	var _warning = __webpack_require__(266);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var didWarnAboutReceivingStore = false;
	function warnAboutReceivingStore() {
	  if (didWarnAboutReceivingStore) {
	    return;
	  }
	  didWarnAboutReceivingStore = true;
	
	  (0, _warning2.default)('<Provider> does not support changing `store` on the fly. ' + 'It is most likely that you see this error because you updated to ' + 'Redux 2.x and React Redux 2.x which no longer hot reload reducers ' + 'automatically. See https://github.com/reactjs/react-redux/releases/' + 'tag/v2.0.0 for the migration instructions.');
	}
	
	function createProvider() {
	  var _Provider$childContex;
	
	  var storeKey = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'store';
	  var subKey = arguments[1];
	
	  var subscriptionKey = subKey || storeKey + 'Subscription';
	
	  var Provider = function (_Component) {
	    _inherits(Provider, _Component);
	
	    Provider.prototype.getChildContext = function getChildContext() {
	      var _ref;
	
	      return _ref = {}, _ref[storeKey] = this[storeKey], _ref[subscriptionKey] = null, _ref;
	    };
	
	    function Provider(props, context) {
	      _classCallCheck(this, Provider);
	
	      var _this = _possibleConstructorReturn(this, _Component.call(this, props, context));
	
	      _this[storeKey] = props.store;
	      return _this;
	    }
	
	    Provider.prototype.render = function render() {
	      return _react.Children.only(this.props.children);
	    };
	
	    return Provider;
	  }(_react.Component);
	
	  if (false) {
	    Provider.prototype.componentWillReceiveProps = function (nextProps) {
	      if (this[storeKey] !== nextProps.store) {
	        warnAboutReceivingStore();
	      }
	    };
	  }
	
	  Provider.propTypes = {
	    store: _PropTypes.storeShape.isRequired,
	    children: _propTypes2.default.element.isRequired
	  };
	  Provider.childContextTypes = (_Provider$childContex = {}, _Provider$childContex[storeKey] = _PropTypes.storeShape.isRequired, _Provider$childContex[subscriptionKey] = _PropTypes.subscriptionShape, _Provider$childContex);
	
	  return Provider;
	}
	
	exports.default = createProvider();

/***/ },
/* 1038 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.createConnect = createConnect;
	
	var _connectAdvanced = __webpack_require__(414);
	
	var _connectAdvanced2 = _interopRequireDefault(_connectAdvanced);
	
	var _shallowEqual = __webpack_require__(1045);
	
	var _shallowEqual2 = _interopRequireDefault(_shallowEqual);
	
	var _mapDispatchToProps = __webpack_require__(1039);
	
	var _mapDispatchToProps2 = _interopRequireDefault(_mapDispatchToProps);
	
	var _mapStateToProps = __webpack_require__(1040);
	
	var _mapStateToProps2 = _interopRequireDefault(_mapStateToProps);
	
	var _mergeProps = __webpack_require__(1041);
	
	var _mergeProps2 = _interopRequireDefault(_mergeProps);
	
	var _selectorFactory = __webpack_require__(1042);
	
	var _selectorFactory2 = _interopRequireDefault(_selectorFactory);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	/*
	  connect is a facade over connectAdvanced. It turns its args into a compatible
	  selectorFactory, which has the signature:
	
	    (dispatch, options) => (nextState, nextOwnProps) => nextFinalProps
	  
	  connect passes its args to connectAdvanced as options, which will in turn pass them to
	  selectorFactory each time a Connect component instance is instantiated or hot reloaded.
	
	  selectorFactory returns a final props selector from its mapStateToProps,
	  mapStateToPropsFactories, mapDispatchToProps, mapDispatchToPropsFactories, mergeProps,
	  mergePropsFactories, and pure args.
	
	  The resulting final props selector is called by the Connect component instance whenever
	  it receives new props or store state.
	 */
	
	function match(arg, factories, name) {
	  for (var i = factories.length - 1; i >= 0; i--) {
	    var result = factories[i](arg);
	    if (result) return result;
	  }
	
	  return function (dispatch, options) {
	    throw new Error('Invalid value of type ' + typeof arg + ' for ' + name + ' argument when connecting component ' + options.wrappedComponentName + '.');
	  };
	}
	
	function strictEqual(a, b) {
	  return a === b;
	}
	
	// createConnect with default args builds the 'official' connect behavior. Calling it with
	// different options opens up some testing and extensibility scenarios
	function createConnect() {
	  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
	      _ref$connectHOC = _ref.connectHOC,
	      connectHOC = _ref$connectHOC === undefined ? _connectAdvanced2.default : _ref$connectHOC,
	      _ref$mapStateToPropsF = _ref.mapStateToPropsFactories,
	      mapStateToPropsFactories = _ref$mapStateToPropsF === undefined ? _mapStateToProps2.default : _ref$mapStateToPropsF,
	      _ref$mapDispatchToPro = _ref.mapDispatchToPropsFactories,
	      mapDispatchToPropsFactories = _ref$mapDispatchToPro === undefined ? _mapDispatchToProps2.default : _ref$mapDispatchToPro,
	      _ref$mergePropsFactor = _ref.mergePropsFactories,
	      mergePropsFactories = _ref$mergePropsFactor === undefined ? _mergeProps2.default : _ref$mergePropsFactor,
	      _ref$selectorFactory = _ref.selectorFactory,
	      selectorFactory = _ref$selectorFactory === undefined ? _selectorFactory2.default : _ref$selectorFactory;
	
	  return function connect(mapStateToProps, mapDispatchToProps, mergeProps) {
	    var _ref2 = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {},
	        _ref2$pure = _ref2.pure,
	        pure = _ref2$pure === undefined ? true : _ref2$pure,
	        _ref2$areStatesEqual = _ref2.areStatesEqual,
	        areStatesEqual = _ref2$areStatesEqual === undefined ? strictEqual : _ref2$areStatesEqual,
	        _ref2$areOwnPropsEqua = _ref2.areOwnPropsEqual,
	        areOwnPropsEqual = _ref2$areOwnPropsEqua === undefined ? _shallowEqual2.default : _ref2$areOwnPropsEqua,
	        _ref2$areStatePropsEq = _ref2.areStatePropsEqual,
	        areStatePropsEqual = _ref2$areStatePropsEq === undefined ? _shallowEqual2.default : _ref2$areStatePropsEq,
	        _ref2$areMergedPropsE = _ref2.areMergedPropsEqual,
	        areMergedPropsEqual = _ref2$areMergedPropsE === undefined ? _shallowEqual2.default : _ref2$areMergedPropsE,
	        extraOptions = _objectWithoutProperties(_ref2, ['pure', 'areStatesEqual', 'areOwnPropsEqual', 'areStatePropsEqual', 'areMergedPropsEqual']);
	
	    var initMapStateToProps = match(mapStateToProps, mapStateToPropsFactories, 'mapStateToProps');
	    var initMapDispatchToProps = match(mapDispatchToProps, mapDispatchToPropsFactories, 'mapDispatchToProps');
	    var initMergeProps = match(mergeProps, mergePropsFactories, 'mergeProps');
	
	    return connectHOC(selectorFactory, _extends({
	      // used in error messages
	      methodName: 'connect',
	
	      // used to compute Connect's displayName from the wrapped component's displayName.
	      getDisplayName: function getDisplayName(name) {
	        return 'Connect(' + name + ')';
	      },
	
	      // if mapStateToProps is falsy, the Connect component doesn't subscribe to store state changes
	      shouldHandleStateChanges: Boolean(mapStateToProps),
	
	      // passed through to selectorFactory
	      initMapStateToProps: initMapStateToProps,
	      initMapDispatchToProps: initMapDispatchToProps,
	      initMergeProps: initMergeProps,
	      pure: pure,
	      areStatesEqual: areStatesEqual,
	      areOwnPropsEqual: areOwnPropsEqual,
	      areStatePropsEqual: areStatePropsEqual,
	      areMergedPropsEqual: areMergedPropsEqual
	
	    }, extraOptions));
	  };
	}
	
	exports.default = createConnect();

/***/ },
/* 1039 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.whenMapDispatchToPropsIsFunction = whenMapDispatchToPropsIsFunction;
	exports.whenMapDispatchToPropsIsMissing = whenMapDispatchToPropsIsMissing;
	exports.whenMapDispatchToPropsIsObject = whenMapDispatchToPropsIsObject;
	
	var _redux = __webpack_require__(4);
	
	var _wrapMapToProps = __webpack_require__(415);
	
	function whenMapDispatchToPropsIsFunction(mapDispatchToProps) {
	  return typeof mapDispatchToProps === 'function' ? (0, _wrapMapToProps.wrapMapToPropsFunc)(mapDispatchToProps, 'mapDispatchToProps') : undefined;
	}
	
	function whenMapDispatchToPropsIsMissing(mapDispatchToProps) {
	  return !mapDispatchToProps ? (0, _wrapMapToProps.wrapMapToPropsConstant)(function (dispatch) {
	    return { dispatch: dispatch };
	  }) : undefined;
	}
	
	function whenMapDispatchToPropsIsObject(mapDispatchToProps) {
	  return mapDispatchToProps && typeof mapDispatchToProps === 'object' ? (0, _wrapMapToProps.wrapMapToPropsConstant)(function (dispatch) {
	    return (0, _redux.bindActionCreators)(mapDispatchToProps, dispatch);
	  }) : undefined;
	}
	
	exports.default = [whenMapDispatchToPropsIsFunction, whenMapDispatchToPropsIsMissing, whenMapDispatchToPropsIsObject];

/***/ },
/* 1040 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.whenMapStateToPropsIsFunction = whenMapStateToPropsIsFunction;
	exports.whenMapStateToPropsIsMissing = whenMapStateToPropsIsMissing;
	
	var _wrapMapToProps = __webpack_require__(415);
	
	function whenMapStateToPropsIsFunction(mapStateToProps) {
	  return typeof mapStateToProps === 'function' ? (0, _wrapMapToProps.wrapMapToPropsFunc)(mapStateToProps, 'mapStateToProps') : undefined;
	}
	
	function whenMapStateToPropsIsMissing(mapStateToProps) {
	  return !mapStateToProps ? (0, _wrapMapToProps.wrapMapToPropsConstant)(function () {
	    return {};
	  }) : undefined;
	}
	
	exports.default = [whenMapStateToPropsIsFunction, whenMapStateToPropsIsMissing];

/***/ },
/* 1041 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.defaultMergeProps = defaultMergeProps;
	exports.wrapMergePropsFunc = wrapMergePropsFunc;
	exports.whenMergePropsIsFunction = whenMergePropsIsFunction;
	exports.whenMergePropsIsOmitted = whenMergePropsIsOmitted;
	
	var _verifyPlainObject = __webpack_require__(417);
	
	var _verifyPlainObject2 = _interopRequireDefault(_verifyPlainObject);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function defaultMergeProps(stateProps, dispatchProps, ownProps) {
	  return _extends({}, ownProps, stateProps, dispatchProps);
	}
	
	function wrapMergePropsFunc(mergeProps) {
	  return function initMergePropsProxy(dispatch, _ref) {
	    var displayName = _ref.displayName,
	        pure = _ref.pure,
	        areMergedPropsEqual = _ref.areMergedPropsEqual;
	
	    var hasRunOnce = false;
	    var mergedProps = void 0;
	
	    return function mergePropsProxy(stateProps, dispatchProps, ownProps) {
	      var nextMergedProps = mergeProps(stateProps, dispatchProps, ownProps);
	
	      if (hasRunOnce) {
	        if (!pure || !areMergedPropsEqual(nextMergedProps, mergedProps)) mergedProps = nextMergedProps;
	      } else {
	        hasRunOnce = true;
	        mergedProps = nextMergedProps;
	
	        if (false) (0, _verifyPlainObject2.default)(mergedProps, displayName, 'mergeProps');
	      }
	
	      return mergedProps;
	    };
	  };
	}
	
	function whenMergePropsIsFunction(mergeProps) {
	  return typeof mergeProps === 'function' ? wrapMergePropsFunc(mergeProps) : undefined;
	}
	
	function whenMergePropsIsOmitted(mergeProps) {
	  return !mergeProps ? function () {
	    return defaultMergeProps;
	  } : undefined;
	}
	
	exports.default = [whenMergePropsIsFunction, whenMergePropsIsOmitted];

/***/ },
/* 1042 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.impureFinalPropsSelectorFactory = impureFinalPropsSelectorFactory;
	exports.pureFinalPropsSelectorFactory = pureFinalPropsSelectorFactory;
	exports.default = finalPropsSelectorFactory;
	
	var _verifySubselectors = __webpack_require__(1043);
	
	var _verifySubselectors2 = _interopRequireDefault(_verifySubselectors);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function impureFinalPropsSelectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch) {
	  return function impureFinalPropsSelector(state, ownProps) {
	    return mergeProps(mapStateToProps(state, ownProps), mapDispatchToProps(dispatch, ownProps), ownProps);
	  };
	}
	
	function pureFinalPropsSelectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, _ref) {
	  var areStatesEqual = _ref.areStatesEqual,
	      areOwnPropsEqual = _ref.areOwnPropsEqual,
	      areStatePropsEqual = _ref.areStatePropsEqual;
	
	  var hasRunAtLeastOnce = false;
	  var state = void 0;
	  var ownProps = void 0;
	  var stateProps = void 0;
	  var dispatchProps = void 0;
	  var mergedProps = void 0;
	
	  function handleFirstCall(firstState, firstOwnProps) {
	    state = firstState;
	    ownProps = firstOwnProps;
	    stateProps = mapStateToProps(state, ownProps);
	    dispatchProps = mapDispatchToProps(dispatch, ownProps);
	    mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
	    hasRunAtLeastOnce = true;
	    return mergedProps;
	  }
	
	  function handleNewPropsAndNewState() {
	    stateProps = mapStateToProps(state, ownProps);
	
	    if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);
	
	    mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
	    return mergedProps;
	  }
	
	  function handleNewProps() {
	    if (mapStateToProps.dependsOnOwnProps) stateProps = mapStateToProps(state, ownProps);
	
	    if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);
	
	    mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
	    return mergedProps;
	  }
	
	  function handleNewState() {
	    var nextStateProps = mapStateToProps(state, ownProps);
	    var statePropsChanged = !areStatePropsEqual(nextStateProps, stateProps);
	    stateProps = nextStateProps;
	
	    if (statePropsChanged) mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
	
	    return mergedProps;
	  }
	
	  function handleSubsequentCalls(nextState, nextOwnProps) {
	    var propsChanged = !areOwnPropsEqual(nextOwnProps, ownProps);
	    var stateChanged = !areStatesEqual(nextState, state);
	    state = nextState;
	    ownProps = nextOwnProps;
	
	    if (propsChanged && stateChanged) return handleNewPropsAndNewState();
	    if (propsChanged) return handleNewProps();
	    if (stateChanged) return handleNewState();
	    return mergedProps;
	  }
	
	  return function pureFinalPropsSelector(nextState, nextOwnProps) {
	    return hasRunAtLeastOnce ? handleSubsequentCalls(nextState, nextOwnProps) : handleFirstCall(nextState, nextOwnProps);
	  };
	}
	
	// TODO: Add more comments
	
	// If pure is true, the selector returned by selectorFactory will memoize its results,
	// allowing connectAdvanced's shouldComponentUpdate to return false if final
	// props have not changed. If false, the selector will always return a new
	// object and shouldComponentUpdate will always return true.
	
	function finalPropsSelectorFactory(dispatch, _ref2) {
	  var initMapStateToProps = _ref2.initMapStateToProps,
	      initMapDispatchToProps = _ref2.initMapDispatchToProps,
	      initMergeProps = _ref2.initMergeProps,
	      options = _objectWithoutProperties(_ref2, ['initMapStateToProps', 'initMapDispatchToProps', 'initMergeProps']);
	
	  var mapStateToProps = initMapStateToProps(dispatch, options);
	  var mapDispatchToProps = initMapDispatchToProps(dispatch, options);
	  var mergeProps = initMergeProps(dispatch, options);
	
	  if (false) {
	    (0, _verifySubselectors2.default)(mapStateToProps, mapDispatchToProps, mergeProps, options.displayName);
	  }
	
	  var selectorFactory = options.pure ? pureFinalPropsSelectorFactory : impureFinalPropsSelectorFactory;
	
	  return selectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, options);
	}

/***/ },
/* 1043 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = verifySubselectors;
	
	var _warning = __webpack_require__(266);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function verify(selector, methodName, displayName) {
	  if (!selector) {
	    throw new Error('Unexpected value for ' + methodName + ' in ' + displayName + '.');
	  } else if (methodName === 'mapStateToProps' || methodName === 'mapDispatchToProps') {
	    if (!selector.hasOwnProperty('dependsOnOwnProps')) {
	      (0, _warning2.default)('The selector for ' + methodName + ' of ' + displayName + ' did not specify a value for dependsOnOwnProps.');
	    }
	  }
	}
	
	function verifySubselectors(mapStateToProps, mapDispatchToProps, mergeProps, displayName) {
	  verify(mapStateToProps, 'mapStateToProps', displayName);
	  verify(mapDispatchToProps, 'mapDispatchToProps', displayName);
	  verify(mergeProps, 'mergeProps', displayName);
	}

/***/ },
/* 1044 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	// encapsulates the subscription logic for connecting a component to the redux store, as
	// well as nesting subscriptions of descendant components, so that we can ensure the
	// ancestor components re-render before descendants
	
	var CLEARED = null;
	var nullListeners = {
	  notify: function notify() {}
	};
	
	function createListenerCollection() {
	  // the current/next pattern is copied from redux's createStore code.
	  // TODO: refactor+expose that code to be reusable here?
	  var current = [];
	  var next = [];
	
	  return {
	    clear: function clear() {
	      next = CLEARED;
	      current = CLEARED;
	    },
	    notify: function notify() {
	      var listeners = current = next;
	      for (var i = 0; i < listeners.length; i++) {
	        listeners[i]();
	      }
	    },
	    get: function get() {
	      return next;
	    },
	    subscribe: function subscribe(listener) {
	      var isSubscribed = true;
	      if (next === current) next = current.slice();
	      next.push(listener);
	
	      return function unsubscribe() {
	        if (!isSubscribed || current === CLEARED) return;
	        isSubscribed = false;
	
	        if (next === current) next = current.slice();
	        next.splice(next.indexOf(listener), 1);
	      };
	    }
	  };
	}
	
	var Subscription = function () {
	  function Subscription(store, parentSub, onStateChange) {
	    _classCallCheck(this, Subscription);
	
	    this.store = store;
	    this.parentSub = parentSub;
	    this.onStateChange = onStateChange;
	    this.unsubscribe = null;
	    this.listeners = nullListeners;
	  }
	
	  Subscription.prototype.addNestedSub = function addNestedSub(listener) {
	    this.trySubscribe();
	    return this.listeners.subscribe(listener);
	  };
	
	  Subscription.prototype.notifyNestedSubs = function notifyNestedSubs() {
	    this.listeners.notify();
	  };
	
	  Subscription.prototype.isSubscribed = function isSubscribed() {
	    return Boolean(this.unsubscribe);
	  };
	
	  Subscription.prototype.trySubscribe = function trySubscribe() {
	    if (!this.unsubscribe) {
	      this.unsubscribe = this.parentSub ? this.parentSub.addNestedSub(this.onStateChange) : this.store.subscribe(this.onStateChange);
	
	      this.listeners = createListenerCollection();
	    }
	  };
	
	  Subscription.prototype.tryUnsubscribe = function tryUnsubscribe() {
	    if (this.unsubscribe) {
	      this.unsubscribe();
	      this.unsubscribe = null;
	      this.listeners.clear();
	      this.listeners = nullListeners;
	    }
	  };
	
	  return Subscription;
	}();
	
	exports.default = Subscription;

/***/ },
/* 1045 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = shallowEqual;
	var hasOwn = Object.prototype.hasOwnProperty;
	
	function is(x, y) {
	  if (x === y) {
	    return x !== 0 || y !== 0 || 1 / x === 1 / y;
	  } else {
	    return x !== x && y !== y;
	  }
	}
	
	function shallowEqual(objA, objB) {
	  if (is(objA, objB)) return true;
	
	  if (typeof objA !== 'object' || objA === null || typeof objB !== 'object' || objB === null) {
	    return false;
	  }
	
	  var keysA = Object.keys(objA);
	  var keysB = Object.keys(objB);
	
	  if (keysA.length !== keysB.length) return false;
	
	  for (var i = 0; i < keysA.length; i++) {
	    if (!hasOwn.call(objB, keysA[i]) || !is(objA[keysA[i]], objB[keysA[i]])) {
	      return false;
	    }
	  }
	
	  return true;
	}

/***/ },
/* 1046 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _createReactClass = __webpack_require__(73);
	
	var _createReactClass2 = _interopRequireDefault(_createReactClass);
	
	var _Link = __webpack_require__(418);
	
	var _Link2 = _interopRequireDefault(_Link);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * An <IndexLink> is used to link to an <IndexRoute>.
	 */
	var IndexLink = (0, _createReactClass2.default)({
	  displayName: 'IndexLink',
	
	  render: function render() {
	    return _react2.default.createElement(_Link2.default, _extends({}, this.props, { onlyActiveOnIndex: true }));
	  }
	});
	
	exports.default = IndexLink;
	module.exports = exports['default'];

/***/ },
/* 1047 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _createReactClass = __webpack_require__(73);
	
	var _createReactClass2 = _interopRequireDefault(_createReactClass);
	
	var _propTypes = __webpack_require__(2);
	
	var _routerWarning = __webpack_require__(130);
	
	var _routerWarning2 = _interopRequireDefault(_routerWarning);
	
	var _invariant = __webpack_require__(46);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _Redirect = __webpack_require__(420);
	
	var _Redirect2 = _interopRequireDefault(_Redirect);
	
	var _InternalPropTypes = __webpack_require__(148);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * An <IndexRedirect> is used to redirect from an indexRoute.
	 */
	/* eslint-disable react/require-render-return */
	var IndexRedirect = (0, _createReactClass2.default)({
	  displayName: 'IndexRedirect',
	
	  statics: {
	    createRouteFromReactElement: function createRouteFromReactElement(element, parentRoute) {
	      /* istanbul ignore else: sanity check */
	      if (parentRoute) {
	        parentRoute.indexRoute = _Redirect2.default.createRouteFromReactElement(element);
	      } else {
	         false ? (0, _routerWarning2.default)(false, 'An <IndexRedirect> does not make sense at the root of your route config') : void 0;
	      }
	    }
	  },
	
	  propTypes: {
	    to: _propTypes.string.isRequired,
	    query: _propTypes.object,
	    state: _propTypes.object,
	    onEnter: _InternalPropTypes.falsy,
	    children: _InternalPropTypes.falsy
	  },
	
	  /* istanbul ignore next: sanity check */
	  render: function render() {
	     true ?  false ? (0, _invariant2.default)(false, '<IndexRedirect> elements are for router configuration only and should not be rendered') : (0, _invariant2.default)(false) : void 0;
	  }
	});
	
	exports.default = IndexRedirect;
	module.exports = exports['default'];

/***/ },
/* 1048 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _createReactClass = __webpack_require__(73);
	
	var _createReactClass2 = _interopRequireDefault(_createReactClass);
	
	var _propTypes = __webpack_require__(2);
	
	var _routerWarning = __webpack_require__(130);
	
	var _routerWarning2 = _interopRequireDefault(_routerWarning);
	
	var _invariant = __webpack_require__(46);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _RouteUtils = __webpack_require__(100);
	
	var _InternalPropTypes = __webpack_require__(148);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * An <IndexRoute> is used to specify its parent's <Route indexRoute> in
	 * a JSX route config.
	 */
	/* eslint-disable react/require-render-return */
	var IndexRoute = (0, _createReactClass2.default)({
	  displayName: 'IndexRoute',
	
	  statics: {
	    createRouteFromReactElement: function createRouteFromReactElement(element, parentRoute) {
	      /* istanbul ignore else: sanity check */
	      if (parentRoute) {
	        parentRoute.indexRoute = (0, _RouteUtils.createRouteFromReactElement)(element);
	      } else {
	         false ? (0, _routerWarning2.default)(false, 'An <IndexRoute> does not make sense at the root of your route config') : void 0;
	      }
	    }
	  },
	
	  propTypes: {
	    path: _InternalPropTypes.falsy,
	    component: _InternalPropTypes.component,
	    components: _InternalPropTypes.components,
	    getComponent: _propTypes.func,
	    getComponents: _propTypes.func
	  },
	
	  /* istanbul ignore next: sanity check */
	  render: function render() {
	     true ?  false ? (0, _invariant2.default)(false, '<IndexRoute> elements are for router configuration only and should not be rendered') : (0, _invariant2.default)(false) : void 0;
	  }
	});
	
	exports.default = IndexRoute;
	module.exports = exports['default'];

/***/ },
/* 1049 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _createReactClass = __webpack_require__(73);
	
	var _createReactClass2 = _interopRequireDefault(_createReactClass);
	
	var _propTypes = __webpack_require__(2);
	
	var _invariant = __webpack_require__(46);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _RouteUtils = __webpack_require__(100);
	
	var _InternalPropTypes = __webpack_require__(148);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * A <Route> is used to declare which components are rendered to the
	 * page when the URL matches a given pattern.
	 *
	 * Routes are arranged in a nested tree structure. When a new URL is
	 * requested, the tree is searched depth-first to find a route whose
	 * path matches the URL.  When one is found, all routes in the tree
	 * that lead to it are considered "active" and their components are
	 * rendered into the DOM, nested in the same order as in the tree.
	 */
	/* eslint-disable react/require-render-return */
	var Route = (0, _createReactClass2.default)({
	  displayName: 'Route',
	
	  statics: {
	    createRouteFromReactElement: _RouteUtils.createRouteFromReactElement
	  },
	
	  propTypes: {
	    path: _propTypes.string,
	    component: _InternalPropTypes.component,
	    components: _InternalPropTypes.components,
	    getComponent: _propTypes.func,
	    getComponents: _propTypes.func
	  },
	
	  /* istanbul ignore next: sanity check */
	  render: function render() {
	     true ?  false ? (0, _invariant2.default)(false, '<Route> elements are for router configuration only and should not be rendered') : (0, _invariant2.default)(false) : void 0;
	  }
	});
	
	exports.default = Route;
	module.exports = exports['default'];

/***/ },
/* 1050 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _invariant = __webpack_require__(46);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _createReactClass = __webpack_require__(73);
	
	var _createReactClass2 = _interopRequireDefault(_createReactClass);
	
	var _propTypes = __webpack_require__(2);
	
	var _createTransitionManager2 = __webpack_require__(424);
	
	var _createTransitionManager3 = _interopRequireDefault(_createTransitionManager2);
	
	var _InternalPropTypes = __webpack_require__(148);
	
	var _RouterContext = __webpack_require__(270);
	
	var _RouterContext2 = _interopRequireDefault(_RouterContext);
	
	var _RouteUtils = __webpack_require__(100);
	
	var _RouterUtils = __webpack_require__(421);
	
	var _routerWarning = __webpack_require__(130);
	
	var _routerWarning2 = _interopRequireDefault(_routerWarning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var propTypes = {
	  history: _propTypes.object,
	  children: _InternalPropTypes.routes,
	  routes: _InternalPropTypes.routes, // alias for children
	  render: _propTypes.func,
	  createElement: _propTypes.func,
	  onError: _propTypes.func,
	  onUpdate: _propTypes.func,
	
	  // PRIVATE: For client-side rehydration of server match.
	  matchContext: _propTypes.object
	
	  /**
	   * A <Router> is a high-level API for automatically setting up
	   * a router that renders a <RouterContext> with all the props
	   * it needs each time the URL changes.
	   */
	};var Router = (0, _createReactClass2.default)({
	  displayName: 'Router',
	
	  propTypes: propTypes,
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      render: function render(props) {
	        return _react2.default.createElement(_RouterContext2.default, props);
	      }
	    };
	  },
	  getInitialState: function getInitialState() {
	    return {
	      location: null,
	      routes: null,
	      params: null,
	      components: null
	    };
	  },
	  handleError: function handleError(error) {
	    if (this.props.onError) {
	      this.props.onError.call(this, error);
	    } else {
	      // Throw errors by default so we don't silently swallow them!
	      throw error; // This error probably occurred in getChildRoutes or getComponents.
	    }
	  },
	  createRouterObject: function createRouterObject(state) {
	    var matchContext = this.props.matchContext;
	
	    if (matchContext) {
	      return matchContext.router;
	    }
	
	    var history = this.props.history;
	
	    return (0, _RouterUtils.createRouterObject)(history, this.transitionManager, state);
	  },
	  createTransitionManager: function createTransitionManager() {
	    var matchContext = this.props.matchContext;
	
	    if (matchContext) {
	      return matchContext.transitionManager;
	    }
	
	    var history = this.props.history;
	    var _props = this.props,
	        routes = _props.routes,
	        children = _props.children;
	
	
	    !history.getCurrentLocation ?  false ? (0, _invariant2.default)(false, 'You have provided a history object created with history v4.x or v2.x ' + 'and earlier. This version of React Router is only compatible with v3 ' + 'history objects. Please change to history v3.x.') : (0, _invariant2.default)(false) : void 0;
	
	    return (0, _createTransitionManager3.default)(history, (0, _RouteUtils.createRoutes)(routes || children));
	  },
	  componentWillMount: function componentWillMount() {
	    var _this = this;
	
	    this.transitionManager = this.createTransitionManager();
	    this.router = this.createRouterObject(this.state);
	
	    this._unlisten = this.transitionManager.listen(function (error, state) {
	      if (error) {
	        _this.handleError(error);
	      } else {
	        // Keep the identity of this.router because of a caveat in ContextUtils:
	        // they only work if the object identity is preserved.
	        (0, _RouterUtils.assignRouterState)(_this.router, state);
	        _this.setState(state, _this.props.onUpdate);
	      }
	    });
	  },
	
	
	  /* istanbul ignore next: sanity check */
	  componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
	     false ? (0, _routerWarning2.default)(nextProps.history === this.props.history, 'You cannot change <Router history>; it will be ignored') : void 0;
	
	     false ? (0, _routerWarning2.default)((nextProps.routes || nextProps.children) === (this.props.routes || this.props.children), 'You cannot change <Router routes>; it will be ignored') : void 0;
	  },
	  componentWillUnmount: function componentWillUnmount() {
	    if (this._unlisten) this._unlisten();
	  },
	  render: function render() {
	    var _state = this.state,
	        location = _state.location,
	        routes = _state.routes,
	        params = _state.params,
	        components = _state.components;
	
	    var _props2 = this.props,
	        createElement = _props2.createElement,
	        render = _props2.render,
	        props = _objectWithoutProperties(_props2, ['createElement', 'render']);
	
	    if (location == null) return null; // Async match
	
	    // Only forward non-Router-specific props to routing context, as those are
	    // the only ones that might be custom routing context props.
	    Object.keys(propTypes).forEach(function (propType) {
	      return delete props[propType];
	    });
	
	    return render(_extends({}, props, {
	      router: this.router,
	      location: location,
	      routes: routes,
	      params: params,
	      components: components,
	      createElement: createElement
	    }));
	  }
	});
	
	exports.default = Router;
	module.exports = exports['default'];

/***/ },
/* 1051 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = getTransitionUtils;
	
	var _AsyncUtils = __webpack_require__(267);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var PendingHooks = function PendingHooks() {
	  var _this = this;
	
	  _classCallCheck(this, PendingHooks);
	
	  this.hooks = [];
	
	  this.add = function (hook) {
	    return _this.hooks.push(hook);
	  };
	
	  this.remove = function (hook) {
	    return _this.hooks = _this.hooks.filter(function (h) {
	      return h !== hook;
	    });
	  };
	
	  this.has = function (hook) {
	    return _this.hooks.indexOf(hook) !== -1;
	  };
	
	  this.clear = function () {
	    return _this.hooks = [];
	  };
	};
	
	function getTransitionUtils() {
	  var enterHooks = new PendingHooks();
	  var changeHooks = new PendingHooks();
	
	  function createTransitionHook(hook, route, asyncArity, pendingHooks) {
	    var isSync = hook.length < asyncArity;
	
	    var transitionHook = function transitionHook() {
	      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	        args[_key] = arguments[_key];
	      }
	
	      hook.apply(route, args);
	
	      if (isSync) {
	        var callback = args[args.length - 1];
	        // Assume hook executes synchronously and
	        // automatically call the callback.
	        callback();
	      }
	    };
	
	    pendingHooks.add(transitionHook);
	
	    return transitionHook;
	  }
	
	  function getEnterHooks(routes) {
	    return routes.reduce(function (hooks, route) {
	      if (route.onEnter) hooks.push(createTransitionHook(route.onEnter, route, 3, enterHooks));
	      return hooks;
	    }, []);
	  }
	
	  function getChangeHooks(routes) {
	    return routes.reduce(function (hooks, route) {
	      if (route.onChange) hooks.push(createTransitionHook(route.onChange, route, 4, changeHooks));
	      return hooks;
	    }, []);
	  }
	
	  function runTransitionHooks(length, iter, callback) {
	    if (!length) {
	      callback();
	      return;
	    }
	
	    var redirectInfo = void 0;
	    function replace(location) {
	      redirectInfo = location;
	    }
	
	    (0, _AsyncUtils.loopAsync)(length, function (index, next, done) {
	      iter(index, replace, function (error) {
	        if (error || redirectInfo) {
	          done(error, redirectInfo); // No need to continue.
	        } else {
	          next();
	        }
	      });
	    }, callback);
	  }
	
	  /**
	   * Runs all onEnter hooks in the given array of routes in order
	   * with onEnter(nextState, replace, callback) and calls
	   * callback(error, redirectInfo) when finished. The first hook
	   * to use replace short-circuits the loop.
	   *
	   * If a hook needs to run asynchronously, it may use the callback
	   * function. However, doing so will cause the transition to pause,
	   * which could lead to a non-responsive UI if the hook is slow.
	   */
	  function runEnterHooks(routes, nextState, callback) {
	    enterHooks.clear();
	    var hooks = getEnterHooks(routes);
	    return runTransitionHooks(hooks.length, function (index, replace, next) {
	      var wrappedNext = function wrappedNext() {
	        if (enterHooks.has(hooks[index])) {
	          next.apply(undefined, arguments);
	          enterHooks.remove(hooks[index]);
	        }
	      };
	      hooks[index](nextState, replace, wrappedNext);
	    }, callback);
	  }
	
	  /**
	   * Runs all onChange hooks in the given array of routes in order
	   * with onChange(prevState, nextState, replace, callback) and calls
	   * callback(error, redirectInfo) when finished. The first hook
	   * to use replace short-circuits the loop.
	   *
	   * If a hook needs to run asynchronously, it may use the callback
	   * function. However, doing so will cause the transition to pause,
	   * which could lead to a non-responsive UI if the hook is slow.
	   */
	  function runChangeHooks(routes, state, nextState, callback) {
	    changeHooks.clear();
	    var hooks = getChangeHooks(routes);
	    return runTransitionHooks(hooks.length, function (index, replace, next) {
	      var wrappedNext = function wrappedNext() {
	        if (changeHooks.has(hooks[index])) {
	          next.apply(undefined, arguments);
	          changeHooks.remove(hooks[index]);
	        }
	      };
	      hooks[index](state, nextState, replace, wrappedNext);
	    }, callback);
	  }
	
	  /**
	   * Runs all onLeave hooks in the given array of routes in order.
	   */
	  function runLeaveHooks(routes, prevState) {
	    for (var i = 0, len = routes.length; i < len; ++i) {
	      if (routes[i].onLeave) routes[i].onLeave.call(routes[i], prevState);
	    }
	  }
	
	  return {
	    runEnterHooks: runEnterHooks,
	    runChangeHooks: runChangeHooks,
	    runLeaveHooks: runLeaveHooks
	  };
	}
	module.exports = exports['default'];

/***/ },
/* 1052 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _RouterContext = __webpack_require__(270);
	
	var _RouterContext2 = _interopRequireDefault(_RouterContext);
	
	var _routerWarning = __webpack_require__(130);
	
	var _routerWarning2 = _interopRequireDefault(_routerWarning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function () {
	  for (var _len = arguments.length, middlewares = Array(_len), _key = 0; _key < _len; _key++) {
	    middlewares[_key] = arguments[_key];
	  }
	
	  if (false) {
	    middlewares.forEach(function (middleware, index) {
	      process.env.NODE_ENV !== 'production' ? (0, _routerWarning2.default)(middleware.renderRouterContext || middleware.renderRouteComponent, 'The middleware specified at index ' + index + ' does not appear to be ' + 'a valid React Router middleware.') : void 0;
	    });
	  }
	
	  var withContext = middlewares.map(function (middleware) {
	    return middleware.renderRouterContext;
	  }).filter(Boolean);
	  var withComponent = middlewares.map(function (middleware) {
	    return middleware.renderRouteComponent;
	  }).filter(Boolean);
	
	  var makeCreateElement = function makeCreateElement() {
	    var baseCreateElement = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _react.createElement;
	    return function (Component, props) {
	      return withComponent.reduceRight(function (previous, renderRouteComponent) {
	        return renderRouteComponent(previous, props);
	      }, baseCreateElement(Component, props));
	    };
	  };
	
	  return function (renderProps) {
	    return withContext.reduceRight(function (previous, renderRouterContext) {
	      return renderRouterContext(previous, renderProps);
	    }, _react2.default.createElement(_RouterContext2.default, _extends({}, renderProps, {
	      createElement: makeCreateElement(renderProps.createElement)
	    })));
	  };
	};
	
	module.exports = exports['default'];

/***/ },
/* 1053 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _createBrowserHistory = __webpack_require__(840);
	
	var _createBrowserHistory2 = _interopRequireDefault(_createBrowserHistory);
	
	var _createRouterHistory = __webpack_require__(423);
	
	var _createRouterHistory2 = _interopRequireDefault(_createRouterHistory);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = (0, _createRouterHistory2.default)(_createBrowserHistory2.default);
	module.exports = exports['default'];

/***/ },
/* 1054 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _PatternUtils = __webpack_require__(129);
	
	function routeParamsChanged(route, prevState, nextState) {
	  if (!route.path) return false;
	
	  var paramNames = (0, _PatternUtils.getParamNames)(route.path);
	
	  return paramNames.some(function (paramName) {
	    return prevState.params[paramName] !== nextState.params[paramName];
	  });
	}
	
	/**
	 * Returns an object of { leaveRoutes, changeRoutes, enterRoutes } determined by
	 * the change from prevState to nextState. We leave routes if either
	 * 1) they are not in the next state or 2) they are in the next state
	 * but their params have changed (i.e. /users/123 => /users/456).
	 *
	 * leaveRoutes are ordered starting at the leaf route of the tree
	 * we're leaving up to the common parent route. enterRoutes are ordered
	 * from the top of the tree we're entering down to the leaf route.
	 *
	 * changeRoutes are any routes that didn't leave or enter during
	 * the transition.
	 */
	function computeChangedRoutes(prevState, nextState) {
	  var prevRoutes = prevState && prevState.routes;
	  var nextRoutes = nextState.routes;
	
	  var leaveRoutes = void 0,
	      changeRoutes = void 0,
	      enterRoutes = void 0;
	  if (prevRoutes) {
	    var parentIsLeaving = false;
	    leaveRoutes = prevRoutes.filter(function (route) {
	      if (parentIsLeaving) {
	        return true;
	      } else {
	        var isLeaving = nextRoutes.indexOf(route) === -1 || routeParamsChanged(route, prevState, nextState);
	        if (isLeaving) parentIsLeaving = true;
	        return isLeaving;
	      }
	    });
	
	    // onLeave hooks start at the leaf route.
	    leaveRoutes.reverse();
	
	    enterRoutes = [];
	    changeRoutes = [];
	
	    nextRoutes.forEach(function (route) {
	      var isNew = prevRoutes.indexOf(route) === -1;
	      var paramsChanged = leaveRoutes.indexOf(route) !== -1;
	
	      if (isNew || paramsChanged) enterRoutes.push(route);else changeRoutes.push(route);
	    });
	  } else {
	    leaveRoutes = [];
	    changeRoutes = [];
	    enterRoutes = nextRoutes;
	  }
	
	  return {
	    leaveRoutes: leaveRoutes,
	    changeRoutes: changeRoutes,
	    enterRoutes: enterRoutes
	  };
	}
	
	exports.default = computeChangedRoutes;
	module.exports = exports['default'];

/***/ },
/* 1055 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _AsyncUtils = __webpack_require__(267);
	
	var _PromiseUtils = __webpack_require__(419);
	
	function getComponentsForRoute(nextState, route, callback) {
	  if (route.component || route.components) {
	    callback(null, route.component || route.components);
	    return;
	  }
	
	  var getComponent = route.getComponent || route.getComponents;
	  if (getComponent) {
	    var componentReturn = getComponent.call(route, nextState, callback);
	    if ((0, _PromiseUtils.isPromise)(componentReturn)) componentReturn.then(function (component) {
	      return callback(null, component);
	    }, callback);
	  } else {
	    callback();
	  }
	}
	
	/**
	 * Asynchronously fetches all components needed for the given router
	 * state and calls callback(error, components) when finished.
	 *
	 * Note: This operation may finish synchronously if no routes have an
	 * asynchronous getComponents method.
	 */
	function getComponents(nextState, callback) {
	  (0, _AsyncUtils.mapAsync)(nextState.routes, function (route, index, callback) {
	    getComponentsForRoute(nextState, route, callback);
	  }, callback);
	}
	
	exports.default = getComponents;
	module.exports = exports['default'];

/***/ },
/* 1056 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _PatternUtils = __webpack_require__(129);
	
	/**
	 * Extracts an object of params the given route cares about from
	 * the given params object.
	 */
	function getRouteParams(route, params) {
	  var routeParams = {};
	
	  if (!route.path) return routeParams;
	
	  (0, _PatternUtils.getParamNames)(route.path).forEach(function (p) {
	    if (Object.prototype.hasOwnProperty.call(params, p)) {
	      routeParams[p] = params[p];
	    }
	  });
	
	  return routeParams;
	}
	
	exports.default = getRouteParams;
	module.exports = exports['default'];

/***/ },
/* 1057 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _createHashHistory = __webpack_require__(841);
	
	var _createHashHistory2 = _interopRequireDefault(_createHashHistory);
	
	var _createRouterHistory = __webpack_require__(423);
	
	var _createRouterHistory2 = _interopRequireDefault(_createRouterHistory);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = (0, _createRouterHistory2.default)(_createHashHistory2.default);
	module.exports = exports['default'];

/***/ },
/* 1058 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	exports.default = isActive;
	
	var _PatternUtils = __webpack_require__(129);
	
	function deepEqual(a, b) {
	  if (a == b) return true;
	
	  if (a == null || b == null) return false;
	
	  if (Array.isArray(a)) {
	    return Array.isArray(b) && a.length === b.length && a.every(function (item, index) {
	      return deepEqual(item, b[index]);
	    });
	  }
	
	  if ((typeof a === 'undefined' ? 'undefined' : _typeof(a)) === 'object') {
	    for (var p in a) {
	      if (!Object.prototype.hasOwnProperty.call(a, p)) {
	        continue;
	      }
	
	      if (a[p] === undefined) {
	        if (b[p] !== undefined) {
	          return false;
	        }
	      } else if (!Object.prototype.hasOwnProperty.call(b, p)) {
	        return false;
	      } else if (!deepEqual(a[p], b[p])) {
	        return false;
	      }
	    }
	
	    return true;
	  }
	
	  return String(a) === String(b);
	}
	
	/**
	 * Returns true if the current pathname matches the supplied one, net of
	 * leading and trailing slash normalization. This is sufficient for an
	 * indexOnly route match.
	 */
	function pathIsActive(pathname, currentPathname) {
	  // Normalize leading slash for consistency. Leading slash on pathname has
	  // already been normalized in isActive. See caveat there.
	  if (currentPathname.charAt(0) !== '/') {
	    currentPathname = '/' + currentPathname;
	  }
	
	  // Normalize the end of both path names too. Maybe `/foo/` shouldn't show
	  // `/foo` as active, but in this case, we would already have failed the
	  // match.
	  if (pathname.charAt(pathname.length - 1) !== '/') {
	    pathname += '/';
	  }
	  if (currentPathname.charAt(currentPathname.length - 1) !== '/') {
	    currentPathname += '/';
	  }
	
	  return currentPathname === pathname;
	}
	
	/**
	 * Returns true if the given pathname matches the active routes and params.
	 */
	function routeIsActive(pathname, routes, params) {
	  var remainingPathname = pathname,
	      paramNames = [],
	      paramValues = [];
	
	  // for...of would work here but it's probably slower post-transpilation.
	  for (var i = 0, len = routes.length; i < len; ++i) {
	    var route = routes[i];
	    var pattern = route.path || '';
	
	    if (pattern.charAt(0) === '/') {
	      remainingPathname = pathname;
	      paramNames = [];
	      paramValues = [];
	    }
	
	    if (remainingPathname !== null && pattern) {
	      var matched = (0, _PatternUtils.matchPattern)(pattern, remainingPathname);
	      if (matched) {
	        remainingPathname = matched.remainingPathname;
	        paramNames = [].concat(paramNames, matched.paramNames);
	        paramValues = [].concat(paramValues, matched.paramValues);
	      } else {
	        remainingPathname = null;
	      }
	
	      if (remainingPathname === '') {
	        // We have an exact match on the route. Just check that all the params
	        // match.
	        // FIXME: This doesn't work on repeated params.
	        return paramNames.every(function (paramName, index) {
	          return String(paramValues[index]) === String(params[paramName]);
	        });
	      }
	    }
	  }
	
	  return false;
	}
	
	/**
	 * Returns true if all key/value pairs in the given query are
	 * currently active.
	 */
	function queryIsActive(query, activeQuery) {
	  if (activeQuery == null) return query == null;
	
	  if (query == null) return true;
	
	  return deepEqual(query, activeQuery);
	}
	
	/**
	 * Returns true if a <Link> to the given pathname/query combination is
	 * currently active.
	 */
	function isActive(_ref, indexOnly, currentLocation, routes, params) {
	  var pathname = _ref.pathname,
	      query = _ref.query;
	
	  if (currentLocation == null) return false;
	
	  // TODO: This is a bit ugly. It keeps around support for treating pathnames
	  // without preceding slashes as absolute paths, but possibly also works
	  // around the same quirks with basenames as in matchRoutes.
	  if (pathname.charAt(0) !== '/') {
	    pathname = '/' + pathname;
	  }
	
	  if (!pathIsActive(pathname, currentLocation.pathname)) {
	    // The path check is necessary and sufficient for indexOnly, but otherwise
	    // we still need to check the routes.
	    if (indexOnly || !routeIsActive(pathname, routes, params)) {
	      return false;
	    }
	  }
	
	  return queryIsActive(query, currentLocation.query);
	}
	module.exports = exports['default'];

/***/ },
/* 1059 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _Actions = __webpack_require__(172);
	
	var _invariant = __webpack_require__(46);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _createMemoryHistory = __webpack_require__(422);
	
	var _createMemoryHistory2 = _interopRequireDefault(_createMemoryHistory);
	
	var _createTransitionManager = __webpack_require__(424);
	
	var _createTransitionManager2 = _interopRequireDefault(_createTransitionManager);
	
	var _RouteUtils = __webpack_require__(100);
	
	var _RouterUtils = __webpack_require__(421);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	/**
	 * A high-level API to be used for server-side rendering.
	 *
	 * This function matches a location to a set of routes and calls
	 * callback(error, redirectLocation, renderProps) when finished.
	 *
	 * Note: You probably don't want to use this in a browser unless you're using
	 * server-side rendering with async routes.
	 */
	function match(_ref, callback) {
	  var history = _ref.history,
	      routes = _ref.routes,
	      location = _ref.location,
	      options = _objectWithoutProperties(_ref, ['history', 'routes', 'location']);
	
	  !(history || location) ?  false ? (0, _invariant2.default)(false, 'match needs a history or a location') : (0, _invariant2.default)(false) : void 0;
	
	  history = history ? history : (0, _createMemoryHistory2.default)(options);
	  var transitionManager = (0, _createTransitionManager2.default)(history, (0, _RouteUtils.createRoutes)(routes));
	
	  if (location) {
	    // Allow match({ location: '/the/path', ... })
	    location = history.createLocation(location);
	  } else {
	    location = history.getCurrentLocation();
	  }
	
	  transitionManager.match(location, function (error, redirectLocation, nextState) {
	    var renderProps = void 0;
	
	    if (nextState) {
	      var router = (0, _RouterUtils.createRouterObject)(history, transitionManager, nextState);
	      renderProps = _extends({}, nextState, {
	        router: router,
	        matchContext: { transitionManager: transitionManager, router: router }
	      });
	    }
	
	    callback(error, redirectLocation && history.createLocation(redirectLocation, _Actions.REPLACE), renderProps);
	  });
	}
	
	exports.default = match;
	module.exports = exports['default'];

/***/ },
/* 1060 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = matchRoutes;
	
	var _AsyncUtils = __webpack_require__(267);
	
	var _PromiseUtils = __webpack_require__(419);
	
	var _PatternUtils = __webpack_require__(129);
	
	var _routerWarning = __webpack_require__(130);
	
	var _routerWarning2 = _interopRequireDefault(_routerWarning);
	
	var _RouteUtils = __webpack_require__(100);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getChildRoutes(route, location, paramNames, paramValues, callback) {
	  if (route.childRoutes) {
	    return [null, route.childRoutes];
	  }
	  if (!route.getChildRoutes) {
	    return [];
	  }
	
	  var sync = true,
	      result = void 0;
	
	  var partialNextState = {
	    location: location,
	    params: createParams(paramNames, paramValues)
	  };
	
	  var childRoutesReturn = route.getChildRoutes(partialNextState, function (error, childRoutes) {
	    childRoutes = !error && (0, _RouteUtils.createRoutes)(childRoutes);
	    if (sync) {
	      result = [error, childRoutes];
	      return;
	    }
	
	    callback(error, childRoutes);
	  });
	
	  if ((0, _PromiseUtils.isPromise)(childRoutesReturn)) childRoutesReturn.then(function (childRoutes) {
	    return callback(null, (0, _RouteUtils.createRoutes)(childRoutes));
	  }, callback);
	
	  sync = false;
	  return result; // Might be undefined.
	}
	
	function getIndexRoute(route, location, paramNames, paramValues, callback) {
	  if (route.indexRoute) {
	    callback(null, route.indexRoute);
	  } else if (route.getIndexRoute) {
	    var partialNextState = {
	      location: location,
	      params: createParams(paramNames, paramValues)
	    };
	
	    var indexRoutesReturn = route.getIndexRoute(partialNextState, function (error, indexRoute) {
	      callback(error, !error && (0, _RouteUtils.createRoutes)(indexRoute)[0]);
	    });
	
	    if ((0, _PromiseUtils.isPromise)(indexRoutesReturn)) indexRoutesReturn.then(function (indexRoute) {
	      return callback(null, (0, _RouteUtils.createRoutes)(indexRoute)[0]);
	    }, callback);
	  } else if (route.childRoutes || route.getChildRoutes) {
	    var onChildRoutes = function onChildRoutes(error, childRoutes) {
	      if (error) {
	        callback(error);
	        return;
	      }
	
	      var pathless = childRoutes.filter(function (childRoute) {
	        return !childRoute.path;
	      });
	
	      (0, _AsyncUtils.loopAsync)(pathless.length, function (index, next, done) {
	        getIndexRoute(pathless[index], location, paramNames, paramValues, function (error, indexRoute) {
	          if (error || indexRoute) {
	            var routes = [pathless[index]].concat(Array.isArray(indexRoute) ? indexRoute : [indexRoute]);
	            done(error, routes);
	          } else {
	            next();
	          }
	        });
	      }, function (err, routes) {
	        callback(null, routes);
	      });
	    };
	
	    var result = getChildRoutes(route, location, paramNames, paramValues, onChildRoutes);
	    if (result) {
	      onChildRoutes.apply(undefined, result);
	    }
	  } else {
	    callback();
	  }
	}
	
	function assignParams(params, paramNames, paramValues) {
	  return paramNames.reduce(function (params, paramName, index) {
	    var paramValue = paramValues && paramValues[index];
	
	    if (Array.isArray(params[paramName])) {
	      params[paramName].push(paramValue);
	    } else if (paramName in params) {
	      params[paramName] = [params[paramName], paramValue];
	    } else {
	      params[paramName] = paramValue;
	    }
	
	    return params;
	  }, params);
	}
	
	function createParams(paramNames, paramValues) {
	  return assignParams({}, paramNames, paramValues);
	}
	
	function matchRouteDeep(route, location, remainingPathname, paramNames, paramValues, callback) {
	  var pattern = route.path || '';
	
	  if (pattern.charAt(0) === '/') {
	    remainingPathname = location.pathname;
	    paramNames = [];
	    paramValues = [];
	  }
	
	  // Only try to match the path if the route actually has a pattern, and if
	  // we're not just searching for potential nested absolute paths.
	  if (remainingPathname !== null && pattern) {
	    try {
	      var matched = (0, _PatternUtils.matchPattern)(pattern, remainingPathname);
	      if (matched) {
	        remainingPathname = matched.remainingPathname;
	        paramNames = [].concat(paramNames, matched.paramNames);
	        paramValues = [].concat(paramValues, matched.paramValues);
	      } else {
	        remainingPathname = null;
	      }
	    } catch (error) {
	      callback(error);
	    }
	
	    // By assumption, pattern is non-empty here, which is the prerequisite for
	    // actually terminating a match.
	    if (remainingPathname === '') {
	      var match = {
	        routes: [route],
	        params: createParams(paramNames, paramValues)
	      };
	
	      getIndexRoute(route, location, paramNames, paramValues, function (error, indexRoute) {
	        if (error) {
	          callback(error);
	        } else {
	          if (Array.isArray(indexRoute)) {
	            var _match$routes;
	
	             false ? (0, _routerWarning2.default)(indexRoute.every(function (route) {
	              return !route.path;
	            }), 'Index routes should not have paths') : void 0;
	            (_match$routes = match.routes).push.apply(_match$routes, indexRoute);
	          } else if (indexRoute) {
	             false ? (0, _routerWarning2.default)(!indexRoute.path, 'Index routes should not have paths') : void 0;
	            match.routes.push(indexRoute);
	          }
	
	          callback(null, match);
	        }
	      });
	
	      return;
	    }
	  }
	
	  if (remainingPathname != null || route.childRoutes) {
	    // Either a) this route matched at least some of the path or b)
	    // we don't have to load this route's children asynchronously. In
	    // either case continue checking for matches in the subtree.
	    var onChildRoutes = function onChildRoutes(error, childRoutes) {
	      if (error) {
	        callback(error);
	      } else if (childRoutes) {
	        // Check the child routes to see if any of them match.
	        matchRoutes(childRoutes, location, function (error, match) {
	          if (error) {
	            callback(error);
	          } else if (match) {
	            // A child route matched! Augment the match and pass it up the stack.
	            match.routes.unshift(route);
	            callback(null, match);
	          } else {
	            callback();
	          }
	        }, remainingPathname, paramNames, paramValues);
	      } else {
	        callback();
	      }
	    };
	
	    var result = getChildRoutes(route, location, paramNames, paramValues, onChildRoutes);
	    if (result) {
	      onChildRoutes.apply(undefined, result);
	    }
	  } else {
	    callback();
	  }
	}
	
	/**
	 * Asynchronously matches the given location to a set of routes and calls
	 * callback(error, state) when finished. The state object will have the
	 * following properties:
	 *
	 * - routes       An array of routes that matched, in hierarchical order
	 * - params       An object of URL parameters
	 *
	 * Note: This operation may finish synchronously if no routes have an
	 * asynchronous getChildRoutes method.
	 */
	function matchRoutes(routes, location, callback, remainingPathname) {
	  var paramNames = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : [];
	  var paramValues = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : [];
	
	  if (remainingPathname === undefined) {
	    // TODO: This is a little bit ugly, but it works around a quirk in history
	    // that strips the leading slash from pathnames when using basenames with
	    // trailing slashes.
	    if (location.pathname.charAt(0) !== '/') {
	      location = _extends({}, location, {
	        pathname: '/' + location.pathname
	      });
	    }
	    remainingPathname = location.pathname;
	  }
	
	  (0, _AsyncUtils.loopAsync)(routes.length, function (index, next, done) {
	    matchRouteDeep(routes[index], location, remainingPathname, paramNames, paramValues, function (error, match) {
	      if (error || match) {
	        done(error, match);
	      } else {
	        next();
	      }
	    });
	  }, callback);
	}
	module.exports = exports['default'];

/***/ },
/* 1061 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = withRouter;
	
	var _invariant = __webpack_require__(46);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _createReactClass = __webpack_require__(73);
	
	var _createReactClass2 = _interopRequireDefault(_createReactClass);
	
	var _hoistNonReactStatics = __webpack_require__(355);
	
	var _hoistNonReactStatics2 = _interopRequireDefault(_hoistNonReactStatics);
	
	var _ContextUtils = __webpack_require__(268);
	
	var _PropTypes = __webpack_require__(269);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getDisplayName(WrappedComponent) {
	  return WrappedComponent.displayName || WrappedComponent.name || 'Component';
	}
	
	function withRouter(WrappedComponent, options) {
	  var withRef = options && options.withRef;
	
	  var WithRouter = (0, _createReactClass2.default)({
	    displayName: 'WithRouter',
	
	    mixins: [(0, _ContextUtils.ContextSubscriber)('router')],
	
	    contextTypes: { router: _PropTypes.routerShape },
	    propTypes: { router: _PropTypes.routerShape },
	
	    getWrappedInstance: function getWrappedInstance() {
	      !withRef ?  false ? (0, _invariant2.default)(false, 'To access the wrapped instance, you need to specify ' + '`{ withRef: true }` as the second argument of the withRouter() call.') : (0, _invariant2.default)(false) : void 0;
	
	      return this.wrappedInstance;
	    },
	    render: function render() {
	      var _this = this;
	
	      var router = this.props.router || this.context.router;
	      if (!router) {
	        return _react2.default.createElement(WrappedComponent, this.props);
	      }
	
	      var params = router.params,
	          location = router.location,
	          routes = router.routes;
	
	      var props = _extends({}, this.props, { router: router, params: params, location: location, routes: routes });
	
	      if (withRef) {
	        props.ref = function (c) {
	          _this.wrappedInstance = c;
	        };
	      }
	
	      return _react2.default.createElement(WrappedComponent, props);
	    }
	  });
	
	  WithRouter.displayName = 'withRouter(' + getDisplayName(WrappedComponent) + ')';
	  WithRouter.WrappedComponent = WrappedComponent;
	
	  return (0, _hoistNonReactStatics2.default)(WithRouter, WrappedComponent);
	}
	module.exports = exports['default'];

/***/ },
/* 1062 */
252,
/* 1063 */
[1138, 149],
/* 1064 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var PooledClass = __webpack_require__(1063);
	var ReactElement = __webpack_require__(131);
	
	var emptyFunction = __webpack_require__(80);
	var traverseAllChildren = __webpack_require__(1073);
	
	var twoArgumentPooler = PooledClass.twoArgumentPooler;
	var fourArgumentPooler = PooledClass.fourArgumentPooler;
	
	var userProvidedKeyEscapeRegex = /\/+/g;
	function escapeUserProvidedKey(text) {
	  return ('' + text).replace(userProvidedKeyEscapeRegex, '$&/');
	}
	
	/**
	 * PooledClass representing the bookkeeping associated with performing a child
	 * traversal. Allows avoiding binding callbacks.
	 *
	 * @constructor ForEachBookKeeping
	 * @param {!function} forEachFunction Function to perform traversal with.
	 * @param {?*} forEachContext Context to perform context with.
	 */
	function ForEachBookKeeping(forEachFunction, forEachContext) {
	  this.func = forEachFunction;
	  this.context = forEachContext;
	  this.count = 0;
	}
	ForEachBookKeeping.prototype.destructor = function () {
	  this.func = null;
	  this.context = null;
	  this.count = 0;
	};
	PooledClass.addPoolingTo(ForEachBookKeeping, twoArgumentPooler);
	
	function forEachSingleChild(bookKeeping, child, name) {
	  var func = bookKeeping.func,
	      context = bookKeeping.context;
	
	  func.call(context, child, bookKeeping.count++);
	}
	
	/**
	 * Iterates through children that are typically specified as `props.children`.
	 *
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.foreach
	 *
	 * The provided forEachFunc(child, index) will be called for each
	 * leaf child.
	 *
	 * @param {?*} children Children tree container.
	 * @param {function(*, int)} forEachFunc
	 * @param {*} forEachContext Context for forEachContext.
	 */
	function forEachChildren(children, forEachFunc, forEachContext) {
	  if (children == null) {
	    return children;
	  }
	  var traverseContext = ForEachBookKeeping.getPooled(forEachFunc, forEachContext);
	  traverseAllChildren(children, forEachSingleChild, traverseContext);
	  ForEachBookKeeping.release(traverseContext);
	}
	
	/**
	 * PooledClass representing the bookkeeping associated with performing a child
	 * mapping. Allows avoiding binding callbacks.
	 *
	 * @constructor MapBookKeeping
	 * @param {!*} mapResult Object containing the ordered map of results.
	 * @param {!function} mapFunction Function to perform mapping with.
	 * @param {?*} mapContext Context to perform mapping with.
	 */
	function MapBookKeeping(mapResult, keyPrefix, mapFunction, mapContext) {
	  this.result = mapResult;
	  this.keyPrefix = keyPrefix;
	  this.func = mapFunction;
	  this.context = mapContext;
	  this.count = 0;
	}
	MapBookKeeping.prototype.destructor = function () {
	  this.result = null;
	  this.keyPrefix = null;
	  this.func = null;
	  this.context = null;
	  this.count = 0;
	};
	PooledClass.addPoolingTo(MapBookKeeping, fourArgumentPooler);
	
	function mapSingleChildIntoContext(bookKeeping, child, childKey) {
	  var result = bookKeeping.result,
	      keyPrefix = bookKeeping.keyPrefix,
	      func = bookKeeping.func,
	      context = bookKeeping.context;
	
	
	  var mappedChild = func.call(context, child, bookKeeping.count++);
	  if (Array.isArray(mappedChild)) {
	    mapIntoWithKeyPrefixInternal(mappedChild, result, childKey, emptyFunction.thatReturnsArgument);
	  } else if (mappedChild != null) {
	    if (ReactElement.isValidElement(mappedChild)) {
	      mappedChild = ReactElement.cloneAndReplaceKey(mappedChild,
	      // Keep both the (mapped) and old keys if they differ, just as
	      // traverseAllChildren used to do for objects as children
	      keyPrefix + (mappedChild.key && (!child || child.key !== mappedChild.key) ? escapeUserProvidedKey(mappedChild.key) + '/' : '') + childKey);
	    }
	    result.push(mappedChild);
	  }
	}
	
	function mapIntoWithKeyPrefixInternal(children, array, prefix, func, context) {
	  var escapedPrefix = '';
	  if (prefix != null) {
	    escapedPrefix = escapeUserProvidedKey(prefix) + '/';
	  }
	  var traverseContext = MapBookKeeping.getPooled(array, escapedPrefix, func, context);
	  traverseAllChildren(children, mapSingleChildIntoContext, traverseContext);
	  MapBookKeeping.release(traverseContext);
	}
	
	/**
	 * Maps children that are typically specified as `props.children`.
	 *
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.map
	 *
	 * The provided mapFunction(child, key, index) will be called for each
	 * leaf child.
	 *
	 * @param {?*} children Children tree container.
	 * @param {function(*, int)} func The map function.
	 * @param {*} context Context for mapFunction.
	 * @return {object} Object containing the ordered map of results.
	 */
	function mapChildren(children, func, context) {
	  if (children == null) {
	    return children;
	  }
	  var result = [];
	  mapIntoWithKeyPrefixInternal(children, result, null, func, context);
	  return result;
	}
	
	function forEachSingleChildDummy(traverseContext, child, name) {
	  return null;
	}
	
	/**
	 * Count the number of children that are typically specified as
	 * `props.children`.
	 *
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.count
	 *
	 * @param {?*} children Children tree container.
	 * @return {number} The number of children.
	 */
	function countChildren(children, context) {
	  return traverseAllChildren(children, forEachSingleChildDummy, null);
	}
	
	/**
	 * Flatten a children object (typically specified as `props.children`) and
	 * return an array with appropriately re-keyed children.
	 *
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.toarray
	 */
	function toArray(children) {
	  var result = [];
	  mapIntoWithKeyPrefixInternal(children, result, null, emptyFunction.thatReturnsArgument);
	  return result;
	}
	
	var ReactChildren = {
	  forEach: forEachChildren,
	  map: mapChildren,
	  mapIntoWithKeyPrefixInternal: mapIntoWithKeyPrefixInternal,
	  count: countChildren,
	  toArray: toArray
	};
	
	module.exports = ReactChildren;

/***/ },
/* 1065 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ReactElement = __webpack_require__(131);
	
	/**
	 * Create a factory that creates HTML tag elements.
	 *
	 * @private
	 */
	var createDOMFactory = ReactElement.createFactory;
	if (false) {
	  var ReactElementValidator = require('./ReactElementValidator');
	  createDOMFactory = ReactElementValidator.createFactory;
	}
	
	/**
	 * Creates a mapping from supported HTML tags to `ReactDOMComponent` classes.
	 *
	 * @public
	 */
	var ReactDOMFactories = {
	  a: createDOMFactory('a'),
	  abbr: createDOMFactory('abbr'),
	  address: createDOMFactory('address'),
	  area: createDOMFactory('area'),
	  article: createDOMFactory('article'),
	  aside: createDOMFactory('aside'),
	  audio: createDOMFactory('audio'),
	  b: createDOMFactory('b'),
	  base: createDOMFactory('base'),
	  bdi: createDOMFactory('bdi'),
	  bdo: createDOMFactory('bdo'),
	  big: createDOMFactory('big'),
	  blockquote: createDOMFactory('blockquote'),
	  body: createDOMFactory('body'),
	  br: createDOMFactory('br'),
	  button: createDOMFactory('button'),
	  canvas: createDOMFactory('canvas'),
	  caption: createDOMFactory('caption'),
	  cite: createDOMFactory('cite'),
	  code: createDOMFactory('code'),
	  col: createDOMFactory('col'),
	  colgroup: createDOMFactory('colgroup'),
	  data: createDOMFactory('data'),
	  datalist: createDOMFactory('datalist'),
	  dd: createDOMFactory('dd'),
	  del: createDOMFactory('del'),
	  details: createDOMFactory('details'),
	  dfn: createDOMFactory('dfn'),
	  dialog: createDOMFactory('dialog'),
	  div: createDOMFactory('div'),
	  dl: createDOMFactory('dl'),
	  dt: createDOMFactory('dt'),
	  em: createDOMFactory('em'),
	  embed: createDOMFactory('embed'),
	  fieldset: createDOMFactory('fieldset'),
	  figcaption: createDOMFactory('figcaption'),
	  figure: createDOMFactory('figure'),
	  footer: createDOMFactory('footer'),
	  form: createDOMFactory('form'),
	  h1: createDOMFactory('h1'),
	  h2: createDOMFactory('h2'),
	  h3: createDOMFactory('h3'),
	  h4: createDOMFactory('h4'),
	  h5: createDOMFactory('h5'),
	  h6: createDOMFactory('h6'),
	  head: createDOMFactory('head'),
	  header: createDOMFactory('header'),
	  hgroup: createDOMFactory('hgroup'),
	  hr: createDOMFactory('hr'),
	  html: createDOMFactory('html'),
	  i: createDOMFactory('i'),
	  iframe: createDOMFactory('iframe'),
	  img: createDOMFactory('img'),
	  input: createDOMFactory('input'),
	  ins: createDOMFactory('ins'),
	  kbd: createDOMFactory('kbd'),
	  keygen: createDOMFactory('keygen'),
	  label: createDOMFactory('label'),
	  legend: createDOMFactory('legend'),
	  li: createDOMFactory('li'),
	  link: createDOMFactory('link'),
	  main: createDOMFactory('main'),
	  map: createDOMFactory('map'),
	  mark: createDOMFactory('mark'),
	  menu: createDOMFactory('menu'),
	  menuitem: createDOMFactory('menuitem'),
	  meta: createDOMFactory('meta'),
	  meter: createDOMFactory('meter'),
	  nav: createDOMFactory('nav'),
	  noscript: createDOMFactory('noscript'),
	  object: createDOMFactory('object'),
	  ol: createDOMFactory('ol'),
	  optgroup: createDOMFactory('optgroup'),
	  option: createDOMFactory('option'),
	  output: createDOMFactory('output'),
	  p: createDOMFactory('p'),
	  param: createDOMFactory('param'),
	  picture: createDOMFactory('picture'),
	  pre: createDOMFactory('pre'),
	  progress: createDOMFactory('progress'),
	  q: createDOMFactory('q'),
	  rp: createDOMFactory('rp'),
	  rt: createDOMFactory('rt'),
	  ruby: createDOMFactory('ruby'),
	  s: createDOMFactory('s'),
	  samp: createDOMFactory('samp'),
	  script: createDOMFactory('script'),
	  section: createDOMFactory('section'),
	  select: createDOMFactory('select'),
	  small: createDOMFactory('small'),
	  source: createDOMFactory('source'),
	  span: createDOMFactory('span'),
	  strong: createDOMFactory('strong'),
	  style: createDOMFactory('style'),
	  sub: createDOMFactory('sub'),
	  summary: createDOMFactory('summary'),
	  sup: createDOMFactory('sup'),
	  table: createDOMFactory('table'),
	  tbody: createDOMFactory('tbody'),
	  td: createDOMFactory('td'),
	  textarea: createDOMFactory('textarea'),
	  tfoot: createDOMFactory('tfoot'),
	  th: createDOMFactory('th'),
	  thead: createDOMFactory('thead'),
	  time: createDOMFactory('time'),
	  title: createDOMFactory('title'),
	  tr: createDOMFactory('tr'),
	  track: createDOMFactory('track'),
	  u: createDOMFactory('u'),
	  ul: createDOMFactory('ul'),
	  'var': createDOMFactory('var'),
	  video: createDOMFactory('video'),
	  wbr: createDOMFactory('wbr'),
	
	  // SVG
	  circle: createDOMFactory('circle'),
	  clipPath: createDOMFactory('clipPath'),
	  defs: createDOMFactory('defs'),
	  ellipse: createDOMFactory('ellipse'),
	  g: createDOMFactory('g'),
	  image: createDOMFactory('image'),
	  line: createDOMFactory('line'),
	  linearGradient: createDOMFactory('linearGradient'),
	  mask: createDOMFactory('mask'),
	  path: createDOMFactory('path'),
	  pattern: createDOMFactory('pattern'),
	  polygon: createDOMFactory('polygon'),
	  polyline: createDOMFactory('polyline'),
	  radialGradient: createDOMFactory('radialGradient'),
	  rect: createDOMFactory('rect'),
	  stop: createDOMFactory('stop'),
	  svg: createDOMFactory('svg'),
	  text: createDOMFactory('text'),
	  tspan: createDOMFactory('tspan')
	};
	
	module.exports = ReactDOMFactories;

/***/ },
/* 1066 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _require = __webpack_require__(131),
	    isValidElement = _require.isValidElement;
	
	var factory = __webpack_require__(378);
	
	module.exports = factory(isValidElement);

/***/ },
/* 1067 */
398,
/* 1068 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _require = __webpack_require__(426),
	    Component = _require.Component;
	
	var _require2 = __webpack_require__(131),
	    isValidElement = _require2.isValidElement;
	
	var ReactNoopUpdateQueue = __webpack_require__(429);
	var factory = __webpack_require__(325);
	
	module.exports = factory(Component, isValidElement, ReactNoopUpdateQueue);

/***/ },
/* 1069 */
1021,
/* 1070 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var nextDebugID = 1;
	
	function getNextDebugID() {
	  return nextDebugID++;
	}
	
	module.exports = getNextDebugID;

/***/ },
/* 1071 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2014-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	/**
	 * Forked from fbjs/warning:
	 * https://github.com/facebook/fbjs/blob/e66ba20ad5be433eb54423f2b097d829324d9de6/packages/fbjs/src/__forks__/warning.js
	 *
	 * Only change is we use console.warn instead of console.error,
	 * and do nothing when 'console' is not supported.
	 * This really simplifies the code.
	 * ---
	 * Similar to invariant but only logs a warning if the condition is not met.
	 * This can be used to log issues in development environments in critical
	 * paths. Removing the logging code for production environments will keep the
	 * same logic and follow the same code paths.
	 */
	
	var lowPriorityWarning = function () {};
	
	if (false) {
	  var printWarning = function (format) {
	    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	      args[_key - 1] = arguments[_key];
	    }
	
	    var argIndex = 0;
	    var message = 'Warning: ' + format.replace(/%s/g, function () {
	      return args[argIndex++];
	    });
	    if (typeof console !== 'undefined') {
	      console.warn(message);
	    }
	    try {
	      // --- Welcome to debugging React ---
	      // This error was thrown as a convenience so that you can use this stack
	      // to find the callsite that caused this warning to fire.
	      throw new Error(message);
	    } catch (x) {}
	  };
	
	  lowPriorityWarning = function (condition, format) {
	    if (format === undefined) {
	      throw new Error('`warning(condition, format, ...args)` requires a warning ' + 'message argument');
	    }
	    if (!condition) {
	      for (var _len2 = arguments.length, args = Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
	        args[_key2 - 2] = arguments[_key2];
	      }
	
	      printWarning.apply(undefined, [format].concat(args));
	    }
	  };
	}
	
	module.exports = lowPriorityWarning;

/***/ },
/* 1072 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	'use strict';
	
	var _prodInvariant = __webpack_require__(149);
	
	var ReactElement = __webpack_require__(131);
	
	var invariant = __webpack_require__(21);
	
	/**
	 * Returns the first child in a collection of children and verifies that there
	 * is only one child in the collection.
	 *
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.only
	 *
	 * The current implementation of this function assumes that a single child gets
	 * passed without a wrapper, but the purpose of this helper function is to
	 * abstract away the particular structure of children.
	 *
	 * @param {?object} children Child collection structure.
	 * @return {ReactElement} The first and only `ReactElement` contained in the
	 * structure.
	 */
	function onlyChild(children) {
	  !ReactElement.isValidElement(children) ?  false ? invariant(false, 'React.Children.only expected to receive a single React element child.') : _prodInvariant('143') : void 0;
	  return children;
	}
	
	module.exports = onlyChild;

/***/ },
/* 1073 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(149);
	
	var ReactCurrentOwner = __webpack_require__(92);
	var REACT_ELEMENT_TYPE = __webpack_require__(428);
	
	var getIteratorFn = __webpack_require__(1069);
	var invariant = __webpack_require__(21);
	var KeyEscapeUtils = __webpack_require__(1062);
	var warning = __webpack_require__(30);
	
	var SEPARATOR = '.';
	var SUBSEPARATOR = ':';
	
	/**
	 * This is inlined from ReactElement since this file is shared between
	 * isomorphic and renderers. We could extract this to a
	 *
	 */
	
	/**
	 * TODO: Test that a single child and an array with one item have the same key
	 * pattern.
	 */
	
	var didWarnAboutMaps = false;
	
	/**
	 * Generate a key string that identifies a component within a set.
	 *
	 * @param {*} component A component that could contain a manual key.
	 * @param {number} index Index that is used if a manual key is not provided.
	 * @return {string}
	 */
	function getComponentKey(component, index) {
	  // Do some typechecking here since we call this blindly. We want to ensure
	  // that we don't block potential future ES APIs.
	  if (component && typeof component === 'object' && component.key != null) {
	    // Explicit key
	    return KeyEscapeUtils.escape(component.key);
	  }
	  // Implicit key determined by the index in the set
	  return index.toString(36);
	}
	
	/**
	 * @param {?*} children Children tree container.
	 * @param {!string} nameSoFar Name of the key path so far.
	 * @param {!function} callback Callback to invoke with each child found.
	 * @param {?*} traverseContext Used to pass information throughout the traversal
	 * process.
	 * @return {!number} The number of children in this subtree.
	 */
	function traverseAllChildrenImpl(children, nameSoFar, callback, traverseContext) {
	  var type = typeof children;
	
	  if (type === 'undefined' || type === 'boolean') {
	    // All of the above are perceived as null.
	    children = null;
	  }
	
	  if (children === null || type === 'string' || type === 'number' ||
	  // The following is inlined from ReactElement. This means we can optimize
	  // some checks. React Fiber also inlines this logic for similar purposes.
	  type === 'object' && children.$$typeof === REACT_ELEMENT_TYPE) {
	    callback(traverseContext, children,
	    // If it's the only child, treat the name as if it was wrapped in an array
	    // so that it's consistent if the number of children grows.
	    nameSoFar === '' ? SEPARATOR + getComponentKey(children, 0) : nameSoFar);
	    return 1;
	  }
	
	  var child;
	  var nextName;
	  var subtreeCount = 0; // Count of children found in the current subtree.
	  var nextNamePrefix = nameSoFar === '' ? SEPARATOR : nameSoFar + SUBSEPARATOR;
	
	  if (Array.isArray(children)) {
	    for (var i = 0; i < children.length; i++) {
	      child = children[i];
	      nextName = nextNamePrefix + getComponentKey(child, i);
	      subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
	    }
	  } else {
	    var iteratorFn = getIteratorFn(children);
	    if (iteratorFn) {
	      var iterator = iteratorFn.call(children);
	      var step;
	      if (iteratorFn !== children.entries) {
	        var ii = 0;
	        while (!(step = iterator.next()).done) {
	          child = step.value;
	          nextName = nextNamePrefix + getComponentKey(child, ii++);
	          subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
	        }
	      } else {
	        if (false) {
	          var mapsAsChildrenAddendum = '';
	          if (ReactCurrentOwner.current) {
	            var mapsAsChildrenOwnerName = ReactCurrentOwner.current.getName();
	            if (mapsAsChildrenOwnerName) {
	              mapsAsChildrenAddendum = ' Check the render method of `' + mapsAsChildrenOwnerName + '`.';
	            }
	          }
	          process.env.NODE_ENV !== 'production' ? warning(didWarnAboutMaps, 'Using Maps as children is not yet fully supported. It is an ' + 'experimental feature that might be removed. Convert it to a ' + 'sequence / iterable of keyed ReactElements instead.%s', mapsAsChildrenAddendum) : void 0;
	          didWarnAboutMaps = true;
	        }
	        // Iterator will provide entry [k,v] tuples rather than values.
	        while (!(step = iterator.next()).done) {
	          var entry = step.value;
	          if (entry) {
	            child = entry[1];
	            nextName = nextNamePrefix + KeyEscapeUtils.escape(entry[0]) + SUBSEPARATOR + getComponentKey(child, 0);
	            subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
	          }
	        }
	      }
	    } else if (type === 'object') {
	      var addendum = '';
	      if (false) {
	        addendum = ' If you meant to render a collection of children, use an array ' + 'instead or wrap the object using createFragment(object) from the ' + 'React add-ons.';
	        if (children._isReactElement) {
	          addendum = " It looks like you're using an element created by a different " + 'version of React. Make sure to use only one copy of React.';
	        }
	        if (ReactCurrentOwner.current) {
	          var name = ReactCurrentOwner.current.getName();
	          if (name) {
	            addendum += ' Check the render method of `' + name + '`.';
	          }
	        }
	      }
	      var childrenString = String(children);
	       true ?  false ? invariant(false, 'Objects are not valid as a React child (found: %s).%s', childrenString === '[object Object]' ? 'object with keys {' + Object.keys(children).join(', ') + '}' : childrenString, addendum) : _prodInvariant('31', childrenString === '[object Object]' ? 'object with keys {' + Object.keys(children).join(', ') + '}' : childrenString, addendum) : void 0;
	    }
	  }
	
	  return subtreeCount;
	}
	
	/**
	 * Traverses children that are typically specified as `props.children`, but
	 * might also be specified through attributes:
	 *
	 * - `traverseAllChildren(this.props.children, ...)`
	 * - `traverseAllChildren(this.props.leftPanelChildren, ...)`
	 *
	 * The `traverseContext` is an optional argument that is passed through the
	 * entire traversal. It can be used to store accumulations or anything else that
	 * the callback might find relevant.
	 *
	 * @param {?*} children Children tree object.
	 * @param {!function} callback To invoke upon traversing each child.
	 * @param {?*} traverseContext Context for traversal.
	 * @return {!number} The number of children in this subtree.
	 */
	function traverseAllChildren(children, callback, traverseContext) {
	  if (children == null) {
	    return 0;
	  }
	
	  return traverseAllChildrenImpl(children, '', callback, traverseContext);
	}
	
	module.exports = traverseAllChildren;

/***/ },
/* 1074 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = immutableStateInvariantMiddleware;
	
	var _invariant = __webpack_require__(46);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _jsonStringifySafe = __webpack_require__(847);
	
	var _jsonStringifySafe2 = _interopRequireDefault(_jsonStringifySafe);
	
	var _isImmutable = __webpack_require__(1075);
	
	var _isImmutable2 = _interopRequireDefault(_isImmutable);
	
	var _trackForMutations = __webpack_require__(1076);
	
	var _trackForMutations2 = _interopRequireDefault(_trackForMutations);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var BETWEEN_DISPATCHES_MESSAGE = ['A state mutation was detected between dispatches, in the path `%s`.', 'This may cause incorrect behavior.', '(http://redux.js.org/docs/Troubleshooting.html#never-mutate-reducer-arguments)'].join(' ');
	
	var INSIDE_DISPATCH_MESSAGE = ['A state mutation was detected inside a dispatch, in the path: `%s`.', 'Take a look at the reducer(s) handling the action %s.', '(http://redux.js.org/docs/Troubleshooting.html#never-mutate-reducer-arguments)'].join(' ');
	
	function immutableStateInvariantMiddleware() {
	  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	  var _options$isImmutable = options.isImmutable,
	      isImmutable = _options$isImmutable === undefined ? _isImmutable2.default : _options$isImmutable,
	      ignore = options.ignore;
	
	  var track = _trackForMutations2.default.bind(null, isImmutable, ignore);
	
	  return function (_ref) {
	    var getState = _ref.getState;
	
	    var state = getState();
	    var tracker = track(state);
	
	    var result = void 0;
	    return function (next) {
	      return function (action) {
	        state = getState();
	
	        result = tracker.detectMutations();
	        // Track before potentially not meeting the invariant
	        tracker = track(state);
	
	        (0, _invariant2.default)(!result.wasMutated, BETWEEN_DISPATCHES_MESSAGE, (result.path || []).join('.'));
	
	        var dispatchedAction = next(action);
	        state = getState();
	
	        result = tracker.detectMutations();
	        // Track before potentially not meeting the invariant
	        tracker = track(state);
	
	        result.wasMutated && (0, _invariant2.default)(!result.wasMutated, INSIDE_DISPATCH_MESSAGE, (result.path || []).join('.'), (0, _jsonStringifySafe2.default)(action));
	
	        return dispatchedAction;
	      };
	    };
	  };
	}

/***/ },
/* 1075 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	exports.default = isImmutableDefault;
	function isImmutableDefault(value) {
	  return (typeof value === 'undefined' ? 'undefined' : _typeof(value)) !== 'object' || value === null || typeof value === 'undefined';
	}

/***/ },
/* 1076 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = trackForMutations;
	function trackForMutations(isImmutable, ignore, obj) {
	  var trackedProperties = trackProperties(isImmutable, ignore, obj);
	  return {
	    detectMutations: function detectMutations() {
	      return _detectMutations(isImmutable, ignore, trackedProperties, obj);
	    }
	  };
	}
	
	function trackProperties(isImmutable) {
	  var ignore = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
	  var obj = arguments[2];
	  var path = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : [];
	
	  var tracked = { value: obj };
	
	  if (!isImmutable(obj)) {
	    tracked.children = {};
	
	    for (var key in obj) {
	      var childPath = path.concat(key);
	      if (ignore.length && ignore.indexOf(childPath.join('.')) !== -1) {
	        continue;
	      }
	
	      tracked.children[key] = trackProperties(isImmutable, ignore, obj[key], childPath);
	    }
	  }
	  return tracked;
	}
	
	function _detectMutations(isImmutable) {
	  var ignore = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
	  var trackedProperty = arguments[2];
	  var obj = arguments[3];
	  var sameParentRef = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;
	  var path = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : [];
	
	  var prevObj = trackedProperty ? trackedProperty.value : undefined;
	
	  var sameRef = prevObj === obj;
	
	  if (sameParentRef && !sameRef && !Number.isNaN(obj)) {
	    return { wasMutated: true, path: path };
	  }
	
	  if (isImmutable(prevObj) || isImmutable(obj)) {
	    return { wasMutated: false };
	  }
	
	  // Gather all keys from prev (tracked) and after objs
	  var keysToDetect = {};
	  Object.keys(trackedProperty.children).forEach(function (key) {
	    keysToDetect[key] = true;
	  });
	  Object.keys(obj).forEach(function (key) {
	    keysToDetect[key] = true;
	  });
	
	  var keys = Object.keys(keysToDetect);
	  for (var i = 0; i < keys.length; i++) {
	    var key = keys[i];
	    var childPath = path.concat(key);
	    if (ignore.length && ignore.indexOf(childPath.join('.')) !== -1) {
	      continue;
	    }
	
	    var result = _detectMutations(isImmutable, ignore, trackedProperty.children[key], obj[key], sameRef, childPath);
	
	    if (result.wasMutated) {
	      return result;
	    }
	  }
	  return { wasMutated: false };
	}

/***/ },
/* 1077 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	function createThunkMiddleware(extraArgument) {
	  return function (_ref) {
	    var dispatch = _ref.dispatch,
	        getState = _ref.getState;
	    return function (next) {
	      return function (action) {
	        if (typeof action === 'function') {
	          return action(dispatch, getState, extraArgument);
	        }
	
	        return next(action);
	      };
	    };
	  };
	}
	
	var thunk = createThunkMiddleware();
	thunk.withExtraArgument = createThunkMiddleware;
	
	exports['default'] = thunk;

/***/ },
/* 1078 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports['default'] = applyMiddleware;
	
	var _compose = __webpack_require__(431);
	
	var _compose2 = _interopRequireDefault(_compose);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	/**
	 * Creates a store enhancer that applies middleware to the dispatch method
	 * of the Redux store. This is handy for a variety of tasks, such as expressing
	 * asynchronous actions in a concise manner, or logging every action payload.
	 *
	 * See `redux-thunk` package as an example of the Redux middleware.
	 *
	 * Because middleware is potentially asynchronous, this should be the first
	 * store enhancer in the composition chain.
	 *
	 * Note that each middleware will be given the `dispatch` and `getState` functions
	 * as named arguments.
	 *
	 * @param {...Function} middlewares The middleware chain to be applied.
	 * @returns {Function} A store enhancer applying the middleware.
	 */
	function applyMiddleware() {
	  for (var _len = arguments.length, middlewares = Array(_len), _key = 0; _key < _len; _key++) {
	    middlewares[_key] = arguments[_key];
	  }
	
	  return function (createStore) {
	    return function (reducer, preloadedState, enhancer) {
	      var store = createStore(reducer, preloadedState, enhancer);
	      var _dispatch = store.dispatch;
	      var chain = [];
	
	      var middlewareAPI = {
	        getState: store.getState,
	        dispatch: function dispatch(action) {
	          return _dispatch(action);
	        }
	      };
	      chain = middlewares.map(function (middleware) {
	        return middleware(middlewareAPI);
	      });
	      _dispatch = _compose2['default'].apply(undefined, chain)(store.dispatch);
	
	      return _extends({}, store, {
	        dispatch: _dispatch
	      });
	    };
	  };
	}

/***/ },
/* 1079 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports['default'] = bindActionCreators;
	function bindActionCreator(actionCreator, dispatch) {
	  return function () {
	    return dispatch(actionCreator.apply(undefined, arguments));
	  };
	}
	
	/**
	 * Turns an object whose values are action creators, into an object with the
	 * same keys, but with every function wrapped into a `dispatch` call so they
	 * may be invoked directly. This is just a convenience method, as you can call
	 * `store.dispatch(MyActionCreators.doSomething())` yourself just fine.
	 *
	 * For convenience, you can also pass a single function as the first argument,
	 * and get a function in return.
	 *
	 * @param {Function|Object} actionCreators An object whose values are action
	 * creator functions. One handy way to obtain it is to use ES6 `import * as`
	 * syntax. You may also pass a single function.
	 *
	 * @param {Function} dispatch The `dispatch` function available on your Redux
	 * store.
	 *
	 * @returns {Function|Object} The object mimicking the original object, but with
	 * every action creator wrapped into the `dispatch` call. If you passed a
	 * function as `actionCreators`, the return value will also be a single
	 * function.
	 */
	function bindActionCreators(actionCreators, dispatch) {
	  if (typeof actionCreators === 'function') {
	    return bindActionCreator(actionCreators, dispatch);
	  }
	
	  if (typeof actionCreators !== 'object' || actionCreators === null) {
	    throw new Error('bindActionCreators expected an object or a function, instead received ' + (actionCreators === null ? 'null' : typeof actionCreators) + '. ' + 'Did you write "import ActionCreators from" instead of "import * as ActionCreators from"?');
	  }
	
	  var keys = Object.keys(actionCreators);
	  var boundActionCreators = {};
	  for (var i = 0; i < keys.length; i++) {
	    var key = keys[i];
	    var actionCreator = actionCreators[key];
	    if (typeof actionCreator === 'function') {
	      boundActionCreators[key] = bindActionCreator(actionCreator, dispatch);
	    }
	  }
	  return boundActionCreators;
	}

/***/ },
/* 1080 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports['default'] = combineReducers;
	
	var _createStore = __webpack_require__(432);
	
	var _isPlainObject = __webpack_require__(246);
	
	var _isPlainObject2 = _interopRequireDefault(_isPlainObject);
	
	var _warning = __webpack_require__(433);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function getUndefinedStateErrorMessage(key, action) {
	  var actionType = action && action.type;
	  var actionName = actionType && '"' + actionType.toString() + '"' || 'an action';
	
	  return 'Given action ' + actionName + ', reducer "' + key + '" returned undefined. ' + 'To ignore an action, you must explicitly return the previous state. ' + 'If you want this reducer to hold no value, you can return null instead of undefined.';
	}
	
	function getUnexpectedStateShapeWarningMessage(inputState, reducers, action, unexpectedKeyCache) {
	  var reducerKeys = Object.keys(reducers);
	  var argumentName = action && action.type === _createStore.ActionTypes.INIT ? 'preloadedState argument passed to createStore' : 'previous state received by the reducer';
	
	  if (reducerKeys.length === 0) {
	    return 'Store does not have a valid reducer. Make sure the argument passed ' + 'to combineReducers is an object whose values are reducers.';
	  }
	
	  if (!(0, _isPlainObject2['default'])(inputState)) {
	    return 'The ' + argumentName + ' has unexpected type of "' + {}.toString.call(inputState).match(/\s([a-z|A-Z]+)/)[1] + '". Expected argument to be an object with the following ' + ('keys: "' + reducerKeys.join('", "') + '"');
	  }
	
	  var unexpectedKeys = Object.keys(inputState).filter(function (key) {
	    return !reducers.hasOwnProperty(key) && !unexpectedKeyCache[key];
	  });
	
	  unexpectedKeys.forEach(function (key) {
	    unexpectedKeyCache[key] = true;
	  });
	
	  if (unexpectedKeys.length > 0) {
	    return 'Unexpected ' + (unexpectedKeys.length > 1 ? 'keys' : 'key') + ' ' + ('"' + unexpectedKeys.join('", "') + '" found in ' + argumentName + '. ') + 'Expected to find one of the known reducer keys instead: ' + ('"' + reducerKeys.join('", "') + '". Unexpected keys will be ignored.');
	  }
	}
	
	function assertReducerShape(reducers) {
	  Object.keys(reducers).forEach(function (key) {
	    var reducer = reducers[key];
	    var initialState = reducer(undefined, { type: _createStore.ActionTypes.INIT });
	
	    if (typeof initialState === 'undefined') {
	      throw new Error('Reducer "' + key + '" returned undefined during initialization. ' + 'If the state passed to the reducer is undefined, you must ' + 'explicitly return the initial state. The initial state may ' + 'not be undefined. If you don\'t want to set a value for this reducer, ' + 'you can use null instead of undefined.');
	    }
	
	    var type = '@@redux/PROBE_UNKNOWN_ACTION_' + Math.random().toString(36).substring(7).split('').join('.');
	    if (typeof reducer(undefined, { type: type }) === 'undefined') {
	      throw new Error('Reducer "' + key + '" returned undefined when probed with a random type. ' + ('Don\'t try to handle ' + _createStore.ActionTypes.INIT + ' or other actions in "redux/*" ') + 'namespace. They are considered private. Instead, you must return the ' + 'current state for any unknown actions, unless it is undefined, ' + 'in which case you must return the initial state, regardless of the ' + 'action type. The initial state may not be undefined, but can be null.');
	    }
	  });
	}
	
	/**
	 * Turns an object whose values are different reducer functions, into a single
	 * reducer function. It will call every child reducer, and gather their results
	 * into a single state object, whose keys correspond to the keys of the passed
	 * reducer functions.
	 *
	 * @param {Object} reducers An object whose values correspond to different
	 * reducer functions that need to be combined into one. One handy way to obtain
	 * it is to use ES6 `import * as reducers` syntax. The reducers may never return
	 * undefined for any action. Instead, they should return their initial state
	 * if the state passed to them was undefined, and the current state for any
	 * unrecognized action.
	 *
	 * @returns {Function} A reducer function that invokes every reducer inside the
	 * passed object, and builds a state object with the same shape.
	 */
	function combineReducers(reducers) {
	  var reducerKeys = Object.keys(reducers);
	  var finalReducers = {};
	  for (var i = 0; i < reducerKeys.length; i++) {
	    var key = reducerKeys[i];
	
	    if (false) {
	      if (typeof reducers[key] === 'undefined') {
	        (0, _warning2['default'])('No reducer provided for key "' + key + '"');
	      }
	    }
	
	    if (typeof reducers[key] === 'function') {
	      finalReducers[key] = reducers[key];
	    }
	  }
	  var finalReducerKeys = Object.keys(finalReducers);
	
	  var unexpectedKeyCache = void 0;
	  if (false) {
	    unexpectedKeyCache = {};
	  }
	
	  var shapeAssertionError = void 0;
	  try {
	    assertReducerShape(finalReducers);
	  } catch (e) {
	    shapeAssertionError = e;
	  }
	
	  return function combination() {
	    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	    var action = arguments[1];
	
	    if (shapeAssertionError) {
	      throw shapeAssertionError;
	    }
	
	    if (false) {
	      var warningMessage = getUnexpectedStateShapeWarningMessage(state, finalReducers, action, unexpectedKeyCache);
	      if (warningMessage) {
	        (0, _warning2['default'])(warningMessage);
	      }
	    }
	
	    var hasChanged = false;
	    var nextState = {};
	    for (var _i = 0; _i < finalReducerKeys.length; _i++) {
	      var _key = finalReducerKeys[_i];
	      var reducer = finalReducers[_key];
	      var previousStateForKey = state[_key];
	      var nextStateForKey = reducer(previousStateForKey, action);
	      if (typeof nextStateForKey === 'undefined') {
	        var errorMessage = getUndefinedStateErrorMessage(_key, action);
	        throw new Error(errorMessage);
	      }
	      nextState[_key] = nextStateForKey;
	      hasChanged = hasChanged || nextStateForKey !== previousStateForKey;
	    }
	    return hasChanged ? nextState : state;
	  };
	}

/***/ },
/* 1081 */
/***/ function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {/**
	 * Copyright (c) 2014, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * https://raw.github.com/facebook/regenerator/master/LICENSE file. An
	 * additional grant of patent rights can be found in the PATENTS file in
	 * the same directory.
	 */
	
	!(function(global) {
	  "use strict";
	
	  var Op = Object.prototype;
	  var hasOwn = Op.hasOwnProperty;
	  var undefined; // More compressible than void 0.
	  var $Symbol = typeof Symbol === "function" ? Symbol : {};
	  var iteratorSymbol = $Symbol.iterator || "@@iterator";
	  var asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator";
	  var toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";
	
	  var inModule = typeof module === "object";
	  var runtime = global.regeneratorRuntime;
	  if (runtime) {
	    if (inModule) {
	      // If regeneratorRuntime is defined globally and we're in a module,
	      // make the exports object identical to regeneratorRuntime.
	      module.exports = runtime;
	    }
	    // Don't bother evaluating the rest of this file if the runtime was
	    // already defined globally.
	    return;
	  }
	
	  // Define the runtime globally (as expected by generated code) as either
	  // module.exports (if we're in a module) or a new, empty object.
	  runtime = global.regeneratorRuntime = inModule ? module.exports : {};
	
	  function wrap(innerFn, outerFn, self, tryLocsList) {
	    // If outerFn provided and outerFn.prototype is a Generator, then outerFn.prototype instanceof Generator.
	    var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator;
	    var generator = Object.create(protoGenerator.prototype);
	    var context = new Context(tryLocsList || []);
	
	    // The ._invoke method unifies the implementations of the .next,
	    // .throw, and .return methods.
	    generator._invoke = makeInvokeMethod(innerFn, self, context);
	
	    return generator;
	  }
	  runtime.wrap = wrap;
	
	  // Try/catch helper to minimize deoptimizations. Returns a completion
	  // record like context.tryEntries[i].completion. This interface could
	  // have been (and was previously) designed to take a closure to be
	  // invoked without arguments, but in all the cases we care about we
	  // already have an existing method we want to call, so there's no need
	  // to create a new function object. We can even get away with assuming
	  // the method takes exactly one argument, since that happens to be true
	  // in every case, so we don't have to touch the arguments object. The
	  // only additional allocation required is the completion record, which
	  // has a stable shape and so hopefully should be cheap to allocate.
	  function tryCatch(fn, obj, arg) {
	    try {
	      return { type: "normal", arg: fn.call(obj, arg) };
	    } catch (err) {
	      return { type: "throw", arg: err };
	    }
	  }
	
	  var GenStateSuspendedStart = "suspendedStart";
	  var GenStateSuspendedYield = "suspendedYield";
	  var GenStateExecuting = "executing";
	  var GenStateCompleted = "completed";
	
	  // Returning this object from the innerFn has the same effect as
	  // breaking out of the dispatch switch statement.
	  var ContinueSentinel = {};
	
	  // Dummy constructor functions that we use as the .constructor and
	  // .constructor.prototype properties for functions that return Generator
	  // objects. For full spec compliance, you may wish to configure your
	  // minifier not to mangle the names of these two functions.
	  function Generator() {}
	  function GeneratorFunction() {}
	  function GeneratorFunctionPrototype() {}
	
	  // This is a polyfill for %IteratorPrototype% for environments that
	  // don't natively support it.
	  var IteratorPrototype = {};
	  IteratorPrototype[iteratorSymbol] = function () {
	    return this;
	  };
	
	  var getProto = Object.getPrototypeOf;
	  var NativeIteratorPrototype = getProto && getProto(getProto(values([])));
	  if (NativeIteratorPrototype &&
	      NativeIteratorPrototype !== Op &&
	      hasOwn.call(NativeIteratorPrototype, iteratorSymbol)) {
	    // This environment has a native %IteratorPrototype%; use it instead
	    // of the polyfill.
	    IteratorPrototype = NativeIteratorPrototype;
	  }
	
	  var Gp = GeneratorFunctionPrototype.prototype =
	    Generator.prototype = Object.create(IteratorPrototype);
	  GeneratorFunction.prototype = Gp.constructor = GeneratorFunctionPrototype;
	  GeneratorFunctionPrototype.constructor = GeneratorFunction;
	  GeneratorFunctionPrototype[toStringTagSymbol] =
	    GeneratorFunction.displayName = "GeneratorFunction";
	
	  // Helper for defining the .next, .throw, and .return methods of the
	  // Iterator interface in terms of a single ._invoke method.
	  function defineIteratorMethods(prototype) {
	    ["next", "throw", "return"].forEach(function(method) {
	      prototype[method] = function(arg) {
	        return this._invoke(method, arg);
	      };
	    });
	  }
	
	  runtime.isGeneratorFunction = function(genFun) {
	    var ctor = typeof genFun === "function" && genFun.constructor;
	    return ctor
	      ? ctor === GeneratorFunction ||
	        // For the native GeneratorFunction constructor, the best we can
	        // do is to check its .name property.
	        (ctor.displayName || ctor.name) === "GeneratorFunction"
	      : false;
	  };
	
	  runtime.mark = function(genFun) {
	    if (Object.setPrototypeOf) {
	      Object.setPrototypeOf(genFun, GeneratorFunctionPrototype);
	    } else {
	      genFun.__proto__ = GeneratorFunctionPrototype;
	      if (!(toStringTagSymbol in genFun)) {
	        genFun[toStringTagSymbol] = "GeneratorFunction";
	      }
	    }
	    genFun.prototype = Object.create(Gp);
	    return genFun;
	  };
	
	  // Within the body of any async function, `await x` is transformed to
	  // `yield regeneratorRuntime.awrap(x)`, so that the runtime can test
	  // `hasOwn.call(value, "__await")` to determine if the yielded value is
	  // meant to be awaited.
	  runtime.awrap = function(arg) {
	    return { __await: arg };
	  };
	
	  function AsyncIterator(generator) {
	    function invoke(method, arg, resolve, reject) {
	      var record = tryCatch(generator[method], generator, arg);
	      if (record.type === "throw") {
	        reject(record.arg);
	      } else {
	        var result = record.arg;
	        var value = result.value;
	        if (value &&
	            typeof value === "object" &&
	            hasOwn.call(value, "__await")) {
	          return Promise.resolve(value.__await).then(function(value) {
	            invoke("next", value, resolve, reject);
	          }, function(err) {
	            invoke("throw", err, resolve, reject);
	          });
	        }
	
	        return Promise.resolve(value).then(function(unwrapped) {
	          // When a yielded Promise is resolved, its final value becomes
	          // the .value of the Promise<{value,done}> result for the
	          // current iteration. If the Promise is rejected, however, the
	          // result for this iteration will be rejected with the same
	          // reason. Note that rejections of yielded Promises are not
	          // thrown back into the generator function, as is the case
	          // when an awaited Promise is rejected. This difference in
	          // behavior between yield and await is important, because it
	          // allows the consumer to decide what to do with the yielded
	          // rejection (swallow it and continue, manually .throw it back
	          // into the generator, abandon iteration, whatever). With
	          // await, by contrast, there is no opportunity to examine the
	          // rejection reason outside the generator function, so the
	          // only option is to throw it from the await expression, and
	          // let the generator function handle the exception.
	          result.value = unwrapped;
	          resolve(result);
	        }, reject);
	      }
	    }
	
	    if (typeof global.process === "object" && global.process.domain) {
	      invoke = global.process.domain.bind(invoke);
	    }
	
	    var previousPromise;
	
	    function enqueue(method, arg) {
	      function callInvokeWithMethodAndArg() {
	        return new Promise(function(resolve, reject) {
	          invoke(method, arg, resolve, reject);
	        });
	      }
	
	      return previousPromise =
	        // If enqueue has been called before, then we want to wait until
	        // all previous Promises have been resolved before calling invoke,
	        // so that results are always delivered in the correct order. If
	        // enqueue has not been called before, then it is important to
	        // call invoke immediately, without waiting on a callback to fire,
	        // so that the async generator function has the opportunity to do
	        // any necessary setup in a predictable way. This predictability
	        // is why the Promise constructor synchronously invokes its
	        // executor callback, and why async functions synchronously
	        // execute code before the first await. Since we implement simple
	        // async functions in terms of async generators, it is especially
	        // important to get this right, even though it requires care.
	        previousPromise ? previousPromise.then(
	          callInvokeWithMethodAndArg,
	          // Avoid propagating failures to Promises returned by later
	          // invocations of the iterator.
	          callInvokeWithMethodAndArg
	        ) : callInvokeWithMethodAndArg();
	    }
	
	    // Define the unified helper method that is used to implement .next,
	    // .throw, and .return (see defineIteratorMethods).
	    this._invoke = enqueue;
	  }
	
	  defineIteratorMethods(AsyncIterator.prototype);
	  AsyncIterator.prototype[asyncIteratorSymbol] = function () {
	    return this;
	  };
	  runtime.AsyncIterator = AsyncIterator;
	
	  // Note that simple async functions are implemented on top of
	  // AsyncIterator objects; they just return a Promise for the value of
	  // the final result produced by the iterator.
	  runtime.async = function(innerFn, outerFn, self, tryLocsList) {
	    var iter = new AsyncIterator(
	      wrap(innerFn, outerFn, self, tryLocsList)
	    );
	
	    return runtime.isGeneratorFunction(outerFn)
	      ? iter // If outerFn is a generator, return the full iterator.
	      : iter.next().then(function(result) {
	          return result.done ? result.value : iter.next();
	        });
	  };
	
	  function makeInvokeMethod(innerFn, self, context) {
	    var state = GenStateSuspendedStart;
	
	    return function invoke(method, arg) {
	      if (state === GenStateExecuting) {
	        throw new Error("Generator is already running");
	      }
	
	      if (state === GenStateCompleted) {
	        if (method === "throw") {
	          throw arg;
	        }
	
	        // Be forgiving, per 25.3.3.3.3 of the spec:
	        // https://people.mozilla.org/~jorendorff/es6-draft.html#sec-generatorresume
	        return doneResult();
	      }
	
	      context.method = method;
	      context.arg = arg;
	
	      while (true) {
	        var delegate = context.delegate;
	        if (delegate) {
	          var delegateResult = maybeInvokeDelegate(delegate, context);
	          if (delegateResult) {
	            if (delegateResult === ContinueSentinel) continue;
	            return delegateResult;
	          }
	        }
	
	        if (context.method === "next") {
	          // Setting context._sent for legacy support of Babel's
	          // function.sent implementation.
	          context.sent = context._sent = context.arg;
	
	        } else if (context.method === "throw") {
	          if (state === GenStateSuspendedStart) {
	            state = GenStateCompleted;
	            throw context.arg;
	          }
	
	          context.dispatchException(context.arg);
	
	        } else if (context.method === "return") {
	          context.abrupt("return", context.arg);
	        }
	
	        state = GenStateExecuting;
	
	        var record = tryCatch(innerFn, self, context);
	        if (record.type === "normal") {
	          // If an exception is thrown from innerFn, we leave state ===
	          // GenStateExecuting and loop back for another invocation.
	          state = context.done
	            ? GenStateCompleted
	            : GenStateSuspendedYield;
	
	          if (record.arg === ContinueSentinel) {
	            continue;
	          }
	
	          return {
	            value: record.arg,
	            done: context.done
	          };
	
	        } else if (record.type === "throw") {
	          state = GenStateCompleted;
	          // Dispatch the exception by looping back around to the
	          // context.dispatchException(context.arg) call above.
	          context.method = "throw";
	          context.arg = record.arg;
	        }
	      }
	    };
	  }
	
	  // Call delegate.iterator[context.method](context.arg) and handle the
	  // result, either by returning a { value, done } result from the
	  // delegate iterator, or by modifying context.method and context.arg,
	  // setting context.delegate to null, and returning the ContinueSentinel.
	  function maybeInvokeDelegate(delegate, context) {
	    var method = delegate.iterator[context.method];
	    if (method === undefined) {
	      // A .throw or .return when the delegate iterator has no .throw
	      // method always terminates the yield* loop.
	      context.delegate = null;
	
	      if (context.method === "throw") {
	        if (delegate.iterator.return) {
	          // If the delegate iterator has a return method, give it a
	          // chance to clean up.
	          context.method = "return";
	          context.arg = undefined;
	          maybeInvokeDelegate(delegate, context);
	
	          if (context.method === "throw") {
	            // If maybeInvokeDelegate(context) changed context.method from
	            // "return" to "throw", let that override the TypeError below.
	            return ContinueSentinel;
	          }
	        }
	
	        context.method = "throw";
	        context.arg = new TypeError(
	          "The iterator does not provide a 'throw' method");
	      }
	
	      return ContinueSentinel;
	    }
	
	    var record = tryCatch(method, delegate.iterator, context.arg);
	
	    if (record.type === "throw") {
	      context.method = "throw";
	      context.arg = record.arg;
	      context.delegate = null;
	      return ContinueSentinel;
	    }
	
	    var info = record.arg;
	
	    if (! info) {
	      context.method = "throw";
	      context.arg = new TypeError("iterator result is not an object");
	      context.delegate = null;
	      return ContinueSentinel;
	    }
	
	    if (info.done) {
	      // Assign the result of the finished delegate to the temporary
	      // variable specified by delegate.resultName (see delegateYield).
	      context[delegate.resultName] = info.value;
	
	      // Resume execution at the desired location (see delegateYield).
	      context.next = delegate.nextLoc;
	
	      // If context.method was "throw" but the delegate handled the
	      // exception, let the outer generator proceed normally. If
	      // context.method was "next", forget context.arg since it has been
	      // "consumed" by the delegate iterator. If context.method was
	      // "return", allow the original .return call to continue in the
	      // outer generator.
	      if (context.method !== "return") {
	        context.method = "next";
	        context.arg = undefined;
	      }
	
	    } else {
	      // Re-yield the result returned by the delegate method.
	      return info;
	    }
	
	    // The delegate iterator is finished, so forget it and continue with
	    // the outer generator.
	    context.delegate = null;
	    return ContinueSentinel;
	  }
	
	  // Define Generator.prototype.{next,throw,return} in terms of the
	  // unified ._invoke helper method.
	  defineIteratorMethods(Gp);
	
	  Gp[toStringTagSymbol] = "Generator";
	
	  // A Generator should always return itself as the iterator object when the
	  // @@iterator function is called on it. Some browsers' implementations of the
	  // iterator prototype chain incorrectly implement this, causing the Generator
	  // object to not be returned from this call. This ensures that doesn't happen.
	  // See https://github.com/facebook/regenerator/issues/274 for more details.
	  Gp[iteratorSymbol] = function() {
	    return this;
	  };
	
	  Gp.toString = function() {
	    return "[object Generator]";
	  };
	
	  function pushTryEntry(locs) {
	    var entry = { tryLoc: locs[0] };
	
	    if (1 in locs) {
	      entry.catchLoc = locs[1];
	    }
	
	    if (2 in locs) {
	      entry.finallyLoc = locs[2];
	      entry.afterLoc = locs[3];
	    }
	
	    this.tryEntries.push(entry);
	  }
	
	  function resetTryEntry(entry) {
	    var record = entry.completion || {};
	    record.type = "normal";
	    delete record.arg;
	    entry.completion = record;
	  }
	
	  function Context(tryLocsList) {
	    // The root entry object (effectively a try statement without a catch
	    // or a finally block) gives us a place to store values thrown from
	    // locations where there is no enclosing try statement.
	    this.tryEntries = [{ tryLoc: "root" }];
	    tryLocsList.forEach(pushTryEntry, this);
	    this.reset(true);
	  }
	
	  runtime.keys = function(object) {
	    var keys = [];
	    for (var key in object) {
	      keys.push(key);
	    }
	    keys.reverse();
	
	    // Rather than returning an object with a next method, we keep
	    // things simple and return the next function itself.
	    return function next() {
	      while (keys.length) {
	        var key = keys.pop();
	        if (key in object) {
	          next.value = key;
	          next.done = false;
	          return next;
	        }
	      }
	
	      // To avoid creating an additional object, we just hang the .value
	      // and .done properties off the next function object itself. This
	      // also ensures that the minifier will not anonymize the function.
	      next.done = true;
	      return next;
	    };
	  };
	
	  function values(iterable) {
	    if (iterable) {
	      var iteratorMethod = iterable[iteratorSymbol];
	      if (iteratorMethod) {
	        return iteratorMethod.call(iterable);
	      }
	
	      if (typeof iterable.next === "function") {
	        return iterable;
	      }
	
	      if (!isNaN(iterable.length)) {
	        var i = -1, next = function next() {
	          while (++i < iterable.length) {
	            if (hasOwn.call(iterable, i)) {
	              next.value = iterable[i];
	              next.done = false;
	              return next;
	            }
	          }
	
	          next.value = undefined;
	          next.done = true;
	
	          return next;
	        };
	
	        return next.next = next;
	      }
	    }
	
	    // Return an iterator with no values.
	    return { next: doneResult };
	  }
	  runtime.values = values;
	
	  function doneResult() {
	    return { value: undefined, done: true };
	  }
	
	  Context.prototype = {
	    constructor: Context,
	
	    reset: function(skipTempReset) {
	      this.prev = 0;
	      this.next = 0;
	      // Resetting context._sent for legacy support of Babel's
	      // function.sent implementation.
	      this.sent = this._sent = undefined;
	      this.done = false;
	      this.delegate = null;
	
	      this.method = "next";
	      this.arg = undefined;
	
	      this.tryEntries.forEach(resetTryEntry);
	
	      if (!skipTempReset) {
	        for (var name in this) {
	          // Not sure about the optimal order of these conditions:
	          if (name.charAt(0) === "t" &&
	              hasOwn.call(this, name) &&
	              !isNaN(+name.slice(1))) {
	            this[name] = undefined;
	          }
	        }
	      }
	    },
	
	    stop: function() {
	      this.done = true;
	
	      var rootEntry = this.tryEntries[0];
	      var rootRecord = rootEntry.completion;
	      if (rootRecord.type === "throw") {
	        throw rootRecord.arg;
	      }
	
	      return this.rval;
	    },
	
	    dispatchException: function(exception) {
	      if (this.done) {
	        throw exception;
	      }
	
	      var context = this;
	      function handle(loc, caught) {
	        record.type = "throw";
	        record.arg = exception;
	        context.next = loc;
	
	        if (caught) {
	          // If the dispatched exception was caught by a catch block,
	          // then let that catch block handle the exception normally.
	          context.method = "next";
	          context.arg = undefined;
	        }
	
	        return !! caught;
	      }
	
	      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
	        var entry = this.tryEntries[i];
	        var record = entry.completion;
	
	        if (entry.tryLoc === "root") {
	          // Exception thrown outside of any try block that could handle
	          // it, so set the completion value of the entire function to
	          // throw the exception.
	          return handle("end");
	        }
	
	        if (entry.tryLoc <= this.prev) {
	          var hasCatch = hasOwn.call(entry, "catchLoc");
	          var hasFinally = hasOwn.call(entry, "finallyLoc");
	
	          if (hasCatch && hasFinally) {
	            if (this.prev < entry.catchLoc) {
	              return handle(entry.catchLoc, true);
	            } else if (this.prev < entry.finallyLoc) {
	              return handle(entry.finallyLoc);
	            }
	
	          } else if (hasCatch) {
	            if (this.prev < entry.catchLoc) {
	              return handle(entry.catchLoc, true);
	            }
	
	          } else if (hasFinally) {
	            if (this.prev < entry.finallyLoc) {
	              return handle(entry.finallyLoc);
	            }
	
	          } else {
	            throw new Error("try statement without catch or finally");
	          }
	        }
	      }
	    },
	
	    abrupt: function(type, arg) {
	      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
	        var entry = this.tryEntries[i];
	        if (entry.tryLoc <= this.prev &&
	            hasOwn.call(entry, "finallyLoc") &&
	            this.prev < entry.finallyLoc) {
	          var finallyEntry = entry;
	          break;
	        }
	      }
	
	      if (finallyEntry &&
	          (type === "break" ||
	           type === "continue") &&
	          finallyEntry.tryLoc <= arg &&
	          arg <= finallyEntry.finallyLoc) {
	        // Ignore the finally entry if control is not jumping to a
	        // location outside the try/catch block.
	        finallyEntry = null;
	      }
	
	      var record = finallyEntry ? finallyEntry.completion : {};
	      record.type = type;
	      record.arg = arg;
	
	      if (finallyEntry) {
	        this.method = "next";
	        this.next = finallyEntry.finallyLoc;
	        return ContinueSentinel;
	      }
	
	      return this.complete(record);
	    },
	
	    complete: function(record, afterLoc) {
	      if (record.type === "throw") {
	        throw record.arg;
	      }
	
	      if (record.type === "break" ||
	          record.type === "continue") {
	        this.next = record.arg;
	      } else if (record.type === "return") {
	        this.rval = this.arg = record.arg;
	        this.method = "return";
	        this.next = "end";
	      } else if (record.type === "normal" && afterLoc) {
	        this.next = afterLoc;
	      }
	
	      return ContinueSentinel;
	    },
	
	    finish: function(finallyLoc) {
	      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
	        var entry = this.tryEntries[i];
	        if (entry.finallyLoc === finallyLoc) {
	          this.complete(entry.completion, entry.afterLoc);
	          resetTryEntry(entry);
	          return ContinueSentinel;
	        }
	      }
	    },
	
	    "catch": function(tryLoc) {
	      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
	        var entry = this.tryEntries[i];
	        if (entry.tryLoc === tryLoc) {
	          var record = entry.completion;
	          if (record.type === "throw") {
	            var thrown = record.arg;
	            resetTryEntry(entry);
	          }
	          return thrown;
	        }
	      }
	
	      // The context.catch method must only be called with a location
	      // argument that corresponds to a known catch block.
	      throw new Error("illegal catch attempt");
	    },
	
	    delegateYield: function(iterable, resultName, nextLoc) {
	      this.delegate = {
	        iterator: values(iterable),
	        resultName: resultName,
	        nextLoc: nextLoc
	      };
	
	      if (this.method === "next") {
	        // Deliberately forget the last sent value so that we don't
	        // accidentally pass it on to the delegate.
	        this.arg = undefined;
	      }
	
	      return ContinueSentinel;
	    }
	  };
	})(
	  // Among the various tricks for obtaining a reference to the global
	  // object, this seems to be the most reliable technique that does not
	  // use indirect eval (which violates Content Security Policy).
	  typeof global === "object" ? global :
	  typeof window === "object" ? window :
	  typeof self === "object" ? self : this
	);
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 1082 */
/***/ function(module, exports) {

	module.exports = SafeParseTuple
	
	function SafeParseTuple(obj, reviver) {
	    var json
	    var error = null
	
	    try {
	        json = JSON.parse(obj, reviver)
	    } catch (err) {
	        error = err
	    }
	
	    return [error, json]
	}


/***/ },
/* 1083 */
/***/ function(module, exports) {

	'use strict';
	module.exports = function (str) {
		return encodeURIComponent(str).replace(/[!'()*]/g, function (c) {
			return '%' + c.charCodeAt(0).toString(16).toUpperCase();
		});
	};


/***/ },
/* 1084 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(814);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// Prepare cssTransformation
	var transform;
	
	var options = {}
	options.transform = transform
	// add the styles to the DOM
	var update = __webpack_require__(132)(content, options);
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../css-loader/index.js!./bootstrap.min.css", function() {
				var newContent = require("!!../../../css-loader/index.js!./bootstrap.min.css");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 1085 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(815);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// Prepare cssTransformation
	var transform;
	
	var options = {}
	options.transform = transform
	// add the styles to the DOM
	var update = __webpack_require__(132)(content, options);
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../css-loader/index.js!./quill.bubble.css", function() {
				var newContent = require("!!../../css-loader/index.js!./quill.bubble.css");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 1086 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(816);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// Prepare cssTransformation
	var transform;
	
	var options = {}
	options.transform = transform
	// add the styles to the DOM
	var update = __webpack_require__(132)(content, options);
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../css-loader/index.js!./quill.core.css", function() {
				var newContent = require("!!../../css-loader/index.js!./quill.core.css");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 1087 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(817);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// Prepare cssTransformation
	var transform;
	
	var options = {}
	options.transform = transform
	// add the styles to the DOM
	var update = __webpack_require__(132)(content, options);
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../css-loader/index.js!./quill.snow.css", function() {
				var newContent = require("!!../../css-loader/index.js!./quill.snow.css");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 1088 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(818);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// Prepare cssTransformation
	var transform;
	
	var options = {}
	options.transform = transform
	// add the styles to the DOM
	var update = __webpack_require__(132)(content, options);
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../css-loader/index.js!./video-js.css", function() {
				var newContent = require("!!../../css-loader/index.js!./video-js.css");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 1089 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(819);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// Prepare cssTransformation
	var transform;
	
	var options = {}
	options.transform = transform
	// add the styles to the DOM
	var update = __webpack_require__(132)(content, options);
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../node_modules/css-loader/index.js!./styles.css", function() {
				var newContent = require("!!../../node_modules/css-loader/index.js!./styles.css");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 1090 */
/***/ function(module, exports) {

	
	/**
	 * When source maps are enabled, `style-loader` uses a link element with a data-uri to
	 * embed the css on the page. This breaks all relative urls because now they are relative to a
	 * bundle instead of the current page.
	 *
	 * One solution is to only use full urls, but that may be impossible.
	 *
	 * Instead, this function "fixes" the relative urls to be absolute according to the current page location.
	 *
	 * A rudimentary test suite is located at `test/fixUrls.js` and can be run via the `npm test` command.
	 *
	 */
	
	module.exports = function (css) {
	  // get current location
	  var location = typeof window !== "undefined" && window.location;
	
	  if (!location) {
	    throw new Error("fixUrls requires window.location");
	  }
	
		// blank or null?
		if (!css || typeof css !== "string") {
		  return css;
	  }
	
	  var baseUrl = location.protocol + "//" + location.host;
	  var currentDir = baseUrl + location.pathname.replace(/\/[^\/]*$/, "/");
	
		// convert each url(...)
		/*
		This regular expression is just a way to recursively match brackets within
		a string.
	
		 /url\s*\(  = Match on the word "url" with any whitespace after it and then a parens
		   (  = Start a capturing group
		     (?:  = Start a non-capturing group
		         [^)(]  = Match anything that isn't a parentheses
		         |  = OR
		         \(  = Match a start parentheses
		             (?:  = Start another non-capturing groups
		                 [^)(]+  = Match anything that isn't a parentheses
		                 |  = OR
		                 \(  = Match a start parentheses
		                     [^)(]*  = Match anything that isn't a parentheses
		                 \)  = Match a end parentheses
		             )  = End Group
	              *\) = Match anything and then a close parens
	          )  = Close non-capturing group
	          *  = Match anything
	       )  = Close capturing group
		 \)  = Match a close parens
	
		 /gi  = Get all matches, not the first.  Be case insensitive.
		 */
		var fixedCss = css.replace(/url\s*\(((?:[^)(]|\((?:[^)(]+|\([^)(]*\))*\))*)\)/gi, function(fullMatch, origUrl) {
			// strip quotes (if they exist)
			var unquotedOrigUrl = origUrl
				.trim()
				.replace(/^"(.*)"$/, function(o, $1){ return $1; })
				.replace(/^'(.*)'$/, function(o, $1){ return $1; });
	
			// already a full url? no change
			if (/^(#|data:|http:\/\/|https:\/\/|file:\/\/\/)/i.test(unquotedOrigUrl)) {
			  return fullMatch;
			}
	
			// convert the url to a full url
			var newUrl;
	
			if (unquotedOrigUrl.indexOf("//") === 0) {
			  	//TODO: should we add protocol?
				newUrl = unquotedOrigUrl;
			} else if (unquotedOrigUrl.indexOf("/") === 0) {
				// path should be relative to the base url
				newUrl = baseUrl + unquotedOrigUrl; // already starts with '/'
			} else {
				// path should be relative to current directory
				newUrl = currentDir + unquotedOrigUrl.replace(/^\.\//, ""); // Strip leading './'
			}
	
			// send back the fixed url(...)
			return "url(" + JSON.stringify(newUrl) + ")";
		});
	
		// send back the fixed css
		return fixedCss;
	};


/***/ },
/* 1091 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.convertReactSVGDOMProperty = convertReactSVGDOMProperty;
	exports.startsWith = startsWith;
	exports.serializeAttrs = serializeAttrs;
	exports.getSVGFromSource = getSVGFromSource;
	exports.extractSVGProps = extractSVGProps;
	// Transform DOM prop/attr names applicable to `<svg>` element but react-limited
	
	function convertReactSVGDOMProperty(str) {
	    return str.replace(/[-|:]([a-z])/g, function (g) {
	        return g[1].toUpperCase();
	    });
	}
	
	function startsWith(str, substring) {
	    return str.indexOf(substring) === 0;
	}
	
	var DataPropPrefix = 'data-';
	// Serialize `Attr` objects in `NamedNodeMap`
	function serializeAttrs(map) {
	    var ret = {};
	    for (var prop, i = 0; i < map.length; i++) {
	        var key = map[i].name;
	        if (key == "class") {
	            prop = "className";
	        } else if (!startsWith(key, DataPropPrefix)) {
	            prop = convertReactSVGDOMProperty(key);
	        } else {
	            prop = key;
	        }
	
	        ret[prop] = map[i].value;
	    }
	    return ret;
	}
	
	function getSVGFromSource(src) {
	    var svgContainer = document.createElement('div');
	    svgContainer.innerHTML = src;
	    var svg = svgContainer.firstElementChild;
	    svg.remove ? svg.remove() : svgContainer.removeChild(svg); // deref from parent element
	    return svg;
	}
	
	// get <svg /> element props
	function extractSVGProps(src) {
	    var map = getSVGFromSource(src).attributes;
	    return map.length > 0 ? serializeAttrs(map) : null;
	}

/***/ },
/* 1092 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global, module) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _ponyfill = __webpack_require__(1093);
	
	var _ponyfill2 = _interopRequireDefault(_ponyfill);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var root; /* global window */
	
	
	if (typeof self !== 'undefined') {
	  root = self;
	} else if (typeof window !== 'undefined') {
	  root = window;
	} else if (typeof global !== 'undefined') {
	  root = global;
	} else if (true) {
	  root = module;
	} else {
	  root = Function('return this')();
	}
	
	var result = (0, _ponyfill2['default'])(root);
	exports['default'] = result;
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }()), __webpack_require__(192)(module)))

/***/ },
/* 1093 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports['default'] = symbolObservablePonyfill;
	function symbolObservablePonyfill(root) {
		var result;
		var _Symbol = root.Symbol;
	
		if (typeof _Symbol === 'function') {
			if (_Symbol.observable) {
				result = _Symbol.observable;
			} else {
				result = _Symbol('observable');
				_Symbol.observable = result;
			}
		} else {
			result = '@@observable';
		}
	
		return result;
	};

/***/ },
/* 1094 */
377,
/* 1095 */
/***/ function(module, exports) {

	
	exports = module.exports = trim;
	
	function trim(str){
	  return str.replace(/^\s*|\s*$/g, '');
	}
	
	exports.left = function(str){
	  return str.replace(/^\s*/, '');
	};
	
	exports.right = function(str){
	  return str.replace(/\s*$/, '');
	};


/***/ },
/* 1096 */
/***/ function(module, exports) {

	function clean (s) {
	  return s.replace(/\n\r?\s*/g, '')
	}
	
	
	module.exports = function tsml (sa) {
	  var s = ''
	    , i = 0
	
	  for (; i < arguments.length; i++)
	    s += clean(sa[i]) + (arguments[i + 1] || '')
	
	  return s
	}

/***/ },
/* 1097 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "assets/fonts/glyphicons-halflings-regular.ttf";

/***/ },
/* 1098 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "assets/fonts/Guroo-Producer.ttf";

/***/ },
/* 1099 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "assets/src/gurooLoading.gif";

/***/ },
/* 1100 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "assets/src/guroo_producer_logo.png";

/***/ },
/* 1101 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "assets/fonts/glyphicons-halflings-regular.svg";

/***/ },
/* 1102 */
/***/ function(module, exports) {

	module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz4KPHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB2aWV3Qm94PSIwIDAgNTAgNTAiIHZlcnNpb249IjEuMSIgd2lkdGg9IjUxMnB4IiBoZWlnaHQ9IjUxMnB4Ij4KPGcgaWQ9InN1cmZhY2UxIj4KPHBhdGggc3R5bGU9IiAiIGQ9Ik0gMzYgNDUgTCAxNyA0NSBDIDEyLjAzOTA2MyA0NSA4IDQwLjk2NDg0NCA4IDM2IEwgOCAyNi42MDE1NjMgQyA4IDI0LjY2MDE1NiA4LjU2NjQwNiAyMi44ODY3MTkgOS42ODc1IDIxLjMyMDMxMyBMIDIwLjg5MDYyNSA1LjkxMDE1NiBDIDIxLjU4OTg0NCA0Ljc0MjE4OCAyMi43Njk1MzEgNCAyNCA0IEMgMjUuNjYwMTU2IDQgMjggNS40MjU3ODEgMjggOC42MDE1NjMgQyAyOCA5LjUwNzgxMyAyNy43NTM5MDYgMTAuMTE3MTg4IDI3LjUxMTcxOSAxMC43MDcwMzEgQyAyNy40NTMxMjUgMTAuODQ3NjU2IDI3LjM5NDUzMSAxMC45OTIxODggMjcuMzM1OTM4IDExLjE0ODQzOCBDIDI2Ljk2MDkzOCAxMi4xOTkyMTkgMjQuOTgwNDY5IDE2LjY3NTc4MSAyMy45NDE0MDYgMTkgQyAyNy4wMTk1MzEgMTkuMDAzOTA2IDMzLjgzOTg0NCAxOS4wMjM0MzggMzYuNDI5Njg4IDE5LjEwMTU2MyBDIDM5LjI4MTI1IDE5LjEwMTU2MyA0MSAyMS4wMzEyNSA0MSAyMi44OTg0MzggQyA0MSAyMy41MzkwNjMgNDAuODk0NTMxIDI0LjQxNDA2MyA0MC44MDQ2ODggMjUuMDMxMjUgQyA0MS42ODM1OTQgMjUuNTU0Njg4IDQzIDI2LjY3OTY4OCA0MyAyOC42OTkyMTkgQyA0MyAzMC4xMDU0NjkgNDIuMzI0MjE5IDMxLjE0NDUzMSA0MS42NzU3ODEgMzEuODI0MjE5IEMgNDIuMzM1OTM4IDMyLjQzMzU5NCA0MyAzMy4zOTA2MjUgNDMgMzQuODAwNzgxIEMgNDMgMzYuODA4NTk0IDQxLjYxNzE4OCAzOC4wMjM0MzggNDAuNjI4OTA2IDM4LjY0MDYyNSBDIDQwLjgyNDIxOSAzOS4xNjQwNjMgNDEgMzkuODY3MTg4IDQxIDQwLjY5OTIxOSBDIDQxIDQyLjQ5NjA5NCAzOS4wOTc2NTYgNDUgMzYgNDUgWiAiLz4KPC9nPgo8L3N2Zz4K"

/***/ },
/* 1103 */
/***/ function(module, exports) {

	module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCA1MTIgNTEyIj48cGF0aCBkPSJNMjU2IDQ4QzE0MS4zIDQ4IDQ4IDE0MS4zIDQ4IDI1NnM5My4zIDIwOCAyMDggMjA4IDIwOC05My4zIDIwOC0yMDhTMzcwLjcgNDggMjU2IDQ4ek0yNTYgODBjOTcuNCAwIDE3NiA3OC42IDE3NiAxNzZzLTc4LjYgMTc2LTE3NiAxNzZTODAgMzUzLjQgODAgMjU2IDE1OC42IDgwIDI1NiA4MHpNMTYwIDI0MHYzMmgxOTJ2LTMySDE2MHoiLz48L3N2Zz4="

/***/ },
/* 1104 */
/***/ function(module, exports) {

	module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz4KPCEtLSBHZW5lcmF0b3I6IEFkb2JlIElsbHVzdHJhdG9yIDIyLjEuMCwgU1ZHIEV4cG9ydCBQbHVnLUluIC4gU1ZHIFZlcnNpb246IDYuMDAgQnVpbGQgMCkgIC0tPgo8c3ZnIHZlcnNpb249IjEuMSIgaWQ9IkxheWVyXzEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiIHg9IjBweCIgeT0iMHB4IgoJIHZpZXdCb3g9IjAgMCA1MTIgNTEyIiBzdHlsZT0iZW5hYmxlLWJhY2tncm91bmQ6bmV3IDAgMCA1MTIgNTEyOyIgeG1sOnNwYWNlPSJwcmVzZXJ2ZSI+CjxnIGlkPSJzdXJmYWNlMSI+Cgk8cGF0aCBkPSJNMjM1LjUsNDIzLjljMC04LjUsMi4xLTEzLjgsNC4zLTE5LjRjMC43LTEuOSwxLjUtMy45LDIuNC02LjZjMy45LTEwLjgsMjQuMi01Ni43LDM0LjgtODAuNWMtMzEuNSwwLTEwMS4zLTAuMi0xMjcuNi0xCgkJYy0yOS41LDAtNDcuMS0xOS44LTQ3LjEtMzguOWMwLTYuNiwxLjEtMTUuNSwyLTIxLjhjLTktNS40LTIyLjUtMTYuOC0yMi41LTM3LjZjMC0xNC40LDYuOS0yNS4xLDEzLjYtMzIKCQljLTYuOC02LjItMTMuNi0xNi0xMy42LTMwLjVjMC0yMC41LDE0LjItMzMsMjQuMy0zOS4zYy0yLTUuNC0zLjgtMTIuNi0zLjgtMjEuMWMwLTE4LjQsMTkuNS00NCw1MS4yLTQ0aDE5NC42CgkJYzUwLjgsMCw5Mi4yLDQxLjQsOTIuMiw5Mi4ydjk2LjJjMCwxOS45LTUuOCwzOC0xNy4zLDU0LjJsLTExNC4yLDE1N2MtNy42LDEyLjctMTkuNywyMC4zLTMyLjMsMjAuMwoJCUMyNTkuNSw0NzEsMjM1LjUsNDU2LjQsMjM1LjUsNDIzLjl6Ii8+CjwvZz4KPC9zdmc+Cg=="

/***/ },
/* 1105 */
/***/ function(module, exports) {

	module.exports = "data:image/svg+xml;base64,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"

/***/ },
/* 1106 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "assets/fonts/glyphicons-halflings-regular.woff";

/***/ },
/* 1107 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "assets/fonts/glyphicons-halflings-regular.woff2";

/***/ },
/* 1108 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "assets/fonts/FWDCircularVietWeb-Black.woff";

/***/ },
/* 1109 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "assets/fonts/FWDCircularVietWeb-BlackItalic.woff";

/***/ },
/* 1110 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "assets/fonts/FWDCircularVietWeb-Bold.woff";

/***/ },
/* 1111 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "assets/fonts/FWDCircularVietWeb-BoldItalic.woff";

/***/ },
/* 1112 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "assets/fonts/FWDCircularVietWeb-Book.woff";

/***/ },
/* 1113 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "assets/fonts/FWDCircularVietWeb-BookItalic.woff";

/***/ },
/* 1114 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "assets/fonts/FWDCircularVietWeb-Medium.woff";

/***/ },
/* 1115 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "assets/fonts/FWDCircularVietWeb-MediumItalic.woff";

/***/ },
/* 1116 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "assets/fonts/FWDCircularWeb-Black.woff";

/***/ },
/* 1117 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "assets/fonts/FWDCircularWeb-BlackItalic.woff";

/***/ },
/* 1118 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "assets/fonts/FWDCircularWeb-Bold.woff";

/***/ },
/* 1119 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "assets/fonts/FWDCircularWeb-BoldItalic.woff";

/***/ },
/* 1120 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "assets/fonts/FWDCircularWeb-Book.woff";

/***/ },
/* 1121 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "assets/fonts/FWDCircularWeb-BookItalic.woff";

/***/ },
/* 1122 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "assets/fonts/FWDCircularWeb-Medium.woff";

/***/ },
/* 1123 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "assets/fonts/FWDCircularWeb-MediumItalic.woff";

/***/ },
/* 1124 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "assets/fonts/Guroo-Producer.woff";

/***/ },
/* 1125 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "assets/fonts/Guroo-Producer.woff2";

/***/ },
/* 1126 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013 vtt.js Contributors
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	
	// Default exports for Node. Export the extended versions of VTTCue and
	// VTTRegion in Node since we likely want the capability to convert back and
	// forth between JSON. If we don't then it's not that big of a deal since we're
	// off browser.
	
	var window = __webpack_require__(170);
	
	var vttjs = module.exports = {
	  WebVTT: __webpack_require__(1127),
	  VTTCue: __webpack_require__(1128),
	  VTTRegion: __webpack_require__(1129)
	};
	
	window.vttjs = vttjs;
	window.WebVTT = vttjs.WebVTT;
	
	var cueShim = vttjs.VTTCue;
	var regionShim = vttjs.VTTRegion;
	var nativeVTTCue = window.VTTCue;
	var nativeVTTRegion = window.VTTRegion;
	
	vttjs.shim = function() {
	  window.VTTCue = cueShim;
	  window.VTTRegion = regionShim;
	};
	
	vttjs.restore = function() {
	  window.VTTCue = nativeVTTCue;
	  window.VTTRegion = nativeVTTRegion;
	};
	
	if (!window.VTTCue) {
	  vttjs.shim();
	}


/***/ },
/* 1127 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013 vtt.js Contributors
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	
	/* -*- Mode: Java; tab-width: 2; indent-tabs-mode: nil; c-basic-offset: 2 -*- */
	/* vim: set shiftwidth=2 tabstop=2 autoindent cindent expandtab: */
	var _objCreate = Object.create || (function() {
	  function F() {}
	  return function(o) {
	    if (arguments.length !== 1) {
	      throw new Error('Object.create shim only accepts one parameter.');
	    }
	    F.prototype = o;
	    return new F();
	  };
	})();
	
	// Creates a new ParserError object from an errorData object. The errorData
	// object should have default code and message properties. The default message
	// property can be overriden by passing in a message parameter.
	// See ParsingError.Errors below for acceptable errors.
	function ParsingError(errorData, message) {
	  this.name = "ParsingError";
	  this.code = errorData.code;
	  this.message = message || errorData.message;
	}
	ParsingError.prototype = _objCreate(Error.prototype);
	ParsingError.prototype.constructor = ParsingError;
	
	// ParsingError metadata for acceptable ParsingErrors.
	ParsingError.Errors = {
	  BadSignature: {
	    code: 0,
	    message: "Malformed WebVTT signature."
	  },
	  BadTimeStamp: {
	    code: 1,
	    message: "Malformed time stamp."
	  }
	};
	
	// Try to parse input as a time stamp.
	function parseTimeStamp(input) {
	
	  function computeSeconds(h, m, s, f) {
	    return (h | 0) * 3600 + (m | 0) * 60 + (s | 0) + (f | 0) / 1000;
	  }
	
	  var m = input.match(/^(\d+):(\d{2})(:\d{2})?\.(\d{3})/);
	  if (!m) {
	    return null;
	  }
	
	  if (m[3]) {
	    // Timestamp takes the form of [hours]:[minutes]:[seconds].[milliseconds]
	    return computeSeconds(m[1], m[2], m[3].replace(":", ""), m[4]);
	  } else if (m[1] > 59) {
	    // Timestamp takes the form of [hours]:[minutes].[milliseconds]
	    // First position is hours as it's over 59.
	    return computeSeconds(m[1], m[2], 0,  m[4]);
	  } else {
	    // Timestamp takes the form of [minutes]:[seconds].[milliseconds]
	    return computeSeconds(0, m[1], m[2], m[4]);
	  }
	}
	
	// A settings object holds key/value pairs and will ignore anything but the first
	// assignment to a specific key.
	function Settings() {
	  this.values = _objCreate(null);
	}
	
	Settings.prototype = {
	  // Only accept the first assignment to any key.
	  set: function(k, v) {
	    if (!this.get(k) && v !== "") {
	      this.values[k] = v;
	    }
	  },
	  // Return the value for a key, or a default value.
	  // If 'defaultKey' is passed then 'dflt' is assumed to be an object with
	  // a number of possible default values as properties where 'defaultKey' is
	  // the key of the property that will be chosen; otherwise it's assumed to be
	  // a single value.
	  get: function(k, dflt, defaultKey) {
	    if (defaultKey) {
	      return this.has(k) ? this.values[k] : dflt[defaultKey];
	    }
	    return this.has(k) ? this.values[k] : dflt;
	  },
	  // Check whether we have a value for a key.
	  has: function(k) {
	    return k in this.values;
	  },
	  // Accept a setting if its one of the given alternatives.
	  alt: function(k, v, a) {
	    for (var n = 0; n < a.length; ++n) {
	      if (v === a[n]) {
	        this.set(k, v);
	        break;
	      }
	    }
	  },
	  // Accept a setting if its a valid (signed) integer.
	  integer: function(k, v) {
	    if (/^-?\d+$/.test(v)) { // integer
	      this.set(k, parseInt(v, 10));
	    }
	  },
	  // Accept a setting if its a valid percentage.
	  percent: function(k, v) {
	    var m;
	    if ((m = v.match(/^([\d]{1,3})(\.[\d]*)?%$/))) {
	      v = parseFloat(v);
	      if (v >= 0 && v <= 100) {
	        this.set(k, v);
	        return true;
	      }
	    }
	    return false;
	  }
	};
	
	// Helper function to parse input into groups separated by 'groupDelim', and
	// interprete each group as a key/value pair separated by 'keyValueDelim'.
	function parseOptions(input, callback, keyValueDelim, groupDelim) {
	  var groups = groupDelim ? input.split(groupDelim) : [input];
	  for (var i in groups) {
	    if (typeof groups[i] !== "string") {
	      continue;
	    }
	    var kv = groups[i].split(keyValueDelim);
	    if (kv.length !== 2) {
	      continue;
	    }
	    var k = kv[0];
	    var v = kv[1];
	    callback(k, v);
	  }
	}
	
	function parseCue(input, cue, regionList) {
	  // Remember the original input if we need to throw an error.
	  var oInput = input;
	  // 4.1 WebVTT timestamp
	  function consumeTimeStamp() {
	    var ts = parseTimeStamp(input);
	    if (ts === null) {
	      throw new ParsingError(ParsingError.Errors.BadTimeStamp,
	                            "Malformed timestamp: " + oInput);
	    }
	    // Remove time stamp from input.
	    input = input.replace(/^[^\sa-zA-Z-]+/, "");
	    return ts;
	  }
	
	  // 4.4.2 WebVTT cue settings
	  function consumeCueSettings(input, cue) {
	    var settings = new Settings();
	
	    parseOptions(input, function (k, v) {
	      switch (k) {
	      case "region":
	        // Find the last region we parsed with the same region id.
	        for (var i = regionList.length - 1; i >= 0; i--) {
	          if (regionList[i].id === v) {
	            settings.set(k, regionList[i].region);
	            break;
	          }
	        }
	        break;
	      case "vertical":
	        settings.alt(k, v, ["rl", "lr"]);
	        break;
	      case "line":
	        var vals = v.split(","),
	            vals0 = vals[0];
	        settings.integer(k, vals0);
	        settings.percent(k, vals0) ? settings.set("snapToLines", false) : null;
	        settings.alt(k, vals0, ["auto"]);
	        if (vals.length === 2) {
	          settings.alt("lineAlign", vals[1], ["start", "middle", "end"]);
	        }
	        break;
	      case "position":
	        vals = v.split(",");
	        settings.percent(k, vals[0]);
	        if (vals.length === 2) {
	          settings.alt("positionAlign", vals[1], ["start", "middle", "end"]);
	        }
	        break;
	      case "size":
	        settings.percent(k, v);
	        break;
	      case "align":
	        settings.alt(k, v, ["start", "middle", "end", "left", "right"]);
	        break;
	      }
	    }, /:/, /\s/);
	
	    // Apply default values for any missing fields.
	    cue.region = settings.get("region", null);
	    cue.vertical = settings.get("vertical", "");
	    cue.line = settings.get("line", "auto");
	    cue.lineAlign = settings.get("lineAlign", "start");
	    cue.snapToLines = settings.get("snapToLines", true);
	    cue.size = settings.get("size", 100);
	    cue.align = settings.get("align", "middle");
	    cue.position = settings.get("position", {
	      start: 0,
	      left: 0,
	      middle: 50,
	      end: 100,
	      right: 100
	    }, cue.align);
	    cue.positionAlign = settings.get("positionAlign", {
	      start: "start",
	      left: "start",
	      middle: "middle",
	      end: "end",
	      right: "end"
	    }, cue.align);
	  }
	
	  function skipWhitespace() {
	    input = input.replace(/^\s+/, "");
	  }
	
	  // 4.1 WebVTT cue timings.
	  skipWhitespace();
	  cue.startTime = consumeTimeStamp();   // (1) collect cue start time
	  skipWhitespace();
	  if (input.substr(0, 3) !== "-->") {     // (3) next characters must match "-->"
	    throw new ParsingError(ParsingError.Errors.BadTimeStamp,
	                           "Malformed time stamp (time stamps must be separated by '-->'): " +
	                           oInput);
	  }
	  input = input.substr(3);
	  skipWhitespace();
	  cue.endTime = consumeTimeStamp();     // (5) collect cue end time
	
	  // 4.1 WebVTT cue settings list.
	  skipWhitespace();
	  consumeCueSettings(input, cue);
	}
	
	var ESCAPE = {
	  "&amp;": "&",
	  "&lt;": "<",
	  "&gt;": ">",
	  "&lrm;": "\u200e",
	  "&rlm;": "\u200f",
	  "&nbsp;": "\u00a0"
	};
	
	var TAG_NAME = {
	  c: "span",
	  i: "i",
	  b: "b",
	  u: "u",
	  ruby: "ruby",
	  rt: "rt",
	  v: "span",
	  lang: "span"
	};
	
	var TAG_ANNOTATION = {
	  v: "title",
	  lang: "lang"
	};
	
	var NEEDS_PARENT = {
	  rt: "ruby"
	};
	
	// Parse content into a document fragment.
	function parseContent(window, input) {
	  function nextToken() {
	    // Check for end-of-string.
	    if (!input) {
	      return null;
	    }
	
	    // Consume 'n' characters from the input.
	    function consume(result) {
	      input = input.substr(result.length);
	      return result;
	    }
	
	    var m = input.match(/^([^<]*)(<[^>]*>?)?/);
	    // If there is some text before the next tag, return it, otherwise return
	    // the tag.
	    return consume(m[1] ? m[1] : m[2]);
	  }
	
	  // Unescape a string 's'.
	  function unescape1(e) {
	    return ESCAPE[e];
	  }
	  function unescape(s) {
	    while ((m = s.match(/&(amp|lt|gt|lrm|rlm|nbsp);/))) {
	      s = s.replace(m[0], unescape1);
	    }
	    return s;
	  }
	
	  function shouldAdd(current, element) {
	    return !NEEDS_PARENT[element.localName] ||
	           NEEDS_PARENT[element.localName] === current.localName;
	  }
	
	  // Create an element for this tag.
	  function createElement(type, annotation) {
	    var tagName = TAG_NAME[type];
	    if (!tagName) {
	      return null;
	    }
	    var element = window.document.createElement(tagName);
	    element.localName = tagName;
	    var name = TAG_ANNOTATION[type];
	    if (name && annotation) {
	      element[name] = annotation.trim();
	    }
	    return element;
	  }
	
	  var rootDiv = window.document.createElement("div"),
	      current = rootDiv,
	      t,
	      tagStack = [];
	
	  while ((t = nextToken()) !== null) {
	    if (t[0] === '<') {
	      if (t[1] === "/") {
	        // If the closing tag matches, move back up to the parent node.
	        if (tagStack.length &&
	            tagStack[tagStack.length - 1] === t.substr(2).replace(">", "")) {
	          tagStack.pop();
	          current = current.parentNode;
	        }
	        // Otherwise just ignore the end tag.
	        continue;
	      }
	      var ts = parseTimeStamp(t.substr(1, t.length - 2));
	      var node;
	      if (ts) {
	        // Timestamps are lead nodes as well.
	        node = window.document.createProcessingInstruction("timestamp", ts);
	        current.appendChild(node);
	        continue;
	      }
	      var m = t.match(/^<([^.\s/0-9>]+)(\.[^\s\\>]+)?([^>\\]+)?(\\?)>?$/);
	      // If we can't parse the tag, skip to the next tag.
	      if (!m) {
	        continue;
	      }
	      // Try to construct an element, and ignore the tag if we couldn't.
	      node = createElement(m[1], m[3]);
	      if (!node) {
	        continue;
	      }
	      // Determine if the tag should be added based on the context of where it
	      // is placed in the cuetext.
	      if (!shouldAdd(current, node)) {
	        continue;
	      }
	      // Set the class list (as a list of classes, separated by space).
	      if (m[2]) {
	        node.className = m[2].substr(1).replace('.', ' ');
	      }
	      // Append the node to the current node, and enter the scope of the new
	      // node.
	      tagStack.push(m[1]);
	      current.appendChild(node);
	      current = node;
	      continue;
	    }
	
	    // Text nodes are leaf nodes.
	    current.appendChild(window.document.createTextNode(unescape(t)));
	  }
	
	  return rootDiv;
	}
	
	// This is a list of all the Unicode characters that have a strong
	// right-to-left category. What this means is that these characters are
	// written right-to-left for sure. It was generated by pulling all the strong
	// right-to-left characters out of the Unicode data table. That table can
	// found at: http://www.unicode.org/Public/UNIDATA/UnicodeData.txt
	var strongRTLRanges = [[0x5be, 0x5be], [0x5c0, 0x5c0], [0x5c3, 0x5c3], [0x5c6, 0x5c6],
	 [0x5d0, 0x5ea], [0x5f0, 0x5f4], [0x608, 0x608], [0x60b, 0x60b], [0x60d, 0x60d],
	 [0x61b, 0x61b], [0x61e, 0x64a], [0x66d, 0x66f], [0x671, 0x6d5], [0x6e5, 0x6e6],
	 [0x6ee, 0x6ef], [0x6fa, 0x70d], [0x70f, 0x710], [0x712, 0x72f], [0x74d, 0x7a5],
	 [0x7b1, 0x7b1], [0x7c0, 0x7ea], [0x7f4, 0x7f5], [0x7fa, 0x7fa], [0x800, 0x815],
	 [0x81a, 0x81a], [0x824, 0x824], [0x828, 0x828], [0x830, 0x83e], [0x840, 0x858],
	 [0x85e, 0x85e], [0x8a0, 0x8a0], [0x8a2, 0x8ac], [0x200f, 0x200f],
	 [0xfb1d, 0xfb1d], [0xfb1f, 0xfb28], [0xfb2a, 0xfb36], [0xfb38, 0xfb3c],
	 [0xfb3e, 0xfb3e], [0xfb40, 0xfb41], [0xfb43, 0xfb44], [0xfb46, 0xfbc1],
	 [0xfbd3, 0xfd3d], [0xfd50, 0xfd8f], [0xfd92, 0xfdc7], [0xfdf0, 0xfdfc],
	 [0xfe70, 0xfe74], [0xfe76, 0xfefc], [0x10800, 0x10805], [0x10808, 0x10808],
	 [0x1080a, 0x10835], [0x10837, 0x10838], [0x1083c, 0x1083c], [0x1083f, 0x10855],
	 [0x10857, 0x1085f], [0x10900, 0x1091b], [0x10920, 0x10939], [0x1093f, 0x1093f],
	 [0x10980, 0x109b7], [0x109be, 0x109bf], [0x10a00, 0x10a00], [0x10a10, 0x10a13],
	 [0x10a15, 0x10a17], [0x10a19, 0x10a33], [0x10a40, 0x10a47], [0x10a50, 0x10a58],
	 [0x10a60, 0x10a7f], [0x10b00, 0x10b35], [0x10b40, 0x10b55], [0x10b58, 0x10b72],
	 [0x10b78, 0x10b7f], [0x10c00, 0x10c48], [0x1ee00, 0x1ee03], [0x1ee05, 0x1ee1f],
	 [0x1ee21, 0x1ee22], [0x1ee24, 0x1ee24], [0x1ee27, 0x1ee27], [0x1ee29, 0x1ee32],
	 [0x1ee34, 0x1ee37], [0x1ee39, 0x1ee39], [0x1ee3b, 0x1ee3b], [0x1ee42, 0x1ee42],
	 [0x1ee47, 0x1ee47], [0x1ee49, 0x1ee49], [0x1ee4b, 0x1ee4b], [0x1ee4d, 0x1ee4f],
	 [0x1ee51, 0x1ee52], [0x1ee54, 0x1ee54], [0x1ee57, 0x1ee57], [0x1ee59, 0x1ee59],
	 [0x1ee5b, 0x1ee5b], [0x1ee5d, 0x1ee5d], [0x1ee5f, 0x1ee5f], [0x1ee61, 0x1ee62],
	 [0x1ee64, 0x1ee64], [0x1ee67, 0x1ee6a], [0x1ee6c, 0x1ee72], [0x1ee74, 0x1ee77],
	 [0x1ee79, 0x1ee7c], [0x1ee7e, 0x1ee7e], [0x1ee80, 0x1ee89], [0x1ee8b, 0x1ee9b],
	 [0x1eea1, 0x1eea3], [0x1eea5, 0x1eea9], [0x1eeab, 0x1eebb], [0x10fffd, 0x10fffd]];
	
	function isStrongRTLChar(charCode) {
	  for (var i = 0; i < strongRTLRanges.length; i++) {
	    var currentRange = strongRTLRanges[i];
	    if (charCode >= currentRange[0] && charCode <= currentRange[1]) {
	      return true;
	    }
	  }
	
	  return false;
	}
	
	function determineBidi(cueDiv) {
	  var nodeStack = [],
	      text = "",
	      charCode;
	
	  if (!cueDiv || !cueDiv.childNodes) {
	    return "ltr";
	  }
	
	  function pushNodes(nodeStack, node) {
	    for (var i = node.childNodes.length - 1; i >= 0; i--) {
	      nodeStack.push(node.childNodes[i]);
	    }
	  }
	
	  function nextTextNode(nodeStack) {
	    if (!nodeStack || !nodeStack.length) {
	      return null;
	    }
	
	    var node = nodeStack.pop(),
	        text = node.textContent || node.innerText;
	    if (text) {
	      // TODO: This should match all unicode type B characters (paragraph
	      // separator characters). See issue #115.
	      var m = text.match(/^.*(\n|\r)/);
	      if (m) {
	        nodeStack.length = 0;
	        return m[0];
	      }
	      return text;
	    }
	    if (node.tagName === "ruby") {
	      return nextTextNode(nodeStack);
	    }
	    if (node.childNodes) {
	      pushNodes(nodeStack, node);
	      return nextTextNode(nodeStack);
	    }
	  }
	
	  pushNodes(nodeStack, cueDiv);
	  while ((text = nextTextNode(nodeStack))) {
	    for (var i = 0; i < text.length; i++) {
	      charCode = text.charCodeAt(i);
	      if (isStrongRTLChar(charCode)) {
	        return "rtl";
	      }
	    }
	  }
	  return "ltr";
	}
	
	function computeLinePos(cue) {
	  if (typeof cue.line === "number" &&
	      (cue.snapToLines || (cue.line >= 0 && cue.line <= 100))) {
	    return cue.line;
	  }
	  if (!cue.track || !cue.track.textTrackList ||
	      !cue.track.textTrackList.mediaElement) {
	    return -1;
	  }
	  var track = cue.track,
	      trackList = track.textTrackList,
	      count = 0;
	  for (var i = 0; i < trackList.length && trackList[i] !== track; i++) {
	    if (trackList[i].mode === "showing") {
	      count++;
	    }
	  }
	  return ++count * -1;
	}
	
	function StyleBox() {
	}
	
	// Apply styles to a div. If there is no div passed then it defaults to the
	// div on 'this'.
	StyleBox.prototype.applyStyles = function(styles, div) {
	  div = div || this.div;
	  for (var prop in styles) {
	    if (styles.hasOwnProperty(prop)) {
	      div.style[prop] = styles[prop];
	    }
	  }
	};
	
	StyleBox.prototype.formatStyle = function(val, unit) {
	  return val === 0 ? 0 : val + unit;
	};
	
	// Constructs the computed display state of the cue (a div). Places the div
	// into the overlay which should be a block level element (usually a div).
	function CueStyleBox(window, cue, styleOptions) {
	  StyleBox.call(this);
	  this.cue = cue;
	
	  // Parse our cue's text into a DOM tree rooted at 'cueDiv'. This div will
	  // have inline positioning and will function as the cue background box.
	  this.cueDiv = parseContent(window, cue.text);
	  var styles = {
	    color: "rgba(255, 255, 255, 1)",
	    backgroundColor:  "rgba(0, 0, 0, 0.8)",
	    position: "relative",
	    left: 0,
	    right: 0,
	    top: 0,
	    bottom: 0,
	    display: "inline",
	    writingMode: cue.vertical === "" ? "horizontal-tb"
	                                     : cue.vertical === "lr" ? "vertical-lr"
	                                                             : "vertical-rl",
	    unicodeBidi: "plaintext"
	  };
	
	  this.applyStyles(styles, this.cueDiv);
	
	  // Create an absolutely positioned div that will be used to position the cue
	  // div. Note, all WebVTT cue-setting alignments are equivalent to the CSS
	  // mirrors of them except "middle" which is "center" in CSS.
	  this.div = window.document.createElement("div");
	  styles = {
	    direction: determineBidi(this.cueDiv),
	    writingMode: cue.vertical === "" ? "horizontal-tb"
	                                     : cue.vertical === "lr" ? "vertical-lr"
	                                                             : "vertical-rl",
	    unicodeBidi: "plaintext",
	    textAlign: cue.align === "middle" ? "center" : cue.align,
	    font: styleOptions.font,
	    whiteSpace: "pre-line",
	    position: "absolute"
	  };
	
	  this.applyStyles(styles);
	  this.div.appendChild(this.cueDiv);
	
	  // Calculate the distance from the reference edge of the viewport to the text
	  // position of the cue box. The reference edge will be resolved later when
	  // the box orientation styles are applied.
	  var textPos = 0;
	  switch (cue.positionAlign) {
	  case "start":
	    textPos = cue.position;
	    break;
	  case "middle":
	    textPos = cue.position - (cue.size / 2);
	    break;
	  case "end":
	    textPos = cue.position - cue.size;
	    break;
	  }
	
	  // Horizontal box orientation; textPos is the distance from the left edge of the
	  // area to the left edge of the box and cue.size is the distance extending to
	  // the right from there.
	  if (cue.vertical === "") {
	    this.applyStyles({
	      left:  this.formatStyle(textPos, "%"),
	      width: this.formatStyle(cue.size, "%")
	    });
	  // Vertical box orientation; textPos is the distance from the top edge of the
	  // area to the top edge of the box and cue.size is the height extending
	  // downwards from there.
	  } else {
	    this.applyStyles({
	      top: this.formatStyle(textPos, "%"),
	      height: this.formatStyle(cue.size, "%")
	    });
	  }
	
	  this.move = function(box) {
	    this.applyStyles({
	      top: this.formatStyle(box.top, "px"),
	      bottom: this.formatStyle(box.bottom, "px"),
	      left: this.formatStyle(box.left, "px"),
	      right: this.formatStyle(box.right, "px"),
	      height: this.formatStyle(box.height, "px"),
	      width: this.formatStyle(box.width, "px")
	    });
	  };
	}
	CueStyleBox.prototype = _objCreate(StyleBox.prototype);
	CueStyleBox.prototype.constructor = CueStyleBox;
	
	// Represents the co-ordinates of an Element in a way that we can easily
	// compute things with such as if it overlaps or intersects with another Element.
	// Can initialize it with either a StyleBox or another BoxPosition.
	function BoxPosition(obj) {
	  // Either a BoxPosition was passed in and we need to copy it, or a StyleBox
	  // was passed in and we need to copy the results of 'getBoundingClientRect'
	  // as the object returned is readonly. All co-ordinate values are in reference
	  // to the viewport origin (top left).
	  var lh, height, width, top;
	  if (obj.div) {
	    height = obj.div.offsetHeight;
	    width = obj.div.offsetWidth;
	    top = obj.div.offsetTop;
	
	    var rects = (rects = obj.div.childNodes) && (rects = rects[0]) &&
	                rects.getClientRects && rects.getClientRects();
	    obj = obj.div.getBoundingClientRect();
	    // In certain cases the outter div will be slightly larger then the sum of
	    // the inner div's lines. This could be due to bold text, etc, on some platforms.
	    // In this case we should get the average line height and use that. This will
	    // result in the desired behaviour.
	    lh = rects ? Math.max((rects[0] && rects[0].height) || 0, obj.height / rects.length)
	               : 0;
	
	  }
	  this.left = obj.left;
	  this.right = obj.right;
	  this.top = obj.top || top;
	  this.height = obj.height || height;
	  this.bottom = obj.bottom || (top + (obj.height || height));
	  this.width = obj.width || width;
	  this.lineHeight = lh !== undefined ? lh : obj.lineHeight;
	}
	
	// Move the box along a particular axis. Optionally pass in an amount to move
	// the box. If no amount is passed then the default is the line height of the
	// box.
	BoxPosition.prototype.move = function(axis, toMove) {
	  toMove = toMove !== undefined ? toMove : this.lineHeight;
	  switch (axis) {
	  case "+x":
	    this.left += toMove;
	    this.right += toMove;
	    break;
	  case "-x":
	    this.left -= toMove;
	    this.right -= toMove;
	    break;
	  case "+y":
	    this.top += toMove;
	    this.bottom += toMove;
	    break;
	  case "-y":
	    this.top -= toMove;
	    this.bottom -= toMove;
	    break;
	  }
	};
	
	// Check if this box overlaps another box, b2.
	BoxPosition.prototype.overlaps = function(b2) {
	  return this.left < b2.right &&
	         this.right > b2.left &&
	         this.top < b2.bottom &&
	         this.bottom > b2.top;
	};
	
	// Check if this box overlaps any other boxes in boxes.
	BoxPosition.prototype.overlapsAny = function(boxes) {
	  for (var i = 0; i < boxes.length; i++) {
	    if (this.overlaps(boxes[i])) {
	      return true;
	    }
	  }
	  return false;
	};
	
	// Check if this box is within another box.
	BoxPosition.prototype.within = function(container) {
	  return this.top >= container.top &&
	         this.bottom <= container.bottom &&
	         this.left >= container.left &&
	         this.right <= container.right;
	};
	
	// Check if this box is entirely within the container or it is overlapping
	// on the edge opposite of the axis direction passed. For example, if "+x" is
	// passed and the box is overlapping on the left edge of the container, then
	// return true.
	BoxPosition.prototype.overlapsOppositeAxis = function(container, axis) {
	  switch (axis) {
	  case "+x":
	    return this.left < container.left;
	  case "-x":
	    return this.right > container.right;
	  case "+y":
	    return this.top < container.top;
	  case "-y":
	    return this.bottom > container.bottom;
	  }
	};
	
	// Find the percentage of the area that this box is overlapping with another
	// box.
	BoxPosition.prototype.intersectPercentage = function(b2) {
	  var x = Math.max(0, Math.min(this.right, b2.right) - Math.max(this.left, b2.left)),
	      y = Math.max(0, Math.min(this.bottom, b2.bottom) - Math.max(this.top, b2.top)),
	      intersectArea = x * y;
	  return intersectArea / (this.height * this.width);
	};
	
	// Convert the positions from this box to CSS compatible positions using
	// the reference container's positions. This has to be done because this
	// box's positions are in reference to the viewport origin, whereas, CSS
	// values are in referecne to their respective edges.
	BoxPosition.prototype.toCSSCompatValues = function(reference) {
	  return {
	    top: this.top - reference.top,
	    bottom: reference.bottom - this.bottom,
	    left: this.left - reference.left,
	    right: reference.right - this.right,
	    height: this.height,
	    width: this.width
	  };
	};
	
	// Get an object that represents the box's position without anything extra.
	// Can pass a StyleBox, HTMLElement, or another BoxPositon.
	BoxPosition.getSimpleBoxPosition = function(obj) {
	  var height = obj.div ? obj.div.offsetHeight : obj.tagName ? obj.offsetHeight : 0;
	  var width = obj.div ? obj.div.offsetWidth : obj.tagName ? obj.offsetWidth : 0;
	  var top = obj.div ? obj.div.offsetTop : obj.tagName ? obj.offsetTop : 0;
	
	  obj = obj.div ? obj.div.getBoundingClientRect() :
	                obj.tagName ? obj.getBoundingClientRect() : obj;
	  var ret = {
	    left: obj.left,
	    right: obj.right,
	    top: obj.top || top,
	    height: obj.height || height,
	    bottom: obj.bottom || (top + (obj.height || height)),
	    width: obj.width || width
	  };
	  return ret;
	};
	
	// Move a StyleBox to its specified, or next best, position. The containerBox
	// is the box that contains the StyleBox, such as a div. boxPositions are
	// a list of other boxes that the styleBox can't overlap with.
	function moveBoxToLinePosition(window, styleBox, containerBox, boxPositions) {
	
	  // Find the best position for a cue box, b, on the video. The axis parameter
	  // is a list of axis, the order of which, it will move the box along. For example:
	  // Passing ["+x", "-x"] will move the box first along the x axis in the positive
	  // direction. If it doesn't find a good position for it there it will then move
	  // it along the x axis in the negative direction.
	  function findBestPosition(b, axis) {
	    var bestPosition,
	        specifiedPosition = new BoxPosition(b),
	        percentage = 1; // Highest possible so the first thing we get is better.
	
	    for (var i = 0; i < axis.length; i++) {
	      while (b.overlapsOppositeAxis(containerBox, axis[i]) ||
	             (b.within(containerBox) && b.overlapsAny(boxPositions))) {
	        b.move(axis[i]);
	      }
	      // We found a spot where we aren't overlapping anything. This is our
	      // best position.
	      if (b.within(containerBox)) {
	        return b;
	      }
	      var p = b.intersectPercentage(containerBox);
	      // If we're outside the container box less then we were on our last try
	      // then remember this position as the best position.
	      if (percentage > p) {
	        bestPosition = new BoxPosition(b);
	        percentage = p;
	      }
	      // Reset the box position to the specified position.
	      b = new BoxPosition(specifiedPosition);
	    }
	    return bestPosition || specifiedPosition;
	  }
	
	  var boxPosition = new BoxPosition(styleBox),
	      cue = styleBox.cue,
	      linePos = computeLinePos(cue),
	      axis = [];
	
	  // If we have a line number to align the cue to.
	  if (cue.snapToLines) {
	    var size;
	    switch (cue.vertical) {
	    case "":
	      axis = [ "+y", "-y" ];
	      size = "height";
	      break;
	    case "rl":
	      axis = [ "+x", "-x" ];
	      size = "width";
	      break;
	    case "lr":
	      axis = [ "-x", "+x" ];
	      size = "width";
	      break;
	    }
	
	    var step = boxPosition.lineHeight,
	        position = step * Math.round(linePos),
	        maxPosition = containerBox[size] + step,
	        initialAxis = axis[0];
	
	    // If the specified intial position is greater then the max position then
	    // clamp the box to the amount of steps it would take for the box to
	    // reach the max position.
	    if (Math.abs(position) > maxPosition) {
	      position = position < 0 ? -1 : 1;
	      position *= Math.ceil(maxPosition / step) * step;
	    }
	
	    // If computed line position returns negative then line numbers are
	    // relative to the bottom of the video instead of the top. Therefore, we
	    // need to increase our initial position by the length or width of the
	    // video, depending on the writing direction, and reverse our axis directions.
	    if (linePos < 0) {
	      position += cue.vertical === "" ? containerBox.height : containerBox.width;
	      axis = axis.reverse();
	    }
	
	    // Move the box to the specified position. This may not be its best
	    // position.
	    boxPosition.move(initialAxis, position);
	
	  } else {
	    // If we have a percentage line value for the cue.
	    var calculatedPercentage = (boxPosition.lineHeight / containerBox.height) * 100;
	
	    switch (cue.lineAlign) {
	    case "middle":
	      linePos -= (calculatedPercentage / 2);
	      break;
	    case "end":
	      linePos -= calculatedPercentage;
	      break;
	    }
	
	    // Apply initial line position to the cue box.
	    switch (cue.vertical) {
	    case "":
	      styleBox.applyStyles({
	        top: styleBox.formatStyle(linePos, "%")
	      });
	      break;
	    case "rl":
	      styleBox.applyStyles({
	        left: styleBox.formatStyle(linePos, "%")
	      });
	      break;
	    case "lr":
	      styleBox.applyStyles({
	        right: styleBox.formatStyle(linePos, "%")
	      });
	      break;
	    }
	
	    axis = [ "+y", "-x", "+x", "-y" ];
	
	    // Get the box position again after we've applied the specified positioning
	    // to it.
	    boxPosition = new BoxPosition(styleBox);
	  }
	
	  var bestPosition = findBestPosition(boxPosition, axis);
	  styleBox.move(bestPosition.toCSSCompatValues(containerBox));
	}
	
	function WebVTT() {
	  // Nothing
	}
	
	// Helper to allow strings to be decoded instead of the default binary utf8 data.
	WebVTT.StringDecoder = function() {
	  return {
	    decode: function(data) {
	      if (!data) {
	        return "";
	      }
	      if (typeof data !== "string") {
	        throw new Error("Error - expected string data.");
	      }
	      return decodeURIComponent(encodeURIComponent(data));
	    }
	  };
	};
	
	WebVTT.convertCueToDOMTree = function(window, cuetext) {
	  if (!window || !cuetext) {
	    return null;
	  }
	  return parseContent(window, cuetext);
	};
	
	var FONT_SIZE_PERCENT = 0.05;
	var FONT_STYLE = "sans-serif";
	var CUE_BACKGROUND_PADDING = "1.5%";
	
	// Runs the processing model over the cues and regions passed to it.
	// @param overlay A block level element (usually a div) that the computed cues
	//                and regions will be placed into.
	WebVTT.processCues = function(window, cues, overlay) {
	  if (!window || !cues || !overlay) {
	    return null;
	  }
	
	  // Remove all previous children.
	  while (overlay.firstChild) {
	    overlay.removeChild(overlay.firstChild);
	  }
	
	  var paddedOverlay = window.document.createElement("div");
	  paddedOverlay.style.position = "absolute";
	  paddedOverlay.style.left = "0";
	  paddedOverlay.style.right = "0";
	  paddedOverlay.style.top = "0";
	  paddedOverlay.style.bottom = "0";
	  paddedOverlay.style.margin = CUE_BACKGROUND_PADDING;
	  overlay.appendChild(paddedOverlay);
	
	  // Determine if we need to compute the display states of the cues. This could
	  // be the case if a cue's state has been changed since the last computation or
	  // if it has not been computed yet.
	  function shouldCompute(cues) {
	    for (var i = 0; i < cues.length; i++) {
	      if (cues[i].hasBeenReset || !cues[i].displayState) {
	        return true;
	      }
	    }
	    return false;
	  }
	
	  // We don't need to recompute the cues' display states. Just reuse them.
	  if (!shouldCompute(cues)) {
	    for (var i = 0; i < cues.length; i++) {
	      paddedOverlay.appendChild(cues[i].displayState);
	    }
	    return;
	  }
	
	  var boxPositions = [],
	      containerBox = BoxPosition.getSimpleBoxPosition(paddedOverlay),
	      fontSize = Math.round(containerBox.height * FONT_SIZE_PERCENT * 100) / 100;
	  var styleOptions = {
	    font: fontSize + "px " + FONT_STYLE
	  };
	
	  (function() {
	    var styleBox, cue;
	
	    for (var i = 0; i < cues.length; i++) {
	      cue = cues[i];
	
	      // Compute the intial position and styles of the cue div.
	      styleBox = new CueStyleBox(window, cue, styleOptions);
	      paddedOverlay.appendChild(styleBox.div);
	
	      // Move the cue div to it's correct line position.
	      moveBoxToLinePosition(window, styleBox, containerBox, boxPositions);
	
	      // Remember the computed div so that we don't have to recompute it later
	      // if we don't have too.
	      cue.displayState = styleBox.div;
	
	      boxPositions.push(BoxPosition.getSimpleBoxPosition(styleBox));
	    }
	  })();
	};
	
	WebVTT.Parser = function(window, vttjs, decoder) {
	  if (!decoder) {
	    decoder = vttjs;
	    vttjs = {};
	  }
	  if (!vttjs) {
	    vttjs = {};
	  }
	
	  this.window = window;
	  this.vttjs = vttjs;
	  this.state = "INITIAL";
	  this.buffer = "";
	  this.decoder = decoder || new TextDecoder("utf8");
	  this.regionList = [];
	};
	
	WebVTT.Parser.prototype = {
	  // If the error is a ParsingError then report it to the consumer if
	  // possible. If it's not a ParsingError then throw it like normal.
	  reportOrThrowError: function(e) {
	    if (e instanceof ParsingError) {
	      this.onparsingerror && this.onparsingerror(e);
	    } else {
	      throw e;
	    }
	  },
	  parse: function (data) {
	    var self = this;
	
	    // If there is no data then we won't decode it, but will just try to parse
	    // whatever is in buffer already. This may occur in circumstances, for
	    // example when flush() is called.
	    if (data) {
	      // Try to decode the data that we received.
	      self.buffer += self.decoder.decode(data, {stream: true});
	    }
	
	    function collectNextLine() {
	      var buffer = self.buffer;
	      var pos = 0;
	      while (pos < buffer.length && buffer[pos] !== '\r' && buffer[pos] !== '\n') {
	        ++pos;
	      }
	      var line = buffer.substr(0, pos);
	      // Advance the buffer early in case we fail below.
	      if (buffer[pos] === '\r') {
	        ++pos;
	      }
	      if (buffer[pos] === '\n') {
	        ++pos;
	      }
	      self.buffer = buffer.substr(pos);
	      return line;
	    }
	
	    // 3.4 WebVTT region and WebVTT region settings syntax
	    function parseRegion(input) {
	      var settings = new Settings();
	
	      parseOptions(input, function (k, v) {
	        switch (k) {
	        case "id":
	          settings.set(k, v);
	          break;
	        case "width":
	          settings.percent(k, v);
	          break;
	        case "lines":
	          settings.integer(k, v);
	          break;
	        case "regionanchor":
	        case "viewportanchor":
	          var xy = v.split(',');
	          if (xy.length !== 2) {
	            break;
	          }
	          // We have to make sure both x and y parse, so use a temporary
	          // settings object here.
	          var anchor = new Settings();
	          anchor.percent("x", xy[0]);
	          anchor.percent("y", xy[1]);
	          if (!anchor.has("x") || !anchor.has("y")) {
	            break;
	          }
	          settings.set(k + "X", anchor.get("x"));
	          settings.set(k + "Y", anchor.get("y"));
	          break;
	        case "scroll":
	          settings.alt(k, v, ["up"]);
	          break;
	        }
	      }, /=/, /\s/);
	
	      // Create the region, using default values for any values that were not
	      // specified.
	      if (settings.has("id")) {
	        var region = new (self.vttjs.VTTRegion || self.window.VTTRegion)();
	        region.width = settings.get("width", 100);
	        region.lines = settings.get("lines", 3);
	        region.regionAnchorX = settings.get("regionanchorX", 0);
	        region.regionAnchorY = settings.get("regionanchorY", 100);
	        region.viewportAnchorX = settings.get("viewportanchorX", 0);
	        region.viewportAnchorY = settings.get("viewportanchorY", 100);
	        region.scroll = settings.get("scroll", "");
	        // Register the region.
	        self.onregion && self.onregion(region);
	        // Remember the VTTRegion for later in case we parse any VTTCues that
	        // reference it.
	        self.regionList.push({
	          id: settings.get("id"),
	          region: region
	        });
	      }
	    }
	
	    // draft-pantos-http-live-streaming-20
	    // https://tools.ietf.org/html/draft-pantos-http-live-streaming-20#section-3.5
	    // 3.5 WebVTT
	    function parseTimestampMap(input) {
	      var settings = new Settings();
	
	      parseOptions(input, function(k, v) {
	        switch(k) {
	        case "MPEGT":
	          settings.integer(k + 'S', v);
	          break;
	        case "LOCA":
	          settings.set(k + 'L', parseTimeStamp(v));
	          break;
	        }
	      }, /[^\d]:/, /,/);
	
	      self.ontimestampmap && self.ontimestampmap({
	        "MPEGTS": settings.get("MPEGTS"),
	        "LOCAL": settings.get("LOCAL")
	      });
	    }
	
	    // 3.2 WebVTT metadata header syntax
	    function parseHeader(input) {
	      if (input.match(/X-TIMESTAMP-MAP/)) {
	        // This line contains HLS X-TIMESTAMP-MAP metadata
	        parseOptions(input, function(k, v) {
	          switch(k) {
	          case "X-TIMESTAMP-MAP":
	            parseTimestampMap(v);
	            break;
	          }
	        }, /=/);
	      } else {
	        parseOptions(input, function (k, v) {
	          switch (k) {
	          case "Region":
	            // 3.3 WebVTT region metadata header syntax
	            parseRegion(v);
	            break;
	          }
	        }, /:/);
	      }
	
	    }
	
	    // 5.1 WebVTT file parsing.
	    try {
	      var line;
	      if (self.state === "INITIAL") {
	        // We can't start parsing until we have the first line.
	        if (!/\r\n|\n/.test(self.buffer)) {
	          return this;
	        }
	
	        line = collectNextLine();
	
	        var m = line.match(/^WEBVTT([ \t].*)?$/);
	        if (!m || !m[0]) {
	          throw new ParsingError(ParsingError.Errors.BadSignature);
	        }
	
	        self.state = "HEADER";
	      }
	
	      var alreadyCollectedLine = false;
	      while (self.buffer) {
	        // We can't parse a line until we have the full line.
	        if (!/\r\n|\n/.test(self.buffer)) {
	          return this;
	        }
	
	        if (!alreadyCollectedLine) {
	          line = collectNextLine();
	        } else {
	          alreadyCollectedLine = false;
	        }
	
	        switch (self.state) {
	        case "HEADER":
	          // 13-18 - Allow a header (metadata) under the WEBVTT line.
	          if (/:/.test(line)) {
	            parseHeader(line);
	          } else if (!line) {
	            // An empty line terminates the header and starts the body (cues).
	            self.state = "ID";
	          }
	          continue;
	        case "NOTE":
	          // Ignore NOTE blocks.
	          if (!line) {
	            self.state = "ID";
	          }
	          continue;
	        case "ID":
	          // Check for the start of NOTE blocks.
	          if (/^NOTE($|[ \t])/.test(line)) {
	            self.state = "NOTE";
	            break;
	          }
	          // 19-29 - Allow any number of line terminators, then initialize new cue values.
	          if (!line) {
	            continue;
	          }
	          self.cue = new (self.vttjs.VTTCue || self.window.VTTCue)(0, 0, "");
	          self.state = "CUE";
	          // 30-39 - Check if self line contains an optional identifier or timing data.
	          if (line.indexOf("-->") === -1) {
	            self.cue.id = line;
	            continue;
	          }
	          // Process line as start of a cue.
	          /*falls through*/
	        case "CUE":
	          // 40 - Collect cue timings and settings.
	          try {
	            parseCue(line, self.cue, self.regionList);
	          } catch (e) {
	            self.reportOrThrowError(e);
	            // In case of an error ignore rest of the cue.
	            self.cue = null;
	            self.state = "BADCUE";
	            continue;
	          }
	          self.state = "CUETEXT";
	          continue;
	        case "CUETEXT":
	          var hasSubstring = line.indexOf("-->") !== -1;
	          // 34 - If we have an empty line then report the cue.
	          // 35 - If we have the special substring '-->' then report the cue,
	          // but do not collect the line as we need to process the current
	          // one as a new cue.
	          if (!line || hasSubstring && (alreadyCollectedLine = true)) {
	            // We are done parsing self cue.
	            self.oncue && self.oncue(self.cue);
	            self.cue = null;
	            self.state = "ID";
	            continue;
	          }
	          if (self.cue.text) {
	            self.cue.text += "\n";
	          }
	          self.cue.text += line;
	          continue;
	        case "BADCUE": // BADCUE
	          // 54-62 - Collect and discard the remaining cue.
	          if (!line) {
	            self.state = "ID";
	          }
	          continue;
	        }
	      }
	    } catch (e) {
	      self.reportOrThrowError(e);
	
	      // If we are currently parsing a cue, report what we have.
	      if (self.state === "CUETEXT" && self.cue && self.oncue) {
	        self.oncue(self.cue);
	      }
	      self.cue = null;
	      // Enter BADWEBVTT state if header was not parsed correctly otherwise
	      // another exception occurred so enter BADCUE state.
	      self.state = self.state === "INITIAL" ? "BADWEBVTT" : "BADCUE";
	    }
	    return this;
	  },
	  flush: function () {
	    var self = this;
	    try {
	      // Finish decoding the stream.
	      self.buffer += self.decoder.decode();
	      // Synthesize the end of the current cue or region.
	      if (self.cue || self.state === "HEADER") {
	        self.buffer += "\n\n";
	        self.parse();
	      }
	      // If we've flushed, parsed, and we're still on the INITIAL state then
	      // that means we don't have enough of the stream to parse the first
	      // line.
	      if (self.state === "INITIAL") {
	        throw new ParsingError(ParsingError.Errors.BadSignature);
	      }
	    } catch(e) {
	      self.reportOrThrowError(e);
	    }
	    self.onflush && self.onflush();
	    return this;
	  }
	};
	
	module.exports = WebVTT;


/***/ },
/* 1128 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013 vtt.js Contributors
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	
	var autoKeyword = "auto";
	var directionSetting = {
	  "": 1,
	  "lr": 1,
	  "rl": 1
	};
	var alignSetting = {
	  "start": 1,
	  "middle": 1,
	  "end": 1,
	  "left": 1,
	  "right": 1
	};
	
	function findDirectionSetting(value) {
	  if (typeof value !== "string") {
	    return false;
	  }
	  var dir = directionSetting[value.toLowerCase()];
	  return dir ? value.toLowerCase() : false;
	}
	
	function findAlignSetting(value) {
	  if (typeof value !== "string") {
	    return false;
	  }
	  var align = alignSetting[value.toLowerCase()];
	  return align ? value.toLowerCase() : false;
	}
	
	function VTTCue(startTime, endTime, text) {
	  /**
	   * Shim implementation specific properties. These properties are not in
	   * the spec.
	   */
	
	  // Lets us know when the VTTCue's data has changed in such a way that we need
	  // to recompute its display state. This lets us compute its display state
	  // lazily.
	  this.hasBeenReset = false;
	
	  /**
	   * VTTCue and TextTrackCue properties
	   * http://dev.w3.org/html5/webvtt/#vttcue-interface
	   */
	
	  var _id = "";
	  var _pauseOnExit = false;
	  var _startTime = startTime;
	  var _endTime = endTime;
	  var _text = text;
	  var _region = null;
	  var _vertical = "";
	  var _snapToLines = true;
	  var _line = "auto";
	  var _lineAlign = "start";
	  var _position = 50;
	  var _positionAlign = "middle";
	  var _size = 50;
	  var _align = "middle";
	
	  Object.defineProperties(this, {
	    "id": {
	      enumerable: true,
	      get: function() {
	        return _id;
	      },
	      set: function(value) {
	        _id = "" + value;
	      }
	    },
	
	    "pauseOnExit": {
	      enumerable: true,
	      get: function() {
	        return _pauseOnExit;
	      },
	      set: function(value) {
	        _pauseOnExit = !!value;
	      }
	    },
	
	    "startTime": {
	      enumerable: true,
	      get: function() {
	        return _startTime;
	      },
	      set: function(value) {
	        if (typeof value !== "number") {
	          throw new TypeError("Start time must be set to a number.");
	        }
	        _startTime = value;
	        this.hasBeenReset = true;
	      }
	    },
	
	    "endTime": {
	      enumerable: true,
	      get: function() {
	        return _endTime;
	      },
	      set: function(value) {
	        if (typeof value !== "number") {
	          throw new TypeError("End time must be set to a number.");
	        }
	        _endTime = value;
	        this.hasBeenReset = true;
	      }
	    },
	
	    "text": {
	      enumerable: true,
	      get: function() {
	        return _text;
	      },
	      set: function(value) {
	        _text = "" + value;
	        this.hasBeenReset = true;
	      }
	    },
	
	    "region": {
	      enumerable: true,
	      get: function() {
	        return _region;
	      },
	      set: function(value) {
	        _region = value;
	        this.hasBeenReset = true;
	      }
	    },
	
	    "vertical": {
	      enumerable: true,
	      get: function() {
	        return _vertical;
	      },
	      set: function(value) {
	        var setting = findDirectionSetting(value);
	        // Have to check for false because the setting an be an empty string.
	        if (setting === false) {
	          throw new SyntaxError("An invalid or illegal string was specified.");
	        }
	        _vertical = setting;
	        this.hasBeenReset = true;
	      }
	    },
	
	    "snapToLines": {
	      enumerable: true,
	      get: function() {
	        return _snapToLines;
	      },
	      set: function(value) {
	        _snapToLines = !!value;
	        this.hasBeenReset = true;
	      }
	    },
	
	    "line": {
	      enumerable: true,
	      get: function() {
	        return _line;
	      },
	      set: function(value) {
	        if (typeof value !== "number" && value !== autoKeyword) {
	          throw new SyntaxError("An invalid number or illegal string was specified.");
	        }
	        _line = value;
	        this.hasBeenReset = true;
	      }
	    },
	
	    "lineAlign": {
	      enumerable: true,
	      get: function() {
	        return _lineAlign;
	      },
	      set: function(value) {
	        var setting = findAlignSetting(value);
	        if (!setting) {
	          throw new SyntaxError("An invalid or illegal string was specified.");
	        }
	        _lineAlign = setting;
	        this.hasBeenReset = true;
	      }
	    },
	
	    "position": {
	      enumerable: true,
	      get: function() {
	        return _position;
	      },
	      set: function(value) {
	        if (value < 0 || value > 100) {
	          throw new Error("Position must be between 0 and 100.");
	        }
	        _position = value;
	        this.hasBeenReset = true;
	      }
	    },
	
	    "positionAlign": {
	      enumerable: true,
	      get: function() {
	        return _positionAlign;
	      },
	      set: function(value) {
	        var setting = findAlignSetting(value);
	        if (!setting) {
	          throw new SyntaxError("An invalid or illegal string was specified.");
	        }
	        _positionAlign = setting;
	        this.hasBeenReset = true;
	      }
	    },
	
	    "size": {
	      enumerable: true,
	      get: function() {
	        return _size;
	      },
	      set: function(value) {
	        if (value < 0 || value > 100) {
	          throw new Error("Size must be between 0 and 100.");
	        }
	        _size = value;
	        this.hasBeenReset = true;
	      }
	    },
	
	    "align": {
	      enumerable: true,
	      get: function() {
	        return _align;
	      },
	      set: function(value) {
	        var setting = findAlignSetting(value);
	        if (!setting) {
	          throw new SyntaxError("An invalid or illegal string was specified.");
	        }
	        _align = setting;
	        this.hasBeenReset = true;
	      }
	    }
	  });
	
	  /**
	   * Other <track> spec defined properties
	   */
	
	  // http://www.whatwg.org/specs/web-apps/current-work/multipage/the-video-element.html#text-track-cue-display-state
	  this.displayState = undefined;
	}
	
	/**
	 * VTTCue methods
	 */
	
	VTTCue.prototype.getCueAsHTML = function() {
	  // Assume WebVTT.convertCueToDOMTree is on the global.
	  return WebVTT.convertCueToDOMTree(window, this.text);
	};
	
	module.exports = VTTCue;


/***/ },
/* 1129 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013 vtt.js Contributors
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	
	var scrollSetting = {
	  "": true,
	  "up": true
	};
	
	function findScrollSetting(value) {
	  if (typeof value !== "string") {
	    return false;
	  }
	  var scroll = scrollSetting[value.toLowerCase()];
	  return scroll ? value.toLowerCase() : false;
	}
	
	function isValidPercentValue(value) {
	  return typeof value === "number" && (value >= 0 && value <= 100);
	}
	
	// VTTRegion shim http://dev.w3.org/html5/webvtt/#vttregion-interface
	function VTTRegion() {
	  var _width = 100;
	  var _lines = 3;
	  var _regionAnchorX = 0;
	  var _regionAnchorY = 100;
	  var _viewportAnchorX = 0;
	  var _viewportAnchorY = 100;
	  var _scroll = "";
	
	  Object.defineProperties(this, {
	    "width": {
	      enumerable: true,
	      get: function() {
	        return _width;
	      },
	      set: function(value) {
	        if (!isValidPercentValue(value)) {
	          throw new Error("Width must be between 0 and 100.");
	        }
	        _width = value;
	      }
	    },
	    "lines": {
	      enumerable: true,
	      get: function() {
	        return _lines;
	      },
	      set: function(value) {
	        if (typeof value !== "number") {
	          throw new TypeError("Lines must be set to a number.");
	        }
	        _lines = value;
	      }
	    },
	    "regionAnchorY": {
	      enumerable: true,
	      get: function() {
	        return _regionAnchorY;
	      },
	      set: function(value) {
	        if (!isValidPercentValue(value)) {
	          throw new Error("RegionAnchorX must be between 0 and 100.");
	        }
	        _regionAnchorY = value;
	      }
	    },
	    "regionAnchorX": {
	      enumerable: true,
	      get: function() {
	        return _regionAnchorX;
	      },
	      set: function(value) {
	        if(!isValidPercentValue(value)) {
	          throw new Error("RegionAnchorY must be between 0 and 100.");
	        }
	        _regionAnchorX = value;
	      }
	    },
	    "viewportAnchorY": {
	      enumerable: true,
	      get: function() {
	        return _viewportAnchorY;
	      },
	      set: function(value) {
	        if (!isValidPercentValue(value)) {
	          throw new Error("ViewportAnchorY must be between 0 and 100.");
	        }
	        _viewportAnchorY = value;
	      }
	    },
	    "viewportAnchorX": {
	      enumerable: true,
	      get: function() {
	        return _viewportAnchorX;
	      },
	      set: function(value) {
	        if (!isValidPercentValue(value)) {
	          throw new Error("ViewportAnchorX must be between 0 and 100.");
	        }
	        _viewportAnchorX = value;
	      }
	    },
	    "scroll": {
	      enumerable: true,
	      get: function() {
	        return _scroll;
	      },
	      set: function(value) {
	        var setting = findScrollSetting(value);
	        // Have to check for false as an empty string is a legal value.
	        if (setting === false) {
	          throw new SyntaxError("An invalid or illegal string was specified.");
	        }
	        _scroll = setting;
	      }
	    }
	  });
	}
	
	module.exports = VTTRegion;


/***/ },
/* 1130 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var window = __webpack_require__(170)
	var isFunction = __webpack_require__(845)
	var parseHeaders = __webpack_require__(960)
	var xtend = __webpack_require__(1131)
	
	module.exports = createXHR
	createXHR.XMLHttpRequest = window.XMLHttpRequest || noop
	createXHR.XDomainRequest = "withCredentials" in (new createXHR.XMLHttpRequest()) ? createXHR.XMLHttpRequest : window.XDomainRequest
	
	forEachArray(["get", "put", "post", "patch", "head", "delete"], function(method) {
	    createXHR[method === "delete" ? "del" : method] = function(uri, options, callback) {
	        options = initParams(uri, options, callback)
	        options.method = method.toUpperCase()
	        return _createXHR(options)
	    }
	})
	
	function forEachArray(array, iterator) {
	    for (var i = 0; i < array.length; i++) {
	        iterator(array[i])
	    }
	}
	
	function isEmpty(obj){
	    for(var i in obj){
	        if(obj.hasOwnProperty(i)) return false
	    }
	    return true
	}
	
	function initParams(uri, options, callback) {
	    var params = uri
	
	    if (isFunction(options)) {
	        callback = options
	        if (typeof uri === "string") {
	            params = {uri:uri}
	        }
	    } else {
	        params = xtend(options, {uri: uri})
	    }
	
	    params.callback = callback
	    return params
	}
	
	function createXHR(uri, options, callback) {
	    options = initParams(uri, options, callback)
	    return _createXHR(options)
	}
	
	function _createXHR(options) {
	    if(typeof options.callback === "undefined"){
	        throw new Error("callback argument missing")
	    }
	
	    var called = false
	    var callback = function cbOnce(err, response, body){
	        if(!called){
	            called = true
	            options.callback(err, response, body)
	        }
	    }
	
	    function readystatechange() {
	        if (xhr.readyState === 4) {
	            setTimeout(loadFunc, 0)
	        }
	    }
	
	    function getBody() {
	        // Chrome with requestType=blob throws errors arround when even testing access to responseText
	        var body = undefined
	
	        if (xhr.response) {
	            body = xhr.response
	        } else {
	            body = xhr.responseText || getXml(xhr)
	        }
	
	        if (isJson) {
	            try {
	                body = JSON.parse(body)
	            } catch (e) {}
	        }
	
	        return body
	    }
	
	    function errorFunc(evt) {
	        clearTimeout(timeoutTimer)
	        if(!(evt instanceof Error)){
	            evt = new Error("" + (evt || "Unknown XMLHttpRequest Error") )
	        }
	        evt.statusCode = 0
	        return callback(evt, failureResponse)
	    }
	
	    // will load the data & process the response in a special response object
	    function loadFunc() {
	        if (aborted) return
	        var status
	        clearTimeout(timeoutTimer)
	        if(options.useXDR && xhr.status===undefined) {
	            //IE8 CORS GET successful response doesn't have a status field, but body is fine
	            status = 200
	        } else {
	            status = (xhr.status === 1223 ? 204 : xhr.status)
	        }
	        var response = failureResponse
	        var err = null
	
	        if (status !== 0){
	            response = {
	                body: getBody(),
	                statusCode: status,
	                method: method,
	                headers: {},
	                url: uri,
	                rawRequest: xhr
	            }
	            if(xhr.getAllResponseHeaders){ //remember xhr can in fact be XDR for CORS in IE
	                response.headers = parseHeaders(xhr.getAllResponseHeaders())
	            }
	        } else {
	            err = new Error("Internal XMLHttpRequest Error")
	        }
	        return callback(err, response, response.body)
	    }
	
	    var xhr = options.xhr || null
	
	    if (!xhr) {
	        if (options.cors || options.useXDR) {
	            xhr = new createXHR.XDomainRequest()
	        }else{
	            xhr = new createXHR.XMLHttpRequest()
	        }
	    }
	
	    var key
	    var aborted
	    var uri = xhr.url = options.uri || options.url
	    var method = xhr.method = options.method || "GET"
	    var body = options.body || options.data
	    var headers = xhr.headers = options.headers || {}
	    var sync = !!options.sync
	    var isJson = false
	    var timeoutTimer
	    var failureResponse = {
	        body: undefined,
	        headers: {},
	        statusCode: 0,
	        method: method,
	        url: uri,
	        rawRequest: xhr
	    }
	
	    if ("json" in options && options.json !== false) {
	        isJson = true
	        headers["accept"] || headers["Accept"] || (headers["Accept"] = "application/json") //Don't override existing accept header declared by user
	        if (method !== "GET" && method !== "HEAD") {
	            headers["content-type"] || headers["Content-Type"] || (headers["Content-Type"] = "application/json") //Don't override existing accept header declared by user
	            body = JSON.stringify(options.json === true ? body : options.json)
	        }
	    }
	
	    xhr.onreadystatechange = readystatechange
	    xhr.onload = loadFunc
	    xhr.onerror = errorFunc
	    // IE9 must have onprogress be set to a unique function.
	    xhr.onprogress = function () {
	        // IE must die
	    }
	    xhr.onabort = function(){
	        aborted = true;
	    }
	    xhr.ontimeout = errorFunc
	    xhr.open(method, uri, !sync, options.username, options.password)
	    //has to be after open
	    if(!sync) {
	        xhr.withCredentials = !!options.withCredentials
	    }
	    // Cannot set timeout with sync request
	    // not setting timeout on the xhr object, because of old webkits etc. not handling that correctly
	    // both npm's request and jquery 1.x use this kind of timeout, so this is being consistent
	    if (!sync && options.timeout > 0 ) {
	        timeoutTimer = setTimeout(function(){
	            if (aborted) return
	            aborted = true//IE9 may still call readystatechange
	            xhr.abort("timeout")
	            var e = new Error("XMLHttpRequest timeout")
	            e.code = "ETIMEDOUT"
	            errorFunc(e)
	        }, options.timeout )
	    }
	
	    if (xhr.setRequestHeader) {
	        for(key in headers){
	            if(headers.hasOwnProperty(key)){
	                xhr.setRequestHeader(key, headers[key])
	            }
	        }
	    } else if (options.headers && !isEmpty(options.headers)) {
	        throw new Error("Headers cannot be set on an XDomainRequest object")
	    }
	
	    if ("responseType" in options) {
	        xhr.responseType = options.responseType
	    }
	
	    if ("beforeSend" in options &&
	        typeof options.beforeSend === "function"
	    ) {
	        options.beforeSend(xhr)
	    }
	
	    // Microsoft Edge browser sends "undefined" when send is called with undefined value.
	    // XMLHttpRequest spec says to pass null as body to indicate no body
	    // See https://github.com/naugtur/xhr/issues/100.
	    xhr.send(body || null)
	
	    return xhr
	
	
	}
	
	function getXml(xhr) {
	    if (xhr.responseType === "document") {
	        return xhr.responseXML
	    }
	    var firefoxBugTakenEffect = xhr.responseXML && xhr.responseXML.documentElement.nodeName === "parsererror"
	    if (xhr.responseType === "" && !firefoxBugTakenEffect) {
	        return xhr.responseXML
	    }
	
	    return null
	}
	
	function noop() {}


/***/ },
/* 1131 */
/***/ function(module, exports) {

	module.exports = extend
	
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	
	function extend() {
	    var target = {}
	
	    for (var i = 0; i < arguments.length; i++) {
	        var source = arguments[i]
	
	        for (var key in source) {
	            if (hasOwnProperty.call(source, key)) {
	                target[key] = source[key]
	            }
	        }
	    }
	
	    return target
	}


/***/ },
/* 1132 */
/***/ function(module, exports) {

	/* (ignored) */

/***/ },
/* 1133 */,
/* 1134 */,
/* 1135 */,
/* 1136 */,
/* 1137 */,
/* 1138 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(__webpack_module_template_argument_0__);
	
	var invariant = __webpack_require__(21);
	
	/**
	 * Static poolers. Several custom versions for each potential number of
	 * arguments. A completely generic pooler is easy to implement, but would
	 * require accessing the `arguments` object. In each of these, `this` refers to
	 * the Class itself, not an instance. If any others are needed, simply add them
	 * here, or in their own files.
	 */
	var oneArgumentPooler = function (copyFieldsFrom) {
	  var Klass = this;
	  if (Klass.instancePool.length) {
	    var instance = Klass.instancePool.pop();
	    Klass.call(instance, copyFieldsFrom);
	    return instance;
	  } else {
	    return new Klass(copyFieldsFrom);
	  }
	};
	
	var twoArgumentPooler = function (a1, a2) {
	  var Klass = this;
	  if (Klass.instancePool.length) {
	    var instance = Klass.instancePool.pop();
	    Klass.call(instance, a1, a2);
	    return instance;
	  } else {
	    return new Klass(a1, a2);
	  }
	};
	
	var threeArgumentPooler = function (a1, a2, a3) {
	  var Klass = this;
	  if (Klass.instancePool.length) {
	    var instance = Klass.instancePool.pop();
	    Klass.call(instance, a1, a2, a3);
	    return instance;
	  } else {
	    return new Klass(a1, a2, a3);
	  }
	};
	
	var fourArgumentPooler = function (a1, a2, a3, a4) {
	  var Klass = this;
	  if (Klass.instancePool.length) {
	    var instance = Klass.instancePool.pop();
	    Klass.call(instance, a1, a2, a3, a4);
	    return instance;
	  } else {
	    return new Klass(a1, a2, a3, a4);
	  }
	};
	
	var standardReleaser = function (instance) {
	  var Klass = this;
	  !(instance instanceof Klass) ?  false ? invariant(false, 'Trying to release an instance into a pool of a different type.') : _prodInvariant('25') : void 0;
	  instance.destructor();
	  if (Klass.instancePool.length < Klass.poolSize) {
	    Klass.instancePool.push(instance);
	  }
	};
	
	var DEFAULT_POOL_SIZE = 10;
	var DEFAULT_POOLER = oneArgumentPooler;
	
	/**
	 * Augments `CopyConstructor` to be a poolable class, augmenting only the class
	 * itself (statically) not adding any prototypical fields. Any CopyConstructor
	 * you give this may have a `poolSize` property, and will look for a
	 * prototypical `destructor` on instances.
	 *
	 * @param {Function} CopyConstructor Constructor that can be used to reset.
	 * @param {Function} pooler Customizable pooler.
	 */
	var addPoolingTo = function (CopyConstructor, pooler) {
	  // Casting as any so that flow ignores the actual implementation and trusts
	  // it to match the type we declared
	  var NewKlass = CopyConstructor;
	  NewKlass.instancePool = [];
	  NewKlass.getPooled = pooler || DEFAULT_POOLER;
	  if (!NewKlass.poolSize) {
	    NewKlass.poolSize = DEFAULT_POOL_SIZE;
	  }
	  NewKlass.release = standardReleaser;
	  return NewKlass;
	};
	
	var PooledClass = {
	  addPoolingTo: addPoolingTo,
	  oneArgumentPooler: oneArgumentPooler,
	  twoArgumentPooler: twoArgumentPooler,
	  threeArgumentPooler: threeArgumentPooler,
	  fourArgumentPooler: fourArgumentPooler
	};
	
	module.exports = PooledClass;

/***/ }
/******/ ])));


/** WEBPACK FOOTER **
 ** bundle.js
 **/